(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[888,354],{

/***/ 46166:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Le": function() { return /* binding */ M; },
/* harmony export */   "Wq": function() { return /* binding */ Q; },
/* harmony export */   "_P": function() { return /* binding */ L; },
/* harmony export */   "j4": function() { return /* binding */ f; },
/* harmony export */   "m1": function() { return /* binding */ te; },
/* harmony export */   "up": function() { return /* binding */ oe; }
/* harmony export */ });
/* unused harmony exports sendImpressionLog, separateURLParams, useImpressionLog, waitForInit */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(75271);



var E=Object.create;var h=Object.defineProperty;var T=Object.getOwnPropertyDescriptor;var K=Object.getOwnPropertyNames;var C=Object.getPrototypeOf,F=Object.prototype.hasOwnProperty;var V=(e,o)=>()=>(o||e((o={exports:{}}).exports,o),o.exports);var q=(e,o,n,s)=>{if(o&&typeof o=="object"||typeof o=="function")for(let i of K(o))!F.call(e,i)&&i!==n&&h(e,i,{get:()=>o[i],enumerable:!(s=T(o,i))||s.enumerable});return e};var A=(e,o,n)=>(n=e!=null?E(C(e)):{},q(o||!e||!e.__esModule?h(n,"default",{value:e,enumerable:!0}):n,e));var k=V((b,p)=>{(function(e){var o=function(t,r,a){if(!I(r)||j(r)||O(r)||B(r)||P(r))return r;var c,u=0,y=0;if(U(r))for(c=[],y=r.length;u<y;u++)c.push(o(t,r[u],a));else {c={};for(var w in r)Object.prototype.hasOwnProperty.call(r,w)&&(c[t(w,a)]=o(t,r[w],a));}return c},n=function(t,r){r=r||{};var a=r.separator||"_",c=r.split||/(?=[A-Z])/;return t.split(c).join(a)},s=function(t){return R(t)?t:(t=t.replace(/[\-_\s]+(.)?/g,function(r,a){return a?a.toUpperCase():""}),t.substr(0,1).toLowerCase()+t.substr(1))},i=function(t){var r=s(t);return r.substr(0,1).toUpperCase()+r.substr(1)},l=function(t,r){return n(t,r).toLowerCase()},g=Object.prototype.toString,P=function(t){return typeof t=="function"},I=function(t){return t===Object(t)},U=function(t){return g.call(t)=="[object Array]"},j=function(t){return g.call(t)=="[object Date]"},O=function(t){return g.call(t)=="[object RegExp]"},B=function(t){return g.call(t)=="[object Boolean]"},R=function(t){return t=t-0,t===t},m=function(t,r){var a=r&&"process"in r?r.process:r;return typeof a!="function"?t:function(c,u){return a(c,t,u)}},d={camelize:s,decamelize:l,pascalize:i,depascalize:l,camelizeKeys:function(t,r){return o(m(s,r),t)},decamelizeKeys:function(t,r){return o(m(l,r),t,r)},pascalizeKeys:function(t,r){return o(m(i,r),t)},depascalizeKeys:function(){return this.decamelizeKeys.apply(this,arguments)}};typeof define=="function"&&__webpack_require__.amdO?define(d):typeof p<"u"&&p.exports?p.exports=d:e.humps=d;})(b);});var z=A(k());var _={local:"https://assets.ohou.se/logging/dev/logging.js",dev:"https://assets.ohou.se/logging/dev/logging.js",stage:"https://assets.ohou.se/logging/stage/logging.js",qa:"https://assets.ohou.se/logging/qa/logging.js",prod:"https://assets.ohou.se/logging/logging.js","local-global":"https://assets.ohouse.com/logging-global/dev/logging.js","dev-global":"https://assets.ohouse.com/logging-global/dev/logging.js","stage-global":"https://assets.ohouse.com/logging-global/stage/logging.js","qa-global":"https://assets.ohouse.com/logging-global/qa/logging.js","prod-global":"https://assets.ohouse.com/logging-global/logging.js"};function x(e,o){let n={};for(let s in e)Object.prototype.hasOwnProperty.call(e,s)&&o(e[s],s)&&(n[s]=e[s]);return n}var f=e=>x({data:e.data,category:e.category,object_section:e.section,object_section_id:e.section_id,object_section_idx:e.section_idx,object_type:e.type&&(0, z.decamelize)(e.type.toLowerCase()),object_id:e.id,object_idx:e.index,object_url:e.url,page_id:e.page_id,page_params:e.page_params},o=>o!=null),L=e=>{window.bucketLog=window.bucketLog||[],window.bucketLog.push(f(e));},M=e=>{let o=window.bucketLog;return o&&o.get?o.get(e):null},Q=({environment:e,version:o="1"})=>`${_[e]}?t=${o}`;var v,Y=()=>{if(v!=null)return v;let e=new Promise(o=>{let n,s=()=>{clearTimeout(n),o();};window.bucketLog=window.bucketLog||[],window.bucketLog.push({category:"waitForInit",callback:s}),n=window.setTimeout(s,8e3);});return v=e,e};var $=e=>{let o=/^([^#\s?]*)(\?([^#\s]*))?(#(\w*))?$/.exec(e);return o!=null?[o[1],(o[3]||"")+(o[4]||"")]:[e,""]},te=(e,o)=>{let[n,s]=$(o),i=location.origin+e;window.bucketLog=window.bucketLog||[],window.bucketLog.push({url:location.origin+n,params:s,referer:i});},oe=()=>{window.bucketLog=window.bucketLog||[],window.bucketLog.push({category:"pageview",mode:"auto"});};function H(e){L({category:"impression",data:[{...f(e),time:Date.now()}]});}function ce({logData:e,threshold:o,disable:n}){let{ref:s,inView:i}=useInView({threshold:o,skip:n,triggerOnce:!0});return useEffect(()=>{if(i&&!n&&e){let{category:l,...g}=e;H(g),L({category:"impression",data:[{...f(g),time:Date.now()}]});}},[i,n,e]),{ref:s}}


//# sourceMappingURL=out.js.map
//# sourceMappingURL=index.esm.js.map

/***/ }),

/***/ 73581:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "AYH": function() { return /* binding */ initDatadogRum; },
/* harmony export */   "Dk8": function() { return /* binding */ GNB; },
/* harmony export */   "GYW": function() { return /* binding */ CUSTOM_COUPON_PUBLISH_MESSAGE; },
/* harmony export */   "HP5": function() { return /* binding */ useKakaoAPI; },
/* harmony export */   "LjL": function() { return /* binding */ CardPlaceholder; },
/* harmony export */   "VCx": function() { return /* binding */ getCouponsPublishMessage; },
/* harmony export */   "W94": function() { return /* binding */ useUspBadgeExperimentType; },
/* harmony export */   "Zsj": function() { return /* binding */ getExhibitionKakaoTemplate; },
/* harmony export */   "jci": function() { return /* binding */ CommerceProductCard; }
/* harmony export */ });
/* unused harmony exports API_AUTOCOMPLETE_HOST, AppDownloadPopupWithQR, BadgeList, Badges, BlockedPage, COUPON_PUBLISH_DONE_MESSAGE, CardFeedItem, CardFeedItemPlaceholder, ChangeLanguageButton, ChipListModule, Container, ContentFeedItem, ContentFeedItemPlaceholder, DEEP_LINK_HOST, DEFAULT_OG_IMAGE, DELIVERY_PAYMENT, DELIVERY_SERVICE_CODE, DELIVERY_TARGET_TYPE, DELIVERY_TARGET_TYPE_NAME, DELIVERY_TRACKING_STATUS, DOMAINS, DeliveryBadge, DeliveryOrderInfo, DeliveryStartAt, DeliverySummary, DeliveryTimeLine, DeliveryTrackingLoadFail, DeliveryTrackingTemplate, FEED_ITEM_DESKTOP_ASPECT_RATIO, FEED_ITEM_MOBILE_ASPECT_RATIO, FeedItem, FeedItemPlaceholder, FeedItemThumbnail, FeedPlaceholder, FilterKey, Follow, GLOBAL_API_GATEWAY, GLOBAL_DEEP_LINK_HOST, GLOBAL_DEFAULT_LOCALE, GLOBAL_DEFAULT_METADATA, GLOBAL_DOMAINS, GLOBAL_INFO, GlobalBanner, GlobalFooter, HTTPError, IconWithTextBadge, ImpressionTracker, Info, InfoPlaceholder, InfoTip, KAKAO_TEMPLATE_ID, LOCALE_ITEMS, LogLink, LogoIcon, Price, PricePlaceholder, ProductCard, ProductCardScrap, QUERY_BLACKLIST, RangeSliderInput, RouteFilter, SHIPMENT_TYPE, SHORTCUT_TYPE, STORE_ITEM_TYPE, Scrap, ScrapBookSelectModal, SharePopper, SoldOutBanner, Stats, StatsPlaceholder, Thumbnail, ThumbnailBadge, ThumbnailPlaceholder, Timer, TrendingKeywordsDropdown, TrendingKeywordsEntry, TrendingKeywordsList, TrendingKeywordsRolling, USERABLE_TYPE, UTM_TAGS, addRange, bucketClickLog, bucketImpressionLog, checkAllowedLocale, convertDealToProduct, convertGoodsSummaryToProduct, convertGoodsToProduct, convertLandingUrlByHost, convertStoreItemToProduct, convertThumbnailBadgeToBadge, countries, createColorSchema, createColorTagDeserializer, createColorTagSerializer, createCookieDomain, createDeserialize, createGlobalDefaultUrl, createGroupSchema, createListSchema, createListTagDeserializer, createListTagSerializer, createProductScrapData, createRangeSchema, createRangeTagDeserializer, createRangeTagSerializer, createSearchHistoryStorage, createSerialize, escapeBracesInQuery, fetchDelete, fetchGet, fetchPatch, fetchPost, fetchPut, fetchSugar, findNextOption, findPreviousOption, formatPhoneNumber, formatPriceByCurrency, formatRange, getAmplitude, getBestCardPromotion, getCardPromotionBadges, getCardPromotionTitle, getClientIp, getCookieDomain, getCouponBadge, getCouponBadgeTitle, getDeepLink, getDeliveryTackingNoticeFormat, getDiscountPrice, getFacebookPixelScript, getLocaleFromUrl, getLoginURL, getMaxDiscountCouponMold, getMinBaseAmountCouponMold, getPublishCartCouponStatus, getPublishProductCouponStatus, getRange, getSearchTargetURL, getSearchType, getSearchURL, getServiceType, getShortenPrice, getURL, getUrlWithExchangeLocale, getUtmData, getUtmDataFromUrl, globalCountries, globalLocales, globalMiddleware, initAirbridge, initBraze, initBucketLog, initCriteo, initKakaoPixel, initNaverAnalycis, initWiderPlanet, isInclude, isNextJsPageRequest, isRootPathnameWithLocale, isSearchRobot, isUrlWithLocale, joinLinkQuery, locales, logAirbridge, logAmplitude, logAppBraze, logBraze, logFacebookPixel, sendImpressionLog, serializePathToString, setUtmData, shouldShowDeliveryBadge, signoutAirbridge, useImpressionLog, useIntersectionObserver, useMergeRef, useProductCardLogData, useToggle, useWebviewEventDispatcher, useWebviewEventListener */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(75271);
/* harmony import */ var _bucketplace_xpc_sdk__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(56738);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(83128);
/* harmony import */ var _emotion_styled_base__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(12851);
/* harmony import */ var _bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(54939);
/* harmony import */ var _bucketplace_design_system__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(33328);
/* harmony import */ var _bucketplace_design_system__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(53700);
/* harmony import */ var _bucketplace_design_system__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(62471);
/* harmony import */ var _bucketplace_design_system__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(65081);
/* harmony import */ var _bucketplace_design_system__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(68479);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(52814);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(57834);
/* harmony import */ var _bucketplace_design_system_bds__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(85435);
/* harmony import */ var react_dom__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(30967);
/* harmony import */ var _bucketplace_ui__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(28746);
/* module decorator */ module = __webpack_require__.hmd(module);
/* provided dependency */ var Buffer = __webpack_require__(55872)["Buffer"];
'use client';












const USERABLE_TYPE = {
  normal: 'NormalUser',
  expert: 'ExpertUser',
  seller: 'SalesUser'
};

/** 브랜드 */

/** 뱃지 */

/** 쿠폰 뱃지 */

/** 카드 할인 혜택 뱃지 */

/** 가격 정보 */

/** 즉시할인 정보 */

const DELIVERY_PAYMENT = {
  /** 무료 */
  FREE: 'FREE',
  /** 조건부 무료 */
  CONDITIONAL_FREE: 'CONDITIONAL_FREE',
  /** 유료 */
  CHARGE: 'CHARGE'
};
const DELIVERY_SERVICE_CODE = {
  /** 일반 택배 */
  NORMAL: 'NORMAL',
  /** 판매자 직접 배송 */
  SELLER: 'SELLER',
  /** 화물택배 */
  CARGO: 'CARGO',
  /** 오늘의집 배송 */
  OHOUSE: 'OHOUSE',
  /** 빠른가전 배송 */
  THIRD_PARTY: 'THIRD_PARTY',
  /** 미노출 */
  NONE: 'NONE',
  /** 빠른가전배송 */
  THIRD_PARTY_APPLIANCE: 'THIRD_PARTY_APPLIANCE',
  /** 빠른가구배송 */
  THIRD_PARTY_FURNITURE: 'THIRD_PARTY_FURNITURE'
};

/** 배송비 유형 */

/** 배송 유형 */

/**
 * @type sm : name -> caption1, price -> caption1
 * @type md : name -> caption1, price -> subTitle2
 * @type lg : name -> subTitle2, price -> title3
 */

const STORE_ITEM_TYPE = {
  /** 상품 */
  GOODS: 'Goods',
  /** 모음전 */
  DEAL: 'Deal'
};

/** 'Goods' 와 'Deal' 에서 동일하게 사용하는 필드들입니다. */

/** type = 'Goods' 일때만 값을 가집니다. */

/** 굿스플로 상세 정보 */

/** 굿스플로 상세 정보 목록 */

/** 배송 조회 타입 - 배송중, 수거중, 재배송중 */
const DELIVERY_TARGET_TYPE = {
  ORDER: 'ORDER',
  PICKUP: 'PICKUP',
  REDELIVERY: 'REDELIVERY'
};
/** 배송  상태 */
const DELIVERY_TRACKING_STATUS = {
  READY: 'READY',
  SCHEDULED: 'SCHEDULED',
  INPROGRESS: 'INPROGRESS',
  COMPLETE: 'COMPLETE'
};
/** 배송방식 */
const SHIPMENT_TYPE = {
  NORMAL: 'NORMAL',
  SELLER: 'SELLER',
  CARGO: 'CARGO',
  OHOUSE: 'OHOUSE',
  THIRD_PARTY: 'THIRD_PARTY'
};

/**
 * 상품쿠폰으로 인한 할인금액 계산
 * @param price 상품가격
 * @param mold 상품쿠폰틀
 * @returns 할인금액
 * @example
 * ```
 * getDiscountPrice(10000, {
 *   title: '(연지) claim_재발행 + 고정만료 5,500원 쿠폰',
 *   discountType: 'FIXED_AMOUNT',
 *   couponType: 'GOODS',
 *   discountAmount: '5500',
 *   minBaseAmount: '100',
 * });
 * ```
 */
const getDiscountPrice = (price, mold) => {
  const {
    discountType,
    discountRate = 0
  } = mold;
  const discountAmount = Number.parseInt(mold.discountAmount ?? '0', 10);
  const maxDiscountAmount = Number.parseInt(mold.maxDiscountAmount ?? '0', 10);

  // 정률일경우
  if (discountType === 'FIXED_RATE') {
    return Math.min(price * discountRate, maxDiscountAmount);
  }

  // 정액일경우
  return Math.min(discountAmount, price);
};

/**
 * 할인금액이 가장 큰 쿠폰틀 계산
 * @param price 상품가격
 * @param molds 상품에 적용 가능한 쿠폰틀 리스트
 * @retuns 할인금액 가장 큰 쿠폰틀
 * @example
 * ```
 * getMaxDiscountCouponMold(1000, [{
 *   title: '(연지) claim_재발행 + 고정만료 5,500원 쿠폰',
 *   discountType: 'FIXED_AMOUNT',
 *   couponType: 'GOODS',
 *   discountAmount: '5500',
 *   minBaseAmount: '100',
 * }]);
 * ```
 */

const getMaxDiscountCouponMold = (price, molds) => {
  if (!molds.length) {
    return;
  }
  return molds.reduce((prev, curr) => {
    const prevDiscountPrice = getDiscountPrice(price, prev);
    const currDiscountPrice = getDiscountPrice(price, curr);
    return prevDiscountPrice > currDiscountPrice ? prev : curr;
  });
};

/**
 * 최소주문금액이 가장 작은 쿠폰틀 계산
 * @param molds 쿠폰틀 리스트
 * @returns 최소주문금액이 가장 작은 쿠폰틀
 * @example
 * ```
 * getMinBaseAmountCouponMold([{
 *   title: '(연지) claim_재발행 + 고정만료 5,500원 쿠폰',
 *   discountType: 'FIXED_AMOUNT',
 *   couponType: 'GOODS',
 *   discountAmount: '5500',
 *   minBaseAmount: '100',
 * }, {
 *   title: '(연지) Order + 정률 20% 쿠폰',
 *   discountType: 'FIXED_RATE',
 *   couponType: 'GOODS',
 *   discountRate: 0.2,
 *   minBaseAmount: '500',
 *   maxDiscountAmount: '20000',
 * }]);
 * ```
 */
const getMinBaseAmountCouponMold = molds => {
  if (!molds.length) {
    return;
  }
  return molds.reduce((prev, curr) => {
    const prevMinBaseAmount = Number.parseInt(prev.minBaseAmount, 10);
    const currMinBaseAmount = Number.parseInt(curr.minBaseAmount, 10);
    return prevMinBaseAmount > currMinBaseAmount ? curr : prev;
  });
};

/**
 * 상품카드에 노출되는 상품쿠폰
 * @param sellingPrice 판매가
 * @param goodsCouponMolds 상품쿠폰 리스트
 * @returns 상품카드에 노출되는 상품쿠폰
 * @example
 * ```
 * getCouponBadge('50', [{
 *   title: '(연지) claim_재발행 + 고정만료 5,500원 쿠폰',
 *   discountType: 'FIXED_AMOUNT',
 *   couponType: 'GOODS',
 *   discountAmount: '5500',
 *   minBaseAmount: '100',
 * },
 * {
 *   title: '(연지) Order + 정률 20% 쿠폰',
 *   discountType: 'FIXED_RATE',
 *   couponType: 'GOODS',
 *   discountRate: 0.2,
 *   minBaseAmount: '500',
 *   maxDiscountAmount: '20000',
 * }]);
 * ```
 */
function getCouponBadge(sellingPrice, goodsCouponMolds) {
  if (!goodsCouponMolds.length) {
    return;
  }
  const price = Number.parseInt(sellingPrice, 10);

  // 최소주문금액이 가장 작은 쿠폰틀
  const minBaseAmountCouponMold = getMinBaseAmountCouponMold(goodsCouponMolds);
  const minBaseAmount = Number.parseInt(minBaseAmountCouponMold?.minBaseAmount ?? '0', 10);
  if (price > minBaseAmount) {
    // sellingPrice가 최소주문금액보다 클경우 할인금액이 가장 큰 쿠폰틀
    return getMaxDiscountCouponMold(price, goodsCouponMolds);
  } else {
    // sellingPrice가 최소주문금액보다 작을경우 최소주문금액이 가장 작은 쿠폰틀
    return minBaseAmountCouponMold;
  }
}

/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function arrayMap$1(array, iteratee) {
  var index = -1,
    length = array == null ? 0 : array.length,
    result = Array(length);
  while (++index < length) {
    result[index] = iteratee(array[index], index, array);
  }
  return result;
}
function _arrayLikeToArray$1(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
function _arrayWithHoles(r) {
  if (Array.isArray(r)) return r;
}
function _arrayWithoutHoles$1(r) {
  if (Array.isArray(r)) return _arrayLikeToArray$1(r);
}
function _createForOfIteratorHelper$1(r, e) {
  var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (!t) {
    if (Array.isArray(r) || (t = _unsupportedIterableToArray$1(r)) || e && r && "number" == typeof r.length) {
      t && (r = t);
      var n = 0,
        F = function () {};
      return {
        s: F,
        n: function () {
          return n >= r.length ? {
            done: !0
          } : {
            done: !1,
            value: r[n++]
          };
        },
        e: function (r) {
          throw r;
        },
        f: F
      };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var o,
    a = !0,
    u = !1;
  return {
    s: function () {
      t = t.call(r);
    },
    n: function () {
      var r = t.next();
      return a = r.done, r;
    },
    e: function (r) {
      u = !0, o = r;
    },
    f: function () {
      try {
        a || null == t.return || t.return();
      } finally {
        if (u) throw o;
      }
    }
  };
}
function _defineProperty$2(e, r, t) {
  return (r = _toPropertyKey$2(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function _iterableToArray$1(r) {
  if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}
function _iterableToArrayLimit(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (null != t) {
    var e,
      n,
      i,
      u,
      a = [],
      f = !0,
      o = !1;
    try {
      if (i = (t = t.call(r)).next, 0 === l) {
        if (Object(t) !== t) return;
        f = !1;
      } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
    } catch (r) {
      o = !0, n = r;
    } finally {
      try {
        if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return;
      } finally {
        if (o) throw n;
      }
    }
    return a;
  }
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _nonIterableSpread$1() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(r, e) {
  return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray$1(r, e) || _nonIterableRest();
}
function _toConsumableArray$1(r) {
  return _arrayWithoutHoles$1(r) || _iterableToArray$1(r) || _unsupportedIterableToArray$1(r) || _nonIterableSpread$1();
}
function _toPrimitive$2(t, r) {
  if ("object" != typeof t || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != typeof i) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
function _toPropertyKey$2(t) {
  var i = _toPrimitive$2(t, "string");
  return "symbol" == typeof i ? i : i + "";
}
function _typeof$2(o) {
  "@babel/helpers - typeof";

  return _typeof$2 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof$2(o);
}
function _unsupportedIterableToArray$1(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray$1(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray$1(r, a) : void 0;
  }
}

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear$1() {
  this.__data__ = [];
  this.size = 0;
}

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq$1(value, other) {
  return value === other || value !== value && other !== other;
}

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf$1(array, key) {
  var length = array.length;
  while (length--) {
    if (eq$1(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

/** Used for built-in method references. */
var arrayProto$1 = Array.prototype;

/** Built-in value references. */
var splice$1 = arrayProto$1.splice;

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete$1(key) {
  var data = this.__data__,
    index = assocIndexOf$1(data, key);
  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice$1.call(data, index, 1);
  }
  --this.size;
  return true;
}

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet$1(key) {
  var data = this.__data__,
    index = assocIndexOf$1(data, key);
  return index < 0 ? undefined : data[index][1];
}

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas$1(key) {
  return assocIndexOf$1(this.__data__, key) > -1;
}

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet$1(key, value) {
  var data = this.__data__,
    index = assocIndexOf$1(data, key);
  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache$1(entries) {
  var index = -1,
    length = entries == null ? 0 : entries.length;
  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `ListCache`.
ListCache$1.prototype.clear = listCacheClear$1;
ListCache$1.prototype['delete'] = listCacheDelete$1;
ListCache$1.prototype.get = listCacheGet$1;
ListCache$1.prototype.has = listCacheHas$1;
ListCache$1.prototype.set = listCacheSet$1;

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear$1() {
  this.__data__ = new ListCache$1();
  this.size = 0;
}

/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function stackDelete$1(key) {
  var data = this.__data__,
    result = data['delete'](key);
  this.size = data.size;
  return result;
}

/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function stackGet$1(key) {
  return this.__data__.get(key);
}

/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function stackHas$1(key) {
  return this.__data__.has(key);
}

/** Detect free variable `global` from Node.js. */
var freeGlobal$2 = (typeof __webpack_require__.g === "undefined" ? "undefined" : _typeof$2(__webpack_require__.g)) == 'object' && __webpack_require__.g && __webpack_require__.g.Object === Object && __webpack_require__.g;
var freeGlobal$1$1 = freeGlobal$2;

/** Detect free variable `self`. */
var freeSelf$1 = (typeof self === "undefined" ? "undefined" : _typeof$2(self)) == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root$2 = freeGlobal$1$1 || freeSelf$1 || Function('return this')();
var root$1$1 = root$2;

/** Built-in value references. */
var _Symbol = root$1$1.Symbol;
var _Symbol$1 = _Symbol;

/** Used for built-in method references. */
var objectProto$h = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$e = objectProto$h.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString$1$1 = objectProto$h.toString;

/** Built-in value references. */
var symToStringTag$1$1 = _Symbol$1 ? _Symbol$1.toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag$1(value) {
  var isOwn = hasOwnProperty$e.call(value, symToStringTag$1$1),
    tag = value[symToStringTag$1$1];
  try {
    value[symToStringTag$1$1] = undefined;
    var unmasked = true;
  } catch (e) {}
  var result = nativeObjectToString$1$1.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag$1$1] = tag;
    } else {
      delete value[symToStringTag$1$1];
    }
  }
  return result;
}

/** Used for built-in method references. */
var objectProto$g = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString$2 = objectProto$g.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString$1(value) {
  return nativeObjectToString$2.call(value);
}

/** `Object#toString` result references. */
var nullTag$1 = '[object Null]',
  undefinedTag$1 = '[object Undefined]';

/** Built-in value references. */
var symToStringTag$2 = _Symbol$1 ? _Symbol$1.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag$1(value) {
  if (value == null) {
    return value === undefined ? undefinedTag$1 : nullTag$1;
  }
  return symToStringTag$2 && symToStringTag$2 in Object(value) ? getRawTag$1(value) : objectToString$1(value);
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject$1$1(value) {
  var type = _typeof$2(value);
  return value != null && (type == 'object' || type == 'function');
}

/** `Object#toString` result references. */
var asyncTag$1 = '[object AsyncFunction]',
  funcTag$2 = '[object Function]',
  genTag$1 = '[object GeneratorFunction]',
  proxyTag$1 = '[object Proxy]';

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction$1(value) {
  if (!isObject$1$1(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = baseGetTag$1(value);
  return tag == funcTag$2 || tag == genTag$1 || tag == asyncTag$1 || tag == proxyTag$1;
}

/** Used to detect overreaching core-js shims. */
var coreJsData$2 = root$1$1['__core-js_shared__'];
var coreJsData$1$1 = coreJsData$2;

/** Used to detect methods masquerading as native. */
var maskSrcKey$1 = function () {
  var uid = /[^.]+$/.exec(coreJsData$1$1 && coreJsData$1$1.keys && coreJsData$1$1.keys.IE_PROTO || '');
  return uid ? 'Symbol(src)_1.' + uid : '';
}();

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked$1(func) {
  return !!maskSrcKey$1 && maskSrcKey$1 in func;
}

/** Used for built-in method references. */
var funcProto$2 = Function.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString$2 = funcProto$2.toString;

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */
function toSource$1(func) {
  if (func != null) {
    try {
      return funcToString$2.call(func);
    } catch (e) {}
    try {
      return func + '';
    } catch (e) {}
  }
  return '';
}

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar$1 = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor$1 = /^\[object .+?Constructor\]$/;

/** Used for built-in method references. */
var funcProto$1$1 = Function.prototype,
  objectProto$f = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString$1$1 = funcProto$1$1.toString;

/** Used to check objects for own properties. */
var hasOwnProperty$d = objectProto$f.hasOwnProperty;

/** Used to detect if a method is native. */
var reIsNative$1 = RegExp('^' + funcToString$1$1.call(hasOwnProperty$d).replace(reRegExpChar$1, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative$1(value) {
  if (!isObject$1$1(value) || isMasked$1(value)) {
    return false;
  }
  var pattern = isFunction$1(value) ? reIsNative$1 : reIsHostCtor$1;
  return pattern.test(toSource$1(value));
}

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue$1(object, key) {
  return object == null ? undefined : object[key];
}

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative$1(object, key) {
  var value = getValue$1(object, key);
  return baseIsNative$1(value) ? value : undefined;
}

/* Built-in method references that are verified to be native. */
var Map$3 = getNative$1(root$1$1, 'Map');
var Map$1$1 = Map$3;

/* Built-in method references that are verified to be native. */
var nativeCreate$2 = getNative$1(Object, 'create');
var nativeCreate$1$1 = nativeCreate$2;

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear$1() {
  this.__data__ = nativeCreate$1$1 ? nativeCreate$1$1(null) : {};
  this.size = 0;
}

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete$1(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED$2$1 = '__lodash_hash_undefined__';

/** Used for built-in method references. */
var objectProto$e$1 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$c = objectProto$e$1.hasOwnProperty;

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet$1(key) {
  var data = this.__data__;
  if (nativeCreate$1$1) {
    var result = data[key];
    return result === HASH_UNDEFINED$2$1 ? undefined : result;
  }
  return hasOwnProperty$c.call(data, key) ? data[key] : undefined;
}

/** Used for built-in method references. */
var objectProto$d$1 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$b$1 = objectProto$d$1.hasOwnProperty;

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas$1(key) {
  var data = this.__data__;
  return nativeCreate$1$1 ? data[key] !== undefined : hasOwnProperty$b$1.call(data, key);
}

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED$1$1 = '__lodash_hash_undefined__';

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet$1(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = nativeCreate$1$1 && value === undefined ? HASH_UNDEFINED$1$1 : value;
  return this;
}

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash$1(entries) {
  var index = -1,
    length = entries == null ? 0 : entries.length;
  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `Hash`.
Hash$1.prototype.clear = hashClear$1;
Hash$1.prototype['delete'] = hashDelete$1;
Hash$1.prototype.get = hashGet$1;
Hash$1.prototype.has = hashHas$1;
Hash$1.prototype.set = hashSet$1;

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear$1() {
  this.size = 0;
  this.__data__ = {
    'hash': new Hash$1(),
    'map': new (Map$1$1 || ListCache$1)(),
    'string': new Hash$1()
  };
}

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable$1(value) {
  var type = _typeof$2(value);
  return type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean' ? value !== '__proto__' : value === null;
}

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData$1(map, key) {
  var data = map.__data__;
  return isKeyable$1(key) ? data[typeof key == 'string' ? 'string' : 'hash'] : data.map;
}

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete$1(key) {
  var result = getMapData$1(this, key)['delete'](key);
  this.size -= result ? 1 : 0;
  return result;
}

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet$1(key) {
  return getMapData$1(this, key).get(key);
}

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas$1(key) {
  return getMapData$1(this, key).has(key);
}

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet$1(key, value) {
  var data = getMapData$1(this, key),
    size = data.size;
  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache$1(entries) {
  var index = -1,
    length = entries == null ? 0 : entries.length;
  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `MapCache`.
MapCache$1.prototype.clear = mapCacheClear$1;
MapCache$1.prototype['delete'] = mapCacheDelete$1;
MapCache$1.prototype.get = mapCacheGet$1;
MapCache$1.prototype.has = mapCacheHas$1;
MapCache$1.prototype.set = mapCacheSet$1;

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE$1 = 200;

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet$1(key, value) {
  var data = this.__data__;
  if (data instanceof ListCache$1) {
    var pairs = data.__data__;
    if (!Map$1$1 || pairs.length < LARGE_ARRAY_SIZE$1 - 1) {
      pairs.push([key, value]);
      this.size = ++data.size;
      return this;
    }
    data = this.__data__ = new MapCache$1(pairs);
  }
  data.set(key, value);
  this.size = data.size;
  return this;
}

/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack$1(entries) {
  var data = this.__data__ = new ListCache$1(entries);
  this.size = data.size;
}

// Add methods to `Stack`.
Stack$1.prototype.clear = stackClear$1;
Stack$1.prototype['delete'] = stackDelete$1;
Stack$1.prototype.get = stackGet$1;
Stack$1.prototype.has = stackHas$1;
Stack$1.prototype.set = stackSet$1;

/** Built-in value references. */
var Uint8Array$3 = root$1$1.Uint8Array;
var Uint8Array$1$1 = Uint8Array$3;

/** Used to convert symbols to primitives and strings. */
var symbolProto$2 = _Symbol$1 ? _Symbol$1.prototype : undefined;
  symbolProto$2 ? symbolProto$2.valueOf : undefined;

/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */
function arrayPush$1(array, values) {
  var index = -1,
    length = values.length,
    offset = array.length;
  while (++index < length) {
    array[offset + index] = values[index];
  }
  return array;
}

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray$1$1 = Array.isArray;
var isArray$2 = isArray$1$1;

/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */
function baseGetAllKeys$1(object, keysFunc, symbolsFunc) {
  var result = keysFunc(object);
  return isArray$2(object) ? result : arrayPush$1(result, symbolsFunc(object));
}

/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */
function arrayFilter$1(array, predicate) {
  var index = -1,
    length = array == null ? 0 : array.length,
    resIndex = 0,
    result = [];
  while (++index < length) {
    var value = array[index];
    if (predicate(value, index, array)) {
      result[resIndex++] = value;
    }
  }
  return result;
}

/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */
function stubArray$1() {
  return [];
}

/** Used for built-in method references. */
var objectProto$c$1 = Object.prototype;

/** Built-in value references. */
var propertyIsEnumerable$1$1 = objectProto$c$1.propertyIsEnumerable;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols$1$1 = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbols$2 = !nativeGetSymbols$1$1 ? stubArray$1 : function (object) {
  if (object == null) {
    return [];
  }
  object = Object(object);
  return arrayFilter$1(nativeGetSymbols$1$1(object), function (symbol) {
    return propertyIsEnumerable$1$1.call(object, symbol);
  });
};
var getSymbols$1$1 = getSymbols$2;

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes$1(n, iteratee) {
  var index = -1,
    result = Array(n);
  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike$1(value) {
  return value != null && _typeof$2(value) == 'object';
}

/** `Object#toString` result references. */
var argsTag$3 = '[object Arguments]';

/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */
function baseIsArguments$1(value) {
  return isObjectLike$1(value) && baseGetTag$1(value) == argsTag$3;
}

/** Used for built-in method references. */
var objectProto$b$1 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$a$1 = objectProto$b$1.hasOwnProperty;

/** Built-in value references. */
var propertyIsEnumerable$2 = objectProto$b$1.propertyIsEnumerable;

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
var isArguments$2 = baseIsArguments$1(function () {
  return arguments;
}()) ? baseIsArguments$1 : function (value) {
  return isObjectLike$1(value) && hasOwnProperty$a$1.call(value, 'callee') && !propertyIsEnumerable$2.call(value, 'callee');
};
var isArguments$1$1 = isArguments$2;

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse$1() {
  return false;
}

/** Detect free variable `exports`. */
var freeExports$2 = (typeof exports === "undefined" ? "undefined" : _typeof$2(exports)) == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule$2 = freeExports$2 && ( false ? 0 : _typeof$2(module)) == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports$2 = freeModule$2 && freeModule$2.exports === freeExports$2;

/** Built-in value references. */
var Buffer$1$1 = moduleExports$2 ? root$1$1.Buffer : undefined;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeIsBuffer$1 = Buffer$1$1 ? Buffer$1$1.isBuffer : undefined;

/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */
var isBuffer$2 = nativeIsBuffer$1 || stubFalse$1;
var isBuffer$1$1 = isBuffer$2;

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER$1$1 = 9007199254740991;

/** Used to detect unsigned integer values. */
var reIsUint$1 = /^(?:0|[1-9]\d*)$/;

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex$1(value, length) {
  var type = _typeof$2(value);
  length = length == null ? MAX_SAFE_INTEGER$1$1 : length;
  return !!length && (type == 'number' || type != 'symbol' && reIsUint$1.test(value)) && value > -1 && value % 1 == 0 && value < length;
}

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER$3 = 9007199254740991;

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength$1(value) {
  return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER$3;
}

/** `Object#toString` result references. */
var argsTag$2$1 = '[object Arguments]',
  arrayTag$2 = '[object Array]',
  boolTag$3 = '[object Boolean]',
  dateTag$2 = '[object Date]',
  errorTag$2 = '[object Error]',
  funcTag$1$1 = '[object Function]',
  mapTag$5 = '[object Map]',
  numberTag$3 = '[object Number]',
  objectTag$4 = '[object Object]',
  regexpTag$2 = '[object RegExp]',
  setTag$5 = '[object Set]',
  stringTag$3 = '[object String]',
  weakMapTag$2 = '[object WeakMap]';
var arrayBufferTag$2 = '[object ArrayBuffer]',
  dataViewTag$3 = '[object DataView]',
  float32Tag$2 = '[object Float32Array]',
  float64Tag$2 = '[object Float64Array]',
  int8Tag$2 = '[object Int8Array]',
  int16Tag$2 = '[object Int16Array]',
  int32Tag$2 = '[object Int32Array]',
  uint8Tag$2 = '[object Uint8Array]',
  uint8ClampedTag$2 = '[object Uint8ClampedArray]',
  uint16Tag$2 = '[object Uint16Array]',
  uint32Tag$2 = '[object Uint32Array]';

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags$1 = {};
typedArrayTags$1[float32Tag$2] = typedArrayTags$1[float64Tag$2] = typedArrayTags$1[int8Tag$2] = typedArrayTags$1[int16Tag$2] = typedArrayTags$1[int32Tag$2] = typedArrayTags$1[uint8Tag$2] = typedArrayTags$1[uint8ClampedTag$2] = typedArrayTags$1[uint16Tag$2] = typedArrayTags$1[uint32Tag$2] = true;
typedArrayTags$1[argsTag$2$1] = typedArrayTags$1[arrayTag$2] = typedArrayTags$1[arrayBufferTag$2] = typedArrayTags$1[boolTag$3] = typedArrayTags$1[dataViewTag$3] = typedArrayTags$1[dateTag$2] = typedArrayTags$1[errorTag$2] = typedArrayTags$1[funcTag$1$1] = typedArrayTags$1[mapTag$5] = typedArrayTags$1[numberTag$3] = typedArrayTags$1[objectTag$4] = typedArrayTags$1[regexpTag$2] = typedArrayTags$1[setTag$5] = typedArrayTags$1[stringTag$3] = typedArrayTags$1[weakMapTag$2] = false;

/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */
function baseIsTypedArray$1(value) {
  return isObjectLike$1(value) && isLength$1(value.length) && !!typedArrayTags$1[baseGetTag$1(value)];
}

/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function baseUnary$1(func) {
  return function (value) {
    return func(value);
  };
}

/** Detect free variable `exports`. */
var freeExports$1$1 = (typeof exports === "undefined" ? "undefined" : _typeof$2(exports)) == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule$1$1 = freeExports$1$1 && ( false ? 0 : _typeof$2(module)) == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports$1$1 = freeModule$1$1 && freeModule$1$1.exports === freeExports$1$1;

/** Detect free variable `process` from Node.js. */
var freeProcess$1 = moduleExports$1$1 && freeGlobal$1$1.process;

/** Used to access faster Node.js helpers. */
var nodeUtil$2 = function () {
  try {
    // Use `util.types` for Node.js 10+.
    var types = freeModule$1$1 && freeModule$1$1.require && freeModule$1$1.require('util').types;
    if (types) {
      return types;
    }

    // Legacy `process.binding('util')` for Node.js < 10.
    return freeProcess$1 && freeProcess$1.binding && freeProcess$1.binding('util');
  } catch (e) {}
}();
var nodeUtil$1$1 = nodeUtil$2;

/* Node.js helper references. */
var nodeIsTypedArray$1 = nodeUtil$1$1 && nodeUtil$1$1.isTypedArray;

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
var isTypedArray$2 = nodeIsTypedArray$1 ? baseUnary$1(nodeIsTypedArray$1) : baseIsTypedArray$1;
var isTypedArray$1$1 = isTypedArray$2;

/** Used for built-in method references. */
var objectProto$a$1 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$9$1 = objectProto$a$1.hasOwnProperty;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys$1(value, inherited) {
  var isArr = isArray$2(value),
    isArg = !isArr && isArguments$1$1(value),
    isBuff = !isArr && !isArg && isBuffer$1$1(value),
    isType = !isArr && !isArg && !isBuff && isTypedArray$1$1(value),
    skipIndexes = isArr || isArg || isBuff || isType,
    result = skipIndexes ? baseTimes$1(value.length, String) : [],
    length = result.length;
  for (var key in value) {
    if ((inherited || hasOwnProperty$9$1.call(value, key)) && !(skipIndexes && (
    // Safari 9 has enumerable `arguments.length` in strict mode.
    key == 'length' ||
    // Node.js 0.10 has enumerable non-index properties on buffers.
    isBuff && (key == 'offset' || key == 'parent') ||
    // PhantomJS 2 has enumerable non-index properties on typed arrays.
    isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset') ||
    // Skip index properties.
    isIndex$1(key, length)))) {
      result.push(key);
    }
  }
  return result;
}

/** Used for built-in method references. */
var objectProto$9$1 = Object.prototype;

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype$1(value) {
  var Ctor = value && value.constructor,
    proto = typeof Ctor == 'function' && Ctor.prototype || objectProto$9$1;
  return value === proto;
}

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg$1(func, transform) {
  return function (arg) {
    return func(transform(arg));
  };
}

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys$2 = overArg$1(Object.keys, Object);
var nativeKeys$1$1 = nativeKeys$2;

/** Used for built-in method references. */
var objectProto$8$1 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$8$1 = objectProto$8$1.hasOwnProperty;

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys$1(object) {
  if (!isPrototype$1(object)) {
    return nativeKeys$1$1(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty$8$1.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike$1(value) {
  return value != null && isLength$1(value.length) && !isFunction$1(value);
}

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys$1(object) {
  return isArrayLike$1(object) ? arrayLikeKeys$1(object) : baseKeys$1(object);
}

/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeys$1(object) {
  return baseGetAllKeys$1(object, keys$1, getSymbols$1$1);
}

/* Built-in method references that are verified to be native. */
var DataView$3 = getNative$1(root$1$1, 'DataView');
var DataView$1$1 = DataView$3;

/* Built-in method references that are verified to be native. */
var Promise$1$1 = getNative$1(root$1$1, 'Promise');
var Promise$2$1 = Promise$1$1;

/* Built-in method references that are verified to be native. */
var Set$3 = getNative$1(root$1$1, 'Set');
var Set$1$1 = Set$3;

/* Built-in method references that are verified to be native. */
var WeakMap$3 = getNative$1(root$1$1, 'WeakMap');
var WeakMap$1$1 = WeakMap$3;

/** `Object#toString` result references. */
var mapTag$4 = '[object Map]',
  objectTag$3 = '[object Object]',
  promiseTag$1 = '[object Promise]',
  setTag$4 = '[object Set]',
  weakMapTag$1$1 = '[object WeakMap]';
var dataViewTag$2$1 = '[object DataView]';

/** Used to detect maps, sets, and weakmaps. */
var dataViewCtorString$1 = toSource$1(DataView$1$1),
  mapCtorString$1 = toSource$1(Map$1$1),
  promiseCtorString$1 = toSource$1(Promise$2$1),
  setCtorString$1 = toSource$1(Set$1$1),
  weakMapCtorString$1 = toSource$1(WeakMap$1$1);

/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
var getTag$2 = baseGetTag$1;

// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if (DataView$1$1 && getTag$2(new DataView$1$1(new ArrayBuffer(1))) != dataViewTag$2$1 || Map$1$1 && getTag$2(new Map$1$1()) != mapTag$4 || Promise$2$1 && getTag$2(Promise$2$1.resolve()) != promiseTag$1 || Set$1$1 && getTag$2(new Set$1$1()) != setTag$4 || WeakMap$1$1 && getTag$2(new WeakMap$1$1()) != weakMapTag$1$1) {
  getTag$2 = function getTag(value) {
    var result = baseGetTag$1(value),
      Ctor = result == objectTag$3 ? value.constructor : undefined,
      ctorString = Ctor ? toSource$1(Ctor) : '';
    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString$1:
          return dataViewTag$2$1;
        case mapCtorString$1:
          return mapTag$4;
        case promiseCtorString$1:
          return promiseTag$1;
        case setCtorString$1:
          return setTag$4;
        case weakMapCtorString$1:
          return weakMapTag$1$1;
      }
    }
    return result;
  };
}
var getTag$1$1 = getTag$2;

/** `Object#toString` result references. */
var symbolTag$2 = '[object Symbol]';

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol$1(value) {
  return _typeof$2(value) == 'symbol' || isObjectLike$1(value) && baseGetTag$1(value) == symbolTag$2;
}

/** Used to match property names within property paths. */
var reIsDeepProp$1 = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
  reIsPlainProp$1 = /^\w*$/;

/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */
function isKey$1(value, object) {
  if (isArray$2(value)) {
    return false;
  }
  var type = _typeof$2(value);
  if (type == 'number' || type == 'symbol' || type == 'boolean' || value == null || isSymbol$1(value)) {
    return true;
  }
  return reIsPlainProp$1.test(value) || !reIsDeepProp$1.test(value) || object != null && value in Object(object);
}

/** Error message constants. */
var FUNC_ERROR_TEXT$4 = 'Expected a function';

/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */
function memoize$1$1(func, resolver) {
  if (typeof func != 'function' || resolver != null && typeof resolver != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT$4);
  }
  var memoized = function memoized() {
    var args = arguments,
      key = resolver ? resolver.apply(this, args) : args[0],
      cache = memoized.cache;
    if (cache.has(key)) {
      return cache.get(key);
    }
    var result = func.apply(this, args);
    memoized.cache = cache.set(key, result) || cache;
    return result;
  };
  memoized.cache = new (memoize$1$1.Cache || MapCache$1)();
  return memoized;
}

// Expose `MapCache`.
memoize$1$1.Cache = MapCache$1;

/** Used as the maximum memoize cache size. */
var MAX_MEMOIZE_SIZE$1 = 500;

/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */
function memoizeCapped$1(func) {
  var result = memoize$1$1(func, function (key) {
    if (cache.size === MAX_MEMOIZE_SIZE$1) {
      cache.clear();
    }
    return key;
  });
  var cache = result.cache;
  return result;
}

/** Used to match property names within property paths. */
var rePropName$1 = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

/** Used to match backslashes in property paths. */
var reEscapeChar$1 = /\\(\\)?/g;

/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */
var stringToPath$2 = memoizeCapped$1(function (string) {
  var result = [];
  if (string.charCodeAt(0) === 46 /* . */) {
    result.push('');
  }
  string.replace(rePropName$1, function (match, number, quote, subString) {
    result.push(quote ? subString.replace(reEscapeChar$1, '$1') : number || match);
  });
  return result;
});
var stringToPath$1$1 = stringToPath$2;

/** Used as references for various `Number` constants. */
var INFINITY$2 = 1 / 0;

/** Used to convert symbols to primitives and strings. */
var symbolProto$1$1 = _Symbol$1 ? _Symbol$1.prototype : undefined,
  symbolToString$1 = symbolProto$1$1 ? symbolProto$1$1.toString : undefined;

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString$1(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isArray$2(value)) {
    // Recursively convert values (susceptible to call stack limits).
    return arrayMap$1(value, baseToString$1) + '';
  }
  if (isSymbol$1(value)) {
    return symbolToString$1 ? symbolToString$1.call(value) : '';
  }
  var result = value + '';
  return result == '0' && 1 / value == -INFINITY$2 ? '-0' : result;
}

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString$2(value) {
  return value == null ? '' : baseToString$1(value);
}

/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */
function castPath$1(value, object) {
  if (isArray$2(value)) {
    return value;
  }
  return isKey$1(value, object) ? [value] : stringToPath$1$1(toString$2(value));
}

/** Used as references for various `Number` constants. */
var INFINITY$1$1 = 1 / 0;

/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */
function toKey$1(value) {
  if (typeof value == 'string' || isSymbol$1(value)) {
    return value;
  }
  var result = value + '';
  return result == '0' && 1 / value == -INFINITY$1$1 ? '-0' : result;
}

/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */
function baseGet$1(object, path) {
  path = castPath$1(path, object);
  var index = 0,
    length = path.length;
  while (object != null && index < length) {
    object = object[toKey$1(path[index++])];
  }
  return index && index == length ? object : undefined;
}

/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */
function baseHasIn$1(object, key) {
  return object != null && key in Object(object);
}

/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */
function hasPath$1(object, path, hasFunc) {
  path = castPath$1(path, object);
  var index = -1,
    length = path.length,
    result = false;
  while (++index < length) {
    var key = toKey$1(path[index]);
    if (!(result = object != null && hasFunc(object, key))) {
      break;
    }
    object = object[key];
  }
  if (result || ++index != length) {
    return result;
  }
  length = object == null ? 0 : object.length;
  return !!length && isLength$1(length) && isIndex$1(key, length) && (isArray$2(object) || isArguments$1$1(object));
}

/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */
function hasIn$1(object, path) {
  return object != null && hasPath$1(object, path, baseHasIn$1);
}

/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function identity$1(value) {
  return value;
}
var defineProperty$2 = function () {
  try {
    var func = getNative$1(Object, 'defineProperty');
    func({}, '', {});
    return func;
  } catch (e) {}
}();
var defineProperty$1$1 = defineProperty$2;

/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function baseAssignValue$1(object, key, value) {
  if (key == '__proto__' && defineProperty$1$1) {
    defineProperty$1$1(object, key, {
      'configurable': true,
      'enumerable': true,
      'value': value,
      'writable': true
    });
  } else {
    object[key] = value;
  }
}
var queryString$2 = {};
var strictUriEncode$2 = function strictUriEncode(str) {
  return encodeURIComponent(str).replace(/[!'()*]/g, function (x) {
    return "%".concat(x.charCodeAt(0).toString(16).toUpperCase());
  });
};
var token$2 = '%[a-f0-9]{2}';
var singleMatcher$2 = new RegExp('(' + token$2 + ')|([^%]+?)', 'gi');
var multiMatcher$2 = new RegExp('(' + token$2 + ')+', 'gi');
function decodeComponents$2(components, split) {
  try {
    // Try to decode the entire string first
    return [decodeURIComponent(components.join(''))];
  } catch (err) {
    // Do nothing
  }
  if (components.length === 1) {
    return components;
  }
  split = split || 1;

  // Split the array in 2 parts
  var left = components.slice(0, split);
  var right = components.slice(split);
  return Array.prototype.concat.call([], decodeComponents$2(left), decodeComponents$2(right));
}
function decode$3(input) {
  try {
    return decodeURIComponent(input);
  } catch (err) {
    var tokens = input.match(singleMatcher$2) || [];
    for (var i = 1; i < tokens.length; i++) {
      input = decodeComponents$2(tokens, i).join('');
      tokens = input.match(singleMatcher$2) || [];
    }
    return input;
  }
}
function customDecodeURIComponent$2(input) {
  // Keep track of all the replacements and prefill the map with the `BOM`
  var replaceMap = {
    '%FE%FF': "\uFFFD\uFFFD",
    '%FF%FE': "\uFFFD\uFFFD"
  };
  var match = multiMatcher$2.exec(input);
  while (match) {
    try {
      // Decode as big chunks as possible
      replaceMap[match[0]] = decodeURIComponent(match[0]);
    } catch (err) {
      var result = decode$3(match[0]);
      if (result !== match[0]) {
        replaceMap[match[0]] = result;
      }
    }
    match = multiMatcher$2.exec(input);
  }

  // Add `%C2` at the end of the map to make sure it does not replace the combinator before everything else
  replaceMap['%C2'] = "\uFFFD";
  var entries = Object.keys(replaceMap);
  for (var i = 0; i < entries.length; i++) {
    // Replace all decoded components
    var key = entries[i];
    input = input.replace(new RegExp(key, 'g'), replaceMap[key]);
  }
  return input;
}
var decodeUriComponent$2 = function decodeUriComponent(encodedURI) {
  if (typeof encodedURI !== 'string') {
    throw new TypeError('Expected `encodedURI` to be of type `string`, got `' + _typeof$2(encodedURI) + '`');
  }
  try {
    encodedURI = encodedURI.replace(/\+/g, ' ');

    // Try the built in decoder first
    return decodeURIComponent(encodedURI);
  } catch (err) {
    // Fallback to a more advanced decoder
    return customDecodeURIComponent$2(encodedURI);
  }
};
var splitOnFirst$2 = function splitOnFirst(string, separator) {
  if (!(typeof string === 'string' && typeof separator === 'string')) {
    throw new TypeError('Expected the arguments to be of type `string`');
  }
  if (separator === '') {
    return [string];
  }
  var separatorIndex = string.indexOf(separator);
  if (separatorIndex === -1) {
    return [string];
  }
  return [string.slice(0, separatorIndex), string.slice(separatorIndex + separator.length)];
};
var filterObj$1 = function filterObj(obj, predicate) {
  var ret = {};
  var keys = Object.keys(obj);
  var isArr = Array.isArray(predicate);
  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    var val = obj[key];
    if (isArr ? predicate.indexOf(key) !== -1 : predicate(key, val, obj)) {
      ret[key] = val;
    }
  }
  return ret;
};
(function (exports) {
  var strictUriEncode$1 = strictUriEncode$2;
  var decodeComponent = decodeUriComponent$2;
  var splitOnFirst$1 = splitOnFirst$2;
  var filterObject = filterObj$1;
  var isNullOrUndefined = function isNullOrUndefined(value) {
    return value === null || value === undefined;
  };
  var encodeFragmentIdentifier = Symbol('encodeFragmentIdentifier');
  function encoderForArrayFormat(options) {
    switch (options.arrayFormat) {
      case 'index':
        return function (key) {
          return function (result, value) {
            var index = result.length;
            if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === '') {
              return result;
            }
            if (value === null) {
              return [].concat(_toConsumableArray$1(result), [[encode(key, options), '[', index, ']'].join('')]);
            }
            return [].concat(_toConsumableArray$1(result), [[encode(key, options), '[', encode(index, options), ']=', encode(value, options)].join('')]);
          };
        };
      case 'bracket':
        return function (key) {
          return function (result, value) {
            if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === '') {
              return result;
            }
            if (value === null) {
              return [].concat(_toConsumableArray$1(result), [[encode(key, options), '[]'].join('')]);
            }
            return [].concat(_toConsumableArray$1(result), [[encode(key, options), '[]=', encode(value, options)].join('')]);
          };
        };
      case 'colon-list-separator':
        return function (key) {
          return function (result, value) {
            if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === '') {
              return result;
            }
            if (value === null) {
              return [].concat(_toConsumableArray$1(result), [[encode(key, options), ':list='].join('')]);
            }
            return [].concat(_toConsumableArray$1(result), [[encode(key, options), ':list=', encode(value, options)].join('')]);
          };
        };
      case 'comma':
      case 'separator':
      case 'bracket-separator':
        {
          var keyValueSep = options.arrayFormat === 'bracket-separator' ? '[]=' : '=';
          return function (key) {
            return function (result, value) {
              if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === '') {
                return result;
              }

              // Translate null to an empty string so that it doesn't serialize as 'null'
              value = value === null ? '' : value;
              if (result.length === 0) {
                return [[encode(key, options), keyValueSep, encode(value, options)].join('')];
              }
              return [[result, encode(value, options)].join(options.arrayFormatSeparator)];
            };
          };
        }
      default:
        return function (key) {
          return function (result, value) {
            if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === '') {
              return result;
            }
            if (value === null) {
              return [].concat(_toConsumableArray$1(result), [encode(key, options)]);
            }
            return [].concat(_toConsumableArray$1(result), [[encode(key, options), '=', encode(value, options)].join('')]);
          };
        };
    }
  }
  function parserForArrayFormat(options) {
    var result;
    switch (options.arrayFormat) {
      case 'index':
        return function (key, value, accumulator) {
          result = /\[(\d*)\]$/.exec(key);
          key = key.replace(/\[\d*\]$/, '');
          if (!result) {
            accumulator[key] = value;
            return;
          }
          if (accumulator[key] === undefined) {
            accumulator[key] = {};
          }
          accumulator[key][result[1]] = value;
        };
      case 'bracket':
        return function (key, value, accumulator) {
          result = /(\[\])$/.exec(key);
          key = key.replace(/\[\]$/, '');
          if (!result) {
            accumulator[key] = value;
            return;
          }
          if (accumulator[key] === undefined) {
            accumulator[key] = [value];
            return;
          }
          accumulator[key] = [].concat(accumulator[key], value);
        };
      case 'colon-list-separator':
        return function (key, value, accumulator) {
          result = /(:list)$/.exec(key);
          key = key.replace(/:list$/, '');
          if (!result) {
            accumulator[key] = value;
            return;
          }
          if (accumulator[key] === undefined) {
            accumulator[key] = [value];
            return;
          }
          accumulator[key] = [].concat(accumulator[key], value);
        };
      case 'comma':
      case 'separator':
        return function (key, value, accumulator) {
          var isArray = typeof value === 'string' && value.includes(options.arrayFormatSeparator);
          var isEncodedArray = typeof value === 'string' && !isArray && decode(value, options).includes(options.arrayFormatSeparator);
          value = isEncodedArray ? decode(value, options) : value;
          var newValue = isArray || isEncodedArray ? value.split(options.arrayFormatSeparator).map(function (item) {
            return decode(item, options);
          }) : value === null ? value : decode(value, options);
          accumulator[key] = newValue;
        };
      case 'bracket-separator':
        return function (key, value, accumulator) {
          var isArray = /(\[\])$/.test(key);
          key = key.replace(/\[\]$/, '');
          if (!isArray) {
            accumulator[key] = value ? decode(value, options) : value;
            return;
          }
          var arrayValue = value === null ? [] : value.split(options.arrayFormatSeparator).map(function (item) {
            return decode(item, options);
          });
          if (accumulator[key] === undefined) {
            accumulator[key] = arrayValue;
            return;
          }
          accumulator[key] = [].concat(accumulator[key], arrayValue);
        };
      default:
        return function (key, value, accumulator) {
          if (accumulator[key] === undefined) {
            accumulator[key] = value;
            return;
          }
          accumulator[key] = [].concat(accumulator[key], value);
        };
    }
  }
  function validateArrayFormatSeparator(value) {
    if (typeof value !== 'string' || value.length !== 1) {
      throw new TypeError('arrayFormatSeparator must be single character string');
    }
  }
  function encode(value, options) {
    if (options.encode) {
      return options.strict ? strictUriEncode$1(value) : encodeURIComponent(value);
    }
    return value;
  }
  function decode(value, options) {
    if (options.decode) {
      return decodeComponent(value);
    }
    return value;
  }
  function keysSorter(input) {
    if (Array.isArray(input)) {
      return input.sort();
    }
    if (_typeof$2(input) === 'object') {
      return keysSorter(Object.keys(input)).sort(function (a, b) {
        return Number(a) - Number(b);
      }).map(function (key) {
        return input[key];
      });
    }
    return input;
  }
  function removeHash(input) {
    var hashStart = input.indexOf('#');
    if (hashStart !== -1) {
      input = input.slice(0, hashStart);
    }
    return input;
  }
  function getHash(url) {
    var hash = '';
    var hashStart = url.indexOf('#');
    if (hashStart !== -1) {
      hash = url.slice(hashStart);
    }
    return hash;
  }
  function extract(input) {
    input = removeHash(input);
    var queryStart = input.indexOf('?');
    if (queryStart === -1) {
      return '';
    }
    return input.slice(queryStart + 1);
  }
  function parseValue(value, options) {
    if (options.parseNumbers && !Number.isNaN(Number(value)) && typeof value === 'string' && value.trim() !== '') {
      value = Number(value);
    } else if (options.parseBooleans && value !== null && (value.toLowerCase() === 'true' || value.toLowerCase() === 'false')) {
      value = value.toLowerCase() === 'true';
    }
    return value;
  }
  function parse(query, options) {
    options = Object.assign({
      decode: true,
      sort: true,
      arrayFormat: 'none',
      arrayFormatSeparator: ',',
      parseNumbers: false,
      parseBooleans: false
    }, options);
    validateArrayFormatSeparator(options.arrayFormatSeparator);
    var formatter = parserForArrayFormat(options);

    // Create an object with no prototype
    var ret = Object.create(null);
    if (typeof query !== 'string') {
      return ret;
    }
    query = query.trim().replace(/^[?#&]/, '');
    if (!query) {
      return ret;
    }
    var _iterator = _createForOfIteratorHelper$1(query.split('&')),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var param = _step.value;
        if (param === '') {
          continue;
        }
        var _splitOnFirst = splitOnFirst$1(options.decode ? param.replace(/\+/g, ' ') : param, '='),
          _splitOnFirst2 = _slicedToArray(_splitOnFirst, 2),
          _key = _splitOnFirst2[0],
          _value = _splitOnFirst2[1];

        // Missing `=` should be `null`:
        // http://w3.org/TR/2012/WD-url-20120524/#collect-url-parameters
        _value = _value === undefined ? null : ['comma', 'separator', 'bracket-separator'].includes(options.arrayFormat) ? _value : decode(_value, options);
        formatter(decode(_key, options), _value, ret);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
    for (var _i = 0, _Object$keys = Object.keys(ret); _i < _Object$keys.length; _i++) {
      var key = _Object$keys[_i];
      var value = ret[key];
      if (_typeof$2(value) === 'object' && value !== null) {
        for (var _i2 = 0, _Object$keys2 = Object.keys(value); _i2 < _Object$keys2.length; _i2++) {
          var k = _Object$keys2[_i2];
          value[k] = parseValue(value[k], options);
        }
      } else {
        ret[key] = parseValue(value, options);
      }
    }
    if (options.sort === false) {
      return ret;
    }
    return (options.sort === true ? Object.keys(ret).sort() : Object.keys(ret).sort(options.sort)).reduce(function (result, key) {
      var value = ret[key];
      if (Boolean(value) && _typeof$2(value) === 'object' && !Array.isArray(value)) {
        // Sort object keys, not values
        result[key] = keysSorter(value);
      } else {
        result[key] = value;
      }
      return result;
    }, Object.create(null));
  }
  exports.extract = extract;
  exports.parse = parse;
  exports.stringify = function (object, options) {
    if (!object) {
      return '';
    }
    options = Object.assign({
      encode: true,
      strict: true,
      arrayFormat: 'none',
      arrayFormatSeparator: ','
    }, options);
    validateArrayFormatSeparator(options.arrayFormatSeparator);
    var shouldFilter = function shouldFilter(key) {
      return options.skipNull && isNullOrUndefined(object[key]) || options.skipEmptyString && object[key] === '';
    };
    var formatter = encoderForArrayFormat(options);
    var objectCopy = {};
    for (var _i3 = 0, _Object$keys3 = Object.keys(object); _i3 < _Object$keys3.length; _i3++) {
      var key = _Object$keys3[_i3];
      if (!shouldFilter(key)) {
        objectCopy[key] = object[key];
      }
    }
    var keys = Object.keys(objectCopy);
    if (options.sort !== false) {
      keys.sort(options.sort);
    }
    return keys.map(function (key) {
      var value = object[key];
      if (value === undefined) {
        return '';
      }
      if (value === null) {
        return encode(key, options);
      }
      if (Array.isArray(value)) {
        if (value.length === 0 && options.arrayFormat === 'bracket-separator') {
          return encode(key, options) + '[]';
        }
        return value.reduce(formatter(key), []).join('&');
      }
      return encode(key, options) + '=' + encode(value, options);
    }).filter(function (x) {
      return x.length > 0;
    }).join('&');
  };
  exports.parseUrl = function (url, options) {
    options = Object.assign({
      decode: true
    }, options);
    var _splitOnFirst3 = splitOnFirst$1(url, '#'),
      _splitOnFirst4 = _slicedToArray(_splitOnFirst3, 2),
      url_ = _splitOnFirst4[0],
      hash = _splitOnFirst4[1];
    return Object.assign({
      url: url_.split('?')[0] || '',
      query: parse(extract(url), options)
    }, options && options.parseFragmentIdentifier && hash ? {
      fragmentIdentifier: decode(hash, options)
    } : {});
  };
  exports.stringifyUrl = function (object, options) {
    options = Object.assign(_defineProperty$2({
      encode: true,
      strict: true
    }, encodeFragmentIdentifier, true), options);
    var url = removeHash(object.url).split('?')[0] || '';
    var queryFromUrl = exports.extract(object.url);
    var parsedQueryFromUrl = exports.parse(queryFromUrl, {
      sort: false
    });
    var query = Object.assign(parsedQueryFromUrl, object.query);
    var queryString = exports.stringify(query, options);
    if (queryString) {
      queryString = "?".concat(queryString);
    }
    var hash = getHash(object.url);
    if (object.fragmentIdentifier) {
      hash = "#".concat(options[encodeFragmentIdentifier] ? encode(object.fragmentIdentifier, options) : object.fragmentIdentifier);
    }
    return "".concat(url).concat(queryString).concat(hash);
  };
  exports.pick = function (input, filter, options) {
    options = Object.assign(_defineProperty$2({
      parseFragmentIdentifier: true
    }, encodeFragmentIdentifier, false), options);
    var _exports$parseUrl = exports.parseUrl(input, options),
      url = _exports$parseUrl.url,
      query = _exports$parseUrl.query,
      fragmentIdentifier = _exports$parseUrl.fragmentIdentifier;
    return exports.stringifyUrl({
      url: url,
      query: filterObject(query, filter),
      fragmentIdentifier: fragmentIdentifier
    }, options);
  };
  exports.exclude = function (input, filter, options) {
    var exclusionFilter = Array.isArray(filter) ? function (key) {
      return !filter.includes(key);
    } : function (key, value) {
      return !filter(key, value);
    };
    return exports.pick(input, exclusionFilter, options);
  };
})(queryString$2);

/**
 * 웹 페이지가 모바일 앱 내의 웹뷰에서 실행되고 있는지 여부를 확인합니다.
 * 이 함수는 서버 사이드와 클라이언트 사이드 렌더링 환경 모두에서 사용 가능합니다.
 *
 * @param {Object} query - 서버 사이드 렌더링 시 사용할 쿼리 파라미터 객체입니다. (선택적)
 * @returns {boolean} 웹 페이지가 앱 내의 웹뷰에서 실행되고 있다면 true, 그렇지 않다면 false를 반환합니다.
 */
function isInApp(query) {
  if (typeof window === 'undefined') {
    if (query != null) {
      return query['os_type'] != null || query['app'] != null;
    }
    return false;
  }
  var triggered = false;
  try {
    triggered = sessionStorage['webviewTriggered'] === 'yes';
  } catch (e) {
    console.error(e);
  }
  var search = queryString$2.parse(location.search);
  var isExpertCenterAndroid = search['pro_app'] != null && search['os_type'] === 'Android';
  if (!isExpertCenterAndroid && (triggered || search['os_type'] != null && search['os_type'] !== '' || search['app'] != null)) {
    try {
      sessionStorage['webviewTriggered'] = 'yes';
    } catch (e) {
      console.error(e);
    }
    return true;
  }
  return false;
}

// 모바일 장치를 포괄하는 정규 표현식
var MOBILE_USER_AGENT_REGEX = /iPhone|iPad|iPod|Android|webOS|BlackBerry|IEMobile|Opera Mini|Windows Phone|Kindle|Silk|PlayBook/;
/**
 * 브라우저의 사용자 에이전트 또는 제공된 사용자 에이전트 문자열을 기반으로 현재 환경이 모바일 장치인지 여부를 확인합니다.
 *
 * @param {string} [userAgent=''] - (선택적) 확인할 사용자 에이전트입니다.
 * @returns {boolean} 모바일 장치면 true, 그렇지 않으면 false를 반환합니다.
 *
 * @example
 * 브라우저 환경에서 사용할 경우:
 * isMobile();
 *
 * 사용자 에이전트 문자열을 제공할 경우:
 * isMobile("Mozilla/5.0 (iPhone; CPU iPhone OS 10_3 like Mac OS X)");
 */
function isMobileDevice() {
  var userAgent = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  if (userAgent !== '') {
    return MOBILE_USER_AGENT_REGEX.test(userAgent);
  }
  // 브라우저 환경에서 실행 중인지 확인
  if (typeof window !== 'undefined' && navigator) {
    var isMobileUA = MOBILE_USER_AGENT_REGEX.test(navigator.userAgent);
    // 터치 기능에 대한 추가 검사
    var isTouchDevice = 'ontouchstart' in window || navigator.maxTouchPoints > 0;
    // 모바일 장치를 나타내는 검사 중 하나라도 참이면 true 반환
    return isMobileUA || isTouchDevice;
  }
  return false;
}

/**
 * 주어진 값이 배열인지 여부를 확인합니다.
 * @param {any} value - 검사할 값.
 * @returns {boolean} 값이 배열이면 true, 그렇지 않으면 false를 반환합니다.
 *
 * @example
 * // 배열인 경우
 * isArray([1, 2, 3]); // true
 *
 * @example
 * // 배열이 아닌 경우
 * isArray({ 'a': 1, 'b': 2, 'c': 3 }); // false
 *
 * @example
 * // null 값을 검사하는 경우
 * isArray(null); // false
 */
var isArray$3 = isArray$2;

/** Built-in value references. */
var getPrototype$2 = overArg$1(Object.getPrototypeOf, Object);
var getPrototype$1$1 = getPrototype$2;

/** `Object#toString` result references. */
var objectTag$1$1 = '[object Object]';

/** Used for built-in method references. */
var funcProto$3 = Function.prototype,
  objectProto$3$1 = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString$3 = funcProto$3.toString;

/** Used to check objects for own properties. */
var hasOwnProperty$3$1 = objectProto$3$1.hasOwnProperty;

/** Used to infer the `Object` constructor. */
var objectCtorString = funcToString$3.call(Object);

/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */
function isPlainObject(value) {
  if (!isObjectLike$1(value) || baseGetTag$1(value) != objectTag$1$1) {
    return false;
  }
  var proto = getPrototype$1$1(value);
  if (proto === null) {
    return true;
  }
  var Ctor = hasOwnProperty$3$1.call(proto, 'constructor') && proto.constructor;
  return typeof Ctor == 'function' && Ctor instanceof Ctor && funcToString$3.call(Ctor) == objectCtorString;
}

/** Used for built-in method references. */
var objectProto$2$1 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$2$1 = objectProto$2$1.hasOwnProperty;

/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignValue$1(object, key, value) {
  var objValue = object[key];
  if (!(hasOwnProperty$2$1.call(object, key) && eq$1(objValue, value)) || value === undefined && !(key in object)) {
    baseAssignValue$1(object, key, value);
  }
}

/**
 * The base implementation of `_.set`.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to set.
 * @param {*} value The value to set.
 * @param {Function} [customizer] The function to customize path creation.
 * @returns {Object} Returns `object`.
 */
function baseSet$1(object, path, value, customizer) {
  if (!isObject$1$1(object)) {
    return object;
  }
  path = castPath$1(path, object);
  var index = -1,
    length = path.length,
    lastIndex = length - 1,
    nested = object;
  while (nested != null && ++index < length) {
    var key = toKey$1(path[index]),
      newValue = value;
    if (key === '__proto__' || key === 'constructor' || key === 'prototype') {
      return object;
    }
    if (index != lastIndex) {
      var objValue = nested[key];
      newValue = customizer ? customizer(objValue, key, nested) : undefined;
      if (newValue === undefined) {
        newValue = isObject$1$1(objValue) ? objValue : isIndex$1(path[index + 1]) ? [] : {};
      }
    }
    assignValue$1(nested, key, newValue);
    nested = nested[key];
  }
  return object;
}

/**
 * The base implementation of  `_.pickBy` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The source object.
 * @param {string[]} paths The property paths to pick.
 * @param {Function} predicate The function invoked per property.
 * @returns {Object} Returns the new object.
 */
function basePickBy$1(object, paths, predicate) {
  var index = -1,
    length = paths.length,
    result = {};
  while (++index < length) {
    var path = paths[index],
      value = baseGet$1(object, path);
    if (predicate(value, path)) {
      baseSet$1(result, castPath$1(path, object), value);
    }
  }
  return result;
}

/**
 * The base implementation of `_.pick` without support for individual
 * property identifiers.
 *
 * @private
 * @param {Object} object The source object.
 * @param {string[]} paths The property paths to pick.
 * @returns {Object} Returns the new object.
 */
function basePick$1(object, paths) {
  return basePickBy$1(object, paths, function (value, path) {
    return hasIn$1(object, path);
  });
}

/** Built-in value references. */
var spreadableSymbol$1 = _Symbol$1 ? _Symbol$1.isConcatSpreadable : undefined;

/**
 * Checks if `value` is a flattenable `arguments` object or array.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
 */
function isFlattenable$1(value) {
  return isArray$2(value) || isArguments$1$1(value) || !!(spreadableSymbol$1 && value && value[spreadableSymbol$1]);
}

/**
 * The base implementation of `_.flatten` with support for restricting flattening.
 *
 * @private
 * @param {Array} array The array to flatten.
 * @param {number} depth The maximum recursion depth.
 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
 * @param {Array} [result=[]] The initial result value.
 * @returns {Array} Returns the new flattened array.
 */
function baseFlatten$1(array, depth, predicate, isStrict, result) {
  var index = -1,
    length = array.length;
  predicate || (predicate = isFlattenable$1);
  result || (result = []);
  while (++index < length) {
    var value = array[index];
    if (depth > 0 && predicate(value)) {
      if (depth > 1) {
        // Recursively flatten arrays (susceptible to call stack limits).
        baseFlatten$1(value, depth - 1, predicate, isStrict, result);
      } else {
        arrayPush$1(result, value);
      }
    } else if (!isStrict) {
      result[result.length] = value;
    }
  }
  return result;
}

/**
 * Flattens `array` a single level deep.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to flatten.
 * @returns {Array} Returns the new flattened array.
 * @example
 *
 * _.flatten([1, [2, [3, [4]], 5]]);
 * // => [1, 2, [3, [4]], 5]
 */
function flatten$1(array) {
  var length = array == null ? 0 : array.length;
  return length ? baseFlatten$1(array, 1) : [];
}

/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */
function apply$1(func, thisArg, args) {
  switch (args.length) {
    case 0:
      return func.call(thisArg);
    case 1:
      return func.call(thisArg, args[0]);
    case 2:
      return func.call(thisArg, args[0], args[1]);
    case 3:
      return func.call(thisArg, args[0], args[1], args[2]);
  }
  return func.apply(thisArg, args);
}

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax$2 = Math.max;

/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */
function overRest$1(func, start, transform) {
  start = nativeMax$2(start === undefined ? func.length - 1 : start, 0);
  return function () {
    var args = arguments,
      index = -1,
      length = nativeMax$2(args.length - start, 0),
      array = Array(length);
    while (++index < length) {
      array[index] = args[start + index];
    }
    index = -1;
    var otherArgs = Array(start + 1);
    while (++index < start) {
      otherArgs[index] = args[index];
    }
    otherArgs[start] = transform(array);
    return apply$1(func, this, otherArgs);
  };
}

/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */
function constant$1(value) {
  return function () {
    return value;
  };
}

/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var baseSetToString$2 = !defineProperty$1$1 ? identity$1 : function (func, string) {
  return defineProperty$1$1(func, 'toString', {
    'configurable': true,
    'enumerable': false,
    'value': constant$1(string),
    'writable': true
  });
};
var baseSetToString$1$1 = baseSetToString$2;

/** Used to detect hot functions by number of calls within a span of milliseconds. */
var HOT_COUNT$1 = 800,
  HOT_SPAN$1 = 16;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeNow$1 = Date.now;

/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */
function shortOut$1(func) {
  var count = 0,
    lastCalled = 0;
  return function () {
    var stamp = nativeNow$1(),
      remaining = HOT_SPAN$1 - (stamp - lastCalled);
    lastCalled = stamp;
    if (remaining > 0) {
      if (++count >= HOT_COUNT$1) {
        return arguments[0];
      }
    } else {
      count = 0;
    }
    return func.apply(undefined, arguments);
  };
}

/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var setToString$2 = shortOut$1(baseSetToString$1$1);
var setToString$1$1 = setToString$2;

/**
 * A specialized version of `baseRest` which flattens the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @returns {Function} Returns the new function.
 */
function flatRest$1(func) {
  return setToString$1$1(overRest$1(func, undefined, flatten$1), func + '');
}

/**
 * Creates an object composed of the picked `object` properties.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The source object.
 * @param {...(string|string[])} [paths] The property paths to pick.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.pick(object, ['a', 'c']);
 * // => { 'a': 1, 'c': 3 }
 */
flatRest$1(function (object, paths) {
  return object == null ? {} : basePick$1(object, paths);
});

/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */
function arrayEach(array, iteratee) {
  var index = -1,
    length = array == null ? 0 : array.length;
  while (++index < length) {
    if (iteratee(array[index], index, array) === false) {
      break;
    }
  }
  return array;
}

/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */
function copyObject(source, props, object, customizer) {
  var isNew = !object;
  object || (object = {});
  var index = -1,
    length = props.length;
  while (++index < length) {
    var key = props[index];
    var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined;
    if (newValue === undefined) {
      newValue = source[key];
    }
    if (isNew) {
      baseAssignValue$1(object, key, newValue);
    } else {
      assignValue$1(object, key, newValue);
    }
  }
  return object;
}

/**
 * The base implementation of `_.assign` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */
function baseAssign(object, source) {
  return object && copyObject(source, keys$1(source), object);
}

/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function nativeKeysIn$1(object) {
  var result = [];
  if (object != null) {
    for (var key in Object(object)) {
      result.push(key);
    }
  }
  return result;
}

/** Used for built-in method references. */
var objectProto$1$1 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$1$1 = objectProto$1$1.hasOwnProperty;

/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeysIn$1(object) {
  if (!isObject$1$1(object)) {
    return nativeKeysIn$1(object);
  }
  var isProto = isPrototype$1(object),
    result = [];
  for (var key in object) {
    if (!(key == 'constructor' && (isProto || !hasOwnProperty$1$1.call(object, key)))) {
      result.push(key);
    }
  }
  return result;
}

/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */
function keysIn$1(object) {
  return isArrayLike$1(object) ? arrayLikeKeys$1(object, true) : baseKeysIn$1(object);
}

/**
 * The base implementation of `_.assignIn` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */
function baseAssignIn(object, source) {
  return object && copyObject(source, keysIn$1(source), object);
}

/** Detect free variable `exports`. */
var freeExports$3 = (typeof exports === "undefined" ? "undefined" : _typeof$2(exports)) == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule$3 = freeExports$3 && ( false ? 0 : _typeof$2(module)) == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports$3 = freeModule$3 && freeModule$3.exports === freeExports$3;

/** Built-in value references. */
var Buffer$2 = moduleExports$3 ? root$1$1.Buffer : undefined,
  allocUnsafe = Buffer$2 ? Buffer$2.allocUnsafe : undefined;

/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */
function cloneBuffer(buffer, isDeep) {
  if (isDeep) {
    return buffer.slice();
  }
  var length = buffer.length,
    result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
  buffer.copy(result);
  return result;
}

/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */
function copyArray(source, array) {
  var index = -1,
    length = source.length;
  array || (array = Array(length));
  while (++index < length) {
    array[index] = source[index];
  }
  return array;
}

/**
 * Copies own symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */
function copySymbols(source, object) {
  return copyObject(source, getSymbols$1$1(source), object);
}

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols$2 = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own and inherited enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbolsIn$2 = !nativeGetSymbols$2 ? stubArray$1 : function (object) {
  var result = [];
  while (object) {
    arrayPush$1(result, getSymbols$1$1(object));
    object = getPrototype$1$1(object);
  }
  return result;
};
var getSymbolsIn$1$1 = getSymbolsIn$2;

/**
 * Copies own and inherited symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */
function copySymbolsIn(source, object) {
  return copyObject(source, getSymbolsIn$1$1(source), object);
}

/**
 * Creates an array of own and inherited enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeysIn$1(object) {
  return baseGetAllKeys$1(object, keysIn$1, getSymbolsIn$1$1);
}

/** Used for built-in method references. */
var objectProto$i = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$f = objectProto$i.hasOwnProperty;

/**
 * Initializes an array clone.
 *
 * @private
 * @param {Array} array The array to clone.
 * @returns {Array} Returns the initialized clone.
 */
function initCloneArray(array) {
  var length = array.length,
    result = new array.constructor(length);

  // Add properties assigned by `RegExp#exec`.
  if (length && typeof array[0] == 'string' && hasOwnProperty$f.call(array, 'index')) {
    result.index = array.index;
    result.input = array.input;
  }
  return result;
}

/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */
function cloneArrayBuffer(arrayBuffer) {
  var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
  new Uint8Array$1$1(result).set(new Uint8Array$1$1(arrayBuffer));
  return result;
}

/**
 * Creates a clone of `dataView`.
 *
 * @private
 * @param {Object} dataView The data view to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned data view.
 */
function cloneDataView(dataView, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
  return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
}

/** Used to match `RegExp` flags from their coerced string values. */
var reFlags = /\w*$/;

/**
 * Creates a clone of `regexp`.
 *
 * @private
 * @param {Object} regexp The regexp to clone.
 * @returns {Object} Returns the cloned regexp.
 */
function cloneRegExp(regexp) {
  var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
  result.lastIndex = regexp.lastIndex;
  return result;
}

/** Used to convert symbols to primitives and strings. */
var symbolProto$3 = _Symbol$1 ? _Symbol$1.prototype : undefined,
  symbolValueOf$1 = symbolProto$3 ? symbolProto$3.valueOf : undefined;

/**
 * Creates a clone of the `symbol` object.
 *
 * @private
 * @param {Object} symbol The symbol object to clone.
 * @returns {Object} Returns the cloned symbol object.
 */
function cloneSymbol(symbol) {
  return symbolValueOf$1 ? Object(symbolValueOf$1.call(symbol)) : {};
}

/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */
function cloneTypedArray(typedArray, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
  return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}

/** `Object#toString` result references. */
var boolTag$1$1 = '[object Boolean]',
  dateTag$1$1 = '[object Date]',
  mapTag$2$1 = '[object Map]',
  numberTag$1$1 = '[object Number]',
  regexpTag$1$1 = '[object RegExp]',
  setTag$2$1 = '[object Set]',
  stringTag$1$1 = '[object String]',
  symbolTag$1$1 = '[object Symbol]';
var arrayBufferTag$1$1 = '[object ArrayBuffer]',
  dataViewTag$1$1 = '[object DataView]',
  float32Tag$1 = '[object Float32Array]',
  float64Tag$1 = '[object Float64Array]',
  int8Tag$1 = '[object Int8Array]',
  int16Tag$1 = '[object Int16Array]',
  int32Tag$1 = '[object Int32Array]',
  uint8Tag$1 = '[object Uint8Array]',
  uint8ClampedTag$1 = '[object Uint8ClampedArray]',
  uint16Tag$1 = '[object Uint16Array]',
  uint32Tag$1 = '[object Uint32Array]';

/**
 * Initializes an object clone based on its `toStringTag`.
 *
 * **Note:** This function only supports cloning values with tags of
 * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
 *
 * @private
 * @param {Object} object The object to clone.
 * @param {string} tag The `toStringTag` of the object to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneByTag(object, tag, isDeep) {
  var Ctor = object.constructor;
  switch (tag) {
    case arrayBufferTag$1$1:
      return cloneArrayBuffer(object);
    case boolTag$1$1:
    case dateTag$1$1:
      return new Ctor(+object);
    case dataViewTag$1$1:
      return cloneDataView(object, isDeep);
    case float32Tag$1:
    case float64Tag$1:
    case int8Tag$1:
    case int16Tag$1:
    case int32Tag$1:
    case uint8Tag$1:
    case uint8ClampedTag$1:
    case uint16Tag$1:
    case uint32Tag$1:
      return cloneTypedArray(object, isDeep);
    case mapTag$2$1:
      return new Ctor();
    case numberTag$1$1:
    case stringTag$1$1:
      return new Ctor(object);
    case regexpTag$1$1:
      return cloneRegExp(object);
    case setTag$2$1:
      return new Ctor();
    case symbolTag$1$1:
      return cloneSymbol(object);
  }
}

/** Built-in value references. */
var objectCreate = Object.create;

/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */
var baseCreate = function () {
  function object() {}
  return function (proto) {
    if (!isObject$1$1(proto)) {
      return {};
    }
    if (objectCreate) {
      return objectCreate(proto);
    }
    object.prototype = proto;
    var result = new object();
    object.prototype = undefined;
    return result;
  };
}();
var baseCreate$1 = baseCreate;

/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneObject(object) {
  return typeof object.constructor == 'function' && !isPrototype$1(object) ? baseCreate$1(getPrototype$1$1(object)) : {};
}

/** `Object#toString` result references. */
var mapTag$1$1 = '[object Map]';

/**
 * The base implementation of `_.isMap` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 */
function baseIsMap(value) {
  return isObjectLike$1(value) && getTag$1$1(value) == mapTag$1$1;
}

/* Node.js helper references. */
var nodeIsMap = nodeUtil$1$1 && nodeUtil$1$1.isMap;

/**
 * Checks if `value` is classified as a `Map` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 * @example
 *
 * _.isMap(new Map);
 * // => true
 *
 * _.isMap(new WeakMap);
 * // => false
 */
var isMap = nodeIsMap ? baseUnary$1(nodeIsMap) : baseIsMap;
var isMap$1 = isMap;

/** `Object#toString` result references. */
var setTag$1$1 = '[object Set]';

/**
 * The base implementation of `_.isSet` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 */
function baseIsSet(value) {
  return isObjectLike$1(value) && getTag$1$1(value) == setTag$1$1;
}

/* Node.js helper references. */
var nodeIsSet = nodeUtil$1$1 && nodeUtil$1$1.isSet;

/**
 * Checks if `value` is classified as a `Set` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 * @example
 *
 * _.isSet(new Set);
 * // => true
 *
 * _.isSet(new WeakSet);
 * // => false
 */
var isSet = nodeIsSet ? baseUnary$1(nodeIsSet) : baseIsSet;
var isSet$1 = isSet;

/** Used to compose bitmasks for cloning. */
var CLONE_DEEP_FLAG$1 = 1,
  CLONE_FLAT_FLAG$1 = 2,
  CLONE_SYMBOLS_FLAG$1 = 4;

/** `Object#toString` result references. */
var argsTag$4 = '[object Arguments]',
  arrayTag$3 = '[object Array]',
  boolTag$2 = '[object Boolean]',
  dateTag$3 = '[object Date]',
  errorTag$3 = '[object Error]',
  funcTag$3 = '[object Function]',
  genTag$2 = '[object GeneratorFunction]',
  mapTag$6 = '[object Map]',
  numberTag$2 = '[object Number]',
  objectTag$5 = '[object Object]',
  regexpTag$3 = '[object RegExp]',
  setTag$6 = '[object Set]',
  stringTag$2 = '[object String]',
  symbolTag$3 = '[object Symbol]',
  weakMapTag$3 = '[object WeakMap]';
var arrayBufferTag$3 = '[object ArrayBuffer]',
  dataViewTag$4 = '[object DataView]',
  float32Tag$3 = '[object Float32Array]',
  float64Tag$3 = '[object Float64Array]',
  int8Tag$3 = '[object Int8Array]',
  int16Tag$3 = '[object Int16Array]',
  int32Tag$3 = '[object Int32Array]',
  uint8Tag$3 = '[object Uint8Array]',
  uint8ClampedTag$3 = '[object Uint8ClampedArray]',
  uint16Tag$3 = '[object Uint16Array]',
  uint32Tag$3 = '[object Uint32Array]';

/** Used to identify `toStringTag` values supported by `_.clone`. */
var cloneableTags = {};
cloneableTags[argsTag$4] = cloneableTags[arrayTag$3] = cloneableTags[arrayBufferTag$3] = cloneableTags[dataViewTag$4] = cloneableTags[boolTag$2] = cloneableTags[dateTag$3] = cloneableTags[float32Tag$3] = cloneableTags[float64Tag$3] = cloneableTags[int8Tag$3] = cloneableTags[int16Tag$3] = cloneableTags[int32Tag$3] = cloneableTags[mapTag$6] = cloneableTags[numberTag$2] = cloneableTags[objectTag$5] = cloneableTags[regexpTag$3] = cloneableTags[setTag$6] = cloneableTags[stringTag$2] = cloneableTags[symbolTag$3] = cloneableTags[uint8Tag$3] = cloneableTags[uint8ClampedTag$3] = cloneableTags[uint16Tag$3] = cloneableTags[uint32Tag$3] = true;
cloneableTags[errorTag$3] = cloneableTags[funcTag$3] = cloneableTags[weakMapTag$3] = false;

/**
 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
 * traversed objects.
 *
 * @private
 * @param {*} value The value to clone.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Deep clone
 *  2 - Flatten inherited properties
 *  4 - Clone symbols
 * @param {Function} [customizer] The function to customize cloning.
 * @param {string} [key] The key of `value`.
 * @param {Object} [object] The parent object of `value`.
 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
 * @returns {*} Returns the cloned value.
 */
function baseClone(value, bitmask, customizer, key, object, stack) {
  var result,
    isDeep = bitmask & CLONE_DEEP_FLAG$1,
    isFlat = bitmask & CLONE_FLAT_FLAG$1,
    isFull = bitmask & CLONE_SYMBOLS_FLAG$1;
  if (customizer) {
    result = object ? customizer(value, key, object, stack) : customizer(value);
  }
  if (result !== undefined) {
    return result;
  }
  if (!isObject$1$1(value)) {
    return value;
  }
  var isArr = isArray$2(value);
  if (isArr) {
    result = initCloneArray(value);
    if (!isDeep) {
      return copyArray(value, result);
    }
  } else {
    var tag = getTag$1$1(value),
      isFunc = tag == funcTag$3 || tag == genTag$2;
    if (isBuffer$1$1(value)) {
      return cloneBuffer(value, isDeep);
    }
    if (tag == objectTag$5 || tag == argsTag$4 || isFunc && !object) {
      result = isFlat || isFunc ? {} : initCloneObject(value);
      if (!isDeep) {
        return isFlat ? copySymbolsIn(value, baseAssignIn(result, value)) : copySymbols(value, baseAssign(result, value));
      }
    } else {
      if (!cloneableTags[tag]) {
        return object ? value : {};
      }
      result = initCloneByTag(value, tag, isDeep);
    }
  }
  // Check for circular references and return its corresponding clone.
  stack || (stack = new Stack$1());
  var stacked = stack.get(value);
  if (stacked) {
    return stacked;
  }
  stack.set(value, result);
  if (isSet$1(value)) {
    value.forEach(function (subValue) {
      result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
    });
  } else if (isMap$1(value)) {
    value.forEach(function (subValue, key) {
      result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
    });
  }
  var keysFunc = isFull ? isFlat ? getAllKeysIn$1 : getAllKeys$1 : isFlat ? keysIn$1 : keys$1;
  var props = isArr ? undefined : keysFunc(value);
  arrayEach(props || value, function (subValue, key) {
    if (props) {
      key = subValue;
      subValue = value[key];
    }
    // Recursively populate clone (susceptible to call stack limits).
    assignValue$1(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
  });
  return result;
}

/**
 * Gets the last element of `array`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to query.
 * @returns {*} Returns the last element of `array`.
 * @example
 *
 * _.last([1, 2, 3]);
 * // => 3
 */
function last(array) {
  var length = array == null ? 0 : array.length;
  return length ? array[length - 1] : undefined;
}

/**
 * The base implementation of `_.slice` without an iteratee call guard.
 *
 * @private
 * @param {Array} array The array to slice.
 * @param {number} [start=0] The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the slice of `array`.
 */
function baseSlice(array, start, end) {
  var index = -1,
    length = array.length;
  if (start < 0) {
    start = -start > length ? 0 : length + start;
  }
  end = end > length ? length : end;
  if (end < 0) {
    end += length;
  }
  length = start > end ? 0 : end - start >>> 0;
  start >>>= 0;
  var result = Array(length);
  while (++index < length) {
    result[index] = array[index + start];
  }
  return result;
}

/**
 * Gets the parent value at `path` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array} path The path to get the parent value of.
 * @returns {*} Returns the parent value.
 */
function parent(object, path) {
  return path.length < 2 ? object : baseGet$1(object, baseSlice(path, 0, -1));
}

/**
 * The base implementation of `_.unset`.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {Array|string} path The property path to unset.
 * @returns {boolean} Returns `true` if the property is deleted, else `false`.
 */
function baseUnset(object, path) {
  path = castPath$1(path, object);
  object = parent(object, path);
  return object == null || delete object[toKey$1(last(path))];
}

/**
 * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
 * objects.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {string} key The key of the property to inspect.
 * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
 */
function customOmitClone(value) {
  return isPlainObject(value) ? undefined : value;
}

/** Used to compose bitmasks for cloning. */
var CLONE_DEEP_FLAG = 1,
  CLONE_FLAT_FLAG = 2,
  CLONE_SYMBOLS_FLAG = 4;

/**
 * The opposite of `_.pick`; this method creates an object composed of the
 * own and inherited enumerable property paths of `object` that are not omitted.
 *
 * **Note:** This method is considerably slower than `_.pick`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The source object.
 * @param {...(string|string[])} [paths] The property paths to omit.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.omit(object, ['a', 'c']);
 * // => { 'b': '2' }
 */
var omit$1 = flatRest$1(function (object, paths) {
  var result = {};
  if (object == null) {
    return result;
  }
  var isDeep = false;
  paths = arrayMap$1(paths, function (path) {
    path = castPath$1(path, object);
    isDeep || (isDeep = path.length > 1);
    return path;
  });
  copyObject(object, getAllKeysIn$1(object), result);
  if (isDeep) {
    result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
  }
  var length = paths.length;
  while (length--) {
    baseUnset(result, paths[length]);
  }
  return result;
});
var omit$2 = (/* unused pure expression or super */ null && (omit$1));

/**
 * 주어진 객체에서 선택된 키들에 해당하는 속성들을 제외한 나머지 속성들을 포함하는 새 객체를 반환합니다.
 * @param {Object} object - 원본 객체.
 * @param {string[]} paths - 제외할 속성의 키들을 나타내는 문자열 배열.
 * @returns {Object} 제외된 속성들을 제외한 나머지 속성들을 포함하는 새 객체.
 *
 * @example
 * // 객체에서 'b' 속성을 제외
 * omit({ 'a': 1, 'b': '2', 'c': 3 }, ['b']); // { 'a': 1, 'c': 3 }
 *
 * @example
 * // 객체에서 여러 속성을 제외
 * omit({ 'name': 'apple', 'color': 'red', 'weight': 100 }, ['color', 'weight']); // { 'name': 'apple' }
 */
var omit = (/* unused pure expression or super */ null && (omit$2));

/**
 * 숫자에 천자리 단위 (,)를 추가합니다.
 * @param x 천자리 단위 (,) 넣을 숫자
 * @returns 천자리 단위 (,) 포함된 숫자
 * @example
 * ```
 * formatComma(1000000);
 * 1,000,000
 * ```
 */
function formatComma(x) {
  if (x == null || Number.isNaN(Number(x))) {
    return '';
  }
  return x.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
}
(',r,R,rt,s,sw,sg,e,f,fr,fa,fq,ft,fx,fv,fg,a,q,qt,t,T,' + 'd,w,c,z,x,v,g').split(',');
(',r,R,rt,s,sw,sg,e,E,f,fr,fa,fq,ft,fx,fv,fg,a,q,Q,qt,t,' + 'T,d,w,W,c,z,x,v,g,k,o,i,O,j,p,u,P,h,hk,ho,hl,y,n,nj,np,nl,b,m,ml,l').split(',');

/**
 * 주어진 숫자를 지정된 기준(base)를 기반으로 승수(step)를 구하고 정규화된 값을 반환합니다.
 *
 * 정규화된 값은 입력된 숫자를 해당 숫자를 나누는 기준(base)의 최고 차수로 나눈 결과입니다.
 * 단계는 입력된 숫자를 나누는 기준(base)의 최고 차수의 지수를 나타냅니다.
 *
 * @example calculateExponentStep(2312111, 1000) -> [2.3, 2]
 *
 * @param input 계산할 숫자
 * @param base 기준 값
 * @returns 정규화된 값과 단계를 포함하는 배열을 반환합니다.
 */
function calculateExponentStep(input, base) {
  if (input === 0) {
    return [0, 0];
  }
  var step = Math.floor(Math.log10(Math.abs(input)) / Math.log10(base));
  var divisor = Math.pow(base, step);
  return [input / divisor, step];
}

/**
 * 큰 수를 줄임 표기 형태로 변환합니다.
 *
 * @example 2312111 -> 2.3M
 * @example 126057 -> 126K
 *
 * @param number 변환할 숫자
 * @param base 기준값
 * @params markers 기준값에 따른 표기
 * @returns 변환된 문자열
 */
function formatLargeNumber(number) {
  var base = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1000;
  var markers = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : ['', 'K', 'M', 'B'];
  var formatNumber = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : function (n) {
    return String(Math.floor(n * 10) / 10);
  };
  var _calculateExponentSte = calculateExponentStep(number, base),
    _calculateExponentSte2 = _slicedToArray(_calculateExponentSte, 2),
    value = _calculateExponentSte2[0],
    step = _calculateExponentSte2[1];
  if (step >= markers.length) {
    var cappedStep = markers.length - 1;
    var accumulated = value * Math.pow(base, step - cappedStep);
    return "".concat(accumulated.toFixed(1)).concat(markers[cappedStep]);
  }
  return "".concat(formatNumber(value)).concat(markers[step]);
}

/**
 * text를 clipboard로 복사합니다.
 * @param text 복사할 text
 * @returns 성공 여부
 * @example
 * ```
 * copyTextToClipboard('오늘의집')
 * true or false
 * ```
 */
var copyTextToClipboard = function copyTextToClipboard(text) {
  var textArea = document.createElement('textarea');
  textArea.style.position = 'fixed';
  textArea.style.top = '0';
  textArea.style.left = '0';
  textArea.style.width = '20em';
  textArea.style.height = '20em';
  textArea.style.padding = '0';
  textArea.style.border = 'none';
  textArea.style.outline = 'none';
  textArea.style.boxShadow = 'none';
  textArea.style.background = 'transparent';
  textArea.value = text;
  document.body.appendChild(textArea);
  if (navigator.userAgent.match(/ipad|ipod|iphone/i)) {
    textArea.contentEditable = 'true';
    textArea.readOnly = true;
    var range = document.createRange();
    range.selectNodeContents(textArea);
    var selection = window.getSelection();
    selection.removeAllRanges();
    selection.addRange(range);
    textArea.setSelectionRange(0, 9999999);
  } else {
    textArea.select();
  }
  var successful = false;
  try {
    /** execCommand: deprecated된 메소드 입니다. */
    successful = document.execCommand('copy');
  } catch (err) {
    throw new Error('Unable to copy');
  } finally {
    window.document.body.removeChild(textArea);
  }
  return successful;
};

/**
 * url에서 쿼리 파라미터를 추출하여 객체 형태로 변환합니다.
 * @param {string} url url
 * @returns url 쿼리 객체
 * @example
 * ```
 * getQuery('https://ohou.se?a=1&b=2');
 * { a: 1, b: 2 }
 * ```
 */
var getQuery = memoize$1$1(function (url) {
  var search = (/\?(.+)$/.exec(url) || ['', ''])[1];
  return queryString$2.parse(search.replace(/&amp;/g, '&'));
});

const THOUSAND_MATCH_REGX = /^((\d)[0]{3})$/;
const MILLION_MATCH_REGX = /(\d{1,})[0]{4}/;

/**
 * 상품카드 내 할인가격을 규칙에 맞게 노출합니다.
 * e.g) 100 -> 100원, 1000원 -> 1천원, 10000원 -> 1만원
 * @param number 할인가격
 * @returns 규칙이 적용된 할인가격
 * @example
 * ```
 * getShortenPrice(1000)
 * 1천원
 * ```
 */
const getShortenPrice = amount => {
  const strAmount = amount.toString();
  if (THOUSAND_MATCH_REGX.test(strAmount)) {
    return strAmount.replace('000', '천원');
  }
  if (MILLION_MATCH_REGX.test(strAmount)) {
    return `${formatComma(amount / 10000)}만원`;
  }
  return `${formatComma(amount)}원`;
};

/**
 * 상품카드에 노출되는 상품쿠폰 뱃지 텍스트
 * e.g) 할인쿠폰, 최대 10% 할인, 최대 10,000원 할인
 * @param goodsCouponMold 상품쿠폰틀
 * @param isLoggedIn 로그인 유무
 * @returns 상품쿠폰 뱃지 텍스트
 * @example
 * ```
 * getCouponBadgeTitle({
 *  title: '(연지) claim_재발행 + 고정만료 5,500원 쿠폰',
 *  discountType: 'FIXED_AMOUNT',
 *  couponType: 'GOODS',
 *  discountAmount: '5500',
 *  minBaseAmount: '100',
 *}, true);
 * ```
 */
const getCouponBadgeTitle = (goodsCouponMold, isLoggedIn) => {
  if (!isLoggedIn) {
    return '할인쿠폰';
  }
  if (goodsCouponMold.discountType === 'FIXED_RATE') {
    return `최대 ${Math.round((goodsCouponMold.discountRate ?? 0) * 100)}% 할인`;
  }
  const maxDiscountAmount = Number.parseInt(goodsCouponMold.maxDiscountAmount ?? '0', 10);
  const discountAmount = Number.parseInt(goodsCouponMold.discountAmount ?? '0', 10);
  const discountPrice = maxDiscountAmount > 0 ? Math.min(maxDiscountAmount, discountAmount) : discountAmount;
  const shortPrice = getShortenPrice(discountPrice);
  return `최대 ${shortPrice} 할인`;
};

/** 사용자에게 노출되는 메시지를 커스텀합니다. */
const CUSTOM_COUPON_PUBLISH_MESSAGE = {
  SUCCESS: '쿠폰이 발급되었습니다. 발급된 쿠폰은 주문서에 자동 적용됩니다.',
  PART_SUCCESS: '발급 불가 쿠폰을 제외하고 발급되었습니다. 발급된 쿠폰은 주문서에 자동 적용됩니다.',
  ERROR: '쿠폰 다운로드에 실패했습니다.',
  DONE: '이미 발급된 쿠폰입니다. 발급된 쿠폰은 주문서에 자동 적용됩니다.'
};
const COUPON_PUBLISH_DONE_MESSAGE = '이미 발급된 쿠폰입니다.';
/**
 * publish_coupons의 결과값들을 상태별로 분류
 * @param coupons publish_coupons의 response
 * @returns publish_coupons 의 status (성공, 실패, 이미발급)
 */
const getPublishCartCouponStatus = coupons => {
  return coupons.reduce((acc, coupon) => {
    const {
      success,
      message
    } = coupon;
    if (success) {
      return {
        ...acc,
        success: acc.success.concat(coupon)
      };
    }
    if (message === COUPON_PUBLISH_DONE_MESSAGE) {
      return {
        ...acc,
        done: acc.done.concat(coupon)
      };
    }
    return {
      ...acc,
      errors: acc.errors.concat(coupon)
    };
  }, {
    errors: [],
    success: [],
    done: []
  });
};
const getPublishProductCouponStatus = coupons => {
  return coupons.reduce((acc, coupon) => {
    if ('response' in coupon) {
      const success = coupon.response?.map(coupon => coupon) ?? [];
      return {
        ...acc,
        success: acc.success.concat(success)
      };
    }
    const {
      message
    } = coupon;
    if (message === COUPON_PUBLISH_DONE_MESSAGE) {
      return {
        ...acc,
        done: acc.done.concat(coupon)
      };
    }
    return {
      ...acc,
      errors: acc.errors.concat(coupon)
    };
  }, {
    errors: [],
    success: [],
    done: []
  });
};

/**
 * 쿠폰팩 메시지 헨들링
 * @see {@link https://wiki.dailyhou.se/x/GP_0Bw}
 */
const getCouponsPublishMessage = (cartCoupons, productCoupons) => {
  const {
    success: cartSuccess,
    done: cartDone,
    errors: cartErrors
  } = getPublishCartCouponStatus(cartCoupons);
  const {
    success: productSuccess,
    done: productDone,
    errors: productErrors
  } = getPublishProductCouponStatus(productCoupons);
  const coupons = [...cartCoupons, ...productCoupons];
  const success = [...cartSuccess, ...productSuccess];
  const done = [...cartDone, ...productDone];
  const errors = [...cartErrors, ...productErrors];

  // 전부 이미 받음
  if (coupons.length === done.length) {
    return CUSTOM_COUPON_PUBLISH_MESSAGE.DONE;
  }
  // 발급 성공 & 발급 실패
  if (success.length > 0 && errors.length > 0) {
    return CUSTOM_COUPON_PUBLISH_MESSAGE.PART_SUCCESS;
  }
  // 발급 성공
  if (success.length > 0) {
    return CUSTOM_COUPON_PUBLISH_MESSAGE.SUCCESS;
  }
  // 전부 실패
  const hasSameError = errors.every(({
    message
  }) => message === errors[0]?.message);
  const errorMessage = hasSameError && errors[0]?.message ? errors[0].message : CUSTOM_COUPON_PUBLISH_MESSAGE.ERROR;
  return errorMessage;
};

const KAKAO_TEMPLATE_ID = {
  INVITE_FRIEND: 55328,
  PROJECT: 7230,
  CARD: 7231,
  ADVICE: 7281,
  SELLING_PRODUCT: 7282,
  NOT_SELLING_PRODUCT: 7286,
  /** 상품4개인 기획전 */
  EXHIBITION: 7289,
  /** 상품없는 기획전 */
  NO_PRODUCT_EXHIBITION: 96825,
  MY_HOME: 7325,
  QUESTION: 8237,
  CONTEST: 7331,
  SCRAP_BOOK: 9425,
  TODAY_PRODUCT: 12318,
  COMMON: 35477,
  COMMON_BUTTON_TEXT_CUSTOM: 77289
};

/**
 * 기획전 카카오 템플릿
 * @param exhibitionId 기획전 ID
 * @param title 기획전 제목
 * @param coverImageUrls 기획전 커버 이미지
 * @param products 상품 리스트
 * @returns 카카오 템플릿
 */
const getExhibitionKakaoTemplate = ({
  exhibitionId,
  title,
  coverImageUrls,
  products
}) => {
  const hasMoreThreeFormattedProducts = products && products.length > 3;
  const templateId = hasMoreThreeFormattedProducts ? KAKAO_TEMPLATE_ID.EXHIBITION : KAKAO_TEMPLATE_ID.NO_PRODUCT_EXHIBITION;
  if (hasMoreThreeFormattedProducts) {
    return {
      templateId,
      templateArgs: {
        exhibitionId,
        title,
        coverImgUrl: coverImageUrls[0],
        product0ImgUrl: products[0]?.originalImageUrl,
        product0Name: products[0]?.name,
        product0Id: products[0]?.id,
        product0CostInfo: products[0]?.sellingPrice,
        product1ImgUrl: products[1]?.originalImageUrl,
        product1Name: products[1]?.name,
        product1Id: products[1]?.id,
        product1CostInfo: products[1]?.sellingPrice,
        product2ImgUrl: products[2]?.originalImageUrl,
        product2Name: products[2]?.name,
        product2Id: products[2]?.id,
        product2CostInfo: products[2]?.sellingPrice,
        product3ImgUrl: products[3]?.originalImageUrl,
        product3Name: products[3]?.name,
        product3Id: products[3]?.id,
        product3CostInfo: products[3]?.sellingPrice
      }
    };
  }
  return {
    templateId,
    templateArgs: {
      exhibitionId,
      title,
      coverImgUrl: coverImageUrls[0]
    }
  };
};

/**
 * 카드 프로모션 중 가장 혜택 좋은 프로모션을 추출합니다. (내부에서만 사용)
 * @param cardPromotions 카드 프로모션 리스트
 * @param sellingPrice 판매가격
 * @returns 가장 혜택 좋은 카드 프로모션
 */
const getBestCardPromotion = (cardPromotions, sellingPrice) => {
  const bestPromotion = (cardPromotions ?? []).reduce((acc, promotion) => {
    const {
      discountType,
      discountRate,
      discountAmount,
      maximumDiscountAmount
    } = promotion;
    let bestPromotion = acc;
    if (!sellingPrice) {
      return promotion;
    }

    // 정률 혜택
    if (discountType === 'FIXED_RATE') {
      const discountAmount = Math.ceil(Number(sellingPrice) * ((discountRate ?? 1) / 100));
      bestPromotion = {
        ...promotion,
        bestPrice: Number(sellingPrice) - Math.min(Number(maximumDiscountAmount) ?? 1, discountAmount)
      };
    }
    if (discountType === 'FIXED_AMOUNT') {
      bestPromotion = {
        ...promotion,
        bestPrice: discountAmount ? Number(sellingPrice) - discountAmount : undefined
      };
    }
    if (acc.bestPrice && bestPromotion.bestPrice) {
      return acc.bestPrice < bestPromotion.bestPrice ? acc : bestPromotion;
    }
    return bestPromotion;
  }, {});
  return bestPromotion;
};

/**
 * 카드 프로모션 타이틀을 추출합니다. (내부에서만 사용)
 * @param cardPromotion 카드 프로모션
 * @returns 정액 / 정률 결제할인
 */
const getCardPromotionTitle = cardPromotion => {
  const {
    discountType,
    discountRate,
    discountAmount
  } = cardPromotion;
  if (discountType === 'FIXED_RATE') {
    return `최대 ${discountRate}% 결제할인`;
  }
  if (discountType === 'FIXED_AMOUNT') {
    return `최대 ${discountAmount}원 결제할인`;
  }
  return undefined;
};

/**
 * 카드 프로모션을 나타낼 badge를 추출합니다.
 * @param cardPromotions 카드 프로모션 리스트
 * @param sellingPrice 판매자
 * @returns 카드 프로모션 badge 리스트
 * @example
 * ```
 * getCardPromotionBadges([
 *   {
 *     cardName: '페이코',
 *     discountType: 'FIXED_RATE',
 *     discountRate: 20,
 *     minimumApplyPrice: '1000',
 *     maximumDiscountAmount: '30000',
 *     promotionPaymentMethod: 'PAYCO',
 *   },
 *   {
 *     cardName: 'KB국민',
 *     discountType: 'FIXED_RATE',
 *     discountRate: 10,
 *     minimumApplyPrice: '10',
 *     maximumDiscountAmount: '10000',
 *     promotionPaymentMethod: 'CREDIT_CARD',
 *   }),
 *   '24500'
 *  )
 * ```
 */
const getCardPromotionBadges = (cardPromotions, sellingPrice) => {
  const cardPromotion = getBestCardPromotion(cardPromotions, sellingPrice);
  const promotionTitle = getCardPromotionTitle(cardPromotion);
  return promotionTitle ? [{
    ozipTitle: '',
    image: 'https://image.ohou.se/i/bucketplace-v2-development/static/productions/card-promotion-v2.png',
    title: promotionTitle,
    discountRatio: cardPromotion.discountRate?.toString(),
    fixedDiscountAmount: cardPromotion.discountAmount?.toString()
  }] : undefined;
};

/**
 * @bucketplace/contents-ui의 Scrap 컴포넌트를 사용하기 위한 헬퍼 함수
 * refs
 *  - https://github.com/bucketplace/contents-web-common/blob/main/packages/ui/src/stories/Scrap/README.stories.mdx
 *  - https://www.notion.so/Scrap-16df6cb18a93435eb513d20b6b32d9f0
 *
 * @param {CreateProductScrapDataProps}
 * @returns {ScrapData}
 */
function createProductScrapData({
  product,
  active,
  count,
  userId,
  scrappedFrom,
  onScrap,
  onUnscrap,
  onCreateScrap,
  onDeleteScrap,
  onCreateCollectionBook,
  onMoveCollectionBookItemList,
  onClickScrapBook,
  onClickScrapBookTo,
  getCollectionBookList,
  redirectToLogin,
  onClickScrap
}) {
  const isLoggedIn = userId != null;
  // contents-ui 옮길 때 ScrapResponse 로 적용
  const handleScrap = async () => {
    const {
      success,
      collectionId,
      collectCount,
      message
    } = await onCreateScrap({
      type: product.type ?? 'Production',
      id: product.id
    });
    if (success) {
      return {
        success: true,
        id: collectionId ?? -1,
        count: collectCount ?? 0
      };
    }
    return {
      success: false,
      message
    };
  };
  // contents-ui 옮길 때 UnscrapResponse 로 적용
  const handleDeleteScrap = async () => {
    const {
      success,
      collectCount,
      message
    } = await onDeleteScrap({
      type: product.type ?? 'Production',
      id: product.id
    });
    if (success) {
      return {
        success: true,
        count: collectCount ?? 0
      };
    }
    return {
      success: false,
      message
    };
  };
  // contents-ui 옮길 때 CreateScrapBookResponse 로 적용
  const handleCreateScrapBook = async name => {
    const {
      success,
      id
    } = await onCreateCollectionBook({
      name
    });
    return {
      success,
      id
    };
  };
  const handleSelectScrapBook = async (scrapBookId, contentIds) => {
    // contents-ui 옮길 때 SelectScrapBookResponse 로 적용
    const {
      success
    } = await onMoveCollectionBookItemList({
      collectionBookId: scrapBookId,
      ids: contentIds // FIXME: remove Type assertion
    });
    return {
      success
    };
  };
  const handleGetScrapBookList = async () => {
    const {
      collectionBooks
    } = await getCollectionBookList();
    return collectionBooks ?? [];
  };
  return {
    contentType: product.type ?? 'Production',
    contentId: product.id,
    initialActive: active,
    initialCount: count,
    isLoggedIn,
    scrappedFrom,
    onScrap,
    onUnscrap,
    scrap: handleScrap,
    unscrap: handleDeleteScrap,
    createScrapBook: handleCreateScrapBook,
    selectScrapBook: handleSelectScrapBook,
    getScrapBooks: handleGetScrapBookList,
    onClickScrapBook,
    onClickScrapBookTo,
    redirectToLogin,
    onClickScrap
  };
}

/**
 * ThumbnailBadge를 Badge 타입으로 반환합니다.
 * @param thumbnailBadges 썸네일 뱃지
 * @returns 뱃지
 * @example
 * ```
 * convertThumbnailBadgeToBadge([{
 *  position: 2,
 *  imageUrl: 'https://bucketplace-v2-development.s3.amazonaws.com/uploads/admins/thumbnail_badges/162817329513046453.png',
 * }])
 * ```
 */
function convertThumbnailBadgeToBadge(thumbnailBadges) {
  return thumbnailBadges?.map(badge => ({
    id: Math.random() * 0x4FFFF | 0,
    thumbnailBadgeId: 0,
    position: badge.position,
    image: {
      url: badge.imageUrl,
      width: null,
      height: null
    }
  })) ?? [];
}

/**
 * convertGoodsToProduct, convertDealToProduct에서 default로 넣는 deprecated fields
 */
const DEPRECATED_FIELDS = {
  usedCardCount: 0,
  viewCount: 0,
  isDepartureTodayExp: 'A',
  isDiscounted: false,
  isRetailDelivery: false,
  isThirdPartyLogistic: false,
  status: 0,
  deliveryType: 0,
  userId: 0,
  isHidden: false,
  isDeliveryDateSpecified: false,
  isBuyable: true,
  isConsultable: false,
  isRemodel: false,
  weekRank: 0
};

/**
 * 상품 아이템을 Product 형태로 전환하는 함수
 * @param goods 상품 아이템
 * @param isScrap 스크랩 유무
 * @returns 상품
 */
const convertGoodsToProduct = ({
  goods,
  showCouponBadge,
  isLoggedIn
}) => {
  const goodsCouponMold = getCouponBadge(goods?.price?.sellingPrice ?? '0', goods?.additionalProperties?.goodsCouponMold ?? []);
  const isDepartureToday = goods?.additionalProperties?.departureToday?.[0]?.status === 'ENABLED';
  const deadline = goods?.delivery?.policy?.releasePolicy?.orderDeadline ?? '';
  return {
    ...DEPRECATED_FIELDS,
    type: 'Production',
    id: Number.parseInt(goods?.id ?? '0', 10),
    name: goods?.name ?? '',
    reviewAvg: goods?.reviewStatistic?.reviewAverage ?? 0,
    reviewCount: goods?.reviewStatistic?.reviewCount ?? 0,
    sellingPrice: Number.parseInt(goods?.price?.sellingPrice ?? '0', 10),
    originalPrice: Number.parseInt(goods?.price?.originalPrice ?? '0', 10),
    originalImageUrl: goods?.imageUrl ?? '',
    brand: goods?.brand ?? {
      id: 0,
      name: ''
    },
    badges: convertThumbnailBadgeToBadge(goods?.additionalProperties?.thumbnailBadges),
    deliveryStartAt: isDepartureToday && deadline ? {
      template: {
        text: '평일 %s까지 결제시',
        values: [deadline]
      }
    } : undefined,
    deliveryServiceCode: goods?.delivery?.serviceCode ?? 'NONE',
    isDepartureToday,
    isSpecialPrice: goods?.price?.isSpecialPrice ?? false,
    isSelling: goods?.isSelling ?? true,
    isSoldOut: goods?.isSoldOut ?? false,
    isDiscontinued: goods?.isDiscontinued ?? false,
    isFreeDelivery: goods?.delivery?.isFree ?? false,
    isOverseasPurchase: goods?.isOverseasPurchase ?? false,
    couponBadge: goodsCouponMold && showCouponBadge ? {
      title: getCouponBadgeTitle(goodsCouponMold, isLoggedIn ?? false),
      image: 'https://image.ohou.se/i/bucketplace-v2-development/static/productions/goods-coupon-badge.png',
      discountRatio: goodsCouponMold.discountRate ? goodsCouponMold.discountRate.toString() : '',
      fixedDiscountAmount: goodsCouponMold.discountAmount
    } : undefined,
    benefitBadges: getCardPromotionBadges(goods?.additionalProperties?.cardPromotions, goods?.price?.sellingPrice),
    isScrap: goods?.isScrap ?? false,
    scrapCount: goods?.scrapCount ?? 0,
    price: goods?.price
  };
};

/**
 * 모음전 아이템을 Product 형태로 전환하는 함수
 * @param deal 모음전 아이템
 * @param isScrap 스크랩 유무
 * @returns 상품
 */
const convertDealToProduct = deal => {
  return {
    ...DEPRECATED_FIELDS,
    type: 'Deal',
    id: Number.parseInt(deal?.id ?? '0', 10),
    name: deal?.name ?? '',
    reviewAvg: deal?.reviewStatistic?.reviewAverage ?? 0,
    reviewCount: deal?.reviewStatistic?.reviewCount ?? 0,
    sellingPrice: Number.parseInt(deal?.price?.representativeSellingPrice ?? '0', 10),
    originalPrice: Number.parseInt(deal?.price?.representativeOriginalPrice ?? '0', 10),
    originalImageUrl: deal?.imageUrl ?? '',
    brand: deal?.brand ?? {
      id: 0,
      name: ''
    },
    badges: convertThumbnailBadgeToBadge(deal?.additionalProperties?.thumbnailBadges),
    deliveryStartAt: undefined,
    deliveryServiceCode: DELIVERY_SERVICE_CODE.NONE,
    isDepartureToday: deal?.additionalProperties?.departureToday?.[0]?.status === 'ENABLED',
    isSpecialPrice: deal?.price?.isSpecialPrice ?? false,
    isSelling: deal?.isSelling ?? true,
    isSoldOut: deal?.isSoldOut ?? false,
    isDiscontinued: false,
    isFreeDelivery: deal?.isFreeDelivery ?? false,
    isOverseasPurchase: deal?.isOverseasPurchase ?? false,
    benefitBadges: getCardPromotionBadges(deal?.additionalProperties?.cardPromotions, deal?.price?.representativeSellingPrice),
    isScrap: deal?.isScrap ?? false,
    scrapCount: deal?.scrapCount ?? 0
  };
};

/**
 * Goods, Deal 둘중 하나의 형태를 지닌 StoreItem을 Product로 변환하는 함수
 * @param storeItem goods 또는 deal을 포함한 storeItem
 * @param showCouponBadge 쿠폰뱃지 노출 여부, 해당값이 true여야 쿠폰뱃지를 보여줌
 * @param isLoggedIn 로그인 여부, 로그인 상태가 아니면 상품쿠폰 뱃지의 타이틀을 할인쿠폰으로 보여줌
 * @returns 상품 Product
 * @example
 * ```
 * convertStoreItemToProduct({
 *   storeItem,
 *   showCouponBadge: true,
 *   isLoggedIn,
 * });
 * ```
 */
const convertStoreItemToProduct = ({
  storeItem,
  showCouponBadge = false,
  isLoggedIn = false
}) => {
  return storeItem.type === 'Goods' ? convertGoodsToProduct({
    goods: storeItem.goods,
    showCouponBadge,
    isLoggedIn
  }) : convertDealToProduct(storeItem.deal);
};

/**
 * store-mobile-bff 의 GoodsSummary 타입을
 * ProductCard 에서 사용하는 Product 타입으로 변환해주는 함수
 */
function convertGoodsSummaryToProduct({
  goodsSummary,
  type
}) {
  return {
    type,
    id: Number.parseInt(goodsSummary.id, 10),
    name: goodsSummary.name ?? '',
    reviewAvg: goodsSummary.reviewStatistic?.reviewAverage ?? 0,
    reviewCount: goodsSummary.reviewStatistic?.reviewCount ?? 0,
    sellingPrice: type === 'Deal' ? Number.parseInt(goodsSummary.price?.representativeSellingPrice ?? '0', 10) : Number.parseInt(goodsSummary.price?.sellingPrice ?? '0', 10),
    originalPrice: type === 'Deal' ? Number.parseInt(goodsSummary.price?.representativeOriginalPrice ?? '0', 10) : Number.parseInt(goodsSummary.price?.originalPrice ?? '0', 10),
    originalImageUrl: goodsSummary.imageUrl ?? '',
    brand: {
      id: Number.parseInt(goodsSummary.brand?.id ?? '0', 10),
      name: goodsSummary.brand?.name ?? ''
    },
    badges: goodsSummary.badgeProperties?.thumbnailBadges?.map(thumbnailBadge => ({
      id: 0,
      thumbnailBadgeId: 0,
      position: thumbnailBadge.position,
      image: {
        url: thumbnailBadge.imageUrl ?? '',
        width: null,
        height: null
      }
    })),
    benefitBadges: goodsSummary.badgeProperties?.cardPromotion != null ? [{
      image: goodsSummary.badgeProperties.cardPromotion.imageUrl,
      title: goodsSummary.badgeProperties.cardPromotion.displayText,
      ozipTitle: '',
      discountRatio: goodsSummary.badgeProperties.cardPromotion.discountRatio,
      fixedDiscountAmount: goodsSummary.badgeProperties.cardPromotion.fixedDiscountAmount
    }] : undefined,
    couponBadge: goodsSummary.badgeProperties?.couponBadge?.imageUrl != null && goodsSummary.badgeProperties?.couponBadge?.displayText != null ? {
      image: goodsSummary.badgeProperties.couponBadge.imageUrl,
      title: goodsSummary.badgeProperties?.couponBadge.displayText
    } : undefined,
    deliveryStartAt: goodsSummary.badgeProperties?.departureToday ? {
      template: {
        text: '평일 %s까지 결제시',
        values: [goodsSummary.badgeProperties.departureToday.orderDeadline]
      }
    } : undefined,
    deliveryServiceCode: goodsSummary.badgeProperties?.deliveryServiceCode ?? 'NONE',
    scrapCount: goodsSummary.scrapInfo?.scrapCount ?? 0,
    isSpecialPrice: goodsSummary.badgeProperties?.isSpecialPrice ?? false,
    isSelling: goodsSummary.badgeProperties?.isSelling ?? true,
    isSoldOut: goodsSummary.isSoldOut ?? false,
    isScrap: goodsSummary.scrapInfo?.isScrap ?? false,
    isFreeDelivery: goodsSummary.badgeProperties?.isFreeDelivery ?? false,
    isDiscontinued: goodsSummary.badgeProperties?.isDiscontinued ?? false,
    isOverseasPurchase: goodsSummary.badgeProperties?.isOverseasPurchase ?? false,
    isDepartureToday: goodsSummary.badgeProperties?.departureToday !== undefined,
    ...DEPRECATED_FIELDS
  };
}

function _typeof$1(o) {
  "@babel/helpers - typeof";

  return _typeof$1 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof$1(o);
}

function toInteger(dirtyNumber) {
  if (dirtyNumber === null || dirtyNumber === true || dirtyNumber === false) {
    return NaN;
  }
  var number = Number(dirtyNumber);
  if (isNaN(number)) {
    return number;
  }
  return number < 0 ? Math.ceil(number) : Math.floor(number);
}

function requiredArgs(required, args) {
  if (args.length < required) {
    throw new TypeError(required + ' argument' + (required > 1 ? 's' : '') + ' required, but only ' + args.length + ' present');
  }
}

/**
 * @name toDate
 * @category Common Helpers
 * @summary Convert the given argument to an instance of Date.
 *
 * @description
 * Convert the given argument to an instance of Date.
 *
 * If the argument is an instance of Date, the function returns its clone.
 *
 * If the argument is a number, it is treated as a timestamp.
 *
 * If the argument is none of the above, the function returns Invalid Date.
 *
 * **Note**: *all* Date arguments passed to any *date-fns* function is processed by `toDate`.
 *
 * @param {Date|Number} argument - the value to convert
 * @returns {Date} the parsed date in the local time zone
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Clone the date:
 * const result = toDate(new Date(2014, 1, 11, 11, 30, 30))
 * //=> Tue Feb 11 2014 11:30:30
 *
 * @example
 * // Convert the timestamp to date:
 * const result = toDate(1392098430000)
 * //=> Tue Feb 11 2014 11:30:30
 */
function toDate(argument) {
  requiredArgs(1, arguments);
  var argStr = Object.prototype.toString.call(argument);

  // Clone the date
  if (argument instanceof Date || _typeof$1(argument) === 'object' && argStr === '[object Date]') {
    // Prevent the date to lose the milliseconds when passed to new Date() in IE10
    return new Date(argument.getTime());
  } else if (typeof argument === 'number' || argStr === '[object Number]') {
    return new Date(argument);
  } else {
    if ((typeof argument === 'string' || argStr === '[object String]') && typeof console !== 'undefined') {
      // eslint-disable-next-line no-console
      console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#string-arguments");
      // eslint-disable-next-line no-console
      console.warn(new Error().stack);
    }
    return new Date(NaN);
  }
}

/**
 * @name addMilliseconds
 * @category Millisecond Helpers
 * @summary Add the specified number of milliseconds to the given date.
 *
 * @description
 * Add the specified number of milliseconds to the given date.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of milliseconds to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the milliseconds added
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Add 750 milliseconds to 10 July 2014 12:45:30.000:
 * const result = addMilliseconds(new Date(2014, 6, 10, 12, 45, 30, 0), 750)
 * //=> Thu Jul 10 2014 12:45:30.750
 */
function addMilliseconds(dirtyDate, dirtyAmount) {
  requiredArgs(2, arguments);
  var timestamp = toDate(dirtyDate).getTime();
  var amount = toInteger(dirtyAmount);
  return new Date(timestamp + amount);
}

var defaultOptions = {};
function getDefaultOptions() {
  return defaultOptions;
}

/**
 * Google Chrome as of 67.0.3396.87 introduced timezones with offset that includes seconds.
 * They usually appear for dates that denote time before the timezones were introduced
 * (e.g. for 'Europe/Prague' timezone the offset is GMT+00:57:44 before 1 October 1891
 * and GMT+01:00:00 after that date)
 *
 * Date#getTimezoneOffset returns the offset in minutes and would return 57 for the example above,
 * which would lead to incorrect calculations.
 *
 * This function returns the timezone offset in milliseconds that takes seconds in account.
 */
function getTimezoneOffsetInMilliseconds(date) {
  var utcDate = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds()));
  utcDate.setUTCFullYear(date.getFullYear());
  return date.getTime() - utcDate.getTime();
}

/**
 * @name startOfDay
 * @category Day Helpers
 * @summary Return the start of a day for the given date.
 *
 * @description
 * Return the start of a day for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|Number} date - the original date
 * @returns {Date} the start of a day
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // The start of a day for 2 September 2014 11:55:00:
 * const result = startOfDay(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Tue Sep 02 2014 00:00:00
 */
function startOfDay(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  date.setHours(0, 0, 0, 0);
  return date;
}

var MILLISECONDS_IN_DAY$1 = 86400000;

/**
 * @name differenceInCalendarDays
 * @category Day Helpers
 * @summary Get the number of calendar days between the given dates.
 *
 * @description
 * Get the number of calendar days between the given dates. This means that the times are removed
 * from the dates and then the difference in days is calculated.
 *
 * @param {Date|Number} dateLeft - the later date
 * @param {Date|Number} dateRight - the earlier date
 * @returns {Number} the number of calendar days
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // How many calendar days are between
 * // 2 July 2011 23:00:00 and 2 July 2012 00:00:00?
 * const result = differenceInCalendarDays(
 *   new Date(2012, 6, 2, 0, 0),
 *   new Date(2011, 6, 2, 23, 0)
 * )
 * //=> 366
 * // How many calendar days are between
 * // 2 July 2011 23:59:00 and 3 July 2011 00:01:00?
 * const result = differenceInCalendarDays(
 *   new Date(2011, 6, 3, 0, 1),
 *   new Date(2011, 6, 2, 23, 59)
 * )
 * //=> 1
 */
function differenceInCalendarDays(dirtyDateLeft, dirtyDateRight) {
  requiredArgs(2, arguments);
  var startOfDayLeft = startOfDay(dirtyDateLeft);
  var startOfDayRight = startOfDay(dirtyDateRight);
  var timestampLeft = startOfDayLeft.getTime() - getTimezoneOffsetInMilliseconds(startOfDayLeft);
  var timestampRight = startOfDayRight.getTime() - getTimezoneOffsetInMilliseconds(startOfDayRight);

  // Round the number of days to the nearest integer
  // because the number of milliseconds in a day is not constant
  // (e.g. it's different in the day of the daylight saving time clock shift)
  return Math.round((timestampLeft - timestampRight) / MILLISECONDS_IN_DAY$1);
}

/**
 * Days in 1 week.
 *
 * @name daysInWeek
 * @constant
 * @type {number}
 * @default
 */

/**
 * Milliseconds in 1 minute
 *
 * @name millisecondsInMinute
 * @constant
 * @type {number}
 * @default
 */
var millisecondsInMinute = 60000;

/**
 * Milliseconds in 1 hour
 *
 * @name millisecondsInHour
 * @constant
 * @type {number}
 * @default
 */
var millisecondsInHour = 3600000;

/**
 * @name isDate
 * @category Common Helpers
 * @summary Is the given value a date?
 *
 * @description
 * Returns true if the given value is an instance of Date. The function works for dates transferred across iframes.
 *
 * @param {*} value - the value to check
 * @returns {boolean} true if the given value is a date
 * @throws {TypeError} 1 arguments required
 *
 * @example
 * // For a valid date:
 * const result = isDate(new Date())
 * //=> true
 *
 * @example
 * // For an invalid date:
 * const result = isDate(new Date(NaN))
 * //=> true
 *
 * @example
 * // For some value:
 * const result = isDate('2014-02-31')
 * //=> false
 *
 * @example
 * // For an object:
 * const result = isDate({})
 * //=> false
 */
function isDate(value) {
  requiredArgs(1, arguments);
  return value instanceof Date || _typeof$1(value) === 'object' && Object.prototype.toString.call(value) === '[object Date]';
}

/**
 * @name isValid
 * @category Common Helpers
 * @summary Is the given date valid?
 *
 * @description
 * Returns false if argument is Invalid Date and true otherwise.
 * Argument is converted to Date using `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
 * Invalid Date is a Date, whose time value is NaN.
 *
 * Time value of Date: http://es5.github.io/#x15.9.1.1
 *
 * @param {*} date - the date to check
 * @returns {Boolean} the date is valid
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // For the valid date:
 * const result = isValid(new Date(2014, 1, 31))
 * //=> true
 *
 * @example
 * // For the value, convertable into a date:
 * const result = isValid(1393804800000)
 * //=> true
 *
 * @example
 * // For the invalid date:
 * const result = isValid(new Date(''))
 * //=> false
 */
function isValid$1(dirtyDate) {
  requiredArgs(1, arguments);
  if (!isDate(dirtyDate) && typeof dirtyDate !== 'number') {
    return false;
  }
  var date = toDate(dirtyDate);
  return !isNaN(Number(date));
}

/**
 * @name subMilliseconds
 * @category Millisecond Helpers
 * @summary Subtract the specified number of milliseconds from the given date.
 *
 * @description
 * Subtract the specified number of milliseconds from the given date.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of milliseconds to be subtracted. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the milliseconds subtracted
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Subtract 750 milliseconds from 10 July 2014 12:45:30.000:
 * const result = subMilliseconds(new Date(2014, 6, 10, 12, 45, 30, 0), 750)
 * //=> Thu Jul 10 2014 12:45:29.250
 */
function subMilliseconds(dirtyDate, dirtyAmount) {
  requiredArgs(2, arguments);
  var amount = toInteger(dirtyAmount);
  return addMilliseconds(dirtyDate, -amount);
}

var MILLISECONDS_IN_DAY = 86400000;
function getUTCDayOfYear(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var timestamp = date.getTime();
  date.setUTCMonth(0, 1);
  date.setUTCHours(0, 0, 0, 0);
  var startOfYearTimestamp = date.getTime();
  var difference = timestamp - startOfYearTimestamp;
  return Math.floor(difference / MILLISECONDS_IN_DAY) + 1;
}

function startOfUTCISOWeek(dirtyDate) {
  requiredArgs(1, arguments);
  var weekStartsOn = 1;
  var date = toDate(dirtyDate);
  var day = date.getUTCDay();
  var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
  date.setUTCDate(date.getUTCDate() - diff);
  date.setUTCHours(0, 0, 0, 0);
  return date;
}

function getUTCISOWeekYear(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var year = date.getUTCFullYear();
  var fourthOfJanuaryOfNextYear = new Date(0);
  fourthOfJanuaryOfNextYear.setUTCFullYear(year + 1, 0, 4);
  fourthOfJanuaryOfNextYear.setUTCHours(0, 0, 0, 0);
  var startOfNextYear = startOfUTCISOWeek(fourthOfJanuaryOfNextYear);
  var fourthOfJanuaryOfThisYear = new Date(0);
  fourthOfJanuaryOfThisYear.setUTCFullYear(year, 0, 4);
  fourthOfJanuaryOfThisYear.setUTCHours(0, 0, 0, 0);
  var startOfThisYear = startOfUTCISOWeek(fourthOfJanuaryOfThisYear);
  if (date.getTime() >= startOfNextYear.getTime()) {
    return year + 1;
  } else if (date.getTime() >= startOfThisYear.getTime()) {
    return year;
  } else {
    return year - 1;
  }
}

function startOfUTCISOWeekYear(dirtyDate) {
  requiredArgs(1, arguments);
  var year = getUTCISOWeekYear(dirtyDate);
  var fourthOfJanuary = new Date(0);
  fourthOfJanuary.setUTCFullYear(year, 0, 4);
  fourthOfJanuary.setUTCHours(0, 0, 0, 0);
  var date = startOfUTCISOWeek(fourthOfJanuary);
  return date;
}

var MILLISECONDS_IN_WEEK$1 = 604800000;
function getUTCISOWeek(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var diff = startOfUTCISOWeek(date).getTime() - startOfUTCISOWeekYear(date).getTime();

  // Round the number of days to the nearest integer
  // because the number of milliseconds in a week is not constant
  // (e.g. it's different in the week of the daylight saving time clock shift)
  return Math.round(diff / MILLISECONDS_IN_WEEK$1) + 1;
}

function startOfUTCWeek(dirtyDate, options) {
  var _ref, _ref2, _ref3, _options$weekStartsOn, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
  requiredArgs(1, arguments);
  var defaultOptions = getDefaultOptions();
  var weekStartsOn = toInteger((_ref = (_ref2 = (_ref3 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref !== void 0 ? _ref : 0);

  // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
  }
  var date = toDate(dirtyDate);
  var day = date.getUTCDay();
  var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
  date.setUTCDate(date.getUTCDate() - diff);
  date.setUTCHours(0, 0, 0, 0);
  return date;
}

function getUTCWeekYear(dirtyDate, options) {
  var _ref, _ref2, _ref3, _options$firstWeekCon, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var year = date.getUTCFullYear();
  var defaultOptions = getDefaultOptions();
  var firstWeekContainsDate = toInteger((_ref = (_ref2 = (_ref3 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref !== void 0 ? _ref : 1);

  // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
  if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) {
    throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
  }
  var firstWeekOfNextYear = new Date(0);
  firstWeekOfNextYear.setUTCFullYear(year + 1, 0, firstWeekContainsDate);
  firstWeekOfNextYear.setUTCHours(0, 0, 0, 0);
  var startOfNextYear = startOfUTCWeek(firstWeekOfNextYear, options);
  var firstWeekOfThisYear = new Date(0);
  firstWeekOfThisYear.setUTCFullYear(year, 0, firstWeekContainsDate);
  firstWeekOfThisYear.setUTCHours(0, 0, 0, 0);
  var startOfThisYear = startOfUTCWeek(firstWeekOfThisYear, options);
  if (date.getTime() >= startOfNextYear.getTime()) {
    return year + 1;
  } else if (date.getTime() >= startOfThisYear.getTime()) {
    return year;
  } else {
    return year - 1;
  }
}

function startOfUTCWeekYear(dirtyDate, options) {
  var _ref, _ref2, _ref3, _options$firstWeekCon, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
  requiredArgs(1, arguments);
  var defaultOptions = getDefaultOptions();
  var firstWeekContainsDate = toInteger((_ref = (_ref2 = (_ref3 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref !== void 0 ? _ref : 1);
  var year = getUTCWeekYear(dirtyDate, options);
  var firstWeek = new Date(0);
  firstWeek.setUTCFullYear(year, 0, firstWeekContainsDate);
  firstWeek.setUTCHours(0, 0, 0, 0);
  var date = startOfUTCWeek(firstWeek, options);
  return date;
}

var MILLISECONDS_IN_WEEK = 604800000;
function getUTCWeek(dirtyDate, options) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var diff = startOfUTCWeek(date, options).getTime() - startOfUTCWeekYear(date, options).getTime();

  // Round the number of days to the nearest integer
  // because the number of milliseconds in a week is not constant
  // (e.g. it's different in the week of the daylight saving time clock shift)
  return Math.round(diff / MILLISECONDS_IN_WEEK) + 1;
}

function addLeadingZeros(number, targetLength) {
  var sign = number < 0 ? '-' : '';
  var output = Math.abs(number).toString();
  while (output.length < targetLength) {
    output = '0' + output;
  }
  return sign + output;
}

/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* |                                |
 * |  d  | Day of month                   |  D  |                                |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  m  | Minute                         |  M  | Month                          |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  y  | Year (abs)                     |  Y  |                                |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 */
var formatters$2 = {
  // Year
  y: function y(date, token) {
    // From http://www.unicode.org/reports/tr35/tr35-31/tr35-dates.html#Date_Format_tokens
    // | Year     |     y | yy |   yyy |  yyyy | yyyyy |
    // |----------|-------|----|-------|-------|-------|
    // | AD 1     |     1 | 01 |   001 |  0001 | 00001 |
    // | AD 12    |    12 | 12 |   012 |  0012 | 00012 |
    // | AD 123   |   123 | 23 |   123 |  0123 | 00123 |
    // | AD 1234  |  1234 | 34 |  1234 |  1234 | 01234 |
    // | AD 12345 | 12345 | 45 | 12345 | 12345 | 12345 |

    var signedYear = date.getUTCFullYear();
    // Returns 1 for 1 BC (which is year 0 in JavaScript)
    var year = signedYear > 0 ? signedYear : 1 - signedYear;
    return addLeadingZeros(token === 'yy' ? year % 100 : year, token.length);
  },
  // Month
  M: function M(date, token) {
    var month = date.getUTCMonth();
    return token === 'M' ? String(month + 1) : addLeadingZeros(month + 1, 2);
  },
  // Day of the month
  d: function d(date, token) {
    return addLeadingZeros(date.getUTCDate(), token.length);
  },
  // AM or PM
  a: function a(date, token) {
    var dayPeriodEnumValue = date.getUTCHours() / 12 >= 1 ? 'pm' : 'am';
    switch (token) {
      case 'a':
      case 'aa':
        return dayPeriodEnumValue.toUpperCase();
      case 'aaa':
        return dayPeriodEnumValue;
      case 'aaaaa':
        return dayPeriodEnumValue[0];
      case 'aaaa':
      default:
        return dayPeriodEnumValue === 'am' ? 'a.m.' : 'p.m.';
    }
  },
  // Hour [1-12]
  h: function h(date, token) {
    return addLeadingZeros(date.getUTCHours() % 12 || 12, token.length);
  },
  // Hour [0-23]
  H: function H(date, token) {
    return addLeadingZeros(date.getUTCHours(), token.length);
  },
  // Minute
  m: function m(date, token) {
    return addLeadingZeros(date.getUTCMinutes(), token.length);
  },
  // Second
  s: function s(date, token) {
    return addLeadingZeros(date.getUTCSeconds(), token.length);
  },
  // Fraction of second
  S: function S(date, token) {
    var numberOfDigits = token.length;
    var milliseconds = date.getUTCMilliseconds();
    var fractionalSeconds = Math.floor(milliseconds * Math.pow(10, numberOfDigits - 3));
    return addLeadingZeros(fractionalSeconds, token.length);
  }
};
var formatters$3 = formatters$2;

var dayPeriodEnum = {
  am: 'am',
  pm: 'pm',
  midnight: 'midnight',
  noon: 'noon',
  morning: 'morning',
  afternoon: 'afternoon',
  evening: 'evening',
  night: 'night'
};
/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* | Milliseconds in day            |
 * |  b  | AM, PM, noon, midnight         |  B  | Flexible day period            |
 * |  c  | Stand-alone local day of week  |  C* | Localized hour w/ day period   |
 * |  d  | Day of month                   |  D  | Day of year                    |
 * |  e  | Local day of week              |  E  | Day of week                    |
 * |  f  |                                |  F* | Day of week in month           |
 * |  g* | Modified Julian day            |  G  | Era                            |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  i! | ISO day of week                |  I! | ISO week of year               |
 * |  j* | Localized hour w/ day period   |  J* | Localized hour w/o day period  |
 * |  k  | Hour [1-24]                    |  K  | Hour [0-11]                    |
 * |  l* | (deprecated)                   |  L  | Stand-alone month              |
 * |  m  | Minute                         |  M  | Month                          |
 * |  n  |                                |  N  |                                |
 * |  o! | Ordinal number modifier        |  O  | Timezone (GMT)                 |
 * |  p! | Long localized time            |  P! | Long localized date            |
 * |  q  | Stand-alone quarter            |  Q  | Quarter                        |
 * |  r* | Related Gregorian year         |  R! | ISO week-numbering year        |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  t! | Seconds timestamp              |  T! | Milliseconds timestamp         |
 * |  u  | Extended year                  |  U* | Cyclic year                    |
 * |  v* | Timezone (generic non-locat.)  |  V* | Timezone (location)            |
 * |  w  | Local week of year             |  W* | Week of month                  |
 * |  x  | Timezone (ISO-8601 w/o Z)      |  X  | Timezone (ISO-8601)            |
 * |  y  | Year (abs)                     |  Y  | Local week-numbering year      |
 * |  z  | Timezone (specific non-locat.) |  Z* | Timezone (aliases)             |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 *
 * Letters marked by ! are non-standard, but implemented by date-fns:
 * - `o` modifies the previous token to turn it into an ordinal (see `format` docs)
 * - `i` is ISO day of week. For `i` and `ii` is returns numeric ISO week days,
 *   i.e. 7 for Sunday, 1 for Monday, etc.
 * - `I` is ISO week of year, as opposed to `w` which is local week of year.
 * - `R` is ISO week-numbering year, as opposed to `Y` which is local week-numbering year.
 *   `R` is supposed to be used in conjunction with `I` and `i`
 *   for universal ISO week-numbering date, whereas
 *   `Y` is supposed to be used in conjunction with `w` and `e`
 *   for week-numbering date specific to the locale.
 * - `P` is long localized date format
 * - `p` is long localized time format
 */

var formatters = {
  // Era
  G: function G(date, token, localize) {
    var era = date.getUTCFullYear() > 0 ? 1 : 0;
    switch (token) {
      // AD, BC
      case 'G':
      case 'GG':
      case 'GGG':
        return localize.era(era, {
          width: 'abbreviated'
        });
      // A, B
      case 'GGGGG':
        return localize.era(era, {
          width: 'narrow'
        });
      // Anno Domini, Before Christ
      case 'GGGG':
      default:
        return localize.era(era, {
          width: 'wide'
        });
    }
  },
  // Year
  y: function y(date, token, localize) {
    // Ordinal number
    if (token === 'yo') {
      var signedYear = date.getUTCFullYear();
      // Returns 1 for 1 BC (which is year 0 in JavaScript)
      var year = signedYear > 0 ? signedYear : 1 - signedYear;
      return localize.ordinalNumber(year, {
        unit: 'year'
      });
    }
    return formatters$3.y(date, token);
  },
  // Local week-numbering year
  Y: function Y(date, token, localize, options) {
    var signedWeekYear = getUTCWeekYear(date, options);
    // Returns 1 for 1 BC (which is year 0 in JavaScript)
    var weekYear = signedWeekYear > 0 ? signedWeekYear : 1 - signedWeekYear;

    // Two digit year
    if (token === 'YY') {
      var twoDigitYear = weekYear % 100;
      return addLeadingZeros(twoDigitYear, 2);
    }

    // Ordinal number
    if (token === 'Yo') {
      return localize.ordinalNumber(weekYear, {
        unit: 'year'
      });
    }

    // Padding
    return addLeadingZeros(weekYear, token.length);
  },
  // ISO week-numbering year
  R: function R(date, token) {
    var isoWeekYear = getUTCISOWeekYear(date);

    // Padding
    return addLeadingZeros(isoWeekYear, token.length);
  },
  // Extended year. This is a single number designating the year of this calendar system.
  // The main difference between `y` and `u` localizers are B.C. years:
  // | Year | `y` | `u` |
  // |------|-----|-----|
  // | AC 1 |   1 |   1 |
  // | BC 1 |   1 |   0 |
  // | BC 2 |   2 |  -1 |
  // Also `yy` always returns the last two digits of a year,
  // while `uu` pads single digit years to 2 characters and returns other years unchanged.
  u: function u(date, token) {
    var year = date.getUTCFullYear();
    return addLeadingZeros(year, token.length);
  },
  // Quarter
  Q: function Q(date, token, localize) {
    var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);
    switch (token) {
      // 1, 2, 3, 4
      case 'Q':
        return String(quarter);
      // 01, 02, 03, 04
      case 'QQ':
        return addLeadingZeros(quarter, 2);
      // 1st, 2nd, 3rd, 4th
      case 'Qo':
        return localize.ordinalNumber(quarter, {
          unit: 'quarter'
        });
      // Q1, Q2, Q3, Q4
      case 'QQQ':
        return localize.quarter(quarter, {
          width: 'abbreviated',
          context: 'formatting'
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)
      case 'QQQQQ':
        return localize.quarter(quarter, {
          width: 'narrow',
          context: 'formatting'
        });
      // 1st quarter, 2nd quarter, ...
      case 'QQQQ':
      default:
        return localize.quarter(quarter, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // Stand-alone quarter
  q: function q(date, token, localize) {
    var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);
    switch (token) {
      // 1, 2, 3, 4
      case 'q':
        return String(quarter);
      // 01, 02, 03, 04
      case 'qq':
        return addLeadingZeros(quarter, 2);
      // 1st, 2nd, 3rd, 4th
      case 'qo':
        return localize.ordinalNumber(quarter, {
          unit: 'quarter'
        });
      // Q1, Q2, Q3, Q4
      case 'qqq':
        return localize.quarter(quarter, {
          width: 'abbreviated',
          context: 'standalone'
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)
      case 'qqqqq':
        return localize.quarter(quarter, {
          width: 'narrow',
          context: 'standalone'
        });
      // 1st quarter, 2nd quarter, ...
      case 'qqqq':
      default:
        return localize.quarter(quarter, {
          width: 'wide',
          context: 'standalone'
        });
    }
  },
  // Month
  M: function M(date, token, localize) {
    var month = date.getUTCMonth();
    switch (token) {
      case 'M':
      case 'MM':
        return formatters$3.M(date, token);
      // 1st, 2nd, ..., 12th
      case 'Mo':
        return localize.ordinalNumber(month + 1, {
          unit: 'month'
        });
      // Jan, Feb, ..., Dec
      case 'MMM':
        return localize.month(month, {
          width: 'abbreviated',
          context: 'formatting'
        });
      // J, F, ..., D
      case 'MMMMM':
        return localize.month(month, {
          width: 'narrow',
          context: 'formatting'
        });
      // January, February, ..., December
      case 'MMMM':
      default:
        return localize.month(month, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // Stand-alone month
  L: function L(date, token, localize) {
    var month = date.getUTCMonth();
    switch (token) {
      // 1, 2, ..., 12
      case 'L':
        return String(month + 1);
      // 01, 02, ..., 12
      case 'LL':
        return addLeadingZeros(month + 1, 2);
      // 1st, 2nd, ..., 12th
      case 'Lo':
        return localize.ordinalNumber(month + 1, {
          unit: 'month'
        });
      // Jan, Feb, ..., Dec
      case 'LLL':
        return localize.month(month, {
          width: 'abbreviated',
          context: 'standalone'
        });
      // J, F, ..., D
      case 'LLLLL':
        return localize.month(month, {
          width: 'narrow',
          context: 'standalone'
        });
      // January, February, ..., December
      case 'LLLL':
      default:
        return localize.month(month, {
          width: 'wide',
          context: 'standalone'
        });
    }
  },
  // Local week of year
  w: function w(date, token, localize, options) {
    var week = getUTCWeek(date, options);
    if (token === 'wo') {
      return localize.ordinalNumber(week, {
        unit: 'week'
      });
    }
    return addLeadingZeros(week, token.length);
  },
  // ISO week of year
  I: function I(date, token, localize) {
    var isoWeek = getUTCISOWeek(date);
    if (token === 'Io') {
      return localize.ordinalNumber(isoWeek, {
        unit: 'week'
      });
    }
    return addLeadingZeros(isoWeek, token.length);
  },
  // Day of the month
  d: function d(date, token, localize) {
    if (token === 'do') {
      return localize.ordinalNumber(date.getUTCDate(), {
        unit: 'date'
      });
    }
    return formatters$3.d(date, token);
  },
  // Day of year
  D: function D(date, token, localize) {
    var dayOfYear = getUTCDayOfYear(date);
    if (token === 'Do') {
      return localize.ordinalNumber(dayOfYear, {
        unit: 'dayOfYear'
      });
    }
    return addLeadingZeros(dayOfYear, token.length);
  },
  // Day of week
  E: function E(date, token, localize) {
    var dayOfWeek = date.getUTCDay();
    switch (token) {
      // Tue
      case 'E':
      case 'EE':
      case 'EEE':
        return localize.day(dayOfWeek, {
          width: 'abbreviated',
          context: 'formatting'
        });
      // T
      case 'EEEEE':
        return localize.day(dayOfWeek, {
          width: 'narrow',
          context: 'formatting'
        });
      // Tu
      case 'EEEEEE':
        return localize.day(dayOfWeek, {
          width: 'short',
          context: 'formatting'
        });
      // Tuesday
      case 'EEEE':
      default:
        return localize.day(dayOfWeek, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // Local day of week
  e: function e(date, token, localize, options) {
    var dayOfWeek = date.getUTCDay();
    var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
    switch (token) {
      // Numerical value (Nth day of week with current locale or weekStartsOn)
      case 'e':
        return String(localDayOfWeek);
      // Padded numerical value
      case 'ee':
        return addLeadingZeros(localDayOfWeek, 2);
      // 1st, 2nd, ..., 7th
      case 'eo':
        return localize.ordinalNumber(localDayOfWeek, {
          unit: 'day'
        });
      case 'eee':
        return localize.day(dayOfWeek, {
          width: 'abbreviated',
          context: 'formatting'
        });
      // T
      case 'eeeee':
        return localize.day(dayOfWeek, {
          width: 'narrow',
          context: 'formatting'
        });
      // Tu
      case 'eeeeee':
        return localize.day(dayOfWeek, {
          width: 'short',
          context: 'formatting'
        });
      // Tuesday
      case 'eeee':
      default:
        return localize.day(dayOfWeek, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // Stand-alone local day of week
  c: function c(date, token, localize, options) {
    var dayOfWeek = date.getUTCDay();
    var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
    switch (token) {
      // Numerical value (same as in `e`)
      case 'c':
        return String(localDayOfWeek);
      // Padded numerical value
      case 'cc':
        return addLeadingZeros(localDayOfWeek, token.length);
      // 1st, 2nd, ..., 7th
      case 'co':
        return localize.ordinalNumber(localDayOfWeek, {
          unit: 'day'
        });
      case 'ccc':
        return localize.day(dayOfWeek, {
          width: 'abbreviated',
          context: 'standalone'
        });
      // T
      case 'ccccc':
        return localize.day(dayOfWeek, {
          width: 'narrow',
          context: 'standalone'
        });
      // Tu
      case 'cccccc':
        return localize.day(dayOfWeek, {
          width: 'short',
          context: 'standalone'
        });
      // Tuesday
      case 'cccc':
      default:
        return localize.day(dayOfWeek, {
          width: 'wide',
          context: 'standalone'
        });
    }
  },
  // ISO day of week
  i: function i(date, token, localize) {
    var dayOfWeek = date.getUTCDay();
    var isoDayOfWeek = dayOfWeek === 0 ? 7 : dayOfWeek;
    switch (token) {
      // 2
      case 'i':
        return String(isoDayOfWeek);
      // 02
      case 'ii':
        return addLeadingZeros(isoDayOfWeek, token.length);
      // 2nd
      case 'io':
        return localize.ordinalNumber(isoDayOfWeek, {
          unit: 'day'
        });
      // Tue
      case 'iii':
        return localize.day(dayOfWeek, {
          width: 'abbreviated',
          context: 'formatting'
        });
      // T
      case 'iiiii':
        return localize.day(dayOfWeek, {
          width: 'narrow',
          context: 'formatting'
        });
      // Tu
      case 'iiiiii':
        return localize.day(dayOfWeek, {
          width: 'short',
          context: 'formatting'
        });
      // Tuesday
      case 'iiii':
      default:
        return localize.day(dayOfWeek, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // AM or PM
  a: function a(date, token, localize) {
    var hours = date.getUTCHours();
    var dayPeriodEnumValue = hours / 12 >= 1 ? 'pm' : 'am';
    switch (token) {
      case 'a':
      case 'aa':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'abbreviated',
          context: 'formatting'
        });
      case 'aaa':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'abbreviated',
          context: 'formatting'
        }).toLowerCase();
      case 'aaaaa':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'narrow',
          context: 'formatting'
        });
      case 'aaaa':
      default:
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // AM, PM, midnight, noon
  b: function b(date, token, localize) {
    var hours = date.getUTCHours();
    var dayPeriodEnumValue;
    if (hours === 12) {
      dayPeriodEnumValue = dayPeriodEnum.noon;
    } else if (hours === 0) {
      dayPeriodEnumValue = dayPeriodEnum.midnight;
    } else {
      dayPeriodEnumValue = hours / 12 >= 1 ? 'pm' : 'am';
    }
    switch (token) {
      case 'b':
      case 'bb':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'abbreviated',
          context: 'formatting'
        });
      case 'bbb':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'abbreviated',
          context: 'formatting'
        }).toLowerCase();
      case 'bbbbb':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'narrow',
          context: 'formatting'
        });
      case 'bbbb':
      default:
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // in the morning, in the afternoon, in the evening, at night
  B: function B(date, token, localize) {
    var hours = date.getUTCHours();
    var dayPeriodEnumValue;
    if (hours >= 17) {
      dayPeriodEnumValue = dayPeriodEnum.evening;
    } else if (hours >= 12) {
      dayPeriodEnumValue = dayPeriodEnum.afternoon;
    } else if (hours >= 4) {
      dayPeriodEnumValue = dayPeriodEnum.morning;
    } else {
      dayPeriodEnumValue = dayPeriodEnum.night;
    }
    switch (token) {
      case 'B':
      case 'BB':
      case 'BBB':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'abbreviated',
          context: 'formatting'
        });
      case 'BBBBB':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'narrow',
          context: 'formatting'
        });
      case 'BBBB':
      default:
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // Hour [1-12]
  h: function h(date, token, localize) {
    if (token === 'ho') {
      var hours = date.getUTCHours() % 12;
      if (hours === 0) hours = 12;
      return localize.ordinalNumber(hours, {
        unit: 'hour'
      });
    }
    return formatters$3.h(date, token);
  },
  // Hour [0-23]
  H: function H(date, token, localize) {
    if (token === 'Ho') {
      return localize.ordinalNumber(date.getUTCHours(), {
        unit: 'hour'
      });
    }
    return formatters$3.H(date, token);
  },
  // Hour [0-11]
  K: function K(date, token, localize) {
    var hours = date.getUTCHours() % 12;
    if (token === 'Ko') {
      return localize.ordinalNumber(hours, {
        unit: 'hour'
      });
    }
    return addLeadingZeros(hours, token.length);
  },
  // Hour [1-24]
  k: function k(date, token, localize) {
    var hours = date.getUTCHours();
    if (hours === 0) hours = 24;
    if (token === 'ko') {
      return localize.ordinalNumber(hours, {
        unit: 'hour'
      });
    }
    return addLeadingZeros(hours, token.length);
  },
  // Minute
  m: function m(date, token, localize) {
    if (token === 'mo') {
      return localize.ordinalNumber(date.getUTCMinutes(), {
        unit: 'minute'
      });
    }
    return formatters$3.m(date, token);
  },
  // Second
  s: function s(date, token, localize) {
    if (token === 'so') {
      return localize.ordinalNumber(date.getUTCSeconds(), {
        unit: 'second'
      });
    }
    return formatters$3.s(date, token);
  },
  // Fraction of second
  S: function S(date, token) {
    return formatters$3.S(date, token);
  },
  // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
  X: function X(date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timezoneOffset = originalDate.getTimezoneOffset();
    if (timezoneOffset === 0) {
      return 'Z';
    }
    switch (token) {
      // Hours and optional minutes
      case 'X':
        return formatTimezoneWithOptionalMinutes(timezoneOffset);

      // Hours, minutes and optional seconds without `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `XX`
      case 'XXXX':
      case 'XX':
        // Hours and minutes without `:` delimiter
        return formatTimezone(timezoneOffset);

      // Hours, minutes and optional seconds with `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `XXX`
      case 'XXXXX':
      case 'XXX': // Hours and minutes with `:` delimiter
      default:
        return formatTimezone(timezoneOffset, ':');
    }
  },
  // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
  x: function x(date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timezoneOffset = originalDate.getTimezoneOffset();
    switch (token) {
      // Hours and optional minutes
      case 'x':
        return formatTimezoneWithOptionalMinutes(timezoneOffset);

      // Hours, minutes and optional seconds without `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `xx`
      case 'xxxx':
      case 'xx':
        // Hours and minutes without `:` delimiter
        return formatTimezone(timezoneOffset);

      // Hours, minutes and optional seconds with `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `xxx`
      case 'xxxxx':
      case 'xxx': // Hours and minutes with `:` delimiter
      default:
        return formatTimezone(timezoneOffset, ':');
    }
  },
  // Timezone (GMT)
  O: function O(date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timezoneOffset = originalDate.getTimezoneOffset();
    switch (token) {
      // Short
      case 'O':
      case 'OO':
      case 'OOO':
        return 'GMT' + formatTimezoneShort(timezoneOffset, ':');
      // Long
      case 'OOOO':
      default:
        return 'GMT' + formatTimezone(timezoneOffset, ':');
    }
  },
  // Timezone (specific non-location)
  z: function z(date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timezoneOffset = originalDate.getTimezoneOffset();
    switch (token) {
      // Short
      case 'z':
      case 'zz':
      case 'zzz':
        return 'GMT' + formatTimezoneShort(timezoneOffset, ':');
      // Long
      case 'zzzz':
      default:
        return 'GMT' + formatTimezone(timezoneOffset, ':');
    }
  },
  // Seconds timestamp
  t: function t(date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timestamp = Math.floor(originalDate.getTime() / 1000);
    return addLeadingZeros(timestamp, token.length);
  },
  // Milliseconds timestamp
  T: function T(date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timestamp = originalDate.getTime();
    return addLeadingZeros(timestamp, token.length);
  }
};
function formatTimezoneShort(offset, dirtyDelimiter) {
  var sign = offset > 0 ? '-' : '+';
  var absOffset = Math.abs(offset);
  var hours = Math.floor(absOffset / 60);
  var minutes = absOffset % 60;
  if (minutes === 0) {
    return sign + String(hours);
  }
  var delimiter = dirtyDelimiter || '';
  return sign + String(hours) + delimiter + addLeadingZeros(minutes, 2);
}
function formatTimezoneWithOptionalMinutes(offset, dirtyDelimiter) {
  if (offset % 60 === 0) {
    var sign = offset > 0 ? '-' : '+';
    return sign + addLeadingZeros(Math.abs(offset) / 60, 2);
  }
  return formatTimezone(offset, dirtyDelimiter);
}
function formatTimezone(offset, dirtyDelimiter) {
  var delimiter = dirtyDelimiter || '';
  var sign = offset > 0 ? '-' : '+';
  var absOffset = Math.abs(offset);
  var hours = addLeadingZeros(Math.floor(absOffset / 60), 2);
  var minutes = addLeadingZeros(absOffset % 60, 2);
  return sign + hours + delimiter + minutes;
}
var formatters$1 = (/* unused pure expression or super */ null && (formatters));

var dateLongFormatter = function dateLongFormatter(pattern, formatLong) {
  switch (pattern) {
    case 'P':
      return formatLong.date({
        width: 'short'
      });
    case 'PP':
      return formatLong.date({
        width: 'medium'
      });
    case 'PPP':
      return formatLong.date({
        width: 'long'
      });
    case 'PPPP':
    default:
      return formatLong.date({
        width: 'full'
      });
  }
};
var timeLongFormatter = function timeLongFormatter(pattern, formatLong) {
  switch (pattern) {
    case 'p':
      return formatLong.time({
        width: 'short'
      });
    case 'pp':
      return formatLong.time({
        width: 'medium'
      });
    case 'ppp':
      return formatLong.time({
        width: 'long'
      });
    case 'pppp':
    default:
      return formatLong.time({
        width: 'full'
      });
  }
};
var dateTimeLongFormatter = function dateTimeLongFormatter(pattern, formatLong) {
  var matchResult = pattern.match(/(P+)(p+)?/) || [];
  var datePattern = matchResult[1];
  var timePattern = matchResult[2];
  if (!timePattern) {
    return dateLongFormatter(pattern, formatLong);
  }
  var dateTimeFormat;
  switch (datePattern) {
    case 'P':
      dateTimeFormat = formatLong.dateTime({
        width: 'short'
      });
      break;
    case 'PP':
      dateTimeFormat = formatLong.dateTime({
        width: 'medium'
      });
      break;
    case 'PPP':
      dateTimeFormat = formatLong.dateTime({
        width: 'long'
      });
      break;
    case 'PPPP':
    default:
      dateTimeFormat = formatLong.dateTime({
        width: 'full'
      });
      break;
  }
  return dateTimeFormat.replace('{{date}}', dateLongFormatter(datePattern, formatLong)).replace('{{time}}', timeLongFormatter(timePattern, formatLong));
};
var longFormatters = {
  p: timeLongFormatter,
  P: dateTimeLongFormatter
};
var longFormatters$1 = (/* unused pure expression or super */ null && (longFormatters));

var protectedDayOfYearTokens = (/* unused pure expression or super */ null && (['D', 'DD']));
var protectedWeekYearTokens = (/* unused pure expression or super */ null && (['YY', 'YYYY']));
function isProtectedDayOfYearToken(token) {
  return protectedDayOfYearTokens.indexOf(token) !== -1;
}
function isProtectedWeekYearToken(token) {
  return protectedWeekYearTokens.indexOf(token) !== -1;
}
function throwProtectedError(token, format, input) {
  if (token === 'YYYY') {
    throw new RangeError("Use `yyyy` instead of `YYYY` (in `".concat(format, "`) for formatting years to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  } else if (token === 'YY') {
    throw new RangeError("Use `yy` instead of `YY` (in `".concat(format, "`) for formatting years to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  } else if (token === 'D') {
    throw new RangeError("Use `d` instead of `D` (in `".concat(format, "`) for formatting days of the month to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  } else if (token === 'DD') {
    throw new RangeError("Use `dd` instead of `DD` (in `".concat(format, "`) for formatting days of the month to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  }
}

var formatDistanceLocale$1 = {
  lessThanXSeconds: {
    one: 'less than a second',
    other: 'less than {{count}} seconds'
  },
  xSeconds: {
    one: '1 second',
    other: '{{count}} seconds'
  },
  halfAMinute: 'half a minute',
  lessThanXMinutes: {
    one: 'less than a minute',
    other: 'less than {{count}} minutes'
  },
  xMinutes: {
    one: '1 minute',
    other: '{{count}} minutes'
  },
  aboutXHours: {
    one: 'about 1 hour',
    other: 'about {{count}} hours'
  },
  xHours: {
    one: '1 hour',
    other: '{{count}} hours'
  },
  xDays: {
    one: '1 day',
    other: '{{count}} days'
  },
  aboutXWeeks: {
    one: 'about 1 week',
    other: 'about {{count}} weeks'
  },
  xWeeks: {
    one: '1 week',
    other: '{{count}} weeks'
  },
  aboutXMonths: {
    one: 'about 1 month',
    other: 'about {{count}} months'
  },
  xMonths: {
    one: '1 month',
    other: '{{count}} months'
  },
  aboutXYears: {
    one: 'about 1 year',
    other: 'about {{count}} years'
  },
  xYears: {
    one: '1 year',
    other: '{{count}} years'
  },
  overXYears: {
    one: 'over 1 year',
    other: 'over {{count}} years'
  },
  almostXYears: {
    one: 'almost 1 year',
    other: 'almost {{count}} years'
  }
};
var formatDistance$2 = function formatDistance(token, count, options) {
  var result;
  var tokenValue = formatDistanceLocale$1[token];
  if (typeof tokenValue === 'string') {
    result = tokenValue;
  } else if (count === 1) {
    result = tokenValue.one;
  } else {
    result = tokenValue.other.replace('{{count}}', count.toString());
  }
  if (options !== null && options !== void 0 && options.addSuffix) {
    if (options.comparison && options.comparison > 0) {
      return 'in ' + result;
    } else {
      return result + ' ago';
    }
  }
  return result;
};
var formatDistance$3 = formatDistance$2;

function buildFormatLongFn(args) {
  return function () {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    // TODO: Remove String()
    var width = options.width ? String(options.width) : args.defaultWidth;
    var format = args.formats[width] || args.formats[args.defaultWidth];
    return format;
  };
}

var dateFormats$1 = {
  full: 'EEEE, MMMM do, y',
  long: 'MMMM do, y',
  medium: 'MMM d, y',
  short: 'MM/dd/yyyy'
};
var timeFormats$1 = {
  full: 'h:mm:ss a zzzz',
  long: 'h:mm:ss a z',
  medium: 'h:mm:ss a',
  short: 'h:mm a'
};
var dateTimeFormats$1 = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: '{{date}}, {{time}}',
  short: '{{date}}, {{time}}'
};
var formatLong$2 = {
  date: buildFormatLongFn({
    formats: dateFormats$1,
    defaultWidth: 'full'
  }),
  time: buildFormatLongFn({
    formats: timeFormats$1,
    defaultWidth: 'full'
  }),
  dateTime: buildFormatLongFn({
    formats: dateTimeFormats$1,
    defaultWidth: 'full'
  })
};
var formatLong$3 = formatLong$2;

var formatRelativeLocale$1 = {
  lastWeek: "'last' eeee 'at' p",
  yesterday: "'yesterday at' p",
  today: "'today at' p",
  tomorrow: "'tomorrow at' p",
  nextWeek: "eeee 'at' p",
  other: 'P'
};
var formatRelative$2 = function formatRelative(token, _date, _baseDate, _options) {
  return formatRelativeLocale$1[token];
};
var formatRelative$3 = formatRelative$2;

function buildLocalizeFn(args) {
  return function (dirtyIndex, options) {
    var context = options !== null && options !== void 0 && options.context ? String(options.context) : 'standalone';
    var valuesArray;
    if (context === 'formatting' && args.formattingValues) {
      var defaultWidth = args.defaultFormattingWidth || args.defaultWidth;
      var width = options !== null && options !== void 0 && options.width ? String(options.width) : defaultWidth;
      valuesArray = args.formattingValues[width] || args.formattingValues[defaultWidth];
    } else {
      var _defaultWidth = args.defaultWidth;
      var _width = options !== null && options !== void 0 && options.width ? String(options.width) : args.defaultWidth;
      valuesArray = args.values[_width] || args.values[_defaultWidth];
    }
    var index = args.argumentCallback ? args.argumentCallback(dirtyIndex) : dirtyIndex;
    // @ts-ignore: For some reason TypeScript just don't want to match it, no matter how hard we try. I challenge you to try to remove it!
    return valuesArray[index];
  };
}

var eraValues$1 = {
  narrow: ['B', 'A'],
  abbreviated: ['BC', 'AD'],
  wide: ['Before Christ', 'Anno Domini']
};
var quarterValues$1 = {
  narrow: ['1', '2', '3', '4'],
  abbreviated: ['Q1', 'Q2', 'Q3', 'Q4'],
  wide: ['1st quarter', '2nd quarter', '3rd quarter', '4th quarter']
};

// Note: in English, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
var monthValues$1 = {
  narrow: ['J', 'F', 'M', 'A', 'M', 'J', 'J', 'A', 'S', 'O', 'N', 'D'],
  abbreviated: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
  wide: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']
};
var dayValues$1 = {
  narrow: ['S', 'M', 'T', 'W', 'T', 'F', 'S'],
  short: ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'],
  abbreviated: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
  wide: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday']
};
var dayPeriodValues$1 = {
  narrow: {
    am: 'a',
    pm: 'p',
    midnight: 'mi',
    noon: 'n',
    morning: 'morning',
    afternoon: 'afternoon',
    evening: 'evening',
    night: 'night'
  },
  abbreviated: {
    am: 'AM',
    pm: 'PM',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'morning',
    afternoon: 'afternoon',
    evening: 'evening',
    night: 'night'
  },
  wide: {
    am: 'a.m.',
    pm: 'p.m.',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'morning',
    afternoon: 'afternoon',
    evening: 'evening',
    night: 'night'
  }
};
var formattingDayPeriodValues$1 = {
  narrow: {
    am: 'a',
    pm: 'p',
    midnight: 'mi',
    noon: 'n',
    morning: 'in the morning',
    afternoon: 'in the afternoon',
    evening: 'in the evening',
    night: 'at night'
  },
  abbreviated: {
    am: 'AM',
    pm: 'PM',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'in the morning',
    afternoon: 'in the afternoon',
    evening: 'in the evening',
    night: 'at night'
  },
  wide: {
    am: 'a.m.',
    pm: 'p.m.',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'in the morning',
    afternoon: 'in the afternoon',
    evening: 'in the evening',
    night: 'at night'
  }
};
var ordinalNumber$1 = function ordinalNumber(dirtyNumber, _options) {
  var number = Number(dirtyNumber);

  // If ordinal numbers depend on context, for example,
  // if they are different for different grammatical genders,
  // use `options.unit`.
  //
  // `unit` can be 'year', 'quarter', 'month', 'week', 'date', 'dayOfYear',
  // 'day', 'hour', 'minute', 'second'.

  var rem100 = number % 100;
  if (rem100 > 20 || rem100 < 10) {
    switch (rem100 % 10) {
      case 1:
        return number + 'st';
      case 2:
        return number + 'nd';
      case 3:
        return number + 'rd';
    }
  }
  return number + 'th';
};
var localize$2 = {
  ordinalNumber: ordinalNumber$1,
  era: buildLocalizeFn({
    values: eraValues$1,
    defaultWidth: 'wide'
  }),
  quarter: buildLocalizeFn({
    values: quarterValues$1,
    defaultWidth: 'wide',
    argumentCallback: function argumentCallback(quarter) {
      return quarter - 1;
    }
  }),
  month: buildLocalizeFn({
    values: monthValues$1,
    defaultWidth: 'wide'
  }),
  day: buildLocalizeFn({
    values: dayValues$1,
    defaultWidth: 'wide'
  }),
  dayPeriod: buildLocalizeFn({
    values: dayPeriodValues$1,
    defaultWidth: 'wide',
    formattingValues: formattingDayPeriodValues$1,
    defaultFormattingWidth: 'wide'
  })
};
var localize$3 = localize$2;

function buildMatchFn(args) {
  return function (string) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var width = options.width;
    var matchPattern = width && args.matchPatterns[width] || args.matchPatterns[args.defaultMatchWidth];
    var matchResult = string.match(matchPattern);
    if (!matchResult) {
      return null;
    }
    var matchedString = matchResult[0];
    var parsePatterns = width && args.parsePatterns[width] || args.parsePatterns[args.defaultParseWidth];
    var key = Array.isArray(parsePatterns) ? findIndex(parsePatterns, function (pattern) {
      return pattern.test(matchedString);
    }) : findKey$1(parsePatterns, function (pattern) {
      return pattern.test(matchedString);
    });
    var value;
    value = args.valueCallback ? args.valueCallback(key) : key;
    value = options.valueCallback ? options.valueCallback(value) : value;
    var rest = string.slice(matchedString.length);
    return {
      value: value,
      rest: rest
    };
  };
}
function findKey$1(object, predicate) {
  for (var key in object) {
    if (object.hasOwnProperty(key) && predicate(object[key])) {
      return key;
    }
  }
  return undefined;
}
function findIndex(array, predicate) {
  for (var key = 0; key < array.length; key++) {
    if (predicate(array[key])) {
      return key;
    }
  }
  return undefined;
}

function buildMatchPatternFn(args) {
  return function (string) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var matchResult = string.match(args.matchPattern);
    if (!matchResult) return null;
    var matchedString = matchResult[0];
    var parseResult = string.match(args.parsePattern);
    if (!parseResult) return null;
    var value = args.valueCallback ? args.valueCallback(parseResult[0]) : parseResult[0];
    value = options.valueCallback ? options.valueCallback(value) : value;
    var rest = string.slice(matchedString.length);
    return {
      value: value,
      rest: rest
    };
  };
}

var matchOrdinalNumberPattern$1 = /^(\d+)(th|st|nd|rd)?/i;
var parseOrdinalNumberPattern$1 = /\d+/i;
var matchEraPatterns$1 = {
  narrow: /^(b|a)/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  wide: /^(before christ|before common era|anno domini|common era)/i
};
var parseEraPatterns$1 = {
  any: [/^b/i, /^(a|c)/i]
};
var matchQuarterPatterns$1 = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](th|st|nd|rd)? quarter/i
};
var parseQuarterPatterns$1 = {
  any: [/1/i, /2/i, /3/i, /4/i]
};
var matchMonthPatterns$1 = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
  wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
};
var parseMonthPatterns$1 = {
  narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
  any: [/^ja/i, /^f/i, /^mar/i, /^ap/i, /^may/i, /^jun/i, /^jul/i, /^au/i, /^s/i, /^o/i, /^n/i, /^d/i]
};
var matchDayPatterns$1 = {
  narrow: /^[smtwf]/i,
  short: /^(su|mo|tu|we|th|fr|sa)/i,
  abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
  wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
};
var parseDayPatterns$1 = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
};
var matchDayPeriodPatterns$1 = {
  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
};
var parseDayPeriodPatterns$1 = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mi/i,
    noon: /^no/i,
    morning: /morning/i,
    afternoon: /afternoon/i,
    evening: /evening/i,
    night: /night/i
  }
};
var match$2 = {
  ordinalNumber: buildMatchPatternFn({
    matchPattern: matchOrdinalNumberPattern$1,
    parsePattern: parseOrdinalNumberPattern$1,
    valueCallback: function valueCallback(value) {
      return parseInt(value, 10);
    }
  }),
  era: buildMatchFn({
    matchPatterns: matchEraPatterns$1,
    defaultMatchWidth: 'wide',
    parsePatterns: parseEraPatterns$1,
    defaultParseWidth: 'any'
  }),
  quarter: buildMatchFn({
    matchPatterns: matchQuarterPatterns$1,
    defaultMatchWidth: 'wide',
    parsePatterns: parseQuarterPatterns$1,
    defaultParseWidth: 'any',
    valueCallback: function valueCallback(index) {
      return index + 1;
    }
  }),
  month: buildMatchFn({
    matchPatterns: matchMonthPatterns$1,
    defaultMatchWidth: 'wide',
    parsePatterns: parseMonthPatterns$1,
    defaultParseWidth: 'any'
  }),
  day: buildMatchFn({
    matchPatterns: matchDayPatterns$1,
    defaultMatchWidth: 'wide',
    parsePatterns: parseDayPatterns$1,
    defaultParseWidth: 'any'
  }),
  dayPeriod: buildMatchFn({
    matchPatterns: matchDayPeriodPatterns$1,
    defaultMatchWidth: 'any',
    parsePatterns: parseDayPeriodPatterns$1,
    defaultParseWidth: 'any'
  })
};
var match$3 = match$2;

/**
 * @type {Locale}
 * @category Locales
 * @summary English locale (United States).
 * @language English
 * @iso-639-2 eng
 * @author Sasha Koss [@kossnocorp]{@link https://github.com/kossnocorp}
 * @author Lesha Koss [@leshakoss]{@link https://github.com/leshakoss}
 */
var locale$1 = {
  code: 'en-US',
  formatDistance: formatDistance$3,
  formatLong: formatLong$3,
  formatRelative: formatRelative$3,
  localize: localize$3,
  match: match$3,
  options: {
    weekStartsOn: 0 /* Sunday */,
    firstWeekContainsDate: 1
  }
};
var defaultLocale = (/* unused pure expression or super */ null && (locale$1));

// - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
//   (one of the certain letters followed by `o`)
// - (\w)\1* matches any sequences of the same letter
// - '' matches two quote characters in a row
// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
//   except a single quote symbol, which ends the sequence.
//   Two quote characters do not end the sequence.
//   If there is no matching single quote
//   then the sequence will continue until the end of the string.
// - . matches any single character unmatched by previous parts of the RegExps
var formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g;

// This RegExp catches symbols escaped by quotes, and also
// sequences of symbols P, p, and the combinations like `PPPPPPPppppp`
var longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
var escapedStringRegExp = /^'([^]*?)'?$/;
var doubleQuoteRegExp = /''/g;
var unescapedLatinCharacterRegExp = /[a-zA-Z]/;

/**
 * @name format
 * @category Common Helpers
 * @summary Format the date.
 *
 * @description
 * Return the formatted date string in the given format. The result may vary by locale.
 *
 * > ⚠️ Please note that the `format` tokens differ from Moment.js and other libraries.
 * > See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * The characters wrapped between two single quotes characters (') are escaped.
 * Two single quotes in a row, whether inside or outside a quoted sequence, represent a 'real' single quote.
 * (see the last example)
 *
 * Format of the string is based on Unicode Technical Standard #35:
 * https://www.unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
 * with a few additions (see note 7 below the table).
 *
 * Accepted patterns:
 * | Unit                            | Pattern | Result examples                   | Notes |
 * |---------------------------------|---------|-----------------------------------|-------|
 * | Era                             | G..GGG  | AD, BC                            |       |
 * |                                 | GGGG    | Anno Domini, Before Christ        | 2     |
 * |                                 | GGGGG   | A, B                              |       |
 * | Calendar year                   | y       | 44, 1, 1900, 2017                 | 5     |
 * |                                 | yo      | 44th, 1st, 0th, 17th              | 5,7   |
 * |                                 | yy      | 44, 01, 00, 17                    | 5     |
 * |                                 | yyy     | 044, 001, 1900, 2017              | 5     |
 * |                                 | yyyy    | 0044, 0001, 1900, 2017            | 5     |
 * |                                 | yyyyy   | ...                               | 3,5   |
 * | Local week-numbering year       | Y       | 44, 1, 1900, 2017                 | 5     |
 * |                                 | Yo      | 44th, 1st, 1900th, 2017th         | 5,7   |
 * |                                 | YY      | 44, 01, 00, 17                    | 5,8   |
 * |                                 | YYY     | 044, 001, 1900, 2017              | 5     |
 * |                                 | YYYY    | 0044, 0001, 1900, 2017            | 5,8   |
 * |                                 | YYYYY   | ...                               | 3,5   |
 * | ISO week-numbering year         | R       | -43, 0, 1, 1900, 2017             | 5,7   |
 * |                                 | RR      | -43, 00, 01, 1900, 2017           | 5,7   |
 * |                                 | RRR     | -043, 000, 001, 1900, 2017        | 5,7   |
 * |                                 | RRRR    | -0043, 0000, 0001, 1900, 2017     | 5,7   |
 * |                                 | RRRRR   | ...                               | 3,5,7 |
 * | Extended year                   | u       | -43, 0, 1, 1900, 2017             | 5     |
 * |                                 | uu      | -43, 01, 1900, 2017               | 5     |
 * |                                 | uuu     | -043, 001, 1900, 2017             | 5     |
 * |                                 | uuuu    | -0043, 0001, 1900, 2017           | 5     |
 * |                                 | uuuuu   | ...                               | 3,5   |
 * | Quarter (formatting)            | Q       | 1, 2, 3, 4                        |       |
 * |                                 | Qo      | 1st, 2nd, 3rd, 4th                | 7     |
 * |                                 | QQ      | 01, 02, 03, 04                    |       |
 * |                                 | QQQ     | Q1, Q2, Q3, Q4                    |       |
 * |                                 | QQQQ    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 | QQQQQ   | 1, 2, 3, 4                        | 4     |
 * | Quarter (stand-alone)           | q       | 1, 2, 3, 4                        |       |
 * |                                 | qo      | 1st, 2nd, 3rd, 4th                | 7     |
 * |                                 | qq      | 01, 02, 03, 04                    |       |
 * |                                 | qqq     | Q1, Q2, Q3, Q4                    |       |
 * |                                 | qqqq    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 | qqqqq   | 1, 2, 3, 4                        | 4     |
 * | Month (formatting)              | M       | 1, 2, ..., 12                     |       |
 * |                                 | Mo      | 1st, 2nd, ..., 12th               | 7     |
 * |                                 | MM      | 01, 02, ..., 12                   |       |
 * |                                 | MMM     | Jan, Feb, ..., Dec                |       |
 * |                                 | MMMM    | January, February, ..., December  | 2     |
 * |                                 | MMMMM   | J, F, ..., D                      |       |
 * | Month (stand-alone)             | L       | 1, 2, ..., 12                     |       |
 * |                                 | Lo      | 1st, 2nd, ..., 12th               | 7     |
 * |                                 | LL      | 01, 02, ..., 12                   |       |
 * |                                 | LLL     | Jan, Feb, ..., Dec                |       |
 * |                                 | LLLL    | January, February, ..., December  | 2     |
 * |                                 | LLLLL   | J, F, ..., D                      |       |
 * | Local week of year              | w       | 1, 2, ..., 53                     |       |
 * |                                 | wo      | 1st, 2nd, ..., 53th               | 7     |
 * |                                 | ww      | 01, 02, ..., 53                   |       |
 * | ISO week of year                | I       | 1, 2, ..., 53                     | 7     |
 * |                                 | Io      | 1st, 2nd, ..., 53th               | 7     |
 * |                                 | II      | 01, 02, ..., 53                   | 7     |
 * | Day of month                    | d       | 1, 2, ..., 31                     |       |
 * |                                 | do      | 1st, 2nd, ..., 31st               | 7     |
 * |                                 | dd      | 01, 02, ..., 31                   |       |
 * | Day of year                     | D       | 1, 2, ..., 365, 366               | 9     |
 * |                                 | Do      | 1st, 2nd, ..., 365th, 366th       | 7     |
 * |                                 | DD      | 01, 02, ..., 365, 366             | 9     |
 * |                                 | DDD     | 001, 002, ..., 365, 366           |       |
 * |                                 | DDDD    | ...                               | 3     |
 * | Day of week (formatting)        | E..EEE  | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 | EEEE    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | EEEEE   | M, T, W, T, F, S, S               |       |
 * |                                 | EEEEEE  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | ISO day of week (formatting)    | i       | 1, 2, 3, ..., 7                   | 7     |
 * |                                 | io      | 1st, 2nd, ..., 7th                | 7     |
 * |                                 | ii      | 01, 02, ..., 07                   | 7     |
 * |                                 | iii     | Mon, Tue, Wed, ..., Sun           | 7     |
 * |                                 | iiii    | Monday, Tuesday, ..., Sunday      | 2,7   |
 * |                                 | iiiii   | M, T, W, T, F, S, S               | 7     |
 * |                                 | iiiiii  | Mo, Tu, We, Th, Fr, Sa, Su        | 7     |
 * | Local day of week (formatting)  | e       | 2, 3, 4, ..., 1                   |       |
 * |                                 | eo      | 2nd, 3rd, ..., 1st                | 7     |
 * |                                 | ee      | 02, 03, ..., 01                   |       |
 * |                                 | eee     | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 | eeee    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | eeeee   | M, T, W, T, F, S, S               |       |
 * |                                 | eeeeee  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | Local day of week (stand-alone) | c       | 2, 3, 4, ..., 1                   |       |
 * |                                 | co      | 2nd, 3rd, ..., 1st                | 7     |
 * |                                 | cc      | 02, 03, ..., 01                   |       |
 * |                                 | ccc     | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 | cccc    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | ccccc   | M, T, W, T, F, S, S               |       |
 * |                                 | cccccc  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | AM, PM                          | a..aa   | AM, PM                            |       |
 * |                                 | aaa     | am, pm                            |       |
 * |                                 | aaaa    | a.m., p.m.                        | 2     |
 * |                                 | aaaaa   | a, p                              |       |
 * | AM, PM, noon, midnight          | b..bb   | AM, PM, noon, midnight            |       |
 * |                                 | bbb     | am, pm, noon, midnight            |       |
 * |                                 | bbbb    | a.m., p.m., noon, midnight        | 2     |
 * |                                 | bbbbb   | a, p, n, mi                       |       |
 * | Flexible day period             | B..BBB  | at night, in the morning, ...     |       |
 * |                                 | BBBB    | at night, in the morning, ...     | 2     |
 * |                                 | BBBBB   | at night, in the morning, ...     |       |
 * | Hour [1-12]                     | h       | 1, 2, ..., 11, 12                 |       |
 * |                                 | ho      | 1st, 2nd, ..., 11th, 12th         | 7     |
 * |                                 | hh      | 01, 02, ..., 11, 12               |       |
 * | Hour [0-23]                     | H       | 0, 1, 2, ..., 23                  |       |
 * |                                 | Ho      | 0th, 1st, 2nd, ..., 23rd          | 7     |
 * |                                 | HH      | 00, 01, 02, ..., 23               |       |
 * | Hour [0-11]                     | K       | 1, 2, ..., 11, 0                  |       |
 * |                                 | Ko      | 1st, 2nd, ..., 11th, 0th          | 7     |
 * |                                 | KK      | 01, 02, ..., 11, 00               |       |
 * | Hour [1-24]                     | k       | 24, 1, 2, ..., 23                 |       |
 * |                                 | ko      | 24th, 1st, 2nd, ..., 23rd         | 7     |
 * |                                 | kk      | 24, 01, 02, ..., 23               |       |
 * | Minute                          | m       | 0, 1, ..., 59                     |       |
 * |                                 | mo      | 0th, 1st, ..., 59th               | 7     |
 * |                                 | mm      | 00, 01, ..., 59                   |       |
 * | Second                          | s       | 0, 1, ..., 59                     |       |
 * |                                 | so      | 0th, 1st, ..., 59th               | 7     |
 * |                                 | ss      | 00, 01, ..., 59                   |       |
 * | Fraction of second              | S       | 0, 1, ..., 9                      |       |
 * |                                 | SS      | 00, 01, ..., 99                   |       |
 * |                                 | SSS     | 000, 001, ..., 999                |       |
 * |                                 | SSSS    | ...                               | 3     |
 * | Timezone (ISO-8601 w/ Z)        | X       | -08, +0530, Z                     |       |
 * |                                 | XX      | -0800, +0530, Z                   |       |
 * |                                 | XXX     | -08:00, +05:30, Z                 |       |
 * |                                 | XXXX    | -0800, +0530, Z, +123456          | 2     |
 * |                                 | XXXXX   | -08:00, +05:30, Z, +12:34:56      |       |
 * | Timezone (ISO-8601 w/o Z)       | x       | -08, +0530, +00                   |       |
 * |                                 | xx      | -0800, +0530, +0000               |       |
 * |                                 | xxx     | -08:00, +05:30, +00:00            | 2     |
 * |                                 | xxxx    | -0800, +0530, +0000, +123456      |       |
 * |                                 | xxxxx   | -08:00, +05:30, +00:00, +12:34:56 |       |
 * | Timezone (GMT)                  | O...OOO | GMT-8, GMT+5:30, GMT+0            |       |
 * |                                 | OOOO    | GMT-08:00, GMT+05:30, GMT+00:00   | 2     |
 * | Timezone (specific non-locat.)  | z...zzz | GMT-8, GMT+5:30, GMT+0            | 6     |
 * |                                 | zzzz    | GMT-08:00, GMT+05:30, GMT+00:00   | 2,6   |
 * | Seconds timestamp               | t       | 512969520                         | 7     |
 * |                                 | tt      | ...                               | 3,7   |
 * | Milliseconds timestamp          | T       | 512969520900                      | 7     |
 * |                                 | TT      | ...                               | 3,7   |
 * | Long localized date             | P       | 04/29/1453                        | 7     |
 * |                                 | PP      | Apr 29, 1453                      | 7     |
 * |                                 | PPP     | April 29th, 1453                  | 7     |
 * |                                 | PPPP    | Friday, April 29th, 1453          | 2,7   |
 * | Long localized time             | p       | 12:00 AM                          | 7     |
 * |                                 | pp      | 12:00:00 AM                       | 7     |
 * |                                 | ppp     | 12:00:00 AM GMT+2                 | 7     |
 * |                                 | pppp    | 12:00:00 AM GMT+02:00             | 2,7   |
 * | Combination of date and time    | Pp      | 04/29/1453, 12:00 AM              | 7     |
 * |                                 | PPpp    | Apr 29, 1453, 12:00:00 AM         | 7     |
 * |                                 | PPPppp  | April 29th, 1453 at ...           | 7     |
 * |                                 | PPPPpppp| Friday, April 29th, 1453 at ...   | 2,7   |
 * Notes:
 * 1. "Formatting" units (e.g. formatting quarter) in the default en-US locale
 *    are the same as "stand-alone" units, but are different in some languages.
 *    "Formatting" units are declined according to the rules of the language
 *    in the context of a date. "Stand-alone" units are always nominative singular:
 *
 *    `format(new Date(2017, 10, 6), 'do LLLL', {locale: cs}) //=> '6. listopad'`
 *
 *    `format(new Date(2017, 10, 6), 'do MMMM', {locale: cs}) //=> '6. listopadu'`
 *
 * 2. Any sequence of the identical letters is a pattern, unless it is escaped by
 *    the single quote characters (see below).
 *    If the sequence is longer than listed in table (e.g. `EEEEEEEEEEE`)
 *    the output will be the same as default pattern for this unit, usually
 *    the longest one (in case of ISO weekdays, `EEEE`). Default patterns for units
 *    are marked with "2" in the last column of the table.
 *
 *    `format(new Date(2017, 10, 6), 'MMM') //=> 'Nov'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMM') //=> 'November'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMM') //=> 'N'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMMM') //=> 'November'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMMMM') //=> 'November'`
 *
 * 3. Some patterns could be unlimited length (such as `yyyyyyyy`).
 *    The output will be padded with zeros to match the length of the pattern.
 *
 *    `format(new Date(2017, 10, 6), 'yyyyyyyy') //=> '00002017'`
 *
 * 4. `QQQQQ` and `qqqqq` could be not strictly numerical in some locales.
 *    These tokens represent the shortest form of the quarter.
 *
 * 5. The main difference between `y` and `u` patterns are B.C. years:
 *
 *    | Year | `y` | `u` |
 *    |------|-----|-----|
 *    | AC 1 |   1 |   1 |
 *    | BC 1 |   1 |   0 |
 *    | BC 2 |   2 |  -1 |
 *
 *    Also `yy` always returns the last two digits of a year,
 *    while `uu` pads single digit years to 2 characters and returns other years unchanged:
 *
 *    | Year | `yy` | `uu` |
 *    |------|------|------|
 *    | 1    |   01 |   01 |
 *    | 14   |   14 |   14 |
 *    | 376  |   76 |  376 |
 *    | 1453 |   53 | 1453 |
 *
 *    The same difference is true for local and ISO week-numbering years (`Y` and `R`),
 *    except local week-numbering years are dependent on `options.weekStartsOn`
 *    and `options.firstWeekContainsDate` (compare [getISOWeekYear]{@link https://date-fns.org/docs/getISOWeekYear}
 *    and [getWeekYear]{@link https://date-fns.org/docs/getWeekYear}).
 *
 * 6. Specific non-location timezones are currently unavailable in `date-fns`,
 *    so right now these tokens fall back to GMT timezones.
 *
 * 7. These patterns are not in the Unicode Technical Standard #35:
 *    - `i`: ISO day of week
 *    - `I`: ISO week of year
 *    - `R`: ISO week-numbering year
 *    - `t`: seconds timestamp
 *    - `T`: milliseconds timestamp
 *    - `o`: ordinal number modifier
 *    - `P`: long localized date
 *    - `p`: long localized time
 *
 * 8. `YY` and `YYYY` tokens represent week-numbering years but they are often confused with years.
 *    You should enable `options.useAdditionalWeekYearTokens` to use them. See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * 9. `D` and `DD` tokens represent days of the year but they are often confused with days of the month.
 *    You should enable `options.useAdditionalDayOfYearTokens` to use them. See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * @param {Date|Number} date - the original date
 * @param {String} format - the string of tokens
 * @param {Object} [options] - an object with options.
 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
 * @param {Number} [options.firstWeekContainsDate=1] - the day of January, which is
 * @param {Boolean} [options.useAdditionalWeekYearTokens=false] - if true, allows usage of the week-numbering year tokens `YY` and `YYYY`;
 *   see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @param {Boolean} [options.useAdditionalDayOfYearTokens=false] - if true, allows usage of the day of year tokens `D` and `DD`;
 *   see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @returns {String} the formatted date string
 * @throws {TypeError} 2 arguments required
 * @throws {RangeError} `date` must not be Invalid Date
 * @throws {RangeError} `options.locale` must contain `localize` property
 * @throws {RangeError} `options.locale` must contain `formatLong` property
 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
 * @throws {RangeError} `options.firstWeekContainsDate` must be between 1 and 7
 * @throws {RangeError} use `yyyy` instead of `YYYY` for formatting years using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws {RangeError} use `yy` instead of `YY` for formatting years using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws {RangeError} use `d` instead of `D` for formatting days of the month using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws {RangeError} use `dd` instead of `DD` for formatting days of the month using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws {RangeError} format string contains an unescaped latin alphabet character
 *
 * @example
 * // Represent 11 February 2014 in middle-endian format:
 * const result = format(new Date(2014, 1, 11), 'MM/dd/yyyy')
 * //=> '02/11/2014'
 *
 * @example
 * // Represent 2 July 2014 in Esperanto:
 * import { eoLocale } from 'date-fns/locale/eo'
 * const result = format(new Date(2014, 6, 2), "do 'de' MMMM yyyy", {
 *   locale: eoLocale
 * })
 * //=> '2-a de julio 2014'
 *
 * @example
 * // Escape string by single quote characters:
 * const result = format(new Date(2014, 6, 2, 15), "h 'o''clock'")
 * //=> "3 o'clock"
 */

function format$1(dirtyDate, dirtyFormatStr, options) {
  var _ref, _options$locale, _ref2, _ref3, _ref4, _options$firstWeekCon, _options$locale2, _options$locale2$opti, _defaultOptions$local, _defaultOptions$local2, _ref5, _ref6, _ref7, _options$weekStartsOn, _options$locale3, _options$locale3$opti, _defaultOptions$local3, _defaultOptions$local4;
  requiredArgs(2, arguments);
  var formatStr = String(dirtyFormatStr);
  var defaultOptions = getDefaultOptions();
  var locale = (_ref = (_options$locale = options === null || options === void 0 ? void 0 : options.locale) !== null && _options$locale !== void 0 ? _options$locale : defaultOptions.locale) !== null && _ref !== void 0 ? _ref : defaultLocale;
  var firstWeekContainsDate = toInteger((_ref2 = (_ref3 = (_ref4 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale2 = options.locale) === null || _options$locale2 === void 0 ? void 0 : (_options$locale2$opti = _options$locale2.options) === null || _options$locale2$opti === void 0 ? void 0 : _options$locale2$opti.firstWeekContainsDate) !== null && _ref4 !== void 0 ? _ref4 : defaultOptions.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : 1);

  // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
  if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) {
    throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
  }
  var weekStartsOn = toInteger((_ref5 = (_ref6 = (_ref7 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale3 = options.locale) === null || _options$locale3 === void 0 ? void 0 : (_options$locale3$opti = _options$locale3.options) === null || _options$locale3$opti === void 0 ? void 0 : _options$locale3$opti.weekStartsOn) !== null && _ref7 !== void 0 ? _ref7 : defaultOptions.weekStartsOn) !== null && _ref6 !== void 0 ? _ref6 : (_defaultOptions$local3 = defaultOptions.locale) === null || _defaultOptions$local3 === void 0 ? void 0 : (_defaultOptions$local4 = _defaultOptions$local3.options) === null || _defaultOptions$local4 === void 0 ? void 0 : _defaultOptions$local4.weekStartsOn) !== null && _ref5 !== void 0 ? _ref5 : 0);

  // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
  }
  if (!locale.localize) {
    throw new RangeError('locale must contain localize property');
  }
  if (!locale.formatLong) {
    throw new RangeError('locale must contain formatLong property');
  }
  var originalDate = toDate(dirtyDate);
  if (!isValid$1(originalDate)) {
    throw new RangeError('Invalid time value');
  }

  // Convert the date in system timezone to the same date in UTC+00:00 timezone.
  // This ensures that when UTC functions will be implemented, locales will be compatible with them.
  // See an issue about UTC functions: https://github.com/date-fns/date-fns/issues/376
  var timezoneOffset = getTimezoneOffsetInMilliseconds(originalDate);
  var utcDate = subMilliseconds(originalDate, timezoneOffset);
  var formatterOptions = {
    firstWeekContainsDate: firstWeekContainsDate,
    weekStartsOn: weekStartsOn,
    locale: locale,
    _originalDate: originalDate
  };
  var result = formatStr.match(longFormattingTokensRegExp).map(function (substring) {
    var firstCharacter = substring[0];
    if (firstCharacter === 'p' || firstCharacter === 'P') {
      var longFormatter = longFormatters$1[firstCharacter];
      return longFormatter(substring, locale.formatLong);
    }
    return substring;
  }).join('').match(formattingTokensRegExp).map(function (substring) {
    // Replace two single quote characters with one single quote character
    if (substring === "''") {
      return "'";
    }
    var firstCharacter = substring[0];
    if (firstCharacter === "'") {
      return cleanEscapedString(substring);
    }
    var formatter = formatters$1[firstCharacter];
    if (formatter) {
      if (!(options !== null && options !== void 0 && options.useAdditionalWeekYearTokens) && isProtectedWeekYearToken(substring)) {
        throwProtectedError(substring, dirtyFormatStr, String(dirtyDate));
      }
      if (!(options !== null && options !== void 0 && options.useAdditionalDayOfYearTokens) && isProtectedDayOfYearToken(substring)) {
        throwProtectedError(substring, dirtyFormatStr, String(dirtyDate));
      }
      return formatter(utcDate, substring, locale.localize, formatterOptions);
    }
    if (firstCharacter.match(unescapedLatinCharacterRegExp)) {
      throw new RangeError('Format string contains an unescaped latin alphabet character `' + firstCharacter + '`');
    }
    return substring;
  }).join('');
  return result;
}
function cleanEscapedString(input) {
  var matched = input.match(escapedStringRegExp);
  if (!matched) {
    return input;
  }
  return matched[1].replace(doubleQuoteRegExp, "'");
}

function _assertThisInitialized(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}

function _setPrototypeOf(t, e) {
  return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) {
    return t.__proto__ = e, t;
  }, _setPrototypeOf(t, e);
}

/**
 * @name parseISO
 * @category Common Helpers
 * @summary Parse ISO string
 *
 * @description
 * Parse the given string in ISO 8601 format and return an instance of Date.
 *
 * Function accepts complete ISO 8601 formats as well as partial implementations.
 * ISO 8601: http://en.wikipedia.org/wiki/ISO_8601
 *
 * If the argument isn't a string, the function cannot parse the string or
 * the values are invalid, it returns Invalid Date.
 *
 * @param {String} argument - the value to convert
 * @param {Object} [options] - an object with options.
 * @param {0|1|2} [options.additionalDigits=2] - the additional number of digits in the extended year format
 * @returns {Date} the parsed date in the local time zone
 * @throws {TypeError} 1 argument required
 * @throws {RangeError} `options.additionalDigits` must be 0, 1 or 2
 *
 * @example
 * // Convert string '2014-02-11T11:30:30' to date:
 * const result = parseISO('2014-02-11T11:30:30')
 * //=> Tue Feb 11 2014 11:30:30
 *
 * @example
 * // Convert string '+02014101' to date,
 * // if the additional number of digits in the extended year format is 1:
 * const result = parseISO('+02014101', { additionalDigits: 1 })
 * //=> Fri Apr 11 2014 00:00:00
 */
function parseISO(argument, options) {
  var _options$additionalDi;
  requiredArgs(1, arguments);
  var additionalDigits = toInteger((_options$additionalDi = options === null || options === void 0 ? void 0 : options.additionalDigits) !== null && _options$additionalDi !== void 0 ? _options$additionalDi : 2);
  if (additionalDigits !== 2 && additionalDigits !== 1 && additionalDigits !== 0) {
    throw new RangeError('additionalDigits must be 0, 1 or 2');
  }
  if (!(typeof argument === 'string' || Object.prototype.toString.call(argument) === '[object String]')) {
    return new Date(NaN);
  }
  var dateStrings = splitDateString(argument);
  var date;
  if (dateStrings.date) {
    var parseYearResult = parseYear(dateStrings.date, additionalDigits);
    date = parseDate(parseYearResult.restDateString, parseYearResult.year);
  }
  if (!date || isNaN(date.getTime())) {
    return new Date(NaN);
  }
  var timestamp = date.getTime();
  var time = 0;
  var offset;
  if (dateStrings.time) {
    time = parseTime(dateStrings.time);
    if (isNaN(time)) {
      return new Date(NaN);
    }
  }
  if (dateStrings.timezone) {
    offset = parseTimezone(dateStrings.timezone);
    if (isNaN(offset)) {
      return new Date(NaN);
    }
  } else {
    var dirtyDate = new Date(timestamp + time);
    // js parsed string assuming it's in UTC timezone
    // but we need it to be parsed in our timezone
    // so we use utc values to build date in our timezone.
    // Year values from 0 to 99 map to the years 1900 to 1999
    // so set year explicitly with setFullYear.
    var result = new Date(0);
    result.setFullYear(dirtyDate.getUTCFullYear(), dirtyDate.getUTCMonth(), dirtyDate.getUTCDate());
    result.setHours(dirtyDate.getUTCHours(), dirtyDate.getUTCMinutes(), dirtyDate.getUTCSeconds(), dirtyDate.getUTCMilliseconds());
    return result;
  }
  return new Date(timestamp + time + offset);
}
var patterns = {
  dateTimeDelimiter: /[T ]/,
  timeZoneDelimiter: /[Z ]/i,
  timezone: /([Z+-].*)$/
};
var dateRegex = /^-?(?:(\d{3})|(\d{2})(?:-?(\d{2}))?|W(\d{2})(?:-?(\d{1}))?|)$/;
var timeRegex = /^(\d{2}(?:[.,]\d*)?)(?::?(\d{2}(?:[.,]\d*)?))?(?::?(\d{2}(?:[.,]\d*)?))?$/;
var timezoneRegex = /^([+-])(\d{2})(?::?(\d{2}))?$/;
function splitDateString(dateString) {
  var dateStrings = {};
  var array = dateString.split(patterns.dateTimeDelimiter);
  var timeString;

  // The regex match should only return at maximum two array elements.
  // [date], [time], or [date, time].
  if (array.length > 2) {
    return dateStrings;
  }
  if (/:/.test(array[0])) {
    timeString = array[0];
  } else {
    dateStrings.date = array[0];
    timeString = array[1];
    if (patterns.timeZoneDelimiter.test(dateStrings.date)) {
      dateStrings.date = dateString.split(patterns.timeZoneDelimiter)[0];
      timeString = dateString.substr(dateStrings.date.length, dateString.length);
    }
  }
  if (timeString) {
    var token = patterns.timezone.exec(timeString);
    if (token) {
      dateStrings.time = timeString.replace(token[1], '');
      dateStrings.timezone = token[1];
    } else {
      dateStrings.time = timeString;
    }
  }
  return dateStrings;
}
function parseYear(dateString, additionalDigits) {
  var regex = new RegExp('^(?:(\\d{4}|[+-]\\d{' + (4 + additionalDigits) + '})|(\\d{2}|[+-]\\d{' + (2 + additionalDigits) + '})$)');
  var captures = dateString.match(regex);
  // Invalid ISO-formatted year
  if (!captures) return {
    year: NaN,
    restDateString: ''
  };
  var year = captures[1] ? parseInt(captures[1]) : null;
  var century = captures[2] ? parseInt(captures[2]) : null;

  // either year or century is null, not both
  return {
    year: century === null ? year : century * 100,
    restDateString: dateString.slice((captures[1] || captures[2]).length)
  };
}
function parseDate(dateString, year) {
  // Invalid ISO-formatted year
  if (year === null) return new Date(NaN);
  var captures = dateString.match(dateRegex);
  // Invalid ISO-formatted string
  if (!captures) return new Date(NaN);
  var isWeekDate = !!captures[4];
  var dayOfYear = parseDateUnit(captures[1]);
  var month = parseDateUnit(captures[2]) - 1;
  var day = parseDateUnit(captures[3]);
  var week = parseDateUnit(captures[4]);
  var dayOfWeek = parseDateUnit(captures[5]) - 1;
  if (isWeekDate) {
    if (!validateWeekDate(year, week, dayOfWeek)) {
      return new Date(NaN);
    }
    return dayOfISOWeekYear(year, week, dayOfWeek);
  } else {
    var date = new Date(0);
    if (!validateDate(year, month, day) || !validateDayOfYearDate(year, dayOfYear)) {
      return new Date(NaN);
    }
    date.setUTCFullYear(year, month, Math.max(dayOfYear, day));
    return date;
  }
}
function parseDateUnit(value) {
  return value ? parseInt(value) : 1;
}
function parseTime(timeString) {
  var captures = timeString.match(timeRegex);
  if (!captures) return NaN; // Invalid ISO-formatted time

  var hours = parseTimeUnit(captures[1]);
  var minutes = parseTimeUnit(captures[2]);
  var seconds = parseTimeUnit(captures[3]);
  if (!validateTime(hours, minutes, seconds)) {
    return NaN;
  }
  return hours * millisecondsInHour + minutes * millisecondsInMinute + seconds * 1000;
}
function parseTimeUnit(value) {
  return value && parseFloat(value.replace(',', '.')) || 0;
}
function parseTimezone(timezoneString) {
  if (timezoneString === 'Z') return 0;
  var captures = timezoneString.match(timezoneRegex);
  if (!captures) return 0;
  var sign = captures[1] === '+' ? -1 : 1;
  var hours = parseInt(captures[2]);
  var minutes = captures[3] && parseInt(captures[3]) || 0;
  if (!validateTimezone(hours, minutes)) {
    return NaN;
  }
  return sign * (hours * millisecondsInHour + minutes * millisecondsInMinute);
}
function dayOfISOWeekYear(isoWeekYear, week, day) {
  var date = new Date(0);
  date.setUTCFullYear(isoWeekYear, 0, 4);
  var fourthOfJanuaryDay = date.getUTCDay() || 7;
  var diff = (week - 1) * 7 + day + 1 - fourthOfJanuaryDay;
  date.setUTCDate(date.getUTCDate() + diff);
  return date;
}

// Validation functions

// February is null to handle the leap year (using ||)
var daysInMonths = (/* unused pure expression or super */ null && ([31, null, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31]));
function isLeapYearIndex(year) {
  return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
}
function validateDate(year, month, date) {
  return month >= 0 && month <= 11 && date >= 1 && date <= (daysInMonths[month] || (isLeapYearIndex(year) ? 29 : 28));
}
function validateDayOfYearDate(year, dayOfYear) {
  return dayOfYear >= 1 && dayOfYear <= (isLeapYearIndex(year) ? 366 : 365);
}
function validateWeekDate(_year, week, day) {
  return week >= 1 && week <= 53 && day >= 0 && day <= 6;
}
function validateTime(hours, minutes, seconds) {
  if (hours === 24) {
    return minutes === 0 && seconds === 0;
  }
  return seconds >= 0 && seconds < 60 && minutes >= 0 && minutes < 60 && hours >= 0 && hours < 25;
}
function validateTimezone(_hours, minutes) {
  return minutes >= 0 && minutes <= 59;
}

var formatDistanceLocale = {
  lessThanXSeconds: {
    one: '1초 미만',
    other: '{{count}}초 미만'
  },
  xSeconds: {
    one: '1초',
    other: '{{count}}초'
  },
  halfAMinute: '30초',
  lessThanXMinutes: {
    one: '1분 미만',
    other: '{{count}}분 미만'
  },
  xMinutes: {
    one: '1분',
    other: '{{count}}분'
  },
  aboutXHours: {
    one: '약 1시간',
    other: '약 {{count}}시간'
  },
  xHours: {
    one: '1시간',
    other: '{{count}}시간'
  },
  xDays: {
    one: '1일',
    other: '{{count}}일'
  },
  aboutXWeeks: {
    one: '약 1주',
    other: '약 {{count}}주'
  },
  xWeeks: {
    one: '1주',
    other: '{{count}}주'
  },
  aboutXMonths: {
    one: '약 1개월',
    other: '약 {{count}}개월'
  },
  xMonths: {
    one: '1개월',
    other: '{{count}}개월'
  },
  aboutXYears: {
    one: '약 1년',
    other: '약 {{count}}년'
  },
  xYears: {
    one: '1년',
    other: '{{count}}년'
  },
  overXYears: {
    one: '1년 이상',
    other: '{{count}}년 이상'
  },
  almostXYears: {
    one: '거의 1년',
    other: '거의 {{count}}년'
  }
};
var formatDistance = function formatDistance(token, count, options) {
  var result;
  var tokenValue = formatDistanceLocale[token];
  if (typeof tokenValue === 'string') {
    result = tokenValue;
  } else if (count === 1) {
    result = tokenValue.one;
  } else {
    result = tokenValue.other.replace('{{count}}', count.toString());
  }
  if (options !== null && options !== void 0 && options.addSuffix) {
    if (options.comparison && options.comparison > 0) {
      return result + ' 후';
    } else {
      return result + ' 전';
    }
  }
  return result;
};
var formatDistance$1 = formatDistance;

var dateFormats = {
  full: 'y년 M월 d일 EEEE',
  long: 'y년 M월 d일',
  medium: 'y.MM.dd',
  short: 'y.MM.dd'
};
var timeFormats = {
  full: 'a H시 mm분 ss초 zzzz',
  long: 'a H:mm:ss z',
  medium: 'HH:mm:ss',
  short: 'HH:mm'
};
var dateTimeFormats = {
  full: '{{date}} {{time}}',
  long: '{{date}} {{time}}',
  medium: '{{date}} {{time}}',
  short: '{{date}} {{time}}'
};
var formatLong = {
  date: buildFormatLongFn({
    formats: dateFormats,
    defaultWidth: 'full'
  }),
  time: buildFormatLongFn({
    formats: timeFormats,
    defaultWidth: 'full'
  }),
  dateTime: buildFormatLongFn({
    formats: dateTimeFormats,
    defaultWidth: 'full'
  })
};
var formatLong$1 = formatLong;

var formatRelativeLocale = {
  lastWeek: "'지난' eeee p",
  yesterday: "'어제' p",
  today: "'오늘' p",
  tomorrow: "'내일' p",
  nextWeek: "'다음' eeee p",
  other: 'P'
};
var formatRelative = function formatRelative(token, _date, _baseDate, _options) {
  return formatRelativeLocale[token];
};
var formatRelative$1 = formatRelative;

var eraValues = {
  narrow: ['BC', 'AD'],
  abbreviated: ['BC', 'AD'],
  wide: ['기원전', '서기']
};
var quarterValues = {
  narrow: ['1', '2', '3', '4'],
  abbreviated: ['Q1', 'Q2', 'Q3', 'Q4'],
  wide: ['1분기', '2분기', '3분기', '4분기']
};
var monthValues = {
  narrow: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12'],
  abbreviated: ['1월', '2월', '3월', '4월', '5월', '6월', '7월', '8월', '9월', '10월', '11월', '12월'],
  wide: ['1월', '2월', '3월', '4월', '5월', '6월', '7월', '8월', '9월', '10월', '11월', '12월']
};
var dayValues = {
  narrow: ['일', '월', '화', '수', '목', '금', '토'],
  short: ['일', '월', '화', '수', '목', '금', '토'],
  abbreviated: ['일', '월', '화', '수', '목', '금', '토'],
  wide: ['일요일', '월요일', '화요일', '수요일', '목요일', '금요일', '토요일']
};
var dayPeriodValues = {
  narrow: {
    am: '오전',
    pm: '오후',
    midnight: '자정',
    noon: '정오',
    morning: '아침',
    afternoon: '오후',
    evening: '저녁',
    night: '밤'
  },
  abbreviated: {
    am: '오전',
    pm: '오후',
    midnight: '자정',
    noon: '정오',
    morning: '아침',
    afternoon: '오후',
    evening: '저녁',
    night: '밤'
  },
  wide: {
    am: '오전',
    pm: '오후',
    midnight: '자정',
    noon: '정오',
    morning: '아침',
    afternoon: '오후',
    evening: '저녁',
    night: '밤'
  }
};
var formattingDayPeriodValues = {
  narrow: {
    am: '오전',
    pm: '오후',
    midnight: '자정',
    noon: '정오',
    morning: '아침',
    afternoon: '오후',
    evening: '저녁',
    night: '밤'
  },
  abbreviated: {
    am: '오전',
    pm: '오후',
    midnight: '자정',
    noon: '정오',
    morning: '아침',
    afternoon: '오후',
    evening: '저녁',
    night: '밤'
  },
  wide: {
    am: '오전',
    pm: '오후',
    midnight: '자정',
    noon: '정오',
    morning: '아침',
    afternoon: '오후',
    evening: '저녁',
    night: '밤'
  }
};
var ordinalNumber = function ordinalNumber(dirtyNumber, options) {
  var number = Number(dirtyNumber);
  var unit = String(options === null || options === void 0 ? void 0 : options.unit);
  switch (unit) {
    case 'minute':
    case 'second':
      return String(number);
    case 'date':
      return number + '일';
    default:
      return number + '번째';
  }
};
var localize = {
  ordinalNumber: ordinalNumber,
  era: buildLocalizeFn({
    values: eraValues,
    defaultWidth: 'wide'
  }),
  quarter: buildLocalizeFn({
    values: quarterValues,
    defaultWidth: 'wide',
    argumentCallback: function argumentCallback(quarter) {
      return quarter - 1;
    }
  }),
  month: buildLocalizeFn({
    values: monthValues,
    defaultWidth: 'wide'
  }),
  day: buildLocalizeFn({
    values: dayValues,
    defaultWidth: 'wide'
  }),
  dayPeriod: buildLocalizeFn({
    values: dayPeriodValues,
    defaultWidth: 'wide',
    formattingValues: formattingDayPeriodValues,
    defaultFormattingWidth: 'wide'
  })
};
var localize$1 = localize;

var matchOrdinalNumberPattern = /^(\d+)(일|번째)?/i;
var parseOrdinalNumberPattern = /\d+/i;
var matchEraPatterns = {
  narrow: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  wide: /^(기원전|서기)/i
};
var parseEraPatterns = {
  any: [/^(bc|기원전)/i, /^(ad|서기)/i]
};
var matchQuarterPatterns = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234]사?분기/i
};
var parseQuarterPatterns = {
  any: [/1/i, /2/i, /3/i, /4/i]
};
var matchMonthPatterns = {
  narrow: /^(1[012]|[123456789])/,
  abbreviated: /^(1[012]|[123456789])월/i,
  wide: /^(1[012]|[123456789])월/i
};
var parseMonthPatterns = {
  any: [/^1월?$/, /^2/, /^3/, /^4/, /^5/, /^6/, /^7/, /^8/, /^9/, /^10/, /^11/, /^12/]
};
var matchDayPatterns = {
  narrow: /^[일월화수목금토]/,
  short: /^[일월화수목금토]/,
  abbreviated: /^[일월화수목금토]/,
  wide: /^[일월화수목금토]요일/
};
var parseDayPatterns = {
  any: [/^일/, /^월/, /^화/, /^수/, /^목/, /^금/, /^토/]
};
var matchDayPeriodPatterns = {
  any: /^(am|pm|오전|오후|자정|정오|아침|저녁|밤)/i
};
var parseDayPeriodPatterns = {
  any: {
    am: /^(am|오전)/i,
    pm: /^(pm|오후)/i,
    midnight: /^자정/i,
    noon: /^정오/i,
    morning: /^아침/i,
    afternoon: /^오후/i,
    evening: /^저녁/i,
    night: /^밤/i
  }
};
var match = {
  ordinalNumber: buildMatchPatternFn({
    matchPattern: matchOrdinalNumberPattern,
    parsePattern: parseOrdinalNumberPattern,
    valueCallback: function valueCallback(value) {
      return parseInt(value, 10);
    }
  }),
  era: buildMatchFn({
    matchPatterns: matchEraPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseEraPatterns,
    defaultParseWidth: 'any'
  }),
  quarter: buildMatchFn({
    matchPatterns: matchQuarterPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseQuarterPatterns,
    defaultParseWidth: 'any',
    valueCallback: function valueCallback(index) {
      return index + 1;
    }
  }),
  month: buildMatchFn({
    matchPatterns: matchMonthPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseMonthPatterns,
    defaultParseWidth: 'any'
  }),
  day: buildMatchFn({
    matchPatterns: matchDayPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseDayPatterns,
    defaultParseWidth: 'any'
  }),
  dayPeriod: buildMatchFn({
    matchPatterns: matchDayPeriodPatterns,
    defaultMatchWidth: 'any',
    parsePatterns: parseDayPeriodPatterns,
    defaultParseWidth: 'any'
  })
};
var match$1 = match;

/**
 * @type {Locale}
 * @category Locales
 * @summary Korean locale.
 * @language Korean
 * @iso-639-2 kor
 * @author Hong Chulju [@angdev]{@link https://github.com/angdev}
 * @author Lee Seoyoen [@iamssen]{@link https://github.com/iamssen}
 * @author Taiki IKeda [@so99ynoodles]{@link https://github.com/so99ynoodles}
 */
var locale = {
  code: 'ko',
  formatDistance: formatDistance$1,
  formatLong: formatLong$1,
  formatRelative: formatRelative$1,
  localize: localize$1,
  match: match$1,
  options: {
    weekStartsOn: 0 /* Sunday */,
    firstWeekContainsDate: 1
  }
};
var ko = (/* unused pure expression or super */ null && (locale));

const DATE_FORMAT = 'M/d (EE)';

/**
 * 배송의 타입, 상태에 따라 배송 추적 날짜 정보를 반환합니다.
 * ex)
 *  M/d (EE) 도착예정
 *  M/d (EE) 도착완료
 *  M/d (EE) 수거예정
 *  M/d (EE) 수거완료 예정 , ...
 * @param param
 */
const getDeliveryTackingNoticeFormat = param => {
  const {
    date,
    deliveryStatus,
    deliveryTargetType,
    isWithinDue
  } = param;
  if (deliveryTargetType === DELIVERY_TARGET_TYPE.PICKUP) {
    return getPickupDateFormat({
      date,
      deliveryStatus
    });
  } else {
    return getOrderDeliveryFormat({
      date,
      isWithinDue,
      isCompleted: deliveryStatus === DELIVERY_TRACKING_STATUS.COMPLETE
    });
  }
};

/**
 * 배송/재배송시의 배송조회 예정 날짜 및 문구 포맷을 반환한다.
 * @param dayDiff 오늘과 배송예정 날짜의 차이
 * @param isCompleted 배송 완료 여부포맷
 * @param isWithinDue ~이내로 표시해야 하는지 여부 (해외배송, 판매자 직접 배송 등 배송일자가 밀릴 수 있는 경우)
 */
const getOrderDeliveryFormat = ({
  date,
  isCompleted,
  isWithinDue
}) => {
  const formatDate = format$1(date, DATE_FORMAT, {
    locale: ko
  });
  const dayDiff = differenceInCalendarDays(date, new Date());
  if (isCompleted) {
    return {
      due: formatDate,
      status: '도착완료',
      isDelayed: false
    };
  }
  if (dayDiff <= -1) {
    return {
      due: '',
      status: '배송지연중',
      isDelayed: true
    };
  }
  if (isWithinDue) {
    return {
      due: `${formatDate} 이내`,
      status: '도착예정',
      isDelayed: false
    };
  }
  let [monthAndDay, week] = formatDate.split(' ');
  if (dayDiff === 0) {
    monthAndDay = '오늘';
  } else if (dayDiff === 1) {
    monthAndDay = '내일';
  }
  return {
    due: `${monthAndDay} ${week}`,
    status: '도착예정',
    isDelayed: false
  };
};

/**
 * 수거관련 날짜 및 문구 포맷을 반환합니다.
 * @param deliveryStatus 배송상태
 * @param date 날짜
 */
const getPickupDateFormat = ({
  deliveryStatus,
  date
}) => {
  const formatDate = format$1(date, DATE_FORMAT, {
    locale: ko
  });
  const dayDiff = differenceInCalendarDays(date, new Date());
  if (deliveryStatus === DELIVERY_TRACKING_STATUS.COMPLETE) {
    return {
      due: formatDate,
      status: '수거완료',
      isDelayed: false
    };
  }
  if (deliveryStatus === DELIVERY_TRACKING_STATUS.SCHEDULED) {
    if (dayDiff <= -1) {
      return {
        due: '',
        status: '수거 지연중',
        isDelayed: true
      };
    }
    return {
      due: formatDate,
      status: '수거예정',
      isDelayed: false
    };
  }
  if (dayDiff <= -1) {
    return {
      due: '',
      status: '수거완료 지연중',
      isDelayed: true
    };
  }
  return {
    due: formatDate,
    status: '수거완료 예정',
    isDelayed: false
  };
};

function formatPhoneNumber(value) {
  return value.replace(/\D/g, '').replace(/(^02|^0505|^1[0-9]{3}|^0[0-9]{2})([0-9]+)?([0-9]{4})$/, '$1-$2-$3').replace('--', '-');
}

/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-explicit-any */
// Loads Kakao API on demand.
const KAKAO_API_SRC = '//developers.kakao.com/sdk/js/kakao.min.js';
const KAKAO_AUTH_TOKEN = '3019c756ec77dd7e0a24e56d9d784f77';
let kakaoAPILoading = null;
let initialized = false;
function getKakaoAPI() {
  if (typeof window === 'undefined') {
    return null;
  }
  return window.Kakao;
}
function loadKakaoAPI() {
  if (window.Kakao != null) {
    if (!initialized) {
      try {
        Kakao.init(KAKAO_AUTH_TOKEN);
      } catch (e) {
        //
      }
      initialized = true;
    }
    return Promise.resolve(window.Kakao);
  } else if (kakaoAPILoading != null) {
    return kakaoAPILoading;
  } else {
    kakaoAPILoading = new Promise(resolve => {
      // Load the script from daum...
      const script = document.createElement('script');
      script.addEventListener('load', () => {
        const Kakao = window.Kakao;
        Kakao.init(KAKAO_AUTH_TOKEN);
        initialized = true;
        resolve(Kakao);
      });
      script.src = KAKAO_API_SRC;
      document.body.appendChild(script);
    });
    return kakaoAPILoading;
  }
}
function useKakaoAPI(onUpdate) {
  const [loaded, setLoaded] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false);
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    if (!loaded) {
      loadKakaoAPI().then(() => {
        setLoaded(true);
        if (onUpdate != null) {
          onUpdate();
        }
      });
    }
  }, []);
  return getKakaoAPI();
}

const USP_BADGE_EXPERIMENT_KEY = 1005;
const useUspBadgeExperimentType = () => {
  const {
    experimentType = 'A',
    pending
  } = (0,_bucketplace_xpc_sdk__WEBPACK_IMPORTED_MODULE_1__/* .useExperimentType */ .XB)({
    type: 'AB',
    experimentKey: USP_BADGE_EXPERIMENT_KEY
  });
  return {
    experimentType: experimentType.toUpperCase(),
    pending
  };
};

var __defProp$1 = Object.defineProperty;
var __defNormalProp$1 = (obj, key, value) => key in obj ? __defProp$1(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => __defNormalProp$1(obj, typeof key !== "symbol" ? key + "" : key, value);

// src/observe.ts
var observerMap = /* @__PURE__ */ new Map();
var RootIds = /* @__PURE__ */ new WeakMap();
var rootId = 0;
var unsupportedValue = void 0;
function getRootId(root) {
  if (!root) return "0";
  if (RootIds.has(root)) return RootIds.get(root);
  rootId += 1;
  RootIds.set(root, rootId.toString());
  return RootIds.get(root);
}
function optionsToId(options) {
  return Object.keys(options).sort().filter(
    (key) => options[key] !== void 0
  ).map((key) => {
    return `${key}_${key === "root" ? getRootId(options.root) : options[key]}`;
  }).toString();
}
function createObserver(options) {
  const id = optionsToId(options);
  let instance = observerMap.get(id);
  if (!instance) {
    const elements = /* @__PURE__ */ new Map();
    let thresholds;
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        var _a;
        const inView = entry.isIntersecting && thresholds.some((threshold) => entry.intersectionRatio >= threshold);
        if (options.trackVisibility && typeof entry.isVisible === "undefined") {
          entry.isVisible = inView;
        }
        (_a = elements.get(entry.target)) == null ? void 0 : _a.forEach((callback) => {
          callback(inView, entry);
        });
      });
    }, options);
    thresholds = observer.thresholds || (Array.isArray(options.threshold) ? options.threshold : [options.threshold || 0]);
    instance = {
      id,
      observer,
      elements
    };
    observerMap.set(id, instance);
  }
  return instance;
}
function observe(element, callback, options = {}, fallbackInView = unsupportedValue) {
  if (typeof window.IntersectionObserver === "undefined" && fallbackInView !== void 0) {
    const bounds = element.getBoundingClientRect();
    callback(fallbackInView, {
      isIntersecting: fallbackInView,
      target: element,
      intersectionRatio: typeof options.threshold === "number" ? options.threshold : 0,
      time: 0,
      boundingClientRect: bounds,
      intersectionRect: bounds,
      rootBounds: bounds
    });
    return () => {
    };
  }
  const { id, observer, elements } = createObserver(options);
  const callbacks = elements.get(element) || [];
  if (!elements.has(element)) {
    elements.set(element, callbacks);
  }
  callbacks.push(callback);
  observer.observe(element);
  return function unobserve() {
    callbacks.splice(callbacks.indexOf(callback), 1);
    if (callbacks.length === 0) {
      elements.delete(element);
      observer.unobserve(element);
    }
    if (elements.size === 0) {
      observer.disconnect();
      observerMap.delete(id);
    }
  };
}

// src/InView.tsx
function isPlainChildren(props) {
  return typeof props.children !== "function";
}
var InView = class extends react__WEBPACK_IMPORTED_MODULE_0__.Component {
  constructor(props) {
    super(props);
    __publicField(this, "node", null);
    __publicField(this, "_unobserveCb", null);
    __publicField(this, "handleNode", (node) => {
      if (this.node) {
        this.unobserve();
        if (!node && !this.props.triggerOnce && !this.props.skip) {
          this.setState({ inView: !!this.props.initialInView, entry: void 0 });
        }
      }
      this.node = node ? node : null;
      this.observeNode();
    });
    __publicField(this, "handleChange", (inView, entry) => {
      if (inView && this.props.triggerOnce) {
        this.unobserve();
      }
      if (!isPlainChildren(this.props)) {
        this.setState({ inView, entry });
      }
      if (this.props.onChange) {
        this.props.onChange(inView, entry);
      }
    });
    this.state = {
      inView: !!props.initialInView,
      entry: void 0
    };
  }
  componentDidMount() {
    this.unobserve();
    this.observeNode();
  }
  componentDidUpdate(prevProps) {
    if (prevProps.rootMargin !== this.props.rootMargin || prevProps.root !== this.props.root || prevProps.threshold !== this.props.threshold || prevProps.skip !== this.props.skip || prevProps.trackVisibility !== this.props.trackVisibility || prevProps.delay !== this.props.delay) {
      this.unobserve();
      this.observeNode();
    }
  }
  componentWillUnmount() {
    this.unobserve();
  }
  observeNode() {
    if (!this.node || this.props.skip) return;
    const {
      threshold,
      root,
      rootMargin,
      trackVisibility,
      delay,
      fallbackInView
    } = this.props;
    this._unobserveCb = observe(
      this.node,
      this.handleChange,
      {
        threshold,
        root,
        rootMargin,
        // @ts-ignore
        trackVisibility,
        // @ts-ignore
        delay
      },
      fallbackInView
    );
  }
  unobserve() {
    if (this._unobserveCb) {
      this._unobserveCb();
      this._unobserveCb = null;
    }
  }
  render() {
    const { children } = this.props;
    if (typeof children === "function") {
      const { inView, entry } = this.state;
      return children({ inView, entry, ref: this.handleNode });
    }
    const {
      as,
      triggerOnce,
      threshold,
      root,
      rootMargin,
      onChange,
      skip,
      trackVisibility,
      delay,
      initialInView,
      fallbackInView,
      ...props
    } = this.props;
    return react__WEBPACK_IMPORTED_MODULE_0__.createElement(
      as || "div",
      { ref: this.handleNode, ...props },
      children
    );
  }
};
function useInView({
  threshold,
  delay,
  trackVisibility,
  rootMargin,
  root,
  triggerOnce,
  skip,
  initialInView,
  fallbackInView,
  onChange
} = {}) {
  var _a;
  const [ref, setRef] = react__WEBPACK_IMPORTED_MODULE_0__.useState(null);
  const callback = react__WEBPACK_IMPORTED_MODULE_0__.useRef();
  const [state, setState] = react__WEBPACK_IMPORTED_MODULE_0__.useState({
    inView: !!initialInView,
    entry: void 0
  });
  callback.current = onChange;
  react__WEBPACK_IMPORTED_MODULE_0__.useEffect(
    () => {
      if (skip || !ref) return;
      let unobserve;
      unobserve = observe(
        ref,
        (inView, entry) => {
          setState({
            inView,
            entry
          });
          if (callback.current) callback.current(inView, entry);
          if (entry.isIntersecting && triggerOnce && unobserve) {
            unobserve();
            unobserve = void 0;
          }
        },
        {
          root,
          rootMargin,
          threshold,
          // @ts-ignore
          trackVisibility,
          // @ts-ignore
          delay
        },
        fallbackInView
      );
      return () => {
        if (unobserve) {
          unobserve();
        }
      };
    },
    // We break the rule here, because we aren't including the actual `threshold` variable
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
      // If the threshold is an array, convert it to a string, so it won't change between renders.
      Array.isArray(threshold) ? threshold.toString() : threshold,
      ref,
      root,
      rootMargin,
      triggerOnce,
      skip,
      trackVisibility,
      fallbackInView,
      delay
    ]
  );
  const entryTarget = (_a = state.entry) == null ? void 0 : _a.target;
  const previousEntryTarget = react__WEBPACK_IMPORTED_MODULE_0__.useRef();
  if (!ref && entryTarget && !triggerOnce && !skip && previousEntryTarget.current !== entryTarget) {
    previousEntryTarget.current = entryTarget;
    setState({
      inView: !!initialInView,
      entry: void 0
    });
  }
  const result = [setRef, state.inView, state.entry];
  result.ref = result[0];
  result.inView = result[1];
  result.entry = result[2];
  return result;
}

var E$1 = Object.create;
var h = Object.defineProperty;
var T$1 = Object.getOwnPropertyDescriptor;
var K = Object.getOwnPropertyNames;
var C$1 = Object.getPrototypeOf,
  F = Object.prototype.hasOwnProperty;
var V$1 = (e, o) => () => (o || e((o = {
  exports: {}
}).exports, o), o.exports);
var q = (e, o, n, s) => {
  if (o && typeof o == "object" || typeof o == "function") for (let i of K(o)) !F.call(e, i) && i !== n && h(e, i, {
    get: () => o[i],
    enumerable: !(s = T$1(o, i)) || s.enumerable
  });
  return e;
};
var A$1 = (e, o, n) => (n = e != null ? E$1(C$1(e)) : {}, q(o || !e || !e.__esModule ? h(n, "default", {
  value: e,
  enumerable: !0
}) : n, e));
var k = V$1((b, p) => {
  (function (e) {
    var o = function (t, r, a) {
        if (!I(r) || j(r) || O(r) || B(r) || P(r)) return r;
        var c,
          u = 0,
          y = 0;
        if (U(r)) for (c = [], y = r.length; u < y; u++) c.push(o(t, r[u], a));else {
          c = {};
          for (var w in r) Object.prototype.hasOwnProperty.call(r, w) && (c[t(w, a)] = o(t, r[w], a));
        }
        return c;
      },
      n = function (t, r) {
        r = r || {};
        var a = r.separator || "_",
          c = r.split || /(?=[A-Z])/;
        return t.split(c).join(a);
      },
      s = function (t) {
        return R(t) ? t : (t = t.replace(/[\-_\s]+(.)?/g, function (r, a) {
          return a ? a.toUpperCase() : "";
        }), t.substr(0, 1).toLowerCase() + t.substr(1));
      },
      i = function (t) {
        var r = s(t);
        return r.substr(0, 1).toUpperCase() + r.substr(1);
      },
      l = function (t, r) {
        return n(t, r).toLowerCase();
      },
      g = Object.prototype.toString,
      P = function (t) {
        return typeof t == "function";
      },
      I = function (t) {
        return t === Object(t);
      },
      U = function (t) {
        return g.call(t) == "[object Array]";
      },
      j = function (t) {
        return g.call(t) == "[object Date]";
      },
      O = function (t) {
        return g.call(t) == "[object RegExp]";
      },
      B = function (t) {
        return g.call(t) == "[object Boolean]";
      },
      R = function (t) {
        return t = t - 0, t === t;
      },
      m = function (t, r) {
        var a = r && "process" in r ? r.process : r;
        return typeof a != "function" ? t : function (c, u) {
          return a(c, t, u);
        };
      },
      d = {
        camelize: s,
        decamelize: l,
        pascalize: i,
        depascalize: l,
        camelizeKeys: function (t, r) {
          return o(m(s, r), t);
        },
        decamelizeKeys: function (t, r) {
          return o(m(l, r), t, r);
        },
        pascalizeKeys: function (t, r) {
          return o(m(i, r), t);
        },
        depascalizeKeys: function () {
          return this.decamelizeKeys.apply(this, arguments);
        }
      };
    typeof define == "function" && __webpack_require__.amdO ? define(d) : typeof p < "u" && p.exports ? p.exports = d : e.humps = d;
  })(b);
});
var z = A$1(k());
function x$1(e, o) {
  let n = {};
  for (let s in e) Object.prototype.hasOwnProperty.call(e, s) && o(e[s], s) && (n[s] = e[s]);
  return n;
}
var f$1 = e => x$1({
    data: e.data,
    category: e.category,
    object_section: e.section,
    object_section_id: e.section_id,
    object_section_idx: e.section_idx,
    object_type: e.type && (0, z.decamelize)(e.type.toLowerCase()),
    object_id: e.id,
    object_idx: e.index,
    object_url: e.url,
    page_id: e.page_id,
    page_params: e.page_params
  }, o => o != null),
  L = e => {
    window.bucketLog = window.bucketLog || [], window.bucketLog.push(f$1(e));
  },
  M$1 = e => {
    let o = window.bucketLog;
    return o && o.get ? o.get(e) : null;
  };
function H(e) {
  L({
    category: "impression",
    data: [{
      ...f$1(e),
      time: Date.now()
    }]
  });
}
function ce({
  logData: e,
  threshold: o,
  disable: n
}) {
  let {
    ref: s,
    inView: i
  } = useInView({
    threshold: o,
    skip: n,
    triggerOnce: !0
  });
  return (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    if (i && !n && e) {
      let {
        category: l,
        ...g
      } = e;
      H(g), L({
        category: "impression",
        data: [{
          ...f$1(g),
          time: Date.now()
        }]
      });
    }
  }, [i, n, e]), {
    ref: s
  };
}

/**
 * 뱃지 관련 로그 데이터 가공을 위한 hooks
 */
function useProductCardLogData({
  product,
  badgeMaxCount
}) {
  const {
    benefitBadges,
    couponBadge,
    deliveryServiceCode,
    isOverseasPurchase,
    isFreeDelivery,
    isSpecialPrice,
    isSoldOut,
    isSelling,
    isDiscontinued,
    price
  } = product;
  const badgeLogData = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(() => {
    const initialData = {
      isOverseasPurchase,
      isFreeDelivery,
      isSpecialPrice
    };
    if (isDiscontinued || !isSelling) {
      return {};
    }
    if (badgeMaxCount != null && Object.values(initialData).filter(val => !!val).length > badgeMaxCount) {
      return Object.keys(initialData).filter(val => !!val).slice(0, badgeMaxCount).reduce((acc, cur) => ({
        ...acc,
        [cur]: initialData[cur]
      }), {});
    }
    return initialData;
  }, [badgeMaxCount, isDiscontinued, isSelling, isOverseasPurchase, isFreeDelivery, isSpecialPrice]);
  const {
    regularPrice,
    sellingPrice,
    salePrice,
    discountPlans
  } = price ?? {};
  const hasInstantDiscount = discountPlans?.[0]?.planType === 'INSTANT_DISCOUNT';
  const instantDiscountPrice = Number(salePrice) - (hasInstantDiscount ? Number(discountPlans?.[0]?.discountAmount) : 0);
  const _detailLogData = {
    delivery_service_code: deliveryServiceCode,
    is_overseas_purchase: badgeLogData['isOverseasPurchase'] ?? false,
    is_free_delivery: badgeLogData['isFreeDelivery'] ?? false,
    is_special_price: badgeLogData['isSpecialPrice'] ?? false,
    is_soldout: isSoldOut,
    is_discontinued: isDiscontinued,
    is_selling: isSelling,
    coupon_badge: couponBadge != null ? {
      fixed_discount_amount: couponBadge?.fixedDiscountAmount,
      discount_ratio: Math.round(Number(couponBadge?.discountRatio ?? '0') * 100),
      display_text: couponBadge?.title
    } : undefined,
    card_promotion: benefitBadges?.[0] != null ? {
      fixed_discount_amount: benefitBadges?.[0]?.fixedDiscountAmount,
      discount_ratio: benefitBadges?.[0]?.discountRatio,
      display_text: benefitBadges?.[0]?.title,
      promotion_payment_method: benefitBadges?.[0]?.promotionPaymentMethod
    } : undefined,
    instant_discount_text_display: false,
    ...(hasInstantDiscount && {
      instant_discount_id: discountPlans?.[0]?.planId,
      instant_discount: {
        fixed_discount_amount: discountPlans?.[0]?.discountAmount ?? null,
        discount_ratio: null
      },
      instant_discount_price: instantDiscountPrice ?? null
    }),
    regular_price: regularPrice ?? null,
    sale_price: salePrice ?? null,
    selling_price: sellingPrice ?? null
  };
  const detailLogData = Object.fromEntries(Object.entries(_detailLogData).filter(([_, v]) => v != null));
  return {
    detailLogData
  };
}

var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof __webpack_require__.g !== 'undefined' ? __webpack_require__.g : typeof self !== 'undefined' ? self : {};

function getDefaultExportFromCjs$1 (x) {
	return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}

function getAugmentedNamespace(n) {
  if (n.__esModule) return n;
  var f = n.default;
	if (typeof f == "function") {
		var a = function a () {
			if (this instanceof a) {
        return Reflect.construct(f, arguments, this.constructor);
			}
			return f.apply(this, arguments);
		};
		a.prototype = f.prototype;
  } else a = {};
  Object.defineProperty(a, '__esModule', {value: true});
	Object.keys(n).forEach(function (k) {
		var d = Object.getOwnPropertyDescriptor(n, k);
		Object.defineProperty(a, k, d.get ? d : {
			enumerable: true,
			get: function () {
				return n[k];
			}
		});
	});
	return a;
}

var classnames = {exports: {}};

/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
(function (module) {
  /* global define */

  (function () {

    var hasOwn = {}.hasOwnProperty;
    function classNames() {
      var classes = '';
      for (var i = 0; i < arguments.length; i++) {
        var arg = arguments[i];
        if (arg) {
          classes = appendClass(classes, parseValue(arg));
        }
      }
      return classes;
    }
    function parseValue(arg) {
      if (typeof arg === 'string' || typeof arg === 'number') {
        return arg;
      }
      if (typeof arg !== 'object') {
        return '';
      }
      if (Array.isArray(arg)) {
        return classNames.apply(null, arg);
      }
      if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes('[native code]')) {
        return arg.toString();
      }
      var classes = '';
      for (var key in arg) {
        if (hasOwn.call(arg, key) && arg[key]) {
          classes = appendClass(classes, key);
        }
      }
      return classes;
    }
    function appendClass(value, newClass) {
      if (!newClass) {
        return value;
      }
      if (value) {
        return value + ' ' + newClass;
      }
      return value + newClass;
    }
    if (module.exports) {
      classNames.default = classNames;
      module.exports = classNames;
    } else {
      window.classNames = classNames;
    }
  })();
})(classnames);
var classnamesExports = classnames.exports;
var classNames = /*@__PURE__*/getDefaultExportFromCjs$1(classnamesExports);

function PlaceholderAnimation(props) {
  const {
    children,
    className
  } = props;
  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(Container$y, {
    className: className,
    children: children
  });
}
const keyframesPlaceholderAnimation = _emotion_react__WEBPACK_IMPORTED_MODULE_6__/* .keyframes */ .F4`
  0% {
    transform: translate3d(-30%, 0, 0);
  }
  100% {
    transform: translate3d(30%, 0, 0);
  }
`;
const Container$y = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)("div",  true ? {
  target: "e2uolej0"
} : 0)("position:relative;display:block;overflow:hidden;", ({
  theme
}) => /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_6__/* .css */ .iv)("color:", theme.content.base5, ";background-color:", theme.content.base5, ";" + ( true ? "" : 0),  true ? "" : 0), " &:after{content:'\\00a0';position:absolute;top:0;right:0;bottom:0;left:50%;z-index:1;width:500%;margin-left:-250%;animation:", keyframesPlaceholderAnimation, " 0.8s linear infinite;background:linear-gradient(to right,\n      rgba(255, 255, 255, 0) 44%,\n      rgba(255, 255, 255, .35) 50%,\n      rgba(255, 255, 255, 0) 56%) 50% 50%;}" + ( true ? "" : 0));

function _EMOTION_STRINGIFIED_CSS_ERROR__$$() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
function Price(props) {
  const {
    originalPrice,
    sellingPrice,
    isDiscontinued,
    isSoldOut,
    variant = 'lg',
    renderSuffix,
    currency,
    priceToken
  } = props;
  const disabled = !isDiscontinued && isSoldOut;
  const discountRate = Math.floor((originalPrice - sellingPrice) / originalPrice * 100);
  const isGlobal = !!currency;
  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsxs */ .BX)(Container$x, {
    className: "price",
    children: [discountRate > 0 && originalPrice > 0 && (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsxs */ .BX)(Rate, {
      disabled: disabled,
      variant: variant,
      children: [discountRate, (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)("span", {
        className: "percentage",
        children: '% '
      })]
    }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsxs */ .BX)(Amount, {
      disabled: disabled,
      variant: variant,
      children: [formatComma(sellingPrice), renderSuffix != null && renderSuffix()]
    }), isGlobal && priceToken && (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(EsportsToken, {
      children: priceToken
    })]
  });
}
function PricePlaceholder(props) {
  const {
    className
  } = props;
  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(Placeholder$1, {
    className: className
  });
}
const Container$x = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)("div",  true ? {
  target: "e175igv94"
} : 0)( true ? {
  name: "14q3hbk",
  styles: "display:flex;align-items:center;flex-wrap:wrap;margin-top:4px"
} : 0);
const getPriceFontStyle = variant => {
  switch (variant) {
    case 'sm':
      return _bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.F.caption1;
    case 'md':
      return _bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.F.subTitle2;
    default:
      return _bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.F.title3;
  }
};
var _ref2$9 =  true ? {
  name: "zw93mq",
  styles: "opacity:0.26"
} : 0;
const Rate = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)("span",  true ? {
  target: "e175igv93"
} : 0)(({
  variant
}) => getPriceFontStyle(variant), ";font-weight:bold;margin-right:2px;color:", ({
  theme
}) => theme.content.primary1.basic, ";", ({
  disabled
}) => disabled && _ref2$9, ";" + ( true ? "" : 0));
var _ref$t =  true ? {
  name: "5b2tzs",
  styles: "opacity:0.14"
} : 0;
const Amount = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)("span",  true ? {
  target: "e175igv92"
} : 0)(({
  variant
}) => getPriceFontStyle(variant), ";font-weight:700;color:#2F3438;", ({
  disabled
}) => disabled && _ref$t, ";" + ( true ? "" : 0));
const Placeholder$1 = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(PlaceholderAnimation,  true ? {
  target: "e175igv91"
} : 0)( true ? {
  name: "1l6via1",
  styles: "font-size:17px;line-height:23px;&:before{content:'\\00a0';}"
} : 0);
const EsportsToken = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)("span",  true ? {
  target: "e175igv90"
} : 0)(_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.F.caption1, " color:", ({
  theme
}) => theme.content.base2, ";margin-left:2px;" + ( true ? "" : 0));

function _EMOTION_STRINGIFIED_CSS_ERROR__$_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
const STATS_TYPES = {
  review(stats) {
    return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsxs */ .BX)(_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .Fragment */ .HY, {
      children: [(0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(_bucketplace_design_system_bds__WEBPACK_IMPORTED_MODULE_8__/* .Icon */ .JO$, {
        name: "star",
        className: "icon",
        size: 12
      }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)("strong", {
        className: "avg",
        children: stats.reviewAvg != null ? Math.round(stats.reviewAvg * 10) / 10 : 0
      }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)("span", {
        className: "count",
        children: `리뷰 ${formatComma(stats.reviewCount || 0)}`
      })]
    });
  },
  scrap(stats) {
    return `스크랩 ${formatComma(stats.scrapCount || 0)}`;
  }
};
function getStatsType({
  stats,
  isMdPick,
  hideReview
}) {
  if (stats.reviewCount != null && stats.reviewCount >= 1 && !hideReview) {
    return 'review';
  }
  if (stats.scrapCount != null && stats.scrapCount >= 1 && !isMdPick) {
    return 'scrap';
  }
  return null;
}
function Stats(props) {
  const {
    stats,
    isMdPick,
    hideReview,
    hideStats
  } = props;
  const {
    type = getStatsType({
      stats,
      isMdPick,
      hideReview
    })
  } = props;
  if (type == null || hideStats) {
    return null;
  }
  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(Container$w, {
    className: type,
    children: STATS_TYPES[type](stats)
  });
}
function StatsPlaceholder(props) {
  const {
    className
  } = props;
  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(Placeholder, {
    className: className
  });
}
const Container$w = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)("div",  true ? {
  target: "eib94ex1"
} : 0)( true ? {
  name: "tk8sp3",
  styles: "font-size:12px;line-height:16px;color:#828C94;display:flex;align-items:center;margin-top:4px;&.review{>.icon{color:#35C5F0;width:1.1em;height:1.1em;margin-right:1px;vertical-align:-2px;}>.avg{margin-right:4px;color:#2F3438;}>.count{font-size:12px;line-height:16px;font-weight:normal;color:#828C94;}}"
} : 0);
const Placeholder = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(PlaceholderAnimation,  true ? {
  target: "eib94ex0"
} : 0)(_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.F.caption1, ";&:before{content:'\\00a0';}" + ( true ? "" : 0));

var OhouseDeliveryIcon = "data:image/png;base64,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";

var ThirdPartyApplianceIcon = "data:image/png;base64,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";

var ThirdPartyFurnitureIcon = "data:image/png;base64,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";

var DepartureTodayIcon = "data:image/png;base64,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";

function _EMOTION_STRINGIFIED_CSS_ERROR__$Z() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
function shouldShowDeliveryBadge(product) {
  const {
    deliveryServiceCode,
    isDepartureToday
  } = product;
  const showBadge = [DELIVERY_SERVICE_CODE.OHOUSE, DELIVERY_SERVICE_CODE.THIRD_PARTY_APPLIANCE, DELIVERY_SERVICE_CODE.THIRD_PARTY_FURNITURE].some(code => code === deliveryServiceCode ?? DELIVERY_SERVICE_CODE.NONE);
  return Boolean(showBadge || isDepartureToday);
}
function DeliveryBadge({
  deliveryServiceCode = DELIVERY_SERVICE_CODE.NONE,
  isDepartureToday
}) {
  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsxs */ .BX)(Container$v, {
    children: [deliveryServiceCode === DELIVERY_SERVICE_CODE.OHOUSE && (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)("img", {
      src: OhouseDeliveryIcon,
      className: "icon",
      alt: "\uC624\uB298\uC758\uC9D1\uBC30\uC1A1\uBC43\uC9C0"
    }), deliveryServiceCode === DELIVERY_SERVICE_CODE.THIRD_PARTY_APPLIANCE && (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)("img", {
      src: ThirdPartyApplianceIcon,
      className: "icon",
      alt: "\uBE60\uB978\uAC00\uC804\uBC30\uC1A1\uBC43\uC9C0"
    }), deliveryServiceCode === DELIVERY_SERVICE_CODE.THIRD_PARTY_FURNITURE && (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)("img", {
      src: ThirdPartyFurnitureIcon,
      className: "icon",
      alt: "\uBE60\uB978\uAC00\uAD6C\uBC30\uC1A1\uBC43\uC9C0"
    }), isDepartureToday && (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)("img", {
      src: DepartureTodayIcon,
      className: "icon",
      alt: "\uC624\uB298\uCD9C\uBC1C\uBC43\uC9C0"
    })]
  });
}
const Container$v = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)("div",  true ? {
  target: "e1l7cet60"
} : 0)( true ? {
  name: "1vaw5w5",
  styles: "display:flex;margin-top:4px;>.icon{width:auto;height:15px;}"
} : 0);

function DeliveryStartAt({
  deliveryStartAt
}) {
  const {
    template
  } = deliveryStartAt;
  const {
    text,
    values
  } = template;
  const startAt = text.replace('%s', values[0] ?? '');
  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(Text$1, {
    children: startAt
  });
}
const Text$1 = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)("span",  true ? {
  target: "enkhhyt0"
} : 0)("display:inline-block;margin-top:4px;", _bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.F.caption1, ";color:", ({
  theme
}) => theme.content.primary4.basic, ";" + ( true ? "" : 0));

var _rect, _path$5;
function _extends$b() { return _extends$b = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$b.apply(null, arguments); }
var SvgProductBadgeCheapestPrice = function SvgProductBadgeCheapestPrice(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends$b({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 20
  }, props), _rect || (_rect = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("rect", {
    width: 30,
    height: 20,
    fill: "#F77",
    rx: 4
  })), _path$5 || (_path$5 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: "#fff",
    d: "M12.83 7.93v-.97h-4.9v-.555h5.228v-.991H6.655v4.063h6.59v-.992H7.928V7.93zm-6.295 3.747v1.002h5.326v2.037h1.274v-3.04zm7.733-.588v-1.024H5.5v1.024zm9.642-1.307V8.725h-1.405V5H21.24v9.705h1.264V9.782h1.405zm-3.954-3.79h-4.53v1.056h3.147c-.174 1.938-1.623 3.975-3.736 4.945l.773.958c2.974-1.612 4.259-4.03 4.346-6.96z"
  })));
};

var _g$3;
function _extends$a() { return _extends$a = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$a.apply(null, arguments); }
var SvgProductBadgeFreeDelivery = function SvgProductBadgeFreeDelivery(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends$a({
    xmlns: "http://www.w3.org/2000/svg",
    width: 47,
    height: 20
  }, props), _g$3 || (_g$3 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("rect", {
    width: 47,
    height: 20,
    fill: "#EAEDEF",
    fillRule: "nonzero",
    rx: 4
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: "#828C94",
    d: "M12.73 5.38v3.96h-6.6V5.38zm-2.68 9.43H8.76v-3.25H5v-1.03h8.86v1.03h-3.81zm1.4-6.49V6.41H7.43v1.91h4.04zm11.08 2.7h-1.42v1.54h2.26v1.02h-8.86v-1.02h2.24v-1.53h-1.1V7.78h5.32V6.65H15.6V5.63h6.66V8.8h-5.33v1.18h5.61v1.04zm-4.53 0v1.54h1.87v-1.53H18zm14.37 3.78h-1.23V9.86h-.8v4.49h-1.2V5.18h1.2v3.66h.8V5h1.23zm-4.2-2.54h-3.9V6.01h1.27v2.26h1.36V6h1.28v6.26zm-1.27-1.01v-2h-1.36v2zm14.49 1.71c0 1.13-1.25 1.82-3.41 1.82s-3.42-.7-3.42-1.82 1.25-1.82 3.4-1.82c2.18 0 3.43.7 3.43 1.82m-3.41-6.05c-.5 1.13-2.1 1.9-3.51 2.1l-.54-1c1.64-.17 3.39-1.06 3.39-2.54V5.2h1.33v.28c0 1.48 1.99 2.47 3.4 2.53l-.55 1.01c-1.31-.18-3.03-.97-3.52-2.1zm4.42 3.78h-8.86V9.66h3.79V8.4h1.29v1.26h3.78zm-2.33 2.27c0-.5-.83-.8-2.1-.8s-2.08.3-2.08.8c0 .51.81.8 2.08.8s2.1-.29 2.1-.8"
  }))));
};

var _g$2;
function _extends$9() { return _extends$9 = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$9.apply(null, arguments); }
var SvgProductBadgeNonSelling = function SvgProductBadgeNonSelling(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends$9({
    xmlns: "http://www.w3.org/2000/svg",
    width: 37,
    height: 20
  }, props), _g$2 || (_g$2 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("rect", {
    width: 37,
    height: 20,
    fill: "#000",
    opacity: 0.07,
    rx: 4
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: "#757575",
    fillRule: "nonzero",
    d: "M12.66 14.8h-1.3V5h1.3zm-4.3-3.52V6.93H6.29v4.35h2.06zm1.3-5.38v6.4H5V5.9h4.65zm12.51 8.78H15.7v-3.94h1.29v.98h3.9v-.99h1.3v3.95zm-1.29-1.02v-.95h-3.9v.95zm1.28-3.43h-1.28V5h1.28v5.22zm-7.78-2.47c0-1.34 1.11-2.34 2.6-2.34 1.5 0 2.6.98 2.6 2.34 0 1.39-1.1 2.25-2.6 2.25-1.49 0-2.6-.86-2.6-2.25m1.3-.01c0 .76.57 1.2 1.3 1.2.71 0 1.3-.44 1.3-1.2 0-.81-.56-1.26-1.3-1.26s-1.3.48-1.3 1.26m16 6.93h-6.5v-3.62h6.5zm-7.76-8V5.63h5.17v1.05h-1.88a3.05 3.05 0 0 0 2.18 2.69l-.7 1a4.2 4.2 0 0 1-2.13-1.92 3.92 3.92 0 0 1-2.28 2.22l-.76-1.02c1.37-.5 2.3-1.54 2.37-2.97zm7.77 3.9h-1.3V8.4h-1.44V7.36h1.45V5h1.29v5.59zm-1.3 3.1v-1.63h-3.94v1.63h3.95z"
  }))));
};

var _g$1;
function _extends$8() { return _extends$8 = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$8.apply(null, arguments); }
var SvgProductBadgeDiscontinued = function SvgProductBadgeDiscontinued(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends$8({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27,
    height: 20
  }, props), _g$1 || (_g$1 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("rect", {
    width: 27,
    height: 20,
    fill: "#EAEDEF",
    rx: 4
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: "#828C94",
    fillRule: "nonzero",
    d: "M13.38 8.8h-1.4v3.34h-1.3V5.07h1.3v2.67h1.4zm-1.16 5.78H5.7v-3.12H7v2.09h5.22zm-6.3-5.11c1.43 0 2.83-.08 3.84-.29.05.33.11.66.18.98-.92.22-2.53.34-4.33.34h-.96V5.87h4.37v1.01h-3.1zm15.77 3.57c0 1.14-1.25 1.83-3.41 1.83s-3.42-.7-3.42-1.83c0-1.1 1.25-1.8 3.4-1.8 2.18 0 3.43.7 3.43 1.8m.6-4.91-.56 1c-1.37-.11-2.9-.87-3.45-1.85-.49 1-1.92 1.75-3.47 1.87l-.53-1c1.49-.08 2.83-.74 3.22-1.7h-2.76v-1h7.1v1h-2.76c.43.97 1.94 1.63 3.2 1.68zm.41 2.67h-8.86V9.76h3.77V8.54h1.28v1.24h3.81v1.03zm-2.33 2.25c0-.5-.83-.8-2.1-.8s-2.08.3-2.08.8.81.8 2.08.8 2.1-.3 2.1-.8"
  }))));
};

var _g;
function _extends$7() { return _extends$7 = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$7.apply(null, arguments); }
var SvgProductBadgeOverseasPurchase = function SvgProductBadgeOverseasPurchase(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends$7({
    xmlns: "http://www.w3.org/2000/svg",
    width: 47,
    height: 20
  }, props), _g || (_g = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("rect", {
    width: 47,
    height: 20,
    fill: "#EAEDEF",
    rx: 4
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: "#828C94",
    fillRule: "nonzero",
    d: "M13.349 14.801h-1.221V9.994h-.814v4.356h-1.199V5.176h1.199V8.96h.814V5h1.221zm-3.85-4.037c0 1.232-.869 2.035-2.145 2.035-1.265 0-2.145-.869-2.145-2.035 0-1.243.891-2.035 2.145-2.035 1.276 0 2.145.803 2.145 2.035M5 8.366V7.343h4.675v1.023zm3.344 2.398c0-.605-.418-1.023-.99-1.023-.561 0-.979.418-.979 1.023 0 .616.418 1.023.979 1.023.572 0 .99-.429.99-1.023M6.067 6.782V5.759h2.64v1.023zm14.861 5.797c-1.694.209-4.29.341-6.127.341a34 34 0 0 1-.187-1.034c.825 0 1.65 0 2.442-.022v-1.562c-1.177-.209-2.002-1.045-2.002-2.233 0-1.364 1.122-2.387 2.629-2.387s2.662 1.012 2.662 2.387c0 1.166-.825 1.991-1.991 2.222v1.518c.913-.055 1.76-.121 2.486-.22zM22.666 5v9.801h-1.298V5zm-3.597 3.069c0-.825-.638-1.309-1.386-1.309-.737 0-1.364.517-1.364 1.309 0 .759.638 1.221 1.364 1.221s1.386-.462 1.386-1.221m5.412-1.353V5.693h5.17v1.023H27.77c.099 1.408 1.1 2.343 2.2 2.695l-.715 1.012c-.748-.286-1.705-1.045-2.134-1.947-.275.957-1.32 1.87-2.277 2.2l-.759-1.001c1.386-.495 2.31-1.529 2.365-2.959zm1.034 4.477h6.644v3.619h-1.298v-2.607h-5.346zm6.633-.484h-1.287V5.011h1.287zm9.13-5.181c0 1.584-.099 3.058-.319 4.18h1.452v1.023h-3.806v4.07h-1.287v-4.07h-3.762V9.708h6.182c.176-.847.264-1.947.264-3.146h-5.357V5.528z"
  }))));
};

function _EMOTION_STRINGIFIED_CSS_ERROR__$Y() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
function BadgeList(props) {
  const {
    isDiscontinued,
    isSoldOut,
    isSelling,
    isOverseasPurchase,
    isFreeDelivery,
    isSpecialPrice,
    isGlobal,
    badgeMaxCount
  } = props;
  const disabled = !isDiscontinued && isSoldOut;
  const badgeList = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(() => [isOverseasPurchase && (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(SvgProductBadgeOverseasPurchase, {
    className: "icon",
    "aria-label": "\uD574\uC678\uC9C1\uAD6C"
  }, 0), isFreeDelivery && (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(SvgProductBadgeFreeDelivery, {
    className: "icon",
    "aria-label": "\uBB34\uB8CC\uBC30\uC1A1"
  }, 1), isSpecialPrice && (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(SvgProductBadgeCheapestPrice, {
    className: "icon",
    "aria-label": "\uD2B9\uAC00"
  }, 2)].filter(value => !!value), [isOverseasPurchase, isFreeDelivery, isSpecialPrice]);
  if (isDiscontinued || !isSelling && !isGlobal) {
    return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsxs */ .BX)(Container$u, {
      disabled: disabled,
      "data-testid": "badge-list-container",
      children: [!isSelling && !isGlobal && (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(SvgProductBadgeNonSelling, {
        className: "icon",
        "aria-label": "\uBBF8\uC785\uC810"
      }), !(!isSelling && !isGlobal) && isDiscontinued && (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(SvgProductBadgeDiscontinued, {
        className: "icon",
        "aria-label": "\uB2E8\uC885"
      })]
    });
  }
  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(Container$u, {
    disabled: disabled,
    "data-testid": "badge-list-container",
    children: badgeMaxCount != null ? badgeList.slice(0, badgeMaxCount) : badgeList
  });
}
var _ref$s =  true ? {
  name: "1s0bkzx",
  styles: "opacity:0.32"
} : 0;
const Container$u = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)("div",  true ? {
  target: "e132f8k40"
} : 0)("display:flex;flex-wrap:wrap;gap:4px;margin-top:8px;", ({
  disabled
}) => disabled && _ref$s, ";" + ( true ? "" : 0));

function _EMOTION_STRINGIFIED_CSS_ERROR__$X() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
function IconWithTextBadge({
  title,
  image
}) {
  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsxs */ .BX)(Container$t, {
    children: [(0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(Icon, {
      src: image,
      alt: "icon-with-text-badge"
    }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(Title$b, {
      children: title
    })]
  });
}
const Container$t = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)("div",  true ? {
  target: "etn6hd12"
} : 0)( true ? {
  name: "1b1ga6k",
  styles: "display:flex;align-items:center;max-width:100%;width:fit-content;margin-top:6px;padding:2px 5px;font-size:10px;line-height:14px;font-weight:700;letter-spacing:-0.3px;border-radius:4px;color:#2F3438;border:1px solid #EAEDEF"
} : 0);
const Icon = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_9__.R,  true ? {
  target: "etn6hd11"
} : 0)( true ? {
  name: "spvu94",
  styles: "display:block;width:11px;margin-right:5px"
} : 0);
const Title$b = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)("span",  true ? {
  target: "etn6hd10"
} : 0)( true ? {
  name: "sqm42b",
  styles: "text-overflow:ellipsis;white-space:nowrap;overflow:hidden"
} : 0);

function Badges({
  product,
  isMdPick,
  badgeMaxCount
}) {
  const {
    isSelling,
    isDiscontinued,
    deliveryServiceCode,
    isDepartureToday,
    deliveryStartAt,
    isSoldOut,
    isOverseasPurchase,
    isFreeDelivery,
    isSpecialPrice,
    currency,
    couponBadge,
    benefitBadges
  } = product;
  const showBadge = isSelling && !isDiscontinued;
  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsxs */ .BX)(_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .Fragment */ .HY, {
    children: [showBadge && shouldShowDeliveryBadge(product) && (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(DeliveryBadge, {
      deliveryServiceCode: deliveryServiceCode,
      isDepartureToday: isDepartureToday
    }), showBadge && deliveryStartAt && (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(DeliveryStartAt, {
      deliveryStartAt: deliveryStartAt
    }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(BadgeList, {
      isDiscontinued: isDiscontinued,
      isSoldOut: isSoldOut,
      isSelling: isSelling,
      isOverseasPurchase: isOverseasPurchase,
      isFreeDelivery: isFreeDelivery,
      isSpecialPrice: isSpecialPrice,
      isGlobal: !!currency,
      badgeMaxCount: badgeMaxCount != null && isMdPick ? 2 : undefined
    }), showBadge && couponBadge != null && (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(IconWithTextBadge, {
      title: couponBadge.title,
      image: couponBadge.image
    }), showBadge && benefitBadges?.map((badge, index) => (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(IconWithTextBadge, {
      title: badge.title,
      image: badge.image
    }, `benefit-badge-${index + 1}`))]
  });
}

function _EMOTION_STRINGIFIED_CSS_ERROR__$W() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
function Info$1({
  product,
  badgeMaxCount,
  isMdPick,
  flex,
  variant = 'lg',
  localeData = {},
  hideBadge,
  hideReview,
  hideStats,
  className,
  bottomArea
}) {
  const {
    name,
    isSelling,
    isDiscontinued,
    brand,
    originalPrice,
    sellingPrice,
    isSoldOut,
    type,
    reviewAvg,
    reviewCount,
    scrapCount,
    currency
  } = product;
  const isGlobal = !!currency;
  const showPrice = isGlobal || isSelling && !isDiscontinued;
  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsxs */ .BX)(Container$s, {
    flex: flex,
    className: classNames('product-info', className),
    children: [(0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsxs */ .BX)(Header$6, {
      children: [(0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(Brand$1, {
        className: "product-brand",
        children: brand.name
      }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(Name$1, {
        className: "product-name",
        variant: variant,
        children: name
      })]
    }), showPrice && (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(Price, {
      originalPrice: originalPrice,
      sellingPrice: sellingPrice,
      isDiscontinued: isDiscontinued,
      isSoldOut: isSoldOut,
      variant: variant,
      currency: currency,
      renderSuffix: () => (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)("span", {
        children: type === 'Deal' && ' 외'
      }),
      priceToken: localeData?.priceToken
    }), !isGlobal && (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(Stats, {
      stats: {
        reviewAvg,
        reviewCount,
        scrapCount
      },
      isMdPick: isMdPick,
      hideReview: hideReview,
      hideStats: hideStats
    }), !hideBadge && (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(Badges, {
      product: product,
      isMdPick: isMdPick,
      badgeMaxCount: badgeMaxCount
    }), bottomArea && bottomArea]
  });
}
function InfoPlaceholder() {
  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsxs */ .BX)(Container$s, {
    children: [(0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsxs */ .BX)(Header$6, {
      children: [(0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(BrandPlaceholder, {}), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(NamePlaceholder, {})]
    }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(StyledPricePlaceholder, {}), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(StyledStatsPlaceholer, {})]
  });
}
var _ref2$8 =  true ? {
  name: "v1s1f3",
  styles: "margin-left:12px"
} : 0;
const Container$s = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)("div",  true ? {
  target: "eo39oc47"
} : 0)("width:100%;", ({
  flex
}) => flex && _ref2$8, ";" + ( true ? "" : 0));
const Header$6 = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)("div",  true ? {
  target: "eo39oc46"
} : 0)( true ? {
  name: "1r0yqr6",
  styles: "margin-top:10px"
} : 0);
const Brand$1 = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)("div",  true ? {
  target: "eo39oc45"
} : 0)( true ? {
  name: "11vbb10",
  styles: "font-size:12px;line-height:16px;display:block;word-break:break-all;color:#828C94"
} : 0);
const nameStyle$1 =  true ? {
  name: "wwgkbi",
  styles: "font-size:14px;line-height:18px;display:block;max-height:36px;margin-top:4px;word-break:break-all;transition:.1s opacity;overflow:hidden;text-overflow:ellipsis;display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical;word-wrap:break-word"
} : 0;
var _ref$r =  true ? {
  name: "xolxwr",
  styles: "font-size:12px;line-height:16px"
} : 0;
const Name$1 = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)("span",  true ? {
  target: "eo39oc44"
} : 0)(nameStyle$1, " color:#2F3438;", ({
  variant
}) => (variant === 'sm' || variant === 'md') && _ref$r, ";" + ( true ? "" : 0));
const BrandPlaceholder = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(PlaceholderAnimation,  true ? {
  target: "eo39oc43"
} : 0)(_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.F.caption1, " &:before{content:'\\00a0';}display:block;word-break:break-all;width:80px;" + ( true ? "" : 0));
const NamePlaceholder = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(PlaceholderAnimation,  true ? {
  target: "eo39oc42"
} : 0)(nameStyle$1, " &:before{content:'\\00a0';}" + ( true ? "" : 0));
const StyledPricePlaceholder = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(PricePlaceholder,  true ? {
  target: "eo39oc41"
} : 0)( true ? {
  name: "192rb07",
  styles: "margin-top:3px;line-height:21px;width:120px"
} : 0);
const StyledStatsPlaceholer = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(StatsPlaceholder,  true ? {
  target: "eo39oc40"
} : 0)( true ? {
  name: "13ec1gr",
  styles: "margin-top:3px;width:100px"
} : 0);

function _EMOTION_STRINGIFIED_CSS_ERROR__$V() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
const badgeSizeLookup = {
  extraSmall: [29, 29],
  small: [29, 26],
  large: [23, 20]
};
const BASE_BADGE_SIZE = 100;
const SEGMENTS = 3;
const calculateColumn = (elementSize, position) => {
  const base = BASE_BADGE_SIZE / SEGMENTS;
  const pos = Math.floor(position / SEGMENTS);
  return base * pos + (base - elementSize) / 2 * pos;
};
const calculateRow = (elementSize, position) => {
  const base = BASE_BADGE_SIZE / SEGMENTS;
  const pos = position % SEGMENTS;
  return base * pos + (base - elementSize) / 2 * pos;
};
function ThumbnailBadge({
  badgeList,
  size
}) {
  const badgeSize = badgeSizeLookup[size ?? 'small'];
  const filteredBadgeList = badgeList.map(badge => ({
    ...badge,
    position: Math.max(1, Math.min(badge.position, 9))
  }));
  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(Container$r, {
    children: filteredBadgeList.map((badge, index) => (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(Content$5, {
      calculateColumn: calculateColumn,
      calculateRow: calculateRow,
      size: badgeSize,
      position: badge.position - 1,
      children: (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(Image, {
        src: badge.image.url
      })
    }, `thumbnail-badge-${index + 1}`))
  });
}
const Container$r = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)("div",  true ? {
  target: "e3bgcpm2"
} : 0)( true ? {
  name: "nm1wv3",
  styles: "position:absolute;width:100%;height:100%;box-sizing:border-box;z-index:1;pointer-events:none"
} : 0);
const Content$5 = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)("div",  true ? {
  target: "e3bgcpm1"
} : 0)("position:absolute;", ({
  calculateColumn,
  calculateRow,
  size,
  position
}) => `
    top: ${calculateColumn(size[0], position)}%;
    left: ${calculateRow(size[0], position)}%;
    width: ${size[0]}%;
    height: ${size[0]}%;
    ${_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.M.min('tablet', `
      top: ${calculateColumn(size[1], position)}%;
      left: ${calculateRow(size[1], position)}%;
      width: ${size[1]}%;
      height: ${size[1]}%;
    `)}
  `, ";" + ( true ? "" : 0));
const Image = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_9__.R,  true ? {
  target: "e3bgcpm0"
} : 0)( true ? {
  name: "1dapu1e",
  styles: "&&&{width:100%;background-color:transparent;}"
} : 0);

var humps = {exports: {}};

(function (module) {
  (function (global) {
    var _processKeys = function (convert, obj, options) {
      if (!_isObject(obj) || _isDate(obj) || _isRegExp(obj) || _isBoolean(obj) || _isFunction(obj)) {
        return obj;
      }
      var output,
        i = 0,
        l = 0;
      if (_isArray(obj)) {
        output = [];
        for (l = obj.length; i < l; i++) {
          output.push(_processKeys(convert, obj[i], options));
        }
      } else {
        output = {};
        for (var key in obj) {
          if (Object.prototype.hasOwnProperty.call(obj, key)) {
            output[convert(key, options)] = _processKeys(convert, obj[key], options);
          }
        }
      }
      return output;
    };

    // String conversion methods

    var separateWords = function (string, options) {
      options = options || {};
      var separator = options.separator || '_';
      var split = options.split || /(?=[A-Z])/;
      return string.split(split).join(separator);
    };
    var camelize = function (string) {
      if (_isNumerical(string)) {
        return string;
      }
      string = string.replace(/[\-_\s]+(.)?/g, function (match, chr) {
        return chr ? chr.toUpperCase() : '';
      });
      // Ensure 1st char is always lowercase
      return string.substr(0, 1).toLowerCase() + string.substr(1);
    };
    var pascalize = function (string) {
      var camelized = camelize(string);
      // Ensure 1st char is always uppercase
      return camelized.substr(0, 1).toUpperCase() + camelized.substr(1);
    };
    var decamelize = function (string, options) {
      return separateWords(string, options).toLowerCase();
    };

    // Utilities
    // Taken from Underscore.js

    var toString = Object.prototype.toString;
    var _isFunction = function (obj) {
      return typeof obj === 'function';
    };
    var _isObject = function (obj) {
      return obj === Object(obj);
    };
    var _isArray = function (obj) {
      return toString.call(obj) == '[object Array]';
    };
    var _isDate = function (obj) {
      return toString.call(obj) == '[object Date]';
    };
    var _isRegExp = function (obj) {
      return toString.call(obj) == '[object RegExp]';
    };
    var _isBoolean = function (obj) {
      return toString.call(obj) == '[object Boolean]';
    };

    // Performant way to determine if obj coerces to a number
    var _isNumerical = function (obj) {
      obj = obj - 0;
      return obj === obj;
    };

    // Sets up function which handles processing keys
    // allowing the convert function to be modified by a callback
    var _processor = function (convert, options) {
      var callback = options && 'process' in options ? options.process : options;
      if (typeof callback !== 'function') {
        return convert;
      }
      return function (string, options) {
        return callback(string, convert, options);
      };
    };
    var humps = {
      camelize: camelize,
      decamelize: decamelize,
      pascalize: pascalize,
      depascalize: decamelize,
      camelizeKeys: function (object, options) {
        return _processKeys(_processor(camelize, options), object);
      },
      decamelizeKeys: function (object, options) {
        return _processKeys(_processor(decamelize, options), object, options);
      },
      pascalizeKeys: function (object, options) {
        return _processKeys(_processor(pascalize, options), object);
      },
      depascalizeKeys: function () {
        return this.decamelizeKeys.apply(this, arguments);
      }
    };
    if (module.exports) {
      module.exports = humps;
    } else {
      global.humps = humps;
    }
  })(commonjsGlobal);
})(humps);
var humpsExports = humps.exports;

/**
 * 웹뷰에서 앱에게 braze custom log를 전송하라고 합니다.
 * braze custom log가 웹이 아니라 앱으로 찍을 때 사용합니다.
 * 사용하는 웹뷰에 ipc 설정이 되어 있을 때만 사용 가능합니다.
 * @param name 이벤트 이름 e.g 'add_cart', 'add_scarp'
 * @param properties 로깅할 데이터
 */
const logAppBraze = (name, properties) => {
  if (window.webkit?.messageHandlers?.ohouseBrazeInterface != null) {
    window.webkit.messageHandlers.ohouseBrazeInterface.postMessage({
      name,
      properties
    });
  } else if (window?.ohouseBrazeInterface != null) {
    window.ohouseBrazeInterface.sendLog(name, JSON.stringify(properties));
  }
};

var mapObj = {exports: {}};

const isObject$1 = value => typeof value === 'object' && value !== null;
const mapObjectSkip = Symbol('skip');

// Customized for this use-case
const isObjectCustom = value => isObject$1(value) && !(value instanceof RegExp) && !(value instanceof Error) && !(value instanceof Date);
const mapObject = (object, mapper, options, isSeen = new WeakMap()) => {
  options = {
    deep: false,
    target: {},
    ...options
  };
  if (isSeen.has(object)) {
    return isSeen.get(object);
  }
  isSeen.set(object, options.target);
  const {
    target
  } = options;
  delete options.target;
  const mapArray = array => array.map(element => isObjectCustom(element) ? mapObject(element, mapper, options, isSeen) : element);
  if (Array.isArray(object)) {
    return mapArray(object);
  }
  for (const [key, value] of Object.entries(object)) {
    const mapResult = mapper(key, value, object);
    if (mapResult === mapObjectSkip) {
      continue;
    }
    let [newKey, newValue, {
      shouldRecurse = true
    } = {}] = mapResult;

    // Drop `__proto__` keys.
    if (newKey === '__proto__') {
      continue;
    }
    if (options.deep && shouldRecurse && isObjectCustom(newValue)) {
      newValue = Array.isArray(newValue) ? mapArray(newValue) : mapObject(newValue, mapper, options, isSeen);
    }
    target[newKey] = newValue;
  }
  return target;
};
mapObj.exports = (object, mapper, options) => {
  if (!isObject$1(object)) {
    throw new TypeError(`Expected an object, got \`${object}\` (${typeof object})`);
  }
  return mapObject(object, mapper, options);
};
mapObj.exports.mapObjectSkip = mapObjectSkip;
var mapObjExports = mapObj.exports;

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise, SuppressedError, Symbol */


var __assign$1 = function() {
  __assign$1 = Object.assign || function __assign(t) {
      for (var s, i = 1, n = arguments.length; i < n; i++) {
          s = arguments[i];
          for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
      return t;
  };
  return __assign$1.apply(this, arguments);
};

typeof SuppressedError === "function" ? SuppressedError : function (error, suppressed, message) {
  var e = new Error(message);
  return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};

/**
 * Source: ftp://ftp.unicode.org/Public/UCD/latest/ucd/SpecialCasing.txt
 */
/**
 * Lower case as a function.
 */
function lowerCase(str) {
  return str.toLowerCase();
}

// Support camel case ("camelCase" -> "camel Case" and "CAMELCase" -> "CAMEL Case").
var DEFAULT_SPLIT_REGEXP = [/([a-z0-9])([A-Z])/g, /([A-Z])([A-Z][a-z])/g];
// Remove all non-word characters.
var DEFAULT_STRIP_REGEXP = /[^A-Z0-9]+/gi;
/**
 * Normalize the string into something other libraries can manipulate easier.
 */
function noCase(input, options) {
  if (options === void 0) {
    options = {};
  }
  var _a = options.splitRegexp,
    splitRegexp = _a === void 0 ? DEFAULT_SPLIT_REGEXP : _a,
    _b = options.stripRegexp,
    stripRegexp = _b === void 0 ? DEFAULT_STRIP_REGEXP : _b,
    _c = options.transform,
    transform = _c === void 0 ? lowerCase : _c,
    _d = options.delimiter,
    delimiter = _d === void 0 ? " " : _d;
  var result = replace(replace(input, splitRegexp, "$1\0$2"), stripRegexp, "\0");
  var start = 0;
  var end = result.length;
  // Trim the delimiter from around the output string.
  while (result.charAt(start) === "\0") start++;
  while (result.charAt(end - 1) === "\0") end--;
  // Transform each token independently.
  return result.slice(start, end).split("\0").map(transform).join(delimiter);
}
/**
 * Replace `re` in the input string with the replacement value.
 */
function replace(input, re, value) {
  if (re instanceof RegExp) return input.replace(re, value);
  return re.reduce(function (input, re) {
    return input.replace(re, value);
  }, input);
}

function dotCase(input, options) {
  if (options === void 0) {
    options = {};
  }
  return noCase(input, __assign$1({
    delimiter: "."
  }, options));
}

function snakeCase$1(input, options) {
  if (options === void 0) {
    options = {};
  }
  return dotCase(input, __assign$1({
    delimiter: "_"
  }, options));
}

var dist_es2015 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  snakeCase: snakeCase$1
});

var require$$1 = /*@__PURE__*/getAugmentedNamespace(dist_es2015);

const map = mapObjExports;
const {
  snakeCase
} = require$$1;
var snakecaseKeys = function (obj, options) {
  options = Object.assign({
    deep: true,
    exclude: [],
    parsingOptions: {}
  }, options);
  return map(obj, function (key, val) {
    return [matches(options.exclude, key) ? key : snakeCase(key, options.parsingOptions), val];
  }, options);
};
function matches(patterns, value) {
  return patterns.some(function (pattern) {
    return typeof pattern === 'string' ? pattern === value : pattern.test(value);
  });
}
var snakecaseKeys$1 = /*@__PURE__*/getDefaultExportFromCjs$1(snakecaseKeys);

/* eslint-disable @typescript-eslint/no-explicit-any */

/**
 * 웹에서 braze custom log를 전송합니다.
 * @param name 이벤트 이름 e.g 'add_cart', 'add_scarp'
 * @param properties 로깅할 데이터이며 object 형태여야 로깅이 동작합니다.
 */
const logBraze = (eventName, properties) => {
  if (window.braze?.logCustomEvent != null) {
    window.braze.logCustomEvent(eventName, snakecaseKeys$1(properties));
  }
};

/* eslint-disable @typescript-eslint/no-explicit-any */

const BRAZE_TOKEN = '5195e134-c2c9-4bdb-8431-ee5fca29b935';
const BRAZE_BASE_URL = 'sdk.iad-03.appboy.com';
let brazeInitialized = false;
let ohouseUserId = '';
/**
 * window.braze 에 Braze 를 세팅하고 초기화하기 위한 함수이며, logBraze 이전에 호출되어야 합니다.
 * 앱 내부일 경우 웹뷰에서 logAppBraze 를 사용할 경우 (ipc 세팅이 되어있을 경우) 호출하지 않아도 됩니다.
 * @param userId braze에 기록될 userId이며, 오늘의집 유저 id 를 주입하면 됩니다.
 * @param isDevelopment 개발환경이라면 debug log를 표시합니다.
 * @example
 * ```
 * <Script
 *   src="https://js.appboycdn.com/web-sdk/4.8/braze.min.js"
 *   onLoad={() => initBraze({ userId, isDevelopment })}
 * />
 * ```
 */
const initBraze = ({
  userId,
  isDevelopment = false
}) => {
  const isUserAlreadyInBraze = brazeInitialized && ohouseUserId === userId;
  if (isUserAlreadyInBraze || !window.braze) {
    return;
  }
  const Braze = window.braze;
  Braze.initialize(BRAZE_TOKEN, {
    baseUrl: BRAZE_BASE_URL,
    allowUserSuppliedJavascript: true,
    enableLogging: isDevelopment
  });
  Braze.openSession();
  Braze.changeUser(userId);
  ohouseUserId = userId;
  brazeInitialized = true;
};

const AIRBRIDGE_TOKEN = '2bd43efc5ef8401baece946c84ba155d';
/**
 * airbridge 전역 객체를 초기화합니다.
 * @param user 로그인 유저 데이터
 * @example
 * ```
 * <Script
 *   src="/js/airbridge.js"
 *   onLoad={() => initAirbridge(user)}
 * />
 * ```
 */
const initAirbridge = user => {
  if (typeof window === 'undefined') {
    return;
  }
  const userConfig = user ? {
    user: {
      externalUserID: `${user.id}`,
      externalUserEmail: `${user.id}@bucketplace.net`
    }
  } : {};
  const config = {
    app: 'ohouse',
    webToken: AIRBRIDGE_TOKEN,
    cookieWindow: 1,
    userHash: false,
    urlQueryMapping: {
      channel: 'utm_source',
      campaign: 'utm_campaign',
      term: 'utm_term',
      ad_creative: 'utm_content',
      ad_group: 'bp_adset',
      content: 'bp_content',
      sub_id: 'bp_sub_id',
      sub_id_1: 'bp_sub_id_1',
      sub_id_2: 'bp_sub_id_2',
      sub_id_3: 'utm_medium'
    },
    ...userConfig
  };
  window.airbridge.init?.(config);
};

/**
 * airbridge 로그를 전송합니다.
 * @param {string} category event 카테고리
 * @param {EventOption} attritube event 옵션
 * @example
 * ```
 * logAirbridge('category', {
 *   label: 'label',
 *   action: 'action',
 *   value: 1,
 *   ...
 * });
 * ```
 */
const logAirbridge = ({
  category,
  attribute
}) => {
  if (!window?.airbridge) {
    return;
  }
  window.airbridge.events?.send(category, attribute);
};

/**
 * signout 시 airbridge 정보도 clear 합니다.
 * @example
 * ```
 * signoutAirbridge();
 * ```
 */
const signoutAirbridge = () => {
  logAirbridge({
    category: 'airbridge.user.signout'
  });
  window.airbridge?.clearUser();
};

const getAmplitude = () => {
  if (!window.amplitude) {
    return null;
  }
  return window.amplitude?.getInstance?.() || null;
};

/**
 * 앰플리튜드 로그를 남깁니다.
 * @param {string} type 이벤트 타입
 * @param {unknown} data 이벤트 데이터
 */
const logAmplitude$1 = (type, data) => {
  const amplitude = getAmplitude();
  if (!amplitude) {
    return;
  }
  amplitude.logEvent(type, data);
};

/**
 * 버킷 클릭 로그를 남깁니다.
 * @param {object} data `category`를 제외한 로그 데이터
 */
const bucketClickLog = data => {
  L({
    category: 'click',
    ...data
  });
};

/**
 * 버킷 임프레션 로그를 남깁니다.
 * @param {object} data `category`를 제외한 로그 데이터
 */
const bucketImpressionLog = data => {
  L({
    category: 'impression',
    data: [{
      ...f$1(data),
      time: Date.now()
    }]
  });
};

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof __webpack_require__.g == 'object' && __webpack_require__.g && __webpack_require__.g.Object === Object && __webpack_require__.g;
var freeGlobal$1 = freeGlobal;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal$1 || freeSelf || Function('return this')();
var root$1 = root;

/** Built-in value references. */
var Symbol$1 = root$1.Symbol;
var Symbol$2 = Symbol$1;

/** Used for built-in method references. */
var objectProto$e = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$b = objectProto$e.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString$1 = objectProto$e.toString;

/** Built-in value references. */
var symToStringTag$1 = Symbol$2 ? Symbol$2.toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty$b.call(value, symToStringTag$1),
    tag = value[symToStringTag$1];
  try {
    value[symToStringTag$1] = undefined;
    var unmasked = true;
  } catch (e) {}
  var result = nativeObjectToString$1.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag$1] = tag;
    } else {
      delete value[symToStringTag$1];
    }
  }
  return result;
}

/** Used for built-in method references. */
var objectProto$d = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto$d.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

/** `Object#toString` result references. */
var nullTag = '[object Null]',
  undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = Symbol$2 ? Symbol$2.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return symToStringTag && symToStringTag in Object(value) ? getRawTag(value) : objectToString(value);
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

/** `Object#toString` result references. */
var symbolTag$1 = '[object Symbol]';

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' || isObjectLike(value) && baseGetTag(value) == symbolTag$1;
}

/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function arrayMap(array, iteratee) {
  var index = -1,
    length = array == null ? 0 : array.length,
    result = Array(length);
  while (++index < length) {
    result[index] = iteratee(array[index], index, array);
  }
  return result;
}

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;
var isArray$1 = isArray;

/** Used as references for various `Number` constants. */
var INFINITY$1 = 1 / 0;

/** Used to convert symbols to primitives and strings. */
var symbolProto$1 = Symbol$2 ? Symbol$2.prototype : undefined,
  symbolToString = symbolProto$1 ? symbolProto$1.toString : undefined;

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isArray$1(value)) {
    // Recursively convert values (susceptible to call stack limits).
    return arrayMap(value, baseToString) + '';
  }
  if (isSymbol(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = value + '';
  return result == '0' && 1 / value == -INFINITY$1 ? '-0' : result;
}

/** Used to match a single whitespace character. */
var reWhitespace = /\s/;

/**
 * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
 * character of `string`.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {number} Returns the index of the last non-whitespace character.
 */
function trimmedEndIndex(string) {
  var index = string.length;
  while (index-- && reWhitespace.test(string.charAt(index))) {}
  return index;
}

/** Used to match leading whitespace. */
var reTrimStart = /^\s+/;

/**
 * The base implementation of `_.trim`.
 *
 * @private
 * @param {string} string The string to trim.
 * @returns {string} Returns the trimmed string.
 */
function baseTrim(string) {
  return string ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, '') : string;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? other + '' : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = baseTrim(value);
  var isBinary = reIsBinary.test(value);
  return isBinary || reIsOctal.test(value) ? freeParseInt(value.slice(2), isBinary ? 2 : 8) : reIsBadHex.test(value) ? NAN : +value;
}

/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function identity(value) {
  return value;
}

/** `Object#toString` result references. */
var asyncTag = '[object AsyncFunction]',
  funcTag$1 = '[object Function]',
  genTag = '[object GeneratorFunction]',
  proxyTag = '[object Proxy]';

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  if (!isObject(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = baseGetTag(value);
  return tag == funcTag$1 || tag == genTag || tag == asyncTag || tag == proxyTag;
}

/** Used to detect overreaching core-js shims. */
var coreJsData = root$1['__core-js_shared__'];
var coreJsData$1 = coreJsData;

/** Used to detect methods masquerading as native. */
var maskSrcKey = function () {
  var uid = /[^.]+$/.exec(coreJsData$1 && coreJsData$1.keys && coreJsData$1.keys.IE_PROTO || '');
  return uid ? 'Symbol(src)_1.' + uid : '';
}();

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && maskSrcKey in func;
}

/** Used for built-in method references. */
var funcProto$1 = Function.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString$1 = funcProto$1.toString;

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString$1.call(func);
    } catch (e) {}
    try {
      return func + '';
    } catch (e) {}
  }
  return '';
}

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used for built-in method references. */
var funcProto = Function.prototype,
  objectProto$c = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty$a = objectProto$c.hasOwnProperty;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' + funcToString.call(hasOwnProperty$a).replace(reRegExpChar, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

/* Built-in method references that are verified to be native. */
var WeakMap$1 = getNative(root$1, 'WeakMap');
var WeakMap$2 = WeakMap$1;

/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */
function apply(func, thisArg, args) {
  switch (args.length) {
    case 0:
      return func.call(thisArg);
    case 1:
      return func.call(thisArg, args[0]);
    case 2:
      return func.call(thisArg, args[0], args[1]);
    case 3:
      return func.call(thisArg, args[0], args[1], args[2]);
  }
  return func.apply(thisArg, args);
}

/** Used to detect hot functions by number of calls within a span of milliseconds. */
var HOT_COUNT = 800,
  HOT_SPAN = 16;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeNow = Date.now;

/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */
function shortOut(func) {
  var count = 0,
    lastCalled = 0;
  return function () {
    var stamp = nativeNow(),
      remaining = HOT_SPAN - (stamp - lastCalled);
    lastCalled = stamp;
    if (remaining > 0) {
      if (++count >= HOT_COUNT) {
        return arguments[0];
      }
    } else {
      count = 0;
    }
    return func.apply(undefined, arguments);
  };
}

/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */
function constant(value) {
  return function () {
    return value;
  };
}

var defineProperty = function () {
  try {
    var func = getNative(Object, 'defineProperty');
    func({}, '', {});
    return func;
  } catch (e) {}
}();
var defineProperty$1 = defineProperty;

/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var baseSetToString = !defineProperty$1 ? identity : function (func, string) {
  return defineProperty$1(func, 'toString', {
    'configurable': true,
    'enumerable': false,
    'value': constant(string),
    'writable': true
  });
};
var baseSetToString$1 = baseSetToString;

/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var setToString = shortOut(baseSetToString$1);
var setToString$1 = setToString;

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER$2 = 9007199254740991;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  var type = typeof value;
  length = length == null ? MAX_SAFE_INTEGER$2 : length;
  return !!length && (type == 'number' || type != 'symbol' && reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}

/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function baseAssignValue(object, key, value) {
  if (key == '__proto__' && defineProperty$1) {
    defineProperty$1(object, key, {
      'configurable': true,
      'enumerable': true,
      'value': value,
      'writable': true
    });
  } else {
    object[key] = value;
  }
}

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || value !== value && other !== other;
}

/** Used for built-in method references. */
var objectProto$b = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$9 = objectProto$b.hasOwnProperty;

/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignValue(object, key, value) {
  var objValue = object[key];
  if (!(hasOwnProperty$9.call(object, key) && eq(objValue, value)) || value === undefined && !(key in object)) {
    baseAssignValue(object, key, value);
  }
}

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax$1 = Math.max;

/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */
function overRest(func, start, transform) {
  start = nativeMax$1(start === undefined ? func.length - 1 : start, 0);
  return function () {
    var args = arguments,
      index = -1,
      length = nativeMax$1(args.length - start, 0),
      array = Array(length);
    while (++index < length) {
      array[index] = args[start + index];
    }
    index = -1;
    var otherArgs = Array(start + 1);
    while (++index < start) {
      otherArgs[index] = args[index];
    }
    otherArgs[start] = transform(array);
    return apply(func, this, otherArgs);
  };
}

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER$1 = 9007199254740991;

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER$1;
}

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

/** Used for built-in method references. */
var objectProto$a = Object.prototype;

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
    proto = typeof Ctor == 'function' && Ctor.prototype || objectProto$a;
  return value === proto;
}

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
    result = Array(n);
  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

/** `Object#toString` result references. */
var argsTag$2 = '[object Arguments]';

/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */
function baseIsArguments(value) {
  return isObjectLike(value) && baseGetTag(value) == argsTag$2;
}

/** Used for built-in method references. */
var objectProto$9 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$8 = objectProto$9.hasOwnProperty;

/** Built-in value references. */
var propertyIsEnumerable$1 = objectProto$9.propertyIsEnumerable;

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
var isArguments = baseIsArguments(function () {
  return arguments;
}()) ? baseIsArguments : function (value) {
  return isObjectLike(value) && hasOwnProperty$8.call(value, 'callee') && !propertyIsEnumerable$1.call(value, 'callee');
};
var isArguments$1 = isArguments;

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

/** Detect free variable `exports`. */
var freeExports$1 = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule$1 = freeExports$1 && "object" == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports$1 = freeModule$1 && freeModule$1.exports === freeExports$1;

/** Built-in value references. */
var Buffer$1 = moduleExports$1 ? root$1.Buffer : undefined;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeIsBuffer = Buffer$1 ? Buffer$1.isBuffer : undefined;

/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */
var isBuffer = nativeIsBuffer || stubFalse;
var isBuffer$1 = isBuffer;

/** `Object#toString` result references. */
var argsTag$1 = '[object Arguments]',
  arrayTag$1 = '[object Array]',
  boolTag$1 = '[object Boolean]',
  dateTag$1 = '[object Date]',
  errorTag$1 = '[object Error]',
  funcTag = '[object Function]',
  mapTag$3 = '[object Map]',
  numberTag$1 = '[object Number]',
  objectTag$2 = '[object Object]',
  regexpTag$1 = '[object RegExp]',
  setTag$3 = '[object Set]',
  stringTag$1 = '[object String]',
  weakMapTag$1 = '[object WeakMap]';
var arrayBufferTag$1 = '[object ArrayBuffer]',
  dataViewTag$2 = '[object DataView]',
  float32Tag = '[object Float32Array]',
  float64Tag = '[object Float64Array]',
  int8Tag = '[object Int8Array]',
  int16Tag = '[object Int16Array]',
  int32Tag = '[object Int32Array]',
  uint8Tag = '[object Uint8Array]',
  uint8ClampedTag = '[object Uint8ClampedArray]',
  uint16Tag = '[object Uint16Array]',
  uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag$1] = typedArrayTags[arrayTag$1] = typedArrayTags[arrayBufferTag$1] = typedArrayTags[boolTag$1] = typedArrayTags[dataViewTag$2] = typedArrayTags[dateTag$1] = typedArrayTags[errorTag$1] = typedArrayTags[funcTag] = typedArrayTags[mapTag$3] = typedArrayTags[numberTag$1] = typedArrayTags[objectTag$2] = typedArrayTags[regexpTag$1] = typedArrayTags[setTag$3] = typedArrayTags[stringTag$1] = typedArrayTags[weakMapTag$1] = false;

/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */
function baseIsTypedArray(value) {
  return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
}

/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function baseUnary(func) {
  return function (value) {
    return func(value);
  };
}

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && "object" == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Detect free variable `process` from Node.js. */
var freeProcess = moduleExports && freeGlobal$1.process;

/** Used to access faster Node.js helpers. */
var nodeUtil = function () {
  try {
    // Use `util.types` for Node.js 10+.
    var types = freeModule && freeModule.require && freeModule.require('util').types;
    if (types) {
      return types;
    }

    // Legacy `process.binding('util')` for Node.js < 10.
    return freeProcess && freeProcess.binding && freeProcess.binding('util');
  } catch (e) {}
}();
var nodeUtil$1 = nodeUtil;

/* Node.js helper references. */
var nodeIsTypedArray = nodeUtil$1 && nodeUtil$1.isTypedArray;

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
var isTypedArray$1 = isTypedArray;

/** Used for built-in method references. */
var objectProto$8 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$7 = objectProto$8.hasOwnProperty;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  var isArr = isArray$1(value),
    isArg = !isArr && isArguments$1(value),
    isBuff = !isArr && !isArg && isBuffer$1(value),
    isType = !isArr && !isArg && !isBuff && isTypedArray$1(value),
    skipIndexes = isArr || isArg || isBuff || isType,
    result = skipIndexes ? baseTimes(value.length, String) : [],
    length = result.length;
  for (var key in value) {
    if ((inherited || hasOwnProperty$7.call(value, key)) && !(skipIndexes && (
    // Safari 9 has enumerable `arguments.length` in strict mode.
    key == 'length' ||
    // Node.js 0.10 has enumerable non-index properties on buffers.
    isBuff && (key == 'offset' || key == 'parent') ||
    // PhantomJS 2 has enumerable non-index properties on typed arrays.
    isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset') ||
    // Skip index properties.
    isIndex(key, length)))) {
      result.push(key);
    }
  }
  return result;
}

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function (arg) {
    return func(transform(arg));
  };
}

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys = overArg(Object.keys, Object);
var nativeKeys$1 = nativeKeys;

/** Used for built-in method references. */
var objectProto$7 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$6 = objectProto$7.hasOwnProperty;

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!isPrototype(object)) {
    return nativeKeys$1(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty$6.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}

/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function nativeKeysIn(object) {
  var result = [];
  if (object != null) {
    for (var key in Object(object)) {
      result.push(key);
    }
  }
  return result;
}

/** Used for built-in method references. */
var objectProto$6 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$5 = objectProto$6.hasOwnProperty;

/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeysIn(object) {
  if (!isObject(object)) {
    return nativeKeysIn(object);
  }
  var isProto = isPrototype(object),
    result = [];
  for (var key in object) {
    if (!(key == 'constructor' && (isProto || !hasOwnProperty$5.call(object, key)))) {
      result.push(key);
    }
  }
  return result;
}

/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */
function keysIn(object) {
  return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
}

/** Used to match property names within property paths. */
var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
  reIsPlainProp = /^\w*$/;

/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */
function isKey(value, object) {
  if (isArray$1(value)) {
    return false;
  }
  var type = typeof value;
  if (type == 'number' || type == 'symbol' || type == 'boolean' || value == null || isSymbol(value)) {
    return true;
  }
  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) || object != null && value in Object(object);
}

/* Built-in method references that are verified to be native. */
var nativeCreate = getNative(Object, 'create');
var nativeCreate$1 = nativeCreate;

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate$1 ? nativeCreate$1(null) : {};
  this.size = 0;
}

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED$2 = '__lodash_hash_undefined__';

/** Used for built-in method references. */
var objectProto$5 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$4 = objectProto$5.hasOwnProperty;

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate$1) {
    var result = data[key];
    return result === HASH_UNDEFINED$2 ? undefined : result;
  }
  return hasOwnProperty$4.call(data, key) ? data[key] : undefined;
}

/** Used for built-in method references. */
var objectProto$4 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$3 = objectProto$4.hasOwnProperty;

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate$1 ? data[key] !== undefined : hasOwnProperty$3.call(data, key);
}

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED$1 = '__lodash_hash_undefined__';

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = nativeCreate$1 && value === undefined ? HASH_UNDEFINED$1 : value;
  return this;
}

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
    length = entries == null ? 0 : entries.length;
  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
  this.size = 0;
}

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

/** Used for built-in method references. */
var arrayProto = Array.prototype;

/** Built-in value references. */
var splice = arrayProto.splice;

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
    index = assocIndexOf(data, key);
  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  --this.size;
  return true;
}

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
    index = assocIndexOf(data, key);
  return index < 0 ? undefined : data[index][1];
}

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
    index = assocIndexOf(data, key);
  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
    length = entries == null ? 0 : entries.length;
  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

/* Built-in method references that are verified to be native. */
var Map$1 = getNative(root$1, 'Map');
var Map$2 = Map$1;

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.size = 0;
  this.__data__ = {
    'hash': new Hash(),
    'map': new (Map$2 || ListCache)(),
    'string': new Hash()
  };
}

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean' ? value !== '__proto__' : value === null;
}

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key) ? data[typeof key == 'string' ? 'string' : 'hash'] : data.map;
}

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  var result = getMapData(this, key)['delete'](key);
  this.size -= result ? 1 : 0;
  return result;
}

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  var data = getMapData(this, key),
    size = data.size;
  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
    length = entries == null ? 0 : entries.length;
  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

/** Error message constants. */
var FUNC_ERROR_TEXT$3 = 'Expected a function';

/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */
function memoize$1(func, resolver) {
  if (typeof func != 'function' || resolver != null && typeof resolver != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT$3);
  }
  var memoized = function () {
    var args = arguments,
      key = resolver ? resolver.apply(this, args) : args[0],
      cache = memoized.cache;
    if (cache.has(key)) {
      return cache.get(key);
    }
    var result = func.apply(this, args);
    memoized.cache = cache.set(key, result) || cache;
    return result;
  };
  memoized.cache = new (memoize$1.Cache || MapCache)();
  return memoized;
}

// Expose `MapCache`.
memoize$1.Cache = MapCache;

/** Used as the maximum memoize cache size. */
var MAX_MEMOIZE_SIZE = 500;

/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */
function memoizeCapped(func) {
  var result = memoize$1(func, function (key) {
    if (cache.size === MAX_MEMOIZE_SIZE) {
      cache.clear();
    }
    return key;
  });
  var cache = result.cache;
  return result;
}

/** Used to match property names within property paths. */
var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

/** Used to match backslashes in property paths. */
var reEscapeChar = /\\(\\)?/g;

/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */
var stringToPath = memoizeCapped(function (string) {
  var result = [];
  if (string.charCodeAt(0) === 46 /* . */) {
    result.push('');
  }
  string.replace(rePropName, function (match, number, quote, subString) {
    result.push(quote ? subString.replace(reEscapeChar, '$1') : number || match);
  });
  return result;
});
var stringToPath$1 = stringToPath;

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString$1(value) {
  return value == null ? '' : baseToString(value);
}

/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */
function castPath(value, object) {
  if (isArray$1(value)) {
    return value;
  }
  return isKey(value, object) ? [value] : stringToPath$1(toString$1(value));
}

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */
function toKey(value) {
  if (typeof value == 'string' || isSymbol(value)) {
    return value;
  }
  var result = value + '';
  return result == '0' && 1 / value == -INFINITY ? '-0' : result;
}

/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */
function baseGet(object, path) {
  path = castPath(path, object);
  var index = 0,
    length = path.length;
  while (object != null && index < length) {
    object = object[toKey(path[index++])];
  }
  return index && index == length ? object : undefined;
}

/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */
function get$3(object, path, defaultValue) {
  var result = object == null ? undefined : baseGet(object, path);
  return result === undefined ? defaultValue : result;
}

/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */
function arrayPush(array, values) {
  var index = -1,
    length = values.length,
    offset = array.length;
  while (++index < length) {
    array[offset + index] = values[index];
  }
  return array;
}

/** Built-in value references. */
var spreadableSymbol = Symbol$2 ? Symbol$2.isConcatSpreadable : undefined;

/**
 * Checks if `value` is a flattenable `arguments` object or array.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
 */
function isFlattenable(value) {
  return isArray$1(value) || isArguments$1(value) || !!(spreadableSymbol && value && value[spreadableSymbol]);
}

/**
 * The base implementation of `_.flatten` with support for restricting flattening.
 *
 * @private
 * @param {Array} array The array to flatten.
 * @param {number} depth The maximum recursion depth.
 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
 * @param {Array} [result=[]] The initial result value.
 * @returns {Array} Returns the new flattened array.
 */
function baseFlatten(array, depth, predicate, isStrict, result) {
  var index = -1,
    length = array.length;
  predicate || (predicate = isFlattenable);
  result || (result = []);
  while (++index < length) {
    var value = array[index];
    if (depth > 0 && predicate(value)) {
      if (depth > 1) {
        // Recursively flatten arrays (susceptible to call stack limits).
        baseFlatten(value, depth - 1, predicate, isStrict, result);
      } else {
        arrayPush(result, value);
      }
    } else if (!isStrict) {
      result[result.length] = value;
    }
  }
  return result;
}

/**
 * Flattens `array` a single level deep.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to flatten.
 * @returns {Array} Returns the new flattened array.
 * @example
 *
 * _.flatten([1, [2, [3, [4]], 5]]);
 * // => [1, 2, [3, [4]], 5]
 */
function flatten(array) {
  var length = array == null ? 0 : array.length;
  return length ? baseFlatten(array, 1) : [];
}

/**
 * A specialized version of `baseRest` which flattens the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @returns {Function} Returns the new function.
 */
function flatRest(func) {
  return setToString$1(overRest(func, undefined, flatten), func + '');
}

/** Built-in value references. */
var getPrototype = overArg(Object.getPrototypeOf, Object);
var getPrototype$1 = getPrototype;

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear() {
  this.__data__ = new ListCache();
  this.size = 0;
}

/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function stackDelete(key) {
  var data = this.__data__,
    result = data['delete'](key);
  this.size = data.size;
  return result;
}

/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function stackGet(key) {
  return this.__data__.get(key);
}

/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function stackHas(key) {
  return this.__data__.has(key);
}

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet(key, value) {
  var data = this.__data__;
  if (data instanceof ListCache) {
    var pairs = data.__data__;
    if (!Map$2 || pairs.length < LARGE_ARRAY_SIZE - 1) {
      pairs.push([key, value]);
      this.size = ++data.size;
      return this;
    }
    data = this.__data__ = new MapCache(pairs);
  }
  data.set(key, value);
  this.size = data.size;
  return this;
}

/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack(entries) {
  var data = this.__data__ = new ListCache(entries);
  this.size = data.size;
}

// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype['delete'] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;

/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */
function arrayFilter(array, predicate) {
  var index = -1,
    length = array == null ? 0 : array.length,
    resIndex = 0,
    result = [];
  while (++index < length) {
    var value = array[index];
    if (predicate(value, index, array)) {
      result[resIndex++] = value;
    }
  }
  return result;
}

/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */
function stubArray() {
  return [];
}

/** Used for built-in method references. */
var objectProto$3 = Object.prototype;

/** Built-in value references. */
var propertyIsEnumerable = objectProto$3.propertyIsEnumerable;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols$1 = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbols = !nativeGetSymbols$1 ? stubArray : function (object) {
  if (object == null) {
    return [];
  }
  object = Object(object);
  return arrayFilter(nativeGetSymbols$1(object), function (symbol) {
    return propertyIsEnumerable.call(object, symbol);
  });
};
var getSymbols$1 = getSymbols;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own and inherited enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbolsIn = !nativeGetSymbols ? stubArray : function (object) {
  var result = [];
  while (object) {
    arrayPush(result, getSymbols$1(object));
    object = getPrototype$1(object);
  }
  return result;
};
var getSymbolsIn$1 = (/* unused pure expression or super */ null && (getSymbolsIn));

/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */
function baseGetAllKeys(object, keysFunc, symbolsFunc) {
  var result = keysFunc(object);
  return isArray$1(object) ? result : arrayPush(result, symbolsFunc(object));
}

/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeys(object) {
  return baseGetAllKeys(object, keys, getSymbols$1);
}

/**
 * Creates an array of own and inherited enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeysIn(object) {
  return baseGetAllKeys(object, keysIn, getSymbolsIn$1);
}

/* Built-in method references that are verified to be native. */
var DataView$1 = getNative(root$1, 'DataView');
var DataView$2 = DataView$1;

/* Built-in method references that are verified to be native. */
var Promise$1 = getNative(root$1, 'Promise');
var Promise$2 = Promise$1;

/* Built-in method references that are verified to be native. */
var Set$1 = getNative(root$1, 'Set');
var Set$2 = Set$1;

/** `Object#toString` result references. */
var mapTag$2 = '[object Map]',
  objectTag$1 = '[object Object]',
  promiseTag = '[object Promise]',
  setTag$2 = '[object Set]',
  weakMapTag = '[object WeakMap]';
var dataViewTag$1 = '[object DataView]';

/** Used to detect maps, sets, and weakmaps. */
var dataViewCtorString = toSource(DataView$2),
  mapCtorString = toSource(Map$2),
  promiseCtorString = toSource(Promise$2),
  setCtorString = toSource(Set$2),
  weakMapCtorString = toSource(WeakMap$2);

/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
var getTag = baseGetTag;

// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if (DataView$2 && getTag(new DataView$2(new ArrayBuffer(1))) != dataViewTag$1 || Map$2 && getTag(new Map$2()) != mapTag$2 || Promise$2 && getTag(Promise$2.resolve()) != promiseTag || Set$2 && getTag(new Set$2()) != setTag$2 || WeakMap$2 && getTag(new WeakMap$2()) != weakMapTag) {
  getTag = function (value) {
    var result = baseGetTag(value),
      Ctor = result == objectTag$1 ? value.constructor : undefined,
      ctorString = Ctor ? toSource(Ctor) : '';
    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString:
          return dataViewTag$1;
        case mapCtorString:
          return mapTag$2;
        case promiseCtorString:
          return promiseTag;
        case setCtorString:
          return setTag$2;
        case weakMapCtorString:
          return weakMapTag;
      }
    }
    return result;
  };
}
var getTag$1 = getTag;

/** Built-in value references. */
var Uint8Array$1 = root$1.Uint8Array;
var Uint8Array$2 = Uint8Array$1;

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */
function setCacheAdd(value) {
  this.__data__.set(value, HASH_UNDEFINED);
  return this;
}

/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */
function setCacheHas(value) {
  return this.__data__.has(value);
}

/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */
function SetCache(values) {
  var index = -1,
    length = values == null ? 0 : values.length;
  this.__data__ = new MapCache();
  while (++index < length) {
    this.add(values[index]);
  }
}

// Add methods to `SetCache`.
SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
SetCache.prototype.has = setCacheHas;

/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */
function arraySome(array, predicate) {
  var index = -1,
    length = array == null ? 0 : array.length;
  while (++index < length) {
    if (predicate(array[index], index, array)) {
      return true;
    }
  }
  return false;
}

/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function cacheHas(cache, key) {
  return cache.has(key);
}

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG$5 = 1,
  COMPARE_UNORDERED_FLAG$3 = 2;

/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */
function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG$5,
    arrLength = array.length,
    othLength = other.length;
  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
    return false;
  }
  // Check that cyclic values are equal.
  var arrStacked = stack.get(array);
  var othStacked = stack.get(other);
  if (arrStacked && othStacked) {
    return arrStacked == other && othStacked == array;
  }
  var index = -1,
    result = true,
    seen = bitmask & COMPARE_UNORDERED_FLAG$3 ? new SetCache() : undefined;
  stack.set(array, other);
  stack.set(other, array);

  // Ignore non-index properties.
  while (++index < arrLength) {
    var arrValue = array[index],
      othValue = other[index];
    if (customizer) {
      var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
    }
    if (compared !== undefined) {
      if (compared) {
        continue;
      }
      result = false;
      break;
    }
    // Recursively compare arrays (susceptible to call stack limits).
    if (seen) {
      if (!arraySome(other, function (othValue, othIndex) {
        if (!cacheHas(seen, othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
          return seen.push(othIndex);
        }
      })) {
        result = false;
        break;
      }
    } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
      result = false;
      break;
    }
  }
  stack['delete'](array);
  stack['delete'](other);
  return result;
}

/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */
function mapToArray(map) {
  var index = -1,
    result = Array(map.size);
  map.forEach(function (value, key) {
    result[++index] = [key, value];
  });
  return result;
}

/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */
function setToArray(set) {
  var index = -1,
    result = Array(set.size);
  set.forEach(function (value) {
    result[++index] = value;
  });
  return result;
}

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG$4 = 1,
  COMPARE_UNORDERED_FLAG$2 = 2;

/** `Object#toString` result references. */
var boolTag = '[object Boolean]',
  dateTag = '[object Date]',
  errorTag = '[object Error]',
  mapTag$1 = '[object Map]',
  numberTag = '[object Number]',
  regexpTag = '[object RegExp]',
  setTag$1 = '[object Set]',
  stringTag = '[object String]',
  symbolTag = '[object Symbol]';
var arrayBufferTag = '[object ArrayBuffer]',
  dataViewTag = '[object DataView]';

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol$2 ? Symbol$2.prototype : undefined,
  symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
  switch (tag) {
    case dataViewTag:
      if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) {
        return false;
      }
      object = object.buffer;
      other = other.buffer;
    case arrayBufferTag:
      if (object.byteLength != other.byteLength || !equalFunc(new Uint8Array$2(object), new Uint8Array$2(other))) {
        return false;
      }
      return true;
    case boolTag:
    case dateTag:
    case numberTag:
      // Coerce booleans to `1` or `0` and dates to milliseconds.
      // Invalid dates are coerced to `NaN`.
      return eq(+object, +other);
    case errorTag:
      return object.name == other.name && object.message == other.message;
    case regexpTag:
    case stringTag:
      // Coerce regexes to strings and treat strings, primitives and objects,
      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
      // for more details.
      return object == other + '';
    case mapTag$1:
      var convert = mapToArray;
    case setTag$1:
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG$4;
      convert || (convert = setToArray);
      if (object.size != other.size && !isPartial) {
        return false;
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(object);
      if (stacked) {
        return stacked == other;
      }
      bitmask |= COMPARE_UNORDERED_FLAG$2;

      // Recursively compare objects (susceptible to call stack limits).
      stack.set(object, other);
      var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
      stack['delete'](object);
      return result;
    case symbolTag:
      if (symbolValueOf) {
        return symbolValueOf.call(object) == symbolValueOf.call(other);
      }
  }
  return false;
}

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG$3 = 1;

/** Used for built-in method references. */
var objectProto$2 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$2 = objectProto$2.hasOwnProperty;

/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG$3,
    objProps = getAllKeys(object),
    objLength = objProps.length,
    othProps = getAllKeys(other),
    othLength = othProps.length;
  if (objLength != othLength && !isPartial) {
    return false;
  }
  var index = objLength;
  while (index--) {
    var key = objProps[index];
    if (!(isPartial ? key in other : hasOwnProperty$2.call(other, key))) {
      return false;
    }
  }
  // Check that cyclic values are equal.
  var objStacked = stack.get(object);
  var othStacked = stack.get(other);
  if (objStacked && othStacked) {
    return objStacked == other && othStacked == object;
  }
  var result = true;
  stack.set(object, other);
  stack.set(other, object);
  var skipCtor = isPartial;
  while (++index < objLength) {
    key = objProps[index];
    var objValue = object[key],
      othValue = other[key];
    if (customizer) {
      var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
    }
    // Recursively compare objects (susceptible to call stack limits).
    if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
      result = false;
      break;
    }
    skipCtor || (skipCtor = key == 'constructor');
  }
  if (result && !skipCtor) {
    var objCtor = object.constructor,
      othCtor = other.constructor;

    // Non `Object` object instances with different constructors are not equal.
    if (objCtor != othCtor && 'constructor' in object && 'constructor' in other && !(typeof objCtor == 'function' && objCtor instanceof objCtor && typeof othCtor == 'function' && othCtor instanceof othCtor)) {
      result = false;
    }
  }
  stack['delete'](object);
  stack['delete'](other);
  return result;
}

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG$2 = 1;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
  arrayTag = '[object Array]',
  objectTag = '[object Object]';

/** Used for built-in method references. */
var objectProto$1 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$1 = objectProto$1.hasOwnProperty;

/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
  var objIsArr = isArray$1(object),
    othIsArr = isArray$1(other),
    objTag = objIsArr ? arrayTag : getTag$1(object),
    othTag = othIsArr ? arrayTag : getTag$1(other);
  objTag = objTag == argsTag ? objectTag : objTag;
  othTag = othTag == argsTag ? objectTag : othTag;
  var objIsObj = objTag == objectTag,
    othIsObj = othTag == objectTag,
    isSameTag = objTag == othTag;
  if (isSameTag && isBuffer$1(object)) {
    if (!isBuffer$1(other)) {
      return false;
    }
    objIsArr = true;
    objIsObj = false;
  }
  if (isSameTag && !objIsObj) {
    stack || (stack = new Stack());
    return objIsArr || isTypedArray$1(object) ? equalArrays(object, other, bitmask, customizer, equalFunc, stack) : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
  }
  if (!(bitmask & COMPARE_PARTIAL_FLAG$2)) {
    var objIsWrapped = objIsObj && hasOwnProperty$1.call(object, '__wrapped__'),
      othIsWrapped = othIsObj && hasOwnProperty$1.call(other, '__wrapped__');
    if (objIsWrapped || othIsWrapped) {
      var objUnwrapped = objIsWrapped ? object.value() : object,
        othUnwrapped = othIsWrapped ? other.value() : other;
      stack || (stack = new Stack());
      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
    }
  }
  if (!isSameTag) {
    return false;
  }
  stack || (stack = new Stack());
  return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
}

/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */
function baseIsEqual(value, other, bitmask, customizer, stack) {
  if (value === other) {
    return true;
  }
  if (value == null || other == null || !isObjectLike(value) && !isObjectLike(other)) {
    return value !== value && other !== other;
  }
  return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
}

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG$1 = 1,
  COMPARE_UNORDERED_FLAG$1 = 2;

/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */
function baseIsMatch(object, source, matchData, customizer) {
  var index = matchData.length,
    length = index,
    noCustomizer = !customizer;
  if (object == null) {
    return !length;
  }
  object = Object(object);
  while (index--) {
    var data = matchData[index];
    if (noCustomizer && data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) {
      return false;
    }
  }
  while (++index < length) {
    data = matchData[index];
    var key = data[0],
      objValue = object[key],
      srcValue = data[1];
    if (noCustomizer && data[2]) {
      if (objValue === undefined && !(key in object)) {
        return false;
      }
    } else {
      var stack = new Stack();
      if (customizer) {
        var result = customizer(objValue, srcValue, key, object, source, stack);
      }
      if (!(result === undefined ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG$1 | COMPARE_UNORDERED_FLAG$1, customizer, stack) : result)) {
        return false;
      }
    }
  }
  return true;
}

/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */
function isStrictComparable(value) {
  return value === value && !isObject(value);
}

/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */
function getMatchData(object) {
  var result = keys(object),
    length = result.length;
  while (length--) {
    var key = result[length],
      value = object[key];
    result[length] = [key, value, isStrictComparable(value)];
  }
  return result;
}

/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function matchesStrictComparable(key, srcValue) {
  return function (object) {
    if (object == null) {
      return false;
    }
    return object[key] === srcValue && (srcValue !== undefined || key in Object(object));
  };
}

/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatches(source) {
  var matchData = getMatchData(source);
  if (matchData.length == 1 && matchData[0][2]) {
    return matchesStrictComparable(matchData[0][0], matchData[0][1]);
  }
  return function (object) {
    return object === source || baseIsMatch(object, source, matchData);
  };
}

/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */
function baseHasIn(object, key) {
  return object != null && key in Object(object);
}

/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */
function hasPath(object, path, hasFunc) {
  path = castPath(path, object);
  var index = -1,
    length = path.length,
    result = false;
  while (++index < length) {
    var key = toKey(path[index]);
    if (!(result = object != null && hasFunc(object, key))) {
      break;
    }
    object = object[key];
  }
  if (result || ++index != length) {
    return result;
  }
  length = object == null ? 0 : object.length;
  return !!length && isLength(length) && isIndex(key, length) && (isArray$1(object) || isArguments$1(object));
}

/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */
function hasIn(object, path) {
  return object != null && hasPath(object, path, baseHasIn);
}

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
  COMPARE_UNORDERED_FLAG = 2;

/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatchesProperty(path, srcValue) {
  if (isKey(path) && isStrictComparable(srcValue)) {
    return matchesStrictComparable(toKey(path), srcValue);
  }
  return function (object) {
    var objValue = get$3(object, path);
    return objValue === undefined && objValue === srcValue ? hasIn(object, path) : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
  };
}

/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function baseProperty(key) {
  return function (object) {
    return object == null ? undefined : object[key];
  };
}

/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function basePropertyDeep(path) {
  return function (object) {
    return baseGet(object, path);
  };
}

/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */
function property(path) {
  return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
}

/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */
function baseIteratee(value) {
  // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
  // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
  if (typeof value == 'function') {
    return value;
  }
  if (value == null) {
    return identity;
  }
  if (typeof value == 'object') {
    return isArray$1(value) ? baseMatchesProperty(value[0], value[1]) : baseMatches(value);
  }
  return property(value);
}

/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseFor(fromRight) {
  return function (object, iteratee, keysFunc) {
    var index = -1,
      iterable = Object(object),
      props = keysFunc(object),
      length = props.length;
    while (length--) {
      var key = props[fromRight ? length : ++index];
      if (iteratee(iterable[key], key, iterable) === false) {
        break;
      }
    }
    return object;
  };
}

/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */
var baseFor = createBaseFor();
var baseFor$1 = baseFor;

/**
 * The base implementation of `_.forOwn` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */
function baseForOwn(object, iteratee) {
  return object && baseFor$1(object, iteratee, keys);
}

/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */
var now$1 = function () {
  return root$1.Date.now();
};
var now$2 = now$1;

/** Error message constants. */
var FUNC_ERROR_TEXT$2 = 'Expected a function';

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max,
  nativeMin = Math.min;

/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */
function debounce$1(func, wait, options) {
  var lastArgs,
    lastThis,
    maxWait,
    result,
    timerId,
    lastCallTime,
    lastInvokeTime = 0,
    leading = false,
    maxing = false,
    trailing = true;
  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT$2);
  }
  wait = toNumber(wait) || 0;
  if (isObject(options)) {
    leading = !!options.leading;
    maxing = 'maxWait' in options;
    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }
  function invokeFunc(time) {
    var args = lastArgs,
      thisArg = lastThis;
    lastArgs = lastThis = undefined;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }
  function leadingEdge(time) {
    // Reset any `maxWait` timer.
    lastInvokeTime = time;
    // Start the timer for the trailing edge.
    timerId = setTimeout(timerExpired, wait);
    // Invoke the leading edge.
    return leading ? invokeFunc(time) : result;
  }
  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime,
      timeSinceLastInvoke = time - lastInvokeTime,
      timeWaiting = wait - timeSinceLastCall;
    return maxing ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke) : timeWaiting;
  }
  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime,
      timeSinceLastInvoke = time - lastInvokeTime;

    // Either this is the first call, activity has stopped and we're at the
    // trailing edge, the system time has gone backwards and we're treating
    // it as the trailing edge, or we've hit the `maxWait` limit.
    return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
  }
  function timerExpired() {
    var time = now$2();
    if (shouldInvoke(time)) {
      return trailingEdge(time);
    }
    // Restart the timer.
    timerId = setTimeout(timerExpired, remainingWait(time));
  }
  function trailingEdge(time) {
    timerId = undefined;

    // Only invoke if we have `lastArgs` which means `func` has been
    // debounced at least once.
    if (trailing && lastArgs) {
      return invokeFunc(time);
    }
    lastArgs = lastThis = undefined;
    return result;
  }
  function cancel() {
    if (timerId !== undefined) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = undefined;
  }
  function flush() {
    return timerId === undefined ? result : trailingEdge(now$2());
  }
  function debounced() {
    var time = now$2(),
      isInvoking = shouldInvoke(time);
    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time;
    if (isInvoking) {
      if (timerId === undefined) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        // Handle invocations in a tight loop.
        clearTimeout(timerId);
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === undefined) {
      timerId = setTimeout(timerExpired, wait);
    }
    return result;
  }
  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}

/**
 * The base implementation of methods like `_.findKey` and `_.findLastKey`,
 * without support for iteratee shorthands, which iterates over `collection`
 * using `eachFunc`.
 *
 * @private
 * @param {Array|Object} collection The collection to inspect.
 * @param {Function} predicate The function invoked per iteration.
 * @param {Function} eachFunc The function to iterate over `collection`.
 * @returns {*} Returns the found element or its key, else `undefined`.
 */
function baseFindKey(collection, predicate, eachFunc) {
  var result;
  eachFunc(collection, function (value, key, collection) {
    if (predicate(value, key, collection)) {
      result = key;
      return false;
    }
  });
  return result;
}

/**
 * This method is like `_.find` except that it returns the key of the first
 * element `predicate` returns truthy for instead of the element itself.
 *
 * @static
 * @memberOf _
 * @since 1.1.0
 * @category Object
 * @param {Object} object The object to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @returns {string|undefined} Returns the key of the matched element,
 *  else `undefined`.
 * @example
 *
 * var users = {
 *   'barney':  { 'age': 36, 'active': true },
 *   'fred':    { 'age': 40, 'active': false },
 *   'pebbles': { 'age': 1,  'active': true }
 * };
 *
 * _.findKey(users, function(o) { return o.age < 40; });
 * // => 'barney' (iteration order is not guaranteed)
 *
 * // The `_.matches` iteratee shorthand.
 * _.findKey(users, { 'age': 1, 'active': true });
 * // => 'pebbles'
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.findKey(users, ['active', false]);
 * // => 'fred'
 *
 * // The `_.property` iteratee shorthand.
 * _.findKey(users, 'active');
 * // => 'barney'
 */
function findKey(object, predicate) {
  return baseFindKey(object, baseIteratee(predicate), baseForOwn);
}

/** `Object#toString` result references. */
var mapTag = '[object Map]',
  setTag = '[object Set]';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Checks if `value` is an empty object, collection, map, or set.
 *
 * Objects are considered empty if they have no own enumerable string keyed
 * properties.
 *
 * Array-like values such as `arguments` objects, arrays, buffers, strings, or
 * jQuery-like collections are considered empty if they have a `length` of `0`.
 * Similarly, maps and sets are considered empty if they have a `size` of `0`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is empty, else `false`.
 * @example
 *
 * _.isEmpty(null);
 * // => true
 *
 * _.isEmpty(true);
 * // => true
 *
 * _.isEmpty(1);
 * // => true
 *
 * _.isEmpty([1, 2, 3]);
 * // => false
 *
 * _.isEmpty({ 'a': 1 });
 * // => false
 */
function isEmpty(value) {
  if (value == null) {
    return true;
  }
  if (isArrayLike(value) && (isArray$1(value) || typeof value == 'string' || typeof value.splice == 'function' || isBuffer$1(value) || isTypedArray$1(value) || isArguments$1(value))) {
    return !value.length;
  }
  var tag = getTag$1(value);
  if (tag == mapTag || tag == setTag) {
    return !value.size;
  }
  if (isPrototype(value)) {
    return !baseKeys(value).length;
  }
  for (var key in value) {
    if (hasOwnProperty.call(value, key)) {
      return false;
    }
  }
  return true;
}

/**
 * Performs a deep comparison between two values to determine if they are
 * equivalent.
 *
 * **Note:** This method supports comparing arrays, array buffers, booleans,
 * date objects, error objects, maps, numbers, `Object` objects, regexes,
 * sets, strings, symbols, and typed arrays. `Object` objects are compared
 * by their own, not inherited, enumerable properties. Functions and DOM
 * nodes are compared by strict equality, i.e. `===`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.isEqual(object, other);
 * // => true
 *
 * object === other;
 * // => false
 */
function isEqual$2(value, other) {
  return baseIsEqual(value, other);
}

/**
 * Checks if `value` is `null` or `undefined`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
 * @example
 *
 * _.isNil(null);
 * // => true
 *
 * _.isNil(void 0);
 * // => true
 *
 * _.isNil(NaN);
 * // => false
 */
function isNil(value) {
  return value == null;
}

/** Error message constants. */
var FUNC_ERROR_TEXT$1 = 'Expected a function';

/**
 * Creates a function that negates the result of the predicate `func`. The
 * `func` predicate is invoked with the `this` binding and arguments of the
 * created function.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Function
 * @param {Function} predicate The predicate to negate.
 * @returns {Function} Returns the new negated function.
 * @example
 *
 * function isEven(n) {
 *   return n % 2 == 0;
 * }
 *
 * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
 * // => [1, 3, 5]
 */
function negate(predicate) {
  if (typeof predicate != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT$1);
  }
  return function () {
    var args = arguments;
    switch (args.length) {
      case 0:
        return !predicate.call(this);
      case 1:
        return !predicate.call(this, args[0]);
      case 2:
        return !predicate.call(this, args[0], args[1]);
      case 3:
        return !predicate.call(this, args[0], args[1], args[2]);
    }
    return !predicate.apply(this, args);
  };
}

/**
 * The base implementation of `_.set`.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to set.
 * @param {*} value The value to set.
 * @param {Function} [customizer] The function to customize path creation.
 * @returns {Object} Returns `object`.
 */
function baseSet(object, path, value, customizer) {
  if (!isObject(object)) {
    return object;
  }
  path = castPath(path, object);
  var index = -1,
    length = path.length,
    lastIndex = length - 1,
    nested = object;
  while (nested != null && ++index < length) {
    var key = toKey(path[index]),
      newValue = value;
    if (key === '__proto__' || key === 'constructor' || key === 'prototype') {
      return object;
    }
    if (index != lastIndex) {
      var objValue = nested[key];
      newValue = customizer ? customizer(objValue, key, nested) : undefined;
      if (newValue === undefined) {
        newValue = isObject(objValue) ? objValue : isIndex(path[index + 1]) ? [] : {};
      }
    }
    assignValue(nested, key, newValue);
    nested = nested[key];
  }
  return object;
}

/**
 * The base implementation of  `_.pickBy` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The source object.
 * @param {string[]} paths The property paths to pick.
 * @param {Function} predicate The function invoked per property.
 * @returns {Object} Returns the new object.
 */
function basePickBy(object, paths, predicate) {
  var index = -1,
    length = paths.length,
    result = {};
  while (++index < length) {
    var path = paths[index],
      value = baseGet(object, path);
    if (predicate(value, path)) {
      baseSet(result, castPath(path, object), value);
    }
  }
  return result;
}

/**
 * Creates an object composed of the `object` properties `predicate` returns
 * truthy for. The predicate is invoked with two arguments: (value, key).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The source object.
 * @param {Function} [predicate=_.identity] The function invoked per property.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.pickBy(object, _.isNumber);
 * // => { 'a': 1, 'c': 3 }
 */
function pickBy(object, predicate) {
  if (object == null) {
    return {};
  }
  var props = arrayMap(getAllKeysIn(object), function (prop) {
    return [prop];
  });
  predicate = baseIteratee(predicate);
  return basePickBy(object, props, function (value, path) {
    return predicate(value, path[0]);
  });
}

/**
 * The opposite of `_.pickBy`; this method creates an object composed of
 * the own and inherited enumerable string keyed properties of `object` that
 * `predicate` doesn't return truthy for. The predicate is invoked with two
 * arguments: (value, key).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The source object.
 * @param {Function} [predicate=_.identity] The function invoked per property.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.omitBy(object, _.isNumber);
 * // => { 'b': '2' }
 */
function omitBy(object, predicate) {
  return pickBy(object, negate(baseIteratee(predicate)));
}

/**
 * The base implementation of `_.pick` without support for individual
 * property identifiers.
 *
 * @private
 * @param {Object} object The source object.
 * @param {string[]} paths The property paths to pick.
 * @returns {Object} Returns the new object.
 */
function basePick(object, paths) {
  return basePickBy(object, paths, function (value, path) {
    return hasIn(object, path);
  });
}

/**
 * Creates an object composed of the picked `object` properties.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The source object.
 * @param {...(string|string[])} [paths] The property paths to pick.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.pick(object, ['a', 'c']);
 * // => { 'a': 1, 'c': 3 }
 */
var pick$1 = flatRest(function (object, paths) {
  return object == null ? {} : basePick(object, paths);
});
var pick$2 = (/* unused pure expression or super */ null && (pick$1));

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/**
 * Creates a throttled function that only invokes `func` at most once per
 * every `wait` milliseconds. The throttled function comes with a `cancel`
 * method to cancel delayed `func` invocations and a `flush` method to
 * immediately invoke them. Provide `options` to indicate whether `func`
 * should be invoked on the leading and/or trailing edge of the `wait`
 * timeout. The `func` is invoked with the last arguments provided to the
 * throttled function. Subsequent calls to the throttled function return the
 * result of the last `func` invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the throttled function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.throttle` and `_.debounce`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to throttle.
 * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=true]
 *  Specify invoking on the leading edge of the timeout.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new throttled function.
 * @example
 *
 * // Avoid excessively updating the position while scrolling.
 * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
 *
 * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
 * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
 * jQuery(element).on('click', throttled);
 *
 * // Cancel the trailing throttled invocation.
 * jQuery(window).on('popstate', throttled.cancel);
 */
function throttle$1(func, wait, options) {
  var leading = true,
    trailing = true;
  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  if (isObject(options)) {
    leading = 'leading' in options ? !!options.leading : leading;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }
  return debounce$1(func, wait, {
    'leading': leading,
    'maxWait': wait,
    'trailing': trailing
  });
}

const GLOBAL_INFO = {
  /** 미국 */
  US: {
    currency: 'USD',
    locale: 'en'
  },
  /** 일본 */
  JP: {
    currency: 'JPY',
    locale: 'ja'
  },
  /** 인도네시아 */
  ID: {
    currency: 'IDR',
    locale: 'id'
  },
  /** 한국 */
  KR: {
    currency: 'KRW',
    locale: 'ko'
  }
};
const GLOBAL_DEFAULT_LOCALE = 'en';

/**
 * 국가별 통화에 맞게 가격을 formatting 합니다.
 */
const formatPriceByCurrency = (price, currency) => {
  if (!currency) {
    return price.toLocaleString();
  }
  const country = findKey(GLOBAL_INFO, global => global.currency === currency) ?? 'KR';
  const locale = GLOBAL_INFO[country].locale;
  const intl = new Intl.NumberFormat(locale, {
    style: 'currency',
    currency
  });
  const originalFormattedPrice = intl.format(price);
  let formattedPrice = '';
  switch (currency) {
    /** 미국 */
    case 'USD':
      formattedPrice = originalFormattedPrice.replace('.00', '');
      break;
    /** 인도네시아 */
    case 'IDR':
      formattedPrice = originalFormattedPrice.replace(',00', '').replace(/\u00A0/, '');
      break;
    /** 일본 */
    case 'JPY':
    case 'KRW':
    default:
      formattedPrice = originalFormattedPrice;
      break;
  }
  return formattedPrice;
};

class HTTPError extends Error {
  constructor(status, body) {
    super(`HTTP ${status} occurred while sending fetch request.`);
    this.status = status;
    this.body = body;
    this.hasMessage = false;
  }
}

const globalLocales = ['en', 'ja', 'id'];
const locales = [...globalLocales, 'ko'];
const globalCountries = ['US', 'JP', 'ID'];
const countries = [...globalCountries, 'KR'];

const fetchSugar = async ({
  url,
  method,
  body = {},
  headers = {
    'Accept': 'application/json',
    'Content-Type': 'application/json'
  },
  credentials = 'same-origin',
  ignoreError = false
}) => {
  const response = await fetch(url, {
    credentials,
    headers,
    method,
    ...(method === 'GET' ? {} : {
      body: JSON.stringify(body)
    })
  });
  if (!ignoreError && !response.ok) {
    const error = new HTTPError(response.status, {
      url: response.url,
      method,
      body
    });
    try {
      const json = await response.json();
      if (json.message) {
        error.message = json.message;
        error.hasMessage = true;
      }
    } catch (e) {
      // noop
    }
    throw error;
  }
  return response;
};
const fetchGet = async (url, options) => {
  return await fetchSugar({
    url,
    method: 'GET',
    ...options
  });
};
const fetchDelete = async (url, body = {}, options) => {
  return await fetchSugar({
    url,
    method: 'DELETE',
    body,
    ...options
  });
};
const fetchPut = async (url, body = {}, options) => {
  return await fetchSugar({
    url,
    method: 'PUT',
    body,
    ...options
  });
};
const fetchPost = async (url, body = {}, options) => {
  return await fetchSugar({
    url,
    method: 'POST',
    body,
    ...options
  });
};
const fetchPatch = async (url, body = {}, options) => {
  return await fetchSugar({
    url,
    method: 'PATCH',
    body,
    ...options
  });
};

const COMMERCE_PATTERN = /^\/productions|^\/store|^\/commerces|^\/exhibitions|^\/cart/;
const O2O_PATTERN = /^\/experts|^\/expert_users/;

/**
 * 현재 URL과 매칭되는 서비스 타입을 반환합니다.
 * @returns {string} 'hnc' | 'commerce | 'o2o'
 */
const getServiceType = (subdomain, pathname) => {
  switch (subdomain) {
    case 'store':
    case 'partner':
    case 'events':
      return 'commerce';
    case 'o2o':
    case 'expert':
      return 'o2o';
    case 'content':
      return 'hnc';
    case 'home':
      {
        if (COMMERCE_PATTERN.test(pathname)) {
          return 'commerce';
        }
        if (O2O_PATTERN.test(pathname)) {
          return 'o2o';
        }
        return 'hnc';
      }
    default:
      return 'hnc';
  }
};

/** 국외향 도메인 */
const GLOBAL_DOMAINS = {
  prod: {
    home: 'https://www.ohouse.com',
    content: 'https://content.ohouse.com',
    store: 'https://store.ohouse.com',
    o2o: undefined,
    events: undefined,
    partner: undefined,
    expert: undefined
  },
  qa: {
    home: 'https://qa-web.ohouse.in',
    content: 'https://content.qa-web.ohouse.in',
    store: 'https://store.qa-web.ohouse.in',
    o2o: undefined,
    events: undefined,
    partner: undefined,
    expert: undefined
  },
  stage: {
    home: 'https://global.stage-web.dailyhou.se',
    content: 'https://content-global.stage-web.dailyhou.se',
    store: 'https://store-global.stage-web.dailyhou.se',
    o2o: undefined,
    events: undefined,
    partner: undefined,
    expert: undefined
  },
  dev: {
    home: 'https://global.dev-web.dailyhou.se',
    content: 'https://content-global.dev-web.dailyhou.se',
    store: 'https://store-global.dev-web.dailyhou.se',
    o2o: undefined,
    events: undefined,
    partner: undefined,
    expert: undefined
  },
  local: {
    home: 'https://qa-web.ohouse.in',
    content: 'https://content.qa-web.ohouse.in',
    store: 'https://store.qa-web.ohouse.in',
    o2o: undefined,
    events: undefined,
    partner: undefined,
    expert: undefined
  }
};

/** 국내향 도메인 */
const DOMAINS = {
  prod: {
    home: 'https://ohou.se',
    content: 'https://contents.ohou.se',
    store: 'https://store.ohou.se',
    o2o: 'https://o2o.ohou.se',
    events: 'https://events.ohou.se',
    partner: 'https://partners.ohou.se',
    expert: 'https://pro.ohou.se'
  },
  qa: {
    home: 'https://qa-web.dailyhou.se',
    content: 'https://contents.qa-web.dailyhou.se',
    store: 'https://store.qa-web.dailyhou.se',
    o2o: 'https://o2o.qa-web.dailyhou.se',
    events: 'https://events.qa-web.dailyhou.se',
    partner: 'https://partners.qa.dailyhou.se',
    expert: 'https://pro.qa-web.dailyhou.se'
  },
  stage: {
    home: 'https://stage-web.dailyhou.se',
    content: 'https://contents.stage-web.dailyhou.se',
    store: 'https://store.stage-web.dailyhou.se',
    o2o: 'https://o2o.stage-web.dailyhou.se',
    events: 'https://events.stage-web.dailyhou.se',
    partner: 'https://partners.stage.dailyhou.se',
    expert: 'https://pro.stage-web.dailyhou.se'
  },
  dev: {
    home: 'https://dev-web.dailyhou.se',
    content: 'https://contents.dev-web.dailyhou.se',
    store: 'https://store.dev-web.dailyhou.se',
    o2o: 'https://o2o.dev-web.dailyhou.se',
    events: 'https://events.dev-web.dailyhou.se',
    partner: 'https://partners.dev.dailyhou.se',
    expert: 'https://pro.dev-web.dailyhou.se'
  },
  local: {
    home: 'https://dev-web.dailyhou.se',
    content: 'https://contents.dev-web.dailyhou.se',
    store: 'https://store.dev-web.dailyhou.se',
    o2o: 'https://o2o.dev-web.dailyhou.se',
    events: 'https://events.dev-web.dailyhou.se',
    partner: 'https://partners.stage.dailyhou.se',
    expert: 'https://pro.dev-web.dailyhou.se'
  }
};
const API_AUTOCOMPLETE_HOST = {
  prod: 'https://autocomplete.datahou.se',
  qa: 'https://autocomplete.qa.datahou.se',
  stage: 'https://autocomplete.stage.datahou.se',
  dev: 'https://autocomplete.stage.datahou.se',
  local: 'https://autocomplete.stage.datahou.se'
};

/** 국외향 API GATEWAY */
const GLOBAL_API_GATEWAY = {
  prod: 'http://global-mbff.common',
  qa: 'http://global-mbff.common',
  stage: 'http://global-mbff.common',
  dev: 'http://global-mbff.common',
  local: 'https://mbff.qa-web.ohouse.in'
};

/** 국외향에서 사용하는 default metadata */
const GLOBAL_DEFAULT_METADATA = {
  ko: {
    title: '라이프스타일 슈퍼앱, 오늘의집',
    description: '감도높은 유저들의 일상 구경부터 제품 구매까지 한번에'
  },
  en: {
    title: 'Ohouse | Community driven interior design and inspiration',
    description: 'See how interior design enthusiasts decorate and furnish their home',
    siteName: 'Ohouse'
  },
  ja: {
    title: 'Ohouse(オーハウス)|部屋と家具のインテリア写真が見放題',
    description: '世界中の様々なテイストや間取りのインテリア写真が見放題！実際のユーザーの写真から欲しい家具や雑貨を見つけるインテリアコミュニティーサービス。',
    siteName: 'Ohouse'
  },
  id: {
    title: 'Ohouse | Komunitas no. 1 home styling di Indonesia',
    description: 'Intip ke dalam rumah-rumah estetik untuk mendapatkan inspirasi nge-bangun dan nge-dekor',
    siteName: 'Ohouse'
  }
};
const DEFAULT_OG_IMAGE = {
  global: 'https://image.ohouse.com/oh-image-ap-northeast-2/site/1_Ohouse_mark_horizontal_black_og.png',
  domestic: 'https://image.ohou.se/i/bucketplace-v2-development/uploads/default_images/open_graph_icon_2.png'
};

/**
 * 도메인에 따른 URL을 리턴합니다.
 * 이동하려는 URL과 현재 도메인이 다를 경우에만 full URL을 리턴합니다.
 * @param {string} subdomain - 현재 서브도메인
 * @param {string} env - 현재 서비스 환경
 * @param {string} url - 이동하려는 URL
 * @param {string} serviceType - 국내 또는 국외향 판단
 * @returns {string}
 */
const getURL = (subdomain, env, url, serviceType) => {
  const SERVICE_TYPE_DOMAINS = serviceType === 'OG' ? GLOBAL_DOMAINS : DOMAINS;
  const redirectURL = url.replace(SERVICE_TYPE_DOMAINS[env][subdomain] ?? '', '');
  return redirectURL === '' ? '/' : redirectURL;
};

/**
 * 로그인을 위한 리다이렉션
 */
const REDIRECTION_PATH_MAP = {
  home: undefined,
  content: '/contents-web',
  store: '/stores',
  o2o: '/o2o-web',
  events: '/events',
  partner: undefined,
  expert: undefined
};

/**
 * 유저 정보가 없을 경우, 로그인 URL을 리턴합니다.
 * 유저 정보가 있을 경우, 이동하려는 URL 그대로를 리턴합니다.
 * @param {Object|null} user - 유저 정보
 * @param {string} subdomain - 현재 서브도메인
 * @param {string} env - 현재 서비스 환경
 * @param {string} url - 이동하려는 URL
 * @returns {string}
 */
const getLoginURL = (user, subdomain, env, url, serviceType, locale) => {
  // Check if it is correct URL
  try {
    const isGlobal = serviceType === 'OG';
    const {
      pathname,
      search,
      hash
    } = new URL(url);
    if (user != null) {
      return url;
    }
    if (isGlobal) {
      const loginURL = `${GLOBAL_DOMAINS[env].home}/${locale}/sign-in?redirect-to=`;
      switch (subdomain) {
        case 'home':
          {
            const redirectURL = [pathname, search, hash].join('');
            return getURL(subdomain, env, `${loginURL}${encodeURIComponent(redirectURL)}`, serviceType);
          }
        default:
          return getURL(subdomain, env, `${loginURL}${encodeURIComponent(url)}`, serviceType);
      }
    }
    const loginURL = `${DOMAINS[env].home}/users/sign_in?redirect_to=`;
    switch (subdomain) {
      case 'content':
      case 'store':
      case 'o2o':
      case 'events':
        {
          const redirectURL = [REDIRECTION_PATH_MAP[subdomain], pathname, search, hash].join('');
          return getURL(subdomain, env, `${loginURL}${encodeURIComponent(redirectURL)}`, serviceType);
        }
      default:
        {
          const redirectURL = [pathname, search, hash].join('');
          return getURL(subdomain, env, `${loginURL}${encodeURIComponent(redirectURL)}`, serviceType);
        }
    }
  } catch (error) {
    return '';
  }
};
const getCookieDomain = (env, subdomain, serviceType) => {
  try {
    const domain = serviceType === 'OG' ? GLOBAL_DOMAINS[env].home : DOMAINS[env].home;
    const {
      host
    } = new URL(domain);
    if (typeof window !== 'undefined' && env === 'local' && subdomain === 'home') {
      return `${window.location.hostname}`;
    }
    // NOTE: 글로벌 환경은 www.ohouse.com 을 도메인으로 사용하지만 쿠키 도메인은 모든 서브도메인을 대응하기 위해서 .ohouse.com 으로 설정합니다.
    if (host === 'www.ohouse.com') {
      return `.ohouse.com`;
    }
    return `.${host}`;
  } catch (error) {
    return '.ohou.se';
  }
};
/**
 * 주어진 URL 배열을 '|'로 연결된 regex 로 반환하는 함수
 */
const convertUrlsToRegex = urlList => {
  const regexString = urlList.map(url => url.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')).join('|');

  // 문자열로부터 RegExp 객체 생성
  return new RegExp(regexString);
};

/**
 * 콘텐츠 서버에서 내려오는 landingUrl 을 각 host 에 맞게 변환해주는 함수
 * @param hostType 'content' | 'home' landingUrl 의 host 는 content, home 기반으로만 내려온다고 전달받았으므로, 해당 경우에는 각 MSA 도메인에서는 상대 경로로 이동하게 하기 위해 hostType을 받습니다.
 *   만약 content, home 기반이 아닌 다른 도메인 기반의 host를 가진 url이 내려온다면 그대로 반환합니다.
 * @param landingUrl 컨버팅할 url로 서버에서 내려오는 landingUrl 필드입니다.
 * @return 변환된 url을 반환합니다.
 */
const convertLandingUrlByHost = ({
  hostType,
  landingUrl,
  serviceType,
  env
}) => {
  const landingUrlHostMap = {
    content: {
      originalHost: convertUrlsToRegex([GLOBAL_DOMAINS.prod.content, DOMAINS.prod.content]),
      targetHost: serviceType === 'OG' ? GLOBAL_DOMAINS[env].content : DOMAINS[env].content
    },
    home: {
      originalHost: convertUrlsToRegex([GLOBAL_DOMAINS.prod.home, DOMAINS.prod.home]),
      targetHost: serviceType === 'OG' ? GLOBAL_DOMAINS[env].home : DOMAINS[env].home
    }
  };
  switch (hostType) {
    case 'content':
      landingUrlHostMap.content.targetHost = '';
      break;
    case 'home':
      landingUrlHostMap.home.targetHost = '';
      break;
  }
  let convertedUrl = landingUrl;
  Object.values(landingUrlHostMap).forEach(({
    originalHost,
    targetHost
  }) => {
    convertedUrl = convertedUrl.replace(originalHost, targetHost);
  });
  return convertedUrl;
};

/**
 * url에서 protocol을 제거한 값을 리턴합니다.
 * @param url
 */
const getUrlWithoutProtocol = url => {
  if (url.startsWith('http://')) {
    return url.replace('http://', '');
  }
  if (url.startsWith('https://')) {
    return url.replace('https://', '');
  }
  return url;
};
/**
 * url에서 hostname을 리턴합니다.
 * @param url
 */
const getHostname = url => {
  const urlWithoutProtocol = getUrlWithoutProtocol(url);
  const splittedUrl = urlWithoutProtocol.split('/');
  return splittedUrl[0] ?? '';
};

/**
 * 허용하는 locale인지 확인합니다.
 * @param locale string
 * @returns 허용하는 locale이라면 그대로 리턴합니다. 허용하지 않는 locale이라면 null을 리턴합니다.
 */
const checkAllowedLocale = locale => {
  if (!locale) {
    return null;
  }
  return globalLocales.find(allowedLocale => allowedLocale === locale) ?? null;
};

/**
 * 주어진 url에 포함된 locale 값을 리턴합니다. 값이 없거나 대응하지 않는 locale인 경우 null을 리턴합니다.
 * @param url
 */
const getLocaleFromUrl = url => {
  const urlWithoutProtocol = getUrlWithoutProtocol(url);
  const pathname = urlWithoutProtocol.split('?')[0];
  const splittedPathname = pathname && pathname.split('/');
  const localeFromUrl = splittedPathname && splittedPathname[1];
  return checkAllowedLocale(localeFromUrl);
};

/**
 * 주어진 url에 서비스에서 대응하는 locale 값이 포함되어 있는지 확인합니다.
 * @param url
 */
const isUrlWithLocale = url => {
  return !!getLocaleFromUrl(url);
};

/**
 * locale을 포함한 root pathname(ex. /ja, /en/)인지 확인합니다.
 * @param relativeUrl relativeUrl(ex. /ja/goods/1234)
 * @param locale GlobalLocale
 */
const isRootPathnameWithLocale = relativeUrl => {
  const locale = getLocaleFromUrl(relativeUrl);
  const pathname = relativeUrl.split('?')[0];
  return pathname === `/${locale}` || pathname === `/${locale}/`;
};

/**
 * 주어진 url에 포함되어 있는 locale 값을 changeLocale로 변경하여 전달합니다.
 * 만약 locale이 없는 경우 추가하여 전달합니다.
 * @param url
 * @param changeLocale 변경하려는 Locale
 * @returns locale이 바뀐 Url
 */
const getUrlWithExchangeLocale = (url, changeLocale) => {
  const localeFromUrl = getLocaleFromUrl(url);
  const hostname = getHostname(url);
  if (localeFromUrl) {
    return url.replace(`${hostname}/${localeFromUrl}`, `${hostname}/${changeLocale}`);
  } else {
    return url.replace(`${hostname}`, `${hostname}/${changeLocale}`);
  }
};
const CONTENT_WEB_GLOBAL_APP_NAME = 'content-web-global';
const createGlobalDefaultUrl = ({
  env,
  locale,
  country,
  appName
}) => {
  let defaultPathname = null;
  switch (country) {
    case 'US':
      defaultPathname = '/projects';
      break;
    default:
      defaultPathname = '/topics/recommend';
  }
  if (appName === CONTENT_WEB_GLOBAL_APP_NAME) {
    return `/${locale}${defaultPathname}`;
  }
  return `${GLOBAL_DOMAINS[env]['content']}/${locale}${defaultPathname}`;
};

/**
 * NextJS 서버 요청 중 웹 페이지 요청인지를 판단합니다.
 * @param relativeUrl 요청 url
 * @returns 웹 페이지 요청인지
*/
const isNextJsPageRequest = relativeUrl => {
  const PUBLIC_FILE_REGEXP = /\.[^.]*$/;
  const pathname = relativeUrl.split('?')[0] ?? '';
  return !pathname.startsWith('/_next') && !pathname.startsWith('/api/') && !PUBLIC_FILE_REGEXP.test(pathname);
};

const getClientIp = req => {
  const ip = req.headers['x-forwarded-for']?.toString().split(',').shift();
  if (ip) {
    return ip;
  }
  return req.socket.remoteAddress;
};

/**
 * 검색 로봇 userAgent인지 판단합니다.
 * @param userAgent string
*/
const isSearchRobot = userAgent => {
  const googlebotRegex = /Googlebot/i;
  const yahooSlurpRegex = /Slurp/i;
  const microsoftBingbotRegex = /bingbot/i;
  const searchBotRegexs = [googlebotRegex, yahooSlurpRegex, microsoftBingbotRegex];
  return searchBotRegexs.some(robot => userAgent && robot.test(userAgent));
};

const logGtm = (event, data) => {
  if (!window) {
    return;
  }
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event,
    ...data
  });
};

/* eslint-disable @typescript-eslint/no-explicit-any */

const useScrapLogger = () => {
  const logScrap = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(({
    contentType,
    contentId,
    bucketLogData = {},
    brazeLogData
  }) => {
    L({
      ...bucketLogData,
      category: 'scrap',
      type: humpsExports.decamelize(contentType),
      id: contentId
    });
    if (brazeLogData) {
      logBraze('add_scrap', {
        ...brazeLogData,
        type: contentType,
        productionId: contentId
      });
    }
    logAirbridge({
      category: 'add_to_wishlist',
      attribute: {
        action: 'type',
        label: contentType === 'Advice' && 'KNOWHOW' || contentType === 'CardCollection' && 'CARD_COLLECTION' || contentType === 'Card' && 'CARD' || contentType === 'Production' && 'PRODUCT' || contentType === 'Deal' && 'PRODUCT' || contentType === 'Exhibition' && 'EXHIBITION' || contentType === 'Project' && 'PROJECT' || '',
        customAttributes: {
          id: contentId
        }
      }
    });
  }, []);
  const logUnScrap = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(({
    contentType,
    contentId,
    bucketLogData = {}
  }) => {
    L({
      ...bucketLogData,
      category: 'unscrap',
      type: contentType,
      id: contentId
    });
  }, []);
  const logScrapSuccess = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(({
    contentType,
    contentId,
    count,
    amplitudeLogData
  }) => {
    logGtm('content_scrap', {
      type: humpsExports.decamelize(contentType),
      id: contentId
    });
    const amplitude = getAmplitude();
    if (amplitudeLogData && amplitude) {
      const identify = new amplitude.Identify();
      identify.set('Total Number of 스크랩 - 전체', count);
      if (['Production', 'Deal'].includes(contentType)) {
        identify.add('Total Number of 스크랩 - 상품', 1);
      }
      amplitude.identify(identify);
      const getAmplitudeLogEventType = () => {
        switch (contentType) {
          case 'Production':
          case 'Deal':
            return '상품 Added to Scrapbook Success';
          case 'Exhibition':
            return '프로모션 Added to Scrapbook Success';
          default:
            return '컨텐츠 Added to Scrapbook Success';
        }
      };
      logAmplitude$1(getAmplitudeLogEventType(), amplitudeLogData);
    }
  }, []);
  const logUnscrapSuccess = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(({
    contentType,
    contentId
  }) => {
    logGtm('content_unscrap', {
      type: contentType,
      id: contentId
    });
  }, []);
  const logSelectScrapBook = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(({
    scrapBookId,
    contentIds
  }) => {
    L({
      category: 'click',
      section: '스크랩 대량 편집',
      type: 'scrap_book',
      id: scrapBookId,
      data: contentIds
    });
  }, []);
  const logClickScrapBook = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(() => {
    L({
      category: 'click',
      section: '스크랩 스낵바',
      type: 'scrap_book'
    });
  }, []);
  const logClickScrapBookTo = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(() => {
    L({
      category: 'scrap',
      section: '폴더링 완료 스낵바',
      type: 'scrap_book'
    });
  }, []);
  return {
    logScrap,
    logUnScrap,
    logScrapSuccess,
    logUnscrapSuccess,
    logSelectScrapBook,
    logClickScrapBook,
    logClickScrapBookTo
  };
};

function useToggle$1(options = {}) {
  const [open, setOpen] = useState(options.initialValue);
  const handleOpen = useCallback(() => setOpen(true), []);
  const handleClose = useCallback(() => setOpen(false), []);
  const handleToggle = useCallback(flag => {
    setOpen(prevState => flag ?? !prevState);
  }, []);
  return {
    open: open ?? false,
    isInitial: open == null,
    handleOpen,
    handleClose,
    handleToggle
  };
}

/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * webview 이벤트에 리스너를 연결합니다.
 * 컴포넌트가 언마운트 되면 연결해둔 리스너도 같이 제거됩니다.
 * **최적화를 위해 이벤트 리스너는 useCallback으로 memoize 하는 것을 권장합니다**
 * @param {WebviewEventType} type 웹뷰 이벤트 타입
 * @param {WebviewEventListener} listener 이벤트 리스너
 */
const useWebviewEventListener = (type, listener) => {
  // 특정한 event type인 경우만 리스너를 실행
  const callback = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(event => {
    if (type !== event.type) {
      return;
    }
    listener(event);
  }, [type, listener]);
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    const windowObj = window;

    // BucketUtils 전역객체 초기화
    if (!windowObj.BucketUtils) {
      windowObj.BucketUtils = {};
    }

    // BucketUtils.sendEvent,
    // BucketUtils.sendEvent.callback 초기화
    if (!windowObj.BucketUtils.sendEvent) {
      windowObj.BucketUtils.sendEvent = event => {
        (windowObj.BucketUtils.sendEvent.callbacks || []).forEach(callback => callback(event));
      };
      windowObj.BucketUtils.sendEvent.callbacks = [];
    }

    // 리스너 등록
    const {
      callbacks
    } = windowObj.BucketUtils.sendEvent;
    callbacks.push(callback);

    // 언마운트 시 리스너 제거
    return () => {
      const index = callbacks.indexOf(callback);
      if (index > -1) {
        callbacks.splice(index, 1);
      }
    };
  }, [callback]);
};

/**
 * 앱으로 이벤트를 전송하는 webview 이벤트 dispatcher를 반환합니다.
 * @return {function} 이벤트 dispatcher
 */
const useWebviewEventDispatcher = () => {
  const dispatchWebviewEvent = event => {
    try {
      const windowObj = window;
      windowObj.webkit?.messageHandlers?.ohouseEventInterface?.postMessage?.(event);
      windowObj.ohouseEventInterface?.sendEvent?.(JSON.stringify(event));
    } catch (e) {
      // noop
    }
  };
  return dispatchWebviewEvent;
};

const useIntersectionObserver = ({
  options,
  onIntersect
}) => {
  const {
    ref: target,
    inView
  } = useInView(options);
  useEffect(() => {
    if (inView) {
      onIntersect();
    }
  }, [inView, onIntersect]);
  return target;
};

const useMergeRef = (...refs) => {
  return (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(node => refs.forEach(ref => {
    if (ref === null) {
      return;
    }
    if (typeof ref === 'function') {
      ref(node);
      return;
    }
    ref.current = node;
  }), [refs]);
};

function _EMOTION_STRINGIFIED_CSS_ERROR__$U() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
const ScrapBookCreateForm = ({
  onSubmit
}) => {
  const [editing, setEditing] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false);
  const [value, setValue] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)('');
  if (!editing) {
    return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(Container$q, {
      size: "basic",
      variant: "thin",
      children: (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsxs */ .BX)(CreateButton, {
        type: "button",
        onClick: () => setEditing(true),
        children: [(0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(IconBox, {
          blue: true,
          children: (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(_bucketplace_design_system_bds__WEBPACK_IMPORTED_MODULE_8__/* .Icon */ .JO$, {
            name: "add_thick",
            size: 18
          })
        }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(CreateButtonText, {
          children: "\uC0C8\uB85C\uC6B4 \uD3F4\uB354 \uCD94\uAC00\uD558\uAE30"
        })]
      })
    });
  }
  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsxs */ .BX)(Container$q, {
    size: "basic",
    variant: "thin",
    children: [(0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(IconBox, {
      children: (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(_bucketplace_design_system_bds__WEBPACK_IMPORTED_MODULE_8__/* .Icon */ .JO$, {
        name: "add_thick",
        size: 18
      })
    }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(Input, {
      placeholder: "\uD3F4\uB354\uBA85\uC744 \uC785\uB825\uD558\uC138\uC694",
      maxLength: 15,
      value: value,
      onChange: e => setValue(e.target.value)
    }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(_bucketplace_design_system_bds__WEBPACK_IMPORTED_MODULE_8__/* .Button */ .zxk, {
      size: 32,
      type: "button",
      variant: "primary1",
      disabled: value.length === 0,
      onClick: () => onSubmit(value),
      children: "\uC644\uB8CC"
    })]
  });
};
const Container$q = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_bucketplace_design_system_bds__WEBPACK_IMPORTED_MODULE_8__/* .DividerListItem */ .vkq,  true ? {
  target: "e1tlor0y4"
} : 0)( true ? {
  name: "vjnku4",
  styles: "display:flex;align-items:center;width:100%;box-sizing:border-box"
} : 0);
const CreateButton = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)("button",  true ? {
  target: "e1tlor0y3"
} : 0)("overflow-x:hidden;display:flex;align-items:center;width:100%;padding:0;border:0;box-sizing:border-box;color:", ({
  theme
}) => theme.content.base1, ";background:none;" + ( true ? "" : 0));
const CreateButtonText = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)("span",  true ? {
  target: "e1tlor0y2"
} : 0)("display:inline-block;margin-left:", (0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.p)(10), ";font-size:", (0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.p)(16), ";font-weight:700;" + ( true ? "" : 0));
const IconBox = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)("span",  true ? {
  target: "e1tlor0y1"
} : 0)("position:relative;flex-shrink:0;display:inline-flex;align-items:center;justify-content:center;width:", (0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.p)(40), ";height:", (0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.p)(40), ";border-radius:", (0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.p)(4), ";color:", ({
  theme
}) => theme.content.white, ";background:", ({
  theme,
  blue
}) => blue ? theme.content.primary1.basic : theme.content.base3, ";" + ( true ? "" : 0));
const Input = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)("input",  true ? {
  target: "e1tlor0y0"
} : 0)("flex:1 1 0%;min-width:0;margin:0 ", (0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.p)(8), " 0 ", (0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.p)(10), ";border:0;color:", ({
  theme
}) => theme.content.base1, ";caret-color:", ({
  theme
}) => theme.content.primary1.basic, ";background:none;font-size:", (0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.p)(16), ";&::placeholder{color:", ({
  theme
}) => theme.content.base3, ";}" + ( true ? "" : 0));

const ScrapBookItem = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_0__.memo)(({
  id,
  name,
  lastImageUrl,
  onSelect
}) => {
  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(_bucketplace_design_system_bds__WEBPACK_IMPORTED_MODULE_8__/* .DividerListItem */ .vkq, {
    size: "basic",
    variant: "thin",
    children: (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsxs */ .BX)(Button$3, {
      type: "button",
      onClick: () => onSelect(id, name),
      children: [(0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(ImageBox, {
        children: lastImageUrl && (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_9__.R, {
          src: lastImageUrl,
          intrinsicAspect: 1,
          intrinsicInitialWidth: 40,
          objectFit: "cover"
        })
      }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(ButtonText, {
        children: name
      })]
    })
  });
});
const Button$3 = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)("button",  true ? {
  target: "etdzwz22"
} : 0)("overflow-x:hidden;display:flex;align-items:center;width:100%;padding:0;border:0;box-sizing:border-box;color:", ({
  theme
}) => theme.content.base1, ";background:none;" + ( true ? "" : 0));
const ImageBox = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)("div",  true ? {
  target: "etdzwz21"
} : 0)("position:relative;flex-shrink:0;display:inline-flex;align-items:center;justify-content:center;width:", (0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.p)(40), ";height:", (0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.p)(40), ";border-radius:", (0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.p)(4), ";color:", ({
  theme
}) => theme.content.white, ";background:", ({
  theme
}) => theme.content.base4, ";" + ( true ? "" : 0));
const ButtonText = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)("span",  true ? {
  target: "etdzwz20"
} : 0)("display:inline-block;margin-left:", (0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.p)(10), ";font-size:", (0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.p)(16), ";" + ( true ? "" : 0));

const ScrapBookSelectModal = ({
  contentIds,
  onClose,
  onClickTo,
  getList,
  create,
  select
}) => {
  const [scrapBooks, setScrapBooks] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)([]);
  const [isLoading, setLoading] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(true);
  const [selectedFolder, setSelectedFolder] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)();
  const {
    open: openSnackbar
  } = (0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_10__/* .useSnackbar */ .Ds_)();
  const {
    logSelectScrapBook,
    logClickScrapBookTo
  } = useScrapLogger();
  const handleConfirmClick = async () => {
    if (!selectedFolder) {
      return;
    }
    if (contentIds.length === 0) {
      openSnackbar({
        content: '이동할 수 있는 콘텐츠가 없습니다. 잠시 후 다시 시도해주세요.'
      });
      return;
    }
    const {
      id,
      name
    } = selectedFolder;
    try {
      const response = await select(id, contentIds);
      if (!response.success) {
        throw new Error();
      }
      openSnackbar({
        content: `'${name}'폴더로 이동했습니다.`,
        buttons: [{
          children: '스크랩북 보기',
          type: 'button',
          onClick: () => {
            logClickScrapBookTo();
            onClickTo(id);
          }
        }]
      });
      logSelectScrapBook({
        scrapBookId: id,
        contentIds
      });
      onClose();
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
      openSnackbar({
        content: error.message || '잠시 후 다시 시도해주세요.'
      });
    }
  };
  const handleSelect = (id, name) => {
    setSelectedFolder({
      id,
      name
    });
  };
  const handleCreate = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(async name => {
    try {
      const response = await create(name);
      if (!response.success) {
        openSnackbar({
          content: '올바른 폴더 이름을 입력해주세요.'
        });
        return;
      }
      handleSelect(response.id, name);
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
      openSnackbar({
        content: error.message || '새로운 폴더를 생성하지 못했습니다.'
      });
    }
  }, [create, handleSelect]);
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    (async () => {
      try {
        setLoading(true);
        const scrapBooks = await getList();
        setScrapBooks(scrapBooks);
      } catch (error) {
        openSnackbar({
          content: '스크랩북 목록을 가져오지 못했습니다.'
        });
      } finally {
        setLoading(false);
      }
    })();
  }, [getList]);
  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsxs */ .BX)(_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .Fragment */ .HY, {
    children: [(0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(_bucketplace_design_system_bds__WEBPACK_IMPORTED_MODULE_8__/* .Modal */ .u_l, {
      width: 400,
      header: {
        title: '폴더 선택',
        onClose
      },
      onBlur: onClose,
      disableBackgroundScroll: true,
      children: (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsxs */ .BX)(ModalBody, {
        children: [(0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(ScrapBookCreateForm, {
          onSubmit: handleCreate
        }), scrapBooks.length === 0 && !isLoading && (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(EmptyMessage, {
          description: '이동할 폴더가 없습니다.\n새로운 폴더를 만들어보세요.'
        }), scrapBooks.length > 0 && scrapBooks.map(scrapBook => (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(ScrapBookItem, {
          ...scrapBook,
          onSelect: handleSelect
        }, scrapBook.id))]
      })
    }), selectedFolder?.id && selectedFolder?.name && (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(_bucketplace_design_system_bds__WEBPACK_IMPORTED_MODULE_8__/* .Modal */ .u_l, {
      width: 400,
      disableBackgroundScroll: true,
      footer: {
        action: {
          primary: {
            text: '확인',
            onClick: handleConfirmClick
          },
          secondary: {
            text: '취소',
            onClick: () => setSelectedFolder(undefined)
          }
        }
      },
      children: (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(Content$4, {
        children: `선택한 컨텐츠를 '${selectedFolder.name}'으로 이동하시겠습니까?`
      })
    })]
  });
};
const ModalBody = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)("div",  true ? {
  target: "eetj5dr2"
} : 0)("overflow-y:auto;height:", (0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.p)(446), ";", _bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.M.min('tablet', /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_6__/* .css */ .iv)("height:", (0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.p)(466), ";padding:0 ", (0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.p)(12), ";" + ( true ? "" : 0),  true ? "" : 0)), ";" + ( true ? "" : 0));
const EmptyMessage = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_bucketplace_design_system_bds__WEBPACK_IMPORTED_MODULE_8__/* .EmptyPage */ .nn_,  true ? {
  target: "eetj5dr1"
} : 0)("margin-top:", (0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.p)(100), ";", _bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.M.min('tablet', /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_6__/* .css */ .iv)("margin-top:", (0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.p)(120), ";" + ( true ? "" : 0),  true ? "" : 0)), ";" + ( true ? "" : 0));
const Content$4 = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)("p",  true ? {
  target: "eetj5dr0"
} : 0)(_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.F.body1_1, ";color:", ({
  theme
}) => theme.content.base1, ";padding:16px 16px 10px 16px;text-align:center;word-break:keep-all;white-space:pre-line;" + ( true ? "" : 0));

/* eslint-disable react-hooks/exhaustive-deps */
const Scrap = ({
  contentType,
  contentId,
  initialActive = false,
  initialCount = 0,
  children,
  scrap,
  onScrap,
  unscrap,
  onUnscrap,
  isLoggedIn,
  redirectToLogin,
  onClickScrapBook,
  onClickScrapBookTo,
  getScrapBooks,
  createScrapBook,
  selectScrapBook,
  isGlobal,
  localeData
}) => {
  const [scrapItem, setScrapItem] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)({
    active: initialActive,
    count: initialCount
  });
  const [pending, setPending] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false);
  const [isScrapBookSelectModalOpen, setScrapBookSelectModalOpen] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false);
  const {
    open: openSnackBar
  } = (0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_10__/* .useSnackbar */ .Ds_)();
  const dispatchWebviewEvent = useWebviewEventDispatcher();
  const {
    logScrap,
    logUnScrap,
    logScrapSuccess,
    logUnscrapSuccess,
    logClickScrapBook
  } = useScrapLogger();
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    setScrapItem(item => ({
      ...item,
      active: initialActive,
      count: initialCount
    }));
  }, [initialActive, initialCount]);
  const handleScrap = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(async ({
    bucketLogData,
    brazeLogData,
    amplitudeLogData
  }) => {
    if (pending) {
      return;
    }
    if (!isLoggedIn) {
      redirectToLogin();
      return;
    }
    setPending(true);
    logScrap({
      contentType,
      contentId,
      bucketLogData,
      brazeLogData
    });
    try {
      const response = await scrap();
      if (!response.success) {
        throw new Error(response.message);
      }
      setScrapItem({
        id: response.id,
        active: true,
        count: response.count
      });
      openSnackBar({
        content: localeData?.successScrap ?? '스크랩했습니다.',
        buttons: [{
          children: localeData?.goToScrapBookPage ?? '스크랩북 보기',
          type: 'button',
          onClick: () => {
            logClickScrapBook();
            onClickScrapBook();
          }
        }, isGlobal ? {} : {
          children: '폴더에 담기',
          type: 'button',
          onClick: () => setScrapBookSelectModalOpen(true)
        }]
      });
      dispatchWebviewEvent({
        type: 'scrap',
        contentType,
        contentId,
        performed: true,
        count: response.count
      });
      logScrapSuccess({
        contentType,
        contentId,
        count: response.count,
        amplitudeLogData
      });
      onScrap?.();
    } catch (error) {
      console.error(error);
      openSnackBar({
        content: localeData?.failScrap ?? '스크랩 도중 문제가 발생하였습니다. 잠시 후 다시 시도해 주세요.'
      });
    } finally {
      setPending(false);
    }
  }, [pending, contentType, contentId, scrap, onScrap, isLoggedIn, redirectToLogin]);
  const handleUnscrap = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(async ({
    bucketLogData
  }) => {
    if (pending) {
      return;
    }
    if (!isLoggedIn) {
      redirectToLogin();
      return;
    }
    setPending(true);
    logUnScrap({
      contentType,
      contentId,
      bucketLogData
    });
    try {
      const response = await unscrap();
      if (!response.success) {
        throw new Error(response.message);
      }
      setScrapItem({
        active: false,
        count: response.count
      });
      openSnackBar({
        content: localeData?.successUnscrap ?? '스크랩북에서 삭제했습니다.'
      });
      dispatchWebviewEvent({
        type: 'scrap',
        contentType,
        contentId,
        performed: false,
        count: response.count
      });
      logUnscrapSuccess({
        contentType,
        contentId
      });
      onUnscrap?.();
    } catch (error) {
      console.error(error);
      openSnackBar({
        content: localeData?.failUnscrap ?? '스크랩북에서 삭제 도중 문제가 발생하였습니다. 잠시 후 다시 시도해 주세요.'
      });
    } finally {
      setPending(false);
    }
  }, [pending, contentType, contentId, unscrap, onUnscrap, isLoggedIn, redirectToLogin]);
  const handleToggle = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(({
    scrap
  }) => {
    if (scrapItem.active) {
      return handleUnscrap(scrap);
    }
    return handleScrap(scrap);
  }, [scrapItem.active, handleScrap, handleUnscrap]);
  const handleWebviewScrap = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(event => {
    if (event.contentId !== contentId) {
      return;
    }
    setScrapItem(item => ({
      ...item,
      count: event.count ?? (event.performed ? ++item.count : --item.count),
      active: event.performed,
      pending: false
    }));
  }, [contentId]);
  useWebviewEventListener('scrap', handleWebviewScrap);
  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsxs */ .BX)(_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .Fragment */ .HY, {
    children: [children({
      active: scrapItem.active,
      count: scrapItem.count,
      scrap: handleScrap,
      unscrap: handleUnscrap,
      toggle: handleToggle
    }), isScrapBookSelectModalOpen && (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(ScrapBookSelectModal, {
      contentIds: scrapItem.id ? [scrapItem.id] : [],
      onClose: () => setScrapBookSelectModalOpen(false),
      onClickTo: onClickScrapBookTo,
      getList: getScrapBooks,
      create: createScrapBook,
      select: selectScrapBook
    })]
  });
};

function HOVER(template, ...args) {
  return /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_6__/* .css */ .iv)("&.focus-visible:focus{", /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_6__/* .css */ .iv)(template, ...args), ";}@media(hover: hover) and (pointer: fine){&:hover,&:active{", /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_6__/* .css */ .iv)(template, ...args), ";}}" + ( true ? "" : 0),  true ? "" : 0);
}

function ProductCardScrap({
  scrapData,
  product,
  logData
}) {
  const {
    initialActive,
    initialCount,
    isLoggedIn,
    userId,
    scrap,
    unscrap,
    onScrap,
    onUnscrap,
    createScrapBook,
    selectScrapBook,
    getScrapBooks,
    onClickScrapBook,
    onClickScrapBookTo,
    redirectToLogin,
    onClickScrap
  } = scrapData;
  const getScrapLogData = ({
    bucketLogData
  } = {}) => {
    return {
      bucketLogData,
      brazeLogData: {
        userId: userId || 0,
        productName: product.name
      }
    };
  };
  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(Scrap, {
    contentType: product.type ?? 'Production',
    contentId: product.id,
    initialActive: initialActive,
    initialCount: initialCount,
    getScrapBooks: getScrapBooks,
    isLoggedIn: isLoggedIn,
    scrap: scrap,
    unscrap: unscrap,
    onScrap: onScrap,
    onUnscrap: onUnscrap,
    createScrapBook: createScrapBook,
    selectScrapBook: selectScrapBook,
    onClickScrapBook: onClickScrapBook,
    onClickScrapBookTo: onClickScrapBookTo,
    redirectToLogin: redirectToLogin,
    children: ({
      active,
      scrap,
      unscrap
    }) => (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(ScrapButton$1, {
      name: "scrap",
      size: 24,
      active: active,
      initialActive: active,
      onActive: onClickScrap ?? (() => scrap({
        ...getScrapLogData({
          bucketLogData: logData
        })
      })),
      onInactive: () => unscrap({
        ...getScrapLogData({
          bucketLogData: logData
        })
      })
    })
  });
}
const ScrapButton$1 = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_bucketplace_design_system_bds__WEBPACK_IMPORTED_MODULE_8__/* .ToggleButton */ .COr,  true ? {
  target: "ena0pzo0"
} : 0)("position:absolute;bottom:4px;right:4px;z-index:10;", HOVER`
    opacity: 0.5;
  `, ";" + ( true ? "" : 0));

function SoldOutBanner() {
  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(Container$p, {
    children: "\uD488\uC808"
  });
}
const Container$p = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)("div",  true ? {
  target: "e152w92t0"
} : 0)(_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.F.caption1, " position:absolute;left:0;right:0;bottom:0;padding:2px 0;text-align:center;font-weight:bold;", ({
  theme
}) => /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_6__/* .css */ .iv)("color:", theme.content.white, ";background-color:", theme.content.base3, ";" + ( true ? "" : 0),  true ? "" : 0), " border-radius:0 0 4px 4px;z-index:2;" + ( true ? "" : 0));

function _EMOTION_STRINGIFIED_CSS_ERROR__$T() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
function Thumbnail$1({
  product,
  scrapData,
  flex,
  isMdPick,
  logData,
  className,
  children,
  renderOverlay
}) {
  const {
    badges,
    originalImageUrl,
    isSoldOut,
    isDiscontinued
  } = product;
  const isVisibleSoldoutBanner = isSoldOut && !isDiscontinued;
  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(Wrapper$4, {
    flex: flex,
    className: classNames('product-thumbnail', className),
    children: (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsxs */ .BX)(Container$o, {
      children: [renderOverlay?.(), scrapData != null && (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(ProductCardScrap, {
        scrapData: scrapData,
        product: product,
        logData: logData
      }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsxs */ .BX)(ImageWrapper, {
        children: [badges != null && badges.length > 0 && (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(ThumbnailBadge, {
          badgeList: badges,
          size: isMdPick ? 'extraSmall' : 'small'
        }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(StyledResizeImage, {
          src: originalImageUrl,
          quality: 50,
          intrinsicAspect: 1,
          className: "thumbnail-image",
          alt: "\uC0C1\uD488-\uC378\uB124\uC77C-\uC774\uBBF8\uC9C0"
        })]
      }), isVisibleSoldoutBanner && (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(SoldOutBanner, {}), children]
    })
  });
}
function ThumbnailPlaceholder() {
  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(ThumbnailPlaceholderAnimation, {});
}
const Wrapper$4 = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)("div",  true ? {
  target: "e1bro5mc4"
} : 0)(({
  flex
}) => flex && `
    flex: 1 0 48%;
  `, ";" + ( true ? "" : 0));
const Container$o = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)("div",  true ? {
  target: "e1bro5mc3"
} : 0)("position:relative;padding-bottom:100%;background-color:", ({
  theme
}) => theme.content.base5, ";border-radius:4px;&:after{content:'';position:absolute;top:0;left:0;right:0;bottom:0;background:rgba(5, 3, 3, 0.02);border-radius:4px;}" + ( true ? "" : 0));
const ImageWrapper = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)("div",  true ? {
  target: "e1bro5mc2"
} : 0)( true ? {
  name: "ypqde8",
  styles: "position:absolute;width:100%;height:100%;border-radius:4px;overflow:hidden"
} : 0);
const StyledResizeImage = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_9__.R,  true ? {
  target: "e1bro5mc1"
} : 0)( true ? {
  name: "j9woce",
  styles: "position:absolute;top:50%;left:50%;width:100%;transform:translate(-50%, -50%);transition:.2s transform"
} : 0);
const ThumbnailPlaceholderAnimation = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(PlaceholderAnimation,  true ? {
  target: "e1bro5mc0"
} : 0)( true ? {
  name: "vs1u20",
  styles: "padding-bottom:100%;border-radius:4px"
} : 0);

function Timer({
  className,
  todayDeal
}) {
  const {
    breakpoint
  } = useResponsive({});
  const isMobile = breakpoint === 'mobile';
  const endAt = new Date(todayDeal.endAt).getTime();
  const [remaining, setRemaining] = useState(() => endAt - Date.now());
  const hasExpired = remaining <= 0;
  const text = remaining >= 86400000 ? `${Math.floor(remaining / 86400000)}일` : `${`00${Math.floor(remaining / 1000 / 3600) % 24}`.slice(-2)}:${`00${Math.floor(remaining / 1000 / 60) % 60}`.slice(-2)}:${`00${Math.floor(remaining / 1000) % 60}`.slice(-2)}`;
  useEffect(() => {
    const timer = window.setInterval(() => {
      setRemaining(endAt - Date.now());
    }, 1000);
    return () => {
      window.clearInterval(timer);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return jsx(Badge, {
    size: isMobile ? 20 : 24,
    type: "fill",
    variant: "primary2",
    className: className,
    children: hasExpired ? '마감' : `${text} 남음`
  });
}
const Badge = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_bucketplace_design_system_bds__WEBPACK_IMPORTED_MODULE_8__/* .SquareBadge */ .zRs,  true ? {
  target: "edmzysc0"
} : 0)("position:absolute;z-index:3;top:8px;left:8px;", _bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.M.min('tablet', `
    top: 12px;
    left: 12px;
  `), ";" + ( true ? "" : 0));

function ProductCard({
  product,
  href,
  badgeMaxCount,
  flex,
  isMdPick,
  logData,
  scrapData,
  localeData,
  hideBadge,
  hideReview,
  hideStats,
  className,
  renderOverlay,
  onClick,
  linkComponent,
  infoBottomArea,
  infoVariant
}) {
  const {
    detailLogData
  } = useProductCardLogData({
    product,
    badgeMaxCount
  });
  const bucketLogData = {
    ...logData,
    type: product.type?.toLowerCase() || 'production',
    id: product.id,
    data: {
      ...logData?.data,
      ...detailLogData
    }
  };
  const {
    ref
  } = ce({
    logData: bucketLogData
  });
  const LinkComponent = linkComponent;
  const handleClickProductLink = event => {
    if (logData) {
      L({
        category: 'click',
        ...bucketLogData
      });
    }
    onClick?.(event);
  };
  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsxs */ .BX)(Container$n, {
    className: className,
    ref: ref,
    flex: flex,
    children: [LinkComponent != null && (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(LinkComponent, {
      href: href,
      onClick: handleClickProductLink
    }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(Thumbnail$1, {
      product: product,
      scrapData: scrapData,
      flex: flex,
      isMdPick: isMdPick,
      logData: bucketLogData,
      renderOverlay: renderOverlay
    }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(Info$1, {
      product: product,
      badgeMaxCount: badgeMaxCount,
      flex: flex,
      isMdPick: isMdPick,
      localeData: localeData,
      hideBadge: hideBadge,
      hideReview: hideReview,
      hideStats: hideStats,
      bottomArea: infoBottomArea,
      variant: infoVariant
    })]
  });
}
function CardPlaceholder() {
  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsxs */ .BX)(Container$n, {
    children: [(0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(ThumbnailPlaceholder, {}), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(InfoPlaceholder, {})]
  });
}
const Container$n = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)("article",  true ? {
  target: "etj6rb20"
} : 0)("display:block;position:relative;padding:16px 0;", ({
  flex
}) => flex && `
    display: flex;
    align-items: center;
  `, ">a{position:absolute;top:0;left:0;right:0;bottom:0;z-index:2;", HOVER`
      & ~ .product-thumbnail .thumbnail-image {
        transform: translate(-50%, -50%) scale(1.1);
      }
      & ~ .product-info .product-name {
        opacity: 0.5;
      }
    `, ";}" + ( true ? "" : 0));

function _EMOTION_STRINGIFIED_CSS_ERROR__$S() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
const STAT_MAX_COUNT = 99999;
/**
 * 스크랩 실험용 Stats 컴포넌트
 *
 * B안에서 리뷰가 1000개 이상인 경우 스크랩이 있더라도 노출하지 않습니다.
 * 그 외에는 리뷰/스크랩 수 모두 최대 99999개로 표시합니다.
 */
function ScrapExperimentStats({
  experimentType,
  reviewAvg,
  reviewCount = 0,
  scrapCount = 0,
  isMdPick,
  hideReview,
  hideStats
}) {
  const hasReview = reviewCount > 0;
  const hasScrap = scrapCount > 0;
  const formattedReviewCount = reviewCount >= STAT_MAX_COUNT ? STAT_MAX_COUNT : reviewCount;
  const showScrap = hasScrap && !isMdPick && (experimentType === 'C' || (hasReview ? reviewCount < 1000 : true));
  const scrapMaxCount = experimentType === 'B' ? 9999 : 99999;
  if (hideStats) {
    return null;
  }
  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsxs */ .BX)(Container$m, {
    children: [hasReview && !hideReview && (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsxs */ .BX)(_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .Fragment */ .HY, {
      children: [(0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(StyledIcon, {
        name: "star",
        size: 12
      }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(Average, {
        experimentType: experimentType,
        children: reviewAvg != null ? Math.round(reviewAvg * 10) / 10 : 0
      }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsxs */ .BX)(InfoText, {
        children: [experimentType === 'B' && `리뷰 ${formatComma(reviewCount)}`, experimentType === 'C' && `(${formatComma(formattedReviewCount)})`]
      })]
    }), showScrap && (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsxs */ .BX)(InfoText, {
      children: [(0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_11__.ax, {
        size: 12,
        fill: theme => theme.colors.foregroundDisabled
      }), `${formatComma(scrapCount >= scrapMaxCount ? scrapMaxCount : scrapCount)}`]
    })]
  });
}
const Container$m = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)("div",  true ? {
  target: "evlaem23"
} : 0)( true ? {
  name: "19imocq",
  styles: "font-size:12px;line-height:16px;color:#828C94;display:flex;align-items:center;margin-top:4px"
} : 0);
const StyledIcon = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_bucketplace_design_system_bds__WEBPACK_IMPORTED_MODULE_8__/* .Icon */ .JO$,  true ? {
  target: "evlaem22"
} : 0)( true ? {
  name: "1ygk9k8",
  styles: "color:#35C5F0;width:1.1em;height:1.1em;margin-right:1px;vertical-align:-2px"
} : 0);
var _ref$q =  true ? {
  name: "1wcfv52",
  styles: "margin-right:0"
} : 0;
const Average = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)("strong",  true ? {
  target: "evlaem21"
} : 0)("margin-right:4px;color:#2F3438;", ({
  experimentType
}) => experimentType === 'C' && _ref$q, ";" + ( true ? "" : 0));
const InfoText = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)("span",  true ? {
  target: "evlaem20"
} : 0)( true ? {
  name: "1eewaai",
  styles: "display:flex;align-items:center;font-size:12px;line-height:16px;font-weight:normal;color:#828C94;margin-right:4px"
} : 0);

function _EMOTION_STRINGIFIED_CSS_ERROR__$R() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
function ScrapExperimentInfo({
  product,
  experimentType,
  badgeMaxCount,
  isMdPick,
  flex,
  variant = 'lg',
  localeData = {},
  hideBadge,
  hideReview,
  hideStats,
  className,
  bottomArea
}) {
  const {
    name,
    isSelling,
    isDiscontinued,
    brand,
    originalPrice,
    sellingPrice,
    isSoldOut,
    type,
    reviewAvg,
    reviewCount,
    scrapCount,
    currency
  } = product;
  const isGlobal = !!currency;
  const showPrice = isGlobal || isSelling && !isDiscontinued;
  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsxs */ .BX)(Container$l, {
    flex: flex,
    className: classNames('product-info', className),
    children: [(0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsxs */ .BX)(Header$5, {
      children: [(0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(Brand, {
        className: "product-brand",
        children: brand.name
      }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(Name, {
        className: "product-name",
        variant: variant,
        children: name
      })]
    }), showPrice && (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(Price, {
      originalPrice: originalPrice,
      sellingPrice: sellingPrice,
      isDiscontinued: isDiscontinued,
      isSoldOut: isSoldOut,
      variant: variant,
      currency: currency,
      renderSuffix: () => (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)("span", {
        children: type === 'Deal' && ' 외'
      }),
      priceToken: localeData?.priceToken
    }), !isGlobal && (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(ScrapExperimentStats, {
      reviewAvg: reviewAvg,
      reviewCount: reviewCount,
      scrapCount: scrapCount,
      hideReview: hideReview,
      hideStats: hideStats,
      isMdPick: isMdPick,
      experimentType: experimentType
    }), !hideBadge && (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(Badges, {
      product: product,
      isMdPick: isMdPick,
      badgeMaxCount: badgeMaxCount
    }), bottomArea && bottomArea]
  });
}
var _ref2$7 =  true ? {
  name: "v1s1f3",
  styles: "margin-left:12px"
} : 0;
const Container$l = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)("div",  true ? {
  target: "e524o2r7"
} : 0)("width:100%;", ({
  flex
}) => flex && _ref2$7, ";" + ( true ? "" : 0));
const Header$5 = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)("div",  true ? {
  target: "e524o2r6"
} : 0)( true ? {
  name: "1r0yqr6",
  styles: "margin-top:10px"
} : 0);
const Brand = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)("div",  true ? {
  target: "e524o2r5"
} : 0)( true ? {
  name: "11vbb10",
  styles: "font-size:12px;line-height:16px;display:block;word-break:break-all;color:#828C94"
} : 0);
const nameStyle =  true ? {
  name: "wwgkbi",
  styles: "font-size:14px;line-height:18px;display:block;max-height:36px;margin-top:4px;word-break:break-all;transition:.1s opacity;overflow:hidden;text-overflow:ellipsis;display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical;word-wrap:break-word"
} : 0;
var _ref$p =  true ? {
  name: "xolxwr",
  styles: "font-size:12px;line-height:16px"
} : 0;
const Name = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)("span",  true ? {
  target: "e524o2r4"
} : 0)(nameStyle, " color:#2F3438;", ({
  variant
}) => (variant === 'sm' || variant === 'md') && _ref$p, ";" + ( true ? "" : 0));
/*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(PlaceholderAnimation,  true ? {
  target: "e524o2r3"
} : 0)(_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.F.caption1, " &:before{content:'\\00a0';}display:block;word-break:break-all;width:80px;" + ( true ? "" : 0));
/*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(PlaceholderAnimation,  true ? {
  target: "e524o2r2"
} : 0)(nameStyle, " &:before{content:'\\00a0';}" + ( true ? "" : 0));
/*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(PricePlaceholder,  true ? {
  target: "e524o2r1"
} : 0)( true ? {
  name: "192rb07",
  styles: "margin-top:3px;line-height:21px;width:120px"
} : 0);
/*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(StatsPlaceholder,  true ? {
  target: "e524o2r0"
} : 0)( true ? {
  name: "13ec1gr",
  styles: "margin-top:3px;width:100px"
} : 0);

function ScrapExperimentProductCard(props) {
  const {
    product,
    experimentType,
    href,
    badgeMaxCount,
    flex,
    isMdPick,
    logData,
    scrapData,
    localeData,
    hideBadge,
    hideReview,
    hideStats,
    className,
    renderOverlay,
    onClick,
    linkComponent,
    infoBottomArea,
    infoVariant
  } = props;
  const {
    detailLogData
  } = useProductCardLogData({
    product,
    badgeMaxCount
  });
  const bucketLogData = {
    ...logData,
    type: product.type?.toLowerCase() || 'production',
    id: product.id,
    data: {
      ...logData?.data,
      ...detailLogData
    }
  };
  const {
    ref
  } = ce({
    logData: bucketLogData
  });
  const LinkComponent = linkComponent;
  const handleClickProductLink = event => {
    if (logData) {
      L({
        category: 'click',
        ...bucketLogData
      });
    }
    onClick?.(event);
  };
  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsxs */ .BX)(Container$n, {
    className: className,
    ref: ref,
    flex: flex,
    children: [LinkComponent != null && (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(LinkComponent, {
      href: href,
      onClick: handleClickProductLink
    }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(Thumbnail$1, {
      product: product,
      scrapData: scrapData,
      flex: flex,
      isMdPick: isMdPick,
      logData: bucketLogData,
      renderOverlay: renderOverlay
    }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(ScrapExperimentInfo, {
      product: product,
      experimentType: experimentType,
      badgeMaxCount: badgeMaxCount,
      flex: flex,
      isMdPick: isMdPick,
      localeData: localeData,
      hideBadge: hideBadge,
      hideReview: hideReview,
      hideStats: hideStats,
      bottomArea: infoBottomArea,
      variant: infoVariant
    })]
  });
}

// TODO: 실험 종료 후 대응 필요
const CommerceProductCard = ({
  experimentType,
  scrapExperimentType,
  ...productCardProps
}) => {
  if (scrapExperimentType === 'B' || scrapExperimentType === 'C') {
    return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(ScrapExperimentProductCard, {
      experimentType: scrapExperimentType,
      ...productCardProps
    });
  }
  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(ProductCard, {
    ...productCardProps
  });
};

function _EMOTION_STRINGIFIED_CSS_ERROR__$Q() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
function DeliverySummary({
  logisticsName,
  invoiceNumber,
  deliveryStatus,
  deliveryTrackingNoticeDate,
  isOverseasPurchase,
  shipmentType,
  deliveryTargetType
}) {
  const theme = useTheme();
  const {
    open
  } = useSnackbar();
  const handleClickCopy = () => {
    copyTextToClipboard(invoiceNumber);
    open({
      content: '운송장 번호를 복사했습니다.'
    });
  };
  let dateFormat = null;
  if (deliveryTrackingNoticeDate) {
    dateFormat = getDeliveryTackingNoticeFormat({
      date: deliveryTrackingNoticeDate,
      isWithinDue: isOverseasPurchase || shipmentType === SHIPMENT_TYPE.SELLER,
      deliveryStatus,
      deliveryTargetType
    });
  }
  return jsxs(Wrapper$3, {
    children: [dateFormat && jsxs(ExpectedInfo, {
      children: [jsx("span", {
        className: "due",
        children: `${dateFormat.due} `
      }), jsx("span", {
        className: classNames('status', {
          delayed: dateFormat.status === '배송지연중'
        }),
        children: dateFormat.status
      })]
    }), jsxs(LogisticInfo, {
      children: [jsxs(LogisticName, {
        children: [jsx(TruckIcon, {
          className: "icon",
          size: 24,
          "data-testid": "truck-icon"
        }), `${logisticsName} ${invoiceNumber}`]
      }), jsx(OutlineButton, {
        css: /*#__PURE__*/css("background-color:", theme.content.white, ";" + ( true ? "" : 0),  true ? "" : 0),
        size: 32,
        variant: "base1",
        onClick: handleClickCopy,
        children: "\uBCF5\uC0AC"
      })]
    })]
  });
}
const Wrapper$3 = /*#__PURE__*/(/* unused pure expression or super */ null && (_styled("section",  true ? {
  target: "e185skhs3"
} : 0)("margin-bottom:40px;color:", ({
  theme
}) => theme.content.base1, ";" + ( true ? "" : 0))));
const ExpectedInfo = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)("h1",  true ? {
  target: "e185skhs2"
} : 0)(_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.F.title2, ";font-weight:700;text-align:center;margin-bottom:20px;.due{color:", ({
  theme
}) => theme.content.primary1.thick, ";}.status.delayed{color:", ({
  theme
}) => theme.content.base2, ";}" + ( true ? "" : 0));
const LogisticInfo = /*#__PURE__*/(/* unused pure expression or super */ null && (_styled("div",  true ? {
  target: "e185skhs1"
} : 0)("display:flex;justify-content:space-between;align-items:center;padding:8px 12px;background-color:", ({
  theme
}) => theme.background.groupedBase, ";border-radius:4px;" + ( true ? "" : 0))));
const LogisticName = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)("span",  true ? {
  target: "e185skhs0"
} : 0)( true ? {
  name: "1ec23nz",
  styles: "display:flex;align-items:center;.icon{margin-right:12px;}"
} : 0);

function DeliveryTimeLineStep({
  highLight,
  showArrow,
  fillPath,
  header,
  children,
  className
}) {
  return jsxs(Wrapper$2, {
    className: classNames(className, {
      highLight,
      fillPath
    }),
    "data-testid": "delivery-time-line-step",
    children: [showArrow && jsx(ArrowMark, {
      children: jsx(ChevronDownIcon$1, {
        size: 12,
        "data-testid": "arrow-down-icon"
      })
    }), header && jsx(Header$4, {
      children: header
    }), children]
  });
}
const Header$4 = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)("h3",  true ? {
  target: "e12hlzca2"
} : 0)(_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.F.subTitle1, ";color:", ({
  theme
}) => theme.content.base3, ";font-weight:700;display:flex;" + ( true ? "" : 0));
const ArrowMark = /*#__PURE__*/(/* unused pure expression or super */ null && (_styled("span",  true ? {
  target: "e12hlzca1"
} : 0)("display:inline-flex;align-items:center;color:", ({
  theme
}) => theme.content.primary1.basic, ";justify-content:center;position:absolute;left:-4px;top:-6px;width:36px;height:36px;border-radius:50%;background-color:", ({
  theme
}) => theme.content.white, ";border:2px solid ", ({
  theme
}) => theme.content.primary1.basic, ";box-sizing:border-box;z-index:5;" + ( true ? "" : 0))));
const Wrapper$2 = /*#__PURE__*/(/* unused pure expression or super */ null && (_styled("div",  true ? {
  target: "e12hlzca0"
} : 0)("padding-left:44px;position:relative;min-height:60px;padding-bottom:16px;&:last-of-type{min-height:0;}&::before{content:\"\";position:absolute;width:20px;display:inline-block;top:0;bottom:0;left:4px;background-color:", ({
  theme
}) => theme.content.base4, ";}&.fillPath::before{background-color:", ({
  theme
}) => theme.content.primary1.basic, ";}&:first-of-type::before{border-top-left-radius:20px;border-top-right-radius:20px;}&:last-of-type::before{border-bottom-left-radius:20px;border-bottom-right-radius:20px;height:20px;}&::after{content:\"\";position:absolute;background-color:white;display:inline-block;width:8px;height:8px;left:10px;top:6px;z-index:3;border-radius:50%;}&.fillPath{", Header$4, "{color:", ({
  theme
}) => theme.content.base1, ";}}&.highLight{", Header$4, "{color:", ({
  theme
}) => theme.content.primary1.thick, ";}}" + ( true ? "" : 0))));

function _EMOTION_STRINGIFIED_CSS_ERROR__$P() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
var _ref$o =  true ? {
  name: "y1f223",
  styles: "margin:auto"
} : 0;
function DeliveryWayPoint({
  currentLocation,
  className,
  empName,
  datetime,
  position,
  empPhone
}) {
  const {
    breakpoint
  } = useResponsive({});
  const isMobile = ['mobile', 'tablet'].includes(breakpoint ?? '');
  const formatDate = datetime && format$1(parseISO(datetime), 'M/d (EE) HH:mm', {
    locale: ko
  });
  return jsxs(Wrapper$1, {
    className: className,
    children: [jsx(Header$3, {
      className: classNames({
        highlight: currentLocation
      }),
      children: position
    }), jsxs(Info, {
      children: [`${formatDate} `, empName && jsxs(Fragment$1, {
        children: ["\xB7", ` ${empName} `]
      }), currentLocation && empPhone && (isMobile ? jsx(CallButton, {
        href: `tel:${empPhone}`,
        children: jsx(CallIcon, {
          size: 18,
          css: _ref$o
        })
      }) : empPhone)]
    })]
  });
}
const Wrapper$1 = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)("div",  true ? {
  target: "e3nenqo3"
} : 0)( true ? {
  name: "1u53ekv",
  styles: "padding-bottom:16px"
} : 0);
const Header$3 = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)("p",  true ? {
  target: "e3nenqo2"
} : 0)(_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.F.subTitle2, ";&.highlight{font-weight:500;}" + ( true ? "" : 0));
const Info = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)("span",  true ? {
  target: "e3nenqo1"
} : 0)(_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.F.body2_small, ";color:", ({
  theme
}) => theme.content.base2, ";display:inline-flex;align-items:center;justify-content:center;" + ( true ? "" : 0));
const CallButton = /*#__PURE__*/(/* unused pure expression or super */ null && (_styled("a",  true ? {
  target: "e3nenqo0"
} : 0)("border:1px solid ", ({
  theme
}) => theme.content.base4, ";border-radius:50%;width:26px;height:26px;display:inline-flex;margin-left:4px;" + ( true ? "" : 0))));

function _EMOTION_STRINGIFIED_CSS_ERROR__$O() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
var _ref$n =  true ? {
  name: "pbbd9q",
  styles: "padding-bottom:0px"
} : 0;
var _ref2$6 =  true ? {
  name: "18g08sj",
  styles: "padding-bottom:0"
} : 0;
function DeliveryTimeLine({
  details,
  status,
  isError,
  message,
  targetType
}) {
  const [isShowDetail, setIsShowDetail] = useState(false);
  if (isError) {
    return jsx(ErrorMessage, {
      children: breakLines(message)
    });
  }
  if (!details) {
    return null;
  }
  const detailsLength = details.length;
  const isExistWayPoint = detailsLength > 0;
  const recentWayPoint = isExistWayPoint && details[detailsLength - 1];
  const passedWayPoints = isExistWayPoint ? details.slice(0, detailsLength - 1) : undefined;
  const canShowPassedWayPoints = passedWayPoints && passedWayPoints?.length > 0;
  const targetTypeKorean = targetType === DELIVERY_TARGET_TYPE.PICKUP ? '수거' : '배송';
  return jsxs(Fragment$1, {
    children: [jsx(DeliveryTimeLineStep, {
      header: `${targetTypeKorean} 준비중`,
      fillPath: [DELIVERY_TRACKING_STATUS.COMPLETE, DELIVERY_TRACKING_STATUS.INPROGRESS, DELIVERY_TRACKING_STATUS.SCHEDULED].includes(status),
      highLight: status === DELIVERY_TRACKING_STATUS.READY,
      showArrow: status === DELIVERY_TRACKING_STATUS.READY
    }), targetType === DELIVERY_TARGET_TYPE.PICKUP && jsx(DeliveryTimeLineStep, {
      header: `${targetTypeKorean} 예정`,
      fillPath: [DELIVERY_TRACKING_STATUS.COMPLETE, DELIVERY_TRACKING_STATUS.INPROGRESS].includes(status),
      highLight: status === DELIVERY_TRACKING_STATUS.SCHEDULED,
      showArrow: status === DELIVERY_TRACKING_STATUS.SCHEDULED
    }), jsx(DeliveryTimeLineStep, {
      header: [`${targetTypeKorean}중`, canShowPassedWayPoints && jsx(ShowDetailButton, {
        isShowDetail: isShowDetail,
        onClick: () => setIsShowDetail(!isShowDetail)
      }, 1)],
      css: canShowPassedWayPoints && status === DELIVERY_TRACKING_STATUS.INPROGRESS && _ref2$6,
      highLight: status === DELIVERY_TRACKING_STATUS.INPROGRESS
      // 배송이 완료된 상태이거나 배송중이면서 하나 이상의 경유지를 방문하였을 경우
      ,
      fillPath: status === DELIVERY_TRACKING_STATUS.COMPLETE || status === DELIVERY_TRACKING_STATUS.INPROGRESS && isExistWayPoint
      // 배송중이지만 경유지 정보가 주어지지 않았을 경우
      ,
      showArrow: status === DELIVERY_TRACKING_STATUS.INPROGRESS && !isExistWayPoint,
      children: isShowDetail && jsx(PassedPointList, {
        children: passedWayPoints?.map((item, index) => jsx(DeliveryWayPoint, {
          ...item
        }, index))
      })
    }), recentWayPoint && status === DELIVERY_TRACKING_STATUS.INPROGRESS && jsx(DeliveryTimeLineStep, {
      highLight: true,
      showArrow: true,
      fillPath: false,
      children: jsx(DeliveryWayPoint, {
        ...recentWayPoint,
        currentLocation: true
      })
    }), jsx(DeliveryTimeLineStep, {
      header: `${targetTypeKorean}완료`,
      highLight: status === DELIVERY_TRACKING_STATUS.COMPLETE,
      showArrow: status === DELIVERY_TRACKING_STATUS.COMPLETE,
      fillPath: false,
      children: status === DELIVERY_TRACKING_STATUS.COMPLETE && recentWayPoint && jsx(DeliveryWayPoint, {
        css: _ref$n,
        ...recentWayPoint,
        position: "",
        currentLocation: true
      })
    })]
  });
}
function ShowDetailButton({
  isShowDetail,
  onClick
}) {
  const text = isShowDetail ? '접기' : '자세히보기';
  return jsxs(WayPointDetailButton, {
    onClick: onClick,
    children: [text, isShowDetail ? jsx(ChevronUpIcon, {
      className: "icon",
      size: 12,
      "data-testid": "chevron-up-icon"
    }) : jsx(ChevronDownIcon$1, {
      className: "icon",
      size: 12,
      "data-testid": "chevron-down-icon"
    })]
  });
}

// dot(.)을 기준으로 라인을 나누어 렌더링
function breakLines(message) {
  return message.split('.').map((line, index) => jsxs(Fragment$2, {
    children: [line, jsx("br", {})]
  }, index));
}
const WayPointDetailButton = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)("button",  true ? {
  target: "e1k86jnz2"
} : 0)(_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.R, ";", _bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.F.subTitle2, ";font-weight:400;margin-left:8px;margin-right:2px;color:", ({
  theme
}) => theme.content.base2, ";display:inline-flex;align-items:center;.icon{margin-left:2px;}" + ( true ? "" : 0));
const ErrorMessage = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)("p",  true ? {
  target: "e1k86jnz1"
} : 0)(_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.F.body2, ";color:", ({
  theme
}) => theme.content.base2, ";text-align:center;padding:24px 0;" + ( true ? "" : 0));
const PassedPointList = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)("div",  true ? {
  target: "e1k86jnz0"
} : 0)( true ? {
  name: "de9hf",
  styles: "padding-top:16px"
} : 0);

function _EMOTION_STRINGIFIED_CSS_ERROR__$N() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
function PhoneButton({
  phoneNumber,
  name
}) {
  const {
    breakpoint
  } = useResponsive({});
  const isMobile = breakpoint === 'mobile' || breakpoint === 'tablet';
  const theme = useTheme();

  // FIXME 디자인시스템의 OutlineButtonWithIcon컴포넌트에서 anchoring을 정상 지원할 경우
  //  컴포넌트에서 처리
  //  관련 이슈 https://github.com/bucketplace/design-system/issues/238
  const handlePhoneCall = () => {
    const a = document.createElement('a');
    a.href = `tel:${phoneNumber}`;
    a.click();
  };
  return isMobile ? jsx(PhoneMobileButton, {
    text: name,
    icon: "call_outline",
    color: theme.content.base2,
    size: 40,
    full: true,
    variant: "base1",
    onClick: handlePhoneCall
  }) : jsxs(PhoneInfo, {
    children: [jsx("span", {
      className: "label",
      children: name
    }), jsx("span", {
      className: "phone-number",
      children: phoneNumber
    })]
  });
}
const PhoneMobileButton = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_bucketplace_design_system_bds__WEBPACK_IMPORTED_MODULE_8__/* .OutlineButtonWithIcon */ .BC7,  true ? {
  target: "eoi3ru91"
} : 0)( true ? {
  name: "1ti5vbu",
  styles: "letter-spacing:-0.4px"
} : 0);
const PhoneInfo = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)("div",  true ? {
  target: "eoi3ru90"
} : 0)(_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.F.caption1, ";background-color:", ({
  theme
}) => theme.background.groupedBase, ";border-radius:4px;height:40px;display:flex;padding:0 20px;align-items:center;justify-content:center;flex:1 1 0;min-width:0;.label{color:", ({
  theme
}) => theme.content.base2, ";margin-right:4px;text-overflow:ellipsis;overflow:hidden;white-space:nowrap;}.phone-number{white-space:nowrap;}" + ( true ? "" : 0));

function _EMOTION_STRINGIFIED_CSS_ERROR__$M() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
function DeliveryOrderInfo({
  productName,
  destinationAddress,
  optionName,
  receiverName,
  productImageUrl,
  sellerPhone,
  sellerName,
  quantity,
  onClickProduct,
  targetType
}) {
  const {
    breakpoint
  } = useResponsive({});
  const isMobile = ['mobile', 'tablet'].includes(breakpoint ?? '');
  const title = targetType === DELIVERY_TARGET_TYPE.PICKUP ? '수거정보' : '배송지정보';
  return jsxs(Wrapper, {
    children: [jsx(Header$2, {
      children: title
    }), jsxs(InfoRow, {
      children: [jsx(InfoLabel, {
        children: "\uC8FC\uC18C"
      }), destinationAddress]
    }), jsxs(InfoRow, {
      children: [jsx(InfoLabel, {
        children: "\uBC1B\uB294 \uC0AC\uB78C"
      }), receiverName]
    }), jsxs(Content$3, {
      onClick: onClickProduct,
      children: [jsx(ProductImage, {
        alt: `${productName}`,
        src: productImageUrl ?? ''
      }), jsxs(ProductExplanation, {
        children: [jsx(ProductName, {
          children: productName
        }), jsx(OptionName, {
          children: `${optionName} • ${quantity}개`
        })]
      })]
    }), jsxs(PhoneNumbersWrapper, {
      children: [sellerPhone && jsx(PhoneButton, {
        phoneNumber: formatPhoneNumber(sellerPhone),
        name: isMobile ? '판매자 전화문의' : sellerName ?? ''
      }), jsx(PhoneButton, {
        phoneNumber: "1670-0876",
        name: "\uC624\uB298\uC758\uC9D1 \uACE0\uAC1D\uC13C\uD130"
      })]
    })]
  });
}
const Wrapper = /*#__PURE__*/(/* unused pure expression or super */ null && (_styled("div",  true ? {
  target: "e1yc6enx9"
} : 0)("color:", ({
  theme
}) => theme.content.base1, ";" + ( true ? "" : 0))));
const Header$2 = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)("h2",  true ? {
  target: "e1yc6enx8"
} : 0)(_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.F.subTitle1, ";font-weight:bold;margin-bottom:20px;" + ( true ? "" : 0));
const InfoRow = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)("div",  true ? {
  target: "e1yc6enx7"
} : 0)("display:flex;", _bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.F.body1_small, ";margin-bottom:6px;&:nth-of-type(2){margin-bottom:20px;}" + ( true ? "" : 0));
const InfoLabel = /*#__PURE__*/(/* unused pure expression or super */ null && (_styled("span",  true ? {
  target: "e1yc6enx6"
} : 0)("display:inherit;min-width:68px;color:", ({
  theme
}) => theme.content.base2, ";" + ( true ? "" : 0))));
const ProductImage = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_9__.R,  true ? {
  target: "e1yc6enx5"
} : 0)( true ? {
  name: "1vc19v7",
  styles: "flex-shrink:0;width:54px;height:54px;border-radius:4px;margin-right:10px"
} : 0);
const PhoneNumbersWrapper = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)("div",  true ? {
  target: "e1yc6enx4"
} : 0)( true ? {
  name: "mapv73",
  styles: "display:flex;column-gap:12px"
} : 0);
const Content$3 = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)("div",  true ? {
  target: "e1yc6enx3"
} : 0)( true ? {
  name: "oyqoge",
  styles: "display:flex;padding-bottom:20px;cursor:pointer"
} : 0);
const ProductExplanation = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)("div",  true ? {
  target: "e1yc6enx2"
} : 0)(_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.F.body2, ";" + ( true ? "" : 0));
const ProductName = /*#__PURE__*/(/* unused pure expression or super */ null && (_styled("p",  true ? {
  target: "e1yc6enx1"
} : 0)("font-weight:500;color:", ({
  theme
}) => theme.content.base1, ";" + ( true ? "" : 0))));
const OptionName = /*#__PURE__*/(/* unused pure expression or super */ null && (_styled("p",  true ? {
  target: "e1yc6enx0"
} : 0)("font-weight:400;color:", ({
  theme
}) => theme.content.base2, ";" + ( true ? "" : 0))));

function _EMOTION_STRINGIFIED_CSS_ERROR__$L() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
const DeliveryTrackingLoadFail = ({
  handleButtonClick,
  title
}) => {
  return jsxs(Fragment$1, {
    children: [!isInApp() && title && jsx(WebViewTitle, {
      children: title
    }), jsxs(LoadingWrapper, {
      children: [jsx(Title$a, {
        children: "\uC815\uBCF4\uB97C \uBD88\uB7EC\uC624\uC9C0 \uBABB\uD588\uC5B4\uC694."
      }), jsxs(Text, {
        children: ["\uC5F0\uB3D9 \uC815\uBCF4 \uC870\uD68C \uC911 \uC77C\uC2DC\uC801\uC778 \uC624\uB958\uAC00 \uBC1C\uC0DD\uD588\uC5B4\uC694.", jsx("br", {}), "\uC0C8\uB85C\uACE0\uCE68\uC744 \uD074\uB9AD\uD574\uC8FC\uC138\uC694."]
      }), jsx(RefreshButton, {
        size: 44,
        variant: "primary1",
        onClick: handleButtonClick,
        children: "\uC0C8\uB85C\uACE0\uCE68"
      })]
    })]
  });
};
const LoadingWrapper = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)("div",  true ? {
  target: "e1ewtnty4"
} : 0)("width:100%;display:flex;flex-direction:column;align-items:center;justify-content:center;height:calc(100vh - 80px);", _bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.M.max('tablet',  true ? {
  name: "lohfg0",
  styles: "height:calc(100vh - 50px)"
} : 0), ";" + ( true ? "" : 0));
const WebViewTitle = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)("h1",  true ? {
  target: "e1ewtnty3"
} : 0)(_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.F.subTitle1, ";border-bottom:1px solid ", ({
  theme
}) => theme.content.base4, ";height:45px;display:flex;align-items:center;justify-content:center;font-weight:bold;" + ( true ? "" : 0));
const Title$a = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)("div",  true ? {
  target: "e1ewtnty2"
} : 0)(_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.F.title2, ";font-weight:600;", _bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.M.max('tablet',  true ? {
  name: "mmvz9h",
  styles: "font-weight:400"
} : 0), ";" + ( true ? "" : 0));
const Text = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)("div",  true ? {
  target: "e1ewtnty1"
} : 0)(_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.F.body1_1, ";margin-top:8px;text-align:center;color:", ({
  theme
}) => theme.content.base2, ";", _bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.M.max('tablet', /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_6__/* .css */ .iv)(_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.F.body2, ";" + ( true ? "" : 0),  true ? "" : 0)), ";" + ( true ? "" : 0));
const RefreshButton = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_bucketplace_design_system_bds__WEBPACK_IMPORTED_MODULE_8__/* .Button */ .zxk,  true ? {
  target: "e1ewtnty0"
} : 0)( true ? {
  name: "1r0yqr6",
  styles: "margin-top:10px"
} : 0);

function _EMOTION_STRINGIFIED_CSS_ERROR__$K() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
const DELIVERY_TARGET_TYPE_NAME = {
  ORDER: '배송',
  PICKUP: '수거',
  REDELIVERY: '재배송'
};
function DeliveryTrackingTemplate({
  deliveryTargetType,
  summaryElement,
  timelineElement,
  orderInfoElement
}) {
  const targetTypeKorean = DELIVERY_TARGET_TYPE_NAME[deliveryTargetType];
  const title = `${targetTypeKorean}조회`;
  return jsx(BackgroundLayout, {
    children: jsxs(ContentWrapper, {
      children: [!isInApp() && jsx(Title$9, {
        children: title
      }), jsxs(Content$2, {
        children: [summaryElement, timelineElement]
      }), jsx(Divider, {
        variant: "thick"
      }), jsx(Content$2, {
        children: orderInfoElement
      })]
    })
  });
}
const BackgroundLayout = /*#__PURE__*/(/* unused pure expression or super */ null && (_styled("div",  true ? {
  target: "e1v1izdq3"
} : 0)("background-color:", ({
  theme
}) => theme.background.groupedBase, ";height:auto;min-height:100vh;" + ( true ? "" : 0))));
const ContentWrapper = /*#__PURE__*/(/* unused pure expression or super */ null && (_styled("div",  true ? {
  target: "e1v1izdq2"
} : 0)("max-width:500px;height:auto;min-height:100vh;background-color:", ({
  theme
}) => theme.background.base, ";margin-left:auto;margin-right:auto;" + ( true ? "" : 0))));
const Content$2 = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)("section",  true ? {
  target: "e1v1izdq1"
} : 0)("padding:24px 20px;", _bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.M.min('tablet',  true ? {
  name: "9zbbnr",
  styles: "padding:24px 16px"
} : 0), ";" + ( true ? "" : 0));
const Title$9 = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)("h1",  true ? {
  target: "e1v1izdq0"
} : 0)(_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.F.subTitle1, ";border-bottom:1px solid ", ({
  theme
}) => theme.content.base4, ";height:45px;display:flex;align-items:center;justify-content:center;font-weight:bold;" + ( true ? "" : 0));

var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, {
  enumerable: true,
  configurable: true,
  writable: true,
  value
}) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {})) if (__hasOwnProp.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols) for (var prop of __getOwnPropSymbols(b)) {
    if (__propIsEnum.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source) if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols) for (var prop of __getOwnPropSymbols(source)) {
    if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop)) target[prop] = source[prop];
  }
  return target;
};

// src/third-party/qrcodegen/index.ts
/**
 * @license QR Code generator library (TypeScript)
 * Copyright (c) Project Nayuki.
 * SPDX-License-Identifier: MIT
 */
var qrcodegen;
(qrcodegen2 => {
  const _QrCode = class {
    constructor(version, errorCorrectionLevel, dataCodewords, msk) {
      this.version = version;
      this.errorCorrectionLevel = errorCorrectionLevel;
      this.modules = [];
      this.isFunction = [];
      if (version < _QrCode.MIN_VERSION || version > _QrCode.MAX_VERSION) throw new RangeError("Version value out of range");
      if (msk < -1 || msk > 7) throw new RangeError("Mask value out of range");
      this.size = version * 4 + 17;
      let row = [];
      for (let i = 0; i < this.size; i++) row.push(false);
      for (let i = 0; i < this.size; i++) {
        this.modules.push(row.slice());
        this.isFunction.push(row.slice());
      }
      this.drawFunctionPatterns();
      const allCodewords = this.addEccAndInterleave(dataCodewords);
      this.drawCodewords(allCodewords);
      if (msk == -1) {
        let minPenalty = 1e9;
        for (let i = 0; i < 8; i++) {
          this.applyMask(i);
          this.drawFormatBits(i);
          const penalty = this.getPenaltyScore();
          if (penalty < minPenalty) {
            msk = i;
            minPenalty = penalty;
          }
          this.applyMask(i);
        }
      }
      assert(0 <= msk && msk <= 7);
      this.mask = msk;
      this.applyMask(msk);
      this.drawFormatBits(msk);
      this.isFunction = [];
    }
    static encodeText(text, ecl) {
      const segs = qrcodegen2.QrSegment.makeSegments(text);
      return _QrCode.encodeSegments(segs, ecl);
    }
    static encodeBinary(data, ecl) {
      const seg = qrcodegen2.QrSegment.makeBytes(data);
      return _QrCode.encodeSegments([seg], ecl);
    }
    static encodeSegments(segs, ecl, minVersion = 1, maxVersion = 40, mask = -1, boostEcl = true) {
      if (!(_QrCode.MIN_VERSION <= minVersion && minVersion <= maxVersion && maxVersion <= _QrCode.MAX_VERSION) || mask < -1 || mask > 7) throw new RangeError("Invalid value");
      let version;
      let dataUsedBits;
      for (version = minVersion;; version++) {
        const dataCapacityBits2 = _QrCode.getNumDataCodewords(version, ecl) * 8;
        const usedBits = QrSegment.getTotalBits(segs, version);
        if (usedBits <= dataCapacityBits2) {
          dataUsedBits = usedBits;
          break;
        }
        if (version >= maxVersion) throw new RangeError("Data too long");
      }
      for (const newEcl of [_QrCode.Ecc.MEDIUM, _QrCode.Ecc.QUARTILE, _QrCode.Ecc.HIGH]) {
        if (boostEcl && dataUsedBits <= _QrCode.getNumDataCodewords(version, newEcl) * 8) ecl = newEcl;
      }
      let bb = [];
      for (const seg of segs) {
        appendBits(seg.mode.modeBits, 4, bb);
        appendBits(seg.numChars, seg.mode.numCharCountBits(version), bb);
        for (const b of seg.getData()) bb.push(b);
      }
      assert(bb.length == dataUsedBits);
      const dataCapacityBits = _QrCode.getNumDataCodewords(version, ecl) * 8;
      assert(bb.length <= dataCapacityBits);
      appendBits(0, Math.min(4, dataCapacityBits - bb.length), bb);
      appendBits(0, (8 - bb.length % 8) % 8, bb);
      assert(bb.length % 8 == 0);
      for (let padByte = 236; bb.length < dataCapacityBits; padByte ^= 236 ^ 17) appendBits(padByte, 8, bb);
      let dataCodewords = [];
      while (dataCodewords.length * 8 < bb.length) dataCodewords.push(0);
      bb.forEach((b, i) => dataCodewords[i >>> 3] |= b << 7 - (i & 7));
      return new _QrCode(version, ecl, dataCodewords, mask);
    }
    getModule(x, y) {
      return 0 <= x && x < this.size && 0 <= y && y < this.size && this.modules[y][x];
    }
    getModules() {
      return this.modules;
    }
    drawFunctionPatterns() {
      for (let i = 0; i < this.size; i++) {
        this.setFunctionModule(6, i, i % 2 == 0);
        this.setFunctionModule(i, 6, i % 2 == 0);
      }
      this.drawFinderPattern(3, 3);
      this.drawFinderPattern(this.size - 4, 3);
      this.drawFinderPattern(3, this.size - 4);
      const alignPatPos = this.getAlignmentPatternPositions();
      const numAlign = alignPatPos.length;
      for (let i = 0; i < numAlign; i++) {
        for (let j = 0; j < numAlign; j++) {
          if (!(i == 0 && j == 0 || i == 0 && j == numAlign - 1 || i == numAlign - 1 && j == 0)) this.drawAlignmentPattern(alignPatPos[i], alignPatPos[j]);
        }
      }
      this.drawFormatBits(0);
      this.drawVersion();
    }
    drawFormatBits(mask) {
      const data = this.errorCorrectionLevel.formatBits << 3 | mask;
      let rem = data;
      for (let i = 0; i < 10; i++) rem = rem << 1 ^ (rem >>> 9) * 1335;
      const bits = (data << 10 | rem) ^ 21522;
      assert(bits >>> 15 == 0);
      for (let i = 0; i <= 5; i++) this.setFunctionModule(8, i, getBit(bits, i));
      this.setFunctionModule(8, 7, getBit(bits, 6));
      this.setFunctionModule(8, 8, getBit(bits, 7));
      this.setFunctionModule(7, 8, getBit(bits, 8));
      for (let i = 9; i < 15; i++) this.setFunctionModule(14 - i, 8, getBit(bits, i));
      for (let i = 0; i < 8; i++) this.setFunctionModule(this.size - 1 - i, 8, getBit(bits, i));
      for (let i = 8; i < 15; i++) this.setFunctionModule(8, this.size - 15 + i, getBit(bits, i));
      this.setFunctionModule(8, this.size - 8, true);
    }
    drawVersion() {
      if (this.version < 7) return;
      let rem = this.version;
      for (let i = 0; i < 12; i++) rem = rem << 1 ^ (rem >>> 11) * 7973;
      const bits = this.version << 12 | rem;
      assert(bits >>> 18 == 0);
      for (let i = 0; i < 18; i++) {
        const color = getBit(bits, i);
        const a = this.size - 11 + i % 3;
        const b = Math.floor(i / 3);
        this.setFunctionModule(a, b, color);
        this.setFunctionModule(b, a, color);
      }
    }
    drawFinderPattern(x, y) {
      for (let dy = -4; dy <= 4; dy++) {
        for (let dx = -4; dx <= 4; dx++) {
          const dist = Math.max(Math.abs(dx), Math.abs(dy));
          const xx = x + dx;
          const yy = y + dy;
          if (0 <= xx && xx < this.size && 0 <= yy && yy < this.size) this.setFunctionModule(xx, yy, dist != 2 && dist != 4);
        }
      }
    }
    drawAlignmentPattern(x, y) {
      for (let dy = -2; dy <= 2; dy++) {
        for (let dx = -2; dx <= 2; dx++) this.setFunctionModule(x + dx, y + dy, Math.max(Math.abs(dx), Math.abs(dy)) != 1);
      }
    }
    setFunctionModule(x, y, isDark) {
      this.modules[y][x] = isDark;
      this.isFunction[y][x] = true;
    }
    addEccAndInterleave(data) {
      const ver = this.version;
      const ecl = this.errorCorrectionLevel;
      if (data.length != _QrCode.getNumDataCodewords(ver, ecl)) throw new RangeError("Invalid argument");
      const numBlocks = _QrCode.NUM_ERROR_CORRECTION_BLOCKS[ecl.ordinal][ver];
      const blockEccLen = _QrCode.ECC_CODEWORDS_PER_BLOCK[ecl.ordinal][ver];
      const rawCodewords = Math.floor(_QrCode.getNumRawDataModules(ver) / 8);
      const numShortBlocks = numBlocks - rawCodewords % numBlocks;
      const shortBlockLen = Math.floor(rawCodewords / numBlocks);
      let blocks = [];
      const rsDiv = _QrCode.reedSolomonComputeDivisor(blockEccLen);
      for (let i = 0, k = 0; i < numBlocks; i++) {
        let dat = data.slice(k, k + shortBlockLen - blockEccLen + (i < numShortBlocks ? 0 : 1));
        k += dat.length;
        const ecc = _QrCode.reedSolomonComputeRemainder(dat, rsDiv);
        if (i < numShortBlocks) dat.push(0);
        blocks.push(dat.concat(ecc));
      }
      let result = [];
      for (let i = 0; i < blocks[0].length; i++) {
        blocks.forEach((block, j) => {
          if (i != shortBlockLen - blockEccLen || j >= numShortBlocks) result.push(block[i]);
        });
      }
      assert(result.length == rawCodewords);
      return result;
    }
    drawCodewords(data) {
      if (data.length != Math.floor(_QrCode.getNumRawDataModules(this.version) / 8)) throw new RangeError("Invalid argument");
      let i = 0;
      for (let right = this.size - 1; right >= 1; right -= 2) {
        if (right == 6) right = 5;
        for (let vert = 0; vert < this.size; vert++) {
          for (let j = 0; j < 2; j++) {
            const x = right - j;
            const upward = (right + 1 & 2) == 0;
            const y = upward ? this.size - 1 - vert : vert;
            if (!this.isFunction[y][x] && i < data.length * 8) {
              this.modules[y][x] = getBit(data[i >>> 3], 7 - (i & 7));
              i++;
            }
          }
        }
      }
      assert(i == data.length * 8);
    }
    applyMask(mask) {
      if (mask < 0 || mask > 7) throw new RangeError("Mask value out of range");
      for (let y = 0; y < this.size; y++) {
        for (let x = 0; x < this.size; x++) {
          let invert;
          switch (mask) {
            case 0:
              invert = (x + y) % 2 == 0;
              break;
            case 1:
              invert = y % 2 == 0;
              break;
            case 2:
              invert = x % 3 == 0;
              break;
            case 3:
              invert = (x + y) % 3 == 0;
              break;
            case 4:
              invert = (Math.floor(x / 3) + Math.floor(y / 2)) % 2 == 0;
              break;
            case 5:
              invert = x * y % 2 + x * y % 3 == 0;
              break;
            case 6:
              invert = (x * y % 2 + x * y % 3) % 2 == 0;
              break;
            case 7:
              invert = ((x + y) % 2 + x * y % 3) % 2 == 0;
              break;
            default:
              throw new Error("Unreachable");
          }
          if (!this.isFunction[y][x] && invert) this.modules[y][x] = !this.modules[y][x];
        }
      }
    }
    getPenaltyScore() {
      let result = 0;
      for (let y = 0; y < this.size; y++) {
        let runColor = false;
        let runX = 0;
        let runHistory = [0, 0, 0, 0, 0, 0, 0];
        for (let x = 0; x < this.size; x++) {
          if (this.modules[y][x] == runColor) {
            runX++;
            if (runX == 5) result += _QrCode.PENALTY_N1;else if (runX > 5) result++;
          } else {
            this.finderPenaltyAddHistory(runX, runHistory);
            if (!runColor) result += this.finderPenaltyCountPatterns(runHistory) * _QrCode.PENALTY_N3;
            runColor = this.modules[y][x];
            runX = 1;
          }
        }
        result += this.finderPenaltyTerminateAndCount(runColor, runX, runHistory) * _QrCode.PENALTY_N3;
      }
      for (let x = 0; x < this.size; x++) {
        let runColor = false;
        let runY = 0;
        let runHistory = [0, 0, 0, 0, 0, 0, 0];
        for (let y = 0; y < this.size; y++) {
          if (this.modules[y][x] == runColor) {
            runY++;
            if (runY == 5) result += _QrCode.PENALTY_N1;else if (runY > 5) result++;
          } else {
            this.finderPenaltyAddHistory(runY, runHistory);
            if (!runColor) result += this.finderPenaltyCountPatterns(runHistory) * _QrCode.PENALTY_N3;
            runColor = this.modules[y][x];
            runY = 1;
          }
        }
        result += this.finderPenaltyTerminateAndCount(runColor, runY, runHistory) * _QrCode.PENALTY_N3;
      }
      for (let y = 0; y < this.size - 1; y++) {
        for (let x = 0; x < this.size - 1; x++) {
          const color = this.modules[y][x];
          if (color == this.modules[y][x + 1] && color == this.modules[y + 1][x] && color == this.modules[y + 1][x + 1]) result += _QrCode.PENALTY_N2;
        }
      }
      let dark = 0;
      for (const row of this.modules) dark = row.reduce((sum, color) => sum + (color ? 1 : 0), dark);
      const total = this.size * this.size;
      const k = Math.ceil(Math.abs(dark * 20 - total * 10) / total) - 1;
      assert(0 <= k && k <= 9);
      result += k * _QrCode.PENALTY_N4;
      assert(0 <= result && result <= 2568888);
      return result;
    }
    getAlignmentPatternPositions() {
      if (this.version == 1) return [];else {
        const numAlign = Math.floor(this.version / 7) + 2;
        const step = this.version == 32 ? 26 : Math.ceil((this.version * 4 + 4) / (numAlign * 2 - 2)) * 2;
        let result = [6];
        for (let pos = this.size - 7; result.length < numAlign; pos -= step) result.splice(1, 0, pos);
        return result;
      }
    }
    static getNumRawDataModules(ver) {
      if (ver < _QrCode.MIN_VERSION || ver > _QrCode.MAX_VERSION) throw new RangeError("Version number out of range");
      let result = (16 * ver + 128) * ver + 64;
      if (ver >= 2) {
        const numAlign = Math.floor(ver / 7) + 2;
        result -= (25 * numAlign - 10) * numAlign - 55;
        if (ver >= 7) result -= 36;
      }
      assert(208 <= result && result <= 29648);
      return result;
    }
    static getNumDataCodewords(ver, ecl) {
      return Math.floor(_QrCode.getNumRawDataModules(ver) / 8) - _QrCode.ECC_CODEWORDS_PER_BLOCK[ecl.ordinal][ver] * _QrCode.NUM_ERROR_CORRECTION_BLOCKS[ecl.ordinal][ver];
    }
    static reedSolomonComputeDivisor(degree) {
      if (degree < 1 || degree > 255) throw new RangeError("Degree out of range");
      let result = [];
      for (let i = 0; i < degree - 1; i++) result.push(0);
      result.push(1);
      let root = 1;
      for (let i = 0; i < degree; i++) {
        for (let j = 0; j < result.length; j++) {
          result[j] = _QrCode.reedSolomonMultiply(result[j], root);
          if (j + 1 < result.length) result[j] ^= result[j + 1];
        }
        root = _QrCode.reedSolomonMultiply(root, 2);
      }
      return result;
    }
    static reedSolomonComputeRemainder(data, divisor) {
      let result = divisor.map(_ => 0);
      for (const b of data) {
        const factor = b ^ result.shift();
        result.push(0);
        divisor.forEach((coef, i) => result[i] ^= _QrCode.reedSolomonMultiply(coef, factor));
      }
      return result;
    }
    static reedSolomonMultiply(x, y) {
      if (x >>> 8 != 0 || y >>> 8 != 0) throw new RangeError("Byte out of range");
      let z = 0;
      for (let i = 7; i >= 0; i--) {
        z = z << 1 ^ (z >>> 7) * 285;
        z ^= (y >>> i & 1) * x;
      }
      assert(z >>> 8 == 0);
      return z;
    }
    finderPenaltyCountPatterns(runHistory) {
      const n = runHistory[1];
      assert(n <= this.size * 3);
      const core = n > 0 && runHistory[2] == n && runHistory[3] == n * 3 && runHistory[4] == n && runHistory[5] == n;
      return (core && runHistory[0] >= n * 4 && runHistory[6] >= n ? 1 : 0) + (core && runHistory[6] >= n * 4 && runHistory[0] >= n ? 1 : 0);
    }
    finderPenaltyTerminateAndCount(currentRunColor, currentRunLength, runHistory) {
      if (currentRunColor) {
        this.finderPenaltyAddHistory(currentRunLength, runHistory);
        currentRunLength = 0;
      }
      currentRunLength += this.size;
      this.finderPenaltyAddHistory(currentRunLength, runHistory);
      return this.finderPenaltyCountPatterns(runHistory);
    }
    finderPenaltyAddHistory(currentRunLength, runHistory) {
      if (runHistory[0] == 0) currentRunLength += this.size;
      runHistory.pop();
      runHistory.unshift(currentRunLength);
    }
  };
  let QrCode = _QrCode;
  QrCode.MIN_VERSION = 1;
  QrCode.MAX_VERSION = 40;
  QrCode.PENALTY_N1 = 3;
  QrCode.PENALTY_N2 = 3;
  QrCode.PENALTY_N3 = 40;
  QrCode.PENALTY_N4 = 10;
  QrCode.ECC_CODEWORDS_PER_BLOCK = [[-1, 7, 10, 15, 20, 26, 18, 20, 24, 30, 18, 20, 24, 26, 30, 22, 24, 28, 30, 28, 28, 28, 28, 30, 30, 26, 28, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30], [-1, 10, 16, 26, 18, 24, 16, 18, 22, 22, 26, 30, 22, 22, 24, 24, 28, 28, 26, 26, 26, 26, 28, 28, 28, 28, 28, 28, 28, 28, 28, 28, 28, 28, 28, 28, 28, 28, 28, 28, 28], [-1, 13, 22, 18, 26, 18, 24, 18, 22, 20, 24, 28, 26, 24, 20, 30, 24, 28, 28, 26, 30, 28, 30, 30, 30, 30, 28, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30], [-1, 17, 28, 22, 16, 22, 28, 26, 26, 24, 28, 24, 28, 22, 24, 24, 30, 28, 28, 26, 28, 30, 24, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30]];
  QrCode.NUM_ERROR_CORRECTION_BLOCKS = [[-1, 1, 1, 1, 1, 1, 2, 2, 2, 2, 4, 4, 4, 4, 4, 6, 6, 6, 6, 7, 8, 8, 9, 9, 10, 12, 12, 12, 13, 14, 15, 16, 17, 18, 19, 19, 20, 21, 22, 24, 25], [-1, 1, 1, 1, 2, 2, 4, 4, 4, 5, 5, 5, 8, 9, 9, 10, 10, 11, 13, 14, 16, 17, 17, 18, 20, 21, 23, 25, 26, 28, 29, 31, 33, 35, 37, 38, 40, 43, 45, 47, 49], [-1, 1, 1, 2, 2, 4, 4, 6, 6, 8, 8, 8, 10, 12, 16, 12, 17, 16, 18, 21, 20, 23, 23, 25, 27, 29, 34, 34, 35, 38, 40, 43, 45, 48, 51, 53, 56, 59, 62, 65, 68], [-1, 1, 1, 2, 4, 4, 4, 5, 6, 8, 8, 11, 11, 16, 16, 18, 16, 19, 21, 25, 25, 25, 34, 30, 32, 35, 37, 40, 42, 45, 48, 51, 54, 57, 60, 63, 66, 70, 74, 77, 81]];
  qrcodegen2.QrCode = QrCode;
  function appendBits(val, len, bb) {
    if (len < 0 || len > 31 || val >>> len != 0) throw new RangeError("Value out of range");
    for (let i = len - 1; i >= 0; i--) bb.push(val >>> i & 1);
  }
  function getBit(x, i) {
    return (x >>> i & 1) != 0;
  }
  function assert(cond) {
    if (!cond) throw new Error("Assertion error");
  }
  const _QrSegment = class {
    constructor(mode, numChars, bitData) {
      this.mode = mode;
      this.numChars = numChars;
      this.bitData = bitData;
      if (numChars < 0) throw new RangeError("Invalid argument");
      this.bitData = bitData.slice();
    }
    static makeBytes(data) {
      let bb = [];
      for (const b of data) appendBits(b, 8, bb);
      return new _QrSegment(_QrSegment.Mode.BYTE, data.length, bb);
    }
    static makeNumeric(digits) {
      if (!_QrSegment.isNumeric(digits)) throw new RangeError("String contains non-numeric characters");
      let bb = [];
      for (let i = 0; i < digits.length;) {
        const n = Math.min(digits.length - i, 3);
        appendBits(parseInt(digits.substr(i, n), 10), n * 3 + 1, bb);
        i += n;
      }
      return new _QrSegment(_QrSegment.Mode.NUMERIC, digits.length, bb);
    }
    static makeAlphanumeric(text) {
      if (!_QrSegment.isAlphanumeric(text)) throw new RangeError("String contains unencodable characters in alphanumeric mode");
      let bb = [];
      let i;
      for (i = 0; i + 2 <= text.length; i += 2) {
        let temp = _QrSegment.ALPHANUMERIC_CHARSET.indexOf(text.charAt(i)) * 45;
        temp += _QrSegment.ALPHANUMERIC_CHARSET.indexOf(text.charAt(i + 1));
        appendBits(temp, 11, bb);
      }
      if (i < text.length) appendBits(_QrSegment.ALPHANUMERIC_CHARSET.indexOf(text.charAt(i)), 6, bb);
      return new _QrSegment(_QrSegment.Mode.ALPHANUMERIC, text.length, bb);
    }
    static makeSegments(text) {
      if (text == "") return [];else if (_QrSegment.isNumeric(text)) return [_QrSegment.makeNumeric(text)];else if (_QrSegment.isAlphanumeric(text)) return [_QrSegment.makeAlphanumeric(text)];else return [_QrSegment.makeBytes(_QrSegment.toUtf8ByteArray(text))];
    }
    static makeEci(assignVal) {
      let bb = [];
      if (assignVal < 0) throw new RangeError("ECI assignment value out of range");else if (assignVal < 1 << 7) appendBits(assignVal, 8, bb);else if (assignVal < 1 << 14) {
        appendBits(2, 2, bb);
        appendBits(assignVal, 14, bb);
      } else if (assignVal < 1e6) {
        appendBits(6, 3, bb);
        appendBits(assignVal, 21, bb);
      } else throw new RangeError("ECI assignment value out of range");
      return new _QrSegment(_QrSegment.Mode.ECI, 0, bb);
    }
    static isNumeric(text) {
      return _QrSegment.NUMERIC_REGEX.test(text);
    }
    static isAlphanumeric(text) {
      return _QrSegment.ALPHANUMERIC_REGEX.test(text);
    }
    getData() {
      return this.bitData.slice();
    }
    static getTotalBits(segs, version) {
      let result = 0;
      for (const seg of segs) {
        const ccbits = seg.mode.numCharCountBits(version);
        if (seg.numChars >= 1 << ccbits) return Infinity;
        result += 4 + ccbits + seg.bitData.length;
      }
      return result;
    }
    static toUtf8ByteArray(str) {
      str = encodeURI(str);
      let result = [];
      for (let i = 0; i < str.length; i++) {
        if (str.charAt(i) != "%") result.push(str.charCodeAt(i));else {
          result.push(parseInt(str.substr(i + 1, 2), 16));
          i += 2;
        }
      }
      return result;
    }
  };
  let QrSegment = _QrSegment;
  QrSegment.NUMERIC_REGEX = /^[0-9]*$/;
  QrSegment.ALPHANUMERIC_REGEX = /^[A-Z0-9 $%*+.\/:-]*$/;
  QrSegment.ALPHANUMERIC_CHARSET = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ $%*+-./:";
  qrcodegen2.QrSegment = QrSegment;
})(qrcodegen || (qrcodegen = {}));
(qrcodegen2 => {
  (QrCode2 => {
    const _Ecc = class {
      constructor(ordinal, formatBits) {
        this.ordinal = ordinal;
        this.formatBits = formatBits;
      }
    };
    let Ecc = _Ecc;
    Ecc.LOW = new _Ecc(0, 1);
    Ecc.MEDIUM = new _Ecc(1, 0);
    Ecc.QUARTILE = new _Ecc(2, 3);
    Ecc.HIGH = new _Ecc(3, 2);
    QrCode2.Ecc = Ecc;
  })(qrcodegen2.QrCode || (qrcodegen2.QrCode = {}));
})(qrcodegen || (qrcodegen = {}));
(qrcodegen2 => {
  (QrSegment2 => {
    const _Mode = class {
      constructor(modeBits, numBitsCharCount) {
        this.modeBits = modeBits;
        this.numBitsCharCount = numBitsCharCount;
      }
      numCharCountBits(ver) {
        return this.numBitsCharCount[Math.floor((ver + 7) / 17)];
      }
    };
    let Mode = _Mode;
    Mode.NUMERIC = new _Mode(1, [10, 12, 14]);
    Mode.ALPHANUMERIC = new _Mode(2, [9, 11, 13]);
    Mode.BYTE = new _Mode(4, [8, 16, 16]);
    Mode.KANJI = new _Mode(8, [8, 10, 12]);
    Mode.ECI = new _Mode(7, [0, 0, 0]);
    QrSegment2.Mode = Mode;
  })(qrcodegen2.QrSegment || (qrcodegen2.QrSegment = {}));
})(qrcodegen || (qrcodegen = {}));
var qrcodegen_default = qrcodegen;

// src/index.tsx
/**
 * @license qrcode.react
 * Copyright (c) Paul O'Shannessy
 * SPDX-License-Identifier: ISC
 */
var ERROR_LEVEL_MAP = {
  L: qrcodegen_default.QrCode.Ecc.LOW,
  M: qrcodegen_default.QrCode.Ecc.MEDIUM,
  Q: qrcodegen_default.QrCode.Ecc.QUARTILE,
  H: qrcodegen_default.QrCode.Ecc.HIGH
};
var DEFAULT_SIZE$1 = 128;
var DEFAULT_LEVEL = "L";
var DEFAULT_BGCOLOR = "#FFFFFF";
var DEFAULT_FGCOLOR = "#000000";
var DEFAULT_INCLUDEMARGIN = false;
var MARGIN_SIZE = 4;
var DEFAULT_IMG_SCALE = 0.1;
function generatePath(modules, margin = 0) {
  const ops = [];
  modules.forEach(function (row, y) {
    let start = null;
    row.forEach(function (cell, x) {
      if (!cell && start !== null) {
        ops.push(`M${start + margin} ${y + margin}h${x - start}v1H${start + margin}z`);
        start = null;
        return;
      }
      if (x === row.length - 1) {
        if (!cell) {
          return;
        }
        if (start === null) {
          ops.push(`M${x + margin},${y + margin} h1v1H${x + margin}z`);
        } else {
          ops.push(`M${start + margin},${y + margin} h${x + 1 - start}v1H${start + margin}z`);
        }
        return;
      }
      if (cell && start === null) {
        start = x;
      }
    });
  });
  return ops.join("");
}
function excavateModules(modules, excavation) {
  return modules.slice().map((row, y) => {
    if (y < excavation.y || y >= excavation.y + excavation.h) {
      return row;
    }
    return row.map((cell, x) => {
      if (x < excavation.x || x >= excavation.x + excavation.w) {
        return cell;
      }
      return false;
    });
  });
}
function getImageSettings(cells, size, includeMargin, imageSettings) {
  if (imageSettings == null) {
    return null;
  }
  const margin = includeMargin ? MARGIN_SIZE : 0;
  const numCells = cells.length + margin * 2;
  const defaultSize = Math.floor(size * DEFAULT_IMG_SCALE);
  const scale = numCells / size;
  const w = (imageSettings.width || defaultSize) * scale;
  const h = (imageSettings.height || defaultSize) * scale;
  const x = imageSettings.x == null ? cells.length / 2 - w / 2 : imageSettings.x * scale;
  const y = imageSettings.y == null ? cells.length / 2 - h / 2 : imageSettings.y * scale;
  let excavation = null;
  if (imageSettings.excavate) {
    let floorX = Math.floor(x);
    let floorY = Math.floor(y);
    let ceilW = Math.ceil(w + x - floorX);
    let ceilH = Math.ceil(h + y - floorY);
    excavation = {
      x: floorX,
      y: floorY,
      w: ceilW,
      h: ceilH
    };
  }
  return {
    x,
    y,
    h,
    w,
    excavation
  };
}
var SUPPORTS_PATH2D = function () {
  try {
    new Path2D().addPath(new Path2D());
  } catch (e) {
    return false;
  }
  return true;
}();
function QRCodeCanvas(props) {
  const _a = props,
    {
      value,
      size = DEFAULT_SIZE$1,
      level = DEFAULT_LEVEL,
      bgColor = DEFAULT_BGCOLOR,
      fgColor = DEFAULT_FGCOLOR,
      includeMargin = DEFAULT_INCLUDEMARGIN,
      style,
      imageSettings
    } = _a,
    otherProps = __objRest(_a, ["value", "size", "level", "bgColor", "fgColor", "includeMargin", "style", "imageSettings"]);
  const imgSrc = imageSettings == null ? void 0 : imageSettings.src;
  const _canvas = useRef(null);
  const _image = useRef(null);
  const [isImgLoaded, setIsImageLoaded] = useState(false);
  useEffect(() => {
    if (_canvas.current != null) {
      const canvas = _canvas.current;
      const ctx = canvas.getContext("2d");
      if (!ctx) {
        return;
      }
      let cells = qrcodegen_default.QrCode.encodeText(value, ERROR_LEVEL_MAP[level]).getModules();
      const margin = includeMargin ? MARGIN_SIZE : 0;
      const numCells = cells.length + margin * 2;
      const calculatedImageSettings = getImageSettings(cells, size, includeMargin, imageSettings);
      const image = _image.current;
      const haveImageToRender = calculatedImageSettings != null && image !== null && image.complete && image.naturalHeight !== 0 && image.naturalWidth !== 0;
      if (haveImageToRender) {
        if (calculatedImageSettings.excavation != null) {
          cells = excavateModules(cells, calculatedImageSettings.excavation);
        }
      }
      const pixelRatio = window.devicePixelRatio || 1;
      canvas.height = canvas.width = size * pixelRatio;
      const scale = size / numCells * pixelRatio;
      ctx.scale(scale, scale);
      ctx.fillStyle = bgColor;
      ctx.fillRect(0, 0, numCells, numCells);
      ctx.fillStyle = fgColor;
      if (SUPPORTS_PATH2D) {
        ctx.fill(new Path2D(generatePath(cells, margin)));
      } else {
        cells.forEach(function (row, rdx) {
          row.forEach(function (cell, cdx) {
            if (cell) {
              ctx.fillRect(cdx + margin, rdx + margin, 1, 1);
            }
          });
        });
      }
      if (haveImageToRender) {
        ctx.drawImage(image, calculatedImageSettings.x + margin, calculatedImageSettings.y + margin, calculatedImageSettings.w, calculatedImageSettings.h);
      }
    }
  });
  useEffect(() => {
    setIsImageLoaded(false);
  }, [imgSrc]);
  const canvasStyle = __spreadValues({
    height: size,
    width: size
  }, style);
  let img = null;
  if (imgSrc != null) {
    img = /* @__PURE__ */React__default.createElement("img", {
      src: imgSrc,
      key: imgSrc,
      style: {
        display: "none"
      },
      onLoad: () => {
        setIsImageLoaded(true);
      },
      ref: _image
    });
  }
  return /* @__PURE__ */React__default.createElement(React__default.Fragment, null, /* @__PURE__ */React__default.createElement("canvas", __spreadValues({
    style: canvasStyle,
    height: size,
    width: size,
    ref: _canvas
  }, otherProps)), img);
}
function QRCodeSVG(props) {
  const _a = props,
    {
      value,
      size = DEFAULT_SIZE$1,
      level = DEFAULT_LEVEL,
      bgColor = DEFAULT_BGCOLOR,
      fgColor = DEFAULT_FGCOLOR,
      includeMargin = DEFAULT_INCLUDEMARGIN,
      imageSettings
    } = _a,
    otherProps = __objRest(_a, ["value", "size", "level", "bgColor", "fgColor", "includeMargin", "imageSettings"]);
  let cells = qrcodegen_default.QrCode.encodeText(value, ERROR_LEVEL_MAP[level]).getModules();
  const margin = includeMargin ? MARGIN_SIZE : 0;
  const numCells = cells.length + margin * 2;
  const calculatedImageSettings = getImageSettings(cells, size, includeMargin, imageSettings);
  let image = null;
  if (imageSettings != null && calculatedImageSettings != null) {
    if (calculatedImageSettings.excavation != null) {
      cells = excavateModules(cells, calculatedImageSettings.excavation);
    }
    image = /* @__PURE__ */React__default.createElement("image", {
      xlinkHref: imageSettings.src,
      height: calculatedImageSettings.h,
      width: calculatedImageSettings.w,
      x: calculatedImageSettings.x + margin,
      y: calculatedImageSettings.y + margin,
      preserveAspectRatio: "none"
    });
  }
  const fgPath = generatePath(cells, margin);
  return /* @__PURE__ */React__default.createElement("svg", __spreadValues({
    height: size,
    width: size,
    viewBox: `0 0 ${numCells} ${numCells}`
  }, otherProps), /* @__PURE__ */React__default.createElement("path", {
    fill: bgColor,
    d: `M0,0 h${numCells}v${numCells}H0z`,
    shapeRendering: "crispEdges"
  }), /* @__PURE__ */React__default.createElement("path", {
    fill: fgColor,
    d: fgPath,
    shapeRendering: "crispEdges"
  }), image);
}
var QRCode = props => {
  const _a = props,
    {
      renderAs
    } = _a,
    otherProps = __objRest(_a, ["renderAs"]);
  if (renderAs === "svg") {
    return /* @__PURE__ */React__default.createElement(QRCodeSVG, __spreadValues({}, otherProps));
  }
  return /* @__PURE__ */React__default.createElement(QRCodeCanvas, __spreadValues({}, otherProps));
};

const LogoIcon$1 = props => (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)("svg", {
  className: "icon",
  width: "100%",
  height: "100%",
  viewBox: "0 0 20 20",
  preserveAspectRatio: "xMidYMid meet",
  ...props,
  children: (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsxs */ .BX)("g", {
    fill: "none",
    fillRule: "evenodd",
    children: [(0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)("path", {
      fill: "#35C5F0",
      d: "M16.41 0H3.59A3.59 3.59 0 0 0 0 3.59v12.82A3.59 3.59 0 0 0 3.59 20h12.82A3.59 3.59 0 0 0 20 16.41V3.59A3.59 3.59 0 0 0 16.41 0"
    }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)("path", {
      fill: "#FFF",
      d: "M14.75 10.34c-.74 0-1.33-.6-1.33-1.34 0-.74.6-1.34 1.33-1.34s1.32.6 1.32 1.34c0 .74-.59 1.34-1.32 1.34zm-1 3.53H6.12V8.75l3.82-2.7 2.2 1.55a3.01 3.01 0 0 0-.35 1.4 3 3 0 0 0 1.98 2.83v2.04zm1-7.87c-.34 0-.66.06-.97.17l-3.17-2.24a1.18 1.18 0 0 0-1.35 0L4.5 7.28a1.2 1.2 0 0 0-.51.98v6.54c0 .66.53 1.2 1.19 1.2h9.5a1.2 1.2 0 0 0 1.18-1.2v-3.02A3 3 0 0 0 17.7 9c0-1.65-1.32-3-2.96-3z"
    })]
  })
});

function _EMOTION_STRINGIFIED_CSS_ERROR__$J() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
const AppDownloadPopupWithQR = ({
  deeplink,
  isOpen,
  isMobileDevice,
  onClose,
  actionType,
  localeData
}) => {
  const isMobile = useResponsive().breakpoint === 'mobile';
  const handleDownloadApp = () => {
    L({
      category: 'click',
      url: window.location.href,
      section: '앱 QR 모달',
      section_id: 'MODAL_APP_QR',
      type: 'button',
      id: 'app',
      data: {
        object_group: '팝업 액션',
        object_group_id: actionType
      }
    });
    window.location.href = deeplink;
  };
  const action = isMobileDevice ? {
    primary: {
      text: localeData.popupWebToAppBtn02,
      onClick: handleDownloadApp
    }
  } : undefined;
  const handleBlur = () => {
    L({
      category: 'click',
      url: window.location.href,
      section: '앱 QR 모달',
      section_id: 'MODAL_APP_QR',
      type: 'grey_zone',
      id: 'close'
    });
    onClose();
  };
  useEffect(() => {
    if (isOpen) {
      L({
        category: 'impression',
        url: window.location.href,
        type: '앱 QR 모달',
        id: 'MODAL_APP_QR',
        data: [{
          object_group: '팝업 액션',
          object_group_id: actionType
        }]
      });
      logAmplitude$1('Pop-up', {
        action_name: actionType
      });
    }
  }, [isOpen, actionType]);
  if (!isOpen) {
    return null;
  }
  return jsx(Modal, {
    width: 400,
    footer: {
      action
    },
    disableBackgroundScroll: isOpen,
    onBlur: handleBlur,
    role: "dialog",
    children: jsxs(Container$k, {
      children: [isMobileDevice ? jsx(Logo$1, {
        "data-testid": "logo"
      }) : jsxs(Fragment$1, {
        children: [jsx(Title$8, {
          children: localeData.popupWebToAppTitleScan
        }), jsx(QRCode, {
          "data-testid": "qr",
          value: deeplink,
          size: isMobile ? 64 : 80
        })]
      }), jsx(Description$1, {
        children: localeData.popupWebToAppTitle
      })]
    })
  });
};
const Container$k = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)("div",  true ? {
  target: "e2lc0f63"
} : 0)("padding:30px 16px 10px 16px;display:flex;flex-direction:column;align-items:center;justify-content:center;gap:10px;", _bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.M.min('tablet',  true ? {
  name: "1b5azyf",
  styles: "padding:20px 16px 0 16px"
} : 0), ";" + ( true ? "" : 0));
const Title$8 = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)("div",  true ? {
  target: "e2lc0f62"
} : 0)(_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.F.title3, " font-weight:700;color:", ({
  theme
}) => theme.content.base1, ";" + ( true ? "" : 0));
const Description$1 = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)("p",  true ? {
  target: "e2lc0f61"
} : 0)(_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.F.body1_small, ";font-weight:500;white-space:pre-wrap;color:", ({
  theme
}) => theme.content.base1, ";" + ( true ? "" : 0));
const Logo$1 = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(LogoIcon$1,  true ? {
  target: "e2lc0f60"
} : 0)("width:64px;height:64px;", _bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.M.min('tablet',  true ? {
  name: "1e9n0ny",
  styles: "width:80px;height:80px"
} : 0), ";" + ( true ? "" : 0));

function BlockedPage({
  className,
  title,
  description,
  exit
}) {
  return jsxs(Container$j, {
    className: className,
    children: [jsx(Title$7, {
      children: title
    }), jsx(Description, {
      children: description
    }), exit && jsx(Responsive, {
      mobile: jsx(ExitButton, {
        size: 32,
        variant: "primary1",
        onClick: exit.onClick,
        children: exit.text
      }),
      tablet: jsx(ExitButton, {
        size: 30,
        variant: "primary1",
        onClick: exit.onClick,
        children: exit.text
      })
    })]
  });
}
const Container$j = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)("div",  true ? {
  target: "eqn4bhi3"
} : 0)("width:100%;max-width:", (0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.p)(300), ";margin:", (0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.p)(140), " auto;padding:0 ", (0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.p)(40), ";box-sizing:border-box;text-align:center;word-break:keep-all;word-wrap:break-word;", _bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.M.min('tablet', /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_6__/* .css */ .iv)("max-width:", (0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.p)(500), ";margin-top:", (0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.p)(200), ";margin-bottom:", (0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.p)(200), ";" + ( true ? "" : 0),  true ? "" : 0)), ";" + ( true ? "" : 0));
const Title$7 = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)("p",  true ? {
  target: "eqn4bhi2"
} : 0)("margin-bottom:", (0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.p)(8), ";", _bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.F.subTitle1, ";font-weight:700;color:", ({
  theme
}) => theme.content.base1, ";", _bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.M.min('tablet', /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_6__/* .css */ .iv)(_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.F.title3, ";" + ( true ? "" : 0),  true ? "" : 0)), ";" + ( true ? "" : 0));
const Description = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)("p",  true ? {
  target: "eqn4bhi1"
} : 0)("margin:", (0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.p)(8), " 0 ", (0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.p)(13), ";", _bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.F.body2, ";color:", ({
  theme
}) => theme.content.base1, ";white-space:pre-line;", _bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.M.min('tablet', /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_6__/* .css */ .iv)(_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.F.body1_1, ";" + ( true ? "" : 0),  true ? "" : 0)), ";" + ( true ? "" : 0));
const ExitButton = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_bucketplace_design_system_bds__WEBPACK_IMPORTED_MODULE_8__/* .TextButton */ .Avr,  true ? {
  target: "eqn4bhi0"
} : 0)("margin:", (0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.p)(7), " 0 0;" + ( true ? "" : 0));

function _EMOTION_STRINGIFIED_CSS_ERROR__$I() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
const ChipListModule = ({
  chipListInfo,
  onClick,
  ...rest
}) => {
  const {
    label,
    chipList
  } = chipListInfo;
  return jsxs(Container$i, {
    ...rest,
    children: [label && jsx(Label$2, {
      children: label
    }), jsx(ChipList, {
      children: chipList.map(({
        chipId,
        chipLabel,
        selected
      }) => {
        return jsx(ChipItem, {
          children: jsx(OutlineSelectChip, {
            size: 32,
            variant: "primary1",
            checked: selected,
            onCheck: () => onClick(chipId),
            children: chipLabel
          })
        }, chipId);
      })
    })]
  });
};
const Container$i = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)("div",  true ? {
  target: "e1t6ufvy3"
} : 0)("margin-bottom:", (0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.p)(20), ";" + ( true ? "" : 0));
const Label$2 = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)("p",  true ? {
  target: "e1t6ufvy2"
} : 0)(_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.F.subTitle2, " font-weight:700;margin-bottom:", (0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.p)(8), ";" + ( true ? "" : 0));
const ChipList = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)("ul",  true ? {
  target: "e1t6ufvy1"
} : 0)( true ? {
  name: "1mzohwv",
  styles: "display:flex;flex-direction:row;flex-wrap:wrap;text-align:center;align-items:center"
} : 0);
const ChipItem = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)("li",  true ? {
  target: "e1t6ufvy0"
} : 0)("margin-right:", (0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.p)(4), ";margin-bottom:", (0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.p)(8), ";" + ( true ? "" : 0));

function _EMOTION_STRINGIFIED_CSS_ERROR__$H() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
const FeedItemThumbnail = ({
  src,
  isZoomed,
  dim,
  topLeft,
  topRight,
  bottomLeft,
  bottomRight,
  aspect = 3 / 2,
  alt = '',
  quality,
  lazy
}) => {
  const isMobile = useResponsive().breakpoint === 'mobile';
  const handleCornerClick = useCallback(e => {
    e.preventDefault();
    e.stopPropagation();
  }, []);
  return jsxs(Container$h, {
    aspect: aspect,
    children: [jsx(Thumbnail, {
      alt: alt,
      src: src,
      intrinsicAspect: aspect,
      objectFit: "cover",
      style: isZoomed && !isMobile ? {
        transform: 'scale(1.05)'
      } : undefined,
      quality: quality,
      lazy: lazy
    }), topLeft && jsx(Corner, {
      position: "top-left",
      onClick: handleCornerClick,
      children: topLeft
    }), topRight && jsx(Corner, {
      position: "top-right",
      onClick: handleCornerClick,
      children: topRight
    }), bottomLeft && jsx(Corner, {
      position: "bottom-left",
      onClick: handleCornerClick,
      children: bottomLeft
    }), bottomRight && jsx(Corner, {
      position: "bottom-right",
      onClick: handleCornerClick,
      children: bottomRight
    }), dim && jsx(Dim, {
      children: dim
    })]
  });
};
const Container$h = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)("div",  true ? {
  target: "e8i2tqm3"
} : 0)("overflow:hidden;position:relative;border-radius:", (0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.p)(4), ";&:before{content:\"\";display:block;", ({
  aspect
}) => /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_6__/* .css */ .iv)("padding-top:", 100 / aspect, "%;" + ( true ? "" : 0),  true ? "" : 0), ";}" + ( true ? "" : 0));
const Thumbnail = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_9__.R,  true ? {
  target: "e8i2tqm2"
} : 0)( true ? {
  name: "161a5fa",
  styles: "position:absolute;top:0;left:0;transition:transform .2s"
} : 0);
const Corner = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)("div",  true ? {
  target: "e8i2tqm1"
} : 0)("position:absolute;padding:", (0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.p)(6), ";font-size:0;z-index:1;", ({
  position
}) => {
  switch (position) {
    case 'top-left':
      return /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_6__/* .css */ .iv)("top:", (0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.p)(6), ";left:", (0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.p)(6), ";" + ( true ? "" : 0),  true ? "" : 0);
    case 'top-right':
      return /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_6__/* .css */ .iv)("top:", (0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.p)(6), ";right:", (0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.p)(6), ";" + ( true ? "" : 0),  true ? "" : 0);
    case 'bottom-left':
      return /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_6__/* .css */ .iv)("left:", (0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.p)(6), ";bottom:", (0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.p)(6), ";" + ( true ? "" : 0),  true ? "" : 0);
    case 'bottom-right':
      return /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_6__/* .css */ .iv)("right:", (0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.p)(6), ";bottom:", (0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.p)(6), ";" + ( true ? "" : 0),  true ? "" : 0);
    default:
      return '';
  }
}, ";" + ( true ? "" : 0));
const Dim = /*#__PURE__*/(/* unused pure expression or super */ null && (_styled("div",  true ? {
  target: "e8i2tqm0"
} : 0)("position:absolute;top:0;left:0;right:0;bottom:0;display:flex;align-items:center;justify-content:center;color:", ({
  theme
}) => theme.content.base6, ";background:", ({
  theme
}) => theme.dim.basic, ";" + ( true ? "" : 0))));

function _EMOTION_STRINGIFIED_CSS_ERROR__$G() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
const HorizontalFeedItem = ({
  className,
  thumbnail,
  title,
  writer,
  counts
}) => {
  return jsxs(Container$g, {
    "data-testid": "horizontal-feed-item",
    className: className,
    children: [jsx(FeedItemThumbnail, {
      aspect: 3 / 2,
      ...thumbnail
    }), title && jsx(Title$6, {
      children: title
    }), writer && jsxs(Writer, {
      onClick: e => {
        writer.onClick?.(e);
        e.preventDefault();
        e.stopPropagation();
      },
      children: [writer.avatar && jsx(Avatar, {
        children: jsx(ResizeImage, {
          src: writer.avatar,
          intrinsicInitialWidth: 18,
          intrinsicAspect: 1,
          objectFit: "cover"
        })
      }), jsx(Nickname$2, {
        children: writer.nickname
      }), jsx(RightNickname, {
        children: writer.rightNickName
      })]
    }), counts && jsx(Counts$1, {
      children: counts.map((count, i) => jsx(Count$1, {
        children: `${count.label} ${count.number.toLocaleString()}`
      }, i))
    })]
  });
};
const Container$g = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)("div",  true ? {
  target: "e1yd5r1u7"
} : 0)( true ? {
  name: "1azakc",
  styles: "text-align:center"
} : 0);
const Title$6 = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)("p",  true ? {
  target: "e1yd5r1u6"
} : 0)(_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.F.subTitle1, " overflow:hidden;display:-webkit-box;margin-top:", (0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.p)(14), ";color:", ({
  theme
}) => theme.content.base1, ";font-weight:700;text-overflow:ellipsis;word-wrap:break-word;-webkit-line-clamp:2;-webkit-box-orient:vertical;" + ( true ? "" : 0));
const Writer = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)("div",  true ? {
  target: "e1yd5r1u5"
} : 0)("display:flex;align-items:center;justify-content:center;margin-top:", (0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.p)(8), ";", _bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.F.subTitle2, " font-weight:500;" + ( true ? "" : 0));
const Avatar = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)("div",  true ? {
  target: "e1yd5r1u4"
} : 0)("overflow:hidden;position:relative;width:", (0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.p)(18), ";height:", (0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.p)(18), ";border-radius:100%;margin-right:", (0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.p)(6), ";flex:none;" + ( true ? "" : 0));
const Nickname$2 = /*#__PURE__*/(/* unused pure expression or super */ null && (_styled("span",  true ? {
  target: "e1yd5r1u3"
} : 0)("color:", ({
  theme
}) => theme.content.base1, ";display:flex;align-items:center;display:-webkit-box;overflow:hidden;text-overflow:ellipsis;-webkit-line-clamp:1;-webkit-box-orient:vertical;word-break:break-all;" + ( true ? "" : 0))));
const RightNickname = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)("span",  true ? {
  target: "e1yd5r1u2"
} : 0)( true ? {
  name: "1iiyiwh",
  styles: "flex:none;display:flex;align-items:center"
} : 0);
const Counts$1 = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)("div",  true ? {
  target: "e1yd5r1u1"
} : 0)("display:flex;flex-wrap:wrap;align-items:center;justify-content:center;margin-top:", (0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.p)(8), ";" + ( true ? "" : 0));
const Count$1 = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)("span",  true ? {
  target: "e1yd5r1u0"
} : 0)(_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.F.subTitle2, " position:relative;flex-shrink:0;margin-right:", (0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.p)(8), ";color:", ({
  theme
}) => theme.content.base2, ";&:before{content:\"\";position:absolute;top:0;left:", (0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.p)(-4), ";bottom:0;width:", (0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.p)(2), ";height:", (0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.p)(2), ";margin:auto;border-radius:100%;background:", ({
  theme
}) => theme.content.base2, ";}&:first-of-type:before{content:none;}" + ( true ? "" : 0));

function _EMOTION_STRINGIFIED_CSS_ERROR__$F() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
const VerticalFeedItem = ({
  className,
  thumbnail,
  title,
  writer,
  counts
}) => {
  return jsxs(Container$f, {
    "data-testid": "vertical-feed-item",
    className: className,
    children: [jsx(Column, {
      children: jsx(FeedItemThumbnail, {
        aspect: 8 / 5,
        ...thumbnail
      })
    }), jsxs(Column, {
      children: [jsx(Row$1, {
        children: title && jsx(Title$5, {
          children: title
        })
      }), writer && jsxs(Nickname$1, {
        onClick: writer.onClick,
        children: [writer.nickname, writer.rightNickName]
      }), counts && jsx(Counts, {
        children: counts.map((count, i) => jsx(Count, {
          children: `${count.label} ${count.number.toLocaleString()}`
        }, i))
      })]
    })]
  });
};
const Container$f = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)("div",  true ? {
  target: "emnxm2m6"
} : 0)("overflow:hidden;display:flex;align-items:top;width:100%;padding:0 ", (0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.p)(16), ";box-sizing:border-box;" + ( true ? "" : 0));
const Column = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)("div",  true ? {
  target: "emnxm2m5"
} : 0)("flex:1 0 0%;margin-left:", (0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.p)(12), ";&:first-of-type{margin-left:0;}" + ( true ? "" : 0));
const Row$1 = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)("div",  true ? {
  target: "emnxm2m4"
} : 0)( true ? {
  name: "zjik7",
  styles: "display:flex"
} : 0);
const Title$5 = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)("p",  true ? {
  target: "emnxm2m3"
} : 0)(_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.F.subTitle1, " overflow:hidden;flex:1 0 0%;display:-webkit-box;color:", ({
  theme
}) => theme.content.base1, ";font-weight:500;text-overflow:ellipsis;word-wrap:break-word;-webkit-line-clamp:3;-webkit-box-orient:vertical;" + ( true ? "" : 0));
const Nickname$1 = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)("span",  true ? {
  target: "emnxm2m2"
} : 0)(_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.F.body3, " display:block;margin-top:", (0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.p)(8), ";color:", ({
  theme
}) => theme.content.base2, ";font-weight:500;display:flex;align-items:center;" + ( true ? "" : 0));
const Counts = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)("div",  true ? {
  target: "emnxm2m1"
} : 0)("display:flex;flex-wrap:wrap;align-items:center;margin-top:", (0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.p)(2), ";" + ( true ? "" : 0));
const Count = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)("span",  true ? {
  target: "emnxm2m0"
} : 0)(_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.F.body3, " flex-shrink:0;position:relative;margin:0 ", (0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.p)(8), ";color:", ({
  theme
}) => theme.content.base2, ";&:before{content:\"\";position:absolute;top:0;left:", (0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.p)(-4), ";bottom:0;width:", (0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.p)(2), ";height:", (0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.p)(2), ";margin:auto;border-radius:100%;background:", ({
  theme
}) => theme.content.base2, ";}&:first-of-type{margin-left:0;&:before{content:none;}}" + ( true ? "" : 0));

function _EMOTION_STRINGIFIED_CSS_ERROR__$E() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
const FeedItem = /*#__PURE__*/(/* unused pure expression or super */ null && (React__default.memo(({
  flow = 'horizontal',
  link,
  onClick,
  onImpression = () => {/* noop */},
  ...props
}) => {
  const [isHovered, setHovered] = useState(false);
  const intersectionObserverTarget = useIntersectionObserver({
    options: {
      triggerOnce: true
    },
    onIntersect: onImpression
  });
  const feedItem = jsxs(Container$e, {
    ref: intersectionObserverTarget,
    clickable: !!onClick,
    onClick: onClick,
    onMouseEnter: () => setHovered(true),
    onMouseLeave: () => setHovered(false),
    children: [flow === 'horizontal' && jsx(HorizontalFeedItem, {
      ...props,
      thumbnail: {
        ...props.thumbnail,
        isZoomed: isHovered
      }
    }), flow === 'vertical' && jsx(VerticalFeedItem, {
      ...props,
      thumbnail: {
        ...props.thumbnail,
        isZoomed: isHovered
      }
    })]
  });
  if (link) {
    const Link = link.component;
    return jsx(Link, {
      href: link.href,
      children: feedItem
    });
  } else {
    return feedItem;
  }
})));
var _ref$m =  true ? {
  name: "e0dnmk",
  styles: "cursor:pointer"
} : 0;
const Container$e = /*#__PURE__*/(/* unused pure expression or super */ null && (_styled("div",  true ? {
  target: "etxueos0"
} : 0)("position:relative;", ({
  clickable
}) => clickable && _ref$m, ";" + ( true ? "" : 0))));

/**
 * @internal
 */
const SkeletonThemeContext = react__WEBPACK_IMPORTED_MODULE_0__.createContext({});

/* eslint-disable react/no-array-index-key */
const defaultEnableAnimation = true;
// For performance & cleanliness, don't add any inline styles unless we have to
function styleOptionsToCssProperties({ baseColor, highlightColor, width, height, borderRadius, circle, direction, duration, enableAnimation = defaultEnableAnimation, }) {
    const style = {};
    if (direction === 'rtl')
        style['--animation-direction'] = 'reverse';
    if (typeof duration === 'number')
        style['--animation-duration'] = `${duration}s`;
    if (!enableAnimation)
        style['--pseudo-element-display'] = 'none';
    if (typeof width === 'string' || typeof width === 'number')
        style.width = width;
    if (typeof height === 'string' || typeof height === 'number')
        style.height = height;
    if (typeof borderRadius === 'string' || typeof borderRadius === 'number')
        style.borderRadius = borderRadius;
    if (circle)
        style.borderRadius = '50%';
    if (typeof baseColor !== 'undefined')
        style['--base-color'] = baseColor;
    if (typeof highlightColor !== 'undefined')
        style['--highlight-color'] = highlightColor;
    return style;
}
function Skeleton({ count = 1, wrapper: Wrapper, className: customClassName, containerClassName, containerTestId, circle = false, style: styleProp, ...originalPropsStyleOptions }) {
    var _a, _b, _c;
    const contextStyleOptions = react__WEBPACK_IMPORTED_MODULE_0__.useContext(SkeletonThemeContext);
    const propsStyleOptions = { ...originalPropsStyleOptions };
    // DO NOT overwrite style options from the context if `propsStyleOptions`
    // has properties explicity set to undefined
    for (const [key, value] of Object.entries(originalPropsStyleOptions)) {
        if (typeof value === 'undefined') {
            delete propsStyleOptions[key];
        }
    }
    // Props take priority over context
    const styleOptions = {
        ...contextStyleOptions,
        ...propsStyleOptions,
        circle,
    };
    // `styleProp` has the least priority out of everything
    const style = {
        ...styleProp,
        ...styleOptionsToCssProperties(styleOptions),
    };
    let className = 'react-loading-skeleton';
    if (customClassName)
        className += ` ${customClassName}`;
    const inline = (_a = styleOptions.inline) !== null && _a !== void 0 ? _a : false;
    const elements = [];
    const countCeil = Math.ceil(count);
    for (let i = 0; i < countCeil; i++) {
        let thisStyle = style;
        if (countCeil > count && i === countCeil - 1) {
            // count is not an integer and we've reached the last iteration of
            // the loop, so add a "fractional" skeleton.
            //
            // For example, if count is 3.5, we've already added 3 full
            // skeletons, so now we add one more skeleton that is 0.5 times the
            // original width.
            const width = (_b = thisStyle.width) !== null && _b !== void 0 ? _b : '100%'; // 100% is the default since that's what's in the CSS
            const fractionalPart = count % 1;
            const fractionalWidth = typeof width === 'number'
                ? width * fractionalPart
                : `calc(${width} * ${fractionalPart})`;
            thisStyle = { ...thisStyle, width: fractionalWidth };
        }
        const skeletonSpan = (react__WEBPACK_IMPORTED_MODULE_0__.createElement("span", { className: className, style: thisStyle, key: i }, "\u200C"));
        if (inline) {
            elements.push(skeletonSpan);
        }
        else {
            // Without the <br />, the skeleton lines will all run together if
            // `width` is specified
            elements.push(react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, { key: i },
                skeletonSpan,
                react__WEBPACK_IMPORTED_MODULE_0__.createElement("br", null)));
        }
    }
    return (react__WEBPACK_IMPORTED_MODULE_0__.createElement("span", { className: containerClassName, "data-testid": containerTestId, "aria-live": "polite", "aria-busy": (_c = styleOptions.enableAnimation) !== null && _c !== void 0 ? _c : defaultEnableAnimation }, Wrapper
        ? elements.map((el, i) => react__WEBPACK_IMPORTED_MODULE_0__.createElement(Wrapper, { key: i }, el))
        : elements));
}

function _EMOTION_STRINGIFIED_CSS_ERROR__$D() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
const FeedItemPlaceholder = /*#__PURE__*/(/* unused pure expression or super */ null && (React__default.memo(({
  flow = 'horizontal'
}) => {
  if (flow === 'vertical') {
    return jsxs(VerticalContainer, {
      "data-testid": "vertical-container",
      children: [jsx(VerticalContainerColumn, {
        children: jsx(ImageSkeletonWrapper, {
          children: jsx(ImageSkeleton$3, {})
        })
      }), jsxs(VerticalContainerColumn, {
        children: [jsx(TextSkeleton$2, {}), jsx(TextSkeleton$2, {
          width: "50%",
          marginTop: 8
        })]
      })]
    });
  }
  return jsxs(HorizontalContainer, {
    "data-testid": "horizontal-container",
    children: [jsx(ImageSkeletonWrapper, {
      children: jsx(ImageSkeleton$3, {})
    }), jsx(TextSkeleton$2, {
      marginTop: 14
    }), jsx(TextSkeleton$2, {
      width: "50%",
      marginTop: 8
    })]
  });
})));
const HorizontalContainer = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)("div",  true ? {
  target: "e1adnbeh5"
} : 0)( true ? {
  name: "1xe63ku",
  styles: "line-height:1"
} : 0);
const VerticalContainer = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)("div",  true ? {
  target: "e1adnbeh4"
} : 0)( true ? {
  name: "7whenc",
  styles: "display:flex;width:100%"
} : 0);
const VerticalContainerColumn = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)("div",  true ? {
  target: "e1adnbeh3"
} : 0)("flex:1;margin-left:", (0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.p)(12), ";&:first-of-type{margin-left:0;}" + ( true ? "" : 0));
const ImageSkeletonWrapper = /*#__PURE__*/(/* unused pure expression or super */ null && (_styled("div",  true ? {
  target: "e1adnbeh2"
} : 0)("position:relative;&:before{content:\"\";display:block;padding-top:", 2 / 3 * 100, "%;}br{display:none;}" + ( true ? "" : 0))));
const ImageSkeleton$3 = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(Skeleton,  true ? {
  target: "e1adnbeh1"
} : 0)( true ? {
  name: "1at77vf",
  styles: "position:absolute;top:0;left:0;min-height:100%"
} : 0);
const TextSkeleton$2 = /*#__PURE__*/(/* unused pure expression or super */ null && (_styled(Skeleton,  true ? {
  target: "e1adnbeh0"
} : 0)("margin-top:", ({
  marginTop
}) => marginTop ? pxToRem(marginTop) : 0, ";" + ( true ? "" : 0))));

const canPlayHls = videoElem => {
  return !!videoElem.canPlayType('application/vnd.apple.mpegurl');
};
const Video = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)((props, ref) => {
  const {
    src,
    autoPlay,
    useHlsJs = true,
    hlsConfig,
    quality = 'auto',
    ...restProps
  } = props;
  const videoRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
  const mergedRef = useMergeRef(ref ?? null, videoRef);
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    const videoElem = videoRef.current;
    if (!videoElem || !src) {
      return;
    }
    let unmounted = false;
    let playPromise;
    Promise.resolve().then(function () { return hls; }).then(({
      default: HlsJs
    }) => {
      if (unmounted) {
        return;
      }
      if (!src) {
        return;
      }
      if (!useHlsJs) {
        videoElem.src = src;
      } else if (HlsJs.isSupported()) {
        const hls = new HlsJs(hlsConfig ?? {});
        hls.attachMedia(videoElem);
        hls.loadSource(src);
        if (quality === 'low') {
          hls.autoLevelCapping = 0;
        }
        if (quality === 'auto') {
          hls.capLevelToPlayerSize = true;
        }
      } else if (canPlayHls(videoElem)) {
        videoElem.src = src;
      }
      videoElem.load();
      // Because Safari
      if (autoPlay) {
        playPromise = videoElem.play();
      }
    });
    return () => {
      unmounted = true;
      if (playPromise !== undefined) {
        playPromise.then(() => {
          videoElem.removeAttribute('src');
          videoElem.load();
        }).catch(() => {
          /**
           * Uncaught (in promise) DOMException: The play() request was interrupted because the media was removed from the document.
           * catch above error
           * */
        });
      }
    };
  }, [src, useHlsJs, autoPlay, hlsConfig, quality]);
  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)("video", {
    ...restProps,
    "data-testid": "video",
    src: src,
    autoPlay: autoPlay,
    ref: mergedRef
  });
});

const FeedItemVideoThumbnail = ({
  src,
  aspect = 3 / 2,
  canPlay,
  poster
}) => {
  return jsx(VideoContainer, {
    aspect: aspect,
    children: canPlay && jsx(StyledVideoPlayer, {
      src: src,
      quality: "auto",
      loop: true,
      autoPlay: true,
      muted: true,
      playsInline: true,
      poster: poster
    })
  });
};
const StyledVideoPlayer = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(Video,  true ? {
  target: "efg1py01"
} : 0)("width:100%;height:100%;object-fit:cover;border-radius:", (0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.p)(4), ";" + ( true ? "" : 0));
const VideoContainer = /*#__PURE__*/(/* unused pure expression or super */ null && (_styled("div",  true ? {
  target: "efg1py00"
} : 0)("aspect-ratio:", props => props.aspect, ";" + ( true ? "" : 0))));

function _EMOTION_STRINGIFIED_CSS_ERROR__$C() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
const CardFeedItem = ({
  writer,
  thumbnail,
  videoThumbnail,
  actions,
  title,
  link
}) => {
  const [isHovered, setIsHovered] = useState(false);
  const {
    ref: targetRef,
    inView
  } = useInView({
    threshold: 1,
    skip: !isMobileDevice()
  });
  const Link = link.component;
  const countFormatter = new Intl.NumberFormat('en', {
    notation: 'compact'
  });
  return jsxs("div", {
    children: [writer && jsxs(WriterContainer$1, {
      children: [jsxs(WriterMainContainer, {
        children: [jsxs(WriterLink, {
          as: Link,
          href: writer.href,
          onClick: writer.onClick,
          children: [jsx(WriterNickname, {
            children: writer.nickname
          }), jsx(WriterAvatar, {
            children: jsx(ResizeImage, {
              src: writer.avatarSrc,
              intrinsicInitialWidth: 72,
              intrinsicAspect: 1,
              objectFit: "cover",
              alt: ""
            })
          })]
        }), writer.action && jsxs(Fragment$1, {
          children: [jsx(WriterNickname, {
            children: "\xB7"
          }), jsx(WriterAction, {
            onClick: writer.action.onClick,
            children: writer.action.label
          })]
        })]
      }), writer.description && jsx(WriterDescription, {
        children: writer.description
      })]
    }), jsxs(Container$d, {
      children: [jsxs(Link, {
        href: link.href,
        onMouseEnter: () => setIsHovered(true),
        onMouseLeave: () => setIsHovered(false),
        children: [jsxs(ThumbnailContainer$1, {
          children: [jsx(FeedItemThumbnail, {
            ...thumbnail,
            aspect: 1,
            isZoomed: isHovered
          }), videoThumbnail && jsx(VideoThumbnailContainer$1, {
            ref: targetRef,
            children: jsx(FeedItemVideoThumbnail, {
              src: videoThumbnail.src,
              aspect: 1,
              canPlay: isHovered && !isMobileDevice() || inView && isMobileDevice()
            })
          })]
        }), actions && jsx(ActionsPlaceholder, {}), jsx(Title$4, {
          isHovered: isHovered,
          children: title
        })]
      }), actions && jsx(Actions, {
        children: actions.map(action => jsxs(ActionButton, {
          type: "button",
          onClick: action.onClick,
          children: [jsx(Icon$1, {
            name: action.iconName,
            size: 24,
            fill: theme => action.iconColor?.(theme) ?? theme.content.base1
          }), jsx(ActionCount, {
            children: countFormatter.format(action.count)
          })]
        }, action.iconName))
      })]
    })]
  });
};
const WriterContainer$1 = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)("div",  true ? {
  target: "e12sucbr14"
} : 0)("display:flex;flex-direction:column;gap:", (0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.p)(2), ";position:relative;min-height:", (0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.p)(40), ";padding-left:", (0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.p)(48), ";margin-bottom:", (0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.p)(16), ";" + ( true ? "" : 0));
const WriterMainContainer = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)("div",  true ? {
  target: "e12sucbr13"
} : 0)("margin:auto 0;display:flex;align-items:center;gap:", (0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.p)(4), ";" + ( true ? "" : 0));
const WriterLink = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)("a",  true ? {
  target: "e12sucbr12"
} : 0)( true ? {
  name: "6isekk",
  styles: "&:hover{opacity:0.5;}"
} : 0);
const WriterAvatar = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)("span",  true ? {
  target: "e12sucbr11"
} : 0)("position:absolute;left:0;top:0;overflow:hidden;width:", (0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.p)(36), ";height:", (0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.p)(36), ";border-radius:100%;" + ( true ? "" : 0));
const WriterNickname = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)("span",  true ? {
  target: "e12sucbr10"
} : 0)(_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.F.body1_small, " font-weight:700;color:", ({
  theme
}) => theme.content.base1, ";display:-webkit-box;overflow:hidden;text-overflow:ellipsis;-webkit-line-clamp:1;-webkit-box-orient:vertical;word-break:break-all;" + ( true ? "" : 0));
const WriterAction = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)("button",  true ? {
  target: "e12sucbr9"
} : 0)(_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.R, " ", _bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.F.body1_small, " font-weight:700;color:", ({
  theme
}) => theme.content.primary1.basic, ";white-space:nowrap;" + ( true ? "" : 0));
const WriterDescription = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)("span",  true ? {
  target: "e12sucbr8"
} : 0)(_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.F.caption1, " color:", ({
  theme
}) => theme.content.base2, ";font-weight:400;display:-webkit-box;overflow:hidden;text-overflow:ellipsis;-webkit-line-clamp:1;-webkit-box-orient:vertical;word-break:break-all;" + ( true ? "" : 0));
const Container$d = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)("div",  true ? {
  target: "e12sucbr7"
} : 0)( true ? {
  name: "bjn8wh",
  styles: "position:relative"
} : 0);
const ThumbnailContainer$1 = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)("div",  true ? {
  target: "e12sucbr6"
} : 0)( true ? {
  name: "bjn8wh",
  styles: "position:relative"
} : 0);
const VideoThumbnailContainer$1 = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)("div",  true ? {
  target: "e12sucbr5"
} : 0)( true ? {
  name: "b98nv4",
  styles: "position:absolute;inset:0"
} : 0);
const ActionsPlaceholder = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)("div",  true ? {
  target: "e12sucbr4"
} : 0)( true ? {
  name: "1k18kha",
  styles: "height:40px"
} : 0);
const Actions = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)("div",  true ? {
  target: "e12sucbr3"
} : 0)( true ? {
  name: "9h583h",
  styles: "position:absolute;top:0;width:100%;margin-top:100%;height:40px;display:flex;justify-content:space-between"
} : 0);
const ActionButton = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)("button",  true ? {
  target: "e12sucbr2"
} : 0)(_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.R, " flex:1 0 0;padding:", (0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.p)(12), " 0 ", (0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.p)(4), " 0;display:flex;justify-content:center;align-items:center;&:hover{opacity:0.5;}" + ( true ? "" : 0));
const ActionCount = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)("span",  true ? {
  target: "e12sucbr1"
} : 0)(_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.F.body3, " color:", ({
  theme
}) => theme.content.base1, ";margin-left:", (0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.p)(6), ";" + ( true ? "" : 0));
var _ref$l =  true ? {
  name: "o9ww1u",
  styles: "opacity:0.5"
} : 0;
const Title$4 = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)("div",  true ? {
  target: "e12sucbr0"
} : 0)("margin-top:12px;", _bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.F.body1_small, " color:", ({
  theme
}) => theme.content.base1, ";white-space:pre-line;display:-webkit-box;overflow:hidden;text-overflow:ellipsis;-webkit-line-clamp:2;-webkit-box-orient:vertical;word-break:break-all;", ({
  isHovered
}) => isHovered && _ref$l, ";" + ( true ? "" : 0));

function _EMOTION_STRINGIFIED_CSS_ERROR__$B() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
const CardFeedItemPlaceholder = ({
  writer,
  actions
}) => {
  return jsxs("div", {
    style: {
      width: '100%'
    },
    children: [writer && jsxs(WriterContainer, {
      children: [jsx(AvatarPlaceholder, {
        height: "auto",
        borderRadius: "50%"
      }), jsx(NicknameContainer, {
        children: jsx(Skeleton, {
          height: "auto"
        })
      })]
    }), jsx(ImageSkeleton$2, {
      height: "auto"
    }), actions && jsx(ActionsContainer, {
      children: Array.from({
        length: 3
      }).map((_, index) => jsx(ActionIconContainer, {
        children: jsx(ActionIconPlaceholder, {
          height: "auto"
        })
      }, index))
    }), jsx(TitlePlaceholder, {})]
  });
};
const WriterContainer = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)("div",  true ? {
  target: "eknv2pi7"
} : 0)("display:flex;gap:", (0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.p)(12), ";min-height:", (0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.p)(40), ";margin-bottom:", (0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.p)(16), ";align-items:center;" + ( true ? "" : 0));
const AvatarPlaceholder = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(Skeleton,  true ? {
  target: "eknv2pi6"
} : 0)("width:", (0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.p)(40), ";aspect-ratio:1;border-radius:50%;" + ( true ? "" : 0));
const NicknameContainer = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)("div",  true ? {
  target: "eknv2pi5"
} : 0)( true ? {
  name: "82a6rk",
  styles: "flex:1"
} : 0);
const ImageSkeleton$2 = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(Skeleton,  true ? {
  target: "eknv2pi4"
} : 0)("aspect-ratio:1;width:100%;height:auto;border-radius:", (0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.p)(4), ";" + ( true ? "" : 0));
const ActionsContainer = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)("div",  true ? {
  target: "eknv2pi3"
} : 0)( true ? {
  name: "8w8w4j",
  styles: "height:40px;display:flex;justify-content:space-between"
} : 0);
const ActionIconContainer = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)("div",  true ? {
  target: "eknv2pi2"
} : 0)("flex:1 0 0;padding:", (0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.p)(12), " 0 ", (0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.p)(4), " 0;display:flex;justify-content:center;align-items:center;" + ( true ? "" : 0));
const ActionIconPlaceholder = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(Skeleton,  true ? {
  target: "eknv2pi1"
} : 0)("width:", (0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.p)(24), ";aspect-ratio:1;border-radius:50%;" + ( true ? "" : 0));
const TitlePlaceholder = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(Skeleton,  true ? {
  target: "eknv2pi0"
} : 0)( true ? {
  name: "xda5ep",
  styles: "margin-top:12px"
} : 0);

function _EMOTION_STRINGIFIED_CSS_ERROR__$A() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
const FEED_ITEM_MOBILE_ASPECT_RATIO = 3 / 4;
const FEED_ITEM_DESKTOP_ASPECT_RATIO = 1;
const ContentFeedItem = ({
  href,
  onClick,
  label,
  title,
  writer,
  thumbnail,
  videoThumbnail,
  className,
  linkComponent,
  like,
  scrap,
  badge
}) => {
  const [isHovered, setIsHovered] = useState(false);
  const {
    ref: targetRef,
    inView
  } = useInView({
    threshold: 1,
    skip: !isMobileDevice()
  });
  const isMobile = useResponsive().breakpoint === 'mobile';
  const Link = linkComponent ?? 'a';
  return jsxs(Container$c, {
    ref: targetRef,
    className: className,
    onMouseEnter: () => setIsHovered(true),
    onMouseLeave: () => setIsHovered(false),
    children: [jsxs(Link, {
      href: href,
      onClick: onClick,
      children: [jsxs(ThumbnailContainer, {
        children: [jsx(FeedItemThumbnail, {
          ...thumbnail,
          aspect: isMobile ? FEED_ITEM_MOBILE_ASPECT_RATIO : FEED_ITEM_DESKTOP_ASPECT_RATIO
        }), videoThumbnail && jsx(VideoThumbnailContainer, {
          children: jsx(FeedItemVideoThumbnail, {
            src: videoThumbnail.src,
            canPlay: isHovered && !isMobileDevice() || inView && isMobileDevice(),
            aspect: isMobile ? FEED_ITEM_MOBILE_ASPECT_RATIO : FEED_ITEM_DESKTOP_ASPECT_RATIO
          })
        })]
      }), jsxs(Title$3, {
        children: [label && jsx(Label$1, {
          children: `${label} `
        }), title]
      })]
    }), badge && jsx(BadgeContainer, {
      children: badge
    }), scrap && jsx(ScrapButton, {
      name: "scrap",
      "aria-label": scrap.label ?? '스크랩',
      size: 24,
      active: scrap.active,
      initialActive: scrap.initialActive,
      onActive: () => scrap.onClick(true),
      onInactive: () => scrap.onClick(false)
    }), jsxs(UserContainer, {
      children: [jsxs(Link, {
        href: writer.href,
        onClick: writer.onClick,
        children: [jsx(StyledAvatar, {
          size: 18,
          alt: "",
          src: getImageUrl({
            src: writer.avatar,
            width: 72,
            height: 72,
            quality: 60
          })
        }), jsx(Nickname, {
          children: writer.nickname
        })]
      }), like && jsxs(LikeButton, {
        type: "button",
        "aria-label": like.label ?? '좋아요',
        onClick: () => like.onClick(like.active),
        children: [jsx(Icon$1, {
          size: 16,
          name: like.active ? 'heart' : 'heart_outline',
          fill: theme => like.active ? theme.content.primary1.basic : theme.interactive.base1
        }), jsx(LikeCountText, {
          children: like.count > 0 && formatLargeNumber(like.count)
        })]
      })]
    })]
  });
};
const Container$c = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)("div",  true ? {
  target: "e1e7vpgj11"
} : 0)( true ? {
  name: "bjn8wh",
  styles: "position:relative"
} : 0);
const ThumbnailContainer = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)("div",  true ? {
  target: "e1e7vpgj10"
} : 0)("position:relative;aspect-ratio:", FEED_ITEM_MOBILE_ASPECT_RATIO, ";margin-bottom:", (0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.p)(8), ";overflow:hidden;border-radius:", (0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.p)(4), ";", _bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.M.min('tablet', /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_6__/* .css */ .iv)("aspect-ratio:", FEED_ITEM_DESKTOP_ASPECT_RATIO, ";margin-bottom:", (0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.p)(10), ";" + ( true ? "" : 0),  true ? "" : 0)), ";" + ( true ? "" : 0));
const VideoThumbnailContainer = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)("div",  true ? {
  target: "e1e7vpgj9"
} : 0)( true ? {
  name: "b98nv4",
  styles: "position:absolute;inset:0"
} : 0);
const Label$1 = /*#__PURE__*/(/* unused pure expression or super */ null && (_styled("span",  true ? {
  target: "e1e7vpgj8"
} : 0)("color:", ({
  theme
}) => theme.content.primary2.thick, ";font-weight:700;" + ( true ? "" : 0))));
const Title$3 = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)("div",  true ? {
  target: "e1e7vpgj7"
} : 0)(_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.F.body2_small, " color:", ({
  theme
}) => theme.content.base1, ";overflow:hidden;text-overflow:ellipsis;white-space:pre-line;display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical;margin-bottom:", (0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.p)(6), ";&:hover{opacity:0.5;}", _bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.M.min('tablet', /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_6__/* .css */ .iv)(_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.F.body1_1, " margin-bottom:", (0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.p)(10), ";" + ( true ? "" : 0),  true ? "" : 0)), ";" + ( true ? "" : 0));
const ScrapButton = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_bucketplace_design_system_bds__WEBPACK_IMPORTED_MODULE_8__/* .ToggleButton */ .COr,  true ? {
  target: "e1e7vpgj6"
} : 0)("position:absolute;top:", (0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.p)(-10), ";right:", (0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.p)(8), ";margin-top:", 1 / FEED_ITEM_MOBILE_ASPECT_RATIO * 100, "%;transform:translateY(-100%);@media(hover: hover){&:hover{opacity:0.5;}}", _bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.M.min('tablet', /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_6__/* .css */ .iv)("margin-top:", 1 / FEED_ITEM_DESKTOP_ASPECT_RATIO * 100, "%;" + ( true ? "" : 0),  true ? "" : 0)), ";" + ( true ? "" : 0));
const BadgeContainer = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)("div",  true ? {
  target: "e1e7vpgj5"
} : 0)("position:absolute;top:", (0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.p)(8), ";right:", (0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.p)(8), ";" + ( true ? "" : 0));
const UserContainer = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)("div",  true ? {
  target: "e1e7vpgj4"
} : 0)("display:flex;margin-top:", (0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.p)(8), ";justify-content:space-between;align-items:center;& a{display:flex;gap:", (0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.p)(6), ";align-items:center;width:fit-content;max-width:100%;overflow:hidden;&:hover{opacity:0.5;}}" + ( true ? "" : 0));
const Nickname = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)("div",  true ? {
  target: "e1e7vpgj3"
} : 0)(_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.F.caption1_small, " font-weight:500;color:", ({
  theme
}) => theme.content.base1, ";overflow:hidden;white-space:nowrap;text-overflow:ellipsis;", _bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.M.min('tablet',  true ? {
  name: "16ceglb",
  styles: "font-weight:600"
} : 0), ";" + ( true ? "" : 0));
const StyledAvatar = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_bucketplace_design_system_bds__WEBPACK_IMPORTED_MODULE_8__/* .Avatar */ .qEK,  true ? {
  target: "e1e7vpgj2"
} : 0)( true ? {
  name: "ozd7xs",
  styles: "flex-shrink:0"
} : 0);
const LikeButton = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)("button",  true ? {
  target: "e1e7vpgj1"
} : 0)("display:flex;justify-content:flex-end;align-items:center;gap:", (0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.p)(4), ";margin-left:", (0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.p)(4), ";text-align:center;" + ( true ? "" : 0));
const LikeCountText = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)("span",  true ? {
  target: "e1e7vpgj0"
} : 0)(_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.F.body3, ";color:", ({
  theme
}) => theme.content.base1, ";" + ( true ? "" : 0));

function _EMOTION_STRINGIFIED_CSS_ERROR__$z() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
const ContentFeedItemPlaceholder = /*#__PURE__*/(/* unused pure expression or super */ null && (React__default.memo(({
  className
}) => {
  return jsxs(Container$b, {
    className: className,
    children: [jsx(ImageSkeleton$1, {
      height: "auto",
      style: {
        display: 'block'
      }
    }), jsx(TextSkeleton$1, {}), jsx(TextSkeleton$1, {
      width: "50%"
    }), jsx(TextSkeleton$1, {
      width: "50%"
    })]
  });
})));
const Container$b = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)("div",  true ? {
  target: "e1l3as7g2"
} : 0)( true ? {
  name: "1amee4m",
  styles: "line-height:0"
} : 0);
const ImageSkeleton$1 = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(Skeleton,  true ? {
  target: "e1l3as7g1"
} : 0)("aspect-ratio:", FEED_ITEM_MOBILE_ASPECT_RATIO, ";margin-bottom:", (0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.p)(8), ";border-radius:", (0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.p)(4), ";", _bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.M.min('tablet', /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_6__/* .css */ .iv)("aspect-ratio:", FEED_ITEM_DESKTOP_ASPECT_RATIO, ";margin-bottom:", (0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.p)(10), ";" + ( true ? "" : 0),  true ? "" : 0)), ";" + ( true ? "" : 0));
const TextSkeleton$1 = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(Skeleton,  true ? {
  target: "e1l3as7g0"
} : 0)("margin-bottom:", (0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.p)(6), ";" + ( true ? "" : 0));

function _EMOTION_STRINGIFIED_CSS_ERROR__$y() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
const FeedPlaceholder = ({
  className,
  loadingText
}) => {
  return jsxs(ContentContainer, {
    className: className,
    children: [jsxs(PlaceholderContainer, {
      children: [jsxs(PlaceholderModule, {
        children: [jsx(ImageSkeleton, {}), jsx(TextSkeleton, {}), jsx(TextSkeleton, {})]
      }), jsxs(PlaceholderModule, {
        children: [jsx(ImageSkeleton, {}), jsx(TextSkeleton, {}), jsx(TextSkeleton, {})]
      })]
    }), jsx(PlaceholderText, {
      children: loadingText ?? '맞춤 피드를 불러오고 있어요'
    })]
  });
};
const ContentContainer = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)("div",  true ? {
  target: "e989kf5"
} : 0)( true ? {
  name: "i4idzn",
  styles: "width:100%;display:flex;flex-direction:column;align-items:center;justify-content:center;margin:auto"
} : 0);
const PlaceholderContainer = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)("div",  true ? {
  target: "e989kf4"
} : 0)("width:", (0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.p)(95), ";display:flex;justify-content:space-around;" + ( true ? "" : 0));
const PlaceholderModule = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)("div",  true ? {
  target: "e989kf3"
} : 0)("width:", (0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.p)(44), ";" + ( true ? "" : 0));
const ImageSkeleton = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)("div",  true ? {
  target: "e989kf2"
} : 0)("width:100%;height:", (0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.p)(58), ";margin-bottom:", (0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.p)(4), ";border-radius:", (0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.p)(8), ";background-color:", ({
  theme
}) => theme.content.base4, ";" + ( true ? "" : 0));
const TextSkeleton = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)("div",  true ? {
  target: "e989kf1"
} : 0)("height:", (0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.p)(6), ";margin-bottom:", (0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.p)(3), ";border-radius:", (0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.p)(8), ";background-color:", ({
  theme
}) => theme.content.base4, ";" + ( true ? "" : 0));
const PlaceholderText = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)("div",  true ? {
  target: "e989kf0"
} : 0)("margin-top:", (0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.p)(16), ";color:", ({
  theme
}) => theme.content.base2, ";", _bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.F.subTitle2, ";" + ( true ? "" : 0));

/** 국외향 웹에서 사용하는 푸터 */
const GlobalFooter = ({
  locale,
  country,
  env,
  subdomain,
  serviceType,
  localeData
}) => {
  const isVisibleJPOnlyTab = country === 'JP' && locale === 'ja';
  const aboutLinks = {
    en: 'https://www.bucketplace.com/en/',
    ja: 'https://www.bucketplace.com/ja/',
    id: 'https://www.bucketplace.com/en/',
    ko: 'https://www.bucketplace.com/en/'
  };
  const defaultCompanyLinks = [{
    text: localeData.footerMenuAbout,
    href: aboutLinks[locale]
  }, {
    text: localeData.footerMenuTerms,
    href: getURL(subdomain, env, `${GLOBAL_DOMAINS[env]['home']}/${locale}/terms`, serviceType)
  }, {
    text: localeData.footerMenuPrivacyPolicy,
    href: getURL(subdomain, env, `${GLOBAL_DOMAINS[env]['home']}/${locale}/privacy`, serviceType)
  }, {
    text: localeData.footerMenuContact,
    href: `mailto:${encodeURIComponent('contact@ohouse.com')}`
  }];
  const electronicAnnouncementLink = {
    text: '電子公告',
    href: getURL(subdomain, env, `${GLOBAL_DOMAINS[env]['home']}/${locale}/electronic-announcement`, serviceType)
  };
  const commerceLawLink = {
    text: '特定商取引法に基づく表記',
    href: getURL(subdomain, env, `${GLOBAL_DOMAINS[env]['home']}/${locale}/commerce-law`, serviceType)
  };
  const companyLinks = isVisibleJPOnlyTab ? [...defaultCompanyLinks.slice(0, 3), electronicAnnouncementLink, commerceLawLink, ...defaultCompanyLinks.slice(3)] : defaultCompanyLinks;
  const socialLinkData = {
    en: [{
      type: 'Instagram',
      href: 'https://www.instagram.com/ohousetoday/'
    }, {
      type: 'TikTok',
      href: 'https://www.tiktok.com/@ohousetoday'
    }],
    ja: [{
      type: 'Instagram',
      href: 'https://www.instagram.com/ohousejp/'
    }, {
      type: 'Pinterest',
      href: 'https://www.pinterest.jp/ohouse_japan/'
    }],
    id: [{
      type: 'Instagram',
      href: 'https://www.instagram.com/ohouseidn/'
    }, {
      type: 'Pinterest',
      href: 'https://www.pinterest.com/ohouseidn/'
    }, {
      type: 'TikTok',
      href: 'https://www.tiktok.com/@ohouseidn'
    }]
  };
  return jsx(SimpleFooter, {
    companyLinks: companyLinks,
    socialLinks: socialLinkData[locale]
  });
};

const GlobalBanner = ({
  linkComponent,
  getDeepLink,
  location,
  banner = {
    pcContentList: [],
    mobileImageSrc: ''
  },
  user,
  onClose,
  localeData
}) => {
  const handleLog = useCallback((type, data) => {
    switch (type) {
      case 'banner.top.pc.click':
        L({
          category: 'click',
          section: '네비 배너',
          index: data.index
        });
        break;
      case 'banner.top.mobile.click':
        L({
          category: 'click',
          section: '네비 배너'
        });
        break;
      case 'banner.top.pc.close':
      case 'banner.top.mobile.close':
        L({
          category: 'click',
          section: '네비 배너 닫기'
        });
        break;
      case 'banner.bottom.mobile.click':
        L({
          category: 'click',
          section: '앱 다운로드'
        });
        break;
      case 'banner.bottom.mobile.close':
        L({
          category: 'click',
          section: '앱 다운로드 닫기'
        });
        break;
    }
  }, []);
  const handleAppOpen = useCallback(type => {
    window.location.href = getDeepLink({
      sub_id_1: type === 'banner.top.mobile.click' ? 'web_top_bnr' : 'web_bottom_bnr'
    });
  }, [getDeepLink]);
  return jsx(NavigationTopBanner, {
    location: location,
    pcContentList: banner.pcContentList,
    mobileImageSrc: banner.mobileImageSrc,
    linkComponent: linkComponent,
    onLog: handleLog,
    onAppOpen: handleAppOpen,
    isUserLoggedIn: !!user,
    onClosePCTopBanner: onClose?.pcTopBanner,
    onCloseMobileTopBanner: onClose?.mobileTopBanner,
    onCloseAppDownloadPopup: onClose?.appDownloadPopup,
    localeData: localeData
  });
};

function _EMOTION_STRINGIFIED_CSS_ERROR__$x() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
const LOCALE_ITEMS = [{
  locale: 'en',
  text: 'English'
}, {
  locale: 'ja',
  text: '日本語'
}, {
  locale: 'id',
  text: 'Bahasa Indonesia'
}];
const DROPDOWN_LOCALE_ITEMS = LOCALE_ITEMS.map((item, index) => {
  return {
    id: index,
    value: item.text
  };
});
const ChangeLanguageButton = () => {
  const isMobile = (0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_12__.m)().breakpoint === 'mobile';
  const [currentLocale, setCurrentLocale] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(null);
  const dropdownRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
  const [isDropdownOpen, setIsDropdownOpen] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false);
  const [selectedItemIndex, setSelectedItemIndex] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(-1);
  const redirectToNewUrlWithLocale = locale => {
    location.href = getUrlWithExchangeLocale(location.href, locale);
  };
  const getLocaleByDropdownItemIndex = index => {
    return LOCALE_ITEMS[index]?.locale;
  };
  const handleClickLocaleButton = () => {
    setIsDropdownOpen(!isDropdownOpen);
  };
  const handleCloseDropdown = () => {
    setIsDropdownOpen(false);
  };
  const handleClickDropdownItem = index => {
    setIsDropdownOpen(false);
    if (selectedItemIndex === index) {
      return;
    }
    const locale = getLocaleByDropdownItemIndex(index);
    if (locale) {
      redirectToNewUrlWithLocale(locale);
    }
  };
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    if (currentLocale) {
      setSelectedItemIndex(LOCALE_ITEMS.findIndex(item => item.locale === currentLocale));
    }
  }, [currentLocale]);
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    if (location) {
      setCurrentLocale(getLocaleFromUrl(location.href));
    }
  }, []);
  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsxs */ .BX)(LocaleContainer, {
    children: [(0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(StyledTextButtonWithIcon, {
      size: isMobile ? 32 : 30,
      icon: isMobile ? 'chevron_thick_down' : 'chevron_down',
      iconSize: isMobile ? 12 : 18,
      variant: "base1",
      text: (isMobile ? LOCALE_ITEMS[selectedItemIndex]?.locale.toUpperCase() : LOCALE_ITEMS[selectedItemIndex]?.text) ?? '',
      isTrailing: true,
      onClick: handleClickLocaleButton
    }), isDropdownOpen && (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(DropdownWrapper, {
      "data-testid": "language-dropdown",
      children: (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(_bucketplace_design_system_bds__WEBPACK_IMPORTED_MODULE_8__/* .Dropdown */ .Ltx, {
        title: "",
        dropdownRef: dropdownRef,
        items: DROPDOWN_LOCALE_ITEMS,
        onCloseDropdown: handleCloseDropdown,
        onClose: () => setIsDropdownOpen(false),
        onClick: handleClickDropdownItem,
        selectedItemId: selectedItemIndex
      })
    })]
  });
};
const LocaleContainer = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)("div",  true ? {
  target: "etdtywj2"
} : 0)(_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.F.caption1, " display:flex;position:relative;flex-wrap:wrap;align-items:center;color:", ({
  theme
}) => theme.content.base1, ";", _bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.M.min('tablet',  true ? {
  name: "gleosg",
  styles: "gap:20px"
} : 0), ";" + ( true ? "" : 0));
const DropdownWrapper = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)("div",  true ? {
  target: "etdtywj1"
} : 0)("position:absolute;top:calc(100% + 16px);left:0px;min-width:296px;padding:8px;background-color:", ({
  theme
}) => theme.background.base, ";border-radius:8px;box-shadow:0px 2px 10px 0px ", ({
  theme
}) => theme.shadow.darken, ";&>div>div{border:0px;}", _bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.M.max('mobile',  true ? {
  name: "52b1oc",
  styles: "padding:0px"
} : 0), ";" + ( true ? "" : 0));
const StyledTextButtonWithIcon = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_bucketplace_design_system_bds__WEBPACK_IMPORTED_MODULE_8__/* .TextButtonWithIcon */ .fj3,  true ? {
  target: "etdtywj0"
} : 0)("&>span:first-of-type{", _bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.M.max('mobile',  true ? {
  name: "14hpr0l",
  styles: "display:inline-block;max-width:42px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap"
} : 0), ";}" + ( true ? "" : 0));

/**
 * Simple ponyfill for Object.fromEntries
 */

var fromEntries = function fromEntries(entries) {
  return entries.reduce(function (acc, _ref) {
    var key = _ref[0],
      value = _ref[1];
    acc[key] = value;
    return acc;
  }, {});
};
/**
 * Small wrapper around `useLayoutEffect` to get rid of the warning on SSR envs
 */

var useIsomorphicLayoutEffect = typeof window !== 'undefined' && window.document && window.document.createElement ? react__WEBPACK_IMPORTED_MODULE_0__.useLayoutEffect : react__WEBPACK_IMPORTED_MODULE_0__.useEffect;

var top = 'top';
var bottom = 'bottom';
var right = 'right';
var left = 'left';
var auto = 'auto';
var basePlacements = [top, bottom, right, left];
var start = 'start';
var end = 'end';
var clippingParents = 'clippingParents';
var viewport = 'viewport';
var popper = 'popper';
var reference = 'reference';
var variationPlacements = /*#__PURE__*/basePlacements.reduce(function (acc, placement) {
  return acc.concat([placement + "-" + start, placement + "-" + end]);
}, []);
var placements = /*#__PURE__*/[].concat(basePlacements, [auto]).reduce(function (acc, placement) {
  return acc.concat([placement, placement + "-" + start, placement + "-" + end]);
}, []); // modifiers that need to read the DOM

var beforeRead = 'beforeRead';
var read = 'read';
var afterRead = 'afterRead'; // pure-logic modifiers

var beforeMain = 'beforeMain';
var main = 'main';
var afterMain = 'afterMain'; // modifier with the purpose to write to the DOM (or write into a framework state)

var beforeWrite = 'beforeWrite';
var write = 'write';
var afterWrite = 'afterWrite';
var modifierPhases = [beforeRead, read, afterRead, beforeMain, main, afterMain, beforeWrite, write, afterWrite];

function getNodeName(element) {
  return element ? (element.nodeName || '').toLowerCase() : null;
}

function getWindow(node) {
  if (node == null) {
    return window;
  }
  if (node.toString() !== '[object Window]') {
    var ownerDocument = node.ownerDocument;
    return ownerDocument ? ownerDocument.defaultView || window : window;
  }
  return node;
}

function isElement(node) {
  var OwnElement = getWindow(node).Element;
  return node instanceof OwnElement || node instanceof Element;
}
function isHTMLElement(node) {
  var OwnElement = getWindow(node).HTMLElement;
  return node instanceof OwnElement || node instanceof HTMLElement;
}
function isShadowRoot(node) {
  // IE 11 has no ShadowRoot
  if (typeof ShadowRoot === 'undefined') {
    return false;
  }
  var OwnElement = getWindow(node).ShadowRoot;
  return node instanceof OwnElement || node instanceof ShadowRoot;
}

// and applies them to the HTMLElements such as popper and arrow

function applyStyles(_ref) {
  var state = _ref.state;
  Object.keys(state.elements).forEach(function (name) {
    var style = state.styles[name] || {};
    var attributes = state.attributes[name] || {};
    var element = state.elements[name]; // arrow is optional + virtual elements

    if (!isHTMLElement(element) || !getNodeName(element)) {
      return;
    } // Flow doesn't support to extend this property, but it's the most
    // effective way to apply styles to an HTMLElement
    // $FlowFixMe[cannot-write]

    Object.assign(element.style, style);
    Object.keys(attributes).forEach(function (name) {
      var value = attributes[name];
      if (value === false) {
        element.removeAttribute(name);
      } else {
        element.setAttribute(name, value === true ? '' : value);
      }
    });
  });
}
function effect$2(_ref2) {
  var state = _ref2.state;
  var initialStyles = {
    popper: {
      position: state.options.strategy,
      left: '0',
      top: '0',
      margin: '0'
    },
    arrow: {
      position: 'absolute'
    },
    reference: {}
  };
  Object.assign(state.elements.popper.style, initialStyles.popper);
  state.styles = initialStyles;
  if (state.elements.arrow) {
    Object.assign(state.elements.arrow.style, initialStyles.arrow);
  }
  return function () {
    Object.keys(state.elements).forEach(function (name) {
      var element = state.elements[name];
      var attributes = state.attributes[name] || {};
      var styleProperties = Object.keys(state.styles.hasOwnProperty(name) ? state.styles[name] : initialStyles[name]); // Set all values to an empty string to unset them

      var style = styleProperties.reduce(function (style, property) {
        style[property] = '';
        return style;
      }, {}); // arrow is optional + virtual elements

      if (!isHTMLElement(element) || !getNodeName(element)) {
        return;
      }
      Object.assign(element.style, style);
      Object.keys(attributes).forEach(function (attribute) {
        element.removeAttribute(attribute);
      });
    });
  };
} // eslint-disable-next-line import/no-unused-modules

var applyStyles$1 = {
  name: 'applyStyles',
  enabled: true,
  phase: 'write',
  fn: applyStyles,
  effect: effect$2,
  requires: ['computeStyles']
};

function getBasePlacement(placement) {
  return placement.split('-')[0];
}

var max = Math.max;
var min = Math.min;
var round$1 = Math.round;

function getUAString() {
  var uaData = navigator.userAgentData;
  if (uaData != null && uaData.brands && Array.isArray(uaData.brands)) {
    return uaData.brands.map(function (item) {
      return item.brand + "/" + item.version;
    }).join(' ');
  }
  return navigator.userAgent;
}

function isLayoutViewport() {
  return !/^((?!chrome|android).)*safari/i.test(getUAString());
}

function getBoundingClientRect(element, includeScale, isFixedStrategy) {
  if (includeScale === void 0) {
    includeScale = false;
  }
  if (isFixedStrategy === void 0) {
    isFixedStrategy = false;
  }
  var clientRect = element.getBoundingClientRect();
  var scaleX = 1;
  var scaleY = 1;
  if (includeScale && isHTMLElement(element)) {
    scaleX = element.offsetWidth > 0 ? round$1(clientRect.width) / element.offsetWidth || 1 : 1;
    scaleY = element.offsetHeight > 0 ? round$1(clientRect.height) / element.offsetHeight || 1 : 1;
  }
  var _ref = isElement(element) ? getWindow(element) : window,
    visualViewport = _ref.visualViewport;
  var addVisualOffsets = !isLayoutViewport() && isFixedStrategy;
  var x = (clientRect.left + (addVisualOffsets && visualViewport ? visualViewport.offsetLeft : 0)) / scaleX;
  var y = (clientRect.top + (addVisualOffsets && visualViewport ? visualViewport.offsetTop : 0)) / scaleY;
  var width = clientRect.width / scaleX;
  var height = clientRect.height / scaleY;
  return {
    width: width,
    height: height,
    top: y,
    right: x + width,
    bottom: y + height,
    left: x,
    x: x,
    y: y
  };
}

// means it doesn't take into account transforms.

function getLayoutRect(element) {
  var clientRect = getBoundingClientRect(element); // Use the clientRect sizes if it's not been transformed.
  // Fixes https://github.com/popperjs/popper-core/issues/1223

  var width = element.offsetWidth;
  var height = element.offsetHeight;
  if (Math.abs(clientRect.width - width) <= 1) {
    width = clientRect.width;
  }
  if (Math.abs(clientRect.height - height) <= 1) {
    height = clientRect.height;
  }
  return {
    x: element.offsetLeft,
    y: element.offsetTop,
    width: width,
    height: height
  };
}

function contains(parent, child) {
  var rootNode = child.getRootNode && child.getRootNode(); // First, attempt with faster native method

  if (parent.contains(child)) {
    return true;
  } // then fallback to custom implementation with Shadow DOM support
  else if (rootNode && isShadowRoot(rootNode)) {
    var next = child;
    do {
      if (next && parent.isSameNode(next)) {
        return true;
      } // $FlowFixMe[prop-missing]: need a better way to handle this...

      next = next.parentNode || next.host;
    } while (next);
  } // Give up, the result is false

  return false;
}

function getComputedStyle(element) {
  return getWindow(element).getComputedStyle(element);
}

function isTableElement(element) {
  return ['table', 'td', 'th'].indexOf(getNodeName(element)) >= 0;
}

function getDocumentElement(element) {
  // $FlowFixMe[incompatible-return]: assume body is always available
  return ((isElement(element) ? element.ownerDocument :
  // $FlowFixMe[prop-missing]
  element.document) || window.document).documentElement;
}

function getParentNode$1(element) {
  if (getNodeName(element) === 'html') {
    return element;
  }
  return (
    // this is a quicker (but less type safe) way to save quite some bytes from the bundle
    // $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    element.assignedSlot ||
    // step into the shadow DOM of the parent of a slotted node
    element.parentNode || (
    // DOM Element detected
    isShadowRoot(element) ? element.host : null) ||
    // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    getDocumentElement(element) // fallback
  );
}

function getTrueOffsetParent(element) {
  if (!isHTMLElement(element) ||
  // https://github.com/popperjs/popper-core/issues/837
  getComputedStyle(element).position === 'fixed') {
    return null;
  }
  return element.offsetParent;
} // `.offsetParent` reports `null` for fixed elements, while absolute elements
// return the containing block

function getContainingBlock(element) {
  var isFirefox = /firefox/i.test(getUAString());
  var isIE = /Trident/i.test(getUAString());
  if (isIE && isHTMLElement(element)) {
    // In IE 9, 10 and 11 fixed elements containing block is always established by the viewport
    var elementCss = getComputedStyle(element);
    if (elementCss.position === 'fixed') {
      return null;
    }
  }
  var currentNode = getParentNode$1(element);
  if (isShadowRoot(currentNode)) {
    currentNode = currentNode.host;
  }
  while (isHTMLElement(currentNode) && ['html', 'body'].indexOf(getNodeName(currentNode)) < 0) {
    var css = getComputedStyle(currentNode); // This is non-exhaustive but covers the most common CSS properties that
    // create a containing block.
    // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block

    if (css.transform !== 'none' || css.perspective !== 'none' || css.contain === 'paint' || ['transform', 'perspective'].indexOf(css.willChange) !== -1 || isFirefox && css.willChange === 'filter' || isFirefox && css.filter && css.filter !== 'none') {
      return currentNode;
    } else {
      currentNode = currentNode.parentNode;
    }
  }
  return null;
} // Gets the closest ancestor positioned element. Handles some edge cases,
// such as table ancestors and cross browser bugs.

function getOffsetParent(element) {
  var window = getWindow(element);
  var offsetParent = getTrueOffsetParent(element);
  while (offsetParent && isTableElement(offsetParent) && getComputedStyle(offsetParent).position === 'static') {
    offsetParent = getTrueOffsetParent(offsetParent);
  }
  if (offsetParent && (getNodeName(offsetParent) === 'html' || getNodeName(offsetParent) === 'body' && getComputedStyle(offsetParent).position === 'static')) {
    return window;
  }
  return offsetParent || getContainingBlock(element) || window;
}

function getMainAxisFromPlacement(placement) {
  return ['top', 'bottom'].indexOf(placement) >= 0 ? 'x' : 'y';
}

function within(min$1, value, max$1) {
  return max(min$1, min(value, max$1));
}
function withinMaxClamp(min, value, max) {
  var v = within(min, value, max);
  return v > max ? max : v;
}

function getFreshSideObject() {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  };
}

function mergePaddingObject(paddingObject) {
  return Object.assign({}, getFreshSideObject(), paddingObject);
}

function expandToHashMap(value, keys) {
  return keys.reduce(function (hashMap, key) {
    hashMap[key] = value;
    return hashMap;
  }, {});
}

var toPaddingObject = function toPaddingObject(padding, state) {
  padding = typeof padding === 'function' ? padding(Object.assign({}, state.rects, {
    placement: state.placement
  })) : padding;
  return mergePaddingObject(typeof padding !== 'number' ? padding : expandToHashMap(padding, basePlacements));
};
function arrow(_ref) {
  var _state$modifiersData$;
  var state = _ref.state,
    name = _ref.name,
    options = _ref.options;
  var arrowElement = state.elements.arrow;
  var popperOffsets = state.modifiersData.popperOffsets;
  var basePlacement = getBasePlacement(state.placement);
  var axis = getMainAxisFromPlacement(basePlacement);
  var isVertical = [left, right].indexOf(basePlacement) >= 0;
  var len = isVertical ? 'height' : 'width';
  if (!arrowElement || !popperOffsets) {
    return;
  }
  var paddingObject = toPaddingObject(options.padding, state);
  var arrowRect = getLayoutRect(arrowElement);
  var minProp = axis === 'y' ? top : left;
  var maxProp = axis === 'y' ? bottom : right;
  var endDiff = state.rects.reference[len] + state.rects.reference[axis] - popperOffsets[axis] - state.rects.popper[len];
  var startDiff = popperOffsets[axis] - state.rects.reference[axis];
  var arrowOffsetParent = getOffsetParent(arrowElement);
  var clientSize = arrowOffsetParent ? axis === 'y' ? arrowOffsetParent.clientHeight || 0 : arrowOffsetParent.clientWidth || 0 : 0;
  var centerToReference = endDiff / 2 - startDiff / 2; // Make sure the arrow doesn't overflow the popper if the center point is
  // outside of the popper bounds

  var min = paddingObject[minProp];
  var max = clientSize - arrowRect[len] - paddingObject[maxProp];
  var center = clientSize / 2 - arrowRect[len] / 2 + centerToReference;
  var offset = within(min, center, max); // Prevents breaking syntax highlighting...

  var axisProp = axis;
  state.modifiersData[name] = (_state$modifiersData$ = {}, _state$modifiersData$[axisProp] = offset, _state$modifiersData$.centerOffset = offset - center, _state$modifiersData$);
}
function effect$1(_ref2) {
  var state = _ref2.state,
    options = _ref2.options;
  var _options$element = options.element,
    arrowElement = _options$element === void 0 ? '[data-popper-arrow]' : _options$element;
  if (arrowElement == null) {
    return;
  } // CSS selector

  if (typeof arrowElement === 'string') {
    arrowElement = state.elements.popper.querySelector(arrowElement);
    if (!arrowElement) {
      return;
    }
  }
  if (!contains(state.elements.popper, arrowElement)) {
    return;
  }
  state.elements.arrow = arrowElement;
} // eslint-disable-next-line import/no-unused-modules

var arrow$1 = {
  name: 'arrow',
  enabled: true,
  phase: 'main',
  fn: arrow,
  effect: effect$1,
  requires: ['popperOffsets'],
  requiresIfExists: ['preventOverflow']
};

function getVariation(placement) {
  return placement.split('-')[1];
}

var unsetSides = {
  top: 'auto',
  right: 'auto',
  bottom: 'auto',
  left: 'auto'
}; // Round the offsets to the nearest suitable subpixel based on the DPR.
// Zooming can change the DPR, but it seems to report a value that will
// cleanly divide the values into the appropriate subpixels.

function roundOffsetsByDPR(_ref, win) {
  var x = _ref.x,
    y = _ref.y;
  var dpr = win.devicePixelRatio || 1;
  return {
    x: round$1(x * dpr) / dpr || 0,
    y: round$1(y * dpr) / dpr || 0
  };
}
function mapToStyles(_ref2) {
  var _Object$assign2;
  var popper = _ref2.popper,
    popperRect = _ref2.popperRect,
    placement = _ref2.placement,
    variation = _ref2.variation,
    offsets = _ref2.offsets,
    position = _ref2.position,
    gpuAcceleration = _ref2.gpuAcceleration,
    adaptive = _ref2.adaptive,
    roundOffsets = _ref2.roundOffsets,
    isFixed = _ref2.isFixed;
  var _offsets$x = offsets.x,
    x = _offsets$x === void 0 ? 0 : _offsets$x,
    _offsets$y = offsets.y,
    y = _offsets$y === void 0 ? 0 : _offsets$y;
  var _ref3 = typeof roundOffsets === 'function' ? roundOffsets({
    x: x,
    y: y
  }) : {
    x: x,
    y: y
  };
  x = _ref3.x;
  y = _ref3.y;
  var hasX = offsets.hasOwnProperty('x');
  var hasY = offsets.hasOwnProperty('y');
  var sideX = left;
  var sideY = top;
  var win = window;
  if (adaptive) {
    var offsetParent = getOffsetParent(popper);
    var heightProp = 'clientHeight';
    var widthProp = 'clientWidth';
    if (offsetParent === getWindow(popper)) {
      offsetParent = getDocumentElement(popper);
      if (getComputedStyle(offsetParent).position !== 'static' && position === 'absolute') {
        heightProp = 'scrollHeight';
        widthProp = 'scrollWidth';
      }
    } // $FlowFixMe[incompatible-cast]: force type refinement, we compare offsetParent with window above, but Flow doesn't detect it

    offsetParent = offsetParent;
    if (placement === top || (placement === left || placement === right) && variation === end) {
      sideY = bottom;
      var offsetY = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.height :
      // $FlowFixMe[prop-missing]
      offsetParent[heightProp];
      y -= offsetY - popperRect.height;
      y *= gpuAcceleration ? 1 : -1;
    }
    if (placement === left || (placement === top || placement === bottom) && variation === end) {
      sideX = right;
      var offsetX = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.width :
      // $FlowFixMe[prop-missing]
      offsetParent[widthProp];
      x -= offsetX - popperRect.width;
      x *= gpuAcceleration ? 1 : -1;
    }
  }
  var commonStyles = Object.assign({
    position: position
  }, adaptive && unsetSides);
  var _ref4 = roundOffsets === true ? roundOffsetsByDPR({
    x: x,
    y: y
  }, getWindow(popper)) : {
    x: x,
    y: y
  };
  x = _ref4.x;
  y = _ref4.y;
  if (gpuAcceleration) {
    var _Object$assign;
    return Object.assign({}, commonStyles, (_Object$assign = {}, _Object$assign[sideY] = hasY ? '0' : '', _Object$assign[sideX] = hasX ? '0' : '', _Object$assign.transform = (win.devicePixelRatio || 1) <= 1 ? "translate(" + x + "px, " + y + "px)" : "translate3d(" + x + "px, " + y + "px, 0)", _Object$assign));
  }
  return Object.assign({}, commonStyles, (_Object$assign2 = {}, _Object$assign2[sideY] = hasY ? y + "px" : '', _Object$assign2[sideX] = hasX ? x + "px" : '', _Object$assign2.transform = '', _Object$assign2));
}
function computeStyles(_ref5) {
  var state = _ref5.state,
    options = _ref5.options;
  var _options$gpuAccelerat = options.gpuAcceleration,
    gpuAcceleration = _options$gpuAccelerat === void 0 ? true : _options$gpuAccelerat,
    _options$adaptive = options.adaptive,
    adaptive = _options$adaptive === void 0 ? true : _options$adaptive,
    _options$roundOffsets = options.roundOffsets,
    roundOffsets = _options$roundOffsets === void 0 ? true : _options$roundOffsets;
  var commonStyles = {
    placement: getBasePlacement(state.placement),
    variation: getVariation(state.placement),
    popper: state.elements.popper,
    popperRect: state.rects.popper,
    gpuAcceleration: gpuAcceleration,
    isFixed: state.options.strategy === 'fixed'
  };
  if (state.modifiersData.popperOffsets != null) {
    state.styles.popper = Object.assign({}, state.styles.popper, mapToStyles(Object.assign({}, commonStyles, {
      offsets: state.modifiersData.popperOffsets,
      position: state.options.strategy,
      adaptive: adaptive,
      roundOffsets: roundOffsets
    })));
  }
  if (state.modifiersData.arrow != null) {
    state.styles.arrow = Object.assign({}, state.styles.arrow, mapToStyles(Object.assign({}, commonStyles, {
      offsets: state.modifiersData.arrow,
      position: 'absolute',
      adaptive: false,
      roundOffsets: roundOffsets
    })));
  }
  state.attributes.popper = Object.assign({}, state.attributes.popper, {
    'data-popper-placement': state.placement
  });
} // eslint-disable-next-line import/no-unused-modules

var computeStyles$1 = {
  name: 'computeStyles',
  enabled: true,
  phase: 'beforeWrite',
  fn: computeStyles,
  data: {}
};

var passive = {
  passive: true
};
function effect(_ref) {
  var state = _ref.state,
    instance = _ref.instance,
    options = _ref.options;
  var _options$scroll = options.scroll,
    scroll = _options$scroll === void 0 ? true : _options$scroll,
    _options$resize = options.resize,
    resize = _options$resize === void 0 ? true : _options$resize;
  var window = getWindow(state.elements.popper);
  var scrollParents = [].concat(state.scrollParents.reference, state.scrollParents.popper);
  if (scroll) {
    scrollParents.forEach(function (scrollParent) {
      scrollParent.addEventListener('scroll', instance.update, passive);
    });
  }
  if (resize) {
    window.addEventListener('resize', instance.update, passive);
  }
  return function () {
    if (scroll) {
      scrollParents.forEach(function (scrollParent) {
        scrollParent.removeEventListener('scroll', instance.update, passive);
      });
    }
    if (resize) {
      window.removeEventListener('resize', instance.update, passive);
    }
  };
} // eslint-disable-next-line import/no-unused-modules

var eventListeners = {
  name: 'eventListeners',
  enabled: true,
  phase: 'write',
  fn: function fn() {},
  effect: effect,
  data: {}
};

var hash$2 = {
  left: 'right',
  right: 'left',
  bottom: 'top',
  top: 'bottom'
};
function getOppositePlacement(placement) {
  return placement.replace(/left|right|bottom|top/g, function (matched) {
    return hash$2[matched];
  });
}

var hash$1 = {
  start: 'end',
  end: 'start'
};
function getOppositeVariationPlacement(placement) {
  return placement.replace(/start|end/g, function (matched) {
    return hash$1[matched];
  });
}

function getWindowScroll(node) {
  var win = getWindow(node);
  var scrollLeft = win.pageXOffset;
  var scrollTop = win.pageYOffset;
  return {
    scrollLeft: scrollLeft,
    scrollTop: scrollTop
  };
}

function getWindowScrollBarX(element) {
  // If <html> has a CSS width greater than the viewport, then this will be
  // incorrect for RTL.
  // Popper 1 is broken in this case and never had a bug report so let's assume
  // it's not an issue. I don't think anyone ever specifies width on <html>
  // anyway.
  // Browsers where the left scrollbar doesn't cause an issue report `0` for
  // this (e.g. Edge 2019, IE11, Safari)
  return getBoundingClientRect(getDocumentElement(element)).left + getWindowScroll(element).scrollLeft;
}

function getViewportRect(element, strategy) {
  var win = getWindow(element);
  var html = getDocumentElement(element);
  var visualViewport = win.visualViewport;
  var width = html.clientWidth;
  var height = html.clientHeight;
  var x = 0;
  var y = 0;
  if (visualViewport) {
    width = visualViewport.width;
    height = visualViewport.height;
    var layoutViewport = isLayoutViewport();
    if (layoutViewport || !layoutViewport && strategy === 'fixed') {
      x = visualViewport.offsetLeft;
      y = visualViewport.offsetTop;
    }
  }
  return {
    width: width,
    height: height,
    x: x + getWindowScrollBarX(element),
    y: y
  };
}

// of the `<html>` and `<body>` rect bounds if horizontally scrollable

function getDocumentRect(element) {
  var _element$ownerDocumen;
  var html = getDocumentElement(element);
  var winScroll = getWindowScroll(element);
  var body = (_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body;
  var width = max(html.scrollWidth, html.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0);
  var height = max(html.scrollHeight, html.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0);
  var x = -winScroll.scrollLeft + getWindowScrollBarX(element);
  var y = -winScroll.scrollTop;
  if (getComputedStyle(body || html).direction === 'rtl') {
    x += max(html.clientWidth, body ? body.clientWidth : 0) - width;
  }
  return {
    width: width,
    height: height,
    x: x,
    y: y
  };
}

function isScrollParent(element) {
  // Firefox wants us to check `-x` and `-y` variations as well
  var _getComputedStyle = getComputedStyle(element),
    overflow = _getComputedStyle.overflow,
    overflowX = _getComputedStyle.overflowX,
    overflowY = _getComputedStyle.overflowY;
  return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
}

function getScrollParent(node) {
  if (['html', 'body', '#document'].indexOf(getNodeName(node)) >= 0) {
    // $FlowFixMe[incompatible-return]: assume body is always available
    return node.ownerDocument.body;
  }
  if (isHTMLElement(node) && isScrollParent(node)) {
    return node;
  }
  return getScrollParent(getParentNode$1(node));
}

/*
given a DOM element, return the list of all scroll parents, up the list of ancesors
until we get to the top window object. This list is what we attach scroll listeners
to, because if any of these parent elements scroll, we'll need to re-calculate the
reference element's position.
*/

function listScrollParents(element, list) {
  var _element$ownerDocumen;
  if (list === void 0) {
    list = [];
  }
  var scrollParent = getScrollParent(element);
  var isBody = scrollParent === ((_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body);
  var win = getWindow(scrollParent);
  var target = isBody ? [win].concat(win.visualViewport || [], isScrollParent(scrollParent) ? scrollParent : []) : scrollParent;
  var updatedList = list.concat(target);
  return isBody ? updatedList :
  // $FlowFixMe[incompatible-call]: isBody tells us target will be an HTMLElement here
  updatedList.concat(listScrollParents(getParentNode$1(target)));
}

function rectToClientRect(rect) {
  return Object.assign({}, rect, {
    left: rect.x,
    top: rect.y,
    right: rect.x + rect.width,
    bottom: rect.y + rect.height
  });
}

function getInnerBoundingClientRect(element, strategy) {
  var rect = getBoundingClientRect(element, false, strategy === 'fixed');
  rect.top = rect.top + element.clientTop;
  rect.left = rect.left + element.clientLeft;
  rect.bottom = rect.top + element.clientHeight;
  rect.right = rect.left + element.clientWidth;
  rect.width = element.clientWidth;
  rect.height = element.clientHeight;
  rect.x = rect.left;
  rect.y = rect.top;
  return rect;
}
function getClientRectFromMixedType(element, clippingParent, strategy) {
  return clippingParent === viewport ? rectToClientRect(getViewportRect(element, strategy)) : isElement(clippingParent) ? getInnerBoundingClientRect(clippingParent, strategy) : rectToClientRect(getDocumentRect(getDocumentElement(element)));
} // A "clipping parent" is an overflowable container with the characteristic of
// clipping (or hiding) overflowing elements with a position different from
// `initial`

function getClippingParents(element) {
  var clippingParents = listScrollParents(getParentNode$1(element));
  var canEscapeClipping = ['absolute', 'fixed'].indexOf(getComputedStyle(element).position) >= 0;
  var clipperElement = canEscapeClipping && isHTMLElement(element) ? getOffsetParent(element) : element;
  if (!isElement(clipperElement)) {
    return [];
  } // $FlowFixMe[incompatible-return]: https://github.com/facebook/flow/issues/1414

  return clippingParents.filter(function (clippingParent) {
    return isElement(clippingParent) && contains(clippingParent, clipperElement) && getNodeName(clippingParent) !== 'body';
  });
} // Gets the maximum area that the element is visible in due to any number of
// clipping parents

function getClippingRect(element, boundary, rootBoundary, strategy) {
  var mainClippingParents = boundary === 'clippingParents' ? getClippingParents(element) : [].concat(boundary);
  var clippingParents = [].concat(mainClippingParents, [rootBoundary]);
  var firstClippingParent = clippingParents[0];
  var clippingRect = clippingParents.reduce(function (accRect, clippingParent) {
    var rect = getClientRectFromMixedType(element, clippingParent, strategy);
    accRect.top = max(rect.top, accRect.top);
    accRect.right = min(rect.right, accRect.right);
    accRect.bottom = min(rect.bottom, accRect.bottom);
    accRect.left = max(rect.left, accRect.left);
    return accRect;
  }, getClientRectFromMixedType(element, firstClippingParent, strategy));
  clippingRect.width = clippingRect.right - clippingRect.left;
  clippingRect.height = clippingRect.bottom - clippingRect.top;
  clippingRect.x = clippingRect.left;
  clippingRect.y = clippingRect.top;
  return clippingRect;
}

function computeOffsets(_ref) {
  var reference = _ref.reference,
    element = _ref.element,
    placement = _ref.placement;
  var basePlacement = placement ? getBasePlacement(placement) : null;
  var variation = placement ? getVariation(placement) : null;
  var commonX = reference.x + reference.width / 2 - element.width / 2;
  var commonY = reference.y + reference.height / 2 - element.height / 2;
  var offsets;
  switch (basePlacement) {
    case top:
      offsets = {
        x: commonX,
        y: reference.y - element.height
      };
      break;
    case bottom:
      offsets = {
        x: commonX,
        y: reference.y + reference.height
      };
      break;
    case right:
      offsets = {
        x: reference.x + reference.width,
        y: commonY
      };
      break;
    case left:
      offsets = {
        x: reference.x - element.width,
        y: commonY
      };
      break;
    default:
      offsets = {
        x: reference.x,
        y: reference.y
      };
  }
  var mainAxis = basePlacement ? getMainAxisFromPlacement(basePlacement) : null;
  if (mainAxis != null) {
    var len = mainAxis === 'y' ? 'height' : 'width';
    switch (variation) {
      case start:
        offsets[mainAxis] = offsets[mainAxis] - (reference[len] / 2 - element[len] / 2);
        break;
      case end:
        offsets[mainAxis] = offsets[mainAxis] + (reference[len] / 2 - element[len] / 2);
        break;
    }
  }
  return offsets;
}

function detectOverflow(state, options) {
  if (options === void 0) {
    options = {};
  }
  var _options = options,
    _options$placement = _options.placement,
    placement = _options$placement === void 0 ? state.placement : _options$placement,
    _options$strategy = _options.strategy,
    strategy = _options$strategy === void 0 ? state.strategy : _options$strategy,
    _options$boundary = _options.boundary,
    boundary = _options$boundary === void 0 ? clippingParents : _options$boundary,
    _options$rootBoundary = _options.rootBoundary,
    rootBoundary = _options$rootBoundary === void 0 ? viewport : _options$rootBoundary,
    _options$elementConte = _options.elementContext,
    elementContext = _options$elementConte === void 0 ? popper : _options$elementConte,
    _options$altBoundary = _options.altBoundary,
    altBoundary = _options$altBoundary === void 0 ? false : _options$altBoundary,
    _options$padding = _options.padding,
    padding = _options$padding === void 0 ? 0 : _options$padding;
  var paddingObject = mergePaddingObject(typeof padding !== 'number' ? padding : expandToHashMap(padding, basePlacements));
  var altContext = elementContext === popper ? reference : popper;
  var popperRect = state.rects.popper;
  var element = state.elements[altBoundary ? altContext : elementContext];
  var clippingClientRect = getClippingRect(isElement(element) ? element : element.contextElement || getDocumentElement(state.elements.popper), boundary, rootBoundary, strategy);
  var referenceClientRect = getBoundingClientRect(state.elements.reference);
  var popperOffsets = computeOffsets({
    reference: referenceClientRect,
    element: popperRect,
    strategy: 'absolute',
    placement: placement
  });
  var popperClientRect = rectToClientRect(Object.assign({}, popperRect, popperOffsets));
  var elementClientRect = elementContext === popper ? popperClientRect : referenceClientRect; // positive = overflowing the clipping rect
  // 0 or negative = within the clipping rect

  var overflowOffsets = {
    top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
    bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
    left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
    right: elementClientRect.right - clippingClientRect.right + paddingObject.right
  };
  var offsetData = state.modifiersData.offset; // Offsets can be applied only to the popper element

  if (elementContext === popper && offsetData) {
    var offset = offsetData[placement];
    Object.keys(overflowOffsets).forEach(function (key) {
      var multiply = [right, bottom].indexOf(key) >= 0 ? 1 : -1;
      var axis = [top, bottom].indexOf(key) >= 0 ? 'y' : 'x';
      overflowOffsets[key] += offset[axis] * multiply;
    });
  }
  return overflowOffsets;
}

function computeAutoPlacement(state, options) {
  if (options === void 0) {
    options = {};
  }
  var _options = options,
    placement = _options.placement,
    boundary = _options.boundary,
    rootBoundary = _options.rootBoundary,
    padding = _options.padding,
    flipVariations = _options.flipVariations,
    _options$allowedAutoP = _options.allowedAutoPlacements,
    allowedAutoPlacements = _options$allowedAutoP === void 0 ? placements : _options$allowedAutoP;
  var variation = getVariation(placement);
  var placements$1 = variation ? flipVariations ? variationPlacements : variationPlacements.filter(function (placement) {
    return getVariation(placement) === variation;
  }) : basePlacements;
  var allowedPlacements = placements$1.filter(function (placement) {
    return allowedAutoPlacements.indexOf(placement) >= 0;
  });
  if (allowedPlacements.length === 0) {
    allowedPlacements = placements$1;
  } // $FlowFixMe[incompatible-type]: Flow seems to have problems with two array unions...

  var overflows = allowedPlacements.reduce(function (acc, placement) {
    acc[placement] = detectOverflow(state, {
      placement: placement,
      boundary: boundary,
      rootBoundary: rootBoundary,
      padding: padding
    })[getBasePlacement(placement)];
    return acc;
  }, {});
  return Object.keys(overflows).sort(function (a, b) {
    return overflows[a] - overflows[b];
  });
}

function getExpandedFallbackPlacements(placement) {
  if (getBasePlacement(placement) === auto) {
    return [];
  }
  var oppositePlacement = getOppositePlacement(placement);
  return [getOppositeVariationPlacement(placement), oppositePlacement, getOppositeVariationPlacement(oppositePlacement)];
}
function flip(_ref) {
  var state = _ref.state,
    options = _ref.options,
    name = _ref.name;
  if (state.modifiersData[name]._skip) {
    return;
  }
  var _options$mainAxis = options.mainAxis,
    checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis,
    _options$altAxis = options.altAxis,
    checkAltAxis = _options$altAxis === void 0 ? true : _options$altAxis,
    specifiedFallbackPlacements = options.fallbackPlacements,
    padding = options.padding,
    boundary = options.boundary,
    rootBoundary = options.rootBoundary,
    altBoundary = options.altBoundary,
    _options$flipVariatio = options.flipVariations,
    flipVariations = _options$flipVariatio === void 0 ? true : _options$flipVariatio,
    allowedAutoPlacements = options.allowedAutoPlacements;
  var preferredPlacement = state.options.placement;
  var basePlacement = getBasePlacement(preferredPlacement);
  var isBasePlacement = basePlacement === preferredPlacement;
  var fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipVariations ? [getOppositePlacement(preferredPlacement)] : getExpandedFallbackPlacements(preferredPlacement));
  var placements = [preferredPlacement].concat(fallbackPlacements).reduce(function (acc, placement) {
    return acc.concat(getBasePlacement(placement) === auto ? computeAutoPlacement(state, {
      placement: placement,
      boundary: boundary,
      rootBoundary: rootBoundary,
      padding: padding,
      flipVariations: flipVariations,
      allowedAutoPlacements: allowedAutoPlacements
    }) : placement);
  }, []);
  var referenceRect = state.rects.reference;
  var popperRect = state.rects.popper;
  var checksMap = new Map();
  var makeFallbackChecks = true;
  var firstFittingPlacement = placements[0];
  for (var i = 0; i < placements.length; i++) {
    var placement = placements[i];
    var _basePlacement = getBasePlacement(placement);
    var isStartVariation = getVariation(placement) === start;
    var isVertical = [top, bottom].indexOf(_basePlacement) >= 0;
    var len = isVertical ? 'width' : 'height';
    var overflow = detectOverflow(state, {
      placement: placement,
      boundary: boundary,
      rootBoundary: rootBoundary,
      altBoundary: altBoundary,
      padding: padding
    });
    var mainVariationSide = isVertical ? isStartVariation ? right : left : isStartVariation ? bottom : top;
    if (referenceRect[len] > popperRect[len]) {
      mainVariationSide = getOppositePlacement(mainVariationSide);
    }
    var altVariationSide = getOppositePlacement(mainVariationSide);
    var checks = [];
    if (checkMainAxis) {
      checks.push(overflow[_basePlacement] <= 0);
    }
    if (checkAltAxis) {
      checks.push(overflow[mainVariationSide] <= 0, overflow[altVariationSide] <= 0);
    }
    if (checks.every(function (check) {
      return check;
    })) {
      firstFittingPlacement = placement;
      makeFallbackChecks = false;
      break;
    }
    checksMap.set(placement, checks);
  }
  if (makeFallbackChecks) {
    // `2` may be desired in some cases – research later
    var numberOfChecks = flipVariations ? 3 : 1;
    var _loop = function _loop(_i) {
      var fittingPlacement = placements.find(function (placement) {
        var checks = checksMap.get(placement);
        if (checks) {
          return checks.slice(0, _i).every(function (check) {
            return check;
          });
        }
      });
      if (fittingPlacement) {
        firstFittingPlacement = fittingPlacement;
        return "break";
      }
    };
    for (var _i = numberOfChecks; _i > 0; _i--) {
      var _ret = _loop(_i);
      if (_ret === "break") break;
    }
  }
  if (state.placement !== firstFittingPlacement) {
    state.modifiersData[name]._skip = true;
    state.placement = firstFittingPlacement;
    state.reset = true;
  }
} // eslint-disable-next-line import/no-unused-modules

var flip$1 = {
  name: 'flip',
  enabled: true,
  phase: 'main',
  fn: flip,
  requiresIfExists: ['offset'],
  data: {
    _skip: false
  }
};

function getSideOffsets(overflow, rect, preventedOffsets) {
  if (preventedOffsets === void 0) {
    preventedOffsets = {
      x: 0,
      y: 0
    };
  }
  return {
    top: overflow.top - rect.height - preventedOffsets.y,
    right: overflow.right - rect.width + preventedOffsets.x,
    bottom: overflow.bottom - rect.height + preventedOffsets.y,
    left: overflow.left - rect.width - preventedOffsets.x
  };
}
function isAnySideFullyClipped(overflow) {
  return [top, right, bottom, left].some(function (side) {
    return overflow[side] >= 0;
  });
}
function hide(_ref) {
  var state = _ref.state,
    name = _ref.name;
  var referenceRect = state.rects.reference;
  var popperRect = state.rects.popper;
  var preventedOffsets = state.modifiersData.preventOverflow;
  var referenceOverflow = detectOverflow(state, {
    elementContext: 'reference'
  });
  var popperAltOverflow = detectOverflow(state, {
    altBoundary: true
  });
  var referenceClippingOffsets = getSideOffsets(referenceOverflow, referenceRect);
  var popperEscapeOffsets = getSideOffsets(popperAltOverflow, popperRect, preventedOffsets);
  var isReferenceHidden = isAnySideFullyClipped(referenceClippingOffsets);
  var hasPopperEscaped = isAnySideFullyClipped(popperEscapeOffsets);
  state.modifiersData[name] = {
    referenceClippingOffsets: referenceClippingOffsets,
    popperEscapeOffsets: popperEscapeOffsets,
    isReferenceHidden: isReferenceHidden,
    hasPopperEscaped: hasPopperEscaped
  };
  state.attributes.popper = Object.assign({}, state.attributes.popper, {
    'data-popper-reference-hidden': isReferenceHidden,
    'data-popper-escaped': hasPopperEscaped
  });
} // eslint-disable-next-line import/no-unused-modules

var hide$1 = {
  name: 'hide',
  enabled: true,
  phase: 'main',
  requiresIfExists: ['preventOverflow'],
  fn: hide
};

function distanceAndSkiddingToXY(placement, rects, offset) {
  var basePlacement = getBasePlacement(placement);
  var invertDistance = [left, top].indexOf(basePlacement) >= 0 ? -1 : 1;
  var _ref = typeof offset === 'function' ? offset(Object.assign({}, rects, {
      placement: placement
    })) : offset,
    skidding = _ref[0],
    distance = _ref[1];
  skidding = skidding || 0;
  distance = (distance || 0) * invertDistance;
  return [left, right].indexOf(basePlacement) >= 0 ? {
    x: distance,
    y: skidding
  } : {
    x: skidding,
    y: distance
  };
}
function offset(_ref2) {
  var state = _ref2.state,
    options = _ref2.options,
    name = _ref2.name;
  var _options$offset = options.offset,
    offset = _options$offset === void 0 ? [0, 0] : _options$offset;
  var data = placements.reduce(function (acc, placement) {
    acc[placement] = distanceAndSkiddingToXY(placement, state.rects, offset);
    return acc;
  }, {});
  var _data$state$placement = data[state.placement],
    x = _data$state$placement.x,
    y = _data$state$placement.y;
  if (state.modifiersData.popperOffsets != null) {
    state.modifiersData.popperOffsets.x += x;
    state.modifiersData.popperOffsets.y += y;
  }
  state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules

var offset$1 = {
  name: 'offset',
  enabled: true,
  phase: 'main',
  requires: ['popperOffsets'],
  fn: offset
};

function popperOffsets(_ref) {
  var state = _ref.state,
    name = _ref.name;
  // Offsets are the actual position the popper needs to have to be
  // properly positioned near its reference element
  // This is the most basic placement, and will be adjusted by
  // the modifiers in the next step
  state.modifiersData[name] = computeOffsets({
    reference: state.rects.reference,
    element: state.rects.popper,
    strategy: 'absolute',
    placement: state.placement
  });
} // eslint-disable-next-line import/no-unused-modules

var popperOffsets$1 = {
  name: 'popperOffsets',
  enabled: true,
  phase: 'read',
  fn: popperOffsets,
  data: {}
};

function getAltAxis(axis) {
  return axis === 'x' ? 'y' : 'x';
}

function preventOverflow(_ref) {
  var state = _ref.state,
    options = _ref.options,
    name = _ref.name;
  var _options$mainAxis = options.mainAxis,
    checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis,
    _options$altAxis = options.altAxis,
    checkAltAxis = _options$altAxis === void 0 ? false : _options$altAxis,
    boundary = options.boundary,
    rootBoundary = options.rootBoundary,
    altBoundary = options.altBoundary,
    padding = options.padding,
    _options$tether = options.tether,
    tether = _options$tether === void 0 ? true : _options$tether,
    _options$tetherOffset = options.tetherOffset,
    tetherOffset = _options$tetherOffset === void 0 ? 0 : _options$tetherOffset;
  var overflow = detectOverflow(state, {
    boundary: boundary,
    rootBoundary: rootBoundary,
    padding: padding,
    altBoundary: altBoundary
  });
  var basePlacement = getBasePlacement(state.placement);
  var variation = getVariation(state.placement);
  var isBasePlacement = !variation;
  var mainAxis = getMainAxisFromPlacement(basePlacement);
  var altAxis = getAltAxis(mainAxis);
  var popperOffsets = state.modifiersData.popperOffsets;
  var referenceRect = state.rects.reference;
  var popperRect = state.rects.popper;
  var tetherOffsetValue = typeof tetherOffset === 'function' ? tetherOffset(Object.assign({}, state.rects, {
    placement: state.placement
  })) : tetherOffset;
  var normalizedTetherOffsetValue = typeof tetherOffsetValue === 'number' ? {
    mainAxis: tetherOffsetValue,
    altAxis: tetherOffsetValue
  } : Object.assign({
    mainAxis: 0,
    altAxis: 0
  }, tetherOffsetValue);
  var offsetModifierState = state.modifiersData.offset ? state.modifiersData.offset[state.placement] : null;
  var data = {
    x: 0,
    y: 0
  };
  if (!popperOffsets) {
    return;
  }
  if (checkMainAxis) {
    var _offsetModifierState$;
    var mainSide = mainAxis === 'y' ? top : left;
    var altSide = mainAxis === 'y' ? bottom : right;
    var len = mainAxis === 'y' ? 'height' : 'width';
    var offset = popperOffsets[mainAxis];
    var min$1 = offset + overflow[mainSide];
    var max$1 = offset - overflow[altSide];
    var additive = tether ? -popperRect[len] / 2 : 0;
    var minLen = variation === start ? referenceRect[len] : popperRect[len];
    var maxLen = variation === start ? -popperRect[len] : -referenceRect[len]; // We need to include the arrow in the calculation so the arrow doesn't go
    // outside the reference bounds

    var arrowElement = state.elements.arrow;
    var arrowRect = tether && arrowElement ? getLayoutRect(arrowElement) : {
      width: 0,
      height: 0
    };
    var arrowPaddingObject = state.modifiersData['arrow#persistent'] ? state.modifiersData['arrow#persistent'].padding : getFreshSideObject();
    var arrowPaddingMin = arrowPaddingObject[mainSide];
    var arrowPaddingMax = arrowPaddingObject[altSide]; // If the reference length is smaller than the arrow length, we don't want
    // to include its full size in the calculation. If the reference is small
    // and near the edge of a boundary, the popper can overflow even if the
    // reference is not overflowing as well (e.g. virtual elements with no
    // width or height)

    var arrowLen = within(0, referenceRect[len], arrowRect[len]);
    var minOffset = isBasePlacement ? referenceRect[len] / 2 - additive - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis : minLen - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis;
    var maxOffset = isBasePlacement ? -referenceRect[len] / 2 + additive + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis : maxLen + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis;
    var arrowOffsetParent = state.elements.arrow && getOffsetParent(state.elements.arrow);
    var clientOffset = arrowOffsetParent ? mainAxis === 'y' ? arrowOffsetParent.clientTop || 0 : arrowOffsetParent.clientLeft || 0 : 0;
    var offsetModifierValue = (_offsetModifierState$ = offsetModifierState == null ? void 0 : offsetModifierState[mainAxis]) != null ? _offsetModifierState$ : 0;
    var tetherMin = offset + minOffset - offsetModifierValue - clientOffset;
    var tetherMax = offset + maxOffset - offsetModifierValue;
    var preventedOffset = within(tether ? min(min$1, tetherMin) : min$1, offset, tether ? max(max$1, tetherMax) : max$1);
    popperOffsets[mainAxis] = preventedOffset;
    data[mainAxis] = preventedOffset - offset;
  }
  if (checkAltAxis) {
    var _offsetModifierState$2;
    var _mainSide = mainAxis === 'x' ? top : left;
    var _altSide = mainAxis === 'x' ? bottom : right;
    var _offset = popperOffsets[altAxis];
    var _len = altAxis === 'y' ? 'height' : 'width';
    var _min = _offset + overflow[_mainSide];
    var _max = _offset - overflow[_altSide];
    var isOriginSide = [top, left].indexOf(basePlacement) !== -1;
    var _offsetModifierValue = (_offsetModifierState$2 = offsetModifierState == null ? void 0 : offsetModifierState[altAxis]) != null ? _offsetModifierState$2 : 0;
    var _tetherMin = isOriginSide ? _min : _offset - referenceRect[_len] - popperRect[_len] - _offsetModifierValue + normalizedTetherOffsetValue.altAxis;
    var _tetherMax = isOriginSide ? _offset + referenceRect[_len] + popperRect[_len] - _offsetModifierValue - normalizedTetherOffsetValue.altAxis : _max;
    var _preventedOffset = tether && isOriginSide ? withinMaxClamp(_tetherMin, _offset, _tetherMax) : within(tether ? _tetherMin : _min, _offset, tether ? _tetherMax : _max);
    popperOffsets[altAxis] = _preventedOffset;
    data[altAxis] = _preventedOffset - _offset;
  }
  state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules

var preventOverflow$1 = {
  name: 'preventOverflow',
  enabled: true,
  phase: 'main',
  fn: preventOverflow,
  requiresIfExists: ['offset']
};

function getHTMLElementScroll(element) {
  return {
    scrollLeft: element.scrollLeft,
    scrollTop: element.scrollTop
  };
}

function getNodeScroll(node) {
  if (node === getWindow(node) || !isHTMLElement(node)) {
    return getWindowScroll(node);
  } else {
    return getHTMLElementScroll(node);
  }
}

function isElementScaled(element) {
  var rect = element.getBoundingClientRect();
  var scaleX = round$1(rect.width) / element.offsetWidth || 1;
  var scaleY = round$1(rect.height) / element.offsetHeight || 1;
  return scaleX !== 1 || scaleY !== 1;
} // Returns the composite rect of an element relative to its offsetParent.
// Composite means it takes into account transforms as well as layout.

function getCompositeRect(elementOrVirtualElement, offsetParent, isFixed) {
  if (isFixed === void 0) {
    isFixed = false;
  }
  var isOffsetParentAnElement = isHTMLElement(offsetParent);
  var offsetParentIsScaled = isHTMLElement(offsetParent) && isElementScaled(offsetParent);
  var documentElement = getDocumentElement(offsetParent);
  var rect = getBoundingClientRect(elementOrVirtualElement, offsetParentIsScaled, isFixed);
  var scroll = {
    scrollLeft: 0,
    scrollTop: 0
  };
  var offsets = {
    x: 0,
    y: 0
  };
  if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
    if (getNodeName(offsetParent) !== 'body' ||
    // https://github.com/popperjs/popper-core/issues/1078
    isScrollParent(documentElement)) {
      scroll = getNodeScroll(offsetParent);
    }
    if (isHTMLElement(offsetParent)) {
      offsets = getBoundingClientRect(offsetParent, true);
      offsets.x += offsetParent.clientLeft;
      offsets.y += offsetParent.clientTop;
    } else if (documentElement) {
      offsets.x = getWindowScrollBarX(documentElement);
    }
  }
  return {
    x: rect.left + scroll.scrollLeft - offsets.x,
    y: rect.top + scroll.scrollTop - offsets.y,
    width: rect.width,
    height: rect.height
  };
}

function order(modifiers) {
  var map = new Map();
  var visited = new Set();
  var result = [];
  modifiers.forEach(function (modifier) {
    map.set(modifier.name, modifier);
  }); // On visiting object, check for its dependencies and visit them recursively

  function sort(modifier) {
    visited.add(modifier.name);
    var requires = [].concat(modifier.requires || [], modifier.requiresIfExists || []);
    requires.forEach(function (dep) {
      if (!visited.has(dep)) {
        var depModifier = map.get(dep);
        if (depModifier) {
          sort(depModifier);
        }
      }
    });
    result.push(modifier);
  }
  modifiers.forEach(function (modifier) {
    if (!visited.has(modifier.name)) {
      // check for visited object
      sort(modifier);
    }
  });
  return result;
}
function orderModifiers(modifiers) {
  // order based on dependencies
  var orderedModifiers = order(modifiers); // order based on phase

  return modifierPhases.reduce(function (acc, phase) {
    return acc.concat(orderedModifiers.filter(function (modifier) {
      return modifier.phase === phase;
    }));
  }, []);
}

function debounce(fn) {
  var pending;
  return function () {
    if (!pending) {
      pending = new Promise(function (resolve) {
        Promise.resolve().then(function () {
          pending = undefined;
          resolve(fn());
        });
      });
    }
    return pending;
  };
}

function mergeByName(modifiers) {
  var merged = modifiers.reduce(function (merged, current) {
    var existing = merged[current.name];
    merged[current.name] = existing ? Object.assign({}, existing, current, {
      options: Object.assign({}, existing.options, current.options),
      data: Object.assign({}, existing.data, current.data)
    }) : current;
    return merged;
  }, {}); // IE11 does not support Object.values

  return Object.keys(merged).map(function (key) {
    return merged[key];
  });
}

var DEFAULT_OPTIONS$1 = {
  placement: 'bottom',
  modifiers: [],
  strategy: 'absolute'
};
function areValidElements() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }
  return !args.some(function (element) {
    return !(element && typeof element.getBoundingClientRect === 'function');
  });
}
function popperGenerator(generatorOptions) {
  if (generatorOptions === void 0) {
    generatorOptions = {};
  }
  var _generatorOptions = generatorOptions,
    _generatorOptions$def = _generatorOptions.defaultModifiers,
    defaultModifiers = _generatorOptions$def === void 0 ? [] : _generatorOptions$def,
    _generatorOptions$def2 = _generatorOptions.defaultOptions,
    defaultOptions = _generatorOptions$def2 === void 0 ? DEFAULT_OPTIONS$1 : _generatorOptions$def2;
  return function createPopper(reference, popper, options) {
    if (options === void 0) {
      options = defaultOptions;
    }
    var state = {
      placement: 'bottom',
      orderedModifiers: [],
      options: Object.assign({}, DEFAULT_OPTIONS$1, defaultOptions),
      modifiersData: {},
      elements: {
        reference: reference,
        popper: popper
      },
      attributes: {},
      styles: {}
    };
    var effectCleanupFns = [];
    var isDestroyed = false;
    var instance = {
      state: state,
      setOptions: function setOptions(setOptionsAction) {
        var options = typeof setOptionsAction === 'function' ? setOptionsAction(state.options) : setOptionsAction;
        cleanupModifierEffects();
        state.options = Object.assign({}, defaultOptions, state.options, options);
        state.scrollParents = {
          reference: isElement(reference) ? listScrollParents(reference) : reference.contextElement ? listScrollParents(reference.contextElement) : [],
          popper: listScrollParents(popper)
        }; // Orders the modifiers based on their dependencies and `phase`
        // properties

        var orderedModifiers = orderModifiers(mergeByName([].concat(defaultModifiers, state.options.modifiers))); // Strip out disabled modifiers

        state.orderedModifiers = orderedModifiers.filter(function (m) {
          return m.enabled;
        });
        runModifierEffects();
        return instance.update();
      },
      // Sync update – it will always be executed, even if not necessary. This
      // is useful for low frequency updates where sync behavior simplifies the
      // logic.
      // For high frequency updates (e.g. `resize` and `scroll` events), always
      // prefer the async Popper#update method
      forceUpdate: function forceUpdate() {
        if (isDestroyed) {
          return;
        }
        var _state$elements = state.elements,
          reference = _state$elements.reference,
          popper = _state$elements.popper; // Don't proceed if `reference` or `popper` are not valid elements
        // anymore

        if (!areValidElements(reference, popper)) {
          return;
        } // Store the reference and popper rects to be read by modifiers

        state.rects = {
          reference: getCompositeRect(reference, getOffsetParent(popper), state.options.strategy === 'fixed'),
          popper: getLayoutRect(popper)
        }; // Modifiers have the ability to reset the current update cycle. The
        // most common use case for this is the `flip` modifier changing the
        // placement, which then needs to re-run all the modifiers, because the
        // logic was previously ran for the previous placement and is therefore
        // stale/incorrect

        state.reset = false;
        state.placement = state.options.placement; // On each update cycle, the `modifiersData` property for each modifier
        // is filled with the initial data specified by the modifier. This means
        // it doesn't persist and is fresh on each update.
        // To ensure persistent data, use `${name}#persistent`

        state.orderedModifiers.forEach(function (modifier) {
          return state.modifiersData[modifier.name] = Object.assign({}, modifier.data);
        });
        for (var index = 0; index < state.orderedModifiers.length; index++) {
          if (state.reset === true) {
            state.reset = false;
            index = -1;
            continue;
          }
          var _state$orderedModifie = state.orderedModifiers[index],
            fn = _state$orderedModifie.fn,
            _state$orderedModifie2 = _state$orderedModifie.options,
            _options = _state$orderedModifie2 === void 0 ? {} : _state$orderedModifie2,
            name = _state$orderedModifie.name;
          if (typeof fn === 'function') {
            state = fn({
              state: state,
              options: _options,
              name: name,
              instance: instance
            }) || state;
          }
        }
      },
      // Async and optimistically optimized update – it will not be executed if
      // not necessary (debounced to run at most once-per-tick)
      update: debounce(function () {
        return new Promise(function (resolve) {
          instance.forceUpdate();
          resolve(state);
        });
      }),
      destroy: function destroy() {
        cleanupModifierEffects();
        isDestroyed = true;
      }
    };
    if (!areValidElements(reference, popper)) {
      return instance;
    }
    instance.setOptions(options).then(function (state) {
      if (!isDestroyed && options.onFirstUpdate) {
        options.onFirstUpdate(state);
      }
    }); // Modifiers have the ability to execute arbitrary code before the first
    // update cycle runs. They will be executed in the same order as the update
    // cycle. This is useful when a modifier adds some persistent data that
    // other modifiers need to use, but the modifier is run after the dependent
    // one.

    function runModifierEffects() {
      state.orderedModifiers.forEach(function (_ref) {
        var name = _ref.name,
          _ref$options = _ref.options,
          options = _ref$options === void 0 ? {} : _ref$options,
          effect = _ref.effect;
        if (typeof effect === 'function') {
          var cleanupFn = effect({
            state: state,
            name: name,
            instance: instance,
            options: options
          });
          var noopFn = function noopFn() {};
          effectCleanupFns.push(cleanupFn || noopFn);
        }
      });
    }
    function cleanupModifierEffects() {
      effectCleanupFns.forEach(function (fn) {
        return fn();
      });
      effectCleanupFns = [];
    }
    return instance;
  };
}

var defaultModifiers = [eventListeners, popperOffsets$1, computeStyles$1, applyStyles$1, offset$1, flip$1, preventOverflow$1, arrow$1, hide$1];
var createPopper = /*#__PURE__*/popperGenerator({
  defaultModifiers: defaultModifiers
}); // eslint-disable-next-line import/no-unused-modules

/* global Map:readonly, Set:readonly, ArrayBuffer:readonly */
var hasElementType = typeof Element !== 'undefined';
var hasMap = typeof Map === 'function';
var hasSet = typeof Set === 'function';
var hasArrayBuffer = typeof ArrayBuffer === 'function' && !!ArrayBuffer.isView;

// Note: We **don't** need `envHasBigInt64Array` in fde es6/index.js

function equal(a, b) {
  // START: fast-deep-equal es6/index.js 3.1.3
  if (a === b) return true;
  if (a && b && typeof a == 'object' && typeof b == 'object') {
    if (a.constructor !== b.constructor) return false;
    var length, i, keys;
    if (Array.isArray(a)) {
      length = a.length;
      if (length != b.length) return false;
      for (i = length; i-- !== 0;) if (!equal(a[i], b[i])) return false;
      return true;
    }

    // START: Modifications:
    // 1. Extra `has<Type> &&` helpers in initial condition allow es6 code
    //    to co-exist with es5.
    // 2. Replace `for of` with es5 compliant iteration using `for`.
    //    Basically, take:
    //
    //    ```js
    //    for (i of a.entries())
    //      if (!b.has(i[0])) return false;
    //    ```
    //
    //    ... and convert to:
    //
    //    ```js
    //    it = a.entries();
    //    while (!(i = it.next()).done)
    //      if (!b.has(i.value[0])) return false;
    //    ```
    //
    //    **Note**: `i` access switches to `i.value`.
    var it;
    if (hasMap && a instanceof Map && b instanceof Map) {
      if (a.size !== b.size) return false;
      it = a.entries();
      while (!(i = it.next()).done) if (!b.has(i.value[0])) return false;
      it = a.entries();
      while (!(i = it.next()).done) if (!equal(i.value[1], b.get(i.value[0]))) return false;
      return true;
    }
    if (hasSet && a instanceof Set && b instanceof Set) {
      if (a.size !== b.size) return false;
      it = a.entries();
      while (!(i = it.next()).done) if (!b.has(i.value[0])) return false;
      return true;
    }
    // END: Modifications

    if (hasArrayBuffer && ArrayBuffer.isView(a) && ArrayBuffer.isView(b)) {
      length = a.length;
      if (length != b.length) return false;
      for (i = length; i-- !== 0;) if (a[i] !== b[i]) return false;
      return true;
    }
    if (a.constructor === RegExp) return a.source === b.source && a.flags === b.flags;
    // START: Modifications:
    // Apply guards for `Object.create(null)` handling. See:
    // - https://github.com/FormidableLabs/react-fast-compare/issues/64
    // - https://github.com/epoberezkin/fast-deep-equal/issues/49
    if (a.valueOf !== Object.prototype.valueOf && typeof a.valueOf === 'function' && typeof b.valueOf === 'function') return a.valueOf() === b.valueOf();
    if (a.toString !== Object.prototype.toString && typeof a.toString === 'function' && typeof b.toString === 'function') return a.toString() === b.toString();
    // END: Modifications

    keys = Object.keys(a);
    length = keys.length;
    if (length !== Object.keys(b).length) return false;
    for (i = length; i-- !== 0;) if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;
    // END: fast-deep-equal

    // START: react-fast-compare
    // custom handling for DOM elements
    if (hasElementType && a instanceof Element) return false;

    // custom handling for React/Preact
    for (i = length; i-- !== 0;) {
      if ((keys[i] === '_owner' || keys[i] === '__v' || keys[i] === '__o') && a.$$typeof) {
        // React-specific: avoid traversing React elements' _owner
        // Preact-specific: avoid traversing Preact elements' __v and __o
        //    __v = $_original / $_vnode
        //    __o = $_owner
        // These properties contain circular references and are not needed when
        // comparing the actual elements (and not their owners)
        // .$$typeof and ._store on just reasonable markers of elements

        continue;
      }

      // all other properties should be traversed as usual
      if (!equal(a[keys[i]], b[keys[i]])) return false;
    }
    // END: react-fast-compare

    // START: fast-deep-equal
    return true;
  }
  return a !== a && b !== b;
}
// end fast-deep-equal

var reactFastCompare = function isEqual(a, b) {
  try {
    return equal(a, b);
  } catch (error) {
    if ((error.message || '').match(/stack|recursion/i)) {
      // warn on circular references, don't crash
      // browsers give this different errors name and messages:
      // chrome/safari: "RangeError", "Maximum call stack size exceeded"
      // firefox: "InternalError", too much recursion"
      // edge: "Error", "Out of stack space"
      console.warn('react-fast-compare cannot handle circular refs');
      return false;
    }
    // some other error. we should definitely know about these
    throw error;
  }
};
var isEqual$1 = /*@__PURE__*/getDefaultExportFromCjs$1(reactFastCompare);

var EMPTY_MODIFIERS = [];
var usePopper = function usePopper(referenceElement, popperElement, options) {
  if (options === void 0) {
    options = {};
  }
  var prevOptions = react__WEBPACK_IMPORTED_MODULE_0__.useRef(null);
  var optionsWithDefaults = {
    onFirstUpdate: options.onFirstUpdate,
    placement: options.placement || 'bottom',
    strategy: options.strategy || 'absolute',
    modifiers: options.modifiers || EMPTY_MODIFIERS
  };
  var _React$useState = react__WEBPACK_IMPORTED_MODULE_0__.useState({
      styles: {
        popper: {
          position: optionsWithDefaults.strategy,
          left: '0',
          top: '0'
        },
        arrow: {
          position: 'absolute'
        }
      },
      attributes: {}
    }),
    state = _React$useState[0],
    setState = _React$useState[1];
  var updateStateModifier = react__WEBPACK_IMPORTED_MODULE_0__.useMemo(function () {
    return {
      name: 'updateState',
      enabled: true,
      phase: 'write',
      fn: function fn(_ref) {
        var state = _ref.state;
        var elements = Object.keys(state.elements);
        react_dom__WEBPACK_IMPORTED_MODULE_3__.flushSync(function () {
          setState({
            styles: fromEntries(elements.map(function (element) {
              return [element, state.styles[element] || {}];
            })),
            attributes: fromEntries(elements.map(function (element) {
              return [element, state.attributes[element]];
            }))
          });
        });
      },
      requires: ['computeStyles']
    };
  }, []);
  var popperOptions = react__WEBPACK_IMPORTED_MODULE_0__.useMemo(function () {
    var newOptions = {
      onFirstUpdate: optionsWithDefaults.onFirstUpdate,
      placement: optionsWithDefaults.placement,
      strategy: optionsWithDefaults.strategy,
      modifiers: [].concat(optionsWithDefaults.modifiers, [updateStateModifier, {
        name: 'applyStyles',
        enabled: false
      }])
    };
    if (isEqual$1(prevOptions.current, newOptions)) {
      return prevOptions.current || newOptions;
    } else {
      prevOptions.current = newOptions;
      return newOptions;
    }
  }, [optionsWithDefaults.onFirstUpdate, optionsWithDefaults.placement, optionsWithDefaults.strategy, optionsWithDefaults.modifiers, updateStateModifier]);
  var popperInstanceRef = react__WEBPACK_IMPORTED_MODULE_0__.useRef();
  useIsomorphicLayoutEffect(function () {
    if (popperInstanceRef.current) {
      popperInstanceRef.current.setOptions(popperOptions);
    }
  }, [popperOptions]);
  useIsomorphicLayoutEffect(function () {
    if (referenceElement == null || popperElement == null) {
      return;
    }
    var createPopper$1 = options.createPopper || createPopper;
    var popperInstance = createPopper$1(referenceElement, popperElement, popperOptions);
    popperInstanceRef.current = popperInstance;
    return function () {
      popperInstance.destroy();
      popperInstanceRef.current = null;
    };
  }, [referenceElement, popperElement, options.createPopper]);
  return {
    state: popperInstanceRef.current ? popperInstanceRef.current.state : null,
    styles: state.styles,
    attributes: state.attributes,
    update: popperInstanceRef.current ? popperInstanceRef.current.update : null,
    forceUpdate: popperInstanceRef.current ? popperInstanceRef.current.forceUpdate : null
  };
};

function _extends$6() {
  return _extends$6 = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$6.apply(null, arguments);
}

function _objectWithoutPropertiesLoose(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (e.includes(n)) continue;
    t[n] = r[n];
  }
  return t;
}

function _inheritsLoose(t, o) {
  t.prototype = Object.create(o.prototype), t.prototype.constructor = t, _setPrototypeOf(t, o);
}

var propTypes = {exports: {}};

var reactIs = {exports: {}};

var reactIs_production_min = {};

/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var hasRequiredReactIs_production_min;
function requireReactIs_production_min() {
  if (hasRequiredReactIs_production_min) return reactIs_production_min;
  hasRequiredReactIs_production_min = 1;
  var b = "function" === typeof Symbol && Symbol.for,
    c = b ? Symbol.for("react.element") : 60103,
    d = b ? Symbol.for("react.portal") : 60106,
    e = b ? Symbol.for("react.fragment") : 60107,
    f = b ? Symbol.for("react.strict_mode") : 60108,
    g = b ? Symbol.for("react.profiler") : 60114,
    h = b ? Symbol.for("react.provider") : 60109,
    k = b ? Symbol.for("react.context") : 60110,
    l = b ? Symbol.for("react.async_mode") : 60111,
    m = b ? Symbol.for("react.concurrent_mode") : 60111,
    n = b ? Symbol.for("react.forward_ref") : 60112,
    p = b ? Symbol.for("react.suspense") : 60113,
    q = b ? Symbol.for("react.suspense_list") : 60120,
    r = b ? Symbol.for("react.memo") : 60115,
    t = b ? Symbol.for("react.lazy") : 60116,
    v = b ? Symbol.for("react.block") : 60121,
    w = b ? Symbol.for("react.fundamental") : 60117,
    x = b ? Symbol.for("react.responder") : 60118,
    y = b ? Symbol.for("react.scope") : 60119;
  function z(a) {
    if ("object" === typeof a && null !== a) {
      var u = a.$$typeof;
      switch (u) {
        case c:
          switch (a = a.type, a) {
            case l:
            case m:
            case e:
            case g:
            case f:
            case p:
              return a;
            default:
              switch (a = a && a.$$typeof, a) {
                case k:
                case n:
                case t:
                case r:
                case h:
                  return a;
                default:
                  return u;
              }
          }
        case d:
          return u;
      }
    }
  }
  function A(a) {
    return z(a) === m;
  }
  reactIs_production_min.AsyncMode = l;
  reactIs_production_min.ConcurrentMode = m;
  reactIs_production_min.ContextConsumer = k;
  reactIs_production_min.ContextProvider = h;
  reactIs_production_min.Element = c;
  reactIs_production_min.ForwardRef = n;
  reactIs_production_min.Fragment = e;
  reactIs_production_min.Lazy = t;
  reactIs_production_min.Memo = r;
  reactIs_production_min.Portal = d;
  reactIs_production_min.Profiler = g;
  reactIs_production_min.StrictMode = f;
  reactIs_production_min.Suspense = p;
  reactIs_production_min.isAsyncMode = function (a) {
    return A(a) || z(a) === l;
  };
  reactIs_production_min.isConcurrentMode = A;
  reactIs_production_min.isContextConsumer = function (a) {
    return z(a) === k;
  };
  reactIs_production_min.isContextProvider = function (a) {
    return z(a) === h;
  };
  reactIs_production_min.isElement = function (a) {
    return "object" === typeof a && null !== a && a.$$typeof === c;
  };
  reactIs_production_min.isForwardRef = function (a) {
    return z(a) === n;
  };
  reactIs_production_min.isFragment = function (a) {
    return z(a) === e;
  };
  reactIs_production_min.isLazy = function (a) {
    return z(a) === t;
  };
  reactIs_production_min.isMemo = function (a) {
    return z(a) === r;
  };
  reactIs_production_min.isPortal = function (a) {
    return z(a) === d;
  };
  reactIs_production_min.isProfiler = function (a) {
    return z(a) === g;
  };
  reactIs_production_min.isStrictMode = function (a) {
    return z(a) === f;
  };
  reactIs_production_min.isSuspense = function (a) {
    return z(a) === p;
  };
  reactIs_production_min.isValidElementType = function (a) {
    return "string" === typeof a || "function" === typeof a || a === e || a === m || a === g || a === f || a === p || a === q || "object" === typeof a && null !== a && (a.$$typeof === t || a.$$typeof === r || a.$$typeof === h || a.$$typeof === k || a.$$typeof === n || a.$$typeof === w || a.$$typeof === x || a.$$typeof === y || a.$$typeof === v);
  };
  reactIs_production_min.typeOf = z;
  return reactIs_production_min;
}

var reactIs_development = {};

/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var hasRequiredReactIs_development;
function requireReactIs_development() {
  if (hasRequiredReactIs_development) return reactIs_development;
  hasRequiredReactIs_development = 1;
  if (false) {}
  return reactIs_development;
}

var hasRequiredReactIs;
function requireReactIs() {
  if (hasRequiredReactIs) return reactIs.exports;
  hasRequiredReactIs = 1;
  if (true) {
    reactIs.exports = requireReactIs_production_min();
  } else {}
  return reactIs.exports;
}

/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
var objectAssign;
var hasRequiredObjectAssign;
function requireObjectAssign() {
  if (hasRequiredObjectAssign) return objectAssign;
  hasRequiredObjectAssign = 1;
  /* eslint-disable no-unused-vars */
  var getOwnPropertySymbols = Object.getOwnPropertySymbols;
  var hasOwnProperty = Object.prototype.hasOwnProperty;
  var propIsEnumerable = Object.prototype.propertyIsEnumerable;
  function toObject(val) {
    if (val === null || val === undefined) {
      throw new TypeError('Object.assign cannot be called with null or undefined');
    }
    return Object(val);
  }
  function shouldUseNative() {
    try {
      if (!Object.assign) {
        return false;
      }

      // Detect buggy property enumeration order in older V8 versions.

      // https://bugs.chromium.org/p/v8/issues/detail?id=4118
      var test1 = new String('abc'); // eslint-disable-line no-new-wrappers
      test1[5] = 'de';
      if (Object.getOwnPropertyNames(test1)[0] === '5') {
        return false;
      }

      // https://bugs.chromium.org/p/v8/issues/detail?id=3056
      var test2 = {};
      for (var i = 0; i < 10; i++) {
        test2['_' + String.fromCharCode(i)] = i;
      }
      var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
        return test2[n];
      });
      if (order2.join('') !== '0123456789') {
        return false;
      }

      // https://bugs.chromium.org/p/v8/issues/detail?id=3056
      var test3 = {};
      'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
        test3[letter] = letter;
      });
      if (Object.keys(Object.assign({}, test3)).join('') !== 'abcdefghijklmnopqrst') {
        return false;
      }
      return true;
    } catch (err) {
      // We don't expect any of the above to throw, but better to be safe.
      return false;
    }
  }
  objectAssign = shouldUseNative() ? Object.assign : function (target, source) {
    var from;
    var to = toObject(target);
    var symbols;
    for (var s = 1; s < arguments.length; s++) {
      from = Object(arguments[s]);
      for (var key in from) {
        if (hasOwnProperty.call(from, key)) {
          to[key] = from[key];
        }
      }
      if (getOwnPropertySymbols) {
        symbols = getOwnPropertySymbols(from);
        for (var i = 0; i < symbols.length; i++) {
          if (propIsEnumerable.call(from, symbols[i])) {
            to[symbols[i]] = from[symbols[i]];
          }
        }
      }
    }
    return to;
  };
  return objectAssign;
}

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var ReactPropTypesSecret_1;
var hasRequiredReactPropTypesSecret;
function requireReactPropTypesSecret() {
  if (hasRequiredReactPropTypesSecret) return ReactPropTypesSecret_1;
  hasRequiredReactPropTypesSecret = 1;
  var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
  ReactPropTypesSecret_1 = ReactPropTypesSecret;
  return ReactPropTypesSecret_1;
}

var has;
var hasRequiredHas;
function requireHas() {
  if (hasRequiredHas) return has;
  hasRequiredHas = 1;
  has = Function.call.bind(Object.prototype.hasOwnProperty);
  return has;
}

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var checkPropTypes_1;
var hasRequiredCheckPropTypes;
function requireCheckPropTypes() {
  if (hasRequiredCheckPropTypes) return checkPropTypes_1;
  hasRequiredCheckPropTypes = 1;
  var printWarning = function () {};
  if (false) { var has, loggedTypeFailures, ReactPropTypesSecret; }

  /**
   * Assert that the values match with the type specs.
   * Error messages are memorized and will only be shown once.
   *
   * @param {object} typeSpecs Map of name to a ReactPropType
   * @param {object} values Runtime values that need to be type-checked
   * @param {string} location e.g. "prop", "context", "child context"
   * @param {string} componentName Name of the component for error messages.
   * @param {?Function} getStack Returns the component stack.
   * @private
   */
  function checkPropTypes(typeSpecs, values, location, componentName, getStack) {
    if (false) { var stack, err, error, typeSpecName; }
  }

  /**
   * Resets warning cache when testing.
   *
   * @private
   */
  checkPropTypes.resetWarningCache = function () {
    if (false) {}
  };
  checkPropTypes_1 = checkPropTypes;
  return checkPropTypes_1;
}

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var factoryWithTypeCheckers;
var hasRequiredFactoryWithTypeCheckers;
function requireFactoryWithTypeCheckers() {
  if (hasRequiredFactoryWithTypeCheckers) return factoryWithTypeCheckers;
  hasRequiredFactoryWithTypeCheckers = 1;
  var ReactIs = requireReactIs();
  var assign = requireObjectAssign();
  var ReactPropTypesSecret = requireReactPropTypesSecret();
  var has = requireHas();
  var checkPropTypes = requireCheckPropTypes();
  var printWarning = function () {};
  if (false) {}
  function emptyFunctionThatReturnsNull() {
    return null;
  }
  factoryWithTypeCheckers = function (isValidElement, throwOnDirectAccess) {
    /* global Symbol */
    var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
    var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.

    /**
     * Returns the iterator method function contained on the iterable object.
     *
     * Be sure to invoke the function with the iterable as context:
     *
     *     var iteratorFn = getIteratorFn(myIterable);
     *     if (iteratorFn) {
     *       var iterator = iteratorFn.call(myIterable);
     *       ...
     *     }
     *
     * @param {?object} maybeIterable
     * @return {?function}
     */
    function getIteratorFn(maybeIterable) {
      var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
      if (typeof iteratorFn === 'function') {
        return iteratorFn;
      }
    }

    /**
     * Collection of methods that allow declaration and validation of props that are
     * supplied to React components. Example usage:
     *
     *   var Props = require('ReactPropTypes');
     *   var MyArticle = React.createClass({
     *     propTypes: {
     *       // An optional string prop named "description".
     *       description: Props.string,
     *
     *       // A required enum prop named "category".
     *       category: Props.oneOf(['News','Photos']).isRequired,
     *
     *       // A prop named "dialog" that requires an instance of Dialog.
     *       dialog: Props.instanceOf(Dialog).isRequired
     *     },
     *     render: function() { ... }
     *   });
     *
     * A more formal specification of how these methods are used:
     *
     *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
     *   decl := ReactPropTypes.{type}(.isRequired)?
     *
     * Each and every declaration produces a function with the same signature. This
     * allows the creation of custom validation functions. For example:
     *
     *  var MyLink = React.createClass({
     *    propTypes: {
     *      // An optional string or URI prop named "href".
     *      href: function(props, propName, componentName) {
     *        var propValue = props[propName];
     *        if (propValue != null && typeof propValue !== 'string' &&
     *            !(propValue instanceof URI)) {
     *          return new Error(
     *            'Expected a string or an URI for ' + propName + ' in ' +
     *            componentName
     *          );
     *        }
     *      }
     *    },
     *    render: function() {...}
     *  });
     *
     * @internal
     */

    var ANONYMOUS = '<<anonymous>>';

    // Important!
    // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.
    var ReactPropTypes = {
      array: createPrimitiveTypeChecker('array'),
      bigint: createPrimitiveTypeChecker('bigint'),
      bool: createPrimitiveTypeChecker('boolean'),
      func: createPrimitiveTypeChecker('function'),
      number: createPrimitiveTypeChecker('number'),
      object: createPrimitiveTypeChecker('object'),
      string: createPrimitiveTypeChecker('string'),
      symbol: createPrimitiveTypeChecker('symbol'),
      any: createAnyTypeChecker(),
      arrayOf: createArrayOfTypeChecker,
      element: createElementTypeChecker(),
      elementType: createElementTypeTypeChecker(),
      instanceOf: createInstanceTypeChecker,
      node: createNodeChecker(),
      objectOf: createObjectOfTypeChecker,
      oneOf: createEnumTypeChecker,
      oneOfType: createUnionTypeChecker,
      shape: createShapeTypeChecker,
      exact: createStrictShapeTypeChecker
    };

    /**
     * inlined Object.is polyfill to avoid requiring consumers ship their own
     * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
     */
    /*eslint-disable no-self-compare*/
    function is(x, y) {
      // SameValue algorithm
      if (x === y) {
        // Steps 1-5, 7-10
        // Steps 6.b-6.e: +0 != -0
        return x !== 0 || 1 / x === 1 / y;
      } else {
        // Step 6.a: NaN == NaN
        return x !== x && y !== y;
      }
    }
    /*eslint-enable no-self-compare*/

    /**
     * We use an Error-like object for backward compatibility as people may call
     * PropTypes directly and inspect their output. However, we don't use real
     * Errors anymore. We don't inspect their stack anyway, and creating them
     * is prohibitively expensive if they are created too often, such as what
     * happens in oneOfType() for any type before the one that matched.
     */
    function PropTypeError(message, data) {
      this.message = message;
      this.data = data && typeof data === 'object' ? data : {};
      this.stack = '';
    }
    // Make `instanceof Error` still work for returned errors.
    PropTypeError.prototype = Error.prototype;
    function createChainableTypeChecker(validate) {
      if (false) { var manualPropTypeWarningCount, manualPropTypeCallCache; }
      function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
        componentName = componentName || ANONYMOUS;
        propFullName = propFullName || propName;
        if (secret !== ReactPropTypesSecret) {
          if (throwOnDirectAccess) {
            // New behavior only for users of `prop-types` package
            var err = new Error('Calling PropTypes validators directly is not supported by the `prop-types` package. ' + 'Use `PropTypes.checkPropTypes()` to call them. ' + 'Read more at http://fb.me/use-check-prop-types');
            err.name = 'Invariant Violation';
            throw err;
          } else if (false) { var cacheKey; }
        }
        if (props[propName] == null) {
          if (isRequired) {
            if (props[propName] === null) {
              return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
            }
            return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
          }
          return null;
        } else {
          return validate(props, propName, componentName, location, propFullName);
        }
      }
      var chainedCheckType = checkType.bind(null, false);
      chainedCheckType.isRequired = checkType.bind(null, true);
      return chainedCheckType;
    }
    function createPrimitiveTypeChecker(expectedType) {
      function validate(props, propName, componentName, location, propFullName, secret) {
        var propValue = props[propName];
        var propType = getPropType(propValue);
        if (propType !== expectedType) {
          // `propValue` being instance of, say, date/regexp, pass the 'object'
          // check, but we can offer a more precise error message here rather than
          // 'of type `object`'.
          var preciseType = getPreciseType(propValue);
          return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'), {
            expectedType: expectedType
          });
        }
        return null;
      }
      return createChainableTypeChecker(validate);
    }
    function createAnyTypeChecker() {
      return createChainableTypeChecker(emptyFunctionThatReturnsNull);
    }
    function createArrayOfTypeChecker(typeChecker) {
      function validate(props, propName, componentName, location, propFullName) {
        if (typeof typeChecker !== 'function') {
          return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
        }
        var propValue = props[propName];
        if (!Array.isArray(propValue)) {
          var propType = getPropType(propValue);
          return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
        }
        for (var i = 0; i < propValue.length; i++) {
          var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret);
          if (error instanceof Error) {
            return error;
          }
        }
        return null;
      }
      return createChainableTypeChecker(validate);
    }
    function createElementTypeChecker() {
      function validate(props, propName, componentName, location, propFullName) {
        var propValue = props[propName];
        if (!isValidElement(propValue)) {
          var propType = getPropType(propValue);
          return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
        }
        return null;
      }
      return createChainableTypeChecker(validate);
    }
    function createElementTypeTypeChecker() {
      function validate(props, propName, componentName, location, propFullName) {
        var propValue = props[propName];
        if (!ReactIs.isValidElementType(propValue)) {
          var propType = getPropType(propValue);
          return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement type.'));
        }
        return null;
      }
      return createChainableTypeChecker(validate);
    }
    function createInstanceTypeChecker(expectedClass) {
      function validate(props, propName, componentName, location, propFullName) {
        if (!(props[propName] instanceof expectedClass)) {
          var expectedClassName = expectedClass.name || ANONYMOUS;
          var actualClassName = getClassName(props[propName]);
          return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
        }
        return null;
      }
      return createChainableTypeChecker(validate);
    }
    function createEnumTypeChecker(expectedValues) {
      if (!Array.isArray(expectedValues)) {
        if (false) {}
        return emptyFunctionThatReturnsNull;
      }
      function validate(props, propName, componentName, location, propFullName) {
        var propValue = props[propName];
        for (var i = 0; i < expectedValues.length; i++) {
          if (is(propValue, expectedValues[i])) {
            return null;
          }
        }
        var valuesString = JSON.stringify(expectedValues, function replacer(key, value) {
          var type = getPreciseType(value);
          if (type === 'symbol') {
            return String(value);
          }
          return value;
        });
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + String(propValue) + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
      }
      return createChainableTypeChecker(validate);
    }
    function createObjectOfTypeChecker(typeChecker) {
      function validate(props, propName, componentName, location, propFullName) {
        if (typeof typeChecker !== 'function') {
          return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
        }
        var propValue = props[propName];
        var propType = getPropType(propValue);
        if (propType !== 'object') {
          return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
        }
        for (var key in propValue) {
          if (has(propValue, key)) {
            var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
            if (error instanceof Error) {
              return error;
            }
          }
        }
        return null;
      }
      return createChainableTypeChecker(validate);
    }
    function createUnionTypeChecker(arrayOfTypeCheckers) {
      if (!Array.isArray(arrayOfTypeCheckers)) {
         false ? 0 : void 0;
        return emptyFunctionThatReturnsNull;
      }
      for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
        var checker = arrayOfTypeCheckers[i];
        if (typeof checker !== 'function') {
          printWarning('Invalid argument supplied to oneOfType. Expected an array of check functions, but ' + 'received ' + getPostfixForTypeWarning(checker) + ' at index ' + i + '.');
          return emptyFunctionThatReturnsNull;
        }
      }
      function validate(props, propName, componentName, location, propFullName) {
        var expectedTypes = [];
        for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
          var checker = arrayOfTypeCheckers[i];
          var checkerResult = checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret);
          if (checkerResult == null) {
            return null;
          }
          if (checkerResult.data && has(checkerResult.data, 'expectedType')) {
            expectedTypes.push(checkerResult.data.expectedType);
          }
        }
        var expectedTypesMessage = expectedTypes.length > 0 ? ', expected one of type [' + expectedTypes.join(', ') + ']' : '';
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`' + expectedTypesMessage + '.'));
      }
      return createChainableTypeChecker(validate);
    }
    function createNodeChecker() {
      function validate(props, propName, componentName, location, propFullName) {
        if (!isNode(props[propName])) {
          return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
        }
        return null;
      }
      return createChainableTypeChecker(validate);
    }
    function invalidValidatorError(componentName, location, propFullName, key, type) {
      return new PropTypeError((componentName || 'React class') + ': ' + location + ' type `' + propFullName + '.' + key + '` is invalid; ' + 'it must be a function, usually from the `prop-types` package, but received `' + type + '`.');
    }
    function createShapeTypeChecker(shapeTypes) {
      function validate(props, propName, componentName, location, propFullName) {
        var propValue = props[propName];
        var propType = getPropType(propValue);
        if (propType !== 'object') {
          return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
        }
        for (var key in shapeTypes) {
          var checker = shapeTypes[key];
          if (typeof checker !== 'function') {
            return invalidValidatorError(componentName, location, propFullName, key, getPreciseType(checker));
          }
          var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
          if (error) {
            return error;
          }
        }
        return null;
      }
      return createChainableTypeChecker(validate);
    }
    function createStrictShapeTypeChecker(shapeTypes) {
      function validate(props, propName, componentName, location, propFullName) {
        var propValue = props[propName];
        var propType = getPropType(propValue);
        if (propType !== 'object') {
          return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
        }
        // We need to check all keys in case some are required but missing from props.
        var allKeys = assign({}, props[propName], shapeTypes);
        for (var key in allKeys) {
          var checker = shapeTypes[key];
          if (has(shapeTypes, key) && typeof checker !== 'function') {
            return invalidValidatorError(componentName, location, propFullName, key, getPreciseType(checker));
          }
          if (!checker) {
            return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` key `' + key + '` supplied to `' + componentName + '`.' + '\nBad object: ' + JSON.stringify(props[propName], null, '  ') + '\nValid keys: ' + JSON.stringify(Object.keys(shapeTypes), null, '  '));
          }
          var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
          if (error) {
            return error;
          }
        }
        return null;
      }
      return createChainableTypeChecker(validate);
    }
    function isNode(propValue) {
      switch (typeof propValue) {
        case 'number':
        case 'string':
        case 'undefined':
          return true;
        case 'boolean':
          return !propValue;
        case 'object':
          if (Array.isArray(propValue)) {
            return propValue.every(isNode);
          }
          if (propValue === null || isValidElement(propValue)) {
            return true;
          }
          var iteratorFn = getIteratorFn(propValue);
          if (iteratorFn) {
            var iterator = iteratorFn.call(propValue);
            var step;
            if (iteratorFn !== propValue.entries) {
              while (!(step = iterator.next()).done) {
                if (!isNode(step.value)) {
                  return false;
                }
              }
            } else {
              // Iterator will provide entry [k,v] tuples rather than values.
              while (!(step = iterator.next()).done) {
                var entry = step.value;
                if (entry) {
                  if (!isNode(entry[1])) {
                    return false;
                  }
                }
              }
            }
          } else {
            return false;
          }
          return true;
        default:
          return false;
      }
    }
    function isSymbol(propType, propValue) {
      // Native Symbol.
      if (propType === 'symbol') {
        return true;
      }

      // falsy value can't be a Symbol
      if (!propValue) {
        return false;
      }

      // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
      if (propValue['@@toStringTag'] === 'Symbol') {
        return true;
      }

      // Fallback for non-spec compliant Symbols which are polyfilled.
      if (typeof Symbol === 'function' && propValue instanceof Symbol) {
        return true;
      }
      return false;
    }

    // Equivalent of `typeof` but with special handling for array and regexp.
    function getPropType(propValue) {
      var propType = typeof propValue;
      if (Array.isArray(propValue)) {
        return 'array';
      }
      if (propValue instanceof RegExp) {
        // Old webkits (at least until Android 4.0) return 'function' rather than
        // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
        // passes PropTypes.object.
        return 'object';
      }
      if (isSymbol(propType, propValue)) {
        return 'symbol';
      }
      return propType;
    }

    // This handles more types than `getPropType`. Only used for error messages.
    // See `createPrimitiveTypeChecker`.
    function getPreciseType(propValue) {
      if (typeof propValue === 'undefined' || propValue === null) {
        return '' + propValue;
      }
      var propType = getPropType(propValue);
      if (propType === 'object') {
        if (propValue instanceof Date) {
          return 'date';
        } else if (propValue instanceof RegExp) {
          return 'regexp';
        }
      }
      return propType;
    }

    // Returns a string that is postfixed to a warning about an invalid type.
    // For example, "undefined" or "of type array"
    function getPostfixForTypeWarning(value) {
      var type = getPreciseType(value);
      switch (type) {
        case 'array':
        case 'object':
          return 'an ' + type;
        case 'boolean':
        case 'date':
        case 'regexp':
          return 'a ' + type;
        default:
          return type;
      }
    }

    // Returns class name of the object, if any.
    function getClassName(propValue) {
      if (!propValue.constructor || !propValue.constructor.name) {
        return ANONYMOUS;
      }
      return propValue.constructor.name;
    }
    ReactPropTypes.checkPropTypes = checkPropTypes;
    ReactPropTypes.resetWarningCache = checkPropTypes.resetWarningCache;
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
  };
  return factoryWithTypeCheckers;
}

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var factoryWithThrowingShims;
var hasRequiredFactoryWithThrowingShims;
function requireFactoryWithThrowingShims() {
  if (hasRequiredFactoryWithThrowingShims) return factoryWithThrowingShims;
  hasRequiredFactoryWithThrowingShims = 1;
  var ReactPropTypesSecret = requireReactPropTypesSecret();
  function emptyFunction() {}
  function emptyFunctionWithReset() {}
  emptyFunctionWithReset.resetWarningCache = emptyFunction;
  factoryWithThrowingShims = function () {
    function shim(props, propName, componentName, location, propFullName, secret) {
      if (secret === ReactPropTypesSecret) {
        // It is still safe when called from React.
        return;
      }
      var err = new Error('Calling PropTypes validators directly is not supported by the `prop-types` package. ' + 'Use PropTypes.checkPropTypes() to call them. ' + 'Read more at http://fb.me/use-check-prop-types');
      err.name = 'Invariant Violation';
      throw err;
    }
    shim.isRequired = shim;
    function getShim() {
      return shim;
    }
    // Important!
    // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
    var ReactPropTypes = {
      array: shim,
      bigint: shim,
      bool: shim,
      func: shim,
      number: shim,
      object: shim,
      string: shim,
      symbol: shim,
      any: shim,
      arrayOf: getShim,
      element: shim,
      elementType: shim,
      instanceOf: getShim,
      node: shim,
      objectOf: getShim,
      oneOf: getShim,
      oneOfType: getShim,
      shape: getShim,
      exact: getShim,
      checkPropTypes: emptyFunctionWithReset,
      resetWarningCache: emptyFunction
    };
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
  };
  return factoryWithThrowingShims;
}

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
if (false) { var throwOnDirectAccess, ReactIs; } else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  propTypes.exports = requireFactoryWithThrowingShims()();
}
var propTypesExports = propTypes.exports;
var PropTypes = /*@__PURE__*/(/* unused pure expression or super */ null && (getDefaultExportFromCjs$1(propTypesExports)));

/**
 * Checks if a given element has a CSS class.
 * 
 * @param element the element
 * @param className the CSS class name
 */
function hasClass(element, className) {
  if (element.classList) return !!className && element.classList.contains(className);
  return (" " + (element.className.baseVal || element.className) + " ").indexOf(" " + className + " ") !== -1;
}

/**
 * Adds a CSS class to a given element.
 * 
 * @param element the element
 * @param className the CSS class name
 */

function addClass(element, className) {
  if (element.classList) element.classList.add(className);else if (!hasClass(element, className)) if (typeof element.className === 'string') element.className = element.className + " " + className;else element.setAttribute('class', (element.className && element.className.baseVal || '') + " " + className);
}

function replaceClassName(origClass, classToRemove) {
  return origClass.replace(new RegExp("(^|\\s)" + classToRemove + "(?:\\s|$)", 'g'), '$1').replace(/\s+/g, ' ').replace(/^\s*|\s*$/g, '');
}
/**
 * Removes a CSS class from a given element.
 * 
 * @param element the element
 * @param className the CSS class name
 */

function removeClass$1(element, className) {
  if (element.classList) {
    element.classList.remove(className);
  } else if (typeof element.className === 'string') {
    element.className = replaceClassName(element.className, className);
  } else {
    element.setAttribute('class', replaceClassName(element.className && element.className.baseVal || '', className));
  }
}

var config = {
  disabled: false
};

var timeoutsShape =  false ? 0 : null;
var classNamesShape =  false ? 0 : null;

var TransitionGroupContext = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createContext(null);

var forceReflow = function forceReflow(node) {
  return node.scrollTop;
};

var UNMOUNTED = 'unmounted';
var EXITED = 'exited';
var ENTERING = 'entering';
var ENTERED = 'entered';
var EXITING = 'exiting';
/**
 * The Transition component lets you describe a transition from one component
 * state to another _over time_ with a simple declarative API. Most commonly
 * it's used to animate the mounting and unmounting of a component, but can also
 * be used to describe in-place transition states as well.
 *
 * ---
 *
 * **Note**: `Transition` is a platform-agnostic base component. If you're using
 * transitions in CSS, you'll probably want to use
 * [`CSSTransition`](https://reactcommunity.org/react-transition-group/css-transition)
 * instead. It inherits all the features of `Transition`, but contains
 * additional features necessary to play nice with CSS transitions (hence the
 * name of the component).
 *
 * ---
 *
 * By default the `Transition` component does not alter the behavior of the
 * component it renders, it only tracks "enter" and "exit" states for the
 * components. It's up to you to give meaning and effect to those states. For
 * example we can add styles to a component when it enters or exits:
 *
 * ```jsx
 * import { Transition } from 'react-transition-group';
 *
 * const duration = 300;
 *
 * const defaultStyle = {
 *   transition: `opacity ${duration}ms ease-in-out`,
 *   opacity: 0,
 * }
 *
 * const transitionStyles = {
 *   entering: { opacity: 1 },
 *   entered:  { opacity: 1 },
 *   exiting:  { opacity: 0 },
 *   exited:  { opacity: 0 },
 * };
 *
 * const Fade = ({ in: inProp }) => (
 *   <Transition in={inProp} timeout={duration}>
 *     {state => (
 *       <div style={{
 *         ...defaultStyle,
 *         ...transitionStyles[state]
 *       }}>
 *         I'm a fade Transition!
 *       </div>
 *     )}
 *   </Transition>
 * );
 * ```
 *
 * There are 4 main states a Transition can be in:
 *  - `'entering'`
 *  - `'entered'`
 *  - `'exiting'`
 *  - `'exited'`
 *
 * Transition state is toggled via the `in` prop. When `true` the component
 * begins the "Enter" stage. During this stage, the component will shift from
 * its current transition state, to `'entering'` for the duration of the
 * transition and then to the `'entered'` stage once it's complete. Let's take
 * the following example (we'll use the
 * [useState](https://reactjs.org/docs/hooks-reference.html#usestate) hook):
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <Transition in={inProp} timeout={500}>
 *         {state => (
 *           // ...
 *         )}
 *       </Transition>
 *       <button onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the button is clicked the component will shift to the `'entering'` state
 * and stay there for 500ms (the value of `timeout`) before it finally switches
 * to `'entered'`.
 *
 * When `in` is `false` the same thing happens except the state moves from
 * `'exiting'` to `'exited'`.
 */

var Transition = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(Transition, _React$Component);
  function Transition(props, context) {
    var _this;
    _this = _React$Component.call(this, props, context) || this;
    var parentGroup = context; // In the context of a TransitionGroup all enters are really appears

    var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;
    var initialStatus;
    _this.appearStatus = null;
    if (props.in) {
      if (appear) {
        initialStatus = EXITED;
        _this.appearStatus = ENTERING;
      } else {
        initialStatus = ENTERED;
      }
    } else {
      if (props.unmountOnExit || props.mountOnEnter) {
        initialStatus = UNMOUNTED;
      } else {
        initialStatus = EXITED;
      }
    }
    _this.state = {
      status: initialStatus
    };
    _this.nextCallback = null;
    return _this;
  }
  Transition.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
    var nextIn = _ref.in;
    if (nextIn && prevState.status === UNMOUNTED) {
      return {
        status: EXITED
      };
    }
    return null;
  } // getSnapshotBeforeUpdate(prevProps) {
  //   let nextStatus = null
  //   if (prevProps !== this.props) {
  //     const { status } = this.state
  //     if (this.props.in) {
  //       if (status !== ENTERING && status !== ENTERED) {
  //         nextStatus = ENTERING
  //       }
  //     } else {
  //       if (status === ENTERING || status === ENTERED) {
  //         nextStatus = EXITING
  //       }
  //     }
  //   }
  //   return { nextStatus }
  // }
  ;
  var _proto = Transition.prototype;
  _proto.componentDidMount = function componentDidMount() {
    this.updateStatus(true, this.appearStatus);
  };
  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    var nextStatus = null;
    if (prevProps !== this.props) {
      var status = this.state.status;
      if (this.props.in) {
        if (status !== ENTERING && status !== ENTERED) {
          nextStatus = ENTERING;
        }
      } else {
        if (status === ENTERING || status === ENTERED) {
          nextStatus = EXITING;
        }
      }
    }
    this.updateStatus(false, nextStatus);
  };
  _proto.componentWillUnmount = function componentWillUnmount() {
    this.cancelNextCallback();
  };
  _proto.getTimeouts = function getTimeouts() {
    var timeout = this.props.timeout;
    var exit, enter, appear;
    exit = enter = appear = timeout;
    if (timeout != null && typeof timeout !== 'number') {
      exit = timeout.exit;
      enter = timeout.enter; // TODO: remove fallback for next major

      appear = timeout.appear !== undefined ? timeout.appear : enter;
    }
    return {
      exit: exit,
      enter: enter,
      appear: appear
    };
  };
  _proto.updateStatus = function updateStatus(mounting, nextStatus) {
    if (mounting === void 0) {
      mounting = false;
    }
    if (nextStatus !== null) {
      // nextStatus will always be ENTERING or EXITING.
      this.cancelNextCallback();
      if (nextStatus === ENTERING) {
        if (this.props.unmountOnExit || this.props.mountOnEnter) {
          var node = this.props.nodeRef ? this.props.nodeRef.current : react_dom__WEBPACK_IMPORTED_MODULE_3__.findDOMNode(this); // https://github.com/reactjs/react-transition-group/pull/749
          // With unmountOnExit or mountOnEnter, the enter animation should happen at the transition between `exited` and `entering`.
          // To make the animation happen,  we have to separate each rendering and avoid being processed as batched.

          if (node) forceReflow(node);
        }
        this.performEnter(mounting);
      } else {
        this.performExit();
      }
    } else if (this.props.unmountOnExit && this.state.status === EXITED) {
      this.setState({
        status: UNMOUNTED
      });
    }
  };
  _proto.performEnter = function performEnter(mounting) {
    var _this2 = this;
    var enter = this.props.enter;
    var appearing = this.context ? this.context.isMounting : mounting;
    var _ref2 = this.props.nodeRef ? [appearing] : [react_dom__WEBPACK_IMPORTED_MODULE_3__.findDOMNode(this), appearing],
      maybeNode = _ref2[0],
      maybeAppearing = _ref2[1];
    var timeouts = this.getTimeouts();
    var enterTimeout = appearing ? timeouts.appear : timeouts.enter; // no enter animation skip right to ENTERED
    // if we are mounting and running this it means appear _must_ be set

    if (!mounting && !enter || config.disabled) {
      this.safeSetState({
        status: ENTERED
      }, function () {
        _this2.props.onEntered(maybeNode);
      });
      return;
    }
    this.props.onEnter(maybeNode, maybeAppearing);
    this.safeSetState({
      status: ENTERING
    }, function () {
      _this2.props.onEntering(maybeNode, maybeAppearing);
      _this2.onTransitionEnd(enterTimeout, function () {
        _this2.safeSetState({
          status: ENTERED
        }, function () {
          _this2.props.onEntered(maybeNode, maybeAppearing);
        });
      });
    });
  };
  _proto.performExit = function performExit() {
    var _this3 = this;
    var exit = this.props.exit;
    var timeouts = this.getTimeouts();
    var maybeNode = this.props.nodeRef ? undefined : react_dom__WEBPACK_IMPORTED_MODULE_3__.findDOMNode(this); // no exit animation skip right to EXITED

    if (!exit || config.disabled) {
      this.safeSetState({
        status: EXITED
      }, function () {
        _this3.props.onExited(maybeNode);
      });
      return;
    }
    this.props.onExit(maybeNode);
    this.safeSetState({
      status: EXITING
    }, function () {
      _this3.props.onExiting(maybeNode);
      _this3.onTransitionEnd(timeouts.exit, function () {
        _this3.safeSetState({
          status: EXITED
        }, function () {
          _this3.props.onExited(maybeNode);
        });
      });
    });
  };
  _proto.cancelNextCallback = function cancelNextCallback() {
    if (this.nextCallback !== null) {
      this.nextCallback.cancel();
      this.nextCallback = null;
    }
  };
  _proto.safeSetState = function safeSetState(nextState, callback) {
    // This shouldn't be necessary, but there are weird race conditions with
    // setState callbacks and unmounting in testing, so always make sure that
    // we can cancel any pending setState callbacks after we unmount.
    callback = this.setNextCallback(callback);
    this.setState(nextState, callback);
  };
  _proto.setNextCallback = function setNextCallback(callback) {
    var _this4 = this;
    var active = true;
    this.nextCallback = function (event) {
      if (active) {
        active = false;
        _this4.nextCallback = null;
        callback(event);
      }
    };
    this.nextCallback.cancel = function () {
      active = false;
    };
    return this.nextCallback;
  };
  _proto.onTransitionEnd = function onTransitionEnd(timeout, handler) {
    this.setNextCallback(handler);
    var node = this.props.nodeRef ? this.props.nodeRef.current : react_dom__WEBPACK_IMPORTED_MODULE_3__.findDOMNode(this);
    var doesNotHaveTimeoutOrListener = timeout == null && !this.props.addEndListener;
    if (!node || doesNotHaveTimeoutOrListener) {
      setTimeout(this.nextCallback, 0);
      return;
    }
    if (this.props.addEndListener) {
      var _ref3 = this.props.nodeRef ? [this.nextCallback] : [node, this.nextCallback],
        maybeNode = _ref3[0],
        maybeNextCallback = _ref3[1];
      this.props.addEndListener(maybeNode, maybeNextCallback);
    }
    if (timeout != null) {
      setTimeout(this.nextCallback, timeout);
    }
  };
  _proto.render = function render() {
    var status = this.state.status;
    if (status === UNMOUNTED) {
      return null;
    }
    var _this$props = this.props,
      children = _this$props.children;
      _this$props.in;
      _this$props.mountOnEnter;
      _this$props.unmountOnExit;
      _this$props.appear;
      _this$props.enter;
      _this$props.exit;
      _this$props.timeout;
      _this$props.addEndListener;
      _this$props.onEnter;
      _this$props.onEntering;
      _this$props.onEntered;
      _this$props.onExit;
      _this$props.onExiting;
      _this$props.onExited;
      _this$props.nodeRef;
      var childProps = _objectWithoutPropertiesLoose(_this$props, ["children", "in", "mountOnEnter", "unmountOnExit", "appear", "enter", "exit", "timeout", "addEndListener", "onEnter", "onEntering", "onEntered", "onExit", "onExiting", "onExited", "nodeRef"]);
    return /*#__PURE__*/(
      // allows for nested Transitions
      react__WEBPACK_IMPORTED_MODULE_0__.createElement(TransitionGroupContext.Provider, {
        value: null
      }, typeof children === 'function' ? children(status, childProps) : /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.cloneElement(react__WEBPACK_IMPORTED_MODULE_0__.Children.only(children), childProps))
    );
  };
  return Transition;
}(react__WEBPACK_IMPORTED_MODULE_0__.Component);
Transition.contextType = TransitionGroupContext;
Transition.propTypes =  false ? 0 : {}; // Name the function so it is clearer in the documentation

function noop$2() {}
Transition.defaultProps = {
  in: false,
  mountOnEnter: false,
  unmountOnExit: false,
  appear: false,
  enter: true,
  exit: true,
  onEnter: noop$2,
  onEntering: noop$2,
  onEntered: noop$2,
  onExit: noop$2,
  onExiting: noop$2,
  onExited: noop$2
};
Transition.UNMOUNTED = UNMOUNTED;
Transition.EXITED = EXITED;
Transition.ENTERING = ENTERING;
Transition.ENTERED = ENTERED;
Transition.EXITING = EXITING;
var Transition$1 = Transition;

var _addClass = function addClass$1(node, classes) {
  return node && classes && classes.split(' ').forEach(function (c) {
    return addClass(node, c);
  });
};
var removeClass = function removeClass(node, classes) {
  return node && classes && classes.split(' ').forEach(function (c) {
    return removeClass$1(node, c);
  });
};
/**
 * A transition component inspired by the excellent
 * [ng-animate](https://docs.angularjs.org/api/ngAnimate) library, you should
 * use it if you're using CSS transitions or animations. It's built upon the
 * [`Transition`](https://reactcommunity.org/react-transition-group/transition)
 * component, so it inherits all of its props.
 *
 * `CSSTransition` applies a pair of class names during the `appear`, `enter`,
 * and `exit` states of the transition. The first class is applied and then a
 * second `*-active` class in order to activate the CSS transition. After the
 * transition, matching `*-done` class names are applied to persist the
 * transition state.
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <CSSTransition in={inProp} timeout={200} classNames="my-node">
 *         <div>
 *           {"I'll receive my-node-* classes"}
 *         </div>
 *       </CSSTransition>
 *       <button type="button" onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the `in` prop is set to `true`, the child component will first receive
 * the class `example-enter`, then the `example-enter-active` will be added in
 * the next tick. `CSSTransition` [forces a
 * reflow](https://github.com/reactjs/react-transition-group/blob/5007303e729a74be66a21c3e2205e4916821524b/src/CSSTransition.js#L208-L215)
 * between before adding the `example-enter-active`. This is an important trick
 * because it allows us to transition between `example-enter` and
 * `example-enter-active` even though they were added immediately one after
 * another. Most notably, this is what makes it possible for us to animate
 * _appearance_.
 *
 * ```css
 * .my-node-enter {
 *   opacity: 0;
 * }
 * .my-node-enter-active {
 *   opacity: 1;
 *   transition: opacity 200ms;
 * }
 * .my-node-exit {
 *   opacity: 1;
 * }
 * .my-node-exit-active {
 *   opacity: 0;
 *   transition: opacity 200ms;
 * }
 * ```
 *
 * `*-active` classes represent which styles you want to animate **to**, so it's
 * important to add `transition` declaration only to them, otherwise transitions
 * might not behave as intended! This might not be obvious when the transitions
 * are symmetrical, i.e. when `*-enter-active` is the same as `*-exit`, like in
 * the example above (minus `transition`), but it becomes apparent in more
 * complex transitions.
 *
 * **Note**: If you're using the
 * [`appear`](http://reactcommunity.org/react-transition-group/transition#Transition-prop-appear)
 * prop, make sure to define styles for `.appear-*` classes as well.
 */

var CSSTransition = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(CSSTransition, _React$Component);
  function CSSTransition() {
    var _this;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
    _this.appliedClasses = {
      appear: {},
      enter: {},
      exit: {}
    };
    _this.onEnter = function (maybeNode, maybeAppearing) {
      var _this$resolveArgument = _this.resolveArguments(maybeNode, maybeAppearing),
        node = _this$resolveArgument[0],
        appearing = _this$resolveArgument[1];
      _this.removeClasses(node, 'exit');
      _this.addClass(node, appearing ? 'appear' : 'enter', 'base');
      if (_this.props.onEnter) {
        _this.props.onEnter(maybeNode, maybeAppearing);
      }
    };
    _this.onEntering = function (maybeNode, maybeAppearing) {
      var _this$resolveArgument2 = _this.resolveArguments(maybeNode, maybeAppearing),
        node = _this$resolveArgument2[0],
        appearing = _this$resolveArgument2[1];
      var type = appearing ? 'appear' : 'enter';
      _this.addClass(node, type, 'active');
      if (_this.props.onEntering) {
        _this.props.onEntering(maybeNode, maybeAppearing);
      }
    };
    _this.onEntered = function (maybeNode, maybeAppearing) {
      var _this$resolveArgument3 = _this.resolveArguments(maybeNode, maybeAppearing),
        node = _this$resolveArgument3[0],
        appearing = _this$resolveArgument3[1];
      var type = appearing ? 'appear' : 'enter';
      _this.removeClasses(node, type);
      _this.addClass(node, type, 'done');
      if (_this.props.onEntered) {
        _this.props.onEntered(maybeNode, maybeAppearing);
      }
    };
    _this.onExit = function (maybeNode) {
      var _this$resolveArgument4 = _this.resolveArguments(maybeNode),
        node = _this$resolveArgument4[0];
      _this.removeClasses(node, 'appear');
      _this.removeClasses(node, 'enter');
      _this.addClass(node, 'exit', 'base');
      if (_this.props.onExit) {
        _this.props.onExit(maybeNode);
      }
    };
    _this.onExiting = function (maybeNode) {
      var _this$resolveArgument5 = _this.resolveArguments(maybeNode),
        node = _this$resolveArgument5[0];
      _this.addClass(node, 'exit', 'active');
      if (_this.props.onExiting) {
        _this.props.onExiting(maybeNode);
      }
    };
    _this.onExited = function (maybeNode) {
      var _this$resolveArgument6 = _this.resolveArguments(maybeNode),
        node = _this$resolveArgument6[0];
      _this.removeClasses(node, 'exit');
      _this.addClass(node, 'exit', 'done');
      if (_this.props.onExited) {
        _this.props.onExited(maybeNode);
      }
    };
    _this.resolveArguments = function (maybeNode, maybeAppearing) {
      return _this.props.nodeRef ? [_this.props.nodeRef.current, maybeNode] // here `maybeNode` is actually `appearing`
      : [maybeNode, maybeAppearing];
    };
    _this.getClassNames = function (type) {
      var classNames = _this.props.classNames;
      var isStringClassNames = typeof classNames === 'string';
      var prefix = isStringClassNames && classNames ? classNames + "-" : '';
      var baseClassName = isStringClassNames ? "" + prefix + type : classNames[type];
      var activeClassName = isStringClassNames ? baseClassName + "-active" : classNames[type + "Active"];
      var doneClassName = isStringClassNames ? baseClassName + "-done" : classNames[type + "Done"];
      return {
        baseClassName: baseClassName,
        activeClassName: activeClassName,
        doneClassName: doneClassName
      };
    };
    return _this;
  }
  var _proto = CSSTransition.prototype;
  _proto.addClass = function addClass(node, type, phase) {
    var className = this.getClassNames(type)[phase + "ClassName"];
    var _this$getClassNames = this.getClassNames('enter'),
      doneClassName = _this$getClassNames.doneClassName;
    if (type === 'appear' && phase === 'done' && doneClassName) {
      className += " " + doneClassName;
    } // This is to force a repaint,
    // which is necessary in order to transition styles when adding a class name.

    if (phase === 'active') {
      if (node) forceReflow(node);
    }
    if (className) {
      this.appliedClasses[type][phase] = className;
      _addClass(node, className);
    }
  };
  _proto.removeClasses = function removeClasses(node, type) {
    var _this$appliedClasses$ = this.appliedClasses[type],
      baseClassName = _this$appliedClasses$.base,
      activeClassName = _this$appliedClasses$.active,
      doneClassName = _this$appliedClasses$.done;
    this.appliedClasses[type] = {};
    if (baseClassName) {
      removeClass(node, baseClassName);
    }
    if (activeClassName) {
      removeClass(node, activeClassName);
    }
    if (doneClassName) {
      removeClass(node, doneClassName);
    }
  };
  _proto.render = function render() {
    var _this$props = this.props;
      _this$props.classNames;
      var props = _objectWithoutPropertiesLoose(_this$props, ["classNames"]);
    return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(Transition$1, _extends$6({}, props, {
      onEnter: this.onEnter,
      onEntered: this.onEntered,
      onEntering: this.onEntering,
      onExit: this.onExit,
      onExiting: this.onExiting,
      onExited: this.onExited
    }));
  };
  return CSSTransition;
}(react__WEBPACK_IMPORTED_MODULE_0__.Component);
CSSTransition.defaultProps = {
  classNames: ''
};
CSSTransition.propTypes =  false ? 0 : {};
var CSSTransition$1 = CSSTransition;

/**
 * Given `this.props.children`, return an object mapping key to child.
 *
 * @param {*} children `this.props.children`
 * @return {object} Mapping of key to child
 */

function getChildMapping(children, mapFn) {
  var mapper = function mapper(child) {
    return mapFn && /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_0__.isValidElement)(child) ? mapFn(child) : child;
  };
  var result = Object.create(null);
  if (children) react__WEBPACK_IMPORTED_MODULE_0__.Children.map(children, function (c) {
    return c;
  }).forEach(function (child) {
    // run the map function here instead so that the key is the computed one
    result[child.key] = mapper(child);
  });
  return result;
}
/**
 * When you're adding or removing children some may be added or removed in the
 * same render pass. We want to show *both* since we want to simultaneously
 * animate elements in and out. This function takes a previous set of keys
 * and a new set of keys and merges them with its best guess of the correct
 * ordering. In the future we may expose some of the utilities in
 * ReactMultiChild to make this easy, but for now React itself does not
 * directly have this concept of the union of prevChildren and nextChildren
 * so we implement it here.
 *
 * @param {object} prev prev children as returned from
 * `ReactTransitionChildMapping.getChildMapping()`.
 * @param {object} next next children as returned from
 * `ReactTransitionChildMapping.getChildMapping()`.
 * @return {object} a key set that contains all keys in `prev` and all keys
 * in `next` in a reasonable order.
 */

function mergeChildMappings(prev, next) {
  prev = prev || {};
  next = next || {};
  function getValueForKey(key) {
    return key in next ? next[key] : prev[key];
  } // For each key of `next`, the list of keys to insert before that key in
  // the combined list

  var nextKeysPending = Object.create(null);
  var pendingKeys = [];
  for (var prevKey in prev) {
    if (prevKey in next) {
      if (pendingKeys.length) {
        nextKeysPending[prevKey] = pendingKeys;
        pendingKeys = [];
      }
    } else {
      pendingKeys.push(prevKey);
    }
  }
  var i;
  var childMapping = {};
  for (var nextKey in next) {
    if (nextKeysPending[nextKey]) {
      for (i = 0; i < nextKeysPending[nextKey].length; i++) {
        var pendingNextKey = nextKeysPending[nextKey][i];
        childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
      }
    }
    childMapping[nextKey] = getValueForKey(nextKey);
  } // Finally, add the keys which didn't appear before any key in `next`

  for (i = 0; i < pendingKeys.length; i++) {
    childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
  }
  return childMapping;
}
function getProp(child, prop, props) {
  return props[prop] != null ? props[prop] : child.props[prop];
}
function getInitialChildMapping(props, onExited) {
  return getChildMapping(props.children, function (child) {
    return /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_0__.cloneElement)(child, {
      onExited: onExited.bind(null, child),
      in: true,
      appear: getProp(child, 'appear', props),
      enter: getProp(child, 'enter', props),
      exit: getProp(child, 'exit', props)
    });
  });
}
function getNextChildMapping(nextProps, prevChildMapping, onExited) {
  var nextChildMapping = getChildMapping(nextProps.children);
  var children = mergeChildMappings(prevChildMapping, nextChildMapping);
  Object.keys(children).forEach(function (key) {
    var child = children[key];
    if (! /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_0__.isValidElement)(child)) return;
    var hasPrev = key in prevChildMapping;
    var hasNext = key in nextChildMapping;
    var prevChild = prevChildMapping[key];
    var isLeaving = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_0__.isValidElement)(prevChild) && !prevChild.props.in; // item is new (entering)

    if (hasNext && (!hasPrev || isLeaving)) {
      // console.log('entering', key)
      children[key] = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_0__.cloneElement)(child, {
        onExited: onExited.bind(null, child),
        in: true,
        exit: getProp(child, 'exit', nextProps),
        enter: getProp(child, 'enter', nextProps)
      });
    } else if (!hasNext && hasPrev && !isLeaving) {
      // item is old (exiting)
      // console.log('leaving', key)
      children[key] = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_0__.cloneElement)(child, {
        in: false
      });
    } else if (hasNext && hasPrev && /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_0__.isValidElement)(prevChild)) {
      // item hasn't changed transition states
      // copy over the last transition props;
      // console.log('unchanged', key)
      children[key] = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_0__.cloneElement)(child, {
        onExited: onExited.bind(null, child),
        in: prevChild.props.in,
        exit: getProp(child, 'exit', nextProps),
        enter: getProp(child, 'enter', nextProps)
      });
    }
  });
  return children;
}

var values = Object.values || function (obj) {
  return Object.keys(obj).map(function (k) {
    return obj[k];
  });
};
var defaultProps = {
  component: 'div',
  childFactory: function childFactory(child) {
    return child;
  }
};
/**
 * The `<TransitionGroup>` component manages a set of transition components
 * (`<Transition>` and `<CSSTransition>`) in a list. Like with the transition
 * components, `<TransitionGroup>` is a state machine for managing the mounting
 * and unmounting of components over time.
 *
 * Consider the example below. As items are removed or added to the TodoList the
 * `in` prop is toggled automatically by the `<TransitionGroup>`.
 *
 * Note that `<TransitionGroup>`  does not define any animation behavior!
 * Exactly _how_ a list item animates is up to the individual transition
 * component. This means you can mix and match animations across different list
 * items.
 */

var TransitionGroup = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(TransitionGroup, _React$Component);
  function TransitionGroup(props, context) {
    var _this;
    _this = _React$Component.call(this, props, context) || this;
    var handleExited = _this.handleExited.bind(_assertThisInitialized(_this)); // Initial children should all be entering, dependent on appear

    _this.state = {
      contextValue: {
        isMounting: true
      },
      handleExited: handleExited,
      firstRender: true
    };
    return _this;
  }
  var _proto = TransitionGroup.prototype;
  _proto.componentDidMount = function componentDidMount() {
    this.mounted = true;
    this.setState({
      contextValue: {
        isMounting: false
      }
    });
  };
  _proto.componentWillUnmount = function componentWillUnmount() {
    this.mounted = false;
  };
  TransitionGroup.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, _ref) {
    var prevChildMapping = _ref.children,
      handleExited = _ref.handleExited,
      firstRender = _ref.firstRender;
    return {
      children: firstRender ? getInitialChildMapping(nextProps, handleExited) : getNextChildMapping(nextProps, prevChildMapping, handleExited),
      firstRender: false
    };
  } // node is `undefined` when user provided `nodeRef` prop
  ;
  _proto.handleExited = function handleExited(child, node) {
    var currentChildMapping = getChildMapping(this.props.children);
    if (child.key in currentChildMapping) return;
    if (child.props.onExited) {
      child.props.onExited(node);
    }
    if (this.mounted) {
      this.setState(function (state) {
        var children = _extends$6({}, state.children);
        delete children[child.key];
        return {
          children: children
        };
      });
    }
  };
  _proto.render = function render() {
    var _this$props = this.props,
      Component = _this$props.component,
      childFactory = _this$props.childFactory,
      props = _objectWithoutPropertiesLoose(_this$props, ["component", "childFactory"]);
    var contextValue = this.state.contextValue;
    var children = values(this.state.children).map(childFactory);
    delete props.appear;
    delete props.enter;
    delete props.exit;
    if (Component === null) {
      return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(TransitionGroupContext.Provider, {
        value: contextValue
      }, children);
    }
    return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(TransitionGroupContext.Provider, {
      value: contextValue
    }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(Component, props, children));
  };
  return TransitionGroup;
}(react__WEBPACK_IMPORTED_MODULE_0__.Component);
TransitionGroup.propTypes =  false ? 0 : {};
TransitionGroup.defaultProps = defaultProps;
var TransitionGroup$1 = TransitionGroup;

var _leaveRenders, _enterRenders;
function areChildrenDifferent(oldChildren, newChildren) {
  if (oldChildren === newChildren) return false;
  if (/*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.isValidElement(oldChildren) && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.isValidElement(newChildren) && oldChildren.key != null && oldChildren.key === newChildren.key) {
    return false;
  }
  return true;
}
/**
 * Enum of modes for SwitchTransition component
 * @enum { string }
 */

var modes = {
  out: 'out-in',
  in: 'in-out'
};
var callHook = function callHook(element, name, cb) {
  return function () {
    var _element$props;
    element.props[name] && (_element$props = element.props)[name].apply(_element$props, arguments);
    cb();
  };
};
var leaveRenders = (_leaveRenders = {}, _leaveRenders[modes.out] = function (_ref) {
  var current = _ref.current,
    changeState = _ref.changeState;
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.cloneElement(current, {
    in: false,
    onExited: callHook(current, 'onExited', function () {
      changeState(ENTERING, null);
    })
  });
}, _leaveRenders[modes.in] = function (_ref2) {
  var current = _ref2.current,
    changeState = _ref2.changeState,
    children = _ref2.children;
  return [current, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.cloneElement(children, {
    in: true,
    onEntered: callHook(children, 'onEntered', function () {
      changeState(ENTERING);
    })
  })];
}, _leaveRenders);
var enterRenders = (_enterRenders = {}, _enterRenders[modes.out] = function (_ref3) {
  var children = _ref3.children,
    changeState = _ref3.changeState;
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.cloneElement(children, {
    in: true,
    onEntered: callHook(children, 'onEntered', function () {
      changeState(ENTERED, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.cloneElement(children, {
        in: true
      }));
    })
  });
}, _enterRenders[modes.in] = function (_ref4) {
  var current = _ref4.current,
    children = _ref4.children,
    changeState = _ref4.changeState;
  return [/*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.cloneElement(current, {
    in: false,
    onExited: callHook(current, 'onExited', function () {
      changeState(ENTERED, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.cloneElement(children, {
        in: true
      }));
    })
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.cloneElement(children, {
    in: true
  })];
}, _enterRenders);
/**
 * A transition component inspired by the [vue transition modes](https://vuejs.org/v2/guide/transitions.html#Transition-Modes).
 * You can use it when you want to control the render between state transitions.
 * Based on the selected mode and the child's key which is the `Transition` or `CSSTransition` component, the `SwitchTransition` makes a consistent transition between them.
 *
 * If the `out-in` mode is selected, the `SwitchTransition` waits until the old child leaves and then inserts a new child.
 * If the `in-out` mode is selected, the `SwitchTransition` inserts a new child first, waits for the new child to enter and then removes the old child.
 *
 * **Note**: If you want the animation to happen simultaneously
 * (that is, to have the old child removed and a new child inserted **at the same time**),
 * you should use
 * [`TransitionGroup`](https://reactcommunity.org/react-transition-group/transition-group)
 * instead.
 *
 * ```jsx
 * function App() {
 *  const [state, setState] = useState(false);
 *  return (
 *    <SwitchTransition>
 *      <CSSTransition
 *        key={state ? "Goodbye, world!" : "Hello, world!"}
 *        addEndListener={(node, done) => node.addEventListener("transitionend", done, false)}
 *        classNames='fade'
 *      >
 *        <button onClick={() => setState(state => !state)}>
 *          {state ? "Goodbye, world!" : "Hello, world!"}
 *        </button>
 *      </CSSTransition>
 *    </SwitchTransition>
 *  );
 * }
 * ```
 *
 * ```css
 * .fade-enter{
 *    opacity: 0;
 * }
 * .fade-exit{
 *    opacity: 1;
 * }
 * .fade-enter-active{
 *    opacity: 1;
 * }
 * .fade-exit-active{
 *    opacity: 0;
 * }
 * .fade-enter-active,
 * .fade-exit-active{
 *    transition: opacity 500ms;
 * }
 * ```
 */

var SwitchTransition = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(SwitchTransition, _React$Component);
  function SwitchTransition() {
    var _this;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
    _this.state = {
      status: ENTERED,
      current: null
    };
    _this.appeared = false;
    _this.changeState = function (status, current) {
      if (current === void 0) {
        current = _this.state.current;
      }
      _this.setState({
        status: status,
        current: current
      });
    };
    return _this;
  }
  var _proto = SwitchTransition.prototype;
  _proto.componentDidMount = function componentDidMount() {
    this.appeared = true;
  };
  SwitchTransition.getDerivedStateFromProps = function getDerivedStateFromProps(props, state) {
    if (props.children == null) {
      return {
        current: null
      };
    }
    if (state.status === ENTERING && props.mode === modes.in) {
      return {
        status: ENTERING
      };
    }
    if (state.current && areChildrenDifferent(state.current, props.children)) {
      return {
        status: EXITING
      };
    }
    return {
      current: /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.cloneElement(props.children, {
        in: true
      })
    };
  };
  _proto.render = function render() {
    var _this$props = this.props,
      children = _this$props.children,
      mode = _this$props.mode,
      _this$state = this.state,
      status = _this$state.status,
      current = _this$state.current;
    var data = {
      children: children,
      current: current,
      changeState: this.changeState,
      status: status
    };
    var component;
    switch (status) {
      case ENTERING:
        component = enterRenders[mode](data);
        break;
      case EXITING:
        component = leaveRenders[mode](data);
        break;
      case ENTERED:
        component = current;
    }
    return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(TransitionGroupContext.Provider, {
      value: {
        isMounting: !this.appeared
      }
    }, component);
  };
  return SwitchTransition;
}(react__WEBPACK_IMPORTED_MODULE_0__.Component);
SwitchTransition.propTypes =  false ? 0 : {};
SwitchTransition.defaultProps = {
  mode: modes.out
};
var SwitchTransition$1 = SwitchTransition;

function _EMOTION_STRINGIFIED_CSS_ERROR__$w() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
const DEFAULT_ARROW = {
  width: 14,
  height: 10,
  color: theme => theme.background.base
};
const InfoTip = ({
  children,
  renderOpener,
  onOpenChange,
  openOnHover,
  offsetTop = 4,
  arrow: arrowProps = {},
  forceOpen,
  forceClose,
  contentStyle
}) => {
  const buttonRef = useRef(null);
  const [arrowRef, setArrowRef] = useState(null);
  const [ref, setRef] = useState(null);
  const [isOpenState, setIsOpenState] = useState(false);
  const arrow = useMemo(() => ({
    ...DEFAULT_ARROW,
    ...arrowProps
  }), [arrowProps]);
  const {
    styles,
    attributes,
    state
  } = usePopper(buttonRef.current, ref, {
    placement: 'bottom',
    modifiers: [{
      name: 'offset',
      enabled: true,
      options: {
        offset: [0, offsetTop + arrow.height]
      }
    }, {
      name: 'arrow',
      enabled: true,
      options: {
        element: arrowRef
      }
    }]
  });
  const handleOpen = useCallback(() => {
    setIsOpenState(true);
    onOpenChange?.(true);
  }, [onOpenChange]);
  const handleClose = useCallback(() => {
    setIsOpenState(false);
    onOpenChange?.(false);
  }, [onOpenChange]);
  const handleToggle = useCallback(() => {
    if (isOpenState) {
      handleClose();
      return;
    }
    handleOpen();
  }, [isOpenState, handleOpen, handleClose]);
  const handleMouseEnter = useCallback(() => {
    if (openOnHover) {
      handleOpen();
    }
  }, [openOnHover, handleOpen]);
  const handleMouseLeave = useCallback(() => {
    if (openOnHover) {
      handleClose();
    }
  }, [openOnHover, handleClose]);
  const isOpen = Boolean((isOpenState || forceOpen) && !forceClose);
  return jsxs(Fragment$1, {
    children: [jsx(ButtonWrapper, {
      ref: buttonRef,
      children: renderOpener({
        isOpen,
        onToggle: handleToggle,
        onMouseEnter: handleMouseEnter,
        onMouseLeave: handleMouseLeave
      })
    }), isOpen && jsx(CSSTransition$1, {
      in: ref !== null && isOpen,
      timeout: 200,
      classNames: {
        enterActive: 'open',
        enterDone: 'open open-active',
        appearDone: 'open',
        exit: 'exiting'
      },
      children: jsxs(Content$1, {
        ref: setRef,
        style: {
          ...styles['popper'],
          ...contentStyle
        },
        onMouseEnter: handleMouseEnter,
        onMouseLeave: handleMouseLeave,
        offset: offsetTop + arrow.height,
        className: state?.placement ?? 'auto',
        ...attributes['popper'],
        children: [jsx(Arrow$1, {
          ref: setArrowRef,
          style: styles['arrow'],
          placement: state?.placement ?? 'auto',
          arrow: arrow,
          "data-popper-arrow": true,
          className: state?.placement
        }), jsx(ChildrenWrapper, {
          style: styles['offset'],
          children: children
        })]
      })
    })]
  });
};
const ButtonWrapper = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)("div",  true ? {
  target: "et5x4au3"
} : 0)( true ? {
  name: "1kx8xpu",
  styles: "line-height:0;display:inline-block"
} : 0);

// 화살표 팁과 Content 영역 사이에 마우스가 위치해도 열림 상태를 유지하기 위한 레이어
const cssBackLayer =  true ? {
  name: "zw5q4a",
  styles: "content:'';width:100%;height:100%;position:absolute;left:0"
} : 0;
const Content$1 = /*#__PURE__*/(/* unused pure expression or super */ null && (_styled("div",  true ? {
  target: "et5x4au2"
} : 0)("z-index:1;&[data-popper-placement^='bottom']{&:before{", cssBackLayer, " top:", ({
  offset
}) => pxToRem(-offset), ";}}&[data-popper-placement^='top']{&:before{", cssBackLayer, " bottom:", ({
  offset
}) => pxToRem(-offset), ";}}&[data-popper-placement^='right']{&:before{", cssBackLayer, " left:", ({
  offset
}) => pxToRem(-offset), ";}}&[data-popper-placement^='left']{&:before{", cssBackLayer, " right:", ({
  offset
}) => pxToRem(-offset), ";}}visibility:hidden;opacity:0;pointer-events:none;&.open{visibility:visible;opacity:1;transform:none;transition:0.2s opacity,0.2s transform;}&.open-active{pointer-events:auto;}&.exiting{transition:visibility 0.2s,0.2s opacity,0.2s transform;}" + ( true ? "" : 0))));
const ChildrenWrapper = /*#__PURE__*/(/* unused pure expression or super */ null && (_styled("div",  true ? {
  target: "et5x4au1"
} : 0)( true ? "" : 0)));
const generateArrow = (placement, arrow, theme) => {
  if (placement.startsWith('bottom')) {
    return /*#__PURE__*/css("border-bottom:", pxToRem(arrow.height), " solid ", arrow.color(theme), ";border-left:", pxToRem(arrow.width / 2), " solid transparent;border-right:", pxToRem(arrow.width / 2), " solid transparent;" + ( true ? "" : 0),  true ? "" : 0);
  }
  if (placement.startsWith('top')) {
    return /*#__PURE__*/css("border-top:", pxToRem(arrow.height), " solid ", arrow.color(theme), ";border-left:", pxToRem(arrow.width / 2), " solid transparent;border-right:", pxToRem(arrow.width / 2), " solid transparent;" + ( true ? "" : 0),  true ? "" : 0);
  }
  if (placement.startsWith('right')) {
    return /*#__PURE__*/css("border-right:", pxToRem(arrow.height), " solid ", arrow.color(theme), ";border-bottom:", pxToRem(arrow.width / 2), " solid transparent;border-top:", pxToRem(arrow.width / 2), " solid transparent;" + ( true ? "" : 0),  true ? "" : 0);
  }
  return /*#__PURE__*/css("border-left:", pxToRem(arrow.height), " solid ", arrow.color(theme), ";border-top:", pxToRem(arrow.width / 2), " solid transparent;border-bottom:", pxToRem(arrow.width / 2), " solid transparent;" + ( true ? "" : 0),  true ? "" : 0);
};
const Arrow$1 = /*#__PURE__*/(/* unused pure expression or super */ null && (_styled("div",  true ? {
  target: "et5x4au0"
} : 0)(({
  arrow
}) => arrow && `
    width: ${pxToRem(arrow.width)};
    height: ${pxToRem(arrow.height)};`, " ", ({
  arrow
}) => `
    &[class^="bottom"] {
      top: ${pxToRem(-arrow.height)};
    }
    &[class^="top"] {
      bottom: ${pxToRem(-arrow.height)};
    }
    &[class^="right"] {
      left: ${pxToRem(-arrow.height)};
    }
    &[class^="left"] {
      right: ${pxToRem(-arrow.height)};
    }
  `, " &:after{content:'';position:absolute;width:0;height:0;left:0;", ({
  placement,
  arrow,
  theme
}) => placement && generateArrow(placement, arrow, theme), ";}" + ( true ? "" : 0))));

const useFilterTags = ({
  schema,
  query,
  onChangeQuery
}) => {
  const [tags, setTags] = useState([]);
  const serializeTags = useCallback(tags => schema.map(schemaEntry => schemaEntry.serializer.serialize).reduce((prev, serialize) => ({
    ...prev,
    ...serialize(tags)
  }), {}), [schema]);
  const deserializeTags = useCallback(() => schema.map(schemaEntry => schemaEntry.serializer.deserialize).reduce((prev, deserialize) => [...prev, ...deserialize(query)], []), [schema, query]);
  const handleChangeTags = useCallback(tags => {
    const queryParams = serializeTags(tags);
    onChangeQuery({
      ...omitBy(queryParams, value => value == null)
    });
    setTags(tags);
  }, [serializeTags, onChangeQuery]);
  useEffect(() => {
    setTags(deserializeTags());
  }, [query, deserializeTags]);
  return {
    handleChangeTags,
    tags
  };
};

const useFilterListModal = ({
  schema,
  tags,
  handleChangeTags
}) => {
  const [selectedEntryId, setSelectedEntryId] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const closeModal = useCallback(() => {
    setIsModalOpen(false);
    setSelectedEntryId(null);
  }, []);
  const activeEntry = schema.find(entry => entry.id === selectedEntryId);
  const isSelectedByQuery = entry => {
    return tags.some(tag => entry.hasTag(tag));
  };
  const showResetButton = activeEntry ? isSelectedByQuery(activeEntry) && activeEntry.config?.showResetButtonOnSelected?.mobile : schema.some(entry => isSelectedByQuery(entry) && entry.config?.showResetButtonOnSelected?.mobile);
  const reset = showResetButton ? () => {
    if (!activeEntry) {
      handleChangeTags([]);
    } else {
      handleChangeTags(tags.filter(tag => tag.id !== activeEntry.id));
    }
  } : undefined;
  return {
    reset,
    selectedEntryId,
    selectEntry: setSelectedEntryId,
    isModalOpen,
    openModal: () => setIsModalOpen(true),
    closeModal
  };
};

const defaultLocaleData = {
  filter: '필터',
  reset: '초기화',
  apply: '확인',
  showAllFilter: '전체 필터 보기'
};
const LocaleDataContext = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)(defaultLocaleData);
function LocaleDataProvider({
  children,
  data
}) {
  return jsx(LocaleDataContext.Provider, {
    value: data,
    children: children
  });
}
function useLocaleData() {
  return (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(LocaleDataContext);
}

const FilterKey = {
  /** 다중 선택 리스트 필터 ex)스타일 필터 */
  MULTI_SELECT_LIST: 'multiSelectList',
  /** 단일 선택 리스트 필터 ex)정렬 필터 */
  SINGLE_SELECT_LIST: 'singleSelectList',
  /** 범위 선택 리스트 필터 ex)예산 필터 */
  RANGE: 'range',
  /** 중첩 필터 ex)지역 필터 */
  NESTED: 'nested',
  /** 여러 필터를 그룹으로 묶어서 선택할 수 있는 필터  */
  /** 동시에 여러 필터를 선택할 수 있는 그룹 필터 ex) 컬러 필터의 벽/바닥 컬러 필터 */
  MULTI_SELECT_GROUP: 'multiSelectGroup',
  /** 그룹 필터 중 한개의 필터만 선택할 수 있는 그룹 필터 ex)컬러 필터 */
  SINGLE_SELECT_GROUP: 'singleSelectGroup',
  /** 다중 색상 선택 필터 */
  MULTI_SELECT_COLOR: 'multiSelectColor',
  /** 단일 색상 선택 필터 */
  SINGLE_SELECT_COLOR: 'singleSelectColor'
};

const ListPanelDropdownItem = ({
  buttonText,
  caption,
  onClick,
  isActive
}) => {
  return jsxs(ItemButton$1, {
    type: "button",
    onClick: onClick,
    children: [jsx(Title$2, {
      isActive: isActive,
      children: buttonText
    }), jsx(Caption$1, {
      children: caption
    })]
  });
};
const ItemButton$1 = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)("button",  true ? {
  target: "e1599rzu2"
} : 0)("width:100%;max-width:", (0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.p)(375), ";min-width:", (0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.p)(200), ";display:block;padding:", (0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.p)(13), " ", (0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.p)(15), ";color:inherit;text-align:left;cursor:pointer;", ({
  theme
}) => _bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.H`
    background: ${theme.interactive.primary1.transparent};
  `, ";" + ( true ? "" : 0));
const Title$2 = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)("span",  true ? {
  target: "e1599rzu1"
} : 0)("width:100%;", _bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.F.body1_small, ";color:", ({
  isActive,
  theme
}) => isActive ? theme.content.primary1.basic : 'inherit', ";font-weight:", ({
  isActive
}) => isActive ? 700 : 400, ";" + ( true ? "" : 0));
const Caption$1 = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)("span",  true ? {
  target: "e1599rzu0"
} : 0)("width:100%;", _bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.F.caption1, ";color:", ({
  theme
}) => theme.content.base2, ";margin:", (0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.p)(5), " 0;" + ( true ? "" : 0));

function _EMOTION_STRINGIFIED_CSS_ERROR__$v() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
const ListPanelModalItem = ({
  buttonText,
  caption,
  isActive,
  onClick,
  icon
}) => {
  return jsxs(ItemButton, {
    type: "button",
    onClick: onClick,
    isActive: isActive,
    children: [jsxs(Right$2, {
      children: [jsx(Title$1, {
        isActive: isActive,
        children: buttonText
      }), caption && jsx(Caption, {
        children: caption
      })]
    }), jsx(IconWrapper$1, {
      children: icon
    })]
  });
};
const ItemButton = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)("button",  true ? {
  target: "e1tzdgxc4"
} : 0)("width:100%;display:flex;justify-content:space-between;align-items:center;padding:", (0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.p)(10), " ", (0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.p)(13), ";background:", ({
  theme,
  isActive
}) => isActive ? theme.interactive.primary1.transparent : 'none', ";color:inherit;text-align:left;border-bottom:", (0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.p)(1), " solid ", ({
  theme
}) => theme.border, ";", ({
  theme
}) => _bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.H`
    background: ${theme.interactive.primary1.transparent};
  `, ";" + ( true ? "" : 0));
const Right$2 = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)("span",  true ? {
  target: "e1tzdgxc3"
} : 0)( true ? {
  name: "b936mu",
  styles: "flex-basis:max-content;flex-shrink:0"
} : 0);
const Title$1 = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)("span",  true ? {
  target: "e1tzdgxc2"
} : 0)(_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.F.body1_small, ";color:", ({
  isActive,
  theme
}) => isActive ? theme.content.primary1.basic : 'inherit', ";font-weight:", ({
  isActive
}) => isActive ? 700 : 400, ";" + ( true ? "" : 0));
const Caption = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)("span",  true ? {
  target: "e1tzdgxc1"
} : 0)("margin:", (0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.p)(5), " 0;", _bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.F.caption1, ";color:", ({
  theme
}) => theme.content.base2, ";" + ( true ? "" : 0));
const IconWrapper$1 = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)("span",  true ? {
  target: "e1tzdgxc0"
} : 0)( true ? {
  name: "pezd64",
  styles: "flex:1;display:flex;justify-content:flex-end"
} : 0);

const ListPanel = ({
  entry,
  tags,
  onChangeTags
}) => {
  const isMobile = useResponsive().breakpoint === 'mobile';
  const handleClickItem = value => {
    const newTag = {
      type: 'list',
      id: entry.id,
      value
    };
    const alreadySelectedTagIndex = tags.findIndex(tag => tag.id === newTag.id && tag.value === newTag.value);
    if (alreadySelectedTagIndex !== -1) {
      onChangeTags(tags.filter((_, index) => alreadySelectedTagIndex !== index));
      return;
    }
    if (entry.type === FilterKey.MULTI_SELECT_LIST) {
      onChangeTags([...tags, newTag]);
      return;
    }
    onChangeTags([...tags.filter(tag => tag.id !== newTag.id), newTag]);
  };

  /**
   * 쿼리 파라미터로 선택된 태그(tags)이거나 기본값으로 설정된 값인 경우 true를 반환
   */
  const isActiveItem = value => {
    const isSelected = tags.some(tag => tag.id === entry.id);
    if (!isSelected) {
      return entry.config?.defaultValue === value;
    }
    return tags.some(tag => tag.id === entry.id && tag.value === value);
  };
  const ListItem = isMobile ? ListPanelModalItem : ListPanelDropdownItem;
  return jsx(Fragment$1, {
    children: entry.options.map(option => jsx(ListItem, {
      buttonText: option.label,
      caption: option.caption,
      isActive: isActiveItem(option.value),
      onClick: () => handleClickItem(option.value)
    }, option.label))
  });
};

/**
 * 뉴턴-랩슨 방법을 사용하여 주어진 함수 `transform`이 목표 y 값 `yTarget`과 같아지도록 하는 x 값을 근사합니다.
 *
 * @param {function(number): number} transform - 근을 찾기 위한 함수.
 * @param {number} yTarget - 목표 y 값, 이 값에 해당하는 x 값을 찾고자 함.
 * @param {number} xStart - 초기 x 값 추정치.
 * @param {number} [iterations=30] - 최대 반복 횟수.
 * @param {number} [epsilon=1e-14] - 기울기의 허용 오차 (기울기가 이 값보다 작으면 반복을 중단).
 * @param {number} [tolerance=1e-7] - x 값 변화의 허용 오차 (변화가 이 값보다 작으면 반복을 중단).
 * @param {number} [derivateStep=1e-5] - 수치 미분을 위한 스텝 크기.
 * @returns {number} 근사된 x 값.
 */
function findApproximateValue(transform, yTarget, xStart, iterations = 30, epsilon = 1e-14, tolerance = 1e-7, derivateStep = 1e-5) {
  let xValue = xStart;
  for (let i = 0; i < iterations; ++i) {
    const yValue = transform(xValue) - yTarget;
    const ySlope = (transform(xValue + derivateStep) - transform(xValue)) / derivateStep;
    // 기울기가 너무 작아 계산할 수 없음.
    if (Math.abs(ySlope) < epsilon) {
      break;
    }
    const newXValue = xValue - yValue / ySlope;
    // 값이 범위 내에 있음; 반복을 종료.
    if (Math.abs(newXValue - xValue) <= tolerance * Math.abs(newXValue)) {
      break;
    }
    xValue = newXValue;
  }
  return xValue;
}

function _EMOTION_STRINGIFIED_CSS_ERROR__$u() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
const RangeSliderInput = ({
  className,
  value,
  onChange,
  dual,
  min,
  max,
  left,
  right,
  projection = x => x,
  quantize = x => x,
  step = 1,
  'aria-label': ariaLabel = ''
}) => {
  const ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
  const leftThumbRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
  const rightThumbRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
  const otherValueRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
  const dualValueRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(dual ? value : null);
  const preventClickUntilRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    dualValueRef.current = dual ? value : null;
  }, [dual, value]);
  const projectValue = (value, fallback = 0) => {
    const leftmost = projection(min);
    const rightmost = projection(max);
    if (value == null) {
      return fallback;
    }
    return (projection(value) - leftmost) / (rightmost - leftmost);
  };
  const leftPos = dual ? projectValue(value && value.min, 0) : 0;
  const rightPos = dual ? projectValue(value && value.max, 1) : projectValue(value, 0.5);
  const leftValue = dual ? value && value.min : 0;
  const rightValue = dual ? value && value.max : value;
  const getNode = clientX => {
    if (ref.current == null) {
      return null;
    }
    if (!dual) {
      return rightThumbRef.current;
    }
    const bounds = ref.current.getBoundingClientRect();
    const pos = (clientX - bounds.left) / bounds.width;
    const leftmost = projection(min);
    const rightmost = projection(max);
    const actualPos = pos * (rightmost - leftmost) + leftmost;

    // Determine which end we should use.
    const valueMin = dualValueRef.current == null || dualValueRef.current.min == null ? min : dualValueRef.current.min;
    const valueMax = dualValueRef.current == null || dualValueRef.current.max == null ? max : dualValueRef.current.max;
    const valueCenter = (projection(valueMin) + projection(valueMax)) / 2;
    if (actualPos > valueCenter) {
      return rightThumbRef.current;
    }
    return leftThumbRef.current;
  };
  const setPos = clientX => {
    if (ref.current == null) {
      return;
    }
    const bounds = ref.current.getBoundingClientRect();
    // Convert position to value using inverse function...
    const pos = (clientX - bounds.left) / bounds.width;
    const leftmost = projection(min);
    const rightmost = projection(max);
    const actualPos = pos * (rightmost - leftmost) + leftmost;
    if (!dual) {
      const newValue = findApproximateValue(projection, actualPos, min);
      let recordedValue = newValue;
      if (quantize != null) {
        recordedValue = quantize(newValue);
      }
      if (Number.isNaN(recordedValue)) {
        return;
      }
      onChange(Math.min(Math.max(recordedValue, min), max));
      return;
    }

    // Determine which end we should use.
    const valueMin = dualValueRef.current == null || dualValueRef.current.min == null ? min : dualValueRef.current.min;
    const valueMax = dualValueRef.current == null || dualValueRef.current.max == null ? max : dualValueRef.current.max;
    const valueCenter = (projection(valueMin) + projection(valueMax)) / 2;
    const newValue = findApproximateValue(projection, actualPos, min);
    let recordedValue = newValue;
    if (quantize != null) {
      recordedValue = quantize(newValue);
    }
    if (Number.isNaN(recordedValue)) {
      return;
    }
    if (otherValueRef.current == null) {
      otherValueRef.current = actualPos > valueCenter ? valueMin : valueMax;
    }
    onChange({
      min: Math.max(Math.min(otherValueRef.current, recordedValue), min),
      max: Math.min(Math.max(otherValueRef.current, recordedValue), max)
    });
  };
  const handleMouseDown = e => {
    const clientX = 'clientX' in e ? e.clientX : e.touches[0]?.clientX ?? 0;
    if ('clientX' in e) {
      e.preventDefault();
      const focusNode = getNode(clientX);
      if (focusNode != null) {
        focusNode.focus();
      }
    }
    setPos(clientX);
    ['mousemove', 'touchmove'].forEach(type => window.addEventListener(type, handleMouseMove));
    ['mouseup', 'touchend', 'touchcancel'].forEach(type => window.addEventListener(type, handleMouseUp));
  };
  const handleMouseMove = e => {
    const clientX = 'clientX' in e ? e.clientX : e.touches[0]?.clientX ?? 0;
    if ('clientX' in e) {
      e.preventDefault();
      const focusNode = getNode(clientX);
      if (focusNode != null && document.activeElement !== focusNode) {
        focusNode.focus();
      }
    }
    setPos(clientX);
  };
  const handleMouseUp = e => {
    if ('clientX' in e) {
      e.preventDefault();
    }
    otherValueRef.current = null;
    ['mousemove', 'touchmove'].forEach(type => window.removeEventListener(type, handleMouseMove));
    ['mouseup', 'touchend', 'touchcancel'].forEach(type => window.removeEventListener(type, handleMouseUp));
    preventClickUntilRef.current = Date.now() + 50;
    window.addEventListener('click', handleClickCapture, true);
  };
  const handleClickCapture = e => {
    if (preventClickUntilRef.current && Date.now() < preventClickUntilRef.current) {
      e.stopPropagation();
    }
    window.removeEventListener('click', handleClickCapture, true);
  };
  const handleKeyDown = (isMin, e) => {
    let currentValue;
    let edited = false;
    if (dual) {
      if (value == null) {
        currentValue = isMin ? min : max;
      } else {
        currentValue = value[isMin ? 'min' : 'max'];
      }
    } else {
      currentValue = value;
    }
    switch (e.code) {
      case 'ArrowDown':
      case 'ArrowLeft':
        {
          // Decrease
          e.preventDefault();
          currentValue -= step;
          edited = true;
          break;
        }
      case 'ArrowUp':
      case 'ArrowRight':
        {
          // Increase
          e.preventDefault();
          currentValue += step;
          edited = true;
          break;
        }
      case 'PageUp':
        {
          // Decrease many times
          e.preventDefault();
          currentValue -= step * 10;
          edited = true;
          break;
        }
      case 'PageDown':
        {
          // Increase many times
          e.preventDefault();
          currentValue += step * 10;
          edited = true;
          break;
        }
      case 'Home':
        {
          // Set to min
          e.preventDefault();
          currentValue = min;
          edited = true;
          break;
        }
      case 'End':
        {
          // Set to max
          e.preventDefault();
          currentValue = max;
          edited = true;
          break;
        }
    }
    if (edited) {
      currentValue = Math.min(Math.max(quantize(currentValue), min), max);
      if (dual) {
        if (isMin) {
          onChange({
            max: value?.max,
            min: Math.min(currentValue, value?.max)
          });
        } else {
          onChange({
            min: value?.min,
            max: Math.max(currentValue, value?.min)
          });
        }
      } else {
        onChange(currentValue);
      }
    }
  };
  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsxs */ .BX)("div", {
    className: className,
    children: [(0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsxs */ .BX)(Container$a, {
      onMouseDown: e => handleMouseDown(e.nativeEvent),
      onTouchStart: e => handleMouseDown(e.nativeEvent),
      children: [(0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(Background, {}), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsxs */ .BX)(BarContainer, {
        ref: ref,
        children: [(0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(Bar, {
          dual: dual,
          style: {
            left: `${leftPos * 100}%`,
            width: `${(rightPos - leftPos) * 100}%`
          }
        }), dual && (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(Thumb, {
          style: {
            left: `${leftPos * 100}%`
          },
          role: "slider",
          tabIndex: 0,
          "aria-valuemin": min,
          "aria-valuemax": max,
          "aria-valuenow": leftValue ?? min,
          "aria-label": `${ariaLabel} 최소`,
          ref: leftThumbRef,
          onKeyDown: e => handleKeyDown(true, e)
        }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(Thumb, {
          style: {
            left: `${rightPos * 100}%`
          },
          role: "slider",
          tabIndex: 0,
          "aria-valuemin": min,
          "aria-valuemax": max,
          "aria-valuenow": rightValue ?? max,
          "aria-label": ariaLabel + (dual ? ' 최대' : ''),
          ref: rightThumbRef,
          onKeyDown: e => handleKeyDown(false, e)
        })]
      })]
    }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsxs */ .BX)(Footer, {
      children: [(0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(FooterItem, {
        children: left
      }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(FooterItem, {
        children: right
      })]
    })]
  });
};
const Container$a = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)("div",  true ? {
  target: "evasvfv6"
} : 0)( true ? {
  name: "1ltp2go",
  styles: "position:relative;padding:7px 0;height:10px"
} : 0);
const Background = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)("div",  true ? {
  target: "evasvfv5"
} : 0)( true ? {
  name: "cg6g99",
  styles: "position:absolute;top:7px;left:0;right:0;height:10px;border-radius:10px;background-color:#f5f5f5"
} : 0);
const BarContainer = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)("div",  true ? {
  target: "evasvfv4"
} : 0)( true ? {
  name: "xf71sx",
  styles: "position:absolute;top:7px;left:12px;right:12px;height:10px"
} : 0);
const Bar = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)("div",  true ? {
  target: "evasvfv3"
} : 0)("position:absolute;height:10px;border-radius:10px;margin-left:", props => props.dual ? 0 : -12, "px;background-color:#c7effb;" + ( true ? "" : 0));
const Thumb = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)("div",  true ? {
  target: "evasvfv2"
} : 0)( true ? {
  name: "vvjryx",
  styles: "position:absolute;top:50%;margin:-12px 0 0 -12px;width:24px;height:24px;border-radius:100%;background-color:#35c5f0;transform:translateZ(0px);@media (hover: none){-webkit-tap-highlight-color:rgba(0, 0, 0, 0);&:active{background-color:#09addb;}}@media (hover: hover){&:hover,&:focus{background-color:#09addb;}}&:focus{outline:none;box-shadow:0 0 0 3px #6cd5f4;}"
} : 0);
const Footer = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)("div",  true ? {
  target: "evasvfv1"
} : 0)( true ? {
  name: "rtxflr",
  styles: "display:flex;justify-content:space-between;margin-top:10px"
} : 0);
const FooterItem = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)("div",  true ? {
  target: "evasvfv0"
} : 0)( true ? {
  name: "15buy4s",
  styles: "font-size:13px;color:#9e9e9e;line-height:16px"
} : 0);

const MULTIPLE_VALUE_SEPERATOR$1 = '^';
const createListTagSerializer = id => tags => {
  const values = tags.filter(v => v.id === id).map(v => v.value);
  if (values.length === 0) {
    return {};
  }
  return {
    [id]: values.join(MULTIPLE_VALUE_SEPERATOR$1)
  };
};
const createListTagDeserializer = id => query => {
  if (query[id] == null) {
    return [];
  }
  const values = query[id]?.split(MULTIPLE_VALUE_SEPERATOR$1) ?? [];
  return values.map(value => ({
    id,
    value,
    type: 'list'
  }));
};
const formatList = ({
  options,
  tag
}) => {
  const option = options.find(option => option.value === tag.value);
  if (option == null) {
    return '';
  }
  return option.label;
};
const createListSchema = ({
  type,
  label,
  id,
  options,
  config
}) => {
  const defaultTag = config?.defaultValue ? {
    id,
    value: config.defaultValue,
    type: 'list'
  } : null;
  return {
    type,
    id,
    label,
    options,
    config: {
      ...config,
      showResetButtonOnSelected: {
        pc: false,
        mobile: true
      },
      showCloseButtonOnSelected: {
        mobile: true
      }
    },
    serializer: {
      serialize: createListTagSerializer(id),
      deserialize: createListTagDeserializer(id)
    },
    hasTag: tag => tag.id === id && tag.value !== config?.defaultValue,
    renderTag: tag => {
      if (tag.type !== 'list' || tag.id !== id || config?.defaultValue === tag.value) {
        return null;
      }
      return formatList({
        options,
        tag
      });
    },
    renderSummary: (tag = defaultTag) => {
      if (!tag || tag.type !== 'list' || tag.id !== id) {
        return null;
      }
      return formatList({
        options,
        tag
      });
    }
  };
};

const formatRange = ({
  range,
  unselectedText,
  unit
}) => {
  if (!range) {
    return unselectedText;
  }
  if (range.max == null && range.min == null) {
    return unselectedText;
  }
  if (range.max != null && range.min != null) {
    return `${range.min} - ${range.max}${unit}`;
  }
  if (range.min) {
    return `${range.min}${unit} 이상`;
  }
  return `${range.max}${unit} 이하`;
};

/**
 * targetRange가 range에 포함되었는지 여부를 반환합니다.
 */
const isInclude = ({
  range,
  targetRange
}) => {
  if (!range) {
    return false;
  }
  return (range.min == null || range.min <= targetRange.min) && (range.max == null || range.max >= targetRange.max);
};

/**
 * 기존 범위에 새로운 범위를 추가한 범위를 반환합니다.
 */
const addRange = ({
  range,
  newRange
}) => {
  if (range == null) {
    return {
      min: newRange.min,
      max: newRange.max
    };
  }
  return omitBy({
    min: range.min == null ? null : Math.min(newRange?.min, range.min),
    max: range.max == null ? null : Math.max(newRange?.max, range.max)
  }, v => v == null);
};

/**
 *
 * @param options 전체 옵션
 * @param target
 * @returns target의 다음 옵션을 반환합니다.
 */
const findNextOption = (options, target) => {
  return options.find(option => option.value.min >= target.max)?.value;
};

/**
 *
 * @param options 전체 옵션
 * @param target
 * @returns target의 이전 옵션을 반환합니다.
 */
const findPreviousOption = (options, target) => {
  return [...options].reverse().find(option => option.value.max <= target.min)?.value;
};

/**
 * 규칙
 * - 기존에 선택한 범위가 없을 때
 *   - 선택한 범위를 추가합니다.
 * - 기존에 선택한 범위가 있을 때
 *   - 기존 범위의 양쪽 끝 범위를 선택한 경우, 선택한 범위를 제외합니다.
 *   - 양쪽 끝이 아닌 범위를 선택한 경우, 선택한 범위만을 반환합니다(나머지 범위는 제거)
 * - 기존 범위 밖에 범위를 선택했을 때
 *   - 해당 범위까지 추가해줍니다.
 */
const getRange = ({
  currentRange,
  newRange,
  entry
}) => {
  const defaultMin = entry.config.range.min;
  const defaultMax = entry.config.range.max;
  const currentMin = currentRange == null || currentRange.min == null ? defaultMin : currentRange.min;
  const currentMax = currentRange == null || currentRange.max == null ? defaultMax : currentRange.max;
  if (currentRange != null && isInclude({
    range: currentRange,
    targetRange: newRange
  })) {
    const isSelectCurrentRange = currentMin === newRange.min && currentMax === newRange.max;
    if (isSelectCurrentRange) {
      return {
        min: defaultMin,
        max: defaultMax
      };
    }
    const result = {
      min: currentMin,
      max: currentMax
    };
    const isSelectFirstMin = currentMin === newRange.min;
    if (isSelectFirstMin) {
      const nextOption = findNextOption(entry.options, newRange);
      if (nextOption != null) {
        result.min = nextOption.min;
      } else {
        result.min = newRange.max ?? entry.config.range.max;
      }
      return result;
    }
    const isSelectLastMax = currentMax === newRange.max;
    if (isSelectLastMax) {
      result.max = newRange.min;
      const target = findPreviousOption(entry.options, newRange);
      if (target != null) {
        result.max = target.max;
      } else {
        result.max = newRange.min;
      }
      return result;
    }
    return {
      min: newRange.min,
      max: newRange.max
    };
  }
  const addedRange = addRange({
    range: currentRange,
    newRange
  });
  if (addedRange.min == null || addedRange.max == null) {
    if (addedRange.min === entry.config.range.min) {
      return {
        min: addedRange.min,
        max: entry.config.range.max
      };
    }
    if (addedRange.max === entry.config.range.max) {
      return {
        min: entry.config.range.min,
        max: addedRange.max
      };
    }
  }
  return addedRange;
};

const createRangeTagSerializer = id => tags => {
  const value = tags.find(v => v.id === id);
  if (value == null || value.type !== 'range') {
    return {};
  }
  const queryParams = {
    [`${id}_min`]: value.value.min != null ? String(value.value.min) : null,
    [`${id}_max`]: value.value.max != null ? String(value.value.max) : null
  };
  return omitBy(queryParams, isNil);
};
const createRangeTagDeserializer = id => query => {
  const minValue = parseFloat(query[`${id}_min`] ?? '');
  const maxValue = parseFloat(query[`${id}_max`] ?? '');
  if (isNaN(minValue) && isNaN(maxValue)) {
    return [];
  }
  return [{
    type: 'range',
    id,
    value: omitBy({
      min: minValue || null,
      max: maxValue || null
    }, isNil)
  }];
};
const createRangeSchema = ({
  type,
  label,
  id,
  config,
  options
}) => {
  return {
    type,
    id,
    label,
    options,
    config: {
      ...config,
      showResetButtonOnSelected: {
        pc: true,
        mobile: true
      },
      showCloseButtonOnSelected: {
        mobile: true
      }
    },
    serializer: {
      serialize: createRangeTagSerializer(id),
      deserialize: createRangeTagDeserializer(id)
    },
    hasTag: tag => tag.id === id && tag.type === 'range' && !isEqual$2(tag.value, config.range),
    renderTag: tag => {
      if (tag.type !== 'range' || tag.id !== id) {
        return null;
      }
      return formatRange({
        range: isEqual$2(tag.value, config.range) ? null : tag.value,
        unselectedText: config.unselectedText,
        unit: config.unit
      });
    },
    renderSummary(tag) {
      if (!tag) {
        return null;
      }
      return this.renderTag(tag);
    }
  };
};

const createSerialize = converters => tags => {
  return converters.reduce((acc, converter) => ({
    ...acc,
    ...converter(tags)
  }), {});
};
const createDeserialize = converters => query => {
  return converters.map(converter => converter(query)).reduce((acc, tag) => [...acc, ...tag], []);
};
const createGroupSchema = ({
  id,
  schema,
  ...rest
}) => {
  return {
    id,
    schema,
    ...rest,
    serializer: {
      serialize: createSerialize(schema.map(entry => entry.serializer.serialize)),
      deserialize: createDeserialize(schema.map(entry => entry.serializer.deserialize))
    },
    hasTag: tag => schema.some(entry => entry.hasTag(tag)),
    renderTag: tag => schema.map(entry => entry.renderTag(tag)),
    renderSummary: tag => schema.map(entry => entry.renderSummary(tag))
  };
};

const DEFAULT_SIZE = 16;
const ColorIcon = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)("span",  true ? {
  target: "e66elua0"
} : 0)("display:inline-flex;justify-content:center;align-items:center;width:", ({
  size
}) => (0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.p)(size ?? DEFAULT_SIZE), ";height:", ({
  size
}) => (0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.p)(size ?? DEFAULT_SIZE), ";background:", ({
  color
}) => color, ";box-sizing:border-box;border:", ({
  hasBorder,
  theme
}) => hasBorder ? `${(0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.p)(1)} solid ${theme.border}` : 'none', ";border-radius:50%;" + ( true ? "" : 0));

const MULTIPLE_VALUE_SEPERATOR = '^';
const createColorTagSerializer = id => tags => {
  const values = tags.filter(v => v.id === id).map(v => v.value);
  if (values.length === 0) {
    return {};
  }
  return {
    [id]: values.join(MULTIPLE_VALUE_SEPERATOR)
  };
};
const createColorTagDeserializer = id => query => {
  if (query[id] == null) {
    return [];
  }
  const values = query[id]?.split(MULTIPLE_VALUE_SEPERATOR) ?? [];
  return values.map(value => ({
    id,
    value: Number(value),
    type: 'color'
  }));
};
const createColorSchema = ({
  id,
  config,
  options,
  type,
  label,
  ...rest
}) => {
  return {
    ...rest,
    type,
    id,
    label,
    options,
    serializer: {
      serialize: createColorTagSerializer(id),
      deserialize: createColorTagDeserializer(id)
    },
    hasTag: tag => tag.id === id,
    renderTag: tag => {
      if (tag.type !== 'color' || tag.id !== id) {
        return null;
      }
      const option = options.find(option => option.value.search === tag.value);
      if (!option) {
        return null;
      }
      if (type === 'singleSelectColor') {
        return jsxs(ColorIconContainer, {
          children: [jsx(ColorIcon, {
            size: 16,
            color: option.value.code,
            hasBorder: option.value.border
          }), label]
        });
      }
      return jsx(ColorIcon, {
        size: 16,
        color: option.value.code,
        hasBorder: option.value.border
      });
    },
    renderSummary: tag => {
      if (!tag || tag.type !== 'color' || tag.id !== id) {
        return null;
      }
      const option = options.find(option => option.value.search === tag.value);
      if (!option) {
        return null;
      }
      if (type === 'singleSelectColor') {
        return jsxs(ColorIconContainer, {
          children: [jsx(ColorIcon, {
            size: 16,
            color: option.value.code,
            hasBorder: option.value.border
          }), label]
        });
      }
      return jsx(ColorIcon, {
        size: 24,
        color: option.value.code,
        hasBorder: option.value.border
      });
    }
  };
};
const ColorIconContainer = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)("span",  true ? {
  target: "e1azwwbb0"
} : 0)("display:flex;align-items:center;gap:", (0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.p)(4), ";" + ( true ? "" : 0));

const ButtonControl = ({
  entry,
  onChangeTags,
  tags
}) => {
  const currentRange = tags.find(tag => tag.id === entry.id);
  const handleClick = newRange => {
    if (currentRange && currentRange.type !== 'range') {
      return;
    }
    const range = getRange({
      currentRange: currentRange?.value,
      newRange,
      entry
    });
    onChangeTags(range);
  };
  return jsx(ButtonList, {
    children: entry.options.map(option => jsx(Button$2, {
      type: "button",
      isActive: isInclude({
        range: currentRange?.type === 'range' ? currentRange?.value : undefined,
        targetRange: option.value
      }),
      onClick: () => handleClick(option.value),
      children: option.label
    }, option.label))
  });
};
const ButtonList = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)("div",  true ? {
  target: "ectpx291"
} : 0)("display:grid;grid-template-columns:repeat(4, 1fr);column-gap:", (0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.p)(4), ";row-gap:", (0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.p)(4), ";" + ( true ? "" : 0));
const Button$2 = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)("button",  true ? {
  target: "ectpx290"
} : 0)("height:", (0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.p)(40), ";", _bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.F.body2_small, ";border-radius:", (0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.p)(4), ";color:", ({
  isActive,
  theme
}) => isActive ? theme.content.white : theme.content.base1, ";background:", ({
  isActive,
  theme
}) => isActive ? theme.content.primary1.basic : theme.content.base5, ";", ({
  theme,
  isActive
}) => _bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.H`
    background: ${isActive ? '#09addb' : theme.interactive.base5};
  `, ";" + ( true ? "" : 0));

function _EMOTION_STRINGIFIED_CSS_ERROR__$t() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
/**
 * max, min값이 default 값일 때 필드를 제거합니다.
 */
const convertRange = (range, defaultRange) => {
  const result = {
    min: range.min === defaultRange.min ? null : range.min,
    max: range.max === defaultRange.max ? null : range.max
  };
  if (result.min == null && result.max == null) {
    return null;
  }
  return omitBy(result, v => v == null);
};
const RangePanel = ({
  entry,
  tags,
  onChangeTags
}) => {
  const [sliderRange, setSliderRange] = useState(null);
  const {
    reset
  } = useLocaleData();
  const handleChangeTags = useCallback(value => {
    const newValue = convertRange(value, entry.config.range);
    if (newValue == null) {
      onChangeTags([...tags.filter(tag => tag.id !== entry.id)]);
      return;
    }
    onChangeTags([...tags.filter(tag => tag.id !== entry.id), {
      id: entry.id,
      type: 'range',
      value: newValue
    }]);
  }, [entry, onChangeTags, tags]);
  const debouncedOnChange = useMemo(() => debounce$1(handleChangeTags, 500), [handleChangeTags]);
  const handleButtonClick = useCallback(handleChangeTags, [handleChangeTags]);
  const handleSliderClick = useCallback(({
    min,
    max
  }) => {
    const value = omitBy({
      min,
      max
    }, v => v == null);
    debouncedOnChange(value);
    if (entry.config.hasSliderInput) {
      setSliderRange(value);
    }
  }, [debouncedOnChange, entry]);
  const getRange = useCallback(() => {
    const tag = tags.find(tag => tag.id === entry.id);
    if (tag && tag.type !== 'range') {
      return null;
    }
    return tag?.value == null ? null : tag.value;
  }, [tags, entry]);
  useEffect(() => {
    const range = getRange();
    if (range == null) {
      setSliderRange(null);
    }
  }, [getRange]);
  const handleReset = () => {
    onChangeTags(tags.filter(tag => tag.id !== entry.id));
  };
  const currentStateText = () => {
    const range = entry.config.hasSliderInput && sliderRange ? sliderRange : getRange();
    return formatRange({
      range: range ? convertRange(range, entry.config.range) : null,
      unselectedText: entry.config.unselectedText,
      unit: entry.config.unit
    });
  };
  const isSelected = !!tags.find(tag => tag.id === entry.id);
  const isMobile = useResponsive().breakpoint === 'mobile';
  const range = sliderRange ?? getRange();
  return jsxs(Container$9, {
    children: [jsxs(Header$1, {
      children: [jsx(CurrentState, {
        children: currentStateText()
      }), isSelected && !isMobile && entry.config.showResetButtonOnSelected?.pc && jsx(ResetButton$3, {
        type: "button",
        onClick: handleReset,
        children: reset
      })]
    }), entry.config.hasSliderInput && jsx(StyledRangeSliderInput, {
      min: entry.config.range.min,
      max: entry.config.range.max,
      dual: true,
      value: {
        min: range?.min,
        max: range?.max
      },
      projection: v => v,
      quantize: v => Math.round(v),
      left: entry.config.rangeStartText,
      right: entry.config.rangeEndText,
      onChange: handleSliderClick
    }), jsx(ButtonControl, {
      entry: entry,
      onChangeTags: handleButtonClick,
      tags: tags
    })]
  });
};
const Container$9 = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)("div",  true ? {
  target: "ek7ao1n4"
} : 0)("width:100%;", _bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.M.min('tablet', /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_6__/* .css */ .iv)("width:", (0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.p)(375), ";" + ( true ? "" : 0),  true ? "" : 0)), " padding:", (0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.p)(20), " ", (0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.p)(15), ";" + ( true ? "" : 0));
const Header$1 = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)("div",  true ? {
  target: "ek7ao1n3"
} : 0)( true ? {
  name: "1066lcq",
  styles: "display:flex;justify-content:space-between;align-items:center"
} : 0);
const ResetButton$3 = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)("button",  true ? {
  target: "ek7ao1n2"
} : 0)(_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.F.body1_small, ";color:", ({
  theme
}) => theme.content.primary1.basic, ";", _bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.H`
    opacity: 0.5;
  `, ";" + ( true ? "" : 0));
const CurrentState = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)("span",  true ? {
  target: "ek7ao1n1"
} : 0)("font-weight:700;", _bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.F.title2, ";text-align:left;padding:", (0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.p)(14), " 0 ", (0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.p)(20), ";" + ( true ? "" : 0));
const StyledRangeSliderInput = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(RangeSliderInput,  true ? {
  target: "ek7ao1n0"
} : 0)("margin-bottom:", (0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.p)(38), ";" + ( true ? "" : 0));

function _EMOTION_STRINGIFIED_CSS_ERROR__$s() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
var _ref$k =  true ? {
  name: "3lrvfj",
  styles: "vertical-align:bottom"
} : 0;
const ColorButton = ({
  isChecked,
  background,
  ...rest
}) => {
  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(ColorIcon, {
    color: background.color,
    hasBorder: background.isWhitish,
    as: "button",
    size: 24,
    css: _ref$k,
    ...rest,
    children: isChecked && (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(_bucketplace_design_system_bds__WEBPACK_IMPORTED_MODULE_8__/* .Icon */ .JO$, {
      name: "check_thick",
      size: 16,
      fill: theme => background.isWhitish ? theme.content.base1 : theme.content.white
    })
  });
};

const ColorPanel = ({
  entry,
  onChangeTags,
  tags
}) => {
  const handleClick = optionValue => {
    const newTag = {
      id: entry.id,
      type: 'color',
      value: optionValue.search
    };
    const isAlreadySelected = tags.some(tag => tag.id === newTag.id && tag.value === newTag.value);
    if (isAlreadySelected) {
      onChangeTags(tags.filter(tag => !(tag.id === newTag.id && tag.value === newTag.value)));
      return;
    }
    if (entry.type === FilterKey.MULTI_SELECT_COLOR) {
      onChangeTags([newTag, ...tags]);
      return;
    }
    onChangeTags([newTag, ...tags.filter(tag => tag.id !== newTag.id)]);
  };
  return jsxs(Fragment$1, {
    children: [entry.label && jsx(Label, {
      children: entry.label
    }), jsx(List, {
      children: entry.options.map(option => jsx(StyledColorButton, {
        background: {
          color: option.value.code,
          isWhitish: !!option.value.border
        },
        isChecked: !!tags.find(tag => {
          return tag.id === entry.id && tag.value === option.value.search;
        }),
        onClick: () => {
          handleClick(option.value);
        }
      }, option.label))
    })]
  });
};
const List = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)("div",  true ? {
  target: "eqyadn62"
} : 0)("min-height:", (0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.p)(50), ";padding:", (0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.p)(5), " ", (0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.p)(10), ";box-sizing:content-box;white-space:nowrap;overflow-x:auto;" + ( true ? "" : 0));
const StyledColorButton = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(ColorButton,  true ? {
  target: "eqyadn61"
} : 0)("margin:", (0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.p)(5), ";" + ( true ? "" : 0));
const Label = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)("span",  true ? {
  target: "eqyadn60"
} : 0)("padding:", (0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.p)(5), " ", (0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.p)(15), ";", _bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.F.caption1, ";color:", ({
  theme
}) => theme.content.base1, ";" + ( true ? "" : 0));

const renderSinglePanel = props => {
  switch (props.entry.type) {
    case FilterKey.MULTI_SELECT_LIST:
    case FilterKey.SINGLE_SELECT_LIST:
      return jsx(ListPanel, {
        ...props,
        entry: props.entry,
        tags: props.tags
      });
    case FilterKey.RANGE:
      return jsx(RangePanel, {
        ...props,
        entry: props.entry,
        tags: props.tags
      });
    case FilterKey.MULTI_SELECT_COLOR:
    case FilterKey.SINGLE_SELECT_COLOR:
      return jsx(ColorPanel, {
        ...props,
        entry: props.entry,
        tags: props.tags
      });
    default:
      return null;
  }
};
const SinglePanel = ({
  entry,
  onChangeTags,
  tags
}) => {
  return jsx(Fragment$1, {
    children: renderSinglePanel({
      entry,
      onChangeTags,
      tags
    })
  });
};

const getIdsInGroup = entry => {
  if (entry.type !== FilterKey.SINGLE_SELECT_GROUP && entry.type !== FilterKey.MULTI_SELECT_GROUP) {
    return [entry.id];
  }
  return entry.schema.map(entry => getIdsInGroup(entry)).reduce((acc, ids) => [...acc, ...ids], []);
};
const GroupPanel = ({
  entry,
  onChangeTags,
  tags
}) => {
  const [activeGroupId, setActiveGroupId] = useState(null);
  const idListInGroup = getIdsInGroup(entry);
  const selectedGroupId = tags.find(tag => idListInGroup.includes(tag.id))?.id;
  const resetAllGroupTags = () => {
    if (!selectedGroupId) {
      return;
    }
    onChangeTags(tags.filter(tag => !idListInGroup.includes(tag.id)));
  };
  const isActiveGroup = entry => {
    if (activeGroupId) {
      return entry.id === activeGroupId;
    }
    return !!(selectedGroupId && getIdsInGroup(entry).includes(selectedGroupId));
  };
  if (entry.type === FilterKey.SINGLE_SELECT_GROUP) {
    return jsx(Fragment$1, {
      children: entry.schema.map(subEntry => jsxs(React__default.Fragment, {
        children: [jsxs(ExpanderController, {
          children: [jsx("span", {
            children: subEntry.label
          }), jsx(Toggle, {
            checked: isActiveGroup(subEntry),
            onCheck: checked => {
              setActiveGroupId(checked ? subEntry.id : null);
              resetAllGroupTags();
            }
          })]
        }), jsx(Expander, {
          isExpanded: isActiveGroup(subEntry),
          children: jsx(SinglePanel, {
            entry: {
              ...subEntry,
              label: subEntry.type === FilterKey.SINGLE_SELECT_GROUP || subEntry.type === FilterKey.MULTI_SELECT_GROUP ? subEntry.label : ''
            },
            onChangeTags: onChangeTags,
            tags: tags
          })
        })]
      }, subEntry.id))
    });
  }
  return jsx(Fragment$1, {
    children: entry.schema.map(entry => jsx(SinglePanel, {
      entry: entry,
      onChangeTags: onChangeTags,
      tags: tags
    }, entry.id))
  });
};
const ExpanderController = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)("div",  true ? {
  target: "ekqfg9x1"
} : 0)(_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.F.body1_small, ";display:flex;justify-content:space-between;align-items:center;padding:", (0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.p)(10.5), " ", (0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.p)(15), ";" + ( true ? "" : 0));
const Expander = /*#__PURE__*/(/* unused pure expression or super */ null && (_styled("div",  true ? {
  target: "ekqfg9x0"
} : 0)("height:", ({
  isExpanded
}) => isExpanded ? 'fit-content' : 0, ";overflow:hidden;" + ( true ? "" : 0))));

const renderPanel = props => {
  switch (props.entry.type) {
    case FilterKey.MULTI_SELECT_GROUP:
    case FilterKey.SINGLE_SELECT_GROUP:
      return jsx(GroupPanel, {
        ...props,
        entry: props.entry,
        tags: props.tags
      });
    default:
      return jsx(SinglePanel, {
        ...props
      });
  }
};
const Panel = ({
  entry,
  onChangeTags,
  tags
}) => {
  return jsx(Container$8, {
    children: renderPanel({
      entry,
      onChangeTags,
      tags
    })
  });
};

// TODO
// InfoTip backlayer 수정 후 스타일 제거
const Container$8 = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)("div",  true ? {
  target: "e1gi3ci50"
} : 0)("position:relative;z-index:1;text-align:start;max-height:", (0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.p)(425), ";overflow:auto;color:", ({
  theme
}) => theme.content.base1, ";" + ( true ? "" : 0));

function _EMOTION_STRINGIFIED_CSS_ERROR__$r() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
const homeTransitionStyles = {
  entering: {
    opacity: 1,
    transition: 'opacity 0.2s'
  },
  entered: {
    opacity: 1
  },
  exiting: {
    opacity: 0,
    transition: 'opacity 0.2s'
  },
  exited: {
    opacity: 0
  }
};
const pageTransitionStyles = {
  entering: {
    opacity: 1,
    transform: 'translateX(0)',
    transition: 'opacity 0.2s, transform 0.2s'
  },
  entered: {
    opacity: 1,
    transform: 'translateX(0)'
  },
  exiting: {
    opacity: 0,
    transform: 'translateX(50px)',
    transition: 'opacity 0.2s, transform 0.2s'
  },
  exited: {
    opacity: 0,
    transform: 'translateX(50px)'
  }
};
const PageWithFadeTransition = ({
  children,
  isHome,
  show
}) => {
  const transitionStyles = isHome ? homeTransitionStyles : pageTransitionStyles;
  const ref = useRef(null);
  return jsx(Transition$1, {
    in: show,
    timeout: 200,
    unmountOnExit: true,
    nodeRef: ref,
    children: state => {
      return jsx(Content, {
        ref: ref,
        style: transitionStyles[state],
        children: children
      });
    }
  });
};
const Content = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)("div",  true ? {
  target: "eq9zchc0"
} : 0)( true ? {
  name: "1b4920d",
  styles: "position:absolute;top:0;left:0;width:100%;height:100%"
} : 0);

function _EMOTION_STRINGIFIED_CSS_ERROR__$q() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
const BaseModal = ({
  actionLeft,
  title,
  actionRight,
  onClose,
  isStartToClose,
  children,
  ...rest
}) => {
  return jsx(StyledModal$1, {
    ...rest,
    width: 400,
    height: "440px",
    hasInteraction: true,
    disableBackgroundScroll: true,
    isStartToClose: isStartToClose,
    onBlur: onClose,
    children: jsxs(Container$7, {
      children: [jsxs(Header, {
        children: [jsx(HeaderLeft, {
          children: actionLeft
        }), title, jsx(HeaderRight, {
          children: actionRight
        })]
      }), jsx(Body, {
        children: children
      })]
    })
  });
};
const slideUp = _emotion_react__WEBPACK_IMPORTED_MODULE_6__/* .keyframes */ .F4`
  from {
    transform: translateY(100px);
    opacity: 0;
  }
  to {
    transform: none;
    opacity: 1;
  }
`;
const StyledModal$1 = /*#__PURE__*/(/* unused pure expression or super */ null && (_styled(Modal,  true ? {
  shouldForwardProp: prop => prop !== 'isStartToClose',
  target: "e14xlalu5"
} : 0)("opacity:", ({
  isStartToClose
}) => isStartToClose ? '0' : '1', ";transition:all .25s ease-out;>div{transform:", ({
  isStartToClose
}) => isStartToClose ? 'translateY(100px)' : 'none', ";transition:all .25s ease-out;animation:", slideUp, " .25s ease-out;}" + ( true ? "" : 0))));
const Container$7 = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)("div",  true ? {
  target: "e14xlalu4"
} : 0)( true ? {
  name: "1lghw08",
  styles: "position:relative;width:100%;height:100%;overflow:hidden;display:flex;flex-direction:column"
} : 0);
const Body = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)("div",  true ? {
  target: "e14xlalu3"
} : 0)("flex:1;position:relative;overflow-x:hidden;overflow-y:scroll;margin-bottom:", (0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.p)(-1), ";margin-top:", (0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.p)(1), ";" + ( true ? "" : 0));
const Header = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)("div",  true ? {
  target: "e14xlalu2"
} : 0)("position:relative;", _bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.F.title4, ";font-weight:700;padding:", (0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.p)(10), " 0;" + ( true ? "" : 0));
const HeaderLeft = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)("div",  true ? {
  target: "e14xlalu1"
} : 0)("position:absolute;top:0;left:0;padding-left:", (0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.p)(20.5), ";height:100%;display:flex;align-items:center;font-weight:400;" + ( true ? "" : 0));
const HeaderRight = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)("div",  true ? {
  target: "e14xlalu0"
} : 0)("position:absolute;top:0;right:0;height:100%;padding-right:", (0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.p)(15.5), ";display:flex;align-items:center;" + ( true ? "" : 0));

function _EMOTION_STRINGIFIED_CSS_ERROR__$p() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
const MenuModal = ({
  menu,
  home,
  currentMenuKey,
  onChangeMenuKey,
  onClose,
  actions,
  ...rest
}) => {
  const showHome = currentMenuKey == null;
  const currentMenuItem = menu.find(item => item.key === currentMenuKey) ?? home;
  const handleBack = !showHome ? () => onChangeMenuKey?.(null) : undefined;
  return jsxs(BaseModal, {
    ...rest,
    actionLeft: handleBack && jsx(BackButton, {
      type: "button",
      onClick: handleBack,
      children: jsx(Icon$1, {
        name: "arrow_left",
        size: 24
      })
    }),
    actionRight: actions,
    title: currentMenuItem.label,
    onClose: onClose,
    children: [jsx(PageWithFadeTransition, {
      isHome: true,
      show: showHome,
      children: home.content
    }), menu.map(item => jsx(PageWithFadeTransition, {
      show: item.key === currentMenuKey,
      children: item.content
    }, item.key))]
  });
};
const BackButton = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)("button",  true ? {
  target: "e1yjndi0"
} : 0)( true ? {
  name: "opde7s",
  styles: "color:inherit"
} : 0);

const FilterTag = ({
  onClick,
  showDeleteIcon = true,
  children
}) => {
  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsxs */ .BX)(TagButton, {
    onClick: onClick,
    children: [children, showDeleteIcon && (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(DeleteIcon, {
      size: 16
    })]
  });
};
const TagButton = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)("button",  true ? {
  target: "e6u93a41"
} : 0)("display:flex;align-items:center;height:", (0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.p)(24), ";padding:", (0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.p)(1), " ", (0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.p)(8), " ", (0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.p)(3), ";background-color:", ({
  theme
}) => theme.content.primary1.basic, ";color:", ({
  theme
}) => theme.content.white, ";font-size:", (0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.p)(15), ";font-weight:700;line-height:", (0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.p)(18), ";border-radius:", (0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.p)(26), ";" + ( true ? "" : 0));
const DeleteIcon = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_11__.U,  true ? {
  target: "e6u93a40"
} : 0)("margin:0 ", (0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.p)(-4), " 0 ", (0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.p)(7), ";vertical-align:", (0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.p)(-1), ";" + ( true ? "" : 0));

const findTagLabel = (schema, tag) => {
  return schema.reduce((result, entry) => {
    if (result) {
      return result;
    }
    if (entry.type === 'multiSelectGroup' || entry.type === 'singleSelectGroup') {
      return findTagLabel(entry.schema, tag);
    }
    return entry.renderTag(tag);
  }, null);
};
const FilterTagList = ({
  className,
  handleChangeTags,
  tags,
  schema: schemaList
}) => {
  const {
    reset
  } = useLocaleData();
  const isMobile = (0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_12__.m)().breakpoint === 'mobile';
  const hideResetButton = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(() => {
    return tags.length <= 1 && tags.some(tag => {
      return schemaList.some(schema => {
        if (schema.type === 'multiSelectList' || schema.type === 'singleSelectList') {
          return schema.config?.defaultValue === tag.value;
        }
        return false;
      });
    });
  }, [schemaList, tags]);
  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsxs */ .BX)(ListContainer, {
    className: className,
    children: [tags.map((tag, index) => findTagLabel(schemaList, tag) == null ? null : (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(FilterTagListItem, {
      children: (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(FilterTag, {
        onClick: () => handleChangeTags(tags.filter((_, i) => i !== index)),
        children: findTagLabel(schemaList, tag)
      })
    }, `${tag.id}-${JSON.stringify(tag.value)}`)), !isMobile && !hideResetButton && (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(FilterTagListItem, {
      children: (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(ResetButton$2, {
        type: "button",
        onClick: () => handleChangeTags([]),
        children: reset
      })
    })]
  });
};
const ListContainer = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)("ul",  true ? {
  target: "e1pjrndz2"
} : 0)("display:flex;flex-wrap:wrap;gap:", (0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.p)(4), ";list-style:none;padding:", (0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.p)(5), " 0;white-space:nowrap;overflow:auto;", _bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.M.max('tablet', /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_6__/* .css */ .iv)("margin:0 ", (0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.p)(-15), ";padding:", (0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.p)(5), " ", (0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.p)(15), ";flex-wrap:nowrap;" + ( true ? "" : 0),  true ? "" : 0)), ";" + ( true ? "" : 0));
const FilterTagListItem = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)("li",  true ? {
  target: "e1pjrndz1"
} : 0)("padding:", (0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.p)(2), " 0;&>button{border:", (0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.p)(1), " solid transparent;}" + ( true ? "" : 0));
const ResetButton$2 = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)("button",  true ? {
  target: "e1pjrndz0"
} : 0)("color:", ({
  theme
}) => theme.content.primary1.basic, ";padding:", (0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.p)(2), " ", (0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.p)(10), ";border:none;background:none;font-size:", (0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.p)(15), ";line-height:", (0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.p)(18), ";font-weight:700;text-align:center;" + ( true ? "" : 0));

const ZINDEX = 3;
const Dropdown = ({
  children,
  content,
  isOpen,
  onChangeOpen
}) => {
  return jsx(InfoTip, {
    renderOpener: ({
      onMouseEnter,
      onMouseLeave
    }) => /*#__PURE__*/React__default.cloneElement(children, {
      onMouseEnter,
      onMouseLeave
    }),
    onOpenChange: onChangeOpen,
    openOnHover: true,
    offsetTop: 8,
    forceClose: !isOpen,
    contentStyle: {
      zIndex: ZINDEX
    },
    children: jsx(Container$6, {
      children: content
    })
  });
};
const Container$6 = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)("div",  true ? {
  target: "ejm8vx70"
} : 0)("border-radius:", (0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.p)(10), ";overflow:hidden;background:", ({
  theme
}) => theme.content.white, ";box-shadow:0 ", (0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.p)(-1), " ", (0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.p)(16), " rgba(0, 0, 0, 0.2);" + ( true ? "" : 0));

const FilterButton = ({
  icon,
  children,
  ...rest
}) => {
  return jsxs(Button$1, {
    type: "button",
    ...rest,
    children: [children, icon]
  });
};
const Button$1 = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)("button",  true ? {
  target: "ebq8vr70"
} : 0)("width:max-content;background:", ({
  isActive,
  theme
}) => isActive ? theme.content.primary1.thin : theme.content.base5, ";color:", ({
  isActive,
  theme
}) => isActive ? theme.content.primary1.thick : theme.content.base2, ";border-radius:", (0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.p)(4), ";", _bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.F.body1_small, ";font-size:", (0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.p)(15), ";font-weight:700;height:", (0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.p)(34), ";padding:0 ", (0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.p)(8), ";display:flex;align-items:center;gap:", (0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.p)(5), ";" + ( true ? "" : 0));

const FilterSelectButton = ({
  icon,
  ...rest
}) => {
  return jsx(FilterButton, {
    icon: icon || jsx(Icon$1, {
      name: "chevron_thick_down",
      size: 12
    }),
    ...rest
  });
};

const FilterController = ({
  entry,
  isActive,
  tags,
  onChangeTags
}) => {
  const isMobile = useResponsive().breakpoint === 'mobile';
  const [isOptionOpen, setIsOptionOpen] = useState(false);
  const [isClicked, setIsClicked] = useState(false);
  const [isOptionStartToClose, setIsOptionStartToClose] = useState(false);
  const {
    reset,
    apply
  } = useLocaleData();
  const closeOption = () => {
    setIsOptionStartToClose(true);
  };
  const handleClose = useCallback(() => {
    closeOption();
    setIsClicked(false);
  }, []);
  const handleChangeTags = useCallback(tags => {
    onChangeTags(tags);
    // 단일 선택 리스트일 때만 옵션 선택 시 선택 창이 닫힘
    // 그 외 타입은 모달의 확인 버튼 클릭하거나 dropdown 영역을 벗어났을 때 닫힘
    if (entry.type === FilterKey.SINGLE_SELECT_LIST) {
      handleClose();
    }
  }, [entry, onChangeTags, handleClose]);
  const handleChangeOpen = useCallback(isOpen => {
    setIsClicked(isOpen);
    setIsOptionOpen(isOpen);
  }, []);
  const showResetButton = isActive && entry.config?.showResetButtonOnSelected?.mobile;
  const showCloseButton = isActive && entry.config?.showCloseButtonOnSelected?.mobile;
  return jsxs(Fragment$1, {
    children: [jsx(Dropdown, {
      content: jsx(Panel, {
        entry: entry,
        onChangeTags: tags => {
          handleChangeTags(tags);
          if (entry.type === FilterKey.SINGLE_SELECT_LIST) {
            closeOption();
            setIsClicked(false);
          }
        },
        tags: tags
      }),
      onChangeOpen: !isMobile ? handleChangeOpen : undefined,
      isOpen: !isMobile && isOptionOpen,
      children: jsx(FilterSelectButton, {
        isActive: isActive,
        onClick: () => {
          if (!isMobile) {
            setIsClicked(prev => !prev);
          }
          setIsOptionOpen(prev => isMobile ? !prev : isClicked);
        },
        children: entry.label
      })
    }, entry.id), isMobile && isOptionOpen && jsx(BaseModal, {
      title: entry?.label,
      onClose: handleClose,
      isStartToClose: isOptionStartToClose,
      onTransitionEnd: () => {
        if (isOptionStartToClose) {
          setIsOptionOpen(false);
          setIsOptionStartToClose(false);
        }
      },
      actionRight: showResetButton && jsx(ResetButton$1, {
        type: "button",
        onClick: () => {
          onChangeTags(tags.filter(tag => tag.id !== entry?.id));
        },
        children: reset
      }),
      footer: showCloseButton ? {
        action: {
          primary: {
            text: apply,
            onClick: handleClose
          }
        }
      } : undefined,
      children: entry && jsx(Panel, {
        entry: entry,
        tags: tags,
        onChangeTags: onChangeTags
      })
    })]
  });
};
const ResetButton$1 = /*#__PURE__*/(/* unused pure expression or super */ null && (_styled("button",  true ? {
  target: "e2ma4e60"
} : 0)("color:", ({
  theme
}) => theme.content.primary1.basic, ";font-size:inherit;font-weight:inherit;line-height:inherit;" + ( true ? "" : 0))));

const FilterListModalItem = ({
  buttonText,
  onClick,
  label
}) => {
  return jsx(ListPanelModalItem, {
    buttonText: buttonText,
    onClick: onClick,
    icon: jsxs(IconWrapper, {
      children: [jsx(SelectedValue, {
        children: label
      }), jsx(Icon$1, {
        name: "chevron_right",
        size: 18
      })]
    })
  });
};
const IconWrapper = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)("div",  true ? {
  target: "eecmxa11"
} : 0)("display:flex;gap:", (0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.p)(4), ";font-weight:700;align-items:center;" + ( true ? "" : 0));
const SelectedValue = /*#__PURE__*/(/* unused pure expression or super */ null && (_styled("span",  true ? {
  target: "eecmxa10"
} : 0)("display:flex;align-items:center;color:", ({
  theme
}) => theme.content.primary1.basic, ";" + ( true ? "" : 0))));

const RouteFilter = ({
  className,
  schema,
  query,
  onChangeQuery,
  localeData = defaultLocaleData
}) => {
  const isMobile = useResponsive().breakpoint === 'mobile';
  const {
    handleChangeTags,
    tags
  } = useFilterTags({
    schema,
    query,
    onChangeQuery
  });
  const {
    reset,
    selectedEntryId,
    selectEntry,
    isModalOpen,
    openModal,
    closeModal
  } = useFilterListModal({
    schema,
    tags,
    handleChangeTags
  });
  const [isStartToClose, setIsStartToClose] = useState(false);
  const isSelected = entry => {
    return tags.some(tag => entry.hasTag(tag));
  };
  const renderSummary = entry => {
    const activeTags = tags.filter(tag => entry.hasTag(tag));
    return activeTags.length === 0 ? entry.renderSummary() : activeTags.map(tag => entry.renderSummary(tag));
  };
  return jsxs(LocaleDataProvider, {
    data: localeData,
    children: [jsxs(Container$5, {
      className: className,
      "data-testid": "router-filter",
      children: [jsxs(FilterControllerList, {
        children: [isMobile && jsxs(AllFilterButton, {
          type: "button",
          onClick: openModal,
          children: [jsx(Icon$1, {
            name: "filter",
            size: 18,
            fill: theme => theme.content.base3
          }), jsx(HiddenText, {
            children: localeData.showAllFilter
          })]
        }), schema.map(entry => jsx(FilterController, {
          entry: entry,
          isActive: isSelected(entry),
          tags: tags,
          onChangeTags: handleChangeTags
        }, entry.id))]
      }), tags.length > 0 && jsx(StyledFilterTagList, {
        tags: tags,
        handleChangeTags: handleChangeTags,
        schema: schema
      })]
    }), isModalOpen && jsx(MenuModal, {
      isStartToClose: isStartToClose,
      onTransitionEnd: () => {
        if (isStartToClose) {
          closeModal();
          setIsStartToClose(false);
        }
      },
      actions: reset && jsx(ResetButton, {
        type: "button",
        onClick: reset,
        children: localeData.reset
      }),
      footer: {
        action: {
          primary: {
            text: localeData.apply,
            onClick: () => setIsStartToClose(true)
          }
        }
      },
      onClose: () => setIsStartToClose(true),
      onChangeMenuKey: selectEntry,
      menu: schema.map(entry => ({
        key: entry.id,
        label: entry.label,
        content: jsx(Panel, {
          entry: entry,
          tags: tags,
          onChangeTags: handleChangeTags
        })
      })),
      home: {
        label: localeData.filter,
        content: jsx(Fragment$1, {
          children: schema.map(entry => jsx(FilterListModalItem, {
            buttonText: entry.label,
            onClick: () => selectEntry(entry.id),
            label: jsx(TagLabelContainer, {
              children: renderSummary(entry)
            })
          }, entry.id))
        })
      },
      currentMenuKey: selectedEntryId
    })]
  });
};
const Container$5 = /*#__PURE__*/(/* unused pure expression or super */ null && (_styled("div",  true ? {
  target: "e1kmhkn46"
} : 0)( true ? "" : 0)));
const FilterControllerList = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)("div",  true ? {
  target: "e1kmhkn45"
} : 0)("display:flex;align-items:center;gap:", (0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.p)(4), ";padding:", (0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.p)(5), " 0;width:100%;overflow-x:auto;&::-webkit-scrollbar{display:none;}-ms-overflow-style:none;scrollbar-width:none;" + ( true ? "" : 0));
const StyledFilterTagList = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(FilterTagList,  true ? {
  target: "e1kmhkn44"
} : 0)("margin:", (0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.p)(10), " 0 ", (0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.p)(5), ";" + ( true ? "" : 0));
const ResetButton = /*#__PURE__*/(/* unused pure expression or super */ null && (_styled("button",  true ? {
  target: "e1kmhkn43"
} : 0)("color:", ({
  theme
}) => theme.content.primary1.basic, ";font-size:inherit;font-weight:inherit;line-height:inherit;" + ( true ? "" : 0))));
const TagLabelContainer = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)("div",  true ? {
  target: "e1kmhkn42"
} : 0)("display:flex;gap:", (0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.p)(4), ";flex-wrap:wrap;justify-content:flex-end;" + ( true ? "" : 0));
const AllFilterButton = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)("button",  true ? {
  target: "e1kmhkn41"
} : 0)("padding-right:", (0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.p)(8), ";" + ( true ? "" : 0));
const HiddenText = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)("span",  true ? {
  target: "e1kmhkn40"
} : 0)("border:0;clip:rect(0 0 0 0);width:", (0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.p)(1), ";height:", (0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.p)(1), ";overflow:hidden;padding:0;position:absolute;white-space:nowrap;" + ( true ? "" : 0));

var ne=Object.defineProperty;var E=(e,t,o)=>t in e?ne(e,t,{enumerable:!0,configurable:!0,writable:!0,value:o}):e[t]=o;(e=> true?__webpack_require__(44599):0)(function(e){if(true)return __webpack_require__(44599).apply(this,arguments);throw Error('Dynamic require of "'+e+'" is not supported')});var f=(e,t,o)=>E(e,typeof t!="symbol"?t+"":t,o);var u={OFF:0,ERROR:10,WARN:20,INFO:30,DEBUG:40};var V=class{constructor(t){f(this,"id");f(this,"level");this.id=t.id,this.level=t.level;}getLevel(){return this.level}setLevel(t){this.level=t;}error(t,o){this.level<u.ERROR||console.error("[ERROR]",this.createLogSchema(u.ERROR,t,o));}warn(t,o){this.level<u.WARN||console.warn("[WARN]",this.createLogSchema(u.WARN,t,o));}info(t,o){this.level<u.INFO||console.info("[INFO]",this.createLogSchema(u.INFO,t,o));}debug(t,o){this.level<u.DEBUG||console.debug("[DEBUG]",this.createLogSchema(u.DEBUG,t,o));}createLogSchema(t,o,r){return JSON.stringify({id:this.id,level:t,message:o,data:r,timestamp:Date.now()})}};var P="bp-m-ver",T="bp-cid",A="bp-sid",w="bp-aid",v="bp-p-type",I="bp-p-ver",R="bp-a-name",x="bp-a-ver",C="bp-s-country",U="bp-locale",j="bp-tz",N="b_visitor_id",y=[P,T,A,w,v,I,R,x,C,U,j,N];function a(e=3456e7){return Date.now()+e}function d(){return {"bp-m-ver":"","bp-cid":"","bp-sid":"","bp-aid":"","bp-p-type":"","bp-p-ver":"","bp-a-name":"","bp-a-ver":"","bp-s-country":"","bp-locale":"","bp-tz":"",b_visitor_id:""}}function _(e){return e.split(";").reduce((t,o)=>{var m,i;let r=o.trim().split("="),c=(m=r[0])!=null?m:"",p=(i=r[1])!=null?i:"";return !c||!p||!y.includes(c)?t:Object.assign(t,{[c]:p})},d())}function M(e){let t=U,o=e.value?e.value:"";return {name:t,value:o,cookie:()=>{let r=a();return `${t}=${o}; path=/; domain=${e.domain}; expires=${new Date(r).toUTCString()}`}}}new V({id:"metadata",level:u.OFF});

var n=new V({id:"metadata:server",level:u.OFF});function me({metadata:t,req:e,res:r,value:a}){var s;if(typeof window!="undefined"){n.warn("\uC11C\uBC84 \uD658\uACBD\uC774 \uC544\uB2D9\uB2C8\uB2E4.");return}let i=t.set("bp-locale",M({domain:t.config.cookieDomain,value:a})),c=(s=r.getHeader("set-cookie"))!=null?s:[],o=`${i.name}=${i.value}`;r.setHeader("set-cookie",[...c,i.cookie()]),e.headers.cookie=e.headers.cookie?`${e.headers.cookie}; ${o}`:o;}

/**
 * @see {@link https://mbff.qa-web.ohouse.in/webjars/swagger-ui/index.html#/meta/intro}
 */
const getMetaIntroData = async (req, env) => {
  const META_INTRO_API_URL = `${GLOBAL_API_GATEWAY[env]}/config/meta/intro`;
  const res = await fetch(META_INTRO_API_URL, {
    headers: {
      'true-client-ip': getClientIp(req) ?? ''
    }
  });
  const data = await res.json();
  return data;
};
const getBpLocale = req => req.metadata?.data?.get(U)?.value;

/**
 * locale 없는 url의 redirect에 사용할 locale을 return 합니다.
 */
const getDefaultLocale = async (req, env) => {
  const localeFromMetadata = getBpLocale(req)?.split('-')[0];
  const allowedLocale = checkAllowedLocale(localeFromMetadata);
  if (allowedLocale) {
    return allowedLocale;
  }
  const data = await getMetaIntroData(req, env);
  return checkAllowedLocale(data?.lang) ?? GLOBAL_DEFAULT_LOCALE;
};

const createCookieDomain = env => {
  const host = GLOBAL_DOMAINS[env]['home'];
  return /https?:\/\/([^/]+)/.exec(host)[1];
};
const updateSetHeader = (res, locale, env) => {
  const ONE_DAY = 24 * 3600 * 1000;
  const expireDate = new Date(Date.now() + ONE_DAY).toUTCString();
  const setCookie = res.getHeader('set-cookie');
  const cookies = isArray$3(setCookie) ? setCookie : [];
  const newBpSCountry = findKey(GLOBAL_INFO, info => info.locale === locale);
  const cookieDomain = `.${createCookieDomain(env)}`;
  res.setHeader('set-cookie', [...cookies, `bp-s-country=${newBpSCountry}; path=/; domain=${cookieDomain}; expires=${expireDate}`]);
};
const globalMiddleware = {
  express: ({
    env
  }) => async (req, res, next) => {
    const relativeUrl = req.url;
    if (isNextJsPageRequest(relativeUrl) && req.metadata) {
      const locale = getLocaleFromUrl(relativeUrl);
      const appName = req.metadata.data?.get(R)?.value;
      const country = req.metadata.data?.get(C)?.value;
      if (!locale) {
        const defaultLocale = await getDefaultLocale(req, env);
        const currentUrlWithLocale = `/${defaultLocale}${relativeUrl}`;
        const defaultUrl = createGlobalDefaultUrl({
          env,
          locale: defaultLocale,
          country,
          appName
        });
        const redirectUrl = isRootPathnameWithLocale(currentUrlWithLocale) ? defaultUrl : currentUrlWithLocale;
        res.redirect(302, redirectUrl);
        return;
      }
      if (isRootPathnameWithLocale(relativeUrl)) {
        const defaultUrl = createGlobalDefaultUrl({
          env,
          locale,
          country,
          appName
        });
        res.redirect(302, defaultUrl);
        return;
      }
      const userAgent = req.headers['user-agent'];
      if (userAgent && isSearchRobot(userAgent)) {
        updateSetHeader(res, locale, env);
      }
      me({
        metadata: req.metadata,
        req,
        res,
        value: locale
      });
    }
    next();
  }
};

var _path$4;
function _extends$5() { return _extends$5 = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$5.apply(null, arguments); }
var SvgNew = function SvgNew(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends$5({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path$4 || (_path$4 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: "currentColor",
    d: "M4.186 15v-3.93h.037L6.994 15h1.027V9H6.834v3.909h-.033L4.035 9H3v6zM12.794 13.96H10.11v-1.513h2.533v-.965H10.11v-1.447h2.684V9H8.87v6h3.924zM17.096 10.9h.037l1.125 4.1h1.17L21 9h-1.285l-.936 4.345h-.033L17.638 9H16.59l-1.108 4.345h-.033L14.518 9h-1.285l1.568 6h1.17z"
  })));
};
var NewIcon$1 = SvgNew;

function _EMOTION_STRINGIFIED_CSS_ERROR__$o() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
const STATUS_MARKER_ICONS_MAPPING = {
  new: () => (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(NewIconWrapper, {
    children: (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(NewIcon$1, {})
  }),
  higher: () => (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(IconFlipper, {
    children: (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(IconColorizer, {
      className: "higher",
      children: (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(_bucketplace_design_system_bds__WEBPACK_IMPORTED_MODULE_8__/* .Icon */ .JO$, {
        size: 24,
        name: "dropdown"
      })
    })
  }),
  lower: () => (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(IconColorizer, {
    className: "lower",
    children: (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(_bucketplace_design_system_bds__WEBPACK_IMPORTED_MODULE_8__/* .Icon */ .JO$, {
      size: 24,
      name: "dropdown"
    })
  }),
  constant: () => (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(IconColorizer, {
    className: "constant",
    children: (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(_bucketplace_design_system_bds__WEBPACK_IMPORTED_MODULE_8__/* .Icon */ .JO$, {
      size: 24,
      name: "unconverted"
    })
  })
};
function TrendingKeywordsEntry(props) {
  const {
    className,
    rank,
    status,
    title
  } = props;
  const marker = STATUS_MARKER_ICONS_MAPPING[status];
  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsxs */ .BX)(Container$4, {
    className: className,
    children: [(0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(RankNumberGutter, {
      children: rank
    }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(StatusMarker, {
      children: /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(marker ?? STATUS_MARKER_ICONS_MAPPING['constant'])
    }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(Title, {
      children: title
    })]
  });
}
const Container$4 = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)("div",  true ? {
  target: "e1p2u4vj6"
} : 0)( true ? {
  name: "s5xdrg",
  styles: "display:flex;align-items:center"
} : 0);
const RankNumberGutter = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)("span",  true ? {
  target: "e1p2u4vj5"
} : 0)("display:inline-block;", _bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.F.subTitle1, ";font-style:normal;font-weight:700;color:", ({
  theme
}) => theme.content.base1, ";text-align:center;margin-right:2px;min-width:20px;" + ( true ? "" : 0));
const StatusMarker = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)("span",  true ? {
  target: "e1p2u4vj4"
} : 0)( true ? {
  name: "ckw133",
  styles: "margin-right:6px;display:flex;align-items:center"
} : 0);
const Title = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)("span",  true ? {
  target: "e1p2u4vj3"
} : 0)("display:inline-block;", _bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.F.subTitle1, ";flex:1 0 auto;font-style:normal;font-weight:400;color:", ({
  theme
}) => theme.content.base1, ";white-space:nowrap;text-overflow:ellipsis;overflow:hidden;width:104px;" + ( true ? "" : 0));
const IconFlipper = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)("span",  true ? {
  target: "e1p2u4vj2"
} : 0)( true ? {
  name: "1mnpgkl",
  styles: "display:block;transform:rotate(180deg)"
} : 0);
const IconColorizer = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)("span",  true ? {
  target: "e1p2u4vj1"
} : 0)("display:block;>span{display:block;}&.higher{color:", ({
  theme
}) => theme.content.primary2.thick, ";}&.lower{color:", ({
  theme
}) => theme.content.primary1.thick, ";}&.constant{color:", ({
  theme
}) => theme.content.base3, ";}" + ( true ? "" : 0));
const NewIconWrapper = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)("span",  true ? {
  target: "e1p2u4vj0"
} : 0)("display:block;width:24px;height:24px;>svg{display:block;width:100%;height:auto;color:", ({
  theme
}) => theme.content.primary2.thick, ";}" + ( true ? "" : 0));

// FIXME: Use exports from @bucketplace/bucket-log instead;
// Leaving this as there's unresolved module resolution issue with bucket-log.
function sendImpressionLog(logData) {
  L({
    category: 'impression',
    data: [{
      ...f$1(logData),
      time: Date.now()
    }]
  });
}
function serializePathToString(path) {
  if (typeof path === 'string') {
    return path;
  }
  return `${path.pathname ?? ''}${path.search ?? ''}${path.hash ?? ''}`;
}

/**
 * 연결된 `ref` 요소가 화면에 보이기 시작하면 `logData`를 가지고 impression 로그를 전송합니다.
 */
function useImpressionLog({
  logData,
  threshold,
  disable
}) {
  const {
    ref,
    inView
  } = useInView({
    threshold,
    skip: disable,
    triggerOnce: true
  });
  useEffect(() => {
    if (inView && !disable && !!logData) {
      sendImpressionLog(logData);
    }
  }, [inView, disable, logData]);
  return {
    ref
  };
}

/**
 * 감싸진 `children`이 화면에 보이기 시작하면 `logData`를 가지고 impression
 * 로그를 전송합니다.
 *
 * `children`이 html element(styled components)이거나, forwardRef로 감싸진
 * 컴포넌트인 경우에만 사용 가능합니다.
 *
 * 더 많은 컨트롤이 필요하다면 useImpressionLog() hook을 사용하세요.
 */
function ImpressionTracker(props) {
  const {
    threshold = 0.5,
    logData,
    disable,
    children
  } = props;
  const handleChange = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(inView => {
    if (inView && !disable && logData != null) {
      L({
        category: 'impression',
        data: [{
          ...f$1(logData),
          time: Date.now()
        }]
      });
    }
  }, [disable, logData]);
  if (logData == null) {
    return children;
  }
  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(InView, {
    threshold: threshold,
    skip: disable,
    onChange: handleChange,
    triggerOnce: true,
    children: ({
      ref: inViewRef
    }) => react__WEBPACK_IMPORTED_MODULE_0__.Children.map(children, child => {
      const ref = node => {
        if (child.props.ref != null) {
          if (typeof child.props.ref === 'function') {
            child.props.ref(node);
          } else {
            child.props.ref.current = node;
          }
        }
        if (inViewRef != null) {
          if (typeof inViewRef === 'function') {
            inViewRef(node);
          } else {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            inViewRef.current = node;
          }
        }
      };
      return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.cloneElement(child, {
        ref
      });
    })
  });
}

/**
 * Checks whether we're in a browser environment
 *
 * @returns Answer to given question
 */
function isBrowserEnv() {
  return typeof window === 'object' && (window === null || window === void 0 ? void 0 : window.document) !== undefined;
}
/**
 * Fixes browser edge case where Prototype.js injects Array.prototype.toJSON and breaks the built-in JSON.stringify()
 *
 * @returns true if Array.prototype.toJSON was deleted, false if not
 */
var prototypeJsFix = function () {
  var _a;
  if (isBrowserEnv()) {
    var augmentedWindow = window;
    var augmentedArray = Array;
    if (augmentedWindow.Prototype !== undefined && ((_a = augmentedArray.prototype) === null || _a === void 0 ? void 0 : _a.toJSON) !== undefined) {
      delete augmentedArray.prototype.toJSON;
      return true;
    }
  }
  return false;
};

var md5$1 = {exports: {}};

/*
 * JavaScript MD5
 * https://github.com/blueimp/JavaScript-MD5
 *
 * Copyright 2011, Sebastian Tschan
 * https://blueimp.net
 *
 * Licensed under the MIT license:
 * https://opensource.org/licenses/MIT
 *
 * Based on
 * A JavaScript implementation of the RSA Data Security, Inc. MD5 Message
 * Digest Algorithm, as defined in RFC 1321.
 * Version 2.2 Copyright (C) Paul Johnston 1999 - 2009
 * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
 * Distributed under the BSD License
 * See http://pajhome.org.uk/crypt/md5 for more info.
 */
(function (module) {
  (function ($) {

    /**
     * Add integers, wrapping at 2^32.
     * This uses 16-bit operations internally to work around bugs in interpreters.
     *
     * @param {number} x First integer
     * @param {number} y Second integer
     * @returns {number} Sum
     */
    function safeAdd(x, y) {
      var lsw = (x & 0xffff) + (y & 0xffff);
      var msw = (x >> 16) + (y >> 16) + (lsw >> 16);
      return msw << 16 | lsw & 0xffff;
    }

    /**
     * Bitwise rotate a 32-bit number to the left.
     *
     * @param {number} num 32-bit number
     * @param {number} cnt Rotation count
     * @returns {number} Rotated number
     */
    function bitRotateLeft(num, cnt) {
      return num << cnt | num >>> 32 - cnt;
    }

    /**
     * Basic operation the algorithm uses.
     *
     * @param {number} q q
     * @param {number} a a
     * @param {number} b b
     * @param {number} x x
     * @param {number} s s
     * @param {number} t t
     * @returns {number} Result
     */
    function md5cmn(q, a, b, x, s, t) {
      return safeAdd(bitRotateLeft(safeAdd(safeAdd(a, q), safeAdd(x, t)), s), b);
    }
    /**
     * Basic operation the algorithm uses.
     *
     * @param {number} a a
     * @param {number} b b
     * @param {number} c c
     * @param {number} d d
     * @param {number} x x
     * @param {number} s s
     * @param {number} t t
     * @returns {number} Result
     */
    function md5ff(a, b, c, d, x, s, t) {
      return md5cmn(b & c | ~b & d, a, b, x, s, t);
    }
    /**
     * Basic operation the algorithm uses.
     *
     * @param {number} a a
     * @param {number} b b
     * @param {number} c c
     * @param {number} d d
     * @param {number} x x
     * @param {number} s s
     * @param {number} t t
     * @returns {number} Result
     */
    function md5gg(a, b, c, d, x, s, t) {
      return md5cmn(b & d | c & ~d, a, b, x, s, t);
    }
    /**
     * Basic operation the algorithm uses.
     *
     * @param {number} a a
     * @param {number} b b
     * @param {number} c c
     * @param {number} d d
     * @param {number} x x
     * @param {number} s s
     * @param {number} t t
     * @returns {number} Result
     */
    function md5hh(a, b, c, d, x, s, t) {
      return md5cmn(b ^ c ^ d, a, b, x, s, t);
    }
    /**
     * Basic operation the algorithm uses.
     *
     * @param {number} a a
     * @param {number} b b
     * @param {number} c c
     * @param {number} d d
     * @param {number} x x
     * @param {number} s s
     * @param {number} t t
     * @returns {number} Result
     */
    function md5ii(a, b, c, d, x, s, t) {
      return md5cmn(c ^ (b | ~d), a, b, x, s, t);
    }

    /**
     * Calculate the MD5 of an array of little-endian words, and a bit length.
     *
     * @param {Array} x Array of little-endian words
     * @param {number} len Bit length
     * @returns {Array<number>} MD5 Array
     */
    function binlMD5(x, len) {
      /* append padding */
      x[len >> 5] |= 0x80 << len % 32;
      x[(len + 64 >>> 9 << 4) + 14] = len;
      var i;
      var olda;
      var oldb;
      var oldc;
      var oldd;
      var a = 1732584193;
      var b = -271733879;
      var c = -1732584194;
      var d = 271733878;
      for (i = 0; i < x.length; i += 16) {
        olda = a;
        oldb = b;
        oldc = c;
        oldd = d;
        a = md5ff(a, b, c, d, x[i], 7, -680876936);
        d = md5ff(d, a, b, c, x[i + 1], 12, -389564586);
        c = md5ff(c, d, a, b, x[i + 2], 17, 606105819);
        b = md5ff(b, c, d, a, x[i + 3], 22, -1044525330);
        a = md5ff(a, b, c, d, x[i + 4], 7, -176418897);
        d = md5ff(d, a, b, c, x[i + 5], 12, 1200080426);
        c = md5ff(c, d, a, b, x[i + 6], 17, -1473231341);
        b = md5ff(b, c, d, a, x[i + 7], 22, -45705983);
        a = md5ff(a, b, c, d, x[i + 8], 7, 1770035416);
        d = md5ff(d, a, b, c, x[i + 9], 12, -1958414417);
        c = md5ff(c, d, a, b, x[i + 10], 17, -42063);
        b = md5ff(b, c, d, a, x[i + 11], 22, -1990404162);
        a = md5ff(a, b, c, d, x[i + 12], 7, 1804603682);
        d = md5ff(d, a, b, c, x[i + 13], 12, -40341101);
        c = md5ff(c, d, a, b, x[i + 14], 17, -1502002290);
        b = md5ff(b, c, d, a, x[i + 15], 22, 1236535329);
        a = md5gg(a, b, c, d, x[i + 1], 5, -165796510);
        d = md5gg(d, a, b, c, x[i + 6], 9, -1069501632);
        c = md5gg(c, d, a, b, x[i + 11], 14, 643717713);
        b = md5gg(b, c, d, a, x[i], 20, -373897302);
        a = md5gg(a, b, c, d, x[i + 5], 5, -701558691);
        d = md5gg(d, a, b, c, x[i + 10], 9, 38016083);
        c = md5gg(c, d, a, b, x[i + 15], 14, -660478335);
        b = md5gg(b, c, d, a, x[i + 4], 20, -405537848);
        a = md5gg(a, b, c, d, x[i + 9], 5, 568446438);
        d = md5gg(d, a, b, c, x[i + 14], 9, -1019803690);
        c = md5gg(c, d, a, b, x[i + 3], 14, -187363961);
        b = md5gg(b, c, d, a, x[i + 8], 20, 1163531501);
        a = md5gg(a, b, c, d, x[i + 13], 5, -1444681467);
        d = md5gg(d, a, b, c, x[i + 2], 9, -51403784);
        c = md5gg(c, d, a, b, x[i + 7], 14, 1735328473);
        b = md5gg(b, c, d, a, x[i + 12], 20, -1926607734);
        a = md5hh(a, b, c, d, x[i + 5], 4, -378558);
        d = md5hh(d, a, b, c, x[i + 8], 11, -2022574463);
        c = md5hh(c, d, a, b, x[i + 11], 16, 1839030562);
        b = md5hh(b, c, d, a, x[i + 14], 23, -35309556);
        a = md5hh(a, b, c, d, x[i + 1], 4, -1530992060);
        d = md5hh(d, a, b, c, x[i + 4], 11, 1272893353);
        c = md5hh(c, d, a, b, x[i + 7], 16, -155497632);
        b = md5hh(b, c, d, a, x[i + 10], 23, -1094730640);
        a = md5hh(a, b, c, d, x[i + 13], 4, 681279174);
        d = md5hh(d, a, b, c, x[i], 11, -358537222);
        c = md5hh(c, d, a, b, x[i + 3], 16, -722521979);
        b = md5hh(b, c, d, a, x[i + 6], 23, 76029189);
        a = md5hh(a, b, c, d, x[i + 9], 4, -640364487);
        d = md5hh(d, a, b, c, x[i + 12], 11, -421815835);
        c = md5hh(c, d, a, b, x[i + 15], 16, 530742520);
        b = md5hh(b, c, d, a, x[i + 2], 23, -995338651);
        a = md5ii(a, b, c, d, x[i], 6, -198630844);
        d = md5ii(d, a, b, c, x[i + 7], 10, 1126891415);
        c = md5ii(c, d, a, b, x[i + 14], 15, -1416354905);
        b = md5ii(b, c, d, a, x[i + 5], 21, -57434055);
        a = md5ii(a, b, c, d, x[i + 12], 6, 1700485571);
        d = md5ii(d, a, b, c, x[i + 3], 10, -1894986606);
        c = md5ii(c, d, a, b, x[i + 10], 15, -1051523);
        b = md5ii(b, c, d, a, x[i + 1], 21, -2054922799);
        a = md5ii(a, b, c, d, x[i + 8], 6, 1873313359);
        d = md5ii(d, a, b, c, x[i + 15], 10, -30611744);
        c = md5ii(c, d, a, b, x[i + 6], 15, -1560198380);
        b = md5ii(b, c, d, a, x[i + 13], 21, 1309151649);
        a = md5ii(a, b, c, d, x[i + 4], 6, -145523070);
        d = md5ii(d, a, b, c, x[i + 11], 10, -1120210379);
        c = md5ii(c, d, a, b, x[i + 2], 15, 718787259);
        b = md5ii(b, c, d, a, x[i + 9], 21, -343485551);
        a = safeAdd(a, olda);
        b = safeAdd(b, oldb);
        c = safeAdd(c, oldc);
        d = safeAdd(d, oldd);
      }
      return [a, b, c, d];
    }

    /**
     * Convert an array of little-endian words to a string
     *
     * @param {Array<number>} input MD5 Array
     * @returns {string} MD5 string
     */
    function binl2rstr(input) {
      var i;
      var output = '';
      var length32 = input.length * 32;
      for (i = 0; i < length32; i += 8) {
        output += String.fromCharCode(input[i >> 5] >>> i % 32 & 0xff);
      }
      return output;
    }

    /**
     * Convert a raw string to an array of little-endian words
     * Characters >255 have their high-byte silently ignored.
     *
     * @param {string} input Raw input string
     * @returns {Array<number>} Array of little-endian words
     */
    function rstr2binl(input) {
      var i;
      var output = [];
      output[(input.length >> 2) - 1] = undefined;
      for (i = 0; i < output.length; i += 1) {
        output[i] = 0;
      }
      var length8 = input.length * 8;
      for (i = 0; i < length8; i += 8) {
        output[i >> 5] |= (input.charCodeAt(i / 8) & 0xff) << i % 32;
      }
      return output;
    }

    /**
     * Calculate the MD5 of a raw string
     *
     * @param {string} s Input string
     * @returns {string} Raw MD5 string
     */
    function rstrMD5(s) {
      return binl2rstr(binlMD5(rstr2binl(s), s.length * 8));
    }

    /**
     * Calculates the HMAC-MD5 of a key and some data (raw strings)
     *
     * @param {string} key HMAC key
     * @param {string} data Raw input string
     * @returns {string} Raw MD5 string
     */
    function rstrHMACMD5(key, data) {
      var i;
      var bkey = rstr2binl(key);
      var ipad = [];
      var opad = [];
      var hash;
      ipad[15] = opad[15] = undefined;
      if (bkey.length > 16) {
        bkey = binlMD5(bkey, key.length * 8);
      }
      for (i = 0; i < 16; i += 1) {
        ipad[i] = bkey[i] ^ 0x36363636;
        opad[i] = bkey[i] ^ 0x5c5c5c5c;
      }
      hash = binlMD5(ipad.concat(rstr2binl(data)), 512 + data.length * 8);
      return binl2rstr(binlMD5(opad.concat(hash), 512 + 128));
    }

    /**
     * Convert a raw string to a hex string
     *
     * @param {string} input Raw input string
     * @returns {string} Hex encoded string
     */
    function rstr2hex(input) {
      var hexTab = '0123456789abcdef';
      var output = '';
      var x;
      var i;
      for (i = 0; i < input.length; i += 1) {
        x = input.charCodeAt(i);
        output += hexTab.charAt(x >>> 4 & 0x0f) + hexTab.charAt(x & 0x0f);
      }
      return output;
    }

    /**
     * Encode a string as UTF-8
     *
     * @param {string} input Input string
     * @returns {string} UTF8 string
     */
    function str2rstrUTF8(input) {
      return unescape(encodeURIComponent(input));
    }

    /**
     * Encodes input string as raw MD5 string
     *
     * @param {string} s Input string
     * @returns {string} Raw MD5 string
     */
    function rawMD5(s) {
      return rstrMD5(str2rstrUTF8(s));
    }
    /**
     * Encodes input string as Hex encoded string
     *
     * @param {string} s Input string
     * @returns {string} Hex encoded string
     */
    function hexMD5(s) {
      return rstr2hex(rawMD5(s));
    }
    /**
     * Calculates the raw HMAC-MD5 for the given key and data
     *
     * @param {string} k HMAC key
     * @param {string} d Input string
     * @returns {string} Raw MD5 string
     */
    function rawHMACMD5(k, d) {
      return rstrHMACMD5(str2rstrUTF8(k), str2rstrUTF8(d));
    }
    /**
     * Calculates the Hex encoded HMAC-MD5 for the given key and data
     *
     * @param {string} k HMAC key
     * @param {string} d Input string
     * @returns {string} Raw MD5 string
     */
    function hexHMACMD5(k, d) {
      return rstr2hex(rawHMACMD5(k, d));
    }

    /**
     * Calculates MD5 value for a given string.
     * If a key is provided, calculates the HMAC-MD5 value.
     * Returns a Hex encoded string unless the raw argument is given.
     *
     * @param {string} string Input string
     * @param {string} [key] HMAC key
     * @param {boolean} [raw] Raw output switch
     * @returns {string} MD5 output
     */
    function md5(string, key, raw) {
      if (!key) {
        if (!raw) {
          return hexMD5(string);
        }
        return rawMD5(string);
      }
      if (!raw) {
        return hexHMACMD5(key, string);
      }
      return rawHMACMD5(key, string);
    }
    if (module.exports) {
      module.exports = md5;
    } else {
      $.md5 = md5;
    }
  })(commonjsGlobal);
})(md5$1);
var md5Exports = md5$1.exports;
var md5 = /*@__PURE__*/getDefaultExportFromCjs$1(md5Exports);

const token$1 = '%[a-f0-9]{2}';
const singleMatcher$1 = new RegExp('(' + token$1 + ')|([^%]+?)', 'gi');
const multiMatcher$1 = new RegExp('(' + token$1 + ')+', 'gi');
function decodeComponents$1(components, split) {
  try {
    // Try to decode the entire string first
    return [decodeURIComponent(components.join(''))];
  } catch {
    // Do nothing
  }
  if (components.length === 1) {
    return components;
  }
  split = split || 1;

  // Split the array in 2 parts
  const left = components.slice(0, split);
  const right = components.slice(split);
  return Array.prototype.concat.call([], decodeComponents$1(left), decodeComponents$1(right));
}
function decode$2(input) {
  try {
    return decodeURIComponent(input);
  } catch {
    let tokens = input.match(singleMatcher$1) || [];
    for (let i = 1; i < tokens.length; i++) {
      input = decodeComponents$1(tokens, i).join('');
      tokens = input.match(singleMatcher$1) || [];
    }
    return input;
  }
}
function customDecodeURIComponent$1(input) {
  // Keep track of all the replacements and prefill the map with the `BOM`
  const replaceMap = {
    '%FE%FF': '\uFFFD\uFFFD',
    '%FF%FE': '\uFFFD\uFFFD'
  };
  let match = multiMatcher$1.exec(input);
  while (match) {
    try {
      // Decode as big chunks as possible
      replaceMap[match[0]] = decodeURIComponent(match[0]);
    } catch {
      const result = decode$2(match[0]);
      if (result !== match[0]) {
        replaceMap[match[0]] = result;
      }
    }
    match = multiMatcher$1.exec(input);
  }

  // Add `%C2` at the end of the map to make sure it does not replace the combinator before everything else
  replaceMap['%C2'] = '\uFFFD';
  const entries = Object.keys(replaceMap);
  for (const key of entries) {
    // Replace all decoded components
    input = input.replace(new RegExp(key, 'g'), replaceMap[key]);
  }
  return input;
}
function decodeUriComponent$1(encodedURI) {
  if (typeof encodedURI !== 'string') {
    throw new TypeError('Expected `encodedURI` to be of type `string`, got `' + typeof encodedURI + '`');
  }
  try {
    // Try the built in decoder first
    return decodeURIComponent(encodedURI);
  } catch {
    // Fallback to a more advanced decoder
    return customDecodeURIComponent$1(encodedURI);
  }
}

function splitOnFirst$1(string, separator) {
  if (!(typeof string === 'string' && typeof separator === 'string')) {
    throw new TypeError('Expected the arguments to be of type `string`');
  }
  if (string === '' || separator === '') {
    return [];
  }
  const separatorIndex = string.indexOf(separator);
  if (separatorIndex === -1) {
    return [];
  }
  return [string.slice(0, separatorIndex), string.slice(separatorIndex + separator.length)];
}

function includeKeys(object, predicate) {
  const result = {};
  if (Array.isArray(predicate)) {
    for (const key of predicate) {
      const descriptor = Object.getOwnPropertyDescriptor(object, key);
      if (descriptor?.enumerable) {
        Object.defineProperty(result, key, descriptor);
      }
    }
  } else {
    // `Reflect.ownKeys()` is required to retrieve symbol properties
    for (const key of Reflect.ownKeys(object)) {
      const descriptor = Object.getOwnPropertyDescriptor(object, key);
      if (descriptor.enumerable) {
        const value = object[key];
        if (predicate(key, value, object)) {
          Object.defineProperty(result, key, descriptor);
        }
      }
    }
  }
  return result;
}

const isNullOrUndefined = value => value === null || value === undefined;

// eslint-disable-next-line unicorn/prefer-code-point
const strictUriEncode$1 = string => encodeURIComponent(string).replace(/[!'()*]/g, x => `%${x.charCodeAt(0).toString(16).toUpperCase()}`);
const encodeFragmentIdentifier = Symbol('encodeFragmentIdentifier');
function encoderForArrayFormat(options) {
  switch (options.arrayFormat) {
    case 'index':
      {
        return key => (result, value) => {
          const index = result.length;
          if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === '') {
            return result;
          }
          if (value === null) {
            return [...result, [encode(key, options), '[', index, ']'].join('')];
          }
          return [...result, [encode(key, options), '[', encode(index, options), ']=', encode(value, options)].join('')];
        };
      }
    case 'bracket':
      {
        return key => (result, value) => {
          if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === '') {
            return result;
          }
          if (value === null) {
            return [...result, [encode(key, options), '[]'].join('')];
          }
          return [...result, [encode(key, options), '[]=', encode(value, options)].join('')];
        };
      }
    case 'colon-list-separator':
      {
        return key => (result, value) => {
          if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === '') {
            return result;
          }
          if (value === null) {
            return [...result, [encode(key, options), ':list='].join('')];
          }
          return [...result, [encode(key, options), ':list=', encode(value, options)].join('')];
        };
      }
    case 'comma':
    case 'separator':
    case 'bracket-separator':
      {
        const keyValueSep = options.arrayFormat === 'bracket-separator' ? '[]=' : '=';
        return key => (result, value) => {
          if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === '') {
            return result;
          }

          // Translate null to an empty string so that it doesn't serialize as 'null'
          value = value === null ? '' : value;
          if (result.length === 0) {
            return [[encode(key, options), keyValueSep, encode(value, options)].join('')];
          }
          return [[result, encode(value, options)].join(options.arrayFormatSeparator)];
        };
      }
    default:
      {
        return key => (result, value) => {
          if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === '') {
            return result;
          }
          if (value === null) {
            return [...result, encode(key, options)];
          }
          return [...result, [encode(key, options), '=', encode(value, options)].join('')];
        };
      }
  }
}
function parserForArrayFormat(options) {
  let result;
  switch (options.arrayFormat) {
    case 'index':
      {
        return (key, value, accumulator) => {
          result = /\[(\d*)]$/.exec(key);
          key = key.replace(/\[\d*]$/, '');
          if (!result) {
            accumulator[key] = value;
            return;
          }
          if (accumulator[key] === undefined) {
            accumulator[key] = {};
          }
          accumulator[key][result[1]] = value;
        };
      }
    case 'bracket':
      {
        return (key, value, accumulator) => {
          result = /(\[])$/.exec(key);
          key = key.replace(/\[]$/, '');
          if (!result) {
            accumulator[key] = value;
            return;
          }
          if (accumulator[key] === undefined) {
            accumulator[key] = [value];
            return;
          }
          accumulator[key] = [...accumulator[key], value];
        };
      }
    case 'colon-list-separator':
      {
        return (key, value, accumulator) => {
          result = /(:list)$/.exec(key);
          key = key.replace(/:list$/, '');
          if (!result) {
            accumulator[key] = value;
            return;
          }
          if (accumulator[key] === undefined) {
            accumulator[key] = [value];
            return;
          }
          accumulator[key] = [...accumulator[key], value];
        };
      }
    case 'comma':
    case 'separator':
      {
        return (key, value, accumulator) => {
          const isArray = typeof value === 'string' && value.includes(options.arrayFormatSeparator);
          const isEncodedArray = typeof value === 'string' && !isArray && decode$1(value, options).includes(options.arrayFormatSeparator);
          value = isEncodedArray ? decode$1(value, options) : value;
          const newValue = isArray || isEncodedArray ? value.split(options.arrayFormatSeparator).map(item => decode$1(item, options)) : value === null ? value : decode$1(value, options);
          accumulator[key] = newValue;
        };
      }
    case 'bracket-separator':
      {
        return (key, value, accumulator) => {
          const isArray = /(\[])$/.test(key);
          key = key.replace(/\[]$/, '');
          if (!isArray) {
            accumulator[key] = value ? decode$1(value, options) : value;
            return;
          }
          const arrayValue = value === null ? [] : value.split(options.arrayFormatSeparator).map(item => decode$1(item, options));
          if (accumulator[key] === undefined) {
            accumulator[key] = arrayValue;
            return;
          }
          accumulator[key] = [...accumulator[key], ...arrayValue];
        };
      }
    default:
      {
        return (key, value, accumulator) => {
          if (accumulator[key] === undefined) {
            accumulator[key] = value;
            return;
          }
          accumulator[key] = [...[accumulator[key]].flat(), value];
        };
      }
  }
}
function validateArrayFormatSeparator(value) {
  if (typeof value !== 'string' || value.length !== 1) {
    throw new TypeError('arrayFormatSeparator must be single character string');
  }
}
function encode(value, options) {
  if (options.encode) {
    return options.strict ? strictUriEncode$1(value) : encodeURIComponent(value);
  }
  return value;
}
function decode$1(value, options) {
  if (options.decode) {
    return decodeUriComponent$1(value);
  }
  return value;
}
function keysSorter(input) {
  if (Array.isArray(input)) {
    return input.sort();
  }
  if (typeof input === 'object') {
    return keysSorter(Object.keys(input)).sort((a, b) => Number(a) - Number(b)).map(key => input[key]);
  }
  return input;
}
function removeHash(input) {
  const hashStart = input.indexOf('#');
  if (hashStart !== -1) {
    input = input.slice(0, hashStart);
  }
  return input;
}
function getHash(url) {
  let hash = '';
  const hashStart = url.indexOf('#');
  if (hashStart !== -1) {
    hash = url.slice(hashStart);
  }
  return hash;
}
function parseValue(value, options) {
  if (options.parseNumbers && !Number.isNaN(Number(value)) && typeof value === 'string' && value.trim() !== '') {
    value = Number(value);
  } else if (options.parseBooleans && value !== null && (value.toLowerCase() === 'true' || value.toLowerCase() === 'false')) {
    value = value.toLowerCase() === 'true';
  }
  return value;
}
function extract(input) {
  input = removeHash(input);
  const queryStart = input.indexOf('?');
  if (queryStart === -1) {
    return '';
  }
  return input.slice(queryStart + 1);
}
function parse(query, options) {
  options = {
    decode: true,
    sort: true,
    arrayFormat: 'none',
    arrayFormatSeparator: ',',
    parseNumbers: false,
    parseBooleans: false,
    ...options
  };
  validateArrayFormatSeparator(options.arrayFormatSeparator);
  const formatter = parserForArrayFormat(options);

  // Create an object with no prototype
  const returnValue = Object.create(null);
  if (typeof query !== 'string') {
    return returnValue;
  }
  query = query.trim().replace(/^[?#&]/, '');
  if (!query) {
    return returnValue;
  }
  for (const parameter of query.split('&')) {
    if (parameter === '') {
      continue;
    }
    const parameter_ = options.decode ? parameter.replace(/\+/g, ' ') : parameter;
    let [key, value] = splitOnFirst$1(parameter_, '=');
    if (key === undefined) {
      key = parameter_;
    }

    // Missing `=` should be `null`:
    // http://w3.org/TR/2012/WD-url-20120524/#collect-url-parameters
    value = value === undefined ? null : ['comma', 'separator', 'bracket-separator'].includes(options.arrayFormat) ? value : decode$1(value, options);
    formatter(decode$1(key, options), value, returnValue);
  }
  for (const [key, value] of Object.entries(returnValue)) {
    if (typeof value === 'object' && value !== null) {
      for (const [key2, value2] of Object.entries(value)) {
        value[key2] = parseValue(value2, options);
      }
    } else {
      returnValue[key] = parseValue(value, options);
    }
  }
  if (options.sort === false) {
    return returnValue;
  }

  // TODO: Remove the use of `reduce`.
  // eslint-disable-next-line unicorn/no-array-reduce
  return (options.sort === true ? Object.keys(returnValue).sort() : Object.keys(returnValue).sort(options.sort)).reduce((result, key) => {
    const value = returnValue[key];
    if (Boolean(value) && typeof value === 'object' && !Array.isArray(value)) {
      // Sort object keys, not values
      result[key] = keysSorter(value);
    } else {
      result[key] = value;
    }
    return result;
  }, Object.create(null));
}
function stringify(object, options) {
  if (!object) {
    return '';
  }
  options = {
    encode: true,
    strict: true,
    arrayFormat: 'none',
    arrayFormatSeparator: ',',
    ...options
  };
  validateArrayFormatSeparator(options.arrayFormatSeparator);
  const shouldFilter = key => options.skipNull && isNullOrUndefined(object[key]) || options.skipEmptyString && object[key] === '';
  const formatter = encoderForArrayFormat(options);
  const objectCopy = {};
  for (const [key, value] of Object.entries(object)) {
    if (!shouldFilter(key)) {
      objectCopy[key] = value;
    }
  }
  const keys = Object.keys(objectCopy);
  if (options.sort !== false) {
    keys.sort(options.sort);
  }
  return keys.map(key => {
    const value = object[key];
    if (value === undefined) {
      return '';
    }
    if (value === null) {
      return encode(key, options);
    }
    if (Array.isArray(value)) {
      if (value.length === 0 && options.arrayFormat === 'bracket-separator') {
        return encode(key, options) + '[]';
      }
      return value.reduce(formatter(key), []).join('&');
    }
    return encode(key, options) + '=' + encode(value, options);
  }).filter(x => x.length > 0).join('&');
}
function parseUrl(url, options) {
  options = {
    decode: true,
    ...options
  };
  let [url_, hash] = splitOnFirst$1(url, '#');
  if (url_ === undefined) {
    url_ = url;
  }
  return {
    url: url_?.split('?')?.[0] ?? '',
    query: parse(extract(url), options),
    ...(options && options.parseFragmentIdentifier && hash ? {
      fragmentIdentifier: decode$1(hash, options)
    } : {})
  };
}
function stringifyUrl(object, options) {
  options = {
    encode: true,
    strict: true,
    [encodeFragmentIdentifier]: true,
    ...options
  };
  const url = removeHash(object.url).split('?')[0] || '';
  const queryFromUrl = extract(object.url);
  const query = {
    ...parse(queryFromUrl, {
      sort: false
    }),
    ...object.query
  };
  let queryString = stringify(query, options);
  if (queryString) {
    queryString = `?${queryString}`;
  }
  let hash = getHash(object.url);
  if (object.fragmentIdentifier) {
    const urlObjectForFragmentEncode = new URL(url);
    urlObjectForFragmentEncode.hash = object.fragmentIdentifier;
    hash = options[encodeFragmentIdentifier] ? urlObjectForFragmentEncode.hash : `#${object.fragmentIdentifier}`;
  }
  return `${url}${queryString}${hash}`;
}
function pick(input, filter, options) {
  options = {
    parseFragmentIdentifier: true,
    [encodeFragmentIdentifier]: false,
    ...options
  };
  const {
    url,
    query,
    fragmentIdentifier
  } = parseUrl(input, options);
  return stringifyUrl({
    url,
    query: includeKeys(query, filter),
    fragmentIdentifier
  }, options);
}
function exclude(input, filter, options) {
  const exclusionFilter = Array.isArray(filter) ? key => !filter.includes(key) : (key, value) => !filter(key, value);
  return pick(input, exclusionFilter, options);
}

var queryString$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  exclude: exclude,
  extract: extract,
  parse: parse,
  parseUrl: parseUrl,
  pick: pick,
  stringify: stringify,
  stringifyUrl: stringifyUrl
});

var uaParser = {exports: {}};

(function (module, exports) {
  /////////////////////////////////////////////////////////////////////////////////
  /* UAParser.js v0.7.33
     Copyright © 2012-2021 Faisal Salman <f@faisalman.com>
     MIT License */ /*
                    Detect Browser, Engine, OS, CPU, and Device type/model from User-Agent data.
                    Supports browser & node.js environment.
                    Demo   : https://faisalman.github.io/ua-parser-js
                    Source : https://github.com/faisalman/ua-parser-js */
  /////////////////////////////////////////////////////////////////////////////////

  (function (window, undefined$1) {

    //////////////
    // Constants
    /////////////
    var LIBVERSION = "0.7.33",
      EMPTY = "",
      UNKNOWN = "?",
      FUNC_TYPE = "function",
      UNDEF_TYPE = "undefined",
      OBJ_TYPE = "object",
      STR_TYPE = "string",
      MAJOR = "major",
      MODEL = "model",
      NAME = "name",
      TYPE = "type",
      VENDOR = "vendor",
      VERSION = "version",
      ARCHITECTURE = "architecture",
      CONSOLE = "console",
      MOBILE = "mobile",
      TABLET = "tablet",
      SMARTTV = "smarttv",
      WEARABLE = "wearable",
      EMBEDDED = "embedded",
      UA_MAX_LENGTH = 350;
    var AMAZON = "Amazon",
      APPLE = "Apple",
      ASUS = "ASUS",
      BLACKBERRY = "BlackBerry",
      BROWSER = "Browser",
      CHROME = "Chrome",
      EDGE = "Edge",
      FIREFOX = "Firefox",
      GOOGLE = "Google",
      HUAWEI = "Huawei",
      LG = "LG",
      MICROSOFT = "Microsoft",
      MOTOROLA = "Motorola",
      OPERA = "Opera",
      SAMSUNG = "Samsung",
      SHARP = "Sharp",
      SONY = "Sony",
      XIAOMI = "Xiaomi",
      ZEBRA = "Zebra",
      FACEBOOK = "Facebook";

    ///////////
    // Helper
    //////////

    var extend = function (regexes, extensions) {
        var mergedRegexes = {};
        for (var i in regexes) {
          if (extensions[i] && extensions[i].length % 2 === 0) {
            mergedRegexes[i] = extensions[i].concat(regexes[i]);
          } else {
            mergedRegexes[i] = regexes[i];
          }
        }
        return mergedRegexes;
      },
      enumerize = function (arr) {
        var enums = {};
        for (var i = 0; i < arr.length; i++) {
          enums[arr[i].toUpperCase()] = arr[i];
        }
        return enums;
      },
      has = function (str1, str2) {
        return typeof str1 === STR_TYPE ? lowerize(str2).indexOf(lowerize(str1)) !== -1 : false;
      },
      lowerize = function (str) {
        return str.toLowerCase();
      },
      majorize = function (version) {
        return typeof version === STR_TYPE ? version.replace(/[^\d\.]/g, EMPTY).split(".")[0] : undefined$1;
      },
      trim = function (str, len) {
        if (typeof str === STR_TYPE) {
          str = str.replace(/^\s\s*/, EMPTY);
          return typeof len === UNDEF_TYPE ? str : str.substring(0, UA_MAX_LENGTH);
        }
      };

    ///////////////
    // Map helper
    //////////////

    var rgxMapper = function (ua, arrays) {
        var i = 0,
          j,
          k,
          p,
          q,
          matches,
          match;

        // loop through all regexes maps
        while (i < arrays.length && !matches) {
          var regex = arrays[i],
            // even sequence (0,2,4,..)
            props = arrays[i + 1]; // odd sequence (1,3,5,..)
          j = k = 0;

          // try matching uastring with regexes
          while (j < regex.length && !matches) {
            matches = regex[j++].exec(ua);
            if (!!matches) {
              for (p = 0; p < props.length; p++) {
                match = matches[++k];
                q = props[p];
                // check if given property is actually array
                if (typeof q === OBJ_TYPE && q.length > 0) {
                  if (q.length === 2) {
                    if (typeof q[1] == FUNC_TYPE) {
                      // assign modified match
                      this[q[0]] = q[1].call(this, match);
                    } else {
                      // assign given value, ignore regex match
                      this[q[0]] = q[1];
                    }
                  } else if (q.length === 3) {
                    // check whether function or regex
                    if (typeof q[1] === FUNC_TYPE && !(q[1].exec && q[1].test)) {
                      // call function (usually string mapper)
                      this[q[0]] = match ? q[1].call(this, match, q[2]) : undefined$1;
                    } else {
                      // sanitize match using given regex
                      this[q[0]] = match ? match.replace(q[1], q[2]) : undefined$1;
                    }
                  } else if (q.length === 4) {
                    this[q[0]] = match ? q[3].call(this, match.replace(q[1], q[2])) : undefined$1;
                  }
                } else {
                  this[q] = match ? match : undefined$1;
                }
              }
            }
          }
          i += 2;
        }
      },
      strMapper = function (str, map) {
        for (var i in map) {
          // check if current value is array
          if (typeof map[i] === OBJ_TYPE && map[i].length > 0) {
            for (var j = 0; j < map[i].length; j++) {
              if (has(map[i][j], str)) {
                return i === UNKNOWN ? undefined$1 : i;
              }
            }
          } else if (has(map[i], str)) {
            return i === UNKNOWN ? undefined$1 : i;
          }
        }
        return str;
      };

    ///////////////
    // String map
    //////////////

    // Safari < 3.0
    var oldSafariMap = {
        "1.0": "/8",
        1.2: "/1",
        1.3: "/3",
        "2.0": "/412",
        "2.0.2": "/416",
        "2.0.3": "/417",
        "2.0.4": "/419",
        "?": "/"
      },
      windowsVersionMap = {
        ME: "4.90",
        "NT 3.11": "NT3.51",
        "NT 4.0": "NT4.0",
        2000: "NT 5.0",
        XP: ["NT 5.1", "NT 5.2"],
        Vista: "NT 6.0",
        7: "NT 6.1",
        8: "NT 6.2",
        8.1: "NT 6.3",
        10: ["NT 6.4", "NT 10.0"],
        RT: "ARM"
      };

    //////////////
    // Regex map
    /////////////

    var regexes = {
      browser: [[/\b(?:crmo|crios)\/([\w\.]+)/i // Chrome for Android/iOS
      ], [VERSION, [NAME, "Chrome"]], [/edg(?:e|ios|a)?\/([\w\.]+)/i // Microsoft Edge
      ], [VERSION, [NAME, "Edge"]], [
      // Presto based
      /(opera mini)\/([-\w\.]+)/i,
      // Opera Mini
      /(opera [mobiletab]{3,6})\b.+version\/([-\w\.]+)/i,
      // Opera Mobi/Tablet
      /(opera)(?:.+version\/|[\/ ]+)([\w\.]+)/i // Opera
      ], [NAME, VERSION], [/opios[\/ ]+([\w\.]+)/i // Opera mini on iphone >= 8.0
      ], [VERSION, [NAME, OPERA + " Mini"]], [/\bopr\/([\w\.]+)/i // Opera Webkit
      ], [VERSION, [NAME, OPERA]], [
      // Mixed
      /(kindle)\/([\w\.]+)/i,
      // Kindle
      /(lunascape|maxthon|netfront|jasmine|blazer)[\/ ]?([\w\.]*)/i,
      // Lunascape/Maxthon/Netfront/Jasmine/Blazer
      // Trident based
      /(avant |iemobile|slim)(?:browser)?[\/ ]?([\w\.]*)/i,
      // Avant/IEMobile/SlimBrowser
      /(ba?idubrowser)[\/ ]?([\w\.]+)/i,
      // Baidu Browser
      /(?:ms|\()(ie) ([\w\.]+)/i,
      // Internet Explorer

      // Webkit/KHTML based                                               // Flock/RockMelt/Midori/Epiphany/Silk/Skyfire/Bolt/Iron/Iridium/PhantomJS/Bowser/QupZilla/Falkon
      /(flock|rockmelt|midori|epiphany|silk|skyfire|ovibrowser|bolt|iron|vivaldi|iridium|phantomjs|bowser|quark|qupzilla|falkon|rekonq|puffin|brave|whale|qqbrowserlite|qq|duckduckgo)\/([-\w\.]+)/i,
      // Rekonq/Puffin/Brave/Whale/QQBrowserLite/QQ, aka ShouQ
      /(weibo)__([\d\.]+)/i // Weibo
      ], [NAME, VERSION], [/(?:\buc? ?browser|(?:juc.+)ucweb)[\/ ]?([\w\.]+)/i // UCBrowser
      ], [VERSION, [NAME, "UC" + BROWSER]], [/microm.+\bqbcore\/([\w\.]+)/i,
      // WeChat Desktop for Windows Built-in Browser
      /\bqbcore\/([\w\.]+).+microm/i], [VERSION, [NAME, "WeChat(Win) Desktop"]], [/micromessenger\/([\w\.]+)/i // WeChat
      ], [VERSION, [NAME, "WeChat"]], [/konqueror\/([\w\.]+)/i // Konqueror
      ], [VERSION, [NAME, "Konqueror"]], [/trident.+rv[: ]([\w\.]{1,9})\b.+like gecko/i // IE11
      ], [VERSION, [NAME, "IE"]], [/yabrowser\/([\w\.]+)/i // Yandex
      ], [VERSION, [NAME, "Yandex"]], [/(avast|avg)\/([\w\.]+)/i // Avast/AVG Secure Browser
      ], [[NAME, /(.+)/, "$1 Secure " + BROWSER], VERSION], [/\bfocus\/([\w\.]+)/i // Firefox Focus
      ], [VERSION, [NAME, FIREFOX + " Focus"]], [/\bopt\/([\w\.]+)/i // Opera Touch
      ], [VERSION, [NAME, OPERA + " Touch"]], [/coc_coc\w+\/([\w\.]+)/i // Coc Coc Browser
      ], [VERSION, [NAME, "Coc Coc"]], [/dolfin\/([\w\.]+)/i // Dolphin
      ], [VERSION, [NAME, "Dolphin"]], [/coast\/([\w\.]+)/i // Opera Coast
      ], [VERSION, [NAME, OPERA + " Coast"]], [/miuibrowser\/([\w\.]+)/i // MIUI Browser
      ], [VERSION, [NAME, "MIUI " + BROWSER]], [/fxios\/([-\w\.]+)/i // Firefox for iOS
      ], [VERSION, [NAME, FIREFOX]], [/\bqihu|(qi?ho?o?|360)browser/i // 360
      ], [[NAME, "360 " + BROWSER]], [/(oculus|samsung|sailfish|huawei)browser\/([\w\.]+)/i], [[NAME, /(.+)/, "$1 " + BROWSER], VERSION], [
      // Oculus/Samsung/Sailfish/Huawei Browser
      /(comodo_dragon)\/([\w\.]+)/i // Comodo Dragon
      ], [[NAME, /_/g, " "], VERSION], [/(electron)\/([\w\.]+) safari/i,
      // Electron-based App
      /(tesla)(?: qtcarbrowser|\/(20\d\d\.[-\w\.]+))/i,
      // Tesla
      /m?(qqbrowser|baiduboxapp|2345Explorer)[\/ ]?([\w\.]+)/i // QQBrowser/Baidu App/2345 Browser
      ], [NAME, VERSION], [/(metasr)[\/ ]?([\w\.]+)/i,
      // SouGouBrowser
      /(lbbrowser)/i,
      // LieBao Browser
      /\[(linkedin)app\]/i // LinkedIn App for iOS & Android
      ], [NAME], [
      // WebView
      /((?:fban\/fbios|fb_iab\/fb4a)(?!.+fbav)|;fbav\/([\w\.]+);)/i // Facebook App for iOS & Android
      ], [[NAME, FACEBOOK], VERSION], [/safari (line)\/([\w\.]+)/i,
      // Line App for iOS
      /\b(line)\/([\w\.]+)\/iab/i,
      // Line App for Android
      /(chromium|instagram)[\/ ]([-\w\.]+)/i // Chromium/Instagram
      ], [NAME, VERSION], [/\bgsa\/([\w\.]+) .*safari\//i // Google Search Appliance on iOS
      ], [VERSION, [NAME, "GSA"]], [/headlesschrome(?:\/([\w\.]+)| )/i // Chrome Headless
      ], [VERSION, [NAME, CHROME + " Headless"]], [/ wv\).+(chrome)\/([\w\.]+)/i // Chrome WebView
      ], [[NAME, CHROME + " WebView"], VERSION], [/droid.+ version\/([\w\.]+)\b.+(?:mobile safari|safari)/i // Android Browser
      ], [VERSION, [NAME, "Android " + BROWSER]], [/(chrome|omniweb|arora|[tizenoka]{5} ?browser)\/v?([\w\.]+)/i // Chrome/OmniWeb/Arora/Tizen/Nokia
      ], [NAME, VERSION], [/version\/([\w\.\,]+) .*mobile\/\w+ (safari)/i // Mobile Safari
      ], [VERSION, [NAME, "Mobile Safari"]], [/version\/([\w(\.|\,)]+) .*(mobile ?safari|safari)/i // Safari & Safari Mobile
      ], [VERSION, NAME], [/webkit.+?(mobile ?safari|safari)(\/[\w\.]+)/i // Safari < 3.0
      ], [NAME, [VERSION, strMapper, oldSafariMap]], [/(webkit|khtml)\/([\w\.]+)/i], [NAME, VERSION], [
      // Gecko based
      /(navigator|netscape\d?)\/([-\w\.]+)/i // Netscape
      ], [[NAME, "Netscape"], VERSION], [/mobile vr; rv:([\w\.]+)\).+firefox/i // Firefox Reality
      ], [VERSION, [NAME, FIREFOX + " Reality"]], [/ekiohf.+(flow)\/([\w\.]+)/i,
      // Flow
      /(swiftfox)/i,
      // Swiftfox
      /(icedragon|iceweasel|camino|chimera|fennec|maemo browser|minimo|conkeror|klar)[\/ ]?([\w\.\+]+)/i,
      // IceDragon/Iceweasel/Camino/Chimera/Fennec/Maemo/Minimo/Conkeror/Klar
      /(seamonkey|k-meleon|icecat|iceape|firebird|phoenix|palemoon|basilisk|waterfox)\/([-\w\.]+)$/i,
      // Firefox/SeaMonkey/K-Meleon/IceCat/IceApe/Firebird/Phoenix
      /(firefox)\/([\w\.]+)/i,
      // Other Firefox-based
      /(mozilla)\/([\w\.]+) .+rv\:.+gecko\/\d+/i,
      // Mozilla

      // Other
      /(polaris|lynx|dillo|icab|doris|amaya|w3m|netsurf|sleipnir|obigo|mosaic|(?:go|ice|up)[\. ]?browser)[-\/ ]?v?([\w\.]+)/i,
      // Polaris/Lynx/Dillo/iCab/Doris/Amaya/w3m/NetSurf/Sleipnir/Obigo/Mosaic/Go/ICE/UP.Browser
      /(links) \(([\w\.]+)/i // Links
      ], [NAME, VERSION], [/(cobalt)\/([\w\.]+)/i // Cobalt
      ], [NAME, [VERSION, /master.|lts./, ""]]],
      cpu: [[/(?:(amd|x(?:(?:86|64)[-_])?|wow|win)64)[;\)]/i // AMD64 (x64)
      ], [[ARCHITECTURE, "amd64"]], [/(ia32(?=;))/i // IA32 (quicktime)
      ], [[ARCHITECTURE, lowerize]], [/((?:i[346]|x)86)[;\)]/i // IA32 (x86)
      ], [[ARCHITECTURE, "ia32"]], [/\b(aarch64|arm(v?8e?l?|_?64))\b/i // ARM64
      ], [[ARCHITECTURE, "arm64"]], [/\b(arm(?:v[67])?ht?n?[fl]p?)\b/i // ARMHF
      ], [[ARCHITECTURE, "armhf"]], [
      // PocketPC mistakenly identified as PowerPC
      /windows (ce|mobile); ppc;/i], [[ARCHITECTURE, "arm"]], [/((?:ppc|powerpc)(?:64)?)(?: mac|;|\))/i // PowerPC
      ], [[ARCHITECTURE, /ower/, EMPTY, lowerize]], [/(sun4\w)[;\)]/i // SPARC
      ], [[ARCHITECTURE, "sparc"]], [/((?:avr32|ia64(?=;))|68k(?=\))|\barm(?=v(?:[1-7]|[5-7]1)l?|;|eabi)|(?=atmel )avr|(?:irix|mips|sparc)(?:64)?\b|pa-risc)/i
      // IA64, 68K, ARM/64, AVR/32, IRIX/64, MIPS/64, SPARC/64, PA-RISC
      ], [[ARCHITECTURE, lowerize]]],
      device: [[
      //////////////////////////
      // MOBILES & TABLETS
      // Ordered by popularity
      /////////////////////////

      // Samsung
      /\b(sch-i[89]0\d|shw-m380s|sm-[ptx]\w{2,4}|gt-[pn]\d{2,4}|sgh-t8[56]9|nexus 10)/i], [MODEL, [VENDOR, SAMSUNG], [TYPE, TABLET]], [/\b((?:s[cgp]h|gt|sm)-\w+|galaxy nexus)/i, /samsung[- ]([-\w]+)/i, /sec-(sgh\w+)/i], [MODEL, [VENDOR, SAMSUNG], [TYPE, MOBILE]], [
      // Apple
      /((ipod|iphone)\d+,\d+)/i // iPod/iPhone model
      ], [MODEL, [VENDOR, APPLE], [TYPE, MOBILE]], [/(ipad\d+,\d+)/i // iPad model
      ], [MODEL, [VENDOR, APPLE], [TYPE, TABLET]], [/\((ip(?:hone|od)[\w ]*);/i // iPod/iPhone
      ], [MODEL, [VENDOR, APPLE], [TYPE, MOBILE]], [/\((ipad);[-\w\),; ]+apple/i,
      // iPad
      /applecoremedia\/[\w\.]+ \((ipad)/i, /\b(ipad)\d\d?,\d\d?[;\]].+ios/i], [MODEL, [VENDOR, APPLE], [TYPE, TABLET]], [/(macintosh);/i], [MODEL, [VENDOR, APPLE]], [
      // Huawei
      /\b((?:ag[rs][23]?|bah2?|sht?|btv)-a?[lw]\d{2})\b(?!.+d\/s)/i], [MODEL, [VENDOR, HUAWEI], [TYPE, TABLET]], [/(?:huawei|honor)([-\w ]+)[;\)]/i, /\b(nexus 6p|\w{2,4}e?-[atu]?[ln][\dx][012359c][adn]?)\b(?!.+d\/s)/i], [MODEL, [VENDOR, HUAWEI], [TYPE, MOBILE]], [
      // Xiaomi
      /\b(poco[\w ]+)(?: bui|\))/i,
      // Xiaomi POCO
      /\b; (\w+) build\/hm\1/i,
      // Xiaomi Hongmi 'numeric' models
      /\b(hm[-_ ]?note?[_ ]?(?:\d\w)?) bui/i,
      // Xiaomi Hongmi
      /\b(redmi[\-_ ]?(?:note|k)?[\w_ ]+)(?: bui|\))/i,
      // Xiaomi Redmi
      /\b(mi[-_ ]?(?:a\d|one|one[_ ]plus|note lte|max|cc)?[_ ]?(?:\d?\w?)[_ ]?(?:plus|se|lite)?)(?: bui|\))/i // Xiaomi Mi
      ], [[MODEL, /_/g, " "], [VENDOR, XIAOMI], [TYPE, MOBILE]], [/\b(mi[-_ ]?(?:pad)(?:[\w_ ]+))(?: bui|\))/i // Mi Pad tablets
      ], [[MODEL, /_/g, " "], [VENDOR, XIAOMI], [TYPE, TABLET]], [
      // OPPO
      /; (\w+) bui.+ oppo/i, /\b(cph[12]\d{3}|p(?:af|c[al]|d\w|e[ar])[mt]\d0|x9007|a101op)\b/i], [MODEL, [VENDOR, "OPPO"], [TYPE, MOBILE]], [
      // Vivo
      /vivo (\w+)(?: bui|\))/i, /\b(v[12]\d{3}\w?[at])(?: bui|;)/i], [MODEL, [VENDOR, "Vivo"], [TYPE, MOBILE]], [
      // Realme
      /\b(rmx[12]\d{3})(?: bui|;|\))/i], [MODEL, [VENDOR, "Realme"], [TYPE, MOBILE]], [
      // Motorola
      /\b(milestone|droid(?:[2-4x]| (?:bionic|x2|pro|razr))?:?( 4g)?)\b[\w ]+build\//i, /\bmot(?:orola)?[- ](\w*)/i, /((?:moto[\w\(\) ]+|xt\d{3,4}|nexus 6)(?= bui|\)))/i], [MODEL, [VENDOR, MOTOROLA], [TYPE, MOBILE]], [/\b(mz60\d|xoom[2 ]{0,2}) build\//i], [MODEL, [VENDOR, MOTOROLA], [TYPE, TABLET]], [
      // LG
      /((?=lg)?[vl]k\-?\d{3}) bui| 3\.[-\w; ]{10}lg?-([06cv9]{3,4})/i], [MODEL, [VENDOR, LG], [TYPE, TABLET]], [/(lm(?:-?f100[nv]?|-[\w\.]+)(?= bui|\))|nexus [45])/i, /\blg[-e;\/ ]+((?!browser|netcast|android tv)\w+)/i, /\blg-?([\d\w]+) bui/i], [MODEL, [VENDOR, LG], [TYPE, MOBILE]], [
      // Lenovo
      /(ideatab[-\w ]+)/i, /lenovo ?(s[56]000[-\w]+|tab(?:[\w ]+)|yt[-\d\w]{6}|tb[-\d\w]{6})/i], [MODEL, [VENDOR, "Lenovo"], [TYPE, TABLET]], [
      // Nokia
      /(?:maemo|nokia).*(n900|lumia \d+)/i, /nokia[-_ ]?([-\w\.]*)/i], [[MODEL, /_/g, " "], [VENDOR, "Nokia"], [TYPE, MOBILE]], [
      // Google
      /(pixel c)\b/i // Google Pixel C
      ], [MODEL, [VENDOR, GOOGLE], [TYPE, TABLET]], [/droid.+; (pixel[\daxl ]{0,6})(?: bui|\))/i // Google Pixel
      ], [MODEL, [VENDOR, GOOGLE], [TYPE, MOBILE]], [
      // Sony
      /droid.+ (a?\d[0-2]{2}so|[c-g]\d{4}|so[-gl]\w+|xq-a\w[4-7][12])(?= bui|\).+chrome\/(?![1-6]{0,1}\d\.))/i], [MODEL, [VENDOR, SONY], [TYPE, MOBILE]], [/sony tablet [ps]/i, /\b(?:sony)?sgp\w+(?: bui|\))/i], [[MODEL, "Xperia Tablet"], [VENDOR, SONY], [TYPE, TABLET]], [
      // OnePlus
      / (kb2005|in20[12]5|be20[12][59])\b/i, /(?:one)?(?:plus)? (a\d0\d\d)(?: b|\))/i], [MODEL, [VENDOR, "OnePlus"], [TYPE, MOBILE]], [
      // Amazon
      /(alexa)webm/i, /(kf[a-z]{2}wi)( bui|\))/i,
      // Kindle Fire without Silk
      /(kf[a-z]+)( bui|\)).+silk\//i // Kindle Fire HD
      ], [MODEL, [VENDOR, AMAZON], [TYPE, TABLET]], [/((?:sd|kf)[0349hijorstuw]+)( bui|\)).+silk\//i // Fire Phone
      ], [[MODEL, /(.+)/g, "Fire Phone $1"], [VENDOR, AMAZON], [TYPE, MOBILE]], [
      // BlackBerry
      /(playbook);[-\w\),; ]+(rim)/i // BlackBerry PlayBook
      ], [MODEL, VENDOR, [TYPE, TABLET]], [/\b((?:bb[a-f]|st[hv])100-\d)/i, /\(bb10; (\w+)/i // BlackBerry 10
      ], [MODEL, [VENDOR, BLACKBERRY], [TYPE, MOBILE]], [
      // Asus
      /(?:\b|asus_)(transfo[prime ]{4,10} \w+|eeepc|slider \w+|nexus 7|padfone|p00[cj])/i], [MODEL, [VENDOR, ASUS], [TYPE, TABLET]], [/ (z[bes]6[027][012][km][ls]|zenfone \d\w?)\b/i], [MODEL, [VENDOR, ASUS], [TYPE, MOBILE]], [
      // HTC
      /(nexus 9)/i // HTC Nexus 9
      ], [MODEL, [VENDOR, "HTC"], [TYPE, TABLET]], [/(htc)[-;_ ]{1,2}([\w ]+(?=\)| bui)|\w+)/i,
      // HTC

      // ZTE
      /(zte)[- ]([\w ]+?)(?: bui|\/|\))/i, /(alcatel|geeksphone|nexian|panasonic|sony(?!-bra))[-_ ]?([-\w]*)/i // Alcatel/GeeksPhone/Nexian/Panasonic/Sony
      ], [VENDOR, [MODEL, /_/g, " "], [TYPE, MOBILE]], [
      // Acer
      /droid.+; ([ab][1-7]-?[0178a]\d\d?)/i], [MODEL, [VENDOR, "Acer"], [TYPE, TABLET]], [
      // Meizu
      /droid.+; (m[1-5] note) bui/i, /\bmz-([-\w]{2,})/i], [MODEL, [VENDOR, "Meizu"], [TYPE, MOBILE]], [
      // Sharp
      /\b(sh-?[altvz]?\d\d[a-ekm]?)/i], [MODEL, [VENDOR, SHARP], [TYPE, MOBILE]], [
      // MIXED
      /(blackberry|benq|palm(?=\-)|sonyericsson|acer|asus|dell|meizu|motorola|polytron)[-_ ]?([-\w]*)/i,
      // BlackBerry/BenQ/Palm/Sony-Ericsson/Acer/Asus/Dell/Meizu/Motorola/Polytron
      /(hp) ([\w ]+\w)/i,
      // HP iPAQ
      /(asus)-?(\w+)/i,
      // Asus
      /(microsoft); (lumia[\w ]+)/i,
      // Microsoft Lumia
      /(lenovo)[-_ ]?([-\w]+)/i,
      // Lenovo
      /(jolla)/i,
      // Jolla
      /(oppo) ?([\w ]+) bui/i // OPPO
      ], [VENDOR, MODEL, [TYPE, MOBILE]], [/(archos) (gamepad2?)/i,
      // Archos
      /(hp).+(touchpad(?!.+tablet)|tablet)/i,
      // HP TouchPad
      /(kindle)\/([\w\.]+)/i,
      // Kindle
      /(nook)[\w ]+build\/(\w+)/i,
      // Nook
      /(dell) (strea[kpr\d ]*[\dko])/i,
      // Dell Streak
      /(le[- ]+pan)[- ]+(\w{1,9}) bui/i,
      // Le Pan Tablets
      /(trinity)[- ]*(t\d{3}) bui/i,
      // Trinity Tablets
      /(gigaset)[- ]+(q\w{1,9}) bui/i,
      // Gigaset Tablets
      /(vodafone) ([\w ]+)(?:\)| bui)/i // Vodafone
      ], [VENDOR, MODEL, [TYPE, TABLET]], [/(surface duo)/i // Surface Duo
      ], [MODEL, [VENDOR, MICROSOFT], [TYPE, TABLET]], [/droid [\d\.]+; (fp\du?)(?: b|\))/i // Fairphone
      ], [MODEL, [VENDOR, "Fairphone"], [TYPE, MOBILE]], [/(u304aa)/i // AT&T
      ], [MODEL, [VENDOR, "AT&T"], [TYPE, MOBILE]], [/\bsie-(\w*)/i // Siemens
      ], [MODEL, [VENDOR, "Siemens"], [TYPE, MOBILE]], [/\b(rct\w+) b/i // RCA Tablets
      ], [MODEL, [VENDOR, "RCA"], [TYPE, TABLET]], [/\b(venue[\d ]{2,7}) b/i // Dell Venue Tablets
      ], [MODEL, [VENDOR, "Dell"], [TYPE, TABLET]], [/\b(q(?:mv|ta)\w+) b/i // Verizon Tablet
      ], [MODEL, [VENDOR, "Verizon"], [TYPE, TABLET]], [/\b(?:barnes[& ]+noble |bn[rt])([\w\+ ]*) b/i // Barnes & Noble Tablet
      ], [MODEL, [VENDOR, "Barnes & Noble"], [TYPE, TABLET]], [/\b(tm\d{3}\w+) b/i], [MODEL, [VENDOR, "NuVision"], [TYPE, TABLET]], [/\b(k88) b/i // ZTE K Series Tablet
      ], [MODEL, [VENDOR, "ZTE"], [TYPE, TABLET]], [/\b(nx\d{3}j) b/i // ZTE Nubia
      ], [MODEL, [VENDOR, "ZTE"], [TYPE, MOBILE]], [/\b(gen\d{3}) b.+49h/i // Swiss GEN Mobile
      ], [MODEL, [VENDOR, "Swiss"], [TYPE, MOBILE]], [/\b(zur\d{3}) b/i // Swiss ZUR Tablet
      ], [MODEL, [VENDOR, "Swiss"], [TYPE, TABLET]], [/\b((zeki)?tb.*\b) b/i // Zeki Tablets
      ], [MODEL, [VENDOR, "Zeki"], [TYPE, TABLET]], [/\b([yr]\d{2}) b/i, /\b(dragon[- ]+touch |dt)(\w{5}) b/i // Dragon Touch Tablet
      ], [[VENDOR, "Dragon Touch"], MODEL, [TYPE, TABLET]], [/\b(ns-?\w{0,9}) b/i // Insignia Tablets
      ], [MODEL, [VENDOR, "Insignia"], [TYPE, TABLET]], [/\b((nxa|next)-?\w{0,9}) b/i // NextBook Tablets
      ], [MODEL, [VENDOR, "NextBook"], [TYPE, TABLET]], [/\b(xtreme\_)?(v(1[045]|2[015]|[3469]0|7[05])) b/i // Voice Xtreme Phones
      ], [[VENDOR, "Voice"], MODEL, [TYPE, MOBILE]], [/\b(lvtel\-)?(v1[12]) b/i // LvTel Phones
      ], [[VENDOR, "LvTel"], MODEL, [TYPE, MOBILE]], [/\b(ph-1) /i // Essential PH-1
      ], [MODEL, [VENDOR, "Essential"], [TYPE, MOBILE]], [/\b(v(100md|700na|7011|917g).*\b) b/i // Envizen Tablets
      ], [MODEL, [VENDOR, "Envizen"], [TYPE, TABLET]], [/\b(trio[-\w\. ]+) b/i // MachSpeed Tablets
      ], [MODEL, [VENDOR, "MachSpeed"], [TYPE, TABLET]], [/\btu_(1491) b/i // Rotor Tablets
      ], [MODEL, [VENDOR, "Rotor"], [TYPE, TABLET]], [/(shield[\w ]+) b/i // Nvidia Shield Tablets
      ], [MODEL, [VENDOR, "Nvidia"], [TYPE, TABLET]], [/(sprint) (\w+)/i // Sprint Phones
      ], [VENDOR, MODEL, [TYPE, MOBILE]], [/(kin\.[onetw]{3})/i // Microsoft Kin
      ], [[MODEL, /\./g, " "], [VENDOR, MICROSOFT], [TYPE, MOBILE]], [/droid.+; (cc6666?|et5[16]|mc[239][23]x?|vc8[03]x?)\)/i // Zebra
      ], [MODEL, [VENDOR, ZEBRA], [TYPE, TABLET]], [/droid.+; (ec30|ps20|tc[2-8]\d[kx])\)/i], [MODEL, [VENDOR, ZEBRA], [TYPE, MOBILE]], [
      ///////////////////
      // CONSOLES
      ///////////////////

      /(ouya)/i,
      // Ouya
      /(nintendo) ([wids3utch]+)/i // Nintendo
      ], [VENDOR, MODEL, [TYPE, CONSOLE]], [/droid.+; (shield) bui/i // Nvidia
      ], [MODEL, [VENDOR, "Nvidia"], [TYPE, CONSOLE]], [/(playstation [345portablevi]+)/i // Playstation
      ], [MODEL, [VENDOR, SONY], [TYPE, CONSOLE]], [/\b(xbox(?: one)?(?!; xbox))[\); ]/i // Microsoft Xbox
      ], [MODEL, [VENDOR, MICROSOFT], [TYPE, CONSOLE]], [
      ///////////////////
      // SMARTTVS
      ///////////////////

      /smart-tv.+(samsung)/i // Samsung
      ], [VENDOR, [TYPE, SMARTTV]], [/hbbtv.+maple;(\d+)/i], [[MODEL, /^/, "SmartTV"], [VENDOR, SAMSUNG], [TYPE, SMARTTV]], [/(nux; netcast.+smarttv|lg (netcast\.tv-201\d|android tv))/i // LG SmartTV
      ], [[VENDOR, LG], [TYPE, SMARTTV]], [/(apple) ?tv/i // Apple TV
      ], [VENDOR, [MODEL, APPLE + " TV"], [TYPE, SMARTTV]], [/crkey/i // Google Chromecast
      ], [[MODEL, CHROME + "cast"], [VENDOR, GOOGLE], [TYPE, SMARTTV]], [/droid.+aft(\w)( bui|\))/i // Fire TV
      ], [MODEL, [VENDOR, AMAZON], [TYPE, SMARTTV]], [/\(dtv[\);].+(aquos)/i, /(aquos-tv[\w ]+)\)/i // Sharp
      ], [MODEL, [VENDOR, SHARP], [TYPE, SMARTTV]], [/(bravia[\w ]+)( bui|\))/i // Sony
      ], [MODEL, [VENDOR, SONY], [TYPE, SMARTTV]], [/(mitv-\w{5}) bui/i // Xiaomi
      ], [MODEL, [VENDOR, XIAOMI], [TYPE, SMARTTV]], [/\b(roku)[\dx]*[\)\/]((?:dvp-)?[\d\.]*)/i,
      // Roku
      /hbbtv\/\d+\.\d+\.\d+ +\([\w ]*; *(\w[^;]*);([^;]*)/i // HbbTV devices
      ], [[VENDOR, trim], [MODEL, trim], [TYPE, SMARTTV]], [/\b(android tv|smart[- ]?tv|opera tv|tv; rv:)\b/i // SmartTV from Unidentified Vendors
      ], [[TYPE, SMARTTV]], [
      ///////////////////
      // WEARABLES
      ///////////////////

      /((pebble))app/i // Pebble
      ], [VENDOR, MODEL, [TYPE, WEARABLE]], [/droid.+; (glass) \d/i // Google Glass
      ], [MODEL, [VENDOR, GOOGLE], [TYPE, WEARABLE]], [/droid.+; (wt63?0{2,3})\)/i], [MODEL, [VENDOR, ZEBRA], [TYPE, WEARABLE]], [/(quest( 2)?)/i // Oculus Quest
      ], [MODEL, [VENDOR, FACEBOOK], [TYPE, WEARABLE]], [
      ///////////////////
      // EMBEDDED
      ///////////////////

      /(tesla)(?: qtcarbrowser|\/[-\w\.]+)/i // Tesla
      ], [VENDOR, [TYPE, EMBEDDED]], [
      ////////////////////
      // MIXED (GENERIC)
      ///////////////////

      /droid .+?; ([^;]+?)(?: bui|\) applew).+? mobile safari/i // Android Phones from Unidentified Vendors
      ], [MODEL, [TYPE, MOBILE]], [/droid .+?; ([^;]+?)(?: bui|\) applew).+?(?! mobile) safari/i // Android Tablets from Unidentified Vendors
      ], [MODEL, [TYPE, TABLET]], [/\b((tablet|tab)[;\/]|focus\/\d(?!.+mobile))/i // Unidentifiable Tablet
      ], [[TYPE, TABLET]], [/(phone|mobile(?:[;\/]| [ \w\/\.]*safari)|pda(?=.+windows ce))/i // Unidentifiable Mobile
      ], [[TYPE, MOBILE]], [/(android[-\w\. ]{0,9});.+buil/i // Generic Android Device
      ], [MODEL, [VENDOR, "Generic"]]],
      engine: [[/windows.+ edge\/([\w\.]+)/i // EdgeHTML
      ], [VERSION, [NAME, EDGE + "HTML"]], [/webkit\/537\.36.+chrome\/(?!27)([\w\.]+)/i // Blink
      ], [VERSION, [NAME, "Blink"]], [/(presto)\/([\w\.]+)/i,
      // Presto
      /(webkit|trident|netfront|netsurf|amaya|lynx|w3m|goanna)\/([\w\.]+)/i,
      // WebKit/Trident/NetFront/NetSurf/Amaya/Lynx/w3m/Goanna
      /ekioh(flow)\/([\w\.]+)/i,
      // Flow
      /(khtml|tasman|links)[\/ ]\(?([\w\.]+)/i,
      // KHTML/Tasman/Links
      /(icab)[\/ ]([23]\.[\d\.]+)/i // iCab
      ], [NAME, VERSION], [/rv\:([\w\.]{1,9})\b.+(gecko)/i // Gecko
      ], [VERSION, NAME]],
      os: [[
      // Windows
      /microsoft (windows) (vista|xp)/i // Windows (iTunes)
      ], [NAME, VERSION], [/(windows) nt 6\.2; (arm)/i,
      // Windows RT
      /(windows (?:phone(?: os)?|mobile))[\/ ]?([\d\.\w ]*)/i,
      // Windows Phone
      /(windows)[\/ ]?([ntce\d\. ]+\w)(?!.+xbox)/i], [NAME, [VERSION, strMapper, windowsVersionMap]], [/(win(?=3|9|n)|win 9x )([nt\d\.]+)/i], [[NAME, "Windows"], [VERSION, strMapper, windowsVersionMap]], [
      // iOS/macOS
      /ip[honead]{2,4}\b(?:.*os ([\w]+) like mac|; opera)/i,
      // iOS
      /cfnetwork\/.+darwin/i], [[VERSION, /_/g, "."], [NAME, "iOS"]], [/(mac os x) ?([\w\. ]*)/i, /(macintosh|mac_powerpc\b)(?!.+haiku)/i // Mac OS
      ], [[NAME, "Mac OS"], [VERSION, /_/g, "."]], [
      // Mobile OSes
      /droid ([\w\.]+)\b.+(android[- ]x86|harmonyos)/i // Android-x86/HarmonyOS
      ], [VERSION, NAME], [
      // Android/WebOS/QNX/Bada/RIM/Maemo/MeeGo/Sailfish OS
      /(android|webos|qnx|bada|rim tablet os|maemo|meego|sailfish)[-\/ ]?([\w\.]*)/i, /(blackberry)\w*\/([\w\.]*)/i,
      // Blackberry
      /(tizen|kaios)[\/ ]([\w\.]+)/i,
      // Tizen/KaiOS
      /\((series40);/i // Series 40
      ], [NAME, VERSION], [/\(bb(10);/i // BlackBerry 10
      ], [VERSION, [NAME, BLACKBERRY]], [/(?:symbian ?os|symbos|s60(?=;)|series60)[-\/ ]?([\w\.]*)/i // Symbian
      ], [VERSION, [NAME, "Symbian"]], [/mozilla\/[\d\.]+ \((?:mobile|tablet|tv|mobile; [\w ]+); rv:.+ gecko\/([\w\.]+)/i // Firefox OS
      ], [VERSION, [NAME, FIREFOX + " OS"]], [/web0s;.+rt(tv)/i, /\b(?:hp)?wos(?:browser)?\/([\w\.]+)/i // WebOS
      ], [VERSION, [NAME, "webOS"]], [
      // Google Chromecast
      /crkey\/([\d\.]+)/i // Google Chromecast
      ], [VERSION, [NAME, CHROME + "cast"]], [/(cros) [\w]+ ([\w\.]+\w)/i // Chromium OS
      ], [[NAME, "Chromium OS"], VERSION], [
      // Console
      /(nintendo|playstation) ([wids345portablevuch]+)/i,
      // Nintendo/Playstation
      /(xbox); +xbox ([^\);]+)/i,
      // Microsoft Xbox (360, One, X, S, Series X, Series S)

      // Other
      /\b(joli|palm)\b ?(?:os)?\/?([\w\.]*)/i,
      // Joli/Palm
      /(mint)[\/\(\) ]?(\w*)/i,
      // Mint
      /(mageia|vectorlinux)[; ]/i,
      // Mageia/VectorLinux
      /([kxln]?ubuntu|debian|suse|opensuse|gentoo|arch(?= linux)|slackware|fedora|mandriva|centos|pclinuxos|red ?hat|zenwalk|linpus|raspbian|plan 9|minix|risc os|contiki|deepin|manjaro|elementary os|sabayon|linspire)(?: gnu\/linux)?(?: enterprise)?(?:[- ]linux)?(?:-gnu)?[-\/ ]?(?!chrom|package)([-\w\.]*)/i,
      // Ubuntu/Debian/SUSE/Gentoo/Arch/Slackware/Fedora/Mandriva/CentOS/PCLinuxOS/RedHat/Zenwalk/Linpus/Raspbian/Plan9/Minix/RISCOS/Contiki/Deepin/Manjaro/elementary/Sabayon/Linspire
      /(hurd|linux) ?([\w\.]*)/i,
      // Hurd/Linux
      /(gnu) ?([\w\.]*)/i,
      // GNU
      /\b([-frentopcghs]{0,5}bsd|dragonfly)[\/ ]?(?!amd|[ix346]{1,2}86)([\w\.]*)/i,
      // FreeBSD/NetBSD/OpenBSD/PC-BSD/GhostBSD/DragonFly
      /(haiku) (\w+)/i // Haiku
      ], [NAME, VERSION], [/(sunos) ?([\w\.\d]*)/i // Solaris
      ], [[NAME, "Solaris"], VERSION], [/((?:open)?solaris)[-\/ ]?([\w\.]*)/i,
      // Solaris
      /(aix) ((\d)(?=\.|\)| )[\w\.])*/i,
      // AIX
      /\b(beos|os\/2|amigaos|morphos|openvms|fuchsia|hp-ux)/i,
      // BeOS/OS2/AmigaOS/MorphOS/OpenVMS/Fuchsia/HP-UX
      /(unix) ?([\w\.]*)/i // UNIX
      ], [NAME, VERSION]]
    };

    /////////////////
    // Constructor
    ////////////////

    var UAParser = function (ua, extensions) {
      if (typeof ua === OBJ_TYPE) {
        extensions = ua;
        ua = undefined$1;
      }
      if (!(this instanceof UAParser)) {
        return new UAParser(ua, extensions).getResult();
      }
      var _ua = ua || (typeof window !== UNDEF_TYPE && window.navigator && window.navigator.userAgent ? window.navigator.userAgent : EMPTY);
      var _rgxmap = extensions ? extend(regexes, extensions) : regexes;
      this.getBrowser = function () {
        var _browser = {};
        _browser[NAME] = undefined$1;
        _browser[VERSION] = undefined$1;
        rgxMapper.call(_browser, _ua, _rgxmap.browser);
        _browser.major = majorize(_browser.version);
        return _browser;
      };
      this.getCPU = function () {
        var _cpu = {};
        _cpu[ARCHITECTURE] = undefined$1;
        rgxMapper.call(_cpu, _ua, _rgxmap.cpu);
        return _cpu;
      };
      this.getDevice = function () {
        var _device = {};
        _device[VENDOR] = undefined$1;
        _device[MODEL] = undefined$1;
        _device[TYPE] = undefined$1;
        rgxMapper.call(_device, _ua, _rgxmap.device);
        return _device;
      };
      this.getEngine = function () {
        var _engine = {};
        _engine[NAME] = undefined$1;
        _engine[VERSION] = undefined$1;
        rgxMapper.call(_engine, _ua, _rgxmap.engine);
        return _engine;
      };
      this.getOS = function () {
        var _os = {};
        _os[NAME] = undefined$1;
        _os[VERSION] = undefined$1;
        rgxMapper.call(_os, _ua, _rgxmap.os);
        return _os;
      };
      this.getResult = function () {
        return {
          ua: this.getUA(),
          browser: this.getBrowser(),
          engine: this.getEngine(),
          os: this.getOS(),
          device: this.getDevice(),
          cpu: this.getCPU()
        };
      };
      this.getUA = function () {
        return _ua;
      };
      this.setUA = function (ua) {
        _ua = typeof ua === STR_TYPE && ua.length > UA_MAX_LENGTH ? trim(ua, UA_MAX_LENGTH) : ua;
        return this;
      };
      this.setUA(_ua);
      return this;
    };
    UAParser.VERSION = LIBVERSION;
    UAParser.BROWSER = enumerize([NAME, VERSION, MAJOR]);
    UAParser.CPU = enumerize([ARCHITECTURE]);
    UAParser.DEVICE = enumerize([MODEL, VENDOR, TYPE, CONSOLE, MOBILE, SMARTTV, TABLET, WEARABLE, EMBEDDED]);
    UAParser.ENGINE = UAParser.OS = enumerize([NAME, VERSION]);

    ///////////
    // Export
    //////////

    // check js environment
    {
      // nodejs env
      if (module.exports) {
        exports = module.exports = UAParser;
      }
      exports.UAParser = UAParser;
    }

    // jQuery/Zepto specific (optional)
    // Note:
    //   In AMD env the global scope should be kept clean, but jQuery is an exception.
    //   jQuery always exports to global scope, unless jQuery.noConflict(true) is used,
    //   and we should catch that.
    var $ = typeof window !== UNDEF_TYPE && (window.jQuery || window.Zepto);
    if ($ && !$.ua) {
      var parser = new UAParser();
      $.ua = parser.getResult();
      $.ua.get = function () {
        return parser.getUA();
      };
      $.ua.set = function (ua) {
        parser.setUA(ua);
        var result = parser.getResult();
        for (var prop in result) {
          $.ua[prop] = result[prop];
        }
      };
    }
  })(typeof window === "object" ? window : commonjsGlobal);
})(uaParser, uaParser.exports);
var uaParserExports = uaParser.exports;
var UAParser = /*@__PURE__*/getDefaultExportFromCjs$1(uaParserExports);

var ApplicationContextProviderImpl = /** @class */function () {
  function ApplicationContextProviderImpl() {}
  ApplicationContextProviderImpl.prototype.getApplicationContext = function () {
    return {
      versionName: this.versionName,
      language: getLanguage$1(),
      platform: 'Web',
      os: undefined,
      deviceModel: undefined
    };
  };
  return ApplicationContextProviderImpl;
}();
var getLanguage$1 = function () {
  return typeof navigator !== 'undefined' && (navigator.languages && navigator.languages[0] || navigator.language) || '';
};
var EventBridgeImpl = /** @class */function () {
  function EventBridgeImpl() {
    this.queue = [];
  }
  EventBridgeImpl.prototype.logEvent = function (event) {
    if (!this.receiver) {
      if (this.queue.length < 512) {
        this.queue.push(event);
      }
    } else {
      this.receiver(event);
    }
  };
  EventBridgeImpl.prototype.setEventReceiver = function (receiver) {
    this.receiver = receiver;
    if (this.queue.length > 0) {
      this.queue.forEach(function (event) {
        receiver(event);
      });
      this.queue = [];
    }
  };
  return EventBridgeImpl;
}();

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
var __assign = function () {
  __assign = Object.assign || function __assign(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
var isEqual = function (obj1, obj2) {
  var primitive = ['string', 'number', 'boolean', 'undefined'];
  var typeA = typeof obj1;
  var typeB = typeof obj2;
  if (typeA !== typeB) {
    return false;
  }
  for (var _i = 0, primitive_1 = primitive; _i < primitive_1.length; _i++) {
    var p = primitive_1[_i];
    if (p === typeA) {
      return obj1 === obj2;
    }
  }
  // check null
  if (obj1 == null && obj2 == null) {
    return true;
  } else if (obj1 == null || obj2 == null) {
    return false;
  }
  // if got here - objects
  if (obj1.length !== obj2.length) {
    return false;
  }
  //check if arrays
  var isArrayA = Array.isArray(obj1);
  var isArrayB = Array.isArray(obj2);
  if (isArrayA !== isArrayB) {
    return false;
  }
  if (isArrayA && isArrayB) {
    //arrays
    for (var i = 0; i < obj1.length; i++) {
      if (!isEqual(obj1[i], obj2[i])) {
        return false;
      }
    }
  } else {
    //objects
    var sorted1 = Object.keys(obj1).sort();
    var sorted2 = Object.keys(obj2).sort();
    if (!isEqual(sorted1, sorted2)) {
      return false;
    }
    //compare object values
    var result_1 = true;
    Object.keys(obj1).forEach(function (key) {
      if (!isEqual(obj1[key], obj2[key])) {
        result_1 = false;
      }
    });
    return result_1;
  }
  return true;
};
var ID_OP_SET = '$set';
var ID_OP_UNSET = '$unset';
var ID_OP_CLEAR_ALL = '$clearAll';
// Polyfill for Object.entries
if (!Object.entries) {
  Object.entries = function (obj) {
    var ownProps = Object.keys(obj);
    var i = ownProps.length;
    var resArray = new Array(i);
    while (i--) {
      resArray[i] = [ownProps[i], obj[ownProps[i]]];
    }
    return resArray;
  };
}
var IdentityStoreImpl = /** @class */function () {
  function IdentityStoreImpl() {
    this.identity = {
      userProperties: {}
    };
    this.listeners = new Set();
  }
  IdentityStoreImpl.prototype.editIdentity = function () {
    // eslint-disable-next-line @typescript-eslint/no-this-alias
    var self = this;
    var actingUserProperties = __assign({}, this.identity.userProperties);
    var actingIdentity = __assign(__assign({}, this.identity), {
      userProperties: actingUserProperties
    });
    return {
      setUserId: function (userId) {
        actingIdentity.userId = userId;
        return this;
      },
      setDeviceId: function (deviceId) {
        actingIdentity.deviceId = deviceId;
        return this;
      },
      setUserProperties: function (userProperties) {
        actingIdentity.userProperties = userProperties;
        return this;
      },
      setOptOut: function (optOut) {
        actingIdentity.optOut = optOut;
        return this;
      },
      updateUserProperties: function (actions) {
        var actingProperties = actingIdentity.userProperties || {};
        for (var _i = 0, _a = Object.entries(actions); _i < _a.length; _i++) {
          var _b = _a[_i],
            action = _b[0],
            properties = _b[1];
          switch (action) {
            case ID_OP_SET:
              for (var _c = 0, _d = Object.entries(properties); _c < _d.length; _c++) {
                var _e = _d[_c],
                  key = _e[0],
                  value = _e[1];
                actingProperties[key] = value;
              }
              break;
            case ID_OP_UNSET:
              for (var _f = 0, _g = Object.keys(properties); _f < _g.length; _f++) {
                var key = _g[_f];
                delete actingProperties[key];
              }
              break;
            case ID_OP_CLEAR_ALL:
              actingProperties = {};
              break;
          }
        }
        actingIdentity.userProperties = actingProperties;
        return this;
      },
      commit: function () {
        self.setIdentity(actingIdentity);
        return this;
      }
    };
  };
  IdentityStoreImpl.prototype.getIdentity = function () {
    return __assign({}, this.identity);
  };
  IdentityStoreImpl.prototype.setIdentity = function (identity) {
    var originalIdentity = __assign({}, this.identity);
    this.identity = __assign({}, identity);
    if (!isEqual(originalIdentity, this.identity)) {
      this.listeners.forEach(function (listener) {
        listener(identity);
      });
    }
  };
  IdentityStoreImpl.prototype.addIdentityListener = function (listener) {
    this.listeners.add(listener);
  };
  IdentityStoreImpl.prototype.removeIdentityListener = function (listener) {
    this.listeners.delete(listener);
  };
  return IdentityStoreImpl;
}();
var safeGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof __webpack_require__.g !== 'undefined' ? __webpack_require__.g : self;
var AnalyticsConnector = /** @class */function () {
  function AnalyticsConnector() {
    this.identityStore = new IdentityStoreImpl();
    this.eventBridge = new EventBridgeImpl();
    this.applicationContextProvider = new ApplicationContextProviderImpl();
  }
  AnalyticsConnector.getInstance = function (instanceName) {
    if (!safeGlobal['analyticsConnectorInstances']) {
      safeGlobal['analyticsConnectorInstances'] = {};
    }
    if (!safeGlobal['analyticsConnectorInstances'][instanceName]) {
      safeGlobal['analyticsConnectorInstances'][instanceName] = new AnalyticsConnector();
    }
    return safeGlobal['analyticsConnectorInstances'][instanceName];
  };
  return AnalyticsConnector;
}();

function ownKeys$1(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread2$1(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys$1(Object(source), !0).forEach(function (key) {
      _defineProperty$1(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$1(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, _toPropertyKey$1(descriptor.key), descriptor);
  }
}
function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}
function _defineProperty$1(obj, key, value) {
  key = _toPropertyKey$1(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _createForOfIteratorHelper(o, allowArrayLike) {
  var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
  if (!it) {
    if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
      if (it) o = it;
      var i = 0;
      var F = function () {};
      return {
        s: F,
        n: function () {
          if (i >= o.length) return {
            done: true
          };
          return {
            done: false,
            value: o[i++]
          };
        },
        e: function (e) {
          throw e;
        },
        f: F
      };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var normalCompletion = true,
    didErr = false,
    err;
  return {
    s: function () {
      it = it.call(o);
    },
    n: function () {
      var step = it.next();
      normalCompletion = step.done;
      return step;
    },
    e: function (e) {
      didErr = true;
      err = e;
    },
    f: function () {
      try {
        if (!normalCompletion && it.return != null) it.return();
      } finally {
        if (didErr) throw err;
      }
    }
  };
}
function _toPrimitive$1(input, hint) {
  if (typeof input !== "object" || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== undefined) {
    var res = prim.call(input, hint || "default");
    if (typeof res !== "object") return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}
function _toPropertyKey$1(arg) {
  var key = _toPrimitive$1(arg, "string");
  return typeof key === "symbol" ? key : String(key);
}
var Constants = {
  DEFAULT_INSTANCE: '$default_instance',
  API_VERSION: 2,
  MAX_STRING_LENGTH: 4096,
  MAX_PROPERTY_KEYS: 1000,
  IDENTIFY_EVENT: '$identify',
  GROUP_IDENTIFY_EVENT: '$groupidentify',
  EVENT_LOG_URL: 'api.amplitude.com',
  EVENT_LOG_EU_URL: 'api.eu.amplitude.com',
  DYNAMIC_CONFIG_URL: 'regionconfig.amplitude.com',
  DYNAMIC_CONFIG_EU_URL: 'regionconfig.eu.amplitude.com',
  // localStorageKeys
  LAST_EVENT_ID: 'amplitude_lastEventId',
  LAST_EVENT_TIME: 'amplitude_lastEventTime',
  LAST_IDENTIFY_ID: 'amplitude_lastIdentifyId',
  LAST_SEQUENCE_NUMBER: 'amplitude_lastSequenceNumber',
  SESSION_ID: 'amplitude_sessionId',
  // Used in cookie as well
  DEVICE_ID: 'amplitude_deviceId',
  OPT_OUT: 'amplitude_optOut',
  USER_ID: 'amplitude_userId',
  // indexes of properties in cookie v2 storage format
  DEVICE_ID_INDEX: 0,
  USER_ID_INDEX: 1,
  OPT_OUT_INDEX: 2,
  SESSION_ID_INDEX: 3,
  LAST_EVENT_TIME_INDEX: 4,
  EVENT_ID_INDEX: 5,
  IDENTIFY_ID_INDEX: 6,
  SEQUENCE_NUMBER_INDEX: 7,
  COOKIE_TEST_PREFIX: 'amp_cookie_test',
  COOKIE_PREFIX: 'amp',
  // Storage options
  STORAGE_DEFAULT: '',
  STORAGE_COOKIES: 'cookies',
  STORAGE_NONE: 'none',
  STORAGE_LOCAL: 'localStorage',
  STORAGE_SESSION: 'sessionStorage',
  // revenue keys
  REVENUE_EVENT: 'revenue_amount',
  REVENUE_PRODUCT_ID: '$productId',
  REVENUE_QUANTITY: '$quantity',
  REVENUE_PRICE: '$price',
  REVENUE_REVENUE_TYPE: '$revenueType',
  AMP_DEVICE_ID_PARAM: 'amp_device_id',
  // url param
  AMP_REFERRER_PARAM: 'amp_referrer',
  // url param for overwriting the document.refer

  REFERRER: 'referrer',
  REFERRING_DOMAIN: 'referring_domain',
  // UTM Params
  UTM_SOURCE: 'utm_source',
  UTM_MEDIUM: 'utm_medium',
  UTM_CAMPAIGN: 'utm_campaign',
  UTM_TERM: 'utm_term',
  UTM_CONTENT: 'utm_content',
  ATTRIBUTION_EVENT: '[Amplitude] Attribution Captured',
  TRANSPORT_HTTP: 'http',
  TRANSPORT_BEACON: 'beacon'
};

/*
 * UTF-8 encoder/decoder
 * http://www.webtoolkit.info/
 */
var UTF8 = {
  encode: function encode(s) {
    var utftext = '';
    for (var n = 0; n < s.length; n++) {
      var c = s.charCodeAt(n);
      if (c < 128) {
        utftext += String.fromCharCode(c);
      } else if (c > 127 && c < 2048) {
        utftext += String.fromCharCode(c >> 6 | 192);
        utftext += String.fromCharCode(c & 63 | 128);
      } else {
        utftext += String.fromCharCode(c >> 12 | 224);
        utftext += String.fromCharCode(c >> 6 & 63 | 128);
        utftext += String.fromCharCode(c & 63 | 128);
      }
    }
    return utftext;
  },
  decode: function decode(utftext) {
    var s = '';
    var i = 0;
    var c = 0,
      c1 = 0,
      c2 = 0;
    while (i < utftext.length) {
      c = utftext.charCodeAt(i);
      if (c < 128) {
        s += String.fromCharCode(c);
        i++;
      } else if (c > 191 && c < 224) {
        c1 = utftext.charCodeAt(i + 1);
        s += String.fromCharCode((c & 31) << 6 | c1 & 63);
        i += 2;
      } else {
        c1 = utftext.charCodeAt(i + 1);
        c2 = utftext.charCodeAt(i + 2);
        s += String.fromCharCode((c & 15) << 12 | (c1 & 63) << 6 | c2 & 63);
        i += 3;
      }
    }
    return s;
  }
};

/* global globalThis */
var GlobalScope = function () {
  if (typeof globalThis !== 'undefined') {
    return globalThis;
  }
  if (typeof window !== 'undefined') {
    return window;
  }
  if (typeof self !== 'undefined') {
    return self;
  }
  if (typeof __webpack_require__.g !== 'undefined') {
    return __webpack_require__.g;
  }
}();

/*
 * Base64 encoder/decoder
 * http://www.webtoolkit.info/
 */
var Base64 = {
  _keyStr: 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=',
  encode: function encode(input) {
    try {
      if (GlobalScope.btoa && GlobalScope.atob) {
        return GlobalScope.btoa(unescape(encodeURIComponent(input)));
      }
    } catch (e) {
      //log(e);
    }
    return Base64._encode(input);
  },
  _encode: function _encode(input) {
    var output = '';
    var chr1, chr2, chr3, enc1, enc2, enc3, enc4;
    var i = 0;
    input = UTF8.encode(input);
    while (i < input.length) {
      chr1 = input.charCodeAt(i++);
      chr2 = input.charCodeAt(i++);
      chr3 = input.charCodeAt(i++);
      enc1 = chr1 >> 2;
      enc2 = (chr1 & 3) << 4 | chr2 >> 4;
      enc3 = (chr2 & 15) << 2 | chr3 >> 6;
      enc4 = chr3 & 63;
      if (isNaN(chr2)) {
        enc3 = enc4 = 64;
      } else if (isNaN(chr3)) {
        enc4 = 64;
      }
      output = output + Base64._keyStr.charAt(enc1) + Base64._keyStr.charAt(enc2) + Base64._keyStr.charAt(enc3) + Base64._keyStr.charAt(enc4);
    }
    return output;
  },
  decode: function decode(input) {
    try {
      if (GlobalScope.btoa && GlobalScope.atob) {
        return decodeURIComponent(escape(GlobalScope.atob(input)));
      }
    } catch (e) {
      //log(e);
    }
    return Base64._decode(input);
  },
  _decode: function _decode(input) {
    var output = '';
    var chr1, chr2, chr3;
    var enc1, enc2, enc3, enc4;
    var i = 0;
    input = input.replace(/[^A-Za-z0-9+/=]/g, '');
    while (i < input.length) {
      enc1 = Base64._keyStr.indexOf(input.charAt(i++));
      enc2 = Base64._keyStr.indexOf(input.charAt(i++));
      enc3 = Base64._keyStr.indexOf(input.charAt(i++));
      enc4 = Base64._keyStr.indexOf(input.charAt(i++));
      chr1 = enc1 << 2 | enc2 >> 4;
      chr2 = (enc2 & 15) << 4 | enc3 >> 2;
      chr3 = (enc3 & 3) << 6 | enc4;
      output = output + String.fromCharCode(chr1);
      if (enc3 !== 64) {
        output = output + String.fromCharCode(chr2);
      }
      if (enc4 !== 64) {
        output = output + String.fromCharCode(chr3);
      }
    }
    output = UTF8.decode(output);
    return output;
  }
};

/**
 * toString ref.
 * @private
 */

var toString = Object.prototype.toString;

/**
 * Return the type of `val`.
 * @private
 * @param {Mixed} val
 * @return {String}
 * @api public
 */

function type(val) {
  switch (toString.call(val)) {
    case '[object Date]':
      return 'date';
    case '[object RegExp]':
      return 'regexp';
    case '[object Arguments]':
      return 'arguments';
    case '[object Array]':
      return 'array';
    case '[object Error]':
      return 'error';
  }
  if (val === null) {
    return 'null';
  }
  if (val === undefined) {
    return 'undefined';
  }
  if (val !== val) {
    return 'nan';
  }
  if (val && val.nodeType === 1) {
    return 'element';
  }
  if (typeof Buffer !== 'undefined' && typeof Buffer.isBuffer === 'function' && Buffer.isBuffer(val)) {
    return 'buffer';
  }
  val = val.valueOf ? val.valueOf() : Object.prototype.valueOf.apply(val);
  return _typeof(val);
}
var logLevels = {
  DISABLE: 0,
  ERROR: 1,
  WARN: 2,
  INFO: 3
};
var logLevel = logLevels.WARN;
var setLogLevel = function setLogLevel(logLevelName) {
  if (Object.prototype.hasOwnProperty.call(logLevels, logLevelName)) {
    logLevel = logLevels[logLevelName];
  }
};
var getLogLevel = function getLogLevel() {
  return logLevel;
};
var log = {
  error: function error(s) {
    if (logLevel >= logLevels.ERROR) {
      _log(s);
    }
  },
  warn: function warn(s) {
    if (logLevel >= logLevels.WARN) {
      _log(s);
    }
  },
  info: function info(s) {
    if (logLevel >= logLevels.INFO) {
      _log(s);
    }
  }
};
var _log = function _log(s) {
  try {
    console.log('[Amplitude] ' + s);
  } catch (e) {
    // console logging not available
  }
};
var isEmptyString = function isEmptyString(str) {
  return !str || str.length === 0;
};
var sessionStorageEnabled = function sessionStorageEnabled() {
  try {
    if (GlobalScope.sessionStorage) {
      return true;
    }
  } catch (e) {
    // sessionStorage disabled
  }
  return false;
};

// truncate string values in event and user properties so that request size does not get too large
var truncate$1 = function truncate(value) {
  if (type(value) === 'array') {
    for (var i = 0; i < value.length; i++) {
      value[i] = truncate(value[i]);
    }
  } else if (type(value) === 'object') {
    for (var key in value) {
      if (key in value) {
        value[key] = truncate(value[key]);
      }
    }
  } else {
    value = _truncateValue(value);
  }
  return value;
};
var _truncateValue = function _truncateValue(value) {
  if (type(value) === 'string') {
    return value.length > Constants.MAX_STRING_LENGTH ? value.substring(0, Constants.MAX_STRING_LENGTH) : value;
  }
  return value;
};
var validateInput = function validateInput(input, name, expectedType) {
  if (type(input) !== expectedType) {
    log.error('Invalid ' + name + ' input type. Expected ' + expectedType + ' but received ' + type(input));
    return false;
  }
  return true;
};
var validateDeviceId = function validateDeviceId(deviceId) {
  if (!validateInput(deviceId, 'deviceId', 'string')) {
    return false;
  }
  if (deviceId.indexOf('.') >= 0) {
    log.error("Device IDs may not contain '.' characters. Value will be ignored: \"".concat(deviceId, "\""));
    return false;
  }
  return true;
};
var validateTransport = function validateTransport(transport) {
  if (!validateInput(transport, 'transport', 'string')) {
    return false;
  }
  if (transport !== Constants.TRANSPORT_HTTP && transport !== Constants.TRANSPORT_BEACON) {
    log.error("transport value must be one of '".concat(Constants.TRANSPORT_BEACON, "' or '").concat(Constants.TRANSPORT_HTTP, "'"));
    return false;
  }
  if (transport !== Constants.TRANSPORT_HTTP && typeof navigator !== 'undefined' && !navigator.sendBeacon) {
    log.error("browser does not support sendBeacon, so transport must be HTTP");
    return false;
  }
  return true;
};

// do some basic sanitization and type checking, also catch property dicts with more than 1000 key/value pairs
var validateProperties = function validateProperties(properties) {
  var propsType = type(properties);
  if (propsType !== 'object') {
    log.error('Error: invalid properties format. Expecting Javascript object, received ' + propsType + ', ignoring');
    return {};
  }
  if (Object.keys(properties).length > Constants.MAX_PROPERTY_KEYS) {
    log.error('Error: too many properties (more than 1000), ignoring');
    return {};
  }
  var copy = {}; // create a copy with all of the valid properties
  for (var property in properties) {
    if (!Object.prototype.hasOwnProperty.call(properties, property)) {
      continue;
    }

    // validate key
    var key = property;
    var keyType = type(key);
    if (keyType !== 'string') {
      key = String(key);
      log.warn('WARNING: Non-string property key, received type ' + keyType + ', coercing to string "' + key + '"');
    }

    // validate value
    var value = validatePropertyValue(key, properties[property]);
    if (value === null) {
      continue;
    }
    copy[key] = value;
  }
  return copy;
};
var invalidValueTypes = ['nan', 'function', 'arguments', 'regexp', 'element'];
var validatePropertyValue = function validatePropertyValue(key, value) {
  var valueType = type(value);
  if (invalidValueTypes.indexOf(valueType) !== -1) {
    log.warn('WARNING: Property key "' + key + '" with invalid value type ' + valueType + ', ignoring');
    value = null;
  } else if (valueType === 'undefined') {
    value = null;
  } else if (valueType === 'error') {
    value = String(value);
    log.warn('WARNING: Property key "' + key + '" with value type error, coercing to ' + value);
  } else if (valueType === 'array') {
    // check for nested arrays or objects
    var arrayCopy = [];
    for (var i = 0; i < value.length; i++) {
      var element = value[i];
      var elemType = type(element);
      if (elemType === 'array') {
        log.warn('WARNING: Cannot have ' + elemType + ' nested in an array property value, skipping');
        continue;
      } else if (elemType === 'object') {
        arrayCopy.push(validateProperties(element));
      } else {
        arrayCopy.push(validatePropertyValue(key, element));
      }
    }
    value = arrayCopy;
  } else if (valueType === 'object') {
    value = validateProperties(value);
  }
  return value;
};
var validateGroups = function validateGroups(groups) {
  var groupsType = type(groups);
  if (groupsType !== 'object') {
    log.error('Error: invalid groups format. Expecting Javascript object, received ' + groupsType + ', ignoring');
    return {};
  }
  var copy = {}; // create a copy with all of the valid properties
  for (var group in groups) {
    if (!Object.prototype.hasOwnProperty.call(groups, group)) {
      continue;
    }

    // validate key
    var key = group;
    var keyType = type(key);
    if (keyType !== 'string') {
      key = String(key);
      log.warn('WARNING: Non-string groupType, received type ' + keyType + ', coercing to string "' + key + '"');
    }

    // validate value
    var value = validateGroupName(key, groups[group]);
    if (value === null) {
      continue;
    }
    copy[key] = value;
  }
  return copy;
};
var validateGroupName = function validateGroupName(key, groupName) {
  var groupNameType = type(groupName);
  if (groupNameType === 'string') {
    return groupName;
  }
  if (groupNameType === 'date' || groupNameType === 'number' || groupNameType === 'boolean') {
    groupName = String(groupName);
    log.warn('WARNING: Non-string groupName, received type ' + groupNameType + ', coercing to string "' + groupName + '"');
    return groupName;
  }
  if (groupNameType === 'array') {
    // check for nested arrays or objects
    var arrayCopy = [];
    for (var i = 0; i < groupName.length; i++) {
      var element = groupName[i];
      var elemType = type(element);
      if (elemType === 'array' || elemType === 'object') {
        log.warn('WARNING: Skipping nested ' + elemType + ' in array groupName');
        continue;
      } else if (elemType === 'string') {
        arrayCopy.push(element);
      } else if (elemType === 'date' || elemType === 'number' || elemType === 'boolean') {
        element = String(element);
        log.warn('WARNING: Non-string groupName, received type ' + elemType + ', coercing to string "' + element + '"');
        arrayCopy.push(element);
      }
    }
    return arrayCopy;
  }
  log.warn('WARNING: Non-string groupName, received type ' + groupNameType + '. Please use strings or array of strings for groupName');
};

// parses the value of a url param (for example ?gclid=1234&...)
var getQueryParam = function getQueryParam(name, query) {
  name = name.replace(/[[]/, '\\[').replace(/[\]]/, '\\]');
  var regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
  var results = regex.exec(query);
  return results === null ? undefined : decodeURIComponent(results[1].replace(/\+/g, ' '));
};
var isWebWorkerEnvironment = function isWebWorkerEnvironment() {
  return typeof WorkerGlobalScope !== 'undefined';
};
var validateSessionId = function validateSessionId(sessionId) {
  if (validateInput(sessionId, 'sessionId', 'number') && new Date(sessionId).getTime() > 0) {
    return true;
  }
  log.error("sessionId value must in milliseconds since epoch (Unix Timestamp)");
  return false;
};
var getLocation = function getLocation() {
  return GlobalScope.location;
};
var getHost = function getHost(url) {
  var defaultHostname = GlobalScope.location ? GlobalScope.location.hostname : '';
  if (url) {
    if (typeof document !== 'undefined') {
      var a = document.createElement('a');
      a.href = url;
      return a.hostname || defaultHostname;
    }
    if (typeof URL === 'function') {
      var u = new URL(url);
      return u.hostname || defaultHostname;
    }
  }
  return defaultHostname;
};
var utils = {
  setLogLevel: setLogLevel,
  getLogLevel: getLogLevel,
  logLevels: logLevels,
  log: log,
  isEmptyString: isEmptyString,
  isWebWorkerEnvironment: isWebWorkerEnvironment,
  getQueryParam: getQueryParam,
  sessionStorageEnabled: sessionStorageEnabled,
  truncate: truncate$1,
  validateGroups: validateGroups,
  validateInput: validateInput,
  validateProperties: validateProperties,
  validateDeviceId: validateDeviceId,
  validateTransport: validateTransport,
  validateSessionId: validateSessionId,
  getLocation: getLocation,
  getHost: getHost
};
var get$1 = function get(name) {
  try {
    var ca = document.cookie.split(';');
    var value = null;
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) === ' ') {
        c = c.substring(1, c.length);
      }
      if (c.indexOf(name) === 0) {
        value = c.substring(name.length, c.length);
        break;
      }
    }
    return value;
  } catch (e) {
    return null;
  }
};
var getAll = function getAll(name) {
  try {
    var cookieArray = document.cookie.split(';').map(function (c) {
      return c.trimStart();
    });
    var values = [];
    var _iterator = _createForOfIteratorHelper(cookieArray),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var cookie = _step.value;
        while (cookie.charAt(0) === ' ') {
          cookie = cookie.substring(1);
        }
        if (cookie.indexOf(name) === 0) {
          values.push(cookie.substring(name.length));
        }
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
    return values;
  } catch (e) {
    return [];
  }
};
var set$1 = function set(name, value, opts) {
  var expires = value !== null ? opts.expirationDays : -1;
  if (expires) {
    var date = new Date();
    date.setTime(date.getTime() + expires * 24 * 60 * 60 * 1000);
    expires = date;
  }
  var str = name + '=' + value;
  if (expires) {
    str += '; expires=' + expires.toUTCString();
  }
  str += '; path=/';
  if (opts.domain) {
    str += '; domain=' + opts.domain;
  }
  if (opts.secure) {
    str += '; Secure';
  }
  if (opts.sameSite) {
    str += '; SameSite=' + opts.sameSite;
  }
  document.cookie = str;
};
var getLastEventTime = function getLastEventTime() {
  var cookie = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var strValue = cookie.split('.')[Constants.LAST_EVENT_TIME_INDEX];
  var parsedValue;
  if (strValue) {
    parsedValue = parseInt(strValue, 32);
  }
  if (parsedValue) {
    return parsedValue;
  } else {
    utils.log.warn("unable to parse malformed cookie: ".concat(cookie));
    return 0;
  }
};
var sortByEventTime = function sortByEventTime(cookies) {
  return _toConsumableArray(cookies).sort(function (c1, c2) {
    var t1 = getLastEventTime(c1);
    var t2 = getLastEventTime(c2);
    // sort c1 first if its last event time is more recent
    // i.e its event time integer is larger that c2's
    return t2 - t1;
  });
};

// test that cookies are enabled - navigator.cookiesEnabled yields false positives in IE, need to test directly
var areCookiesEnabled = function areCookiesEnabled() {
  var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var cookieName = Constants.COOKIE_TEST_PREFIX;
  if (typeof document === 'undefined') {
    return false;
  }
  var _areCookiesEnabled = false;
  try {
    var uid = String(Date.now());
    set$1(cookieName, uid, opts);
    utils.log.info("Testing if cookies available");
    _areCookiesEnabled = get$1(cookieName + '=') === uid;
  } catch (e) {
    utils.log.warn("Error thrown when checking for cookies. Reason: \"".concat(e, "\""));
  } finally {
    utils.log.info("Cleaning up cookies availability test");
    set$1(cookieName, null, opts);
  }
  return _areCookiesEnabled;
};
var baseCookie = {
  set: set$1,
  get: get$1,
  getAll: getAll,
  getLastEventTime: getLastEventTime,
  sortByEventTime: sortByEventTime,
  areCookiesEnabled: areCookiesEnabled
};

// A URL safe variation on the the list of Base64 characters
var base64Chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_';
var base64Id = function base64Id() {
  var str = '';
  for (var i = 0; i < 22; ++i) {
    str += base64Chars.charAt(Math.floor(Math.random() * 64));
  }
  return str;
};

// Utility that finds top level domain to write to
var topDomain = function topDomain(url) {
  var host = utils.getHost(url);
  var parts = host.split('.');
  var levels = [];
  var cname = '_tldtest_' + base64Id();
  if (utils.isWebWorkerEnvironment()) return '';
  for (var i = parts.length - 2; i >= 0; --i) {
    levels.push(parts.slice(i).join('.'));
  }
  for (var _i = 0; _i < levels.length; ++_i) {
    var domain = levels[_i];
    var opts = {
      domain: '.' + domain
    };
    baseCookie.set(cname, 1, opts);
    if (baseCookie.get(cname)) {
      baseCookie.set(cname, null, opts);
      return domain;
    }
  }
  return '';
};

/*
 * Cookie data
 */
var _options = {
  expirationDays: undefined,
  domain: undefined
};
var reset = function reset() {
  _options = {
    expirationDays: undefined,
    domain: undefined
  };
};
var options = function options(opts) {
  if (arguments.length === 0) {
    return _options;
  }
  opts = opts || {};
  _options.expirationDays = opts.expirationDays;
  _options.secure = opts.secure;
  _options.sameSite = opts.sameSite;
  var domain = !utils.isEmptyString(opts.domain) ? opts.domain : '.' + topDomain(utils.getLocation().href);
  var token = Math.random();
  _options.domain = domain;
  set$2('amplitude_test', token);
  var stored = get$2('amplitude_test');
  if (!stored || stored !== token) {
    domain = null;
  }
  remove('amplitude_test');
  _options.domain = domain;
  return _options;
};
var _domainSpecific = function _domainSpecific(name) {
  // differentiate between cookies on different domains
  var suffix = '';
  if (_options.domain) {
    suffix = _options.domain.charAt(0) === '.' ? _options.domain.substring(1) : _options.domain;
  }
  return name + suffix;
};
var get$2 = function get(name) {
  var nameEq = _domainSpecific(name) + '=';
  var value = baseCookie.get(nameEq);
  try {
    if (value) {
      return JSON.parse(Base64.decode(value));
    }
  } catch (e) {
    return null;
  }
  return null;
};
var set$2 = function set(name, value) {
  try {
    baseCookie.set(_domainSpecific(name), Base64.encode(JSON.stringify(value)), _options);
    return true;
  } catch (e) {
    return false;
  }
};
var setRaw = function setRaw(name, value) {
  try {
    baseCookie.set(_domainSpecific(name), value, _options);
    return true;
  } catch (e) {
    return false;
  }
};
var getRaw = function getRaw(name) {
  var nameEq = _domainSpecific(name) + '=';
  return baseCookie.get(nameEq);
};
var remove = function remove(name) {
  try {
    baseCookie.set(_domainSpecific(name), null, _options);
    return true;
  } catch (e) {
    return false;
  }
};
var Cookie = {
  reset: reset,
  options: options,
  get: get$2,
  set: set$2,
  remove: remove,
  setRaw: setRaw,
  getRaw: getRaw
};
var WorkerStorage = /*#__PURE__*/function () {
  function WorkerStorage() {
    _classCallCheck(this, WorkerStorage);
    this.map = new Map();
    this.length = 0;
  }
  _createClass(WorkerStorage, [{
    key: "key",
    value: function key(index) {
      var keys = Array.from(this.map.keys());
      var key = keys[index];
      return this.map.get(key);
    }
  }, {
    key: "getItem",
    value: function getItem(key) {
      return this.map.get(key);
    }
  }, {
    key: "setItem",
    value: function setItem(key, value) {
      if (!this.map.has(key)) {
        this.length += 1;
      }
      this.map.set(key, value);
    }
  }, {
    key: "removeItem",
    value: function removeItem(key) {
      if (this.map.has(key)) {
        this.length -= 1;
        this.map["delete"](key);
      }
    }
  }, {
    key: "clear",
    value: function clear() {
      this.map.clear();
      this.length = 0;
    }
  }]);
  return WorkerStorage;
}();

/*
 * Implement localStorage to support Firefox 2-3 and IE 5-7
 */
var localStorage$1;
{
  // test that Window.localStorage is available and works
  var windowLocalStorageAvailable = function windowLocalStorageAvailable() {
    var uid = new Date();
    var result;
    try {
      GlobalScope.localStorage.setItem(uid, uid);
      result = GlobalScope.localStorage.getItem(uid) === String(uid);
      GlobalScope.localStorage.removeItem(uid);
      return result;
    } catch (e) {
      // localStorage not available
    }
    return false;
  };
  if (windowLocalStorageAvailable()) {
    localStorage$1 = GlobalScope.localStorage;
  } else if (typeof GlobalScope !== 'undefined' && GlobalScope.globalStorage) {
    // Firefox 2-3 use globalStorage
    // See https://developer.mozilla.org/en/dom/storage#globalStorage
    try {
      localStorage$1 = GlobalScope.globalStorage[GlobalScope.location.hostname];
    } catch (e) {
      // Something bad happened...
    }
  } else if (typeof document !== 'undefined') {
    // IE 5-7 use userData
    // See http://msdn.microsoft.com/en-us/library/ms531424(v=vs.85).aspx
    var div = document.createElement('div'),
      attrKey = 'localStorage';
    div.style.display = 'none';
    document.getElementsByTagName('head')[0].appendChild(div);
    if (div.addBehavior) {
      div.addBehavior('#default#userdata');
      localStorage$1 = {
        length: 0,
        setItem: function setItem(k, v) {
          div.load(attrKey);
          if (!div.getAttribute(k)) {
            this.length++;
          }
          div.setAttribute(k, v);
          div.save(attrKey);
        },
        getItem: function getItem(k) {
          div.load(attrKey);
          return div.getAttribute(k);
        },
        removeItem: function removeItem(k) {
          div.load(attrKey);
          if (div.getAttribute(k)) {
            this.length--;
          }
          div.removeAttribute(k);
          div.save(attrKey);
        },
        clear: function clear() {
          div.load(attrKey);
          var i = 0;
          var attr;
          while (attr = div.XMLDocument.documentElement.attributes[i++]) {
            div.removeAttribute(attr.name);
          }
          div.save(attrKey);
          this.length = 0;
        },
        key: function key(k) {
          div.load(attrKey);
          return div.XMLDocument.documentElement.attributes[k];
        }
      };
      div.load(attrKey);
      localStorage$1.length = div.XMLDocument.documentElement.attributes.length;
    }
  } else if (utils.isWebWorkerEnvironment()) {
    // Web worker
    localStorage$1 = new WorkerStorage();
  }
  if (!localStorage$1) {
    /* eslint-disable no-unused-vars */
    localStorage$1 = {
      length: 0,
      setItem: function setItem(k, v) {},
      getItem: function getItem(k) {},
      removeItem: function removeItem(k) {},
      clear: function clear() {},
      key: function key(k) {}
    };
    /* eslint-enable no-unused-vars */
  }
}
var localStorage$1$1 = localStorage$1;

/*
 * Abstraction layer for cookie storage.
 * Uses cookie if available, otherwise fallback to localstorage.
 */
var cookieStorage = function cookieStorage() {
  this.storage = null;
};
cookieStorage.prototype.getStorage = function (disableCookies) {
  if (this.storage !== null) {
    return this.storage;
  }
  if (!disableCookies && baseCookie.areCookiesEnabled()) {
    this.storage = Cookie;
  } else {
    // if cookies disabled, fallback to localstorage
    // note: localstorage does not persist across subdomains
    var keyPrefix = 'amp_cookiestore_';
    this.storage = {
      _options: {
        expirationDays: undefined,
        domain: undefined,
        secure: false
      },
      reset: function reset() {
        this._options = {
          expirationDays: undefined,
          domain: undefined,
          secure: false
        };
      },
      options: function options(opts) {
        if (arguments.length === 0) {
          return this._options;
        }
        opts = opts || {};
        this._options.expirationDays = opts.expirationDays || this._options.expirationDays;
        // localStorage is specific to subdomains
        this._options.domain = opts.domain || this._options.domain || GlobalScope && GlobalScope.location && GlobalScope.location.hostname;
        return this._options.secure = opts.secure || false;
      },
      get: function get(name) {
        try {
          return JSON.parse(localStorage$1$1.getItem(keyPrefix + name));
        } catch (e) {} /* eslint-disable-line no-empty */
        return null;
      },
      set: function set(name, value) {
        try {
          localStorage$1$1.setItem(keyPrefix + name, JSON.stringify(value));
          return true;
        } catch (e) {} /* eslint-disable-line no-empty */
        return false;
      },
      remove: function remove(name) {
        try {
          localStorage$1$1.removeItem(keyPrefix + name);
        } catch (e) {
          return false;
        }
      }
    };
  }
  return this.storage;
};
var _storageOptionExists;
var storageOptionExists = (_storageOptionExists = {}, _defineProperty$1(_storageOptionExists, Constants.STORAGE_COOKIES, true), _defineProperty$1(_storageOptionExists, Constants.STORAGE_NONE, true), _defineProperty$1(_storageOptionExists, Constants.STORAGE_LOCAL, true), _defineProperty$1(_storageOptionExists, Constants.STORAGE_SESSION, true), _storageOptionExists);

/**
 * MetadataStorage involves SDK data persistance
 * storage priority: cookies -> localStorage -> in memory
 * This priority can be overriden by setting the storage options.
 * if in localStorage, unable track users between subdomains
 * if in memory, then memory can't be shared between different tabs
 */
var MetadataStorage = /*#__PURE__*/function () {
  function MetadataStorage(_ref) {
    var storageKey = _ref.storageKey,
      disableCookies = _ref.disableCookies,
      domain = _ref.domain,
      secure = _ref.secure,
      sameSite = _ref.sameSite,
      expirationDays = _ref.expirationDays,
      storage = _ref.storage;
    _classCallCheck(this, MetadataStorage);
    this.storageKey = storageKey;
    this.domain = domain;
    this.secure = secure;
    this.sameSite = sameSite;
    this.expirationDays = expirationDays;
    this.cookieDomain = '';
    var loc = utils.getLocation() ? utils.getLocation().href : undefined;
    var writableTopDomain = !disableCookies ? topDomain(loc) : '';
    this.cookieDomain = domain || (writableTopDomain ? '.' + writableTopDomain : null);
    if (storageOptionExists[storage]) {
      this.storage = storage;
    } else {
      var disableCookieStorage = disableCookies || !baseCookie.areCookiesEnabled({
        domain: this.cookieDomain,
        secure: this.secure,
        sameSite: this.sameSite,
        expirationDays: this.expirationDays
      });
      if (disableCookieStorage) {
        this.storage = Constants.STORAGE_LOCAL;
      } else {
        this.storage = Constants.STORAGE_COOKIES;
      }
    }
  }
  _createClass(MetadataStorage, [{
    key: "getCookieStorageKey",
    value: function getCookieStorageKey() {
      if (!this.domain) {
        return this.storageKey;
      }
      var suffix = this.domain.charAt(0) === '.' ? this.domain.substring(1) : this.domain;
      return "".concat(this.storageKey).concat(suffix ? "_".concat(suffix) : '');
    }

    /*
     * Data is saved as delimited values rather than JSO to minimize cookie space
     * Should not change order of the items
     */
  }, {
    key: "save",
    value: function save(_ref2) {
      var deviceId = _ref2.deviceId,
        userId = _ref2.userId,
        optOut = _ref2.optOut,
        sessionId = _ref2.sessionId,
        lastEventTime = _ref2.lastEventTime,
        eventId = _ref2.eventId,
        identifyId = _ref2.identifyId,
        sequenceNumber = _ref2.sequenceNumber;
      if (this.storage === Constants.STORAGE_NONE) {
        return;
      }
      var value = [deviceId, Base64.encode(userId || ''),
      // used to convert not unicode to alphanumeric since cookies only use alphanumeric
      optOut ? '1' : '', sessionId ? sessionId.toString(32) : '0',
      // generated when instantiated, timestamp (but re-uses session id in cookie if not expired) @TODO clients may want custom session id
      lastEventTime ? lastEventTime.toString(32) : '0',
      // last time an event was set
      eventId ? eventId.toString(32) : '0', identifyId ? identifyId.toString(32) : '0', sequenceNumber ? sequenceNumber.toString(32) : '0'].join('.');
      switch (this.storage) {
        case Constants.STORAGE_SESSION:
          if (GlobalScope.sessionStorage) {
            GlobalScope.sessionStorage.setItem(this.storageKey, value);
          }
          break;
        case Constants.STORAGE_LOCAL:
          localStorage$1$1.setItem(this.storageKey, value);
          break;
        case Constants.STORAGE_COOKIES:
          this.saveCookie(value);
          break;
      }
    }
  }, {
    key: "saveCookie",
    value: function saveCookie(value) {
      baseCookie.set(this.getCookieStorageKey(), value, {
        domain: this.cookieDomain,
        secure: this.secure,
        sameSite: this.sameSite,
        expirationDays: this.expirationDays
      });
    }
  }, {
    key: "load",
    value: function load() {
      var _this = this;
      var str;
      if (this.storage === Constants.STORAGE_COOKIES) {
        var cookieKey = this.getCookieStorageKey() + '=';
        var allCookies = baseCookie.getAll(cookieKey);
        if (allCookies.length === 0 || allCookies.length === 1) {
          str = allCookies[0];
        } else {
          // dedup cookies by deleting them all and restoring
          // the one with the most recent event time
          var latestCookie = baseCookie.sortByEventTime(allCookies)[0];
          allCookies.forEach(function () {
            return baseCookie.set(_this.getCookieStorageKey(), null, {});
          });
          this.saveCookie(latestCookie);
          str = baseCookie.get(cookieKey);
        }
      }
      if (!str) {
        str = localStorage$1$1.getItem(this.storageKey);
      }
      if (!str) {
        try {
          str = GlobalScope.sessionStorage && GlobalScope.sessionStorage.getItem(this.storageKey);
        } catch (e) {
          utils.log.info("window.sessionStorage unavailable. Reason: \"".concat(e, "\""));
        }
      }
      if (!str) {
        return null;
      }
      var values = str.split('.');
      var userId = null;
      if (values[Constants.USER_ID_INDEX]) {
        try {
          userId = Base64.decode(values[Constants.USER_ID_INDEX]);
        } catch (e) {
          userId = null;
        }
      }
      return {
        deviceId: values[Constants.DEVICE_ID_INDEX],
        userId: userId,
        optOut: values[Constants.OPT_OUT_INDEX] === '1',
        sessionId: parseInt(values[Constants.SESSION_ID_INDEX], 32),
        lastEventTime: parseInt(values[Constants.LAST_EVENT_TIME_INDEX], 32),
        eventId: parseInt(values[Constants.EVENT_ID_INDEX], 32),
        identifyId: parseInt(values[Constants.IDENTIFY_ID_INDEX], 32),
        sequenceNumber: parseInt(values[Constants.SEQUENCE_NUMBER_INDEX], 32)
      };
    }

    /**
     * Clears any saved metadata storage
     * @constructor AmplitudeClient
     * @public
     * @return {boolean} True if metadata was cleared, false if none existed
     */
  }, {
    key: "clear",
    value: function clear() {
      var str;
      if (this.storage === Constants.STORAGE_COOKIES) {
        str = baseCookie.get(this.getCookieStorageKey() + '=');
        baseCookie.set(this.getCookieStorageKey(), null, {
          domain: this.cookieDomain,
          secure: this.secure,
          sameSite: this.sameSite,
          expirationDays: 0
        });
      }
      if (!str) {
        str = localStorage$1$1.getItem(this.storageKey);
        localStorage$1$1.clear();
      }
      if (!str) {
        try {
          str = GlobalScope.sessionStorage && GlobalScope.sessionStorage.getItem(this.storageKey);
          GlobalScope.sessionStorage.clear();
        } catch (e) {
          utils.log.info("window.sessionStorage unavailable. Reason: \"".concat(e, "\""));
        }
      }
      return !!str;
    }
  }]);
  return MetadataStorage;
}();
var getUtmData$1 = function getUtmData(rawCookie, query) {
  // Translate the utmz cookie format into url query string format.
  var cookie = rawCookie ? '?' + rawCookie.split('.').slice(-1)[0].replace(/\|/g, '&') : '';
  var fetchParam = function fetchParam(queryName, query, cookieName, cookie) {
    return utils.getQueryParam(queryName, query) || utils.getQueryParam(cookieName, cookie);
  };
  var utmSource = fetchParam(Constants.UTM_SOURCE, query, 'utmcsr', cookie);
  var utmMedium = fetchParam(Constants.UTM_MEDIUM, query, 'utmcmd', cookie);
  var utmCampaign = fetchParam(Constants.UTM_CAMPAIGN, query, 'utmccn', cookie);
  var utmTerm = fetchParam(Constants.UTM_TERM, query, 'utmctr', cookie);
  var utmContent = fetchParam(Constants.UTM_CONTENT, query, 'utmcct', cookie);
  var utmData = {};
  var addIfNotNull = function addIfNotNull(key, value) {
    if (!utils.isEmptyString(value)) {
      utmData[key] = value;
    }
  };
  addIfNotNull(Constants.UTM_SOURCE, utmSource);
  addIfNotNull(Constants.UTM_MEDIUM, utmMedium);
  addIfNotNull(Constants.UTM_CAMPAIGN, utmCampaign);
  addIfNotNull(Constants.UTM_TERM, utmTerm);
  addIfNotNull(Constants.UTM_CONTENT, utmContent);
  return utmData;
};

/*
 * Wrapper for a user properties JSON object that supports operations.
 * Note: if a user property is used in multiple operations on the same Identify object,
 * only the first operation will be saved, and the rest will be ignored.
 */

var AMP_OP_ADD = '$add';
var AMP_OP_APPEND = '$append';
var AMP_OP_CLEAR_ALL = '$clearAll';
var AMP_OP_PREPEND = '$prepend';
var AMP_OP_SET = '$set';
var AMP_OP_SET_ONCE = '$setOnce';
var AMP_OP_UNSET = '$unset';
var AMP_OP_PREINSERT = '$preInsert';
var AMP_OP_POSTINSERT = '$postInsert';
var AMP_OP_REMOVE = '$remove';

/**
 * Identify API - instance constructor. Identify objects are a wrapper for user property operations.
 * Each method adds a user property operation to the Identify object, and returns the same Identify object,
 * allowing you to chain multiple method calls together.
 * Note: if the same user property is used in multiple operations on a single Identify object,
 * only the first operation on that property will be saved, and the rest will be ignored.
 * @constructor Identify
 * @public
 * @example var identify = new amplitude.Identify();
 */
var Identify = function Identify() {
  this.userPropertiesOperations = {};
  this.properties = []; // keep track of keys that have been added
};

/**
 * Increment a user property by a given value (can also be negative to decrement).
 * If the user property does not have a value set yet, it will be initialized to 0 before being incremented.
 * @public
 * @param {string} property - The user property key.
 * @param {number|string} value - The amount by which to increment the user property. Allows numbers as strings (ex: '123').
 * @return {Identify} Returns the same Identify object, allowing you to chain multiple method calls together.
 * @example var identify = new amplitude.Identify().add('karma', 1).add('friends', 1);
 * amplitude.identify(identify); // send the Identify call
 */
Identify.prototype.add = function (property, value) {
  if (type(value) === 'number' || type(value) === 'string') {
    this._addOperation(AMP_OP_ADD, property, value);
  } else {
    utils.log.error('Unsupported type for value: ' + type(value) + ', expecting number or string');
  }
  return this;
};

/**
 * Append a value or values to a user property.
 * If the user property does not have a value set yet,
 * it will be initialized to an empty list before the new values are appended.
 * If the user property has an existing value and it is not a list,
 * the existing value will be converted into a list with the new values appended.
 * @public
 * @param {string} property - The user property key.
 * @param {number|string|list|object} value - A value or values to append.
 * Values can be numbers, strings, lists, or object (key:value dict will be flattened).
 * @return {Identify} Returns the same Identify object, allowing you to chain multiple method calls together.
 * @example var identify = new amplitude.Identify().append('ab-tests', 'new-user-tests');
 * identify.append('some_list', [1, 2, 3, 4, 'values']);
 * amplitude.identify(identify); // send the Identify call
 */
Identify.prototype.append = function (property, value) {
  this._addOperation(AMP_OP_APPEND, property, value);
  return this;
};

/**
 * Clear all user properties for the current user.
 * SDK user should instead call amplitude.clearUserProperties() instead of using this.
 * $clearAll needs to be sent on its own Identify object. If there are already other operations, then don't add $clearAll.
 * If $clearAll already in an Identify object, don't allow other operations to be added.
 * @private
 */
Identify.prototype.clearAll = function () {
  if (Object.keys(this.userPropertiesOperations).length > 0) {
    if (!Object.prototype.hasOwnProperty.call(this.userPropertiesOperations, AMP_OP_CLEAR_ALL)) {
      utils.log.error('Need to send $clearAll on its own Identify object without any other operations, skipping $clearAll');
    }
    return this;
  }
  this.userPropertiesOperations[AMP_OP_CLEAR_ALL] = '-';
  return this;
};

/**
 * Prepend a value or values to a user property.
 * Prepend means inserting the value or values at the front of a list.
 * If the user property does not have a value set yet,
 * it will be initialized to an empty list before the new values are prepended.
 * If the user property has an existing value and it is not a list,
 * the existing value will be converted into a list with the new values prepended.
 * @public
 * @param {string} property - The user property key.
 * @param {number|string|list|object} value - A value or values to prepend.
 * Values can be numbers, strings, lists, or object (key:value dict will be flattened).
 * @return {Identify} Returns the same Identify object, allowing you to chain multiple method calls together.
 * @example var identify = new amplitude.Identify().prepend('ab-tests', 'new-user-tests');
 * identify.prepend('some_list', [1, 2, 3, 4, 'values']);
 * amplitude.identify(identify); // send the Identify call
 */
Identify.prototype.prepend = function (property, value) {
  this._addOperation(AMP_OP_PREPEND, property, value);
  return this;
};

/**
 * Sets the value of a given user property. If a value already exists, it will be overwriten with the new value.
 * @public
 * @param {string} property - The user property key.
 * @param {number|string|list|boolean|object} value - A value or values to set.
 * Values can be numbers, strings, lists, or object (key:value dict will be flattened).
 * @return {Identify} Returns the same Identify object, allowing you to chain multiple method calls together.
 * @example var identify = new amplitude.Identify().set('user_type', 'beta');
 * identify.set('name', {'first': 'John', 'last': 'Doe'}); // dict is flattened and becomes name.first: John, name.last: Doe
 * amplitude.identify(identify); // send the Identify call
 */
Identify.prototype.set = function (property, value) {
  this._addOperation(AMP_OP_SET, property, value);
  return this;
};

/**
 * Sets the value of a given user property only once. Subsequent setOnce operations on that user property will be ignored;
 * however, that user property can still be modified through any of the other operations.
 * Useful for capturing properties such as 'initial_signup_date', 'initial_referrer', etc.
 * @public
 * @param {string} property - The user property key.
 * @param {number|string|list|boolean|object} value - A value or values to set once.
 * Values can be numbers, strings, lists, or object (key:value dict will be flattened).
 * @return {Identify} Returns the same Identify object, allowing you to chain multiple method calls together.
 * @example var identify = new amplitude.Identify().setOnce('sign_up_date', '2016-04-01');
 * amplitude.identify(identify); // send the Identify call
 */
Identify.prototype.setOnce = function (property, value) {
  this._addOperation(AMP_OP_SET_ONCE, property, value);
  return this;
};

/**
 * Unset and remove a user property. This user property will no longer show up in a user's profile.
 * @public
 * @param {string} property - The user property key.
 * @return {Identify} Returns the same Identify object, allowing you to chain multiple method calls together.
 * @example var identify = new amplitude.Identify().unset('user_type').unset('age');
 * amplitude.identify(identify); // send the Identify call
 */
Identify.prototype.unset = function (property) {
  this._addOperation(AMP_OP_UNSET, property, '-');
  return this;
};

/**
 * Preinsert a value or values to a user property, if it does not exist in the user property already.
 * Preinsert means inserting the value or values to the beginning of the specified user property.
 * If the item already exists in the user property, it will be a no-op.
 * @public
 * @param {string} property - The user property key.
 * @param {number|string|list|object} value - A value or values to insert.
 * @returns {Identify} Returns the same Identify object, allowing you to chain multiple method calls together.
 */
Identify.prototype.preInsert = function (property, value) {
  this._addOperation(AMP_OP_PREINSERT, property, value);
  return this;
};

/**
 * Postinsert a value or values to a user property, if it does not exist in the user property already.
 * Postinsert means inserting the value or values to the beginning of the specified user property.
 * If the item already exists in the user property, it will be a no-op.
 * @param {string} property - The user property key.
 * @param {number|string|list|object} value - A value or values to insert.
 * @returns {Identify} Returns the same Identify object, allowing you to chain multiple method calls together.
 */
Identify.prototype.postInsert = function (property, value) {
  this._addOperation(AMP_OP_POSTINSERT, property, value);
  return this;
};

/**
 * Remove a value or values to a user property, if it does exist in the user property.
 * If the item does not exist in the user property, it will be a no-op.
 * @param {string} property - The user property key.
 * @param {number|string|list|object} value - A value or values to remove.
 * @returns {Identify} Returns the same Identify object, allowing you to chain multiple method calls together.
 */
Identify.prototype.remove = function (property, value) {
  this._addOperation(AMP_OP_REMOVE, property, value);
  return this;
};

/**
 * Helper function that adds operation to the Identify's object
 * Handle's filtering of duplicate user property keys, and filtering for clearAll.
 * @private
 */
Identify.prototype._addOperation = function (operation, property, value) {
  // check that the identify doesn't already contain a clearAll
  if (Object.prototype.hasOwnProperty.call(this.userPropertiesOperations, AMP_OP_CLEAR_ALL)) {
    utils.log.error('This identify already contains a $clearAll operation, skipping operation ' + operation);
    return;
  }

  // check that property wasn't already used in this Identify
  if (this.properties.indexOf(property) !== -1) {
    utils.log.error('User property "' + property + '" already used in this identify, skipping operation ' + operation);
    return;
  }
  if (!Object.prototype.hasOwnProperty.call(this.userPropertiesOperations, operation)) {
    this.userPropertiesOperations[operation] = {};
  }
  this.userPropertiesOperations[operation][property] = value;
  this.properties.push(property);
};

/*
 * Simple AJAX request object
 */
var Request$1 = function Request(url, data, headers) {
  this.url = url;
  this.data = data || {};
  this.headers = headers;
};
var CORS_HEADER = 'Cross-Origin-Resource-Policy';
function setHeaders(xhr, headers) {
  for (var header in headers) {
    if (header === CORS_HEADER && !headers[header]) {
      continue;
    }
    xhr.setRequestHeader(header, headers[header]);
  }
}
Request$1.prototype.send = function (callback) {
  var isIE = GlobalScope.XDomainRequest ? true : false;
  if (isIE) {
    var xdr = new GlobalScope.XDomainRequest();
    xdr.open('POST', this.url, true);
    xdr.onload = function () {
      callback(200, xdr.responseText);
    };
    xdr.onerror = function () {
      // status code not available from xdr, try string matching on responseText
      if (xdr.responseText === 'Request Entity Too Large') {
        callback(413, xdr.responseText);
      } else {
        callback(500, xdr.responseText);
      }
    };
    xdr.ontimeout = function () {};
    xdr.onprogress = function () {};
    xdr.send(queryString$1.stringify(this.data));
  } else if (typeof XMLHttpRequest !== 'undefined') {
    var xhr = new XMLHttpRequest();
    xhr.open('POST', this.url, true);
    xhr.onreadystatechange = function () {
      if (xhr.readyState === 4) {
        callback(xhr.status, xhr.responseText);
      }
    };
    setHeaders(xhr, this.headers);
    xhr.send(queryString$1.stringify(this.data));
  } else {
    var responseStatus = undefined;
    fetch(this.url, {
      method: 'POST',
      headers: this.headers,
      body: queryString$1.stringify(this.data)
    }).then(function (response) {
      responseStatus = response.status;
      return response.text();
    }).then(function (responseText) {
      callback(responseStatus, responseText);
    });
  }
  //log('sent request to ' + this.url + ' with data ' + decodeURIComponent(queryString(this.data)));
};

/**
 * Revenue API - instance constructor. Wrapper for logging Revenue data. Revenue objects get passed to amplitude.logRevenueV2 to send to Amplitude servers.
 * Each method updates a revenue property in the Revenue object, and returns the same Revenue object,
 * allowing you to chain multiple method calls together.
 *
 * Note: price is a required field to log revenue events.
 * If quantity is not specified then defaults to 1.
 * @constructor Revenue
 * @public
 * @example var revenue = new amplitude.Revenue();
 */
var Revenue = function Revenue() {
  // required fields
  this._price = null;

  // optional fields
  this._productId = null;
  this._quantity = 1;
  this._revenueType = null;
  this._properties = null;
};

/**
 * Set a value for the product identifer.
 * @public
 * @param {string} productId - The value for the product identifier. Empty and invalid strings are ignored.
 * @return {Revenue} Returns the same Revenue object, allowing you to chain multiple method calls together.
 * @example var revenue = new amplitude.Revenue().setProductId('productIdentifier').setPrice(10.99);
 * amplitude.logRevenueV2(revenue);
 */
Revenue.prototype.setProductId = function setProductId(productId) {
  if (type(productId) !== 'string') {
    utils.log.error('Unsupported type for productId: ' + type(productId) + ', expecting string');
  } else if (utils.isEmptyString(productId)) {
    utils.log.error('Invalid empty productId');
  } else {
    this._productId = productId;
  }
  return this;
};

/**
 * Set a value for the quantity. Note revenue amount is calculated as price * quantity.
 * @public
 * @param {number} quantity - Integer value for the quantity. If not set, quantity defaults to 1.
 * @return {Revenue} Returns the same Revenue object, allowing you to chain multiple method calls together.
 * @example var revenue = new amplitude.Revenue().setProductId('productIdentifier').setPrice(10.99).setQuantity(5);
 * amplitude.logRevenueV2(revenue);
 */
Revenue.prototype.setQuantity = function setQuantity(quantity) {
  if (type(quantity) !== 'number') {
    utils.log.error('Unsupported type for quantity: ' + type(quantity) + ', expecting number');
  } else {
    this._quantity = parseInt(quantity);
  }
  return this;
};

/**
 * Set a value for the price. This field is required for all revenue being logged.
 *
 * Note: revenue amount is calculated as price * quantity.
 * @public
 * @param {number} price - Double value for the quantity.
 * @return {Revenue} Returns the same Revenue object, allowing you to chain multiple method calls together.
 * @example var revenue = new amplitude.Revenue().setProductId('productIdentifier').setPrice(10.99);
 * amplitude.logRevenueV2(revenue);
 */
Revenue.prototype.setPrice = function setPrice(price) {
  if (type(price) !== 'number') {
    utils.log.error('Unsupported type for price: ' + type(price) + ', expecting number');
  } else {
    this._price = price;
  }
  return this;
};

/**
 * Set a value for the revenueType (for example purchase, cost, tax, refund, etc).
 * @public
 * @param {string} revenueType - RevenueType to designate.
 * @return {Revenue} Returns the same Revenue object, allowing you to chain multiple method calls together.
 * @example var revenue = new amplitude.Revenue().setProductId('productIdentifier').setPrice(10.99).setRevenueType('purchase');
 * amplitude.logRevenueV2(revenue);
 */
Revenue.prototype.setRevenueType = function setRevenueType(revenueType) {
  if (type(revenueType) !== 'string') {
    utils.log.error('Unsupported type for revenueType: ' + type(revenueType) + ', expecting string');
  } else {
    this._revenueType = revenueType;
  }
  return this;
};

/**
 * Set event properties for the revenue event.
 * @public
 * @param {object} eventProperties - Revenue event properties to set.
 * @return {Revenue} Returns the same Revenue object, allowing you to chain multiple method calls together.
 * @example var event_properties = {'city': 'San Francisco'};
 * var revenue = new amplitude.Revenue().setProductId('productIdentifier').setPrice(10.99).setEventProperties(event_properties);
 * amplitude.logRevenueV2(revenue);
 */
Revenue.prototype.setEventProperties = function setEventProperties(eventProperties) {
  if (type(eventProperties) !== 'object') {
    utils.log.error('Unsupported type for eventProperties: ' + type(eventProperties) + ', expecting object');
  } else {
    this._properties = utils.validateProperties(eventProperties);
  }
  return this;
};

/**
 * @private
 */
Revenue.prototype._isValidRevenue = function _isValidRevenue() {
  if (type(this._price) !== 'number') {
    utils.log.error('Invalid revenue, need to set price field');
    return false;
  }
  return true;
};

/**
 * @private
 */
Revenue.prototype._toJSONObject = function _toJSONObject() {
  var obj = type(this._properties) === 'object' ? this._properties : {};
  if (this._productId !== null) {
    obj[Constants.REVENUE_PRODUCT_ID] = this._productId;
  }
  if (this._quantity !== null) {
    obj[Constants.REVENUE_QUANTITY] = this._quantity;
  }
  if (this._price !== null) {
    obj[Constants.REVENUE_PRICE] = this._price;
  }
  if (this._revenueType !== null) {
    obj[Constants.REVENUE_REVENUE_TYPE] = this._revenueType;
  }
  return obj;
};

/**
 * Source: [jed's gist]{@link https://gist.github.com/982883}.
 * Returns a random v4 UUID of the form xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx,
 * where each x is replaced with a random hexadecimal digit from 0 to f, and
 * y is replaced with a random hexadecimal digit from 8 to b.
 * Used to generate UUIDs for deviceIds.
 * @private
 */
var uuid$1 = function uuid(a) {
  return a // if the placeholder was passed, return
  ?
  // a random number from 0 to 15
  (a ^
  // unless b is 8,
  Math.random() *
  // in which case
  16 >>
  // a random number from
  a / 4
  // 8 to 11
  ).toString(16) // in hexadecimal
  :
  // or otherwise a concatenated string:
  ([1e7] +
  // 10000000 +
  -1e3 +
  // -1000 +
  -4e3 +
  // -4000 +
  -8e3 +
  // -80000000 +
  -1e11
  // -100000000000,
  ).replace(
  // replacing
  /[018]/g,
  // zeroes, ones, and eights with
  uuid // random hex digits
  );
};
var getLanguage = function getLanguage() {
  return typeof navigator !== 'undefined' && (navigator.languages && navigator.languages[0] || navigator.language || navigator.userLanguage) || '';
};
var language = {
  getLanguage: getLanguage
};

/**
 * AmplitudeServerZone is for Data Residency and handling server zone related properties.
 * The server zones now are US and EU.
 *
 * For usage like sending data to Amplitude's EU servers, you need to configure the serverZone during nitializing.
 */
var AmplitudeServerZone = {
  US: 'US',
  EU: 'EU'
};
var getEventLogApi = function getEventLogApi(serverZone) {
  var eventLogUrl = Constants.EVENT_LOG_URL;
  switch (serverZone) {
    case AmplitudeServerZone.EU:
      eventLogUrl = Constants.EVENT_LOG_EU_URL;
      break;
    case AmplitudeServerZone.US:
      eventLogUrl = Constants.EVENT_LOG_URL;
      break;
  }
  return eventLogUrl;
};
var getDynamicConfigApi = function getDynamicConfigApi(serverZone) {
  var dynamicConfigUrl = Constants.DYNAMIC_CONFIG_URL;
  switch (serverZone) {
    case AmplitudeServerZone.EU:
      dynamicConfigUrl = Constants.DYNAMIC_CONFIG_EU_URL;
      break;
    case AmplitudeServerZone.US:
      dynamicConfigUrl = Constants.DYNAMIC_CONFIG_URL;
      break;
  }
  return dynamicConfigUrl;
};
var version = "8.21.9";

/**
 * Options used when initializing Amplitude
 * @typedef {Object} Options
 * @property {string} [apiEndpoint=`api.amplitude.com`] - Endpoint to send amplitude event requests to.
 * @property {boolean} [batchEvents=`false`] -  If `true`, then events are batched together and uploaded only when the number of unsent events is greater than or equal to eventUploadThreshold or after eventUploadPeriodMillis milliseconds have passed since the first unsent event was logged.
 * @property {number} [cookieExpiration=`365`] - The number of days after which the Amplitude cookie will expire. 12 months is for GDPR compliance.
 * @property {string} [cookieName=`amplitude_id`] - *DEPRECATED*
 * @property {string} [sameSiteCookie='None'] -  Sets the SameSite flag on the amplitude cookie. Decides cookie privacy policy.
 * @property {boolean} [cookieForceUpgrade=`false`] - Forces pre-v6.0.0 instances to adopt post-v6.0.0 compat cookie formats.
 * @property {boolean} [deferInitialization=`null`] -  If `true`, disables the core functionality of the sdk, including saving a cookie and all logging, until explicitly enabled. To enable tracking, please call `amplitude.getInstance().enableTracking()` *Note: This will not affect users who already have an amplitude cookie. The decision to track events is determined by whether or not a user has an amplitude analytics cookie. If the `cookieExpiration</code> is manually defined to be a short lifespan, you may need to run `amplitude.getInstance().enableTracking()` upon the cookie expiring or upon logging in.*
 * @property {boolean} [disableCookies=`false`] -  Disable Ampllitude cookies altogether.
 * @property {string} [deviceId=A randomly generated UUID.] -  The custom Device ID to set. *Note: This is not recommended unless you know what you are doing (e.g. you have your own system for tracking user devices).*
 * @property {boolean} [deviceIdFromUrlParam=`false`] -  If `true`, then the SDK will parse Device ID values from the URL parameter amp_device_id if available. Device IDs defined in the configuration options during init will take priority over Device IDs from URL parameters.
 * @property {string} [domain=The top domain of the current page's URL. ('https://amplitude.com')] -  Set a custom domain for the Amplitude cookie. To include subdomains, add a preceding period, eg: `.amplitude.com`.
 * @property {number} [eventUploadPeriodMillis=`30000` (30 sec)] -  Amount of time in milliseconds that the SDK waits before uploading events if batchEvents is true.
 * @property {number} [eventUploadThreshold=`30`] -  Minimum number of events to batch together per request if batchEvents is true.
 * @property {boolean} [forceHttps=`true`] -  If `true`, the events will always be uploaded to HTTPS endpoint. Otherwise, it will use the embedding site's protocol.
 * @property {boolean} [includeFbclid=`false`] -  If `true`, captures the fbclid URL parameter as well as the user's initial_fbclid via a setOnce operation.
 * @property {boolean} [includeGclid=`false`] -  If `true`, captures the gclid URL parameter as well as the user's initial_gclid via a setOnce operation.
 * @property {boolean} [includeReferrer=`false`] -  If `true`, captures the referrer and referring_domain for each session, as well as the user's initial_referrer and initial_referring_domain via a setOnce operation.
 * @property {boolean} [includeUtm=`false`] -  If `true`, finds UTM parameters in the query string or the _utmz cookie, parses, and includes them as user properties on all events uploaded. This also captures initial UTM parameters for each session via a setOnce operation.
 * @property {Object} [ingestionMetadata] Ingestion metadata
 * @property {string} [ingestionMetadata.sourceName] source name in ingestion metadata, e.g. "ampli"
 * @property {string} [ingestionMetadata.sourceVersion] source version in ingestion metadata, e.g. "1.0.0"
 * @property {string} [language=The language determined by the browser] -  Custom language to set.
 * @property {Object} [library=`{ name: 'amplitude-js', version: packageJsonVersion }`] -  Values for the library version
 * @property {string} [logLevel=`WARN`] -  Level of logs to be printed in the developer console. Valid values are 'DISABLE', 'ERROR', 'WARN', 'INFO'. To learn more about the different options, see below.
 * @property {boolean} [logAttributionCapturedEvent=`false`] - If `true`, the SDK will log an Amplitude event anytime new attribution values are captured from the user. **Note: These events count towards your event volume.** Event name being logged: [Amplitude] Attribution Captured. Event Properties that can be logged: `utm_source`, `utm_medium`, `utm_campaign`, `utm_term`, `utm_content`, `referrer`, `referring_domain`, `gclid`, `fbclid`. For UTM properties to be logged, `includeUtm` must be set to `true`. For the `referrer` and `referring_domain` properties to be logged, `includeReferrer` must be set to `true`. For the `gclid` property to be logged, `includeGclid` must be set to `true`. For the `fbclid` property to be logged, `includeFbclid` must be set to `true`.
 * @property {boolean} [optOut=`false`] -  Whether or not to disable tracking for the current user.
 * @property {function} [onError=`() => {}`] - Function to call on error.
 * @property {function} [onExitPage=`() => {}`] - Function called when the user exits the browser. Useful logging on page exit.
 * @property {Object} [plan] Tracking plan properties
 * @property {string} [plan.branch] The tracking plan branch name e.g. "main"
 * @property {string} [plan.source] The tracking plan source e.g. "web"
 * @property {string} [plan.version] The tracking plan version e.g. "1", "15"
 * @property {string} [plan.versionId] The tracking plan version Id e.g. "9ec23ba0-275f-468f-80d1-66b88bff9529"
 * @property {string} [platform=`Web`] -  Platform device is running on. Defaults to `Web` (browser, including mobile browsers).
 * @property {number} [savedMaxCount=`1000`] -  Maximum number of events to save in localStorage. If more events are logged while offline, then old events are removed.
 * @property {boolean} [saveEvents=`true`] -  If `true`, saves events to localStorage and removes them upon successful upload. *Note: Without saving events, events may be lost if the user navigates to another page before the events are uploaded.*
 * @property {boolean} [saveParamsReferrerOncePerSession=`true`] -  If `true`, then includeGclid, includeFbclid, includeReferrer, and includeUtm will only track their respective properties once per session. New values that come in during the middle of the user's session will be ignored. Set to false to always capture new values.
 * @property {boolean} [secureCookie=`false`] -  If `true`, the amplitude cookie will be set with the Secure flag.
 * @property {number} [sessionTimeout=`30*60*1000` (30 min)] -  The time between logged events before a new session starts in milliseconds.
 * @property {string[]} [storage=`''`] - Sets storage strategy.  Options are 'cookies', 'localStorage', 'sessionStorage', or `none`. Will override `disableCookies` option
 * @property {Object} [trackingOptions=`{ city: true, country: true, carrier: true, device_manufacturer: true, device_model: true, dma: true, ip_address: true, language: true, os_name: true, os_version: true, platform: true, region: true, version_name: true}`] - Type of data associated with a user.
 * @property {string} [transport=`http`] - Network transport mechanism used to send events. Options are 'http' and 'beacon'.
 * @property {boolean} [unsetParamsReferrerOnNewSession=`false`] -  If `false`, the existing `referrer` and `utm_parameter` values will be carried through each new session. If set to `true`, the `referrer` and `utm_parameter` user properties, which include `referrer`, `utm_source`, `utm_medium`, `utm_campaign`, `utm_term`, and `utm_content`, will be set to `null` upon instantiating a new session. Note: This only works if `includeReferrer` or `includeUtm` is set to `true`.
 * @property {string} [unsentKey=`amplitude_unsent`] - localStorage key that stores unsent events.
 * @property {string} [unsentIdentifyKey=`amplitude_unsent_identify`] - localStorage key that stores unsent identifies.
 * @property {number} [uploadBatchSize=`100`] -  The maximum number of events to send to the server per request.
 * @property {Object} [headers=`{ 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' }`] - Headers attached to an event(s) upload network request. Custom header properties are merged with this object.
 * @property {string} [serverZone] - For server zone related configuration, used for server api endpoint and dynamic configuration.
 * @property {boolean} [useDynamicConfig] - Enable dynamic configuration to find best server url for user.
 * @property {boolean} [serverZoneBasedApi] - To update api endpoint with serverZone change or not. For data residency, recommend to enable it unless using own proxy server.
 * @property {number} [sessionId=`null`] - The custom Session ID for the current session. *Note: This is not recommended unless you know what you are doing because the Session ID of a session is utilized for all session metrics in Amplitude.
 * @property {string} [partnerId=`null`] - The partner id value
 */
var DEFAULT_OPTIONS = {
  apiEndpoint: Constants.EVENT_LOG_URL,
  batchEvents: false,
  cookieExpiration: 365,
  // 12 months is for GDPR compliance
  cookieName: 'amplitude_id',
  // this is a deprecated option
  sameSiteCookie: 'Lax',
  // cookie privacy policy
  cookieForceUpgrade: false,
  deferInitialization: false,
  disableCookies: false,
  // this is a deprecated option
  deviceIdFromUrlParam: false,
  domain: '',
  eventUploadPeriodMillis: 30 * 1000,
  // 30s
  eventUploadThreshold: 30,
  forceHttps: true,
  includeFbclid: false,
  includeGclid: false,
  includeReferrer: false,
  includeUtm: false,
  ingestionMetadata: {
    sourceName: '',
    sourceVersion: ''
  },
  language: language.getLanguage(),
  library: {
    name: 'amplitude-js',
    version: version
  },
  logLevel: 'WARN',
  logAttributionCapturedEvent: false,
  optOut: false,
  onError: function onError() {},
  onExitPage: function onExitPage() {},
  onNewSessionStart: function onNewSessionStart() {},
  plan: {
    branch: '',
    source: '',
    version: '',
    versionId: ''
  },
  platform: 'Web',
  savedMaxCount: 1000,
  saveEvents: true,
  saveParamsReferrerOncePerSession: true,
  secureCookie: false,
  sessionTimeout: 30 * 60 * 1000,
  storage: Constants.STORAGE_DEFAULT,
  trackingOptions: {
    city: true,
    country: true,
    carrier: true,
    device_manufacturer: true,
    device_model: true,
    dma: true,
    ip_address: true,
    language: true,
    os_name: true,
    os_version: true,
    platform: true,
    region: true,
    version_name: true
  },
  transport: Constants.TRANSPORT_HTTP,
  unsetParamsReferrerOnNewSession: false,
  unsentKey: 'amplitude_unsent',
  unsentIdentifyKey: 'amplitude_unsent_identify',
  uploadBatchSize: 100,
  headers: {
    'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
    'Cross-Origin-Resource-Policy': 'cross-origin'
  },
  serverZone: AmplitudeServerZone.US,
  useDynamicConfig: false,
  serverZoneBasedApi: false,
  sessionId: null,
  partnerId: ''
};

/**
 * Dynamic Configuration
 * Find the best server url automatically based on app users' geo location.
 */
var ConfigManager = /*#__PURE__*/function () {
  function ConfigManager() {
    _classCallCheck(this, ConfigManager);
    if (!ConfigManager.instance) {
      this.ingestionEndpoint = Constants.EVENT_LOG_URL;
      ConfigManager.instance = this;
    }
    return ConfigManager.instance;
  }
  _createClass(ConfigManager, [{
    key: "refresh",
    value: function refresh(serverZone, forceHttps, callback) {
      var protocol = 'https';
      if (!forceHttps && 'https:' !== GlobalScope.location.protocol) {
        protocol = 'http';
      }
      var dynamicConfigUrl = protocol + '://' + getDynamicConfigApi(serverZone);
      var self = this;
      var isIE = GlobalScope.XDomainRequest ? true : false;
      if (isIE) {
        var xdr = new GlobalScope.XDomainRequest();
        xdr.open('GET', dynamicConfigUrl, true);
        xdr.onload = function () {
          var response = JSON.parse(xdr.responseText);
          self.ingestionEndpoint = response['ingestionEndpoint'];
          if (callback) {
            callback();
          }
        };
        xdr.onerror = function () {};
        xdr.ontimeout = function () {};
        xdr.onprogress = function () {};
        xdr.send();
      } else {
        var xhr = new XMLHttpRequest();
        xhr.open('GET', dynamicConfigUrl, true);
        xhr.onreadystatechange = function () {
          if (xhr.readyState === 4 && xhr.status === 200) {
            var response = JSON.parse(xhr.responseText);
            self.ingestionEndpoint = response['ingestionEndpoint'];
            if (callback) {
              callback();
            }
          }
        };
        xhr.send();
      }
    }
  }]);
  return ConfigManager;
}();
var instance$1 = new ConfigManager();

/**
 * AmplitudeClient SDK API - instance constructor.
 * The Amplitude class handles creation of client instances, all you need to do is call amplitude.getInstance()
 * @constructor AmplitudeClient
 * @public
 * @example var amplitudeClient = new AmplitudeClient();
 */
var AmplitudeClient = function AmplitudeClient(instanceName) {
  if (!isBrowserEnv() && !utils.isWebWorkerEnvironment()) {
    utils.log.warn('amplitude-js will not work in a non-browser environment. If you are planning to add Amplitude to a node environment, please use @amplitude/node');
  }
  this._instanceName = utils.isEmptyString(instanceName) ? Constants.DEFAULT_INSTANCE : instanceName.toLowerCase();
  this._unsentEvents = [];
  this._unsentIdentifys = [];
  this.options = _objectSpread2$1(_objectSpread2$1({}, DEFAULT_OPTIONS), {}, {
    headers: _objectSpread2$1({}, DEFAULT_OPTIONS.headers),
    ingestionMetadata: _objectSpread2$1({}, DEFAULT_OPTIONS.ingestionMetadata),
    library: _objectSpread2$1({}, DEFAULT_OPTIONS.library),
    plan: _objectSpread2$1({}, DEFAULT_OPTIONS.plan),
    trackingOptions: _objectSpread2$1({}, DEFAULT_OPTIONS.trackingOptions)
  });
  this._q = []; // queue for proxied functions before script load
  this._sending = false;
  this._updateScheduled = false;
  this._onInitCallbacks = [];
  this._onNewSessionStartCallbacks = [];

  // event meta data
  this._eventId = 0;
  this._identifyId = 0;
  this._lastEventTime = null;
  this._newSession = false;
  // sequence used for by frontend for prioritizing event send retries
  this._sequenceNumber = 0;
  this._sessionId = null;
  this._isInitialized = false;

  // used to integrate with experiment SDK (client-side exposure tracking & real-time user properties)
  this._connector = null;
  this._userAgent = typeof navigator !== 'undefined' && navigator && navigator.userAgent || null;
  this._ua = new UAParser(this._userAgent).getResult();
};
AmplitudeClient.prototype.Identify = Identify;
AmplitudeClient.prototype.Revenue = Revenue;

/**
 * Initializes the Amplitude Javascript SDK with your apiKey and any optional configurations.
 * This is required before any other methods can be called.
 * @public
 * @param {string} apiKey - The API key for your app.
 * @param {string} opt_userId - (optional) An identifier for this user.
 * @param {object} opt_config - (optional) Configuration options.
 * See [options.js](https://amplitude.github.io/Amplitude-JavaScript/Options) for a list of options and default values.
 * @param {function} opt_callback - (optional) Provide a callback function to run after initialization is complete.
 * @example amplitudeClient.init('API_KEY', 'USER_ID', {includeReferrer: true, includeUtm: true}, function() { alert('init complete'); });
 */
AmplitudeClient.prototype.init = function init(apiKey, opt_userId, opt_config, opt_callback) {
  var _this = this;
  if (type(apiKey) !== 'string' || utils.isEmptyString(apiKey)) {
    utils.log.error('Invalid apiKey. Please re-initialize with a valid apiKey');
    return;
  }
  try {
    // used to integrate with experiment SDK (client-side exposure tracking & real-time user properties)
    this._connector = AnalyticsConnector.getInstance(this._instanceName);
    _parseConfig(this.options, opt_config);
    if ((isBrowserEnv() || utils.isWebWorkerEnvironment()) && GlobalScope.Prototype !== undefined && Array.prototype.toJSON) {
      prototypeJsFix();
      utils.log.warn('Prototype.js injected Array.prototype.toJSON. Deleting Array.prototype.toJSON to prevent double-stringify');
    }
    if (this.options.cookieName !== DEFAULT_OPTIONS.cookieName) {
      utils.log.warn('The cookieName option is deprecated. We will be ignoring it for newer cookies');
    }
    if (this.options.serverZoneBasedApi) {
      this.options.apiEndpoint = getEventLogApi(this.options.serverZone);
    }
    this._refreshDynamicConfig();
    this.options.apiKey = apiKey;
    this._storageSuffix = '_' + apiKey + (this._instanceName === Constants.DEFAULT_INSTANCE ? '' : '_' + this._instanceName);
    this._storageSuffixV5 = apiKey.slice(0, 6);
    this._oldCookiename = this.options.cookieName + this._storageSuffix;
    this._unsentKey = this.options.unsentKey + this._storageSuffix;
    this._unsentIdentifyKey = this.options.unsentIdentifyKey + this._storageSuffix;
    this._cookieName = Constants.COOKIE_PREFIX + '_' + this._storageSuffixV5;
    this.cookieStorage = new cookieStorage().getStorage(this.options.disableCookies);
    this.cookieStorage.options({
      expirationDays: this.options.cookieExpiration,
      domain: this.options.domain,
      secure: this.options.secureCookie,
      sameSite: this.options.sameSiteCookie
    });
    this._metadataStorage = new MetadataStorage({
      storageKey: this._cookieName,
      disableCookies: this.options.disableCookies,
      expirationDays: this.options.cookieExpiration,
      domain: this.options.domain,
      secure: this.options.secureCookie,
      sameSite: this.options.sameSiteCookie,
      storage: this.options.storage
    });
    var hasOldCookie = !!this.cookieStorage.get(this._oldCookiename);
    var hasNewCookie = !!this._metadataStorage.load();
    this._useOldCookie = !hasNewCookie && hasOldCookie && !this.options.cookieForceUpgrade;
    var hasCookie = hasNewCookie || hasOldCookie;
    if (this.options.deferInitialization && !hasCookie) {
      this._deferInitialization(apiKey, opt_userId, opt_config, opt_callback);
      return;
    }
    this.options.domain = this.cookieStorage.options().domain;
    if (type(this.options.logLevel) === 'string') {
      utils.setLogLevel(this.options.logLevel);
    }
    var trackingOptions = _generateApiPropertiesTrackingConfig(this);
    this._apiPropertiesTrackingOptions = Object.keys(trackingOptions).length > 0 ? {
      tracking_options: trackingOptions
    } : {};
    if (this.options.cookieForceUpgrade && hasOldCookie) {
      if (!hasNewCookie) {
        _upgradeCookieData(this);
      }
      this.cookieStorage.remove(this._oldCookiename);
    }
    _loadCookieData(this);
    this._pendingReadStorage = true;
    var initFromStorage = function initFromStorage(storedDeviceId) {
      if (opt_config && opt_config.deviceId && !utils.validateDeviceId(opt_config.deviceId)) {
        utils.log.error("Invalid device ID rejected. Randomly generated UUID will be used instead of \"".concat(opt_config.deviceId, "\""));
        delete opt_config.deviceId;
      }
      _this.options.deviceId = _this._getInitialDeviceId(opt_config && opt_config.deviceId, storedDeviceId);
      _this.options.userId = type(opt_userId) === 'string' && !utils.isEmptyString(opt_userId) && opt_userId || type(opt_userId) === 'number' && opt_userId.toString() || _this.options.userId || null;
      var now = new Date().getTime();
      var startNewSession = !_this._sessionId || !_this._lastEventTime || now - _this._lastEventTime > _this.options.sessionTimeout || _this.options.sessionId;
      if (startNewSession) {
        if (_this.options.unsetParamsReferrerOnNewSession) {
          _this._unsetUTMParams();
        }
        _this._newSession = true;
        _this._sessionId = _this.options.sessionId || now;
        // reset this.options.sessionId to avoid re-usage
        // use instance.getSessionId() to get session id
        _this.options.sessionId = undefined;

        // only capture UTM params and referrer if new session
        if (_this.options.saveParamsReferrerOncePerSession) {
          _this._trackParamsAndReferrer();
        }
      }
      if (!_this.options.saveParamsReferrerOncePerSession) {
        _this._trackParamsAndReferrer();
      }

      // load unsent events and identifies before any attempt to log new ones
      if (_this.options.saveEvents) {
        _validateUnsentEventQueue(_this._unsentEvents);
        _validateUnsentEventQueue(_this._unsentIdentifys);
      }
      _this._lastEventTime = now;
      _saveCookieData(_this);
      _this._pendingReadStorage = false;
      _this._sendEventsIfReady(); // try sending unsent events

      for (var i = 0; i < _this._onInitCallbacks.length; i++) {
        _this._onInitCallbacks[i](_this);
      }
      _this._onInitCallbacks = [];
      _this._isInitialized = true;
      if (startNewSession) {
        _this._runNewSessionStartCallbacks();
      }
    };
    if (this.options.saveEvents) {
      this._unsentEvents = this._loadSavedUnsentEvents(this.options.unsentKey).map(function (event) {
        return {
          event: event
        };
      }).concat(this._unsentEvents);
      this._unsentIdentifys = this._loadSavedUnsentEvents(this.options.unsentIdentifyKey).map(function (event) {
        return {
          event: event
        };
      }).concat(this._unsentIdentifys);
    }
    if (opt_config && opt_config.onNewSessionStart) {
      this.onNewSessionStart(this.options.onNewSessionStart);
    }
    initFromStorage();
    this.runQueuedFunctions();
    if (type(opt_callback) === 'function') {
      opt_callback(this);
    }
    var onExitPage = this.options.onExitPage;
    if (type(onExitPage) === 'function' && GlobalScope.addEventListener) {
      if (!this.pageHandlersAdded) {
        this.pageHandlersAdded = true;
        var handleVisibilityChange = function handleVisibilityChange() {
          var prevTransport = _this.options.transport;
          _this.setTransport(Constants.TRANSPORT_BEACON);
          onExitPage();
          _this.setTransport(prevTransport);
        };

        // Monitoring just page exits because that is the most requested feature for now
        // "If you're specifically trying to detect page unload events, the pagehide event is the best option."
        // https://developer.mozilla.org/en-US/docs/Web/API/Window/pagehide_event
        GlobalScope.addEventListener('pagehide', function () {
          handleVisibilityChange();
        }, false);
      }
    }

    // Sets an event receiver to receive and forward exposure events from the experiment SDK.
    this._connector.eventBridge.setEventReceiver(function (event) {
      _this._logEvent(event.eventType, event.eventProperties, event.userProperties);
    });

    // Set the user ID and device ID in the core identity store to enable fetching variants.
    var editor = this._connector.identityStore.editIdentity();
    if (this.options.deviceId) {
      editor.setDeviceId(this.options.deviceId);
    }
    if (this.options.userId) {
      editor.setUserId(this.options.userId);
    }
    editor.commit();
  } catch (err) {
    utils.log.error(err);
    if (opt_config && type(opt_config.onError) === 'function') {
      opt_config.onError(err);
    }
  }
};
AmplitudeClient.prototype._runNewSessionStartCallbacks = function () {
  for (var i = 0; i < this._onNewSessionStartCallbacks.length; i++) {
    this._onNewSessionStartCallbacks[i](this);
  }
};
AmplitudeClient.prototype.deleteLowerLevelDomainCookies = function () {
  var host = utils.getHost();
  var cookieHost = this.options.domain && this.options.domain[0] === '.' ? this.options.domain.slice(1) : this.options.domain;
  if (!cookieHost || !utils.isWebWorkerEnvironment()) {
    return;
  }
  if (host !== cookieHost) {
    if (new RegExp(cookieHost + '$').test(host)) {
      var hostParts = host.split('.');
      var cookieHostParts = cookieHost.split('.');
      for (var i = hostParts.length; i > cookieHostParts.length; --i) {
        var deleteDomain = hostParts.slice(hostParts.length - i).join('.');
        baseCookie.set(this._cookieName, null, {
          domain: '.' + deleteDomain
        });
      }
      baseCookie.set(this._cookieName, null, {});
    }
  }
};
AmplitudeClient.prototype._getInitialDeviceId = function (configDeviceId, storedDeviceId) {
  if (configDeviceId) {
    return configDeviceId;
  }
  if (this.options.deviceIdFromUrlParam) {
    var deviceIdFromUrlParam = this._getDeviceIdFromUrlParam(this._getUrlParams());
    if (deviceIdFromUrlParam) {
      return deviceIdFromUrlParam;
    }
  }
  if (this.options.deviceId) {
    return this.options.deviceId;
  }
  if (storedDeviceId) {
    return storedDeviceId;
  }
  return base64Id();
};

// validate properties for unsent events
var _validateUnsentEventQueue = function _validateUnsentEventQueue(queue) {
  for (var i = 0; i < queue.length; i++) {
    var userProperties = queue[i].event.user_properties;
    var eventProperties = queue[i].event.event_properties;
    var groups = queue[i].event.groups;
    queue[i].event.user_properties = utils.validateProperties(userProperties);
    queue[i].event.event_properties = utils.validateProperties(eventProperties);
    queue[i].event.groups = utils.validateGroups(groups);
  }
};

/**
 * @private
 */
AmplitudeClient.prototype._trackParamsAndReferrer = function _trackParamsAndReferrer() {
  var utmProperties;
  var referrerProperties;
  var gclidProperties;
  var fbclidProperties;
  if (this.options.includeUtm) {
    utmProperties = this._initUtmData();
  }
  if (this.options.includeReferrer) {
    referrerProperties = this._saveReferrer(this._getReferrer());
  }
  if (this.options.includeGclid) {
    gclidProperties = this._saveGclid(this._getUrlParams());
  }
  if (this.options.includeFbclid) {
    fbclidProperties = this._saveFbclid(this._getUrlParams());
  }
  if (this.options.logAttributionCapturedEvent) {
    var attributionProperties = _objectSpread2$1(_objectSpread2$1(_objectSpread2$1(_objectSpread2$1({}, utmProperties), referrerProperties), gclidProperties), fbclidProperties);
    if (Object.keys(attributionProperties).length > 0) {
      this.logEvent(Constants.ATTRIBUTION_EVENT, attributionProperties);
    }
  }
};

/**
 * Parse and validate user specified config values and overwrite existing option value
 * DEFAULT_OPTIONS provides list of all config keys that are modifiable, as well as expected types for values
 * @private
 */
var _parseConfig = function _parseConfig(options, config) {
  if (type(config) !== 'object') {
    return;
  }

  // Add exception in headers
  var freeFormObjectKeys = new Set(['headers']);
  var zeroAllowedKeys = new Set(['eventUploadPeriodMillis']);

  // validates config value is defined, is the correct type, and some additional value sanity checks
  var parseValidateAndLoad = function parseValidateAndLoad(key) {
    if (!Object.prototype.hasOwnProperty.call(options, key)) {
      return; // skip bogus config values
    }
    var inputValue = config[key];
    var expectedType = type(options[key]);
    if (key === 'transport' && !utils.validateTransport(inputValue)) {
      return;
    } else if (key === 'sessionId' && inputValue !== null) {
      options[key] = utils.validateSessionId(inputValue) ? inputValue : null;
      return;
    } else if (!utils.validateInput(inputValue, key + ' option', expectedType)) {
      return;
    }
    if (expectedType === 'boolean') {
      options[key] = !!inputValue;
    } else if (expectedType === 'string' && !utils.isEmptyString(inputValue) || expectedType === 'number' && (inputValue > 0 || inputValue === 0 && zeroAllowedKeys.has(key)) || expectedType === 'function') {
      options[key] = inputValue;
    } else if (expectedType === 'object') {
      _parseConfig(options[key], inputValue);
    }
  };
  for (var key in config) {
    if (freeFormObjectKeys.has(key)) {
      options[key] = _objectSpread2$1(_objectSpread2$1({}, options[key]), config[key]);
    } else if (Object.prototype.hasOwnProperty.call(config, key)) {
      parseValidateAndLoad(key);
    }
  }
};

/**
 * Run functions queued up by proxy loading snippet
 * @private
 */
AmplitudeClient.prototype.runQueuedFunctions = function () {
  var queue = this._q;
  this._q = [];
  for (var i = 0; i < queue.length; i++) {
    var fn = this[queue[i][0]];
    if (type(fn) === 'function') {
      fn.apply(this, queue[i].slice(1));
    }
  }
};

/**
 * Check that the apiKey is set before calling a function. Logs a warning message if not set.
 * @private
 */
AmplitudeClient.prototype._apiKeySet = function _apiKeySet(methodName) {
  if (utils.isEmptyString(this.options.apiKey)) {
    utils.log.error('Invalid apiKey. Please set a valid apiKey with init() before calling ' + methodName);
    return false;
  }
  return true;
};

/**
 * Load saved events from localStorage. JSON deserializes event array. Handles case where string is corrupted.
 * @private
 */
AmplitudeClient.prototype._loadSavedUnsentEvents = function _loadSavedUnsentEvents(unsentKey) {
  var savedUnsentEventsString = this._getFromStorage(localStorage$1$1, unsentKey);
  var unsentEvents = this._parseSavedUnsentEventsString(savedUnsentEventsString, unsentKey);
  this._setInStorage(localStorage$1$1, unsentKey, JSON.stringify(unsentEvents));
  return unsentEvents;
};

/**
 * Load saved events from localStorage. JSON deserializes event array. Handles case where string is corrupted.
 * @private
 */
AmplitudeClient.prototype._parseSavedUnsentEventsString = function _parseSavedUnsentEventsString(savedUnsentEventsString, unsentKey) {
  if (utils.isEmptyString(savedUnsentEventsString)) {
    return []; // new app, does not have any saved events
  }
  if (type(savedUnsentEventsString) === 'string') {
    try {
      var events = JSON.parse(savedUnsentEventsString);
      if (type(events) === 'array') {
        // handle case where JSON dumping of unsent events is corrupted
        return events;
      }
    } catch (e) {} /* eslint-disable-line no-empty */
  }
  utils.log.error('Unable to load ' + unsentKey + ' events. Restart with a new empty queue.');
  return [];
};

/**
 * Returns true if a new session was created during initialization, otherwise false.
 * @public
 * @return {boolean} Whether a new session was created during initialization.
 */
AmplitudeClient.prototype.isNewSession = function isNewSession() {
  return this._newSession;
};

/**
 * Add callbacks to call after init. Useful for users who load Amplitude through a snippet.
 * @public
 */
AmplitudeClient.prototype.onInit = function onInit(callback) {
  if (this._isInitialized) {
    callback(this);
  } else {
    this._onInitCallbacks.push(callback);
  }
};

/**
 * Add callbacks to call after new session start.
 * @public
 */
AmplitudeClient.prototype.onNewSessionStart = function onNewSessionStart(callback) {
  this._onNewSessionStartCallbacks.push(callback);
};

/**
 * Returns the id of the current session.
 * @public
 * @return {number} Id of the current session.
 */
AmplitudeClient.prototype.getSessionId = function getSessionId() {
  return this._sessionId;
};

/**
 * Increments the eventId and returns it.
 * @private
 */
AmplitudeClient.prototype.nextEventId = function nextEventId() {
  this._eventId++;
  return this._eventId;
};

/**
 * Increments the identifyId and returns it.
 * @private
 */
AmplitudeClient.prototype.nextIdentifyId = function nextIdentifyId() {
  this._identifyId++;
  return this._identifyId;
};

/**
 * Increments the sequenceNumber and returns it.
 * @private
 */
AmplitudeClient.prototype.nextSequenceNumber = function nextSequenceNumber() {
  this._sequenceNumber++;
  return this._sequenceNumber;
};

/**
 * Returns the total count of unsent events and identifys
 * @private
 */
AmplitudeClient.prototype._unsentCount = function _unsentCount() {
  return this._unsentEvents.length + this._unsentIdentifys.length;
};

/**
 * Send events if ready. Returns true if events are sent.
 * @private
 */
AmplitudeClient.prototype._sendEventsIfReady = function _sendEventsIfReady() {
  if (this._unsentCount() === 0) {
    return false;
  }

  // if batching disabled, send any unsent events immediately
  if (!this.options.batchEvents) {
    this.sendEvents();
    return true;
  }

  // if batching enabled, check if min threshold met for batch size
  if (this._unsentCount() >= this.options.eventUploadThreshold) {
    this.sendEvents();
    return true;
  }

  // if beacon transport is activated, send events immediately
  // because there is no way to retry them later
  if (this.options.transport === Constants.TRANSPORT_BEACON) {
    this.sendEvents();
    return true;
  }

  // otherwise schedule an upload after 30s
  if (!this._updateScheduled) {
    // make sure we only schedule 1 upload
    this._updateScheduled = true;
    setTimeout(function () {
      this._updateScheduled = false;
      this.sendEvents();
    }.bind(this), this.options.eventUploadPeriodMillis);
  }
  return false; // an upload was scheduled, no events were uploaded
};

/**
 * Clears any stored events and metadata. Storage is then re-created on next event sending.
 * @public
 * @return {boolean} True if metadata was cleared, false if none existed
 */
AmplitudeClient.prototype.clearStorage = function clearStorage() {
  return this._metadataStorage.clear();
};

/**
 * Helper function to fetch values from storage
 * Storage argument allows for localStoraoge and sessionStoraoge
 * @private
 */
AmplitudeClient.prototype._getFromStorage = function _getFromStorage(storage, key) {
  return storage.getItem(key + this._storageSuffix);
};

/**
 * Helper function to set values in storage
 * Storage argument allows for localStoraoge and sessionStoraoge
 * @private
 */
AmplitudeClient.prototype._setInStorage = function _setInStorage(storage, key, value) {
  storage.setItem(key + this._storageSuffix, value);
};

/**
 * Fetches deviceId, userId, event meta data from amplitude cookie
 * @private
 */
var _loadCookieData = function _loadCookieData(scope) {
  if (!scope._useOldCookie) {
    var props = scope._metadataStorage.load();
    if (type(props) === 'object') {
      _loadCookieDataProps(scope, props);
    }
    return;
  }
  var cookieData = scope.cookieStorage.get(scope._oldCookiename);
  if (type(cookieData) === 'object') {
    _loadCookieDataProps(scope, cookieData);
    return;
  }
};
var _upgradeCookieData = function _upgradeCookieData(scope) {
  var cookieData = scope.cookieStorage.get(scope._oldCookiename);
  if (type(cookieData) === 'object') {
    _loadCookieDataProps(scope, cookieData);
    _saveCookieData(scope);
  }
};
var _loadCookieDataProps = function _loadCookieDataProps(scope, cookieData) {
  if (cookieData.deviceId) {
    scope.options.deviceId = cookieData.deviceId;
  }
  if (cookieData.userId) {
    scope.options.userId = cookieData.userId;
  }
  if (cookieData.optOut !== null && cookieData.optOut !== undefined) {
    // Do not clobber config opt out value if cookieData has optOut as false
    if (cookieData.optOut !== false) {
      scope.options.optOut = cookieData.optOut;
    }
  }
  if (cookieData.sessionId) {
    scope._sessionId = parseInt(cookieData.sessionId, 10);
  }
  if (cookieData.lastEventTime) {
    scope._lastEventTime = parseInt(cookieData.lastEventTime, 10);
  }
  if (cookieData.eventId) {
    scope._eventId = parseInt(cookieData.eventId, 10);
  }
  if (cookieData.identifyId) {
    scope._identifyId = parseInt(cookieData.identifyId, 10);
  }
  if (cookieData.sequenceNumber) {
    scope._sequenceNumber = parseInt(cookieData.sequenceNumber, 10);
  }
};

/**
 * Saves deviceId, userId, event meta data to amplitude cookie
 * @private
 */
var _saveCookieData = function _saveCookieData(scope) {
  var cookieData = {
    deviceId: scope.options.deviceId,
    userId: scope.options.userId,
    optOut: scope.options.optOut,
    sessionId: scope._sessionId,
    lastEventTime: scope._lastEventTime,
    eventId: scope._eventId,
    identifyId: scope._identifyId,
    sequenceNumber: scope._sequenceNumber
  };
  if (scope._useOldCookie) {
    scope.cookieStorage.set(scope.options.cookieName + scope._storageSuffix, cookieData);
  } else {
    scope._metadataStorage.save(cookieData);
  }
};

/**
 * Parse the utm properties out of cookies and query for adding to user properties.
 * @private
 */
AmplitudeClient.prototype._initUtmData = function _initUtmData(queryParams, cookieParams) {
  queryParams = queryParams || this._getUrlParams();
  cookieParams = cookieParams || this.cookieStorage.get('__utmz');
  var utmProperties = getUtmData$1(cookieParams, queryParams);
  _sendParamsReferrerUserProperties(this, utmProperties);
  return utmProperties;
};

/**
 * Unset the utm params from the Amplitude instance and update the identify.
 * @private
 */
AmplitudeClient.prototype._unsetUTMParams = function _unsetUTMParams() {
  var identify = new Identify();
  identify.unset(Constants.REFERRER);
  identify.unset(Constants.REFERRING_DOMAIN);
  identify.unset(Constants.UTM_SOURCE);
  identify.unset(Constants.UTM_MEDIUM);
  identify.unset(Constants.UTM_CAMPAIGN);
  identify.unset(Constants.UTM_TERM);
  identify.unset(Constants.UTM_CONTENT);
  this.identify(identify);
};

/**
 * The calling function should determine when it is appropriate to send these user properties. This function
 * will no longer contain any session storage checking logic.
 * @private
 */
var _sendParamsReferrerUserProperties = function _sendParamsReferrerUserProperties(scope, userProperties) {
  if (type(userProperties) !== 'object' || Object.keys(userProperties).length === 0) {
    return;
  }

  // setOnce the initial user properties
  var identify = new Identify();
  for (var key in userProperties) {
    if (Object.prototype.hasOwnProperty.call(userProperties, key)) {
      identify.setOnce('initial_' + key, userProperties[key]);
      identify.set(key, userProperties[key]);
    }
  }
  scope.identify(identify);
};

/**
 * @private
 */
AmplitudeClient.prototype._getReferrer = function _getReferrer() {
  var urlRefer = this._getReferrerFromUrlParam(this._getUrlParams());
  if (urlRefer) return urlRefer;else return typeof document !== 'undefined' ? document.referrer : '';
};

/**
 * @private
 */
AmplitudeClient.prototype._getUrlParams = function _getUrlParams() {
  return GlobalScope.location.search;
};

/**
 * Try to fetch Google Gclid from url params.
 * @private
 */
AmplitudeClient.prototype._saveGclid = function _saveGclid(urlParams) {
  var gclid = utils.getQueryParam('gclid', urlParams);
  if (utils.isEmptyString(gclid)) {
    return;
  }
  var gclidProperties = {
    gclid: gclid
  };
  _sendParamsReferrerUserProperties(this, gclidProperties);
  return gclidProperties;
};

/**
 * Try to fetch Facebook Fbclid from url params.
 * @private
 */
AmplitudeClient.prototype._saveFbclid = function _saveFbclid(urlParams) {
  var fbclid = utils.getQueryParam('fbclid', urlParams);
  if (utils.isEmptyString(fbclid)) {
    return;
  }
  var fbclidProperties = {
    fbclid: fbclid
  };
  _sendParamsReferrerUserProperties(this, fbclidProperties);
  return fbclidProperties;
};

/**
 * Try to fetch Amplitude device id from url params.
 * @private
 */
AmplitudeClient.prototype._getDeviceIdFromUrlParam = function _getDeviceIdFromUrlParam(urlParams) {
  return utils.getQueryParam(Constants.AMP_DEVICE_ID_PARAM, urlParams);
};

/**
 * Try to fetch referrer from url params.
 * @private
 */
AmplitudeClient.prototype._getReferrerFromUrlParam = function _getReferrerFromUrlParam(urlParams) {
  return utils.getQueryParam(Constants.AMP_REFERRER_PARAM, urlParams);
};

/**
 * Parse the domain from referrer info
 * @private
 */
AmplitudeClient.prototype._getReferringDomain = function _getReferringDomain(referrer) {
  if (utils.isEmptyString(referrer)) {
    return null;
  }
  var parts = referrer.split('/');
  if (parts.length >= 3) {
    return parts[2];
  }
  return null;
};

/**
 * Fetch the referrer information, parse the domain and send.
 * Since user properties are propagated on the server, only send once per session, don't need to send with every event
 * @private
 */
AmplitudeClient.prototype._saveReferrer = function _saveReferrer(referrer) {
  if (utils.isEmptyString(referrer)) {
    return;
  }
  var referrerInfo = {
    referrer: referrer,
    referring_domain: this._getReferringDomain(referrer)
  };
  _sendParamsReferrerUserProperties(this, referrerInfo);
  return referrerInfo;
};

/**
 * Saves unsent events and identifies to localStorage. JSON stringifies event queues before saving.
 * Note: this is called automatically every time events are logged, unless you explicitly set option saveEvents to false.
 * @private
 */
AmplitudeClient.prototype.saveEvents = function saveEvents() {
  try {
    var serializedUnsentEvents = JSON.stringify(this._unsentEvents.map(function (_ref) {
      var event = _ref.event;
      return event;
    }));
    this._setInStorage(localStorage$1$1, this.options.unsentKey, serializedUnsentEvents);
  } catch (e) {} /* eslint-disable-line no-empty */

  try {
    var serializedIdentifys = JSON.stringify(this._unsentIdentifys.map(function (unsentIdentify) {
      return unsentIdentify.event;
    }));
    this._setInStorage(localStorage$1$1, this.options.unsentIdentifyKey, serializedIdentifys);
  } catch (e) {} /* eslint-disable-line no-empty */
};

/**
 * Sets a customer domain for the amplitude cookie. Useful if you want to support cross-subdomain tracking.
 * @public
 * @param {string} domain to set.
 * @example amplitudeClient.setDomain('.amplitude.com');
 */
AmplitudeClient.prototype.setDomain = function setDomain(domain) {
  if (this._shouldDeferCall()) {
    return this._q.push(['setDomain'].concat(Array.prototype.slice.call(arguments, 0)));
  }
  if (!utils.validateInput(domain, 'domain', 'string')) {
    return;
  }
  try {
    this.cookieStorage.options({
      expirationDays: this.options.cookieExpiration,
      secure: this.options.secureCookie,
      domain: domain,
      sameSite: this.options.sameSiteCookie
    });
    this.options.domain = this.cookieStorage.options().domain;
    _loadCookieData(this);
    _saveCookieData(this);
  } catch (e) {
    utils.log.error(e);
  }
};

/**
 * Sets an identifier for the current user.
 * @public
 * @param {string} userId - identifier to set. Can be null.
 * @param {boolean} startNewSession - (optional) if start a new session or not
 * @example amplitudeClient.setUserId('joe@gmail.com');
 */
AmplitudeClient.prototype.setUserId = function setUserId(userId) {
  var startNewSession = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  if (!utils.validateInput(startNewSession, 'startNewSession', 'boolean')) {
    return;
  }
  if (this._shouldDeferCall()) {
    return this._q.push(['setUserId'].concat(Array.prototype.slice.call(arguments, 0)));
  }
  try {
    this.options.userId = userId !== undefined && userId !== null && '' + userId || null;
    if (startNewSession) {
      if (this.options.unsetParamsReferrerOnNewSession) {
        this._unsetUTMParams();
      }
      this._newSession = true;
      this._sessionId = new Date().getTime();
      this._runNewSessionStartCallbacks();

      // only capture UTM params and referrer if new session
      if (this.options.saveParamsReferrerOncePerSession) {
        this._trackParamsAndReferrer();
      }
    }
    _saveCookieData(this);

    // Update core identity store to propagate new user info
    // to experiment SDK and trigger a fetch if the ID has changed.
    if (this._connector) {
      this._connector.identityStore.editIdentity().setUserId(this.options.userId).commit();
    }
  } catch (e) {
    utils.log.error(e);
  }
};

/**
 * Add user to a group or groups. You need to specify a groupType and groupName(s).
 *
 * For example you can group people by their organization.
 * In that case, groupType is "orgId" and groupName would be the actual ID(s).
 * groupName can be a string or an array of strings to indicate a user in multiple gruups.
 * You can also call setGroup multiple times with different groupTypes to track multiple types of groups (up to 5 per app).
 *
 * Note: this will also set groupType: groupName as a user property.
 * See the [advanced topics article](https://developers.amplitude.com/docs/javascript#user-groups) for more information.
 * @public
 * @param {string} groupType - the group type (ex: orgId)
 * @param {string|list} groupName - the name of the group (ex: 15), or a list of names of the groups
 * @example amplitudeClient.setGroup('orgId', 15); // this adds the current user to orgId 15.
 */
AmplitudeClient.prototype.setGroup = function (groupType, groupName) {
  if (this._shouldDeferCall()) {
    return this._q.push(['setGroup'].concat(Array.prototype.slice.call(arguments, 0)));
  }
  if (!this._apiKeySet('setGroup()') || !utils.validateInput(groupType, 'groupType', 'string') || utils.isEmptyString(groupType)) {
    return;
  }
  var groups = {};
  groups[groupType] = groupName;
  var identify = new Identify().set(groupType, groupName);
  this._logEvent(Constants.IDENTIFY_EVENT, null, null, identify.userPropertiesOperations, groups, null, null, null);
};

/**
 * Sets whether to opt current user out of tracking.
 * @public
 * @param {boolean} enable - if true then no events will be logged or sent.
 * @example: amplitude.setOptOut(true);
 */
AmplitudeClient.prototype.setOptOut = function setOptOut(enable) {
  if (this._shouldDeferCall()) {
    return this._q.push(['setOptOut'].concat(Array.prototype.slice.call(arguments, 0)));
  }
  if (!utils.validateInput(enable, 'enable', 'boolean')) {
    return;
  }
  try {
    this.options.optOut = enable;
    _saveCookieData(this);
  } catch (e) {
    utils.log.error(e);
  }
};

/**
 * Set a custom Session ID for the current session.
 * Note: This is not recommended unless you know what you are doing because the Session ID of a session is utilized for all session metrics in Amplitude.
 * The Session ID to set for the current session must be in milliseconds since epoch (Unix Timestamp).
 * @public
 * @param {int} sessionId to set.
 * @example amplitudeClient.setSessionId(1622158968000);
 */
AmplitudeClient.prototype.setSessionId = function setSessionId(sessionId) {
  if (!utils.validateInput(sessionId, 'sessionId', 'number')) {
    return;
  }
  try {
    this._sessionId = sessionId;
    _saveCookieData(this);
  } catch (e) {
    utils.log.error(e);
  }
};

/**
 * Sets the current Unix timestamp as the new Session ID for the instance.
 * @public
 * @example amplitudeClient.resetSessionId();
 */
AmplitudeClient.prototype.resetSessionId = function resetSessionId() {
  this.setSessionId(new Date().getTime());
};

/**
 * Regenerates a new random deviceId for current user. Note: this is not recommended unless you know what you
 * are doing. This can be used in conjunction with `setUserId(null)` to anonymize users after they log out.
 * With a null userId and a completely new deviceId, the current user would appear as a brand new user in dashboard.
 * This uses src/uuid.js to regenerate the deviceId.
 * @public
 */
AmplitudeClient.prototype.regenerateDeviceId = function regenerateDeviceId() {
  if (this._shouldDeferCall()) {
    return this._q.push(['regenerateDeviceId'].concat(Array.prototype.slice.call(arguments, 0)));
  }
  this.setDeviceId(base64Id());
};

/**
 * Sets a custom deviceId for current user. **Values may not have `.` inside them**
 * Note: this is not recommended unless you know what you are doing (like if you have your own system for managing deviceIds).
 * Make sure the deviceId you set is sufficiently unique
 * (we recommend something like a UUID - see src/uuid.js for an example of how to generate) to prevent conflicts with other devices in our system.
 * @public
 * @param {string} deviceId - custom deviceId for current user.
 * @example amplitudeClient.setDeviceId('45f0954f-eb79-4463-ac8a-233a6f45a8f0');
 */
AmplitudeClient.prototype.setDeviceId = function setDeviceId(deviceId) {
  if (this._shouldDeferCall()) {
    return this._q.push(['setDeviceId'].concat(Array.prototype.slice.call(arguments, 0)));
  }
  if (!utils.validateDeviceId(deviceId)) {
    return;
  }
  try {
    if (!utils.isEmptyString(deviceId)) {
      this.options.deviceId = '' + deviceId;
      _saveCookieData(this);

      // Update core identity store to propagate new user info
      // to experiment SDK and trigger a fetch if the ID has changed.
      if (this._connector) {
        this._connector.identityStore.editIdentity().setDeviceId(this.options.deviceId).commit();
      }
    }
  } catch (e) {
    utils.log.error(e);
  }
};

/**
 * Sets the network transport type for events. Typically used to set to 'beacon'
 * on an end-of-lifecycle event handler such as `onpagehide` or `onvisibilitychange`
 * @public
 * @param {string} transport - transport mechanism to use for events. Must be one of `http` or `beacon`.
 * @example amplitudeClient.setTransport('beacon');
 */
AmplitudeClient.prototype.setTransport = function setTransport(transport) {
  if (this._shouldDeferCall()) {
    return this._q.push(['setTransport'].concat(Array.prototype.slice.call(arguments, 0)));
  }
  if (!utils.validateTransport(transport)) {
    return;
  }
  this.options.transport = transport;
};

/**
 * Sets user properties for the current user.
 * @public
 * @param {object} - object with string keys and values for the user properties to set.
 * @param {boolean} - DEPRECATED opt_replace: in earlier versions of the JS SDK the user properties object was kept in
 * memory and replace = true would replace the object in memory. Now the properties are no longer stored in memory, so replace is deprecated.
 * @example amplitudeClient.setUserProperties({'gender': 'female', 'sign_up_complete': true})
 */
AmplitudeClient.prototype.setUserProperties = function setUserProperties(userProperties) {
  if (this._shouldDeferCall()) {
    return this._q.push(['setUserProperties'].concat(Array.prototype.slice.call(arguments, 0)));
  }
  if (!this._apiKeySet('setUserProperties()') || !utils.validateInput(userProperties, 'userProperties', 'object')) {
    return;
  }
  // sanitize the userProperties dict before converting into identify
  var sanitized = utils.truncate(utils.validateProperties(userProperties));
  if (Object.keys(sanitized).length === 0) {
    return;
  }

  // convert userProperties into an identify call
  var identify = new Identify();
  for (var property in sanitized) {
    if (Object.prototype.hasOwnProperty.call(sanitized, property)) {
      identify.set(property, sanitized[property]);
    }
  }
  this.identify(identify);
};

/**
 * Clear all of the user properties for the current user. Note: clearing user properties is irreversible!
 * @public
 * @example amplitudeClient.clearUserProperties();
 */
AmplitudeClient.prototype.clearUserProperties = function clearUserProperties() {
  if (this._shouldDeferCall()) {
    return this._q.push(['clearUserProperties'].concat(Array.prototype.slice.call(arguments, 0)));
  }
  if (!this._apiKeySet('clearUserProperties()')) {
    return;
  }
  var identify = new Identify();
  identify.clearAll();
  this.identify(identify);
};

/**
 * Applies the proxied functions on the proxied object to an instance of the real object.
 * Used to convert proxied Identify and Revenue objects.
 * @private
 */
var _convertProxyObjectToRealObject = function _convertProxyObjectToRealObject(instance, proxy) {
  for (var i = 0; i < proxy._q.length; i++) {
    var fn = instance[proxy._q[i][0]];
    if (type(fn) === 'function') {
      fn.apply(instance, proxy._q[i].slice(1));
    }
  }
  return instance;
};

/**
 * Send an identify call containing user property operations to Amplitude servers.
 * See the [Identify](https://amplitude.github.io/Amplitude-JavaScript/Identify/)
 * reference page for more information on the Identify API and user property operations.
 * @param {Identify} identify_obj - the Identify object containing the user property operations to send.
 * @param {Amplitude~eventCallback} opt_callback - (optional) callback function to run when the identify event has been sent.
 * Note: the server response code and response body from the identify event upload are passed to the callback function.
 * @param {Amplitude~eventCallback} opt_error_callback - (optional) a callback function to run after the event logging
 * fails. The failure can be from the request being malformed or from a network failure
 * Note: the server response code and response body from the event upload are passed to the callback function.
 * @example
 * var identify = new amplitude.Identify().set('colors', ['rose', 'gold']).add('karma', 1).setOnce('sign_up_date', '2016-03-31');
 * amplitude.identify(identify);
 */
AmplitudeClient.prototype.identify = function (identify_obj, opt_callback, opt_error_callback, outOfSession) {
  if (this._shouldDeferCall()) {
    return this._q.push(['identify'].concat(Array.prototype.slice.call(arguments, 0)));
  }
  if (!this._apiKeySet('identify()')) {
    _logErrorsWithCallbacks(opt_callback, opt_error_callback, 0, 'No request sent', {
      reason: 'API key is not set'
    });
    return;
  }

  // if identify input is a proxied object created by the async loading snippet, convert it into an identify object
  if (type(identify_obj) === 'object' && Object.prototype.hasOwnProperty.call(identify_obj, '_q')) {
    identify_obj = _convertProxyObjectToRealObject(new Identify(), identify_obj);
  }
  if (identify_obj instanceof Identify) {
    // only send if there are operations
    if (Object.keys(identify_obj.userPropertiesOperations).length > 0) {
      return this._logEvent(Constants.IDENTIFY_EVENT, null, null, identify_obj.userPropertiesOperations, null, null, null, opt_callback, opt_error_callback, outOfSession);
    } else {
      _logErrorsWithCallbacks(opt_callback, opt_error_callback, 0, 'No request sent', {
        reason: 'No user property operations'
      });
    }
  } else {
    utils.log.error('Invalid identify input type. Expected Identify object but saw ' + type(identify_obj));
    _logErrorsWithCallbacks(opt_callback, opt_error_callback, 0, 'No request sent', {
      reason: 'Invalid identify input type'
    });
  }
};
AmplitudeClient.prototype.groupIdentify = function (group_type, group_name, identify_obj, opt_callback, opt_error_callback, outOfSession) {
  if (this._shouldDeferCall()) {
    return this._q.push(['groupIdentify'].concat(Array.prototype.slice.call(arguments, 0)));
  }
  if (!this._apiKeySet('groupIdentify()')) {
    _logErrorsWithCallbacks(opt_callback, opt_error_callback, 0, 'No request sent', {
      reason: 'API key is not set'
    });
    return;
  }
  if (!utils.validateInput(group_type, 'group_type', 'string') || utils.isEmptyString(group_type)) {
    _logErrorsWithCallbacks(opt_callback, opt_error_callback, 0, 'No request sent', {
      reason: 'Invalid group type'
    });
    return;
  }
  if (group_name === null || group_name === undefined) {
    _logErrorsWithCallbacks(opt_callback, opt_error_callback, 0, 'No request sent', {
      reason: 'Invalid group name'
    });
    return;
  }

  // if identify input is a proxied object created by the async loading snippet, convert it into an identify object
  if (type(identify_obj) === 'object' && Object.prototype.hasOwnProperty.call(identify_obj, '_q')) {
    identify_obj = _convertProxyObjectToRealObject(new Identify(), identify_obj);
  }
  if (identify_obj instanceof Identify) {
    // only send if there are operations
    if (Object.keys(identify_obj.userPropertiesOperations).length > 0) {
      return this._logEvent(Constants.GROUP_IDENTIFY_EVENT, null, null, null, _defineProperty$1({}, group_type, group_name), identify_obj.userPropertiesOperations, null, opt_callback, opt_error_callback, outOfSession);
    } else {
      _logErrorsWithCallbacks(opt_callback, opt_error_callback, 0, 'No request sent', {
        reason: 'No group property operations'
      });
    }
  } else {
    utils.log.error('Invalid identify input type. Expected Identify object but saw ' + type(identify_obj));
    _logErrorsWithCallbacks(opt_callback, opt_error_callback, 0, 'No request sent', {
      reason: 'Invalid identify input type'
    });
  }
};

/**
 * Set a versionName for your application.
 * @public
 * @param {string} versionName - The version to set for your application.
 * @example amplitudeClient.setVersionName('1.12.3');
 */
AmplitudeClient.prototype.setVersionName = function setVersionName(versionName) {
  if (this._shouldDeferCall()) {
    return this._q.push(['setVersionName'].concat(Array.prototype.slice.call(arguments, 0)));
  }
  if (!utils.validateInput(versionName, 'versionName', 'string')) {
    return;
  }
  this.options.versionName = versionName;
};

/**
 * Private logEvent method. Keeps apiProperties from being publicly exposed.
 * @private
 */
AmplitudeClient.prototype._logEvent = function _logEvent(eventType, eventProperties, apiProperties, userProperties, groups, groupProperties, timestamp, callback, errorCallback, outOfSession) {
  _loadCookieData(this); // reload cookie before each log event to sync event meta-data between windows and tabs

  if (!eventType) {
    _logErrorsWithCallbacks(callback, errorCallback, 0, 'No request sent', {
      reason: 'Missing eventType'
    });
    return;
  }
  if (this.options.optOut) {
    _logErrorsWithCallbacks(callback, errorCallback, 0, 'No request sent', {
      reason: 'optOut is set to true'
    });
    return;
  }
  try {
    var eventId;
    if (eventType === Constants.IDENTIFY_EVENT || eventType === Constants.GROUP_IDENTIFY_EVENT) {
      eventId = this.nextIdentifyId();
    } else {
      eventId = this.nextEventId();
    }
    var sequenceNumber = this.nextSequenceNumber();
    var eventTime = type(timestamp) === 'number' ? timestamp : new Date().getTime();
    if (outOfSession) {
      this._sessionId = -1;
    } else if (!this._sessionId || !this._lastEventTime || eventTime - this._lastEventTime > this.options.sessionTimeout) {
      this._sessionId = eventTime;
      this._runNewSessionStartCallbacks();
    }
    this._lastEventTime = eventTime;
    _saveCookieData(this);
    var osName = this._ua.browser.name;
    var osVersion = this._ua.browser.major;
    var deviceModel = this._ua.device.model || this._ua.os.name;
    var deviceVendor = this._ua.device.vendor;
    userProperties = userProperties || {};
    var trackingOptions = _objectSpread2$1({}, this._apiPropertiesTrackingOptions);
    apiProperties = _objectSpread2$1(_objectSpread2$1({}, apiProperties || {}), trackingOptions);
    eventProperties = eventProperties || {};
    groups = groups || {};
    groupProperties = groupProperties || {};
    var event = {
      device_id: this.options.deviceId,
      user_id: this.options.userId,
      timestamp: eventTime,
      event_id: eventId,
      session_id: this._sessionId || -1,
      event_type: eventType,
      version_name: this.options.versionName || null,
      platform: _shouldTrackField(this, 'platform') ? this.options.platform : null,
      os_name: _shouldTrackField(this, 'os_name') ? osName || null : null,
      os_version: _shouldTrackField(this, 'os_version') ? osVersion || null : null,
      device_model: _shouldTrackField(this, 'device_model') ? deviceModel || null : null,
      device_manufacturer: _shouldTrackField(this, 'device_manufacturer') ? deviceVendor || null : null,
      language: _shouldTrackField(this, 'language') ? this.options.language : null,
      api_properties: apiProperties,
      event_properties: utils.truncate(utils.validateProperties(eventProperties)),
      user_properties: utils.truncate(utils.validateProperties(userProperties)),
      uuid: uuid$1(),
      library: this.options.library,
      sequence_number: sequenceNumber,
      // for ordering events and identifys
      groups: utils.truncate(utils.validateGroups(groups)),
      group_properties: utils.truncate(utils.validateProperties(groupProperties)),
      user_agent: this._userAgent,
      partner_id: this.options.partnerId || null
    };
    if (_isObservePlanSet(this)) {
      event.plan = {
        branch: this.options.plan.branch || undefined,
        source: this.options.plan.source || undefined,
        version: this.options.plan.version || undefined,
        versionId: this.options.plan.versionId || undefined
      };
    }
    if (_isIngestionMetadataSet(this)) {
      event.ingestion_metadata = {
        source_name: this.options.ingestionMetadata.sourceName || undefined,
        source_version: this.options.ingestionMetadata.sourceVersion || undefined
      };
    }
    if (eventType === Constants.IDENTIFY_EVENT || eventType === Constants.GROUP_IDENTIFY_EVENT) {
      this._unsentIdentifys.push({
        event: event,
        callback: callback,
        errorCallback: errorCallback
      });
      this._limitEventsQueued(this._unsentIdentifys);
    } else {
      this._unsentEvents.push({
        event: event,
        callback: callback,
        errorCallback: errorCallback
      });
      this._limitEventsQueued(this._unsentEvents);
    }
    if (this.options.saveEvents) {
      this.saveEvents();
    }
    this._sendEventsIfReady();

    // In the case of an identify event, update the core user store so the experiment SDK can fetch new variants and
    // utilize user properties in real time.
    if (eventType === Constants.IDENTIFY_EVENT && this._connector) {
      this._connector.identityStore.editIdentity().updateUserProperties(utils.truncate(utils.validateProperties(userProperties))).commit();
    }
    return eventId;
  } catch (e) {
    utils.log.error(e);
  }
};
var _isObservePlanSet = function _isObservePlanSet(scope) {
  return scope.options.plan && (scope.options.plan.source || scope.options.plan.branch || scope.options.plan.version || scope.options.plan.versionId);
};
var _isIngestionMetadataSet = function _isIngestionMetadataSet(scope) {
  return scope.options.ingestionMetadata && (scope.options.ingestionMetadata.sourceName || scope.options.ingestionMetadata.sourceVersion);
};
var _shouldTrackField = function _shouldTrackField(scope, field) {
  return !!scope.options.trackingOptions[field];
};
var _generateApiPropertiesTrackingConfig = function _generateApiPropertiesTrackingConfig(scope) {
  // to limit size of config payload, only send fields that have been disabled
  var fields = ['city', 'country', 'dma', 'ip_address', 'region'];
  var config = {};
  for (var i = 0; i < fields.length; i++) {
    var field = fields[i];
    if (!_shouldTrackField(scope, field)) {
      config[field] = false;
    }
  }
  return config;
};

/**
 * Remove old events from the beginning of the array if too many have accumulated. Default limit is 1000 events.
 * @private
 */
AmplitudeClient.prototype._limitEventsQueued = function _limitEventsQueued(queue) {
  if (queue.length > this.options.savedMaxCount) {
    var deletedEvents = queue.splice(0, queue.length - this.options.savedMaxCount);
    deletedEvents.forEach(function (event) {
      _logErrorsWithCallbacks(event.callback, event.errorCallback, 0, 'No request sent', {
        reason: 'Event dropped because options.savedMaxCount exceeded. User may be offline or have a content blocker'
      });
    });
  }
};

/**
 * This is the callback for logEvent and identify calls. It gets called after the event/identify is uploaded,
 * and the server response code and response body from the upload request are passed to the callback function.
 * @callback Amplitude~eventCallback
 * @param {number} responseCode - Server response code for the event / identify upload request.
 * @param {string} responseBody - Server response body for the event / identify upload request.
 * @param {object} details - (optional) Additional information associated with sending event.
 */

/**
 * Log an event with eventType and eventProperties
 * @public
 * @param {string} eventType - name of event
 * @param {object} eventProperties - (optional) an object with string keys and values for the event properties.
 * @param {Amplitude~eventCallback} opt_callback - (optional) a callback function to run after the event is logged.
 * Note: the server response code and response body from the event upload are passed to the callback function.
 * @param {Amplitude~eventCallback} opt_error_callback - (optional) a callback function to run after the event logging
 * fails. The failure can be from the request being malformed or from a network failure
 * Note: the server response code and response body from the event upload are passed to the callback function.
 * @param {boolean} outOfSession - (optional) if this event is out of session or not
 * @example amplitudeClient.logEvent('Clicked Homepage Button', {'finished_flow': false, 'clicks': 15});
 */
AmplitudeClient.prototype.logEvent = function logEvent(eventType, eventProperties, opt_callback, opt_error_callback) {
  var outOfSession = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
  if (this._shouldDeferCall()) {
    return this._q.push(['logEvent'].concat(Array.prototype.slice.call(arguments, 0)));
  }
  return this.logEventWithTimestamp(eventType, eventProperties, null, opt_callback, opt_error_callback, outOfSession);
};

/**
 * Log an event with eventType and eventProperties and a custom timestamp
 * @public
 * @param {string} eventType - name of event
 * @param {object} eventProperties - (optional) an object with string keys and values for the event properties.
 * @param {number} timestamp - (optional) the custom timestamp as milliseconds since epoch.
 * @param {Amplitude~eventCallback} opt_callback - (optional) a callback function to run after the event is logged.
 * Note: the server response code and response body from the event upload are passed to the callback function.
 * @param {Amplitude~eventCallback} opt_error_callback - (optional) a callback function to run after the event logging
 * fails. The failure can be from the request being malformed or from a network failure
 * Note: the server response code and response body from the event upload are passed to the callback function.
 * @param {boolean} outOfSession - (optional) if out of the sessioin or not
 * @example amplitudeClient.logEventWithTimestamp('Clicked Homepage Button', {'finished_flow': false, 'clicks': 15}, Date.now());
 */
AmplitudeClient.prototype.logEventWithTimestamp = function logEvent(eventType, eventProperties, timestamp, opt_callback, opt_error_callback) {
  var outOfSession = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : false;
  if (this._shouldDeferCall()) {
    return this._q.push(['logEventWithTimestamp'].concat(Array.prototype.slice.call(arguments, 0)));
  }
  if (!this._apiKeySet('logEvent()')) {
    _logErrorsWithCallbacks(opt_callback, opt_error_callback, 0, 'No request sent', {
      reason: 'API key not set'
    });
    return -1;
  }
  if (!utils.validateInput(eventType, 'eventType', 'string')) {
    _logErrorsWithCallbacks(opt_callback, opt_error_callback, 0, 'No request sent', {
      reason: 'Invalid type for eventType'
    });
    return -1;
  }
  if (utils.isEmptyString(eventType)) {
    _logErrorsWithCallbacks(opt_callback, opt_error_callback, 0, 'No request sent', {
      reason: 'Missing eventType'
    });
    return -1;
  }
  if (!utils.validateInput(outOfSession, 'outOfSession', 'boolean')) {
    _logErrorsWithCallbacks(opt_callback, opt_error_callback, 0, 'No request sent', {
      reason: 'Invalid outOfSession value'
    });
  }
  return this._logEvent(eventType, eventProperties, null, null, null, null, timestamp, opt_callback, opt_error_callback, outOfSession);
};

/**
 * Log an event with eventType, eventProperties, and groups. Use this to set event-level groups.
 * Note: the group(s) set only apply for the specific event type being logged and does not persist on the user
 * (unless you explicitly set it with setGroup).
 *
 * See the [advanced topics article](https://developers.amplitude.com/docs/javascript#user-groups) for more information
 * about groups and Count by Distinct on the Amplitude platform.
 * @public
 * @param {string} eventType - name of event
 * @param {object} eventProperties - (optional) an object with string keys and values for the event properties.
 * @param {object} groups - (optional) an object with string groupType: groupName values for the event being logged.
 * groupName can be a string or an array of strings.
 * @param {Amplitude~eventCallback} opt_callback - (optional) a callback function to run after the event is logged.
 * Note: the server response code and response body from the event upload are passed to the callback function.
 * @param {Amplitude~eventCallback} opt_error_callback - (optional) a callback function to run after the event logging
 * fails. The failure can be from the request being malformed or from a network failure
 * Note: the server response code and response body from the event upload are passed to the callback function.
 * @example amplitudeClient.logEventWithGroups('Clicked Button', null, {'orgId': 24});
 */
AmplitudeClient.prototype.logEventWithGroups = function (eventType, eventProperties, groups, opt_callback, opt_error_callback) {
  var outOfSession = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : false;
  if (this._shouldDeferCall()) {
    return this._q.push(['logEventWithGroups'].concat(Array.prototype.slice.call(arguments, 0)));
  }
  if (!this._apiKeySet('logEventWithGroups()')) {
    _logErrorsWithCallbacks(event.callback, event.errorCallback, 0, 'No request sent', {
      reason: 'API key not set'
    });
    return -1;
  }
  if (!utils.validateInput(eventType, 'eventType', 'string')) {
    _logErrorsWithCallbacks(event.callback, event.errorCallback, 0, 'No request sent', {
      reason: 'Invalid type for eventType'
    });
    return -1;
  }
  if (!utils.validateInput(outOfSession, 'outOfSession', 'boolean')) {
    _logErrorsWithCallbacks(event.callback, event.errorCallback, 0, 'No request sent', {
      reason: 'Invalid outOfSession value'
    });
  }
  return this._logEvent(eventType, eventProperties, null, null, groups, null, null, opt_callback, opt_error_callback, outOfSession);
};

/**
 * Test that n is a number or a numeric value.
 * @private
 */
var _isNumber = function _isNumber(n) {
  return !isNaN(parseFloat(n)) && isFinite(n);
};

/**
 * Handles errors that are sent to both callbacks
 * @private
 */
var _logErrorsWithCallbacks = function _logErrorsWithCallbacks(opt_callback, opt_error_callback, status, response, details) {
  if (type(opt_callback) === 'function') {
    opt_callback(status, response, details);
  }
  if (type(opt_error_callback) === 'function') {
    opt_error_callback(status, response, details);
  }
};

/**
 * Log revenue with Revenue interface. The new revenue interface allows for more revenue fields like
 * revenueType and event properties.
 *
 * See the [Revenue](https://amplitude.github.io/Amplitude-JavaScript/Revenue/)
 * reference page for more information on the Revenue interface and logging revenue.
 * @public
 * @param {Revenue} revenue_obj - the revenue object containing the revenue data being logged.
 * @example var revenue = new amplitude.Revenue().setProductId('productIdentifier').setPrice(10.99);
 * amplitude.logRevenueV2(revenue);
 */
AmplitudeClient.prototype.logRevenueV2 = function logRevenueV2(revenue_obj) {
  if (this._shouldDeferCall()) {
    return this._q.push(['logRevenueV2'].concat(Array.prototype.slice.call(arguments, 0)));
  }
  if (!this._apiKeySet('logRevenueV2()')) {
    return;
  }

  // if revenue input is a proxied object created by the async loading snippet, convert it into an revenue object
  if (type(revenue_obj) === 'object' && Object.prototype.hasOwnProperty.call(revenue_obj, '_q')) {
    revenue_obj = _convertProxyObjectToRealObject(new Revenue(), revenue_obj);
  }
  if (revenue_obj instanceof Revenue) {
    // only send if revenue is valid
    if (revenue_obj && revenue_obj._isValidRevenue()) {
      return this.logEvent(Constants.REVENUE_EVENT, revenue_obj._toJSONObject());
    }
  } else {
    utils.log.error('Invalid revenue input type. Expected Revenue object but saw ' + type(revenue_obj));
  }
};
{
  /**
   * Log revenue event with a price, quantity, and product identifier. DEPRECATED - use logRevenueV2
   * @public
   * @deprecated
   * @param {number} price - price of revenue event
   * @param {number} quantity - (optional) quantity of products in revenue event. If no quantity specified default to 1.
   * @param {string} product - (optional) product identifier
   * @example amplitudeClient.logRevenue(3.99, 1, 'product_1234');
   */
  AmplitudeClient.prototype.logRevenue = function logRevenue(price, quantity, product) {
    if (this._shouldDeferCall()) {
      return this._q.push(['logRevenue'].concat(Array.prototype.slice.call(arguments, 0)));
    }

    // Test that the parameters are of the right type.
    if (!this._apiKeySet('logRevenue()') || !_isNumber(price) || quantity !== undefined && !_isNumber(quantity)) {
      // utils.log('Price and quantity arguments to logRevenue must be numbers');
      return -1;
    }
    return this._logEvent(Constants.REVENUE_EVENT, {}, {
      productId: product,
      special: 'revenue_amount',
      quantity: quantity || 1,
      price: price
    }, null, null, null, null, null);
  };
}

/**
 * Calls error callback on unsent events
 * @private
 */
AmplitudeClient.prototype._logErrorsOnEvents = function _logErrorsOnEvents(maxEventId, maxIdentifyId, status, response) {
  var queues = ['_unsentEvents', '_unsentIdentifys'];
  for (var j = 0; j < queues.length; j++) {
    var queue = queues[j];
    var maxId = queue === '_unsentEvents' ? maxEventId : maxIdentifyId;
    for (var i = 0; i < this[queue].length || 0; i++) {
      var unsentEvent = this[queue][i];
      if (unsentEvent.event.event_id <= maxId) {
        if (unsentEvent.errorCallback) {
          unsentEvent.errorCallback(status, response);
        }
      }
    }
  }
};

/**
 * Remove events in storage with event ids up to and including maxEventId.
 * @private
 */
AmplitudeClient.prototype.removeEvents = function removeEvents(maxEventId, maxIdentifyId, status, response) {
  _removeEvents(this, '_unsentEvents', maxEventId, status, response);
  _removeEvents(this, '_unsentIdentifys', maxIdentifyId, status, response);
};

/**
 * Helper function to remove events up to maxId from a single queue.
 * Does a true filter in case events get out of order or old events are removed.
 * @private
 */
var _removeEvents = function _removeEvents(scope, eventQueue, maxId, status, response) {
  if (maxId < 0) {
    return;
  }
  var filteredEvents = [];
  for (var i = 0; i < scope[eventQueue].length || 0; i++) {
    var unsentEvent = scope[eventQueue][i];
    if (unsentEvent.event.event_id > maxId) {
      filteredEvents.push(unsentEvent);
    } else {
      if (unsentEvent.callback) {
        unsentEvent.callback(status, response);
      }
    }
  }
  scope[eventQueue] = filteredEvents;
};

/**
 * Send unsent events. Note: this is called automatically after events are logged if option batchEvents is false.
 * If batchEvents is true, then events are only sent when batch criterias are met.
 * @private
 */
AmplitudeClient.prototype.sendEvents = function sendEvents() {
  if (!this._apiKeySet('sendEvents()')) {
    this.removeEvents(Infinity, Infinity, 0, 'No request sent', {
      reason: 'API key not set'
    });
    return;
  }
  if (this.options.optOut) {
    this.removeEvents(Infinity, Infinity, 0, 'No request sent', {
      reason: 'Opt out is set to true'
    });
    return;
  }

  // How is it possible to get into this state?
  if (this._unsentCount() === 0) {
    return;
  }

  // We only make one request at a time. sendEvents will be invoked again once
  // the last request completes.
  // beacon data is sent synchronously, so don't pause for it
  if (this.options.transport !== Constants.TRANSPORT_BEACON) {
    if (this._sending) {
      return;
    }
    this._sending = true;
  }
  var protocol = this.options.forceHttps ? 'https' : 'https:' === GlobalScope.location.protocol ? 'https' : 'http';
  var url = protocol + '://' + this.options.apiEndpoint;

  // fetch events to send
  var numEvents = Math.min(this._unsentCount(), this.options.uploadBatchSize);
  var mergedEvents = this._mergeEventsAndIdentifys(numEvents);
  var maxEventId = mergedEvents.maxEventId;
  var maxIdentifyId = mergedEvents.maxIdentifyId;
  var events = JSON.stringify(mergedEvents.eventsToSend.map(function (_ref2) {
    var event = _ref2.event;
    return event;
  }));
  var uploadTime = new Date().getTime();
  var data = {
    client: this.options.apiKey,
    e: events,
    v: Constants.API_VERSION,
    upload_time: uploadTime,
    checksum: md5(Constants.API_VERSION + this.options.apiKey + events + uploadTime)
  };
  if (this.options.transport === Constants.TRANSPORT_BEACON && typeof navigator !== 'undefined') {
    var success = navigator.sendBeacon(url, new URLSearchParams(data));
    if (success) {
      this.removeEvents(maxEventId, maxIdentifyId, 200, 'success');
      if (this.options.saveEvents) {
        this.saveEvents();
      }
    } else {
      this._logErrorsOnEvents(maxEventId, maxIdentifyId, 0, '');
    }
    return;
  }
  var scope = this;
  try {
    new Request$1(url, data, this.options.headers).send(function (status, response) {
      scope._sending = false;
      try {
        if (status === 200) {
          scope.removeEvents(maxEventId, maxIdentifyId, status, response);

          // Update the event cache after the removal of sent events.
          if (scope.options.saveEvents) {
            scope.saveEvents();
          }

          // Send more events if any queued during previous send.
          scope._sendEventsIfReady();

          // handle payload too large
        } else {
          scope._logErrorsOnEvents(maxEventId, maxIdentifyId, status, response);
          if (status === 413) {
            // utils.log('request too large');
            // Can't even get this one massive event through. Drop it, even if it is an identify.
            if (scope.options.uploadBatchSize === 1) {
              scope.removeEvents(maxEventId, maxIdentifyId, status, response);
            }

            // The server complained about the length of the request. Backoff and try again.
            scope.options.uploadBatchSize = Math.ceil(numEvents / 2);
            scope.sendEvents();
          }
        }
        // else {
        //  all the events are still queued, and will be retried when the next
        //  event is sent In the interest of debugging, it would be nice to have
        //  something like an event emitter for a better debugging experince
        //  here.
        // }
      } catch (e) {
        // utils.log.error('failed upload');
      }
    });
  } catch (e) {
    var status = 0,
      response = 'Request failed to send';
    utils.log.error(response);
    scope._logErrorsOnEvents(maxEventId, maxIdentifyId, status, response);
    scope.removeEvents(maxEventId, maxIdentifyId, status, response, {
      reason: e.message
    });
  }
};

/**
 * Merge unsent events and identifys together in sequential order based on their sequence number, for uploading.
 * Identifys given higher priority than Events. Also earlier sequence given priority
 * @private
 */
AmplitudeClient.prototype._mergeEventsAndIdentifys = function _mergeEventsAndIdentifys(numEvents) {
  // coalesce events from both queues
  var eventsToSend = [];
  var eventIndex = 0;
  var maxEventId = -1;
  var identifyIndex = 0;
  var maxIdentifyId = -1;
  while (eventsToSend.length < numEvents) {
    var unsentEvent = void 0;
    var noIdentifys = identifyIndex >= this._unsentIdentifys.length;
    var noEvents = eventIndex >= this._unsentEvents.length;

    // case 0: no events or identifys left
    // note this should not happen, this means we have less events and identifys than expected
    if (noEvents && noIdentifys) {
      utils.log.error('Merging Events and Identifys, less events and identifys than expected');
      break;
    }

    // case 1: no identifys - grab from events
    else if (noIdentifys) {
      unsentEvent = this._unsentEvents[eventIndex++];
      maxEventId = unsentEvent.event.event_id;

      // case 2: no events - grab from identifys
    } else if (noEvents) {
      unsentEvent = this._unsentIdentifys[identifyIndex++];
      maxIdentifyId = unsentEvent.event.event_id;

      // case 3: need to compare sequence numbers
    } else {
      // events logged before v2.5.0 won't have a sequence number, put those first
      if (!('sequence_number' in this._unsentEvents[eventIndex].event) || this._unsentEvents[eventIndex].event.sequence_number < this._unsentIdentifys[identifyIndex].event.sequence_number) {
        unsentEvent = this._unsentEvents[eventIndex++];
        maxEventId = unsentEvent.event.event_id;
      } else {
        unsentEvent = this._unsentIdentifys[identifyIndex++];
        maxIdentifyId = unsentEvent.event.event_id;
      }
    }
    eventsToSend.push(unsentEvent);
  }
  return {
    eventsToSend: eventsToSend,
    maxEventId: maxEventId,
    maxIdentifyId: maxIdentifyId
  };
};
{
  /**
   * Set global user properties. Note this is deprecated, and we recommend using setUserProperties
   * @public
   * @deprecated
   */
  AmplitudeClient.prototype.setGlobalUserProperties = function setGlobalUserProperties(userProperties) {
    this.setUserProperties(userProperties);
  };
}

/**
 * Get the current version of Amplitude's Javascript SDK.
 * @public
 * @returns {number} version number
 * @example var amplitudeVersion = amplitude.__VERSION__;
 */
AmplitudeClient.prototype.__VERSION__ = function getVersion() {
  return this.options.library.version;
};

/**
 * Sets the library name and version. Default is `amplitude-js` and the version defined in package.json. Used if you're building another library on top of amplitude-js and want a custom data source value
 * @public
 * @param {string} name - Custom library name
 * @param {string} version - Custom library version
 */
AmplitudeClient.prototype.setLibrary = function setLibrary(name, version) {
  if (name !== null && typeof name !== 'undefined') {
    this.options.library.name = name;
  }
  if (version !== null && typeof version !== 'undefined') {
    this.options.library.version = version;
  }
};

/**
 * Determines whether or not to push call to this._q or invoke it
 * @private
 */
AmplitudeClient.prototype._shouldDeferCall = function _shouldDeferCall() {
  return this._pendingReadStorage || this._initializationDeferred;
};

/**
 * Defers Initialization by putting all functions into storage until users
 * have accepted terms for tracking
 * @private
 */
AmplitudeClient.prototype._deferInitialization = function _deferInitialization() {
  this._initializationDeferred = true;
  this._q.push(['init'].concat(Array.prototype.slice.call(arguments, 0)));
};

/**
 * Enable tracking via logging events and dropping a cookie
 * Intended to be used with the deferInitialization configuration flag
 * This will drop a cookie and reset initialization deferred
 * @public
 */
AmplitudeClient.prototype.enableTracking = function enableTracking() {
  // This will call init (which drops the cookie) and will run any pending tasks
  this._initializationDeferred = false;
  _saveCookieData(this);
  this.runQueuedFunctions();
};

/**
 * Find best server url if choose to enable dynamic configuration.
 */
AmplitudeClient.prototype._refreshDynamicConfig = function _refreshDynamicConfig() {
  if (this.options.useDynamicConfig) {
    instance$1.refresh(this.options.serverZone, this.options.forceHttps, function () {
      this.options.apiEndpoint = instance$1.ingestionEndpoint;
    }.bind(this));
  }
};

/**
 * Returns the deviceId value.
 * @public
 * @return {string} Id of current device.
 */
AmplitudeClient.prototype.getDeviceId = function getDeviceId() {
  return this.options.deviceId;
};

/**
 * Returns the userId.
 * @public
 * @return {string} Id of current user.
 */
AmplitudeClient.prototype.getUserId = function getUserId() {
  return this.options.userId;
};

/**
 * Set a custom session expiration time.
 * @public
 * @param {number} timeInMillis - session expireation time in milliseconds.
 */
AmplitudeClient.prototype.setMinTimeBetweenSessionsMillis = function setMinTimeBetweenSessionsMillis(timeInMillis) {
  if (!utils.validateInput(timeInMillis, 'timeInMillis', 'number')) {
    return;
  }
  if (this._shouldDeferCall()) {
    return this._q.push(['setMinTimeBetweenSessionsMillis'].concat(Array.prototype.slice.call(arguments, 0)));
  }
  try {
    this.options.sessionTimeout = timeInMillis;
  } catch (e) {
    utils.log.error(e);
  }
};

/**
 * Sets minimum number of events to batch together per request if batchEvents is true.
 * @public
 * @param {number} eventUploadThreshold - The number of the event upload threshold. Default value is 30.
 * @example amplitudeClient.setEventUploadThreshold(10);
 */
AmplitudeClient.prototype.setEventUploadThreshold = function setEventUploadThreshold(eventUploadThreshold) {
  if (!utils.validateInput(eventUploadThreshold, 'eventUploadThreshold', 'number')) {
    return;
  }
  if (this._shouldDeferCall()) {
    return this._q.push(['setEventUploadThreshold'].concat(Array.prototype.slice.call(arguments, 0)));
  }
  try {
    this.options.eventUploadThreshold = eventUploadThreshold;
  } catch (e) {
    utils.log.error(e);
  }
};

/**
 * Dynamically adjust server URL
 * @public
 * @param {bool} useDynamicConfig - if enable dynamic config or not.
 * @example amplitudeClient.setUseDynamicConfig(true);
 */
AmplitudeClient.prototype.setUseDynamicConfig = function setUseDynamicConfig(useDynamicConfig) {
  if (!utils.validateInput(useDynamicConfig, 'useDynamicConfig', 'boolean')) {
    return;
  }
  if (this._shouldDeferCall()) {
    return this._q.push(['setUseDynamicConfig'].concat(Array.prototype.slice.call(arguments, 0)));
  }
  try {
    this.options.useDynamicConfig = useDynamicConfig;
    this._refreshDynamicConfig();
  } catch (e) {
    utils.log.error(e);
  }
};

/**
 * Sets the server zone, used for server api endpoint and dynamic configuration.
 * @public
 * @param {string} serverZone - the server zone value. AmplitudeServerZone.US or AmplitudeServerZone.EU.
 * @param {bool} serverZoneBasedApi - (optional) update api endpoint with serverZone change or not. For data residency, recommend to enable it unless using own proxy server.
 * @example amplitudeClient.setServerZone(AmplitudeServerZone.EU, true);
 */
AmplitudeClient.prototype.setServerZone = function setServerZone(serverZone) {
  var serverZoneBasedApi = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  if (serverZone !== AmplitudeServerZone.EU && serverZone !== AmplitudeServerZone.US || !utils.validateInput(serverZoneBasedApi, 'serverZoneBasedApi', 'boolean')) {
    return;
  }
  if (this._shouldDeferCall()) {
    return this._q.push(['setServerZone'].concat(Array.prototype.slice.call(arguments, 0)));
  }
  try {
    this.options.serverZone = serverZone;
    this.options.serverZoneBasedApi = serverZoneBasedApi;
    if (serverZoneBasedApi) {
      this.options.apiEndpoint = getEventLogApi(this.options.serverZone);
    }
  } catch (e) {
    utils.log.error(e);
  }
};

/**
 * Sets the server URL for the request.
 * @public
 * @param {string} serverUrl - The value of the server URL.
 * @example amplitudeClient.setServerUrl('api.amplitude.com');
 */
AmplitudeClient.prototype.setServerUrl = function setServerUrl(serverUrl) {
  if (!utils.validateInput(serverUrl, 'serverUrl', 'string')) {
    return;
  }
  if (this._shouldDeferCall()) {
    return this._q.push(['setServerUrl'].concat(Array.prototype.slice.call(arguments, 0)));
  }
  try {
    this.options.apiEndpoint = serverUrl;
  } catch (e) {
    utils.log.error(e);
  }
};

/**
 * Deprecated legacy API of the Amplitude JS SDK - instance manager.
 *
 * Wraps around the current [AmplitudeClient](https://amplitude.github.io/Amplitude-JavaScript/) which provides more features
 * Function calls directly on amplitude have been deprecated. Please call methods on the default shared instance: amplitude.getInstance() instead.
 *
 * See the [3.0.0 changelog](https://github.com/amplitude/Amplitude-JavaScript/blob/ed405afb5f06d5cf5b72539a5d09179abcf7e1fe/README.md#300-update-and-logging-events-to-multiple-amplitude-apps) for more information about this change.
 * @constructor Amplitude
 * @public
 * @deprecated
 * @example var amplitude = new Amplitude();
 */
var Amplitude = function Amplitude() {
  this.options = _objectSpread2$1({}, DEFAULT_OPTIONS);
  this._q = [];
  this._instances = {}; // mapping of instance names to instances
};
Amplitude.prototype.Identify = Identify;
Amplitude.prototype.Revenue = Revenue;
Amplitude.prototype.getInstance = function getInstance(instance) {
  instance = utils.isEmptyString(instance) ? Constants.DEFAULT_INSTANCE : instance.toLowerCase();
  var client = this._instances[instance];
  if (client === undefined) {
    client = new AmplitudeClient(instance);
    this._instances[instance] = client;
  }
  return client;
};
{
  /**
   * Initializes the Amplitude Javascript SDK with your apiKey and any optional configurations.
   * This is required before any other methods can be called.
   * @public
   * @param {string} apiKey - The API key for your app.
   * @param {string} opt_userId - (optional) An identifier for this user.
   * @param {object} opt_config - (optional) Configuration options.
   * See [options.js](https://github.com/amplitude/Amplitude-JavaScript/blob/master/src/options.js#L14) for list of options and default values.
   * @param {function} opt_callback - (optional) Provide a callback function to run after initialization is complete.
   * @deprecated Please use amplitude.getInstance().init(apiKey, opt_userId, opt_config, opt_callback);
   * @example amplitude.init('API_KEY', 'USER_ID', {includeReferrer: true, includeUtm: true}, function() { alert('init complete'); });
   */
  Amplitude.prototype.init = function init(apiKey, opt_userId, opt_config, opt_callback) {
    this.getInstance().init(apiKey, opt_userId, opt_config, function (instance) {
      // make options such as deviceId available for callback functions
      this.options = instance.options;
      if (type(opt_callback) === 'function') {
        opt_callback(instance);
      }
    }.bind(this));
  };

  /**
   * Returns true if a new session was created during initialization, otherwise false.
   * @public
   * @return {boolean} Whether a new session was created during initialization.
   * @deprecated Please use amplitude.getInstance().isNewSession();
   */
  Amplitude.prototype.isNewSession = function isNewSession() {
    return this.getInstance().isNewSession();
  };

  /**
   * Returns the id of the current session.
   * @public
   * @return {number} Id of the current session.
   * @deprecated Please use amplitude.getInstance().getSessionId();
   */
  Amplitude.prototype.getSessionId = function getSessionId() {
    return this.getInstance().getSessionId();
  };

  /**
   * Increments the eventId and returns it.
   * @private
   */
  Amplitude.prototype.nextEventId = function nextEventId() {
    return this.getInstance().nextEventId();
  };

  /**
   * Increments the identifyId and returns it.
   * @private
   */
  Amplitude.prototype.nextIdentifyId = function nextIdentifyId() {
    return this.getInstance().nextIdentifyId();
  };

  /**
   * Increments the sequenceNumber and returns it.
   * @private
   */
  Amplitude.prototype.nextSequenceNumber = function nextSequenceNumber() {
    return this.getInstance().nextSequenceNumber();
  };

  /**
   * Saves unsent events and identifies to localStorage. JSON stringifies event queues before saving.
   * Note: this is called automatically every time events are logged, unless you explicitly set option saveEvents to false.
   * @private
   */
  Amplitude.prototype.saveEvents = function saveEvents() {
    this.getInstance().saveEvents();
  };

  /**
   * Sets a customer domain for the amplitude cookie. Useful if you want to support cross-subdomain tracking.
   * @public
   * @param {string} domain to set.
   * @deprecated Please use amplitude.getInstance().setDomain(domain);
   * @example amplitude.setDomain('.amplitude.com');
   */
  Amplitude.prototype.setDomain = function setDomain(domain) {
    this.getInstance().setDomain(domain);
  };

  /**
   * Sets an identifier for the current user.
   * @public
   * @param {string} userId - identifier to set. Can be null.
   * @deprecated Please use amplitude.getInstance().setUserId(userId);
   * @example amplitude.setUserId('joe@gmail.com');
   */
  Amplitude.prototype.setUserId = function setUserId(userId) {
    this.getInstance().setUserId(userId);
  };

  /**
   * Add user to a group or groups. You need to specify a groupType and groupName(s).
   * For example you can group people by their organization.
   * In that case groupType is "orgId" and groupName would be the actual ID(s).
   * groupName can be a string or an array of strings to indicate a user in multiple gruups.
   * You can also call setGroup multiple times with different groupTypes to track multiple types of groups (up to 5 per app).
   * Note: this will also set groupType: groupName as a user property.
   * See the [advanced topics article](https://developers.amplitude.com/docs/javascript#user-groups) for more information.
   * @public
   * @param {string} groupType - the group type (ex: orgId)
   * @param {string|list} groupName - the name of the group (ex: 15), or a list of names of the groups
   * @deprecated Please use amplitude.getInstance().setGroup(groupType, groupName);
   * @example amplitude.setGroup('orgId', 15); // this adds the current user to orgId 15.
   */
  Amplitude.prototype.setGroup = function (groupType, groupName) {
    this.getInstance().setGroup(groupType, groupName);
  };

  /**
   * Sets whether to opt current user out of tracking.
   * @public
   * @param {boolean} enable - if true then no events will be logged or sent.
   * @deprecated Please use amplitude.getInstance().setOptOut(enable);
   * @example: amplitude.setOptOut(true);
   */
  Amplitude.prototype.setOptOut = function setOptOut(enable) {
    this.getInstance().setOptOut(enable);
  };

  /**
   * Regenerates a new random deviceId for current user. Note: this is not recommended unless you know what you
   * are doing. This can be used in conjunction with `setUserId(null)` to anonymize users after they log out.
   * With a null userId and a completely new deviceId, the current user would appear as a brand new user in dashboard.
   * This uses src/uuid.js to regenerate the deviceId.
   * @public
   * @deprecated Please use amplitude.getInstance().regenerateDeviceId();
   */
  Amplitude.prototype.regenerateDeviceId = function regenerateDeviceId() {
    this.getInstance().regenerateDeviceId();
  };

  /**
   * Sets a custom deviceId for current user. Note: this is not recommended unless you know what you are doing
   * (like if you have your own system for managing deviceIds).
   *
   * Make sure the deviceId you set is sufficiently unique
   * (we recommend something like a UUID - see src/uuid.js for an example of how to generate) to prevent conflicts with other devices in our system.
   * @public
   * @param {string} deviceId - custom deviceId for current user.
   * @deprecated Please use amplitude.getInstance().setDeviceId(deviceId);
   * @example amplitude.setDeviceId('45f0954f-eb79-4463-ac8a-233a6f45a8f0');
   */
  Amplitude.prototype.setDeviceId = function setDeviceId(deviceId) {
    this.getInstance().setDeviceId(deviceId);
  };

  /**
   * Sets user properties for the current user.
   * @public
   * @param {object} userProperties - object with string keys and values for the user properties to set.
   * @param {boolean} opt_replace - Deprecated. In earlier versions of the JS SDK the user properties object was kept in
   * memory and replace = true would replace the object in memory. Now the properties are no longer stored in memory, so replace is deprecated.
   * @deprecated Please use amplitude.getInstance().setUserProperties(userProperties);
   * @example amplitude.setUserProperties({'gender': 'female', 'sign_up_complete': true})
   */
  Amplitude.prototype.setUserProperties = function setUserProperties(userProperties) {
    this.getInstance().setUserProperties(userProperties);
  };

  /**
   * Clear all of the user properties for the current user. Note: clearing user properties is irreversible!
   * @public
   * @deprecated Please use amplitude.getInstance().clearUserProperties();
   * @example amplitude.clearUserProperties();
   */
  Amplitude.prototype.clearUserProperties = function clearUserProperties() {
    this.getInstance().clearUserProperties();
  };

  /**
   * Send an identify call containing user property operations to Amplitude servers.
   * See the [Identify](https://amplitude.github.io/Amplitude-JavaScript/Identify/)
   * reference page for more information on the Identify API and user property operations.
   * @param {Identify} identify_obj - the Identify object containing the user property operations to send.
   * @param {Amplitude~eventCallback} opt_callback - (optional) callback function to run when the identify event has been sent.
   * Note: the server response code and response body from the identify event upload are passed to the callback function.
   * @deprecated Please use amplitude.getInstance().identify(identify);
   * @example
   * var identify = new amplitude.Identify().set('colors', ['rose', 'gold']).add('karma', 1).setOnce('sign_up_date', '2016-03-31');
   * amplitude.identify(identify);
   */
  Amplitude.prototype.identify = function (identify_obj, opt_callback) {
    this.getInstance().identify(identify_obj, opt_callback);
  };

  /**
   * Set a versionName for your application.
   * @public
   * @param {string} versionName - The version to set for your application.
   * @deprecated Please use amplitude.getInstance().setVersionName(versionName);
   * @example amplitude.setVersionName('1.12.3');
   */
  Amplitude.prototype.setVersionName = function setVersionName(versionName) {
    this.getInstance().setVersionName(versionName);
  };

  /**
   * This is the callback for logEvent and identify calls. It gets called after the event/identify is uploaded,
   * and the server response code and response body from the upload request are passed to the callback function.
   * @callback Amplitude~eventCallback
   * @param {number} responseCode - Server response code for the event / identify upload request.
   * @param {string} responseBody - Server response body for the event / identify upload request.
   */

  /**
   * Log an event with eventType and eventProperties
   * @public
   * @param {string} eventType - name of event
   * @param {object} eventProperties - (optional) an object with string keys and values for the event properties.
   * @param {Amplitude~eventCallback} opt_callback - (optional) a callback function to run after the event is logged.
   * Note: the server response code and response body from the event upload are passed to the callback function.
   * @deprecated Please use amplitude.getInstance().logEvent(eventType, eventProperties, opt_callback);
   * @example amplitude.logEvent('Clicked Homepage Button', {'finished_flow': false, 'clicks': 15});
   */
  Amplitude.prototype.logEvent = function logEvent(eventType, eventProperties, opt_callback) {
    return this.getInstance().logEvent(eventType, eventProperties, opt_callback);
  };

  /**
   * Log an event with eventType, eventProperties, and groups. Use this to set event-level groups.
   *
   * Note: the group(s) set only apply for the specific event type being logged and does not persist on the user
   * (unless you explicitly set it with setGroup).
   *
   * See the [advanced topics article](https://developers.amplitude.com/docs/javascript#user-groups) for more information
   * about groups and Count by Distinct on the Amplitude platform.
   * @public
   * @param {string} eventType - name of event
   * @param {object} eventProperties - (optional) an object with string keys and values for the event properties.
   * @param {object} groups - (optional) an object with string groupType: groupName values for the event being logged.
   * groupName can be a string or an array of strings.
   * @param {Amplitude~eventCallback} opt_callback - (optional) a callback function to run after the event is logged.
   * Note: the server response code and response body from the event upload are passed to the callback function.
   * @deprecated Please use amplitude.getInstance().logEventWithGroups(eventType, eventProperties, groups, opt_callback);
   * @example amplitude.logEventWithGroups('Clicked Button', null, {'orgId': 24});
   */
  Amplitude.prototype.logEventWithGroups = function (eventType, eventProperties, groups, opt_callback) {
    return this.getInstance().logEventWithGroups(eventType, eventProperties, groups, opt_callback);
  };

  /**
   * Log revenue with Revenue interface. The new revenue interface allows for more revenue fields like
   * revenueType and event properties.
   *
   * See the [Revenue](https://amplitude.github.io/Amplitude-JavaScript/Revenue/)
   * reference page for more information on the Revenue interface and logging revenue.
   * @public
   * @param {Revenue} revenue_obj - the revenue object containing the revenue data being logged.
   * @deprecated Please use amplitude.getInstance().logRevenueV2(revenue_obj);
   * @example var revenue = new amplitude.Revenue().setProductId('productIdentifier').setPrice(10.99);
   * amplitude.logRevenueV2(revenue);
   */
  Amplitude.prototype.logRevenueV2 = function logRevenueV2(revenue_obj) {
    return this.getInstance().logRevenueV2(revenue_obj);
  };

  /**
   * Log revenue event with a price, quantity, and product identifier.
   * @public
   * @param {number} price - price of revenue event
   * @param {number} quantity - (optional) quantity of products in revenue event. If no quantity specified default to 1.
   * @param {string} product - (optional) product identifier
   * @deprecated Please use amplitude.getInstance().logRevenueV2(revenue_obj);
   * @example amplitude.logRevenue(3.99, 1, 'product_1234');
   */
  Amplitude.prototype.logRevenue = function logRevenue(price, quantity, product) {
    return this.getInstance().logRevenue(price, quantity, product);
  };

  /**
   * Remove events in storage with event ids up to and including maxEventId.
   * @private
   */
  Amplitude.prototype.removeEvents = function removeEvents(maxEventId, maxIdentifyId) {
    this.getInstance().removeEvents(maxEventId, maxIdentifyId);
  };

  /**
   * Send unsent events. Note: this is called automatically after events are logged if option batchEvents is false.
   * If batchEvents is true, then events are only sent when batch criterias are met.
   * @private
   * @param {Amplitude~eventCallback} callback - (optional) callback to run after events are sent.
   * Note the server response code and response body are passed to the callback as input arguments.
   */
  Amplitude.prototype.sendEvents = function sendEvents(callback) {
    this.getInstance().sendEvents(callback);
  };

  /**
   * Set global user properties.
   * @public
   * @deprecated Please use amplitudeClient.setUserProperties
   */
  Amplitude.prototype.setGlobalUserProperties = function setGlobalUserProperties(userProperties) {
    this.getInstance().setUserProperties(userProperties);
  };
}

/**
 * Get the current version of Amplitude's Javascript SDK.
 * @public
 * @returns {number} version number
 * @example var amplitudeVersion = amplitude.__VERSION__;
 */
Amplitude.prototype.__VERSION__ = version;

// Entry point
var old = typeof GlobalScope !== 'undefined' && GlobalScope.amplitude || {};
var newInstance = new Amplitude();
newInstance._q = old._q || [];

/**
 * Instantiates Amplitude object and runs all queued function logged by stubbed methods provided by snippets
 * Event queue allows async loading of SDK to not blocking client's app
 */
for (var instance in old._iq) {
  // migrate each instance's queue
  if (Object.prototype.hasOwnProperty.call(old._iq, instance)) {
    newInstance.getInstance(instance)._q = old._iq[instance]._q || [];
  }
}

/**
 * Amplitude 로그를 남깁니다.
 *
 * @param type 이벤트 타입
 * @param data 이벤트 데이터
 */
function logAmplitude(type, data) {
  newInstance.getInstance().logEvent(type, data);
}

function _LogLink(props, ref) {
  const {
    logData,
    amplitudeType,
    amplitudeData = {},
    href,
    to,
    as: LinkComponent = 'a',
    onClick,
    ...linkProps
  } = props;
  const interopHref = href ?? to; // Supports both Next.js and React Router.
  const normalizedHref = interopHref != null ? serializePathToString(interopHref) : interopHref;
  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(LinkComponent, {
    ref: ref,
    onClick: e => {
      if (logData != null) {
        L({
          category: 'click',
          ...logData
        });
      }
      if (amplitudeType != null) {
        logAmplitude(amplitudeType, amplitudeData);
      }
      onClick?.(e);
    },
    href: normalizedHref,
    to: normalizedHref,
    ...linkProps
  });
}

/**
 * A generic logging link component that supports any routing library.
 */
const LogLink = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.forwardRef(_LogLink);

const STATUS_MAPPING = {
  1: 'higher',
  0: 'constant',
  [-1]: 'lower'
};
function mapTrendingKeywordStatus(keyword) {
  if (keyword.isNew) {
    return 'new';
  }
  return STATUS_MAPPING[Math.sign(keyword.diffRank)] ?? 'constant';
}

function _EMOTION_STRINGIFIED_CSS_ERROR__$n() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
function TrendingKeywordsList(props) {
  const {
    className,
    entries,
    historyStorage,
    mode,
    linkComponent,
    baseUrl,
    onEntryClick
  } = props;
  const logDataFragment = {
    section: '인기 검색어 펼침',
    type: 'keyword',
    data: {
      keyword_popular: entries.map(keyword => keyword.displayKeyword)
    }
  };
  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(Container$3, {
    className: className,
    children: (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(ImpressionTracker, {
      logData: logDataFragment,
      children: (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(KeywordEntryList, {
        mode: mode ?? 'grid',
        children: entries.map((keyword, index) => (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(LinkStyled$1, {
          as: linkComponent,
          href: `${baseUrl ?? ''}/search/index?query=${encodeURIComponent(keyword.displayKeyword)}&input_source=integrated&search_affect_type=Issue`,
          onClick: () => {
            historyStorage.append(keyword.displayKeyword);
            onEntryClick?.(keyword, index);
          },
          logData: {
            ...logDataFragment,
            id: keyword.displayKeyword,
            index
          },
          children: (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(KeywordEntry, {
            rank: keyword.rank,
            status: mapTrendingKeywordStatus(keyword),
            title: keyword.displayKeyword
          })
        }, keyword.key))
      })
    })
  });
}
const Container$3 = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)("div",  true ? {
  target: "ekcs1el3"
} : 0)( true ? "" : 0);
const LinkStyled$1 = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(LogLink,  true ? {
  target: "ekcs1el2"
} : 0)("display:block;", ({
  theme
}) => /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_6__/* .css */ .iv)(_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.H`
      background-color: ${theme.background.groupedBase};
    `, ";" + ( true ? "" : 0),  true ? "" : 0), ";" + ( true ? "" : 0));
var _ref$j =  true ? {
  name: "1ety6b1",
  styles: "margin:0 4px;grid-template-columns:repeat(2, 1fr);& * div{margin:8px 12px;}"
} : 0;
const KeywordEntryList = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)("div",  true ? {
  target: "ekcs1el1"
} : 0)("display:grid;", ({
  mode
}) => mode === 'grid' && _ref$j, ";" + ( true ? "" : 0));
const KeywordEntry = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(TrendingKeywordsEntry,  true ? {
  target: "ekcs1el0"
} : 0)( true ? {
  name: "uhy4xz",
  styles: "margin:8px 16px"
} : 0);

function _EMOTION_STRINGIFIED_CSS_ERROR__$m() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
const TRANSITION_DURATION = 400;
const ROLLING_INTERVAL = 1500 + TRANSITION_DURATION;
function _TrendingKeywordsRolling(props, ref) {
  const {
    className,
    entries,
    historyStorage,
    paused,
    linkComponent,
    baseUrl,
    onOpen,
    onMouseEnter,
    onMouseLeave
  } = props;
  const [currentIndex, setCurrentIndex] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(0);
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    if (paused) {
      return;
    }
    const handle = setInterval(() => {
      setCurrentIndex(prevIndex => (prevIndex + 1) % entries.length);
    }, ROLLING_INTERVAL);
    return () => {
      clearInterval(handle);
    };
  }, [entries, paused]);
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    setCurrentIndex(0);
  }, [entries]);
  const logDataFragment = {
    section: '인기 검색어',
    type: 'keyword',
    data: {
      keyword_popular: entries.map(keyword => keyword.displayKeyword)
    }
  };
  const currentKeyword = entries[currentIndex];
  const currentElement = currentKeyword != null ? (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(LinkStyled, {
    as: linkComponent,
    href: `${baseUrl ?? ''}/search/index?query=${encodeURIComponent(currentKeyword.displayKeyword)}&input_source=integrated&search_affect_type=Issue`,
    onClick: () => historyStorage.append(currentKeyword.displayKeyword),
    logData: {
      ...logDataFragment,
      id: currentKeyword.displayKeyword,
      index: currentIndex
    },
    children: (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(TrendingKeywordsEntry, {
      rank: currentKeyword.rank,
      status: mapTrendingKeywordStatus(currentKeyword),
      title: currentKeyword.displayKeyword
    })
  }) : null;
  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(ImpressionTracker, {
    logData: logDataFragment,
    children: (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsxs */ .BX)(Container$2, {
      className: className,
      ref: ref,
      children: [(0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsxs */ .BX)(RollingContainer, {
        children: [(0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(InvisibleSpacingMachine, {
          children: currentElement
        }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(TransitionGroup$1, {
          children: (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(CSSTransition$1, {
            timeout: TRANSITION_DURATION,
            classNames: "item",
            children: (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(TransitionContainer, {
              children: currentElement
            })
          }, currentKeyword?.key)
        })]
      }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(MenuToggleButton$1, {
        type: "button",
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave,
        onClick: () => onOpen(),
        children: (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(_bucketplace_design_system_bds__WEBPACK_IMPORTED_MODULE_8__/* .Icon */ .JO$, {
          size: 18,
          name: "chevron_down"
        })
      })]
    })
  });
}
const TrendingKeywordsRolling = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.forwardRef(_TrendingKeywordsRolling);
const Container$2 = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)("div",  true ? {
  target: "e1nb0uji5"
} : 0)( true ? {
  name: "ga3b11",
  styles: "display:flex;align-items:center;justify-content:space-between;width:100%"
} : 0);
const RollingContainer = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)("div",  true ? {
  target: "e1nb0uji4"
} : 0)( true ? {
  name: "s0wc5p",
  styles: "position:relative;margin-right:6px;overflow:hidden"
} : 0);
const MenuToggleButton$1 = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)("button",  true ? {
  target: "e1nb0uji3"
} : 0)(_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.R, ";padding:6px;>span{display:block;color:", ({
  theme
}) => theme.content.base2, ";}" + ( true ? "" : 0));
const InvisibleSpacingMachine = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)("div",  true ? {
  target: "e1nb0uji2"
} : 0)( true ? {
  name: "6dhm9o",
  styles: "visibility:hidden"
} : 0);
const TransitionContainer = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)("div",  true ? {
  target: "e1nb0uji1"
} : 0)("position:absolute;top:0;left:0;&.item-enter{transform:translateY(24px);opacity:0;}&.item-enter-active{opacity:1;transform:translateY(0);transition:opacity ", TRANSITION_DURATION, "ms cubic-bezier(0.25, 0.1, 0.25, 1),transform ", TRANSITION_DURATION, "ms cubic-bezier(0.25, 0.1, 0.25, 1);}&.item-exit{transform:translateY(0);opacity:1;}&.item-exit-active{transform:translateY(-24px);opacity:0;transition:opacity ", TRANSITION_DURATION, "ms cubic-bezier(0.25, 0.1, 0.25, 1),transform ", TRANSITION_DURATION, "ms cubic-bezier(0.25, 0.1, 0.25, 1);}" + ( true ? "" : 0));
const LinkStyled = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(LogLink,  true ? {
  target: "e1nb0uji0"
} : 0)( true ? {
  name: "4zleql",
  styles: "display:block"
} : 0);

function useToggle(options = {}) {
  const [open, setOpen] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(options.open ?? false);
  const handleOpen = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(() => setOpen(true), []);
  const handleClose = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(() => setOpen(false), []);
  const handleToggle = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(flag => {
    setOpen(prevState => flag ?? !prevState);
  }, []);
  return {
    open,
    handleOpen,
    handleClose,
    handleToggle
  };
}

function _EMOTION_STRINGIFIED_CSS_ERROR__$l() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
function TrendingKeywordsDropdown(props) {
  const {
    className,
    entries,
    historyStorage,
    linkComponent,
    baseUrl
  } = props;
  const {
    open: dropdownOpened,
    handleOpen,
    handleClose
  } = useToggle({
    open: false
  });
  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(Container$1, {
    className: className,
    children: (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(DropdownPopper, {
      placement: "bottom-end",
      isForceClosed: !dropdownOpened,
      renderButton: ({
        onClick
      }) => (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(TrendingKeywordsRolling, {
        entries: entries,
        paused: dropdownOpened,
        historyStorage: historyStorage,
        linkComponent: linkComponent,
        baseUrl: baseUrl,
        onOpen: () => {
          onClick();
          handleOpen();
        }
      }),
      children: (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsxs */ .BX)(DropdownListPanel, {
        children: [(0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsxs */ .BX)(DropdownListHeader, {
          children: [(0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(DropdownListHeaderTitle, {
            children: "\uC778\uAE30 \uAC80\uC0C9\uC5B4"
          }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(MenuToggleButton, {
            type: "button",
            onClick: () => {
              L({
                category: 'click',
                section: '인기 검색어 닫힘'
              });
              handleClose();
            },
            children: (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(_bucketplace_design_system_bds__WEBPACK_IMPORTED_MODULE_8__/* .Icon */ .JO$, {
              size: 18,
              name: "chevron_down"
            })
          })]
        }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(TrendingKeywordsList, {
          mode: "list",
          entries: entries,
          historyStorage: historyStorage,
          baseUrl: baseUrl,
          onEntryClick: handleClose
        })]
      })
    })
  });
}
const Container$1 = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)("div",  true ? {
  target: "eft3pbw5"
} : 0)( true ? {
  name: "bjn8wh",
  styles: "position:relative"
} : 0);
const DropdownPopper = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_bucketplace_design_system_bds__WEBPACK_IMPORTED_MODULE_8__/* .Popper */ .rDy,  true ? {
  target: "eft3pbw4"
} : 0)( true ? {
  name: "1iqaq9l",
  styles: "z-index:10000;&&>.popper-item{transform:translate3d(24px, -70px, 0);}"
} : 0);
const DropdownListPanel = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)("div",  true ? {
  target: "eft3pbw3"
} : 0)("width:268px;background:", ({
  theme
}) => theme.background.base, ";padding:20px 0;" + ( true ? "" : 0));
const DropdownListHeader = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)("header",  true ? {
  target: "eft3pbw2"
} : 0)( true ? {
  name: "mnvjsq",
  styles: "display:flex;align-items:center;justify-content:space-between;margin:0 16px 8px"
} : 0);
const DropdownListHeaderTitle = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)("h2",  true ? {
  target: "eft3pbw1"
} : 0)(_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.F.title3, ";font-style:normal;font-weight:700;color:", ({
  theme
}) => theme.content.base1, ";" + ( true ? "" : 0));
const MenuToggleButton = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)("button",  true ? {
  target: "eft3pbw0"
} : 0)(_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.R, ";padding:6px;>span{display:block;color:", ({
  theme
}) => theme.content.base2, ";transform:rotate(180deg);}" + ( true ? "" : 0));

const useFollow = ({
  id,
  userId,
  isInitialFollowing = false,
  initialFollowCount = 0,
  onRedirectToSignIn,
  requestFollow,
  requestUnfollow,
  onFollow,
  onUnfollow,
  snackbarPlacement = 'basic',
  logData = {}
}) => {
  const snackbar = useSnackbar();
  const [pending, setPending] = useState(false);
  const [isFollowing, setIsFollowing] = useState(isInitialFollowing);
  const [count, setCount] = useState(initialFollowCount);
  const dispatchWebviewEvent = useWebviewEventDispatcher();
  const logFollow = () => {
    L({
      category: 'follow',
      type: 'user',
      id,
      ...logData
    });
  };
  const logUnfollow = () => {
    L({
      category: 'unfollow',
      type: 'user',
      id,
      ...logData
    });
  };
  const sendEventToWebview = eventType => {
    if (eventType === 'follow') {
      dispatchWebviewEvent({
        type: 'follow',
        contentType: 'User',
        contentId: id,
        performed: true,
        count: count + 1
      });
      return;
    }
    dispatchWebviewEvent({
      type: 'follow',
      contentType: 'User',
      contentId: id,
      performed: false,
      count: count - 1
    });
  };
  const handleFollow = async () => {
    if (!userId) {
      onRedirectToSignIn();
      return;
    }
    if (pending) {
      return;
    }
    setPending(true);
    try {
      const response = await requestFollow({
        userId: id
      });
      if (response.success) {
        setIsFollowing(true);
        setCount(count => count + 1);
        logFollow();
        sendEventToWebview('follow');
        onFollow?.();
      } else {
        snackbar.open({
          content: '팔로우 도중 문제가 발생하였습니다. 잠시 후 다시 시도해 주세요.',
          placement: snackbarPlacement
        });
      }
    } catch (error) {
      snackbar.open({
        content: '팔로우 도중 문제가 발생하였습니다. 잠시 후 다시 시도해 주세요.',
        placement: snackbarPlacement
      });
    } finally {
      setPending(false);
    }
  };
  const handleUnfollow = async () => {
    if (!userId) {
      onRedirectToSignIn();
      return;
    }
    if (pending) {
      return;
    }
    setPending(true);
    try {
      const response = await requestUnfollow({
        userId: id
      });
      if (response.success) {
        setIsFollowing(false);
        setCount(count => count - 1);
        logUnfollow();
        sendEventToWebview('unfollow');
        onUnfollow?.();
      } else {
        snackbar.open({
          content: '언팔로우 도중 문제가 발생하였습니다. 잠시 후 다시 시도해 주세요.',
          placement: snackbarPlacement
        });
      }
    } catch (error) {
      snackbar.open({
        content: '언팔로우 도중 문제가 발생하였습니다. 잠시 후 다시 시도해 주세요.',
        placement: snackbarPlacement
      });
    } finally {
      setPending(false);
    }
  };
  const handleToggleFollow = () => {
    if (isFollowing) {
      handleUnfollow();
      return;
    }
    handleFollow();
  };
  useWebviewEventListener('follow', event => {
    if (event.contentId !== id) {
      return;
    }
    setIsFollowing(event.performed);
    setCount(event.count);
    setPending(false);
  });
  return {
    follow: handleFollow,
    unfollow: handleUnfollow,
    toggle: handleToggleFollow,
    isFollowing,
    count,
    pending,
    isMe: id === userId
  };
};

const Follow = ({
  children,
  ...followProps
}) => {
  const followData = useFollow(followProps);
  return jsx(Fragment$1, {
    children: children(followData)
  });
};

const LinkContext = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)('a');
const useLinkContext = () => (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(LinkContext);
function LinkProvider({
  children,
  linkComponent
}) {
  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(LinkContext.Provider, {
    value: linkComponent,
    children: children
  });
}

const LogContext = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)(() => {/* noop */});
const useLogContext = () => (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(LogContext);
function LogProvider({
  children,
  onLog
}) {
  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(LogContext.Provider, {
    value: onLog,
    children: children
  });
}

const GNBDataContext = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)(null);
function GNBDataProvider({
  children,
  value
}) {
  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(GNBDataContext.Provider, {
    value: value,
    children: children
  });
}
function useGNBData() {
  const value = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(GNBDataContext);
  if (value === null) {
    throw new Error('The useLocaleData must be used within a LocaleDataContext');
  }
  return value;
}

var _path$3, _path2$3;
function _extends$4() { return _extends$4 = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$4.apply(null, arguments); }
var SvgIcNew18 = function SvgIcNew18(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends$4({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _path$3 || (_path$3 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: "#fff",
    d: "M0 9a9 9 0 1 1 18 0A9 9 0 0 1 0 9"
  })), _path2$3 || (_path2$3 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: "#F77",
    fillRule: "evenodd",
    d: "M9 18A9 9 0 1 0 9 0a9 9 0 0 0 0 18m-1.7-5.25H5.26v-7.5h2.61l2.8 4.2h.03v-4.2h2.06v7.5h-2.3l-3.1-4.68h-.05v4.68z",
    clipRule: "evenodd"
  })));
};
var NewIcon = SvgIcNew18;

function _EMOTION_STRINGIFIED_CSS_ERROR__$k() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
var _ref$i =  true ? {
  name: "d3v9zr",
  styles: "overflow:hidden"
} : 0;
function NavigationDrawerMenuAccordion({
  children,
  isExpanded,
  onTransitionStart,
  onTransitionEnd
}) {
  const container = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
  const content = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
  const isExpanding = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(false);
  const isCollapsing = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(false);
  const expand = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(() => {
    if (!container.current || !content.current) {
      return;
    }
    if (isExpanding.current) {
      return;
    }
    if (isCollapsing.current) {
      return;
    }
    isExpanding.current = true;
    container.current.style.display = 'block';
    container.current.style.height = `${content.current.clientHeight}px`;
    onTransitionStart();
  }, [onTransitionStart]);
  const collapse = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(() => {
    if (!container.current || !content.current) {
      return;
    }
    if (isExpanding.current) {
      return;
    }
    if (isCollapsing.current) {
      return;
    }
    isCollapsing.current = true;
    container.current.style.height = `${content.current.clientHeight}px`;
    setTimeout(() => {
      if (!container.current) {
        return;
      }
      container.current.style.height = '0px';
      onTransitionStart();
    }, 50);
  }, [onTransitionStart]);
  const handleTransitionEnd = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(() => {
    if (!container.current || !content.current) {
      return;
    }
    if (isExpanding.current) {
      container.current.style.height = 'auto';
      isExpanding.current = false;
    } else if (isCollapsing.current) {
      container.current.style.display = 'none';
      isCollapsing.current = false;
    }
    onTransitionEnd();
  }, [onTransitionEnd]);
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    if (!container.current) {
      return;
    }
    if (!container.current.style.transition) {
      return;
    }
    (isExpanded ? expand : collapse)();
  }, [isExpanded, expand, collapse]);
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    if (!container.current) {
      return;
    }
    container.current.style.height = isExpanded ? 'auto' : '0px';
    container.current.style.display = isExpanded ? 'block' : 'none';
    setTimeout(() => {
      if (!container.current) {
        return;
      }
      container.current.style.transition = 'height .3s';
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)("div", {
    ref: container,
    css: _ref$i,
    onTransitionEnd: handleTransitionEnd,
    children: (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)("div", {
      ref: content,
      children: children
    })
  });
}

function _EMOTION_STRINGIFIED_CSS_ERROR__$j() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
var _ref3$2 =  true ? {
  name: "1hcx8jb",
  styles: "padding:0"
} : 0;
function NavigationDrawerMenu({
  items,
  indents,
  fontStyles,
  onClose
}) {
  const [expandedIndex, setExpandedIndex] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(() => items.findIndex(item => item.active));
  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)("ul", {
    css: _ref3$2,
    children: items.map((item, index) => (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(NavigationDrawerMenuItem, {
      title: item.title,
      icon: item.icon,
      bullet: item.bullet,
      href: item.href,
      isActive: item.active,
      items: item.entries,
      renderChild: item.renderDrawerChild,
      indents: indents,
      fontStyles: fontStyles,
      isExpanded: index === expandedIndex,
      onExpand: () => setExpandedIndex(index),
      onCollapse: () => setExpandedIndex(-1),
      onClick: () => {
        item.onClick?.({
          item,
          index
        });
        if (!item.entries) {
          onClose?.();
        }
      },
      onClose: onClose
    }, index))
  });
}
var _ref$h =  true ? {
  name: "1r7xtnv",
  styles: "margin-left:1.5px"
} : 0;
var _ref2$5 =  true ? {
  name: "6103ef",
  styles: "display:flex;flex-wrap:wrap;align-items:center;width:100%;height:100%;line-height:1"
} : 0;
function NavigationDrawerMenuItem({
  title,
  icon,
  href,
  bullet,
  items,
  indents = [],
  fontStyles = [],
  isActive,
  isExpanded,
  onExpand,
  onCollapse,
  renderChild,
  onClick,
  onClose
}) {
  const theme = (0,_emotion_react__WEBPACK_IMPORTED_MODULE_13__.u)();
  const Link = useLinkContext();
  const isAccordionTransitioning = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(false);
  const handleAccordionTransitionStart = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(() => {
    isAccordionTransitioning.current = true;
  }, []);
  const handleAccordionTransitionEnd = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(() => {
    isAccordionTransitioning.current = false;
  }, []);
  const handleAccordionToggle = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(() => {
    if (isAccordionTransitioning.current) {
      return;
    }
    (isExpanded ? onCollapse : onExpand)();
  }, [isExpanded, onCollapse, onExpand]);
  const renderTitle = () => {
    return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsxs */ .BX)("div", {
      css: _ref2$5,
      children: [icon && (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)("span", {
        css: /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_6__/* .css */ .iv)("display:inline-block;margin-right:", (0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.p)(8), ";border-radius:", (0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.p)(4), ";" + ( true ? "" : 0),  true ? "" : 0),
        children: icon
      }), title, bullet === 'new' && (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(NewIcon, {
        css: _ref$h
      })]
    });
  };
  const [indent] = indents;
  const [fontStyle = {}] = fontStyles;
  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)("li", {
    css: /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_6__/* .css */ .iv)("margin:", (0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.p)(4), " 0 0;padding:0;font-size:", (0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.p)(fontStyle.size || 14), ";font-weight:", isActive ? 'bold' : fontStyle.weight || 'normal', ";color:", fontStyle.color || theme.content.base1, ";" + ( true ? "" : 0),  true ? "" : 0),
    children: items && items.length || renderChild ? (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsxs */ .BX)(_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .Fragment */ .HY, {
      children: [(0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsxs */ .BX)("button", {
        type: "button",
        onClick: () => {
          handleAccordionToggle();
          onClick?.();
        },
        css: /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_6__/* .css */ .iv)(_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.R, " overflow:hidden;position:relative;display:block;width:100%;height:", (0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.p)(40), ";margin:0;padding:0 ", (0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.p)(40), " 0 ", (0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.p)(indent || 14), ";color:inherit;text-align:left;text-overflow:ellipsis;white-space:nowrap;box-sizing:border-box;outline:none;border-radius:4px;", isActive ? /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_6__/* .css */ .iv)("background-color:", theme.interactive.transparent, ";", _bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.H`
                      background-color: ${theme.content.base5};
                    `, ";" + ( true ? "" : 0),  true ? "" : 0) : _bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.H`
                    background-color: ${theme.content.base5};
                  `, ";" + ( true ? "" : 0),  true ? "" : 0),
        children: [renderTitle(), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(_bucketplace_design_system_bds__WEBPACK_IMPORTED_MODULE_8__/* .Icon */ .JO$, {
          size: 12,
          name: isExpanded ? 'chevron_thick_up' : 'chevron_thick_down',
          css: /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_6__/* .css */ .iv)("position:absolute;top:", (0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.p)(14), ";right:", (0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.p)(14), ";color:", theme.content.base1, ";" + ( true ? "" : 0),  true ? "" : 0)
        })]
      }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(NavigationDrawerMenuAccordion, {
        isExpanded: isExpanded,
        onTransitionStart: handleAccordionTransitionStart,
        onTransitionEnd: handleAccordionTransitionEnd,
        children: items && (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(NavigationDrawerMenu, {
          items: items,
          fontStyles: fontStyles.slice(1),
          indents: indents.length > 1 ? indents.slice(1) : indents.slice(-1),
          onClose: onClose
        }) || renderChild && renderChild()
      })]
    }) : (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(Link, {
      href: href,
      onClick: onClick,
      css: /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_6__/* .css */ .iv)("overflow:hidden;display:block;width:100%;height:", (0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.p)(40), ";padding:0 ", (0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.p)(14), " 0 ", (0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.p)(indent || 14), ";color:inherit;text-overflow:ellipsis;white-space:nowrap;box-sizing:border-box;outline:none;border-radius:4px;", isActive ? /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_6__/* .css */ .iv)("background-color:", theme.interactive.transparent, ";", _bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.H`
                  background-color: ${theme.content.base5};
                `, ";" + ( true ? "" : 0),  true ? "" : 0) : _bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.H`
                background-color: ${theme.content.base5};
              `, ";" + ( true ? "" : 0),  true ? "" : 0),
      children: renderTitle()
    })
  });
}

var _path$2, _path2$2, _path3, _path4, _path5;
function _extends$3() { return _extends$3 = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$3.apply(null, arguments); }
var SvgLogo = function SvgLogo(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends$3({
    xmlns: "http://www.w3.org/2000/svg",
    width: 71,
    height: 28,
    fill: "none"
  }, props), _path$2 || (_path$2 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: "#2F3438",
    d: "M19.711 7.307h10.226c.759 0 1.374-.606 1.374-1.355s-.615-1.356-1.374-1.356h-8.852v-3.24C21.085.607 20.47 0 19.71 0c-.759 0-1.374.607-1.374 1.356v4.596c0 .749.615 1.355 1.374 1.355Z"
  })), _path2$2 || (_path2$2 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M13.804 8.877c0 4.711-2.261 7.638-5.9 7.638s-5.901-2.927-5.901-7.638V8.54c0-4.711 2.26-7.638 5.9-7.638s5.9 2.927 5.9 7.638zm-5.9-5.264c-1.178 0-3.153.64-3.153 4.927v.337c0 4.287 1.975 4.927 3.152 4.927s3.153-.64 3.153-4.927V8.54c0-4.287-1.975-4.927-3.153-4.927Z",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: "#2F3438",
    d: "M9.278 23.496h4.655c.76 0 1.374.607 1.374 1.356 0 .748-.615 1.355-1.374 1.355H1.873A1.365 1.365 0 0 1 .5 24.852c0-.75.615-1.356 1.374-1.356H6.53v-4.173c0-.748.615-1.355 1.374-1.355.758 0 1.374.607 1.374 1.355zm22.79-13.84H17.343c-.759 0-1.373.607-1.373 1.355 0 .75.614 1.356 1.373 1.356h14.725c.76 0 1.374-.607 1.374-1.356 0-.748-.615-1.355-1.374-1.355M21.009 24.362c.654.499 2.897 1.475 9.59-.24a1.376 1.376 0 0 1 1.675.97 1.354 1.354 0 0 1-.984 1.653c-2.745.704-5.095 1.055-7.035 1.056-2.15 0-3.797-.432-4.927-1.294-1.103-.843-1.686-2.063-1.686-3.532v-2.163c0-.748.614-1.356 1.373-1.356h9.703v-2.03h-9.703a1.365 1.365 0 0 1-1.373-1.355c0-.749.614-1.356 1.373-1.356h11.077c.759 0 1.373.607 1.373 1.356v4.741c0 .749-.614 1.356-1.373 1.356h-9.703v.807c0 .632.191 1.06.62 1.387M68.135 0a1.41 1.41 0 0 0-1.419 1.4v11.2c0 .773.636 1.4 1.42 1.4a1.41 1.41 0 0 0 1.418-1.4V1.4c0-.773-.635-1.4-1.419-1.4m-6.624 12.39a1.374 1.374 0 0 0 1.759.808 1.35 1.35 0 0 0 .823-1.737c-.045-.12-.944-2.5-3.191-4.195l3.49-3.83c.362-.398.454-.97.233-1.458a1.38 1.38 0 0 0-1.255-.804h-8.56c-.759 0-1.374.607-1.374 1.356 0 .748.615 1.355 1.374 1.355h5.477l-6.499 7.132a1.34 1.34 0 0 0 .103 1.914c.263.233.591.348.919.348.376 0 .75-.152 1.022-.45l3.224-3.538c1.706 1.19 2.437 3.054 2.454 3.1Z"
  })), _path4 || (_path4 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M67.072 17.362c0-.749.615-1.356 1.374-1.356s1.374.607 1.374 1.356v6.627c0 1.914-1.579 3.471-3.519 3.471h-6.634c-1.94 0-3.519-1.557-3.519-3.471v-6.627c0-.749.615-1.356 1.374-1.356s1.374.607 1.374 1.356v2.095h8.176zm-7.405 7.387h6.634c.425 0 .771-.34.771-.76v-1.821h-8.176v1.82c0 .42.346.761.771.761m-18.999-8.935c1.664 0 3.052-.87 3.91-2.452.678-1.252 1.037-2.982 1.037-5.004s-.359-3.752-1.038-5.004C43.72 1.772 42.332.902 40.668.902s-3.052.87-3.91 2.452c-.678 1.252-1.037 2.982-1.037 5.004s.359 3.752 1.038 5.004c.857 1.581 2.245 2.452 3.909 2.452m0-12.201c2.093 0 2.2 3.952 2.2 4.745 0 .792-.107 4.745-2.2 4.745s-2.2-3.953-2.2-4.745.106-4.745 2.2-4.745",
    clipRule: "evenodd"
  })), _path5 || (_path5 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: "#2F3438",
    d: "M47.746 1.81c0-.748.615-1.355 1.374-1.355s1.374.607 1.374 1.356V25.73c0 .749-.615 1.355-1.374 1.355a1.365 1.365 0 0 1-1.374-1.355v-4.514c-2.992.733-7.314.95-9.812.95h-2.091a1.365 1.365 0 0 1-1.374-1.355c0-.749.615-1.356 1.374-1.356h2.091c4.378 0 7.991-.493 9.812-1.052z"
  })));
};
var LogoIcon = SvgLogo;

function _EMOTION_STRINGIFIED_CSS_ERROR__$i() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
var _ref$g =  true ? {
  name: "40f4ru",
  styles: "vertical-align:top"
} : 0;
function Logo({
  logo,
  children,
  ...rest
}) {
  const theme = (0,_emotion_react__WEBPACK_IMPORTED_MODULE_13__.u)();
  const Link = useLinkContext();
  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(Link, {
    ...rest,
    href: logo?.href || 'https://ohou.se',
    "aria-label": "\uC624\uB298\uC758\uC9D1 \uB85C\uACE0",
    css: [/*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_6__/* .css */ .iv)(_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.R, " display:inline-flex;align-items:center;margin:", (0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.p)(-4), ";padding:", (0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.p)(4), ";font-size:0;line-height:0;color:", theme.interactive.base1, ";outline:none;" + ( true ? "" : 0),  true ? "" : 0), _bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.g`
          box-shadow: 0 0 0 ${(0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.p)(3)} ${theme.interactive.primary1.thin};
          border-radius: ${(0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.p)(3)};
        `,  true ? "" : 0,  true ? "" : 0],
    children: children || logo?.item || (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(LogoIcon, {
      css: _ref$g
    })
  });
}

function _EMOTION_STRINGIFIED_CSS_ERROR__$h() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
var _ref$f =  true ? {
  name: "1200b05",
  styles: "position:absolute;top:0;right:0;display:flex;align-items:center;outline:none"
} : 0;
function NavigationDrawerHeader({
  logo,
  action,
  supplementary
}) {
  const log = useLogContext();
  const {
    userProfile,
    signup,
    signin
  } = supplementary;
  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsxs */ .BX)(_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .Fragment */ .HY, {
    children: [(0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsxs */ .BX)("div", {
      css: /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_6__/* .css */ .iv)("position:relative;font-size:", (0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.p)(14), ";line-height:", (0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.p)(18), ";" + ( true ? "" : 0),  true ? "" : 0),
      children: [(0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(Logo, {
        ...logo,
        onClick: () => log({
          key: 'drawer.logo',
          category: 'click'
        })
      }), action && (({
        text,
        ...rest
      }) => (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsxs */ .BX)(_bucketplace_design_system_bds__WEBPACK_IMPORTED_MODULE_8__/* .TextButton */ .Avr, {
        ...rest,
        size: 32,
        variant: "primary1",
        css: _ref$f,
        children: [text, (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(_bucketplace_design_system_bds__WEBPACK_IMPORTED_MODULE_8__/* .Icon */ .JO$, {
          name: "chevron_right",
          size: 12,
          fill: theme => theme.content.primary1.basic,
          css: /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_6__/* .css */ .iv)("margin-left:", (0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.p)(4), ";" + ( true ? "" : 0),  true ? "" : 0)
        })]
      }))(action)]
    }), userProfile == null ? (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsxs */ .BX)("div", {
      css: /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_6__/* .css */ .iv)("display:flex;justify-content:space-between;width:100%;margin:", (0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.p)(20), " 0 ", (0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.p)(10), ";" + ( true ? "" : 0),  true ? "" : 0),
      children: [signin && (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(_bucketplace_design_system_bds__WEBPACK_IMPORTED_MODULE_8__/* .OutlineAnchorButton */ .Ths, {
        href: signin.href,
        size: 44,
        variant: "primary1",
        onClick: () => {
          // to signIn page
        },
        css: /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_6__/* .css */ .iv)("font-weight:bold;outline:none;display:flex;flex:1;justify-content:center;align-items:center;height:", (0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.p)(42), ";" + ( true ? "" : 0),  true ? "" : 0),
        children: signin.title
      }), signup && (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(_bucketplace_design_system_bds__WEBPACK_IMPORTED_MODULE_8__/* .AnchorButton */ .ANg, {
        href: signup.href,
        size: 44,
        variant: "primary1",
        onClick: () => {
          // to signUp page
        },
        css: /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_6__/* .css */ .iv)("margin-left:", (0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.p)(8), ";font-weight:bold;outline:none;display:flex;flex:1;justify-content:center;align-items:center;" + ( true ? "" : 0),  true ? "" : 0),
        children: signup.title
      })]
    }) : (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsxs */ .BX)("div", {
      css: /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_6__/* .css */ .iv)("display:flex;align-items:center;margin:", (0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.p)(24), " 0 ", (0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.p)(20), ";" + ( true ? "" : 0),  true ? "" : 0),
      children: [(0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(_bucketplace_design_system_bds__WEBPACK_IMPORTED_MODULE_8__/* .Avatar */ .qEK, {
        "aria-label": "drawer \uC720\uC800 \uD504\uB85C\uD544 \uC774\uBBF8\uC9C0",
        size: 20,
        src: userProfile.imageUrl
      }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)("p", {
        css: /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_6__/* .css */ .iv)("font-size:", (0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.p)(14), ";line-height:", (0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.p)(20), ";margin-left:", (0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.p)(4), ";" + ( true ? "" : 0),  true ? "" : 0),
        children: userProfile.nickname
      })]
    })]
  });
}

function NavigationDrawerFooterListItem({
  title,
  href,
  onClick,
  onClose
}) {
  const theme = (0,_emotion_react__WEBPACK_IMPORTED_MODULE_13__.u)();
  const LinkComponent = useLinkContext();
  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)("li", {
    css: [/*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_6__/* .css */ .iv)("display:inline-block;padding:", (0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.p)(6), ";border-radius:", (0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.p)(4), ";margin:0 0 0 ", (0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.p)(7), ";line-height:", (0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.p)(18), ";&:first-of-type{margin:0;}" + ( true ? "" : 0),  true ? "" : 0), _bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.H`
        background-color: ${theme.background.groupedBase};
      `,  true ? "" : 0,  true ? "" : 0],
    children: href != null ? (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(LinkComponent, {
      href: href,
      css: /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_6__/* .css */ .iv)(_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.F.subTitle2, " outline:none;vertical-align:middle;white-space:nowrap;" + ( true ? "" : 0),  true ? "" : 0),
      onClick: onClose,
      children: title
    }) : (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)("button", {
      css: /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_6__/* .css */ .iv)(_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.R, " ", _bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.F.subTitle2, " color:", theme.content.base1, ";outline:none;cursor:pointer;vertical-align:middle;white-space:nowrap;" + ( true ? "" : 0),  true ? "" : 0),
      onClick: onClick,
      type: "button",
      children: title
    })
  });
}
function NavigationDrawerFooter({
  items,
  onClose
}) {
  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)("ul", {
    css: /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_6__/* .css */ .iv)("padding:0;margin-top:", (0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.p)(14), ";display:flex;align-items:center;>button{font-size:", (0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.p)(14), ";font-weight:normal;}" + ( true ? "" : 0),  true ? "" : 0),
    children: items.map((item, index) => (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(NavigationDrawerFooterListItem, {
      onClose: onClose,
      ...item
    }, index))
  });
}

function NavigationDrawer({
  open,
  logo,
  menuSchema,
  supplementary,
  onClose,
  onAppDownload,
  ...rest
}) {
  const {
    userMenu,
    showAppDownloadButton = true
  } = supplementary;
  const log = useLogContext();
  const {
    localeData
  } = useGNBData();
  const drawerMenu = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(() => menuSchema.map(mainMenu => ({
    ...mainMenu,
    onClick: ({
      index
    }) => {
      log({
        key: 'drawer.main.item',
        category: 'click',
        params: {
          index
        }
      });
    },
    entries: mainMenu.entries?.map(subMenu => ({
      ...subMenu,
      onClick: ({
        item: {
          href
        },
        index
      }) => {
        log({
          key: 'drawer.sub.item',
          category: 'click',
          params: {
            index,
            href
          }
        });
      }
    }))
  })), [menuSchema, log]);
  const drawerUserMenu = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(() => userMenu.filter(menu => menu.showOn?.includes('drawer')).map(({
    title,
    href,
    bullet
  }) => ({
    title,
    href,
    bullet,
    onClick: ({
      index
    }) => {
      log({
        key: 'drawer.user.item',
        category: 'click',
        params: {
          index
        }
      });
    }
  })), [userMenu, log]);
  const drawerFooterMenu = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(() => userMenu.filter(menu => menu.type === 'bottom'), [userMenu]);
  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsxs */ .BX)(_bucketplace_design_system_bds__WEBPACK_IMPORTED_MODULE_8__/* .Drawer */ .dys, {
    open: open,
    width: 270,
    onClose: onClose,
    ...rest,
    children: [(0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(NavigationDrawerHeader, {
      logo: {
        logo,
        onClick: () => window.open(logo?.href || 'https://ohou.se')
      },
      action: showAppDownloadButton ? {
        text: localeData?.appDownload ?? '앱다운로드',
        onClick: () => {
          log({
            key: 'drawer.user.profile',
            category: 'click'
          });
          onAppDownload?.();
        }
      } : undefined,
      supplementary: supplementary
    }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(NavigationDrawerDivider, {
      variant: "thin"
    }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(NavigationDrawerMenu, {
      items: drawerMenu,
      fontStyles: [{
        size: 16,
        weight: 'bold'
      }],
      indents: [14, 42, 50],
      onClose: onClose
    }), drawerUserMenu.length > 0 && (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(NavigationDrawerDivider, {
      variant: "thin"
    }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(NavigationDrawerMenu, {
      items: drawerUserMenu,
      onClose: onClose
    }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(NavigationDrawerDivider, {
      variant: "thin"
    }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(NavigationDrawerFooter, {
      items: drawerFooterMenu,
      onClose: onClose
    })]
  });
}
const NavigationDrawerDivider = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_bucketplace_design_system_bds__WEBPACK_IMPORTED_MODULE_8__/* .Divider */ .izJ,  true ? {
  target: "e1thtjjz0"
} : 0)("margin:", (0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.p)(20), " 0;" + ( true ? "" : 0));

function getActiveIds(menuSchema, fallbackMenuSchema) {
  // Check for fallback menu schema first
  if (fallbackMenuSchema != null) {
    const index = fallbackMenuSchema.findIndex(item => item.active);
    if (index !== -1) {
      return [null, index];
    }
  }
  // Try to descend down to the matching entry
  for (let i = 0; i < menuSchema.length; i += 1) {
    const child = menuSchema[i];
    const childActiveIds = getActiveIdsEntry(child);
    // If the child has 'active' entry, merge all indices
    if (childActiveIds != null) {
      return [i, ...childActiveIds];
    }
  }
  // Nothing matched
  return [null];
}
function getActiveIdsEntry(entry) {
  if (entry.entries != null) {
    for (let i = 0; i < entry.entries.length; i += 1) {
      const child = entry.entries[i];
      const childActiveIds = getActiveIdsEntry(child);
      // If the child has 'active' entry, merge all indices
      if (childActiveIds != null) {
        return [i, ...childActiveIds];
      }
    }
  }
  if (entry.active) {
    // If the entry itself is active, return itself
    return [];
  }
  // Otherwise, it didn't match
  return null;
}

function useHover(onHover) {
  const onHoverRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(onHover);
  onHoverRef.current = onHover;
  const timeoutRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
  const handleMouseTimeout = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(() => {
    onHoverRef.current();
    timeoutRef.current = null;
  }, []);
  const handleMouseMove = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(() => {
    if (timeoutRef.current != null) {
      window.clearTimeout(timeoutRef.current);
    }
    timeoutRef.current = window.setTimeout(handleMouseTimeout, 50);
  }, [handleMouseTimeout]);
  const handleMouseEnter = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(() => {
    window.addEventListener('mousemove', handleMouseMove);
    if (timeoutRef.current != null) {
      window.clearTimeout(timeoutRef.current);
    }
    timeoutRef.current = window.setTimeout(handleMouseTimeout, 50);
  }, [handleMouseTimeout, handleMouseMove]);
  const handleMouseLeave = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(() => {
    window.removeEventListener('mousemove', handleMouseMove);
    if (timeoutRef.current != null) {
      window.clearTimeout(timeoutRef.current);
      timeoutRef.current = null;
    }
  }, [handleMouseMove]);
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    return () => {
      window.removeEventListener('mousemove', handleMouseMove);
      if (timeoutRef.current != null) {
        window.clearTimeout(timeoutRef.current);
      }
    };
  }, [handleMouseMove]);
  return [handleMouseEnter, handleMouseLeave];
}

function NavigationBarPrimaryTabItem(props) {
  const {
    component = 'button',
    index,
    isActive,
    isOpen,
    children,
    onSelect,
    forwardedRef,
    onClick,
    ...rest
  } = props;
  const theme = (0,_emotion_react__WEBPACK_IMPORTED_MODULE_13__.u)();
  const log = useLogContext();
  const handleClick = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(e => {
    if (onClick) {
      onClick(e);
    }
    log({
      key: 'primary.item',
      category: 'click',
      params: {
        index
      }
    });
  }, [log, onClick, index]);
  const [handleMouseEnter, handleMouseLeave] = useHover(onSelect);
  const Component = component;
  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(Component, {
    "data-testid": "navigation-primary-tab-item",
    css: [/*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_6__/* .css */ .iv)(_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.R, " position:relative;display:inline-block;margin:0 ", (0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.p)(10), ";padding:", (0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.p)(21), " ", (0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.p)(5), " ", (0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.p)(15), ";font-size:", (0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.p)(18), ";line-height:1;font-weight:bold;color:", theme.content.base1, ";outline:none;" + ( true ? "" : 0),  true ? "" : 0), isActive && /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_6__/* .css */ .iv)("color:", theme.content.primary1.basic, ";" + ( true ? "" : 0),  true ? "" : 0), isOpen && /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_6__/* .css */ .iv)("color:", theme.content.primary1.basic, ";" + ( true ? "" : 0),  true ? "" : 0), _bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.H`
          color: ${theme.content.primary1.basic};
        `, _bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.g`
          color: ${theme.content.primary1.basic};
          & > span {
            box-shadow: 0 0 0 ${(0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.p)(3)} ${theme.interactive.primary1.thin};
          }
        `,  true ? "" : 0,  true ? "" : 0],
    ref: forwardedRef,
    onClick: handleClick,
    onMouseEnter: handleMouseEnter,
    onMouseLeave: handleMouseLeave,
    ...rest,
    children: (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)("span", {
      css: /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_6__/* .css */ .iv)("display:inline-block;margin:", (0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.p)(-4), ";padding:", (0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.p)(4), ";border-radius:", (0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.p)(3), ";" + ( true ? "" : 0),  true ? "" : 0),
      children: children
    })
  });
}

function _EMOTION_STRINGIFIED_CSS_ERROR__$g() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
const INITIAL_NODE_HEIGHT$1 = 81;
function NavigationBarPrimary(props) {
  const {
    leftmost,
    left,
    right,
    menuEntries,
    activeId,
    selectedId,
    onMouseEnter,
    onMouseLeave,
    onSelect
  } = props;
  const LinkComponent = useLinkContext();
  const childRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
  const isPc = (0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_12__.h)(`(min-width: ${_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.B.tablet}px)`, true);
  const nodeHeight = (0,_bucketplace_ui__WEBPACK_IMPORTED_MODULE_4__/* .useNodeHeight */ .XP)(childRef, INITIAL_NODE_HEIGHT$1);
  const scrollDir = (0,_bucketplace_ui__WEBPACK_IMPORTED_MODULE_4__/* .useScrollDirection */ .C7)();
  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(StyledSticky$1, {
    direction: "top",
    offset: !isPc && scrollDir === 'down' ? -nodeHeight : 0,
    offsetRange: isPc ? [0, 0] : [-nodeHeight, 0],
    type: "navigation",
    disableNativeSticky: true,
    disableBottom: true,
    zIndex: _bucketplace_design_system__WEBPACK_IMPORTED_MODULE_14__.Z.appBar + 2,
    transition: 0.1,
    onMouseEnter: onMouseEnter,
    onMouseLeave: onMouseLeave,
    forwardRef: childRef,
    children: (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsxs */ .BX)(StyledContainer$1, {
      children: [(0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(LeftMost, {
        children: leftmost
      }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(Left, {
        children: left
      }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(NavigationBarPrimaryTabList, {
        children: menuEntries.map((item, index) => (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(NavigationBarPrimaryTabItem, {
          index: index,
          component: LinkComponent,
          href: item.href,
          isActive: activeId === index,
          isOpen: selectedId === index,
          onSelect: () => onSelect(item, index),
          children: item.title
        }, index))
      }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(Right$1, {
        children: right
      })]
    })
  });
}
const StyledSticky$1 = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_bucketplace_ui__WEBPACK_IMPORTED_MODULE_4__/* .Sticky */ .Le,  true ? {
  target: "e1uull345"
} : 0)("background:", ({
  theme
}) => theme.background.base, ";border-bottom:", (0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.p)(1), " solid ", ({
  theme
}) => theme.divider, ";" + ( true ? "" : 0));
const StyledContainer$1 = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_bucketplace_design_system_bds__WEBPACK_IMPORTED_MODULE_8__/* .Container */ .W20,  true ? {
  target: "e1uull344"
} : 0)("position:relative;display:flex;align-items:center;justify-content:space-between;height:", (0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.p)(50), ";box-sizing:border-box;line-height:0;", _bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.M.min('tablet', /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_6__/* .css */ .iv)("height:", (0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.p)(80), ";padding-top:", (0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.p)(10), ";padding-bottom:", (0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.p)(10), ";" + ( true ? "" : 0),  true ? "" : 0)), ";" + ( true ? "" : 0));
const LeftMost = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)("div",  true ? {
  target: "e1uull343"
} : 0)("flex:0 0 auto;display:block;margin-left:", (0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.p)(-7), ";", _bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.M.min('tablet',  true ? {
  name: "eivff4",
  styles: "display:none"
} : 0), ";" + ( true ? "" : 0));
const Left = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)("div",  true ? {
  target: "e1uull342"
} : 0)("position:absolute;flex:0 0 auto;left:50%;top:50%;color:", ({
  theme
}) => theme.interactive.base1, ";transform:translate(-50%, -50%);", _bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.M.min('tablet', /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_6__/* .css */ .iv)("position:static;margin-right:", (0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.p)(20), ";left:none;top:none;transform:none;" + ( true ? "" : 0),  true ? "" : 0)), " ", _bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.M.min('laptop', /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_6__/* .css */ .iv)("margin-right:", (0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.p)(35), ";" + ( true ? "" : 0),  true ? "" : 0)), ";" + ( true ? "" : 0));
const NavigationBarPrimaryTabList = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)("div",  true ? {
  target: "e1uull341"
} : 0)("flex:1 1 0px;display:none;white-space:nowrap;", _bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.M.min('tablet',  true ? {
  name: "4zleql",
  styles: "display:block"
} : 0), ";" + ( true ? "" : 0));
const Right$1 = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)("div",  true ? {
  target: "e1uull340"
} : 0)("flex:0 0 auto;", _bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.M.min('tablet', /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_6__/* .css */ .iv)("flex:0 1 ", (0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.p)(476), ";" + ( true ? "" : 0),  true ? "" : 0)), " ", _bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.M.min('desktop', /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_6__/* .css */ .iv)("flex:0 1 ", (0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.p)(650), ";" + ( true ? "" : 0),  true ? "" : 0)), " ", _bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.M.max('mobile', /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_6__/* .css */ .iv)("margin-right:", (0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.p)(-7), ";" + ( true ? "" : 0),  true ? "" : 0)), ";" + ( true ? "" : 0));

function memoize(fn) {
  var cache = Object.create(null);
  return function (arg) {
    if (cache[arg] === undefined) cache[arg] = fn(arg);
    return cache[arg];
  };
}

var reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|disableRemotePlayback|download|draggable|encType|enterKeyHint|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/; // https://esbench.com/bench/5bfee68a4cd7e6009ef61d23

var isPropValid = /* #__PURE__ */memoize(function (prop) {
  return reactPropsRegex.test(prop) || prop.charCodeAt(0) === 111
  /* o */ && prop.charCodeAt(1) === 110
  /* n */ && prop.charCodeAt(2) < 91;
}
/* Z+1 */);

/* eslint-disable camelcase */

/** 글로벌에서만 찍는 로그를 한시적으로 적용합니다. 추후 국내와 국외 로그 스펙이 같거나 비슷해져서 통합 가능해졌을 때 Context형태로 통합하는 것을 권장합니다. */

const globalLog = {
  logClickTab: ({
    section_id,
    section_idx
  }) => {
    L({
      category: 'click',
      section_id,
      section_idx,
      type: 'TAB'
    });
  },
  logClickAutocompleteKeyword: ({
    id,
    index
  }) => {
    L({
      category: 'click',
      section_id: 'AUTOCOMPLETE',
      type: 'KEYWORD',
      id,
      index
    });
  },
  logClickSearchInput: () => {
    L({
      category: 'click',
      section_id: 'TOPBAR',
      type: 'INPUT',
      id: 'SEARCH'
    });
  }
};

const useNavigationLog = () => {
  const log = useLogContext();
  const logTabImpression = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)((menu, index) => {
    log({
      key: 'secondary.item',
      category: 'impression',
      params: {
        index,
        id: menu.logId,
        type: 'topic',
        section: '서브 메뉴',
        section_id: 'LNB'
      }
    });
  }, [log]);
  const logTabClick = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)((menu, index, isHncTopicTab) => {
    const defaultParams = {
      index,
      section: '서브 메뉴',
      type: 'tab',
      id: menu.logId ?? menu.title
    };
    const params = isHncTopicTab ? {
      ...defaultParams,
      type: 'topic',
      section_id: 'LNB'
    } : defaultParams;
    log({
      key: 'secondary.item',
      category: 'click',
      params
    });
  }, [log]);
  const logMoreButtonClick = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(() => {
    log({
      key: 'secondary.more.button',
      category: 'click'
    });
  }, [log]);
  return {
    logTabClick,
    logTabImpression,
    logMoreButtonClick
  };
};

function _EMOTION_STRINGIFIED_CSS_ERROR__$f() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
const BUTTON_WIDTH = 100;
/**
 * scraollableEntries가 false일 경우
 * 메뉴 entries UI를 다른 UI로 보여주는 로직들을 포함합니다.
 */
const useMoreMenus = ({
  menus,
  scrollableEntries,
  activeId,
  primaryId
}) => {
  const menusWithIndex = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(() => menus.map((menu, index) => ({
    ...menu,
    index
  })), [menus]);
  const [moreMenus, setMoreMenus] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(menusWithIndex);
  /** moreButton + popper의 visible 여부 */
  const [isVisible, setIsVisible] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false);
  const [isGradientVisible, setIsGradientVisible] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(true);
  /** popper를 강제로 닫을지 여부 */
  const [isForcePopperClosed, setIsForcePopperClosed] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false);
  /** popper의 open 여부 */
  const [isPopperOpened, setIsPopperOpened] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false);

  // TODO: bottomSheet 관련 공통 인터랙션 공통화
  const [bottomSheetHeight, setBottomSheetHeight] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)('auto');
  const [hasClosingInteraction, setHasClosingInteraction] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false);
  const containerRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
  const currentClientY = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(0);
  const isMobile = (0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_12__.m)().breakpoint === 'mobile';
  const theme = (0,_emotion_react__WEBPACK_IMPORTED_MODULE_13__.u)();
  const Link = useLinkContext();
  const {
    logTabClick,
    logTabImpression,
    logMoreButtonClick
  } = useNavigationLog();
  const isHncSecondaryTabItem = primaryId === 0;
  const handleIntersect = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)((menu, index) => {
    if (!isHncSecondaryTabItem || !menu.logId) {
      return;
    }
    logTabImpression(menu, index);
  }, [logTabImpression, isHncSecondaryTabItem]);
  const handleClick = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)((menu, index) => {
    logTabClick(menu, index, !!(isHncSecondaryTabItem && menu.logId));
  }, [logTabClick, isHncSecondaryTabItem]);
  const activeIdInMoreMenus = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(() => {
    if (activeId == null) {
      return null;
    }
    return activeId - (menus.length - moreMenus.length);
  }, [activeId, menus.length, moreMenus.length]);
  const handleOpenBottomSheet = () => {
    setHasClosingInteraction(false);
    setBottomSheetHeight('auto');
    setIsForcePopperClosed(false);
  };
  const handleCloseBottomSheet = () => {
    setHasClosingInteraction(true);
    setBottomSheetHeight('0%');
  };
  const handleTouchMove = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(event => {
    if (event.changedTouches[0]?.clientY) {
      const scrollDown = currentClientY.current < event.changedTouches[0].clientY;
      if (scrollDown) {
        handleCloseBottomSheet();
      }
    }
  }, []);
  const handleChangeVisibleMenu = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)((changedMenu, changedMenuIndex, visibleRatio) => {
    if (isMobile) {
      setMoreMenus(menusWithIndex);
      return;
    }
    if (visibleRatio == null) {
      return;
    }
    if (visibleRatio < 1) {
      setMoreMenus(menus => menus.map(menu => menu.index).includes(changedMenuIndex) ? menus : [...menus, {
        ...changedMenu,
        index: changedMenuIndex
      }].sort((a, b) => a.index - b.index));
    } else {
      setMoreMenus(menus => menus.filter(menu => changedMenuIndex !== menu.index));
    }
  }, [isMobile, menusWithIndex]);
  const handleChangeVisibleGradient = node => {
    const scrollRight = node.scrollWidth - Math.ceil(node.scrollLeft) - node?.getBoundingClientRect().width;
    setIsGradientVisible(scrollRight > 5);
  };
  const handleResize = () => {
    if (!containerRef.current) {
      return;
    }
    const scrollWidth = containerRef.current.scrollWidth;
    const elementWidth = Math.ceil(containerRef.current.getBoundingClientRect().width);
    const overflowWidth = Math.max(scrollWidth - elementWidth, 0);
    setIsVisible(overflowWidth > 0);
  };
  (0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_12__.j)(containerRef, handleResize);
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    setMoreMenus([]);
  }, [scrollableEntries]);
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    if (isMobile) {
      return;
    }
    const handleScroll = () => {
      const isScrollDown = currentClientY.current < window.scrollY;
      setIsForcePopperClosed(isScrollDown);
      currentClientY.current = window.scrollY;
    };
    const throttleScroll = throttle$1(handleScroll, 1000);
    window.addEventListener('scroll', throttleScroll);
    return () => {
      window.removeEventListener('scroll', throttleScroll);
    };
  }, [isMobile]);
  const MoreMenus = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(() => {
    return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(MoreMenusContainer, {
      children: moreMenus.map((menu, index) => (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(StyledIntersectionObserver, {
        onIntersect: () => handleIntersect(menu, menu.index),
        children: (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(Link, {
          href: menu.href,
          onClick: () => {
            handleClick(menu, menu.index);
            setIsForcePopperClosed(true);
          },
          css: [cssLink, /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_6__/* .css */ .iv)("@media(hover: hover){&:hover{color:", theme.content.primary1.basic, ";}}", activeIdInMoreMenus === index && /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_6__/* .css */ .iv)("color:", theme.content.primary1.basic, ";" + ( true ? "" : 0),  true ? "" : 0), ";" + ( true ? "" : 0),  true ? "" : 0), _bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.g`
                  color: ${theme.content.primary1.basic};
                `,  true ? "" : 0,  true ? "" : 0],
          children: menu.title
        })
      }, menu.title))
    });
  }, [theme, moreMenus, Link, activeIdInMoreMenus, handleIntersect, handleClick]);
  return {
    onChangeVisibleMenu: handleChangeVisibleMenu,
    onChangeVisibleGradient: handleChangeVisibleGradient,
    containerRef,
    isPopperOpened,
    moreMenusComponent: isVisible ? (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(_bucketplace_design_system_bds__WEBPACK_IMPORTED_MODULE_8__/* .Popper */ .rDy, {
      isForceClosed: isForcePopperClosed,
      usePortal: false,
      style: isMobile ? {
        visibility: 'hidden'
      } : undefined,
      onChange: setIsPopperOpened,
      renderButton: ({
        onClick,
        isOpen
      }) => (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsxs */ .BX)(_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .Fragment */ .HY, {
        children: [(0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(MoreButton, {
          isGradientVisible: isGradientVisible,
          type: "button",
          onClick: () => {
            handleOpenBottomSheet();
            onClick();
            logMoreButtonClick();
          },
          children: (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(ChevronDownIcon, {
            size: 12,
            name: "chevron_down",
            fill: theme => theme.content.base1
          })
        }), isMobile && isOpen && (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(StyledModal, {
          width: 400,
          hasInteraction: true,
          hasGrabber: true,
          height: bottomSheetHeight,
          hasClosingInteraction: hasClosingInteraction,
          onBlur: handleCloseBottomSheet,
          onTouchStart: event => {
            if (event.changedTouches[0]?.clientY) {
              currentClientY.current = event.changedTouches[0]?.clientY;
            }
          },
          onTouchMove: handleTouchMove,
          disableBackgroundScroll: true,
          header: {
            title: '탭 선택하기',
            onClose: handleCloseBottomSheet
          },
          onTransitionEnd: () => {
            if (hasClosingInteraction) {
              onClick();
            }
          },
          children: (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(SwitchTransition$1, {
            children: (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(Transition$1, {
              timeout: 200,
              children: MoreMenus
            })
          })
        })]
      }),
      children: !isMobile && MoreMenus
    }) : null
  };
};
const cssLink = /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_6__/* .css */ .iv)(_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.F.body1_small, " display:block;padding:", (0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.p)(10), " 0 ", (0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.p)(10), " ", (0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.p)(26), ";text-align:start;font-weight:700;", _bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.M.min('tablet', /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_6__/* .css */ .iv)(_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.F.subTitle1, ";padding:0 0 ", (0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.p)(20), ";" + ( true ? "" : 0),  true ? "" : 0)), ";" + ( true ? "" : 0),  true ? "" : 0);
const MoreButton = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)("button",  true ? {
  target: "ehl2p6i4"
} : 0)(_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.R, " padding:0 ", (0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.p)(6), ";height:100%;display:flex;align-items:center;position:absolute;transform:translateX(-100%);", ({
  isGradientVisible,
  theme
}) => isGradientVisible && /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_6__/* .css */ .iv)("&:after{content:'';position:absolute;right:0;width:", (0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.p)(BUTTON_WIDTH), ";height:100%;background:linear-gradient(90deg, ", (0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.h)(theme.background.base, 0), " 0%, ", theme.background.base, " 50%);}" + ( true ? "" : 0),  true ? "" : 0), ";" + ( true ? "" : 0));
const MoreMenusContainer = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)("div",  true ? {
  target: "ehl2p6i3"
} : 0)("display:flex;flex-wrap:wrap;padding-top:", (0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.p)(30), ";", _bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.M.min('tablet', /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_6__/* .css */ .iv)("display:block;min-width:", (0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.p)(250), ";padding:", (0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.p)(20), " ", (0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.p)(22), " 0;" + ( true ? "" : 0),  true ? "" : 0)), ";" + ( true ? "" : 0));
const ChevronDownIcon = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_bucketplace_design_system_bds__WEBPACK_IMPORTED_MODULE_8__/* .Icon */ .JO$,  true ? {
  target: "ehl2p6i2"
} : 0)( true ? {
  name: "1dk0v5d",
  styles: "z-index:2"
} : 0);
var _ref$e =  true ? {
  name: "1yoibbp",
  styles: "opacity:0;transition:opacity 0.3s ease-in"
} : 0;
const StyledModal = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_bucketplace_design_system_bds__WEBPACK_IMPORTED_MODULE_8__/* .Modal */ .u_l,  true ? {
  target: "ehl2p6i1"
} : 0)(({
  hasClosingInteraction
}) => hasClosingInteraction && _ref$e, ";" + ( true ? "" : 0));
const StyledIntersectionObserver = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_14__.I,  true ? {
  target: "ehl2p6i0"
} : 0)( true ? {
  name: "1dlyed8",
  styles: "flex-basis:50%"
} : 0);

function _EMOTION_STRINGIFIED_CSS_ERROR__$e() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
var _ref$d =  true ? {
  name: "gth0vq",
  styles: "height:inherit"
} : 0;
function NavigationBarSecondaryTabItem(props) {
  const {
    onSelect,
    index,
    item,
    onChangeVisibleMenu,
    containerRef,
    primaryId,
    ...rest
  } = props;
  const {
    isGlobal
  } = useGNBData();
  const LinkComponent = useLinkContext();
  const [handleMouseEnter, handleMouseLeave] = useHover(onSelect);
  const {
    ref,
    entry
  } = useInView({
    root: containerRef.current,
    rootMargin: `0px -${BUTTON_WIDTH}px 0px 0px`,
    initialInView: true,
    threshold: [0, 1]
  });
  const {
    logTabClick,
    logTabImpression
  } = useNavigationLog();
  const isHncSecondaryTabItem = primaryId === 0;
  const handleIntersect = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(() => {
    if (!isHncSecondaryTabItem || !item.logId) {
      return;
    }
    logTabImpression?.(item, index);
  }, [logTabImpression, item, index, isHncSecondaryTabItem]);
  const handleTabClick = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(() => {
    if (isGlobal) {
      globalLog.logClickTab({
        section_idx: index,
        section_id: item.logId
      });
    } else {
      logTabClick?.(item, index, !!(isHncSecondaryTabItem && item.logId));
    }
  }, [index, isGlobal, isHncSecondaryTabItem, item, logTabClick]);
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    onChangeVisibleMenu(item, index, entry?.intersectionRatio);
  }, [entry, item, index, onChangeVisibleMenu]);
  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_14__.I, {
    onIntersect: handleIntersect,
    children: (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)("div", {
      ref: ref,
      css: _ref$d,
      children: (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(StyledTabItem, {
        ...rest,
        component: LinkComponent,
        onClick: handleTabClick,
        onMouseEnter: handleMouseEnter,
        onMouseLeave: handleMouseLeave
      })
    })
  });
}
const StyledTabItem = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_bucketplace_design_system_bds__WEBPACK_IMPORTED_MODULE_8__/* .TabItem */ .E2J,  true ? {
  target: "e1sy26r80"
} : 0)("height:inherit;outline:none;&>div>p{font-weight:700;}", _bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.M.max('mobile', /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_6__/* .css */ .iv)("padding:", (0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.p)(11), " ", (0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.p)(5), ";>div>p{", _bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.F.subTitle2, ";}" + ( true ? "" : 0),  true ? "" : 0)), " ", ({
  theme
}) => /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_6__/* .css */ .iv)(_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.H`
      color: ${theme.content.primary1.basic};
    `, " ", _bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.g`
      * {
        color: ${theme.content.primary1.basic};
      }
      & > div {
        box-shadow: 0 0 0 ${(0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.p)(3)} ${theme.interactive.primary1.thin};
        border-radius: ${(0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.p)(3)};
      }
    `, ";" + ( true ? "" : 0),  true ? "" : 0), ";" + ( true ? "" : 0));

function _EMOTION_STRINGIFIED_CSS_ERROR__$d() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
const INITIAL_NODE_HEIGHT = 51;
function NavigationBarSecondary(props) {
  const {
    hasItems,
    isForceOpened,
    isFallback,
    right,
    menuEntries,
    activeId,
    onMouseEnter,
    onMouseLeave,
    onSelect,
    primaryId,
    scrollableEntries = true
  } = props;
  const childRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
  const theme = (0,_emotion_react__WEBPACK_IMPORTED_MODULE_13__.u)();
  const isMobile = (0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_12__.m)().breakpoint === 'mobile';
  const nodeHeight = (0,_bucketplace_ui__WEBPACK_IMPORTED_MODULE_4__/* .useNodeHeight */ .XP)(childRef, INITIAL_NODE_HEIGHT);
  const scrollDir = (0,_bucketplace_ui__WEBPACK_IMPORTED_MODULE_4__/* .useScrollDirection */ .C7)();
  const shouldOpen = hasItems && scrollDir !== 'down' || isForceOpened;
  const {
    onChangeVisibleMenu,
    onChangeVisibleGradient,
    containerRef,
    moreMenusComponent,
    isPopperOpened
  } = useMoreMenus({
    menus: menuEntries,
    scrollableEntries,
    activeId,
    primaryId
  });

  /** Hover된 Secondary 메뉴 내 Popper가 닫히면, Secondary의 Hover상태도 없애기 위해 실행합니다. */
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    if (isPopperOpened) {
      return;
    }
    onMouseLeave?.();
  }, [isPopperOpened, onMouseLeave]);
  if (menuEntries.length === 0) {
    return null;
  }

  // NOTE: Secondary의 모바일/PC 동작은 완전히 동일합니다.
  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(StyledSticky, {
    className: "layout-navigation-secondary",
    css: /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_6__/* .css */ .iv)(isFallback && /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_6__/* .css */ .iv)("background:", theme.background.groupedBase, ";" + ( true ? "" : 0),  true ? "" : 0), ";" + ( true ? "" : 0),  true ? "" : 0),
    containerStyle: !hasItems ? {
      position: 'relative',
      top: isForceOpened ? '0' : (0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.p)(-nodeHeight),
      height: '0px',
      transition: '.1s top'
    } : undefined,
    direction: "top",
    offset: shouldOpen ? 0 : -nodeHeight,
    offsetRange: [-nodeHeight, 0],
    type: "navigation",
    disableNativeSticky: true,
    disableBottom: true,
    disableHeight: !hasItems,
    forwardRef: childRef,
    zIndex: _bucketplace_design_system__WEBPACK_IMPORTED_MODULE_14__.Z.appBar + 1,
    transition: 0.1,
    initialState: !hasItems ? {
      ..._bucketplace_ui__WEBPACK_IMPORTED_MODULE_4__/* .DEFAULT_STICKY_STATE */ .O8,
      disabled: false,
      emulatedDisabled: false,
      offset: -nodeHeight,
      emulatedOffset: -nodeHeight
    } : undefined,
    onMouseEnter: onMouseEnter,
    onMouseLeave: () => {
      if (isPopperOpened) {
        return;
      }
      onMouseLeave?.();
    },
    children: (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsxs */ .BX)(StyledContainer, {
      scrollable: scrollableEntries,
      children: [(0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsxs */ .BX)(TabContainer, {
        ref: containerRef,
        scrollable: scrollableEntries,
        children: [(0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(StyledTab, {
          ref: node => {
            if (!node) {
              return;
            }
            const throttleScroll = throttle$1(() => onChangeVisibleGradient(node), 100);
            node.addEventListener('scroll', throttleScroll);
          },
          scrollable: scrollableEntries,
          isMobile: isMobile,
          children: menuEntries.map((item, index) => (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(NavigationBarSecondaryTabItem, {
            containerRef: containerRef,
            index: index,
            onChangeVisibleMenu: onChangeVisibleMenu,
            item: item,
            href: item.href,
            bullet: item.bullet,
            badge: item.badge,
            isActive: activeId === index,
            onSelect: () => onSelect(item, index),
            primaryId: primaryId,
            children: item.title
          }, item.title))
        }), !scrollableEntries && moreMenusComponent]
      }), right && (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(Right, {
        children: right
      })]
    })
  });
}
const StyledSticky = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_bucketplace_ui__WEBPACK_IMPORTED_MODULE_4__/* .Sticky */ .Le,  true ? {
  target: "e2301rp4"
} : 0)("background:", ({
  theme
}) => theme.background.base, ";border-bottom:", (0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.p)(1), " solid ", ({
  theme
}) => theme.divider, ";" + ( true ? "" : 0));
var _ref3$1 =  true ? {
  name: "1ahtu5h",
  styles: "overflow:initial;padding-left:0"
} : 0;
const StyledContainer = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_bucketplace_design_system_bds__WEBPACK_IMPORTED_MODULE_8__/* .Container */ .W20,  true ? {
  shouldForwardProp: prop => isPropValid(prop),
  target: "e2301rp3"
} : 0)("position:relative;display:flex;align-items:center;justify-content:space-between;box-sizing:border-box;overflow:auto;", ({
  scrollable
}) => !scrollable && _ref3$1, ";" + ( true ? "" : 0));
var _ref2$4 =  true ? {
  name: "d3v9zr",
  styles: "overflow:hidden"
} : 0;
const StyledTab = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_bucketplace_design_system_bds__WEBPACK_IMPORTED_MODULE_8__/* .Tab */ .OK9,  true ? {
  shouldForwardProp: prop => isPropValid(prop),
  target: "e2301rp2"
} : 0)("height:", (0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.p)(51), ";", _bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.M.max('mobile', /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_6__/* .css */ .iv)("height:", (0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.p)(40), ";justify-content:center;margin:0 ", (0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.p)(-2), ";&&>*{margin:0 ", (0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.p)(2), ";}" + ( true ? "" : 0),  true ? "" : 0)), " ", ({
  scrollable,
  isMobile
}) => !scrollable && /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_6__/* .css */ .iv)("&{", isMobile ? /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_6__/* .css */ .iv)("padding:0 ", (0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.p)(32), " 0 ", (0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.p)(16), ";justify-content:start;" + ( true ? "" : 0),  true ? "" : 0) : _ref2$4, ";}" + ( true ? "" : 0),  true ? "" : 0), ";" + ( true ? "" : 0));
const Right = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)("div",  true ? {
  target: "e2301rp1"
} : 0)("flex:0 0 auto;display:none;", _bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.M.min('tablet',  true ? {
  name: "17kpjmp",
  styles: "display:block;margin-left:10px"
} : 0), ";" + ( true ? "" : 0));
var _ref$c =  true ? {
  name: "t1y265",
  styles: "display:flex;justify-content:space-between;overflow:hidden"
} : 0;
const TabContainer = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)("div",  true ? {
  target: "e2301rp0"
} : 0)("flex:1 0 0;", ({
  scrollable
}) => !scrollable && _ref$c, ";" + ( true ? "" : 0));

function NavigationBarTertiary({
  item,
  isOpen,
  onMouseEnter,
  onMouseLeave
}) {
  const itemRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(item);
  if (item != null) {
    itemRef.current = item;
  }
  const currentItem = itemRef.current;
  const nodeRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
  const [top, setTop] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(null);
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    if (!isOpen) {
      return;
    }
    if (nodeRef.current == null) {
      nodeRef.current = document.querySelector('.layout-navigation-secondary');
    }
    if (nodeRef.current) {
      setTop(nodeRef.current.getBoundingClientRect().bottom);
    }
    let timer = null;
    function handleScroll() {
      if (timer != null) {
        cancelAnimationFrame(timer);
      }
      timer = requestAnimationFrame(() => {
        timer = null;
        if (nodeRef.current) {
          setTop(nodeRef.current.getBoundingClientRect().bottom);
        }
      });
    }
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
      if (timer != null) {
        cancelAnimationFrame(timer);
      }
    };
  }, [isOpen]);
  const show = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(() => Boolean(isOpen && item?.renderBarChild), [isOpen, item]);
  if (top == null) {
    return null;
  }
  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(CSSTransition$1, {
    timeout: 200,
    in: show,
    appear: show,
    unmountOnExit: true,
    classNames: {
      enterActive: 'open opening',
      enterDone: 'open open-active',
      appearActive: 'open opening',
      appearDone: 'open open-active',
      exit: 'exiting'
    },
    children: (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)("div", {
      css: /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_6__/* .css */ .iv)("position:fixed;top:", top, "px;left:0;right:0;background-color:#ffffff;border-bottom:1px solid #ededed;z-index:500;opacity:0;transform:translateY(-100%);&.opening{transition:.2s opacity,.2s transform;}&.exiting{transition:.2s opacity,.2s transform;}&.open{opacity:1;transform:none;}" + ( true ? "" : 0),  true ? "" : 0),
      onMouseEnter: onMouseEnter,
      onMouseLeave: onMouseLeave,
      children: currentItem?.renderBarChild?.()
    })
  });
}

const HistoryStorageContext = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)({});
const useHistoryStorage = () => (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(HistoryStorageContext);
function HistoryStorageProvider({
  children,
  ...props
}) {
  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(HistoryStorageContext.Provider, {
    value: props,
    children: children
  });
}

function _EMOTION_STRINGIFIED_CSS_ERROR__$c() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
function HighlightedText({
  item,
  query
}) {
  const {
    highlightedDisplay
  } = item.value;
  if (!query) {
    return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .Fragment */ .HY, {
      children: item.query
    });
  }
  const parts = highlightedDisplay ? highlightedDisplay.split(/<strong>|<\/strong>/gi) : item.query.split(new RegExp(`(${query})`, 'gi'));
  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .Fragment */ .HY, {
    children: parts.map((part, index) => (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
      children: index % 2 === 1 ? (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)("strong", {
        children: part
      }) : part
    }, index))
  });
}
var _ref$b =  true ? {
  name: "17uk3v8",
  styles: "display:flex;align-items:center;white-space:nowrap"
} : 0;
function KeywordItem(props) {
  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsxs */ .BX)("div", {
    css: _ref$b,
    children: [(0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(_bucketplace_design_system_bds__WEBPACK_IMPORTED_MODULE_8__/* .Icon */ .JO$, {
      name: "search",
      size: 18,
      fill: theme => theme.content.base1,
      css: /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_6__/* .css */ .iv)("width:", (0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.p)(32), ";height:", (0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.p)(32), ";display:flex;align-items:center;justify-content:center;", _bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.M.min('laptop', `
            width: ${(0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.p)(24)};
            height: ${(0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.p)(24)};
          `), ";" + ( true ? "" : 0),  true ? "" : 0)
    }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)("div", {
      css: /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_6__/* .css */ .iv)("flex:1;text-overflow:ellipsis;overflow:hidden;margin-left:", (0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.p)(8), ";" + ( true ? "" : 0),  true ? "" : 0),
      children: (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(HighlightedText, {
        ...props
      })
    })]
  });
}

function _EMOTION_STRINGIFIED_CSS_ERROR__$b() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
var _ref$a =  true ? {
  name: "1kghokd",
  styles: "display:flex;align-items:center;overflow:hidden"
} : 0;
var _ref2$3 =  true ? {
  name: "7gjpkq",
  styles: "display:flex;align-items:center;justify-content:space-between;white-space:nowrap"
} : 0;
function CategoryItem(props) {
  const theme = (0,_emotion_react__WEBPACK_IMPORTED_MODULE_13__.u)();
  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsxs */ .BX)("div", {
    css: _ref2$3,
    children: [(0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsxs */ .BX)("div", {
      css: _ref$a,
      children: [(0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(_bucketplace_design_system_bds__WEBPACK_IMPORTED_MODULE_8__/* .Icon */ .JO$, {
        css: /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_6__/* .css */ .iv)("width:", (0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.p)(32), ";height:", (0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.p)(32), ";display:flex;align-items:center;justify-content:center;", _bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.M.min('laptop', `
              width: ${(0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.p)(24)};
              height: ${(0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.p)(24)};
              min-width: ${(0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.p)(24)};
            `), ";" + ( true ? "" : 0),  true ? "" : 0),
        name: "search",
        size: 18,
        fill: theme => theme.content.base1
      }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)("div", {
        css: /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_6__/* .css */ .iv)("text-overflow:ellipsis;overflow:hidden;margin-left:", (0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.p)(8), ";" + ( true ? "" : 0),  true ? "" : 0),
        children: (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(HighlightedText, {
          ...props
        })
      }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)("span", {
        css: /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_6__/* .css */ .iv)("width:", (0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.p)(1), ";height:", (0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.p)(10), ";background:", theme.content.base4, ";margin:0 ", (0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.p)(4), ";" + ( true ? "" : 0),  true ? "" : 0)
      }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)("span", {
        css: /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_6__/* .css */ .iv)(_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.F.caption1, " margin-right:", (0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.p)(14), ";color:", theme.content.base2, ";", _bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.M.min('laptop', `
            ${_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.F.caption2}
          `), ";" + ( true ? "" : 0),  true ? "" : 0),
        children: "\uCE74\uD14C\uACE0\uB9AC"
      })]
    }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(_bucketplace_design_system_bds__WEBPACK_IMPORTED_MODULE_8__/* .Icon */ .JO$, {
      name: "chevron_right",
      size: 18,
      fill: theme => theme.content.base3
    })]
  });
}

function _EMOTION_STRINGIFIED_CSS_ERROR__$a() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
const MAX_DEPTH = 2;
var _ref$9 =  true ? {
  name: "n0fp6c",
  styles: "display:flex;flex-flow:row wrap;align-items:center;width:100%"
} : 0;
function CategoryHierarchy({
  hierarchy
}) {
  const trailings = hierarchy.slice(-MAX_DEPTH);
  const theme = (0,_emotion_react__WEBPACK_IMPORTED_MODULE_13__.u)();
  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)("div", {
    css: _ref$9,
    children: trailings.map((depth, index) => (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsxs */ .BX)(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
      children: [(0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)("span", {
        css: /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_6__/* .css */ .iv)("display:inline-block;font-weight:bold;line-height:1.4;&:last-of-type{color:", theme.content.primary1.thick, ";}" + ( true ? "" : 0),  true ? "" : 0),
        children: depth
      }), index < trailings.length - 1 && (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(_bucketplace_design_system_bds__WEBPACK_IMPORTED_MODULE_8__/* .Icon */ .JO$, {
        name: "chevron_right",
        size: 12,
        css: /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_6__/* .css */ .iv)("margin:0 ", (0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.p)(6), ";" + ( true ? "" : 0),  true ? "" : 0)
      })]
    }, index))
  });
}

function _EMOTION_STRINGIFIED_CSS_ERROR__$9() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
var _ref$8 =  true ? {
  name: "fzu03x",
  styles: "text-overflow:ellipsis;overflow:hidden"
} : 0;
function HistoryItem({
  item,
  hovered
}) {
  const theme = (0,_emotion_react__WEBPACK_IMPORTED_MODULE_13__.u)();
  const {
    query,
    value
  } = item;
  const historyStorage = useHistoryStorage();
  const handleDeleteClick = e => {
    e.stopPropagation();
    historyStorage.remove(value);
  };
  const renderItem = () => {
    let elem = query;
    if (typeof value === 'object' && value.type === 'category') {
      // 기존 History 데이터가 undefined 인 경우가 있어, 옵셔널 값 추가
      const orgDisplay = value.value.orgDisplay ?? '';
      elem = (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(CategoryHierarchy, {
        hierarchy: orgDisplay.split('>').map(value => value.trim())
      });
    }
    return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)("span", {
      css: _ref$8,
      children: elem
    });
  };
  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsxs */ .BX)("div", {
    css: /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_6__/* .css */ .iv)("display:flex;align-items:center;justify-content:space-between;width:100%;padding:", (0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.p)(4), " 0;box-sizing:border-box;", _bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.M.min('laptop', /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_6__/* .css */ .iv)("padding:", (0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.p)(4), " ", (0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.p)(4), ";" + ( true ? "" : 0),  true ? "" : 0)), ";" + ( true ? "" : 0),  true ? "" : 0),
    children: [renderItem(), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)("button", {
      type: "button",
      onClick: handleDeleteClick,
      css: [/*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_6__/* .css */ .iv)(_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.R, " margin-right:", (0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.p)(-6), ";padding:", (0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.p)(6), ";transition:.1s opacity;font-size:0;line-height:0;border-radius:", (0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.p)(2), ";outline:none;" + ( true ? "" : 0),  true ? "" : 0), _bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.H`
            opacity: .4;
          `, _bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.g`
            box-shadow: 0 0 0 ${(0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.p)(3)} ${theme.interactive.primary1.thin};
          `,  true ? "" : 0,  true ? "" : 0],
      children: (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(_bucketplace_design_system_bds__WEBPACK_IMPORTED_MODULE_8__/* .Icon */ .JO$, {
        name: "dismiss",
        size: 12,
        fill: theme => hovered ? theme.content.base2 : theme.content.base3
      })
    })]
  });
}

function _EMOTION_STRINGIFIED_CSS_ERROR__$8() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
var _ref$7 =  true ? {
  name: "1kghokd",
  styles: "display:flex;align-items:center;overflow:hidden"
} : 0;
var _ref2$2 =  true ? {
  name: "7gjpkq",
  styles: "display:flex;align-items:center;justify-content:space-between;white-space:nowrap"
} : 0;
function ConsultingItem(props) {
  const {
    item: {
      value
    }
  } = props;
  const theme = (0,_emotion_react__WEBPACK_IMPORTED_MODULE_13__.u)();
  const cta = ` ${value.info.cta}`;
  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsxs */ .BX)("div", {
    css: _ref2$2,
    children: [(0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsxs */ .BX)("div", {
      css: _ref$7,
      children: [(0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)("div", {
        css: /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_6__/* .css */ .iv)("width:", (0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.p)(32), ";height:", (0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.p)(32), ";display:flex;align-items:center;justify-content:center;", _bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.M.min('laptop', `
              width: ${(0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.p)(24)};
              height: ${(0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.p)(24)};
            `), ";" + ( true ? "" : 0),  true ? "" : 0),
        children: value.info.iconFileUrl ? (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(_bucketplace_design_system_bds__WEBPACK_IMPORTED_MODULE_8__/* .CircleImage */ .rUs, {
          src: value.info.iconFileUrl,
          css: /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_6__/* .css */ .iv)("width:100%;border:", (0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.p)(0.5), " solid ", theme.outline, ";" + ( true ? "" : 0),  true ? "" : 0)
        }) : (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(_bucketplace_design_system_bds__WEBPACK_IMPORTED_MODULE_8__/* .Icon */ .JO$, {
          name: "search",
          size: 18,
          fill: theme => theme.content.base1
        })
      }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsxs */ .BX)("div", {
        css: /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_6__/* .css */ .iv)("flex:1;white-space:nowrap;text-overflow:ellipsis;overflow:hidden;margin-left:", (0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.p)(8), ";" + ( true ? "" : 0),  true ? "" : 0),
        children: [(0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(HighlightedText, {
          ...props
        }), cta]
      })]
    }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(_bucketplace_design_system_bds__WEBPACK_IMPORTED_MODULE_8__/* .Icon */ .JO$, {
      name: "chevron_right",
      size: 18,
      fill: theme => theme.content.base3
    })]
  });
}

function ListBoxItem({
  item,
  hovered,
  query,
  showDivider = false,
  onHover,
  ...props
}) {
  const theme = (0,_emotion_react__WEBPACK_IMPORTED_MODULE_13__.u)();
  const ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
  const renderItem = () => {
    switch (item.type) {
      case 'query':
        return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(KeywordItem, {
          item: item,
          query: query
        });
      case 'category':
        return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(CategoryItem, {
          item: item,
          query: query
        });
      case 'consulting':
        return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(ConsultingItem, {
          item: item,
          query: query
        });
      case 'history':
        return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(HistoryItem, {
          item: item,
          hovered: hovered
        });
      default:
        return null;
    }
  };
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    if (!hovered || !ref.current) {
      return;
    }
    onHover(ref.current);
  }, [hovered, onHover]);
  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsxs */ .BX)(_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .Fragment */ .HY, {
    children: [(0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)("li", {
      ref: ref,
      role: "option",
      "aria-selected": undefined,
      css: [/*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_6__/* .css */ .iv)(_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.F.subTitle1, " position:relative;margin:0;padding:", (0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.p)(8), " ", (0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.p)(16), ";color:", theme.content.base1, ";line-height:", (0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.p)(21), ";cursor:pointer;border-radius:", (0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.p)(2), ";outline:none;strong{color:", theme.content.primary1.thick, ";font-weight:400;}", hovered && `background: ${theme.background.groupedBase};`, " ", _bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.M.min('laptop', /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_6__/* .css */ .iv)(_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.F.subTitle2, " padding:", (0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.p)(8), ";" + ( true ? "" : 0),  true ? "" : 0)), ";" + ( true ? "" : 0),  true ? "" : 0), _bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.g`
          background: ${theme.background.groupedBase};
        `,  true ? "" : 0,  true ? "" : 0],
      tabIndex: 0,
      ...props,
      children: renderItem()
    }), showDivider && (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(_bucketplace_design_system_bds__WEBPACK_IMPORTED_MODULE_8__/* .Divider */ .izJ, {
      css: /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_6__/* .css */ .iv)("margin:", (0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.p)(8), " 0;", _bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.M.min('laptop', `
              margin: ${(0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.p)(10)} 0;
            `), ";" + ( true ? "" : 0),  true ? "" : 0),
      variant: "thin"
    })]
  });
}

function _EMOTION_STRINGIFIED_CSS_ERROR__$7() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
function filterOnlyHistoryKeyword(items) {
  return items.filter(item => item.type === 'history' && typeof item.value !== 'string' && item.value.type === 'query');
}
var _ref$6 =  true ? {
  name: "1xclg2i",
  styles: "margin:0;padding:0"
} : 0;
function ListBox({
  items,
  query,
  hoveredIndex,
  isHistoryList,
  onItemClick,
  onItemMouseEnter
}) {
  const theme = (0,_emotion_react__WEBPACK_IMPORTED_MODULE_13__.u)();
  const container = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
  const {
    localeData
  } = useGNBData();
  const log = useLogContext();
  const handleIntersect = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(() => {
    if (filterOnlyHistoryKeyword(items).length > 0) {
      log({
        key: 'primary.right.search.history',
        category: 'impression',
        params: {
          type: 'keyword'
        }
      });
    }
  }, [items, log]);
  const isShowDivider = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)((item, index) => {
    return index < items.length - 1 && items[index + 1]?.type !== item.type;
  }, [items]);
  const handleItemHover = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(item => {
    if (!container.current) {
      return;
    }
    container.current.scrollTop = item.offsetTop - (container.current.offsetHeight - item.offsetHeight) / 2;
  }, []);
  const handleItemClick = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)((item, index) => () => onItemClick(item, index), [onItemClick]);
  const handleItemMouseEnter = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)((item, index) => () => onItemMouseEnter(item, index), [onItemMouseEnter]);
  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_14__.I, {
    onIntersect: handleIntersect,
    children: (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsxs */ .BX)("div", {
      ref: container,
      css: /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_6__/* .css */ .iv)("overflow-y:auto;position:relative;width:100%;padding:", (0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.p)(10), " 0;border:", (0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.p)(1), " solid ", theme.divider, ";border-radius:", (0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.p)(4), ";background:", theme.background.base, ";box-shadow:0 ", (0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.p)(4), " ", (0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.p)(6), " 0 ", theme.shadow.basic, ";box-sizing:border-box;", _bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.M.min('laptop', `
          position: absolute;
          top: calc(100% + ${(0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.p)(4)});
          left: 0;
          max-height: ${(0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.p)(400)};
        `), " ", _bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.M.only('tablet', `
          top: ${(0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.p)(4)};
          height: 100%;
        `), " ", _bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.M.only('mobile', `
          height: 100%;
          padding: ${(0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.p)(8)} 0;
          border: 0;
          box-shadow: none;
        `), ";" + ( true ? "" : 0),  true ? "" : 0),
      children: [!isHistoryList && (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(HistoryListBoxHeader, {
        hasDeleteButton: items.length > 0,
        localeData: localeData
      }), items.length > 0 ? (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)("ul", {
        css: _ref$6,
        children: items.map((item, index) => (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(ListBoxItem, {
          item: item,
          query: query,
          hovered: hoveredIndex === index,
          showDivider: isShowDivider(item, index),
          onHover: handleItemHover,
          onClick: handleItemClick(item, index),
          onMouseEnter: handleItemMouseEnter(item, index)
        }, `${item.query}${index}`))
      }) : (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)("p", {
        css: /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_6__/* .css */ .iv)("margin:0;padding:", (0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.p)(10), " ", (0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.p)(16), ";color:", theme.content.base3, ";font-size:", (0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.p)(15), ";line-height:1.4;" + ( true ? "" : 0),  true ? "" : 0),
        children: localeData?.search?.historyEmpty ?? '최근 검색한 내역이 없습니다.'
      })]
    })
  });
}
function HistoryListBoxHeader({
  hasDeleteButton,
  localeData
}) {
  const theme = (0,_emotion_react__WEBPACK_IMPORTED_MODULE_13__.u)();
  const historyStorage = useHistoryStorage();
  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsxs */ .BX)("div", {
    css: /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_6__/* .css */ .iv)("display:flex;align-items:center;justify-content:space-between;padding:", (0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.p)(7), " ", (0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.p)(8), " ", (0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.p)(10), ";font-size:", (0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.p)(15), ";line-height:", (0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.p)(21), ";" + ( true ? "" : 0),  true ? "" : 0),
    children: [(0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)("span", {
      css: /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_6__/* .css */ .iv)("font-size:", (0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.p)(13), ";color:", theme.content.base2, ";" + ( true ? "" : 0),  true ? "" : 0),
      children: localeData?.search?.historyLabel ?? '최근 검색어'
    }), hasDeleteButton && (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)("button", {
      type: "button",
      onClick: historyStorage.removeAll,
      css: [/*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_6__/* .css */ .iv)(_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.R, " margin:", (0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.p)(-2), ";padding:", (0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.p)(2), ";font-size:", (0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.p)(12), ";color:", theme.content.base2, ";border-radius:", (0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.p)(2), ";outline:none;transition:.1s opacity;" + ( true ? "" : 0),  true ? "" : 0), _bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.H`
              opacity: .4;
            `, _bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.g`
              box-shadow: 0 0 0 ${(0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.p)(3)} ${theme.interactive.primary1.thin};
            `,  true ? "" : 0,  true ? "" : 0],
      children: localeData?.search?.deleteHistory ?? '전체 삭제'
    })]
  });
}

function getSearchPlaceholder(searchType) {
  return searchType === 'store' && '쇼핑 검색' || searchType === 'expert_user' && '시공업체 검색' || '통합검색';
}

function NavigationSearch({
  searchType,
  initialQuery,
  onFetch,
  onSubmit,
  onSubmitItem,
  onInputFocus,
  historyStorage,
  placeholder,
  ...props
}) {
  const [pageKey, setPageKey] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(null);
  const [manuallyTypedInputValue, setManuallyTypedInputValue] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(initialQuery);
  const {
    isGlobal
  } = useGNBData();
  const fetchListFromSearchHistory = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(() => {
    const history = historyStorage.get();
    return history.map(value => ({
      type: 'history',
      value,
      query: typeof value === 'string' ? value : value.query
    }));
  }, [historyStorage]);
  const fetchList = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(async query => {
    if (!manuallyTypedInputValue) {
      return fetchListFromSearchHistory();
    }
    return onFetch(query);
  }, [manuallyTypedInputValue, fetchListFromSearchHistory, onFetch]);
  const handleHistoryUpdate = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(() => {
    setPageKey({
      ...window.location,
      timestamp: new Date().getTime()
    });
  }, []);
  const handleSubmit = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(value => {
    historyStorage.append(value);
    if (onSubmit) {
      onSubmit(value);
    }
  }, [historyStorage, onSubmit]);
  const log = useLogContext();
  const logAutocompleteKeyword = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)((item, index) => {
    const params = {
      type: item.type,
      index,
      id: item.query
    };
    if (isGlobal) {
      globalLog.logClickAutocompleteKeyword({
        id: item.query,
        index
      });
      return;
    }
    if (item.type === 'history' && typeof item.value !== 'string') {
      log({
        key: 'primary.right.search.history',
        category: 'click',
        params: {
          ...params,
          type: item.value.type
        }
      });
    }
    if (item.type === 'category' || item.type === 'query') {
      log({
        key: `primary.right.search.autocomplete.${item.type}`,
        category: 'click',
        params
      });
    }
  }, [log, isGlobal]);
  const handleSubmitItem = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)((item, index) => {
    const value = item.type === 'history' ? item.value : item;
    historyStorage.append(value);
    if (onSubmitItem) {
      onSubmitItem(item);
    }
    logAutocompleteKeyword(item, index);
  }, [historyStorage, onSubmitItem, logAutocompleteKeyword]);
  const handleInputFocus = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(e => {
    if (onInputFocus) {
      onInputFocus(e);
    }
    if (isGlobal) {
      globalLog.logClickSearchInput();
    } else {
      log({
        key: 'primary.right.search.input',
        category: 'click',
        params: {
          search_type: searchType
        }
      });
    }
  }, [onInputFocus, log, searchType, isGlobal]);
  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(HistoryStorageProvider, {
    get: historyStorage.get,
    set: histories => {
      historyStorage.set(histories);
      handleHistoryUpdate();
    },
    append: history => {
      historyStorage.append(history);
      handleHistoryUpdate();
    },
    remove: history => {
      historyStorage.remove(history);
      handleHistoryUpdate();
    },
    removeAll: () => {
      historyStorage.removeAll();
      handleHistoryUpdate();
    },
    children: (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(_bucketplace_design_system_bds__WEBPACK_IMPORTED_MODULE_8__/* .Search */ .olm, {
      id: "global-search",
      pageKey: pageKey,
      initialQuery: initialQuery,
      placeholder: placeholder ?? getSearchPlaceholder(searchType),
      fetchList: fetchList,
      getItemQuery: item => item.query,
      renderListBox: props => (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(ListBox, {
        ...props,
        isHistoryList: !!manuallyTypedInputValue
      }),
      onSubmit: handleSubmit,
      onSubmitItem: handleSubmitItem,
      onInputFocus: handleInputFocus,
      onInputChange: setManuallyTypedInputValue,
      ...props
    })
  });
}

const slideIn = _emotion_react__WEBPACK_IMPORTED_MODULE_6__/* .keyframes */ .F4`
  from {
    transform: translateX(50px);
  }
  to {
    transform: translateX(0);
  }
`;
function SearchDrawer({
  className,
  onSubmit,
  onSubmitItem,
  ...searchProps
}) {
  const theme = (0,_emotion_react__WEBPACK_IMPORTED_MODULE_13__.u)();
  const {
    localeData
  } = useGNBData();
  const [open, setOpen] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false);
  const drawerAnimation = {
    drawer: slideIn
  };
  const handleDrawerOpen = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(() => {
    setOpen(true);
  }, []);
  const handleDrawerClose = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(() => {
    setOpen(false);
  }, []);
  const handleSubmit = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(value => {
    setOpen(false);
    onSubmit?.(value);
  }, [onSubmit]);
  const handleSubmitItem = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(item => {
    setOpen(false);
    onSubmitItem?.(item);
  }, [onSubmitItem]);
  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsxs */ .BX)("div", {
    css: className,
    children: [(0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)("button", {
      type: "button",
      css: [/*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_6__/* .css */ .iv)(_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.R, " padding:", (0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.p)(6), ";margin:", (0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.p)(3), " ", (0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.p)(1), ";color:", theme.content.base1, ";line-height:0;outline:none;" + ( true ? "" : 0),  true ? "" : 0), _bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.H`
            color: ${theme.content.primary1.basic};
          `, _bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.g`
            color: ${theme.content.primary1.basic};
          `,  true ? "" : 0,  true ? "" : 0],
      onClick: handleDrawerOpen,
      children: (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(_bucketplace_design_system_bds__WEBPACK_IMPORTED_MODULE_8__/* .Icon */ .JO$, {
        name: "search",
        size: 24
      })
    }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(_bucketplace_design_system_bds__WEBPACK_IMPORTED_MODULE_8__/* .Drawer */ .dys, {
      open: open,
      align: "right",
      onClose: handleDrawerClose,
      animationKeyframes: drawerAnimation,
      containerCss: /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_6__/* .css */ .iv)((0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.s)('bottom', 'padding-bottom'), " ", _bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.M.min('tablet', `
            min-width: ${(0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.p)(256)};
            max-width: ${(0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.p)(326)};
            padding: ${(0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.p)(30)};
          `), ";" + ( true ? "" : 0),  true ? "" : 0),
      children: (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(NavigationSearch, {
        ...searchProps,
        onSubmit: handleSubmit,
        onSubmitItem: handleSubmitItem,
        isInputAutoFocused: true,
        renderInputRight: () => (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)("button", {
          type: "button",
          onClick: handleDrawerClose,
          css: [/*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_6__/* .css */ .iv)(_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.R, " flex-shrink:0;margin-left:", (0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.p)(15), ";padding:", (0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.p)(9), " ", (0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.p)(5), " ", (0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.p)(10), ";color:", theme.content.base1, ";font-size:", (0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.p)(15), ";line-height:1;font-weight:700;outline:none;", _bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.M.min('tablet', `
                    display: none;
                  `), ";" + ( true ? "" : 0),  true ? "" : 0), _bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.g`
                  & > span {
                    box-shadow: 0 0 0 ${(0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.p)(3)} ${theme.interactive.primary1.thin};
                  }
                `,  true ? "" : 0,  true ? "" : 0],
          children: (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)("span", {
            css: /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_6__/* .css */ .iv)("display:inline-block;margin:", (0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.p)(-4), ";padding:", (0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.p)(4), ";border-radius:", (0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.p)(2), ";" + ( true ? "" : 0),  true ? "" : 0),
            children: localeData?.search?.closeDrawer ?? '취소'
          })
        })
      })
    })]
  });
}

function _EMOTION_STRINGIFIED_CSS_ERROR__$6() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
var _ref$5 =  true ? {
  name: "bjn8wh",
  styles: "position:relative"
} : 0;
function UploadDropdownContentItem({
  href,
  icon,
  title,
  subtitle,
  logId
}) {
  const theme = (0,_emotion_react__WEBPACK_IMPORTED_MODULE_13__.u)();
  const LinkComponent = useLinkContext();
  const log = useLogContext();
  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsxs */ .BX)(LinkComponent, {
    role: "link",
    href: href,
    css: [/*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_6__/* .css */ .iv)("display:flex;align-items:center;padding:", (0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.p)(15), ";background-color:", theme.background.base, ";border-radius:", (0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.p)(2), ";transition:.1s background-color;word-break:keep-all;white-space:nowrap;font-size:", (0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.p)(15), ";line-height:0;outline:none;" + ( true ? "" : 0),  true ? "" : 0), _bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.H`
          background-color: ${theme.background.groupedBase};
        `, _bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.g`
          background-color: ${theme.background.groupedBase};
        `,  true ? "" : 0,  true ? "" : 0],
    onClick: () => {
      if (logId) {
        log({
          key: logId,
          category: 'click'
        });
      }
    },
    children: [(0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)("div", {
      css: _ref$5,
      children: icon
    }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsxs */ .BX)("div", {
      css: /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_6__/* .css */ .iv)("margin-left:", (0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.p)(12), ";" + ( true ? "" : 0),  true ? "" : 0),
      children: [(0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)("div", {
        css: /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_6__/* .css */ .iv)("font-size:", (0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.p)(15), ";font-weight:bold;line-height:", (0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.p)(21), ";color:", theme.content.base1, ";" + ( true ? "" : 0),  true ? "" : 0),
        children: title
      }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)("div", {
        css: /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_6__/* .css */ .iv)("margin:", (0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.p)(4), " 0 0;font-size:", (0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.p)(12), ";line-height:", (0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.p)(16), ";color:", theme.content.base2, ";" + ( true ? "" : 0),  true ? "" : 0),
        children: subtitle
      })]
    })]
  });
}

function _EMOTION_STRINGIFIED_CSS_ERROR__$5() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
const BUTTON_SIZE = 40;
var _ref$4 =  true ? {
  name: "12whrtl",
  styles: "outline:none;overflow:hidden"
} : 0;
function UploadDropdownContentButton({
  uploadMenuLinks
}) {
  const theme = (0,_emotion_react__WEBPACK_IMPORTED_MODULE_13__.u)();
  const log = useLogContext();
  const {
    gap,
    iconSize
  } = (0,_bucketplace_design_system_bds__WEBPACK_IMPORTED_MODULE_8__/* .getWithIconOptions */ .j6W)(BUTTON_SIZE);
  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(_bucketplace_design_system_bds__WEBPACK_IMPORTED_MODULE_8__/* .Popper */ .rDy, {
    usePortal: false,
    renderButton: ({
      onClick
    }) => (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsxs */ .BX)(_bucketplace_design_system_bds__WEBPACK_IMPORTED_MODULE_8__/* .Button */ .zxk, {
      role: "button",
      variant: "primary1",
      size: BUTTON_SIZE,
      type: "button",
      css: [_ref$4, _bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.g`
              box-shadow: 0 0 0 ${(0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.p)(3)} ${theme.interactive.primary1.thin};
            `,  true ? "" : 0,  true ? "" : 0],
      onClick: () => {
        onClick();
        log({
          key: 'primary.right.upload',
          category: 'click'
        });
      },
      children: [(0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)("span", {
        css: /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_6__/* .css */ .iv)("vertical-align:middle;white-space:nowrap;", _bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.M.min('laptop', `
                margin-right: ${(0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.p)(gap)};
              `), ";" + ( true ? "" : 0),  true ? "" : 0),
        children: "\uAE00\uC4F0\uAE30"
      }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(_bucketplace_design_system_bds__WEBPACK_IMPORTED_MODULE_8__/* .Icon */ .JO$, {
        css: /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_6__/* .css */ .iv)("vertical-align:middle;display:none;", _bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.M.min('laptop', `
                display: inline-block;
              `), ";" + ( true ? "" : 0),  true ? "" : 0),
        name: "chevron_down",
        size: iconSize
      })]
    }),
    children: uploadMenuLinks && uploadMenuLinks.map(item => (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(UploadDropdownContentItem, {
      ...item
    }, item.title))
  });
}

function _EMOTION_STRINGIFIED_CSS_ERROR__$4() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
var _ref$3 =  true ? {
  name: "1dnrp50",
  styles: "vertical-align:middle;margin:0 1.5px 1.5px 0"
} : 0;
function UserDropdownContentItem({
  bullet,
  title,
  href,
  onClick,
  logId
}) {
  const theme = (0,_emotion_react__WEBPACK_IMPORTED_MODULE_13__.u)();
  const LinkComponent = useLinkContext();
  const log = useLogContext();
  const Component = href ? LinkComponent : 'button';
  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsxs */ .BX)(Component, {
    ...(Component === LinkComponent ? {
      href
    } : {
      type: 'button'
    }),
    css: [/*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_6__/* .css */ .iv)("display:block;position:relative;width:100%;margin:0;padding:", (0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.p)(10), " ", (0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.p)(14), " ", (0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.p)(11), ";box-sizing:border-box;border:none;background:", theme.background.base, ";color:", theme.content.base1, ";font-family:inherit;font-weight:normal;font-size:", (0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.p)(15), ";line-height:", (0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.p)(21), ";text-decoration:none;text-align:left;cursor:pointer;border-radius:", (0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.p)(2), ";outline:none;" + ( true ? "" : 0),  true ? "" : 0), _bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.H`
          background: ${theme.background.groupedBase};
        `, _bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.g`
          background: ${theme.background.groupedBase};
        `,  true ? "" : 0,  true ? "" : 0],
    onClick: () => {
      if (logId) {
        log({
          key: 'primary.right.user.dropdown',
          category: 'click',
          params: {
            id: logId
          }
        });
      }
      if (onClick) {
        onClick();
      }
    },
    children: [title, bullet === 'new' && (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(NewIcon, {
      "data-testid": "new-icon",
      css: _ref$3
    })]
  });
}

function _EMOTION_STRINGIFIED_CSS_ERROR__$3() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
const DEFAULT_PROFILE_URL = 'https://image.ohou.se/i/bucketplace-v2-development/uploads/users/profile_images1542987307_LkcmI.jpeg';
var _ref$2 =  true ? {
  name: "xnm8en",
  styles: "vertical-align:middle;width:100%;height:100%;object-fit:cover"
} : 0;
function UserDropdownContentButton({
  profileUrl,
  userMenu
}) {
  const theme = (0,_emotion_react__WEBPACK_IMPORTED_MODULE_13__.u)();
  const items = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(() => userMenu.filter(menu => menu.showOn?.includes('bar')), [userMenu]);
  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(_bucketplace_design_system_bds__WEBPACK_IMPORTED_MODULE_8__/* .Popper */ .rDy, {
    usePortal: false,
    renderButton: ({
      onClick
    }) => (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)("button", {
      css: [/*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_6__/* .css */ .iv)(_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.R, " position:relative;overflow:hidden;width:", (0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.p)(40), ";height:", (0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.p)(40), ";border-radius:100%;outline:none;&:after{content:'';display:none;position:absolute;top:0;left:0;width:100%;height:100%;border-radius:100%;border:", (0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.p)(2), " solid ", theme.content.primary1.basic, ";box-sizing:border-box;}" + ( true ? "" : 0),  true ? "" : 0), _bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.H`
              &:after {
                display: block;
              }
            `, _bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.g`
              &:after {
                display: block;
              }
            `,  true ? "" : 0,  true ? "" : 0],
      type: "button",
      onClick: onClick,
      "aria-label": "\uD504\uB85C\uD544 \uBA54\uB274",
      children: (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(_bucketplace_ui__WEBPACK_IMPORTED_MODULE_4__/* .ResizeImage */ .ux, {
        width: 40,
        aspect: 1,
        src: profileUrl || DEFAULT_PROFILE_URL,
        alt: "\uD504\uB85C\uD544 \uC0AC\uC9C4",
        css: _ref$2
      })
    }),
    children: (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)("div", {
      css: /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_6__/* .css */ .iv)("width:", (0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.p)(184), ";" + ( true ? "" : 0),  true ? "" : 0),
      children: items.map((item, index) => (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(UserDropdownContentItem, {
        ...item
      }, index))
    })
  });
}

function NoLoginMenuItem({
  component = 'a',
  label,
  href,
  logKey,
  ...rest
}) {
  const theme = (0,_emotion_react__WEBPACK_IMPORTED_MODULE_13__.u)();
  const Component = component;
  const log = useLogContext();
  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(Component, {
    ...rest,
    href: href,
    css: /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_6__/* .css */ .iv)(_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.F.subTitle2, ";color:", theme.content.base1, ";padding:0 10px;border-left:1px solid ", theme.content.base4, ";&:first-of-type{border-left:none;}" + ( true ? "" : 0),  true ? "" : 0),
    onClick: () => log({
      key: logKey,
      category: 'click'
    }),
    children: label
  });
}

const SELLER_USERABLE_TYPE = 'SalesUser';
var SellerButton = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_0__.memo)(({
  userableType,
  ...rest
}) => {
  if (userableType !== SELLER_USERABLE_TYPE) {
    return null;
  }
  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(_bucketplace_design_system_bds__WEBPACK_IMPORTED_MODULE_8__/* .OutlineAnchorButton */ .Ths, {
    css: /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_6__/* .css */ .iv)("display:none;margin-left:8px;", _bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.M.min('laptop', `
          display: flex;
          align-items: center;
        `), ";" + ( true ? "" : 0)),
    variant: "base1",
    size: 40,
    ...rest,
    children: "\uD310\uB9E4\uC790 \uC804\uC6A9\uC11C\uBE44\uC2A4"
  });
});

function _EMOTION_STRINGIFIED_CSS_ERROR__$2() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
var _ref$1 =  true ? {
  name: "1kpxvh4",
  styles: "display:flex;margin:0 10px 0 8px"
} : 0;
var _ref2$1 =  true ? {
  name: "10vibjk",
  styles: "display:flex;align-items:center;justify-content:flex-end;line-height:0"
} : 0;
function PrimaryRight({
  searchProps,
  userProfile,
  userMenu,
  scrap,
  cart,
  notification,
  signin,
  signup,
  cs,
  seller,
  uploadMenuLinks,
  showChangeLanguageButton = false
}) {
  const LinkComponent = useLinkContext();
  const log = useLogContext();
  const {
    userId,
    imageUrl
  } = userProfile || {};
  const loggedIn = userId != null;
  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsxs */ .BX)("div", {
    css: _ref2$1,
    children: [searchProps && (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsxs */ .BX)(_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .Fragment */ .HY, {
      children: [(0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(NavigationSearch, {
        css: /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_6__/* .css */ .iv)("flex:1 1 0px;min-width:0;margin-right:", (0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.p)(9), ";", _bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.M.min('desktop', `
                margin-right: ${(0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.p)(14)};
              `), " ", _bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.M.max('tablet', `
                display: none;
              `), ";" + ( true ? "" : 0),  true ? "" : 0),
        ...searchProps
      }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(SearchDrawer, {
        css: /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_6__/* .css */ .iv)(_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.M.min('laptop', `
                display: none;
              `), ";" + ( true ? "" : 0),  true ? "" : 0),
        ...searchProps
      })]
    }), showChangeLanguageButton && (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(ChangeLanguageButton, {}), scrap && (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)("div", {
      css: /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_6__/* .css */ .iv)(_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.M.max('mobile', `
            display: none;
          `), ";" + ( true ? "" : 0),  true ? "" : 0),
      children: (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(_bucketplace_design_system_bds__WEBPACK_IMPORTED_MODULE_8__/* .IconNotification */ .pPA, {
        iconName: "scrap_outline",
        type: _bucketplace_design_system_bds__WEBPACK_IMPORTED_MODULE_8__/* .NotificationType.None */ .k$E.None,
        component: LinkComponent,
        "aria-label": "\uC2A4\uD06C\uB7A9\uBD81 \uD398\uC774\uC9C0 \uB9C1\uD06C \uBC84\uD2BC",
        href: scrap.href,
        onClick: () => log({
          key: 'primary.right.scrap',
          category: 'click'
        })
      })
    }), notification && (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)("div", {
      css: /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_6__/* .css */ .iv)(_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.M.max('mobile', `
              display: none;
            `), ";" + ( true ? "" : 0),  true ? "" : 0),
      children: (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(_bucketplace_design_system_bds__WEBPACK_IMPORTED_MODULE_8__/* .IconNotification */ .pPA, {
        iconName: "notification_outline",
        type: _bucketplace_design_system_bds__WEBPACK_IMPORTED_MODULE_8__/* .NotificationType.Number */ .k$E.Number,
        count: notification.count,
        component: LinkComponent,
        href: notification.href,
        "aria-label": "\uB0B4\uC18C\uC2DD \uD398\uC774\uC9C0 \uB9C1\uD06C \uBC84\uD2BC",
        onClick: () => log({
          key: 'primary.right.notification',
          category: 'click'
        })
      })
    }), cart && (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(_bucketplace_design_system_bds__WEBPACK_IMPORTED_MODULE_8__/* .IconNotification */ .pPA, {
      iconName: "cart",
      type: _bucketplace_design_system_bds__WEBPACK_IMPORTED_MODULE_8__/* .NotificationType.Number */ .k$E.Number,
      count: cart.count,
      component: LinkComponent,
      href: cart.href,
      "aria-label": "\uC7A5\uBC14\uAD6C\uB2C8 \uD398\uC774\uC9C0 \uB9C1\uD06C \uBC84\uD2BC",
      onClick: () => log({
        key: 'primary.right.cart',
        category: 'click'
      })
    }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsxs */ .BX)("div", {
      css: /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_6__/* .css */ .iv)("display:flex;align-items:center;", _bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.M.max('mobile', `
            display: none;
          `), ";" + ( true ? "" : 0),  true ? "" : 0),
      children: [loggedIn && (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)("div", {
        css: /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_6__/* .css */ .iv)("margin:0 ", (0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.p)(12), " 0 ", (0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.p)(5), ";", _bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.M.min('laptop', `
                margin: 0 ${(0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.p)(16)} 0 ${(0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.p)(9)};
              `), " ", _bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.M.min('desktop', `
                margin: 0 ${(0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.p)(20)} 0 ${(0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.p)(13)};
              `), ";" + ( true ? "" : 0),  true ? "" : 0),
        children: (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(UserDropdownContentButton, {
          profileUrl: imageUrl,
          userMenu: userMenu
        })
      }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsxs */ .BX)("div", {
        css: _ref$1,
        children: [signin && (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(NoLoginMenuItem, {
          label: signin.title,
          href: signin.href,
          component: LinkComponent,
          logKey: "primary.right.login"
        }), signup && (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(NoLoginMenuItem, {
          label: signup.title,
          href: signup.href,
          component: LinkComponent,
          logKey: "primary.right.signup"
        }), cs && (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(NoLoginMenuItem, {
          label: cs.title,
          href: cs.href,
          component: LinkComponent,
          logKey: "primary.right.cs",
          css: /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_6__/* .css */ .iv)(_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.M.max('laptop', `
                  display: none;
                `), ";" + ( true ? "" : 0),  true ? "" : 0)
        })]
      }), uploadMenuLinks && uploadMenuLinks.length > 0 && (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(UploadDropdownContentButton, {
        uploadMenuLinks: uploadMenuLinks
      }), seller && (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(SellerButton, {
        href: seller.href
      })]
    })]
  });
}

function useFocusedLatch(onChange) {
  const focusRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
  const handleFocusIn = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(() => {
    if (focusRef.current != null) {
      cancelAnimationFrame(focusRef.current);
    }
    onChange(true);
  }, [onChange]);
  const handleFocusOut = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(() => {
    if (focusRef.current != null) {
      cancelAnimationFrame(focusRef.current);
    }
    focusRef.current = requestAnimationFrame(() => onChange(false));
  }, [onChange]);
  return [handleFocusIn, handleFocusOut];
}

function _EMOTION_STRINGIFIED_CSS_ERROR__$1() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
function NavigationBar(props) {
  const log = useLogContext();
  const {
    logo,
    primaryLeftmost,
    menuSchema,
    fallbackMenuSchema,
    searchOptions,
    supplementary
  } = props;
  const [{
    isHovered,
    selectedIds
  }, setState] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)({
    isHovered: false,
    selectedIds: null
  });
  const setHovered = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(value => {
    setState(prevState => ({
      ...prevState,
      isHovered: value,
      selectedIds: !value ? null : prevState.selectedIds
    }));
  }, []);
  const [onMouseEnter, onMouseLeave] = useFocusedLatch(setHovered);
  const activeIds = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(() => getActiveIds(menuSchema, fallbackMenuSchema), [menuSchema, fallbackMenuSchema]);
  const currentSelectedIds = selectedIds == null ? activeIds : selectedIds;
  const primaryEntries = menuSchema;
  const activePrimaryItem = activeIds[0] != null ? primaryEntries[activeIds[0]] : null;
  const primaryItem = currentSelectedIds[0] != null ? primaryEntries[currentSelectedIds[0]] : null;
  const secondaryEntries = getSecondaryEntries({
    primary: primaryItem ?? null,
    activeIds,
    fallbackMenuSchema
  });
  const secondaryItem = currentSelectedIds[1] != null ? secondaryEntries[currentSelectedIds[1]] : null;
  const hasFallbackMenuSchema = fallbackMenuSchema != null && fallbackMenuSchema.length > 0;
  const handlePrimarySelect = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)((_, index) => {
    setState(prevState => ({
      ...prevState,
      selectedIds: [index]
    }));
  }, []);
  const handleSecondarySelect = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)((_, index) => {
    setState(prevState => ({
      ...prevState,
      selectedIds: [currentSelectedIds[0] ?? null, index]
    }));
  }, [currentSelectedIds]);
  const CustomPrimaryRight = supplementary.primaryRight ?? null;
  const showTertiary = selectedIds != null && selectedIds[1] != null && secondaryItem != null && secondaryItem.renderBarChild != null;
  const secondaryRightElement = supplementary.secondaryRight != null ? /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(supplementary.secondaryRight) : null;
  const hasItemInActivedPrimaryItem = activePrimaryItem != null && activePrimaryItem.entries != null ? activePrimaryItem.entries.length > 0 : false;
  const hasItemInHoveredPrimaryItem = primaryItem != null && primaryItem.entries != null ? primaryItem.entries.length > 0 : false;
  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsxs */ .BX)("header", {
    children: [(0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(NavigationBarPrimary, {
      leftmost: primaryLeftmost,
      left: (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(StyledLogo, {
        logo: logo,
        onClick: () => {
          log({
            key: 'logo',
            category: 'click'
          });
        }
      }),
      right: CustomPrimaryRight ? (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(CustomPrimaryRightContainer, {
        children: (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(CustomPrimaryRight, {})
      }) : (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(PrimaryRight, {
        searchProps: searchOptions,
        ...supplementary
      }),
      menuEntries: primaryEntries,
      activeId: activeIds[0] ?? null,
      selectedId: currentSelectedIds[0] ?? null,
      onMouseEnter: onMouseEnter,
      onMouseLeave: onMouseLeave,
      onSelect: handlePrimarySelect
    }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(NavigationBarSecondary, {
      right: secondaryRightElement,
      menuEntries: secondaryEntries,
      hasItems: hasItemInActivedPrimaryItem || hasItemInHoveredPrimaryItem || hasFallbackMenuSchema,
      activeId: currentSelectedIds[0] === activeIds[0] || activeIds[1] ? activeIds[1] ?? null : null,
      primaryId: currentSelectedIds[0] ?? null,
      isForceOpened: isHovered && secondaryEntries.length > 0,
      isFallback: currentSelectedIds[0] == null && hasFallbackMenuSchema,
      onMouseEnter: onMouseEnter,
      onMouseLeave: onMouseLeave,
      onSelect: handleSecondarySelect,
      scrollableEntries: primaryItem?.scrollableEntries
    }), showTertiary && (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(NavigationBarTertiary, {
      item: showTertiary ? secondaryItem : null,
      isOpen: showTertiary,
      onMouseEnter: onMouseEnter,
      onMouseLeave: onMouseLeave
    })]
  });
}
const StyledLogo = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(Logo,  true ? {
  target: "e1d4t2q81"
} : 0)("height:", (0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.p)(26), ";", _bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.M.min('tablet', /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_6__/* .css */ .iv)("height:", (0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.p)(30), ";" + ( true ? "" : 0),  true ? "" : 0)), ";" + ( true ? "" : 0));
const CustomPrimaryRightContainer = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)("div",  true ? {
  target: "e1d4t2q80"
} : 0)(_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.M.max('mobile',  true ? {
  name: "eivff4",
  styles: "display:none"
} : 0), ";" + ( true ? "" : 0));

/** Secondary 메뉴 스키마를 리턴합니다 */
function getSecondaryEntries({
  primary,
  activeIds,
  fallbackMenuSchema
}) {
  if (primary != null) {
    return primary.entries ?? [];
  }
  if (activeIds[1] != null) {
    return fallbackMenuSchema ?? [];
  }
  return [];
}

function Navigation(props) {
  const {
    logo,
    menuSchema,
    searchOptions,
    supplementary,
    fallbackMenuSchema,
    linkComponent,
    onLog,
    onAppDownload,
    location
  } = props;
  const [isDrawerOpen, setDrawerOpen] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false);
  const handleDrawerToggle = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(() => {
    setDrawerOpen(v => !v);
  }, []);
  const handleDrawerClose = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(() => {
    setDrawerOpen(false);
  }, []);
  const isInApp = (0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_12__.e)(location);
  if (isInApp) {
    return null;
  }
  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(LinkProvider, {
    linkComponent: linkComponent,
    children: (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(LogProvider, {
      onLog: onLog,
      children: (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsxs */ .BX)(_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .Fragment */ .HY, {
        children: [(0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(NavigationBar, {
          logo: logo,
          menuSchema: menuSchema,
          primaryLeftmost: (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(Button, {
            type: "button",
            onClick: () => {
              onLog({
                key: 'drawer.button',
                category: 'click'
              });
              handleDrawerToggle();
            },
            children: (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(_bucketplace_design_system_bds__WEBPACK_IMPORTED_MODULE_8__/* .Icon */ .JO$, {
              size: 24,
              name: "menu"
            })
          }),
          searchOptions: searchOptions,
          supplementary: supplementary,
          fallbackMenuSchema: fallbackMenuSchema
        }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(NavigationDrawer, {
          open: isDrawerOpen,
          logo: logo,
          menuSchema: menuSchema,
          supplementary: supplementary,
          onOpen: handleDrawerToggle,
          onClose: handleDrawerClose,
          onAppDownload: onAppDownload
        })]
      })
    })
  });
}
const Button = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)("button",  true ? {
  target: "e7erebj0"
} : 0)(_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.R, " padding:", (0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.p)(6), ";margin:", (0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.p)(3), " ", (0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.p)(1), ";color:", ({
  theme
}) => theme.content.base1, ";outline:none;" + ( true ? "" : 0));

function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
var _ref =  true ? {
  name: "10qs83r",
  styles: "display:block;margin:20px -10px 0;line-height:1"
} : 0;
var _ref2 =  true ? {
  name: "d0zu4q",
  styles: "position:relative;display:block;width:80px;height:80px;&>img{position:absolute;top:0;left:0;width:100%;border:0;}"
} : 0;
var _ref3 =  true ? {
  name: "dg5hsf",
  styles: "display:block;padding:10px 0;font-size:14px;font-weight:bold;text-align:center"
} : 0;
var _ref4 =  true ? {
  name: "laomuu",
  styles: "padding-right:60px"
} : 0;
var _ref5 =  true ? {
  name: "v61o11",
  styles: "max-width:1276px;padding:10px 0 10px 60px"
} : 0;
var _ref6 =  true ? {
  name: "1qmr6ab",
  styles: "overflow:auto"
} : 0;
function StoreCategory({
  categories
}) {
  const Link = useLinkContext();
  const log = useLogContext();
  const theme = (0,_emotion_react__WEBPACK_IMPORTED_MODULE_13__.u)();
  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)("div", {
    css: _ref6,
    children: (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)("ul", {
      css: /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_6__/* .css */ .iv)("display:flex;justify-content:space-between;margin:0 auto;padding:10px 0 10px 40px;box-sizing:border-box;", _bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.M.min('laptop', _ref5), ";" + ( true ? "" : 0),  true ? "" : 0),
      children: categories.map((category, index) => (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)("li", {
        css: /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_6__/* .css */ .iv)("flex:0 0 auto;margin:0;padding:0 0 0 10px;color:", category.active ? theme.content.primary1.basic : theme.content.base1, ";&:last-of-type{padding-right:40px;", _bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.M.min('laptop', _ref4), ";}&:hover{color:", theme.content.primary1.basic, ";}" + ( true ? "" : 0),  true ? "" : 0),
        children: (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsxs */ .BX)(Link, {
          "data-testid": `category-${category.title}-link`,
          href: category.href,
          onClick: () => {
            log({
              key: 'tertiary.store.category.item',
              category: 'click',
              params: {
                id: category.logId,
                index
              }
            });
          },
          css: _ref3,
          children: [(0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)("span", {
            css: _ref2,
            children: category.icon
          }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)("span", {
            css: _ref,
            children: category.title
          })]
        })
      }, category.title))
    })
  });
}

/* eslint-disable camelcase */

const TYPE_MAP = {
  'logo': () => ({
    click: {
      bucket: {
        section: '로고'
      }
    }
  }),
  // primary
  'primary.item': ({
    index
  }) => ({
    click: {
      bucket: {
        section: '메인 메뉴',
        index
      }
    }
  }),
  'primary.right.search.input': ({
    search_type
  }) => ({
    click: {
      bucket: {
        section: '검색'
      },
      amplitude: {
        type: '검색 필드 Clicked',
        search_type
      }
    }
  }),
  'primary.right.search.autocomplete.query': ({
    id,
    type,
    index
  }) => ({
    click: {
      bucket: {
        section: '자동완성',
        id,
        type,
        index
      }
    }
  }),
  'primary.right.search.autocomplete.category': ({
    id,
    type,
    index
  }) => ({
    click: {
      bucket: {
        section: '추천 카테고리',
        id,
        type,
        index
      }
    }
  }),
  'primary.right.search.history': ({
    id,
    type,
    index
  }) => ({
    click: {
      bucket: {
        section: '최근 검색어',
        id,
        type,
        index
      }
    },
    impression: {
      bucket: {
        section: '최근 검색어',
        type
      }
    }
  }),
  'primary.right.scrap': () => ({
    click: {
      bucket: {
        section: '스크랩북'
      },
      amplitude: {
        type: '스크랩북 Viewed',
        data: {
          source: {
            page: {
              tab: {
                main: '스크랩북'
              }
            },
            referrer: {
              type: '바로가기'
            }
          }
        }
      }
    }
  }),
  'primary.right.cart': () => ({
    click: {
      bucket: {
        section: '장바구니'
      }
    }
  }),
  'primary.right.notification': () => ({
    click: {
      bucket: {
        section: '알림'
      },
      amplitude: {
        type: '알림 리스트 Viewed'
      }
    }
  }),
  'primary.right.login': () => ({
    click: {
      bucket: {
        section: '로그인'
      }
    }
  }),
  'primary.right.signup': () => ({
    click: {
      bucket: {
        section: '회원가입'
      }
    }
  }),
  'primary.right.cs': () => ({
    click: {
      bucket: {
        section: '고객센터'
      }
    }
  }),
  'primary.right.user.dropdown': ({
    id
  }) => ({
    click: {
      bucket: {
        section: 'user_menu',
        section_id: id
      }
    }
  }),
  'primary.right.mypage': () => ({
    click: {
      amplitude: {
        type: '계정 Viewed'
      }
    }
  }),
  'primary.right.logout': () => ({
    click: {
      amplitude: {
        type: '계정 Logout'
      }
    }
  }),
  'primary.right.upload': () => ({
    click: {
      bucket: {
        section: '글쓰기'
      }
    }
  }),
  'primary.right.upload.photo': () => ({
    click: {
      bucket: {
        section: '사진 올리기'
      }
    }
  }),
  // secondary
  'secondary.item': ({
    index,
    href,
    ...rest
  }) => ({
    click: {
      bucket: {
        index,
        url: typeof href === 'string' ? href : '/',
        ...rest
      }
    },
    impression: {
      bucket: {
        index,
        ...rest
      }
    }
  }),
  'secondary.interior': () => ({
    click: {
      bucket: {
        section: '3D인테리어'
      }
    }
  }),
  'secondary.more.button': () => ({
    click: {
      bucket: {
        section: '토픽',
        section_id: 'TOPIC',
        type: 'button',
        id: 'more_button'
      }
    }
  }),
  // tertiary
  'tertiary.store.category.item': ({
    id,
    index
  }) => ({
    click: {
      bucket: {
        section: '카테고리 메뉴',
        type: 'category',
        id,
        index
      }
    }
  }),
  // drawer
  'drawer.logo': () => ({
    click: {
      bucket: {
        section: 'drawer 로고'
      }
    }
  }),
  'drawer.button': () => ({
    click: {
      bucket: {
        section: '햄버거 메뉴'
      }
    }
  }),
  'drawer.main.item': ({
    index
  }) => ({
    click: {
      bucket: {
        section: '메인 메뉴',
        index
      }
    }
  }),
  'drawer.sub.item': ({
    index,
    href
  }) => ({
    click: {
      bucket: {
        section: '서브 메뉴',
        index,
        url: typeof href === 'string' ? href : '/'
      }
    }
  }),
  'drawer.user.item': ({
    index
  }) => ({
    click: {
      bucket: {
        section: '유저 메뉴',
        index
      }
    }
  }),
  'drawer.user.profile': () => ({
    click: {
      bucket: {
        section: '유저 프로필'
      },
      amplitude: {
        type: '계정 Viewed'
      }
    }
  })
};

const SEARCH_TYPE = {
  TOTAL: 'total',
  STORE: 'store',
  EXPERT: 'expert_user'
};

const getSearchPathname = searchType => {
  switch (searchType) {
    case SEARCH_TYPE.STORE:
      return 'commerce';
    case SEARCH_TYPE.EXPERT:
      return 'expert';
    case SEARCH_TYPE.TOTAL:
    default:
      return 'integrated';
  }
};
const SEARCH_ITEM_TYPE = ['query', 'category', 'consulting', 'history'];
const getDomesticAutoCompleteKeywords = async ({
  env,
  searchType,
  query
}) => {
  const searchPathname = getSearchPathname(searchType);

  /** @see {https://www.notion.so/ohouse/integrated-4a4eeee9b22340faa3dbb3b4e7c83f25?pvs=4} */
  const response = await fetchGet(`${API_AUTOCOMPLETE_HOST[env]}/${searchPathname}?query=${query}&v=v2`, {
    headers: {}
  });
  const data = await response.json();
  return data;
};
const formatAutoCompleteKeywords = data => {
  const autoCompleteKeywords = humpsExports.camelizeKeys(data.results);
  return autoCompleteKeywords.map(item => ({
    type: item.dataType,
    value: item,
    query: item.orgDisplay
  })).filter(item => SEARCH_ITEM_TYPE.includes(item.type));
};

const defaultSignOut = async ({
  user,
  env
}) => {
  const isPro = user?.userableType === 'ExpertUser';
  const res = await fetchDelete(`${DOMAINS[env].home}/users/sign_out.json`, {
    data: {
      is_pro: isPro
    }
  }, {
    headers: {},
    credentials: 'include'
  });
  return res.json();
};

const filterHistory = (history, query) => {
  return typeof history === 'string' ? history !== query : history.query !== query;
};

/** 최근 검색어 데이터들을 다루는 storage를 생성합니다. */
const createSearchHistoryStorage = ({
  env,
  subdomain,
  serviceType
}) => {
  const SearchHistoryStorage = {
    get: () => {
      const matches = document.cookie.match(
      // eslint-disable-next-line prefer-regex-literals
      new RegExp('(?:^|; )searchHistory=([^;]*)'));
      if (matches) {
        try {
          return JSON.parse(decodeURIComponent(matches[1] ?? ''));
        } catch {
          return [];
        }
      }
      return [];
    },
    set: histories => {
      const value = encodeURIComponent(JSON.stringify(histories.slice(0, 5)));
      const cookieDomain = getCookieDomain(env, subdomain, serviceType);
      document.cookie = `searchHistory=${value}; domain=${cookieDomain}; max-age=2147483647; path=/`;
    },
    append: history => {
      const query = typeof history === 'string' ? history : history.query;
      SearchHistoryStorage.set([history, ...SearchHistoryStorage.get().filter(history => filterHistory(history, query))]);
    },
    remove: history => {
      const query = typeof history === 'string' ? history : history.query;
      SearchHistoryStorage.set(SearchHistoryStorage.get().filter(history => filterHistory(history, query)));
    },
    removeAll: () => {
      SearchHistoryStorage.set([]);
    }
  };
  return SearchHistoryStorage;
};

var queryString = {};

var strictUriEncode = str => encodeURIComponent(str).replace(/[!'()*]/g, x => `%${x.charCodeAt(0).toString(16).toUpperCase()}`);

var token = '%[a-f0-9]{2}';
var singleMatcher = new RegExp('(' + token + ')|([^%]+?)', 'gi');
var multiMatcher = new RegExp('(' + token + ')+', 'gi');
function decodeComponents(components, split) {
  try {
    // Try to decode the entire string first
    return [decodeURIComponent(components.join(''))];
  } catch (err) {
    // Do nothing
  }
  if (components.length === 1) {
    return components;
  }
  split = split || 1;

  // Split the array in 2 parts
  var left = components.slice(0, split);
  var right = components.slice(split);
  return Array.prototype.concat.call([], decodeComponents(left), decodeComponents(right));
}
function decode(input) {
  try {
    return decodeURIComponent(input);
  } catch (err) {
    var tokens = input.match(singleMatcher) || [];
    for (var i = 1; i < tokens.length; i++) {
      input = decodeComponents(tokens, i).join('');
      tokens = input.match(singleMatcher) || [];
    }
    return input;
  }
}
function customDecodeURIComponent(input) {
  // Keep track of all the replacements and prefill the map with the `BOM`
  var replaceMap = {
    '%FE%FF': '\uFFFD\uFFFD',
    '%FF%FE': '\uFFFD\uFFFD'
  };
  var match = multiMatcher.exec(input);
  while (match) {
    try {
      // Decode as big chunks as possible
      replaceMap[match[0]] = decodeURIComponent(match[0]);
    } catch (err) {
      var result = decode(match[0]);
      if (result !== match[0]) {
        replaceMap[match[0]] = result;
      }
    }
    match = multiMatcher.exec(input);
  }

  // Add `%C2` at the end of the map to make sure it does not replace the combinator before everything else
  replaceMap['%C2'] = '\uFFFD';
  var entries = Object.keys(replaceMap);
  for (var i = 0; i < entries.length; i++) {
    // Replace all decoded components
    var key = entries[i];
    input = input.replace(new RegExp(key, 'g'), replaceMap[key]);
  }
  return input;
}
var decodeUriComponent = function (encodedURI) {
  if (typeof encodedURI !== 'string') {
    throw new TypeError('Expected `encodedURI` to be of type `string`, got `' + typeof encodedURI + '`');
  }
  try {
    encodedURI = encodedURI.replace(/\+/g, ' ');

    // Try the built in decoder first
    return decodeURIComponent(encodedURI);
  } catch (err) {
    // Fallback to a more advanced decoder
    return customDecodeURIComponent(encodedURI);
  }
};

var splitOnFirst = (string, separator) => {
  if (!(typeof string === 'string' && typeof separator === 'string')) {
    throw new TypeError('Expected the arguments to be of type `string`');
  }
  if (separator === '') {
    return [string];
  }
  const separatorIndex = string.indexOf(separator);
  if (separatorIndex === -1) {
    return [string];
  }
  return [string.slice(0, separatorIndex), string.slice(separatorIndex + separator.length)];
};

var filterObj = function (obj, predicate) {
  var ret = {};
  var keys = Object.keys(obj);
  var isArr = Array.isArray(predicate);
  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    var val = obj[key];
    if (isArr ? predicate.indexOf(key) !== -1 : predicate(key, val, obj)) {
      ret[key] = val;
    }
  }
  return ret;
};

(function (exports) {

  const strictUriEncode$1 = strictUriEncode;
  const decodeComponent = decodeUriComponent;
  const splitOnFirst$1 = splitOnFirst;
  const filterObject = filterObj;
  const isNullOrUndefined = value => value === null || value === undefined;
  const encodeFragmentIdentifier = Symbol('encodeFragmentIdentifier');
  function encoderForArrayFormat(options) {
    switch (options.arrayFormat) {
      case 'index':
        return key => (result, value) => {
          const index = result.length;
          if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === '') {
            return result;
          }
          if (value === null) {
            return [...result, [encode(key, options), '[', index, ']'].join('')];
          }
          return [...result, [encode(key, options), '[', encode(index, options), ']=', encode(value, options)].join('')];
        };
      case 'bracket':
        return key => (result, value) => {
          if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === '') {
            return result;
          }
          if (value === null) {
            return [...result, [encode(key, options), '[]'].join('')];
          }
          return [...result, [encode(key, options), '[]=', encode(value, options)].join('')];
        };
      case 'colon-list-separator':
        return key => (result, value) => {
          if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === '') {
            return result;
          }
          if (value === null) {
            return [...result, [encode(key, options), ':list='].join('')];
          }
          return [...result, [encode(key, options), ':list=', encode(value, options)].join('')];
        };
      case 'comma':
      case 'separator':
      case 'bracket-separator':
        {
          const keyValueSep = options.arrayFormat === 'bracket-separator' ? '[]=' : '=';
          return key => (result, value) => {
            if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === '') {
              return result;
            }

            // Translate null to an empty string so that it doesn't serialize as 'null'
            value = value === null ? '' : value;
            if (result.length === 0) {
              return [[encode(key, options), keyValueSep, encode(value, options)].join('')];
            }
            return [[result, encode(value, options)].join(options.arrayFormatSeparator)];
          };
        }
      default:
        return key => (result, value) => {
          if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === '') {
            return result;
          }
          if (value === null) {
            return [...result, encode(key, options)];
          }
          return [...result, [encode(key, options), '=', encode(value, options)].join('')];
        };
    }
  }
  function parserForArrayFormat(options) {
    let result;
    switch (options.arrayFormat) {
      case 'index':
        return (key, value, accumulator) => {
          result = /\[(\d*)\]$/.exec(key);
          key = key.replace(/\[\d*\]$/, '');
          if (!result) {
            accumulator[key] = value;
            return;
          }
          if (accumulator[key] === undefined) {
            accumulator[key] = {};
          }
          accumulator[key][result[1]] = value;
        };
      case 'bracket':
        return (key, value, accumulator) => {
          result = /(\[\])$/.exec(key);
          key = key.replace(/\[\]$/, '');
          if (!result) {
            accumulator[key] = value;
            return;
          }
          if (accumulator[key] === undefined) {
            accumulator[key] = [value];
            return;
          }
          accumulator[key] = [].concat(accumulator[key], value);
        };
      case 'colon-list-separator':
        return (key, value, accumulator) => {
          result = /(:list)$/.exec(key);
          key = key.replace(/:list$/, '');
          if (!result) {
            accumulator[key] = value;
            return;
          }
          if (accumulator[key] === undefined) {
            accumulator[key] = [value];
            return;
          }
          accumulator[key] = [].concat(accumulator[key], value);
        };
      case 'comma':
      case 'separator':
        return (key, value, accumulator) => {
          const isArray = typeof value === 'string' && value.includes(options.arrayFormatSeparator);
          const isEncodedArray = typeof value === 'string' && !isArray && decode(value, options).includes(options.arrayFormatSeparator);
          value = isEncodedArray ? decode(value, options) : value;
          const newValue = isArray || isEncodedArray ? value.split(options.arrayFormatSeparator).map(item => decode(item, options)) : value === null ? value : decode(value, options);
          accumulator[key] = newValue;
        };
      case 'bracket-separator':
        return (key, value, accumulator) => {
          const isArray = /(\[\])$/.test(key);
          key = key.replace(/\[\]$/, '');
          if (!isArray) {
            accumulator[key] = value ? decode(value, options) : value;
            return;
          }
          const arrayValue = value === null ? [] : value.split(options.arrayFormatSeparator).map(item => decode(item, options));
          if (accumulator[key] === undefined) {
            accumulator[key] = arrayValue;
            return;
          }
          accumulator[key] = [].concat(accumulator[key], arrayValue);
        };
      default:
        return (key, value, accumulator) => {
          if (accumulator[key] === undefined) {
            accumulator[key] = value;
            return;
          }
          accumulator[key] = [].concat(accumulator[key], value);
        };
    }
  }
  function validateArrayFormatSeparator(value) {
    if (typeof value !== 'string' || value.length !== 1) {
      throw new TypeError('arrayFormatSeparator must be single character string');
    }
  }
  function encode(value, options) {
    if (options.encode) {
      return options.strict ? strictUriEncode$1(value) : encodeURIComponent(value);
    }
    return value;
  }
  function decode(value, options) {
    if (options.decode) {
      return decodeComponent(value);
    }
    return value;
  }
  function keysSorter(input) {
    if (Array.isArray(input)) {
      return input.sort();
    }
    if (typeof input === 'object') {
      return keysSorter(Object.keys(input)).sort((a, b) => Number(a) - Number(b)).map(key => input[key]);
    }
    return input;
  }
  function removeHash(input) {
    const hashStart = input.indexOf('#');
    if (hashStart !== -1) {
      input = input.slice(0, hashStart);
    }
    return input;
  }
  function getHash(url) {
    let hash = '';
    const hashStart = url.indexOf('#');
    if (hashStart !== -1) {
      hash = url.slice(hashStart);
    }
    return hash;
  }
  function extract(input) {
    input = removeHash(input);
    const queryStart = input.indexOf('?');
    if (queryStart === -1) {
      return '';
    }
    return input.slice(queryStart + 1);
  }
  function parseValue(value, options) {
    if (options.parseNumbers && !Number.isNaN(Number(value)) && typeof value === 'string' && value.trim() !== '') {
      value = Number(value);
    } else if (options.parseBooleans && value !== null && (value.toLowerCase() === 'true' || value.toLowerCase() === 'false')) {
      value = value.toLowerCase() === 'true';
    }
    return value;
  }
  function parse(query, options) {
    options = Object.assign({
      decode: true,
      sort: true,
      arrayFormat: 'none',
      arrayFormatSeparator: ',',
      parseNumbers: false,
      parseBooleans: false
    }, options);
    validateArrayFormatSeparator(options.arrayFormatSeparator);
    const formatter = parserForArrayFormat(options);

    // Create an object with no prototype
    const ret = Object.create(null);
    if (typeof query !== 'string') {
      return ret;
    }
    query = query.trim().replace(/^[?#&]/, '');
    if (!query) {
      return ret;
    }
    for (const param of query.split('&')) {
      if (param === '') {
        continue;
      }
      let [key, value] = splitOnFirst$1(options.decode ? param.replace(/\+/g, ' ') : param, '=');

      // Missing `=` should be `null`:
      // http://w3.org/TR/2012/WD-url-20120524/#collect-url-parameters
      value = value === undefined ? null : ['comma', 'separator', 'bracket-separator'].includes(options.arrayFormat) ? value : decode(value, options);
      formatter(decode(key, options), value, ret);
    }
    for (const key of Object.keys(ret)) {
      const value = ret[key];
      if (typeof value === 'object' && value !== null) {
        for (const k of Object.keys(value)) {
          value[k] = parseValue(value[k], options);
        }
      } else {
        ret[key] = parseValue(value, options);
      }
    }
    if (options.sort === false) {
      return ret;
    }
    return (options.sort === true ? Object.keys(ret).sort() : Object.keys(ret).sort(options.sort)).reduce((result, key) => {
      const value = ret[key];
      if (Boolean(value) && typeof value === 'object' && !Array.isArray(value)) {
        // Sort object keys, not values
        result[key] = keysSorter(value);
      } else {
        result[key] = value;
      }
      return result;
    }, Object.create(null));
  }
  exports.extract = extract;
  exports.parse = parse;
  exports.stringify = (object, options) => {
    if (!object) {
      return '';
    }
    options = Object.assign({
      encode: true,
      strict: true,
      arrayFormat: 'none',
      arrayFormatSeparator: ','
    }, options);
    validateArrayFormatSeparator(options.arrayFormatSeparator);
    const shouldFilter = key => options.skipNull && isNullOrUndefined(object[key]) || options.skipEmptyString && object[key] === '';
    const formatter = encoderForArrayFormat(options);
    const objectCopy = {};
    for (const key of Object.keys(object)) {
      if (!shouldFilter(key)) {
        objectCopy[key] = object[key];
      }
    }
    const keys = Object.keys(objectCopy);
    if (options.sort !== false) {
      keys.sort(options.sort);
    }
    return keys.map(key => {
      const value = object[key];
      if (value === undefined) {
        return '';
      }
      if (value === null) {
        return encode(key, options);
      }
      if (Array.isArray(value)) {
        if (value.length === 0 && options.arrayFormat === 'bracket-separator') {
          return encode(key, options) + '[]';
        }
        return value.reduce(formatter(key), []).join('&');
      }
      return encode(key, options) + '=' + encode(value, options);
    }).filter(x => x.length > 0).join('&');
  };
  exports.parseUrl = (url, options) => {
    options = Object.assign({
      decode: true
    }, options);
    const [url_, hash] = splitOnFirst$1(url, '#');
    return Object.assign({
      url: url_.split('?')[0] || '',
      query: parse(extract(url), options)
    }, options && options.parseFragmentIdentifier && hash ? {
      fragmentIdentifier: decode(hash, options)
    } : {});
  };
  exports.stringifyUrl = (object, options) => {
    options = Object.assign({
      encode: true,
      strict: true,
      [encodeFragmentIdentifier]: true
    }, options);
    const url = removeHash(object.url).split('?')[0] || '';
    const queryFromUrl = exports.extract(object.url);
    const parsedQueryFromUrl = exports.parse(queryFromUrl, {
      sort: false
    });
    const query = Object.assign(parsedQueryFromUrl, object.query);
    let queryString = exports.stringify(query, options);
    if (queryString) {
      queryString = `?${queryString}`;
    }
    let hash = getHash(object.url);
    if (object.fragmentIdentifier) {
      hash = `#${options[encodeFragmentIdentifier] ? encode(object.fragmentIdentifier, options) : object.fragmentIdentifier}`;
    }
    return `${url}${queryString}${hash}`;
  };
  exports.pick = (input, filter, options) => {
    options = Object.assign({
      parseFragmentIdentifier: true,
      [encodeFragmentIdentifier]: false
    }, options);
    const {
      url,
      query,
      fragmentIdentifier
    } = exports.parseUrl(input, options);
    return exports.stringifyUrl({
      url,
      query: filterObject(query, filter),
      fragmentIdentifier
    }, options);
  };
  exports.exclude = (input, filter, options) => {
    const exclusionFilter = Array.isArray(filter) ? key => !filter.includes(key) : (key, value) => !filter(key, value);
    return exports.pick(input, exclusionFilter, options);
  };
})(queryString);

/**
 *  SEARCH_TYPE에 따라 다른 이동할 검색 페이지의 URL을 return합니다
 */
const getSearchURL = ({
  searchType,
  env,
  params,
  serviceType,
  locale
}) => {
  const queryParams = queryString.stringify(params);
  switch (serviceType) {
    case 'OG':
      return getGlobalSearchURL({
        env,
        queryParams,
        locale
      });
    case 'OK':
    default:
      return getDomesticSearchURL({
        searchType,
        env,
        queryParams
      });
  }
};
const getDomesticSearchURL = ({
  searchType,
  env,
  queryParams
}) => {
  const domain = DOMAINS[env].home;
  switch (searchType) {
    case SEARCH_TYPE.STORE:
      return `${domain}/productions/feed?${queryParams}`;
    case SEARCH_TYPE.EXPERT:
      return `${domain}/expert_users?${queryParams}`;
    case SEARCH_TYPE.TOTAL:
    default:
      return `${domain}/search/index?${queryParams}`;
  }
};
const getGlobalSearchURL = ({
  env,
  locale,
  queryParams
}) => {
  const domain = GLOBAL_DOMAINS[env].home;
  return `${domain}/${locale}/search?${queryParams}`;
};

/**
 * '최근 검색어', '추천 검색어'를 통해 검색 후 이동할 페이지의 URL을 return합니다
 * @param {object} GetSearchTargetURLParams.item 검색할 아이템. 인터페이스는 디자인시스템 `SearchItem` 인터페이스 참고
 * @param {string} env 서비스 환경
 * @return {string} 검색 후 이동할 페이지 URL
 * */
const getSearchTargetURL = ({
  searchType,
  item,
  env,
  serviceType,
  locale
}) => {
  const searchItem = item.type === 'history' ? item.value : item;
  const params = {
    search_affect_type: item.type === 'history' ? 'History' : 'Autocomplete'
  };
  if (typeof searchItem === 'string') {
    return getSearchURL({
      searchType,
      env,
      params: {
        ...params,
        query: searchItem
      },
      serviceType,
      locale
    });
  }
  switch (searchItem.type) {
    case 'query':
      {
        return getSearchURL({
          searchType,
          env,
          params: {
            ...params,
            query: searchItem.query
          },
          serviceType,
          locale
        });
      }
    case 'category':
      {
        return `${DOMAINS[env].home}/store/category?${queryString.stringify({
          category_id: searchItem.value.info.displayCategoryId,
          affect_type: 'StoreSearch',
          affect_id: 0,
          ...params
        })}`;
      }
    case 'consulting':
      {
        const [url, search] = searchItem.value.info.contentUrl.split('?');
        const query = search ? `${search}&${queryString.stringify(params)}` : queryString.stringify(params);
        return `${url}?${query}`;
      }
    default:
      {
        return `${DOMAINS[env].home}/search/index?${queryString.stringify({
          query: searchItem.query,
          ...params
        })}`;
      }
  }
};

const getSearchType = ({
  subdomain,
  pathname
}) => {
  const serviceType = getServiceType(subdomain, pathname);
  switch (serviceType) {
    case 'commerce':
      return _bucketplace_design_system_bds__WEBPACK_IMPORTED_MODULE_8__/* .SEARCH_TYPE.STORE */ .VOb.STORE;
    case 'o2o':
      return _bucketplace_design_system_bds__WEBPACK_IMPORTED_MODULE_8__/* .SEARCH_TYPE.EXPERT */ .VOb.EXPERT;
    default:
      return _bucketplace_design_system_bds__WEBPACK_IMPORTED_MODULE_8__/* .SEARCH_TYPE.TOTAL */ .VOb.TOTAL;
  }
};

const useGNBSearch = ({
  location,
  env,
  subdomain,
  hiddenSearchBar,
  serviceType = 'OK',
  autoComplete
}) => {
  const {
    locale
  } = location;
  const urlSearchParams = new URLSearchParams(location.search);
  const initialQuery = urlSearchParams.get('query');
  const {
    localeData
  } = useGNBData();
  const searchType = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(() => getSearchType({
    subdomain,
    pathname: location.pathname
  }), [location.pathname, subdomain]);
  const historyStorage = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(() => createSearchHistoryStorage({
    env,
    subdomain,
    serviceType
  }), [env, subdomain, serviceType]);
  const isGlobal = serviceType === 'OG';

  /**
   * 유저가 검색시 api요청으로 응답받은 추천 자동완성 키워드 리스트를 return하는 함수
   */
  const handleFetch = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(async query => {
    try {
      const response = await autoComplete({
        env,
        searchType,
        query
      });
      return formatAutoCompleteKeywords(response);
    } catch (error) {
      return [];
    }
  }, [env, searchType, autoComplete]);

  /**
   * 유저가 직접 입력하여 검색하는 경우 실행하는 함수
   */
  const handleSubmit = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(searchValue => {
    if (!searchValue) {
      return;
    }
    const url = getSearchURL({
      searchType,
      env,
      params: {
        query: searchValue,
        search_affect_type: 'Typing'
      },
      serviceType,
      locale
    });
    window.location.href = getURL(subdomain, env, url, serviceType);
  }, [env, searchType, serviceType, subdomain, locale]);

  /**
   * 유저가 '최근 검색어', '추천 검색어'를 클릭하는 경우 실행하는 함수
   */
  const handleSubmitItem = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(item => {
    const url = getSearchTargetURL({
      searchType,
      item,
      env,
      serviceType,
      locale
    });
    window.location.href = getURL(subdomain, env, url, serviceType);
  }, [searchType, env, subdomain, serviceType, locale]);
  return hiddenSearchBar ? undefined : {
    searchType,
    initialQuery: typeof initialQuery === 'string' ? initialQuery : undefined,
    historyStorage,
    onFetch: handleFetch,
    onSubmit: handleSubmit,
    onSubmitItem: handleSubmitItem,
    placeholder: isGlobal ? localeData?.search?.inputPlaceholder : undefined
  };
};

const GnbUploadMenuAdviceIcon = props => (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "36",
  height: "36",
  viewBox: "0 0 36 36",
  ...props,
  children: (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsxs */ .BX)("g", {
    fill: "none",
    fillRule: "evenodd",
    children: [(0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)("path", {
      d: "M0 0h36v36H0z"
    }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)("path", {
      fill: "#EDEDED",
      d: "M17 10h2v22h-2z"
    }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)("path", {
      fill: "#FFF",
      d: "M3 10.2c3.65-1.07 6.98-1.07 10 0h10.16c2.98-1 6.26-1 9.84 0v21c-5.79-1.62-10.79-1.29-15 1-4.21-2.37-9.21-2.7-15-1z"
    }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)("path", {
      fill: "#EDEDED",
      d: "M16.5 15h3v16c-.66.8-1.16 1.2-1.5 1.2-.34 0-.84-.4-1.5-1.2V15z"
    }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)("path", {
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      d: "M3 10.2c3.65-1.07 6.98-1.07 10 0h10.16c2.98-1 6.26-1 9.84 0h0v1.97h0V31.2c-5.79-1.62-10.79-1.29-15 1-4.21-2.37-9.21-2.7-15-1z"
    }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsxs */ .BX)("g", {
      transform: "translate(11 3)",
      children: [(0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)("path", {
        fill: "#FFDB92",
        stroke: "#000",
        d: "M7 0a7 7 0 013 13.33V17H4v-3.67A7 7 0 017 0z"
      }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)("path", {
        stroke: "#000",
        strokeLinecap: "square",
        d: "M7 15.68V8.5"
      }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)("circle", {
        cx: "7",
        cy: "7.5",
        r: "1.5",
        fill: "#000"
      }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)("path", {
        fill: "#FFF",
        stroke: "#000",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M3 16h8v7H3z"
      }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)("path", {
        stroke: "#000",
        strokeLinecap: "square",
        d: "M3 18.5h8m-8 2h8"
      })]
    })]
  })
});
const GnbUploadMenuPhotosIcon = props => (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsxs */ .BX)("svg", {
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 36 36",
  width: "36",
  height: "36",
  ...props,
  children: [(0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)("rect", {
    x: "6.54",
    y: "3.59",
    width: "27",
    height: "29",
    rx: "2.5",
    transform: "rotate(4 6.54 3.6)",
    fill: "#DBDBDB",
    stroke: "#000",
    strokeLinejoin: "round"
  }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)("rect", {
    x: "2.5",
    y: "1.5",
    width: "27",
    height: "29",
    rx: "2.5",
    fill: "#fff",
    stroke: "#000",
    strokeLinejoin: "round"
  }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)("rect", {
    x: "5",
    y: "4",
    width: "22",
    height: "22",
    rx: "1",
    fill: "#FFE2C7"
  }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 7l5 .45v3.5l-5-.45V7zm0 4.5V15l5 .45v-3.5l-5-.45zm6 .55v3.5l5 .45v-3.5l-5-.45zm5-.55V8l-5-.45v3.5l5 .45z",
    fill: "#fff"
  }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 19l22 2v7L5 26v-7z",
    fill: "#E6A87C"
  }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 3.45h5v16l-5 4v-20z",
    fill: "#F1C8A3"
  })]
});
const GnbUploadMenuProReviewIcon = props => (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "36",
  height: "36",
  viewBox: "0 0 36 36",
  ...props,
  children: (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsxs */ .BX)("g", {
    fill: "none",
    fillRule: "evenodd",
    children: [(0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)("path", {
      d: "M0 0h36v36H0z"
    }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)("path", {
      fill: "#FFDB92",
      d: "M13.75 3.52h1.9a8.1 8.1 0 018.1 8.1v1.9H5.65v-1.9a8.1 8.1 0 018.1-8.1z"
    }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)("path", {
      fill: "#FFDB92",
      d: "M12 3h5v2h-5z"
    }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)("path", {
      fill: "#FFF",
      d: "M12.2 23.92h5.4a7.2 7.2 0 017.2 7.2v2.8H5v-2.8a7.2 7.2 0 017.2-7.2z"
    }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)("path", {
      fill: "#EDEDED",
      fillOpacity: ".14",
      d: "M17.6 23.92c1.2 0 2.33.3 3.32.8a10.84 10.84 0 01-6.19 1.78c-2.28 0-4.38-.57-6.04-1.67a7.15 7.15 0 013.51-.91h5.4z"
    }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)("path", {
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      d: "M5 33.59V30.9a6.59 6.59 0 015.47-6.37"
    }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)("path", {
      d: "M10.64 24.6v3.19",
      fillRule: "nonzero",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)("path", {
      fill: "#B1C0CB",
      fillRule: "nonzero",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      d: "M8.9 33.92l.98-6H21.9l.98 6"
    }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)("path", {
      fill: "#FFF6E6",
      fillRule: "nonzero",
      d: "M22.04 14.29c.31.9.48 2.3.48 3.31 0 4.65-3.49 7.2-7.79 7.2s-7.78-2.55-7.78-7.2c0-1.02.17-2.4.48-3.31"
    }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)("path", {
      fill: "#EDE2CD",
      fillRule: "nonzero",
      d: "M22.04 14.29c.16.48.29 1.09.37 1.71H7.06c.08-.62.2-1.23.37-1.71h14.6z"
    }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)("path", {
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      d: "M22.04 14.29c.31.9.48 2.3.48 3.31 0 4.65-3.49 7.2-7.79 7.2s-7.78-2.55-7.78-7.2c0-1.02.17-2.4.48-3.31"
    }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)("path", {
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      d: "M16.29 20.9c-.23.46-.84.79-1.56.79-.72 0-1.33-.33-1.56-.78"
    }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)("path", {
      d: "M12 17.55V17m5.46.55V17",
      fillRule: "nonzero",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.3"
    }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)("path", {
      fill: "#EFC570",
      d: "M9.5 5l2.88 4.72v-5.9zM19.94 5l-2.89 4.72v-5.9z"
    }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsxs */ .BX)("g", {
      stroke: "#000",
      strokeLinecap: "round",
      children: [(0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)("path", {
        strokeLinejoin: "round",
        d: "M5.75 11.76c0-4.08 2.9-7.45 6.63-7.94v-.3c0-.55.43-1 .95-1h2.84c.53 0 .95.45.95 1v.3c3.74.5 6.63 3.86 6.63 7.94"
      }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)("path", {
        d: "M12.38 5.52v-2c0-.55.43-1 .95-1h2.84c.53 0 .95.45.95 1v2"
      }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)("path", {
        fill: "#F5F5F5",
        fillRule: "nonzero",
        d: "M4.2 14.02h20.7"
      })]
    }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsxs */ .BX)("g", {
      children: [(0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)("path", {
        fill: "#35C5F0",
        d: "M26.25 33.1l-3.71 1.31a1 1 0 01-1.34-.97l.11-3.93a.99.99 0 00-.2-.64l-2.4-3.11a1 1 0 01.5-1.57L23 23.07a1 1 0 00.54-.39l2.23-3.24a1 1 0 011.65 0l2.22 3.24a1 1 0 00.54.4l3.78 1.1a1 1 0 01.5 1.58l-2.4 3.11a1 1 0 00-.2.64l.1 3.93a1 1 0 01-1.33.97l-3.7-1.32a1 1 0 00-.67 0z"
      }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)("path", {
        fill: "#9AE2F7",
        d: "M27.15 19.18a1 1 0 01.26.26l2.22 3.24c.06.09.13.16.21.23l-8.58 8.58.05-1.98a.99.99 0 00-.2-.64l-2.4-3.11a1 1 0 01.5-1.57L23 23.07a1 1 0 00.54-.39l2.23-3.24a1 1 0 011.39-.26z"
      }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)("path", {
        stroke: "#000",
        d: "M26.25 33.1l-3.71 1.31a1 1 0 01-1.34-.97l.11-3.93a.99.99 0 00-.2-.64l-2.4-3.11a1 1 0 01.5-1.57L23 23.07a1 1 0 00.54-.39l2.23-3.24a1 1 0 011.65 0l2.22 3.24a1 1 0 00.54.4l3.78 1.1a1 1 0 01.5 1.58l-2.4 3.11a1 1 0 00-.2.64l.1 3.93a1 1 0 01-1.33.97l-3.7-1.32a1 1 0 00-.67 0z"
      })]
    })]
  })
});
const GnbUploadMenuProductReviewIcon = props => (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "36",
  height: "36",
  viewBox: "0 0 36 36",
  ...props,
  children: (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsxs */ .BX)("g", {
    fill: "none",
    fillRule: "evenodd",
    children: [(0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)("path", {
      d: "M0 0h36v36H0z"
    }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsxs */ .BX)("g", {
      strokeLinejoin: "round",
      transform: "translate(2 3)",
      children: [(0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)("rect", {
        width: "4",
        height: "8",
        x: "3",
        y: "21",
        fill: "#FFB787",
        stroke: "#000",
        rx: "2"
      }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)("rect", {
        fill: "#FFE2C7",
        width: "24",
        height: "25",
        rx: "3"
      }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)("rect", {
        fill: "#ffe2c7",
        width: "24",
        height: "25",
        rx: "3"
      }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)("rect", {
        stroke: "#000",
        width: "24",
        height: "25",
        rx: "3",
        strokeWidth: "1.2"
      }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)("rect", {
        width: "6",
        height: "3",
        x: "9",
        y: "5",
        fill: "#DB9F77",
        stroke: "#FFF",
        rx: "1.5"
      }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)("rect", {
        width: "6",
        height: "3",
        x: "9",
        y: "17",
        fill: "#DB9F77",
        stroke: "#FFF",
        rx: "1.5"
      }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)("path", {
        fill: "#FFDB92",
        stroke: "#EDC29B",
        d: "M1.5 12.5h21"
      })]
    }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)("path", {
      fill: "#35C5F0",
      d: "M26.25 31.53l-3.7 1.32a1 1 0 01-1.34-.97l.1-3.93a.99.99 0 00-.2-.64l-2.4-3.11a1 1 0 01.51-1.57l3.77-1.12a1 1 0 00.55-.39l2.22-3.24a1 1 0 011.65 0l2.22 3.24a1 1 0 00.55.4l3.77 1.1a1 1 0 01.5 1.58l-2.4 3.11a1 1 0 00-.2.64l.11 3.93a1 1 0 01-1.33.97l-3.71-1.32a1 1 0 00-.67 0z"
    }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)("path", {
      fill: "#9AE2F7",
      d: "M27.15 17.61a1 1 0 01.26.26l2.22 3.25c.06.09.13.16.22.23l-8.59 8.58.06-1.98a.99.99 0 00-.21-.64l-2.4-3.11a1 1 0 01.51-1.57l3.77-1.12a1 1 0 00.55-.39l2.22-3.24a1 1 0 011.39-.26z"
    }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)("path", {
      stroke: "#000",
      d: "M26.29 30.85l-3.31 1.17a.9.9 0 01-1.2-.86l.1-3.51c0-.2-.06-.4-.18-.57l-2.14-2.78a.9.9 0 01.45-1.4l3.37-.99a.9.9 0 00.48-.35l1.99-2.9a.9.9 0 011.47 0l1.99 2.9c.11.17.28.3.48.35l3.37 1a.9.9 0 01.45 1.4l-2.14 2.77a.89.89 0 00-.18.57l.1 3.5a.9.9 0 01-1.2.87l-3.3-1.17a.9.9 0 00-.6 0z",
      strokeWidth: "1.2"
    })]
  })
});
const GnbUploadMenuProjectIcon = props => (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "36",
  height: "36",
  viewBox: "0 0 36 36",
  ...props,
  children: (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsxs */ .BX)("g", {
    fill: "none",
    fillRule: "evenodd",
    children: [(0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)("path", {
      d: "M0 0h36v36H0z"
    }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)("path", {
      fill: "#FFF6E6",
      d: "M27.2 29.31H4.8V14.38h22.4"
    }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)("path", {
      fill: "#EDE2CD",
      d: "M27.2 17.18H4.8v-2.8h22.4"
    }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)("path", {
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      d: "M4.8 29.31V14.38h22.4v14.93H4.8z"
    }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)("path", {
      fill: "#FFF",
      d: "M16 19.05a4.67 4.67 0 014.67 4.66v5.6h-9.34v-5.6A4.67 4.67 0 0116 19.05z"
    }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)("path", {
      fill: "#fff",
      d: "M16 19.05a4.67 4.67 0 014.67 4.66v5.6h-9.34v-5.6A4.67 4.67 0 0116 19.05z"
    }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)("path", {
      stroke: "#000",
      d: "M16 19.05a4.67 4.67 0 014.67 4.66v5.6h-9.34v-5.6A4.67 4.67 0 0116 19.05z"
    }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)("path", {
      fill: "#FBDEC1",
      d: "M2.94 14.38a.9.9 0 01-.81-1.3l3.25-6.6a.9.9 0 01.8-.5h19.64c.34 0 .65.2.8.5l3.25 6.6a.9.9 0 01-.8 1.3H2.93z"
    }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)("path", {
      fill: "#E9C39D",
      d: "M2.94 14.38a.9.9 0 01-.81-1.3l.74-1.5h26.26l.74 1.5a.9.9 0 01-.8 1.3H2.92z"
    }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)("path", {
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      d: "M2.94 14.38a.9.9 0 01-.81-1.3l3.25-6.6a.9.9 0 01.8-.5h19.64c.34 0 .65.2.8.5h0l3.25 6.6a.9.9 0 01-.8 1.3h0H2.93z"
    }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsxs */ .BX)("g", {
      transform: "translate(26 9)",
      children: [(0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)("path", {
        fill: "#fff",
        d: "M0 5h8.07v12H0z"
      }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)("path", {
        fill: "#ffdb92",
        d: "M0 0h8v4H0z"
      }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)("path", {
        d: "M8.5 17.43H-.52 8.5L4 23.8l-4.52-6.37H8.5",
        fill: "#fff6e6"
      }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)("path", {
        d: "M8.5 1v0A1.49 1.49 0 007-.5H1v0A1.5 1.5 0 00-.5 1l-.02 16.43L4 23.8l4.5-6.37z",
        stroke: "#000"
      }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)("path", {
        fill: "#000",
        d: "M4 23l2-2H2z"
      }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)("rect", {
        width: "6",
        height: "2",
        x: "-14",
        y: "3",
        stroke: "#000",
        rx: "1",
        transform: "rotate(-90)",
        ry: "1"
      }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)("rect", {
        width: "5",
        height: "1",
        x: "-13.5",
        y: "3.5",
        fill: "#ffdb92",
        rx: ".5",
        transform: "rotate(-90)",
        ry: ".5"
      }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)("path", {
        fill: "#000",
        d: "M0 4h8v1H0z",
        opacity: ".9"
      }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)("path", {
        d: "M-.52 17.43H8.5",
        stroke: "#000"
      })]
    }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)("path", {
      fill: "#000",
      d: "M30 32l2-2h-4z"
    })]
  })
});

const GNBIcon = ({
  size = 24,
  name,
  ...props
}) => {
  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(_bucketplace_design_system_bds__WEBPACK_IMPORTED_MODULE_8__/* .Icon */ .JO$, {
    ...props,
    size: size,
    name: name
  });
};
const GNBImage = ({
  width = 80,
  height = 80,
  alt = '',
  url
}) => {
  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)("img", {
    src: url,
    width: width,
    height: height,
    alt: alt
  });
};
const GNBSVG = ({
  name
}) => {
  switch (name) {
    case 'photo':
      return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(GnbUploadMenuPhotosIcon, {});
    case 'project':
      return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(GnbUploadMenuProjectIcon, {});
    case 'advice':
      return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(GnbUploadMenuAdviceIcon, {});
    case 'production':
      return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(GnbUploadMenuProductReviewIcon, {});
    case 'remodeling':
      return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(GnbUploadMenuProReviewIcon, {});
    default:
      return null;
  }
};

/**
 * type에 따라 디자인 시스템 Icon | SVG Icon | 이미지를 생성합니다.
 * @param media
 * @returns 디자인 시스템 Icon | SVG Icon | 이미지
 */
const createMedia = media => {
  switch (media.type) {
    case 'icon':
      {
        return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(GNBIcon, {
          ...media
        });
      }
    case 'image':
      {
        return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(GNBImage, {
          ...media
        });
      }
    case 'svg':
      {
        return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(GNBSVG, {
          ...media
        });
      }
    default:
      return null;
  }
};

/**
 * GNB의 메뉴 스키마를 생성합니다. level1 ~ level3까지 모든 메뉴를 생성합니다.
 * design-system Navigation을 warpping한 구조입니다.
 */
const createMenuSchema = ({
  menus,
  location
}) => {
  const createMenu = menu => {
    if (!menu) {
      return null;
    }
    const {
      title,
      href,
      matches,
      media,
      items,
      log,
      custom
    } = menu;
    const localePath = location.locale ? `/${location.locale}` : '';
    const currentURL = location.origin + localePath + location.pathname + location.search + location.hash;
    const active = matches.map(match => new RegExp(match)).some(regExp => regExp.test(currentURL));
    const entries = items?.map(item => createMenu(item)).filter(Boolean);
    const scrollableProps = custom === 'noScrollableEntries' ? {
      scrollableEntries: false
    } : {};
    return {
      title,
      href,
      icon: media && createMedia(media),
      entries: custom === 'store' ? entries.map(entry => ({
        ...entry,
        icon: null
      })) : entries,
      active,
      logId: log?.id,
      renderBarChild: custom === 'store' ? () => (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(StoreCategory, {
        categories: entries
      }) : undefined,
      ...scrollableProps
    };
  };
  return menus.map(menu => createMenu(menu)).filter(Boolean);
};

/**
 * store: 쇼핑 > 카테고리 메뉴 하위로 tertinary menus를 보여줍니다.
 * noScrollableEntries: menu의 entries를 scroll UI가 아닌 별도의 UI로 보여줍니다.
 */

const SHORTCUT_TYPE = {
  cart: 'cart',
  cs: 'cs',
  notification: 'notification',
  scrap: 'scrap',
  seller: 'seller',
  signin: 'signin',
  signup: 'signup'
};

/**
 * 신규 /api/navigation API에 추가 정의된 response 타입
 * @see {@link https://docs.google.com/document/d/1LE9v_LcjKgnxiVOGjxXiG_q75dFpb_6pKnEJR2_yryI#heading=h.qofnrodkae26 웹 네비게이션 모듈화 BFF API }
 */

/** 유저 프로필 클릭 시 나오는 유저 메뉴를 create합니다. */
const createUserMenus = ({
  userMenus,
  onSignout
}) => {
  return userMenus.map(({
    title,
    href,
    position,
    showOn,
    action,
    bullet,
    log
  }) => {
    return {
      type: position,
      showOn,
      title,
      href,
      bullet,
      onClick: action === 'signout' ? onSignout : undefined,
      logId: log?.id
    };
  });
};
/** 검색과 유저 프로필 사이에 있는 아이콘 메뉴를 create합니다. */
const createShortcuts = ({
  supplementary,
  user,
  subdomain,
  env,
  location,
  serviceType
}) => {
  const localePath = location.locale ? `/${location.locale}` : '';
  const url = [location.origin, localePath, location.pathname, location.search, location.hash].join('');
  const shortcuts = Object.entries(supplementary).reduce((prev, [key, value]) => {
    if (!Object.keys(SHORTCUT_TYPE).includes(key)) {
      return prev;
    }
    return {
      ...prev,
      [key]: {
        title: value?.title,
        count: value?.count,
        href: value?.action === 'signin' ? getLoginURL(user, subdomain, env, url, serviceType, location.locale) : value?.href
      }
    };
  }, {});
  return shortcuts;
};
/** 글쓰기 버튼 클릭시 나오는 업로드 메뉴를 create합니다. */
const createUploadMenuLinks = uploadLinks => {
  return uploadLinks.map(({
    title,
    subtitle,
    href,
    media,
    log
  }) => {
    return {
      title,
      subtitle,
      href,
      icon: createMedia(media),
      logId: log?.id
    };
  });
};

/** 로그인 유저의 정보를 통해 유저 프로필 data를 create합니다. */
const createUserProfile = user => {
  if (!user) {
    return undefined;
  }
  return {
    userId: user.id,
    imageUrl: user.profileImageUrl,
    nickname: user.nickname,
    userableType: user.userableType
  };
};
const createSupplementary = ({
  user,
  supplementary,
  subdomain,
  env,
  location,
  serviceType,
  onSignout,
  secondaryRight
}) => {
  const userProfile = createUserProfile(user);
  const userMenus = createUserMenus({
    userMenus: supplementary.userMenus,
    onSignout
  });
  const uploadMenuLinks = createUploadMenuLinks(supplementary.uploads);
  const shortcuts = createShortcuts({
    supplementary,
    user,
    subdomain,
    env,
    location,
    serviceType
  });
  const showChangeLanguageButton = serviceType === 'OG';
  return {
    ...shortcuts,
    userProfile,
    userMenu: userMenus,
    uploadMenuLinks,
    secondaryRight,
    showChangeLanguageButton
  };
};

/**
 * 원하는 도메인에 대하여 fallback 메뉴를 생성합니다.
 */
const createFallbackMenuSchema = ({
  subdomain,
  searchMenus,
  location
}) => {
  const currentURLSearchParams = new URLSearchParams(location.search);
  const newURLSearchParams = new URLSearchParams();
  const queryParam = currentURLSearchParams.get('query');
  if (queryParam) {
    newURLSearchParams.set('query', queryParam);
  }
  const searchAffectTypeParam = currentURLSearchParams.get('search_affect_type');
  if (searchAffectTypeParam) {
    newURLSearchParams.set('search_affect_type', searchAffectTypeParam);
  }
  const suggestParam = currentURLSearchParams.get('suggest');
  if (suggestParam) {
    newURLSearchParams.set('suggest', suggestParam);
  }
  const search = newURLSearchParams.size === 0 ? '' : `?${newURLSearchParams.toString()}`;
  const searchMenuSchema = createMenuSchema({
    menus: searchMenus,
    location
  }).map(menu => {
    return {
      ...menu,
      active: !!queryParam && menu.active,
      href: `${menu.href}${search}`
    };
  });
  const getFallbackMenuSchema = () => {
    switch (subdomain) {
      case 'home':
        return searchMenuSchema;
      default:
        return [];
    }
  };
  return getFallbackMenuSchema();
};

const GNBInner = ({
  linkComponent,
  location,
  getDeepLink,
  env,
  logo,
  menus = [],
  supplementary = {
    userMenus: [],
    uploads: []
  },
  searchMenus = [],
  user,
  subdomain,
  secondaryRight,
  trendingKeywords,
  hiddenSearchBar = false,
  serviceType = 'OK',
  localeData,
  signOut = defaultSignOut,
  autoComplete = getDomesticAutoCompleteKeywords
}) => {
  const isGlobal = serviceType === 'OG';
  const {
    open
  } = (0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_10__/* .useSnackbar */ .Ds_)();
  const handleSignout = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(async () => {
    try {
      const data = await signOut({
        user,
        env
      });
      if (data.success) {
        signoutAirbridge();
        logAmplitude$1('계정 Logout');
        const url = isGlobal ? `${GLOBAL_DOMAINS[env].home}/${location.locale}` : DOMAINS[env].home;
        window.location.href = getURL(subdomain, env, url, serviceType);
      }
    } catch (e) {
      open({
        content: localeData?.failSignout ?? '로그아웃에 실패했습니다. 잠시 후 다시 시도해 주세요.'
      });
    }
  }, [signOut, user, env, isGlobal, subdomain, serviceType, open, localeData?.failSignout, location.locale]);
  const searchOptions = useGNBSearch({
    location,
    env,
    subdomain,
    hiddenSearchBar,
    serviceType,
    autoComplete
  });
  const menuSchema = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(() => createMenuSchema({
    menus,
    location
  }), [menus, location]);
  const fallbackMenuSchema = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(() => createFallbackMenuSchema({
    subdomain,
    searchMenus,
    location
  }), [subdomain, searchMenus, location]);
  const supplementarySchema = createSupplementary({
    user,
    supplementary,
    subdomain,
    env,
    location,
    serviceType,
    secondaryRight: secondaryRight ?? (() => {
      if (searchOptions == null) {
        return null;
      }
      if (trendingKeywords == null || trendingKeywords.length < 1) {
        return null;
      }
      return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(TrendingKeywordsDropdown, {
        entries: trendingKeywords,
        historyStorage: searchOptions.historyStorage,
        linkComponent: linkComponent,
        baseUrl: DOMAINS[env].home
      });
    }),
    onSignout: handleSignout
  });
  const handleLog = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(({
    key,
    category,
    params
  }) => {
    const logData = TYPE_MAP[key](params || {})[category];
    const {
      bucket,
      amplitude
    } = logData || {};
    if (bucket) {
      switch (category) {
        case 'impression':
          {
            bucketImpressionLog(bucket);
            break;
          }
        case 'click':
        default:
          {
            bucketClickLog(bucket);
            break;
          }
      }
    }
    if (amplitude) {
      const {
        type,
        data
      } = amplitude;
      logAmplitude$1(`${type}`, data);
    }
  }, []);
  const handleAppDownload = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(() => {
    window.location.href = getDeepLink({
      sub_id_1: 'web_left_bnr'
    });
  }, [getDeepLink]);
  const defaultLogo = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(() => ({
    href: getURL(subdomain, env, DOMAINS[env].home, serviceType)
  }), [env, subdomain, serviceType]);
  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(Navigation, {
    menuSchema: menuSchema,
    searchOptions: searchOptions,
    supplementary: supplementarySchema,
    linkComponent: linkComponent,
    fallbackMenuSchema: fallbackMenuSchema,
    onLog: handleLog,
    onAppDownload: handleAppDownload,
    location: location,
    logo: logo ?? defaultLogo
  });
};
const GNB = ({
  ...params
}) => {
  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(GNBDataProvider, {
    value: {
      isGlobal: params.serviceType === 'OG',
      location: params.location,
      localeData: params.localeData
    },
    children: (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(GNBInner, {
      ...params
    })
  });
};

const ShareButton = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)("button",  true ? {
  target: "e1ftxrf30"
} : 0)(_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.R, ";width:", (0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.p)(40), ";height:", (0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.p)(40), ";margin:0 ", (0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.p)(6), ";" + ( true ? "" : 0));
ShareButton.withComponent('a',  true ? {
  target: "e1ftxrf31"
} : 0);

var _circle$1, _path$1, _path2$1;
function _extends$2() { return _extends$2 = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$2.apply(null, arguments); }
var SvgIcShareUrl = function SvgIcShareUrl(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends$2({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    fill: "none"
  }, props), _circle$1 || (_circle$1 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#EAEDEF"
  })), _path$1 || (_path$1 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: "#2F3438",
    d: "M25 20.65H15v-1.3h10z"
  })), _path2$1 || (_path2$1 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: "#2F3438",
    d: "M10.35 20A4.65 4.65 0 0 1 15 15.35h3v1.3h-3a3.35 3.35 0 1 0 0 6.7h3v1.3h-3A4.65 4.65 0 0 1 10.35 20M29.65 20A4.65 4.65 0 0 0 25 15.35h-3v1.3h3a3.35 3.35 0 1 1 0 6.7h-3v1.3h3A4.65 4.65 0 0 0 29.65 20"
  })));
};
var UrlIcon = SvgIcShareUrl;

const ShareHandlerContext = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)(undefined);
function ShareHandlerProvider({
  children,
  value
}) {
  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(ShareHandlerContext.Provider, {
    value: value,
    children: children
  });
}
function useShareHandler() {
  return (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(ShareHandlerContext);
}

const isAndroid13OrAbove = cookie => {
  const parsedCookie = _(cookie);
  const bpPType = parsedCookie['bp-p-type'];
  const bpPVersion = parsedCookie['bp-p-ver'];
  if (bpPType === 'mWebAndroid') {
    const version = bpPVersion.split(', ').find(item => item.includes('Android'))?.split(' ')?.[1];
    return version != null && parseInt(version, 10) >= 13;
  }
  return bpPType === 'Android' && parseInt(bpPVersion, 10) >= 13;
};
function UrlCopyButton(props) {
  const {
    url,
    onShare,
    onError,
    localeData
  } = props;
  const snackbar = (0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_10__/* .useSnackbar */ .Ds_)();
  const shareHandler = useShareHandler();
  const handleClick = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(async () => {
    try {
      if (!url) {
        return onError?.(new Error('No URL provided to copy'));
      }
      await copyTextToClipboard(url);
      onShare?.();
      shareHandler?.();
      if (isAndroid13OrAbove(document.cookie)) {
        return;
      }
      snackbar.open({
        content: localeData?.clipboardSuccess ?? '클립보드에 복사되었습니다.'
      });
    } catch (err) {
      console.error(err);
      if (isAndroid13OrAbove(document.cookie)) {
        return;
      }
      snackbar.open({
        content: localeData?.clipboardFail ?? '클립보드 복사에 실패했습니다.'
      });
      onError?.(err);
    }
  }, [url, onShare, shareHandler, snackbar, localeData?.clipboardSuccess, localeData?.clipboardFail, onError]);
  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(ShareButton, {
    type: "button",
    onClick: handleClick,
    children: (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(UrlIcon, {
      "aria-label": "\uC8FC\uC18C \uBCF5\uC0AC"
    })
  });
}

var _circle, _path, _path2;
function _extends$1() { return _extends$1 = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$1.apply(null, arguments); }
var SvgIcShareKakaotalk = function SvgIcShareKakaotalk(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends$1({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    fill: "none"
  }, props), _circle || (_circle = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#F9E000"
  })), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: "#371C1D",
    d: "m17.095 18.06.75 2.13h-1.5z"
  })), _path2 || (_path2 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: "#371C1D",
    fillRule: "evenodd",
    d: "M6.842 19.253C6.842 13.591 12.664 9 19.846 9s13.003 4.59 13.003 10.253-5.821 10.253-13.003 10.253q-1.184-.001-2.31-.161c-.75.529-5.086 3.574-5.495 3.63 0 0-.168.066-.31-.018-.143-.084-.117-.304-.117-.304.043-.294 1.124-4.026 1.323-4.713-3.661-1.814-6.095-5.026-6.095-8.687m5.064 2.863c0 .395.336.716.75.716s.75-.321.75-.716v-4.457h1.17c.407 0 .737-.33.737-.735a.736.736 0 0 0-.736-.734h-3.842a.736.736 0 0 0-.736.734c0 .405.33.735.736.735h1.17zm6.704.375c.072.204.312.332.625.332.164 0 .327-.036.476-.104.207-.095.406-.358.178-1.067l-1.794-4.721c-.127-.36-.51-.73-1-.741-.49.01-.873.381-1 .74l-1.794 4.724c-.228.707-.03.97.177 1.065.15.068.313.104.477.104.313 0 .552-.127.624-.331l.372-.974h2.288zm1.767-.456c0 .38.323.688.719.688h2.407c.396 0 .719-.309.719-.688s-.323-.688-.719-.688h-1.594V16.94a.76.76 0 0 0-.766-.75.76.76 0 0 0-.766.75zm4.137.037a.751.751 0 0 0 1.5 0v-1.637l.26-.26 1.76 2.33a.75.75 0 0 0 .6.3.74.74 0 0 0 .646-.37.75.75 0 0 0 .08-.57.7.7 0 0 0-.128-.263l-1.847-2.446 1.71-1.71a.58.58 0 0 0 .165-.457.74.74 0 0 0-.22-.475.74.74 0 0 0-.517-.222c-.16 0-.308.06-.416.167l-2.093 2.093V16.94a.751.751 0 0 0-1.5 0z",
    clipRule: "evenodd"
  })));
};
var KakaoTalkIcon = SvgIcShareKakaotalk;

function KakaoTalkButton(props) {
  const {
    kakaoApi,
    templateId,
    templateArgs,
    onShare,
    onError
  } = props;
  const snackbar = (0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_10__/* .useSnackbar */ .Ds_)();
  const shareHandler = useShareHandler();
  const handleClick = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(() => {
    // Use optimistic handler, ignoring an action when not ready.
    if (kakaoApi == null) {
      return;
    }
    try {
      kakaoApi?.Share.sendCustom({
        templateId,
        templateArgs: templateArgs ?? {},
        installTalk: true
      });
      onShare?.();
      shareHandler?.();
    } catch (err) {
      console.error(err);
      snackbar.open({
        content: '카카오톡 공유에 실패했습니다.'
      });
      onError?.(err);
    }
  }, [kakaoApi, templateId, templateArgs, onShare, shareHandler, snackbar, onError]);
  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(ShareButton, {
    role: "button",
    type: "button",
    onClick: handleClick,
    children: (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(KakaoTalkIcon, {
      "aria-label": "\uCE74\uCE74\uC624\uD1A1 \uACF5\uC720"
    })
  });
}

function SharePopper(props) {
  const {
    targetElement,
    isOpen,
    onClose,
    onShare,
    children,
    className
  } = props;
  const [popperElement, setPopperElement] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(null);
  const [arrowElement, setArrowElement] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(null);
  const {
    styles,
    attributes
  } = usePopper(targetElement, popperElement, {
    placement: 'bottom',
    modifiers: [{
      name: 'offset',
      options: {
        offset: [0, 10]
      }
    }, {
      name: 'arrow',
      options: {
        element: arrowElement,
        padding: 8
      }
    }]
  });
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    const handleClickWindow = ({
      target
    }) => {
      // eslint-disable-next-line react/prop-types
      if (targetElement?.contains(target)) {
        return;
      }
      onClose?.();
    };
    const handleClose = () => onClose?.();
    window.addEventListener('scroll', handleClose);
    window.addEventListener('click', handleClickWindow);
    return () => {
      window.removeEventListener('scroll', handleClose);
      window.removeEventListener('click', handleClickWindow);
    };
  }, [targetElement, onClose]);
  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(CSSTransition$1, {
    in: isOpen,
    timeout: 200,
    classNames: {
      enterActive: 'open',
      enterDone: 'open'
    },
    children: (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsxs */ .BX)(Popper, {
      ref: setPopperElement,
      style: styles['popper'],
      ...attributes['popper'],
      children: [(0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(Arrow, {
        ref: setArrowElement,
        style: styles['arrow']
      }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(Container, {
        className: className,
        children: (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(ShareHandlerProvider, {
          value: onShare,
          children: children
        })
      })]
    })
  });
}
SharePopper.UrlCopyButton = UrlCopyButton;
SharePopper.KakaoTalkButton = KakaoTalkButton;
const Container = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)("div",  true ? {
  target: "e5zrl1f2"
} : 0)("display:flex;align-items:center;margin:0 ", (0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.p)(-6), ";" + ( true ? "" : 0));
const Arrow = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)("span",  true ? {
  target: "e5zrl1f1"
} : 0)("border:", (0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.p)(7), " solid transparent;" + ( true ? "" : 0));
const Popper = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)("div",  true ? {
  target: "e5zrl1f0"
} : 0)("position:relative;padding:", (0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.p)(16), ";white-space:nowrap;border-radius:", (0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.p)(8), ";background:", ({
  theme
}) => theme.content.base6, ";box-shadow:rgb(0 0 0 / 12%) 0 ", (0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.p)(2), " ", (0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_7__.p)(16), ";opacity:0;transition:.2s opacity,.2s margin;pointer-events:none;&[data-popper-placement^='bottom']{margin-top:-10px;", Arrow, "{bottom:100%;border-bottom-color:", ({
  theme
}) => theme.content.base6, ";}}&[data-popper-placement^='top']{margin-top:10px;", Arrow, "{top:100%;border-top-color:", ({
  theme
}) => theme.content.base6, ";}}&[data-popper-placement^='right']{margin-left:10px;", Arrow, "{right:100%;border-right-color:", ({
  theme
}) => theme.content.base6, ";}}&[data-popper-placement^='left']{margin-left:-10px;", Arrow, "{left:100%;border-left-color:", ({
  theme
}) => theme.content.base6, ";}}&.open{margin:0;opacity:1;pointer-events:auto;}" + ( true ? "" : 0));

const CRITEO_ACCOUNT = 50838;

/**
 * criteo 전역 객체를 초기화합니다.
 * @param user 로그인 유저 데이터
 * @example
 * ```
 * initCriteo(loginUser);
 * ```
 */
const initCriteo = user => {
  if (typeof window === 'undefined') {
    return;
  }
  const _window = window;
  const ua = navigator.userAgent.toLowerCase();
  const mobile = {
    isAndroid: ua.indexOf('android') > -1,
    isIos: ua.match(/(ipad|iphone|ipod)/g)
  };
  const type = mobile.isAndroid || mobile.isIos ? 'm' : 'd';
  _window.criteo_q = _window.criteo_q || [];
  _window.criteo_q.push({
    event: 'setAccount',
    account: CRITEO_ACCOUNT
  }, {
    event: 'setEmail',
    email: user ? `${user.id}@bucketplace.net` : ''
  }, {
    event: 'setSiteType',
    type
  });
};

const PIXEL_ID = '937204509645248';

/**
 * Facebook pixel script를 로드합니다.
 * @returns {string} facebook pixel load script
 * @example
 * ```
 * <Script
 *   id="load-facebook-pixel"
 *   strategy="beforeInteractive"
 *   dangerouslySetInnerHTML={{ __html: getFacebookPixelScript() }}
 * />
 * <noscript>
 *   <img
 *     width="1"
 *     height="1"
 *     style={{ display: 'none' }}
 *     src="https://www.facebook.com/tr?id=937204509645248&ev=PageView&noscript=1"
 *   />
 * </noscript>
 * ```
 */
const getFacebookPixelScript = () => {
  return `
    !(function(f,b,e,v,n,t,s)
    {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
    n.callMethod.apply(n,arguments):n.queue.push(arguments)};
    if(!f._fbq)f._fbq=n;n.push=n;n.loaded =!0;n.version='2.0';
    n.queue=[];t=b.createElement(e);t.async=!0;
    t.src=v;s=b.getElementsByTagName(e)[0];
    s.parentNode.insertBefore(t,s);})(window,document,'script',
    'https://connect.facebook.net/en_US/fbevents.js');
    fbq('set', 'autoConfig', 'false', '${PIXEL_ID}');
    fbq('init', '${PIXEL_ID}');
    fbq('track', 'PageView');
  `;
};

/**
 * Facebook pixel log를 전송합니다.
 * @see {@link https://developers.facebook.com/docs/meta-pixel/implementation/conversion-tracking}
 * @param eventName 이벤트 이름
 * @param properties 로깅할 데이터
 * @example
 * ```
 * logFacebookPixel('AddToCart', {
 *   content_name: 'name',
 *   content_type: 'product',
 *   contents: [],
 *   currentcy: 'KRW',
 * });
 * ```
 */
const logFacebookPixel = (eventName, properties) => {
  if (!window.fbq) {
    return;
  }
  window.fbq('track', eventName, properties);
};

const KAKAO_ID = '7919701595446099671';
/**
 * kakao pixel 전역 객체를 초기화합니다.
 * @example
 * ```
 * <Script
 *   src="https://t1.daumcdn.net/adfit/static/kp.js"
 *   onLoad={() => initKakaoPixel()}
 * />
 * ```
 */
const initKakaoPixel = () => {
  if (!window.kakaoPixel) {
    return;
  }
  window.kakaoPixel(KAKAO_ID).pageView();
};

const NAVER_ID = 's_2e85116be219';
const OHOUSE_URL = 'ohou.se';
/**
 * naver analytics 전역 객체를 생성합니다.
 * @example
 * ```
 * <Script
 *   src="https://wcs.naver.net/wcslog.js"
 *   onLoad={() => initNaverAnalytics()}
 *   async
 * />
 * ```
 */
const initNaverAnalycis = () => {
  if (!window || window.wcs == null) {
    return;
  }
  if (!window.wcs_add) {
    window.wcs_add = {};
  }
  window.wcs_add['wa'] = NAVER_ID;
  if (!window._nasa) {
    window._nasa = {};
  }
  window.wcs.inflow(OHOUSE_URL);
  if (window.wcs_do) {
    window.wcs_do(window._nasa);
  }
};

const DEEP_LINK_HOST = 'https://link.ohou.se/@ohouse';
const GLOBAL_DEEP_LINK_HOST = 'https://link.ohouse.com/@globalohouse';

/**
 * query 에서 제외해야하는 blacklist
 */
const QUERY_BLACKLIST = (/* unused pure expression or super */ null && (['airbridge_referrer', 'fallback_ios', 'fallback_android', 'short_id', 'https_deeplink', 'campaign', 'ad_group', 'ad_creative', 'term', 'deeplink_url', 'fallback_desktop', 'n_media', 'n_query', 'n_rank', 'n_ad_group', 'n_ad', 'n_keyword_id', 'n_keyword', 'n_campaign_type', 'n_ad_group_type', 'NaPm', 'routing_short_id', 'content', 'sub_id_1', 'sub_id_2', 'sub_id_3', 'campaign_id', 'ad_group_id', 'ad_creative_id', 'term_id']));

/** 사용하는 utm tags */
const UTM_TAGS = (/* unused pure expression or super */ null && (['source', 'utm_source', 'utm_campaign', 'utm_content', 'utm_media', 'utm_term', 'utm_medium', 'bp_adset', 'bp_content', 'bp_sub_id', 'bp_sub_id_1', 'bp_sub_id_2']));

/**
 * 객체의 값에서 `/{}`, `_{}`, `{}`로 감싸진 문자열을 제거합니다.
 * 제거된 결과가 빈 문자열인 경우, 리턴되는 객체에서 해당 키를 삭제합니다.
 * @param query escape 처리할 객체
 * @return escape 처리된 객체
 * @example
 * escapeBracesInQuery({ test: 'foo_{bar}' })
 * escapeBracesInQuery({ test: 'foo/{bar}' })
 * escapeBracesInQuery({ test: 'foo{bar}' })
 * { test: 'foo' }
 * escapeBracesInQuery({ test: '{foo}' })
 * {}
 * ```
 */
const escapeBracesInQuery = query => {
  const trimmed = Object.fromEntries(Object.entries(query).map(([key, value]) => {
    return [key, value?.replace?.(/([/\\_]?{[^}]+})+/g, '')];
  }));
  return pickBy(trimmed, Boolean);
};

/**
 * sesisonStorage에서 ohsUtmData를 가져옵니다.
 * @returns UTM_TAGS가 포함된 object
 */
const getUtmData = () => {
  try {
    return JSON.parse(sessionStorage['ohsUtmData'] || '{}');
  } catch (e) {
    //
    return {};
  }
};

/**
 * NOTE This relies on document / window object. Therefore, SSR is not possible
 * with this - it's recommend to use location.href = getDeepLink() or
 * equivalent to defer retriving UTM data.
 * query에서 블랙리스트를 제외하고 utm tags 기반으로 deeplink를 생성
 * @param additionalParams 추가로 더 포함할 params
 * @param pathname pathname
 * @param query query
 * @param host 각 호스트 store.ohou.se, contents.ohou.se, o2o.ohou.se
 * @param fallbackDesktopUrl fallback url
 * @param isOwap owap 유무
 * @param isGlobal global 유무
 */
function getDeepLink({
  additionalParams,
  pathname,
  query,
  host,
  fallbackDesktopUrl,
  isOwap,
  isGlobal
} = {}) {
  const queryObj = getQuery(query ?? location.search);
  const essentialQuery = pickBy({
    ...omit(queryObj, [...UTM_TAGS, ...QUERY_BLACKLIST])
  }, value => value != null);
  const escapedQuery = escapeBracesInQuery(essentialQuery);
  const searchString = queryString.stringify(escapedQuery);
  const deepLinkPath = pathname ?? location.pathname;
  const path = `${deepLinkPath}?${searchString}`;
  const utmData = getUtmData();
  const owapDeepLink = `ohouseapp://owap?url=https://${host}${path}&webviewType=page`;
  const deepLinkHost = isGlobal ? GLOBAL_DEEP_LINK_HOST : DEEP_LINK_HOST;
  const result = `${deepLinkHost}/${utmData['utm_source'] || 'web_organic'}?${queryString.stringify({
    deeplink_url: isOwap ? owapDeepLink : `${isGlobal ? 'ohouseglobalapp' : 'ohouseapp'}://${host}${path}`,
    // fallback_desktop을 공통으로 사용하려면 window.location.href 가 필요하지 않을까?
    fallback_desktop: fallbackDesktopUrl ?? window.location.href,
    campaign: queryObj['campaign'] || utmData['utm_campaign'],
    term: queryObj['term'] || utmData['utm_term'],
    client_id: M$1('visitor_id'),
    sub_id: queryObj['sub_id'] || utmData['bp_sub_id'],
    sub_id_1: 'ohouseWeb',
    sub_id_2: queryObj['sub_id_2'] || utmData['bp_sub_id_2'],
    sub_id_3: queryObj['sub_id_3'] || utmData['utm_medium'],
    ad_creative: queryObj['ad_creative'] || utmData['utm_content'],
    ad_group: queryObj['ad_group'] || utmData['bp_adset'],
    content: queryObj['content'] || utmData['bp_content'],
    ...(additionalParams ?? {})
  })}`;
  return result;
}

/**
 * 기존 있던 url에 query들을 연결시켜 주는 함수
 * @param url 기존 url
 * @param query 새로 붙일 query
 * @returns 연결된 url
 * @example
 * ```
 * joinLinkQuery('ohou.se/store?a=1&b=2', 'c=3&d=4')
 * ohou.se/store?a=1&b=2&c=3&d=4
 * ```
 */
const joinLinkQuery = (url, query) => {
  const pattern = /^([^?#]+)(\?[^?#]+)?(#.+?)?$/.exec(url);
  if (pattern == null) {
    return url;
  }
  const [, pathname, urlQuery, urlHash] = pattern;
  return pathname + (urlQuery ?? '') + (urlQuery != null ? '&' : '?') + query + (urlHash ?? '');
};

/**
 * 쿼리 문자열에서 utm 파라미터 객체를 추출합니다.
 * @param queryString utmData를 추출하고픈 target 쿼리 문자열
 * @return object 추출된 utm 파라미터 객체
 */
const getUtmDataFromUrl = queryString => {
  const query = getQuery(queryString ?? location.search);
  const utmQuery = pick$2(query, UTM_TAGS);
  return escapeBracesInQuery(utmQuery);
};

/**
 * 현재 url의 utmData를 추출하여 sessionStorage에 저장합니다.
 */
const setUtmData = () => {
  const urlData = getUtmDataFromUrl();
  if (isEmpty(urlData)) {
    return;
  }
  try {
    sessionStorage.setItem('ohsUtmData', JSON.stringify(urlData));
  } catch (e) {
    //
  }
};

const WP_TRACKING_ID = '47350';
const WP_TRACKING_TAG_TYPE = 'Home';
/**
 * wider planet script를 로드합니다.
 * @param user 로그인 유저 데이터
 * @example
 * ```
 * <div id="wp_tg_cts" style={{ display: 'none' }} />
 * <Script id="init-wp">
 *   { `${initWiderPlanet(navigation.loginUser)}` }
 * </Script>
 * <Script src="https://cdn-aitg.widerplanet.com/js/wp_astg_4.0.js" async />
 * ```
 */
const initWiderPlanet = user => {
  if (typeof window === 'undefined') {
    return;
  }
  window.wptg_tagscript_vars = window.wptg_tagscript_vars || [];
  window.wptg_tagscript_vars.push(() => {
    return {
      wp_hcuid: user?.id ?? '',
      ti: WP_TRACKING_ID,
      ty: WP_TRACKING_TAG_TYPE,
      device: navigator.userAgent.match(/ios|iphone|ipad|android/i) ? 'mobile' : 'web'
    };
  });
};

/**
 * 버킷로그 전역 객체를 초기화합니다.
 * 유저 정보가 있으면 버킷로그 데이터 큐에 유저 아이디를 넣습니다.
 * @param {User} user 로그인 유저 데이터
 * @example
 * ```
 * initBucketLog(user)
 * ```
 */
const initBucketLog = user => {
  if (typeof window === 'undefined') {
    return;
  }
  window.bucketLog = window.bucketLog || [];
  if (user) {
    window.bucketLog.push({
      user_id: user.id
    });
  }
};

/* eslint-disable local-rules/disallow-side-effects */
/**
 * Keep references on console methods to avoid triggering patched behaviors
 *
 * NB: in some setup, console could already be patched by another SDK.
 * In this case, some display messages can be sent by the other SDK
 * but we should be safe from infinite loop nonetheless.
 */
var ConsoleApiName = {
  log: 'log',
  debug: 'debug',
  info: 'info',
  warn: 'warn',
  error: 'error'
};
/**
 * When building JS bundles, some users might use a plugin[1] or configuration[2] to remove
 * "console.*" references. This causes some issue as we expect `console.*` to be defined.
 * As a workaround, let's use a variable alias, so those expressions won't be taken into account by
 * simple static analysis.
 *
 * [1]: https://babeljs.io/docs/babel-plugin-transform-remove-console/
 * [2]: https://github.com/terser/terser#compress-options (look for drop_console)
 */
var globalConsole = console;
var originalConsoleMethods = {};
Object.keys(ConsoleApiName).forEach(function (name) {
  originalConsoleMethods[name] = globalConsole[name];
});
var PREFIX = 'Datadog Browser SDK:';
var display = {
  debug: originalConsoleMethods.debug.bind(globalConsole, PREFIX),
  log: originalConsoleMethods.log.bind(globalConsole, PREFIX),
  info: originalConsoleMethods.info.bind(globalConsole, PREFIX),
  warn: originalConsoleMethods.warn.bind(globalConsole, PREFIX),
  error: originalConsoleMethods.error.bind(globalConsole, PREFIX)
};
var DOCS_ORIGIN = 'https://docs.datadoghq.com';

function catchUserErrors(fn, errorMsg) {
  return function () {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
      args[_i] = arguments[_i];
    }
    try {
      return fn.apply(void 0, args);
    } catch (err) {
      display.error(errorMsg, err);
    }
  };
}

/**
 * Return true if the draw is successful
 * @param threshold between 0 and 100
 */
function performDraw(threshold) {
  return threshold !== 0 && Math.random() * 100 <= threshold;
}
function round(num, decimals) {
  return +num.toFixed(decimals);
}
function isPercentage(value) {
  return isNumber(value) && value >= 0 && value <= 100;
}
function isNumber(value) {
  return typeof value === 'number';
}

var ONE_SECOND = 1000;
var ONE_MINUTE = 60 * ONE_SECOND;
var ONE_HOUR = 60 * ONE_MINUTE;
var ONE_DAY = 24 * ONE_HOUR;
var ONE_YEAR = 365 * ONE_DAY;
function relativeToClocks(relative) {
  return {
    relative: relative,
    timeStamp: getCorrectedTimeStamp(relative)
  };
}
function timeStampToClocks(timeStamp) {
  return {
    relative: getRelativeTime(timeStamp),
    timeStamp: timeStamp
  };
}
function getCorrectedTimeStamp(relativeTime) {
  var correctedOrigin = dateNow() - performance.now();
  // apply correction only for positive drift
  if (correctedOrigin > getNavigationStart()) {
    return Math.round(addDuration(correctedOrigin, relativeTime));
  }
  return getTimeStamp$1(relativeTime);
}
function currentDrift() {
  return Math.round(dateNow() - addDuration(getNavigationStart(), performance.now()));
}
function toServerDuration(duration) {
  if (!isNumber(duration)) {
    return duration;
  }
  return round(duration * 1e6, 0);
}
function dateNow() {
  // Do not use `Date.now` because sometimes websites are wrongly "polyfilling" it. For example, we
  // had some users using a very old version of `datejs`, which patched `Date.now` to return a Date
  // instance instead of a timestamp[1]. Those users are unlikely to fix this, so let's handle this
  // case ourselves.
  // [1]: https://github.com/datejs/Datejs/blob/97f5c7c58c5bc5accdab8aa7602b6ac56462d778/src/core-debug.js#L14-L16
  return new Date().getTime();
}
function timeStampNow() {
  return dateNow();
}
function relativeNow() {
  return performance.now();
}
function clocksNow() {
  return {
    relative: relativeNow(),
    timeStamp: timeStampNow()
  };
}
function clocksOrigin() {
  return {
    relative: 0,
    timeStamp: getNavigationStart()
  };
}
function elapsed(start, end) {
  return end - start;
}
function addDuration(a, b) {
  return a + b;
}
/**
 * Get the time since the navigation was started.
 *
 * Note: this does not use `performance.timeOrigin` because it doesn't seem to reflect the actual
 * time on which the navigation has started: it may be much farther in the past, at least in Firefox 71.
 * Related issue in Firefox: https://bugzilla.mozilla.org/show_bug.cgi?id=1429926
 */
function getRelativeTime(timestamp) {
  return timestamp - getNavigationStart();
}
function getTimeStamp$1(relativeTime) {
  return Math.round(addDuration(getNavigationStart(), relativeTime));
}
function looksLikeRelativeTime(time) {
  return time < ONE_YEAR;
}
/**
 * Navigation start slightly change on some rare cases
 */
var navigationStart;
function getNavigationStart() {
  if (navigationStart === undefined) {
    navigationStart = performance.timing.navigationStart;
  }
  return navigationStart;
}

var ONE_KIBI_BYTE = 1024;
var ONE_MEBI_BYTE = 1024 * ONE_KIBI_BYTE;
// eslint-disable-next-line no-control-regex
var HAS_MULTI_BYTES_CHARACTERS = /[^\u0000-\u007F]/;
function computeBytesCount(candidate) {
  // Accurate bytes count computations can degrade performances when there is a lot of events to process
  if (!HAS_MULTI_BYTES_CHARACTERS.test(candidate)) {
    return candidate.length;
  }
  if (window.TextEncoder !== undefined) {
    return new TextEncoder().encode(candidate).length;
  }
  return new Blob([candidate]).size;
}
function concatBuffers(buffers) {
  var length = buffers.reduce(function (total, buffer) {
    return total + buffer.length;
  }, 0);
  var result = new Uint8Array(length);
  var offset = 0;
  for (var _i = 0, buffers_1 = buffers; _i < buffers_1.length; _i++) {
    var buffer = buffers_1[_i];
    result.set(buffer, offset);
    offset += buffer.length;
  }
  return result;
}

function includes(candidate, search) {
  return candidate.indexOf(search) !== -1;
}
function arrayFrom(arrayLike) {
  if (Array.from) {
    return Array.from(arrayLike);
  }
  var array = [];
  if (arrayLike instanceof Set) {
    arrayLike.forEach(function (item) {
      return array.push(item);
    });
  } else {
    for (var i = 0; i < arrayLike.length; i++) {
      array.push(arrayLike[i]);
    }
  }
  return array;
}
function find(array, predicate) {
  for (var i = 0; i < array.length; i += 1) {
    var item = array[i];
    if (predicate(item, i)) {
      return item;
    }
  }
  return undefined;
}
function findLast(array, predicate) {
  for (var i = array.length - 1; i >= 0; i -= 1) {
    var item = array[i];
    if (predicate(item, i, array)) {
      return item;
    }
  }
  return undefined;
}
function forEach(list, callback) {
  Array.prototype.forEach.call(list, callback);
}
function objectValues(object) {
  return Object.keys(object).map(function (key) {
    return object[key];
  });
}
function objectEntries(object) {
  return Object.keys(object).map(function (key) {
    return [key, object[key]];
  });
}
function startsWith$1(candidate, search) {
  return candidate.slice(0, search.length) === search;
}
function endsWith(candidate, search) {
  return candidate.slice(-search.length) === search;
}
function assign(target) {
  var toAssign = [];
  for (var _i = 1; _i < arguments.length; _i++) {
    toAssign[_i - 1] = arguments[_i];
  }
  toAssign.forEach(function (source) {
    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  });
  return target;
}

function shallowClone(object) {
  return assign({}, object);
}
function objectHasValue(object, value) {
  return Object.keys(object).some(function (key) {
    return object[key] === value;
  });
}
function isEmptyObject(object) {
  return Object.keys(object).length === 0;
}
function mapValues(object, fn) {
  var newObject = {};
  for (var _i = 0, _a = Object.keys(object); _i < _a.length; _i++) {
    var key = _a[_i];
    newObject[key] = fn(object[key]);
  }
  return newObject;
}

/**
 * inspired by https://mathiasbynens.be/notes/globalthis
 */
function getGlobalObject() {
  if (typeof globalThis === 'object') {
    return globalThis;
  }
  Object.defineProperty(Object.prototype, '_dd_temp_', {
    get: function () {
      return this;
    },
    configurable: true
  });
  // @ts-ignore _dd_temp is defined using defineProperty
  var globalObject = _dd_temp_;
  // @ts-ignore _dd_temp is defined using defineProperty
  delete Object.prototype._dd_temp_;
  if (typeof globalObject !== 'object') {
    // on safari _dd_temp_ is available on window but not globally
    // fallback on other browser globals check
    if (typeof self === 'object') {
      globalObject = self;
    } else if (typeof window === 'object') {
      globalObject = window;
    } else {
      globalObject = {};
    }
  }
  return globalObject;
}

/**
 * Gets the original value for a DOM API that was potentially patched by Zone.js.
 *
 * Zone.js[1] is a library that patches a bunch of JS and DOM APIs. It usually stores the original
 * value of the patched functions/constructors/methods in a hidden property prefixed by
 * __zone_symbol__.
 *
 * In multiple occasions, we observed that Zone.js is the culprit of important issues leading to
 * browser resource exhaustion (memory leak, high CPU usage). This method is used as a workaround to
 * use the original DOM API instead of the one patched by Zone.js.
 *
 * [1]: https://github.com/angular/angular/tree/main/packages/zone.js
 */
function getZoneJsOriginalValue(target, name) {
  var browserWindow = getGlobalObject();
  var original;
  if (browserWindow.Zone && typeof browserWindow.Zone.__symbol__ === 'function') {
    original = target[browserWindow.Zone.__symbol__(name)];
  }
  if (!original) {
    original = target[name];
  }
  return original;
}

var __spreadArray =  false || function (to, from, pack) {
  if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
    if (ar || !(i in from)) {
      if (!ar) ar = Array.prototype.slice.call(from, 0, i);
      ar[i] = from[i];
    }
  }
  return to.concat(ar || Array.prototype.slice.call(from));
};
var onMonitorErrorCollected;
var debugMode = false;
function startMonitorErrorCollection(newOnMonitorErrorCollected) {
  onMonitorErrorCollected = newOnMonitorErrorCollected;
}
function setDebugMode(newDebugMode) {
  debugMode = newDebugMode;
}
function monitor(fn) {
  return function () {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    return callMonitored(fn, this, arguments);
  }; // consider output type has input type
}
function callMonitored(fn, context, args) {
  try {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    return fn.apply(context, args);
  } catch (e) {
    displayIfDebugEnabled(e);
    if (onMonitorErrorCollected) {
      try {
        onMonitorErrorCollected(e);
      } catch (e) {
        displayIfDebugEnabled(e);
      }
    }
  }
}
function displayIfDebugEnabled() {
  var args = [];
  for (var _i = 0; _i < arguments.length; _i++) {
    args[_i] = arguments[_i];
  }
  if (debugMode) {
    display.error.apply(display, __spreadArray(['[MONITOR]'], args, false));
  }
}

function setTimeout$1(callback, delay) {
  return getZoneJsOriginalValue(getGlobalObject(), 'setTimeout')(monitor(callback), delay);
}
function clearTimeout$1(timeoutId) {
  getZoneJsOriginalValue(getGlobalObject(), 'clearTimeout')(timeoutId);
}
function setInterval$1(callback, delay) {
  return getZoneJsOriginalValue(getGlobalObject(), 'setInterval')(monitor(callback), delay);
}
function clearInterval$1(timeoutId) {
  getZoneJsOriginalValue(getGlobalObject(), 'clearInterval')(timeoutId);
}

var Observable = /** @class */function () {
  function Observable(onFirstSubscribe) {
    this.onFirstSubscribe = onFirstSubscribe;
    this.observers = [];
  }
  Observable.prototype.subscribe = function (f) {
    var _this = this;
    this.observers.push(f);
    if (this.observers.length === 1 && this.onFirstSubscribe) {
      this.onLastUnsubscribe = this.onFirstSubscribe(this) || undefined;
    }
    return {
      unsubscribe: function () {
        _this.observers = _this.observers.filter(function (other) {
          return f !== other;
        });
        if (!_this.observers.length && _this.onLastUnsubscribe) {
          _this.onLastUnsubscribe();
        }
      }
    };
  };
  Observable.prototype.notify = function (data) {
    this.observers.forEach(function (observer) {
      return observer(data);
    });
  };
  return Observable;
}();
function mergeObservables() {
  var observables = [];
  for (var _i = 0; _i < arguments.length; _i++) {
    observables[_i] = arguments[_i];
  }
  return new Observable(function (globalObservable) {
    var subscriptions = observables.map(function (observable) {
      return observable.subscribe(function (data) {
        return globalObservable.notify(data);
      });
    });
    return function () {
      return subscriptions.forEach(function (subscription) {
        return subscription.unsubscribe();
      });
    };
  });
}

// use lodash API
function throttle(fn, wait, options) {
  var needLeadingExecution = options && options.leading !== undefined ? options.leading : true;
  var needTrailingExecution = options && options.trailing !== undefined ? options.trailing : true;
  var inWaitPeriod = false;
  var pendingExecutionWithParameters;
  var pendingTimeoutId;
  return {
    throttled: function () {
      var parameters = [];
      for (var _i = 0; _i < arguments.length; _i++) {
        parameters[_i] = arguments[_i];
      }
      if (inWaitPeriod) {
        pendingExecutionWithParameters = parameters;
        return;
      }
      if (needLeadingExecution) {
        fn.apply(void 0, parameters);
      } else {
        pendingExecutionWithParameters = parameters;
      }
      inWaitPeriod = true;
      pendingTimeoutId = setTimeout$1(function () {
        if (needTrailingExecution && pendingExecutionWithParameters) {
          fn.apply(void 0, pendingExecutionWithParameters);
        }
        inWaitPeriod = false;
        pendingExecutionWithParameters = undefined;
      }, wait);
    },
    cancel: function () {
      clearTimeout$1(pendingTimeoutId);
      inWaitPeriod = false;
      pendingExecutionWithParameters = undefined;
    }
  };
}
// eslint-disable-next-line @typescript-eslint/no-empty-function
function noop$1() {}

/**
 * UUID v4
 * from https://gist.github.com/jed/982883
 */
function generateUUID(placeholder) {
  return placeholder ?
  // eslint-disable-next-line  no-bitwise
  (parseInt(placeholder, 10) ^ Math.random() * 16 >> parseInt(placeholder, 10) / 4).toString(16) : "".concat(1e7, "-").concat(1e3, "-").concat(4e3, "-").concat(8e3, "-").concat(1e11).replace(/[018]/g, generateUUID);
}
var COMMA_SEPARATED_KEY_VALUE = /([\w-]+)\s*=\s*([^;]+)/g;
function findCommaSeparatedValue(rawString, name) {
  COMMA_SEPARATED_KEY_VALUE.lastIndex = 0;
  // eslint-disable-next-line no-constant-condition
  while (true) {
    var match = COMMA_SEPARATED_KEY_VALUE.exec(rawString);
    if (match) {
      if (match[1] === name) {
        return match[2];
      }
    } else {
      break;
    }
  }
}
function findCommaSeparatedValues(rawString) {
  var result = new Map();
  COMMA_SEPARATED_KEY_VALUE.lastIndex = 0;
  // eslint-disable-next-line no-constant-condition
  while (true) {
    var match = COMMA_SEPARATED_KEY_VALUE.exec(rawString);
    if (match) {
      result.set(match[1], match[2]);
    } else {
      break;
    }
  }
  return result;
}
function safeTruncate(candidate, length, suffix) {
  if (suffix === void 0) {
    suffix = '';
  }
  var lastChar = candidate.charCodeAt(length - 1);
  var isLastCharSurrogatePair = lastChar >= 0xd800 && lastChar <= 0xdbff;
  var correctedLength = isLastCharSurrogatePair ? length + 1 : length;
  if (candidate.length <= correctedLength) {
    return candidate;
  }
  return "".concat(candidate.slice(0, correctedLength)).concat(suffix);
}

function isIE() {
  return detectBrowserCached() === 0 /* Browser.IE */;
}
function isChromium() {
  return detectBrowserCached() === 1 /* Browser.CHROMIUM */;
}
function isSafari() {
  return detectBrowserCached() === 2 /* Browser.SAFARI */;
}
var browserCache;
function detectBrowserCached() {
  return browserCache !== null && browserCache !== void 0 ? browserCache : browserCache = detectBrowser();
}
// Exported only for tests
function detectBrowser(browserWindow) {
  var _a;
  if (browserWindow === void 0) {
    browserWindow = window;
  }
  var userAgent = browserWindow.navigator.userAgent;
  if (browserWindow.chrome || /HeadlessChrome/.test(userAgent)) {
    return 1 /* Browser.CHROMIUM */;
  }
  if (
  // navigator.vendor is deprecated, but it is the most resilient way we found to detect
  // "Apple maintained browsers" (AKA Safari). If one day it gets removed, we still have the
  // useragent test as a semi-working fallback.
  ((_a = browserWindow.navigator.vendor) === null || _a === void 0 ? void 0 : _a.indexOf('Apple')) === 0 || /safari/i.test(userAgent) && !/chrome|android/i.test(userAgent)) {
    return 2 /* Browser.SAFARI */;
  }
  if (browserWindow.document.documentMode) {
    return 0 /* Browser.IE */;
  }
  return 3 /* Browser.OTHER */;
}

function setCookie(name, value, expireDelay, options) {
  var date = new Date();
  date.setTime(date.getTime() + expireDelay);
  var expires = "expires=".concat(date.toUTCString());
  var sameSite = options && options.crossSite ? 'none' : 'strict';
  var domain = options && options.domain ? ";domain=".concat(options.domain) : '';
  var secure = options && options.secure ? ';secure' : '';
  var partitioned = options && options.partitioned ? ';partitioned' : '';
  document.cookie = "".concat(name, "=").concat(value, ";").concat(expires, ";path=/;samesite=").concat(sameSite).concat(domain).concat(secure).concat(partitioned);
}
function getCookie(name) {
  return findCommaSeparatedValue(document.cookie, name);
}
var initCookieParsed;
/**
 * Returns a cached value of the cookie. Use this during SDK initialization (and whenever possible)
 * to avoid accessing document.cookie multiple times.
 */
function getInitCookie(name) {
  if (!initCookieParsed) {
    initCookieParsed = findCommaSeparatedValues(document.cookie);
  }
  return initCookieParsed.get(name);
}
function deleteCookie(name, options) {
  setCookie(name, '', 0, options);
}
function areCookiesAuthorized(options) {
  if (document.cookie === undefined || document.cookie === null) {
    return false;
  }
  try {
    // Use a unique cookie name to avoid issues when the SDK is initialized multiple times during
    // the test cookie lifetime
    var testCookieName = "dd_cookie_test_".concat(generateUUID());
    var testCookieValue = 'test';
    setCookie(testCookieName, testCookieValue, ONE_MINUTE, options);
    var isCookieCorrectlySet = getCookie(testCookieName) === testCookieValue;
    deleteCookie(testCookieName, options);
    return isCookieCorrectlySet;
  } catch (error) {
    display.error(error);
    return false;
  }
}
/**
 * No API to retrieve it, number of levels for subdomain and suffix are unknown
 * strategy: find the minimal domain on which cookies are allowed to be set
 * https://web.dev/same-site-same-origin/#site
 */
var getCurrentSiteCache;
function getCurrentSite() {
  if (getCurrentSiteCache === undefined) {
    // Use a unique cookie name to avoid issues when the SDK is initialized multiple times during
    // the test cookie lifetime
    var testCookieName = "dd_site_test_".concat(generateUUID());
    var testCookieValue = 'test';
    var domainLevels = window.location.hostname.split('.');
    var candidateDomain = domainLevels.pop();
    while (domainLevels.length && !getCookie(testCookieName)) {
      candidateDomain = "".concat(domainLevels.pop(), ".").concat(candidateDomain);
      setCookie(testCookieName, testCookieValue, ONE_SECOND, {
        domain: candidateDomain
      });
    }
    deleteCookie(testCookieName, {
      domain: candidateDomain
    });
    getCurrentSiteCache = candidateDomain;
  }
  return getCurrentSiteCache;
}

var SESSION_STORE_KEY = '_dd_s';

var SESSION_TIME_OUT_DELAY = 4 * ONE_HOUR;
var SESSION_EXPIRATION_DELAY = 15 * ONE_MINUTE;

var SESSION_ENTRY_REGEXP = /^([a-zA-Z]+)=([a-z0-9-]+)$/;
var SESSION_ENTRY_SEPARATOR = '&';
var EXPIRED = '1';
function getExpiredSessionState() {
  return {
    isExpired: EXPIRED
  };
}
function isSessionInNotStartedState(session) {
  return isEmptyObject(session);
}
function isSessionStarted(session) {
  return !isSessionInNotStartedState(session);
}
function isSessionInExpiredState(session) {
  return session.isExpired !== undefined || !isActiveSession(session);
}
// An active session is a session in either `Tracked` or `NotTracked` state
function isActiveSession(sessionState) {
  // created and expire can be undefined for versions which was not storing them
  // these checks could be removed when older versions will not be available/live anymore
  return (sessionState.created === undefined || dateNow() - Number(sessionState.created) < SESSION_TIME_OUT_DELAY) && (sessionState.expire === undefined || dateNow() < Number(sessionState.expire));
}
function expandSessionState(session) {
  session.expire = String(dateNow() + SESSION_EXPIRATION_DELAY);
}
function toSessionString(session) {
  return objectEntries(session).map(function (_a) {
    var key = _a[0],
      value = _a[1];
    return "".concat(key, "=").concat(value);
  }).join(SESSION_ENTRY_SEPARATOR);
}
function toSessionState(sessionString) {
  var session = {};
  if (isValidSessionString(sessionString)) {
    sessionString.split(SESSION_ENTRY_SEPARATOR).forEach(function (entry) {
      var matches = SESSION_ENTRY_REGEXP.exec(entry);
      if (matches !== null) {
        var key = matches[1],
          value = matches[2];
        session[key] = value;
      }
    });
  }
  return session;
}
function isValidSessionString(sessionString) {
  return !!sessionString && (sessionString.indexOf(SESSION_ENTRY_SEPARATOR) !== -1 || SESSION_ENTRY_REGEXP.test(sessionString));
}

var OLD_SESSION_COOKIE_NAME = '_dd';
var OLD_RUM_COOKIE_NAME = '_dd_r';
var OLD_LOGS_COOKIE_NAME = '_dd_l';
// duplicate values to avoid dependency issues
var RUM_SESSION_KEY$1 = 'rum';
var LOGS_SESSION_KEY = 'logs';
/**
 * This migration should remain in the codebase as long as older versions are available/live
 * to allow older sdk versions to be upgraded to newer versions without compatibility issues.
 */
function tryOldCookiesMigration(cookieStoreStrategy) {
  var sessionString = getInitCookie(SESSION_STORE_KEY);
  if (!sessionString) {
    var oldSessionId = getInitCookie(OLD_SESSION_COOKIE_NAME);
    var oldRumType = getInitCookie(OLD_RUM_COOKIE_NAME);
    var oldLogsType = getInitCookie(OLD_LOGS_COOKIE_NAME);
    var session = {};
    if (oldSessionId) {
      session.id = oldSessionId;
    }
    if (oldLogsType && /^[01]$/.test(oldLogsType)) {
      session[LOGS_SESSION_KEY] = oldLogsType;
    }
    if (oldRumType && /^[012]$/.test(oldRumType)) {
      session[RUM_SESSION_KEY$1] = oldRumType;
    }
    if (isSessionStarted(session)) {
      expandSessionState(session);
      cookieStoreStrategy.persistSession(session);
    }
  }
}

function selectCookieStrategy(initConfiguration) {
  var cookieOptions = buildCookieOptions(initConfiguration);
  return areCookiesAuthorized(cookieOptions) ? {
    type: 'Cookie',
    cookieOptions: cookieOptions
  } : undefined;
}
function initCookieStrategy(cookieOptions) {
  var cookieStore = {
    /**
     * Lock strategy allows mitigating issues due to concurrent access to cookie.
     * This issue concerns only chromium browsers and enabling this on firefox increases cookie write failures.
     */
    isLockEnabled: isChromium(),
    persistSession: persistSessionCookie(cookieOptions),
    retrieveSession: retrieveSessionCookie,
    expireSession: function () {
      return expireSessionCookie(cookieOptions);
    }
  };
  tryOldCookiesMigration(cookieStore);
  return cookieStore;
}
function persistSessionCookie(options) {
  return function (session) {
    setCookie(SESSION_STORE_KEY, toSessionString(session), SESSION_EXPIRATION_DELAY, options);
  };
}
function expireSessionCookie(options) {
  setCookie(SESSION_STORE_KEY, toSessionString(getExpiredSessionState()), SESSION_TIME_OUT_DELAY, options);
}
function retrieveSessionCookie() {
  var sessionString = getCookie(SESSION_STORE_KEY);
  return toSessionState(sessionString);
}
function buildCookieOptions(initConfiguration) {
  var cookieOptions = {};
  cookieOptions.secure = !!initConfiguration.useSecureSessionCookie || !!initConfiguration.usePartitionedCrossSiteSessionCookie || !!initConfiguration.useCrossSiteSessionCookie;
  cookieOptions.crossSite = !!initConfiguration.usePartitionedCrossSiteSessionCookie || !!initConfiguration.useCrossSiteSessionCookie;
  cookieOptions.partitioned = !!initConfiguration.usePartitionedCrossSiteSessionCookie;
  if (initConfiguration.trackSessionAcrossSubdomains) {
    cookieOptions.domain = getCurrentSite();
  }
  return cookieOptions;
}

var LOCAL_STORAGE_TEST_KEY = '_dd_test_';
function selectLocalStorageStrategy() {
  try {
    var id = generateUUID();
    var testKey = "".concat(LOCAL_STORAGE_TEST_KEY).concat(id);
    localStorage.setItem(testKey, id);
    var retrievedId = localStorage.getItem(testKey);
    localStorage.removeItem(testKey);
    return id === retrievedId ? {
      type: 'LocalStorage'
    } : undefined;
  } catch (e) {
    return undefined;
  }
}
function initLocalStorageStrategy() {
  return {
    isLockEnabled: false,
    persistSession: persistInLocalStorage,
    retrieveSession: retrieveSessionFromLocalStorage,
    expireSession: expireSessionFromLocalStorage
  };
}
function persistInLocalStorage(sessionState) {
  localStorage.setItem(SESSION_STORE_KEY, toSessionString(sessionState));
}
function retrieveSessionFromLocalStorage() {
  var sessionString = localStorage.getItem(SESSION_STORE_KEY);
  return toSessionState(sessionString);
}
function expireSessionFromLocalStorage() {
  persistInLocalStorage(getExpiredSessionState());
}

var LOCK_RETRY_DELAY = 10;
var LOCK_MAX_TRIES = 100;
var bufferedOperations = [];
var ongoingOperations;
function processSessionStoreOperations(operations, sessionStoreStrategy, numberOfRetries) {
  var _a;
  if (numberOfRetries === void 0) {
    numberOfRetries = 0;
  }
  var isLockEnabled = sessionStoreStrategy.isLockEnabled,
    persistSession = sessionStoreStrategy.persistSession,
    expireSession = sessionStoreStrategy.expireSession;
  var persistWithLock = function (session) {
    return persistSession(assign({}, session, {
      lock: currentLock
    }));
  };
  var retrieveStore = function () {
    var session = sessionStoreStrategy.retrieveSession();
    var lock = session.lock;
    if (session.lock) {
      delete session.lock;
    }
    return {
      session: session,
      lock: lock
    };
  };
  if (!ongoingOperations) {
    ongoingOperations = operations;
  }
  if (operations !== ongoingOperations) {
    bufferedOperations.push(operations);
    return;
  }
  if (isLockEnabled && numberOfRetries >= LOCK_MAX_TRIES) {
    next(sessionStoreStrategy);
    return;
  }
  var currentLock;
  var currentStore = retrieveStore();
  if (isLockEnabled) {
    // if someone has lock, retry later
    if (currentStore.lock) {
      retryLater(operations, sessionStoreStrategy, numberOfRetries);
      return;
    }
    // acquire lock
    currentLock = generateUUID();
    persistWithLock(currentStore.session);
    // if lock is not acquired, retry later
    currentStore = retrieveStore();
    if (currentStore.lock !== currentLock) {
      retryLater(operations, sessionStoreStrategy, numberOfRetries);
      return;
    }
  }
  var processedSession = operations.process(currentStore.session);
  if (isLockEnabled) {
    // if lock corrupted after process, retry later
    currentStore = retrieveStore();
    if (currentStore.lock !== currentLock) {
      retryLater(operations, sessionStoreStrategy, numberOfRetries);
      return;
    }
  }
  if (processedSession) {
    if (isSessionInExpiredState(processedSession)) {
      expireSession();
    } else {
      expandSessionState(processedSession);
      isLockEnabled ? persistWithLock(processedSession) : persistSession(processedSession);
    }
  }
  if (isLockEnabled) {
    // correctly handle lock around expiration would require to handle this case properly at several levels
    // since we don't have evidence of lock issues around expiration, let's just not do the corruption check for it
    if (!(processedSession && isSessionInExpiredState(processedSession))) {
      // if lock corrupted after persist, retry later
      currentStore = retrieveStore();
      if (currentStore.lock !== currentLock) {
        retryLater(operations, sessionStoreStrategy, numberOfRetries);
        return;
      }
      persistSession(currentStore.session);
      processedSession = currentStore.session;
    }
  }
  // call after even if session is not persisted in order to perform operations on
  // up-to-date session state value => the value could have been modified by another tab
  (_a = operations.after) === null || _a === void 0 ? void 0 : _a.call(operations, processedSession || currentStore.session);
  next(sessionStoreStrategy);
}
function retryLater(operations, sessionStore, currentNumberOfRetries) {
  setTimeout$1(function () {
    processSessionStoreOperations(operations, sessionStore, currentNumberOfRetries + 1);
  }, LOCK_RETRY_DELAY);
}
function next(sessionStore) {
  ongoingOperations = undefined;
  var nextOperations = bufferedOperations.shift();
  if (nextOperations) {
    processSessionStoreOperations(nextOperations, sessionStore);
  }
}

/**
 * Every second, the storage will be polled to check for any change that can occur
 * to the session state in another browser tab, or another window.
 * This value has been determined from our previous cookie-only implementation.
 */
var STORAGE_POLL_DELAY = ONE_SECOND;
/**
 * Checks if cookies are available as the preferred storage
 * Else, checks if LocalStorage is allowed and available
 */
function selectSessionStoreStrategyType(initConfiguration) {
  var sessionStoreStrategyType = selectCookieStrategy(initConfiguration);
  if (!sessionStoreStrategyType && initConfiguration.allowFallbackToLocalStorage) {
    sessionStoreStrategyType = selectLocalStorageStrategy();
  }
  return sessionStoreStrategyType;
}
/**
 * Different session concepts:
 * - tracked, the session has an id and is updated along the user navigation
 * - not tracked, the session does not have an id but it is updated along the user navigation
 * - inactive, no session in store or session expired, waiting for a renew session
 */
function startSessionStore(sessionStoreStrategyType, productKey, computeSessionState) {
  var renewObservable = new Observable();
  var expireObservable = new Observable();
  var sessionStateUpdateObservable = new Observable();
  var sessionStoreStrategy = sessionStoreStrategyType.type === 'Cookie' ? initCookieStrategy(sessionStoreStrategyType.cookieOptions) : initLocalStorageStrategy();
  var expireSession = sessionStoreStrategy.expireSession;
  var watchSessionTimeoutId = setInterval$1(watchSession, STORAGE_POLL_DELAY);
  var sessionCache;
  startSession();
  var _a = throttle(function () {
      processSessionStoreOperations({
        process: function (sessionState) {
          if (isSessionInNotStartedState(sessionState)) {
            return;
          }
          var synchronizedSession = synchronizeSession(sessionState);
          expandOrRenewSessionState(synchronizedSession);
          return synchronizedSession;
        },
        after: function (sessionState) {
          if (isSessionStarted(sessionState) && !hasSessionInCache()) {
            renewSessionInCache(sessionState);
          }
          sessionCache = sessionState;
        }
      }, sessionStoreStrategy);
    }, STORAGE_POLL_DELAY),
    throttledExpandOrRenewSession = _a.throttled,
    cancelExpandOrRenewSession = _a.cancel;
  function expandSession() {
    processSessionStoreOperations({
      process: function (sessionState) {
        return hasSessionInCache() ? synchronizeSession(sessionState) : undefined;
      }
    }, sessionStoreStrategy);
  }
  /**
   * allows two behaviors:
   * - if the session is active, synchronize the session cache without updating the session store
   * - if the session is not active, clear the session store and expire the session cache
   */
  function watchSession() {
    processSessionStoreOperations({
      process: function (sessionState) {
        return isSessionInExpiredState(sessionState) ? getExpiredSessionState() : undefined;
      },
      after: synchronizeSession
    }, sessionStoreStrategy);
  }
  function synchronizeSession(sessionState) {
    if (isSessionInExpiredState(sessionState)) {
      sessionState = getExpiredSessionState();
    }
    if (hasSessionInCache()) {
      if (isSessionInCacheOutdated(sessionState)) {
        expireSessionInCache();
      } else {
        sessionStateUpdateObservable.notify({
          previousState: sessionCache,
          newState: sessionState
        });
        sessionCache = sessionState;
      }
    }
    return sessionState;
  }
  function startSession() {
    processSessionStoreOperations({
      process: function (sessionState) {
        if (isSessionInNotStartedState(sessionState)) {
          return getExpiredSessionState();
        }
      },
      after: function (sessionState) {
        sessionCache = sessionState;
      }
    }, sessionStoreStrategy);
  }
  function expandOrRenewSessionState(sessionState) {
    if (isSessionInNotStartedState(sessionState)) {
      return false;
    }
    var _a = computeSessionState(sessionState[productKey]),
      trackingType = _a.trackingType,
      isTracked = _a.isTracked;
    sessionState[productKey] = trackingType;
    delete sessionState.isExpired;
    if (isTracked && !sessionState.id) {
      sessionState.id = generateUUID();
      sessionState.created = String(dateNow());
    }
  }
  function hasSessionInCache() {
    return sessionCache[productKey] !== undefined;
  }
  function isSessionInCacheOutdated(sessionState) {
    return sessionCache.id !== sessionState.id || sessionCache[productKey] !== sessionState[productKey];
  }
  function expireSessionInCache() {
    sessionCache = getExpiredSessionState();
    expireObservable.notify();
  }
  function renewSessionInCache(sessionState) {
    sessionCache = sessionState;
    renewObservable.notify();
  }
  function updateSessionState(partialSessionState) {
    processSessionStoreOperations({
      process: function (sessionState) {
        return assign({}, sessionState, partialSessionState);
      },
      after: synchronizeSession
    }, sessionStoreStrategy);
  }
  return {
    expandOrRenewSession: throttledExpandOrRenewSession,
    expandSession: expandSession,
    getSession: function () {
      return sessionCache;
    },
    renewObservable: renewObservable,
    expireObservable: expireObservable,
    sessionStateUpdateObservable: sessionStateUpdateObservable,
    restartSession: startSession,
    expire: function () {
      cancelExpandOrRenewSession();
      expireSession();
      synchronizeSession(getExpiredSessionState());
    },
    stop: function () {
      clearInterval$1(watchSessionTimeoutId);
    },
    updateSessionState: updateSessionState
  };
}

var TrackingConsent = {
  GRANTED: 'granted',
  NOT_GRANTED: 'not-granted'
};
function createTrackingConsentState(currentConsent) {
  var observable = new Observable();
  return {
    tryToInit: function (trackingConsent) {
      if (!currentConsent) {
        currentConsent = trackingConsent;
      }
    },
    update: function (trackingConsent) {
      currentConsent = trackingConsent;
      observable.notify();
    },
    isGranted: function () {
      return currentConsent === TrackingConsent.GRANTED;
    },
    observable: observable
  };
}

/**
 * Custom implementation of JSON.stringify that ignores some toJSON methods. We need to do that
 * because some sites badly override toJSON on certain objects. Removing all toJSON methods from
 * nested values would be too costly, so we just detach them from the root value, and native classes
 * used to build JSON values (Array and Object).
 *
 * Note: this still assumes that JSON.stringify is correct.
 */
function jsonStringify(value, replacer, space) {
  if (typeof value !== 'object' || value === null) {
    return JSON.stringify(value);
  }
  // Note: The order matter here. We need to detach toJSON methods on parent classes before their
  // subclasses.
  var restoreObjectPrototypeToJson = detachToJsonMethod(Object.prototype);
  var restoreArrayPrototypeToJson = detachToJsonMethod(Array.prototype);
  var restoreValuePrototypeToJson = detachToJsonMethod(Object.getPrototypeOf(value));
  var restoreValueToJson = detachToJsonMethod(value);
  try {
    return JSON.stringify(value, replacer, space);
  } catch (_a) {
    return '<error: unable to serialize object>';
  } finally {
    restoreObjectPrototypeToJson();
    restoreArrayPrototypeToJson();
    restoreValuePrototypeToJson();
    restoreValueToJson();
  }
}
function detachToJsonMethod(value) {
  var object = value;
  var objectToJson = object.toJSON;
  if (objectToJson) {
    delete object.toJSON;
    return function () {
      object.toJSON = objectToJson;
    };
  }
  return noop$1;
}

function normalizeUrl(url) {
  return buildUrl(url, location.href).href;
}
function isValidUrl(url) {
  try {
    return !!buildUrl(url);
  } catch (_a) {
    return false;
  }
}
function getPathName(url) {
  var pathname = buildUrl(url).pathname;
  return pathname[0] === '/' ? pathname : "/".concat(pathname);
}
function buildUrl(url, base) {
  var supportedURL = getSupportedUrl();
  if (supportedURL) {
    try {
      return base !== undefined ? new supportedURL(url, base) : new supportedURL(url);
    } catch (error) {
      throw new Error("Failed to construct URL: ".concat(String(error), " ").concat(jsonStringify({
        url: url,
        base: base
      })));
    }
  }
  if (base === undefined && !/:/.test(url)) {
    throw new Error("Invalid URL: '".concat(url, "'"));
  }
  var doc = document;
  var anchorElement = doc.createElement('a');
  if (base !== undefined) {
    doc = document.implementation.createHTMLDocument('');
    var baseElement = doc.createElement('base');
    baseElement.href = base;
    doc.head.appendChild(baseElement);
    doc.body.appendChild(anchorElement);
  }
  anchorElement.href = url;
  return anchorElement;
}
var originalURL = URL;
var isURLSupported;
function getSupportedUrl() {
  if (isURLSupported === undefined) {
    try {
      var url = new originalURL('http://test/path');
      isURLSupported = url.href === 'http://test/path';
    } catch (_a) {
      isURLSupported = false;
    }
  }
  return isURLSupported ? originalURL : undefined;
}

var INTAKE_SITE_STAGING = 'datad0g.com';
var INTAKE_SITE_FED_STAGING = 'dd0g-gov.com';
var INTAKE_SITE_US1 = 'datadoghq.com';
var INTAKE_SITE_EU1 = 'datadoghq.eu';
var INTAKE_SITE_US1_FED = 'ddog-gov.com';
var PCI_INTAKE_HOST_US1 = 'pci.browser-intake-datadoghq.com';

function createEndpointBuilder(initConfiguration, trackType, configurationTags) {
  var buildUrlWithParameters = createEndpointUrlWithParametersBuilder(initConfiguration, trackType);
  return {
    build: function (api, payload) {
      var parameters = buildEndpointParameters(initConfiguration, trackType, configurationTags, api, payload);
      return buildUrlWithParameters(parameters);
    },
    urlPrefix: buildUrlWithParameters(''),
    trackType: trackType
  };
}
/**
 * Create a function used to build a full endpoint url from provided parameters. The goal of this
 * function is to pre-compute some parts of the URL to avoid re-computing everything on every
 * request, as only parameters are changing.
 */
function createEndpointUrlWithParametersBuilder(initConfiguration, trackType) {
  var path = "/api/v2/".concat(trackType);
  var proxy = initConfiguration.proxy;
  if (typeof proxy === 'string') {
    var normalizedProxyUrl_1 = normalizeUrl(proxy);
    return function (parameters) {
      return "".concat(normalizedProxyUrl_1, "?ddforward=").concat(encodeURIComponent("".concat(path, "?").concat(parameters)));
    };
  }
  if (typeof proxy === 'function') {
    return function (parameters) {
      return proxy({
        path: path,
        parameters: parameters
      });
    };
  }
  var host = buildEndpointHost(trackType, initConfiguration);
  return function (parameters) {
    return "https://".concat(host).concat(path, "?").concat(parameters);
  };
}
function buildEndpointHost(trackType, initConfiguration) {
  var _a = initConfiguration.site,
    site = _a === void 0 ? INTAKE_SITE_US1 : _a,
    internalAnalyticsSubdomain = initConfiguration.internalAnalyticsSubdomain;
  if (trackType === 'logs' && initConfiguration.usePciIntake && site === INTAKE_SITE_US1) {
    return PCI_INTAKE_HOST_US1;
  }
  if (internalAnalyticsSubdomain && site === INTAKE_SITE_US1) {
    return "".concat(internalAnalyticsSubdomain, ".").concat(INTAKE_SITE_US1);
  }
  if (site === INTAKE_SITE_FED_STAGING) {
    return "http-intake.logs.".concat(site);
  }
  var domainParts = site.split('.');
  var extension = domainParts.pop();
  return "browser-intake-".concat(domainParts.join('-'), ".").concat(extension);
}
/**
 * Build parameters to be used for an intake request. Parameters should be re-built for each
 * request, as they change randomly.
 */
function buildEndpointParameters(_a, trackType, configurationTags, api, _b) {
  var clientToken = _a.clientToken,
    internalAnalyticsSubdomain = _a.internalAnalyticsSubdomain;
  var retry = _b.retry,
    encoding = _b.encoding;
  var tags = ["sdk_version:".concat("5.23.0"), "api:".concat(api)].concat(configurationTags);
  if (retry) {
    tags.push("retry_count:".concat(retry.count), "retry_after:".concat(retry.lastFailureStatus));
  }
  var parameters = ['ddsource=browser', "ddtags=".concat(encodeURIComponent(tags.join(','))), "dd-api-key=".concat(clientToken), "dd-evp-origin-version=".concat(encodeURIComponent("5.23.0")), 'dd-evp-origin=browser', "dd-request-id=".concat(generateUUID())];
  if (encoding) {
    parameters.push("dd-evp-encoding=".concat(encoding));
  }
  if (trackType === 'rum') {
    parameters.push("batch_time=".concat(timeStampNow()));
  }
  if (internalAnalyticsSubdomain) {
    parameters.reverse();
  }
  return parameters.join('&');
}

var TAG_SIZE_LIMIT = 200;
function buildTags(configuration) {
  var env = configuration.env,
    service = configuration.service,
    version = configuration.version,
    datacenter = configuration.datacenter;
  var tags = [];
  if (env) {
    tags.push(buildTag('env', env));
  }
  if (service) {
    tags.push(buildTag('service', service));
  }
  if (version) {
    tags.push(buildTag('version', version));
  }
  if (datacenter) {
    tags.push(buildTag('datacenter', datacenter));
  }
  return tags;
}
var FORBIDDEN_CHARACTERS = /[^a-z0-9_:./-]/;
function buildTag(key, rawValue) {
  // See https://docs.datadoghq.com/getting_started/tagging/#defining-tags for tags syntax. Note
  // that the backend may not follow the exact same rules, so we only want to display an informal
  // warning.
  var valueSizeLimit = TAG_SIZE_LIMIT - key.length - 1;
  if (rawValue.length > valueSizeLimit || FORBIDDEN_CHARACTERS.test(rawValue)) {
    display.warn("".concat(key, " value doesn't meet tag requirements and will be sanitized. More details: ").concat(DOCS_ORIGIN, "/getting_started/tagging/#defining-tags"));
  }
  // Let the backend do most of the sanitization, but still make sure multiple tags can't be crafted
  // by forging a value containing commas.
  var sanitizedValue = rawValue.replace(/,/g, '_');
  return "".concat(key, ":").concat(sanitizedValue);
}

function computeTransportConfiguration(initConfiguration) {
  var site = initConfiguration.site || INTAKE_SITE_US1;
  var tags = buildTags(initConfiguration);
  var endpointBuilders = computeEndpointBuilders(initConfiguration, tags);
  var intakeUrlPrefixes = computeIntakeUrlPrefixes(endpointBuilders, site);
  var replicaConfiguration = computeReplicaConfiguration(initConfiguration, intakeUrlPrefixes, tags);
  return assign({
    isIntakeUrl: function (url) {
      return intakeUrlPrefixes.some(function (intakeEndpoint) {
        return url.indexOf(intakeEndpoint) === 0;
      });
    },
    replica: replicaConfiguration,
    site: site
  }, endpointBuilders);
}
function computeEndpointBuilders(initConfiguration, tags) {
  return {
    logsEndpointBuilder: createEndpointBuilder(initConfiguration, 'logs', tags),
    rumEndpointBuilder: createEndpointBuilder(initConfiguration, 'rum', tags),
    sessionReplayEndpointBuilder: createEndpointBuilder(initConfiguration, 'replay', tags)
  };
}
function computeReplicaConfiguration(initConfiguration, intakeUrlPrefixes, tags) {
  if (!initConfiguration.replica) {
    return;
  }
  var replicaConfiguration = assign({}, initConfiguration, {
    site: INTAKE_SITE_US1,
    clientToken: initConfiguration.replica.clientToken
  });
  var replicaEndpointBuilders = {
    logsEndpointBuilder: createEndpointBuilder(replicaConfiguration, 'logs', tags),
    rumEndpointBuilder: createEndpointBuilder(replicaConfiguration, 'rum', tags)
  };
  intakeUrlPrefixes.push.apply(intakeUrlPrefixes, objectValues(replicaEndpointBuilders).map(function (builder) {
    return builder.urlPrefix;
  }));
  return assign({
    applicationId: initConfiguration.replica.applicationId
  }, replicaEndpointBuilders);
}
function computeIntakeUrlPrefixes(endpointBuilders, site) {
  var intakeUrlPrefixes = objectValues(endpointBuilders).map(function (builder) {
    return builder.urlPrefix;
  });
  if (site === INTAKE_SITE_US1) {
    intakeUrlPrefixes.push("https://".concat(PCI_INTAKE_HOST_US1, "/"));
  }
  return intakeUrlPrefixes;
}

var DefaultPrivacyLevel = {
  ALLOW: 'allow',
  MASK: 'mask',
  MASK_USER_INPUT: 'mask-user-input'
};
var TraceContextInjection = {
  ALL: 'all',
  SAMPLED: 'sampled'
};
function checkIfString(tag, tagName) {
  if (tag !== undefined && tag !== null && typeof tag !== 'string') {
    display.error("".concat(tagName, " must be defined as a string"));
    return false;
  }
  return true;
}
function isDatadogSite(site) {
  return /(datadog|ddog|datad0g|dd0g)/.test(site);
}
function validateAndBuildConfiguration(initConfiguration) {
  var _a, _b, _c, _d, _e;
  if (!initConfiguration || !initConfiguration.clientToken) {
    display.error('Client Token is not configured, we will not send any data.');
    return;
  }
  if (initConfiguration.sessionSampleRate !== undefined && !isPercentage(initConfiguration.sessionSampleRate)) {
    display.error('Session Sample Rate should be a number between 0 and 100');
    return;
  }
  if (initConfiguration.telemetrySampleRate !== undefined && !isPercentage(initConfiguration.telemetrySampleRate)) {
    display.error('Telemetry Sample Rate should be a number between 0 and 100');
    return;
  }
  if (initConfiguration.telemetryConfigurationSampleRate !== undefined && !isPercentage(initConfiguration.telemetryConfigurationSampleRate)) {
    display.error('Telemetry Configuration Sample Rate should be a number between 0 and 100');
    return;
  }
  if (initConfiguration.telemetryUsageSampleRate !== undefined && !isPercentage(initConfiguration.telemetryUsageSampleRate)) {
    display.error('Telemetry Usage Sample Rate should be a number between 0 and 100');
    return;
  }
  if (!checkIfString(initConfiguration.version, 'Version')) {
    return;
  }
  if (!checkIfString(initConfiguration.env, 'Env')) {
    return;
  }
  if (!checkIfString(initConfiguration.service, 'Service')) {
    return;
  }
  if (initConfiguration.trackingConsent !== undefined && !objectHasValue(TrackingConsent, initConfiguration.trackingConsent)) {
    display.error('Tracking Consent should be either "granted" or "not-granted"');
    return;
  }
  if (initConfiguration.site && !isDatadogSite(initConfiguration.site)) {
    display.error("Site should be a valid Datadog site. Learn more here: ".concat(DOCS_ORIGIN, "/getting_started/site/."));
    return;
  }
  return assign({
    beforeSend: initConfiguration.beforeSend && catchUserErrors(initConfiguration.beforeSend, 'beforeSend threw an error:'),
    sessionStoreStrategyType: selectSessionStoreStrategyType(initConfiguration),
    sessionSampleRate: (_a = initConfiguration.sessionSampleRate) !== null && _a !== void 0 ? _a : 100,
    telemetrySampleRate: (_b = initConfiguration.telemetrySampleRate) !== null && _b !== void 0 ? _b : 20,
    telemetryConfigurationSampleRate: (_c = initConfiguration.telemetryConfigurationSampleRate) !== null && _c !== void 0 ? _c : 5,
    telemetryUsageSampleRate: (_d = initConfiguration.telemetryUsageSampleRate) !== null && _d !== void 0 ? _d : 5,
    service: initConfiguration.service || undefined,
    silentMultipleInit: !!initConfiguration.silentMultipleInit,
    allowUntrustedEvents: !!initConfiguration.allowUntrustedEvents,
    trackingConsent: (_e = initConfiguration.trackingConsent) !== null && _e !== void 0 ? _e : TrackingConsent.GRANTED,
    storeContextsAcrossPages: !!initConfiguration.storeContextsAcrossPages,
    /**
     * beacon payload max queue size implementation is 64kb
     * ensure that we leave room for logs, rum and potential other users
     */
    batchBytesLimit: 16 * ONE_KIBI_BYTE,
    eventRateLimiterThreshold: 3000,
    maxTelemetryEventsPerPage: 15,
    /**
     * flush automatically, aim to be lower than ALB connection timeout
     * to maximize connection reuse.
     */
    flushTimeout: 30 * ONE_SECOND,
    /**
     * Logs intake limit
     */
    batchMessagesLimit: 50,
    messageBytesLimit: 256 * ONE_KIBI_BYTE
  }, computeTransportConfiguration(initConfiguration));
}
function serializeConfiguration(initConfiguration) {
  return {
    session_sample_rate: initConfiguration.sessionSampleRate,
    telemetry_sample_rate: initConfiguration.telemetrySampleRate,
    telemetry_configuration_sample_rate: initConfiguration.telemetryConfigurationSampleRate,
    telemetry_usage_sample_rate: initConfiguration.telemetryUsageSampleRate,
    use_before_send: !!initConfiguration.beforeSend,
    use_cross_site_session_cookie: initConfiguration.useCrossSiteSessionCookie,
    use_partitioned_cross_site_session_cookie: initConfiguration.usePartitionedCrossSiteSessionCookie,
    use_secure_session_cookie: initConfiguration.useSecureSessionCookie,
    use_proxy: !!initConfiguration.proxy,
    silent_multiple_init: initConfiguration.silentMultipleInit,
    track_session_across_subdomains: initConfiguration.trackSessionAcrossSubdomains,
    allow_fallback_to_local_storage: !!initConfiguration.allowFallbackToLocalStorage,
    store_contexts_across_pages: !!initConfiguration.storeContextsAcrossPages,
    allow_untrusted_events: !!initConfiguration.allowUntrustedEvents,
    tracking_consent: initConfiguration.trackingConsent
  };
}

/**
 * LIMITATION:
 * For NPM setup, this feature flag singleton is shared between RUM and Logs product.
 * This means that an experimental flag set on the RUM product will be set on the Logs product.
 * So keep in mind that in certain configurations, your experimental feature flag may affect other products.
 *
 * FORMAT:
 * All feature flags should be snake_cased
 */
// We want to use a real enum (i.e. not a const enum) here, to be able to check whether an arbitrary
// string is an expected feature flag
// eslint-disable-next-line no-restricted-syntax
var ExperimentalFeature;
(function (ExperimentalFeature) {
  ExperimentalFeature["WRITABLE_RESOURCE_GRAPHQL"] = "writable_resource_graphql";
  ExperimentalFeature["CUSTOM_VITALS"] = "custom_vitals";
  ExperimentalFeature["TOLERANT_RESOURCE_TIMINGS"] = "tolerant_resource_timings";
  ExperimentalFeature["REMOTE_CONFIGURATION"] = "remote_configuration";
  ExperimentalFeature["UPDATE_VIEW_NAME"] = "update_view_name";
  ExperimentalFeature["PLUGINS"] = "plugins";
})(ExperimentalFeature || (ExperimentalFeature = {}));
var enabledExperimentalFeatures = new Set();
function initFeatureFlags(enableExperimentalFeatures) {
  if (Array.isArray(enableExperimentalFeatures)) {
    addExperimentalFeatures(enableExperimentalFeatures.filter(function (flag) {
      return objectHasValue(ExperimentalFeature, flag);
    }));
  }
}
function addExperimentalFeatures(enabledFeatures) {
  enabledFeatures.forEach(function (flag) {
    enabledExperimentalFeatures.add(flag);
  });
}
function isExperimentalFeatureEnabled(featureName) {
  return enabledExperimentalFeatures.has(featureName);
}
function getExperimentalFeatures() {
  return enabledExperimentalFeatures;
}

/**
 * Cross-browser stack trace computation.
 *
 * Reference implementation: https://github.com/csnover/TraceKit/blob/04530298073c3823de72deb0b97e7b38ca7bcb59/tracekit.js
 */
var UNKNOWN_FUNCTION = '?';
function computeStackTrace(ex) {
  var stack = [];
  var stackProperty = tryToGetString(ex, 'stack');
  var exString = String(ex);
  if (stackProperty && startsWith$1(stackProperty, exString)) {
    stackProperty = stackProperty.slice(exString.length);
  }
  if (stackProperty) {
    stackProperty.split('\n').forEach(function (line) {
      var stackFrame = parseChromeLine(line) || parseChromeAnonymousLine(line) || parseWinLine(line) || parseGeckoLine(line);
      if (stackFrame) {
        if (!stackFrame.func && stackFrame.line) {
          stackFrame.func = UNKNOWN_FUNCTION;
        }
        stack.push(stackFrame);
      }
    });
  }
  return {
    message: tryToGetString(ex, 'message'),
    name: tryToGetString(ex, 'name'),
    stack: stack
  };
}
var fileUrl = '((?:file|https?|blob|chrome-extension|native|eval|webpack|snippet|<anonymous>|\\w+\\.|\\/).*?)';
var filePosition = '(?::(\\d+))';
var CHROME_LINE_RE = new RegExp("^\\s*at (.*?) ?\\(".concat(fileUrl).concat(filePosition, "?").concat(filePosition, "?\\)?\\s*$"), 'i');
var CHROME_EVAL_RE = new RegExp("\\((\\S*)".concat(filePosition).concat(filePosition, "\\)"));
function parseChromeLine(line) {
  var parts = CHROME_LINE_RE.exec(line);
  if (!parts) {
    return;
  }
  var isNative = parts[2] && parts[2].indexOf('native') === 0; // start of line
  var isEval = parts[2] && parts[2].indexOf('eval') === 0; // start of line
  var submatch = CHROME_EVAL_RE.exec(parts[2]);
  if (isEval && submatch) {
    // throw out eval line/column and use top-most line/column number
    parts[2] = submatch[1]; // url
    parts[3] = submatch[2]; // line
    parts[4] = submatch[3]; // column
  }
  return {
    args: isNative ? [parts[2]] : [],
    column: parts[4] ? +parts[4] : undefined,
    func: parts[1] || UNKNOWN_FUNCTION,
    line: parts[3] ? +parts[3] : undefined,
    url: !isNative ? parts[2] : undefined
  };
}
var CHROME_ANONYMOUS_FUNCTION_RE = new RegExp("^\\s*at ?".concat(fileUrl).concat(filePosition, "?").concat(filePosition, "??\\s*$"), 'i');
function parseChromeAnonymousLine(line) {
  var parts = CHROME_ANONYMOUS_FUNCTION_RE.exec(line);
  if (!parts) {
    return;
  }
  return {
    args: [],
    column: parts[3] ? +parts[3] : undefined,
    func: UNKNOWN_FUNCTION,
    line: parts[2] ? +parts[2] : undefined,
    url: parts[1]
  };
}
var WINJS_LINE_RE = /^\s*at (?:((?:\[object object\])?.+) )?\(?((?:file|ms-appx|https?|webpack|blob):.*?):(\d+)(?::(\d+))?\)?\s*$/i;
function parseWinLine(line) {
  var parts = WINJS_LINE_RE.exec(line);
  if (!parts) {
    return;
  }
  return {
    args: [],
    column: parts[4] ? +parts[4] : undefined,
    func: parts[1] || UNKNOWN_FUNCTION,
    line: +parts[3],
    url: parts[2]
  };
}
var GECKO_LINE_RE = /^\s*(.*?)(?:\((.*?)\))?(?:^|@)((?:file|https?|blob|chrome|webpack|resource|capacitor|\[native).*?|[^@]*bundle)(?::(\d+))?(?::(\d+))?\s*$/i;
var GECKO_EVAL_RE = /(\S+) line (\d+)(?: > eval line \d+)* > eval/i;
function parseGeckoLine(line) {
  var parts = GECKO_LINE_RE.exec(line);
  if (!parts) {
    return;
  }
  var isEval = parts[3] && parts[3].indexOf(' > eval') > -1;
  var submatch = GECKO_EVAL_RE.exec(parts[3]);
  if (isEval && submatch) {
    // throw out eval line/column and use top-most line number
    parts[3] = submatch[1];
    parts[4] = submatch[2];
    parts[5] = undefined; // no column when eval
  }
  return {
    args: parts[2] ? parts[2].split(',') : [],
    column: parts[5] ? +parts[5] : undefined,
    func: parts[1] || UNKNOWN_FUNCTION,
    line: parts[4] ? +parts[4] : undefined,
    url: parts[3]
  };
}
function tryToGetString(candidate, property) {
  if (typeof candidate !== 'object' || !candidate || !(property in candidate)) {
    return undefined;
  }
  var value = candidate[property];
  return typeof value === 'string' ? value : undefined;
}
function computeStackTraceFromOnErrorMessage(messageObj, url, line, column) {
  var stack = [{
    url: url,
    column: column,
    line: line
  }];
  var _a = tryToParseMessage(messageObj),
    name = _a.name,
    message = _a.message;
  return {
    name: name,
    message: message,
    stack: stack
  };
}
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Error#Error_types
var ERROR_TYPES_RE = /^(?:[Uu]ncaught (?:exception: )?)?(?:((?:Eval|Internal|Range|Reference|Syntax|Type|URI|)Error): )?([\s\S]*)$/;
function tryToParseMessage(messageObj) {
  var _a;
  var name;
  var message;
  if ({}.toString.call(messageObj) === '[object String]') {
    _a = ERROR_TYPES_RE.exec(messageObj), name = _a[1], message = _a[2];
  }
  return {
    name: name,
    message: message
  };
}

/**
 * Creates a stacktrace without SDK internal frames.
 * Constraints:
 * - Has to be called at the utmost position of the call stack.
 * - No monitored function should encapsulate it, that is why we need to use callMonitored inside it.
 */
function createHandlingStack() {
  /**
   * Skip the two internal frames:
   * - SDK API (console.error, ...)
   * - this function
   * in order to keep only the user calls
   */
  var internalFramesToSkip = 2;
  var error = new Error();
  var formattedStack;
  // IE needs to throw the error to fill in the stack trace
  if (!error.stack) {
    try {
      throw error;
    } catch (e) {
    }
  }
  callMonitored(function () {
    var stackTrace = computeStackTrace(error);
    stackTrace.stack = stackTrace.stack.slice(internalFramesToSkip);
    formattedStack = toStackTraceString(stackTrace);
  });
  return formattedStack;
}
function toStackTraceString(stack) {
  var result = formatErrorMessage(stack);
  stack.stack.forEach(function (frame) {
    var func = frame.func === '?' ? '<anonymous>' : frame.func;
    var args = frame.args && frame.args.length > 0 ? "(".concat(frame.args.join(', '), ")") : '';
    var line = frame.line ? ":".concat(frame.line) : '';
    var column = frame.line && frame.column ? ":".concat(frame.column) : '';
    result += "\n  at ".concat(func).concat(args, " @ ").concat(frame.url).concat(line).concat(column);
  });
  return result;
}
function formatErrorMessage(stack) {
  return "".concat(stack.name || 'Error', ": ").concat(stack.message);
}

/**
 * Instruments a method on a object, calling the given callback before the original method is
 * invoked. The callback receives an object with information about the method call.
 *
 * This function makes sure that we are "good citizens" regarding third party instrumentations: when
 * removing the instrumentation, the original method is usually restored, but if a third party
 * instrumentation was set after ours, we keep it in place and just replace our instrumentation with
 * a noop.
 *
 * Note: it is generally better to instrument methods that are "owned" by the object instead of ones
 * that are inherited from the prototype chain. Example:
 * * do:    `instrumentMethod(Array.prototype, 'push', ...)`
 * * don't: `instrumentMethod([], 'push', ...)`
 *
 * This method is also used to set event handler properties (ex: window.onerror = ...), as it has
 * the same requirements as instrumenting a method:
 * * if the event handler is already set by a third party, we need to call it and not just blindly
 * override it.
 * * if the event handler is set by a third party after us, we need to keep it in place when
 * removing ours.
 *
 * @example
 *
 *  instrumentMethod(window, 'fetch', ({ target, parameters, onPostCall }) => {
 *    console.log('Before calling fetch on', target, 'with parameters', parameters)
 *
 *    onPostCall((result) => {
 *      console.log('After fetch calling on', target, 'with parameters', parameters, 'and result', result)
 *    })
 *  })
 */
function instrumentMethod(targetPrototype, method, onPreCall, _a) {
  var _b = _a === void 0 ? {} : _a,
    computeHandlingStack = _b.computeHandlingStack;
  var original = targetPrototype[method];
  if (typeof original !== 'function') {
    if (startsWith$1(method, 'on')) {
      original = noop$1;
    } else {
      return {
        stop: noop$1
      };
    }
  }
  var stopped = false;
  var instrumentation = function () {
    if (stopped) {
      // eslint-disable-next-line @typescript-eslint/no-unsafe-return, @typescript-eslint/no-unsafe-call
      return original.apply(this, arguments);
    }
    var parameters = arrayFrom(arguments);
    var postCallCallback;
    callMonitored(onPreCall, null, [{
      target: this,
      parameters: parameters,
      onPostCall: function (callback) {
        postCallCallback = callback;
      },
      handlingStack: computeHandlingStack ? createHandlingStack() : undefined
    }]);
    // eslint-disable-next-line @typescript-eslint/no-unsafe-call
    var result = original.apply(this, parameters);
    if (postCallCallback) {
      callMonitored(postCallCallback, null, [result]);
    }
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    return result;
  };
  targetPrototype[method] = instrumentation;
  return {
    stop: function () {
      stopped = true;
      // If the instrumentation has been removed by a third party, keep the last one
      if (targetPrototype[method] === instrumentation) {
        targetPrototype[method] = original;
      }
    }
  };
}
function instrumentSetter(targetPrototype, property, after) {
  var originalDescriptor = Object.getOwnPropertyDescriptor(targetPrototype, property);
  if (!originalDescriptor || !originalDescriptor.set || !originalDescriptor.configurable) {
    return {
      stop: noop$1
    };
  }
  var stoppedInstrumentation = noop$1;
  var instrumentation = function (target, value) {
    // put hooked setter into event loop to avoid of set latency
    setTimeout$1(function () {
      if (instrumentation !== stoppedInstrumentation) {
        after(target, value);
      }
    }, 0);
  };
  var instrumentationWrapper = function (value) {
    originalDescriptor.set.call(this, value);
    instrumentation(this, value);
  };
  Object.defineProperty(targetPrototype, property, {
    set: instrumentationWrapper
  });
  return {
    stop: function () {
      var _a;
      if (((_a = Object.getOwnPropertyDescriptor(targetPrototype, property)) === null || _a === void 0 ? void 0 : _a.set) === instrumentationWrapper) {
        Object.defineProperty(targetPrototype, property, originalDescriptor);
      }
      instrumentation = stoppedInstrumentation;
    }
  };
}

// The maximum size of a single event is 256KiB. By default, we ensure that user-provided data
// going through sanitize fits inside our events, while leaving room for other contexts, metadata, ...
var SANITIZE_DEFAULT_MAX_CHARACTER_COUNT = 220 * ONE_KIBI_BYTE;
// Symbol for the root element of the JSONPath used for visited objects
var JSON_PATH_ROOT_ELEMENT = '$';
// When serializing (using JSON.stringify) a key of an object, { key: 42 } gets wrapped in quotes as "key".
// With the separator (:), we need to add 3 characters to the count.
var KEY_DECORATION_LENGTH = 3;
function sanitize(source, maxCharacterCount) {
  var _a;
  if (maxCharacterCount === void 0) {
    maxCharacterCount = SANITIZE_DEFAULT_MAX_CHARACTER_COUNT;
  }
  // Unbind any toJSON function we may have on [] or {} prototypes
  var restoreObjectPrototypeToJson = detachToJsonMethod(Object.prototype);
  var restoreArrayPrototypeToJson = detachToJsonMethod(Array.prototype);
  // Initial call to sanitizeProcessor - will populate containerQueue if source is an Array or a plain Object
  var containerQueue = [];
  var visitedObjectsWithPath = new WeakMap();
  var sanitizedData = sanitizeProcessor(source, JSON_PATH_ROOT_ELEMENT, undefined, containerQueue, visitedObjectsWithPath);
  var accumulatedCharacterCount = ((_a = JSON.stringify(sanitizedData)) === null || _a === void 0 ? void 0 : _a.length) || 0;
  if (accumulatedCharacterCount > maxCharacterCount) {
    warnOverCharacterLimit(maxCharacterCount, 'discarded', source);
    return undefined;
  }
  while (containerQueue.length > 0 && accumulatedCharacterCount < maxCharacterCount) {
    var containerToProcess = containerQueue.shift();
    var separatorLength = 0; // 0 for the first element, 1 for subsequent elements
    // Arrays and Objects have to be handled distinctly to ensure
    // we do not pick up non-numerical properties from Arrays
    if (Array.isArray(containerToProcess.source)) {
      for (var key = 0; key < containerToProcess.source.length; key++) {
        var targetData = sanitizeProcessor(containerToProcess.source[key], containerToProcess.path, key, containerQueue, visitedObjectsWithPath);
        if (targetData !== undefined) {
          accumulatedCharacterCount += JSON.stringify(targetData).length;
        } else {
          // When an element of an Array (targetData) is undefined, it is serialized as null:
          // JSON.stringify([undefined]) => '[null]' - This accounts for 4 characters
          accumulatedCharacterCount += 4;
        }
        accumulatedCharacterCount += separatorLength;
        separatorLength = 1;
        if (accumulatedCharacterCount > maxCharacterCount) {
          warnOverCharacterLimit(maxCharacterCount, 'truncated', source);
          break;
        }
        containerToProcess.target[key] = targetData;
      }
    } else {
      for (var key in containerToProcess.source) {
        if (Object.prototype.hasOwnProperty.call(containerToProcess.source, key)) {
          var targetData = sanitizeProcessor(containerToProcess.source[key], containerToProcess.path, key, containerQueue, visitedObjectsWithPath);
          // When a property of an object has an undefined value, it will be dropped during serialization:
          // JSON.stringify({a:undefined}) => '{}'
          if (targetData !== undefined) {
            accumulatedCharacterCount += JSON.stringify(targetData).length + separatorLength + key.length + KEY_DECORATION_LENGTH;
            separatorLength = 1;
          }
          if (accumulatedCharacterCount > maxCharacterCount) {
            warnOverCharacterLimit(maxCharacterCount, 'truncated', source);
            break;
          }
          containerToProcess.target[key] = targetData;
        }
      }
    }
  }
  // Rebind detached toJSON functions
  restoreObjectPrototypeToJson();
  restoreArrayPrototypeToJson();
  return sanitizedData;
}
/**
 * Internal function to factorize the process common to the
 * initial call to sanitize, and iterations for Arrays and Objects
 *
 */
function sanitizeProcessor(source, parentPath, key, queue, visitedObjectsWithPath) {
  // Start by handling toJSON, as we want to sanitize its output
  var sourceToSanitize = tryToApplyToJSON(source);
  if (!sourceToSanitize || typeof sourceToSanitize !== 'object') {
    return sanitizePrimitivesAndFunctions(sourceToSanitize);
  }
  var sanitizedSource = sanitizeObjects(sourceToSanitize);
  if (sanitizedSource !== '[Object]' && sanitizedSource !== '[Array]' && sanitizedSource !== '[Error]') {
    return sanitizedSource;
  }
  // Handle potential cyclic references
  // We need to use source as sourceToSanitize could be a reference to a new object
  // At this stage, we know the source is an object type
  var sourceAsObject = source;
  if (visitedObjectsWithPath.has(sourceAsObject)) {
    return "[Reference seen at ".concat(visitedObjectsWithPath.get(sourceAsObject), "]");
  }
  // Add processed source to queue
  var currentPath = key !== undefined ? "".concat(parentPath, ".").concat(key) : parentPath;
  var target = Array.isArray(sourceToSanitize) ? [] : {};
  visitedObjectsWithPath.set(sourceAsObject, currentPath);
  queue.push({
    source: sourceToSanitize,
    target: target,
    path: currentPath
  });
  return target;
}
/**
 * Handles sanitization of simple, non-object types
 *
 */
function sanitizePrimitivesAndFunctions(value) {
  // BigInt cannot be serialized by JSON.stringify(), convert it to a string representation
  if (typeof value === 'bigint') {
    return "[BigInt] ".concat(value.toString());
  }
  // Functions cannot be serialized by JSON.stringify(). Moreover, if a faulty toJSON is present, it needs to be converted
  // so it won't prevent stringify from serializing later
  if (typeof value === 'function') {
    return "[Function] ".concat(value.name || 'unknown');
  }
  // JSON.stringify() does not serialize symbols.
  if (typeof value === 'symbol') {
    return "[Symbol] ".concat(value.description || value.toString());
  }
  return value;
}
/**
 * Handles sanitization of object types
 *
 * LIMITATIONS
 * - If a class defines a toStringTag Symbol, it will fall in the catch-all method and prevent enumeration of properties.
 * To avoid this, a toJSON method can be defined.
 * - IE11 does not return a distinct type for objects such as Map, WeakMap, ... These objects will pass through and their
 * properties enumerated if any.
 *
 */
function sanitizeObjects(value) {
  try {
    // Handle events - Keep a simple implementation to avoid breaking changes
    if (value instanceof Event) {
      return {
        isTrusted: value.isTrusted
      };
    }
    // Handle all remaining object types in a generic way
    var result = Object.prototype.toString.call(value);
    var match = result.match(/\[object (.*)\]/);
    if (match && match[1]) {
      return "[".concat(match[1], "]");
    }
  } catch (_a) {
    // If the previous serialization attempts failed, and we cannot convert using
    // Object.prototype.toString, declare the value unserializable
  }
  return '[Unserializable]';
}
/**
 * Checks if a toJSON function exists and tries to execute it
 *
 */
function tryToApplyToJSON(value) {
  var object = value;
  if (object && typeof object.toJSON === 'function') {
    try {
      return object.toJSON();
    } catch (_a) {
      // If toJSON fails, we continue by trying to serialize the value manually
    }
  }
  return value;
}
/**
 * Helper function to display the warning when the accumulated character count is over the limit
 */
function warnOverCharacterLimit(maxCharacterCount, changeType, source) {
  display.warn("The data provided has been ".concat(changeType, " as it is over the limit of ").concat(maxCharacterCount, " characters:"), source);
}

var NO_ERROR_STACK_PRESENT_MESSAGE = 'No stack, consider using an instance of Error';
function computeRawError(_a) {
  var stackTrace = _a.stackTrace,
    originalError = _a.originalError,
    handlingStack = _a.handlingStack,
    startClocks = _a.startClocks,
    nonErrorPrefix = _a.nonErrorPrefix,
    source = _a.source,
    handling = _a.handling;
  var isErrorInstance = originalError instanceof Error;
  var message = computeMessage(stackTrace, isErrorInstance, nonErrorPrefix, originalError);
  var stack = hasUsableStack(isErrorInstance, stackTrace) ? toStackTraceString(stackTrace) : NO_ERROR_STACK_PRESENT_MESSAGE;
  var causes = isErrorInstance ? flattenErrorCauses(originalError, source) : undefined;
  var type = stackTrace === null || stackTrace === void 0 ? void 0 : stackTrace.name;
  var fingerprint = tryToGetFingerprint(originalError);
  return {
    startClocks: startClocks,
    source: source,
    handling: handling,
    handlingStack: handlingStack,
    originalError: originalError,
    type: type,
    message: message,
    stack: stack,
    causes: causes,
    fingerprint: fingerprint
  };
}
function computeMessage(stackTrace, isErrorInstance, nonErrorPrefix, originalError) {
  // Favor stackTrace message only if tracekit has really been able to extract something meaningful (message + name)
  // TODO rework tracekit integration to avoid scattering error building logic
  return (stackTrace === null || stackTrace === void 0 ? void 0 : stackTrace.message) && (stackTrace === null || stackTrace === void 0 ? void 0 : stackTrace.name) ? stackTrace.message : !isErrorInstance ? "".concat(nonErrorPrefix, " ").concat(jsonStringify(sanitize(originalError))) : 'Empty message';
}
function hasUsableStack(isErrorInstance, stackTrace) {
  if (stackTrace === undefined) {
    return false;
  }
  if (isErrorInstance) {
    return true;
  }
  // handle cases where tracekit return stack = [] or stack = [{url: undefined, line: undefined, column: undefined}]
  // TODO rework tracekit integration to avoid generating those unusable stack
  return stackTrace.stack.length > 0 && (stackTrace.stack.length > 1 || stackTrace.stack[0].url !== undefined);
}
function tryToGetFingerprint(originalError) {
  return originalError instanceof Error && 'dd_fingerprint' in originalError ? String(originalError.dd_fingerprint) : undefined;
}
function flattenErrorCauses(error, parentSource) {
  var currentError = error;
  var causes = [];
  while ((currentError === null || currentError === void 0 ? void 0 : currentError.cause) instanceof Error && causes.length < 10) {
    var stackTrace = computeStackTrace(currentError.cause);
    causes.push({
      message: currentError.cause.message,
      source: parentSource,
      type: stackTrace === null || stackTrace === void 0 ? void 0 : stackTrace.name,
      stack: stackTrace && toStackTraceString(stackTrace)
    });
    currentError = currentError.cause;
  }
  return causes.length ? causes : undefined;
}

var ErrorSource = {
  AGENT: 'agent',
  CONSOLE: 'console',
  CUSTOM: 'custom',
  LOGGER: 'logger',
  NETWORK: 'network',
  SOURCE: 'source',
  REPORT: 'report'
};

function trackRuntimeError(errorObservable) {
  var handleRuntimeError = function (stackTrace, originalError) {
    var rawError = computeRawError({
      stackTrace: stackTrace,
      originalError: originalError,
      startClocks: clocksNow(),
      nonErrorPrefix: "Uncaught" /* NonErrorPrefix.UNCAUGHT */,
      source: ErrorSource.SOURCE,
      handling: "unhandled" /* ErrorHandling.UNHANDLED */
    });
    errorObservable.notify(rawError);
  };
  var stopInstrumentingOnError = instrumentOnError(handleRuntimeError).stop;
  var stopInstrumentingOnUnhandledRejection = instrumentUnhandledRejection(handleRuntimeError).stop;
  return {
    stop: function () {
      stopInstrumentingOnError();
      stopInstrumentingOnUnhandledRejection();
    }
  };
}
function instrumentOnError(callback) {
  return instrumentMethod(window, 'onerror', function (_a) {
    var _b = _a.parameters,
      messageObj = _b[0],
      url = _b[1],
      line = _b[2],
      column = _b[3],
      errorObj = _b[4];
    var stackTrace;
    if (errorObj instanceof Error) {
      stackTrace = computeStackTrace(errorObj);
    } else {
      stackTrace = computeStackTraceFromOnErrorMessage(messageObj, url, line, column);
    }
    callback(stackTrace, errorObj !== null && errorObj !== void 0 ? errorObj : messageObj);
  });
}
function instrumentUnhandledRejection(callback) {
  return instrumentMethod(window, 'onunhandledrejection', function (_a) {
    var e = _a.parameters[0];
    var reason = e.reason || 'Empty reason';
    var stack = computeStackTrace(reason);
    callback(stack, reason);
  });
}

function makePublicApi(stub) {
  var publicApi = assign({
    version: "5.23.0",
    // This API method is intentionally not monitored, since the only thing executed is the
    // user-provided 'callback'.  All SDK usages executed in the callback should be monitored, and
    // we don't want to interfere with the user uncaught exceptions.
    onReady: function (callback) {
      callback();
    }
  }, stub);
  // Add a "hidden" property to set debug mode. We define it that way to hide it
  // as much as possible but of course it's not a real protection.
  Object.defineProperty(publicApi, '_setDebug', {
    get: function () {
      return setDebugMode;
    },
    enumerable: false
  });
  return publicApi;
}
function defineGlobal(global, name, api) {
  var existingGlobalVariable = global[name];
  if (existingGlobalVariable && !existingGlobalVariable.q && existingGlobalVariable.version) {
    display.warn('SDK is loaded more than once. This is unsupported and might have unexpected behavior.');
  }
  global[name] = api;
  if (existingGlobalVariable && existingGlobalVariable.q) {
    existingGlobalVariable.q.forEach(function (fn) {
      return catchUserErrors(fn, 'onReady callback threw an error:')();
    });
  }
}

function displayAlreadyInitializedError(sdkName, initConfiguration) {
  if (!initConfiguration.silentMultipleInit) {
    display.error("".concat(sdkName, " is already initialized."));
  }
}

// We want to use a real enum (i.e. not a const enum) here, to be able to iterate over it to automatically add _ddIsTrusted in e2e tests
// eslint-disable-next-line no-restricted-syntax
var DOM_EVENT;
(function (DOM_EVENT) {
  DOM_EVENT["BEFORE_UNLOAD"] = "beforeunload";
  DOM_EVENT["CLICK"] = "click";
  DOM_EVENT["DBL_CLICK"] = "dblclick";
  DOM_EVENT["KEY_DOWN"] = "keydown";
  DOM_EVENT["LOAD"] = "load";
  DOM_EVENT["POP_STATE"] = "popstate";
  DOM_EVENT["SCROLL"] = "scroll";
  DOM_EVENT["TOUCH_START"] = "touchstart";
  DOM_EVENT["TOUCH_END"] = "touchend";
  DOM_EVENT["TOUCH_MOVE"] = "touchmove";
  DOM_EVENT["VISIBILITY_CHANGE"] = "visibilitychange";
  DOM_EVENT["PAGE_SHOW"] = "pageshow";
  DOM_EVENT["FREEZE"] = "freeze";
  DOM_EVENT["RESUME"] = "resume";
  DOM_EVENT["DOM_CONTENT_LOADED"] = "DOMContentLoaded";
  DOM_EVENT["POINTER_DOWN"] = "pointerdown";
  DOM_EVENT["POINTER_UP"] = "pointerup";
  DOM_EVENT["POINTER_CANCEL"] = "pointercancel";
  DOM_EVENT["HASH_CHANGE"] = "hashchange";
  DOM_EVENT["PAGE_HIDE"] = "pagehide";
  DOM_EVENT["MOUSE_DOWN"] = "mousedown";
  DOM_EVENT["MOUSE_UP"] = "mouseup";
  DOM_EVENT["MOUSE_MOVE"] = "mousemove";
  DOM_EVENT["FOCUS"] = "focus";
  DOM_EVENT["BLUR"] = "blur";
  DOM_EVENT["CONTEXT_MENU"] = "contextmenu";
  DOM_EVENT["RESIZE"] = "resize";
  DOM_EVENT["CHANGE"] = "change";
  DOM_EVENT["INPUT"] = "input";
  DOM_EVENT["PLAY"] = "play";
  DOM_EVENT["PAUSE"] = "pause";
  DOM_EVENT["SECURITY_POLICY_VIOLATION"] = "securitypolicyviolation";
  DOM_EVENT["SELECTION_CHANGE"] = "selectionchange";
  DOM_EVENT["STORAGE"] = "storage";
})(DOM_EVENT || (DOM_EVENT = {}));
/**
 * Add an event listener to an event target object (Window, Element, mock object...).  This provides
 * a few conveniences compared to using `element.addEventListener` directly:
 *
 * * supports IE11 by: using an option object only if needed and emulating the `once` option
 *
 * * wraps the listener with a `monitor` function
 *
 * * returns a `stop` function to remove the listener
 */
function addEventListener(configuration, eventTarget, eventName, listener, options) {
  return addEventListeners(configuration, eventTarget, [eventName], listener, options);
}
/**
 * Add event listeners to an event target object (Window, Element, mock object...).  This provides
 * a few conveniences compared to using `element.addEventListener` directly:
 *
 * * supports IE11 by: using an option object only if needed and emulating the `once` option
 *
 * * wraps the listener with a `monitor` function
 *
 * * returns a `stop` function to remove the listener
 *
 * * with `once: true`, the listener will be called at most once, even if different events are listened
 */
function addEventListeners(configuration, eventTarget, eventNames, listener, _a) {
  var _b = _a === void 0 ? {} : _a,
    once = _b.once,
    capture = _b.capture,
    passive = _b.passive;
  var listenerWithMonitor = monitor(function (event) {
    if (!event.isTrusted && !event.__ddIsTrusted && !configuration.allowUntrustedEvents) {
      return;
    }
    if (once) {
      stop();
    }
    listener(event);
  });
  var options = passive ? {
    capture: capture,
    passive: passive
  } : capture;
  var add = getZoneJsOriginalValue(eventTarget, 'addEventListener');
  eventNames.forEach(function (eventName) {
    return add.call(eventTarget, eventName, listenerWithMonitor, options);
  });
  function stop() {
    var remove = getZoneJsOriginalValue(eventTarget, 'removeEventListener');
    eventNames.forEach(function (eventName) {
      return remove.call(eventTarget, eventName, listenerWithMonitor, options);
    });
  }
  return {
    stop: stop
  };
}

var RawReportType = {
  intervention: 'intervention',
  deprecation: 'deprecation',
  cspViolation: 'csp_violation'
};
function initReportObservable(configuration, apis) {
  var observables = [];
  if (includes(apis, RawReportType.cspViolation)) {
    observables.push(createCspViolationReportObservable(configuration));
  }
  var reportTypes = apis.filter(function (api) {
    return api !== RawReportType.cspViolation;
  });
  if (reportTypes.length) {
    observables.push(createReportObservable(reportTypes));
  }
  return mergeObservables.apply(void 0, observables);
}
function createReportObservable(reportTypes) {
  return new Observable(function (observable) {
    if (!window.ReportingObserver) {
      return;
    }
    var handleReports = monitor(function (reports, _) {
      return reports.forEach(function (report) {
        observable.notify(buildRawReportFromReport(report));
      });
    });
    var observer = new window.ReportingObserver(handleReports, {
      types: reportTypes,
      buffered: true
    });
    observer.observe();
    return function () {
      observer.disconnect();
    };
  });
}
function createCspViolationReportObservable(configuration) {
  return new Observable(function (observable) {
    var stop = addEventListener(configuration, document, DOM_EVENT.SECURITY_POLICY_VIOLATION, function (event) {
      observable.notify(buildRawReportFromCspViolation(event));
    }).stop;
    return stop;
  });
}
function buildRawReportFromReport(report) {
  var type = report.type,
    body = report.body;
  return {
    type: type,
    subtype: body.id,
    message: "".concat(type, ": ").concat(body.message),
    originalReport: report,
    stack: buildStack(body.id, body.message, body.sourceFile, body.lineNumber, body.columnNumber)
  };
}
function buildRawReportFromCspViolation(event) {
  var type = RawReportType.cspViolation;
  var message = "'".concat(event.blockedURI, "' blocked by '").concat(event.effectiveDirective, "' directive");
  return {
    type: RawReportType.cspViolation,
    subtype: event.effectiveDirective,
    message: "".concat(type, ": ").concat(message),
    stack: buildStack(event.effectiveDirective, event.originalPolicy ? "".concat(message, " of the policy \"").concat(safeTruncate(event.originalPolicy, 100, '...'), "\"") : 'no policy', event.sourceFile, event.lineNumber, event.columnNumber),
    originalReport: event
  };
}
function buildStack(name, message, sourceFile, lineNumber, columnNumber) {
  return sourceFile ? toStackTraceString({
    name: name,
    message: message,
    stack: [{
      func: '?',
      url: sourceFile,
      line: lineNumber !== null && lineNumber !== void 0 ? lineNumber : undefined,
      column: columnNumber !== null && columnNumber !== void 0 ? columnNumber : undefined
    }]
  }) : undefined;
}

function sendToExtension(type, payload) {
  var callback = window.__ddBrowserSdkExtensionCallback;
  if (callback) {
    callback({
      type: type,
      payload: payload
    });
  }
}

/**
 * Similar to `typeof`, but distinguish plain objects from `null` and arrays
 */
function getType(value) {
  if (value === null) {
    return 'null';
  }
  if (Array.isArray(value)) {
    return 'array';
  }
  return typeof value;
}

/**
 * Iterate over source and affect its sub values into destination, recursively.
 * If the source and destination can't be merged, return source.
 */
function mergeInto(destination, source, circularReferenceChecker) {
  if (circularReferenceChecker === void 0) {
    circularReferenceChecker = createCircularReferenceChecker();
  }
  // ignore the source if it is undefined
  if (source === undefined) {
    return destination;
  }
  if (typeof source !== 'object' || source === null) {
    // primitive values - just return source
    return source;
  } else if (source instanceof Date) {
    return new Date(source.getTime());
  } else if (source instanceof RegExp) {
    var flags = source.flags ||
    // old browsers compatibility
    [source.global ? 'g' : '', source.ignoreCase ? 'i' : '', source.multiline ? 'm' : '', source.sticky ? 'y' : '', source.unicode ? 'u' : ''].join('');
    return new RegExp(source.source, flags);
  }
  if (circularReferenceChecker.hasAlreadyBeenSeen(source)) {
    // remove circular references
    return undefined;
  } else if (Array.isArray(source)) {
    var merged_1 = Array.isArray(destination) ? destination : [];
    for (var i = 0; i < source.length; ++i) {
      merged_1[i] = mergeInto(merged_1[i], source[i], circularReferenceChecker);
    }
    return merged_1;
  }
  var merged = getType(destination) === 'object' ? destination : {};
  for (var key in source) {
    if (Object.prototype.hasOwnProperty.call(source, key)) {
      merged[key] = mergeInto(merged[key], source[key], circularReferenceChecker);
    }
  }
  return merged;
}
/**
 * A simplistic implementation of a deep clone algorithm.
 * Caveats:
 * - It doesn't maintain prototype chains - don't use with instances of custom classes.
 * - It doesn't handle Map and Set
 */
function deepClone(value) {
  return mergeInto(undefined, value);
}
function combine() {
  var sources = [];
  for (var _i = 0; _i < arguments.length; _i++) {
    sources[_i] = arguments[_i];
  }
  var destination;
  for (var _a = 0, sources_1 = sources; _a < sources_1.length; _a++) {
    var source = sources_1[_a];
    // Ignore any undefined or null sources.
    if (source === undefined || source === null) {
      continue;
    }
    destination = mergeInto(destination, source);
  }
  return destination;
}
function createCircularReferenceChecker() {
  if (typeof WeakSet !== 'undefined') {
    var set_1 = new WeakSet();
    return {
      hasAlreadyBeenSeen: function (value) {
        var has = set_1.has(value);
        if (!has) {
          set_1.add(value);
        }
        return has;
      }
    };
  }
  var array = [];
  return {
    hasAlreadyBeenSeen: function (value) {
      var has = array.indexOf(value) >= 0;
      if (!has) {
        array.push(value);
      }
      return has;
    }
  };
}

function getConnectivity() {
  var _a;
  var navigator = window.navigator;
  return {
    status: navigator.onLine ? 'connected' : 'not_connected',
    interfaces: navigator.connection && navigator.connection.type ? [navigator.connection.type] : undefined,
    effective_type: (_a = navigator.connection) === null || _a === void 0 ? void 0 : _a.effectiveType
  };
}

function removeItem(array, item) {
  var index = array.indexOf(item);
  if (index >= 0) {
    array.splice(index, 1);
  }
}

var BUFFER_LIMIT = 500;
var BoundedBuffer = /** @class */function () {
  function BoundedBuffer() {
    this.buffer = [];
  }
  BoundedBuffer.prototype.add = function (callback) {
    var length = this.buffer.push(callback);
    if (length > BUFFER_LIMIT) {
      this.buffer.splice(0, 1);
    }
  };
  BoundedBuffer.prototype.remove = function (callback) {
    removeItem(this.buffer, callback);
  };
  BoundedBuffer.prototype.drain = function (arg) {
    this.buffer.forEach(function (callback) {
      return callback(arg);
    });
    this.buffer.length = 0;
  };
  return BoundedBuffer;
}();

var TelemetryType = {
  log: 'log',
  configuration: 'configuration',
  usage: 'usage'
};

var ALLOWED_FRAME_URLS = ['https://www.datadoghq-browser-agent.com', 'https://www.datad0g-browser-agent.com', 'https://d3uc069fcn7uxw.cloudfront.net', 'https://d20xtzwzcl0ceb.cloudfront.net', 'http://localhost', '<anonymous>'];
var TELEMETRY_EXCLUDED_SITES = [INTAKE_SITE_US1_FED];
// eslint-disable-next-line local-rules/disallow-side-effects
var preStartTelemetryBuffer = new BoundedBuffer();
var onRawTelemetryEventCollected = function (event) {
  preStartTelemetryBuffer.add(function () {
    return onRawTelemetryEventCollected(event);
  });
};
function startTelemetry(telemetryService, configuration) {
  var _a;
  var contextProvider;
  var observable = new Observable();
  var alreadySentEvents = new Set();
  var telemetryEnabled = !includes(TELEMETRY_EXCLUDED_SITES, configuration.site) && performDraw(configuration.telemetrySampleRate);
  var telemetryEnabledPerType = (_a = {}, _a[TelemetryType.log] = telemetryEnabled, _a[TelemetryType.configuration] = telemetryEnabled && performDraw(configuration.telemetryConfigurationSampleRate), _a[TelemetryType.usage] = telemetryEnabled && performDraw(configuration.telemetryUsageSampleRate), _a);
  var runtimeEnvInfo = getRuntimeEnvInfo();
  onRawTelemetryEventCollected = function (rawEvent) {
    var stringifiedEvent = jsonStringify(rawEvent);
    if (telemetryEnabledPerType[rawEvent.type] && alreadySentEvents.size < configuration.maxTelemetryEventsPerPage && !alreadySentEvents.has(stringifiedEvent)) {
      var event_1 = toTelemetryEvent(telemetryService, rawEvent, runtimeEnvInfo);
      observable.notify(event_1);
      sendToExtension('telemetry', event_1);
      alreadySentEvents.add(stringifiedEvent);
    }
  };
  startMonitorErrorCollection(addTelemetryError);
  function toTelemetryEvent(telemetryService, event, runtimeEnvInfo) {
    return combine({
      type: 'telemetry',
      date: timeStampNow(),
      service: telemetryService,
      version: "5.23.0",
      source: 'browser',
      _dd: {
        format_version: 2
      },
      telemetry: combine(event, {
        runtime_env: runtimeEnvInfo,
        connectivity: getConnectivity()
      }),
      experimental_features: arrayFrom(getExperimentalFeatures())
    }, contextProvider !== undefined ? contextProvider() : {});
  }
  return {
    setContextProvider: function (provider) {
      contextProvider = provider;
    },
    observable: observable,
    enabled: telemetryEnabled
  };
}
function getRuntimeEnvInfo() {
  return {
    is_local_file: window.location.protocol === 'file:',
    is_worker: 'WorkerGlobalScope' in self
  };
}
// need to be called after telemetry context is provided and observers are registered
function drainPreStartTelemetry() {
  preStartTelemetryBuffer.drain();
}
/**
 * Avoid mixing telemetry events from different data centers
 * but keep replicating staging events for reliability
 */
function isTelemetryReplicationAllowed(configuration) {
  return configuration.site === INTAKE_SITE_STAGING;
}
function addTelemetryDebug(message, context) {
  displayIfDebugEnabled(ConsoleApiName.debug, message, context);
  onRawTelemetryEventCollected(assign({
    type: TelemetryType.log,
    message: message,
    status: "debug" /* StatusType.debug */
  }, context));
}
function addTelemetryError(e, context) {
  onRawTelemetryEventCollected(assign({
    type: TelemetryType.log,
    status: "error" /* StatusType.error */
  }, formatError(e), context));
}
function addTelemetryConfiguration(configuration) {
  onRawTelemetryEventCollected({
    type: TelemetryType.configuration,
    configuration: configuration
  });
}
function addTelemetryUsage(usage) {
  onRawTelemetryEventCollected({
    type: TelemetryType.usage,
    usage: usage
  });
}
function formatError(e) {
  if (e instanceof Error) {
    var stackTrace = computeStackTrace(e);
    return {
      error: {
        kind: stackTrace.name,
        stack: toStackTraceString(scrubCustomerFrames(stackTrace))
      },
      message: stackTrace.message
    };
  }
  return {
    error: {
      stack: NO_ERROR_STACK_PRESENT_MESSAGE
    },
    message: "".concat("Uncaught" /* NonErrorPrefix.UNCAUGHT */, " ").concat(jsonStringify(e))
  };
}
function scrubCustomerFrames(stackTrace) {
  stackTrace.stack = stackTrace.stack.filter(function (frame) {
    return !frame.url || ALLOWED_FRAME_URLS.some(function (allowedFrameUrl) {
      return startsWith$1(frame.url, allowedFrameUrl);
    });
  });
  return stackTrace;
}

var END_OF_TIMES = Infinity;
var CLEAR_OLD_VALUES_INTERVAL = ONE_MINUTE;
/**
 * Store and keep track of values spans. This whole class assumes that values are added in
 * chronological order (i.e. all entries have an increasing start time).
 */
var ValueHistory = /** @class */function () {
  function ValueHistory(expireDelay, maxEntries) {
    var _this = this;
    this.expireDelay = expireDelay;
    this.maxEntries = maxEntries;
    this.entries = [];
    this.clearOldValuesInterval = setInterval$1(function () {
      return _this.clearOldValues();
    }, CLEAR_OLD_VALUES_INTERVAL);
  }
  /**
   * Add a value to the history associated with a start time. Returns a reference to this newly
   * added entry that can be removed or closed.
   */
  ValueHistory.prototype.add = function (value, startTime) {
    var _this = this;
    var entry = {
      value: value,
      startTime: startTime,
      endTime: END_OF_TIMES,
      remove: function () {
        removeItem(_this.entries, entry);
      },
      close: function (endTime) {
        entry.endTime = endTime;
      }
    };
    if (this.maxEntries && this.entries.length >= this.maxEntries) {
      this.entries.pop();
    }
    this.entries.unshift(entry);
    return entry;
  };
  /**
   * Return the latest value that was active during `startTime`, or the currently active value
   * if no `startTime` is provided. This method assumes that entries are not overlapping.
   *
   * If `option.returnInactive` is true, returns the value at `startTime` (active or not).
   */
  ValueHistory.prototype.find = function (startTime, options) {
    if (startTime === void 0) {
      startTime = END_OF_TIMES;
    }
    if (options === void 0) {
      options = {
        returnInactive: false
      };
    }
    for (var _i = 0, _a = this.entries; _i < _a.length; _i++) {
      var entry = _a[_i];
      if (entry.startTime <= startTime) {
        if (options.returnInactive || startTime <= entry.endTime) {
          return entry.value;
        }
        break;
      }
    }
  };
  /**
   * Helper function to close the currently active value, if any. This method assumes that entries
   * are not overlapping.
   */
  ValueHistory.prototype.closeActive = function (endTime) {
    var latestEntry = this.entries[0];
    if (latestEntry && latestEntry.endTime === END_OF_TIMES) {
      latestEntry.close(endTime);
    }
  };
  /**
   * Return all values with an active period overlapping with the duration,
   * or all values that were active during `startTime` if no duration is provided,
   * or all currently active values if no `startTime` is provided.
   */
  ValueHistory.prototype.findAll = function (startTime, duration) {
    if (startTime === void 0) {
      startTime = END_OF_TIMES;
    }
    if (duration === void 0) {
      duration = 0;
    }
    var endTime = addDuration(startTime, duration);
    return this.entries.filter(function (entry) {
      return entry.startTime <= endTime && startTime <= entry.endTime;
    }).map(function (entry) {
      return entry.value;
    });
  };
  /**
   * Remove all entries from this collection.
   */
  ValueHistory.prototype.reset = function () {
    this.entries = [];
  };
  /**
   * Stop internal garbage collection of past entries.
   */
  ValueHistory.prototype.stop = function () {
    clearInterval$1(this.clearOldValuesInterval);
  };
  ValueHistory.prototype.clearOldValues = function () {
    var oldTimeThreshold = relativeNow() - this.expireDelay;
    while (this.entries.length > 0 && this.entries[this.entries.length - 1].endTime < oldTimeThreshold) {
      this.entries.pop();
    }
  };
  return ValueHistory;
}();

var VISIBILITY_CHECK_DELAY = ONE_MINUTE;
var SESSION_CONTEXT_TIMEOUT_DELAY = SESSION_TIME_OUT_DELAY;
function startSessionManager(configuration, productKey, computeSessionState, trackingConsentState) {
  var renewObservable = new Observable();
  var expireObservable = new Observable();
  // TODO - Improve configuration type and remove assertion
  var sessionStore = startSessionStore(configuration.sessionStoreStrategyType, productKey, computeSessionState);
  var sessionContextHistory = new ValueHistory(SESSION_CONTEXT_TIMEOUT_DELAY);
  sessionStore.renewObservable.subscribe(function () {
    sessionContextHistory.add(buildSessionContext(), relativeNow());
    renewObservable.notify();
  });
  sessionStore.expireObservable.subscribe(function () {
    expireObservable.notify();
    sessionContextHistory.closeActive(relativeNow());
  });
  // We expand/renew session unconditionally as tracking consent is always granted when the session
  // manager is started.
  sessionStore.expandOrRenewSession();
  sessionContextHistory.add(buildSessionContext(), clocksOrigin().relative);
  trackingConsentState.observable.subscribe(function () {
    if (trackingConsentState.isGranted()) {
      sessionStore.expandOrRenewSession();
    } else {
      sessionStore.expire();
    }
  });
  trackActivity(configuration, function () {
    if (trackingConsentState.isGranted()) {
      sessionStore.expandOrRenewSession();
    }
  });
  trackVisibility(configuration, function () {
    return sessionStore.expandSession();
  });
  trackResume(configuration, function () {
    return sessionStore.restartSession();
  });
  function buildSessionContext() {
    return {
      id: sessionStore.getSession().id,
      trackingType: sessionStore.getSession()[productKey],
      isReplayForced: !!sessionStore.getSession().forcedReplay
    };
  }
  return {
    findSession: function (startTime, options) {
      return sessionContextHistory.find(startTime, options);
    },
    renewObservable: renewObservable,
    expireObservable: expireObservable,
    sessionStateUpdateObservable: sessionStore.sessionStateUpdateObservable,
    expire: sessionStore.expire,
    updateSessionState: sessionStore.updateSessionState
  };
}
function trackActivity(configuration, expandOrRenewSession) {
  addEventListeners(configuration, window, [DOM_EVENT.CLICK, DOM_EVENT.TOUCH_START, DOM_EVENT.KEY_DOWN, DOM_EVENT.SCROLL], expandOrRenewSession, {
    capture: true,
    passive: true
  }).stop;
}
function trackVisibility(configuration, expandSession) {
  var expandSessionWhenVisible = function () {
    if (document.visibilityState === 'visible') {
      expandSession();
    }
  };
  addEventListener(configuration, document, DOM_EVENT.VISIBILITY_CHANGE, expandSessionWhenVisible).stop;
  setInterval$1(expandSessionWhenVisible, VISIBILITY_CHECK_DELAY);
}
function trackResume(configuration, cb) {
  addEventListener(configuration, window, DOM_EVENT.RESUME, cb, {
    capture: true
  }).stop;
}

function isServerError(status) {
  return status >= 500;
}
function tryToClone(response) {
  try {
    return response.clone();
  } catch (e) {
    // clone can throw if the response has already been used by another instrumentation or is disturbed
    return;
  }
}

var MAX_ONGOING_BYTES_COUNT = 80 * ONE_KIBI_BYTE;
var MAX_ONGOING_REQUESTS = 32;
var MAX_QUEUE_BYTES_COUNT = 3 * ONE_MEBI_BYTE;
var MAX_BACKOFF_TIME = ONE_MINUTE;
var INITIAL_BACKOFF_TIME = ONE_SECOND;
function sendWithRetryStrategy(payload, state, sendStrategy, trackType, reportError) {
  if (state.transportStatus === 0 /* TransportStatus.UP */ && state.queuedPayloads.size() === 0 && state.bandwidthMonitor.canHandle(payload)) {
    send(payload, state, sendStrategy, {
      onSuccess: function () {
        return retryQueuedPayloads(0 /* RetryReason.AFTER_SUCCESS */, state, sendStrategy, trackType, reportError);
      },
      onFailure: function () {
        state.queuedPayloads.enqueue(payload);
        scheduleRetry(state, sendStrategy, trackType, reportError);
      }
    });
  } else {
    state.queuedPayloads.enqueue(payload);
  }
}
function scheduleRetry(state, sendStrategy, trackType, reportError) {
  if (state.transportStatus !== 2 /* TransportStatus.DOWN */) {
    return;
  }
  setTimeout$1(function () {
    var payload = state.queuedPayloads.first();
    send(payload, state, sendStrategy, {
      onSuccess: function () {
        state.queuedPayloads.dequeue();
        state.currentBackoffTime = INITIAL_BACKOFF_TIME;
        retryQueuedPayloads(1 /* RetryReason.AFTER_RESUME */, state, sendStrategy, trackType, reportError);
      },
      onFailure: function () {
        state.currentBackoffTime = Math.min(MAX_BACKOFF_TIME, state.currentBackoffTime * 2);
        scheduleRetry(state, sendStrategy, trackType, reportError);
      }
    });
  }, state.currentBackoffTime);
}
function send(payload, state, sendStrategy, _a) {
  var onSuccess = _a.onSuccess,
    onFailure = _a.onFailure;
  state.bandwidthMonitor.add(payload);
  sendStrategy(payload, function (response) {
    state.bandwidthMonitor.remove(payload);
    if (!shouldRetryRequest(response)) {
      state.transportStatus = 0 /* TransportStatus.UP */;
      onSuccess();
    } else {
      // do not consider transport down if another ongoing request could succeed
      state.transportStatus = state.bandwidthMonitor.ongoingRequestCount > 0 ? 1 /* TransportStatus.FAILURE_DETECTED */ : 2 /* TransportStatus.DOWN */;
      payload.retry = {
        count: payload.retry ? payload.retry.count + 1 : 1,
        lastFailureStatus: response.status
      };
      onFailure();
    }
  });
}
function retryQueuedPayloads(reason, state, sendStrategy, trackType, reportError) {
  if (reason === 0 /* RetryReason.AFTER_SUCCESS */ && state.queuedPayloads.isFull() && !state.queueFullReported) {
    reportError({
      message: "Reached max ".concat(trackType, " events size queued for upload: ").concat(MAX_QUEUE_BYTES_COUNT / ONE_MEBI_BYTE, "MiB"),
      source: ErrorSource.AGENT,
      startClocks: clocksNow()
    });
    state.queueFullReported = true;
  }
  var previousQueue = state.queuedPayloads;
  state.queuedPayloads = newPayloadQueue();
  while (previousQueue.size() > 0) {
    sendWithRetryStrategy(previousQueue.dequeue(), state, sendStrategy, trackType, reportError);
  }
}
function shouldRetryRequest(response) {
  return response.type !== 'opaque' && (response.status === 0 && !navigator.onLine || response.status === 408 || response.status === 429 || isServerError(response.status));
}
function newRetryState() {
  return {
    transportStatus: 0 /* TransportStatus.UP */,
    currentBackoffTime: INITIAL_BACKOFF_TIME,
    bandwidthMonitor: newBandwidthMonitor(),
    queuedPayloads: newPayloadQueue(),
    queueFullReported: false
  };
}
function newPayloadQueue() {
  var queue = [];
  return {
    bytesCount: 0,
    enqueue: function (payload) {
      if (this.isFull()) {
        return;
      }
      queue.push(payload);
      this.bytesCount += payload.bytesCount;
    },
    first: function () {
      return queue[0];
    },
    dequeue: function () {
      var payload = queue.shift();
      if (payload) {
        this.bytesCount -= payload.bytesCount;
      }
      return payload;
    },
    size: function () {
      return queue.length;
    },
    isFull: function () {
      return this.bytesCount >= MAX_QUEUE_BYTES_COUNT;
    }
  };
}
function newBandwidthMonitor() {
  return {
    ongoingRequestCount: 0,
    ongoingByteCount: 0,
    canHandle: function (payload) {
      return this.ongoingRequestCount === 0 || this.ongoingByteCount + payload.bytesCount <= MAX_ONGOING_BYTES_COUNT && this.ongoingRequestCount < MAX_ONGOING_REQUESTS;
    },
    add: function (payload) {
      this.ongoingRequestCount += 1;
      this.ongoingByteCount += payload.bytesCount;
    },
    remove: function (payload) {
      this.ongoingRequestCount -= 1;
      this.ongoingByteCount -= payload.bytesCount;
    }
  };
}

function createHttpRequest(configuration, endpointBuilder, bytesLimit, reportError) {
  var retryState = newRetryState();
  var sendStrategyForRetry = function (payload, onResponse) {
    return fetchKeepAliveStrategy(configuration, endpointBuilder, bytesLimit, payload, onResponse);
  };
  return {
    send: function (payload) {
      sendWithRetryStrategy(payload, retryState, sendStrategyForRetry, endpointBuilder.trackType, reportError);
    },
    /**
     * Since fetch keepalive behaves like regular fetch on Firefox,
     * keep using sendBeaconStrategy on exit
     */
    sendOnExit: function (payload) {
      sendBeaconStrategy(configuration, endpointBuilder, bytesLimit, payload);
    }
  };
}
function sendBeaconStrategy(configuration, endpointBuilder, bytesLimit, payload) {
  var canUseBeacon = !!navigator.sendBeacon && payload.bytesCount < bytesLimit;
  if (canUseBeacon) {
    try {
      var beaconUrl = endpointBuilder.build('beacon', payload);
      var isQueued = navigator.sendBeacon(beaconUrl, payload.data);
      if (isQueued) {
        return;
      }
    } catch (e) {
      reportBeaconError(e);
    }
  }
  var xhrUrl = endpointBuilder.build('xhr', payload);
  sendXHR(configuration, xhrUrl, payload.data);
}
var hasReportedBeaconError = false;
function reportBeaconError(e) {
  if (!hasReportedBeaconError) {
    hasReportedBeaconError = true;
    addTelemetryError(e);
  }
}
function fetchKeepAliveStrategy(configuration, endpointBuilder, bytesLimit, payload, onResponse) {
  var canUseKeepAlive = isKeepAliveSupported() && payload.bytesCount < bytesLimit;
  if (canUseKeepAlive) {
    var fetchUrl = endpointBuilder.build('fetch', payload);
    fetch(fetchUrl, {
      method: 'POST',
      body: payload.data,
      keepalive: true,
      mode: 'cors'
    }).then(monitor(function (response) {
      return onResponse === null || onResponse === void 0 ? void 0 : onResponse({
        status: response.status,
        type: response.type
      });
    }), monitor(function () {
      var xhrUrl = endpointBuilder.build('xhr', payload);
      // failed to queue the request
      sendXHR(configuration, xhrUrl, payload.data, onResponse);
    }));
  } else {
    var xhrUrl = endpointBuilder.build('xhr', payload);
    sendXHR(configuration, xhrUrl, payload.data, onResponse);
  }
}
function isKeepAliveSupported() {
  // Request can throw, cf https://developer.mozilla.org/en-US/docs/Web/API/Request/Request#errors
  try {
    return window.Request && 'keepalive' in new Request('http://a');
  } catch (_a) {
    return false;
  }
}
function sendXHR(configuration, url, data, onResponse) {
  var request = new XMLHttpRequest();
  request.open('POST', url, true);
  if (data instanceof Blob) {
    // When using a Blob instance, IE does not use its 'type' to define the 'Content-Type' header
    // automatically, so the intake request ends up being rejected with an HTTP status 415
    // Defining the header manually fixes this issue.
    request.setRequestHeader('Content-Type', data.type);
  }
  addEventListener(configuration, request, 'loadend', function () {
    onResponse === null || onResponse === void 0 ? void 0 : onResponse({
      status: request.status
    });
  }, {
    // prevent multiple onResponse callbacks
    // if the xhr instance is reused by a third party
    once: true
  });
  request.send(data);
}

function getEventBridge() {
  var eventBridgeGlobal = getEventBridgeGlobal();
  if (!eventBridgeGlobal) {
    return;
  }
  return {
    getCapabilities: function () {
      var _a;
      return JSON.parse(((_a = eventBridgeGlobal.getCapabilities) === null || _a === void 0 ? void 0 : _a.call(eventBridgeGlobal)) || '[]');
    },
    getPrivacyLevel: function () {
      var _a;
      return (_a = eventBridgeGlobal.getPrivacyLevel) === null || _a === void 0 ? void 0 : _a.call(eventBridgeGlobal);
    },
    getAllowedWebViewHosts: function () {
      return JSON.parse(eventBridgeGlobal.getAllowedWebViewHosts());
    },
    send: function (eventType, event, viewId) {
      var view = viewId ? {
        id: viewId
      } : undefined;
      eventBridgeGlobal.send(JSON.stringify({
        eventType: eventType,
        event: event,
        view: view
      }));
    }
  };
}
function bridgeSupports(capability) {
  var bridge = getEventBridge();
  return !!bridge && includes(bridge.getCapabilities(), capability);
}
function canUseEventBridge(currentHost) {
  var _a;
  if (currentHost === void 0) {
    currentHost = (_a = getGlobalObject().location) === null || _a === void 0 ? void 0 : _a.hostname;
  }
  var bridge = getEventBridge();
  return !!bridge && bridge.getAllowedWebViewHosts().some(function (allowedHost) {
    return currentHost === allowedHost || endsWith(currentHost, ".".concat(allowedHost));
  });
}
function getEventBridgeGlobal() {
  return getGlobalObject().DatadogEventBridge;
}

var PageExitReason = {
  HIDDEN: 'visibility_hidden',
  UNLOADING: 'before_unload',
  PAGEHIDE: 'page_hide',
  FROZEN: 'page_frozen'
};
function createPageExitObservable(configuration) {
  return new Observable(function (observable) {
    var stopListeners = addEventListeners(configuration, window, [DOM_EVENT.VISIBILITY_CHANGE, DOM_EVENT.FREEZE], function (event) {
      if (event.type === DOM_EVENT.VISIBILITY_CHANGE && document.visibilityState === 'hidden') {
        /**
         * Only event that guarantee to fire on mobile devices when the page transitions to background state
         * (e.g. when user switches to a different application, goes to homescreen, etc), or is being unloaded.
         */
        observable.notify({
          reason: PageExitReason.HIDDEN
        });
      } else if (event.type === DOM_EVENT.FREEZE) {
        /**
         * After transitioning in background a tab can be freezed to preserve resources. (cf: https://developer.chrome.com/blog/page-lifecycle-api)
         * Allow to collect events happening between hidden and frozen state.
         */
        observable.notify({
          reason: PageExitReason.FROZEN
        });
      }
    }, {
      capture: true
    }).stop;
    var stopBeforeUnloadListener = addEventListener(configuration, window, DOM_EVENT.BEFORE_UNLOAD, function () {
      observable.notify({
        reason: PageExitReason.UNLOADING
      });
    }).stop;
    return function () {
      stopListeners();
      stopBeforeUnloadListener();
    };
  });
}
function isPageExitReason(reason) {
  return includes(objectValues(PageExitReason), reason);
}

var Batch = /** @class */function () {
  function Batch(encoder, request, flushController, messageBytesLimit) {
    var _this = this;
    this.encoder = encoder;
    this.request = request;
    this.flushController = flushController;
    this.messageBytesLimit = messageBytesLimit;
    this.upsertBuffer = {};
    this.flushSubscription = this.flushController.flushObservable.subscribe(function (event) {
      return _this.flush(event);
    });
  }
  Batch.prototype.add = function (message) {
    this.addOrUpdate(message);
  };
  Batch.prototype.upsert = function (message, key) {
    this.addOrUpdate(message, key);
  };
  Batch.prototype.stop = function () {
    this.flushSubscription.unsubscribe();
  };
  Batch.prototype.flush = function (event) {
    var upsertMessages = objectValues(this.upsertBuffer).join('\n');
    this.upsertBuffer = {};
    var isPageExit = isPageExitReason(event.reason);
    var send = isPageExit ? this.request.sendOnExit : this.request.send;
    if (isPageExit &&
    // Note: checking that the encoder is async is not strictly needed, but it's an optimization:
    // if the encoder is async we need to send two requests in some cases (one for encoded data
    // and the other for non-encoded data). But if it's not async, we don't have to worry about
    // it and always send a single request.
    this.encoder.isAsync) {
      var encoderResult = this.encoder.finishSync();
      // Send encoded messages
      if (encoderResult.outputBytesCount) {
        send(formatPayloadFromEncoder(encoderResult));
      }
      // Send messages that are not yet encoded at this point
      var pendingMessages = [encoderResult.pendingData, upsertMessages].filter(Boolean).join('\n');
      if (pendingMessages) {
        send({
          data: pendingMessages,
          bytesCount: computeBytesCount(pendingMessages)
        });
      }
    } else {
      if (upsertMessages) {
        this.encoder.write(this.encoder.isEmpty ? upsertMessages : "\n".concat(upsertMessages));
      }
      this.encoder.finish(function (encoderResult) {
        send(formatPayloadFromEncoder(encoderResult));
      });
    }
  };
  Batch.prototype.addOrUpdate = function (message, key) {
    var serializedMessage = jsonStringify(message);
    var estimatedMessageBytesCount = this.encoder.estimateEncodedBytesCount(serializedMessage);
    if (estimatedMessageBytesCount >= this.messageBytesLimit) {
      display.warn("Discarded a message whose size was bigger than the maximum allowed size ".concat(this.messageBytesLimit, "KB. More details: ").concat(DOCS_ORIGIN, "/real_user_monitoring/browser/troubleshooting/#technical-limitations"));
      return;
    }
    if (this.hasMessageFor(key)) {
      this.remove(key);
    }
    this.push(serializedMessage, estimatedMessageBytesCount, key);
  };
  Batch.prototype.push = function (serializedMessage, estimatedMessageBytesCount, key) {
    var _this = this;
    this.flushController.notifyBeforeAddMessage(estimatedMessageBytesCount);
    if (key !== undefined) {
      this.upsertBuffer[key] = serializedMessage;
      this.flushController.notifyAfterAddMessage();
    } else {
      this.encoder.write(this.encoder.isEmpty ? serializedMessage : "\n".concat(serializedMessage), function (realMessageBytesCount) {
        _this.flushController.notifyAfterAddMessage(realMessageBytesCount - estimatedMessageBytesCount);
      });
    }
  };
  Batch.prototype.remove = function (key) {
    var removedMessage = this.upsertBuffer[key];
    delete this.upsertBuffer[key];
    var messageBytesCount = this.encoder.estimateEncodedBytesCount(removedMessage);
    this.flushController.notifyAfterRemoveMessage(messageBytesCount);
  };
  Batch.prototype.hasMessageFor = function (key) {
    return key !== undefined && this.upsertBuffer[key] !== undefined;
  };
  return Batch;
}();
function formatPayloadFromEncoder(encoderResult) {
  var data;
  if (typeof encoderResult.output === 'string') {
    data = encoderResult.output;
  } else {
    data = new Blob([encoderResult.output], {
      // This will set the 'Content-Type: text/plain' header. Reasoning:
      // * The intake rejects the request if there is no content type.
      // * The browser will issue CORS preflight requests if we set it to 'application/json', which
      // could induce higher intake load (and maybe has other impacts).
      // * Also it's not quite JSON, since we are concatenating multiple JSON objects separated by
      // new lines.
      type: 'text/plain'
    });
  }
  return {
    data: data,
    bytesCount: encoderResult.outputBytesCount,
    encoding: encoderResult.encoding
  };
}

/**
 * Returns a "flush controller", responsible of notifying when flushing a pool of pending data needs
 * to happen. The implementation is designed to support both synchronous and asynchronous usages,
 * but relies on invariants described in each method documentation to keep a coherent state.
 */
function createFlushController(_a) {
  var messagesLimit = _a.messagesLimit,
    bytesLimit = _a.bytesLimit,
    durationLimit = _a.durationLimit,
    pageExitObservable = _a.pageExitObservable,
    sessionExpireObservable = _a.sessionExpireObservable;
  var pageExitSubscription = pageExitObservable.subscribe(function (event) {
    return flush(event.reason);
  });
  var sessionExpireSubscription = sessionExpireObservable.subscribe(function () {
    return flush('session_expire');
  });
  var flushObservable = new Observable(function () {
    return function () {
      pageExitSubscription.unsubscribe();
      sessionExpireSubscription.unsubscribe();
    };
  });
  var currentBytesCount = 0;
  var currentMessagesCount = 0;
  function flush(flushReason) {
    if (currentMessagesCount === 0) {
      return;
    }
    var messagesCount = currentMessagesCount;
    var bytesCount = currentBytesCount;
    currentMessagesCount = 0;
    currentBytesCount = 0;
    cancelDurationLimitTimeout();
    flushObservable.notify({
      reason: flushReason,
      messagesCount: messagesCount,
      bytesCount: bytesCount
    });
  }
  var durationLimitTimeoutId;
  function scheduleDurationLimitTimeout() {
    if (durationLimitTimeoutId === undefined) {
      durationLimitTimeoutId = setTimeout$1(function () {
        flush('duration_limit');
      }, durationLimit);
    }
  }
  function cancelDurationLimitTimeout() {
    clearTimeout$1(durationLimitTimeoutId);
    durationLimitTimeoutId = undefined;
  }
  return {
    flushObservable: flushObservable,
    get messagesCount() {
      return currentMessagesCount;
    },
    /**
     * Notifies that a message will be added to a pool of pending messages waiting to be flushed.
     *
     * This function needs to be called synchronously, right before adding the message, so no flush
     * event can happen after `notifyBeforeAddMessage` and before adding the message.
     *
     * @param estimatedMessageBytesCount: an estimation of the message bytes count once it is
     * actually added.
     */
    notifyBeforeAddMessage: function (estimatedMessageBytesCount) {
      if (currentBytesCount + estimatedMessageBytesCount >= bytesLimit) {
        flush('bytes_limit');
      }
      // Consider the message to be added now rather than in `notifyAfterAddMessage`, because if no
      // message was added yet and `notifyAfterAddMessage` is called asynchronously, we still want
      // to notify when a flush is needed (for example on page exit).
      currentMessagesCount += 1;
      currentBytesCount += estimatedMessageBytesCount;
      scheduleDurationLimitTimeout();
    },
    /**
     * Notifies that a message *was* added to a pool of pending messages waiting to be flushed.
     *
     * This function can be called asynchronously after the message was added, but in this case it
     * should not be called if a flush event occurred in between.
     *
     * @param messageBytesCountDiff: the difference between the estimated message bytes count and
     * its actual bytes count once added to the pool.
     */
    notifyAfterAddMessage: function (messageBytesCountDiff) {
      if (messageBytesCountDiff === void 0) {
        messageBytesCountDiff = 0;
      }
      currentBytesCount += messageBytesCountDiff;
      if (currentMessagesCount >= messagesLimit) {
        flush('messages_limit');
      } else if (currentBytesCount >= bytesLimit) {
        flush('bytes_limit');
      }
    },
    /**
     * Notifies that a message was removed from a pool of pending messages waiting to be flushed.
     *
     * This function needs to be called synchronously, right after removing the message, so no flush
     * event can happen after removing the message and before `notifyAfterRemoveMessage`.
     *
     * @param messageBytesCount: the message bytes count that was added to the pool. Should
     * correspond to the sum of bytes counts passed to `notifyBeforeAddMessage` and
     * `notifyAfterAddMessage`.
     */
    notifyAfterRemoveMessage: function (messageBytesCount) {
      currentBytesCount -= messageBytesCount;
      currentMessagesCount -= 1;
      if (currentMessagesCount === 0) {
        cancelDurationLimitTimeout();
      }
    }
  };
}

function startBatchWithReplica(configuration, primary, replica, reportError, pageExitObservable, sessionExpireObservable) {
  var primaryBatch = createBatch(configuration, primary);
  var replicaBatch = replica && createBatch(configuration, replica);
  function createBatch(configuration, _a) {
    var endpoint = _a.endpoint,
      encoder = _a.encoder;
    return new Batch(encoder, createHttpRequest(configuration, endpoint, configuration.batchBytesLimit, reportError), createFlushController({
      messagesLimit: configuration.batchMessagesLimit,
      bytesLimit: configuration.batchBytesLimit,
      durationLimit: configuration.flushTimeout,
      pageExitObservable: pageExitObservable,
      sessionExpireObservable: sessionExpireObservable
    }), configuration.messageBytesLimit);
  }
  return {
    flushObservable: primaryBatch.flushController.flushObservable,
    add: function (message, replicated) {
      if (replicated === void 0) {
        replicated = true;
      }
      primaryBatch.add(message);
      if (replicaBatch && replicated) {
        replicaBatch.add(replica.transformMessage ? replica.transformMessage(message) : message);
      }
    },
    upsert: function (message, key) {
      primaryBatch.upsert(message, key);
      if (replicaBatch) {
        replicaBatch.upsert(replica.transformMessage ? replica.transformMessage(message) : message, key);
      }
    },
    stop: function () {
      primaryBatch.stop();
      replicaBatch === null || replicaBatch === void 0 ? void 0 : replicaBatch.stop();
    }
  };
}

function createIdentityEncoder() {
  var output = '';
  var outputBytesCount = 0;
  return {
    isAsync: false,
    get isEmpty() {
      return !output;
    },
    write: function (data, callback) {
      var additionalEncodedBytesCount = computeBytesCount(data);
      outputBytesCount += additionalEncodedBytesCount;
      output += data;
      if (callback) {
        callback(additionalEncodedBytesCount);
      }
    },
    finish: function (callback) {
      callback(this.finishSync());
    },
    finishSync: function () {
      var result = {
        output: output,
        outputBytesCount: outputBytesCount,
        rawBytesCount: outputBytesCount,
        pendingData: ''
      };
      output = '';
      outputBytesCount = 0;
      return result;
    },
    estimateEncodedBytesCount: function (data) {
      return data.length;
    }
  };
}

var AbstractLifeCycle = /** @class */function () {
  function AbstractLifeCycle() {
    this.callbacks = {};
  }
  AbstractLifeCycle.prototype.notify = function (eventType, data) {
    var eventCallbacks = this.callbacks[eventType];
    if (eventCallbacks) {
      eventCallbacks.forEach(function (callback) {
        return callback(data);
      });
    }
  };
  AbstractLifeCycle.prototype.subscribe = function (eventType, callback) {
    var _this = this;
    if (!this.callbacks[eventType]) {
      this.callbacks[eventType] = [];
    }
    this.callbacks[eventType].push(callback);
    return {
      unsubscribe: function () {
        _this.callbacks[eventType] = _this.callbacks[eventType].filter(function (other) {
          return callback !== other;
        });
      }
    };
  };
  return AbstractLifeCycle;
}();

function createEventRateLimiter(eventType, limit, onLimitReached) {
  var eventCount = 0;
  var allowNextEvent = false;
  return {
    isLimitReached: function () {
      if (eventCount === 0) {
        setTimeout$1(function () {
          eventCount = 0;
        }, ONE_MINUTE);
      }
      eventCount += 1;
      if (eventCount <= limit || allowNextEvent) {
        allowNextEvent = false;
        return false;
      }
      if (eventCount === limit + 1) {
        allowNextEvent = true;
        try {
          onLimitReached({
            message: "Reached max number of ".concat(eventType, "s by minute: ").concat(limit),
            source: ErrorSource.AGENT,
            startClocks: clocksNow()
          });
        } finally {
          allowNextEvent = false;
        }
      }
      return true;
    }
  };
}

function runOnReadyState(configuration, expectedReadyState, callback) {
  if (document.readyState === expectedReadyState || document.readyState === 'complete') {
    callback();
  } else {
    var eventName = expectedReadyState === 'complete' ? DOM_EVENT.LOAD : DOM_EVENT.DOM_CONTENT_LOADED;
    addEventListener(configuration, window, eventName, callback, {
      once: true
    });
  }
}

var xhrObservable;
var xhrContexts = new WeakMap();
function initXhrObservable(configuration) {
  if (!xhrObservable) {
    xhrObservable = createXhrObservable(configuration);
  }
  return xhrObservable;
}
function createXhrObservable(configuration) {
  return new Observable(function (observable) {
    var stopInstrumentingStart = instrumentMethod(XMLHttpRequest.prototype, 'open', openXhr).stop;
    var stopInstrumentingSend = instrumentMethod(XMLHttpRequest.prototype, 'send', function (call) {
      sendXhr(call, configuration, observable);
    }, {
      computeHandlingStack: true
    }).stop;
    var stopInstrumentingAbort = instrumentMethod(XMLHttpRequest.prototype, 'abort', abortXhr).stop;
    return function () {
      stopInstrumentingStart();
      stopInstrumentingSend();
      stopInstrumentingAbort();
    };
  });
}
function openXhr(_a) {
  var xhr = _a.target,
    _b = _a.parameters,
    method = _b[0],
    url = _b[1];
  xhrContexts.set(xhr, {
    state: 'open',
    method: String(method).toUpperCase(),
    url: normalizeUrl(String(url))
  });
}
function sendXhr(_a, configuration, observable) {
  var xhr = _a.target,
    handlingStack = _a.handlingStack;
  var context = xhrContexts.get(xhr);
  if (!context) {
    return;
  }
  var startContext = context;
  startContext.state = 'start';
  startContext.startClocks = clocksNow();
  startContext.isAborted = false;
  startContext.xhr = xhr;
  startContext.handlingStack = handlingStack;
  var hasBeenReported = false;
  var stopInstrumentingOnReadyStateChange = instrumentMethod(xhr, 'onreadystatechange', function () {
    if (xhr.readyState === XMLHttpRequest.DONE) {
      // Try to report the XHR as soon as possible, because the XHR may be mutated by the
      // application during a future event. For example, Angular is calling .abort() on
      // completed requests during an onreadystatechange event, so the status becomes '0'
      // before the request is collected.
      onEnd();
    }
  }).stop;
  var onEnd = function () {
    unsubscribeLoadEndListener();
    stopInstrumentingOnReadyStateChange();
    if (hasBeenReported) {
      return;
    }
    hasBeenReported = true;
    var completeContext = context;
    completeContext.state = 'complete';
    completeContext.duration = elapsed(startContext.startClocks.timeStamp, timeStampNow());
    completeContext.status = xhr.status;
    observable.notify(shallowClone(completeContext));
  };
  var unsubscribeLoadEndListener = addEventListener(configuration, xhr, 'loadend', onEnd).stop;
  observable.notify(startContext);
}
function abortXhr(_a) {
  var xhr = _a.target;
  var context = xhrContexts.get(xhr);
  if (context) {
    context.isAborted = true;
  }
}

var fetchObservable;
function initFetchObservable() {
  if (!fetchObservable) {
    fetchObservable = createFetchObservable();
  }
  return fetchObservable;
}
function createFetchObservable() {
  return new Observable(function (observable) {
    if (!window.fetch) {
      return;
    }
    var stop = instrumentMethod(window, 'fetch', function (call) {
      return beforeSend(call, observable);
    }, {
      computeHandlingStack: true
    }).stop;
    return stop;
  });
}
function beforeSend(_a, observable) {
  var parameters = _a.parameters,
    onPostCall = _a.onPostCall,
    handlingStack = _a.handlingStack;
  var input = parameters[0],
    init = parameters[1];
  var methodFromParams = init && init.method;
  if (methodFromParams === undefined && input instanceof Request) {
    methodFromParams = input.method;
  }
  var method = methodFromParams !== undefined ? String(methodFromParams).toUpperCase() : 'GET';
  var url = input instanceof Request ? input.url : normalizeUrl(String(input));
  var startClocks = clocksNow();
  var context = {
    state: 'start',
    init: init,
    input: input,
    method: method,
    startClocks: startClocks,
    url: url,
    handlingStack: handlingStack
  };
  observable.notify(context);
  // Those properties can be changed by observable subscribers
  parameters[0] = context.input;
  parameters[1] = context.init;
  onPostCall(function (responsePromise) {
    return afterSend(observable, responsePromise, context);
  });
}
function afterSend(observable, responsePromise, startContext) {
  var reportFetch = function (response) {
    var context = startContext;
    context.state = 'resolve';
    if ('stack' in response || response instanceof Error) {
      context.status = 0;
      context.isAborted = response instanceof DOMException && response.code === DOMException.ABORT_ERR;
      context.error = response;
    } else if ('status' in response) {
      context.response = response;
      context.responseType = response.type;
      context.status = response.status;
      context.isAborted = false;
    }
    observable.notify(context);
  };
  responsePromise.then(monitor(reportFetch), monitor(reportFetch));
}

var consoleObservablesByApi = {};
function initConsoleObservable(apis) {
  var consoleObservables = apis.map(function (api) {
    if (!consoleObservablesByApi[api]) {
      consoleObservablesByApi[api] = createConsoleObservable(api);
    }
    return consoleObservablesByApi[api];
  });
  return mergeObservables.apply(void 0, consoleObservables);
}
function createConsoleObservable(api) {
  return new Observable(function (observable) {
    var originalConsoleApi = globalConsole[api];
    globalConsole[api] = function () {
      var params = [];
      for (var _i = 0; _i < arguments.length; _i++) {
        params[_i] = arguments[_i];
      }
      originalConsoleApi.apply(console, params);
      var handlingStack = createHandlingStack();
      callMonitored(function () {
        observable.notify(buildConsoleLog(params, api, handlingStack));
      });
    };
    return function () {
      globalConsole[api] = originalConsoleApi;
    };
  });
}
function buildConsoleLog(params, api, handlingStack) {
  var message = params.map(function (param) {
    return formatConsoleParameters(param);
  }).join(' ');
  var stack;
  var fingerprint;
  var causes;
  if (api === ConsoleApiName.error) {
    var firstErrorParam = find(params, function (param) {
      return param instanceof Error;
    });
    stack = firstErrorParam ? toStackTraceString(computeStackTrace(firstErrorParam)) : undefined;
    fingerprint = tryToGetFingerprint(firstErrorParam);
    causes = firstErrorParam ? flattenErrorCauses(firstErrorParam, 'console') : undefined;
  }
  return {
    api: api,
    message: message,
    stack: stack,
    handlingStack: handlingStack,
    fingerprint: fingerprint,
    causes: causes
  };
}
function formatConsoleParameters(param) {
  if (typeof param === 'string') {
    return sanitize(param);
  }
  if (param instanceof Error) {
    return formatErrorMessage(computeStackTrace(param));
  }
  return jsonStringify(sanitize(param), undefined, 2);
}

function createContextManager(customerDataTracker) {
  var context = {};
  var changeObservable = new Observable();
  var contextManager = {
    getContext: function () {
      return deepClone(context);
    },
    setContext: function (newContext) {
      if (getType(newContext) === 'object') {
        context = sanitize(newContext);
        customerDataTracker.updateCustomerData(context);
      } else {
        contextManager.clearContext();
      }
      changeObservable.notify();
    },
    setContextProperty: function (key, property) {
      context[key] = sanitize(property);
      customerDataTracker.updateCustomerData(context);
      changeObservable.notify();
    },
    removeContextProperty: function (key) {
      delete context[key];
      customerDataTracker.updateCustomerData(context);
      changeObservable.notify();
    },
    clearContext: function () {
      context = {};
      customerDataTracker.resetCustomerData();
      changeObservable.notify();
    },
    changeObservable: changeObservable
  };
  return contextManager;
}

var CONTEXT_STORE_KEY_PREFIX = '_dd_c';
var storageListeners = [];
function storeContextManager(configuration, contextManager, productKey, customerDataType) {
  var storageKey = buildStorageKey(productKey, customerDataType);
  storageListeners.push(addEventListener(configuration, window, DOM_EVENT.STORAGE, function (_a) {
    var key = _a.key;
    if (storageKey === key) {
      synchronizeWithStorage();
    }
  }));
  contextManager.changeObservable.subscribe(dumpToStorage);
  contextManager.setContext(combine(getFromStorage(), contextManager.getContext()));
  function synchronizeWithStorage() {
    contextManager.setContext(getFromStorage());
  }
  function dumpToStorage() {
    localStorage.setItem(storageKey, JSON.stringify(contextManager.getContext()));
  }
  function getFromStorage() {
    var rawContext = localStorage.getItem(storageKey);
    return rawContext !== null ? JSON.parse(rawContext) : {};
  }
}
function buildStorageKey(productKey, customerDataType) {
  return "".concat(CONTEXT_STORE_KEY_PREFIX, "_").concat(productKey, "_").concat(customerDataType);
}

// RUM and logs batch bytes limit is 16KB
// ensure that we leave room for other event attributes and maintain a decent amount of event per batch
// (3KB (customer data) + 1KB (other attributes)) * 4 (events per batch) = 16KB
var CUSTOMER_DATA_BYTES_LIMIT = 3 * ONE_KIBI_BYTE;
// We observed that the compression ratio is around 8 in general, but we also want to keep a margin
// because some data might not be compressed (ex: last view update on page exit). We chose 16KiB
// because it is also the limit of the 'batchBytesCount' that we use for RUM and Logs data, but this
// is a bit arbitrary.
var CUSTOMER_COMPRESSED_DATA_BYTES_LIMIT = 16 * ONE_KIBI_BYTE;
var BYTES_COMPUTATION_THROTTLING_DELAY = 200;
function createCustomerDataTrackerManager(compressionStatus) {
  if (compressionStatus === void 0) {
    compressionStatus = 2 /* CustomerDataCompressionStatus.Disabled */;
  }
  var customerDataTrackers = new Map();
  var alreadyWarned = false;
  function checkCustomerDataLimit(initialBytesCount) {
    if (initialBytesCount === void 0) {
      initialBytesCount = 0;
    }
    if (alreadyWarned || compressionStatus === 0 /* CustomerDataCompressionStatus.Unknown */) {
      return;
    }
    var bytesCountLimit = compressionStatus === 2 /* CustomerDataCompressionStatus.Disabled */ ? CUSTOMER_DATA_BYTES_LIMIT : CUSTOMER_COMPRESSED_DATA_BYTES_LIMIT;
    var bytesCount = initialBytesCount;
    customerDataTrackers.forEach(function (tracker) {
      bytesCount += tracker.getBytesCount();
    });
    if (bytesCount > bytesCountLimit) {
      displayCustomerDataLimitReachedWarning(bytesCountLimit);
      alreadyWarned = true;
    }
  }
  return {
    /**
     * Creates a detached tracker. The manager will not store a reference to that tracker, and the
     * bytes count will be counted independently from other detached trackers.
     *
     * This is particularly useful when we don't know when the tracker will be unused, so we don't
     * leak memory (ex: when used in Logger instances).
     */
    createDetachedTracker: function () {
      var tracker = createCustomerDataTracker(function () {
        return checkCustomerDataLimit(tracker.getBytesCount());
      });
      return tracker;
    },
    /**
     * Creates a tracker if it doesn't exist, and returns it.
     */
    getOrCreateTracker: function (type) {
      if (!customerDataTrackers.has(type)) {
        customerDataTrackers.set(type, createCustomerDataTracker(checkCustomerDataLimit));
      }
      return customerDataTrackers.get(type);
    },
    setCompressionStatus: function (newCompressionStatus) {
      if (compressionStatus === 0 /* CustomerDataCompressionStatus.Unknown */) {
        compressionStatus = newCompressionStatus;
        checkCustomerDataLimit();
      }
    },
    getCompressionStatus: function () {
      return compressionStatus;
    },
    stop: function () {
      customerDataTrackers.forEach(function (tracker) {
        return tracker.stop();
      });
      customerDataTrackers.clear();
    }
  };
}
function createCustomerDataTracker(checkCustomerDataLimit) {
  var bytesCountCache = 0;
  // Throttle the bytes computation to minimize the impact on performance.
  // Especially useful if the user call context APIs synchronously multiple times in a row
  var _a = throttle(function (context) {
      bytesCountCache = computeBytesCount(jsonStringify(context));
      checkCustomerDataLimit();
    }, BYTES_COMPUTATION_THROTTLING_DELAY),
    computeBytesCountThrottled = _a.throttled,
    cancelComputeBytesCount = _a.cancel;
  var resetBytesCount = function () {
    cancelComputeBytesCount();
    bytesCountCache = 0;
  };
  return {
    updateCustomerData: function (context) {
      if (isEmptyObject(context)) {
        resetBytesCount();
      } else {
        computeBytesCountThrottled(context);
      }
    },
    resetCustomerData: resetBytesCount,
    getBytesCount: function () {
      return bytesCountCache;
    },
    stop: function () {
      cancelComputeBytesCount();
    }
  };
}
function displayCustomerDataLimitReachedWarning(bytesCountLimit) {
  display.warn("Customer data exceeds the recommended ".concat(bytesCountLimit / ONE_KIBI_BYTE, "KiB threshold. More details: ").concat(DOCS_ORIGIN, "/real_user_monitoring/browser/troubleshooting/#customer-data-exceeds-the-recommended-threshold-warning"));
}

/**
 * Read bytes from a ReadableStream until at least `limit` bytes have been read (or until the end of
 * the stream). The callback is invoked with the at most `limit` bytes, and indicates that the limit
 * has been exceeded if more bytes were available.
 */
function readBytesFromStream(stream, callback, options) {
  var reader = stream.getReader();
  var chunks = [];
  var readBytesCount = 0;
  readMore();
  function readMore() {
    reader.read().then(monitor(function (result) {
      if (result.done) {
        onDone();
        return;
      }
      if (options.collectStreamBody) {
        chunks.push(result.value);
      }
      readBytesCount += result.value.length;
      if (readBytesCount > options.bytesLimit) {
        onDone();
      } else {
        readMore();
      }
    }), monitor(function (error) {
      return callback(error);
    }));
  }
  function onDone() {
    reader.cancel().catch(
    // we don't care if cancel fails, but we still need to catch the error to avoid reporting it
    // as an unhandled rejection
    noop$1);
    var bytes;
    var limitExceeded;
    if (options.collectStreamBody) {
      var completeBuffer_1;
      if (chunks.length === 1) {
        // optimization: if the response is small enough to fit in a single buffer (provided by the browser), just
        // use it directly.
        completeBuffer_1 = chunks[0];
      } else {
        // else, we need to copy buffers into a larger buffer to concatenate them.
        completeBuffer_1 = new Uint8Array(readBytesCount);
        var offset_1 = 0;
        chunks.forEach(function (chunk) {
          completeBuffer_1.set(chunk, offset_1);
          offset_1 += chunk.length;
        });
      }
      bytes = completeBuffer_1.slice(0, options.bytesLimit);
      limitExceeded = completeBuffer_1.length > options.bytesLimit;
    }
    callback(undefined, bytes, limitExceeded);
  }
}

var SYNTHETICS_TEST_ID_COOKIE_NAME = 'datadog-synthetics-public-id';
var SYNTHETICS_RESULT_ID_COOKIE_NAME = 'datadog-synthetics-result-id';
var SYNTHETICS_INJECTS_RUM_COOKIE_NAME = 'datadog-synthetics-injects-rum';
function willSyntheticsInjectRum() {
  return Boolean(window._DATADOG_SYNTHETICS_INJECTS_RUM || getInitCookie(SYNTHETICS_INJECTS_RUM_COOKIE_NAME));
}
function getSyntheticsTestId() {
  var value = window._DATADOG_SYNTHETICS_PUBLIC_ID || getInitCookie(SYNTHETICS_TEST_ID_COOKIE_NAME);
  return typeof value === 'string' ? value : undefined;
}
function getSyntheticsResultId() {
  var value = window._DATADOG_SYNTHETICS_RESULT_ID || getInitCookie(SYNTHETICS_RESULT_ID_COOKIE_NAME);
  return typeof value === 'string' ? value : undefined;
}

/**
 * Clone input data and ensure known user properties (id, name, email)
 * are strings, as defined here:
 * https://docs.datadoghq.com/logs/log_configuration/attributes_naming_convention/#user-related-attributes
 */
function sanitizeUser(newUser) {
  // We shallow clone only to prevent mutation of user data.
  var user = assign({}, newUser);
  var keys = ['id', 'name', 'email'];
  keys.forEach(function (key) {
    if (key in user) {
      user[key] = String(user[key]);
    }
  });
  return user;
}
/**
 * Simple check to ensure user is valid
 */
function checkUser(newUser) {
  var isValid = getType(newUser) === 'object';
  if (!isValid) {
    display.error('Unsupported user:', newUser);
  }
  return isValid;
}

function isMatchOption(item) {
  var itemType = getType(item);
  return itemType === 'string' || itemType === 'function' || item instanceof RegExp;
}
/**
 * Returns true if value can be matched by at least one of the provided MatchOptions.
 * When comparing strings, setting useStartsWith to true will compare the value with the start of
 * the option, instead of requiring an exact match.
 */
function matchList(list, value, useStartsWith) {
  if (useStartsWith === void 0) {
    useStartsWith = false;
  }
  return list.some(function (item) {
    try {
      if (typeof item === 'function') {
        return item(value);
      } else if (item instanceof RegExp) {
        return item.test(value);
      } else if (typeof item === 'string') {
        return useStartsWith ? startsWith$1(value, item) : item === value;
      }
    } catch (e) {
      display.error(e);
    }
    return false;
  });
}

function buildCommonContext(globalContextManager, userContextManager, recorderApi) {
  return {
    context: globalContextManager.getContext(),
    user: userContextManager.getContext(),
    hasReplay: recorderApi.isRecording() ? true : undefined
  };
}

function isTracingOption(item) {
  var expectedItem = item;
  return getType(expectedItem) === 'object' && isMatchOption(expectedItem.match) && Array.isArray(expectedItem.propagatorTypes);
}
/**
 * Clear tracing information to avoid incomplete traces. Ideally, we should do it when the
 * request did not reach the server, but the browser does not expose this. So, we clear tracing
 * information if the request ended with status 0 without being aborted by the application.
 *
 * Reasoning:
 *
 * * Applications are usually aborting requests after a bit of time, for example when the user is
 * typing (autocompletion) or navigating away (in a SPA). With a performant device and good
 * network conditions, the request is likely to reach the server before being canceled.
 *
 * * Requests aborted otherwise (ex: lack of internet, CORS issue, blocked by a privacy extension)
 * are likely to finish quickly and without reaching the server.
 *
 * Of course, it might not be the case every time, but it should limit having incomplete traces a
 * bit.
 * */
function clearTracingIfNeeded(context) {
  if (context.status === 0 && !context.isAborted) {
    context.traceId = undefined;
    context.spanId = undefined;
    context.traceSampled = undefined;
  }
}
function startTracer(configuration, sessionManager) {
  return {
    clearTracingIfNeeded: clearTracingIfNeeded,
    traceFetch: function (context) {
      return injectHeadersIfTracingAllowed(configuration, context, sessionManager, function (tracingHeaders) {
        var _a;
        if (context.input instanceof Request && !((_a = context.init) === null || _a === void 0 ? void 0 : _a.headers)) {
          context.input = new Request(context.input);
          Object.keys(tracingHeaders).forEach(function (key) {
            context.input.headers.append(key, tracingHeaders[key]);
          });
        } else {
          context.init = shallowClone(context.init);
          var headers_1 = [];
          if (context.init.headers instanceof Headers) {
            context.init.headers.forEach(function (value, key) {
              headers_1.push([key, value]);
            });
          } else if (Array.isArray(context.init.headers)) {
            context.init.headers.forEach(function (header) {
              headers_1.push(header);
            });
          } else if (context.init.headers) {
            Object.keys(context.init.headers).forEach(function (key) {
              headers_1.push([key, context.init.headers[key]]);
            });
          }
          context.init.headers = headers_1.concat(objectEntries(tracingHeaders));
        }
      });
    },
    traceXhr: function (context, xhr) {
      return injectHeadersIfTracingAllowed(configuration, context, sessionManager, function (tracingHeaders) {
        Object.keys(tracingHeaders).forEach(function (name) {
          xhr.setRequestHeader(name, tracingHeaders[name]);
        });
      });
    }
  };
}
function injectHeadersIfTracingAllowed(configuration, context, sessionManager, inject) {
  if (!isTracingSupported() || !sessionManager.findTrackedSession()) {
    return;
  }
  var tracingOption = find(configuration.allowedTracingUrls, function (tracingOption) {
    return matchList([tracingOption.match], context.url, true);
  });
  if (!tracingOption) {
    return;
  }
  context.traceSampled = !isNumber(configuration.traceSampleRate) || performDraw(configuration.traceSampleRate);
  if (!context.traceSampled && configuration.traceContextInjection !== TraceContextInjection.ALL) {
    return;
  }
  context.traceId = new TraceIdentifier();
  context.spanId = new TraceIdentifier();
  inject(makeTracingHeaders(context.traceId, context.spanId, context.traceSampled, tracingOption.propagatorTypes));
}
function isTracingSupported() {
  return getCrypto() !== undefined;
}
function getCrypto() {
  return window.crypto || window.msCrypto;
}
/**
 * When trace is not sampled, set priority to '0' instead of not adding the tracing headers
 * to prepare the implementation for sampling delegation.
 */
function makeTracingHeaders(traceId, spanId, traceSampled, propagatorTypes) {
  var tracingHeaders = {};
  propagatorTypes.forEach(function (propagatorType) {
    switch (propagatorType) {
      case 'datadog':
        {
          assign(tracingHeaders, {
            'x-datadog-origin': 'rum',
            'x-datadog-parent-id': spanId.toDecimalString(),
            'x-datadog-sampling-priority': traceSampled ? '1' : '0',
            'x-datadog-trace-id': traceId.toDecimalString()
          });
          break;
        }
      // https://www.w3.org/TR/trace-context/
      case 'tracecontext':
        {
          assign(tracingHeaders, {
            traceparent: "00-0000000000000000".concat(traceId.toPaddedHexadecimalString(), "-").concat(spanId.toPaddedHexadecimalString(), "-0").concat(traceSampled ? '1' : '0')
          });
          break;
        }
      // https://github.com/openzipkin/b3-propagation
      case 'b3':
        {
          assign(tracingHeaders, {
            b3: "".concat(traceId.toPaddedHexadecimalString(), "-").concat(spanId.toPaddedHexadecimalString(), "-").concat(traceSampled ? '1' : '0')
          });
          break;
        }
      case 'b3multi':
        {
          assign(tracingHeaders, {
            'X-B3-TraceId': traceId.toPaddedHexadecimalString(),
            'X-B3-SpanId': spanId.toPaddedHexadecimalString(),
            'X-B3-Sampled': traceSampled ? '1' : '0'
          });
          break;
        }
    }
  });
  return tracingHeaders;
}
/* eslint-disable no-bitwise */
var TraceIdentifier = /** @class */function () {
  function TraceIdentifier() {
    this.buffer = new Uint8Array(8);
    getCrypto().getRandomValues(this.buffer);
    this.buffer[0] = this.buffer[0] & 0x7f; // force 63-bit
  }
  TraceIdentifier.prototype.toString = function (radix) {
    var high = this.readInt32(0);
    var low = this.readInt32(4);
    var str = '';
    do {
      var mod = high % radix * 4294967296 + low;
      high = Math.floor(high / radix);
      low = Math.floor(mod / radix);
      str = (mod % radix).toString(radix) + str;
    } while (high || low);
    return str;
  };
  /**
   * Format used everywhere except the trace intake
   */
  TraceIdentifier.prototype.toDecimalString = function () {
    return this.toString(10);
  };
  /**
   * Format used by OTel headers
   */
  TraceIdentifier.prototype.toPaddedHexadecimalString = function () {
    var traceId = this.toString(16);
    return Array(17 - traceId.length).join('0') + traceId;
  };
  TraceIdentifier.prototype.readInt32 = function (offset) {
    return this.buffer[offset] * 16777216 + (this.buffer[offset + 1] << 16) + (this.buffer[offset + 2] << 8) + this.buffer[offset + 3];
  };
  return TraceIdentifier;
}();
/* eslint-enable no-bitwise */

var DEFAULT_PROPAGATOR_TYPES = ['tracecontext', 'datadog'];
function validateAndBuildRumConfiguration(initConfiguration) {
  var _a, _b;
  if (!initConfiguration.applicationId) {
    display.error('Application ID is not configured, no RUM data will be collected.');
    return;
  }
  if (initConfiguration.sessionReplaySampleRate !== undefined && !isPercentage(initConfiguration.sessionReplaySampleRate)) {
    display.error('Session Replay Sample Rate should be a number between 0 and 100');
    return;
  }
  if (initConfiguration.traceSampleRate !== undefined && !isPercentage(initConfiguration.traceSampleRate)) {
    display.error('Trace Sample Rate should be a number between 0 and 100');
    return;
  }
  if (initConfiguration.excludedActivityUrls !== undefined && !Array.isArray(initConfiguration.excludedActivityUrls)) {
    display.error('Excluded Activity Urls should be an array');
    return;
  }
  var allowedTracingUrls = validateAndBuildTracingOptions(initConfiguration);
  if (!allowedTracingUrls) {
    return;
  }
  var baseConfiguration = validateAndBuildConfiguration(initConfiguration);
  if (!baseConfiguration) {
    return;
  }
  return assign({
    applicationId: initConfiguration.applicationId,
    version: initConfiguration.version || undefined,
    actionNameAttribute: initConfiguration.actionNameAttribute,
    sessionReplaySampleRate: (_a = initConfiguration.sessionReplaySampleRate) !== null && _a !== void 0 ? _a : 0,
    startSessionReplayRecordingManually: !!initConfiguration.startSessionReplayRecordingManually,
    traceSampleRate: initConfiguration.traceSampleRate,
    allowedTracingUrls: allowedTracingUrls,
    excludedActivityUrls: (_b = initConfiguration.excludedActivityUrls) !== null && _b !== void 0 ? _b : [],
    workerUrl: initConfiguration.workerUrl,
    compressIntakeRequests: !!initConfiguration.compressIntakeRequests,
    trackUserInteractions: !!initConfiguration.trackUserInteractions,
    trackViewsManually: !!initConfiguration.trackViewsManually,
    trackResources: !!initConfiguration.trackResources,
    trackLongTasks: !!initConfiguration.trackLongTasks,
    subdomain: initConfiguration.subdomain,
    defaultPrivacyLevel: objectHasValue(DefaultPrivacyLevel, initConfiguration.defaultPrivacyLevel) ? initConfiguration.defaultPrivacyLevel : DefaultPrivacyLevel.MASK,
    enablePrivacyForActionName: !!initConfiguration.enablePrivacyForActionName,
    customerDataTelemetrySampleRate: 1,
    traceContextInjection: objectHasValue(TraceContextInjection, initConfiguration.traceContextInjection) ? initConfiguration.traceContextInjection : TraceContextInjection.ALL,
    plugins: isExperimentalFeatureEnabled(ExperimentalFeature.PLUGINS) && initConfiguration.plugins || []
  }, baseConfiguration);
}
/**
 * Validates allowedTracingUrls and converts match options to tracing options
 */
function validateAndBuildTracingOptions(initConfiguration) {
  if (initConfiguration.allowedTracingUrls !== undefined) {
    if (!Array.isArray(initConfiguration.allowedTracingUrls)) {
      display.error('Allowed Tracing URLs should be an array');
      return;
    }
    if (initConfiguration.allowedTracingUrls.length !== 0 && initConfiguration.service === undefined) {
      display.error('Service needs to be configured when tracing is enabled');
      return;
    }
    // Convert from (MatchOption | TracingOption) to TracingOption, remove unknown properties
    var tracingOptions_1 = [];
    initConfiguration.allowedTracingUrls.forEach(function (option) {
      if (isMatchOption(option)) {
        tracingOptions_1.push({
          match: option,
          propagatorTypes: DEFAULT_PROPAGATOR_TYPES
        });
      } else if (isTracingOption(option)) {
        tracingOptions_1.push(option);
      } else {
        display.warn('Allowed Tracing Urls parameters should be a string, RegExp, function, or an object. Ignoring parameter', option);
      }
    });
    return tracingOptions_1;
  }
  return [];
}
/**
 * Combines the selected tracing propagators from the different options in allowedTracingUrls
 */
function getSelectedTracingPropagators(configuration) {
  var usedTracingPropagators = new Set();
  if (Array.isArray(configuration.allowedTracingUrls) && configuration.allowedTracingUrls.length > 0) {
    configuration.allowedTracingUrls.forEach(function (option) {
      if (isMatchOption(option)) {
        DEFAULT_PROPAGATOR_TYPES.forEach(function (propagatorType) {
          return usedTracingPropagators.add(propagatorType);
        });
      } else if (getType(option) === 'object' && Array.isArray(option.propagatorTypes)) {
        // Ensure we have an array, as we cannot rely on types yet (configuration is provided by users)
        option.propagatorTypes.forEach(function (propagatorType) {
          return usedTracingPropagators.add(propagatorType);
        });
      }
    });
  }
  return arrayFrom(usedTracingPropagators);
}
function serializeRumConfiguration(configuration) {
  var _a;
  var baseSerializedConfiguration = serializeConfiguration(configuration);
  return assign({
    session_replay_sample_rate: configuration.sessionReplaySampleRate,
    start_session_replay_recording_manually: configuration.startSessionReplayRecordingManually,
    trace_sample_rate: configuration.traceSampleRate,
    trace_context_injection: configuration.traceContextInjection,
    action_name_attribute: configuration.actionNameAttribute,
    use_allowed_tracing_urls: Array.isArray(configuration.allowedTracingUrls) && configuration.allowedTracingUrls.length > 0,
    selected_tracing_propagators: getSelectedTracingPropagators(configuration),
    default_privacy_level: configuration.defaultPrivacyLevel,
    enable_privacy_for_action_name: configuration.enablePrivacyForActionName,
    use_excluded_activity_urls: Array.isArray(configuration.excludedActivityUrls) && configuration.excludedActivityUrls.length > 0,
    use_worker_url: !!configuration.workerUrl,
    compress_intake_requests: configuration.compressIntakeRequests,
    track_views_manually: configuration.trackViewsManually,
    track_user_interactions: configuration.trackUserInteractions,
    track_resources: configuration.trackResources,
    track_long_task: configuration.trackLongTasks,
    plugins: (_a = configuration.plugins) === null || _a === void 0 ? void 0 : _a.map(function (plugin) {
      var _a;
      return assign({
        name: plugin.name
      }, (_a = plugin.getConfigurationTelemetry) === null || _a === void 0 ? void 0 : _a.call(plugin));
    })
  }, baseSerializedConfiguration);
}

var REMOTE_CONFIGURATION_URL = 'https://d3uc069fcn7uxw.cloudfront.net/configuration';
function fetchAndApplyRemoteConfiguration(initConfiguration, callback) {
  fetchRemoteConfiguration(initConfiguration, function (remoteInitConfiguration) {
    callback(applyRemoteConfiguration(initConfiguration, remoteInitConfiguration));
  });
}
function applyRemoteConfiguration(initConfiguration, remoteInitConfiguration) {
  return assign({}, initConfiguration, remoteInitConfiguration);
}
function fetchRemoteConfiguration(configuration, callback) {
  var xhr = new XMLHttpRequest();
  addEventListener(configuration, xhr, 'load', function () {
    if (xhr.status === 200) {
      callback(JSON.parse(xhr.responseText));
    } else {
      displayRemoteConfigurationFetchingError();
    }
  });
  addEventListener(configuration, xhr, 'error', function () {
    displayRemoteConfigurationFetchingError();
  });
  xhr.open('GET', "".concat(REMOTE_CONFIGURATION_URL, "/").concat(encodeURIComponent(configuration.remoteConfigurationId), ".json"));
  xhr.send();
}
function displayRemoteConfigurationFetchingError() {
  display.error('Error fetching the remote configuration.');
}

function startVitalCollection(lifeCycle, pageStateHistory) {
  function isValid(vital) {
    return !pageStateHistory.wasInPageStateDuringPeriod("frozen" /* PageState.FROZEN */, vital.startClocks.relative, vital.duration);
  }
  function addDurationVital(vital) {
    if (isValid(vital)) {
      lifeCycle.notify(12 /* LifeCycleEventType.RAW_RUM_EVENT_COLLECTED */, processVital(vital, true));
    }
  }
  return {
    addDurationVital: addDurationVital,
    startDurationVital: function (startVital) {
      return createVitalInstance(function (vital) {
        addDurationVital(vital);
      }, startVital);
    }
  };
}
function createVitalInstance(stopCallback, vitalStart) {
  var startClocks = clocksNow();
  var stopClocks;
  return {
    stop: function (vitalStop) {
      if (stopClocks) {
        return;
      }
      stopClocks = clocksNow();
      stopCallback(buildDurationVital(vitalStart, startClocks, vitalStop, stopClocks));
    }
  };
}
function buildDurationVital(vitalStart, startClocks, vitalStop, stopClocks) {
  var _a;
  if (vitalStop === void 0) {
    vitalStop = {};
  }
  return {
    name: vitalStart.name,
    type: "duration" /* VitalType.DURATION */,
    startClocks: startClocks,
    duration: elapsed(startClocks.timeStamp, stopClocks.timeStamp),
    context: combine(vitalStart.context, vitalStop.context),
    details: (_a = vitalStop.details) !== null && _a !== void 0 ? _a : vitalStart.details
  };
}
function processVital(vital, valueComputedBySdk) {
  var rawRumEvent = {
    date: vital.startClocks.timeStamp,
    vital: {
      id: generateUUID(),
      type: vital.type,
      name: vital.name,
      duration: toServerDuration(vital.duration),
      details: vital.details
    },
    type: "vital" /* RumEventType.VITAL */
  };
  if (valueComputedBySdk) {
    rawRumEvent._dd = {
      vital: {
        computed_value: true
      }
    };
  }
  return {
    rawRumEvent: rawRumEvent,
    startTime: vital.startClocks.relative,
    customerContext: vital.context,
    domainContext: {}
  };
}

function callPluginsMethod(plugins, methodName, parameter) {
  if (!plugins) {
    return;
  }
  for (var _i = 0, plugins_1 = plugins; _i < plugins_1.length; _i++) {
    var plugin = plugins_1[_i];
    var method = plugin[methodName];
    if (method) {
      method(parameter);
    }
  }
}

function createPreStartStrategy(_a, getCommonContext, trackingConsentState, doStartRum) {
  var ignoreInitIfSyntheticsWillInjectRum = _a.ignoreInitIfSyntheticsWillInjectRum,
    startDeflateWorker = _a.startDeflateWorker;
  var bufferApiCalls = new BoundedBuffer();
  var firstStartViewCall;
  var deflateWorker;
  var cachedInitConfiguration;
  var cachedConfiguration;
  var trackingConsentStateSubscription = trackingConsentState.observable.subscribe(tryStartRum);
  function tryStartRum() {
    if (!cachedInitConfiguration || !cachedConfiguration || !trackingConsentState.isGranted()) {
      return;
    }
    trackingConsentStateSubscription.unsubscribe();
    var initialViewOptions;
    if (cachedConfiguration.trackViewsManually) {
      if (!firstStartViewCall) {
        return;
      }
      // An initial view is always created when starting RUM.
      // When tracking views automatically, any startView call before RUM start creates an extra
      // view.
      // When tracking views manually, we use the ViewOptions from the first startView call as the
      // initial view options, and we remove the actual startView call so we don't create an extra
      // view.
      bufferApiCalls.remove(firstStartViewCall.callback);
      initialViewOptions = firstStartViewCall.options;
    }
    var startRumResult = doStartRum(cachedConfiguration, deflateWorker, initialViewOptions);
    bufferApiCalls.drain(startRumResult);
  }
  function doInit(initConfiguration) {
    var eventBridgeAvailable = canUseEventBridge();
    if (eventBridgeAvailable) {
      initConfiguration = overrideInitConfigurationForBridge(initConfiguration);
    }
    // Update the exposed initConfiguration to reflect the bridge and remote configuration overrides
    cachedInitConfiguration = initConfiguration;
    addTelemetryConfiguration(serializeRumConfiguration(initConfiguration));
    if (cachedConfiguration) {
      displayAlreadyInitializedError('DD_RUM', initConfiguration);
      return;
    }
    var configuration = validateAndBuildRumConfiguration(initConfiguration);
    if (!configuration) {
      return;
    }
    if (!eventBridgeAvailable && !configuration.sessionStoreStrategyType) {
      display.warn('No storage available for session. We will not send any data.');
      return;
    }
    if (configuration.compressIntakeRequests && !eventBridgeAvailable && startDeflateWorker) {
      deflateWorker = startDeflateWorker(configuration, 'Datadog RUM',
      // Worker initialization can fail asynchronously, especially in Firefox where even CSP
      // issues are reported asynchronously. For now, the SDK will continue its execution even if
      // data won't be sent to Datadog. We could improve this behavior in the future.
      noop$1);
      if (!deflateWorker) {
        // `startDeflateWorker` should have logged an error message explaining the issue
        return;
      }
    }
    cachedConfiguration = configuration;
    // Instrumuent fetch to track network requests
    // This is needed in case the consent is not granted and some cutsomer
    // library (Apollo Client) is storing uninstrumented fetch to be used later
    // The subscrption is needed so that the instrumentation process is completed
    initFetchObservable().subscribe(noop$1);
    trackingConsentState.tryToInit(configuration.trackingConsent);
    tryStartRum();
  }
  var addDurationVital = function (vital) {
    bufferApiCalls.add(function (startRumResult) {
      return startRumResult.addDurationVital(vital);
    });
  };
  return {
    init: function (initConfiguration, publicApi) {
      if (!initConfiguration) {
        display.error('Missing configuration');
        return;
      }
      // Set the experimental feature flags as early as possible, so we can use them in most places
      initFeatureFlags(initConfiguration.enableExperimentalFeatures);
      // Expose the initial configuration regardless of initialization success.
      cachedInitConfiguration = initConfiguration;
      // If we are in a Synthetics test configured to automatically inject a RUM instance, we want
      // to completely discard the customer application RUM instance by ignoring their init() call.
      // But, we should not ignore the init() call from the Synthetics-injected RUM instance, so the
      // internal `ignoreInitIfSyntheticsWillInjectRum` option is here to bypass this condition.
      if (ignoreInitIfSyntheticsWillInjectRum && willSyntheticsInjectRum()) {
        return;
      }
      if (isExperimentalFeatureEnabled(ExperimentalFeature.PLUGINS)) {
        callPluginsMethod(initConfiguration.plugins, 'onInit', {
          initConfiguration: initConfiguration,
          publicApi: publicApi
        });
      }
      if (initConfiguration.remoteConfigurationId && isExperimentalFeatureEnabled(ExperimentalFeature.REMOTE_CONFIGURATION)) {
        fetchAndApplyRemoteConfiguration(initConfiguration, doInit);
      } else {
        doInit(initConfiguration);
      }
    },
    get initConfiguration() {
      return cachedInitConfiguration;
    },
    getInternalContext: noop$1,
    stopSession: noop$1,
    addTiming: function (name, time) {
      if (time === void 0) {
        time = timeStampNow();
      }
      bufferApiCalls.add(function (startRumResult) {
        return startRumResult.addTiming(name, time);
      });
    },
    startView: function (options, startClocks) {
      if (startClocks === void 0) {
        startClocks = clocksNow();
      }
      var callback = function (startRumResult) {
        startRumResult.startView(options, startClocks);
      };
      bufferApiCalls.add(callback);
      if (!firstStartViewCall) {
        firstStartViewCall = {
          options: options,
          callback: callback
        };
        tryStartRum();
      }
    },
    updateViewName: function (name) {
      bufferApiCalls.add(function (startRumResult) {
        return startRumResult.updateViewName(name);
      });
    },
    addAction: function (action, commonContext) {
      if (commonContext === void 0) {
        commonContext = getCommonContext();
      }
      bufferApiCalls.add(function (startRumResult) {
        return startRumResult.addAction(action, commonContext);
      });
    },
    addError: function (providedError, commonContext) {
      if (commonContext === void 0) {
        commonContext = getCommonContext();
      }
      bufferApiCalls.add(function (startRumResult) {
        return startRumResult.addError(providedError, commonContext);
      });
    },
    addFeatureFlagEvaluation: function (key, value) {
      bufferApiCalls.add(function (startRumResult) {
        return startRumResult.addFeatureFlagEvaluation(key, value);
      });
    },
    startDurationVital: function (vitalStart) {
      return createVitalInstance(function (vital) {
        return addDurationVital(vital);
      }, vitalStart);
    },
    addDurationVital: addDurationVital
  };
}
function overrideInitConfigurationForBridge(initConfiguration) {
  var _a, _b;
  return assign({}, initConfiguration, {
    applicationId: '00000000-aaaa-0000-aaaa-000000000000',
    clientToken: 'empty',
    sessionSampleRate: 100,
    defaultPrivacyLevel: (_a = initConfiguration.defaultPrivacyLevel) !== null && _a !== void 0 ? _a : (_b = getEventBridge()) === null || _b === void 0 ? void 0 : _b.getPrivacyLevel()
  });
}

var RUM_STORAGE_KEY = 'rum';
function makeRumPublicApi(startRumImpl, recorderApi, options) {
  if (options === void 0) {
    options = {};
  }
  var customerDataTrackerManager = createCustomerDataTrackerManager(0 /* CustomerDataCompressionStatus.Unknown */);
  var globalContextManager = createContextManager(customerDataTrackerManager.getOrCreateTracker(2 /* CustomerDataType.GlobalContext */));
  var userContextManager = createContextManager(customerDataTrackerManager.getOrCreateTracker(1 /* CustomerDataType.User */));
  var trackingConsentState = createTrackingConsentState();
  function getCommonContext() {
    return buildCommonContext(globalContextManager, userContextManager, recorderApi);
  }
  var strategy = createPreStartStrategy(options, getCommonContext, trackingConsentState, function (configuration, deflateWorker, initialViewOptions) {
    if (isExperimentalFeatureEnabled(ExperimentalFeature.CUSTOM_VITALS)) {
      rumPublicApi.startDurationVital = monitor(function (name, options) {
        addTelemetryUsage({
          feature: 'start-duration-vital'
        });
        return strategy.startDurationVital({
          name: sanitize(name),
          context: sanitize(options === null || options === void 0 ? void 0 : options.context),
          details: sanitize(options === null || options === void 0 ? void 0 : options.details)
        });
      });
      rumPublicApi.addDurationVital = monitor(function (name, options) {
        addTelemetryUsage({
          feature: 'add-duration-vital'
        });
        strategy.addDurationVital({
          name: sanitize(name),
          type: "duration" /* VitalType.DURATION */,
          startClocks: timeStampToClocks(options.startTime),
          duration: options.duration,
          context: sanitize(options === null || options === void 0 ? void 0 : options.context),
          details: sanitize(options === null || options === void 0 ? void 0 : options.details)
        });
      });
      rumPublicApi.stopDurationVital = noop$1;
    }
    if (isExperimentalFeatureEnabled(ExperimentalFeature.UPDATE_VIEW_NAME)) {
      rumPublicApi.updateViewName = monitor(function (name) {
        strategy.updateViewName(name);
      });
    }
    if (configuration.storeContextsAcrossPages) {
      storeContextManager(configuration, globalContextManager, RUM_STORAGE_KEY, 2 /* CustomerDataType.GlobalContext */);
      storeContextManager(configuration, userContextManager, RUM_STORAGE_KEY, 1 /* CustomerDataType.User */);
    }
    customerDataTrackerManager.setCompressionStatus(deflateWorker ? 1 /* CustomerDataCompressionStatus.Enabled */ : 2 /* CustomerDataCompressionStatus.Disabled */);
    var startRumResult = startRumImpl(configuration, recorderApi, customerDataTrackerManager, getCommonContext, initialViewOptions, deflateWorker && options.createDeflateEncoder ? function (streamId) {
      return options.createDeflateEncoder(configuration, deflateWorker, streamId);
    } : createIdentityEncoder, trackingConsentState);
    recorderApi.onRumStart(startRumResult.lifeCycle, configuration, startRumResult.session, startRumResult.viewContexts, deflateWorker);
    strategy = createPostStartStrategy(strategy, startRumResult);
    return startRumResult;
  });
  var startView = monitor(function (options) {
    var sanitizedOptions = typeof options === 'object' ? options : {
      name: options
    };
    strategy.startView(sanitizedOptions);
    addTelemetryUsage({
      feature: 'start-view'
    });
  });
  var rumPublicApi = makePublicApi({
    init: monitor(function (initConfiguration) {
      return strategy.init(initConfiguration, rumPublicApi);
    }),
    setTrackingConsent: monitor(function (trackingConsent) {
      trackingConsentState.update(trackingConsent);
      addTelemetryUsage({
        feature: 'set-tracking-consent',
        tracking_consent: trackingConsent
      });
    }),
    setGlobalContext: monitor(function (context) {
      globalContextManager.setContext(context);
      addTelemetryUsage({
        feature: 'set-global-context'
      });
    }),
    getGlobalContext: monitor(function () {
      return globalContextManager.getContext();
    }),
    setGlobalContextProperty: monitor(function (key, value) {
      globalContextManager.setContextProperty(key, value);
      addTelemetryUsage({
        feature: 'set-global-context'
      });
    }),
    removeGlobalContextProperty: monitor(function (key) {
      return globalContextManager.removeContextProperty(key);
    }),
    clearGlobalContext: monitor(function () {
      return globalContextManager.clearContext();
    }),
    getInternalContext: monitor(function (startTime) {
      return strategy.getInternalContext(startTime);
    }),
    getInitConfiguration: monitor(function () {
      return deepClone(strategy.initConfiguration);
    }),
    addAction: function (name, context) {
      var handlingStack = createHandlingStack();
      callMonitored(function () {
        strategy.addAction({
          name: sanitize(name),
          context: sanitize(context),
          startClocks: clocksNow(),
          type: "custom" /* ActionType.CUSTOM */,
          handlingStack: handlingStack
        });
        addTelemetryUsage({
          feature: 'add-action'
        });
      });
    },
    addError: function (error, context) {
      var handlingStack = createHandlingStack();
      callMonitored(function () {
        strategy.addError({
          error: error,
          // Do not sanitize error here, it is needed unserialized by computeRawError()
          handlingStack: handlingStack,
          context: sanitize(context),
          startClocks: clocksNow()
        });
        addTelemetryUsage({
          feature: 'add-error'
        });
      });
    },
    addTiming: monitor(function (name, time) {
      // TODO: next major decide to drop relative time support or update its behaviour
      strategy.addTiming(sanitize(name), time);
    }),
    setUser: monitor(function (newUser) {
      if (checkUser(newUser)) {
        userContextManager.setContext(sanitizeUser(newUser));
      }
      addTelemetryUsage({
        feature: 'set-user'
      });
    }),
    getUser: monitor(function () {
      return userContextManager.getContext();
    }),
    setUserProperty: monitor(function (key, property) {
      var _a;
      var sanitizedProperty = sanitizeUser((_a = {}, _a[key] = property, _a))[key];
      userContextManager.setContextProperty(key, sanitizedProperty);
      addTelemetryUsage({
        feature: 'set-user'
      });
    }),
    removeUserProperty: monitor(function (key) {
      return userContextManager.removeContextProperty(key);
    }),
    clearUser: monitor(function () {
      return userContextManager.clearContext();
    }),
    startView: startView,
    stopSession: monitor(function () {
      strategy.stopSession();
      addTelemetryUsage({
        feature: 'stop-session'
      });
    }),
    addFeatureFlagEvaluation: monitor(function (key, value) {
      strategy.addFeatureFlagEvaluation(sanitize(key), sanitize(value));
      addTelemetryUsage({
        feature: 'add-feature-flag-evaluation'
      });
    }),
    getSessionReplayLink: monitor(function () {
      return recorderApi.getSessionReplayLink();
    }),
    startSessionReplayRecording: monitor(function (options) {
      recorderApi.start(options);
      addTelemetryUsage({
        feature: 'start-session-replay-recording',
        force: options === null || options === void 0 ? void 0 : options.force
      });
    }),
    stopSessionReplayRecording: monitor(function () {
      return recorderApi.stop();
    })
  });
  return rumPublicApi;
}
function createPostStartStrategy(preStartStrategy, startRumResult) {
  return assign({
    init: function (initConfiguration) {
      displayAlreadyInitializedError('DD_RUM', initConfiguration);
    },
    initConfiguration: preStartStrategy.initConfiguration
  }, startRumResult);
}

function createDOMMutationObservable() {
  var MutationObserver = getMutationObserverConstructor();
  return new Observable(function (observable) {
    if (!MutationObserver) {
      return;
    }
    var observer = new MutationObserver(monitor(function () {
      return observable.notify();
    }));
    observer.observe(document, {
      attributes: true,
      characterData: true,
      childList: true,
      subtree: true
    });
    return function () {
      return observer.disconnect();
    };
  });
}
function getMutationObserverConstructor() {
  var constructor;
  var browserWindow = window;
  // Angular uses Zone.js to provide a context persisting across async tasks.  Zone.js replaces the
  // global MutationObserver constructor with a patched version to support the context propagation.
  // There is an ongoing issue[1][2] with this setup when using a MutationObserver within a Angular
  // component: on some occasions, the callback is being called in an infinite loop, causing the
  // page to freeze (even if the callback is completely empty).
  //
  // To work around this issue, we try to get the original MutationObserver constructor stored by
  // Zone.js.
  //
  // [1] https://github.com/angular/angular/issues/26948
  // [2] https://github.com/angular/angular/issues/31712
  if (browserWindow.Zone) {
    // Zone.js 0.8.6+ is storing original class constructors into the browser 'window' object[3].
    //
    // [3] https://github.com/angular/angular/blob/6375fa79875c0fe7b815efc45940a6e6f5c9c9eb/packages/zone.js/lib/common/utils.ts#L288
    constructor = getZoneJsOriginalValue(browserWindow, 'MutationObserver');
    if (browserWindow.MutationObserver && constructor === browserWindow.MutationObserver) {
      // Anterior Zone.js versions (used in Angular 2) does not expose the original MutationObserver
      // in the 'window' object. Luckily, the patched MutationObserver class is storing an original
      // instance in its properties[4]. Let's get the original MutationObserver constructor from
      // there.
      //
      // [4] https://github.com/angular/zone.js/blob/v0.8.5/lib/common/utils.ts#L412
      var patchedInstance = new browserWindow.MutationObserver(noop$1);
      var originalInstance = getZoneJsOriginalValue(patchedInstance, 'originalInstance');
      constructor = originalInstance && originalInstance.constructor;
    }
  }
  if (!constructor) {
    constructor = browserWindow.MutationObserver;
  }
  return constructor;
}

var FAKE_INITIAL_DOCUMENT = 'initial_document';
var RESOURCE_TYPES = [["document" /* ResourceType.DOCUMENT */, function (initiatorType) {
  return FAKE_INITIAL_DOCUMENT === initiatorType;
}], ["xhr" /* ResourceType.XHR */, function (initiatorType) {
  return 'xmlhttprequest' === initiatorType;
}], ["fetch" /* ResourceType.FETCH */, function (initiatorType) {
  return 'fetch' === initiatorType;
}], ["beacon" /* ResourceType.BEACON */, function (initiatorType) {
  return 'beacon' === initiatorType;
}], ["css" /* ResourceType.CSS */, function (_, path) {
  return /\.css$/i.test(path);
}], ["js" /* ResourceType.JS */, function (_, path) {
  return /\.js$/i.test(path);
}], ["image" /* ResourceType.IMAGE */, function (initiatorType, path) {
  return includes(['image', 'img', 'icon'], initiatorType) || /\.(gif|jpg|jpeg|tiff|png|svg|ico)$/i.exec(path) !== null;
}], ["font" /* ResourceType.FONT */, function (_, path) {
  return /\.(woff|eot|woff2|ttf)$/i.exec(path) !== null;
}], ["media" /* ResourceType.MEDIA */, function (initiatorType, path) {
  return includes(['audio', 'video'], initiatorType) || /\.(mp3|mp4)$/i.exec(path) !== null;
}]];
function computeResourceKind(timing) {
  var url = timing.name;
  if (!isValidUrl(url)) {
    addTelemetryDebug("Failed to construct URL for \"".concat(timing.name, "\""));
    return "other" /* ResourceType.OTHER */;
  }
  var path = getPathName(url);
  for (var _i = 0, RESOURCE_TYPES_1 = RESOURCE_TYPES; _i < RESOURCE_TYPES_1.length; _i++) {
    var _a = RESOURCE_TYPES_1[_i],
      type = _a[0],
      isType = _a[1];
    if (isType(timing.initiatorType, path)) {
      return type;
    }
  }
  return "other" /* ResourceType.OTHER */;
}
function areInOrder() {
  var numbers = [];
  for (var _i = 0; _i < arguments.length; _i++) {
    numbers[_i] = arguments[_i];
  }
  for (var i = 1; i < numbers.length; i += 1) {
    if (numbers[i - 1] > numbers[i]) {
      return false;
    }
  }
  return true;
}
function isRequestKind(timing) {
  return timing.initiatorType === 'xmlhttprequest' || timing.initiatorType === 'fetch';
}
function computePerformanceResourceDuration(entry) {
  var duration = entry.duration,
    startTime = entry.startTime,
    responseEnd = entry.responseEnd;
  // Safari duration is always 0 on timings blocked by cross origin policies.
  if (duration === 0 && startTime < responseEnd) {
    return toServerDuration(elapsed(startTime, responseEnd));
  }
  return toServerDuration(duration);
}
function computePerformanceResourceDetails(entry) {
  if (!isValidEntry(entry)) {
    return undefined;
  }
  var startTime = entry.startTime,
    fetchStart = entry.fetchStart,
    redirectStart = entry.redirectStart,
    redirectEnd = entry.redirectEnd,
    domainLookupStart = entry.domainLookupStart,
    domainLookupEnd = entry.domainLookupEnd,
    connectStart = entry.connectStart,
    secureConnectionStart = entry.secureConnectionStart,
    connectEnd = entry.connectEnd,
    requestStart = entry.requestStart,
    responseStart = entry.responseStart,
    responseEnd = entry.responseEnd;
  var details = {
    download: formatTiming(startTime, responseStart, responseEnd),
    first_byte: formatTiming(startTime, requestStart, responseStart)
  };
  // Make sure a connection occurred
  if (fetchStart < connectEnd) {
    details.connect = formatTiming(startTime, connectStart, connectEnd);
    // Make sure a secure connection occurred
    if (connectStart <= secureConnectionStart && secureConnectionStart <= connectEnd) {
      details.ssl = formatTiming(startTime, secureConnectionStart, connectEnd);
    }
  }
  // Make sure a domain lookup occurred
  if (fetchStart < domainLookupEnd) {
    details.dns = formatTiming(startTime, domainLookupStart, domainLookupEnd);
  }
  // Make sure a redirection occurred
  if (startTime < redirectEnd) {
    details.redirect = formatTiming(startTime, redirectStart, redirectEnd);
  }
  return details;
}
function isValidEntry(entry) {
  if (isExperimentalFeatureEnabled(ExperimentalFeature.TOLERANT_RESOURCE_TIMINGS)) {
    return true;
  }
  // Ensure timings are in the right order. On top of filtering out potential invalid
  // RumPerformanceResourceTiming, it will ignore entries from requests where timings cannot be
  // collected, for example cross origin requests without a "Timing-Allow-Origin" header allowing
  // it.
  var areCommonTimingsInOrder = areInOrder(entry.startTime, entry.fetchStart, entry.domainLookupStart, entry.domainLookupEnd, entry.connectStart, entry.connectEnd, entry.requestStart, entry.responseStart, entry.responseEnd);
  var areRedirectionTimingsInOrder = hasRedirection(entry) ? areInOrder(entry.startTime, entry.redirectStart, entry.redirectEnd, entry.fetchStart) : true;
  return areCommonTimingsInOrder && areRedirectionTimingsInOrder;
}
function hasRedirection(entry) {
  return entry.redirectEnd > entry.startTime;
}
function formatTiming(origin, start, end) {
  if (origin <= start && start <= end) {
    return {
      duration: toServerDuration(elapsed(start, end)),
      start: toServerDuration(elapsed(origin, start))
    };
  }
}
function computeSize(entry) {
  // Make sure a request actually occurred
  if (entry.startTime < entry.responseStart) {
    var encodedBodySize = entry.encodedBodySize,
      decodedBodySize = entry.decodedBodySize,
      transferSize = entry.transferSize;
    return {
      size: decodedBodySize,
      encoded_body_size: encodedBodySize,
      decoded_body_size: decodedBodySize,
      transfer_size: transferSize
    };
  }
  return {
    size: undefined,
    encoded_body_size: undefined,
    decoded_body_size: undefined,
    transfer_size: undefined
  };
}
function isAllowedRequestUrl(configuration, url) {
  return url && !configuration.isIntakeUrl(url);
}
var DATA_URL_REGEX = /data:(.+)?(;base64)?,/g;
var MAX_ATTRIBUTE_VALUE_CHAR_LENGTH = 24000;
function isLongDataUrl(url) {
  if (url.length <= MAX_ATTRIBUTE_VALUE_CHAR_LENGTH) {
    return false;
  } else if (url.substring(0, 5) === 'data:') {
    // Avoid String.match RangeError: Maximum call stack size exceeded
    url = url.substring(0, MAX_ATTRIBUTE_VALUE_CHAR_LENGTH);
    return true;
  }
  return false;
}
function sanitizeDataUrl(url) {
  return "".concat(url.match(DATA_URL_REGEX)[0], "[...]");
}
function computeRelativePerformanceTiming() {
  var result = {};
  var timing = performance.timing;
  for (var key in timing) {
    if (isNumber(timing[key])) {
      var numberKey = key;
      var timingElement = timing[numberKey];
      result[numberKey] = timingElement === 0 ? 0 : getRelativeTime(timingElement);
    }
  }
  return result;
}

// We want to use a real enum (i.e. not a const enum) here, to be able to check whether an arbitrary
// string is an expected performance entry
// eslint-disable-next-line no-restricted-syntax
var RumPerformanceEntryType;
(function (RumPerformanceEntryType) {
  RumPerformanceEntryType["EVENT"] = "event";
  RumPerformanceEntryType["FIRST_INPUT"] = "first-input";
  RumPerformanceEntryType["LARGEST_CONTENTFUL_PAINT"] = "largest-contentful-paint";
  RumPerformanceEntryType["LAYOUT_SHIFT"] = "layout-shift";
  RumPerformanceEntryType["LONG_TASK"] = "longtask";
  RumPerformanceEntryType["NAVIGATION"] = "navigation";
  RumPerformanceEntryType["PAINT"] = "paint";
  RumPerformanceEntryType["RESOURCE"] = "resource";
})(RumPerformanceEntryType || (RumPerformanceEntryType = {}));
function createPerformanceObservable(configuration, options) {
  return new Observable(function (observable) {
    var observer;
    var timeoutId;
    if (window.PerformanceObserver) {
      var isObserverInitializing_1 = true;
      var handlePerformanceEntries_1 = function (entries) {
        var rumPerformanceEntries = filterRumPerformanceEntries(configuration, entries);
        if (rumPerformanceEntries.length > 0) {
          observable.notify(rumPerformanceEntries);
        }
      };
      observer = new PerformanceObserver(monitor(function (entries) {
        // In Safari the performance observer callback is synchronous.
        // Because the buffered performance entry list can be quite large we delay the computation to prevent the SDK from blocking the main thread on init
        if (isObserverInitializing_1) {
          timeoutId = setTimeout$1(function () {
            return handlePerformanceEntries_1(entries.getEntries());
          });
        } else {
          handlePerformanceEntries_1(entries.getEntries());
        }
      }));
      try {
        observer.observe(options);
      } catch (_a) {
        // Some old browser versions (<= chrome 74 ) don't support the PerformanceObserver type and buffered options
        // In these cases, fallback to getEntriesByType and PerformanceObserver with entryTypes
        // TODO: remove this fallback in the next major version
        var fallbackSupportedEntryTypes = [RumPerformanceEntryType.RESOURCE, RumPerformanceEntryType.NAVIGATION, RumPerformanceEntryType.LONG_TASK, RumPerformanceEntryType.PAINT];
        if (includes(fallbackSupportedEntryTypes, options.type)) {
          if (options.buffered) {
            timeoutId = setTimeout$1(function () {
              return handlePerformanceEntries_1(performance.getEntriesByType(options.type));
            });
          }
          observer.observe({
            entryTypes: [options.type]
          });
        }
      }
      isObserverInitializing_1 = false;
    }
    manageResourceTimingBufferFull(configuration);
    return function () {
      observer === null || observer === void 0 ? void 0 : observer.disconnect();
      if (timeoutId) {
        clearTimeout$1(timeoutId);
      }
    };
  });
}
var resourceTimingBufferFullListener;
function manageResourceTimingBufferFull(configuration) {
  if (!resourceTimingBufferFullListener && supportPerformanceObject$1() && 'addEventListener' in performance) {
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1559377
    resourceTimingBufferFullListener = addEventListener(configuration, performance, 'resourcetimingbufferfull', function () {
      performance.clearResourceTimings();
    });
  }
  return function () {
    resourceTimingBufferFullListener === null || resourceTimingBufferFullListener === void 0 ? void 0 : resourceTimingBufferFullListener.stop();
  };
}
function supportPerformanceObject$1() {
  return window.performance !== undefined && 'getEntries' in performance;
}
function supportPerformanceTimingEvent(entryType) {
  return window.PerformanceObserver && PerformanceObserver.supportedEntryTypes !== undefined && PerformanceObserver.supportedEntryTypes.includes(entryType);
}
function filterRumPerformanceEntries(configuration, entries) {
  return entries.filter(function (entry) {
    return isAllowedResource(configuration, entry);
  });
}
function isAllowedResource(configuration, entry) {
  return entry.entryType === RumPerformanceEntryType.RESOURCE && isAllowedRequestUrl(configuration, entry.name);
}

function supportPerformanceObject() {
  return window.performance !== undefined && 'getEntries' in performance;
}
function startPerformanceCollection(lifeCycle, configuration) {
  var cleanupTasks = [];
  if (supportPerformanceObject()) {
    var performanceEntries_1 = performance.getEntries();
    // Because the performance entry list can be quite large
    // delay the computation to prevent the SDK from blocking the main thread on init
    setTimeout$1(function () {
      return handleRumPerformanceEntries(lifeCycle, performanceEntries_1);
    });
  }
  if (window.PerformanceObserver) {
    var handlePerformanceEntryList_1 = monitor(function (entries) {
      return handleRumPerformanceEntries(lifeCycle, entries.getEntries());
    });
    var mainEntries = [RumPerformanceEntryType.NAVIGATION, RumPerformanceEntryType.LONG_TASK, RumPerformanceEntryType.PAINT];
    var experimentalEntries = [RumPerformanceEntryType.LARGEST_CONTENTFUL_PAINT, RumPerformanceEntryType.FIRST_INPUT, RumPerformanceEntryType.LAYOUT_SHIFT, RumPerformanceEntryType.EVENT];
    try {
      // Experimental entries are not retrieved by performance.getEntries()
      // use a single PerformanceObserver with buffered flag by type
      // to get values that could happen before SDK init
      experimentalEntries.forEach(function (type) {
        var observer = new window.PerformanceObserver(handlePerformanceEntryList_1);
        observer.observe({
          type: type,
          buffered: true,
          // durationThreshold only impact PerformanceEventTiming entries used for INP computation which requires a threshold at 40 (default is 104ms)
          // cf: https://github.com/GoogleChrome/web-vitals/blob/3806160ffbc93c3c4abf210a167b81228172b31c/src/onINP.ts#L209
          durationThreshold: 40
        });
        cleanupTasks.push(function () {
          return observer.disconnect();
        });
      });
    } catch (e) {
      // Some old browser versions (ex: chrome 67) don't support the PerformanceObserver type and buffered options
      // In these cases, fallback to PerformanceObserver with entryTypes
      mainEntries.push.apply(mainEntries, experimentalEntries);
    }
    var mainObserver_1 = new PerformanceObserver(handlePerformanceEntryList_1);
    mainObserver_1.observe({
      entryTypes: mainEntries
    });
    cleanupTasks.push(function () {
      return mainObserver_1.disconnect();
    });
    if (supportPerformanceObject() && 'addEventListener' in performance) {
      // https://bugzilla.mozilla.org/show_bug.cgi?id=1559377
      var removePerformanceListener = addEventListener(configuration, performance, 'resourcetimingbufferfull', function () {
        performance.clearResourceTimings();
      }).stop;
      cleanupTasks.push(removePerformanceListener);
    }
  }
  if (!supportPerformanceTimingEvent(RumPerformanceEntryType.NAVIGATION)) {
    retrieveNavigationTiming(configuration, function (timing) {
      handleRumPerformanceEntries(lifeCycle, [timing]);
    });
  }
  if (!supportPerformanceTimingEvent(RumPerformanceEntryType.FIRST_INPUT)) {
    var stopFirstInputTiming = retrieveFirstInputTiming(configuration, function (timing) {
      handleRumPerformanceEntries(lifeCycle, [timing]);
    }).stop;
    cleanupTasks.push(stopFirstInputTiming);
  }
  return {
    stop: function () {
      cleanupTasks.forEach(function (task) {
        return task();
      });
    }
  };
}
function retrieveNavigationTiming(configuration, callback) {
  function sendFakeTiming() {
    callback(assign(computeRelativePerformanceTiming(), {
      entryType: RumPerformanceEntryType.NAVIGATION
    }));
  }
  runOnReadyState(configuration, 'complete', function () {
    // Send it a bit after the actual load event, so the "loadEventEnd" timing is accurate
    setTimeout$1(sendFakeTiming);
  });
}
/**
 * first-input timing entry polyfill based on
 * https://github.com/GoogleChrome/web-vitals/blob/master/src/lib/polyfills/firstInputPolyfill.ts
 */
function retrieveFirstInputTiming(configuration, callback) {
  var startTimeStamp = dateNow();
  var timingSent = false;
  var removeEventListeners = addEventListeners(configuration, window, [DOM_EVENT.CLICK, DOM_EVENT.MOUSE_DOWN, DOM_EVENT.KEY_DOWN, DOM_EVENT.TOUCH_START, DOM_EVENT.POINTER_DOWN], function (evt) {
    // Only count cancelable events, which should trigger behavior important to the user.
    if (!evt.cancelable) {
      return;
    }
    // This timing will be used to compute the "first Input delay", which is the delta between
    // when the system received the event (e.g. evt.timeStamp) and when it could run the callback
    // (e.g. performance.now()).
    var timing = {
      entryType: RumPerformanceEntryType.FIRST_INPUT,
      processingStart: relativeNow(),
      processingEnd: relativeNow(),
      startTime: evt.timeStamp,
      duration: 0,
      // arbitrary value to avoid nullable duration and simplify INP logic
      name: ''
    };
    if (evt.type === DOM_EVENT.POINTER_DOWN) {
      sendTimingIfPointerIsNotCancelled(configuration, timing);
    } else {
      sendTiming(timing);
    }
  }, {
    passive: true,
    capture: true
  }).stop;
  return {
    stop: removeEventListeners
  };
  /**
   * Pointer events are a special case, because they can trigger main or compositor thread behavior.
   * We differentiate these cases based on whether or not we see a pointercancel event, which are
   * fired when we scroll. If we're scrolling we don't need to report input delay since FID excludes
   * scrolling and pinch/zooming.
   */
  function sendTimingIfPointerIsNotCancelled(configuration, timing) {
    addEventListeners(configuration, window, [DOM_EVENT.POINTER_UP, DOM_EVENT.POINTER_CANCEL], function (event) {
      if (event.type === DOM_EVENT.POINTER_UP) {
        sendTiming(timing);
      }
    }, {
      once: true
    });
  }
  function sendTiming(timing) {
    if (!timingSent) {
      timingSent = true;
      removeEventListeners();
      // In some cases the recorded delay is clearly wrong, e.g. it's negative or it's larger than
      // the time between now and when the page was loaded.
      // - https://github.com/GoogleChromeLabs/first-input-delay/issues/4
      // - https://github.com/GoogleChromeLabs/first-input-delay/issues/6
      // - https://github.com/GoogleChromeLabs/first-input-delay/issues/7
      var delay = timing.processingStart - timing.startTime;
      if (delay >= 0 && delay < dateNow() - startTimeStamp) {
        callback(timing);
      }
    }
  }
}
function handleRumPerformanceEntries(lifeCycle, entries) {
  var rumPerformanceEntries = entries.filter(function (entry) {
    return objectHasValue(RumPerformanceEntryType, entry.entryType);
  });
  var rumAllowedPerformanceEntries = rumPerformanceEntries.filter(function (entry) {
    return !isIncompleteNavigation(entry);
  });
  if (rumAllowedPerformanceEntries.length) {
    lifeCycle.notify(0 /* LifeCycleEventType.PERFORMANCE_ENTRIES_COLLECTED */, rumAllowedPerformanceEntries);
  }
}
function isIncompleteNavigation(entry) {
  return entry.entryType === RumPerformanceEntryType.NAVIGATION && entry.loadEventEnd <= 0;
}

function getSyntheticsContext() {
  var testId = getSyntheticsTestId();
  var resultId = getSyntheticsResultId();
  if (testId && resultId) {
    return {
      test_id: testId,
      result_id: resultId,
      injected: willSyntheticsInjectRum()
    };
  }
}

/**
 * Current limitation:
 * - field path do not support array, 'a.b.c' only
 */
function limitModification(object, modifiableFieldPaths, modifier) {
  var clone = deepClone(object);
  var result = modifier(clone);
  objectEntries(modifiableFieldPaths).forEach(function (_a) {
    var fieldPath = _a[0],
      fieldType = _a[1];
    var newValue = get(clone, fieldPath);
    var newType = getType(newValue);
    if (newType === fieldType) {
      set(object, fieldPath, sanitize(newValue));
    } else if (fieldType === 'object' && (newType === 'undefined' || newType === 'null')) {
      set(object, fieldPath, {});
    }
  });
  return result;
}
function get(object, path) {
  var current = object;
  for (var _i = 0, _a = path.split('.'); _i < _a.length; _i++) {
    var field = _a[_i];
    if (!isValidObjectContaining(current, field)) {
      return;
    }
    current = current[field];
  }
  return current;
}
function set(object, path, value) {
  var current = object;
  var fields = path.split('.');
  for (var i = 0; i < fields.length; i += 1) {
    var field = fields[i];
    if (!isValidObject(current)) {
      return;
    }
    if (i !== fields.length - 1) {
      current = current[field];
    } else {
      current[field] = value;
    }
  }
}
function isValidObject(object) {
  return getType(object) === 'object';
}
function isValidObjectContaining(object, field) {
  return isValidObject(object) && Object.prototype.hasOwnProperty.call(object, field);
}

var VIEW_MODIFIABLE_FIELD_PATHS = {
  'view.name': 'string',
  'view.url': 'string',
  'view.referrer': 'string'
};
var USER_CUSTOMIZABLE_FIELD_PATHS = {
  context: 'object'
};
var ROOT_MODIFIABLE_FIELD_PATHS = {
  service: 'string',
  version: 'string'
};
var modifiableFieldPathsByEvent;
function startRumAssembly(configuration, lifeCycle, sessionManager, viewContexts, urlContexts, actionContexts, displayContext, ciVisibilityContext, getCommonContext, reportError) {
  var _a, _b;
  modifiableFieldPathsByEvent = (_a = {}, _a["view" /* RumEventType.VIEW */] = VIEW_MODIFIABLE_FIELD_PATHS, _a["error" /* RumEventType.ERROR */] = assign({
    'error.message': 'string',
    'error.stack': 'string',
    'error.resource.url': 'string',
    'error.fingerprint': 'string'
  }, USER_CUSTOMIZABLE_FIELD_PATHS, VIEW_MODIFIABLE_FIELD_PATHS, ROOT_MODIFIABLE_FIELD_PATHS), _a["resource" /* RumEventType.RESOURCE */] = assign({
    'resource.url': 'string'
  }, isExperimentalFeatureEnabled(ExperimentalFeature.WRITABLE_RESOURCE_GRAPHQL) ? {
    'resource.graphql': 'object'
  } : {}, USER_CUSTOMIZABLE_FIELD_PATHS, VIEW_MODIFIABLE_FIELD_PATHS, ROOT_MODIFIABLE_FIELD_PATHS), _a["action" /* RumEventType.ACTION */] = assign({
    'action.target.name': 'string'
  }, USER_CUSTOMIZABLE_FIELD_PATHS, VIEW_MODIFIABLE_FIELD_PATHS, ROOT_MODIFIABLE_FIELD_PATHS), _a["long_task" /* RumEventType.LONG_TASK */] = assign({}, USER_CUSTOMIZABLE_FIELD_PATHS, VIEW_MODIFIABLE_FIELD_PATHS), _a["vital" /* RumEventType.VITAL */] = assign({}, USER_CUSTOMIZABLE_FIELD_PATHS, VIEW_MODIFIABLE_FIELD_PATHS), _a);
  var eventRateLimiters = (_b = {}, _b["error" /* RumEventType.ERROR */] = createEventRateLimiter("error" /* RumEventType.ERROR */, configuration.eventRateLimiterThreshold, reportError), _b["action" /* RumEventType.ACTION */] = createEventRateLimiter("action" /* RumEventType.ACTION */, configuration.eventRateLimiterThreshold, reportError), _b["vital" /* RumEventType.VITAL */] = createEventRateLimiter("vital" /* RumEventType.VITAL */, configuration.eventRateLimiterThreshold, reportError), _b);
  var syntheticsContext = getSyntheticsContext();
  lifeCycle.subscribe(12 /* LifeCycleEventType.RAW_RUM_EVENT_COLLECTED */, function (_a) {
    var startTime = _a.startTime,
      rawRumEvent = _a.rawRumEvent,
      domainContext = _a.domainContext,
      savedCommonContext = _a.savedCommonContext,
      customerContext = _a.customerContext;
    var viewContext = viewContexts.findView(startTime);
    var urlContext = urlContexts.findUrl(startTime);
    var session = sessionManager.findTrackedSession(startTime);
    if (session && viewContext && urlContext) {
      var commonContext = savedCommonContext || getCommonContext();
      var actionId = actionContexts.findActionId(startTime);
      var rumContext = {
        _dd: {
          format_version: 2,
          drift: currentDrift(),
          configuration: {
            session_sample_rate: round(configuration.sessionSampleRate, 3),
            session_replay_sample_rate: round(configuration.sessionReplaySampleRate, 3)
          },
          browser_sdk_version: canUseEventBridge() ? "5.23.0" : undefined
        },
        application: {
          id: configuration.applicationId
        },
        date: timeStampNow(),
        service: viewContext.service || configuration.service,
        version: viewContext.version || configuration.version,
        source: 'browser',
        session: {
          id: session.id,
          type: syntheticsContext ? "synthetics" /* SessionType.SYNTHETICS */ : ciVisibilityContext.get() ? "ci_test" /* SessionType.CI_TEST */ : "user" /* SessionType.USER */
        },
        view: {
          id: viewContext.id,
          name: viewContext.name,
          url: urlContext.url,
          referrer: urlContext.referrer
        },
        action: needToAssembleWithAction(rawRumEvent) && actionId ? {
          id: actionId
        } : undefined,
        synthetics: syntheticsContext,
        ci_test: ciVisibilityContext.get(),
        display: displayContext.get(),
        connectivity: getConnectivity()
      };
      var serverRumEvent = combine(rumContext, rawRumEvent);
      serverRumEvent.context = combine(commonContext.context, customerContext);
      if (!('has_replay' in serverRumEvent.session)) {
        serverRumEvent.session.has_replay = commonContext.hasReplay;
      }
      if (serverRumEvent.type === 'view') {
        serverRumEvent.session.sampled_for_replay = session.sessionReplay === 1 /* SessionReplayState.SAMPLED */;
      }
      if (!isEmptyObject(commonContext.user)) {
        serverRumEvent.usr = commonContext.user;
      }
      if (shouldSend(serverRumEvent, configuration.beforeSend, domainContext, eventRateLimiters)) {
        if (isEmptyObject(serverRumEvent.context)) {
          delete serverRumEvent.context;
        }
        lifeCycle.notify(13 /* LifeCycleEventType.RUM_EVENT_COLLECTED */, serverRumEvent);
      }
    }
  });
}
function shouldSend(event, beforeSend, domainContext, eventRateLimiters) {
  var _a;
  if (beforeSend) {
    var result = limitModification(event, modifiableFieldPathsByEvent[event.type], function (event) {
      return beforeSend(event, domainContext);
    });
    if (result === false && event.type !== "view" /* RumEventType.VIEW */) {
      return false;
    }
    if (result === false) {
      display.warn("Can't dismiss view events using beforeSend!");
    }
  }
  var rateLimitReached = (_a = eventRateLimiters[event.type]) === null || _a === void 0 ? void 0 : _a.isLimitReached();
  return !rateLimitReached;
}
function needToAssembleWithAction(event) {
  return ["error" /* RumEventType.ERROR */, "resource" /* RumEventType.RESOURCE */, "long_task" /* RumEventType.LONG_TASK */].indexOf(event.type) !== -1;
}

/**
 * Internal context keep returning v1 format
 * to not break compatibility with logs data format
 */
function startInternalContext(applicationId, sessionManager, viewContexts, actionContexts, urlContexts) {
  return {
    get: function (startTime) {
      var viewContext = viewContexts.findView(startTime);
      var urlContext = urlContexts.findUrl(startTime);
      var session = sessionManager.findTrackedSession(startTime);
      if (session && viewContext && urlContext) {
        var actionId = actionContexts.findActionId(startTime);
        return {
          application_id: applicationId,
          session_id: session.id,
          user_action: actionId ? {
            id: actionId
          } : undefined,
          view: {
            id: viewContext.id,
            name: viewContext.name,
            referrer: urlContext.referrer,
            url: urlContext.url
          }
        };
      }
    }
  };
}

var LifeCycle = AbstractLifeCycle;

var VIEW_CONTEXT_TIME_OUT_DELAY = SESSION_TIME_OUT_DELAY;
function startViewContexts(lifeCycle) {
  var viewContextHistory = new ValueHistory(VIEW_CONTEXT_TIME_OUT_DELAY);
  lifeCycle.subscribe(2 /* LifeCycleEventType.BEFORE_VIEW_CREATED */, function (view) {
    viewContextHistory.add(buildViewContext(view), view.startClocks.relative);
  });
  lifeCycle.subscribe(6 /* LifeCycleEventType.AFTER_VIEW_ENDED */, function (_a) {
    var endClocks = _a.endClocks;
    viewContextHistory.closeActive(endClocks.relative);
  });
  lifeCycle.subscribe(4 /* LifeCycleEventType.VIEW_UPDATED */, function (viewUpdate) {
    var currentView = viewContextHistory.find(viewUpdate.startClocks.relative);
    if (currentView && viewUpdate.name) {
      currentView.name = viewUpdate.name;
    }
  });
  lifeCycle.subscribe(10 /* LifeCycleEventType.SESSION_RENEWED */, function () {
    viewContextHistory.reset();
  });
  function buildViewContext(view) {
    return {
      service: view.service,
      version: view.version,
      id: view.id,
      name: view.name,
      startClocks: view.startClocks
    };
  }
  return {
    findView: function (startTime) {
      return viewContextHistory.find(startTime);
    },
    stop: function () {
      viewContextHistory.stop();
    }
  };
}

var nextRequestIndex = 1;
function startRequestCollection(lifeCycle, configuration, sessionManager) {
  var tracer = startTracer(configuration, sessionManager);
  trackXhr(lifeCycle, configuration, tracer);
  trackFetch(lifeCycle, configuration, tracer);
}
function trackXhr(lifeCycle, configuration, tracer) {
  var subscription = initXhrObservable(configuration).subscribe(function (rawContext) {
    var context = rawContext;
    if (!isAllowedRequestUrl(configuration, context.url)) {
      return;
    }
    switch (context.state) {
      case 'start':
        tracer.traceXhr(context, context.xhr);
        context.requestIndex = getNextRequestIndex();
        lifeCycle.notify(7 /* LifeCycleEventType.REQUEST_STARTED */, {
          requestIndex: context.requestIndex,
          url: context.url
        });
        break;
      case 'complete':
        tracer.clearTracingIfNeeded(context);
        lifeCycle.notify(8 /* LifeCycleEventType.REQUEST_COMPLETED */, {
          duration: context.duration,
          method: context.method,
          requestIndex: context.requestIndex,
          spanId: context.spanId,
          startClocks: context.startClocks,
          status: context.status,
          traceId: context.traceId,
          traceSampled: context.traceSampled,
          type: "xhr" /* RequestType.XHR */,
          url: context.url,
          xhr: context.xhr,
          isAborted: context.isAborted,
          handlingStack: context.handlingStack
        });
        break;
    }
  });
  return {
    stop: function () {
      return subscription.unsubscribe();
    }
  };
}
function trackFetch(lifeCycle, configuration, tracer) {
  var subscription = initFetchObservable().subscribe(function (rawContext) {
    var context = rawContext;
    if (!isAllowedRequestUrl(configuration, context.url)) {
      return;
    }
    switch (context.state) {
      case 'start':
        tracer.traceFetch(context);
        context.requestIndex = getNextRequestIndex();
        lifeCycle.notify(7 /* LifeCycleEventType.REQUEST_STARTED */, {
          requestIndex: context.requestIndex,
          url: context.url
        });
        break;
      case 'resolve':
        waitForResponseToComplete(context, function (duration) {
          tracer.clearTracingIfNeeded(context);
          lifeCycle.notify(8 /* LifeCycleEventType.REQUEST_COMPLETED */, {
            duration: duration,
            method: context.method,
            requestIndex: context.requestIndex,
            responseType: context.responseType,
            spanId: context.spanId,
            startClocks: context.startClocks,
            status: context.status,
            traceId: context.traceId,
            traceSampled: context.traceSampled,
            type: "fetch" /* RequestType.FETCH */,
            url: context.url,
            response: context.response,
            init: context.init,
            input: context.input,
            isAborted: context.isAborted,
            handlingStack: context.handlingStack
          });
        });
        break;
    }
  });
  return {
    stop: function () {
      return subscription.unsubscribe();
    }
  };
}
function getNextRequestIndex() {
  var result = nextRequestIndex;
  nextRequestIndex += 1;
  return result;
}
function waitForResponseToComplete(context, callback) {
  var clonedResponse = context.response && tryToClone(context.response);
  if (!clonedResponse || !clonedResponse.body) {
    // do not try to wait for the response if the clone failed, fetch error or null body
    callback(elapsed(context.startClocks.timeStamp, timeStampNow()));
  } else {
    readBytesFromStream(clonedResponse.body, function () {
      callback(elapsed(context.startClocks.timeStamp, timeStampNow()));
    }, {
      bytesLimit: Number.POSITIVE_INFINITY,
      collectStreamBody: false
    });
  }
}

function discardNegativeDuration(duration) {
  return isNumber(duration) && duration < 0 ? undefined : duration;
}

function trackEventCounts(_a) {
  var lifeCycle = _a.lifeCycle,
    isChildEvent = _a.isChildEvent,
    _b = _a.onChange,
    callback = _b === void 0 ? noop$1 : _b;
  var eventCounts = {
    errorCount: 0,
    longTaskCount: 0,
    resourceCount: 0,
    actionCount: 0,
    frustrationCount: 0
  };
  var subscription = lifeCycle.subscribe(13 /* LifeCycleEventType.RUM_EVENT_COLLECTED */, function (event) {
    var _a;
    if (event.type === 'view' || event.type === 'vital' || !isChildEvent(event)) {
      return;
    }
    switch (event.type) {
      case "error" /* RumEventType.ERROR */:
        eventCounts.errorCount += 1;
        callback();
        break;
      case "action" /* RumEventType.ACTION */:
        eventCounts.actionCount += 1;
        if (event.action.frustration) {
          eventCounts.frustrationCount += event.action.frustration.type.length;
        }
        callback();
        break;
      case "long_task" /* RumEventType.LONG_TASK */:
        eventCounts.longTaskCount += 1;
        callback();
        break;
      case "resource" /* RumEventType.RESOURCE */:
        if (!((_a = event._dd) === null || _a === void 0 ? void 0 : _a.discarded)) {
          eventCounts.resourceCount += 1;
          callback();
        }
        break;
    }
  });
  return {
    stop: function () {
      subscription.unsubscribe();
    },
    eventCounts: eventCounts
  };
}

// Delay to wait for a page activity to validate the tracking process
var PAGE_ACTIVITY_VALIDATION_DELAY = 100;
// Delay to wait after a page activity to end the tracking process
var PAGE_ACTIVITY_END_DELAY = 100;
/**
 * Wait for the page activity end
 *
 * Detection lifecycle:
 * ```
 *                        Wait page activity end
 *              .-------------------'--------------------.
 *              v                                        v
 *     [Wait for a page activity ]          [Wait for a maximum duration]
 *     [timeout: VALIDATION_DELAY]          [  timeout: maxDuration     ]
 *          /                  \                           |
 *         v                    v                          |
 *  [No page activity]   [Page activity]                   |
 *         |                   |,----------------------.   |
 *         v                   v                       |   |
 *     (Discard)     [Wait for a page activity]        |   |
 *                   [   timeout: END_DELAY   ]        |   |
 *                       /                \            |   |
 *                      v                  v           |   |
 *             [No page activity]    [Page activity]   |   |
 *                      |                 |            |   |
 *                      |                 '------------'   |
 *                      '-----------. ,--------------------'
 *                                   v
 *                                 (End)
 * ```
 *
 * Note: by assuming that maxDuration is greater than VALIDATION_DELAY, we are sure that if the
 * process is still alive after maxDuration, it has been validated.
 */
function waitPageActivityEnd(lifeCycle, domMutationObservable, configuration, pageActivityEndCallback, maxDuration) {
  var pageActivityObservable = createPageActivityObservable(lifeCycle, domMutationObservable, configuration);
  return doWaitPageActivityEnd(pageActivityObservable, pageActivityEndCallback, maxDuration);
}
function doWaitPageActivityEnd(pageActivityObservable, pageActivityEndCallback, maxDuration) {
  var pageActivityEndTimeoutId;
  var hasCompleted = false;
  var validationTimeoutId = setTimeout$1(monitor(function () {
    return complete({
      hadActivity: false
    });
  }), PAGE_ACTIVITY_VALIDATION_DELAY);
  var maxDurationTimeoutId = maxDuration !== undefined ? setTimeout$1(monitor(function () {
    return complete({
      hadActivity: true,
      end: timeStampNow()
    });
  }), maxDuration) : undefined;
  var pageActivitySubscription = pageActivityObservable.subscribe(function (_a) {
    var isBusy = _a.isBusy;
    clearTimeout$1(validationTimeoutId);
    clearTimeout$1(pageActivityEndTimeoutId);
    var lastChangeTime = timeStampNow();
    if (!isBusy) {
      pageActivityEndTimeoutId = setTimeout$1(monitor(function () {
        return complete({
          hadActivity: true,
          end: lastChangeTime
        });
      }), PAGE_ACTIVITY_END_DELAY);
    }
  });
  var stop = function () {
    hasCompleted = true;
    clearTimeout$1(validationTimeoutId);
    clearTimeout$1(pageActivityEndTimeoutId);
    clearTimeout$1(maxDurationTimeoutId);
    pageActivitySubscription.unsubscribe();
  };
  function complete(event) {
    if (hasCompleted) {
      return;
    }
    stop();
    pageActivityEndCallback(event);
  }
  return {
    stop: stop
  };
}
function createPageActivityObservable(lifeCycle, domMutationObservable, configuration) {
  return new Observable(function (observable) {
    var subscriptions = [];
    var firstRequestIndex;
    var pendingRequestsCount = 0;
    subscriptions.push(domMutationObservable.subscribe(notifyPageActivity), createPerformanceObservable(configuration, {
      type: RumPerformanceEntryType.RESOURCE
    }).subscribe(function (entries) {
      if (entries.some(function (entry) {
        return !isExcludedUrl(configuration, entry.name);
      })) {
        notifyPageActivity();
      }
    }), lifeCycle.subscribe(7 /* LifeCycleEventType.REQUEST_STARTED */, function (startEvent) {
      if (isExcludedUrl(configuration, startEvent.url)) {
        return;
      }
      if (firstRequestIndex === undefined) {
        firstRequestIndex = startEvent.requestIndex;
      }
      pendingRequestsCount += 1;
      notifyPageActivity();
    }), lifeCycle.subscribe(8 /* LifeCycleEventType.REQUEST_COMPLETED */, function (request) {
      if (isExcludedUrl(configuration, request.url) || firstRequestIndex === undefined ||
      // If the request started before the tracking start, ignore it
      request.requestIndex < firstRequestIndex) {
        return;
      }
      pendingRequestsCount -= 1;
      notifyPageActivity();
    }));
    var stopTrackingWindowOpen = trackWindowOpen(notifyPageActivity).stop;
    return function () {
      stopTrackingWindowOpen();
      subscriptions.forEach(function (s) {
        return s.unsubscribe();
      });
    };
    function notifyPageActivity() {
      observable.notify({
        isBusy: pendingRequestsCount > 0
      });
    }
  });
}
function isExcludedUrl(configuration, requestUrl) {
  return matchList(configuration.excludedActivityUrls, requestUrl);
}
function trackWindowOpen(callback) {
  return instrumentMethod(window, 'open', callback);
}

// https://github.com/jquery/jquery/blob/a684e6ba836f7c553968d7d026ed7941e1a612d8/src/selector/escapeSelector.js
function cssEscape(str) {
  if (window.CSS && window.CSS.escape) {
    return window.CSS.escape(str);
  }
  // eslint-disable-next-line no-control-regex
  return str.replace(/([\0-\x1f\x7f]|^-?\d)|^-$|[^\x80-\uFFFF\w-]/g, function (ch, asCodePoint) {
    if (asCodePoint) {
      // U+0000 NULL becomes U+FFFD REPLACEMENT CHARACTER
      if (ch === '\0') {
        return '\uFFFD';
      }
      // Control characters and (dependent upon position) numbers get escaped as code points
      return "".concat(ch.slice(0, -1), "\\").concat(ch.charCodeAt(ch.length - 1).toString(16), " ");
    }
    // Other potentially-special ASCII characters get backslash-escaped
    return "\\".concat(ch);
  });
}
function elementMatches(element, selector) {
  if (element.matches) {
    return element.matches(selector);
  }
  // IE11 support
  if (element.msMatchesSelector) {
    return element.msMatchesSelector(selector);
  }
  return false;
}
/**
 * Return the parentElement of an node
 *
 * In cases where parentElement is not supported, such as in IE11 for SVG nodes, we fallback to parentNode
 */
function getParentElement(node) {
  if (node.parentElement) {
    return node.parentElement;
  }
  while (node.parentNode) {
    if (node.parentNode.nodeType === Node.ELEMENT_NODE) {
      return node.parentNode;
    }
    node = node.parentNode;
  }
  return null;
}
/**
 * Return the classList of an element or an array of classes if classList is not supported
 *
 * In cases where classList is not supported, such as in IE11 for SVG and MathML elements,
 * we fallback to using element.getAttribute('class').
 * We opt for element.getAttribute('class') over element.className because className returns an SVGAnimatedString for SVG elements.
 */
function getClassList(element) {
  var _a;
  if (element.classList) {
    return element.classList;
  }
  var classes = (_a = element.getAttribute('class')) === null || _a === void 0 ? void 0 : _a.trim();
  return classes ? classes.split(/\s+/) : [];
}
// ie11 supports WeakMap but not WeakSet
var PLACEHOLDER = 1;
var WeakSet$1 = /** @class */function () {
  function WeakSet(initialValues) {
    var _this = this;
    this.map = new WeakMap();
    if (initialValues) {
      initialValues.forEach(function (value) {
        return _this.map.set(value, PLACEHOLDER);
      });
    }
  }
  WeakSet.prototype.add = function (value) {
    this.map.set(value, PLACEHOLDER);
    return this;
  };
  WeakSet.prototype.delete = function (value) {
    return this.map.delete(value);
  };
  WeakSet.prototype.has = function (value) {
    return this.map.has(value);
  };
  return WeakSet;
}();

function isTextNode(node) {
  return node.nodeType === Node.TEXT_NODE;
}
function isCommentNode(node) {
  return node.nodeType === Node.COMMENT_NODE;
}
function isElementNode(node) {
  return node.nodeType === Node.ELEMENT_NODE;
}
function isNodeShadowHost(node) {
  return isElementNode(node) && Boolean(node.shadowRoot);
}
function isNodeShadowRoot(node) {
  var shadowRoot = node;
  return !!shadowRoot.host && shadowRoot.nodeType === Node.DOCUMENT_FRAGMENT_NODE && isElementNode(shadowRoot.host);
}
function hasChildNodes(node) {
  return node.childNodes.length > 0 || isNodeShadowHost(node);
}
function forEachChildNodes(node, callback) {
  var child = node.firstChild;
  while (child) {
    callback(child);
    child = child.nextSibling;
  }
  if (isNodeShadowHost(node)) {
    callback(node.shadowRoot);
  }
}
/**
 * Return `host` in case if the current node is a shadow root otherwise will return the `parentNode`
 */
function getParentNode(node) {
  return isNodeShadowRoot(node) ? node.host : node.parentNode;
}

var NodePrivacyLevel = {
  IGNORE: 'ignore',
  HIDDEN: 'hidden',
  ALLOW: DefaultPrivacyLevel.ALLOW,
  MASK: DefaultPrivacyLevel.MASK,
  MASK_USER_INPUT: DefaultPrivacyLevel.MASK_USER_INPUT
};
var PRIVACY_ATTR_NAME = 'data-dd-privacy';
var PRIVACY_ATTR_VALUE_HIDDEN = 'hidden';
// Privacy Classes - not all customers can set plain HTML attributes, so support classes too
var PRIVACY_CLASS_PREFIX = 'dd-privacy-';
// Private Replacement Templates
var CENSORED_STRING_MARK = '***';
var CENSORED_IMG_MARK = 'data:image/gif;base64,R0lGODlhAQABAIAAAMLCwgAAACH5BAAAAAAALAAAAAABAAEAAAICRAEAOw==';
var FORM_PRIVATE_TAG_NAMES = {
  INPUT: true,
  OUTPUT: true,
  TEXTAREA: true,
  SELECT: true,
  OPTION: true,
  DATALIST: true,
  OPTGROUP: true
};
var TEXT_MASKING_CHAR = 'x';
/**
 * Get node privacy level by iterating over its ancestors. When the direct parent privacy level is
 * know, it is best to use something like:
 *
 * derivePrivacyLevelGivenParent(getNodeSelfPrivacyLevel(node), parentNodePrivacyLevel)
 */
function getNodePrivacyLevel(node, defaultPrivacyLevel, cache) {
  if (cache && cache.has(node)) {
    return cache.get(node);
  }
  var parentNode = getParentNode(node);
  var parentNodePrivacyLevel = parentNode ? getNodePrivacyLevel(parentNode, defaultPrivacyLevel, cache) : defaultPrivacyLevel;
  var selfNodePrivacyLevel = getNodeSelfPrivacyLevel(node);
  var nodePrivacyLevel = reducePrivacyLevel(selfNodePrivacyLevel, parentNodePrivacyLevel);
  if (cache) {
    cache.set(node, nodePrivacyLevel);
  }
  return nodePrivacyLevel;
}
/**
 * Reduces the next privacy level based on self + parent privacy levels
 */
function reducePrivacyLevel(childPrivacyLevel, parentNodePrivacyLevel) {
  switch (parentNodePrivacyLevel) {
    // These values cannot be overridden
    case NodePrivacyLevel.HIDDEN:
    case NodePrivacyLevel.IGNORE:
      return parentNodePrivacyLevel;
  }
  switch (childPrivacyLevel) {
    case NodePrivacyLevel.ALLOW:
    case NodePrivacyLevel.MASK:
    case NodePrivacyLevel.MASK_USER_INPUT:
    case NodePrivacyLevel.HIDDEN:
    case NodePrivacyLevel.IGNORE:
      return childPrivacyLevel;
    default:
      return parentNodePrivacyLevel;
  }
}
/**
 * Determines the node's own privacy level without checking for ancestors.
 */
function getNodeSelfPrivacyLevel(node) {
  // Only Element types can have a privacy level set
  if (!isElementNode(node)) {
    return;
  }
  // Overrules for replay purpose
  if (node.tagName === 'BASE') {
    return NodePrivacyLevel.ALLOW;
  }
  // Overrules to enforce end-user protection
  if (node.tagName === 'INPUT') {
    var inputElement = node;
    if (inputElement.type === 'password' || inputElement.type === 'email' || inputElement.type === 'tel') {
      return NodePrivacyLevel.MASK;
    }
    if (inputElement.type === 'hidden') {
      return NodePrivacyLevel.MASK;
    }
    var autocomplete = inputElement.getAttribute('autocomplete');
    // Handle input[autocomplete=cc-number/cc-csc/cc-exp/cc-exp-month/cc-exp-year]
    if (autocomplete && autocomplete.indexOf('cc-') === 0) {
      return NodePrivacyLevel.MASK;
    }
  }
  // Check HTML privacy attributes and classes
  if (elementMatches(node, getPrivacySelector(NodePrivacyLevel.HIDDEN))) {
    return NodePrivacyLevel.HIDDEN;
  }
  if (elementMatches(node, getPrivacySelector(NodePrivacyLevel.MASK))) {
    return NodePrivacyLevel.MASK;
  }
  if (elementMatches(node, getPrivacySelector(NodePrivacyLevel.MASK_USER_INPUT))) {
    return NodePrivacyLevel.MASK_USER_INPUT;
  }
  if (elementMatches(node, getPrivacySelector(NodePrivacyLevel.ALLOW))) {
    return NodePrivacyLevel.ALLOW;
  }
  if (shouldIgnoreElement(node)) {
    return NodePrivacyLevel.IGNORE;
  }
}
/**
 * Helper aiming to unify `mask` and `mask-user-input` privacy levels:
 *
 * In the `mask` case, it is trivial: we should mask the element.
 *
 * In the `mask-user-input` case, we should mask the element only if it is a "form" element or the
 * direct parent is a form element for text nodes).
 *
 * Other `shouldMaskNode` cases are edge cases that should not matter too much (ex: should we mask a
 * node if it is ignored or hidden? it doesn't matter since it won't be serialized).
 */
function shouldMaskNode(node, privacyLevel) {
  switch (privacyLevel) {
    case NodePrivacyLevel.MASK:
    case NodePrivacyLevel.HIDDEN:
    case NodePrivacyLevel.IGNORE:
      return true;
    case NodePrivacyLevel.MASK_USER_INPUT:
      return isTextNode(node) ? isFormElement(node.parentNode) : isFormElement(node);
    default:
      return false;
  }
}
function isFormElement(node) {
  if (!node || node.nodeType !== node.ELEMENT_NODE) {
    return false;
  }
  var element = node;
  if (element.tagName === 'INPUT') {
    switch (element.type) {
      case 'button':
      case 'color':
      case 'reset':
      case 'submit':
        return false;
    }
  }
  return !!FORM_PRIVATE_TAG_NAMES[element.tagName];
}
/**
 * Text censoring non-destructively maintains whitespace characters in order to preserve text shape
 * during replay.
 */
var censorText = function (text) {
  return text.replace(/\S/g, TEXT_MASKING_CHAR);
};
function getTextContent$1(textNode, ignoreWhiteSpace, parentNodePrivacyLevel) {
  var _a;
  // The parent node may not be a html element which has a tagName attribute.
  // So just let it be undefined which is ok in this use case.
  var parentTagName = (_a = textNode.parentElement) === null || _a === void 0 ? void 0 : _a.tagName;
  var textContent = textNode.textContent || '';
  if (ignoreWhiteSpace && !textContent.trim()) {
    return;
  }
  var nodePrivacyLevel = parentNodePrivacyLevel;
  var isScript = parentTagName === 'SCRIPT';
  if (isScript) {
    // For perf reasons, we don't record script (heuristic)
    textContent = CENSORED_STRING_MARK;
  } else if (nodePrivacyLevel === NodePrivacyLevel.HIDDEN) {
    // Should never occur, but just in case, we set to CENSORED_MARK.
    textContent = CENSORED_STRING_MARK;
  } else if (shouldMaskNode(textNode, nodePrivacyLevel)) {
    if (
    // Scrambling the child list breaks text nodes for DATALIST/SELECT/OPTGROUP
    parentTagName === 'DATALIST' || parentTagName === 'SELECT' || parentTagName === 'OPTGROUP') {
      if (!textContent.trim()) {
        return;
      }
    } else if (parentTagName === 'OPTION') {
      // <Option> has low entropy in charset + text length, so use `CENSORED_STRING_MARK` when masked
      textContent = CENSORED_STRING_MARK;
    } else {
      textContent = censorText(textContent);
    }
  }
  return textContent;
}
/**
 * TODO: Preserve CSS element order, and record the presence of the tag, just don't render
 * We don't need this logic on the recorder side.
 * For security related meta's, customer can mask themmanually given they
 * are easy to identify in the HEAD tag.
 */
function shouldIgnoreElement(element) {
  if (element.nodeName === 'SCRIPT') {
    return true;
  }
  if (element.nodeName === 'LINK') {
    var relAttribute = getLowerCaseAttribute('rel');
    return (
      // Link as script - Ignore only when rel=preload, modulepreload or prefetch
      /preload|prefetch/i.test(relAttribute) && getLowerCaseAttribute('as') === 'script' ||
      // Favicons
      relAttribute === 'shortcut icon' || relAttribute === 'icon'
    );
  }
  if (element.nodeName === 'META') {
    var nameAttribute = getLowerCaseAttribute('name');
    var relAttribute = getLowerCaseAttribute('rel');
    var propertyAttribute = getLowerCaseAttribute('property');
    return (
      // Favicons
      /^msapplication-tile(image|color)$/.test(nameAttribute) || nameAttribute === 'application-name' || relAttribute === 'icon' || relAttribute === 'apple-touch-icon' || relAttribute === 'shortcut icon' ||
      // Description
      nameAttribute === 'keywords' || nameAttribute === 'description' ||
      // Social
      /^(og|twitter|fb):/.test(propertyAttribute) || /^(og|twitter):/.test(nameAttribute) || nameAttribute === 'pinterest' ||
      // Robots
      nameAttribute === 'robots' || nameAttribute === 'googlebot' || nameAttribute === 'bingbot' ||
      // Http headers. Ex: X-UA-Compatible, Content-Type, Content-Language, cache-control,
      // X-Translated-By
      element.hasAttribute('http-equiv') ||
      // Authorship
      nameAttribute === 'author' || nameAttribute === 'generator' || nameAttribute === 'framework' || nameAttribute === 'publisher' || nameAttribute === 'progid' || /^article:/.test(propertyAttribute) || /^product:/.test(propertyAttribute) ||
      // Verification
      nameAttribute === 'google-site-verification' || nameAttribute === 'yandex-verification' || nameAttribute === 'csrf-token' || nameAttribute === 'p:domain_verify' || nameAttribute === 'verify-v1' || nameAttribute === 'verification' || nameAttribute === 'shopify-checkout-api-token'
    );
  }
  function getLowerCaseAttribute(name) {
    return (element.getAttribute(name) || '').toLowerCase();
  }
  return false;
}
function getPrivacySelector(privacyLevel) {
  return "[".concat(PRIVACY_ATTR_NAME, "=\"").concat(privacyLevel, "\"], .").concat(PRIVACY_CLASS_PREFIX).concat(privacyLevel);
}

/**
 * Get the action name from the attribute 'data-dd-action-name' on the element or any of its parent.
 * It can also be retrieved from a user defined attribute.
 */
var DEFAULT_PROGRAMMATIC_ACTION_NAME_ATTRIBUTE = 'data-dd-action-name';
var ACTION_NAME_PLACEHOLDER = 'Masked Element';
function getActionNameFromElement(element, _a, nodePrivacyLevel) {
  var enablePrivacyForActionName = _a.enablePrivacyForActionName,
    userProgrammaticAttribute = _a.actionNameAttribute;
  // Proceed to get the action name in two steps:
  // * first, get the name programmatically, explicitly defined by the user.
  // * then, use strategies that are known to return good results. Those strategies will be used on
  //   the element and a few parents, but it's likely that they won't succeed at all.
  // * if no name is found this way, use strategies returning less accurate names as a fallback.
  //   Those are much likely to succeed.
  var defaultActionName = getActionNameFromElementProgrammatically(element, DEFAULT_PROGRAMMATIC_ACTION_NAME_ATTRIBUTE) || userProgrammaticAttribute && getActionNameFromElementProgrammatically(element, userProgrammaticAttribute);
  if (nodePrivacyLevel === NodePrivacyLevel.MASK) {
    return defaultActionName || ACTION_NAME_PLACEHOLDER;
  }
  return defaultActionName || getActionNameFromElementForStrategies(element, userProgrammaticAttribute, priorityStrategies, enablePrivacyForActionName) || getActionNameFromElementForStrategies(element, userProgrammaticAttribute, fallbackStrategies, enablePrivacyForActionName) || '';
}
function getActionNameFromElementProgrammatically(targetElement, programmaticAttribute) {
  var elementWithAttribute;
  // We don't use getActionNameFromElementForStrategies here, because we want to consider all parents,
  // without limit. It is up to the user to declare a relevant naming strategy.
  // If available, use element.closest() to match get the attribute from the element or any of its
  // parent.  Else fallback to a more traditional implementation.
  if (supportsElementClosest()) {
    elementWithAttribute = targetElement.closest("[".concat(programmaticAttribute, "]"));
  } else {
    var element = targetElement;
    while (element) {
      if (element.hasAttribute(programmaticAttribute)) {
        elementWithAttribute = element;
        break;
      }
      element = getParentElement(element);
    }
  }
  if (!elementWithAttribute) {
    return;
  }
  var name = elementWithAttribute.getAttribute(programmaticAttribute);
  return truncate(normalizeWhitespace(name.trim()));
}
var priorityStrategies = [
// associated LABEL text
function (element, userProgrammaticAttribute, privacy) {
  // IE does not support element.labels, so we fallback to a CSS selector based on the element id
  // instead
  if (supportsLabelProperty()) {
    if ('labels' in element && element.labels && element.labels.length > 0) {
      return getTextualContent(element.labels[0], userProgrammaticAttribute);
    }
  } else if (element.id) {
    var label = element.ownerDocument && find(element.ownerDocument.querySelectorAll('label'), function (label) {
      return label.htmlFor === element.id;
    });
    return label && getTextualContent(label, userProgrammaticAttribute, privacy);
  }
},
// INPUT button (and associated) value
function (element) {
  if (element.nodeName === 'INPUT') {
    var input = element;
    var type = input.getAttribute('type');
    if (type === 'button' || type === 'submit' || type === 'reset') {
      return input.value;
    }
  }
},
// BUTTON, LABEL or button-like element text
function (element, userProgrammaticAttribute, privacyEnabledActionName) {
  if (element.nodeName === 'BUTTON' || element.nodeName === 'LABEL' || element.getAttribute('role') === 'button') {
    return getTextualContent(element, userProgrammaticAttribute, privacyEnabledActionName);
  }
}, function (element) {
  return element.getAttribute('aria-label');
},
// associated element text designated by the aria-labelledby attribute
function (element, userProgrammaticAttribute, privacyEnabledActionName) {
  var labelledByAttribute = element.getAttribute('aria-labelledby');
  if (labelledByAttribute) {
    return labelledByAttribute.split(/\s+/).map(function (id) {
      return getElementById(element, id);
    }).filter(function (label) {
      return Boolean(label);
    }).map(function (element) {
      return getTextualContent(element, userProgrammaticAttribute, privacyEnabledActionName);
    }).join(' ');
  }
}, function (element) {
  return element.getAttribute('alt');
}, function (element) {
  return element.getAttribute('name');
}, function (element) {
  return element.getAttribute('title');
}, function (element) {
  return element.getAttribute('placeholder');
},
// SELECT first OPTION text
function (element, userProgrammaticAttribute) {
  if ('options' in element && element.options.length > 0) {
    return getTextualContent(element.options[0], userProgrammaticAttribute);
  }
}];
var fallbackStrategies = [function (element, userProgrammaticAttribute, privacyEnabledActionName) {
  return getTextualContent(element, userProgrammaticAttribute, privacyEnabledActionName);
}];
/**
 * Iterates over the target element and its parent, using the strategies list to get an action name.
 * Each strategies are applied on each element, stopping as soon as a non-empty value is returned.
 */
var MAX_PARENTS_TO_CONSIDER = 10;
function getActionNameFromElementForStrategies(targetElement, userProgrammaticAttribute, strategies, privacyEnabledActionName) {
  var element = targetElement;
  var recursionCounter = 0;
  while (recursionCounter <= MAX_PARENTS_TO_CONSIDER && element && element.nodeName !== 'BODY' && element.nodeName !== 'HTML' && element.nodeName !== 'HEAD') {
    for (var _i = 0, strategies_1 = strategies; _i < strategies_1.length; _i++) {
      var strategy = strategies_1[_i];
      var name_1 = strategy(element, userProgrammaticAttribute, privacyEnabledActionName);
      if (typeof name_1 === 'string') {
        var trimmedName = name_1.trim();
        if (trimmedName) {
          return truncate(normalizeWhitespace(trimmedName));
        }
      }
    }
    // Consider a FORM as a contextual limit to get the action name.  This is experimental and may
    // be reconsidered in the future.
    if (element.nodeName === 'FORM') {
      break;
    }
    element = getParentElement(element);
    recursionCounter += 1;
  }
}
function normalizeWhitespace(s) {
  return s.replace(/\s+/g, ' ');
}
function truncate(s) {
  return s.length > 100 ? "".concat(safeTruncate(s, 100), " [...]") : s;
}
function getElementById(refElement, id) {
  // Use the element ownerDocument here, because tests are executed in an iframe, so
  // document.getElementById won't work.
  return refElement.ownerDocument ? refElement.ownerDocument.getElementById(id) : null;
}
function getTextualContent(element, userProgrammaticAttribute, privacyEnabledActionName) {
  if (element.isContentEditable) {
    return;
  }
  if ('innerText' in element) {
    var text_1 = element.innerText;
    var removeTextFromElements = function (query) {
      var list = element.querySelectorAll(query);
      for (var index = 0; index < list.length; index += 1) {
        var element_1 = list[index];
        if ('innerText' in element_1) {
          var textToReplace = element_1.innerText;
          if (textToReplace && textToReplace.trim().length > 0) {
            text_1 = text_1.replace(textToReplace, '');
          }
        }
      }
    };
    if (!supportsInnerTextScriptAndStyleRemoval()) {
      // remove the inner text of SCRIPT and STYLES from the result. This is a bit dirty, but should
      // be relatively fast and work in most cases.
      removeTextFromElements('script, style');
    }
    // remove the text of elements with programmatic attribute value
    removeTextFromElements("[".concat(DEFAULT_PROGRAMMATIC_ACTION_NAME_ATTRIBUTE, "]"));
    if (userProgrammaticAttribute) {
      removeTextFromElements("[".concat(userProgrammaticAttribute, "]"));
    }
    if (privacyEnabledActionName) {
      // remove the text of elements with privacy override
      removeTextFromElements("".concat(getPrivacySelector(NodePrivacyLevel.HIDDEN), ", ").concat(getPrivacySelector(NodePrivacyLevel.MASK)));
    }
    return text_1;
  }
  return element.textContent;
}
/**
 * Returns true if element.innerText excludes the text from inline SCRIPT and STYLE element. This
 * should be the case everywhere except on Internet Explorer 10 and 11 (see [1])
 *
 * The innerText property relies on what is actually rendered to compute its output, so to check if
 * it actually excludes SCRIPT and STYLE content, a solution would be to create a style element, set
 * its content to '*', inject it in the document body, and check if the style element innerText
 * property returns '*'. Using a new `document` instance won't work as it is not rendered.
 *
 * This solution requires specific CSP rules (see [2]) to be set by the customer. We want to avoid
 * this, so instead we rely on browser detection. In case of false negative, the impact should be
 * low, since we rely on this result to remove the SCRIPT and STYLE innerText (which will be empty)
 * from a parent element innerText.
 *
 * [1]: https://web.archive.org/web/20210602165716/http://perfectionkills.com/the-poor-misunderstood-innerText/#diff-with-textContent
 * [2]: https://github.com/DataDog/browser-sdk/issues/1084
 */
function supportsInnerTextScriptAndStyleRemoval() {
  return !isIE();
}
/**
 * Returns true if the browser supports the element.labels property.  This should be the case
 * everywhere except on Internet Explorer.
 * Note: The result is computed lazily, because we don't want any DOM access when the SDK is
 * evaluated.
 */
var supportsLabelPropertyResult;
function supportsLabelProperty() {
  if (supportsLabelPropertyResult === undefined) {
    supportsLabelPropertyResult = 'labels' in HTMLInputElement.prototype;
  }
  return supportsLabelPropertyResult;
}
/**
 * Returns true if the browser supports the element.closest method.  This should be the case
 * everywhere except on Internet Explorer.
 * Note: The result is computed lazily, because we don't want any DOM access when the SDK is
 * evaluated.
 */
var supportsElementClosestResult;
function supportsElementClosest() {
  if (supportsElementClosestResult === undefined) {
    supportsElementClosestResult = 'closest' in HTMLElement.prototype;
  }
  return supportsElementClosestResult;
}

/**
 * Stable attributes are attributes that are commonly used to identify parts of a UI (ex:
 * component). Those attribute values should not be generated randomly (hardcoded most of the time)
 * and stay the same across deploys. They are not necessarily unique across the document.
 */
var STABLE_ATTRIBUTES = [DEFAULT_PROGRAMMATIC_ACTION_NAME_ATTRIBUTE,
// Common test attributes (list provided by google recorder)
'data-testid', 'data-test', 'data-qa', 'data-cy', 'data-test-id', 'data-qa-id', 'data-testing',
// FullStory decorator attributes:
'data-component', 'data-element', 'data-source-file'];
// Selectors to use if they target a single element on the whole document. Those selectors are
// considered as "stable" and uniquely identify an element regardless of the page state. If we find
// one, we should consider the selector "complete" and stop iterating over ancestors.
var GLOBALLY_UNIQUE_SELECTOR_GETTERS = [getStableAttributeSelector, getIDSelector];
// Selectors to use if they target a single element among an element descendants. Those selectors
// are more brittle than "globally unique" selectors and should be combined with ancestor selectors
// to improve specificity.
var UNIQUE_AMONG_CHILDREN_SELECTOR_GETTERS = [getStableAttributeSelector, getClassSelector, getTagNameSelector];
function getSelectorFromElement(targetElement, actionNameAttribute) {
  if (!isConnected(targetElement)) {
    // We cannot compute a selector for a detached element, as we don't have access to all of its
    // parents, and we cannot determine if it's unique in the document.
    return;
  }
  var targetElementSelector;
  var currentElement = targetElement;
  while (currentElement && currentElement.nodeName !== 'HTML') {
    var globallyUniqueSelector = findSelector(currentElement, GLOBALLY_UNIQUE_SELECTOR_GETTERS, isSelectorUniqueGlobally, actionNameAttribute, targetElementSelector);
    if (globallyUniqueSelector) {
      return globallyUniqueSelector;
    }
    var uniqueSelectorAmongChildren = findSelector(currentElement, UNIQUE_AMONG_CHILDREN_SELECTOR_GETTERS, isSelectorUniqueAmongSiblings, actionNameAttribute, targetElementSelector);
    targetElementSelector = uniqueSelectorAmongChildren || combineSelector(getPositionSelector(currentElement), targetElementSelector);
    currentElement = getParentElement(currentElement);
  }
  return targetElementSelector;
}
function isGeneratedValue(value) {
  // To compute the "URL path group", the backend replaces every URL path parts as a question mark
  // if it thinks the part is an identifier. The condition it uses is to checks whether a digit is
  // present.
  //
  // Here, we use the same strategy: if the value contains a digit, we consider it generated. This
  // strategy might be a bit naive and fail in some cases, but there are many fallbacks to generate
  // CSS selectors so it should be fine most of the time.
  return /[0-9]/.test(value);
}
function getIDSelector(element) {
  if (element.id && !isGeneratedValue(element.id)) {
    return "#".concat(cssEscape(element.id));
  }
}
function getClassSelector(element) {
  if (element.tagName === 'BODY') {
    return;
  }
  var classList = getClassList(element);
  for (var i = 0; i < classList.length; i += 1) {
    var className = classList[i];
    if (isGeneratedValue(className)) {
      continue;
    }
    return "".concat(cssEscape(element.tagName), ".").concat(cssEscape(className));
  }
}
function getTagNameSelector(element) {
  return cssEscape(element.tagName);
}
function getStableAttributeSelector(element, actionNameAttribute) {
  if (actionNameAttribute) {
    var selector = getAttributeSelector(actionNameAttribute);
    if (selector) {
      return selector;
    }
  }
  for (var _i = 0, STABLE_ATTRIBUTES_1 = STABLE_ATTRIBUTES; _i < STABLE_ATTRIBUTES_1.length; _i++) {
    var attributeName = STABLE_ATTRIBUTES_1[_i];
    var selector = getAttributeSelector(attributeName);
    if (selector) {
      return selector;
    }
  }
  function getAttributeSelector(attributeName) {
    if (element.hasAttribute(attributeName)) {
      return "".concat(cssEscape(element.tagName), "[").concat(attributeName, "=\"").concat(cssEscape(element.getAttribute(attributeName)), "\"]");
    }
  }
}
function getPositionSelector(element) {
  var sibling = getParentElement(element).firstElementChild;
  var elementIndex = 1;
  while (sibling && sibling !== element) {
    if (sibling.tagName === element.tagName) {
      elementIndex += 1;
    }
    sibling = sibling.nextElementSibling;
  }
  return "".concat(cssEscape(element.tagName), ":nth-of-type(").concat(elementIndex, ")");
}
function findSelector(element, selectorGetters, predicate, actionNameAttribute, childSelector) {
  for (var _i = 0, selectorGetters_1 = selectorGetters; _i < selectorGetters_1.length; _i++) {
    var selectorGetter = selectorGetters_1[_i];
    var elementSelector = selectorGetter(element, actionNameAttribute);
    if (!elementSelector) {
      continue;
    }
    if (predicate(element, elementSelector, childSelector)) {
      return combineSelector(elementSelector, childSelector);
    }
  }
}
/**
 * Check whether the selector is unique among the whole document.
 */
function isSelectorUniqueGlobally(element, elementSelector, childSelector) {
  return element.ownerDocument.querySelectorAll(combineSelector(elementSelector, childSelector)).length === 1;
}
/**
 * Check whether the selector is unique among the element siblings. In other words, it returns true
 * if "ELEMENT_PARENT > CHILD_SELECTOR" returns a single element.
 *
 * @param {Element} currentElement - the element being considered while iterating over the target
 * element ancestors.
 *
 * @param {string} currentElementSelector - a selector that matches the current element. That
 * selector is not a composed selector (i.e. it might be a single tag name, class name...).
 *
 * @param {string|undefined} childSelector - child selector is a selector that targets a descendant
 * of the current element. When undefined, the current element is the target element.
 *
 * # Scope selector usage
 *
 * When composed together, the final selector will be joined with `>` operators to make sure we
 * target direct descendants at each level. In this function, we'll use `querySelector` to check if
 * a selector matches descendants of the current element. But by default, the query selector match
 * elements at any level. Example:
 *
 * ```html
 * <main>
 *   <div>
 *     <span></span>
 *   </div>
 *   <marquee>
 *     <div>
 *       <span></span>
 *     </div>
 *   </marquee>
 * </main>
 * ```
 *
 * `sibling.querySelector('DIV > SPAN')` will match both span elements, so we would consider the
 * selector to be not unique, even if it is unique when we'll compose it with the parent with a `>`
 * operator (`MAIN > DIV > SPAN`).
 *
 * To avoid this, we can use the `:scope` selector to make sure the selector starts from the current
 * sibling (i.e. `sibling.querySelector('DIV:scope > SPAN')` will only match the first span).
 *
 * The result will be less accurate on browsers that don't support :scope (i. e. IE): it will check
 * for any element matching the selector contained in the parent (in other words,
 * "ELEMENT_PARENT CHILD_SELECTOR" returns a single element), regardless of whether the selector is
 * a direct descendant of the element parent. This should not impact results too much: if it
 * inaccurately returns false, we'll just fall back to another strategy.
 *
 * [1]: https://developer.mozilla.org/fr/docs/Web/CSS/:scope
 *
 * # Performance considerations
 *
 * We compute selectors in performance-critical operations (ex: during a click), so we need to make
 * sure the function is as fast as possible. We observed that naively using `querySelectorAll` to
 * check if the selector matches more than 1 element is quite expensive, so we want to avoid it.
 *
 * Because we are iterating the DOM upward and we use that function at every level, we know the
 * child selector is already unique among the current element children, so we don't need to check
 * for the current element subtree.
 *
 * Instead, we can focus on the current element siblings. If we find a single element matching the
 * selector within a sibling, we know that it's not unique. This allows us to use `querySelector`
 * (or `matches`, when the current element is the target element) instead of `querySelectorAll`.
 */
function isSelectorUniqueAmongSiblings(currentElement, currentElementSelector, childSelector) {
  var isSiblingMatching;
  if (childSelector === undefined) {
    // If the child selector is undefined (meaning `currentElement` is the target element, not one
    // of its ancestor), we need to use `matches` to check if the sibling is matching the selector,
    // as `querySelector` only returns a descendant of the element.
    isSiblingMatching = function (sibling) {
      return elementMatches(sibling, currentElementSelector);
    };
  } else {
    var scopedSelector_1 = supportScopeSelector() ? combineSelector("".concat(currentElementSelector, ":scope"), childSelector) : combineSelector(currentElementSelector, childSelector);
    isSiblingMatching = function (sibling) {
      return sibling.querySelector(scopedSelector_1) !== null;
    };
  }
  var parent = getParentElement(currentElement);
  var sibling = parent.firstElementChild;
  while (sibling) {
    if (sibling !== currentElement && isSiblingMatching(sibling)) {
      return false;
    }
    sibling = sibling.nextElementSibling;
  }
  return true;
}
function combineSelector(parent, child) {
  return child ? "".concat(parent, ">").concat(child) : parent;
}
var supportScopeSelectorCache;
function supportScopeSelector() {
  if (supportScopeSelectorCache === undefined) {
    try {
      document.querySelector(':scope');
      supportScopeSelectorCache = true;
    } catch (_a) {
      supportScopeSelectorCache = false;
    }
  }
  return supportScopeSelectorCache;
}
/**
 * Polyfill-utility for the `isConnected` property not supported in IE11
 */
function isConnected(element) {
  if ('isConnected' in
  // cast is to make sure `element` is not inferred as `never` after the check
  element) {
    return element.isConnected;
  }
  return element.ownerDocument.documentElement.contains(element);
}

var MAX_DURATION_BETWEEN_CLICKS = ONE_SECOND;
var MAX_DISTANCE_BETWEEN_CLICKS = 100;
function createClickChain(firstClick, onFinalize) {
  var bufferedClicks = [];
  var status = 0 /* ClickChainStatus.WaitingForMoreClicks */;
  var maxDurationBetweenClicksTimeoutId;
  appendClick(firstClick);
  function appendClick(click) {
    click.stopObservable.subscribe(tryFinalize);
    bufferedClicks.push(click);
    clearTimeout$1(maxDurationBetweenClicksTimeoutId);
    maxDurationBetweenClicksTimeoutId = setTimeout$1(dontAcceptMoreClick, MAX_DURATION_BETWEEN_CLICKS);
  }
  function tryFinalize() {
    if (status === 1 /* ClickChainStatus.WaitingForClicksToStop */ && bufferedClicks.every(function (click) {
      return click.isStopped();
    })) {
      status = 2 /* ClickChainStatus.Finalized */;
      onFinalize(bufferedClicks);
    }
  }
  function dontAcceptMoreClick() {
    clearTimeout$1(maxDurationBetweenClicksTimeoutId);
    if (status === 0 /* ClickChainStatus.WaitingForMoreClicks */) {
      status = 1 /* ClickChainStatus.WaitingForClicksToStop */;
      tryFinalize();
    }
  }
  return {
    tryAppend: function (click) {
      if (status !== 0 /* ClickChainStatus.WaitingForMoreClicks */) {
        return false;
      }
      if (bufferedClicks.length > 0 && !areEventsSimilar(bufferedClicks[bufferedClicks.length - 1].event, click.event)) {
        dontAcceptMoreClick();
        return false;
      }
      appendClick(click);
      return true;
    },
    stop: function () {
      dontAcceptMoreClick();
    }
  };
}
/**
 * Checks whether two events are similar by comparing their target, position and timestamp
 */
function areEventsSimilar(first, second) {
  return first.target === second.target && mouseEventDistance(first, second) <= MAX_DISTANCE_BETWEEN_CLICKS && first.timeStamp - second.timeStamp <= MAX_DURATION_BETWEEN_CLICKS;
}
function mouseEventDistance(origin, other) {
  return Math.sqrt(Math.pow(origin.clientX - other.clientX, 2) + Math.pow(origin.clientY - other.clientY, 2));
}

function listenActionEvents(configuration, _a) {
  var onPointerDown = _a.onPointerDown,
    onPointerUp = _a.onPointerUp;
  var selectionEmptyAtPointerDown;
  var userActivity = {
    selection: false,
    input: false,
    scroll: false
  };
  var clickContext;
  var listeners = [addEventListener(configuration, window, DOM_EVENT.POINTER_DOWN, function (event) {
    if (isValidPointerEvent(event)) {
      selectionEmptyAtPointerDown = isSelectionEmpty();
      userActivity = {
        selection: false,
        input: false,
        scroll: false
      };
      clickContext = onPointerDown(event);
    }
  }, {
    capture: true
  }), addEventListener(configuration, window, DOM_EVENT.SELECTION_CHANGE, function () {
    if (!selectionEmptyAtPointerDown || !isSelectionEmpty()) {
      userActivity.selection = true;
    }
  }, {
    capture: true
  }), addEventListener(configuration, window, DOM_EVENT.SCROLL, function () {
    userActivity.scroll = true;
  }, {
    capture: true,
    passive: true
  }), addEventListener(configuration, window, DOM_EVENT.POINTER_UP, function (event) {
    if (isValidPointerEvent(event) && clickContext) {
      // Use a scoped variable to make sure the value is not changed by other clicks
      var localUserActivity_1 = userActivity;
      onPointerUp(clickContext, event, function () {
        return localUserActivity_1;
      });
      clickContext = undefined;
    }
  }, {
    capture: true
  }), addEventListener(configuration, window, DOM_EVENT.INPUT, function () {
    userActivity.input = true;
  }, {
    capture: true
  })];
  return {
    stop: function () {
      listeners.forEach(function (listener) {
        return listener.stop();
      });
    }
  };
}
function isSelectionEmpty() {
  var selection = window.getSelection();
  return !selection || selection.isCollapsed;
}
function isValidPointerEvent(event) {
  return event.target instanceof Element &&
  // Only consider 'primary' pointer events for now. Multi-touch support could be implemented in
  // the future.
  event.isPrimary !== false;
}

var MIN_CLICKS_PER_SECOND_TO_CONSIDER_RAGE = 3;
function computeFrustration(clicks, rageClick) {
  if (isRage(clicks)) {
    rageClick.addFrustration("rage_click" /* FrustrationType.RAGE_CLICK */);
    if (clicks.some(isDead)) {
      rageClick.addFrustration("dead_click" /* FrustrationType.DEAD_CLICK */);
    }
    if (rageClick.hasError) {
      rageClick.addFrustration("error_click" /* FrustrationType.ERROR_CLICK */);
    }
    return {
      isRage: true
    };
  }
  var hasSelectionChanged = clicks.some(function (click) {
    return click.getUserActivity().selection;
  });
  clicks.forEach(function (click) {
    if (click.hasError) {
      click.addFrustration("error_click" /* FrustrationType.ERROR_CLICK */);
    }
    if (isDead(click) &&
    // Avoid considering clicks part of a double-click or triple-click selections as dead clicks
    !hasSelectionChanged) {
      click.addFrustration("dead_click" /* FrustrationType.DEAD_CLICK */);
    }
  });
  return {
    isRage: false
  };
}
function isRage(clicks) {
  if (clicks.some(function (click) {
    return click.getUserActivity().selection || click.getUserActivity().scroll;
  })) {
    return false;
  }
  for (var i = 0; i < clicks.length - (MIN_CLICKS_PER_SECOND_TO_CONSIDER_RAGE - 1); i += 1) {
    if (clicks[i + MIN_CLICKS_PER_SECOND_TO_CONSIDER_RAGE - 1].event.timeStamp - clicks[i].event.timeStamp <= ONE_SECOND) {
      return true;
    }
  }
  return false;
}
var DEAD_CLICK_EXCLUDE_SELECTOR =
// inputs that don't trigger a meaningful event like "input" when clicked, including textual
// inputs (using a negative selector is shorter here)
'input:not([type="checkbox"]):not([type="radio"]):not([type="button"]):not([type="submit"]):not([type="reset"]):not([type="range"]),' + 'textarea,' + 'select,' +
// contenteditable and their descendants don't always trigger meaningful changes when manipulated
'[contenteditable],' + '[contenteditable] *,' +
// canvas, as there is no good way to detect activity occurring on them
'canvas,' +
// links that are interactive (have an href attribute) or any of their descendants, as they can
// open a new tab or navigate to a hash without triggering a meaningful event
'a[href],' + 'a[href] *';
function isDead(click) {
  if (click.hasPageActivity || click.getUserActivity().input || click.getUserActivity().scroll) {
    return false;
  }
  return !elementMatches(click.event.target, DEAD_CLICK_EXCLUDE_SELECTOR);
}

// Maximum duration for click actions
var CLICK_ACTION_MAX_DURATION = 10 * ONE_SECOND;
var ACTION_CONTEXT_TIME_OUT_DELAY = 5 * ONE_MINUTE; // arbitrary
function trackClickActions(lifeCycle, domMutationObservable, configuration) {
  var history = new ValueHistory(ACTION_CONTEXT_TIME_OUT_DELAY);
  var stopObservable = new Observable();
  var currentClickChain;
  lifeCycle.subscribe(10 /* LifeCycleEventType.SESSION_RENEWED */, function () {
    history.reset();
  });
  lifeCycle.subscribe(5 /* LifeCycleEventType.VIEW_ENDED */, stopClickChain);
  var stopActionEventsListener = listenActionEvents(configuration, {
    onPointerDown: function (pointerDownEvent) {
      return processPointerDown(configuration, lifeCycle, domMutationObservable, pointerDownEvent);
    },
    onPointerUp: function (_a, startEvent, getUserActivity) {
      var clickActionBase = _a.clickActionBase,
        hadActivityOnPointerDown = _a.hadActivityOnPointerDown;
      startClickAction(configuration, lifeCycle, domMutationObservable, history, stopObservable, appendClickToClickChain, clickActionBase, startEvent, getUserActivity, hadActivityOnPointerDown);
    }
  }).stop;
  var actionContexts = {
    findActionId: function (startTime) {
      return history.findAll(startTime);
    }
  };
  return {
    stop: function () {
      stopClickChain();
      stopObservable.notify();
      stopActionEventsListener();
    },
    actionContexts: actionContexts
  };
  function appendClickToClickChain(click) {
    if (!currentClickChain || !currentClickChain.tryAppend(click)) {
      var rageClick_1 = click.clone();
      currentClickChain = createClickChain(click, function (clicks) {
        finalizeClicks(clicks, rageClick_1);
      });
    }
  }
  function stopClickChain() {
    if (currentClickChain) {
      currentClickChain.stop();
    }
  }
}
function processPointerDown(configuration, lifeCycle, domMutationObservable, pointerDownEvent) {
  var nodePrivacyLevel = configuration.enablePrivacyForActionName ? getNodePrivacyLevel(pointerDownEvent.target, configuration.defaultPrivacyLevel) : NodePrivacyLevel.ALLOW;
  if (nodePrivacyLevel === NodePrivacyLevel.HIDDEN) {
    return undefined;
  }
  var clickActionBase = computeClickActionBase(pointerDownEvent, nodePrivacyLevel, configuration);
  var hadActivityOnPointerDown = false;
  waitPageActivityEnd(lifeCycle, domMutationObservable, configuration, function (pageActivityEndEvent) {
    hadActivityOnPointerDown = pageActivityEndEvent.hadActivity;
  },
  // We don't care about the activity duration, we just want to know whether an activity did happen
  // within the "validation delay" or not. Limit the duration so the callback is called sooner.
  PAGE_ACTIVITY_VALIDATION_DELAY);
  return {
    clickActionBase: clickActionBase,
    hadActivityOnPointerDown: function () {
      return hadActivityOnPointerDown;
    }
  };
}
function startClickAction(configuration, lifeCycle, domMutationObservable, history, stopObservable, appendClickToClickChain, clickActionBase, startEvent, getUserActivity, hadActivityOnPointerDown) {
  var click = newClick(lifeCycle, history, getUserActivity, clickActionBase, startEvent);
  appendClickToClickChain(click);
  var stopWaitPageActivityEnd = waitPageActivityEnd(lifeCycle, domMutationObservable, configuration, function (pageActivityEndEvent) {
    if (pageActivityEndEvent.hadActivity && pageActivityEndEvent.end < click.startClocks.timeStamp) {
      // If the clock is looking weird, just discard the click
      click.discard();
    } else {
      if (pageActivityEndEvent.hadActivity) {
        click.stop(pageActivityEndEvent.end);
      } else if (hadActivityOnPointerDown()) {
        click.stop(
        // using the click start as activity end, so the click will have some activity but its
        // duration will be 0 (as the activity started before the click start)
        click.startClocks.timeStamp);
      } else {
        click.stop();
      }
    }
  }, CLICK_ACTION_MAX_DURATION).stop;
  var viewEndedSubscription = lifeCycle.subscribe(5 /* LifeCycleEventType.VIEW_ENDED */, function (_a) {
    var endClocks = _a.endClocks;
    click.stop(endClocks.timeStamp);
  });
  var stopSubscription = stopObservable.subscribe(function () {
    click.stop();
  });
  click.stopObservable.subscribe(function () {
    viewEndedSubscription.unsubscribe();
    stopWaitPageActivityEnd();
    stopSubscription.unsubscribe();
  });
}
function computeClickActionBase(event, nodePrivacyLevel, configuration) {
  var rect = event.target.getBoundingClientRect();
  return {
    type: "click" /* ActionType.CLICK */,
    target: {
      width: Math.round(rect.width),
      height: Math.round(rect.height),
      selector: getSelectorFromElement(event.target, configuration.actionNameAttribute)
    },
    position: {
      // Use clientX and Y because for SVG element offsetX and Y are relatives to the <svg> element
      x: Math.round(event.clientX - rect.left),
      y: Math.round(event.clientY - rect.top)
    },
    name: getActionNameFromElement(event.target, configuration, nodePrivacyLevel)
  };
}
function newClick(lifeCycle, history, getUserActivity, clickActionBase, startEvent) {
  var id = generateUUID();
  var startClocks = clocksNow();
  var historyEntry = history.add(id, startClocks.relative);
  var eventCountsSubscription = trackEventCounts({
    lifeCycle: lifeCycle,
    isChildEvent: function (event) {
      return event.action !== undefined && (Array.isArray(event.action.id) ? includes(event.action.id, id) : event.action.id === id);
    }
  });
  var status = 0 /* ClickStatus.ONGOING */;
  var activityEndTime;
  var frustrationTypes = [];
  var stopObservable = new Observable();
  function stop(newActivityEndTime) {
    if (status !== 0 /* ClickStatus.ONGOING */) {
      return;
    }
    activityEndTime = newActivityEndTime;
    status = 1 /* ClickStatus.STOPPED */;
    if (activityEndTime) {
      historyEntry.close(getRelativeTime(activityEndTime));
    } else {
      historyEntry.remove();
    }
    eventCountsSubscription.stop();
    stopObservable.notify();
  }
  return {
    event: startEvent,
    stop: stop,
    stopObservable: stopObservable,
    get hasError() {
      return eventCountsSubscription.eventCounts.errorCount > 0;
    },
    get hasPageActivity() {
      return activityEndTime !== undefined;
    },
    getUserActivity: getUserActivity,
    addFrustration: function (frustrationType) {
      frustrationTypes.push(frustrationType);
    },
    startClocks: startClocks,
    isStopped: function () {
      return status === 1 /* ClickStatus.STOPPED */ || status === 2 /* ClickStatus.FINALIZED */;
    },
    clone: function () {
      return newClick(lifeCycle, history, getUserActivity, clickActionBase, startEvent);
    },
    validate: function (domEvents) {
      stop();
      if (status !== 1 /* ClickStatus.STOPPED */) {
        return;
      }
      var _a = eventCountsSubscription.eventCounts,
        resourceCount = _a.resourceCount,
        errorCount = _a.errorCount,
        longTaskCount = _a.longTaskCount;
      var clickAction = assign({
        type: "click" /* ActionType.CLICK */,
        duration: activityEndTime && elapsed(startClocks.timeStamp, activityEndTime),
        startClocks: startClocks,
        id: id,
        frustrationTypes: frustrationTypes,
        counts: {
          resourceCount: resourceCount,
          errorCount: errorCount,
          longTaskCount: longTaskCount
        },
        events: domEvents !== null && domEvents !== void 0 ? domEvents : [startEvent],
        event: startEvent
      }, clickActionBase);
      lifeCycle.notify(1 /* LifeCycleEventType.AUTO_ACTION_COMPLETED */, clickAction);
      status = 2 /* ClickStatus.FINALIZED */;
    },
    discard: function () {
      stop();
      status = 2 /* ClickStatus.FINALIZED */;
    }
  };
}
function finalizeClicks(clicks, rageClick) {
  var isRage = computeFrustration(clicks, rageClick).isRage;
  if (isRage) {
    clicks.forEach(function (click) {
      return click.discard();
    });
    rageClick.stop(timeStampNow());
    rageClick.validate(clicks.map(function (click) {
      return click.event;
    }));
  } else {
    rageClick.discard();
    clicks.forEach(function (click) {
      return click.validate();
    });
  }
}

function startActionCollection(lifeCycle, domMutationObservable, configuration, pageStateHistory) {
  lifeCycle.subscribe(1 /* LifeCycleEventType.AUTO_ACTION_COMPLETED */, function (action) {
    return lifeCycle.notify(12 /* LifeCycleEventType.RAW_RUM_EVENT_COLLECTED */, processAction(action, pageStateHistory));
  });
  var actionContexts = {
    findActionId: noop$1
  };
  if (configuration.trackUserInteractions) {
    actionContexts = trackClickActions(lifeCycle, domMutationObservable, configuration).actionContexts;
  }
  return {
    addAction: function (action, savedCommonContext) {
      lifeCycle.notify(12 /* LifeCycleEventType.RAW_RUM_EVENT_COLLECTED */, assign({
        savedCommonContext: savedCommonContext
      }, processAction(action, pageStateHistory)));
    },
    actionContexts: actionContexts
  };
}
function processAction(action, pageStateHistory) {
  var autoActionProperties = isAutoAction(action) ? {
    action: {
      id: action.id,
      loading_time: discardNegativeDuration(toServerDuration(action.duration)),
      frustration: {
        type: action.frustrationTypes
      },
      error: {
        count: action.counts.errorCount
      },
      long_task: {
        count: action.counts.longTaskCount
      },
      resource: {
        count: action.counts.resourceCount
      }
    },
    _dd: {
      action: {
        target: action.target,
        position: action.position
      }
    }
  } : undefined;
  var customerContext = !isAutoAction(action) ? action.context : undefined;
  var actionEvent = combine({
    action: {
      id: generateUUID(),
      target: {
        name: action.name
      },
      type: action.type
    },
    date: action.startClocks.timeStamp,
    type: "action" /* RumEventType.ACTION */,
    view: {
      in_foreground: pageStateHistory.wasInPageStateAt("active" /* PageState.ACTIVE */, action.startClocks.relative)
    }
  }, autoActionProperties);
  var domainContext = isAutoAction(action) ? {
    events: action.events
  } : {};
  if (!isAutoAction(action) && action.handlingStack) {
    domainContext.handlingStack = action.handlingStack;
  }
  return {
    customerContext: customerContext,
    rawRumEvent: actionEvent,
    startTime: action.startClocks.relative,
    domainContext: domainContext
  };
}
function isAutoAction(action) {
  return action.type !== "custom" /* ActionType.CUSTOM */;
}

function trackConsoleError(errorObservable) {
  var subscription = initConsoleObservable([ConsoleApiName.error]).subscribe(function (consoleError) {
    return errorObservable.notify({
      startClocks: clocksNow(),
      message: consoleError.message,
      stack: consoleError.stack,
      fingerprint: consoleError.fingerprint,
      source: ErrorSource.CONSOLE,
      handling: "handled" /* ErrorHandling.HANDLED */,
      handlingStack: consoleError.handlingStack
    });
  });
  return {
    stop: function () {
      subscription.unsubscribe();
    }
  };
}

function trackReportError(configuration, errorObservable) {
  var subscription = initReportObservable(configuration, [RawReportType.cspViolation, RawReportType.intervention]).subscribe(function (reportError) {
    var rawError = {
      startClocks: clocksNow(),
      message: reportError.message,
      stack: reportError.stack,
      type: reportError.subtype,
      source: ErrorSource.REPORT,
      handling: "unhandled" /* ErrorHandling.UNHANDLED */,
      originalError: reportError.originalReport
    };
    if (reportError.originalReport.type === 'securitypolicyviolation') {
      rawError.csp = {
        disposition: reportError.originalReport.disposition
      };
    }
    return errorObservable.notify(rawError);
  });
  return {
    stop: function () {
      subscription.unsubscribe();
    }
  };
}

function startErrorCollection(lifeCycle, configuration, pageStateHistory, featureFlagContexts) {
  var errorObservable = new Observable();
  trackConsoleError(errorObservable);
  trackRuntimeError(errorObservable);
  trackReportError(configuration, errorObservable);
  errorObservable.subscribe(function (error) {
    return lifeCycle.notify(14 /* LifeCycleEventType.RAW_ERROR_COLLECTED */, {
      error: error
    });
  });
  return doStartErrorCollection(lifeCycle, pageStateHistory, featureFlagContexts);
}
function doStartErrorCollection(lifeCycle, pageStateHistory, featureFlagContexts) {
  lifeCycle.subscribe(14 /* LifeCycleEventType.RAW_ERROR_COLLECTED */, function (_a) {
    var error = _a.error,
      customerContext = _a.customerContext,
      savedCommonContext = _a.savedCommonContext;
    lifeCycle.notify(12 /* LifeCycleEventType.RAW_RUM_EVENT_COLLECTED */, assign({
      customerContext: customerContext,
      savedCommonContext: savedCommonContext
    }, processError(error, pageStateHistory, featureFlagContexts)));
  });
  return {
    addError: function (_a, savedCommonContext) {
      var error = _a.error,
        handlingStack = _a.handlingStack,
        startClocks = _a.startClocks,
        customerContext = _a.context;
      var stackTrace = error instanceof Error ? computeStackTrace(error) : undefined;
      var rawError = computeRawError({
        stackTrace: stackTrace,
        originalError: error,
        handlingStack: handlingStack,
        startClocks: startClocks,
        nonErrorPrefix: "Provided" /* NonErrorPrefix.PROVIDED */,
        source: ErrorSource.CUSTOM,
        handling: "handled" /* ErrorHandling.HANDLED */
      });
      lifeCycle.notify(14 /* LifeCycleEventType.RAW_ERROR_COLLECTED */, {
        customerContext: customerContext,
        savedCommonContext: savedCommonContext,
        error: rawError
      });
    }
  };
}
function processError(error, pageStateHistory, featureFlagContexts) {
  var rawRumEvent = {
    date: error.startClocks.timeStamp,
    error: {
      id: generateUUID(),
      message: error.message,
      source: error.source,
      stack: error.stack,
      handling_stack: error.handlingStack,
      type: error.type,
      handling: error.handling,
      causes: error.causes,
      source_type: 'browser',
      fingerprint: error.fingerprint,
      csp: error.csp
    },
    type: "error" /* RumEventType.ERROR */,
    view: {
      in_foreground: pageStateHistory.wasInPageStateAt("active" /* PageState.ACTIVE */, error.startClocks.relative)
    }
  };
  var featureFlagContext = featureFlagContexts.findFeatureFlagEvaluations(error.startClocks.relative);
  if (featureFlagContext && !isEmptyObject(featureFlagContext)) {
    rawRumEvent.feature_flags = featureFlagContext;
  }
  var domainContext = {
    error: error.originalError,
    handlingStack: error.handlingStack
  };
  return {
    rawRumEvent: rawRumEvent,
    startTime: error.startClocks.relative,
    domainContext: domainContext
  };
}

function startLongTaskCollection(lifeCycle, configuration) {
  lifeCycle.subscribe(0 /* LifeCycleEventType.PERFORMANCE_ENTRIES_COLLECTED */, function (entries) {
    for (var _i = 0, entries_1 = entries; _i < entries_1.length; _i++) {
      var entry = entries_1[_i];
      if (entry.entryType !== RumPerformanceEntryType.LONG_TASK) {
        break;
      }
      if (!configuration.trackLongTasks) {
        break;
      }
      var startClocks = relativeToClocks(entry.startTime);
      var rawRumEvent = {
        date: startClocks.timeStamp,
        long_task: {
          id: generateUUID(),
          duration: toServerDuration(entry.duration)
        },
        type: "long_task" /* RumEventType.LONG_TASK */,
        _dd: {
          discarded: false
        }
      };
      lifeCycle.notify(12 /* LifeCycleEventType.RAW_RUM_EVENT_COLLECTED */, {
        rawRumEvent: rawRumEvent,
        startTime: startClocks.relative,
        domainContext: {
          performanceEntry: entry
        }
      });
    }
  });
}

var alreadyMatchedEntries = new WeakSet$1();
/**
 * Look for corresponding timing in resource timing buffer
 *
 * Observations:
 * - Timing (start, end) are nested inside the request (start, end)
 * - Some timing can be not exactly nested, being off by < 1 ms
 *
 * Strategy:
 * - from valid nested entries (with 1 ms error margin)
 * - filter out timing that were already matched to a request
 * - then, if a single timing match, return the timing
 * - otherwise we can't decide, return undefined
 */
function matchRequestTiming(request) {
  if (!performance || !('getEntriesByName' in performance)) {
    return;
  }
  var sameNameEntries = performance.getEntriesByName(request.url, 'resource');
  if (!sameNameEntries.length || !('toJSON' in sameNameEntries[0])) {
    return;
  }
  var candidates = sameNameEntries.filter(function (entry) {
    return !alreadyMatchedEntries.has(entry);
  }).filter(function (entry) {
    return isValidEntry(entry);
  }).filter(function (entry) {
    return isBetween(entry, request.startClocks.relative, endTime({
      startTime: request.startClocks.relative,
      duration: request.duration
    }));
  });
  if (candidates.length === 1) {
    alreadyMatchedEntries.add(candidates[0]);
    return candidates[0].toJSON();
  }
  return;
}
function endTime(timing) {
  return addDuration(timing.startTime, timing.duration);
}
function isBetween(timing, start, end) {
  var errorMargin = 1;
  return timing.startTime >= start - errorMargin && endTime(timing) <= addDuration(end, errorMargin);
}

var INITIAL_DOCUMENT_OUTDATED_TRACE_ID_THRESHOLD = 2 * ONE_MINUTE;
function getDocumentTraceId(document) {
  var data = getDocumentTraceDataFromMeta(document) || getDocumentTraceDataFromComment(document);
  if (!data || data.traceTime <= dateNow() - INITIAL_DOCUMENT_OUTDATED_TRACE_ID_THRESHOLD) {
    return undefined;
  }
  return data.traceId;
}
function getDocumentTraceDataFromMeta(document) {
  var traceIdMeta = document.querySelector('meta[name=dd-trace-id]');
  var traceTimeMeta = document.querySelector('meta[name=dd-trace-time]');
  return createDocumentTraceData(traceIdMeta && traceIdMeta.content, traceTimeMeta && traceTimeMeta.content);
}
function getDocumentTraceDataFromComment(document) {
  var comment = findTraceComment(document);
  if (!comment) {
    return undefined;
  }
  return createDocumentTraceData(findCommaSeparatedValue(comment, 'trace-id'), findCommaSeparatedValue(comment, 'trace-time'));
}
function createDocumentTraceData(traceId, rawTraceTime) {
  var traceTime = rawTraceTime && Number(rawTraceTime);
  if (!traceId || !traceTime) {
    return undefined;
  }
  return {
    traceId: traceId,
    traceTime: traceTime
  };
}
function findTraceComment(document) {
  // 1. Try to find the comment as a direct child of the document
  // Note: TSLint advises to use a 'for of', but TS doesn't allow to use 'for of' if the iterated
  // value is not an array or string (here, a NodeList).
  for (var i = 0; i < document.childNodes.length; i += 1) {
    var comment = getTraceCommentFromNode(document.childNodes[i]);
    if (comment) {
      return comment;
    }
  }
  // 2. If the comment is placed after the </html> tag, but have some space or new lines before or
  // after, the DOM parser will lift it (and the surrounding text) at the end of the <body> tag.
  // Try to look for the comment at the end of the <body> by by iterating over its child nodes in
  // reverse order, stopping if we come across a non-text node.
  if (document.body) {
    for (var i = document.body.childNodes.length - 1; i >= 0; i -= 1) {
      var node = document.body.childNodes[i];
      var comment = getTraceCommentFromNode(node);
      if (comment) {
        return comment;
      }
      if (!isTextNode(node)) {
        break;
      }
    }
  }
}
function getTraceCommentFromNode(node) {
  if (node && isCommentNode(node)) {
    var match = /^\s*DATADOG;(.*?)\s*$/.exec(node.data);
    if (match) {
      return match[1];
    }
  }
}

function retrieveInitialDocumentResourceTiming(configuration, callback) {
  runOnReadyState(configuration, 'interactive', function () {
    var timing;
    var forcedAttributes = {
      entryType: RumPerformanceEntryType.RESOURCE,
      initiatorType: FAKE_INITIAL_DOCUMENT,
      traceId: getDocumentTraceId(document),
      toJSON: function () {
        return assign({}, timing, {
          toJSON: undefined
        });
      }
    };
    if (supportPerformanceTimingEvent(RumPerformanceEntryType.NAVIGATION) && performance.getEntriesByType(RumPerformanceEntryType.NAVIGATION).length > 0) {
      var navigationEntry = performance.getEntriesByType(RumPerformanceEntryType.NAVIGATION)[0];
      timing = assign(navigationEntry.toJSON(), forcedAttributes);
    } else {
      var relativePerformanceTiming = computeRelativePerformanceTiming();
      timing = assign(relativePerformanceTiming, {
        decodedBodySize: 0,
        encodedBodySize: 0,
        transferSize: 0,
        renderBlockingStatus: 'non-blocking',
        duration: relativePerformanceTiming.responseEnd,
        name: window.location.href,
        startTime: 0
      }, forcedAttributes);
    }
    callback(timing);
  });
}

function startResourceCollection(lifeCycle, configuration, pageStateHistory) {
  lifeCycle.subscribe(8 /* LifeCycleEventType.REQUEST_COMPLETED */, function (request) {
    var rawEvent = processRequest(request, configuration, pageStateHistory);
    if (rawEvent) {
      lifeCycle.notify(12 /* LifeCycleEventType.RAW_RUM_EVENT_COLLECTED */, rawEvent);
    }
  });
  var performanceResourceSubscription = createPerformanceObservable(configuration, {
    type: RumPerformanceEntryType.RESOURCE,
    buffered: true
  }).subscribe(function (entries) {
    for (var _i = 0, entries_1 = entries; _i < entries_1.length; _i++) {
      var entry = entries_1[_i];
      if (!isRequestKind(entry)) {
        var rawEvent = processResourceEntry(entry, configuration);
        if (rawEvent) {
          lifeCycle.notify(12 /* LifeCycleEventType.RAW_RUM_EVENT_COLLECTED */, rawEvent);
        }
      }
    }
  });
  retrieveInitialDocumentResourceTiming(configuration, function (timing) {
    var rawEvent = processResourceEntry(timing, configuration);
    if (rawEvent) {
      lifeCycle.notify(12 /* LifeCycleEventType.RAW_RUM_EVENT_COLLECTED */, rawEvent);
    }
  });
  return {
    stop: function () {
      performanceResourceSubscription.unsubscribe();
    }
  };
}
function processRequest(request, configuration, pageStateHistory) {
  var matchingTiming = matchRequestTiming(request);
  var startClocks = matchingTiming ? relativeToClocks(matchingTiming.startTime) : request.startClocks;
  var tracingInfo = computeRequestTracingInfo(request, configuration);
  if (!configuration.trackResources && !tracingInfo) {
    return;
  }
  var type = request.type === "xhr" /* RequestType.XHR */ ? "xhr" /* ResourceType.XHR */ : "fetch" /* ResourceType.FETCH */;
  var correspondingTimingOverrides = matchingTiming ? computePerformanceEntryMetrics(matchingTiming) : undefined;
  var duration = computeRequestDuration(pageStateHistory, startClocks, request.duration);
  var resourceEvent = combine({
    date: startClocks.timeStamp,
    resource: {
      id: generateUUID(),
      type: type,
      duration: duration,
      method: request.method,
      status_code: request.status,
      url: isLongDataUrl(request.url) ? sanitizeDataUrl(request.url) : request.url
    },
    type: "resource" /* RumEventType.RESOURCE */,
    _dd: {
      discarded: !configuration.trackResources
    }
  }, tracingInfo, correspondingTimingOverrides);
  return {
    startTime: startClocks.relative,
    rawRumEvent: resourceEvent,
    domainContext: {
      performanceEntry: matchingTiming,
      xhr: request.xhr,
      response: request.response,
      requestInput: request.input,
      requestInit: request.init,
      error: request.error,
      isAborted: request.isAborted,
      handlingStack: request.handlingStack
    }
  };
}
function processResourceEntry(entry, configuration) {
  var startClocks = relativeToClocks(entry.startTime);
  var tracingInfo = computeEntryTracingInfo(entry, configuration);
  if (!configuration.trackResources && !tracingInfo) {
    return;
  }
  var type = computeResourceKind(entry);
  var entryMetrics = computePerformanceEntryMetrics(entry);
  var resourceEvent = combine({
    date: startClocks.timeStamp,
    resource: {
      id: generateUUID(),
      type: type,
      url: entry.name,
      status_code: discardZeroStatus(entry.responseStatus)
    },
    type: "resource" /* RumEventType.RESOURCE */,
    _dd: {
      discarded: !configuration.trackResources
    }
  }, tracingInfo, entryMetrics);
  return {
    startTime: startClocks.relative,
    rawRumEvent: resourceEvent,
    domainContext: {
      performanceEntry: entry
    }
  };
}
function computePerformanceEntryMetrics(timing) {
  var renderBlockingStatus = timing.renderBlockingStatus;
  return {
    resource: assign({
      duration: computePerformanceResourceDuration(timing),
      render_blocking_status: renderBlockingStatus
    }, computeSize(timing), computePerformanceResourceDetails(timing))
  };
}
function computeRequestTracingInfo(request, configuration) {
  var hasBeenTraced = request.traceSampled && request.traceId && request.spanId;
  if (!hasBeenTraced) {
    return undefined;
  }
  return {
    _dd: {
      span_id: request.spanId.toDecimalString(),
      trace_id: request.traceId.toDecimalString(),
      rule_psr: getRulePsr(configuration)
    }
  };
}
function computeEntryTracingInfo(entry, configuration) {
  var hasBeenTraced = entry.traceId;
  if (!hasBeenTraced) {
    return undefined;
  }
  return {
    _dd: {
      trace_id: entry.traceId,
      span_id: new TraceIdentifier().toDecimalString(),
      rule_psr: getRulePsr(configuration)
    }
  };
}
/**
 * @returns number between 0 and 1 which represents trace sample rate
 */
function getRulePsr(configuration) {
  return isNumber(configuration.traceSampleRate) ? configuration.traceSampleRate / 100 : undefined;
}
function computeRequestDuration(pageStateHistory, startClocks, duration) {
  return !pageStateHistory.wasInPageStateDuringPeriod("frozen" /* PageState.FROZEN */, startClocks.relative, duration) ? toServerDuration(duration) : undefined;
}
/**
 * The status is 0 for cross-origin resources without CORS headers, so the status is meaningless, and we shouldn't report it
 * https://developer.mozilla.org/en-US/docs/Web/API/PerformanceResourceTiming/responseStatus#cross-origin_response_status_codes
 */
function discardZeroStatus(statusCode) {
  return statusCode === 0 ? undefined : statusCode;
}

function trackViewEventCounts(lifeCycle, viewId, onChange) {
  var _a = trackEventCounts({
      lifeCycle: lifeCycle,
      isChildEvent: function (event) {
        return event.view.id === viewId;
      },
      onChange: onChange
    }),
    stop = _a.stop,
    eventCounts = _a.eventCounts;
  return {
    stop: stop,
    eventCounts: eventCounts
  };
}

// Discard FCP timings above a certain delay to avoid incorrect data
// It happens in some cases like sleep mode or some browser implementations
var FCP_MAXIMUM_DELAY = 10 * ONE_MINUTE;
function trackFirstContentfulPaint(lifeCycle, firstHidden, callback) {
  var unsubscribeLifeCycle = lifeCycle.subscribe(0 /* LifeCycleEventType.PERFORMANCE_ENTRIES_COLLECTED */, function (entries) {
    var fcpEntry = find(entries, function (entry) {
      return entry.entryType === RumPerformanceEntryType.PAINT && entry.name === 'first-contentful-paint' && entry.startTime < firstHidden.timeStamp && entry.startTime < FCP_MAXIMUM_DELAY;
    });
    if (fcpEntry) {
      callback(fcpEntry.startTime);
    }
  }).unsubscribe;
  return {
    stop: unsubscribeLifeCycle
  };
}

/**
 * Track the first input occurring during the initial View to return:
 * - First Input Delay
 * - First Input Time
 * Callback is called at most one time.
 * Documentation: https://web.dev/fid/
 * Reference implementation: https://github.com/GoogleChrome/web-vitals/blob/master/src/getFID.ts
 */
function trackFirstInput(lifeCycle, configuration, firstHidden, callback) {
  var unsubscribeLifeCycle = lifeCycle.subscribe(0 /* LifeCycleEventType.PERFORMANCE_ENTRIES_COLLECTED */, function (entries) {
    var firstInputEntry = find(entries, function (entry) {
      return entry.entryType === RumPerformanceEntryType.FIRST_INPUT && entry.startTime < firstHidden.timeStamp;
    });
    if (firstInputEntry) {
      var firstInputDelay = elapsed(firstInputEntry.startTime, firstInputEntry.processingStart);
      var firstInputTargetSelector = void 0;
      if (firstInputEntry.target && isElementNode(firstInputEntry.target)) {
        firstInputTargetSelector = getSelectorFromElement(firstInputEntry.target, configuration.actionNameAttribute);
      }
      callback({
        // Ensure firstInputDelay to be positive, see
        // https://bugs.chromium.org/p/chromium/issues/detail?id=1185815
        delay: firstInputDelay >= 0 ? firstInputDelay : 0,
        time: firstInputEntry.startTime,
        targetSelector: firstInputTargetSelector
      });
    }
  }).unsubscribe;
  return {
    stop: unsubscribeLifeCycle
  };
}

function trackNavigationTimings(lifeCycle, callback) {
  var stop = lifeCycle.subscribe(0 /* LifeCycleEventType.PERFORMANCE_ENTRIES_COLLECTED */, function (entries) {
    for (var _i = 0, entries_1 = entries; _i < entries_1.length; _i++) {
      var entry = entries_1[_i];
      if (entry.entryType === RumPerformanceEntryType.NAVIGATION) {
        callback({
          domComplete: entry.domComplete,
          domContentLoaded: entry.domContentLoadedEventEnd,
          domInteractive: entry.domInteractive,
          loadEvent: entry.loadEventEnd,
          // In some cases the value reported is negative or is larger
          // than the current page time. Ignore these cases:
          // https://github.com/GoogleChrome/web-vitals/issues/137
          // https://github.com/GoogleChrome/web-vitals/issues/162
          firstByte: entry.responseStart >= 0 && entry.responseStart <= relativeNow() ? entry.responseStart : undefined
        });
      }
    }
  }).unsubscribe;
  return {
    stop: stop
  };
}

// Discard LCP timings above a certain delay to avoid incorrect data
// It happens in some cases like sleep mode or some browser implementations
var LCP_MAXIMUM_DELAY = 10 * ONE_MINUTE;
/**
 * Track the largest contentful paint (LCP) occurring during the initial View.  This can yield
 * multiple values, only the most recent one should be used.
 * Documentation: https://web.dev/lcp/
 * Reference implementation: https://github.com/GoogleChrome/web-vitals/blob/master/src/onLCP.ts
 */
function trackLargestContentfulPaint(lifeCycle, configuration, firstHidden, eventTarget, callback) {
  // Ignore entries that come after the first user interaction. According to the documentation, the
  // browser should not send largest-contentful-paint entries after a user interact with the page,
  // but the web-vitals reference implementation uses this as a safeguard.
  var firstInteractionTimestamp = Infinity;
  var stopEventListener = addEventListeners(configuration, eventTarget, [DOM_EVENT.POINTER_DOWN, DOM_EVENT.KEY_DOWN], function (event) {
    firstInteractionTimestamp = event.timeStamp;
  }, {
    capture: true,
    once: true
  }).stop;
  var biggestLcpSize = 0;
  var unsubscribeLifeCycle = lifeCycle.subscribe(0 /* LifeCycleEventType.PERFORMANCE_ENTRIES_COLLECTED */, function (entries) {
    var lcpEntry = findLast(entries, function (entry) {
      return entry.entryType === RumPerformanceEntryType.LARGEST_CONTENTFUL_PAINT && entry.startTime < firstInteractionTimestamp && entry.startTime < firstHidden.timeStamp && entry.startTime < LCP_MAXIMUM_DELAY &&
      // Ensure to get the LCP entry with the biggest size, see
      // https://bugs.chromium.org/p/chromium/issues/detail?id=1516655
      entry.size > biggestLcpSize;
    });
    if (lcpEntry) {
      var lcpTargetSelector = void 0;
      if (lcpEntry.element) {
        lcpTargetSelector = getSelectorFromElement(lcpEntry.element, configuration.actionNameAttribute);
      }
      callback({
        value: lcpEntry.startTime,
        targetSelector: lcpTargetSelector
      });
      biggestLcpSize = lcpEntry.size;
    }
  }).unsubscribe;
  return {
    stop: function () {
      stopEventListener();
      unsubscribeLifeCycle();
    }
  };
}

function trackFirstHidden(configuration, eventTarget) {
  if (eventTarget === void 0) {
    eventTarget = window;
  }
  var timeStamp;
  var stopListeners;
  if (document.visibilityState === 'hidden') {
    timeStamp = 0;
  } else {
    timeStamp = Infinity;
    stopListeners = addEventListeners(configuration, eventTarget, [DOM_EVENT.PAGE_HIDE, DOM_EVENT.VISIBILITY_CHANGE], function (event) {
      if (event.type === DOM_EVENT.PAGE_HIDE || document.visibilityState === 'hidden') {
        timeStamp = event.timeStamp;
        stopListeners();
      }
    }, {
      capture: true
    }).stop;
  }
  return {
    get timeStamp() {
      return timeStamp;
    },
    stop: function () {
      stopListeners === null || stopListeners === void 0 ? void 0 : stopListeners();
    }
  };
}

function trackInitialViewMetrics(lifeCycle, configuration, setLoadEvent, scheduleViewUpdate) {
  var initialViewMetrics = {};
  var stopNavigationTracking = trackNavigationTimings(lifeCycle, function (navigationTimings) {
    setLoadEvent(navigationTimings.loadEvent);
    initialViewMetrics.navigationTimings = navigationTimings;
    scheduleViewUpdate();
  }).stop;
  var firstHidden = trackFirstHidden(configuration);
  var stopFCPTracking = trackFirstContentfulPaint(lifeCycle, firstHidden, function (firstContentfulPaint) {
    initialViewMetrics.firstContentfulPaint = firstContentfulPaint;
    scheduleViewUpdate();
  }).stop;
  var stopLCPTracking = trackLargestContentfulPaint(lifeCycle, configuration, firstHidden, window, function (largestContentfulPaint) {
    initialViewMetrics.largestContentfulPaint = largestContentfulPaint;
    scheduleViewUpdate();
  }).stop;
  var stopFIDTracking = trackFirstInput(lifeCycle, configuration, firstHidden, function (firstInput) {
    initialViewMetrics.firstInput = firstInput;
    scheduleViewUpdate();
  }).stop;
  function stop() {
    stopNavigationTracking();
    stopFCPTracking();
    stopLCPTracking();
    stopFIDTracking();
    firstHidden.stop();
  }
  return {
    stop: stop,
    initialViewMetrics: initialViewMetrics
  };
}

/**
 * Track the cumulative layout shifts (CLS).
 * Layout shifts are grouped into session windows.
 * The minimum gap between session windows is 1 second.
 * The maximum duration of a session window is 5 second.
 * The session window layout shift value is the sum of layout shifts inside it.
 * The CLS value is the max of session windows values.
 *
 * This yields a new value whenever the CLS value is updated (a higher session window value is computed).
 *
 * See isLayoutShiftSupported to check for browser support.
 *
 * Documentation:
 * https://web.dev/cls/
 * https://web.dev/evolving-cls/
 * Reference implementation: https://github.com/GoogleChrome/web-vitals/blob/master/src/getCLS.ts
 */
function trackCumulativeLayoutShift(configuration, lifeCycle, viewStart, callback) {
  if (!isLayoutShiftSupported()) {
    return {
      stop: noop$1
    };
  }
  var maxClsValue = 0;
  // WeakRef is not supported in IE11 and Safari mobile, but so is the layout shift API, so this code won't be executed in these browsers
  var maxClsTarget;
  var maxClsStartTime;
  // if no layout shift happen the value should be reported as 0
  callback({
    value: 0
  });
  var window = slidingSessionWindow();
  var stop = lifeCycle.subscribe(0 /* LifeCycleEventType.PERFORMANCE_ENTRIES_COLLECTED */, function (entries) {
    for (var _i = 0, entries_1 = entries; _i < entries_1.length; _i++) {
      var entry = entries_1[_i];
      if (entry.entryType === RumPerformanceEntryType.LAYOUT_SHIFT && !entry.hadRecentInput) {
        var _a = window.update(entry),
          cumulatedValue = _a.cumulatedValue,
          isMaxValue = _a.isMaxValue;
        if (isMaxValue) {
          var target = getTargetFromSource(entry.sources);
          maxClsTarget = target ? new WeakRef(target) : undefined;
          maxClsStartTime = elapsed(viewStart, entry.startTime);
        }
        if (cumulatedValue > maxClsValue) {
          maxClsValue = cumulatedValue;
          var target = maxClsTarget === null || maxClsTarget === void 0 ? void 0 : maxClsTarget.deref();
          callback({
            value: round(maxClsValue, 4),
            targetSelector: target && getSelectorFromElement(target, configuration.actionNameAttribute),
            time: maxClsStartTime
          });
        }
      }
    }
  }).unsubscribe;
  return {
    stop: stop
  };
}
function getTargetFromSource(sources) {
  var _a;
  if (!sources) {
    return;
  }
  return (_a = find(sources, function (source) {
    return !!source.node && isElementNode(source.node);
  })) === null || _a === void 0 ? void 0 : _a.node;
}
var MAX_WINDOW_DURATION = 5 * ONE_SECOND;
var MAX_UPDATE_GAP = ONE_SECOND;
function slidingSessionWindow() {
  var cumulatedValue = 0;
  var startTime;
  var endTime;
  var maxValue = 0;
  return {
    update: function (entry) {
      var shouldCreateNewWindow = startTime === undefined || entry.startTime - endTime >= MAX_UPDATE_GAP || entry.startTime - startTime >= MAX_WINDOW_DURATION;
      var isMaxValue;
      if (shouldCreateNewWindow) {
        startTime = endTime = entry.startTime;
        maxValue = cumulatedValue = entry.value;
        isMaxValue = true;
      } else {
        cumulatedValue += entry.value;
        endTime = entry.startTime;
        isMaxValue = entry.value > maxValue;
        if (isMaxValue) {
          maxValue = entry.value;
        }
      }
      return {
        cumulatedValue: cumulatedValue,
        isMaxValue: isMaxValue
      };
    }
  };
}
/**
 * Check whether `layout-shift` is supported by the browser.
 */
function isLayoutShiftSupported() {
  return supportPerformanceTimingEvent(RumPerformanceEntryType.LAYOUT_SHIFT);
}

/**
 * performance.interactionCount polyfill
 *
 * The interactionCount is an integer which counts the total number of distinct user interactions,
 * for which there was a unique interactionId.
 *
 * The interactionCount polyfill is an estimate based on a convention specific to Chrome. Cf: https://github.com/GoogleChrome/web-vitals/pull/213
 * This is currently not an issue as the polyfill is only used for INP which is currently only supported on Chrome.
 * Hopefully when/if other browsers will support INP, they will also implement performance.interactionCount at the same time, so we won't need that polyfill.
 *
 * Reference implementation: https://github.com/GoogleChrome/web-vitals/blob/main/src/lib/polyfills/interactionCountPolyfill.ts
 */
var observer;
var interactionCountEstimate = 0;
var minKnownInteractionId = Infinity;
var maxKnownInteractionId = 0;
function initInteractionCountPolyfill() {
  if ('interactionCount' in performance || observer) {
    return;
  }
  observer = new window.PerformanceObserver(monitor(function (entries) {
    entries.getEntries().forEach(function (e) {
      var entry = e;
      if (entry.interactionId) {
        minKnownInteractionId = Math.min(minKnownInteractionId, entry.interactionId);
        maxKnownInteractionId = Math.max(maxKnownInteractionId, entry.interactionId);
        interactionCountEstimate = (maxKnownInteractionId - minKnownInteractionId) / 7 + 1;
      }
    });
  }));
  observer.observe({
    type: 'event',
    buffered: true,
    durationThreshold: 0
  });
}
/**
 * Returns the `interactionCount` value using the native API (if available)
 * or the polyfill estimate in this module.
 */
var getInteractionCount = function () {
  return observer ? interactionCountEstimate : window.performance.interactionCount || 0;
};

// Arbitrary value to prevent unnecessary memory usage on views with lots of interactions.
var MAX_INTERACTION_ENTRIES = 10;
// Arbitrary value to cap INP outliers
var MAX_INP_VALUE = 1 * ONE_MINUTE;
/**
 * Track the interaction to next paint (INP).
 * To avoid outliers, return the p98 worst interaction of the view.
 * Documentation: https://web.dev/inp/
 * Reference implementation: https://github.com/GoogleChrome/web-vitals/blob/main/src/onINP.ts
 */
function trackInteractionToNextPaint(configuration, viewStart, viewLoadingType, lifeCycle) {
  if (!isInteractionToNextPaintSupported()) {
    return {
      getInteractionToNextPaint: function () {
        return undefined;
      },
      setViewEnd: noop$1,
      stop: noop$1
    };
  }
  var _a = trackViewInteractionCount(viewLoadingType),
    getViewInteractionCount = _a.getViewInteractionCount,
    stopViewInteractionCount = _a.stopViewInteractionCount;
  var viewEnd = Infinity;
  var longestInteractions = trackLongestInteractions(getViewInteractionCount);
  var interactionToNextPaint = -1;
  var interactionToNextPaintTargetSelector;
  var interactionToNextPaintStartTime;
  var stop = lifeCycle.subscribe(0 /* LifeCycleEventType.PERFORMANCE_ENTRIES_COLLECTED */, function (entries) {
    for (var _i = 0, entries_1 = entries; _i < entries_1.length; _i++) {
      var entry = entries_1[_i];
      if ((entry.entryType === RumPerformanceEntryType.EVENT || entry.entryType === RumPerformanceEntryType.FIRST_INPUT) && entry.interactionId &&
      // Check the entry start time is inside the view bounds because some view interactions can be reported after the view end (if long duration).
      entry.startTime >= viewStart && entry.startTime <= viewEnd) {
        longestInteractions.process(entry);
      }
    }
    var newInteraction = longestInteractions.estimateP98Interaction();
    if (newInteraction && newInteraction.duration !== interactionToNextPaint) {
      interactionToNextPaint = newInteraction.duration;
      interactionToNextPaintStartTime = elapsed(viewStart, newInteraction.startTime);
      if (newInteraction.target && isElementNode(newInteraction.target)) {
        interactionToNextPaintTargetSelector = getSelectorFromElement(newInteraction.target, configuration.actionNameAttribute);
      } else {
        interactionToNextPaintTargetSelector = undefined;
      }
    }
  }).unsubscribe;
  return {
    getInteractionToNextPaint: function () {
      // If no INP duration where captured because of the performanceObserver 40ms threshold
      // but the view interaction count > 0 then report 0
      if (interactionToNextPaint >= 0) {
        return {
          value: Math.min(interactionToNextPaint, MAX_INP_VALUE),
          targetSelector: interactionToNextPaintTargetSelector,
          time: interactionToNextPaintStartTime
        };
      } else if (getViewInteractionCount()) {
        return {
          value: 0
        };
      }
    },
    setViewEnd: function (viewEndTime) {
      viewEnd = viewEndTime;
      stopViewInteractionCount();
    },
    stop: stop
  };
}
function trackLongestInteractions(getViewInteractionCount) {
  var longestInteractions = [];
  function sortAndTrimLongestInteractions() {
    longestInteractions.sort(function (a, b) {
      return b.duration - a.duration;
    }).splice(MAX_INTERACTION_ENTRIES);
  }
  return {
    /**
     * Process the performance entry:
     * - if its duration is long enough, add the performance entry to the list of worst interactions
     * - if an entry with the same interaction id exists and its duration is lower than the new one, then replace it in the list of worst interactions
     */
    process: function (entry) {
      var interactionIndex = longestInteractions.findIndex(function (interaction) {
        return entry.interactionId === interaction.interactionId;
      });
      var minLongestInteraction = longestInteractions[longestInteractions.length - 1];
      if (interactionIndex !== -1) {
        if (entry.duration > longestInteractions[interactionIndex].duration) {
          longestInteractions[interactionIndex] = entry;
          sortAndTrimLongestInteractions();
        }
      } else if (longestInteractions.length < MAX_INTERACTION_ENTRIES || entry.duration > minLongestInteraction.duration) {
        longestInteractions.push(entry);
        sortAndTrimLongestInteractions();
      }
    },
    /**
     * Compute the p98 longest interaction.
     * For better performance the computation is based on 10 longest interactions and the interaction count of the current view.
     */
    estimateP98Interaction: function () {
      var interactionIndex = Math.min(longestInteractions.length - 1, Math.floor(getViewInteractionCount() / 50));
      return longestInteractions[interactionIndex];
    }
  };
}
function trackViewInteractionCount(viewLoadingType) {
  initInteractionCountPolyfill();
  var previousInteractionCount = viewLoadingType === "initial_load" /* ViewLoadingType.INITIAL_LOAD */ ? 0 : getInteractionCount();
  var state = {
    stopped: false
  };
  function computeViewInteractionCount() {
    return getInteractionCount() - previousInteractionCount;
  }
  return {
    getViewInteractionCount: function () {
      if (state.stopped) {
        return state.interactionCount;
      }
      return computeViewInteractionCount();
    },
    stopViewInteractionCount: function () {
      state = {
        stopped: true,
        interactionCount: computeViewInteractionCount()
      };
    }
  };
}
function isInteractionToNextPaintSupported() {
  return supportPerformanceTimingEvent(RumPerformanceEntryType.EVENT) && window.PerformanceEventTiming && 'interactionId' in PerformanceEventTiming.prototype;
}

function trackLoadingTime(lifeCycle, domMutationObservable, configuration, loadType, viewStart, callback) {
  var isWaitingForLoadEvent = loadType === "initial_load" /* ViewLoadingType.INITIAL_LOAD */;
  var isWaitingForActivityLoadingTime = true;
  var loadingTimeCandidates = [];
  function invokeCallbackIfAllCandidatesAreReceived() {
    if (!isWaitingForActivityLoadingTime && !isWaitingForLoadEvent && loadingTimeCandidates.length > 0) {
      callback(Math.max.apply(Math, loadingTimeCandidates));
    }
  }
  var stop = waitPageActivityEnd(lifeCycle, domMutationObservable, configuration, function (event) {
    if (isWaitingForActivityLoadingTime) {
      isWaitingForActivityLoadingTime = false;
      if (event.hadActivity) {
        loadingTimeCandidates.push(elapsed(viewStart.timeStamp, event.end));
      }
      invokeCallbackIfAllCandidatesAreReceived();
    }
  }).stop;
  return {
    stop: stop,
    setLoadEvent: function (loadEvent) {
      if (isWaitingForLoadEvent) {
        isWaitingForLoadEvent = false;
        loadingTimeCandidates.push(loadEvent);
        invokeCallbackIfAllCandidatesAreReceived();
      }
    }
  };
}

function getScrollX() {
  var scrollX;
  var visual = window.visualViewport;
  if (visual) {
    scrollX = visual.pageLeft - visual.offsetLeft;
  } else if (window.scrollX !== undefined) {
    scrollX = window.scrollX;
  } else {
    scrollX = window.pageXOffset || 0;
  }
  return Math.round(scrollX);
}
function getScrollY() {
  var scrollY;
  var visual = window.visualViewport;
  if (visual) {
    scrollY = visual.pageTop - visual.offsetTop;
  } else if (window.scrollY !== undefined) {
    scrollY = window.scrollY;
  } else {
    scrollY = window.pageYOffset || 0;
  }
  return Math.round(scrollY);
}

var viewportObservable;
function initViewportObservable(configuration) {
  if (!viewportObservable) {
    viewportObservable = createViewportObservable(configuration);
  }
  return viewportObservable;
}
function createViewportObservable(configuration) {
  return new Observable(function (observable) {
    var updateDimension = throttle(function () {
      observable.notify(getViewportDimension());
    }, 200).throttled;
    return addEventListener(configuration, window, DOM_EVENT.RESIZE, updateDimension, {
      capture: true,
      passive: true
    }).stop;
  });
}
// excludes the width and height of any rendered classic scrollbar that is fixed to the visual viewport
function getViewportDimension() {
  var visual = window.visualViewport;
  if (visual) {
    return {
      width: Number(visual.width * visual.scale),
      height: Number(visual.height * visual.scale)
    };
  }
  return {
    width: Number(window.innerWidth || 0),
    height: Number(window.innerHeight || 0)
  };
}

/** Arbitrary scroll throttle duration */
var THROTTLE_SCROLL_DURATION = ONE_SECOND;
function trackScrollMetrics(configuration, viewStart, callback, scrollValues) {
  if (scrollValues === void 0) {
    scrollValues = createScrollValuesObservable(configuration);
  }
  var maxScrollDepth = 0;
  var maxScrollHeight = 0;
  var maxScrollHeightTime = 0;
  var subscription = scrollValues.subscribe(function (_a) {
    var scrollDepth = _a.scrollDepth,
      scrollTop = _a.scrollTop,
      scrollHeight = _a.scrollHeight;
    var shouldUpdate = false;
    if (scrollDepth > maxScrollDepth) {
      maxScrollDepth = scrollDepth;
      shouldUpdate = true;
    }
    if (scrollHeight > maxScrollHeight) {
      maxScrollHeight = scrollHeight;
      var now = relativeNow();
      maxScrollHeightTime = elapsed(viewStart.relative, now);
      shouldUpdate = true;
    }
    if (shouldUpdate) {
      callback({
        maxDepth: Math.min(maxScrollDepth, maxScrollHeight),
        maxDepthScrollTop: scrollTop,
        maxScrollHeight: maxScrollHeight,
        maxScrollHeightTime: maxScrollHeightTime
      });
    }
  });
  return {
    stop: function () {
      return subscription.unsubscribe();
    }
  };
}
function computeScrollValues() {
  var scrollTop = getScrollY();
  var height = getViewportDimension().height;
  var scrollHeight = Math.round((document.scrollingElement || document.documentElement).scrollHeight);
  var scrollDepth = Math.round(height + scrollTop);
  return {
    scrollHeight: scrollHeight,
    scrollDepth: scrollDepth,
    scrollTop: scrollTop
  };
}
function createScrollValuesObservable(configuration, throttleDuration) {
  if (throttleDuration === void 0) {
    throttleDuration = THROTTLE_SCROLL_DURATION;
  }
  return new Observable(function (observable) {
    function notify() {
      observable.notify(computeScrollValues());
    }
    if (window.ResizeObserver) {
      var throttledNotify_1 = throttle(notify, throttleDuration, {
        leading: false,
        trailing: true
      });
      var observerTarget_1 = document.scrollingElement || document.documentElement;
      var resizeObserver_1 = new ResizeObserver(monitor(throttledNotify_1.throttled));
      resizeObserver_1.observe(observerTarget_1);
      var eventListener_1 = addEventListener(configuration, window, DOM_EVENT.SCROLL, throttledNotify_1.throttled, {
        passive: true
      });
      return function () {
        throttledNotify_1.cancel();
        resizeObserver_1.unobserve(observerTarget_1);
        eventListener_1.stop();
      };
    }
  });
}

function trackCommonViewMetrics(lifeCycle, domMutationObservable, configuration, scheduleViewUpdate, loadingType, viewStart) {
  var commonViewMetrics = {};
  var _a = trackLoadingTime(lifeCycle, domMutationObservable, configuration, loadingType, viewStart, function (newLoadingTime) {
      commonViewMetrics.loadingTime = newLoadingTime;
      scheduleViewUpdate();
    }),
    stopLoadingTimeTracking = _a.stop,
    setLoadEvent = _a.setLoadEvent;
  var stopScrollMetricsTracking = trackScrollMetrics(configuration, viewStart, function (newScrollMetrics) {
    commonViewMetrics.scroll = newScrollMetrics;
  }).stop;
  var stopCLSTracking = trackCumulativeLayoutShift(configuration, lifeCycle, viewStart.relative, function (cumulativeLayoutShift) {
    commonViewMetrics.cumulativeLayoutShift = cumulativeLayoutShift;
    scheduleViewUpdate();
  }).stop;
  var _b = trackInteractionToNextPaint(configuration, viewStart.relative, loadingType, lifeCycle),
    stopINPTracking = _b.stop,
    getInteractionToNextPaint = _b.getInteractionToNextPaint,
    setViewEnd = _b.setViewEnd;
  return {
    stop: function () {
      stopLoadingTimeTracking();
      stopCLSTracking();
      stopScrollMetricsTracking();
    },
    stopINPTracking: stopINPTracking,
    setLoadEvent: setLoadEvent,
    setViewEnd: setViewEnd,
    getCommonViewMetrics: function () {
      commonViewMetrics.interactionToNextPaint = getInteractionToNextPaint();
      return commonViewMetrics;
    }
  };
}

var THROTTLE_VIEW_UPDATE_PERIOD = 3000;
var SESSION_KEEP_ALIVE_INTERVAL = 5 * ONE_MINUTE;
// Some events or metrics can be captured after the end of the view. To avoid missing those;
// an arbitrary delay is added for stopping their tracking after the view ends.
//
// Ideally, we would not stop and keep tracking events or metrics until the end of the session.
// But this might have a small performance impact if there are many many views.
// So let's have a fairly short delay improving the situation in most cases and avoid impacting performances too much.
var KEEP_TRACKING_AFTER_VIEW_DELAY = 5 * ONE_MINUTE;
function trackViews(location, lifeCycle, domMutationObservable, configuration, locationChangeObservable, areViewsTrackedAutomatically, initialViewOptions) {
  var activeViews = new Set();
  var currentView = startNewView("initial_load" /* ViewLoadingType.INITIAL_LOAD */, clocksOrigin(), initialViewOptions);
  startViewLifeCycle();
  var locationChangeSubscription;
  if (areViewsTrackedAutomatically) {
    locationChangeSubscription = renewViewOnLocationChange(locationChangeObservable);
  }
  function startNewView(loadingType, startClocks, viewOptions) {
    var newlyCreatedView = newView(lifeCycle, domMutationObservable, configuration, location, loadingType, startClocks, viewOptions);
    activeViews.add(newlyCreatedView);
    newlyCreatedView.stopObservable.subscribe(function () {
      activeViews.delete(newlyCreatedView);
    });
    return newlyCreatedView;
  }
  function startViewLifeCycle() {
    lifeCycle.subscribe(10 /* LifeCycleEventType.SESSION_RENEWED */, function () {
      // Renew view on session renewal
      currentView = startNewView("route_change" /* ViewLoadingType.ROUTE_CHANGE */, undefined, {
        name: currentView.name,
        service: currentView.service,
        version: currentView.version
      });
    });
    lifeCycle.subscribe(9 /* LifeCycleEventType.SESSION_EXPIRED */, function () {
      currentView.end({
        sessionIsActive: false
      });
    });
    // End the current view on page unload
    lifeCycle.subscribe(11 /* LifeCycleEventType.PAGE_EXITED */, function (pageExitEvent) {
      if (pageExitEvent.reason === PageExitReason.UNLOADING) {
        currentView.end();
      }
    });
  }
  function renewViewOnLocationChange(locationChangeObservable) {
    return locationChangeObservable.subscribe(function (_a) {
      var oldLocation = _a.oldLocation,
        newLocation = _a.newLocation;
      if (areDifferentLocation(oldLocation, newLocation)) {
        currentView.end();
        currentView = startNewView("route_change" /* ViewLoadingType.ROUTE_CHANGE */);
      }
    });
  }
  return {
    addTiming: function (name, time) {
      if (time === void 0) {
        time = timeStampNow();
      }
      currentView.addTiming(name, time);
    },
    startView: function (options, startClocks) {
      currentView.end({
        endClocks: startClocks
      });
      currentView = startNewView("route_change" /* ViewLoadingType.ROUTE_CHANGE */, startClocks, options);
    },
    updateViewName: function (name) {
      currentView.updateViewName(name);
    },
    stop: function () {
      locationChangeSubscription === null || locationChangeSubscription === void 0 ? void 0 : locationChangeSubscription.unsubscribe();
      currentView.end();
      activeViews.forEach(function (view) {
        return view.stop();
      });
    }
  };
}
function newView(lifeCycle, domMutationObservable, configuration, initialLocation, loadingType, startClocks, viewOptions) {
  if (startClocks === void 0) {
    startClocks = clocksNow();
  }
  // Setup initial values
  var id = generateUUID();
  var stopObservable = new Observable();
  var customTimings = {};
  var documentVersion = 0;
  var endClocks;
  var location = shallowClone(initialLocation);
  var sessionIsActive = true;
  var name;
  var service;
  var version;
  if (viewOptions) {
    name = viewOptions.name;
    service = viewOptions.service || undefined;
    version = viewOptions.version || undefined;
  }
  var viewCreatedEvent = {
    id: id,
    name: name,
    startClocks: startClocks,
    service: service,
    version: version
  };
  lifeCycle.notify(2 /* LifeCycleEventType.BEFORE_VIEW_CREATED */, viewCreatedEvent);
  lifeCycle.notify(3 /* LifeCycleEventType.VIEW_CREATED */, viewCreatedEvent);
  // Update the view every time the measures are changing
  var _a = throttle(triggerViewUpdate, THROTTLE_VIEW_UPDATE_PERIOD, {
      leading: false
    }),
    scheduleViewUpdate = _a.throttled,
    cancelScheduleViewUpdate = _a.cancel;
  var _b = trackCommonViewMetrics(lifeCycle, domMutationObservable, configuration, scheduleViewUpdate, loadingType, startClocks),
    setLoadEvent = _b.setLoadEvent,
    setViewEnd = _b.setViewEnd,
    stopCommonViewMetricsTracking = _b.stop,
    stopINPTracking = _b.stopINPTracking,
    getCommonViewMetrics = _b.getCommonViewMetrics;
  var _c = loadingType === "initial_load" /* ViewLoadingType.INITIAL_LOAD */ ? trackInitialViewMetrics(lifeCycle, configuration, setLoadEvent, scheduleViewUpdate) : {
      stop: noop$1,
      initialViewMetrics: {}
    },
    stopInitialViewMetricsTracking = _c.stop,
    initialViewMetrics = _c.initialViewMetrics;
  var _d = trackViewEventCounts(lifeCycle, id, scheduleViewUpdate),
    stopEventCountsTracking = _d.stop,
    eventCounts = _d.eventCounts;
  // Session keep alive
  var keepAliveIntervalId = setInterval$1(triggerViewUpdate, SESSION_KEEP_ALIVE_INTERVAL);
  // Initial view update
  triggerViewUpdate();
  function triggerViewUpdate() {
    cancelScheduleViewUpdate();
    documentVersion += 1;
    var currentEnd = endClocks === undefined ? timeStampNow() : endClocks.timeStamp;
    lifeCycle.notify(4 /* LifeCycleEventType.VIEW_UPDATED */, {
      customTimings: customTimings,
      documentVersion: documentVersion,
      id: id,
      name: name,
      service: service,
      version: version,
      loadingType: loadingType,
      location: location,
      startClocks: startClocks,
      commonViewMetrics: getCommonViewMetrics(),
      initialViewMetrics: initialViewMetrics,
      duration: elapsed(startClocks.timeStamp, currentEnd),
      isActive: endClocks === undefined,
      sessionIsActive: sessionIsActive,
      eventCounts: eventCounts
    });
  }
  return {
    get name() {
      return name;
    },
    service: service,
    version: version,
    stopObservable: stopObservable,
    end: function (options) {
      var _this = this;
      var _a, _b;
      if (options === void 0) {
        options = {};
      }
      if (endClocks) {
        // view already ended
        return;
      }
      endClocks = (_a = options.endClocks) !== null && _a !== void 0 ? _a : clocksNow();
      sessionIsActive = (_b = options.sessionIsActive) !== null && _b !== void 0 ? _b : true;
      lifeCycle.notify(5 /* LifeCycleEventType.VIEW_ENDED */, {
        endClocks: endClocks
      });
      lifeCycle.notify(6 /* LifeCycleEventType.AFTER_VIEW_ENDED */, {
        endClocks: endClocks
      });
      clearInterval$1(keepAliveIntervalId);
      setViewEnd(endClocks.relative);
      stopCommonViewMetricsTracking();
      triggerViewUpdate();
      setTimeout$1(function () {
        _this.stop();
      }, KEEP_TRACKING_AFTER_VIEW_DELAY);
    },
    stop: function () {
      stopInitialViewMetricsTracking();
      stopEventCountsTracking();
      stopINPTracking();
      stopObservable.notify();
    },
    addTiming: function (name, time) {
      if (endClocks) {
        return;
      }
      var relativeTime = looksLikeRelativeTime(time) ? time : elapsed(startClocks.timeStamp, time);
      customTimings[sanitizeTiming(name)] = relativeTime;
      scheduleViewUpdate();
    },
    updateViewName: function (updatedName) {
      if (!isExperimentalFeatureEnabled(ExperimentalFeature.UPDATE_VIEW_NAME)) {
        return;
      }
      name = updatedName;
      triggerViewUpdate();
    }
  };
}
/**
 * Timing name is used as facet path that must contain only letters, digits, or the characters - _ . @ $
 */
function sanitizeTiming(name) {
  var sanitized = name.replace(/[^a-zA-Z0-9-_.@$]/g, '_');
  if (sanitized !== name) {
    display.warn("Invalid timing name: ".concat(name, ", sanitized to: ").concat(sanitized));
  }
  return sanitized;
}
function areDifferentLocation(currentLocation, otherLocation) {
  return currentLocation.pathname !== otherLocation.pathname || !isHashAnAnchor(otherLocation.hash) && getPathFromHash(otherLocation.hash) !== getPathFromHash(currentLocation.hash);
}
function isHashAnAnchor(hash) {
  var correspondingId = hash.substring(1);
  // check if the correspondingId is empty because on Firefox an empty string passed to getElementById() prints a consol warning
  return correspondingId !== '' && !!document.getElementById(correspondingId);
}
function getPathFromHash(hash) {
  var index = hash.indexOf('?');
  return index < 0 ? hash : hash.slice(0, index);
}

function startViewCollection(lifeCycle, configuration, location, domMutationObservable, locationChangeObservable, featureFlagContexts, pageStateHistory, recorderApi, initialViewOptions) {
  lifeCycle.subscribe(4 /* LifeCycleEventType.VIEW_UPDATED */, function (view) {
    return lifeCycle.notify(12 /* LifeCycleEventType.RAW_RUM_EVENT_COLLECTED */, processViewUpdate(view, configuration, featureFlagContexts, recorderApi, pageStateHistory));
  });
  return trackViews(location, lifeCycle, domMutationObservable, configuration, locationChangeObservable, !configuration.trackViewsManually, initialViewOptions);
}
function processViewUpdate(view, configuration, featureFlagContexts, recorderApi, pageStateHistory) {
  var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r;
  var replayStats = recorderApi.getReplayStats(view.id);
  var featureFlagContext = featureFlagContexts.findFeatureFlagEvaluations(view.startClocks.relative);
  var pageStates = pageStateHistory.findAll(view.startClocks.relative, view.duration);
  var viewEvent = {
    _dd: {
      document_version: view.documentVersion,
      replay_stats: replayStats,
      page_states: pageStates,
      configuration: {
        start_session_replay_recording_manually: configuration.startSessionReplayRecordingManually
      }
    },
    date: view.startClocks.timeStamp,
    type: "view" /* RumEventType.VIEW */,
    view: {
      action: {
        count: view.eventCounts.actionCount
      },
      frustration: {
        count: view.eventCounts.frustrationCount
      },
      cumulative_layout_shift: (_a = view.commonViewMetrics.cumulativeLayoutShift) === null || _a === void 0 ? void 0 : _a.value,
      cumulative_layout_shift_time: toServerDuration((_b = view.commonViewMetrics.cumulativeLayoutShift) === null || _b === void 0 ? void 0 : _b.time),
      cumulative_layout_shift_target_selector: (_c = view.commonViewMetrics.cumulativeLayoutShift) === null || _c === void 0 ? void 0 : _c.targetSelector,
      first_byte: toServerDuration((_d = view.initialViewMetrics.navigationTimings) === null || _d === void 0 ? void 0 : _d.firstByte),
      dom_complete: toServerDuration((_e = view.initialViewMetrics.navigationTimings) === null || _e === void 0 ? void 0 : _e.domComplete),
      dom_content_loaded: toServerDuration((_f = view.initialViewMetrics.navigationTimings) === null || _f === void 0 ? void 0 : _f.domContentLoaded),
      dom_interactive: toServerDuration((_g = view.initialViewMetrics.navigationTimings) === null || _g === void 0 ? void 0 : _g.domInteractive),
      error: {
        count: view.eventCounts.errorCount
      },
      first_contentful_paint: toServerDuration(view.initialViewMetrics.firstContentfulPaint),
      first_input_delay: toServerDuration((_h = view.initialViewMetrics.firstInput) === null || _h === void 0 ? void 0 : _h.delay),
      first_input_time: toServerDuration((_j = view.initialViewMetrics.firstInput) === null || _j === void 0 ? void 0 : _j.time),
      first_input_target_selector: (_k = view.initialViewMetrics.firstInput) === null || _k === void 0 ? void 0 : _k.targetSelector,
      interaction_to_next_paint: toServerDuration((_l = view.commonViewMetrics.interactionToNextPaint) === null || _l === void 0 ? void 0 : _l.value),
      interaction_to_next_paint_time: toServerDuration((_m = view.commonViewMetrics.interactionToNextPaint) === null || _m === void 0 ? void 0 : _m.time),
      interaction_to_next_paint_target_selector: (_o = view.commonViewMetrics.interactionToNextPaint) === null || _o === void 0 ? void 0 : _o.targetSelector,
      is_active: view.isActive,
      name: view.name,
      largest_contentful_paint: toServerDuration((_p = view.initialViewMetrics.largestContentfulPaint) === null || _p === void 0 ? void 0 : _p.value),
      largest_contentful_paint_target_selector: (_q = view.initialViewMetrics.largestContentfulPaint) === null || _q === void 0 ? void 0 : _q.targetSelector,
      load_event: toServerDuration((_r = view.initialViewMetrics.navigationTimings) === null || _r === void 0 ? void 0 : _r.loadEvent),
      loading_time: discardNegativeDuration(toServerDuration(view.commonViewMetrics.loadingTime)),
      loading_type: view.loadingType,
      long_task: {
        count: view.eventCounts.longTaskCount
      },
      resource: {
        count: view.eventCounts.resourceCount
      },
      time_spent: toServerDuration(view.duration)
    },
    feature_flags: featureFlagContext && !isEmptyObject(featureFlagContext) ? featureFlagContext : undefined,
    display: view.commonViewMetrics.scroll ? {
      scroll: {
        max_depth: view.commonViewMetrics.scroll.maxDepth,
        max_depth_scroll_top: view.commonViewMetrics.scroll.maxDepthScrollTop,
        max_scroll_height: view.commonViewMetrics.scroll.maxScrollHeight,
        max_scroll_height_time: toServerDuration(view.commonViewMetrics.scroll.maxScrollHeightTime)
      }
    } : undefined,
    session: {
      has_replay: replayStats ? true : undefined,
      is_active: view.sessionIsActive ? undefined : false
    },
    privacy: {
      replay_level: configuration.defaultPrivacyLevel
    }
  };
  if (!isEmptyObject(view.customTimings)) {
    viewEvent.view.custom_timings = mapValues(view.customTimings, toServerDuration);
  }
  return {
    rawRumEvent: viewEvent,
    startTime: view.startClocks.relative,
    domainContext: {
      location: view.location
    }
  };
}

var RUM_SESSION_KEY = 'rum';
function startRumSessionManager(configuration, lifeCycle, trackingConsentState) {
  var sessionManager = startSessionManager(configuration, RUM_SESSION_KEY, function (rawTrackingType) {
    return computeSessionState(configuration, rawTrackingType);
  }, trackingConsentState);
  sessionManager.expireObservable.subscribe(function () {
    lifeCycle.notify(9 /* LifeCycleEventType.SESSION_EXPIRED */);
  });
  sessionManager.renewObservable.subscribe(function () {
    lifeCycle.notify(10 /* LifeCycleEventType.SESSION_RENEWED */);
  });
  sessionManager.sessionStateUpdateObservable.subscribe(function (_a) {
    var previousState = _a.previousState,
      newState = _a.newState;
    if (!previousState.forcedReplay && newState.forcedReplay) {
      var sessionEntity = sessionManager.findSession();
      if (sessionEntity) {
        sessionEntity.isReplayForced = true;
      }
    }
  });
  return {
    findTrackedSession: function (startTime) {
      var session = sessionManager.findSession(startTime);
      if (!session || !isTypeTracked(session.trackingType)) {
        return;
      }
      return {
        id: session.id,
        sessionReplay: session.trackingType === "1" /* RumTrackingType.TRACKED_WITH_SESSION_REPLAY */ ? 1 /* SessionReplayState.SAMPLED */ : session.isReplayForced ? 2 /* SessionReplayState.FORCED */ : 0 /* SessionReplayState.OFF */
      };
    },
    expire: sessionManager.expire,
    expireObservable: sessionManager.expireObservable,
    setForcedReplay: function () {
      return sessionManager.updateSessionState({
        forcedReplay: '1'
      });
    }
  };
}
/**
 * Start a tracked replay session stub
 */
function startRumSessionManagerStub() {
  var session = {
    id: '00000000-aaaa-0000-aaaa-000000000000',
    sessionReplay: bridgeSupports("records" /* BridgeCapability.RECORDS */) ? 1 /* SessionReplayState.SAMPLED */ : 0 /* SessionReplayState.OFF */
  };
  return {
    findTrackedSession: function () {
      return session;
    },
    expire: noop$1,
    expireObservable: new Observable(),
    setForcedReplay: noop$1
  };
}
function computeSessionState(configuration, rawTrackingType) {
  var trackingType;
  if (hasValidRumSession(rawTrackingType)) {
    trackingType = rawTrackingType;
  } else if (!performDraw(configuration.sessionSampleRate)) {
    trackingType = "0" /* RumTrackingType.NOT_TRACKED */;
  } else if (!performDraw(configuration.sessionReplaySampleRate)) {
    trackingType = "2" /* RumTrackingType.TRACKED_WITHOUT_SESSION_REPLAY */;
  } else {
    trackingType = "1" /* RumTrackingType.TRACKED_WITH_SESSION_REPLAY */;
  }
  return {
    trackingType: trackingType,
    isTracked: isTypeTracked(trackingType)
  };
}
function hasValidRumSession(trackingType) {
  return trackingType === "0" /* RumTrackingType.NOT_TRACKED */ || trackingType === "1" /* RumTrackingType.TRACKED_WITH_SESSION_REPLAY */ || trackingType === "2" /* RumTrackingType.TRACKED_WITHOUT_SESSION_REPLAY */;
}
function isTypeTracked(rumSessionType) {
  return rumSessionType === "2" /* RumTrackingType.TRACKED_WITHOUT_SESSION_REPLAY */ || rumSessionType === "1" /* RumTrackingType.TRACKED_WITH_SESSION_REPLAY */;
}

function startRumBatch(configuration, lifeCycle, telemetryEventObservable, reportError, pageExitObservable, sessionExpireObservable, createEncoder) {
  var replica = configuration.replica;
  var batch = startBatchWithReplica(configuration, {
    endpoint: configuration.rumEndpointBuilder,
    encoder: createEncoder(2 /* DeflateEncoderStreamId.RUM */)
  }, replica && {
    endpoint: replica.rumEndpointBuilder,
    transformMessage: function (message) {
      return combine(message, {
        application: {
          id: replica.applicationId
        }
      });
    },
    encoder: createEncoder(3 /* DeflateEncoderStreamId.RUM_REPLICA */)
  }, reportError, pageExitObservable, sessionExpireObservable);
  lifeCycle.subscribe(13 /* LifeCycleEventType.RUM_EVENT_COLLECTED */, function (serverRumEvent) {
    if (serverRumEvent.type === "view" /* RumEventType.VIEW */) {
      batch.upsert(serverRumEvent, serverRumEvent.view.id);
    } else {
      batch.add(serverRumEvent);
    }
  });
  telemetryEventObservable.subscribe(function (event) {
    return batch.add(event, isTelemetryReplicationAllowed(configuration));
  });
  return batch;
}

function startRumEventBridge(lifeCycle) {
  var bridge = getEventBridge();
  lifeCycle.subscribe(13 /* LifeCycleEventType.RUM_EVENT_COLLECTED */, function (serverRumEvent) {
    bridge.send('rum', serverRumEvent);
  });
}

/**
 * We want to attach to an event:
 * - the url corresponding to its start
 * - the referrer corresponding to the previous view url (or document referrer for initial view)
 */
var URL_CONTEXT_TIME_OUT_DELAY = SESSION_TIME_OUT_DELAY;
function startUrlContexts(lifeCycle, locationChangeObservable, location) {
  var urlContextHistory = new ValueHistory(URL_CONTEXT_TIME_OUT_DELAY);
  var previousViewUrl;
  lifeCycle.subscribe(2 /* LifeCycleEventType.BEFORE_VIEW_CREATED */, function (_a) {
    var startClocks = _a.startClocks;
    var viewUrl = location.href;
    urlContextHistory.add(buildUrlContext({
      url: viewUrl,
      referrer: !previousViewUrl ? document.referrer : previousViewUrl
    }), startClocks.relative);
    previousViewUrl = viewUrl;
  });
  lifeCycle.subscribe(6 /* LifeCycleEventType.AFTER_VIEW_ENDED */, function (_a) {
    var endClocks = _a.endClocks;
    urlContextHistory.closeActive(endClocks.relative);
  });
  var locationChangeSubscription = locationChangeObservable.subscribe(function (_a) {
    var newLocation = _a.newLocation;
    var current = urlContextHistory.find();
    if (current) {
      var changeTime = relativeNow();
      urlContextHistory.closeActive(changeTime);
      urlContextHistory.add(buildUrlContext({
        url: newLocation.href,
        referrer: current.referrer
      }), changeTime);
    }
  });
  function buildUrlContext(_a) {
    var url = _a.url,
      referrer = _a.referrer;
    return {
      url: url,
      referrer: referrer
    };
  }
  return {
    findUrl: function (startTime) {
      return urlContextHistory.find(startTime);
    },
    stop: function () {
      locationChangeSubscription.unsubscribe();
      urlContextHistory.stop();
    }
  };
}

function createLocationChangeObservable(configuration, location) {
  var currentLocation = shallowClone(location);
  return new Observable(function (observable) {
    var stopHistoryTracking = trackHistory(configuration, onLocationChange).stop;
    var stopHashTracking = trackHash(configuration, onLocationChange).stop;
    function onLocationChange() {
      if (currentLocation.href === location.href) {
        return;
      }
      var newLocation = shallowClone(location);
      observable.notify({
        newLocation: newLocation,
        oldLocation: currentLocation
      });
      currentLocation = newLocation;
    }
    return function () {
      stopHistoryTracking();
      stopHashTracking();
    };
  });
}
function trackHistory(configuration, onHistoryChange) {
  var stopInstrumentingPushState = instrumentMethod(history, 'pushState', function (_a) {
    var onPostCall = _a.onPostCall;
    onPostCall(onHistoryChange);
  }).stop;
  var stopInstrumentingReplaceState = instrumentMethod(history, 'replaceState', function (_a) {
    var onPostCall = _a.onPostCall;
    onPostCall(onHistoryChange);
  }).stop;
  var removeListener = addEventListener(configuration, window, DOM_EVENT.POP_STATE, onHistoryChange).stop;
  return {
    stop: function () {
      stopInstrumentingPushState();
      stopInstrumentingReplaceState();
      removeListener();
    }
  };
}
function trackHash(configuration, onHashChange) {
  return addEventListener(configuration, window, DOM_EVENT.HASH_CHANGE, onHashChange);
}

var FEATURE_FLAG_CONTEXT_TIME_OUT_DELAY = SESSION_TIME_OUT_DELAY;
/**
 * Start feature flag contexts
 *
 * Feature flag contexts follow the life of views.
 * A new context is added when a view is created and ended when the view is ended
 *
 * Note: we choose not to add a new context at each evaluation to save memory
 */
function startFeatureFlagContexts(lifeCycle, customerDataTracker) {
  var featureFlagContexts = new ValueHistory(FEATURE_FLAG_CONTEXT_TIME_OUT_DELAY);
  lifeCycle.subscribe(2 /* LifeCycleEventType.BEFORE_VIEW_CREATED */, function (_a) {
    var startClocks = _a.startClocks;
    featureFlagContexts.add({}, startClocks.relative);
    customerDataTracker.resetCustomerData();
  });
  lifeCycle.subscribe(6 /* LifeCycleEventType.AFTER_VIEW_ENDED */, function (_a) {
    var endClocks = _a.endClocks;
    featureFlagContexts.closeActive(endClocks.relative);
  });
  return {
    findFeatureFlagEvaluations: function (startTime) {
      return featureFlagContexts.find(startTime);
    },
    addFeatureFlagEvaluation: function (key, value) {
      var currentContext = featureFlagContexts.find();
      if (currentContext) {
        currentContext[key] = value;
        customerDataTracker.updateCustomerData(currentContext);
      }
    },
    stop: function () {
      return customerDataTracker.stop();
    }
  };
}

var MEASURES_PERIOD_DURATION = 10 * ONE_SECOND;
var currentPeriodMeasures;
var currentBatchMeasures;
var batchHasRumEvent;
function startCustomerDataTelemetry(configuration, telemetry, lifeCycle, customerDataTrackerManager, batchFlushObservable) {
  var customerDataTelemetryEnabled = telemetry.enabled && performDraw(configuration.customerDataTelemetrySampleRate);
  if (!customerDataTelemetryEnabled) {
    return;
  }
  initCurrentPeriodMeasures();
  initCurrentBatchMeasures();
  // We measure the data of every view updates even if there could only be one per batch due to the upsert
  // It means that contexts bytes count sums can be higher than it really is
  lifeCycle.subscribe(13 /* LifeCycleEventType.RUM_EVENT_COLLECTED */, function (event) {
    batchHasRumEvent = true;
    updateMeasure(currentBatchMeasures.globalContextBytes, customerDataTrackerManager.getOrCreateTracker(2 /* CustomerDataType.GlobalContext */).getBytesCount());
    updateMeasure(currentBatchMeasures.userContextBytes, customerDataTrackerManager.getOrCreateTracker(1 /* CustomerDataType.User */).getBytesCount());
    updateMeasure(currentBatchMeasures.featureFlagBytes, includes(["view" /* RumEventType.VIEW */, "error" /* RumEventType.ERROR */], event.type) ? customerDataTrackerManager.getOrCreateTracker(0 /* CustomerDataType.FeatureFlag */).getBytesCount() : 0);
  });
  batchFlushObservable.subscribe(function (_a) {
    var bytesCount = _a.bytesCount,
      messagesCount = _a.messagesCount;
    // Don't measure batch that only contains telemetry events to avoid batch sending loop
    // It could happen because after each batch we are adding a customer data measures telemetry event to the next one
    if (!batchHasRumEvent) {
      return;
    }
    currentPeriodMeasures.batchCount += 1;
    updateMeasure(currentPeriodMeasures.batchBytesCount, bytesCount);
    updateMeasure(currentPeriodMeasures.batchMessagesCount, messagesCount);
    mergeMeasure(currentPeriodMeasures.globalContextBytes, currentBatchMeasures.globalContextBytes);
    mergeMeasure(currentPeriodMeasures.userContextBytes, currentBatchMeasures.userContextBytes);
    mergeMeasure(currentPeriodMeasures.featureFlagBytes, currentBatchMeasures.featureFlagBytes);
    initCurrentBatchMeasures();
  });
  setInterval$1(sendCurrentPeriodMeasures, MEASURES_PERIOD_DURATION);
}
function sendCurrentPeriodMeasures() {
  if (currentPeriodMeasures.batchCount === 0) {
    return;
  }
  addTelemetryDebug('Customer data measures', currentPeriodMeasures);
  initCurrentPeriodMeasures();
}
function createMeasure() {
  return {
    min: Infinity,
    max: 0,
    sum: 0
  };
}
function updateMeasure(measure, value) {
  measure.sum += value;
  measure.min = Math.min(measure.min, value);
  measure.max = Math.max(measure.max, value);
}
function mergeMeasure(target, source) {
  target.sum += source.sum;
  target.min = Math.min(target.min, source.min);
  target.max = Math.max(target.max, source.max);
}
function initCurrentPeriodMeasures() {
  currentPeriodMeasures = {
    batchCount: 0,
    batchBytesCount: createMeasure(),
    batchMessagesCount: createMeasure(),
    globalContextBytes: createMeasure(),
    userContextBytes: createMeasure(),
    featureFlagBytes: createMeasure()
  };
}
function initCurrentBatchMeasures() {
  batchHasRumEvent = false;
  currentBatchMeasures = {
    globalContextBytes: createMeasure(),
    userContextBytes: createMeasure(),
    featureFlagBytes: createMeasure()
  };
}

// Arbitrary value to cap number of element for memory consumption in the browser
var MAX_PAGE_STATE_ENTRIES = 4000;
// Arbitrary value to cap number of element for backend & to save bandwidth
var MAX_PAGE_STATE_ENTRIES_SELECTABLE = 500;
var PAGE_STATE_CONTEXT_TIME_OUT_DELAY = SESSION_TIME_OUT_DELAY;
function startPageStateHistory(configuration, maxPageStateEntriesSelectable) {
  if (maxPageStateEntriesSelectable === void 0) {
    maxPageStateEntriesSelectable = MAX_PAGE_STATE_ENTRIES_SELECTABLE;
  }
  var pageStateEntryHistory = new ValueHistory(PAGE_STATE_CONTEXT_TIME_OUT_DELAY, MAX_PAGE_STATE_ENTRIES);
  var currentPageState;
  addPageState(getPageState(), relativeNow());
  var stopEventListeners = addEventListeners(configuration, window, [DOM_EVENT.PAGE_SHOW, DOM_EVENT.FOCUS, DOM_EVENT.BLUR, DOM_EVENT.VISIBILITY_CHANGE, DOM_EVENT.RESUME, DOM_EVENT.FREEZE, DOM_EVENT.PAGE_HIDE], function (event) {
    addPageState(computePageState(event), event.timeStamp);
  }, {
    capture: true
  }).stop;
  function addPageState(nextPageState, startTime) {
    if (startTime === void 0) {
      startTime = relativeNow();
    }
    if (nextPageState === currentPageState) {
      return;
    }
    currentPageState = nextPageState;
    pageStateEntryHistory.closeActive(startTime);
    pageStateEntryHistory.add({
      state: currentPageState,
      startTime: startTime
    }, startTime);
  }
  var pageStateHistory = {
    findAll: function (eventStartTime, duration) {
      var pageStateEntries = pageStateEntryHistory.findAll(eventStartTime, duration);
      if (pageStateEntries.length === 0) {
        return;
      }
      var pageStateServerEntries = [];
      // limit the number of entries to return
      var limit = Math.max(0, pageStateEntries.length - maxPageStateEntriesSelectable);
      // loop page state entries backward to return the selected ones in desc order
      for (var index = pageStateEntries.length - 1; index >= limit; index--) {
        var pageState = pageStateEntries[index];
        // compute the start time relative to the event start time (ex: to be relative to the view start time)
        var relativeStartTime = elapsed(eventStartTime, pageState.startTime);
        pageStateServerEntries.push({
          state: pageState.state,
          start: toServerDuration(relativeStartTime)
        });
      }
      return pageStateServerEntries;
    },
    wasInPageStateAt: function (state, startTime) {
      return pageStateHistory.wasInPageStateDuringPeriod(state, startTime, 0);
    },
    wasInPageStateDuringPeriod: function (state, startTime, duration) {
      return pageStateEntryHistory.findAll(startTime, duration).some(function (pageState) {
        return pageState.state === state;
      });
    },
    addPageState: addPageState,
    stop: function () {
      stopEventListeners();
      pageStateEntryHistory.stop();
    }
  };
  return pageStateHistory;
}
function computePageState(event) {
  if (event.type === DOM_EVENT.FREEZE) {
    return "frozen" /* PageState.FROZEN */;
  } else if (event.type === DOM_EVENT.PAGE_HIDE) {
    return event.persisted ? "frozen" /* PageState.FROZEN */ : "terminated" /* PageState.TERMINATED */;
  }
  return getPageState();
}
function getPageState() {
  if (document.visibilityState === 'hidden') {
    return "hidden" /* PageState.HIDDEN */;
  }
  if (document.hasFocus()) {
    return "active" /* PageState.ACTIVE */;
  }
  return "passive" /* PageState.PASSIVE */;
}

function startDisplayContext(configuration) {
  var viewport = getViewportDimension();
  var unsubscribeViewport = initViewportObservable(configuration).subscribe(function (viewportDimension) {
    viewport = viewportDimension;
  }).unsubscribe;
  return {
    get: function () {
      return {
        viewport: viewport
      };
    },
    stop: unsubscribeViewport
  };
}

function createCookieObservable(configuration, cookieName) {
  var detectCookieChangeStrategy = window.cookieStore ? listenToCookieStoreChange(configuration) : watchCookieFallback;
  return new Observable(function (observable) {
    return detectCookieChangeStrategy(cookieName, function (event) {
      return observable.notify(event);
    });
  });
}
function listenToCookieStoreChange(configuration) {
  return function (cookieName, callback) {
    var listener = addEventListener(configuration, window.cookieStore, DOM_EVENT.CHANGE, function (event) {
      // Based on our experimentation, we're assuming that entries for the same cookie cannot be in both the 'changed' and 'deleted' arrays.
      // However, due to ambiguity in the specification, we asked for clarification: https://github.com/WICG/cookie-store/issues/226
      var changeEvent = find(event.changed, function (event) {
        return event.name === cookieName;
      }) || find(event.deleted, function (event) {
        return event.name === cookieName;
      });
      if (changeEvent) {
        callback(changeEvent.value);
      }
    });
    return listener.stop;
  };
}
var WATCH_COOKIE_INTERVAL_DELAY = ONE_SECOND;
function watchCookieFallback(cookieName, callback) {
  var previousCookieValue = findCommaSeparatedValue(document.cookie, cookieName);
  var watchCookieIntervalId = setInterval$1(function () {
    var cookieValue = findCommaSeparatedValue(document.cookie, cookieName);
    if (cookieValue !== previousCookieValue) {
      callback(cookieValue);
    }
  }, WATCH_COOKIE_INTERVAL_DELAY);
  return function () {
    clearInterval$1(watchCookieIntervalId);
  };
}

var CI_VISIBILITY_TEST_ID_COOKIE_NAME = 'datadog-ci-visibility-test-execution-id';
function startCiVisibilityContext(configuration, cookieObservable) {
  var _a;
  if (cookieObservable === void 0) {
    cookieObservable = createCookieObservable(configuration, CI_VISIBILITY_TEST_ID_COOKIE_NAME);
  }
  var testExecutionId = getInitCookie(CI_VISIBILITY_TEST_ID_COOKIE_NAME) || ((_a = window.Cypress) === null || _a === void 0 ? void 0 : _a.env('traceId'));
  var cookieObservableSubscription = cookieObservable.subscribe(function (value) {
    testExecutionId = value;
  });
  return {
    get: function () {
      if (typeof testExecutionId === 'string') {
        return {
          test_execution_id: testExecutionId
        };
      }
    },
    stop: function () {
      return cookieObservableSubscription.unsubscribe();
    }
  };
}

function startRum(configuration, recorderApi, customerDataTrackerManager, getCommonContext, initialViewOptions, createEncoder,
// `startRum` and its subcomponents assume tracking consent is granted initially and starts
// collecting logs unconditionally. As such, `startRum` should be called with a
// `trackingConsentState` set to "granted".
trackingConsentState) {
  var cleanupTasks = [];
  var lifeCycle = new LifeCycle();
  lifeCycle.subscribe(13 /* LifeCycleEventType.RUM_EVENT_COLLECTED */, function (event) {
    return sendToExtension('rum', event);
  });
  var telemetry = startRumTelemetry(configuration);
  telemetry.setContextProvider(function () {
    var _a, _b;
    return {
      application: {
        id: configuration.applicationId
      },
      session: {
        id: (_a = session.findTrackedSession()) === null || _a === void 0 ? void 0 : _a.id
      },
      view: {
        id: (_b = viewContexts.findView()) === null || _b === void 0 ? void 0 : _b.id
      },
      action: {
        id: actionContexts.findActionId()
      }
    };
  });
  var reportError = function (error) {
    lifeCycle.notify(14 /* LifeCycleEventType.RAW_ERROR_COLLECTED */, {
      error: error
    });
    addTelemetryDebug('Error reported to customer', {
      'error.message': error.message
    });
  };
  var featureFlagContexts = startFeatureFlagContexts(lifeCycle, customerDataTrackerManager.getOrCreateTracker(0 /* CustomerDataType.FeatureFlag */));
  var pageExitObservable = createPageExitObservable(configuration);
  var pageExitSubscription = pageExitObservable.subscribe(function (event) {
    lifeCycle.notify(11 /* LifeCycleEventType.PAGE_EXITED */, event);
  });
  cleanupTasks.push(function () {
    return pageExitSubscription.unsubscribe();
  });
  var session = !canUseEventBridge() ? startRumSessionManager(configuration, lifeCycle, trackingConsentState) : startRumSessionManagerStub();
  if (!canUseEventBridge()) {
    var batch_1 = startRumBatch(configuration, lifeCycle, telemetry.observable, reportError, pageExitObservable, session.expireObservable, createEncoder);
    cleanupTasks.push(function () {
      return batch_1.stop();
    });
    startCustomerDataTelemetry(configuration, telemetry, lifeCycle, customerDataTrackerManager, batch_1.flushObservable);
  } else {
    startRumEventBridge(lifeCycle);
  }
  var domMutationObservable = createDOMMutationObservable();
  var locationChangeObservable = createLocationChangeObservable(configuration, location);
  var pageStateHistory = startPageStateHistory(configuration);
  var _a = startRumEventCollection(lifeCycle, configuration, location, session, pageStateHistory, locationChangeObservable, domMutationObservable, getCommonContext, reportError),
    viewContexts = _a.viewContexts,
    urlContexts = _a.urlContexts,
    actionContexts = _a.actionContexts,
    addAction = _a.addAction,
    stopRumEventCollection = _a.stop;
  cleanupTasks.push(stopRumEventCollection);
  drainPreStartTelemetry();
  var _b = startViewCollection(lifeCycle, configuration, location, domMutationObservable, locationChangeObservable, featureFlagContexts, pageStateHistory, recorderApi, initialViewOptions),
    addTiming = _b.addTiming,
    startView = _b.startView,
    updateViewName = _b.updateViewName,
    stopViewCollection = _b.stop;
  cleanupTasks.push(stopViewCollection);
  var stopResourceCollection = startResourceCollection(lifeCycle, configuration, pageStateHistory).stop;
  cleanupTasks.push(stopResourceCollection);
  startLongTaskCollection(lifeCycle, configuration);
  var addError = startErrorCollection(lifeCycle, configuration, pageStateHistory, featureFlagContexts).addError;
  startRequestCollection(lifeCycle, configuration, session);
  var stopPerformanceCollection = startPerformanceCollection(lifeCycle, configuration).stop;
  cleanupTasks.push(stopPerformanceCollection);
  var vitalCollection = startVitalCollection(lifeCycle, pageStateHistory);
  var internalContext = startInternalContext(configuration.applicationId, session, viewContexts, actionContexts, urlContexts);
  return {
    addAction: addAction,
    addError: addError,
    addTiming: addTiming,
    addFeatureFlagEvaluation: featureFlagContexts.addFeatureFlagEvaluation,
    startView: startView,
    updateViewName: updateViewName,
    lifeCycle: lifeCycle,
    viewContexts: viewContexts,
    session: session,
    stopSession: function () {
      return session.expire();
    },
    getInternalContext: internalContext.get,
    startDurationVital: vitalCollection.startDurationVital,
    addDurationVital: vitalCollection.addDurationVital,
    stop: function () {
      cleanupTasks.forEach(function (task) {
        return task();
      });
    }
  };
}
function startRumTelemetry(configuration) {
  var telemetry = startTelemetry("browser-rum-sdk" /* TelemetryService.RUM */, configuration);
  if (canUseEventBridge()) {
    var bridge_1 = getEventBridge();
    telemetry.observable.subscribe(function (event) {
      return bridge_1.send('internal_telemetry', event);
    });
  }
  return telemetry;
}
function startRumEventCollection(lifeCycle, configuration, location, sessionManager, pageStateHistory, locationChangeObservable, domMutationObservable, getCommonContext, reportError) {
  var viewContexts = startViewContexts(lifeCycle);
  var urlContexts = startUrlContexts(lifeCycle, locationChangeObservable, location);
  var _a = startActionCollection(lifeCycle, domMutationObservable, configuration, pageStateHistory),
    addAction = _a.addAction,
    actionContexts = _a.actionContexts;
  var displayContext = startDisplayContext(configuration);
  var ciVisibilityContext = startCiVisibilityContext(configuration);
  startRumAssembly(configuration, lifeCycle, sessionManager, viewContexts, urlContexts, actionContexts, displayContext, ciVisibilityContext, getCommonContext, reportError);
  return {
    viewContexts: viewContexts,
    pageStateHistory: pageStateHistory,
    urlContexts: urlContexts,
    addAction: addAction,
    actionContexts: actionContexts,
    stop: function () {
      ciVisibilityContext.stop();
      displayContext.stop();
      pageStateHistory.stop();
      urlContexts.stop();
      viewContexts.stop();
      pageStateHistory.stop();
    }
  };
}

function getSessionReplayUrl(configuration, _a) {
  var session = _a.session,
    viewContext = _a.viewContext,
    errorType = _a.errorType;
  var sessionId = session ? session.id : 'no-session-id';
  var parameters = [];
  if (errorType !== undefined) {
    parameters.push("error-type=".concat(errorType));
  }
  if (viewContext) {
    parameters.push("seed=".concat(viewContext.id));
    parameters.push("from=".concat(viewContext.startClocks.timeStamp));
  }
  var origin = getDatadogSiteUrl(configuration);
  var path = "/rum/replay/sessions/".concat(sessionId);
  return "".concat(origin).concat(path, "?").concat(parameters.join('&'));
}
function getDatadogSiteUrl(rumConfiguration) {
  var site = rumConfiguration.site;
  var subdomain = rumConfiguration.subdomain || getSiteDefaultSubdomain(rumConfiguration);
  return "https://".concat(subdomain ? "".concat(subdomain, ".") : '').concat(site);
}
function getSiteDefaultSubdomain(configuration) {
  switch (configuration.site) {
    case INTAKE_SITE_US1:
    case INTAKE_SITE_EU1:
      return 'app';
    case INTAKE_SITE_STAGING:
      return 'dd';
    default:
      return undefined;
  }
}

var MAX_STATS_HISTORY = 10;
var statsPerView;
function getSegmentsCount(viewId) {
  return getOrCreateReplayStats(viewId).segments_count;
}
function addSegment(viewId) {
  getOrCreateReplayStats(viewId).segments_count += 1;
}
function addRecord(viewId) {
  getOrCreateReplayStats(viewId).records_count += 1;
}
function addWroteData(viewId, additionalBytesCount) {
  getOrCreateReplayStats(viewId).segments_total_raw_size += additionalBytesCount;
}
function getReplayStats(viewId) {
  return statsPerView === null || statsPerView === void 0 ? void 0 : statsPerView.get(viewId);
}
function getOrCreateReplayStats(viewId) {
  if (!statsPerView) {
    statsPerView = new Map();
  }
  var replayStats;
  if (statsPerView.has(viewId)) {
    replayStats = statsPerView.get(viewId);
  } else {
    replayStats = {
      records_count: 0,
      segments_count: 0,
      segments_total_raw_size: 0
    };
    statsPerView.set(viewId, replayStats);
    if (statsPerView.size > MAX_STATS_HISTORY) {
      deleteOldestStats();
    }
  }
  return replayStats;
}
function deleteOldestStats() {
  if (!statsPerView) {
    return;
  }
  if (statsPerView.keys) {
    statsPerView.delete(statsPerView.keys().next().value);
  } else {
    // IE11 doesn't support map.keys
    var isFirst_1 = true;
    statsPerView.forEach(function (_value, key) {
      if (isFirst_1) {
        statsPerView.delete(key);
        isFirst_1 = false;
      }
    });
  }
}

var serializedNodeIds = new WeakMap();
function hasSerializedNode(node) {
  return serializedNodeIds.has(node);
}
function nodeAndAncestorsHaveSerializedNode(node) {
  var current = node;
  while (current) {
    if (!hasSerializedNode(current) && !isNodeShadowRoot(current)) {
      return false;
    }
    current = getParentNode(current);
  }
  return true;
}
function getSerializedNodeId(node) {
  return serializedNodeIds.get(node);
}
function setSerializedNodeId(node, serializeNodeId) {
  serializedNodeIds.set(node, serializeNodeId);
}
/**
 * Get the element "value" to be serialized as an attribute or an input update record. It respects
 * the input privacy mode of the element.
 * PERFROMANCE OPTIMIZATION: Assumes that privacy level `HIDDEN` is never encountered because of earlier checks.
 */
function getElementInputValue(element, nodePrivacyLevel) {
  /*
   BROWSER SPEC NOTE: <input>, <select>
   For some <input> elements, the `value` is an exceptional property/attribute that has the
   value synced between el.value and el.getAttribute()
   input[type=button,checkbox,hidden,image,radio,reset,submit]
   */
  var tagName = element.tagName;
  var value = element.value;
  if (shouldMaskNode(element, nodePrivacyLevel)) {
    var type = element.type;
    if (tagName === 'INPUT' && (type === 'button' || type === 'submit' || type === 'reset')) {
      // Overrule `MASK` privacy level for button-like element values, as they are used during replay
      // to display their label. They can still be hidden via the "hidden" privacy attribute or class name.
      return value;
    } else if (!value || tagName === 'OPTION') {
      // <Option> value provides no benefit
      return;
    }
    return CENSORED_STRING_MARK;
  }
  if (tagName === 'OPTION' || tagName === 'SELECT') {
    return element.value;
  }
  if (tagName !== 'INPUT' && tagName !== 'TEXTAREA') {
    return;
  }
  return value;
}
var URL_IN_CSS_REF = /url\((?:(')([^']*)'|(")([^"]*)"|([^)]*))\)/gm;
var ABSOLUTE_URL = /^[A-Za-z]+:|^\/\//;
var DATA_URI = /^data:.*,/i;
function switchToAbsoluteUrl(cssText, cssHref) {
  return cssText.replace(URL_IN_CSS_REF, function (matchingSubstring, singleQuote, urlWrappedInSingleQuotes, doubleQuote, urlWrappedInDoubleQuotes, urlNotWrappedInQuotes) {
    var url = urlWrappedInSingleQuotes || urlWrappedInDoubleQuotes || urlNotWrappedInQuotes;
    if (!cssHref || !url || ABSOLUTE_URL.test(url) || DATA_URI.test(url)) {
      return matchingSubstring;
    }
    var quote = singleQuote || doubleQuote || '';
    return "url(".concat(quote).concat(makeUrlAbsolute(url, cssHref)).concat(quote, ")");
  });
}
function makeUrlAbsolute(url, baseUrl) {
  try {
    return buildUrl(url, baseUrl).href;
  } catch (_) {
    return url;
  }
}
var TAG_NAME_REGEX = /[^a-z1-6-_]/;
function getValidTagName(tagName) {
  var processedTagName = tagName.toLowerCase().trim();
  if (TAG_NAME_REGEX.test(processedTagName)) {
    // if the tag name is odd and we cannot extract
    // anything from the string, then we return a
    // generic div
    return 'div';
  }
  return processedTagName;
}
function censoredImageForSize(width, height) {
  return "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='".concat(width, "' height='").concat(height, "' style='background-color:silver'%3E%3C/svg%3E");
}

var RecordType = {
  FullSnapshot: 2,
  IncrementalSnapshot: 3,
  Meta: 4,
  Focus: 6,
  ViewEnd: 7,
  VisualViewport: 8,
  FrustrationRecord: 9
};
var NodeType = {
  Document: 0,
  DocumentType: 1,
  Element: 2,
  Text: 3,
  CDATA: 4,
  DocumentFragment: 11
};
var IncrementalSource = {
  Mutation: 0,
  MouseMove: 1,
  MouseInteraction: 2,
  Scroll: 3,
  ViewportResize: 4,
  Input: 5,
  TouchMove: 6,
  MediaInteraction: 7,
  StyleSheetRule: 8
  // CanvasMutation : 9,
  // Font : 10,
};
var MouseInteractionType = {
  MouseUp: 0,
  MouseDown: 1,
  Click: 2,
  ContextMenu: 3,
  DblClick: 4,
  Focus: 5,
  Blur: 6,
  TouchStart: 7,
  TouchEnd: 9
};
var MediaInteractionType = {
  Play: 0,
  Pause: 1
};

function serializeStyleSheets(cssStyleSheets) {
  if (cssStyleSheets === undefined || cssStyleSheets.length === 0) {
    return undefined;
  }
  return cssStyleSheets.map(function (cssStyleSheet) {
    var rules = cssStyleSheet.cssRules || cssStyleSheet.rules;
    var cssRules = Array.from(rules, function (cssRule) {
      return cssRule.cssText;
    });
    var styleSheet = {
      cssRules: cssRules,
      disabled: cssStyleSheet.disabled || undefined,
      media: cssStyleSheet.media.length > 0 ? Array.from(cssStyleSheet.media) : undefined
    };
    return styleSheet;
  });
}

function serializeAttribute(element, nodePrivacyLevel, attributeName, configuration) {
  if (nodePrivacyLevel === NodePrivacyLevel.HIDDEN) {
    // dup condition for direct access case
    return null;
  }
  var attributeValue = element.getAttribute(attributeName);
  if (nodePrivacyLevel === NodePrivacyLevel.MASK && attributeName !== PRIVACY_ATTR_NAME && !STABLE_ATTRIBUTES.includes(attributeName) && attributeName !== configuration.actionNameAttribute) {
    var tagName = element.tagName;
    switch (attributeName) {
      // Mask Attribute text content
      case 'title':
      case 'alt':
      case 'placeholder':
        return CENSORED_STRING_MARK;
    }
    // mask image URLs
    if (tagName === 'IMG' && (attributeName === 'src' || attributeName === 'srcset')) {
      // generate image with similar dimension than the original to have the same rendering behaviour
      var image = element;
      if (image.naturalWidth > 0) {
        return censoredImageForSize(image.naturalWidth, image.naturalHeight);
      }
      var _a = element.getBoundingClientRect(),
        width = _a.width,
        height = _a.height;
      if (width > 0 || height > 0) {
        return censoredImageForSize(width, height);
      }
      // if we can't get the image size, fallback to the censored image
      return CENSORED_IMG_MARK;
    }
    // mask source URLs
    if (tagName === 'SOURCE' && (attributeName === 'src' || attributeName === 'srcset')) {
      return CENSORED_IMG_MARK;
    }
    // mask <a> URLs
    if (tagName === 'A' && attributeName === 'href') {
      return CENSORED_STRING_MARK;
    }
    // mask data-* attributes
    if (attributeValue && startsWith$1(attributeName, 'data-')) {
      // Exception: it's safe to reveal the `${PRIVACY_ATTR_NAME}` attr
      return CENSORED_STRING_MARK;
    }
    // mask iframe srcdoc
    if (tagName === 'IFRAME' && attributeName === 'srcdoc') {
      return CENSORED_STRING_MARK;
    }
  }
  if (!attributeValue || typeof attributeValue !== 'string') {
    return attributeValue;
  }
  // Minimum Fix for customer.
  if (isLongDataUrl(attributeValue)) {
    return sanitizeDataUrl(attributeValue);
  }
  return attributeValue;
}

function serializeAttributes(element, nodePrivacyLevel, options) {
  var _a;
  if (nodePrivacyLevel === NodePrivacyLevel.HIDDEN) {
    return {};
  }
  var safeAttrs = {};
  var tagName = getValidTagName(element.tagName);
  var doc = element.ownerDocument;
  for (var i = 0; i < element.attributes.length; i += 1) {
    var attribute = element.attributes.item(i);
    var attributeName = attribute.name;
    var attributeValue = serializeAttribute(element, nodePrivacyLevel, attributeName, options.configuration);
    if (attributeValue !== null) {
      safeAttrs[attributeName] = attributeValue;
    }
  }
  if (element.value && (tagName === 'textarea' || tagName === 'select' || tagName === 'option' || tagName === 'input')) {
    var formValue = getElementInputValue(element, nodePrivacyLevel);
    if (formValue !== undefined) {
      safeAttrs.value = formValue;
    }
  }
  /**
   * <Option> can be selected, which occurs if its `value` matches ancestor `<Select>.value`
   */
  if (tagName === 'option' && nodePrivacyLevel === NodePrivacyLevel.ALLOW) {
    // For privacy=`MASK`, all the values would be the same, so skip.
    var optionElement = element;
    if (optionElement.selected) {
      safeAttrs.selected = optionElement.selected;
    }
  }
  // remote css
  if (tagName === 'link') {
    var stylesheet = Array.from(doc.styleSheets).find(function (s) {
      return s.href === element.href;
    });
    var cssText = getCssRulesString(stylesheet);
    if (cssText && stylesheet) {
      safeAttrs._cssText = cssText;
    }
  }
  // dynamic stylesheet
  if (tagName === 'style' && element.sheet) {
    var cssText = getCssRulesString(element.sheet);
    if (cssText) {
      safeAttrs._cssText = cssText;
    }
  }
  /**
   * Forms: input[type=checkbox,radio]
   * The `checked` property for <input> is a little bit special:
   * 1. el.checked is a setter that returns if truthy.
   * 2. getAttribute returns the string value
   * getAttribute('checked') does not sync with `Element.checked`, so use JS property
   * NOTE: `checked` property exists on `HTMLInputElement`. For serializer assumptions, we check for type=radio|check.
   */
  var inputElement = element;
  if (tagName === 'input' && (inputElement.type === 'radio' || inputElement.type === 'checkbox')) {
    if (nodePrivacyLevel === NodePrivacyLevel.ALLOW) {
      safeAttrs.checked = !!inputElement.checked;
    } else if (shouldMaskNode(inputElement, nodePrivacyLevel)) {
      delete safeAttrs.checked;
    }
  }
  /**
   * Serialize the media playback state
   */
  if (tagName === 'audio' || tagName === 'video') {
    var mediaElement = element;
    safeAttrs.rr_mediaState = mediaElement.paused ? 'paused' : 'played';
  }
  /**
   * Serialize the scroll state for each element only for full snapshot
   */
  var scrollTop;
  var scrollLeft;
  var serializationContext = options.serializationContext;
  switch (serializationContext.status) {
    case 0 /* SerializationContextStatus.INITIAL_FULL_SNAPSHOT */:
      scrollTop = Math.round(element.scrollTop);
      scrollLeft = Math.round(element.scrollLeft);
      if (scrollTop || scrollLeft) {
        serializationContext.elementsScrollPositions.set(element, {
          scrollTop: scrollTop,
          scrollLeft: scrollLeft
        });
      }
      break;
    case 1 /* SerializationContextStatus.SUBSEQUENT_FULL_SNAPSHOT */:
      if (serializationContext.elementsScrollPositions.has(element)) {
        _a = serializationContext.elementsScrollPositions.get(element), scrollTop = _a.scrollTop, scrollLeft = _a.scrollLeft;
      }
      break;
  }
  if (scrollLeft) {
    safeAttrs.rr_scrollLeft = scrollLeft;
  }
  if (scrollTop) {
    safeAttrs.rr_scrollTop = scrollTop;
  }
  return safeAttrs;
}
function getCssRulesString(cssStyleSheet) {
  if (!cssStyleSheet) {
    return null;
  }
  var rules;
  try {
    rules = cssStyleSheet.rules || cssStyleSheet.cssRules;
  } catch (_a) {
    // if css is protected by CORS we cannot access cssRules see: https://www.w3.org/TR/cssom-1/#the-cssstylesheet-interface
  }
  if (!rules) {
    return null;
  }
  var styleSheetCssText = Array.from(rules, isSafari() ? getCssRuleStringForSafari : getCssRuleString).join('');
  return switchToAbsoluteUrl(styleSheetCssText, cssStyleSheet.href);
}
function getCssRuleStringForSafari(rule) {
  // Safari does not escape attribute selectors containing : properly
  // https://bugs.webkit.org/show_bug.cgi?id=184604
  if (isCSSStyleRule(rule) && rule.selectorText.includes(':')) {
    // This regex replaces [foo:bar] by [foo\\:bar]
    var escapeColon = /(\[[\w-]+[^\\])(:[^\]]+\])/g;
    return rule.cssText.replace(escapeColon, '$1\\$2');
  }
  return getCssRuleString(rule);
}
function getCssRuleString(rule) {
  // If it's an @import rule, try to inline sub-rules recursively with `getCssRulesString`. This
  // operation can fail if the imported stylesheet is protected by CORS, in which case we fallback
  // to the @import rule CSS text.
  return isCSSImportRule(rule) && getCssRulesString(rule.styleSheet) || rule.cssText;
}
function isCSSImportRule(rule) {
  return 'styleSheet' in rule;
}
function isCSSStyleRule(rule) {
  return 'selectorText' in rule;
}

function serializeNodeWithId(node, options) {
  var serializedNode = serializeNode(node, options);
  if (!serializedNode) {
    return null;
  }
  // Try to reuse the previous id
  var id = getSerializedNodeId(node) || generateNextId();
  var serializedNodeWithId = serializedNode;
  serializedNodeWithId.id = id;
  setSerializedNodeId(node, id);
  if (options.serializedNodeIds) {
    options.serializedNodeIds.add(id);
  }
  return serializedNodeWithId;
}
var _nextId = 1;
function generateNextId() {
  return _nextId++;
}
function serializeChildNodes(node, options) {
  var result = [];
  forEachChildNodes(node, function (childNode) {
    var serializedChildNode = serializeNodeWithId(childNode, options);
    if (serializedChildNode) {
      result.push(serializedChildNode);
    }
  });
  return result;
}
function serializeNode(node, options) {
  switch (node.nodeType) {
    case node.DOCUMENT_NODE:
      return serializeDocumentNode(node, options);
    case node.DOCUMENT_FRAGMENT_NODE:
      return serializeDocumentFragmentNode(node, options);
    case node.DOCUMENT_TYPE_NODE:
      return serializeDocumentTypeNode(node);
    case node.ELEMENT_NODE:
      return serializeElementNode(node, options);
    case node.TEXT_NODE:
      return serializeTextNode(node, options);
    case node.CDATA_SECTION_NODE:
      return serializeCDataNode();
  }
}
function serializeDocumentNode(document, options) {
  return {
    type: NodeType.Document,
    childNodes: serializeChildNodes(document, options),
    adoptedStyleSheets: serializeStyleSheets(document.adoptedStyleSheets)
  };
}
function serializeDocumentFragmentNode(element, options) {
  var isShadowRoot = isNodeShadowRoot(element);
  if (isShadowRoot) {
    options.serializationContext.shadowRootsController.addShadowRoot(element);
  }
  return {
    type: NodeType.DocumentFragment,
    childNodes: serializeChildNodes(element, options),
    isShadowRoot: isShadowRoot,
    adoptedStyleSheets: isShadowRoot ? serializeStyleSheets(element.adoptedStyleSheets) : undefined
  };
}
function serializeDocumentTypeNode(documentType) {
  return {
    type: NodeType.DocumentType,
    name: documentType.name,
    publicId: documentType.publicId,
    systemId: documentType.systemId
  };
}
/**
 * Serializing Element nodes involves capturing:
 * 1. HTML ATTRIBUTES:
 * 2. JS STATE:
 * - scroll offsets
 * - Form fields (input value, checkbox checked, option selection, range)
 * - Canvas state,
 * - Media (video/audio) play mode + currentTime
 * - iframe contents
 * - webcomponents
 * 3. CUSTOM PROPERTIES:
 * - height+width for when `hidden` to cover the element
 * 4. EXCLUDED INTERACTION STATE:
 * - focus (possible, but not worth perf impact)
 * - hover (tracked only via mouse activity)
 * - fullscreen mode
 */
function serializeElementNode(element, options) {
  var _a;
  var tagName = getValidTagName(element.tagName);
  var isSVG = isSVGElement(element) || undefined;
  // For performance reason, we don't use getNodePrivacyLevel directly: we leverage the
  // parentNodePrivacyLevel option to avoid iterating over all parents
  var nodePrivacyLevel = reducePrivacyLevel(getNodeSelfPrivacyLevel(element), options.parentNodePrivacyLevel);
  if (nodePrivacyLevel === NodePrivacyLevel.HIDDEN) {
    var _b = element.getBoundingClientRect(),
      width = _b.width,
      height = _b.height;
    return {
      type: NodeType.Element,
      tagName: tagName,
      attributes: (_a = {
        rr_width: "".concat(width, "px"),
        rr_height: "".concat(height, "px")
      }, _a[PRIVACY_ATTR_NAME] = PRIVACY_ATTR_VALUE_HIDDEN, _a),
      childNodes: [],
      isSVG: isSVG
    };
  }
  // Ignore Elements like Script and some Link, Metas
  if (nodePrivacyLevel === NodePrivacyLevel.IGNORE) {
    return;
  }
  var attributes = serializeAttributes(element, nodePrivacyLevel, options);
  var childNodes = [];
  if (hasChildNodes(element) &&
  // Do not serialize style children as the css rules are already in the _cssText attribute
  tagName !== 'style') {
    // OBJECT POOLING OPTIMIZATION:
    // We should not create a new object systematically as it could impact performances. Try to reuse
    // the same object as much as possible, and clone it only if we need to.
    var childNodesSerializationOptions = void 0;
    if (options.parentNodePrivacyLevel === nodePrivacyLevel && options.ignoreWhiteSpace === (tagName === 'head')) {
      childNodesSerializationOptions = options;
    } else {
      childNodesSerializationOptions = assign({}, options, {
        parentNodePrivacyLevel: nodePrivacyLevel,
        ignoreWhiteSpace: tagName === 'head'
      });
    }
    childNodes = serializeChildNodes(element, childNodesSerializationOptions);
  }
  return {
    type: NodeType.Element,
    tagName: tagName,
    attributes: attributes,
    childNodes: childNodes,
    isSVG: isSVG
  };
}
function isSVGElement(el) {
  return el.tagName === 'svg' || el instanceof SVGElement;
}
/**
 * Text Nodes are dependant on Element nodes
 * Privacy levels are set on elements so we check the parentElement of a text node
 * for privacy level.
 */
function serializeTextNode(textNode, options) {
  var textContent = getTextContent$1(textNode, options.ignoreWhiteSpace || false, options.parentNodePrivacyLevel);
  if (textContent === undefined) {
    return;
  }
  return {
    type: NodeType.Text,
    textContent: textContent
  };
}
function serializeCDataNode() {
  return {
    type: NodeType.CDATA,
    textContent: ''
  };
}

function serializeDocument(document, configuration, serializationContext) {
  // We are sure that Documents are never ignored, so this function never returns null
  return serializeNodeWithId(document, {
    serializationContext: serializationContext,
    parentNodePrivacyLevel: configuration.defaultPrivacyLevel,
    configuration: configuration
  });
}

function isTouchEvent(event) {
  return Boolean(event.changedTouches);
}
function getEventTarget(event) {
  if (event.composed === true && isNodeShadowHost(event.target)) {
    return event.composedPath()[0];
  }
  return event.target;
}

/**
 * Browsers have not standardized various dimension properties. Mobile devices typically report
 * dimensions in reference to the visual viewport, while desktop uses the layout viewport. For example,
 * Mobile Chrome will change innerWidth when a pinch zoom takes place, while Chrome Desktop (mac) will not.
 *
 * With the new Viewport API, we now calculate and normalize dimension properties to the layout viewport.
 * If the VisualViewport API is not supported by a browser, it isn't reasonably possible to detect or normalize
 * which viewport is being measured. Therefore these exported functions will fallback to assuming that the layout
 * viewport is being measured by the browser
 */
// Scrollbar widths vary across properties on different devices and browsers
var TOLERANCE = 25;
/**
 * Use the Visual Viewport API's properties to measure scrollX/Y in reference to the layout viewport
 * in order to determine if window.scrollX/Y is measuring the layout or visual viewport.
 * This finding corresponds to which viewport mouseEvent.clientX/Y and window.innerWidth/Height measures.
 */
function isVisualViewportFactoredIn(visualViewport) {
  return Math.abs(visualViewport.pageTop - visualViewport.offsetTop - window.scrollY) > TOLERANCE || Math.abs(visualViewport.pageLeft - visualViewport.offsetLeft - window.scrollX) > TOLERANCE;
}
var convertMouseEventToLayoutCoordinates = function (clientX, clientY) {
  var visualViewport = window.visualViewport;
  var normalized = {
    layoutViewportX: clientX,
    layoutViewportY: clientY,
    visualViewportX: clientX,
    visualViewportY: clientY
  };
  if (!visualViewport) {
    // On old browsers, we cannot normalize, so fallback to clientX/Y
    return normalized;
  } else if (isVisualViewportFactoredIn(visualViewport)) {
    // Typically Mobile Devices
    normalized.layoutViewportX = Math.round(clientX + visualViewport.offsetLeft);
    normalized.layoutViewportY = Math.round(clientY + visualViewport.offsetTop);
  } else {
    // Typically Desktop Devices
    normalized.visualViewportX = Math.round(clientX - visualViewport.offsetLeft);
    normalized.visualViewportY = Math.round(clientY - visualViewport.offsetTop);
  }
  return normalized;
};
var getVisualViewport = function (visualViewport) {
  return {
    scale: visualViewport.scale,
    offsetLeft: visualViewport.offsetLeft,
    offsetTop: visualViewport.offsetTop,
    pageLeft: visualViewport.pageLeft,
    pageTop: visualViewport.pageTop,
    height: visualViewport.height,
    width: visualViewport.width
  };
};

function assembleIncrementalSnapshot(source, data) {
  return {
    data: assign({
      source: source
    }, data),
    type: RecordType.IncrementalSnapshot,
    timestamp: timeStampNow()
  };
}

var MOUSE_MOVE_OBSERVER_THRESHOLD = 50;
function trackMove(configuration, moveCb) {
  var _a = throttle(function (event) {
      var target = getEventTarget(event);
      if (hasSerializedNode(target)) {
        var coordinates = tryToComputeCoordinates(event);
        if (!coordinates) {
          return;
        }
        var position = {
          id: getSerializedNodeId(target),
          timeOffset: 0,
          x: coordinates.x,
          y: coordinates.y
        };
        moveCb(assembleIncrementalSnapshot(isTouchEvent(event) ? IncrementalSource.TouchMove : IncrementalSource.MouseMove, {
          positions: [position]
        }));
      }
    }, MOUSE_MOVE_OBSERVER_THRESHOLD, {
      trailing: false
    }),
    updatePosition = _a.throttled,
    cancelThrottle = _a.cancel;
  var removeListener = addEventListeners(configuration, document, [DOM_EVENT.MOUSE_MOVE, DOM_EVENT.TOUCH_MOVE], updatePosition, {
    capture: true,
    passive: true
  }).stop;
  return {
    stop: function () {
      removeListener();
      cancelThrottle();
    }
  };
}
function tryToComputeCoordinates(event) {
  var _a = isTouchEvent(event) ? event.changedTouches[0] : event,
    x = _a.clientX,
    y = _a.clientY;
  if (window.visualViewport) {
    var _b = convertMouseEventToLayoutCoordinates(x, y),
      visualViewportX = _b.visualViewportX,
      visualViewportY = _b.visualViewportY;
    x = visualViewportX;
    y = visualViewportY;
  }
  if (!Number.isFinite(x) || !Number.isFinite(y)) {
    if (event.isTrusted) {
      addTelemetryDebug('mouse/touch event without x/y');
    }
    return undefined;
  }
  return {
    x: x,
    y: y
  };
}

var _a;
var eventTypeToMouseInteraction = (_a = {},
// Listen for pointerup DOM events instead of mouseup for MouseInteraction/MouseUp records. This
// allows to reference such records from Frustration records.
//
// In the context of supporting Mobile Session Replay, we introduced `PointerInteraction` records
// used by the Mobile SDKs in place of `MouseInteraction`. In the future, we should replace
// `MouseInteraction` by `PointerInteraction` in the Browser SDK so we have an uniform way to
// convey such interaction. This would cleanly solve the issue since we would have
// `PointerInteraction/Up` records that we could reference from `Frustration` records.
_a[DOM_EVENT.POINTER_UP] = MouseInteractionType.MouseUp, _a[DOM_EVENT.MOUSE_DOWN] = MouseInteractionType.MouseDown, _a[DOM_EVENT.CLICK] = MouseInteractionType.Click, _a[DOM_EVENT.CONTEXT_MENU] = MouseInteractionType.ContextMenu, _a[DOM_EVENT.DBL_CLICK] = MouseInteractionType.DblClick, _a[DOM_EVENT.FOCUS] = MouseInteractionType.Focus, _a[DOM_EVENT.BLUR] = MouseInteractionType.Blur, _a[DOM_EVENT.TOUCH_START] = MouseInteractionType.TouchStart, _a[DOM_EVENT.TOUCH_END] = MouseInteractionType.TouchEnd, _a);
function trackMouseInteraction(configuration, mouseInteractionCb, recordIds) {
  var handler = function (event) {
    var target = getEventTarget(event);
    if (getNodePrivacyLevel(target, configuration.defaultPrivacyLevel) === NodePrivacyLevel.HIDDEN || !hasSerializedNode(target)) {
      return;
    }
    var id = getSerializedNodeId(target);
    var type = eventTypeToMouseInteraction[event.type];
    var interaction;
    if (type !== MouseInteractionType.Blur && type !== MouseInteractionType.Focus) {
      var coordinates = tryToComputeCoordinates(event);
      if (!coordinates) {
        return;
      }
      interaction = {
        id: id,
        type: type,
        x: coordinates.x,
        y: coordinates.y
      };
    } else {
      interaction = {
        id: id,
        type: type
      };
    }
    var record = assign({
      id: recordIds.getIdForEvent(event)
    }, assembleIncrementalSnapshot(IncrementalSource.MouseInteraction, interaction));
    mouseInteractionCb(record);
  };
  return addEventListeners(configuration, document, Object.keys(eventTypeToMouseInteraction), handler, {
    capture: true,
    passive: true
  });
}

var SCROLL_OBSERVER_THRESHOLD = 100;
function trackScroll(configuration, scrollCb, elementsScrollPositions, target) {
  if (target === void 0) {
    target = document;
  }
  var _a = throttle(function (event) {
      var target = getEventTarget(event);
      if (!target || getNodePrivacyLevel(target, configuration.defaultPrivacyLevel) === NodePrivacyLevel.HIDDEN || !hasSerializedNode(target)) {
        return;
      }
      var id = getSerializedNodeId(target);
      var scrollPositions = target === document ? {
        scrollTop: getScrollY(),
        scrollLeft: getScrollX()
      } : {
        scrollTop: Math.round(target.scrollTop),
        scrollLeft: Math.round(target.scrollLeft)
      };
      elementsScrollPositions.set(target, scrollPositions);
      scrollCb(assembleIncrementalSnapshot(IncrementalSource.Scroll, {
        id: id,
        x: scrollPositions.scrollLeft,
        y: scrollPositions.scrollTop
      }));
    }, SCROLL_OBSERVER_THRESHOLD),
    updatePosition = _a.throttled,
    cancelThrottle = _a.cancel;
  var removeListener = addEventListener(configuration, target, DOM_EVENT.SCROLL, updatePosition, {
    capture: true,
    passive: true
  }).stop;
  return {
    stop: function () {
      removeListener();
      cancelThrottle();
    }
  };
}

function trackViewportResize(configuration, viewportResizeCb) {
  var viewportResizeSubscription = initViewportObservable(configuration).subscribe(function (data) {
    viewportResizeCb(assembleIncrementalSnapshot(IncrementalSource.ViewportResize, data));
  });
  return {
    stop: function () {
      viewportResizeSubscription.unsubscribe();
    }
  };
}

function trackMediaInteraction(configuration, mediaInteractionCb) {
  return addEventListeners(configuration, document, [DOM_EVENT.PLAY, DOM_EVENT.PAUSE], function (event) {
    var target = getEventTarget(event);
    if (!target || getNodePrivacyLevel(target, configuration.defaultPrivacyLevel) === NodePrivacyLevel.HIDDEN || !hasSerializedNode(target)) {
      return;
    }
    mediaInteractionCb(assembleIncrementalSnapshot(IncrementalSource.MediaInteraction, {
      id: getSerializedNodeId(target),
      type: event.type === DOM_EVENT.PLAY ? MediaInteractionType.Play : MediaInteractionType.Pause
    }));
  }, {
    capture: true,
    passive: true
  });
}

function trackStyleSheet(styleSheetCb) {
  function checkStyleSheetAndCallback(styleSheet, callback) {
    if (styleSheet && hasSerializedNode(styleSheet.ownerNode)) {
      callback(getSerializedNodeId(styleSheet.ownerNode));
    }
  }
  var instrumentationStoppers = [instrumentMethod(CSSStyleSheet.prototype, 'insertRule', function (_a) {
    var styleSheet = _a.target,
      _b = _a.parameters,
      rule = _b[0],
      index = _b[1];
    checkStyleSheetAndCallback(styleSheet, function (id) {
      return styleSheetCb(assembleIncrementalSnapshot(IncrementalSource.StyleSheetRule, {
        id: id,
        adds: [{
          rule: rule,
          index: index
        }]
      }));
    });
  }), instrumentMethod(CSSStyleSheet.prototype, 'deleteRule', function (_a) {
    var styleSheet = _a.target,
      index = _a.parameters[0];
    checkStyleSheetAndCallback(styleSheet, function (id) {
      return styleSheetCb(assembleIncrementalSnapshot(IncrementalSource.StyleSheetRule, {
        id: id,
        removes: [{
          index: index
        }]
      }));
    });
  })];
  if (typeof CSSGroupingRule !== 'undefined') {
    instrumentGroupingCSSRuleClass(CSSGroupingRule);
  } else {
    instrumentGroupingCSSRuleClass(CSSMediaRule);
    instrumentGroupingCSSRuleClass(CSSSupportsRule);
  }
  function instrumentGroupingCSSRuleClass(cls) {
    instrumentationStoppers.push(instrumentMethod(cls.prototype, 'insertRule', function (_a) {
      var styleSheet = _a.target,
        _b = _a.parameters,
        rule = _b[0],
        index = _b[1];
      checkStyleSheetAndCallback(styleSheet.parentStyleSheet, function (id) {
        var path = getPathToNestedCSSRule(styleSheet);
        if (path) {
          path.push(index || 0);
          styleSheetCb(assembleIncrementalSnapshot(IncrementalSource.StyleSheetRule, {
            id: id,
            adds: [{
              rule: rule,
              index: path
            }]
          }));
        }
      });
    }), instrumentMethod(cls.prototype, 'deleteRule', function (_a) {
      var styleSheet = _a.target,
        index = _a.parameters[0];
      checkStyleSheetAndCallback(styleSheet.parentStyleSheet, function (id) {
        var path = getPathToNestedCSSRule(styleSheet);
        if (path) {
          path.push(index);
          styleSheetCb(assembleIncrementalSnapshot(IncrementalSource.StyleSheetRule, {
            id: id,
            removes: [{
              index: path
            }]
          }));
        }
      });
    }));
  }
  return {
    stop: function () {
      instrumentationStoppers.forEach(function (stopper) {
        return stopper.stop();
      });
    }
  };
}
function getPathToNestedCSSRule(rule) {
  var path = [];
  var currentRule = rule;
  while (currentRule.parentRule) {
    var rules_1 = Array.from(currentRule.parentRule.cssRules);
    var index_1 = rules_1.indexOf(currentRule);
    path.unshift(index_1);
    currentRule = currentRule.parentRule;
  }
  // A rule may not be attached to a stylesheet
  if (!currentRule.parentStyleSheet) {
    return;
  }
  var rules = Array.from(currentRule.parentStyleSheet.cssRules);
  var index = rules.indexOf(currentRule);
  path.unshift(index);
  return path;
}

function trackFocus(configuration, focusCb) {
  return addEventListeners(configuration, window, [DOM_EVENT.FOCUS, DOM_EVENT.BLUR], function () {
    focusCb({
      data: {
        has_focus: document.hasFocus()
      },
      type: RecordType.Focus,
      timestamp: timeStampNow()
    });
  });
}

function trackFrustration(lifeCycle, frustrationCb, recordIds) {
  var frustrationSubscription = lifeCycle.subscribe(12 /* LifeCycleEventType.RAW_RUM_EVENT_COLLECTED */, function (data) {
    var _a, _b, _c;
    if (data.rawRumEvent.type === "action" /* RumEventType.ACTION */ && data.rawRumEvent.action.type === "click" /* ActionType.CLICK */ && ((_b = (_a = data.rawRumEvent.action.frustration) === null || _a === void 0 ? void 0 : _a.type) === null || _b === void 0 ? void 0 : _b.length) && 'events' in data.domainContext && ((_c = data.domainContext.events) === null || _c === void 0 ? void 0 : _c.length)) {
      frustrationCb({
        timestamp: data.rawRumEvent.date,
        type: RecordType.FrustrationRecord,
        data: {
          frustrationTypes: data.rawRumEvent.action.frustration.type,
          recordIds: data.domainContext.events.map(function (e) {
            return recordIds.getIdForEvent(e);
          })
        }
      });
    }
  });
  return {
    stop: function () {
      frustrationSubscription.unsubscribe();
    }
  };
}

function trackViewEnd(lifeCycle, viewEndCb) {
  var viewEndSubscription = lifeCycle.subscribe(5 /* LifeCycleEventType.VIEW_ENDED */, function () {
    viewEndCb({
      timestamp: timeStampNow(),
      type: RecordType.ViewEnd
    });
  });
  return {
    stop: function () {
      viewEndSubscription.unsubscribe();
    }
  };
}

function trackInput(configuration, inputCb, target) {
  if (target === void 0) {
    target = document;
  }
  var defaultPrivacyLevel = configuration.defaultPrivacyLevel;
  var lastInputStateMap = new WeakMap();
  var isShadowRoot = target !== document;
  var stopEventListeners = addEventListeners(configuration, target,
  // The 'input' event bubbles across shadow roots, so we don't have to listen for it on shadow
  // roots since it will be handled by the event listener that we did add to the document. Only
  // the 'change' event is blocked and needs to be handled on shadow roots.
  isShadowRoot ? [DOM_EVENT.CHANGE] : [DOM_EVENT.INPUT, DOM_EVENT.CHANGE], function (event) {
    var target = getEventTarget(event);
    if (target instanceof HTMLInputElement || target instanceof HTMLTextAreaElement || target instanceof HTMLSelectElement) {
      onElementChange(target);
    }
  }, {
    capture: true,
    passive: true
  }).stop;
  var stopPropertySetterInstrumentation;
  if (!isShadowRoot) {
    var instrumentationStoppers_1 = [instrumentSetter(HTMLInputElement.prototype, 'value', onElementChange), instrumentSetter(HTMLInputElement.prototype, 'checked', onElementChange), instrumentSetter(HTMLSelectElement.prototype, 'value', onElementChange), instrumentSetter(HTMLTextAreaElement.prototype, 'value', onElementChange), instrumentSetter(HTMLSelectElement.prototype, 'selectedIndex', onElementChange)];
    stopPropertySetterInstrumentation = function () {
      instrumentationStoppers_1.forEach(function (stopper) {
        return stopper.stop();
      });
    };
  } else {
    stopPropertySetterInstrumentation = noop$1;
  }
  return {
    stop: function () {
      stopPropertySetterInstrumentation();
      stopEventListeners();
    }
  };
  function onElementChange(target) {
    var nodePrivacyLevel = getNodePrivacyLevel(target, defaultPrivacyLevel);
    if (nodePrivacyLevel === NodePrivacyLevel.HIDDEN) {
      return;
    }
    var type = target.type;
    var inputState;
    if (type === 'radio' || type === 'checkbox') {
      if (shouldMaskNode(target, nodePrivacyLevel)) {
        return;
      }
      inputState = {
        isChecked: target.checked
      };
    } else {
      var value = getElementInputValue(target, nodePrivacyLevel);
      if (value === undefined) {
        return;
      }
      inputState = {
        text: value
      };
    }
    // Can be multiple changes on the same node within the same batched mutation observation.
    cbWithDedup(target, inputState);
    // If a radio was checked, other radios with the same name attribute will be unchecked.
    var name = target.name;
    if (type === 'radio' && name && target.checked) {
      forEach(document.querySelectorAll("input[type=\"radio\"][name=\"".concat(cssEscape(name), "\"]")), function (el) {
        if (el !== target) {
          // TODO: Consider the privacy implications for various differing input privacy levels
          cbWithDedup(el, {
            isChecked: false
          });
        }
      });
    }
  }
  /**
   * There can be multiple changes on the same node within the same batched mutation observation.
   */
  function cbWithDedup(target, inputState) {
    if (!hasSerializedNode(target)) {
      return;
    }
    var lastInputState = lastInputStateMap.get(target);
    if (!lastInputState || lastInputState.text !== inputState.text || lastInputState.isChecked !== inputState.isChecked) {
      lastInputStateMap.set(target, inputState);
      inputCb(assembleIncrementalSnapshot(IncrementalSource.Input, assign({
        id: getSerializedNodeId(target)
      }, inputState)));
    }
  }
}

/**
 * Maximum duration to wait before processing mutations. If the browser is idle, mutations will be
 * processed more quickly. If the browser is busy executing small tasks (ex: rendering frames), the
 * mutations will wait MUTATION_PROCESS_MAX_DELAY milliseconds before being processed. If the
 * browser is busy executing a longer task, mutations will be processed after this task.
 */
var MUTATION_PROCESS_MAX_DELAY = 100;
/**
 * Minimum duration to wait before processing mutations. This is used to batch mutations together
 * and be able to deduplicate them to save processing time and bandwidth.
 * 16ms is the duration of a frame at 60fps that ensure fluid UI.
 */
var MUTATION_PROCESS_MIN_DELAY = 16;
function createMutationBatch(processMutationBatch) {
  var cancelScheduledFlush = noop$1;
  var pendingMutations = [];
  function flush() {
    cancelScheduledFlush();
    processMutationBatch(pendingMutations);
    pendingMutations = [];
  }
  var _a = throttle(flush, MUTATION_PROCESS_MIN_DELAY, {
      leading: false
    }),
    throttledFlush = _a.throttled,
    cancelThrottle = _a.cancel;
  return {
    addMutations: function (mutations) {
      if (pendingMutations.length === 0) {
        cancelScheduledFlush = requestIdleCallback(throttledFlush, {
          timeout: MUTATION_PROCESS_MAX_DELAY
        });
      }
      pendingMutations.push.apply(pendingMutations, mutations);
    },
    flush: flush,
    stop: function () {
      cancelScheduledFlush();
      cancelThrottle();
    }
  };
}
/**
 * Use 'requestIdleCallback' when available: it will throttle the mutation processing if the
 * browser is busy rendering frames (ex: when frames are below 60fps). When not available, the
 * fallback on 'requestAnimationFrame' will still ensure the mutations are processed after any
 * browser rendering process (Layout, Recalculate Style, etc.), so we can serialize DOM nodes efficiently.
 *
 * Note: check both 'requestIdleCallback' and 'cancelIdleCallback' existence because some polyfills only implement 'requestIdleCallback'.
 */
function requestIdleCallback(callback, opts) {
  if (window.requestIdleCallback && window.cancelIdleCallback) {
    var id_1 = window.requestIdleCallback(monitor(callback), opts);
    return function () {
      return window.cancelIdleCallback(id_1);
    };
  }
  var id = window.requestAnimationFrame(monitor(callback));
  return function () {
    return window.cancelAnimationFrame(id);
  };
}

/**
 * Buffers and aggregate mutations generated by a MutationObserver into MutationPayload
 */
function trackMutation(mutationCallback, configuration, shadowRootsController, target) {
  var MutationObserver = getMutationObserverConstructor();
  if (!MutationObserver) {
    return {
      stop: noop$1,
      flush: noop$1
    };
  }
  var mutationBatch = createMutationBatch(function (mutations) {
    processMutations(mutations.concat(observer.takeRecords()), mutationCallback, configuration, shadowRootsController);
  });
  var observer = new MutationObserver(monitor(mutationBatch.addMutations));
  observer.observe(target, {
    attributeOldValue: true,
    attributes: true,
    characterData: true,
    characterDataOldValue: true,
    childList: true,
    subtree: true
  });
  return {
    stop: function () {
      observer.disconnect();
      mutationBatch.stop();
    },
    flush: function () {
      mutationBatch.flush();
    }
  };
}
function processMutations(mutations, mutationCallback, configuration, shadowRootsController) {
  var nodePrivacyLevelCache = new Map();
  mutations.filter(function (mutation) {
    return mutation.type === 'childList';
  }).forEach(function (mutation) {
    mutation.removedNodes.forEach(function (removedNode) {
      traverseRemovedShadowDom(removedNode, shadowRootsController.removeShadowRoot);
    });
  });
  // Discard any mutation with a 'target' node that:
  // * isn't injected in the current document or isn't known/serialized yet: those nodes are likely
  // part of a mutation occurring in a parent Node
  // * should be hidden or ignored
  var filteredMutations = mutations.filter(function (mutation) {
    return mutation.target.isConnected && nodeAndAncestorsHaveSerializedNode(mutation.target) && getNodePrivacyLevel(mutation.target, configuration.defaultPrivacyLevel, nodePrivacyLevelCache) !== NodePrivacyLevel.HIDDEN;
  });
  var _a = processChildListMutations(filteredMutations.filter(function (mutation) {
      return mutation.type === 'childList';
    }), configuration, shadowRootsController, nodePrivacyLevelCache),
    adds = _a.adds,
    removes = _a.removes,
    hasBeenSerialized = _a.hasBeenSerialized;
  var texts = processCharacterDataMutations(filteredMutations.filter(function (mutation) {
    return mutation.type === 'characterData' && !hasBeenSerialized(mutation.target);
  }), configuration, nodePrivacyLevelCache);
  var attributes = processAttributesMutations(filteredMutations.filter(function (mutation) {
    return mutation.type === 'attributes' && !hasBeenSerialized(mutation.target);
  }), configuration, nodePrivacyLevelCache);
  if (!texts.length && !attributes.length && !removes.length && !adds.length) {
    return;
  }
  mutationCallback(assembleIncrementalSnapshot(IncrementalSource.Mutation, {
    adds: adds,
    removes: removes,
    texts: texts,
    attributes: attributes
  }));
}
function processChildListMutations(mutations, configuration, shadowRootsController, nodePrivacyLevelCache) {
  // First, we iterate over mutations to collect:
  //
  // * nodes that have been added in the document and not removed by a subsequent mutation
  // * nodes that have been removed from the document but were not added in a previous mutation
  //
  // For this second category, we also collect their previous parent (mutation.target) because we'll
  // need it to emit a 'remove' mutation.
  //
  // Those two categories may overlap: if a node moved from a position to another, it is reported as
  // two mutation records, one with a "removedNodes" and the other with "addedNodes". In this case,
  // the node will be in both sets.
  var addedAndMovedNodes = new Set();
  var removedNodes = new Map();
  var _loop_1 = function (mutation) {
    mutation.addedNodes.forEach(function (node) {
      addedAndMovedNodes.add(node);
    });
    mutation.removedNodes.forEach(function (node) {
      if (!addedAndMovedNodes.has(node)) {
        removedNodes.set(node, mutation.target);
      }
      addedAndMovedNodes.delete(node);
    });
  };
  for (var _i = 0, mutations_1 = mutations; _i < mutations_1.length; _i++) {
    var mutation = mutations_1[_i];
    _loop_1(mutation);
  }
  // Then, we sort nodes that are still in the document by topological order, for two reasons:
  //
  // * We will serialize each added nodes with their descendants. We don't want to serialize a node
  // twice, so we need to iterate over the parent nodes first and skip any node that is contained in
  // a precedent node.
  //
  // * To emit "add" mutations, we need references to the parent and potential next sibling of each
  // added node. So we need to iterate over the parent nodes first, and when multiple nodes are
  // siblings, we want to iterate from last to first. This will ensure that any "next" node is
  // already serialized and have an id.
  var sortedAddedAndMovedNodes = Array.from(addedAndMovedNodes);
  sortAddedAndMovedNodes(sortedAddedAndMovedNodes);
  // Then, we iterate over our sorted node sets to emit mutations. We collect the newly serialized
  // node ids in a set to be able to skip subsequent related mutations.
  var serializedNodeIds = new Set();
  var addedNodeMutations = [];
  for (var _a = 0, sortedAddedAndMovedNodes_1 = sortedAddedAndMovedNodes; _a < sortedAddedAndMovedNodes_1.length; _a++) {
    var node = sortedAddedAndMovedNodes_1[_a];
    if (hasBeenSerialized(node)) {
      continue;
    }
    var parentNodePrivacyLevel = getNodePrivacyLevel(node.parentNode, configuration.defaultPrivacyLevel, nodePrivacyLevelCache);
    if (parentNodePrivacyLevel === NodePrivacyLevel.HIDDEN || parentNodePrivacyLevel === NodePrivacyLevel.IGNORE) {
      continue;
    }
    var serializedNode = serializeNodeWithId(node, {
      serializedNodeIds: serializedNodeIds,
      parentNodePrivacyLevel: parentNodePrivacyLevel,
      serializationContext: {
        status: 2 /* SerializationContextStatus.MUTATION */,
        shadowRootsController: shadowRootsController
      },
      configuration: configuration
    });
    if (!serializedNode) {
      continue;
    }
    var parentNode = getParentNode(node);
    addedNodeMutations.push({
      nextId: getNextSibling(node),
      parentId: getSerializedNodeId(parentNode),
      node: serializedNode
    });
  }
  // Finally, we emit remove mutations.
  var removedNodeMutations = [];
  removedNodes.forEach(function (parent, node) {
    if (hasSerializedNode(node)) {
      removedNodeMutations.push({
        parentId: getSerializedNodeId(parent),
        id: getSerializedNodeId(node)
      });
    }
  });
  return {
    adds: addedNodeMutations,
    removes: removedNodeMutations,
    hasBeenSerialized: hasBeenSerialized
  };
  function hasBeenSerialized(node) {
    return hasSerializedNode(node) && serializedNodeIds.has(getSerializedNodeId(node));
  }
  function getNextSibling(node) {
    var nextSibling = node.nextSibling;
    while (nextSibling) {
      if (hasSerializedNode(nextSibling)) {
        return getSerializedNodeId(nextSibling);
      }
      nextSibling = nextSibling.nextSibling;
    }
    return null;
  }
}
function processCharacterDataMutations(mutations, configuration, nodePrivacyLevelCache) {
  var _a;
  var textMutations = [];
  // Deduplicate mutations based on their target node
  var handledNodes = new Set();
  var filteredMutations = mutations.filter(function (mutation) {
    if (handledNodes.has(mutation.target)) {
      return false;
    }
    handledNodes.add(mutation.target);
    return true;
  });
  // Emit mutations
  for (var _i = 0, filteredMutations_1 = filteredMutations; _i < filteredMutations_1.length; _i++) {
    var mutation = filteredMutations_1[_i];
    var value = mutation.target.textContent;
    if (value === mutation.oldValue) {
      continue;
    }
    var parentNodePrivacyLevel = getNodePrivacyLevel(getParentNode(mutation.target), configuration.defaultPrivacyLevel, nodePrivacyLevelCache);
    if (parentNodePrivacyLevel === NodePrivacyLevel.HIDDEN || parentNodePrivacyLevel === NodePrivacyLevel.IGNORE) {
      continue;
    }
    textMutations.push({
      id: getSerializedNodeId(mutation.target),
      // TODO: pass a valid "ignoreWhiteSpace" argument
      value: (_a = getTextContent$1(mutation.target, false, parentNodePrivacyLevel)) !== null && _a !== void 0 ? _a : null
    });
  }
  return textMutations;
}
function processAttributesMutations(mutations, configuration, nodePrivacyLevelCache) {
  var attributeMutations = [];
  // Deduplicate mutations based on their target node and changed attribute
  var handledElements = new Map();
  var filteredMutations = mutations.filter(function (mutation) {
    var handledAttributes = handledElements.get(mutation.target);
    if (handledAttributes === null || handledAttributes === void 0 ? void 0 : handledAttributes.has(mutation.attributeName)) {
      return false;
    }
    if (!handledAttributes) {
      handledElements.set(mutation.target, new Set([mutation.attributeName]));
    } else {
      handledAttributes.add(mutation.attributeName);
    }
    return true;
  });
  // Emit mutations
  var emittedMutations = new Map();
  for (var _i = 0, filteredMutations_2 = filteredMutations; _i < filteredMutations_2.length; _i++) {
    var mutation = filteredMutations_2[_i];
    var uncensoredValue = mutation.target.getAttribute(mutation.attributeName);
    if (uncensoredValue === mutation.oldValue) {
      continue;
    }
    var privacyLevel = getNodePrivacyLevel(mutation.target, configuration.defaultPrivacyLevel, nodePrivacyLevelCache);
    var attributeValue = serializeAttribute(mutation.target, privacyLevel, mutation.attributeName, configuration);
    var transformedValue = void 0;
    if (mutation.attributeName === 'value') {
      var inputValue = getElementInputValue(mutation.target, privacyLevel);
      if (inputValue === undefined) {
        continue;
      }
      transformedValue = inputValue;
    } else if (typeof attributeValue === 'string') {
      transformedValue = attributeValue;
    } else {
      transformedValue = null;
    }
    var emittedMutation = emittedMutations.get(mutation.target);
    if (!emittedMutation) {
      emittedMutation = {
        id: getSerializedNodeId(mutation.target),
        attributes: {}
      };
      attributeMutations.push(emittedMutation);
      emittedMutations.set(mutation.target, emittedMutation);
    }
    emittedMutation.attributes[mutation.attributeName] = transformedValue;
  }
  return attributeMutations;
}
function sortAddedAndMovedNodes(nodes) {
  nodes.sort(function (a, b) {
    var position = a.compareDocumentPosition(b);
    /* eslint-disable no-bitwise */
    if (position & Node.DOCUMENT_POSITION_CONTAINED_BY) {
      return -1;
    } else if (position & Node.DOCUMENT_POSITION_CONTAINS) {
      return 1;
    } else if (position & Node.DOCUMENT_POSITION_FOLLOWING) {
      return 1;
    } else if (position & Node.DOCUMENT_POSITION_PRECEDING) {
      return -1;
    }
    /* eslint-enable no-bitwise */
    return 0;
  });
}
function traverseRemovedShadowDom(removedNode, shadowDomRemovedCallback) {
  if (isNodeShadowHost(removedNode)) {
    shadowDomRemovedCallback(removedNode.shadowRoot);
  }
  forEachChildNodes(removedNode, function (childNode) {
    return traverseRemovedShadowDom(childNode, shadowDomRemovedCallback);
  });
}

function createElementsScrollPositions() {
  var scrollPositionsByElement = new WeakMap();
  return {
    set: function (element, scrollPositions) {
      if (element === document && !document.scrollingElement) {
        // cf https://drafts.csswg.org/cssom-view/#dom-document-scrollingelement,
        // in some cases scrolling elements can not be defined, we don't support those for now
        return;
      }
      scrollPositionsByElement.set(element === document ? document.scrollingElement : element, scrollPositions);
    },
    get: function (element) {
      return scrollPositionsByElement.get(element);
    },
    has: function (element) {
      return scrollPositionsByElement.has(element);
    }
  };
}

var initShadowRootsController = function (configuration, callback, elementsScrollPositions) {
  var controllerByShadowRoot = new Map();
  var shadowRootsController = {
    addShadowRoot: function (shadowRoot) {
      if (controllerByShadowRoot.has(shadowRoot)) {
        return;
      }
      var mutationTracker = trackMutation(callback, configuration, shadowRootsController, shadowRoot);
      // The change event does not bubble up across the shadow root, we have to listen on the shadow root
      var inputTracker = trackInput(configuration, callback, shadowRoot);
      // The scroll event does not bubble up across the shadow root, we have to listen on the shadow root
      var scrollTracker = trackScroll(configuration, callback, elementsScrollPositions, shadowRoot);
      controllerByShadowRoot.set(shadowRoot, {
        flush: function () {
          return mutationTracker.flush();
        },
        stop: function () {
          mutationTracker.stop();
          inputTracker.stop();
          scrollTracker.stop();
        }
      });
    },
    removeShadowRoot: function (shadowRoot) {
      var entry = controllerByShadowRoot.get(shadowRoot);
      if (!entry) {
        // unidentified root cause: observed in some cases with shadow DOM added by browser extensions
        return;
      }
      entry.stop();
      controllerByShadowRoot.delete(shadowRoot);
    },
    stop: function () {
      controllerByShadowRoot.forEach(function (_a) {
        var stop = _a.stop;
        return stop();
      });
    },
    flush: function () {
      controllerByShadowRoot.forEach(function (_a) {
        var flush = _a.flush;
        return flush();
      });
    }
  };
  return shadowRootsController;
};

function startFullSnapshots(elementsScrollPositions, shadowRootsController, lifeCycle, configuration, flushMutations, fullSnapshotCallback) {
  var takeFullSnapshot = function (timestamp, serializationContext) {
    if (timestamp === void 0) {
      timestamp = timeStampNow();
    }
    if (serializationContext === void 0) {
      serializationContext = {
        status: 0 /* SerializationContextStatus.INITIAL_FULL_SNAPSHOT */,
        elementsScrollPositions: elementsScrollPositions,
        shadowRootsController: shadowRootsController
      };
    }
    var _a = getViewportDimension(),
      width = _a.width,
      height = _a.height;
    var records = [{
      data: {
        height: height,
        href: window.location.href,
        width: width
      },
      type: RecordType.Meta,
      timestamp: timestamp
    }, {
      data: {
        has_focus: document.hasFocus()
      },
      type: RecordType.Focus,
      timestamp: timestamp
    }, {
      data: {
        node: serializeDocument(document, configuration, serializationContext),
        initialOffset: {
          left: getScrollX(),
          top: getScrollY()
        }
      },
      type: RecordType.FullSnapshot,
      timestamp: timestamp
    }];
    if (window.visualViewport) {
      records.push({
        data: getVisualViewport(window.visualViewport),
        type: RecordType.VisualViewport,
        timestamp: timestamp
      });
    }
    return records;
  };
  fullSnapshotCallback(takeFullSnapshot());
  var unsubscribe = lifeCycle.subscribe(3 /* LifeCycleEventType.VIEW_CREATED */, function (view) {
    flushMutations();
    fullSnapshotCallback(takeFullSnapshot(view.startClocks.timeStamp, {
      shadowRootsController: shadowRootsController,
      status: 1 /* SerializationContextStatus.SUBSEQUENT_FULL_SNAPSHOT */,
      elementsScrollPositions: elementsScrollPositions
    }));
  }).unsubscribe;
  return {
    stop: unsubscribe
  };
}

function initRecordIds() {
  var recordIds = new WeakMap();
  var nextId = 1;
  return {
    getIdForEvent: function (event) {
      if (!recordIds.has(event)) {
        recordIds.set(event, nextId++);
      }
      return recordIds.get(event);
    }
  };
}

function record(options) {
  var emit = options.emit,
    configuration = options.configuration,
    lifeCycle = options.lifeCycle;
  // runtime checks for user options
  if (!emit) {
    throw new Error('emit function is required');
  }
  var emitAndComputeStats = function (record) {
    emit(record);
    sendToExtension('record', {
      record: record
    });
    var view = options.viewContexts.findView();
    addRecord(view.id);
  };
  var elementsScrollPositions = createElementsScrollPositions();
  var shadowRootsController = initShadowRootsController(configuration, emitAndComputeStats, elementsScrollPositions);
  var stopFullSnapshots = startFullSnapshots(elementsScrollPositions, shadowRootsController, lifeCycle, configuration, flushMutations, function (records) {
    return records.forEach(function (record) {
      return emitAndComputeStats(record);
    });
  }).stop;
  function flushMutations() {
    shadowRootsController.flush();
    mutationTracker.flush();
  }
  var recordIds = initRecordIds();
  var mutationTracker = trackMutation(emitAndComputeStats, configuration, shadowRootsController, document);
  var trackers = [mutationTracker, trackMove(configuration, emitAndComputeStats), trackMouseInteraction(configuration, emitAndComputeStats, recordIds), trackScroll(configuration, emitAndComputeStats, elementsScrollPositions, document), trackViewportResize(configuration, emitAndComputeStats), trackInput(configuration, emitAndComputeStats), trackMediaInteraction(configuration, emitAndComputeStats), trackStyleSheet(emitAndComputeStats), trackFocus(configuration, emitAndComputeStats), trackViewportResize(configuration, emitAndComputeStats), trackFrustration(lifeCycle, emitAndComputeStats, recordIds), trackViewEnd(lifeCycle, function (viewEndRecord) {
    flushMutations();
    emitAndComputeStats(viewEndRecord);
  })];
  return {
    stop: function () {
      shadowRootsController.stop();
      trackers.forEach(function (tracker) {
        return tracker.stop();
      });
      stopFullSnapshots();
    },
    flushMutations: flushMutations,
    shadowRootsController: shadowRootsController
  };
}

function buildReplayPayload(data, metadata, rawSegmentBytesCount) {
  var formData = new FormData();
  formData.append('segment', new Blob([data], {
    type: 'application/octet-stream'
  }), "".concat(metadata.session.id, "-").concat(metadata.start));
  var metadataAndSegmentSizes = assign({
    raw_segment_size: rawSegmentBytesCount,
    compressed_segment_size: data.byteLength
  }, metadata);
  var serializedMetadataAndSegmentSizes = JSON.stringify(metadataAndSegmentSizes);
  formData.append('event', new Blob([serializedMetadataAndSegmentSizes], {
    type: 'application/json'
  }));
  return {
    data: formData,
    bytesCount: data.byteLength
  };
}

var Segment = /** @class */function () {
  function Segment(encoder, context, creationReason) {
    this.encoder = encoder;
    this.encodedBytesCount = 0;
    var viewId = context.view.id;
    this.metadata = assign({
      start: Infinity,
      end: -Infinity,
      creation_reason: creationReason,
      records_count: 0,
      has_full_snapshot: false,
      index_in_view: getSegmentsCount(viewId),
      source: 'browser'
    }, context);
    addSegment(viewId);
  }
  Segment.prototype.addRecord = function (record, callback) {
    var _this = this;
    var _a;
    this.metadata.start = Math.min(this.metadata.start, record.timestamp);
    this.metadata.end = Math.max(this.metadata.end, record.timestamp);
    this.metadata.records_count += 1;
    (_a = this.metadata).has_full_snapshot || (_a.has_full_snapshot = record.type === RecordType.FullSnapshot);
    var prefix = this.encoder.isEmpty ? '{"records":[' : ',';
    this.encoder.write(prefix + JSON.stringify(record), function (additionalEncodedBytesCount) {
      _this.encodedBytesCount += additionalEncodedBytesCount;
      callback(_this.encodedBytesCount);
    });
  };
  Segment.prototype.flush = function (callback) {
    var _this = this;
    if (this.encoder.isEmpty) {
      throw new Error('Empty segment flushed');
    }
    this.encoder.write("],".concat(JSON.stringify(this.metadata).slice(1), "\n"));
    this.encoder.finish(function (encoderResult) {
      addWroteData(_this.metadata.view.id, encoderResult.rawBytesCount);
      callback(_this.metadata, encoderResult);
    });
  };
  return Segment;
}();

var SEGMENT_DURATION_LIMIT = 30 * ONE_SECOND;
/**
 * beacon payload max queue size implementation is 64kb
 * ensure that we leave room for logs, rum and potential other users
 */
var SEGMENT_BYTES_LIMIT = 60000;
// Segments are the main data structure for session replays. They contain context information used
// for indexing or UI needs, and a list of records (RRWeb 'events', renamed to avoid confusing
// namings). They are stored without any processing from the intake, and fetched one after the
// other while a session is being replayed. Their encoding (deflate) are carefully crafted to allow
// concatenating multiple segments together. Segments have a size overhead (metadata), so our goal is to
// build segments containing as many records as possible while complying with the various flush
// strategies to guarantee a good replay quality.
//
// When the recording starts, a segment is initially created.  The segment is flushed (finalized and
// sent) based on various events (non-exhaustive list):
//
// * the page visibility change or becomes to unload
// * the segment duration reaches a limit
// * the encoded segment bytes count reaches a limit
// * ...
//
// A segment cannot be created without its context.  If the RUM session ends and no session id is
// available when creating a new segment, records will be ignored, until the session is renewed and
// a new session id is available.
//
// Empty segments (segments with no record) aren't useful and should be ignored.
//
// To help investigate session replays issues, each segment is created with a "creation reason",
// indicating why the session has been created.
function startSegmentCollection(lifeCycle, configuration, sessionManager, viewContexts, httpRequest, encoder) {
  return doStartSegmentCollection(lifeCycle, function () {
    return computeSegmentContext(configuration.applicationId, sessionManager, viewContexts);
  }, httpRequest, encoder);
}
function doStartSegmentCollection(lifeCycle, getSegmentContext, httpRequest, encoder) {
  var state = {
    status: 0 /* SegmentCollectionStatus.WaitingForInitialRecord */,
    nextSegmentCreationReason: 'init'
  };
  var unsubscribeViewCreated = lifeCycle.subscribe(3 /* LifeCycleEventType.VIEW_CREATED */, function () {
    flushSegment('view_change');
  }).unsubscribe;
  var unsubscribePageExited = lifeCycle.subscribe(11 /* LifeCycleEventType.PAGE_EXITED */, function (pageExitEvent) {
    flushSegment(pageExitEvent.reason);
  }).unsubscribe;
  function flushSegment(flushReason) {
    if (state.status === 1 /* SegmentCollectionStatus.SegmentPending */) {
      state.segment.flush(function (metadata, encoderResult) {
        var payload = buildReplayPayload(encoderResult.output, metadata, encoderResult.rawBytesCount);
        if (isPageExitReason(flushReason)) {
          httpRequest.sendOnExit(payload);
        } else {
          httpRequest.send(payload);
        }
      });
      clearTimeout$1(state.expirationTimeoutId);
    }
    if (flushReason !== 'stop') {
      state = {
        status: 0 /* SegmentCollectionStatus.WaitingForInitialRecord */,
        nextSegmentCreationReason: flushReason
      };
    } else {
      state = {
        status: 2 /* SegmentCollectionStatus.Stopped */
      };
    }
  }
  return {
    addRecord: function (record) {
      if (state.status === 2 /* SegmentCollectionStatus.Stopped */) {
        return;
      }
      if (state.status === 0 /* SegmentCollectionStatus.WaitingForInitialRecord */) {
        var context = getSegmentContext();
        if (!context) {
          return;
        }
        state = {
          status: 1 /* SegmentCollectionStatus.SegmentPending */,
          segment: new Segment(encoder, context, state.nextSegmentCreationReason),
          expirationTimeoutId: setTimeout$1(function () {
            flushSegment('segment_duration_limit');
          }, SEGMENT_DURATION_LIMIT)
        };
      }
      state.segment.addRecord(record, function (encodedBytesCount) {
        if (encodedBytesCount > SEGMENT_BYTES_LIMIT) {
          flushSegment('segment_bytes_limit');
        }
      });
    },
    stop: function () {
      flushSegment('stop');
      unsubscribeViewCreated();
      unsubscribePageExited();
    }
  };
}
function computeSegmentContext(applicationId, sessionManager, viewContexts) {
  var session = sessionManager.findTrackedSession();
  var viewContext = viewContexts.findView();
  if (!session || !viewContext) {
    return undefined;
  }
  return {
    application: {
      id: applicationId
    },
    session: {
      id: session.id
    },
    view: {
      id: viewContext.id
    }
  };
}

function startRecordBridge(viewContexts) {
  var bridge = getEventBridge();
  return {
    addRecord: function (record) {
      // Get the current active view, not at the time of the record, aligning with the segment logic.
      // This approach could potentially associate the record to an incorrect view, in case the record date is in the past (e.g. frustration records).
      // However the risk is minimal. We could address the issue when potential negative impact are identified.
      var view = viewContexts.findView();
      bridge.send('record', record, view.id);
    }
  };
}

function startRecording(lifeCycle, configuration, sessionManager, viewContexts, encoder, httpRequest) {
  var cleanupTasks = [];
  var reportError = function (error) {
    lifeCycle.notify(14 /* LifeCycleEventType.RAW_ERROR_COLLECTED */, {
      error: error
    });
    addTelemetryDebug('Error reported to customer', {
      'error.message': error.message
    });
  };
  var replayRequest = httpRequest || createHttpRequest(configuration, configuration.sessionReplayEndpointBuilder, SEGMENT_BYTES_LIMIT, reportError);
  var addRecord;
  if (!canUseEventBridge()) {
    var segmentCollection = startSegmentCollection(lifeCycle, configuration, sessionManager, viewContexts, replayRequest, encoder);
    addRecord = segmentCollection.addRecord;
    cleanupTasks.push(segmentCollection.stop);
  } else {
    addRecord = startRecordBridge(viewContexts).addRecord;
  }
  var stopRecording = record({
    emit: addRecord,
    configuration: configuration,
    lifeCycle: lifeCycle,
    viewContexts: viewContexts
  }).stop;
  cleanupTasks.push(stopRecording);
  return {
    stop: function () {
      cleanupTasks.forEach(function (task) {
        return task();
      });
    }
  };
}

/**
 * Test for Browser features used while recording
 */
function isBrowserSupported() {
  return (
    // Array.from is a bit less supported by browsers than CSSSupportsRule, but has higher chances
    // to be polyfilled. Test for both to be more confident. We could add more things if we find out
    // this test is not sufficient.
    typeof Array.from === 'function' && typeof CSSSupportsRule === 'function' && typeof URL.createObjectURL === 'function' && 'forEach' in NodeList.prototype
  );
}

function getSessionReplayLink(configuration, sessionManager, viewContexts, isRecordingStarted) {
  var session = sessionManager.findTrackedSession();
  var errorType = getErrorType(session, isRecordingStarted);
  var viewContext = viewContexts.findView();
  return getSessionReplayUrl(configuration, {
    viewContext: viewContext,
    errorType: errorType,
    session: session
  });
}
function getErrorType(session, isRecordingStarted) {
  if (!isBrowserSupported()) {
    return 'browser-not-supported';
  }
  if (!session) {
    // possibilities:
    // - rum sampled out
    // - session expired (edge case)
    return 'rum-not-tracked';
  }
  if (session.sessionReplay === 0 /* SessionReplayState.OFF */) {
    // possibilities
    // - replay sampled out
    return 'incorrect-session-plan';
  }
  if (!isRecordingStarted) {
    return 'replay-not-started';
  }
}

function createDeflateEncoder(configuration, worker, streamId) {
  var rawBytesCount = 0;
  var compressedData = [];
  var compressedDataTrailer;
  var nextWriteActionId = 0;
  var pendingWriteActions = [];
  var removeMessageListener = addEventListener(configuration, worker, 'message', function (_a) {
    var workerResponse = _a.data;
    if (workerResponse.type !== 'wrote' || workerResponse.streamId !== streamId) {
      return;
    }
    rawBytesCount += workerResponse.additionalBytesCount;
    compressedData.push(workerResponse.result);
    compressedDataTrailer = workerResponse.trailer;
    var nextPendingAction = pendingWriteActions.shift();
    if (nextPendingAction && nextPendingAction.id === workerResponse.id) {
      if (nextPendingAction.writeCallback) {
        nextPendingAction.writeCallback(workerResponse.result.byteLength);
      } else if (nextPendingAction.finishCallback) {
        nextPendingAction.finishCallback();
      }
    } else {
      removeMessageListener();
      addTelemetryDebug('Worker responses received out of order.');
    }
  }).stop;
  function consumeResult() {
    var output = compressedData.length === 0 ? new Uint8Array(0) : concatBuffers(compressedData.concat(compressedDataTrailer));
    var result = {
      rawBytesCount: rawBytesCount,
      output: output,
      outputBytesCount: output.byteLength,
      encoding: 'deflate'
    };
    rawBytesCount = 0;
    compressedData = [];
    return result;
  }
  function sendResetIfNeeded() {
    if (nextWriteActionId > 0) {
      worker.postMessage({
        action: 'reset',
        streamId: streamId
      });
      nextWriteActionId = 0;
    }
  }
  return {
    isAsync: true,
    get isEmpty() {
      return nextWriteActionId === 0;
    },
    write: function (data, callback) {
      worker.postMessage({
        action: 'write',
        id: nextWriteActionId,
        data: data,
        streamId: streamId
      });
      pendingWriteActions.push({
        id: nextWriteActionId,
        writeCallback: callback,
        data: data
      });
      nextWriteActionId += 1;
    },
    finish: function (callback) {
      sendResetIfNeeded();
      if (!pendingWriteActions.length) {
        callback(consumeResult());
      } else {
        // Make sure we do not call any write callback
        pendingWriteActions.forEach(function (pendingWriteAction) {
          delete pendingWriteAction.writeCallback;
        });
        // Wait for the last action to finish before calling the finish callback
        pendingWriteActions[pendingWriteActions.length - 1].finishCallback = function () {
          return callback(consumeResult());
        };
      }
    },
    finishSync: function () {
      sendResetIfNeeded();
      var pendingData = pendingWriteActions.map(function (pendingWriteAction) {
        // Make sure we do not call any write or finish callback
        delete pendingWriteAction.writeCallback;
        delete pendingWriteAction.finishCallback;
        return pendingWriteAction.data;
      }).join('');
      return assign(consumeResult(), {
        pendingData: pendingData
      });
    },
    estimateEncodedBytesCount: function (data) {
      // This is a rough estimation of the data size once it'll be encoded by deflate. We observed
      // that if it's the first chunk of data pushed to the stream, the ratio is lower (3-4), but
      // after that the ratio is greater (10+). We chose 8 here, which (on average) seems to produce
      // requests of the expected size.
      return data.length / 8;
    },
    stop: function () {
      removeMessageListener();
    }
  };
}

var INITIALIZATION_TIME_OUT_DELAY = 10 * ONE_SECOND;
function createDeflateWorker(configuration) {
  return new Worker(configuration.workerUrl || URL.createObjectURL(new Blob(["!function(){\"use strict\";function t(t){for(var e=t.reduce((function(t,e){return t+e.length}),0),a=new Uint8Array(e),n=0,r=0,i=t;r<i.length;r++){var s=i[r];a.set(s,n),n+=s.length}return a}function e(t){for(var e=t.length;--e>=0;)t[e]=0}var a=256,n=286,r=30,i=15,s=new Uint8Array([0,0,0,0,0,0,0,0,1,1,1,1,2,2,2,2,3,3,3,3,4,4,4,4,5,5,5,5,0]),_=new Uint8Array([0,0,0,0,1,1,2,2,3,3,4,4,5,5,6,6,7,7,8,8,9,9,10,10,11,11,12,12,13,13]),h=new Uint8Array([0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,2,3,7]),l=new Uint8Array([16,17,18,0,8,7,9,6,10,5,11,4,12,3,13,2,14,1,15]),o=new Array(576);e(o);var d=new Array(60);e(d);var u=new Array(512);e(u);var f=new Array(256);e(f);var c=new Array(29);e(c);var p,g,w,v=new Array(r);function b(t,e,a,n,r){this.static_tree=t,this.extra_bits=e,this.extra_base=a,this.elems=n,this.max_length=r,this.has_stree=t&&t.length}function m(t,e){this.dyn_tree=t,this.max_code=0,this.stat_desc=e}e(v);var y=function(t){return t<256?u[t]:u[256+(t>>>7)]},k=function(t,e){t.pending_buf[t.pending++]=255&e,t.pending_buf[t.pending++]=e>>>8&255},z=function(t,e,a){t.bi_valid>16-a?(t.bi_buf|=e<<t.bi_valid&65535,k(t,t.bi_buf),t.bi_buf=e>>16-t.bi_valid,t.bi_valid+=a-16):(t.bi_buf|=e<<t.bi_valid&65535,t.bi_valid+=a)},x=function(t,e,a){z(t,a[2*e],a[2*e+1])},A=function(t,e){var a=0;do{a|=1&t,t>>>=1,a<<=1}while(--e>0);return a>>>1},E=function(t,e,a){var n,r,s=new Array(16),_=0;for(n=1;n<=i;n++)s[n]=_=_+a[n-1]<<1;for(r=0;r<=e;r++){var h=t[2*r+1];0!==h&&(t[2*r]=A(s[h]++,h))}},Z=function(t){var e;for(e=0;e<n;e++)t.dyn_ltree[2*e]=0;for(e=0;e<r;e++)t.dyn_dtree[2*e]=0;for(e=0;e<19;e++)t.bl_tree[2*e]=0;t.dyn_ltree[512]=1,t.opt_len=t.static_len=0,t.last_lit=t.matches=0},U=function(t){t.bi_valid>8?k(t,t.bi_buf):t.bi_valid>0&&(t.pending_buf[t.pending++]=t.bi_buf),t.bi_buf=0,t.bi_valid=0},S=function(t,e,a,n){var r=2*e,i=2*a;return t[r]<t[i]||t[r]===t[i]&&n[e]<=n[a]},R=function(t,e,a){for(var n=t.heap[a],r=a<<1;r<=t.heap_len&&(r<t.heap_len&&S(e,t.heap[r+1],t.heap[r],t.depth)&&r++,!S(e,n,t.heap[r],t.depth));)t.heap[a]=t.heap[r],a=r,r<<=1;t.heap[a]=n},L=function(t,e,n){var r,i,h,l,o=0;if(0!==t.last_lit)do{r=t.pending_buf[t.d_buf+2*o]<<8|t.pending_buf[t.d_buf+2*o+1],i=t.pending_buf[t.l_buf+o],o++,0===r?x(t,i,e):(h=f[i],x(t,h+a+1,e),0!==(l=s[h])&&(i-=c[h],z(t,i,l)),r--,h=y(r),x(t,h,n),0!==(l=_[h])&&(r-=v[h],z(t,r,l)))}while(o<t.last_lit);x(t,256,e)},F=function(t,e){var a,n,r,s=e.dyn_tree,_=e.stat_desc.static_tree,h=e.stat_desc.has_stree,l=e.stat_desc.elems,o=-1;for(t.heap_len=0,t.heap_max=573,a=0;a<l;a++)0!==s[2*a]?(t.heap[++t.heap_len]=o=a,t.depth[a]=0):s[2*a+1]=0;for(;t.heap_len<2;)s[2*(r=t.heap[++t.heap_len]=o<2?++o:0)]=1,t.depth[r]=0,t.opt_len--,h&&(t.static_len-=_[2*r+1]);for(e.max_code=o,a=t.heap_len>>1;a>=1;a--)R(t,s,a);r=l;do{a=t.heap[1],t.heap[1]=t.heap[t.heap_len--],R(t,s,1),n=t.heap[1],t.heap[--t.heap_max]=a,t.heap[--t.heap_max]=n,s[2*r]=s[2*a]+s[2*n],t.depth[r]=(t.depth[a]>=t.depth[n]?t.depth[a]:t.depth[n])+1,s[2*a+1]=s[2*n+1]=r,t.heap[1]=r++,R(t,s,1)}while(t.heap_len>=2);t.heap[--t.heap_max]=t.heap[1],function(t,e){var a,n,r,s,_,h,l=e.dyn_tree,o=e.max_code,d=e.stat_desc.static_tree,u=e.stat_desc.has_stree,f=e.stat_desc.extra_bits,c=e.stat_desc.extra_base,p=e.stat_desc.max_length,g=0;for(s=0;s<=i;s++)t.bl_count[s]=0;for(l[2*t.heap[t.heap_max]+1]=0,a=t.heap_max+1;a<573;a++)(s=l[2*l[2*(n=t.heap[a])+1]+1]+1)>p&&(s=p,g++),l[2*n+1]=s,n>o||(t.bl_count[s]++,_=0,n>=c&&(_=f[n-c]),h=l[2*n],t.opt_len+=h*(s+_),u&&(t.static_len+=h*(d[2*n+1]+_)));if(0!==g){do{for(s=p-1;0===t.bl_count[s];)s--;t.bl_count[s]--,t.bl_count[s+1]+=2,t.bl_count[p]--,g-=2}while(g>0);for(s=p;0!==s;s--)for(n=t.bl_count[s];0!==n;)(r=t.heap[--a])>o||(l[2*r+1]!==s&&(t.opt_len+=(s-l[2*r+1])*l[2*r],l[2*r+1]=s),n--)}}(t,e),E(s,o,t.bl_count)},T=function(t,e,a){var n,r,i=-1,s=e[1],_=0,h=7,l=4;for(0===s&&(h=138,l=3),e[2*(a+1)+1]=65535,n=0;n<=a;n++)r=s,s=e[2*(n+1)+1],++_<h&&r===s||(_<l?t.bl_tree[2*r]+=_:0!==r?(r!==i&&t.bl_tree[2*r]++,t.bl_tree[32]++):_<=10?t.bl_tree[34]++:t.bl_tree[36]++,_=0,i=r,0===s?(h=138,l=3):r===s?(h=6,l=3):(h=7,l=4))},I=function(t,e,a){var n,r,i=-1,s=e[1],_=0,h=7,l=4;for(0===s&&(h=138,l=3),n=0;n<=a;n++)if(r=s,s=e[2*(n+1)+1],!(++_<h&&r===s)){if(_<l)do{x(t,r,t.bl_tree)}while(0!=--_);else 0!==r?(r!==i&&(x(t,r,t.bl_tree),_--),x(t,16,t.bl_tree),z(t,_-3,2)):_<=10?(x(t,17,t.bl_tree),z(t,_-3,3)):(x(t,18,t.bl_tree),z(t,_-11,7));_=0,i=r,0===s?(h=138,l=3):r===s?(h=6,l=3):(h=7,l=4)}},N=!1,O=function(t,e,a,n){z(t,0+(n?1:0),3),function(t,e,a,n){U(t),n&&(k(t,a),k(t,~a)),t.pending_buf.set(t.window.subarray(e,e+a),t.pending),t.pending+=a}(t,e,a,!0)},D=function(t,e,n,r){var i,s,_=0;t.level>0?(2===t.strm.data_type&&(t.strm.data_type=function(t){var e,n=4093624447;for(e=0;e<=31;e++,n>>>=1)if(1&n&&0!==t.dyn_ltree[2*e])return 0;if(0!==t.dyn_ltree[18]||0!==t.dyn_ltree[20]||0!==t.dyn_ltree[26])return 1;for(e=32;e<a;e++)if(0!==t.dyn_ltree[2*e])return 1;return 0}(t)),F(t,t.l_desc),F(t,t.d_desc),_=function(t){var e;for(T(t,t.dyn_ltree,t.l_desc.max_code),T(t,t.dyn_dtree,t.d_desc.max_code),F(t,t.bl_desc),e=18;e>=3&&0===t.bl_tree[2*l[e]+1];e--);return t.opt_len+=3*(e+1)+5+5+4,e}(t),i=t.opt_len+3+7>>>3,(s=t.static_len+3+7>>>3)<=i&&(i=s)):i=s=n+5,n+4<=i&&-1!==e?O(t,e,n,r):4===t.strategy||s===i?(z(t,2+(r?1:0),3),L(t,o,d)):(z(t,4+(r?1:0),3),function(t,e,a,n){var r;for(z(t,e-257,5),z(t,a-1,5),z(t,n-4,4),r=0;r<n;r++)z(t,t.bl_tree[2*l[r]+1],3);I(t,t.dyn_ltree,e-1),I(t,t.dyn_dtree,a-1)}(t,t.l_desc.max_code+1,t.d_desc.max_code+1,_+1),L(t,t.dyn_ltree,t.dyn_dtree)),Z(t),r&&U(t)},B={_tr_init:function(t){N||(!function(){var t,e,a,l,m,y=new Array(16);for(a=0,l=0;l<28;l++)for(c[l]=a,t=0;t<1<<s[l];t++)f[a++]=l;for(f[a-1]=l,m=0,l=0;l<16;l++)for(v[l]=m,t=0;t<1<<_[l];t++)u[m++]=l;for(m>>=7;l<r;l++)for(v[l]=m<<7,t=0;t<1<<_[l]-7;t++)u[256+m++]=l;for(e=0;e<=i;e++)y[e]=0;for(t=0;t<=143;)o[2*t+1]=8,t++,y[8]++;for(;t<=255;)o[2*t+1]=9,t++,y[9]++;for(;t<=279;)o[2*t+1]=7,t++,y[7]++;for(;t<=287;)o[2*t+1]=8,t++,y[8]++;for(E(o,287,y),t=0;t<r;t++)d[2*t+1]=5,d[2*t]=A(t,5);p=new b(o,s,257,n,i),g=new b(d,_,0,r,i),w=new b(new Array(0),h,0,19,7)}(),N=!0),t.l_desc=new m(t.dyn_ltree,p),t.d_desc=new m(t.dyn_dtree,g),t.bl_desc=new m(t.bl_tree,w),t.bi_buf=0,t.bi_valid=0,Z(t)},_tr_stored_block:O,_tr_flush_block:D,_tr_tally:function(t,e,n){return t.pending_buf[t.d_buf+2*t.last_lit]=e>>>8&255,t.pending_buf[t.d_buf+2*t.last_lit+1]=255&e,t.pending_buf[t.l_buf+t.last_lit]=255&n,t.last_lit++,0===e?t.dyn_ltree[2*n]++:(t.matches++,e--,t.dyn_ltree[2*(f[n]+a+1)]++,t.dyn_dtree[2*y(e)]++),t.last_lit===t.lit_bufsize-1},_tr_align:function(t){z(t,2,3),x(t,256,o),function(t){16===t.bi_valid?(k(t,t.bi_buf),t.bi_buf=0,t.bi_valid=0):t.bi_valid>=8&&(t.pending_buf[t.pending++]=255&t.bi_buf,t.bi_buf>>=8,t.bi_valid-=8)}(t)}},C=function(t,e,a,n){for(var r=65535&t|0,i=t>>>16&65535|0,s=0;0!==a;){a-=s=a>2e3?2e3:a;do{i=i+(r=r+e[n++]|0)|0}while(--s);r%=65521,i%=65521}return r|i<<16|0},H=new Uint32Array(function(){for(var t,e=[],a=0;a<256;a++){t=a;for(var n=0;n<8;n++)t=1&t?3988292384^t>>>1:t>>>1;e[a]=t}return e}()),M=function(t,e,a,n){var r=H,i=n+a;t^=-1;for(var s=n;s<i;s++)t=t>>>8^r[255&(t^e[s])];return-1^t},Y={2:\"need dictionary\",1:\"stream end\",0:\"\",\"-1\":\"file error\",\"-2\":\"stream error\",\"-3\":\"data error\",\"-4\":\"insufficient memory\",\"-5\":\"buffer error\",\"-6\":\"incompatible version\"},K={Z_NO_FLUSH:0,Z_PARTIAL_FLUSH:1,Z_SYNC_FLUSH:2,Z_FULL_FLUSH:3,Z_FINISH:4,Z_BLOCK:5,Z_TREES:6,Z_OK:0,Z_STREAM_END:1,Z_NEED_DICT:2,Z_ERRNO:-1,Z_STREAM_ERROR:-2,Z_DATA_ERROR:-3,Z_MEM_ERROR:-4,Z_BUF_ERROR:-5,Z_NO_COMPRESSION:0,Z_BEST_SPEED:1,Z_BEST_COMPRESSION:9,Z_DEFAULT_COMPRESSION:-1,Z_FILTERED:1,Z_HUFFMAN_ONLY:2,Z_RLE:3,Z_FIXED:4,Z_DEFAULT_STRATEGY:0,Z_BINARY:0,Z_TEXT:1,Z_UNKNOWN:2,Z_DEFLATED:8},P=B._tr_init,j=B._tr_stored_block,G=B._tr_flush_block,X=B._tr_tally,W=B._tr_align,q=K.Z_NO_FLUSH,J=K.Z_PARTIAL_FLUSH,Q=K.Z_FULL_FLUSH,V=K.Z_FINISH,$=K.Z_BLOCK,tt=K.Z_OK,et=K.Z_STREAM_END,at=K.Z_STREAM_ERROR,nt=K.Z_DATA_ERROR,rt=K.Z_BUF_ERROR,it=K.Z_DEFAULT_COMPRESSION,st=K.Z_FILTERED,_t=K.Z_HUFFMAN_ONLY,ht=K.Z_RLE,lt=K.Z_FIXED,ot=K.Z_DEFAULT_STRATEGY,dt=K.Z_UNKNOWN,ut=K.Z_DEFLATED,ft=258,ct=262,pt=103,gt=113,wt=666,vt=function(t,e){return t.msg=Y[e],e},bt=function(t){return(t<<1)-(t>4?9:0)},mt=function(t){for(var e=t.length;--e>=0;)t[e]=0},yt=function(t,e,a){return(e<<t.hash_shift^a)&t.hash_mask},kt=function(t){var e=t.state,a=e.pending;a>t.avail_out&&(a=t.avail_out),0!==a&&(t.output.set(e.pending_buf.subarray(e.pending_out,e.pending_out+a),t.next_out),t.next_out+=a,e.pending_out+=a,t.total_out+=a,t.avail_out-=a,e.pending-=a,0===e.pending&&(e.pending_out=0))},zt=function(t,e){G(t,t.block_start>=0?t.block_start:-1,t.strstart-t.block_start,e),t.block_start=t.strstart,kt(t.strm)},xt=function(t,e){t.pending_buf[t.pending++]=e},At=function(t,e){t.pending_buf[t.pending++]=e>>>8&255,t.pending_buf[t.pending++]=255&e},Et=function(t,e){var a,n,r=t.max_chain_length,i=t.strstart,s=t.prev_length,_=t.nice_match,h=t.strstart>t.w_size-ct?t.strstart-(t.w_size-ct):0,l=t.window,o=t.w_mask,d=t.prev,u=t.strstart+ft,f=l[i+s-1],c=l[i+s];t.prev_length>=t.good_match&&(r>>=2),_>t.lookahead&&(_=t.lookahead);do{if(l[(a=e)+s]===c&&l[a+s-1]===f&&l[a]===l[i]&&l[++a]===l[i+1]){i+=2,a++;do{}while(l[++i]===l[++a]&&l[++i]===l[++a]&&l[++i]===l[++a]&&l[++i]===l[++a]&&l[++i]===l[++a]&&l[++i]===l[++a]&&l[++i]===l[++a]&&l[++i]===l[++a]&&i<u);if(n=ft-(u-i),i=u-ft,n>s){if(t.match_start=e,s=n,n>=_)break;f=l[i+s-1],c=l[i+s]}}}while((e=d[e&o])>h&&0!=--r);return s<=t.lookahead?s:t.lookahead},Zt=function(t){var e,a,n,r,i,s,_,h,l,o,d=t.w_size;do{if(r=t.window_size-t.lookahead-t.strstart,t.strstart>=d+(d-ct)){t.window.set(t.window.subarray(d,d+d),0),t.match_start-=d,t.strstart-=d,t.block_start-=d,e=a=t.hash_size;do{n=t.head[--e],t.head[e]=n>=d?n-d:0}while(--a);e=a=d;do{n=t.prev[--e],t.prev[e]=n>=d?n-d:0}while(--a);r+=d}if(0===t.strm.avail_in)break;if(s=t.strm,_=t.window,h=t.strstart+t.lookahead,l=r,o=void 0,(o=s.avail_in)>l&&(o=l),a=0===o?0:(s.avail_in-=o,_.set(s.input.subarray(s.next_in,s.next_in+o),h),1===s.state.wrap?s.adler=C(s.adler,_,o,h):2===s.state.wrap&&(s.adler=M(s.adler,_,o,h)),s.next_in+=o,s.total_in+=o,o),t.lookahead+=a,t.lookahead+t.insert>=3)for(i=t.strstart-t.insert,t.ins_h=t.window[i],t.ins_h=yt(t,t.ins_h,t.window[i+1]);t.insert&&(t.ins_h=yt(t,t.ins_h,t.window[i+3-1]),t.prev[i&t.w_mask]=t.head[t.ins_h],t.head[t.ins_h]=i,i++,t.insert--,!(t.lookahead+t.insert<3)););}while(t.lookahead<ct&&0!==t.strm.avail_in)},Ut=function(t,e){for(var a,n;;){if(t.lookahead<ct){if(Zt(t),t.lookahead<ct&&e===q)return 1;if(0===t.lookahead)break}if(a=0,t.lookahead>=3&&(t.ins_h=yt(t,t.ins_h,t.window[t.strstart+3-1]),a=t.prev[t.strstart&t.w_mask]=t.head[t.ins_h],t.head[t.ins_h]=t.strstart),0!==a&&t.strstart-a<=t.w_size-ct&&(t.match_length=Et(t,a)),t.match_length>=3)if(n=X(t,t.strstart-t.match_start,t.match_length-3),t.lookahead-=t.match_length,t.match_length<=t.max_lazy_match&&t.lookahead>=3){t.match_length--;do{t.strstart++,t.ins_h=yt(t,t.ins_h,t.window[t.strstart+3-1]),a=t.prev[t.strstart&t.w_mask]=t.head[t.ins_h],t.head[t.ins_h]=t.strstart}while(0!=--t.match_length);t.strstart++}else t.strstart+=t.match_length,t.match_length=0,t.ins_h=t.window[t.strstart],t.ins_h=yt(t,t.ins_h,t.window[t.strstart+1]);else n=X(t,0,t.window[t.strstart]),t.lookahead--,t.strstart++;if(n&&(zt(t,!1),0===t.strm.avail_out))return 1}return t.insert=t.strstart<2?t.strstart:2,e===V?(zt(t,!0),0===t.strm.avail_out?3:4):t.last_lit&&(zt(t,!1),0===t.strm.avail_out)?1:2},St=function(t,e){for(var a,n,r;;){if(t.lookahead<ct){if(Zt(t),t.lookahead<ct&&e===q)return 1;if(0===t.lookahead)break}if(a=0,t.lookahead>=3&&(t.ins_h=yt(t,t.ins_h,t.window[t.strstart+3-1]),a=t.prev[t.strstart&t.w_mask]=t.head[t.ins_h],t.head[t.ins_h]=t.strstart),t.prev_length=t.match_length,t.prev_match=t.match_start,t.match_length=2,0!==a&&t.prev_length<t.max_lazy_match&&t.strstart-a<=t.w_size-ct&&(t.match_length=Et(t,a),t.match_length<=5&&(t.strategy===st||3===t.match_length&&t.strstart-t.match_start>4096)&&(t.match_length=2)),t.prev_length>=3&&t.match_length<=t.prev_length){r=t.strstart+t.lookahead-3,n=X(t,t.strstart-1-t.prev_match,t.prev_length-3),t.lookahead-=t.prev_length-1,t.prev_length-=2;do{++t.strstart<=r&&(t.ins_h=yt(t,t.ins_h,t.window[t.strstart+3-1]),a=t.prev[t.strstart&t.w_mask]=t.head[t.ins_h],t.head[t.ins_h]=t.strstart)}while(0!=--t.prev_length);if(t.match_available=0,t.match_length=2,t.strstart++,n&&(zt(t,!1),0===t.strm.avail_out))return 1}else if(t.match_available){if((n=X(t,0,t.window[t.strstart-1]))&&zt(t,!1),t.strstart++,t.lookahead--,0===t.strm.avail_out)return 1}else t.match_available=1,t.strstart++,t.lookahead--}return t.match_available&&(n=X(t,0,t.window[t.strstart-1]),t.match_available=0),t.insert=t.strstart<2?t.strstart:2,e===V?(zt(t,!0),0===t.strm.avail_out?3:4):t.last_lit&&(zt(t,!1),0===t.strm.avail_out)?1:2};function Rt(t,e,a,n,r){this.good_length=t,this.max_lazy=e,this.nice_length=a,this.max_chain=n,this.func=r}var Lt=[new Rt(0,0,0,0,(function(t,e){var a=65535;for(a>t.pending_buf_size-5&&(a=t.pending_buf_size-5);;){if(t.lookahead<=1){if(Zt(t),0===t.lookahead&&e===q)return 1;if(0===t.lookahead)break}t.strstart+=t.lookahead,t.lookahead=0;var n=t.block_start+a;if((0===t.strstart||t.strstart>=n)&&(t.lookahead=t.strstart-n,t.strstart=n,zt(t,!1),0===t.strm.avail_out))return 1;if(t.strstart-t.block_start>=t.w_size-ct&&(zt(t,!1),0===t.strm.avail_out))return 1}return t.insert=0,e===V?(zt(t,!0),0===t.strm.avail_out?3:4):(t.strstart>t.block_start&&(zt(t,!1),t.strm.avail_out),1)})),new Rt(4,4,8,4,Ut),new Rt(4,5,16,8,Ut),new Rt(4,6,32,32,Ut),new Rt(4,4,16,16,St),new Rt(8,16,32,32,St),new Rt(8,16,128,128,St),new Rt(8,32,128,256,St),new Rt(32,128,258,1024,St),new Rt(32,258,258,4096,St)];function Ft(){this.strm=null,this.status=0,this.pending_buf=null,this.pending_buf_size=0,this.pending_out=0,this.pending=0,this.wrap=0,this.gzhead=null,this.gzindex=0,this.method=ut,this.last_flush=-1,this.w_size=0,this.w_bits=0,this.w_mask=0,this.window=null,this.window_size=0,this.prev=null,this.head=null,this.ins_h=0,this.hash_size=0,this.hash_bits=0,this.hash_mask=0,this.hash_shift=0,this.block_start=0,this.match_length=0,this.prev_match=0,this.match_available=0,this.strstart=0,this.match_start=0,this.lookahead=0,this.prev_length=0,this.max_chain_length=0,this.max_lazy_match=0,this.level=0,this.strategy=0,this.good_match=0,this.nice_match=0,this.dyn_ltree=new Uint16Array(1146),this.dyn_dtree=new Uint16Array(122),this.bl_tree=new Uint16Array(78),mt(this.dyn_ltree),mt(this.dyn_dtree),mt(this.bl_tree),this.l_desc=null,this.d_desc=null,this.bl_desc=null,this.bl_count=new Uint16Array(16),this.heap=new Uint16Array(573),mt(this.heap),this.heap_len=0,this.heap_max=0,this.depth=new Uint16Array(573),mt(this.depth),this.l_buf=0,this.lit_bufsize=0,this.last_lit=0,this.d_buf=0,this.opt_len=0,this.static_len=0,this.matches=0,this.insert=0,this.bi_buf=0,this.bi_valid=0}var Tt=function(t){if(!t||!t.state)return vt(t,at);t.total_in=t.total_out=0,t.data_type=dt;var e=t.state;return e.pending=0,e.pending_out=0,e.wrap<0&&(e.wrap=-e.wrap),e.status=e.wrap?42:gt,t.adler=2===e.wrap?0:1,e.last_flush=q,P(e),tt},It=function(t){var e,a=Tt(t);return a===tt&&((e=t.state).window_size=2*e.w_size,mt(e.head),e.max_lazy_match=Lt[e.level].max_lazy,e.good_match=Lt[e.level].good_length,e.nice_match=Lt[e.level].nice_length,e.max_chain_length=Lt[e.level].max_chain,e.strstart=0,e.block_start=0,e.lookahead=0,e.insert=0,e.match_length=e.prev_length=2,e.match_available=0,e.ins_h=0),a},Nt=function(t,e,a,n,r,i){if(!t)return at;var s=1;if(e===it&&(e=6),n<0?(s=0,n=-n):n>15&&(s=2,n-=16),r<1||r>9||a!==ut||n<8||n>15||e<0||e>9||i<0||i>lt)return vt(t,at);8===n&&(n=9);var _=new Ft;return t.state=_,_.strm=t,_.wrap=s,_.gzhead=null,_.w_bits=n,_.w_size=1<<_.w_bits,_.w_mask=_.w_size-1,_.hash_bits=r+7,_.hash_size=1<<_.hash_bits,_.hash_mask=_.hash_size-1,_.hash_shift=~~((_.hash_bits+3-1)/3),_.window=new Uint8Array(2*_.w_size),_.head=new Uint16Array(_.hash_size),_.prev=new Uint16Array(_.w_size),_.lit_bufsize=1<<r+6,_.pending_buf_size=4*_.lit_bufsize,_.pending_buf=new Uint8Array(_.pending_buf_size),_.d_buf=1*_.lit_bufsize,_.l_buf=3*_.lit_bufsize,_.level=e,_.strategy=i,_.method=a,It(t)},Ot={deflateInit:function(t,e){return Nt(t,e,ut,15,8,ot)},deflateInit2:Nt,deflateReset:It,deflateResetKeep:Tt,deflateSetHeader:function(t,e){return t&&t.state?2!==t.state.wrap?at:(t.state.gzhead=e,tt):at},deflate:function(t,e){var a,n;if(!t||!t.state||e>$||e<0)return t?vt(t,at):at;var r=t.state;if(!t.output||!t.input&&0!==t.avail_in||r.status===wt&&e!==V)return vt(t,0===t.avail_out?rt:at);r.strm=t;var i=r.last_flush;if(r.last_flush=e,42===r.status)if(2===r.wrap)t.adler=0,xt(r,31),xt(r,139),xt(r,8),r.gzhead?(xt(r,(r.gzhead.text?1:0)+(r.gzhead.hcrc?2:0)+(r.gzhead.extra?4:0)+(r.gzhead.name?8:0)+(r.gzhead.comment?16:0)),xt(r,255&r.gzhead.time),xt(r,r.gzhead.time>>8&255),xt(r,r.gzhead.time>>16&255),xt(r,r.gzhead.time>>24&255),xt(r,9===r.level?2:r.strategy>=_t||r.level<2?4:0),xt(r,255&r.gzhead.os),r.gzhead.extra&&r.gzhead.extra.length&&(xt(r,255&r.gzhead.extra.length),xt(r,r.gzhead.extra.length>>8&255)),r.gzhead.hcrc&&(t.adler=M(t.adler,r.pending_buf,r.pending,0)),r.gzindex=0,r.status=69):(xt(r,0),xt(r,0),xt(r,0),xt(r,0),xt(r,0),xt(r,9===r.level?2:r.strategy>=_t||r.level<2?4:0),xt(r,3),r.status=gt);else{var s=ut+(r.w_bits-8<<4)<<8;s|=(r.strategy>=_t||r.level<2?0:r.level<6?1:6===r.level?2:3)<<6,0!==r.strstart&&(s|=32),s+=31-s%31,r.status=gt,At(r,s),0!==r.strstart&&(At(r,t.adler>>>16),At(r,65535&t.adler)),t.adler=1}if(69===r.status)if(r.gzhead.extra){for(a=r.pending;r.gzindex<(65535&r.gzhead.extra.length)&&(r.pending!==r.pending_buf_size||(r.gzhead.hcrc&&r.pending>a&&(t.adler=M(t.adler,r.pending_buf,r.pending-a,a)),kt(t),a=r.pending,r.pending!==r.pending_buf_size));)xt(r,255&r.gzhead.extra[r.gzindex]),r.gzindex++;r.gzhead.hcrc&&r.pending>a&&(t.adler=M(t.adler,r.pending_buf,r.pending-a,a)),r.gzindex===r.gzhead.extra.length&&(r.gzindex=0,r.status=73)}else r.status=73;if(73===r.status)if(r.gzhead.name){a=r.pending;do{if(r.pending===r.pending_buf_size&&(r.gzhead.hcrc&&r.pending>a&&(t.adler=M(t.adler,r.pending_buf,r.pending-a,a)),kt(t),a=r.pending,r.pending===r.pending_buf_size)){n=1;break}n=r.gzindex<r.gzhead.name.length?255&r.gzhead.name.charCodeAt(r.gzindex++):0,xt(r,n)}while(0!==n);r.gzhead.hcrc&&r.pending>a&&(t.adler=M(t.adler,r.pending_buf,r.pending-a,a)),0===n&&(r.gzindex=0,r.status=91)}else r.status=91;if(91===r.status)if(r.gzhead.comment){a=r.pending;do{if(r.pending===r.pending_buf_size&&(r.gzhead.hcrc&&r.pending>a&&(t.adler=M(t.adler,r.pending_buf,r.pending-a,a)),kt(t),a=r.pending,r.pending===r.pending_buf_size)){n=1;break}n=r.gzindex<r.gzhead.comment.length?255&r.gzhead.comment.charCodeAt(r.gzindex++):0,xt(r,n)}while(0!==n);r.gzhead.hcrc&&r.pending>a&&(t.adler=M(t.adler,r.pending_buf,r.pending-a,a)),0===n&&(r.status=pt)}else r.status=pt;if(r.status===pt&&(r.gzhead.hcrc?(r.pending+2>r.pending_buf_size&&kt(t),r.pending+2<=r.pending_buf_size&&(xt(r,255&t.adler),xt(r,t.adler>>8&255),t.adler=0,r.status=gt)):r.status=gt),0!==r.pending){if(kt(t),0===t.avail_out)return r.last_flush=-1,tt}else if(0===t.avail_in&&bt(e)<=bt(i)&&e!==V)return vt(t,rt);if(r.status===wt&&0!==t.avail_in)return vt(t,rt);if(0!==t.avail_in||0!==r.lookahead||e!==q&&r.status!==wt){var _=r.strategy===_t?function(t,e){for(var a;;){if(0===t.lookahead&&(Zt(t),0===t.lookahead)){if(e===q)return 1;break}if(t.match_length=0,a=X(t,0,t.window[t.strstart]),t.lookahead--,t.strstart++,a&&(zt(t,!1),0===t.strm.avail_out))return 1}return t.insert=0,e===V?(zt(t,!0),0===t.strm.avail_out?3:4):t.last_lit&&(zt(t,!1),0===t.strm.avail_out)?1:2}(r,e):r.strategy===ht?function(t,e){for(var a,n,r,i,s=t.window;;){if(t.lookahead<=ft){if(Zt(t),t.lookahead<=ft&&e===q)return 1;if(0===t.lookahead)break}if(t.match_length=0,t.lookahead>=3&&t.strstart>0&&(n=s[r=t.strstart-1])===s[++r]&&n===s[++r]&&n===s[++r]){i=t.strstart+ft;do{}while(n===s[++r]&&n===s[++r]&&n===s[++r]&&n===s[++r]&&n===s[++r]&&n===s[++r]&&n===s[++r]&&n===s[++r]&&r<i);t.match_length=ft-(i-r),t.match_length>t.lookahead&&(t.match_length=t.lookahead)}if(t.match_length>=3?(a=X(t,1,t.match_length-3),t.lookahead-=t.match_length,t.strstart+=t.match_length,t.match_length=0):(a=X(t,0,t.window[t.strstart]),t.lookahead--,t.strstart++),a&&(zt(t,!1),0===t.strm.avail_out))return 1}return t.insert=0,e===V?(zt(t,!0),0===t.strm.avail_out?3:4):t.last_lit&&(zt(t,!1),0===t.strm.avail_out)?1:2}(r,e):Lt[r.level].func(r,e);if(3!==_&&4!==_||(r.status=wt),1===_||3===_)return 0===t.avail_out&&(r.last_flush=-1),tt;if(2===_&&(e===J?W(r):e!==$&&(j(r,0,0,!1),e===Q&&(mt(r.head),0===r.lookahead&&(r.strstart=0,r.block_start=0,r.insert=0))),kt(t),0===t.avail_out))return r.last_flush=-1,tt}return e!==V?tt:r.wrap<=0?et:(2===r.wrap?(xt(r,255&t.adler),xt(r,t.adler>>8&255),xt(r,t.adler>>16&255),xt(r,t.adler>>24&255),xt(r,255&t.total_in),xt(r,t.total_in>>8&255),xt(r,t.total_in>>16&255),xt(r,t.total_in>>24&255)):(At(r,t.adler>>>16),At(r,65535&t.adler)),kt(t),r.wrap>0&&(r.wrap=-r.wrap),0!==r.pending?tt:et)},deflateEnd:function(t){if(!t||!t.state)return at;var e=t.state.status;return 42!==e&&69!==e&&73!==e&&91!==e&&e!==pt&&e!==gt&&e!==wt?vt(t,at):(t.state=null,e===gt?vt(t,nt):tt)},deflateSetDictionary:function(t,e){var a=e.length;if(!t||!t.state)return at;var n=t.state,r=n.wrap;if(2===r||1===r&&42!==n.status||n.lookahead)return at;if(1===r&&(t.adler=C(t.adler,e,a,0)),n.wrap=0,a>=n.w_size){0===r&&(mt(n.head),n.strstart=0,n.block_start=0,n.insert=0);var i=new Uint8Array(n.w_size);i.set(e.subarray(a-n.w_size,a),0),e=i,a=n.w_size}var s=t.avail_in,_=t.next_in,h=t.input;for(t.avail_in=a,t.next_in=0,t.input=e,Zt(n);n.lookahead>=3;){var l=n.strstart,o=n.lookahead-2;do{n.ins_h=yt(n,n.ins_h,n.window[l+3-1]),n.prev[l&n.w_mask]=n.head[n.ins_h],n.head[n.ins_h]=l,l++}while(--o);n.strstart=l,n.lookahead=2,Zt(n)}return n.strstart+=n.lookahead,n.block_start=n.strstart,n.insert=n.lookahead,n.lookahead=0,n.match_length=n.prev_length=2,n.match_available=0,t.next_in=_,t.input=h,t.avail_in=s,n.wrap=r,tt},deflateInfo:\"pako deflate (from Nodeca project)\"};for(var Dt=new Uint8Array(256),Bt=0;Bt<256;Bt++)Dt[Bt]=Bt>=252?6:Bt>=248?5:Bt>=240?4:Bt>=224?3:Bt>=192?2:1;Dt[254]=Dt[254]=1;var Ct=function(){this.input=null,this.next_in=0,this.avail_in=0,this.total_in=0,this.output=null,this.next_out=0,this.avail_out=0,this.total_out=0,this.msg=\"\",this.state=null,this.data_type=2,this.adler=0},Ht=Object.prototype.toString,Mt=K.Z_NO_FLUSH,Yt=K.Z_SYNC_FLUSH,Kt=K.Z_FULL_FLUSH,Pt=K.Z_FINISH,jt=K.Z_OK,Gt=K.Z_STREAM_END,Xt=K.Z_DEFAULT_COMPRESSION,Wt=K.Z_DEFAULT_STRATEGY,qt=K.Z_DEFLATED;function Jt(){this.options={level:Xt,method:qt,chunkSize:16384,windowBits:15,memLevel:8,strategy:Wt};var t=this.options;t.raw&&t.windowBits>0?t.windowBits=-t.windowBits:t.gzip&&t.windowBits>0&&t.windowBits<16&&(t.windowBits+=16),this.err=0,this.msg=\"\",this.ended=!1,this.chunks=[],this.strm=new Ct,this.strm.avail_out=0;var e=Ot.deflateInit2(this.strm,t.level,t.method,t.windowBits,t.memLevel,t.strategy);if(e!==jt)throw new Error(Y[e]);if(t.header&&Ot.deflateSetHeader(this.strm,t.header),t.dictionary){var a;if(a=\"[object ArrayBuffer]\"===Ht.call(t.dictionary)?new Uint8Array(t.dictionary):t.dictionary,(e=Ot.deflateSetDictionary(this.strm,a))!==jt)throw new Error(Y[e]);this._dict_set=!0}}function Qt(t,e,a){try{t.postMessage({type:\"errored\",error:e,streamId:a})}catch(n){t.postMessage({type:\"errored\",error:String(e),streamId:a})}}function Vt(t){var e=t.strm.adler;return new Uint8Array([3,0,e>>>24&255,e>>>16&255,e>>>8&255,255&e])}Jt.prototype.push=function(t,e){var a,n,r=this.strm,i=this.options.chunkSize;if(this.ended)return!1;for(n=e===~~e?e:!0===e?Pt:Mt,\"[object ArrayBuffer]\"===Ht.call(t)?r.input=new Uint8Array(t):r.input=t,r.next_in=0,r.avail_in=r.input.length;;)if(0===r.avail_out&&(r.output=new Uint8Array(i),r.next_out=0,r.avail_out=i),(n===Yt||n===Kt)&&r.avail_out<=6)this.onData(r.output.subarray(0,r.next_out)),r.avail_out=0;else{if((a=Ot.deflate(r,n))===Gt)return r.next_out>0&&this.onData(r.output.subarray(0,r.next_out)),a=Ot.deflateEnd(this.strm),this.onEnd(a),this.ended=!0,a===jt;if(0!==r.avail_out){if(n>0&&r.next_out>0)this.onData(r.output.subarray(0,r.next_out)),r.avail_out=0;else if(0===r.avail_in)break}else this.onData(r.output)}return!0},Jt.prototype.onData=function(t){this.chunks.push(t)},Jt.prototype.onEnd=function(t){t===jt&&(this.result=function(t){for(var e=0,a=0,n=t.length;a<n;a++)e+=t[a].length;for(var r=new Uint8Array(e),i=0,s=0,_=t.length;i<_;i++){var h=t[i];r.set(h,s),s+=h.length}return r}(this.chunks)),this.chunks=[],this.err=t,this.msg=this.strm.msg},function(e){void 0===e&&(e=self);try{var a=new Map;e.addEventListener(\"message\",(function(n){try{var r=function(e,a){switch(a.action){case\"init\":return{type:\"initialized\",version:\"5.23.0\"};case\"write\":var n=e.get(a.streamId);n||(n=new Jt,e.set(a.streamId,n));var r=n.chunks.length,i=function(t){if(\"function\"==typeof TextEncoder&&TextEncoder.prototype.encode)return(new TextEncoder).encode(t);var e,a,n,r,i,s=t.length,_=0;for(r=0;r<s;r++)55296==(64512&(a=t.charCodeAt(r)))&&r+1<s&&56320==(64512&(n=t.charCodeAt(r+1)))&&(a=65536+(a-55296<<10)+(n-56320),r++),_+=a<128?1:a<2048?2:a<65536?3:4;for(e=new Uint8Array(_),i=0,r=0;i<_;r++)55296==(64512&(a=t.charCodeAt(r)))&&r+1<s&&56320==(64512&(n=t.charCodeAt(r+1)))&&(a=65536+(a-55296<<10)+(n-56320),r++),a<128?e[i++]=a:a<2048?(e[i++]=192|a>>>6,e[i++]=128|63&a):a<65536?(e[i++]=224|a>>>12,e[i++]=128|a>>>6&63,e[i++]=128|63&a):(e[i++]=240|a>>>18,e[i++]=128|a>>>12&63,e[i++]=128|a>>>6&63,e[i++]=128|63&a);return e}(a.data);return n.push(i,K.Z_SYNC_FLUSH),{type:\"wrote\",id:a.id,streamId:a.streamId,result:t(n.chunks.slice(r)),trailer:Vt(n),additionalBytesCount:i.length};case\"reset\":e.delete(a.streamId)}}(a,n.data);r&&e.postMessage(r)}catch(t){Qt(e,t,n.data&&\"streamId\"in n.data?n.data.streamId:void 0)}}))}catch(t){Qt(e,t)}}()}();"])));
}
var state = {
  status: 0 /* DeflateWorkerStatus.Nil */
};
function startDeflateWorker(configuration, source, onInitializationFailure, createDeflateWorkerImpl) {
  if (createDeflateWorkerImpl === void 0) {
    createDeflateWorkerImpl = createDeflateWorker;
  }
  if (state.status === 0 /* DeflateWorkerStatus.Nil */) {
    // doStartDeflateWorker updates the state to "loading" or "error"
    doStartDeflateWorker(configuration, source, createDeflateWorkerImpl);
  }
  switch (state.status) {
    case 1 /* DeflateWorkerStatus.Loading */:
      state.initializationFailureCallbacks.push(onInitializationFailure);
      return state.worker;
    case 3 /* DeflateWorkerStatus.Initialized */:
      return state.worker;
  }
}
function getDeflateWorkerStatus() {
  return state.status;
}
/**
 * Starts the deflate worker and handle messages and errors
 *
 * The spec allow browsers to handle worker errors differently:
 * - Chromium throws an exception
 * - Firefox fires an error event
 *
 * more details: https://bugzilla.mozilla.org/show_bug.cgi?id=1736865#c2
 */
function doStartDeflateWorker(configuration, source, createDeflateWorkerImpl) {
  if (createDeflateWorkerImpl === void 0) {
    createDeflateWorkerImpl = createDeflateWorker;
  }
  try {
    var worker = createDeflateWorkerImpl(configuration);
    var removeErrorListener_1 = addEventListener(configuration, worker, 'error', function (error) {
      onError(configuration, source, error);
    }).stop;
    var removeMessageListener_1 = addEventListener(configuration, worker, 'message', function (_a) {
      var data = _a.data;
      if (data.type === 'errored') {
        onError(configuration, source, data.error, data.streamId);
      } else if (data.type === 'initialized') {
        onInitialized(data.version);
      }
    }).stop;
    worker.postMessage({
      action: 'init'
    });
    setTimeout$1(function () {
      return onTimeout(source);
    }, INITIALIZATION_TIME_OUT_DELAY);
    var stop_1 = function () {
      removeErrorListener_1();
      removeMessageListener_1();
    };
    state = {
      status: 1 /* DeflateWorkerStatus.Loading */,
      worker: worker,
      stop: stop_1,
      initializationFailureCallbacks: []
    };
  } catch (error) {
    onError(configuration, source, error);
  }
}
function onTimeout(source) {
  if (state.status === 1 /* DeflateWorkerStatus.Loading */) {
    display.error("".concat(source, " failed to start: a timeout occurred while initializing the Worker"));
    state.initializationFailureCallbacks.forEach(function (callback) {
      return callback();
    });
    state = {
      status: 2 /* DeflateWorkerStatus.Error */
    };
  }
}
function onInitialized(version) {
  if (state.status === 1 /* DeflateWorkerStatus.Loading */) {
    state = {
      status: 3 /* DeflateWorkerStatus.Initialized */,
      worker: state.worker,
      stop: state.stop,
      version: version
    };
  }
}
function onError(configuration, source, error, streamId) {
  if (state.status === 1 /* DeflateWorkerStatus.Loading */ || state.status === 0 /* DeflateWorkerStatus.Nil */) {
    display.error("".concat(source, " failed to start: an error occurred while creating the Worker:"), error);
    if (error instanceof Event || error instanceof Error && isMessageCspRelated(error.message)) {
      var baseMessage = void 0;
      if (configuration.workerUrl) {
        baseMessage = "Please make sure the Worker URL ".concat(configuration.workerUrl, " is correct and CSP is correctly configured.");
      } else {
        baseMessage = 'Please make sure CSP is correctly configured.';
      }
      display.error("".concat(baseMessage, " See documentation at ").concat(DOCS_ORIGIN, "/integrations/content_security_policy_logs/#use-csp-with-real-user-monitoring-and-session-replay"));
    } else {
      addTelemetryError(error);
    }
    if (state.status === 1 /* DeflateWorkerStatus.Loading */) {
      state.initializationFailureCallbacks.forEach(function (callback) {
        return callback();
      });
    }
    state = {
      status: 2 /* DeflateWorkerStatus.Error */
    };
  } else {
    addTelemetryError(error, {
      worker_version: state.status === 3 /* DeflateWorkerStatus.Initialized */ && state.version,
      stream_id: streamId
    });
  }
}
function isMessageCspRelated(message) {
  return includes(message, 'Content Security Policy') ||
  // Related to `require-trusted-types-for` CSP: https://developer.mozilla.org/en-US/docs/Web/HTTP/Headers/Content-Security-Policy/require-trusted-types-for
  includes(message, "requires 'TrustedScriptURL'");
}

function makeRecorderApi(startRecordingImpl, createDeflateWorkerImpl) {
  if (canUseEventBridge() && !bridgeSupports("records" /* BridgeCapability.RECORDS */) || !isBrowserSupported()) {
    return {
      start: noop$1,
      stop: noop$1,
      getReplayStats: function () {
        return undefined;
      },
      onRumStart: noop$1,
      isRecording: function () {
        return false;
      },
      getSessionReplayLink: function () {
        return undefined;
      }
    };
  }
  var state = {
    status: 1 /* RecorderStatus.IntentToStart */
  };
  var startStrategy = function () {
    state = {
      status: 1 /* RecorderStatus.IntentToStart */
    };
  };
  var stopStrategy = function () {
    state = {
      status: 0 /* RecorderStatus.Stopped */
    };
  };
  var getSessionReplayLinkStrategy = noop$1;
  return {
    start: function (options) {
      return startStrategy(options);
    },
    stop: function () {
      return stopStrategy();
    },
    getSessionReplayLink: function () {
      return getSessionReplayLinkStrategy();
    },
    onRumStart: function (lifeCycle, configuration, sessionManager, viewContexts, worker) {
      if (configuration.startSessionReplayRecordingManually) {
        state = {
          status: 0 /* RecorderStatus.Stopped */
        };
      }
      lifeCycle.subscribe(9 /* LifeCycleEventType.SESSION_EXPIRED */, function () {
        if (state.status === 2 /* RecorderStatus.Starting */ || state.status === 3 /* RecorderStatus.Started */) {
          stopStrategy();
          state = {
            status: 1 /* RecorderStatus.IntentToStart */
          };
        }
      });
      // Stop the recorder on page unload to avoid sending records after the page is ended.
      lifeCycle.subscribe(11 /* LifeCycleEventType.PAGE_EXITED */, function (pageExitEvent) {
        if (pageExitEvent.reason === PageExitReason.UNLOADING) {
          stopStrategy();
        }
      });
      lifeCycle.subscribe(10 /* LifeCycleEventType.SESSION_RENEWED */, function () {
        if (state.status === 1 /* RecorderStatus.IntentToStart */) {
          startStrategy();
        }
      });
      var cachedDeflateEncoder;
      function getOrCreateDeflateEncoder() {
        if (!cachedDeflateEncoder) {
          if (!worker) {
            worker = startDeflateWorker(configuration, 'Datadog Session Replay', function () {
              stopStrategy();
            }, createDeflateWorkerImpl);
          }
          if (worker) {
            cachedDeflateEncoder = createDeflateEncoder(configuration, worker, 1 /* DeflateEncoderStreamId.REPLAY */);
          }
        }
        return cachedDeflateEncoder;
      }
      startStrategy = function (options) {
        var session = sessionManager.findTrackedSession();
        if (!session || session.sessionReplay === 0 /* SessionReplayState.OFF */ && !(options === null || options === void 0 ? void 0 : options.force)) {
          state = {
            status: 1 /* RecorderStatus.IntentToStart */
          };
          return;
        }
        if (state.status === 2 /* RecorderStatus.Starting */ || state.status === 3 /* RecorderStatus.Started */) {
          return;
        }
        state = {
          status: 2 /* RecorderStatus.Starting */
        };
        runOnReadyState(configuration, 'interactive', function () {
          if (state.status !== 2 /* RecorderStatus.Starting */) {
            return;
          }
          var deflateEncoder = getOrCreateDeflateEncoder();
          if (!deflateEncoder) {
            state = {
              status: 0 /* RecorderStatus.Stopped */
            };
            return;
          }
          var stopRecording = startRecordingImpl(lifeCycle, configuration, sessionManager, viewContexts, deflateEncoder).stop;
          state = {
            status: 3 /* RecorderStatus.Started */,
            stopRecording: stopRecording
          };
        });
        if ((options === null || options === void 0 ? void 0 : options.force) && session.sessionReplay === 0 /* SessionReplayState.OFF */) {
          sessionManager.setForcedReplay();
        }
      };
      stopStrategy = function () {
        if (state.status === 0 /* RecorderStatus.Stopped */) {
          return;
        }
        if (state.status === 3 /* RecorderStatus.Started */) {
          state.stopRecording();
        }
        state = {
          status: 0 /* RecorderStatus.Stopped */
        };
      };
      getSessionReplayLinkStrategy = function () {
        return getSessionReplayLink(configuration, sessionManager, viewContexts, state.status !== 0 /* RecorderStatus.Stopped */);
      };
      if (state.status === 1 /* RecorderStatus.IntentToStart */) {
        startStrategy();
      }
    },
    isRecording: function () {
      // The worker is started optimistically, meaning we could have started to record but its
      // initialization fails a bit later. This could happen when:
      // * the worker URL (blob or plain URL) is blocked by CSP in Firefox only (Chromium and Safari
      // throw an exception when instantiating the worker, and IE doesn't care about CSP)
      // * the browser fails to load the worker in case the workerUrl is used
      // * an unexpected error occurs in the Worker before initialization, ex:
      //   * a runtime exception collected by monitor()
      //   * a syntax error notified by the browser via an error event
      // * the worker is unresponsive for some reason and timeouts
      //
      // It is not expected to happen often. Nonetheless, the "replayable" status on RUM events is
      // an important part of the Datadog App:
      // * If we have a false positive (we set has_replay: true even if no replay data is present),
      // we might display broken links to the Session Replay player.
      // * If we have a false negative (we don't set has_replay: true even if replay data is
      // available), it is less noticeable because no link will be displayed.
      //
      // Thus, it is better to have false negative, so let's make sure the worker is correctly
      // initialized before advertizing that we are recording.
      //
      // In the future, when the compression worker will also be used for RUM data, this will be
      // less important since no RUM event will be sent when the worker fails to initialize.
      return getDeflateWorkerStatus() === 3 /* DeflateWorkerStatus.Initialized */ && state.status === 3 /* RecorderStatus.Started */;
    },
    getReplayStats: function (viewId) {
      return getDeflateWorkerStatus() === 3 /* DeflateWorkerStatus.Initialized */ ? getReplayStats(viewId) : undefined;
    }
  };
}

// Keep the following in sync with packages/rum-slim/src/entries/main.ts
var recorderApi = makeRecorderApi(startRecording);
var datadogRum = makeRumPublicApi(startRum, recorderApi, {
  startDeflateWorker: startDeflateWorker,
  createDeflateEncoder: createDeflateEncoder
});
defineGlobal(getGlobalObject(), 'DD_RUM', datadogRum);

/**
 * datadogRum 초기화
 * @see {@link https://docs.datadoghq.com/real_user_monitoring/browser/}
 * @param {InitDatadogRumParam} datadogRumConfig
 * @example
 * ```
 * initDatadogRum({
 *   applicationId: '66451c75-004a-4a0a-ae4c-02d685d69a6c',
 *   clientToken: 'pub016ce1bb00dd9537751b302853449132',
 *   env: 'dev' | 'qa' | 'prod'
 *   service: 'store-web',
 *   sessionSampleRate: 5,
 *   sessionReplaySampleRate: 5,
 * });
 * ```
 */
const initDatadogRum = ({
  applicationId,
  clientToken,
  service,
  env,
  version = '',
  sessionSampleRate,
  sessionReplaySampleRate
}) => {
  if (typeof window === 'undefined' || !['qa', 'prod'].includes(env ?? '')) {
    return;
  }
  datadogRum.init({
    applicationId,
    clientToken,
    site: 'datadoghq.com',
    service,
    env,
    version,
    sessionSampleRate,
    sessionReplaySampleRate,
    trackResources: true,
    trackLongTasks: true,
    trackUserInteractions: true,
    defaultPrivacyLevel: 'mask-user-input'
  });
  if (sessionReplaySampleRate > 0) {
    datadogRum.startSessionReplayRecording();
  }
};

function getDefaultExportFromCjs (x) {
	return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}

var urlToolkit = {exports: {}};

(function (module, exports) {
	// see https://tools.ietf.org/html/rfc1808

	(function (root) {
	  var URL_REGEX =
	    /^(?=((?:[a-zA-Z0-9+\-.]+:)?))\1(?=((?:\/\/[^\/?#]*)?))\2(?=((?:(?:[^?#\/]*\/)*[^;?#\/]*)?))\3((?:;[^?#]*)?)(\?[^#]*)?(#[^]*)?$/;
	  var FIRST_SEGMENT_REGEX = /^(?=([^\/?#]*))\1([^]*)$/;
	  var SLASH_DOT_REGEX = /(?:\/|^)\.(?=\/)/g;
	  var SLASH_DOT_DOT_REGEX = /(?:\/|^)\.\.\/(?!\.\.\/)[^\/]*(?=\/)/g;

	  var URLToolkit = {
	    // If opts.alwaysNormalize is true then the path will always be normalized even when it starts with / or //
	    // E.g
	    // With opts.alwaysNormalize = false (default, spec compliant)
	    // http://a.com/b/cd + /e/f/../g => http://a.com/e/f/../g
	    // With opts.alwaysNormalize = true (not spec compliant)
	    // http://a.com/b/cd + /e/f/../g => http://a.com/e/g
	    buildAbsoluteURL: function (baseURL, relativeURL, opts) {
	      opts = opts || {};
	      // remove any remaining space and CRLF
	      baseURL = baseURL.trim();
	      relativeURL = relativeURL.trim();
	      if (!relativeURL) {
	        // 2a) If the embedded URL is entirely empty, it inherits the
	        // entire base URL (i.e., is set equal to the base URL)
	        // and we are done.
	        if (!opts.alwaysNormalize) {
	          return baseURL;
	        }
	        var basePartsForNormalise = URLToolkit.parseURL(baseURL);
	        if (!basePartsForNormalise) {
	          throw new Error('Error trying to parse base URL.');
	        }
	        basePartsForNormalise.path = URLToolkit.normalizePath(
	          basePartsForNormalise.path
	        );
	        return URLToolkit.buildURLFromParts(basePartsForNormalise);
	      }
	      var relativeParts = URLToolkit.parseURL(relativeURL);
	      if (!relativeParts) {
	        throw new Error('Error trying to parse relative URL.');
	      }
	      if (relativeParts.scheme) {
	        // 2b) If the embedded URL starts with a scheme name, it is
	        // interpreted as an absolute URL and we are done.
	        if (!opts.alwaysNormalize) {
	          return relativeURL;
	        }
	        relativeParts.path = URLToolkit.normalizePath(relativeParts.path);
	        return URLToolkit.buildURLFromParts(relativeParts);
	      }
	      var baseParts = URLToolkit.parseURL(baseURL);
	      if (!baseParts) {
	        throw new Error('Error trying to parse base URL.');
	      }
	      if (!baseParts.netLoc && baseParts.path && baseParts.path[0] !== '/') {
	        // If netLoc missing and path doesn't start with '/', assume everthing before the first '/' is the netLoc
	        // This causes 'example.com/a' to be handled as '//example.com/a' instead of '/example.com/a'
	        var pathParts = FIRST_SEGMENT_REGEX.exec(baseParts.path);
	        baseParts.netLoc = pathParts[1];
	        baseParts.path = pathParts[2];
	      }
	      if (baseParts.netLoc && !baseParts.path) {
	        baseParts.path = '/';
	      }
	      var builtParts = {
	        // 2c) Otherwise, the embedded URL inherits the scheme of
	        // the base URL.
	        scheme: baseParts.scheme,
	        netLoc: relativeParts.netLoc,
	        path: null,
	        params: relativeParts.params,
	        query: relativeParts.query,
	        fragment: relativeParts.fragment,
	      };
	      if (!relativeParts.netLoc) {
	        // 3) If the embedded URL's <net_loc> is non-empty, we skip to
	        // Step 7.  Otherwise, the embedded URL inherits the <net_loc>
	        // (if any) of the base URL.
	        builtParts.netLoc = baseParts.netLoc;
	        // 4) If the embedded URL path is preceded by a slash "/", the
	        // path is not relative and we skip to Step 7.
	        if (relativeParts.path[0] !== '/') {
	          if (!relativeParts.path) {
	            // 5) If the embedded URL path is empty (and not preceded by a
	            // slash), then the embedded URL inherits the base URL path
	            builtParts.path = baseParts.path;
	            // 5a) if the embedded URL's <params> is non-empty, we skip to
	            // step 7; otherwise, it inherits the <params> of the base
	            // URL (if any) and
	            if (!relativeParts.params) {
	              builtParts.params = baseParts.params;
	              // 5b) if the embedded URL's <query> is non-empty, we skip to
	              // step 7; otherwise, it inherits the <query> of the base
	              // URL (if any) and we skip to step 7.
	              if (!relativeParts.query) {
	                builtParts.query = baseParts.query;
	              }
	            }
	          } else {
	            // 6) The last segment of the base URL's path (anything
	            // following the rightmost slash "/", or the entire path if no
	            // slash is present) is removed and the embedded URL's path is
	            // appended in its place.
	            var baseURLPath = baseParts.path;
	            var newPath =
	              baseURLPath.substring(0, baseURLPath.lastIndexOf('/') + 1) +
	              relativeParts.path;
	            builtParts.path = URLToolkit.normalizePath(newPath);
	          }
	        }
	      }
	      if (builtParts.path === null) {
	        builtParts.path = opts.alwaysNormalize
	          ? URLToolkit.normalizePath(relativeParts.path)
	          : relativeParts.path;
	      }
	      return URLToolkit.buildURLFromParts(builtParts);
	    },
	    parseURL: function (url) {
	      var parts = URL_REGEX.exec(url);
	      if (!parts) {
	        return null;
	      }
	      return {
	        scheme: parts[1] || '',
	        netLoc: parts[2] || '',
	        path: parts[3] || '',
	        params: parts[4] || '',
	        query: parts[5] || '',
	        fragment: parts[6] || '',
	      };
	    },
	    normalizePath: function (path) {
	      // The following operations are
	      // then applied, in order, to the new path:
	      // 6a) All occurrences of "./", where "." is a complete path
	      // segment, are removed.
	      // 6b) If the path ends with "." as a complete path segment,
	      // that "." is removed.
	      path = path.split('').reverse().join('').replace(SLASH_DOT_REGEX, '');
	      // 6c) All occurrences of "<segment>/../", where <segment> is a
	      // complete path segment not equal to "..", are removed.
	      // Removal of these path segments is performed iteratively,
	      // removing the leftmost matching pattern on each iteration,
	      // until no matching pattern remains.
	      // 6d) If the path ends with "<segment>/..", where <segment> is a
	      // complete path segment not equal to "..", that
	      // "<segment>/.." is removed.
	      while (
	        path.length !== (path = path.replace(SLASH_DOT_DOT_REGEX, '')).length
	      ) {}
	      return path.split('').reverse().join('');
	    },
	    buildURLFromParts: function (parts) {
	      return (
	        parts.scheme +
	        parts.netLoc +
	        parts.path +
	        parts.params +
	        parts.query +
	        parts.fragment
	      );
	    },
	  };

	  module.exports = URLToolkit;
	})(); 
} (urlToolkit));

var urlToolkitExports = urlToolkit.exports;

function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread2(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _toPrimitive(t, r) {
  if ("object" != typeof t || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != typeof i) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == typeof i ? i : String(i);
}
function _defineProperty(obj, key, value) {
  key = _toPropertyKey(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}

// https://caniuse.com/mdn-javascript_builtins_number_isfinite
const isFiniteNumber = Number.isFinite || function (value) {
  return typeof value === 'number' && isFinite(value);
};

// https://caniuse.com/mdn-javascript_builtins_number_issafeinteger
const isSafeInteger = Number.isSafeInteger || function (value) {
  return typeof value === 'number' && Math.abs(value) <= MAX_SAFE_INTEGER;
};
const MAX_SAFE_INTEGER = Number.MAX_SAFE_INTEGER || 9007199254740991;

let Events = /*#__PURE__*/function (Events) {
  Events["MEDIA_ATTACHING"] = "hlsMediaAttaching";
  Events["MEDIA_ATTACHED"] = "hlsMediaAttached";
  Events["MEDIA_DETACHING"] = "hlsMediaDetaching";
  Events["MEDIA_DETACHED"] = "hlsMediaDetached";
  Events["BUFFER_RESET"] = "hlsBufferReset";
  Events["BUFFER_CODECS"] = "hlsBufferCodecs";
  Events["BUFFER_CREATED"] = "hlsBufferCreated";
  Events["BUFFER_APPENDING"] = "hlsBufferAppending";
  Events["BUFFER_APPENDED"] = "hlsBufferAppended";
  Events["BUFFER_EOS"] = "hlsBufferEos";
  Events["BUFFER_FLUSHING"] = "hlsBufferFlushing";
  Events["BUFFER_FLUSHED"] = "hlsBufferFlushed";
  Events["MANIFEST_LOADING"] = "hlsManifestLoading";
  Events["MANIFEST_LOADED"] = "hlsManifestLoaded";
  Events["MANIFEST_PARSED"] = "hlsManifestParsed";
  Events["LEVEL_SWITCHING"] = "hlsLevelSwitching";
  Events["LEVEL_SWITCHED"] = "hlsLevelSwitched";
  Events["LEVEL_LOADING"] = "hlsLevelLoading";
  Events["LEVEL_LOADED"] = "hlsLevelLoaded";
  Events["LEVEL_UPDATED"] = "hlsLevelUpdated";
  Events["LEVEL_PTS_UPDATED"] = "hlsLevelPtsUpdated";
  Events["LEVELS_UPDATED"] = "hlsLevelsUpdated";
  Events["AUDIO_TRACKS_UPDATED"] = "hlsAudioTracksUpdated";
  Events["AUDIO_TRACK_SWITCHING"] = "hlsAudioTrackSwitching";
  Events["AUDIO_TRACK_SWITCHED"] = "hlsAudioTrackSwitched";
  Events["AUDIO_TRACK_LOADING"] = "hlsAudioTrackLoading";
  Events["AUDIO_TRACK_LOADED"] = "hlsAudioTrackLoaded";
  Events["SUBTITLE_TRACKS_UPDATED"] = "hlsSubtitleTracksUpdated";
  Events["SUBTITLE_TRACKS_CLEARED"] = "hlsSubtitleTracksCleared";
  Events["SUBTITLE_TRACK_SWITCH"] = "hlsSubtitleTrackSwitch";
  Events["SUBTITLE_TRACK_LOADING"] = "hlsSubtitleTrackLoading";
  Events["SUBTITLE_TRACK_LOADED"] = "hlsSubtitleTrackLoaded";
  Events["SUBTITLE_FRAG_PROCESSED"] = "hlsSubtitleFragProcessed";
  Events["CUES_PARSED"] = "hlsCuesParsed";
  Events["NON_NATIVE_TEXT_TRACKS_FOUND"] = "hlsNonNativeTextTracksFound";
  Events["INIT_PTS_FOUND"] = "hlsInitPtsFound";
  Events["FRAG_LOADING"] = "hlsFragLoading";
  Events["FRAG_LOAD_EMERGENCY_ABORTED"] = "hlsFragLoadEmergencyAborted";
  Events["FRAG_LOADED"] = "hlsFragLoaded";
  Events["FRAG_DECRYPTED"] = "hlsFragDecrypted";
  Events["FRAG_PARSING_INIT_SEGMENT"] = "hlsFragParsingInitSegment";
  Events["FRAG_PARSING_USERDATA"] = "hlsFragParsingUserdata";
  Events["FRAG_PARSING_METADATA"] = "hlsFragParsingMetadata";
  Events["FRAG_PARSED"] = "hlsFragParsed";
  Events["FRAG_BUFFERED"] = "hlsFragBuffered";
  Events["FRAG_CHANGED"] = "hlsFragChanged";
  Events["FPS_DROP"] = "hlsFpsDrop";
  Events["FPS_DROP_LEVEL_CAPPING"] = "hlsFpsDropLevelCapping";
  Events["MAX_AUTO_LEVEL_UPDATED"] = "hlsMaxAutoLevelUpdated";
  Events["ERROR"] = "hlsError";
  Events["DESTROYING"] = "hlsDestroying";
  Events["KEY_LOADING"] = "hlsKeyLoading";
  Events["KEY_LOADED"] = "hlsKeyLoaded";
  Events["LIVE_BACK_BUFFER_REACHED"] = "hlsLiveBackBufferReached";
  Events["BACK_BUFFER_REACHED"] = "hlsBackBufferReached";
  Events["STEERING_MANIFEST_LOADED"] = "hlsSteeringManifestLoaded";
  return Events;
}({});

/**
 * Defines each Event type and payload by Event name. Used in {@link hls.js#HlsEventEmitter} to strongly type the event listener API.
 */

let ErrorTypes = /*#__PURE__*/function (ErrorTypes) {
  ErrorTypes["NETWORK_ERROR"] = "networkError";
  ErrorTypes["MEDIA_ERROR"] = "mediaError";
  ErrorTypes["KEY_SYSTEM_ERROR"] = "keySystemError";
  ErrorTypes["MUX_ERROR"] = "muxError";
  ErrorTypes["OTHER_ERROR"] = "otherError";
  return ErrorTypes;
}({});
let ErrorDetails = /*#__PURE__*/function (ErrorDetails) {
  ErrorDetails["KEY_SYSTEM_NO_KEYS"] = "keySystemNoKeys";
  ErrorDetails["KEY_SYSTEM_NO_ACCESS"] = "keySystemNoAccess";
  ErrorDetails["KEY_SYSTEM_NO_SESSION"] = "keySystemNoSession";
  ErrorDetails["KEY_SYSTEM_NO_CONFIGURED_LICENSE"] = "keySystemNoConfiguredLicense";
  ErrorDetails["KEY_SYSTEM_LICENSE_REQUEST_FAILED"] = "keySystemLicenseRequestFailed";
  ErrorDetails["KEY_SYSTEM_SERVER_CERTIFICATE_REQUEST_FAILED"] = "keySystemServerCertificateRequestFailed";
  ErrorDetails["KEY_SYSTEM_SERVER_CERTIFICATE_UPDATE_FAILED"] = "keySystemServerCertificateUpdateFailed";
  ErrorDetails["KEY_SYSTEM_SESSION_UPDATE_FAILED"] = "keySystemSessionUpdateFailed";
  ErrorDetails["KEY_SYSTEM_STATUS_OUTPUT_RESTRICTED"] = "keySystemStatusOutputRestricted";
  ErrorDetails["KEY_SYSTEM_STATUS_INTERNAL_ERROR"] = "keySystemStatusInternalError";
  ErrorDetails["MANIFEST_LOAD_ERROR"] = "manifestLoadError";
  ErrorDetails["MANIFEST_LOAD_TIMEOUT"] = "manifestLoadTimeOut";
  ErrorDetails["MANIFEST_PARSING_ERROR"] = "manifestParsingError";
  ErrorDetails["MANIFEST_INCOMPATIBLE_CODECS_ERROR"] = "manifestIncompatibleCodecsError";
  ErrorDetails["LEVEL_EMPTY_ERROR"] = "levelEmptyError";
  ErrorDetails["LEVEL_LOAD_ERROR"] = "levelLoadError";
  ErrorDetails["LEVEL_LOAD_TIMEOUT"] = "levelLoadTimeOut";
  ErrorDetails["LEVEL_PARSING_ERROR"] = "levelParsingError";
  ErrorDetails["LEVEL_SWITCH_ERROR"] = "levelSwitchError";
  ErrorDetails["AUDIO_TRACK_LOAD_ERROR"] = "audioTrackLoadError";
  ErrorDetails["AUDIO_TRACK_LOAD_TIMEOUT"] = "audioTrackLoadTimeOut";
  ErrorDetails["SUBTITLE_LOAD_ERROR"] = "subtitleTrackLoadError";
  ErrorDetails["SUBTITLE_TRACK_LOAD_TIMEOUT"] = "subtitleTrackLoadTimeOut";
  ErrorDetails["FRAG_LOAD_ERROR"] = "fragLoadError";
  ErrorDetails["FRAG_LOAD_TIMEOUT"] = "fragLoadTimeOut";
  ErrorDetails["FRAG_DECRYPT_ERROR"] = "fragDecryptError";
  ErrorDetails["FRAG_PARSING_ERROR"] = "fragParsingError";
  ErrorDetails["FRAG_GAP"] = "fragGap";
  ErrorDetails["REMUX_ALLOC_ERROR"] = "remuxAllocError";
  ErrorDetails["KEY_LOAD_ERROR"] = "keyLoadError";
  ErrorDetails["KEY_LOAD_TIMEOUT"] = "keyLoadTimeOut";
  ErrorDetails["BUFFER_ADD_CODEC_ERROR"] = "bufferAddCodecError";
  ErrorDetails["BUFFER_INCOMPATIBLE_CODECS_ERROR"] = "bufferIncompatibleCodecsError";
  ErrorDetails["BUFFER_APPEND_ERROR"] = "bufferAppendError";
  ErrorDetails["BUFFER_APPENDING_ERROR"] = "bufferAppendingError";
  ErrorDetails["BUFFER_STALLED_ERROR"] = "bufferStalledError";
  ErrorDetails["BUFFER_FULL_ERROR"] = "bufferFullError";
  ErrorDetails["BUFFER_SEEK_OVER_HOLE"] = "bufferSeekOverHole";
  ErrorDetails["BUFFER_NUDGE_ON_STALL"] = "bufferNudgeOnStall";
  ErrorDetails["INTERNAL_EXCEPTION"] = "internalException";
  ErrorDetails["INTERNAL_ABORTED"] = "aborted";
  ErrorDetails["UNKNOWN"] = "unknown";
  return ErrorDetails;
}({});

const noop = function noop() {};
const fakeLogger = {
  trace: noop,
  debug: noop,
  log: noop,
  warn: noop,
  info: noop,
  error: noop
};
let exportedLogger = fakeLogger;

// let lastCallTime;
// function formatMsgWithTimeInfo(type, msg) {
//   const now = Date.now();
//   const diff = lastCallTime ? '+' + (now - lastCallTime) : '0';
//   lastCallTime = now;
//   msg = (new Date(now)).toISOString() + ' | [' +  type + '] > ' + msg + ' ( ' + diff + ' ms )';
//   return msg;
// }

function consolePrintFn(type) {
  const func = self.console[type];
  if (func) {
    return func.bind(self.console, `[${type}] >`);
  }
  return noop;
}
function exportLoggerFunctions(debugConfig, ...functions) {
  functions.forEach(function (type) {
    exportedLogger[type] = debugConfig[type] ? debugConfig[type].bind(debugConfig) : consolePrintFn(type);
  });
}
function enableLogs(debugConfig, id) {
  // check that console is available
  if (typeof console === 'object' && debugConfig === true || typeof debugConfig === 'object') {
    exportLoggerFunctions(debugConfig,
    // Remove out from list here to hard-disable a log-level
    // 'trace',
    'debug', 'log', 'info', 'warn', 'error');
    // Some browsers don't allow to use bind on console object anyway
    // fallback to default if needed
    try {
      exportedLogger.log(`Debug logs enabled for "${id}" in hls.js version ${"1.5.14"}`);
    } catch (e) {
      exportedLogger = fakeLogger;
    }
  } else {
    exportedLogger = fakeLogger;
  }
}
const logger = exportedLogger;

const DECIMAL_RESOLUTION_REGEX = /^(\d+)x(\d+)$/;
const ATTR_LIST_REGEX = /(.+?)=(".*?"|.*?)(?:,|$)/g;

// adapted from https://github.com/kanongil/node-m3u8parse/blob/master/attrlist.js
class AttrList {
  constructor(attrs) {
    if (typeof attrs === 'string') {
      attrs = AttrList.parseAttrList(attrs);
    }
    _extends(this, attrs);
  }
  get clientAttrs() {
    return Object.keys(this).filter(attr => attr.substring(0, 2) === 'X-');
  }
  decimalInteger(attrName) {
    const intValue = parseInt(this[attrName], 10);
    if (intValue > Number.MAX_SAFE_INTEGER) {
      return Infinity;
    }
    return intValue;
  }
  hexadecimalInteger(attrName) {
    if (this[attrName]) {
      let stringValue = (this[attrName] || '0x').slice(2);
      stringValue = (stringValue.length & 1 ? '0' : '') + stringValue;
      const value = new Uint8Array(stringValue.length / 2);
      for (let i = 0; i < stringValue.length / 2; i++) {
        value[i] = parseInt(stringValue.slice(i * 2, i * 2 + 2), 16);
      }
      return value;
    } else {
      return null;
    }
  }
  hexadecimalIntegerAsNumber(attrName) {
    const intValue = parseInt(this[attrName], 16);
    if (intValue > Number.MAX_SAFE_INTEGER) {
      return Infinity;
    }
    return intValue;
  }
  decimalFloatingPoint(attrName) {
    return parseFloat(this[attrName]);
  }
  optionalFloat(attrName, defaultValue) {
    const value = this[attrName];
    return value ? parseFloat(value) : defaultValue;
  }
  enumeratedString(attrName) {
    return this[attrName];
  }
  bool(attrName) {
    return this[attrName] === 'YES';
  }
  decimalResolution(attrName) {
    const res = DECIMAL_RESOLUTION_REGEX.exec(this[attrName]);
    if (res === null) {
      return undefined;
    }
    return {
      width: parseInt(res[1], 10),
      height: parseInt(res[2], 10)
    };
  }
  static parseAttrList(input) {
    let match;
    const attrs = {};
    const quote = '"';
    ATTR_LIST_REGEX.lastIndex = 0;
    while ((match = ATTR_LIST_REGEX.exec(input)) !== null) {
      let value = match[2];
      if (value.indexOf(quote) === 0 && value.lastIndexOf(quote) === value.length - 1) {
        value = value.slice(1, -1);
      }
      const name = match[1].trim();
      attrs[name] = value;
    }
    return attrs;
  }
}

// Avoid exporting const enum so that these values can be inlined

function isDateRangeCueAttribute(attrName) {
  return attrName !== "ID" && attrName !== "CLASS" && attrName !== "START-DATE" && attrName !== "DURATION" && attrName !== "END-DATE" && attrName !== "END-ON-NEXT";
}
function isSCTE35Attribute(attrName) {
  return attrName === "SCTE35-OUT" || attrName === "SCTE35-IN";
}
class DateRange {
  constructor(dateRangeAttr, dateRangeWithSameId) {
    this.attr = void 0;
    this._startDate = void 0;
    this._endDate = void 0;
    this._badValueForSameId = void 0;
    if (dateRangeWithSameId) {
      const previousAttr = dateRangeWithSameId.attr;
      for (const key in previousAttr) {
        if (Object.prototype.hasOwnProperty.call(dateRangeAttr, key) && dateRangeAttr[key] !== previousAttr[key]) {
          logger.warn(`DATERANGE tag attribute: "${key}" does not match for tags with ID: "${dateRangeAttr.ID}"`);
          this._badValueForSameId = key;
          break;
        }
      }
      // Merge DateRange tags with the same ID
      dateRangeAttr = _extends(new AttrList({}), previousAttr, dateRangeAttr);
    }
    this.attr = dateRangeAttr;
    this._startDate = new Date(dateRangeAttr["START-DATE"]);
    if ("END-DATE" in this.attr) {
      const endDate = new Date(this.attr["END-DATE"]);
      if (isFiniteNumber(endDate.getTime())) {
        this._endDate = endDate;
      }
    }
  }
  get id() {
    return this.attr.ID;
  }
  get class() {
    return this.attr.CLASS;
  }
  get startDate() {
    return this._startDate;
  }
  get endDate() {
    if (this._endDate) {
      return this._endDate;
    }
    const duration = this.duration;
    if (duration !== null) {
      return new Date(this._startDate.getTime() + duration * 1000);
    }
    return null;
  }
  get duration() {
    if ("DURATION" in this.attr) {
      const duration = this.attr.decimalFloatingPoint("DURATION");
      if (isFiniteNumber(duration)) {
        return duration;
      }
    } else if (this._endDate) {
      return (this._endDate.getTime() - this._startDate.getTime()) / 1000;
    }
    return null;
  }
  get plannedDuration() {
    if ("PLANNED-DURATION" in this.attr) {
      return this.attr.decimalFloatingPoint("PLANNED-DURATION");
    }
    return null;
  }
  get endOnNext() {
    return this.attr.bool("END-ON-NEXT");
  }
  get isValid() {
    return !!this.id && !this._badValueForSameId && isFiniteNumber(this.startDate.getTime()) && (this.duration === null || this.duration >= 0) && (!this.endOnNext || !!this.class);
  }
}

class LoadStats {
  constructor() {
    this.aborted = false;
    this.loaded = 0;
    this.retry = 0;
    this.total = 0;
    this.chunkCount = 0;
    this.bwEstimate = 0;
    this.loading = {
      start: 0,
      first: 0,
      end: 0
    };
    this.parsing = {
      start: 0,
      end: 0
    };
    this.buffering = {
      start: 0,
      first: 0,
      end: 0
    };
  }
}

var ElementaryStreamTypes = {
  AUDIO: "audio",
  VIDEO: "video",
  AUDIOVIDEO: "audiovideo"
};
class BaseSegment {
  constructor(baseurl) {
    this._byteRange = null;
    this._url = null;
    // baseurl is the URL to the playlist
    this.baseurl = void 0;
    // relurl is the portion of the URL that comes from inside the playlist.
    this.relurl = void 0;
    // Holds the types of data this fragment supports
    this.elementaryStreams = {
      [ElementaryStreamTypes.AUDIO]: null,
      [ElementaryStreamTypes.VIDEO]: null,
      [ElementaryStreamTypes.AUDIOVIDEO]: null
    };
    this.baseurl = baseurl;
  }

  // setByteRange converts a EXT-X-BYTERANGE attribute into a two element array
  setByteRange(value, previous) {
    const params = value.split('@', 2);
    let start;
    if (params.length === 1) {
      start = (previous == null ? void 0 : previous.byteRangeEndOffset) || 0;
    } else {
      start = parseInt(params[1]);
    }
    this._byteRange = [start, parseInt(params[0]) + start];
  }
  get byteRange() {
    if (!this._byteRange) {
      return [];
    }
    return this._byteRange;
  }
  get byteRangeStartOffset() {
    return this.byteRange[0];
  }
  get byteRangeEndOffset() {
    return this.byteRange[1];
  }
  get url() {
    if (!this._url && this.baseurl && this.relurl) {
      this._url = urlToolkitExports.buildAbsoluteURL(this.baseurl, this.relurl, {
        alwaysNormalize: true
      });
    }
    return this._url || '';
  }
  set url(value) {
    this._url = value;
  }
}

/**
 * Object representing parsed data from an HLS Segment. Found in {@link hls.js#LevelDetails.fragments}.
 */
class Fragment extends BaseSegment {
  constructor(type, baseurl) {
    super(baseurl);
    this._decryptdata = null;
    this.rawProgramDateTime = null;
    this.programDateTime = null;
    this.tagList = [];
    // EXTINF has to be present for a m3u8 to be considered valid
    this.duration = 0;
    // sn notates the sequence number for a segment, and if set to a string can be 'initSegment'
    this.sn = 0;
    // levelkeys are the EXT-X-KEY tags that apply to this segment for decryption
    // core difference from the private field _decryptdata is the lack of the initialized IV
    // _decryptdata will set the IV for this segment based on the segment number in the fragment
    this.levelkeys = void 0;
    // A string representing the fragment type
    this.type = void 0;
    // A reference to the loader. Set while the fragment is loading, and removed afterwards. Used to abort fragment loading
    this.loader = null;
    // A reference to the key loader. Set while the key is loading, and removed afterwards. Used to abort key loading
    this.keyLoader = null;
    // The level/track index to which the fragment belongs
    this.level = -1;
    // The continuity counter of the fragment
    this.cc = 0;
    // The starting Presentation Time Stamp (PTS) of the fragment. Set after transmux complete.
    this.startPTS = void 0;
    // The ending Presentation Time Stamp (PTS) of the fragment. Set after transmux complete.
    this.endPTS = void 0;
    // The starting Decode Time Stamp (DTS) of the fragment. Set after transmux complete.
    this.startDTS = void 0;
    // The ending Decode Time Stamp (DTS) of the fragment. Set after transmux complete.
    this.endDTS = void 0;
    // The start time of the fragment, as listed in the manifest. Updated after transmux complete.
    this.start = 0;
    // Set by `updateFragPTSDTS` in level-helper
    this.deltaPTS = void 0;
    // The maximum starting Presentation Time Stamp (audio/video PTS) of the fragment. Set after transmux complete.
    this.maxStartPTS = void 0;
    // The minimum ending Presentation Time Stamp (audio/video PTS) of the fragment. Set after transmux complete.
    this.minEndPTS = void 0;
    // Load/parse timing information
    this.stats = new LoadStats();
    // Init Segment bytes (unset for media segments)
    this.data = void 0;
    // A flag indicating whether the segment was downloaded in order to test bitrate, and was not buffered
    this.bitrateTest = false;
    // #EXTINF  segment title
    this.title = null;
    // The Media Initialization Section for this segment
    this.initSegment = null;
    // Fragment is the last fragment in the media playlist
    this.endList = void 0;
    // Fragment is marked by an EXT-X-GAP tag indicating that it does not contain media data and should not be loaded
    this.gap = void 0;
    // Deprecated
    this.urlId = 0;
    this.type = type;
  }
  get decryptdata() {
    const {
      levelkeys
    } = this;
    if (!levelkeys && !this._decryptdata) {
      return null;
    }
    if (!this._decryptdata && this.levelkeys && !this.levelkeys.NONE) {
      const key = this.levelkeys.identity;
      if (key) {
        this._decryptdata = key.getDecryptData(this.sn);
      } else {
        const keyFormats = Object.keys(this.levelkeys);
        if (keyFormats.length === 1) {
          return this._decryptdata = this.levelkeys[keyFormats[0]].getDecryptData(this.sn);
        }
      }
    }
    return this._decryptdata;
  }
  get end() {
    return this.start + this.duration;
  }
  get endProgramDateTime() {
    if (this.programDateTime === null) {
      return null;
    }
    if (!isFiniteNumber(this.programDateTime)) {
      return null;
    }
    const duration = !isFiniteNumber(this.duration) ? 0 : this.duration;
    return this.programDateTime + duration * 1000;
  }
  get encrypted() {
    var _this$_decryptdata;
    // At the m3u8-parser level we need to add support for manifest signalled keyformats
    // when we want the fragment to start reporting that it is encrypted.
    // Currently, keyFormat will only be set for identity keys
    if ((_this$_decryptdata = this._decryptdata) != null && _this$_decryptdata.encrypted) {
      return true;
    } else if (this.levelkeys) {
      const keyFormats = Object.keys(this.levelkeys);
      const len = keyFormats.length;
      if (len > 1 || len === 1 && this.levelkeys[keyFormats[0]].encrypted) {
        return true;
      }
    }
    return false;
  }
  setKeyFormat(keyFormat) {
    if (this.levelkeys) {
      const key = this.levelkeys[keyFormat];
      if (key && !this._decryptdata) {
        this._decryptdata = key.getDecryptData(this.sn);
      }
    }
  }
  abortRequests() {
    var _this$loader, _this$keyLoader;
    (_this$loader = this.loader) == null ? void 0 : _this$loader.abort();
    (_this$keyLoader = this.keyLoader) == null ? void 0 : _this$keyLoader.abort();
  }
  setElementaryStreamInfo(type, startPTS, endPTS, startDTS, endDTS, partial = false) {
    const {
      elementaryStreams
    } = this;
    const info = elementaryStreams[type];
    if (!info) {
      elementaryStreams[type] = {
        startPTS,
        endPTS,
        startDTS,
        endDTS,
        partial
      };
      return;
    }
    info.startPTS = Math.min(info.startPTS, startPTS);
    info.endPTS = Math.max(info.endPTS, endPTS);
    info.startDTS = Math.min(info.startDTS, startDTS);
    info.endDTS = Math.max(info.endDTS, endDTS);
  }
  clearElementaryStreamInfo() {
    const {
      elementaryStreams
    } = this;
    elementaryStreams[ElementaryStreamTypes.AUDIO] = null;
    elementaryStreams[ElementaryStreamTypes.VIDEO] = null;
    elementaryStreams[ElementaryStreamTypes.AUDIOVIDEO] = null;
  }
}

/**
 * Object representing parsed data from an HLS Partial Segment. Found in {@link hls.js#LevelDetails.partList}.
 */
class Part extends BaseSegment {
  constructor(partAttrs, frag, baseurl, index, previous) {
    super(baseurl);
    this.fragOffset = 0;
    this.duration = 0;
    this.gap = false;
    this.independent = false;
    this.relurl = void 0;
    this.fragment = void 0;
    this.index = void 0;
    this.stats = new LoadStats();
    this.duration = partAttrs.decimalFloatingPoint('DURATION');
    this.gap = partAttrs.bool('GAP');
    this.independent = partAttrs.bool('INDEPENDENT');
    this.relurl = partAttrs.enumeratedString('URI');
    this.fragment = frag;
    this.index = index;
    const byteRange = partAttrs.enumeratedString('BYTERANGE');
    if (byteRange) {
      this.setByteRange(byteRange, previous);
    }
    if (previous) {
      this.fragOffset = previous.fragOffset + previous.duration;
    }
  }
  get start() {
    return this.fragment.start + this.fragOffset;
  }
  get end() {
    return this.start + this.duration;
  }
  get loaded() {
    const {
      elementaryStreams
    } = this;
    return !!(elementaryStreams.audio || elementaryStreams.video || elementaryStreams.audiovideo);
  }
}

const DEFAULT_TARGET_DURATION = 10;

/**
 * Object representing parsed data from an HLS Media Playlist. Found in {@link hls.js#Level.details}.
 */
class LevelDetails {
  constructor(baseUrl) {
    this.PTSKnown = false;
    this.alignedSliding = false;
    this.averagetargetduration = void 0;
    this.endCC = 0;
    this.endSN = 0;
    this.fragments = void 0;
    this.fragmentHint = void 0;
    this.partList = null;
    this.dateRanges = void 0;
    this.live = true;
    this.ageHeader = 0;
    this.advancedDateTime = void 0;
    this.updated = true;
    this.advanced = true;
    this.availabilityDelay = void 0;
    // Manifest reload synchronization
    this.misses = 0;
    this.startCC = 0;
    this.startSN = 0;
    this.startTimeOffset = null;
    this.targetduration = 0;
    this.totalduration = 0;
    this.type = null;
    this.url = void 0;
    this.m3u8 = '';
    this.version = null;
    this.canBlockReload = false;
    this.canSkipUntil = 0;
    this.canSkipDateRanges = false;
    this.skippedSegments = 0;
    this.recentlyRemovedDateranges = void 0;
    this.partHoldBack = 0;
    this.holdBack = 0;
    this.partTarget = 0;
    this.preloadHint = void 0;
    this.renditionReports = void 0;
    this.tuneInGoal = 0;
    this.deltaUpdateFailed = void 0;
    this.driftStartTime = 0;
    this.driftEndTime = 0;
    this.driftStart = 0;
    this.driftEnd = 0;
    this.encryptedFragments = void 0;
    this.playlistParsingError = null;
    this.variableList = null;
    this.hasVariableRefs = false;
    this.fragments = [];
    this.encryptedFragments = [];
    this.dateRanges = {};
    this.url = baseUrl;
  }
  reloaded(previous) {
    if (!previous) {
      this.advanced = true;
      this.updated = true;
      return;
    }
    const partSnDiff = this.lastPartSn - previous.lastPartSn;
    const partIndexDiff = this.lastPartIndex - previous.lastPartIndex;
    this.updated = this.endSN !== previous.endSN || !!partIndexDiff || !!partSnDiff || !this.live;
    this.advanced = this.endSN > previous.endSN || partSnDiff > 0 || partSnDiff === 0 && partIndexDiff > 0;
    if (this.updated || this.advanced) {
      this.misses = Math.floor(previous.misses * 0.6);
    } else {
      this.misses = previous.misses + 1;
    }
    this.availabilityDelay = previous.availabilityDelay;
  }
  get hasProgramDateTime() {
    if (this.fragments.length) {
      return isFiniteNumber(this.fragments[this.fragments.length - 1].programDateTime);
    }
    return false;
  }
  get levelTargetDuration() {
    return this.averagetargetduration || this.targetduration || DEFAULT_TARGET_DURATION;
  }
  get drift() {
    const runTime = this.driftEndTime - this.driftStartTime;
    if (runTime > 0) {
      const runDuration = this.driftEnd - this.driftStart;
      return runDuration * 1000 / runTime;
    }
    return 1;
  }
  get edge() {
    return this.partEnd || this.fragmentEnd;
  }
  get partEnd() {
    var _this$partList;
    if ((_this$partList = this.partList) != null && _this$partList.length) {
      return this.partList[this.partList.length - 1].end;
    }
    return this.fragmentEnd;
  }
  get fragmentEnd() {
    var _this$fragments;
    if ((_this$fragments = this.fragments) != null && _this$fragments.length) {
      return this.fragments[this.fragments.length - 1].end;
    }
    return 0;
  }
  get age() {
    if (this.advancedDateTime) {
      return Math.max(Date.now() - this.advancedDateTime, 0) / 1000;
    }
    return 0;
  }
  get lastPartIndex() {
    var _this$partList2;
    if ((_this$partList2 = this.partList) != null && _this$partList2.length) {
      return this.partList[this.partList.length - 1].index;
    }
    return -1;
  }
  get lastPartSn() {
    var _this$partList3;
    if ((_this$partList3 = this.partList) != null && _this$partList3.length) {
      return this.partList[this.partList.length - 1].fragment.sn;
    }
    return this.endSN;
  }
}

function base64Decode(base64encodedStr) {
  return Uint8Array.from(atob(base64encodedStr), c => c.charCodeAt(0));
}

function getKeyIdBytes(str) {
  const keyIdbytes = strToUtf8array(str).subarray(0, 16);
  const paddedkeyIdbytes = new Uint8Array(16);
  paddedkeyIdbytes.set(keyIdbytes, 16 - keyIdbytes.length);
  return paddedkeyIdbytes;
}
function changeEndianness(keyId) {
  const swap = function swap(array, from, to) {
    const cur = array[from];
    array[from] = array[to];
    array[to] = cur;
  };
  swap(keyId, 0, 3);
  swap(keyId, 1, 2);
  swap(keyId, 4, 5);
  swap(keyId, 6, 7);
}
function convertDataUriToArrayBytes(uri) {
  // data:[<media type][;attribute=value][;base64],<data>
  const colonsplit = uri.split(':');
  let keydata = null;
  if (colonsplit[0] === 'data' && colonsplit.length === 2) {
    const semicolonsplit = colonsplit[1].split(';');
    const commasplit = semicolonsplit[semicolonsplit.length - 1].split(',');
    if (commasplit.length === 2) {
      const isbase64 = commasplit[0] === 'base64';
      const data = commasplit[1];
      if (isbase64) {
        semicolonsplit.splice(-1, 1); // remove from processing
        keydata = base64Decode(data);
      } else {
        keydata = getKeyIdBytes(data);
      }
    }
  }
  return keydata;
}
function strToUtf8array(str) {
  return Uint8Array.from(unescape(encodeURIComponent(str)), c => c.charCodeAt(0));
}

/** returns `undefined` is `self` is missing, e.g. in node */
const optionalSelf = typeof self !== 'undefined' ? self : undefined;

/**
 * @see https://developer.mozilla.org/en-US/docs/Web/API/Navigator/requestMediaKeySystemAccess
 */
var KeySystems = {
  CLEARKEY: "org.w3.clearkey",
  FAIRPLAY: "com.apple.fps",
  PLAYREADY: "com.microsoft.playready",
  WIDEVINE: "com.widevine.alpha"
};

// Playlist #EXT-X-KEY KEYFORMAT values
var KeySystemFormats = {
  CLEARKEY: "org.w3.clearkey",
  FAIRPLAY: "com.apple.streamingkeydelivery",
  PLAYREADY: "com.microsoft.playready",
  WIDEVINE: "urn:uuid:edef8ba9-79d6-4ace-a3c8-27dcd51d21ed"
};
function keySystemFormatToKeySystemDomain(format) {
  switch (format) {
    case KeySystemFormats.FAIRPLAY:
      return KeySystems.FAIRPLAY;
    case KeySystemFormats.PLAYREADY:
      return KeySystems.PLAYREADY;
    case KeySystemFormats.WIDEVINE:
      return KeySystems.WIDEVINE;
    case KeySystemFormats.CLEARKEY:
      return KeySystems.CLEARKEY;
  }
}

// System IDs for which we can extract a key ID from "encrypted" event PSSH
var KeySystemIds = {
  WIDEVINE: "edef8ba979d64acea3c827dcd51d21ed"
};
function keySystemIdToKeySystemDomain(systemId) {
  if (systemId === KeySystemIds.WIDEVINE) {
    return KeySystems.WIDEVINE;
    // } else if (systemId === KeySystemIds.PLAYREADY) {
    //   return KeySystems.PLAYREADY;
    // } else if (systemId === KeySystemIds.CENC || systemId === KeySystemIds.CLEARKEY) {
    //   return KeySystems.CLEARKEY;
  }
}
function keySystemDomainToKeySystemFormat(keySystem) {
  switch (keySystem) {
    case KeySystems.FAIRPLAY:
      return KeySystemFormats.FAIRPLAY;
    case KeySystems.PLAYREADY:
      return KeySystemFormats.PLAYREADY;
    case KeySystems.WIDEVINE:
      return KeySystemFormats.WIDEVINE;
    case KeySystems.CLEARKEY:
      return KeySystemFormats.CLEARKEY;
  }
}
function getKeySystemsForConfig(config) {
  const {
    drmSystems,
    widevineLicenseUrl
  } = config;
  const keySystemsToAttempt = drmSystems ? [KeySystems.FAIRPLAY, KeySystems.WIDEVINE, KeySystems.PLAYREADY, KeySystems.CLEARKEY].filter(keySystem => !!drmSystems[keySystem]) : [];
  if (!keySystemsToAttempt[KeySystems.WIDEVINE] && widevineLicenseUrl) {
    keySystemsToAttempt.push(KeySystems.WIDEVINE);
  }
  return keySystemsToAttempt;
}
const requestMediaKeySystemAccess = function (_optionalSelf$navigat) {
  if (optionalSelf != null && (_optionalSelf$navigat = optionalSelf.navigator) != null && _optionalSelf$navigat.requestMediaKeySystemAccess) {
    return self.navigator.requestMediaKeySystemAccess.bind(self.navigator);
  } else {
    return null;
  }
}();

/**
 * @see https://developer.mozilla.org/en-US/docs/Web/API/MediaKeySystemConfiguration
 */
function getSupportedMediaKeySystemConfigurations(keySystem, audioCodecs, videoCodecs, drmSystemOptions) {
  let initDataTypes;
  switch (keySystem) {
    case KeySystems.FAIRPLAY:
      initDataTypes = ['cenc', 'sinf'];
      break;
    case KeySystems.WIDEVINE:
    case KeySystems.PLAYREADY:
      initDataTypes = ['cenc'];
      break;
    case KeySystems.CLEARKEY:
      initDataTypes = ['cenc', 'keyids'];
      break;
    default:
      throw new Error(`Unknown key-system: ${keySystem}`);
  }
  return createMediaKeySystemConfigurations(initDataTypes, audioCodecs, videoCodecs, drmSystemOptions);
}
function createMediaKeySystemConfigurations(initDataTypes, audioCodecs, videoCodecs, drmSystemOptions) {
  const baseConfig = {
    initDataTypes: initDataTypes,
    persistentState: drmSystemOptions.persistentState || 'optional',
    distinctiveIdentifier: drmSystemOptions.distinctiveIdentifier || 'optional',
    sessionTypes: drmSystemOptions.sessionTypes || [drmSystemOptions.sessionType || 'temporary'],
    audioCapabilities: audioCodecs.map(codec => ({
      contentType: `audio/mp4; codecs="${codec}"`,
      robustness: drmSystemOptions.audioRobustness || '',
      encryptionScheme: drmSystemOptions.audioEncryptionScheme || null
    })),
    videoCapabilities: videoCodecs.map(codec => ({
      contentType: `video/mp4; codecs="${codec}"`,
      robustness: drmSystemOptions.videoRobustness || '',
      encryptionScheme: drmSystemOptions.videoEncryptionScheme || null
    }))
  };
  return [baseConfig];
}

function sliceUint8(array, start, end) {
  // @ts-expect-error This polyfills IE11 usage of Uint8Array slice.
  // It always exists in the TypeScript definition so fails, but it fails at runtime on IE11.
  return Uint8Array.prototype.slice ? array.slice(start, end) : new Uint8Array(Array.prototype.slice.call(array, start, end));
}

// breaking up those two types in order to clarify what is happening in the decoding path.

/**
 * Returns true if an ID3 header can be found at offset in data
 * @param data - The data to search
 * @param offset - The offset at which to start searching
 */
const isHeader$2 = (data, offset) => {
  /*
   * http://id3.org/id3v2.3.0
   * [0]     = 'I'
   * [1]     = 'D'
   * [2]     = '3'
   * [3,4]   = {Version}
   * [5]     = {Flags}
   * [6-9]   = {ID3 Size}
   *
   * An ID3v2 tag can be detected with the following pattern:
   *  $49 44 33 yy yy xx zz zz zz zz
   * Where yy is less than $FF, xx is the 'flags' byte and zz is less than $80
   */
  if (offset + 10 <= data.length) {
    // look for 'ID3' identifier
    if (data[offset] === 0x49 && data[offset + 1] === 0x44 && data[offset + 2] === 0x33) {
      // check version is within range
      if (data[offset + 3] < 0xff && data[offset + 4] < 0xff) {
        // check size is within range
        if (data[offset + 6] < 0x80 && data[offset + 7] < 0x80 && data[offset + 8] < 0x80 && data[offset + 9] < 0x80) {
          return true;
        }
      }
    }
  }
  return false;
};

/**
 * Returns true if an ID3 footer can be found at offset in data
 * @param data - The data to search
 * @param offset - The offset at which to start searching
 */
const isFooter = (data, offset) => {
  /*
   * The footer is a copy of the header, but with a different identifier
   */
  if (offset + 10 <= data.length) {
    // look for '3DI' identifier
    if (data[offset] === 0x33 && data[offset + 1] === 0x44 && data[offset + 2] === 0x49) {
      // check version is within range
      if (data[offset + 3] < 0xff && data[offset + 4] < 0xff) {
        // check size is within range
        if (data[offset + 6] < 0x80 && data[offset + 7] < 0x80 && data[offset + 8] < 0x80 && data[offset + 9] < 0x80) {
          return true;
        }
      }
    }
  }
  return false;
};

/**
 * Returns any adjacent ID3 tags found in data starting at offset, as one block of data
 * @param data - The data to search in
 * @param offset - The offset at which to start searching
 * @returns the block of data containing any ID3 tags found
 * or *undefined* if no header is found at the starting offset
 */
const getID3Data = (data, offset) => {
  const front = offset;
  let length = 0;
  while (isHeader$2(data, offset)) {
    // ID3 header is 10 bytes
    length += 10;
    const size = readSize(data, offset + 6);
    length += size;
    if (isFooter(data, offset + 10)) {
      // ID3 footer is 10 bytes
      length += 10;
    }
    offset += length;
  }
  if (length > 0) {
    return data.subarray(front, front + length);
  }
  return undefined;
};
const readSize = (data, offset) => {
  let size = 0;
  size = (data[offset] & 0x7f) << 21;
  size |= (data[offset + 1] & 0x7f) << 14;
  size |= (data[offset + 2] & 0x7f) << 7;
  size |= data[offset + 3] & 0x7f;
  return size;
};
const canParse$2 = (data, offset) => {
  return isHeader$2(data, offset) && readSize(data, offset + 6) + 10 <= data.length - offset;
};

/**
 * Searches for the Elementary Stream timestamp found in the ID3 data chunk
 * @param data - Block of data containing one or more ID3 tags
 */
const getTimeStamp = data => {
  const frames = getID3Frames(data);
  for (let i = 0; i < frames.length; i++) {
    const frame = frames[i];
    if (isTimeStampFrame(frame)) {
      return readTimeStamp(frame);
    }
  }
  return undefined;
};

/**
 * Returns true if the ID3 frame is an Elementary Stream timestamp frame
 */
const isTimeStampFrame = frame => {
  return frame && frame.key === 'PRIV' && frame.info === 'com.apple.streaming.transportStreamTimestamp';
};
const getFrameData = data => {
  /*
  Frame ID       $xx xx xx xx (four characters)
  Size           $xx xx xx xx
  Flags          $xx xx
  */
  const type = String.fromCharCode(data[0], data[1], data[2], data[3]);
  const size = readSize(data, 4);

  // skip frame id, size, and flags
  const offset = 10;
  return {
    type,
    size,
    data: data.subarray(offset, offset + size)
  };
};

/**
 * Returns an array of ID3 frames found in all the ID3 tags in the id3Data
 * @param id3Data - The ID3 data containing one or more ID3 tags
 */
const getID3Frames = id3Data => {
  let offset = 0;
  const frames = [];
  while (isHeader$2(id3Data, offset)) {
    const size = readSize(id3Data, offset + 6);
    // skip past ID3 header
    offset += 10;
    const end = offset + size;
    // loop through frames in the ID3 tag
    while (offset + 8 < end) {
      const frameData = getFrameData(id3Data.subarray(offset));
      const frame = decodeFrame(frameData);
      if (frame) {
        frames.push(frame);
      }

      // skip frame header and frame data
      offset += frameData.size + 10;
    }
    if (isFooter(id3Data, offset)) {
      offset += 10;
    }
  }
  return frames;
};
const decodeFrame = frame => {
  if (frame.type === 'PRIV') {
    return decodePrivFrame(frame);
  } else if (frame.type[0] === 'W') {
    return decodeURLFrame(frame);
  }
  return decodeTextFrame(frame);
};
const decodePrivFrame = frame => {
  /*
  Format: <text string>\0<binary data>
  */
  if (frame.size < 2) {
    return undefined;
  }
  const owner = utf8ArrayToStr(frame.data, true);
  const privateData = new Uint8Array(frame.data.subarray(owner.length + 1));
  return {
    key: frame.type,
    info: owner,
    data: privateData.buffer
  };
};
const decodeTextFrame = frame => {
  if (frame.size < 2) {
    return undefined;
  }
  if (frame.type === 'TXXX') {
    /*
    Format:
    [0]   = {Text Encoding}
    [1-?] = {Description}\0{Value}
    */
    let index = 1;
    const description = utf8ArrayToStr(frame.data.subarray(index), true);
    index += description.length + 1;
    const value = utf8ArrayToStr(frame.data.subarray(index));
    return {
      key: frame.type,
      info: description,
      data: value
    };
  }
  /*
  Format:
  [0]   = {Text Encoding}
  [1-?] = {Value}
  */
  const text = utf8ArrayToStr(frame.data.subarray(1));
  return {
    key: frame.type,
    data: text
  };
};
const decodeURLFrame = frame => {
  if (frame.type === 'WXXX') {
    /*
    Format:
    [0]   = {Text Encoding}
    [1-?] = {Description}\0{URL}
    */
    if (frame.size < 2) {
      return undefined;
    }
    let index = 1;
    const description = utf8ArrayToStr(frame.data.subarray(index), true);
    index += description.length + 1;
    const value = utf8ArrayToStr(frame.data.subarray(index));
    return {
      key: frame.type,
      info: description,
      data: value
    };
  }
  /*
  Format:
  [0-?] = {URL}
  */
  const url = utf8ArrayToStr(frame.data);
  return {
    key: frame.type,
    data: url
  };
};
const readTimeStamp = timeStampFrame => {
  if (timeStampFrame.data.byteLength === 8) {
    const data = new Uint8Array(timeStampFrame.data);
    // timestamp is 33 bit expressed as a big-endian eight-octet number,
    // with the upper 31 bits set to zero.
    const pts33Bit = data[3] & 0x1;
    let timestamp = (data[4] << 23) + (data[5] << 15) + (data[6] << 7) + data[7];
    timestamp /= 45;
    if (pts33Bit) {
      timestamp += 47721858.84;
    } // 2^32 / 90

    return Math.round(timestamp);
  }
  return undefined;
};

// http://stackoverflow.com/questions/8936984/uint8array-to-string-in-javascript/22373197
// http://www.onicos.com/staff/iz/amuse/javascript/expert/utf.txt
/* utf.js - UTF-8 <=> UTF-16 convertion
 *
 * Copyright (C) 1999 Masanao Izumo <iz@onicos.co.jp>
 * Version: 1.0
 * LastModified: Dec 25 1999
 * This library is free.  You can redistribute it and/or modify it.
 */
const utf8ArrayToStr = (array, exitOnNull = false) => {
  const decoder = getTextDecoder();
  if (decoder) {
    const decoded = decoder.decode(array);
    if (exitOnNull) {
      // grab up to the first null
      const idx = decoded.indexOf('\0');
      return idx !== -1 ? decoded.substring(0, idx) : decoded;
    }

    // remove any null characters
    return decoded.replace(/\0/g, '');
  }
  const len = array.length;
  let c;
  let char2;
  let char3;
  let out = '';
  let i = 0;
  while (i < len) {
    c = array[i++];
    if (c === 0x00 && exitOnNull) {
      return out;
    } else if (c === 0x00 || c === 0x03) {
      // If the character is 3 (END_OF_TEXT) or 0 (NULL) then skip it
      continue;
    }
    switch (c >> 4) {
      case 0:
      case 1:
      case 2:
      case 3:
      case 4:
      case 5:
      case 6:
      case 7:
        // 0xxxxxxx
        out += String.fromCharCode(c);
        break;
      case 12:
      case 13:
        // 110x xxxx   10xx xxxx
        char2 = array[i++];
        out += String.fromCharCode((c & 0x1f) << 6 | char2 & 0x3f);
        break;
      case 14:
        // 1110 xxxx  10xx xxxx  10xx xxxx
        char2 = array[i++];
        char3 = array[i++];
        out += String.fromCharCode((c & 0x0f) << 12 | (char2 & 0x3f) << 6 | (char3 & 0x3f) << 0);
        break;
    }
  }
  return out;
};
let decoder;
function getTextDecoder() {
  // On Play Station 4, TextDecoder is defined but partially implemented.
  // Manual decoding option is preferable
  if (navigator.userAgent.includes('PlayStation 4')) {
    return;
  }
  if (!decoder && typeof self.TextDecoder !== 'undefined') {
    decoder = new self.TextDecoder('utf-8');
  }
  return decoder;
}

/**
 *  hex dump helper class
 */

const Hex = {
  hexDump: function (array) {
    let str = '';
    for (let i = 0; i < array.length; i++) {
      let h = array[i].toString(16);
      if (h.length < 2) {
        h = '0' + h;
      }
      str += h;
    }
    return str;
  }
};

const UINT32_MAX$1 = Math.pow(2, 32) - 1;
const push = [].push;

// We are using fixed track IDs for driving the MP4 remuxer
// instead of following the TS PIDs.
// There is no reason not to do this and some browsers/SourceBuffer-demuxers
// may not like if there are TrackID "switches"
// See https://github.com/video-dev/hls.js/issues/1331
// Here we are mapping our internal track types to constant MP4 track IDs
// With MSE currently one can only have one track of each, and we are muxing
// whatever video/audio rendition in them.
const RemuxerTrackIdConfig = {
  video: 1,
  audio: 2,
  id3: 3,
  text: 4
};
function bin2str(data) {
  return String.fromCharCode.apply(null, data);
}
function readUint16(buffer, offset) {
  const val = buffer[offset] << 8 | buffer[offset + 1];
  return val < 0 ? 65536 + val : val;
}
function readUint32(buffer, offset) {
  const val = readSint32(buffer, offset);
  return val < 0 ? 4294967296 + val : val;
}
function readUint64(buffer, offset) {
  let result = readUint32(buffer, offset);
  result *= Math.pow(2, 32);
  result += readUint32(buffer, offset + 4);
  return result;
}
function readSint32(buffer, offset) {
  return buffer[offset] << 24 | buffer[offset + 1] << 16 | buffer[offset + 2] << 8 | buffer[offset + 3];
}
function writeUint32(buffer, offset, value) {
  buffer[offset] = value >> 24;
  buffer[offset + 1] = value >> 16 & 0xff;
  buffer[offset + 2] = value >> 8 & 0xff;
  buffer[offset + 3] = value & 0xff;
}

// Find "moof" box
function hasMoofData(data) {
  const end = data.byteLength;
  for (let i = 0; i < end;) {
    const size = readUint32(data, i);
    if (size > 8 && data[i + 4] === 0x6d && data[i + 5] === 0x6f && data[i + 6] === 0x6f && data[i + 7] === 0x66) {
      return true;
    }
    i = size > 1 ? i + size : end;
  }
  return false;
}

// Find the data for a box specified by its path
function findBox(data, path) {
  const results = [];
  if (!path.length) {
    // short-circuit the search for empty paths
    return results;
  }
  const end = data.byteLength;
  for (let i = 0; i < end;) {
    const size = readUint32(data, i);
    const type = bin2str(data.subarray(i + 4, i + 8));
    const endbox = size > 1 ? i + size : end;
    if (type === path[0]) {
      if (path.length === 1) {
        // this is the end of the path and we've found the box we were
        // looking for
        results.push(data.subarray(i + 8, endbox));
      } else {
        // recursively search for the next box along the path
        const subresults = findBox(data.subarray(i + 8, endbox), path.slice(1));
        if (subresults.length) {
          push.apply(results, subresults);
        }
      }
    }
    i = endbox;
  }

  // we've finished searching all of data
  return results;
}
function parseSegmentIndex(sidx) {
  const references = [];
  const version = sidx[0];

  // set initial offset, we skip the reference ID (not needed)
  let index = 8;
  const timescale = readUint32(sidx, index);
  index += 4;
  let earliestPresentationTime = 0;
  let firstOffset = 0;
  if (version === 0) {
    earliestPresentationTime = readUint32(sidx, index);
    firstOffset = readUint32(sidx, index + 4);
    index += 8;
  } else {
    earliestPresentationTime = readUint64(sidx, index);
    firstOffset = readUint64(sidx, index + 8);
    index += 16;
  }

  // skip reserved
  index += 2;
  let startByte = sidx.length + firstOffset;
  const referencesCount = readUint16(sidx, index);
  index += 2;
  for (let i = 0; i < referencesCount; i++) {
    let referenceIndex = index;
    const referenceInfo = readUint32(sidx, referenceIndex);
    referenceIndex += 4;
    const referenceSize = referenceInfo & 0x7fffffff;
    const referenceType = (referenceInfo & 0x80000000) >>> 31;
    if (referenceType === 1) {
      logger.warn('SIDX has hierarchical references (not supported)');
      return null;
    }
    const subsegmentDuration = readUint32(sidx, referenceIndex);
    referenceIndex += 4;
    references.push({
      referenceSize,
      subsegmentDuration,
      // unscaled
      info: {
        duration: subsegmentDuration / timescale,
        start: startByte,
        end: startByte + referenceSize - 1
      }
    });
    startByte += referenceSize;

    // Skipping 1 bit for |startsWithSap|, 3 bits for |sapType|, and 28 bits
    // for |sapDelta|.
    referenceIndex += 4;

    // skip to next ref
    index = referenceIndex;
  }
  return {
    earliestPresentationTime,
    timescale,
    version,
    referencesCount,
    references
  };
}

/**
 * Parses an MP4 initialization segment and extracts stream type and
 * timescale values for any declared tracks. Timescale values indicate the
 * number of clock ticks per second to assume for time-based values
 * elsewhere in the MP4.
 *
 * To determine the start time of an MP4, you need two pieces of
 * information: the timescale unit and the earliest base media decode
 * time. Multiple timescales can be specified within an MP4 but the
 * base media decode time is always expressed in the timescale from
 * the media header box for the track:
 * ```
 * moov > trak > mdia > mdhd.timescale
 * moov > trak > mdia > hdlr
 * ```
 * @param initSegment the bytes of the init segment
 * @returns a hash of track type to timescale values or null if
 * the init segment is malformed.
 */

function parseInitSegment(initSegment) {
  const result = [];
  const traks = findBox(initSegment, ['moov', 'trak']);
  for (let i = 0; i < traks.length; i++) {
    const trak = traks[i];
    const tkhd = findBox(trak, ['tkhd'])[0];
    if (tkhd) {
      let version = tkhd[0];
      const trackId = readUint32(tkhd, version === 0 ? 12 : 20);
      const mdhd = findBox(trak, ['mdia', 'mdhd'])[0];
      if (mdhd) {
        version = mdhd[0];
        const timescale = readUint32(mdhd, version === 0 ? 12 : 20);
        const hdlr = findBox(trak, ['mdia', 'hdlr'])[0];
        if (hdlr) {
          const hdlrType = bin2str(hdlr.subarray(8, 12));
          const type = {
            soun: ElementaryStreamTypes.AUDIO,
            vide: ElementaryStreamTypes.VIDEO
          }[hdlrType];
          if (type) {
            // Parse codec details
            const stsd = findBox(trak, ['mdia', 'minf', 'stbl', 'stsd'])[0];
            const stsdData = parseStsd(stsd);
            result[trackId] = {
              timescale,
              type
            };
            result[type] = _objectSpread2({
              timescale,
              id: trackId
            }, stsdData);
          }
        }
      }
    }
  }
  const trex = findBox(initSegment, ['moov', 'mvex', 'trex']);
  trex.forEach(trex => {
    const trackId = readUint32(trex, 4);
    const track = result[trackId];
    if (track) {
      track.default = {
        duration: readUint32(trex, 12),
        flags: readUint32(trex, 20)
      };
    }
  });
  return result;
}
function parseStsd(stsd) {
  const sampleEntries = stsd.subarray(8);
  const sampleEntriesEnd = sampleEntries.subarray(8 + 78);
  const fourCC = bin2str(sampleEntries.subarray(4, 8));
  let codec = fourCC;
  const encrypted = fourCC === 'enca' || fourCC === 'encv';
  if (encrypted) {
    const encBox = findBox(sampleEntries, [fourCC])[0];
    const encBoxChildren = encBox.subarray(fourCC === 'enca' ? 28 : 78);
    const sinfs = findBox(encBoxChildren, ['sinf']);
    sinfs.forEach(sinf => {
      const schm = findBox(sinf, ['schm'])[0];
      if (schm) {
        const scheme = bin2str(schm.subarray(4, 8));
        if (scheme === 'cbcs' || scheme === 'cenc') {
          const frma = findBox(sinf, ['frma'])[0];
          if (frma) {
            // for encrypted content codec fourCC will be in frma
            codec = bin2str(frma);
          }
        }
      }
    });
  }
  switch (codec) {
    case 'avc1':
    case 'avc2':
    case 'avc3':
    case 'avc4':
      {
        // extract profile + compatibility + level out of avcC box
        const avcCBox = findBox(sampleEntriesEnd, ['avcC'])[0];
        codec += '.' + toHex(avcCBox[1]) + toHex(avcCBox[2]) + toHex(avcCBox[3]);
        break;
      }
    case 'mp4a':
      {
        const codecBox = findBox(sampleEntries, [fourCC])[0];
        const esdsBox = findBox(codecBox.subarray(28), ['esds'])[0];
        if (esdsBox && esdsBox.length > 12) {
          let i = 4;
          // ES Descriptor tag
          if (esdsBox[i++] !== 0x03) {
            break;
          }
          i = skipBERInteger(esdsBox, i);
          i += 2; // skip es_id;
          const flags = esdsBox[i++];
          if (flags & 0x80) {
            i += 2; // skip dependency es_id
          }
          if (flags & 0x40) {
            i += esdsBox[i++]; // skip URL
          }
          // Decoder config descriptor
          if (esdsBox[i++] !== 0x04) {
            break;
          }
          i = skipBERInteger(esdsBox, i);
          const objectType = esdsBox[i++];
          if (objectType === 0x40) {
            codec += '.' + toHex(objectType);
          } else {
            break;
          }
          i += 12;
          // Decoder specific info
          if (esdsBox[i++] !== 0x05) {
            break;
          }
          i = skipBERInteger(esdsBox, i);
          const firstByte = esdsBox[i++];
          let audioObjectType = (firstByte & 0xf8) >> 3;
          if (audioObjectType === 31) {
            audioObjectType += 1 + ((firstByte & 0x7) << 3) + ((esdsBox[i] & 0xe0) >> 5);
          }
          codec += '.' + audioObjectType;
        }
        break;
      }
    case 'hvc1':
    case 'hev1':
      {
        const hvcCBox = findBox(sampleEntriesEnd, ['hvcC'])[0];
        const profileByte = hvcCBox[1];
        const profileSpace = ['', 'A', 'B', 'C'][profileByte >> 6];
        const generalProfileIdc = profileByte & 0x1f;
        const profileCompat = readUint32(hvcCBox, 2);
        const tierFlag = (profileByte & 0x20) >> 5 ? 'H' : 'L';
        const levelIDC = hvcCBox[12];
        const constraintIndicator = hvcCBox.subarray(6, 12);
        codec += '.' + profileSpace + generalProfileIdc;
        codec += '.' + profileCompat.toString(16).toUpperCase();
        codec += '.' + tierFlag + levelIDC;
        let constraintString = '';
        for (let i = constraintIndicator.length; i--;) {
          const byte = constraintIndicator[i];
          if (byte || constraintString) {
            const encodedByte = byte.toString(16).toUpperCase();
            constraintString = '.' + encodedByte + constraintString;
          }
        }
        codec += constraintString;
        break;
      }
    case 'dvh1':
    case 'dvhe':
      {
        const dvcCBox = findBox(sampleEntriesEnd, ['dvcC'])[0];
        const profile = dvcCBox[2] >> 1 & 0x7f;
        const level = dvcCBox[2] << 5 & 0x20 | dvcCBox[3] >> 3 & 0x1f;
        codec += '.' + addLeadingZero(profile) + '.' + addLeadingZero(level);
        break;
      }
    case 'vp09':
      {
        const vpcCBox = findBox(sampleEntriesEnd, ['vpcC'])[0];
        const profile = vpcCBox[4];
        const level = vpcCBox[5];
        const bitDepth = vpcCBox[6] >> 4 & 0x0f;
        codec += '.' + addLeadingZero(profile) + '.' + addLeadingZero(level) + '.' + addLeadingZero(bitDepth);
        break;
      }
    case 'av01':
      {
        const av1CBox = findBox(sampleEntriesEnd, ['av1C'])[0];
        const profile = av1CBox[1] >>> 5;
        const level = av1CBox[1] & 0x1f;
        const tierFlag = av1CBox[2] >>> 7 ? 'H' : 'M';
        const highBitDepth = (av1CBox[2] & 0x40) >> 6;
        const twelveBit = (av1CBox[2] & 0x20) >> 5;
        const bitDepth = profile === 2 && highBitDepth ? twelveBit ? 12 : 10 : highBitDepth ? 10 : 8;
        const monochrome = (av1CBox[2] & 0x10) >> 4;
        const chromaSubsamplingX = (av1CBox[2] & 0x08) >> 3;
        const chromaSubsamplingY = (av1CBox[2] & 0x04) >> 2;
        const chromaSamplePosition = av1CBox[2] & 0x03;
        // TODO: parse color_description_present_flag
        // default it to BT.709/limited range for now
        // more info https://aomediacodec.github.io/av1-isobmff/#av1codecconfigurationbox-syntax
        const colorPrimaries = 1;
        const transferCharacteristics = 1;
        const matrixCoefficients = 1;
        const videoFullRangeFlag = 0;
        codec += '.' + profile + '.' + addLeadingZero(level) + tierFlag + '.' + addLeadingZero(bitDepth) + '.' + monochrome + '.' + chromaSubsamplingX + chromaSubsamplingY + chromaSamplePosition + '.' + addLeadingZero(colorPrimaries) + '.' + addLeadingZero(transferCharacteristics) + '.' + addLeadingZero(matrixCoefficients) + '.' + videoFullRangeFlag;
        break;
      }
  }
  return {
    codec,
    encrypted
  };
}
function skipBERInteger(bytes, i) {
  const limit = i + 5;
  while (bytes[i++] & 0x80 && i < limit) {}
  return i;
}
function toHex(x) {
  return ('0' + x.toString(16).toUpperCase()).slice(-2);
}
function addLeadingZero(num) {
  return (num < 10 ? '0' : '') + num;
}
function patchEncyptionData(initSegment, decryptdata) {
  if (!initSegment || !decryptdata) {
    return initSegment;
  }
  const keyId = decryptdata.keyId;
  if (keyId && decryptdata.isCommonEncryption) {
    const traks = findBox(initSegment, ['moov', 'trak']);
    traks.forEach(trak => {
      const stsd = findBox(trak, ['mdia', 'minf', 'stbl', 'stsd'])[0];

      // skip the sample entry count
      const sampleEntries = stsd.subarray(8);
      let encBoxes = findBox(sampleEntries, ['enca']);
      const isAudio = encBoxes.length > 0;
      if (!isAudio) {
        encBoxes = findBox(sampleEntries, ['encv']);
      }
      encBoxes.forEach(enc => {
        const encBoxChildren = isAudio ? enc.subarray(28) : enc.subarray(78);
        const sinfBoxes = findBox(encBoxChildren, ['sinf']);
        sinfBoxes.forEach(sinf => {
          const tenc = parseSinf(sinf);
          if (tenc) {
            // Look for default key id (keyID offset is always 8 within the tenc box):
            const tencKeyId = tenc.subarray(8, 24);
            if (!tencKeyId.some(b => b !== 0)) {
              logger.log(`[eme] Patching keyId in 'enc${isAudio ? 'a' : 'v'}>sinf>>tenc' box: ${Hex.hexDump(tencKeyId)} -> ${Hex.hexDump(keyId)}`);
              tenc.set(keyId, 8);
            }
          }
        });
      });
    });
  }
  return initSegment;
}
function parseSinf(sinf) {
  const schm = findBox(sinf, ['schm'])[0];
  if (schm) {
    const scheme = bin2str(schm.subarray(4, 8));
    if (scheme === 'cbcs' || scheme === 'cenc') {
      return findBox(sinf, ['schi', 'tenc'])[0];
    }
  }
  logger.error(`[eme] missing 'schm' box`);
  return null;
}

/**
 * Determine the base media decode start time, in seconds, for an MP4
 * fragment. If multiple fragments are specified, the earliest time is
 * returned.
 *
 * The base media decode time can be parsed from track fragment
 * metadata:
 * ```
 * moof > traf > tfdt.baseMediaDecodeTime
 * ```
 * It requires the timescale value from the mdhd to interpret.
 *
 * @param initData - a hash of track type to timescale values
 * @param fmp4 - the bytes of the mp4 fragment
 * @returns the earliest base media decode start time for the
 * fragment, in seconds
 */
function getStartDTS(initData, fmp4) {
  // we need info from two children of each track fragment box
  return findBox(fmp4, ['moof', 'traf']).reduce((result, traf) => {
    const tfdt = findBox(traf, ['tfdt'])[0];
    const version = tfdt[0];
    const start = findBox(traf, ['tfhd']).reduce((result, tfhd) => {
      // get the track id from the tfhd
      const id = readUint32(tfhd, 4);
      const track = initData[id];
      if (track) {
        let baseTime = readUint32(tfdt, 4);
        if (version === 1) {
          // If value is too large, assume signed 64-bit. Negative track fragment decode times are invalid, but they exist in the wild.
          // This prevents large values from being used for initPTS, which can cause playlist sync issues.
          // https://github.com/video-dev/hls.js/issues/5303
          if (baseTime === UINT32_MAX$1) {
            logger.warn(`[mp4-demuxer]: Ignoring assumed invalid signed 64-bit track fragment decode time`);
            return result;
          }
          baseTime *= UINT32_MAX$1 + 1;
          baseTime += readUint32(tfdt, 8);
        }
        // assume a 90kHz clock if no timescale was specified
        const scale = track.timescale || 90e3;
        // convert base time to seconds
        const startTime = baseTime / scale;
        if (isFiniteNumber(startTime) && (result === null || startTime < result)) {
          return startTime;
        }
      }
      return result;
    }, null);
    if (start !== null && isFiniteNumber(start) && (result === null || start < result)) {
      return start;
    }
    return result;
  }, null);
}

/*
  For Reference:
  aligned(8) class TrackFragmentHeaderBox
           extends FullBox(‘tfhd’, 0, tf_flags){
     unsigned int(32)  track_ID;
     // all the following are optional fields
     unsigned int(64)  base_data_offset;
     unsigned int(32)  sample_description_index;
     unsigned int(32)  default_sample_duration;
     unsigned int(32)  default_sample_size;
     unsigned int(32)  default_sample_flags
  }
 */
function getDuration(data, initData) {
  let rawDuration = 0;
  let videoDuration = 0;
  let audioDuration = 0;
  const trafs = findBox(data, ['moof', 'traf']);
  for (let i = 0; i < trafs.length; i++) {
    const traf = trafs[i];
    // There is only one tfhd & trun per traf
    // This is true for CMAF style content, and we should perhaps check the ftyp
    // and only look for a single trun then, but for ISOBMFF we should check
    // for multiple track runs.
    const tfhd = findBox(traf, ['tfhd'])[0];
    // get the track id from the tfhd
    const id = readUint32(tfhd, 4);
    const track = initData[id];
    if (!track) {
      continue;
    }
    const trackDefault = track.default;
    const tfhdFlags = readUint32(tfhd, 0) | (trackDefault == null ? void 0 : trackDefault.flags);
    let sampleDuration = trackDefault == null ? void 0 : trackDefault.duration;
    if (tfhdFlags & 0x000008) {
      // 0x000008 indicates the presence of the default_sample_duration field
      if (tfhdFlags & 0x000002) {
        // 0x000002 indicates the presence of the sample_description_index field, which precedes default_sample_duration
        // If present, the default_sample_duration exists at byte offset 12
        sampleDuration = readUint32(tfhd, 12);
      } else {
        // Otherwise, the duration is at byte offset 8
        sampleDuration = readUint32(tfhd, 8);
      }
    }
    // assume a 90kHz clock if no timescale was specified
    const timescale = track.timescale || 90e3;
    const truns = findBox(traf, ['trun']);
    for (let j = 0; j < truns.length; j++) {
      rawDuration = computeRawDurationFromSamples(truns[j]);
      if (!rawDuration && sampleDuration) {
        const sampleCount = readUint32(truns[j], 4);
        rawDuration = sampleDuration * sampleCount;
      }
      if (track.type === ElementaryStreamTypes.VIDEO) {
        videoDuration += rawDuration / timescale;
      } else if (track.type === ElementaryStreamTypes.AUDIO) {
        audioDuration += rawDuration / timescale;
      }
    }
  }
  if (videoDuration === 0 && audioDuration === 0) {
    // If duration samples are not available in the traf use sidx subsegment_duration
    let sidxMinStart = Infinity;
    let sidxMaxEnd = 0;
    let sidxDuration = 0;
    const sidxs = findBox(data, ['sidx']);
    for (let i = 0; i < sidxs.length; i++) {
      const sidx = parseSegmentIndex(sidxs[i]);
      if (sidx != null && sidx.references) {
        sidxMinStart = Math.min(sidxMinStart, sidx.earliestPresentationTime / sidx.timescale);
        const subSegmentDuration = sidx.references.reduce((dur, ref) => dur + ref.info.duration || 0, 0);
        sidxMaxEnd = Math.max(sidxMaxEnd, subSegmentDuration + sidx.earliestPresentationTime / sidx.timescale);
        sidxDuration = sidxMaxEnd - sidxMinStart;
      }
    }
    if (sidxDuration && isFiniteNumber(sidxDuration)) {
      return sidxDuration;
    }
  }
  if (videoDuration) {
    return videoDuration;
  }
  return audioDuration;
}

/*
  For Reference:
  aligned(8) class TrackRunBox
           extends FullBox(‘trun’, version, tr_flags) {
     unsigned int(32)  sample_count;
     // the following are optional fields
     signed int(32) data_offset;
     unsigned int(32)  first_sample_flags;
     // all fields in the following array are optional
     {
        unsigned int(32)  sample_duration;
        unsigned int(32)  sample_size;
        unsigned int(32)  sample_flags
        if (version == 0)
           { unsigned int(32)
        else
           { signed int(32)
     }[ sample_count ]
  }
 */
function computeRawDurationFromSamples(trun) {
  const flags = readUint32(trun, 0);
  // Flags are at offset 0, non-optional sample_count is at offset 4. Therefore we start 8 bytes in.
  // Each field is an int32, which is 4 bytes
  let offset = 8;
  // data-offset-present flag
  if (flags & 0x000001) {
    offset += 4;
  }
  // first-sample-flags-present flag
  if (flags & 0x000004) {
    offset += 4;
  }
  let duration = 0;
  const sampleCount = readUint32(trun, 4);
  for (let i = 0; i < sampleCount; i++) {
    // sample-duration-present flag
    if (flags & 0x000100) {
      const sampleDuration = readUint32(trun, offset);
      duration += sampleDuration;
      offset += 4;
    }
    // sample-size-present flag
    if (flags & 0x000200) {
      offset += 4;
    }
    // sample-flags-present flag
    if (flags & 0x000400) {
      offset += 4;
    }
    // sample-composition-time-offsets-present flag
    if (flags & 0x000800) {
      offset += 4;
    }
  }
  return duration;
}
function offsetStartDTS(initData, fmp4, timeOffset) {
  findBox(fmp4, ['moof', 'traf']).forEach(traf => {
    findBox(traf, ['tfhd']).forEach(tfhd => {
      // get the track id from the tfhd
      const id = readUint32(tfhd, 4);
      const track = initData[id];
      if (!track) {
        return;
      }
      // assume a 90kHz clock if no timescale was specified
      const timescale = track.timescale || 90e3;
      // get the base media decode time from the tfdt
      findBox(traf, ['tfdt']).forEach(tfdt => {
        const version = tfdt[0];
        const offset = timeOffset * timescale;
        if (offset) {
          let baseMediaDecodeTime = readUint32(tfdt, 4);
          if (version === 0) {
            baseMediaDecodeTime -= offset;
            baseMediaDecodeTime = Math.max(baseMediaDecodeTime, 0);
            writeUint32(tfdt, 4, baseMediaDecodeTime);
          } else {
            baseMediaDecodeTime *= Math.pow(2, 32);
            baseMediaDecodeTime += readUint32(tfdt, 8);
            baseMediaDecodeTime -= offset;
            baseMediaDecodeTime = Math.max(baseMediaDecodeTime, 0);
            const upper = Math.floor(baseMediaDecodeTime / (UINT32_MAX$1 + 1));
            const lower = Math.floor(baseMediaDecodeTime % (UINT32_MAX$1 + 1));
            writeUint32(tfdt, 4, upper);
            writeUint32(tfdt, 8, lower);
          }
        }
      });
    });
  });
}

// TODO: Check if the last moof+mdat pair is part of the valid range
function segmentValidRange(data) {
  const segmentedRange = {
    valid: null,
    remainder: null
  };
  const moofs = findBox(data, ['moof']);
  if (moofs.length < 2) {
    segmentedRange.remainder = data;
    return segmentedRange;
  }
  const last = moofs[moofs.length - 1];
  // Offset by 8 bytes; findBox offsets the start by as much
  segmentedRange.valid = sliceUint8(data, 0, last.byteOffset - 8);
  segmentedRange.remainder = sliceUint8(data, last.byteOffset - 8);
  return segmentedRange;
}
function appendUint8Array(data1, data2) {
  const temp = new Uint8Array(data1.length + data2.length);
  temp.set(data1);
  temp.set(data2, data1.length);
  return temp;
}
function parseSamples(timeOffset, track) {
  const seiSamples = [];
  const videoData = track.samples;
  const timescale = track.timescale;
  const trackId = track.id;
  let isHEVCFlavor = false;
  const moofs = findBox(videoData, ['moof']);
  moofs.map(moof => {
    const moofOffset = moof.byteOffset - 8;
    const trafs = findBox(moof, ['traf']);
    trafs.map(traf => {
      // get the base media decode time from the tfdt
      const baseTime = findBox(traf, ['tfdt']).map(tfdt => {
        const version = tfdt[0];
        let result = readUint32(tfdt, 4);
        if (version === 1) {
          result *= Math.pow(2, 32);
          result += readUint32(tfdt, 8);
        }
        return result / timescale;
      })[0];
      if (baseTime !== undefined) {
        timeOffset = baseTime;
      }
      return findBox(traf, ['tfhd']).map(tfhd => {
        const id = readUint32(tfhd, 4);
        const tfhdFlags = readUint32(tfhd, 0) & 0xffffff;
        const baseDataOffsetPresent = (tfhdFlags & 0x000001) !== 0;
        const sampleDescriptionIndexPresent = (tfhdFlags & 0x000002) !== 0;
        const defaultSampleDurationPresent = (tfhdFlags & 0x000008) !== 0;
        let defaultSampleDuration = 0;
        const defaultSampleSizePresent = (tfhdFlags & 0x000010) !== 0;
        let defaultSampleSize = 0;
        const defaultSampleFlagsPresent = (tfhdFlags & 0x000020) !== 0;
        let tfhdOffset = 8;
        if (id === trackId) {
          if (baseDataOffsetPresent) {
            tfhdOffset += 8;
          }
          if (sampleDescriptionIndexPresent) {
            tfhdOffset += 4;
          }
          if (defaultSampleDurationPresent) {
            defaultSampleDuration = readUint32(tfhd, tfhdOffset);
            tfhdOffset += 4;
          }
          if (defaultSampleSizePresent) {
            defaultSampleSize = readUint32(tfhd, tfhdOffset);
            tfhdOffset += 4;
          }
          if (defaultSampleFlagsPresent) {
            tfhdOffset += 4;
          }
          if (track.type === 'video') {
            isHEVCFlavor = isHEVC(track.codec);
          }
          findBox(traf, ['trun']).map(trun => {
            const version = trun[0];
            const flags = readUint32(trun, 0) & 0xffffff;
            const dataOffsetPresent = (flags & 0x000001) !== 0;
            let dataOffset = 0;
            const firstSampleFlagsPresent = (flags & 0x000004) !== 0;
            const sampleDurationPresent = (flags & 0x000100) !== 0;
            let sampleDuration = 0;
            const sampleSizePresent = (flags & 0x000200) !== 0;
            let sampleSize = 0;
            const sampleFlagsPresent = (flags & 0x000400) !== 0;
            const sampleCompositionOffsetsPresent = (flags & 0x000800) !== 0;
            let compositionOffset = 0;
            const sampleCount = readUint32(trun, 4);
            let trunOffset = 8; // past version, flags, and sample count

            if (dataOffsetPresent) {
              dataOffset = readUint32(trun, trunOffset);
              trunOffset += 4;
            }
            if (firstSampleFlagsPresent) {
              trunOffset += 4;
            }
            let sampleOffset = dataOffset + moofOffset;
            for (let ix = 0; ix < sampleCount; ix++) {
              if (sampleDurationPresent) {
                sampleDuration = readUint32(trun, trunOffset);
                trunOffset += 4;
              } else {
                sampleDuration = defaultSampleDuration;
              }
              if (sampleSizePresent) {
                sampleSize = readUint32(trun, trunOffset);
                trunOffset += 4;
              } else {
                sampleSize = defaultSampleSize;
              }
              if (sampleFlagsPresent) {
                trunOffset += 4;
              }
              if (sampleCompositionOffsetsPresent) {
                if (version === 0) {
                  compositionOffset = readUint32(trun, trunOffset);
                } else {
                  compositionOffset = readSint32(trun, trunOffset);
                }
                trunOffset += 4;
              }
              if (track.type === ElementaryStreamTypes.VIDEO) {
                let naluTotalSize = 0;
                while (naluTotalSize < sampleSize) {
                  const naluSize = readUint32(videoData, sampleOffset);
                  sampleOffset += 4;
                  if (isSEIMessage(isHEVCFlavor, videoData[sampleOffset])) {
                    const data = videoData.subarray(sampleOffset, sampleOffset + naluSize);
                    parseSEIMessageFromNALu(data, isHEVCFlavor ? 2 : 1, timeOffset + compositionOffset / timescale, seiSamples);
                  }
                  sampleOffset += naluSize;
                  naluTotalSize += naluSize + 4;
                }
              }
              timeOffset += sampleDuration / timescale;
            }
          });
        }
      });
    });
  });
  return seiSamples;
}
function isHEVC(codec) {
  if (!codec) {
    return false;
  }
  const delimit = codec.indexOf('.');
  const baseCodec = delimit < 0 ? codec : codec.substring(0, delimit);
  return baseCodec === 'hvc1' || baseCodec === 'hev1' ||
  // Dolby Vision
  baseCodec === 'dvh1' || baseCodec === 'dvhe';
}
function isSEIMessage(isHEVCFlavor, naluHeader) {
  if (isHEVCFlavor) {
    const naluType = naluHeader >> 1 & 0x3f;
    return naluType === 39 || naluType === 40;
  } else {
    const naluType = naluHeader & 0x1f;
    return naluType === 6;
  }
}
function parseSEIMessageFromNALu(unescapedData, headerSize, pts, samples) {
  const data = discardEPB(unescapedData);
  let seiPtr = 0;
  // skip nal header
  seiPtr += headerSize;
  let payloadType = 0;
  let payloadSize = 0;
  let b = 0;
  while (seiPtr < data.length) {
    payloadType = 0;
    do {
      if (seiPtr >= data.length) {
        break;
      }
      b = data[seiPtr++];
      payloadType += b;
    } while (b === 0xff);

    // Parse payload size.
    payloadSize = 0;
    do {
      if (seiPtr >= data.length) {
        break;
      }
      b = data[seiPtr++];
      payloadSize += b;
    } while (b === 0xff);
    const leftOver = data.length - seiPtr;
    // Create a variable to process the payload
    let payPtr = seiPtr;

    // Increment the seiPtr to the end of the payload
    if (payloadSize < leftOver) {
      seiPtr += payloadSize;
    } else if (payloadSize > leftOver) {
      // Some type of corruption has happened?
      logger.error(`Malformed SEI payload. ${payloadSize} is too small, only ${leftOver} bytes left to parse.`);
      // We might be able to parse some data, but let's be safe and ignore it.
      break;
    }
    if (payloadType === 4) {
      const countryCode = data[payPtr++];
      if (countryCode === 181) {
        const providerCode = readUint16(data, payPtr);
        payPtr += 2;
        if (providerCode === 49) {
          const userStructure = readUint32(data, payPtr);
          payPtr += 4;
          if (userStructure === 0x47413934) {
            const userDataType = data[payPtr++];

            // Raw CEA-608 bytes wrapped in CEA-708 packet
            if (userDataType === 3) {
              const firstByte = data[payPtr++];
              const totalCCs = 0x1f & firstByte;
              const enabled = 0x40 & firstByte;
              const totalBytes = enabled ? 2 + totalCCs * 3 : 0;
              const byteArray = new Uint8Array(totalBytes);
              if (enabled) {
                byteArray[0] = firstByte;
                for (let i = 1; i < totalBytes; i++) {
                  byteArray[i] = data[payPtr++];
                }
              }
              samples.push({
                type: userDataType,
                payloadType,
                pts,
                bytes: byteArray
              });
            }
          }
        }
      }
    } else if (payloadType === 5) {
      if (payloadSize > 16) {
        const uuidStrArray = [];
        for (let i = 0; i < 16; i++) {
          const _b = data[payPtr++].toString(16);
          uuidStrArray.push(_b.length == 1 ? '0' + _b : _b);
          if (i === 3 || i === 5 || i === 7 || i === 9) {
            uuidStrArray.push('-');
          }
        }
        const length = payloadSize - 16;
        const userDataBytes = new Uint8Array(length);
        for (let i = 0; i < length; i++) {
          userDataBytes[i] = data[payPtr++];
        }
        samples.push({
          payloadType,
          pts,
          uuid: uuidStrArray.join(''),
          userData: utf8ArrayToStr(userDataBytes),
          userDataBytes
        });
      }
    }
  }
}

/**
 * remove Emulation Prevention bytes from a RBSP
 */
function discardEPB(data) {
  const length = data.byteLength;
  const EPBPositions = [];
  let i = 1;

  // Find all `Emulation Prevention Bytes`
  while (i < length - 2) {
    if (data[i] === 0 && data[i + 1] === 0 && data[i + 2] === 0x03) {
      EPBPositions.push(i + 2);
      i += 2;
    } else {
      i++;
    }
  }

  // If no Emulation Prevention Bytes were found just return the original
  // array
  if (EPBPositions.length === 0) {
    return data;
  }

  // Create a new array to hold the NAL unit data
  const newLength = length - EPBPositions.length;
  const newData = new Uint8Array(newLength);
  let sourceIndex = 0;
  for (i = 0; i < newLength; sourceIndex++, i++) {
    if (sourceIndex === EPBPositions[0]) {
      // Skip this byte
      sourceIndex++;
      // Remove this position index
      EPBPositions.shift();
    }
    newData[i] = data[sourceIndex];
  }
  return newData;
}
function parseEmsg(data) {
  const version = data[0];
  let schemeIdUri = '';
  let value = '';
  let timeScale = 0;
  let presentationTimeDelta = 0;
  let presentationTime = 0;
  let eventDuration = 0;
  let id = 0;
  let offset = 0;
  if (version === 0) {
    while (bin2str(data.subarray(offset, offset + 1)) !== '\0') {
      schemeIdUri += bin2str(data.subarray(offset, offset + 1));
      offset += 1;
    }
    schemeIdUri += bin2str(data.subarray(offset, offset + 1));
    offset += 1;
    while (bin2str(data.subarray(offset, offset + 1)) !== '\0') {
      value += bin2str(data.subarray(offset, offset + 1));
      offset += 1;
    }
    value += bin2str(data.subarray(offset, offset + 1));
    offset += 1;
    timeScale = readUint32(data, 12);
    presentationTimeDelta = readUint32(data, 16);
    eventDuration = readUint32(data, 20);
    id = readUint32(data, 24);
    offset = 28;
  } else if (version === 1) {
    offset += 4;
    timeScale = readUint32(data, offset);
    offset += 4;
    const leftPresentationTime = readUint32(data, offset);
    offset += 4;
    const rightPresentationTime = readUint32(data, offset);
    offset += 4;
    presentationTime = 2 ** 32 * leftPresentationTime + rightPresentationTime;
    if (!isSafeInteger(presentationTime)) {
      presentationTime = Number.MAX_SAFE_INTEGER;
      logger.warn('Presentation time exceeds safe integer limit and wrapped to max safe integer in parsing emsg box');
    }
    eventDuration = readUint32(data, offset);
    offset += 4;
    id = readUint32(data, offset);
    offset += 4;
    while (bin2str(data.subarray(offset, offset + 1)) !== '\0') {
      schemeIdUri += bin2str(data.subarray(offset, offset + 1));
      offset += 1;
    }
    schemeIdUri += bin2str(data.subarray(offset, offset + 1));
    offset += 1;
    while (bin2str(data.subarray(offset, offset + 1)) !== '\0') {
      value += bin2str(data.subarray(offset, offset + 1));
      offset += 1;
    }
    value += bin2str(data.subarray(offset, offset + 1));
    offset += 1;
  }
  const payload = data.subarray(offset, data.byteLength);
  return {
    schemeIdUri,
    value,
    timeScale,
    presentationTime,
    presentationTimeDelta,
    eventDuration,
    id,
    payload
  };
}
function mp4Box(type, ...payload) {
  const len = payload.length;
  let size = 8;
  let i = len;
  while (i--) {
    size += payload[i].byteLength;
  }
  const result = new Uint8Array(size);
  result[0] = size >> 24 & 0xff;
  result[1] = size >> 16 & 0xff;
  result[2] = size >> 8 & 0xff;
  result[3] = size & 0xff;
  result.set(type, 4);
  for (i = 0, size = 8; i < len; i++) {
    result.set(payload[i], size);
    size += payload[i].byteLength;
  }
  return result;
}
function mp4pssh(systemId, keyids, data) {
  if (systemId.byteLength !== 16) {
    throw new RangeError('Invalid system id');
  }
  let version;
  let kids;
  if (keyids) {
    version = 1;
    kids = new Uint8Array(keyids.length * 16);
    for (let ix = 0; ix < keyids.length; ix++) {
      const k = keyids[ix]; // uint8array
      if (k.byteLength !== 16) {
        throw new RangeError('Invalid key');
      }
      kids.set(k, ix * 16);
    }
  } else {
    version = 0;
    kids = new Uint8Array();
  }
  let kidCount;
  if (version > 0) {
    kidCount = new Uint8Array(4);
    if (keyids.length > 0) {
      new DataView(kidCount.buffer).setUint32(0, keyids.length, false);
    }
  } else {
    kidCount = new Uint8Array();
  }
  const dataSize = new Uint8Array(4);
  if (data && data.byteLength > 0) {
    new DataView(dataSize.buffer).setUint32(0, data.byteLength, false);
  }
  return mp4Box([112, 115, 115, 104], new Uint8Array([version, 0x00, 0x00, 0x00 // Flags
  ]), systemId,
  // 16 bytes
  kidCount, kids, dataSize, data || new Uint8Array());
}
function parsePssh(initData) {
  if (!(initData instanceof ArrayBuffer) || initData.byteLength < 32) {
    return null;
  }
  const result = {
    version: 0,
    systemId: '',
    kids: null,
    data: null
  };
  const view = new DataView(initData);
  const boxSize = view.getUint32(0);
  if (initData.byteLength !== boxSize && boxSize > 44) {
    return null;
  }
  const type = view.getUint32(4);
  if (type !== 0x70737368) {
    return null;
  }
  result.version = view.getUint32(8) >>> 24;
  if (result.version > 1) {
    return null;
  }
  result.systemId = Hex.hexDump(new Uint8Array(initData, 12, 16));
  const dataSizeOrKidCount = view.getUint32(28);
  if (result.version === 0) {
    if (boxSize - 32 < dataSizeOrKidCount) {
      return null;
    }
    result.data = new Uint8Array(initData, 32, dataSizeOrKidCount);
  } else if (result.version === 1) {
    result.kids = [];
    for (let i = 0; i < dataSizeOrKidCount; i++) {
      result.kids.push(new Uint8Array(initData, 32 + i * 16, 16));
    }
  }
  return result;
}

let keyUriToKeyIdMap = {};
class LevelKey {
  static clearKeyUriToKeyIdMap() {
    keyUriToKeyIdMap = {};
  }
  constructor(method, uri, format, formatversions = [1], iv = null) {
    this.uri = void 0;
    this.method = void 0;
    this.keyFormat = void 0;
    this.keyFormatVersions = void 0;
    this.encrypted = void 0;
    this.isCommonEncryption = void 0;
    this.iv = null;
    this.key = null;
    this.keyId = null;
    this.pssh = null;
    this.method = method;
    this.uri = uri;
    this.keyFormat = format;
    this.keyFormatVersions = formatversions;
    this.iv = iv;
    this.encrypted = method ? method !== 'NONE' : false;
    this.isCommonEncryption = this.encrypted && method !== 'AES-128';
  }
  isSupported() {
    // If it's Segment encryption or No encryption, just select that key system
    if (this.method) {
      if (this.method === 'AES-128' || this.method === 'NONE') {
        return true;
      }
      if (this.keyFormat === 'identity') {
        // Maintain support for clear SAMPLE-AES with MPEG-3 TS
        return this.method === 'SAMPLE-AES';
      } else {
        switch (this.keyFormat) {
          case KeySystemFormats.FAIRPLAY:
          case KeySystemFormats.WIDEVINE:
          case KeySystemFormats.PLAYREADY:
          case KeySystemFormats.CLEARKEY:
            return ['ISO-23001-7', 'SAMPLE-AES', 'SAMPLE-AES-CENC', 'SAMPLE-AES-CTR'].indexOf(this.method) !== -1;
        }
      }
    }
    return false;
  }
  getDecryptData(sn) {
    if (!this.encrypted || !this.uri) {
      return null;
    }
    if (this.method === 'AES-128' && this.uri && !this.iv) {
      if (typeof sn !== 'number') {
        // We are fetching decryption data for a initialization segment
        // If the segment was encrypted with AES-128
        // It must have an IV defined. We cannot substitute the Segment Number in.
        if (this.method === 'AES-128' && !this.iv) {
          logger.warn(`missing IV for initialization segment with method="${this.method}" - compliance issue`);
        }
        // Explicitly set sn to resulting value from implicit conversions 'initSegment' values for IV generation.
        sn = 0;
      }
      const iv = createInitializationVector(sn);
      const decryptdata = new LevelKey(this.method, this.uri, 'identity', this.keyFormatVersions, iv);
      return decryptdata;
    }

    // Initialize keyId if possible
    const keyBytes = convertDataUriToArrayBytes(this.uri);
    if (keyBytes) {
      switch (this.keyFormat) {
        case KeySystemFormats.WIDEVINE:
          this.pssh = keyBytes;
          // In case of widevine keyID is embedded in PSSH box. Read Key ID.
          if (keyBytes.length >= 22) {
            this.keyId = keyBytes.subarray(keyBytes.length - 22, keyBytes.length - 6);
          }
          break;
        case KeySystemFormats.PLAYREADY:
          {
            const PlayReadyKeySystemUUID = new Uint8Array([0x9a, 0x04, 0xf0, 0x79, 0x98, 0x40, 0x42, 0x86, 0xab, 0x92, 0xe6, 0x5b, 0xe0, 0x88, 0x5f, 0x95]);
            this.pssh = mp4pssh(PlayReadyKeySystemUUID, null, keyBytes);
            const keyBytesUtf16 = new Uint16Array(keyBytes.buffer, keyBytes.byteOffset, keyBytes.byteLength / 2);
            const keyByteStr = String.fromCharCode.apply(null, Array.from(keyBytesUtf16));

            // Parse Playready WRMHeader XML
            const xmlKeyBytes = keyByteStr.substring(keyByteStr.indexOf('<'), keyByteStr.length);
            const parser = new DOMParser();
            const xmlDoc = parser.parseFromString(xmlKeyBytes, 'text/xml');
            const keyData = xmlDoc.getElementsByTagName('KID')[0];
            if (keyData) {
              const keyId = keyData.childNodes[0] ? keyData.childNodes[0].nodeValue : keyData.getAttribute('VALUE');
              if (keyId) {
                const keyIdArray = base64Decode(keyId).subarray(0, 16);
                // KID value in PRO is a base64-encoded little endian GUID interpretation of UUID
                // KID value in ‘tenc’ is a big endian UUID GUID interpretation of UUID
                changeEndianness(keyIdArray);
                this.keyId = keyIdArray;
              }
            }
            break;
          }
        default:
          {
            let keydata = keyBytes.subarray(0, 16);
            if (keydata.length !== 16) {
              const padded = new Uint8Array(16);
              padded.set(keydata, 16 - keydata.length);
              keydata = padded;
            }
            this.keyId = keydata;
            break;
          }
      }
    }

    // Default behavior: assign a new keyId for each uri
    if (!this.keyId || this.keyId.byteLength !== 16) {
      let keyId = keyUriToKeyIdMap[this.uri];
      if (!keyId) {
        const val = Object.keys(keyUriToKeyIdMap).length % Number.MAX_SAFE_INTEGER;
        keyId = new Uint8Array(16);
        const dv = new DataView(keyId.buffer, 12, 4); // Just set the last 4 bytes
        dv.setUint32(0, val);
        keyUriToKeyIdMap[this.uri] = keyId;
      }
      this.keyId = keyId;
    }
    return this;
  }
}
function createInitializationVector(segmentNumber) {
  const uint8View = new Uint8Array(16);
  for (let i = 12; i < 16; i++) {
    uint8View[i] = segmentNumber >> 8 * (15 - i) & 0xff;
  }
  return uint8View;
}

const VARIABLE_REPLACEMENT_REGEX = /\{\$([a-zA-Z0-9-_]+)\}/g;
function hasVariableReferences(str) {
  return VARIABLE_REPLACEMENT_REGEX.test(str);
}
function substituteVariablesInAttributes(parsed, attr, attributeNames) {
  if (parsed.variableList !== null || parsed.hasVariableRefs) {
    for (let i = attributeNames.length; i--;) {
      const name = attributeNames[i];
      const value = attr[name];
      if (value) {
        attr[name] = substituteVariables(parsed, value);
      }
    }
  }
}
function substituteVariables(parsed, value) {
  if (parsed.variableList !== null || parsed.hasVariableRefs) {
    const variableList = parsed.variableList;
    return value.replace(VARIABLE_REPLACEMENT_REGEX, variableReference => {
      const variableName = variableReference.substring(2, variableReference.length - 1);
      const variableValue = variableList == null ? void 0 : variableList[variableName];
      if (variableValue === undefined) {
        parsed.playlistParsingError || (parsed.playlistParsingError = new Error(`Missing preceding EXT-X-DEFINE tag for Variable Reference: "${variableName}"`));
        return variableReference;
      }
      return variableValue;
    });
  }
  return value;
}
function addVariableDefinition(parsed, attr, parentUrl) {
  let variableList = parsed.variableList;
  if (!variableList) {
    parsed.variableList = variableList = {};
  }
  let NAME;
  let VALUE;
  if ('QUERYPARAM' in attr) {
    NAME = attr.QUERYPARAM;
    try {
      const searchParams = new self.URL(parentUrl).searchParams;
      if (searchParams.has(NAME)) {
        VALUE = searchParams.get(NAME);
      } else {
        throw new Error(`"${NAME}" does not match any query parameter in URI: "${parentUrl}"`);
      }
    } catch (error) {
      parsed.playlistParsingError || (parsed.playlistParsingError = new Error(`EXT-X-DEFINE QUERYPARAM: ${error.message}`));
    }
  } else {
    NAME = attr.NAME;
    VALUE = attr.VALUE;
  }
  if (NAME in variableList) {
    parsed.playlistParsingError || (parsed.playlistParsingError = new Error(`EXT-X-DEFINE duplicate Variable Name declarations: "${NAME}"`));
  } else {
    variableList[NAME] = VALUE || '';
  }
}
function importVariableDefinition(parsed, attr, sourceVariableList) {
  const IMPORT = attr.IMPORT;
  if (sourceVariableList && IMPORT in sourceVariableList) {
    let variableList = parsed.variableList;
    if (!variableList) {
      parsed.variableList = variableList = {};
    }
    variableList[IMPORT] = sourceVariableList[IMPORT];
  } else {
    parsed.playlistParsingError || (parsed.playlistParsingError = new Error(`EXT-X-DEFINE IMPORT attribute not found in Multivariant Playlist: "${IMPORT}"`));
  }
}

/**
 * MediaSource helper
 */

function getMediaSource(preferManagedMediaSource = true) {
  if (typeof self === 'undefined') return undefined;
  const mms = (preferManagedMediaSource || !self.MediaSource) && self.ManagedMediaSource;
  return mms || self.MediaSource || self.WebKitMediaSource;
}
function isManagedMediaSource(source) {
  return typeof self !== 'undefined' && source === self.ManagedMediaSource;
}

// from http://mp4ra.org/codecs.html
// values indicate codec selection preference (lower is higher priority)
const sampleEntryCodesISO = {
  audio: {
    a3ds: 1,
    'ac-3': 0.95,
    'ac-4': 1,
    alac: 0.9,
    alaw: 1,
    dra1: 1,
    'dts+': 1,
    'dts-': 1,
    dtsc: 1,
    dtse: 1,
    dtsh: 1,
    'ec-3': 0.9,
    enca: 1,
    fLaC: 0.9,
    // MP4-RA listed codec entry for FLAC
    flac: 0.9,
    // legacy browser codec name for FLAC
    FLAC: 0.9,
    // some manifests may list "FLAC" with Apple's tools
    g719: 1,
    g726: 1,
    m4ae: 1,
    mha1: 1,
    mha2: 1,
    mhm1: 1,
    mhm2: 1,
    mlpa: 1,
    mp4a: 1,
    'raw ': 1,
    Opus: 1,
    opus: 1,
    // browsers expect this to be lowercase despite MP4RA says 'Opus'
    samr: 1,
    sawb: 1,
    sawp: 1,
    sevc: 1,
    sqcp: 1,
    ssmv: 1,
    twos: 1,
    ulaw: 1
  },
  video: {
    avc1: 1,
    avc2: 1,
    avc3: 1,
    avc4: 1,
    avcp: 1,
    av01: 0.8,
    drac: 1,
    dva1: 1,
    dvav: 1,
    dvh1: 0.7,
    dvhe: 0.7,
    encv: 1,
    hev1: 0.75,
    hvc1: 0.75,
    mjp2: 1,
    mp4v: 1,
    mvc1: 1,
    mvc2: 1,
    mvc3: 1,
    mvc4: 1,
    resv: 1,
    rv60: 1,
    s263: 1,
    svc1: 1,
    svc2: 1,
    'vc-1': 1,
    vp08: 1,
    vp09: 0.9
  },
  text: {
    stpp: 1,
    wvtt: 1
  }
};
function isCodecType(codec, type) {
  const typeCodes = sampleEntryCodesISO[type];
  return !!typeCodes && !!typeCodes[codec.slice(0, 4)];
}
function areCodecsMediaSourceSupported(codecs, type, preferManagedMediaSource = true) {
  return !codecs.split(',').some(codec => !isCodecMediaSourceSupported(codec, type, preferManagedMediaSource));
}
function isCodecMediaSourceSupported(codec, type, preferManagedMediaSource = true) {
  var _MediaSource$isTypeSu;
  const MediaSource = getMediaSource(preferManagedMediaSource);
  return (_MediaSource$isTypeSu = MediaSource == null ? void 0 : MediaSource.isTypeSupported(mimeTypeForCodec(codec, type))) != null ? _MediaSource$isTypeSu : false;
}
function mimeTypeForCodec(codec, type) {
  return `${type}/mp4;codecs="${codec}"`;
}
function videoCodecPreferenceValue(videoCodec) {
  if (videoCodec) {
    const fourCC = videoCodec.substring(0, 4);
    return sampleEntryCodesISO.video[fourCC];
  }
  return 2;
}
function codecsSetSelectionPreferenceValue(codecSet) {
  return codecSet.split(',').reduce((num, fourCC) => {
    const preferenceValue = sampleEntryCodesISO.video[fourCC];
    if (preferenceValue) {
      return (preferenceValue * 2 + num) / (num ? 3 : 2);
    }
    return (sampleEntryCodesISO.audio[fourCC] + num) / (num ? 2 : 1);
  }, 0);
}
const CODEC_COMPATIBLE_NAMES = {};
function getCodecCompatibleNameLower(lowerCaseCodec, preferManagedMediaSource = true) {
  if (CODEC_COMPATIBLE_NAMES[lowerCaseCodec]) {
    return CODEC_COMPATIBLE_NAMES[lowerCaseCodec];
  }

  // Idealy fLaC and Opus would be first (spec-compliant) but
  // some browsers will report that fLaC is supported then fail.
  // see: https://bugs.chromium.org/p/chromium/issues/detail?id=1422728
  const codecsToCheck = {
    flac: ['flac', 'fLaC', 'FLAC'],
    opus: ['opus', 'Opus']
  }[lowerCaseCodec];
  for (let i = 0; i < codecsToCheck.length; i++) {
    if (isCodecMediaSourceSupported(codecsToCheck[i], 'audio', preferManagedMediaSource)) {
      CODEC_COMPATIBLE_NAMES[lowerCaseCodec] = codecsToCheck[i];
      return codecsToCheck[i];
    }
  }
  return lowerCaseCodec;
}
const AUDIO_CODEC_REGEXP = /flac|opus/i;
function getCodecCompatibleName(codec, preferManagedMediaSource = true) {
  return codec.replace(AUDIO_CODEC_REGEXP, m => getCodecCompatibleNameLower(m.toLowerCase(), preferManagedMediaSource));
}
function pickMostCompleteCodecName(parsedCodec, levelCodec) {
  // Parsing of mp4a codecs strings in mp4-tools from media is incomplete as of d8c6c7a
  // so use level codec is parsed codec is unavailable or incomplete
  if (parsedCodec && parsedCodec !== 'mp4a') {
    return parsedCodec;
  }
  return levelCodec ? levelCodec.split(',')[0] : levelCodec;
}
function convertAVC1ToAVCOTI(codec) {
  // Convert avc1 codec string from RFC-4281 to RFC-6381 for MediaSource.isTypeSupported
  // Examples: avc1.66.30 to avc1.42001e and avc1.77.30,avc1.66.30 to avc1.4d001e,avc1.42001e.
  const codecs = codec.split(',');
  for (let i = 0; i < codecs.length; i++) {
    const avcdata = codecs[i].split('.');
    if (avcdata.length > 2) {
      let result = avcdata.shift() + '.';
      result += parseInt(avcdata.shift()).toString(16);
      result += ('000' + parseInt(avcdata.shift()).toString(16)).slice(-4);
      codecs[i] = result;
    }
  }
  return codecs.join(',');
}

const MASTER_PLAYLIST_REGEX = /#EXT-X-STREAM-INF:([^\r\n]*)(?:[\r\n](?:#[^\r\n]*)?)*([^\r\n]+)|#EXT-X-(SESSION-DATA|SESSION-KEY|DEFINE|CONTENT-STEERING|START):([^\r\n]*)[\r\n]+/g;
const MASTER_PLAYLIST_MEDIA_REGEX = /#EXT-X-MEDIA:(.*)/g;
const IS_MEDIA_PLAYLIST = /^#EXT(?:INF|-X-TARGETDURATION):/m; // Handle empty Media Playlist (first EXTINF not signaled, but TARGETDURATION present)

const LEVEL_PLAYLIST_REGEX_FAST = new RegExp([/#EXTINF:\s*(\d*(?:\.\d+)?)(?:,(.*)\s+)?/.source,
// duration (#EXTINF:<duration>,<title>), group 1 => duration, group 2 => title
/(?!#) *(\S[^\r\n]*)/.source,
// segment URI, group 3 => the URI (note newline is not eaten)
/#EXT-X-BYTERANGE:*(.+)/.source,
// next segment's byterange, group 4 => range spec (x@y)
/#EXT-X-PROGRAM-DATE-TIME:(.+)/.source,
// next segment's program date/time group 5 => the datetime spec
/#.*/.source // All other non-segment oriented tags will match with all groups empty
].join('|'), 'g');
const LEVEL_PLAYLIST_REGEX_SLOW = new RegExp([/#(EXTM3U)/.source, /#EXT-X-(DATERANGE|DEFINE|KEY|MAP|PART|PART-INF|PLAYLIST-TYPE|PRELOAD-HINT|RENDITION-REPORT|SERVER-CONTROL|SKIP|START):(.+)/.source, /#EXT-X-(BITRATE|DISCONTINUITY-SEQUENCE|MEDIA-SEQUENCE|TARGETDURATION|VERSION): *(\d+)/.source, /#EXT-X-(DISCONTINUITY|ENDLIST|GAP|INDEPENDENT-SEGMENTS)/.source, /(#)([^:]*):(.*)/.source, /(#)(.*)(?:.*)\r?\n?/.source].join('|'));
class M3U8Parser {
  static findGroup(groups, mediaGroupId) {
    for (let i = 0; i < groups.length; i++) {
      const group = groups[i];
      if (group.id === mediaGroupId) {
        return group;
      }
    }
  }
  static resolve(url, baseUrl) {
    return urlToolkitExports.buildAbsoluteURL(baseUrl, url, {
      alwaysNormalize: true
    });
  }
  static isMediaPlaylist(str) {
    return IS_MEDIA_PLAYLIST.test(str);
  }
  static parseMasterPlaylist(string, baseurl) {
    const hasVariableRefs = hasVariableReferences(string) ;
    const parsed = {
      contentSteering: null,
      levels: [],
      playlistParsingError: null,
      sessionData: null,
      sessionKeys: null,
      startTimeOffset: null,
      variableList: null,
      hasVariableRefs
    };
    const levelsWithKnownCodecs = [];
    MASTER_PLAYLIST_REGEX.lastIndex = 0;
    let result;
    while ((result = MASTER_PLAYLIST_REGEX.exec(string)) != null) {
      if (result[1]) {
        var _level$unknownCodecs;
        // '#EXT-X-STREAM-INF' is found, parse level tag  in group 1
        const attrs = new AttrList(result[1]);
        {
          substituteVariablesInAttributes(parsed, attrs, ['CODECS', 'SUPPLEMENTAL-CODECS', 'ALLOWED-CPC', 'PATHWAY-ID', 'STABLE-VARIANT-ID', 'AUDIO', 'VIDEO', 'SUBTITLES', 'CLOSED-CAPTIONS', 'NAME']);
        }
        const uri = substituteVariables(parsed, result[2]) ;
        const level = {
          attrs,
          bitrate: attrs.decimalInteger('BANDWIDTH') || attrs.decimalInteger('AVERAGE-BANDWIDTH'),
          name: attrs.NAME,
          url: M3U8Parser.resolve(uri, baseurl)
        };
        const resolution = attrs.decimalResolution('RESOLUTION');
        if (resolution) {
          level.width = resolution.width;
          level.height = resolution.height;
        }
        setCodecs(attrs.CODECS, level);
        if (!((_level$unknownCodecs = level.unknownCodecs) != null && _level$unknownCodecs.length)) {
          levelsWithKnownCodecs.push(level);
        }
        parsed.levels.push(level);
      } else if (result[3]) {
        const tag = result[3];
        const attributes = result[4];
        switch (tag) {
          case 'SESSION-DATA':
            {
              // #EXT-X-SESSION-DATA
              const sessionAttrs = new AttrList(attributes);
              {
                substituteVariablesInAttributes(parsed, sessionAttrs, ['DATA-ID', 'LANGUAGE', 'VALUE', 'URI']);
              }
              const dataId = sessionAttrs['DATA-ID'];
              if (dataId) {
                if (parsed.sessionData === null) {
                  parsed.sessionData = {};
                }
                parsed.sessionData[dataId] = sessionAttrs;
              }
              break;
            }
          case 'SESSION-KEY':
            {
              // #EXT-X-SESSION-KEY
              const sessionKey = parseKey(attributes, baseurl, parsed);
              if (sessionKey.encrypted && sessionKey.isSupported()) {
                if (parsed.sessionKeys === null) {
                  parsed.sessionKeys = [];
                }
                parsed.sessionKeys.push(sessionKey);
              } else {
                logger.warn(`[Keys] Ignoring invalid EXT-X-SESSION-KEY tag: "${attributes}"`);
              }
              break;
            }
          case 'DEFINE':
            {
              // #EXT-X-DEFINE
              {
                const variableAttributes = new AttrList(attributes);
                substituteVariablesInAttributes(parsed, variableAttributes, ['NAME', 'VALUE', 'QUERYPARAM']);
                addVariableDefinition(parsed, variableAttributes, baseurl);
              }
              break;
            }
          case 'CONTENT-STEERING':
            {
              // #EXT-X-CONTENT-STEERING
              const contentSteeringAttributes = new AttrList(attributes);
              {
                substituteVariablesInAttributes(parsed, contentSteeringAttributes, ['SERVER-URI', 'PATHWAY-ID']);
              }
              parsed.contentSteering = {
                uri: M3U8Parser.resolve(contentSteeringAttributes['SERVER-URI'], baseurl),
                pathwayId: contentSteeringAttributes['PATHWAY-ID'] || '.'
              };
              break;
            }
          case 'START':
            {
              // #EXT-X-START
              parsed.startTimeOffset = parseStartTimeOffset(attributes);
              break;
            }
        }
      }
    }
    // Filter out levels with unknown codecs if it does not remove all levels
    const stripUnknownCodecLevels = levelsWithKnownCodecs.length > 0 && levelsWithKnownCodecs.length < parsed.levels.length;
    parsed.levels = stripUnknownCodecLevels ? levelsWithKnownCodecs : parsed.levels;
    if (parsed.levels.length === 0) {
      parsed.playlistParsingError = new Error('no levels found in manifest');
    }
    return parsed;
  }
  static parseMasterPlaylistMedia(string, baseurl, parsed) {
    let result;
    const results = {};
    const levels = parsed.levels;
    const groupsByType = {
      AUDIO: levels.map(level => ({
        id: level.attrs.AUDIO,
        audioCodec: level.audioCodec
      })),
      SUBTITLES: levels.map(level => ({
        id: level.attrs.SUBTITLES,
        textCodec: level.textCodec
      })),
      'CLOSED-CAPTIONS': []
    };
    let id = 0;
    MASTER_PLAYLIST_MEDIA_REGEX.lastIndex = 0;
    while ((result = MASTER_PLAYLIST_MEDIA_REGEX.exec(string)) !== null) {
      const attrs = new AttrList(result[1]);
      const type = attrs.TYPE;
      if (type) {
        const groups = groupsByType[type];
        const medias = results[type] || [];
        results[type] = medias;
        {
          substituteVariablesInAttributes(parsed, attrs, ['URI', 'GROUP-ID', 'LANGUAGE', 'ASSOC-LANGUAGE', 'STABLE-RENDITION-ID', 'NAME', 'INSTREAM-ID', 'CHARACTERISTICS', 'CHANNELS']);
        }
        const lang = attrs.LANGUAGE;
        const assocLang = attrs['ASSOC-LANGUAGE'];
        const channels = attrs.CHANNELS;
        const characteristics = attrs.CHARACTERISTICS;
        const instreamId = attrs['INSTREAM-ID'];
        const media = {
          attrs,
          bitrate: 0,
          id: id++,
          groupId: attrs['GROUP-ID'] || '',
          name: attrs.NAME || lang || '',
          type,
          default: attrs.bool('DEFAULT'),
          autoselect: attrs.bool('AUTOSELECT'),
          forced: attrs.bool('FORCED'),
          lang,
          url: attrs.URI ? M3U8Parser.resolve(attrs.URI, baseurl) : ''
        };
        if (assocLang) {
          media.assocLang = assocLang;
        }
        if (channels) {
          media.channels = channels;
        }
        if (characteristics) {
          media.characteristics = characteristics;
        }
        if (instreamId) {
          media.instreamId = instreamId;
        }
        if (groups != null && groups.length) {
          // If there are audio or text groups signalled in the manifest, let's look for a matching codec string for this track
          // If we don't find the track signalled, lets use the first audio groups codec we have
          // Acting as a best guess
          const groupCodec = M3U8Parser.findGroup(groups, media.groupId) || groups[0];
          assignCodec(media, groupCodec, 'audioCodec');
          assignCodec(media, groupCodec, 'textCodec');
        }
        medias.push(media);
      }
    }
    return results;
  }
  static parseLevelPlaylist(string, baseurl, id, type, levelUrlId, multivariantVariableList) {
    const level = new LevelDetails(baseurl);
    const fragments = level.fragments;
    // The most recent init segment seen (applies to all subsequent segments)
    let currentInitSegment = null;
    let currentSN = 0;
    let currentPart = 0;
    let totalduration = 0;
    let discontinuityCounter = 0;
    let prevFrag = null;
    let frag = new Fragment(type, baseurl);
    let result;
    let i;
    let levelkeys;
    let firstPdtIndex = -1;
    let createNextFrag = false;
    let nextByteRange = null;
    LEVEL_PLAYLIST_REGEX_FAST.lastIndex = 0;
    level.m3u8 = string;
    level.hasVariableRefs = hasVariableReferences(string) ;
    while ((result = LEVEL_PLAYLIST_REGEX_FAST.exec(string)) !== null) {
      if (createNextFrag) {
        createNextFrag = false;
        frag = new Fragment(type, baseurl);
        // setup the next fragment for part loading
        frag.start = totalduration;
        frag.sn = currentSN;
        frag.cc = discontinuityCounter;
        frag.level = id;
        if (currentInitSegment) {
          frag.initSegment = currentInitSegment;
          frag.rawProgramDateTime = currentInitSegment.rawProgramDateTime;
          currentInitSegment.rawProgramDateTime = null;
          if (nextByteRange) {
            frag.setByteRange(nextByteRange);
            nextByteRange = null;
          }
        }
      }
      const duration = result[1];
      if (duration) {
        // INF
        frag.duration = parseFloat(duration);
        // avoid sliced strings    https://github.com/video-dev/hls.js/issues/939
        const title = (' ' + result[2]).slice(1);
        frag.title = title || null;
        frag.tagList.push(title ? ['INF', duration, title] : ['INF', duration]);
      } else if (result[3]) {
        // url
        if (isFiniteNumber(frag.duration)) {
          frag.start = totalduration;
          if (levelkeys) {
            setFragLevelKeys(frag, levelkeys, level);
          }
          frag.sn = currentSN;
          frag.level = id;
          frag.cc = discontinuityCounter;
          fragments.push(frag);
          // avoid sliced strings    https://github.com/video-dev/hls.js/issues/939
          const uri = (' ' + result[3]).slice(1);
          frag.relurl = substituteVariables(level, uri) ;
          assignProgramDateTime(frag, prevFrag);
          prevFrag = frag;
          totalduration += frag.duration;
          currentSN++;
          currentPart = 0;
          createNextFrag = true;
        }
      } else if (result[4]) {
        // X-BYTERANGE
        const data = (' ' + result[4]).slice(1);
        if (prevFrag) {
          frag.setByteRange(data, prevFrag);
        } else {
          frag.setByteRange(data);
        }
      } else if (result[5]) {
        // PROGRAM-DATE-TIME
        // avoid sliced strings    https://github.com/video-dev/hls.js/issues/939
        frag.rawProgramDateTime = (' ' + result[5]).slice(1);
        frag.tagList.push(['PROGRAM-DATE-TIME', frag.rawProgramDateTime]);
        if (firstPdtIndex === -1) {
          firstPdtIndex = fragments.length;
        }
      } else {
        result = result[0].match(LEVEL_PLAYLIST_REGEX_SLOW);
        if (!result) {
          logger.warn('No matches on slow regex match for level playlist!');
          continue;
        }
        for (i = 1; i < result.length; i++) {
          if (typeof result[i] !== 'undefined') {
            break;
          }
        }

        // avoid sliced strings    https://github.com/video-dev/hls.js/issues/939
        const tag = (' ' + result[i]).slice(1);
        const value1 = (' ' + result[i + 1]).slice(1);
        const value2 = result[i + 2] ? (' ' + result[i + 2]).slice(1) : '';
        switch (tag) {
          case 'PLAYLIST-TYPE':
            level.type = value1.toUpperCase();
            break;
          case 'MEDIA-SEQUENCE':
            currentSN = level.startSN = parseInt(value1);
            break;
          case 'SKIP':
            {
              const skipAttrs = new AttrList(value1);
              {
                substituteVariablesInAttributes(level, skipAttrs, ['RECENTLY-REMOVED-DATERANGES']);
              }
              const skippedSegments = skipAttrs.decimalInteger('SKIPPED-SEGMENTS');
              if (isFiniteNumber(skippedSegments)) {
                level.skippedSegments = skippedSegments;
                // This will result in fragments[] containing undefined values, which we will fill in with `mergeDetails`
                for (let _i = skippedSegments; _i--;) {
                  fragments.unshift(null);
                }
                currentSN += skippedSegments;
              }
              const recentlyRemovedDateranges = skipAttrs.enumeratedString('RECENTLY-REMOVED-DATERANGES');
              if (recentlyRemovedDateranges) {
                level.recentlyRemovedDateranges = recentlyRemovedDateranges.split('\t');
              }
              break;
            }
          case 'TARGETDURATION':
            level.targetduration = Math.max(parseInt(value1), 1);
            break;
          case 'VERSION':
            level.version = parseInt(value1);
            break;
          case 'INDEPENDENT-SEGMENTS':
          case 'EXTM3U':
            break;
          case 'ENDLIST':
            level.live = false;
            break;
          case '#':
            if (value1 || value2) {
              frag.tagList.push(value2 ? [value1, value2] : [value1]);
            }
            break;
          case 'DISCONTINUITY':
            discontinuityCounter++;
            frag.tagList.push(['DIS']);
            break;
          case 'GAP':
            frag.gap = true;
            frag.tagList.push([tag]);
            break;
          case 'BITRATE':
            frag.tagList.push([tag, value1]);
            break;
          case 'DATERANGE':
            {
              const dateRangeAttr = new AttrList(value1);
              {
                substituteVariablesInAttributes(level, dateRangeAttr, ['ID', 'CLASS', 'START-DATE', 'END-DATE', 'SCTE35-CMD', 'SCTE35-OUT', 'SCTE35-IN']);
                substituteVariablesInAttributes(level, dateRangeAttr, dateRangeAttr.clientAttrs);
              }
              const dateRange = new DateRange(dateRangeAttr, level.dateRanges[dateRangeAttr.ID]);
              if (dateRange.isValid || level.skippedSegments) {
                level.dateRanges[dateRange.id] = dateRange;
              } else {
                logger.warn(`Ignoring invalid DATERANGE tag: "${value1}"`);
              }
              // Add to fragment tag list for backwards compatibility (< v1.2.0)
              frag.tagList.push(['EXT-X-DATERANGE', value1]);
              break;
            }
          case 'DEFINE':
            {
              {
                const variableAttributes = new AttrList(value1);
                substituteVariablesInAttributes(level, variableAttributes, ['NAME', 'VALUE', 'IMPORT', 'QUERYPARAM']);
                if ('IMPORT' in variableAttributes) {
                  importVariableDefinition(level, variableAttributes, multivariantVariableList);
                } else {
                  addVariableDefinition(level, variableAttributes, baseurl);
                }
              }
              break;
            }
          case 'DISCONTINUITY-SEQUENCE':
            discontinuityCounter = parseInt(value1);
            break;
          case 'KEY':
            {
              const levelKey = parseKey(value1, baseurl, level);
              if (levelKey.isSupported()) {
                if (levelKey.method === 'NONE') {
                  levelkeys = undefined;
                  break;
                }
                if (!levelkeys) {
                  levelkeys = {};
                }
                if (levelkeys[levelKey.keyFormat]) {
                  levelkeys = _extends({}, levelkeys);
                }
                levelkeys[levelKey.keyFormat] = levelKey;
              } else {
                logger.warn(`[Keys] Ignoring invalid EXT-X-KEY tag: "${value1}"`);
              }
              break;
            }
          case 'START':
            level.startTimeOffset = parseStartTimeOffset(value1);
            break;
          case 'MAP':
            {
              const mapAttrs = new AttrList(value1);
              {
                substituteVariablesInAttributes(level, mapAttrs, ['BYTERANGE', 'URI']);
              }
              if (frag.duration) {
                // Initial segment tag is after segment duration tag.
                //   #EXTINF: 6.0
                //   #EXT-X-MAP:URI="init.mp4
                const init = new Fragment(type, baseurl);
                setInitSegment(init, mapAttrs, id, levelkeys);
                currentInitSegment = init;
                frag.initSegment = currentInitSegment;
                if (currentInitSegment.rawProgramDateTime && !frag.rawProgramDateTime) {
                  frag.rawProgramDateTime = currentInitSegment.rawProgramDateTime;
                }
              } else {
                // Initial segment tag is before segment duration tag
                // Handle case where EXT-X-MAP is declared after EXT-X-BYTERANGE
                const end = frag.byteRangeEndOffset;
                if (end) {
                  const start = frag.byteRangeStartOffset;
                  nextByteRange = `${end - start}@${start}`;
                } else {
                  nextByteRange = null;
                }
                setInitSegment(frag, mapAttrs, id, levelkeys);
                currentInitSegment = frag;
                createNextFrag = true;
              }
              break;
            }
          case 'SERVER-CONTROL':
            {
              const serverControlAttrs = new AttrList(value1);
              level.canBlockReload = serverControlAttrs.bool('CAN-BLOCK-RELOAD');
              level.canSkipUntil = serverControlAttrs.optionalFloat('CAN-SKIP-UNTIL', 0);
              level.canSkipDateRanges = level.canSkipUntil > 0 && serverControlAttrs.bool('CAN-SKIP-DATERANGES');
              level.partHoldBack = serverControlAttrs.optionalFloat('PART-HOLD-BACK', 0);
              level.holdBack = serverControlAttrs.optionalFloat('HOLD-BACK', 0);
              break;
            }
          case 'PART-INF':
            {
              const partInfAttrs = new AttrList(value1);
              level.partTarget = partInfAttrs.decimalFloatingPoint('PART-TARGET');
              break;
            }
          case 'PART':
            {
              let partList = level.partList;
              if (!partList) {
                partList = level.partList = [];
              }
              const previousFragmentPart = currentPart > 0 ? partList[partList.length - 1] : undefined;
              const index = currentPart++;
              const partAttrs = new AttrList(value1);
              {
                substituteVariablesInAttributes(level, partAttrs, ['BYTERANGE', 'URI']);
              }
              const part = new Part(partAttrs, frag, baseurl, index, previousFragmentPart);
              partList.push(part);
              frag.duration += part.duration;
              break;
            }
          case 'PRELOAD-HINT':
            {
              const preloadHintAttrs = new AttrList(value1);
              {
                substituteVariablesInAttributes(level, preloadHintAttrs, ['URI']);
              }
              level.preloadHint = preloadHintAttrs;
              break;
            }
          case 'RENDITION-REPORT':
            {
              const renditionReportAttrs = new AttrList(value1);
              {
                substituteVariablesInAttributes(level, renditionReportAttrs, ['URI']);
              }
              level.renditionReports = level.renditionReports || [];
              level.renditionReports.push(renditionReportAttrs);
              break;
            }
          default:
            logger.warn(`line parsed but not handled: ${result}`);
            break;
        }
      }
    }
    if (prevFrag && !prevFrag.relurl) {
      fragments.pop();
      totalduration -= prevFrag.duration;
      if (level.partList) {
        level.fragmentHint = prevFrag;
      }
    } else if (level.partList) {
      assignProgramDateTime(frag, prevFrag);
      frag.cc = discontinuityCounter;
      level.fragmentHint = frag;
      if (levelkeys) {
        setFragLevelKeys(frag, levelkeys, level);
      }
    }
    const fragmentLength = fragments.length;
    const firstFragment = fragments[0];
    const lastFragment = fragments[fragmentLength - 1];
    totalduration += level.skippedSegments * level.targetduration;
    if (totalduration > 0 && fragmentLength && lastFragment) {
      level.averagetargetduration = totalduration / fragmentLength;
      const lastSn = lastFragment.sn;
      level.endSN = lastSn !== 'initSegment' ? lastSn : 0;
      if (!level.live) {
        lastFragment.endList = true;
      }
      if (firstFragment) {
        level.startCC = firstFragment.cc;
      }
    } else {
      level.endSN = 0;
      level.startCC = 0;
    }
    if (level.fragmentHint) {
      totalduration += level.fragmentHint.duration;
    }
    level.totalduration = totalduration;
    level.endCC = discontinuityCounter;

    /**
     * Backfill any missing PDT values
     * "If the first EXT-X-PROGRAM-DATE-TIME tag in a Playlist appears after
     * one or more Media Segment URIs, the client SHOULD extrapolate
     * backward from that tag (using EXTINF durations and/or media
     * timestamps) to associate dates with those segments."
     * We have already extrapolated forward, but all fragments up to the first instance of PDT do not have their PDTs
     * computed.
     */
    if (firstPdtIndex > 0) {
      backfillProgramDateTimes(fragments, firstPdtIndex);
    }
    return level;
  }
}
function parseKey(keyTagAttributes, baseurl, parsed) {
  var _keyAttrs$METHOD, _keyAttrs$KEYFORMAT;
  // https://tools.ietf.org/html/rfc8216#section-4.3.2.4
  const keyAttrs = new AttrList(keyTagAttributes);
  {
    substituteVariablesInAttributes(parsed, keyAttrs, ['KEYFORMAT', 'KEYFORMATVERSIONS', 'URI', 'IV', 'URI']);
  }
  const decryptmethod = (_keyAttrs$METHOD = keyAttrs.METHOD) != null ? _keyAttrs$METHOD : '';
  const decrypturi = keyAttrs.URI;
  const decryptiv = keyAttrs.hexadecimalInteger('IV');
  const decryptkeyformatversions = keyAttrs.KEYFORMATVERSIONS;
  // From RFC: This attribute is OPTIONAL; its absence indicates an implicit value of "identity".
  const decryptkeyformat = (_keyAttrs$KEYFORMAT = keyAttrs.KEYFORMAT) != null ? _keyAttrs$KEYFORMAT : 'identity';
  if (decrypturi && keyAttrs.IV && !decryptiv) {
    logger.error(`Invalid IV: ${keyAttrs.IV}`);
  }
  // If decrypturi is a URI with a scheme, then baseurl will be ignored
  // No uri is allowed when METHOD is NONE
  const resolvedUri = decrypturi ? M3U8Parser.resolve(decrypturi, baseurl) : '';
  const keyFormatVersions = (decryptkeyformatversions ? decryptkeyformatversions : '1').split('/').map(Number).filter(Number.isFinite);
  return new LevelKey(decryptmethod, resolvedUri, decryptkeyformat, keyFormatVersions, decryptiv);
}
function parseStartTimeOffset(startAttributes) {
  const startAttrs = new AttrList(startAttributes);
  const startTimeOffset = startAttrs.decimalFloatingPoint('TIME-OFFSET');
  if (isFiniteNumber(startTimeOffset)) {
    return startTimeOffset;
  }
  return null;
}
function setCodecs(codecsAttributeValue, level) {
  let codecs = (codecsAttributeValue || '').split(/[ ,]+/).filter(c => c);
  ['video', 'audio', 'text'].forEach(type => {
    const filtered = codecs.filter(codec => isCodecType(codec, type));
    if (filtered.length) {
      // Comma separated list of all codecs for type
      level[`${type}Codec`] = filtered.join(',');
      // Remove known codecs so that only unknownCodecs are left after iterating through each type
      codecs = codecs.filter(codec => filtered.indexOf(codec) === -1);
    }
  });
  level.unknownCodecs = codecs;
}
function assignCodec(media, groupItem, codecProperty) {
  const codecValue = groupItem[codecProperty];
  if (codecValue) {
    media[codecProperty] = codecValue;
  }
}
function backfillProgramDateTimes(fragments, firstPdtIndex) {
  let fragPrev = fragments[firstPdtIndex];
  for (let i = firstPdtIndex; i--;) {
    const frag = fragments[i];
    // Exit on delta-playlist skipped segments
    if (!frag) {
      return;
    }
    frag.programDateTime = fragPrev.programDateTime - frag.duration * 1000;
    fragPrev = frag;
  }
}
function assignProgramDateTime(frag, prevFrag) {
  if (frag.rawProgramDateTime) {
    frag.programDateTime = Date.parse(frag.rawProgramDateTime);
  } else if (prevFrag != null && prevFrag.programDateTime) {
    frag.programDateTime = prevFrag.endProgramDateTime;
  }
  if (!isFiniteNumber(frag.programDateTime)) {
    frag.programDateTime = null;
    frag.rawProgramDateTime = null;
  }
}
function setInitSegment(frag, mapAttrs, id, levelkeys) {
  frag.relurl = mapAttrs.URI;
  if (mapAttrs.BYTERANGE) {
    frag.setByteRange(mapAttrs.BYTERANGE);
  }
  frag.level = id;
  frag.sn = 'initSegment';
  if (levelkeys) {
    frag.levelkeys = levelkeys;
  }
  frag.initSegment = null;
}
function setFragLevelKeys(frag, levelkeys, level) {
  frag.levelkeys = levelkeys;
  const {
    encryptedFragments
  } = level;
  if ((!encryptedFragments.length || encryptedFragments[encryptedFragments.length - 1].levelkeys !== levelkeys) && Object.keys(levelkeys).some(format => levelkeys[format].isCommonEncryption)) {
    encryptedFragments.push(frag);
  }
}

var PlaylistContextType = {
  MANIFEST: "manifest",
  LEVEL: "level",
  AUDIO_TRACK: "audioTrack",
  SUBTITLE_TRACK: "subtitleTrack"
};
var PlaylistLevelType = {
  MAIN: "main",
  AUDIO: "audio",
  SUBTITLE: "subtitle"
};

function mapContextToLevelType(context) {
  const {
    type
  } = context;
  switch (type) {
    case PlaylistContextType.AUDIO_TRACK:
      return PlaylistLevelType.AUDIO;
    case PlaylistContextType.SUBTITLE_TRACK:
      return PlaylistLevelType.SUBTITLE;
    default:
      return PlaylistLevelType.MAIN;
  }
}
function getResponseUrl(response, context) {
  let url = response.url;
  // responseURL not supported on some browsers (it is used to detect URL redirection)
  // data-uri mode also not supported (but no need to detect redirection)
  if (url === undefined || url.indexOf('data:') === 0) {
    // fallback to initial URL
    url = context.url;
  }
  return url;
}
class PlaylistLoader {
  constructor(hls) {
    this.hls = void 0;
    this.loaders = Object.create(null);
    this.variableList = null;
    this.hls = hls;
    this.registerListeners();
  }
  startLoad(startPosition) {}
  stopLoad() {
    this.destroyInternalLoaders();
  }
  registerListeners() {
    const {
      hls
    } = this;
    hls.on(Events.MANIFEST_LOADING, this.onManifestLoading, this);
    hls.on(Events.LEVEL_LOADING, this.onLevelLoading, this);
    hls.on(Events.AUDIO_TRACK_LOADING, this.onAudioTrackLoading, this);
    hls.on(Events.SUBTITLE_TRACK_LOADING, this.onSubtitleTrackLoading, this);
  }
  unregisterListeners() {
    const {
      hls
    } = this;
    hls.off(Events.MANIFEST_LOADING, this.onManifestLoading, this);
    hls.off(Events.LEVEL_LOADING, this.onLevelLoading, this);
    hls.off(Events.AUDIO_TRACK_LOADING, this.onAudioTrackLoading, this);
    hls.off(Events.SUBTITLE_TRACK_LOADING, this.onSubtitleTrackLoading, this);
  }

  /**
   * Returns defaults or configured loader-type overloads (pLoader and loader config params)
   */
  createInternalLoader(context) {
    const config = this.hls.config;
    const PLoader = config.pLoader;
    const Loader = config.loader;
    const InternalLoader = PLoader || Loader;
    const loader = new InternalLoader(config);
    this.loaders[context.type] = loader;
    return loader;
  }
  getInternalLoader(context) {
    return this.loaders[context.type];
  }
  resetInternalLoader(contextType) {
    if (this.loaders[contextType]) {
      delete this.loaders[contextType];
    }
  }

  /**
   * Call `destroy` on all internal loader instances mapped (one per context type)
   */
  destroyInternalLoaders() {
    for (const contextType in this.loaders) {
      const loader = this.loaders[contextType];
      if (loader) {
        loader.destroy();
      }
      this.resetInternalLoader(contextType);
    }
  }
  destroy() {
    this.variableList = null;
    this.unregisterListeners();
    this.destroyInternalLoaders();
  }
  onManifestLoading(event, data) {
    const {
      url
    } = data;
    this.variableList = null;
    this.load({
      id: null,
      level: 0,
      responseType: 'text',
      type: PlaylistContextType.MANIFEST,
      url,
      deliveryDirectives: null
    });
  }
  onLevelLoading(event, data) {
    const {
      id,
      level,
      pathwayId,
      url,
      deliveryDirectives
    } = data;
    this.load({
      id,
      level,
      pathwayId,
      responseType: 'text',
      type: PlaylistContextType.LEVEL,
      url,
      deliveryDirectives
    });
  }
  onAudioTrackLoading(event, data) {
    const {
      id,
      groupId,
      url,
      deliveryDirectives
    } = data;
    this.load({
      id,
      groupId,
      level: null,
      responseType: 'text',
      type: PlaylistContextType.AUDIO_TRACK,
      url,
      deliveryDirectives
    });
  }
  onSubtitleTrackLoading(event, data) {
    const {
      id,
      groupId,
      url,
      deliveryDirectives
    } = data;
    this.load({
      id,
      groupId,
      level: null,
      responseType: 'text',
      type: PlaylistContextType.SUBTITLE_TRACK,
      url,
      deliveryDirectives
    });
  }
  load(context) {
    var _context$deliveryDire;
    const config = this.hls.config;

    // logger.debug(`[playlist-loader]: Loading playlist of type ${context.type}, level: ${context.level}, id: ${context.id}`);

    // Check if a loader for this context already exists
    let loader = this.getInternalLoader(context);
    if (loader) {
      const loaderContext = loader.context;
      if (loaderContext && loaderContext.url === context.url && loaderContext.level === context.level) {
        // same URL can't overlap
        logger.trace('[playlist-loader]: playlist request ongoing');
        return;
      }
      logger.log(`[playlist-loader]: aborting previous loader for type: ${context.type}`);
      loader.abort();
    }

    // apply different configs for retries depending on
    // context (manifest, level, audio/subs playlist)
    let loadPolicy;
    if (context.type === PlaylistContextType.MANIFEST) {
      loadPolicy = config.manifestLoadPolicy.default;
    } else {
      loadPolicy = _extends({}, config.playlistLoadPolicy.default, {
        timeoutRetry: null,
        errorRetry: null
      });
    }
    loader = this.createInternalLoader(context);

    // Override level/track timeout for LL-HLS requests
    // (the default of 10000ms is counter productive to blocking playlist reload requests)
    if (isFiniteNumber((_context$deliveryDire = context.deliveryDirectives) == null ? void 0 : _context$deliveryDire.part)) {
      let levelDetails;
      if (context.type === PlaylistContextType.LEVEL && context.level !== null) {
        levelDetails = this.hls.levels[context.level].details;
      } else if (context.type === PlaylistContextType.AUDIO_TRACK && context.id !== null) {
        levelDetails = this.hls.audioTracks[context.id].details;
      } else if (context.type === PlaylistContextType.SUBTITLE_TRACK && context.id !== null) {
        levelDetails = this.hls.subtitleTracks[context.id].details;
      }
      if (levelDetails) {
        const partTarget = levelDetails.partTarget;
        const targetDuration = levelDetails.targetduration;
        if (partTarget && targetDuration) {
          const maxLowLatencyPlaylistRefresh = Math.max(partTarget * 3, targetDuration * 0.8) * 1000;
          loadPolicy = _extends({}, loadPolicy, {
            maxTimeToFirstByteMs: Math.min(maxLowLatencyPlaylistRefresh, loadPolicy.maxTimeToFirstByteMs),
            maxLoadTimeMs: Math.min(maxLowLatencyPlaylistRefresh, loadPolicy.maxTimeToFirstByteMs)
          });
        }
      }
    }
    const legacyRetryCompatibility = loadPolicy.errorRetry || loadPolicy.timeoutRetry || {};
    const loaderConfig = {
      loadPolicy,
      timeout: loadPolicy.maxLoadTimeMs,
      maxRetry: legacyRetryCompatibility.maxNumRetry || 0,
      retryDelay: legacyRetryCompatibility.retryDelayMs || 0,
      maxRetryDelay: legacyRetryCompatibility.maxRetryDelayMs || 0
    };
    const loaderCallbacks = {
      onSuccess: (response, stats, context, networkDetails) => {
        const loader = this.getInternalLoader(context);
        this.resetInternalLoader(context.type);
        const string = response.data;

        // Validate if it is an M3U8 at all
        if (string.indexOf('#EXTM3U') !== 0) {
          this.handleManifestParsingError(response, context, new Error('no EXTM3U delimiter'), networkDetails || null, stats);
          return;
        }
        stats.parsing.start = performance.now();
        if (M3U8Parser.isMediaPlaylist(string)) {
          this.handleTrackOrLevelPlaylist(response, stats, context, networkDetails || null, loader);
        } else {
          this.handleMasterPlaylist(response, stats, context, networkDetails);
        }
      },
      onError: (response, context, networkDetails, stats) => {
        this.handleNetworkError(context, networkDetails, false, response, stats);
      },
      onTimeout: (stats, context, networkDetails) => {
        this.handleNetworkError(context, networkDetails, true, undefined, stats);
      }
    };

    // logger.debug(`[playlist-loader]: Calling internal loader delegate for URL: ${context.url}`);

    loader.load(context, loaderConfig, loaderCallbacks);
  }
  handleMasterPlaylist(response, stats, context, networkDetails) {
    const hls = this.hls;
    const string = response.data;
    const url = getResponseUrl(response, context);
    const parsedResult = M3U8Parser.parseMasterPlaylist(string, url);
    if (parsedResult.playlistParsingError) {
      this.handleManifestParsingError(response, context, parsedResult.playlistParsingError, networkDetails, stats);
      return;
    }
    const {
      contentSteering,
      levels,
      sessionData,
      sessionKeys,
      startTimeOffset,
      variableList
    } = parsedResult;
    this.variableList = variableList;
    const {
      AUDIO: audioTracks = [],
      SUBTITLES: subtitles,
      'CLOSED-CAPTIONS': captions
    } = M3U8Parser.parseMasterPlaylistMedia(string, url, parsedResult);
    if (audioTracks.length) {
      // check if we have found an audio track embedded in main playlist (audio track without URI attribute)
      const embeddedAudioFound = audioTracks.some(audioTrack => !audioTrack.url);

      // if no embedded audio track defined, but audio codec signaled in quality level,
      // we need to signal this main audio track this could happen with playlists with
      // alt audio rendition in which quality levels (main)
      // contains both audio+video. but with mixed audio track not signaled
      if (!embeddedAudioFound && levels[0].audioCodec && !levels[0].attrs.AUDIO) {
        logger.log('[playlist-loader]: audio codec signaled in quality level, but no embedded audio track signaled, create one');
        audioTracks.unshift({
          type: 'main',
          name: 'main',
          groupId: 'main',
          default: false,
          autoselect: false,
          forced: false,
          id: -1,
          attrs: new AttrList({}),
          bitrate: 0,
          url: ''
        });
      }
    }
    hls.trigger(Events.MANIFEST_LOADED, {
      levels,
      audioTracks,
      subtitles,
      captions,
      contentSteering,
      url,
      stats,
      networkDetails,
      sessionData,
      sessionKeys,
      startTimeOffset,
      variableList
    });
  }
  handleTrackOrLevelPlaylist(response, stats, context, networkDetails, loader) {
    const hls = this.hls;
    const {
      id,
      level,
      type
    } = context;
    const url = getResponseUrl(response, context);
    const levelUrlId = 0;
    const levelId = isFiniteNumber(level) ? level : isFiniteNumber(id) ? id : 0;
    const levelType = mapContextToLevelType(context);
    const levelDetails = M3U8Parser.parseLevelPlaylist(response.data, url, levelId, levelType, levelUrlId, this.variableList);

    // We have done our first request (Manifest-type) and receive
    // not a master playlist but a chunk-list (track/level)
    // We fire the manifest-loaded event anyway with the parsed level-details
    // by creating a single-level structure for it.
    if (type === PlaylistContextType.MANIFEST) {
      const singleLevel = {
        attrs: new AttrList({}),
        bitrate: 0,
        details: levelDetails,
        name: '',
        url
      };
      hls.trigger(Events.MANIFEST_LOADED, {
        levels: [singleLevel],
        audioTracks: [],
        url,
        stats,
        networkDetails,
        sessionData: null,
        sessionKeys: null,
        contentSteering: null,
        startTimeOffset: null,
        variableList: null
      });
    }

    // save parsing time
    stats.parsing.end = performance.now();

    // extend the context with the new levelDetails property
    context.levelDetails = levelDetails;
    this.handlePlaylistLoaded(levelDetails, response, stats, context, networkDetails, loader);
  }
  handleManifestParsingError(response, context, error, networkDetails, stats) {
    this.hls.trigger(Events.ERROR, {
      type: ErrorTypes.NETWORK_ERROR,
      details: ErrorDetails.MANIFEST_PARSING_ERROR,
      fatal: context.type === PlaylistContextType.MANIFEST,
      url: response.url,
      err: error,
      error,
      reason: error.message,
      response,
      context,
      networkDetails,
      stats
    });
  }
  handleNetworkError(context, networkDetails, timeout = false, response, stats) {
    let message = `A network ${timeout ? 'timeout' : 'error' + (response ? ' (status ' + response.code + ')' : '')} occurred while loading ${context.type}`;
    if (context.type === PlaylistContextType.LEVEL) {
      message += `: ${context.level} id: ${context.id}`;
    } else if (context.type === PlaylistContextType.AUDIO_TRACK || context.type === PlaylistContextType.SUBTITLE_TRACK) {
      message += ` id: ${context.id} group-id: "${context.groupId}"`;
    }
    const error = new Error(message);
    logger.warn(`[playlist-loader]: ${message}`);
    let details = ErrorDetails.UNKNOWN;
    let fatal = false;
    const loader = this.getInternalLoader(context);
    switch (context.type) {
      case PlaylistContextType.MANIFEST:
        details = timeout ? ErrorDetails.MANIFEST_LOAD_TIMEOUT : ErrorDetails.MANIFEST_LOAD_ERROR;
        fatal = true;
        break;
      case PlaylistContextType.LEVEL:
        details = timeout ? ErrorDetails.LEVEL_LOAD_TIMEOUT : ErrorDetails.LEVEL_LOAD_ERROR;
        fatal = false;
        break;
      case PlaylistContextType.AUDIO_TRACK:
        details = timeout ? ErrorDetails.AUDIO_TRACK_LOAD_TIMEOUT : ErrorDetails.AUDIO_TRACK_LOAD_ERROR;
        fatal = false;
        break;
      case PlaylistContextType.SUBTITLE_TRACK:
        details = timeout ? ErrorDetails.SUBTITLE_TRACK_LOAD_TIMEOUT : ErrorDetails.SUBTITLE_LOAD_ERROR;
        fatal = false;
        break;
    }
    if (loader) {
      this.resetInternalLoader(context.type);
    }
    const errorData = {
      type: ErrorTypes.NETWORK_ERROR,
      details,
      fatal,
      url: context.url,
      loader,
      context,
      error,
      networkDetails,
      stats
    };
    if (response) {
      const url = (networkDetails == null ? void 0 : networkDetails.url) || context.url;
      errorData.response = _objectSpread2({
        url,
        data: undefined
      }, response);
    }
    this.hls.trigger(Events.ERROR, errorData);
  }
  handlePlaylistLoaded(levelDetails, response, stats, context, networkDetails, loader) {
    const hls = this.hls;
    const {
      type,
      level,
      id,
      groupId,
      deliveryDirectives
    } = context;
    const url = getResponseUrl(response, context);
    const parent = mapContextToLevelType(context);
    const levelIndex = typeof context.level === 'number' && parent === PlaylistLevelType.MAIN ? level : undefined;
    if (!levelDetails.fragments.length) {
      const _error = new Error('No Segments found in Playlist');
      hls.trigger(Events.ERROR, {
        type: ErrorTypes.NETWORK_ERROR,
        details: ErrorDetails.LEVEL_EMPTY_ERROR,
        fatal: false,
        url,
        error: _error,
        reason: _error.message,
        response,
        context,
        level: levelIndex,
        parent,
        networkDetails,
        stats
      });
      return;
    }
    if (!levelDetails.targetduration) {
      levelDetails.playlistParsingError = new Error('Missing Target Duration');
    }
    const error = levelDetails.playlistParsingError;
    if (error) {
      hls.trigger(Events.ERROR, {
        type: ErrorTypes.NETWORK_ERROR,
        details: ErrorDetails.LEVEL_PARSING_ERROR,
        fatal: false,
        url,
        error,
        reason: error.message,
        response,
        context,
        level: levelIndex,
        parent,
        networkDetails,
        stats
      });
      return;
    }
    if (levelDetails.live && loader) {
      if (loader.getCacheAge) {
        levelDetails.ageHeader = loader.getCacheAge() || 0;
      }
      if (!loader.getCacheAge || isNaN(levelDetails.ageHeader)) {
        levelDetails.ageHeader = 0;
      }
    }
    switch (type) {
      case PlaylistContextType.MANIFEST:
      case PlaylistContextType.LEVEL:
        hls.trigger(Events.LEVEL_LOADED, {
          details: levelDetails,
          level: levelIndex || 0,
          id: id || 0,
          stats,
          networkDetails,
          deliveryDirectives
        });
        break;
      case PlaylistContextType.AUDIO_TRACK:
        hls.trigger(Events.AUDIO_TRACK_LOADED, {
          details: levelDetails,
          id: id || 0,
          groupId: groupId || '',
          stats,
          networkDetails,
          deliveryDirectives
        });
        break;
      case PlaylistContextType.SUBTITLE_TRACK:
        hls.trigger(Events.SUBTITLE_TRACK_LOADED, {
          details: levelDetails,
          id: id || 0,
          groupId: groupId || '',
          stats,
          networkDetails,
          deliveryDirectives
        });
        break;
    }
  }
}

function sendAddTrackEvent(track, videoEl) {
  let event;
  try {
    event = new Event('addtrack');
  } catch (err) {
    // for IE11
    event = document.createEvent('Event');
    event.initEvent('addtrack', false, false);
  }
  event.track = track;
  videoEl.dispatchEvent(event);
}
function addCueToTrack(track, cue) {
  // Sometimes there are cue overlaps on segmented vtts so the same
  // cue can appear more than once in different vtt files.
  // This avoid showing duplicated cues with same timecode and text.
  const mode = track.mode;
  if (mode === 'disabled') {
    track.mode = 'hidden';
  }
  if (track.cues && !track.cues.getCueById(cue.id)) {
    try {
      track.addCue(cue);
      if (!track.cues.getCueById(cue.id)) {
        throw new Error(`addCue is failed for: ${cue}`);
      }
    } catch (err) {
      logger.debug(`[texttrack-utils]: ${err}`);
      try {
        const textTrackCue = new self.TextTrackCue(cue.startTime, cue.endTime, cue.text);
        textTrackCue.id = cue.id;
        track.addCue(textTrackCue);
      } catch (err2) {
        logger.debug(`[texttrack-utils]: Legacy TextTrackCue fallback failed: ${err2}`);
      }
    }
  }
  if (mode === 'disabled') {
    track.mode = mode;
  }
}
function clearCurrentCues(track) {
  // When track.mode is disabled, track.cues will be null.
  // To guarantee the removal of cues, we need to temporarily
  // change the mode to hidden
  const mode = track.mode;
  if (mode === 'disabled') {
    track.mode = 'hidden';
  }
  if (track.cues) {
    for (let i = track.cues.length; i--;) {
      track.removeCue(track.cues[i]);
    }
  }
  if (mode === 'disabled') {
    track.mode = mode;
  }
}
function removeCuesInRange(track, start, end, predicate) {
  const mode = track.mode;
  if (mode === 'disabled') {
    track.mode = 'hidden';
  }
  if (track.cues && track.cues.length > 0) {
    const cues = getCuesInRange(track.cues, start, end);
    for (let i = 0; i < cues.length; i++) {
      if (!predicate || predicate(cues[i])) {
        track.removeCue(cues[i]);
      }
    }
  }
  if (mode === 'disabled') {
    track.mode = mode;
  }
}

// Find first cue starting after given time.
// Modified version of binary search O(log(n)).
function getFirstCueIndexAfterTime(cues, time) {
  // If first cue starts after time, start there
  if (time < cues[0].startTime) {
    return 0;
  }
  // If the last cue ends before time there is no overlap
  const len = cues.length - 1;
  if (time > cues[len].endTime) {
    return -1;
  }
  let left = 0;
  let right = len;
  while (left <= right) {
    const mid = Math.floor((right + left) / 2);
    if (time < cues[mid].startTime) {
      right = mid - 1;
    } else if (time > cues[mid].startTime && left < len) {
      left = mid + 1;
    } else {
      // If it's not lower or higher, it must be equal.
      return mid;
    }
  }
  // At this point, left and right have swapped.
  // No direct match was found, left or right element must be the closest. Check which one has the smallest diff.
  return cues[left].startTime - time < time - cues[right].startTime ? left : right;
}
function getCuesInRange(cues, start, end) {
  const cuesFound = [];
  const firstCueInRange = getFirstCueIndexAfterTime(cues, start);
  if (firstCueInRange > -1) {
    for (let i = firstCueInRange, len = cues.length; i < len; i++) {
      const cue = cues[i];
      if (cue.startTime >= start && cue.endTime <= end) {
        cuesFound.push(cue);
      } else if (cue.startTime > end) {
        return cuesFound;
      }
    }
  }
  return cuesFound;
}
function filterSubtitleTracks(textTrackList) {
  const tracks = [];
  for (let i = 0; i < textTrackList.length; i++) {
    const track = textTrackList[i];
    // Edge adds a track without a label; we don't want to use it
    if ((track.kind === 'subtitles' || track.kind === 'captions') && track.label) {
      tracks.push(textTrackList[i]);
    }
  }
  return tracks;
}

var MetadataSchema = {
  audioId3: "org.id3",
  dateRange: "com.apple.quicktime.HLS",
  emsg: "https://aomedia.org/emsg/ID3"
};

const MIN_CUE_DURATION = 0.25;
function getCueClass() {
  if (typeof self === 'undefined') return undefined;
  return self.VTTCue || self.TextTrackCue;
}
function createCueWithDataFields(Cue, startTime, endTime, data, type) {
  let cue = new Cue(startTime, endTime, '');
  try {
    cue.value = data;
    if (type) {
      cue.type = type;
    }
  } catch (e) {
    cue = new Cue(startTime, endTime, JSON.stringify(type ? _objectSpread2({
      type
    }, data) : data));
  }
  return cue;
}

// VTTCue latest draft allows an infinite duration, fallback
// to MAX_VALUE if necessary
const MAX_CUE_ENDTIME = (() => {
  const Cue = getCueClass();
  try {
    Cue && new Cue(0, Number.POSITIVE_INFINITY, '');
  } catch (e) {
    return Number.MAX_VALUE;
  }
  return Number.POSITIVE_INFINITY;
})();
function dateRangeDateToTimelineSeconds(date, offset) {
  return date.getTime() / 1000 - offset;
}
function hexToArrayBuffer(str) {
  return Uint8Array.from(str.replace(/^0x/, '').replace(/([\da-fA-F]{2}) ?/g, '0x$1 ').replace(/ +$/, '').split(' ')).buffer;
}
class ID3TrackController {
  constructor(hls) {
    this.hls = void 0;
    this.id3Track = null;
    this.media = null;
    this.dateRangeCuesAppended = {};
    this.hls = hls;
    this._registerListeners();
  }
  destroy() {
    this._unregisterListeners();
    this.id3Track = null;
    this.media = null;
    this.dateRangeCuesAppended = {};
    // @ts-ignore
    this.hls = null;
  }
  _registerListeners() {
    const {
      hls
    } = this;
    hls.on(Events.MEDIA_ATTACHED, this.onMediaAttached, this);
    hls.on(Events.MEDIA_DETACHING, this.onMediaDetaching, this);
    hls.on(Events.MANIFEST_LOADING, this.onManifestLoading, this);
    hls.on(Events.FRAG_PARSING_METADATA, this.onFragParsingMetadata, this);
    hls.on(Events.BUFFER_FLUSHING, this.onBufferFlushing, this);
    hls.on(Events.LEVEL_UPDATED, this.onLevelUpdated, this);
  }
  _unregisterListeners() {
    const {
      hls
    } = this;
    hls.off(Events.MEDIA_ATTACHED, this.onMediaAttached, this);
    hls.off(Events.MEDIA_DETACHING, this.onMediaDetaching, this);
    hls.off(Events.MANIFEST_LOADING, this.onManifestLoading, this);
    hls.off(Events.FRAG_PARSING_METADATA, this.onFragParsingMetadata, this);
    hls.off(Events.BUFFER_FLUSHING, this.onBufferFlushing, this);
    hls.off(Events.LEVEL_UPDATED, this.onLevelUpdated, this);
  }

  // Add ID3 metatadata text track.
  onMediaAttached(event, data) {
    this.media = data.media;
  }
  onMediaDetaching() {
    if (!this.id3Track) {
      return;
    }
    clearCurrentCues(this.id3Track);
    this.id3Track = null;
    this.media = null;
    this.dateRangeCuesAppended = {};
  }
  onManifestLoading() {
    this.dateRangeCuesAppended = {};
  }
  createTrack(media) {
    const track = this.getID3Track(media.textTracks);
    track.mode = 'hidden';
    return track;
  }
  getID3Track(textTracks) {
    if (!this.media) {
      return;
    }
    for (let i = 0; i < textTracks.length; i++) {
      const textTrack = textTracks[i];
      if (textTrack.kind === 'metadata' && textTrack.label === 'id3') {
        // send 'addtrack' when reusing the textTrack for metadata,
        // same as what we do for captions
        sendAddTrackEvent(textTrack, this.media);
        return textTrack;
      }
    }
    return this.media.addTextTrack('metadata', 'id3');
  }
  onFragParsingMetadata(event, data) {
    if (!this.media) {
      return;
    }
    const {
      hls: {
        config: {
          enableEmsgMetadataCues,
          enableID3MetadataCues
        }
      }
    } = this;
    if (!enableEmsgMetadataCues && !enableID3MetadataCues) {
      return;
    }
    const {
      samples
    } = data;

    // create track dynamically
    if (!this.id3Track) {
      this.id3Track = this.createTrack(this.media);
    }
    const Cue = getCueClass();
    if (!Cue) {
      return;
    }
    for (let i = 0; i < samples.length; i++) {
      const type = samples[i].type;
      if (type === MetadataSchema.emsg && !enableEmsgMetadataCues || !enableID3MetadataCues) {
        continue;
      }
      const frames = getID3Frames(samples[i].data);
      if (frames) {
        const startTime = samples[i].pts;
        let endTime = startTime + samples[i].duration;
        if (endTime > MAX_CUE_ENDTIME) {
          endTime = MAX_CUE_ENDTIME;
        }
        const timeDiff = endTime - startTime;
        if (timeDiff <= 0) {
          endTime = startTime + MIN_CUE_DURATION;
        }
        for (let j = 0; j < frames.length; j++) {
          const frame = frames[j];
          // Safari doesn't put the timestamp frame in the TextTrack
          if (!isTimeStampFrame(frame)) {
            // add a bounds to any unbounded cues
            this.updateId3CueEnds(startTime, type);
            const cue = createCueWithDataFields(Cue, startTime, endTime, frame, type);
            if (cue) {
              this.id3Track.addCue(cue);
            }
          }
        }
      }
    }
  }
  updateId3CueEnds(startTime, type) {
    var _this$id3Track;
    const cues = (_this$id3Track = this.id3Track) == null ? void 0 : _this$id3Track.cues;
    if (cues) {
      for (let i = cues.length; i--;) {
        const cue = cues[i];
        if (cue.type === type && cue.startTime < startTime && cue.endTime === MAX_CUE_ENDTIME) {
          cue.endTime = startTime;
        }
      }
    }
  }
  onBufferFlushing(event, {
    startOffset,
    endOffset,
    type
  }) {
    const {
      id3Track,
      hls
    } = this;
    if (!hls) {
      return;
    }
    const {
      config: {
        enableEmsgMetadataCues,
        enableID3MetadataCues
      }
    } = hls;
    if (id3Track && (enableEmsgMetadataCues || enableID3MetadataCues)) {
      let predicate;
      if (type === 'audio') {
        predicate = cue => cue.type === MetadataSchema.audioId3 && enableID3MetadataCues;
      } else if (type === 'video') {
        predicate = cue => cue.type === MetadataSchema.emsg && enableEmsgMetadataCues;
      } else {
        predicate = cue => cue.type === MetadataSchema.audioId3 && enableID3MetadataCues || cue.type === MetadataSchema.emsg && enableEmsgMetadataCues;
      }
      removeCuesInRange(id3Track, startOffset, endOffset, predicate);
    }
  }
  onLevelUpdated(event, {
    details
  }) {
    if (!this.media || !details.hasProgramDateTime || !this.hls.config.enableDateRangeMetadataCues) {
      return;
    }
    const {
      dateRangeCuesAppended,
      id3Track
    } = this;
    const {
      dateRanges
    } = details;
    const ids = Object.keys(dateRanges);
    // Remove cues from track not found in details.dateRanges
    if (id3Track) {
      const idsToRemove = Object.keys(dateRangeCuesAppended).filter(id => !ids.includes(id));
      for (let i = idsToRemove.length; i--;) {
        const id = idsToRemove[i];
        Object.keys(dateRangeCuesAppended[id].cues).forEach(key => {
          id3Track.removeCue(dateRangeCuesAppended[id].cues[key]);
        });
        delete dateRangeCuesAppended[id];
      }
    }
    // Exit if the playlist does not have Date Ranges or does not have Program Date Time
    const lastFragment = details.fragments[details.fragments.length - 1];
    if (ids.length === 0 || !isFiniteNumber(lastFragment == null ? void 0 : lastFragment.programDateTime)) {
      return;
    }
    if (!this.id3Track) {
      this.id3Track = this.createTrack(this.media);
    }
    const dateTimeOffset = lastFragment.programDateTime / 1000 - lastFragment.start;
    const Cue = getCueClass();
    for (let i = 0; i < ids.length; i++) {
      const id = ids[i];
      const dateRange = dateRanges[id];
      const startTime = dateRangeDateToTimelineSeconds(dateRange.startDate, dateTimeOffset);

      // Process DateRanges to determine end-time (known DURATION, END-DATE, or END-ON-NEXT)
      const appendedDateRangeCues = dateRangeCuesAppended[id];
      const cues = (appendedDateRangeCues == null ? void 0 : appendedDateRangeCues.cues) || {};
      let durationKnown = (appendedDateRangeCues == null ? void 0 : appendedDateRangeCues.durationKnown) || false;
      let endTime = MAX_CUE_ENDTIME;
      const endDate = dateRange.endDate;
      if (endDate) {
        endTime = dateRangeDateToTimelineSeconds(endDate, dateTimeOffset);
        durationKnown = true;
      } else if (dateRange.endOnNext && !durationKnown) {
        const nextDateRangeWithSameClass = ids.reduce((candidateDateRange, id) => {
          if (id !== dateRange.id) {
            const otherDateRange = dateRanges[id];
            if (otherDateRange.class === dateRange.class && otherDateRange.startDate > dateRange.startDate && (!candidateDateRange || dateRange.startDate < candidateDateRange.startDate)) {
              return otherDateRange;
            }
          }
          return candidateDateRange;
        }, null);
        if (nextDateRangeWithSameClass) {
          endTime = dateRangeDateToTimelineSeconds(nextDateRangeWithSameClass.startDate, dateTimeOffset);
          durationKnown = true;
        }
      }

      // Create TextTrack Cues for each MetadataGroup Item (select DateRange attribute)
      // This is to emulate Safari HLS playback handling of DateRange tags
      const attributes = Object.keys(dateRange.attr);
      for (let j = 0; j < attributes.length; j++) {
        const key = attributes[j];
        if (!isDateRangeCueAttribute(key)) {
          continue;
        }
        const cue = cues[key];
        if (cue) {
          if (durationKnown && !appendedDateRangeCues.durationKnown) {
            cue.endTime = endTime;
          }
        } else if (Cue) {
          let data = dateRange.attr[key];
          if (isSCTE35Attribute(key)) {
            data = hexToArrayBuffer(data);
          }
          const _cue = createCueWithDataFields(Cue, startTime, endTime, {
            key,
            data
          }, MetadataSchema.dateRange);
          if (_cue) {
            _cue.id = id;
            this.id3Track.addCue(_cue);
            cues[key] = _cue;
          }
        }
      }

      // Keep track of processed DateRanges by ID for updating cues with new DateRange tag attributes
      dateRangeCuesAppended[id] = {
        cues,
        dateRange,
        durationKnown
      };
    }
  }
}

class LatencyController {
  constructor(hls) {
    this.hls = void 0;
    this.config = void 0;
    this.media = null;
    this.levelDetails = null;
    this.currentTime = 0;
    this.stallCount = 0;
    this._latency = null;
    this.timeupdateHandler = () => this.timeupdate();
    this.hls = hls;
    this.config = hls.config;
    this.registerListeners();
  }
  get latency() {
    return this._latency || 0;
  }
  get maxLatency() {
    const {
      config,
      levelDetails
    } = this;
    if (config.liveMaxLatencyDuration !== undefined) {
      return config.liveMaxLatencyDuration;
    }
    return levelDetails ? config.liveMaxLatencyDurationCount * levelDetails.targetduration : 0;
  }
  get targetLatency() {
    const {
      levelDetails
    } = this;
    if (levelDetails === null) {
      return null;
    }
    const {
      holdBack,
      partHoldBack,
      targetduration
    } = levelDetails;
    const {
      liveSyncDuration,
      liveSyncDurationCount,
      lowLatencyMode
    } = this.config;
    const userConfig = this.hls.userConfig;
    let targetLatency = lowLatencyMode ? partHoldBack || holdBack : holdBack;
    if (userConfig.liveSyncDuration || userConfig.liveSyncDurationCount || targetLatency === 0) {
      targetLatency = liveSyncDuration !== undefined ? liveSyncDuration : liveSyncDurationCount * targetduration;
    }
    const maxLiveSyncOnStallIncrease = targetduration;
    const liveSyncOnStallIncrease = 1.0;
    return targetLatency + Math.min(this.stallCount * liveSyncOnStallIncrease, maxLiveSyncOnStallIncrease);
  }
  get liveSyncPosition() {
    const liveEdge = this.estimateLiveEdge();
    const targetLatency = this.targetLatency;
    const levelDetails = this.levelDetails;
    if (liveEdge === null || targetLatency === null || levelDetails === null) {
      return null;
    }
    const edge = levelDetails.edge;
    const syncPosition = liveEdge - targetLatency - this.edgeStalled;
    const min = edge - levelDetails.totalduration;
    const max = edge - (this.config.lowLatencyMode && levelDetails.partTarget || levelDetails.targetduration);
    return Math.min(Math.max(min, syncPosition), max);
  }
  get drift() {
    const {
      levelDetails
    } = this;
    if (levelDetails === null) {
      return 1;
    }
    return levelDetails.drift;
  }
  get edgeStalled() {
    const {
      levelDetails
    } = this;
    if (levelDetails === null) {
      return 0;
    }
    const maxLevelUpdateAge = (this.config.lowLatencyMode && levelDetails.partTarget || levelDetails.targetduration) * 3;
    return Math.max(levelDetails.age - maxLevelUpdateAge, 0);
  }
  get forwardBufferLength() {
    const {
      media,
      levelDetails
    } = this;
    if (!media || !levelDetails) {
      return 0;
    }
    const bufferedRanges = media.buffered.length;
    return (bufferedRanges ? media.buffered.end(bufferedRanges - 1) : levelDetails.edge) - this.currentTime;
  }
  destroy() {
    this.unregisterListeners();
    this.onMediaDetaching();
    this.levelDetails = null;
    // @ts-ignore
    this.hls = this.timeupdateHandler = null;
  }
  registerListeners() {
    this.hls.on(Events.MEDIA_ATTACHED, this.onMediaAttached, this);
    this.hls.on(Events.MEDIA_DETACHING, this.onMediaDetaching, this);
    this.hls.on(Events.MANIFEST_LOADING, this.onManifestLoading, this);
    this.hls.on(Events.LEVEL_UPDATED, this.onLevelUpdated, this);
    this.hls.on(Events.ERROR, this.onError, this);
  }
  unregisterListeners() {
    this.hls.off(Events.MEDIA_ATTACHED, this.onMediaAttached, this);
    this.hls.off(Events.MEDIA_DETACHING, this.onMediaDetaching, this);
    this.hls.off(Events.MANIFEST_LOADING, this.onManifestLoading, this);
    this.hls.off(Events.LEVEL_UPDATED, this.onLevelUpdated, this);
    this.hls.off(Events.ERROR, this.onError, this);
  }
  onMediaAttached(event, data) {
    this.media = data.media;
    this.media.addEventListener('timeupdate', this.timeupdateHandler);
  }
  onMediaDetaching() {
    if (this.media) {
      this.media.removeEventListener('timeupdate', this.timeupdateHandler);
      this.media = null;
    }
  }
  onManifestLoading() {
    this.levelDetails = null;
    this._latency = null;
    this.stallCount = 0;
  }
  onLevelUpdated(event, {
    details
  }) {
    this.levelDetails = details;
    if (details.advanced) {
      this.timeupdate();
    }
    if (!details.live && this.media) {
      this.media.removeEventListener('timeupdate', this.timeupdateHandler);
    }
  }
  onError(event, data) {
    var _this$levelDetails;
    if (data.details !== ErrorDetails.BUFFER_STALLED_ERROR) {
      return;
    }
    this.stallCount++;
    if ((_this$levelDetails = this.levelDetails) != null && _this$levelDetails.live) {
      logger.warn('[playback-rate-controller]: Stall detected, adjusting target latency');
    }
  }
  timeupdate() {
    const {
      media,
      levelDetails
    } = this;
    if (!media || !levelDetails) {
      return;
    }
    this.currentTime = media.currentTime;
    const latency = this.computeLatency();
    if (latency === null) {
      return;
    }
    this._latency = latency;

    // Adapt playbackRate to meet target latency in low-latency mode
    const {
      lowLatencyMode,
      maxLiveSyncPlaybackRate
    } = this.config;
    if (!lowLatencyMode || maxLiveSyncPlaybackRate === 1 || !levelDetails.live) {
      return;
    }
    const targetLatency = this.targetLatency;
    if (targetLatency === null) {
      return;
    }
    const distanceFromTarget = latency - targetLatency;
    // Only adjust playbackRate when within one target duration of targetLatency
    // and more than one second from under-buffering.
    // Playback further than one target duration from target can be considered DVR playback.
    const liveMinLatencyDuration = Math.min(this.maxLatency, targetLatency + levelDetails.targetduration);
    const inLiveRange = distanceFromTarget < liveMinLatencyDuration;
    if (inLiveRange && distanceFromTarget > 0.05 && this.forwardBufferLength > 1) {
      const max = Math.min(2, Math.max(1.0, maxLiveSyncPlaybackRate));
      const rate = Math.round(2 / (1 + Math.exp(-0.75 * distanceFromTarget - this.edgeStalled)) * 20) / 20;
      media.playbackRate = Math.min(max, Math.max(1, rate));
    } else if (media.playbackRate !== 1 && media.playbackRate !== 0) {
      media.playbackRate = 1;
    }
  }
  estimateLiveEdge() {
    const {
      levelDetails
    } = this;
    if (levelDetails === null) {
      return null;
    }
    return levelDetails.edge + levelDetails.age;
  }
  computeLatency() {
    const liveEdge = this.estimateLiveEdge();
    if (liveEdge === null) {
      return null;
    }
    return liveEdge - this.currentTime;
  }
}

const HdcpLevels = ['NONE', 'TYPE-0', 'TYPE-1', null];
function isHdcpLevel(value) {
  return HdcpLevels.indexOf(value) > -1;
}
const VideoRangeValues = ['SDR', 'PQ', 'HLG'];
function isVideoRange(value) {
  return !!value && VideoRangeValues.indexOf(value) > -1;
}
var HlsSkip = {
  No: "",
  Yes: "YES",
  v2: "v2"
};
function getSkipValue(details) {
  const {
    canSkipUntil,
    canSkipDateRanges,
    age
  } = details;
  // A Client SHOULD NOT request a Playlist Delta Update unless it already
  // has a version of the Playlist that is no older than one-half of the Skip Boundary.
  // @see: https://datatracker.ietf.org/doc/html/draft-pantos-hls-rfc8216bis#section-6.3.7
  const playlistRecentEnough = age < canSkipUntil / 2;
  if (canSkipUntil && playlistRecentEnough) {
    if (canSkipDateRanges) {
      return HlsSkip.v2;
    }
    return HlsSkip.Yes;
  }
  return HlsSkip.No;
}
class HlsUrlParameters {
  constructor(msn, part, skip) {
    this.msn = void 0;
    this.part = void 0;
    this.skip = void 0;
    this.msn = msn;
    this.part = part;
    this.skip = skip;
  }
  addDirectives(uri) {
    const url = new self.URL(uri);
    if (this.msn !== undefined) {
      url.searchParams.set('_HLS_msn', this.msn.toString());
    }
    if (this.part !== undefined) {
      url.searchParams.set('_HLS_part', this.part.toString());
    }
    if (this.skip) {
      url.searchParams.set('_HLS_skip', this.skip);
    }
    return url.href;
  }
}
class Level {
  constructor(data) {
    this._attrs = void 0;
    this.audioCodec = void 0;
    this.bitrate = void 0;
    this.codecSet = void 0;
    this.url = void 0;
    this.frameRate = void 0;
    this.height = void 0;
    this.id = void 0;
    this.name = void 0;
    this.videoCodec = void 0;
    this.width = void 0;
    this.details = void 0;
    this.fragmentError = 0;
    this.loadError = 0;
    this.loaded = void 0;
    this.realBitrate = 0;
    this.supportedPromise = void 0;
    this.supportedResult = void 0;
    this._avgBitrate = 0;
    this._audioGroups = void 0;
    this._subtitleGroups = void 0;
    // Deprecated (retained for backwards compatibility)
    this._urlId = 0;
    this.url = [data.url];
    this._attrs = [data.attrs];
    this.bitrate = data.bitrate;
    if (data.details) {
      this.details = data.details;
    }
    this.id = data.id || 0;
    this.name = data.name;
    this.width = data.width || 0;
    this.height = data.height || 0;
    this.frameRate = data.attrs.optionalFloat('FRAME-RATE', 0);
    this._avgBitrate = data.attrs.decimalInteger('AVERAGE-BANDWIDTH');
    this.audioCodec = data.audioCodec;
    this.videoCodec = data.videoCodec;
    this.codecSet = [data.videoCodec, data.audioCodec].filter(c => !!c).map(s => s.substring(0, 4)).join(',');
    this.addGroupId('audio', data.attrs.AUDIO);
    this.addGroupId('text', data.attrs.SUBTITLES);
  }
  get maxBitrate() {
    return Math.max(this.realBitrate, this.bitrate);
  }
  get averageBitrate() {
    return this._avgBitrate || this.realBitrate || this.bitrate;
  }
  get attrs() {
    return this._attrs[0];
  }
  get codecs() {
    return this.attrs.CODECS || '';
  }
  get pathwayId() {
    return this.attrs['PATHWAY-ID'] || '.';
  }
  get videoRange() {
    return this.attrs['VIDEO-RANGE'] || 'SDR';
  }
  get score() {
    return this.attrs.optionalFloat('SCORE', 0);
  }
  get uri() {
    return this.url[0] || '';
  }
  hasAudioGroup(groupId) {
    return hasGroup(this._audioGroups, groupId);
  }
  hasSubtitleGroup(groupId) {
    return hasGroup(this._subtitleGroups, groupId);
  }
  get audioGroups() {
    return this._audioGroups;
  }
  get subtitleGroups() {
    return this._subtitleGroups;
  }
  addGroupId(type, groupId) {
    if (!groupId) {
      return;
    }
    if (type === 'audio') {
      let audioGroups = this._audioGroups;
      if (!audioGroups) {
        audioGroups = this._audioGroups = [];
      }
      if (audioGroups.indexOf(groupId) === -1) {
        audioGroups.push(groupId);
      }
    } else if (type === 'text') {
      let subtitleGroups = this._subtitleGroups;
      if (!subtitleGroups) {
        subtitleGroups = this._subtitleGroups = [];
      }
      if (subtitleGroups.indexOf(groupId) === -1) {
        subtitleGroups.push(groupId);
      }
    }
  }

  // Deprecated methods (retained for backwards compatibility)
  get urlId() {
    return 0;
  }
  set urlId(value) {}
  get audioGroupIds() {
    return this.audioGroups ? [this.audioGroupId] : undefined;
  }
  get textGroupIds() {
    return this.subtitleGroups ? [this.textGroupId] : undefined;
  }
  get audioGroupId() {
    var _this$audioGroups;
    return (_this$audioGroups = this.audioGroups) == null ? void 0 : _this$audioGroups[0];
  }
  get textGroupId() {
    var _this$subtitleGroups;
    return (_this$subtitleGroups = this.subtitleGroups) == null ? void 0 : _this$subtitleGroups[0];
  }
  addFallback() {}
}
function hasGroup(groups, groupId) {
  if (!groupId || !groups) {
    return false;
  }
  return groups.indexOf(groupId) !== -1;
}

function updateFromToPTS(fragFrom, fragTo) {
  const fragToPTS = fragTo.startPTS;
  // if we know startPTS[toIdx]
  if (isFiniteNumber(fragToPTS)) {
    // update fragment duration.
    // it helps to fix drifts between playlist reported duration and fragment real duration
    let duration = 0;
    let frag;
    if (fragTo.sn > fragFrom.sn) {
      duration = fragToPTS - fragFrom.start;
      frag = fragFrom;
    } else {
      duration = fragFrom.start - fragToPTS;
      frag = fragTo;
    }
    if (frag.duration !== duration) {
      frag.duration = duration;
    }
    // we dont know startPTS[toIdx]
  } else if (fragTo.sn > fragFrom.sn) {
    const contiguous = fragFrom.cc === fragTo.cc;
    // TODO: With part-loading end/durations we need to confirm the whole fragment is loaded before using (or setting) minEndPTS
    if (contiguous && fragFrom.minEndPTS) {
      fragTo.start = fragFrom.start + (fragFrom.minEndPTS - fragFrom.start);
    } else {
      fragTo.start = fragFrom.start + fragFrom.duration;
    }
  } else {
    fragTo.start = Math.max(fragFrom.start - fragTo.duration, 0);
  }
}
function updateFragPTSDTS(details, frag, startPTS, endPTS, startDTS, endDTS) {
  const parsedMediaDuration = endPTS - startPTS;
  if (parsedMediaDuration <= 0) {
    logger.warn('Fragment should have a positive duration', frag);
    endPTS = startPTS + frag.duration;
    endDTS = startDTS + frag.duration;
  }
  let maxStartPTS = startPTS;
  let minEndPTS = endPTS;
  const fragStartPts = frag.startPTS;
  const fragEndPts = frag.endPTS;
  if (isFiniteNumber(fragStartPts)) {
    // delta PTS between audio and video
    const deltaPTS = Math.abs(fragStartPts - startPTS);
    if (!isFiniteNumber(frag.deltaPTS)) {
      frag.deltaPTS = deltaPTS;
    } else {
      frag.deltaPTS = Math.max(deltaPTS, frag.deltaPTS);
    }
    maxStartPTS = Math.max(startPTS, fragStartPts);
    startPTS = Math.min(startPTS, fragStartPts);
    startDTS = Math.min(startDTS, frag.startDTS);
    minEndPTS = Math.min(endPTS, fragEndPts);
    endPTS = Math.max(endPTS, fragEndPts);
    endDTS = Math.max(endDTS, frag.endDTS);
  }
  const drift = startPTS - frag.start;
  if (frag.start !== 0) {
    frag.start = startPTS;
  }
  frag.duration = endPTS - frag.start;
  frag.startPTS = startPTS;
  frag.maxStartPTS = maxStartPTS;
  frag.startDTS = startDTS;
  frag.endPTS = endPTS;
  frag.minEndPTS = minEndPTS;
  frag.endDTS = endDTS;
  const sn = frag.sn; // 'initSegment'
  // exit if sn out of range
  if (!details || sn < details.startSN || sn > details.endSN) {
    return 0;
  }
  let i;
  const fragIdx = sn - details.startSN;
  const fragments = details.fragments;
  // update frag reference in fragments array
  // rationale is that fragments array might not contain this frag object.
  // this will happen if playlist has been refreshed between frag loading and call to updateFragPTSDTS()
  // if we don't update frag, we won't be able to propagate PTS info on the playlist
  // resulting in invalid sliding computation
  fragments[fragIdx] = frag;
  // adjust fragment PTS/duration from seqnum-1 to frag 0
  for (i = fragIdx; i > 0; i--) {
    updateFromToPTS(fragments[i], fragments[i - 1]);
  }

  // adjust fragment PTS/duration from seqnum to last frag
  for (i = fragIdx; i < fragments.length - 1; i++) {
    updateFromToPTS(fragments[i], fragments[i + 1]);
  }
  if (details.fragmentHint) {
    updateFromToPTS(fragments[fragments.length - 1], details.fragmentHint);
  }
  details.PTSKnown = details.alignedSliding = true;
  return drift;
}
function mergeDetails(oldDetails, newDetails) {
  // Track the last initSegment processed. Initialize it to the last one on the timeline.
  let currentInitSegment = null;
  const oldFragments = oldDetails.fragments;
  for (let i = oldFragments.length - 1; i >= 0; i--) {
    const oldInit = oldFragments[i].initSegment;
    if (oldInit) {
      currentInitSegment = oldInit;
      break;
    }
  }
  if (oldDetails.fragmentHint) {
    // prevent PTS and duration from being adjusted on the next hint
    delete oldDetails.fragmentHint.endPTS;
  }
  // check if old/new playlists have fragments in common
  // loop through overlapping SN and update startPTS , cc, and duration if any found
  let ccOffset = 0;
  let PTSFrag;
  mapFragmentIntersection(oldDetails, newDetails, (oldFrag, newFrag) => {
    if (oldFrag.relurl) {
      // Do not compare CC if the old fragment has no url. This is a level.fragmentHint used by LL-HLS parts.
      // It maybe be off by 1 if it was created before any parts or discontinuity tags were appended to the end
      // of the playlist.
      ccOffset = oldFrag.cc - newFrag.cc;
    }
    if (isFiniteNumber(oldFrag.startPTS) && isFiniteNumber(oldFrag.endPTS)) {
      newFrag.start = newFrag.startPTS = oldFrag.startPTS;
      newFrag.startDTS = oldFrag.startDTS;
      newFrag.maxStartPTS = oldFrag.maxStartPTS;
      newFrag.endPTS = oldFrag.endPTS;
      newFrag.endDTS = oldFrag.endDTS;
      newFrag.minEndPTS = oldFrag.minEndPTS;
      newFrag.duration = oldFrag.endPTS - oldFrag.startPTS;
      if (newFrag.duration) {
        PTSFrag = newFrag;
      }

      // PTS is known when any segment has startPTS and endPTS
      newDetails.PTSKnown = newDetails.alignedSliding = true;
    }
    newFrag.elementaryStreams = oldFrag.elementaryStreams;
    newFrag.loader = oldFrag.loader;
    newFrag.stats = oldFrag.stats;
    if (oldFrag.initSegment) {
      newFrag.initSegment = oldFrag.initSegment;
      currentInitSegment = oldFrag.initSegment;
    }
  });
  if (currentInitSegment) {
    const fragmentsToCheck = newDetails.fragmentHint ? newDetails.fragments.concat(newDetails.fragmentHint) : newDetails.fragments;
    fragmentsToCheck.forEach(frag => {
      var _currentInitSegment;
      if (frag && (!frag.initSegment || frag.initSegment.relurl === ((_currentInitSegment = currentInitSegment) == null ? void 0 : _currentInitSegment.relurl))) {
        frag.initSegment = currentInitSegment;
      }
    });
  }
  if (newDetails.skippedSegments) {
    newDetails.deltaUpdateFailed = newDetails.fragments.some(frag => !frag);
    if (newDetails.deltaUpdateFailed) {
      logger.warn('[level-helper] Previous playlist missing segments skipped in delta playlist');
      for (let i = newDetails.skippedSegments; i--;) {
        newDetails.fragments.shift();
      }
      newDetails.startSN = newDetails.fragments[0].sn;
      newDetails.startCC = newDetails.fragments[0].cc;
    } else if (newDetails.canSkipDateRanges) {
      newDetails.dateRanges = mergeDateRanges(oldDetails.dateRanges, newDetails.dateRanges, newDetails.recentlyRemovedDateranges);
    }
  }
  const newFragments = newDetails.fragments;
  if (ccOffset) {
    logger.warn('discontinuity sliding from playlist, take drift into account');
    for (let i = 0; i < newFragments.length; i++) {
      newFragments[i].cc += ccOffset;
    }
  }
  if (newDetails.skippedSegments) {
    newDetails.startCC = newDetails.fragments[0].cc;
  }

  // Merge parts
  mapPartIntersection(oldDetails.partList, newDetails.partList, (oldPart, newPart) => {
    newPart.elementaryStreams = oldPart.elementaryStreams;
    newPart.stats = oldPart.stats;
  });

  // if at least one fragment contains PTS info, recompute PTS information for all fragments
  if (PTSFrag) {
    updateFragPTSDTS(newDetails, PTSFrag, PTSFrag.startPTS, PTSFrag.endPTS, PTSFrag.startDTS, PTSFrag.endDTS);
  } else {
    // ensure that delta is within oldFragments range
    // also adjust sliding in case delta is 0 (we could have old=[50-60] and new=old=[50-61])
    // in that case we also need to adjust start offset of all fragments
    adjustSliding(oldDetails, newDetails);
  }
  if (newFragments.length) {
    newDetails.totalduration = newDetails.edge - newFragments[0].start;
  }
  newDetails.driftStartTime = oldDetails.driftStartTime;
  newDetails.driftStart = oldDetails.driftStart;
  const advancedDateTime = newDetails.advancedDateTime;
  if (newDetails.advanced && advancedDateTime) {
    const edge = newDetails.edge;
    if (!newDetails.driftStart) {
      newDetails.driftStartTime = advancedDateTime;
      newDetails.driftStart = edge;
    }
    newDetails.driftEndTime = advancedDateTime;
    newDetails.driftEnd = edge;
  } else {
    newDetails.driftEndTime = oldDetails.driftEndTime;
    newDetails.driftEnd = oldDetails.driftEnd;
    newDetails.advancedDateTime = oldDetails.advancedDateTime;
  }
}
function mergeDateRanges(oldDateRanges, deltaDateRanges, recentlyRemovedDateranges) {
  const dateRanges = _extends({}, oldDateRanges);
  if (recentlyRemovedDateranges) {
    recentlyRemovedDateranges.forEach(id => {
      delete dateRanges[id];
    });
  }
  Object.keys(deltaDateRanges).forEach(id => {
    const dateRange = new DateRange(deltaDateRanges[id].attr, dateRanges[id]);
    if (dateRange.isValid) {
      dateRanges[id] = dateRange;
    } else {
      logger.warn(`Ignoring invalid Playlist Delta Update DATERANGE tag: "${JSON.stringify(deltaDateRanges[id].attr)}"`);
    }
  });
  return dateRanges;
}
function mapPartIntersection(oldParts, newParts, intersectionFn) {
  if (oldParts && newParts) {
    let delta = 0;
    for (let i = 0, len = oldParts.length; i <= len; i++) {
      const oldPart = oldParts[i];
      const newPart = newParts[i + delta];
      if (oldPart && newPart && oldPart.index === newPart.index && oldPart.fragment.sn === newPart.fragment.sn) {
        intersectionFn(oldPart, newPart);
      } else {
        delta--;
      }
    }
  }
}
function mapFragmentIntersection(oldDetails, newDetails, intersectionFn) {
  const skippedSegments = newDetails.skippedSegments;
  const start = Math.max(oldDetails.startSN, newDetails.startSN) - newDetails.startSN;
  const end = (oldDetails.fragmentHint ? 1 : 0) + (skippedSegments ? newDetails.endSN : Math.min(oldDetails.endSN, newDetails.endSN)) - newDetails.startSN;
  const delta = newDetails.startSN - oldDetails.startSN;
  const newFrags = newDetails.fragmentHint ? newDetails.fragments.concat(newDetails.fragmentHint) : newDetails.fragments;
  const oldFrags = oldDetails.fragmentHint ? oldDetails.fragments.concat(oldDetails.fragmentHint) : oldDetails.fragments;
  for (let i = start; i <= end; i++) {
    const oldFrag = oldFrags[delta + i];
    let newFrag = newFrags[i];
    if (skippedSegments && !newFrag && i < skippedSegments) {
      // Fill in skipped segments in delta playlist
      newFrag = newDetails.fragments[i] = oldFrag;
    }
    if (oldFrag && newFrag) {
      intersectionFn(oldFrag, newFrag);
    }
  }
}
function adjustSliding(oldDetails, newDetails) {
  const delta = newDetails.startSN + newDetails.skippedSegments - oldDetails.startSN;
  const oldFragments = oldDetails.fragments;
  if (delta < 0 || delta >= oldFragments.length) {
    return;
  }
  addSliding(newDetails, oldFragments[delta].start);
}
function addSliding(details, start) {
  if (start) {
    const fragments = details.fragments;
    for (let i = details.skippedSegments; i < fragments.length; i++) {
      fragments[i].start += start;
    }
    if (details.fragmentHint) {
      details.fragmentHint.start += start;
    }
  }
}
function computeReloadInterval(newDetails, distanceToLiveEdgeMs = Infinity) {
  let reloadInterval = 1000 * newDetails.targetduration;
  if (newDetails.updated) {
    // Use last segment duration when shorter than target duration and near live edge
    const fragments = newDetails.fragments;
    const liveEdgeMaxTargetDurations = 4;
    if (fragments.length && reloadInterval * liveEdgeMaxTargetDurations > distanceToLiveEdgeMs) {
      const lastSegmentDuration = fragments[fragments.length - 1].duration * 1000;
      if (lastSegmentDuration < reloadInterval) {
        reloadInterval = lastSegmentDuration;
      }
    }
  } else {
    // estimate = 'miss half average';
    // follow HLS Spec, If the client reloads a Playlist file and finds that it has not
    // changed then it MUST wait for a period of one-half the target
    // duration before retrying.
    reloadInterval /= 2;
  }
  return Math.round(reloadInterval);
}
function getFragmentWithSN(level, sn, fragCurrent) {
  if (!(level != null && level.details)) {
    return null;
  }
  const levelDetails = level.details;
  let fragment = levelDetails.fragments[sn - levelDetails.startSN];
  if (fragment) {
    return fragment;
  }
  fragment = levelDetails.fragmentHint;
  if (fragment && fragment.sn === sn) {
    return fragment;
  }
  if (sn < levelDetails.startSN && fragCurrent && fragCurrent.sn === sn) {
    return fragCurrent;
  }
  return null;
}
function getPartWith(level, sn, partIndex) {
  var _level$details;
  if (!(level != null && level.details)) {
    return null;
  }
  return findPart((_level$details = level.details) == null ? void 0 : _level$details.partList, sn, partIndex);
}
function findPart(partList, sn, partIndex) {
  if (partList) {
    for (let i = partList.length; i--;) {
      const part = partList[i];
      if (part.index === partIndex && part.fragment.sn === sn) {
        return part;
      }
    }
  }
  return null;
}
function reassignFragmentLevelIndexes(levels) {
  levels.forEach((level, index) => {
    const {
      details
    } = level;
    if (details != null && details.fragments) {
      details.fragments.forEach(fragment => {
        fragment.level = index;
      });
    }
  });
}

function isTimeoutError(error) {
  switch (error.details) {
    case ErrorDetails.FRAG_LOAD_TIMEOUT:
    case ErrorDetails.KEY_LOAD_TIMEOUT:
    case ErrorDetails.LEVEL_LOAD_TIMEOUT:
    case ErrorDetails.MANIFEST_LOAD_TIMEOUT:
      return true;
  }
  return false;
}
function getRetryConfig(loadPolicy, error) {
  const isTimeout = isTimeoutError(error);
  return loadPolicy.default[`${isTimeout ? 'timeout' : 'error'}Retry`];
}
function getRetryDelay(retryConfig, retryCount) {
  // exponential backoff capped to max retry delay
  const backoffFactor = retryConfig.backoff === 'linear' ? 1 : Math.pow(2, retryCount);
  return Math.min(backoffFactor * retryConfig.retryDelayMs, retryConfig.maxRetryDelayMs);
}
function getLoaderConfigWithoutReties(loderConfig) {
  return _objectSpread2(_objectSpread2({}, loderConfig), {
    errorRetry: null,
    timeoutRetry: null
  });
}
function shouldRetry(retryConfig, retryCount, isTimeout, loaderResponse) {
  if (!retryConfig) {
    return false;
  }
  const httpStatus = loaderResponse == null ? void 0 : loaderResponse.code;
  const retry = retryCount < retryConfig.maxNumRetry && (retryForHttpStatus(httpStatus) || !!isTimeout);
  return retryConfig.shouldRetry ? retryConfig.shouldRetry(retryConfig, retryCount, isTimeout, loaderResponse, retry) : retry;
}
function retryForHttpStatus(httpStatus) {
  // Do not retry on status 4xx, status 0 (CORS error), or undefined (decrypt/gap/parse error)
  return httpStatus === 0 && navigator.onLine === false || !!httpStatus && (httpStatus < 400 || httpStatus > 499);
}

const BinarySearch = {
  /**
   * Searches for an item in an array which matches a certain condition.
   * This requires the condition to only match one item in the array,
   * and for the array to be ordered.
   *
   * @param list The array to search.
   * @param comparisonFn
   *      Called and provided a candidate item as the first argument.
   *      Should return:
   *          > -1 if the item should be located at a lower index than the provided item.
   *          > 1 if the item should be located at a higher index than the provided item.
   *          > 0 if the item is the item you're looking for.
   *
   * @returns the object if found, otherwise returns null
   */
  search: function (list, comparisonFn) {
    let minIndex = 0;
    let maxIndex = list.length - 1;
    let currentIndex = null;
    let currentElement = null;
    while (minIndex <= maxIndex) {
      currentIndex = (minIndex + maxIndex) / 2 | 0;
      currentElement = list[currentIndex];
      const comparisonResult = comparisonFn(currentElement);
      if (comparisonResult > 0) {
        minIndex = currentIndex + 1;
      } else if (comparisonResult < 0) {
        maxIndex = currentIndex - 1;
      } else {
        return currentElement;
      }
    }
    return null;
  }
};

/**
 * Returns first fragment whose endPdt value exceeds the given PDT, or null.
 * @param fragments - The array of candidate fragments
 * @param PDTValue - The PDT value which must be exceeded
 * @param maxFragLookUpTolerance - The amount of time that a fragment's start/end can be within in order to be considered contiguous
 */
function findFragmentByPDT(fragments, PDTValue, maxFragLookUpTolerance) {
  if (PDTValue === null || !Array.isArray(fragments) || !fragments.length || !isFiniteNumber(PDTValue)) {
    return null;
  }

  // if less than start
  const startPDT = fragments[0].programDateTime;
  if (PDTValue < (startPDT || 0)) {
    return null;
  }
  const endPDT = fragments[fragments.length - 1].endProgramDateTime;
  if (PDTValue >= (endPDT || 0)) {
    return null;
  }
  maxFragLookUpTolerance = maxFragLookUpTolerance || 0;
  for (let seg = 0; seg < fragments.length; ++seg) {
    const frag = fragments[seg];
    if (pdtWithinToleranceTest(PDTValue, maxFragLookUpTolerance, frag)) {
      return frag;
    }
  }
  return null;
}

/**
 * Finds a fragment based on the SN of the previous fragment; or based on the needs of the current buffer.
 * This method compensates for small buffer gaps by applying a tolerance to the start of any candidate fragment, thus
 * breaking any traps which would cause the same fragment to be continuously selected within a small range.
 * @param fragPrevious - The last frag successfully appended
 * @param fragments - The array of candidate fragments
 * @param bufferEnd - The end of the contiguous buffered range the playhead is currently within
 * @param maxFragLookUpTolerance - The amount of time that a fragment's start/end can be within in order to be considered contiguous
 * @returns a matching fragment or null
 */
function findFragmentByPTS(fragPrevious, fragments, bufferEnd = 0, maxFragLookUpTolerance = 0, nextFragLookupTolerance = 0.005) {
  let fragNext = null;
  if (fragPrevious) {
    fragNext = fragments[fragPrevious.sn - fragments[0].sn + 1] || null;
    // check for buffer-end rounding error
    const bufferEdgeError = fragPrevious.endDTS - bufferEnd;
    if (bufferEdgeError > 0 && bufferEdgeError < 0.0000015) {
      bufferEnd += 0.0000015;
    }
  } else if (bufferEnd === 0 && fragments[0].start === 0) {
    fragNext = fragments[0];
  }
  // Prefer the next fragment if it's within tolerance
  if (fragNext && ((!fragPrevious || fragPrevious.level === fragNext.level) && fragmentWithinToleranceTest(bufferEnd, maxFragLookUpTolerance, fragNext) === 0 || fragmentWithinFastStartSwitch(fragNext, fragPrevious, Math.min(nextFragLookupTolerance, maxFragLookUpTolerance)))) {
    return fragNext;
  }
  // We might be seeking past the tolerance so find the best match
  const foundFragment = BinarySearch.search(fragments, fragmentWithinToleranceTest.bind(null, bufferEnd, maxFragLookUpTolerance));
  if (foundFragment && (foundFragment !== fragPrevious || !fragNext)) {
    return foundFragment;
  }
  // If no match was found return the next fragment after fragPrevious, or null
  return fragNext;
}
function fragmentWithinFastStartSwitch(fragNext, fragPrevious, nextFragLookupTolerance) {
  if (fragPrevious && fragPrevious.start === 0 && fragPrevious.level < fragNext.level && (fragPrevious.endPTS || 0) > 0) {
    const firstDuration = fragPrevious.tagList.reduce((duration, tag) => {
      if (tag[0] === 'INF') {
        duration += parseFloat(tag[1]);
      }
      return duration;
    }, nextFragLookupTolerance);
    return fragNext.start <= firstDuration;
  }
  return false;
}

/**
 * The test function used by the findFragmentBySn's BinarySearch to look for the best match to the current buffer conditions.
 * @param candidate - The fragment to test
 * @param bufferEnd - The end of the current buffered range the playhead is currently within
 * @param maxFragLookUpTolerance - The amount of time that a fragment's start can be within in order to be considered contiguous
 * @returns 0 if it matches, 1 if too low, -1 if too high
 */
function fragmentWithinToleranceTest(bufferEnd = 0, maxFragLookUpTolerance = 0, candidate) {
  // eagerly accept an accurate match (no tolerance)
  if (candidate.start <= bufferEnd && candidate.start + candidate.duration > bufferEnd) {
    return 0;
  }
  // offset should be within fragment boundary - config.maxFragLookUpTolerance
  // this is to cope with situations like
  // bufferEnd = 9.991
  // frag[Ø] : [0,10]
  // frag[1] : [10,20]
  // bufferEnd is within frag[0] range ... although what we are expecting is to return frag[1] here
  //              frag start               frag start+duration
  //                  |-----------------------------|
  //              <--->                         <--->
  //  ...--------><-----------------------------><---------....
  // previous frag         matching fragment         next frag
  //  return -1             return 0                 return 1
  // logger.log(`level/sn/start/end/bufEnd:${level}/${candidate.sn}/${candidate.start}/${(candidate.start+candidate.duration)}/${bufferEnd}`);
  // Set the lookup tolerance to be small enough to detect the current segment - ensures we don't skip over very small segments
  const candidateLookupTolerance = Math.min(maxFragLookUpTolerance, candidate.duration + (candidate.deltaPTS ? candidate.deltaPTS : 0));
  if (candidate.start + candidate.duration - candidateLookupTolerance <= bufferEnd) {
    return 1;
  } else if (candidate.start - candidateLookupTolerance > bufferEnd && candidate.start) {
    // if maxFragLookUpTolerance will have negative value then don't return -1 for first element
    return -1;
  }
  return 0;
}

/**
 * The test function used by the findFragmentByPdt's BinarySearch to look for the best match to the current buffer conditions.
 * This function tests the candidate's program date time values, as represented in Unix time
 * @param candidate - The fragment to test
 * @param pdtBufferEnd - The Unix time representing the end of the current buffered range
 * @param maxFragLookUpTolerance - The amount of time that a fragment's start can be within in order to be considered contiguous
 * @returns true if contiguous, false otherwise
 */
function pdtWithinToleranceTest(pdtBufferEnd, maxFragLookUpTolerance, candidate) {
  const candidateLookupTolerance = Math.min(maxFragLookUpTolerance, candidate.duration + (candidate.deltaPTS ? candidate.deltaPTS : 0)) * 1000;

  // endProgramDateTime can be null, default to zero
  const endProgramDateTime = candidate.endProgramDateTime || 0;
  return endProgramDateTime - candidateLookupTolerance > pdtBufferEnd;
}
function findFragWithCC(fragments, cc) {
  return BinarySearch.search(fragments, candidate => {
    if (candidate.cc < cc) {
      return 1;
    } else if (candidate.cc > cc) {
      return -1;
    } else {
      return 0;
    }
  });
}

var NetworkErrorAction = {
  DoNothing: 0,
  SendEndCallback: 1,
  SendAlternateToPenaltyBox: 2,
  RemoveAlternatePermanently: 3,
  InsertDiscontinuity: 4,
  RetryRequest: 5
};
var ErrorActionFlags = {
  None: 0,
  MoveAllAlternatesMatchingHost: 1,
  MoveAllAlternatesMatchingHDCP: 2,
  SwitchToSDR: 4
}; // Reserved for future use
class ErrorController {
  constructor(hls) {
    this.hls = void 0;
    this.playlistError = 0;
    this.penalizedRenditions = {};
    this.log = void 0;
    this.warn = void 0;
    this.error = void 0;
    this.hls = hls;
    this.log = logger.log.bind(logger, `[info]:`);
    this.warn = logger.warn.bind(logger, `[warning]:`);
    this.error = logger.error.bind(logger, `[error]:`);
    this.registerListeners();
  }
  registerListeners() {
    const hls = this.hls;
    hls.on(Events.ERROR, this.onError, this);
    hls.on(Events.MANIFEST_LOADING, this.onManifestLoading, this);
    hls.on(Events.LEVEL_UPDATED, this.onLevelUpdated, this);
  }
  unregisterListeners() {
    const hls = this.hls;
    if (!hls) {
      return;
    }
    hls.off(Events.ERROR, this.onError, this);
    hls.off(Events.ERROR, this.onErrorOut, this);
    hls.off(Events.MANIFEST_LOADING, this.onManifestLoading, this);
    hls.off(Events.LEVEL_UPDATED, this.onLevelUpdated, this);
  }
  destroy() {
    this.unregisterListeners();
    // @ts-ignore
    this.hls = null;
    this.penalizedRenditions = {};
  }
  startLoad(startPosition) {}
  stopLoad() {
    this.playlistError = 0;
  }
  getVariantLevelIndex(frag) {
    return (frag == null ? void 0 : frag.type) === PlaylistLevelType.MAIN ? frag.level : this.hls.loadLevel;
  }
  onManifestLoading() {
    this.playlistError = 0;
    this.penalizedRenditions = {};
  }
  onLevelUpdated() {
    this.playlistError = 0;
  }
  onError(event, data) {
    var _data$frag, _data$level;
    if (data.fatal) {
      return;
    }
    const hls = this.hls;
    const context = data.context;
    switch (data.details) {
      case ErrorDetails.FRAG_LOAD_ERROR:
      case ErrorDetails.FRAG_LOAD_TIMEOUT:
      case ErrorDetails.KEY_LOAD_ERROR:
      case ErrorDetails.KEY_LOAD_TIMEOUT:
        data.errorAction = this.getFragRetryOrSwitchAction(data);
        return;
      case ErrorDetails.FRAG_PARSING_ERROR:
        // ignore empty segment errors marked as gap
        if ((_data$frag = data.frag) != null && _data$frag.gap) {
          data.errorAction = {
            action: NetworkErrorAction.DoNothing,
            flags: ErrorActionFlags.None
          };
          return;
        }
      // falls through
      case ErrorDetails.FRAG_GAP:
      case ErrorDetails.FRAG_DECRYPT_ERROR:
        {
          // Switch level if possible, otherwise allow retry count to reach max error retries
          data.errorAction = this.getFragRetryOrSwitchAction(data);
          data.errorAction.action = NetworkErrorAction.SendAlternateToPenaltyBox;
          return;
        }
      case ErrorDetails.LEVEL_EMPTY_ERROR:
      case ErrorDetails.LEVEL_PARSING_ERROR:
        {
          var _data$context, _data$context$levelDe;
          // Only retry when empty and live
          const levelIndex = data.parent === PlaylistLevelType.MAIN ? data.level : hls.loadLevel;
          if (data.details === ErrorDetails.LEVEL_EMPTY_ERROR && !!((_data$context = data.context) != null && (_data$context$levelDe = _data$context.levelDetails) != null && _data$context$levelDe.live)) {
            data.errorAction = this.getPlaylistRetryOrSwitchAction(data, levelIndex);
          } else {
            // Escalate to fatal if not retrying or switching
            data.levelRetry = false;
            data.errorAction = this.getLevelSwitchAction(data, levelIndex);
          }
        }
        return;
      case ErrorDetails.LEVEL_LOAD_ERROR:
      case ErrorDetails.LEVEL_LOAD_TIMEOUT:
        if (typeof (context == null ? void 0 : context.level) === 'number') {
          data.errorAction = this.getPlaylistRetryOrSwitchAction(data, context.level);
        }
        return;
      case ErrorDetails.AUDIO_TRACK_LOAD_ERROR:
      case ErrorDetails.AUDIO_TRACK_LOAD_TIMEOUT:
      case ErrorDetails.SUBTITLE_LOAD_ERROR:
      case ErrorDetails.SUBTITLE_TRACK_LOAD_TIMEOUT:
        if (context) {
          const level = hls.levels[hls.loadLevel];
          if (level && (context.type === PlaylistContextType.AUDIO_TRACK && level.hasAudioGroup(context.groupId) || context.type === PlaylistContextType.SUBTITLE_TRACK && level.hasSubtitleGroup(context.groupId))) {
            // Perform Pathway switch or Redundant failover if possible for fastest recovery
            // otherwise allow playlist retry count to reach max error retries
            data.errorAction = this.getPlaylistRetryOrSwitchAction(data, hls.loadLevel);
            data.errorAction.action = NetworkErrorAction.SendAlternateToPenaltyBox;
            data.errorAction.flags = ErrorActionFlags.MoveAllAlternatesMatchingHost;
            return;
          }
        }
        return;
      case ErrorDetails.KEY_SYSTEM_STATUS_OUTPUT_RESTRICTED:
        {
          const level = hls.levels[hls.loadLevel];
          const restrictedHdcpLevel = level == null ? void 0 : level.attrs['HDCP-LEVEL'];
          if (restrictedHdcpLevel) {
            data.errorAction = {
              action: NetworkErrorAction.SendAlternateToPenaltyBox,
              flags: ErrorActionFlags.MoveAllAlternatesMatchingHDCP,
              hdcpLevel: restrictedHdcpLevel
            };
          } else {
            this.keySystemError(data);
          }
        }
        return;
      case ErrorDetails.BUFFER_ADD_CODEC_ERROR:
      case ErrorDetails.REMUX_ALLOC_ERROR:
      case ErrorDetails.BUFFER_APPEND_ERROR:
        data.errorAction = this.getLevelSwitchAction(data, (_data$level = data.level) != null ? _data$level : hls.loadLevel);
        return;
      case ErrorDetails.INTERNAL_EXCEPTION:
      case ErrorDetails.BUFFER_APPENDING_ERROR:
      case ErrorDetails.BUFFER_FULL_ERROR:
      case ErrorDetails.LEVEL_SWITCH_ERROR:
      case ErrorDetails.BUFFER_STALLED_ERROR:
      case ErrorDetails.BUFFER_SEEK_OVER_HOLE:
      case ErrorDetails.BUFFER_NUDGE_ON_STALL:
        data.errorAction = {
          action: NetworkErrorAction.DoNothing,
          flags: ErrorActionFlags.None
        };
        return;
    }
    if (data.type === ErrorTypes.KEY_SYSTEM_ERROR) {
      this.keySystemError(data);
    }
  }
  keySystemError(data) {
    const levelIndex = this.getVariantLevelIndex(data.frag);
    // Do not retry level. Escalate to fatal if switching levels fails.
    data.levelRetry = false;
    data.errorAction = this.getLevelSwitchAction(data, levelIndex);
  }
  getPlaylistRetryOrSwitchAction(data, levelIndex) {
    const hls = this.hls;
    const retryConfig = getRetryConfig(hls.config.playlistLoadPolicy, data);
    const retryCount = this.playlistError++;
    const retry = shouldRetry(retryConfig, retryCount, isTimeoutError(data), data.response);
    if (retry) {
      return {
        action: NetworkErrorAction.RetryRequest,
        flags: ErrorActionFlags.None,
        retryConfig,
        retryCount
      };
    }
    const errorAction = this.getLevelSwitchAction(data, levelIndex);
    if (retryConfig) {
      errorAction.retryConfig = retryConfig;
      errorAction.retryCount = retryCount;
    }
    return errorAction;
  }
  getFragRetryOrSwitchAction(data) {
    const hls = this.hls;
    // Share fragment error count accross media options (main, audio, subs)
    // This allows for level based rendition switching when media option assets fail
    const variantLevelIndex = this.getVariantLevelIndex(data.frag);
    const level = hls.levels[variantLevelIndex];
    const {
      fragLoadPolicy,
      keyLoadPolicy
    } = hls.config;
    const retryConfig = getRetryConfig(data.details.startsWith('key') ? keyLoadPolicy : fragLoadPolicy, data);
    const fragmentErrors = hls.levels.reduce((acc, level) => acc + level.fragmentError, 0);
    // Switch levels when out of retried or level index out of bounds
    if (level) {
      if (data.details !== ErrorDetails.FRAG_GAP) {
        level.fragmentError++;
      }
      const retry = shouldRetry(retryConfig, fragmentErrors, isTimeoutError(data), data.response);
      if (retry) {
        return {
          action: NetworkErrorAction.RetryRequest,
          flags: ErrorActionFlags.None,
          retryConfig,
          retryCount: fragmentErrors
        };
      }
    }
    // Reach max retry count, or Missing level reference
    // Switch to valid index
    const errorAction = this.getLevelSwitchAction(data, variantLevelIndex);
    // Add retry details to allow skipping of FRAG_PARSING_ERROR
    if (retryConfig) {
      errorAction.retryConfig = retryConfig;
      errorAction.retryCount = fragmentErrors;
    }
    return errorAction;
  }
  getLevelSwitchAction(data, levelIndex) {
    const hls = this.hls;
    if (levelIndex === null || levelIndex === undefined) {
      levelIndex = hls.loadLevel;
    }
    const level = this.hls.levels[levelIndex];
    if (level) {
      var _data$frag2, _data$context2;
      const errorDetails = data.details;
      level.loadError++;
      if (errorDetails === ErrorDetails.BUFFER_APPEND_ERROR) {
        level.fragmentError++;
      }
      // Search for next level to retry
      let nextLevel = -1;
      const {
        levels,
        loadLevel,
        minAutoLevel,
        maxAutoLevel
      } = hls;
      if (!hls.autoLevelEnabled) {
        hls.loadLevel = -1;
      }
      const fragErrorType = (_data$frag2 = data.frag) == null ? void 0 : _data$frag2.type;
      // Find alternate audio codec if available on audio codec error
      const isAudioCodecError = fragErrorType === PlaylistLevelType.AUDIO && errorDetails === ErrorDetails.FRAG_PARSING_ERROR || data.sourceBufferName === 'audio' && (errorDetails === ErrorDetails.BUFFER_ADD_CODEC_ERROR || errorDetails === ErrorDetails.BUFFER_APPEND_ERROR);
      const findAudioCodecAlternate = isAudioCodecError && levels.some(({
        audioCodec
      }) => level.audioCodec !== audioCodec);
      // Find alternate video codec if available on video codec error
      const isVideoCodecError = data.sourceBufferName === 'video' && (errorDetails === ErrorDetails.BUFFER_ADD_CODEC_ERROR || errorDetails === ErrorDetails.BUFFER_APPEND_ERROR);
      const findVideoCodecAlternate = isVideoCodecError && levels.some(({
        codecSet,
        audioCodec
      }) => level.codecSet !== codecSet && level.audioCodec === audioCodec);
      const {
        type: playlistErrorType,
        groupId: playlistErrorGroupId
      } = (_data$context2 = data.context) != null ? _data$context2 : {};
      for (let i = levels.length; i--;) {
        const candidate = (i + loadLevel) % levels.length;
        if (candidate !== loadLevel && candidate >= minAutoLevel && candidate <= maxAutoLevel && levels[candidate].loadError === 0) {
          var _level$audioGroups, _level$subtitleGroups;
          const levelCandidate = levels[candidate];
          // Skip level switch if GAP tag is found in next level at same position
          if (errorDetails === ErrorDetails.FRAG_GAP && fragErrorType === PlaylistLevelType.MAIN && data.frag) {
            const levelDetails = levels[candidate].details;
            if (levelDetails) {
              const fragCandidate = findFragmentByPTS(data.frag, levelDetails.fragments, data.frag.start);
              if (fragCandidate != null && fragCandidate.gap) {
                continue;
              }
            }
          } else if (playlistErrorType === PlaylistContextType.AUDIO_TRACK && levelCandidate.hasAudioGroup(playlistErrorGroupId) || playlistErrorType === PlaylistContextType.SUBTITLE_TRACK && levelCandidate.hasSubtitleGroup(playlistErrorGroupId)) {
            // For audio/subs playlist errors find another group ID or fallthrough to redundant fail-over
            continue;
          } else if (fragErrorType === PlaylistLevelType.AUDIO && (_level$audioGroups = level.audioGroups) != null && _level$audioGroups.some(groupId => levelCandidate.hasAudioGroup(groupId)) || fragErrorType === PlaylistLevelType.SUBTITLE && (_level$subtitleGroups = level.subtitleGroups) != null && _level$subtitleGroups.some(groupId => levelCandidate.hasSubtitleGroup(groupId)) || findAudioCodecAlternate && level.audioCodec === levelCandidate.audioCodec || !findAudioCodecAlternate && level.audioCodec !== levelCandidate.audioCodec || findVideoCodecAlternate && level.codecSet === levelCandidate.codecSet) {
            // For video/audio/subs frag errors find another group ID or fallthrough to redundant fail-over
            continue;
          }
          nextLevel = candidate;
          break;
        }
      }
      if (nextLevel > -1 && hls.loadLevel !== nextLevel) {
        data.levelRetry = true;
        this.playlistError = 0;
        return {
          action: NetworkErrorAction.SendAlternateToPenaltyBox,
          flags: ErrorActionFlags.None,
          nextAutoLevel: nextLevel
        };
      }
    }
    // No levels to switch / Manual level selection / Level not found
    // Resolve with Pathway switch, Redundant fail-over, or stay on lowest Level
    return {
      action: NetworkErrorAction.SendAlternateToPenaltyBox,
      flags: ErrorActionFlags.MoveAllAlternatesMatchingHost
    };
  }
  onErrorOut(event, data) {
    var _data$errorAction;
    switch ((_data$errorAction = data.errorAction) == null ? void 0 : _data$errorAction.action) {
      case NetworkErrorAction.DoNothing:
        break;
      case NetworkErrorAction.SendAlternateToPenaltyBox:
        this.sendAlternateToPenaltyBox(data);
        if (!data.errorAction.resolved && data.details !== ErrorDetails.FRAG_GAP) {
          data.fatal = true;
        } else if (/MediaSource readyState: ended/.test(data.error.message)) {
          this.warn(`MediaSource ended after "${data.sourceBufferName}" sourceBuffer append error. Attempting to recover from media error.`);
          this.hls.recoverMediaError();
        }
        break;
    }
    if (data.fatal) {
      this.hls.stopLoad();
      return;
    }
  }
  sendAlternateToPenaltyBox(data) {
    const hls = this.hls;
    const errorAction = data.errorAction;
    if (!errorAction) {
      return;
    }
    const {
      flags,
      hdcpLevel,
      nextAutoLevel
    } = errorAction;
    switch (flags) {
      case ErrorActionFlags.None:
        this.switchLevel(data, nextAutoLevel);
        break;
      case ErrorActionFlags.MoveAllAlternatesMatchingHDCP:
        if (hdcpLevel) {
          hls.maxHdcpLevel = HdcpLevels[HdcpLevels.indexOf(hdcpLevel) - 1];
          errorAction.resolved = true;
        }
        this.warn(`Restricting playback to HDCP-LEVEL of "${hls.maxHdcpLevel}" or lower`);
        break;
    }
    // If not resolved by previous actions try to switch to next level
    if (!errorAction.resolved) {
      this.switchLevel(data, nextAutoLevel);
    }
  }
  switchLevel(data, levelIndex) {
    if (levelIndex !== undefined && data.errorAction) {
      this.warn(`switching to level ${levelIndex} after ${data.details}`);
      this.hls.nextAutoLevel = levelIndex;
      data.errorAction.resolved = true;
      // Stream controller is responsible for this but won't switch on false start
      this.hls.nextLoadLevel = this.hls.nextAutoLevel;
    }
  }
}

class BasePlaylistController {
  constructor(hls, logPrefix) {
    this.hls = void 0;
    this.timer = -1;
    this.requestScheduled = -1;
    this.canLoad = false;
    this.log = void 0;
    this.warn = void 0;
    this.log = logger.log.bind(logger, `${logPrefix}:`);
    this.warn = logger.warn.bind(logger, `${logPrefix}:`);
    this.hls = hls;
  }
  destroy() {
    this.clearTimer();
    // @ts-ignore
    this.hls = this.log = this.warn = null;
  }
  clearTimer() {
    if (this.timer !== -1) {
      self.clearTimeout(this.timer);
      this.timer = -1;
    }
  }
  startLoad() {
    this.canLoad = true;
    this.requestScheduled = -1;
    this.loadPlaylist();
  }
  stopLoad() {
    this.canLoad = false;
    this.clearTimer();
  }
  switchParams(playlistUri, previous, current) {
    const renditionReports = previous == null ? void 0 : previous.renditionReports;
    if (renditionReports) {
      let foundIndex = -1;
      for (let i = 0; i < renditionReports.length; i++) {
        const attr = renditionReports[i];
        let uri;
        try {
          uri = new self.URL(attr.URI, previous.url).href;
        } catch (error) {
          logger.warn(`Could not construct new URL for Rendition Report: ${error}`);
          uri = attr.URI || '';
        }
        // Use exact match. Otherwise, the last partial match, if any, will be used
        // (Playlist URI includes a query string that the Rendition Report does not)
        if (uri === playlistUri) {
          foundIndex = i;
          break;
        } else if (uri === playlistUri.substring(0, uri.length)) {
          foundIndex = i;
        }
      }
      if (foundIndex !== -1) {
        const attr = renditionReports[foundIndex];
        const msn = parseInt(attr['LAST-MSN']) || (previous == null ? void 0 : previous.lastPartSn);
        let part = parseInt(attr['LAST-PART']) || (previous == null ? void 0 : previous.lastPartIndex);
        if (this.hls.config.lowLatencyMode) {
          const currentGoal = Math.min(previous.age - previous.partTarget, previous.targetduration);
          if (part >= 0 && currentGoal > previous.partTarget) {
            part += 1;
          }
        }
        const skip = current && getSkipValue(current);
        return new HlsUrlParameters(msn, part >= 0 ? part : undefined, skip);
      }
    }
  }
  loadPlaylist(hlsUrlParameters) {
    if (this.requestScheduled === -1) {
      this.requestScheduled = self.performance.now();
    }
    // Loading is handled by the subclasses
  }
  shouldLoadPlaylist(playlist) {
    return this.canLoad && !!playlist && !!playlist.url && (!playlist.details || playlist.details.live);
  }
  shouldReloadPlaylist(playlist) {
    return this.timer === -1 && this.requestScheduled === -1 && this.shouldLoadPlaylist(playlist);
  }
  playlistLoaded(index, data, previousDetails) {
    const {
      details,
      stats
    } = data;

    // Set last updated date-time
    const now = self.performance.now();
    const elapsed = stats.loading.first ? Math.max(0, now - stats.loading.first) : 0;
    details.advancedDateTime = Date.now() - elapsed;

    // if current playlist is a live playlist, arm a timer to reload it
    if (details.live || previousDetails != null && previousDetails.live) {
      details.reloaded(previousDetails);
      if (previousDetails) {
        this.log(`live playlist ${index} ${details.advanced ? 'REFRESHED ' + details.lastPartSn + '-' + details.lastPartIndex : details.updated ? 'UPDATED' : 'MISSED'}`);
      }
      // Merge live playlists to adjust fragment starts and fill in delta playlist skipped segments
      if (previousDetails && details.fragments.length > 0) {
        mergeDetails(previousDetails, details);
      }
      if (!this.canLoad || !details.live) {
        return;
      }
      let deliveryDirectives;
      let msn = undefined;
      let part = undefined;
      if (details.canBlockReload && details.endSN && details.advanced) {
        // Load level with LL-HLS delivery directives
        const lowLatencyMode = this.hls.config.lowLatencyMode;
        const lastPartSn = details.lastPartSn;
        const endSn = details.endSN;
        const lastPartIndex = details.lastPartIndex;
        const hasParts = lastPartIndex !== -1;
        const lastPart = lastPartSn === endSn;
        // When low latency mode is disabled, we'll skip part requests once the last part index is found
        const nextSnStartIndex = lowLatencyMode ? 0 : lastPartIndex;
        if (hasParts) {
          msn = lastPart ? endSn + 1 : lastPartSn;
          part = lastPart ? nextSnStartIndex : lastPartIndex + 1;
        } else {
          msn = endSn + 1;
        }
        // Low-Latency CDN Tune-in: "age" header and time since load indicates we're behind by more than one part
        // Update directives to obtain the Playlist that has the estimated additional duration of media
        const lastAdvanced = details.age;
        const cdnAge = lastAdvanced + details.ageHeader;
        let currentGoal = Math.min(cdnAge - details.partTarget, details.targetduration * 1.5);
        if (currentGoal > 0) {
          if (previousDetails && currentGoal > previousDetails.tuneInGoal) {
            // If we attempted to get the next or latest playlist update, but currentGoal increased,
            // then we either can't catchup, or the "age" header cannot be trusted.
            this.warn(`CDN Tune-in goal increased from: ${previousDetails.tuneInGoal} to: ${currentGoal} with playlist age: ${details.age}`);
            currentGoal = 0;
          } else {
            const segments = Math.floor(currentGoal / details.targetduration);
            msn += segments;
            if (part !== undefined) {
              const parts = Math.round(currentGoal % details.targetduration / details.partTarget);
              part += parts;
            }
            this.log(`CDN Tune-in age: ${details.ageHeader}s last advanced ${lastAdvanced.toFixed(2)}s goal: ${currentGoal} skip sn ${segments} to part ${part}`);
          }
          details.tuneInGoal = currentGoal;
        }
        deliveryDirectives = this.getDeliveryDirectives(details, data.deliveryDirectives, msn, part);
        if (lowLatencyMode || !lastPart) {
          this.loadPlaylist(deliveryDirectives);
          return;
        }
      } else if (details.canBlockReload || details.canSkipUntil) {
        deliveryDirectives = this.getDeliveryDirectives(details, data.deliveryDirectives, msn, part);
      }
      const bufferInfo = this.hls.mainForwardBufferInfo;
      const position = bufferInfo ? bufferInfo.end - bufferInfo.len : 0;
      const distanceToLiveEdgeMs = (details.edge - position) * 1000;
      const reloadInterval = computeReloadInterval(details, distanceToLiveEdgeMs);
      if (details.updated && now > this.requestScheduled + reloadInterval) {
        this.requestScheduled = stats.loading.start;
      }
      if (msn !== undefined && details.canBlockReload) {
        this.requestScheduled = stats.loading.first + reloadInterval - (details.partTarget * 1000 || 1000);
      } else if (this.requestScheduled === -1 || this.requestScheduled + reloadInterval < now) {
        this.requestScheduled = now;
      } else if (this.requestScheduled - now <= 0) {
        this.requestScheduled += reloadInterval;
      }
      let estimatedTimeUntilUpdate = this.requestScheduled - now;
      estimatedTimeUntilUpdate = Math.max(0, estimatedTimeUntilUpdate);
      this.log(`reload live playlist ${index} in ${Math.round(estimatedTimeUntilUpdate)} ms`);
      // this.log(
      //   `live reload ${details.updated ? 'REFRESHED' : 'MISSED'}
      // reload in ${estimatedTimeUntilUpdate / 1000}
      // round trip ${(stats.loading.end - stats.loading.start) / 1000}
      // diff ${
      //   (reloadInterval -
      //     (estimatedTimeUntilUpdate +
      //       stats.loading.end -
      //       stats.loading.start)) /
      //   1000
      // }
      // reload interval ${reloadInterval / 1000}
      // target duration ${details.targetduration}
      // distance to edge ${distanceToLiveEdgeMs / 1000}`
      // );

      this.timer = self.setTimeout(() => this.loadPlaylist(deliveryDirectives), estimatedTimeUntilUpdate);
    } else {
      this.clearTimer();
    }
  }
  getDeliveryDirectives(details, previousDeliveryDirectives, msn, part) {
    let skip = getSkipValue(details);
    if (previousDeliveryDirectives != null && previousDeliveryDirectives.skip && details.deltaUpdateFailed) {
      msn = previousDeliveryDirectives.msn;
      part = previousDeliveryDirectives.part;
      skip = HlsSkip.No;
    }
    return new HlsUrlParameters(msn, part, skip);
  }
  checkRetry(errorEvent) {
    const errorDetails = errorEvent.details;
    const isTimeout = isTimeoutError(errorEvent);
    const errorAction = errorEvent.errorAction;
    const {
      action,
      retryCount = 0,
      retryConfig
    } = errorAction || {};
    const retry = !!errorAction && !!retryConfig && (action === NetworkErrorAction.RetryRequest || !errorAction.resolved && action === NetworkErrorAction.SendAlternateToPenaltyBox);
    if (retry) {
      var _errorEvent$context;
      this.requestScheduled = -1;
      if (retryCount >= retryConfig.maxNumRetry) {
        return false;
      }
      if (isTimeout && (_errorEvent$context = errorEvent.context) != null && _errorEvent$context.deliveryDirectives) {
        // The LL-HLS request already timed out so retry immediately
        this.warn(`Retrying playlist loading ${retryCount + 1}/${retryConfig.maxNumRetry} after "${errorDetails}" without delivery-directives`);
        this.loadPlaylist();
      } else {
        const delay = getRetryDelay(retryConfig, retryCount);
        // Schedule level/track reload
        this.timer = self.setTimeout(() => this.loadPlaylist(), delay);
        this.warn(`Retrying playlist loading ${retryCount + 1}/${retryConfig.maxNumRetry} after "${errorDetails}" in ${delay}ms`);
      }
      // `levelRetry = true` used to inform other controllers that a retry is happening
      errorEvent.levelRetry = true;
      errorAction.resolved = true;
    }
    return retry;
  }
}

/*
 * compute an Exponential Weighted moving average
 * - https://en.wikipedia.org/wiki/Moving_average#Exponential_moving_average
 *  - heavily inspired from shaka-player
 */

class EWMA {
  //  About half of the estimated value will be from the last |halfLife| samples by weight.
  constructor(halfLife, estimate = 0, weight = 0) {
    this.halfLife = void 0;
    this.alpha_ = void 0;
    this.estimate_ = void 0;
    this.totalWeight_ = void 0;
    this.halfLife = halfLife;
    // Larger values of alpha expire historical data more slowly.
    this.alpha_ = halfLife ? Math.exp(Math.log(0.5) / halfLife) : 0;
    this.estimate_ = estimate;
    this.totalWeight_ = weight;
  }
  sample(weight, value) {
    const adjAlpha = Math.pow(this.alpha_, weight);
    this.estimate_ = value * (1 - adjAlpha) + adjAlpha * this.estimate_;
    this.totalWeight_ += weight;
  }
  getTotalWeight() {
    return this.totalWeight_;
  }
  getEstimate() {
    if (this.alpha_) {
      const zeroFactor = 1 - Math.pow(this.alpha_, this.totalWeight_);
      if (zeroFactor) {
        return this.estimate_ / zeroFactor;
      }
    }
    return this.estimate_;
  }
}

/*
 * EWMA Bandwidth Estimator
 *  - heavily inspired from shaka-player
 * Tracks bandwidth samples and estimates available bandwidth.
 * Based on the minimum of two exponentially-weighted moving averages with
 * different half-lives.
 */

class EwmaBandWidthEstimator {
  constructor(slow, fast, defaultEstimate, defaultTTFB = 100) {
    this.defaultEstimate_ = void 0;
    this.minWeight_ = void 0;
    this.minDelayMs_ = void 0;
    this.slow_ = void 0;
    this.fast_ = void 0;
    this.defaultTTFB_ = void 0;
    this.ttfb_ = void 0;
    this.defaultEstimate_ = defaultEstimate;
    this.minWeight_ = 0.001;
    this.minDelayMs_ = 50;
    this.slow_ = new EWMA(slow);
    this.fast_ = new EWMA(fast);
    this.defaultTTFB_ = defaultTTFB;
    this.ttfb_ = new EWMA(slow);
  }
  update(slow, fast) {
    const {
      slow_,
      fast_,
      ttfb_
    } = this;
    if (slow_.halfLife !== slow) {
      this.slow_ = new EWMA(slow, slow_.getEstimate(), slow_.getTotalWeight());
    }
    if (fast_.halfLife !== fast) {
      this.fast_ = new EWMA(fast, fast_.getEstimate(), fast_.getTotalWeight());
    }
    if (ttfb_.halfLife !== slow) {
      this.ttfb_ = new EWMA(slow, ttfb_.getEstimate(), ttfb_.getTotalWeight());
    }
  }
  sample(durationMs, numBytes) {
    durationMs = Math.max(durationMs, this.minDelayMs_);
    const numBits = 8 * numBytes;
    // weight is duration in seconds
    const durationS = durationMs / 1000;
    // value is bandwidth in bits/s
    const bandwidthInBps = numBits / durationS;
    this.fast_.sample(durationS, bandwidthInBps);
    this.slow_.sample(durationS, bandwidthInBps);
  }
  sampleTTFB(ttfb) {
    // weight is frequency curve applied to TTFB in seconds
    // (longer times have less weight with expected input under 1 second)
    const seconds = ttfb / 1000;
    const weight = Math.sqrt(2) * Math.exp(-Math.pow(seconds, 2) / 2);
    this.ttfb_.sample(weight, Math.max(ttfb, 5));
  }
  canEstimate() {
    return this.fast_.getTotalWeight() >= this.minWeight_;
  }
  getEstimate() {
    if (this.canEstimate()) {
      // console.log('slow estimate:'+ Math.round(this.slow_.getEstimate()));
      // console.log('fast estimate:'+ Math.round(this.fast_.getEstimate()));
      // Take the minimum of these two estimates.  This should have the effect of
      // adapting down quickly, but up more slowly.
      return Math.min(this.fast_.getEstimate(), this.slow_.getEstimate());
    } else {
      return this.defaultEstimate_;
    }
  }
  getEstimateTTFB() {
    if (this.ttfb_.getTotalWeight() >= this.minWeight_) {
      return this.ttfb_.getEstimate();
    } else {
      return this.defaultTTFB_;
    }
  }
  destroy() {}
}

const SUPPORTED_INFO_DEFAULT = {
  supported: true,
  configurations: [],
  decodingInfoResults: [{
    supported: true,
    powerEfficient: true,
    smooth: true
  }]
};
const SUPPORTED_INFO_CACHE = {};
function requiresMediaCapabilitiesDecodingInfo(level, audioTracksByGroup, currentVideoRange, currentFrameRate, currentBw, audioPreference) {
  // Only test support when configuration is exceeds minimum options
  const audioGroups = level.audioCodec ? level.audioGroups : null;
  const audioCodecPreference = audioPreference == null ? void 0 : audioPreference.audioCodec;
  const channelsPreference = audioPreference == null ? void 0 : audioPreference.channels;
  const maxChannels = channelsPreference ? parseInt(channelsPreference) : audioCodecPreference ? Infinity : 2;
  let audioChannels = null;
  if (audioGroups != null && audioGroups.length) {
    try {
      if (audioGroups.length === 1 && audioGroups[0]) {
        audioChannels = audioTracksByGroup.groups[audioGroups[0]].channels;
      } else {
        audioChannels = audioGroups.reduce((acc, groupId) => {
          if (groupId) {
            const audioTrackGroup = audioTracksByGroup.groups[groupId];
            if (!audioTrackGroup) {
              throw new Error(`Audio track group ${groupId} not found`);
            }
            // Sum all channel key values
            Object.keys(audioTrackGroup.channels).forEach(key => {
              acc[key] = (acc[key] || 0) + audioTrackGroup.channels[key];
            });
          }
          return acc;
        }, {
          2: 0
        });
      }
    } catch (error) {
      return true;
    }
  }
  return level.videoCodec !== undefined && (level.width > 1920 && level.height > 1088 || level.height > 1920 && level.width > 1088 || level.frameRate > Math.max(currentFrameRate, 30) || level.videoRange !== 'SDR' && level.videoRange !== currentVideoRange || level.bitrate > Math.max(currentBw, 8e6)) || !!audioChannels && isFiniteNumber(maxChannels) && Object.keys(audioChannels).some(channels => parseInt(channels) > maxChannels);
}
function getMediaDecodingInfoPromise(level, audioTracksByGroup, mediaCapabilities) {
  const videoCodecs = level.videoCodec;
  const audioCodecs = level.audioCodec;
  if (!videoCodecs || !audioCodecs || !mediaCapabilities) {
    return Promise.resolve(SUPPORTED_INFO_DEFAULT);
  }
  const baseVideoConfiguration = {
    width: level.width,
    height: level.height,
    bitrate: Math.ceil(Math.max(level.bitrate * 0.9, level.averageBitrate)),
    // Assume a framerate of 30fps since MediaCapabilities will not accept Level default of 0.
    framerate: level.frameRate || 30
  };
  const videoRange = level.videoRange;
  if (videoRange !== 'SDR') {
    baseVideoConfiguration.transferFunction = videoRange.toLowerCase();
  }
  const configurations = videoCodecs.split(',').map(videoCodec => ({
    type: 'media-source',
    video: _objectSpread2(_objectSpread2({}, baseVideoConfiguration), {}, {
      contentType: mimeTypeForCodec(videoCodec, 'video')
    })
  }));
  if (audioCodecs && level.audioGroups) {
    level.audioGroups.forEach(audioGroupId => {
      var _audioTracksByGroup$g;
      if (!audioGroupId) {
        return;
      }
      (_audioTracksByGroup$g = audioTracksByGroup.groups[audioGroupId]) == null ? void 0 : _audioTracksByGroup$g.tracks.forEach(audioTrack => {
        if (audioTrack.groupId === audioGroupId) {
          const channels = audioTrack.channels || '';
          const channelsNumber = parseFloat(channels);
          if (isFiniteNumber(channelsNumber) && channelsNumber > 2) {
            configurations.push.apply(configurations, audioCodecs.split(',').map(audioCodec => ({
              type: 'media-source',
              audio: {
                contentType: mimeTypeForCodec(audioCodec, 'audio'),
                channels: '' + channelsNumber
                // spatialRendering:
                //   audioCodec === 'ec-3' && channels.indexOf('JOC'),
              }
            })));
          }
        }
      });
    });
  }
  return Promise.all(configurations.map(configuration => {
    // Cache MediaCapabilities promises
    const decodingInfoKey = getMediaDecodingInfoKey(configuration);
    return SUPPORTED_INFO_CACHE[decodingInfoKey] || (SUPPORTED_INFO_CACHE[decodingInfoKey] = mediaCapabilities.decodingInfo(configuration));
  })).then(decodingInfoResults => ({
    supported: !decodingInfoResults.some(info => !info.supported),
    configurations,
    decodingInfoResults
  })).catch(error => ({
    supported: false,
    configurations,
    decodingInfoResults: [],
    error
  }));
}
function getMediaDecodingInfoKey(config) {
  const {
    audio,
    video
  } = config;
  const mediaConfig = video || audio;
  if (mediaConfig) {
    const codec = mediaConfig.contentType.split('"')[1];
    if (video) {
      return `r${video.height}x${video.width}f${Math.ceil(video.framerate)}${video.transferFunction || 'sd'}_${codec}_${Math.ceil(video.bitrate / 1e5)}`;
    }
    if (audio) {
      return `c${audio.channels}${audio.spatialRendering ? 's' : 'n'}_${codec}`;
    }
  }
  return '';
}

/**
 * @returns Whether we can detect and validate HDR capability within the window context
 */
function isHdrSupported() {
  if (typeof matchMedia === 'function') {
    const mediaQueryList = matchMedia('(dynamic-range: high)');
    const badQuery = matchMedia('bad query');
    if (mediaQueryList.media !== badQuery.media) {
      return mediaQueryList.matches === true;
    }
  }
  return false;
}

/**
 * Sanitizes inputs to return the active video selection options for HDR/SDR.
 * When both inputs are null:
 *
 *    `{ preferHDR: false, allowedVideoRanges: [] }`
 *
 * When `currentVideoRange` non-null, maintain the active range:
 *
 *    `{ preferHDR: currentVideoRange !== 'SDR', allowedVideoRanges: [currentVideoRange] }`
 *
 * When VideoSelectionOption non-null:
 *
 *  - Allow all video ranges if `allowedVideoRanges` unspecified.
 *  - If `preferHDR` is non-null use the value to filter `allowedVideoRanges`.
 *  - Else check window for HDR support and set `preferHDR` to the result.
 *
 * @param currentVideoRange
 * @param videoPreference
 */
function getVideoSelectionOptions(currentVideoRange, videoPreference) {
  let preferHDR = false;
  let allowedVideoRanges = [];
  if (currentVideoRange) {
    preferHDR = currentVideoRange !== 'SDR';
    allowedVideoRanges = [currentVideoRange];
  }
  if (videoPreference) {
    allowedVideoRanges = videoPreference.allowedVideoRanges || VideoRangeValues.slice(0);
    preferHDR = videoPreference.preferHDR !== undefined ? videoPreference.preferHDR : isHdrSupported();
    if (preferHDR) {
      allowedVideoRanges = allowedVideoRanges.filter(range => range !== 'SDR');
    } else {
      allowedVideoRanges = ['SDR'];
    }
  }
  return {
    preferHDR,
    allowedVideoRanges
  };
}

function getStartCodecTier(codecTiers, currentVideoRange, currentBw, audioPreference, videoPreference) {
  const codecSets = Object.keys(codecTiers);
  const channelsPreference = audioPreference == null ? void 0 : audioPreference.channels;
  const audioCodecPreference = audioPreference == null ? void 0 : audioPreference.audioCodec;
  const preferStereo = channelsPreference && parseInt(channelsPreference) === 2;
  // Use first level set to determine stereo, and minimum resolution and framerate
  let hasStereo = true;
  let hasCurrentVideoRange = false;
  let minHeight = Infinity;
  let minFramerate = Infinity;
  let minBitrate = Infinity;
  let selectedScore = 0;
  let videoRanges = [];
  const {
    preferHDR,
    allowedVideoRanges
  } = getVideoSelectionOptions(currentVideoRange, videoPreference);
  for (let i = codecSets.length; i--;) {
    const tier = codecTiers[codecSets[i]];
    hasStereo = tier.channels[2] > 0;
    minHeight = Math.min(minHeight, tier.minHeight);
    minFramerate = Math.min(minFramerate, tier.minFramerate);
    minBitrate = Math.min(minBitrate, tier.minBitrate);
    const matchingVideoRanges = allowedVideoRanges.filter(range => tier.videoRanges[range] > 0);
    if (matchingVideoRanges.length > 0) {
      hasCurrentVideoRange = true;
      videoRanges = matchingVideoRanges;
    }
  }
  minHeight = isFiniteNumber(minHeight) ? minHeight : 0;
  minFramerate = isFiniteNumber(minFramerate) ? minFramerate : 0;
  const maxHeight = Math.max(1080, minHeight);
  const maxFramerate = Math.max(30, minFramerate);
  minBitrate = isFiniteNumber(minBitrate) ? minBitrate : currentBw;
  currentBw = Math.max(minBitrate, currentBw);
  // If there are no variants with matching preference, set currentVideoRange to undefined
  if (!hasCurrentVideoRange) {
    currentVideoRange = undefined;
    videoRanges = [];
  }
  const codecSet = codecSets.reduce((selected, candidate) => {
    // Remove candiates which do not meet bitrate, default audio, stereo or channels preference, 1080p or lower, 30fps or lower, or SDR/HDR selection if present
    const candidateTier = codecTiers[candidate];
    if (candidate === selected) {
      return selected;
    }
    if (candidateTier.minBitrate > currentBw) {
      logStartCodecCandidateIgnored(candidate, `min bitrate of ${candidateTier.minBitrate} > current estimate of ${currentBw}`);
      return selected;
    }
    if (!candidateTier.hasDefaultAudio) {
      logStartCodecCandidateIgnored(candidate, `no renditions with default or auto-select sound found`);
      return selected;
    }
    if (audioCodecPreference && candidate.indexOf(audioCodecPreference.substring(0, 4)) % 5 !== 0) {
      logStartCodecCandidateIgnored(candidate, `audio codec preference "${audioCodecPreference}" not found`);
      return selected;
    }
    if (channelsPreference && !preferStereo) {
      if (!candidateTier.channels[channelsPreference]) {
        logStartCodecCandidateIgnored(candidate, `no renditions with ${channelsPreference} channel sound found (channels options: ${Object.keys(candidateTier.channels)})`);
        return selected;
      }
    } else if ((!audioCodecPreference || preferStereo) && hasStereo && candidateTier.channels['2'] === 0) {
      logStartCodecCandidateIgnored(candidate, `no renditions with stereo sound found`);
      return selected;
    }
    if (candidateTier.minHeight > maxHeight) {
      logStartCodecCandidateIgnored(candidate, `min resolution of ${candidateTier.minHeight} > maximum of ${maxHeight}`);
      return selected;
    }
    if (candidateTier.minFramerate > maxFramerate) {
      logStartCodecCandidateIgnored(candidate, `min framerate of ${candidateTier.minFramerate} > maximum of ${maxFramerate}`);
      return selected;
    }
    if (!videoRanges.some(range => candidateTier.videoRanges[range] > 0)) {
      logStartCodecCandidateIgnored(candidate, `no variants with VIDEO-RANGE of ${JSON.stringify(videoRanges)} found`);
      return selected;
    }
    if (candidateTier.maxScore < selectedScore) {
      logStartCodecCandidateIgnored(candidate, `max score of ${candidateTier.maxScore} < selected max of ${selectedScore}`);
      return selected;
    }
    // Remove candiates with less preferred codecs or more errors
    if (selected && (codecsSetSelectionPreferenceValue(candidate) >= codecsSetSelectionPreferenceValue(selected) || candidateTier.fragmentError > codecTiers[selected].fragmentError)) {
      return selected;
    }
    selectedScore = candidateTier.maxScore;
    return candidate;
  }, undefined);
  return {
    codecSet,
    videoRanges,
    preferHDR,
    minFramerate,
    minBitrate
  };
}
function logStartCodecCandidateIgnored(codeSet, reason) {
  logger.log(`[abr] start candidates with "${codeSet}" ignored because ${reason}`);
}
function getAudioTracksByGroup(allAudioTracks) {
  return allAudioTracks.reduce((audioTracksByGroup, track) => {
    let trackGroup = audioTracksByGroup.groups[track.groupId];
    if (!trackGroup) {
      trackGroup = audioTracksByGroup.groups[track.groupId] = {
        tracks: [],
        channels: {
          2: 0
        },
        hasDefault: false,
        hasAutoSelect: false
      };
    }
    trackGroup.tracks.push(track);
    const channelsKey = track.channels || '2';
    trackGroup.channels[channelsKey] = (trackGroup.channels[channelsKey] || 0) + 1;
    trackGroup.hasDefault = trackGroup.hasDefault || track.default;
    trackGroup.hasAutoSelect = trackGroup.hasAutoSelect || track.autoselect;
    if (trackGroup.hasDefault) {
      audioTracksByGroup.hasDefaultAudio = true;
    }
    if (trackGroup.hasAutoSelect) {
      audioTracksByGroup.hasAutoSelectAudio = true;
    }
    return audioTracksByGroup;
  }, {
    hasDefaultAudio: false,
    hasAutoSelectAudio: false,
    groups: {}
  });
}
function getCodecTiers(levels, audioTracksByGroup, minAutoLevel, maxAutoLevel) {
  return levels.slice(minAutoLevel, maxAutoLevel + 1).reduce((tiers, level) => {
    if (!level.codecSet) {
      return tiers;
    }
    const audioGroups = level.audioGroups;
    let tier = tiers[level.codecSet];
    if (!tier) {
      tiers[level.codecSet] = tier = {
        minBitrate: Infinity,
        minHeight: Infinity,
        minFramerate: Infinity,
        maxScore: 0,
        videoRanges: {
          SDR: 0
        },
        channels: {
          '2': 0
        },
        hasDefaultAudio: !audioGroups,
        fragmentError: 0
      };
    }
    tier.minBitrate = Math.min(tier.minBitrate, level.bitrate);
    const lesserWidthOrHeight = Math.min(level.height, level.width);
    tier.minHeight = Math.min(tier.minHeight, lesserWidthOrHeight);
    tier.minFramerate = Math.min(tier.minFramerate, level.frameRate);
    tier.maxScore = Math.max(tier.maxScore, level.score);
    tier.fragmentError += level.fragmentError;
    tier.videoRanges[level.videoRange] = (tier.videoRanges[level.videoRange] || 0) + 1;
    if (audioGroups) {
      audioGroups.forEach(audioGroupId => {
        if (!audioGroupId) {
          return;
        }
        const audioGroup = audioTracksByGroup.groups[audioGroupId];
        if (!audioGroup) {
          return;
        }
        // Default audio is any group with DEFAULT=YES, or if missing then any group with AUTOSELECT=YES, or all variants
        tier.hasDefaultAudio = tier.hasDefaultAudio || audioTracksByGroup.hasDefaultAudio ? audioGroup.hasDefault : audioGroup.hasAutoSelect || !audioTracksByGroup.hasDefaultAudio && !audioTracksByGroup.hasAutoSelectAudio;
        Object.keys(audioGroup.channels).forEach(channels => {
          tier.channels[channels] = (tier.channels[channels] || 0) + audioGroup.channels[channels];
        });
      });
    }
    return tiers;
  }, {});
}
function findMatchingOption(option, tracks, matchPredicate) {
  if ('attrs' in option) {
    const index = tracks.indexOf(option);
    if (index !== -1) {
      return index;
    }
  }
  for (let i = 0; i < tracks.length; i++) {
    const track = tracks[i];
    if (matchesOption(option, track, matchPredicate)) {
      return i;
    }
  }
  return -1;
}
function matchesOption(option, track, matchPredicate) {
  const {
    groupId,
    name,
    lang,
    assocLang,
    characteristics,
    default: isDefault
  } = option;
  const forced = option.forced;
  return (groupId === undefined || track.groupId === groupId) && (name === undefined || track.name === name) && (lang === undefined || track.lang === lang) && (lang === undefined || track.assocLang === assocLang) && (isDefault === undefined || track.default === isDefault) && (forced === undefined || track.forced === forced) && (characteristics === undefined || characteristicsMatch(characteristics, track.characteristics)) && (matchPredicate === undefined || matchPredicate(option, track));
}
function characteristicsMatch(characteristicsA, characteristicsB = '') {
  const arrA = characteristicsA.split(',');
  const arrB = characteristicsB.split(',');
  // Expects each item to be unique:
  return arrA.length === arrB.length && !arrA.some(el => arrB.indexOf(el) === -1);
}
function audioMatchPredicate(option, track) {
  const {
    audioCodec,
    channels
  } = option;
  return (audioCodec === undefined || (track.audioCodec || '').substring(0, 4) === audioCodec.substring(0, 4)) && (channels === undefined || channels === (track.channels || '2'));
}
function findClosestLevelWithAudioGroup(option, levels, allAudioTracks, searchIndex, matchPredicate) {
  const currentLevel = levels[searchIndex];
  // Are there variants with same URI as current level?
  // If so, find a match that does not require any level URI change
  const variants = levels.reduce((variantMap, level, index) => {
    const uri = level.uri;
    const renditions = variantMap[uri] || (variantMap[uri] = []);
    renditions.push(index);
    return variantMap;
  }, {});
  const renditions = variants[currentLevel.uri];
  if (renditions.length > 1) {
    searchIndex = Math.max.apply(Math, renditions);
  }
  // Find best match
  const currentVideoRange = currentLevel.videoRange;
  const currentFrameRate = currentLevel.frameRate;
  const currentVideoCodec = currentLevel.codecSet.substring(0, 4);
  const matchingVideo = searchDownAndUpList(levels, searchIndex, level => {
    if (level.videoRange !== currentVideoRange || level.frameRate !== currentFrameRate || level.codecSet.substring(0, 4) !== currentVideoCodec) {
      return false;
    }
    const audioGroups = level.audioGroups;
    const tracks = allAudioTracks.filter(track => !audioGroups || audioGroups.indexOf(track.groupId) !== -1);
    return findMatchingOption(option, tracks, matchPredicate) > -1;
  });
  if (matchingVideo > -1) {
    return matchingVideo;
  }
  return searchDownAndUpList(levels, searchIndex, level => {
    const audioGroups = level.audioGroups;
    const tracks = allAudioTracks.filter(track => !audioGroups || audioGroups.indexOf(track.groupId) !== -1);
    return findMatchingOption(option, tracks, matchPredicate) > -1;
  });
}
function searchDownAndUpList(arr, searchIndex, predicate) {
  for (let i = searchIndex; i; i--) {
    if (predicate(arr[i])) {
      return i;
    }
  }
  for (let i = searchIndex + 1; i < arr.length; i++) {
    if (predicate(arr[i])) {
      return i;
    }
  }
  return -1;
}

class AbrController {
  constructor(_hls) {
    this.hls = void 0;
    this.lastLevelLoadSec = 0;
    this.lastLoadedFragLevel = -1;
    this.firstSelection = -1;
    this._nextAutoLevel = -1;
    this.nextAutoLevelKey = '';
    this.audioTracksByGroup = null;
    this.codecTiers = null;
    this.timer = -1;
    this.fragCurrent = null;
    this.partCurrent = null;
    this.bitrateTestDelay = 0;
    this.bwEstimator = void 0;
    /*
        This method monitors the download rate of the current fragment, and will downswitch if that fragment will not load
        quickly enough to prevent underbuffering
      */
    this._abandonRulesCheck = () => {
      const {
        fragCurrent: frag,
        partCurrent: part,
        hls
      } = this;
      const {
        autoLevelEnabled,
        media
      } = hls;
      if (!frag || !media) {
        return;
      }
      const now = performance.now();
      const stats = part ? part.stats : frag.stats;
      const duration = part ? part.duration : frag.duration;
      const timeLoading = now - stats.loading.start;
      const minAutoLevel = hls.minAutoLevel;
      // If frag loading is aborted, complete, or from lowest level, stop timer and return
      if (stats.aborted || stats.loaded && stats.loaded === stats.total || frag.level <= minAutoLevel) {
        this.clearTimer();
        // reset forced auto level value so that next level will be selected
        this._nextAutoLevel = -1;
        return;
      }

      // This check only runs if we're in ABR mode and actually playing
      if (!autoLevelEnabled || media.paused || !media.playbackRate || !media.readyState) {
        return;
      }
      const bufferInfo = hls.mainForwardBufferInfo;
      if (bufferInfo === null) {
        return;
      }
      const ttfbEstimate = this.bwEstimator.getEstimateTTFB();
      const playbackRate = Math.abs(media.playbackRate);
      // To maintain stable adaptive playback, only begin monitoring frag loading after half or more of its playback duration has passed
      if (timeLoading <= Math.max(ttfbEstimate, 1000 * (duration / (playbackRate * 2)))) {
        return;
      }

      // bufferStarvationDelay is an estimate of the amount time (in seconds) it will take to exhaust the buffer
      const bufferStarvationDelay = bufferInfo.len / playbackRate;
      const ttfb = stats.loading.first ? stats.loading.first - stats.loading.start : -1;
      const loadedFirstByte = stats.loaded && ttfb > -1;
      const bwEstimate = this.getBwEstimate();
      const levels = hls.levels;
      const level = levels[frag.level];
      const expectedLen = stats.total || Math.max(stats.loaded, Math.round(duration * level.averageBitrate / 8));
      let timeStreaming = loadedFirstByte ? timeLoading - ttfb : timeLoading;
      if (timeStreaming < 1 && loadedFirstByte) {
        timeStreaming = Math.min(timeLoading, stats.loaded * 8 / bwEstimate);
      }
      const loadRate = loadedFirstByte ? stats.loaded * 1000 / timeStreaming : 0;
      // fragLoadDelay is an estimate of the time (in seconds) it will take to buffer the remainder of the fragment
      const fragLoadedDelay = loadRate ? (expectedLen - stats.loaded) / loadRate : expectedLen * 8 / bwEstimate + ttfbEstimate / 1000;
      // Only downswitch if the time to finish loading the current fragment is greater than the amount of buffer left
      if (fragLoadedDelay <= bufferStarvationDelay) {
        return;
      }
      const bwe = loadRate ? loadRate * 8 : bwEstimate;
      let fragLevelNextLoadedDelay = Number.POSITIVE_INFINITY;
      let nextLoadLevel;
      // Iterate through lower level and try to find the largest one that avoids rebuffering
      for (nextLoadLevel = frag.level - 1; nextLoadLevel > minAutoLevel; nextLoadLevel--) {
        // compute time to load next fragment at lower level
        // 8 = bits per byte (bps/Bps)
        const levelNextBitrate = levels[nextLoadLevel].maxBitrate;
        fragLevelNextLoadedDelay = this.getTimeToLoadFrag(ttfbEstimate / 1000, bwe, duration * levelNextBitrate, !levels[nextLoadLevel].details);
        if (fragLevelNextLoadedDelay < bufferStarvationDelay) {
          break;
        }
      }
      // Only emergency switch down if it takes less time to load a new fragment at lowest level instead of continuing
      // to load the current one
      if (fragLevelNextLoadedDelay >= fragLoadedDelay) {
        return;
      }

      // if estimated load time of new segment is completely unreasonable, ignore and do not emergency switch down
      if (fragLevelNextLoadedDelay > duration * 10) {
        return;
      }
      hls.nextLoadLevel = hls.nextAutoLevel = nextLoadLevel;
      if (loadedFirstByte) {
        // If there has been loading progress, sample bandwidth using loading time offset by minimum TTFB time
        this.bwEstimator.sample(timeLoading - Math.min(ttfbEstimate, ttfb), stats.loaded);
      } else {
        // If there has been no loading progress, sample TTFB
        this.bwEstimator.sampleTTFB(timeLoading);
      }
      const nextLoadLevelBitrate = levels[nextLoadLevel].maxBitrate;
      if (this.getBwEstimate() * this.hls.config.abrBandWidthUpFactor > nextLoadLevelBitrate) {
        this.resetEstimator(nextLoadLevelBitrate);
      }
      this.clearTimer();
      logger.warn(`[abr] Fragment ${frag.sn}${part ? ' part ' + part.index : ''} of level ${frag.level} is loading too slowly;
      Time to underbuffer: ${bufferStarvationDelay.toFixed(3)} s
      Estimated load time for current fragment: ${fragLoadedDelay.toFixed(3)} s
      Estimated load time for down switch fragment: ${fragLevelNextLoadedDelay.toFixed(3)} s
      TTFB estimate: ${ttfb | 0} ms
      Current BW estimate: ${isFiniteNumber(bwEstimate) ? bwEstimate | 0 : 'Unknown'} bps
      New BW estimate: ${this.getBwEstimate() | 0} bps
      Switching to level ${nextLoadLevel} @ ${nextLoadLevelBitrate | 0} bps`);
      hls.trigger(Events.FRAG_LOAD_EMERGENCY_ABORTED, {
        frag,
        part,
        stats
      });
    };
    this.hls = _hls;
    this.bwEstimator = this.initEstimator();
    this.registerListeners();
  }
  resetEstimator(abrEwmaDefaultEstimate) {
    if (abrEwmaDefaultEstimate) {
      logger.log(`setting initial bwe to ${abrEwmaDefaultEstimate}`);
      this.hls.config.abrEwmaDefaultEstimate = abrEwmaDefaultEstimate;
    }
    this.firstSelection = -1;
    this.bwEstimator = this.initEstimator();
  }
  initEstimator() {
    const config = this.hls.config;
    return new EwmaBandWidthEstimator(config.abrEwmaSlowVoD, config.abrEwmaFastVoD, config.abrEwmaDefaultEstimate);
  }
  registerListeners() {
    const {
      hls
    } = this;
    hls.on(Events.MANIFEST_LOADING, this.onManifestLoading, this);
    hls.on(Events.FRAG_LOADING, this.onFragLoading, this);
    hls.on(Events.FRAG_LOADED, this.onFragLoaded, this);
    hls.on(Events.FRAG_BUFFERED, this.onFragBuffered, this);
    hls.on(Events.LEVEL_SWITCHING, this.onLevelSwitching, this);
    hls.on(Events.LEVEL_LOADED, this.onLevelLoaded, this);
    hls.on(Events.LEVELS_UPDATED, this.onLevelsUpdated, this);
    hls.on(Events.MAX_AUTO_LEVEL_UPDATED, this.onMaxAutoLevelUpdated, this);
    hls.on(Events.ERROR, this.onError, this);
  }
  unregisterListeners() {
    const {
      hls
    } = this;
    if (!hls) {
      return;
    }
    hls.off(Events.MANIFEST_LOADING, this.onManifestLoading, this);
    hls.off(Events.FRAG_LOADING, this.onFragLoading, this);
    hls.off(Events.FRAG_LOADED, this.onFragLoaded, this);
    hls.off(Events.FRAG_BUFFERED, this.onFragBuffered, this);
    hls.off(Events.LEVEL_SWITCHING, this.onLevelSwitching, this);
    hls.off(Events.LEVEL_LOADED, this.onLevelLoaded, this);
    hls.off(Events.LEVELS_UPDATED, this.onLevelsUpdated, this);
    hls.off(Events.MAX_AUTO_LEVEL_UPDATED, this.onMaxAutoLevelUpdated, this);
    hls.off(Events.ERROR, this.onError, this);
  }
  destroy() {
    this.unregisterListeners();
    this.clearTimer();
    // @ts-ignore
    this.hls = this._abandonRulesCheck = null;
    this.fragCurrent = this.partCurrent = null;
  }
  onManifestLoading(event, data) {
    this.lastLoadedFragLevel = -1;
    this.firstSelection = -1;
    this.lastLevelLoadSec = 0;
    this.fragCurrent = this.partCurrent = null;
    this.onLevelsUpdated();
    this.clearTimer();
  }
  onLevelsUpdated() {
    if (this.lastLoadedFragLevel > -1 && this.fragCurrent) {
      this.lastLoadedFragLevel = this.fragCurrent.level;
    }
    this._nextAutoLevel = -1;
    this.onMaxAutoLevelUpdated();
    this.codecTiers = null;
    this.audioTracksByGroup = null;
  }
  onMaxAutoLevelUpdated() {
    this.firstSelection = -1;
    this.nextAutoLevelKey = '';
  }
  onFragLoading(event, data) {
    const frag = data.frag;
    if (this.ignoreFragment(frag)) {
      return;
    }
    if (!frag.bitrateTest) {
      var _data$part;
      this.fragCurrent = frag;
      this.partCurrent = (_data$part = data.part) != null ? _data$part : null;
    }
    this.clearTimer();
    this.timer = self.setInterval(this._abandonRulesCheck, 100);
  }
  onLevelSwitching(event, data) {
    this.clearTimer();
  }
  onError(event, data) {
    if (data.fatal) {
      return;
    }
    switch (data.details) {
      case ErrorDetails.BUFFER_ADD_CODEC_ERROR:
      case ErrorDetails.BUFFER_APPEND_ERROR:
        // Reset last loaded level so that a new selection can be made after calling recoverMediaError
        this.lastLoadedFragLevel = -1;
        this.firstSelection = -1;
        break;
      case ErrorDetails.FRAG_LOAD_TIMEOUT:
        {
          const frag = data.frag;
          const {
            fragCurrent,
            partCurrent: part
          } = this;
          if (frag && fragCurrent && frag.sn === fragCurrent.sn && frag.level === fragCurrent.level) {
            const now = performance.now();
            const stats = part ? part.stats : frag.stats;
            const timeLoading = now - stats.loading.start;
            const ttfb = stats.loading.first ? stats.loading.first - stats.loading.start : -1;
            const loadedFirstByte = stats.loaded && ttfb > -1;
            if (loadedFirstByte) {
              const ttfbEstimate = this.bwEstimator.getEstimateTTFB();
              this.bwEstimator.sample(timeLoading - Math.min(ttfbEstimate, ttfb), stats.loaded);
            } else {
              this.bwEstimator.sampleTTFB(timeLoading);
            }
          }
          break;
        }
    }
  }
  getTimeToLoadFrag(timeToFirstByteSec, bandwidth, fragSizeBits, isSwitch) {
    const fragLoadSec = timeToFirstByteSec + fragSizeBits / bandwidth;
    const playlistLoadSec = isSwitch ? this.lastLevelLoadSec : 0;
    return fragLoadSec + playlistLoadSec;
  }
  onLevelLoaded(event, data) {
    const config = this.hls.config;
    const {
      loading
    } = data.stats;
    const timeLoadingMs = loading.end - loading.start;
    if (isFiniteNumber(timeLoadingMs)) {
      this.lastLevelLoadSec = timeLoadingMs / 1000;
    }
    if (data.details.live) {
      this.bwEstimator.update(config.abrEwmaSlowLive, config.abrEwmaFastLive);
    } else {
      this.bwEstimator.update(config.abrEwmaSlowVoD, config.abrEwmaFastVoD);
    }
  }
  onFragLoaded(event, {
    frag,
    part
  }) {
    const stats = part ? part.stats : frag.stats;
    if (frag.type === PlaylistLevelType.MAIN) {
      this.bwEstimator.sampleTTFB(stats.loading.first - stats.loading.start);
    }
    if (this.ignoreFragment(frag)) {
      return;
    }
    // stop monitoring bw once frag loaded
    this.clearTimer();
    // reset forced auto level value so that next level will be selected
    if (frag.level === this._nextAutoLevel) {
      this._nextAutoLevel = -1;
    }
    this.firstSelection = -1;

    // compute level average bitrate
    if (this.hls.config.abrMaxWithRealBitrate) {
      const duration = part ? part.duration : frag.duration;
      const level = this.hls.levels[frag.level];
      const loadedBytes = (level.loaded ? level.loaded.bytes : 0) + stats.loaded;
      const loadedDuration = (level.loaded ? level.loaded.duration : 0) + duration;
      level.loaded = {
        bytes: loadedBytes,
        duration: loadedDuration
      };
      level.realBitrate = Math.round(8 * loadedBytes / loadedDuration);
    }
    if (frag.bitrateTest) {
      const fragBufferedData = {
        stats,
        frag,
        part,
        id: frag.type
      };
      this.onFragBuffered(Events.FRAG_BUFFERED, fragBufferedData);
      frag.bitrateTest = false;
    } else {
      // store level id after successful fragment load for playback
      this.lastLoadedFragLevel = frag.level;
    }
  }
  onFragBuffered(event, data) {
    const {
      frag,
      part
    } = data;
    const stats = part != null && part.stats.loaded ? part.stats : frag.stats;
    if (stats.aborted) {
      return;
    }
    if (this.ignoreFragment(frag)) {
      return;
    }
    // Use the difference between parsing and request instead of buffering and request to compute fragLoadingProcessing;
    // rationale is that buffer appending only happens once media is attached. This can happen when config.startFragPrefetch
    // is used. If we used buffering in that case, our BW estimate sample will be very large.
    const processingMs = stats.parsing.end - stats.loading.start - Math.min(stats.loading.first - stats.loading.start, this.bwEstimator.getEstimateTTFB());
    this.bwEstimator.sample(processingMs, stats.loaded);
    stats.bwEstimate = this.getBwEstimate();
    if (frag.bitrateTest) {
      this.bitrateTestDelay = processingMs / 1000;
    } else {
      this.bitrateTestDelay = 0;
    }
  }
  ignoreFragment(frag) {
    // Only count non-alt-audio frags which were actually buffered in our BW calculations
    return frag.type !== PlaylistLevelType.MAIN || frag.sn === 'initSegment';
  }
  clearTimer() {
    if (this.timer > -1) {
      self.clearInterval(this.timer);
      this.timer = -1;
    }
  }
  get firstAutoLevel() {
    const {
      maxAutoLevel,
      minAutoLevel
    } = this.hls;
    const bwEstimate = this.getBwEstimate();
    const maxStartDelay = this.hls.config.maxStarvationDelay;
    const abrAutoLevel = this.findBestLevel(bwEstimate, minAutoLevel, maxAutoLevel, 0, maxStartDelay, 1, 1);
    if (abrAutoLevel > -1) {
      return abrAutoLevel;
    }
    const firstLevel = this.hls.firstLevel;
    const clamped = Math.min(Math.max(firstLevel, minAutoLevel), maxAutoLevel);
    logger.warn(`[abr] Could not find best starting auto level. Defaulting to first in playlist ${firstLevel} clamped to ${clamped}`);
    return clamped;
  }
  get forcedAutoLevel() {
    if (this.nextAutoLevelKey) {
      return -1;
    }
    return this._nextAutoLevel;
  }

  // return next auto level
  get nextAutoLevel() {
    const forcedAutoLevel = this.forcedAutoLevel;
    const bwEstimator = this.bwEstimator;
    const useEstimate = bwEstimator.canEstimate();
    const loadedFirstFrag = this.lastLoadedFragLevel > -1;
    // in case next auto level has been forced, and bw not available or not reliable, return forced value
    if (forcedAutoLevel !== -1 && (!useEstimate || !loadedFirstFrag || this.nextAutoLevelKey === this.getAutoLevelKey())) {
      return forcedAutoLevel;
    }

    // compute next level using ABR logic
    const nextABRAutoLevel = useEstimate && loadedFirstFrag ? this.getNextABRAutoLevel() : this.firstAutoLevel;

    // use forced auto level while it hasn't errored more than ABR selection
    if (forcedAutoLevel !== -1) {
      const levels = this.hls.levels;
      if (levels.length > Math.max(forcedAutoLevel, nextABRAutoLevel) && levels[forcedAutoLevel].loadError <= levels[nextABRAutoLevel].loadError) {
        return forcedAutoLevel;
      }
    }

    // save result until state has changed
    this._nextAutoLevel = nextABRAutoLevel;
    this.nextAutoLevelKey = this.getAutoLevelKey();
    return nextABRAutoLevel;
  }
  getAutoLevelKey() {
    return `${this.getBwEstimate()}_${this.getStarvationDelay().toFixed(2)}`;
  }
  getNextABRAutoLevel() {
    const {
      fragCurrent,
      partCurrent,
      hls
    } = this;
    const {
      maxAutoLevel,
      config,
      minAutoLevel
    } = hls;
    const currentFragDuration = partCurrent ? partCurrent.duration : fragCurrent ? fragCurrent.duration : 0;
    const avgbw = this.getBwEstimate();
    // bufferStarvationDelay is the wall-clock time left until the playback buffer is exhausted.
    const bufferStarvationDelay = this.getStarvationDelay();
    let bwFactor = config.abrBandWidthFactor;
    let bwUpFactor = config.abrBandWidthUpFactor;

    // First, look to see if we can find a level matching with our avg bandwidth AND that could also guarantee no rebuffering at all
    if (bufferStarvationDelay) {
      const _bestLevel = this.findBestLevel(avgbw, minAutoLevel, maxAutoLevel, bufferStarvationDelay, 0, bwFactor, bwUpFactor);
      if (_bestLevel >= 0) {
        return _bestLevel;
      }
    }
    // not possible to get rid of rebuffering... try to find level that will guarantee less than maxStarvationDelay of rebuffering
    let maxStarvationDelay = currentFragDuration ? Math.min(currentFragDuration, config.maxStarvationDelay) : config.maxStarvationDelay;
    if (!bufferStarvationDelay) {
      // in case buffer is empty, let's check if previous fragment was loaded to perform a bitrate test
      const bitrateTestDelay = this.bitrateTestDelay;
      if (bitrateTestDelay) {
        // if it is the case, then we need to adjust our max starvation delay using maxLoadingDelay config value
        // max video loading delay used in  automatic start level selection :
        // in that mode ABR controller will ensure that video loading time (ie the time to fetch the first fragment at lowest quality level +
        // the time to fetch the fragment at the appropriate quality level is less than ```maxLoadingDelay``` )
        // cap maxLoadingDelay and ensure it is not bigger 'than bitrate test' frag duration
        const maxLoadingDelay = currentFragDuration ? Math.min(currentFragDuration, config.maxLoadingDelay) : config.maxLoadingDelay;
        maxStarvationDelay = maxLoadingDelay - bitrateTestDelay;
        logger.info(`[abr] bitrate test took ${Math.round(1000 * bitrateTestDelay)}ms, set first fragment max fetchDuration to ${Math.round(1000 * maxStarvationDelay)} ms`);
        // don't use conservative factor on bitrate test
        bwFactor = bwUpFactor = 1;
      }
    }
    const bestLevel = this.findBestLevel(avgbw, minAutoLevel, maxAutoLevel, bufferStarvationDelay, maxStarvationDelay, bwFactor, bwUpFactor);
    logger.info(`[abr] ${bufferStarvationDelay ? 'rebuffering expected' : 'buffer is empty'}, optimal quality level ${bestLevel}`);
    if (bestLevel > -1) {
      return bestLevel;
    }
    // If no matching level found, see if min auto level would be a better option
    const minLevel = hls.levels[minAutoLevel];
    const autoLevel = hls.levels[hls.loadLevel];
    if ((minLevel == null ? void 0 : minLevel.bitrate) < (autoLevel == null ? void 0 : autoLevel.bitrate)) {
      return minAutoLevel;
    }
    // or if bitrate is not lower, continue to use loadLevel
    return hls.loadLevel;
  }
  getStarvationDelay() {
    const hls = this.hls;
    const media = hls.media;
    if (!media) {
      return Infinity;
    }
    // playbackRate is the absolute value of the playback rate; if media.playbackRate is 0, we use 1 to load as
    // if we're playing back at the normal rate.
    const playbackRate = media && media.playbackRate !== 0 ? Math.abs(media.playbackRate) : 1.0;
    const bufferInfo = hls.mainForwardBufferInfo;
    return (bufferInfo ? bufferInfo.len : 0) / playbackRate;
  }
  getBwEstimate() {
    return this.bwEstimator.canEstimate() ? this.bwEstimator.getEstimate() : this.hls.config.abrEwmaDefaultEstimate;
  }
  findBestLevel(currentBw, minAutoLevel, maxAutoLevel, bufferStarvationDelay, maxStarvationDelay, bwFactor, bwUpFactor) {
    var _level$details;
    const maxFetchDuration = bufferStarvationDelay + maxStarvationDelay;
    const lastLoadedFragLevel = this.lastLoadedFragLevel;
    const selectionBaseLevel = lastLoadedFragLevel === -1 ? this.hls.firstLevel : lastLoadedFragLevel;
    const {
      fragCurrent,
      partCurrent
    } = this;
    const {
      levels,
      allAudioTracks,
      loadLevel,
      config
    } = this.hls;
    if (levels.length === 1) {
      return 0;
    }
    const level = levels[selectionBaseLevel];
    const live = !!(level != null && (_level$details = level.details) != null && _level$details.live);
    const firstSelection = loadLevel === -1 || lastLoadedFragLevel === -1;
    let currentCodecSet;
    let currentVideoRange = 'SDR';
    let currentFrameRate = (level == null ? void 0 : level.frameRate) || 0;
    const {
      audioPreference,
      videoPreference
    } = config;
    const audioTracksByGroup = this.audioTracksByGroup || (this.audioTracksByGroup = getAudioTracksByGroup(allAudioTracks));
    if (firstSelection) {
      if (this.firstSelection !== -1) {
        return this.firstSelection;
      }
      const codecTiers = this.codecTiers || (this.codecTiers = getCodecTiers(levels, audioTracksByGroup, minAutoLevel, maxAutoLevel));
      const startTier = getStartCodecTier(codecTiers, currentVideoRange, currentBw, audioPreference, videoPreference);
      const {
        codecSet,
        videoRanges,
        minFramerate,
        minBitrate,
        preferHDR
      } = startTier;
      currentCodecSet = codecSet;
      currentVideoRange = preferHDR ? videoRanges[videoRanges.length - 1] : videoRanges[0];
      currentFrameRate = minFramerate;
      currentBw = Math.max(currentBw, minBitrate);
      logger.log(`[abr] picked start tier ${JSON.stringify(startTier)}`);
    } else {
      currentCodecSet = level == null ? void 0 : level.codecSet;
      currentVideoRange = level == null ? void 0 : level.videoRange;
    }
    const currentFragDuration = partCurrent ? partCurrent.duration : fragCurrent ? fragCurrent.duration : 0;
    const ttfbEstimateSec = this.bwEstimator.getEstimateTTFB() / 1000;
    const levelsSkipped = [];
    for (let i = maxAutoLevel; i >= minAutoLevel; i--) {
      var _levelInfo$supportedR;
      const levelInfo = levels[i];
      const upSwitch = i > selectionBaseLevel;
      if (!levelInfo) {
        continue;
      }
      if (config.useMediaCapabilities && !levelInfo.supportedResult && !levelInfo.supportedPromise) {
        const mediaCapabilities = navigator.mediaCapabilities;
        if (typeof (mediaCapabilities == null ? void 0 : mediaCapabilities.decodingInfo) === 'function' && requiresMediaCapabilitiesDecodingInfo(levelInfo, audioTracksByGroup, currentVideoRange, currentFrameRate, currentBw, audioPreference)) {
          levelInfo.supportedPromise = getMediaDecodingInfoPromise(levelInfo, audioTracksByGroup, mediaCapabilities);
          levelInfo.supportedPromise.then(decodingInfo => {
            if (!this.hls) {
              return;
            }
            levelInfo.supportedResult = decodingInfo;
            const levels = this.hls.levels;
            const index = levels.indexOf(levelInfo);
            if (decodingInfo.error) {
              logger.warn(`[abr] MediaCapabilities decodingInfo error: "${decodingInfo.error}" for level ${index} ${JSON.stringify(decodingInfo)}`);
            } else if (!decodingInfo.supported) {
              logger.warn(`[abr] Unsupported MediaCapabilities decodingInfo result for level ${index} ${JSON.stringify(decodingInfo)}`);
              if (index > -1 && levels.length > 1) {
                logger.log(`[abr] Removing unsupported level ${index}`);
                this.hls.removeLevel(index);
              }
            }
          });
        } else {
          levelInfo.supportedResult = SUPPORTED_INFO_DEFAULT;
        }
      }

      // skip candidates which change codec-family or video-range,
      // and which decrease or increase frame-rate for up and down-switch respectfully
      if (currentCodecSet && levelInfo.codecSet !== currentCodecSet || currentVideoRange && levelInfo.videoRange !== currentVideoRange || upSwitch && currentFrameRate > levelInfo.frameRate || !upSwitch && currentFrameRate > 0 && currentFrameRate < levelInfo.frameRate || levelInfo.supportedResult && !((_levelInfo$supportedR = levelInfo.supportedResult.decodingInfoResults) != null && _levelInfo$supportedR[0].smooth)) {
        levelsSkipped.push(i);
        continue;
      }
      const levelDetails = levelInfo.details;
      const avgDuration = (partCurrent ? levelDetails == null ? void 0 : levelDetails.partTarget : levelDetails == null ? void 0 : levelDetails.averagetargetduration) || currentFragDuration;
      let adjustedbw;
      // follow algorithm captured from stagefright :
      // https://android.googlesource.com/platform/frameworks/av/+/master/media/libstagefright/httplive/LiveSession.cpp
      // Pick the highest bandwidth stream below or equal to estimated bandwidth.
      // consider only 80% of the available bandwidth, but if we are switching up,
      // be even more conservative (70%) to avoid overestimating and immediately
      // switching back.
      if (!upSwitch) {
        adjustedbw = bwFactor * currentBw;
      } else {
        adjustedbw = bwUpFactor * currentBw;
      }

      // Use average bitrate when starvation delay (buffer length) is gt or eq two segment durations and rebuffering is not expected (maxStarvationDelay > 0)
      const bitrate = currentFragDuration && bufferStarvationDelay >= currentFragDuration * 2 && maxStarvationDelay === 0 ? levels[i].averageBitrate : levels[i].maxBitrate;
      const fetchDuration = this.getTimeToLoadFrag(ttfbEstimateSec, adjustedbw, bitrate * avgDuration, levelDetails === undefined);
      const canSwitchWithinTolerance =
      // if adjusted bw is greater than level bitrate AND
      adjustedbw >= bitrate && (
      // no level change, or new level has no error history
      i === lastLoadedFragLevel || levelInfo.loadError === 0 && levelInfo.fragmentError === 0) && (
      // fragment fetchDuration unknown OR live stream OR fragment fetchDuration less than max allowed fetch duration, then this level matches
      // we don't account for max Fetch Duration for live streams, this is to avoid switching down when near the edge of live sliding window ...
      // special case to support startLevel = -1 (bitrateTest) on live streams : in that case we should not exit loop so that findBestLevel will return -1
      fetchDuration <= ttfbEstimateSec || !isFiniteNumber(fetchDuration) || live && !this.bitrateTestDelay || fetchDuration < maxFetchDuration);
      if (canSwitchWithinTolerance) {
        const forcedAutoLevel = this.forcedAutoLevel;
        if (i !== loadLevel && (forcedAutoLevel === -1 || forcedAutoLevel !== loadLevel)) {
          if (levelsSkipped.length) {
            logger.trace(`[abr] Skipped level(s) ${levelsSkipped.join(',')} of ${maxAutoLevel} max with CODECS and VIDEO-RANGE:"${levels[levelsSkipped[0]].codecs}" ${levels[levelsSkipped[0]].videoRange}; not compatible with "${level.codecs}" ${currentVideoRange}`);
          }
          logger.info(`[abr] switch candidate:${selectionBaseLevel}->${i} adjustedbw(${Math.round(adjustedbw)})-bitrate=${Math.round(adjustedbw - bitrate)} ttfb:${ttfbEstimateSec.toFixed(1)} avgDuration:${avgDuration.toFixed(1)} maxFetchDuration:${maxFetchDuration.toFixed(1)} fetchDuration:${fetchDuration.toFixed(1)} firstSelection:${firstSelection} codecSet:${currentCodecSet} videoRange:${currentVideoRange} hls.loadLevel:${loadLevel}`);
        }
        if (firstSelection) {
          this.firstSelection = i;
        }
        // as we are looping from highest to lowest, this will return the best achievable quality level
        return i;
      }
    }
    // not enough time budget even with quality level 0 ... rebuffering might happen
    return -1;
  }
  set nextAutoLevel(nextLevel) {
    const {
      maxAutoLevel,
      minAutoLevel
    } = this.hls;
    const value = Math.min(Math.max(nextLevel, minAutoLevel), maxAutoLevel);
    if (this._nextAutoLevel !== value) {
      this.nextAutoLevelKey = '';
      this._nextAutoLevel = value;
    }
  }
}

/**
 * @ignore
 * Sub-class specialization of EventHandler base class.
 *
 * TaskLoop allows to schedule a task function being called (optionnaly repeatedly) on the main loop,
 * scheduled asynchroneously, avoiding recursive calls in the same tick.
 *
 * The task itself is implemented in `doTick`. It can be requested and called for single execution
 * using the `tick` method.
 *
 * It will be assured that the task execution method (`tick`) only gets called once per main loop "tick",
 * no matter how often it gets requested for execution. Execution in further ticks will be scheduled accordingly.
 *
 * If further execution requests have already been scheduled on the next tick, it can be checked with `hasNextTick`,
 * and cancelled with `clearNextTick`.
 *
 * The task can be scheduled as an interval repeatedly with a period as parameter (see `setInterval`, `clearInterval`).
 *
 * Sub-classes need to implement the `doTick` method which will effectively have the task execution routine.
 *
 * Further explanations:
 *
 * The baseclass has a `tick` method that will schedule the doTick call. It may be called synchroneously
 * only for a stack-depth of one. On re-entrant calls, sub-sequent calls are scheduled for next main loop ticks.
 *
 * When the task execution (`tick` method) is called in re-entrant way this is detected and
 * we are limiting the task execution per call stack to exactly one, but scheduling/post-poning further
 * task processing on the next main loop iteration (also known as "next tick" in the Node/JS runtime lingo).
 */
class TaskLoop {
  constructor() {
    this._boundTick = void 0;
    this._tickTimer = null;
    this._tickInterval = null;
    this._tickCallCount = 0;
    this._boundTick = this.tick.bind(this);
  }
  destroy() {
    this.onHandlerDestroying();
    this.onHandlerDestroyed();
  }
  onHandlerDestroying() {
    // clear all timers before unregistering from event bus
    this.clearNextTick();
    this.clearInterval();
  }
  onHandlerDestroyed() {}
  hasInterval() {
    return !!this._tickInterval;
  }
  hasNextTick() {
    return !!this._tickTimer;
  }

  /**
   * @param millis - Interval time (ms)
   * @eturns True when interval has been scheduled, false when already scheduled (no effect)
   */
  setInterval(millis) {
    if (!this._tickInterval) {
      this._tickCallCount = 0;
      this._tickInterval = self.setInterval(this._boundTick, millis);
      return true;
    }
    return false;
  }

  /**
   * @returns True when interval was cleared, false when none was set (no effect)
   */
  clearInterval() {
    if (this._tickInterval) {
      self.clearInterval(this._tickInterval);
      this._tickInterval = null;
      return true;
    }
    return false;
  }

  /**
   * @returns True when timeout was cleared, false when none was set (no effect)
   */
  clearNextTick() {
    if (this._tickTimer) {
      self.clearTimeout(this._tickTimer);
      this._tickTimer = null;
      return true;
    }
    return false;
  }

  /**
   * Will call the subclass doTick implementation in this main loop tick
   * or in the next one (via setTimeout(,0)) in case it has already been called
   * in this tick (in case this is a re-entrant call).
   */
  tick() {
    this._tickCallCount++;
    if (this._tickCallCount === 1) {
      this.doTick();
      // re-entrant call to tick from previous doTick call stack
      // -> schedule a call on the next main loop iteration to process this task processing request
      if (this._tickCallCount > 1) {
        // make sure only one timer exists at any time at max
        this.tickImmediate();
      }
      this._tickCallCount = 0;
    }
  }
  tickImmediate() {
    this.clearNextTick();
    this._tickTimer = self.setTimeout(this._boundTick, 0);
  }

  /**
   * For subclass to implement task logic
   * @abstract
   */
  doTick() {}
}

var FragmentState = {
  NOT_LOADED: "NOT_LOADED",
  APPENDING: "APPENDING",
  PARTIAL: "PARTIAL",
  OK: "OK"
};
class FragmentTracker {
  constructor(hls) {
    this.activePartLists = Object.create(null);
    this.endListFragments = Object.create(null);
    this.fragments = Object.create(null);
    this.timeRanges = Object.create(null);
    this.bufferPadding = 0.2;
    this.hls = void 0;
    this.hasGaps = false;
    this.hls = hls;
    this._registerListeners();
  }
  _registerListeners() {
    const {
      hls
    } = this;
    hls.on(Events.BUFFER_APPENDED, this.onBufferAppended, this);
    hls.on(Events.FRAG_BUFFERED, this.onFragBuffered, this);
    hls.on(Events.FRAG_LOADED, this.onFragLoaded, this);
  }
  _unregisterListeners() {
    const {
      hls
    } = this;
    hls.off(Events.BUFFER_APPENDED, this.onBufferAppended, this);
    hls.off(Events.FRAG_BUFFERED, this.onFragBuffered, this);
    hls.off(Events.FRAG_LOADED, this.onFragLoaded, this);
  }
  destroy() {
    this._unregisterListeners();
    // @ts-ignore
    this.fragments =
    // @ts-ignore
    this.activePartLists =
    // @ts-ignore
    this.endListFragments = this.timeRanges = null;
  }

  /**
   * Return a Fragment or Part with an appended range that matches the position and levelType
   * Otherwise, return null
   */
  getAppendedFrag(position, levelType) {
    const activeParts = this.activePartLists[levelType];
    if (activeParts) {
      for (let i = activeParts.length; i--;) {
        const activePart = activeParts[i];
        if (!activePart) {
          break;
        }
        const appendedPTS = activePart.end;
        if (activePart.start <= position && appendedPTS !== null && position <= appendedPTS) {
          return activePart;
        }
      }
    }
    return this.getBufferedFrag(position, levelType);
  }

  /**
   * Return a buffered Fragment that matches the position and levelType.
   * A buffered Fragment is one whose loading, parsing and appending is done (completed or "partial" meaning aborted).
   * If not found any Fragment, return null
   */
  getBufferedFrag(position, levelType) {
    const {
      fragments
    } = this;
    const keys = Object.keys(fragments);
    for (let i = keys.length; i--;) {
      const fragmentEntity = fragments[keys[i]];
      if ((fragmentEntity == null ? void 0 : fragmentEntity.body.type) === levelType && fragmentEntity.buffered) {
        const frag = fragmentEntity.body;
        if (frag.start <= position && position <= frag.end) {
          return frag;
        }
      }
    }
    return null;
  }

  /**
   * Partial fragments effected by coded frame eviction will be removed
   * The browser will unload parts of the buffer to free up memory for new buffer data
   * Fragments will need to be reloaded when the buffer is freed up, removing partial fragments will allow them to reload(since there might be parts that are still playable)
   */
  detectEvictedFragments(elementaryStream, timeRange, playlistType, appendedPart) {
    if (this.timeRanges) {
      this.timeRanges[elementaryStream] = timeRange;
    }
    // Check if any flagged fragments have been unloaded
    // excluding anything newer than appendedPartSn
    const appendedPartSn = (appendedPart == null ? void 0 : appendedPart.fragment.sn) || -1;
    Object.keys(this.fragments).forEach(key => {
      const fragmentEntity = this.fragments[key];
      if (!fragmentEntity) {
        return;
      }
      if (appendedPartSn >= fragmentEntity.body.sn) {
        return;
      }
      if (!fragmentEntity.buffered && !fragmentEntity.loaded) {
        if (fragmentEntity.body.type === playlistType) {
          this.removeFragment(fragmentEntity.body);
        }
        return;
      }
      const esData = fragmentEntity.range[elementaryStream];
      if (!esData) {
        return;
      }
      esData.time.some(time => {
        const isNotBuffered = !this.isTimeBuffered(time.startPTS, time.endPTS, timeRange);
        if (isNotBuffered) {
          // Unregister partial fragment as it needs to load again to be reused
          this.removeFragment(fragmentEntity.body);
        }
        return isNotBuffered;
      });
    });
  }

  /**
   * Checks if the fragment passed in is loaded in the buffer properly
   * Partially loaded fragments will be registered as a partial fragment
   */
  detectPartialFragments(data) {
    const timeRanges = this.timeRanges;
    const {
      frag,
      part
    } = data;
    if (!timeRanges || frag.sn === 'initSegment') {
      return;
    }
    const fragKey = getFragmentKey(frag);
    const fragmentEntity = this.fragments[fragKey];
    if (!fragmentEntity || fragmentEntity.buffered && frag.gap) {
      return;
    }
    const isFragHint = !frag.relurl;
    Object.keys(timeRanges).forEach(elementaryStream => {
      const streamInfo = frag.elementaryStreams[elementaryStream];
      if (!streamInfo) {
        return;
      }
      const timeRange = timeRanges[elementaryStream];
      const partial = isFragHint || streamInfo.partial === true;
      fragmentEntity.range[elementaryStream] = this.getBufferedTimes(frag, part, partial, timeRange);
    });
    fragmentEntity.loaded = null;
    if (Object.keys(fragmentEntity.range).length) {
      fragmentEntity.buffered = true;
      const endList = fragmentEntity.body.endList = frag.endList || fragmentEntity.body.endList;
      if (endList) {
        this.endListFragments[fragmentEntity.body.type] = fragmentEntity;
      }
      if (!isPartial(fragmentEntity)) {
        // Remove older fragment parts from lookup after frag is tracked as buffered
        this.removeParts(frag.sn - 1, frag.type);
      }
    } else {
      // remove fragment if nothing was appended
      this.removeFragment(fragmentEntity.body);
    }
  }
  removeParts(snToKeep, levelType) {
    const activeParts = this.activePartLists[levelType];
    if (!activeParts) {
      return;
    }
    this.activePartLists[levelType] = activeParts.filter(part => part.fragment.sn >= snToKeep);
  }
  fragBuffered(frag, force) {
    const fragKey = getFragmentKey(frag);
    let fragmentEntity = this.fragments[fragKey];
    if (!fragmentEntity && force) {
      fragmentEntity = this.fragments[fragKey] = {
        body: frag,
        appendedPTS: null,
        loaded: null,
        buffered: false,
        range: Object.create(null)
      };
      if (frag.gap) {
        this.hasGaps = true;
      }
    }
    if (fragmentEntity) {
      fragmentEntity.loaded = null;
      fragmentEntity.buffered = true;
    }
  }
  getBufferedTimes(fragment, part, partial, timeRange) {
    const buffered = {
      time: [],
      partial
    };
    const startPTS = fragment.start;
    const endPTS = fragment.end;
    const minEndPTS = fragment.minEndPTS || endPTS;
    const maxStartPTS = fragment.maxStartPTS || startPTS;
    for (let i = 0; i < timeRange.length; i++) {
      const startTime = timeRange.start(i) - this.bufferPadding;
      const endTime = timeRange.end(i) + this.bufferPadding;
      if (maxStartPTS >= startTime && minEndPTS <= endTime) {
        // Fragment is entirely contained in buffer
        // No need to check the other timeRange times since it's completely playable
        buffered.time.push({
          startPTS: Math.max(startPTS, timeRange.start(i)),
          endPTS: Math.min(endPTS, timeRange.end(i))
        });
        break;
      } else if (startPTS < endTime && endPTS > startTime) {
        const start = Math.max(startPTS, timeRange.start(i));
        const end = Math.min(endPTS, timeRange.end(i));
        if (end > start) {
          buffered.partial = true;
          // Check for intersection with buffer
          // Get playable sections of the fragment
          buffered.time.push({
            startPTS: start,
            endPTS: end
          });
        }
      } else if (endPTS <= startTime) {
        // No need to check the rest of the timeRange as it is in order
        break;
      }
    }
    return buffered;
  }

  /**
   * Gets the partial fragment for a certain time
   */
  getPartialFragment(time) {
    let bestFragment = null;
    let timePadding;
    let startTime;
    let endTime;
    let bestOverlap = 0;
    const {
      bufferPadding,
      fragments
    } = this;
    Object.keys(fragments).forEach(key => {
      const fragmentEntity = fragments[key];
      if (!fragmentEntity) {
        return;
      }
      if (isPartial(fragmentEntity)) {
        startTime = fragmentEntity.body.start - bufferPadding;
        endTime = fragmentEntity.body.end + bufferPadding;
        if (time >= startTime && time <= endTime) {
          // Use the fragment that has the most padding from start and end time
          timePadding = Math.min(time - startTime, endTime - time);
          if (bestOverlap <= timePadding) {
            bestFragment = fragmentEntity.body;
            bestOverlap = timePadding;
          }
        }
      }
    });
    return bestFragment;
  }
  isEndListAppended(type) {
    const lastFragmentEntity = this.endListFragments[type];
    return lastFragmentEntity !== undefined && (lastFragmentEntity.buffered || isPartial(lastFragmentEntity));
  }
  getState(fragment) {
    const fragKey = getFragmentKey(fragment);
    const fragmentEntity = this.fragments[fragKey];
    if (fragmentEntity) {
      if (!fragmentEntity.buffered) {
        return FragmentState.APPENDING;
      } else if (isPartial(fragmentEntity)) {
        return FragmentState.PARTIAL;
      } else {
        return FragmentState.OK;
      }
    }
    return FragmentState.NOT_LOADED;
  }
  isTimeBuffered(startPTS, endPTS, timeRange) {
    let startTime;
    let endTime;
    for (let i = 0; i < timeRange.length; i++) {
      startTime = timeRange.start(i) - this.bufferPadding;
      endTime = timeRange.end(i) + this.bufferPadding;
      if (startPTS >= startTime && endPTS <= endTime) {
        return true;
      }
      if (endPTS <= startTime) {
        // No need to check the rest of the timeRange as it is in order
        return false;
      }
    }
    return false;
  }
  onFragLoaded(event, data) {
    const {
      frag,
      part
    } = data;
    // don't track initsegment (for which sn is not a number)
    // don't track frags used for bitrateTest, they're irrelevant.
    if (frag.sn === 'initSegment' || frag.bitrateTest) {
      return;
    }

    // Fragment entity `loaded` FragLoadedData is null when loading parts
    const loaded = part ? null : data;
    const fragKey = getFragmentKey(frag);
    this.fragments[fragKey] = {
      body: frag,
      appendedPTS: null,
      loaded,
      buffered: false,
      range: Object.create(null)
    };
  }
  onBufferAppended(event, data) {
    const {
      frag,
      part,
      timeRanges
    } = data;
    if (frag.sn === 'initSegment') {
      return;
    }
    const playlistType = frag.type;
    if (part) {
      let activeParts = this.activePartLists[playlistType];
      if (!activeParts) {
        this.activePartLists[playlistType] = activeParts = [];
      }
      activeParts.push(part);
    }
    // Store the latest timeRanges loaded in the buffer
    this.timeRanges = timeRanges;
    Object.keys(timeRanges).forEach(elementaryStream => {
      const timeRange = timeRanges[elementaryStream];
      this.detectEvictedFragments(elementaryStream, timeRange, playlistType, part);
    });
  }
  onFragBuffered(event, data) {
    this.detectPartialFragments(data);
  }
  hasFragment(fragment) {
    const fragKey = getFragmentKey(fragment);
    return !!this.fragments[fragKey];
  }
  hasParts(type) {
    var _this$activePartLists;
    return !!((_this$activePartLists = this.activePartLists[type]) != null && _this$activePartLists.length);
  }
  removeFragmentsInRange(start, end, playlistType, withGapOnly, unbufferedOnly) {
    if (withGapOnly && !this.hasGaps) {
      return;
    }
    Object.keys(this.fragments).forEach(key => {
      const fragmentEntity = this.fragments[key];
      if (!fragmentEntity) {
        return;
      }
      const frag = fragmentEntity.body;
      if (frag.type !== playlistType || withGapOnly && !frag.gap) {
        return;
      }
      if (frag.start < end && frag.end > start && (fragmentEntity.buffered || unbufferedOnly)) {
        this.removeFragment(frag);
      }
    });
  }
  removeFragment(fragment) {
    const fragKey = getFragmentKey(fragment);
    fragment.stats.loaded = 0;
    fragment.clearElementaryStreamInfo();
    const activeParts = this.activePartLists[fragment.type];
    if (activeParts) {
      const snToRemove = fragment.sn;
      this.activePartLists[fragment.type] = activeParts.filter(part => part.fragment.sn !== snToRemove);
    }
    delete this.fragments[fragKey];
    if (fragment.endList) {
      delete this.endListFragments[fragment.type];
    }
  }
  removeAllFragments() {
    this.fragments = Object.create(null);
    this.endListFragments = Object.create(null);
    this.activePartLists = Object.create(null);
    this.hasGaps = false;
  }
}
function isPartial(fragmentEntity) {
  var _fragmentEntity$range, _fragmentEntity$range2, _fragmentEntity$range3;
  return fragmentEntity.buffered && (fragmentEntity.body.gap || ((_fragmentEntity$range = fragmentEntity.range.video) == null ? void 0 : _fragmentEntity$range.partial) || ((_fragmentEntity$range2 = fragmentEntity.range.audio) == null ? void 0 : _fragmentEntity$range2.partial) || ((_fragmentEntity$range3 = fragmentEntity.range.audiovideo) == null ? void 0 : _fragmentEntity$range3.partial));
}
function getFragmentKey(fragment) {
  return `${fragment.type}_${fragment.level}_${fragment.sn}`;
}

/**
 * Provides methods dealing with buffer length retrieval for example.
 *
 * In general, a helper around HTML5 MediaElement TimeRanges gathered from `buffered` property.
 *
 * Also @see https://developer.mozilla.org/en-US/docs/Web/API/HTMLMediaElement/buffered
 */

const noopBuffered = {
  length: 0,
  start: () => 0,
  end: () => 0
};
class BufferHelper {
  /**
   * Return true if `media`'s buffered include `position`
   */
  static isBuffered(media, position) {
    try {
      if (media) {
        const buffered = BufferHelper.getBuffered(media);
        for (let i = 0; i < buffered.length; i++) {
          if (position >= buffered.start(i) && position <= buffered.end(i)) {
            return true;
          }
        }
      }
    } catch (error) {
      // this is to catch
      // InvalidStateError: Failed to read the 'buffered' property from 'SourceBuffer':
      // This SourceBuffer has been removed from the parent media source
    }
    return false;
  }
  static bufferInfo(media, pos, maxHoleDuration) {
    try {
      if (media) {
        const vbuffered = BufferHelper.getBuffered(media);
        const buffered = [];
        let i;
        for (i = 0; i < vbuffered.length; i++) {
          buffered.push({
            start: vbuffered.start(i),
            end: vbuffered.end(i)
          });
        }
        return this.bufferedInfo(buffered, pos, maxHoleDuration);
      }
    } catch (error) {
      // this is to catch
      // InvalidStateError: Failed to read the 'buffered' property from 'SourceBuffer':
      // This SourceBuffer has been removed from the parent media source
    }
    return {
      len: 0,
      start: pos,
      end: pos,
      nextStart: undefined
    };
  }
  static bufferedInfo(buffered, pos, maxHoleDuration) {
    pos = Math.max(0, pos);
    // sort on buffer.start/smaller end (IE does not always return sorted buffered range)
    buffered.sort(function (a, b) {
      const diff = a.start - b.start;
      if (diff) {
        return diff;
      } else {
        return b.end - a.end;
      }
    });
    let buffered2 = [];
    if (maxHoleDuration) {
      // there might be some small holes between buffer time range
      // consider that holes smaller than maxHoleDuration are irrelevant and build another
      // buffer time range representations that discards those holes
      for (let i = 0; i < buffered.length; i++) {
        const buf2len = buffered2.length;
        if (buf2len) {
          const buf2end = buffered2[buf2len - 1].end;
          // if small hole (value between 0 or maxHoleDuration ) or overlapping (negative)
          if (buffered[i].start - buf2end < maxHoleDuration) {
            // merge overlapping time ranges
            // update lastRange.end only if smaller than item.end
            // e.g.  [ 1, 15] with  [ 2,8] => [ 1,15] (no need to modify lastRange.end)
            // whereas [ 1, 8] with  [ 2,15] => [ 1,15] ( lastRange should switch from [1,8] to [1,15])
            if (buffered[i].end > buf2end) {
              buffered2[buf2len - 1].end = buffered[i].end;
            }
          } else {
            // big hole
            buffered2.push(buffered[i]);
          }
        } else {
          // first value
          buffered2.push(buffered[i]);
        }
      }
    } else {
      buffered2 = buffered;
    }
    let bufferLen = 0;

    // bufferStartNext can possibly be undefined based on the conditional logic below
    let bufferStartNext;

    // bufferStart and bufferEnd are buffer boundaries around current video position
    let bufferStart = pos;
    let bufferEnd = pos;
    for (let i = 0; i < buffered2.length; i++) {
      const start = buffered2[i].start;
      const end = buffered2[i].end;
      // logger.log('buf start/end:' + buffered.start(i) + '/' + buffered.end(i));
      if (pos + maxHoleDuration >= start && pos < end) {
        // play position is inside this buffer TimeRange, retrieve end of buffer position and buffer length
        bufferStart = start;
        bufferEnd = end;
        bufferLen = bufferEnd - pos;
      } else if (pos + maxHoleDuration < start) {
        bufferStartNext = start;
        break;
      }
    }
    return {
      len: bufferLen,
      start: bufferStart || 0,
      end: bufferEnd || 0,
      nextStart: bufferStartNext
    };
  }

  /**
   * Safe method to get buffered property.
   * SourceBuffer.buffered may throw if SourceBuffer is removed from it's MediaSource
   */
  static getBuffered(media) {
    try {
      return media.buffered;
    } catch (e) {
      logger.log('failed to get media.buffered', e);
      return noopBuffered;
    }
  }
}

class ChunkMetadata {
  constructor(level, sn, id, size = 0, part = -1, partial = false) {
    this.level = void 0;
    this.sn = void 0;
    this.part = void 0;
    this.id = void 0;
    this.size = void 0;
    this.partial = void 0;
    this.transmuxing = getNewPerformanceTiming();
    this.buffering = {
      audio: getNewPerformanceTiming(),
      video: getNewPerformanceTiming(),
      audiovideo: getNewPerformanceTiming()
    };
    this.level = level;
    this.sn = sn;
    this.id = id;
    this.size = size;
    this.part = part;
    this.partial = partial;
  }
}
function getNewPerformanceTiming() {
  return {
    start: 0,
    executeStart: 0,
    executeEnd: 0,
    end: 0
  };
}

function findFirstFragWithCC(fragments, cc) {
  for (let i = 0, len = fragments.length; i < len; i++) {
    var _fragments$i;
    if (((_fragments$i = fragments[i]) == null ? void 0 : _fragments$i.cc) === cc) {
      return fragments[i];
    }
  }
  return null;
}
function shouldAlignOnDiscontinuities(lastFrag, switchDetails, details) {
  if (switchDetails) {
    if (details.endCC > details.startCC || lastFrag && lastFrag.cc < details.startCC) {
      return true;
    }
  }
  return false;
}

// Find the first frag in the previous level which matches the CC of the first frag of the new level
function findDiscontinuousReferenceFrag(prevDetails, curDetails) {
  const prevFrags = prevDetails.fragments;
  const curFrags = curDetails.fragments;
  if (!curFrags.length || !prevFrags.length) {
    logger.log('No fragments to align');
    return;
  }
  const prevStartFrag = findFirstFragWithCC(prevFrags, curFrags[0].cc);
  if (!prevStartFrag || prevStartFrag && !prevStartFrag.startPTS) {
    logger.log('No frag in previous level to align on');
    return;
  }
  return prevStartFrag;
}
function adjustFragmentStart(frag, sliding) {
  if (frag) {
    const start = frag.start + sliding;
    frag.start = frag.startPTS = start;
    frag.endPTS = start + frag.duration;
  }
}
function adjustSlidingStart(sliding, details) {
  // Update segments
  const fragments = details.fragments;
  for (let i = 0, len = fragments.length; i < len; i++) {
    adjustFragmentStart(fragments[i], sliding);
  }
  // Update LL-HLS parts at the end of the playlist
  if (details.fragmentHint) {
    adjustFragmentStart(details.fragmentHint, sliding);
  }
  details.alignedSliding = true;
}

/**
 * Using the parameters of the last level, this function computes PTS' of the new fragments so that they form a
 * contiguous stream with the last fragments.
 * The PTS of a fragment lets Hls.js know where it fits into a stream - by knowing every PTS, we know which fragment to
 * download at any given time. PTS is normally computed when the fragment is demuxed, so taking this step saves us time
 * and an extra download.
 * @param lastFrag
 * @param lastLevel
 * @param details
 */
function alignStream(lastFrag, switchDetails, details) {
  if (!switchDetails) {
    return;
  }
  alignDiscontinuities(lastFrag, details, switchDetails);
  if (!details.alignedSliding && switchDetails) {
    // If the PTS wasn't figured out via discontinuity sequence that means there was no CC increase within the level.
    // Aligning via Program Date Time should therefore be reliable, since PDT should be the same within the same
    // discontinuity sequence.
    alignMediaPlaylistByPDT(details, switchDetails);
  }
  if (!details.alignedSliding && switchDetails && !details.skippedSegments) {
    // Try to align on sn so that we pick a better start fragment.
    // Do not perform this on playlists with delta updates as this is only to align levels on switch
    // and adjustSliding only adjusts fragments after skippedSegments.
    adjustSliding(switchDetails, details);
  }
}

/**
 * Computes the PTS if a new level's fragments using the PTS of a fragment in the last level which shares the same
 * discontinuity sequence.
 * @param lastFrag - The last Fragment which shares the same discontinuity sequence
 * @param lastLevel - The details of the last loaded level
 * @param details - The details of the new level
 */
function alignDiscontinuities(lastFrag, details, switchDetails) {
  if (shouldAlignOnDiscontinuities(lastFrag, switchDetails, details)) {
    const referenceFrag = findDiscontinuousReferenceFrag(switchDetails, details);
    if (referenceFrag && isFiniteNumber(referenceFrag.start)) {
      logger.log(`Adjusting PTS using last level due to CC increase within current level ${details.url}`);
      adjustSlidingStart(referenceFrag.start, details);
    }
  }
}

/**
 * Ensures appropriate time-alignment between renditions based on PDT.
 * This function assumes the timelines represented in `refDetails` are accurate, including the PDTs
 * for the last discontinuity sequence number shared by both playlists when present,
 * and uses the "wallclock"/PDT timeline as a cross-reference to `details`, adjusting the presentation
 * times/timelines of `details` accordingly.
 * Given the asynchronous nature of fetches and initial loads of live `main` and audio/subtitle tracks,
 * the primary purpose of this function is to ensure the "local timelines" of audio/subtitle tracks
 * are aligned to the main/video timeline, using PDT as the cross-reference/"anchor" that should
 * be consistent across playlists, per the HLS spec.
 * @param details - The details of the rendition you'd like to time-align (e.g. an audio rendition).
 * @param refDetails - The details of the reference rendition with start and PDT times for alignment.
 */
function alignMediaPlaylistByPDT(details, refDetails) {
  if (!details.hasProgramDateTime || !refDetails.hasProgramDateTime) {
    return;
  }
  const fragments = details.fragments;
  const refFragments = refDetails.fragments;
  if (!fragments.length || !refFragments.length) {
    return;
  }

  // Calculate a delta to apply to all fragments according to the delta in PDT times and start times
  // of a fragment in the reference details, and a fragment in the target details of the same discontinuity.
  // If a fragment of the same discontinuity was not found use the middle fragment of both.
  let refFrag;
  let frag;
  const targetCC = Math.min(refDetails.endCC, details.endCC);
  if (refDetails.startCC < targetCC && details.startCC < targetCC) {
    refFrag = findFirstFragWithCC(refFragments, targetCC);
    frag = findFirstFragWithCC(fragments, targetCC);
  }
  if (!refFrag || !frag) {
    refFrag = refFragments[Math.floor(refFragments.length / 2)];
    frag = findFirstFragWithCC(fragments, refFrag.cc) || fragments[Math.floor(fragments.length / 2)];
  }
  const refPDT = refFrag.programDateTime;
  const targetPDT = frag.programDateTime;
  if (!refPDT || !targetPDT) {
    return;
  }
  const delta = (targetPDT - refPDT) / 1000 - (frag.start - refFrag.start);
  adjustSlidingStart(delta, details);
}

const MIN_CHUNK_SIZE = Math.pow(2, 17); // 128kb

class FragmentLoader {
  constructor(config) {
    this.config = void 0;
    this.loader = null;
    this.partLoadTimeout = -1;
    this.config = config;
  }
  destroy() {
    if (this.loader) {
      this.loader.destroy();
      this.loader = null;
    }
  }
  abort() {
    if (this.loader) {
      // Abort the loader for current fragment. Only one may load at any given time
      this.loader.abort();
    }
  }
  load(frag, onProgress) {
    const url = frag.url;
    if (!url) {
      return Promise.reject(new LoadError({
        type: ErrorTypes.NETWORK_ERROR,
        details: ErrorDetails.FRAG_LOAD_ERROR,
        fatal: false,
        frag,
        error: new Error(`Fragment does not have a ${url ? 'part list' : 'url'}`),
        networkDetails: null
      }));
    }
    this.abort();
    const config = this.config;
    const FragmentILoader = config.fLoader;
    const DefaultILoader = config.loader;
    return new Promise((resolve, reject) => {
      if (this.loader) {
        this.loader.destroy();
      }
      if (frag.gap) {
        if (frag.tagList.some(tags => tags[0] === 'GAP')) {
          reject(createGapLoadError(frag));
          return;
        } else {
          // Reset temporary treatment as GAP tag
          frag.gap = false;
        }
      }
      const loader = this.loader = frag.loader = FragmentILoader ? new FragmentILoader(config) : new DefaultILoader(config);
      const loaderContext = createLoaderContext(frag);
      const loadPolicy = getLoaderConfigWithoutReties(config.fragLoadPolicy.default);
      const loaderConfig = {
        loadPolicy,
        timeout: loadPolicy.maxLoadTimeMs,
        maxRetry: 0,
        retryDelay: 0,
        maxRetryDelay: 0,
        highWaterMark: frag.sn === 'initSegment' ? Infinity : MIN_CHUNK_SIZE
      };
      // Assign frag stats to the loader's stats reference
      frag.stats = loader.stats;
      loader.load(loaderContext, loaderConfig, {
        onSuccess: (response, stats, context, networkDetails) => {
          this.resetLoader(frag, loader);
          let payload = response.data;
          if (context.resetIV && frag.decryptdata) {
            frag.decryptdata.iv = new Uint8Array(payload.slice(0, 16));
            payload = payload.slice(16);
          }
          resolve({
            frag,
            part: null,
            payload,
            networkDetails
          });
        },
        onError: (response, context, networkDetails, stats) => {
          this.resetLoader(frag, loader);
          reject(new LoadError({
            type: ErrorTypes.NETWORK_ERROR,
            details: ErrorDetails.FRAG_LOAD_ERROR,
            fatal: false,
            frag,
            response: _objectSpread2({
              url,
              data: undefined
            }, response),
            error: new Error(`HTTP Error ${response.code} ${response.text}`),
            networkDetails,
            stats
          }));
        },
        onAbort: (stats, context, networkDetails) => {
          this.resetLoader(frag, loader);
          reject(new LoadError({
            type: ErrorTypes.NETWORK_ERROR,
            details: ErrorDetails.INTERNAL_ABORTED,
            fatal: false,
            frag,
            error: new Error('Aborted'),
            networkDetails,
            stats
          }));
        },
        onTimeout: (stats, context, networkDetails) => {
          this.resetLoader(frag, loader);
          reject(new LoadError({
            type: ErrorTypes.NETWORK_ERROR,
            details: ErrorDetails.FRAG_LOAD_TIMEOUT,
            fatal: false,
            frag,
            error: new Error(`Timeout after ${loaderConfig.timeout}ms`),
            networkDetails,
            stats
          }));
        },
        onProgress: (stats, context, data, networkDetails) => {
          if (onProgress) {
            onProgress({
              frag,
              part: null,
              payload: data,
              networkDetails
            });
          }
        }
      });
    });
  }
  loadPart(frag, part, onProgress) {
    this.abort();
    const config = this.config;
    const FragmentILoader = config.fLoader;
    const DefaultILoader = config.loader;
    return new Promise((resolve, reject) => {
      if (this.loader) {
        this.loader.destroy();
      }
      if (frag.gap || part.gap) {
        reject(createGapLoadError(frag, part));
        return;
      }
      const loader = this.loader = frag.loader = FragmentILoader ? new FragmentILoader(config) : new DefaultILoader(config);
      const loaderContext = createLoaderContext(frag, part);
      // Should we define another load policy for parts?
      const loadPolicy = getLoaderConfigWithoutReties(config.fragLoadPolicy.default);
      const loaderConfig = {
        loadPolicy,
        timeout: loadPolicy.maxLoadTimeMs,
        maxRetry: 0,
        retryDelay: 0,
        maxRetryDelay: 0,
        highWaterMark: MIN_CHUNK_SIZE
      };
      // Assign part stats to the loader's stats reference
      part.stats = loader.stats;
      loader.load(loaderContext, loaderConfig, {
        onSuccess: (response, stats, context, networkDetails) => {
          this.resetLoader(frag, loader);
          this.updateStatsFromPart(frag, part);
          const partLoadedData = {
            frag,
            part,
            payload: response.data,
            networkDetails
          };
          onProgress(partLoadedData);
          resolve(partLoadedData);
        },
        onError: (response, context, networkDetails, stats) => {
          this.resetLoader(frag, loader);
          reject(new LoadError({
            type: ErrorTypes.NETWORK_ERROR,
            details: ErrorDetails.FRAG_LOAD_ERROR,
            fatal: false,
            frag,
            part,
            response: _objectSpread2({
              url: loaderContext.url,
              data: undefined
            }, response),
            error: new Error(`HTTP Error ${response.code} ${response.text}`),
            networkDetails,
            stats
          }));
        },
        onAbort: (stats, context, networkDetails) => {
          frag.stats.aborted = part.stats.aborted;
          this.resetLoader(frag, loader);
          reject(new LoadError({
            type: ErrorTypes.NETWORK_ERROR,
            details: ErrorDetails.INTERNAL_ABORTED,
            fatal: false,
            frag,
            part,
            error: new Error('Aborted'),
            networkDetails,
            stats
          }));
        },
        onTimeout: (stats, context, networkDetails) => {
          this.resetLoader(frag, loader);
          reject(new LoadError({
            type: ErrorTypes.NETWORK_ERROR,
            details: ErrorDetails.FRAG_LOAD_TIMEOUT,
            fatal: false,
            frag,
            part,
            error: new Error(`Timeout after ${loaderConfig.timeout}ms`),
            networkDetails,
            stats
          }));
        }
      });
    });
  }
  updateStatsFromPart(frag, part) {
    const fragStats = frag.stats;
    const partStats = part.stats;
    const partTotal = partStats.total;
    fragStats.loaded += partStats.loaded;
    if (partTotal) {
      const estTotalParts = Math.round(frag.duration / part.duration);
      const estLoadedParts = Math.min(Math.round(fragStats.loaded / partTotal), estTotalParts);
      const estRemainingParts = estTotalParts - estLoadedParts;
      const estRemainingBytes = estRemainingParts * Math.round(fragStats.loaded / estLoadedParts);
      fragStats.total = fragStats.loaded + estRemainingBytes;
    } else {
      fragStats.total = Math.max(fragStats.loaded, fragStats.total);
    }
    const fragLoading = fragStats.loading;
    const partLoading = partStats.loading;
    if (fragLoading.start) {
      // add to fragment loader latency
      fragLoading.first += partLoading.first - partLoading.start;
    } else {
      fragLoading.start = partLoading.start;
      fragLoading.first = partLoading.first;
    }
    fragLoading.end = partLoading.end;
  }
  resetLoader(frag, loader) {
    frag.loader = null;
    if (this.loader === loader) {
      self.clearTimeout(this.partLoadTimeout);
      this.loader = null;
    }
    loader.destroy();
  }
}
function createLoaderContext(frag, part = null) {
  const segment = part || frag;
  const loaderContext = {
    frag,
    part,
    responseType: 'arraybuffer',
    url: segment.url,
    headers: {},
    rangeStart: 0,
    rangeEnd: 0
  };
  const start = segment.byteRangeStartOffset;
  const end = segment.byteRangeEndOffset;
  if (isFiniteNumber(start) && isFiniteNumber(end)) {
    var _frag$decryptdata;
    let byteRangeStart = start;
    let byteRangeEnd = end;
    if (frag.sn === 'initSegment' && ((_frag$decryptdata = frag.decryptdata) == null ? void 0 : _frag$decryptdata.method) === 'AES-128') {
      // MAP segment encrypted with method 'AES-128', when served with HTTP Range,
      // has the unencrypted size specified in the range.
      // Ref: https://tools.ietf.org/html/draft-pantos-hls-rfc8216bis-08#section-6.3.6
      const fragmentLen = end - start;
      if (fragmentLen % 16) {
        byteRangeEnd = end + (16 - fragmentLen % 16);
      }
      if (start !== 0) {
        loaderContext.resetIV = true;
        byteRangeStart = start - 16;
      }
    }
    loaderContext.rangeStart = byteRangeStart;
    loaderContext.rangeEnd = byteRangeEnd;
  }
  return loaderContext;
}
function createGapLoadError(frag, part) {
  const error = new Error(`GAP ${frag.gap ? 'tag' : 'attribute'} found`);
  const errorData = {
    type: ErrorTypes.MEDIA_ERROR,
    details: ErrorDetails.FRAG_GAP,
    fatal: false,
    frag,
    error,
    networkDetails: null
  };
  if (part) {
    errorData.part = part;
  }
  (part ? part : frag).stats.aborted = true;
  return new LoadError(errorData);
}
class LoadError extends Error {
  constructor(data) {
    super(data.error.message);
    this.data = void 0;
    this.data = data;
  }
}

class AESCrypto {
  constructor(subtle, iv) {
    this.subtle = void 0;
    this.aesIV = void 0;
    this.subtle = subtle;
    this.aesIV = iv;
  }
  decrypt(data, key) {
    return this.subtle.decrypt({
      name: 'AES-CBC',
      iv: this.aesIV
    }, key, data);
  }
}

class FastAESKey {
  constructor(subtle, key) {
    this.subtle = void 0;
    this.key = void 0;
    this.subtle = subtle;
    this.key = key;
  }
  expandKey() {
    return this.subtle.importKey('raw', this.key, {
      name: 'AES-CBC'
    }, false, ['encrypt', 'decrypt']);
  }
}

// PKCS7
function removePadding(array) {
  const outputBytes = array.byteLength;
  const paddingBytes = outputBytes && new DataView(array.buffer).getUint8(outputBytes - 1);
  if (paddingBytes) {
    return sliceUint8(array, 0, outputBytes - paddingBytes);
  }
  return array;
}
class AESDecryptor {
  constructor() {
    this.rcon = [0x0, 0x1, 0x2, 0x4, 0x8, 0x10, 0x20, 0x40, 0x80, 0x1b, 0x36];
    this.subMix = [new Uint32Array(256), new Uint32Array(256), new Uint32Array(256), new Uint32Array(256)];
    this.invSubMix = [new Uint32Array(256), new Uint32Array(256), new Uint32Array(256), new Uint32Array(256)];
    this.sBox = new Uint32Array(256);
    this.invSBox = new Uint32Array(256);
    this.key = new Uint32Array(0);
    this.ksRows = 0;
    this.keySize = 0;
    this.keySchedule = void 0;
    this.invKeySchedule = void 0;
    this.initTable();
  }

  // Using view.getUint32() also swaps the byte order.
  uint8ArrayToUint32Array_(arrayBuffer) {
    const view = new DataView(arrayBuffer);
    const newArray = new Uint32Array(4);
    for (let i = 0; i < 4; i++) {
      newArray[i] = view.getUint32(i * 4);
    }
    return newArray;
  }
  initTable() {
    const sBox = this.sBox;
    const invSBox = this.invSBox;
    const subMix = this.subMix;
    const subMix0 = subMix[0];
    const subMix1 = subMix[1];
    const subMix2 = subMix[2];
    const subMix3 = subMix[3];
    const invSubMix = this.invSubMix;
    const invSubMix0 = invSubMix[0];
    const invSubMix1 = invSubMix[1];
    const invSubMix2 = invSubMix[2];
    const invSubMix3 = invSubMix[3];
    const d = new Uint32Array(256);
    let x = 0;
    let xi = 0;
    let i = 0;
    for (i = 0; i < 256; i++) {
      if (i < 128) {
        d[i] = i << 1;
      } else {
        d[i] = i << 1 ^ 0x11b;
      }
    }
    for (i = 0; i < 256; i++) {
      let sx = xi ^ xi << 1 ^ xi << 2 ^ xi << 3 ^ xi << 4;
      sx = sx >>> 8 ^ sx & 0xff ^ 0x63;
      sBox[x] = sx;
      invSBox[sx] = x;

      // Compute multiplication
      const x2 = d[x];
      const x4 = d[x2];
      const x8 = d[x4];

      // Compute sub/invSub bytes, mix columns tables
      let t = d[sx] * 0x101 ^ sx * 0x1010100;
      subMix0[x] = t << 24 | t >>> 8;
      subMix1[x] = t << 16 | t >>> 16;
      subMix2[x] = t << 8 | t >>> 24;
      subMix3[x] = t;

      // Compute inv sub bytes, inv mix columns tables
      t = x8 * 0x1010101 ^ x4 * 0x10001 ^ x2 * 0x101 ^ x * 0x1010100;
      invSubMix0[sx] = t << 24 | t >>> 8;
      invSubMix1[sx] = t << 16 | t >>> 16;
      invSubMix2[sx] = t << 8 | t >>> 24;
      invSubMix3[sx] = t;

      // Compute next counter
      if (!x) {
        x = xi = 1;
      } else {
        x = x2 ^ d[d[d[x8 ^ x2]]];
        xi ^= d[d[xi]];
      }
    }
  }
  expandKey(keyBuffer) {
    // convert keyBuffer to Uint32Array
    const key = this.uint8ArrayToUint32Array_(keyBuffer);
    let sameKey = true;
    let offset = 0;
    while (offset < key.length && sameKey) {
      sameKey = key[offset] === this.key[offset];
      offset++;
    }
    if (sameKey) {
      return;
    }
    this.key = key;
    const keySize = this.keySize = key.length;
    if (keySize !== 4 && keySize !== 6 && keySize !== 8) {
      throw new Error('Invalid aes key size=' + keySize);
    }
    const ksRows = this.ksRows = (keySize + 6 + 1) * 4;
    let ksRow;
    let invKsRow;
    const keySchedule = this.keySchedule = new Uint32Array(ksRows);
    const invKeySchedule = this.invKeySchedule = new Uint32Array(ksRows);
    const sbox = this.sBox;
    const rcon = this.rcon;
    const invSubMix = this.invSubMix;
    const invSubMix0 = invSubMix[0];
    const invSubMix1 = invSubMix[1];
    const invSubMix2 = invSubMix[2];
    const invSubMix3 = invSubMix[3];
    let prev;
    let t;
    for (ksRow = 0; ksRow < ksRows; ksRow++) {
      if (ksRow < keySize) {
        prev = keySchedule[ksRow] = key[ksRow];
        continue;
      }
      t = prev;
      if (ksRow % keySize === 0) {
        // Rot word
        t = t << 8 | t >>> 24;

        // Sub word
        t = sbox[t >>> 24] << 24 | sbox[t >>> 16 & 0xff] << 16 | sbox[t >>> 8 & 0xff] << 8 | sbox[t & 0xff];

        // Mix Rcon
        t ^= rcon[ksRow / keySize | 0] << 24;
      } else if (keySize > 6 && ksRow % keySize === 4) {
        // Sub word
        t = sbox[t >>> 24] << 24 | sbox[t >>> 16 & 0xff] << 16 | sbox[t >>> 8 & 0xff] << 8 | sbox[t & 0xff];
      }
      keySchedule[ksRow] = prev = (keySchedule[ksRow - keySize] ^ t) >>> 0;
    }
    for (invKsRow = 0; invKsRow < ksRows; invKsRow++) {
      ksRow = ksRows - invKsRow;
      if (invKsRow & 3) {
        t = keySchedule[ksRow];
      } else {
        t = keySchedule[ksRow - 4];
      }
      if (invKsRow < 4 || ksRow <= 4) {
        invKeySchedule[invKsRow] = t;
      } else {
        invKeySchedule[invKsRow] = invSubMix0[sbox[t >>> 24]] ^ invSubMix1[sbox[t >>> 16 & 0xff]] ^ invSubMix2[sbox[t >>> 8 & 0xff]] ^ invSubMix3[sbox[t & 0xff]];
      }
      invKeySchedule[invKsRow] = invKeySchedule[invKsRow] >>> 0;
    }
  }

  // Adding this as a method greatly improves performance.
  networkToHostOrderSwap(word) {
    return word << 24 | (word & 0xff00) << 8 | (word & 0xff0000) >> 8 | word >>> 24;
  }
  decrypt(inputArrayBuffer, offset, aesIV) {
    const nRounds = this.keySize + 6;
    const invKeySchedule = this.invKeySchedule;
    const invSBOX = this.invSBox;
    const invSubMix = this.invSubMix;
    const invSubMix0 = invSubMix[0];
    const invSubMix1 = invSubMix[1];
    const invSubMix2 = invSubMix[2];
    const invSubMix3 = invSubMix[3];
    const initVector = this.uint8ArrayToUint32Array_(aesIV);
    let initVector0 = initVector[0];
    let initVector1 = initVector[1];
    let initVector2 = initVector[2];
    let initVector3 = initVector[3];
    const inputInt32 = new Int32Array(inputArrayBuffer);
    const outputInt32 = new Int32Array(inputInt32.length);
    let t0, t1, t2, t3;
    let s0, s1, s2, s3;
    let inputWords0, inputWords1, inputWords2, inputWords3;
    let ksRow, i;
    const swapWord = this.networkToHostOrderSwap;
    while (offset < inputInt32.length) {
      inputWords0 = swapWord(inputInt32[offset]);
      inputWords1 = swapWord(inputInt32[offset + 1]);
      inputWords2 = swapWord(inputInt32[offset + 2]);
      inputWords3 = swapWord(inputInt32[offset + 3]);
      s0 = inputWords0 ^ invKeySchedule[0];
      s1 = inputWords3 ^ invKeySchedule[1];
      s2 = inputWords2 ^ invKeySchedule[2];
      s3 = inputWords1 ^ invKeySchedule[3];
      ksRow = 4;

      // Iterate through the rounds of decryption
      for (i = 1; i < nRounds; i++) {
        t0 = invSubMix0[s0 >>> 24] ^ invSubMix1[s1 >> 16 & 0xff] ^ invSubMix2[s2 >> 8 & 0xff] ^ invSubMix3[s3 & 0xff] ^ invKeySchedule[ksRow];
        t1 = invSubMix0[s1 >>> 24] ^ invSubMix1[s2 >> 16 & 0xff] ^ invSubMix2[s3 >> 8 & 0xff] ^ invSubMix3[s0 & 0xff] ^ invKeySchedule[ksRow + 1];
        t2 = invSubMix0[s2 >>> 24] ^ invSubMix1[s3 >> 16 & 0xff] ^ invSubMix2[s0 >> 8 & 0xff] ^ invSubMix3[s1 & 0xff] ^ invKeySchedule[ksRow + 2];
        t3 = invSubMix0[s3 >>> 24] ^ invSubMix1[s0 >> 16 & 0xff] ^ invSubMix2[s1 >> 8 & 0xff] ^ invSubMix3[s2 & 0xff] ^ invKeySchedule[ksRow + 3];
        // Update state
        s0 = t0;
        s1 = t1;
        s2 = t2;
        s3 = t3;
        ksRow = ksRow + 4;
      }

      // Shift rows, sub bytes, add round key
      t0 = invSBOX[s0 >>> 24] << 24 ^ invSBOX[s1 >> 16 & 0xff] << 16 ^ invSBOX[s2 >> 8 & 0xff] << 8 ^ invSBOX[s3 & 0xff] ^ invKeySchedule[ksRow];
      t1 = invSBOX[s1 >>> 24] << 24 ^ invSBOX[s2 >> 16 & 0xff] << 16 ^ invSBOX[s3 >> 8 & 0xff] << 8 ^ invSBOX[s0 & 0xff] ^ invKeySchedule[ksRow + 1];
      t2 = invSBOX[s2 >>> 24] << 24 ^ invSBOX[s3 >> 16 & 0xff] << 16 ^ invSBOX[s0 >> 8 & 0xff] << 8 ^ invSBOX[s1 & 0xff] ^ invKeySchedule[ksRow + 2];
      t3 = invSBOX[s3 >>> 24] << 24 ^ invSBOX[s0 >> 16 & 0xff] << 16 ^ invSBOX[s1 >> 8 & 0xff] << 8 ^ invSBOX[s2 & 0xff] ^ invKeySchedule[ksRow + 3];

      // Write
      outputInt32[offset] = swapWord(t0 ^ initVector0);
      outputInt32[offset + 1] = swapWord(t3 ^ initVector1);
      outputInt32[offset + 2] = swapWord(t2 ^ initVector2);
      outputInt32[offset + 3] = swapWord(t1 ^ initVector3);

      // reset initVector to last 4 unsigned int
      initVector0 = inputWords0;
      initVector1 = inputWords1;
      initVector2 = inputWords2;
      initVector3 = inputWords3;
      offset = offset + 4;
    }
    return outputInt32.buffer;
  }
}

const CHUNK_SIZE = 16; // 16 bytes, 128 bits

class Decrypter {
  constructor(config, {
    removePKCS7Padding = true
  } = {}) {
    this.logEnabled = true;
    this.removePKCS7Padding = void 0;
    this.subtle = null;
    this.softwareDecrypter = null;
    this.key = null;
    this.fastAesKey = null;
    this.remainderData = null;
    this.currentIV = null;
    this.currentResult = null;
    this.useSoftware = void 0;
    this.useSoftware = config.enableSoftwareAES;
    this.removePKCS7Padding = removePKCS7Padding;
    // built in decryptor expects PKCS7 padding
    if (removePKCS7Padding) {
      try {
        const browserCrypto = self.crypto;
        if (browserCrypto) {
          this.subtle = browserCrypto.subtle || browserCrypto.webkitSubtle;
        }
      } catch (e) {
        /* no-op */
      }
    }
    this.useSoftware = !this.subtle;
  }
  destroy() {
    this.subtle = null;
    this.softwareDecrypter = null;
    this.key = null;
    this.fastAesKey = null;
    this.remainderData = null;
    this.currentIV = null;
    this.currentResult = null;
  }
  isSync() {
    return this.useSoftware;
  }
  flush() {
    const {
      currentResult,
      remainderData
    } = this;
    if (!currentResult || remainderData) {
      this.reset();
      return null;
    }
    const data = new Uint8Array(currentResult);
    this.reset();
    if (this.removePKCS7Padding) {
      return removePadding(data);
    }
    return data;
  }
  reset() {
    this.currentResult = null;
    this.currentIV = null;
    this.remainderData = null;
    if (this.softwareDecrypter) {
      this.softwareDecrypter = null;
    }
  }
  decrypt(data, key, iv) {
    if (this.useSoftware) {
      return new Promise((resolve, reject) => {
        this.softwareDecrypt(new Uint8Array(data), key, iv);
        const decryptResult = this.flush();
        if (decryptResult) {
          resolve(decryptResult.buffer);
        } else {
          reject(new Error('[softwareDecrypt] Failed to decrypt data'));
        }
      });
    }
    return this.webCryptoDecrypt(new Uint8Array(data), key, iv);
  }

  // Software decryption is progressive. Progressive decryption may not return a result on each call. Any cached
  // data is handled in the flush() call
  softwareDecrypt(data, key, iv) {
    const {
      currentIV,
      currentResult,
      remainderData
    } = this;
    this.logOnce('JS AES decrypt');
    // The output is staggered during progressive parsing - the current result is cached, and emitted on the next call
    // This is done in order to strip PKCS7 padding, which is found at the end of each segment. We only know we've reached
    // the end on flush(), but by that time we have already received all bytes for the segment.
    // Progressive decryption does not work with WebCrypto

    if (remainderData) {
      data = appendUint8Array(remainderData, data);
      this.remainderData = null;
    }

    // Byte length must be a multiple of 16 (AES-128 = 128 bit blocks = 16 bytes)
    const currentChunk = this.getValidChunk(data);
    if (!currentChunk.length) {
      return null;
    }
    if (currentIV) {
      iv = currentIV;
    }
    let softwareDecrypter = this.softwareDecrypter;
    if (!softwareDecrypter) {
      softwareDecrypter = this.softwareDecrypter = new AESDecryptor();
    }
    softwareDecrypter.expandKey(key);
    const result = currentResult;
    this.currentResult = softwareDecrypter.decrypt(currentChunk.buffer, 0, iv);
    this.currentIV = sliceUint8(currentChunk, -16).buffer;
    if (!result) {
      return null;
    }
    return result;
  }
  webCryptoDecrypt(data, key, iv) {
    if (this.key !== key || !this.fastAesKey) {
      if (!this.subtle) {
        return Promise.resolve(this.onWebCryptoError(data, key, iv));
      }
      this.key = key;
      this.fastAesKey = new FastAESKey(this.subtle, key);
    }
    return this.fastAesKey.expandKey().then(aesKey => {
      // decrypt using web crypto
      if (!this.subtle) {
        return Promise.reject(new Error('web crypto not initialized'));
      }
      this.logOnce('WebCrypto AES decrypt');
      const crypto = new AESCrypto(this.subtle, new Uint8Array(iv));
      return crypto.decrypt(data.buffer, aesKey);
    }).catch(err => {
      logger.warn(`[decrypter]: WebCrypto Error, disable WebCrypto API, ${err.name}: ${err.message}`);
      return this.onWebCryptoError(data, key, iv);
    });
  }
  onWebCryptoError(data, key, iv) {
    this.useSoftware = true;
    this.logEnabled = true;
    this.softwareDecrypt(data, key, iv);
    const decryptResult = this.flush();
    if (decryptResult) {
      return decryptResult.buffer;
    }
    throw new Error('WebCrypto and softwareDecrypt: failed to decrypt data');
  }
  getValidChunk(data) {
    let currentChunk = data;
    const splitPoint = data.length - data.length % CHUNK_SIZE;
    if (splitPoint !== data.length) {
      currentChunk = sliceUint8(data, 0, splitPoint);
      this.remainderData = sliceUint8(data, splitPoint);
    }
    return currentChunk;
  }
  logOnce(msg) {
    if (!this.logEnabled) {
      return;
    }
    logger.log(`[decrypter]: ${msg}`);
    this.logEnabled = false;
  }
}

/**
 *  TimeRanges to string helper
 */

const TimeRanges = {
  toString: function (r) {
    let log = '';
    const len = r.length;
    for (let i = 0; i < len; i++) {
      log += `[${r.start(i).toFixed(3)}-${r.end(i).toFixed(3)}]`;
    }
    return log;
  }
};

const State = {
  STOPPED: 'STOPPED',
  IDLE: 'IDLE',
  KEY_LOADING: 'KEY_LOADING',
  FRAG_LOADING: 'FRAG_LOADING',
  FRAG_LOADING_WAITING_RETRY: 'FRAG_LOADING_WAITING_RETRY',
  WAITING_TRACK: 'WAITING_TRACK',
  PARSING: 'PARSING',
  PARSED: 'PARSED',
  ENDED: 'ENDED',
  ERROR: 'ERROR',
  WAITING_INIT_PTS: 'WAITING_INIT_PTS',
  WAITING_LEVEL: 'WAITING_LEVEL'
};
class BaseStreamController extends TaskLoop {
  constructor(hls, fragmentTracker, keyLoader, logPrefix, playlistType) {
    super();
    this.hls = void 0;
    this.fragPrevious = null;
    this.fragCurrent = null;
    this.fragmentTracker = void 0;
    this.transmuxer = null;
    this._state = State.STOPPED;
    this.playlistType = void 0;
    this.media = null;
    this.mediaBuffer = null;
    this.config = void 0;
    this.bitrateTest = false;
    this.lastCurrentTime = 0;
    this.nextLoadPosition = 0;
    this.startPosition = 0;
    this.startTimeOffset = null;
    this.loadedmetadata = false;
    this.retryDate = 0;
    this.levels = null;
    this.fragmentLoader = void 0;
    this.keyLoader = void 0;
    this.levelLastLoaded = null;
    this.startFragRequested = false;
    this.decrypter = void 0;
    this.initPTS = [];
    this.onvseeking = null;
    this.onvended = null;
    this.logPrefix = '';
    this.log = void 0;
    this.warn = void 0;
    this.playlistType = playlistType;
    this.logPrefix = logPrefix;
    this.log = logger.log.bind(logger, `${logPrefix}:`);
    this.warn = logger.warn.bind(logger, `${logPrefix}:`);
    this.hls = hls;
    this.fragmentLoader = new FragmentLoader(hls.config);
    this.keyLoader = keyLoader;
    this.fragmentTracker = fragmentTracker;
    this.config = hls.config;
    this.decrypter = new Decrypter(hls.config);
    hls.on(Events.MANIFEST_LOADED, this.onManifestLoaded, this);
  }
  doTick() {
    this.onTickEnd();
  }
  onTickEnd() {}

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  startLoad(startPosition) {}
  stopLoad() {
    this.fragmentLoader.abort();
    this.keyLoader.abort(this.playlistType);
    const frag = this.fragCurrent;
    if (frag != null && frag.loader) {
      frag.abortRequests();
      this.fragmentTracker.removeFragment(frag);
    }
    this.resetTransmuxer();
    this.fragCurrent = null;
    this.fragPrevious = null;
    this.clearInterval();
    this.clearNextTick();
    this.state = State.STOPPED;
  }
  _streamEnded(bufferInfo, levelDetails) {
    // If playlist is live, there is another buffered range after the current range, nothing buffered, media is detached,
    // of nothing loading/loaded return false
    if (levelDetails.live || bufferInfo.nextStart || !bufferInfo.end || !this.media) {
      return false;
    }
    const partList = levelDetails.partList;
    // Since the last part isn't guaranteed to correspond to the last playlist segment for Low-Latency HLS,
    // check instead if the last part is buffered.
    if (partList != null && partList.length) {
      const lastPart = partList[partList.length - 1];

      // Checking the midpoint of the part for potential margin of error and related issues.
      // NOTE: Technically I believe parts could yield content that is < the computed duration (including potential a duration of 0)
      // and still be spec-compliant, so there may still be edge cases here. Likewise, there could be issues in end of stream
      // part mismatches for independent audio and video playlists/segments.
      const lastPartBuffered = BufferHelper.isBuffered(this.media, lastPart.start + lastPart.duration / 2);
      return lastPartBuffered;
    }
    const playlistType = levelDetails.fragments[levelDetails.fragments.length - 1].type;
    return this.fragmentTracker.isEndListAppended(playlistType);
  }
  getLevelDetails() {
    if (this.levels && this.levelLastLoaded !== null) {
      var _this$levelLastLoaded;
      return (_this$levelLastLoaded = this.levelLastLoaded) == null ? void 0 : _this$levelLastLoaded.details;
    }
  }
  onMediaAttached(event, data) {
    const media = this.media = this.mediaBuffer = data.media;
    this.onvseeking = this.onMediaSeeking.bind(this);
    this.onvended = this.onMediaEnded.bind(this);
    media.addEventListener('seeking', this.onvseeking);
    media.addEventListener('ended', this.onvended);
    const config = this.config;
    if (this.levels && config.autoStartLoad && this.state === State.STOPPED) {
      this.startLoad(config.startPosition);
    }
  }
  onMediaDetaching() {
    const media = this.media;
    if (media != null && media.ended) {
      this.log('MSE detaching and video ended, reset startPosition');
      this.startPosition = this.lastCurrentTime = 0;
    }

    // remove video listeners
    if (media && this.onvseeking && this.onvended) {
      media.removeEventListener('seeking', this.onvseeking);
      media.removeEventListener('ended', this.onvended);
      this.onvseeking = this.onvended = null;
    }
    if (this.keyLoader) {
      this.keyLoader.detach();
    }
    this.media = this.mediaBuffer = null;
    this.loadedmetadata = false;
    this.fragmentTracker.removeAllFragments();
    this.stopLoad();
  }
  onMediaSeeking() {
    const {
      config,
      fragCurrent,
      media,
      mediaBuffer,
      state
    } = this;
    const currentTime = media ? media.currentTime : 0;
    const bufferInfo = BufferHelper.bufferInfo(mediaBuffer ? mediaBuffer : media, currentTime, config.maxBufferHole);
    this.log(`media seeking to ${isFiniteNumber(currentTime) ? currentTime.toFixed(3) : currentTime}, state: ${state}`);
    if (this.state === State.ENDED) {
      this.resetLoadingState();
    } else if (fragCurrent) {
      // Seeking while frag load is in progress
      const tolerance = config.maxFragLookUpTolerance;
      const fragStartOffset = fragCurrent.start - tolerance;
      const fragEndOffset = fragCurrent.start + fragCurrent.duration + tolerance;
      // if seeking out of buffered range or into new one
      if (!bufferInfo.len || fragEndOffset < bufferInfo.start || fragStartOffset > bufferInfo.end) {
        const pastFragment = currentTime > fragEndOffset;
        // if the seek position is outside the current fragment range
        if (currentTime < fragStartOffset || pastFragment) {
          if (pastFragment && fragCurrent.loader) {
            this.log('seeking outside of buffer while fragment load in progress, cancel fragment load');
            fragCurrent.abortRequests();
            this.resetLoadingState();
          }
          this.fragPrevious = null;
        }
      }
    }
    if (media) {
      // Remove gap fragments
      this.fragmentTracker.removeFragmentsInRange(currentTime, Infinity, this.playlistType, true);
      this.lastCurrentTime = currentTime;
    }

    // in case seeking occurs although no media buffered, adjust startPosition and nextLoadPosition to seek target
    if (!this.loadedmetadata && !bufferInfo.len) {
      this.nextLoadPosition = this.startPosition = currentTime;
    }

    // Async tick to speed up processing
    this.tickImmediate();
  }
  onMediaEnded() {
    // reset startPosition and lastCurrentTime to restart playback @ stream beginning
    this.startPosition = this.lastCurrentTime = 0;
  }
  onManifestLoaded(event, data) {
    this.startTimeOffset = data.startTimeOffset;
    this.initPTS = [];
  }
  onHandlerDestroying() {
    this.hls.off(Events.MANIFEST_LOADED, this.onManifestLoaded, this);
    this.stopLoad();
    super.onHandlerDestroying();
    // @ts-ignore
    this.hls = null;
  }
  onHandlerDestroyed() {
    this.state = State.STOPPED;
    if (this.fragmentLoader) {
      this.fragmentLoader.destroy();
    }
    if (this.keyLoader) {
      this.keyLoader.destroy();
    }
    if (this.decrypter) {
      this.decrypter.destroy();
    }
    this.hls = this.log = this.warn = this.decrypter = this.keyLoader = this.fragmentLoader = this.fragmentTracker = null;
    super.onHandlerDestroyed();
  }
  loadFragment(frag, level, targetBufferTime) {
    this._loadFragForPlayback(frag, level, targetBufferTime);
  }
  _loadFragForPlayback(frag, level, targetBufferTime) {
    const progressCallback = data => {
      if (this.fragContextChanged(frag)) {
        this.warn(`Fragment ${frag.sn}${data.part ? ' p: ' + data.part.index : ''} of level ${frag.level} was dropped during download.`);
        this.fragmentTracker.removeFragment(frag);
        return;
      }
      frag.stats.chunkCount++;
      this._handleFragmentLoadProgress(data);
    };
    this._doFragLoad(frag, level, targetBufferTime, progressCallback).then(data => {
      if (!data) {
        // if we're here we probably needed to backtrack or are waiting for more parts
        return;
      }
      const state = this.state;
      if (this.fragContextChanged(frag)) {
        if (state === State.FRAG_LOADING || !this.fragCurrent && state === State.PARSING) {
          this.fragmentTracker.removeFragment(frag);
          this.state = State.IDLE;
        }
        return;
      }
      if ('payload' in data) {
        this.log(`Loaded fragment ${frag.sn} of level ${frag.level}`);
        this.hls.trigger(Events.FRAG_LOADED, data);
      }

      // Pass through the whole payload; controllers not implementing progressive loading receive data from this callback
      this._handleFragmentLoadComplete(data);
    }).catch(reason => {
      if (this.state === State.STOPPED || this.state === State.ERROR) {
        return;
      }
      this.warn(`Frag error: ${(reason == null ? void 0 : reason.message) || reason}`);
      this.resetFragmentLoading(frag);
    });
  }
  clearTrackerIfNeeded(frag) {
    var _this$mediaBuffer;
    const {
      fragmentTracker
    } = this;
    const fragState = fragmentTracker.getState(frag);
    if (fragState === FragmentState.APPENDING) {
      // Lower the max buffer length and try again
      const playlistType = frag.type;
      const bufferedInfo = this.getFwdBufferInfo(this.mediaBuffer, playlistType);
      const minForwardBufferLength = Math.max(frag.duration, bufferedInfo ? bufferedInfo.len : this.config.maxBufferLength);
      // If backtracking, always remove from the tracker without reducing max buffer length
      const backtrackFragment = this.backtrackFragment;
      const backtracked = backtrackFragment ? frag.sn - backtrackFragment.sn : 0;
      if (backtracked === 1 || this.reduceMaxBufferLength(minForwardBufferLength, frag.duration)) {
        fragmentTracker.removeFragment(frag);
      }
    } else if (((_this$mediaBuffer = this.mediaBuffer) == null ? void 0 : _this$mediaBuffer.buffered.length) === 0) {
      // Stop gap for bad tracker / buffer flush behavior
      fragmentTracker.removeAllFragments();
    } else if (fragmentTracker.hasParts(frag.type)) {
      // In low latency mode, remove fragments for which only some parts were buffered
      fragmentTracker.detectPartialFragments({
        frag,
        part: null,
        stats: frag.stats,
        id: frag.type
      });
      if (fragmentTracker.getState(frag) === FragmentState.PARTIAL) {
        fragmentTracker.removeFragment(frag);
      }
    }
  }
  checkLiveUpdate(details) {
    if (details.updated && !details.live) {
      // Live stream ended, update fragment tracker
      const lastFragment = details.fragments[details.fragments.length - 1];
      this.fragmentTracker.detectPartialFragments({
        frag: lastFragment,
        part: null,
        stats: lastFragment.stats,
        id: lastFragment.type
      });
    }
    if (!details.fragments[0]) {
      details.deltaUpdateFailed = true;
    }
  }
  flushMainBuffer(startOffset, endOffset, type = null) {
    if (!(startOffset - endOffset)) {
      return;
    }
    // When alternate audio is playing, the audio-stream-controller is responsible for the audio buffer. Otherwise,
    // passing a null type flushes both buffers
    const flushScope = {
      startOffset,
      endOffset,
      type
    };
    this.hls.trigger(Events.BUFFER_FLUSHING, flushScope);
  }
  _loadInitSegment(frag, level) {
    this._doFragLoad(frag, level).then(data => {
      if (!data || this.fragContextChanged(frag) || !this.levels) {
        throw new Error('init load aborted');
      }
      return data;
    }).then(data => {
      const {
        hls
      } = this;
      const {
        payload
      } = data;
      const decryptData = frag.decryptdata;

      // check to see if the payload needs to be decrypted
      if (payload && payload.byteLength > 0 && decryptData != null && decryptData.key && decryptData.iv && decryptData.method === 'AES-128') {
        const startTime = self.performance.now();
        // decrypt init segment data
        return this.decrypter.decrypt(new Uint8Array(payload), decryptData.key.buffer, decryptData.iv.buffer).catch(err => {
          hls.trigger(Events.ERROR, {
            type: ErrorTypes.MEDIA_ERROR,
            details: ErrorDetails.FRAG_DECRYPT_ERROR,
            fatal: false,
            error: err,
            reason: err.message,
            frag
          });
          throw err;
        }).then(decryptedData => {
          const endTime = self.performance.now();
          hls.trigger(Events.FRAG_DECRYPTED, {
            frag,
            payload: decryptedData,
            stats: {
              tstart: startTime,
              tdecrypt: endTime
            }
          });
          data.payload = decryptedData;
          return this.completeInitSegmentLoad(data);
        });
      }
      return this.completeInitSegmentLoad(data);
    }).catch(reason => {
      if (this.state === State.STOPPED || this.state === State.ERROR) {
        return;
      }
      this.warn(reason);
      this.resetFragmentLoading(frag);
    });
  }
  completeInitSegmentLoad(data) {
    const {
      levels
    } = this;
    if (!levels) {
      throw new Error('init load aborted, missing levels');
    }
    const stats = data.frag.stats;
    this.state = State.IDLE;
    data.frag.data = new Uint8Array(data.payload);
    stats.parsing.start = stats.buffering.start = self.performance.now();
    stats.parsing.end = stats.buffering.end = self.performance.now();
    this.tick();
  }
  fragContextChanged(frag) {
    const {
      fragCurrent
    } = this;
    return !frag || !fragCurrent || frag.sn !== fragCurrent.sn || frag.level !== fragCurrent.level;
  }
  fragBufferedComplete(frag, part) {
    var _frag$startPTS, _frag$endPTS, _this$fragCurrent, _this$fragPrevious;
    const media = this.mediaBuffer ? this.mediaBuffer : this.media;
    this.log(`Buffered ${frag.type} sn: ${frag.sn}${part ? ' part: ' + part.index : ''} of ${this.playlistType === PlaylistLevelType.MAIN ? 'level' : 'track'} ${frag.level} (frag:[${((_frag$startPTS = frag.startPTS) != null ? _frag$startPTS : NaN).toFixed(3)}-${((_frag$endPTS = frag.endPTS) != null ? _frag$endPTS : NaN).toFixed(3)}] > buffer:${media ? TimeRanges.toString(BufferHelper.getBuffered(media)) : '(detached)'})`);
    if (frag.sn !== 'initSegment') {
      var _this$levels;
      if (frag.type !== PlaylistLevelType.SUBTITLE) {
        const el = frag.elementaryStreams;
        if (!Object.keys(el).some(type => !!el[type])) {
          // empty segment
          this.state = State.IDLE;
          return;
        }
      }
      const level = (_this$levels = this.levels) == null ? void 0 : _this$levels[frag.level];
      if (level != null && level.fragmentError) {
        this.log(`Resetting level fragment error count of ${level.fragmentError} on frag buffered`);
        level.fragmentError = 0;
      }
    }
    this.state = State.IDLE;
    if (!media) {
      return;
    }
    if (!this.loadedmetadata && frag.type == PlaylistLevelType.MAIN && media.buffered.length && ((_this$fragCurrent = this.fragCurrent) == null ? void 0 : _this$fragCurrent.sn) === ((_this$fragPrevious = this.fragPrevious) == null ? void 0 : _this$fragPrevious.sn)) {
      this.loadedmetadata = true;
      this.seekToStartPos();
    }
    this.tick();
  }
  seekToStartPos() {}
  _handleFragmentLoadComplete(fragLoadedEndData) {
    const {
      transmuxer
    } = this;
    if (!transmuxer) {
      return;
    }
    const {
      frag,
      part,
      partsLoaded
    } = fragLoadedEndData;
    // If we did not load parts, or loaded all parts, we have complete (not partial) fragment data
    const complete = !partsLoaded || partsLoaded.length === 0 || partsLoaded.some(fragLoaded => !fragLoaded);
    const chunkMeta = new ChunkMetadata(frag.level, frag.sn, frag.stats.chunkCount + 1, 0, part ? part.index : -1, !complete);
    transmuxer.flush(chunkMeta);
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  _handleFragmentLoadProgress(frag) {}
  _doFragLoad(frag, level, targetBufferTime = null, progressCallback) {
    var _frag$decryptdata;
    const details = level == null ? void 0 : level.details;
    if (!this.levels || !details) {
      throw new Error(`frag load aborted, missing level${details ? '' : ' detail'}s`);
    }
    let keyLoadingPromise = null;
    if (frag.encrypted && !((_frag$decryptdata = frag.decryptdata) != null && _frag$decryptdata.key)) {
      this.log(`Loading key for ${frag.sn} of [${details.startSN}-${details.endSN}], ${this.logPrefix === '[stream-controller]' ? 'level' : 'track'} ${frag.level}`);
      this.state = State.KEY_LOADING;
      this.fragCurrent = frag;
      keyLoadingPromise = this.keyLoader.load(frag).then(keyLoadedData => {
        if (!this.fragContextChanged(keyLoadedData.frag)) {
          this.hls.trigger(Events.KEY_LOADED, keyLoadedData);
          if (this.state === State.KEY_LOADING) {
            this.state = State.IDLE;
          }
          return keyLoadedData;
        }
      });
      this.hls.trigger(Events.KEY_LOADING, {
        frag
      });
      if (this.fragCurrent === null) {
        keyLoadingPromise = Promise.reject(new Error(`frag load aborted, context changed in KEY_LOADING`));
      }
    } else if (!frag.encrypted && details.encryptedFragments.length) {
      this.keyLoader.loadClear(frag, details.encryptedFragments);
    }
    targetBufferTime = Math.max(frag.start, targetBufferTime || 0);
    if (this.config.lowLatencyMode && frag.sn !== 'initSegment') {
      const partList = details.partList;
      if (partList && progressCallback) {
        if (targetBufferTime > frag.end && details.fragmentHint) {
          frag = details.fragmentHint;
        }
        const partIndex = this.getNextPart(partList, frag, targetBufferTime);
        if (partIndex > -1) {
          const part = partList[partIndex];
          this.log(`Loading part sn: ${frag.sn} p: ${part.index} cc: ${frag.cc} of playlist [${details.startSN}-${details.endSN}] parts [0-${partIndex}-${partList.length - 1}] ${this.logPrefix === '[stream-controller]' ? 'level' : 'track'}: ${frag.level}, target: ${parseFloat(targetBufferTime.toFixed(3))}`);
          this.nextLoadPosition = part.start + part.duration;
          this.state = State.FRAG_LOADING;
          let _result;
          if (keyLoadingPromise) {
            _result = keyLoadingPromise.then(keyLoadedData => {
              if (!keyLoadedData || this.fragContextChanged(keyLoadedData.frag)) {
                return null;
              }
              return this.doFragPartsLoad(frag, part, level, progressCallback);
            }).catch(error => this.handleFragLoadError(error));
          } else {
            _result = this.doFragPartsLoad(frag, part, level, progressCallback).catch(error => this.handleFragLoadError(error));
          }
          this.hls.trigger(Events.FRAG_LOADING, {
            frag,
            part,
            targetBufferTime
          });
          if (this.fragCurrent === null) {
            return Promise.reject(new Error(`frag load aborted, context changed in FRAG_LOADING parts`));
          }
          return _result;
        } else if (!frag.url || this.loadedEndOfParts(partList, targetBufferTime)) {
          // Fragment hint has no parts
          return Promise.resolve(null);
        }
      }
    }
    this.log(`Loading fragment ${frag.sn} cc: ${frag.cc} ${details ? 'of [' + details.startSN + '-' + details.endSN + '] ' : ''}${this.logPrefix === '[stream-controller]' ? 'level' : 'track'}: ${frag.level}, target: ${parseFloat(targetBufferTime.toFixed(3))}`);
    // Don't update nextLoadPosition for fragments which are not buffered
    if (isFiniteNumber(frag.sn) && !this.bitrateTest) {
      this.nextLoadPosition = frag.start + frag.duration;
    }
    this.state = State.FRAG_LOADING;

    // Load key before streaming fragment data
    const dataOnProgress = this.config.progressive;
    let result;
    if (dataOnProgress && keyLoadingPromise) {
      result = keyLoadingPromise.then(keyLoadedData => {
        if (!keyLoadedData || this.fragContextChanged(keyLoadedData == null ? void 0 : keyLoadedData.frag)) {
          return null;
        }
        return this.fragmentLoader.load(frag, progressCallback);
      }).catch(error => this.handleFragLoadError(error));
    } else {
      // load unencrypted fragment data with progress event,
      // or handle fragment result after key and fragment are finished loading
      result = Promise.all([this.fragmentLoader.load(frag, dataOnProgress ? progressCallback : undefined), keyLoadingPromise]).then(([fragLoadedData]) => {
        if (!dataOnProgress && fragLoadedData && progressCallback) {
          progressCallback(fragLoadedData);
        }
        return fragLoadedData;
      }).catch(error => this.handleFragLoadError(error));
    }
    this.hls.trigger(Events.FRAG_LOADING, {
      frag,
      targetBufferTime
    });
    if (this.fragCurrent === null) {
      return Promise.reject(new Error(`frag load aborted, context changed in FRAG_LOADING`));
    }
    return result;
  }
  doFragPartsLoad(frag, fromPart, level, progressCallback) {
    return new Promise((resolve, reject) => {
      var _level$details;
      const partsLoaded = [];
      const initialPartList = (_level$details = level.details) == null ? void 0 : _level$details.partList;
      const loadPart = part => {
        this.fragmentLoader.loadPart(frag, part, progressCallback).then(partLoadedData => {
          partsLoaded[part.index] = partLoadedData;
          const loadedPart = partLoadedData.part;
          this.hls.trigger(Events.FRAG_LOADED, partLoadedData);
          const nextPart = getPartWith(level, frag.sn, part.index + 1) || findPart(initialPartList, frag.sn, part.index + 1);
          if (nextPart) {
            loadPart(nextPart);
          } else {
            return resolve({
              frag,
              part: loadedPart,
              partsLoaded
            });
          }
        }).catch(reject);
      };
      loadPart(fromPart);
    });
  }
  handleFragLoadError(error) {
    if ('data' in error) {
      const data = error.data;
      if (error.data && data.details === ErrorDetails.INTERNAL_ABORTED) {
        this.handleFragLoadAborted(data.frag, data.part);
      } else {
        this.hls.trigger(Events.ERROR, data);
      }
    } else {
      this.hls.trigger(Events.ERROR, {
        type: ErrorTypes.OTHER_ERROR,
        details: ErrorDetails.INTERNAL_EXCEPTION,
        err: error,
        error,
        fatal: true
      });
    }
    return null;
  }
  _handleTransmuxerFlush(chunkMeta) {
    const context = this.getCurrentContext(chunkMeta);
    if (!context || this.state !== State.PARSING) {
      if (!this.fragCurrent && this.state !== State.STOPPED && this.state !== State.ERROR) {
        this.state = State.IDLE;
      }
      return;
    }
    const {
      frag,
      part,
      level
    } = context;
    const now = self.performance.now();
    frag.stats.parsing.end = now;
    if (part) {
      part.stats.parsing.end = now;
    }
    this.updateLevelTiming(frag, part, level, chunkMeta.partial);
  }
  getCurrentContext(chunkMeta) {
    const {
      levels,
      fragCurrent
    } = this;
    const {
      level: levelIndex,
      sn,
      part: partIndex
    } = chunkMeta;
    if (!(levels != null && levels[levelIndex])) {
      this.warn(`Levels object was unset while buffering fragment ${sn} of level ${levelIndex}. The current chunk will not be buffered.`);
      return null;
    }
    const level = levels[levelIndex];
    const part = partIndex > -1 ? getPartWith(level, sn, partIndex) : null;
    const frag = part ? part.fragment : getFragmentWithSN(level, sn, fragCurrent);
    if (!frag) {
      return null;
    }
    if (fragCurrent && fragCurrent !== frag) {
      frag.stats = fragCurrent.stats;
    }
    return {
      frag,
      part,
      level
    };
  }
  bufferFragmentData(data, frag, part, chunkMeta, noBacktracking) {
    var _buffer;
    if (!data || this.state !== State.PARSING) {
      return;
    }
    const {
      data1,
      data2
    } = data;
    let buffer = data1;
    if (data1 && data2) {
      // Combine the moof + mdat so that we buffer with a single append
      buffer = appendUint8Array(data1, data2);
    }
    if (!((_buffer = buffer) != null && _buffer.length)) {
      return;
    }
    const segment = {
      type: data.type,
      frag,
      part,
      chunkMeta,
      parent: frag.type,
      data: buffer
    };
    this.hls.trigger(Events.BUFFER_APPENDING, segment);
    if (data.dropped && data.independent && !part) {
      if (noBacktracking) {
        return;
      }
      // Clear buffer so that we reload previous segments sequentially if required
      this.flushBufferGap(frag);
    }
  }
  flushBufferGap(frag) {
    const media = this.media;
    if (!media) {
      return;
    }
    // If currentTime is not buffered, clear the back buffer so that we can backtrack as much as needed
    if (!BufferHelper.isBuffered(media, media.currentTime)) {
      this.flushMainBuffer(0, frag.start);
      return;
    }
    // Remove back-buffer without interrupting playback to allow back tracking
    const currentTime = media.currentTime;
    const bufferInfo = BufferHelper.bufferInfo(media, currentTime, 0);
    const fragDuration = frag.duration;
    const segmentFraction = Math.min(this.config.maxFragLookUpTolerance * 2, fragDuration * 0.25);
    const start = Math.max(Math.min(frag.start - segmentFraction, bufferInfo.end - segmentFraction), currentTime + segmentFraction);
    if (frag.start - start > segmentFraction) {
      this.flushMainBuffer(start, frag.start);
    }
  }
  getFwdBufferInfo(bufferable, type) {
    const pos = this.getLoadPosition();
    if (!isFiniteNumber(pos)) {
      return null;
    }
    return this.getFwdBufferInfoAtPos(bufferable, pos, type);
  }
  getFwdBufferInfoAtPos(bufferable, pos, type) {
    const {
      config: {
        maxBufferHole
      }
    } = this;
    const bufferInfo = BufferHelper.bufferInfo(bufferable, pos, maxBufferHole);
    // Workaround flaw in getting forward buffer when maxBufferHole is smaller than gap at current pos
    if (bufferInfo.len === 0 && bufferInfo.nextStart !== undefined) {
      const bufferedFragAtPos = this.fragmentTracker.getBufferedFrag(pos, type);
      if (bufferedFragAtPos && bufferInfo.nextStart < bufferedFragAtPos.end) {
        return BufferHelper.bufferInfo(bufferable, pos, Math.max(bufferInfo.nextStart, maxBufferHole));
      }
    }
    return bufferInfo;
  }
  getMaxBufferLength(levelBitrate) {
    const {
      config
    } = this;
    let maxBufLen;
    if (levelBitrate) {
      maxBufLen = Math.max(8 * config.maxBufferSize / levelBitrate, config.maxBufferLength);
    } else {
      maxBufLen = config.maxBufferLength;
    }
    return Math.min(maxBufLen, config.maxMaxBufferLength);
  }
  reduceMaxBufferLength(threshold, fragDuration) {
    const config = this.config;
    const minLength = Math.max(Math.min(threshold - fragDuration, config.maxBufferLength), fragDuration);
    const reducedLength = Math.max(threshold - fragDuration * 3, config.maxMaxBufferLength / 2, minLength);
    if (reducedLength >= minLength) {
      // reduce max buffer length as it might be too high. we do this to avoid loop flushing ...
      config.maxMaxBufferLength = reducedLength;
      this.warn(`Reduce max buffer length to ${reducedLength}s`);
      return true;
    }
    return false;
  }
  getAppendedFrag(position, playlistType = PlaylistLevelType.MAIN) {
    const fragOrPart = this.fragmentTracker.getAppendedFrag(position, PlaylistLevelType.MAIN);
    if (fragOrPart && 'fragment' in fragOrPart) {
      return fragOrPart.fragment;
    }
    return fragOrPart;
  }
  getNextFragment(pos, levelDetails) {
    const fragments = levelDetails.fragments;
    const fragLen = fragments.length;
    if (!fragLen) {
      return null;
    }

    // find fragment index, contiguous with end of buffer position
    const {
      config
    } = this;
    const start = fragments[0].start;
    let frag;
    if (levelDetails.live) {
      const initialLiveManifestSize = config.initialLiveManifestSize;
      if (fragLen < initialLiveManifestSize) {
        this.warn(`Not enough fragments to start playback (have: ${fragLen}, need: ${initialLiveManifestSize})`);
        return null;
      }
      // The real fragment start times for a live stream are only known after the PTS range for that level is known.
      // In order to discover the range, we load the best matching fragment for that level and demux it.
      // Do not load using live logic if the starting frag is requested - we want to use getFragmentAtPosition() so that
      // we get the fragment matching that start time
      if (!levelDetails.PTSKnown && !this.startFragRequested && this.startPosition === -1 || pos < start) {
        frag = this.getInitialLiveFragment(levelDetails, fragments);
        this.startPosition = this.nextLoadPosition = frag ? this.hls.liveSyncPosition || frag.start : pos;
      }
    } else if (pos <= start) {
      // VoD playlist: if loadPosition before start of playlist, load first fragment
      frag = fragments[0];
    }

    // If we haven't run into any special cases already, just load the fragment most closely matching the requested position
    if (!frag) {
      const end = config.lowLatencyMode ? levelDetails.partEnd : levelDetails.fragmentEnd;
      frag = this.getFragmentAtPosition(pos, end, levelDetails);
    }
    return this.mapToInitFragWhenRequired(frag);
  }
  isLoopLoading(frag, targetBufferTime) {
    const trackerState = this.fragmentTracker.getState(frag);
    return (trackerState === FragmentState.OK || trackerState === FragmentState.PARTIAL && !!frag.gap) && this.nextLoadPosition > targetBufferTime;
  }
  getNextFragmentLoopLoading(frag, levelDetails, bufferInfo, playlistType, maxBufLen) {
    const gapStart = frag.gap;
    const nextFragment = this.getNextFragment(this.nextLoadPosition, levelDetails);
    if (nextFragment === null) {
      return nextFragment;
    }
    frag = nextFragment;
    if (gapStart && frag && !frag.gap && bufferInfo.nextStart) {
      // Media buffered after GAP tags should not make the next buffer timerange exceed forward buffer length
      const nextbufferInfo = this.getFwdBufferInfoAtPos(this.mediaBuffer ? this.mediaBuffer : this.media, bufferInfo.nextStart, playlistType);
      if (nextbufferInfo !== null && bufferInfo.len + nextbufferInfo.len >= maxBufLen) {
        // Returning here might result in not finding an audio and video candiate to skip to
        this.log(`buffer full after gaps in "${playlistType}" playlist starting at sn: ${frag.sn}`);
        return null;
      }
    }
    return frag;
  }
  mapToInitFragWhenRequired(frag) {
    // If an initSegment is present, it must be buffered first
    if (frag != null && frag.initSegment && !(frag != null && frag.initSegment.data) && !this.bitrateTest) {
      return frag.initSegment;
    }
    return frag;
  }
  getNextPart(partList, frag, targetBufferTime) {
    let nextPart = -1;
    let contiguous = false;
    let independentAttrOmitted = true;
    for (let i = 0, len = partList.length; i < len; i++) {
      const part = partList[i];
      independentAttrOmitted = independentAttrOmitted && !part.independent;
      if (nextPart > -1 && targetBufferTime < part.start) {
        break;
      }
      const loaded = part.loaded;
      if (loaded) {
        nextPart = -1;
      } else if ((contiguous || part.independent || independentAttrOmitted) && part.fragment === frag) {
        nextPart = i;
      }
      contiguous = loaded;
    }
    return nextPart;
  }
  loadedEndOfParts(partList, targetBufferTime) {
    const lastPart = partList[partList.length - 1];
    return lastPart && targetBufferTime > lastPart.start && lastPart.loaded;
  }

  /*
   This method is used find the best matching first fragment for a live playlist. This fragment is used to calculate the
   "sliding" of the playlist, which is its offset from the start of playback. After sliding we can compute the real
   start and end times for each fragment in the playlist (after which this method will not need to be called).
  */
  getInitialLiveFragment(levelDetails, fragments) {
    const fragPrevious = this.fragPrevious;
    let frag = null;
    if (fragPrevious) {
      if (levelDetails.hasProgramDateTime) {
        // Prefer using PDT, because it can be accurate enough to choose the correct fragment without knowing the level sliding
        this.log(`Live playlist, switching playlist, load frag with same PDT: ${fragPrevious.programDateTime}`);
        frag = findFragmentByPDT(fragments, fragPrevious.endProgramDateTime, this.config.maxFragLookUpTolerance);
      }
      if (!frag) {
        // SN does not need to be accurate between renditions, but depending on the packaging it may be so.
        const targetSN = fragPrevious.sn + 1;
        if (targetSN >= levelDetails.startSN && targetSN <= levelDetails.endSN) {
          const fragNext = fragments[targetSN - levelDetails.startSN];
          // Ensure that we're staying within the continuity range, since PTS resets upon a new range
          if (fragPrevious.cc === fragNext.cc) {
            frag = fragNext;
            this.log(`Live playlist, switching playlist, load frag with next SN: ${frag.sn}`);
          }
        }
        // It's important to stay within the continuity range if available; otherwise the fragments in the playlist
        // will have the wrong start times
        if (!frag) {
          frag = findFragWithCC(fragments, fragPrevious.cc);
          if (frag) {
            this.log(`Live playlist, switching playlist, load frag with same CC: ${frag.sn}`);
          }
        }
      }
    } else {
      // Find a new start fragment when fragPrevious is null
      const liveStart = this.hls.liveSyncPosition;
      if (liveStart !== null) {
        frag = this.getFragmentAtPosition(liveStart, this.bitrateTest ? levelDetails.fragmentEnd : levelDetails.edge, levelDetails);
      }
    }
    return frag;
  }

  /*
  This method finds the best matching fragment given the provided position.
   */
  getFragmentAtPosition(bufferEnd, end, levelDetails) {
    const {
      config
    } = this;
    let {
      fragPrevious
    } = this;
    let {
      fragments,
      endSN
    } = levelDetails;
    const {
      fragmentHint
    } = levelDetails;
    const {
      maxFragLookUpTolerance
    } = config;
    const partList = levelDetails.partList;
    const loadingParts = !!(config.lowLatencyMode && partList != null && partList.length && fragmentHint);
    if (loadingParts && fragmentHint && !this.bitrateTest) {
      // Include incomplete fragment with parts at end
      fragments = fragments.concat(fragmentHint);
      endSN = fragmentHint.sn;
    }
    let frag;
    if (bufferEnd < end) {
      const lookupTolerance = bufferEnd > end - maxFragLookUpTolerance ? 0 : maxFragLookUpTolerance;
      // Remove the tolerance if it would put the bufferEnd past the actual end of stream
      // Uses buffer and sequence number to calculate switch segment (required if using EXT-X-DISCONTINUITY-SEQUENCE)
      frag = findFragmentByPTS(fragPrevious, fragments, bufferEnd, lookupTolerance);
    } else {
      // reach end of playlist
      frag = fragments[fragments.length - 1];
    }
    if (frag) {
      const curSNIdx = frag.sn - levelDetails.startSN;
      // Move fragPrevious forward to support forcing the next fragment to load
      // when the buffer catches up to a previously buffered range.
      const fragState = this.fragmentTracker.getState(frag);
      if (fragState === FragmentState.OK || fragState === FragmentState.PARTIAL && frag.gap) {
        fragPrevious = frag;
      }
      if (fragPrevious && frag.sn === fragPrevious.sn && (!loadingParts || partList[0].fragment.sn > frag.sn)) {
        // Force the next fragment to load if the previous one was already selected. This can occasionally happen with
        // non-uniform fragment durations
        const sameLevel = fragPrevious && frag.level === fragPrevious.level;
        if (sameLevel) {
          const nextFrag = fragments[curSNIdx + 1];
          if (frag.sn < endSN && this.fragmentTracker.getState(nextFrag) !== FragmentState.OK) {
            frag = nextFrag;
          } else {
            frag = null;
          }
        }
      }
    }
    return frag;
  }
  synchronizeToLiveEdge(levelDetails) {
    const {
      config,
      media
    } = this;
    if (!media) {
      return;
    }
    const liveSyncPosition = this.hls.liveSyncPosition;
    const currentTime = media.currentTime;
    const start = levelDetails.fragments[0].start;
    const end = levelDetails.edge;
    const withinSlidingWindow = currentTime >= start - config.maxFragLookUpTolerance && currentTime <= end;
    // Continue if we can seek forward to sync position or if current time is outside of sliding window
    if (liveSyncPosition !== null && media.duration > liveSyncPosition && (currentTime < liveSyncPosition || !withinSlidingWindow)) {
      // Continue if buffer is starving or if current time is behind max latency
      const maxLatency = config.liveMaxLatencyDuration !== undefined ? config.liveMaxLatencyDuration : config.liveMaxLatencyDurationCount * levelDetails.targetduration;
      if (!withinSlidingWindow && media.readyState < 4 || currentTime < end - maxLatency) {
        if (!this.loadedmetadata) {
          this.nextLoadPosition = liveSyncPosition;
        }
        // Only seek if ready and there is not a significant forward buffer available for playback
        if (media.readyState) {
          this.warn(`Playback: ${currentTime.toFixed(3)} is located too far from the end of live sliding playlist: ${end}, reset currentTime to : ${liveSyncPosition.toFixed(3)}`);
          media.currentTime = liveSyncPosition;
        }
      }
    }
  }
  alignPlaylists(details, previousDetails, switchDetails) {
    // FIXME: If not for `shouldAlignOnDiscontinuities` requiring fragPrevious.cc,
    //  this could all go in level-helper mergeDetails()
    const length = details.fragments.length;
    if (!length) {
      this.warn(`No fragments in live playlist`);
      return 0;
    }
    const slidingStart = details.fragments[0].start;
    const firstLevelLoad = !previousDetails;
    const aligned = details.alignedSliding && isFiniteNumber(slidingStart);
    if (firstLevelLoad || !aligned && !slidingStart) {
      const {
        fragPrevious
      } = this;
      alignStream(fragPrevious, switchDetails, details);
      const alignedSlidingStart = details.fragments[0].start;
      this.log(`Live playlist sliding: ${alignedSlidingStart.toFixed(2)} start-sn: ${previousDetails ? previousDetails.startSN : 'na'}->${details.startSN} prev-sn: ${fragPrevious ? fragPrevious.sn : 'na'} fragments: ${length}`);
      return alignedSlidingStart;
    }
    return slidingStart;
  }
  waitForCdnTuneIn(details) {
    // Wait for Low-Latency CDN Tune-in to get an updated playlist
    const advancePartLimit = 3;
    return details.live && details.canBlockReload && details.partTarget && details.tuneInGoal > Math.max(details.partHoldBack, details.partTarget * advancePartLimit);
  }
  setStartPosition(details, sliding) {
    // compute start position if set to -1. use it straight away if value is defined
    let startPosition = this.startPosition;
    if (startPosition < sliding) {
      startPosition = -1;
    }
    if (startPosition === -1 || this.lastCurrentTime === -1) {
      // Use Playlist EXT-X-START:TIME-OFFSET when set
      // Prioritize Multivariant Playlist offset so that main, audio, and subtitle stream-controller start times match
      const offsetInMultivariantPlaylist = this.startTimeOffset !== null;
      const startTimeOffset = offsetInMultivariantPlaylist ? this.startTimeOffset : details.startTimeOffset;
      if (startTimeOffset !== null && isFiniteNumber(startTimeOffset)) {
        startPosition = sliding + startTimeOffset;
        if (startTimeOffset < 0) {
          startPosition += details.totalduration;
        }
        startPosition = Math.min(Math.max(sliding, startPosition), sliding + details.totalduration);
        this.log(`Start time offset ${startTimeOffset} found in ${offsetInMultivariantPlaylist ? 'multivariant' : 'media'} playlist, adjust startPosition to ${startPosition}`);
        this.startPosition = startPosition;
      } else if (details.live) {
        // Leave this.startPosition at -1, so that we can use `getInitialLiveFragment` logic when startPosition has
        // not been specified via the config or an as an argument to startLoad (#3736).
        startPosition = this.hls.liveSyncPosition || sliding;
      } else {
        this.startPosition = startPosition = 0;
      }
      this.lastCurrentTime = startPosition;
    }
    this.nextLoadPosition = startPosition;
  }
  getLoadPosition() {
    const {
      media
    } = this;
    // if we have not yet loaded any fragment, start loading from start position
    let pos = 0;
    if (this.loadedmetadata && media) {
      pos = media.currentTime;
    } else if (this.nextLoadPosition) {
      pos = this.nextLoadPosition;
    }
    return pos;
  }
  handleFragLoadAborted(frag, part) {
    if (this.transmuxer && frag.sn !== 'initSegment' && frag.stats.aborted) {
      this.warn(`Fragment ${frag.sn}${part ? ' part ' + part.index : ''} of level ${frag.level} was aborted`);
      this.resetFragmentLoading(frag);
    }
  }
  resetFragmentLoading(frag) {
    if (!this.fragCurrent || !this.fragContextChanged(frag) && this.state !== State.FRAG_LOADING_WAITING_RETRY) {
      this.state = State.IDLE;
    }
  }
  onFragmentOrKeyLoadError(filterType, data) {
    if (data.chunkMeta && !data.frag) {
      const context = this.getCurrentContext(data.chunkMeta);
      if (context) {
        data.frag = context.frag;
      }
    }
    const frag = data.frag;
    // Handle frag error related to caller's filterType
    if (!frag || frag.type !== filterType || !this.levels) {
      return;
    }
    if (this.fragContextChanged(frag)) {
      var _this$fragCurrent2;
      this.warn(`Frag load error must match current frag to retry ${frag.url} > ${(_this$fragCurrent2 = this.fragCurrent) == null ? void 0 : _this$fragCurrent2.url}`);
      return;
    }
    const gapTagEncountered = data.details === ErrorDetails.FRAG_GAP;
    if (gapTagEncountered) {
      this.fragmentTracker.fragBuffered(frag, true);
    }
    // keep retrying until the limit will be reached
    const errorAction = data.errorAction;
    const {
      action,
      retryCount = 0,
      retryConfig
    } = errorAction || {};
    if (errorAction && action === NetworkErrorAction.RetryRequest && retryConfig) {
      this.resetStartWhenNotLoaded(this.levelLastLoaded);
      const delay = getRetryDelay(retryConfig, retryCount);
      this.warn(`Fragment ${frag.sn} of ${filterType} ${frag.level} errored with ${data.details}, retrying loading ${retryCount + 1}/${retryConfig.maxNumRetry} in ${delay}ms`);
      errorAction.resolved = true;
      this.retryDate = self.performance.now() + delay;
      this.state = State.FRAG_LOADING_WAITING_RETRY;
    } else if (retryConfig && errorAction) {
      this.resetFragmentErrors(filterType);
      if (retryCount < retryConfig.maxNumRetry) {
        // Network retry is skipped when level switch is preferred
        if (!gapTagEncountered && action !== NetworkErrorAction.RemoveAlternatePermanently) {
          errorAction.resolved = true;
        }
      } else {
        logger.warn(`${data.details} reached or exceeded max retry (${retryCount})`);
        return;
      }
    } else if ((errorAction == null ? void 0 : errorAction.action) === NetworkErrorAction.SendAlternateToPenaltyBox) {
      this.state = State.WAITING_LEVEL;
    } else {
      this.state = State.ERROR;
    }
    // Perform next async tick sooner to speed up error action resolution
    this.tickImmediate();
  }
  reduceLengthAndFlushBuffer(data) {
    // if in appending state
    if (this.state === State.PARSING || this.state === State.PARSED) {
      const frag = data.frag;
      const playlistType = data.parent;
      const bufferedInfo = this.getFwdBufferInfo(this.mediaBuffer, playlistType);
      // 0.5 : tolerance needed as some browsers stalls playback before reaching buffered end
      // reduce max buf len if current position is buffered
      const buffered = bufferedInfo && bufferedInfo.len > 0.5;
      if (buffered) {
        this.reduceMaxBufferLength(bufferedInfo.len, (frag == null ? void 0 : frag.duration) || 10);
      }
      const flushBuffer = !buffered;
      if (flushBuffer) {
        // current position is not buffered, but browser is still complaining about buffer full error
        // this happens on IE/Edge, refer to https://github.com/video-dev/hls.js/pull/708
        // in that case flush the whole audio buffer to recover
        this.warn(`Buffer full error while media.currentTime is not buffered, flush ${playlistType} buffer`);
      }
      if (frag) {
        this.fragmentTracker.removeFragment(frag);
        this.nextLoadPosition = frag.start;
      }
      this.resetLoadingState();
      return flushBuffer;
    }
    return false;
  }
  resetFragmentErrors(filterType) {
    if (filterType === PlaylistLevelType.AUDIO) {
      // Reset current fragment since audio track audio is essential and may not have a fail-over track
      this.fragCurrent = null;
    }
    // Fragment errors that result in a level switch or redundant fail-over
    // should reset the stream controller state to idle
    if (!this.loadedmetadata) {
      this.startFragRequested = false;
    }
    if (this.state !== State.STOPPED) {
      this.state = State.IDLE;
    }
  }
  afterBufferFlushed(media, bufferType, playlistType) {
    if (!media) {
      return;
    }
    // After successful buffer flushing, filter flushed fragments from bufferedFrags use mediaBuffered instead of media
    // (so that we will check against video.buffered ranges in case of alt audio track)
    const bufferedTimeRanges = BufferHelper.getBuffered(media);
    this.fragmentTracker.detectEvictedFragments(bufferType, bufferedTimeRanges, playlistType);
    if (this.state === State.ENDED) {
      this.resetLoadingState();
    }
  }
  resetLoadingState() {
    this.log('Reset loading state');
    this.fragCurrent = null;
    this.fragPrevious = null;
    this.state = State.IDLE;
  }
  resetStartWhenNotLoaded(level) {
    // if loadedmetadata is not set, it means that first frag request failed
    // in that case, reset startFragRequested flag
    if (!this.loadedmetadata) {
      this.startFragRequested = false;
      const details = level ? level.details : null;
      if (details != null && details.live) {
        // Update the start position and return to IDLE to recover live start
        this.startPosition = -1;
        this.setStartPosition(details, 0);
        this.resetLoadingState();
      } else {
        this.nextLoadPosition = this.startPosition;
      }
    }
  }
  resetWhenMissingContext(chunkMeta) {
    this.warn(`The loading context changed while buffering fragment ${chunkMeta.sn} of level ${chunkMeta.level}. This chunk will not be buffered.`);
    this.removeUnbufferedFrags();
    this.resetStartWhenNotLoaded(this.levelLastLoaded);
    this.resetLoadingState();
  }
  removeUnbufferedFrags(start = 0) {
    this.fragmentTracker.removeFragmentsInRange(start, Infinity, this.playlistType, false, true);
  }
  updateLevelTiming(frag, part, level, partial) {
    var _this$transmuxer;
    const details = level.details;
    if (!details) {
      this.warn('level.details undefined');
      return;
    }
    const parsed = Object.keys(frag.elementaryStreams).reduce((result, type) => {
      const info = frag.elementaryStreams[type];
      if (info) {
        const parsedDuration = info.endPTS - info.startPTS;
        if (parsedDuration <= 0) {
          // Destroy the transmuxer after it's next time offset failed to advance because duration was <= 0.
          // The new transmuxer will be configured with a time offset matching the next fragment start,
          // preventing the timeline from shifting.
          this.warn(`Could not parse fragment ${frag.sn} ${type} duration reliably (${parsedDuration})`);
          return result || false;
        }
        const drift = partial ? 0 : updateFragPTSDTS(details, frag, info.startPTS, info.endPTS, info.startDTS, info.endDTS);
        this.hls.trigger(Events.LEVEL_PTS_UPDATED, {
          details,
          level,
          drift,
          type,
          frag,
          start: info.startPTS,
          end: info.endPTS
        });
        return true;
      }
      return result;
    }, false);
    if (!parsed && ((_this$transmuxer = this.transmuxer) == null ? void 0 : _this$transmuxer.error) === null) {
      const error = new Error(`Found no media in fragment ${frag.sn} of level ${frag.level} resetting transmuxer to fallback to playlist timing`);
      if (level.fragmentError === 0) {
        // Mark and track the odd empty segment as a gap to avoid reloading
        level.fragmentError++;
        frag.gap = true;
        this.fragmentTracker.removeFragment(frag);
        this.fragmentTracker.fragBuffered(frag, true);
      }
      this.warn(error.message);
      this.hls.trigger(Events.ERROR, {
        type: ErrorTypes.MEDIA_ERROR,
        details: ErrorDetails.FRAG_PARSING_ERROR,
        fatal: false,
        error,
        frag,
        reason: `Found no media in msn ${frag.sn} of level "${level.url}"`
      });
      if (!this.hls) {
        return;
      }
      this.resetTransmuxer();
      // For this error fallthrough. Marking parsed will allow advancing to next fragment.
    }
    this.state = State.PARSED;
    this.hls.trigger(Events.FRAG_PARSED, {
      frag,
      part
    });
  }
  resetTransmuxer() {
    if (this.transmuxer) {
      this.transmuxer.destroy();
      this.transmuxer = null;
    }
  }
  recoverWorkerError(data) {
    if (data.event === 'demuxerWorker') {
      this.fragmentTracker.removeAllFragments();
      this.resetTransmuxer();
      this.resetStartWhenNotLoaded(this.levelLastLoaded);
      this.resetLoadingState();
    }
  }
  set state(nextState) {
    const previousState = this._state;
    if (previousState !== nextState) {
      this._state = nextState;
      this.log(`${previousState}->${nextState}`);
    }
  }
  get state() {
    return this._state;
  }
}

class ChunkCache {
  constructor() {
    this.chunks = [];
    this.dataLength = 0;
  }
  push(chunk) {
    this.chunks.push(chunk);
    this.dataLength += chunk.length;
  }
  flush() {
    const {
      chunks,
      dataLength
    } = this;
    let result;
    if (!chunks.length) {
      return new Uint8Array(0);
    } else if (chunks.length === 1) {
      result = chunks[0];
    } else {
      result = concatUint8Arrays(chunks, dataLength);
    }
    this.reset();
    return result;
  }
  reset() {
    this.chunks.length = 0;
    this.dataLength = 0;
  }
}
function concatUint8Arrays(chunks, dataLength) {
  const result = new Uint8Array(dataLength);
  let offset = 0;
  for (let i = 0; i < chunks.length; i++) {
    const chunk = chunks[i];
    result.set(chunk, offset);
    offset += chunk.length;
  }
  return result;
}

// ensure the worker ends up in the bundle
// If the worker should not be included this gets aliased to empty.js
function hasUMDWorker() {
  return typeof __HLS_WORKER_BUNDLE__ === 'function';
}
function injectWorker() {
  const blob = new self.Blob([`var exports={};var module={exports:exports};function define(f){f()};define.amd=true;(${__HLS_WORKER_BUNDLE__.toString()})(true);`], {
    type: 'text/javascript'
  });
  const objectURL = self.URL.createObjectURL(blob);
  const worker = new self.Worker(objectURL);
  return {
    worker,
    objectURL
  };
}
function loadWorker(path) {
  const scriptURL = new self.URL(path, self.location.href).href;
  const worker = new self.Worker(scriptURL);
  return {
    worker,
    scriptURL
  };
}

function dummyTrack(type = '', inputTimeScale = 90000) {
  return {
    type,
    id: -1,
    pid: -1,
    inputTimeScale,
    sequenceNumber: -1,
    samples: [],
    dropped: 0
  };
}

class BaseAudioDemuxer {
  constructor() {
    this._audioTrack = void 0;
    this._id3Track = void 0;
    this.frameIndex = 0;
    this.cachedData = null;
    this.basePTS = null;
    this.initPTS = null;
    this.lastPTS = null;
  }
  resetInitSegment(initSegment, audioCodec, videoCodec, trackDuration) {
    this._id3Track = {
      type: 'id3',
      id: 3,
      pid: -1,
      inputTimeScale: 90000,
      sequenceNumber: 0,
      samples: [],
      dropped: 0
    };
  }
  resetTimeStamp(deaultTimestamp) {
    this.initPTS = deaultTimestamp;
    this.resetContiguity();
  }
  resetContiguity() {
    this.basePTS = null;
    this.lastPTS = null;
    this.frameIndex = 0;
  }
  canParse(data, offset) {
    return false;
  }
  appendFrame(track, data, offset) {}

  // feed incoming data to the front of the parsing pipeline
  demux(data, timeOffset) {
    if (this.cachedData) {
      data = appendUint8Array(this.cachedData, data);
      this.cachedData = null;
    }
    let id3Data = getID3Data(data, 0);
    let offset = id3Data ? id3Data.length : 0;
    let lastDataIndex;
    const track = this._audioTrack;
    const id3Track = this._id3Track;
    const timestamp = id3Data ? getTimeStamp(id3Data) : undefined;
    const length = data.length;
    if (this.basePTS === null || this.frameIndex === 0 && isFiniteNumber(timestamp)) {
      this.basePTS = initPTSFn(timestamp, timeOffset, this.initPTS);
      this.lastPTS = this.basePTS;
    }
    if (this.lastPTS === null) {
      this.lastPTS = this.basePTS;
    }

    // more expressive than alternative: id3Data?.length
    if (id3Data && id3Data.length > 0) {
      id3Track.samples.push({
        pts: this.lastPTS,
        dts: this.lastPTS,
        data: id3Data,
        type: MetadataSchema.audioId3,
        duration: Number.POSITIVE_INFINITY
      });
    }
    while (offset < length) {
      if (this.canParse(data, offset)) {
        const frame = this.appendFrame(track, data, offset);
        if (frame) {
          this.frameIndex++;
          this.lastPTS = frame.sample.pts;
          offset += frame.length;
          lastDataIndex = offset;
        } else {
          offset = length;
        }
      } else if (canParse$2(data, offset)) {
        // after a ID3.canParse, a call to ID3.getID3Data *should* always returns some data
        id3Data = getID3Data(data, offset);
        id3Track.samples.push({
          pts: this.lastPTS,
          dts: this.lastPTS,
          data: id3Data,
          type: MetadataSchema.audioId3,
          duration: Number.POSITIVE_INFINITY
        });
        offset += id3Data.length;
        lastDataIndex = offset;
      } else {
        offset++;
      }
      if (offset === length && lastDataIndex !== length) {
        const partialData = sliceUint8(data, lastDataIndex);
        if (this.cachedData) {
          this.cachedData = appendUint8Array(this.cachedData, partialData);
        } else {
          this.cachedData = partialData;
        }
      }
    }
    return {
      audioTrack: track,
      videoTrack: dummyTrack(),
      id3Track,
      textTrack: dummyTrack()
    };
  }
  demuxSampleAes(data, keyData, timeOffset) {
    return Promise.reject(new Error(`[${this}] This demuxer does not support Sample-AES decryption`));
  }
  flush(timeOffset) {
    // Parse cache in case of remaining frames.
    const cachedData = this.cachedData;
    if (cachedData) {
      this.cachedData = null;
      this.demux(cachedData, 0);
    }
    return {
      audioTrack: this._audioTrack,
      videoTrack: dummyTrack(),
      id3Track: this._id3Track,
      textTrack: dummyTrack()
    };
  }
  destroy() {}
}

/**
 * Initialize PTS
 * <p>
 *    use timestamp unless it is undefined, NaN or Infinity
 * </p>
 */
const initPTSFn = (timestamp, timeOffset, initPTS) => {
  if (isFiniteNumber(timestamp)) {
    return timestamp * 90;
  }
  const init90kHz = initPTS ? initPTS.baseTime * 90000 / initPTS.timescale : 0;
  return timeOffset * 90000 + init90kHz;
};

/**
 * ADTS parser helper
 * @link https://wiki.multimedia.cx/index.php?title=ADTS
 */
function getAudioConfig(observer, data, offset, audioCodec) {
  let adtsObjectType;
  let adtsExtensionSamplingIndex;
  let adtsChannelConfig;
  let config;
  const userAgent = navigator.userAgent.toLowerCase();
  const manifestCodec = audioCodec;
  const adtsSamplingRates = [96000, 88200, 64000, 48000, 44100, 32000, 24000, 22050, 16000, 12000, 11025, 8000, 7350];
  // byte 2
  adtsObjectType = ((data[offset + 2] & 0xc0) >>> 6) + 1;
  const adtsSamplingIndex = (data[offset + 2] & 0x3c) >>> 2;
  if (adtsSamplingIndex > adtsSamplingRates.length - 1) {
    const error = new Error(`invalid ADTS sampling index:${adtsSamplingIndex}`);
    observer.emit(Events.ERROR, Events.ERROR, {
      type: ErrorTypes.MEDIA_ERROR,
      details: ErrorDetails.FRAG_PARSING_ERROR,
      fatal: true,
      error,
      reason: error.message
    });
    return;
  }
  adtsChannelConfig = (data[offset + 2] & 0x01) << 2;
  // byte 3
  adtsChannelConfig |= (data[offset + 3] & 0xc0) >>> 6;
  logger.log(`manifest codec:${audioCodec}, ADTS type:${adtsObjectType}, samplingIndex:${adtsSamplingIndex}`);
  // firefox: freq less than 24kHz = AAC SBR (HE-AAC)
  if (/firefox/i.test(userAgent)) {
    if (adtsSamplingIndex >= 6) {
      adtsObjectType = 5;
      config = new Array(4);
      // HE-AAC uses SBR (Spectral Band Replication) , high frequencies are constructed from low frequencies
      // there is a factor 2 between frame sample rate and output sample rate
      // multiply frequency by 2 (see table below, equivalent to substract 3)
      adtsExtensionSamplingIndex = adtsSamplingIndex - 3;
    } else {
      adtsObjectType = 2;
      config = new Array(2);
      adtsExtensionSamplingIndex = adtsSamplingIndex;
    }
    // Android : always use AAC
  } else if (userAgent.indexOf('android') !== -1) {
    adtsObjectType = 2;
    config = new Array(2);
    adtsExtensionSamplingIndex = adtsSamplingIndex;
  } else {
    /*  for other browsers (Chrome/Vivaldi/Opera ...)
        always force audio type to be HE-AAC SBR, as some browsers do not support audio codec switch properly (like Chrome ...)
    */
    adtsObjectType = 5;
    config = new Array(4);
    // if (manifest codec is HE-AAC or HE-AACv2) OR (manifest codec not specified AND frequency less than 24kHz)
    if (audioCodec && (audioCodec.indexOf('mp4a.40.29') !== -1 || audioCodec.indexOf('mp4a.40.5') !== -1) || !audioCodec && adtsSamplingIndex >= 6) {
      // HE-AAC uses SBR (Spectral Band Replication) , high frequencies are constructed from low frequencies
      // there is a factor 2 between frame sample rate and output sample rate
      // multiply frequency by 2 (see table below, equivalent to substract 3)
      adtsExtensionSamplingIndex = adtsSamplingIndex - 3;
    } else {
      // if (manifest codec is AAC) AND (frequency less than 24kHz AND nb channel is 1) OR (manifest codec not specified and mono audio)
      // Chrome fails to play back with low frequency AAC LC mono when initialized with HE-AAC.  This is not a problem with stereo.
      if (audioCodec && audioCodec.indexOf('mp4a.40.2') !== -1 && (adtsSamplingIndex >= 6 && adtsChannelConfig === 1 || /vivaldi/i.test(userAgent)) || !audioCodec && adtsChannelConfig === 1) {
        adtsObjectType = 2;
        config = new Array(2);
      }
      adtsExtensionSamplingIndex = adtsSamplingIndex;
    }
  }
  /* refer to http://wiki.multimedia.cx/index.php?title=MPEG-4_Audio#Audio_Specific_Config
      ISO 14496-3 (AAC).pdf - Table 1.13 — Syntax of AudioSpecificConfig()
    Audio Profile / Audio Object Type
    0: Null
    1: AAC Main
    2: AAC LC (Low Complexity)
    3: AAC SSR (Scalable Sample Rate)
    4: AAC LTP (Long Term Prediction)
    5: SBR (Spectral Band Replication)
    6: AAC Scalable
   sampling freq
    0: 96000 Hz
    1: 88200 Hz
    2: 64000 Hz
    3: 48000 Hz
    4: 44100 Hz
    5: 32000 Hz
    6: 24000 Hz
    7: 22050 Hz
    8: 16000 Hz
    9: 12000 Hz
    10: 11025 Hz
    11: 8000 Hz
    12: 7350 Hz
    13: Reserved
    14: Reserved
    15: frequency is written explictly
    Channel Configurations
    These are the channel configurations:
    0: Defined in AOT Specifc Config
    1: 1 channel: front-center
    2: 2 channels: front-left, front-right
  */
  // audioObjectType = profile => profile, the MPEG-4 Audio Object Type minus 1
  config[0] = adtsObjectType << 3;
  // samplingFrequencyIndex
  config[0] |= (adtsSamplingIndex & 0x0e) >> 1;
  config[1] |= (adtsSamplingIndex & 0x01) << 7;
  // channelConfiguration
  config[1] |= adtsChannelConfig << 3;
  if (adtsObjectType === 5) {
    // adtsExtensionSamplingIndex
    config[1] |= (adtsExtensionSamplingIndex & 0x0e) >> 1;
    config[2] = (adtsExtensionSamplingIndex & 0x01) << 7;
    // adtsObjectType (force to 2, chrome is checking that object type is less than 5 ???
    //    https://chromium.googlesource.com/chromium/src.git/+/master/media/formats/mp4/aac.cc
    config[2] |= 2 << 2;
    config[3] = 0;
  }
  return {
    config,
    samplerate: adtsSamplingRates[adtsSamplingIndex],
    channelCount: adtsChannelConfig,
    codec: 'mp4a.40.' + adtsObjectType,
    manifestCodec
  };
}
function isHeaderPattern$1(data, offset) {
  return data[offset] === 0xff && (data[offset + 1] & 0xf6) === 0xf0;
}
function getHeaderLength(data, offset) {
  return data[offset + 1] & 0x01 ? 7 : 9;
}
function getFullFrameLength(data, offset) {
  return (data[offset + 3] & 0x03) << 11 | data[offset + 4] << 3 | (data[offset + 5] & 0xe0) >>> 5;
}
function canGetFrameLength(data, offset) {
  return offset + 5 < data.length;
}
function isHeader$1(data, offset) {
  // Look for ADTS header | 1111 1111 | 1111 X00X | where X can be either 0 or 1
  // Layer bits (position 14 and 15) in header should be always 0 for ADTS
  // More info https://wiki.multimedia.cx/index.php?title=ADTS
  return offset + 1 < data.length && isHeaderPattern$1(data, offset);
}
function canParse$1(data, offset) {
  return canGetFrameLength(data, offset) && isHeaderPattern$1(data, offset) && getFullFrameLength(data, offset) <= data.length - offset;
}
function probe$1(data, offset) {
  // same as isHeader but we also check that ADTS frame follows last ADTS frame
  // or end of data is reached
  if (isHeader$1(data, offset)) {
    // ADTS header Length
    const headerLength = getHeaderLength(data, offset);
    if (offset + headerLength >= data.length) {
      return false;
    }
    // ADTS frame Length
    const frameLength = getFullFrameLength(data, offset);
    if (frameLength <= headerLength) {
      return false;
    }
    const newOffset = offset + frameLength;
    return newOffset === data.length || isHeader$1(data, newOffset);
  }
  return false;
}
function initTrackConfig(track, observer, data, offset, audioCodec) {
  if (!track.samplerate) {
    const config = getAudioConfig(observer, data, offset, audioCodec);
    if (!config) {
      return;
    }
    track.config = config.config;
    track.samplerate = config.samplerate;
    track.channelCount = config.channelCount;
    track.codec = config.codec;
    track.manifestCodec = config.manifestCodec;
    logger.log(`parsed codec:${track.codec}, rate:${config.samplerate}, channels:${config.channelCount}`);
  }
}
function getFrameDuration(samplerate) {
  return 1024 * 90000 / samplerate;
}
function parseFrameHeader(data, offset) {
  // The protection skip bit tells us if we have 2 bytes of CRC data at the end of the ADTS header
  const headerLength = getHeaderLength(data, offset);
  if (offset + headerLength <= data.length) {
    // retrieve frame size
    const frameLength = getFullFrameLength(data, offset) - headerLength;
    if (frameLength > 0) {
      // logger.log(`AAC frame, offset/length/total/pts:${offset+headerLength}/${frameLength}/${data.byteLength}`);
      return {
        headerLength,
        frameLength
      };
    }
  }
}
function appendFrame$2(track, data, offset, pts, frameIndex) {
  const frameDuration = getFrameDuration(track.samplerate);
  const stamp = pts + frameIndex * frameDuration;
  const header = parseFrameHeader(data, offset);
  let unit;
  if (header) {
    const {
      frameLength,
      headerLength
    } = header;
    const _length = headerLength + frameLength;
    const missing = Math.max(0, offset + _length - data.length);
    // logger.log(`AAC frame ${frameIndex}, pts:${stamp} length@offset/total: ${frameLength}@${offset+headerLength}/${data.byteLength} missing: ${missing}`);
    if (missing) {
      unit = new Uint8Array(_length - headerLength);
      unit.set(data.subarray(offset + headerLength, data.length), 0);
    } else {
      unit = data.subarray(offset + headerLength, offset + _length);
    }
    const _sample = {
      unit,
      pts: stamp
    };
    if (!missing) {
      track.samples.push(_sample);
    }
    return {
      sample: _sample,
      length: _length,
      missing
    };
  }
  // overflow incomplete header
  const length = data.length - offset;
  unit = new Uint8Array(length);
  unit.set(data.subarray(offset, data.length), 0);
  const sample = {
    unit,
    pts: stamp
  };
  return {
    sample,
    length,
    missing: -1
  };
}

/**
 *  MPEG parser helper
 */

let chromeVersion$1 = null;
const BitratesMap = [32, 64, 96, 128, 160, 192, 224, 256, 288, 320, 352, 384, 416, 448, 32, 48, 56, 64, 80, 96, 112, 128, 160, 192, 224, 256, 320, 384, 32, 40, 48, 56, 64, 80, 96, 112, 128, 160, 192, 224, 256, 320, 32, 48, 56, 64, 80, 96, 112, 128, 144, 160, 176, 192, 224, 256, 8, 16, 24, 32, 40, 48, 56, 64, 80, 96, 112, 128, 144, 160];
const SamplingRateMap = [44100, 48000, 32000, 22050, 24000, 16000, 11025, 12000, 8000];
const SamplesCoefficients = [
// MPEG 2.5
[0,
// Reserved
72,
// Layer3
144,
// Layer2
12 // Layer1
],
// Reserved
[0,
// Reserved
0,
// Layer3
0,
// Layer2
0 // Layer1
],
// MPEG 2
[0,
// Reserved
72,
// Layer3
144,
// Layer2
12 // Layer1
],
// MPEG 1
[0,
// Reserved
144,
// Layer3
144,
// Layer2
12 // Layer1
]];
const BytesInSlot = [0,
// Reserved
1,
// Layer3
1,
// Layer2
4 // Layer1
];
function appendFrame$1(track, data, offset, pts, frameIndex) {
  // Using http://www.datavoyage.com/mpgscript/mpeghdr.htm as a reference
  if (offset + 24 > data.length) {
    return;
  }
  const header = parseHeader(data, offset);
  if (header && offset + header.frameLength <= data.length) {
    const frameDuration = header.samplesPerFrame * 90000 / header.sampleRate;
    const stamp = pts + frameIndex * frameDuration;
    const sample = {
      unit: data.subarray(offset, offset + header.frameLength),
      pts: stamp,
      dts: stamp
    };
    track.config = [];
    track.channelCount = header.channelCount;
    track.samplerate = header.sampleRate;
    track.samples.push(sample);
    return {
      sample,
      length: header.frameLength,
      missing: 0
    };
  }
}
function parseHeader(data, offset) {
  const mpegVersion = data[offset + 1] >> 3 & 3;
  const mpegLayer = data[offset + 1] >> 1 & 3;
  const bitRateIndex = data[offset + 2] >> 4 & 15;
  const sampleRateIndex = data[offset + 2] >> 2 & 3;
  if (mpegVersion !== 1 && bitRateIndex !== 0 && bitRateIndex !== 15 && sampleRateIndex !== 3) {
    const paddingBit = data[offset + 2] >> 1 & 1;
    const channelMode = data[offset + 3] >> 6;
    const columnInBitrates = mpegVersion === 3 ? 3 - mpegLayer : mpegLayer === 3 ? 3 : 4;
    const bitRate = BitratesMap[columnInBitrates * 14 + bitRateIndex - 1] * 1000;
    const columnInSampleRates = mpegVersion === 3 ? 0 : mpegVersion === 2 ? 1 : 2;
    const sampleRate = SamplingRateMap[columnInSampleRates * 3 + sampleRateIndex];
    const channelCount = channelMode === 3 ? 1 : 2; // If bits of channel mode are `11` then it is a single channel (Mono)
    const sampleCoefficient = SamplesCoefficients[mpegVersion][mpegLayer];
    const bytesInSlot = BytesInSlot[mpegLayer];
    const samplesPerFrame = sampleCoefficient * 8 * bytesInSlot;
    const frameLength = Math.floor(sampleCoefficient * bitRate / sampleRate + paddingBit) * bytesInSlot;
    if (chromeVersion$1 === null) {
      const userAgent = navigator.userAgent || '';
      const result = userAgent.match(/Chrome\/(\d+)/i);
      chromeVersion$1 = result ? parseInt(result[1]) : 0;
    }
    const needChromeFix = !!chromeVersion$1 && chromeVersion$1 <= 87;
    if (needChromeFix && mpegLayer === 2 && bitRate >= 224000 && channelMode === 0) {
      // Work around bug in Chromium by setting channelMode to dual-channel (01) instead of stereo (00)
      data[offset + 3] = data[offset + 3] | 0x80;
    }
    return {
      sampleRate,
      channelCount,
      frameLength,
      samplesPerFrame
    };
  }
}
function isHeaderPattern(data, offset) {
  return data[offset] === 0xff && (data[offset + 1] & 0xe0) === 0xe0 && (data[offset + 1] & 0x06) !== 0x00;
}
function isHeader(data, offset) {
  // Look for MPEG header | 1111 1111 | 111X XYZX | where X can be either 0 or 1 and Y or Z should be 1
  // Layer bits (position 14 and 15) in header should be always different from 0 (Layer I or Layer II or Layer III)
  // More info http://www.mp3-tech.org/programmer/frame_header.html
  return offset + 1 < data.length && isHeaderPattern(data, offset);
}
function canParse(data, offset) {
  const headerSize = 4;
  return isHeaderPattern(data, offset) && headerSize <= data.length - offset;
}
function probe(data, offset) {
  // same as isHeader but we also check that MPEG frame follows last MPEG frame
  // or end of data is reached
  if (offset + 1 < data.length && isHeaderPattern(data, offset)) {
    // MPEG header Length
    const headerLength = 4;
    // MPEG frame Length
    const header = parseHeader(data, offset);
    let frameLength = headerLength;
    if (header != null && header.frameLength) {
      frameLength = header.frameLength;
    }
    const newOffset = offset + frameLength;
    return newOffset === data.length || isHeader(data, newOffset);
  }
  return false;
}

/**
 * AAC demuxer
 */
class AACDemuxer extends BaseAudioDemuxer {
  constructor(observer, config) {
    super();
    this.observer = void 0;
    this.config = void 0;
    this.observer = observer;
    this.config = config;
  }
  resetInitSegment(initSegment, audioCodec, videoCodec, trackDuration) {
    super.resetInitSegment(initSegment, audioCodec, videoCodec, trackDuration);
    this._audioTrack = {
      container: 'audio/adts',
      type: 'audio',
      id: 2,
      pid: -1,
      sequenceNumber: 0,
      segmentCodec: 'aac',
      samples: [],
      manifestCodec: audioCodec,
      duration: trackDuration,
      inputTimeScale: 90000,
      dropped: 0
    };
  }

  // Source for probe info - https://wiki.multimedia.cx/index.php?title=ADTS
  static probe(data) {
    if (!data) {
      return false;
    }

    // Check for the ADTS sync word
    // Look for ADTS header | 1111 1111 | 1111 X00X | where X can be either 0 or 1
    // Layer bits (position 14 and 15) in header should be always 0 for ADTS
    // More info https://wiki.multimedia.cx/index.php?title=ADTS
    const id3Data = getID3Data(data, 0);
    let offset = (id3Data == null ? void 0 : id3Data.length) || 0;
    if (probe(data, offset)) {
      return false;
    }
    for (let length = data.length; offset < length; offset++) {
      if (probe$1(data, offset)) {
        logger.log('ADTS sync word found !');
        return true;
      }
    }
    return false;
  }
  canParse(data, offset) {
    return canParse$1(data, offset);
  }
  appendFrame(track, data, offset) {
    initTrackConfig(track, this.observer, data, offset, track.manifestCodec);
    const frame = appendFrame$2(track, data, offset, this.basePTS, this.frameIndex);
    if (frame && frame.missing === 0) {
      return frame;
    }
  }
}

const emsgSchemePattern = /\/emsg[-/]ID3/i;
class MP4Demuxer {
  constructor(observer, config) {
    this.remainderData = null;
    this.timeOffset = 0;
    this.config = void 0;
    this.videoTrack = void 0;
    this.audioTrack = void 0;
    this.id3Track = void 0;
    this.txtTrack = void 0;
    this.config = config;
  }
  resetTimeStamp() {}
  resetInitSegment(initSegment, audioCodec, videoCodec, trackDuration) {
    const videoTrack = this.videoTrack = dummyTrack('video', 1);
    const audioTrack = this.audioTrack = dummyTrack('audio', 1);
    const captionTrack = this.txtTrack = dummyTrack('text', 1);
    this.id3Track = dummyTrack('id3', 1);
    this.timeOffset = 0;
    if (!(initSegment != null && initSegment.byteLength)) {
      return;
    }
    const initData = parseInitSegment(initSegment);
    if (initData.video) {
      const {
        id,
        timescale,
        codec
      } = initData.video;
      videoTrack.id = id;
      videoTrack.timescale = captionTrack.timescale = timescale;
      videoTrack.codec = codec;
    }
    if (initData.audio) {
      const {
        id,
        timescale,
        codec
      } = initData.audio;
      audioTrack.id = id;
      audioTrack.timescale = timescale;
      audioTrack.codec = codec;
    }
    captionTrack.id = RemuxerTrackIdConfig.text;
    videoTrack.sampleDuration = 0;
    videoTrack.duration = audioTrack.duration = trackDuration;
  }
  resetContiguity() {
    this.remainderData = null;
  }
  static probe(data) {
    return hasMoofData(data);
  }
  demux(data, timeOffset) {
    this.timeOffset = timeOffset;
    // Load all data into the avc track. The CMAF remuxer will look for the data in the samples object; the rest of the fields do not matter
    let videoSamples = data;
    const videoTrack = this.videoTrack;
    const textTrack = this.txtTrack;
    if (this.config.progressive) {
      // Split the bytestream into two ranges: one encompassing all data up until the start of the last moof, and everything else.
      // This is done to guarantee that we're sending valid data to MSE - when demuxing progressively, we have no guarantee
      // that the fetch loader gives us flush moof+mdat pairs. If we push jagged data to MSE, it will throw an exception.
      if (this.remainderData) {
        videoSamples = appendUint8Array(this.remainderData, data);
      }
      const segmentedData = segmentValidRange(videoSamples);
      this.remainderData = segmentedData.remainder;
      videoTrack.samples = segmentedData.valid || new Uint8Array();
    } else {
      videoTrack.samples = videoSamples;
    }
    const id3Track = this.extractID3Track(videoTrack, timeOffset);
    textTrack.samples = parseSamples(timeOffset, videoTrack);
    return {
      videoTrack,
      audioTrack: this.audioTrack,
      id3Track,
      textTrack: this.txtTrack
    };
  }
  flush() {
    const timeOffset = this.timeOffset;
    const videoTrack = this.videoTrack;
    const textTrack = this.txtTrack;
    videoTrack.samples = this.remainderData || new Uint8Array();
    this.remainderData = null;
    const id3Track = this.extractID3Track(videoTrack, this.timeOffset);
    textTrack.samples = parseSamples(timeOffset, videoTrack);
    return {
      videoTrack,
      audioTrack: dummyTrack(),
      id3Track,
      textTrack: dummyTrack()
    };
  }
  extractID3Track(videoTrack, timeOffset) {
    const id3Track = this.id3Track;
    if (videoTrack.samples.length) {
      const emsgs = findBox(videoTrack.samples, ['emsg']);
      if (emsgs) {
        emsgs.forEach(data => {
          const emsgInfo = parseEmsg(data);
          if (emsgSchemePattern.test(emsgInfo.schemeIdUri)) {
            const pts = isFiniteNumber(emsgInfo.presentationTime) ? emsgInfo.presentationTime / emsgInfo.timeScale : timeOffset + emsgInfo.presentationTimeDelta / emsgInfo.timeScale;
            let duration = emsgInfo.eventDuration === 0xffffffff ? Number.POSITIVE_INFINITY : emsgInfo.eventDuration / emsgInfo.timeScale;
            // Safari takes anything <= 0.001 seconds and maps it to Infinity
            if (duration <= 0.001) {
              duration = Number.POSITIVE_INFINITY;
            }
            const payload = emsgInfo.payload;
            id3Track.samples.push({
              data: payload,
              len: payload.byteLength,
              dts: pts,
              pts: pts,
              type: MetadataSchema.emsg,
              duration: duration
            });
          }
        });
      }
    }
    return id3Track;
  }
  demuxSampleAes(data, keyData, timeOffset) {
    return Promise.reject(new Error('The MP4 demuxer does not support SAMPLE-AES decryption'));
  }
  destroy() {}
}

const getAudioBSID = (data, offset) => {
  // check the bsid to confirm ac-3 | ec-3
  let bsid = 0;
  let numBits = 5;
  offset += numBits;
  const temp = new Uint32Array(1); // unsigned 32 bit for temporary storage
  const mask = new Uint32Array(1); // unsigned 32 bit mask value
  const byte = new Uint8Array(1); // unsigned 8 bit for temporary storage
  while (numBits > 0) {
    byte[0] = data[offset];
    // read remaining bits, upto 8 bits at a time
    const bits = Math.min(numBits, 8);
    const shift = 8 - bits;
    mask[0] = 0xff000000 >>> 24 + shift << shift;
    temp[0] = (byte[0] & mask[0]) >> shift;
    bsid = !bsid ? temp[0] : bsid << bits | temp[0];
    offset += 1;
    numBits -= bits;
  }
  return bsid;
};

class AC3Demuxer extends BaseAudioDemuxer {
  constructor(observer) {
    super();
    this.observer = void 0;
    this.observer = observer;
  }
  resetInitSegment(initSegment, audioCodec, videoCodec, trackDuration) {
    super.resetInitSegment(initSegment, audioCodec, videoCodec, trackDuration);
    this._audioTrack = {
      container: 'audio/ac-3',
      type: 'audio',
      id: 2,
      pid: -1,
      sequenceNumber: 0,
      segmentCodec: 'ac3',
      samples: [],
      manifestCodec: audioCodec,
      duration: trackDuration,
      inputTimeScale: 90000,
      dropped: 0
    };
  }
  canParse(data, offset) {
    return offset + 64 < data.length;
  }
  appendFrame(track, data, offset) {
    const frameLength = appendFrame(track, data, offset, this.basePTS, this.frameIndex);
    if (frameLength !== -1) {
      const sample = track.samples[track.samples.length - 1];
      return {
        sample,
        length: frameLength,
        missing: 0
      };
    }
  }
  static probe(data) {
    if (!data) {
      return false;
    }
    const id3Data = getID3Data(data, 0);
    if (!id3Data) {
      return false;
    }

    // look for the ac-3 sync bytes
    const offset = id3Data.length;
    if (data[offset] === 0x0b && data[offset + 1] === 0x77 && getTimeStamp(id3Data) !== undefined &&
    // check the bsid to confirm ac-3
    getAudioBSID(data, offset) < 16) {
      return true;
    }
    return false;
  }
}
function appendFrame(track, data, start, pts, frameIndex) {
  if (start + 8 > data.length) {
    return -1; // not enough bytes left
  }
  if (data[start] !== 0x0b || data[start + 1] !== 0x77) {
    return -1; // invalid magic
  }

  // get sample rate
  const samplingRateCode = data[start + 4] >> 6;
  if (samplingRateCode >= 3) {
    return -1; // invalid sampling rate
  }
  const samplingRateMap = [48000, 44100, 32000];
  const sampleRate = samplingRateMap[samplingRateCode];

  // get frame size
  const frameSizeCode = data[start + 4] & 0x3f;
  const frameSizeMap = [64, 69, 96, 64, 70, 96, 80, 87, 120, 80, 88, 120, 96, 104, 144, 96, 105, 144, 112, 121, 168, 112, 122, 168, 128, 139, 192, 128, 140, 192, 160, 174, 240, 160, 175, 240, 192, 208, 288, 192, 209, 288, 224, 243, 336, 224, 244, 336, 256, 278, 384, 256, 279, 384, 320, 348, 480, 320, 349, 480, 384, 417, 576, 384, 418, 576, 448, 487, 672, 448, 488, 672, 512, 557, 768, 512, 558, 768, 640, 696, 960, 640, 697, 960, 768, 835, 1152, 768, 836, 1152, 896, 975, 1344, 896, 976, 1344, 1024, 1114, 1536, 1024, 1115, 1536, 1152, 1253, 1728, 1152, 1254, 1728, 1280, 1393, 1920, 1280, 1394, 1920];
  const frameLength = frameSizeMap[frameSizeCode * 3 + samplingRateCode] * 2;
  if (start + frameLength > data.length) {
    return -1;
  }

  // get channel count
  const channelMode = data[start + 6] >> 5;
  let skipCount = 0;
  if (channelMode === 2) {
    skipCount += 2;
  } else {
    if (channelMode & 1 && channelMode !== 1) {
      skipCount += 2;
    }
    if (channelMode & 4) {
      skipCount += 2;
    }
  }
  const lfeon = (data[start + 6] << 8 | data[start + 7]) >> 12 - skipCount & 1;
  const channelsMap = [2, 1, 2, 3, 3, 4, 4, 5];
  const channelCount = channelsMap[channelMode] + lfeon;

  // build dac3 box
  const bsid = data[start + 5] >> 3;
  const bsmod = data[start + 5] & 7;
  const config = new Uint8Array([samplingRateCode << 6 | bsid << 1 | bsmod >> 2, (bsmod & 3) << 6 | channelMode << 3 | lfeon << 2 | frameSizeCode >> 4, frameSizeCode << 4 & 0xe0]);
  const frameDuration = 1536 / sampleRate * 90000;
  const stamp = pts + frameIndex * frameDuration;
  const unit = data.subarray(start, start + frameLength);
  track.config = config;
  track.channelCount = channelCount;
  track.samplerate = sampleRate;
  track.samples.push({
    unit,
    pts: stamp
  });
  return frameLength;
}

class BaseVideoParser {
  constructor() {
    this.VideoSample = null;
  }
  createVideoSample(key, pts, dts, debug) {
    return {
      key,
      frame: false,
      pts,
      dts,
      units: [],
      debug,
      length: 0
    };
  }
  getLastNalUnit(samples) {
    var _VideoSample;
    let VideoSample = this.VideoSample;
    let lastUnit;
    // try to fallback to previous sample if current one is empty
    if (!VideoSample || VideoSample.units.length === 0) {
      VideoSample = samples[samples.length - 1];
    }
    if ((_VideoSample = VideoSample) != null && _VideoSample.units) {
      const units = VideoSample.units;
      lastUnit = units[units.length - 1];
    }
    return lastUnit;
  }
  pushAccessUnit(VideoSample, videoTrack) {
    if (VideoSample.units.length && VideoSample.frame) {
      // if sample does not have PTS/DTS, patch with last sample PTS/DTS
      if (VideoSample.pts === undefined) {
        const samples = videoTrack.samples;
        const nbSamples = samples.length;
        if (nbSamples) {
          const lastSample = samples[nbSamples - 1];
          VideoSample.pts = lastSample.pts;
          VideoSample.dts = lastSample.dts;
        } else {
          // dropping samples, no timestamp found
          videoTrack.dropped++;
          return;
        }
      }
      videoTrack.samples.push(VideoSample);
    }
    if (VideoSample.debug.length) {
      logger.log(VideoSample.pts + '/' + VideoSample.dts + ':' + VideoSample.debug);
    }
  }
}

/**
 * Parser for exponential Golomb codes, a variable-bitwidth number encoding scheme used by h264.
 */

class ExpGolomb {
  constructor(data) {
    this.data = void 0;
    this.bytesAvailable = void 0;
    this.word = void 0;
    this.bitsAvailable = void 0;
    this.data = data;
    // the number of bytes left to examine in this.data
    this.bytesAvailable = data.byteLength;
    // the current word being examined
    this.word = 0; // :uint
    // the number of bits left to examine in the current word
    this.bitsAvailable = 0; // :uint
  }

  // ():void
  loadWord() {
    const data = this.data;
    const bytesAvailable = this.bytesAvailable;
    const position = data.byteLength - bytesAvailable;
    const workingBytes = new Uint8Array(4);
    const availableBytes = Math.min(4, bytesAvailable);
    if (availableBytes === 0) {
      throw new Error('no bytes available');
    }
    workingBytes.set(data.subarray(position, position + availableBytes));
    this.word = new DataView(workingBytes.buffer).getUint32(0);
    // track the amount of this.data that has been processed
    this.bitsAvailable = availableBytes * 8;
    this.bytesAvailable -= availableBytes;
  }

  // (count:int):void
  skipBits(count) {
    let skipBytes; // :int
    count = Math.min(count, this.bytesAvailable * 8 + this.bitsAvailable);
    if (this.bitsAvailable > count) {
      this.word <<= count;
      this.bitsAvailable -= count;
    } else {
      count -= this.bitsAvailable;
      skipBytes = count >> 3;
      count -= skipBytes << 3;
      this.bytesAvailable -= skipBytes;
      this.loadWord();
      this.word <<= count;
      this.bitsAvailable -= count;
    }
  }

  // (size:int):uint
  readBits(size) {
    let bits = Math.min(this.bitsAvailable, size); // :uint
    const valu = this.word >>> 32 - bits; // :uint
    if (size > 32) {
      logger.error('Cannot read more than 32 bits at a time');
    }
    this.bitsAvailable -= bits;
    if (this.bitsAvailable > 0) {
      this.word <<= bits;
    } else if (this.bytesAvailable > 0) {
      this.loadWord();
    } else {
      throw new Error('no bits available');
    }
    bits = size - bits;
    if (bits > 0 && this.bitsAvailable) {
      return valu << bits | this.readBits(bits);
    } else {
      return valu;
    }
  }

  // ():uint
  skipLZ() {
    let leadingZeroCount; // :uint
    for (leadingZeroCount = 0; leadingZeroCount < this.bitsAvailable; ++leadingZeroCount) {
      if ((this.word & 0x80000000 >>> leadingZeroCount) !== 0) {
        // the first bit of working word is 1
        this.word <<= leadingZeroCount;
        this.bitsAvailable -= leadingZeroCount;
        return leadingZeroCount;
      }
    }
    // we exhausted word and still have not found a 1
    this.loadWord();
    return leadingZeroCount + this.skipLZ();
  }

  // ():void
  skipUEG() {
    this.skipBits(1 + this.skipLZ());
  }

  // ():void
  skipEG() {
    this.skipBits(1 + this.skipLZ());
  }

  // ():uint
  readUEG() {
    const clz = this.skipLZ(); // :uint
    return this.readBits(clz + 1) - 1;
  }

  // ():int
  readEG() {
    const valu = this.readUEG(); // :int
    if (0x01 & valu) {
      // the number is odd if the low order bit is set
      return 1 + valu >>> 1; // add 1 to make it even, and divide by 2
    } else {
      return -1 * (valu >>> 1); // divide by two then make it negative
    }
  }

  // Some convenience functions
  // :Boolean
  readBoolean() {
    return this.readBits(1) === 1;
  }

  // ():int
  readUByte() {
    return this.readBits(8);
  }

  // ():int
  readUShort() {
    return this.readBits(16);
  }

  // ():int
  readUInt() {
    return this.readBits(32);
  }

  /**
   * Advance the ExpGolomb decoder past a scaling list. The scaling
   * list is optionally transmitted as part of a sequence parameter
   * set and is not relevant to transmuxing.
   * @param count the number of entries in this scaling list
   * @see Recommendation ITU-T H.264, Section 7.3.2.1.1.1
   */
  skipScalingList(count) {
    let lastScale = 8;
    let nextScale = 8;
    let deltaScale;
    for (let j = 0; j < count; j++) {
      if (nextScale !== 0) {
        deltaScale = this.readEG();
        nextScale = (lastScale + deltaScale + 256) % 256;
      }
      lastScale = nextScale === 0 ? lastScale : nextScale;
    }
  }

  /**
   * Read a sequence parameter set and return some interesting video
   * properties. A sequence parameter set is the H264 metadata that
   * describes the properties of upcoming video frames.
   * @returns an object with configuration parsed from the
   * sequence parameter set, including the dimensions of the
   * associated video frames.
   */
  readSPS() {
    let frameCropLeftOffset = 0;
    let frameCropRightOffset = 0;
    let frameCropTopOffset = 0;
    let frameCropBottomOffset = 0;
    let numRefFramesInPicOrderCntCycle;
    let scalingListCount;
    let i;
    const readUByte = this.readUByte.bind(this);
    const readBits = this.readBits.bind(this);
    const readUEG = this.readUEG.bind(this);
    const readBoolean = this.readBoolean.bind(this);
    const skipBits = this.skipBits.bind(this);
    const skipEG = this.skipEG.bind(this);
    const skipUEG = this.skipUEG.bind(this);
    const skipScalingList = this.skipScalingList.bind(this);
    readUByte();
    const profileIdc = readUByte(); // profile_idc
    readBits(5); // profileCompat constraint_set[0-4]_flag, u(5)
    skipBits(3); // reserved_zero_3bits u(3),
    readUByte(); // level_idc u(8)
    skipUEG(); // seq_parameter_set_id
    // some profiles have more optional data we don't need
    if (profileIdc === 100 || profileIdc === 110 || profileIdc === 122 || profileIdc === 244 || profileIdc === 44 || profileIdc === 83 || profileIdc === 86 || profileIdc === 118 || profileIdc === 128) {
      const chromaFormatIdc = readUEG();
      if (chromaFormatIdc === 3) {
        skipBits(1);
      } // separate_colour_plane_flag

      skipUEG(); // bit_depth_luma_minus8
      skipUEG(); // bit_depth_chroma_minus8
      skipBits(1); // qpprime_y_zero_transform_bypass_flag
      if (readBoolean()) {
        // seq_scaling_matrix_present_flag
        scalingListCount = chromaFormatIdc !== 3 ? 8 : 12;
        for (i = 0; i < scalingListCount; i++) {
          if (readBoolean()) {
            // seq_scaling_list_present_flag[ i ]
            if (i < 6) {
              skipScalingList(16);
            } else {
              skipScalingList(64);
            }
          }
        }
      }
    }
    skipUEG(); // log2_max_frame_num_minus4
    const picOrderCntType = readUEG();
    if (picOrderCntType === 0) {
      readUEG(); // log2_max_pic_order_cnt_lsb_minus4
    } else if (picOrderCntType === 1) {
      skipBits(1); // delta_pic_order_always_zero_flag
      skipEG(); // offset_for_non_ref_pic
      skipEG(); // offset_for_top_to_bottom_field
      numRefFramesInPicOrderCntCycle = readUEG();
      for (i = 0; i < numRefFramesInPicOrderCntCycle; i++) {
        skipEG();
      } // offset_for_ref_frame[ i ]
    }
    skipUEG(); // max_num_ref_frames
    skipBits(1); // gaps_in_frame_num_value_allowed_flag
    const picWidthInMbsMinus1 = readUEG();
    const picHeightInMapUnitsMinus1 = readUEG();
    const frameMbsOnlyFlag = readBits(1);
    if (frameMbsOnlyFlag === 0) {
      skipBits(1);
    } // mb_adaptive_frame_field_flag

    skipBits(1); // direct_8x8_inference_flag
    if (readBoolean()) {
      // frame_cropping_flag
      frameCropLeftOffset = readUEG();
      frameCropRightOffset = readUEG();
      frameCropTopOffset = readUEG();
      frameCropBottomOffset = readUEG();
    }
    let pixelRatio = [1, 1];
    if (readBoolean()) {
      // vui_parameters_present_flag
      if (readBoolean()) {
        // aspect_ratio_info_present_flag
        const aspectRatioIdc = readUByte();
        switch (aspectRatioIdc) {
          case 1:
            pixelRatio = [1, 1];
            break;
          case 2:
            pixelRatio = [12, 11];
            break;
          case 3:
            pixelRatio = [10, 11];
            break;
          case 4:
            pixelRatio = [16, 11];
            break;
          case 5:
            pixelRatio = [40, 33];
            break;
          case 6:
            pixelRatio = [24, 11];
            break;
          case 7:
            pixelRatio = [20, 11];
            break;
          case 8:
            pixelRatio = [32, 11];
            break;
          case 9:
            pixelRatio = [80, 33];
            break;
          case 10:
            pixelRatio = [18, 11];
            break;
          case 11:
            pixelRatio = [15, 11];
            break;
          case 12:
            pixelRatio = [64, 33];
            break;
          case 13:
            pixelRatio = [160, 99];
            break;
          case 14:
            pixelRatio = [4, 3];
            break;
          case 15:
            pixelRatio = [3, 2];
            break;
          case 16:
            pixelRatio = [2, 1];
            break;
          case 255:
            {
              pixelRatio = [readUByte() << 8 | readUByte(), readUByte() << 8 | readUByte()];
              break;
            }
        }
      }
    }
    return {
      width: Math.ceil((picWidthInMbsMinus1 + 1) * 16 - frameCropLeftOffset * 2 - frameCropRightOffset * 2),
      height: (2 - frameMbsOnlyFlag) * (picHeightInMapUnitsMinus1 + 1) * 16 - (frameMbsOnlyFlag ? 2 : 4) * (frameCropTopOffset + frameCropBottomOffset),
      pixelRatio: pixelRatio
    };
  }
  readSliceType() {
    // skip NALu type
    this.readUByte();
    // discard first_mb_in_slice
    this.readUEG();
    // return slice_type
    return this.readUEG();
  }
}

class AvcVideoParser extends BaseVideoParser {
  parseAVCPES(track, textTrack, pes, last, duration) {
    const units = this.parseAVCNALu(track, pes.data);
    let VideoSample = this.VideoSample;
    let push;
    let spsfound = false;
    // free pes.data to save up some memory
    pes.data = null;

    // if new NAL units found and last sample still there, let's push ...
    // this helps parsing streams with missing AUD (only do this if AUD never found)
    if (VideoSample && units.length && !track.audFound) {
      this.pushAccessUnit(VideoSample, track);
      VideoSample = this.VideoSample = this.createVideoSample(false, pes.pts, pes.dts, '');
    }
    units.forEach(unit => {
      var _VideoSample2;
      switch (unit.type) {
        // NDR
        case 1:
          {
            let iskey = false;
            push = true;
            const data = unit.data;
            // only check slice type to detect KF in case SPS found in same packet (any keyframe is preceded by SPS ...)
            if (spsfound && data.length > 4) {
              // retrieve slice type by parsing beginning of NAL unit (follow H264 spec, slice_header definition) to detect keyframe embedded in NDR
              const sliceType = new ExpGolomb(data).readSliceType();
              // 2 : I slice, 4 : SI slice, 7 : I slice, 9: SI slice
              // SI slice : A slice that is coded using intra prediction only and using quantisation of the prediction samples.
              // An SI slice can be coded such that its decoded samples can be constructed identically to an SP slice.
              // I slice: A slice that is not an SI slice that is decoded using intra prediction only.
              // if (sliceType === 2 || sliceType === 7) {
              if (sliceType === 2 || sliceType === 4 || sliceType === 7 || sliceType === 9) {
                iskey = true;
              }
            }
            if (iskey) {
              var _VideoSample;
              // if we have non-keyframe data already, that cannot belong to the same frame as a keyframe, so force a push
              if ((_VideoSample = VideoSample) != null && _VideoSample.frame && !VideoSample.key) {
                this.pushAccessUnit(VideoSample, track);
                VideoSample = this.VideoSample = null;
              }
            }
            if (!VideoSample) {
              VideoSample = this.VideoSample = this.createVideoSample(true, pes.pts, pes.dts, '');
            }
            VideoSample.frame = true;
            VideoSample.key = iskey;
            break;
            // IDR
          }
        case 5:
          push = true;
          // handle PES not starting with AUD
          // if we have frame data already, that cannot belong to the same frame, so force a push
          if ((_VideoSample2 = VideoSample) != null && _VideoSample2.frame && !VideoSample.key) {
            this.pushAccessUnit(VideoSample, track);
            VideoSample = this.VideoSample = null;
          }
          if (!VideoSample) {
            VideoSample = this.VideoSample = this.createVideoSample(true, pes.pts, pes.dts, '');
          }
          VideoSample.key = true;
          VideoSample.frame = true;
          break;
        // SEI
        case 6:
          {
            push = true;
            parseSEIMessageFromNALu(unit.data, 1, pes.pts, textTrack.samples);
            break;
            // SPS
          }
        case 7:
          {
            var _track$pixelRatio, _track$pixelRatio2;
            push = true;
            spsfound = true;
            const sps = unit.data;
            const expGolombDecoder = new ExpGolomb(sps);
            const config = expGolombDecoder.readSPS();
            if (!track.sps || track.width !== config.width || track.height !== config.height || ((_track$pixelRatio = track.pixelRatio) == null ? void 0 : _track$pixelRatio[0]) !== config.pixelRatio[0] || ((_track$pixelRatio2 = track.pixelRatio) == null ? void 0 : _track$pixelRatio2[1]) !== config.pixelRatio[1]) {
              track.width = config.width;
              track.height = config.height;
              track.pixelRatio = config.pixelRatio;
              track.sps = [sps];
              track.duration = duration;
              const codecarray = sps.subarray(1, 4);
              let codecstring = 'avc1.';
              for (let i = 0; i < 3; i++) {
                let h = codecarray[i].toString(16);
                if (h.length < 2) {
                  h = '0' + h;
                }
                codecstring += h;
              }
              track.codec = codecstring;
            }
            break;
          }
        // PPS
        case 8:
          push = true;
          track.pps = [unit.data];
          break;
        // AUD
        case 9:
          push = true;
          track.audFound = true;
          if (VideoSample) {
            this.pushAccessUnit(VideoSample, track);
          }
          VideoSample = this.VideoSample = this.createVideoSample(false, pes.pts, pes.dts, '');
          break;
        // Filler Data
        case 12:
          push = true;
          break;
        default:
          push = false;
          if (VideoSample) {
            VideoSample.debug += 'unknown NAL ' + unit.type + ' ';
          }
          break;
      }
      if (VideoSample && push) {
        const units = VideoSample.units;
        units.push(unit);
      }
    });
    // if last PES packet, push samples
    if (last && VideoSample) {
      this.pushAccessUnit(VideoSample, track);
      this.VideoSample = null;
    }
  }
  parseAVCNALu(track, array) {
    const len = array.byteLength;
    let state = track.naluState || 0;
    const lastState = state;
    const units = [];
    let i = 0;
    let value;
    let overflow;
    let unitType;
    let lastUnitStart = -1;
    let lastUnitType = 0;
    // logger.log('PES:' + Hex.hexDump(array));

    if (state === -1) {
      // special use case where we found 3 or 4-byte start codes exactly at the end of previous PES packet
      lastUnitStart = 0;
      // NALu type is value read from offset 0
      lastUnitType = array[0] & 0x1f;
      state = 0;
      i = 1;
    }
    while (i < len) {
      value = array[i++];
      // optimization. state 0 and 1 are the predominant case. let's handle them outside of the switch/case
      if (!state) {
        state = value ? 0 : 1;
        continue;
      }
      if (state === 1) {
        state = value ? 0 : 2;
        continue;
      }
      // here we have state either equal to 2 or 3
      if (!value) {
        state = 3;
      } else if (value === 1) {
        overflow = i - state - 1;
        if (lastUnitStart >= 0) {
          const unit = {
            data: array.subarray(lastUnitStart, overflow),
            type: lastUnitType
          };
          // logger.log('pushing NALU, type/size:' + unit.type + '/' + unit.data.byteLength);
          units.push(unit);
        } else {
          // lastUnitStart is undefined => this is the first start code found in this PES packet
          // first check if start code delimiter is overlapping between 2 PES packets,
          // ie it started in last packet (lastState not zero)
          // and ended at the beginning of this PES packet (i <= 4 - lastState)
          const lastUnit = this.getLastNalUnit(track.samples);
          if (lastUnit) {
            if (lastState && i <= 4 - lastState) {
              // start delimiter overlapping between PES packets
              // strip start delimiter bytes from the end of last NAL unit
              // check if lastUnit had a state different from zero
              if (lastUnit.state) {
                // strip last bytes
                lastUnit.data = lastUnit.data.subarray(0, lastUnit.data.byteLength - lastState);
              }
            }
            // If NAL units are not starting right at the beginning of the PES packet, push preceding data into previous NAL unit.

            if (overflow > 0) {
              // logger.log('first NALU found with overflow:' + overflow);
              lastUnit.data = appendUint8Array(lastUnit.data, array.subarray(0, overflow));
              lastUnit.state = 0;
            }
          }
        }
        // check if we can read unit type
        if (i < len) {
          unitType = array[i] & 0x1f;
          // logger.log('find NALU @ offset:' + i + ',type:' + unitType);
          lastUnitStart = i;
          lastUnitType = unitType;
          state = 0;
        } else {
          // not enough byte to read unit type. let's read it on next PES parsing
          state = -1;
        }
      } else {
        state = 0;
      }
    }
    if (lastUnitStart >= 0 && state >= 0) {
      const unit = {
        data: array.subarray(lastUnitStart, len),
        type: lastUnitType,
        state: state
      };
      units.push(unit);
      // logger.log('pushing NALU, type/size/state:' + unit.type + '/' + unit.data.byteLength + '/' + state);
    }
    // no NALu found
    if (units.length === 0) {
      // append pes.data to previous NAL unit
      const lastUnit = this.getLastNalUnit(track.samples);
      if (lastUnit) {
        lastUnit.data = appendUint8Array(lastUnit.data, array);
      }
    }
    track.naluState = state;
    return units;
  }
}

/**
 * SAMPLE-AES decrypter
 */

class SampleAesDecrypter {
  constructor(observer, config, keyData) {
    this.keyData = void 0;
    this.decrypter = void 0;
    this.keyData = keyData;
    this.decrypter = new Decrypter(config, {
      removePKCS7Padding: false
    });
  }
  decryptBuffer(encryptedData) {
    return this.decrypter.decrypt(encryptedData, this.keyData.key.buffer, this.keyData.iv.buffer);
  }

  // AAC - encrypt all full 16 bytes blocks starting from offset 16
  decryptAacSample(samples, sampleIndex, callback) {
    const curUnit = samples[sampleIndex].unit;
    if (curUnit.length <= 16) {
      // No encrypted portion in this sample (first 16 bytes is not
      // encrypted, see https://developer.apple.com/library/archive/documentation/AudioVideo/Conceptual/HLS_Sample_Encryption/Encryption/Encryption.html),
      return;
    }
    const encryptedData = curUnit.subarray(16, curUnit.length - curUnit.length % 16);
    const encryptedBuffer = encryptedData.buffer.slice(encryptedData.byteOffset, encryptedData.byteOffset + encryptedData.length);
    this.decryptBuffer(encryptedBuffer).then(decryptedBuffer => {
      const decryptedData = new Uint8Array(decryptedBuffer);
      curUnit.set(decryptedData, 16);
      if (!this.decrypter.isSync()) {
        this.decryptAacSamples(samples, sampleIndex + 1, callback);
      }
    });
  }
  decryptAacSamples(samples, sampleIndex, callback) {
    for (;; sampleIndex++) {
      if (sampleIndex >= samples.length) {
        callback();
        return;
      }
      if (samples[sampleIndex].unit.length < 32) {
        continue;
      }
      this.decryptAacSample(samples, sampleIndex, callback);
      if (!this.decrypter.isSync()) {
        return;
      }
    }
  }

  // AVC - encrypt one 16 bytes block out of ten, starting from offset 32
  getAvcEncryptedData(decodedData) {
    const encryptedDataLen = Math.floor((decodedData.length - 48) / 160) * 16 + 16;
    const encryptedData = new Int8Array(encryptedDataLen);
    let outputPos = 0;
    for (let inputPos = 32; inputPos < decodedData.length - 16; inputPos += 160, outputPos += 16) {
      encryptedData.set(decodedData.subarray(inputPos, inputPos + 16), outputPos);
    }
    return encryptedData;
  }
  getAvcDecryptedUnit(decodedData, decryptedData) {
    const uint8DecryptedData = new Uint8Array(decryptedData);
    let inputPos = 0;
    for (let outputPos = 32; outputPos < decodedData.length - 16; outputPos += 160, inputPos += 16) {
      decodedData.set(uint8DecryptedData.subarray(inputPos, inputPos + 16), outputPos);
    }
    return decodedData;
  }
  decryptAvcSample(samples, sampleIndex, unitIndex, callback, curUnit) {
    const decodedData = discardEPB(curUnit.data);
    const encryptedData = this.getAvcEncryptedData(decodedData);
    this.decryptBuffer(encryptedData.buffer).then(decryptedBuffer => {
      curUnit.data = this.getAvcDecryptedUnit(decodedData, decryptedBuffer);
      if (!this.decrypter.isSync()) {
        this.decryptAvcSamples(samples, sampleIndex, unitIndex + 1, callback);
      }
    });
  }
  decryptAvcSamples(samples, sampleIndex, unitIndex, callback) {
    if (samples instanceof Uint8Array) {
      throw new Error('Cannot decrypt samples of type Uint8Array');
    }
    for (;; sampleIndex++, unitIndex = 0) {
      if (sampleIndex >= samples.length) {
        callback();
        return;
      }
      const curUnits = samples[sampleIndex].units;
      for (;; unitIndex++) {
        if (unitIndex >= curUnits.length) {
          break;
        }
        const curUnit = curUnits[unitIndex];
        if (curUnit.data.length <= 48 || curUnit.type !== 1 && curUnit.type !== 5) {
          continue;
        }
        this.decryptAvcSample(samples, sampleIndex, unitIndex, callback, curUnit);
        if (!this.decrypter.isSync()) {
          return;
        }
      }
    }
  }
}

const PACKET_LENGTH = 188;
class TSDemuxer {
  constructor(observer, config, typeSupported) {
    this.observer = void 0;
    this.config = void 0;
    this.typeSupported = void 0;
    this.sampleAes = null;
    this.pmtParsed = false;
    this.audioCodec = void 0;
    this.videoCodec = void 0;
    this._duration = 0;
    this._pmtId = -1;
    this._videoTrack = void 0;
    this._audioTrack = void 0;
    this._id3Track = void 0;
    this._txtTrack = void 0;
    this.aacOverFlow = null;
    this.remainderData = null;
    this.videoParser = void 0;
    this.observer = observer;
    this.config = config;
    this.typeSupported = typeSupported;
    this.videoParser = new AvcVideoParser();
  }
  static probe(data) {
    const syncOffset = TSDemuxer.syncOffset(data);
    if (syncOffset > 0) {
      logger.warn(`MPEG2-TS detected but first sync word found @ offset ${syncOffset}`);
    }
    return syncOffset !== -1;
  }
  static syncOffset(data) {
    const length = data.length;
    let scanwindow = Math.min(PACKET_LENGTH * 5, length - PACKET_LENGTH) + 1;
    let i = 0;
    while (i < scanwindow) {
      // a TS init segment should contain at least 2 TS packets: PAT and PMT, each starting with 0x47
      let foundPat = false;
      let packetStart = -1;
      let tsPackets = 0;
      for (let j = i; j < length; j += PACKET_LENGTH) {
        if (data[j] === 0x47 && (length - j === PACKET_LENGTH || data[j + PACKET_LENGTH] === 0x47)) {
          tsPackets++;
          if (packetStart === -1) {
            packetStart = j;
            // First sync word found at offset, increase scan length (#5251)
            if (packetStart !== 0) {
              scanwindow = Math.min(packetStart + PACKET_LENGTH * 99, data.length - PACKET_LENGTH) + 1;
            }
          }
          if (!foundPat) {
            foundPat = parsePID(data, j) === 0;
          }
          // Sync word found at 0 with 3 packets, or found at offset least 2 packets up to scanwindow (#5501)
          if (foundPat && tsPackets > 1 && (packetStart === 0 && tsPackets > 2 || j + PACKET_LENGTH > scanwindow)) {
            return packetStart;
          }
        } else if (tsPackets) {
          // Exit if sync word found, but does not contain contiguous packets
          return -1;
        } else {
          break;
        }
      }
      i++;
    }
    return -1;
  }

  /**
   * Creates a track model internal to demuxer used to drive remuxing input
   */
  static createTrack(type, duration) {
    return {
      container: type === 'video' || type === 'audio' ? 'video/mp2t' : undefined,
      type,
      id: RemuxerTrackIdConfig[type],
      pid: -1,
      inputTimeScale: 90000,
      sequenceNumber: 0,
      samples: [],
      dropped: 0,
      duration: type === 'audio' ? duration : undefined
    };
  }

  /**
   * Initializes a new init segment on the demuxer/remuxer interface. Needed for discontinuities/track-switches (or at stream start)
   * Resets all internal track instances of the demuxer.
   */
  resetInitSegment(initSegment, audioCodec, videoCodec, trackDuration) {
    this.pmtParsed = false;
    this._pmtId = -1;
    this._videoTrack = TSDemuxer.createTrack('video');
    this._audioTrack = TSDemuxer.createTrack('audio', trackDuration);
    this._id3Track = TSDemuxer.createTrack('id3');
    this._txtTrack = TSDemuxer.createTrack('text');
    this._audioTrack.segmentCodec = 'aac';

    // flush any partial content
    this.aacOverFlow = null;
    this.remainderData = null;
    this.audioCodec = audioCodec;
    this.videoCodec = videoCodec;
    this._duration = trackDuration;
  }
  resetTimeStamp() {}
  resetContiguity() {
    const {
      _audioTrack,
      _videoTrack,
      _id3Track
    } = this;
    if (_audioTrack) {
      _audioTrack.pesData = null;
    }
    if (_videoTrack) {
      _videoTrack.pesData = null;
    }
    if (_id3Track) {
      _id3Track.pesData = null;
    }
    this.aacOverFlow = null;
    this.remainderData = null;
  }
  demux(data, timeOffset, isSampleAes = false, flush = false) {
    if (!isSampleAes) {
      this.sampleAes = null;
    }
    let pes;
    const videoTrack = this._videoTrack;
    const audioTrack = this._audioTrack;
    const id3Track = this._id3Track;
    const textTrack = this._txtTrack;
    let videoPid = videoTrack.pid;
    let videoData = videoTrack.pesData;
    let audioPid = audioTrack.pid;
    let id3Pid = id3Track.pid;
    let audioData = audioTrack.pesData;
    let id3Data = id3Track.pesData;
    let unknownPID = null;
    let pmtParsed = this.pmtParsed;
    let pmtId = this._pmtId;
    let len = data.length;
    if (this.remainderData) {
      data = appendUint8Array(this.remainderData, data);
      len = data.length;
      this.remainderData = null;
    }
    if (len < PACKET_LENGTH && !flush) {
      this.remainderData = data;
      return {
        audioTrack,
        videoTrack,
        id3Track,
        textTrack
      };
    }
    const syncOffset = Math.max(0, TSDemuxer.syncOffset(data));
    len -= (len - syncOffset) % PACKET_LENGTH;
    if (len < data.byteLength && !flush) {
      this.remainderData = new Uint8Array(data.buffer, len, data.buffer.byteLength - len);
    }

    // loop through TS packets
    let tsPacketErrors = 0;
    for (let start = syncOffset; start < len; start += PACKET_LENGTH) {
      if (data[start] === 0x47) {
        const stt = !!(data[start + 1] & 0x40);
        const pid = parsePID(data, start);
        const atf = (data[start + 3] & 0x30) >> 4;

        // if an adaption field is present, its length is specified by the fifth byte of the TS packet header.
        let offset;
        if (atf > 1) {
          offset = start + 5 + data[start + 4];
          // continue if there is only adaptation field
          if (offset === start + PACKET_LENGTH) {
            continue;
          }
        } else {
          offset = start + 4;
        }
        switch (pid) {
          case videoPid:
            if (stt) {
              if (videoData && (pes = parsePES(videoData))) {
                this.videoParser.parseAVCPES(videoTrack, textTrack, pes, false, this._duration);
              }
              videoData = {
                data: [],
                size: 0
              };
            }
            if (videoData) {
              videoData.data.push(data.subarray(offset, start + PACKET_LENGTH));
              videoData.size += start + PACKET_LENGTH - offset;
            }
            break;
          case audioPid:
            if (stt) {
              if (audioData && (pes = parsePES(audioData))) {
                switch (audioTrack.segmentCodec) {
                  case 'aac':
                    this.parseAACPES(audioTrack, pes);
                    break;
                  case 'mp3':
                    this.parseMPEGPES(audioTrack, pes);
                    break;
                  case 'ac3':
                    {
                      this.parseAC3PES(audioTrack, pes);
                    }
                    break;
                }
              }
              audioData = {
                data: [],
                size: 0
              };
            }
            if (audioData) {
              audioData.data.push(data.subarray(offset, start + PACKET_LENGTH));
              audioData.size += start + PACKET_LENGTH - offset;
            }
            break;
          case id3Pid:
            if (stt) {
              if (id3Data && (pes = parsePES(id3Data))) {
                this.parseID3PES(id3Track, pes);
              }
              id3Data = {
                data: [],
                size: 0
              };
            }
            if (id3Data) {
              id3Data.data.push(data.subarray(offset, start + PACKET_LENGTH));
              id3Data.size += start + PACKET_LENGTH - offset;
            }
            break;
          case 0:
            if (stt) {
              offset += data[offset] + 1;
            }
            pmtId = this._pmtId = parsePAT(data, offset);
            // logger.log('PMT PID:'  + this._pmtId);
            break;
          case pmtId:
            {
              if (stt) {
                offset += data[offset] + 1;
              }
              const parsedPIDs = parsePMT(data, offset, this.typeSupported, isSampleAes, this.observer);

              // only update track id if track PID found while parsing PMT
              // this is to avoid resetting the PID to -1 in case
              // track PID transiently disappears from the stream
              // this could happen in case of transient missing audio samples for example
              // NOTE this is only the PID of the track as found in TS,
              // but we are not using this for MP4 track IDs.
              videoPid = parsedPIDs.videoPid;
              if (videoPid > 0) {
                videoTrack.pid = videoPid;
                videoTrack.segmentCodec = parsedPIDs.segmentVideoCodec;
              }
              audioPid = parsedPIDs.audioPid;
              if (audioPid > 0) {
                audioTrack.pid = audioPid;
                audioTrack.segmentCodec = parsedPIDs.segmentAudioCodec;
              }
              id3Pid = parsedPIDs.id3Pid;
              if (id3Pid > 0) {
                id3Track.pid = id3Pid;
              }
              if (unknownPID !== null && !pmtParsed) {
                logger.warn(`MPEG-TS PMT found at ${start} after unknown PID '${unknownPID}'. Backtracking to sync byte @${syncOffset} to parse all TS packets.`);
                unknownPID = null;
                // we set it to -188, the += 188 in the for loop will reset start to 0
                start = syncOffset - 188;
              }
              pmtParsed = this.pmtParsed = true;
              break;
            }
          case 0x11:
          case 0x1fff:
            break;
          default:
            unknownPID = pid;
            break;
        }
      } else {
        tsPacketErrors++;
      }
    }
    if (tsPacketErrors > 0) {
      emitParsingError(this.observer, new Error(`Found ${tsPacketErrors} TS packet/s that do not start with 0x47`));
    }
    videoTrack.pesData = videoData;
    audioTrack.pesData = audioData;
    id3Track.pesData = id3Data;
    const demuxResult = {
      audioTrack,
      videoTrack,
      id3Track,
      textTrack
    };
    if (flush) {
      this.extractRemainingSamples(demuxResult);
    }
    return demuxResult;
  }
  flush() {
    const {
      remainderData
    } = this;
    this.remainderData = null;
    let result;
    if (remainderData) {
      result = this.demux(remainderData, -1, false, true);
    } else {
      result = {
        videoTrack: this._videoTrack,
        audioTrack: this._audioTrack,
        id3Track: this._id3Track,
        textTrack: this._txtTrack
      };
    }
    this.extractRemainingSamples(result);
    if (this.sampleAes) {
      return this.decrypt(result, this.sampleAes);
    }
    return result;
  }
  extractRemainingSamples(demuxResult) {
    const {
      audioTrack,
      videoTrack,
      id3Track,
      textTrack
    } = demuxResult;
    const videoData = videoTrack.pesData;
    const audioData = audioTrack.pesData;
    const id3Data = id3Track.pesData;
    // try to parse last PES packets
    let pes;
    if (videoData && (pes = parsePES(videoData))) {
      this.videoParser.parseAVCPES(videoTrack, textTrack, pes, true, this._duration);
      videoTrack.pesData = null;
    } else {
      // either avcData null or PES truncated, keep it for next frag parsing
      videoTrack.pesData = videoData;
    }
    if (audioData && (pes = parsePES(audioData))) {
      switch (audioTrack.segmentCodec) {
        case 'aac':
          this.parseAACPES(audioTrack, pes);
          break;
        case 'mp3':
          this.parseMPEGPES(audioTrack, pes);
          break;
        case 'ac3':
          {
            this.parseAC3PES(audioTrack, pes);
          }
          break;
      }
      audioTrack.pesData = null;
    } else {
      if (audioData != null && audioData.size) {
        logger.log('last AAC PES packet truncated,might overlap between fragments');
      }

      // either audioData null or PES truncated, keep it for next frag parsing
      audioTrack.pesData = audioData;
    }
    if (id3Data && (pes = parsePES(id3Data))) {
      this.parseID3PES(id3Track, pes);
      id3Track.pesData = null;
    } else {
      // either id3Data null or PES truncated, keep it for next frag parsing
      id3Track.pesData = id3Data;
    }
  }
  demuxSampleAes(data, keyData, timeOffset) {
    const demuxResult = this.demux(data, timeOffset, true, !this.config.progressive);
    const sampleAes = this.sampleAes = new SampleAesDecrypter(this.observer, this.config, keyData);
    return this.decrypt(demuxResult, sampleAes);
  }
  decrypt(demuxResult, sampleAes) {
    return new Promise(resolve => {
      const {
        audioTrack,
        videoTrack
      } = demuxResult;
      if (audioTrack.samples && audioTrack.segmentCodec === 'aac') {
        sampleAes.decryptAacSamples(audioTrack.samples, 0, () => {
          if (videoTrack.samples) {
            sampleAes.decryptAvcSamples(videoTrack.samples, 0, 0, () => {
              resolve(demuxResult);
            });
          } else {
            resolve(demuxResult);
          }
        });
      } else if (videoTrack.samples) {
        sampleAes.decryptAvcSamples(videoTrack.samples, 0, 0, () => {
          resolve(demuxResult);
        });
      }
    });
  }
  destroy() {
    this._duration = 0;
  }
  parseAACPES(track, pes) {
    let startOffset = 0;
    const aacOverFlow = this.aacOverFlow;
    let data = pes.data;
    if (aacOverFlow) {
      this.aacOverFlow = null;
      const frameMissingBytes = aacOverFlow.missing;
      const sampleLength = aacOverFlow.sample.unit.byteLength;
      // logger.log(`AAC: append overflowing ${sampleLength} bytes to beginning of new PES`);
      if (frameMissingBytes === -1) {
        data = appendUint8Array(aacOverFlow.sample.unit, data);
      } else {
        const frameOverflowBytes = sampleLength - frameMissingBytes;
        aacOverFlow.sample.unit.set(data.subarray(0, frameMissingBytes), frameOverflowBytes);
        track.samples.push(aacOverFlow.sample);
        startOffset = aacOverFlow.missing;
      }
    }
    // look for ADTS header (0xFFFx)
    let offset;
    let len;
    for (offset = startOffset, len = data.length; offset < len - 1; offset++) {
      if (isHeader$1(data, offset)) {
        break;
      }
    }
    // if ADTS header does not start straight from the beginning of the PES payload, raise an error
    if (offset !== startOffset) {
      let reason;
      const recoverable = offset < len - 1;
      if (recoverable) {
        reason = `AAC PES did not start with ADTS header,offset:${offset}`;
      } else {
        reason = 'No ADTS header found in AAC PES';
      }
      emitParsingError(this.observer, new Error(reason), recoverable);
      if (!recoverable) {
        return;
      }
    }
    initTrackConfig(track, this.observer, data, offset, this.audioCodec);
    let pts;
    if (pes.pts !== undefined) {
      pts = pes.pts;
    } else if (aacOverFlow) {
      // if last AAC frame is overflowing, we should ensure timestamps are contiguous:
      // first sample PTS should be equal to last sample PTS + frameDuration
      const frameDuration = getFrameDuration(track.samplerate);
      pts = aacOverFlow.sample.pts + frameDuration;
    } else {
      logger.warn('[tsdemuxer]: AAC PES unknown PTS');
      return;
    }

    // scan for aac samples
    let frameIndex = 0;
    let frame;
    while (offset < len) {
      frame = appendFrame$2(track, data, offset, pts, frameIndex);
      offset += frame.length;
      if (!frame.missing) {
        frameIndex++;
        for (; offset < len - 1; offset++) {
          if (isHeader$1(data, offset)) {
            break;
          }
        }
      } else {
        this.aacOverFlow = frame;
        break;
      }
    }
  }
  parseMPEGPES(track, pes) {
    const data = pes.data;
    const length = data.length;
    let frameIndex = 0;
    let offset = 0;
    const pts = pes.pts;
    if (pts === undefined) {
      logger.warn('[tsdemuxer]: MPEG PES unknown PTS');
      return;
    }
    while (offset < length) {
      if (isHeader(data, offset)) {
        const frame = appendFrame$1(track, data, offset, pts, frameIndex);
        if (frame) {
          offset += frame.length;
          frameIndex++;
        } else {
          // logger.log('Unable to parse Mpeg audio frame');
          break;
        }
      } else {
        // nothing found, keep looking
        offset++;
      }
    }
  }
  parseAC3PES(track, pes) {
    {
      const data = pes.data;
      const pts = pes.pts;
      if (pts === undefined) {
        logger.warn('[tsdemuxer]: AC3 PES unknown PTS');
        return;
      }
      const length = data.length;
      let frameIndex = 0;
      let offset = 0;
      let parsed;
      while (offset < length && (parsed = appendFrame(track, data, offset, pts, frameIndex++)) > 0) {
        offset += parsed;
      }
    }
  }
  parseID3PES(id3Track, pes) {
    if (pes.pts === undefined) {
      logger.warn('[tsdemuxer]: ID3 PES unknown PTS');
      return;
    }
    const id3Sample = _extends({}, pes, {
      type: this._videoTrack ? MetadataSchema.emsg : MetadataSchema.audioId3,
      duration: Number.POSITIVE_INFINITY
    });
    id3Track.samples.push(id3Sample);
  }
}
function parsePID(data, offset) {
  // pid is a 13-bit field starting at the last bit of TS[1]
  return ((data[offset + 1] & 0x1f) << 8) + data[offset + 2];
}
function parsePAT(data, offset) {
  // skip the PSI header and parse the first PMT entry
  return (data[offset + 10] & 0x1f) << 8 | data[offset + 11];
}
function parsePMT(data, offset, typeSupported, isSampleAes, observer) {
  const result = {
    audioPid: -1,
    videoPid: -1,
    id3Pid: -1,
    segmentVideoCodec: 'avc',
    segmentAudioCodec: 'aac'
  };
  const sectionLength = (data[offset + 1] & 0x0f) << 8 | data[offset + 2];
  const tableEnd = offset + 3 + sectionLength - 4;
  // to determine where the table is, we have to figure out how
  // long the program info descriptors are
  const programInfoLength = (data[offset + 10] & 0x0f) << 8 | data[offset + 11];
  // advance the offset to the first entry in the mapping table
  offset += 12 + programInfoLength;
  while (offset < tableEnd) {
    const pid = parsePID(data, offset);
    const esInfoLength = (data[offset + 3] & 0x0f) << 8 | data[offset + 4];
    switch (data[offset]) {
      case 0xcf:
        // SAMPLE-AES AAC
        if (!isSampleAes) {
          logEncryptedSamplesFoundInUnencryptedStream('ADTS AAC');
          break;
        }
      /* falls through */
      case 0x0f:
        // ISO/IEC 13818-7 ADTS AAC (MPEG-2 lower bit-rate audio)
        // logger.log('AAC PID:'  + pid);
        if (result.audioPid === -1) {
          result.audioPid = pid;
        }
        break;

      // Packetized metadata (ID3)
      case 0x15:
        // logger.log('ID3 PID:'  + pid);
        if (result.id3Pid === -1) {
          result.id3Pid = pid;
        }
        break;
      case 0xdb:
        // SAMPLE-AES AVC
        if (!isSampleAes) {
          logEncryptedSamplesFoundInUnencryptedStream('H.264');
          break;
        }
      /* falls through */
      case 0x1b:
        // ITU-T Rec. H.264 and ISO/IEC 14496-10 (lower bit-rate video)
        // logger.log('AVC PID:'  + pid);
        if (result.videoPid === -1) {
          result.videoPid = pid;
          result.segmentVideoCodec = 'avc';
        }
        break;

      // ISO/IEC 11172-3 (MPEG-1 audio)
      // or ISO/IEC 13818-3 (MPEG-2 halved sample rate audio)
      case 0x03:
      case 0x04:
        // logger.log('MPEG PID:'  + pid);
        if (!typeSupported.mpeg && !typeSupported.mp3) {
          logger.log('MPEG audio found, not supported in this browser');
        } else if (result.audioPid === -1) {
          result.audioPid = pid;
          result.segmentAudioCodec = 'mp3';
        }
        break;
      case 0xc1:
        // SAMPLE-AES AC3
        if (!isSampleAes) {
          logEncryptedSamplesFoundInUnencryptedStream('AC-3');
          break;
        }
      /* falls through */
      case 0x81:
        {
          if (!typeSupported.ac3) {
            logger.log('AC-3 audio found, not supported in this browser');
          } else if (result.audioPid === -1) {
            result.audioPid = pid;
            result.segmentAudioCodec = 'ac3';
          }
        }
        break;
      case 0x06:
        // stream_type 6 can mean a lot of different things in case of DVB.
        // We need to look at the descriptors. Right now, we're only interested
        // in AC-3 audio, so we do the descriptor parsing only when we don't have
        // an audio PID yet.
        if (result.audioPid === -1 && esInfoLength > 0) {
          let parsePos = offset + 5;
          let remaining = esInfoLength;
          while (remaining > 2) {
            const descriptorId = data[parsePos];
            switch (descriptorId) {
              case 0x6a:
                // DVB Descriptor for AC-3
                {
                  if (typeSupported.ac3 !== true) {
                    logger.log('AC-3 audio found, not supported in this browser for now');
                  } else {
                    result.audioPid = pid;
                    result.segmentAudioCodec = 'ac3';
                  }
                }
                break;
            }
            const descriptorLen = data[parsePos + 1] + 2;
            parsePos += descriptorLen;
            remaining -= descriptorLen;
          }
        }
        break;
      case 0xc2: // SAMPLE-AES EC3
      /* falls through */
      case 0x87:
        emitParsingError(observer, new Error('Unsupported EC-3 in M2TS found'));
        return result;
      case 0x24:
        emitParsingError(observer, new Error('Unsupported HEVC in M2TS found'));
        return result;
    }
    // move to the next table entry
    // skip past the elementary stream descriptors, if present
    offset += esInfoLength + 5;
  }
  return result;
}
function emitParsingError(observer, error, levelRetry) {
  logger.warn(`parsing error: ${error.message}`);
  observer.emit(Events.ERROR, Events.ERROR, {
    type: ErrorTypes.MEDIA_ERROR,
    details: ErrorDetails.FRAG_PARSING_ERROR,
    fatal: false,
    levelRetry,
    error,
    reason: error.message
  });
}
function logEncryptedSamplesFoundInUnencryptedStream(type) {
  logger.log(`${type} with AES-128-CBC encryption found in unencrypted stream`);
}
function parsePES(stream) {
  let i = 0;
  let frag;
  let pesLen;
  let pesHdrLen;
  let pesPts;
  let pesDts;
  const data = stream.data;
  // safety check
  if (!stream || stream.size === 0) {
    return null;
  }

  // we might need up to 19 bytes to read PES header
  // if first chunk of data is less than 19 bytes, let's merge it with following ones until we get 19 bytes
  // usually only one merge is needed (and this is rare ...)
  while (data[0].length < 19 && data.length > 1) {
    data[0] = appendUint8Array(data[0], data[1]);
    data.splice(1, 1);
  }
  // retrieve PTS/DTS from first fragment
  frag = data[0];
  const pesPrefix = (frag[0] << 16) + (frag[1] << 8) + frag[2];
  if (pesPrefix === 1) {
    pesLen = (frag[4] << 8) + frag[5];
    // if PES parsed length is not zero and greater than total received length, stop parsing. PES might be truncated
    // minus 6 : PES header size
    if (pesLen && pesLen > stream.size - 6) {
      return null;
    }
    const pesFlags = frag[7];
    if (pesFlags & 0xc0) {
      /* PES header described here : http://dvd.sourceforge.net/dvdinfo/pes-hdr.html
          as PTS / DTS is 33 bit we cannot use bitwise operator in JS,
          as Bitwise operators treat their operands as a sequence of 32 bits */
      pesPts = (frag[9] & 0x0e) * 536870912 +
      // 1 << 29
      (frag[10] & 0xff) * 4194304 +
      // 1 << 22
      (frag[11] & 0xfe) * 16384 +
      // 1 << 14
      (frag[12] & 0xff) * 128 +
      // 1 << 7
      (frag[13] & 0xfe) / 2;
      if (pesFlags & 0x40) {
        pesDts = (frag[14] & 0x0e) * 536870912 +
        // 1 << 29
        (frag[15] & 0xff) * 4194304 +
        // 1 << 22
        (frag[16] & 0xfe) * 16384 +
        // 1 << 14
        (frag[17] & 0xff) * 128 +
        // 1 << 7
        (frag[18] & 0xfe) / 2;
        if (pesPts - pesDts > 60 * 90000) {
          logger.warn(`${Math.round((pesPts - pesDts) / 90000)}s delta between PTS and DTS, align them`);
          pesPts = pesDts;
        }
      } else {
        pesDts = pesPts;
      }
    }
    pesHdrLen = frag[8];
    // 9 bytes : 6 bytes for PES header + 3 bytes for PES extension
    let payloadStartOffset = pesHdrLen + 9;
    if (stream.size <= payloadStartOffset) {
      return null;
    }
    stream.size -= payloadStartOffset;
    // reassemble PES packet
    const pesData = new Uint8Array(stream.size);
    for (let j = 0, dataLen = data.length; j < dataLen; j++) {
      frag = data[j];
      let len = frag.byteLength;
      if (payloadStartOffset) {
        if (payloadStartOffset > len) {
          // trim full frag if PES header bigger than frag
          payloadStartOffset -= len;
          continue;
        } else {
          // trim partial frag if PES header smaller than frag
          frag = frag.subarray(payloadStartOffset);
          len -= payloadStartOffset;
          payloadStartOffset = 0;
        }
      }
      pesData.set(frag, i);
      i += len;
    }
    if (pesLen) {
      // payload size : remove PES header + PES extension
      pesLen -= pesHdrLen + 3;
    }
    return {
      data: pesData,
      pts: pesPts,
      dts: pesDts,
      len: pesLen
    };
  }
  return null;
}

/**
 * MP3 demuxer
 */
class MP3Demuxer extends BaseAudioDemuxer {
  resetInitSegment(initSegment, audioCodec, videoCodec, trackDuration) {
    super.resetInitSegment(initSegment, audioCodec, videoCodec, trackDuration);
    this._audioTrack = {
      container: 'audio/mpeg',
      type: 'audio',
      id: 2,
      pid: -1,
      sequenceNumber: 0,
      segmentCodec: 'mp3',
      samples: [],
      manifestCodec: audioCodec,
      duration: trackDuration,
      inputTimeScale: 90000,
      dropped: 0
    };
  }
  static probe(data) {
    if (!data) {
      return false;
    }

    // check if data contains ID3 timestamp and MPEG sync word
    // Look for MPEG header | 1111 1111 | 111X XYZX | where X can be either 0 or 1 and Y or Z should be 1
    // Layer bits (position 14 and 15) in header should be always different from 0 (Layer I or Layer II or Layer III)
    // More info http://www.mp3-tech.org/programmer/frame_header.html
    const id3Data = getID3Data(data, 0);
    let offset = (id3Data == null ? void 0 : id3Data.length) || 0;

    // Check for ac-3|ec-3 sync bytes and return false if present
    if (id3Data && data[offset] === 0x0b && data[offset + 1] === 0x77 && getTimeStamp(id3Data) !== undefined &&
    // check the bsid to confirm ac-3 or ec-3 (not mp3)
    getAudioBSID(data, offset) <= 16) {
      return false;
    }
    for (let length = data.length; offset < length; offset++) {
      if (probe(data, offset)) {
        logger.log('MPEG Audio sync word found !');
        return true;
      }
    }
    return false;
  }
  canParse(data, offset) {
    return canParse(data, offset);
  }
  appendFrame(track, data, offset) {
    if (this.basePTS === null) {
      return;
    }
    return appendFrame$1(track, data, offset, this.basePTS, this.frameIndex);
  }
}

/**
 *  AAC helper
 */

class AAC {
  static getSilentFrame(codec, channelCount) {
    switch (codec) {
      case 'mp4a.40.2':
        if (channelCount === 1) {
          return new Uint8Array([0x00, 0xc8, 0x00, 0x80, 0x23, 0x80]);
        } else if (channelCount === 2) {
          return new Uint8Array([0x21, 0x00, 0x49, 0x90, 0x02, 0x19, 0x00, 0x23, 0x80]);
        } else if (channelCount === 3) {
          return new Uint8Array([0x00, 0xc8, 0x00, 0x80, 0x20, 0x84, 0x01, 0x26, 0x40, 0x08, 0x64, 0x00, 0x8e]);
        } else if (channelCount === 4) {
          return new Uint8Array([0x00, 0xc8, 0x00, 0x80, 0x20, 0x84, 0x01, 0x26, 0x40, 0x08, 0x64, 0x00, 0x80, 0x2c, 0x80, 0x08, 0x02, 0x38]);
        } else if (channelCount === 5) {
          return new Uint8Array([0x00, 0xc8, 0x00, 0x80, 0x20, 0x84, 0x01, 0x26, 0x40, 0x08, 0x64, 0x00, 0x82, 0x30, 0x04, 0x99, 0x00, 0x21, 0x90, 0x02, 0x38]);
        } else if (channelCount === 6) {
          return new Uint8Array([0x00, 0xc8, 0x00, 0x80, 0x20, 0x84, 0x01, 0x26, 0x40, 0x08, 0x64, 0x00, 0x82, 0x30, 0x04, 0x99, 0x00, 0x21, 0x90, 0x02, 0x00, 0xb2, 0x00, 0x20, 0x08, 0xe0]);
        }
        break;
      // handle HE-AAC below (mp4a.40.5 / mp4a.40.29)
      default:
        if (channelCount === 1) {
          // ffmpeg -y -f lavfi -i "aevalsrc=0:d=0.05" -c:a libfdk_aac -profile:a aac_he -b:a 4k output.aac && hexdump -v -e '16/1 "0x%x," "\n"' -v output.aac
          return new Uint8Array([0x1, 0x40, 0x22, 0x80, 0xa3, 0x4e, 0xe6, 0x80, 0xba, 0x8, 0x0, 0x0, 0x0, 0x1c, 0x6, 0xf1, 0xc1, 0xa, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5e]);
        } else if (channelCount === 2) {
          // ffmpeg -y -f lavfi -i "aevalsrc=0|0:d=0.05" -c:a libfdk_aac -profile:a aac_he_v2 -b:a 4k output.aac && hexdump -v -e '16/1 "0x%x," "\n"' -v output.aac
          return new Uint8Array([0x1, 0x40, 0x22, 0x80, 0xa3, 0x5e, 0xe6, 0x80, 0xba, 0x8, 0x0, 0x0, 0x0, 0x0, 0x95, 0x0, 0x6, 0xf1, 0xa1, 0xa, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5e]);
        } else if (channelCount === 3) {
          // ffmpeg -y -f lavfi -i "aevalsrc=0|0|0:d=0.05" -c:a libfdk_aac -profile:a aac_he_v2 -b:a 4k output.aac && hexdump -v -e '16/1 "0x%x," "\n"' -v output.aac
          return new Uint8Array([0x1, 0x40, 0x22, 0x80, 0xa3, 0x5e, 0xe6, 0x80, 0xba, 0x8, 0x0, 0x0, 0x0, 0x0, 0x95, 0x0, 0x6, 0xf1, 0xa1, 0xa, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5e]);
        }
        break;
    }
    return undefined;
  }
}

/**
 * Generate MP4 Box
 */

const UINT32_MAX = Math.pow(2, 32) - 1;
class MP4 {
  static init() {
    MP4.types = {
      avc1: [],
      // codingname
      avcC: [],
      btrt: [],
      dinf: [],
      dref: [],
      esds: [],
      ftyp: [],
      hdlr: [],
      mdat: [],
      mdhd: [],
      mdia: [],
      mfhd: [],
      minf: [],
      moof: [],
      moov: [],
      mp4a: [],
      '.mp3': [],
      dac3: [],
      'ac-3': [],
      mvex: [],
      mvhd: [],
      pasp: [],
      sdtp: [],
      stbl: [],
      stco: [],
      stsc: [],
      stsd: [],
      stsz: [],
      stts: [],
      tfdt: [],
      tfhd: [],
      traf: [],
      trak: [],
      trun: [],
      trex: [],
      tkhd: [],
      vmhd: [],
      smhd: []
    };
    let i;
    for (i in MP4.types) {
      if (MP4.types.hasOwnProperty(i)) {
        MP4.types[i] = [i.charCodeAt(0), i.charCodeAt(1), i.charCodeAt(2), i.charCodeAt(3)];
      }
    }
    const videoHdlr = new Uint8Array([0x00,
    // version 0
    0x00, 0x00, 0x00,
    // flags
    0x00, 0x00, 0x00, 0x00,
    // pre_defined
    0x76, 0x69, 0x64, 0x65,
    // handler_type: 'vide'
    0x00, 0x00, 0x00, 0x00,
    // reserved
    0x00, 0x00, 0x00, 0x00,
    // reserved
    0x00, 0x00, 0x00, 0x00,
    // reserved
    0x56, 0x69, 0x64, 0x65, 0x6f, 0x48, 0x61, 0x6e, 0x64, 0x6c, 0x65, 0x72, 0x00 // name: 'VideoHandler'
    ]);
    const audioHdlr = new Uint8Array([0x00,
    // version 0
    0x00, 0x00, 0x00,
    // flags
    0x00, 0x00, 0x00, 0x00,
    // pre_defined
    0x73, 0x6f, 0x75, 0x6e,
    // handler_type: 'soun'
    0x00, 0x00, 0x00, 0x00,
    // reserved
    0x00, 0x00, 0x00, 0x00,
    // reserved
    0x00, 0x00, 0x00, 0x00,
    // reserved
    0x53, 0x6f, 0x75, 0x6e, 0x64, 0x48, 0x61, 0x6e, 0x64, 0x6c, 0x65, 0x72, 0x00 // name: 'SoundHandler'
    ]);
    MP4.HDLR_TYPES = {
      video: videoHdlr,
      audio: audioHdlr
    };
    const dref = new Uint8Array([0x00,
    // version 0
    0x00, 0x00, 0x00,
    // flags
    0x00, 0x00, 0x00, 0x01,
    // entry_count
    0x00, 0x00, 0x00, 0x0c,
    // entry_size
    0x75, 0x72, 0x6c, 0x20,
    // 'url' type
    0x00,
    // version 0
    0x00, 0x00, 0x01 // entry_flags
    ]);
    const stco = new Uint8Array([0x00,
    // version
    0x00, 0x00, 0x00,
    // flags
    0x00, 0x00, 0x00, 0x00 // entry_count
    ]);
    MP4.STTS = MP4.STSC = MP4.STCO = stco;
    MP4.STSZ = new Uint8Array([0x00,
    // version
    0x00, 0x00, 0x00,
    // flags
    0x00, 0x00, 0x00, 0x00,
    // sample_size
    0x00, 0x00, 0x00, 0x00 // sample_count
    ]);
    MP4.VMHD = new Uint8Array([0x00,
    // version
    0x00, 0x00, 0x01,
    // flags
    0x00, 0x00,
    // graphicsmode
    0x00, 0x00, 0x00, 0x00, 0x00, 0x00 // opcolor
    ]);
    MP4.SMHD = new Uint8Array([0x00,
    // version
    0x00, 0x00, 0x00,
    // flags
    0x00, 0x00,
    // balance
    0x00, 0x00 // reserved
    ]);
    MP4.STSD = new Uint8Array([0x00,
    // version 0
    0x00, 0x00, 0x00,
    // flags
    0x00, 0x00, 0x00, 0x01]); // entry_count

    const majorBrand = new Uint8Array([105, 115, 111, 109]); // isom
    const avc1Brand = new Uint8Array([97, 118, 99, 49]); // avc1
    const minorVersion = new Uint8Array([0, 0, 0, 1]);
    MP4.FTYP = MP4.box(MP4.types.ftyp, majorBrand, minorVersion, majorBrand, avc1Brand);
    MP4.DINF = MP4.box(MP4.types.dinf, MP4.box(MP4.types.dref, dref));
  }
  static box(type, ...payload) {
    let size = 8;
    let i = payload.length;
    const len = i;
    // calculate the total size we need to allocate
    while (i--) {
      size += payload[i].byteLength;
    }
    const result = new Uint8Array(size);
    result[0] = size >> 24 & 0xff;
    result[1] = size >> 16 & 0xff;
    result[2] = size >> 8 & 0xff;
    result[3] = size & 0xff;
    result.set(type, 4);
    // copy the payload into the result
    for (i = 0, size = 8; i < len; i++) {
      // copy payload[i] array @ offset size
      result.set(payload[i], size);
      size += payload[i].byteLength;
    }
    return result;
  }
  static hdlr(type) {
    return MP4.box(MP4.types.hdlr, MP4.HDLR_TYPES[type]);
  }
  static mdat(data) {
    return MP4.box(MP4.types.mdat, data);
  }
  static mdhd(timescale, duration) {
    duration *= timescale;
    const upperWordDuration = Math.floor(duration / (UINT32_MAX + 1));
    const lowerWordDuration = Math.floor(duration % (UINT32_MAX + 1));
    return MP4.box(MP4.types.mdhd, new Uint8Array([0x01,
    // version 1
    0x00, 0x00, 0x00,
    // flags
    0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x02,
    // creation_time
    0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x03,
    // modification_time
    timescale >> 24 & 0xff, timescale >> 16 & 0xff, timescale >> 8 & 0xff, timescale & 0xff,
    // timescale
    upperWordDuration >> 24, upperWordDuration >> 16 & 0xff, upperWordDuration >> 8 & 0xff, upperWordDuration & 0xff, lowerWordDuration >> 24, lowerWordDuration >> 16 & 0xff, lowerWordDuration >> 8 & 0xff, lowerWordDuration & 0xff, 0x55, 0xc4,
    // 'und' language (undetermined)
    0x00, 0x00]));
  }
  static mdia(track) {
    return MP4.box(MP4.types.mdia, MP4.mdhd(track.timescale, track.duration), MP4.hdlr(track.type), MP4.minf(track));
  }
  static mfhd(sequenceNumber) {
    return MP4.box(MP4.types.mfhd, new Uint8Array([0x00, 0x00, 0x00, 0x00,
    // flags
    sequenceNumber >> 24, sequenceNumber >> 16 & 0xff, sequenceNumber >> 8 & 0xff, sequenceNumber & 0xff // sequence_number
    ]));
  }
  static minf(track) {
    if (track.type === 'audio') {
      return MP4.box(MP4.types.minf, MP4.box(MP4.types.smhd, MP4.SMHD), MP4.DINF, MP4.stbl(track));
    } else {
      return MP4.box(MP4.types.minf, MP4.box(MP4.types.vmhd, MP4.VMHD), MP4.DINF, MP4.stbl(track));
    }
  }
  static moof(sn, baseMediaDecodeTime, track) {
    return MP4.box(MP4.types.moof, MP4.mfhd(sn), MP4.traf(track, baseMediaDecodeTime));
  }
  static moov(tracks) {
    let i = tracks.length;
    const boxes = [];
    while (i--) {
      boxes[i] = MP4.trak(tracks[i]);
    }
    return MP4.box.apply(null, [MP4.types.moov, MP4.mvhd(tracks[0].timescale, tracks[0].duration)].concat(boxes).concat(MP4.mvex(tracks)));
  }
  static mvex(tracks) {
    let i = tracks.length;
    const boxes = [];
    while (i--) {
      boxes[i] = MP4.trex(tracks[i]);
    }
    return MP4.box.apply(null, [MP4.types.mvex, ...boxes]);
  }
  static mvhd(timescale, duration) {
    duration *= timescale;
    const upperWordDuration = Math.floor(duration / (UINT32_MAX + 1));
    const lowerWordDuration = Math.floor(duration % (UINT32_MAX + 1));
    const bytes = new Uint8Array([0x01,
    // version 1
    0x00, 0x00, 0x00,
    // flags
    0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x02,
    // creation_time
    0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x03,
    // modification_time
    timescale >> 24 & 0xff, timescale >> 16 & 0xff, timescale >> 8 & 0xff, timescale & 0xff,
    // timescale
    upperWordDuration >> 24, upperWordDuration >> 16 & 0xff, upperWordDuration >> 8 & 0xff, upperWordDuration & 0xff, lowerWordDuration >> 24, lowerWordDuration >> 16 & 0xff, lowerWordDuration >> 8 & 0xff, lowerWordDuration & 0xff, 0x00, 0x01, 0x00, 0x00,
    // 1.0 rate
    0x01, 0x00,
    // 1.0 volume
    0x00, 0x00,
    // reserved
    0x00, 0x00, 0x00, 0x00,
    // reserved
    0x00, 0x00, 0x00, 0x00,
    // reserved
    0x00, 0x01, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x01, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x40, 0x00, 0x00, 0x00,
    // transformation: unity matrix
    0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00,
    // pre_defined
    0xff, 0xff, 0xff, 0xff // next_track_ID
    ]);
    return MP4.box(MP4.types.mvhd, bytes);
  }
  static sdtp(track) {
    const samples = track.samples || [];
    const bytes = new Uint8Array(4 + samples.length);
    let i;
    let flags;
    // leave the full box header (4 bytes) all zero
    // write the sample table
    for (i = 0; i < samples.length; i++) {
      flags = samples[i].flags;
      bytes[i + 4] = flags.dependsOn << 4 | flags.isDependedOn << 2 | flags.hasRedundancy;
    }
    return MP4.box(MP4.types.sdtp, bytes);
  }
  static stbl(track) {
    return MP4.box(MP4.types.stbl, MP4.stsd(track), MP4.box(MP4.types.stts, MP4.STTS), MP4.box(MP4.types.stsc, MP4.STSC), MP4.box(MP4.types.stsz, MP4.STSZ), MP4.box(MP4.types.stco, MP4.STCO));
  }
  static avc1(track) {
    let sps = [];
    let pps = [];
    let i;
    let data;
    let len;
    // assemble the SPSs

    for (i = 0; i < track.sps.length; i++) {
      data = track.sps[i];
      len = data.byteLength;
      sps.push(len >>> 8 & 0xff);
      sps.push(len & 0xff);

      // SPS
      sps = sps.concat(Array.prototype.slice.call(data));
    }

    // assemble the PPSs
    for (i = 0; i < track.pps.length; i++) {
      data = track.pps[i];
      len = data.byteLength;
      pps.push(len >>> 8 & 0xff);
      pps.push(len & 0xff);
      pps = pps.concat(Array.prototype.slice.call(data));
    }
    const avcc = MP4.box(MP4.types.avcC, new Uint8Array([0x01,
    // version
    sps[3],
    // profile
    sps[4],
    // profile compat
    sps[5],
    // level
    0xfc | 3,
    // lengthSizeMinusOne, hard-coded to 4 bytes
    0xe0 | track.sps.length // 3bit reserved (111) + numOfSequenceParameterSets
    ].concat(sps).concat([track.pps.length // numOfPictureParameterSets
    ]).concat(pps))); // "PPS"
    const width = track.width;
    const height = track.height;
    const hSpacing = track.pixelRatio[0];
    const vSpacing = track.pixelRatio[1];
    return MP4.box(MP4.types.avc1, new Uint8Array([0x00, 0x00, 0x00,
    // reserved
    0x00, 0x00, 0x00,
    // reserved
    0x00, 0x01,
    // data_reference_index
    0x00, 0x00,
    // pre_defined
    0x00, 0x00,
    // reserved
    0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00,
    // pre_defined
    width >> 8 & 0xff, width & 0xff,
    // width
    height >> 8 & 0xff, height & 0xff,
    // height
    0x00, 0x48, 0x00, 0x00,
    // horizresolution
    0x00, 0x48, 0x00, 0x00,
    // vertresolution
    0x00, 0x00, 0x00, 0x00,
    // reserved
    0x00, 0x01,
    // frame_count
    0x12, 0x64, 0x61, 0x69, 0x6c,
    // dailymotion/hls.js
    0x79, 0x6d, 0x6f, 0x74, 0x69, 0x6f, 0x6e, 0x2f, 0x68, 0x6c, 0x73, 0x2e, 0x6a, 0x73, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00,
    // compressorname
    0x00, 0x18,
    // depth = 24
    0x11, 0x11]),
    // pre_defined = -1
    avcc, MP4.box(MP4.types.btrt, new Uint8Array([0x00, 0x1c, 0x9c, 0x80,
    // bufferSizeDB
    0x00, 0x2d, 0xc6, 0xc0,
    // maxBitrate
    0x00, 0x2d, 0xc6, 0xc0])),
    // avgBitrate
    MP4.box(MP4.types.pasp, new Uint8Array([hSpacing >> 24,
    // hSpacing
    hSpacing >> 16 & 0xff, hSpacing >> 8 & 0xff, hSpacing & 0xff, vSpacing >> 24,
    // vSpacing
    vSpacing >> 16 & 0xff, vSpacing >> 8 & 0xff, vSpacing & 0xff])));
  }
  static esds(track) {
    const configlen = track.config.length;
    return new Uint8Array([0x00,
    // version 0
    0x00, 0x00, 0x00,
    // flags

    0x03,
    // descriptor_type
    0x17 + configlen,
    // length
    0x00, 0x01,
    // es_id
    0x00,
    // stream_priority

    0x04,
    // descriptor_type
    0x0f + configlen,
    // length
    0x40,
    // codec : mpeg4_audio
    0x15,
    // stream_type
    0x00, 0x00, 0x00,
    // buffer_size
    0x00, 0x00, 0x00, 0x00,
    // maxBitrate
    0x00, 0x00, 0x00, 0x00,
    // avgBitrate

    0x05 // descriptor_type
    ].concat([configlen]).concat(track.config).concat([0x06, 0x01, 0x02])); // GASpecificConfig)); // length + audio config descriptor
  }
  static audioStsd(track) {
    const samplerate = track.samplerate;
    return new Uint8Array([0x00, 0x00, 0x00,
    // reserved
    0x00, 0x00, 0x00,
    // reserved
    0x00, 0x01,
    // data_reference_index
    0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00,
    // reserved
    0x00, track.channelCount,
    // channelcount
    0x00, 0x10,
    // sampleSize:16bits
    0x00, 0x00, 0x00, 0x00,
    // reserved2
    samplerate >> 8 & 0xff, samplerate & 0xff,
    //
    0x00, 0x00]);
  }
  static mp4a(track) {
    return MP4.box(MP4.types.mp4a, MP4.audioStsd(track), MP4.box(MP4.types.esds, MP4.esds(track)));
  }
  static mp3(track) {
    return MP4.box(MP4.types['.mp3'], MP4.audioStsd(track));
  }
  static ac3(track) {
    return MP4.box(MP4.types['ac-3'], MP4.audioStsd(track), MP4.box(MP4.types.dac3, track.config));
  }
  static stsd(track) {
    if (track.type === 'audio') {
      if (track.segmentCodec === 'mp3' && track.codec === 'mp3') {
        return MP4.box(MP4.types.stsd, MP4.STSD, MP4.mp3(track));
      }
      if (track.segmentCodec === 'ac3') {
        return MP4.box(MP4.types.stsd, MP4.STSD, MP4.ac3(track));
      }
      return MP4.box(MP4.types.stsd, MP4.STSD, MP4.mp4a(track));
    } else {
      return MP4.box(MP4.types.stsd, MP4.STSD, MP4.avc1(track));
    }
  }
  static tkhd(track) {
    const id = track.id;
    const duration = track.duration * track.timescale;
    const width = track.width;
    const height = track.height;
    const upperWordDuration = Math.floor(duration / (UINT32_MAX + 1));
    const lowerWordDuration = Math.floor(duration % (UINT32_MAX + 1));
    return MP4.box(MP4.types.tkhd, new Uint8Array([0x01,
    // version 1
    0x00, 0x00, 0x07,
    // flags
    0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x02,
    // creation_time
    0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x03,
    // modification_time
    id >> 24 & 0xff, id >> 16 & 0xff, id >> 8 & 0xff, id & 0xff,
    // track_ID
    0x00, 0x00, 0x00, 0x00,
    // reserved
    upperWordDuration >> 24, upperWordDuration >> 16 & 0xff, upperWordDuration >> 8 & 0xff, upperWordDuration & 0xff, lowerWordDuration >> 24, lowerWordDuration >> 16 & 0xff, lowerWordDuration >> 8 & 0xff, lowerWordDuration & 0xff, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00,
    // reserved
    0x00, 0x00,
    // layer
    0x00, 0x00,
    // alternate_group
    0x00, 0x00,
    // non-audio track volume
    0x00, 0x00,
    // reserved
    0x00, 0x01, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x01, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x40, 0x00, 0x00, 0x00,
    // transformation: unity matrix
    width >> 8 & 0xff, width & 0xff, 0x00, 0x00,
    // width
    height >> 8 & 0xff, height & 0xff, 0x00, 0x00 // height
    ]));
  }
  static traf(track, baseMediaDecodeTime) {
    const sampleDependencyTable = MP4.sdtp(track);
    const id = track.id;
    const upperWordBaseMediaDecodeTime = Math.floor(baseMediaDecodeTime / (UINT32_MAX + 1));
    const lowerWordBaseMediaDecodeTime = Math.floor(baseMediaDecodeTime % (UINT32_MAX + 1));
    return MP4.box(MP4.types.traf, MP4.box(MP4.types.tfhd, new Uint8Array([0x00,
    // version 0
    0x00, 0x00, 0x00,
    // flags
    id >> 24, id >> 16 & 0xff, id >> 8 & 0xff, id & 0xff // track_ID
    ])), MP4.box(MP4.types.tfdt, new Uint8Array([0x01,
    // version 1
    0x00, 0x00, 0x00,
    // flags
    upperWordBaseMediaDecodeTime >> 24, upperWordBaseMediaDecodeTime >> 16 & 0xff, upperWordBaseMediaDecodeTime >> 8 & 0xff, upperWordBaseMediaDecodeTime & 0xff, lowerWordBaseMediaDecodeTime >> 24, lowerWordBaseMediaDecodeTime >> 16 & 0xff, lowerWordBaseMediaDecodeTime >> 8 & 0xff, lowerWordBaseMediaDecodeTime & 0xff])), MP4.trun(track, sampleDependencyTable.length + 16 +
    // tfhd
    20 +
    // tfdt
    8 +
    // traf header
    16 +
    // mfhd
    8 +
    // moof header
    8),
    // mdat header
    sampleDependencyTable);
  }

  /**
   * Generate a track box.
   * @param track a track definition
   */
  static trak(track) {
    track.duration = track.duration || 0xffffffff;
    return MP4.box(MP4.types.trak, MP4.tkhd(track), MP4.mdia(track));
  }
  static trex(track) {
    const id = track.id;
    return MP4.box(MP4.types.trex, new Uint8Array([0x00,
    // version 0
    0x00, 0x00, 0x00,
    // flags
    id >> 24, id >> 16 & 0xff, id >> 8 & 0xff, id & 0xff,
    // track_ID
    0x00, 0x00, 0x00, 0x01,
    // default_sample_description_index
    0x00, 0x00, 0x00, 0x00,
    // default_sample_duration
    0x00, 0x00, 0x00, 0x00,
    // default_sample_size
    0x00, 0x01, 0x00, 0x01 // default_sample_flags
    ]));
  }
  static trun(track, offset) {
    const samples = track.samples || [];
    const len = samples.length;
    const arraylen = 12 + 16 * len;
    const array = new Uint8Array(arraylen);
    let i;
    let sample;
    let duration;
    let size;
    let flags;
    let cts;
    offset += 8 + arraylen;
    array.set([track.type === 'video' ? 0x01 : 0x00,
    // version 1 for video with signed-int sample_composition_time_offset
    0x00, 0x0f, 0x01,
    // flags
    len >>> 24 & 0xff, len >>> 16 & 0xff, len >>> 8 & 0xff, len & 0xff,
    // sample_count
    offset >>> 24 & 0xff, offset >>> 16 & 0xff, offset >>> 8 & 0xff, offset & 0xff // data_offset
    ], 0);
    for (i = 0; i < len; i++) {
      sample = samples[i];
      duration = sample.duration;
      size = sample.size;
      flags = sample.flags;
      cts = sample.cts;
      array.set([duration >>> 24 & 0xff, duration >>> 16 & 0xff, duration >>> 8 & 0xff, duration & 0xff,
      // sample_duration
      size >>> 24 & 0xff, size >>> 16 & 0xff, size >>> 8 & 0xff, size & 0xff,
      // sample_size
      flags.isLeading << 2 | flags.dependsOn, flags.isDependedOn << 6 | flags.hasRedundancy << 4 | flags.paddingValue << 1 | flags.isNonSync, flags.degradPrio & 0xf0 << 8, flags.degradPrio & 0x0f,
      // sample_flags
      cts >>> 24 & 0xff, cts >>> 16 & 0xff, cts >>> 8 & 0xff, cts & 0xff // sample_composition_time_offset
      ], 12 + 16 * i);
    }
    return MP4.box(MP4.types.trun, array);
  }
  static initSegment(tracks) {
    if (!MP4.types) {
      MP4.init();
    }
    const movie = MP4.moov(tracks);
    const result = appendUint8Array(MP4.FTYP, movie);
    return result;
  }
}
MP4.types = void 0;
MP4.HDLR_TYPES = void 0;
MP4.STTS = void 0;
MP4.STSC = void 0;
MP4.STCO = void 0;
MP4.STSZ = void 0;
MP4.VMHD = void 0;
MP4.SMHD = void 0;
MP4.STSD = void 0;
MP4.FTYP = void 0;
MP4.DINF = void 0;

const MPEG_TS_CLOCK_FREQ_HZ = 90000;
function toTimescaleFromBase(baseTime, destScale, srcBase = 1, round = false) {
  const result = baseTime * destScale * srcBase; // equivalent to `(value * scale) / (1 / base)`
  return round ? Math.round(result) : result;
}
function toTimescaleFromScale(baseTime, destScale, srcScale = 1, round = false) {
  return toTimescaleFromBase(baseTime, destScale, 1 / srcScale, round);
}
function toMsFromMpegTsClock(baseTime, round = false) {
  return toTimescaleFromBase(baseTime, 1000, 1 / MPEG_TS_CLOCK_FREQ_HZ, round);
}
function toMpegTsClockFromTimescale(baseTime, srcScale = 1) {
  return toTimescaleFromBase(baseTime, MPEG_TS_CLOCK_FREQ_HZ, 1 / srcScale);
}

const MAX_SILENT_FRAME_DURATION = 10 * 1000; // 10 seconds
const AAC_SAMPLES_PER_FRAME = 1024;
const MPEG_AUDIO_SAMPLE_PER_FRAME = 1152;
const AC3_SAMPLES_PER_FRAME = 1536;
let chromeVersion = null;
let safariWebkitVersion = null;
class MP4Remuxer {
  constructor(observer, config, typeSupported, vendor = '') {
    this.observer = void 0;
    this.config = void 0;
    this.typeSupported = void 0;
    this.ISGenerated = false;
    this._initPTS = null;
    this._initDTS = null;
    this.nextAvcDts = null;
    this.nextAudioPts = null;
    this.videoSampleDuration = null;
    this.isAudioContiguous = false;
    this.isVideoContiguous = false;
    this.videoTrackConfig = void 0;
    this.observer = observer;
    this.config = config;
    this.typeSupported = typeSupported;
    this.ISGenerated = false;
    if (chromeVersion === null) {
      const userAgent = navigator.userAgent || '';
      const result = userAgent.match(/Chrome\/(\d+)/i);
      chromeVersion = result ? parseInt(result[1]) : 0;
    }
    if (safariWebkitVersion === null) {
      const result = navigator.userAgent.match(/Safari\/(\d+)/i);
      safariWebkitVersion = result ? parseInt(result[1]) : 0;
    }
  }
  destroy() {
    // @ts-ignore
    this.config = this.videoTrackConfig = this._initPTS = this._initDTS = null;
  }
  resetTimeStamp(defaultTimeStamp) {
    logger.log('[mp4-remuxer]: initPTS & initDTS reset');
    this._initPTS = this._initDTS = defaultTimeStamp;
  }
  resetNextTimestamp() {
    logger.log('[mp4-remuxer]: reset next timestamp');
    this.isVideoContiguous = false;
    this.isAudioContiguous = false;
  }
  resetInitSegment() {
    logger.log('[mp4-remuxer]: ISGenerated flag reset');
    this.ISGenerated = false;
    this.videoTrackConfig = undefined;
  }
  getVideoStartPts(videoSamples) {
    let rolloverDetected = false;
    const startPTS = videoSamples.reduce((minPTS, sample) => {
      const delta = sample.pts - minPTS;
      if (delta < -4294967296) {
        // 2^32, see PTSNormalize for reasoning, but we're hitting a rollover here, and we don't want that to impact the timeOffset calculation
        rolloverDetected = true;
        return normalizePts(minPTS, sample.pts);
      } else if (delta > 0) {
        return minPTS;
      } else {
        return sample.pts;
      }
    }, videoSamples[0].pts);
    if (rolloverDetected) {
      logger.debug('PTS rollover detected');
    }
    return startPTS;
  }
  remux(audioTrack, videoTrack, id3Track, textTrack, timeOffset, accurateTimeOffset, flush, playlistType) {
    let video;
    let audio;
    let initSegment;
    let text;
    let id3;
    let independent;
    let audioTimeOffset = timeOffset;
    let videoTimeOffset = timeOffset;

    // If we're remuxing audio and video progressively, wait until we've received enough samples for each track before proceeding.
    // This is done to synchronize the audio and video streams. We know if the current segment will have samples if the "pid"
    // parameter is greater than -1. The pid is set when the PMT is parsed, which contains the tracks list.
    // However, if the initSegment has already been generated, or we've reached the end of a segment (flush),
    // then we can remux one track without waiting for the other.
    const hasAudio = audioTrack.pid > -1;
    const hasVideo = videoTrack.pid > -1;
    const length = videoTrack.samples.length;
    const enoughAudioSamples = audioTrack.samples.length > 0;
    const enoughVideoSamples = flush && length > 0 || length > 1;
    const canRemuxAvc = (!hasAudio || enoughAudioSamples) && (!hasVideo || enoughVideoSamples) || this.ISGenerated || flush;
    if (canRemuxAvc) {
      if (this.ISGenerated) {
        var _videoTrack$pixelRati, _config$pixelRatio, _videoTrack$pixelRati2, _config$pixelRatio2;
        const config = this.videoTrackConfig;
        if (config && (videoTrack.width !== config.width || videoTrack.height !== config.height || ((_videoTrack$pixelRati = videoTrack.pixelRatio) == null ? void 0 : _videoTrack$pixelRati[0]) !== ((_config$pixelRatio = config.pixelRatio) == null ? void 0 : _config$pixelRatio[0]) || ((_videoTrack$pixelRati2 = videoTrack.pixelRatio) == null ? void 0 : _videoTrack$pixelRati2[1]) !== ((_config$pixelRatio2 = config.pixelRatio) == null ? void 0 : _config$pixelRatio2[1]))) {
          this.resetInitSegment();
        }
      } else {
        initSegment = this.generateIS(audioTrack, videoTrack, timeOffset, accurateTimeOffset);
      }
      const isVideoContiguous = this.isVideoContiguous;
      let firstKeyFrameIndex = -1;
      let firstKeyFramePTS;
      if (enoughVideoSamples) {
        firstKeyFrameIndex = findKeyframeIndex(videoTrack.samples);
        if (!isVideoContiguous && this.config.forceKeyFrameOnDiscontinuity) {
          independent = true;
          if (firstKeyFrameIndex > 0) {
            logger.warn(`[mp4-remuxer]: Dropped ${firstKeyFrameIndex} out of ${length} video samples due to a missing keyframe`);
            const startPTS = this.getVideoStartPts(videoTrack.samples);
            videoTrack.samples = videoTrack.samples.slice(firstKeyFrameIndex);
            videoTrack.dropped += firstKeyFrameIndex;
            videoTimeOffset += (videoTrack.samples[0].pts - startPTS) / videoTrack.inputTimeScale;
            firstKeyFramePTS = videoTimeOffset;
          } else if (firstKeyFrameIndex === -1) {
            logger.warn(`[mp4-remuxer]: No keyframe found out of ${length} video samples`);
            independent = false;
          }
        }
      }
      if (this.ISGenerated) {
        if (enoughAudioSamples && enoughVideoSamples) {
          // timeOffset is expected to be the offset of the first timestamp of this fragment (first DTS)
          // if first audio DTS is not aligned with first video DTS then we need to take that into account
          // when providing timeOffset to remuxAudio / remuxVideo. if we don't do that, there might be a permanent / small
          // drift between audio and video streams
          const startPTS = this.getVideoStartPts(videoTrack.samples);
          const tsDelta = normalizePts(audioTrack.samples[0].pts, startPTS) - startPTS;
          const audiovideoTimestampDelta = tsDelta / videoTrack.inputTimeScale;
          audioTimeOffset += Math.max(0, audiovideoTimestampDelta);
          videoTimeOffset += Math.max(0, -audiovideoTimestampDelta);
        }

        // Purposefully remuxing audio before video, so that remuxVideo can use nextAudioPts, which is calculated in remuxAudio.
        if (enoughAudioSamples) {
          // if initSegment was generated without audio samples, regenerate it again
          if (!audioTrack.samplerate) {
            logger.warn('[mp4-remuxer]: regenerate InitSegment as audio detected');
            initSegment = this.generateIS(audioTrack, videoTrack, timeOffset, accurateTimeOffset);
          }
          audio = this.remuxAudio(audioTrack, audioTimeOffset, this.isAudioContiguous, accurateTimeOffset, hasVideo || enoughVideoSamples || playlistType === PlaylistLevelType.AUDIO ? videoTimeOffset : undefined);
          if (enoughVideoSamples) {
            const audioTrackLength = audio ? audio.endPTS - audio.startPTS : 0;
            // if initSegment was generated without video samples, regenerate it again
            if (!videoTrack.inputTimeScale) {
              logger.warn('[mp4-remuxer]: regenerate InitSegment as video detected');
              initSegment = this.generateIS(audioTrack, videoTrack, timeOffset, accurateTimeOffset);
            }
            video = this.remuxVideo(videoTrack, videoTimeOffset, isVideoContiguous, audioTrackLength);
          }
        } else if (enoughVideoSamples) {
          video = this.remuxVideo(videoTrack, videoTimeOffset, isVideoContiguous, 0);
        }
        if (video) {
          video.firstKeyFrame = firstKeyFrameIndex;
          video.independent = firstKeyFrameIndex !== -1;
          video.firstKeyFramePTS = firstKeyFramePTS;
        }
      }
    }

    // Allow ID3 and text to remux, even if more audio/video samples are required
    if (this.ISGenerated && this._initPTS && this._initDTS) {
      if (id3Track.samples.length) {
        id3 = flushTextTrackMetadataCueSamples(id3Track, timeOffset, this._initPTS, this._initDTS);
      }
      if (textTrack.samples.length) {
        text = flushTextTrackUserdataCueSamples(textTrack, timeOffset, this._initPTS);
      }
    }
    return {
      audio,
      video,
      initSegment,
      independent,
      text,
      id3
    };
  }
  generateIS(audioTrack, videoTrack, timeOffset, accurateTimeOffset) {
    const audioSamples = audioTrack.samples;
    const videoSamples = videoTrack.samples;
    const typeSupported = this.typeSupported;
    const tracks = {};
    const _initPTS = this._initPTS;
    let computePTSDTS = !_initPTS || accurateTimeOffset;
    let container = 'audio/mp4';
    let initPTS;
    let initDTS;
    let timescale;
    if (computePTSDTS) {
      initPTS = initDTS = Infinity;
    }
    if (audioTrack.config && audioSamples.length) {
      // let's use audio sampling rate as MP4 time scale.
      // rationale is that there is a integer nb of audio frames per audio sample (1024 for AAC)
      // using audio sampling rate here helps having an integer MP4 frame duration
      // this avoids potential rounding issue and AV sync issue
      audioTrack.timescale = audioTrack.samplerate;
      switch (audioTrack.segmentCodec) {
        case 'mp3':
          if (typeSupported.mpeg) {
            // Chrome and Safari
            container = 'audio/mpeg';
            audioTrack.codec = '';
          } else if (typeSupported.mp3) {
            // Firefox
            audioTrack.codec = 'mp3';
          }
          break;
        case 'ac3':
          audioTrack.codec = 'ac-3';
          break;
      }
      tracks.audio = {
        id: 'audio',
        container: container,
        codec: audioTrack.codec,
        initSegment: audioTrack.segmentCodec === 'mp3' && typeSupported.mpeg ? new Uint8Array(0) : MP4.initSegment([audioTrack]),
        metadata: {
          channelCount: audioTrack.channelCount
        }
      };
      if (computePTSDTS) {
        timescale = audioTrack.inputTimeScale;
        if (!_initPTS || timescale !== _initPTS.timescale) {
          // remember first PTS of this demuxing context. for audio, PTS = DTS
          initPTS = initDTS = audioSamples[0].pts - Math.round(timescale * timeOffset);
        } else {
          computePTSDTS = false;
        }
      }
    }
    if (videoTrack.sps && videoTrack.pps && videoSamples.length) {
      // let's use input time scale as MP4 video timescale
      // we use input time scale straight away to avoid rounding issues on frame duration / cts computation
      videoTrack.timescale = videoTrack.inputTimeScale;
      tracks.video = {
        id: 'main',
        container: 'video/mp4',
        codec: videoTrack.codec,
        initSegment: MP4.initSegment([videoTrack]),
        metadata: {
          width: videoTrack.width,
          height: videoTrack.height
        }
      };
      if (computePTSDTS) {
        timescale = videoTrack.inputTimeScale;
        if (!_initPTS || timescale !== _initPTS.timescale) {
          const startPTS = this.getVideoStartPts(videoSamples);
          const startOffset = Math.round(timescale * timeOffset);
          initDTS = Math.min(initDTS, normalizePts(videoSamples[0].dts, startPTS) - startOffset);
          initPTS = Math.min(initPTS, startPTS - startOffset);
        } else {
          computePTSDTS = false;
        }
      }
      this.videoTrackConfig = {
        width: videoTrack.width,
        height: videoTrack.height,
        pixelRatio: videoTrack.pixelRatio
      };
    }
    if (Object.keys(tracks).length) {
      this.ISGenerated = true;
      if (computePTSDTS) {
        this._initPTS = {
          baseTime: initPTS,
          timescale: timescale
        };
        this._initDTS = {
          baseTime: initDTS,
          timescale: timescale
        };
      } else {
        initPTS = timescale = undefined;
      }
      return {
        tracks,
        initPTS,
        timescale
      };
    }
  }
  remuxVideo(track, timeOffset, contiguous, audioTrackLength) {
    const timeScale = track.inputTimeScale;
    const inputSamples = track.samples;
    const outputSamples = [];
    const nbSamples = inputSamples.length;
    const initPTS = this._initPTS;
    let nextAvcDts = this.nextAvcDts;
    let offset = 8;
    let mp4SampleDuration = this.videoSampleDuration;
    let firstDTS;
    let lastDTS;
    let minPTS = Number.POSITIVE_INFINITY;
    let maxPTS = Number.NEGATIVE_INFINITY;
    let sortSamples = false;

    // if parsed fragment is contiguous with last one, let's use last DTS value as reference
    if (!contiguous || nextAvcDts === null) {
      const pts = timeOffset * timeScale;
      const cts = inputSamples[0].pts - normalizePts(inputSamples[0].dts, inputSamples[0].pts);
      if (chromeVersion && nextAvcDts !== null && Math.abs(pts - cts - nextAvcDts) < 15000) {
        // treat as contigous to adjust samples that would otherwise produce video buffer gaps in Chrome
        contiguous = true;
      } else {
        // if not contiguous, let's use target timeOffset
        nextAvcDts = pts - cts;
      }
    }

    // PTS is coded on 33bits, and can loop from -2^32 to 2^32
    // PTSNormalize will make PTS/DTS value monotonic, we use last known DTS value as reference value
    const initTime = initPTS.baseTime * timeScale / initPTS.timescale;
    for (let i = 0; i < nbSamples; i++) {
      const sample = inputSamples[i];
      sample.pts = normalizePts(sample.pts - initTime, nextAvcDts);
      sample.dts = normalizePts(sample.dts - initTime, nextAvcDts);
      if (sample.dts < inputSamples[i > 0 ? i - 1 : i].dts) {
        sortSamples = true;
      }
    }

    // sort video samples by DTS then PTS then demux id order
    if (sortSamples) {
      inputSamples.sort(function (a, b) {
        const deltadts = a.dts - b.dts;
        const deltapts = a.pts - b.pts;
        return deltadts || deltapts;
      });
    }

    // Get first/last DTS
    firstDTS = inputSamples[0].dts;
    lastDTS = inputSamples[inputSamples.length - 1].dts;

    // Sample duration (as expected by trun MP4 boxes), should be the delta between sample DTS
    // set this constant duration as being the avg delta between consecutive DTS.
    const inputDuration = lastDTS - firstDTS;
    const averageSampleDuration = inputDuration ? Math.round(inputDuration / (nbSamples - 1)) : mp4SampleDuration || track.inputTimeScale / 30;

    // if fragment are contiguous, detect hole/overlapping between fragments
    if (contiguous) {
      // check timestamp continuity across consecutive fragments (this is to remove inter-fragment gap/hole)
      const delta = firstDTS - nextAvcDts;
      const foundHole = delta > averageSampleDuration;
      const foundOverlap = delta < -1;
      if (foundHole || foundOverlap) {
        if (foundHole) {
          logger.warn(`AVC: ${toMsFromMpegTsClock(delta, true)} ms (${delta}dts) hole between fragments detected at ${timeOffset.toFixed(3)}`);
        } else {
          logger.warn(`AVC: ${toMsFromMpegTsClock(-delta, true)} ms (${delta}dts) overlapping between fragments detected at ${timeOffset.toFixed(3)}`);
        }
        if (!foundOverlap || nextAvcDts >= inputSamples[0].pts || chromeVersion) {
          firstDTS = nextAvcDts;
          const firstPTS = inputSamples[0].pts - delta;
          if (foundHole) {
            inputSamples[0].dts = firstDTS;
            inputSamples[0].pts = firstPTS;
          } else {
            for (let i = 0; i < inputSamples.length; i++) {
              if (inputSamples[i].dts > firstPTS) {
                break;
              }
              inputSamples[i].dts -= delta;
              inputSamples[i].pts -= delta;
            }
          }
          logger.log(`Video: Initial PTS/DTS adjusted: ${toMsFromMpegTsClock(firstPTS, true)}/${toMsFromMpegTsClock(firstDTS, true)}, delta: ${toMsFromMpegTsClock(delta, true)} ms`);
        }
      }
    }
    firstDTS = Math.max(0, firstDTS);
    let nbNalu = 0;
    let naluLen = 0;
    let dtsStep = firstDTS;
    for (let i = 0; i < nbSamples; i++) {
      // compute total/avc sample length and nb of NAL units
      const sample = inputSamples[i];
      const units = sample.units;
      const nbUnits = units.length;
      let sampleLen = 0;
      for (let j = 0; j < nbUnits; j++) {
        sampleLen += units[j].data.length;
      }
      naluLen += sampleLen;
      nbNalu += nbUnits;
      sample.length = sampleLen;

      // ensure sample monotonic DTS
      if (sample.dts < dtsStep) {
        sample.dts = dtsStep;
        dtsStep += averageSampleDuration / 4 | 0 || 1;
      } else {
        dtsStep = sample.dts;
      }
      minPTS = Math.min(sample.pts, minPTS);
      maxPTS = Math.max(sample.pts, maxPTS);
    }
    lastDTS = inputSamples[nbSamples - 1].dts;

    /* concatenate the video data and construct the mdat in place
      (need 8 more bytes to fill length and mpdat type) */
    const mdatSize = naluLen + 4 * nbNalu + 8;
    let mdat;
    try {
      mdat = new Uint8Array(mdatSize);
    } catch (err) {
      this.observer.emit(Events.ERROR, Events.ERROR, {
        type: ErrorTypes.MUX_ERROR,
        details: ErrorDetails.REMUX_ALLOC_ERROR,
        fatal: false,
        error: err,
        bytes: mdatSize,
        reason: `fail allocating video mdat ${mdatSize}`
      });
      return;
    }
    const view = new DataView(mdat.buffer);
    view.setUint32(0, mdatSize);
    mdat.set(MP4.types.mdat, 4);
    let stretchedLastFrame = false;
    let minDtsDelta = Number.POSITIVE_INFINITY;
    let minPtsDelta = Number.POSITIVE_INFINITY;
    let maxDtsDelta = Number.NEGATIVE_INFINITY;
    let maxPtsDelta = Number.NEGATIVE_INFINITY;
    for (let i = 0; i < nbSamples; i++) {
      const VideoSample = inputSamples[i];
      const VideoSampleUnits = VideoSample.units;
      let mp4SampleLength = 0;
      // convert NALU bitstream to MP4 format (prepend NALU with size field)
      for (let j = 0, nbUnits = VideoSampleUnits.length; j < nbUnits; j++) {
        const unit = VideoSampleUnits[j];
        const unitData = unit.data;
        const unitDataLen = unit.data.byteLength;
        view.setUint32(offset, unitDataLen);
        offset += 4;
        mdat.set(unitData, offset);
        offset += unitDataLen;
        mp4SampleLength += 4 + unitDataLen;
      }

      // expected sample duration is the Decoding Timestamp diff of consecutive samples
      let ptsDelta;
      if (i < nbSamples - 1) {
        mp4SampleDuration = inputSamples[i + 1].dts - VideoSample.dts;
        ptsDelta = inputSamples[i + 1].pts - VideoSample.pts;
      } else {
        const config = this.config;
        const lastFrameDuration = i > 0 ? VideoSample.dts - inputSamples[i - 1].dts : averageSampleDuration;
        ptsDelta = i > 0 ? VideoSample.pts - inputSamples[i - 1].pts : averageSampleDuration;
        if (config.stretchShortVideoTrack && this.nextAudioPts !== null) {
          // In some cases, a segment's audio track duration may exceed the video track duration.
          // Since we've already remuxed audio, and we know how long the audio track is, we look to
          // see if the delta to the next segment is longer than maxBufferHole.
          // If so, playback would potentially get stuck, so we artificially inflate
          // the duration of the last frame to minimize any potential gap between segments.
          const gapTolerance = Math.floor(config.maxBufferHole * timeScale);
          const deltaToFrameEnd = (audioTrackLength ? minPTS + audioTrackLength * timeScale : this.nextAudioPts) - VideoSample.pts;
          if (deltaToFrameEnd > gapTolerance) {
            // We subtract lastFrameDuration from deltaToFrameEnd to try to prevent any video
            // frame overlap. maxBufferHole should be >> lastFrameDuration anyway.
            mp4SampleDuration = deltaToFrameEnd - lastFrameDuration;
            if (mp4SampleDuration < 0) {
              mp4SampleDuration = lastFrameDuration;
            } else {
              stretchedLastFrame = true;
            }
            logger.log(`[mp4-remuxer]: It is approximately ${deltaToFrameEnd / 90} ms to the next segment; using duration ${mp4SampleDuration / 90} ms for the last video frame.`);
          } else {
            mp4SampleDuration = lastFrameDuration;
          }
        } else {
          mp4SampleDuration = lastFrameDuration;
        }
      }
      const compositionTimeOffset = Math.round(VideoSample.pts - VideoSample.dts);
      minDtsDelta = Math.min(minDtsDelta, mp4SampleDuration);
      maxDtsDelta = Math.max(maxDtsDelta, mp4SampleDuration);
      minPtsDelta = Math.min(minPtsDelta, ptsDelta);
      maxPtsDelta = Math.max(maxPtsDelta, ptsDelta);
      outputSamples.push(new Mp4Sample(VideoSample.key, mp4SampleDuration, mp4SampleLength, compositionTimeOffset));
    }
    if (outputSamples.length) {
      if (chromeVersion) {
        if (chromeVersion < 70) {
          // Chrome workaround, mark first sample as being a Random Access Point (keyframe) to avoid sourcebuffer append issue
          // https://code.google.com/p/chromium/issues/detail?id=229412
          const flags = outputSamples[0].flags;
          flags.dependsOn = 2;
          flags.isNonSync = 0;
        }
      } else if (safariWebkitVersion) {
        // Fix for "CNN special report, with CC" in test-streams (Safari browser only)
        // Ignore DTS when frame durations are irregular. Safari MSE does not handle this leading to gaps.
        if (maxPtsDelta - minPtsDelta < maxDtsDelta - minDtsDelta && averageSampleDuration / maxDtsDelta < 0.025 && outputSamples[0].cts === 0) {
          logger.warn('Found irregular gaps in sample duration. Using PTS instead of DTS to determine MP4 sample duration.');
          let dts = firstDTS;
          for (let i = 0, len = outputSamples.length; i < len; i++) {
            const nextDts = dts + outputSamples[i].duration;
            const pts = dts + outputSamples[i].cts;
            if (i < len - 1) {
              const nextPts = nextDts + outputSamples[i + 1].cts;
              outputSamples[i].duration = nextPts - pts;
            } else {
              outputSamples[i].duration = i ? outputSamples[i - 1].duration : averageSampleDuration;
            }
            outputSamples[i].cts = 0;
            dts = nextDts;
          }
        }
      }
    }
    // next AVC sample DTS should be equal to last sample DTS + last sample duration (in PES timescale)
    mp4SampleDuration = stretchedLastFrame || !mp4SampleDuration ? averageSampleDuration : mp4SampleDuration;
    this.nextAvcDts = nextAvcDts = lastDTS + mp4SampleDuration;
    this.videoSampleDuration = mp4SampleDuration;
    this.isVideoContiguous = true;
    const moof = MP4.moof(track.sequenceNumber++, firstDTS, _extends({}, track, {
      samples: outputSamples
    }));
    const type = 'video';
    const data = {
      data1: moof,
      data2: mdat,
      startPTS: minPTS / timeScale,
      endPTS: (maxPTS + mp4SampleDuration) / timeScale,
      startDTS: firstDTS / timeScale,
      endDTS: nextAvcDts / timeScale,
      type,
      hasAudio: false,
      hasVideo: true,
      nb: outputSamples.length,
      dropped: track.dropped
    };
    track.samples = [];
    track.dropped = 0;
    return data;
  }
  getSamplesPerFrame(track) {
    switch (track.segmentCodec) {
      case 'mp3':
        return MPEG_AUDIO_SAMPLE_PER_FRAME;
      case 'ac3':
        return AC3_SAMPLES_PER_FRAME;
      default:
        return AAC_SAMPLES_PER_FRAME;
    }
  }
  remuxAudio(track, timeOffset, contiguous, accurateTimeOffset, videoTimeOffset) {
    const inputTimeScale = track.inputTimeScale;
    const mp4timeScale = track.samplerate ? track.samplerate : inputTimeScale;
    const scaleFactor = inputTimeScale / mp4timeScale;
    const mp4SampleDuration = this.getSamplesPerFrame(track);
    const inputSampleDuration = mp4SampleDuration * scaleFactor;
    const initPTS = this._initPTS;
    const rawMPEG = track.segmentCodec === 'mp3' && this.typeSupported.mpeg;
    const outputSamples = [];
    const alignedWithVideo = videoTimeOffset !== undefined;
    let inputSamples = track.samples;
    let offset = rawMPEG ? 0 : 8;
    let nextAudioPts = this.nextAudioPts || -1;

    // window.audioSamples ? window.audioSamples.push(inputSamples.map(s => s.pts)) : (window.audioSamples = [inputSamples.map(s => s.pts)]);

    // for audio samples, also consider consecutive fragments as being contiguous (even if a level switch occurs),
    // for sake of clarity:
    // consecutive fragments are frags with
    //  - less than 100ms gaps between new time offset (if accurate) and next expected PTS OR
    //  - less than 20 audio frames distance
    // contiguous fragments are consecutive fragments from same quality level (same level, new SN = old SN + 1)
    // this helps ensuring audio continuity
    // and this also avoids audio glitches/cut when switching quality, or reporting wrong duration on first audio frame
    const timeOffsetMpegTS = timeOffset * inputTimeScale;
    const initTime = initPTS.baseTime * inputTimeScale / initPTS.timescale;
    this.isAudioContiguous = contiguous = contiguous || inputSamples.length && nextAudioPts > 0 && (accurateTimeOffset && Math.abs(timeOffsetMpegTS - nextAudioPts) < 9000 || Math.abs(normalizePts(inputSamples[0].pts - initTime, timeOffsetMpegTS) - nextAudioPts) < 20 * inputSampleDuration);

    // compute normalized PTS
    inputSamples.forEach(function (sample) {
      sample.pts = normalizePts(sample.pts - initTime, timeOffsetMpegTS);
    });
    if (!contiguous || nextAudioPts < 0) {
      // filter out sample with negative PTS that are not playable anyway
      // if we don't remove these negative samples, they will shift all audio samples forward.
      // leading to audio overlap between current / next fragment
      inputSamples = inputSamples.filter(sample => sample.pts >= 0);

      // in case all samples have negative PTS, and have been filtered out, return now
      if (!inputSamples.length) {
        return;
      }
      if (videoTimeOffset === 0) {
        // Set the start to 0 to match video so that start gaps larger than inputSampleDuration are filled with silence
        nextAudioPts = 0;
      } else if (accurateTimeOffset && !alignedWithVideo) {
        // When not seeking, not live, and LevelDetails.PTSKnown, use fragment start as predicted next audio PTS
        nextAudioPts = Math.max(0, timeOffsetMpegTS);
      } else {
        // if frags are not contiguous and if we cant trust time offset, let's use first sample PTS as next audio PTS
        nextAudioPts = inputSamples[0].pts;
      }
    }

    // If the audio track is missing samples, the frames seem to get "left-shifted" within the
    // resulting mp4 segment, causing sync issues and leaving gaps at the end of the audio segment.
    // In an effort to prevent this from happening, we inject frames here where there are gaps.
    // When possible, we inject a silent frame; when that's not possible, we duplicate the last
    // frame.

    if (track.segmentCodec === 'aac') {
      const maxAudioFramesDrift = this.config.maxAudioFramesDrift;
      for (let i = 0, nextPts = nextAudioPts; i < inputSamples.length; i++) {
        // First, let's see how far off this frame is from where we expect it to be
        const sample = inputSamples[i];
        const pts = sample.pts;
        const delta = pts - nextPts;
        const duration = Math.abs(1000 * delta / inputTimeScale);

        // When remuxing with video, if we're overlapping by more than a duration, drop this sample to stay in sync
        if (delta <= -maxAudioFramesDrift * inputSampleDuration && alignedWithVideo) {
          if (i === 0) {
            logger.warn(`Audio frame @ ${(pts / inputTimeScale).toFixed(3)}s overlaps nextAudioPts by ${Math.round(1000 * delta / inputTimeScale)} ms.`);
            this.nextAudioPts = nextAudioPts = nextPts = pts;
          }
        } // eslint-disable-line brace-style

        // Insert missing frames if:
        // 1: We're more than maxAudioFramesDrift frame away
        // 2: Not more than MAX_SILENT_FRAME_DURATION away
        // 3: currentTime (aka nextPtsNorm) is not 0
        // 4: remuxing with video (videoTimeOffset !== undefined)
        else if (delta >= maxAudioFramesDrift * inputSampleDuration && duration < MAX_SILENT_FRAME_DURATION && alignedWithVideo) {
          let missing = Math.round(delta / inputSampleDuration);
          // Adjust nextPts so that silent samples are aligned with media pts. This will prevent media samples from
          // later being shifted if nextPts is based on timeOffset and delta is not a multiple of inputSampleDuration.
          nextPts = pts - missing * inputSampleDuration;
          if (nextPts < 0) {
            missing--;
            nextPts += inputSampleDuration;
          }
          if (i === 0) {
            this.nextAudioPts = nextAudioPts = nextPts;
          }
          logger.warn(`[mp4-remuxer]: Injecting ${missing} audio frame @ ${(nextPts / inputTimeScale).toFixed(3)}s due to ${Math.round(1000 * delta / inputTimeScale)} ms gap.`);
          for (let j = 0; j < missing; j++) {
            const newStamp = Math.max(nextPts, 0);
            let fillFrame = AAC.getSilentFrame(track.manifestCodec || track.codec, track.channelCount);
            if (!fillFrame) {
              logger.log('[mp4-remuxer]: Unable to get silent frame for given audio codec; duplicating last frame instead.');
              fillFrame = sample.unit.subarray();
            }
            inputSamples.splice(i, 0, {
              unit: fillFrame,
              pts: newStamp
            });
            nextPts += inputSampleDuration;
            i++;
          }
        }
        sample.pts = nextPts;
        nextPts += inputSampleDuration;
      }
    }
    let firstPTS = null;
    let lastPTS = null;
    let mdat;
    let mdatSize = 0;
    let sampleLength = inputSamples.length;
    while (sampleLength--) {
      mdatSize += inputSamples[sampleLength].unit.byteLength;
    }
    for (let j = 0, _nbSamples = inputSamples.length; j < _nbSamples; j++) {
      const audioSample = inputSamples[j];
      const unit = audioSample.unit;
      let pts = audioSample.pts;
      if (lastPTS !== null) {
        // If we have more than one sample, set the duration of the sample to the "real" duration; the PTS diff with
        // the previous sample
        const prevSample = outputSamples[j - 1];
        prevSample.duration = Math.round((pts - lastPTS) / scaleFactor);
      } else {
        if (contiguous && track.segmentCodec === 'aac') {
          // set PTS/DTS to expected PTS/DTS
          pts = nextAudioPts;
        }
        // remember first PTS of our audioSamples
        firstPTS = pts;
        if (mdatSize > 0) {
          /* concatenate the audio data and construct the mdat in place
            (need 8 more bytes to fill length and mdat type) */
          mdatSize += offset;
          try {
            mdat = new Uint8Array(mdatSize);
          } catch (err) {
            this.observer.emit(Events.ERROR, Events.ERROR, {
              type: ErrorTypes.MUX_ERROR,
              details: ErrorDetails.REMUX_ALLOC_ERROR,
              fatal: false,
              error: err,
              bytes: mdatSize,
              reason: `fail allocating audio mdat ${mdatSize}`
            });
            return;
          }
          if (!rawMPEG) {
            const view = new DataView(mdat.buffer);
            view.setUint32(0, mdatSize);
            mdat.set(MP4.types.mdat, 4);
          }
        } else {
          // no audio samples
          return;
        }
      }
      mdat.set(unit, offset);
      const unitLen = unit.byteLength;
      offset += unitLen;
      // Default the sample's duration to the computed mp4SampleDuration, which will either be 1024 for AAC or 1152 for MPEG
      // In the case that we have 1 sample, this will be the duration. If we have more than one sample, the duration
      // becomes the PTS diff with the previous sample
      outputSamples.push(new Mp4Sample(true, mp4SampleDuration, unitLen, 0));
      lastPTS = pts;
    }

    // We could end up with no audio samples if all input samples were overlapping with the previously remuxed ones
    const nbSamples = outputSamples.length;
    if (!nbSamples) {
      return;
    }

    // The next audio sample PTS should be equal to last sample PTS + duration
    const lastSample = outputSamples[outputSamples.length - 1];
    this.nextAudioPts = nextAudioPts = lastPTS + scaleFactor * lastSample.duration;

    // Set the track samples from inputSamples to outputSamples before remuxing
    const moof = rawMPEG ? new Uint8Array(0) : MP4.moof(track.sequenceNumber++, firstPTS / scaleFactor, _extends({}, track, {
      samples: outputSamples
    }));

    // Clear the track samples. This also clears the samples array in the demuxer, since the reference is shared
    track.samples = [];
    const start = firstPTS / inputTimeScale;
    const end = nextAudioPts / inputTimeScale;
    const type = 'audio';
    const audioData = {
      data1: moof,
      data2: mdat,
      startPTS: start,
      endPTS: end,
      startDTS: start,
      endDTS: end,
      type,
      hasAudio: true,
      hasVideo: false,
      nb: nbSamples
    };
    this.isAudioContiguous = true;
    return audioData;
  }
  remuxEmptyAudio(track, timeOffset, contiguous, videoData) {
    const inputTimeScale = track.inputTimeScale;
    const mp4timeScale = track.samplerate ? track.samplerate : inputTimeScale;
    const scaleFactor = inputTimeScale / mp4timeScale;
    const nextAudioPts = this.nextAudioPts;
    // sync with video's timestamp
    const initDTS = this._initDTS;
    const init90kHz = initDTS.baseTime * 90000 / initDTS.timescale;
    const startDTS = (nextAudioPts !== null ? nextAudioPts : videoData.startDTS * inputTimeScale) + init90kHz;
    const endDTS = videoData.endDTS * inputTimeScale + init90kHz;
    // one sample's duration value
    const frameDuration = scaleFactor * AAC_SAMPLES_PER_FRAME;
    // samples count of this segment's duration
    const nbSamples = Math.ceil((endDTS - startDTS) / frameDuration);
    // silent frame
    const silentFrame = AAC.getSilentFrame(track.manifestCodec || track.codec, track.channelCount);
    logger.warn('[mp4-remuxer]: remux empty Audio');
    // Can't remux if we can't generate a silent frame...
    if (!silentFrame) {
      logger.trace('[mp4-remuxer]: Unable to remuxEmptyAudio since we were unable to get a silent frame for given audio codec');
      return;
    }
    const samples = [];
    for (let i = 0; i < nbSamples; i++) {
      const stamp = startDTS + i * frameDuration;
      samples.push({
        unit: silentFrame,
        pts: stamp,
        dts: stamp
      });
    }
    track.samples = samples;
    return this.remuxAudio(track, timeOffset, contiguous, false);
  }
}
function normalizePts(value, reference) {
  let offset;
  if (reference === null) {
    return value;
  }
  if (reference < value) {
    // - 2^33
    offset = -8589934592;
  } else {
    // + 2^33
    offset = 8589934592;
  }
  /* PTS is 33bit (from 0 to 2^33 -1)
    if diff between value and reference is bigger than half of the amplitude (2^32) then it means that
    PTS looping occured. fill the gap */
  while (Math.abs(value - reference) > 4294967296) {
    value += offset;
  }
  return value;
}
function findKeyframeIndex(samples) {
  for (let i = 0; i < samples.length; i++) {
    if (samples[i].key) {
      return i;
    }
  }
  return -1;
}
function flushTextTrackMetadataCueSamples(track, timeOffset, initPTS, initDTS) {
  const length = track.samples.length;
  if (!length) {
    return;
  }
  const inputTimeScale = track.inputTimeScale;
  for (let index = 0; index < length; index++) {
    const sample = track.samples[index];
    // setting id3 pts, dts to relative time
    // using this._initPTS and this._initDTS to calculate relative time
    sample.pts = normalizePts(sample.pts - initPTS.baseTime * inputTimeScale / initPTS.timescale, timeOffset * inputTimeScale) / inputTimeScale;
    sample.dts = normalizePts(sample.dts - initDTS.baseTime * inputTimeScale / initDTS.timescale, timeOffset * inputTimeScale) / inputTimeScale;
  }
  const samples = track.samples;
  track.samples = [];
  return {
    samples
  };
}
function flushTextTrackUserdataCueSamples(track, timeOffset, initPTS) {
  const length = track.samples.length;
  if (!length) {
    return;
  }
  const inputTimeScale = track.inputTimeScale;
  for (let index = 0; index < length; index++) {
    const sample = track.samples[index];
    // setting text pts, dts to relative time
    // using this._initPTS and this._initDTS to calculate relative time
    sample.pts = normalizePts(sample.pts - initPTS.baseTime * inputTimeScale / initPTS.timescale, timeOffset * inputTimeScale) / inputTimeScale;
  }
  track.samples.sort((a, b) => a.pts - b.pts);
  const samples = track.samples;
  track.samples = [];
  return {
    samples
  };
}
class Mp4Sample {
  constructor(isKeyframe, duration, size, cts) {
    this.size = void 0;
    this.duration = void 0;
    this.cts = void 0;
    this.flags = void 0;
    this.duration = duration;
    this.size = size;
    this.cts = cts;
    this.flags = {
      isLeading: 0,
      isDependedOn: 0,
      hasRedundancy: 0,
      degradPrio: 0,
      dependsOn: isKeyframe ? 2 : 1,
      isNonSync: isKeyframe ? 0 : 1
    };
  }
}

class PassThroughRemuxer {
  constructor() {
    this.emitInitSegment = false;
    this.audioCodec = void 0;
    this.videoCodec = void 0;
    this.initData = void 0;
    this.initPTS = null;
    this.initTracks = void 0;
    this.lastEndTime = null;
  }
  destroy() {}
  resetTimeStamp(defaultInitPTS) {
    this.initPTS = defaultInitPTS;
    this.lastEndTime = null;
  }
  resetNextTimestamp() {
    this.lastEndTime = null;
  }
  resetInitSegment(initSegment, audioCodec, videoCodec, decryptdata) {
    this.audioCodec = audioCodec;
    this.videoCodec = videoCodec;
    this.generateInitSegment(patchEncyptionData(initSegment, decryptdata));
    this.emitInitSegment = true;
  }
  generateInitSegment(initSegment) {
    let {
      audioCodec,
      videoCodec
    } = this;
    if (!(initSegment != null && initSegment.byteLength)) {
      this.initTracks = undefined;
      this.initData = undefined;
      return;
    }
    const initData = this.initData = parseInitSegment(initSegment);

    // Get codec from initSegment or fallback to default
    if (initData.audio) {
      audioCodec = getParsedTrackCodec(initData.audio, ElementaryStreamTypes.AUDIO);
    }
    if (initData.video) {
      videoCodec = getParsedTrackCodec(initData.video, ElementaryStreamTypes.VIDEO);
    }
    const tracks = {};
    if (initData.audio && initData.video) {
      tracks.audiovideo = {
        container: 'video/mp4',
        codec: audioCodec + ',' + videoCodec,
        initSegment,
        id: 'main'
      };
    } else if (initData.audio) {
      tracks.audio = {
        container: 'audio/mp4',
        codec: audioCodec,
        initSegment,
        id: 'audio'
      };
    } else if (initData.video) {
      tracks.video = {
        container: 'video/mp4',
        codec: videoCodec,
        initSegment,
        id: 'main'
      };
    } else {
      logger.warn('[passthrough-remuxer.ts]: initSegment does not contain moov or trak boxes.');
    }
    this.initTracks = tracks;
  }
  remux(audioTrack, videoTrack, id3Track, textTrack, timeOffset, accurateTimeOffset) {
    var _initData, _initData2;
    let {
      initPTS,
      lastEndTime
    } = this;
    const result = {
      audio: undefined,
      video: undefined,
      text: textTrack,
      id3: id3Track,
      initSegment: undefined
    };

    // If we haven't yet set a lastEndDTS, or it was reset, set it to the provided timeOffset. We want to use the
    // lastEndDTS over timeOffset whenever possible; during progressive playback, the media source will not update
    // the media duration (which is what timeOffset is provided as) before we need to process the next chunk.
    if (!isFiniteNumber(lastEndTime)) {
      lastEndTime = this.lastEndTime = timeOffset || 0;
    }

    // The binary segment data is added to the videoTrack in the mp4demuxer. We don't check to see if the data is only
    // audio or video (or both); adding it to video was an arbitrary choice.
    const data = videoTrack.samples;
    if (!(data != null && data.length)) {
      return result;
    }
    const initSegment = {
      initPTS: undefined,
      timescale: 1
    };
    let initData = this.initData;
    if (!((_initData = initData) != null && _initData.length)) {
      this.generateInitSegment(data);
      initData = this.initData;
    }
    if (!((_initData2 = initData) != null && _initData2.length)) {
      // We can't remux if the initSegment could not be generated
      logger.warn('[passthrough-remuxer.ts]: Failed to generate initSegment.');
      return result;
    }
    if (this.emitInitSegment) {
      initSegment.tracks = this.initTracks;
      this.emitInitSegment = false;
    }
    const duration = getDuration(data, initData);
    const startDTS = getStartDTS(initData, data);
    const decodeTime = startDTS === null ? timeOffset : startDTS;
    if (isInvalidInitPts(initPTS, decodeTime, timeOffset, duration) || initSegment.timescale !== initPTS.timescale && accurateTimeOffset) {
      initSegment.initPTS = decodeTime - timeOffset;
      if (initPTS && initPTS.timescale === 1) {
        logger.warn(`Adjusting initPTS by ${initSegment.initPTS - initPTS.baseTime}`);
      }
      this.initPTS = initPTS = {
        baseTime: initSegment.initPTS,
        timescale: 1
      };
    }
    const startTime = audioTrack ? decodeTime - initPTS.baseTime / initPTS.timescale : lastEndTime;
    const endTime = startTime + duration;
    offsetStartDTS(initData, data, initPTS.baseTime / initPTS.timescale);
    if (duration > 0) {
      this.lastEndTime = endTime;
    } else {
      logger.warn('Duration parsed from mp4 should be greater than zero');
      this.resetNextTimestamp();
    }
    const hasAudio = !!initData.audio;
    const hasVideo = !!initData.video;
    let type = '';
    if (hasAudio) {
      type += 'audio';
    }
    if (hasVideo) {
      type += 'video';
    }
    const track = {
      data1: data,
      startPTS: startTime,
      startDTS: startTime,
      endPTS: endTime,
      endDTS: endTime,
      type,
      hasAudio,
      hasVideo,
      nb: 1,
      dropped: 0
    };
    result.audio = track.type === 'audio' ? track : undefined;
    result.video = track.type !== 'audio' ? track : undefined;
    result.initSegment = initSegment;
    result.id3 = flushTextTrackMetadataCueSamples(id3Track, timeOffset, initPTS, initPTS);
    if (textTrack.samples.length) {
      result.text = flushTextTrackUserdataCueSamples(textTrack, timeOffset, initPTS);
    }
    return result;
  }
}
function isInvalidInitPts(initPTS, startDTS, timeOffset, duration) {
  if (initPTS === null) {
    return true;
  }
  // InitPTS is invalid when distance from program would be more than segment duration or a minimum of one second
  const minDuration = Math.max(duration, 1);
  const startTime = startDTS - initPTS.baseTime / initPTS.timescale;
  return Math.abs(startTime - timeOffset) > minDuration;
}
function getParsedTrackCodec(track, type) {
  const parsedCodec = track == null ? void 0 : track.codec;
  if (parsedCodec && parsedCodec.length > 4) {
    return parsedCodec;
  }
  if (type === ElementaryStreamTypes.AUDIO) {
    if (parsedCodec === 'ec-3' || parsedCodec === 'ac-3' || parsedCodec === 'alac') {
      return parsedCodec;
    }
    if (parsedCodec === 'fLaC' || parsedCodec === 'Opus') {
      // Opting not to get `preferManagedMediaSource` from player config for isSupported() check for simplicity
      const preferManagedMediaSource = false;
      return getCodecCompatibleName(parsedCodec, preferManagedMediaSource);
    }
    const result = 'mp4a.40.5';
    logger.info(`Parsed audio codec "${parsedCodec}" or audio object type not handled. Using "${result}"`);
    return result;
  }
  // Provide defaults based on codec type
  // This allows for some playback of some fmp4 playlists without CODECS defined in manifest
  logger.warn(`Unhandled video codec "${parsedCodec}"`);
  if (parsedCodec === 'hvc1' || parsedCodec === 'hev1') {
    return 'hvc1.1.6.L120.90';
  }
  if (parsedCodec === 'av01') {
    return 'av01.0.04M.08';
  }
  return 'avc1.42e01e';
}

let now;
// performance.now() not available on WebWorker, at least on Safari Desktop
try {
  now = self.performance.now.bind(self.performance);
} catch (err) {
  logger.debug('Unable to use Performance API on this environment');
  now = optionalSelf == null ? void 0 : optionalSelf.Date.now;
}
const muxConfig = [{
  demux: MP4Demuxer,
  remux: PassThroughRemuxer
}, {
  demux: TSDemuxer,
  remux: MP4Remuxer
}, {
  demux: AACDemuxer,
  remux: MP4Remuxer
}, {
  demux: MP3Demuxer,
  remux: MP4Remuxer
}];
{
  muxConfig.splice(2, 0, {
    demux: AC3Demuxer,
    remux: MP4Remuxer
  });
}
class Transmuxer {
  constructor(observer, typeSupported, config, vendor, id) {
    this.async = false;
    this.observer = void 0;
    this.typeSupported = void 0;
    this.config = void 0;
    this.vendor = void 0;
    this.id = void 0;
    this.demuxer = void 0;
    this.remuxer = void 0;
    this.decrypter = void 0;
    this.probe = void 0;
    this.decryptionPromise = null;
    this.transmuxConfig = void 0;
    this.currentTransmuxState = void 0;
    this.observer = observer;
    this.typeSupported = typeSupported;
    this.config = config;
    this.vendor = vendor;
    this.id = id;
  }
  configure(transmuxConfig) {
    this.transmuxConfig = transmuxConfig;
    if (this.decrypter) {
      this.decrypter.reset();
    }
  }
  push(data, decryptdata, chunkMeta, state) {
    const stats = chunkMeta.transmuxing;
    stats.executeStart = now();
    let uintData = new Uint8Array(data);
    const {
      currentTransmuxState,
      transmuxConfig
    } = this;
    if (state) {
      this.currentTransmuxState = state;
    }
    const {
      contiguous,
      discontinuity,
      trackSwitch,
      accurateTimeOffset,
      timeOffset,
      initSegmentChange
    } = state || currentTransmuxState;
    const {
      audioCodec,
      videoCodec,
      defaultInitPts,
      duration,
      initSegmentData
    } = transmuxConfig;
    const keyData = getEncryptionType(uintData, decryptdata);
    if (keyData && keyData.method === 'AES-128') {
      const decrypter = this.getDecrypter();
      // Software decryption is synchronous; webCrypto is not
      if (decrypter.isSync()) {
        // Software decryption is progressive. Progressive decryption may not return a result on each call. Any cached
        // data is handled in the flush() call
        let decryptedData = decrypter.softwareDecrypt(uintData, keyData.key.buffer, keyData.iv.buffer);
        // For Low-Latency HLS Parts, decrypt in place, since part parsing is expected on push progress
        const loadingParts = chunkMeta.part > -1;
        if (loadingParts) {
          decryptedData = decrypter.flush();
        }
        if (!decryptedData) {
          stats.executeEnd = now();
          return emptyResult(chunkMeta);
        }
        uintData = new Uint8Array(decryptedData);
      } else {
        this.decryptionPromise = decrypter.webCryptoDecrypt(uintData, keyData.key.buffer, keyData.iv.buffer).then(decryptedData => {
          // Calling push here is important; if flush() is called while this is still resolving, this ensures that
          // the decrypted data has been transmuxed
          const result = this.push(decryptedData, null, chunkMeta);
          this.decryptionPromise = null;
          return result;
        });
        return this.decryptionPromise;
      }
    }
    const resetMuxers = this.needsProbing(discontinuity, trackSwitch);
    if (resetMuxers) {
      const error = this.configureTransmuxer(uintData);
      if (error) {
        logger.warn(`[transmuxer] ${error.message}`);
        this.observer.emit(Events.ERROR, Events.ERROR, {
          type: ErrorTypes.MEDIA_ERROR,
          details: ErrorDetails.FRAG_PARSING_ERROR,
          fatal: false,
          error,
          reason: error.message
        });
        stats.executeEnd = now();
        return emptyResult(chunkMeta);
      }
    }
    if (discontinuity || trackSwitch || initSegmentChange || resetMuxers) {
      this.resetInitSegment(initSegmentData, audioCodec, videoCodec, duration, decryptdata);
    }
    if (discontinuity || initSegmentChange || resetMuxers) {
      this.resetInitialTimestamp(defaultInitPts);
    }
    if (!contiguous) {
      this.resetContiguity();
    }
    const result = this.transmux(uintData, keyData, timeOffset, accurateTimeOffset, chunkMeta);
    const currentState = this.currentTransmuxState;
    currentState.contiguous = true;
    currentState.discontinuity = false;
    currentState.trackSwitch = false;
    stats.executeEnd = now();
    return result;
  }

  // Due to data caching, flush calls can produce more than one TransmuxerResult (hence the Array type)
  flush(chunkMeta) {
    const stats = chunkMeta.transmuxing;
    stats.executeStart = now();
    const {
      decrypter,
      currentTransmuxState,
      decryptionPromise
    } = this;
    if (decryptionPromise) {
      // Upon resolution, the decryption promise calls push() and returns its TransmuxerResult up the stack. Therefore
      // only flushing is required for async decryption
      return decryptionPromise.then(() => {
        return this.flush(chunkMeta);
      });
    }
    const transmuxResults = [];
    const {
      timeOffset
    } = currentTransmuxState;
    if (decrypter) {
      // The decrypter may have data cached, which needs to be demuxed. In this case we'll have two TransmuxResults
      // This happens in the case that we receive only 1 push call for a segment (either for non-progressive downloads,
      // or for progressive downloads with small segments)
      const decryptedData = decrypter.flush();
      if (decryptedData) {
        // Push always returns a TransmuxerResult if decryptdata is null
        transmuxResults.push(this.push(decryptedData, null, chunkMeta));
      }
    }
    const {
      demuxer,
      remuxer
    } = this;
    if (!demuxer || !remuxer) {
      // If probing failed, then Hls.js has been given content its not able to handle
      stats.executeEnd = now();
      return [emptyResult(chunkMeta)];
    }
    const demuxResultOrPromise = demuxer.flush(timeOffset);
    if (isPromise(demuxResultOrPromise)) {
      // Decrypt final SAMPLE-AES samples
      return demuxResultOrPromise.then(demuxResult => {
        this.flushRemux(transmuxResults, demuxResult, chunkMeta);
        return transmuxResults;
      });
    }
    this.flushRemux(transmuxResults, demuxResultOrPromise, chunkMeta);
    return transmuxResults;
  }
  flushRemux(transmuxResults, demuxResult, chunkMeta) {
    const {
      audioTrack,
      videoTrack,
      id3Track,
      textTrack
    } = demuxResult;
    const {
      accurateTimeOffset,
      timeOffset
    } = this.currentTransmuxState;
    logger.log(`[transmuxer.ts]: Flushed fragment ${chunkMeta.sn}${chunkMeta.part > -1 ? ' p: ' + chunkMeta.part : ''} of level ${chunkMeta.level}`);
    const remuxResult = this.remuxer.remux(audioTrack, videoTrack, id3Track, textTrack, timeOffset, accurateTimeOffset, true, this.id);
    transmuxResults.push({
      remuxResult,
      chunkMeta
    });
    chunkMeta.transmuxing.executeEnd = now();
  }
  resetInitialTimestamp(defaultInitPts) {
    const {
      demuxer,
      remuxer
    } = this;
    if (!demuxer || !remuxer) {
      return;
    }
    demuxer.resetTimeStamp(defaultInitPts);
    remuxer.resetTimeStamp(defaultInitPts);
  }
  resetContiguity() {
    const {
      demuxer,
      remuxer
    } = this;
    if (!demuxer || !remuxer) {
      return;
    }
    demuxer.resetContiguity();
    remuxer.resetNextTimestamp();
  }
  resetInitSegment(initSegmentData, audioCodec, videoCodec, trackDuration, decryptdata) {
    const {
      demuxer,
      remuxer
    } = this;
    if (!demuxer || !remuxer) {
      return;
    }
    demuxer.resetInitSegment(initSegmentData, audioCodec, videoCodec, trackDuration);
    remuxer.resetInitSegment(initSegmentData, audioCodec, videoCodec, decryptdata);
  }
  destroy() {
    if (this.demuxer) {
      this.demuxer.destroy();
      this.demuxer = undefined;
    }
    if (this.remuxer) {
      this.remuxer.destroy();
      this.remuxer = undefined;
    }
  }
  transmux(data, keyData, timeOffset, accurateTimeOffset, chunkMeta) {
    let result;
    if (keyData && keyData.method === 'SAMPLE-AES') {
      result = this.transmuxSampleAes(data, keyData, timeOffset, accurateTimeOffset, chunkMeta);
    } else {
      result = this.transmuxUnencrypted(data, timeOffset, accurateTimeOffset, chunkMeta);
    }
    return result;
  }
  transmuxUnencrypted(data, timeOffset, accurateTimeOffset, chunkMeta) {
    const {
      audioTrack,
      videoTrack,
      id3Track,
      textTrack
    } = this.demuxer.demux(data, timeOffset, false, !this.config.progressive);
    const remuxResult = this.remuxer.remux(audioTrack, videoTrack, id3Track, textTrack, timeOffset, accurateTimeOffset, false, this.id);
    return {
      remuxResult,
      chunkMeta
    };
  }
  transmuxSampleAes(data, decryptData, timeOffset, accurateTimeOffset, chunkMeta) {
    return this.demuxer.demuxSampleAes(data, decryptData, timeOffset).then(demuxResult => {
      const remuxResult = this.remuxer.remux(demuxResult.audioTrack, demuxResult.videoTrack, demuxResult.id3Track, demuxResult.textTrack, timeOffset, accurateTimeOffset, false, this.id);
      return {
        remuxResult,
        chunkMeta
      };
    });
  }
  configureTransmuxer(data) {
    const {
      config,
      observer,
      typeSupported,
      vendor
    } = this;
    // probe for content type
    let mux;
    for (let i = 0, len = muxConfig.length; i < len; i++) {
      var _muxConfig$i$demux;
      if ((_muxConfig$i$demux = muxConfig[i].demux) != null && _muxConfig$i$demux.probe(data)) {
        mux = muxConfig[i];
        break;
      }
    }
    if (!mux) {
      return new Error('Failed to find demuxer by probing fragment data');
    }
    // so let's check that current remuxer and demuxer are still valid
    const demuxer = this.demuxer;
    const remuxer = this.remuxer;
    const Remuxer = mux.remux;
    const Demuxer = mux.demux;
    if (!remuxer || !(remuxer instanceof Remuxer)) {
      this.remuxer = new Remuxer(observer, config, typeSupported, vendor);
    }
    if (!demuxer || !(demuxer instanceof Demuxer)) {
      this.demuxer = new Demuxer(observer, config, typeSupported);
      this.probe = Demuxer.probe;
    }
  }
  needsProbing(discontinuity, trackSwitch) {
    // in case of continuity change, or track switch
    // we might switch from content type (AAC container to TS container, or TS to fmp4 for example)
    return !this.demuxer || !this.remuxer || discontinuity || trackSwitch;
  }
  getDecrypter() {
    let decrypter = this.decrypter;
    if (!decrypter) {
      decrypter = this.decrypter = new Decrypter(this.config);
    }
    return decrypter;
  }
}
function getEncryptionType(data, decryptData) {
  let encryptionType = null;
  if (data.byteLength > 0 && (decryptData == null ? void 0 : decryptData.key) != null && decryptData.iv !== null && decryptData.method != null) {
    encryptionType = decryptData;
  }
  return encryptionType;
}
const emptyResult = chunkMeta => ({
  remuxResult: {},
  chunkMeta
});
function isPromise(p) {
  return 'then' in p && p.then instanceof Function;
}
class TransmuxConfig {
  constructor(audioCodec, videoCodec, initSegmentData, duration, defaultInitPts) {
    this.audioCodec = void 0;
    this.videoCodec = void 0;
    this.initSegmentData = void 0;
    this.duration = void 0;
    this.defaultInitPts = void 0;
    this.audioCodec = audioCodec;
    this.videoCodec = videoCodec;
    this.initSegmentData = initSegmentData;
    this.duration = duration;
    this.defaultInitPts = defaultInitPts || null;
  }
}
class TransmuxState {
  constructor(discontinuity, contiguous, accurateTimeOffset, trackSwitch, timeOffset, initSegmentChange) {
    this.discontinuity = void 0;
    this.contiguous = void 0;
    this.accurateTimeOffset = void 0;
    this.trackSwitch = void 0;
    this.timeOffset = void 0;
    this.initSegmentChange = void 0;
    this.discontinuity = discontinuity;
    this.contiguous = contiguous;
    this.accurateTimeOffset = accurateTimeOffset;
    this.trackSwitch = trackSwitch;
    this.timeOffset = timeOffset;
    this.initSegmentChange = initSegmentChange;
  }
}

var eventemitter3 = {exports: {}};

(function (module) {

	var has = Object.prototype.hasOwnProperty
	  , prefix = '~';

	/**
	 * Constructor to create a storage for our `EE` objects.
	 * An `Events` instance is a plain object whose properties are event names.
	 *
	 * @constructor
	 * @private
	 */
	function Events() {}

	//
	// We try to not inherit from `Object.prototype`. In some engines creating an
	// instance in this way is faster than calling `Object.create(null)` directly.
	// If `Object.create(null)` is not supported we prefix the event names with a
	// character to make sure that the built-in object properties are not
	// overridden or used as an attack vector.
	//
	if (Object.create) {
	  Events.prototype = Object.create(null);

	  //
	  // This hack is needed because the `__proto__` property is still inherited in
	  // some old browsers like Android 4, iPhone 5.1, Opera 11 and Safari 5.
	  //
	  if (!new Events().__proto__) prefix = false;
	}

	/**
	 * Representation of a single event listener.
	 *
	 * @param {Function} fn The listener function.
	 * @param {*} context The context to invoke the listener with.
	 * @param {Boolean} [once=false] Specify if the listener is a one-time listener.
	 * @constructor
	 * @private
	 */
	function EE(fn, context, once) {
	  this.fn = fn;
	  this.context = context;
	  this.once = once || false;
	}

	/**
	 * Add a listener for a given event.
	 *
	 * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
	 * @param {(String|Symbol)} event The event name.
	 * @param {Function} fn The listener function.
	 * @param {*} context The context to invoke the listener with.
	 * @param {Boolean} once Specify if the listener is a one-time listener.
	 * @returns {EventEmitter}
	 * @private
	 */
	function addListener(emitter, event, fn, context, once) {
	  if (typeof fn !== 'function') {
	    throw new TypeError('The listener must be a function');
	  }

	  var listener = new EE(fn, context || emitter, once)
	    , evt = prefix ? prefix + event : event;

	  if (!emitter._events[evt]) emitter._events[evt] = listener, emitter._eventsCount++;
	  else if (!emitter._events[evt].fn) emitter._events[evt].push(listener);
	  else emitter._events[evt] = [emitter._events[evt], listener];

	  return emitter;
	}

	/**
	 * Clear event by name.
	 *
	 * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
	 * @param {(String|Symbol)} evt The Event name.
	 * @private
	 */
	function clearEvent(emitter, evt) {
	  if (--emitter._eventsCount === 0) emitter._events = new Events();
	  else delete emitter._events[evt];
	}

	/**
	 * Minimal `EventEmitter` interface that is molded against the Node.js
	 * `EventEmitter` interface.
	 *
	 * @constructor
	 * @public
	 */
	function EventEmitter() {
	  this._events = new Events();
	  this._eventsCount = 0;
	}

	/**
	 * Return an array listing the events for which the emitter has registered
	 * listeners.
	 *
	 * @returns {Array}
	 * @public
	 */
	EventEmitter.prototype.eventNames = function eventNames() {
	  var names = []
	    , events
	    , name;

	  if (this._eventsCount === 0) return names;

	  for (name in (events = this._events)) {
	    if (has.call(events, name)) names.push(prefix ? name.slice(1) : name);
	  }

	  if (Object.getOwnPropertySymbols) {
	    return names.concat(Object.getOwnPropertySymbols(events));
	  }

	  return names;
	};

	/**
	 * Return the listeners registered for a given event.
	 *
	 * @param {(String|Symbol)} event The event name.
	 * @returns {Array} The registered listeners.
	 * @public
	 */
	EventEmitter.prototype.listeners = function listeners(event) {
	  var evt = prefix ? prefix + event : event
	    , handlers = this._events[evt];

	  if (!handlers) return [];
	  if (handlers.fn) return [handlers.fn];

	  for (var i = 0, l = handlers.length, ee = new Array(l); i < l; i++) {
	    ee[i] = handlers[i].fn;
	  }

	  return ee;
	};

	/**
	 * Return the number of listeners listening to a given event.
	 *
	 * @param {(String|Symbol)} event The event name.
	 * @returns {Number} The number of listeners.
	 * @public
	 */
	EventEmitter.prototype.listenerCount = function listenerCount(event) {
	  var evt = prefix ? prefix + event : event
	    , listeners = this._events[evt];

	  if (!listeners) return 0;
	  if (listeners.fn) return 1;
	  return listeners.length;
	};

	/**
	 * Calls each of the listeners registered for a given event.
	 *
	 * @param {(String|Symbol)} event The event name.
	 * @returns {Boolean} `true` if the event had listeners, else `false`.
	 * @public
	 */
	EventEmitter.prototype.emit = function emit(event, a1, a2, a3, a4, a5) {
	  var evt = prefix ? prefix + event : event;

	  if (!this._events[evt]) return false;

	  var listeners = this._events[evt]
	    , len = arguments.length
	    , args
	    , i;

	  if (listeners.fn) {
	    if (listeners.once) this.removeListener(event, listeners.fn, undefined, true);

	    switch (len) {
	      case 1: return listeners.fn.call(listeners.context), true;
	      case 2: return listeners.fn.call(listeners.context, a1), true;
	      case 3: return listeners.fn.call(listeners.context, a1, a2), true;
	      case 4: return listeners.fn.call(listeners.context, a1, a2, a3), true;
	      case 5: return listeners.fn.call(listeners.context, a1, a2, a3, a4), true;
	      case 6: return listeners.fn.call(listeners.context, a1, a2, a3, a4, a5), true;
	    }

	    for (i = 1, args = new Array(len -1); i < len; i++) {
	      args[i - 1] = arguments[i];
	    }

	    listeners.fn.apply(listeners.context, args);
	  } else {
	    var length = listeners.length
	      , j;

	    for (i = 0; i < length; i++) {
	      if (listeners[i].once) this.removeListener(event, listeners[i].fn, undefined, true);

	      switch (len) {
	        case 1: listeners[i].fn.call(listeners[i].context); break;
	        case 2: listeners[i].fn.call(listeners[i].context, a1); break;
	        case 3: listeners[i].fn.call(listeners[i].context, a1, a2); break;
	        case 4: listeners[i].fn.call(listeners[i].context, a1, a2, a3); break;
	        default:
	          if (!args) for (j = 1, args = new Array(len -1); j < len; j++) {
	            args[j - 1] = arguments[j];
	          }

	          listeners[i].fn.apply(listeners[i].context, args);
	      }
	    }
	  }

	  return true;
	};

	/**
	 * Add a listener for a given event.
	 *
	 * @param {(String|Symbol)} event The event name.
	 * @param {Function} fn The listener function.
	 * @param {*} [context=this] The context to invoke the listener with.
	 * @returns {EventEmitter} `this`.
	 * @public
	 */
	EventEmitter.prototype.on = function on(event, fn, context) {
	  return addListener(this, event, fn, context, false);
	};

	/**
	 * Add a one-time listener for a given event.
	 *
	 * @param {(String|Symbol)} event The event name.
	 * @param {Function} fn The listener function.
	 * @param {*} [context=this] The context to invoke the listener with.
	 * @returns {EventEmitter} `this`.
	 * @public
	 */
	EventEmitter.prototype.once = function once(event, fn, context) {
	  return addListener(this, event, fn, context, true);
	};

	/**
	 * Remove the listeners of a given event.
	 *
	 * @param {(String|Symbol)} event The event name.
	 * @param {Function} fn Only remove the listeners that match this function.
	 * @param {*} context Only remove the listeners that have this context.
	 * @param {Boolean} once Only remove one-time listeners.
	 * @returns {EventEmitter} `this`.
	 * @public
	 */
	EventEmitter.prototype.removeListener = function removeListener(event, fn, context, once) {
	  var evt = prefix ? prefix + event : event;

	  if (!this._events[evt]) return this;
	  if (!fn) {
	    clearEvent(this, evt);
	    return this;
	  }

	  var listeners = this._events[evt];

	  if (listeners.fn) {
	    if (
	      listeners.fn === fn &&
	      (!once || listeners.once) &&
	      (!context || listeners.context === context)
	    ) {
	      clearEvent(this, evt);
	    }
	  } else {
	    for (var i = 0, events = [], length = listeners.length; i < length; i++) {
	      if (
	        listeners[i].fn !== fn ||
	        (once && !listeners[i].once) ||
	        (context && listeners[i].context !== context)
	      ) {
	        events.push(listeners[i]);
	      }
	    }

	    //
	    // Reset the array, or remove it completely if we have no more listeners.
	    //
	    if (events.length) this._events[evt] = events.length === 1 ? events[0] : events;
	    else clearEvent(this, evt);
	  }

	  return this;
	};

	/**
	 * Remove all listeners, or those of the specified event.
	 *
	 * @param {(String|Symbol)} [event] The event name.
	 * @returns {EventEmitter} `this`.
	 * @public
	 */
	EventEmitter.prototype.removeAllListeners = function removeAllListeners(event) {
	  var evt;

	  if (event) {
	    evt = prefix ? prefix + event : event;
	    if (this._events[evt]) clearEvent(this, evt);
	  } else {
	    this._events = new Events();
	    this._eventsCount = 0;
	  }

	  return this;
	};

	//
	// Alias methods names because people roll like that.
	//
	EventEmitter.prototype.off = EventEmitter.prototype.removeListener;
	EventEmitter.prototype.addListener = EventEmitter.prototype.on;

	//
	// Expose the prefix.
	//
	EventEmitter.prefixed = prefix;

	//
	// Allow `EventEmitter` to be imported as module namespace.
	//
	EventEmitter.EventEmitter = EventEmitter;

	//
	// Expose the module.
	//
	{
	  module.exports = EventEmitter;
	} 
} (eventemitter3));

var eventemitter3Exports = eventemitter3.exports;
var EventEmitter = /*@__PURE__*/getDefaultExportFromCjs(eventemitter3Exports);

class TransmuxerInterface {
  constructor(hls, id, onTransmuxComplete, onFlush) {
    this.error = null;
    this.hls = void 0;
    this.id = void 0;
    this.observer = void 0;
    this.frag = null;
    this.part = null;
    this.useWorker = void 0;
    this.workerContext = null;
    this.onwmsg = void 0;
    this.transmuxer = null;
    this.onTransmuxComplete = void 0;
    this.onFlush = void 0;
    const config = hls.config;
    this.hls = hls;
    this.id = id;
    this.useWorker = !!config.enableWorker;
    this.onTransmuxComplete = onTransmuxComplete;
    this.onFlush = onFlush;
    const forwardMessage = (ev, data) => {
      data = data || {};
      data.frag = this.frag;
      data.id = this.id;
      if (ev === Events.ERROR) {
        this.error = data.error;
      }
      this.hls.trigger(ev, data);
    };

    // forward events to main thread
    this.observer = new EventEmitter();
    this.observer.on(Events.FRAG_DECRYPTED, forwardMessage);
    this.observer.on(Events.ERROR, forwardMessage);
    const MediaSource = getMediaSource(config.preferManagedMediaSource) || {
      isTypeSupported: () => false
    };
    const m2tsTypeSupported = {
      mpeg: MediaSource.isTypeSupported('audio/mpeg'),
      mp3: MediaSource.isTypeSupported('audio/mp4; codecs="mp3"'),
      ac3: MediaSource.isTypeSupported('audio/mp4; codecs="ac-3"') 
    };
    if (this.useWorker && typeof Worker !== 'undefined') {
      const canCreateWorker = config.workerPath || hasUMDWorker();
      if (canCreateWorker) {
        try {
          if (config.workerPath) {
            logger.log(`loading Web Worker ${config.workerPath} for "${id}"`);
            this.workerContext = loadWorker(config.workerPath);
          } else {
            logger.log(`injecting Web Worker for "${id}"`);
            this.workerContext = injectWorker();
          }
          this.onwmsg = event => this.onWorkerMessage(event);
          const {
            worker
          } = this.workerContext;
          worker.addEventListener('message', this.onwmsg);
          worker.onerror = event => {
            const error = new Error(`${event.message}  (${event.filename}:${event.lineno})`);
            config.enableWorker = false;
            logger.warn(`Error in "${id}" Web Worker, fallback to inline`);
            this.hls.trigger(Events.ERROR, {
              type: ErrorTypes.OTHER_ERROR,
              details: ErrorDetails.INTERNAL_EXCEPTION,
              fatal: false,
              event: 'demuxerWorker',
              error
            });
          };
          worker.postMessage({
            cmd: 'init',
            typeSupported: m2tsTypeSupported,
            vendor: '',
            id: id,
            config: JSON.stringify(config)
          });
        } catch (err) {
          logger.warn(`Error setting up "${id}" Web Worker, fallback to inline`, err);
          this.resetWorker();
          this.error = null;
          this.transmuxer = new Transmuxer(this.observer, m2tsTypeSupported, config, '', id);
        }
        return;
      }
    }
    this.transmuxer = new Transmuxer(this.observer, m2tsTypeSupported, config, '', id);
  }
  resetWorker() {
    if (this.workerContext) {
      const {
        worker,
        objectURL
      } = this.workerContext;
      if (objectURL) {
        // revoke the Object URL that was used to create transmuxer worker, so as not to leak it
        self.URL.revokeObjectURL(objectURL);
      }
      worker.removeEventListener('message', this.onwmsg);
      worker.onerror = null;
      worker.terminate();
      this.workerContext = null;
    }
  }
  destroy() {
    if (this.workerContext) {
      this.resetWorker();
      this.onwmsg = undefined;
    } else {
      const transmuxer = this.transmuxer;
      if (transmuxer) {
        transmuxer.destroy();
        this.transmuxer = null;
      }
    }
    const observer = this.observer;
    if (observer) {
      observer.removeAllListeners();
    }
    this.frag = null;
    // @ts-ignore
    this.observer = null;
    // @ts-ignore
    this.hls = null;
  }
  push(data, initSegmentData, audioCodec, videoCodec, frag, part, duration, accurateTimeOffset, chunkMeta, defaultInitPTS) {
    var _frag$initSegment, _lastFrag$initSegment;
    chunkMeta.transmuxing.start = self.performance.now();
    const {
      transmuxer
    } = this;
    const timeOffset = part ? part.start : frag.start;
    // TODO: push "clear-lead" decrypt data for unencrypted fragments in streams with encrypted ones
    const decryptdata = frag.decryptdata;
    const lastFrag = this.frag;
    const discontinuity = !(lastFrag && frag.cc === lastFrag.cc);
    const trackSwitch = !(lastFrag && chunkMeta.level === lastFrag.level);
    const snDiff = lastFrag ? chunkMeta.sn - lastFrag.sn : -1;
    const partDiff = this.part ? chunkMeta.part - this.part.index : -1;
    const progressive = snDiff === 0 && chunkMeta.id > 1 && chunkMeta.id === (lastFrag == null ? void 0 : lastFrag.stats.chunkCount);
    const contiguous = !trackSwitch && (snDiff === 1 || snDiff === 0 && (partDiff === 1 || progressive && partDiff <= 0));
    const now = self.performance.now();
    if (trackSwitch || snDiff || frag.stats.parsing.start === 0) {
      frag.stats.parsing.start = now;
    }
    if (part && (partDiff || !contiguous)) {
      part.stats.parsing.start = now;
    }
    const initSegmentChange = !(lastFrag && ((_frag$initSegment = frag.initSegment) == null ? void 0 : _frag$initSegment.url) === ((_lastFrag$initSegment = lastFrag.initSegment) == null ? void 0 : _lastFrag$initSegment.url));
    const state = new TransmuxState(discontinuity, contiguous, accurateTimeOffset, trackSwitch, timeOffset, initSegmentChange);
    if (!contiguous || discontinuity || initSegmentChange) {
      logger.log(`[transmuxer-interface, ${frag.type}]: Starting new transmux session for sn: ${chunkMeta.sn} p: ${chunkMeta.part} level: ${chunkMeta.level} id: ${chunkMeta.id}
        discontinuity: ${discontinuity}
        trackSwitch: ${trackSwitch}
        contiguous: ${contiguous}
        accurateTimeOffset: ${accurateTimeOffset}
        timeOffset: ${timeOffset}
        initSegmentChange: ${initSegmentChange}`);
      const config = new TransmuxConfig(audioCodec, videoCodec, initSegmentData, duration, defaultInitPTS);
      this.configureTransmuxer(config);
    }
    this.frag = frag;
    this.part = part;

    // Frags with sn of 'initSegment' are not transmuxed
    if (this.workerContext) {
      // post fragment payload as transferable objects for ArrayBuffer (no copy)
      this.workerContext.worker.postMessage({
        cmd: 'demux',
        data,
        decryptdata,
        chunkMeta,
        state
      }, data instanceof ArrayBuffer ? [data] : []);
    } else if (transmuxer) {
      const transmuxResult = transmuxer.push(data, decryptdata, chunkMeta, state);
      if (isPromise(transmuxResult)) {
        transmuxer.async = true;
        transmuxResult.then(data => {
          this.handleTransmuxComplete(data);
        }).catch(error => {
          this.transmuxerError(error, chunkMeta, 'transmuxer-interface push error');
        });
      } else {
        transmuxer.async = false;
        this.handleTransmuxComplete(transmuxResult);
      }
    }
  }
  flush(chunkMeta) {
    chunkMeta.transmuxing.start = self.performance.now();
    const {
      transmuxer
    } = this;
    if (this.workerContext) {
      this.workerContext.worker.postMessage({
        cmd: 'flush',
        chunkMeta
      });
    } else if (transmuxer) {
      let transmuxResult = transmuxer.flush(chunkMeta);
      const asyncFlush = isPromise(transmuxResult);
      if (asyncFlush || transmuxer.async) {
        if (!isPromise(transmuxResult)) {
          transmuxResult = Promise.resolve(transmuxResult);
        }
        transmuxResult.then(data => {
          this.handleFlushResult(data, chunkMeta);
        }).catch(error => {
          this.transmuxerError(error, chunkMeta, 'transmuxer-interface flush error');
        });
      } else {
        this.handleFlushResult(transmuxResult, chunkMeta);
      }
    }
  }
  transmuxerError(error, chunkMeta, reason) {
    if (!this.hls) {
      return;
    }
    this.error = error;
    this.hls.trigger(Events.ERROR, {
      type: ErrorTypes.MEDIA_ERROR,
      details: ErrorDetails.FRAG_PARSING_ERROR,
      chunkMeta,
      frag: this.frag || undefined,
      fatal: false,
      error,
      err: error,
      reason
    });
  }
  handleFlushResult(results, chunkMeta) {
    results.forEach(result => {
      this.handleTransmuxComplete(result);
    });
    this.onFlush(chunkMeta);
  }
  onWorkerMessage(event) {
    const data = event.data;
    if (!(data != null && data.event)) {
      logger.warn(`worker message received with no ${data ? 'event name' : 'data'}`);
      return;
    }
    const hls = this.hls;
    if (!this.hls) {
      return;
    }
    switch (data.event) {
      case 'init':
        {
          var _this$workerContext;
          const objectURL = (_this$workerContext = this.workerContext) == null ? void 0 : _this$workerContext.objectURL;
          if (objectURL) {
            // revoke the Object URL that was used to create transmuxer worker, so as not to leak it
            self.URL.revokeObjectURL(objectURL);
          }
          break;
        }
      case 'transmuxComplete':
        {
          this.handleTransmuxComplete(data.data);
          break;
        }
      case 'flush':
        {
          this.onFlush(data.data);
          break;
        }

      // pass logs from the worker thread to the main logger
      case 'workerLog':
        if (logger[data.data.logType]) {
          logger[data.data.logType](data.data.message);
        }
        break;
      default:
        {
          data.data = data.data || {};
          data.data.frag = this.frag;
          data.data.id = this.id;
          hls.trigger(data.event, data.data);
          break;
        }
    }
  }
  configureTransmuxer(config) {
    const {
      transmuxer
    } = this;
    if (this.workerContext) {
      this.workerContext.worker.postMessage({
        cmd: 'configure',
        config
      });
    } else if (transmuxer) {
      transmuxer.configure(config);
    }
  }
  handleTransmuxComplete(result) {
    result.chunkMeta.transmuxing.end = self.performance.now();
    this.onTransmuxComplete(result);
  }
}

function subtitleOptionsIdentical(trackList1, trackList2) {
  if (trackList1.length !== trackList2.length) {
    return false;
  }
  for (let i = 0; i < trackList1.length; i++) {
    if (!mediaAttributesIdentical(trackList1[i].attrs, trackList2[i].attrs)) {
      return false;
    }
  }
  return true;
}
function mediaAttributesIdentical(attrs1, attrs2, customAttributes) {
  // Media options with the same rendition ID must be bit identical
  const stableRenditionId = attrs1['STABLE-RENDITION-ID'];
  if (stableRenditionId && !customAttributes) {
    return stableRenditionId === attrs2['STABLE-RENDITION-ID'];
  }
  // When rendition ID is not present, compare attributes
  return !(customAttributes || ['LANGUAGE', 'NAME', 'CHARACTERISTICS', 'AUTOSELECT', 'DEFAULT', 'FORCED', 'ASSOC-LANGUAGE']).some(subtitleAttribute => attrs1[subtitleAttribute] !== attrs2[subtitleAttribute]);
}
function subtitleTrackMatchesTextTrack(subtitleTrack, textTrack) {
  return textTrack.label.toLowerCase() === subtitleTrack.name.toLowerCase() && (!textTrack.language || textTrack.language.toLowerCase() === (subtitleTrack.lang || '').toLowerCase());
}

const TICK_INTERVAL$2 = 100; // how often to tick in ms

class AudioStreamController extends BaseStreamController {
  constructor(hls, fragmentTracker, keyLoader) {
    super(hls, fragmentTracker, keyLoader, '[audio-stream-controller]', PlaylistLevelType.AUDIO);
    this.videoBuffer = null;
    this.videoTrackCC = -1;
    this.waitingVideoCC = -1;
    this.bufferedTrack = null;
    this.switchingTrack = null;
    this.trackId = -1;
    this.waitingData = null;
    this.mainDetails = null;
    this.flushing = false;
    this.bufferFlushed = false;
    this.cachedTrackLoadedData = null;
    this._registerListeners();
  }
  onHandlerDestroying() {
    this._unregisterListeners();
    super.onHandlerDestroying();
    this.mainDetails = null;
    this.bufferedTrack = null;
    this.switchingTrack = null;
  }
  _registerListeners() {
    const {
      hls
    } = this;
    hls.on(Events.MEDIA_ATTACHED, this.onMediaAttached, this);
    hls.on(Events.MEDIA_DETACHING, this.onMediaDetaching, this);
    hls.on(Events.MANIFEST_LOADING, this.onManifestLoading, this);
    hls.on(Events.LEVEL_LOADED, this.onLevelLoaded, this);
    hls.on(Events.AUDIO_TRACKS_UPDATED, this.onAudioTracksUpdated, this);
    hls.on(Events.AUDIO_TRACK_SWITCHING, this.onAudioTrackSwitching, this);
    hls.on(Events.AUDIO_TRACK_LOADED, this.onAudioTrackLoaded, this);
    hls.on(Events.ERROR, this.onError, this);
    hls.on(Events.BUFFER_RESET, this.onBufferReset, this);
    hls.on(Events.BUFFER_CREATED, this.onBufferCreated, this);
    hls.on(Events.BUFFER_FLUSHING, this.onBufferFlushing, this);
    hls.on(Events.BUFFER_FLUSHED, this.onBufferFlushed, this);
    hls.on(Events.INIT_PTS_FOUND, this.onInitPtsFound, this);
    hls.on(Events.FRAG_BUFFERED, this.onFragBuffered, this);
  }
  _unregisterListeners() {
    const {
      hls
    } = this;
    hls.off(Events.MEDIA_ATTACHED, this.onMediaAttached, this);
    hls.off(Events.MEDIA_DETACHING, this.onMediaDetaching, this);
    hls.off(Events.MANIFEST_LOADING, this.onManifestLoading, this);
    hls.off(Events.LEVEL_LOADED, this.onLevelLoaded, this);
    hls.off(Events.AUDIO_TRACKS_UPDATED, this.onAudioTracksUpdated, this);
    hls.off(Events.AUDIO_TRACK_SWITCHING, this.onAudioTrackSwitching, this);
    hls.off(Events.AUDIO_TRACK_LOADED, this.onAudioTrackLoaded, this);
    hls.off(Events.ERROR, this.onError, this);
    hls.off(Events.BUFFER_RESET, this.onBufferReset, this);
    hls.off(Events.BUFFER_CREATED, this.onBufferCreated, this);
    hls.off(Events.BUFFER_FLUSHING, this.onBufferFlushing, this);
    hls.off(Events.BUFFER_FLUSHED, this.onBufferFlushed, this);
    hls.off(Events.INIT_PTS_FOUND, this.onInitPtsFound, this);
    hls.off(Events.FRAG_BUFFERED, this.onFragBuffered, this);
  }

  // INIT_PTS_FOUND is triggered when the video track parsed in the stream-controller has a new PTS value
  onInitPtsFound(event, {
    frag,
    id,
    initPTS,
    timescale
  }) {
    // Always update the new INIT PTS
    // Can change due level switch
    if (id === 'main') {
      const cc = frag.cc;
      this.initPTS[frag.cc] = {
        baseTime: initPTS,
        timescale
      };
      this.log(`InitPTS for cc: ${cc} found from main: ${initPTS}`);
      this.videoTrackCC = cc;
      // If we are waiting, tick immediately to unblock audio fragment transmuxing
      if (this.state === State.WAITING_INIT_PTS) {
        this.tick();
      }
    }
  }
  startLoad(startPosition) {
    if (!this.levels) {
      this.startPosition = startPosition;
      this.state = State.STOPPED;
      return;
    }
    const lastCurrentTime = this.lastCurrentTime;
    this.stopLoad();
    this.setInterval(TICK_INTERVAL$2);
    if (lastCurrentTime > 0 && startPosition === -1) {
      this.log(`Override startPosition with lastCurrentTime @${lastCurrentTime.toFixed(3)}`);
      startPosition = lastCurrentTime;
      this.state = State.IDLE;
    } else {
      this.loadedmetadata = false;
      this.state = State.WAITING_TRACK;
    }
    this.nextLoadPosition = this.startPosition = this.lastCurrentTime = startPosition;
    this.tick();
  }
  doTick() {
    switch (this.state) {
      case State.IDLE:
        this.doTickIdle();
        break;
      case State.WAITING_TRACK:
        {
          var _levels$trackId;
          const {
            levels,
            trackId
          } = this;
          const details = levels == null ? void 0 : (_levels$trackId = levels[trackId]) == null ? void 0 : _levels$trackId.details;
          if (details) {
            if (this.waitForCdnTuneIn(details)) {
              break;
            }
            this.state = State.WAITING_INIT_PTS;
          }
          break;
        }
      case State.FRAG_LOADING_WAITING_RETRY:
        {
          var _this$media;
          const now = performance.now();
          const retryDate = this.retryDate;
          // if current time is gt than retryDate, or if media seeking let's switch to IDLE state to retry loading
          if (!retryDate || now >= retryDate || (_this$media = this.media) != null && _this$media.seeking) {
            const {
              levels,
              trackId
            } = this;
            this.log('RetryDate reached, switch back to IDLE state');
            this.resetStartWhenNotLoaded((levels == null ? void 0 : levels[trackId]) || null);
            this.state = State.IDLE;
          }
          break;
        }
      case State.WAITING_INIT_PTS:
        {
          // Ensure we don't get stuck in the WAITING_INIT_PTS state if the waiting frag CC doesn't match any initPTS
          const waitingData = this.waitingData;
          if (waitingData) {
            const {
              frag,
              part,
              cache,
              complete
            } = waitingData;
            if (this.initPTS[frag.cc] !== undefined) {
              this.waitingData = null;
              this.waitingVideoCC = -1;
              this.state = State.FRAG_LOADING;
              const payload = cache.flush();
              const data = {
                frag,
                part,
                payload,
                networkDetails: null
              };
              this._handleFragmentLoadProgress(data);
              if (complete) {
                super._handleFragmentLoadComplete(data);
              }
            } else if (this.videoTrackCC !== this.waitingVideoCC) {
              // Drop waiting fragment if videoTrackCC has changed since waitingFragment was set and initPTS was not found
              this.log(`Waiting fragment cc (${frag.cc}) cancelled because video is at cc ${this.videoTrackCC}`);
              this.clearWaitingFragment();
            } else {
              // Drop waiting fragment if an earlier fragment is needed
              const pos = this.getLoadPosition();
              const bufferInfo = BufferHelper.bufferInfo(this.mediaBuffer, pos, this.config.maxBufferHole);
              const waitingFragmentAtPosition = fragmentWithinToleranceTest(bufferInfo.end, this.config.maxFragLookUpTolerance, frag);
              if (waitingFragmentAtPosition < 0) {
                this.log(`Waiting fragment cc (${frag.cc}) @ ${frag.start} cancelled because another fragment at ${bufferInfo.end} is needed`);
                this.clearWaitingFragment();
              }
            }
          } else {
            this.state = State.IDLE;
          }
        }
    }
    this.onTickEnd();
  }
  clearWaitingFragment() {
    const waitingData = this.waitingData;
    if (waitingData) {
      this.fragmentTracker.removeFragment(waitingData.frag);
      this.waitingData = null;
      this.waitingVideoCC = -1;
      this.state = State.IDLE;
    }
  }
  resetLoadingState() {
    this.clearWaitingFragment();
    super.resetLoadingState();
  }
  onTickEnd() {
    const {
      media
    } = this;
    if (!(media != null && media.readyState)) {
      // Exit early if we don't have media or if the media hasn't buffered anything yet (readyState 0)
      return;
    }
    this.lastCurrentTime = media.currentTime;
  }
  doTickIdle() {
    const {
      hls,
      levels,
      media,
      trackId
    } = this;
    const config = hls.config;

    // 1. if video not attached AND
    //    start fragment already requested OR start frag prefetch not enabled
    // 2. if tracks or track not loaded and selected
    // then exit loop
    // => if media not attached but start frag prefetch is enabled and start frag not requested yet, we will not exit loop
    if (!media && (this.startFragRequested || !config.startFragPrefetch) || !(levels != null && levels[trackId])) {
      return;
    }
    const levelInfo = levels[trackId];
    const trackDetails = levelInfo.details;
    if (!trackDetails || trackDetails.live && this.levelLastLoaded !== levelInfo || this.waitForCdnTuneIn(trackDetails)) {
      this.state = State.WAITING_TRACK;
      return;
    }
    const bufferable = this.mediaBuffer ? this.mediaBuffer : this.media;
    if (this.bufferFlushed && bufferable) {
      this.bufferFlushed = false;
      this.afterBufferFlushed(bufferable, ElementaryStreamTypes.AUDIO, PlaylistLevelType.AUDIO);
    }
    const bufferInfo = this.getFwdBufferInfo(bufferable, PlaylistLevelType.AUDIO);
    if (bufferInfo === null) {
      return;
    }
    const {
      bufferedTrack,
      switchingTrack
    } = this;
    if (!switchingTrack && this._streamEnded(bufferInfo, trackDetails)) {
      hls.trigger(Events.BUFFER_EOS, {
        type: 'audio'
      });
      this.state = State.ENDED;
      return;
    }
    const mainBufferInfo = this.getFwdBufferInfo(this.videoBuffer ? this.videoBuffer : this.media, PlaylistLevelType.MAIN);
    const bufferLen = bufferInfo.len;
    const maxBufLen = this.getMaxBufferLength(mainBufferInfo == null ? void 0 : mainBufferInfo.len);
    const fragments = trackDetails.fragments;
    const start = fragments[0].start;
    let targetBufferTime = this.flushing ? this.getLoadPosition() : bufferInfo.end;
    if (switchingTrack && media) {
      const pos = this.getLoadPosition();
      // STABLE
      if (bufferedTrack && !mediaAttributesIdentical(switchingTrack.attrs, bufferedTrack.attrs)) {
        targetBufferTime = pos;
      }
      // if currentTime (pos) is less than alt audio playlist start time, it means that alt audio is ahead of currentTime
      if (trackDetails.PTSKnown && pos < start) {
        // if everything is buffered from pos to start or if audio buffer upfront, let's seek to start
        if (bufferInfo.end > start || bufferInfo.nextStart) {
          this.log('Alt audio track ahead of main track, seek to start of alt audio track');
          media.currentTime = start + 0.05;
        }
      }
    }

    // if buffer length is less than maxBufLen, or near the end, find a fragment to load
    if (bufferLen >= maxBufLen && !switchingTrack && targetBufferTime < fragments[fragments.length - 1].start) {
      return;
    }
    let frag = this.getNextFragment(targetBufferTime, trackDetails);
    let atGap = false;
    // Avoid loop loading by using nextLoadPosition set for backtracking and skipping consecutive GAP tags
    if (frag && this.isLoopLoading(frag, targetBufferTime)) {
      atGap = !!frag.gap;
      frag = this.getNextFragmentLoopLoading(frag, trackDetails, bufferInfo, PlaylistLevelType.MAIN, maxBufLen);
    }
    if (!frag) {
      this.bufferFlushed = true;
      return;
    }

    // Buffer audio up to one target duration ahead of main buffer
    const atBufferSyncLimit = mainBufferInfo && frag.start > mainBufferInfo.end + trackDetails.targetduration;
    if (atBufferSyncLimit ||
    // Or wait for main buffer after buffing some audio
    !(mainBufferInfo != null && mainBufferInfo.len) && bufferInfo.len) {
      // Check fragment-tracker for main fragments since GAP segments do not show up in bufferInfo
      const mainFrag = this.getAppendedFrag(frag.start, PlaylistLevelType.MAIN);
      if (mainFrag === null) {
        return;
      }
      // Bridge gaps in main buffer
      atGap || (atGap = !!mainFrag.gap || !!atBufferSyncLimit && mainBufferInfo.len === 0);
      if (atBufferSyncLimit && !atGap || atGap && bufferInfo.nextStart && bufferInfo.nextStart < mainFrag.end) {
        return;
      }
    }
    this.loadFragment(frag, levelInfo, targetBufferTime);
  }
  getMaxBufferLength(mainBufferLength) {
    const maxConfigBuffer = super.getMaxBufferLength();
    if (!mainBufferLength) {
      return maxConfigBuffer;
    }
    return Math.min(Math.max(maxConfigBuffer, mainBufferLength), this.config.maxMaxBufferLength);
  }
  onMediaDetaching() {
    this.videoBuffer = null;
    this.bufferFlushed = this.flushing = false;
    super.onMediaDetaching();
  }
  onAudioTracksUpdated(event, {
    audioTracks
  }) {
    // Reset tranxmuxer is essential for large context switches (Content Steering)
    this.resetTransmuxer();
    this.levels = audioTracks.map(mediaPlaylist => new Level(mediaPlaylist));
  }
  onAudioTrackSwitching(event, data) {
    // if any URL found on new audio track, it is an alternate audio track
    const altAudio = !!data.url;
    this.trackId = data.id;
    const {
      fragCurrent
    } = this;
    if (fragCurrent) {
      fragCurrent.abortRequests();
      this.removeUnbufferedFrags(fragCurrent.start);
    }
    this.resetLoadingState();
    // destroy useless transmuxer when switching audio to main
    if (!altAudio) {
      this.resetTransmuxer();
    } else {
      // switching to audio track, start timer if not already started
      this.setInterval(TICK_INTERVAL$2);
    }

    // should we switch tracks ?
    if (altAudio) {
      this.switchingTrack = data;
      // main audio track are handled by stream-controller, just do something if switching to alt audio track
      this.state = State.IDLE;
      this.flushAudioIfNeeded(data);
    } else {
      this.switchingTrack = null;
      this.bufferedTrack = data;
      this.state = State.STOPPED;
    }
    this.tick();
  }
  onManifestLoading() {
    this.fragmentTracker.removeAllFragments();
    this.startPosition = this.lastCurrentTime = 0;
    this.bufferFlushed = this.flushing = false;
    this.levels = this.mainDetails = this.waitingData = this.bufferedTrack = this.cachedTrackLoadedData = this.switchingTrack = null;
    this.startFragRequested = false;
    this.trackId = this.videoTrackCC = this.waitingVideoCC = -1;
  }
  onLevelLoaded(event, data) {
    this.mainDetails = data.details;
    if (this.cachedTrackLoadedData !== null) {
      this.hls.trigger(Events.AUDIO_TRACK_LOADED, this.cachedTrackLoadedData);
      this.cachedTrackLoadedData = null;
    }
  }
  onAudioTrackLoaded(event, data) {
    var _track$details;
    if (this.mainDetails == null) {
      this.cachedTrackLoadedData = data;
      return;
    }
    const {
      levels
    } = this;
    const {
      details: newDetails,
      id: trackId
    } = data;
    if (!levels) {
      this.warn(`Audio tracks were reset while loading level ${trackId}`);
      return;
    }
    this.log(`Audio track ${trackId} loaded [${newDetails.startSN},${newDetails.endSN}]${newDetails.lastPartSn ? `[part-${newDetails.lastPartSn}-${newDetails.lastPartIndex}]` : ''},duration:${newDetails.totalduration}`);
    const track = levels[trackId];
    let sliding = 0;
    if (newDetails.live || (_track$details = track.details) != null && _track$details.live) {
      this.checkLiveUpdate(newDetails);
      const mainDetails = this.mainDetails;
      if (newDetails.deltaUpdateFailed || !mainDetails) {
        return;
      }
      if (!track.details && newDetails.hasProgramDateTime && mainDetails.hasProgramDateTime) {
        // Make sure our audio rendition is aligned with the "main" rendition, using
        // pdt as our reference times.
        alignMediaPlaylistByPDT(newDetails, mainDetails);
        sliding = newDetails.fragments[0].start;
      } else {
        var _this$levelLastLoaded;
        sliding = this.alignPlaylists(newDetails, track.details, (_this$levelLastLoaded = this.levelLastLoaded) == null ? void 0 : _this$levelLastLoaded.details);
      }
    }
    track.details = newDetails;
    this.levelLastLoaded = track;

    // compute start position if we are aligned with the main playlist
    if (!this.startFragRequested && (this.mainDetails || !newDetails.live)) {
      this.setStartPosition(this.mainDetails || newDetails, sliding);
    }
    // only switch back to IDLE state if we were waiting for track to start downloading a new fragment
    if (this.state === State.WAITING_TRACK && !this.waitForCdnTuneIn(newDetails)) {
      this.state = State.IDLE;
    }

    // trigger handler right now
    this.tick();
  }
  _handleFragmentLoadProgress(data) {
    var _frag$initSegment;
    const {
      frag,
      part,
      payload
    } = data;
    const {
      config,
      trackId,
      levels
    } = this;
    if (!levels) {
      this.warn(`Audio tracks were reset while fragment load was in progress. Fragment ${frag.sn} of level ${frag.level} will not be buffered`);
      return;
    }
    const track = levels[trackId];
    if (!track) {
      this.warn('Audio track is undefined on fragment load progress');
      return;
    }
    const details = track.details;
    if (!details) {
      this.warn('Audio track details undefined on fragment load progress');
      this.removeUnbufferedFrags(frag.start);
      return;
    }
    const audioCodec = config.defaultAudioCodec || track.audioCodec || 'mp4a.40.2';
    let transmuxer = this.transmuxer;
    if (!transmuxer) {
      transmuxer = this.transmuxer = new TransmuxerInterface(this.hls, PlaylistLevelType.AUDIO, this._handleTransmuxComplete.bind(this), this._handleTransmuxerFlush.bind(this));
    }

    // Check if we have video initPTS
    // If not we need to wait for it
    const initPTS = this.initPTS[frag.cc];
    const initSegmentData = (_frag$initSegment = frag.initSegment) == null ? void 0 : _frag$initSegment.data;
    if (initPTS !== undefined) {
      // this.log(`Transmuxing ${sn} of [${details.startSN} ,${details.endSN}],track ${trackId}`);
      // time Offset is accurate if level PTS is known, or if playlist is not sliding (not live)
      const accurateTimeOffset = false; // details.PTSKnown || !details.live;
      const partIndex = part ? part.index : -1;
      const partial = partIndex !== -1;
      const chunkMeta = new ChunkMetadata(frag.level, frag.sn, frag.stats.chunkCount, payload.byteLength, partIndex, partial);
      transmuxer.push(payload, initSegmentData, audioCodec, '', frag, part, details.totalduration, accurateTimeOffset, chunkMeta, initPTS);
    } else {
      this.log(`Unknown video PTS for cc ${frag.cc}, waiting for video PTS before demuxing audio frag ${frag.sn} of [${details.startSN} ,${details.endSN}],track ${trackId}`);
      const {
        cache
      } = this.waitingData = this.waitingData || {
        frag,
        part,
        cache: new ChunkCache(),
        complete: false
      };
      cache.push(new Uint8Array(payload));
      this.waitingVideoCC = this.videoTrackCC;
      this.state = State.WAITING_INIT_PTS;
    }
  }
  _handleFragmentLoadComplete(fragLoadedData) {
    if (this.waitingData) {
      this.waitingData.complete = true;
      return;
    }
    super._handleFragmentLoadComplete(fragLoadedData);
  }
  onBufferReset( /* event: Events.BUFFER_RESET */
  ) {
    // reset reference to sourcebuffers
    this.mediaBuffer = this.videoBuffer = null;
    this.loadedmetadata = false;
  }
  onBufferCreated(event, data) {
    const audioTrack = data.tracks.audio;
    if (audioTrack) {
      this.mediaBuffer = audioTrack.buffer || null;
    }
    if (data.tracks.video) {
      this.videoBuffer = data.tracks.video.buffer || null;
    }
  }
  onFragBuffered(event, data) {
    const {
      frag,
      part
    } = data;
    if (frag.type !== PlaylistLevelType.AUDIO) {
      if (!this.loadedmetadata && frag.type === PlaylistLevelType.MAIN) {
        const bufferable = this.videoBuffer || this.media;
        if (bufferable) {
          const bufferedTimeRanges = BufferHelper.getBuffered(bufferable);
          if (bufferedTimeRanges.length) {
            this.loadedmetadata = true;
          }
        }
      }
      return;
    }
    if (this.fragContextChanged(frag)) {
      // If a level switch was requested while a fragment was buffering, it will emit the FRAG_BUFFERED event upon completion
      // Avoid setting state back to IDLE or concluding the audio switch; otherwise, the switched-to track will not buffer
      this.warn(`Fragment ${frag.sn}${part ? ' p: ' + part.index : ''} of level ${frag.level} finished buffering, but was aborted. state: ${this.state}, audioSwitch: ${this.switchingTrack ? this.switchingTrack.name : 'false'}`);
      return;
    }
    if (frag.sn !== 'initSegment') {
      this.fragPrevious = frag;
      const track = this.switchingTrack;
      if (track) {
        this.bufferedTrack = track;
        this.switchingTrack = null;
        this.hls.trigger(Events.AUDIO_TRACK_SWITCHED, _objectSpread2({}, track));
      }
    }
    this.fragBufferedComplete(frag, part);
  }
  onError(event, data) {
    var _data$context;
    if (data.fatal) {
      this.state = State.ERROR;
      return;
    }
    switch (data.details) {
      case ErrorDetails.FRAG_GAP:
      case ErrorDetails.FRAG_PARSING_ERROR:
      case ErrorDetails.FRAG_DECRYPT_ERROR:
      case ErrorDetails.FRAG_LOAD_ERROR:
      case ErrorDetails.FRAG_LOAD_TIMEOUT:
      case ErrorDetails.KEY_LOAD_ERROR:
      case ErrorDetails.KEY_LOAD_TIMEOUT:
        this.onFragmentOrKeyLoadError(PlaylistLevelType.AUDIO, data);
        break;
      case ErrorDetails.AUDIO_TRACK_LOAD_ERROR:
      case ErrorDetails.AUDIO_TRACK_LOAD_TIMEOUT:
      case ErrorDetails.LEVEL_PARSING_ERROR:
        // in case of non fatal error while loading track, if not retrying to load track, switch back to IDLE
        if (!data.levelRetry && this.state === State.WAITING_TRACK && ((_data$context = data.context) == null ? void 0 : _data$context.type) === PlaylistContextType.AUDIO_TRACK) {
          this.state = State.IDLE;
        }
        break;
      case ErrorDetails.BUFFER_APPEND_ERROR:
      case ErrorDetails.BUFFER_FULL_ERROR:
        if (!data.parent || data.parent !== 'audio') {
          return;
        }
        if (data.details === ErrorDetails.BUFFER_APPEND_ERROR) {
          this.resetLoadingState();
          return;
        }
        if (this.reduceLengthAndFlushBuffer(data)) {
          this.bufferedTrack = null;
          super.flushMainBuffer(0, Number.POSITIVE_INFINITY, 'audio');
        }
        break;
      case ErrorDetails.INTERNAL_EXCEPTION:
        this.recoverWorkerError(data);
        break;
    }
  }
  onBufferFlushing(event, {
    type
  }) {
    if (type !== ElementaryStreamTypes.VIDEO) {
      this.flushing = true;
    }
  }
  onBufferFlushed(event, {
    type
  }) {
    if (type !== ElementaryStreamTypes.VIDEO) {
      this.flushing = false;
      this.bufferFlushed = true;
      if (this.state === State.ENDED) {
        this.state = State.IDLE;
      }
      const mediaBuffer = this.mediaBuffer || this.media;
      if (mediaBuffer) {
        this.afterBufferFlushed(mediaBuffer, type, PlaylistLevelType.AUDIO);
        this.tick();
      }
    }
  }
  _handleTransmuxComplete(transmuxResult) {
    var _id3$samples;
    const id = 'audio';
    const {
      hls
    } = this;
    const {
      remuxResult,
      chunkMeta
    } = transmuxResult;
    const context = this.getCurrentContext(chunkMeta);
    if (!context) {
      this.resetWhenMissingContext(chunkMeta);
      return;
    }
    const {
      frag,
      part,
      level
    } = context;
    const {
      details
    } = level;
    const {
      audio,
      text,
      id3,
      initSegment
    } = remuxResult;

    // Check if the current fragment has been aborted. We check this by first seeing if we're still playing the current level.
    // If we are, subsequently check if the currently loading fragment (fragCurrent) has changed.
    if (this.fragContextChanged(frag) || !details) {
      this.fragmentTracker.removeFragment(frag);
      return;
    }
    this.state = State.PARSING;
    if (this.switchingTrack && audio) {
      this.completeAudioSwitch(this.switchingTrack);
    }
    if (initSegment != null && initSegment.tracks) {
      const mapFragment = frag.initSegment || frag;
      this._bufferInitSegment(level, initSegment.tracks, mapFragment, chunkMeta);
      hls.trigger(Events.FRAG_PARSING_INIT_SEGMENT, {
        frag: mapFragment,
        id,
        tracks: initSegment.tracks
      });
      // Only flush audio from old audio tracks when PTS is known on new audio track
    }
    if (audio) {
      const {
        startPTS,
        endPTS,
        startDTS,
        endDTS
      } = audio;
      if (part) {
        part.elementaryStreams[ElementaryStreamTypes.AUDIO] = {
          startPTS,
          endPTS,
          startDTS,
          endDTS
        };
      }
      frag.setElementaryStreamInfo(ElementaryStreamTypes.AUDIO, startPTS, endPTS, startDTS, endDTS);
      this.bufferFragmentData(audio, frag, part, chunkMeta);
    }
    if (id3 != null && (_id3$samples = id3.samples) != null && _id3$samples.length) {
      const emittedID3 = _extends({
        id,
        frag,
        details
      }, id3);
      hls.trigger(Events.FRAG_PARSING_METADATA, emittedID3);
    }
    if (text) {
      const emittedText = _extends({
        id,
        frag,
        details
      }, text);
      hls.trigger(Events.FRAG_PARSING_USERDATA, emittedText);
    }
  }
  _bufferInitSegment(currentLevel, tracks, frag, chunkMeta) {
    if (this.state !== State.PARSING) {
      return;
    }
    // delete any video track found on audio transmuxer
    if (tracks.video) {
      delete tracks.video;
    }

    // include levelCodec in audio and video tracks
    const track = tracks.audio;
    if (!track) {
      return;
    }
    track.id = 'audio';
    const variantAudioCodecs = currentLevel.audioCodec;
    this.log(`Init audio buffer, container:${track.container}, codecs[level/parsed]=[${variantAudioCodecs}/${track.codec}]`);
    // SourceBuffer will use track.levelCodec if defined
    if (variantAudioCodecs && variantAudioCodecs.split(',').length === 1) {
      track.levelCodec = variantAudioCodecs;
    }
    this.hls.trigger(Events.BUFFER_CODECS, tracks);
    const initSegment = track.initSegment;
    if (initSegment != null && initSegment.byteLength) {
      const segment = {
        type: 'audio',
        frag,
        part: null,
        chunkMeta,
        parent: frag.type,
        data: initSegment
      };
      this.hls.trigger(Events.BUFFER_APPENDING, segment);
    }
    // trigger handler right now
    this.tickImmediate();
  }
  loadFragment(frag, track, targetBufferTime) {
    // only load if fragment is not loaded or if in audio switch
    const fragState = this.fragmentTracker.getState(frag);
    this.fragCurrent = frag;

    // we force a frag loading in audio switch as fragment tracker might not have evicted previous frags in case of quick audio switch
    if (this.switchingTrack || fragState === FragmentState.NOT_LOADED || fragState === FragmentState.PARTIAL) {
      var _track$details2;
      if (frag.sn === 'initSegment') {
        this._loadInitSegment(frag, track);
      } else if ((_track$details2 = track.details) != null && _track$details2.live && !this.initPTS[frag.cc]) {
        this.log(`Waiting for video PTS in continuity counter ${frag.cc} of live stream before loading audio fragment ${frag.sn} of level ${this.trackId}`);
        this.state = State.WAITING_INIT_PTS;
        const mainDetails = this.mainDetails;
        if (mainDetails && mainDetails.fragments[0].start !== track.details.fragments[0].start) {
          alignMediaPlaylistByPDT(track.details, mainDetails);
        }
      } else {
        this.startFragRequested = true;
        super.loadFragment(frag, track, targetBufferTime);
      }
    } else {
      this.clearTrackerIfNeeded(frag);
    }
  }
  flushAudioIfNeeded(switchingTrack) {
    const {
      media,
      bufferedTrack
    } = this;
    const bufferedAttributes = bufferedTrack == null ? void 0 : bufferedTrack.attrs;
    const switchAttributes = switchingTrack.attrs;
    if (media && bufferedAttributes && (bufferedAttributes.CHANNELS !== switchAttributes.CHANNELS || bufferedTrack.name !== switchingTrack.name || bufferedTrack.lang !== switchingTrack.lang)) {
      this.log('Switching audio track : flushing all audio');
      super.flushMainBuffer(0, Number.POSITIVE_INFINITY, 'audio');
      this.bufferedTrack = null;
    }
  }
  completeAudioSwitch(switchingTrack) {
    const {
      hls
    } = this;
    this.flushAudioIfNeeded(switchingTrack);
    this.bufferedTrack = switchingTrack;
    this.switchingTrack = null;
    hls.trigger(Events.AUDIO_TRACK_SWITCHED, _objectSpread2({}, switchingTrack));
  }
}

class AudioTrackController extends BasePlaylistController {
  constructor(hls) {
    super(hls, '[audio-track-controller]');
    this.tracks = [];
    this.groupIds = null;
    this.tracksInGroup = [];
    this.trackId = -1;
    this.currentTrack = null;
    this.selectDefaultTrack = true;
    this.registerListeners();
  }
  registerListeners() {
    const {
      hls
    } = this;
    hls.on(Events.MANIFEST_LOADING, this.onManifestLoading, this);
    hls.on(Events.MANIFEST_PARSED, this.onManifestParsed, this);
    hls.on(Events.LEVEL_LOADING, this.onLevelLoading, this);
    hls.on(Events.LEVEL_SWITCHING, this.onLevelSwitching, this);
    hls.on(Events.AUDIO_TRACK_LOADED, this.onAudioTrackLoaded, this);
    hls.on(Events.ERROR, this.onError, this);
  }
  unregisterListeners() {
    const {
      hls
    } = this;
    hls.off(Events.MANIFEST_LOADING, this.onManifestLoading, this);
    hls.off(Events.MANIFEST_PARSED, this.onManifestParsed, this);
    hls.off(Events.LEVEL_LOADING, this.onLevelLoading, this);
    hls.off(Events.LEVEL_SWITCHING, this.onLevelSwitching, this);
    hls.off(Events.AUDIO_TRACK_LOADED, this.onAudioTrackLoaded, this);
    hls.off(Events.ERROR, this.onError, this);
  }
  destroy() {
    this.unregisterListeners();
    this.tracks.length = 0;
    this.tracksInGroup.length = 0;
    this.currentTrack = null;
    super.destroy();
  }
  onManifestLoading() {
    this.tracks = [];
    this.tracksInGroup = [];
    this.groupIds = null;
    this.currentTrack = null;
    this.trackId = -1;
    this.selectDefaultTrack = true;
  }
  onManifestParsed(event, data) {
    this.tracks = data.audioTracks || [];
  }
  onAudioTrackLoaded(event, data) {
    const {
      id,
      groupId,
      details
    } = data;
    const trackInActiveGroup = this.tracksInGroup[id];
    if (!trackInActiveGroup || trackInActiveGroup.groupId !== groupId) {
      this.warn(`Audio track with id:${id} and group:${groupId} not found in active group ${trackInActiveGroup == null ? void 0 : trackInActiveGroup.groupId}`);
      return;
    }
    const curDetails = trackInActiveGroup.details;
    trackInActiveGroup.details = data.details;
    this.log(`Audio track ${id} "${trackInActiveGroup.name}" lang:${trackInActiveGroup.lang} group:${groupId} loaded [${details.startSN}-${details.endSN}]`);
    if (id === this.trackId) {
      this.playlistLoaded(id, data, curDetails);
    }
  }
  onLevelLoading(event, data) {
    this.switchLevel(data.level);
  }
  onLevelSwitching(event, data) {
    this.switchLevel(data.level);
  }
  switchLevel(levelIndex) {
    const levelInfo = this.hls.levels[levelIndex];
    if (!levelInfo) {
      return;
    }
    const audioGroups = levelInfo.audioGroups || null;
    const currentGroups = this.groupIds;
    let currentTrack = this.currentTrack;
    if (!audioGroups || (currentGroups == null ? void 0 : currentGroups.length) !== (audioGroups == null ? void 0 : audioGroups.length) || audioGroups != null && audioGroups.some(groupId => (currentGroups == null ? void 0 : currentGroups.indexOf(groupId)) === -1)) {
      this.groupIds = audioGroups;
      this.trackId = -1;
      this.currentTrack = null;
      const audioTracks = this.tracks.filter(track => !audioGroups || audioGroups.indexOf(track.groupId) !== -1);
      if (audioTracks.length) {
        // Disable selectDefaultTrack if there are no default tracks
        if (this.selectDefaultTrack && !audioTracks.some(track => track.default)) {
          this.selectDefaultTrack = false;
        }
        // track.id should match hls.audioTracks index
        audioTracks.forEach((track, i) => {
          track.id = i;
        });
      } else if (!currentTrack && !this.tracksInGroup.length) {
        // Do not dispatch AUDIO_TRACKS_UPDATED when there were and are no tracks
        return;
      }
      this.tracksInGroup = audioTracks;

      // Find preferred track
      const audioPreference = this.hls.config.audioPreference;
      if (!currentTrack && audioPreference) {
        const groupIndex = findMatchingOption(audioPreference, audioTracks, audioMatchPredicate);
        if (groupIndex > -1) {
          currentTrack = audioTracks[groupIndex];
        } else {
          const allIndex = findMatchingOption(audioPreference, this.tracks);
          currentTrack = this.tracks[allIndex];
        }
      }

      // Select initial track
      let trackId = this.findTrackId(currentTrack);
      if (trackId === -1 && currentTrack) {
        trackId = this.findTrackId(null);
      }

      // Dispatch events and load track if needed
      const audioTracksUpdated = {
        audioTracks
      };
      this.log(`Updating audio tracks, ${audioTracks.length} track(s) found in group(s): ${audioGroups == null ? void 0 : audioGroups.join(',')}`);
      this.hls.trigger(Events.AUDIO_TRACKS_UPDATED, audioTracksUpdated);
      const selectedTrackId = this.trackId;
      if (trackId !== -1 && selectedTrackId === -1) {
        this.setAudioTrack(trackId);
      } else if (audioTracks.length && selectedTrackId === -1) {
        var _this$groupIds;
        const error = new Error(`No audio track selected for current audio group-ID(s): ${(_this$groupIds = this.groupIds) == null ? void 0 : _this$groupIds.join(',')} track count: ${audioTracks.length}`);
        this.warn(error.message);
        this.hls.trigger(Events.ERROR, {
          type: ErrorTypes.MEDIA_ERROR,
          details: ErrorDetails.AUDIO_TRACK_LOAD_ERROR,
          fatal: true,
          error
        });
      }
    } else if (this.shouldReloadPlaylist(currentTrack)) {
      // Retry playlist loading if no playlist is or has been loaded yet
      this.setAudioTrack(this.trackId);
    }
  }
  onError(event, data) {
    if (data.fatal || !data.context) {
      return;
    }
    if (data.context.type === PlaylistContextType.AUDIO_TRACK && data.context.id === this.trackId && (!this.groupIds || this.groupIds.indexOf(data.context.groupId) !== -1)) {
      this.requestScheduled = -1;
      this.checkRetry(data);
    }
  }
  get allAudioTracks() {
    return this.tracks;
  }
  get audioTracks() {
    return this.tracksInGroup;
  }
  get audioTrack() {
    return this.trackId;
  }
  set audioTrack(newId) {
    // If audio track is selected from API then don't choose from the manifest default track
    this.selectDefaultTrack = false;
    this.setAudioTrack(newId);
  }
  setAudioOption(audioOption) {
    const hls = this.hls;
    hls.config.audioPreference = audioOption;
    if (audioOption) {
      const allAudioTracks = this.allAudioTracks;
      this.selectDefaultTrack = false;
      if (allAudioTracks.length) {
        // First see if current option matches (no switch op)
        const currentTrack = this.currentTrack;
        if (currentTrack && matchesOption(audioOption, currentTrack, audioMatchPredicate)) {
          return currentTrack;
        }
        // Find option in available tracks (tracksInGroup)
        const groupIndex = findMatchingOption(audioOption, this.tracksInGroup, audioMatchPredicate);
        if (groupIndex > -1) {
          const track = this.tracksInGroup[groupIndex];
          this.setAudioTrack(groupIndex);
          return track;
        } else if (currentTrack) {
          // Find option in nearest level audio group
          let searchIndex = hls.loadLevel;
          if (searchIndex === -1) {
            searchIndex = hls.firstAutoLevel;
          }
          const switchIndex = findClosestLevelWithAudioGroup(audioOption, hls.levels, allAudioTracks, searchIndex, audioMatchPredicate);
          if (switchIndex === -1) {
            // could not find matching variant
            return null;
          }
          // and switch level to acheive the audio group switch
          hls.nextLoadLevel = switchIndex;
        }
        if (audioOption.channels || audioOption.audioCodec) {
          // Could not find a match with codec / channels predicate
          // Find a match without channels or codec
          const withoutCodecAndChannelsMatch = findMatchingOption(audioOption, allAudioTracks);
          if (withoutCodecAndChannelsMatch > -1) {
            return allAudioTracks[withoutCodecAndChannelsMatch];
          }
        }
      }
    }
    return null;
  }
  setAudioTrack(newId) {
    const tracks = this.tracksInGroup;

    // check if level idx is valid
    if (newId < 0 || newId >= tracks.length) {
      this.warn(`Invalid audio track id: ${newId}`);
      return;
    }

    // stopping live reloading timer if any
    this.clearTimer();
    this.selectDefaultTrack = false;
    const lastTrack = this.currentTrack;
    const track = tracks[newId];
    const trackLoaded = track.details && !track.details.live;
    if (newId === this.trackId && track === lastTrack && trackLoaded) {
      return;
    }
    this.log(`Switching to audio-track ${newId} "${track.name}" lang:${track.lang} group:${track.groupId} channels:${track.channels}`);
    this.trackId = newId;
    this.currentTrack = track;
    this.hls.trigger(Events.AUDIO_TRACK_SWITCHING, _objectSpread2({}, track));
    // Do not reload track unless live
    if (trackLoaded) {
      return;
    }
    const hlsUrlParameters = this.switchParams(track.url, lastTrack == null ? void 0 : lastTrack.details, track.details);
    this.loadPlaylist(hlsUrlParameters);
  }
  findTrackId(currentTrack) {
    const audioTracks = this.tracksInGroup;
    for (let i = 0; i < audioTracks.length; i++) {
      const track = audioTracks[i];
      if (this.selectDefaultTrack && !track.default) {
        continue;
      }
      if (!currentTrack || matchesOption(currentTrack, track, audioMatchPredicate)) {
        return i;
      }
    }
    if (currentTrack) {
      const {
        name,
        lang,
        assocLang,
        characteristics,
        audioCodec,
        channels
      } = currentTrack;
      for (let i = 0; i < audioTracks.length; i++) {
        const track = audioTracks[i];
        if (matchesOption({
          name,
          lang,
          assocLang,
          characteristics,
          audioCodec,
          channels
        }, track, audioMatchPredicate)) {
          return i;
        }
      }
      for (let i = 0; i < audioTracks.length; i++) {
        const track = audioTracks[i];
        if (mediaAttributesIdentical(currentTrack.attrs, track.attrs, ['LANGUAGE', 'ASSOC-LANGUAGE', 'CHARACTERISTICS'])) {
          return i;
        }
      }
      for (let i = 0; i < audioTracks.length; i++) {
        const track = audioTracks[i];
        if (mediaAttributesIdentical(currentTrack.attrs, track.attrs, ['LANGUAGE'])) {
          return i;
        }
      }
    }
    return -1;
  }
  loadPlaylist(hlsUrlParameters) {
    const audioTrack = this.currentTrack;
    if (this.shouldLoadPlaylist(audioTrack) && audioTrack) {
      super.loadPlaylist();
      const id = audioTrack.id;
      const groupId = audioTrack.groupId;
      let url = audioTrack.url;
      if (hlsUrlParameters) {
        try {
          url = hlsUrlParameters.addDirectives(url);
        } catch (error) {
          this.warn(`Could not construct new URL with HLS Delivery Directives: ${error}`);
        }
      }
      // track not retrieved yet, or live playlist we need to (re)load it
      this.log(`loading audio-track playlist ${id} "${audioTrack.name}" lang:${audioTrack.lang} group:${groupId}`);
      this.clearTimer();
      this.hls.trigger(Events.AUDIO_TRACK_LOADING, {
        url,
        id,
        groupId,
        deliveryDirectives: hlsUrlParameters || null
      });
    }
  }
}

const TICK_INTERVAL$1 = 500; // how often to tick in ms

class SubtitleStreamController extends BaseStreamController {
  constructor(hls, fragmentTracker, keyLoader) {
    super(hls, fragmentTracker, keyLoader, '[subtitle-stream-controller]', PlaylistLevelType.SUBTITLE);
    this.currentTrackId = -1;
    this.tracksBuffered = [];
    this.mainDetails = null;
    this._registerListeners();
  }
  onHandlerDestroying() {
    this._unregisterListeners();
    super.onHandlerDestroying();
    this.mainDetails = null;
  }
  _registerListeners() {
    const {
      hls
    } = this;
    hls.on(Events.MEDIA_ATTACHED, this.onMediaAttached, this);
    hls.on(Events.MEDIA_DETACHING, this.onMediaDetaching, this);
    hls.on(Events.MANIFEST_LOADING, this.onManifestLoading, this);
    hls.on(Events.LEVEL_LOADED, this.onLevelLoaded, this);
    hls.on(Events.ERROR, this.onError, this);
    hls.on(Events.SUBTITLE_TRACKS_UPDATED, this.onSubtitleTracksUpdated, this);
    hls.on(Events.SUBTITLE_TRACK_SWITCH, this.onSubtitleTrackSwitch, this);
    hls.on(Events.SUBTITLE_TRACK_LOADED, this.onSubtitleTrackLoaded, this);
    hls.on(Events.SUBTITLE_FRAG_PROCESSED, this.onSubtitleFragProcessed, this);
    hls.on(Events.BUFFER_FLUSHING, this.onBufferFlushing, this);
    hls.on(Events.FRAG_BUFFERED, this.onFragBuffered, this);
  }
  _unregisterListeners() {
    const {
      hls
    } = this;
    hls.off(Events.MEDIA_ATTACHED, this.onMediaAttached, this);
    hls.off(Events.MEDIA_DETACHING, this.onMediaDetaching, this);
    hls.off(Events.MANIFEST_LOADING, this.onManifestLoading, this);
    hls.off(Events.LEVEL_LOADED, this.onLevelLoaded, this);
    hls.off(Events.ERROR, this.onError, this);
    hls.off(Events.SUBTITLE_TRACKS_UPDATED, this.onSubtitleTracksUpdated, this);
    hls.off(Events.SUBTITLE_TRACK_SWITCH, this.onSubtitleTrackSwitch, this);
    hls.off(Events.SUBTITLE_TRACK_LOADED, this.onSubtitleTrackLoaded, this);
    hls.off(Events.SUBTITLE_FRAG_PROCESSED, this.onSubtitleFragProcessed, this);
    hls.off(Events.BUFFER_FLUSHING, this.onBufferFlushing, this);
    hls.off(Events.FRAG_BUFFERED, this.onFragBuffered, this);
  }
  startLoad(startPosition) {
    this.stopLoad();
    this.state = State.IDLE;
    this.setInterval(TICK_INTERVAL$1);
    this.nextLoadPosition = this.startPosition = this.lastCurrentTime = startPosition;
    this.tick();
  }
  onManifestLoading() {
    this.mainDetails = null;
    this.fragmentTracker.removeAllFragments();
  }
  onMediaDetaching() {
    this.tracksBuffered = [];
    super.onMediaDetaching();
  }
  onLevelLoaded(event, data) {
    this.mainDetails = data.details;
  }
  onSubtitleFragProcessed(event, data) {
    const {
      frag,
      success
    } = data;
    this.fragPrevious = frag;
    this.state = State.IDLE;
    if (!success) {
      return;
    }
    const buffered = this.tracksBuffered[this.currentTrackId];
    if (!buffered) {
      return;
    }

    // Create/update a buffered array matching the interface used by BufferHelper.bufferedInfo
    // so we can re-use the logic used to detect how much has been buffered
    let timeRange;
    const fragStart = frag.start;
    for (let i = 0; i < buffered.length; i++) {
      if (fragStart >= buffered[i].start && fragStart <= buffered[i].end) {
        timeRange = buffered[i];
        break;
      }
    }
    const fragEnd = frag.start + frag.duration;
    if (timeRange) {
      timeRange.end = fragEnd;
    } else {
      timeRange = {
        start: fragStart,
        end: fragEnd
      };
      buffered.push(timeRange);
    }
    this.fragmentTracker.fragBuffered(frag);
    this.fragBufferedComplete(frag, null);
  }
  onBufferFlushing(event, data) {
    const {
      startOffset,
      endOffset
    } = data;
    if (startOffset === 0 && endOffset !== Number.POSITIVE_INFINITY) {
      const endOffsetSubtitles = endOffset - 1;
      if (endOffsetSubtitles <= 0) {
        return;
      }
      data.endOffsetSubtitles = Math.max(0, endOffsetSubtitles);
      this.tracksBuffered.forEach(buffered => {
        for (let i = 0; i < buffered.length;) {
          if (buffered[i].end <= endOffsetSubtitles) {
            buffered.shift();
            continue;
          } else if (buffered[i].start < endOffsetSubtitles) {
            buffered[i].start = endOffsetSubtitles;
          } else {
            break;
          }
          i++;
        }
      });
      this.fragmentTracker.removeFragmentsInRange(startOffset, endOffsetSubtitles, PlaylistLevelType.SUBTITLE);
    }
  }
  onFragBuffered(event, data) {
    if (!this.loadedmetadata && data.frag.type === PlaylistLevelType.MAIN) {
      var _this$media;
      if ((_this$media = this.media) != null && _this$media.buffered.length) {
        this.loadedmetadata = true;
      }
    }
  }

  // If something goes wrong, proceed to next frag, if we were processing one.
  onError(event, data) {
    const frag = data.frag;
    if ((frag == null ? void 0 : frag.type) === PlaylistLevelType.SUBTITLE) {
      if (data.details === ErrorDetails.FRAG_GAP) {
        this.fragmentTracker.fragBuffered(frag, true);
      }
      if (this.fragCurrent) {
        this.fragCurrent.abortRequests();
      }
      if (this.state !== State.STOPPED) {
        this.state = State.IDLE;
      }
    }
  }

  // Got all new subtitle levels.
  onSubtitleTracksUpdated(event, {
    subtitleTracks
  }) {
    if (this.levels && subtitleOptionsIdentical(this.levels, subtitleTracks)) {
      this.levels = subtitleTracks.map(mediaPlaylist => new Level(mediaPlaylist));
      return;
    }
    this.tracksBuffered = [];
    this.levels = subtitleTracks.map(mediaPlaylist => {
      const level = new Level(mediaPlaylist);
      this.tracksBuffered[level.id] = [];
      return level;
    });
    this.fragmentTracker.removeFragmentsInRange(0, Number.POSITIVE_INFINITY, PlaylistLevelType.SUBTITLE);
    this.fragPrevious = null;
    this.mediaBuffer = null;
  }
  onSubtitleTrackSwitch(event, data) {
    var _this$levels;
    this.currentTrackId = data.id;
    if (!((_this$levels = this.levels) != null && _this$levels.length) || this.currentTrackId === -1) {
      this.clearInterval();
      return;
    }

    // Check if track has the necessary details to load fragments
    const currentTrack = this.levels[this.currentTrackId];
    if (currentTrack != null && currentTrack.details) {
      this.mediaBuffer = this.mediaBufferTimeRanges;
    } else {
      this.mediaBuffer = null;
    }
    if (currentTrack) {
      this.setInterval(TICK_INTERVAL$1);
    }
  }

  // Got a new set of subtitle fragments.
  onSubtitleTrackLoaded(event, data) {
    var _track$details;
    const {
      currentTrackId,
      levels
    } = this;
    const {
      details: newDetails,
      id: trackId
    } = data;
    if (!levels) {
      this.warn(`Subtitle tracks were reset while loading level ${trackId}`);
      return;
    }
    const track = levels[trackId];
    if (trackId >= levels.length || !track) {
      return;
    }
    this.log(`Subtitle track ${trackId} loaded [${newDetails.startSN},${newDetails.endSN}]${newDetails.lastPartSn ? `[part-${newDetails.lastPartSn}-${newDetails.lastPartIndex}]` : ''},duration:${newDetails.totalduration}`);
    this.mediaBuffer = this.mediaBufferTimeRanges;
    let sliding = 0;
    if (newDetails.live || (_track$details = track.details) != null && _track$details.live) {
      const mainDetails = this.mainDetails;
      if (newDetails.deltaUpdateFailed || !mainDetails) {
        return;
      }
      const mainSlidingStartFragment = mainDetails.fragments[0];
      if (!track.details) {
        if (newDetails.hasProgramDateTime && mainDetails.hasProgramDateTime) {
          alignMediaPlaylistByPDT(newDetails, mainDetails);
          sliding = newDetails.fragments[0].start;
        } else if (mainSlidingStartFragment) {
          // line up live playlist with main so that fragments in range are loaded
          sliding = mainSlidingStartFragment.start;
          addSliding(newDetails, sliding);
        }
      } else {
        var _this$levelLastLoaded;
        sliding = this.alignPlaylists(newDetails, track.details, (_this$levelLastLoaded = this.levelLastLoaded) == null ? void 0 : _this$levelLastLoaded.details);
        if (sliding === 0 && mainSlidingStartFragment) {
          // realign with main when there is no overlap with last refresh
          sliding = mainSlidingStartFragment.start;
          addSliding(newDetails, sliding);
        }
      }
    }
    track.details = newDetails;
    this.levelLastLoaded = track;
    if (trackId !== currentTrackId) {
      return;
    }
    if (!this.startFragRequested && (this.mainDetails || !newDetails.live)) {
      this.setStartPosition(this.mainDetails || newDetails, sliding);
    }

    // trigger handler right now
    this.tick();

    // If playlist is misaligned because of bad PDT or drift, delete details to resync with main on reload
    if (newDetails.live && !this.fragCurrent && this.media && this.state === State.IDLE) {
      const foundFrag = findFragmentByPTS(null, newDetails.fragments, this.media.currentTime, 0);
      if (!foundFrag) {
        this.warn('Subtitle playlist not aligned with playback');
        track.details = undefined;
      }
    }
  }
  _handleFragmentLoadComplete(fragLoadedData) {
    const {
      frag,
      payload
    } = fragLoadedData;
    const decryptData = frag.decryptdata;
    const hls = this.hls;
    if (this.fragContextChanged(frag)) {
      return;
    }
    // check to see if the payload needs to be decrypted
    if (payload && payload.byteLength > 0 && decryptData != null && decryptData.key && decryptData.iv && decryptData.method === 'AES-128') {
      const startTime = performance.now();
      // decrypt the subtitles
      this.decrypter.decrypt(new Uint8Array(payload), decryptData.key.buffer, decryptData.iv.buffer).catch(err => {
        hls.trigger(Events.ERROR, {
          type: ErrorTypes.MEDIA_ERROR,
          details: ErrorDetails.FRAG_DECRYPT_ERROR,
          fatal: false,
          error: err,
          reason: err.message,
          frag
        });
        throw err;
      }).then(decryptedData => {
        const endTime = performance.now();
        hls.trigger(Events.FRAG_DECRYPTED, {
          frag,
          payload: decryptedData,
          stats: {
            tstart: startTime,
            tdecrypt: endTime
          }
        });
      }).catch(err => {
        this.warn(`${err.name}: ${err.message}`);
        this.state = State.IDLE;
      });
    }
  }
  doTick() {
    if (!this.media) {
      this.state = State.IDLE;
      return;
    }
    if (this.state === State.IDLE) {
      const {
        currentTrackId,
        levels
      } = this;
      const track = levels == null ? void 0 : levels[currentTrackId];
      if (!track || !levels.length || !track.details) {
        return;
      }
      const {
        config
      } = this;
      const currentTime = this.getLoadPosition();
      const bufferedInfo = BufferHelper.bufferedInfo(this.tracksBuffered[this.currentTrackId] || [], currentTime, config.maxBufferHole);
      const {
        end: targetBufferTime,
        len: bufferLen
      } = bufferedInfo;
      const mainBufferInfo = this.getFwdBufferInfo(this.media, PlaylistLevelType.MAIN);
      const trackDetails = track.details;
      const maxBufLen = this.getMaxBufferLength(mainBufferInfo == null ? void 0 : mainBufferInfo.len) + trackDetails.levelTargetDuration;
      if (bufferLen > maxBufLen) {
        return;
      }
      const fragments = trackDetails.fragments;
      const fragLen = fragments.length;
      const end = trackDetails.edge;
      let foundFrag = null;
      const fragPrevious = this.fragPrevious;
      if (targetBufferTime < end) {
        const tolerance = config.maxFragLookUpTolerance;
        const lookupTolerance = targetBufferTime > end - tolerance ? 0 : tolerance;
        foundFrag = findFragmentByPTS(fragPrevious, fragments, Math.max(fragments[0].start, targetBufferTime), lookupTolerance);
        if (!foundFrag && fragPrevious && fragPrevious.start < fragments[0].start) {
          foundFrag = fragments[0];
        }
      } else {
        foundFrag = fragments[fragLen - 1];
      }
      if (!foundFrag) {
        return;
      }
      foundFrag = this.mapToInitFragWhenRequired(foundFrag);
      if (foundFrag.sn !== 'initSegment') {
        // Load earlier fragment in same discontinuity to make up for misaligned playlists and cues that extend beyond end of segment
        const curSNIdx = foundFrag.sn - trackDetails.startSN;
        const prevFrag = fragments[curSNIdx - 1];
        if (prevFrag && prevFrag.cc === foundFrag.cc && this.fragmentTracker.getState(prevFrag) === FragmentState.NOT_LOADED) {
          foundFrag = prevFrag;
        }
      }
      if (this.fragmentTracker.getState(foundFrag) === FragmentState.NOT_LOADED) {
        // only load if fragment is not loaded
        this.loadFragment(foundFrag, track, targetBufferTime);
      }
    }
  }
  getMaxBufferLength(mainBufferLength) {
    const maxConfigBuffer = super.getMaxBufferLength();
    if (!mainBufferLength) {
      return maxConfigBuffer;
    }
    return Math.max(maxConfigBuffer, mainBufferLength);
  }
  loadFragment(frag, level, targetBufferTime) {
    this.fragCurrent = frag;
    if (frag.sn === 'initSegment') {
      this._loadInitSegment(frag, level);
    } else {
      this.startFragRequested = true;
      super.loadFragment(frag, level, targetBufferTime);
    }
  }
  get mediaBufferTimeRanges() {
    return new BufferableInstance(this.tracksBuffered[this.currentTrackId] || []);
  }
}
class BufferableInstance {
  constructor(timeranges) {
    this.buffered = void 0;
    const getRange = (name, index, length) => {
      index = index >>> 0;
      if (index > length - 1) {
        throw new DOMException(`Failed to execute '${name}' on 'TimeRanges': The index provided (${index}) is greater than the maximum bound (${length})`);
      }
      return timeranges[index][name];
    };
    this.buffered = {
      get length() {
        return timeranges.length;
      },
      end(index) {
        return getRange('end', index, timeranges.length);
      },
      start(index) {
        return getRange('start', index, timeranges.length);
      }
    };
  }
}

class SubtitleTrackController extends BasePlaylistController {
  constructor(hls) {
    super(hls, '[subtitle-track-controller]');
    this.media = null;
    this.tracks = [];
    this.groupIds = null;
    this.tracksInGroup = [];
    this.trackId = -1;
    this.currentTrack = null;
    this.selectDefaultTrack = true;
    this.queuedDefaultTrack = -1;
    this.asyncPollTrackChange = () => this.pollTrackChange(0);
    this.useTextTrackPolling = false;
    this.subtitlePollingInterval = -1;
    this._subtitleDisplay = true;
    this.onTextTracksChanged = () => {
      if (!this.useTextTrackPolling) {
        self.clearInterval(this.subtitlePollingInterval);
      }
      // Media is undefined when switching streams via loadSource()
      if (!this.media || !this.hls.config.renderTextTracksNatively) {
        return;
      }
      let textTrack = null;
      const tracks = filterSubtitleTracks(this.media.textTracks);
      for (let i = 0; i < tracks.length; i++) {
        if (tracks[i].mode === 'hidden') {
          // Do not break in case there is a following track with showing.
          textTrack = tracks[i];
        } else if (tracks[i].mode === 'showing') {
          textTrack = tracks[i];
          break;
        }
      }

      // Find internal track index for TextTrack
      const trackId = this.findTrackForTextTrack(textTrack);
      if (this.subtitleTrack !== trackId) {
        this.setSubtitleTrack(trackId);
      }
    };
    this.registerListeners();
  }
  destroy() {
    this.unregisterListeners();
    this.tracks.length = 0;
    this.tracksInGroup.length = 0;
    this.currentTrack = null;
    this.onTextTracksChanged = this.asyncPollTrackChange = null;
    super.destroy();
  }
  get subtitleDisplay() {
    return this._subtitleDisplay;
  }
  set subtitleDisplay(value) {
    this._subtitleDisplay = value;
    if (this.trackId > -1) {
      this.toggleTrackModes();
    }
  }
  registerListeners() {
    const {
      hls
    } = this;
    hls.on(Events.MEDIA_ATTACHED, this.onMediaAttached, this);
    hls.on(Events.MEDIA_DETACHING, this.onMediaDetaching, this);
    hls.on(Events.MANIFEST_LOADING, this.onManifestLoading, this);
    hls.on(Events.MANIFEST_PARSED, this.onManifestParsed, this);
    hls.on(Events.LEVEL_LOADING, this.onLevelLoading, this);
    hls.on(Events.LEVEL_SWITCHING, this.onLevelSwitching, this);
    hls.on(Events.SUBTITLE_TRACK_LOADED, this.onSubtitleTrackLoaded, this);
    hls.on(Events.ERROR, this.onError, this);
  }
  unregisterListeners() {
    const {
      hls
    } = this;
    hls.off(Events.MEDIA_ATTACHED, this.onMediaAttached, this);
    hls.off(Events.MEDIA_DETACHING, this.onMediaDetaching, this);
    hls.off(Events.MANIFEST_LOADING, this.onManifestLoading, this);
    hls.off(Events.MANIFEST_PARSED, this.onManifestParsed, this);
    hls.off(Events.LEVEL_LOADING, this.onLevelLoading, this);
    hls.off(Events.LEVEL_SWITCHING, this.onLevelSwitching, this);
    hls.off(Events.SUBTITLE_TRACK_LOADED, this.onSubtitleTrackLoaded, this);
    hls.off(Events.ERROR, this.onError, this);
  }

  // Listen for subtitle track change, then extract the current track ID.
  onMediaAttached(event, data) {
    this.media = data.media;
    if (!this.media) {
      return;
    }
    if (this.queuedDefaultTrack > -1) {
      this.subtitleTrack = this.queuedDefaultTrack;
      this.queuedDefaultTrack = -1;
    }
    this.useTextTrackPolling = !(this.media.textTracks && 'onchange' in this.media.textTracks);
    if (this.useTextTrackPolling) {
      this.pollTrackChange(500);
    } else {
      this.media.textTracks.addEventListener('change', this.asyncPollTrackChange);
    }
  }
  pollTrackChange(timeout) {
    self.clearInterval(this.subtitlePollingInterval);
    this.subtitlePollingInterval = self.setInterval(this.onTextTracksChanged, timeout);
  }
  onMediaDetaching() {
    if (!this.media) {
      return;
    }
    self.clearInterval(this.subtitlePollingInterval);
    if (!this.useTextTrackPolling) {
      this.media.textTracks.removeEventListener('change', this.asyncPollTrackChange);
    }
    if (this.trackId > -1) {
      this.queuedDefaultTrack = this.trackId;
    }
    const textTracks = filterSubtitleTracks(this.media.textTracks);
    // Clear loaded cues on media detachment from tracks
    textTracks.forEach(track => {
      clearCurrentCues(track);
    });
    // Disable all subtitle tracks before detachment so when reattached only tracks in that content are enabled.
    this.subtitleTrack = -1;
    this.media = null;
  }
  onManifestLoading() {
    this.tracks = [];
    this.groupIds = null;
    this.tracksInGroup = [];
    this.trackId = -1;
    this.currentTrack = null;
    this.selectDefaultTrack = true;
  }

  // Fired whenever a new manifest is loaded.
  onManifestParsed(event, data) {
    this.tracks = data.subtitleTracks;
  }
  onSubtitleTrackLoaded(event, data) {
    const {
      id,
      groupId,
      details
    } = data;
    const trackInActiveGroup = this.tracksInGroup[id];
    if (!trackInActiveGroup || trackInActiveGroup.groupId !== groupId) {
      this.warn(`Subtitle track with id:${id} and group:${groupId} not found in active group ${trackInActiveGroup == null ? void 0 : trackInActiveGroup.groupId}`);
      return;
    }
    const curDetails = trackInActiveGroup.details;
    trackInActiveGroup.details = data.details;
    this.log(`Subtitle track ${id} "${trackInActiveGroup.name}" lang:${trackInActiveGroup.lang} group:${groupId} loaded [${details.startSN}-${details.endSN}]`);
    if (id === this.trackId) {
      this.playlistLoaded(id, data, curDetails);
    }
  }
  onLevelLoading(event, data) {
    this.switchLevel(data.level);
  }
  onLevelSwitching(event, data) {
    this.switchLevel(data.level);
  }
  switchLevel(levelIndex) {
    const levelInfo = this.hls.levels[levelIndex];
    if (!levelInfo) {
      return;
    }
    const subtitleGroups = levelInfo.subtitleGroups || null;
    const currentGroups = this.groupIds;
    let currentTrack = this.currentTrack;
    if (!subtitleGroups || (currentGroups == null ? void 0 : currentGroups.length) !== (subtitleGroups == null ? void 0 : subtitleGroups.length) || subtitleGroups != null && subtitleGroups.some(groupId => (currentGroups == null ? void 0 : currentGroups.indexOf(groupId)) === -1)) {
      this.groupIds = subtitleGroups;
      this.trackId = -1;
      this.currentTrack = null;
      const subtitleTracks = this.tracks.filter(track => !subtitleGroups || subtitleGroups.indexOf(track.groupId) !== -1);
      if (subtitleTracks.length) {
        // Disable selectDefaultTrack if there are no default tracks
        if (this.selectDefaultTrack && !subtitleTracks.some(track => track.default)) {
          this.selectDefaultTrack = false;
        }
        // track.id should match hls.audioTracks index
        subtitleTracks.forEach((track, i) => {
          track.id = i;
        });
      } else if (!currentTrack && !this.tracksInGroup.length) {
        // Do not dispatch SUBTITLE_TRACKS_UPDATED when there were and are no tracks
        return;
      }
      this.tracksInGroup = subtitleTracks;

      // Find preferred track
      const subtitlePreference = this.hls.config.subtitlePreference;
      if (!currentTrack && subtitlePreference) {
        this.selectDefaultTrack = false;
        const groupIndex = findMatchingOption(subtitlePreference, subtitleTracks);
        if (groupIndex > -1) {
          currentTrack = subtitleTracks[groupIndex];
        } else {
          const allIndex = findMatchingOption(subtitlePreference, this.tracks);
          currentTrack = this.tracks[allIndex];
        }
      }

      // Select initial track
      let trackId = this.findTrackId(currentTrack);
      if (trackId === -1 && currentTrack) {
        trackId = this.findTrackId(null);
      }

      // Dispatch events and load track if needed
      const subtitleTracksUpdated = {
        subtitleTracks
      };
      this.log(`Updating subtitle tracks, ${subtitleTracks.length} track(s) found in "${subtitleGroups == null ? void 0 : subtitleGroups.join(',')}" group-id`);
      this.hls.trigger(Events.SUBTITLE_TRACKS_UPDATED, subtitleTracksUpdated);
      if (trackId !== -1 && this.trackId === -1) {
        this.setSubtitleTrack(trackId);
      }
    } else if (this.shouldReloadPlaylist(currentTrack)) {
      // Retry playlist loading if no playlist is or has been loaded yet
      this.setSubtitleTrack(this.trackId);
    }
  }
  findTrackId(currentTrack) {
    const tracks = this.tracksInGroup;
    const selectDefault = this.selectDefaultTrack;
    for (let i = 0; i < tracks.length; i++) {
      const track = tracks[i];
      if (selectDefault && !track.default || !selectDefault && !currentTrack) {
        continue;
      }
      if (!currentTrack || matchesOption(track, currentTrack)) {
        return i;
      }
    }
    if (currentTrack) {
      for (let i = 0; i < tracks.length; i++) {
        const track = tracks[i];
        if (mediaAttributesIdentical(currentTrack.attrs, track.attrs, ['LANGUAGE', 'ASSOC-LANGUAGE', 'CHARACTERISTICS'])) {
          return i;
        }
      }
      for (let i = 0; i < tracks.length; i++) {
        const track = tracks[i];
        if (mediaAttributesIdentical(currentTrack.attrs, track.attrs, ['LANGUAGE'])) {
          return i;
        }
      }
    }
    return -1;
  }
  findTrackForTextTrack(textTrack) {
    if (textTrack) {
      const tracks = this.tracksInGroup;
      for (let i = 0; i < tracks.length; i++) {
        const track = tracks[i];
        if (subtitleTrackMatchesTextTrack(track, textTrack)) {
          return i;
        }
      }
    }
    return -1;
  }
  onError(event, data) {
    if (data.fatal || !data.context) {
      return;
    }
    if (data.context.type === PlaylistContextType.SUBTITLE_TRACK && data.context.id === this.trackId && (!this.groupIds || this.groupIds.indexOf(data.context.groupId) !== -1)) {
      this.checkRetry(data);
    }
  }
  get allSubtitleTracks() {
    return this.tracks;
  }

  /** get alternate subtitle tracks list from playlist **/
  get subtitleTracks() {
    return this.tracksInGroup;
  }

  /** get/set index of the selected subtitle track (based on index in subtitle track lists) **/
  get subtitleTrack() {
    return this.trackId;
  }
  set subtitleTrack(newId) {
    this.selectDefaultTrack = false;
    this.setSubtitleTrack(newId);
  }
  setSubtitleOption(subtitleOption) {
    this.hls.config.subtitlePreference = subtitleOption;
    if (subtitleOption) {
      const allSubtitleTracks = this.allSubtitleTracks;
      this.selectDefaultTrack = false;
      if (allSubtitleTracks.length) {
        // First see if current option matches (no switch op)
        const currentTrack = this.currentTrack;
        if (currentTrack && matchesOption(subtitleOption, currentTrack)) {
          return currentTrack;
        }
        // Find option in current group
        const groupIndex = findMatchingOption(subtitleOption, this.tracksInGroup);
        if (groupIndex > -1) {
          const track = this.tracksInGroup[groupIndex];
          this.setSubtitleTrack(groupIndex);
          return track;
        } else if (currentTrack) {
          // If this is not the initial selection return null
          // option should have matched one in active group
          return null;
        } else {
          // Find the option in all tracks for initial selection
          const allIndex = findMatchingOption(subtitleOption, allSubtitleTracks);
          if (allIndex > -1) {
            return allSubtitleTracks[allIndex];
          }
        }
      }
    }
    return null;
  }
  loadPlaylist(hlsUrlParameters) {
    super.loadPlaylist();
    const currentTrack = this.currentTrack;
    if (this.shouldLoadPlaylist(currentTrack) && currentTrack) {
      const id = currentTrack.id;
      const groupId = currentTrack.groupId;
      let url = currentTrack.url;
      if (hlsUrlParameters) {
        try {
          url = hlsUrlParameters.addDirectives(url);
        } catch (error) {
          this.warn(`Could not construct new URL with HLS Delivery Directives: ${error}`);
        }
      }
      this.log(`Loading subtitle playlist for id ${id}`);
      this.hls.trigger(Events.SUBTITLE_TRACK_LOADING, {
        url,
        id,
        groupId,
        deliveryDirectives: hlsUrlParameters || null
      });
    }
  }

  /**
   * Disables the old subtitleTrack and sets current mode on the next subtitleTrack.
   * This operates on the DOM textTracks.
   * A value of -1 will disable all subtitle tracks.
   */
  toggleTrackModes() {
    const {
      media
    } = this;
    if (!media) {
      return;
    }
    const textTracks = filterSubtitleTracks(media.textTracks);
    const currentTrack = this.currentTrack;
    let nextTrack;
    if (currentTrack) {
      nextTrack = textTracks.filter(textTrack => subtitleTrackMatchesTextTrack(currentTrack, textTrack))[0];
      if (!nextTrack) {
        this.warn(`Unable to find subtitle TextTrack with name "${currentTrack.name}" and language "${currentTrack.lang}"`);
      }
    }
    [].slice.call(textTracks).forEach(track => {
      if (track.mode !== 'disabled' && track !== nextTrack) {
        track.mode = 'disabled';
      }
    });
    if (nextTrack) {
      const mode = this.subtitleDisplay ? 'showing' : 'hidden';
      if (nextTrack.mode !== mode) {
        nextTrack.mode = mode;
      }
    }
  }

  /**
   * This method is responsible for validating the subtitle index and periodically reloading if live.
   * Dispatches the SUBTITLE_TRACK_SWITCH event, which instructs the subtitle-stream-controller to load the selected track.
   */
  setSubtitleTrack(newId) {
    const tracks = this.tracksInGroup;

    // setting this.subtitleTrack will trigger internal logic
    // if media has not been attached yet, it will fail
    // we keep a reference to the default track id
    // and we'll set subtitleTrack when onMediaAttached is triggered
    if (!this.media) {
      this.queuedDefaultTrack = newId;
      return;
    }

    // exit if track id as already set or invalid
    if (newId < -1 || newId >= tracks.length || !isFiniteNumber(newId)) {
      this.warn(`Invalid subtitle track id: ${newId}`);
      return;
    }

    // stopping live reloading timer if any
    this.clearTimer();
    this.selectDefaultTrack = false;
    const lastTrack = this.currentTrack;
    const track = tracks[newId] || null;
    this.trackId = newId;
    this.currentTrack = track;
    this.toggleTrackModes();
    if (!track) {
      // switch to -1
      this.hls.trigger(Events.SUBTITLE_TRACK_SWITCH, {
        id: newId
      });
      return;
    }
    const trackLoaded = !!track.details && !track.details.live;
    if (newId === this.trackId && track === lastTrack && trackLoaded) {
      return;
    }
    this.log(`Switching to subtitle-track ${newId}` + (track ? ` "${track.name}" lang:${track.lang} group:${track.groupId}` : ''));
    const {
      id,
      groupId = '',
      name,
      type,
      url
    } = track;
    this.hls.trigger(Events.SUBTITLE_TRACK_SWITCH, {
      id,
      groupId,
      name,
      type,
      url
    });
    const hlsUrlParameters = this.switchParams(track.url, lastTrack == null ? void 0 : lastTrack.details, track.details);
    this.loadPlaylist(hlsUrlParameters);
  }
}

class BufferOperationQueue {
  constructor(sourceBufferReference) {
    this.buffers = void 0;
    this.queues = {
      video: [],
      audio: [],
      audiovideo: []
    };
    this.buffers = sourceBufferReference;
  }
  append(operation, type, pending) {
    const queue = this.queues[type];
    queue.push(operation);
    if (queue.length === 1 && !pending) {
      this.executeNext(type);
    }
  }
  insertAbort(operation, type) {
    const queue = this.queues[type];
    queue.unshift(operation);
    this.executeNext(type);
  }
  appendBlocker(type) {
    let execute;
    const promise = new Promise(resolve => {
      execute = resolve;
    });
    const operation = {
      execute,
      onStart: () => {},
      onComplete: () => {},
      onError: () => {}
    };
    this.append(operation, type);
    return promise;
  }
  executeNext(type) {
    const queue = this.queues[type];
    if (queue.length) {
      const operation = queue[0];
      try {
        // Operations are expected to result in an 'updateend' event being fired. If not, the queue will lock. Operations
        // which do not end with this event must call _onSBUpdateEnd manually
        operation.execute();
      } catch (error) {
        logger.warn(`[buffer-operation-queue]: Exception executing "${type}" SourceBuffer operation: ${error}`);
        operation.onError(error);

        // Only shift the current operation off, otherwise the updateend handler will do this for us
        const sb = this.buffers[type];
        if (!(sb != null && sb.updating)) {
          this.shiftAndExecuteNext(type);
        }
      }
    }
  }
  shiftAndExecuteNext(type) {
    this.queues[type].shift();
    this.executeNext(type);
  }
  current(type) {
    return this.queues[type][0];
  }
}

const VIDEO_CODEC_PROFILE_REPLACE = /(avc[1234]|hvc1|hev1|dvh[1e]|vp09|av01)(?:\.[^.,]+)+/;
class BufferController {
  constructor(hls) {
    // The level details used to determine duration, target-duration and live
    this.details = null;
    // cache the self generated object url to detect hijack of video tag
    this._objectUrl = null;
    // A queue of buffer operations which require the SourceBuffer to not be updating upon execution
    this.operationQueue = void 0;
    // References to event listeners for each SourceBuffer, so that they can be referenced for event removal
    this.listeners = void 0;
    this.hls = void 0;
    // The number of BUFFER_CODEC events received before any sourceBuffers are created
    this.bufferCodecEventsExpected = 0;
    // The total number of BUFFER_CODEC events received
    this._bufferCodecEventsTotal = 0;
    // A reference to the attached media element
    this.media = null;
    // A reference to the active media source
    this.mediaSource = null;
    // Last MP3 audio chunk appended
    this.lastMpegAudioChunk = null;
    this.appendSource = void 0;
    // counters
    this.appendErrors = {
      audio: 0,
      video: 0,
      audiovideo: 0
    };
    this.tracks = {};
    this.pendingTracks = {};
    this.sourceBuffer = void 0;
    this.log = void 0;
    this.warn = void 0;
    this.error = void 0;
    this._onEndStreaming = event => {
      if (!this.hls) {
        return;
      }
      this.hls.pauseBuffering();
    };
    this._onStartStreaming = event => {
      if (!this.hls) {
        return;
      }
      this.hls.resumeBuffering();
    };
    // Keep as arrow functions so that we can directly reference these functions directly as event listeners
    this._onMediaSourceOpen = () => {
      const {
        media,
        mediaSource
      } = this;
      this.log('Media source opened');
      if (media) {
        media.removeEventListener('emptied', this._onMediaEmptied);
        this.updateMediaElementDuration();
        this.hls.trigger(Events.MEDIA_ATTACHED, {
          media,
          mediaSource: mediaSource
        });
      }
      if (mediaSource) {
        // once received, don't listen anymore to sourceopen event
        mediaSource.removeEventListener('sourceopen', this._onMediaSourceOpen);
      }
      this.checkPendingTracks();
    };
    this._onMediaSourceClose = () => {
      this.log('Media source closed');
    };
    this._onMediaSourceEnded = () => {
      this.log('Media source ended');
    };
    this._onMediaEmptied = () => {
      const {
        mediaSrc,
        _objectUrl
      } = this;
      if (mediaSrc !== _objectUrl) {
        logger.error(`Media element src was set while attaching MediaSource (${_objectUrl} > ${mediaSrc})`);
      }
    };
    this.hls = hls;
    const logPrefix = '[buffer-controller]';
    this.appendSource = isManagedMediaSource(getMediaSource(hls.config.preferManagedMediaSource));
    this.log = logger.log.bind(logger, logPrefix);
    this.warn = logger.warn.bind(logger, logPrefix);
    this.error = logger.error.bind(logger, logPrefix);
    this._initSourceBuffer();
    this.registerListeners();
  }
  hasSourceTypes() {
    return this.getSourceBufferTypes().length > 0 || Object.keys(this.pendingTracks).length > 0;
  }
  destroy() {
    this.unregisterListeners();
    this.details = null;
    this.lastMpegAudioChunk = null;
    // @ts-ignore
    this.hls = null;
  }
  registerListeners() {
    const {
      hls
    } = this;
    hls.on(Events.MEDIA_ATTACHING, this.onMediaAttaching, this);
    hls.on(Events.MEDIA_DETACHING, this.onMediaDetaching, this);
    hls.on(Events.MANIFEST_LOADING, this.onManifestLoading, this);
    hls.on(Events.MANIFEST_PARSED, this.onManifestParsed, this);
    hls.on(Events.BUFFER_RESET, this.onBufferReset, this);
    hls.on(Events.BUFFER_APPENDING, this.onBufferAppending, this);
    hls.on(Events.BUFFER_CODECS, this.onBufferCodecs, this);
    hls.on(Events.BUFFER_EOS, this.onBufferEos, this);
    hls.on(Events.BUFFER_FLUSHING, this.onBufferFlushing, this);
    hls.on(Events.LEVEL_UPDATED, this.onLevelUpdated, this);
    hls.on(Events.FRAG_PARSED, this.onFragParsed, this);
    hls.on(Events.FRAG_CHANGED, this.onFragChanged, this);
  }
  unregisterListeners() {
    const {
      hls
    } = this;
    hls.off(Events.MEDIA_ATTACHING, this.onMediaAttaching, this);
    hls.off(Events.MEDIA_DETACHING, this.onMediaDetaching, this);
    hls.off(Events.MANIFEST_LOADING, this.onManifestLoading, this);
    hls.off(Events.MANIFEST_PARSED, this.onManifestParsed, this);
    hls.off(Events.BUFFER_RESET, this.onBufferReset, this);
    hls.off(Events.BUFFER_APPENDING, this.onBufferAppending, this);
    hls.off(Events.BUFFER_CODECS, this.onBufferCodecs, this);
    hls.off(Events.BUFFER_EOS, this.onBufferEos, this);
    hls.off(Events.BUFFER_FLUSHING, this.onBufferFlushing, this);
    hls.off(Events.LEVEL_UPDATED, this.onLevelUpdated, this);
    hls.off(Events.FRAG_PARSED, this.onFragParsed, this);
    hls.off(Events.FRAG_CHANGED, this.onFragChanged, this);
  }
  _initSourceBuffer() {
    this.sourceBuffer = {};
    this.operationQueue = new BufferOperationQueue(this.sourceBuffer);
    this.listeners = {
      audio: [],
      video: [],
      audiovideo: []
    };
    this.appendErrors = {
      audio: 0,
      video: 0,
      audiovideo: 0
    };
    this.lastMpegAudioChunk = null;
  }
  onManifestLoading() {
    this.bufferCodecEventsExpected = this._bufferCodecEventsTotal = 0;
    this.details = null;
  }
  onManifestParsed(event, data) {
    // in case of alt audio 2 BUFFER_CODECS events will be triggered, one per stream controller
    // sourcebuffers will be created all at once when the expected nb of tracks will be reached
    // in case alt audio is not used, only one BUFFER_CODEC event will be fired from main stream controller
    // it will contain the expected nb of source buffers, no need to compute it
    let codecEvents = 2;
    if (data.audio && !data.video || !data.altAudio || !true) {
      codecEvents = 1;
    }
    this.bufferCodecEventsExpected = this._bufferCodecEventsTotal = codecEvents;
    this.log(`${this.bufferCodecEventsExpected} bufferCodec event(s) expected`);
  }
  onMediaAttaching(event, data) {
    const media = this.media = data.media;
    const MediaSource = getMediaSource(this.appendSource);
    if (media && MediaSource) {
      var _ms$constructor;
      const ms = this.mediaSource = new MediaSource();
      this.log(`created media source: ${(_ms$constructor = ms.constructor) == null ? void 0 : _ms$constructor.name}`);
      // MediaSource listeners are arrow functions with a lexical scope, and do not need to be bound
      ms.addEventListener('sourceopen', this._onMediaSourceOpen);
      ms.addEventListener('sourceended', this._onMediaSourceEnded);
      ms.addEventListener('sourceclose', this._onMediaSourceClose);
      if (this.appendSource) {
        ms.addEventListener('startstreaming', this._onStartStreaming);
        ms.addEventListener('endstreaming', this._onEndStreaming);
      }

      // cache the locally generated object url
      const objectUrl = this._objectUrl = self.URL.createObjectURL(ms);
      // link video and media Source
      if (this.appendSource) {
        try {
          media.removeAttribute('src');
          // ManagedMediaSource will not open without disableRemotePlayback set to false or source alternatives
          const MMS = self.ManagedMediaSource;
          media.disableRemotePlayback = media.disableRemotePlayback || MMS && ms instanceof MMS;
          removeSourceChildren(media);
          addSource(media, objectUrl);
          media.load();
        } catch (error) {
          media.src = objectUrl;
        }
      } else {
        media.src = objectUrl;
      }
      media.addEventListener('emptied', this._onMediaEmptied);
    }
  }
  onMediaDetaching() {
    const {
      media,
      mediaSource,
      _objectUrl
    } = this;
    if (mediaSource) {
      this.log('media source detaching');
      if (mediaSource.readyState === 'open') {
        try {
          // endOfStream could trigger exception if any sourcebuffer is in updating state
          // we don't really care about checking sourcebuffer state here,
          // as we are anyway detaching the MediaSource
          // let's just avoid this exception to propagate
          mediaSource.endOfStream();
        } catch (err) {
          this.warn(`onMediaDetaching: ${err.message} while calling endOfStream`);
        }
      }
      // Clean up the SourceBuffers by invoking onBufferReset
      this.onBufferReset();
      mediaSource.removeEventListener('sourceopen', this._onMediaSourceOpen);
      mediaSource.removeEventListener('sourceended', this._onMediaSourceEnded);
      mediaSource.removeEventListener('sourceclose', this._onMediaSourceClose);
      if (this.appendSource) {
        mediaSource.removeEventListener('startstreaming', this._onStartStreaming);
        mediaSource.removeEventListener('endstreaming', this._onEndStreaming);
      }

      // Detach properly the MediaSource from the HTMLMediaElement as
      // suggested in https://github.com/w3c/media-source/issues/53.
      if (media) {
        media.removeEventListener('emptied', this._onMediaEmptied);
        if (_objectUrl) {
          self.URL.revokeObjectURL(_objectUrl);
        }

        // clean up video tag src only if it's our own url. some external libraries might
        // hijack the video tag and change its 'src' without destroying the Hls instance first
        if (this.mediaSrc === _objectUrl) {
          media.removeAttribute('src');
          if (this.appendSource) {
            removeSourceChildren(media);
          }
          media.load();
        } else {
          this.warn('media|source.src was changed by a third party - skip cleanup');
        }
      }
      this.mediaSource = null;
      this.media = null;
      this._objectUrl = null;
      this.bufferCodecEventsExpected = this._bufferCodecEventsTotal;
      this.pendingTracks = {};
      this.tracks = {};
    }
    this.hls.trigger(Events.MEDIA_DETACHED, undefined);
  }
  onBufferReset() {
    this.getSourceBufferTypes().forEach(type => {
      this.resetBuffer(type);
    });
    this._initSourceBuffer();
  }
  resetBuffer(type) {
    const sb = this.sourceBuffer[type];
    try {
      if (sb) {
        var _this$mediaSource;
        this.removeBufferListeners(type);
        // Synchronously remove the SB from the map before the next call in order to prevent an async function from
        // accessing it
        this.sourceBuffer[type] = undefined;
        if ((_this$mediaSource = this.mediaSource) != null && _this$mediaSource.sourceBuffers.length) {
          this.mediaSource.removeSourceBuffer(sb);
        }
      }
    } catch (err) {
      this.warn(`onBufferReset ${type}`, err);
    }
  }
  onBufferCodecs(event, data) {
    const sourceBufferCount = this.getSourceBufferTypes().length;
    const trackNames = Object.keys(data);
    trackNames.forEach(trackName => {
      if (sourceBufferCount) {
        // check if SourceBuffer codec needs to change
        const track = this.tracks[trackName];
        if (track && typeof track.buffer.changeType === 'function') {
          var _trackCodec;
          const {
            id,
            codec,
            levelCodec,
            container,
            metadata
          } = data[trackName];
          const currentCodecFull = pickMostCompleteCodecName(track.codec, track.levelCodec);
          const currentCodec = currentCodecFull == null ? void 0 : currentCodecFull.replace(VIDEO_CODEC_PROFILE_REPLACE, '$1');
          let trackCodec = pickMostCompleteCodecName(codec, levelCodec);
          const nextCodec = (_trackCodec = trackCodec) == null ? void 0 : _trackCodec.replace(VIDEO_CODEC_PROFILE_REPLACE, '$1');
          if (trackCodec && currentCodec !== nextCodec) {
            if (trackName.slice(0, 5) === 'audio') {
              trackCodec = getCodecCompatibleName(trackCodec, this.appendSource);
            }
            const mimeType = `${container};codecs=${trackCodec}`;
            this.appendChangeType(trackName, mimeType);
            this.log(`switching codec ${currentCodecFull} to ${trackCodec}`);
            this.tracks[trackName] = {
              buffer: track.buffer,
              codec,
              container,
              levelCodec,
              metadata,
              id
            };
          }
        }
      } else {
        // if source buffer(s) not created yet, appended buffer tracks in this.pendingTracks
        this.pendingTracks[trackName] = data[trackName];
      }
    });

    // if sourcebuffers already created, do nothing ...
    if (sourceBufferCount) {
      return;
    }
    const bufferCodecEventsExpected = Math.max(this.bufferCodecEventsExpected - 1, 0);
    if (this.bufferCodecEventsExpected !== bufferCodecEventsExpected) {
      this.log(`${bufferCodecEventsExpected} bufferCodec event(s) expected ${trackNames.join(',')}`);
      this.bufferCodecEventsExpected = bufferCodecEventsExpected;
    }
    if (this.mediaSource && this.mediaSource.readyState === 'open') {
      this.checkPendingTracks();
    }
  }
  appendChangeType(type, mimeType) {
    const {
      operationQueue
    } = this;
    const operation = {
      execute: () => {
        const sb = this.sourceBuffer[type];
        if (sb) {
          this.log(`changing ${type} sourceBuffer type to ${mimeType}`);
          sb.changeType(mimeType);
        }
        operationQueue.shiftAndExecuteNext(type);
      },
      onStart: () => {},
      onComplete: () => {},
      onError: error => {
        this.warn(`Failed to change ${type} SourceBuffer type`, error);
      }
    };
    operationQueue.append(operation, type, !!this.pendingTracks[type]);
  }
  onBufferAppending(event, eventData) {
    const {
      hls,
      operationQueue,
      tracks
    } = this;
    const {
      data,
      type,
      frag,
      part,
      chunkMeta
    } = eventData;
    const chunkStats = chunkMeta.buffering[type];
    const bufferAppendingStart = self.performance.now();
    chunkStats.start = bufferAppendingStart;
    const fragBuffering = frag.stats.buffering;
    const partBuffering = part ? part.stats.buffering : null;
    if (fragBuffering.start === 0) {
      fragBuffering.start = bufferAppendingStart;
    }
    if (partBuffering && partBuffering.start === 0) {
      partBuffering.start = bufferAppendingStart;
    }

    // TODO: Only update timestampOffset when audio/mpeg fragment or part is not contiguous with previously appended
    // Adjusting `SourceBuffer.timestampOffset` (desired point in the timeline where the next frames should be appended)
    // in Chrome browser when we detect MPEG audio container and time delta between level PTS and `SourceBuffer.timestampOffset`
    // is greater than 100ms (this is enough to handle seek for VOD or level change for LIVE videos).
    // More info here: https://github.com/video-dev/hls.js/issues/332#issuecomment-257986486
    const audioTrack = tracks.audio;
    let checkTimestampOffset = false;
    if (type === 'audio' && (audioTrack == null ? void 0 : audioTrack.container) === 'audio/mpeg') {
      checkTimestampOffset = !this.lastMpegAudioChunk || chunkMeta.id === 1 || this.lastMpegAudioChunk.sn !== chunkMeta.sn;
      this.lastMpegAudioChunk = chunkMeta;
    }
    const fragStart = frag.start;
    const operation = {
      execute: () => {
        chunkStats.executeStart = self.performance.now();
        if (checkTimestampOffset) {
          const sb = this.sourceBuffer[type];
          if (sb) {
            const delta = fragStart - sb.timestampOffset;
            if (Math.abs(delta) >= 0.1) {
              this.log(`Updating audio SourceBuffer timestampOffset to ${fragStart} (delta: ${delta}) sn: ${frag.sn})`);
              sb.timestampOffset = fragStart;
            }
          }
        }
        this.appendExecutor(data, type);
      },
      onStart: () => {
        // logger.debug(`[buffer-controller]: ${type} SourceBuffer updatestart`);
      },
      onComplete: () => {
        // logger.debug(`[buffer-controller]: ${type} SourceBuffer updateend`);
        const end = self.performance.now();
        chunkStats.executeEnd = chunkStats.end = end;
        if (fragBuffering.first === 0) {
          fragBuffering.first = end;
        }
        if (partBuffering && partBuffering.first === 0) {
          partBuffering.first = end;
        }
        const {
          sourceBuffer
        } = this;
        const timeRanges = {};
        for (const type in sourceBuffer) {
          timeRanges[type] = BufferHelper.getBuffered(sourceBuffer[type]);
        }
        this.appendErrors[type] = 0;
        if (type === 'audio' || type === 'video') {
          this.appendErrors.audiovideo = 0;
        } else {
          this.appendErrors.audio = 0;
          this.appendErrors.video = 0;
        }
        this.hls.trigger(Events.BUFFER_APPENDED, {
          type,
          frag,
          part,
          chunkMeta,
          parent: frag.type,
          timeRanges
        });
      },
      onError: error => {
        // in case any error occured while appending, put back segment in segments table
        const event = {
          type: ErrorTypes.MEDIA_ERROR,
          parent: frag.type,
          details: ErrorDetails.BUFFER_APPEND_ERROR,
          sourceBufferName: type,
          frag,
          part,
          chunkMeta,
          error,
          err: error,
          fatal: false
        };
        if (error.code === DOMException.QUOTA_EXCEEDED_ERR) {
          // QuotaExceededError: http://www.w3.org/TR/html5/infrastructure.html#quotaexceedederror
          // let's stop appending any segments, and report BUFFER_FULL_ERROR error
          event.details = ErrorDetails.BUFFER_FULL_ERROR;
        } else {
          const appendErrorCount = ++this.appendErrors[type];
          event.details = ErrorDetails.BUFFER_APPEND_ERROR;
          /* with UHD content, we could get loop of quota exceeded error until
            browser is able to evict some data from sourcebuffer. Retrying can help recover.
          */
          this.warn(`Failed ${appendErrorCount}/${hls.config.appendErrorMaxRetry} times to append segment in "${type}" sourceBuffer`);
          if (appendErrorCount >= hls.config.appendErrorMaxRetry) {
            event.fatal = true;
          }
        }
        hls.trigger(Events.ERROR, event);
      }
    };
    operationQueue.append(operation, type, !!this.pendingTracks[type]);
  }
  onBufferFlushing(event, data) {
    const {
      operationQueue
    } = this;
    const flushOperation = type => ({
      execute: this.removeExecutor.bind(this, type, data.startOffset, data.endOffset),
      onStart: () => {
        // logger.debug(`[buffer-controller]: Started flushing ${data.startOffset} -> ${data.endOffset} for ${type} Source Buffer`);
      },
      onComplete: () => {
        // logger.debug(`[buffer-controller]: Finished flushing ${data.startOffset} -> ${data.endOffset} for ${type} Source Buffer`);
        this.hls.trigger(Events.BUFFER_FLUSHED, {
          type
        });
      },
      onError: error => {
        this.warn(`Failed to remove from ${type} SourceBuffer`, error);
      }
    });
    if (data.type) {
      operationQueue.append(flushOperation(data.type), data.type);
    } else {
      this.getSourceBufferTypes().forEach(type => {
        operationQueue.append(flushOperation(type), type);
      });
    }
  }
  onFragParsed(event, data) {
    const {
      frag,
      part
    } = data;
    const buffersAppendedTo = [];
    const elementaryStreams = part ? part.elementaryStreams : frag.elementaryStreams;
    if (elementaryStreams[ElementaryStreamTypes.AUDIOVIDEO]) {
      buffersAppendedTo.push('audiovideo');
    } else {
      if (elementaryStreams[ElementaryStreamTypes.AUDIO]) {
        buffersAppendedTo.push('audio');
      }
      if (elementaryStreams[ElementaryStreamTypes.VIDEO]) {
        buffersAppendedTo.push('video');
      }
    }
    const onUnblocked = () => {
      const now = self.performance.now();
      frag.stats.buffering.end = now;
      if (part) {
        part.stats.buffering.end = now;
      }
      const stats = part ? part.stats : frag.stats;
      this.hls.trigger(Events.FRAG_BUFFERED, {
        frag,
        part,
        stats,
        id: frag.type
      });
    };
    if (buffersAppendedTo.length === 0) {
      this.warn(`Fragments must have at least one ElementaryStreamType set. type: ${frag.type} level: ${frag.level} sn: ${frag.sn}`);
    }
    this.blockBuffers(onUnblocked, buffersAppendedTo);
  }
  onFragChanged(event, data) {
    this.trimBuffers();
  }

  // on BUFFER_EOS mark matching sourcebuffer(s) as ended and trigger checkEos()
  // an undefined data.type will mark all buffers as EOS.
  onBufferEos(event, data) {
    const ended = this.getSourceBufferTypes().reduce((acc, type) => {
      const sb = this.sourceBuffer[type];
      if (sb && (!data.type || data.type === type)) {
        sb.ending = true;
        if (!sb.ended) {
          sb.ended = true;
          this.log(`${type} sourceBuffer now EOS`);
        }
      }
      return acc && !!(!sb || sb.ended);
    }, true);
    if (ended) {
      this.log(`Queueing mediaSource.endOfStream()`);
      this.blockBuffers(() => {
        this.getSourceBufferTypes().forEach(type => {
          const sb = this.sourceBuffer[type];
          if (sb) {
            sb.ending = false;
          }
        });
        const {
          mediaSource
        } = this;
        if (!mediaSource || mediaSource.readyState !== 'open') {
          if (mediaSource) {
            this.log(`Could not call mediaSource.endOfStream(). mediaSource.readyState: ${mediaSource.readyState}`);
          }
          return;
        }
        this.log(`Calling mediaSource.endOfStream()`);
        // Allow this to throw and be caught by the enqueueing function
        mediaSource.endOfStream();
      });
    }
  }
  onLevelUpdated(event, {
    details
  }) {
    if (!details.fragments.length) {
      return;
    }
    this.details = details;
    if (this.getSourceBufferTypes().length) {
      this.blockBuffers(this.updateMediaElementDuration.bind(this));
    } else {
      this.updateMediaElementDuration();
    }
  }
  trimBuffers() {
    const {
      hls,
      details,
      media
    } = this;
    if (!media || details === null) {
      return;
    }
    const sourceBufferTypes = this.getSourceBufferTypes();
    if (!sourceBufferTypes.length) {
      return;
    }
    const config = hls.config;
    const currentTime = media.currentTime;
    const targetDuration = details.levelTargetDuration;

    // Support for deprecated liveBackBufferLength
    const backBufferLength = details.live && config.liveBackBufferLength !== null ? config.liveBackBufferLength : config.backBufferLength;
    if (isFiniteNumber(backBufferLength) && backBufferLength > 0) {
      const maxBackBufferLength = Math.max(backBufferLength, targetDuration);
      const targetBackBufferPosition = Math.floor(currentTime / targetDuration) * targetDuration - maxBackBufferLength;
      this.flushBackBuffer(currentTime, targetDuration, targetBackBufferPosition);
    }
    if (isFiniteNumber(config.frontBufferFlushThreshold) && config.frontBufferFlushThreshold > 0) {
      const frontBufferLength = Math.max(config.maxBufferLength, config.frontBufferFlushThreshold);
      const maxFrontBufferLength = Math.max(frontBufferLength, targetDuration);
      const targetFrontBufferPosition = Math.floor(currentTime / targetDuration) * targetDuration + maxFrontBufferLength;
      this.flushFrontBuffer(currentTime, targetDuration, targetFrontBufferPosition);
    }
  }
  flushBackBuffer(currentTime, targetDuration, targetBackBufferPosition) {
    const {
      details,
      sourceBuffer
    } = this;
    const sourceBufferTypes = this.getSourceBufferTypes();
    sourceBufferTypes.forEach(type => {
      const sb = sourceBuffer[type];
      if (sb) {
        const buffered = BufferHelper.getBuffered(sb);
        // when target buffer start exceeds actual buffer start
        if (buffered.length > 0 && targetBackBufferPosition > buffered.start(0)) {
          this.hls.trigger(Events.BACK_BUFFER_REACHED, {
            bufferEnd: targetBackBufferPosition
          });

          // Support for deprecated event:
          if (details != null && details.live) {
            this.hls.trigger(Events.LIVE_BACK_BUFFER_REACHED, {
              bufferEnd: targetBackBufferPosition
            });
          } else if (sb.ended && buffered.end(buffered.length - 1) - currentTime < targetDuration * 2) {
            this.log(`Cannot flush ${type} back buffer while SourceBuffer is in ended state`);
            return;
          }
          this.hls.trigger(Events.BUFFER_FLUSHING, {
            startOffset: 0,
            endOffset: targetBackBufferPosition,
            type
          });
        }
      }
    });
  }
  flushFrontBuffer(currentTime, targetDuration, targetFrontBufferPosition) {
    const {
      sourceBuffer
    } = this;
    const sourceBufferTypes = this.getSourceBufferTypes();
    sourceBufferTypes.forEach(type => {
      const sb = sourceBuffer[type];
      if (sb) {
        const buffered = BufferHelper.getBuffered(sb);
        const numBufferedRanges = buffered.length;
        // The buffer is either empty or contiguous
        if (numBufferedRanges < 2) {
          return;
        }
        const bufferStart = buffered.start(numBufferedRanges - 1);
        const bufferEnd = buffered.end(numBufferedRanges - 1);
        // No flush if we can tolerate the current buffer length or the current buffer range we would flush is contiguous with current position
        if (targetFrontBufferPosition > bufferStart || currentTime >= bufferStart && currentTime <= bufferEnd) {
          return;
        } else if (sb.ended && currentTime - bufferEnd < 2 * targetDuration) {
          this.log(`Cannot flush ${type} front buffer while SourceBuffer is in ended state`);
          return;
        }
        this.hls.trigger(Events.BUFFER_FLUSHING, {
          startOffset: bufferStart,
          endOffset: Infinity,
          type
        });
      }
    });
  }

  /**
   * Update Media Source duration to current level duration or override to Infinity if configuration parameter
   * 'liveDurationInfinity` is set to `true`
   * More details: https://github.com/video-dev/hls.js/issues/355
   */
  updateMediaElementDuration() {
    if (!this.details || !this.media || !this.mediaSource || this.mediaSource.readyState !== 'open') {
      return;
    }
    const {
      details,
      hls,
      media,
      mediaSource
    } = this;
    const levelDuration = details.fragments[0].start + details.totalduration;
    const mediaDuration = media.duration;
    const msDuration = isFiniteNumber(mediaSource.duration) ? mediaSource.duration : 0;
    if (details.live && hls.config.liveDurationInfinity) {
      // Override duration to Infinity
      mediaSource.duration = Infinity;
      this.updateSeekableRange(details);
    } else if (levelDuration > msDuration && levelDuration > mediaDuration || !isFiniteNumber(mediaDuration)) {
      // levelDuration was the last value we set.
      // not using mediaSource.duration as the browser may tweak this value
      // only update Media Source duration if its value increase, this is to avoid
      // flushing already buffered portion when switching between quality level
      this.log(`Updating Media Source duration to ${levelDuration.toFixed(3)}`);
      mediaSource.duration = levelDuration;
    }
  }
  updateSeekableRange(levelDetails) {
    const mediaSource = this.mediaSource;
    const fragments = levelDetails.fragments;
    const len = fragments.length;
    if (len && levelDetails.live && mediaSource != null && mediaSource.setLiveSeekableRange) {
      const start = Math.max(0, fragments[0].start);
      const end = Math.max(start, start + levelDetails.totalduration);
      this.log(`Media Source duration is set to ${mediaSource.duration}. Setting seekable range to ${start}-${end}.`);
      mediaSource.setLiveSeekableRange(start, end);
    }
  }
  checkPendingTracks() {
    const {
      bufferCodecEventsExpected,
      operationQueue,
      pendingTracks
    } = this;

    // Check if we've received all of the expected bufferCodec events. When none remain, create all the sourceBuffers at once.
    // This is important because the MSE spec allows implementations to throw QuotaExceededErrors if creating new sourceBuffers after
    // data has been appended to existing ones.
    // 2 tracks is the max (one for audio, one for video). If we've reach this max go ahead and create the buffers.
    const pendingTracksCount = Object.keys(pendingTracks).length;
    if (pendingTracksCount && (!bufferCodecEventsExpected || pendingTracksCount === 2 || 'audiovideo' in pendingTracks)) {
      // ok, let's create them now !
      this.createSourceBuffers(pendingTracks);
      this.pendingTracks = {};
      // append any pending segments now !
      const buffers = this.getSourceBufferTypes();
      if (buffers.length) {
        this.hls.trigger(Events.BUFFER_CREATED, {
          tracks: this.tracks
        });
        buffers.forEach(type => {
          operationQueue.executeNext(type);
        });
      } else {
        const error = new Error('could not create source buffer for media codec(s)');
        this.hls.trigger(Events.ERROR, {
          type: ErrorTypes.MEDIA_ERROR,
          details: ErrorDetails.BUFFER_INCOMPATIBLE_CODECS_ERROR,
          fatal: true,
          error,
          reason: error.message
        });
      }
    }
  }
  createSourceBuffers(tracks) {
    const {
      sourceBuffer,
      mediaSource
    } = this;
    if (!mediaSource) {
      throw Error('createSourceBuffers called when mediaSource was null');
    }
    for (const trackName in tracks) {
      if (!sourceBuffer[trackName]) {
        var _track$levelCodec;
        const track = tracks[trackName];
        if (!track) {
          throw Error(`source buffer exists for track ${trackName}, however track does not`);
        }
        // use levelCodec as first priority unless it contains multiple comma-separated codec values
        let codec = ((_track$levelCodec = track.levelCodec) == null ? void 0 : _track$levelCodec.indexOf(',')) === -1 ? track.levelCodec : track.codec;
        if (codec) {
          if (trackName.slice(0, 5) === 'audio') {
            codec = getCodecCompatibleName(codec, this.appendSource);
          }
        }
        const mimeType = `${track.container};codecs=${codec}`;
        this.log(`creating sourceBuffer(${mimeType})`);
        try {
          const sb = sourceBuffer[trackName] = mediaSource.addSourceBuffer(mimeType);
          const sbName = trackName;
          this.addBufferListener(sbName, 'updatestart', this._onSBUpdateStart);
          this.addBufferListener(sbName, 'updateend', this._onSBUpdateEnd);
          this.addBufferListener(sbName, 'error', this._onSBUpdateError);
          // ManagedSourceBuffer bufferedchange event
          if (this.appendSource) {
            this.addBufferListener(sbName, 'bufferedchange', (type, event) => {
              // If media was ejected check for a change. Added ranges are redundant with changes on 'updateend' event.
              const removedRanges = event.removedRanges;
              if (removedRanges != null && removedRanges.length) {
                this.hls.trigger(Events.BUFFER_FLUSHED, {
                  type: trackName
                });
              }
            });
          }
          this.tracks[trackName] = {
            buffer: sb,
            codec: codec,
            container: track.container,
            levelCodec: track.levelCodec,
            metadata: track.metadata,
            id: track.id
          };
        } catch (err) {
          this.error(`error while trying to add sourceBuffer: ${err.message}`);
          this.hls.trigger(Events.ERROR, {
            type: ErrorTypes.MEDIA_ERROR,
            details: ErrorDetails.BUFFER_ADD_CODEC_ERROR,
            fatal: false,
            error: err,
            sourceBufferName: trackName,
            mimeType: mimeType
          });
        }
      }
    }
  }
  get mediaSrc() {
    var _this$media, _this$media$querySele;
    const media = ((_this$media = this.media) == null ? void 0 : (_this$media$querySele = _this$media.querySelector) == null ? void 0 : _this$media$querySele.call(_this$media, 'source')) || this.media;
    return media == null ? void 0 : media.src;
  }
  _onSBUpdateStart(type) {
    const {
      operationQueue
    } = this;
    const operation = operationQueue.current(type);
    operation.onStart();
  }
  _onSBUpdateEnd(type) {
    var _this$mediaSource2;
    if (((_this$mediaSource2 = this.mediaSource) == null ? void 0 : _this$mediaSource2.readyState) === 'closed') {
      this.resetBuffer(type);
      return;
    }
    const {
      operationQueue
    } = this;
    const operation = operationQueue.current(type);
    operation.onComplete();
    operationQueue.shiftAndExecuteNext(type);
  }
  _onSBUpdateError(type, event) {
    var _this$mediaSource3;
    const error = new Error(`${type} SourceBuffer error. MediaSource readyState: ${(_this$mediaSource3 = this.mediaSource) == null ? void 0 : _this$mediaSource3.readyState}`);
    this.error(`${error}`, event);
    // according to http://www.w3.org/TR/media-source/#sourcebuffer-append-error
    // SourceBuffer errors are not necessarily fatal; if so, the HTMLMediaElement will fire an error event
    this.hls.trigger(Events.ERROR, {
      type: ErrorTypes.MEDIA_ERROR,
      details: ErrorDetails.BUFFER_APPENDING_ERROR,
      sourceBufferName: type,
      error,
      fatal: false
    });
    // updateend is always fired after error, so we'll allow that to shift the current operation off of the queue
    const operation = this.operationQueue.current(type);
    if (operation) {
      operation.onError(error);
    }
  }

  // This method must result in an updateend event; if remove is not called, _onSBUpdateEnd must be called manually
  removeExecutor(type, startOffset, endOffset) {
    const {
      media,
      mediaSource,
      operationQueue,
      sourceBuffer
    } = this;
    const sb = sourceBuffer[type];
    if (!media || !mediaSource || !sb) {
      this.warn(`Attempting to remove from the ${type} SourceBuffer, but it does not exist`);
      operationQueue.shiftAndExecuteNext(type);
      return;
    }
    const mediaDuration = isFiniteNumber(media.duration) ? media.duration : Infinity;
    const msDuration = isFiniteNumber(mediaSource.duration) ? mediaSource.duration : Infinity;
    const removeStart = Math.max(0, startOffset);
    const removeEnd = Math.min(endOffset, mediaDuration, msDuration);
    if (removeEnd > removeStart && (!sb.ending || sb.ended)) {
      sb.ended = false;
      this.log(`Removing [${removeStart},${removeEnd}] from the ${type} SourceBuffer`);
      sb.remove(removeStart, removeEnd);
    } else {
      // Cycle the queue
      operationQueue.shiftAndExecuteNext(type);
    }
  }

  // This method must result in an updateend event; if append is not called, _onSBUpdateEnd must be called manually
  appendExecutor(data, type) {
    const sb = this.sourceBuffer[type];
    if (!sb) {
      if (!this.pendingTracks[type]) {
        throw new Error(`Attempting to append to the ${type} SourceBuffer, but it does not exist`);
      }
      return;
    }
    sb.ended = false;
    sb.appendBuffer(data);
  }

  // Enqueues an operation to each SourceBuffer queue which, upon execution, resolves a promise. When all promises
  // resolve, the onUnblocked function is executed. Functions calling this method do not need to unblock the queue
  // upon completion, since we already do it here
  blockBuffers(onUnblocked, buffers = this.getSourceBufferTypes()) {
    if (!buffers.length) {
      this.log('Blocking operation requested, but no SourceBuffers exist');
      Promise.resolve().then(onUnblocked);
      return;
    }
    const {
      operationQueue
    } = this;

    // logger.debug(`[buffer-controller]: Blocking ${buffers} SourceBuffer`);
    const blockingOperations = buffers.map(type => operationQueue.appendBlocker(type));
    Promise.all(blockingOperations).then(() => {
      // logger.debug(`[buffer-controller]: Blocking operation resolved; unblocking ${buffers} SourceBuffer`);
      onUnblocked();
      buffers.forEach(type => {
        const sb = this.sourceBuffer[type];
        // Only cycle the queue if the SB is not updating. There's a bug in Chrome which sets the SB updating flag to
        // true when changing the MediaSource duration (https://bugs.chromium.org/p/chromium/issues/detail?id=959359&can=2&q=mediasource%20duration)
        // While this is a workaround, it's probably useful to have around
        if (!(sb != null && sb.updating)) {
          operationQueue.shiftAndExecuteNext(type);
        }
      });
    });
  }
  getSourceBufferTypes() {
    return Object.keys(this.sourceBuffer);
  }
  addBufferListener(type, event, fn) {
    const buffer = this.sourceBuffer[type];
    if (!buffer) {
      return;
    }
    const listener = fn.bind(this, type);
    this.listeners[type].push({
      event,
      listener
    });
    buffer.addEventListener(event, listener);
  }
  removeBufferListeners(type) {
    const buffer = this.sourceBuffer[type];
    if (!buffer) {
      return;
    }
    this.listeners[type].forEach(l => {
      buffer.removeEventListener(l.event, l.listener);
    });
  }
}
function removeSourceChildren(node) {
  const sourceChildren = node.querySelectorAll('source');
  [].slice.call(sourceChildren).forEach(source => {
    node.removeChild(source);
  });
}
function addSource(media, url) {
  const source = self.document.createElement('source');
  source.type = 'video/mp4';
  source.src = url;
  media.appendChild(source);
}

/**
 *
 * This code was ported from the dash.js project at:
 *   https://github.com/Dash-Industry-Forum/dash.js/blob/development/externals/cea608-parser.js
 *   https://github.com/Dash-Industry-Forum/dash.js/commit/8269b26a761e0853bb21d78780ed945144ecdd4d#diff-71bc295a2d6b6b7093a1d3290d53a4b2
 *
 * The original copyright appears below:
 *
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2015-2016, DASH Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  1. Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  2. Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */
/**
 *  Exceptions from regular ASCII. CodePoints are mapped to UTF-16 codes
 */

const specialCea608CharsCodes = {
  0x2a: 0xe1,
  // lowercase a, acute accent
  0x5c: 0xe9,
  // lowercase e, acute accent
  0x5e: 0xed,
  // lowercase i, acute accent
  0x5f: 0xf3,
  // lowercase o, acute accent
  0x60: 0xfa,
  // lowercase u, acute accent
  0x7b: 0xe7,
  // lowercase c with cedilla
  0x7c: 0xf7,
  // division symbol
  0x7d: 0xd1,
  // uppercase N tilde
  0x7e: 0xf1,
  // lowercase n tilde
  0x7f: 0x2588,
  // Full block
  // THIS BLOCK INCLUDES THE 16 EXTENDED (TWO-BYTE) LINE 21 CHARACTERS
  // THAT COME FROM HI BYTE=0x11 AND LOW BETWEEN 0x30 AND 0x3F
  // THIS MEANS THAT \x50 MUST BE ADDED TO THE VALUES
  0x80: 0xae,
  // Registered symbol (R)
  0x81: 0xb0,
  // degree sign
  0x82: 0xbd,
  // 1/2 symbol
  0x83: 0xbf,
  // Inverted (open) question mark
  0x84: 0x2122,
  // Trademark symbol (TM)
  0x85: 0xa2,
  // Cents symbol
  0x86: 0xa3,
  // Pounds sterling
  0x87: 0x266a,
  // Music 8'th note
  0x88: 0xe0,
  // lowercase a, grave accent
  0x89: 0x20,
  // transparent space (regular)
  0x8a: 0xe8,
  // lowercase e, grave accent
  0x8b: 0xe2,
  // lowercase a, circumflex accent
  0x8c: 0xea,
  // lowercase e, circumflex accent
  0x8d: 0xee,
  // lowercase i, circumflex accent
  0x8e: 0xf4,
  // lowercase o, circumflex accent
  0x8f: 0xfb,
  // lowercase u, circumflex accent
  // THIS BLOCK INCLUDES THE 32 EXTENDED (TWO-BYTE) LINE 21 CHARACTERS
  // THAT COME FROM HI BYTE=0x12 AND LOW BETWEEN 0x20 AND 0x3F
  0x90: 0xc1,
  // capital letter A with acute
  0x91: 0xc9,
  // capital letter E with acute
  0x92: 0xd3,
  // capital letter O with acute
  0x93: 0xda,
  // capital letter U with acute
  0x94: 0xdc,
  // capital letter U with diaresis
  0x95: 0xfc,
  // lowercase letter U with diaeresis
  0x96: 0x2018,
  // opening single quote
  0x97: 0xa1,
  // inverted exclamation mark
  0x98: 0x2a,
  // asterisk
  0x99: 0x2019,
  // closing single quote
  0x9a: 0x2501,
  // box drawings heavy horizontal
  0x9b: 0xa9,
  // copyright sign
  0x9c: 0x2120,
  // Service mark
  0x9d: 0x2022,
  // (round) bullet
  0x9e: 0x201c,
  // Left double quotation mark
  0x9f: 0x201d,
  // Right double quotation mark
  0xa0: 0xc0,
  // uppercase A, grave accent
  0xa1: 0xc2,
  // uppercase A, circumflex
  0xa2: 0xc7,
  // uppercase C with cedilla
  0xa3: 0xc8,
  // uppercase E, grave accent
  0xa4: 0xca,
  // uppercase E, circumflex
  0xa5: 0xcb,
  // capital letter E with diaresis
  0xa6: 0xeb,
  // lowercase letter e with diaresis
  0xa7: 0xce,
  // uppercase I, circumflex
  0xa8: 0xcf,
  // uppercase I, with diaresis
  0xa9: 0xef,
  // lowercase i, with diaresis
  0xaa: 0xd4,
  // uppercase O, circumflex
  0xab: 0xd9,
  // uppercase U, grave accent
  0xac: 0xf9,
  // lowercase u, grave accent
  0xad: 0xdb,
  // uppercase U, circumflex
  0xae: 0xab,
  // left-pointing double angle quotation mark
  0xaf: 0xbb,
  // right-pointing double angle quotation mark
  // THIS BLOCK INCLUDES THE 32 EXTENDED (TWO-BYTE) LINE 21 CHARACTERS
  // THAT COME FROM HI BYTE=0x13 AND LOW BETWEEN 0x20 AND 0x3F
  0xb0: 0xc3,
  // Uppercase A, tilde
  0xb1: 0xe3,
  // Lowercase a, tilde
  0xb2: 0xcd,
  // Uppercase I, acute accent
  0xb3: 0xcc,
  // Uppercase I, grave accent
  0xb4: 0xec,
  // Lowercase i, grave accent
  0xb5: 0xd2,
  // Uppercase O, grave accent
  0xb6: 0xf2,
  // Lowercase o, grave accent
  0xb7: 0xd5,
  // Uppercase O, tilde
  0xb8: 0xf5,
  // Lowercase o, tilde
  0xb9: 0x7b,
  // Open curly brace
  0xba: 0x7d,
  // Closing curly brace
  0xbb: 0x5c,
  // Backslash
  0xbc: 0x5e,
  // Caret
  0xbd: 0x5f,
  // Underscore
  0xbe: 0x7c,
  // Pipe (vertical line)
  0xbf: 0x223c,
  // Tilde operator
  0xc0: 0xc4,
  // Uppercase A, umlaut
  0xc1: 0xe4,
  // Lowercase A, umlaut
  0xc2: 0xd6,
  // Uppercase O, umlaut
  0xc3: 0xf6,
  // Lowercase o, umlaut
  0xc4: 0xdf,
  // Esszett (sharp S)
  0xc5: 0xa5,
  // Yen symbol
  0xc6: 0xa4,
  // Generic currency sign
  0xc7: 0x2503,
  // Box drawings heavy vertical
  0xc8: 0xc5,
  // Uppercase A, ring
  0xc9: 0xe5,
  // Lowercase A, ring
  0xca: 0xd8,
  // Uppercase O, stroke
  0xcb: 0xf8,
  // Lowercase o, strok
  0xcc: 0x250f,
  // Box drawings heavy down and right
  0xcd: 0x2513,
  // Box drawings heavy down and left
  0xce: 0x2517,
  // Box drawings heavy up and right
  0xcf: 0x251b // Box drawings heavy up and left
};

/**
 * Utils
 */
const getCharForByte = byte => String.fromCharCode(specialCea608CharsCodes[byte] || byte);
const NR_ROWS = 15;
const NR_COLS = 100;
// Tables to look up row from PAC data
const rowsLowCh1 = {
  0x11: 1,
  0x12: 3,
  0x15: 5,
  0x16: 7,
  0x17: 9,
  0x10: 11,
  0x13: 12,
  0x14: 14
};
const rowsHighCh1 = {
  0x11: 2,
  0x12: 4,
  0x15: 6,
  0x16: 8,
  0x17: 10,
  0x13: 13,
  0x14: 15
};
const rowsLowCh2 = {
  0x19: 1,
  0x1a: 3,
  0x1d: 5,
  0x1e: 7,
  0x1f: 9,
  0x18: 11,
  0x1b: 12,
  0x1c: 14
};
const rowsHighCh2 = {
  0x19: 2,
  0x1a: 4,
  0x1d: 6,
  0x1e: 8,
  0x1f: 10,
  0x1b: 13,
  0x1c: 15
};
const backgroundColors = ['white', 'green', 'blue', 'cyan', 'red', 'yellow', 'magenta', 'black', 'transparent'];
class CaptionsLogger {
  constructor() {
    this.time = null;
    this.verboseLevel = 0;
  }
  log(severity, msg) {
    if (this.verboseLevel >= severity) {
      const m = typeof msg === 'function' ? msg() : msg;
      logger.log(`${this.time} [${severity}] ${m}`);
    }
  }
}
const numArrayToHexArray = function numArrayToHexArray(numArray) {
  const hexArray = [];
  for (let j = 0; j < numArray.length; j++) {
    hexArray.push(numArray[j].toString(16));
  }
  return hexArray;
};
class PenState {
  constructor() {
    this.foreground = 'white';
    this.underline = false;
    this.italics = false;
    this.background = 'black';
    this.flash = false;
  }
  reset() {
    this.foreground = 'white';
    this.underline = false;
    this.italics = false;
    this.background = 'black';
    this.flash = false;
  }
  setStyles(styles) {
    const attribs = ['foreground', 'underline', 'italics', 'background', 'flash'];
    for (let i = 0; i < attribs.length; i++) {
      const style = attribs[i];
      if (styles.hasOwnProperty(style)) {
        this[style] = styles[style];
      }
    }
  }
  isDefault() {
    return this.foreground === 'white' && !this.underline && !this.italics && this.background === 'black' && !this.flash;
  }
  equals(other) {
    return this.foreground === other.foreground && this.underline === other.underline && this.italics === other.italics && this.background === other.background && this.flash === other.flash;
  }
  copy(newPenState) {
    this.foreground = newPenState.foreground;
    this.underline = newPenState.underline;
    this.italics = newPenState.italics;
    this.background = newPenState.background;
    this.flash = newPenState.flash;
  }
  toString() {
    return 'color=' + this.foreground + ', underline=' + this.underline + ', italics=' + this.italics + ', background=' + this.background + ', flash=' + this.flash;
  }
}

/**
 * Unicode character with styling and background.
 * @constructor
 */
class StyledUnicodeChar {
  constructor() {
    this.uchar = ' ';
    this.penState = new PenState();
  }
  reset() {
    this.uchar = ' ';
    this.penState.reset();
  }
  setChar(uchar, newPenState) {
    this.uchar = uchar;
    this.penState.copy(newPenState);
  }
  setPenState(newPenState) {
    this.penState.copy(newPenState);
  }
  equals(other) {
    return this.uchar === other.uchar && this.penState.equals(other.penState);
  }
  copy(newChar) {
    this.uchar = newChar.uchar;
    this.penState.copy(newChar.penState);
  }
  isEmpty() {
    return this.uchar === ' ' && this.penState.isDefault();
  }
}

/**
 * CEA-608 row consisting of NR_COLS instances of StyledUnicodeChar.
 * @constructor
 */
class Row {
  constructor(logger) {
    this.chars = [];
    this.pos = 0;
    this.currPenState = new PenState();
    this.cueStartTime = null;
    this.logger = void 0;
    for (let i = 0; i < NR_COLS; i++) {
      this.chars.push(new StyledUnicodeChar());
    }
    this.logger = logger;
  }
  equals(other) {
    for (let i = 0; i < NR_COLS; i++) {
      if (!this.chars[i].equals(other.chars[i])) {
        return false;
      }
    }
    return true;
  }
  copy(other) {
    for (let i = 0; i < NR_COLS; i++) {
      this.chars[i].copy(other.chars[i]);
    }
  }
  isEmpty() {
    let empty = true;
    for (let i = 0; i < NR_COLS; i++) {
      if (!this.chars[i].isEmpty()) {
        empty = false;
        break;
      }
    }
    return empty;
  }

  /**
   *  Set the cursor to a valid column.
   */
  setCursor(absPos) {
    if (this.pos !== absPos) {
      this.pos = absPos;
    }
    if (this.pos < 0) {
      this.logger.log(3, 'Negative cursor position ' + this.pos);
      this.pos = 0;
    } else if (this.pos > NR_COLS) {
      this.logger.log(3, 'Too large cursor position ' + this.pos);
      this.pos = NR_COLS;
    }
  }

  /**
   * Move the cursor relative to current position.
   */
  moveCursor(relPos) {
    const newPos = this.pos + relPos;
    if (relPos > 1) {
      for (let i = this.pos + 1; i < newPos + 1; i++) {
        this.chars[i].setPenState(this.currPenState);
      }
    }
    this.setCursor(newPos);
  }

  /**
   * Backspace, move one step back and clear character.
   */
  backSpace() {
    this.moveCursor(-1);
    this.chars[this.pos].setChar(' ', this.currPenState);
  }
  insertChar(byte) {
    if (byte >= 0x90) {
      // Extended char
      this.backSpace();
    }
    const char = getCharForByte(byte);
    if (this.pos >= NR_COLS) {
      this.logger.log(0, () => 'Cannot insert ' + byte.toString(16) + ' (' + char + ') at position ' + this.pos + '. Skipping it!');
      return;
    }
    this.chars[this.pos].setChar(char, this.currPenState);
    this.moveCursor(1);
  }
  clearFromPos(startPos) {
    let i;
    for (i = startPos; i < NR_COLS; i++) {
      this.chars[i].reset();
    }
  }
  clear() {
    this.clearFromPos(0);
    this.pos = 0;
    this.currPenState.reset();
  }
  clearToEndOfRow() {
    this.clearFromPos(this.pos);
  }
  getTextString() {
    const chars = [];
    let empty = true;
    for (let i = 0; i < NR_COLS; i++) {
      const char = this.chars[i].uchar;
      if (char !== ' ') {
        empty = false;
      }
      chars.push(char);
    }
    if (empty) {
      return '';
    } else {
      return chars.join('');
    }
  }
  setPenStyles(styles) {
    this.currPenState.setStyles(styles);
    const currChar = this.chars[this.pos];
    currChar.setPenState(this.currPenState);
  }
}

/**
 * Keep a CEA-608 screen of 32x15 styled characters
 * @constructor
 */
class CaptionScreen {
  constructor(logger) {
    this.rows = [];
    this.currRow = NR_ROWS - 1;
    this.nrRollUpRows = null;
    this.lastOutputScreen = null;
    this.logger = void 0;
    for (let i = 0; i < NR_ROWS; i++) {
      this.rows.push(new Row(logger));
    }
    this.logger = logger;
  }
  reset() {
    for (let i = 0; i < NR_ROWS; i++) {
      this.rows[i].clear();
    }
    this.currRow = NR_ROWS - 1;
  }
  equals(other) {
    let equal = true;
    for (let i = 0; i < NR_ROWS; i++) {
      if (!this.rows[i].equals(other.rows[i])) {
        equal = false;
        break;
      }
    }
    return equal;
  }
  copy(other) {
    for (let i = 0; i < NR_ROWS; i++) {
      this.rows[i].copy(other.rows[i]);
    }
  }
  isEmpty() {
    let empty = true;
    for (let i = 0; i < NR_ROWS; i++) {
      if (!this.rows[i].isEmpty()) {
        empty = false;
        break;
      }
    }
    return empty;
  }
  backSpace() {
    const row = this.rows[this.currRow];
    row.backSpace();
  }
  clearToEndOfRow() {
    const row = this.rows[this.currRow];
    row.clearToEndOfRow();
  }

  /**
   * Insert a character (without styling) in the current row.
   */
  insertChar(char) {
    const row = this.rows[this.currRow];
    row.insertChar(char);
  }
  setPen(styles) {
    const row = this.rows[this.currRow];
    row.setPenStyles(styles);
  }
  moveCursor(relPos) {
    const row = this.rows[this.currRow];
    row.moveCursor(relPos);
  }
  setCursor(absPos) {
    this.logger.log(2, 'setCursor: ' + absPos);
    const row = this.rows[this.currRow];
    row.setCursor(absPos);
  }
  setPAC(pacData) {
    this.logger.log(2, () => 'pacData = ' + JSON.stringify(pacData));
    let newRow = pacData.row - 1;
    if (this.nrRollUpRows && newRow < this.nrRollUpRows - 1) {
      newRow = this.nrRollUpRows - 1;
    }

    // Make sure this only affects Roll-up Captions by checking this.nrRollUpRows
    if (this.nrRollUpRows && this.currRow !== newRow) {
      // clear all rows first
      for (let i = 0; i < NR_ROWS; i++) {
        this.rows[i].clear();
      }

      // Copy this.nrRollUpRows rows from lastOutputScreen and place it in the newRow location
      // topRowIndex - the start of rows to copy (inclusive index)
      const topRowIndex = this.currRow + 1 - this.nrRollUpRows;
      // We only copy if the last position was already shown.
      // We use the cueStartTime value to check this.
      const lastOutputScreen = this.lastOutputScreen;
      if (lastOutputScreen) {
        const prevLineTime = lastOutputScreen.rows[topRowIndex].cueStartTime;
        const time = this.logger.time;
        if (prevLineTime !== null && time !== null && prevLineTime < time) {
          for (let i = 0; i < this.nrRollUpRows; i++) {
            this.rows[newRow - this.nrRollUpRows + i + 1].copy(lastOutputScreen.rows[topRowIndex + i]);
          }
        }
      }
    }
    this.currRow = newRow;
    const row = this.rows[this.currRow];
    if (pacData.indent !== null) {
      const indent = pacData.indent;
      const prevPos = Math.max(indent - 1, 0);
      row.setCursor(pacData.indent);
      pacData.color = row.chars[prevPos].penState.foreground;
    }
    const styles = {
      foreground: pacData.color,
      underline: pacData.underline,
      italics: pacData.italics,
      background: 'black',
      flash: false
    };
    this.setPen(styles);
  }

  /**
   * Set background/extra foreground, but first do back_space, and then insert space (backwards compatibility).
   */
  setBkgData(bkgData) {
    this.logger.log(2, () => 'bkgData = ' + JSON.stringify(bkgData));
    this.backSpace();
    this.setPen(bkgData);
    this.insertChar(0x20); // Space
  }
  setRollUpRows(nrRows) {
    this.nrRollUpRows = nrRows;
  }
  rollUp() {
    if (this.nrRollUpRows === null) {
      this.logger.log(3, 'roll_up but nrRollUpRows not set yet');
      return; // Not properly setup
    }
    this.logger.log(1, () => this.getDisplayText());
    const topRowIndex = this.currRow + 1 - this.nrRollUpRows;
    const topRow = this.rows.splice(topRowIndex, 1)[0];
    topRow.clear();
    this.rows.splice(this.currRow, 0, topRow);
    this.logger.log(2, 'Rolling up');
    // this.logger.log(VerboseLevel.TEXT, this.get_display_text())
  }

  /**
   * Get all non-empty rows with as unicode text.
   */
  getDisplayText(asOneRow) {
    asOneRow = asOneRow || false;
    const displayText = [];
    let text = '';
    let rowNr = -1;
    for (let i = 0; i < NR_ROWS; i++) {
      const rowText = this.rows[i].getTextString();
      if (rowText) {
        rowNr = i + 1;
        if (asOneRow) {
          displayText.push('Row ' + rowNr + ": '" + rowText + "'");
        } else {
          displayText.push(rowText.trim());
        }
      }
    }
    if (displayText.length > 0) {
      if (asOneRow) {
        text = '[' + displayText.join(' | ') + ']';
      } else {
        text = displayText.join('\n');
      }
    }
    return text;
  }
  getTextAndFormat() {
    return this.rows;
  }
}

// var modes = ['MODE_ROLL-UP', 'MODE_POP-ON', 'MODE_PAINT-ON', 'MODE_TEXT'];

class Cea608Channel {
  constructor(channelNumber, outputFilter, logger) {
    this.chNr = void 0;
    this.outputFilter = void 0;
    this.mode = void 0;
    this.verbose = void 0;
    this.displayedMemory = void 0;
    this.nonDisplayedMemory = void 0;
    this.lastOutputScreen = void 0;
    this.currRollUpRow = void 0;
    this.writeScreen = void 0;
    this.cueStartTime = void 0;
    this.logger = void 0;
    this.chNr = channelNumber;
    this.outputFilter = outputFilter;
    this.mode = null;
    this.verbose = 0;
    this.displayedMemory = new CaptionScreen(logger);
    this.nonDisplayedMemory = new CaptionScreen(logger);
    this.lastOutputScreen = new CaptionScreen(logger);
    this.currRollUpRow = this.displayedMemory.rows[NR_ROWS - 1];
    this.writeScreen = this.displayedMemory;
    this.mode = null;
    this.cueStartTime = null; // Keeps track of where a cue started.
    this.logger = logger;
  }
  reset() {
    this.mode = null;
    this.displayedMemory.reset();
    this.nonDisplayedMemory.reset();
    this.lastOutputScreen.reset();
    this.outputFilter.reset();
    this.currRollUpRow = this.displayedMemory.rows[NR_ROWS - 1];
    this.writeScreen = this.displayedMemory;
    this.mode = null;
    this.cueStartTime = null;
  }
  getHandler() {
    return this.outputFilter;
  }
  setHandler(newHandler) {
    this.outputFilter = newHandler;
  }
  setPAC(pacData) {
    this.writeScreen.setPAC(pacData);
  }
  setBkgData(bkgData) {
    this.writeScreen.setBkgData(bkgData);
  }
  setMode(newMode) {
    if (newMode === this.mode) {
      return;
    }
    this.mode = newMode;
    this.logger.log(2, () => 'MODE=' + newMode);
    if (this.mode === 'MODE_POP-ON') {
      this.writeScreen = this.nonDisplayedMemory;
    } else {
      this.writeScreen = this.displayedMemory;
      this.writeScreen.reset();
    }
    if (this.mode !== 'MODE_ROLL-UP') {
      this.displayedMemory.nrRollUpRows = null;
      this.nonDisplayedMemory.nrRollUpRows = null;
    }
    this.mode = newMode;
  }
  insertChars(chars) {
    for (let i = 0; i < chars.length; i++) {
      this.writeScreen.insertChar(chars[i]);
    }
    const screen = this.writeScreen === this.displayedMemory ? 'DISP' : 'NON_DISP';
    this.logger.log(2, () => screen + ': ' + this.writeScreen.getDisplayText(true));
    if (this.mode === 'MODE_PAINT-ON' || this.mode === 'MODE_ROLL-UP') {
      this.logger.log(1, () => 'DISPLAYED: ' + this.displayedMemory.getDisplayText(true));
      this.outputDataUpdate();
    }
  }
  ccRCL() {
    // Resume Caption Loading (switch mode to Pop On)
    this.logger.log(2, 'RCL - Resume Caption Loading');
    this.setMode('MODE_POP-ON');
  }
  ccBS() {
    // BackSpace
    this.logger.log(2, 'BS - BackSpace');
    if (this.mode === 'MODE_TEXT') {
      return;
    }
    this.writeScreen.backSpace();
    if (this.writeScreen === this.displayedMemory) {
      this.outputDataUpdate();
    }
  }
  ccAOF() {
    // Reserved (formerly Alarm Off)
  }
  ccAON() {
    // Reserved (formerly Alarm On)
  }
  ccDER() {
    // Delete to End of Row
    this.logger.log(2, 'DER- Delete to End of Row');
    this.writeScreen.clearToEndOfRow();
    this.outputDataUpdate();
  }
  ccRU(nrRows) {
    // Roll-Up Captions-2,3,or 4 Rows
    this.logger.log(2, 'RU(' + nrRows + ') - Roll Up');
    this.writeScreen = this.displayedMemory;
    this.setMode('MODE_ROLL-UP');
    this.writeScreen.setRollUpRows(nrRows);
  }
  ccFON() {
    // Flash On
    this.logger.log(2, 'FON - Flash On');
    this.writeScreen.setPen({
      flash: true
    });
  }
  ccRDC() {
    // Resume Direct Captioning (switch mode to PaintOn)
    this.logger.log(2, 'RDC - Resume Direct Captioning');
    this.setMode('MODE_PAINT-ON');
  }
  ccTR() {
    // Text Restart in text mode (not supported, however)
    this.logger.log(2, 'TR');
    this.setMode('MODE_TEXT');
  }
  ccRTD() {
    // Resume Text Display in Text mode (not supported, however)
    this.logger.log(2, 'RTD');
    this.setMode('MODE_TEXT');
  }
  ccEDM() {
    // Erase Displayed Memory
    this.logger.log(2, 'EDM - Erase Displayed Memory');
    this.displayedMemory.reset();
    this.outputDataUpdate(true);
  }
  ccCR() {
    // Carriage Return
    this.logger.log(2, 'CR - Carriage Return');
    this.writeScreen.rollUp();
    this.outputDataUpdate(true);
  }
  ccENM() {
    // Erase Non-Displayed Memory
    this.logger.log(2, 'ENM - Erase Non-displayed Memory');
    this.nonDisplayedMemory.reset();
  }
  ccEOC() {
    // End of Caption (Flip Memories)
    this.logger.log(2, 'EOC - End Of Caption');
    if (this.mode === 'MODE_POP-ON') {
      const tmp = this.displayedMemory;
      this.displayedMemory = this.nonDisplayedMemory;
      this.nonDisplayedMemory = tmp;
      this.writeScreen = this.nonDisplayedMemory;
      this.logger.log(1, () => 'DISP: ' + this.displayedMemory.getDisplayText());
    }
    this.outputDataUpdate(true);
  }
  ccTO(nrCols) {
    // Tab Offset 1,2, or 3 columns
    this.logger.log(2, 'TO(' + nrCols + ') - Tab Offset');
    this.writeScreen.moveCursor(nrCols);
  }
  ccMIDROW(secondByte) {
    // Parse MIDROW command
    const styles = {
      flash: false
    };
    styles.underline = secondByte % 2 === 1;
    styles.italics = secondByte >= 0x2e;
    if (!styles.italics) {
      const colorIndex = Math.floor(secondByte / 2) - 0x10;
      const colors = ['white', 'green', 'blue', 'cyan', 'red', 'yellow', 'magenta'];
      styles.foreground = colors[colorIndex];
    } else {
      styles.foreground = 'white';
    }
    this.logger.log(2, 'MIDROW: ' + JSON.stringify(styles));
    this.writeScreen.setPen(styles);
  }
  outputDataUpdate(dispatch = false) {
    const time = this.logger.time;
    if (time === null) {
      return;
    }
    if (this.outputFilter) {
      if (this.cueStartTime === null && !this.displayedMemory.isEmpty()) {
        // Start of a new cue
        this.cueStartTime = time;
      } else {
        if (!this.displayedMemory.equals(this.lastOutputScreen)) {
          this.outputFilter.newCue(this.cueStartTime, time, this.lastOutputScreen);
          if (dispatch && this.outputFilter.dispatchCue) {
            this.outputFilter.dispatchCue();
          }
          this.cueStartTime = this.displayedMemory.isEmpty() ? null : time;
        }
      }
      this.lastOutputScreen.copy(this.displayedMemory);
    }
  }
  cueSplitAtTime(t) {
    if (this.outputFilter) {
      if (!this.displayedMemory.isEmpty()) {
        if (this.outputFilter.newCue) {
          this.outputFilter.newCue(this.cueStartTime, t, this.displayedMemory);
        }
        this.cueStartTime = t;
      }
    }
  }
}

// Will be 1 or 2 when parsing captions

class Cea608Parser {
  constructor(field, out1, out2) {
    this.channels = void 0;
    this.currentChannel = 0;
    this.cmdHistory = createCmdHistory();
    this.logger = void 0;
    const logger = this.logger = new CaptionsLogger();
    this.channels = [null, new Cea608Channel(field, out1, logger), new Cea608Channel(field + 1, out2, logger)];
  }
  getHandler(channel) {
    return this.channels[channel].getHandler();
  }
  setHandler(channel, newHandler) {
    this.channels[channel].setHandler(newHandler);
  }

  /**
   * Add data for time t in forms of list of bytes (unsigned ints). The bytes are treated as pairs.
   */
  addData(time, byteList) {
    this.logger.time = time;
    for (let i = 0; i < byteList.length; i += 2) {
      const a = byteList[i] & 0x7f;
      const b = byteList[i + 1] & 0x7f;
      let cmdFound = false;
      let charsFound = null;
      if (a === 0 && b === 0) {
        continue;
      } else {
        this.logger.log(3, () => '[' + numArrayToHexArray([byteList[i], byteList[i + 1]]) + '] -> (' + numArrayToHexArray([a, b]) + ')');
      }
      const cmdHistory = this.cmdHistory;
      const isControlCode = a >= 0x10 && a <= 0x1f;
      if (isControlCode) {
        // Skip redundant control codes
        if (hasCmdRepeated(a, b, cmdHistory)) {
          setLastCmd(null, null, cmdHistory);
          this.logger.log(3, () => 'Repeated command (' + numArrayToHexArray([a, b]) + ') is dropped');
          continue;
        }
        setLastCmd(a, b, this.cmdHistory);
        cmdFound = this.parseCmd(a, b);
        if (!cmdFound) {
          cmdFound = this.parseMidrow(a, b);
        }
        if (!cmdFound) {
          cmdFound = this.parsePAC(a, b);
        }
        if (!cmdFound) {
          cmdFound = this.parseBackgroundAttributes(a, b);
        }
      } else {
        setLastCmd(null, null, cmdHistory);
      }
      if (!cmdFound) {
        charsFound = this.parseChars(a, b);
        if (charsFound) {
          const currChNr = this.currentChannel;
          if (currChNr && currChNr > 0) {
            const channel = this.channels[currChNr];
            channel.insertChars(charsFound);
          } else {
            this.logger.log(2, 'No channel found yet. TEXT-MODE?');
          }
        }
      }
      if (!cmdFound && !charsFound) {
        this.logger.log(2, () => "Couldn't parse cleaned data " + numArrayToHexArray([a, b]) + ' orig: ' + numArrayToHexArray([byteList[i], byteList[i + 1]]));
      }
    }
  }

  /**
   * Parse Command.
   * @returns True if a command was found
   */
  parseCmd(a, b) {
    const cond1 = (a === 0x14 || a === 0x1c || a === 0x15 || a === 0x1d) && b >= 0x20 && b <= 0x2f;
    const cond2 = (a === 0x17 || a === 0x1f) && b >= 0x21 && b <= 0x23;
    if (!(cond1 || cond2)) {
      return false;
    }
    const chNr = a === 0x14 || a === 0x15 || a === 0x17 ? 1 : 2;
    const channel = this.channels[chNr];
    if (a === 0x14 || a === 0x15 || a === 0x1c || a === 0x1d) {
      if (b === 0x20) {
        channel.ccRCL();
      } else if (b === 0x21) {
        channel.ccBS();
      } else if (b === 0x22) {
        channel.ccAOF();
      } else if (b === 0x23) {
        channel.ccAON();
      } else if (b === 0x24) {
        channel.ccDER();
      } else if (b === 0x25) {
        channel.ccRU(2);
      } else if (b === 0x26) {
        channel.ccRU(3);
      } else if (b === 0x27) {
        channel.ccRU(4);
      } else if (b === 0x28) {
        channel.ccFON();
      } else if (b === 0x29) {
        channel.ccRDC();
      } else if (b === 0x2a) {
        channel.ccTR();
      } else if (b === 0x2b) {
        channel.ccRTD();
      } else if (b === 0x2c) {
        channel.ccEDM();
      } else if (b === 0x2d) {
        channel.ccCR();
      } else if (b === 0x2e) {
        channel.ccENM();
      } else if (b === 0x2f) {
        channel.ccEOC();
      }
    } else {
      // a == 0x17 || a == 0x1F
      channel.ccTO(b - 0x20);
    }
    this.currentChannel = chNr;
    return true;
  }

  /**
   * Parse midrow styling command
   */
  parseMidrow(a, b) {
    let chNr = 0;
    if ((a === 0x11 || a === 0x19) && b >= 0x20 && b <= 0x2f) {
      if (a === 0x11) {
        chNr = 1;
      } else {
        chNr = 2;
      }
      if (chNr !== this.currentChannel) {
        this.logger.log(0, 'Mismatch channel in midrow parsing');
        return false;
      }
      const channel = this.channels[chNr];
      if (!channel) {
        return false;
      }
      channel.ccMIDROW(b);
      this.logger.log(3, () => 'MIDROW (' + numArrayToHexArray([a, b]) + ')');
      return true;
    }
    return false;
  }

  /**
   * Parse Preable Access Codes (Table 53).
   * @returns {Boolean} Tells if PAC found
   */
  parsePAC(a, b) {
    let row;
    const case1 = (a >= 0x11 && a <= 0x17 || a >= 0x19 && a <= 0x1f) && b >= 0x40 && b <= 0x7f;
    const case2 = (a === 0x10 || a === 0x18) && b >= 0x40 && b <= 0x5f;
    if (!(case1 || case2)) {
      return false;
    }
    const chNr = a <= 0x17 ? 1 : 2;
    if (b >= 0x40 && b <= 0x5f) {
      row = chNr === 1 ? rowsLowCh1[a] : rowsLowCh2[a];
    } else {
      // 0x60 <= b <= 0x7F
      row = chNr === 1 ? rowsHighCh1[a] : rowsHighCh2[a];
    }
    const channel = this.channels[chNr];
    if (!channel) {
      return false;
    }
    channel.setPAC(this.interpretPAC(row, b));
    this.currentChannel = chNr;
    return true;
  }

  /**
   * Interpret the second byte of the pac, and return the information.
   * @returns pacData with style parameters
   */
  interpretPAC(row, byte) {
    let pacIndex;
    const pacData = {
      color: null,
      italics: false,
      indent: null,
      underline: false,
      row: row
    };
    if (byte > 0x5f) {
      pacIndex = byte - 0x60;
    } else {
      pacIndex = byte - 0x40;
    }
    pacData.underline = (pacIndex & 1) === 1;
    if (pacIndex <= 0xd) {
      pacData.color = ['white', 'green', 'blue', 'cyan', 'red', 'yellow', 'magenta', 'white'][Math.floor(pacIndex / 2)];
    } else if (pacIndex <= 0xf) {
      pacData.italics = true;
      pacData.color = 'white';
    } else {
      pacData.indent = Math.floor((pacIndex - 0x10) / 2) * 4;
    }
    return pacData; // Note that row has zero offset. The spec uses 1.
  }

  /**
   * Parse characters.
   * @returns An array with 1 to 2 codes corresponding to chars, if found. null otherwise.
   */
  parseChars(a, b) {
    let channelNr;
    let charCodes = null;
    let charCode1 = null;
    if (a >= 0x19) {
      channelNr = 2;
      charCode1 = a - 8;
    } else {
      channelNr = 1;
      charCode1 = a;
    }
    if (charCode1 >= 0x11 && charCode1 <= 0x13) {
      // Special character
      let oneCode;
      if (charCode1 === 0x11) {
        oneCode = b + 0x50;
      } else if (charCode1 === 0x12) {
        oneCode = b + 0x70;
      } else {
        oneCode = b + 0x90;
      }
      this.logger.log(2, () => "Special char '" + getCharForByte(oneCode) + "' in channel " + channelNr);
      charCodes = [oneCode];
    } else if (a >= 0x20 && a <= 0x7f) {
      charCodes = b === 0 ? [a] : [a, b];
    }
    if (charCodes) {
      this.logger.log(3, () => 'Char codes =  ' + numArrayToHexArray(charCodes).join(','));
    }
    return charCodes;
  }

  /**
   * Parse extended background attributes as well as new foreground color black.
   * @returns True if background attributes are found
   */
  parseBackgroundAttributes(a, b) {
    const case1 = (a === 0x10 || a === 0x18) && b >= 0x20 && b <= 0x2f;
    const case2 = (a === 0x17 || a === 0x1f) && b >= 0x2d && b <= 0x2f;
    if (!(case1 || case2)) {
      return false;
    }
    let index;
    const bkgData = {};
    if (a === 0x10 || a === 0x18) {
      index = Math.floor((b - 0x20) / 2);
      bkgData.background = backgroundColors[index];
      if (b % 2 === 1) {
        bkgData.background = bkgData.background + '_semi';
      }
    } else if (b === 0x2d) {
      bkgData.background = 'transparent';
    } else {
      bkgData.foreground = 'black';
      if (b === 0x2f) {
        bkgData.underline = true;
      }
    }
    const chNr = a <= 0x17 ? 1 : 2;
    const channel = this.channels[chNr];
    channel.setBkgData(bkgData);
    return true;
  }

  /**
   * Reset state of parser and its channels.
   */
  reset() {
    for (let i = 0; i < Object.keys(this.channels).length; i++) {
      const channel = this.channels[i];
      if (channel) {
        channel.reset();
      }
    }
    setLastCmd(null, null, this.cmdHistory);
  }

  /**
   * Trigger the generation of a cue, and the start of a new one if displayScreens are not empty.
   */
  cueSplitAtTime(t) {
    for (let i = 0; i < this.channels.length; i++) {
      const channel = this.channels[i];
      if (channel) {
        channel.cueSplitAtTime(t);
      }
    }
  }
}
function setLastCmd(a, b, cmdHistory) {
  cmdHistory.a = a;
  cmdHistory.b = b;
}
function hasCmdRepeated(a, b, cmdHistory) {
  return cmdHistory.a === a && cmdHistory.b === b;
}
function createCmdHistory() {
  return {
    a: null,
    b: null
  };
}

class OutputFilter {
  constructor(timelineController, trackName) {
    this.timelineController = void 0;
    this.cueRanges = [];
    this.trackName = void 0;
    this.startTime = null;
    this.endTime = null;
    this.screen = null;
    this.timelineController = timelineController;
    this.trackName = trackName;
  }
  dispatchCue() {
    if (this.startTime === null) {
      return;
    }
    this.timelineController.addCues(this.trackName, this.startTime, this.endTime, this.screen, this.cueRanges);
    this.startTime = null;
  }
  newCue(startTime, endTime, screen) {
    if (this.startTime === null || this.startTime > startTime) {
      this.startTime = startTime;
    }
    this.endTime = endTime;
    this.screen = screen;
    this.timelineController.createCaptionsTrack(this.trackName);
  }
  reset() {
    this.cueRanges = [];
    this.startTime = null;
  }
}

/**
 * Copyright 2013 vtt.js Contributors
 *
 * Licensed under the Apache License, Version 2.0 (the 'License');
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an 'AS IS' BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

var VTTCue = (function () {
  if (optionalSelf != null && optionalSelf.VTTCue) {
    return self.VTTCue;
  }
  const AllowedDirections = ['', 'lr', 'rl'];
  const AllowedAlignments = ['start', 'middle', 'end', 'left', 'right'];
  function isAllowedValue(allowed, value) {
    if (typeof value !== 'string') {
      return false;
    }
    // necessary for assuring the generic conforms to the Array interface
    if (!Array.isArray(allowed)) {
      return false;
    }
    // reset the type so that the next narrowing works well
    const lcValue = value.toLowerCase();
    // use the allow list to narrow the type to a specific subset of strings
    if (~allowed.indexOf(lcValue)) {
      return lcValue;
    }
    return false;
  }
  function findDirectionSetting(value) {
    return isAllowedValue(AllowedDirections, value);
  }
  function findAlignSetting(value) {
    return isAllowedValue(AllowedAlignments, value);
  }
  function extend(obj, ...rest) {
    let i = 1;
    for (; i < arguments.length; i++) {
      const cobj = arguments[i];
      for (const p in cobj) {
        obj[p] = cobj[p];
      }
    }
    return obj;
  }
  function VTTCue(startTime, endTime, text) {
    const cue = this;
    const baseObj = {
      enumerable: true
    };
    /**
     * Shim implementation specific properties. These properties are not in
     * the spec.
     */

    // Lets us know when the VTTCue's data has changed in such a way that we need
    // to recompute its display state. This lets us compute its display state
    // lazily.
    cue.hasBeenReset = false;

    /**
     * VTTCue and TextTrackCue properties
     * http://dev.w3.org/html5/webvtt/#vttcue-interface
     */

    let _id = '';
    let _pauseOnExit = false;
    let _startTime = startTime;
    let _endTime = endTime;
    let _text = text;
    let _region = null;
    let _vertical = '';
    let _snapToLines = true;
    let _line = 'auto';
    let _lineAlign = 'start';
    let _position = 50;
    let _positionAlign = 'middle';
    let _size = 50;
    let _align = 'middle';
    Object.defineProperty(cue, 'id', extend({}, baseObj, {
      get: function () {
        return _id;
      },
      set: function (value) {
        _id = '' + value;
      }
    }));
    Object.defineProperty(cue, 'pauseOnExit', extend({}, baseObj, {
      get: function () {
        return _pauseOnExit;
      },
      set: function (value) {
        _pauseOnExit = !!value;
      }
    }));
    Object.defineProperty(cue, 'startTime', extend({}, baseObj, {
      get: function () {
        return _startTime;
      },
      set: function (value) {
        if (typeof value !== 'number') {
          throw new TypeError('Start time must be set to a number.');
        }
        _startTime = value;
        this.hasBeenReset = true;
      }
    }));
    Object.defineProperty(cue, 'endTime', extend({}, baseObj, {
      get: function () {
        return _endTime;
      },
      set: function (value) {
        if (typeof value !== 'number') {
          throw new TypeError('End time must be set to a number.');
        }
        _endTime = value;
        this.hasBeenReset = true;
      }
    }));
    Object.defineProperty(cue, 'text', extend({}, baseObj, {
      get: function () {
        return _text;
      },
      set: function (value) {
        _text = '' + value;
        this.hasBeenReset = true;
      }
    }));

    // todo: implement VTTRegion polyfill?
    Object.defineProperty(cue, 'region', extend({}, baseObj, {
      get: function () {
        return _region;
      },
      set: function (value) {
        _region = value;
        this.hasBeenReset = true;
      }
    }));
    Object.defineProperty(cue, 'vertical', extend({}, baseObj, {
      get: function () {
        return _vertical;
      },
      set: function (value) {
        const setting = findDirectionSetting(value);
        // Have to check for false because the setting an be an empty string.
        if (setting === false) {
          throw new SyntaxError('An invalid or illegal string was specified.');
        }
        _vertical = setting;
        this.hasBeenReset = true;
      }
    }));
    Object.defineProperty(cue, 'snapToLines', extend({}, baseObj, {
      get: function () {
        return _snapToLines;
      },
      set: function (value) {
        _snapToLines = !!value;
        this.hasBeenReset = true;
      }
    }));
    Object.defineProperty(cue, 'line', extend({}, baseObj, {
      get: function () {
        return _line;
      },
      set: function (value) {
        if (typeof value !== 'number' && value !== 'auto') {
          throw new SyntaxError('An invalid number or illegal string was specified.');
        }
        _line = value;
        this.hasBeenReset = true;
      }
    }));
    Object.defineProperty(cue, 'lineAlign', extend({}, baseObj, {
      get: function () {
        return _lineAlign;
      },
      set: function (value) {
        const setting = findAlignSetting(value);
        if (!setting) {
          throw new SyntaxError('An invalid or illegal string was specified.');
        }
        _lineAlign = setting;
        this.hasBeenReset = true;
      }
    }));
    Object.defineProperty(cue, 'position', extend({}, baseObj, {
      get: function () {
        return _position;
      },
      set: function (value) {
        if (value < 0 || value > 100) {
          throw new Error('Position must be between 0 and 100.');
        }
        _position = value;
        this.hasBeenReset = true;
      }
    }));
    Object.defineProperty(cue, 'positionAlign', extend({}, baseObj, {
      get: function () {
        return _positionAlign;
      },
      set: function (value) {
        const setting = findAlignSetting(value);
        if (!setting) {
          throw new SyntaxError('An invalid or illegal string was specified.');
        }
        _positionAlign = setting;
        this.hasBeenReset = true;
      }
    }));
    Object.defineProperty(cue, 'size', extend({}, baseObj, {
      get: function () {
        return _size;
      },
      set: function (value) {
        if (value < 0 || value > 100) {
          throw new Error('Size must be between 0 and 100.');
        }
        _size = value;
        this.hasBeenReset = true;
      }
    }));
    Object.defineProperty(cue, 'align', extend({}, baseObj, {
      get: function () {
        return _align;
      },
      set: function (value) {
        const setting = findAlignSetting(value);
        if (!setting) {
          throw new SyntaxError('An invalid or illegal string was specified.');
        }
        _align = setting;
        this.hasBeenReset = true;
      }
    }));

    /**
     * Other <track> spec defined properties
     */

    // http://www.whatwg.org/specs/web-apps/current-work/multipage/the-video-element.html#text-track-cue-display-state
    cue.displayState = undefined;
  }

  /**
   * VTTCue methods
   */

  VTTCue.prototype.getCueAsHTML = function () {
    // Assume WebVTT.convertCueToDOMTree is on the global.
    const WebVTT = self.WebVTT;
    return WebVTT.convertCueToDOMTree(self, this.text);
  };
  // this is a polyfill hack
  return VTTCue;
})();

/*
 * Source: https://github.com/mozilla/vtt.js/blob/master/dist/vtt.js
 */

class StringDecoder {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  decode(data, options) {
    if (!data) {
      return '';
    }
    if (typeof data !== 'string') {
      throw new Error('Error - expected string data.');
    }
    return decodeURIComponent(encodeURIComponent(data));
  }
}

// Try to parse input as a time stamp.
function parseTimeStamp(input) {
  function computeSeconds(h, m, s, f) {
    return (h | 0) * 3600 + (m | 0) * 60 + (s | 0) + parseFloat(f || 0);
  }
  const m = input.match(/^(?:(\d+):)?(\d{2}):(\d{2})(\.\d+)?/);
  if (!m) {
    return null;
  }
  if (parseFloat(m[2]) > 59) {
    // Timestamp takes the form of [hours]:[minutes].[milliseconds]
    // First position is hours as it's over 59.
    return computeSeconds(m[2], m[3], 0, m[4]);
  }
  // Timestamp takes the form of [hours (optional)]:[minutes]:[seconds].[milliseconds]
  return computeSeconds(m[1], m[2], m[3], m[4]);
}

// A settings object holds key/value pairs and will ignore anything but the first
// assignment to a specific key.
class Settings {
  constructor() {
    this.values = Object.create(null);
  }
  // Only accept the first assignment to any key.
  set(k, v) {
    if (!this.get(k) && v !== '') {
      this.values[k] = v;
    }
  }
  // Return the value for a key, or a default value.
  // If 'defaultKey' is passed then 'dflt' is assumed to be an object with
  // a number of possible default values as properties where 'defaultKey' is
  // the key of the property that will be chosen; otherwise it's assumed to be
  // a single value.
  get(k, dflt, defaultKey) {
    if (defaultKey) {
      return this.has(k) ? this.values[k] : dflt[defaultKey];
    }
    return this.has(k) ? this.values[k] : dflt;
  }
  // Check whether we have a value for a key.
  has(k) {
    return k in this.values;
  }
  // Accept a setting if its one of the given alternatives.
  alt(k, v, a) {
    for (let n = 0; n < a.length; ++n) {
      if (v === a[n]) {
        this.set(k, v);
        break;
      }
    }
  }
  // Accept a setting if its a valid (signed) integer.
  integer(k, v) {
    if (/^-?\d+$/.test(v)) {
      // integer
      this.set(k, parseInt(v, 10));
    }
  }
  // Accept a setting if its a valid percentage.
  percent(k, v) {
    if (/^([\d]{1,3})(\.[\d]*)?%$/.test(v)) {
      const percent = parseFloat(v);
      if (percent >= 0 && percent <= 100) {
        this.set(k, percent);
        return true;
      }
    }
    return false;
  }
}

// Helper function to parse input into groups separated by 'groupDelim', and
// interpret each group as a key/value pair separated by 'keyValueDelim'.
function parseOptions(input, callback, keyValueDelim, groupDelim) {
  const groups = groupDelim ? input.split(groupDelim) : [input];
  for (const i in groups) {
    if (typeof groups[i] !== 'string') {
      continue;
    }
    const kv = groups[i].split(keyValueDelim);
    if (kv.length !== 2) {
      continue;
    }
    const k = kv[0];
    const v = kv[1];
    callback(k, v);
  }
}
const defaults = new VTTCue(0, 0, '');
// 'middle' was changed to 'center' in the spec: https://github.com/w3c/webvtt/pull/244
//  Safari doesn't yet support this change, but FF and Chrome do.
const center = defaults.align === 'middle' ? 'middle' : 'center';
function parseCue(input, cue, regionList) {
  // Remember the original input if we need to throw an error.
  const oInput = input;
  // 4.1 WebVTT timestamp
  function consumeTimeStamp() {
    const ts = parseTimeStamp(input);
    if (ts === null) {
      throw new Error('Malformed timestamp: ' + oInput);
    }

    // Remove time stamp from input.
    input = input.replace(/^[^\sa-zA-Z-]+/, '');
    return ts;
  }

  // 4.4.2 WebVTT cue settings
  function consumeCueSettings(input, cue) {
    const settings = new Settings();
    parseOptions(input, function (k, v) {
      let vals;
      switch (k) {
        case 'region':
          // Find the last region we parsed with the same region id.
          for (let i = regionList.length - 1; i >= 0; i--) {
            if (regionList[i].id === v) {
              settings.set(k, regionList[i].region);
              break;
            }
          }
          break;
        case 'vertical':
          settings.alt(k, v, ['rl', 'lr']);
          break;
        case 'line':
          vals = v.split(',');
          settings.integer(k, vals[0]);
          if (settings.percent(k, vals[0])) {
            settings.set('snapToLines', false);
          }
          settings.alt(k, vals[0], ['auto']);
          if (vals.length === 2) {
            settings.alt('lineAlign', vals[1], ['start', center, 'end']);
          }
          break;
        case 'position':
          vals = v.split(',');
          settings.percent(k, vals[0]);
          if (vals.length === 2) {
            settings.alt('positionAlign', vals[1], ['start', center, 'end', 'line-left', 'line-right', 'auto']);
          }
          break;
        case 'size':
          settings.percent(k, v);
          break;
        case 'align':
          settings.alt(k, v, ['start', center, 'end', 'left', 'right']);
          break;
      }
    }, /:/, /\s/);

    // Apply default values for any missing fields.
    cue.region = settings.get('region', null);
    cue.vertical = settings.get('vertical', '');
    let line = settings.get('line', 'auto');
    if (line === 'auto' && defaults.line === -1) {
      // set numeric line number for Safari
      line = -1;
    }
    cue.line = line;
    cue.lineAlign = settings.get('lineAlign', 'start');
    cue.snapToLines = settings.get('snapToLines', true);
    cue.size = settings.get('size', 100);
    cue.align = settings.get('align', center);
    let position = settings.get('position', 'auto');
    if (position === 'auto' && defaults.position === 50) {
      // set numeric position for Safari
      position = cue.align === 'start' || cue.align === 'left' ? 0 : cue.align === 'end' || cue.align === 'right' ? 100 : 50;
    }
    cue.position = position;
  }
  function skipWhitespace() {
    input = input.replace(/^\s+/, '');
  }

  // 4.1 WebVTT cue timings.
  skipWhitespace();
  cue.startTime = consumeTimeStamp(); // (1) collect cue start time
  skipWhitespace();
  if (input.slice(0, 3) !== '-->') {
    // (3) next characters must match '-->'
    throw new Error("Malformed time stamp (time stamps must be separated by '-->'): " + oInput);
  }
  input = input.slice(3);
  skipWhitespace();
  cue.endTime = consumeTimeStamp(); // (5) collect cue end time

  // 4.1 WebVTT cue settings list.
  skipWhitespace();
  consumeCueSettings(input, cue);
}
function fixLineBreaks(input) {
  return input.replace(/<br(?: \/)?>/gi, '\n');
}
class VTTParser {
  constructor() {
    this.state = 'INITIAL';
    this.buffer = '';
    this.decoder = new StringDecoder();
    this.regionList = [];
    this.cue = null;
    this.oncue = void 0;
    this.onparsingerror = void 0;
    this.onflush = void 0;
  }
  parse(data) {
    const _this = this;

    // If there is no data then we won't decode it, but will just try to parse
    // whatever is in buffer already. This may occur in circumstances, for
    // example when flush() is called.
    if (data) {
      // Try to decode the data that we received.
      _this.buffer += _this.decoder.decode(data, {
        stream: true
      });
    }
    function collectNextLine() {
      let buffer = _this.buffer;
      let pos = 0;
      buffer = fixLineBreaks(buffer);
      while (pos < buffer.length && buffer[pos] !== '\r' && buffer[pos] !== '\n') {
        ++pos;
      }
      const line = buffer.slice(0, pos);
      // Advance the buffer early in case we fail below.
      if (buffer[pos] === '\r') {
        ++pos;
      }
      if (buffer[pos] === '\n') {
        ++pos;
      }
      _this.buffer = buffer.slice(pos);
      return line;
    }

    // 3.2 WebVTT metadata header syntax
    function parseHeader(input) {
      parseOptions(input, function (k, v) {
        // switch (k) {
        // case 'region':
        // 3.3 WebVTT region metadata header syntax
        // console.log('parse region', v);
        // parseRegion(v);
        // break;
        // }
      }, /:/);
    }

    // 5.1 WebVTT file parsing.
    try {
      let line = '';
      if (_this.state === 'INITIAL') {
        // We can't start parsing until we have the first line.
        if (!/\r\n|\n/.test(_this.buffer)) {
          return this;
        }
        line = collectNextLine();
        // strip of UTF-8 BOM if any
        // https://en.wikipedia.org/wiki/Byte_order_mark#UTF-8
        const m = line.match(/^(ï»¿)?WEBVTT([ \t].*)?$/);
        if (!(m != null && m[0])) {
          throw new Error('Malformed WebVTT signature.');
        }
        _this.state = 'HEADER';
      }
      let alreadyCollectedLine = false;
      while (_this.buffer) {
        // We can't parse a line until we have the full line.
        if (!/\r\n|\n/.test(_this.buffer)) {
          return this;
        }
        if (!alreadyCollectedLine) {
          line = collectNextLine();
        } else {
          alreadyCollectedLine = false;
        }
        switch (_this.state) {
          case 'HEADER':
            // 13-18 - Allow a header (metadata) under the WEBVTT line.
            if (/:/.test(line)) {
              parseHeader(line);
            } else if (!line) {
              // An empty line terminates the header and starts the body (cues).
              _this.state = 'ID';
            }
            continue;
          case 'NOTE':
            // Ignore NOTE blocks.
            if (!line) {
              _this.state = 'ID';
            }
            continue;
          case 'ID':
            // Check for the start of NOTE blocks.
            if (/^NOTE($|[ \t])/.test(line)) {
              _this.state = 'NOTE';
              break;
            }
            // 19-29 - Allow any number of line terminators, then initialize new cue values.
            if (!line) {
              continue;
            }
            _this.cue = new VTTCue(0, 0, '');
            _this.state = 'CUE';
            // 30-39 - Check if self line contains an optional identifier or timing data.
            if (line.indexOf('-->') === -1) {
              _this.cue.id = line;
              continue;
            }
          // Process line as start of a cue.
          /* falls through */
          case 'CUE':
            // 40 - Collect cue timings and settings.
            if (!_this.cue) {
              _this.state = 'BADCUE';
              continue;
            }
            try {
              parseCue(line, _this.cue, _this.regionList);
            } catch (e) {
              // In case of an error ignore rest of the cue.
              _this.cue = null;
              _this.state = 'BADCUE';
              continue;
            }
            _this.state = 'CUETEXT';
            continue;
          case 'CUETEXT':
            {
              const hasSubstring = line.indexOf('-->') !== -1;
              // 34 - If we have an empty line then report the cue.
              // 35 - If we have the special substring '-->' then report the cue,
              // but do not collect the line as we need to process the current
              // one as a new cue.
              if (!line || hasSubstring && (alreadyCollectedLine = true)) {
                // We are done parsing self cue.
                if (_this.oncue && _this.cue) {
                  _this.oncue(_this.cue);
                }
                _this.cue = null;
                _this.state = 'ID';
                continue;
              }
              if (_this.cue === null) {
                continue;
              }
              if (_this.cue.text) {
                _this.cue.text += '\n';
              }
              _this.cue.text += line;
            }
            continue;
          case 'BADCUE':
            // 54-62 - Collect and discard the remaining cue.
            if (!line) {
              _this.state = 'ID';
            }
        }
      }
    } catch (e) {
      // If we are currently parsing a cue, report what we have.
      if (_this.state === 'CUETEXT' && _this.cue && _this.oncue) {
        _this.oncue(_this.cue);
      }
      _this.cue = null;
      // Enter BADWEBVTT state if header was not parsed correctly otherwise
      // another exception occurred so enter BADCUE state.
      _this.state = _this.state === 'INITIAL' ? 'BADWEBVTT' : 'BADCUE';
    }
    return this;
  }
  flush() {
    const _this = this;
    try {
      // Finish decoding the stream.
      // _this.buffer += _this.decoder.decode();
      // Synthesize the end of the current cue or region.
      if (_this.cue || _this.state === 'HEADER') {
        _this.buffer += '\n\n';
        _this.parse();
      }
      // If we've flushed, parsed, and we're still on the INITIAL state then
      // that means we don't have enough of the stream to parse the first
      // line.
      if (_this.state === 'INITIAL' || _this.state === 'BADWEBVTT') {
        throw new Error('Malformed WebVTT signature.');
      }
    } catch (e) {
      if (_this.onparsingerror) {
        _this.onparsingerror(e);
      }
    }
    if (_this.onflush) {
      _this.onflush();
    }
    return this;
  }
}

const LINEBREAKS = /\r\n|\n\r|\n|\r/g;

// String.prototype.startsWith is not supported in IE11
const startsWith = function startsWith(inputString, searchString, position = 0) {
  return inputString.slice(position, position + searchString.length) === searchString;
};
const cueString2millis = function cueString2millis(timeString) {
  let ts = parseInt(timeString.slice(-3));
  const secs = parseInt(timeString.slice(-6, -4));
  const mins = parseInt(timeString.slice(-9, -7));
  const hours = timeString.length > 9 ? parseInt(timeString.substring(0, timeString.indexOf(':'))) : 0;
  if (!isFiniteNumber(ts) || !isFiniteNumber(secs) || !isFiniteNumber(mins) || !isFiniteNumber(hours)) {
    throw Error(`Malformed X-TIMESTAMP-MAP: Local:${timeString}`);
  }
  ts += 1000 * secs;
  ts += 60 * 1000 * mins;
  ts += 60 * 60 * 1000 * hours;
  return ts;
};

// From https://github.com/darkskyapp/string-hash
const hash = function hash(text) {
  let _hash = 5381;
  let i = text.length;
  while (i) {
    _hash = _hash * 33 ^ text.charCodeAt(--i);
  }
  return (_hash >>> 0).toString();
};

// Create a unique hash id for a cue based on start/end times and text.
// This helps timeline-controller to avoid showing repeated captions.
function generateCueId(startTime, endTime, text) {
  return hash(startTime.toString()) + hash(endTime.toString()) + hash(text);
}
const calculateOffset = function calculateOffset(vttCCs, cc, presentationTime) {
  let currCC = vttCCs[cc];
  let prevCC = vttCCs[currCC.prevCC];

  // This is the first discontinuity or cues have been processed since the last discontinuity
  // Offset = current discontinuity time
  if (!prevCC || !prevCC.new && currCC.new) {
    vttCCs.ccOffset = vttCCs.presentationOffset = currCC.start;
    currCC.new = false;
    return;
  }

  // There have been discontinuities since cues were last parsed.
  // Offset = time elapsed
  while ((_prevCC = prevCC) != null && _prevCC.new) {
    var _prevCC;
    vttCCs.ccOffset += currCC.start - prevCC.start;
    currCC.new = false;
    currCC = prevCC;
    prevCC = vttCCs[currCC.prevCC];
  }
  vttCCs.presentationOffset = presentationTime;
};
function parseWebVTT(vttByteArray, initPTS, vttCCs, cc, timeOffset, callBack, errorCallBack) {
  const parser = new VTTParser();
  // Convert byteArray into string, replacing any somewhat exotic linefeeds with "\n", then split on that character.
  // Uint8Array.prototype.reduce is not implemented in IE11
  const vttLines = utf8ArrayToStr(new Uint8Array(vttByteArray)).trim().replace(LINEBREAKS, '\n').split('\n');
  const cues = [];
  const init90kHz = initPTS ? toMpegTsClockFromTimescale(initPTS.baseTime, initPTS.timescale) : 0;
  let cueTime = '00:00.000';
  let timestampMapMPEGTS = 0;
  let timestampMapLOCAL = 0;
  let parsingError;
  let inHeader = true;
  parser.oncue = function (cue) {
    // Adjust cue timing; clamp cues to start no earlier than - and drop cues that don't end after - 0 on timeline.
    const currCC = vttCCs[cc];
    let cueOffset = vttCCs.ccOffset;

    // Calculate subtitle PTS offset
    const webVttMpegTsMapOffset = (timestampMapMPEGTS - init90kHz) / 90000;

    // Update offsets for new discontinuities
    if (currCC != null && currCC.new) {
      if (timestampMapLOCAL !== undefined) {
        // When local time is provided, offset = discontinuity start time - local time
        cueOffset = vttCCs.ccOffset = currCC.start;
      } else {
        calculateOffset(vttCCs, cc, webVttMpegTsMapOffset);
      }
    }
    if (webVttMpegTsMapOffset) {
      if (!initPTS) {
        parsingError = new Error('Missing initPTS for VTT MPEGTS');
        return;
      }
      // If we have MPEGTS, offset = presentation time + discontinuity offset
      cueOffset = webVttMpegTsMapOffset - vttCCs.presentationOffset;
    }
    const duration = cue.endTime - cue.startTime;
    const startTime = normalizePts((cue.startTime + cueOffset - timestampMapLOCAL) * 90000, timeOffset * 90000) / 90000;
    cue.startTime = Math.max(startTime, 0);
    cue.endTime = Math.max(startTime + duration, 0);

    //trim trailing webvtt block whitespaces
    const text = cue.text.trim();

    // Fix encoding of special characters
    cue.text = decodeURIComponent(encodeURIComponent(text));

    // If the cue was not assigned an id from the VTT file (line above the content), create one.
    if (!cue.id) {
      cue.id = generateCueId(cue.startTime, cue.endTime, text);
    }
    if (cue.endTime > 0) {
      cues.push(cue);
    }
  };
  parser.onparsingerror = function (error) {
    parsingError = error;
  };
  parser.onflush = function () {
    if (parsingError) {
      errorCallBack(parsingError);
      return;
    }
    callBack(cues);
  };

  // Go through contents line by line.
  vttLines.forEach(line => {
    if (inHeader) {
      // Look for X-TIMESTAMP-MAP in header.
      if (startsWith(line, 'X-TIMESTAMP-MAP=')) {
        // Once found, no more are allowed anyway, so stop searching.
        inHeader = false;
        // Extract LOCAL and MPEGTS.
        line.slice(16).split(',').forEach(timestamp => {
          if (startsWith(timestamp, 'LOCAL:')) {
            cueTime = timestamp.slice(6);
          } else if (startsWith(timestamp, 'MPEGTS:')) {
            timestampMapMPEGTS = parseInt(timestamp.slice(7));
          }
        });
        try {
          // Convert cue time to seconds
          timestampMapLOCAL = cueString2millis(cueTime) / 1000;
        } catch (error) {
          parsingError = error;
        }
        // Return without parsing X-TIMESTAMP-MAP line.
        return;
      } else if (line === '') {
        inHeader = false;
      }
    }
    // Parse line by default.
    parser.parse(line + '\n');
  });
  parser.flush();
}

const IMSC1_CODEC = 'stpp.ttml.im1t';

// Time format: h:m:s:frames(.subframes)
const HMSF_REGEX = /^(\d{2,}):(\d{2}):(\d{2}):(\d{2})\.?(\d+)?$/;

// Time format: hours, minutes, seconds, milliseconds, frames, ticks
const TIME_UNIT_REGEX = /^(\d*(?:\.\d*)?)(h|m|s|ms|f|t)$/;
const textAlignToLineAlign = {
  left: 'start',
  center: 'center',
  right: 'end',
  start: 'start',
  end: 'end'
};
function parseIMSC1(payload, initPTS, callBack, errorCallBack) {
  const results = findBox(new Uint8Array(payload), ['mdat']);
  if (results.length === 0) {
    errorCallBack(new Error('Could not parse IMSC1 mdat'));
    return;
  }
  const ttmlList = results.map(mdat => utf8ArrayToStr(mdat));
  const syncTime = toTimescaleFromScale(initPTS.baseTime, 1, initPTS.timescale);
  try {
    ttmlList.forEach(ttml => callBack(parseTTML(ttml, syncTime)));
  } catch (error) {
    errorCallBack(error);
  }
}
function parseTTML(ttml, syncTime) {
  const parser = new DOMParser();
  const xmlDoc = parser.parseFromString(ttml, 'text/xml');
  const tt = xmlDoc.getElementsByTagName('tt')[0];
  if (!tt) {
    throw new Error('Invalid ttml');
  }
  const defaultRateInfo = {
    frameRate: 30,
    subFrameRate: 1,
    frameRateMultiplier: 0,
    tickRate: 0
  };
  const rateInfo = Object.keys(defaultRateInfo).reduce((result, key) => {
    result[key] = tt.getAttribute(`ttp:${key}`) || defaultRateInfo[key];
    return result;
  }, {});
  const trim = tt.getAttribute('xml:space') !== 'preserve';
  const styleElements = collectionToDictionary(getElementCollection(tt, 'styling', 'style'));
  const regionElements = collectionToDictionary(getElementCollection(tt, 'layout', 'region'));
  const cueElements = getElementCollection(tt, 'body', '[begin]');
  return [].map.call(cueElements, cueElement => {
    const cueText = getTextContent(cueElement, trim);
    if (!cueText || !cueElement.hasAttribute('begin')) {
      return null;
    }
    const startTime = parseTtmlTime(cueElement.getAttribute('begin'), rateInfo);
    const duration = parseTtmlTime(cueElement.getAttribute('dur'), rateInfo);
    let endTime = parseTtmlTime(cueElement.getAttribute('end'), rateInfo);
    if (startTime === null) {
      throw timestampParsingError(cueElement);
    }
    if (endTime === null) {
      if (duration === null) {
        throw timestampParsingError(cueElement);
      }
      endTime = startTime + duration;
    }
    const cue = new VTTCue(startTime - syncTime, endTime - syncTime, cueText);
    cue.id = generateCueId(cue.startTime, cue.endTime, cue.text);
    const region = regionElements[cueElement.getAttribute('region')];
    const style = styleElements[cueElement.getAttribute('style')];

    // Apply styles to cue
    const styles = getTtmlStyles(region, style, styleElements);
    const {
      textAlign
    } = styles;
    if (textAlign) {
      // cue.positionAlign not settable in FF~2016
      const lineAlign = textAlignToLineAlign[textAlign];
      if (lineAlign) {
        cue.lineAlign = lineAlign;
      }
      cue.align = textAlign;
    }
    _extends(cue, styles);
    return cue;
  }).filter(cue => cue !== null);
}
function getElementCollection(fromElement, parentName, childName) {
  const parent = fromElement.getElementsByTagName(parentName)[0];
  if (parent) {
    return [].slice.call(parent.querySelectorAll(childName));
  }
  return [];
}
function collectionToDictionary(elementsWithId) {
  return elementsWithId.reduce((dict, element) => {
    const id = element.getAttribute('xml:id');
    if (id) {
      dict[id] = element;
    }
    return dict;
  }, {});
}
function getTextContent(element, trim) {
  return [].slice.call(element.childNodes).reduce((str, node, i) => {
    var _node$childNodes;
    if (node.nodeName === 'br' && i) {
      return str + '\n';
    }
    if ((_node$childNodes = node.childNodes) != null && _node$childNodes.length) {
      return getTextContent(node, trim);
    } else if (trim) {
      return str + node.textContent.trim().replace(/\s+/g, ' ');
    }
    return str + node.textContent;
  }, '');
}
function getTtmlStyles(region, style, styleElements) {
  const ttsNs = 'http://www.w3.org/ns/ttml#styling';
  let regionStyle = null;
  const styleAttributes = ['displayAlign', 'textAlign', 'color', 'backgroundColor', 'fontSize', 'fontFamily'
  // 'fontWeight',
  // 'lineHeight',
  // 'wrapOption',
  // 'fontStyle',
  // 'direction',
  // 'writingMode'
  ];
  const regionStyleName = region != null && region.hasAttribute('style') ? region.getAttribute('style') : null;
  if (regionStyleName && styleElements.hasOwnProperty(regionStyleName)) {
    regionStyle = styleElements[regionStyleName];
  }
  return styleAttributes.reduce((styles, name) => {
    const value = getAttributeNS(style, ttsNs, name) || getAttributeNS(region, ttsNs, name) || getAttributeNS(regionStyle, ttsNs, name);
    if (value) {
      styles[name] = value;
    }
    return styles;
  }, {});
}
function getAttributeNS(element, ns, name) {
  if (!element) {
    return null;
  }
  return element.hasAttributeNS(ns, name) ? element.getAttributeNS(ns, name) : null;
}
function timestampParsingError(node) {
  return new Error(`Could not parse ttml timestamp ${node}`);
}
function parseTtmlTime(timeAttributeValue, rateInfo) {
  if (!timeAttributeValue) {
    return null;
  }
  let seconds = parseTimeStamp(timeAttributeValue);
  if (seconds === null) {
    if (HMSF_REGEX.test(timeAttributeValue)) {
      seconds = parseHoursMinutesSecondsFrames(timeAttributeValue, rateInfo);
    } else if (TIME_UNIT_REGEX.test(timeAttributeValue)) {
      seconds = parseTimeUnits(timeAttributeValue, rateInfo);
    }
  }
  return seconds;
}
function parseHoursMinutesSecondsFrames(timeAttributeValue, rateInfo) {
  const m = HMSF_REGEX.exec(timeAttributeValue);
  const frames = (m[4] | 0) + (m[5] | 0) / rateInfo.subFrameRate;
  return (m[1] | 0) * 3600 + (m[2] | 0) * 60 + (m[3] | 0) + frames / rateInfo.frameRate;
}
function parseTimeUnits(timeAttributeValue, rateInfo) {
  const m = TIME_UNIT_REGEX.exec(timeAttributeValue);
  const value = Number(m[1]);
  const unit = m[2];
  switch (unit) {
    case 'h':
      return value * 3600;
    case 'm':
      return value * 60;
    case 'ms':
      return value * 1000;
    case 'f':
      return value / rateInfo.frameRate;
    case 't':
      return value / rateInfo.tickRate;
  }
  return value;
}

class TimelineController {
  constructor(hls) {
    this.hls = void 0;
    this.media = null;
    this.config = void 0;
    this.enabled = true;
    this.Cues = void 0;
    this.textTracks = [];
    this.tracks = [];
    this.initPTS = [];
    this.unparsedVttFrags = [];
    this.captionsTracks = {};
    this.nonNativeCaptionsTracks = {};
    this.cea608Parser1 = void 0;
    this.cea608Parser2 = void 0;
    this.lastCc = -1;
    // Last video (CEA-608) fragment CC
    this.lastSn = -1;
    // Last video (CEA-608) fragment MSN
    this.lastPartIndex = -1;
    // Last video (CEA-608) fragment Part Index
    this.prevCC = -1;
    // Last subtitle fragment CC
    this.vttCCs = newVTTCCs();
    this.captionsProperties = void 0;
    this.hls = hls;
    this.config = hls.config;
    this.Cues = hls.config.cueHandler;
    this.captionsProperties = {
      textTrack1: {
        label: this.config.captionsTextTrack1Label,
        languageCode: this.config.captionsTextTrack1LanguageCode
      },
      textTrack2: {
        label: this.config.captionsTextTrack2Label,
        languageCode: this.config.captionsTextTrack2LanguageCode
      },
      textTrack3: {
        label: this.config.captionsTextTrack3Label,
        languageCode: this.config.captionsTextTrack3LanguageCode
      },
      textTrack4: {
        label: this.config.captionsTextTrack4Label,
        languageCode: this.config.captionsTextTrack4LanguageCode
      }
    };
    hls.on(Events.MEDIA_ATTACHING, this.onMediaAttaching, this);
    hls.on(Events.MEDIA_DETACHING, this.onMediaDetaching, this);
    hls.on(Events.MANIFEST_LOADING, this.onManifestLoading, this);
    hls.on(Events.MANIFEST_LOADED, this.onManifestLoaded, this);
    hls.on(Events.SUBTITLE_TRACKS_UPDATED, this.onSubtitleTracksUpdated, this);
    hls.on(Events.FRAG_LOADING, this.onFragLoading, this);
    hls.on(Events.FRAG_LOADED, this.onFragLoaded, this);
    hls.on(Events.FRAG_PARSING_USERDATA, this.onFragParsingUserdata, this);
    hls.on(Events.FRAG_DECRYPTED, this.onFragDecrypted, this);
    hls.on(Events.INIT_PTS_FOUND, this.onInitPtsFound, this);
    hls.on(Events.SUBTITLE_TRACKS_CLEARED, this.onSubtitleTracksCleared, this);
    hls.on(Events.BUFFER_FLUSHING, this.onBufferFlushing, this);
  }
  destroy() {
    const {
      hls
    } = this;
    hls.off(Events.MEDIA_ATTACHING, this.onMediaAttaching, this);
    hls.off(Events.MEDIA_DETACHING, this.onMediaDetaching, this);
    hls.off(Events.MANIFEST_LOADING, this.onManifestLoading, this);
    hls.off(Events.MANIFEST_LOADED, this.onManifestLoaded, this);
    hls.off(Events.SUBTITLE_TRACKS_UPDATED, this.onSubtitleTracksUpdated, this);
    hls.off(Events.FRAG_LOADING, this.onFragLoading, this);
    hls.off(Events.FRAG_LOADED, this.onFragLoaded, this);
    hls.off(Events.FRAG_PARSING_USERDATA, this.onFragParsingUserdata, this);
    hls.off(Events.FRAG_DECRYPTED, this.onFragDecrypted, this);
    hls.off(Events.INIT_PTS_FOUND, this.onInitPtsFound, this);
    hls.off(Events.SUBTITLE_TRACKS_CLEARED, this.onSubtitleTracksCleared, this);
    hls.off(Events.BUFFER_FLUSHING, this.onBufferFlushing, this);
    // @ts-ignore
    this.hls = this.config = null;
    this.cea608Parser1 = this.cea608Parser2 = undefined;
  }
  initCea608Parsers() {
    if (this.config.enableCEA708Captions && (!this.cea608Parser1 || !this.cea608Parser2)) {
      const channel1 = new OutputFilter(this, 'textTrack1');
      const channel2 = new OutputFilter(this, 'textTrack2');
      const channel3 = new OutputFilter(this, 'textTrack3');
      const channel4 = new OutputFilter(this, 'textTrack4');
      this.cea608Parser1 = new Cea608Parser(1, channel1, channel2);
      this.cea608Parser2 = new Cea608Parser(3, channel3, channel4);
    }
  }
  addCues(trackName, startTime, endTime, screen, cueRanges) {
    // skip cues which overlap more than 50% with previously parsed time ranges
    let merged = false;
    for (let i = cueRanges.length; i--;) {
      const cueRange = cueRanges[i];
      const overlap = intersection(cueRange[0], cueRange[1], startTime, endTime);
      if (overlap >= 0) {
        cueRange[0] = Math.min(cueRange[0], startTime);
        cueRange[1] = Math.max(cueRange[1], endTime);
        merged = true;
        if (overlap / (endTime - startTime) > 0.5) {
          return;
        }
      }
    }
    if (!merged) {
      cueRanges.push([startTime, endTime]);
    }
    if (this.config.renderTextTracksNatively) {
      const track = this.captionsTracks[trackName];
      this.Cues.newCue(track, startTime, endTime, screen);
    } else {
      const cues = this.Cues.newCue(null, startTime, endTime, screen);
      this.hls.trigger(Events.CUES_PARSED, {
        type: 'captions',
        cues,
        track: trackName
      });
    }
  }

  // Triggered when an initial PTS is found; used for synchronisation of WebVTT.
  onInitPtsFound(event, {
    frag,
    id,
    initPTS,
    timescale
  }) {
    const {
      unparsedVttFrags
    } = this;
    if (id === 'main') {
      this.initPTS[frag.cc] = {
        baseTime: initPTS,
        timescale
      };
    }

    // Due to asynchronous processing, initial PTS may arrive later than the first VTT fragments are loaded.
    // Parse any unparsed fragments upon receiving the initial PTS.
    if (unparsedVttFrags.length) {
      this.unparsedVttFrags = [];
      unparsedVttFrags.forEach(frag => {
        this.onFragLoaded(Events.FRAG_LOADED, frag);
      });
    }
  }
  getExistingTrack(label, language) {
    const {
      media
    } = this;
    if (media) {
      for (let i = 0; i < media.textTracks.length; i++) {
        const textTrack = media.textTracks[i];
        if (canReuseVttTextTrack(textTrack, {
          name: label,
          lang: language,
          attrs: {}
        })) {
          return textTrack;
        }
      }
    }
    return null;
  }
  createCaptionsTrack(trackName) {
    if (this.config.renderTextTracksNatively) {
      this.createNativeTrack(trackName);
    } else {
      this.createNonNativeTrack(trackName);
    }
  }
  createNativeTrack(trackName) {
    if (this.captionsTracks[trackName]) {
      return;
    }
    const {
      captionsProperties,
      captionsTracks,
      media
    } = this;
    const {
      label,
      languageCode
    } = captionsProperties[trackName];
    // Enable reuse of existing text track.
    const existingTrack = this.getExistingTrack(label, languageCode);
    if (!existingTrack) {
      const textTrack = this.createTextTrack('captions', label, languageCode);
      if (textTrack) {
        // Set a special property on the track so we know it's managed by Hls.js
        textTrack[trackName] = true;
        captionsTracks[trackName] = textTrack;
      }
    } else {
      captionsTracks[trackName] = existingTrack;
      clearCurrentCues(captionsTracks[trackName]);
      sendAddTrackEvent(captionsTracks[trackName], media);
    }
  }
  createNonNativeTrack(trackName) {
    if (this.nonNativeCaptionsTracks[trackName]) {
      return;
    }
    // Create a list of a single track for the provider to consume
    const trackProperties = this.captionsProperties[trackName];
    if (!trackProperties) {
      return;
    }
    const label = trackProperties.label;
    const track = {
      _id: trackName,
      label,
      kind: 'captions',
      default: trackProperties.media ? !!trackProperties.media.default : false,
      closedCaptions: trackProperties.media
    };
    this.nonNativeCaptionsTracks[trackName] = track;
    this.hls.trigger(Events.NON_NATIVE_TEXT_TRACKS_FOUND, {
      tracks: [track]
    });
  }
  createTextTrack(kind, label, lang) {
    const media = this.media;
    if (!media) {
      return;
    }
    return media.addTextTrack(kind, label, lang);
  }
  onMediaAttaching(event, data) {
    this.media = data.media;
    this._cleanTracks();
  }
  onMediaDetaching() {
    const {
      captionsTracks
    } = this;
    Object.keys(captionsTracks).forEach(trackName => {
      clearCurrentCues(captionsTracks[trackName]);
      delete captionsTracks[trackName];
    });
    this.nonNativeCaptionsTracks = {};
  }
  onManifestLoading() {
    // Detect discontinuity in video fragment (CEA-608) parsing
    this.lastCc = -1;
    this.lastSn = -1;
    this.lastPartIndex = -1;
    // Detect discontinuity in subtitle manifests
    this.prevCC = -1;
    this.vttCCs = newVTTCCs();
    // Reset tracks
    this._cleanTracks();
    this.tracks = [];
    this.captionsTracks = {};
    this.nonNativeCaptionsTracks = {};
    this.textTracks = [];
    this.unparsedVttFrags = [];
    this.initPTS = [];
    if (this.cea608Parser1 && this.cea608Parser2) {
      this.cea608Parser1.reset();
      this.cea608Parser2.reset();
    }
  }
  _cleanTracks() {
    // clear outdated subtitles
    const {
      media
    } = this;
    if (!media) {
      return;
    }
    const textTracks = media.textTracks;
    if (textTracks) {
      for (let i = 0; i < textTracks.length; i++) {
        clearCurrentCues(textTracks[i]);
      }
    }
  }
  onSubtitleTracksUpdated(event, data) {
    const tracks = data.subtitleTracks || [];
    const hasIMSC1 = tracks.some(track => track.textCodec === IMSC1_CODEC);
    if (this.config.enableWebVTT || hasIMSC1 && this.config.enableIMSC1) {
      const listIsIdentical = subtitleOptionsIdentical(this.tracks, tracks);
      if (listIsIdentical) {
        this.tracks = tracks;
        return;
      }
      this.textTracks = [];
      this.tracks = tracks;
      if (this.config.renderTextTracksNatively) {
        const media = this.media;
        const inUseTracks = media ? filterSubtitleTracks(media.textTracks) : null;
        this.tracks.forEach((track, index) => {
          // Reuse tracks with the same label and lang, but do not reuse 608/708 tracks
          let textTrack;
          if (inUseTracks) {
            let inUseTrack = null;
            for (let i = 0; i < inUseTracks.length; i++) {
              if (inUseTracks[i] && canReuseVttTextTrack(inUseTracks[i], track)) {
                inUseTrack = inUseTracks[i];
                inUseTracks[i] = null;
                break;
              }
            }
            if (inUseTrack) {
              textTrack = inUseTrack;
            }
          }
          if (textTrack) {
            clearCurrentCues(textTrack);
          } else {
            const textTrackKind = captionsOrSubtitlesFromCharacteristics(track);
            textTrack = this.createTextTrack(textTrackKind, track.name, track.lang);
            if (textTrack) {
              textTrack.mode = 'disabled';
            }
          }
          if (textTrack) {
            this.textTracks.push(textTrack);
          }
        });
        // Warn when video element has captions or subtitle TextTracks carried over from another source
        if (inUseTracks != null && inUseTracks.length) {
          const unusedTextTracks = inUseTracks.filter(t => t !== null).map(t => t.label);
          if (unusedTextTracks.length) {
            logger.warn(`Media element contains unused subtitle tracks: ${unusedTextTracks.join(', ')}. Replace media element for each source to clear TextTracks and captions menu.`);
          }
        }
      } else if (this.tracks.length) {
        // Create a list of tracks for the provider to consume
        const tracksList = this.tracks.map(track => {
          return {
            label: track.name,
            kind: track.type.toLowerCase(),
            default: track.default,
            subtitleTrack: track
          };
        });
        this.hls.trigger(Events.NON_NATIVE_TEXT_TRACKS_FOUND, {
          tracks: tracksList
        });
      }
    }
  }
  onManifestLoaded(event, data) {
    if (this.config.enableCEA708Captions && data.captions) {
      data.captions.forEach(captionsTrack => {
        const instreamIdMatch = /(?:CC|SERVICE)([1-4])/.exec(captionsTrack.instreamId);
        if (!instreamIdMatch) {
          return;
        }
        const trackName = `textTrack${instreamIdMatch[1]}`;
        const trackProperties = this.captionsProperties[trackName];
        if (!trackProperties) {
          return;
        }
        trackProperties.label = captionsTrack.name;
        if (captionsTrack.lang) {
          // optional attribute
          trackProperties.languageCode = captionsTrack.lang;
        }
        trackProperties.media = captionsTrack;
      });
    }
  }
  closedCaptionsForLevel(frag) {
    const level = this.hls.levels[frag.level];
    return level == null ? void 0 : level.attrs['CLOSED-CAPTIONS'];
  }
  onFragLoading(event, data) {
    // if this frag isn't contiguous, clear the parser so cues with bad start/end times aren't added to the textTrack
    if (this.enabled && data.frag.type === PlaylistLevelType.MAIN) {
      var _data$part$index, _data$part;
      const {
        cea608Parser1,
        cea608Parser2,
        lastSn
      } = this;
      const {
        cc,
        sn
      } = data.frag;
      const partIndex = (_data$part$index = (_data$part = data.part) == null ? void 0 : _data$part.index) != null ? _data$part$index : -1;
      if (cea608Parser1 && cea608Parser2) {
        if (sn !== lastSn + 1 || sn === lastSn && partIndex !== this.lastPartIndex + 1 || cc !== this.lastCc) {
          cea608Parser1.reset();
          cea608Parser2.reset();
        }
      }
      this.lastCc = cc;
      this.lastSn = sn;
      this.lastPartIndex = partIndex;
    }
  }
  onFragLoaded(event, data) {
    const {
      frag,
      payload
    } = data;
    if (frag.type === PlaylistLevelType.SUBTITLE) {
      // If fragment is subtitle type, parse as WebVTT.
      if (payload.byteLength) {
        const decryptData = frag.decryptdata;
        // fragment after decryption has a stats object
        const decrypted = ('stats' in data);
        // If the subtitles are not encrypted, parse VTTs now. Otherwise, we need to wait.
        if (decryptData == null || !decryptData.encrypted || decrypted) {
          const trackPlaylistMedia = this.tracks[frag.level];
          const vttCCs = this.vttCCs;
          if (!vttCCs[frag.cc]) {
            vttCCs[frag.cc] = {
              start: frag.start,
              prevCC: this.prevCC,
              new: true
            };
            this.prevCC = frag.cc;
          }
          if (trackPlaylistMedia && trackPlaylistMedia.textCodec === IMSC1_CODEC) {
            this._parseIMSC1(frag, payload);
          } else {
            this._parseVTTs(data);
          }
        }
      } else {
        // In case there is no payload, finish unsuccessfully.
        this.hls.trigger(Events.SUBTITLE_FRAG_PROCESSED, {
          success: false,
          frag,
          error: new Error('Empty subtitle payload')
        });
      }
    }
  }
  _parseIMSC1(frag, payload) {
    const hls = this.hls;
    parseIMSC1(payload, this.initPTS[frag.cc], cues => {
      this._appendCues(cues, frag.level);
      hls.trigger(Events.SUBTITLE_FRAG_PROCESSED, {
        success: true,
        frag: frag
      });
    }, error => {
      logger.log(`Failed to parse IMSC1: ${error}`);
      hls.trigger(Events.SUBTITLE_FRAG_PROCESSED, {
        success: false,
        frag: frag,
        error
      });
    });
  }
  _parseVTTs(data) {
    var _frag$initSegment;
    const {
      frag,
      payload
    } = data;
    // We need an initial synchronisation PTS. Store fragments as long as none has arrived
    const {
      initPTS,
      unparsedVttFrags
    } = this;
    const maxAvCC = initPTS.length - 1;
    if (!initPTS[frag.cc] && maxAvCC === -1) {
      unparsedVttFrags.push(data);
      return;
    }
    const hls = this.hls;
    // Parse the WebVTT file contents.
    const payloadWebVTT = (_frag$initSegment = frag.initSegment) != null && _frag$initSegment.data ? appendUint8Array(frag.initSegment.data, new Uint8Array(payload)) : payload;
    parseWebVTT(payloadWebVTT, this.initPTS[frag.cc], this.vttCCs, frag.cc, frag.start, cues => {
      this._appendCues(cues, frag.level);
      hls.trigger(Events.SUBTITLE_FRAG_PROCESSED, {
        success: true,
        frag: frag
      });
    }, error => {
      const missingInitPTS = error.message === 'Missing initPTS for VTT MPEGTS';
      if (missingInitPTS) {
        unparsedVttFrags.push(data);
      } else {
        this._fallbackToIMSC1(frag, payload);
      }
      // Something went wrong while parsing. Trigger event with success false.
      logger.log(`Failed to parse VTT cue: ${error}`);
      if (missingInitPTS && maxAvCC > frag.cc) {
        return;
      }
      hls.trigger(Events.SUBTITLE_FRAG_PROCESSED, {
        success: false,
        frag: frag,
        error
      });
    });
  }
  _fallbackToIMSC1(frag, payload) {
    // If textCodec is unknown, try parsing as IMSC1. Set textCodec based on the result
    const trackPlaylistMedia = this.tracks[frag.level];
    if (!trackPlaylistMedia.textCodec) {
      parseIMSC1(payload, this.initPTS[frag.cc], () => {
        trackPlaylistMedia.textCodec = IMSC1_CODEC;
        this._parseIMSC1(frag, payload);
      }, () => {
        trackPlaylistMedia.textCodec = 'wvtt';
      });
    }
  }
  _appendCues(cues, fragLevel) {
    const hls = this.hls;
    if (this.config.renderTextTracksNatively) {
      const textTrack = this.textTracks[fragLevel];
      // WebVTTParser.parse is an async method and if the currently selected text track mode is set to "disabled"
      // before parsing is done then don't try to access currentTrack.cues.getCueById as cues will be null
      // and trying to access getCueById method of cues will throw an exception
      // Because we check if the mode is disabled, we can force check `cues` below. They can't be null.
      if (!textTrack || textTrack.mode === 'disabled') {
        return;
      }
      cues.forEach(cue => addCueToTrack(textTrack, cue));
    } else {
      const currentTrack = this.tracks[fragLevel];
      if (!currentTrack) {
        return;
      }
      const track = currentTrack.default ? 'default' : 'subtitles' + fragLevel;
      hls.trigger(Events.CUES_PARSED, {
        type: 'subtitles',
        cues,
        track
      });
    }
  }
  onFragDecrypted(event, data) {
    const {
      frag
    } = data;
    if (frag.type === PlaylistLevelType.SUBTITLE) {
      this.onFragLoaded(Events.FRAG_LOADED, data);
    }
  }
  onSubtitleTracksCleared() {
    this.tracks = [];
    this.captionsTracks = {};
  }
  onFragParsingUserdata(event, data) {
    this.initCea608Parsers();
    const {
      cea608Parser1,
      cea608Parser2
    } = this;
    if (!this.enabled || !cea608Parser1 || !cea608Parser2) {
      return;
    }
    const {
      frag,
      samples
    } = data;
    if (frag.type === PlaylistLevelType.MAIN && this.closedCaptionsForLevel(frag) === 'NONE') {
      return;
    }
    // If the event contains captions (found in the bytes property), push all bytes into the parser immediately
    // It will create the proper timestamps based on the PTS value
    for (let i = 0; i < samples.length; i++) {
      const ccBytes = samples[i].bytes;
      if (ccBytes) {
        const ccdatas = this.extractCea608Data(ccBytes);
        cea608Parser1.addData(samples[i].pts, ccdatas[0]);
        cea608Parser2.addData(samples[i].pts, ccdatas[1]);
      }
    }
  }
  onBufferFlushing(event, {
    startOffset,
    endOffset,
    endOffsetSubtitles,
    type
  }) {
    const {
      media
    } = this;
    if (!media || media.currentTime < endOffset) {
      return;
    }
    // Clear 608 caption cues from the captions TextTracks when the video back buffer is flushed
    // Forward cues are never removed because we can loose streamed 608 content from recent fragments
    if (!type || type === 'video') {
      const {
        captionsTracks
      } = this;
      Object.keys(captionsTracks).forEach(trackName => removeCuesInRange(captionsTracks[trackName], startOffset, endOffset));
    }
    if (this.config.renderTextTracksNatively) {
      // Clear VTT/IMSC1 subtitle cues from the subtitle TextTracks when the back buffer is flushed
      if (startOffset === 0 && endOffsetSubtitles !== undefined) {
        const {
          textTracks
        } = this;
        Object.keys(textTracks).forEach(trackName => removeCuesInRange(textTracks[trackName], startOffset, endOffsetSubtitles));
      }
    }
  }
  extractCea608Data(byteArray) {
    const actualCCBytes = [[], []];
    const count = byteArray[0] & 0x1f;
    let position = 2;
    for (let j = 0; j < count; j++) {
      const tmpByte = byteArray[position++];
      const ccbyte1 = 0x7f & byteArray[position++];
      const ccbyte2 = 0x7f & byteArray[position++];
      if (ccbyte1 === 0 && ccbyte2 === 0) {
        continue;
      }
      const ccValid = (0x04 & tmpByte) !== 0; // Support all four channels
      if (ccValid) {
        const ccType = 0x03 & tmpByte;
        if (0x00 /* CEA608 field1*/ === ccType || 0x01 /* CEA608 field2*/ === ccType) {
          // Exclude CEA708 CC data.
          actualCCBytes[ccType].push(ccbyte1);
          actualCCBytes[ccType].push(ccbyte2);
        }
      }
    }
    return actualCCBytes;
  }
}
function captionsOrSubtitlesFromCharacteristics(track) {
  if (track.characteristics) {
    if (/transcribes-spoken-dialog/gi.test(track.characteristics) && /describes-music-and-sound/gi.test(track.characteristics)) {
      return 'captions';
    }
  }
  return 'subtitles';
}
function canReuseVttTextTrack(inUseTrack, manifestTrack) {
  return !!inUseTrack && inUseTrack.kind === captionsOrSubtitlesFromCharacteristics(manifestTrack) && subtitleTrackMatchesTextTrack(manifestTrack, inUseTrack);
}
function intersection(x1, x2, y1, y2) {
  return Math.min(x2, y2) - Math.max(x1, y1);
}
function newVTTCCs() {
  return {
    ccOffset: 0,
    presentationOffset: 0,
    0: {
      start: 0,
      prevCC: -1,
      new: true
    }
  };
}

class CapLevelController {
  constructor(hls) {
    this.hls = void 0;
    this.autoLevelCapping = void 0;
    this.firstLevel = void 0;
    this.media = void 0;
    this.restrictedLevels = void 0;
    this.timer = void 0;
    this.clientRect = void 0;
    this.streamController = void 0;
    this.hls = hls;
    this.autoLevelCapping = Number.POSITIVE_INFINITY;
    this.firstLevel = -1;
    this.media = null;
    this.restrictedLevels = [];
    this.timer = undefined;
    this.clientRect = null;
    this.registerListeners();
  }
  setStreamController(streamController) {
    this.streamController = streamController;
  }
  destroy() {
    if (this.hls) {
      this.unregisterListener();
    }
    if (this.timer) {
      this.stopCapping();
    }
    this.media = null;
    this.clientRect = null;
    // @ts-ignore
    this.hls = this.streamController = null;
  }
  registerListeners() {
    const {
      hls
    } = this;
    hls.on(Events.FPS_DROP_LEVEL_CAPPING, this.onFpsDropLevelCapping, this);
    hls.on(Events.MEDIA_ATTACHING, this.onMediaAttaching, this);
    hls.on(Events.MANIFEST_PARSED, this.onManifestParsed, this);
    hls.on(Events.LEVELS_UPDATED, this.onLevelsUpdated, this);
    hls.on(Events.BUFFER_CODECS, this.onBufferCodecs, this);
    hls.on(Events.MEDIA_DETACHING, this.onMediaDetaching, this);
  }
  unregisterListener() {
    const {
      hls
    } = this;
    hls.off(Events.FPS_DROP_LEVEL_CAPPING, this.onFpsDropLevelCapping, this);
    hls.off(Events.MEDIA_ATTACHING, this.onMediaAttaching, this);
    hls.off(Events.MANIFEST_PARSED, this.onManifestParsed, this);
    hls.off(Events.LEVELS_UPDATED, this.onLevelsUpdated, this);
    hls.off(Events.BUFFER_CODECS, this.onBufferCodecs, this);
    hls.off(Events.MEDIA_DETACHING, this.onMediaDetaching, this);
  }
  onFpsDropLevelCapping(event, data) {
    // Don't add a restricted level more than once
    const level = this.hls.levels[data.droppedLevel];
    if (this.isLevelAllowed(level)) {
      this.restrictedLevels.push({
        bitrate: level.bitrate,
        height: level.height,
        width: level.width
      });
    }
  }
  onMediaAttaching(event, data) {
    this.media = data.media instanceof HTMLVideoElement ? data.media : null;
    this.clientRect = null;
    if (this.timer && this.hls.levels.length) {
      this.detectPlayerSize();
    }
  }
  onManifestParsed(event, data) {
    const hls = this.hls;
    this.restrictedLevels = [];
    this.firstLevel = data.firstLevel;
    if (hls.config.capLevelToPlayerSize && data.video) {
      // Start capping immediately if the manifest has signaled video codecs
      this.startCapping();
    }
  }
  onLevelsUpdated(event, data) {
    if (this.timer && isFiniteNumber(this.autoLevelCapping)) {
      this.detectPlayerSize();
    }
  }

  // Only activate capping when playing a video stream; otherwise, multi-bitrate audio-only streams will be restricted
  // to the first level
  onBufferCodecs(event, data) {
    const hls = this.hls;
    if (hls.config.capLevelToPlayerSize && data.video) {
      // If the manifest did not signal a video codec capping has been deferred until we're certain video is present
      this.startCapping();
    }
  }
  onMediaDetaching() {
    this.stopCapping();
  }
  detectPlayerSize() {
    if (this.media) {
      if (this.mediaHeight <= 0 || this.mediaWidth <= 0) {
        this.clientRect = null;
        return;
      }
      const levels = this.hls.levels;
      if (levels.length) {
        const hls = this.hls;
        const maxLevel = this.getMaxLevel(levels.length - 1);
        if (maxLevel !== this.autoLevelCapping) {
          logger.log(`Setting autoLevelCapping to ${maxLevel}: ${levels[maxLevel].height}p@${levels[maxLevel].bitrate} for media ${this.mediaWidth}x${this.mediaHeight}`);
        }
        hls.autoLevelCapping = maxLevel;
        if (hls.autoLevelCapping > this.autoLevelCapping && this.streamController) {
          // if auto level capping has a higher value for the previous one, flush the buffer using nextLevelSwitch
          // usually happen when the user go to the fullscreen mode.
          this.streamController.nextLevelSwitch();
        }
        this.autoLevelCapping = hls.autoLevelCapping;
      }
    }
  }

  /*
   * returns level should be the one with the dimensions equal or greater than the media (player) dimensions (so the video will be downscaled)
   */
  getMaxLevel(capLevelIndex) {
    const levels = this.hls.levels;
    if (!levels.length) {
      return -1;
    }
    const validLevels = levels.filter((level, index) => this.isLevelAllowed(level) && index <= capLevelIndex);
    this.clientRect = null;
    return CapLevelController.getMaxLevelByMediaSize(validLevels, this.mediaWidth, this.mediaHeight);
  }
  startCapping() {
    if (this.timer) {
      // Don't reset capping if started twice; this can happen if the manifest signals a video codec
      return;
    }
    this.autoLevelCapping = Number.POSITIVE_INFINITY;
    self.clearInterval(this.timer);
    this.timer = self.setInterval(this.detectPlayerSize.bind(this), 1000);
    this.detectPlayerSize();
  }
  stopCapping() {
    this.restrictedLevels = [];
    this.firstLevel = -1;
    this.autoLevelCapping = Number.POSITIVE_INFINITY;
    if (this.timer) {
      self.clearInterval(this.timer);
      this.timer = undefined;
    }
  }
  getDimensions() {
    if (this.clientRect) {
      return this.clientRect;
    }
    const media = this.media;
    const boundsRect = {
      width: 0,
      height: 0
    };
    if (media) {
      const clientRect = media.getBoundingClientRect();
      boundsRect.width = clientRect.width;
      boundsRect.height = clientRect.height;
      if (!boundsRect.width && !boundsRect.height) {
        // When the media element has no width or height (equivalent to not being in the DOM),
        // then use its width and height attributes (media.width, media.height)
        boundsRect.width = clientRect.right - clientRect.left || media.width || 0;
        boundsRect.height = clientRect.bottom - clientRect.top || media.height || 0;
      }
    }
    this.clientRect = boundsRect;
    return boundsRect;
  }
  get mediaWidth() {
    return this.getDimensions().width * this.contentScaleFactor;
  }
  get mediaHeight() {
    return this.getDimensions().height * this.contentScaleFactor;
  }
  get contentScaleFactor() {
    let pixelRatio = 1;
    if (!this.hls.config.ignoreDevicePixelRatio) {
      try {
        pixelRatio = self.devicePixelRatio;
      } catch (e) {
        /* no-op */
      }
    }
    return pixelRatio;
  }
  isLevelAllowed(level) {
    const restrictedLevels = this.restrictedLevels;
    return !restrictedLevels.some(restrictedLevel => {
      return level.bitrate === restrictedLevel.bitrate && level.width === restrictedLevel.width && level.height === restrictedLevel.height;
    });
  }
  static getMaxLevelByMediaSize(levels, width, height) {
    if (!(levels != null && levels.length)) {
      return -1;
    }

    // Levels can have the same dimensions but differing bandwidths - since levels are ordered, we can look to the next
    // to determine whether we've chosen the greatest bandwidth for the media's dimensions
    const atGreatestBandwidth = (curLevel, nextLevel) => {
      if (!nextLevel) {
        return true;
      }
      return curLevel.width !== nextLevel.width || curLevel.height !== nextLevel.height;
    };

    // If we run through the loop without breaking, the media's dimensions are greater than every level, so default to
    // the max level
    let maxLevelIndex = levels.length - 1;
    // Prevent changes in aspect-ratio from causing capping to toggle back and forth
    const squareSize = Math.max(width, height);
    for (let i = 0; i < levels.length; i += 1) {
      const level = levels[i];
      if ((level.width >= squareSize || level.height >= squareSize) && atGreatestBandwidth(level, levels[i + 1])) {
        maxLevelIndex = i;
        break;
      }
    }
    return maxLevelIndex;
  }
}

class FPSController {
  constructor(hls) {
    this.hls = void 0;
    this.isVideoPlaybackQualityAvailable = false;
    this.timer = void 0;
    this.media = null;
    this.lastTime = void 0;
    this.lastDroppedFrames = 0;
    this.lastDecodedFrames = 0;
    // stream controller must be provided as a dependency!
    this.streamController = void 0;
    this.hls = hls;
    this.registerListeners();
  }
  setStreamController(streamController) {
    this.streamController = streamController;
  }
  registerListeners() {
    this.hls.on(Events.MEDIA_ATTACHING, this.onMediaAttaching, this);
  }
  unregisterListeners() {
    this.hls.off(Events.MEDIA_ATTACHING, this.onMediaAttaching, this);
  }
  destroy() {
    if (this.timer) {
      clearInterval(this.timer);
    }
    this.unregisterListeners();
    this.isVideoPlaybackQualityAvailable = false;
    this.media = null;
  }
  onMediaAttaching(event, data) {
    const config = this.hls.config;
    if (config.capLevelOnFPSDrop) {
      const media = data.media instanceof self.HTMLVideoElement ? data.media : null;
      this.media = media;
      if (media && typeof media.getVideoPlaybackQuality === 'function') {
        this.isVideoPlaybackQualityAvailable = true;
      }
      self.clearInterval(this.timer);
      this.timer = self.setInterval(this.checkFPSInterval.bind(this), config.fpsDroppedMonitoringPeriod);
    }
  }
  checkFPS(video, decodedFrames, droppedFrames) {
    const currentTime = performance.now();
    if (decodedFrames) {
      if (this.lastTime) {
        const currentPeriod = currentTime - this.lastTime;
        const currentDropped = droppedFrames - this.lastDroppedFrames;
        const currentDecoded = decodedFrames - this.lastDecodedFrames;
        const droppedFPS = 1000 * currentDropped / currentPeriod;
        const hls = this.hls;
        hls.trigger(Events.FPS_DROP, {
          currentDropped: currentDropped,
          currentDecoded: currentDecoded,
          totalDroppedFrames: droppedFrames
        });
        if (droppedFPS > 0) {
          // logger.log('checkFPS : droppedFPS/decodedFPS:' + droppedFPS/(1000 * currentDecoded / currentPeriod));
          if (currentDropped > hls.config.fpsDroppedMonitoringThreshold * currentDecoded) {
            let currentLevel = hls.currentLevel;
            logger.warn('drop FPS ratio greater than max allowed value for currentLevel: ' + currentLevel);
            if (currentLevel > 0 && (hls.autoLevelCapping === -1 || hls.autoLevelCapping >= currentLevel)) {
              currentLevel = currentLevel - 1;
              hls.trigger(Events.FPS_DROP_LEVEL_CAPPING, {
                level: currentLevel,
                droppedLevel: hls.currentLevel
              });
              hls.autoLevelCapping = currentLevel;
              this.streamController.nextLevelSwitch();
            }
          }
        }
      }
      this.lastTime = currentTime;
      this.lastDroppedFrames = droppedFrames;
      this.lastDecodedFrames = decodedFrames;
    }
  }
  checkFPSInterval() {
    const video = this.media;
    if (video) {
      if (this.isVideoPlaybackQualityAvailable) {
        const videoPlaybackQuality = video.getVideoPlaybackQuality();
        this.checkFPS(video, videoPlaybackQuality.totalVideoFrames, videoPlaybackQuality.droppedVideoFrames);
      } else {
        // HTMLVideoElement doesn't include the webkit types
        this.checkFPS(video, video.webkitDecodedFrameCount, video.webkitDroppedFrameCount);
      }
    }
  }
}

const LOGGER_PREFIX = '[eme]';
/**
 * Controller to deal with encrypted media extensions (EME)
 * @see https://developer.mozilla.org/en-US/docs/Web/API/Encrypted_Media_Extensions_API
 *
 * @class
 * @constructor
 */
class EMEController {
  constructor(hls) {
    this.hls = void 0;
    this.config = void 0;
    this.media = null;
    this.keyFormatPromise = null;
    this.keySystemAccessPromises = {};
    this._requestLicenseFailureCount = 0;
    this.mediaKeySessions = [];
    this.keyIdToKeySessionPromise = {};
    this.setMediaKeysQueue = EMEController.CDMCleanupPromise ? [EMEController.CDMCleanupPromise] : [];
    this.onMediaEncrypted = this._onMediaEncrypted.bind(this);
    this.onWaitingForKey = this._onWaitingForKey.bind(this);
    this.debug = logger.debug.bind(logger, LOGGER_PREFIX);
    this.log = logger.log.bind(logger, LOGGER_PREFIX);
    this.warn = logger.warn.bind(logger, LOGGER_PREFIX);
    this.error = logger.error.bind(logger, LOGGER_PREFIX);
    this.hls = hls;
    this.config = hls.config;
    this.registerListeners();
  }
  destroy() {
    this.unregisterListeners();
    this.onMediaDetached();
    // Remove any references that could be held in config options or callbacks
    const config = this.config;
    config.requestMediaKeySystemAccessFunc = null;
    config.licenseXhrSetup = config.licenseResponseCallback = undefined;
    config.drmSystems = config.drmSystemOptions = {};
    // @ts-ignore
    this.hls = this.onMediaEncrypted = this.onWaitingForKey = this.keyIdToKeySessionPromise = null;
    // @ts-ignore
    this.config = null;
  }
  registerListeners() {
    this.hls.on(Events.MEDIA_ATTACHED, this.onMediaAttached, this);
    this.hls.on(Events.MEDIA_DETACHED, this.onMediaDetached, this);
    this.hls.on(Events.MANIFEST_LOADING, this.onManifestLoading, this);
    this.hls.on(Events.MANIFEST_LOADED, this.onManifestLoaded, this);
  }
  unregisterListeners() {
    this.hls.off(Events.MEDIA_ATTACHED, this.onMediaAttached, this);
    this.hls.off(Events.MEDIA_DETACHED, this.onMediaDetached, this);
    this.hls.off(Events.MANIFEST_LOADING, this.onManifestLoading, this);
    this.hls.off(Events.MANIFEST_LOADED, this.onManifestLoaded, this);
  }
  getLicenseServerUrl(keySystem) {
    const {
      drmSystems,
      widevineLicenseUrl
    } = this.config;
    const keySystemConfiguration = drmSystems[keySystem];
    if (keySystemConfiguration) {
      return keySystemConfiguration.licenseUrl;
    }

    // For backward compatibility
    if (keySystem === KeySystems.WIDEVINE && widevineLicenseUrl) {
      return widevineLicenseUrl;
    }
    throw new Error(`no license server URL configured for key-system "${keySystem}"`);
  }
  getServerCertificateUrl(keySystem) {
    const {
      drmSystems
    } = this.config;
    const keySystemConfiguration = drmSystems[keySystem];
    if (keySystemConfiguration) {
      return keySystemConfiguration.serverCertificateUrl;
    } else {
      this.log(`No Server Certificate in config.drmSystems["${keySystem}"]`);
    }
  }
  attemptKeySystemAccess(keySystemsToAttempt) {
    const levels = this.hls.levels;
    const uniqueCodec = (value, i, a) => !!value && a.indexOf(value) === i;
    const audioCodecs = levels.map(level => level.audioCodec).filter(uniqueCodec);
    const videoCodecs = levels.map(level => level.videoCodec).filter(uniqueCodec);
    if (audioCodecs.length + videoCodecs.length === 0) {
      videoCodecs.push('avc1.42e01e');
    }
    return new Promise((resolve, reject) => {
      const attempt = keySystems => {
        const keySystem = keySystems.shift();
        this.getMediaKeysPromise(keySystem, audioCodecs, videoCodecs).then(mediaKeys => resolve({
          keySystem,
          mediaKeys
        })).catch(error => {
          if (keySystems.length) {
            attempt(keySystems);
          } else if (error instanceof EMEKeyError) {
            reject(error);
          } else {
            reject(new EMEKeyError({
              type: ErrorTypes.KEY_SYSTEM_ERROR,
              details: ErrorDetails.KEY_SYSTEM_NO_ACCESS,
              error,
              fatal: true
            }, error.message));
          }
        });
      };
      attempt(keySystemsToAttempt);
    });
  }
  requestMediaKeySystemAccess(keySystem, supportedConfigurations) {
    const {
      requestMediaKeySystemAccessFunc
    } = this.config;
    if (!(typeof requestMediaKeySystemAccessFunc === 'function')) {
      let errMessage = `Configured requestMediaKeySystemAccess is not a function ${requestMediaKeySystemAccessFunc}`;
      if (requestMediaKeySystemAccess === null && self.location.protocol === 'http:') {
        errMessage = `navigator.requestMediaKeySystemAccess is not available over insecure protocol ${location.protocol}`;
      }
      return Promise.reject(new Error(errMessage));
    }
    return requestMediaKeySystemAccessFunc(keySystem, supportedConfigurations);
  }
  getMediaKeysPromise(keySystem, audioCodecs, videoCodecs) {
    // This can throw, but is caught in event handler callpath
    const mediaKeySystemConfigs = getSupportedMediaKeySystemConfigurations(keySystem, audioCodecs, videoCodecs, this.config.drmSystemOptions);
    const keySystemAccessPromises = this.keySystemAccessPromises[keySystem];
    let keySystemAccess = keySystemAccessPromises == null ? void 0 : keySystemAccessPromises.keySystemAccess;
    if (!keySystemAccess) {
      this.log(`Requesting encrypted media "${keySystem}" key-system access with config: ${JSON.stringify(mediaKeySystemConfigs)}`);
      keySystemAccess = this.requestMediaKeySystemAccess(keySystem, mediaKeySystemConfigs);
      const _keySystemAccessPromises = this.keySystemAccessPromises[keySystem] = {
        keySystemAccess
      };
      keySystemAccess.catch(error => {
        this.log(`Failed to obtain access to key-system "${keySystem}": ${error}`);
      });
      return keySystemAccess.then(mediaKeySystemAccess => {
        this.log(`Access for key-system "${mediaKeySystemAccess.keySystem}" obtained`);
        const certificateRequest = this.fetchServerCertificate(keySystem);
        this.log(`Create media-keys for "${keySystem}"`);
        _keySystemAccessPromises.mediaKeys = mediaKeySystemAccess.createMediaKeys().then(mediaKeys => {
          this.log(`Media-keys created for "${keySystem}"`);
          return certificateRequest.then(certificate => {
            if (certificate) {
              return this.setMediaKeysServerCertificate(mediaKeys, keySystem, certificate);
            }
            return mediaKeys;
          });
        });
        _keySystemAccessPromises.mediaKeys.catch(error => {
          this.error(`Failed to create media-keys for "${keySystem}"}: ${error}`);
        });
        return _keySystemAccessPromises.mediaKeys;
      });
    }
    return keySystemAccess.then(() => keySystemAccessPromises.mediaKeys);
  }
  createMediaKeySessionContext({
    decryptdata,
    keySystem,
    mediaKeys
  }) {
    this.log(`Creating key-system session "${keySystem}" keyId: ${Hex.hexDump(decryptdata.keyId || [])}`);
    const mediaKeysSession = mediaKeys.createSession();
    const mediaKeySessionContext = {
      decryptdata,
      keySystem,
      mediaKeys,
      mediaKeysSession,
      keyStatus: 'status-pending'
    };
    this.mediaKeySessions.push(mediaKeySessionContext);
    return mediaKeySessionContext;
  }
  renewKeySession(mediaKeySessionContext) {
    const decryptdata = mediaKeySessionContext.decryptdata;
    if (decryptdata.pssh) {
      const keySessionContext = this.createMediaKeySessionContext(mediaKeySessionContext);
      const keyId = this.getKeyIdString(decryptdata);
      const scheme = 'cenc';
      this.keyIdToKeySessionPromise[keyId] = this.generateRequestWithPreferredKeySession(keySessionContext, scheme, decryptdata.pssh, 'expired');
    } else {
      this.warn(`Could not renew expired session. Missing pssh initData.`);
    }
    this.removeSession(mediaKeySessionContext);
  }
  getKeyIdString(decryptdata) {
    if (!decryptdata) {
      throw new Error('Could not read keyId of undefined decryptdata');
    }
    if (decryptdata.keyId === null) {
      throw new Error('keyId is null');
    }
    return Hex.hexDump(decryptdata.keyId);
  }
  updateKeySession(mediaKeySessionContext, data) {
    var _mediaKeySessionConte;
    const keySession = mediaKeySessionContext.mediaKeysSession;
    this.log(`Updating key-session "${keySession.sessionId}" for keyID ${Hex.hexDump(((_mediaKeySessionConte = mediaKeySessionContext.decryptdata) == null ? void 0 : _mediaKeySessionConte.keyId) || [])}
      } (data length: ${data ? data.byteLength : data})`);
    return keySession.update(data);
  }
  selectKeySystemFormat(frag) {
    const keyFormats = Object.keys(frag.levelkeys || {});
    if (!this.keyFormatPromise) {
      this.log(`Selecting key-system from fragment (sn: ${frag.sn} ${frag.type}: ${frag.level}) key formats ${keyFormats.join(', ')}`);
      this.keyFormatPromise = this.getKeyFormatPromise(keyFormats);
    }
    return this.keyFormatPromise;
  }
  getKeyFormatPromise(keyFormats) {
    return new Promise((resolve, reject) => {
      const keySystemsInConfig = getKeySystemsForConfig(this.config);
      const keySystemsToAttempt = keyFormats.map(keySystemFormatToKeySystemDomain).filter(value => !!value && keySystemsInConfig.indexOf(value) !== -1);
      return this.getKeySystemSelectionPromise(keySystemsToAttempt).then(({
        keySystem
      }) => {
        const keySystemFormat = keySystemDomainToKeySystemFormat(keySystem);
        if (keySystemFormat) {
          resolve(keySystemFormat);
        } else {
          reject(new Error(`Unable to find format for key-system "${keySystem}"`));
        }
      }).catch(reject);
    });
  }
  loadKey(data) {
    const decryptdata = data.keyInfo.decryptdata;
    const keyId = this.getKeyIdString(decryptdata);
    const keyDetails = `(keyId: ${keyId} format: "${decryptdata.keyFormat}" method: ${decryptdata.method} uri: ${decryptdata.uri})`;
    this.log(`Starting session for key ${keyDetails}`);
    let keySessionContextPromise = this.keyIdToKeySessionPromise[keyId];
    if (!keySessionContextPromise) {
      keySessionContextPromise = this.keyIdToKeySessionPromise[keyId] = this.getKeySystemForKeyPromise(decryptdata).then(({
        keySystem,
        mediaKeys
      }) => {
        this.throwIfDestroyed();
        this.log(`Handle encrypted media sn: ${data.frag.sn} ${data.frag.type}: ${data.frag.level} using key ${keyDetails}`);
        return this.attemptSetMediaKeys(keySystem, mediaKeys).then(() => {
          this.throwIfDestroyed();
          const keySessionContext = this.createMediaKeySessionContext({
            keySystem,
            mediaKeys,
            decryptdata
          });
          const scheme = 'cenc';
          return this.generateRequestWithPreferredKeySession(keySessionContext, scheme, decryptdata.pssh, 'playlist-key');
        });
      });
      keySessionContextPromise.catch(error => this.handleError(error));
    }
    return keySessionContextPromise;
  }
  throwIfDestroyed(message = 'Invalid state') {
    if (!this.hls) {
      throw new Error('invalid state');
    }
  }
  handleError(error) {
    if (!this.hls) {
      return;
    }
    this.error(error.message);
    if (error instanceof EMEKeyError) {
      this.hls.trigger(Events.ERROR, error.data);
    } else {
      this.hls.trigger(Events.ERROR, {
        type: ErrorTypes.KEY_SYSTEM_ERROR,
        details: ErrorDetails.KEY_SYSTEM_NO_KEYS,
        error,
        fatal: true
      });
    }
  }
  getKeySystemForKeyPromise(decryptdata) {
    const keyId = this.getKeyIdString(decryptdata);
    const mediaKeySessionContext = this.keyIdToKeySessionPromise[keyId];
    if (!mediaKeySessionContext) {
      const keySystem = keySystemFormatToKeySystemDomain(decryptdata.keyFormat);
      const keySystemsToAttempt = keySystem ? [keySystem] : getKeySystemsForConfig(this.config);
      return this.attemptKeySystemAccess(keySystemsToAttempt);
    }
    return mediaKeySessionContext;
  }
  getKeySystemSelectionPromise(keySystemsToAttempt) {
    if (!keySystemsToAttempt.length) {
      keySystemsToAttempt = getKeySystemsForConfig(this.config);
    }
    if (keySystemsToAttempt.length === 0) {
      throw new EMEKeyError({
        type: ErrorTypes.KEY_SYSTEM_ERROR,
        details: ErrorDetails.KEY_SYSTEM_NO_CONFIGURED_LICENSE,
        fatal: true
      }, `Missing key-system license configuration options ${JSON.stringify({
        drmSystems: this.config.drmSystems
      })}`);
    }
    return this.attemptKeySystemAccess(keySystemsToAttempt);
  }
  _onMediaEncrypted(event) {
    const {
      initDataType,
      initData
    } = event;
    this.debug(`"${event.type}" event: init data type: "${initDataType}"`);

    // Ignore event when initData is null
    if (initData === null) {
      return;
    }
    let keyId;
    let keySystemDomain;
    if (initDataType === 'sinf' && this.config.drmSystems[KeySystems.FAIRPLAY]) {
      // Match sinf keyId to playlist skd://keyId=
      const json = bin2str(new Uint8Array(initData));
      try {
        const sinf = base64Decode(JSON.parse(json).sinf);
        const tenc = parseSinf(new Uint8Array(sinf));
        if (!tenc) {
          return;
        }
        keyId = tenc.subarray(8, 24);
        keySystemDomain = KeySystems.FAIRPLAY;
      } catch (error) {
        this.warn('Failed to parse sinf "encrypted" event message initData');
        return;
      }
    } else {
      // Support clear-lead key-session creation (otherwise depend on playlist keys)
      const psshInfo = parsePssh(initData);
      if (psshInfo === null) {
        return;
      }
      if (psshInfo.version === 0 && psshInfo.systemId === KeySystemIds.WIDEVINE && psshInfo.data) {
        keyId = psshInfo.data.subarray(8, 24);
      }
      keySystemDomain = keySystemIdToKeySystemDomain(psshInfo.systemId);
    }
    if (!keySystemDomain || !keyId) {
      return;
    }
    const keyIdHex = Hex.hexDump(keyId);
    const {
      keyIdToKeySessionPromise,
      mediaKeySessions
    } = this;
    let keySessionContextPromise = keyIdToKeySessionPromise[keyIdHex];
    for (let i = 0; i < mediaKeySessions.length; i++) {
      // Match playlist key
      const keyContext = mediaKeySessions[i];
      const decryptdata = keyContext.decryptdata;
      if (decryptdata.pssh || !decryptdata.keyId) {
        continue;
      }
      const oldKeyIdHex = Hex.hexDump(decryptdata.keyId);
      if (keyIdHex === oldKeyIdHex || decryptdata.uri.replace(/-/g, '').indexOf(keyIdHex) !== -1) {
        keySessionContextPromise = keyIdToKeySessionPromise[oldKeyIdHex];
        delete keyIdToKeySessionPromise[oldKeyIdHex];
        decryptdata.pssh = new Uint8Array(initData);
        decryptdata.keyId = keyId;
        keySessionContextPromise = keyIdToKeySessionPromise[keyIdHex] = keySessionContextPromise.then(() => {
          return this.generateRequestWithPreferredKeySession(keyContext, initDataType, initData, 'encrypted-event-key-match');
        });
        break;
      }
    }
    if (!keySessionContextPromise) {
      // Clear-lead key (not encountered in playlist)
      keySessionContextPromise = keyIdToKeySessionPromise[keyIdHex] = this.getKeySystemSelectionPromise([keySystemDomain]).then(({
        keySystem,
        mediaKeys
      }) => {
        var _keySystemToKeySystem;
        this.throwIfDestroyed();
        const decryptdata = new LevelKey('ISO-23001-7', keyIdHex, (_keySystemToKeySystem = keySystemDomainToKeySystemFormat(keySystem)) != null ? _keySystemToKeySystem : '');
        decryptdata.pssh = new Uint8Array(initData);
        decryptdata.keyId = keyId;
        return this.attemptSetMediaKeys(keySystem, mediaKeys).then(() => {
          this.throwIfDestroyed();
          const keySessionContext = this.createMediaKeySessionContext({
            decryptdata,
            keySystem,
            mediaKeys
          });
          return this.generateRequestWithPreferredKeySession(keySessionContext, initDataType, initData, 'encrypted-event-no-match');
        });
      });
    }
    keySessionContextPromise.catch(error => this.handleError(error));
  }
  _onWaitingForKey(event) {
    this.log(`"${event.type}" event`);
  }
  attemptSetMediaKeys(keySystem, mediaKeys) {
    const queue = this.setMediaKeysQueue.slice();
    this.log(`Setting media-keys for "${keySystem}"`);
    // Only one setMediaKeys() can run at one time, and multiple setMediaKeys() operations
    // can be queued for execution for multiple key sessions.
    const setMediaKeysPromise = Promise.all(queue).then(() => {
      if (!this.media) {
        throw new Error('Attempted to set mediaKeys without media element attached');
      }
      return this.media.setMediaKeys(mediaKeys);
    });
    this.setMediaKeysQueue.push(setMediaKeysPromise);
    return setMediaKeysPromise.then(() => {
      this.log(`Media-keys set for "${keySystem}"`);
      queue.push(setMediaKeysPromise);
      this.setMediaKeysQueue = this.setMediaKeysQueue.filter(p => queue.indexOf(p) === -1);
    });
  }
  generateRequestWithPreferredKeySession(context, initDataType, initData, reason) {
    var _this$config$drmSyste, _this$config$drmSyste2;
    const generateRequestFilter = (_this$config$drmSyste = this.config.drmSystems) == null ? void 0 : (_this$config$drmSyste2 = _this$config$drmSyste[context.keySystem]) == null ? void 0 : _this$config$drmSyste2.generateRequest;
    if (generateRequestFilter) {
      try {
        const mappedInitData = generateRequestFilter.call(this.hls, initDataType, initData, context);
        if (!mappedInitData) {
          throw new Error('Invalid response from configured generateRequest filter');
        }
        initDataType = mappedInitData.initDataType;
        initData = context.decryptdata.pssh = mappedInitData.initData ? new Uint8Array(mappedInitData.initData) : null;
      } catch (error) {
        var _this$hls;
        this.warn(error.message);
        if ((_this$hls = this.hls) != null && _this$hls.config.debug) {
          throw error;
        }
      }
    }
    if (initData === null) {
      this.log(`Skipping key-session request for "${reason}" (no initData)`);
      return Promise.resolve(context);
    }
    const keyId = this.getKeyIdString(context.decryptdata);
    this.log(`Generating key-session request for "${reason}": ${keyId} (init data type: ${initDataType} length: ${initData ? initData.byteLength : null})`);
    const licenseStatus = new EventEmitter();
    const onmessage = context._onmessage = event => {
      const keySession = context.mediaKeysSession;
      if (!keySession) {
        licenseStatus.emit('error', new Error('invalid state'));
        return;
      }
      const {
        messageType,
        message
      } = event;
      this.log(`"${messageType}" message event for session "${keySession.sessionId}" message size: ${message.byteLength}`);
      if (messageType === 'license-request' || messageType === 'license-renewal') {
        this.renewLicense(context, message).catch(error => {
          this.handleError(error);
          licenseStatus.emit('error', error);
        });
      } else if (messageType === 'license-release') {
        if (context.keySystem === KeySystems.FAIRPLAY) {
          this.updateKeySession(context, strToUtf8array('acknowledged'));
          this.removeSession(context);
        }
      } else {
        this.warn(`unhandled media key message type "${messageType}"`);
      }
    };
    const onkeystatuseschange = context._onkeystatuseschange = event => {
      const keySession = context.mediaKeysSession;
      if (!keySession) {
        licenseStatus.emit('error', new Error('invalid state'));
        return;
      }
      this.onKeyStatusChange(context);
      const keyStatus = context.keyStatus;
      licenseStatus.emit('keyStatus', keyStatus);
      if (keyStatus === 'expired') {
        this.warn(`${context.keySystem} expired for key ${keyId}`);
        this.renewKeySession(context);
      }
    };
    context.mediaKeysSession.addEventListener('message', onmessage);
    context.mediaKeysSession.addEventListener('keystatuseschange', onkeystatuseschange);
    const keyUsablePromise = new Promise((resolve, reject) => {
      licenseStatus.on('error', reject);
      licenseStatus.on('keyStatus', keyStatus => {
        if (keyStatus.startsWith('usable')) {
          resolve();
        } else if (keyStatus === 'output-restricted') {
          reject(new EMEKeyError({
            type: ErrorTypes.KEY_SYSTEM_ERROR,
            details: ErrorDetails.KEY_SYSTEM_STATUS_OUTPUT_RESTRICTED,
            fatal: false
          }, 'HDCP level output restricted'));
        } else if (keyStatus === 'internal-error') {
          reject(new EMEKeyError({
            type: ErrorTypes.KEY_SYSTEM_ERROR,
            details: ErrorDetails.KEY_SYSTEM_STATUS_INTERNAL_ERROR,
            fatal: true
          }, `key status changed to "${keyStatus}"`));
        } else if (keyStatus === 'expired') {
          reject(new Error('key expired while generating request'));
        } else {
          this.warn(`unhandled key status change "${keyStatus}"`);
        }
      });
    });
    return context.mediaKeysSession.generateRequest(initDataType, initData).then(() => {
      var _context$mediaKeysSes;
      this.log(`Request generated for key-session "${(_context$mediaKeysSes = context.mediaKeysSession) == null ? void 0 : _context$mediaKeysSes.sessionId}" keyId: ${keyId}`);
    }).catch(error => {
      throw new EMEKeyError({
        type: ErrorTypes.KEY_SYSTEM_ERROR,
        details: ErrorDetails.KEY_SYSTEM_NO_SESSION,
        error,
        fatal: false
      }, `Error generating key-session request: ${error}`);
    }).then(() => keyUsablePromise).catch(error => {
      licenseStatus.removeAllListeners();
      this.removeSession(context);
      throw error;
    }).then(() => {
      licenseStatus.removeAllListeners();
      return context;
    });
  }
  onKeyStatusChange(mediaKeySessionContext) {
    mediaKeySessionContext.mediaKeysSession.keyStatuses.forEach((status, keyId) => {
      this.log(`key status change "${status}" for keyStatuses keyId: ${Hex.hexDump('buffer' in keyId ? new Uint8Array(keyId.buffer, keyId.byteOffset, keyId.byteLength) : new Uint8Array(keyId))} session keyId: ${Hex.hexDump(new Uint8Array(mediaKeySessionContext.decryptdata.keyId || []))} uri: ${mediaKeySessionContext.decryptdata.uri}`);
      mediaKeySessionContext.keyStatus = status;
    });
  }
  fetchServerCertificate(keySystem) {
    const config = this.config;
    const Loader = config.loader;
    const certLoader = new Loader(config);
    const url = this.getServerCertificateUrl(keySystem);
    if (!url) {
      return Promise.resolve();
    }
    this.log(`Fetching server certificate for "${keySystem}"`);
    return new Promise((resolve, reject) => {
      const loaderContext = {
        responseType: 'arraybuffer',
        url
      };
      const loadPolicy = config.certLoadPolicy.default;
      const loaderConfig = {
        loadPolicy,
        timeout: loadPolicy.maxLoadTimeMs,
        maxRetry: 0,
        retryDelay: 0,
        maxRetryDelay: 0
      };
      const loaderCallbacks = {
        onSuccess: (response, stats, context, networkDetails) => {
          resolve(response.data);
        },
        onError: (response, contex, networkDetails, stats) => {
          reject(new EMEKeyError({
            type: ErrorTypes.KEY_SYSTEM_ERROR,
            details: ErrorDetails.KEY_SYSTEM_SERVER_CERTIFICATE_REQUEST_FAILED,
            fatal: true,
            networkDetails,
            response: _objectSpread2({
              url: loaderContext.url,
              data: undefined
            }, response)
          }, `"${keySystem}" certificate request failed (${url}). Status: ${response.code} (${response.text})`));
        },
        onTimeout: (stats, context, networkDetails) => {
          reject(new EMEKeyError({
            type: ErrorTypes.KEY_SYSTEM_ERROR,
            details: ErrorDetails.KEY_SYSTEM_SERVER_CERTIFICATE_REQUEST_FAILED,
            fatal: true,
            networkDetails,
            response: {
              url: loaderContext.url,
              data: undefined
            }
          }, `"${keySystem}" certificate request timed out (${url})`));
        },
        onAbort: (stats, context, networkDetails) => {
          reject(new Error('aborted'));
        }
      };
      certLoader.load(loaderContext, loaderConfig, loaderCallbacks);
    });
  }
  setMediaKeysServerCertificate(mediaKeys, keySystem, cert) {
    return new Promise((resolve, reject) => {
      mediaKeys.setServerCertificate(cert).then(success => {
        this.log(`setServerCertificate ${success ? 'success' : 'not supported by CDM'} (${cert == null ? void 0 : cert.byteLength}) on "${keySystem}"`);
        resolve(mediaKeys);
      }).catch(error => {
        reject(new EMEKeyError({
          type: ErrorTypes.KEY_SYSTEM_ERROR,
          details: ErrorDetails.KEY_SYSTEM_SERVER_CERTIFICATE_UPDATE_FAILED,
          error,
          fatal: true
        }, error.message));
      });
    });
  }
  renewLicense(context, keyMessage) {
    return this.requestLicense(context, new Uint8Array(keyMessage)).then(data => {
      return this.updateKeySession(context, new Uint8Array(data)).catch(error => {
        throw new EMEKeyError({
          type: ErrorTypes.KEY_SYSTEM_ERROR,
          details: ErrorDetails.KEY_SYSTEM_SESSION_UPDATE_FAILED,
          error,
          fatal: true
        }, error.message);
      });
    });
  }
  unpackPlayReadyKeyMessage(xhr, licenseChallenge) {
    // On Edge, the raw license message is UTF-16-encoded XML.  We need
    // to unpack the Challenge element (base64-encoded string containing the
    // actual license request) and any HttpHeader elements (sent as request
    // headers).
    // For PlayReady CDMs, we need to dig the Challenge out of the XML.
    const xmlString = String.fromCharCode.apply(null, new Uint16Array(licenseChallenge.buffer));
    if (!xmlString.includes('PlayReadyKeyMessage')) {
      // This does not appear to be a wrapped message as on Edge.  Some
      // clients do not need this unwrapping, so we will assume this is one of
      // them.  Note that "xml" at this point probably looks like random
      // garbage, since we interpreted UTF-8 as UTF-16.
      xhr.setRequestHeader('Content-Type', 'text/xml; charset=utf-8');
      return licenseChallenge;
    }
    const keyMessageXml = new DOMParser().parseFromString(xmlString, 'application/xml');
    // Set request headers.
    const headers = keyMessageXml.querySelectorAll('HttpHeader');
    if (headers.length > 0) {
      let header;
      for (let i = 0, len = headers.length; i < len; i++) {
        var _header$querySelector, _header$querySelector2;
        header = headers[i];
        const name = (_header$querySelector = header.querySelector('name')) == null ? void 0 : _header$querySelector.textContent;
        const value = (_header$querySelector2 = header.querySelector('value')) == null ? void 0 : _header$querySelector2.textContent;
        if (name && value) {
          xhr.setRequestHeader(name, value);
        }
      }
    }
    const challengeElement = keyMessageXml.querySelector('Challenge');
    const challengeText = challengeElement == null ? void 0 : challengeElement.textContent;
    if (!challengeText) {
      throw new Error(`Cannot find <Challenge> in key message`);
    }
    return strToUtf8array(atob(challengeText));
  }
  setupLicenseXHR(xhr, url, keysListItem, licenseChallenge) {
    const licenseXhrSetup = this.config.licenseXhrSetup;
    if (!licenseXhrSetup) {
      xhr.open('POST', url, true);
      return Promise.resolve({
        xhr,
        licenseChallenge
      });
    }
    return Promise.resolve().then(() => {
      if (!keysListItem.decryptdata) {
        throw new Error('Key removed');
      }
      return licenseXhrSetup.call(this.hls, xhr, url, keysListItem, licenseChallenge);
    }).catch(error => {
      if (!keysListItem.decryptdata) {
        // Key session removed. Cancel license request.
        throw error;
      }
      // let's try to open before running setup
      xhr.open('POST', url, true);
      return licenseXhrSetup.call(this.hls, xhr, url, keysListItem, licenseChallenge);
    }).then(licenseXhrSetupResult => {
      // if licenseXhrSetup did not yet call open, let's do it now
      if (!xhr.readyState) {
        xhr.open('POST', url, true);
      }
      const finalLicenseChallenge = licenseXhrSetupResult ? licenseXhrSetupResult : licenseChallenge;
      return {
        xhr,
        licenseChallenge: finalLicenseChallenge
      };
    });
  }
  requestLicense(keySessionContext, licenseChallenge) {
    const keyLoadPolicy = this.config.keyLoadPolicy.default;
    return new Promise((resolve, reject) => {
      const url = this.getLicenseServerUrl(keySessionContext.keySystem);
      this.log(`Sending license request to URL: ${url}`);
      const xhr = new XMLHttpRequest();
      xhr.responseType = 'arraybuffer';
      xhr.onreadystatechange = () => {
        if (!this.hls || !keySessionContext.mediaKeysSession) {
          return reject(new Error('invalid state'));
        }
        if (xhr.readyState === 4) {
          if (xhr.status === 200) {
            this._requestLicenseFailureCount = 0;
            let data = xhr.response;
            this.log(`License received ${data instanceof ArrayBuffer ? data.byteLength : data}`);
            const licenseResponseCallback = this.config.licenseResponseCallback;
            if (licenseResponseCallback) {
              try {
                data = licenseResponseCallback.call(this.hls, xhr, url, keySessionContext);
              } catch (error) {
                this.error(error);
              }
            }
            resolve(data);
          } else {
            const retryConfig = keyLoadPolicy.errorRetry;
            const maxNumRetry = retryConfig ? retryConfig.maxNumRetry : 0;
            this._requestLicenseFailureCount++;
            if (this._requestLicenseFailureCount > maxNumRetry || xhr.status >= 400 && xhr.status < 500) {
              reject(new EMEKeyError({
                type: ErrorTypes.KEY_SYSTEM_ERROR,
                details: ErrorDetails.KEY_SYSTEM_LICENSE_REQUEST_FAILED,
                fatal: true,
                networkDetails: xhr,
                response: {
                  url,
                  data: undefined,
                  code: xhr.status,
                  text: xhr.statusText
                }
              }, `License Request XHR failed (${url}). Status: ${xhr.status} (${xhr.statusText})`));
            } else {
              const attemptsLeft = maxNumRetry - this._requestLicenseFailureCount + 1;
              this.warn(`Retrying license request, ${attemptsLeft} attempts left`);
              this.requestLicense(keySessionContext, licenseChallenge).then(resolve, reject);
            }
          }
        }
      };
      if (keySessionContext.licenseXhr && keySessionContext.licenseXhr.readyState !== XMLHttpRequest.DONE) {
        keySessionContext.licenseXhr.abort();
      }
      keySessionContext.licenseXhr = xhr;
      this.setupLicenseXHR(xhr, url, keySessionContext, licenseChallenge).then(({
        xhr,
        licenseChallenge
      }) => {
        if (keySessionContext.keySystem == KeySystems.PLAYREADY) {
          licenseChallenge = this.unpackPlayReadyKeyMessage(xhr, licenseChallenge);
        }
        xhr.send(licenseChallenge);
      });
    });
  }
  onMediaAttached(event, data) {
    if (!this.config.emeEnabled) {
      return;
    }
    const media = data.media;

    // keep reference of media
    this.media = media;
    media.addEventListener('encrypted', this.onMediaEncrypted);
    media.addEventListener('waitingforkey', this.onWaitingForKey);
  }
  onMediaDetached() {
    const media = this.media;
    const mediaKeysList = this.mediaKeySessions;
    if (media) {
      media.removeEventListener('encrypted', this.onMediaEncrypted);
      media.removeEventListener('waitingforkey', this.onWaitingForKey);
      this.media = null;
    }
    this._requestLicenseFailureCount = 0;
    this.setMediaKeysQueue = [];
    this.mediaKeySessions = [];
    this.keyIdToKeySessionPromise = {};
    LevelKey.clearKeyUriToKeyIdMap();

    // Close all sessions and remove media keys from the video element.
    const keySessionCount = mediaKeysList.length;
    EMEController.CDMCleanupPromise = Promise.all(mediaKeysList.map(mediaKeySessionContext => this.removeSession(mediaKeySessionContext)).concat(media == null ? void 0 : media.setMediaKeys(null).catch(error => {
      this.log(`Could not clear media keys: ${error}`);
    }))).then(() => {
      if (keySessionCount) {
        this.log('finished closing key sessions and clearing media keys');
        mediaKeysList.length = 0;
      }
    }).catch(error => {
      this.log(`Could not close sessions and clear media keys: ${error}`);
    });
  }
  onManifestLoading() {
    this.keyFormatPromise = null;
  }
  onManifestLoaded(event, {
    sessionKeys
  }) {
    if (!sessionKeys || !this.config.emeEnabled) {
      return;
    }
    if (!this.keyFormatPromise) {
      const keyFormats = sessionKeys.reduce((formats, sessionKey) => {
        if (formats.indexOf(sessionKey.keyFormat) === -1) {
          formats.push(sessionKey.keyFormat);
        }
        return formats;
      }, []);
      this.log(`Selecting key-system from session-keys ${keyFormats.join(', ')}`);
      this.keyFormatPromise = this.getKeyFormatPromise(keyFormats);
    }
  }
  removeSession(mediaKeySessionContext) {
    const {
      mediaKeysSession,
      licenseXhr
    } = mediaKeySessionContext;
    if (mediaKeysSession) {
      this.log(`Remove licenses and keys and close session ${mediaKeysSession.sessionId}`);
      if (mediaKeySessionContext._onmessage) {
        mediaKeysSession.removeEventListener('message', mediaKeySessionContext._onmessage);
        mediaKeySessionContext._onmessage = undefined;
      }
      if (mediaKeySessionContext._onkeystatuseschange) {
        mediaKeysSession.removeEventListener('keystatuseschange', mediaKeySessionContext._onkeystatuseschange);
        mediaKeySessionContext._onkeystatuseschange = undefined;
      }
      if (licenseXhr && licenseXhr.readyState !== XMLHttpRequest.DONE) {
        licenseXhr.abort();
      }
      mediaKeySessionContext.mediaKeysSession = mediaKeySessionContext.decryptdata = mediaKeySessionContext.licenseXhr = undefined;
      const index = this.mediaKeySessions.indexOf(mediaKeySessionContext);
      if (index > -1) {
        this.mediaKeySessions.splice(index, 1);
      }
      return mediaKeysSession.remove().catch(error => {
        this.log(`Could not remove session: ${error}`);
      }).then(() => {
        return mediaKeysSession.close();
      }).catch(error => {
        this.log(`Could not close session: ${error}`);
      });
    }
  }
}
EMEController.CDMCleanupPromise = void 0;
class EMEKeyError extends Error {
  constructor(data, message) {
    super(message);
    this.data = void 0;
    data.error || (data.error = new Error(message));
    this.data = data;
    data.err = data.error;
  }
}

/**
 * Common Media Object Type
 *
 * @group CMCD
 * @group CMSD
 *
 * @beta
 */
var CmObjectType;
(function (CmObjectType) {
  /**
   * text file, such as a manifest or playlist
   */
  CmObjectType["MANIFEST"] = "m";
  /**
   * audio only
   */
  CmObjectType["AUDIO"] = "a";
  /**
   * video only
   */
  CmObjectType["VIDEO"] = "v";
  /**
   * muxed audio and video
   */
  CmObjectType["MUXED"] = "av";
  /**
   * init segment
   */
  CmObjectType["INIT"] = "i";
  /**
   * caption or subtitle
   */
  CmObjectType["CAPTION"] = "c";
  /**
   * ISOBMFF timed text track
   */
  CmObjectType["TIMED_TEXT"] = "tt";
  /**
   * cryptographic key, license or certificate.
   */
  CmObjectType["KEY"] = "k";
  /**
   * other
   */
  CmObjectType["OTHER"] = "o";
})(CmObjectType || (CmObjectType = {}));

/**
 * Common Media Streaming Format
 *
 * @group CMCD
 * @group CMSD
 *
 * @beta
 */
var CmStreamingFormat;
(function (CmStreamingFormat) {
  /**
   * MPEG DASH
   */
  CmStreamingFormat["DASH"] = "d";
  /**
   * HTTP Live Streaming (HLS)
   */
  CmStreamingFormat["HLS"] = "h";
  /**
   * Smooth Streaming
   */
  CmStreamingFormat["SMOOTH"] = "s";
  /**
   * Other
   */
  CmStreamingFormat["OTHER"] = "o";
})(CmStreamingFormat || (CmStreamingFormat = {}));

/**
 * CMCD header fields.
 *
 * @group CMCD
 *
 * @beta
 */
var CmcdHeaderField;
(function (CmcdHeaderField) {
  /**
   * keys whose values vary with the object being requested.
   */
  CmcdHeaderField["OBJECT"] = "CMCD-Object";
  /**
   * keys whose values vary with each request.
   */
  CmcdHeaderField["REQUEST"] = "CMCD-Request";
  /**
   * keys whose values are expected to be invariant over the life of the session.
   */
  CmcdHeaderField["SESSION"] = "CMCD-Session";
  /**
   * keys whose values do not vary with every request or object.
   */
  CmcdHeaderField["STATUS"] = "CMCD-Status";
})(CmcdHeaderField || (CmcdHeaderField = {}));

/**
 * The map of CMCD header fields to official CMCD keys.
 *
 * @internal
 *
 * @group CMCD
 */
const CmcdHeaderMap = {
  [CmcdHeaderField.OBJECT]: ['br', 'd', 'ot', 'tb'],
  [CmcdHeaderField.REQUEST]: ['bl', 'dl', 'mtp', 'nor', 'nrr', 'su'],
  [CmcdHeaderField.SESSION]: ['cid', 'pr', 'sf', 'sid', 'st', 'v'],
  [CmcdHeaderField.STATUS]: ['bs', 'rtp']
};

/**
 * Structured Field Item
 *
 * @group Structured Field
 *
 * @beta
 */
class SfItem {
  constructor(value, params) {
    this.value = void 0;
    this.params = void 0;
    if (Array.isArray(value)) {
      value = value.map(v => v instanceof SfItem ? v : new SfItem(v));
    }
    this.value = value;
    this.params = params;
  }
}

/**
 * A class to represent structured field tokens when `Symbol` is not available.
 *
 * @group Structured Field
 *
 * @beta
 */
class SfToken {
  constructor(description) {
    this.description = void 0;
    this.description = description;
  }
}

const DICT = 'Dict';

function format(value) {
  if (Array.isArray(value)) {
    return JSON.stringify(value);
  }
  if (value instanceof Map) {
    return 'Map{}';
  }
  if (value instanceof Set) {
    return 'Set{}';
  }
  if (typeof value === 'object') {
    return JSON.stringify(value);
  }
  return String(value);
}
function throwError(action, src, type, cause) {
  return new Error(`failed to ${action} "${format(src)}" as ${type}`, {
    cause
  });
}

const BARE_ITEM = 'Bare Item';

const BOOLEAN = 'Boolean';

const BYTES = 'Byte Sequence';

const DECIMAL = 'Decimal';

const INTEGER = 'Integer';

function isInvalidInt(value) {
  return value < -999999999999999 || 999999999999999 < value;
}

const STRING_REGEX = /[\x00-\x1f\x7f]+/; // eslint-disable-line no-control-regex

const TOKEN = 'Token';

const KEY = 'Key';

function serializeError(src, type, cause) {
  return throwError('serialize', src, type, cause);
}

// 4.1.9.  Serializing a Boolean
//
// Given a Boolean as input_boolean, return an ASCII string suitable for
// use in a HTTP field value.
//
// 1.  If input_boolean is not a boolean, fail serialization.
//
// 2.  Let output be an empty string.
//
// 3.  Append "?" to output.
//
// 4.  If input_boolean is true, append "1" to output.
//
// 5.  If input_boolean is false, append "0" to output.
//
// 6.  Return output.
function serializeBoolean(value) {
  if (typeof value !== 'boolean') {
    throw serializeError(value, BOOLEAN);
  }
  return value ? '?1' : '?0';
}

/**
 * Encodes binary data to base64
 *
 * @param binary - The binary data to encode
 * @returns The base64 encoded string
 *
 * @group Utils
 *
 * @beta
 */
function base64encode(binary) {
  return btoa(String.fromCharCode(...binary));
}

// 4.1.8.  Serializing a Byte Sequence
//
// Given a Byte Sequence as input_bytes, return an ASCII string suitable
// for use in a HTTP field value.
//
// 1.  If input_bytes is not a sequence of bytes, fail serialization.
//
// 2.  Let output be an empty string.
//
// 3.  Append ":" to output.
//
// 4.  Append the result of base64-encoding input_bytes as per
//     [RFC4648], Section 4, taking account of the requirements below.
//
// 5.  Append ":" to output.
//
// 6.  Return output.
//
// The encoded data is required to be padded with "=", as per [RFC4648],
// Section 3.2.
//
// Likewise, encoded data SHOULD have pad bits set to zero, as per
// [RFC4648], Section 3.5, unless it is not possible to do so due to
// implementation constraints.
function serializeByteSequence(value) {
  if (ArrayBuffer.isView(value) === false) {
    throw serializeError(value, BYTES);
  }
  return `:${base64encode(value)}:`;
}

// 4.1.4.  Serializing an Integer
//
// Given an Integer as input_integer, return an ASCII string suitable
// for use in a HTTP field value.
//
// 1.  If input_integer is not an integer in the range of
//     -999,999,999,999,999 to 999,999,999,999,999 inclusive, fail
//     serialization.
//
// 2.  Let output be an empty string.
//
// 3.  If input_integer is less than (but not equal to) 0, append "-" to
//     output.
//
// 4.  Append input_integer's numeric value represented in base 10 using
//     only decimal digits to output.
//
// 5.  Return output.
function serializeInteger(value) {
  if (isInvalidInt(value)) {
    throw serializeError(value, INTEGER);
  }
  return value.toString();
}

// 4.1.10.  Serializing a Date
//
// Given a Date as input_integer, return an ASCII string suitable for
// use in an HTTP field value.
// 1.  Let output be "@".
// 2.  Append to output the result of running Serializing an Integer
//     with input_date (Section 4.1.4).
// 3.  Return output.
function serializeDate(value) {
  return `@${serializeInteger(value.getTime() / 1000)}`;
}

/**
 * This implements the rounding procedure described in step 2 of the "Serializing a Decimal" specification.
 * This rounding style is known as "even rounding", "banker's rounding", or "commercial rounding".
 *
 * @param value - The value to round
 * @param precision - The number of decimal places to round to
 * @returns The rounded value
 *
 * @group Utils
 *
 * @beta
 */
function roundToEven(value, precision) {
  if (value < 0) {
    return -roundToEven(-value, precision);
  }
  const decimalShift = Math.pow(10, precision);
  const isEquidistant = Math.abs(value * decimalShift % 1 - 0.5) < Number.EPSILON;
  if (isEquidistant) {
    // If the tail of the decimal place is 'equidistant' we round to the nearest even value
    const flooredValue = Math.floor(value * decimalShift);
    return (flooredValue % 2 === 0 ? flooredValue : flooredValue + 1) / decimalShift;
  } else {
    // Otherwise, proceed as normal
    return Math.round(value * decimalShift) / decimalShift;
  }
}

// 4.1.5.  Serializing a Decimal
//
// Given a decimal number as input_decimal, return an ASCII string
// suitable for use in a HTTP field value.
//
// 1.   If input_decimal is not a decimal number, fail serialization.
//
// 2.   If input_decimal has more than three significant digits to the
//      right of the decimal point, round it to three decimal places,
//      rounding the final digit to the nearest value, or to the even
//      value if it is equidistant.
//
// 3.   If input_decimal has more than 12 significant digits to the left
//      of the decimal point after rounding, fail serialization.
//
// 4.   Let output be an empty string.
//
// 5.   If input_decimal is less than (but not equal to) 0, append "-"
//      to output.
//
// 6.   Append input_decimal's integer component represented in base 10
//      (using only decimal digits) to output; if it is zero, append
//      "0".
//
// 7.   Append "." to output.
//
// 8.   If input_decimal's fractional component is zero, append "0" to
//      output.
//
// 9.   Otherwise, append the significant digits of input_decimal's
//      fractional component represented in base 10 (using only decimal
//      digits) to output.
//
// 10.  Return output.
function serializeDecimal(value) {
  const roundedValue = roundToEven(value, 3); // round to 3 decimal places
  if (Math.floor(Math.abs(roundedValue)).toString().length > 12) {
    throw serializeError(value, DECIMAL);
  }
  const stringValue = roundedValue.toString();
  return stringValue.includes('.') ? stringValue : `${stringValue}.0`;
}

const STRING = 'String';

// 4.1.6.  Serializing a String
//
// Given a String as input_string, return an ASCII string suitable for
// use in a HTTP field value.
//
// 1.  Convert input_string into a sequence of ASCII characters; if
//     conversion fails, fail serialization.
//
// 2.  If input_string contains characters in the range %x00-1f or %x7f
//     (i.e., not in VCHAR or SP), fail serialization.
//
// 3.  Let output be the string DQUOTE.
//
// 4.  For each character char in input_string:
//
//     1.  If char is "\" or DQUOTE:
//
//         1.  Append "\" to output.
//
//     2.  Append char to output.
//
// 5.  Append DQUOTE to output.
//
// 6.  Return output.
function serializeString(value) {
  if (STRING_REGEX.test(value)) {
    throw serializeError(value, STRING);
  }
  return `"${value.replace(/\\/g, `\\\\`).replace(/"/g, `\\"`)}"`;
}

function symbolToStr(symbol) {
  return symbol.description || symbol.toString().slice(7, -1);
}

function serializeToken(token) {
  const value = symbolToStr(token);
  if (/^([a-zA-Z*])([!#$%&'*+\-.^_`|~\w:/]*)$/.test(value) === false) {
    throw serializeError(value, TOKEN);
  }
  return value;
}

// 4.1.3.1.  Serializing a Bare Item
//
// Given an Item as input_item, return an ASCII string suitable for use
// in a HTTP field value.
//
// 1.  If input_item is an Integer, return the result of running
//     Serializing an Integer (Section 4.1.4) with input_item.
//
// 2.  If input_item is a Decimal, return the result of running
//     Serializing a Decimal (Section 4.1.5) with input_item.
//
// 3.  If input_item is a String, return the result of running
//     Serializing a String (Section 4.1.6) with input_item.
//
// 4.  If input_item is a Token, return the result of running
//     Serializing a Token (Section 4.1.7) with input_item.
//
// 5.  If input_item is a Boolean, return the result of running
//     Serializing a Boolean (Section 4.1.9) with input_item.
//
// 6.  If input_item is a Byte Sequence, return the result of running
//     Serializing a Byte Sequence (Section 4.1.8) with input_item.
//
// 7.  If input_item is a Date, return the result of running Serializing
//     a Date (Section 4.1.10) with input_item.
//
// 8.  Otherwise, fail serialization.
function serializeBareItem(value) {
  switch (typeof value) {
    case 'number':
      if (!isFiniteNumber(value)) {
        throw serializeError(value, BARE_ITEM);
      }
      if (Number.isInteger(value)) {
        return serializeInteger(value);
      }
      return serializeDecimal(value);
    case 'string':
      return serializeString(value);
    case 'symbol':
      return serializeToken(value);
    case 'boolean':
      return serializeBoolean(value);
    case 'object':
      if (value instanceof Date) {
        return serializeDate(value);
      }
      if (value instanceof Uint8Array) {
        return serializeByteSequence(value);
      }
      if (value instanceof SfToken) {
        return serializeToken(value);
      }
    default:
      // fail
      throw serializeError(value, BARE_ITEM);
  }
}

// 4.1.1.3.  Serializing a Key
//
// Given a key as input_key, return an ASCII string suitable for use in
// a HTTP field value.
//
// 1.  Convert input_key into a sequence of ASCII characters; if
//     conversion fails, fail serialization.
//
// 2.  If input_key contains characters not in lcalpha, DIGIT, "_", "-",
//     ".", or "*" fail serialization.
//
// 3.  If the first character of input_key is not lcalpha or "*", fail
//     serialization.
//
// 4.  Let output be an empty string.
//
// 5.  Append input_key to output.
//
// 6.  Return output.
function serializeKey(value) {
  if (/^[a-z*][a-z0-9\-_.*]*$/.test(value) === false) {
    throw serializeError(value, KEY);
  }
  return value;
}

// 4.1.1.2.  Serializing Parameters
//
// Given an ordered Dictionary as input_parameters (each member having a
// param_name and a param_value), return an ASCII string suitable for
// use in a HTTP field value.
//
// 1.  Let output be an empty string.
//
// 2.  For each param_name with a value of param_value in
//     input_parameters:
//
//     1.  Append ";" to output.
//
//     2.  Append the result of running Serializing a Key
//         (Section 4.1.1.3) with param_name to output.
//
//     3.  If param_value is not Boolean true:
//
//         1.  Append "=" to output.
//
//         2.  Append the result of running Serializing a bare Item
//             (Section 4.1.3.1) with param_value to output.
//
// 3.  Return output.
function serializeParams(params) {
  if (params == null) {
    return '';
  }
  return Object.entries(params).map(([key, value]) => {
    if (value === true) {
      return `;${serializeKey(key)}`; // omit true
    }
    return `;${serializeKey(key)}=${serializeBareItem(value)}`;
  }).join('');
}

// 4.1.3.  Serializing an Item
//
// Given an Item as bare_item and Parameters as item_parameters, return
// an ASCII string suitable for use in a HTTP field value.
//
// 1.  Let output be an empty string.
//
// 2.  Append the result of running Serializing a Bare Item
//     Section 4.1.3.1 with bare_item to output.
//
// 3.  Append the result of running Serializing Parameters
//     Section 4.1.1.2 with item_parameters to output.
//
// 4.  Return output.
function serializeItem(value) {
  if (value instanceof SfItem) {
    return `${serializeBareItem(value.value)}${serializeParams(value.params)}`;
  } else {
    return serializeBareItem(value);
  }
}

// 4.1.1.1.  Serializing an Inner List
//
// Given an array of (member_value, parameters) tuples as inner_list,
// and parameters as list_parameters, return an ASCII string suitable
// for use in a HTTP field value.
//
// 1.  Let output be the string "(".
//
// 2.  For each (member_value, parameters) of inner_list:
//
//     1.  Append the result of running Serializing an Item
//         (Section 4.1.3) with (member_value, parameters) to output.
//
//     2.  If more values remain in inner_list, append a single SP to
//         output.
//
// 3.  Append ")" to output.
//
// 4.  Append the result of running Serializing Parameters
//     (Section 4.1.1.2) with list_parameters to output.
//
// 5.  Return output.
function serializeInnerList(value) {
  return `(${value.value.map(serializeItem).join(' ')})${serializeParams(value.params)}`;
}

// 4.1.2.  Serializing a Dictionary
//
// Given an ordered Dictionary as input_dictionary (each member having a
// member_name and a tuple value of (member_value, parameters)), return
// an ASCII string suitable for use in a HTTP field value.
//
// 1.  Let output be an empty string.
//
// 2.  For each member_name with a value of (member_value, parameters)
//     in input_dictionary:
//
//     1.  Append the result of running Serializing a Key
//         (Section 4.1.1.3) with member's member_name to output.
//
//     2.  If member_value is Boolean true:
//
//         1.  Append the result of running Serializing Parameters
//             (Section 4.1.1.2) with parameters to output.
//
//     3.  Otherwise:
//
//         1.  Append "=" to output.
//
//         2.  If member_value is an array, append the result of running
//             Serializing an Inner List (Section 4.1.1.1) with
//             (member_value, parameters) to output.
//
//         3.  Otherwise, append the result of running Serializing an
//             Item (Section 4.1.3) with (member_value, parameters) to
//             output.
//
//     4.  If more members remain in input_dictionary:
//
//         1.  Append "," to output.
//
//         2.  Append a single SP to output.
//
// 3.  Return output.
function serializeDict(dict, options = {
  whitespace: true
}) {
  if (typeof dict !== 'object') {
    throw serializeError(dict, DICT);
  }
  const entries = dict instanceof Map ? dict.entries() : Object.entries(dict);
  const optionalWhiteSpace = options != null && options.whitespace ? ' ' : '';
  return Array.from(entries).map(([key, item]) => {
    if (item instanceof SfItem === false) {
      item = new SfItem(item);
    }
    let output = serializeKey(key);
    if (item.value === true) {
      output += serializeParams(item.params);
    } else {
      output += '=';
      if (Array.isArray(item.value)) {
        output += serializeInnerList(item);
      } else {
        output += serializeItem(item);
      }
    }
    return output;
  }).join(`,${optionalWhiteSpace}`);
}

/**
 * Encode an object into a structured field dictionary
 *
 * @param input - The structured field dictionary to encode
 * @returns The structured field string
 *
 * @group Structured Field
 *
 * @beta
 */
function encodeSfDict(value, options) {
  return serializeDict(value, options);
}

/**
 * Checks if the given key is a token field.
 *
 * @param key - The key to check.
 *
 * @returns `true` if the key is a token field.
 *
 * @internal
 *
 * @group CMCD
 */
const isTokenField = key => key === 'ot' || key === 'sf' || key === 'st';

const isValid = value => {
  if (typeof value === 'number') {
    return isFiniteNumber(value);
  }
  return value != null && value !== '' && value !== false;
};

/**
 * Constructs a relative path from a URL.
 *
 * @param url - The destination URL
 * @param base - The base URL
 * @returns The relative path
 *
 * @group Utils
 *
 * @beta
 */
function urlToRelativePath(url, base) {
  const to = new URL(url);
  const from = new URL(base);
  if (to.origin !== from.origin) {
    return url;
  }
  const toPath = to.pathname.split('/').slice(1);
  const fromPath = from.pathname.split('/').slice(1, -1);
  // remove common parents
  while (toPath[0] === fromPath[0]) {
    toPath.shift();
    fromPath.shift();
  }
  // add back paths
  while (fromPath.length) {
    fromPath.shift();
    toPath.unshift('..');
  }
  return toPath.join('/');
}

/**
 * Generate a random v4 UUID
 *
 * @returns A random v4 UUID
 *
 * @group Utils
 *
 * @beta
 */
function uuid() {
  try {
    return crypto.randomUUID();
  } catch (error) {
    try {
      const url = URL.createObjectURL(new Blob());
      const uuid = url.toString();
      URL.revokeObjectURL(url);
      return uuid.slice(uuid.lastIndexOf('/') + 1);
    } catch (error) {
      let dt = new Date().getTime();
      const uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, c => {
        const r = (dt + Math.random() * 16) % 16 | 0;
        dt = Math.floor(dt / 16);
        return (c == 'x' ? r : r & 0x3 | 0x8).toString(16);
      });
      return uuid;
    }
  }
}

const toRounded = value => Math.round(value);
const toUrlSafe = (value, options) => {
  if (options != null && options.baseUrl) {
    value = urlToRelativePath(value, options.baseUrl);
  }
  return encodeURIComponent(value);
};
const toHundred = value => toRounded(value / 100) * 100;
/**
 * The default formatters for CMCD values.
 *
 * @group CMCD
 *
 * @beta
 */
const CmcdFormatters = {
  /**
   * Bitrate (kbps) rounded integer
   */
  br: toRounded,
  /**
   * Duration (milliseconds) rounded integer
   */
  d: toRounded,
  /**
   * Buffer Length (milliseconds) rounded nearest 100ms
   */
  bl: toHundred,
  /**
   * Deadline (milliseconds) rounded nearest 100ms
   */
  dl: toHundred,
  /**
   * Measured Throughput (kbps) rounded nearest 100kbps
   */
  mtp: toHundred,
  /**
   * Next Object Request URL encoded
   */
  nor: toUrlSafe,
  /**
   * Requested maximum throughput (kbps) rounded nearest 100kbps
   */
  rtp: toHundred,
  /**
   * Top Bitrate (kbps) rounded integer
   */
  tb: toRounded
};

/**
 * Internal CMCD processing function.
 *
 * @param obj - The CMCD object to process.
 * @param map - The mapping function to use.
 * @param options - Options for encoding.
 *
 * @internal
 *
 * @group CMCD
 */
function processCmcd(obj, options) {
  const results = {};
  if (obj == null || typeof obj !== 'object') {
    return results;
  }
  const keys = Object.keys(obj).sort();
  const formatters = _extends({}, CmcdFormatters, options == null ? void 0 : options.formatters);
  const filter = options == null ? void 0 : options.filter;
  keys.forEach(key => {
    if (filter != null && filter(key)) {
      return;
    }
    let value = obj[key];
    const formatter = formatters[key];
    if (formatter) {
      value = formatter(value, options);
    }
    // Version should only be reported if not equal to 1.
    if (key === 'v' && value === 1) {
      return;
    }
    // Playback rate should only be sent if not equal to 1.
    if (key == 'pr' && value === 1) {
      return;
    }
    // ignore invalid values
    if (!isValid(value)) {
      return;
    }
    if (isTokenField(key) && typeof value === 'string') {
      value = new SfToken(value);
    }
    results[key] = value;
  });
  return results;
}

/**
 * Encode a CMCD object to a string.
 *
 * @param cmcd - The CMCD object to encode.
 * @param options - Options for encoding.
 *
 * @returns The encoded CMCD string.
 *
 * @group CMCD
 *
 * @beta
 */
function encodeCmcd(cmcd, options = {}) {
  if (!cmcd) {
    return '';
  }
  return encodeSfDict(processCmcd(cmcd, options), _extends({
    whitespace: false
  }, options));
}

/**
 * Convert a CMCD data object to request headers
 *
 * @param cmcd - The CMCD data object to convert.
 * @param options - Options for encoding the CMCD object.
 *
 * @returns The CMCD header shards.
 *
 * @group CMCD
 *
 * @beta
 */
function toCmcdHeaders(cmcd, options = {}) {
  if (!cmcd) {
    return {};
  }
  const entries = Object.entries(cmcd);
  const headerMap = Object.entries(CmcdHeaderMap).concat(Object.entries((options == null ? void 0 : options.customHeaderMap) || {}));
  const shards = entries.reduce((acc, entry) => {
    var _headerMap$find, _acc$field;
    const [key, value] = entry;
    const field = ((_headerMap$find = headerMap.find(entry => entry[1].includes(key))) == null ? void 0 : _headerMap$find[0]) || CmcdHeaderField.REQUEST;
    (_acc$field = acc[field]) != null ? _acc$field : acc[field] = {};
    acc[field][key] = value;
    return acc;
  }, {});
  return Object.entries(shards).reduce((acc, [field, value]) => {
    acc[field] = encodeCmcd(value, options);
    return acc;
  }, {});
}

/**
 * Append CMCD query args to a header object.
 *
 * @param headers - The headers to append to.
 * @param cmcd - The CMCD object to append.
 * @param customHeaderMap - A map of custom CMCD keys to header fields.
 *
 * @returns The headers with the CMCD header shards appended.
 *
 * @group CMCD
 *
 * @beta
 */
function appendCmcdHeaders(headers, cmcd, options) {
  return _extends(headers, toCmcdHeaders(cmcd, options));
}

/**
 * CMCD parameter name.
 *
 * @group CMCD
 *
 * @beta
 */
const CMCD_PARAM = 'CMCD';

/**
 * Convert a CMCD data object to a query arg.
 *
 * @param cmcd - The CMCD object to convert.
 * @param options - Options for encoding the CMCD object.
 *
 * @returns The CMCD query arg.
 *
 * @group CMCD
 *
 * @beta
 */
function toCmcdQuery(cmcd, options = {}) {
  if (!cmcd) {
    return '';
  }
  const params = encodeCmcd(cmcd, options);
  return `${CMCD_PARAM}=${encodeURIComponent(params)}`;
}

const REGEX = /CMCD=[^&#]+/;
/**
 * Append CMCD query args to a URL.
 *
 * @param url - The URL to append to.
 * @param cmcd - The CMCD object to append.
 * @param options - Options for encoding the CMCD object.
 *
 * @returns The URL with the CMCD query args appended.
 *
 * @group CMCD
 *
 * @beta
 */
function appendCmcdQuery(url, cmcd, options) {
  // TODO: Replace with URLSearchParams once we drop Safari < 10.1 & Chrome < 49 support.
  // https://developer.mozilla.org/en-US/docs/Web/API/URLSearchParams
  const query = toCmcdQuery(cmcd, options);
  if (!query) {
    return url;
  }
  if (REGEX.test(url)) {
    return url.replace(REGEX, query);
  }
  const separator = url.includes('?') ? '&' : '?';
  return `${url}${separator}${query}`;
}

/**
 * Controller to deal with Common Media Client Data (CMCD)
 * @see https://cdn.cta.tech/cta/media/media/resources/standards/pdfs/cta-5004-final.pdf
 */
class CMCDController {
  // eslint-disable-line no-restricted-globals

  constructor(hls) {
    this.hls = void 0;
    this.config = void 0;
    this.media = void 0;
    this.sid = void 0;
    this.cid = void 0;
    this.useHeaders = false;
    this.includeKeys = void 0;
    this.initialized = false;
    this.starved = false;
    this.buffering = true;
    this.audioBuffer = void 0;
    // eslint-disable-line no-restricted-globals
    this.videoBuffer = void 0;
    this.onWaiting = () => {
      if (this.initialized) {
        this.starved = true;
      }
      this.buffering = true;
    };
    this.onPlaying = () => {
      if (!this.initialized) {
        this.initialized = true;
      }
      this.buffering = false;
    };
    /**
     * Apply CMCD data to a manifest request.
     */
    this.applyPlaylistData = context => {
      try {
        this.apply(context, {
          ot: CmObjectType.MANIFEST,
          su: !this.initialized
        });
      } catch (error) {
        logger.warn('Could not generate manifest CMCD data.', error);
      }
    };
    /**
     * Apply CMCD data to a segment request
     */
    this.applyFragmentData = context => {
      try {
        const fragment = context.frag;
        const level = this.hls.levels[fragment.level];
        const ot = this.getObjectType(fragment);
        const data = {
          d: fragment.duration * 1000,
          ot
        };
        if (ot === CmObjectType.VIDEO || ot === CmObjectType.AUDIO || ot == CmObjectType.MUXED) {
          data.br = level.bitrate / 1000;
          data.tb = this.getTopBandwidth(ot) / 1000;
          data.bl = this.getBufferLength(ot);
        }
        this.apply(context, data);
      } catch (error) {
        logger.warn('Could not generate segment CMCD data.', error);
      }
    };
    this.hls = hls;
    const config = this.config = hls.config;
    const {
      cmcd
    } = config;
    if (cmcd != null) {
      config.pLoader = this.createPlaylistLoader();
      config.fLoader = this.createFragmentLoader();
      this.sid = cmcd.sessionId || uuid();
      this.cid = cmcd.contentId;
      this.useHeaders = cmcd.useHeaders === true;
      this.includeKeys = cmcd.includeKeys;
      this.registerListeners();
    }
  }
  registerListeners() {
    const hls = this.hls;
    hls.on(Events.MEDIA_ATTACHED, this.onMediaAttached, this);
    hls.on(Events.MEDIA_DETACHED, this.onMediaDetached, this);
    hls.on(Events.BUFFER_CREATED, this.onBufferCreated, this);
  }
  unregisterListeners() {
    const hls = this.hls;
    hls.off(Events.MEDIA_ATTACHED, this.onMediaAttached, this);
    hls.off(Events.MEDIA_DETACHED, this.onMediaDetached, this);
    hls.off(Events.BUFFER_CREATED, this.onBufferCreated, this);
  }
  destroy() {
    this.unregisterListeners();
    this.onMediaDetached();

    // @ts-ignore
    this.hls = this.config = this.audioBuffer = this.videoBuffer = null;
    // @ts-ignore
    this.onWaiting = this.onPlaying = null;
  }
  onMediaAttached(event, data) {
    this.media = data.media;
    this.media.addEventListener('waiting', this.onWaiting);
    this.media.addEventListener('playing', this.onPlaying);
  }
  onMediaDetached() {
    if (!this.media) {
      return;
    }
    this.media.removeEventListener('waiting', this.onWaiting);
    this.media.removeEventListener('playing', this.onPlaying);

    // @ts-ignore
    this.media = null;
  }
  onBufferCreated(event, data) {
    var _data$tracks$audio, _data$tracks$video;
    this.audioBuffer = (_data$tracks$audio = data.tracks.audio) == null ? void 0 : _data$tracks$audio.buffer;
    this.videoBuffer = (_data$tracks$video = data.tracks.video) == null ? void 0 : _data$tracks$video.buffer;
  }
  /**
   * Create baseline CMCD data
   */
  createData() {
    var _this$media;
    return {
      v: 1,
      sf: CmStreamingFormat.HLS,
      sid: this.sid,
      cid: this.cid,
      pr: (_this$media = this.media) == null ? void 0 : _this$media.playbackRate,
      mtp: this.hls.bandwidthEstimate / 1000
    };
  }

  /**
   * Apply CMCD data to a request.
   */
  apply(context, data = {}) {
    // apply baseline data
    _extends(data, this.createData());
    const isVideo = data.ot === CmObjectType.INIT || data.ot === CmObjectType.VIDEO || data.ot === CmObjectType.MUXED;
    if (this.starved && isVideo) {
      data.bs = true;
      data.su = true;
      this.starved = false;
    }
    if (data.su == null) {
      data.su = this.buffering;
    }

    // TODO: Implement rtp, nrr, nor, dl

    const {
      includeKeys
    } = this;
    if (includeKeys) {
      data = Object.keys(data).reduce((acc, key) => {
        includeKeys.includes(key) && (acc[key] = data[key]);
        return acc;
      }, {});
    }
    if (this.useHeaders) {
      if (!context.headers) {
        context.headers = {};
      }
      appendCmcdHeaders(context.headers, data);
    } else {
      context.url = appendCmcdQuery(context.url, data);
    }
  }
  /**
   * The CMCD object type.
   */
  getObjectType(fragment) {
    const {
      type
    } = fragment;
    if (type === 'subtitle') {
      return CmObjectType.TIMED_TEXT;
    }
    if (fragment.sn === 'initSegment') {
      return CmObjectType.INIT;
    }
    if (type === 'audio') {
      return CmObjectType.AUDIO;
    }
    if (type === 'main') {
      if (!this.hls.audioTracks.length) {
        return CmObjectType.MUXED;
      }
      return CmObjectType.VIDEO;
    }
    return undefined;
  }

  /**
   * Get the highest bitrate.
   */
  getTopBandwidth(type) {
    let bitrate = 0;
    let levels;
    const hls = this.hls;
    if (type === CmObjectType.AUDIO) {
      levels = hls.audioTracks;
    } else {
      const max = hls.maxAutoLevel;
      const len = max > -1 ? max + 1 : hls.levels.length;
      levels = hls.levels.slice(0, len);
    }
    for (const level of levels) {
      if (level.bitrate > bitrate) {
        bitrate = level.bitrate;
      }
    }
    return bitrate > 0 ? bitrate : NaN;
  }

  /**
   * Get the buffer length for a media type in milliseconds
   */
  getBufferLength(type) {
    const media = this.hls.media;
    const buffer = type === CmObjectType.AUDIO ? this.audioBuffer : this.videoBuffer;
    if (!buffer || !media) {
      return NaN;
    }
    const info = BufferHelper.bufferInfo(buffer, media.currentTime, this.config.maxBufferHole);
    return info.len * 1000;
  }

  /**
   * Create a playlist loader
   */
  createPlaylistLoader() {
    const {
      pLoader
    } = this.config;
    const apply = this.applyPlaylistData;
    const Ctor = pLoader || this.config.loader;
    return class CmcdPlaylistLoader {
      constructor(config) {
        this.loader = void 0;
        this.loader = new Ctor(config);
      }
      get stats() {
        return this.loader.stats;
      }
      get context() {
        return this.loader.context;
      }
      destroy() {
        this.loader.destroy();
      }
      abort() {
        this.loader.abort();
      }
      load(context, config, callbacks) {
        apply(context);
        this.loader.load(context, config, callbacks);
      }
    };
  }

  /**
   * Create a playlist loader
   */
  createFragmentLoader() {
    const {
      fLoader
    } = this.config;
    const apply = this.applyFragmentData;
    const Ctor = fLoader || this.config.loader;
    return class CmcdFragmentLoader {
      constructor(config) {
        this.loader = void 0;
        this.loader = new Ctor(config);
      }
      get stats() {
        return this.loader.stats;
      }
      get context() {
        return this.loader.context;
      }
      destroy() {
        this.loader.destroy();
      }
      abort() {
        this.loader.abort();
      }
      load(context, config, callbacks) {
        apply(context);
        this.loader.load(context, config, callbacks);
      }
    };
  }
}

const PATHWAY_PENALTY_DURATION_MS = 300000;
class ContentSteeringController {
  constructor(hls) {
    this.hls = void 0;
    this.log = void 0;
    this.loader = null;
    this.uri = null;
    this.pathwayId = '.';
    this.pathwayPriority = null;
    this.timeToLoad = 300;
    this.reloadTimer = -1;
    this.updated = 0;
    this.started = false;
    this.enabled = true;
    this.levels = null;
    this.audioTracks = null;
    this.subtitleTracks = null;
    this.penalizedPathways = {};
    this.hls = hls;
    this.log = logger.log.bind(logger, `[content-steering]:`);
    this.registerListeners();
  }
  registerListeners() {
    const hls = this.hls;
    hls.on(Events.MANIFEST_LOADING, this.onManifestLoading, this);
    hls.on(Events.MANIFEST_LOADED, this.onManifestLoaded, this);
    hls.on(Events.MANIFEST_PARSED, this.onManifestParsed, this);
    hls.on(Events.ERROR, this.onError, this);
  }
  unregisterListeners() {
    const hls = this.hls;
    if (!hls) {
      return;
    }
    hls.off(Events.MANIFEST_LOADING, this.onManifestLoading, this);
    hls.off(Events.MANIFEST_LOADED, this.onManifestLoaded, this);
    hls.off(Events.MANIFEST_PARSED, this.onManifestParsed, this);
    hls.off(Events.ERROR, this.onError, this);
  }
  startLoad() {
    this.started = true;
    this.clearTimeout();
    if (this.enabled && this.uri) {
      if (this.updated) {
        const ttl = this.timeToLoad * 1000 - (performance.now() - this.updated);
        if (ttl > 0) {
          this.scheduleRefresh(this.uri, ttl);
          return;
        }
      }
      this.loadSteeringManifest(this.uri);
    }
  }
  stopLoad() {
    this.started = false;
    if (this.loader) {
      this.loader.destroy();
      this.loader = null;
    }
    this.clearTimeout();
  }
  clearTimeout() {
    if (this.reloadTimer !== -1) {
      self.clearTimeout(this.reloadTimer);
      this.reloadTimer = -1;
    }
  }
  destroy() {
    this.unregisterListeners();
    this.stopLoad();
    // @ts-ignore
    this.hls = null;
    this.levels = this.audioTracks = this.subtitleTracks = null;
  }
  removeLevel(levelToRemove) {
    const levels = this.levels;
    if (levels) {
      this.levels = levels.filter(level => level !== levelToRemove);
    }
  }
  onManifestLoading() {
    this.stopLoad();
    this.enabled = true;
    this.timeToLoad = 300;
    this.updated = 0;
    this.uri = null;
    this.pathwayId = '.';
    this.levels = this.audioTracks = this.subtitleTracks = null;
  }
  onManifestLoaded(event, data) {
    const {
      contentSteering
    } = data;
    if (contentSteering === null) {
      return;
    }
    this.pathwayId = contentSteering.pathwayId;
    this.uri = contentSteering.uri;
    if (this.started) {
      this.startLoad();
    }
  }
  onManifestParsed(event, data) {
    this.audioTracks = data.audioTracks;
    this.subtitleTracks = data.subtitleTracks;
  }
  onError(event, data) {
    const {
      errorAction
    } = data;
    if ((errorAction == null ? void 0 : errorAction.action) === NetworkErrorAction.SendAlternateToPenaltyBox && errorAction.flags === ErrorActionFlags.MoveAllAlternatesMatchingHost) {
      const levels = this.levels;
      let pathwayPriority = this.pathwayPriority;
      let errorPathway = this.pathwayId;
      if (data.context) {
        const {
          groupId,
          pathwayId,
          type
        } = data.context;
        if (groupId && levels) {
          errorPathway = this.getPathwayForGroupId(groupId, type, errorPathway);
        } else if (pathwayId) {
          errorPathway = pathwayId;
        }
      }
      if (!(errorPathway in this.penalizedPathways)) {
        this.penalizedPathways[errorPathway] = performance.now();
      }
      if (!pathwayPriority && levels) {
        // If PATHWAY-PRIORITY was not provided, list pathways for error handling
        pathwayPriority = levels.reduce((pathways, level) => {
          if (pathways.indexOf(level.pathwayId) === -1) {
            pathways.push(level.pathwayId);
          }
          return pathways;
        }, []);
      }
      if (pathwayPriority && pathwayPriority.length > 1) {
        this.updatePathwayPriority(pathwayPriority);
        errorAction.resolved = this.pathwayId !== errorPathway;
      }
      if (!errorAction.resolved) {
        logger.warn(`Could not resolve ${data.details} ("${data.error.message}") with content-steering for Pathway: ${errorPathway} levels: ${levels ? levels.length : levels} priorities: ${JSON.stringify(pathwayPriority)} penalized: ${JSON.stringify(this.penalizedPathways)}`);
      }
    }
  }
  filterParsedLevels(levels) {
    // Filter levels to only include those that are in the initial pathway
    this.levels = levels;
    let pathwayLevels = this.getLevelsForPathway(this.pathwayId);
    if (pathwayLevels.length === 0) {
      const pathwayId = levels[0].pathwayId;
      this.log(`No levels found in Pathway ${this.pathwayId}. Setting initial Pathway to "${pathwayId}"`);
      pathwayLevels = this.getLevelsForPathway(pathwayId);
      this.pathwayId = pathwayId;
    }
    if (pathwayLevels.length !== levels.length) {
      this.log(`Found ${pathwayLevels.length}/${levels.length} levels in Pathway "${this.pathwayId}"`);
      return pathwayLevels;
    }
    return levels;
  }
  getLevelsForPathway(pathwayId) {
    if (this.levels === null) {
      return [];
    }
    return this.levels.filter(level => pathwayId === level.pathwayId);
  }
  updatePathwayPriority(pathwayPriority) {
    this.pathwayPriority = pathwayPriority;
    let levels;

    // Evaluate if we should remove the pathway from the penalized list
    const penalizedPathways = this.penalizedPathways;
    const now = performance.now();
    Object.keys(penalizedPathways).forEach(pathwayId => {
      if (now - penalizedPathways[pathwayId] > PATHWAY_PENALTY_DURATION_MS) {
        delete penalizedPathways[pathwayId];
      }
    });
    for (let i = 0; i < pathwayPriority.length; i++) {
      const pathwayId = pathwayPriority[i];
      if (pathwayId in penalizedPathways) {
        continue;
      }
      if (pathwayId === this.pathwayId) {
        return;
      }
      const selectedIndex = this.hls.nextLoadLevel;
      const selectedLevel = this.hls.levels[selectedIndex];
      levels = this.getLevelsForPathway(pathwayId);
      if (levels.length > 0) {
        this.log(`Setting Pathway to "${pathwayId}"`);
        this.pathwayId = pathwayId;
        reassignFragmentLevelIndexes(levels);
        this.hls.trigger(Events.LEVELS_UPDATED, {
          levels
        });
        // Set LevelController's level to trigger LEVEL_SWITCHING which loads playlist if needed
        const levelAfterChange = this.hls.levels[selectedIndex];
        if (selectedLevel && levelAfterChange && this.levels) {
          if (levelAfterChange.attrs['STABLE-VARIANT-ID'] !== selectedLevel.attrs['STABLE-VARIANT-ID'] && levelAfterChange.bitrate !== selectedLevel.bitrate) {
            this.log(`Unstable Pathways change from bitrate ${selectedLevel.bitrate} to ${levelAfterChange.bitrate}`);
          }
          this.hls.nextLoadLevel = selectedIndex;
        }
        break;
      }
    }
  }
  getPathwayForGroupId(groupId, type, defaultPathway) {
    const levels = this.getLevelsForPathway(defaultPathway).concat(this.levels || []);
    for (let i = 0; i < levels.length; i++) {
      if (type === PlaylistContextType.AUDIO_TRACK && levels[i].hasAudioGroup(groupId) || type === PlaylistContextType.SUBTITLE_TRACK && levels[i].hasSubtitleGroup(groupId)) {
        return levels[i].pathwayId;
      }
    }
    return defaultPathway;
  }
  clonePathways(pathwayClones) {
    const levels = this.levels;
    if (!levels) {
      return;
    }
    const audioGroupCloneMap = {};
    const subtitleGroupCloneMap = {};
    pathwayClones.forEach(pathwayClone => {
      const {
        ID: cloneId,
        'BASE-ID': baseId,
        'URI-REPLACEMENT': uriReplacement
      } = pathwayClone;
      if (levels.some(level => level.pathwayId === cloneId)) {
        return;
      }
      const clonedVariants = this.getLevelsForPathway(baseId).map(baseLevel => {
        const attributes = new AttrList(baseLevel.attrs);
        attributes['PATHWAY-ID'] = cloneId;
        const clonedAudioGroupId = attributes.AUDIO && `${attributes.AUDIO}_clone_${cloneId}`;
        const clonedSubtitleGroupId = attributes.SUBTITLES && `${attributes.SUBTITLES}_clone_${cloneId}`;
        if (clonedAudioGroupId) {
          audioGroupCloneMap[attributes.AUDIO] = clonedAudioGroupId;
          attributes.AUDIO = clonedAudioGroupId;
        }
        if (clonedSubtitleGroupId) {
          subtitleGroupCloneMap[attributes.SUBTITLES] = clonedSubtitleGroupId;
          attributes.SUBTITLES = clonedSubtitleGroupId;
        }
        const url = performUriReplacement(baseLevel.uri, attributes['STABLE-VARIANT-ID'], 'PER-VARIANT-URIS', uriReplacement);
        const clonedLevel = new Level({
          attrs: attributes,
          audioCodec: baseLevel.audioCodec,
          bitrate: baseLevel.bitrate,
          height: baseLevel.height,
          name: baseLevel.name,
          url,
          videoCodec: baseLevel.videoCodec,
          width: baseLevel.width
        });
        if (baseLevel.audioGroups) {
          for (let i = 1; i < baseLevel.audioGroups.length; i++) {
            clonedLevel.addGroupId('audio', `${baseLevel.audioGroups[i]}_clone_${cloneId}`);
          }
        }
        if (baseLevel.subtitleGroups) {
          for (let i = 1; i < baseLevel.subtitleGroups.length; i++) {
            clonedLevel.addGroupId('text', `${baseLevel.subtitleGroups[i]}_clone_${cloneId}`);
          }
        }
        return clonedLevel;
      });
      levels.push(...clonedVariants);
      cloneRenditionGroups(this.audioTracks, audioGroupCloneMap, uriReplacement, cloneId);
      cloneRenditionGroups(this.subtitleTracks, subtitleGroupCloneMap, uriReplacement, cloneId);
    });
  }
  loadSteeringManifest(uri) {
    const config = this.hls.config;
    const Loader = config.loader;
    if (this.loader) {
      this.loader.destroy();
    }
    this.loader = new Loader(config);
    let url;
    try {
      url = new self.URL(uri);
    } catch (error) {
      this.enabled = false;
      this.log(`Failed to parse Steering Manifest URI: ${uri}`);
      return;
    }
    if (url.protocol !== 'data:') {
      const throughput = (this.hls.bandwidthEstimate || config.abrEwmaDefaultEstimate) | 0;
      url.searchParams.set('_HLS_pathway', this.pathwayId);
      url.searchParams.set('_HLS_throughput', '' + throughput);
    }
    const context = {
      responseType: 'json',
      url: url.href
    };
    const loadPolicy = config.steeringManifestLoadPolicy.default;
    const legacyRetryCompatibility = loadPolicy.errorRetry || loadPolicy.timeoutRetry || {};
    const loaderConfig = {
      loadPolicy,
      timeout: loadPolicy.maxLoadTimeMs,
      maxRetry: legacyRetryCompatibility.maxNumRetry || 0,
      retryDelay: legacyRetryCompatibility.retryDelayMs || 0,
      maxRetryDelay: legacyRetryCompatibility.maxRetryDelayMs || 0
    };
    const callbacks = {
      onSuccess: (response, stats, context, networkDetails) => {
        this.log(`Loaded steering manifest: "${url}"`);
        const steeringData = response.data;
        if (steeringData.VERSION !== 1) {
          this.log(`Steering VERSION ${steeringData.VERSION} not supported!`);
          return;
        }
        this.updated = performance.now();
        this.timeToLoad = steeringData.TTL;
        const {
          'RELOAD-URI': reloadUri,
          'PATHWAY-CLONES': pathwayClones,
          'PATHWAY-PRIORITY': pathwayPriority
        } = steeringData;
        if (reloadUri) {
          try {
            this.uri = new self.URL(reloadUri, url).href;
          } catch (error) {
            this.enabled = false;
            this.log(`Failed to parse Steering Manifest RELOAD-URI: ${reloadUri}`);
            return;
          }
        }
        this.scheduleRefresh(this.uri || context.url);
        if (pathwayClones) {
          this.clonePathways(pathwayClones);
        }
        const loadedSteeringData = {
          steeringManifest: steeringData,
          url: url.toString()
        };
        this.hls.trigger(Events.STEERING_MANIFEST_LOADED, loadedSteeringData);
        if (pathwayPriority) {
          this.updatePathwayPriority(pathwayPriority);
        }
      },
      onError: (error, context, networkDetails, stats) => {
        this.log(`Error loading steering manifest: ${error.code} ${error.text} (${context.url})`);
        this.stopLoad();
        if (error.code === 410) {
          this.enabled = false;
          this.log(`Steering manifest ${context.url} no longer available`);
          return;
        }
        let ttl = this.timeToLoad * 1000;
        if (error.code === 429) {
          const loader = this.loader;
          if (typeof (loader == null ? void 0 : loader.getResponseHeader) === 'function') {
            const retryAfter = loader.getResponseHeader('Retry-After');
            if (retryAfter) {
              ttl = parseFloat(retryAfter) * 1000;
            }
          }
          this.log(`Steering manifest ${context.url} rate limited`);
          return;
        }
        this.scheduleRefresh(this.uri || context.url, ttl);
      },
      onTimeout: (stats, context, networkDetails) => {
        this.log(`Timeout loading steering manifest (${context.url})`);
        this.scheduleRefresh(this.uri || context.url);
      }
    };
    this.log(`Requesting steering manifest: ${url}`);
    this.loader.load(context, loaderConfig, callbacks);
  }
  scheduleRefresh(uri, ttlMs = this.timeToLoad * 1000) {
    this.clearTimeout();
    this.reloadTimer = self.setTimeout(() => {
      var _this$hls;
      const media = (_this$hls = this.hls) == null ? void 0 : _this$hls.media;
      if (media && !media.ended) {
        this.loadSteeringManifest(uri);
        return;
      }
      this.scheduleRefresh(uri, this.timeToLoad * 1000);
    }, ttlMs);
  }
}
function cloneRenditionGroups(tracks, groupCloneMap, uriReplacement, cloneId) {
  if (!tracks) {
    return;
  }
  Object.keys(groupCloneMap).forEach(audioGroupId => {
    const clonedTracks = tracks.filter(track => track.groupId === audioGroupId).map(track => {
      const clonedTrack = _extends({}, track);
      clonedTrack.details = undefined;
      clonedTrack.attrs = new AttrList(clonedTrack.attrs);
      clonedTrack.url = clonedTrack.attrs.URI = performUriReplacement(track.url, track.attrs['STABLE-RENDITION-ID'], 'PER-RENDITION-URIS', uriReplacement);
      clonedTrack.groupId = clonedTrack.attrs['GROUP-ID'] = groupCloneMap[audioGroupId];
      clonedTrack.attrs['PATHWAY-ID'] = cloneId;
      return clonedTrack;
    });
    tracks.push(...clonedTracks);
  });
}
function performUriReplacement(uri, stableId, perOptionKey, uriReplacement) {
  const {
    HOST: host,
    PARAMS: params,
    [perOptionKey]: perOptionUris
  } = uriReplacement;
  let perVariantUri;
  if (stableId) {
    perVariantUri = perOptionUris == null ? void 0 : perOptionUris[stableId];
    if (perVariantUri) {
      uri = perVariantUri;
    }
  }
  const url = new self.URL(uri);
  if (host && !perVariantUri) {
    url.host = host;
  }
  if (params) {
    Object.keys(params).sort().forEach(key => {
      if (key) {
        url.searchParams.set(key, params[key]);
      }
    });
  }
  return url.href;
}

const AGE_HEADER_LINE_REGEX = /^age:\s*[\d.]+\s*$/im;
class XhrLoader {
  constructor(config) {
    this.xhrSetup = void 0;
    this.requestTimeout = void 0;
    this.retryTimeout = void 0;
    this.retryDelay = void 0;
    this.config = null;
    this.callbacks = null;
    this.context = null;
    this.loader = null;
    this.stats = void 0;
    this.xhrSetup = config ? config.xhrSetup || null : null;
    this.stats = new LoadStats();
    this.retryDelay = 0;
  }
  destroy() {
    this.callbacks = null;
    this.abortInternal();
    this.loader = null;
    this.config = null;
    this.context = null;
    this.xhrSetup = null;
  }
  abortInternal() {
    const loader = this.loader;
    self.clearTimeout(this.requestTimeout);
    self.clearTimeout(this.retryTimeout);
    if (loader) {
      loader.onreadystatechange = null;
      loader.onprogress = null;
      if (loader.readyState !== 4) {
        this.stats.aborted = true;
        loader.abort();
      }
    }
  }
  abort() {
    var _this$callbacks;
    this.abortInternal();
    if ((_this$callbacks = this.callbacks) != null && _this$callbacks.onAbort) {
      this.callbacks.onAbort(this.stats, this.context, this.loader);
    }
  }
  load(context, config, callbacks) {
    if (this.stats.loading.start) {
      throw new Error('Loader can only be used once.');
    }
    this.stats.loading.start = self.performance.now();
    this.context = context;
    this.config = config;
    this.callbacks = callbacks;
    this.loadInternal();
  }
  loadInternal() {
    const {
      config,
      context
    } = this;
    if (!config || !context) {
      return;
    }
    const xhr = this.loader = new self.XMLHttpRequest();
    const stats = this.stats;
    stats.loading.first = 0;
    stats.loaded = 0;
    stats.aborted = false;
    const xhrSetup = this.xhrSetup;
    if (xhrSetup) {
      Promise.resolve().then(() => {
        if (this.loader !== xhr || this.stats.aborted) return;
        return xhrSetup(xhr, context.url);
      }).catch(error => {
        if (this.loader !== xhr || this.stats.aborted) return;
        xhr.open('GET', context.url, true);
        return xhrSetup(xhr, context.url);
      }).then(() => {
        if (this.loader !== xhr || this.stats.aborted) return;
        this.openAndSendXhr(xhr, context, config);
      }).catch(error => {
        // IE11 throws an exception on xhr.open if attempting to access an HTTP resource over HTTPS
        this.callbacks.onError({
          code: xhr.status,
          text: error.message
        }, context, xhr, stats);
        return;
      });
    } else {
      this.openAndSendXhr(xhr, context, config);
    }
  }
  openAndSendXhr(xhr, context, config) {
    if (!xhr.readyState) {
      xhr.open('GET', context.url, true);
    }
    const headers = context.headers;
    const {
      maxTimeToFirstByteMs,
      maxLoadTimeMs
    } = config.loadPolicy;
    if (headers) {
      for (const header in headers) {
        xhr.setRequestHeader(header, headers[header]);
      }
    }
    if (context.rangeEnd) {
      xhr.setRequestHeader('Range', 'bytes=' + context.rangeStart + '-' + (context.rangeEnd - 1));
    }
    xhr.onreadystatechange = this.readystatechange.bind(this);
    xhr.onprogress = this.loadprogress.bind(this);
    xhr.responseType = context.responseType;
    // setup timeout before we perform request
    self.clearTimeout(this.requestTimeout);
    config.timeout = maxTimeToFirstByteMs && isFiniteNumber(maxTimeToFirstByteMs) ? maxTimeToFirstByteMs : maxLoadTimeMs;
    this.requestTimeout = self.setTimeout(this.loadtimeout.bind(this), config.timeout);
    xhr.send();
  }
  readystatechange() {
    const {
      context,
      loader: xhr,
      stats
    } = this;
    if (!context || !xhr) {
      return;
    }
    const readyState = xhr.readyState;
    const config = this.config;

    // don't proceed if xhr has been aborted
    if (stats.aborted) {
      return;
    }

    // >= HEADERS_RECEIVED
    if (readyState >= 2) {
      if (stats.loading.first === 0) {
        stats.loading.first = Math.max(self.performance.now(), stats.loading.start);
        // readyState >= 2 AND readyState !==4 (readyState = HEADERS_RECEIVED || LOADING) rearm timeout as xhr not finished yet
        if (config.timeout !== config.loadPolicy.maxLoadTimeMs) {
          self.clearTimeout(this.requestTimeout);
          config.timeout = config.loadPolicy.maxLoadTimeMs;
          this.requestTimeout = self.setTimeout(this.loadtimeout.bind(this), config.loadPolicy.maxLoadTimeMs - (stats.loading.first - stats.loading.start));
        }
      }
      if (readyState === 4) {
        self.clearTimeout(this.requestTimeout);
        xhr.onreadystatechange = null;
        xhr.onprogress = null;
        const status = xhr.status;
        // http status between 200 to 299 are all successful
        const useResponse = xhr.responseType !== 'text';
        if (status >= 200 && status < 300 && (useResponse && xhr.response || xhr.responseText !== null)) {
          stats.loading.end = Math.max(self.performance.now(), stats.loading.first);
          const data = useResponse ? xhr.response : xhr.responseText;
          const len = xhr.responseType === 'arraybuffer' ? data.byteLength : data.length;
          stats.loaded = stats.total = len;
          stats.bwEstimate = stats.total * 8000 / (stats.loading.end - stats.loading.first);
          if (!this.callbacks) {
            return;
          }
          const onProgress = this.callbacks.onProgress;
          if (onProgress) {
            onProgress(stats, context, data, xhr);
          }
          if (!this.callbacks) {
            return;
          }
          const response = {
            url: xhr.responseURL,
            data: data,
            code: status
          };
          this.callbacks.onSuccess(response, stats, context, xhr);
        } else {
          const retryConfig = config.loadPolicy.errorRetry;
          const retryCount = stats.retry;
          // if max nb of retries reached or if http status between 400 and 499 (such error cannot be recovered, retrying is useless), return error
          const response = {
            url: context.url,
            data: undefined,
            code: status
          };
          if (shouldRetry(retryConfig, retryCount, false, response)) {
            this.retry(retryConfig);
          } else {
            logger.error(`${status} while loading ${context.url}`);
            this.callbacks.onError({
              code: status,
              text: xhr.statusText
            }, context, xhr, stats);
          }
        }
      }
    }
  }
  loadtimeout() {
    if (!this.config) return;
    const retryConfig = this.config.loadPolicy.timeoutRetry;
    const retryCount = this.stats.retry;
    if (shouldRetry(retryConfig, retryCount, true)) {
      this.retry(retryConfig);
    } else {
      var _this$context;
      logger.warn(`timeout while loading ${(_this$context = this.context) == null ? void 0 : _this$context.url}`);
      const callbacks = this.callbacks;
      if (callbacks) {
        this.abortInternal();
        callbacks.onTimeout(this.stats, this.context, this.loader);
      }
    }
  }
  retry(retryConfig) {
    const {
      context,
      stats
    } = this;
    this.retryDelay = getRetryDelay(retryConfig, stats.retry);
    stats.retry++;
    logger.warn(`${status ? 'HTTP Status ' + status : 'Timeout'} while loading ${context == null ? void 0 : context.url}, retrying ${stats.retry}/${retryConfig.maxNumRetry} in ${this.retryDelay}ms`);
    // abort and reset internal state
    this.abortInternal();
    this.loader = null;
    // schedule retry
    self.clearTimeout(this.retryTimeout);
    this.retryTimeout = self.setTimeout(this.loadInternal.bind(this), this.retryDelay);
  }
  loadprogress(event) {
    const stats = this.stats;
    stats.loaded = event.loaded;
    if (event.lengthComputable) {
      stats.total = event.total;
    }
  }
  getCacheAge() {
    let result = null;
    if (this.loader && AGE_HEADER_LINE_REGEX.test(this.loader.getAllResponseHeaders())) {
      const ageHeader = this.loader.getResponseHeader('age');
      result = ageHeader ? parseFloat(ageHeader) : null;
    }
    return result;
  }
  getResponseHeader(name) {
    if (this.loader && new RegExp(`^${name}:\\s*[\\d.]+\\s*$`, 'im').test(this.loader.getAllResponseHeaders())) {
      return this.loader.getResponseHeader(name);
    }
    return null;
  }
}

function fetchSupported() {
  if (
  // @ts-ignore
  self.fetch && self.AbortController && self.ReadableStream && self.Request) {
    try {
      new self.ReadableStream({}); // eslint-disable-line no-new
      return true;
    } catch (e) {
      /* noop */
    }
  }
  return false;
}
const BYTERANGE = /(\d+)-(\d+)\/(\d+)/;
class FetchLoader {
  constructor(config /* HlsConfig */) {
    this.fetchSetup = void 0;
    this.requestTimeout = void 0;
    this.request = null;
    this.response = null;
    this.controller = void 0;
    this.context = null;
    this.config = null;
    this.callbacks = null;
    this.stats = void 0;
    this.loader = null;
    this.fetchSetup = config.fetchSetup || getRequest;
    this.controller = new self.AbortController();
    this.stats = new LoadStats();
  }
  destroy() {
    this.loader = this.callbacks = this.context = this.config = this.request = null;
    this.abortInternal();
    this.response = null;
    // @ts-ignore
    this.fetchSetup = this.controller = this.stats = null;
  }
  abortInternal() {
    if (this.controller && !this.stats.loading.end) {
      this.stats.aborted = true;
      this.controller.abort();
    }
  }
  abort() {
    var _this$callbacks;
    this.abortInternal();
    if ((_this$callbacks = this.callbacks) != null && _this$callbacks.onAbort) {
      this.callbacks.onAbort(this.stats, this.context, this.response);
    }
  }
  load(context, config, callbacks) {
    const stats = this.stats;
    if (stats.loading.start) {
      throw new Error('Loader can only be used once.');
    }
    stats.loading.start = self.performance.now();
    const initParams = getRequestParameters(context, this.controller.signal);
    const onProgress = callbacks.onProgress;
    const isArrayBuffer = context.responseType === 'arraybuffer';
    const LENGTH = isArrayBuffer ? 'byteLength' : 'length';
    const {
      maxTimeToFirstByteMs,
      maxLoadTimeMs
    } = config.loadPolicy;
    this.context = context;
    this.config = config;
    this.callbacks = callbacks;
    this.request = this.fetchSetup(context, initParams);
    self.clearTimeout(this.requestTimeout);
    config.timeout = maxTimeToFirstByteMs && isFiniteNumber(maxTimeToFirstByteMs) ? maxTimeToFirstByteMs : maxLoadTimeMs;
    this.requestTimeout = self.setTimeout(() => {
      this.abortInternal();
      callbacks.onTimeout(stats, context, this.response);
    }, config.timeout);
    self.fetch(this.request).then(response => {
      this.response = this.loader = response;
      const first = Math.max(self.performance.now(), stats.loading.start);
      self.clearTimeout(this.requestTimeout);
      config.timeout = maxLoadTimeMs;
      this.requestTimeout = self.setTimeout(() => {
        this.abortInternal();
        callbacks.onTimeout(stats, context, this.response);
      }, maxLoadTimeMs - (first - stats.loading.start));
      if (!response.ok) {
        const {
          status,
          statusText
        } = response;
        throw new FetchError(statusText || 'fetch, bad network response', status, response);
      }
      stats.loading.first = first;
      stats.total = getContentLength(response.headers) || stats.total;
      if (onProgress && isFiniteNumber(config.highWaterMark)) {
        return this.loadProgressively(response, stats, context, config.highWaterMark, onProgress);
      }
      if (isArrayBuffer) {
        return response.arrayBuffer();
      }
      if (context.responseType === 'json') {
        return response.json();
      }
      return response.text();
    }).then(responseData => {
      const response = this.response;
      if (!response) {
        throw new Error('loader destroyed');
      }
      self.clearTimeout(this.requestTimeout);
      stats.loading.end = Math.max(self.performance.now(), stats.loading.first);
      const total = responseData[LENGTH];
      if (total) {
        stats.loaded = stats.total = total;
      }
      const loaderResponse = {
        url: response.url,
        data: responseData,
        code: response.status
      };
      if (onProgress && !isFiniteNumber(config.highWaterMark)) {
        onProgress(stats, context, responseData, response);
      }
      callbacks.onSuccess(loaderResponse, stats, context, response);
    }).catch(error => {
      self.clearTimeout(this.requestTimeout);
      if (stats.aborted) {
        return;
      }
      // CORS errors result in an undefined code. Set it to 0 here to align with XHR's behavior
      // when destroying, 'error' itself can be undefined
      const code = !error ? 0 : error.code || 0;
      const text = !error ? null : error.message;
      callbacks.onError({
        code,
        text
      }, context, error ? error.details : null, stats);
    });
  }
  getCacheAge() {
    let result = null;
    if (this.response) {
      const ageHeader = this.response.headers.get('age');
      result = ageHeader ? parseFloat(ageHeader) : null;
    }
    return result;
  }
  getResponseHeader(name) {
    return this.response ? this.response.headers.get(name) : null;
  }
  loadProgressively(response, stats, context, highWaterMark = 0, onProgress) {
    const chunkCache = new ChunkCache();
    const reader = response.body.getReader();
    const pump = () => {
      return reader.read().then(data => {
        if (data.done) {
          if (chunkCache.dataLength) {
            onProgress(stats, context, chunkCache.flush(), response);
          }
          return Promise.resolve(new ArrayBuffer(0));
        }
        const chunk = data.value;
        const len = chunk.length;
        stats.loaded += len;
        if (len < highWaterMark || chunkCache.dataLength) {
          // The current chunk is too small to to be emitted or the cache already has data
          // Push it to the cache
          chunkCache.push(chunk);
          if (chunkCache.dataLength >= highWaterMark) {
            // flush in order to join the typed arrays
            onProgress(stats, context, chunkCache.flush(), response);
          }
        } else {
          // If there's nothing cached already, and the chache is large enough
          // just emit the progress event
          onProgress(stats, context, chunk, response);
        }
        return pump();
      }).catch(() => {
        /* aborted */
        return Promise.reject();
      });
    };
    return pump();
  }
}
function getRequestParameters(context, signal) {
  const initParams = {
    method: 'GET',
    mode: 'cors',
    credentials: 'same-origin',
    signal,
    headers: new self.Headers(_extends({}, context.headers))
  };
  if (context.rangeEnd) {
    initParams.headers.set('Range', 'bytes=' + context.rangeStart + '-' + String(context.rangeEnd - 1));
  }
  return initParams;
}
function getByteRangeLength(byteRangeHeader) {
  const result = BYTERANGE.exec(byteRangeHeader);
  if (result) {
    return parseInt(result[2]) - parseInt(result[1]) + 1;
  }
}
function getContentLength(headers) {
  const contentRange = headers.get('Content-Range');
  if (contentRange) {
    const byteRangeLength = getByteRangeLength(contentRange);
    if (isFiniteNumber(byteRangeLength)) {
      return byteRangeLength;
    }
  }
  const contentLength = headers.get('Content-Length');
  if (contentLength) {
    return parseInt(contentLength);
  }
}
function getRequest(context, initParams) {
  return new self.Request(context.url, initParams);
}
class FetchError extends Error {
  constructor(message, code, details) {
    super(message);
    this.code = void 0;
    this.details = void 0;
    this.code = code;
    this.details = details;
  }
}

const WHITESPACE_CHAR = /\s/;
const Cues = {
  newCue(track, startTime, endTime, captionScreen) {
    const result = [];
    let row;
    // the type data states this is VTTCue, but it can potentially be a TextTrackCue on old browsers
    let cue;
    let indenting;
    let indent;
    let text;
    const Cue = self.VTTCue || self.TextTrackCue;
    for (let r = 0; r < captionScreen.rows.length; r++) {
      row = captionScreen.rows[r];
      indenting = true;
      indent = 0;
      text = '';
      if (!row.isEmpty()) {
        var _track$cues;
        for (let c = 0; c < row.chars.length; c++) {
          if (WHITESPACE_CHAR.test(row.chars[c].uchar) && indenting) {
            indent++;
          } else {
            text += row.chars[c].uchar;
            indenting = false;
          }
        }
        // To be used for cleaning-up orphaned roll-up captions
        row.cueStartTime = startTime;

        // Give a slight bump to the endTime if it's equal to startTime to avoid a SyntaxError in IE
        if (startTime === endTime) {
          endTime += 0.0001;
        }
        if (indent >= 16) {
          indent--;
        } else {
          indent++;
        }
        const cueText = fixLineBreaks(text.trim());
        const id = generateCueId(startTime, endTime, cueText);

        // If this cue already exists in the track do not push it
        if (!(track != null && (_track$cues = track.cues) != null && _track$cues.getCueById(id))) {
          cue = new Cue(startTime, endTime, cueText);
          cue.id = id;
          cue.line = r + 1;
          cue.align = 'left';
          // Clamp the position between 10 and 80 percent (CEA-608 PAC indent code)
          // https://dvcs.w3.org/hg/text-tracks/raw-file/default/608toVTT/608toVTT.html#positioning-in-cea-608
          // Firefox throws an exception and captions break with out of bounds 0-100 values
          cue.position = 10 + Math.min(80, Math.floor(indent * 8 / 32) * 10);
          result.push(cue);
        }
      }
    }
    if (track && result.length) {
      // Sort bottom cues in reverse order so that they render in line order when overlapping in Chrome
      result.sort((cueA, cueB) => {
        if (cueA.line === 'auto' || cueB.line === 'auto') {
          return 0;
        }
        if (cueA.line > 8 && cueB.line > 8) {
          return cueB.line - cueA.line;
        }
        return cueA.line - cueB.line;
      });
      result.forEach(cue => addCueToTrack(track, cue));
    }
    return result;
  }
};

/**
 * @deprecated use fragLoadPolicy.default
 */

/**
 * @deprecated use manifestLoadPolicy.default and playlistLoadPolicy.default
 */

const defaultLoadPolicy = {
  maxTimeToFirstByteMs: 8000,
  maxLoadTimeMs: 20000,
  timeoutRetry: null,
  errorRetry: null
};

/**
 * @ignore
 * If possible, keep hlsDefaultConfig shallow
 * It is cloned whenever a new Hls instance is created, by keeping the config
 * shallow the properties are cloned, and we don't end up manipulating the default
 */
const hlsDefaultConfig = _objectSpread2(_objectSpread2({
  autoStartLoad: true,
  // used by stream-controller
  startPosition: -1,
  // used by stream-controller
  defaultAudioCodec: undefined,
  // used by stream-controller
  debug: false,
  // used by logger
  capLevelOnFPSDrop: false,
  // used by fps-controller
  capLevelToPlayerSize: false,
  // used by cap-level-controller
  ignoreDevicePixelRatio: false,
  // used by cap-level-controller
  preferManagedMediaSource: true,
  initialLiveManifestSize: 1,
  // used by stream-controller
  maxBufferLength: 30,
  // used by stream-controller
  backBufferLength: Infinity,
  // used by buffer-controller
  frontBufferFlushThreshold: Infinity,
  maxBufferSize: 60 * 1000 * 1000,
  // used by stream-controller
  maxBufferHole: 0.1,
  // used by stream-controller
  highBufferWatchdogPeriod: 2,
  // used by stream-controller
  nudgeOffset: 0.1,
  // used by stream-controller
  nudgeMaxRetry: 3,
  // used by stream-controller
  maxFragLookUpTolerance: 0.25,
  // used by stream-controller
  liveSyncDurationCount: 3,
  // used by latency-controller
  liveMaxLatencyDurationCount: Infinity,
  // used by latency-controller
  liveSyncDuration: undefined,
  // used by latency-controller
  liveMaxLatencyDuration: undefined,
  // used by latency-controller
  maxLiveSyncPlaybackRate: 1,
  // used by latency-controller
  liveDurationInfinity: false,
  // used by buffer-controller
  /**
   * @deprecated use backBufferLength
   */
  liveBackBufferLength: null,
  // used by buffer-controller
  maxMaxBufferLength: 600,
  // used by stream-controller
  enableWorker: true,
  // used by transmuxer
  workerPath: null,
  // used by transmuxer
  enableSoftwareAES: true,
  // used by decrypter
  startLevel: undefined,
  // used by level-controller
  startFragPrefetch: false,
  // used by stream-controller
  fpsDroppedMonitoringPeriod: 5000,
  // used by fps-controller
  fpsDroppedMonitoringThreshold: 0.2,
  // used by fps-controller
  appendErrorMaxRetry: 3,
  // used by buffer-controller
  loader: XhrLoader,
  // loader: FetchLoader,
  fLoader: undefined,
  // used by fragment-loader
  pLoader: undefined,
  // used by playlist-loader
  xhrSetup: undefined,
  // used by xhr-loader
  licenseXhrSetup: undefined,
  // used by eme-controller
  licenseResponseCallback: undefined,
  // used by eme-controller
  abrController: AbrController,
  bufferController: BufferController,
  capLevelController: CapLevelController,
  errorController: ErrorController,
  fpsController: FPSController,
  stretchShortVideoTrack: false,
  // used by mp4-remuxer
  maxAudioFramesDrift: 1,
  // used by mp4-remuxer
  forceKeyFrameOnDiscontinuity: true,
  // used by ts-demuxer
  abrEwmaFastLive: 3,
  // used by abr-controller
  abrEwmaSlowLive: 9,
  // used by abr-controller
  abrEwmaFastVoD: 3,
  // used by abr-controller
  abrEwmaSlowVoD: 9,
  // used by abr-controller
  abrEwmaDefaultEstimate: 5e5,
  // 500 kbps  // used by abr-controller
  abrEwmaDefaultEstimateMax: 5e6,
  // 5 mbps
  abrBandWidthFactor: 0.95,
  // used by abr-controller
  abrBandWidthUpFactor: 0.7,
  // used by abr-controller
  abrMaxWithRealBitrate: false,
  // used by abr-controller
  maxStarvationDelay: 4,
  // used by abr-controller
  maxLoadingDelay: 4,
  // used by abr-controller
  minAutoBitrate: 0,
  // used by hls
  emeEnabled: false,
  // used by eme-controller
  widevineLicenseUrl: undefined,
  // used by eme-controller
  drmSystems: {},
  // used by eme-controller
  drmSystemOptions: {},
  // used by eme-controller
  requestMediaKeySystemAccessFunc: requestMediaKeySystemAccess ,
  // used by eme-controller
  testBandwidth: true,
  progressive: false,
  lowLatencyMode: true,
  cmcd: undefined,
  enableDateRangeMetadataCues: true,
  enableEmsgMetadataCues: true,
  enableID3MetadataCues: true,
  useMediaCapabilities: true,
  certLoadPolicy: {
    default: defaultLoadPolicy
  },
  keyLoadPolicy: {
    default: {
      maxTimeToFirstByteMs: 8000,
      maxLoadTimeMs: 20000,
      timeoutRetry: {
        maxNumRetry: 1,
        retryDelayMs: 1000,
        maxRetryDelayMs: 20000,
        backoff: 'linear'
      },
      errorRetry: {
        maxNumRetry: 8,
        retryDelayMs: 1000,
        maxRetryDelayMs: 20000,
        backoff: 'linear'
      }
    }
  },
  manifestLoadPolicy: {
    default: {
      maxTimeToFirstByteMs: Infinity,
      maxLoadTimeMs: 20000,
      timeoutRetry: {
        maxNumRetry: 2,
        retryDelayMs: 0,
        maxRetryDelayMs: 0
      },
      errorRetry: {
        maxNumRetry: 1,
        retryDelayMs: 1000,
        maxRetryDelayMs: 8000
      }
    }
  },
  playlistLoadPolicy: {
    default: {
      maxTimeToFirstByteMs: 10000,
      maxLoadTimeMs: 20000,
      timeoutRetry: {
        maxNumRetry: 2,
        retryDelayMs: 0,
        maxRetryDelayMs: 0
      },
      errorRetry: {
        maxNumRetry: 2,
        retryDelayMs: 1000,
        maxRetryDelayMs: 8000
      }
    }
  },
  fragLoadPolicy: {
    default: {
      maxTimeToFirstByteMs: 10000,
      maxLoadTimeMs: 120000,
      timeoutRetry: {
        maxNumRetry: 4,
        retryDelayMs: 0,
        maxRetryDelayMs: 0
      },
      errorRetry: {
        maxNumRetry: 6,
        retryDelayMs: 1000,
        maxRetryDelayMs: 8000
      }
    }
  },
  steeringManifestLoadPolicy: {
    default: {
      maxTimeToFirstByteMs: 10000,
      maxLoadTimeMs: 20000,
      timeoutRetry: {
        maxNumRetry: 2,
        retryDelayMs: 0,
        maxRetryDelayMs: 0
      },
      errorRetry: {
        maxNumRetry: 1,
        retryDelayMs: 1000,
        maxRetryDelayMs: 8000
      }
    } 
  },
  // These default settings are deprecated in favor of the above policies
  // and are maintained for backwards compatibility
  manifestLoadingTimeOut: 10000,
  manifestLoadingMaxRetry: 1,
  manifestLoadingRetryDelay: 1000,
  manifestLoadingMaxRetryTimeout: 64000,
  levelLoadingTimeOut: 10000,
  levelLoadingMaxRetry: 4,
  levelLoadingRetryDelay: 1000,
  levelLoadingMaxRetryTimeout: 64000,
  fragLoadingTimeOut: 20000,
  fragLoadingMaxRetry: 6,
  fragLoadingRetryDelay: 1000,
  fragLoadingMaxRetryTimeout: 64000
}, timelineConfig()), {}, {
  subtitleStreamController: SubtitleStreamController ,
  subtitleTrackController: SubtitleTrackController ,
  timelineController: TimelineController ,
  audioStreamController: AudioStreamController ,
  audioTrackController: AudioTrackController ,
  emeController: EMEController ,
  cmcdController: CMCDController ,
  contentSteeringController: ContentSteeringController 
});
function timelineConfig() {
  return {
    cueHandler: Cues,
    // used by timeline-controller
    enableWebVTT: true,
    // used by timeline-controller
    enableIMSC1: true,
    // used by timeline-controller
    enableCEA708Captions: true,
    // used by timeline-controller
    captionsTextTrack1Label: 'English',
    // used by timeline-controller
    captionsTextTrack1LanguageCode: 'en',
    // used by timeline-controller
    captionsTextTrack2Label: 'Spanish',
    // used by timeline-controller
    captionsTextTrack2LanguageCode: 'es',
    // used by timeline-controller
    captionsTextTrack3Label: 'Unknown CC',
    // used by timeline-controller
    captionsTextTrack3LanguageCode: '',
    // used by timeline-controller
    captionsTextTrack4Label: 'Unknown CC',
    // used by timeline-controller
    captionsTextTrack4LanguageCode: '',
    // used by timeline-controller
    renderTextTracksNatively: true
  };
}

/**
 * @ignore
 */
function mergeConfig(defaultConfig, userConfig) {
  if ((userConfig.liveSyncDurationCount || userConfig.liveMaxLatencyDurationCount) && (userConfig.liveSyncDuration || userConfig.liveMaxLatencyDuration)) {
    throw new Error("Illegal hls.js config: don't mix up liveSyncDurationCount/liveMaxLatencyDurationCount and liveSyncDuration/liveMaxLatencyDuration");
  }
  if (userConfig.liveMaxLatencyDurationCount !== undefined && (userConfig.liveSyncDurationCount === undefined || userConfig.liveMaxLatencyDurationCount <= userConfig.liveSyncDurationCount)) {
    throw new Error('Illegal hls.js config: "liveMaxLatencyDurationCount" must be greater than "liveSyncDurationCount"');
  }
  if (userConfig.liveMaxLatencyDuration !== undefined && (userConfig.liveSyncDuration === undefined || userConfig.liveMaxLatencyDuration <= userConfig.liveSyncDuration)) {
    throw new Error('Illegal hls.js config: "liveMaxLatencyDuration" must be greater than "liveSyncDuration"');
  }
  const defaultsCopy = deepCpy(defaultConfig);

  // Backwards compatibility with deprecated config values
  const deprecatedSettingTypes = ['manifest', 'level', 'frag'];
  const deprecatedSettings = ['TimeOut', 'MaxRetry', 'RetryDelay', 'MaxRetryTimeout'];
  deprecatedSettingTypes.forEach(type => {
    const policyName = `${type === 'level' ? 'playlist' : type}LoadPolicy`;
    const policyNotSet = userConfig[policyName] === undefined;
    const report = [];
    deprecatedSettings.forEach(setting => {
      const deprecatedSetting = `${type}Loading${setting}`;
      const value = userConfig[deprecatedSetting];
      if (value !== undefined && policyNotSet) {
        report.push(deprecatedSetting);
        const settings = defaultsCopy[policyName].default;
        userConfig[policyName] = {
          default: settings
        };
        switch (setting) {
          case 'TimeOut':
            settings.maxLoadTimeMs = value;
            settings.maxTimeToFirstByteMs = value;
            break;
          case 'MaxRetry':
            settings.errorRetry.maxNumRetry = value;
            settings.timeoutRetry.maxNumRetry = value;
            break;
          case 'RetryDelay':
            settings.errorRetry.retryDelayMs = value;
            settings.timeoutRetry.retryDelayMs = value;
            break;
          case 'MaxRetryTimeout':
            settings.errorRetry.maxRetryDelayMs = value;
            settings.timeoutRetry.maxRetryDelayMs = value;
            break;
        }
      }
    });
    if (report.length) {
      logger.warn(`hls.js config: "${report.join('", "')}" setting(s) are deprecated, use "${policyName}": ${JSON.stringify(userConfig[policyName])}`);
    }
  });
  return _objectSpread2(_objectSpread2({}, defaultsCopy), userConfig);
}
function deepCpy(obj) {
  if (obj && typeof obj === 'object') {
    if (Array.isArray(obj)) {
      return obj.map(deepCpy);
    }
    return Object.keys(obj).reduce((result, key) => {
      result[key] = deepCpy(obj[key]);
      return result;
    }, {});
  }
  return obj;
}

/**
 * @ignore
 */
function enableStreamingMode(config) {
  const currentLoader = config.loader;
  if (currentLoader !== FetchLoader && currentLoader !== XhrLoader) {
    // If a developer has configured their own loader, respect that choice
    logger.log('[config]: Custom loader detected, cannot enable progressive streaming');
    config.progressive = false;
  } else {
    const canStreamProgressively = fetchSupported();
    if (canStreamProgressively) {
      config.loader = FetchLoader;
      config.progressive = true;
      config.enableSoftwareAES = true;
      logger.log('[config]: Progressive streaming enabled, using FetchLoader');
    }
  }
}

let chromeOrFirefox;
class LevelController extends BasePlaylistController {
  constructor(hls, contentSteeringController) {
    super(hls, '[level-controller]');
    this._levels = [];
    this._firstLevel = -1;
    this._maxAutoLevel = -1;
    this._startLevel = void 0;
    this.currentLevel = null;
    this.currentLevelIndex = -1;
    this.manualLevelIndex = -1;
    this.steering = void 0;
    this.onParsedComplete = void 0;
    this.steering = contentSteeringController;
    this._registerListeners();
  }
  _registerListeners() {
    const {
      hls
    } = this;
    hls.on(Events.MANIFEST_LOADING, this.onManifestLoading, this);
    hls.on(Events.MANIFEST_LOADED, this.onManifestLoaded, this);
    hls.on(Events.LEVEL_LOADED, this.onLevelLoaded, this);
    hls.on(Events.LEVELS_UPDATED, this.onLevelsUpdated, this);
    hls.on(Events.FRAG_BUFFERED, this.onFragBuffered, this);
    hls.on(Events.ERROR, this.onError, this);
  }
  _unregisterListeners() {
    const {
      hls
    } = this;
    hls.off(Events.MANIFEST_LOADING, this.onManifestLoading, this);
    hls.off(Events.MANIFEST_LOADED, this.onManifestLoaded, this);
    hls.off(Events.LEVEL_LOADED, this.onLevelLoaded, this);
    hls.off(Events.LEVELS_UPDATED, this.onLevelsUpdated, this);
    hls.off(Events.FRAG_BUFFERED, this.onFragBuffered, this);
    hls.off(Events.ERROR, this.onError, this);
  }
  destroy() {
    this._unregisterListeners();
    this.steering = null;
    this.resetLevels();
    super.destroy();
  }
  stopLoad() {
    const levels = this._levels;

    // clean up live level details to force reload them, and reset load errors
    levels.forEach(level => {
      level.loadError = 0;
      level.fragmentError = 0;
    });
    super.stopLoad();
  }
  resetLevels() {
    this._startLevel = undefined;
    this.manualLevelIndex = -1;
    this.currentLevelIndex = -1;
    this.currentLevel = null;
    this._levels = [];
    this._maxAutoLevel = -1;
  }
  onManifestLoading(event, data) {
    this.resetLevels();
  }
  onManifestLoaded(event, data) {
    const preferManagedMediaSource = this.hls.config.preferManagedMediaSource;
    const levels = [];
    const redundantSet = {};
    const generatePathwaySet = {};
    let resolutionFound = false;
    let videoCodecFound = false;
    let audioCodecFound = false;
    data.levels.forEach(levelParsed => {
      var _audioCodec, _videoCodec;
      const attributes = levelParsed.attrs;

      // erase audio codec info if browser does not support mp4a.40.34.
      // demuxer will autodetect codec and fallback to mpeg/audio
      let {
        audioCodec,
        videoCodec
      } = levelParsed;
      if (((_audioCodec = audioCodec) == null ? void 0 : _audioCodec.indexOf('mp4a.40.34')) !== -1) {
        chromeOrFirefox || (chromeOrFirefox = /chrome|firefox/i.test(navigator.userAgent));
        if (chromeOrFirefox) {
          levelParsed.audioCodec = audioCodec = undefined;
        }
      }
      if (audioCodec) {
        levelParsed.audioCodec = audioCodec = getCodecCompatibleName(audioCodec, preferManagedMediaSource);
      }
      if (((_videoCodec = videoCodec) == null ? void 0 : _videoCodec.indexOf('avc1')) === 0) {
        videoCodec = levelParsed.videoCodec = convertAVC1ToAVCOTI(videoCodec);
      }

      // only keep levels with supported audio/video codecs
      const {
        width,
        height,
        unknownCodecs
      } = levelParsed;
      resolutionFound || (resolutionFound = !!(width && height));
      videoCodecFound || (videoCodecFound = !!videoCodec);
      audioCodecFound || (audioCodecFound = !!audioCodec);
      if (unknownCodecs != null && unknownCodecs.length || audioCodec && !areCodecsMediaSourceSupported(audioCodec, 'audio', preferManagedMediaSource) || videoCodec && !areCodecsMediaSourceSupported(videoCodec, 'video', preferManagedMediaSource)) {
        return;
      }
      const {
        CODECS,
        'FRAME-RATE': FRAMERATE,
        'HDCP-LEVEL': HDCP,
        'PATHWAY-ID': PATHWAY,
        RESOLUTION,
        'VIDEO-RANGE': VIDEO_RANGE
      } = attributes;
      const contentSteeringPrefix = `${PATHWAY || '.'}-`;
      const levelKey = `${contentSteeringPrefix}${levelParsed.bitrate}-${RESOLUTION}-${FRAMERATE}-${CODECS}-${VIDEO_RANGE}-${HDCP}`;
      if (!redundantSet[levelKey]) {
        const level = new Level(levelParsed);
        redundantSet[levelKey] = level;
        generatePathwaySet[levelKey] = 1;
        levels.push(level);
      } else if (redundantSet[levelKey].uri !== levelParsed.url && !levelParsed.attrs['PATHWAY-ID']) {
        // Assign Pathway IDs to Redundant Streams (default Pathways is ".". Redundant Streams "..", "...", and so on.)
        // Content Steering controller to handles Pathway fallback on error
        const pathwayCount = generatePathwaySet[levelKey] += 1;
        levelParsed.attrs['PATHWAY-ID'] = new Array(pathwayCount + 1).join('.');
        const level = new Level(levelParsed);
        redundantSet[levelKey] = level;
        levels.push(level);
      } else {
        redundantSet[levelKey].addGroupId('audio', attributes.AUDIO);
        redundantSet[levelKey].addGroupId('text', attributes.SUBTITLES);
      }
    });
    this.filterAndSortMediaOptions(levels, data, resolutionFound, videoCodecFound, audioCodecFound);
  }
  filterAndSortMediaOptions(filteredLevels, data, resolutionFound, videoCodecFound, audioCodecFound) {
    let audioTracks = [];
    let subtitleTracks = [];
    let levels = filteredLevels;

    // remove audio-only and invalid video-range levels if we also have levels with video codecs or RESOLUTION signalled
    if ((resolutionFound || videoCodecFound) && audioCodecFound) {
      levels = levels.filter(({
        videoCodec,
        videoRange,
        width,
        height
      }) => (!!videoCodec || !!(width && height)) && isVideoRange(videoRange));
    }
    if (levels.length === 0) {
      // Dispatch error after MANIFEST_LOADED is done propagating
      Promise.resolve().then(() => {
        if (this.hls) {
          if (data.levels.length) {
            this.warn(`One or more CODECS in variant not supported: ${JSON.stringify(data.levels[0].attrs)}`);
          }
          const error = new Error('no level with compatible codecs found in manifest');
          this.hls.trigger(Events.ERROR, {
            type: ErrorTypes.MEDIA_ERROR,
            details: ErrorDetails.MANIFEST_INCOMPATIBLE_CODECS_ERROR,
            fatal: true,
            url: data.url,
            error,
            reason: error.message
          });
        }
      });
      return;
    }
    if (data.audioTracks) {
      const {
        preferManagedMediaSource
      } = this.hls.config;
      audioTracks = data.audioTracks.filter(track => !track.audioCodec || areCodecsMediaSourceSupported(track.audioCodec, 'audio', preferManagedMediaSource));
      // Assign ids after filtering as array indices by group-id
      assignTrackIdsByGroup(audioTracks);
    }
    if (data.subtitles) {
      subtitleTracks = data.subtitles;
      assignTrackIdsByGroup(subtitleTracks);
    }
    // start bitrate is the first bitrate of the manifest
    const unsortedLevels = levels.slice(0);
    // sort levels from lowest to highest
    levels.sort((a, b) => {
      if (a.attrs['HDCP-LEVEL'] !== b.attrs['HDCP-LEVEL']) {
        return (a.attrs['HDCP-LEVEL'] || '') > (b.attrs['HDCP-LEVEL'] || '') ? 1 : -1;
      }
      // sort on height before bitrate for cap-level-controller
      if (resolutionFound && a.height !== b.height) {
        return a.height - b.height;
      }
      if (a.frameRate !== b.frameRate) {
        return a.frameRate - b.frameRate;
      }
      if (a.videoRange !== b.videoRange) {
        return VideoRangeValues.indexOf(a.videoRange) - VideoRangeValues.indexOf(b.videoRange);
      }
      if (a.videoCodec !== b.videoCodec) {
        const valueA = videoCodecPreferenceValue(a.videoCodec);
        const valueB = videoCodecPreferenceValue(b.videoCodec);
        if (valueA !== valueB) {
          return valueB - valueA;
        }
      }
      if (a.uri === b.uri && a.codecSet !== b.codecSet) {
        const valueA = codecsSetSelectionPreferenceValue(a.codecSet);
        const valueB = codecsSetSelectionPreferenceValue(b.codecSet);
        if (valueA !== valueB) {
          return valueB - valueA;
        }
      }
      if (a.averageBitrate !== b.averageBitrate) {
        return a.averageBitrate - b.averageBitrate;
      }
      return 0;
    });
    let firstLevelInPlaylist = unsortedLevels[0];
    if (this.steering) {
      levels = this.steering.filterParsedLevels(levels);
      if (levels.length !== unsortedLevels.length) {
        for (let i = 0; i < unsortedLevels.length; i++) {
          if (unsortedLevels[i].pathwayId === levels[0].pathwayId) {
            firstLevelInPlaylist = unsortedLevels[i];
            break;
          }
        }
      }
    }
    this._levels = levels;

    // find index of first level in sorted levels
    for (let i = 0; i < levels.length; i++) {
      if (levels[i] === firstLevelInPlaylist) {
        var _this$hls$userConfig;
        this._firstLevel = i;
        const firstLevelBitrate = firstLevelInPlaylist.bitrate;
        const bandwidthEstimate = this.hls.bandwidthEstimate;
        this.log(`manifest loaded, ${levels.length} level(s) found, first bitrate: ${firstLevelBitrate}`);
        // Update default bwe to first variant bitrate as long it has not been configured or set
        if (((_this$hls$userConfig = this.hls.userConfig) == null ? void 0 : _this$hls$userConfig.abrEwmaDefaultEstimate) === undefined) {
          const startingBwEstimate = Math.min(firstLevelBitrate, this.hls.config.abrEwmaDefaultEstimateMax);
          if (startingBwEstimate > bandwidthEstimate && bandwidthEstimate === hlsDefaultConfig.abrEwmaDefaultEstimate) {
            this.hls.bandwidthEstimate = startingBwEstimate;
          }
        }
        break;
      }
    }

    // Audio is only alternate if manifest include a URI along with the audio group tag,
    // and this is not an audio-only stream where levels contain audio-only
    const audioOnly = audioCodecFound && !videoCodecFound;
    const edata = {
      levels,
      audioTracks,
      subtitleTracks,
      sessionData: data.sessionData,
      sessionKeys: data.sessionKeys,
      firstLevel: this._firstLevel,
      stats: data.stats,
      audio: audioCodecFound,
      video: videoCodecFound,
      altAudio: !audioOnly && audioTracks.some(t => !!t.url)
    };
    this.hls.trigger(Events.MANIFEST_PARSED, edata);

    // Initiate loading after all controllers have received MANIFEST_PARSED
    if (this.hls.config.autoStartLoad || this.hls.forceStartLoad) {
      this.hls.startLoad(this.hls.config.startPosition);
    }
  }
  get levels() {
    if (this._levels.length === 0) {
      return null;
    }
    return this._levels;
  }
  get level() {
    return this.currentLevelIndex;
  }
  set level(newLevel) {
    const levels = this._levels;
    if (levels.length === 0) {
      return;
    }
    // check if level idx is valid
    if (newLevel < 0 || newLevel >= levels.length) {
      // invalid level id given, trigger error
      const error = new Error('invalid level idx');
      const fatal = newLevel < 0;
      this.hls.trigger(Events.ERROR, {
        type: ErrorTypes.OTHER_ERROR,
        details: ErrorDetails.LEVEL_SWITCH_ERROR,
        level: newLevel,
        fatal,
        error,
        reason: error.message
      });
      if (fatal) {
        return;
      }
      newLevel = Math.min(newLevel, levels.length - 1);
    }
    const lastLevelIndex = this.currentLevelIndex;
    const lastLevel = this.currentLevel;
    const lastPathwayId = lastLevel ? lastLevel.attrs['PATHWAY-ID'] : undefined;
    const level = levels[newLevel];
    const pathwayId = level.attrs['PATHWAY-ID'];
    this.currentLevelIndex = newLevel;
    this.currentLevel = level;
    if (lastLevelIndex === newLevel && level.details && lastLevel && lastPathwayId === pathwayId) {
      return;
    }
    this.log(`Switching to level ${newLevel} (${level.height ? level.height + 'p ' : ''}${level.videoRange ? level.videoRange + ' ' : ''}${level.codecSet ? level.codecSet + ' ' : ''}@${level.bitrate})${pathwayId ? ' with Pathway ' + pathwayId : ''} from level ${lastLevelIndex}${lastPathwayId ? ' with Pathway ' + lastPathwayId : ''}`);
    const levelSwitchingData = {
      level: newLevel,
      attrs: level.attrs,
      details: level.details,
      bitrate: level.bitrate,
      averageBitrate: level.averageBitrate,
      maxBitrate: level.maxBitrate,
      realBitrate: level.realBitrate,
      width: level.width,
      height: level.height,
      codecSet: level.codecSet,
      audioCodec: level.audioCodec,
      videoCodec: level.videoCodec,
      audioGroups: level.audioGroups,
      subtitleGroups: level.subtitleGroups,
      loaded: level.loaded,
      loadError: level.loadError,
      fragmentError: level.fragmentError,
      name: level.name,
      id: level.id,
      uri: level.uri,
      url: level.url,
      urlId: 0,
      audioGroupIds: level.audioGroupIds,
      textGroupIds: level.textGroupIds
    };
    this.hls.trigger(Events.LEVEL_SWITCHING, levelSwitchingData);
    // check if we need to load playlist for this level
    const levelDetails = level.details;
    if (!levelDetails || levelDetails.live) {
      // level not retrieved yet, or live playlist we need to (re)load it
      const hlsUrlParameters = this.switchParams(level.uri, lastLevel == null ? void 0 : lastLevel.details, levelDetails);
      this.loadPlaylist(hlsUrlParameters);
    }
  }
  get manualLevel() {
    return this.manualLevelIndex;
  }
  set manualLevel(newLevel) {
    this.manualLevelIndex = newLevel;
    if (this._startLevel === undefined) {
      this._startLevel = newLevel;
    }
    if (newLevel !== -1) {
      this.level = newLevel;
    }
  }
  get firstLevel() {
    return this._firstLevel;
  }
  set firstLevel(newLevel) {
    this._firstLevel = newLevel;
  }
  get startLevel() {
    // Setting hls.startLevel (this._startLevel) overrides config.startLevel
    if (this._startLevel === undefined) {
      const configStartLevel = this.hls.config.startLevel;
      if (configStartLevel !== undefined) {
        return configStartLevel;
      }
      return this.hls.firstAutoLevel;
    }
    return this._startLevel;
  }
  set startLevel(newLevel) {
    this._startLevel = newLevel;
  }
  onError(event, data) {
    if (data.fatal || !data.context) {
      return;
    }
    if (data.context.type === PlaylistContextType.LEVEL && data.context.level === this.level) {
      this.checkRetry(data);
    }
  }

  // reset errors on the successful load of a fragment
  onFragBuffered(event, {
    frag
  }) {
    if (frag !== undefined && frag.type === PlaylistLevelType.MAIN) {
      const el = frag.elementaryStreams;
      if (!Object.keys(el).some(type => !!el[type])) {
        return;
      }
      const level = this._levels[frag.level];
      if (level != null && level.loadError) {
        this.log(`Resetting level error count of ${level.loadError} on frag buffered`);
        level.loadError = 0;
      }
    }
  }
  onLevelLoaded(event, data) {
    var _data$deliveryDirecti2;
    const {
      level,
      details
    } = data;
    const curLevel = this._levels[level];
    if (!curLevel) {
      var _data$deliveryDirecti;
      this.warn(`Invalid level index ${level}`);
      if ((_data$deliveryDirecti = data.deliveryDirectives) != null && _data$deliveryDirecti.skip) {
        details.deltaUpdateFailed = true;
      }
      return;
    }

    // only process level loaded events matching with expected level
    if (level === this.currentLevelIndex) {
      // reset level load error counter on successful level loaded only if there is no issues with fragments
      if (curLevel.fragmentError === 0) {
        curLevel.loadError = 0;
      }
      this.playlistLoaded(level, data, curLevel.details);
    } else if ((_data$deliveryDirecti2 = data.deliveryDirectives) != null && _data$deliveryDirecti2.skip) {
      // received a delta playlist update that cannot be merged
      details.deltaUpdateFailed = true;
    }
  }
  loadPlaylist(hlsUrlParameters) {
    super.loadPlaylist();
    const currentLevelIndex = this.currentLevelIndex;
    const currentLevel = this.currentLevel;
    if (currentLevel && this.shouldLoadPlaylist(currentLevel)) {
      let url = currentLevel.uri;
      if (hlsUrlParameters) {
        try {
          url = hlsUrlParameters.addDirectives(url);
        } catch (error) {
          this.warn(`Could not construct new URL with HLS Delivery Directives: ${error}`);
        }
      }
      const pathwayId = currentLevel.attrs['PATHWAY-ID'];
      this.log(`Loading level index ${currentLevelIndex}${(hlsUrlParameters == null ? void 0 : hlsUrlParameters.msn) !== undefined ? ' at sn ' + hlsUrlParameters.msn + ' part ' + hlsUrlParameters.part : ''} with${pathwayId ? ' Pathway ' + pathwayId : ''} ${url}`);

      // console.log('Current audio track group ID:', this.hls.audioTracks[this.hls.audioTrack].groupId);
      // console.log('New video quality level audio group id:', levelObject.attrs.AUDIO, level);
      this.clearTimer();
      this.hls.trigger(Events.LEVEL_LOADING, {
        url,
        level: currentLevelIndex,
        pathwayId: currentLevel.attrs['PATHWAY-ID'],
        id: 0,
        // Deprecated Level urlId
        deliveryDirectives: hlsUrlParameters || null
      });
    }
  }
  get nextLoadLevel() {
    if (this.manualLevelIndex !== -1) {
      return this.manualLevelIndex;
    } else {
      return this.hls.nextAutoLevel;
    }
  }
  set nextLoadLevel(nextLevel) {
    this.level = nextLevel;
    if (this.manualLevelIndex === -1) {
      this.hls.nextAutoLevel = nextLevel;
    }
  }
  removeLevel(levelIndex) {
    var _this$currentLevel;
    const levels = this._levels.filter((level, index) => {
      if (index !== levelIndex) {
        return true;
      }
      if (this.steering) {
        this.steering.removeLevel(level);
      }
      if (level === this.currentLevel) {
        this.currentLevel = null;
        this.currentLevelIndex = -1;
        if (level.details) {
          level.details.fragments.forEach(f => f.level = -1);
        }
      }
      return false;
    });
    reassignFragmentLevelIndexes(levels);
    this._levels = levels;
    if (this.currentLevelIndex > -1 && (_this$currentLevel = this.currentLevel) != null && _this$currentLevel.details) {
      this.currentLevelIndex = this.currentLevel.details.fragments[0].level;
    }
    this.hls.trigger(Events.LEVELS_UPDATED, {
      levels
    });
  }
  onLevelsUpdated(event, {
    levels
  }) {
    this._levels = levels;
  }
  checkMaxAutoUpdated() {
    const {
      autoLevelCapping,
      maxAutoLevel,
      maxHdcpLevel
    } = this.hls;
    if (this._maxAutoLevel !== maxAutoLevel) {
      this._maxAutoLevel = maxAutoLevel;
      this.hls.trigger(Events.MAX_AUTO_LEVEL_UPDATED, {
        autoLevelCapping,
        levels: this.levels,
        maxAutoLevel,
        minAutoLevel: this.hls.minAutoLevel,
        maxHdcpLevel
      });
    }
  }
}
function assignTrackIdsByGroup(tracks) {
  const groups = {};
  tracks.forEach(track => {
    const groupId = track.groupId || '';
    track.id = groups[groupId] = groups[groupId] || 0;
    groups[groupId]++;
  });
}

class KeyLoader {
  constructor(config) {
    this.config = void 0;
    this.keyUriToKeyInfo = {};
    this.emeController = null;
    this.config = config;
  }
  abort(type) {
    for (const uri in this.keyUriToKeyInfo) {
      const loader = this.keyUriToKeyInfo[uri].loader;
      if (loader) {
        var _loader$context;
        if (type && type !== ((_loader$context = loader.context) == null ? void 0 : _loader$context.frag.type)) {
          return;
        }
        loader.abort();
      }
    }
  }
  detach() {
    for (const uri in this.keyUriToKeyInfo) {
      const keyInfo = this.keyUriToKeyInfo[uri];
      // Remove cached EME keys on detach
      if (keyInfo.mediaKeySessionContext || keyInfo.decryptdata.isCommonEncryption) {
        delete this.keyUriToKeyInfo[uri];
      }
    }
  }
  destroy() {
    this.detach();
    for (const uri in this.keyUriToKeyInfo) {
      const loader = this.keyUriToKeyInfo[uri].loader;
      if (loader) {
        loader.destroy();
      }
    }
    this.keyUriToKeyInfo = {};
  }
  createKeyLoadError(frag, details = ErrorDetails.KEY_LOAD_ERROR, error, networkDetails, response) {
    return new LoadError({
      type: ErrorTypes.NETWORK_ERROR,
      details,
      fatal: false,
      frag,
      response,
      error,
      networkDetails
    });
  }
  loadClear(loadingFrag, encryptedFragments) {
    if (this.emeController && this.config.emeEnabled) {
      // access key-system with nearest key on start (loaidng frag is unencrypted)
      const {
        sn,
        cc
      } = loadingFrag;
      for (let i = 0; i < encryptedFragments.length; i++) {
        const frag = encryptedFragments[i];
        if (cc <= frag.cc && (sn === 'initSegment' || frag.sn === 'initSegment' || sn < frag.sn)) {
          this.emeController.selectKeySystemFormat(frag).then(keySystemFormat => {
            frag.setKeyFormat(keySystemFormat);
          });
          break;
        }
      }
    }
  }
  load(frag) {
    if (!frag.decryptdata && frag.encrypted && this.emeController) {
      // Multiple keys, but none selected, resolve in eme-controller
      return this.emeController.selectKeySystemFormat(frag).then(keySystemFormat => {
        return this.loadInternal(frag, keySystemFormat);
      });
    }
    return this.loadInternal(frag);
  }
  loadInternal(frag, keySystemFormat) {
    var _keyInfo, _keyInfo2;
    if (keySystemFormat) {
      frag.setKeyFormat(keySystemFormat);
    }
    const decryptdata = frag.decryptdata;
    if (!decryptdata) {
      const error = new Error(keySystemFormat ? `Expected frag.decryptdata to be defined after setting format ${keySystemFormat}` : 'Missing decryption data on fragment in onKeyLoading');
      return Promise.reject(this.createKeyLoadError(frag, ErrorDetails.KEY_LOAD_ERROR, error));
    }
    const uri = decryptdata.uri;
    if (!uri) {
      return Promise.reject(this.createKeyLoadError(frag, ErrorDetails.KEY_LOAD_ERROR, new Error(`Invalid key URI: "${uri}"`)));
    }
    let keyInfo = this.keyUriToKeyInfo[uri];
    if ((_keyInfo = keyInfo) != null && _keyInfo.decryptdata.key) {
      decryptdata.key = keyInfo.decryptdata.key;
      return Promise.resolve({
        frag,
        keyInfo
      });
    }
    // Return key load promise as long as it does not have a mediakey session with an unusable key status
    if ((_keyInfo2 = keyInfo) != null && _keyInfo2.keyLoadPromise) {
      var _keyInfo$mediaKeySess;
      switch ((_keyInfo$mediaKeySess = keyInfo.mediaKeySessionContext) == null ? void 0 : _keyInfo$mediaKeySess.keyStatus) {
        case undefined:
        case 'status-pending':
        case 'usable':
        case 'usable-in-future':
          return keyInfo.keyLoadPromise.then(keyLoadedData => {
            // Return the correct fragment with updated decryptdata key and loaded keyInfo
            decryptdata.key = keyLoadedData.keyInfo.decryptdata.key;
            return {
              frag,
              keyInfo
            };
          });
      }
      // If we have a key session and status and it is not pending or usable, continue
      // This will go back to the eme-controller for expired keys to get a new keyLoadPromise
    }

    // Load the key or return the loading promise
    keyInfo = this.keyUriToKeyInfo[uri] = {
      decryptdata,
      keyLoadPromise: null,
      loader: null,
      mediaKeySessionContext: null
    };
    switch (decryptdata.method) {
      case 'ISO-23001-7':
      case 'SAMPLE-AES':
      case 'SAMPLE-AES-CENC':
      case 'SAMPLE-AES-CTR':
        if (decryptdata.keyFormat === 'identity') {
          // loadKeyHTTP handles http(s) and data URLs
          return this.loadKeyHTTP(keyInfo, frag);
        }
        return this.loadKeyEME(keyInfo, frag);
      case 'AES-128':
        return this.loadKeyHTTP(keyInfo, frag);
      default:
        return Promise.reject(this.createKeyLoadError(frag, ErrorDetails.KEY_LOAD_ERROR, new Error(`Key supplied with unsupported METHOD: "${decryptdata.method}"`)));
    }
  }
  loadKeyEME(keyInfo, frag) {
    const keyLoadedData = {
      frag,
      keyInfo
    };
    if (this.emeController && this.config.emeEnabled) {
      const keySessionContextPromise = this.emeController.loadKey(keyLoadedData);
      if (keySessionContextPromise) {
        return (keyInfo.keyLoadPromise = keySessionContextPromise.then(keySessionContext => {
          keyInfo.mediaKeySessionContext = keySessionContext;
          return keyLoadedData;
        })).catch(error => {
          // Remove promise for license renewal or retry
          keyInfo.keyLoadPromise = null;
          throw error;
        });
      }
    }
    return Promise.resolve(keyLoadedData);
  }
  loadKeyHTTP(keyInfo, frag) {
    const config = this.config;
    const Loader = config.loader;
    const keyLoader = new Loader(config);
    frag.keyLoader = keyInfo.loader = keyLoader;
    return keyInfo.keyLoadPromise = new Promise((resolve, reject) => {
      const loaderContext = {
        keyInfo,
        frag,
        responseType: 'arraybuffer',
        url: keyInfo.decryptdata.uri
      };

      // maxRetry is 0 so that instead of retrying the same key on the same variant multiple times,
      // key-loader will trigger an error and rely on stream-controller to handle retry logic.
      // this will also align retry logic with fragment-loader
      const loadPolicy = config.keyLoadPolicy.default;
      const loaderConfig = {
        loadPolicy,
        timeout: loadPolicy.maxLoadTimeMs,
        maxRetry: 0,
        retryDelay: 0,
        maxRetryDelay: 0
      };
      const loaderCallbacks = {
        onSuccess: (response, stats, context, networkDetails) => {
          const {
            frag,
            keyInfo,
            url: uri
          } = context;
          if (!frag.decryptdata || keyInfo !== this.keyUriToKeyInfo[uri]) {
            return reject(this.createKeyLoadError(frag, ErrorDetails.KEY_LOAD_ERROR, new Error('after key load, decryptdata unset or changed'), networkDetails));
          }
          keyInfo.decryptdata.key = frag.decryptdata.key = new Uint8Array(response.data);

          // detach fragment key loader on load success
          frag.keyLoader = null;
          keyInfo.loader = null;
          resolve({
            frag,
            keyInfo
          });
        },
        onError: (response, context, networkDetails, stats) => {
          this.resetLoader(context);
          reject(this.createKeyLoadError(frag, ErrorDetails.KEY_LOAD_ERROR, new Error(`HTTP Error ${response.code} loading key ${response.text}`), networkDetails, _objectSpread2({
            url: loaderContext.url,
            data: undefined
          }, response)));
        },
        onTimeout: (stats, context, networkDetails) => {
          this.resetLoader(context);
          reject(this.createKeyLoadError(frag, ErrorDetails.KEY_LOAD_TIMEOUT, new Error('key loading timed out'), networkDetails));
        },
        onAbort: (stats, context, networkDetails) => {
          this.resetLoader(context);
          reject(this.createKeyLoadError(frag, ErrorDetails.INTERNAL_ABORTED, new Error('key loading aborted'), networkDetails));
        }
      };
      keyLoader.load(loaderContext, loaderConfig, loaderCallbacks);
    });
  }
  resetLoader(context) {
    const {
      frag,
      keyInfo,
      url: uri
    } = context;
    const loader = keyInfo.loader;
    if (frag.keyLoader === loader) {
      frag.keyLoader = null;
      keyInfo.loader = null;
    }
    delete this.keyUriToKeyInfo[uri];
    if (loader) {
      loader.destroy();
    }
  }
}

function getSourceBuffer() {
  return self.SourceBuffer || self.WebKitSourceBuffer;
}
function isMSESupported() {
  const mediaSource = getMediaSource();
  if (!mediaSource) {
    return false;
  }

  // if SourceBuffer is exposed ensure its API is valid
  // Older browsers do not expose SourceBuffer globally so checking SourceBuffer.prototype is impossible
  const sourceBuffer = getSourceBuffer();
  return !sourceBuffer || sourceBuffer.prototype && typeof sourceBuffer.prototype.appendBuffer === 'function' && typeof sourceBuffer.prototype.remove === 'function';
}
function isSupported() {
  if (!isMSESupported()) {
    return false;
  }
  const mediaSource = getMediaSource();
  return typeof (mediaSource == null ? void 0 : mediaSource.isTypeSupported) === 'function' && (['avc1.42E01E,mp4a.40.2', 'av01.0.01M.08', 'vp09.00.50.08'].some(codecsForVideoContainer => mediaSource.isTypeSupported(mimeTypeForCodec(codecsForVideoContainer, 'video'))) || ['mp4a.40.2', 'fLaC'].some(codecForAudioContainer => mediaSource.isTypeSupported(mimeTypeForCodec(codecForAudioContainer, 'audio'))));
}
function changeTypeSupported() {
  var _sourceBuffer$prototy;
  const sourceBuffer = getSourceBuffer();
  return typeof (sourceBuffer == null ? void 0 : (_sourceBuffer$prototy = sourceBuffer.prototype) == null ? void 0 : _sourceBuffer$prototy.changeType) === 'function';
}

const STALL_MINIMUM_DURATION_MS = 250;
const MAX_START_GAP_JUMP = 2.0;
const SKIP_BUFFER_HOLE_STEP_SECONDS = 0.1;
const SKIP_BUFFER_RANGE_START = 0.05;
class GapController {
  constructor(config, media, fragmentTracker, hls) {
    this.config = void 0;
    this.media = null;
    this.fragmentTracker = void 0;
    this.hls = void 0;
    this.nudgeRetry = 0;
    this.stallReported = false;
    this.stalled = null;
    this.moved = false;
    this.seeking = false;
    this.config = config;
    this.media = media;
    this.fragmentTracker = fragmentTracker;
    this.hls = hls;
  }
  destroy() {
    this.media = null;
    // @ts-ignore
    this.hls = this.fragmentTracker = null;
  }

  /**
   * Checks if the playhead is stuck within a gap, and if so, attempts to free it.
   * A gap is an unbuffered range between two buffered ranges (or the start and the first buffered range).
   *
   * @param lastCurrentTime - Previously read playhead position
   */
  poll(lastCurrentTime, activeFrag) {
    const {
      config,
      media,
      stalled
    } = this;
    if (media === null) {
      return;
    }
    const {
      currentTime,
      seeking
    } = media;
    const seeked = this.seeking && !seeking;
    const beginSeek = !this.seeking && seeking;
    this.seeking = seeking;

    // The playhead is moving, no-op
    if (currentTime !== lastCurrentTime) {
      this.moved = true;
      if (!seeking) {
        this.nudgeRetry = 0;
      }
      if (stalled !== null) {
        // The playhead is now moving, but was previously stalled
        if (this.stallReported) {
          const _stalledDuration = self.performance.now() - stalled;
          logger.warn(`playback not stuck anymore @${currentTime}, after ${Math.round(_stalledDuration)}ms`);
          this.stallReported = false;
        }
        this.stalled = null;
      }
      return;
    }

    // Clear stalled state when beginning or finishing seeking so that we don't report stalls coming out of a seek
    if (beginSeek || seeked) {
      this.stalled = null;
      return;
    }

    // The playhead should not be moving
    if (media.paused && !seeking || media.ended || media.playbackRate === 0 || !BufferHelper.getBuffered(media).length) {
      this.nudgeRetry = 0;
      return;
    }
    const bufferInfo = BufferHelper.bufferInfo(media, currentTime, 0);
    const nextStart = bufferInfo.nextStart || 0;
    if (seeking) {
      // Waiting for seeking in a buffered range to complete
      const hasEnoughBuffer = bufferInfo.len > MAX_START_GAP_JUMP;
      // Next buffered range is too far ahead to jump to while still seeking
      const noBufferGap = !nextStart || activeFrag && activeFrag.start <= currentTime || nextStart - currentTime > MAX_START_GAP_JUMP && !this.fragmentTracker.getPartialFragment(currentTime);
      if (hasEnoughBuffer || noBufferGap) {
        return;
      }
      // Reset moved state when seeking to a point in or before a gap
      this.moved = false;
    }

    // Skip start gaps if we haven't played, but the last poll detected the start of a stall
    // The addition poll gives the browser a chance to jump the gap for us
    if (!this.moved && this.stalled !== null) {
      var _level$details;
      // There is no playable buffer (seeked, waiting for buffer)
      const isBuffered = bufferInfo.len > 0;
      if (!isBuffered && !nextStart) {
        return;
      }
      // Jump start gaps within jump threshold
      const startJump = Math.max(nextStart, bufferInfo.start || 0) - currentTime;

      // When joining a live stream with audio tracks, account for live playlist window sliding by allowing
      // a larger jump over start gaps caused by the audio-stream-controller buffering a start fragment
      // that begins over 1 target duration after the video start position.
      const level = this.hls.levels ? this.hls.levels[this.hls.currentLevel] : null;
      const isLive = level == null ? void 0 : (_level$details = level.details) == null ? void 0 : _level$details.live;
      const maxStartGapJump = isLive ? level.details.targetduration * 2 : MAX_START_GAP_JUMP;
      const partialOrGap = this.fragmentTracker.getPartialFragment(currentTime);
      if (startJump > 0 && (startJump <= maxStartGapJump || partialOrGap)) {
        if (!media.paused) {
          this._trySkipBufferHole(partialOrGap);
        }
        return;
      }
    }

    // Start tracking stall time
    const tnow = self.performance.now();
    if (stalled === null) {
      this.stalled = tnow;
      return;
    }
    const stalledDuration = tnow - stalled;
    if (!seeking && stalledDuration >= STALL_MINIMUM_DURATION_MS) {
      // Report stalling after trying to fix
      this._reportStall(bufferInfo);
      if (!this.media) {
        return;
      }
    }
    const bufferedWithHoles = BufferHelper.bufferInfo(media, currentTime, config.maxBufferHole);
    this._tryFixBufferStall(bufferedWithHoles, stalledDuration);
  }

  /**
   * Detects and attempts to fix known buffer stalling issues.
   * @param bufferInfo - The properties of the current buffer.
   * @param stalledDurationMs - The amount of time Hls.js has been stalling for.
   * @private
   */
  _tryFixBufferStall(bufferInfo, stalledDurationMs) {
    const {
      config,
      fragmentTracker,
      media
    } = this;
    if (media === null) {
      return;
    }
    const currentTime = media.currentTime;
    const partial = fragmentTracker.getPartialFragment(currentTime);
    if (partial) {
      // Try to skip over the buffer hole caused by a partial fragment
      // This method isn't limited by the size of the gap between buffered ranges
      const targetTime = this._trySkipBufferHole(partial);
      // we return here in this case, meaning
      // the branch below only executes when we haven't seeked to a new position
      if (targetTime || !this.media) {
        return;
      }
    }

    // if we haven't had to skip over a buffer hole of a partial fragment
    // we may just have to "nudge" the playlist as the browser decoding/rendering engine
    // needs to cross some sort of threshold covering all source-buffers content
    // to start playing properly.
    if ((bufferInfo.len > config.maxBufferHole || bufferInfo.nextStart && bufferInfo.nextStart - currentTime < config.maxBufferHole) && stalledDurationMs > config.highBufferWatchdogPeriod * 1000) {
      logger.warn('Trying to nudge playhead over buffer-hole');
      // Try to nudge currentTime over a buffer hole if we've been stalling for the configured amount of seconds
      // We only try to jump the hole if it's under the configured size
      // Reset stalled so to rearm watchdog timer
      this.stalled = null;
      this._tryNudgeBuffer();
    }
  }

  /**
   * Triggers a BUFFER_STALLED_ERROR event, but only once per stall period.
   * @param bufferLen - The playhead distance from the end of the current buffer segment.
   * @private
   */
  _reportStall(bufferInfo) {
    const {
      hls,
      media,
      stallReported
    } = this;
    if (!stallReported && media) {
      // Report stalled error once
      this.stallReported = true;
      const error = new Error(`Playback stalling at @${media.currentTime} due to low buffer (${JSON.stringify(bufferInfo)})`);
      logger.warn(error.message);
      hls.trigger(Events.ERROR, {
        type: ErrorTypes.MEDIA_ERROR,
        details: ErrorDetails.BUFFER_STALLED_ERROR,
        fatal: false,
        error,
        buffer: bufferInfo.len
      });
    }
  }

  /**
   * Attempts to fix buffer stalls by jumping over known gaps caused by partial fragments
   * @param partial - The partial fragment found at the current time (where playback is stalling).
   * @private
   */
  _trySkipBufferHole(partial) {
    const {
      config,
      hls,
      media
    } = this;
    if (media === null) {
      return 0;
    }

    // Check if currentTime is between unbuffered regions of partial fragments
    const currentTime = media.currentTime;
    const bufferInfo = BufferHelper.bufferInfo(media, currentTime, 0);
    const startTime = currentTime < bufferInfo.start ? bufferInfo.start : bufferInfo.nextStart;
    if (startTime) {
      const bufferStarved = bufferInfo.len <= config.maxBufferHole;
      const waiting = bufferInfo.len > 0 && bufferInfo.len < 1 && media.readyState < 3;
      const gapLength = startTime - currentTime;
      if (gapLength > 0 && (bufferStarved || waiting)) {
        // Only allow large gaps to be skipped if it is a start gap, or all fragments in skip range are partial
        if (gapLength > config.maxBufferHole) {
          const {
            fragmentTracker
          } = this;
          let startGap = false;
          if (currentTime === 0) {
            const startFrag = fragmentTracker.getAppendedFrag(0, PlaylistLevelType.MAIN);
            if (startFrag && startTime < startFrag.end) {
              startGap = true;
            }
          }
          if (!startGap) {
            const startProvisioned = partial || fragmentTracker.getAppendedFrag(currentTime, PlaylistLevelType.MAIN);
            if (startProvisioned) {
              let moreToLoad = false;
              let pos = startProvisioned.end;
              while (pos < startTime) {
                const provisioned = fragmentTracker.getPartialFragment(pos);
                if (provisioned) {
                  pos += provisioned.duration;
                } else {
                  moreToLoad = true;
                  break;
                }
              }
              if (moreToLoad) {
                return 0;
              }
            }
          }
        }
        const targetTime = Math.max(startTime + SKIP_BUFFER_RANGE_START, currentTime + SKIP_BUFFER_HOLE_STEP_SECONDS);
        logger.warn(`skipping hole, adjusting currentTime from ${currentTime} to ${targetTime}`);
        this.moved = true;
        this.stalled = null;
        media.currentTime = targetTime;
        if (partial && !partial.gap) {
          const error = new Error(`fragment loaded with buffer holes, seeking from ${currentTime} to ${targetTime}`);
          hls.trigger(Events.ERROR, {
            type: ErrorTypes.MEDIA_ERROR,
            details: ErrorDetails.BUFFER_SEEK_OVER_HOLE,
            fatal: false,
            error,
            reason: error.message,
            frag: partial
          });
        }
        return targetTime;
      }
    }
    return 0;
  }

  /**
   * Attempts to fix buffer stalls by advancing the mediaElement's current time by a small amount.
   * @private
   */
  _tryNudgeBuffer() {
    const {
      config,
      hls,
      media,
      nudgeRetry
    } = this;
    if (media === null) {
      return;
    }
    const currentTime = media.currentTime;
    this.nudgeRetry++;
    if (nudgeRetry < config.nudgeMaxRetry) {
      const targetTime = currentTime + (nudgeRetry + 1) * config.nudgeOffset;
      // playback stalled in buffered area ... let's nudge currentTime to try to overcome this
      const error = new Error(`Nudging 'currentTime' from ${currentTime} to ${targetTime}`);
      logger.warn(error.message);
      media.currentTime = targetTime;
      hls.trigger(Events.ERROR, {
        type: ErrorTypes.MEDIA_ERROR,
        details: ErrorDetails.BUFFER_NUDGE_ON_STALL,
        error,
        fatal: false
      });
    } else {
      const error = new Error(`Playhead still not moving while enough data buffered @${currentTime} after ${config.nudgeMaxRetry} nudges`);
      logger.error(error.message);
      hls.trigger(Events.ERROR, {
        type: ErrorTypes.MEDIA_ERROR,
        details: ErrorDetails.BUFFER_STALLED_ERROR,
        error,
        fatal: true
      });
    }
  }
}

const TICK_INTERVAL = 100; // how often to tick in ms

class StreamController extends BaseStreamController {
  constructor(hls, fragmentTracker, keyLoader) {
    super(hls, fragmentTracker, keyLoader, '[stream-controller]', PlaylistLevelType.MAIN);
    this.audioCodecSwap = false;
    this.gapController = null;
    this.level = -1;
    this._forceStartLoad = false;
    this.altAudio = false;
    this.audioOnly = false;
    this.fragPlaying = null;
    this.onvplaying = null;
    this.onvseeked = null;
    this.fragLastKbps = 0;
    this.couldBacktrack = false;
    this.backtrackFragment = null;
    this.audioCodecSwitch = false;
    this.videoBuffer = null;
    this._registerListeners();
  }
  _registerListeners() {
    const {
      hls
    } = this;
    hls.on(Events.MEDIA_ATTACHED, this.onMediaAttached, this);
    hls.on(Events.MEDIA_DETACHING, this.onMediaDetaching, this);
    hls.on(Events.MANIFEST_LOADING, this.onManifestLoading, this);
    hls.on(Events.MANIFEST_PARSED, this.onManifestParsed, this);
    hls.on(Events.LEVEL_LOADING, this.onLevelLoading, this);
    hls.on(Events.LEVEL_LOADED, this.onLevelLoaded, this);
    hls.on(Events.FRAG_LOAD_EMERGENCY_ABORTED, this.onFragLoadEmergencyAborted, this);
    hls.on(Events.ERROR, this.onError, this);
    hls.on(Events.AUDIO_TRACK_SWITCHING, this.onAudioTrackSwitching, this);
    hls.on(Events.AUDIO_TRACK_SWITCHED, this.onAudioTrackSwitched, this);
    hls.on(Events.BUFFER_CREATED, this.onBufferCreated, this);
    hls.on(Events.BUFFER_FLUSHED, this.onBufferFlushed, this);
    hls.on(Events.LEVELS_UPDATED, this.onLevelsUpdated, this);
    hls.on(Events.FRAG_BUFFERED, this.onFragBuffered, this);
  }
  _unregisterListeners() {
    const {
      hls
    } = this;
    hls.off(Events.MEDIA_ATTACHED, this.onMediaAttached, this);
    hls.off(Events.MEDIA_DETACHING, this.onMediaDetaching, this);
    hls.off(Events.MANIFEST_LOADING, this.onManifestLoading, this);
    hls.off(Events.MANIFEST_PARSED, this.onManifestParsed, this);
    hls.off(Events.LEVEL_LOADED, this.onLevelLoaded, this);
    hls.off(Events.FRAG_LOAD_EMERGENCY_ABORTED, this.onFragLoadEmergencyAborted, this);
    hls.off(Events.ERROR, this.onError, this);
    hls.off(Events.AUDIO_TRACK_SWITCHING, this.onAudioTrackSwitching, this);
    hls.off(Events.AUDIO_TRACK_SWITCHED, this.onAudioTrackSwitched, this);
    hls.off(Events.BUFFER_CREATED, this.onBufferCreated, this);
    hls.off(Events.BUFFER_FLUSHED, this.onBufferFlushed, this);
    hls.off(Events.LEVELS_UPDATED, this.onLevelsUpdated, this);
    hls.off(Events.FRAG_BUFFERED, this.onFragBuffered, this);
  }
  onHandlerDestroying() {
    this._unregisterListeners();
    super.onHandlerDestroying();
  }
  startLoad(startPosition) {
    if (this.levels) {
      const {
        lastCurrentTime,
        hls
      } = this;
      this.stopLoad();
      this.setInterval(TICK_INTERVAL);
      this.level = -1;
      if (!this.startFragRequested) {
        // determine load level
        let startLevel = hls.startLevel;
        if (startLevel === -1) {
          if (hls.config.testBandwidth && this.levels.length > 1) {
            // -1 : guess start Level by doing a bitrate test by loading first fragment of lowest quality level
            startLevel = 0;
            this.bitrateTest = true;
          } else {
            startLevel = hls.firstAutoLevel;
          }
        }
        // set new level to playlist loader : this will trigger start level load
        // hls.nextLoadLevel remains until it is set to a new value or until a new frag is successfully loaded
        hls.nextLoadLevel = startLevel;
        this.level = hls.loadLevel;
        this.loadedmetadata = false;
      }
      // if startPosition undefined but lastCurrentTime set, set startPosition to last currentTime
      if (lastCurrentTime > 0 && startPosition === -1) {
        this.log(`Override startPosition with lastCurrentTime @${lastCurrentTime.toFixed(3)}`);
        startPosition = lastCurrentTime;
      }
      this.state = State.IDLE;
      this.nextLoadPosition = this.startPosition = this.lastCurrentTime = startPosition;
      this.tick();
    } else {
      this._forceStartLoad = true;
      this.state = State.STOPPED;
    }
  }
  stopLoad() {
    this._forceStartLoad = false;
    super.stopLoad();
  }
  doTick() {
    switch (this.state) {
      case State.WAITING_LEVEL:
        {
          const {
            levels,
            level
          } = this;
          const currentLevel = levels == null ? void 0 : levels[level];
          const details = currentLevel == null ? void 0 : currentLevel.details;
          if (details && (!details.live || this.levelLastLoaded === currentLevel)) {
            if (this.waitForCdnTuneIn(details)) {
              break;
            }
            this.state = State.IDLE;
            break;
          } else if (this.hls.nextLoadLevel !== this.level) {
            this.state = State.IDLE;
            break;
          }
          break;
        }
      case State.FRAG_LOADING_WAITING_RETRY:
        {
          var _this$media;
          const now = self.performance.now();
          const retryDate = this.retryDate;
          // if current time is gt than retryDate, or if media seeking let's switch to IDLE state to retry loading
          if (!retryDate || now >= retryDate || (_this$media = this.media) != null && _this$media.seeking) {
            const {
              levels,
              level
            } = this;
            const currentLevel = levels == null ? void 0 : levels[level];
            this.resetStartWhenNotLoaded(currentLevel || null);
            this.state = State.IDLE;
          }
        }
        break;
    }
    if (this.state === State.IDLE) {
      this.doTickIdle();
    }
    this.onTickEnd();
  }
  onTickEnd() {
    super.onTickEnd();
    this.checkBuffer();
    this.checkFragmentChanged();
  }
  doTickIdle() {
    const {
      hls,
      levelLastLoaded,
      levels,
      media
    } = this;

    // if start level not parsed yet OR
    // if video not attached AND start fragment already requested OR start frag prefetch not enabled
    // exit loop, as we either need more info (level not parsed) or we need media to be attached to load new fragment
    if (levelLastLoaded === null || !media && (this.startFragRequested || !hls.config.startFragPrefetch)) {
      return;
    }

    // If the "main" level is audio-only but we are loading an alternate track in the same group, do not load anything
    if (this.altAudio && this.audioOnly) {
      return;
    }
    const level = hls.nextLoadLevel;
    if (!(levels != null && levels[level])) {
      return;
    }
    const levelInfo = levels[level];

    // if buffer length is less than maxBufLen try to load a new fragment

    const bufferInfo = this.getMainFwdBufferInfo();
    if (bufferInfo === null) {
      return;
    }
    const lastDetails = this.getLevelDetails();
    if (lastDetails && this._streamEnded(bufferInfo, lastDetails)) {
      const data = {};
      if (this.altAudio) {
        data.type = 'video';
      }
      this.hls.trigger(Events.BUFFER_EOS, data);
      this.state = State.ENDED;
      return;
    }

    // set next load level : this will trigger a playlist load if needed
    if (hls.loadLevel !== level && hls.manualLevel === -1) {
      this.log(`Adapting to level ${level} from level ${this.level}`);
    }
    this.level = hls.nextLoadLevel = level;
    const levelDetails = levelInfo.details;
    // if level info not retrieved yet, switch state and wait for level retrieval
    // if live playlist, ensure that new playlist has been refreshed to avoid loading/try to load
    // a useless and outdated fragment (that might even introduce load error if it is already out of the live playlist)
    if (!levelDetails || this.state === State.WAITING_LEVEL || levelDetails.live && this.levelLastLoaded !== levelInfo) {
      this.level = level;
      this.state = State.WAITING_LEVEL;
      return;
    }
    const bufferLen = bufferInfo.len;

    // compute max Buffer Length that we could get from this load level, based on level bitrate. don't buffer more than 60 MB and more than 30s
    const maxBufLen = this.getMaxBufferLength(levelInfo.maxBitrate);

    // Stay idle if we are still with buffer margins
    if (bufferLen >= maxBufLen) {
      return;
    }
    if (this.backtrackFragment && this.backtrackFragment.start > bufferInfo.end) {
      this.backtrackFragment = null;
    }
    const targetBufferTime = this.backtrackFragment ? this.backtrackFragment.start : bufferInfo.end;
    let frag = this.getNextFragment(targetBufferTime, levelDetails);
    // Avoid backtracking by loading an earlier segment in streams with segments that do not start with a key frame (flagged by `couldBacktrack`)
    if (this.couldBacktrack && !this.fragPrevious && frag && frag.sn !== 'initSegment' && this.fragmentTracker.getState(frag) !== FragmentState.OK) {
      var _this$backtrackFragme;
      const backtrackSn = ((_this$backtrackFragme = this.backtrackFragment) != null ? _this$backtrackFragme : frag).sn;
      const fragIdx = backtrackSn - levelDetails.startSN;
      const backtrackFrag = levelDetails.fragments[fragIdx - 1];
      if (backtrackFrag && frag.cc === backtrackFrag.cc) {
        frag = backtrackFrag;
        this.fragmentTracker.removeFragment(backtrackFrag);
      }
    } else if (this.backtrackFragment && bufferInfo.len) {
      this.backtrackFragment = null;
    }
    // Avoid loop loading by using nextLoadPosition set for backtracking and skipping consecutive GAP tags
    if (frag && this.isLoopLoading(frag, targetBufferTime)) {
      const gapStart = frag.gap;
      if (!gapStart) {
        // Cleanup the fragment tracker before trying to find the next unbuffered fragment
        const type = this.audioOnly && !this.altAudio ? ElementaryStreamTypes.AUDIO : ElementaryStreamTypes.VIDEO;
        const mediaBuffer = (type === ElementaryStreamTypes.VIDEO ? this.videoBuffer : this.mediaBuffer) || this.media;
        if (mediaBuffer) {
          this.afterBufferFlushed(mediaBuffer, type, PlaylistLevelType.MAIN);
        }
      }
      frag = this.getNextFragmentLoopLoading(frag, levelDetails, bufferInfo, PlaylistLevelType.MAIN, maxBufLen);
    }
    if (!frag) {
      return;
    }
    if (frag.initSegment && !frag.initSegment.data && !this.bitrateTest) {
      frag = frag.initSegment;
    }
    this.loadFragment(frag, levelInfo, targetBufferTime);
  }
  loadFragment(frag, level, targetBufferTime) {
    // Check if fragment is not loaded
    const fragState = this.fragmentTracker.getState(frag);
    this.fragCurrent = frag;
    if (fragState === FragmentState.NOT_LOADED || fragState === FragmentState.PARTIAL) {
      if (frag.sn === 'initSegment') {
        this._loadInitSegment(frag, level);
      } else if (this.bitrateTest) {
        this.log(`Fragment ${frag.sn} of level ${frag.level} is being downloaded to test bitrate and will not be buffered`);
        this._loadBitrateTestFrag(frag, level);
      } else {
        this.startFragRequested = true;
        super.loadFragment(frag, level, targetBufferTime);
      }
    } else {
      this.clearTrackerIfNeeded(frag);
    }
  }
  getBufferedFrag(position) {
    return this.fragmentTracker.getBufferedFrag(position, PlaylistLevelType.MAIN);
  }
  followingBufferedFrag(frag) {
    if (frag) {
      // try to get range of next fragment (500ms after this range)
      return this.getBufferedFrag(frag.end + 0.5);
    }
    return null;
  }

  /*
    on immediate level switch :
     - pause playback if playing
     - cancel any pending load request
     - and trigger a buffer flush
  */
  immediateLevelSwitch() {
    this.abortCurrentFrag();
    this.flushMainBuffer(0, Number.POSITIVE_INFINITY);
  }

  /**
   * try to switch ASAP without breaking video playback:
   * in order to ensure smooth but quick level switching,
   * we need to find the next flushable buffer range
   * we should take into account new segment fetch time
   */
  nextLevelSwitch() {
    const {
      levels,
      media
    } = this;
    // ensure that media is defined and that metadata are available (to retrieve currentTime)
    if (media != null && media.readyState) {
      let fetchdelay;
      const fragPlayingCurrent = this.getAppendedFrag(media.currentTime);
      if (fragPlayingCurrent && fragPlayingCurrent.start > 1) {
        // flush buffer preceding current fragment (flush until current fragment start offset)
        // minus 1s to avoid video freezing, that could happen if we flush keyframe of current video ...
        this.flushMainBuffer(0, fragPlayingCurrent.start - 1);
      }
      const levelDetails = this.getLevelDetails();
      if (levelDetails != null && levelDetails.live) {
        const bufferInfo = this.getMainFwdBufferInfo();
        // Do not flush in live stream with low buffer
        if (!bufferInfo || bufferInfo.len < levelDetails.targetduration * 2) {
          return;
        }
      }
      if (!media.paused && levels) {
        // add a safety delay of 1s
        const nextLevelId = this.hls.nextLoadLevel;
        const nextLevel = levels[nextLevelId];
        const fragLastKbps = this.fragLastKbps;
        if (fragLastKbps && this.fragCurrent) {
          fetchdelay = this.fragCurrent.duration * nextLevel.maxBitrate / (1000 * fragLastKbps) + 1;
        } else {
          fetchdelay = 0;
        }
      } else {
        fetchdelay = 0;
      }
      // this.log('fetchdelay:'+fetchdelay);
      // find buffer range that will be reached once new fragment will be fetched
      const bufferedFrag = this.getBufferedFrag(media.currentTime + fetchdelay);
      if (bufferedFrag) {
        // we can flush buffer range following this one without stalling playback
        const nextBufferedFrag = this.followingBufferedFrag(bufferedFrag);
        if (nextBufferedFrag) {
          // if we are here, we can also cancel any loading/demuxing in progress, as they are useless
          this.abortCurrentFrag();
          // start flush position is in next buffered frag. Leave some padding for non-independent segments and smoother playback.
          const maxStart = nextBufferedFrag.maxStartPTS ? nextBufferedFrag.maxStartPTS : nextBufferedFrag.start;
          const fragDuration = nextBufferedFrag.duration;
          const startPts = Math.max(bufferedFrag.end, maxStart + Math.min(Math.max(fragDuration - this.config.maxFragLookUpTolerance, fragDuration * (this.couldBacktrack ? 0.5 : 0.125)), fragDuration * (this.couldBacktrack ? 0.75 : 0.25)));
          this.flushMainBuffer(startPts, Number.POSITIVE_INFINITY);
        }
      }
    }
  }
  abortCurrentFrag() {
    const fragCurrent = this.fragCurrent;
    this.fragCurrent = null;
    this.backtrackFragment = null;
    if (fragCurrent) {
      fragCurrent.abortRequests();
      this.fragmentTracker.removeFragment(fragCurrent);
    }
    switch (this.state) {
      case State.KEY_LOADING:
      case State.FRAG_LOADING:
      case State.FRAG_LOADING_WAITING_RETRY:
      case State.PARSING:
      case State.PARSED:
        this.state = State.IDLE;
        break;
    }
    this.nextLoadPosition = this.getLoadPosition();
  }
  flushMainBuffer(startOffset, endOffset) {
    super.flushMainBuffer(startOffset, endOffset, this.altAudio ? 'video' : null);
  }
  onMediaAttached(event, data) {
    super.onMediaAttached(event, data);
    const media = data.media;
    this.onvplaying = this.onMediaPlaying.bind(this);
    this.onvseeked = this.onMediaSeeked.bind(this);
    media.addEventListener('playing', this.onvplaying);
    media.addEventListener('seeked', this.onvseeked);
    this.gapController = new GapController(this.config, media, this.fragmentTracker, this.hls);
  }
  onMediaDetaching() {
    const {
      media
    } = this;
    if (media && this.onvplaying && this.onvseeked) {
      media.removeEventListener('playing', this.onvplaying);
      media.removeEventListener('seeked', this.onvseeked);
      this.onvplaying = this.onvseeked = null;
      this.videoBuffer = null;
    }
    this.fragPlaying = null;
    if (this.gapController) {
      this.gapController.destroy();
      this.gapController = null;
    }
    super.onMediaDetaching();
  }
  onMediaPlaying() {
    // tick to speed up FRAG_CHANGED triggering
    this.tick();
  }
  onMediaSeeked() {
    const media = this.media;
    const currentTime = media ? media.currentTime : null;
    if (isFiniteNumber(currentTime)) {
      this.log(`Media seeked to ${currentTime.toFixed(3)}`);
    }

    // If seeked was issued before buffer was appended do not tick immediately
    const bufferInfo = this.getMainFwdBufferInfo();
    if (bufferInfo === null || bufferInfo.len === 0) {
      this.warn(`Main forward buffer length on "seeked" event ${bufferInfo ? bufferInfo.len : 'empty'})`);
      return;
    }

    // tick to speed up FRAG_CHANGED triggering
    this.tick();
  }
  onManifestLoading() {
    // reset buffer on manifest loading
    this.log('Trigger BUFFER_RESET');
    this.hls.trigger(Events.BUFFER_RESET, undefined);
    this.fragmentTracker.removeAllFragments();
    this.couldBacktrack = false;
    this.startPosition = this.lastCurrentTime = this.fragLastKbps = 0;
    this.levels = this.fragPlaying = this.backtrackFragment = this.levelLastLoaded = null;
    this.altAudio = this.audioOnly = this.startFragRequested = false;
  }
  onManifestParsed(event, data) {
    // detect if we have different kind of audio codecs used amongst playlists
    let aac = false;
    let heaac = false;
    data.levels.forEach(level => {
      const codec = level.audioCodec;
      if (codec) {
        aac = aac || codec.indexOf('mp4a.40.2') !== -1;
        heaac = heaac || codec.indexOf('mp4a.40.5') !== -1;
      }
    });
    this.audioCodecSwitch = aac && heaac && !changeTypeSupported();
    if (this.audioCodecSwitch) {
      this.log('Both AAC/HE-AAC audio found in levels; declaring level codec as HE-AAC');
    }
    this.levels = data.levels;
    this.startFragRequested = false;
  }
  onLevelLoading(event, data) {
    const {
      levels
    } = this;
    if (!levels || this.state !== State.IDLE) {
      return;
    }
    const level = levels[data.level];
    if (!level.details || level.details.live && this.levelLastLoaded !== level || this.waitForCdnTuneIn(level.details)) {
      this.state = State.WAITING_LEVEL;
    }
  }
  onLevelLoaded(event, data) {
    var _curLevel$details;
    const {
      levels
    } = this;
    const newLevelId = data.level;
    const newDetails = data.details;
    const duration = newDetails.totalduration;
    if (!levels) {
      this.warn(`Levels were reset while loading level ${newLevelId}`);
      return;
    }
    this.log(`Level ${newLevelId} loaded [${newDetails.startSN},${newDetails.endSN}]${newDetails.lastPartSn ? `[part-${newDetails.lastPartSn}-${newDetails.lastPartIndex}]` : ''}, cc [${newDetails.startCC}, ${newDetails.endCC}] duration:${duration}`);
    const curLevel = levels[newLevelId];
    const fragCurrent = this.fragCurrent;
    if (fragCurrent && (this.state === State.FRAG_LOADING || this.state === State.FRAG_LOADING_WAITING_RETRY)) {
      if (fragCurrent.level !== data.level && fragCurrent.loader) {
        this.abortCurrentFrag();
      }
    }
    let sliding = 0;
    if (newDetails.live || (_curLevel$details = curLevel.details) != null && _curLevel$details.live) {
      var _this$levelLastLoaded;
      this.checkLiveUpdate(newDetails);
      if (newDetails.deltaUpdateFailed) {
        return;
      }
      sliding = this.alignPlaylists(newDetails, curLevel.details, (_this$levelLastLoaded = this.levelLastLoaded) == null ? void 0 : _this$levelLastLoaded.details);
    }
    // override level info
    curLevel.details = newDetails;
    this.levelLastLoaded = curLevel;
    this.hls.trigger(Events.LEVEL_UPDATED, {
      details: newDetails,
      level: newLevelId
    });

    // only switch back to IDLE state if we were waiting for level to start downloading a new fragment
    if (this.state === State.WAITING_LEVEL) {
      if (this.waitForCdnTuneIn(newDetails)) {
        // Wait for Low-Latency CDN Tune-in
        return;
      }
      this.state = State.IDLE;
    }
    if (!this.startFragRequested) {
      this.setStartPosition(newDetails, sliding);
    } else if (newDetails.live) {
      this.synchronizeToLiveEdge(newDetails);
    }

    // trigger handler right now
    this.tick();
  }
  _handleFragmentLoadProgress(data) {
    var _frag$initSegment;
    const {
      frag,
      part,
      payload
    } = data;
    const {
      levels
    } = this;
    if (!levels) {
      this.warn(`Levels were reset while fragment load was in progress. Fragment ${frag.sn} of level ${frag.level} will not be buffered`);
      return;
    }
    const currentLevel = levels[frag.level];
    const details = currentLevel.details;
    if (!details) {
      this.warn(`Dropping fragment ${frag.sn} of level ${frag.level} after level details were reset`);
      this.fragmentTracker.removeFragment(frag);
      return;
    }
    const videoCodec = currentLevel.videoCodec;

    // time Offset is accurate if level PTS is known, or if playlist is not sliding (not live)
    const accurateTimeOffset = details.PTSKnown || !details.live;
    const initSegmentData = (_frag$initSegment = frag.initSegment) == null ? void 0 : _frag$initSegment.data;
    const audioCodec = this._getAudioCodec(currentLevel);

    // transmux the MPEG-TS data to ISO-BMFF segments
    // this.log(`Transmuxing ${frag.sn} of [${details.startSN} ,${details.endSN}],level ${frag.level}, cc ${frag.cc}`);
    const transmuxer = this.transmuxer = this.transmuxer || new TransmuxerInterface(this.hls, PlaylistLevelType.MAIN, this._handleTransmuxComplete.bind(this), this._handleTransmuxerFlush.bind(this));
    const partIndex = part ? part.index : -1;
    const partial = partIndex !== -1;
    const chunkMeta = new ChunkMetadata(frag.level, frag.sn, frag.stats.chunkCount, payload.byteLength, partIndex, partial);
    const initPTS = this.initPTS[frag.cc];
    transmuxer.push(payload, initSegmentData, audioCodec, videoCodec, frag, part, details.totalduration, accurateTimeOffset, chunkMeta, initPTS);
  }
  onAudioTrackSwitching(event, data) {
    // if any URL found on new audio track, it is an alternate audio track
    const fromAltAudio = this.altAudio;
    const altAudio = !!data.url;
    // if we switch on main audio, ensure that main fragment scheduling is synced with media.buffered
    // don't do anything if we switch to alt audio: audio stream controller is handling it.
    // we will just have to change buffer scheduling on audioTrackSwitched
    if (!altAudio) {
      if (this.mediaBuffer !== this.media) {
        this.log('Switching on main audio, use media.buffered to schedule main fragment loading');
        this.mediaBuffer = this.media;
        const fragCurrent = this.fragCurrent;
        // we need to refill audio buffer from main: cancel any frag loading to speed up audio switch
        if (fragCurrent) {
          this.log('Switching to main audio track, cancel main fragment load');
          fragCurrent.abortRequests();
          this.fragmentTracker.removeFragment(fragCurrent);
        }
        // destroy transmuxer to force init segment generation (following audio switch)
        this.resetTransmuxer();
        // switch to IDLE state to load new fragment
        this.resetLoadingState();
      } else if (this.audioOnly) {
        // Reset audio transmuxer so when switching back to main audio we're not still appending where we left off
        this.resetTransmuxer();
      }
      const hls = this.hls;
      // If switching from alt to main audio, flush all audio and trigger track switched
      if (fromAltAudio) {
        hls.trigger(Events.BUFFER_FLUSHING, {
          startOffset: 0,
          endOffset: Number.POSITIVE_INFINITY,
          type: null
        });
        this.fragmentTracker.removeAllFragments();
      }
      hls.trigger(Events.AUDIO_TRACK_SWITCHED, data);
    }
  }
  onAudioTrackSwitched(event, data) {
    const trackId = data.id;
    const altAudio = !!this.hls.audioTracks[trackId].url;
    if (altAudio) {
      const videoBuffer = this.videoBuffer;
      // if we switched on alternate audio, ensure that main fragment scheduling is synced with video sourcebuffer buffered
      if (videoBuffer && this.mediaBuffer !== videoBuffer) {
        this.log('Switching on alternate audio, use video.buffered to schedule main fragment loading');
        this.mediaBuffer = videoBuffer;
      }
    }
    this.altAudio = altAudio;
    this.tick();
  }
  onBufferCreated(event, data) {
    const tracks = data.tracks;
    let mediaTrack;
    let name;
    let alternate = false;
    for (const type in tracks) {
      const track = tracks[type];
      if (track.id === 'main') {
        name = type;
        mediaTrack = track;
        // keep video source buffer reference
        if (type === 'video') {
          const videoTrack = tracks[type];
          if (videoTrack) {
            this.videoBuffer = videoTrack.buffer;
          }
        }
      } else {
        alternate = true;
      }
    }
    if (alternate && mediaTrack) {
      this.log(`Alternate track found, use ${name}.buffered to schedule main fragment loading`);
      this.mediaBuffer = mediaTrack.buffer;
    } else {
      this.mediaBuffer = this.media;
    }
  }
  onFragBuffered(event, data) {
    const {
      frag,
      part
    } = data;
    if (frag && frag.type !== PlaylistLevelType.MAIN) {
      return;
    }
    if (this.fragContextChanged(frag)) {
      // If a level switch was requested while a fragment was buffering, it will emit the FRAG_BUFFERED event upon completion
      // Avoid setting state back to IDLE, since that will interfere with a level switch
      this.warn(`Fragment ${frag.sn}${part ? ' p: ' + part.index : ''} of level ${frag.level} finished buffering, but was aborted. state: ${this.state}`);
      if (this.state === State.PARSED) {
        this.state = State.IDLE;
      }
      return;
    }
    const stats = part ? part.stats : frag.stats;
    this.fragLastKbps = Math.round(8 * stats.total / (stats.buffering.end - stats.loading.first));
    if (frag.sn !== 'initSegment') {
      this.fragPrevious = frag;
    }
    this.fragBufferedComplete(frag, part);
  }
  onError(event, data) {
    var _data$context;
    if (data.fatal) {
      this.state = State.ERROR;
      return;
    }
    switch (data.details) {
      case ErrorDetails.FRAG_GAP:
      case ErrorDetails.FRAG_PARSING_ERROR:
      case ErrorDetails.FRAG_DECRYPT_ERROR:
      case ErrorDetails.FRAG_LOAD_ERROR:
      case ErrorDetails.FRAG_LOAD_TIMEOUT:
      case ErrorDetails.KEY_LOAD_ERROR:
      case ErrorDetails.KEY_LOAD_TIMEOUT:
        this.onFragmentOrKeyLoadError(PlaylistLevelType.MAIN, data);
        break;
      case ErrorDetails.LEVEL_LOAD_ERROR:
      case ErrorDetails.LEVEL_LOAD_TIMEOUT:
      case ErrorDetails.LEVEL_PARSING_ERROR:
        // in case of non fatal error while loading level, if level controller is not retrying to load level, switch back to IDLE
        if (!data.levelRetry && this.state === State.WAITING_LEVEL && ((_data$context = data.context) == null ? void 0 : _data$context.type) === PlaylistContextType.LEVEL) {
          this.state = State.IDLE;
        }
        break;
      case ErrorDetails.BUFFER_APPEND_ERROR:
      case ErrorDetails.BUFFER_FULL_ERROR:
        if (!data.parent || data.parent !== 'main') {
          return;
        }
        if (data.details === ErrorDetails.BUFFER_APPEND_ERROR) {
          this.resetLoadingState();
          return;
        }
        if (this.reduceLengthAndFlushBuffer(data)) {
          this.flushMainBuffer(0, Number.POSITIVE_INFINITY);
        }
        break;
      case ErrorDetails.INTERNAL_EXCEPTION:
        this.recoverWorkerError(data);
        break;
    }
  }

  // Checks the health of the buffer and attempts to resolve playback stalls.
  checkBuffer() {
    const {
      media,
      gapController
    } = this;
    if (!media || !gapController || !media.readyState) {
      // Exit early if we don't have media or if the media hasn't buffered anything yet (readyState 0)
      return;
    }
    if (this.loadedmetadata || !BufferHelper.getBuffered(media).length) {
      // Resolve gaps using the main buffer, whose ranges are the intersections of the A/V sourcebuffers
      const activeFrag = this.state !== State.IDLE ? this.fragCurrent : null;
      gapController.poll(this.lastCurrentTime, activeFrag);
    }
    this.lastCurrentTime = media.currentTime;
  }
  onFragLoadEmergencyAborted() {
    this.state = State.IDLE;
    // if loadedmetadata is not set, it means that we are emergency switch down on first frag
    // in that case, reset startFragRequested flag
    if (!this.loadedmetadata) {
      this.startFragRequested = false;
      this.nextLoadPosition = this.startPosition;
    }
    this.tickImmediate();
  }
  onBufferFlushed(event, {
    type
  }) {
    if (type !== ElementaryStreamTypes.AUDIO || this.audioOnly && !this.altAudio) {
      const mediaBuffer = (type === ElementaryStreamTypes.VIDEO ? this.videoBuffer : this.mediaBuffer) || this.media;
      this.afterBufferFlushed(mediaBuffer, type, PlaylistLevelType.MAIN);
      this.tick();
    }
  }
  onLevelsUpdated(event, data) {
    if (this.level > -1 && this.fragCurrent) {
      this.level = this.fragCurrent.level;
    }
    this.levels = data.levels;
  }
  swapAudioCodec() {
    this.audioCodecSwap = !this.audioCodecSwap;
  }

  /**
   * Seeks to the set startPosition if not equal to the mediaElement's current time.
   */
  seekToStartPos() {
    const {
      media
    } = this;
    if (!media) {
      return;
    }
    const currentTime = media.currentTime;
    let startPosition = this.startPosition;
    // only adjust currentTime if different from startPosition or if startPosition not buffered
    // at that stage, there should be only one buffered range, as we reach that code after first fragment has been buffered
    if (startPosition >= 0 && currentTime < startPosition) {
      if (media.seeking) {
        this.log(`could not seek to ${startPosition}, already seeking at ${currentTime}`);
        return;
      }
      const buffered = BufferHelper.getBuffered(media);
      const bufferStart = buffered.length ? buffered.start(0) : 0;
      const delta = bufferStart - startPosition;
      if (delta > 0 && (delta < this.config.maxBufferHole || delta < this.config.maxFragLookUpTolerance)) {
        this.log(`adjusting start position by ${delta} to match buffer start`);
        startPosition += delta;
        this.startPosition = startPosition;
      }
      this.log(`seek to target start position ${startPosition} from current time ${currentTime}`);
      media.currentTime = startPosition;
    }
  }
  _getAudioCodec(currentLevel) {
    let audioCodec = this.config.defaultAudioCodec || currentLevel.audioCodec;
    if (this.audioCodecSwap && audioCodec) {
      this.log('Swapping audio codec');
      if (audioCodec.indexOf('mp4a.40.5') !== -1) {
        audioCodec = 'mp4a.40.2';
      } else {
        audioCodec = 'mp4a.40.5';
      }
    }
    return audioCodec;
  }
  _loadBitrateTestFrag(frag, level) {
    frag.bitrateTest = true;
    this._doFragLoad(frag, level).then(data => {
      const {
        hls
      } = this;
      if (!data || this.fragContextChanged(frag)) {
        return;
      }
      level.fragmentError = 0;
      this.state = State.IDLE;
      this.startFragRequested = false;
      this.bitrateTest = false;
      const stats = frag.stats;
      // Bitrate tests fragments are neither parsed nor buffered
      stats.parsing.start = stats.parsing.end = stats.buffering.start = stats.buffering.end = self.performance.now();
      hls.trigger(Events.FRAG_LOADED, data);
      frag.bitrateTest = false;
    });
  }
  _handleTransmuxComplete(transmuxResult) {
    var _id3$samples;
    const id = 'main';
    const {
      hls
    } = this;
    const {
      remuxResult,
      chunkMeta
    } = transmuxResult;
    const context = this.getCurrentContext(chunkMeta);
    if (!context) {
      this.resetWhenMissingContext(chunkMeta);
      return;
    }
    const {
      frag,
      part,
      level
    } = context;
    const {
      video,
      text,
      id3,
      initSegment
    } = remuxResult;
    const {
      details
    } = level;
    // The audio-stream-controller handles audio buffering if Hls.js is playing an alternate audio track
    const audio = this.altAudio ? undefined : remuxResult.audio;

    // Check if the current fragment has been aborted. We check this by first seeing if we're still playing the current level.
    // If we are, subsequently check if the currently loading fragment (fragCurrent) has changed.
    if (this.fragContextChanged(frag)) {
      this.fragmentTracker.removeFragment(frag);
      return;
    }
    this.state = State.PARSING;
    if (initSegment) {
      if (initSegment != null && initSegment.tracks) {
        const mapFragment = frag.initSegment || frag;
        this._bufferInitSegment(level, initSegment.tracks, mapFragment, chunkMeta);
        hls.trigger(Events.FRAG_PARSING_INIT_SEGMENT, {
          frag: mapFragment,
          id,
          tracks: initSegment.tracks
        });
      }

      // This would be nice if Number.isFinite acted as a typeguard, but it doesn't. See: https://github.com/Microsoft/TypeScript/issues/10038
      const initPTS = initSegment.initPTS;
      const timescale = initSegment.timescale;
      if (isFiniteNumber(initPTS)) {
        this.initPTS[frag.cc] = {
          baseTime: initPTS,
          timescale
        };
        hls.trigger(Events.INIT_PTS_FOUND, {
          frag,
          id,
          initPTS,
          timescale
        });
      }
    }

    // Avoid buffering if backtracking this fragment
    if (video && details && frag.sn !== 'initSegment') {
      const prevFrag = details.fragments[frag.sn - 1 - details.startSN];
      const isFirstFragment = frag.sn === details.startSN;
      const isFirstInDiscontinuity = !prevFrag || frag.cc > prevFrag.cc;
      if (remuxResult.independent !== false) {
        const {
          startPTS,
          endPTS,
          startDTS,
          endDTS
        } = video;
        if (part) {
          part.elementaryStreams[video.type] = {
            startPTS,
            endPTS,
            startDTS,
            endDTS
          };
        } else {
          if (video.firstKeyFrame && video.independent && chunkMeta.id === 1 && !isFirstInDiscontinuity) {
            this.couldBacktrack = true;
          }
          if (video.dropped && video.independent) {
            // Backtrack if dropped frames create a gap after currentTime

            const bufferInfo = this.getMainFwdBufferInfo();
            const targetBufferTime = (bufferInfo ? bufferInfo.end : this.getLoadPosition()) + this.config.maxBufferHole;
            const startTime = video.firstKeyFramePTS ? video.firstKeyFramePTS : startPTS;
            if (!isFirstFragment && targetBufferTime < startTime - this.config.maxBufferHole && !isFirstInDiscontinuity) {
              this.backtrack(frag);
              return;
            } else if (isFirstInDiscontinuity) {
              // Mark segment with a gap to avoid loop loading
              frag.gap = true;
            }
            // Set video stream start to fragment start so that truncated samples do not distort the timeline, and mark it partial
            frag.setElementaryStreamInfo(video.type, frag.start, endPTS, frag.start, endDTS, true);
          } else if (isFirstFragment && startPTS > MAX_START_GAP_JUMP) {
            // Mark segment with a gap to skip large start gap
            frag.gap = true;
          }
        }
        frag.setElementaryStreamInfo(video.type, startPTS, endPTS, startDTS, endDTS);
        if (this.backtrackFragment) {
          this.backtrackFragment = frag;
        }
        this.bufferFragmentData(video, frag, part, chunkMeta, isFirstFragment || isFirstInDiscontinuity);
      } else if (isFirstFragment || isFirstInDiscontinuity) {
        // Mark segment with a gap to avoid loop loading
        frag.gap = true;
      } else {
        this.backtrack(frag);
        return;
      }
    }
    if (audio) {
      const {
        startPTS,
        endPTS,
        startDTS,
        endDTS
      } = audio;
      if (part) {
        part.elementaryStreams[ElementaryStreamTypes.AUDIO] = {
          startPTS,
          endPTS,
          startDTS,
          endDTS
        };
      }
      frag.setElementaryStreamInfo(ElementaryStreamTypes.AUDIO, startPTS, endPTS, startDTS, endDTS);
      this.bufferFragmentData(audio, frag, part, chunkMeta);
    }
    if (details && id3 != null && (_id3$samples = id3.samples) != null && _id3$samples.length) {
      const emittedID3 = {
        id,
        frag,
        details,
        samples: id3.samples
      };
      hls.trigger(Events.FRAG_PARSING_METADATA, emittedID3);
    }
    if (details && text) {
      const emittedText = {
        id,
        frag,
        details,
        samples: text.samples
      };
      hls.trigger(Events.FRAG_PARSING_USERDATA, emittedText);
    }
  }
  _bufferInitSegment(currentLevel, tracks, frag, chunkMeta) {
    if (this.state !== State.PARSING) {
      return;
    }
    this.audioOnly = !!tracks.audio && !tracks.video;

    // if audio track is expected to come from audio stream controller, discard any coming from main
    if (this.altAudio && !this.audioOnly) {
      delete tracks.audio;
    }
    // include levelCodec in audio and video tracks
    const {
      audio,
      video,
      audiovideo
    } = tracks;
    if (audio) {
      let audioCodec = currentLevel.audioCodec;
      const ua = navigator.userAgent.toLowerCase();
      if (this.audioCodecSwitch) {
        if (audioCodec) {
          if (audioCodec.indexOf('mp4a.40.5') !== -1) {
            audioCodec = 'mp4a.40.2';
          } else {
            audioCodec = 'mp4a.40.5';
          }
        }
        // In the case that AAC and HE-AAC audio codecs are signalled in manifest,
        // force HE-AAC, as it seems that most browsers prefers it.
        // don't force HE-AAC if mono stream, or in Firefox
        const audioMetadata = audio.metadata;
        if (audioMetadata && 'channelCount' in audioMetadata && (audioMetadata.channelCount || 1) !== 1 && ua.indexOf('firefox') === -1) {
          audioCodec = 'mp4a.40.5';
        }
      }
      // HE-AAC is broken on Android, always signal audio codec as AAC even if variant manifest states otherwise
      if (audioCodec && audioCodec.indexOf('mp4a.40.5') !== -1 && ua.indexOf('android') !== -1 && audio.container !== 'audio/mpeg') {
        // Exclude mpeg audio
        audioCodec = 'mp4a.40.2';
        this.log(`Android: force audio codec to ${audioCodec}`);
      }
      if (currentLevel.audioCodec && currentLevel.audioCodec !== audioCodec) {
        this.log(`Swapping manifest audio codec "${currentLevel.audioCodec}" for "${audioCodec}"`);
      }
      audio.levelCodec = audioCodec;
      audio.id = 'main';
      this.log(`Init audio buffer, container:${audio.container}, codecs[selected/level/parsed]=[${audioCodec || ''}/${currentLevel.audioCodec || ''}/${audio.codec}]`);
    }
    if (video) {
      video.levelCodec = currentLevel.videoCodec;
      video.id = 'main';
      this.log(`Init video buffer, container:${video.container}, codecs[level/parsed]=[${currentLevel.videoCodec || ''}/${video.codec}]`);
    }
    if (audiovideo) {
      this.log(`Init audiovideo buffer, container:${audiovideo.container}, codecs[level/parsed]=[${currentLevel.codecs}/${audiovideo.codec}]`);
    }
    this.hls.trigger(Events.BUFFER_CODECS, tracks);
    // loop through tracks that are going to be provided to bufferController
    Object.keys(tracks).forEach(trackName => {
      const track = tracks[trackName];
      const initSegment = track.initSegment;
      if (initSegment != null && initSegment.byteLength) {
        this.hls.trigger(Events.BUFFER_APPENDING, {
          type: trackName,
          data: initSegment,
          frag,
          part: null,
          chunkMeta,
          parent: frag.type
        });
      }
    });
    // trigger handler right now
    this.tickImmediate();
  }
  getMainFwdBufferInfo() {
    return this.getFwdBufferInfo(this.mediaBuffer ? this.mediaBuffer : this.media, PlaylistLevelType.MAIN);
  }
  backtrack(frag) {
    this.couldBacktrack = true;
    // Causes findFragments to backtrack through fragments to find the keyframe
    this.backtrackFragment = frag;
    this.resetTransmuxer();
    this.flushBufferGap(frag);
    this.fragmentTracker.removeFragment(frag);
    this.fragPrevious = null;
    this.nextLoadPosition = frag.start;
    this.state = State.IDLE;
  }
  checkFragmentChanged() {
    const video = this.media;
    let fragPlayingCurrent = null;
    if (video && video.readyState > 1 && video.seeking === false) {
      const currentTime = video.currentTime;
      /* if video element is in seeked state, currentTime can only increase.
        (assuming that playback rate is positive ...)
        As sometimes currentTime jumps back to zero after a
        media decode error, check this, to avoid seeking back to
        wrong position after a media decode error
      */

      if (BufferHelper.isBuffered(video, currentTime)) {
        fragPlayingCurrent = this.getAppendedFrag(currentTime);
      } else if (BufferHelper.isBuffered(video, currentTime + 0.1)) {
        /* ensure that FRAG_CHANGED event is triggered at startup,
          when first video frame is displayed and playback is paused.
          add a tolerance of 100ms, in case current position is not buffered,
          check if current pos+100ms is buffered and use that buffer range
          for FRAG_CHANGED event reporting */
        fragPlayingCurrent = this.getAppendedFrag(currentTime + 0.1);
      }
      if (fragPlayingCurrent) {
        this.backtrackFragment = null;
        const fragPlaying = this.fragPlaying;
        const fragCurrentLevel = fragPlayingCurrent.level;
        if (!fragPlaying || fragPlayingCurrent.sn !== fragPlaying.sn || fragPlaying.level !== fragCurrentLevel) {
          this.fragPlaying = fragPlayingCurrent;
          this.hls.trigger(Events.FRAG_CHANGED, {
            frag: fragPlayingCurrent
          });
          if (!fragPlaying || fragPlaying.level !== fragCurrentLevel) {
            this.hls.trigger(Events.LEVEL_SWITCHED, {
              level: fragCurrentLevel
            });
          }
        }
      }
    }
  }
  get nextLevel() {
    const frag = this.nextBufferedFrag;
    if (frag) {
      return frag.level;
    }
    return -1;
  }
  get currentFrag() {
    const media = this.media;
    if (media) {
      return this.fragPlaying || this.getAppendedFrag(media.currentTime);
    }
    return null;
  }
  get currentProgramDateTime() {
    const media = this.media;
    if (media) {
      const currentTime = media.currentTime;
      const frag = this.currentFrag;
      if (frag && isFiniteNumber(currentTime) && isFiniteNumber(frag.programDateTime)) {
        const epocMs = frag.programDateTime + (currentTime - frag.start) * 1000;
        return new Date(epocMs);
      }
    }
    return null;
  }
  get currentLevel() {
    const frag = this.currentFrag;
    if (frag) {
      return frag.level;
    }
    return -1;
  }
  get nextBufferedFrag() {
    const frag = this.currentFrag;
    if (frag) {
      return this.followingBufferedFrag(frag);
    }
    return null;
  }
  get forceStartLoad() {
    return this._forceStartLoad;
  }
}

/**
 * The `Hls` class is the core of the HLS.js library used to instantiate player instances.
 * @public
 */
class Hls {
  /**
   * Get the video-dev/hls.js package version.
   */
  static get version() {
    return "1.5.14";
  }

  /**
   * Check if the required MediaSource Extensions are available.
   */
  static isMSESupported() {
    return isMSESupported();
  }

  /**
   * Check if MediaSource Extensions are available and isTypeSupported checks pass for any baseline codecs.
   */
  static isSupported() {
    return isSupported();
  }

  /**
   * Get the MediaSource global used for MSE playback (ManagedMediaSource, MediaSource, or WebKitMediaSource).
   */
  static getMediaSource() {
    return getMediaSource();
  }
  static get Events() {
    return Events;
  }
  static get ErrorTypes() {
    return ErrorTypes;
  }
  static get ErrorDetails() {
    return ErrorDetails;
  }

  /**
   * Get the default configuration applied to new instances.
   */
  static get DefaultConfig() {
    if (!Hls.defaultConfig) {
      return hlsDefaultConfig;
    }
    return Hls.defaultConfig;
  }

  /**
   * Replace the default configuration applied to new instances.
   */
  static set DefaultConfig(defaultConfig) {
    Hls.defaultConfig = defaultConfig;
  }

  /**
   * Creates an instance of an HLS client that can attach to exactly one `HTMLMediaElement`.
   * @param userConfig - Configuration options applied over `Hls.DefaultConfig`
   */
  constructor(userConfig = {}) {
    /**
     * The runtime configuration used by the player. At instantiation this is combination of `hls.userConfig` merged over `Hls.DefaultConfig`.
     */
    this.config = void 0;
    /**
     * The configuration object provided on player instantiation.
     */
    this.userConfig = void 0;
    this.coreComponents = void 0;
    this.networkControllers = void 0;
    this.started = false;
    this._emitter = new EventEmitter();
    this._autoLevelCapping = -1;
    this._maxHdcpLevel = null;
    this.abrController = void 0;
    this.bufferController = void 0;
    this.capLevelController = void 0;
    this.latencyController = void 0;
    this.levelController = void 0;
    this.streamController = void 0;
    this.audioTrackController = void 0;
    this.subtitleTrackController = void 0;
    this.emeController = void 0;
    this.cmcdController = void 0;
    this._media = null;
    this.url = null;
    this.triggeringException = void 0;
    enableLogs(userConfig.debug || false, 'Hls instance');
    const config = this.config = mergeConfig(Hls.DefaultConfig, userConfig);
    this.userConfig = userConfig;
    if (config.progressive) {
      enableStreamingMode(config);
    }

    // core controllers and network loaders
    const {
      abrController: ConfigAbrController,
      bufferController: ConfigBufferController,
      capLevelController: ConfigCapLevelController,
      errorController: ConfigErrorController,
      fpsController: ConfigFpsController
    } = config;
    const errorController = new ConfigErrorController(this);
    const abrController = this.abrController = new ConfigAbrController(this);
    const bufferController = this.bufferController = new ConfigBufferController(this);
    const capLevelController = this.capLevelController = new ConfigCapLevelController(this);
    const fpsController = new ConfigFpsController(this);
    const playListLoader = new PlaylistLoader(this);
    const id3TrackController = new ID3TrackController(this);
    const ConfigContentSteeringController = config.contentSteeringController;
    // ConentSteeringController is defined before LevelController to receive Multivariant Playlist events first
    const contentSteering = ConfigContentSteeringController ? new ConfigContentSteeringController(this) : null;
    const levelController = this.levelController = new LevelController(this, contentSteering);
    // FragmentTracker must be defined before StreamController because the order of event handling is important
    const fragmentTracker = new FragmentTracker(this);
    const keyLoader = new KeyLoader(this.config);
    const streamController = this.streamController = new StreamController(this, fragmentTracker, keyLoader);

    // Cap level controller uses streamController to flush the buffer
    capLevelController.setStreamController(streamController);
    // fpsController uses streamController to switch when frames are being dropped
    fpsController.setStreamController(streamController);
    const networkControllers = [playListLoader, levelController, streamController];
    if (contentSteering) {
      networkControllers.splice(1, 0, contentSteering);
    }
    this.networkControllers = networkControllers;
    const coreComponents = [abrController, bufferController, capLevelController, fpsController, id3TrackController, fragmentTracker];
    this.audioTrackController = this.createController(config.audioTrackController, networkControllers);
    const AudioStreamControllerClass = config.audioStreamController;
    if (AudioStreamControllerClass) {
      networkControllers.push(new AudioStreamControllerClass(this, fragmentTracker, keyLoader));
    }
    // subtitleTrackController must be defined before subtitleStreamController because the order of event handling is important
    this.subtitleTrackController = this.createController(config.subtitleTrackController, networkControllers);
    const SubtitleStreamControllerClass = config.subtitleStreamController;
    if (SubtitleStreamControllerClass) {
      networkControllers.push(new SubtitleStreamControllerClass(this, fragmentTracker, keyLoader));
    }
    this.createController(config.timelineController, coreComponents);
    keyLoader.emeController = this.emeController = this.createController(config.emeController, coreComponents);
    this.cmcdController = this.createController(config.cmcdController, coreComponents);
    this.latencyController = this.createController(LatencyController, coreComponents);
    this.coreComponents = coreComponents;

    // Error controller handles errors before and after all other controllers
    // This listener will be invoked after all other controllers error listeners
    networkControllers.push(errorController);
    const onErrorOut = errorController.onErrorOut;
    if (typeof onErrorOut === 'function') {
      this.on(Events.ERROR, onErrorOut, errorController);
    }
  }
  createController(ControllerClass, components) {
    if (ControllerClass) {
      const controllerInstance = new ControllerClass(this);
      if (components) {
        components.push(controllerInstance);
      }
      return controllerInstance;
    }
    return null;
  }

  // Delegate the EventEmitter through the public API of Hls.js
  on(event, listener, context = this) {
    this._emitter.on(event, listener, context);
  }
  once(event, listener, context = this) {
    this._emitter.once(event, listener, context);
  }
  removeAllListeners(event) {
    this._emitter.removeAllListeners(event);
  }
  off(event, listener, context = this, once) {
    this._emitter.off(event, listener, context, once);
  }
  listeners(event) {
    return this._emitter.listeners(event);
  }
  emit(event, name, eventObject) {
    return this._emitter.emit(event, name, eventObject);
  }
  trigger(event, eventObject) {
    if (this.config.debug) {
      return this.emit(event, event, eventObject);
    } else {
      try {
        return this.emit(event, event, eventObject);
      } catch (error) {
        logger.error('An internal error happened while handling event ' + event + '. Error message: "' + error.message + '". Here is a stacktrace:', error);
        // Prevent recursion in error event handlers that throw #5497
        if (!this.triggeringException) {
          this.triggeringException = true;
          const fatal = event === Events.ERROR;
          this.trigger(Events.ERROR, {
            type: ErrorTypes.OTHER_ERROR,
            details: ErrorDetails.INTERNAL_EXCEPTION,
            fatal,
            event,
            error
          });
          this.triggeringException = false;
        }
      }
    }
    return false;
  }
  listenerCount(event) {
    return this._emitter.listenerCount(event);
  }

  /**
   * Dispose of the instance
   */
  destroy() {
    logger.log('destroy');
    this.trigger(Events.DESTROYING, undefined);
    this.detachMedia();
    this.removeAllListeners();
    this._autoLevelCapping = -1;
    this.url = null;
    this.networkControllers.forEach(component => component.destroy());
    this.networkControllers.length = 0;
    this.coreComponents.forEach(component => component.destroy());
    this.coreComponents.length = 0;
    // Remove any references that could be held in config options or callbacks
    const config = this.config;
    config.xhrSetup = config.fetchSetup = undefined;
    // @ts-ignore
    this.userConfig = null;
  }

  /**
   * Attaches Hls.js to a media element
   */
  attachMedia(media) {
    logger.log('attachMedia');
    this._media = media;
    this.trigger(Events.MEDIA_ATTACHING, {
      media: media
    });
  }

  /**
   * Detach Hls.js from the media
   */
  detachMedia() {
    logger.log('detachMedia');
    this.trigger(Events.MEDIA_DETACHING, undefined);
    this._media = null;
  }

  /**
   * Set the source URL. Can be relative or absolute.
   */
  loadSource(url) {
    this.stopLoad();
    const media = this.media;
    const loadedSource = this.url;
    const loadingSource = this.url = urlToolkitExports.buildAbsoluteURL(self.location.href, url, {
      alwaysNormalize: true
    });
    this._autoLevelCapping = -1;
    this._maxHdcpLevel = null;
    logger.log(`loadSource:${loadingSource}`);
    if (media && loadedSource && (loadedSource !== loadingSource || this.bufferController.hasSourceTypes())) {
      this.detachMedia();
      this.attachMedia(media);
    }
    // when attaching to a source URL, trigger a playlist load
    this.trigger(Events.MANIFEST_LOADING, {
      url: url
    });
  }

  /**
   * Start loading data from the stream source.
   * Depending on default config, client starts loading automatically when a source is set.
   *
   * @param startPosition - Set the start position to stream from.
   * Defaults to -1 (None: starts from earliest point)
   */
  startLoad(startPosition = -1) {
    logger.log(`startLoad(${startPosition})`);
    this.started = true;
    this.networkControllers.forEach(controller => {
      controller.startLoad(startPosition);
    });
  }

  /**
   * Stop loading of any stream data.
   */
  stopLoad() {
    logger.log('stopLoad');
    this.started = false;
    this.networkControllers.forEach(controller => {
      controller.stopLoad();
    });
  }

  /**
   * Resumes stream controller segment loading if previously started.
   */
  resumeBuffering() {
    if (this.started) {
      this.networkControllers.forEach(controller => {
        if ('fragmentLoader' in controller) {
          controller.startLoad(-1);
        }
      });
    }
  }

  /**
   * Stops stream controller segment loading without changing 'started' state like stopLoad().
   * This allows for media buffering to be paused without interupting playlist loading.
   */
  pauseBuffering() {
    this.networkControllers.forEach(controller => {
      if ('fragmentLoader' in controller) {
        controller.stopLoad();
      }
    });
  }

  /**
   * Swap through possible audio codecs in the stream (for example to switch from stereo to 5.1)
   */
  swapAudioCodec() {
    logger.log('swapAudioCodec');
    this.streamController.swapAudioCodec();
  }

  /**
   * When the media-element fails, this allows to detach and then re-attach it
   * as one call (convenience method).
   *
   * Automatic recovery of media-errors by this process is configurable.
   */
  recoverMediaError() {
    logger.log('recoverMediaError');
    const media = this._media;
    this.detachMedia();
    if (media) {
      this.attachMedia(media);
    }
  }
  removeLevel(levelIndex) {
    this.levelController.removeLevel(levelIndex);
  }

  /**
   * @returns an array of levels (variants) sorted by HDCP-LEVEL, RESOLUTION (height), FRAME-RATE, CODECS, VIDEO-RANGE, and BANDWIDTH
   */
  get levels() {
    const levels = this.levelController.levels;
    return levels ? levels : [];
  }

  /**
   * Index of quality level (variant) currently played
   */
  get currentLevel() {
    return this.streamController.currentLevel;
  }

  /**
   * Set quality level index immediately. This will flush the current buffer to replace the quality asap. That means playback will interrupt at least shortly to re-buffer and re-sync eventually. Set to -1 for automatic level selection.
   */
  set currentLevel(newLevel) {
    logger.log(`set currentLevel:${newLevel}`);
    this.levelController.manualLevel = newLevel;
    this.streamController.immediateLevelSwitch();
  }

  /**
   * Index of next quality level loaded as scheduled by stream controller.
   */
  get nextLevel() {
    return this.streamController.nextLevel;
  }

  /**
   * Set quality level index for next loaded data.
   * This will switch the video quality asap, without interrupting playback.
   * May abort current loading of data, and flush parts of buffer (outside currently played fragment region).
   * @param newLevel - Pass -1 for automatic level selection
   */
  set nextLevel(newLevel) {
    logger.log(`set nextLevel:${newLevel}`);
    this.levelController.manualLevel = newLevel;
    this.streamController.nextLevelSwitch();
  }

  /**
   * Return the quality level of the currently or last (of none is loaded currently) segment
   */
  get loadLevel() {
    return this.levelController.level;
  }

  /**
   * Set quality level index for next loaded data in a conservative way.
   * This will switch the quality without flushing, but interrupt current loading.
   * Thus the moment when the quality switch will appear in effect will only be after the already existing buffer.
   * @param newLevel - Pass -1 for automatic level selection
   */
  set loadLevel(newLevel) {
    logger.log(`set loadLevel:${newLevel}`);
    this.levelController.manualLevel = newLevel;
  }

  /**
   * get next quality level loaded
   */
  get nextLoadLevel() {
    return this.levelController.nextLoadLevel;
  }

  /**
   * Set quality level of next loaded segment in a fully "non-destructive" way.
   * Same as `loadLevel` but will wait for next switch (until current loading is done).
   */
  set nextLoadLevel(level) {
    this.levelController.nextLoadLevel = level;
  }

  /**
   * Return "first level": like a default level, if not set,
   * falls back to index of first level referenced in manifest
   */
  get firstLevel() {
    return Math.max(this.levelController.firstLevel, this.minAutoLevel);
  }

  /**
   * Sets "first-level", see getter.
   */
  set firstLevel(newLevel) {
    logger.log(`set firstLevel:${newLevel}`);
    this.levelController.firstLevel = newLevel;
  }

  /**
   * Return the desired start level for the first fragment that will be loaded.
   * The default value of -1 indicates automatic start level selection.
   * Setting hls.nextAutoLevel without setting a startLevel will result in
   * the nextAutoLevel value being used for one fragment load.
   */
  get startLevel() {
    const startLevel = this.levelController.startLevel;
    if (startLevel === -1 && this.abrController.forcedAutoLevel > -1) {
      return this.abrController.forcedAutoLevel;
    }
    return startLevel;
  }

  /**
   * set  start level (level of first fragment that will be played back)
   * if not overrided by user, first level appearing in manifest will be used as start level
   * if -1 : automatic start level selection, playback will start from level matching download bandwidth
   * (determined from download of first segment)
   */
  set startLevel(newLevel) {
    logger.log(`set startLevel:${newLevel}`);
    // if not in automatic start level detection, ensure startLevel is greater than minAutoLevel
    if (newLevel !== -1) {
      newLevel = Math.max(newLevel, this.minAutoLevel);
    }
    this.levelController.startLevel = newLevel;
  }

  /**
   * Whether level capping is enabled.
   * Default value is set via `config.capLevelToPlayerSize`.
   */
  get capLevelToPlayerSize() {
    return this.config.capLevelToPlayerSize;
  }

  /**
   * Enables or disables level capping. If disabled after previously enabled, `nextLevelSwitch` will be immediately called.
   */
  set capLevelToPlayerSize(shouldStartCapping) {
    const newCapLevelToPlayerSize = !!shouldStartCapping;
    if (newCapLevelToPlayerSize !== this.config.capLevelToPlayerSize) {
      if (newCapLevelToPlayerSize) {
        this.capLevelController.startCapping(); // If capping occurs, nextLevelSwitch will happen based on size.
      } else {
        this.capLevelController.stopCapping();
        this.autoLevelCapping = -1;
        this.streamController.nextLevelSwitch(); // Now we're uncapped, get the next level asap.
      }
      this.config.capLevelToPlayerSize = newCapLevelToPlayerSize;
    }
  }

  /**
   * Capping/max level value that should be used by automatic level selection algorithm (`ABRController`)
   */
  get autoLevelCapping() {
    return this._autoLevelCapping;
  }

  /**
   * Returns the current bandwidth estimate in bits per second, when available. Otherwise, `NaN` is returned.
   */
  get bandwidthEstimate() {
    const {
      bwEstimator
    } = this.abrController;
    if (!bwEstimator) {
      return NaN;
    }
    return bwEstimator.getEstimate();
  }
  set bandwidthEstimate(abrEwmaDefaultEstimate) {
    this.abrController.resetEstimator(abrEwmaDefaultEstimate);
  }

  /**
   * get time to first byte estimate
   * @type {number}
   */
  get ttfbEstimate() {
    const {
      bwEstimator
    } = this.abrController;
    if (!bwEstimator) {
      return NaN;
    }
    return bwEstimator.getEstimateTTFB();
  }

  /**
   * Capping/max level value that should be used by automatic level selection algorithm (`ABRController`)
   */
  set autoLevelCapping(newLevel) {
    if (this._autoLevelCapping !== newLevel) {
      logger.log(`set autoLevelCapping:${newLevel}`);
      this._autoLevelCapping = newLevel;
      this.levelController.checkMaxAutoUpdated();
    }
  }
  get maxHdcpLevel() {
    return this._maxHdcpLevel;
  }
  set maxHdcpLevel(value) {
    if (isHdcpLevel(value) && this._maxHdcpLevel !== value) {
      this._maxHdcpLevel = value;
      this.levelController.checkMaxAutoUpdated();
    }
  }

  /**
   * True when automatic level selection enabled
   */
  get autoLevelEnabled() {
    return this.levelController.manualLevel === -1;
  }

  /**
   * Level set manually (if any)
   */
  get manualLevel() {
    return this.levelController.manualLevel;
  }

  /**
   * min level selectable in auto mode according to config.minAutoBitrate
   */
  get minAutoLevel() {
    const {
      levels,
      config: {
        minAutoBitrate
      }
    } = this;
    if (!levels) return 0;
    const len = levels.length;
    for (let i = 0; i < len; i++) {
      if (levels[i].maxBitrate >= minAutoBitrate) {
        return i;
      }
    }
    return 0;
  }

  /**
   * max level selectable in auto mode according to autoLevelCapping
   */
  get maxAutoLevel() {
    const {
      levels,
      autoLevelCapping,
      maxHdcpLevel
    } = this;
    let maxAutoLevel;
    if (autoLevelCapping === -1 && levels != null && levels.length) {
      maxAutoLevel = levels.length - 1;
    } else {
      maxAutoLevel = autoLevelCapping;
    }
    if (maxHdcpLevel) {
      for (let i = maxAutoLevel; i--;) {
        const hdcpLevel = levels[i].attrs['HDCP-LEVEL'];
        if (hdcpLevel && hdcpLevel <= maxHdcpLevel) {
          return i;
        }
      }
    }
    return maxAutoLevel;
  }
  get firstAutoLevel() {
    return this.abrController.firstAutoLevel;
  }

  /**
   * next automatically selected quality level
   */
  get nextAutoLevel() {
    return this.abrController.nextAutoLevel;
  }

  /**
   * this setter is used to force next auto level.
   * this is useful to force a switch down in auto mode:
   * in case of load error on level N, hls.js can set nextAutoLevel to N-1 for example)
   * forced value is valid for one fragment. upon successful frag loading at forced level,
   * this value will be resetted to -1 by ABR controller.
   */
  set nextAutoLevel(nextLevel) {
    this.abrController.nextAutoLevel = nextLevel;
  }

  /**
   * get the datetime value relative to media.currentTime for the active level Program Date Time if present
   */
  get playingDate() {
    return this.streamController.currentProgramDateTime;
  }
  get mainForwardBufferInfo() {
    return this.streamController.getMainFwdBufferInfo();
  }

  /**
   * Find and select the best matching audio track, making a level switch when a Group change is necessary.
   * Updates `hls.config.audioPreference`. Returns the selected track, or null when no matching track is found.
   */
  setAudioOption(audioOption) {
    var _this$audioTrackContr;
    return (_this$audioTrackContr = this.audioTrackController) == null ? void 0 : _this$audioTrackContr.setAudioOption(audioOption);
  }
  /**
   * Find and select the best matching subtitle track, making a level switch when a Group change is necessary.
   * Updates `hls.config.subtitlePreference`. Returns the selected track, or null when no matching track is found.
   */
  setSubtitleOption(subtitleOption) {
    var _this$subtitleTrackCo;
    (_this$subtitleTrackCo = this.subtitleTrackController) == null ? void 0 : _this$subtitleTrackCo.setSubtitleOption(subtitleOption);
    return null;
  }

  /**
   * Get the complete list of audio tracks across all media groups
   */
  get allAudioTracks() {
    const audioTrackController = this.audioTrackController;
    return audioTrackController ? audioTrackController.allAudioTracks : [];
  }

  /**
   * Get the list of selectable audio tracks
   */
  get audioTracks() {
    const audioTrackController = this.audioTrackController;
    return audioTrackController ? audioTrackController.audioTracks : [];
  }

  /**
   * index of the selected audio track (index in audio track lists)
   */
  get audioTrack() {
    const audioTrackController = this.audioTrackController;
    return audioTrackController ? audioTrackController.audioTrack : -1;
  }

  /**
   * selects an audio track, based on its index in audio track lists
   */
  set audioTrack(audioTrackId) {
    const audioTrackController = this.audioTrackController;
    if (audioTrackController) {
      audioTrackController.audioTrack = audioTrackId;
    }
  }

  /**
   * get the complete list of subtitle tracks across all media groups
   */
  get allSubtitleTracks() {
    const subtitleTrackController = this.subtitleTrackController;
    return subtitleTrackController ? subtitleTrackController.allSubtitleTracks : [];
  }

  /**
   * get alternate subtitle tracks list from playlist
   */
  get subtitleTracks() {
    const subtitleTrackController = this.subtitleTrackController;
    return subtitleTrackController ? subtitleTrackController.subtitleTracks : [];
  }

  /**
   * index of the selected subtitle track (index in subtitle track lists)
   */
  get subtitleTrack() {
    const subtitleTrackController = this.subtitleTrackController;
    return subtitleTrackController ? subtitleTrackController.subtitleTrack : -1;
  }
  get media() {
    return this._media;
  }

  /**
   * select an subtitle track, based on its index in subtitle track lists
   */
  set subtitleTrack(subtitleTrackId) {
    const subtitleTrackController = this.subtitleTrackController;
    if (subtitleTrackController) {
      subtitleTrackController.subtitleTrack = subtitleTrackId;
    }
  }

  /**
   * Whether subtitle display is enabled or not
   */
  get subtitleDisplay() {
    const subtitleTrackController = this.subtitleTrackController;
    return subtitleTrackController ? subtitleTrackController.subtitleDisplay : false;
  }

  /**
   * Enable/disable subtitle display rendering
   */
  set subtitleDisplay(value) {
    const subtitleTrackController = this.subtitleTrackController;
    if (subtitleTrackController) {
      subtitleTrackController.subtitleDisplay = value;
    }
  }

  /**
   * get mode for Low-Latency HLS loading
   */
  get lowLatencyMode() {
    return this.config.lowLatencyMode;
  }

  /**
   * Enable/disable Low-Latency HLS part playlist and segment loading, and start live streams at playlist PART-HOLD-BACK rather than HOLD-BACK.
   */
  set lowLatencyMode(mode) {
    this.config.lowLatencyMode = mode;
  }

  /**
   * Position (in seconds) of live sync point (ie edge of live position minus safety delay defined by ```hls.config.liveSyncDuration```)
   * @returns null prior to loading live Playlist
   */
  get liveSyncPosition() {
    return this.latencyController.liveSyncPosition;
  }

  /**
   * Estimated position (in seconds) of live edge (ie edge of live playlist plus time sync playlist advanced)
   * @returns 0 before first playlist is loaded
   */
  get latency() {
    return this.latencyController.latency;
  }

  /**
   * maximum distance from the edge before the player seeks forward to ```hls.liveSyncPosition```
   * configured using ```liveMaxLatencyDurationCount``` (multiple of target duration) or ```liveMaxLatencyDuration```
   * @returns 0 before first playlist is loaded
   */
  get maxLatency() {
    return this.latencyController.maxLatency;
  }

  /**
   * target distance from the edge as calculated by the latency controller
   */
  get targetLatency() {
    return this.latencyController.targetLatency;
  }

  /**
   * the rate at which the edge of the current live playlist is advancing or 1 if there is none
   */
  get drift() {
    return this.latencyController.drift;
  }

  /**
   * set to true when startLoad is called before MANIFEST_PARSED event
   */
  get forceStartLoad() {
    return this.streamController.forceStartLoad;
  }
}
Hls.defaultConfig = void 0;

var hls = /*#__PURE__*/Object.freeze({
  __proto__: null,
  AbrController: AbrController,
  AttrList: AttrList,
  AudioStreamController: AudioStreamController,
  AudioTrackController: AudioTrackController,
  BasePlaylistController: BasePlaylistController,
  BaseSegment: BaseSegment,
  BaseStreamController: BaseStreamController,
  BufferController: BufferController,
  CMCDController: CMCDController,
  CapLevelController: CapLevelController,
  ChunkMetadata: ChunkMetadata,
  ContentSteeringController: ContentSteeringController,
  DateRange: DateRange,
  EMEController: EMEController,
  ErrorActionFlags: ErrorActionFlags,
  ErrorController: ErrorController,
  ErrorDetails: ErrorDetails,
  ErrorTypes: ErrorTypes,
  Events: Events,
  FPSController: FPSController,
  Fragment: Fragment,
  Hls: Hls,
  HlsSkip: HlsSkip,
  HlsUrlParameters: HlsUrlParameters,
  KeySystemFormats: KeySystemFormats,
  KeySystems: KeySystems,
  Level: Level,
  LevelDetails: LevelDetails,
  LevelKey: LevelKey,
  LoadStats: LoadStats,
  MetadataSchema: MetadataSchema,
  NetworkErrorAction: NetworkErrorAction,
  Part: Part,
  PlaylistLevelType: PlaylistLevelType,
  SubtitleStreamController: SubtitleStreamController,
  SubtitleTrackController: SubtitleTrackController,
  TimelineController: TimelineController,
  default: Hls,
  getMediaSource: getMediaSource,
  isMSESupported: isMSESupported,
  isSupported: isSupported
});


//# sourceMappingURL=index.es.js.map


/***/ }),

/***/ 44599:
/***/ (function(module) {

function webpackEmptyContext(req) {
	var e = new Error("Cannot find module '" + req + "'");
	e.code = 'MODULE_NOT_FOUND';
	throw e;
}
webpackEmptyContext.keys = function() { return []; };
webpackEmptyContext.resolve = webpackEmptyContext;
webpackEmptyContext.id = 44599;
module.exports = webpackEmptyContext;

/***/ }),

/***/ 33328:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "L": function() { return /* binding */ Loading; },
/* harmony export */   "R": function() { return /* binding */ ResizeImage; }
/* harmony export */ });
/* unused harmony exports D, m */
/* harmony import */ var _common_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(68479);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(83128);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(75271);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(57834);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(52814);
/* harmony import */ var _hooks_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(65081);
/* harmony import */ var _bucketplace_lib__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(94834);
/* harmony import */ var _utils_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(85353);
/* harmony import */ var _foundation_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(54939);










var DEFAULT_WIDTH = 240;
var PIXEL_RATIOS = [1.5, 2, 3];
var DEFAULT_RESIZE_IMAGE = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAQSURBVHgBAQUA+v8AAAAAAAAFAAFkeJU4AAAAAElFTkSuQmCC';
var ResizeImage = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_0__.memo)(function (_a) {
  var src = _a.src,
    alt = _a.alt,
    style = _a.style,
    className = _a.className,
    quality = _a.quality,
    objectFit = _a.objectFit,
    placeholderColor = _a.placeholderColor,
    _b = _a.intrinsicInitialWidth,
    intrinsicInitialWidth = _b === void 0 ? DEFAULT_WIDTH : _b,
    intrinsicInitialHeight = _a.intrinsicInitialHeight,
    intrinsicAspect = _a.intrinsicAspect,
    _c = _a.lazy,
    lazy = _c === void 0 ? {
      threshold: 0
    } : _c,
    onError = _a.onError,
    rest = (0,_common_js__WEBPACK_IMPORTED_MODULE_2__.e)(_a, ["src", "alt", "style", "className", "quality", "objectFit", "placeholderColor", "intrinsicInitialWidth", "intrinsicInitialHeight", "intrinsicAspect", "lazy", "onError"]);
  var theme = (0,_emotion_react__WEBPACK_IMPORTED_MODULE_3__.u)();
  var getImageOptions = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function () {
    return (0,_common_js__WEBPACK_IMPORTED_MODULE_2__.a)((0,_common_js__WEBPACK_IMPORTED_MODULE_2__.a)({
      src: src,
      quality: quality
    }, (0,_utils_js__WEBPACK_IMPORTED_MODULE_4__.d)({
      width: intrinsicInitialWidth,
      height: intrinsicInitialHeight,
      aspect: intrinsicAspect
    })), intrinsicAspect && {
      mode: 'cover'
    });
  }, [src, intrinsicAspect, intrinsicInitialWidth, intrinsicInitialHeight, quality]);
  var _d = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(function () {
      return getImageOptions();
    }),
    image = _d[0],
    setImage = _d[1];
  var _e = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false),
    isLoaded = _e[0],
    setLoaded = _e[1];
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    setImage(getImageOptions());
    setLoaded(false);
  }, [src, intrinsicAspect, getImageOptions]);
  var handleChangeImgNodeSize = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function (size) {
    if (size.width === 0 || size.height === 0 || !isLoaded) return;
    setImage(function (image) {
      if (size.width > (image.width || 0) || size.height > (image.height || 0)) {
        var width = (0,_utils_js__WEBPACK_IMPORTED_MODULE_4__.c)(size.width);
        var height = Math.ceil(width * size.height / size.width);
        return (0,_common_js__WEBPACK_IMPORTED_MODULE_2__.a)((0,_common_js__WEBPACK_IMPORTED_MODULE_2__.a)((0,_common_js__WEBPACK_IMPORTED_MODULE_2__.a)({}, image), typeof image.width !== 'undefined' && {
          width: width
        }), typeof image.height !== 'undefined' && {
          height: height
        });
      }
      return image;
    });
  }, [isLoaded]);
  var imgNodeRef = (0,_hooks_js__WEBPACK_IMPORTED_MODULE_5__.i)(handleChangeImgNodeSize, [isLoaded]);
  var imgCSS = /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_6__/* .css */ .iv)(templateObject_3$2 || (templateObject_3$2 = (0,_common_js__WEBPACK_IMPORTED_MODULE_2__._)(["\n    ", "\n    ", "\n  " + ( true ? "" : 0)], ["\n    ", "\n    ", "\n  " + ( true ? "" : 0)])), objectFit && /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_6__/* .css */ .iv)(templateObject_1$2 || (templateObject_1$2 = (0,_common_js__WEBPACK_IMPORTED_MODULE_2__._)(["\n      width: 100%;\n      height: 100%;\n      object-fit: ", ";\n    " + ( true ? "" : 0)], ["\n      width: 100%;\n      height: 100%;\n      object-fit: ", ";\n    " + ( true ? "" : 0)])), objectFit), !isLoaded && /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_6__/* .css */ .iv)(templateObject_2$2 || (templateObject_2$2 = (0,_common_js__WEBPACK_IMPORTED_MODULE_2__._)(["\n      background-color: ", ";\n    " + ( true ? "" : 0)], ["\n      background-color: ", ";\n    " + ( true ? "" : 0)])), placeholderColor || theme.content.base4));
  var _f = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(!lazy),
    isLazyRendered = _f[0],
    setLazyRendered = _f[1];
  if (!isLazyRendered) {
    return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsx */ .tZ)(_common_js__WEBPACK_IMPORTED_MODULE_2__.I, (0,_common_js__WEBPACK_IMPORTED_MODULE_2__.a)({
      onIntersect: function onIntersect() {
        return setLazyRendered(true);
      }
    }, lazy, {
      style: style,
      className: className
    }, {
      children: (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsx */ .tZ)("img", {
        // 1x1 transparent image
        src: DEFAULT_RESIZE_IMAGE,
        style: style,
        css: imgCSS,
        className: className,
        alt: "",
        "aria-label": rest['aria-label']
      })
    }));
  }
  var imageSrc = (0,_utils_js__WEBPACK_IMPORTED_MODULE_4__.a)(image);
  var imageSrcSet = (0,_utils_js__WEBPACK_IMPORTED_MODULE_4__.b)(image, PIXEL_RATIOS);
  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsx */ .tZ)("img", {
    src: imageSrc,
    srcSet: imageSrcSet,
    ref: imgNodeRef,
    alt: alt,
    style: style,
    css: imgCSS,
    className: className,
    onError: onError,
    onLoad: function onLoad() {
      return setLoaded(true);
    },
    "aria-label": rest['aria-label']
  });
});
var templateObject_1$2, templateObject_2$2, templateObject_3$2;

function cssDotColors(_a) {
  var dotBackgroundColor = _a.dotBackgroundColor,
    boxShadow = _a.boxShadow;
  return /*#__PURE__*/css(templateObject_1$1 || (templateObject_1$1 = __makeTemplateObject(["\n    background-color: ", ";\n    box-shadow: ", ";\n  " + ( true ? "" : 0)], ["\n    background-color: ", ";\n    box-shadow: ", ";\n  " + ( true ? "" : 0)])), dotBackgroundColor, boxShadow);
}
function cssCurrentDot(_a) {
  var activeDotBackgroundColor = _a.activeDotBackgroundColor,
    boxShadow = _a.boxShadow;
  return /*#__PURE__*/css(templateObject_2$1 || (templateObject_2$1 = __makeTemplateObject(["\n    background-color: ", ";\n    box-shadow: ", ";\n  " + ( true ? "" : 0)], ["\n    background-color: ", ";\n    box-shadow: ", ";\n  " + ( true ? "" : 0)])), activeDotBackgroundColor, boxShadow);
}
function cssDotSize(size) {
  return /*#__PURE__*/css(templateObject_3$1 || (templateObject_3$1 = __makeTemplateObject(["\n    width: ", ";\n    height: ", ";\n    ", ";\n  " + ( true ? "" : 0)], ["\n    width: ", ";\n    height: ", ";\n    ", ";\n  " + ( true ? "" : 0)])), pxToRem(size), pxToRem(size), size === 0 ? "margin: ".concat(pxToRem(0)) : '');
}
function makeIndicatorDots(settings) {
  var dotSize = settings.dotSize;
  return function (_a) {
    var maxPage = _a.maxPage,
      _b = _a.currentPage,
      currentPage = _b === void 0 ? 1 : _b,
      _onClick = _a.onClick,
      rest = __rest(_a, ["maxPage", "currentPage", "onClick"]);
    var _c = useState(currentPage - 1),
      currentIndex = _c[0],
      setCurrentIndex = _c[1];
    var isCurrentDot = function isCurrentDot(index) {
      return index === currentIndex;
    };
    useEffect(function () {
      setCurrentIndex(currentPage - 1);
    }, [currentPage]);
    if (maxPage <= 1) return null;
    return jsx("ul", _assign({
      css: /*#__PURE__*/css(templateObject_4$1 || (templateObject_4$1 = __makeTemplateObject(["\n        text-align: center;\n        white-space: nowrap;\n        font-size: 0;\n        line-height: 0;\n        padding: 0;\n      " + ( true ? "" : 0)], ["\n        text-align: center;\n        white-space: nowrap;\n        font-size: 0;\n        line-height: 0;\n        padding: 0;\n      " + ( true ? "" : 0)])))
    }, rest, {
      children: Array(maxPage).fill(0).map(function (_, index) {
        return jsx("li", _assign({
          css: /*#__PURE__*/css(templateObject_5$1 || (templateObject_5$1 = __makeTemplateObject(["\n                margin: 0;\n                padding: 0;\n                height: 0;\n                vertical-align: bottom;\n                display: inline-block;\n              " + ( true ? "" : 0)], ["\n                margin: 0;\n                padding: 0;\n                height: 0;\n                vertical-align: bottom;\n                display: inline-block;\n              " + ( true ? "" : 0)])))
        }, {
          children: jsx("button", {
            type: "button",
            "aria-label": "".concat(index + 1, " \uD398\uC774\uC9C0"),
            "aria-current": isCurrentDot(index) ? 'true' : undefined,
            onClick: function onClick() {
              setCurrentIndex(index);
              _onClick === null || _onClick === void 0 ? void 0 : _onClick(index);
            },
            css: [/*#__PURE__*/css(templateObject_6$1 || (templateObject_6$1 = __makeTemplateObject(["\n                    ", "\n                    border-radius: 50%;\n                    transition: 0.15s background-color, 0.15s width, 0.15s height;\n                    transform: translateY(-50%);\n                    box-sizing: border-box;\n                    margin: 0 ", ";\n                  " + ( true ? "" : 0)], ["\n                    ", "\n                    border-radius: 50%;\n                    transition: 0.15s background-color, 0.15s width, 0.15s height;\n                    transform: translateY(-50%);\n                    box-sizing: border-box;\n                    margin: 0 ", ";\n                  " + ( true ? "" : 0)])), RESET_BUTTON, pxToRem(3)), cssDotColors(settings), isCurrentDot(index) && cssCurrentDot(settings), cssDotSize(dotSize(index, maxPage, currentIndex))]
          })
        }), "dot-".concat(index));
      })
    }));
  };
}
var templateObject_1$1, templateObject_2$1, templateObject_3$1, templateObject_4$1, templateObject_5$1, templateObject_6$1;

var rotate = (0,_emotion_react__WEBPACK_IMPORTED_MODULE_6__/* .keyframes */ .F4)(templateObject_1 || (templateObject_1 = (0,_common_js__WEBPACK_IMPORTED_MODULE_2__._)(["\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n"], ["\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n"])));
function cssVariant(theme, variant, onDimmed) {
  switch (variant) {
    case 'default':
      return /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_6__/* .css */ .iv)(templateObject_2 || (templateObject_2 = (0,_common_js__WEBPACK_IMPORTED_MODULE_2__._)(["\n        border-color: ", ";\n        border-top-color: ", ";\n      " + ( true ? "" : 0)], ["\n        border-color: ", ";\n        border-top-color: ", ";\n      " + ( true ? "" : 0)])), theme.dim.onDark.thick, theme.content.white);
    case 'white':
      return /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_6__/* .css */ .iv)(templateObject_3 || (templateObject_3 = (0,_common_js__WEBPACK_IMPORTED_MODULE_2__._)(["\n        border-color: ", ";\n        border-top-color: ", ";\n      " + ( true ? "" : 0)], ["\n        border-color: ", ";\n        border-top-color: ", ";\n      " + ( true ? "" : 0)])), theme.dim.onDark.basic, theme.content.white);
    case 'base1':
      return /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_6__/* .css */ .iv)(templateObject_4 || (templateObject_4 = (0,_common_js__WEBPACK_IMPORTED_MODULE_2__._)(["\n        border-color: ", ";\n        border-top-color: ", ";\n      " + ( true ? "" : 0)], ["\n        border-color: ", ";\n        border-top-color: ", ";\n      " + ( true ? "" : 0)])), onDimmed ? theme.content.base6 : theme.content.base5, theme.content.base1);
    case 'primary1':
    case 'primary2':
    case 'primary3':
    case 'primary4':
      return /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_6__/* .css */ .iv)(templateObject_5 || (templateObject_5 = (0,_common_js__WEBPACK_IMPORTED_MODULE_2__._)(["\n        border-color: ", ";\n        border-top-color: ", ";\n      " + ( true ? "" : 0)], ["\n        border-color: ", ";\n        border-top-color: ", ";\n      " + ( true ? "" : 0)])), onDimmed ? theme.content.base6 : theme.content[variant].thin, theme.content[variant].basic);
  }
}
function Loading(_a) {
  var _b = _a.disabled,
    disabled = _b === void 0 ? false : _b,
    _c = _a.variant,
    variant = _c === void 0 ? 'default' : _c,
    _d = _a.onDimmed,
    onDimmed = _d === void 0 ? false : _d,
    rest = (0,_common_js__WEBPACK_IMPORTED_MODULE_2__.e)(_a, ["disabled", "variant", "onDimmed"]);
  var theme = (0,_emotion_react__WEBPACK_IMPORTED_MODULE_3__.u)();
  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsx */ .tZ)("div", (0,_common_js__WEBPACK_IMPORTED_MODULE_2__.a)({}, rest, {
    css: /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_6__/* .css */ .iv)(templateObject_6 || (templateObject_6 = (0,_common_js__WEBPACK_IMPORTED_MODULE_2__._)(["\n        display: inline-block;\n        width: ", ";\n        height: ", ";\n      " + ( true ? "" : 0)], ["\n        display: inline-block;\n        width: ", ";\n        height: ", ";\n      " + ( true ? "" : 0)])), (0,_foundation_js__WEBPACK_IMPORTED_MODULE_8__.p)(24), (0,_foundation_js__WEBPACK_IMPORTED_MODULE_8__.p)(24))
  }, {
    children: (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsx */ .tZ)("div", {
      css: [/*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_6__/* .css */ .iv)(templateObject_7 || (templateObject_7 = (0,_common_js__WEBPACK_IMPORTED_MODULE_2__._)(["\n            border-radius: 50%;\n            width: 100%;\n            height: 100%;\n            border: ", " solid;\n            animation: ", " 1.1s infinite linear;\n            box-sizing: border-box;\n          " + ( true ? "" : 0)], ["\n            border-radius: 50%;\n            width: 100%;\n            height: 100%;\n            border: ", " solid;\n            animation: ", " 1.1s infinite linear;\n            box-sizing: border-box;\n          " + ( true ? "" : 0)])), (0,_foundation_js__WEBPACK_IMPORTED_MODULE_8__.p)(2), rotate), disabled ? /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_6__/* .css */ .iv)(templateObject_8 || (templateObject_8 = (0,_common_js__WEBPACK_IMPORTED_MODULE_2__._)(["\n                border-color: ", ";\n                border-top-color: ", ";\n              " + ( true ? "" : 0)], ["\n                border-color: ", ";\n                border-top-color: ", ";\n              " + ( true ? "" : 0)])), theme.content.base3, theme.content.white) : cssVariant(theme, variant, onDimmed)]
    })
  }));
}
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8;


//# sourceMappingURL=Loading.js.map


/***/ }),

/***/ 85435:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "ANg": function() { return /* binding */ AnchorButton; },
  "qEK": function() { return /* binding */ Avatar; },
  "zxk": function() { return /* binding */ Button$2; },
  "bdp": function() { return /* binding */ COLUMN_PRESET; },
  "UWt": function() { return /* binding */ Callout; },
  "SOM": function() { return /* binding */ CarouselControlButton; },
  "ffs": function() { return /* binding */ CarouselScrollControl; },
  "EG1": function() { return /* binding */ CheckboxWithText; },
  "AfN": function() { return /* binding */ Chip; },
  "rUs": function() { return /* binding */ CircleImage; },
  "W20": function() { return /* binding */ Container$4; },
  "SHs": function() { return /* binding */ DEFAULT_GAP; },
  "izJ": function() { return /* binding */ Divider$1; },
  "vkq": function() { return /* binding */ DividerListItem; },
  "dys": function() { return /* binding */ Drawer; },
  "Ltx": function() { return /* binding */ Dropdown; },
  "nn_": function() { return /* binding */ EmptyPage; },
  "rjZ": function() { return /* binding */ Grid; },
  "P4e": function() { return /* binding */ GridItem; },
  "JO$": function() { return /* binding */ Icon; },
  "pPA": function() { return /* binding */ IconNotification; },
  "IIB": function() { return /* binding */ Input$1; },
  "u_l": function() { return /* binding */ Modal; },
  "ZiW": function() { return /* binding */ NavigationTopBanner; },
  "k$E": function() { return /* binding */ NotificationType; },
  "wbw": function() { return /* binding */ OhouseFooter; },
  "Ths": function() { return /* binding */ OutlineAnchorButton; },
  "f5": function() { return /* binding */ OutlineButton; },
  "BC7": function() { return /* binding */ OutlineButtonWithIcon; },
  "kbF": function() { return /* binding */ OutlineFileButton; },
  "tlE": function() { return /* binding */ Pagination$1; },
  "rDy": function() { return /* binding */ Popper; },
  "r0l": function() { return /* binding */ RadioWithText; },
  "VOb": function() { return /* binding */ SEARCH_TYPE; },
  "olm": function() { return /* binding */ Search; },
  "PhF": function() { return /* binding */ Select; },
  "WKm": function() { return /* binding */ SelectChip; },
  "zRs": function() { return /* binding */ SquareBadge; },
  "DWR": function() { return /* binding */ StoreCategory; },
  "PgY": function() { return /* binding */ TOTAL_COLUMN; },
  "OK9": function() { return /* binding */ Tab; },
  "E2J": function() { return /* binding */ TabItem; },
  "iA_": function() { return /* binding */ Table; },
  "C5u": function() { return /* binding */ TableData; },
  "xDH": function() { return /* binding */ TableHeader; },
  "SCH": function() { return /* binding */ TableRow; },
  "Avr": function() { return /* binding */ TextButton; },
  "fj3": function() { return /* binding */ TextButtonWithIcon; },
  "gxH": function() { return /* binding */ Textarea; },
  "ZDl": function() { return /* binding */ Toggle; },
  "COr": function() { return /* binding */ ToggleButton; },
  "ua7": function() { return /* binding */ Tooltip; },
  "xd5": function() { return /* binding */ createOhouseFooterLinkSchema; },
  "j6W": function() { return /* binding */ getWithIconOptions; }
});

// UNUSED EXPORTS: ADDRESS, AnchorButtonWithIcon, Animation, AppDownloadPopup, AppDownloadPopupContainer, BUCKETPLACE_HOMEPAGE_URL, BaseSticky, Breadcrumb, ButtonWithIcon, COPYRIGHT_TEXT, Carousel, CarouselControl, Checkbox, CircleBadge, Column, CompanyLink, CounterHint, DEFAULT_STICKY_STATE, Dim, DimLoading, DotNotification, EMAIL, ExtendedFab, ExtendedFabWithIcon, FETCH_STATUS, Fab, FileButton, FileButtonWithIcon, FileInputLabel, FillOutlineSelectChip, FixedTab, Footer, FooterComponenet, Hint, IconFab, Image, ImageAttachedItem, ImageUploadButton, IndicatorDots, IndicatorNumber, IndicatorNumberWithIcon, InputChip, InputWithCountHint, InputWithHint, InputWithThumbnail, LinearProgressBar, LinkContext, LinkProvider, ListItem, Loading, MobileTopBanner, MoreAnchor, NaverPostSvg, Navigation, NavigationBar, NavigationDrawer, NavigationRightButton, NavigationSearch, NotSupportedBrowser, NumberNotification, OPENING_HOUR, OutlineAnchorButtonWithIcon, OutlineFileButtonWithIcon, OutlineSelectChip, PCTopBanner, PHONE_NUMBER, PillBadge, PinterestSvg, PrimaryRight, Radio, Ranking, ReactComponent, Responsive, Row, ScrollSticky, SectionTitle, SelectButton, SelectWithHint, SimpleFooter, SocialLink, Sticky, StickyControlContext, StickyProvider, StickyValueContext, TABLE_HIGHLIGHT_STYLE, TOGGLE_SIZE, TYPE_MAP, TableDataImpl, TableHeaderWithAction, TextareaWithCountHint, TextareaWithHint, TextareaWithThumbnail, ThumbnailAnchor, ThumbnailAnchorWithBadge, TikTokSvg, TopBannerContainer, UploadDropdownContentButton, UploadDropdownContentItem, UserDropdownContentButton, UserDropdownContentItem, VirtualizedList, YoutubeSvg, assertStickyParentPosition, createScrollStorage, cssBaseButton, cssDimmed, cssFontWeight, cssSize, dotSize, getStickyChildStyle, getStickyContainerStyle, getTextButtonWithIconOptions, getUpdatedStickyState, hasStickyStateChanged, setCookie, useBaseSticky, useGetStickyHeight, useLinkContext, useNodeHeight, usePagedCursorInfiniteList, usePagedInfiniteList, useScrollAppear, useScrollDirection, useSticky

// EXTERNAL MODULE: ./node_modules/.pnpm/@bucketplace+design-system@5.3.3_@bucketplace+ui@1.0.9_@emotion+react@11.13.3_@emotion+styled_gws5alfnqy5ixwsabrkna3jsv4/node_modules/@bucketplace/design-system/dist/esm/common.js + 1 modules
var common = __webpack_require__(68479);
// EXTERNAL MODULE: ./node_modules/.pnpm/@emotion+react@11.13.3_@types+react@18.3.12_react@18.3.1/node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(83128);
// EXTERNAL MODULE: ./node_modules/.pnpm/@emotion+react@11.13.3_@types+react@18.3.12_react@18.3.1/node_modules/@emotion/react/dist/emotion-react.browser.esm.js
var emotion_react_browser_esm = __webpack_require__(52814);
// EXTERNAL MODULE: ./node_modules/.pnpm/@emotion+react@11.13.3_@types+react@18.3.12_react@18.3.1/node_modules/@emotion/react/dist/emotion-element-5486c51c.browser.esm.js + 1 modules
var emotion_element_5486c51c_browser_esm = __webpack_require__(57834);
// EXTERNAL MODULE: ./node_modules/.pnpm/@bucketplace+design-system@5.3.3_@bucketplace+ui@1.0.9_@emotion+react@11.13.3_@emotion+styled_gws5alfnqy5ixwsabrkna3jsv4/node_modules/@bucketplace/design-system/dist/esm/foundation.js
var foundation = __webpack_require__(54939);
// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.3.1/node_modules/react/index.js
var react = __webpack_require__(75271);
// EXTERNAL MODULE: ./node_modules/.pnpm/@emotion+styled@11.13.0_@emotion+react@11.13.3_@types+react@18.3.12_react@18.3.1/node_modules/@emotion/styled/base/dist/emotion-styled-base.browser.esm.js
var emotion_styled_base_browser_esm = __webpack_require__(12851);
// EXTERNAL MODULE: ./node_modules/.pnpm/@bucketplace+ui@1.0.9_@emotion+react@11.13.3_@emotion+styled@11.13.0_react-dom@18.3.1_react@18.3.1_scheduler@0.23.2/node_modules/@bucketplace/ui/lib-esm/index.js + 45 modules
var lib_esm = __webpack_require__(28746);
// EXTERNAL MODULE: ./node_modules/.pnpm/@bucketplace+design-system@5.3.3_@bucketplace+ui@1.0.9_@emotion+react@11.13.3_@emotion+styled_gws5alfnqy5ixwsabrkna3jsv4/node_modules/@bucketplace/design-system/dist/esm/hooks.js
var hooks = __webpack_require__(65081);
// EXTERNAL MODULE: ./node_modules/.pnpm/@emotion+is-prop-valid@1.3.1/node_modules/@emotion/is-prop-valid/dist/emotion-is-prop-valid.esm.js
var emotion_is_prop_valid_esm = __webpack_require__(2366);
// EXTERNAL MODULE: ./node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/throttle.js
var lodash_throttle = __webpack_require__(38209);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-transition-group@4.4.5_react-dom@18.3.1_react@18.3.1/node_modules/react-transition-group/esm/CSSTransition.js + 10 modules
var esm_CSSTransition = __webpack_require__(58583);
// EXTERNAL MODULE: ./node_modules/.pnpm/qs@6.13.0/node_modules/qs/lib/index.js
var lib = __webpack_require__(93672);
// EXTERNAL MODULE: ./node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/lodash.js
var lodash = __webpack_require__(32699);
// EXTERNAL MODULE: ./node_modules/.pnpm/@bucketplace+lib@0.1.4_@emotion+react@11.13.3_@emotion+styled@11.13.0_react-dom@18.3.1_react@18.3.1/node_modules/@bucketplace/lib/dist/index.es.js
var index_es = __webpack_require__(94834);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-dom@18.3.1_react@18.3.1/node_modules/react-dom/index.js
var react_dom = __webpack_require__(30967);
;// CONCATENATED MODULE: ./node_modules/.pnpm/@popperjs+core@2.11.8/node_modules/@popperjs/core/lib/dom-utils/getWindow.js
function getWindow(node) {
  if (node == null) {
    return window;
  }

  if (node.toString() !== '[object Window]') {
    var ownerDocument = node.ownerDocument;
    return ownerDocument ? ownerDocument.defaultView || window : window;
  }

  return node;
}
;// CONCATENATED MODULE: ./node_modules/.pnpm/@popperjs+core@2.11.8/node_modules/@popperjs/core/lib/dom-utils/instanceOf.js


function isElement(node) {
  var OwnElement = getWindow(node).Element;
  return node instanceof OwnElement || node instanceof Element;
}

function isHTMLElement(node) {
  var OwnElement = getWindow(node).HTMLElement;
  return node instanceof OwnElement || node instanceof HTMLElement;
}

function isShadowRoot(node) {
  // IE 11 has no ShadowRoot
  if (typeof ShadowRoot === 'undefined') {
    return false;
  }

  var OwnElement = getWindow(node).ShadowRoot;
  return node instanceof OwnElement || node instanceof ShadowRoot;
}


;// CONCATENATED MODULE: ./node_modules/.pnpm/@popperjs+core@2.11.8/node_modules/@popperjs/core/lib/utils/math.js
var math_max = Math.max;
var math_min = Math.min;
var round = Math.round;
;// CONCATENATED MODULE: ./node_modules/.pnpm/@popperjs+core@2.11.8/node_modules/@popperjs/core/lib/utils/userAgent.js
function getUAString() {
  var uaData = navigator.userAgentData;

  if (uaData != null && uaData.brands && Array.isArray(uaData.brands)) {
    return uaData.brands.map(function (item) {
      return item.brand + "/" + item.version;
    }).join(' ');
  }

  return navigator.userAgent;
}
;// CONCATENATED MODULE: ./node_modules/.pnpm/@popperjs+core@2.11.8/node_modules/@popperjs/core/lib/dom-utils/isLayoutViewport.js

function isLayoutViewport() {
  return !/^((?!chrome|android).)*safari/i.test(getUAString());
}
;// CONCATENATED MODULE: ./node_modules/.pnpm/@popperjs+core@2.11.8/node_modules/@popperjs/core/lib/dom-utils/getBoundingClientRect.js




function getBoundingClientRect(element, includeScale, isFixedStrategy) {
  if (includeScale === void 0) {
    includeScale = false;
  }

  if (isFixedStrategy === void 0) {
    isFixedStrategy = false;
  }

  var clientRect = element.getBoundingClientRect();
  var scaleX = 1;
  var scaleY = 1;

  if (includeScale && isHTMLElement(element)) {
    scaleX = element.offsetWidth > 0 ? round(clientRect.width) / element.offsetWidth || 1 : 1;
    scaleY = element.offsetHeight > 0 ? round(clientRect.height) / element.offsetHeight || 1 : 1;
  }

  var _ref = isElement(element) ? getWindow(element) : window,
      visualViewport = _ref.visualViewport;

  var addVisualOffsets = !isLayoutViewport() && isFixedStrategy;
  var x = (clientRect.left + (addVisualOffsets && visualViewport ? visualViewport.offsetLeft : 0)) / scaleX;
  var y = (clientRect.top + (addVisualOffsets && visualViewport ? visualViewport.offsetTop : 0)) / scaleY;
  var width = clientRect.width / scaleX;
  var height = clientRect.height / scaleY;
  return {
    width: width,
    height: height,
    top: y,
    right: x + width,
    bottom: y + height,
    left: x,
    x: x,
    y: y
  };
}
;// CONCATENATED MODULE: ./node_modules/.pnpm/@popperjs+core@2.11.8/node_modules/@popperjs/core/lib/dom-utils/getWindowScroll.js

function getWindowScroll(node) {
  var win = getWindow(node);
  var scrollLeft = win.pageXOffset;
  var scrollTop = win.pageYOffset;
  return {
    scrollLeft: scrollLeft,
    scrollTop: scrollTop
  };
}
;// CONCATENATED MODULE: ./node_modules/.pnpm/@popperjs+core@2.11.8/node_modules/@popperjs/core/lib/dom-utils/getHTMLElementScroll.js
function getHTMLElementScroll(element) {
  return {
    scrollLeft: element.scrollLeft,
    scrollTop: element.scrollTop
  };
}
;// CONCATENATED MODULE: ./node_modules/.pnpm/@popperjs+core@2.11.8/node_modules/@popperjs/core/lib/dom-utils/getNodeScroll.js




function getNodeScroll(node) {
  if (node === getWindow(node) || !isHTMLElement(node)) {
    return getWindowScroll(node);
  } else {
    return getHTMLElementScroll(node);
  }
}
;// CONCATENATED MODULE: ./node_modules/.pnpm/@popperjs+core@2.11.8/node_modules/@popperjs/core/lib/dom-utils/getNodeName.js
function getNodeName(element) {
  return element ? (element.nodeName || '').toLowerCase() : null;
}
;// CONCATENATED MODULE: ./node_modules/.pnpm/@popperjs+core@2.11.8/node_modules/@popperjs/core/lib/dom-utils/getDocumentElement.js

function getDocumentElement(element) {
  // $FlowFixMe[incompatible-return]: assume body is always available
  return ((isElement(element) ? element.ownerDocument : // $FlowFixMe[prop-missing]
  element.document) || window.document).documentElement;
}
;// CONCATENATED MODULE: ./node_modules/.pnpm/@popperjs+core@2.11.8/node_modules/@popperjs/core/lib/dom-utils/getWindowScrollBarX.js



function getWindowScrollBarX(element) {
  // If <html> has a CSS width greater than the viewport, then this will be
  // incorrect for RTL.
  // Popper 1 is broken in this case and never had a bug report so let's assume
  // it's not an issue. I don't think anyone ever specifies width on <html>
  // anyway.
  // Browsers where the left scrollbar doesn't cause an issue report `0` for
  // this (e.g. Edge 2019, IE11, Safari)
  return getBoundingClientRect(getDocumentElement(element)).left + getWindowScroll(element).scrollLeft;
}
;// CONCATENATED MODULE: ./node_modules/.pnpm/@popperjs+core@2.11.8/node_modules/@popperjs/core/lib/dom-utils/getComputedStyle.js

function getComputedStyle(element) {
  return getWindow(element).getComputedStyle(element);
}
;// CONCATENATED MODULE: ./node_modules/.pnpm/@popperjs+core@2.11.8/node_modules/@popperjs/core/lib/dom-utils/isScrollParent.js

function isScrollParent(element) {
  // Firefox wants us to check `-x` and `-y` variations as well
  var _getComputedStyle = getComputedStyle(element),
      overflow = _getComputedStyle.overflow,
      overflowX = _getComputedStyle.overflowX,
      overflowY = _getComputedStyle.overflowY;

  return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
}
;// CONCATENATED MODULE: ./node_modules/.pnpm/@popperjs+core@2.11.8/node_modules/@popperjs/core/lib/dom-utils/getCompositeRect.js









function isElementScaled(element) {
  var rect = element.getBoundingClientRect();
  var scaleX = round(rect.width) / element.offsetWidth || 1;
  var scaleY = round(rect.height) / element.offsetHeight || 1;
  return scaleX !== 1 || scaleY !== 1;
} // Returns the composite rect of an element relative to its offsetParent.
// Composite means it takes into account transforms as well as layout.


function getCompositeRect(elementOrVirtualElement, offsetParent, isFixed) {
  if (isFixed === void 0) {
    isFixed = false;
  }

  var isOffsetParentAnElement = isHTMLElement(offsetParent);
  var offsetParentIsScaled = isHTMLElement(offsetParent) && isElementScaled(offsetParent);
  var documentElement = getDocumentElement(offsetParent);
  var rect = getBoundingClientRect(elementOrVirtualElement, offsetParentIsScaled, isFixed);
  var scroll = {
    scrollLeft: 0,
    scrollTop: 0
  };
  var offsets = {
    x: 0,
    y: 0
  };

  if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
    if (getNodeName(offsetParent) !== 'body' || // https://github.com/popperjs/popper-core/issues/1078
    isScrollParent(documentElement)) {
      scroll = getNodeScroll(offsetParent);
    }

    if (isHTMLElement(offsetParent)) {
      offsets = getBoundingClientRect(offsetParent, true);
      offsets.x += offsetParent.clientLeft;
      offsets.y += offsetParent.clientTop;
    } else if (documentElement) {
      offsets.x = getWindowScrollBarX(documentElement);
    }
  }

  return {
    x: rect.left + scroll.scrollLeft - offsets.x,
    y: rect.top + scroll.scrollTop - offsets.y,
    width: rect.width,
    height: rect.height
  };
}
;// CONCATENATED MODULE: ./node_modules/.pnpm/@popperjs+core@2.11.8/node_modules/@popperjs/core/lib/dom-utils/getLayoutRect.js
 // Returns the layout rect of an element relative to its offsetParent. Layout
// means it doesn't take into account transforms.

function getLayoutRect(element) {
  var clientRect = getBoundingClientRect(element); // Use the clientRect sizes if it's not been transformed.
  // Fixes https://github.com/popperjs/popper-core/issues/1223

  var width = element.offsetWidth;
  var height = element.offsetHeight;

  if (Math.abs(clientRect.width - width) <= 1) {
    width = clientRect.width;
  }

  if (Math.abs(clientRect.height - height) <= 1) {
    height = clientRect.height;
  }

  return {
    x: element.offsetLeft,
    y: element.offsetTop,
    width: width,
    height: height
  };
}
;// CONCATENATED MODULE: ./node_modules/.pnpm/@popperjs+core@2.11.8/node_modules/@popperjs/core/lib/dom-utils/getParentNode.js



function getParentNode(element) {
  if (getNodeName(element) === 'html') {
    return element;
  }

  return (// this is a quicker (but less type safe) way to save quite some bytes from the bundle
    // $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    element.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    element.parentNode || ( // DOM Element detected
    isShadowRoot(element) ? element.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    getDocumentElement(element) // fallback

  );
}
;// CONCATENATED MODULE: ./node_modules/.pnpm/@popperjs+core@2.11.8/node_modules/@popperjs/core/lib/dom-utils/getScrollParent.js




function getScrollParent(node) {
  if (['html', 'body', '#document'].indexOf(getNodeName(node)) >= 0) {
    // $FlowFixMe[incompatible-return]: assume body is always available
    return node.ownerDocument.body;
  }

  if (isHTMLElement(node) && isScrollParent(node)) {
    return node;
  }

  return getScrollParent(getParentNode(node));
}
;// CONCATENATED MODULE: ./node_modules/.pnpm/@popperjs+core@2.11.8/node_modules/@popperjs/core/lib/dom-utils/listScrollParents.js




/*
given a DOM element, return the list of all scroll parents, up the list of ancesors
until we get to the top window object. This list is what we attach scroll listeners
to, because if any of these parent elements scroll, we'll need to re-calculate the
reference element's position.
*/

function listScrollParents(element, list) {
  var _element$ownerDocumen;

  if (list === void 0) {
    list = [];
  }

  var scrollParent = getScrollParent(element);
  var isBody = scrollParent === ((_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body);
  var win = getWindow(scrollParent);
  var target = isBody ? [win].concat(win.visualViewport || [], isScrollParent(scrollParent) ? scrollParent : []) : scrollParent;
  var updatedList = list.concat(target);
  return isBody ? updatedList : // $FlowFixMe[incompatible-call]: isBody tells us target will be an HTMLElement here
  updatedList.concat(listScrollParents(getParentNode(target)));
}
;// CONCATENATED MODULE: ./node_modules/.pnpm/@popperjs+core@2.11.8/node_modules/@popperjs/core/lib/dom-utils/isTableElement.js

function isTableElement(element) {
  return ['table', 'td', 'th'].indexOf(getNodeName(element)) >= 0;
}
;// CONCATENATED MODULE: ./node_modules/.pnpm/@popperjs+core@2.11.8/node_modules/@popperjs/core/lib/dom-utils/getOffsetParent.js








function getTrueOffsetParent(element) {
  if (!isHTMLElement(element) || // https://github.com/popperjs/popper-core/issues/837
  getComputedStyle(element).position === 'fixed') {
    return null;
  }

  return element.offsetParent;
} // `.offsetParent` reports `null` for fixed elements, while absolute elements
// return the containing block


function getContainingBlock(element) {
  var isFirefox = /firefox/i.test(getUAString());
  var isIE = /Trident/i.test(getUAString());

  if (isIE && isHTMLElement(element)) {
    // In IE 9, 10 and 11 fixed elements containing block is always established by the viewport
    var elementCss = getComputedStyle(element);

    if (elementCss.position === 'fixed') {
      return null;
    }
  }

  var currentNode = getParentNode(element);

  if (isShadowRoot(currentNode)) {
    currentNode = currentNode.host;
  }

  while (isHTMLElement(currentNode) && ['html', 'body'].indexOf(getNodeName(currentNode)) < 0) {
    var css = getComputedStyle(currentNode); // This is non-exhaustive but covers the most common CSS properties that
    // create a containing block.
    // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block

    if (css.transform !== 'none' || css.perspective !== 'none' || css.contain === 'paint' || ['transform', 'perspective'].indexOf(css.willChange) !== -1 || isFirefox && css.willChange === 'filter' || isFirefox && css.filter && css.filter !== 'none') {
      return currentNode;
    } else {
      currentNode = currentNode.parentNode;
    }
  }

  return null;
} // Gets the closest ancestor positioned element. Handles some edge cases,
// such as table ancestors and cross browser bugs.


function getOffsetParent(element) {
  var window = getWindow(element);
  var offsetParent = getTrueOffsetParent(element);

  while (offsetParent && isTableElement(offsetParent) && getComputedStyle(offsetParent).position === 'static') {
    offsetParent = getTrueOffsetParent(offsetParent);
  }

  if (offsetParent && (getNodeName(offsetParent) === 'html' || getNodeName(offsetParent) === 'body' && getComputedStyle(offsetParent).position === 'static')) {
    return window;
  }

  return offsetParent || getContainingBlock(element) || window;
}
;// CONCATENATED MODULE: ./node_modules/.pnpm/@popperjs+core@2.11.8/node_modules/@popperjs/core/lib/enums.js
var enums_top = 'top';
var bottom = 'bottom';
var right = 'right';
var left = 'left';
var auto = 'auto';
var basePlacements = [enums_top, bottom, right, left];
var start = 'start';
var end = 'end';
var clippingParents = 'clippingParents';
var viewport = 'viewport';
var popper = 'popper';
var reference = 'reference';
var variationPlacements = /*#__PURE__*/basePlacements.reduce(function (acc, placement) {
  return acc.concat([placement + "-" + start, placement + "-" + end]);
}, []);
var enums_placements = /*#__PURE__*/[].concat(basePlacements, [auto]).reduce(function (acc, placement) {
  return acc.concat([placement, placement + "-" + start, placement + "-" + end]);
}, []); // modifiers that need to read the DOM

var beforeRead = 'beforeRead';
var read = 'read';
var afterRead = 'afterRead'; // pure-logic modifiers

var beforeMain = 'beforeMain';
var main = 'main';
var afterMain = 'afterMain'; // modifier with the purpose to write to the DOM (or write into a framework state)

var beforeWrite = 'beforeWrite';
var write = 'write';
var afterWrite = 'afterWrite';
var modifierPhases = [beforeRead, read, afterRead, beforeMain, main, afterMain, beforeWrite, write, afterWrite];
;// CONCATENATED MODULE: ./node_modules/.pnpm/@popperjs+core@2.11.8/node_modules/@popperjs/core/lib/utils/orderModifiers.js
 // source: https://stackoverflow.com/questions/49875255

function order(modifiers) {
  var map = new Map();
  var visited = new Set();
  var result = [];
  modifiers.forEach(function (modifier) {
    map.set(modifier.name, modifier);
  }); // On visiting object, check for its dependencies and visit them recursively

  function sort(modifier) {
    visited.add(modifier.name);
    var requires = [].concat(modifier.requires || [], modifier.requiresIfExists || []);
    requires.forEach(function (dep) {
      if (!visited.has(dep)) {
        var depModifier = map.get(dep);

        if (depModifier) {
          sort(depModifier);
        }
      }
    });
    result.push(modifier);
  }

  modifiers.forEach(function (modifier) {
    if (!visited.has(modifier.name)) {
      // check for visited object
      sort(modifier);
    }
  });
  return result;
}

function orderModifiers(modifiers) {
  // order based on dependencies
  var orderedModifiers = order(modifiers); // order based on phase

  return modifierPhases.reduce(function (acc, phase) {
    return acc.concat(orderedModifiers.filter(function (modifier) {
      return modifier.phase === phase;
    }));
  }, []);
}
;// CONCATENATED MODULE: ./node_modules/.pnpm/@popperjs+core@2.11.8/node_modules/@popperjs/core/lib/utils/debounce.js
function debounce(fn) {
  var pending;
  return function () {
    if (!pending) {
      pending = new Promise(function (resolve) {
        Promise.resolve().then(function () {
          pending = undefined;
          resolve(fn());
        });
      });
    }

    return pending;
  };
}
;// CONCATENATED MODULE: ./node_modules/.pnpm/@popperjs+core@2.11.8/node_modules/@popperjs/core/lib/utils/mergeByName.js
function mergeByName(modifiers) {
  var merged = modifiers.reduce(function (merged, current) {
    var existing = merged[current.name];
    merged[current.name] = existing ? Object.assign({}, existing, current, {
      options: Object.assign({}, existing.options, current.options),
      data: Object.assign({}, existing.data, current.data)
    }) : current;
    return merged;
  }, {}); // IE11 does not support Object.values

  return Object.keys(merged).map(function (key) {
    return merged[key];
  });
}
;// CONCATENATED MODULE: ./node_modules/.pnpm/@popperjs+core@2.11.8/node_modules/@popperjs/core/lib/createPopper.js









var DEFAULT_OPTIONS = {
  placement: 'bottom',
  modifiers: [],
  strategy: 'absolute'
};

function areValidElements() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  return !args.some(function (element) {
    return !(element && typeof element.getBoundingClientRect === 'function');
  });
}

function popperGenerator(generatorOptions) {
  if (generatorOptions === void 0) {
    generatorOptions = {};
  }

  var _generatorOptions = generatorOptions,
      _generatorOptions$def = _generatorOptions.defaultModifiers,
      defaultModifiers = _generatorOptions$def === void 0 ? [] : _generatorOptions$def,
      _generatorOptions$def2 = _generatorOptions.defaultOptions,
      defaultOptions = _generatorOptions$def2 === void 0 ? DEFAULT_OPTIONS : _generatorOptions$def2;
  return function createPopper(reference, popper, options) {
    if (options === void 0) {
      options = defaultOptions;
    }

    var state = {
      placement: 'bottom',
      orderedModifiers: [],
      options: Object.assign({}, DEFAULT_OPTIONS, defaultOptions),
      modifiersData: {},
      elements: {
        reference: reference,
        popper: popper
      },
      attributes: {},
      styles: {}
    };
    var effectCleanupFns = [];
    var isDestroyed = false;
    var instance = {
      state: state,
      setOptions: function setOptions(setOptionsAction) {
        var options = typeof setOptionsAction === 'function' ? setOptionsAction(state.options) : setOptionsAction;
        cleanupModifierEffects();
        state.options = Object.assign({}, defaultOptions, state.options, options);
        state.scrollParents = {
          reference: isElement(reference) ? listScrollParents(reference) : reference.contextElement ? listScrollParents(reference.contextElement) : [],
          popper: listScrollParents(popper)
        }; // Orders the modifiers based on their dependencies and `phase`
        // properties

        var orderedModifiers = orderModifiers(mergeByName([].concat(defaultModifiers, state.options.modifiers))); // Strip out disabled modifiers

        state.orderedModifiers = orderedModifiers.filter(function (m) {
          return m.enabled;
        });
        runModifierEffects();
        return instance.update();
      },
      // Sync update – it will always be executed, even if not necessary. This
      // is useful for low frequency updates where sync behavior simplifies the
      // logic.
      // For high frequency updates (e.g. `resize` and `scroll` events), always
      // prefer the async Popper#update method
      forceUpdate: function forceUpdate() {
        if (isDestroyed) {
          return;
        }

        var _state$elements = state.elements,
            reference = _state$elements.reference,
            popper = _state$elements.popper; // Don't proceed if `reference` or `popper` are not valid elements
        // anymore

        if (!areValidElements(reference, popper)) {
          return;
        } // Store the reference and popper rects to be read by modifiers


        state.rects = {
          reference: getCompositeRect(reference, getOffsetParent(popper), state.options.strategy === 'fixed'),
          popper: getLayoutRect(popper)
        }; // Modifiers have the ability to reset the current update cycle. The
        // most common use case for this is the `flip` modifier changing the
        // placement, which then needs to re-run all the modifiers, because the
        // logic was previously ran for the previous placement and is therefore
        // stale/incorrect

        state.reset = false;
        state.placement = state.options.placement; // On each update cycle, the `modifiersData` property for each modifier
        // is filled with the initial data specified by the modifier. This means
        // it doesn't persist and is fresh on each update.
        // To ensure persistent data, use `${name}#persistent`

        state.orderedModifiers.forEach(function (modifier) {
          return state.modifiersData[modifier.name] = Object.assign({}, modifier.data);
        });

        for (var index = 0; index < state.orderedModifiers.length; index++) {
          if (state.reset === true) {
            state.reset = false;
            index = -1;
            continue;
          }

          var _state$orderedModifie = state.orderedModifiers[index],
              fn = _state$orderedModifie.fn,
              _state$orderedModifie2 = _state$orderedModifie.options,
              _options = _state$orderedModifie2 === void 0 ? {} : _state$orderedModifie2,
              name = _state$orderedModifie.name;

          if (typeof fn === 'function') {
            state = fn({
              state: state,
              options: _options,
              name: name,
              instance: instance
            }) || state;
          }
        }
      },
      // Async and optimistically optimized update – it will not be executed if
      // not necessary (debounced to run at most once-per-tick)
      update: debounce(function () {
        return new Promise(function (resolve) {
          instance.forceUpdate();
          resolve(state);
        });
      }),
      destroy: function destroy() {
        cleanupModifierEffects();
        isDestroyed = true;
      }
    };

    if (!areValidElements(reference, popper)) {
      return instance;
    }

    instance.setOptions(options).then(function (state) {
      if (!isDestroyed && options.onFirstUpdate) {
        options.onFirstUpdate(state);
      }
    }); // Modifiers have the ability to execute arbitrary code before the first
    // update cycle runs. They will be executed in the same order as the update
    // cycle. This is useful when a modifier adds some persistent data that
    // other modifiers need to use, but the modifier is run after the dependent
    // one.

    function runModifierEffects() {
      state.orderedModifiers.forEach(function (_ref) {
        var name = _ref.name,
            _ref$options = _ref.options,
            options = _ref$options === void 0 ? {} : _ref$options,
            effect = _ref.effect;

        if (typeof effect === 'function') {
          var cleanupFn = effect({
            state: state,
            name: name,
            instance: instance,
            options: options
          });

          var noopFn = function noopFn() {};

          effectCleanupFns.push(cleanupFn || noopFn);
        }
      });
    }

    function cleanupModifierEffects() {
      effectCleanupFns.forEach(function (fn) {
        return fn();
      });
      effectCleanupFns = [];
    }

    return instance;
  };
}
var createPopper = /*#__PURE__*/(/* unused pure expression or super */ null && (popperGenerator())); // eslint-disable-next-line import/no-unused-modules


;// CONCATENATED MODULE: ./node_modules/.pnpm/@popperjs+core@2.11.8/node_modules/@popperjs/core/lib/modifiers/eventListeners.js
 // eslint-disable-next-line import/no-unused-modules

var passive = {
  passive: true
};

function effect(_ref) {
  var state = _ref.state,
      instance = _ref.instance,
      options = _ref.options;
  var _options$scroll = options.scroll,
      scroll = _options$scroll === void 0 ? true : _options$scroll,
      _options$resize = options.resize,
      resize = _options$resize === void 0 ? true : _options$resize;
  var window = getWindow(state.elements.popper);
  var scrollParents = [].concat(state.scrollParents.reference, state.scrollParents.popper);

  if (scroll) {
    scrollParents.forEach(function (scrollParent) {
      scrollParent.addEventListener('scroll', instance.update, passive);
    });
  }

  if (resize) {
    window.addEventListener('resize', instance.update, passive);
  }

  return function () {
    if (scroll) {
      scrollParents.forEach(function (scrollParent) {
        scrollParent.removeEventListener('scroll', instance.update, passive);
      });
    }

    if (resize) {
      window.removeEventListener('resize', instance.update, passive);
    }
  };
} // eslint-disable-next-line import/no-unused-modules


/* harmony default export */ var eventListeners = ({
  name: 'eventListeners',
  enabled: true,
  phase: 'write',
  fn: function fn() {},
  effect: effect,
  data: {}
});
;// CONCATENATED MODULE: ./node_modules/.pnpm/@popperjs+core@2.11.8/node_modules/@popperjs/core/lib/utils/getBasePlacement.js

function getBasePlacement(placement) {
  return placement.split('-')[0];
}
;// CONCATENATED MODULE: ./node_modules/.pnpm/@popperjs+core@2.11.8/node_modules/@popperjs/core/lib/utils/getVariation.js
function getVariation(placement) {
  return placement.split('-')[1];
}
;// CONCATENATED MODULE: ./node_modules/.pnpm/@popperjs+core@2.11.8/node_modules/@popperjs/core/lib/utils/getMainAxisFromPlacement.js
function getMainAxisFromPlacement(placement) {
  return ['top', 'bottom'].indexOf(placement) >= 0 ? 'x' : 'y';
}
;// CONCATENATED MODULE: ./node_modules/.pnpm/@popperjs+core@2.11.8/node_modules/@popperjs/core/lib/utils/computeOffsets.js




function computeOffsets(_ref) {
  var reference = _ref.reference,
      element = _ref.element,
      placement = _ref.placement;
  var basePlacement = placement ? getBasePlacement(placement) : null;
  var variation = placement ? getVariation(placement) : null;
  var commonX = reference.x + reference.width / 2 - element.width / 2;
  var commonY = reference.y + reference.height / 2 - element.height / 2;
  var offsets;

  switch (basePlacement) {
    case enums_top:
      offsets = {
        x: commonX,
        y: reference.y - element.height
      };
      break;

    case bottom:
      offsets = {
        x: commonX,
        y: reference.y + reference.height
      };
      break;

    case right:
      offsets = {
        x: reference.x + reference.width,
        y: commonY
      };
      break;

    case left:
      offsets = {
        x: reference.x - element.width,
        y: commonY
      };
      break;

    default:
      offsets = {
        x: reference.x,
        y: reference.y
      };
  }

  var mainAxis = basePlacement ? getMainAxisFromPlacement(basePlacement) : null;

  if (mainAxis != null) {
    var len = mainAxis === 'y' ? 'height' : 'width';

    switch (variation) {
      case start:
        offsets[mainAxis] = offsets[mainAxis] - (reference[len] / 2 - element[len] / 2);
        break;

      case end:
        offsets[mainAxis] = offsets[mainAxis] + (reference[len] / 2 - element[len] / 2);
        break;

      default:
    }
  }

  return offsets;
}
;// CONCATENATED MODULE: ./node_modules/.pnpm/@popperjs+core@2.11.8/node_modules/@popperjs/core/lib/modifiers/popperOffsets.js


function popperOffsets(_ref) {
  var state = _ref.state,
      name = _ref.name;
  // Offsets are the actual position the popper needs to have to be
  // properly positioned near its reference element
  // This is the most basic placement, and will be adjusted by
  // the modifiers in the next step
  state.modifiersData[name] = computeOffsets({
    reference: state.rects.reference,
    element: state.rects.popper,
    strategy: 'absolute',
    placement: state.placement
  });
} // eslint-disable-next-line import/no-unused-modules


/* harmony default export */ var modifiers_popperOffsets = ({
  name: 'popperOffsets',
  enabled: true,
  phase: 'read',
  fn: popperOffsets,
  data: {}
});
;// CONCATENATED MODULE: ./node_modules/.pnpm/@popperjs+core@2.11.8/node_modules/@popperjs/core/lib/modifiers/computeStyles.js







 // eslint-disable-next-line import/no-unused-modules

var unsetSides = {
  top: 'auto',
  right: 'auto',
  bottom: 'auto',
  left: 'auto'
}; // Round the offsets to the nearest suitable subpixel based on the DPR.
// Zooming can change the DPR, but it seems to report a value that will
// cleanly divide the values into the appropriate subpixels.

function roundOffsetsByDPR(_ref, win) {
  var x = _ref.x,
      y = _ref.y;
  var dpr = win.devicePixelRatio || 1;
  return {
    x: round(x * dpr) / dpr || 0,
    y: round(y * dpr) / dpr || 0
  };
}

function mapToStyles(_ref2) {
  var _Object$assign2;

  var popper = _ref2.popper,
      popperRect = _ref2.popperRect,
      placement = _ref2.placement,
      variation = _ref2.variation,
      offsets = _ref2.offsets,
      position = _ref2.position,
      gpuAcceleration = _ref2.gpuAcceleration,
      adaptive = _ref2.adaptive,
      roundOffsets = _ref2.roundOffsets,
      isFixed = _ref2.isFixed;
  var _offsets$x = offsets.x,
      x = _offsets$x === void 0 ? 0 : _offsets$x,
      _offsets$y = offsets.y,
      y = _offsets$y === void 0 ? 0 : _offsets$y;

  var _ref3 = typeof roundOffsets === 'function' ? roundOffsets({
    x: x,
    y: y
  }) : {
    x: x,
    y: y
  };

  x = _ref3.x;
  y = _ref3.y;
  var hasX = offsets.hasOwnProperty('x');
  var hasY = offsets.hasOwnProperty('y');
  var sideX = left;
  var sideY = enums_top;
  var win = window;

  if (adaptive) {
    var offsetParent = getOffsetParent(popper);
    var heightProp = 'clientHeight';
    var widthProp = 'clientWidth';

    if (offsetParent === getWindow(popper)) {
      offsetParent = getDocumentElement(popper);

      if (getComputedStyle(offsetParent).position !== 'static' && position === 'absolute') {
        heightProp = 'scrollHeight';
        widthProp = 'scrollWidth';
      }
    } // $FlowFixMe[incompatible-cast]: force type refinement, we compare offsetParent with window above, but Flow doesn't detect it


    offsetParent = offsetParent;

    if (placement === enums_top || (placement === left || placement === right) && variation === end) {
      sideY = bottom;
      var offsetY = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.height : // $FlowFixMe[prop-missing]
      offsetParent[heightProp];
      y -= offsetY - popperRect.height;
      y *= gpuAcceleration ? 1 : -1;
    }

    if (placement === left || (placement === enums_top || placement === bottom) && variation === end) {
      sideX = right;
      var offsetX = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.width : // $FlowFixMe[prop-missing]
      offsetParent[widthProp];
      x -= offsetX - popperRect.width;
      x *= gpuAcceleration ? 1 : -1;
    }
  }

  var commonStyles = Object.assign({
    position: position
  }, adaptive && unsetSides);

  var _ref4 = roundOffsets === true ? roundOffsetsByDPR({
    x: x,
    y: y
  }, getWindow(popper)) : {
    x: x,
    y: y
  };

  x = _ref4.x;
  y = _ref4.y;

  if (gpuAcceleration) {
    var _Object$assign;

    return Object.assign({}, commonStyles, (_Object$assign = {}, _Object$assign[sideY] = hasY ? '0' : '', _Object$assign[sideX] = hasX ? '0' : '', _Object$assign.transform = (win.devicePixelRatio || 1) <= 1 ? "translate(" + x + "px, " + y + "px)" : "translate3d(" + x + "px, " + y + "px, 0)", _Object$assign));
  }

  return Object.assign({}, commonStyles, (_Object$assign2 = {}, _Object$assign2[sideY] = hasY ? y + "px" : '', _Object$assign2[sideX] = hasX ? x + "px" : '', _Object$assign2.transform = '', _Object$assign2));
}

function computeStyles(_ref5) {
  var state = _ref5.state,
      options = _ref5.options;
  var _options$gpuAccelerat = options.gpuAcceleration,
      gpuAcceleration = _options$gpuAccelerat === void 0 ? true : _options$gpuAccelerat,
      _options$adaptive = options.adaptive,
      adaptive = _options$adaptive === void 0 ? true : _options$adaptive,
      _options$roundOffsets = options.roundOffsets,
      roundOffsets = _options$roundOffsets === void 0 ? true : _options$roundOffsets;
  var commonStyles = {
    placement: getBasePlacement(state.placement),
    variation: getVariation(state.placement),
    popper: state.elements.popper,
    popperRect: state.rects.popper,
    gpuAcceleration: gpuAcceleration,
    isFixed: state.options.strategy === 'fixed'
  };

  if (state.modifiersData.popperOffsets != null) {
    state.styles.popper = Object.assign({}, state.styles.popper, mapToStyles(Object.assign({}, commonStyles, {
      offsets: state.modifiersData.popperOffsets,
      position: state.options.strategy,
      adaptive: adaptive,
      roundOffsets: roundOffsets
    })));
  }

  if (state.modifiersData.arrow != null) {
    state.styles.arrow = Object.assign({}, state.styles.arrow, mapToStyles(Object.assign({}, commonStyles, {
      offsets: state.modifiersData.arrow,
      position: 'absolute',
      adaptive: false,
      roundOffsets: roundOffsets
    })));
  }

  state.attributes.popper = Object.assign({}, state.attributes.popper, {
    'data-popper-placement': state.placement
  });
} // eslint-disable-next-line import/no-unused-modules


/* harmony default export */ var modifiers_computeStyles = ({
  name: 'computeStyles',
  enabled: true,
  phase: 'beforeWrite',
  fn: computeStyles,
  data: {}
});
;// CONCATENATED MODULE: ./node_modules/.pnpm/@popperjs+core@2.11.8/node_modules/@popperjs/core/lib/modifiers/applyStyles.js

 // This modifier takes the styles prepared by the `computeStyles` modifier
// and applies them to the HTMLElements such as popper and arrow

function applyStyles(_ref) {
  var state = _ref.state;
  Object.keys(state.elements).forEach(function (name) {
    var style = state.styles[name] || {};
    var attributes = state.attributes[name] || {};
    var element = state.elements[name]; // arrow is optional + virtual elements

    if (!isHTMLElement(element) || !getNodeName(element)) {
      return;
    } // Flow doesn't support to extend this property, but it's the most
    // effective way to apply styles to an HTMLElement
    // $FlowFixMe[cannot-write]


    Object.assign(element.style, style);
    Object.keys(attributes).forEach(function (name) {
      var value = attributes[name];

      if (value === false) {
        element.removeAttribute(name);
      } else {
        element.setAttribute(name, value === true ? '' : value);
      }
    });
  });
}

function applyStyles_effect(_ref2) {
  var state = _ref2.state;
  var initialStyles = {
    popper: {
      position: state.options.strategy,
      left: '0',
      top: '0',
      margin: '0'
    },
    arrow: {
      position: 'absolute'
    },
    reference: {}
  };
  Object.assign(state.elements.popper.style, initialStyles.popper);
  state.styles = initialStyles;

  if (state.elements.arrow) {
    Object.assign(state.elements.arrow.style, initialStyles.arrow);
  }

  return function () {
    Object.keys(state.elements).forEach(function (name) {
      var element = state.elements[name];
      var attributes = state.attributes[name] || {};
      var styleProperties = Object.keys(state.styles.hasOwnProperty(name) ? state.styles[name] : initialStyles[name]); // Set all values to an empty string to unset them

      var style = styleProperties.reduce(function (style, property) {
        style[property] = '';
        return style;
      }, {}); // arrow is optional + virtual elements

      if (!isHTMLElement(element) || !getNodeName(element)) {
        return;
      }

      Object.assign(element.style, style);
      Object.keys(attributes).forEach(function (attribute) {
        element.removeAttribute(attribute);
      });
    });
  };
} // eslint-disable-next-line import/no-unused-modules


/* harmony default export */ var modifiers_applyStyles = ({
  name: 'applyStyles',
  enabled: true,
  phase: 'write',
  fn: applyStyles,
  effect: applyStyles_effect,
  requires: ['computeStyles']
});
;// CONCATENATED MODULE: ./node_modules/.pnpm/@popperjs+core@2.11.8/node_modules/@popperjs/core/lib/modifiers/offset.js

 // eslint-disable-next-line import/no-unused-modules

function distanceAndSkiddingToXY(placement, rects, offset) {
  var basePlacement = getBasePlacement(placement);
  var invertDistance = [left, enums_top].indexOf(basePlacement) >= 0 ? -1 : 1;

  var _ref = typeof offset === 'function' ? offset(Object.assign({}, rects, {
    placement: placement
  })) : offset,
      skidding = _ref[0],
      distance = _ref[1];

  skidding = skidding || 0;
  distance = (distance || 0) * invertDistance;
  return [left, right].indexOf(basePlacement) >= 0 ? {
    x: distance,
    y: skidding
  } : {
    x: skidding,
    y: distance
  };
}

function offset(_ref2) {
  var state = _ref2.state,
      options = _ref2.options,
      name = _ref2.name;
  var _options$offset = options.offset,
      offset = _options$offset === void 0 ? [0, 0] : _options$offset;
  var data = enums_placements.reduce(function (acc, placement) {
    acc[placement] = distanceAndSkiddingToXY(placement, state.rects, offset);
    return acc;
  }, {});
  var _data$state$placement = data[state.placement],
      x = _data$state$placement.x,
      y = _data$state$placement.y;

  if (state.modifiersData.popperOffsets != null) {
    state.modifiersData.popperOffsets.x += x;
    state.modifiersData.popperOffsets.y += y;
  }

  state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules


/* harmony default export */ var modifiers_offset = ({
  name: 'offset',
  enabled: true,
  phase: 'main',
  requires: ['popperOffsets'],
  fn: offset
});
;// CONCATENATED MODULE: ./node_modules/.pnpm/@popperjs+core@2.11.8/node_modules/@popperjs/core/lib/utils/getOppositePlacement.js
var hash = {
  left: 'right',
  right: 'left',
  bottom: 'top',
  top: 'bottom'
};
function getOppositePlacement(placement) {
  return placement.replace(/left|right|bottom|top/g, function (matched) {
    return hash[matched];
  });
}
;// CONCATENATED MODULE: ./node_modules/.pnpm/@popperjs+core@2.11.8/node_modules/@popperjs/core/lib/utils/getOppositeVariationPlacement.js
var getOppositeVariationPlacement_hash = {
  start: 'end',
  end: 'start'
};
function getOppositeVariationPlacement(placement) {
  return placement.replace(/start|end/g, function (matched) {
    return getOppositeVariationPlacement_hash[matched];
  });
}
;// CONCATENATED MODULE: ./node_modules/.pnpm/@popperjs+core@2.11.8/node_modules/@popperjs/core/lib/dom-utils/getViewportRect.js




function getViewportRect(element, strategy) {
  var win = getWindow(element);
  var html = getDocumentElement(element);
  var visualViewport = win.visualViewport;
  var width = html.clientWidth;
  var height = html.clientHeight;
  var x = 0;
  var y = 0;

  if (visualViewport) {
    width = visualViewport.width;
    height = visualViewport.height;
    var layoutViewport = isLayoutViewport();

    if (layoutViewport || !layoutViewport && strategy === 'fixed') {
      x = visualViewport.offsetLeft;
      y = visualViewport.offsetTop;
    }
  }

  return {
    width: width,
    height: height,
    x: x + getWindowScrollBarX(element),
    y: y
  };
}
;// CONCATENATED MODULE: ./node_modules/.pnpm/@popperjs+core@2.11.8/node_modules/@popperjs/core/lib/dom-utils/getDocumentRect.js




 // Gets the entire size of the scrollable document area, even extending outside
// of the `<html>` and `<body>` rect bounds if horizontally scrollable

function getDocumentRect(element) {
  var _element$ownerDocumen;

  var html = getDocumentElement(element);
  var winScroll = getWindowScroll(element);
  var body = (_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body;
  var width = math_max(html.scrollWidth, html.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0);
  var height = math_max(html.scrollHeight, html.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0);
  var x = -winScroll.scrollLeft + getWindowScrollBarX(element);
  var y = -winScroll.scrollTop;

  if (getComputedStyle(body || html).direction === 'rtl') {
    x += math_max(html.clientWidth, body ? body.clientWidth : 0) - width;
  }

  return {
    width: width,
    height: height,
    x: x,
    y: y
  };
}
;// CONCATENATED MODULE: ./node_modules/.pnpm/@popperjs+core@2.11.8/node_modules/@popperjs/core/lib/dom-utils/contains.js

function contains(parent, child) {
  var rootNode = child.getRootNode && child.getRootNode(); // First, attempt with faster native method

  if (parent.contains(child)) {
    return true;
  } // then fallback to custom implementation with Shadow DOM support
  else if (rootNode && isShadowRoot(rootNode)) {
      var next = child;

      do {
        if (next && parent.isSameNode(next)) {
          return true;
        } // $FlowFixMe[prop-missing]: need a better way to handle this...


        next = next.parentNode || next.host;
      } while (next);
    } // Give up, the result is false


  return false;
}
;// CONCATENATED MODULE: ./node_modules/.pnpm/@popperjs+core@2.11.8/node_modules/@popperjs/core/lib/utils/rectToClientRect.js
function rectToClientRect(rect) {
  return Object.assign({}, rect, {
    left: rect.x,
    top: rect.y,
    right: rect.x + rect.width,
    bottom: rect.y + rect.height
  });
}
;// CONCATENATED MODULE: ./node_modules/.pnpm/@popperjs+core@2.11.8/node_modules/@popperjs/core/lib/dom-utils/getClippingRect.js















function getInnerBoundingClientRect(element, strategy) {
  var rect = getBoundingClientRect(element, false, strategy === 'fixed');
  rect.top = rect.top + element.clientTop;
  rect.left = rect.left + element.clientLeft;
  rect.bottom = rect.top + element.clientHeight;
  rect.right = rect.left + element.clientWidth;
  rect.width = element.clientWidth;
  rect.height = element.clientHeight;
  rect.x = rect.left;
  rect.y = rect.top;
  return rect;
}

function getClientRectFromMixedType(element, clippingParent, strategy) {
  return clippingParent === viewport ? rectToClientRect(getViewportRect(element, strategy)) : isElement(clippingParent) ? getInnerBoundingClientRect(clippingParent, strategy) : rectToClientRect(getDocumentRect(getDocumentElement(element)));
} // A "clipping parent" is an overflowable container with the characteristic of
// clipping (or hiding) overflowing elements with a position different from
// `initial`


function getClippingParents(element) {
  var clippingParents = listScrollParents(getParentNode(element));
  var canEscapeClipping = ['absolute', 'fixed'].indexOf(getComputedStyle(element).position) >= 0;
  var clipperElement = canEscapeClipping && isHTMLElement(element) ? getOffsetParent(element) : element;

  if (!isElement(clipperElement)) {
    return [];
  } // $FlowFixMe[incompatible-return]: https://github.com/facebook/flow/issues/1414


  return clippingParents.filter(function (clippingParent) {
    return isElement(clippingParent) && contains(clippingParent, clipperElement) && getNodeName(clippingParent) !== 'body';
  });
} // Gets the maximum area that the element is visible in due to any number of
// clipping parents


function getClippingRect(element, boundary, rootBoundary, strategy) {
  var mainClippingParents = boundary === 'clippingParents' ? getClippingParents(element) : [].concat(boundary);
  var clippingParents = [].concat(mainClippingParents, [rootBoundary]);
  var firstClippingParent = clippingParents[0];
  var clippingRect = clippingParents.reduce(function (accRect, clippingParent) {
    var rect = getClientRectFromMixedType(element, clippingParent, strategy);
    accRect.top = math_max(rect.top, accRect.top);
    accRect.right = math_min(rect.right, accRect.right);
    accRect.bottom = math_min(rect.bottom, accRect.bottom);
    accRect.left = math_max(rect.left, accRect.left);
    return accRect;
  }, getClientRectFromMixedType(element, firstClippingParent, strategy));
  clippingRect.width = clippingRect.right - clippingRect.left;
  clippingRect.height = clippingRect.bottom - clippingRect.top;
  clippingRect.x = clippingRect.left;
  clippingRect.y = clippingRect.top;
  return clippingRect;
}
;// CONCATENATED MODULE: ./node_modules/.pnpm/@popperjs+core@2.11.8/node_modules/@popperjs/core/lib/utils/getFreshSideObject.js
function getFreshSideObject() {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  };
}
;// CONCATENATED MODULE: ./node_modules/.pnpm/@popperjs+core@2.11.8/node_modules/@popperjs/core/lib/utils/mergePaddingObject.js

function mergePaddingObject(paddingObject) {
  return Object.assign({}, getFreshSideObject(), paddingObject);
}
;// CONCATENATED MODULE: ./node_modules/.pnpm/@popperjs+core@2.11.8/node_modules/@popperjs/core/lib/utils/expandToHashMap.js
function expandToHashMap(value, keys) {
  return keys.reduce(function (hashMap, key) {
    hashMap[key] = value;
    return hashMap;
  }, {});
}
;// CONCATENATED MODULE: ./node_modules/.pnpm/@popperjs+core@2.11.8/node_modules/@popperjs/core/lib/utils/detectOverflow.js








 // eslint-disable-next-line import/no-unused-modules

function detectOverflow(state, options) {
  if (options === void 0) {
    options = {};
  }

  var _options = options,
      _options$placement = _options.placement,
      placement = _options$placement === void 0 ? state.placement : _options$placement,
      _options$strategy = _options.strategy,
      strategy = _options$strategy === void 0 ? state.strategy : _options$strategy,
      _options$boundary = _options.boundary,
      boundary = _options$boundary === void 0 ? clippingParents : _options$boundary,
      _options$rootBoundary = _options.rootBoundary,
      rootBoundary = _options$rootBoundary === void 0 ? viewport : _options$rootBoundary,
      _options$elementConte = _options.elementContext,
      elementContext = _options$elementConte === void 0 ? popper : _options$elementConte,
      _options$altBoundary = _options.altBoundary,
      altBoundary = _options$altBoundary === void 0 ? false : _options$altBoundary,
      _options$padding = _options.padding,
      padding = _options$padding === void 0 ? 0 : _options$padding;
  var paddingObject = mergePaddingObject(typeof padding !== 'number' ? padding : expandToHashMap(padding, basePlacements));
  var altContext = elementContext === popper ? reference : popper;
  var popperRect = state.rects.popper;
  var element = state.elements[altBoundary ? altContext : elementContext];
  var clippingClientRect = getClippingRect(isElement(element) ? element : element.contextElement || getDocumentElement(state.elements.popper), boundary, rootBoundary, strategy);
  var referenceClientRect = getBoundingClientRect(state.elements.reference);
  var popperOffsets = computeOffsets({
    reference: referenceClientRect,
    element: popperRect,
    strategy: 'absolute',
    placement: placement
  });
  var popperClientRect = rectToClientRect(Object.assign({}, popperRect, popperOffsets));
  var elementClientRect = elementContext === popper ? popperClientRect : referenceClientRect; // positive = overflowing the clipping rect
  // 0 or negative = within the clipping rect

  var overflowOffsets = {
    top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
    bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
    left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
    right: elementClientRect.right - clippingClientRect.right + paddingObject.right
  };
  var offsetData = state.modifiersData.offset; // Offsets can be applied only to the popper element

  if (elementContext === popper && offsetData) {
    var offset = offsetData[placement];
    Object.keys(overflowOffsets).forEach(function (key) {
      var multiply = [right, bottom].indexOf(key) >= 0 ? 1 : -1;
      var axis = [enums_top, bottom].indexOf(key) >= 0 ? 'y' : 'x';
      overflowOffsets[key] += offset[axis] * multiply;
    });
  }

  return overflowOffsets;
}
;// CONCATENATED MODULE: ./node_modules/.pnpm/@popperjs+core@2.11.8/node_modules/@popperjs/core/lib/utils/computeAutoPlacement.js




function computeAutoPlacement(state, options) {
  if (options === void 0) {
    options = {};
  }

  var _options = options,
      placement = _options.placement,
      boundary = _options.boundary,
      rootBoundary = _options.rootBoundary,
      padding = _options.padding,
      flipVariations = _options.flipVariations,
      _options$allowedAutoP = _options.allowedAutoPlacements,
      allowedAutoPlacements = _options$allowedAutoP === void 0 ? enums_placements : _options$allowedAutoP;
  var variation = getVariation(placement);
  var placements = variation ? flipVariations ? variationPlacements : variationPlacements.filter(function (placement) {
    return getVariation(placement) === variation;
  }) : basePlacements;
  var allowedPlacements = placements.filter(function (placement) {
    return allowedAutoPlacements.indexOf(placement) >= 0;
  });

  if (allowedPlacements.length === 0) {
    allowedPlacements = placements;
  } // $FlowFixMe[incompatible-type]: Flow seems to have problems with two array unions...


  var overflows = allowedPlacements.reduce(function (acc, placement) {
    acc[placement] = detectOverflow(state, {
      placement: placement,
      boundary: boundary,
      rootBoundary: rootBoundary,
      padding: padding
    })[getBasePlacement(placement)];
    return acc;
  }, {});
  return Object.keys(overflows).sort(function (a, b) {
    return overflows[a] - overflows[b];
  });
}
;// CONCATENATED MODULE: ./node_modules/.pnpm/@popperjs+core@2.11.8/node_modules/@popperjs/core/lib/modifiers/flip.js






 // eslint-disable-next-line import/no-unused-modules

function getExpandedFallbackPlacements(placement) {
  if (getBasePlacement(placement) === auto) {
    return [];
  }

  var oppositePlacement = getOppositePlacement(placement);
  return [getOppositeVariationPlacement(placement), oppositePlacement, getOppositeVariationPlacement(oppositePlacement)];
}

function flip(_ref) {
  var state = _ref.state,
      options = _ref.options,
      name = _ref.name;

  if (state.modifiersData[name]._skip) {
    return;
  }

  var _options$mainAxis = options.mainAxis,
      checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis,
      _options$altAxis = options.altAxis,
      checkAltAxis = _options$altAxis === void 0 ? true : _options$altAxis,
      specifiedFallbackPlacements = options.fallbackPlacements,
      padding = options.padding,
      boundary = options.boundary,
      rootBoundary = options.rootBoundary,
      altBoundary = options.altBoundary,
      _options$flipVariatio = options.flipVariations,
      flipVariations = _options$flipVariatio === void 0 ? true : _options$flipVariatio,
      allowedAutoPlacements = options.allowedAutoPlacements;
  var preferredPlacement = state.options.placement;
  var basePlacement = getBasePlacement(preferredPlacement);
  var isBasePlacement = basePlacement === preferredPlacement;
  var fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipVariations ? [getOppositePlacement(preferredPlacement)] : getExpandedFallbackPlacements(preferredPlacement));
  var placements = [preferredPlacement].concat(fallbackPlacements).reduce(function (acc, placement) {
    return acc.concat(getBasePlacement(placement) === auto ? computeAutoPlacement(state, {
      placement: placement,
      boundary: boundary,
      rootBoundary: rootBoundary,
      padding: padding,
      flipVariations: flipVariations,
      allowedAutoPlacements: allowedAutoPlacements
    }) : placement);
  }, []);
  var referenceRect = state.rects.reference;
  var popperRect = state.rects.popper;
  var checksMap = new Map();
  var makeFallbackChecks = true;
  var firstFittingPlacement = placements[0];

  for (var i = 0; i < placements.length; i++) {
    var placement = placements[i];

    var _basePlacement = getBasePlacement(placement);

    var isStartVariation = getVariation(placement) === start;
    var isVertical = [enums_top, bottom].indexOf(_basePlacement) >= 0;
    var len = isVertical ? 'width' : 'height';
    var overflow = detectOverflow(state, {
      placement: placement,
      boundary: boundary,
      rootBoundary: rootBoundary,
      altBoundary: altBoundary,
      padding: padding
    });
    var mainVariationSide = isVertical ? isStartVariation ? right : left : isStartVariation ? bottom : enums_top;

    if (referenceRect[len] > popperRect[len]) {
      mainVariationSide = getOppositePlacement(mainVariationSide);
    }

    var altVariationSide = getOppositePlacement(mainVariationSide);
    var checks = [];

    if (checkMainAxis) {
      checks.push(overflow[_basePlacement] <= 0);
    }

    if (checkAltAxis) {
      checks.push(overflow[mainVariationSide] <= 0, overflow[altVariationSide] <= 0);
    }

    if (checks.every(function (check) {
      return check;
    })) {
      firstFittingPlacement = placement;
      makeFallbackChecks = false;
      break;
    }

    checksMap.set(placement, checks);
  }

  if (makeFallbackChecks) {
    // `2` may be desired in some cases – research later
    var numberOfChecks = flipVariations ? 3 : 1;

    var _loop = function _loop(_i) {
      var fittingPlacement = placements.find(function (placement) {
        var checks = checksMap.get(placement);

        if (checks) {
          return checks.slice(0, _i).every(function (check) {
            return check;
          });
        }
      });

      if (fittingPlacement) {
        firstFittingPlacement = fittingPlacement;
        return "break";
      }
    };

    for (var _i = numberOfChecks; _i > 0; _i--) {
      var _ret = _loop(_i);

      if (_ret === "break") break;
    }
  }

  if (state.placement !== firstFittingPlacement) {
    state.modifiersData[name]._skip = true;
    state.placement = firstFittingPlacement;
    state.reset = true;
  }
} // eslint-disable-next-line import/no-unused-modules


/* harmony default export */ var modifiers_flip = ({
  name: 'flip',
  enabled: true,
  phase: 'main',
  fn: flip,
  requiresIfExists: ['offset'],
  data: {
    _skip: false
  }
});
;// CONCATENATED MODULE: ./node_modules/.pnpm/@popperjs+core@2.11.8/node_modules/@popperjs/core/lib/utils/getAltAxis.js
function getAltAxis(axis) {
  return axis === 'x' ? 'y' : 'x';
}
;// CONCATENATED MODULE: ./node_modules/.pnpm/@popperjs+core@2.11.8/node_modules/@popperjs/core/lib/utils/within.js

function within(min, value, max) {
  return math_max(min, math_min(value, max));
}
function withinMaxClamp(min, value, max) {
  var v = within(min, value, max);
  return v > max ? max : v;
}
;// CONCATENATED MODULE: ./node_modules/.pnpm/@popperjs+core@2.11.8/node_modules/@popperjs/core/lib/modifiers/preventOverflow.js












function preventOverflow(_ref) {
  var state = _ref.state,
      options = _ref.options,
      name = _ref.name;
  var _options$mainAxis = options.mainAxis,
      checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis,
      _options$altAxis = options.altAxis,
      checkAltAxis = _options$altAxis === void 0 ? false : _options$altAxis,
      boundary = options.boundary,
      rootBoundary = options.rootBoundary,
      altBoundary = options.altBoundary,
      padding = options.padding,
      _options$tether = options.tether,
      tether = _options$tether === void 0 ? true : _options$tether,
      _options$tetherOffset = options.tetherOffset,
      tetherOffset = _options$tetherOffset === void 0 ? 0 : _options$tetherOffset;
  var overflow = detectOverflow(state, {
    boundary: boundary,
    rootBoundary: rootBoundary,
    padding: padding,
    altBoundary: altBoundary
  });
  var basePlacement = getBasePlacement(state.placement);
  var variation = getVariation(state.placement);
  var isBasePlacement = !variation;
  var mainAxis = getMainAxisFromPlacement(basePlacement);
  var altAxis = getAltAxis(mainAxis);
  var popperOffsets = state.modifiersData.popperOffsets;
  var referenceRect = state.rects.reference;
  var popperRect = state.rects.popper;
  var tetherOffsetValue = typeof tetherOffset === 'function' ? tetherOffset(Object.assign({}, state.rects, {
    placement: state.placement
  })) : tetherOffset;
  var normalizedTetherOffsetValue = typeof tetherOffsetValue === 'number' ? {
    mainAxis: tetherOffsetValue,
    altAxis: tetherOffsetValue
  } : Object.assign({
    mainAxis: 0,
    altAxis: 0
  }, tetherOffsetValue);
  var offsetModifierState = state.modifiersData.offset ? state.modifiersData.offset[state.placement] : null;
  var data = {
    x: 0,
    y: 0
  };

  if (!popperOffsets) {
    return;
  }

  if (checkMainAxis) {
    var _offsetModifierState$;

    var mainSide = mainAxis === 'y' ? enums_top : left;
    var altSide = mainAxis === 'y' ? bottom : right;
    var len = mainAxis === 'y' ? 'height' : 'width';
    var offset = popperOffsets[mainAxis];
    var min = offset + overflow[mainSide];
    var max = offset - overflow[altSide];
    var additive = tether ? -popperRect[len] / 2 : 0;
    var minLen = variation === start ? referenceRect[len] : popperRect[len];
    var maxLen = variation === start ? -popperRect[len] : -referenceRect[len]; // We need to include the arrow in the calculation so the arrow doesn't go
    // outside the reference bounds

    var arrowElement = state.elements.arrow;
    var arrowRect = tether && arrowElement ? getLayoutRect(arrowElement) : {
      width: 0,
      height: 0
    };
    var arrowPaddingObject = state.modifiersData['arrow#persistent'] ? state.modifiersData['arrow#persistent'].padding : getFreshSideObject();
    var arrowPaddingMin = arrowPaddingObject[mainSide];
    var arrowPaddingMax = arrowPaddingObject[altSide]; // If the reference length is smaller than the arrow length, we don't want
    // to include its full size in the calculation. If the reference is small
    // and near the edge of a boundary, the popper can overflow even if the
    // reference is not overflowing as well (e.g. virtual elements with no
    // width or height)

    var arrowLen = within(0, referenceRect[len], arrowRect[len]);
    var minOffset = isBasePlacement ? referenceRect[len] / 2 - additive - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis : minLen - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis;
    var maxOffset = isBasePlacement ? -referenceRect[len] / 2 + additive + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis : maxLen + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis;
    var arrowOffsetParent = state.elements.arrow && getOffsetParent(state.elements.arrow);
    var clientOffset = arrowOffsetParent ? mainAxis === 'y' ? arrowOffsetParent.clientTop || 0 : arrowOffsetParent.clientLeft || 0 : 0;
    var offsetModifierValue = (_offsetModifierState$ = offsetModifierState == null ? void 0 : offsetModifierState[mainAxis]) != null ? _offsetModifierState$ : 0;
    var tetherMin = offset + minOffset - offsetModifierValue - clientOffset;
    var tetherMax = offset + maxOffset - offsetModifierValue;
    var preventedOffset = within(tether ? math_min(min, tetherMin) : min, offset, tether ? math_max(max, tetherMax) : max);
    popperOffsets[mainAxis] = preventedOffset;
    data[mainAxis] = preventedOffset - offset;
  }

  if (checkAltAxis) {
    var _offsetModifierState$2;

    var _mainSide = mainAxis === 'x' ? enums_top : left;

    var _altSide = mainAxis === 'x' ? bottom : right;

    var _offset = popperOffsets[altAxis];

    var _len = altAxis === 'y' ? 'height' : 'width';

    var _min = _offset + overflow[_mainSide];

    var _max = _offset - overflow[_altSide];

    var isOriginSide = [enums_top, left].indexOf(basePlacement) !== -1;

    var _offsetModifierValue = (_offsetModifierState$2 = offsetModifierState == null ? void 0 : offsetModifierState[altAxis]) != null ? _offsetModifierState$2 : 0;

    var _tetherMin = isOriginSide ? _min : _offset - referenceRect[_len] - popperRect[_len] - _offsetModifierValue + normalizedTetherOffsetValue.altAxis;

    var _tetherMax = isOriginSide ? _offset + referenceRect[_len] + popperRect[_len] - _offsetModifierValue - normalizedTetherOffsetValue.altAxis : _max;

    var _preventedOffset = tether && isOriginSide ? withinMaxClamp(_tetherMin, _offset, _tetherMax) : within(tether ? _tetherMin : _min, _offset, tether ? _tetherMax : _max);

    popperOffsets[altAxis] = _preventedOffset;
    data[altAxis] = _preventedOffset - _offset;
  }

  state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules


/* harmony default export */ var modifiers_preventOverflow = ({
  name: 'preventOverflow',
  enabled: true,
  phase: 'main',
  fn: preventOverflow,
  requiresIfExists: ['offset']
});
;// CONCATENATED MODULE: ./node_modules/.pnpm/@popperjs+core@2.11.8/node_modules/@popperjs/core/lib/modifiers/arrow.js








 // eslint-disable-next-line import/no-unused-modules

var toPaddingObject = function toPaddingObject(padding, state) {
  padding = typeof padding === 'function' ? padding(Object.assign({}, state.rects, {
    placement: state.placement
  })) : padding;
  return mergePaddingObject(typeof padding !== 'number' ? padding : expandToHashMap(padding, basePlacements));
};

function arrow(_ref) {
  var _state$modifiersData$;

  var state = _ref.state,
      name = _ref.name,
      options = _ref.options;
  var arrowElement = state.elements.arrow;
  var popperOffsets = state.modifiersData.popperOffsets;
  var basePlacement = getBasePlacement(state.placement);
  var axis = getMainAxisFromPlacement(basePlacement);
  var isVertical = [left, right].indexOf(basePlacement) >= 0;
  var len = isVertical ? 'height' : 'width';

  if (!arrowElement || !popperOffsets) {
    return;
  }

  var paddingObject = toPaddingObject(options.padding, state);
  var arrowRect = getLayoutRect(arrowElement);
  var minProp = axis === 'y' ? enums_top : left;
  var maxProp = axis === 'y' ? bottom : right;
  var endDiff = state.rects.reference[len] + state.rects.reference[axis] - popperOffsets[axis] - state.rects.popper[len];
  var startDiff = popperOffsets[axis] - state.rects.reference[axis];
  var arrowOffsetParent = getOffsetParent(arrowElement);
  var clientSize = arrowOffsetParent ? axis === 'y' ? arrowOffsetParent.clientHeight || 0 : arrowOffsetParent.clientWidth || 0 : 0;
  var centerToReference = endDiff / 2 - startDiff / 2; // Make sure the arrow doesn't overflow the popper if the center point is
  // outside of the popper bounds

  var min = paddingObject[minProp];
  var max = clientSize - arrowRect[len] - paddingObject[maxProp];
  var center = clientSize / 2 - arrowRect[len] / 2 + centerToReference;
  var offset = within(min, center, max); // Prevents breaking syntax highlighting...

  var axisProp = axis;
  state.modifiersData[name] = (_state$modifiersData$ = {}, _state$modifiersData$[axisProp] = offset, _state$modifiersData$.centerOffset = offset - center, _state$modifiersData$);
}

function arrow_effect(_ref2) {
  var state = _ref2.state,
      options = _ref2.options;
  var _options$element = options.element,
      arrowElement = _options$element === void 0 ? '[data-popper-arrow]' : _options$element;

  if (arrowElement == null) {
    return;
  } // CSS selector


  if (typeof arrowElement === 'string') {
    arrowElement = state.elements.popper.querySelector(arrowElement);

    if (!arrowElement) {
      return;
    }
  }

  if (!contains(state.elements.popper, arrowElement)) {
    return;
  }

  state.elements.arrow = arrowElement;
} // eslint-disable-next-line import/no-unused-modules


/* harmony default export */ var modifiers_arrow = ({
  name: 'arrow',
  enabled: true,
  phase: 'main',
  fn: arrow,
  effect: arrow_effect,
  requires: ['popperOffsets'],
  requiresIfExists: ['preventOverflow']
});
;// CONCATENATED MODULE: ./node_modules/.pnpm/@popperjs+core@2.11.8/node_modules/@popperjs/core/lib/modifiers/hide.js



function getSideOffsets(overflow, rect, preventedOffsets) {
  if (preventedOffsets === void 0) {
    preventedOffsets = {
      x: 0,
      y: 0
    };
  }

  return {
    top: overflow.top - rect.height - preventedOffsets.y,
    right: overflow.right - rect.width + preventedOffsets.x,
    bottom: overflow.bottom - rect.height + preventedOffsets.y,
    left: overflow.left - rect.width - preventedOffsets.x
  };
}

function isAnySideFullyClipped(overflow) {
  return [enums_top, right, bottom, left].some(function (side) {
    return overflow[side] >= 0;
  });
}

function hide(_ref) {
  var state = _ref.state,
      name = _ref.name;
  var referenceRect = state.rects.reference;
  var popperRect = state.rects.popper;
  var preventedOffsets = state.modifiersData.preventOverflow;
  var referenceOverflow = detectOverflow(state, {
    elementContext: 'reference'
  });
  var popperAltOverflow = detectOverflow(state, {
    altBoundary: true
  });
  var referenceClippingOffsets = getSideOffsets(referenceOverflow, referenceRect);
  var popperEscapeOffsets = getSideOffsets(popperAltOverflow, popperRect, preventedOffsets);
  var isReferenceHidden = isAnySideFullyClipped(referenceClippingOffsets);
  var hasPopperEscaped = isAnySideFullyClipped(popperEscapeOffsets);
  state.modifiersData[name] = {
    referenceClippingOffsets: referenceClippingOffsets,
    popperEscapeOffsets: popperEscapeOffsets,
    isReferenceHidden: isReferenceHidden,
    hasPopperEscaped: hasPopperEscaped
  };
  state.attributes.popper = Object.assign({}, state.attributes.popper, {
    'data-popper-reference-hidden': isReferenceHidden,
    'data-popper-escaped': hasPopperEscaped
  });
} // eslint-disable-next-line import/no-unused-modules


/* harmony default export */ var modifiers_hide = ({
  name: 'hide',
  enabled: true,
  phase: 'main',
  requiresIfExists: ['preventOverflow'],
  fn: hide
});
;// CONCATENATED MODULE: ./node_modules/.pnpm/@popperjs+core@2.11.8/node_modules/@popperjs/core/lib/popper.js










var defaultModifiers = [eventListeners, modifiers_popperOffsets, modifiers_computeStyles, modifiers_applyStyles, modifiers_offset, modifiers_flip, modifiers_preventOverflow, modifiers_arrow, modifiers_hide];
var popper_createPopper = /*#__PURE__*/popperGenerator({
  defaultModifiers: defaultModifiers
}); // eslint-disable-next-line import/no-unused-modules

 // eslint-disable-next-line import/no-unused-modules

 // eslint-disable-next-line import/no-unused-modules


// EXTERNAL MODULE: ./node_modules/.pnpm/react-fast-compare@3.2.2/node_modules/react-fast-compare/index.js
var react_fast_compare = __webpack_require__(15154);
var react_fast_compare_default = /*#__PURE__*/__webpack_require__.n(react_fast_compare);
;// CONCATENATED MODULE: ./node_modules/.pnpm/react-popper@2.3.0_@popperjs+core@2.11.8_react-dom@18.3.1_react@18.3.1/node_modules/react-popper/lib/esm/utils.js


/**
 * Takes an argument and if it's an array, returns the first item in the array,
 * otherwise returns the argument. Used for Preact compatibility.
 */
var unwrapArray = function unwrapArray(arg) {
  return Array.isArray(arg) ? arg[0] : arg;
};
/**
 * Takes a maybe-undefined function and arbitrary args and invokes the function
 * only if it is defined.
 */

var safeInvoke = function safeInvoke(fn) {
  if (typeof fn === 'function') {
    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    return fn.apply(void 0, args);
  }
};
/**
 * Sets a ref using either a ref callback or a ref object
 */

var setRef = function setRef(ref, node) {
  // if its a function call it
  if (typeof ref === 'function') {
    return safeInvoke(ref, node);
  } // otherwise we should treat it as a ref object
  else if (ref != null) {
      ref.current = node;
    }
};
/**
 * Simple ponyfill for Object.fromEntries
 */

var fromEntries = function fromEntries(entries) {
  return entries.reduce(function (acc, _ref) {
    var key = _ref[0],
        value = _ref[1];
    acc[key] = value;
    return acc;
  }, {});
};
/**
 * Small wrapper around `useLayoutEffect` to get rid of the warning on SSR envs
 */

var useIsomorphicLayoutEffect = typeof window !== 'undefined' && window.document && window.document.createElement ? react.useLayoutEffect : react.useEffect;
;// CONCATENATED MODULE: ./node_modules/.pnpm/react-popper@2.3.0_@popperjs+core@2.11.8_react-dom@18.3.1_react@18.3.1/node_modules/react-popper/lib/esm/usePopper.js





var EMPTY_MODIFIERS = [];
var usePopper = function usePopper(referenceElement, popperElement, options) {
  if (options === void 0) {
    options = {};
  }

  var prevOptions = react.useRef(null);
  var optionsWithDefaults = {
    onFirstUpdate: options.onFirstUpdate,
    placement: options.placement || 'bottom',
    strategy: options.strategy || 'absolute',
    modifiers: options.modifiers || EMPTY_MODIFIERS
  };

  var _React$useState = react.useState({
    styles: {
      popper: {
        position: optionsWithDefaults.strategy,
        left: '0',
        top: '0'
      },
      arrow: {
        position: 'absolute'
      }
    },
    attributes: {}
  }),
      state = _React$useState[0],
      setState = _React$useState[1];

  var updateStateModifier = react.useMemo(function () {
    return {
      name: 'updateState',
      enabled: true,
      phase: 'write',
      fn: function fn(_ref) {
        var state = _ref.state;
        var elements = Object.keys(state.elements);
        react_dom.flushSync(function () {
          setState({
            styles: fromEntries(elements.map(function (element) {
              return [element, state.styles[element] || {}];
            })),
            attributes: fromEntries(elements.map(function (element) {
              return [element, state.attributes[element]];
            }))
          });
        });
      },
      requires: ['computeStyles']
    };
  }, []);
  var popperOptions = react.useMemo(function () {
    var newOptions = {
      onFirstUpdate: optionsWithDefaults.onFirstUpdate,
      placement: optionsWithDefaults.placement,
      strategy: optionsWithDefaults.strategy,
      modifiers: [].concat(optionsWithDefaults.modifiers, [updateStateModifier, {
        name: 'applyStyles',
        enabled: false
      }])
    };

    if (react_fast_compare_default()(prevOptions.current, newOptions)) {
      return prevOptions.current || newOptions;
    } else {
      prevOptions.current = newOptions;
      return newOptions;
    }
  }, [optionsWithDefaults.onFirstUpdate, optionsWithDefaults.placement, optionsWithDefaults.strategy, optionsWithDefaults.modifiers, updateStateModifier]);
  var popperInstanceRef = react.useRef();
  useIsomorphicLayoutEffect(function () {
    if (popperInstanceRef.current) {
      popperInstanceRef.current.setOptions(popperOptions);
    }
  }, [popperOptions]);
  useIsomorphicLayoutEffect(function () {
    if (referenceElement == null || popperElement == null) {
      return;
    }

    var createPopper = options.createPopper || popper_createPopper;
    var popperInstance = createPopper(referenceElement, popperElement, popperOptions);
    popperInstanceRef.current = popperInstance;
    return function () {
      popperInstance.destroy();
      popperInstanceRef.current = null;
    };
  }, [referenceElement, popperElement, options.createPopper]);
  return {
    state: popperInstanceRef.current ? popperInstanceRef.current.state : null,
    styles: state.styles,
    attributes: state.attributes,
    update: popperInstanceRef.current ? popperInstanceRef.current.update : null,
    forceUpdate: popperInstanceRef.current ? popperInstanceRef.current.forceUpdate : null
  };
};
// EXTERNAL MODULE: ./node_modules/.pnpm/classnames@2.5.1/node_modules/classnames/index.js
var classnames = __webpack_require__(82187);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/.pnpm/void-elements@3.1.0/node_modules/void-elements/index.js
var void_elements = __webpack_require__(89626);
var void_elements_default = /*#__PURE__*/__webpack_require__.n(void_elements);
;// CONCATENATED MODULE: ./node_modules/.pnpm/html-parse-stringify@3.0.1/node_modules/html-parse-stringify/dist/html-parse-stringify.module.js
var t=/\s([^'"/\s><]+?)[\s/>]|([^\s=]+)=\s?(".*?"|'.*?')/g;function n(n){var r={type:"tag",name:"",voidElement:!1,attrs:{},children:[]},i=n.match(/<\/?([^\s]+?)[/\s>]/);if(i&&(r.name=i[1],((void_elements_default())[i[1]]||"/"===n.charAt(n.length-2))&&(r.voidElement=!0),r.name.startsWith("!--"))){var s=n.indexOf("--\x3e");return{type:"comment",comment:-1!==s?n.slice(4,s):""}}for(var a=new RegExp(t),c=null;null!==(c=a.exec(n));)if(c[0].trim())if(c[1]){var o=c[1].trim(),l=[o,""];o.indexOf("=")>-1&&(l=o.split("=")),r.attrs[l[0]]=l[1],a.lastIndex--}else c[2]&&(r.attrs[c[2]]=c[3].trim().substring(1,c[3].length-1));return r}var r=/<[a-zA-Z0-9\-\!\/](?:"[^"]*"|'[^']*'|[^'">])*>/g,i=/^\s*$/,s=Object.create(null);function a(e,t){switch(t.type){case"text":return e+t.content;case"tag":return e+="<"+t.name+(t.attrs?function(e){var t=[];for(var n in e)t.push(n+'="'+e[n]+'"');return t.length?" "+t.join(" "):""}(t.attrs):"")+(t.voidElement?"/>":">"),t.voidElement?e:e+t.children.reduce(a,"")+"</"+t.name+">";case"comment":return e+"\x3c!--"+t.comment+"--\x3e"}}var c={parse:function(e,t){t||(t={}),t.components||(t.components=s);var a,c=[],o=[],l=-1,m=!1;if(0!==e.indexOf("<")){var u=e.indexOf("<");c.push({type:"text",content:-1===u?e:e.substring(0,u)})}return e.replace(r,function(r,s){if(m){if(r!=="</"+a.name+">")return;m=!1}var u,f="/"!==r.charAt(1),h=r.startsWith("\x3c!--"),p=s+r.length,d=e.charAt(p);if(h){var v=n(r);return l<0?(c.push(v),c):((u=o[l]).children.push(v),c)}if(f&&(l++,"tag"===(a=n(r)).type&&t.components[a.name]&&(a.type="component",m=!0),a.voidElement||m||!d||"<"===d||a.children.push({type:"text",content:e.slice(p,e.indexOf("<",p))}),0===l&&c.push(a),(u=o[l-1])&&u.children.push(a),o[l]=a),(!f||a.voidElement)&&(l>-1&&(a.voidElement||a.name===r.slice(2,-1))&&(l--,a=-1===l?c:o[l]),!m&&"<"!==d&&d)){u=-1===l?c:o[l].children;var x=e.indexOf("<",p),g=e.slice(p,-1===x?void 0:x);i.test(g)&&(g=" "),(x>-1&&l+u.length>=0||" "!==g)&&u.push({type:"text",content:g})}}),c},stringify:function(e){return e.reduce(function(e,t){return e+a("",t)},"")}};/* harmony default export */ var html_parse_stringify_module = ((/* unused pure expression or super */ null && (c)));
//# sourceMappingURL=html-parse-stringify.module.js.map

;// CONCATENATED MODULE: ./node_modules/.pnpm/react-i18next@13.5.0_i18next@23.16.4_react-dom@18.3.1_react@18.3.1/node_modules/react-i18next/dist/es/utils.js
function utils_warn() {
  if (console && console.warn) {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    if (typeof args[0] === 'string') args[0] = `react-i18next:: ${args[0]}`;
    console.warn(...args);
  }
}
const alreadyWarned = {};
function utils_warnOnce() {
  for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    args[_key2] = arguments[_key2];
  }
  if (typeof args[0] === 'string' && alreadyWarned[args[0]]) return;
  if (typeof args[0] === 'string') alreadyWarned[args[0]] = new Date();
  utils_warn(...args);
}
const loadedClb = (i18n, cb) => () => {
  if (i18n.isInitialized) {
    cb();
  } else {
    const initialized = () => {
      setTimeout(() => {
        i18n.off('initialized', initialized);
      }, 0);
      cb();
    };
    i18n.on('initialized', initialized);
  }
};
function utils_loadNamespaces(i18n, ns, cb) {
  i18n.loadNamespaces(ns, loadedClb(i18n, cb));
}
function utils_loadLanguages(i18n, lng, ns, cb) {
  if (typeof ns === 'string') ns = [ns];
  ns.forEach(n => {
    if (i18n.options.ns.indexOf(n) < 0) i18n.options.ns.push(n);
  });
  i18n.loadLanguages(lng, loadedClb(i18n, cb));
}
function oldI18nextHasLoadedNamespace(ns, i18n) {
  let options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  const lng = i18n.languages[0];
  const fallbackLng = i18n.options ? i18n.options.fallbackLng : false;
  const lastLng = i18n.languages[i18n.languages.length - 1];
  if (lng.toLowerCase() === 'cimode') return true;
  const loadNotPending = (l, n) => {
    const loadState = i18n.services.backendConnector.state[`${l}|${n}`];
    return loadState === -1 || loadState === 2;
  };
  if (options.bindI18n && options.bindI18n.indexOf('languageChanging') > -1 && i18n.services.backendConnector.backend && i18n.isLanguageChangingTo && !loadNotPending(i18n.isLanguageChangingTo, ns)) return false;
  if (i18n.hasResourceBundle(lng, ns)) return true;
  if (!i18n.services.backendConnector.backend || i18n.options.resources && !i18n.options.partialBundledLanguages) return true;
  if (loadNotPending(lng, ns) && (!fallbackLng || loadNotPending(lastLng, ns))) return true;
  return false;
}
function utils_hasLoadedNamespace(ns, i18n) {
  let options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  if (!i18n.languages || !i18n.languages.length) {
    utils_warnOnce('i18n.languages were undefined or empty', i18n.languages);
    return true;
  }
  const isNewerI18next = i18n.options.ignoreJSONStructure !== undefined;
  if (!isNewerI18next) {
    return oldI18nextHasLoadedNamespace(ns, i18n, options);
  }
  return i18n.hasLoadedNamespace(ns, {
    lng: options.lng,
    precheck: (i18nInstance, loadNotPending) => {
      if (options.bindI18n && options.bindI18n.indexOf('languageChanging') > -1 && i18nInstance.services.backendConnector.backend && i18nInstance.isLanguageChangingTo && !loadNotPending(i18nInstance.isLanguageChangingTo, ns)) return false;
    }
  });
}
function utils_getDisplayName(Component) {
  return Component.displayName || Component.name || (typeof Component === 'string' && Component.length > 0 ? Component : 'Unknown');
}
;// CONCATENATED MODULE: ./node_modules/.pnpm/react-i18next@13.5.0_i18next@23.16.4_react-dom@18.3.1_react@18.3.1/node_modules/react-i18next/dist/es/unescape.js
const matchHtmlEntity = /&(?:amp|#38|lt|#60|gt|#62|apos|#39|quot|#34|nbsp|#160|copy|#169|reg|#174|hellip|#8230|#x2F|#47);/g;
const htmlEntities = {
  '&amp;': '&',
  '&#38;': '&',
  '&lt;': '<',
  '&#60;': '<',
  '&gt;': '>',
  '&#62;': '>',
  '&apos;': "'",
  '&#39;': "'",
  '&quot;': '"',
  '&#34;': '"',
  '&nbsp;': ' ',
  '&#160;': ' ',
  '&copy;': '©',
  '&#169;': '©',
  '&reg;': '®',
  '&#174;': '®',
  '&hellip;': '…',
  '&#8230;': '…',
  '&#x2F;': '/',
  '&#47;': '/'
};
const unescapeHtmlEntity = m => htmlEntities[m];
const unescape_unescape = text => text.replace(matchHtmlEntity, unescapeHtmlEntity);
;// CONCATENATED MODULE: ./node_modules/.pnpm/react-i18next@13.5.0_i18next@23.16.4_react-dom@18.3.1_react@18.3.1/node_modules/react-i18next/dist/es/defaults.js

let defaultOptions = {
  bindI18n: 'languageChanged',
  bindI18nStore: '',
  transEmptyNodeValue: '',
  transSupportBasicHtmlNodes: true,
  transWrapTextNodes: '',
  transKeepBasicHtmlNodesFor: ['br', 'strong', 'i', 'p'],
  useSuspense: true,
  unescape: unescape_unescape
};
function setDefaults() {
  let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  defaultOptions = {
    ...defaultOptions,
    ...options
  };
}
function defaults_getDefaults() {
  return defaultOptions;
}
;// CONCATENATED MODULE: ./node_modules/.pnpm/react-i18next@13.5.0_i18next@23.16.4_react-dom@18.3.1_react@18.3.1/node_modules/react-i18next/dist/es/TransWithoutContext.js






function hasChildren(node, checkLength) {
  if (!node) return false;
  const base = node.props ? node.props.children : node.children;
  if (checkLength) return base.length > 0;
  return !!base;
}
function getChildren(node) {
  if (!node) return [];
  const children = node.props ? node.props.children : node.children;
  return node.props && node.props.i18nIsDynamicList ? getAsArray(children) : children;
}
function hasValidReactChildren(children) {
  if (Object.prototype.toString.call(children) !== '[object Array]') return false;
  return children.every(child => isValidElement(child));
}
function getAsArray(data) {
  return Array.isArray(data) ? data : [data];
}
function mergeProps(source, target) {
  const newTarget = {
    ...target
  };
  newTarget.props = Object.assign(source.props, target.props);
  return newTarget;
}
function nodesToString(children, i18nOptions) {
  if (!children) return '';
  let stringNode = '';
  const childrenArray = getAsArray(children);
  const keepArray = i18nOptions.transSupportBasicHtmlNodes && i18nOptions.transKeepBasicHtmlNodesFor ? i18nOptions.transKeepBasicHtmlNodesFor : [];
  childrenArray.forEach((child, childIndex) => {
    if (typeof child === 'string') {
      stringNode += `${child}`;
    } else if (isValidElement(child)) {
      const childPropsCount = Object.keys(child.props).length;
      const shouldKeepChild = keepArray.indexOf(child.type) > -1;
      const childChildren = child.props.children;
      if (!childChildren && shouldKeepChild && childPropsCount === 0) {
        stringNode += `<${child.type}/>`;
      } else if (!childChildren && (!shouldKeepChild || childPropsCount !== 0)) {
        stringNode += `<${childIndex}></${childIndex}>`;
      } else if (child.props.i18nIsDynamicList) {
        stringNode += `<${childIndex}></${childIndex}>`;
      } else if (shouldKeepChild && childPropsCount === 1 && typeof childChildren === 'string') {
        stringNode += `<${child.type}>${childChildren}</${child.type}>`;
      } else {
        const content = nodesToString(childChildren, i18nOptions);
        stringNode += `<${childIndex}>${content}</${childIndex}>`;
      }
    } else if (child === null) {
      warn(`Trans: the passed in value is invalid - seems you passed in a null child.`);
    } else if (typeof child === 'object') {
      const {
        format,
        ...clone
      } = child;
      const keys = Object.keys(clone);
      if (keys.length === 1) {
        const value = format ? `${keys[0]}, ${format}` : keys[0];
        stringNode += `{{${value}}}`;
      } else {
        warn(`react-i18next: the passed in object contained more than one variable - the object should look like {{ value, format }} where format is optional.`, child);
      }
    } else {
      warn(`Trans: the passed in value is invalid - seems you passed in a variable like {number} - please pass in variables for interpolation as full objects like {{number}}.`, child);
    }
  });
  return stringNode;
}
function renderNodes(children, targetString, i18n, i18nOptions, combinedTOpts, shouldUnescape) {
  if (targetString === '') return [];
  const keepArray = i18nOptions.transKeepBasicHtmlNodesFor || [];
  const emptyChildrenButNeedsHandling = targetString && new RegExp(keepArray.map(keep => `<${keep}`).join('|')).test(targetString);
  if (!children && !emptyChildrenButNeedsHandling && !shouldUnescape) return [targetString];
  const data = {};
  function getData(childs) {
    const childrenArray = getAsArray(childs);
    childrenArray.forEach(child => {
      if (typeof child === 'string') return;
      if (hasChildren(child)) getData(getChildren(child));else if (typeof child === 'object' && !isValidElement(child)) Object.assign(data, child);
    });
  }
  getData(children);
  const ast = HTML.parse(`<0>${targetString}</0>`);
  const opts = {
    ...data,
    ...combinedTOpts
  };
  function renderInner(child, node, rootReactNode) {
    const childs = getChildren(child);
    const mappedChildren = mapAST(childs, node.children, rootReactNode);
    return hasValidReactChildren(childs) && mappedChildren.length === 0 || child.props && child.props.i18nIsDynamicList ? childs : mappedChildren;
  }
  function pushTranslatedJSX(child, inner, mem, i, isVoid) {
    if (child.dummy) {
      child.children = inner;
      mem.push(cloneElement(child, {
        key: i
      }, isVoid ? undefined : inner));
    } else {
      mem.push(...Children.map([child], c => {
        const props = {
          ...c.props
        };
        delete props.i18nIsDynamicList;
        return React.createElement(c.type, _extends({}, props, {
          key: i,
          ref: c.ref
        }, isVoid ? {} : {
          children: inner
        }));
      }));
    }
  }
  function mapAST(reactNode, astNode, rootReactNode) {
    const reactNodes = getAsArray(reactNode);
    const astNodes = getAsArray(astNode);
    return astNodes.reduce((mem, node, i) => {
      const translationContent = node.children && node.children[0] && node.children[0].content && i18n.services.interpolator.interpolate(node.children[0].content, opts, i18n.language);
      if (node.type === 'tag') {
        let tmp = reactNodes[parseInt(node.name, 10)];
        if (rootReactNode.length === 1 && !tmp) tmp = rootReactNode[0][node.name];
        if (!tmp) tmp = {};
        const child = Object.keys(node.attrs).length !== 0 ? mergeProps({
          props: node.attrs
        }, tmp) : tmp;
        const isElement = isValidElement(child);
        const isValidTranslationWithChildren = isElement && hasChildren(node, true) && !node.voidElement;
        const isEmptyTransWithHTML = emptyChildrenButNeedsHandling && typeof child === 'object' && child.dummy && !isElement;
        const isKnownComponent = typeof children === 'object' && children !== null && Object.hasOwnProperty.call(children, node.name);
        if (typeof child === 'string') {
          const value = i18n.services.interpolator.interpolate(child, opts, i18n.language);
          mem.push(value);
        } else if (hasChildren(child) || isValidTranslationWithChildren) {
          const inner = renderInner(child, node, rootReactNode);
          pushTranslatedJSX(child, inner, mem, i);
        } else if (isEmptyTransWithHTML) {
          const inner = mapAST(reactNodes, node.children, rootReactNode);
          pushTranslatedJSX(child, inner, mem, i);
        } else if (Number.isNaN(parseFloat(node.name))) {
          if (isKnownComponent) {
            const inner = renderInner(child, node, rootReactNode);
            pushTranslatedJSX(child, inner, mem, i, node.voidElement);
          } else if (i18nOptions.transSupportBasicHtmlNodes && keepArray.indexOf(node.name) > -1) {
            if (node.voidElement) {
              mem.push(createElement(node.name, {
                key: `${node.name}-${i}`
              }));
            } else {
              const inner = mapAST(reactNodes, node.children, rootReactNode);
              mem.push(createElement(node.name, {
                key: `${node.name}-${i}`
              }, inner));
            }
          } else if (node.voidElement) {
            mem.push(`<${node.name} />`);
          } else {
            const inner = mapAST(reactNodes, node.children, rootReactNode);
            mem.push(`<${node.name}>${inner}</${node.name}>`);
          }
        } else if (typeof child === 'object' && !isElement) {
          const content = node.children[0] ? translationContent : null;
          if (content) mem.push(content);
        } else {
          pushTranslatedJSX(child, translationContent, mem, i, node.children.length !== 1 || !translationContent);
        }
      } else if (node.type === 'text') {
        const wrapTextNodes = i18nOptions.transWrapTextNodes;
        const content = shouldUnescape ? i18nOptions.unescape(i18n.services.interpolator.interpolate(node.content, opts, i18n.language)) : i18n.services.interpolator.interpolate(node.content, opts, i18n.language);
        if (wrapTextNodes) {
          mem.push(createElement(wrapTextNodes, {
            key: `${node.name}-${i}`
          }, content));
        } else {
          mem.push(content);
        }
      }
      return mem;
    }, []);
  }
  const result = mapAST([{
    dummy: true,
    children: children || []
  }], ast, getAsArray(children || []));
  return getChildren(result[0]);
}
function Trans(_ref) {
  let {
    children,
    count,
    parent,
    i18nKey,
    context,
    tOptions = {},
    values,
    defaults,
    components,
    ns,
    i18n: i18nFromProps,
    t: tFromProps,
    shouldUnescape,
    ...additionalProps
  } = _ref;
  const i18n = i18nFromProps || getI18n();
  if (!i18n) {
    warnOnce('You will need to pass in an i18next instance by using i18nextReactModule');
    return children;
  }
  const t = tFromProps || i18n.t.bind(i18n) || (k => k);
  if (context) tOptions.context = context;
  const reactI18nextOptions = {
    ...getDefaults(),
    ...(i18n.options && i18n.options.react)
  };
  let namespaces = ns || t.ns || i18n.options && i18n.options.defaultNS;
  namespaces = typeof namespaces === 'string' ? [namespaces] : namespaces || ['translation'];
  const nodeAsString = nodesToString(children, reactI18nextOptions);
  const defaultValue = defaults || nodeAsString || reactI18nextOptions.transEmptyNodeValue || i18nKey;
  const {
    hashTransKey
  } = reactI18nextOptions;
  const key = i18nKey || (hashTransKey ? hashTransKey(nodeAsString || defaultValue) : nodeAsString || defaultValue);
  if (i18n.options && i18n.options.interpolation && i18n.options.interpolation.defaultVariables) {
    values = values && Object.keys(values).length > 0 ? {
      ...values,
      ...i18n.options.interpolation.defaultVariables
    } : {
      ...i18n.options.interpolation.defaultVariables
    };
  }
  const interpolationOverride = values ? tOptions.interpolation : {
    interpolation: {
      ...tOptions.interpolation,
      prefix: '#$?',
      suffix: '?$#'
    }
  };
  const combinedTOpts = {
    ...tOptions,
    count,
    ...values,
    ...interpolationOverride,
    defaultValue,
    ns: namespaces
  };
  const translation = key ? t(key, combinedTOpts) : defaultValue;
  if (components) {
    Object.keys(components).forEach(c => {
      const comp = components[c];
      if (typeof comp.type === 'function' || !comp.props || !comp.props.children || translation.indexOf(`${c}/>`) < 0 && translation.indexOf(`${c} />`) < 0) return;
      function Componentized() {
        return React.createElement(React.Fragment, null, comp);
      }
      components[c] = React.createElement(Componentized, null);
    });
  }
  const content = renderNodes(components || children, translation, i18n, reactI18nextOptions, combinedTOpts, shouldUnescape);
  const useAsParent = parent !== undefined ? parent : reactI18nextOptions.defaultTransParent;
  return useAsParent ? createElement(useAsParent, additionalProps, content) : content;
}
;// CONCATENATED MODULE: ./node_modules/.pnpm/react-i18next@13.5.0_i18next@23.16.4_react-dom@18.3.1_react@18.3.1/node_modules/react-i18next/dist/es/i18nInstance.js
let i18nInstance;
function setI18n(instance) {
  i18nInstance = instance;
}
function i18nInstance_getI18n() {
  return i18nInstance;
}
;// CONCATENATED MODULE: ./node_modules/.pnpm/react-i18next@13.5.0_i18next@23.16.4_react-dom@18.3.1_react@18.3.1/node_modules/react-i18next/dist/es/initReactI18next.js


const initReactI18next = {
  type: '3rdParty',
  init(instance) {
    setDefaults(instance.options.react);
    setI18n(instance);
  }
};
;// CONCATENATED MODULE: ./node_modules/.pnpm/react-i18next@13.5.0_i18next@23.16.4_react-dom@18.3.1_react@18.3.1/node_modules/react-i18next/dist/es/context.js





const context_I18nContext = (0,react.createContext)();
class context_ReportNamespaces {
  constructor() {
    this.usedNamespaces = {};
  }
  addUsedNamespaces(namespaces) {
    namespaces.forEach(ns => {
      if (!this.usedNamespaces[ns]) this.usedNamespaces[ns] = true;
    });
  }
  getUsedNamespaces() {
    return Object.keys(this.usedNamespaces);
  }
}
function context_composeInitialProps(ForComponent) {
  return ctx => new Promise(resolve => {
    const i18nInitialProps = getInitialProps();
    if (ForComponent.getInitialProps) {
      ForComponent.getInitialProps(ctx).then(componentsInitialProps => {
        resolve({
          ...componentsInitialProps,
          ...i18nInitialProps
        });
      });
    } else {
      resolve(i18nInitialProps);
    }
  });
}
function getInitialProps() {
  const i18n = getI18n();
  const namespaces = i18n.reportNamespaces ? i18n.reportNamespaces.getUsedNamespaces() : [];
  const ret = {};
  const initialI18nStore = {};
  i18n.languages.forEach(l => {
    initialI18nStore[l] = {};
    namespaces.forEach(ns => {
      initialI18nStore[l][ns] = i18n.getResourceBundle(l, ns) || {};
    });
  });
  ret.initialI18nStore = initialI18nStore;
  ret.initialLanguage = i18n.language;
  return ret;
}
;// CONCATENATED MODULE: ./node_modules/.pnpm/react-i18next@13.5.0_i18next@23.16.4_react-dom@18.3.1_react@18.3.1/node_modules/react-i18next/dist/es/Trans.js




function Trans_Trans(_ref) {
  let {
    children,
    count,
    parent,
    i18nKey,
    context,
    tOptions = {},
    values,
    defaults,
    components,
    ns,
    i18n: i18nFromProps,
    t: tFromProps,
    shouldUnescape,
    ...additionalProps
  } = _ref;
  const {
    i18n: i18nFromContext,
    defaultNS: defaultNSFromContext
  } = useContext(I18nContext) || {};
  const i18n = i18nFromProps || i18nFromContext || getI18n();
  const t = tFromProps || i18n && i18n.t.bind(i18n);
  return TransWithoutContext({
    children,
    count,
    parent,
    i18nKey,
    context,
    tOptions,
    values,
    defaults,
    components,
    ns: ns || t && t.ns || defaultNSFromContext || i18n && i18n.options && i18n.options.defaultNS,
    i18n,
    t: tFromProps,
    shouldUnescape,
    ...additionalProps
  });
}
;// CONCATENATED MODULE: ./node_modules/.pnpm/react-i18next@13.5.0_i18next@23.16.4_react-dom@18.3.1_react@18.3.1/node_modules/react-i18next/dist/es/useTranslation.js



const usePrevious = (value, ignore) => {
  const ref = useRef();
  useEffect(() => {
    ref.current = ignore ? ref.current : value;
  }, [value, ignore]);
  return ref.current;
};
function useTranslation_useTranslation(ns) {
  let props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  const {
    i18n: i18nFromProps
  } = props;
  const {
    i18n: i18nFromContext,
    defaultNS: defaultNSFromContext
  } = useContext(I18nContext) || {};
  const i18n = i18nFromProps || i18nFromContext || getI18n();
  if (i18n && !i18n.reportNamespaces) i18n.reportNamespaces = new ReportNamespaces();
  if (!i18n) {
    warnOnce('You will need to pass in an i18next instance by using initReactI18next');
    const notReadyT = (k, optsOrDefaultValue) => {
      if (typeof optsOrDefaultValue === 'string') return optsOrDefaultValue;
      if (optsOrDefaultValue && typeof optsOrDefaultValue === 'object' && typeof optsOrDefaultValue.defaultValue === 'string') return optsOrDefaultValue.defaultValue;
      return Array.isArray(k) ? k[k.length - 1] : k;
    };
    const retNotReady = [notReadyT, {}, false];
    retNotReady.t = notReadyT;
    retNotReady.i18n = {};
    retNotReady.ready = false;
    return retNotReady;
  }
  if (i18n.options.react && i18n.options.react.wait !== undefined) warnOnce('It seems you are still using the old wait option, you may migrate to the new useSuspense behaviour.');
  const i18nOptions = {
    ...getDefaults(),
    ...i18n.options.react,
    ...props
  };
  const {
    useSuspense,
    keyPrefix
  } = i18nOptions;
  let namespaces = ns || defaultNSFromContext || i18n.options && i18n.options.defaultNS;
  namespaces = typeof namespaces === 'string' ? [namespaces] : namespaces || ['translation'];
  if (i18n.reportNamespaces.addUsedNamespaces) i18n.reportNamespaces.addUsedNamespaces(namespaces);
  const ready = (i18n.isInitialized || i18n.initializedStoreOnce) && namespaces.every(n => hasLoadedNamespace(n, i18n, i18nOptions));
  function getT() {
    return i18n.getFixedT(props.lng || null, i18nOptions.nsMode === 'fallback' ? namespaces : namespaces[0], keyPrefix);
  }
  const [t, setT] = useState(getT);
  let joinedNS = namespaces.join();
  if (props.lng) joinedNS = `${props.lng}${joinedNS}`;
  const previousJoinedNS = usePrevious(joinedNS);
  const isMounted = useRef(true);
  useEffect(() => {
    const {
      bindI18n,
      bindI18nStore
    } = i18nOptions;
    isMounted.current = true;
    if (!ready && !useSuspense) {
      if (props.lng) {
        loadLanguages(i18n, props.lng, namespaces, () => {
          if (isMounted.current) setT(getT);
        });
      } else {
        loadNamespaces(i18n, namespaces, () => {
          if (isMounted.current) setT(getT);
        });
      }
    }
    if (ready && previousJoinedNS && previousJoinedNS !== joinedNS && isMounted.current) {
      setT(getT);
    }
    function boundReset() {
      if (isMounted.current) setT(getT);
    }
    if (bindI18n && i18n) i18n.on(bindI18n, boundReset);
    if (bindI18nStore && i18n) i18n.store.on(bindI18nStore, boundReset);
    return () => {
      isMounted.current = false;
      if (bindI18n && i18n) bindI18n.split(' ').forEach(e => i18n.off(e, boundReset));
      if (bindI18nStore && i18n) bindI18nStore.split(' ').forEach(e => i18n.store.off(e, boundReset));
    };
  }, [i18n, joinedNS]);
  const isInitial = useRef(true);
  useEffect(() => {
    if (isMounted.current && !isInitial.current) {
      setT(getT);
    }
    isInitial.current = false;
  }, [i18n, keyPrefix]);
  const ret = [t, i18n, ready];
  ret.t = t;
  ret.i18n = i18n;
  ret.ready = ready;
  if (ready) return ret;
  if (!ready && !useSuspense) return ret;
  throw new Promise(resolve => {
    if (props.lng) {
      loadLanguages(i18n, props.lng, namespaces, () => resolve());
    } else {
      loadNamespaces(i18n, namespaces, () => resolve());
    }
  });
}
;// CONCATENATED MODULE: ./node_modules/.pnpm/react-i18next@13.5.0_i18next@23.16.4_react-dom@18.3.1_react@18.3.1/node_modules/react-i18next/dist/es/withTranslation.js



function withTranslation(ns) {
  let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return function Extend(WrappedComponent) {
    function I18nextWithTranslation(_ref) {
      let {
        forwardedRef,
        ...rest
      } = _ref;
      const [t, i18n, ready] = useTranslation(ns, {
        ...rest,
        keyPrefix: options.keyPrefix
      });
      const passDownProps = {
        ...rest,
        t,
        i18n,
        tReady: ready
      };
      if (options.withRef && forwardedRef) {
        passDownProps.ref = forwardedRef;
      } else if (!options.withRef && forwardedRef) {
        passDownProps.forwardedRef = forwardedRef;
      }
      return createElement(WrappedComponent, passDownProps);
    }
    I18nextWithTranslation.displayName = `withI18nextTranslation(${getDisplayName(WrappedComponent)})`;
    I18nextWithTranslation.WrappedComponent = WrappedComponent;
    const forwardRef = (props, ref) => createElement(I18nextWithTranslation, Object.assign({}, props, {
      forwardedRef: ref
    }));
    return options.withRef ? forwardRefReact(forwardRef) : I18nextWithTranslation;
  };
}
;// CONCATENATED MODULE: ./node_modules/.pnpm/react-i18next@13.5.0_i18next@23.16.4_react-dom@18.3.1_react@18.3.1/node_modules/react-i18next/dist/es/Translation.js

function Translation(props) {
  const {
    ns,
    children,
    ...options
  } = props;
  const [t, i18n, ready] = useTranslation(ns, options);
  return children(t, {
    i18n,
    lng: i18n.language
  }, ready);
}
;// CONCATENATED MODULE: ./node_modules/.pnpm/react-i18next@13.5.0_i18next@23.16.4_react-dom@18.3.1_react@18.3.1/node_modules/react-i18next/dist/es/I18nextProvider.js


function I18nextProvider(_ref) {
  let {
    i18n,
    defaultNS,
    children
  } = _ref;
  const value = useMemo(() => ({
    i18n,
    defaultNS
  }), [i18n, defaultNS]);
  return createElement(I18nContext.Provider, {
    value
  }, children);
}
;// CONCATENATED MODULE: ./node_modules/.pnpm/react-i18next@13.5.0_i18next@23.16.4_react-dom@18.3.1_react@18.3.1/node_modules/react-i18next/dist/es/useSSR.js


function useSSR_useSSR(initialI18nStore, initialLanguage) {
  let props = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  const {
    i18n: i18nFromProps
  } = props;
  const {
    i18n: i18nFromContext
  } = useContext(I18nContext) || {};
  const i18n = i18nFromProps || i18nFromContext || getI18n();
  if (i18n.options && i18n.options.isClone) return;
  if (initialI18nStore && !i18n.initializedStoreOnce) {
    i18n.services.resourceStore.data = initialI18nStore;
    i18n.options.ns = Object.values(initialI18nStore).reduce((mem, lngResources) => {
      Object.keys(lngResources).forEach(ns => {
        if (mem.indexOf(ns) < 0) mem.push(ns);
      });
      return mem;
    }, i18n.options.ns);
    i18n.initializedStoreOnce = true;
    i18n.isInitialized = true;
  }
  if (initialLanguage && !i18n.initializedLanguageOnce) {
    i18n.changeLanguage(initialLanguage);
    i18n.initializedLanguageOnce = true;
  }
}
;// CONCATENATED MODULE: ./node_modules/.pnpm/react-i18next@13.5.0_i18next@23.16.4_react-dom@18.3.1_react@18.3.1/node_modules/react-i18next/dist/es/withSSR.js




function withSSR() {
  return function Extend(WrappedComponent) {
    function I18nextWithSSR(_ref) {
      let {
        initialI18nStore,
        initialLanguage,
        ...rest
      } = _ref;
      useSSR(initialI18nStore, initialLanguage);
      return createElement(WrappedComponent, {
        ...rest
      });
    }
    I18nextWithSSR.getInitialProps = composeInitialProps(WrappedComponent);
    I18nextWithSSR.displayName = `withI18nextSSR(${getDisplayName(WrappedComponent)})`;
    I18nextWithSSR.WrappedComponent = WrappedComponent;
    return I18nextWithSSR;
  };
}
;// CONCATENATED MODULE: ./node_modules/.pnpm/react-i18next@13.5.0_i18next@23.16.4_react-dom@18.3.1_react@18.3.1/node_modules/react-i18next/dist/es/index.js












const date = () => '';
const time = () => '';
const number = () => '';
const es_select = () => '';
const plural = () => '';
const selectOrdinal = () => '';
// EXTERNAL MODULE: ./node_modules/.pnpm/@bucketplace+design-system@5.3.3_@bucketplace+ui@1.0.9_@emotion+react@11.13.3_@emotion+styled_gws5alfnqy5ixwsabrkna3jsv4/node_modules/@bucketplace/design-system/dist/esm/Loading.js
var esm_Loading = __webpack_require__(33328);
// EXTERNAL MODULE: ./node_modules/.pnpm/@bucketplace+design-system@5.3.3_@bucketplace+ui@1.0.9_@emotion+react@11.13.3_@emotion+styled_gws5alfnqy5ixwsabrkna3jsv4/node_modules/@bucketplace/design-system/dist/esm/icons.js
var icons = __webpack_require__(62471);
// EXTERNAL MODULE: ./node_modules/.pnpm/@bucketplace+design-system@5.3.3_@bucketplace+ui@1.0.9_@emotion+react@11.13.3_@emotion+styled_gws5alfnqy5ixwsabrkna3jsv4/node_modules/@bucketplace/design-system/dist/esm/utils.js
var utils = __webpack_require__(85353);
// EXTERNAL MODULE: ./node_modules/.pnpm/eases@1.0.8/node_modules/eases/index.js
var eases = __webpack_require__(52075);
// EXTERNAL MODULE: ./node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/isEqual.js
var lodash_isEqual = __webpack_require__(31223);
// EXTERNAL MODULE: ./node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/findLastKey.js
var lodash_findLastKey = __webpack_require__(94274);
// EXTERNAL MODULE: ./node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/omit.js
var lodash_omit = __webpack_require__(59245);
// EXTERNAL MODULE: ./node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/findLast.js
var lodash_findLast = __webpack_require__(90469);
// EXTERNAL MODULE: ./node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/size.js
var lodash_size = __webpack_require__(81430);
;// CONCATENATED MODULE: ./node_modules/.pnpm/@bucketplace+design-system@5.3.3_@bucketplace+ui@1.0.9_@emotion+react@11.13.3_@emotion+styled_gws5alfnqy5ixwsabrkna3jsv4/node_modules/@bucketplace/design-system/dist/esm/bds.js


































function cssBaseBadge(theme, props) {
  return /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)(templateObject_1$28 || (templateObject_1$28 = (0,common._)(["\n    ", "\n    display: inline-block;\n    font-weight: 700;\n    height: ", ";\n    line-height: ", ";\n  " + ( true ? "" : 0)], ["\n    ", "\n    display: inline-block;\n    font-weight: 700;\n    height: ", ";\n    line-height: ", ";\n  " + ( true ? "" : 0)])), cssBadgeVariant$1(theme, props), (0,foundation.p)(props.size), (0,foundation.p)(props.size));
}
function cssBadgeVariant$1(theme, props) {
  if (props.disabled) {
    return cssDisabledBadge(theme, props.variant);
  }
  switch (props.type) {
    case 'fill':
      return cssFillBadge(theme, props.variant);
    case 'weak':
      return cssWeakBadge(theme, props.variant);
  }
}
function cssDisabledBadge(theme, variant) {
  switch (variant) {
    case 'dim':
      return /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)(templateObject_2$1F || (templateObject_2$1F = (0,common._)(["\n        color: ", ";\n        background-color: ", ";\n        " + ( true ? "" : 0)], ["\n        color: ", ";\n        background-color: ", ";\n        " + ( true ? "" : 0)])), theme.content.base2, theme.dim.disabled);
    case 'base2Outline':
      return /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)(templateObject_3$1o || (templateObject_3$1o = (0,common._)(["\n        color: ", ";\n        background-color: ", ";\n        border: ", " solid ", ";\n      " + ( true ? "" : 0)], ["\n        color: ", ";\n        background-color: ", ";\n        border: ", " solid ", ";\n      " + ( true ? "" : 0)])), theme.content.base3, (0,foundation.h)(theme.content.base5, 0.7), (0,foundation.p)(1), theme.outline);
    default:
      return /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)(templateObject_4$17 || (templateObject_4$17 = (0,common._)(["\n        color: ", ";\n        background-color: ", ";\n      " + ( true ? "" : 0)], ["\n        color: ", ";\n        background-color: ", ";\n      " + ( true ? "" : 0)])), theme.content.base3, theme.content.base4);
  }
}
function cssFillBadge(theme, variant) {
  switch (variant) {
    case 'dim':
      return /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)(templateObject_5$W || (templateObject_5$W = (0,common._)(["\n        color: ", ";\n        background-color: ", ";\n      " + ( true ? "" : 0)], ["\n        color: ", ";\n        background-color: ", ";\n      " + ( true ? "" : 0)])), theme.content.white, theme.dim.thick);
    case 'base2':
      return /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)(templateObject_6$L || (templateObject_6$L = (0,common._)(["\n        color: ", ";\n        background-color: ", ";\n      " + ( true ? "" : 0)], ["\n        color: ", ";\n        background-color: ", ";\n      " + ( true ? "" : 0)])), theme.content.base6, theme.content.base2);
    case 'primary1':
    case 'primary2':
    case 'primary3':
    case 'primary4':
      return /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)(templateObject_7$A || (templateObject_7$A = (0,common._)(["\n        color: ", ";\n        background-color: ", ";\n      " + ( true ? "" : 0)], ["\n        color: ", ";\n        background-color: ", ";\n      " + ( true ? "" : 0)])), theme.content.white, theme.content[variant].basic);
  }
}
function cssWeakBadge(theme, variant) {
  switch (variant) {
    case 'base2Outline':
      return /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)(templateObject_8$s || (templateObject_8$s = (0,common._)(["\n        color: ", ";\n        background-color: ", ";\n        border: ", " solid ", ";\n      " + ( true ? "" : 0)], ["\n        color: ", ";\n        background-color: ", ";\n        border: ", " solid ", ";\n      " + ( true ? "" : 0)])), theme.content.base2, (0,foundation.h)(theme.content.base6, 0.7), (0,foundation.p)(1), theme.outline);
    case 'primary1':
    case 'primary3':
      return /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)(templateObject_9$k || (templateObject_9$k = (0,common._)(["\n        color: ", ";\n        background-color: ", ";\n      " + ( true ? "" : 0)], ["\n        color: ", ";\n        background-color: ", ";\n      " + ( true ? "" : 0)])), theme.content[variant].basic, theme.content[variant].thin);
    case 'primary2':
    case 'primary4':
      return /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)(templateObject_10$h || (templateObject_10$h = (0,common._)(["\n        color: ", ";\n        background-color: ", ";\n      " + ( true ? "" : 0)], ["\n        color: ", ";\n        background-color: ", ";\n      " + ( true ? "" : 0)])), theme.content[variant].thick, theme.content[variant].thin);
    case 'base2':
      return /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)(templateObject_11$a || (templateObject_11$a = (0,common._)(["\n        color: ", ";\n        background-color: ", ";\n      " + ( true ? "" : 0)], ["\n        color: ", ";\n        background-color: ", ";\n      " + ( true ? "" : 0)])), theme.content.base2, theme.content.base4);
  }
}
var templateObject_1$28, templateObject_2$1F, templateObject_3$1o, templateObject_4$17, templateObject_5$W, templateObject_6$L, templateObject_7$A, templateObject_8$s, templateObject_9$k, templateObject_10$h, templateObject_11$a;

function cssSize$6(size) {
  switch (size) {
    case 16:
      return /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)(templateObject_1$27 || (templateObject_1$27 = (0,common._)(["\n        ", "\n        padding: 0 ", ";\n      " + ( true ? "" : 0)], ["\n        ", "\n        padding: 0 ", ";\n      " + ( true ? "" : 0)])), foundation.F.caption2, (0,foundation.p)(4));
    case 20:
      return /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)(templateObject_2$1E || (templateObject_2$1E = (0,common._)(["\n        ", "\n        padding: 0 ", ";\n      " + ( true ? "" : 0)], ["\n        ", "\n        padding: 0 ", ";\n      " + ( true ? "" : 0)])), foundation.F.caption2, (0,foundation.p)(6));
    case 24:
      return /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)(templateObject_3$1n || (templateObject_3$1n = (0,common._)(["\n        ", "\n        padding: 0 ", ";\n      " + ( true ? "" : 0)], ["\n        ", "\n        padding: 0 ", ";\n      " + ( true ? "" : 0)])), foundation.F.caption1, (0,foundation.p)(6));
    case 28:
      return /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)(templateObject_4$16 || (templateObject_4$16 = (0,common._)(["\n        ", "\n        padding: 0 ", ";\n      " + ( true ? "" : 0)], ["\n        ", "\n        padding: 0 ", ";\n      " + ( true ? "" : 0)])), foundation.F.subTitle1, (0,foundation.p)(8));
  }
}
/**
 * @deprecated ODS의 SquareBadge를 사용해주세요.
 */
function SquareBadge(props) {
  var size = props.size,
    children = props.children,
    rest = (0,common.e)(props, ["size", "children"]);
  var theme = (0,emotion_element_5486c51c_browser_esm.u)();
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", (0,common.a)({}, rest, {
    css: [cssSize$6(size), cssBaseBadge(theme, props), /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)(templateObject_5$V || (templateObject_5$V = (0,common._)(["\n          border-radius: ", ";\n        " + ( true ? "" : 0)], ["\n          border-radius: ", ";\n        " + ( true ? "" : 0)])), (0,foundation.p)(4))]
  }, {
    children: children
  }));
}
var templateObject_1$27, templateObject_2$1E, templateObject_3$1n, templateObject_4$16, templateObject_5$V;

function cssSize$5(size) {
  switch (size) {
    case 16:
      return /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)(templateObject_1$26 || (templateObject_1$26 = (0,common._)(["\n        ", "\n        padding: 0 ", ";\n        border-radius: ", ";\n      " + ( true ? "" : 0)], ["\n        ", "\n        padding: 0 ", ";\n        border-radius: ", ";\n      " + ( true ? "" : 0)])), foundation.F.caption2, (0,foundation.p)(6), (0,foundation.p)(9));
    case 20:
      return /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)(templateObject_2$1D || (templateObject_2$1D = (0,common._)(["\n        ", "\n        padding: 0 ", ";\n        border-radius: ", ";\n      " + ( true ? "" : 0)], ["\n        ", "\n        padding: 0 ", ";\n        border-radius: ", ";\n      " + ( true ? "" : 0)])), foundation.F.caption1, (0,foundation.p)(6), (0,foundation.p)(10));
    case 24:
      return /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)(templateObject_3$1m || (templateObject_3$1m = (0,common._)(["\n        ", "\n        padding: 0 ", ";\n        border-radius: ", ";\n      " + ( true ? "" : 0)], ["\n        ", "\n        padding: 0 ", ";\n        border-radius: ", ";\n      " + ( true ? "" : 0)])), foundation.F.body3, (0,foundation.p)(8), (0,foundation.p)(12));
  }
}
/**
 * @deprecated ODS의 PillBadge를 사용해주세요.
 */
function PillBadge(props) {
  var size = props.size,
    children = props.children,
    rest = (0,common.e)(props, ["size", "children"]);
  var theme = (0,emotion_element_5486c51c_browser_esm.u)();
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", (0,common.a)({}, rest, {
    css: [cssSize$5(size), cssBaseBadge(theme, props)]
  }, {
    children: children
  }));
}
var templateObject_1$26, templateObject_2$1D, templateObject_3$1m;

function cssSize$4(size) {
  switch (size) {
    case 16:
      return /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)(templateObject_1$25 || (templateObject_1$25 = (0,common._)(["\n        ", "\n        padding: 0 ", ";\n      " + ( true ? "" : 0)], ["\n        ", "\n        padding: 0 ", ";\n      " + ( true ? "" : 0)])), foundation.F.caption2, (0,foundation.p)(5));
    case 20:
      return /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)(templateObject_2$1C || (templateObject_2$1C = (0,common._)(["\n        ", "\n        padding: 0 ", ";\n      " + ( true ? "" : 0)], ["\n        ", "\n        padding: 0 ", ";\n      " + ( true ? "" : 0)])), foundation.F.caption2, (0,foundation.p)(7));
    case 24:
      return /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)(templateObject_3$1l || (templateObject_3$1l = (0,common._)(["\n        ", "\n        padding: 0 ", ";\n      " + ( true ? "" : 0)], ["\n        ", "\n        padding: 0 ", ";\n      " + ( true ? "" : 0)])), foundation.F.caption1, (0,foundation.p)(8));
  }
}
/**
 * @deprecated ODS의 CircleBadge 컴포넌트를 사용해 주세요.
 */
function CircleBadge(props) {
  var size = props.size,
    children = props.children,
    rest = (0,common.e)(props, ["size", "children"]);
  var theme = (0,emotion_element_5486c51c_browser_esm.u)();
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", (0,common.a)({}, rest, {
    css: [cssSize$4(size), cssBaseBadge(theme, props), /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)(templateObject_4$15 || (templateObject_4$15 = (0,common._)(["\n          border-radius: ", ";\n        " + ( true ? "" : 0)], ["\n          border-radius: ", ";\n        " + ( true ? "" : 0)])), (0,foundation.p)(size / 2))]
  }, {
    children: children
  }));
}
var templateObject_1$25, templateObject_2$1C, templateObject_3$1l, templateObject_4$15;

/**
 * @author TroyTae
 * @version 1.3.8
 * @license MIT
 * @name one-spaces
 */
function bds_n(r) {
  for (var t, e = 0, o = ""; e < r.length;) (t = r[e++]) && (t.pop && !(t = bds_n(t)) || (o && (o += " "), o += t));
  return o;
}
function spaces () {
  return bds_n(arguments);
}

/**
 * @deprecated ODS의 Icon 컴포넌트를 사용해 주세요.
 */
function Icon(_a) {
  var fill = _a.fill,
    name = _a.name,
    size = _a.size,
    className = _a.className,
    rest = (0,common.e)(_a, ["fill", "name", "size", "className"]);
  var theme = (0,emotion_element_5486c51c_browser_esm.u)();
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", (0,common.a)({}, rest, {
    css: [/*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)(templateObject_1$24 || (templateObject_1$24 = (0,common._)(["\n          display: inline-block;\n          font-size: ", ";\n          line-height: 1;\n          &::before {\n            font-family: OhouseIcon;\n            vertical-align: top;\n          }\n        " + ( true ? "" : 0)], ["\n          display: inline-block;\n          font-size: ", ";\n          line-height: 1;\n          &::before {\n            font-family: OhouseIcon;\n            vertical-align: top;\n          }\n        " + ( true ? "" : 0)])), (0,foundation.p)(size)), fill && /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)(templateObject_2$1B || (templateObject_2$1B = (0,common._)(["\n          color: ", ";\n        " + ( true ? "" : 0)], ["\n          color: ", ";\n        " + ( true ? "" : 0)])), fill(theme))],
    className: spaces(className, "_".concat(name, "_").concat(size))
  }));
}
var templateObject_1$24, templateObject_2$1B;

function Crumb(_a) {
  var text = _a.text,
    isActive = _a.isActive,
    rest = __rest(_a, ["text", "isActive"]);
  var theme = useTheme();
  return jsx("button", _assign({
    type: "button"
  }, rest, {
    css: /*#__PURE__*/css(templateObject_1$23 || (templateObject_1$23 = __makeTemplateObject(["\n        ", "\n        font: inherit;\n        vertical-align: top;\n        color: ", ";\n      " + ( true ? "" : 0)], ["\n        ", "\n        font: inherit;\n        vertical-align: top;\n        color: ", ";\n      " + ( true ? "" : 0)])), RESET_BUTTON, isActive ? theme.content.base1 : theme.content.base2)
  }, {
    children: text
  }));
}
var templateObject_1$23;

function Breadcrumb(_a) {
  var activeIndex = _a.activeIndex,
    onChangeIndex = _a.onChangeIndex,
    crumbs = _a.crumbs,
    rest = __rest(_a, ["activeIndex", "onChangeIndex", "crumbs"]);
  var theme = useTheme();
  return jsx("nav", _assign({}, rest, {
    css: [FONT_STYLE.subTitle2, /*#__PURE__*/css(templateObject_1$22 || (templateObject_1$22 = __makeTemplateObject(["\n          overflow-x: auto;\n          white-space: nowrap;\n        " + ( true ? "" : 0)], ["\n          overflow-x: auto;\n          white-space: nowrap;\n        " + ( true ? "" : 0)])))]
  }, {
    children: crumbs.map(function (_a, index) {
      var text = _a.text,
        rest = __rest(_a, ["text"]);
      return jsxs(Fragment, {
        children: [jsx(Crumb, _assign({}, rest, {
          text: text,
          isActive: index === activeIndex,
          onClick: function onClick() {
            return onChangeIndex(index);
          }
        })), index + 1 < crumbs.length && jsx(Icon, {
          size: 18,
          name: "chevron_right",
          css: /*#__PURE__*/css(templateObject_2$1A || (templateObject_2$1A = __makeTemplateObject(["\n                vertical-align: top;\n                margin: 0 ", ";\n                color: ", ";\n              " + ( true ? "" : 0)], ["\n                vertical-align: top;\n                margin: 0 ", ";\n                color: ", ";\n              " + ( true ? "" : 0)])), pxToRem(4), theme.content.base2)
        })]
      }, text);
    })
  }));
}
var templateObject_1$22, templateObject_2$1A;

function getWithIconOptions(size, iconSize) {
  return {
    gap: {
      32: 4,
      40: 6,
      44: 6,
      50: 6
    }[size],
    iconSize: iconSize !== null && iconSize !== void 0 ? iconSize : 18
  };
}
function cssBaseButton(size, full) {
  return /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)(templateObject_1$21 || (templateObject_1$21 = (0,common._)(["\n    ", "\n    ", "\n    display: inline-flex;\n    justify-content: center;\n    align-items: center;\n    width: ", ";\n    height: ", ";\n    border-radius: ", ";\n    padding: 0 ", ";\n    font-weight: ", ";\n    box-sizing: border-box;\n    text-align: center;\n  " + ( true ? "" : 0)], ["\n    ", "\n    ", "\n    display: inline-flex;\n    justify-content: center;\n    align-items: center;\n    width: ", ";\n    height: ", ";\n    border-radius: ", ";\n    padding: 0 ", ";\n    font-weight: ", ";\n    box-sizing: border-box;\n    text-align: center;\n  " + ( true ? "" : 0)])), foundation.R, {
    32: foundation.F.body2,
    40: foundation.F.subTitle2,
    44: foundation.F.subTitle2,
    50: foundation.F.subTitle1
  }[size], full ? '100%' : 'auto', (0,foundation.p)(size), (0,foundation.p)(4), (0,foundation.p)(size === 32 ? 8 : 16), size === 50 ? 700 : 400);
}
function FileInputLabel(_a) {
  var id = _a.id,
    _onClick = _a.onClick,
    forwardedRef = _a.forwardedRef,
    className = _a.className,
    size = _a.size,
    full = _a.full,
    disabled = _a.disabled,
    children = _a.children,
    rest = (0,common.e)(_a, ["id", "onClick", "forwardedRef", "className", "size", "full", "disabled", "children"]);
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("label", (0,common.a)({
    className: className,
    htmlFor: id,
    css: [cssBaseButton(size, full), /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)(templateObject_2$1z || (templateObject_2$1z = (0,common._)(["\n          cursor: pointer;\n          position: relative;\n        " + ( true ? "" : 0)], ["\n          cursor: pointer;\n          position: relative;\n        " + ( true ? "" : 0)]))), full && /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)(templateObject_3$1k || (templateObject_3$1k = (0,common._)(["text-align: center;" + ( true ? "" : 0)], ["text-align: center;" + ( true ? "" : 0)])))]
  }, {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", (0,common.a)({
      css: /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)(templateObject_4$14 || (templateObject_4$14 = (0,common._)(["vertical-align: middle;" + ( true ? "" : 0)], ["vertical-align: middle;" + ( true ? "" : 0)])))
    }, {
      children: children
    })), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("input", (0,common.a)({}, rest, {
      id: id,
      ref: forwardedRef,
      type: "file",
      css: /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)(templateObject_5$U || (templateObject_5$U = (0,common._)(["\n          position: absolute;\n          top: 0;\n          left: 0;\n          width: 0;\n          height: 0;\n          opacity: 0;\n        " + ( true ? "" : 0)], ["\n          position: absolute;\n          top: 0;\n          left: 0;\n          width: 0;\n          height: 0;\n          opacity: 0;\n        " + ( true ? "" : 0)]))),
      onClick: function onClick(e) {
        if (disabled) {
          e.preventDefault();
        }
        if (_onClick) {
          _onClick(e);
        }
      }
    }))]
  }));
}
var templateObject_1$21, templateObject_2$1z, templateObject_3$1k, templateObject_4$14, templateObject_5$U;

function cssDisabled$1(theme, variant) {
  switch (variant) {
    case 'dim':
      return /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)(templateObject_1$20 || (templateObject_1$20 = (0,common._)(["\n        color: ", ";\n        background-color: ", ";\n        pointer-events: none;\n      " + ( true ? "" : 0)], ["\n        color: ", ";\n        background-color: ", ";\n        pointer-events: none;\n      " + ( true ? "" : 0)])), theme.content.base2, theme.dim.disabled);
    case 'primary1':
    case 'primary2':
    case 'primary3':
    case 'base1':
      return /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)(templateObject_2$1y || (templateObject_2$1y = (0,common._)(["\n        color: ", ";\n        background-color: ", ";\n        pointer-events: none;\n      " + ( true ? "" : 0)], ["\n        color: ", ";\n        background-color: ", ";\n        pointer-events: none;\n      " + ( true ? "" : 0)])), theme.content.base3, theme.content.base4);
  }
}
function cssVariant$7(theme, variant) {
  switch (variant) {
    case 'primary1':
    case 'primary2':
    case 'primary3':
      return /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)(templateObject_4$13 || (templateObject_4$13 = (0,common._)(["\n        color: ", ";\n        background-color: ", ";\n        ", "\n      " + ( true ? "" : 0)], ["\n        color: ", ";\n        background-color: ", ";\n        ", "\n      " + ( true ? "" : 0)])), theme.content.white, theme.content[variant].basic, (0,foundation.H)(templateObject_3$1j || (templateObject_3$1j = (0,common._)(["\n          background-color: ", ";\n        "], ["\n          background-color: ", ";\n        "])), theme.interactive[variant].basic));
    case 'base1':
      return /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)(templateObject_6$K || (templateObject_6$K = (0,common._)(["\n        color: ", ";\n        background-color: ", ";\n        ", "\n      " + ( true ? "" : 0)], ["\n        color: ", ";\n        background-color: ", ";\n        ", "\n      " + ( true ? "" : 0)])), theme.content.base6, theme.content.base1, (0,foundation.H)(templateObject_5$T || (templateObject_5$T = (0,common._)(["\n          background-color: ", ";\n        "], ["\n          background-color: ", ";\n        "])), theme.interactive.base1));
    case 'dim':
      return /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)(templateObject_8$r || (templateObject_8$r = (0,common._)(["\n        color: ", ";\n        background-color: ", ";\n        ", "\n      " + ( true ? "" : 0)], ["\n        color: ", ";\n        background-color: ", ";\n        ", "\n      " + ( true ? "" : 0)])), theme.content.white, theme.dim.thick, (0,foundation.H)(templateObject_7$z || (templateObject_7$z = (0,common._)(["\n          background-color: ", ";\n        "], ["\n          background-color: ", ";\n        "])), theme.interactive.dim.thick));
  }
}
/**
 * @deprecated ODS의 BoxButton 컴포넌트를 사용해 주세요.
 */
function Button$2(_a) {
  var forwardedRef = _a.forwardedRef,
    full = _a.full,
    size = _a.size,
    variant = _a.variant,
    disabled = _a.disabled,
    children = _a.children,
    rest = (0,common.e)(_a, ["forwardedRef", "full", "size", "variant", "disabled", "children"]);
  var theme = (0,emotion_element_5486c51c_browser_esm.u)();
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("button", (0,common.a)({}, rest, {
    ref: forwardedRef,
    disabled: disabled,
    css: [cssBaseButton(size, full), (disabled ? cssDisabled$1 : cssVariant$7)(theme, variant)]
  }, {
    children: children
  }));
}
function AnchorButton(_a) {
  var forwardedRef = _a.forwardedRef,
    full = _a.full,
    size = _a.size,
    variant = _a.variant,
    children = _a.children,
    disabled = _a.disabled,
    rest = (0,common.e)(_a, ["forwardedRef", "full", "size", "variant", "children", "disabled"]);
  var theme = (0,emotion_element_5486c51c_browser_esm.u)();
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("a", (0,common.a)({}, rest, {
    ref: forwardedRef,
    css: [cssBaseButton(size, full), (disabled ? cssDisabled$1 : cssVariant$7)(theme, variant)]
  }, {
    children: children
  }));
}
function FileButton(_a) {
  var full = _a.full,
    size = _a.size,
    variant = _a.variant,
    disabled = _a.disabled,
    rest = (0,common.e)(_a, ["full", "size", "variant", "disabled"]);
  var theme = (0,emotion_element_5486c51c_browser_esm.u)();
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FileInputLabel, (0,common.a)({}, rest, {
    size: size,
    full: full,
    disabled: disabled,
    css: (disabled ? cssDisabled$1 : cssVariant$7)(theme, variant)
  }));
}
var templateObject_1$20, templateObject_2$1y, templateObject_3$1j, templateObject_4$13, templateObject_5$T, templateObject_6$K, templateObject_7$z, templateObject_8$r;

function MiddleIcon(props) {
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Icon, (0,common.a)({}, props, {
    css: /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)(templateObject_1$1$ || (templateObject_1$1$ = (0,common._)(["vertical-align: middle;" + ( true ? "" : 0)], ["vertical-align: middle;" + ( true ? "" : 0)])))
  }));
}
function withIcon(Component, getOptions) {
  return function (_a) {
    var text = _a.text,
      icon = _a.icon,
      isTrailing = _a.isTrailing,
      rest = (0,common.e)(_a, ["text", "icon", "isTrailing"]);
    var _b = getOptions(rest),
      gap = _b.gap,
      iconSize = _b.iconSize;
    var middleIcon = (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MiddleIcon, {
      name: icon,
      size: iconSize
    });
    return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Component, (0,common.a)({}, rest, {
      children: [!isTrailing && middleIcon, (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", (0,common.a)({
        css: /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)(templateObject_2$1x || (templateObject_2$1x = (0,common._)(["\n            vertical-align: middle;\n            margin-", ": ", ";\n          " + ( true ? "" : 0)], ["\n            vertical-align: middle;\n            margin-", ": ", ";\n          " + ( true ? "" : 0)])), isTrailing ? 'right' : 'left', (0,foundation.p)(gap))
      }, {
        children: text
      })), isTrailing && middleIcon]
    }));
  };
}
var templateObject_1$1$, templateObject_2$1x;

/**
 * @deprecated ODS의 BoxButton 컴포넌트를 사용해 주세요.
 */
var ButtonWithIcon = withIcon(Button$2, function (_a) {
  var size = _a.size,
    iconSize = _a.iconSize;
  return getWithIconOptions(size, iconSize);
});
/**
 * @deprecated ODS의 BoxButton 컴포넌트를 사용해 주세요.
 */
var AnchorButtonWithIcon = withIcon(AnchorButton, function (_a) {
  var size = _a.size,
    iconSize = _a.iconSize;
  return getWithIconOptions(size, iconSize);
});
/**
 * @deprecated ODS의 BoxButton 컴포넌트를 사용해 주세요.
 */
var FileButtonWithIcon = withIcon(FileButton, function (_a) {
  var size = _a.size,
    iconSize = _a.iconSize;
  return getWithIconOptions(size, iconSize);
});

function cssVariant$6(theme, variant, filled) {
  switch (variant) {
    case 'primary1':
    case 'primary2':
    case 'primary3':
      return /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)(templateObject_3$1i || (templateObject_3$1i = (0,common._)(["\n        color: ", ";\n        border: ", " solid ", ";\n        ", "\n        ", "\n      " + ( true ? "" : 0)], ["\n        color: ", ";\n        border: ", " solid ", ";\n        ", "\n        ", "\n      " + ( true ? "" : 0)])), theme.content[variant].basic, (0,foundation.p)(1), theme.content[variant].basic, filled && /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)(templateObject_1$1_ || (templateObject_1$1_ = (0,common._)(["background-color: ", ";" + ( true ? "" : 0)], ["background-color: ", ";" + ( true ? "" : 0)])), theme.content.base6), (0,foundation.H)(templateObject_2$1w || (templateObject_2$1w = (0,common._)(["\n          background-color: ", ";\n        "], ["\n          background-color: ", ";\n        "])), theme.interactive[variant].transparent));
    case 'base1':
      return /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)(templateObject_6$J || (templateObject_6$J = (0,common._)(["\n        color: ", ";\n        border: ", " solid ", ";\n        ", "\n        ", "\n      " + ( true ? "" : 0)], ["\n        color: ", ";\n        border: ", " solid ", ";\n        ", "\n        ", "\n      " + ( true ? "" : 0)])), theme.content.base1, (0,foundation.p)(1), theme.border, filled && /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)(templateObject_4$12 || (templateObject_4$12 = (0,common._)(["background-color: ", ";" + ( true ? "" : 0)], ["background-color: ", ";" + ( true ? "" : 0)])), theme.content.base6), (0,foundation.H)(templateObject_5$S || (templateObject_5$S = (0,common._)(["\n          background-color: ", ";\n        "], ["\n          background-color: ", ";\n        "])), theme.interactive.transparent));
    case 'onDark':
      return /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)(templateObject_9$j || (templateObject_9$j = (0,common._)(["\n        color: ", ";\n        border: ", " solid ", ";\n        ", "\n        ", "\n      " + ( true ? "" : 0)], ["\n        color: ", ";\n        border: ", " solid ", ";\n        ", "\n        ", "\n      " + ( true ? "" : 0)])), theme.content.white, (0,foundation.p)(1), theme.content.white, filled && /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)(templateObject_7$y || (templateObject_7$y = (0,common._)(["background-color: ", ";" + ( true ? "" : 0)], ["background-color: ", ";" + ( true ? "" : 0)])), theme.dim.thin), (0,foundation.H)(templateObject_8$q || (templateObject_8$q = (0,common._)(["\n          background-color: ", ";\n        "], ["\n          background-color: ", ";\n        "])), theme.interactive.onDark));
  }
}
function cssDisabled(theme) {
  return /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)(templateObject_10$g || (templateObject_10$g = (0,common._)(["\n    color: ", ";\n    border: ", " solid ", ";\n    background-color: ", ";\n  " + ( true ? "" : 0)], ["\n    color: ", ";\n    border: ", " solid ", ";\n    background-color: ", ";\n  " + ( true ? "" : 0)])), theme.content.base3, (0,foundation.p)(1), theme.content.base4, theme.content.base5);
}
/**
 * @deprecated ODS의 BoxButton 컴포넌트를 사용해 주세요.
 */
function OutlineButton(_a) {
  var forwardedRef = _a.forwardedRef,
    full = _a.full,
    size = _a.size,
    variant = _a.variant,
    disabled = _a.disabled,
    children = _a.children,
    _b = _a.filled,
    filled = _b === void 0 ? false : _b,
    rest = (0,common.e)(_a, ["forwardedRef", "full", "size", "variant", "disabled", "children", "filled"]);
  var theme = (0,emotion_element_5486c51c_browser_esm.u)();
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("button", (0,common.a)({}, rest, {
    ref: forwardedRef,
    disabled: disabled,
    css: [cssBaseButton(size, full), disabled ? cssDisabled(theme) : cssVariant$6(theme, variant, filled)]
  }, {
    children: children
  }));
}
/**
 * @deprecated ODS의 BoxButton 컴포넌트를 사용해 주세요.
 */
function OutlineAnchorButton(_a) {
  var forwardedRef = _a.forwardedRef,
    full = _a.full,
    size = _a.size,
    variant = _a.variant,
    children = _a.children,
    disabled = _a.disabled,
    _b = _a.filled,
    filled = _b === void 0 ? false : _b,
    rest = (0,common.e)(_a, ["forwardedRef", "full", "size", "variant", "children", "disabled", "filled"]);
  var theme = (0,emotion_element_5486c51c_browser_esm.u)();
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("a", (0,common.a)({}, rest, {
    ref: forwardedRef,
    css: [cssBaseButton(size, full), disabled ? cssDisabled(theme) : cssVariant$6(theme, variant, filled)]
  }, {
    children: children
  }));
}
/**
 * @deprecated ODS의 BoxButton 컴포넌트를 사용해 주세요.
 */
function OutlineFileButton(_a) {
  var full = _a.full,
    size = _a.size,
    variant = _a.variant,
    disabled = _a.disabled,
    _b = _a.filled,
    filled = _b === void 0 ? false : _b,
    rest = (0,common.e)(_a, ["full", "size", "variant", "disabled", "filled"]);
  var theme = (0,emotion_element_5486c51c_browser_esm.u)();
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FileInputLabel, (0,common.a)({}, rest, {
    size: size,
    full: full,
    disabled: disabled,
    css: disabled ? cssDisabled(theme) : cssVariant$6(theme, variant, filled)
  }));
}
var templateObject_1$1_, templateObject_2$1w, templateObject_3$1i, templateObject_4$12, templateObject_5$S, templateObject_6$J, templateObject_7$y, templateObject_8$q, templateObject_9$j, templateObject_10$g;

/**
 * @deprecated ODS의 BoxButton 컴포넌트를 사용해 주세요.
 */
var OutlineButtonWithIcon = withIcon(OutlineButton, function (_a) {
  var size = _a.size,
    iconSize = _a.iconSize;
  return getWithIconOptions(size, iconSize);
});
/**
 * @deprecated ODS의 BoxButton 컴포넌트를 사용해 주세요.
 */
var OutlineAnchorButtonWithIcon = withIcon(OutlineAnchorButton, function (_a) {
  var size = _a.size,
    iconSize = _a.iconSize;
  return getWithIconOptions(size, iconSize);
});
/**
 * @deprecated ODS의 BoxButton 컴포넌트를 사용해 주세요.
 */
var OutlineFileButtonWithIcon = withIcon(OutlineFileButton, function (_a) {
  var size = _a.size,
    iconSize = _a.iconSize;
  return getWithIconOptions(size, iconSize);
});

function cssVariant$5(theme, checked, variant) {
  if (checked) {
    switch (variant) {
      case 'primary1':
      case 'primary3':
        return /*#__PURE__*/css(templateObject_1$1Z || (templateObject_1$1Z = __makeTemplateObject(["\n          color: ", ";\n          border-color: ", ";\n          &:hover,\n          &:active {\n            background-color: ", ";\n          }\n        " + ( true ? "" : 0)], ["\n          color: ", ";\n          border-color: ", ";\n          &:hover,\n          &:active {\n            background-color: ", ";\n          }\n        " + ( true ? "" : 0)])), theme.content[variant].basic, theme.content[variant].basic, theme.interactive[variant].transparent);
      case 'primary2':
      case 'primary4':
        return /*#__PURE__*/css(templateObject_2$1v || (templateObject_2$1v = __makeTemplateObject(["\n          color: ", ";\n          border-color: ", ";\n          &:hover,\n          &:active {\n            background-color: ", ";\n          }\n        " + ( true ? "" : 0)], ["\n          color: ", ";\n          border-color: ", ";\n          &:hover,\n          &:active {\n            background-color: ", ";\n          }\n        " + ( true ? "" : 0)])), theme.content[variant].thick, theme.content[variant].thick, theme.interactive[variant].transparent);
    }
  }
  return /*#__PURE__*/css(templateObject_3$1h || (templateObject_3$1h = __makeTemplateObject(["\n    color: ", ";\n    border-color: ", ";\n    &:hover,\n    &:active {\n      background-color: ", ";\n    }\n  " + ( true ? "" : 0)], ["\n    color: ", ";\n    border-color: ", ";\n    &:hover,\n    &:active {\n      background-color: ", ";\n    }\n  " + ( true ? "" : 0)])), theme.content.base2, theme.border, theme.interactive.transparent);
}
function SelectButton(_a) {
  var forwardedRef = _a.forwardedRef,
    error = _a.error,
    disabled = _a.disabled,
    grid = _a.grid,
    size = _a.size,
    variant = _a.variant,
    options = _a.options,
    onChange = _a.onChange,
    rest = __rest(_a, ["forwardedRef", "error", "disabled", "grid", "size", "variant", "options", "onChange"]);
  var theme = useTheme();
  var getMsGridColums = function getMsGridColums(grid) {
    if (grid === 1) return '1fr';
    return new Array(grid).fill('1fr').join(" ".concat(pxToRem(6), " "));
  };
  var getMsGridRows = function getMsGridRows(grid, buttonCount) {
    return new Array(Math.ceil(buttonCount / grid)).fill('1fr').join(" ".concat(pxToRem(6), " "));
  };
  return jsx("div", _assign({}, rest, {
    css: /*#__PURE__*/css(templateObject_4$11 || (templateObject_4$11 = __makeTemplateObject(["\n        overflow: hidden;\n      " + ( true ? "" : 0)], ["\n        overflow: hidden;\n      " + ( true ? "" : 0)])))
  }, {
    children: jsx("div", _assign({
      css: /*#__PURE__*/css(templateObject_5$R || (templateObject_5$R = __makeTemplateObject(["\n          display: grid;\n          grid-template-columns: repeat(", ", 1fr);\n          grid-gap: ", ";\n          display: -ms-grid;\n          -ms-grid-columns: ", ";\n          -ms-grid-columns: ", ";\n        " + ( true ? "" : 0)], ["\n          display: grid;\n          grid-template-columns: repeat(", ", 1fr);\n          grid-gap: ", ";\n          display: -ms-grid;\n          -ms-grid-columns: ", ";\n          -ms-grid-columns: ", ";\n        " + ( true ? "" : 0)])), grid, pxToRem(6), getMsGridColums(grid), getMsGridRows(grid, options.length))
    }, {
      children: options.map(function (option) {
        return _assign(_assign({}, option), {
          disabled: option.disabled || disabled
        });
      }).map(function (_a, index) {
        var text = _a.text,
          checked = _a.checked,
          disabled = _a.disabled;
        return jsx("div", _assign({
          css: /*#__PURE__*/css(templateObject_6$I || (templateObject_6$I = __makeTemplateObject(["\n                display: inline-block;\n                vertical-align: top;\n                -ms-grid-column: ", ";\n                -ms-grid-row: ", ";\n              " + ( true ? "" : 0)], ["\n                display: inline-block;\n                vertical-align: top;\n                -ms-grid-column: ", ";\n                -ms-grid-row: ", ";\n              " + ( true ? "" : 0)])), Math.floor(index % grid) * 2 + 1, Math.floor(index / grid) * 2 + 1)
        }, {
          children: jsx("button", _assign({
            type: "button",
            disabled: disabled,
            ref: index === 0 ? forwardedRef : null,
            css: [cssBaseButton(size), disabled ? /*#__PURE__*/css(templateObject_7$x || (templateObject_7$x = __makeTemplateObject(["\n                      color: ", ";\n                      border-color: ", ";\n                      background-color: ", ";\n                    " + ( true ? "" : 0)], ["\n                      color: ", ";\n                      border-color: ", ";\n                      background-color: ", ";\n                    " + ( true ? "" : 0)])), theme.content.base3, theme.content.base4, theme.content.base5) : cssVariant$5(theme, checked, variant), /*#__PURE__*/css(templateObject_8$p || (templateObject_8$p = __makeTemplateObject(["\n                    width: 100%;\n                    border-width: ", ";\n                    border-style: solid;\n                    font-weight: ", ";\n                  " + ( true ? "" : 0)], ["\n                    width: 100%;\n                    border-width: ", ";\n                    border-style: solid;\n                    font-weight: ", ";\n                  " + ( true ? "" : 0)])), pxToRem(1), checked ? 700 : 400), error && /*#__PURE__*/css(templateObject_9$i || (templateObject_9$i = __makeTemplateObject(["border-color: ", ";" + ( true ? "" : 0)], ["border-color: ", ";" + ( true ? "" : 0)])), theme.content.primary2.basic)],
            onClick: function onClick() {
              return onChange(index, !checked);
            }
          }, {
            children: text
          }))
        }), text);
      })
    }))
  }));
}
var templateObject_1$1Z, templateObject_2$1v, templateObject_3$1h, templateObject_4$11, templateObject_5$R, templateObject_6$I, templateObject_7$x, templateObject_8$p, templateObject_9$i;

var _g$2, _defs$1;
function _extends$6() { _extends$6 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$6.apply(this, arguments); }
var SvgInactiveScrap24 = function SvgInactiveScrap24(props) {
  return /*#__PURE__*/react.createElement("svg", _extends$6({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _g$2 || (_g$2 = /*#__PURE__*/react.createElement("g", {
    fill: "#fff",
    clipPath: "url(#inactiveScrap24_svg__a)",
    filter: "url(#inactiveScrap24_svg__b)"
  }, /*#__PURE__*/react.createElement("path", {
    d: "M4.3 4.05V19.5l6.63-3.482a2.3 2.3 0 0 1 2.14 0l6.63 3.481V4.05zM4 2.75h16a1 1 0 0 1 1 1v17.073a.5.5 0 0 1-.732.442l-7.803-4.096a1 1 0 0 0-.93 0l-7.803 4.096A.5.5 0 0 1 3 20.824V3.75a1 1 0 0 1 1-1"
  }), /*#__PURE__*/react.createElement("path", {
    fillOpacity: 0.5,
    d: "M4.3 4.05V19.5l6.63-3.482a2.3 2.3 0 0 1 2.14 0l6.63 3.481V4.05z"
  }))), _defs$1 || (_defs$1 = /*#__PURE__*/react.createElement("defs", null, /*#__PURE__*/react.createElement("clipPath", {
    id: "inactiveScrap24_svg__a"
  }, /*#__PURE__*/react.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })), /*#__PURE__*/react.createElement("filter", {
    id: "inactiveScrap24_svg__b",
    width: 28,
    height: 28.573,
    x: -2,
    y: -0.25,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/react.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/react.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/react.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/react.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/react.createElement("feColorMatrix", {
    values: "0 0 0 0 0.247059 0 0 0 0 0.278431 0 0 0 0 0.301961 0 0 0 0.15 0"
  }), /*#__PURE__*/react.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_15409_67579"
  }), /*#__PURE__*/react.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_15409_67579",
    result: "shape"
  })))));
};
var InactiveScrapIcon24 = SvgInactiveScrap24;

var _g$1, _defs;
function _extends$5() { _extends$5 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$5.apply(this, arguments); }
var SvgInactiveScrap32 = function SvgInactiveScrap32(props) {
  return /*#__PURE__*/react.createElement("svg", _extends$5({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _g$1 || (_g$1 = /*#__PURE__*/react.createElement("g", {
    fill: "#fff",
    fillRule: "evenodd",
    clipPath: "url(#inactiveScrap32_svg__a)",
    clipRule: "evenodd",
    filter: "url(#inactiveScrap32_svg__b)"
  }, /*#__PURE__*/react.createElement("path", {
    d: "M5.3 5.3v21.55l9.536-5.007a2.3 2.3 0 0 1 2.138 0l9.535 5.006V5.3zM5 4a1 1 0 0 0-1 1v23.173a.5.5 0 0 0 .732.443l10.708-5.622a1 1 0 0 1 .93 0l10.707 5.622a.5.5 0 0 0 .732-.443V5a1 1 0 0 0-1-1z"
  }), /*#__PURE__*/react.createElement("path", {
    fillOpacity: 0.5,
    d: "M5.3 5.3v21.55l9.536-5.007a2.3 2.3 0 0 1 2.138 0l9.535 5.006V5.3z"
  }))), _defs || (_defs = /*#__PURE__*/react.createElement("defs", null, /*#__PURE__*/react.createElement("clipPath", {
    id: "inactiveScrap32_svg__a"
  }, /*#__PURE__*/react.createElement("path", {
    fill: "#fff",
    d: "M0 0h32v32H0z"
  })), /*#__PURE__*/react.createElement("filter", {
    id: "inactiveScrap32_svg__b",
    width: 33.81,
    height: 34.673,
    x: -1,
    y: 1,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/react.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/react.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/react.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/react.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/react.createElement("feColorMatrix", {
    values: "0 0 0 0 0.247059 0 0 0 0 0.278431 0 0 0 0 0.301961 0 0 0 0.15 0"
  }), /*#__PURE__*/react.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_15409_67578"
  }), /*#__PURE__*/react.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_15409_67578",
    result: "shape"
  })))));
};
var InactiveScrapIcon32 = SvgInactiveScrap32;

var _path$3;
function _extends$4() { _extends$4 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$4.apply(this, arguments); }
var SvgActiveScrap24 = function SvgActiveScrap24(props) {
  return /*#__PURE__*/react.createElement("svg", _extends$4({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path$3 || (_path$3 = /*#__PURE__*/react.createElement("path", {
    fill: "#35C5F0",
    fillRule: "evenodd",
    d: "M20 2.75H4a1 1 0 0 0-1 1v17.073a.5.5 0 0 0 .732.442l7.803-4.096a1 1 0 0 1 .93 0l7.803 4.096a.5.5 0 0 0 .732-.442V3.75a1 1 0 0 0-1-1",
    clipRule: "evenodd"
  })));
};
var ActiveScrapIcon24 = SvgActiveScrap24;

var _path$2;
function _extends$3() { _extends$3 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3.apply(this, arguments); }
var SvgActiveScrap32 = function SvgActiveScrap32(props) {
  return /*#__PURE__*/react.createElement("svg", _extends$3({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _path$2 || (_path$2 = /*#__PURE__*/react.createElement("path", {
    fill: "#35C5F0",
    fillRule: "evenodd",
    d: "M4 5a1 1 0 0 1 1-1h21.81a1 1 0 0 1 1 1v23.173a.5.5 0 0 1-.733.443L16.37 22.994a1 1 0 0 0-.93 0L4.732 28.616A.5.5 0 0 1 4 28.173z",
    clipRule: "evenodd"
  })));
};
var ActiveScrapIcon32 = SvgActiveScrap32;

var SCRAP = {
  inactive: {
    24: InactiveScrapIcon24,
    32: InactiveScrapIcon32
  },
  active: {
    24: ActiveScrapIcon24,
    32: ActiveScrapIcon32
  }
};
var ScrapButtonSet = function ScrapButtonSet(_a) {
  var size = _a.size,
    isActive = _a.isActive;
  var InactiveIcon = SCRAP['inactive'][size];
  var ActiveIcon = SCRAP['active'][size];
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ActiveIcon, {
      css: /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)(templateObject_1$1Y || (templateObject_1$1Y = (0,common._)([" opacity: ", "" + ( true ? "" : 0)], [" opacity: ", "" + ( true ? "" : 0)])), isActive ? 1 : 0)
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(InactiveIcon, {
      css: /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)(templateObject_2$1u || (templateObject_2$1u = (0,common._)([" opacity: ", "" + ( true ? "" : 0)], [" opacity: ", "" + ( true ? "" : 0)])), isActive ? 0 : 1)
    })]
  });
};
var ICONS_MAP = {
  scrap: ScrapButtonSet
};
var templateObject_1$1Y, templateObject_2$1u;

function ToggleButton(_a) {
  var name = _a.name,
    size = _a.size,
    active = _a.active,
    onActive = _a.onActive,
    onInactive = _a.onInactive,
    _b = _a.initialActive,
    initialActive = _b === void 0 ? false : _b,
    rest = (0,common.e)(_a, ["name", "size", "active", "onActive", "onInactive", "initialActive"]);
  var theme = (0,emotion_element_5486c51c_browser_esm.u)();
  var _c = (0,react.useState)(initialActive),
    isActive = _c[0],
    setActive = _c[1];
  (0,react.useEffect)(function () {
    if (active === undefined) return;
    setActive(active);
  }, [active]);
  var Icons = ICONS_MAP[name];
  var handleClick = (0,react.useCallback)(function () {
    var _a;
    (_a = isActive ? onInactive : onActive) === null || _a === void 0 ? void 0 : _a();
    if (active !== undefined) return;
    setActive(!isActive);
  }, [onActive, onInactive, active, isActive]);
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("button", (0,common.a)({
    type: "button",
    onClick: handleClick,
    "aria-label": "".concat(name, " \uD1A0\uAE00 \uBC84\uD2BC"),
    css: [foundation.R, /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)(templateObject_1$1X || (templateObject_1$1X = (0,common._)(["\n          display: flex;\n          justify-content: center;\n          align-items: center;\n          width: ", ";\n          height: ", ";\n          position: relative;\n        " + ( true ? "" : 0)], ["\n          display: flex;\n          justify-content: center;\n          align-items: center;\n          width: ", ";\n          height: ", ";\n          position: relative;\n        " + ( true ? "" : 0)])), (0,foundation.p)(size + 12), (0,foundation.p)(size + 12))]
  }, rest, {
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", (0,common.a)({
      css: [/*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)(templateObject_2$1t || (templateObject_2$1t = (0,common._)(["\n          display: inline-block;\n          font-size: ", ";\n          line-height: 1;\n          transform: translateZ(0);\n          & > svg {\n            position: absolute;\n            top: 50%;\n            left: 50%;\n            transform: translate(-50%, -50%);\n          }\n        " + ( true ? "" : 0)], ["\n          display: inline-block;\n          font-size: ", ";\n          line-height: 1;\n          transform: translateZ(0);\n          & > svg {\n            position: absolute;\n            top: 50%;\n            left: 50%;\n            transform: translate(-50%, -50%);\n          }\n        " + ( true ? "" : 0)])), (0,foundation.p)(size)), !isActive && name === 'scrap' && /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)(templateObject_3$1g || (templateObject_3$1g = (0,common._)(["\n          & > svg {\n            filter: drop-shadow(0 ", " ", " ", ");\n          }\n        " + ( true ? "" : 0)], ["\n          & > svg {\n            filter: drop-shadow(0 ", " ", " ", ");\n          }\n        " + ( true ? "" : 0)])), (0,foundation.p)(2), (0,foundation.p)(5), theme.shadow.thick)]
    }, {
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Icons, {
        size: size,
        isActive: isActive
      })
    }))
  }));
}
var templateObject_1$1X, templateObject_2$1t, templateObject_3$1g;

function getTextButtonWithIconOptions(size, iconSize) {
  return {
    gap: {
      30: 4,
      32: 2
    }[size],
    iconSize: iconSize !== null && iconSize !== void 0 ? iconSize : 18
  };
}
function cssSize$3(size) {
  switch (size) {
    case 30:
      return /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)(templateObject_1$1W || (templateObject_1$1W = (0,common._)(["\n        ", "\n        padding: 0 ", ";\n      " + ( true ? "" : 0)], ["\n        ", "\n        padding: 0 ", ";\n      " + ( true ? "" : 0)])), foundation.F.subTitle1, (0,foundation.p)(8));
    case 32:
      return /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)(templateObject_2$1s || (templateObject_2$1s = (0,common._)(["\n        ", "\n        padding: 0 ", ";\n      " + ( true ? "" : 0)], ["\n        ", "\n        padding: 0 ", ";\n      " + ( true ? "" : 0)])), foundation.F.subTitle2, (0,foundation.p)(6));
  }
}
function cssVariant$4(theme, variant) {
  switch (variant) {
    case 'primary1':
      return /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)(templateObject_3$1f || (templateObject_3$1f = (0,common._)(["\n        color: ", ";\n        font-weight: 700;\n\n        &:active {\n          background-color: ", ";\n        }\n\n        @media (hover: hover) and (pointer: fine) {\n          &:hover {\n            background-color: ", ";\n          }\n        }\n      " + ( true ? "" : 0)], ["\n        color: ", ";\n        font-weight: 700;\n\n        &:active {\n          background-color: ", ";\n        }\n\n        @media (hover: hover) and (pointer: fine) {\n          &:hover {\n            background-color: ", ";\n          }\n        }\n      " + ( true ? "" : 0)])), theme.content.primary1.basic, theme.interactive.transparent, theme.interactive.transparent);
    case 'base1':
      return /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)(templateObject_4$10 || (templateObject_4$10 = (0,common._)(["\n        color: ", ";\n        font-weight: 500;\n        &:active {\n          background-color: ", ";\n        }\n\n        @media (hover: hover) and (pointer: fine) {\n          &:hover {\n            background-color: ", ";\n          }\n        }\n      " + ( true ? "" : 0)], ["\n        color: ", ";\n        font-weight: 500;\n        &:active {\n          background-color: ", ";\n        }\n\n        @media (hover: hover) and (pointer: fine) {\n          &:hover {\n            background-color: ", ";\n          }\n        }\n      " + ( true ? "" : 0)])), theme.content.base1, theme.interactive.transparent, theme.interactive.transparent);
    case 'onDark':
      return /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)(templateObject_5$Q || (templateObject_5$Q = (0,common._)(["\n        color: ", ";\n        font-weight: 500;\n        &:active {\n          background-color: ", ";\n        }\n\n        @media (hover: hover) and (pointer: fine) {\n          &:hover {\n            background-color: ", ";\n          }\n        }\n      " + ( true ? "" : 0)], ["\n        color: ", ";\n        font-weight: 500;\n        &:active {\n          background-color: ", ";\n        }\n\n        @media (hover: hover) and (pointer: fine) {\n          &:hover {\n            background-color: ", ";\n          }\n        }\n      " + ( true ? "" : 0)])), theme.content.white, theme.interactive.onDark, theme.interactive.onDark);
  }
}
/**
 * @deprecated ODS의 TextButton 컴포넌트를 사용해 주세요.
 */
function TextButton(_a) {
  var forwardedRef = _a.forwardedRef,
    size = _a.size,
    variant = _a.variant,
    disabled = _a.disabled,
    children = _a.children,
    rest = (0,common.e)(_a, ["forwardedRef", "size", "variant", "disabled", "children"]);
  var theme = (0,emotion_element_5486c51c_browser_esm.u)();
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("button", (0,common.a)({
    type: "button"
  }, rest, {
    ref: forwardedRef,
    disabled: disabled,
    css: [/*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)(templateObject_6$H || (templateObject_6$H = (0,common._)(["\n          ", "\n          height: ", ";\n          border-radius: ", ";\n        " + ( true ? "" : 0)], ["\n          ", "\n          height: ", ";\n          border-radius: ", ";\n        " + ( true ? "" : 0)])), foundation.R, (0,foundation.p)(size), (0,foundation.p)(4)), cssSize$3(size), disabled ? /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)(templateObject_7$w || (templateObject_7$w = (0,common._)(["\n              color: ", ";\n              background-color: transparent;\n            " + ( true ? "" : 0)], ["\n              color: ", ";\n              background-color: transparent;\n            " + ( true ? "" : 0)])), theme.content.base3) : cssVariant$4(theme, variant)]
  }, {
    children: children
  }));
}
var templateObject_1$1W, templateObject_2$1s, templateObject_3$1f, templateObject_4$10, templateObject_5$Q, templateObject_6$H, templateObject_7$w;

/**
 * @deprecated ODS의 TextButton 컴포넌트를 사용해 주세요.
 */
var TextButtonWithIcon = withIcon(TextButton, function (_a) {
  var size = _a.size,
    iconSize = _a.iconSize;
  return getTextButtonWithIconOptions(size, iconSize);
});

function cssBaseFab(theme, size) {
  return /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)(templateObject_1$1V || (templateObject_1$1V = (0,common._)(["\n    ", "\n    ", "\n    height: ", ";\n    line-height: 0;\n  " + ( true ? "" : 0)], ["\n    ", "\n    ", "\n    height: ", ";\n    line-height: 0;\n  " + ( true ? "" : 0)])), foundation.R, foundation.S.depth30(theme), (0,foundation.p)(size));
}
function cssFabVariant(theme, variant) {
  switch (variant) {
    case 'white':
      return /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)(templateObject_2$1r || (templateObject_2$1r = (0,common._)(["\n        color: ", ";\n        background-color: ", ";\n        &:hover,\n        &:active {\n          background-color: ", ";\n        }\n      " + ( true ? "" : 0)], ["\n        color: ", ";\n        background-color: ", ";\n        &:hover,\n        &:active {\n          background-color: ", ";\n        }\n      " + ( true ? "" : 0)])), theme.content.base1, theme.background.elevated, theme.interactive.transparent);
    case 'primary1':
    case 'primary3':
    case 'primary4':
      return /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)(templateObject_3$1e || (templateObject_3$1e = (0,common._)(["\n        color: ", ";\n        background-color: ", ";\n        &:hover,\n        &:active {\n          background-color: ", ";\n        }\n      " + ( true ? "" : 0)], ["\n        color: ", ";\n        background-color: ", ";\n        &:hover,\n        &:active {\n          background-color: ", ";\n        }\n      " + ( true ? "" : 0)])), theme.content.white, theme.content[variant].basic, theme.interactive[variant].basic);
  }
}
var templateObject_1$1V, templateObject_2$1r, templateObject_3$1e;

function Fab(_a) {
  var forwardedRef = _a.forwardedRef,
    size = _a.size,
    variant = _a.variant,
    children = _a.children,
    rest = __rest(_a, ["forwardedRef", "size", "variant", "children"]);
  var theme = useTheme();
  return jsx("button", _assign({}, rest, {
    type: "button",
    ref: forwardedRef,
    css: [cssBaseFab(theme, size), cssFabVariant(theme, variant), /*#__PURE__*/css(templateObject_1$1U || (templateObject_1$1U = __makeTemplateObject(["\n          border-radius: 50%;\n          width: ", ";\n        " + ( true ? "" : 0)], ["\n          border-radius: 50%;\n          width: ", ";\n        " + ( true ? "" : 0)])), pxToRem(size))]
  }, {
    children: children
  }));
}
var templateObject_1$1U;

function IconFab(_a) {
  var icon = _a.icon,
    rest = __rest(_a, ["icon"]);
  return jsx(Fab, _assign({}, rest, {
    children: jsx(Icon, {
      size: 24,
      name: icon
    })
  }));
}

function ExtendedFab(_a) {
  var forwardedRef = _a.forwardedRef,
    size = _a.size,
    variant = _a.variant,
    children = _a.children,
    rest = (0,common.e)(_a, ["forwardedRef", "size", "variant", "children"]);
  var theme = (0,emotion_element_5486c51c_browser_esm.u)();
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("button", (0,common.a)({}, rest, {
    type: "button",
    ref: forwardedRef,
    css: [cssBaseFab(theme, size), cssFabVariant(theme, variant), /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)(templateObject_1$1T || (templateObject_1$1T = (0,common._)(["\n          ", "\n          font-weight: 700;\n          padding: 0 ", ";\n          border-radius: ", ";\n        " + ( true ? "" : 0)], ["\n          ", "\n          font-weight: 700;\n          padding: 0 ", ";\n          border-radius: ", ";\n        " + ( true ? "" : 0)])), foundation.F.subTitle1, (0,foundation.p)(16), (0,foundation.p)(size / 2))]
  }, {
    children: children
  }));
}
var templateObject_1$1T;

var ExtendedFabWithIcon = withIcon(ExtendedFab, function () {
  return {
    gap: 8,
    iconSize: 24
  };
});

function HiddenInput(_a) {
  var forwardedRef = _a.forwardedRef,
    onCheck = _a.onCheck,
    _onChange = _a.onChange,
    rest = (0,common.e)(_a, ["forwardedRef", "onCheck", "onChange"]);
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("input", (0,common.a)({}, rest, {
    ref: forwardedRef,
    type: "checkbox",
    onChange: function onChange(e) {
      return (0,common.o)(e, {
        onChange: _onChange,
        onCheck: onCheck
      });
    },
    css: /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)(templateObject_1$1S || (templateObject_1$1S = (0,common._)(["\n        position: absolute;\n        top: 0;\n        left: 0;\n        opacity: 0;\n        width: 100%;\n        height: 100%;\n        margin: 0;\n        cursor: pointer;\n      " + ( true ? "" : 0)], ["\n        position: absolute;\n        top: 0;\n        left: 0;\n        opacity: 0;\n        width: 100%;\n        height: 100%;\n        margin: 0;\n        cursor: pointer;\n      " + ( true ? "" : 0)])))
  }));
}
var templateObject_1$1S;

var TOGGLE_SIZE = {
  sm: function sm() {
    return {
      toggle: {
        width: 42,
        height: 24
      },
      knob: {
        width: 20,
        height: 20
      }
    };
  },
  md: function md() {
    return {
      toggle: {
        width: 50,
        height: 30
      },
      knob: {
        width: 26,
        height: 26
      }
    };
  }
};
function Toggle(_a) {
  var className = _a.className,
    checked = _a.checked,
    _b = _a.size,
    size = _b === void 0 ? 'md' : _b,
    rest = (0,common.e)(_a, ["className", "checked", "size"]);
  var theme = (0,emotion_element_5486c51c_browser_esm.u)();
  var _c = TOGGLE_SIZE[size](),
    toggle = _c.toggle,
    knob = _c.knob;
  var x = checked ? toggle.width - knob.width - 4 : 0;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", (0,common.a)({
    className: className,
    css: /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)(templateObject_1$1R || (templateObject_1$1R = (0,common._)(["\n        position: relative;\n        display: inline-block;\n        width: ", "px;\n        height: ", "px;\n        border-radius: 25px;\n        background-color: ", ";\n            &::before {\n              ", "\n              content: \"\";\n              position: absolute;\n              top: 2px;\n              left: 2px;\n              width: ", "px;\n              height: ", "px;\n              border-radius: 50%;\n              background-color: ", ";\n              transform: translateX(", "px);\n              transition: transform 0.2s ease;\n            }\n      " + ( true ? "" : 0)], ["\n        position: relative;\n        display: inline-block;\n        width: ", "px;\n        height: ", "px;\n        border-radius: 25px;\n        background-color: ", ";\n            &::before {\n              ", "\n              content: \"\";\n              position: absolute;\n              top: 2px;\n              left: 2px;\n              width: ", "px;\n              height: ", "px;\n              border-radius: 50%;\n              background-color: ", ";\n              transform: translateX(", "px);\n              transition: transform 0.2s ease;\n            }\n      " + ( true ? "" : 0)])), toggle.width, toggle.height, checked ? theme.content.primary1.basic : theme.content.base3, foundation.S.depth20(theme), knob.width, knob.height, theme.content.white, checked ? x : 0)
  }, {
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(HiddenInput, (0,common.a)({}, rest, {
      checked: checked
    }))
  }));
}
var templateObject_1$1R;

function Checkbox$1(_a) {
  var className = _a.className,
    _b = _a.icon,
    icon = _b === void 0 ? 'check' : _b,
    disabled = _a.disabled,
    checked = _a.checked,
    rest = (0,common.e)(_a, ["className", "icon", "disabled", "checked"]);
  var theme = (0,emotion_element_5486c51c_browser_esm.u)();
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", (0,common.a)({
    className: className,
    css: [/*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)(templateObject_1$1Q || (templateObject_1$1Q = (0,common._)(["\n          display: inline-block;\n          position: relative;\n          width: ", ";\n          height: ", ";\n          border: ", " solid;\n          border-radius: ", ";\n          box-sizing: border-box;\n        " + ( true ? "" : 0)], ["\n          display: inline-block;\n          position: relative;\n          width: ", ";\n          height: ", ";\n          border: ", " solid;\n          border-radius: ", ";\n          box-sizing: border-box;\n        " + ( true ? "" : 0)])), (0,foundation.p)(20), (0,foundation.p)(20), (0,foundation.p)(1), (0,foundation.p)(4)), disabled ? /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)(templateObject_2$1q || (templateObject_2$1q = (0,common._)(["\n              border-color: ", ";\n              background-color: ", ";\n            " + ( true ? "" : 0)], ["\n              border-color: ", ";\n              background-color: ", ";\n            " + ( true ? "" : 0)])), theme.content.base3, theme.content.base3) : /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)(templateObject_4$$ || (templateObject_4$$ = (0,common._)(["\n              border-color: ", ";\n              background-color: ", ";\n              transition: border-color 0.1s, background-color 0.1s;\n              ", "\n            " + ( true ? "" : 0)], ["\n              border-color: ", ";\n              background-color: ", ";\n              transition: border-color 0.1s, background-color 0.1s;\n              ", "\n            " + ( true ? "" : 0)])), checked ? theme.content.primary1.basic : theme.border, checked ? theme.content.primary1.basic : theme.content.white, (0,foundation.H)(templateObject_3$1d || (templateObject_3$1d = (0,common._)(["\n                background-color: ", ";\n                border-color: ", ";\n              "], ["\n                background-color: ", ";\n                border-color: ", ";\n              "])), checked ? theme.interactive.primary1.basic : theme.interactive.transparent, checked ? theme.interactive.primary1.basic : theme.border))]
  }, {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", (0,common.a)({
      css: /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)(templateObject_5$P || (templateObject_5$P = (0,common._)(["\n          position: absolute;\n          overflow: hidden;\n          top: ", ";\n          left: ", ";\n          width: ", ";\n          height: ", ";\n          transition: width 0.2s 0.1s;\n        " + ( true ? "" : 0)], ["\n          position: absolute;\n          overflow: hidden;\n          top: ", ";\n          left: ", ";\n          width: ", ";\n          height: ", ";\n          transition: width 0.2s 0.1s;\n        " + ( true ? "" : 0)])), (0,foundation.p)(3.6), (0,foundation.p)(3), (0,foundation.p)(checked ? 12 : 0), (0,foundation.p)(12))
    }, {
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Icon, {
        size: 12,
        name: icon,
        css: /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)(templateObject_6$G || (templateObject_6$G = (0,common._)(["\n            vertical-align: top;\n            color: ", ";\n          " + ( true ? "" : 0)], ["\n            vertical-align: top;\n            color: ", ";\n          " + ( true ? "" : 0)])), theme.content.base6)
      })
    })), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(HiddenInput, (0,common.a)({}, rest, {
      checked: checked,
      disabled: disabled
    }))]
  }));
}
var templateObject_1$1Q, templateObject_2$1q, templateObject_3$1d, templateObject_4$$, templateObject_5$P, templateObject_6$G;

function CheckboxWithText(_a) {
  var id = _a.id,
    className = _a.className,
    children = _a.children,
    rest = (0,common.e)(_a, ["id", "className", "children"]);
  var theme = (0,emotion_element_5486c51c_browser_esm.u)();
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("label", (0,common.a)({
    css: /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)(templateObject_1$1P || (templateObject_1$1P = (0,common._)(["\n        display: inline-flex;\n        align-items: center;\n        cursor: pointer;\n      " + ( true ? "" : 0)], ["\n        display: inline-flex;\n        align-items: center;\n        cursor: pointer;\n      " + ( true ? "" : 0)]))),
    className: className,
    htmlFor: id
  }, {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Checkbox$1, (0,common.a)({}, rest, {
      id: id,
      css: /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)(templateObject_2$1p || (templateObject_2$1p = (0,common._)(["\n          flex-shrink: 0;\n        " + ( true ? "" : 0)], ["\n          flex-shrink: 0;\n        " + ( true ? "" : 0)])))
    })), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", (0,common.a)({
      css: /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)(templateObject_3$1c || (templateObject_3$1c = (0,common._)(["\n          flex: 1;\n          ", "\n          margin-left: ", ";\n          color: ", ";\n        " + ( true ? "" : 0)], ["\n          flex: 1;\n          ", "\n          margin-left: ", ";\n          color: ", ";\n        " + ( true ? "" : 0)])), foundation.F.subTitle1, (0,foundation.p)(6), theme.content.base1)
    }, {
      children: children
    }))]
  }));
}
var templateObject_1$1P, templateObject_2$1p, templateObject_3$1c;

function Radio(_a) {
  var forwardedRef = _a.forwardedRef,
    className = _a.className,
    disabled = _a.disabled,
    checked = _a.checked,
    rest = (0,common.e)(_a, ["forwardedRef", "className", "disabled", "checked"]);
  var theme = (0,emotion_element_5486c51c_browser_esm.u)();
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", (0,common.a)({
    className: className,
    css: [/*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)(templateObject_1$1O || (templateObject_1$1O = (0,common._)(["\n          display: inline-block;\n          position: relative;\n          width: ", ";\n          height: ", ";\n          border: ", " solid;\n          border-radius: 50%;\n          box-sizing: border-box;\n          &::before {\n            content: \"\";\n            position: absolute;\n            border-radius: 50%;\n            top: ", ";\n            left: ", ";\n            width: ", ";\n            height: ", ";\n            transform: scale(", ");\n            transition: transform 0.4s cubic-bezier(0.5, 2, 0.5, 0.5);\n            background-color: ", ";\n          }\n        " + ( true ? "" : 0)], ["\n          display: inline-block;\n          position: relative;\n          width: ", ";\n          height: ", ";\n          border: ", " solid;\n          border-radius: 50%;\n          box-sizing: border-box;\n          &::before {\n            content: \"\";\n            position: absolute;\n            border-radius: 50%;\n            top: ", ";\n            left: ", ";\n            width: ", ";\n            height: ", ";\n            transform: scale(", ");\n            transition: transform 0.4s cubic-bezier(0.5, 2, 0.5, 0.5);\n            background-color: ", ";\n          }\n        " + ( true ? "" : 0)])), (0,foundation.p)(20), (0,foundation.p)(20), (0,foundation.p)(1), (0,foundation.p)(5), (0,foundation.p)(5), (0,foundation.p)(8), (0,foundation.p)(8), checked ? 1 : 0, theme.content.base6), disabled ? /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)(templateObject_2$1o || (templateObject_2$1o = (0,common._)(["\n              border-color: ", ";\n              background-color: ", ";\n            " + ( true ? "" : 0)], ["\n              border-color: ", ";\n              background-color: ", ";\n            " + ( true ? "" : 0)])), theme.content.base3, theme.content.base3) : /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)(templateObject_4$_ || (templateObject_4$_ = (0,common._)(["\n              border-color: ", ";\n              background-color: ", ";\n              transition: border-color 0.1s, background-color 0.1s;\n              ", "\n            " + ( true ? "" : 0)], ["\n              border-color: ", ";\n              background-color: ", ";\n              transition: border-color 0.1s, background-color 0.1s;\n              ", "\n            " + ( true ? "" : 0)])), checked ? theme.content.primary1.basic : theme.content.base3, checked ? theme.content.primary1.basic : theme.content.white, (0,foundation.H)(templateObject_3$1b || (templateObject_3$1b = (0,common._)(["\n                background-color: ", ";\n                border-color: ", ";\n              "], ["\n                background-color: ", ";\n                border-color: ", ";\n              "])), checked ? theme.interactive.primary1.basic : theme.interactive.transparent, checked ? theme.interactive.primary1.basic : theme.content.base3))]
  }, {
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("input", (0,common.a)({}, rest, {
      ref: forwardedRef,
      type: "radio",
      checked: checked,
      disabled: disabled,
      css: /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)(templateObject_5$O || (templateObject_5$O = (0,common._)(["\n          cursor: pointer;\n          position: absolute;\n          top: 0;\n          left: 0;\n          opacity: 0;\n          width: 100%;\n          height: 100%;\n          margin: 0;\n          &:disabled {\n            cursor: default;\n          }\n        " + ( true ? "" : 0)], ["\n          cursor: pointer;\n          position: absolute;\n          top: 0;\n          left: 0;\n          opacity: 0;\n          width: 100%;\n          height: 100%;\n          margin: 0;\n          &:disabled {\n            cursor: default;\n          }\n        " + ( true ? "" : 0)])))
    }))
  }));
}
var templateObject_1$1O, templateObject_2$1o, templateObject_3$1b, templateObject_4$_, templateObject_5$O;

function RadioWithText(_a) {
  var id = _a.id,
    className = _a.className,
    children = _a.children,
    rest = (0,common.e)(_a, ["id", "className", "children"]);
  var theme = (0,emotion_element_5486c51c_browser_esm.u)();
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("label", (0,common.a)({
    css: /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)(templateObject_1$1N || (templateObject_1$1N = (0,common._)(["\n        display: inline-block;\n      " + ( true ? "" : 0)], ["\n        display: inline-block;\n      " + ( true ? "" : 0)]))),
    className: className,
    htmlFor: id
  }, {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Radio, (0,common.a)({}, rest, {
      id: id,
      css: /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)(templateObject_2$1n || (templateObject_2$1n = (0,common._)(["\n          vertical-align: middle;\n        " + ( true ? "" : 0)], ["\n          vertical-align: middle;\n        " + ( true ? "" : 0)])))
    })), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", (0,common.a)({
      css: /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)(templateObject_3$1a || (templateObject_3$1a = (0,common._)(["\n          ", "\n          vertical-align: middle;\n          margin-left: ", ";\n          color: ", ";\n        " + ( true ? "" : 0)], ["\n          ", "\n          vertical-align: middle;\n          margin-left: ", ";\n          color: ", ";\n        " + ( true ? "" : 0)])), foundation.F.subTitle1, (0,foundation.p)(6), theme.content.base1)
    }, {
      children: children
    }))]
  }));
}
var templateObject_1$1N, templateObject_2$1n, templateObject_3$1a;

var GRID_ITEM_CLASS_NAME = 'bucketplace-grid-item';
var COLUMN_CLASS_NAME = 'bucketplace-column';
function cssBaseGap(gap, className) {
  var _a = "".concat(gap).split(' ').map(Number),
    vertical = _a[0],
    horizontal = _a[1];
  if (horizontal) {
    var verticalGap = (0,foundation.p)(vertical / 2);
    var horizontalGap = (0,foundation.p)(horizontal / 2);
    return "\n      margin: -".concat(verticalGap, " -").concat(horizontalGap, ";\n      > .").concat(className, " {\n        padding: ").concat(verticalGap, " ").concat(horizontalGap, ";\n      }\n    ");
  }
  var halfGap = (0,foundation.p)(vertical / 2);
  return "\n    margin: -".concat(halfGap, ";\n    > .").concat(className, " {\n      padding: ").concat(halfGap, ";\n    }\n  ");
}
function cssGap(gap, className) {
  if ((0,common.k)(gap) === 'object') {
    var _a = gap.mobile,
      mobile = _a === void 0 ? 0 : _a,
      _b = gap.tablet,
      tablet = _b === void 0 ? mobile : _b,
      _c = gap.laptop,
      laptop = _c === void 0 ? tablet : _c;
    return /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)(templateObject_1$1M || (templateObject_1$1M = (0,common._)(["\n      ", "\n      ", "\n      ", "\n    " + ( true ? "" : 0)], ["\n      ", "\n      ", "\n      ", "\n    " + ( true ? "" : 0)])), cssBaseGap(mobile, className), foundation.M.min('tablet', cssBaseGap(tablet, className)), foundation.M.min('laptop', cssBaseGap(laptop, className)));
  }
  return /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)(templateObject_2$1m || (templateObject_2$1m = (0,common._)(["", "" + ( true ? "" : 0)], ["", "" + ( true ? "" : 0)])), cssBaseGap(gap, className));
}
var templateObject_1$1M, templateObject_2$1m;

var DEFAULT_GAP = {
  mobile: 12,
  tablet: 16,
  laptop: 20,
  // FIXME:
  // at this point, we do not have a grid-gap specification for `desktop` size, deriving `laptop` size for now.
  // revisit later to fix this: https://ohou-se.slack.com/archives/C017TF9FQUV/p1650524602037409
  desktop: 20
};
function Grid(_a) {
  var _b = _a.gap,
    gap = _b === void 0 ? DEFAULT_GAP : _b,
    children = _a.children,
    rest = (0,common.e)(_a, ["gap", "children"]);
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", (0,common.a)({}, rest, {
    css: /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)(templateObject_1$1L || (templateObject_1$1L = (0,common._)(["overflow: hidden;" + ( true ? "" : 0)], ["overflow: hidden;" + ( true ? "" : 0)])))
  }, {
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", (0,common.a)({
      css: cssGap(gap, GRID_ITEM_CLASS_NAME)
    }, {
      children: children
    }))
  }));
}
var templateObject_1$1L;

var TOTAL_COLUMN = {
  mobile: 4,
  tablet: 8,
  laptop: 12,
  // FIXME:
  // at this point, we do not have a grid-gap specification for `desktop` size, deriving `laptop` size for now.
  // revisit later to fix this: https://ohou-se.slack.com/archives/C017TF9FQUV/p1650524602037409
  desktop: 12
};
var COLUMN_PRESET = {
  full: {
    mobile: 4,
    tablet: 8,
    laptop: 12,
    desktop: 12
  },
  half: {
    mobile: 2,
    tablet: 4,
    laptop: 6,
    desktop: 6
  },
  quarter: {
    mobile: 1,
    tablet: 2,
    laptop: 3,
    desktop: 3
  }
};
function cssColumn$1(breakPoint, column) {
  return /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)(templateObject_1$1K || (templateObject_1$1K = (0,common._)(["\n    ", "\n  " + ( true ? "" : 0)], ["\n    ", "\n  " + ( true ? "" : 0)])), foundation.M.min(breakPoint, "\n      width: ".concat(100 / TOTAL_COLUMN[breakPoint] * (typeof column === 'number' ? column : COLUMN_PRESET[column][breakPoint]), "%;\n    ")));
}
function GridItem(_a) {
  var column = _a.column,
    className = _a.className,
    children = _a.children,
    rest = (0,common.e)(_a, ["column", "className", "children"]);
  var _b = (0,common.k)(column) === 'object' ? column : COLUMN_PRESET[column],
    _c = _b.mobile,
    mobile = _c === void 0 ? 1 : _c,
    _d = _b.tablet,
    tablet = _d === void 0 ? mobile : _d,
    _e = _b.laptop,
    laptop = _e === void 0 ? tablet : _e,
    _f = _b.desktop,
    desktop = _f === void 0 ? laptop : _f;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", (0,common.a)({}, rest, {
    css: [/*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)(templateObject_2$1l || (templateObject_2$1l = (0,common._)(["\n          display: inline-block;\n          vertical-align: top;\n          box-sizing: border-box;\n        " + ( true ? "" : 0)], ["\n          display: inline-block;\n          vertical-align: top;\n          box-sizing: border-box;\n        " + ( true ? "" : 0)]))), cssColumn$1('mobile', mobile), cssColumn$1('tablet', tablet), cssColumn$1('laptop', laptop), cssColumn$1('desktop', desktop)],
    className: spaces(className, GRID_ITEM_CLASS_NAME)
  }, {
    children: children
  }));
}
var templateObject_1$1K, templateObject_2$1l;

function cssColumn(column) {
  var ratios = column.split(' ').map(Number);
  var total = ratios.reduce(function (v1, v2) {
    return v1 + v2;
  });
  return "\n    > .".concat(COLUMN_CLASS_NAME, " {\n      ").concat(ratios.map(function (ratio, index) {
    return "\n        &:nth-of-type(".concat(ratios.length, "n + ").concat(index + 1, ") {\n          width: ").concat(100 / total * ratio, "%;\n        }\n      ");
  }), "\n    }\n  ");
}
function cssColumns(columns) {
  if (_typeof(columns) === 'object') {
    var mobile = columns.mobile,
      _a = columns.tablet,
      tablet = _a === void 0 ? mobile : _a,
      _b = columns.laptop,
      laptop = _b === void 0 ? tablet : _b;
    return /*#__PURE__*/css(templateObject_1$1J || (templateObject_1$1J = __makeTemplateObject(["\n      ", "\n      ", "\n      ", "\n    " + ( true ? "" : 0)], ["\n      ", "\n      ", "\n      ", "\n    " + ( true ? "" : 0)])), cssColumn(mobile), MEDIA_QUERY.min('tablet', cssColumn(tablet)), MEDIA_QUERY.min('laptop', cssColumn(laptop)));
  }
  return /*#__PURE__*/css(templateObject_2$1k || (templateObject_2$1k = __makeTemplateObject(["", "" + ( true ? "" : 0)], ["", "" + ( true ? "" : 0)])), cssColumn(columns));
}
function Row$1(_a) {
  var gap = _a.gap,
    columns = _a.columns,
    children = _a.children,
    rest = __rest(_a, ["gap", "columns", "children"]);
  return jsx("div", _assign({}, rest, {
    css: /*#__PURE__*/css(templateObject_3$19 || (templateObject_3$19 = __makeTemplateObject(["overflow: hidden;" + ( true ? "" : 0)], ["overflow: hidden;" + ( true ? "" : 0)])))
  }, {
    children: jsx("div", _assign({
      css: [gap && cssGap(gap, COLUMN_CLASS_NAME), cssColumns(columns)]
    }, {
      children: children
    }))
  }));
}
var templateObject_1$1J, templateObject_2$1k, templateObject_3$19;

function Column(_a) {
  var children = _a.children,
    className = _a.className,
    rest = __rest(_a, ["children", "className"]);
  return jsx("div", _assign({}, rest, {
    className: spaces(className, COLUMN_CLASS_NAME),
    css: /*#__PURE__*/css(templateObject_1$1I || (templateObject_1$1I = __makeTemplateObject(["\n        display: inline-block;\n        vertical-align: top;\n      " + ( true ? "" : 0)], ["\n        display: inline-block;\n        vertical-align: top;\n      " + ( true ? "" : 0)])))
  }, {
    children: children
  }));
}
var templateObject_1$1I;

function getActiveIds(menuSchema, fallbackMenuSchema) {
  // Check for fallback menu schema first
  if (fallbackMenuSchema != null) {
    var index = fallbackMenuSchema.findIndex(function (item) {
      return item.active;
    });
    if (index !== -1) {
      return [null, index];
    }
  }
  // Try to descend down to the matching entry
  for (var i = 0; i < menuSchema.length; i += 1) {
    var child = menuSchema[i];
    var childActiveIds = getActiveIdsEntry(child);
    // If the child has 'active' entry, merge all indices
    if (childActiveIds != null) {
      return __spreadArray([i], childActiveIds, true);
    }
  }
  // Nothing matched
  return [null];
}
function getActiveIdsEntry(entry) {
  if (entry.entries != null) {
    for (var i = 0; i < entry.entries.length; i += 1) {
      var child = entry.entries[i];
      var childActiveIds = getActiveIdsEntry(child);
      // If the child has 'active' entry, merge all indices
      if (childActiveIds != null) {
        return __spreadArray([i], childActiveIds, true);
      }
    }
  }
  if (entry.active) {
    // If the entry itself is active, return itself
    return [];
  }
  // Otherwise, it didn't match
  return null;
}

var LinkContext = /*#__PURE__*/(0,react.createContext)('a');
var useLinkContext = function useLinkContext() {
  return (0,react.useContext)(LinkContext);
};
function LinkProvider(_a) {
  var children = _a.children,
    linkComponent = _a.linkComponent;
  return jsx(LinkContext.Provider, _assign({
    value: linkComponent
  }, {
    children: children
  }));
}

function Container$4(_a) {
  var children = _a.children,
    rest = (0,common.e)(_a, ["children"]);
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", (0,common.a)({}, rest, {
    css: /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)(templateObject_1$1H || (templateObject_1$1H = (0,common._)(["\n        width: 100%;\n        padding: 0 ", ";\n        box-sizing: border-box;\n        ", "\n        ", "\n        ", "\n      " + ( true ? "" : 0)], ["\n        width: 100%;\n        padding: 0 ", ";\n        box-sizing: border-box;\n        ", "\n        ", "\n        ", "\n      " + ( true ? "" : 0)])), (0,foundation.p)(16), foundation.M.min('tablet', "\n          padding: 0 ".concat((0,foundation.p)(40), ";\n        ")), foundation.M.min('laptop', "\n          padding: 0 ".concat((0,foundation.p)(60), ";\n        ")), foundation.M.min('desktop', "\n          max-width: ".concat(foundation.B.desktop, "px;\n          margin: 0 auto;\n          padding: 0 ").concat((0,foundation.p)(60), ";\n        ")))
  }, {
    children: children
  }));
}
var templateObject_1$1H;

var LogContext = /*#__PURE__*/(0,react.createContext)(function () {});
var useLogContext = function useLogContext() {
  return (0,react.useContext)(LogContext);
};
function LogProvider(_a) {
  var children = _a.children,
    onLog = _a.onLog;
  return jsx(LogContext.Provider, _assign({
    value: onLog
  }, {
    children: children
  }));
}

function useHover(onHover) {
  var onHoverRef = useRef(onHover);
  onHoverRef.current = onHover;
  var timeoutRef = useRef(null);
  var handleMouseTimeout = useCallback(function () {
    onHoverRef.current();
    timeoutRef.current = null;
  }, []);
  var handleMouseMove = useCallback(function () {
    if (timeoutRef.current != null) {
      window.clearTimeout(timeoutRef.current);
    }
    timeoutRef.current = window.setTimeout(handleMouseTimeout, 50);
  }, [handleMouseTimeout]);
  var handleMouseEnter = useCallback(function () {
    window.addEventListener('mousemove', handleMouseMove);
    if (timeoutRef.current != null) {
      window.clearTimeout(timeoutRef.current);
    }
    timeoutRef.current = window.setTimeout(handleMouseTimeout, 50);
  }, [handleMouseTimeout, handleMouseMove]);
  var handleMouseLeave = useCallback(function () {
    window.removeEventListener('mousemove', handleMouseMove);
    if (timeoutRef.current != null) {
      window.clearTimeout(timeoutRef.current);
      timeoutRef.current = null;
    }
  }, [handleMouseMove]);
  useEffect(function () {
    return function () {
      window.removeEventListener('mousemove', handleMouseMove);
      if (timeoutRef.current != null) {
        window.clearTimeout(timeoutRef.current);
      }
    };
  }, [handleMouseMove]);
  return [handleMouseEnter, handleMouseLeave];
}

function NavigationBarPrimaryTabItem(props) {
  var _a = props.component,
    component = _a === void 0 ? 'button' : _a,
    index = props.index,
    isActive = props.isActive,
    isOpen = props.isOpen,
    children = props.children,
    onSelect = props.onSelect,
    forwardedRef = props.forwardedRef,
    onClick = props.onClick,
    rest = __rest(props, ["component", "index", "isActive", "isOpen", "children", "onSelect", "forwardedRef", "onClick"]);
  var theme = useTheme();
  var log = useLogContext();
  var handleClick = useCallback(function (e) {
    if (onClick) onClick(e);
    log({
      key: 'primary.item',
      category: 'click',
      params: {
        index: index
      }
    });
  }, [log, onClick, index]);
  var _b = useHover(onSelect),
    handleMouseEnter = _b[0],
    handleMouseLeave = _b[1];
  var Component = component;
  return jsx(Component, _assign({
    css: [/*#__PURE__*/css(templateObject_1$1G || (templateObject_1$1G = __makeTemplateObject(["\n          ", "\n          position: relative;\n          display: inline-block;\n          margin: 0 ", ";\n          padding: ", " ", " ", ";\n          font-size: ", ";\n          line-height: 1;\n          font-weight: bold;\n          color: ", ";\n          outline: none;\n        " + ( true ? "" : 0)], ["\n          ", "\n          position: relative;\n          display: inline-block;\n          margin: 0 ", ";\n          padding: ", " ", " ", ";\n          font-size: ", ";\n          line-height: 1;\n          font-weight: bold;\n          color: ", ";\n          outline: none;\n        " + ( true ? "" : 0)])), RESET_BUTTON, pxToRem(10), pxToRem(21), pxToRem(5), pxToRem(15), pxToRem(18), theme.content.base1), isActive && /*#__PURE__*/css(templateObject_2$1j || (templateObject_2$1j = __makeTemplateObject(["\n          color: ", ";\n        " + ( true ? "" : 0)], ["\n          color: ", ";\n        " + ( true ? "" : 0)])), theme.content.primary1.basic), isOpen && /*#__PURE__*/css(templateObject_3$18 || (templateObject_3$18 = __makeTemplateObject(["\n          color: ", ";\n        " + ( true ? "" : 0)], ["\n          color: ", ";\n        " + ( true ? "" : 0)])), theme.content.primary1.basic), HOVER(templateObject_4$Z || (templateObject_4$Z = __makeTemplateObject(["\n          color: ", ";\n        "], ["\n          color: ", ";\n        "])), theme.content.primary1.basic), FOCUS(templateObject_5$N || (templateObject_5$N = __makeTemplateObject(["\n          color: ", ";\n          & > span {\n            box-shadow: 0 0 0 ", " ", ";\n          }\n        "], ["\n          color: ", ";\n          & > span {\n            box-shadow: 0 0 0 ", " ", ";\n          }\n        "])), theme.content.primary1.basic, pxToRem(3), theme.interactive.primary1.thin)],
    ref: forwardedRef,
    onClick: handleClick,
    onMouseEnter: handleMouseEnter,
    onMouseLeave: handleMouseLeave
  }, rest, {
    children: jsx("span", _assign({
      css: /*#__PURE__*/css(templateObject_6$F || (templateObject_6$F = __makeTemplateObject(["\n        display: inline-block;\n        margin: ", ";\n        padding: ", ";\n        border-radius: ", ";\n      " + ( true ? "" : 0)], ["\n        display: inline-block;\n        margin: ", ";\n        padding: ", ";\n        border-radius: ", ";\n      " + ( true ? "" : 0)])), pxToRem(-4), pxToRem(4), pxToRem(3))
    }, {
      children: children
    }))
  }));
}
var templateObject_1$1G, templateObject_2$1j, templateObject_3$18, templateObject_4$Z, templateObject_5$N, templateObject_6$F;

var INITIAL_NODE_HEIGHT$1 = 81;
function NavigationBarPrimary(props) {
  var leftmost = props.leftmost,
    left = props.left,
    right = props.right,
    menuEntries = props.menuEntries,
    activeId = props.activeId,
    selectedId = props.selectedId,
    onMouseEnter = props.onMouseEnter,
    onMouseLeave = props.onMouseLeave,
    _onSelect = props.onSelect;
  var LinkComponent = useLinkContext();
  var childRef = useRef(null);
  var isPc = useMedia("(min-width: ".concat(BREAK_POINT.tablet, "px)"), true);
  var nodeHeight = useNodeHeight(childRef, INITIAL_NODE_HEIGHT$1);
  var scrollDir = useScrollDirection();
  return jsx(StyledSticky$1, _assign({
    direction: "top",
    offset: !isPc && scrollDir === 'down' ? -nodeHeight : 0,
    offsetRange: isPc ? [0, 0] : [-nodeHeight, 0],
    type: "navigation",
    disableNativeSticky: true,
    disableBottom: true,
    zIndex: ZINDEX.appBar + 2,
    transition: 0.1,
    onMouseEnter: onMouseEnter,
    onMouseLeave: onMouseLeave,
    forwardRef: childRef
  }, {
    children: jsxs(StyledContainer$2, {
      children: [jsx(LeftMost, {
        children: leftmost
      }), jsx(Left, {
        children: left
      }), jsx(NavigationBarPrimaryTabList, {
        children: menuEntries.map(function (item, index) {
          return jsx(NavigationBarPrimaryTabItem, _assign({
            index: index,
            component: LinkComponent,
            href: item.href,
            isActive: activeId === index,
            isOpen: selectedId === index,
            onSelect: function onSelect() {
              return _onSelect(item, index);
            }
          }, {
            children: item.title
          }), index);
        })
      }), jsx(Right$1, {
        children: right
      })]
    })
  }));
}
var StyledSticky$1 = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(lib_esm/* Sticky */.Le,  true ? {
  target: "e1qjsy915"
} : 0)(templateObject_1$1F || (templateObject_1$1F = (0,common._)(["\n  background: ", ";\n  border-bottom: ", " solid ", ";\n"], ["\n  background: ", ";\n  border-bottom: ", " solid ", ";\n"])), function (_a) {
  var theme = _a.theme;
  return theme.background.base;
}, (0,foundation.p)(1), function (_a) {
  var theme = _a.theme;
  return theme.divider;
});
var StyledContainer$2 = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Container$4,  true ? {
  target: "e1qjsy914"
} : 0)(templateObject_3$17 || (templateObject_3$17 = (0,common._)(["\n  position: relative;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  height: ", ";\n  box-sizing: border-box;\n  line-height: 0;\n  ", "\n"], ["\n  position: relative;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  height: ", ";\n  box-sizing: border-box;\n  line-height: 0;\n  ", "\n"])), (0,foundation.p)(50), foundation.M.min('tablet', /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)(templateObject_2$1i || (templateObject_2$1i = (0,common._)(["\n    height: ", ";\n    padding-top: ", ";\n    padding-bottom: ", ";\n  " + ( true ? "" : 0)], ["\n    height: ", ";\n    padding-top: ", ";\n    padding-bottom: ", ";\n  " + ( true ? "" : 0)])), (0,foundation.p)(80), (0,foundation.p)(10), (0,foundation.p)(10))));
var LeftMost = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1qjsy913"
} : 0)(templateObject_5$M || (templateObject_5$M = (0,common._)(["\n  flex: 0 0 auto;\n  display: block;\n  margin-left: ", ";\n  ", "\n  "], ["\n  flex: 0 0 auto;\n  display: block;\n  margin-left: ", ";\n  ", "\n  "])), (0,foundation.p)(-7), foundation.M.min('tablet', /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)(templateObject_4$Y || (templateObject_4$Y = (0,common._)(["\n  display: none;\n  " + ( true ? "" : 0)], ["\n  display: none;\n  " + ( true ? "" : 0)])))));
var Left = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1qjsy912"
} : 0)(templateObject_8$o || (templateObject_8$o = (0,common._)(["\n  position: absolute;\n  flex: 0 0 auto;\n  left: 50%;\n  top: 50%;\n  color: ", ";\n  transform: translate(-50%, -50%);\n  ", "\n  ", "\n"], ["\n  position: absolute;\n  flex: 0 0 auto;\n  left: 50%;\n  top: 50%;\n  color: ", ";\n  transform: translate(-50%, -50%);\n  ", "\n  ", "\n"])), function (_a) {
  var theme = _a.theme;
  return theme.interactive.base1;
}, foundation.M.min('tablet', /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)(templateObject_6$E || (templateObject_6$E = (0,common._)(["\n    position: static;\n    margin-right: ", ";\n    left: none;\n    top: none;\n    transform: none;\n  " + ( true ? "" : 0)], ["\n    position: static;\n    margin-right: ", ";\n    left: none;\n    top: none;\n    transform: none;\n  " + ( true ? "" : 0)])), (0,foundation.p)(20))), foundation.M.min('laptop', /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)(templateObject_7$v || (templateObject_7$v = (0,common._)(["\n    margin-right: ", ";\n  " + ( true ? "" : 0)], ["\n    margin-right: ", ";\n  " + ( true ? "" : 0)])), (0,foundation.p)(35))));
var NavigationBarPrimaryTabList = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1qjsy911"
} : 0)(templateObject_10$f || (templateObject_10$f = (0,common._)(["\n  flex: 1 1 0px;\n  display: none;\n  white-space: nowrap;\n  ", "\n  "], ["\n  flex: 1 1 0px;\n  display: none;\n  white-space: nowrap;\n  ", "\n  "])), foundation.M.min('tablet', /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)(templateObject_9$h || (templateObject_9$h = (0,common._)(["\n  display: block;\n  " + ( true ? "" : 0)], ["\n  display: block;\n  " + ( true ? "" : 0)])))));
var Right$1 = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1qjsy910"
} : 0)(templateObject_14$3 || (templateObject_14$3 = (0,common._)(["\n  flex: 0 0 auto;\n  ", "\n  ", "\n  ", "\n"], ["\n  flex: 0 0 auto;\n  ", "\n  ", "\n  ", "\n"])), foundation.M.min('tablet', /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)(templateObject_11$9 || (templateObject_11$9 = (0,common._)(["\n    flex: 0 1 ", ";\n  " + ( true ? "" : 0)], ["\n    flex: 0 1 ", ";\n  " + ( true ? "" : 0)])), (0,foundation.p)(476))), foundation.M.min('desktop', /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)(templateObject_12$6 || (templateObject_12$6 = (0,common._)(["\n    flex: 0 1 ", ";\n  " + ( true ? "" : 0)], ["\n    flex: 0 1 ", ";\n  " + ( true ? "" : 0)])), (0,foundation.p)(650))), foundation.M.max('mobile', /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)(templateObject_13$6 || (templateObject_13$6 = (0,common._)(["\n    margin-right: ", ";\n  " + ( true ? "" : 0)], ["\n    margin-right: ", ";\n  " + ( true ? "" : 0)])), (0,foundation.p)(-7))));
var templateObject_1$1F, templateObject_2$1i, templateObject_3$17, templateObject_4$Y, templateObject_5$M, templateObject_6$E, templateObject_7$v, templateObject_8$o, templateObject_9$h, templateObject_10$f, templateObject_11$9, templateObject_12$6, templateObject_13$6, templateObject_14$3;

var FixedTab = /*#__PURE__*/(/* unused pure expression or super */ null && (forwardRef(function (_a, ref) {
  var rest = __rest(_a, []);
  return jsx("nav", _assign({}, rest, {
    ref: ref,
    css: /*#__PURE__*/css(templateObject_1$1E || (templateObject_1$1E = __makeTemplateObject(["\n          display: flex;\n          align-items: stretch;\n          overflow-x: auto;\n          white-space: nowrap;\n          && > * {\n            flex: 1 0 0px;\n            min-width: 0;\n          }\n        " + ( true ? "" : 0)], ["\n          display: flex;\n          align-items: stretch;\n          overflow-x: auto;\n          white-space: nowrap;\n          && > * {\n            flex: 1 0 0px;\n            min-width: 0;\n          }\n        " + ( true ? "" : 0)])))
  }));
})));
var templateObject_1$1E;

var Tab = /*#__PURE__*/(0,react.forwardRef)(function (_a, ref) {
  var rest = (0,common.e)(_a, []);
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("nav", (0,common.a)({}, rest, {
    ref: ref,
    css: /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)(templateObject_1$1D || (templateObject_1$1D = (0,common._)(["\n          display: flex;\n          align-items: stretch;\n          overflow-x: auto;\n          white-space: nowrap;\n          margin: 0 -5px;\n          && > * {\n            margin: 0 5px;\n          }\n        " + ( true ? "" : 0)], ["\n          display: flex;\n          align-items: stretch;\n          overflow-x: auto;\n          white-space: nowrap;\n          margin: 0 -5px;\n          && > * {\n            margin: 0 5px;\n          }\n        " + ( true ? "" : 0)])))
  }));
});
var templateObject_1$1D;

var _path$1, _path2$1;
function _extends$2() { _extends$2 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2.apply(this, arguments); }
var SvgIcNew18 = function SvgIcNew18(props) {
  return /*#__PURE__*/react.createElement("svg", _extends$2({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _path$1 || (_path$1 = /*#__PURE__*/react.createElement("path", {
    fill: "#fff",
    d: "M0 9a9 9 0 1 1 18 0A9 9 0 0 1 0 9"
  })), _path2$1 || (_path2$1 = /*#__PURE__*/react.createElement("path", {
    fill: "#F77",
    fillRule: "evenodd",
    d: "M9 18A9 9 0 1 0 9 0a9 9 0 0 0 0 18m-1.7-5.25H5.26v-7.5h2.61l2.8 4.2h.03v-4.2h2.06v7.5h-2.3l-3.1-4.68h-.05v4.68z",
    clipRule: "evenodd"
  })));
};
var NewIcon = SvgIcNew18;

/**
 * @deprecated ODS의 DotBadge 컴포넌트를 사용해 주세요.
 */
function DotNotification(props) {
  var theme = (0,emotion_element_5486c51c_browser_esm.u)();
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", (0,common.a)({}, props, {
    css: /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)(templateObject_1$1C || (templateObject_1$1C = (0,common._)(["\n        position: absolute;\n        border-radius: 50%;\n        width: ", ";\n        height: ", ";\n        background-color: ", ";\n      " + ( true ? "" : 0)], ["\n        position: absolute;\n        border-radius: 50%;\n        width: ", ";\n        height: ", ";\n        background-color: ", ";\n      " + ( true ? "" : 0)])), (0,foundation.p)(4), (0,foundation.p)(4), theme.content.primary2.basic)
  }));
}
var templateObject_1$1C;

function TabItem(_a) {
  var _b = _a.component,
    component = _b === void 0 ? 'button' : _b,
    isActive = _a.isActive,
    children = _a.children,
    subText = _a.subText,
    bullet = _a.bullet,
    forwardedRef = _a.forwardedRef,
    _onClick = _a.onClick,
    badge = _a.badge,
    className = _a.className,
    rest = (0,common.e)(_a, ["component", "isActive", "children", "subText", "bullet", "forwardedRef", "onClick", "badge", "className"]);
  var theme = (0,emotion_element_5486c51c_browser_esm.u)();
  var Component = component;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Component, (0,common.a)({
    className: className,
    css: [/*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)(templateObject_1$1B || (templateObject_1$1B = (0,common._)(["\n          ", "\n          position: relative;\n          display: inline-flex;\n          flex-direction: column;\n          justify-content: center;\n          vertical-align: top;\n          text-align: center;\n          box-sizing: border-box;\n          &:after {\n            content: '';\n            display: block;\n            position: absolute;\n            left: 0;\n            bottom: 0;\n            width: 100%;\n            height: ", ";\n            background-color: ", ";\n            transition: transform 0.2s;\n            transform: scale(", ");\n          }\n        " + ( true ? "" : 0)], ["\n          ", "\n          position: relative;\n          display: inline-flex;\n          flex-direction: column;\n          justify-content: center;\n          vertical-align: top;\n          text-align: center;\n          box-sizing: border-box;\n          &:after {\n            content: '';\n            display: block;\n            position: absolute;\n            left: 0;\n            bottom: 0;\n            width: 100%;\n            height: ", ";\n            background-color: ", ";\n            transition: transform 0.2s;\n            transform: scale(", ");\n          }\n        " + ( true ? "" : 0)])), foundation.R, (0,foundation.p)(2), theme.content.primary1.basic, isActive ? 1 : 0), (0,foundation.H)(templateObject_2$1h || (templateObject_2$1h = (0,common._)(["\n          & > div > p:first-of-type {\n            color: ", ";\n          }\n        "], ["\n          & > div > p:first-of-type {\n            color: ", ";\n          }\n        "])), theme.content.primary1.basic), (0,foundation.g)(templateObject_3$16 || (templateObject_3$16 = (0,common._)(["\n          & > div {\n            box-shadow: 0 0 0 3px ", ";\n            border-radius: 3px;\n          }\n        "], ["\n          & > div {\n            box-shadow: 0 0 0 3px ", ";\n            border-radius: 3px;\n          }\n        "])), theme.content.primary1.basic), subText ? /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)(templateObject_4$X || (templateObject_4$X = (0,common._)(["\n            padding: ", " ", " ", ";\n          " + ( true ? "" : 0)], ["\n            padding: ", " ", " ", ";\n          " + ( true ? "" : 0)])), (0,foundation.p)(11), (0,foundation.p)(6), (0,foundation.p)(5)) : /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)(templateObject_5$L || (templateObject_5$L = (0,common._)(["\n            padding: ", " ", ";\n          " + ( true ? "" : 0)], ["\n            padding: ", " ", ";\n          " + ( true ? "" : 0)])), (0,foundation.p)(12), (0,foundation.p)(6))],
    ref: forwardedRef,
    onClick: function onClick() {
      if (_onClick) {
        _onClick();
      }
    }
  }, rest, {
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", (0,common.a)({
      css: /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)(templateObject_6$D || (templateObject_6$D = (0,common._)(["\n          padding: ", ";\n          margin: -", ";\n        " + ( true ? "" : 0)], ["\n          padding: ", ";\n          margin: -", ";\n        " + ( true ? "" : 0)])), (0,foundation.p)(4), (0,foundation.p)(4))
    }, {
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("p", (0,common.a)({
        css: [foundation.F.subTitle1, /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)(templateObject_7$u || (templateObject_7$u = (0,common._)(["\n              position: relative;\n              font-weight: ", ";\n              color: ", ";\n            " + ( true ? "" : 0)], ["\n              position: relative;\n              font-weight: ", ";\n              color: ", ";\n            " + ( true ? "" : 0)])), isActive ? 700 : 500, isActive ? theme.content.primary1.basic : theme.content.base1)]
      }, {
        children: [children, badge && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SquareBadge, (0,common.a)({
          size: 16,
          type: badge.type,
          variant: badge.variant,
          css: /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)(templateObject_8$n || (templateObject_8$n = (0,common._)(["\n                vertical-align: middle;\n                margin-left: ", ";\n              " + ( true ? "" : 0)], ["\n                vertical-align: middle;\n                margin-left: ", ";\n              " + ( true ? "" : 0)])), (0,foundation.p)(3))
        }, {
          children: badge.text
        })), bullet === 'dot' && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DotNotification, {
          css: /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)(templateObject_9$g || (templateObject_9$g = (0,common._)(["\n                top: 0;\n                right: ", ";\n              " + ( true ? "" : 0)], ["\n                top: 0;\n                right: ", ";\n              " + ( true ? "" : 0)])), (0,foundation.p)(-6))
        }), bullet === 'new' && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(NewIcon, {
          css: /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)(templateObject_10$e || (templateObject_10$e = (0,common._)(["\n                vertical-align: middle;\n                margin: 0 ", " ", " ", ";\n              " + ( true ? "" : 0)], ["\n                vertical-align: middle;\n                margin: 0 ", " ", " ", ";\n              " + ( true ? "" : 0)])), (0,foundation.p)(1.5), (0,foundation.p)(1.5), (0,foundation.p)(1.5))
        })]
      })), subText && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("p", (0,common.a)({
        css: [foundation.F.caption2, /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)(templateObject_11$8 || (templateObject_11$8 = (0,common._)(["\n                color: ", ";\n              " + ( true ? "" : 0)], ["\n                color: ", ";\n              " + ( true ? "" : 0)])), theme.content.base2)]
      }, {
        children: subText
      }))]
    }))
  }));
}
var templateObject_1$1B, templateObject_2$1h, templateObject_3$16, templateObject_4$X, templateObject_5$L, templateObject_6$D, templateObject_7$u, templateObject_8$n, templateObject_9$g, templateObject_10$e, templateObject_11$8;

var useNavigationLog = function useNavigationLog() {
  var log = useLogContext();
  var logTabImpression = useCallback(function (menu, index) {
    log({
      key: 'secondary.item',
      category: 'impression',
      params: {
        index: index,
        id: menu.logId,
        type: 'topic',
        section: '서브 메뉴',
        section_id: 'LNB'
      }
    });
  }, [log]);
  var logTabClick = useCallback(function (menu, index, isHncTopicTab) {
    var _a;
    var defaultParams = {
      index: index,
      section: '서브 메뉴',
      type: 'tab',
      id: (_a = menu.logId) !== null && _a !== void 0 ? _a : menu.title
    };
    var params = isHncTopicTab ? _assign(_assign({}, defaultParams), {
      type: 'topic',
      section_id: 'LNB'
    }) : defaultParams;
    log({
      key: 'secondary.item',
      category: 'click',
      params: params
    });
  }, [log]);
  var logMoreButtonClick = useCallback(function () {
    log({
      key: 'secondary.more.button',
      category: 'click'
    });
  }, [log]);
  return {
    logTabClick: logTabClick,
    logTabImpression: logTabImpression,
    logMoreButtonClick: logMoreButtonClick
  };
};

function PopperContent(_a) {
  var referenceRef = _a.referenceRef,
    isOpen = _a.isOpen,
    onClose = _a.onClose,
    onExited = _a.onExited,
    children = _a.children,
    _b = _a.placement,
    placement = _b === void 0 ? 'bottom' : _b,
    size = _a.size,
    className = _a.className,
    style = _a.style;
  var theme = (0,emotion_element_5486c51c_browser_esm.u)();
  var _c = (0,react.useState)(null),
    popperRef = _c[0],
    setPopperRef = _c[1];
  var _d = usePopper(referenceRef, popperRef, {
      placement: placement,
      modifiers: [{
        name: 'offset',
        enabled: true,
        options: {
          offset: [0, 10]
        }
      }]
    }),
    styles = _d.styles,
    attributes = _d.attributes,
    state = _d.state;
  (0,react.useEffect)(function () {
    var handleClick = function handleClick(e) {
      var target = e.target;
      // Chrome regression
      if (e.target === document.body) return;
      if (e.defaultPrevented || target == null || target.parentElement == null) {
        return;
      }
      // If the user clicked somewhere else, close the popper
      while (target != null) {
        if (referenceRef === target || popperRef === target || target instanceof HTMLElement && target.hasAttribute('data-popout')) {
          return;
        }
        target = target.parentElement;
      }
      onClose();
    };
    window.addEventListener('click', handleClick);
    return function () {
      window.removeEventListener('click', handleClick);
    };
  }, [onClose, referenceRef, popperRef]);
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(esm_CSSTransition/* default */.Z
  // NOTE: This is a quirky workaround happening due to 'setPopperRef' -
  // which will confuse CSSTransition.
  // In order to workaround this, the timeout is set to 0 until the user
  // decides to close the popper.
  // https://github.com/reactjs/react-transition-group/issues/284
  , (0,common.a)({
    // NOTE: This is a quirky workaround happening due to 'setPopperRef' -
    // which will confuse CSSTransition.
    // In order to workaround this, the timeout is set to 0 until the user
    // decides to close the popper.
    // https://github.com/reactjs/react-transition-group/issues/284
    "in": popperRef != null && isOpen,
    timeout: isOpen ? 0 : 200,
    classNames: {
      enterActive: 'open',
      enterDone: 'open open-active',
      appearActive: 'open',
      exitActive: 'exiting',
      exit: 'exiting',
      exitDone: 'exiting'
    },
    onExited: onExited
  }, {
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", (0,common.a)({
      ref: setPopperRef,
      style: (0,common.a)((0,common.a)({}, styles.popper), style)
    }, attributes.popper, {
      className: classnames_default()("placement-".concat((state || {}).placement), className),
      css: /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)(templateObject_1$1A || (templateObject_1$1A = (0,common._)(["\n          opacity: 1;\n          visibility: visible;\n          pointer-events: none;\n          z-index: ", ";\n\n          &.placement-top .popper-item {\n            transform: translate(0, 10px);\n          }\n\n          &.placement-bottom .popper-item {\n            transform: translate(0, -10px);\n          }\n\n          &.open {\n            transform: none;\n            transition: .2s opacity;\n          }\n\n          &.open .popper-item {\n            transform: none;\n            transition: .2s transform;\n          }\n\n          &.open-active {\n            pointer-events: auto;\n            transition: .2s opacity;\n          }\n\n          &.exiting {\n            opacity: 0;\n            visibility: hidden;\n            transition: 0s visibility .2s, .2s opacity;\n          }\n\n          &.exiting .popper-item {\n            transition: .2s transform;\n          }\n        " + ( true ? "" : 0)], ["\n          opacity: 1;\n          visibility: visible;\n          pointer-events: none;\n          z-index: ", ";\n\n          &.placement-top .popper-item {\n            transform: translate(0, 10px);\n          }\n\n          &.placement-bottom .popper-item {\n            transform: translate(0, -10px);\n          }\n\n          &.open {\n            transform: none;\n            transition: .2s opacity;\n          }\n\n          &.open .popper-item {\n            transform: none;\n            transition: .2s transform;\n          }\n\n          &.open-active {\n            pointer-events: auto;\n            transition: .2s opacity;\n          }\n\n          &.exiting {\n            opacity: 0;\n            visibility: hidden;\n            transition: 0s visibility .2s, .2s opacity;\n          }\n\n          &.exiting .popper-item {\n            transition: .2s transform;\n          }\n        " + ( true ? "" : 0)])), common.Z.dropdown)
    }, {
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", (0,common.a)({
        className: "popper-item",
        style: styles.offset,
        css: /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)(templateObject_2$1g || (templateObject_2$1g = (0,common._)(["\n            position: relative;\n            padding: 8px;\n            background-color: ", ";\n            border: 1px solid ", ";\n            border-radius: 6px;\n            box-shadow: 0 4px 10px 0 rgb(63, 71, 77, 0.2);\n            width: ", ";\n          " + ( true ? "" : 0)], ["\n            position: relative;\n            padding: 8px;\n            background-color: ", ";\n            border: 1px solid ", ";\n            border-radius: 6px;\n            box-shadow: 0 4px 10px 0 rgb(63, 71, 77, 0.2);\n            width: ", ";\n          " + ( true ? "" : 0)])), theme.background.base, theme.interactive.base4, size ? (0,foundation.p)(size) : undefined)
      }, {
        children: children
      }))
    }))
  }));
}
function Popper(_a) {
  var renderButton = _a.renderButton,
    onChange = _a.onChange,
    _b = _a.usePortal,
    usePortal = _b === void 0 ? true : _b,
    _c = _a.isForceClosed,
    isForceClosed = _c === void 0 ? false : _c,
    children = _a.children,
    other = (0,common.e)(_a, ["renderButton", "onChange", "usePortal", "isForceClosed", "children"]);
  var _d = (0,react.useState)({
      isVisible: false,
      isOpen: false
    }),
    state = _d[0],
    setState = _d[1];
  var referenceRef = (0,react.useRef)(null);
  var handleClose = (0,react.useCallback)(function () {
    setState(function (v) {
      return (0,common.a)((0,common.a)({}, v), {
        isOpen: false
      });
    });
  }, []);
  var handleExited = (0,react.useCallback)(function () {
    setState({
      isVisible: false,
      isOpen: false
    });
  }, []);
  var handleToggle = (0,react.useCallback)(function () {
    setState(function (v) {
      return {
        isOpen: !v.isOpen,
        // If the node is visible, keep it visible. But if we need to reveal it,
        // make it visible
        isVisible: v.isVisible || !v.isOpen
      };
    });
  }, []);
  (0,react.useEffect)(function () {
    onChange === null || onChange === void 0 ? void 0 : onChange(state.isOpen);
  }, [state.isOpen, onChange]);
  (0,react.useEffect)(function () {
    if (isForceClosed) {
      handleClose();
    }
  }, [isForceClosed, handleClose]);
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", (0,common.a)({
      ref: referenceRef,
      css: /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)(templateObject_3$15 || (templateObject_3$15 = (0,common._)(["line-height: 0;" + ( true ? "" : 0)], ["line-height: 0;" + ( true ? "" : 0)])))
    }, {
      children: renderButton({
        onClick: handleToggle,
        isOpen: state.isOpen
      })
    })), state.isVisible && usePortal && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(common.h, {
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PopperContent, (0,common.a)({
        referenceRef: referenceRef.current,
        isOpen: state.isOpen,
        onClose: handleClose,
        onExited: handleExited
      }, other, {
        children: children
      }))
    }), state.isVisible && !usePortal && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PopperContent, (0,common.a)({
      referenceRef: referenceRef.current,
      isOpen: state.isOpen,
      onClose: handleClose,
      onExited: handleExited
    }, other, {
      children: children
    }))]
  });
}
var templateObject_1$1A, templateObject_2$1g, templateObject_3$15;

var Dim = /*#__PURE__*/(0,react.forwardRef)(function (props, ref) {
  var onDark = props.onDark,
    variant = props.variant,
    children = props.children,
    rest = (0,common.e)(props, ["onDark", "variant", "children"]);
  var theme = (0,emotion_element_5486c51c_browser_esm.u)();
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", (0,common.a)({
    "data-testid": "bds-dim"
  }, rest, {
    ref: ref,
    css: [/*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)(templateObject_1$1z || (templateObject_1$1z = (0,common._)(["\n          position: fixed;\n          top: 0;\n          left: 0;\n          width: 100%;\n          height: 100%;\n          text-align: center;\n          z-index: ", ";\n          &::before {\n            content: \"\";\n            height: 100%;\n            display: inline-block;\n            vertical-align: middle;\n          }\n        " + ( true ? "" : 0)], ["\n          position: fixed;\n          top: 0;\n          left: 0;\n          width: 100%;\n          height: 100%;\n          text-align: center;\n          z-index: ", ";\n          &::before {\n            content: \"\";\n            height: 100%;\n            display: inline-block;\n            vertical-align: middle;\n          }\n        " + ( true ? "" : 0)])), common.Z.modal), variant && /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)(templateObject_2$1f || (templateObject_2$1f = (0,common._)(["\n          background-color: ", ";\n        " + ( true ? "" : 0)], ["\n          background-color: ", ";\n        " + ( true ? "" : 0)])), (onDark ? theme.dim.onDark : theme.dim)[variant])]
  }, {
    children: children
  }));
});
var templateObject_1$1z, templateObject_2$1f;

var GAP$1 = 10;
var ICON_SIZE$3 = 24;
function ModalHeader(_a) {
  var title = _a.title,
    onBack = _a.onBack,
    onClose = _a.onClose;
  var theme = (0,emotion_element_5486c51c_browser_esm.u)();
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", (0,common.a)({
    css: /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)(templateObject_1$1y || (templateObject_1$1y = (0,common._)(["\n        padding: ", " ", " ", " ", ";\n        line-height: 0;\n      " + ( true ? "" : 0)], ["\n        padding: ", " ", " ", " ", ";\n        line-height: 0;\n      " + ( true ? "" : 0)])), (0,foundation.p)(16), (0,foundation.p)(16), (0,foundation.p)(10), (0,foundation.p)(16))
  }, {
    children: [onBack && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("button", (0,common.a)({
      type: "button",
      onClick: onBack,
      css: /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)(templateObject_2$1e || (templateObject_2$1e = (0,common._)(["\n            ", "\n            vertical-align: middle;\n            width: ", ";\n            height: ", ";\n          " + ( true ? "" : 0)], ["\n            ", "\n            vertical-align: middle;\n            width: ", ";\n            height: ", ";\n          " + ( true ? "" : 0)])), foundation.R, (0,foundation.p)(ICON_SIZE$3), (0,foundation.p)(ICON_SIZE$3))
    }, {
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Icon, {
        size: ICON_SIZE$3,
        name: "arrow_left",
        css: /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)(templateObject_3$14 || (templateObject_3$14 = (0,common._)(["\n              color: ", ";\n            " + ( true ? "" : 0)], ["\n              color: ", ";\n            " + ( true ? "" : 0)])), theme.content.base1)
      })
    })), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", (0,common.a)({
      css: [foundation.F.title2, /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)(templateObject_4$W || (templateObject_4$W = (0,common._)(["\n            display: inline-block;\n            vertical-align: middle;\n            font-weight: 700;\n            text-align: center;\n            width: calc(100% - ", ");\n            margin-left: ", ";\n            margin-right: ", ";\n            white-space: pre-line;\n          " + ( true ? "" : 0)], ["\n            display: inline-block;\n            vertical-align: middle;\n            font-weight: 700;\n            text-align: center;\n            width: calc(100% - ", ");\n            margin-left: ", ";\n            margin-right: ", ";\n            white-space: pre-line;\n          " + ( true ? "" : 0)])), (0,foundation.p)((GAP$1 + ICON_SIZE$3) * 2), (0,foundation.p)(onBack ? GAP$1 : ICON_SIZE$3), (0,foundation.p)(onClose ? GAP$1 : ICON_SIZE$3))]
    }, {
      children: title
    })), onClose && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("button", (0,common.a)({
      type: "button",
      onClick: onClose,
      css: /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)(templateObject_5$K || (templateObject_5$K = (0,common._)(["\n            ", "\n            vertical-align: middle;\n            width: ", ";\n            height: ", ";\n          " + ( true ? "" : 0)], ["\n            ", "\n            vertical-align: middle;\n            width: ", ";\n            height: ", ";\n          " + ( true ? "" : 0)])), foundation.R, (0,foundation.p)(ICON_SIZE$3), (0,foundation.p)(ICON_SIZE$3))
    }, {
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Icon, {
        size: ICON_SIZE$3,
        name: "dismiss",
        css: /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)(templateObject_6$C || (templateObject_6$C = (0,common._)(["\n              color: ", ";\n            " + ( true ? "" : 0)], ["\n              color: ", ";\n            " + ( true ? "" : 0)])), theme.content.base1)
      })
    }))]
  }));
}
var templateObject_1$1y, templateObject_2$1e, templateObject_3$14, templateObject_4$W, templateObject_5$K, templateObject_6$C;

function ModalFooter(_a) {
  var _b, _c, _d;
  var action = _a.action,
    subAction = _a.subAction,
    style = _a.style;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", (0,common.a)({
    css: [style, /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)(templateObject_1$1x || (templateObject_1$1x = (0,common._)(["\n          padding: ", " ", ";\n          line-height: 0;\n        " + ( true ? "" : 0)], ["\n          padding: ", " ", ";\n          line-height: 0;\n        " + ( true ? "" : 0)])), (0,foundation.p)(9), (0,foundation.p)(16))]
  }, {
    children: [action && (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", (0,common.a)({
      css: /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)(templateObject_2$1d || (templateObject_2$1d = (0,common._)(["\n            padding-top: ", ";\n            padding-bottom: ", ";\n          " + ( true ? "" : 0)], ["\n            padding-top: ", ";\n            padding-bottom: ", ";\n          " + ( true ? "" : 0)])), (0,foundation.p)(1), (0,foundation.p)(subAction ? 9 : 7))
    }, {
      children: [action.secondary && (!Array.isArray(action.secondary) ? (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(OutlineButton, (0,common.a)({
        size: 50,
        variant: "base1",
        onClick: action.secondary.onClick,
        disabled: (_b = action.secondary.disabled) !== null && _b !== void 0 ? _b : false,
        css: /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)(templateObject_3$13 || (templateObject_3$13 = (0,common._)(["\n                  width: calc(50% - ", ");\n                  margin-right: ", ";\n                " + ( true ? "" : 0)], ["\n                  width: calc(50% - ", ");\n                  margin-right: ", ";\n                " + ( true ? "" : 0)])), (0,foundation.p)(5), (0,foundation.p)(10))
      }, {
        children: action.secondary.text
      })) : (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: action.secondary.map(function (secondaryAction, index) {
          var _a;
          return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(OutlineButton, (0,common.a)({
            size: 50,
            variant: "base1",
            onClick: secondaryAction.onClick,
            disabled: (_a = secondaryAction.disabled) !== null && _a !== void 0 ? _a : false,
            css: [/*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)(templateObject_4$V || (templateObject_4$V = (0,common._)(["\n                        width: calc(50% - ", ");\n                      " + ( true ? "" : 0)], ["\n                        width: calc(50% - ", ");\n                      " + ( true ? "" : 0)])), (0,foundation.p)(5)), index === 0 && /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)(templateObject_5$J || (templateObject_5$J = (0,common._)(["\n                        margin-right: ", ";\n                      " + ( true ? "" : 0)], ["\n                        margin-right: ", ";\n                      " + ( true ? "" : 0)])), (0,foundation.p)(10))]
          }, {
            children: secondaryAction.text
          }), index);
        })
      })), action.primary && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Button$2, (0,common.a)({
        size: 50,
        variant: "primary1",
        onClick: action.primary.onClick,
        disabled: (_c = action.primary.disabled) !== null && _c !== void 0 ? _c : false,
        css: action.secondary ? /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)(templateObject_6$B || (templateObject_6$B = (0,common._)(["\n                    width: calc(50% - ", ");\n                  " + ( true ? "" : 0)], ["\n                    width: calc(50% - ", ");\n                  " + ( true ? "" : 0)])), (0,foundation.p)(5)) : /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)(templateObject_7$t || (templateObject_7$t = (0,common._)(["\n                    width: 100%;\n                  " + ( true ? "" : 0)], ["\n                    width: 100%;\n                  " + ( true ? "" : 0)])))
      }, {
        children: action.primary.text
      }))]
    })), subAction && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TextButton, (0,common.a)({
      size: 32,
      variant: "base1",
      onClick: subAction.onClick,
      disabled: (_d = subAction.disabled) !== null && _d !== void 0 ? _d : false
    }, {
      children: subAction.text
    }))]
  }));
}
var templateObject_1$1x, templateObject_2$1d, templateObject_3$13, templateObject_4$V, templateObject_5$J, templateObject_6$B, templateObject_7$t;

var LAPTOP_HEIGHT = {
  300: '48%',
  400: '78%',
  500: '84%',
  600: '90%',
  700: '96%',
  1200: '96%'
};
var MARGIN = {
  300: '0',
  400: '0',
  500: '0',
  600: '0',
  700: '0',
  1200: "0 ".concat((0,foundation.p)(80))
};
function Modal(_a) {
  var width = _a.width,
    onBlur = _a.onBlur,
    header = _a.header,
    footer = _a.footer,
    _b = _a.isPopupInMobile,
    isPopupInMobile = _b === void 0 ? false : _b,
    _c = _a.isStretch,
    isStretch = _c === void 0 ? false : _c,
    stretch = _a.stretch,
    children = _a.children,
    _d = _a.hasInteraction,
    hasInteraction = _d === void 0 ? false : _d,
    _e = _a.height,
    height = _e === void 0 ? '' : _e,
    _f = _a.hasGrabber,
    hasGrabber = _f === void 0 ? false : _f,
    _g = _a.disableBackgroundScroll,
    disableBackgroundScroll = _g === void 0 ? false : _g,
    rest = (0,common.e)(_a, ["width", "onBlur", "header", "footer", "isPopupInMobile", "isStretch", "stretch", "children", "hasInteraction", "height", "hasGrabber", "disableBackgroundScroll"]);
  var theme = (0,emotion_element_5486c51c_browser_esm.u)();
  var isMobile = (0,hooks.m)().breakpoint === 'mobile';
  var scrollAvailableRef = (0,react.useRef)(null);
  var modalRef = (0,react.useRef)(null);
  var grabberRef = (0,react.useRef)(null);
  var _h = (0,react.useState)(height),
    customHeight = _h[0],
    setCustomHeight = _h[1];
  var isPopup = isPopupInMobile && width === 300;
  (0,react.useEffect)(function () {
    if (height !== 'auto') {
      setCustomHeight(height);
      return;
    }
    if (!modalRef.current || hasGrabber && !grabberRef.current) return;
    setCustomHeight("".concat(modalRef.current.getBoundingClientRect().height, "px"));
  }, [height, hasGrabber, isMobile]);
  (0,react.useEffect)(function () {
    if (!disableBackgroundScroll) return;
    document.getElementsByTagName('body')[0].style.overflow = 'hidden';
    return function () {
      document.getElementsByTagName('body')[0].style.overflow = 'auto';
    };
  }, [disableBackgroundScroll]);
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(common.h, {
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Dim, (0,common.a)({}, rest, {
      ref: scrollAvailableRef,
      variant: "basic",
      onClick: onBlur,
      css: /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)(templateObject_2$1c || (templateObject_2$1c = (0,common._)(["\n          display: flex;\n          align-items: center;\n          justify-content: center;\n          ", " \n        " + ( true ? "" : 0)], ["\n          display: flex;\n          align-items: center;\n          justify-content: center;\n          ", " \n        " + ( true ? "" : 0)])), !isPopup && foundation.M.max('mobile', /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)(templateObject_1$1w || (templateObject_1$1w = (0,common._)(["\n            align-items: flex-end;\n          " + ( true ? "" : 0)], ["\n            align-items: flex-end;\n          " + ( true ? "" : 0)])))))
    }, {
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", (0,common.a)({
        ref: modalRef,
        onClick: function onClick(e) {
          return e.stopPropagation();
        },
        css: /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)(templateObject_4$U || (templateObject_4$U = (0,common._)(["\n            ", "\n            vertical-align: middle;\n            border-radius: ", ";\n            display: inline-flex;\n            flex-direction: column;\n            color: ", ";\n            background-color: ", ";\n            max-width: ", ";\n            width: 100%;\n\n            ", "\n          " + ( true ? "" : 0)], ["\n            ", "\n            vertical-align: middle;\n            border-radius: ", ";\n            display: inline-flex;\n            flex-direction: column;\n            color: ", ";\n            background-color: ", ";\n            max-width: ", ";\n            width: 100%;\n\n            ", "\n          " + ( true ? "" : 0)])), createSizeStyle({
          width: width,
          customHeight: customHeight,
          hasInteraction: hasInteraction,
          stretch: stretch !== null && stretch !== void 0 ? stretch : isStretch,
          isPopup: isPopup
        }), (0,foundation.p)(8), theme.content.base1, theme.background.elevated, (0,foundation.p)(width), !isPopup && foundation.M.max('mobile', /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)(templateObject_3$12 || (templateObject_3$12 = (0,common._)(["\n              max-width: none;\n              ", "\n              vertical-align: bottom;\n              border-bottom-left-radius: initial;\n              border-bottom-right-radius: initial;\n            " + ( true ? "" : 0)], ["\n              max-width: none;\n              ", "\n              vertical-align: bottom;\n              border-bottom-left-radius: initial;\n              border-bottom-right-radius: initial;\n            " + ( true ? "" : 0)])), (0,foundation.s)('bottom', 'padding-bottom'))))
      }, {
        children: [isMobile && hasGrabber && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Grabber, {
          ref: grabberRef
        }), header && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ModalHeader, (0,common.a)({}, header)), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", (0,common.a)({
          css: [foundation.F.body1_1, /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)(templateObject_5$I || (templateObject_5$I = (0,common._)(["\n                display: flex;\n                flex-direction: column;\n                width: 100%;\n                height: 100%;\n                word-break: break-all;\n                overflow-y: auto;\n              " + ( true ? "" : 0)], ["\n                display: flex;\n                flex-direction: column;\n                width: 100%;\n                height: 100%;\n                word-break: break-all;\n                overflow-y: auto;\n              " + ( true ? "" : 0)]))), !footer && /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)(templateObject_6$A || (templateObject_6$A = (0,common._)(["padding-bottom: ", ";" + ( true ? "" : 0)], ["padding-bottom: ", ";" + ( true ? "" : 0)])), (0,foundation.p)(9))]
        }, {
          children: children
        })), footer && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ModalFooter, (0,common.a)({}, footer))]
      }))
    }))
  });
}
/**
 * 모달 사이즈 스타일을 생성합니다.
 */
function createSizeStyle(_a) {
  var width = _a.width,
    customHeight = _a.customHeight,
    hasInteraction = _a.hasInteraction,
    stretch = _a.stretch,
    isPopup = _a.isPopup;
  var height = LAPTOP_HEIGHT[width];
  var margin = MARGIN[width];
  var interactionCSS = /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)(templateObject_7$s || (templateObject_7$s = (0,common._)(["\n    height: ", ";\n    transition: height 0.3s;\n  " + ( true ? "" : 0)], ["\n    height: ", ";\n    transition: height 0.3s;\n  " + ( true ? "" : 0)])), customHeight);
  if (stretch) {
    return createStretchStyle({
      stretch: stretch
    });
  }
  return /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)(templateObject_9$f || (templateObject_9$f = (0,common._)(["\n    max-height: ", ";\n    margin: ", ";\n\n    ", "\n  " + ( true ? "" : 0)], ["\n    max-height: ", ";\n    margin: ", ";\n\n    ", "\n  " + ( true ? "" : 0)])), height, margin, !isPopup && foundation.M.max('mobile', /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)(templateObject_8$m || (templateObject_8$m = (0,common._)(["\n      max-height: 90%;\n      margin: 0;\n      ", "\n    " + ( true ? "" : 0)], ["\n      max-height: 90%;\n      margin: 0;\n      ", "\n    " + ( true ? "" : 0)])), hasInteraction && interactionCSS)));
}
function createStretchStyle(_a) {
  var stretch = _a.stretch;
  if (stretch === true) {
    return /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)(templateObject_11$7 || (templateObject_11$7 = (0,common._)(["\n      height: 100%;\n\n      ", "\n    " + ( true ? "" : 0)], ["\n      height: 100%;\n\n      ", "\n    " + ( true ? "" : 0)])), foundation.M.max('mobile', /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)(templateObject_10$d || (templateObject_10$d = (0,common._)(["\n        height: 90%;\n      " + ( true ? "" : 0)], ["\n        height: 90%;\n      " + ( true ? "" : 0)])))));
  }
  if ((0,common.k)(stretch) === 'object') {
    var mobile = stretch.mobile,
      tablet = stretch.tablet,
      laptop = stretch.laptop,
      desktop = stretch.desktop;
    return /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)(templateObject_16 || (templateObject_16 = (0,common._)(["\n      ", "\n      ", "\n      ", "\n      ", "\n    " + ( true ? "" : 0)], ["\n      ", "\n      ", "\n      ", "\n      ", "\n    " + ( true ? "" : 0)])), mobile && foundation.M.min('mobile', /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)(templateObject_12$5 || (templateObject_12$5 = (0,common._)(["height: ", ";" + ( true ? "" : 0)], ["height: ", ";" + ( true ? "" : 0)])), mobile)), tablet && foundation.M.min('tablet', /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)(templateObject_13$5 || (templateObject_13$5 = (0,common._)(["height: ", ";" + ( true ? "" : 0)], ["height: ", ";" + ( true ? "" : 0)])), tablet)), laptop && foundation.M.min('laptop', /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)(templateObject_14$2 || (templateObject_14$2 = (0,common._)(["height: ", ";" + ( true ? "" : 0)], ["height: ", ";" + ( true ? "" : 0)])), laptop)), desktop && foundation.M.min('desktop', /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)(templateObject_15 || (templateObject_15 = (0,common._)(["height: ", ";" + ( true ? "" : 0)], ["height: ", ";" + ( true ? "" : 0)])), desktop)));
  }
  return /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)(templateObject_17 || (templateObject_17 = (0,common._)(["height: ", ";" + ( true ? "" : 0)], ["height: ", ";" + ( true ? "" : 0)])), stretch);
}
var Grabber = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "eslvxdd0"
} : 0)(templateObject_18 || (templateObject_18 = (0,common._)(["\n  width: ", ";\n  min-height: ", ";\n  border-radius: ", ";\n  background-color: ", ";\n  margin: ", " auto 0;\n"], ["\n  width: ", ";\n  min-height: ", ";\n  border-radius: ", ";\n  background-color: ", ";\n  margin: ", " auto 0;\n"])), (0,foundation.p)(32), (0,foundation.p)(4), (0,foundation.p)(2), function (_a) {
  var theme = _a.theme;
  return theme.content.base4;
}, (0,foundation.p)(6));
var templateObject_1$1w, templateObject_2$1c, templateObject_3$12, templateObject_4$U, templateObject_5$I, templateObject_6$A, templateObject_7$s, templateObject_8$m, templateObject_9$f, templateObject_10$d, templateObject_11$7, templateObject_12$5, templateObject_13$5, templateObject_14$2, templateObject_15, templateObject_16, templateObject_17, templateObject_18;

var BUTTON_WIDTH = 100;
/**
 * scraollableEntries가 false일 경우
 * 메뉴 entries UI를 다른 UI로 보여주는 로직들을 포함합니다.
 */
var useMoreMenus = function useMoreMenus(_a) {
  var menus = _a.menus,
    scrollableEntries = _a.scrollableEntries,
    activeId = _a.activeId,
    primaryId = _a.primaryId;
  var menusWithIndex = useMemo(function () {
    return menus.map(function (menu, index) {
      return _assign(_assign({}, menu), {
        index: index
      });
    });
  }, [menus]);
  var _b = useState(menusWithIndex),
    moreMenus = _b[0],
    setMoreMenus = _b[1];
  /** moreButton + popper의 visible 여부 */
  var _c = useState(false),
    isVisible = _c[0],
    setIsVisible = _c[1];
  var _d = useState(true),
    isGradientVisible = _d[0],
    setIsGradientVisible = _d[1];
  /** popper를 강제로 닫을지 여부 */
  var _e = useState(false),
    isForcePopperClosed = _e[0],
    setIsForcePopperClosed = _e[1];
  /** popper의 open 여부 */
  var _f = useState(false),
    isPopperOpened = _f[0],
    setIsPopperOpened = _f[1];
  // TODO: bottomSheet 관련 공통 인터랙션 공통화
  var _g = useState('auto'),
    bottomSheetHeight = _g[0],
    setBottomSheetHeight = _g[1];
  var _h = useState(false),
    hasClosingInteraction = _h[0],
    setHasClosingInteraction = _h[1];
  var containerRef = useRef(null);
  var currentClientY = useRef(0);
  var isMobile = useResponsive().breakpoint === 'mobile';
  var theme = useTheme();
  var Link = useLinkContext();
  var _j = useNavigationLog(),
    logTabClick = _j.logTabClick,
    logTabImpression = _j.logTabImpression,
    logMoreButtonClick = _j.logMoreButtonClick;
  var isHncSecondaryTabItem = primaryId === 0;
  var handleIntersect = useCallback(function (menu, index) {
    if (!isHncSecondaryTabItem || !menu.logId) return;
    logTabImpression(menu, index);
  }, [logTabImpression, isHncSecondaryTabItem]);
  var handleClick = useCallback(function (menu, index) {
    logTabClick(menu, index, !!(isHncSecondaryTabItem && menu.logId));
  }, [logTabClick, isHncSecondaryTabItem]);
  var activeIdInMoreMenus = useMemo(function () {
    if (activeId == null) return null;
    return activeId - (menus.length - moreMenus.length);
  }, [activeId, menus.length, moreMenus.length]);
  var handleOpenBottomSheet = function handleOpenBottomSheet() {
    setHasClosingInteraction(false);
    setBottomSheetHeight('auto');
    setIsForcePopperClosed(false);
  };
  var handleCloseBottomSheet = function handleCloseBottomSheet() {
    setHasClosingInteraction(true);
    setBottomSheetHeight('0%');
  };
  var handleTouchMove = useCallback(function (event) {
    var scrollDown = currentClientY.current < event.changedTouches[0].clientY;
    if (scrollDown) {
      handleCloseBottomSheet();
    }
  }, []);
  var handleChangeVisibleMenu = useCallback(function (changedMenu, changedMenuIndex, visibleRatio) {
    if (isMobile) {
      setMoreMenus(menusWithIndex);
      return;
    }
    if (visibleRatio == null) return;
    if (visibleRatio < 1) {
      setMoreMenus(function (menus) {
        return menus.map(function (menu) {
          return menu.index;
        }).includes(changedMenuIndex) ? menus : __spreadArray(__spreadArray([], menus, true), [_assign(_assign({}, changedMenu), {
          index: changedMenuIndex
        })], false).sort(function (a, b) {
          return a.index - b.index;
        });
      });
    } else {
      setMoreMenus(function (menus) {
        return menus.filter(function (menu) {
          return changedMenuIndex !== menu.index;
        });
      });
    }
  }, [isMobile, menusWithIndex]);
  var handleChangeVisibleGradient = function handleChangeVisibleGradient(node) {
    var scrollRight = node.scrollWidth - Math.ceil(node.scrollLeft) - (node === null || node === void 0 ? void 0 : node.getBoundingClientRect().width);
    setIsGradientVisible(scrollRight > 5);
  };
  var handleResize = function handleResize() {
    if (!containerRef.current) return;
    var scrollWidth = containerRef.current.scrollWidth;
    var elementWidth = Math.ceil(containerRef.current.getBoundingClientRect().width);
    var overflowWidth = Math.max(scrollWidth - elementWidth, 0);
    setIsVisible(overflowWidth > 0);
  };
  useResize(containerRef, handleResize);
  useEffect(function () {
    setMoreMenus([]);
  }, [scrollableEntries]);
  useEffect(function () {
    if (isMobile) return;
    var handleScroll = function handleScroll() {
      var isScrollDown = currentClientY.current < window.scrollY;
      setIsForcePopperClosed(isScrollDown);
      currentClientY.current = window.scrollY;
    };
    var throttleScroll = throttle(handleScroll, 1000);
    window.addEventListener('scroll', throttleScroll);
    return function () {
      window.removeEventListener('scroll', throttleScroll);
    };
  }, [isMobile]);
  var MoreMenus = useMemo(function () {
    return jsx(MoreMenusContainer, {
      children: moreMenus.map(function (menu, index) {
        return jsx(StyledIntersectionObserver, _assign({
          onIntersect: function onIntersect() {
            return handleIntersect(menu, menu.index);
          }
        }, {
          children: jsx(Link, _assign({
            href: menu.href,
            onClick: function onClick() {
              handleClick(menu, menu.index);
              setIsForcePopperClosed(true);
            },
            css: [cssLink, /*#__PURE__*/css(templateObject_2$1b || (templateObject_2$1b = __makeTemplateObject(["\n                @media(hover: hover) {\n                  &:hover {\n                    color: ", ";\n                  }\n                }\n                ", "\n              " + ( true ? "" : 0)], ["\n                @media(hover: hover) {\n                  &:hover {\n                    color: ", ";\n                  }\n                }\n                ", "\n              " + ( true ? "" : 0)])), theme.content.primary1.basic, activeIdInMoreMenus === index && /*#__PURE__*/css(templateObject_1$1v || (templateObject_1$1v = __makeTemplateObject(["\n                  color: ", ";\n                " + ( true ? "" : 0)], ["\n                  color: ", ";\n                " + ( true ? "" : 0)])), theme.content.primary1.basic)), FOCUS(templateObject_3$11 || (templateObject_3$11 = __makeTemplateObject(["\n                  color: ", ";\n                "], ["\n                  color: ", ";\n                "])), theme.content.primary1.basic)]
          }, {
            children: menu.title
          }))
        }), menu.title);
      })
    });
  }, [theme, moreMenus, Link, activeIdInMoreMenus, handleIntersect, handleClick]);
  return {
    onChangeVisibleMenu: handleChangeVisibleMenu,
    onChangeVisibleGradient: handleChangeVisibleGradient,
    containerRef: containerRef,
    isPopperOpened: isPopperOpened,
    moreMenusComponent: isVisible ? jsx(Popper, _assign({
      isForceClosed: isForcePopperClosed,
      usePortal: false,
      style: isMobile ? {
        visibility: 'hidden'
      } : undefined,
      onChange: setIsPopperOpened,
      renderButton: function renderButton(_a) {
        var _onClick = _a.onClick,
          isOpen = _a.isOpen;
        return jsxs(Fragment$1, {
          children: [jsx(MoreButton, _assign({
            isGradientVisible: isGradientVisible,
            type: "button",
            onClick: function onClick() {
              handleOpenBottomSheet();
              _onClick();
              logMoreButtonClick();
            }
          }, {
            children: jsx(ChevronDownIcon, {
              size: 12,
              name: "chevron_down",
              fill: function fill(theme) {
                return theme.content.base1;
              }
            })
          })), isMobile && isOpen && jsx(StyledModal, _assign({
            width: 400,
            hasInteraction: true,
            hasGrabber: true,
            height: bottomSheetHeight,
            hasClosingInteraction: hasClosingInteraction,
            onBlur: handleCloseBottomSheet,
            onTouchStart: function onTouchStart(event) {
              currentClientY.current = event.changedTouches[0].clientY;
            },
            onTouchMove: handleTouchMove,
            disableBackgroundScroll: true,
            header: {
              title: '탭 선택하기',
              onClose: handleCloseBottomSheet
            },
            onTransitionEnd: function onTransitionEnd() {
              if (hasClosingInteraction) {
                _onClick();
              }
            }
          }, {
            children: jsx(SwitchTransition, {
              children: jsx(Transition, _assign({
                timeout: 200
              }, {
                children: MoreMenus
              }))
            })
          }))]
        });
      }
    }, {
      children: !isMobile && MoreMenus
    })) : null
  };
};
var cssLink = /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)(templateObject_5$H || (templateObject_5$H = (0,common._)(["\n  ", "\n  display: block;\n  padding: ", " 0 ", " ", ";\n  text-align: start;\n  font-weight: 700;\n  ", "\n" + ( true ? "" : 0)], ["\n  ", "\n  display: block;\n  padding: ", " 0 ", " ", ";\n  text-align: start;\n  font-weight: 700;\n  ", "\n" + ( true ? "" : 0)])), foundation.F.body1_small, (0,foundation.p)(10), (0,foundation.p)(10), (0,foundation.p)(26), foundation.M.min('tablet', /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)(templateObject_4$T || (templateObject_4$T = (0,common._)(["\n    ", ";\n    padding: 0 0 ", ";\n  " + ( true ? "" : 0)], ["\n    ", ";\n    padding: 0 0 ", ";\n  " + ( true ? "" : 0)])), foundation.F.subTitle1, (0,foundation.p)(20))));
var MoreButton = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("button",  true ? {
  target: "e1h7bema4"
} : 0)(templateObject_7$r || (templateObject_7$r = (0,common._)(["\n  ", "\n  padding: 0 ", ";\n  height: 100%;\n  display: flex;\n  align-items: center;\n  position: absolute;\n  transform: translateX(-100%);\n  ", "\n"], ["\n  ", "\n  padding: 0 ", ";\n  height: 100%;\n  display: flex;\n  align-items: center;\n  position: absolute;\n  transform: translateX(-100%);\n  ", "\n"])), foundation.R, (0,foundation.p)(6), function (_a) {
  var isGradientVisible = _a.isGradientVisible,
    theme = _a.theme;
  return isGradientVisible && /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)(templateObject_6$z || (templateObject_6$z = (0,common._)(["\n    &:after {\n      content: '';\n      position: absolute;\n      right: 0;\n      width: ", ";\n      height: 100%;\n      background: linear-gradient(90deg, ", " 0%, ", " 50%);\n    }\n  " + ( true ? "" : 0)], ["\n    &:after {\n      content: '';\n      position: absolute;\n      right: 0;\n      width: ", ";\n      height: 100%;\n      background: linear-gradient(90deg, ", " 0%, ", " 50%);\n    }\n  " + ( true ? "" : 0)])), (0,foundation.p)(BUTTON_WIDTH), (0,foundation.h)(theme.background.base, 0), theme.background.base);
});
var MoreMenusContainer = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1h7bema3"
} : 0)(templateObject_9$e || (templateObject_9$e = (0,common._)(["\n  display: flex;\n  flex-wrap: wrap;\n  padding-top: ", ";\n  ", "\n"], ["\n  display: flex;\n  flex-wrap: wrap;\n  padding-top: ", ";\n  ", "\n"])), (0,foundation.p)(30), foundation.M.min('tablet', /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)(templateObject_8$l || (templateObject_8$l = (0,common._)(["\n    display: block;\n    min-width: ", ";\n    padding: ", " ", " 0;\n  " + ( true ? "" : 0)], ["\n    display: block;\n    min-width: ", ";\n    padding: ", " ", " 0;\n  " + ( true ? "" : 0)])), (0,foundation.p)(250), (0,foundation.p)(20), (0,foundation.p)(22))));
var ChevronDownIcon = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Icon,  true ? {
  target: "e1h7bema2"
} : 0)(templateObject_10$c || (templateObject_10$c = (0,common._)(["\n  z-index: 2;\n"], ["\n  z-index: 2;\n"])));
var StyledModal = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Modal,  true ? {
  target: "e1h7bema1"
} : 0)(templateObject_12$4 || (templateObject_12$4 = (0,common._)(["\n  ", "\n"], ["\n  ", "\n"])), function (_a) {
  var hasClosingInteraction = _a.hasClosingInteraction;
  return hasClosingInteraction && /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)(templateObject_11$6 || (templateObject_11$6 = (0,common._)(["\n    opacity: 0;\n    transition: opacity 0.3s ease-in;\n  " + ( true ? "" : 0)], ["\n    opacity: 0;\n    transition: opacity 0.3s ease-in;\n  " + ( true ? "" : 0)])));
});
var StyledIntersectionObserver = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(common.I,  true ? {
  target: "e1h7bema0"
} : 0)(templateObject_13$4 || (templateObject_13$4 = (0,common._)(["\n  flex-basis: 50%;\n"], ["\n  flex-basis: 50%;\n"])));
var templateObject_1$1v, templateObject_2$1b, templateObject_3$11, templateObject_4$T, templateObject_5$H, templateObject_6$z, templateObject_7$r, templateObject_8$l, templateObject_9$e, templateObject_10$c, templateObject_11$6, templateObject_12$4, templateObject_13$4;

function NavigationBarSecondaryTabItem(props) {
  var onSelect = props.onSelect,
    index = props.index,
    item = props.item,
    onChangeVisibleMenu = props.onChangeVisibleMenu,
    containerRef = props.containerRef,
    primaryId = props.primaryId,
    rest = __rest(props, ["onSelect", "index", "item", "onChangeVisibleMenu", "containerRef", "primaryId"]);
  var LinkComponent = useLinkContext();
  var _a = useHover(onSelect),
    handleMouseEnter = _a[0],
    handleMouseLeave = _a[1];
  var _b = useInView({
      root: containerRef.current,
      rootMargin: "0px -".concat(BUTTON_WIDTH, "px 0px 0px"),
      initialInView: true,
      threshold: [0, 1]
    }),
    ref = _b.ref,
    entry = _b.entry;
  var _c = useNavigationLog(),
    logTabClick = _c.logTabClick,
    logTabImpression = _c.logTabImpression;
  var isHncSecondaryTabItem = primaryId === 0;
  var handleIntersect = useCallback(function () {
    if (!isHncSecondaryTabItem || !item.logId) return;
    logTabImpression === null || logTabImpression === void 0 ? void 0 : logTabImpression(item, index);
  }, [logTabImpression, item, index, isHncSecondaryTabItem]);
  useEffect(function () {
    onChangeVisibleMenu(item, index, entry === null || entry === void 0 ? void 0 : entry.intersectionRatio);
  }, [entry, item, index, onChangeVisibleMenu]);
  return jsx(IntersectionObserver, _assign({
    onIntersect: handleIntersect
  }, {
    children: jsx("div", _assign({
      ref: ref,
      css: /*#__PURE__*/css(templateObject_1$1u || (templateObject_1$1u = __makeTemplateObject(["height: inherit;" + ( true ? "" : 0)], ["height: inherit;" + ( true ? "" : 0)])))
    }, {
      children: jsx(StyledTabItem, _assign({}, rest, {
        component: LinkComponent,
        onClick: function onClick() {
          return logTabClick === null || logTabClick === void 0 ? void 0 : logTabClick(item, index, !!(isHncSecondaryTabItem && item.logId));
        },
        onMouseEnter: handleMouseEnter,
        onMouseLeave: handleMouseLeave
      }))
    }))
  }));
}
var StyledTabItem = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(TabItem,  true ? {
  target: "e1w9mhmv0"
} : 0)(templateObject_6$y || (templateObject_6$y = (0,common._)(["\n  height: inherit;\n  outline: none;\n  & > div > p {\n    font-weight: 700;\n  }\n  ", "\n  ", "\n"], ["\n  height: inherit;\n  outline: none;\n  & > div > p {\n    font-weight: 700;\n  }\n  ", "\n  ", "\n"])), foundation.M.max('mobile', /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)(templateObject_2$1a || (templateObject_2$1a = (0,common._)(["\n    padding: ", " ", ";\n    > div > p {\n      ", "\n    }\n  " + ( true ? "" : 0)], ["\n    padding: ", " ", ";\n    > div > p {\n      ", "\n    }\n  " + ( true ? "" : 0)])), (0,foundation.p)(11), (0,foundation.p)(5), foundation.F.subTitle2)), function (_a) {
  var theme = _a.theme;
  return /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)(templateObject_5$G || (templateObject_5$G = (0,common._)(["\n    ", "\n     ", "\n  " + ( true ? "" : 0)], ["\n    ", "\n     ", "\n  " + ( true ? "" : 0)])), (0,foundation.H)(templateObject_3$10 || (templateObject_3$10 = (0,common._)(["\n      color: ", ";\n    "], ["\n      color: ", ";\n    "])), theme.content.primary1.basic), (0,foundation.g)(templateObject_4$S || (templateObject_4$S = (0,common._)(["\n      * {\n        color: ", ";\n      }\n      & > div {\n        box-shadow: 0 0 0 ", " ", ";\n        border-radius: ", ";\n      }\n    "], ["\n      * {\n        color: ", ";\n      }\n      & > div {\n        box-shadow: 0 0 0 ", " ", ";\n        border-radius: ", ";\n      }\n    "])), theme.content.primary1.basic, (0,foundation.p)(3), theme.interactive.primary1.thin, (0,foundation.p)(3)));
});
var templateObject_1$1u, templateObject_2$1a, templateObject_3$10, templateObject_4$S, templateObject_5$G, templateObject_6$y;

var INITIAL_NODE_HEIGHT = 51;
function NavigationBarSecondary(props) {
  var hasItems = props.hasItems,
    isForceOpened = props.isForceOpened,
    isFallback = props.isFallback,
    right = props.right,
    menuEntries = props.menuEntries,
    activeId = props.activeId,
    onMouseEnter = props.onMouseEnter,
    _onMouseLeave = props.onMouseLeave,
    _onSelect = props.onSelect,
    primaryId = props.primaryId,
    _a = props.scrollableEntries,
    scrollableEntries = _a === void 0 ? true : _a;
  var childRef = useRef(null);
  var theme = useTheme();
  var isMobile = useResponsive().breakpoint === 'mobile';
  var nodeHeight = useNodeHeight(childRef, INITIAL_NODE_HEIGHT);
  var scrollDir = useScrollDirection();
  var shouldOpen = hasItems && scrollDir !== 'down' || isForceOpened;
  var _b = useMoreMenus({
      menus: menuEntries,
      scrollableEntries: scrollableEntries,
      activeId: activeId,
      primaryId: primaryId
    }),
    onChangeVisibleMenu = _b.onChangeVisibleMenu,
    onChangeVisibleGradient = _b.onChangeVisibleGradient,
    containerRef = _b.containerRef,
    moreMenusComponent = _b.moreMenusComponent,
    isPopperOpened = _b.isPopperOpened;
  /** Hover된 Secondary 메뉴 내 Popper가 닫히면, Secondary의 Hover상태도 없애기 위해 실행합니다. */
  useEffect(function () {
    if (isPopperOpened) return;
    _onMouseLeave === null || _onMouseLeave === void 0 ? void 0 : _onMouseLeave();
  }, [isPopperOpened, _onMouseLeave]);
  if (menuEntries.length === 0) return null;
  // NOTE: Secondary의 모바일/PC 동작은 완전히 동일합니다.
  return jsx(StyledSticky, _assign({
    className: "layout-navigation-secondary",
    css: /*#__PURE__*/css(templateObject_2$19 || (templateObject_2$19 = __makeTemplateObject(["", "" + ( true ? "" : 0)], ["", "" + ( true ? "" : 0)])), isFallback && /*#__PURE__*/css(templateObject_1$1t || (templateObject_1$1t = __makeTemplateObject(["background: ", ";" + ( true ? "" : 0)], ["background: ", ";" + ( true ? "" : 0)])), theme.background.groupedBase)),
    containerStyle: !hasItems ? {
      position: 'relative',
      top: isForceOpened ? '0' : pxToRem(-nodeHeight),
      height: '0px',
      transition: '.1s top'
    } : undefined,
    direction: "top",
    offset: shouldOpen ? 0 : -nodeHeight,
    offsetRange: [-nodeHeight, 0],
    type: "navigation",
    disableNativeSticky: true,
    disableBottom: true,
    disableHeight: !hasItems,
    forwardRef: childRef,
    zIndex: ZINDEX.appBar + 1,
    transition: 0.1,
    initialState: !hasItems ? _assign(_assign({}, DEFAULT_STICKY_STATE), {
      disabled: false,
      emulatedDisabled: false,
      offset: -nodeHeight,
      emulatedOffset: -nodeHeight
    }) : undefined,
    onMouseEnter: onMouseEnter,
    onMouseLeave: function onMouseLeave() {
      if (isPopperOpened) return;
      _onMouseLeave === null || _onMouseLeave === void 0 ? void 0 : _onMouseLeave();
    }
  }, {
    children: jsxs(StyledContainer$1, _assign({
      scrollable: scrollableEntries
    }, {
      children: [jsxs(TabContainer, _assign({
        ref: containerRef,
        scrollable: scrollableEntries
      }, {
        children: [jsx(StyledTab, _assign({
          ref: function ref(node) {
            if (!node) return;
            var throttleScroll = throttle(function () {
              return onChangeVisibleGradient(node);
            }, 100);
            node.addEventListener('scroll', throttleScroll);
          },
          scrollable: scrollableEntries,
          isMobile: isMobile
        }, {
          children: menuEntries.map(function (item, index) {
            return jsx(NavigationBarSecondaryTabItem, _assign({
              containerRef: containerRef,
              index: index,
              onChangeVisibleMenu: onChangeVisibleMenu,
              item: item,
              href: item.href,
              bullet: item.bullet,
              badge: item.badge,
              isActive: activeId === index,
              onSelect: function onSelect() {
                return _onSelect(item, index);
              },
              primaryId: primaryId
            }, {
              children: item.title
            }), item.title);
          })
        })), !scrollableEntries && moreMenusComponent]
      })), right && jsx(Right, {
        children: right
      })]
    }))
  }));
}
var StyledSticky = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(lib_esm/* Sticky */.Le,  true ? {
  target: "e1br7gq24"
} : 0)(templateObject_3$$ || (templateObject_3$$ = (0,common._)(["\n  background: ", ";\n  border-bottom: ", " solid ", ";\n"], ["\n  background: ", ";\n  border-bottom: ", " solid ", ";\n"])), function (_a) {
  var theme = _a.theme;
  return theme.background.base;
}, (0,foundation.p)(1), function (_a) {
  var theme = _a.theme;
  return theme.divider;
});
var StyledContainer$1 = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Container$4,  true ? {
  shouldForwardProp: function shouldForwardProp(prop) {
    return (0,emotion_is_prop_valid_esm/* default */.Z)(prop);
  },
  target: "e1br7gq23"
} : 0)(templateObject_5$F || (templateObject_5$F = (0,common._)(["\n  position: relative;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  box-sizing: border-box;\n  overflow: auto;\n  ", "\n"], ["\n  position: relative;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  box-sizing: border-box;\n  overflow: auto;\n  ", "\n"])), function (_a) {
  var scrollable = _a.scrollable;
  return !scrollable && /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)(templateObject_4$R || (templateObject_4$R = (0,common._)(["\n    overflow: initial;\n    padding-left: 0;\n  " + ( true ? "" : 0)], ["\n    overflow: initial;\n    padding-left: 0;\n  " + ( true ? "" : 0)])));
});
var StyledTab = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Tab,  true ? {
  shouldForwardProp: function shouldForwardProp(prop) {
    return (0,emotion_is_prop_valid_esm/* default */.Z)(prop);
  },
  target: "e1br7gq22"
} : 0)(templateObject_10$b || (templateObject_10$b = (0,common._)(["\n  height: ", ";\n  ", "\n  ", "\n"], ["\n  height: ", ";\n  ", "\n  ", "\n"])), (0,foundation.p)(51), foundation.M.max('mobile', /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)(templateObject_6$x || (templateObject_6$x = (0,common._)(["\n    height: ", ";\n    justify-content: center;\n    margin: 0 ", ";\n    && > * {\n      margin: 0 ", ";\n    }\n  " + ( true ? "" : 0)], ["\n    height: ", ";\n    justify-content: center;\n    margin: 0 ", ";\n    && > * {\n      margin: 0 ", ";\n    }\n  " + ( true ? "" : 0)])), (0,foundation.p)(40), (0,foundation.p)(-2), (0,foundation.p)(2))), function (_a) {
  var scrollable = _a.scrollable,
    isMobile = _a.isMobile;
  return !scrollable && /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)(templateObject_9$d || (templateObject_9$d = (0,common._)(["\n    & {\n      ", "\n    }\n  " + ( true ? "" : 0)], ["\n    & {\n      ", "\n    }\n  " + ( true ? "" : 0)])), isMobile ? /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)(templateObject_7$q || (templateObject_7$q = (0,common._)(["\n        padding: 0 ", " 0 ", ";\n        justify-content: start;\n      " + ( true ? "" : 0)], ["\n        padding: 0 ", " 0 ", ";\n        justify-content: start;\n      " + ( true ? "" : 0)])), (0,foundation.p)(32), (0,foundation.p)(16)) : /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)(templateObject_8$k || (templateObject_8$k = (0,common._)(["overflow: hidden;" + ( true ? "" : 0)], ["overflow: hidden;" + ( true ? "" : 0)]))));
});
var Right = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1br7gq21"
} : 0)(templateObject_12$3 || (templateObject_12$3 = (0,common._)(["\n  flex: 0 0 auto;\n  display: none;\n  ", "\n"], ["\n  flex: 0 0 auto;\n  display: none;\n  ", "\n"])), foundation.M.min('tablet', /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)(templateObject_11$5 || (templateObject_11$5 = (0,common._)(["\n    display: block;\n    margin-left: 10px;\n  " + ( true ? "" : 0)], ["\n    display: block;\n    margin-left: 10px;\n  " + ( true ? "" : 0)])))));
var TabContainer = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1br7gq20"
} : 0)(templateObject_14$1 || (templateObject_14$1 = (0,common._)(["\n  flex: 1 0 0;\n  ", "\n"], ["\n  flex: 1 0 0;\n  ", "\n"])), function (_a) {
  var scrollable = _a.scrollable;
  return !scrollable && /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)(templateObject_13$3 || (templateObject_13$3 = (0,common._)(["\n    display: flex;\n    justify-content: space-between;\n    overflow: hidden;\n  " + ( true ? "" : 0)], ["\n    display: flex;\n    justify-content: space-between;\n    overflow: hidden;\n  " + ( true ? "" : 0)])));
});
var templateObject_1$1t, templateObject_2$19, templateObject_3$$, templateObject_4$R, templateObject_5$F, templateObject_6$x, templateObject_7$q, templateObject_8$k, templateObject_9$d, templateObject_10$b, templateObject_11$5, templateObject_12$3, templateObject_13$3, templateObject_14$1;

function NavigationBarTertiary(_a) {
  var _b;
  var item = _a.item,
    isOpen = _a.isOpen,
    onMouseEnter = _a.onMouseEnter,
    onMouseLeave = _a.onMouseLeave;
  var itemRef = useRef(item);
  if (item != null) {
    itemRef.current = item;
  }
  var currentItem = itemRef.current;
  var nodeRef = useRef(null);
  var _c = useState(null),
    top = _c[0],
    setTop = _c[1];
  useEffect(function () {
    if (!isOpen) {
      return;
    }
    if (nodeRef.current == null) {
      nodeRef.current = document.querySelector('.layout-navigation-secondary');
    }
    if (nodeRef.current) {
      setTop(nodeRef.current.getBoundingClientRect().bottom);
    }
    var timer = null;
    function handleScroll() {
      if (timer != null) {
        cancelAnimationFrame(timer);
      }
      timer = requestAnimationFrame(function () {
        timer = null;
        if (nodeRef.current) {
          setTop(nodeRef.current.getBoundingClientRect().bottom);
        }
      });
    }
    window.addEventListener('scroll', handleScroll);
    return function () {
      window.removeEventListener('scroll', handleScroll);
      if (timer != null) {
        cancelAnimationFrame(timer);
      }
    };
  }, [isOpen]);
  var show = useMemo(function () {
    return Boolean(isOpen && (item === null || item === void 0 ? void 0 : item.renderBarChild));
  }, [isOpen, item]);
  if (top == null) {
    return null;
  }
  return jsx(CSSTransition, _assign({
    timeout: 200,
    "in": show,
    appear: show,
    unmountOnExit: true,
    classNames: {
      enterActive: 'open opening',
      enterDone: 'open open-active',
      appearActive: 'open opening',
      appearDone: 'open open-active',
      exit: 'exiting'
    }
  }, {
    children: jsx("div", _assign({
      css: /*#__PURE__*/css(templateObject_1$1s || (templateObject_1$1s = __makeTemplateObject(["\n          position: fixed;\n          top: ", "px;\n          left: 0;\n          right: 0;\n          background-color: #ffffff;\n          border-bottom: 1px solid #ededed;\n          z-index: 500;\n          opacity: 0;\n          transform: translateY(-100%);\n\n          &.opening {\n            transition: .2s opacity, .2s transform;\n          }\n          &.exiting {\n            transition: .2s opacity, .2s transform;\n          }\n          &.open {\n            opacity: 1;\n            transform: none;\n          }\n        " + ( true ? "" : 0)], ["\n          position: fixed;\n          top: ", "px;\n          left: 0;\n          right: 0;\n          background-color: #ffffff;\n          border-bottom: 1px solid #ededed;\n          z-index: 500;\n          opacity: 0;\n          transform: translateY(-100%);\n\n          &.opening {\n            transition: .2s opacity, .2s transform;\n          }\n          &.exiting {\n            transition: .2s opacity, .2s transform;\n          }\n          &.open {\n            opacity: 1;\n            transform: none;\n          }\n        " + ( true ? "" : 0)])), top),
      onMouseEnter: onMouseEnter,
      onMouseLeave: onMouseLeave
    }, {
      children: (_b = currentItem === null || currentItem === void 0 ? void 0 : currentItem.renderBarChild) === null || _b === void 0 ? void 0 : _b.call(currentItem)
    }))
  }));
}
var templateObject_1$1s;

function isIconAction(action) {
  return 'icon' in action;
}
function cssBaseTextField(theme, onDimmed, _a) {
  if (onDimmed === void 0) {
    onDimmed = false;
  }
  var error = _a.error,
    focused = _a.focused,
    disabled = _a.disabled,
    readOnly = _a.readOnly;
  return /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)(templateObject_1$1r || (templateObject_1$1r = (0,common._)(["\n    display: inline-flex;\n    align-items: center;\n    line-height: 0;\n    box-sizing: border-box;\n    border: ", " solid ", ";\n    border-radius: ", ";\n    &:hover {\n      background-color: ", ";\n    }\n    ", "\n    ", "\n    ", "\n    ", "\n    ", "\n  " + ( true ? "" : 0)], ["\n    display: inline-flex;\n    align-items: center;\n    line-height: 0;\n    box-sizing: border-box;\n    border: ", " solid ", ";\n    border-radius: ", ";\n    &:hover {\n      background-color: ", ";\n    }\n    ", "\n    ", "\n    ", "\n    ", "\n    ", "\n  " + ( true ? "" : 0)])), (0,foundation.p)(1), theme.border, (0,foundation.p)(4), theme.content.base5, disabled && "\n      border-color: ".concat(theme.content.base4, ";\n      background-color: ").concat(theme.content.base5, ";\n    "), readOnly && "\n      background-color: ".concat(theme.content.base5, ";\n    "), focused && "border-color: ".concat(theme.content.primary1.basic, ";"), error && "border-color: ".concat(theme.content.primary2.basic, ";"), onDimmed && "background-color: ".concat(theme.background.base, ";"));
}
function cssTextField(theme) {
  return /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)(templateObject_2$18 || (templateObject_2$18 = (0,common._)(["\n    ", "\n    height: 100%;\n    color: ", ";\n    outline: none;\n    &::placeholder {\n      color: ", ";\n    }\n  " + ( true ? "" : 0)], ["\n    ", "\n    height: 100%;\n    color: ", ";\n    outline: none;\n    &::placeholder {\n      color: ", ";\n    }\n  " + ( true ? "" : 0)])), foundation.a, theme.content.base1, theme.content.base3);
}
var templateObject_1$1r, templateObject_2$18;

var ICON_SIZE$2 = 24;
function cssContainer(size) {
  return /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)(templateObject_1$1q || (templateObject_1$1q = (0,common._)(["\n    height: ", ";\n    padding: 0\n    ", ";\n  " + ( true ? "" : 0)], ["\n    height: ", ";\n    padding: 0\n    ", ";\n  " + ( true ? "" : 0)])), (0,foundation.p)(size), (0,foundation.p)({
    32: 8,
    40: 14,
    44: 16,
    50: 16
  }[size]));
}
function cssFontSize$1(size) {
  return /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)(templateObject_2$17 || (templateObject_2$17 = (0,common._)(["", "" + ( true ? "" : 0)], ["", "" + ( true ? "" : 0)])), {
    32: foundation.F.body2,
    40: foundation.F.body1_1,
    44: foundation.F.body1_1,
    50: foundation.F.body1_1
  }[size]);
}
function cssIconInputPadding(size) {
  return /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)(templateObject_3$_ || (templateObject_3$_ = (0,common._)(["", "" + ( true ? "" : 0)], ["", "" + ( true ? "" : 0)])), (0,foundation.p)({
    32: 4,
    40: 6,
    44: 6,
    50: 8
  }[size]));
}
/**
 * @deprecated ODS의 Input 컴포넌트를 사용해주세요. 만약 디자인상 ODS의 Input를 사용할 수 없는 경우, 디자인시스템 담당 디자이너에게 문의해주세요.
 */
function Input$1(_a) {
  var _onChange = _a.onChange,
    onValue = _a.onValue,
    _onFocus = _a.onFocus,
    _onBlur = _a.onBlur,
    forwardedRef = _a.forwardedRef,
    className = _a.className,
    size = _a.size,
    icon = _a.icon,
    action = _a.action,
    _b = _a.onDimmed,
    onDimmed = _b === void 0 ? false : _b,
    _c = _a.error,
    error = _c === void 0 ? false : _c,
    _d = _a.disabled,
    disabled = _d === void 0 ? false : _d,
    _e = _a.readOnly,
    readOnly = _e === void 0 ? false : _e,
    rest = (0,common.e)(_a, ["onChange", "onValue", "onFocus", "onBlur", "forwardedRef", "className", "size", "icon", "action", "onDimmed", "error", "disabled", "readOnly"]);
  var theme = (0,emotion_element_5486c51c_browser_esm.u)();
  var _f = (0,react.useState)(false),
    focused = _f[0],
    setFocused = _f[1];
  var actions = Array.isArray(action) ? action : [action];
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", (0,common.a)({
    className: className,
    css: [cssBaseTextField(theme, onDimmed, {
      error: error,
      focused: focused,
      disabled: disabled,
      readOnly: readOnly
    }), cssContainer(size)]
  }, {
    children: [icon && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Icon, {
      size: ICON_SIZE$2,
      name: (0,common.k)(icon) === 'object' ? icon.name : icon,
      css: /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)(templateObject_4$Q || (templateObject_4$Q = (0,common._)(["\n            vertical-align: middle;\n            padding-right: ", ";\n            color: ", ";\n          " + ( true ? "" : 0)], ["\n            vertical-align: middle;\n            padding-right: ", ";\n            color: ", ";\n          " + ( true ? "" : 0)])), cssIconInputPadding(size), (0,common.k)(icon) === 'object' ? "".concat((icon === null || icon === void 0 ? void 0 : icon.color) || theme.content.base2) : theme.content.base2)
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledInput, (0,common.a)({}, rest, {
      ref: forwardedRef,
      disabled: disabled,
      readOnly: readOnly,
      onChange: function onChange(e) {
        return (0,common.j)(e, {
          onChange: _onChange,
          onValue: onValue
        });
      },
      onFocus: function onFocus(e) {
        if (_onFocus) {
          _onFocus(e);
        }
        setFocused(true);
      },
      onBlur: function onBlur(e) {
        if (_onBlur) {
          _onBlur(e);
        }
        setFocused(false);
      },
      css: [cssTextField(theme), cssFontSize$1(size), /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)(templateObject_5$E || (templateObject_5$E = (0,common._)(["\n            padding-right: ", ";\n          " + ( true ? "" : 0)], ["\n            padding-right: ", ";\n          " + ( true ? "" : 0)])), cssIconInputPadding(size))]
    })), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", (0,common.a)({
      css: /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)(templateObject_6$w || (templateObject_6$w = (0,common._)(["\n          display: flex;\n          align-items: center;\n        " + ( true ? "" : 0)], ["\n          display: flex;\n          align-items: center;\n        " + ( true ? "" : 0)])))
    }, {
      children: actions.map(function (action, i) {
        return !!action && (isIconAction(action) ? (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ActionButton, (0,common.a)({
          type: action.type || 'button',
          disabled: disabled || action.disabled,
          tabIndex: action.tabIndex || 0,
          css: /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)(templateObject_7$p || (templateObject_7$p = (0,common._)(["\n                  color: ", ";\n                " + ( true ? "" : 0)], ["\n                  color: ", ";\n                " + ( true ? "" : 0)])), action.color || theme.content.base2),
          onClick: function onClick(e) {
            var _a;
            e.stopPropagation();
            (_a = action.onClick) === null || _a === void 0 ? void 0 : _a.call(action, e);
          }
        }, {
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Icon, {
            size: ICON_SIZE$2,
            name: action.icon
          })
        }), i) : (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ActionTextButton, (0,common.a)({
          size: 30,
          variant: "primary1",
          type: action.type || 'button',
          disabled: disabled || action.disabled,
          tabIndex: action.tabIndex || 0,
          css: [cssFontSize$1(size)],
          onClick: function onClick(e) {
            var _a;
            e.stopPropagation();
            (_a = action.onClick) === null || _a === void 0 ? void 0 : _a.call(action, e);
          }
        }, {
          children: action.text
        }), i));
      })
    }))]
  }));
}
var StyledInput = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("input",  true ? {
  target: "e1rynmtb2"
} : 0)(templateObject_8$j || (templateObject_8$j = (0,common._)(["\n  box-sizing: border-box;\n  flex: 1 0 0%;\n  vertical-align: middle;\n  outline: none;\n"], ["\n  box-sizing: border-box;\n  flex: 1 0 0%;\n  vertical-align: middle;\n  outline: none;\n"])));
var ActionButton = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("button",  true ? {
  target: "e1rynmtb1"
} : 0)(templateObject_9$c || (templateObject_9$c = (0,common._)(["\n  ", "\n  vertical-align: middle;\n  width: ", ";\n  height: ", ";\n  outline: none;\n  margin-left: ", ";\n  &:first-of-type {\n    margin-left: 0;\n  }\n"], ["\n  ", "\n  vertical-align: middle;\n  width: ", ";\n  height: ", ";\n  outline: none;\n  margin-left: ", ";\n  &:first-of-type {\n    margin-left: 0;\n  }\n"])), foundation.R, (0,foundation.p)(ICON_SIZE$2), (0,foundation.p)(ICON_SIZE$2), (0,foundation.p)(8));
var ActionTextButton = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(TextButton,  true ? {
  target: "e1rynmtb0"
} : 0)(templateObject_10$a || (templateObject_10$a = (0,common._)(["\n  flex-shrink: 0;\n  margin-left: ", ";\n  padding: 0;\n  &:first-of-type {\n    margin-left: 0;\n  }\n"], ["\n  flex-shrink: 0;\n  margin-left: ", ";\n  padding: 0;\n  &:first-of-type {\n    margin-left: 0;\n  }\n"])), (0,foundation.p)(8));
var templateObject_1$1q, templateObject_2$17, templateObject_3$_, templateObject_4$Q, templateObject_5$E, templateObject_6$w, templateObject_7$p, templateObject_8$j, templateObject_9$c, templateObject_10$a;

var Input = /*#__PURE__*/(0,react.forwardRef)(function (_a, ref) {
  var value = _a.value,
    placeholder = _a.placeholder,
    onChange = _a.onChange,
    onClear = _a.onClear,
    props = (0,common.e)(_a, ["value", "placeholder", "onChange", "onClear"]);
  var input = (0,react.useRef)(null);
  var handleChange = (0,react.useCallback)(function (e) {
    onChange(e.target.value);
  }, [onChange]);
  var handleClear = (0,react.useCallback)(function () {
    onChange('');
    onClear();
  }, [onChange, onClear]);
  (0,react.useImperativeHandle)(ref, function () {
    return input.current;
  });
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Input$1, (0,common.a)({
    css: /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)(templateObject_1$1p || (templateObject_1$1p = (0,common._)(["\n        width: 100%;\n        input::-ms-clear {\n          display: none;\n        }\n      " + ( true ? "" : 0)], ["\n        width: 100%;\n        input::-ms-clear {\n          display: none;\n        }\n      " + ( true ? "" : 0)]))),
    forwardedRef: input,
    type: "text",
    size: 40,
    value: value,
    placeholder: placeholder,
    icon: "search",
    action: value ? {
      icon: 'dismiss_circle',
      type: 'button',
      onClick: handleClear
    } : undefined,
    onChange: handleChange
  }, props));
});
var templateObject_1$1p;

function Search(_a) {
  var id = _a.id,
    className = _a.className,
    pageKey = _a.pageKey,
    initialQuery = _a.initialQuery,
    placeholder = _a.placeholder,
    isInputAutoFocused = _a.isInputAutoFocused,
    isListBoxAlwaysOpened = _a.isListBoxAlwaysOpened,
    renderInputRight = _a.renderInputRight,
    fetchList = _a.fetchList,
    getItemQuery = _a.getItemQuery,
    renderListBox = _a.renderListBox,
    onSubmit = _a.onSubmit,
    onSubmitItem = _a.onSubmitItem,
    onInputBlur = _a.onInputBlur,
    onClear = _a.onClear,
    props = (0,common.e)(_a, ["id", "className", "pageKey", "initialQuery", "placeholder", "isInputAutoFocused", "isListBoxAlwaysOpened", "renderInputRight", "fetchList", "getItemQuery", "renderListBox", "onSubmit", "onSubmitItem", "onInputBlur", "onClear"]);
  var input = (0,react.useRef)(null);
  var _b = (0,hooks.u)(input, {
      pageKey: pageKey,
      query: '',
      initialQuery: initialQuery,
      isAlwaysFocused: isInputAutoFocused,
      onFetch: fetchList,
      getItemQuery: getItemQuery,
      onSubmit: onSubmit,
      onSubmitItem: onSubmitItem
    }),
    items = _b.items,
    isOpened = _b.isOpened,
    shownQuery = _b.shownQuery,
    hoveredIndex = _b.hoveredIndex,
    onInputFocus = _b.onInputFocus,
    onInputClick = _b.onInputClick,
    onInputChange = _b.onInputChange,
    onInputKeyDown = _b.onInputKeyDown,
    onReset = _b.onReset,
    onListClick = _b.onListClick,
    onListMouseEnter = _b.onListMouseEnter;
  var handleInputFocus = (0,react.useCallback)(function (e) {
    onInputFocus(e);
    if (props.onInputFocus) props.onInputFocus(e);
  }, [onInputFocus, props]);
  var handleInputChange = (0,react.useCallback)(function (value) {
    onInputChange(value);
    if (props.onInputChange) props.onInputChange(value);
  }, [onInputChange, props]);
  var handleInputBlur = (0,react.useCallback)(function (e) {
    onInputBlur === null || onInputBlur === void 0 ? void 0 : onInputBlur(e);
  }, [onInputBlur]);
  var handleInputClear = (0,react.useCallback)(function () {
    onReset === null || onReset === void 0 ? void 0 : onReset();
    onClear === null || onClear === void 0 ? void 0 : onClear();
  }, [onReset, onClear]);
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", (0,common.a)({
    className: className,
    css: /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)(templateObject_1$1o || (templateObject_1$1o = (0,common._)(["\n        position: relative;\n        display: flex;\n        flex-direction: column;\n        height: 100%;\n      " + ( true ? "" : 0)], ["\n        position: relative;\n        display: flex;\n        flex-direction: column;\n        height: 100%;\n      " + ( true ? "" : 0)])))
  }, {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", (0,common.a)({
      id: "".concat(id, "-combobox"),
      role: "combobox",
      "aria-expanded": isOpened,
      "aria-haspopup": "listbox",
      "aria-controls": isOpened ? "".concat(id, "-listbox") : undefined,
      css: /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)(templateObject_2$16 || (templateObject_2$16 = (0,common._)(["\n          display: flex;\n          width: 100%;\n        " + ( true ? "" : 0)], ["\n          display: flex;\n          width: 100%;\n        " + ( true ? "" : 0)])))
    }, {
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Input, {
        css: /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)(templateObject_3$Z || (templateObject_3$Z = (0,common._)(["\n            > input {\n              width: 100%;\n            }\n          " + ( true ? "" : 0)], ["\n            > input {\n              width: 100%;\n            }\n          " + ( true ? "" : 0)]))),
        ref: input,
        value: shownQuery,
        placeholder: placeholder,
        autoFocus: isInputAutoFocused,
        onFocus: handleInputFocus,
        onClick: onInputClick,
        onChange: handleInputChange,
        onKeyDown: onInputKeyDown,
        onBlur: handleInputBlur,
        onClear: handleInputClear,
        autoComplete: "off",
        "aria-autocomplete": "list"
      }), renderInputRight && renderInputRight()]
    })), (isListBoxAlwaysOpened || isOpened) && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", (0,common.a)({
      id: "".concat(id, "-listbox"),
      role: "listbox",
      css: /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)(templateObject_4$P || (templateObject_4$P = (0,common._)(["\n            min-height: 0;\n          " + ( true ? "" : 0)], ["\n            min-height: 0;\n          " + ( true ? "" : 0)])))
    }, {
      children: renderListBox({
        items: items,
        query: shownQuery,
        hoveredIndex: hoveredIndex,
        onItemClick: onListClick,
        onItemMouseEnter: onListMouseEnter
      })
    }))]
  }));
}
var templateObject_1$1o, templateObject_2$16, templateObject_3$Z, templateObject_4$P;

var HistoryStorageContext = /*#__PURE__*/(0,react.createContext)({});
var useHistoryStorage = function useHistoryStorage() {
  return useContext(HistoryStorageContext);
};
function HistoryStorageProvider(_a) {
  var children = _a.children,
    props = __rest(_a, ["children"]);
  return jsx(HistoryStorageContext.Provider, _assign({
    value: props
  }, {
    children: children
  }));
}

function cssVariant$3(theme, variant) {
  switch (variant) {
    case 'thin':
      return /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)(templateObject_1$1n || (templateObject_1$1n = (0,common._)(["\n        margin: 0;\n        padding: 0;\n        height: ", ";\n        border: none;\n        background-color: ", ";\n      " + ( true ? "" : 0)], ["\n        margin: 0;\n        padding: 0;\n        height: ", ";\n        border: none;\n        background-color: ", ";\n      " + ( true ? "" : 0)])), (0,foundation.p)(1), theme.divider);
    case 'thick':
      return /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)(templateObject_2$15 || (templateObject_2$15 = (0,common._)(["\n        margin: 0;\n        padding: 0;\n        height: ", ";\n        border: none;\n        background-color: ", ";\n      " + ( true ? "" : 0)], ["\n        margin: 0;\n        padding: 0;\n        height: ", ";\n        border: none;\n        background-color: ", ";\n      " + ( true ? "" : 0)])), (0,foundation.p)(10), theme.background.groupedBase);
  }
}
function Divider$1(_a) {
  var variant = _a.variant,
    rest = (0,common.e)(_a, ["variant"]);
  var theme = (0,emotion_element_5486c51c_browser_esm.u)();
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("hr", (0,common.a)({}, rest, {
    css: cssVariant$3(theme, variant)
  }));
}
var templateObject_1$1n, templateObject_2$15;

function HighlightedText(_a) {
  var item = _a.item,
    query = _a.query;
  var highlightedDisplay = item.value.highlightedDisplay;
  if (!query) return jsx(Fragment$1, {
    children: item.query
  });
  var parts = highlightedDisplay ? highlightedDisplay.split(/<strong>|<\/strong>/gi) : item.query.split(new RegExp("(".concat(query, ")"), 'gi'));
  return jsx(Fragment$1, {
    children: parts.map(function (part, index) {
      return jsx(Fragment, {
        children: index % 2 === 1 ? jsx("strong", {
          children: part
        }) : part
      }, index);
    })
  });
}
function KeywordItem(props) {
  return jsxs("div", _assign({
    css: /*#__PURE__*/css(templateObject_1$1m || (templateObject_1$1m = __makeTemplateObject(["\n        display: flex;\n        align-items: center;\n        white-space: nowrap;\n      " + ( true ? "" : 0)], ["\n        display: flex;\n        align-items: center;\n        white-space: nowrap;\n      " + ( true ? "" : 0)])))
  }, {
    children: [jsx(Icon, {
      name: "search",
      size: 18,
      fill: function fill(theme) {
        return theme.content.base1;
      },
      css: /*#__PURE__*/css(templateObject_2$14 || (templateObject_2$14 = __makeTemplateObject(["\n          width: ", ";\n          height: ", ";\n          display: flex;\n          align-items: center;\n          justify-content: center;\n          ", "\n        " + ( true ? "" : 0)], ["\n          width: ", ";\n          height: ", ";\n          display: flex;\n          align-items: center;\n          justify-content: center;\n          ", "\n        " + ( true ? "" : 0)])), pxToRem(32), pxToRem(32), MEDIA_QUERY.min('laptop', "\n            width: ".concat(pxToRem(24), ";\n            height: ").concat(pxToRem(24), ";\n          ")))
    }), jsx("div", _assign({
      css: /*#__PURE__*/css(templateObject_3$Y || (templateObject_3$Y = __makeTemplateObject(["\n          flex: 1;\n          text-overflow: ellipsis;\n          overflow: hidden;\n          margin-left: ", ";\n        " + ( true ? "" : 0)], ["\n          flex: 1;\n          text-overflow: ellipsis;\n          overflow: hidden;\n          margin-left: ", ";\n        " + ( true ? "" : 0)])), pxToRem(8))
    }, {
      children: jsx(HighlightedText, _assign({}, props))
    }))]
  }));
}
var templateObject_1$1m, templateObject_2$14, templateObject_3$Y;

function CategoryItem(props) {
  var theme = useTheme();
  return jsxs("div", _assign({
    css: /*#__PURE__*/css(templateObject_1$1l || (templateObject_1$1l = __makeTemplateObject(["\n        display: flex;\n        align-items: center;\n        justify-content: space-between;\n        white-space: nowrap;\n      " + ( true ? "" : 0)], ["\n        display: flex;\n        align-items: center;\n        justify-content: space-between;\n        white-space: nowrap;\n      " + ( true ? "" : 0)])))
  }, {
    children: [jsxs("div", _assign({
      css: /*#__PURE__*/css(templateObject_2$13 || (templateObject_2$13 = __makeTemplateObject(["\n          display: flex;\n          align-items: center;\n          overflow: hidden;\n        " + ( true ? "" : 0)], ["\n          display: flex;\n          align-items: center;\n          overflow: hidden;\n        " + ( true ? "" : 0)])))
    }, {
      children: [jsx(Icon, {
        css: /*#__PURE__*/css(templateObject_3$X || (templateObject_3$X = __makeTemplateObject(["\n            width: ", ";\n            height: ", ";\n            display: flex;\n            align-items: center;\n            justify-content: center;\n            ", "\n          " + ( true ? "" : 0)], ["\n            width: ", ";\n            height: ", ";\n            display: flex;\n            align-items: center;\n            justify-content: center;\n            ", "\n          " + ( true ? "" : 0)])), pxToRem(32), pxToRem(32), MEDIA_QUERY.min('laptop', "\n              width: ".concat(pxToRem(24), ";\n              height: ").concat(pxToRem(24), ";\n              min-width: ").concat(pxToRem(24), ";\n            "))),
        name: "search",
        size: 18,
        fill: function fill(theme) {
          return theme.content.base1;
        }
      }), jsx("div", _assign({
        css: /*#__PURE__*/css(templateObject_4$O || (templateObject_4$O = __makeTemplateObject(["\n            text-overflow: ellipsis;\n            overflow: hidden;\n            margin-left: ", ";\n          " + ( true ? "" : 0)], ["\n            text-overflow: ellipsis;\n            overflow: hidden;\n            margin-left: ", ";\n          " + ( true ? "" : 0)])), pxToRem(8))
      }, {
        children: jsx(HighlightedText, _assign({}, props))
      })), jsx("span", {
        css: /*#__PURE__*/css(templateObject_5$D || (templateObject_5$D = __makeTemplateObject(["\n            width: ", ";\n            height: ", ";\n            background: ", ";\n            margin: 0 ", ";\n          " + ( true ? "" : 0)], ["\n            width: ", ";\n            height: ", ";\n            background: ", ";\n            margin: 0 ", ";\n          " + ( true ? "" : 0)])), pxToRem(1), pxToRem(10), theme.content.base4, pxToRem(4))
      }), jsx("span", _assign({
        css: /*#__PURE__*/css(templateObject_6$v || (templateObject_6$v = __makeTemplateObject(["\n          ", "\n          margin-right: ", ";\n          color: ", ";\n          ", "\n        " + ( true ? "" : 0)], ["\n          ", "\n          margin-right: ", ";\n          color: ", ";\n          ", "\n        " + ( true ? "" : 0)])), FONT_STYLE.caption1, pxToRem(14), theme.content.base2, MEDIA_QUERY.min('laptop', "\n            ".concat(FONT_STYLE.caption2, "\n          ")))
      }, {
        children: "\uCE74\uD14C\uACE0\uB9AC"
      }))]
    })), jsx(Icon, {
      name: "chevron_right",
      size: 18,
      fill: function fill(theme) {
        return theme.content.base3;
      }
    })]
  }));
}
var templateObject_1$1l, templateObject_2$13, templateObject_3$X, templateObject_4$O, templateObject_5$D, templateObject_6$v;

var MAX_DEPTH = 2;
function CategoryHierarchy(_a) {
  var hierarchy = _a.hierarchy;
  var trailings = hierarchy.slice(-MAX_DEPTH);
  var theme = useTheme();
  return jsx("div", _assign({
    css: /*#__PURE__*/css(templateObject_1$1k || (templateObject_1$1k = __makeTemplateObject(["\n      display: flex;\n      flex-flow: row wrap;\n      align-items: center;\n      width: 100%;\n    " + ( true ? "" : 0)], ["\n      display: flex;\n      flex-flow: row wrap;\n      align-items: center;\n      width: 100%;\n    " + ( true ? "" : 0)])))
  }, {
    children: trailings.map(function (depth, index) {
      return jsxs(Fragment, {
        children: [jsx("span", _assign({
          css: /*#__PURE__*/css(templateObject_2$12 || (templateObject_2$12 = __makeTemplateObject(["\n            display: inline-block;\n            font-weight: bold;\n            line-height: 1.4;\n            &:last-of-type {\n              color: ", ";\n            }\n          " + ( true ? "" : 0)], ["\n            display: inline-block;\n            font-weight: bold;\n            line-height: 1.4;\n            &:last-of-type {\n              color: ", ";\n            }\n          " + ( true ? "" : 0)])), theme.content.primary1.thick)
        }, {
          children: depth
        })), index < trailings.length - 1 && jsx(Icon, {
          name: "chevron_right",
          size: 12,
          css: /*#__PURE__*/css(templateObject_3$W || (templateObject_3$W = __makeTemplateObject(["margin: 0 ", ";" + ( true ? "" : 0)], ["margin: 0 ", ";" + ( true ? "" : 0)])), pxToRem(6))
        })]
      }, index);
    })
  }));
}
var templateObject_1$1k, templateObject_2$12, templateObject_3$W;

function HistoryItem(_a) {
  var item = _a.item,
    hovered = _a.hovered;
  var theme = useTheme();
  var query = item.query,
    value = item.value;
  var historyStorage = useHistoryStorage();
  var handleDeleteClick = function handleDeleteClick(e) {
    e.stopPropagation();
    historyStorage.remove(value);
  };
  var renderItem = function renderItem() {
    var _a;
    var elem = query;
    if (_typeof(value) === 'object' && value.type === 'category') {
      // 기존 History 데이터가 undefined 인 경우가 있어, 옵셔널 값 추가
      var orgDisplay = (_a = value.value.orgDisplay) !== null && _a !== void 0 ? _a : '';
      elem = jsx(CategoryHierarchy, {
        hierarchy: orgDisplay.split('>').map(function (value) {
          return value.trim();
        })
      });
    }
    return jsx("span", _assign({
      css: /*#__PURE__*/css(templateObject_1$1j || (templateObject_1$1j = __makeTemplateObject(["\n          text-overflow: ellipsis;\n          overflow: hidden;\n        " + ( true ? "" : 0)], ["\n          text-overflow: ellipsis;\n          overflow: hidden;\n        " + ( true ? "" : 0)])))
    }, {
      children: elem
    }));
  };
  return jsxs("div", _assign({
    css: /*#__PURE__*/css(templateObject_3$V || (templateObject_3$V = __makeTemplateObject(["\n      display: flex;\n      align-items: center;\n      justify-content: space-between;\n      width: 100%;\n      padding: ", " 0;\n      box-sizing: border-box;\n      ", "\n    " + ( true ? "" : 0)], ["\n      display: flex;\n      align-items: center;\n      justify-content: space-between;\n      width: 100%;\n      padding: ", " 0;\n      box-sizing: border-box;\n      ", "\n    " + ( true ? "" : 0)])), pxToRem(4), MEDIA_QUERY.min('laptop', /*#__PURE__*/css(templateObject_2$11 || (templateObject_2$11 = __makeTemplateObject(["\n        padding: ", " ", ";\n      " + ( true ? "" : 0)], ["\n        padding: ", " ", ";\n      " + ( true ? "" : 0)])), pxToRem(4), pxToRem(4))))
  }, {
    children: [renderItem(), jsx("button", _assign({
      type: "button",
      onClick: handleDeleteClick,
      css: [/*#__PURE__*/css(templateObject_4$N || (templateObject_4$N = __makeTemplateObject(["\n            ", "\n            margin-right: ", ";\n            padding: ", ";\n            transition: .1s opacity;\n            font-size: 0;\n            line-height: 0;\n            border-radius: ", ";\n            outline: none;\n          " + ( true ? "" : 0)], ["\n            ", "\n            margin-right: ", ";\n            padding: ", ";\n            transition: .1s opacity;\n            font-size: 0;\n            line-height: 0;\n            border-radius: ", ";\n            outline: none;\n          " + ( true ? "" : 0)])), RESET_BUTTON, pxToRem(-6), pxToRem(6), pxToRem(2)), HOVER(templateObject_5$C || (templateObject_5$C = __makeTemplateObject(["\n            opacity: .4;\n          "], ["\n            opacity: .4;\n          "]))), FOCUS(templateObject_6$u || (templateObject_6$u = __makeTemplateObject(["\n            box-shadow: 0 0 0 ", " ", ";\n          "], ["\n            box-shadow: 0 0 0 ", " ", ";\n          "])), pxToRem(3), theme.interactive.primary1.thin)]
    }, {
      children: jsx(Icon, {
        name: "dismiss",
        size: 12,
        fill: function fill(theme) {
          return hovered ? theme.content.base2 : theme.content.base3;
        }
      })
    }))]
  }));
}
var templateObject_1$1j, templateObject_2$11, templateObject_3$V, templateObject_4$N, templateObject_5$C, templateObject_6$u;

function HorizontalImage(_a) {
  var className = _a.className,
    verticalRatio = _a.verticalRatio,
    horizontalRatio = _a.horizontalRatio,
    alt = _a.alt,
    rest = (0,common.e)(_a, ["className", "verticalRatio", "horizontalRatio", "alt"]);
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("figure", (0,common.a)({
    className: className
  }, {
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("img", (0,common.a)({}, rest, {
      alt: alt,
      height: 0,
      css: /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)(templateObject_1$1i || (templateObject_1$1i = (0,common._)(["\n          height: 0;\n          display: block;\n          visibility: hidden;\n          padding-top: ", "%;\n        " + ( true ? "" : 0)], ["\n          height: 0;\n          display: block;\n          visibility: hidden;\n          padding-top: ", "%;\n        " + ( true ? "" : 0)])), 100 / verticalRatio * horizontalRatio)
    }))
  }));
}
function VerticalImage(_a) {
  var className = _a.className,
    verticalRatio = _a.verticalRatio,
    horizontalRatio = _a.horizontalRatio,
    alt = _a.alt,
    rest = (0,common.e)(_a, ["className", "verticalRatio", "horizontalRatio", "alt"]);
  var _b = (0,react.useState)(0),
    clientHeight = _b[0],
    setClientHeight = _b[1];
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("figure", (0,common.a)({
    ref: function ref(el) {
      if (el) {
        setClientHeight(el.getBoundingClientRect().height);
      }
    },
    css: /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)(templateObject_2$10 || (templateObject_2$10 = (0,common._)(["\n        width: ", ";\n      " + ( true ? "" : 0)], ["\n        width: ", ";\n      " + ( true ? "" : 0)])), (0,foundation.p)(clientHeight / horizontalRatio * verticalRatio)),
    className: className
  }, {
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("img", (0,common.a)({}, rest, {
      alt: alt,
      width: 0,
      height: 0,
      css: /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)(templateObject_3$U || (templateObject_3$U = (0,common._)(["\n          width: 0;\n          height: 0;\n          visibility: hidden;\n        " + ( true ? "" : 0)], ["\n          width: 0;\n          height: 0;\n          visibility: hidden;\n        " + ( true ? "" : 0)])))
    }))
  }));
}
var templateObject_1$1i, templateObject_2$10, templateObject_3$U;

function Image(_a) {
  var _b = _a.src,
    src = _b === void 0 ? '' : _b,
    _c = _a.src2x,
    src2x = _c === void 0 ? src : _c,
    _d = _a.src3x,
    src3x = _d === void 0 ? src2x : _d,
    _e = _a.axis,
    axis = _e === void 0 ? 'width' : _e,
    _f = _a.radius,
    radius = _f === void 0 ? 0 : _f,
    aspectRatio = _a.aspectRatio,
    rest = (0,common.e)(_a, ["src", "src2x", "src3x", "axis", "radius", "aspectRatio"]);
  var _g = (0,react.useState)(''),
    url = _g[0],
    setUrl = _g[1];
  var imageCss = /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)(templateObject_1$1h || (templateObject_1$1h = (0,common._)(["\n    display: inline-block;\n    background: no-repeat 50% / cover;\n    border-radius: ", ";\n    background-image: url(", ");\n    @media only screen and (-webkit-min-device-pixel-ratio: 2),\n      only screen and (min--moz-device-pixel-ratio: 2),\n      only screen and (-o-min-device-pixel-ratio: 2/1),\n      only screen and (min-device-pixel-ratio: 2),\n      only screen and (min-resolution: 2dppx) {\n      background-image: url(", ");\n    }\n    @media only screen and (-webkit-min-device-pixel-ratio: 3),\n      only screen and (min--moz-device-pixel-ratio: 3),\n      only screen and (-o-min-device-pixel-ratio: 3/1),\n      only screen and (min-device-pixel-ratio: 3),\n      only screen and (min-resolution: 3dppx) {\n      background-image: url(", ");\n    }\n  " + ( true ? "" : 0)], ["\n    display: inline-block;\n    background: no-repeat 50% / cover;\n    border-radius: ", ";\n    background-image: url(", ");\n    @media only screen and (-webkit-min-device-pixel-ratio: 2),\n      only screen and (min--moz-device-pixel-ratio: 2),\n      only screen and (-o-min-device-pixel-ratio: 2/1),\n      only screen and (min-device-pixel-ratio: 2),\n      only screen and (min-resolution: 2dppx) {\n      background-image: url(", ");\n    }\n    @media only screen and (-webkit-min-device-pixel-ratio: 3),\n      only screen and (min--moz-device-pixel-ratio: 3),\n      only screen and (-o-min-device-pixel-ratio: 3/1),\n      only screen and (min-device-pixel-ratio: 3),\n      only screen and (min-resolution: 3dppx) {\n      background-image: url(", ");\n    }\n  " + ( true ? "" : 0)])), (0,foundation.p)(radius), src, src2x, src3x);
  var _h = aspectRatio.split(':').map(function (ratio) {
      return parseInt(ratio, 10);
    }),
    verticalRatio = _h[0],
    horizontalRatio = _h[1];
  (0,react.useEffect)(function () {
    switch (window.devicePixelRatio) {
      case 2:
        setUrl(src2x);
        break;
      case 3:
        setUrl(src3x);
        break;
      default:
        setUrl(src);
        break;
    }
  }, [src, src2x, src3x]);
  return axis === 'width' ? (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(HorizontalImage, (0,common.a)({}, rest, {
    src: url,
    verticalRatio: verticalRatio,
    horizontalRatio: horizontalRatio,
    css: imageCss
  })) : (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(VerticalImage, (0,common.a)({}, rest, {
    src: url,
    verticalRatio: verticalRatio,
    horizontalRatio: horizontalRatio,
    css: imageCss
  }));
}
var templateObject_1$1h;

function CircleImage(_a) {
  var rest = (0,common.e)(_a, []);
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Image, (0,common.a)({}, rest, {
    aspectRatio: "1:1",
    css: /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)(templateObject_1$1g || (templateObject_1$1g = (0,common._)(["\n        border-radius: 50%;\n      " + ( true ? "" : 0)], ["\n        border-radius: 50%;\n      " + ( true ? "" : 0)])))
  }));
}
var templateObject_1$1g;

function ConsultingItem(props) {
  var value = props.item.value;
  var theme = useTheme();
  var cta = " ".concat(value.info.cta);
  return jsxs("div", _assign({
    css: /*#__PURE__*/css(templateObject_1$1f || (templateObject_1$1f = __makeTemplateObject(["\n        display: flex;\n        align-items: center;\n        justify-content: space-between;\n        white-space: nowrap;\n      " + ( true ? "" : 0)], ["\n        display: flex;\n        align-items: center;\n        justify-content: space-between;\n        white-space: nowrap;\n      " + ( true ? "" : 0)])))
  }, {
    children: [jsxs("div", _assign({
      css: /*#__PURE__*/css(templateObject_2$$ || (templateObject_2$$ = __makeTemplateObject(["\n          display: flex;\n          align-items: center;\n          overflow: hidden;\n        " + ( true ? "" : 0)], ["\n          display: flex;\n          align-items: center;\n          overflow: hidden;\n        " + ( true ? "" : 0)])))
    }, {
      children: [jsx("div", _assign({
        css: /*#__PURE__*/css(templateObject_3$T || (templateObject_3$T = __makeTemplateObject(["\n            width: ", ";\n            height: ", ";\n            display: flex;\n            align-items: center;\n            justify-content: center;\n            ", "\n          " + ( true ? "" : 0)], ["\n            width: ", ";\n            height: ", ";\n            display: flex;\n            align-items: center;\n            justify-content: center;\n            ", "\n          " + ( true ? "" : 0)])), pxToRem(32), pxToRem(32), MEDIA_QUERY.min('laptop', "\n              width: ".concat(pxToRem(24), ";\n              height: ").concat(pxToRem(24), ";\n            ")))
      }, {
        children: value.info.iconFileUrl ? jsx(CircleImage, {
          src: value.info.iconFileUrl,
          css: /*#__PURE__*/css(templateObject_4$M || (templateObject_4$M = __makeTemplateObject(["\n                  width: 100%;\n                  border: ", " solid ", ";\n                " + ( true ? "" : 0)], ["\n                  width: 100%;\n                  border: ", " solid ", ";\n                " + ( true ? "" : 0)])), pxToRem(0.5), theme.outline)
        }) : jsx(Icon, {
          name: "search",
          size: 18,
          fill: function fill(theme) {
            return theme.content.base1;
          }
        })
      })), jsxs("div", _assign({
        css: /*#__PURE__*/css(templateObject_5$B || (templateObject_5$B = __makeTemplateObject(["\n            flex: 1;\n            white-space: nowrap;\n            text-overflow: ellipsis;\n            overflow: hidden;\n            margin-left: ", ";\n          " + ( true ? "" : 0)], ["\n            flex: 1;\n            white-space: nowrap;\n            text-overflow: ellipsis;\n            overflow: hidden;\n            margin-left: ", ";\n          " + ( true ? "" : 0)])), pxToRem(8))
      }, {
        children: [jsx(HighlightedText, _assign({}, props)), cta]
      }))]
    })), jsx(Icon, {
      name: "chevron_right",
      size: 18,
      fill: function fill(theme) {
        return theme.content.base3;
      }
    })]
  }));
}
var templateObject_1$1f, templateObject_2$$, templateObject_3$T, templateObject_4$M, templateObject_5$B;

function ListBoxItem(_a) {
  var item = _a.item,
    hovered = _a.hovered,
    query = _a.query,
    _b = _a.showDivider,
    showDivider = _b === void 0 ? false : _b,
    onHover = _a.onHover,
    props = __rest(_a, ["item", "hovered", "query", "showDivider", "onHover"]);
  var theme = useTheme();
  var ref = useRef(null);
  var renderItem = function renderItem() {
    switch (item.type) {
      case 'query':
        return jsx(KeywordItem, {
          item: item,
          query: query
        });
      case 'category':
        return jsx(CategoryItem, {
          item: item,
          query: query
        });
      case 'consulting':
        return jsx(ConsultingItem, {
          item: item,
          query: query
        });
      case 'history':
        return jsx(HistoryItem, {
          item: item,
          hovered: hovered
        });
      default:
        return null;
    }
  };
  useEffect(function () {
    if (!hovered || !ref.current) return;
    onHover(ref.current);
  }, [hovered, onHover]);
  return jsxs(Fragment$1, {
    children: [jsx("li", _assign({
      ref: ref,
      role: "option",
      "aria-selected": undefined,
      css: [/*#__PURE__*/css(templateObject_2$_ || (templateObject_2$_ = __makeTemplateObject(["\n            ", "\n            position: relative;\n            margin: 0;\n            padding: ", " ", ";\n            color: ", ";\n            line-height: ", ";\n            cursor: pointer;\n            border-radius: ", ";\n            outline: none;\n            strong {\n              color: ", ";\n              font-weight: 400;\n            }\n            ", "\n            ", "\n          " + ( true ? "" : 0)], ["\n            ", "\n            position: relative;\n            margin: 0;\n            padding: ", " ", ";\n            color: ", ";\n            line-height: ", ";\n            cursor: pointer;\n            border-radius: ", ";\n            outline: none;\n            strong {\n              color: ", ";\n              font-weight: 400;\n            }\n            ", "\n            ", "\n          " + ( true ? "" : 0)])), FONT_STYLE.subTitle1, pxToRem(8), pxToRem(16), theme.content.base1, pxToRem(21), pxToRem(2), theme.content.primary1.thick, hovered && "background: ".concat(theme.background.groupedBase, ";"), MEDIA_QUERY.min('laptop', /*#__PURE__*/css(templateObject_1$1e || (templateObject_1$1e = __makeTemplateObject(["\n              ", "\n              padding: ", ";\n            " + ( true ? "" : 0)], ["\n              ", "\n              padding: ", ";\n            " + ( true ? "" : 0)])), FONT_STYLE.subTitle2, pxToRem(8)))), FOCUS(templateObject_3$S || (templateObject_3$S = __makeTemplateObject(["\n          background: ", ";\n        "], ["\n          background: ", ";\n        "])), theme.background.groupedBase)],
      tabIndex: 0
    }, props, {
      children: renderItem()
    })), showDivider && jsx(Divider$1, {
      css: /*#__PURE__*/css(templateObject_4$L || (templateObject_4$L = __makeTemplateObject(["\n            margin: ", " 0;\n            ", "\n          " + ( true ? "" : 0)], ["\n            margin: ", " 0;\n            ", "\n          " + ( true ? "" : 0)])), pxToRem(8), MEDIA_QUERY.min('laptop', "\n              margin: ".concat(pxToRem(10), " 0;\n            "))),
      variant: "thin"
    })]
  });
}
var templateObject_1$1e, templateObject_2$_, templateObject_3$S, templateObject_4$L;

function filterOnlyHistoryKeyword(items) {
  return items.filter(function (item) {
    return item.type === 'history' && typeof item.value !== 'string' && item.value.type === 'query';
  });
}
function ListBox(_a) {
  var items = _a.items,
    query = _a.query,
    hoveredIndex = _a.hoveredIndex,
    isHistoryList = _a.isHistoryList,
    onItemClick = _a.onItemClick,
    onItemMouseEnter = _a.onItemMouseEnter;
  var theme = useTheme();
  var container = useRef(null);
  var log = useLogContext();
  var handleIntersect = useCallback(function () {
    if (filterOnlyHistoryKeyword(items).length > 0) {
      log({
        key: 'primary.right.search.history',
        category: 'impression',
        params: {
          type: 'keyword'
        }
      });
    }
  }, [items, log]);
  var isShowDivider = useCallback(function (item, index) {
    return index < items.length - 1 && items[index + 1].type !== item.type;
  }, [items]);
  var handleItemHover = useCallback(function (item) {
    if (!container.current) return;
    container.current.scrollTop = item.offsetTop - (container.current.offsetHeight - item.offsetHeight) / 2;
  }, []);
  var handleItemClick = useCallback(function (item, index) {
    return function () {
      return onItemClick(item, index);
    };
  }, [onItemClick]);
  var handleItemMouseEnter = useCallback(function (item, index) {
    return function () {
      return onItemMouseEnter(item, index);
    };
  }, [onItemMouseEnter]);
  return jsx(IntersectionObserver, _assign({
    onIntersect: handleIntersect
  }, {
    children: jsxs("div", _assign({
      ref: container,
      css: /*#__PURE__*/css(templateObject_1$1d || (templateObject_1$1d = __makeTemplateObject(["\n        overflow-y: auto;\n        position: relative;\n        width: 100%;\n        padding: ", " 0;\n        border: ", " solid ", ";\n        border-radius: ", ";\n        background: ", ";\n        box-shadow: 0 ", " ", " 0 ", ";\n        box-sizing: border-box;\n        ", "\n        ", "\n        ", "\n      " + ( true ? "" : 0)], ["\n        overflow-y: auto;\n        position: relative;\n        width: 100%;\n        padding: ", " 0;\n        border: ", " solid ", ";\n        border-radius: ", ";\n        background: ", ";\n        box-shadow: 0 ", " ", " 0 ", ";\n        box-sizing: border-box;\n        ", "\n        ", "\n        ", "\n      " + ( true ? "" : 0)])), pxToRem(10), pxToRem(1), theme.divider, pxToRem(4), theme.background.base, pxToRem(4), pxToRem(6), theme.shadow.basic, MEDIA_QUERY.min('laptop', "\n          position: absolute;\n          top: calc(100% + ".concat(pxToRem(4), ");\n          left: 0;\n          max-height: ").concat(pxToRem(400), ";\n        ")), MEDIA_QUERY.only('tablet', "\n          top: ".concat(pxToRem(4), ";\n          height: 100%;\n        ")), MEDIA_QUERY.only('mobile', "\n          height: 100%;\n          padding: ".concat(pxToRem(8), " 0;\n          border: 0;\n          box-shadow: none;\n        ")))
    }, {
      children: [!isHistoryList && jsx(HistoryListBoxHeader, {
        hasDeleteButton: items.length > 0
      }), items.length > 0 ? jsx("ul", _assign({
        css: /*#__PURE__*/css(templateObject_2$Z || (templateObject_2$Z = __makeTemplateObject(["\n              margin: 0;\n              padding: 0;\n            " + ( true ? "" : 0)], ["\n              margin: 0;\n              padding: 0;\n            " + ( true ? "" : 0)])))
      }, {
        children: items.map(function (item, index) {
          return jsx(ListBoxItem, {
            item: item,
            query: query,
            hovered: hoveredIndex === index,
            showDivider: isShowDivider(item, index),
            onHover: handleItemHover,
            onClick: handleItemClick(item, index),
            onMouseEnter: handleItemMouseEnter(item, index)
          }, "".concat(item.query).concat(index));
        })
      })) : jsx("p", _assign({
        css: /*#__PURE__*/css(templateObject_3$R || (templateObject_3$R = __makeTemplateObject(["\n            margin: 0;\n            padding: ", " ", ";\n            color: ", ";\n            font-size: ", ";\n            line-height: 1.4;\n          " + ( true ? "" : 0)], ["\n            margin: 0;\n            padding: ", " ", ";\n            color: ", ";\n            font-size: ", ";\n            line-height: 1.4;\n          " + ( true ? "" : 0)])), pxToRem(10), pxToRem(16), theme.content.base3, pxToRem(15))
      }, {
        children: "\uCD5C\uADFC \uAC80\uC0C9\uD55C \uB0B4\uC5ED\uC774 \uC5C6\uC2B5\uB2C8\uB2E4."
      }))]
    }))
  }));
}
function HistoryListBoxHeader(_a) {
  var hasDeleteButton = _a.hasDeleteButton;
  var theme = useTheme();
  var historyStorage = useHistoryStorage();
  return jsxs("div", _assign({
    css: /*#__PURE__*/css(templateObject_4$K || (templateObject_4$K = __makeTemplateObject(["\n        display: flex;\n        align-items: center;\n        justify-content: space-between;\n        padding: ", " ", " ", ";\n        font-size: ", ";\n        line-height: ", ";\n      " + ( true ? "" : 0)], ["\n        display: flex;\n        align-items: center;\n        justify-content: space-between;\n        padding: ", " ", " ", ";\n        font-size: ", ";\n        line-height: ", ";\n      " + ( true ? "" : 0)])), pxToRem(7), pxToRem(8), pxToRem(10), pxToRem(15), pxToRem(21))
  }, {
    children: [jsx("span", _assign({
      css: /*#__PURE__*/css(templateObject_5$A || (templateObject_5$A = __makeTemplateObject(["\n          font-size: ", ";\n          color: ", ";\n        " + ( true ? "" : 0)], ["\n          font-size: ", ";\n          color: ", ";\n        " + ( true ? "" : 0)])), pxToRem(13), theme.content.base2)
    }, {
      children: "\uCD5C\uADFC \uAC80\uC0C9\uC5B4"
    })), hasDeleteButton && jsx("button", _assign({
      type: "button",
      onClick: historyStorage.removeAll,
      css: [/*#__PURE__*/css(templateObject_6$t || (templateObject_6$t = __makeTemplateObject(["\n              ", "\n              margin: ", ";\n              padding: ", ";\n              font-size: ", ";\n              color: ", ";\n              border-radius: ", ";\n              outline: none;\n              transition: .1s opacity;\n            " + ( true ? "" : 0)], ["\n              ", "\n              margin: ", ";\n              padding: ", ";\n              font-size: ", ";\n              color: ", ";\n              border-radius: ", ";\n              outline: none;\n              transition: .1s opacity;\n            " + ( true ? "" : 0)])), RESET_BUTTON, pxToRem(-2), pxToRem(2), pxToRem(12), theme.content.base2, pxToRem(2)), HOVER(templateObject_7$o || (templateObject_7$o = __makeTemplateObject(["\n              opacity: .4;\n            "], ["\n              opacity: .4;\n            "]))), FOCUS(templateObject_8$i || (templateObject_8$i = __makeTemplateObject(["\n              box-shadow: 0 0 0 ", " ", ";\n            "], ["\n              box-shadow: 0 0 0 ", " ", ";\n            "])), pxToRem(3), theme.interactive.primary1.thin)]
    }, {
      children: "\uC804\uCCB4 \uC0AD\uC81C"
    }))]
  }));
}
var templateObject_1$1d, templateObject_2$Z, templateObject_3$R, templateObject_4$K, templateObject_5$A, templateObject_6$t, templateObject_7$o, templateObject_8$i;

function getSearchPlaceholder(searchType) {
  return searchType === 'store' && '쇼핑 검색' || searchType === 'expert_user' && '시공업체 검색' || '통합검색';
}

function NavigationSearch(_a) {
  var _this = this;
  var searchType = _a.searchType,
    initialQuery = _a.initialQuery,
    onFetch = _a.onFetch,
    onSubmit = _a.onSubmit,
    onSubmitItem = _a.onSubmitItem,
    onInputFocus = _a.onInputFocus,
    historyStorage = _a.historyStorage,
    placeholder = _a.placeholder,
    props = __rest(_a, ["searchType", "initialQuery", "onFetch", "onSubmit", "onSubmitItem", "onInputFocus", "historyStorage", "placeholder"]);
  var _b = useState(null),
    pageKey = _b[0],
    setPageKey = _b[1];
  var _c = useState(initialQuery),
    manuallyTypedInputValue = _c[0],
    setManuallyTypedInputValue = _c[1];
  var fetchListFromSearchHistory = useCallback(function () {
    var history = historyStorage.get();
    return history.map(function (value) {
      return {
        type: 'history',
        value: value,
        query: typeof value === 'string' ? value : value.query
      };
    });
  }, [historyStorage]);
  var fetchList = useCallback(function (query) {
    return __awaiter(_this, void 0, void 0, function () {
      return __generator(this, function (_a) {
        if (!manuallyTypedInputValue) {
          return [2 /*return*/, fetchListFromSearchHistory()];
        }
        return [2 /*return*/, onFetch(query)];
      });
    });
  }, [manuallyTypedInputValue, fetchListFromSearchHistory, onFetch]);
  var handleHistoryUpdate = useCallback(function () {
    setPageKey(_assign(_assign({}, window.location), {
      timestamp: new Date().getTime()
    }));
  }, []);
  var handleSubmit = useCallback(function (value) {
    historyStorage.append(value);
    if (onSubmit) onSubmit(value);
  }, [historyStorage, onSubmit]);
  var log = useLogContext();
  var logAutocompleteKeyword = useCallback(function (item, index) {
    var params = {
      type: item.type,
      index: index,
      id: item.query
    };
    if (item.type === 'history' && typeof item.value !== 'string') {
      log({
        key: 'primary.right.search.history',
        category: 'click',
        params: _assign(_assign({}, params), {
          type: item.value.type
        })
      });
    }
    if (item.type === 'category' || item.type === 'query') {
      log({
        key: "primary.right.search.autocomplete.".concat(item.type),
        category: 'click',
        params: params
      });
    }
  }, [log]);
  var handleSubmitItem = useCallback(function (item, index) {
    var value = item.type === 'history' ? item.value : item;
    historyStorage.append(value);
    if (onSubmitItem) onSubmitItem(item);
    logAutocompleteKeyword(item, index);
  }, [historyStorage, onSubmitItem, logAutocompleteKeyword]);
  var handleInputFocus = useCallback(function (e) {
    if (onInputFocus) onInputFocus(e);
    log({
      key: 'primary.right.search.input',
      category: 'click',
      params: {
        search_type: searchType
      }
    });
  }, [onInputFocus, log, searchType]);
  return jsx(HistoryStorageProvider, _assign({
    get: historyStorage.get,
    set: function set(histories) {
      historyStorage.set(histories);
      handleHistoryUpdate();
    },
    append: function append(history) {
      historyStorage.append(history);
      handleHistoryUpdate();
    },
    remove: function remove(history) {
      historyStorage.remove(history);
      handleHistoryUpdate();
    },
    removeAll: function removeAll() {
      historyStorage.removeAll();
      handleHistoryUpdate();
    }
  }, {
    children: jsx(Search, _assign({
      id: "global-search",
      pageKey: pageKey,
      initialQuery: initialQuery,
      placeholder: placeholder !== null && placeholder !== void 0 ? placeholder : getSearchPlaceholder(searchType),
      fetchList: fetchList,
      getItemQuery: function getItemQuery(item) {
        return item.query;
      },
      renderListBox: function renderListBox(props) {
        return jsx(ListBox, _assign({}, props, {
          isHistoryList: !!manuallyTypedInputValue
        }));
      },
      onSubmit: handleSubmit,
      onSubmitItem: handleSubmitItem,
      onInputFocus: handleInputFocus,
      onInputChange: setManuallyTypedInputValue
    }, props))
  }));
}

var KEYFRAMES = {
  overlay: (0,emotion_react_browser_esm/* keyframes */.F4)(templateObject_1$1c || (templateObject_1$1c = (0,common._)(["\n    from {\n      opacity: 0;\n    }\n    to {\n      opacity: 1;\n    }\n  "], ["\n    from {\n      opacity: 0;\n    }\n    to {\n      opacity: 1;\n    }\n  "]))),
  drawer: (0,emotion_react_browser_esm/* keyframes */.F4)(templateObject_2$Y || (templateObject_2$Y = (0,common._)(["\n    from {\n      transform: translateX(-100%);\n    }\n    to {\n      transform: translateX(0);\n    }\n  "], ["\n    from {\n      transform: translateX(-100%);\n    }\n    to {\n      transform: translateX(0);\n    }\n  "])))
};
var Animation = {
  open: 'open',
  close: 'close'
};
function Drawer(_a) {
  var open = _a.open,
    _b = _a.align,
    align = _b === void 0 ? 'left' : _b,
    width = _a.width,
    padding = _a.padding,
    animationKeyframes = _a.animationKeyframes,
    containerCss = _a.containerCss,
    children = _a.children,
    onClose = _a.onClose,
    onClosed = _a.onClosed;
  var theme = (0,emotion_element_5486c51c_browser_esm.u)();
  var scrollAvailableRef = (0,react.useRef)(null);
  var _c = (0,react.useState)(undefined),
    animation = _c[0],
    setAnimation = _c[1];
  var _d = (0,react.useState)(open),
    visible = _d[0],
    setVisible = _d[1];
  (0,react.useEffect)(function () {
    setAnimation(open ? Animation.open : Animation.close);
  }, [open]);
  (0,react.useEffect)(function () {
    if (open) {
      setVisible(true);
    }
  }, [open]);
  var overlayAnimation = (animationKeyframes === null || animationKeyframes === void 0 ? void 0 : animationKeyframes.overlay) || KEYFRAMES.overlay;
  var drawerAnimation = (animationKeyframes === null || animationKeyframes === void 0 ? void 0 : animationKeyframes.drawer) || KEYFRAMES.drawer;
  var handleNavigationClose = (0,react.useCallback)(function () {
    onClose();
  }, [onClose]);
  var handleAnimationEnd = (0,react.useCallback)(function () {
    if (animation === Animation.open) {
      setAnimation(undefined);
    }
    if (animation === Animation.close) {
      setVisible(false);
      onClosed === null || onClosed === void 0 ? void 0 : onClosed();
    }
  }, [animation, onClosed]);
  if (!visible) {
    return null;
  }
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(common.h, {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(lib_esm/* ScrollLock */.tH, {
      enabled: open,
      getElement: function getElement() {
        return scrollAvailableRef.current;
      }
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Dim, (0,common.a)({
      ref: scrollAvailableRef,
      variant: "basic",
      onClick: handleNavigationClose,
      css: /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)(templateObject_5$z || (templateObject_5$z = (0,common._)(["\n          ", "\n          ", "\n        " + ( true ? "" : 0)], ["\n          ", "\n          ", "\n        " + ( true ? "" : 0)])), animation === Animation.open && /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)(templateObject_3$Q || (templateObject_3$Q = (0,common._)(["\n            animation: ", " .2s forwards;\n          " + ( true ? "" : 0)], ["\n            animation: ", " .2s forwards;\n          " + ( true ? "" : 0)])), overlayAnimation), animation === Animation.close && /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)(templateObject_4$J || (templateObject_4$J = (0,common._)(["\n            pointer-events: none;\n            animation: ", " .2s reverse forwards;\n          " + ( true ? "" : 0)], ["\n            pointer-events: none;\n            animation: ", " .2s reverse forwards;\n          " + ( true ? "" : 0)])), overlayAnimation))
    }, {
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", (0,common.a)({
        onClick: function onClick(e) {
          return e.stopPropagation();
        },
        onAnimationEnd: handleAnimationEnd,
        css: [/*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)(templateObject_8$h || (templateObject_8$h = (0,common._)(["\n              position: absolute;\n              overflow-y: auto;\n              top: 0;\n              bottom: 0;\n              ", ";\n              width: ", ";\n              height: 100%;\n              padding: ", ";\n              box-sizing: border-box;\n              background: ", ";\n              text-align: left;\n              ", "\n              ", "\n            " + ( true ? "" : 0)], ["\n              position: absolute;\n              overflow-y: auto;\n              top: 0;\n              bottom: 0;\n              ", ";\n              width: ", ";\n              height: 100%;\n              padding: ", ";\n              box-sizing: border-box;\n              background: ", ";\n              text-align: left;\n              ", "\n              ", "\n            " + ( true ? "" : 0)])), align === 'left' ? 'left: 0' : 'right: 0', width != null ? "".concat(width, "px") : '100%', padding != null ? "".concat(padding[0], " ").concat(padding[1]) : "".concat((0,foundation.p)(26), " ").concat((0,foundation.p)(16)), theme.background.base, animation === Animation.open && /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)(templateObject_6$s || (templateObject_6$s = (0,common._)(["\n                animation: ", " .3s forwards;\n              " + ( true ? "" : 0)], ["\n                animation: ", " .3s forwards;\n              " + ( true ? "" : 0)])), drawerAnimation), animation === Animation.close && /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)(templateObject_7$n || (templateObject_7$n = (0,common._)(["\n                animation: ", " .3s reverse forwards;\n              " + ( true ? "" : 0)], ["\n                animation: ", " .3s reverse forwards;\n              " + ( true ? "" : 0)])), drawerAnimation)), containerCss]
      }, {
        children: children
      }))
    }))]
  });
}
var templateObject_1$1c, templateObject_2$Y, templateObject_3$Q, templateObject_4$J, templateObject_5$z, templateObject_6$s, templateObject_7$n, templateObject_8$h;

var slideIn = (0,emotion_react_browser_esm/* keyframes */.F4)(templateObject_1$1b || (templateObject_1$1b = (0,common._)(["\n  from {\n    transform: translateX(50px);\n  }\n  to {\n    transform: translateX(0);\n  }\n"], ["\n  from {\n    transform: translateX(50px);\n  }\n  to {\n    transform: translateX(0);\n  }\n"])));
function SearchDrawer(_a) {
  var className = _a.className,
    onSubmit = _a.onSubmit,
    onSubmitItem = _a.onSubmitItem,
    searchProps = __rest(_a, ["className", "onSubmit", "onSubmitItem"]);
  var theme = useTheme();
  var _b = useState(false),
    open = _b[0],
    setOpen = _b[1];
  var drawerAnimation = {
    drawer: slideIn
  };
  var handleDrawerOpen = useCallback(function () {
    setOpen(true);
  }, []);
  var handleDrawerClose = useCallback(function () {
    setOpen(false);
  }, []);
  var handleSubmit = useCallback(function (value) {
    setOpen(false);
    onSubmit === null || onSubmit === void 0 ? void 0 : onSubmit(value);
  }, [onSubmit]);
  var handleSubmitItem = useCallback(function (item) {
    setOpen(false);
    onSubmitItem === null || onSubmitItem === void 0 ? void 0 : onSubmitItem(item);
  }, [onSubmitItem]);
  return jsxs("div", _assign({
    css: className
  }, {
    children: [jsx("button", _assign({
      type: "button",
      css: [/*#__PURE__*/css(templateObject_2$X || (templateObject_2$X = __makeTemplateObject(["\n            ", "\n            padding: ", ";\n            margin: ", " ", ";\n            color: ", ";\n            line-height: 0;\n            outline: none;\n          " + ( true ? "" : 0)], ["\n            ", "\n            padding: ", ";\n            margin: ", " ", ";\n            color: ", ";\n            line-height: 0;\n            outline: none;\n          " + ( true ? "" : 0)])), RESET_BUTTON, pxToRem(6), pxToRem(3), pxToRem(1), theme.content.base1), HOVER(templateObject_3$P || (templateObject_3$P = __makeTemplateObject(["\n            color: ", ";\n          "], ["\n            color: ", ";\n          "])), theme.content.primary1.basic), FOCUS(templateObject_4$I || (templateObject_4$I = __makeTemplateObject(["\n            color: ", ";\n          "], ["\n            color: ", ";\n          "])), theme.content.primary1.basic)],
      onClick: handleDrawerOpen
    }, {
      children: jsx(Icon, {
        name: "search",
        size: 24
      })
    })), jsx(Drawer, _assign({
      open: open,
      align: "right",
      onClose: handleDrawerClose,
      animationKeyframes: drawerAnimation,
      containerCss: /*#__PURE__*/css(templateObject_5$y || (templateObject_5$y = __makeTemplateObject(["\n          ", "\n          ", "\n        " + ( true ? "" : 0)], ["\n          ", "\n          ", "\n        " + ( true ? "" : 0)])), safeAreaInset('bottom', 'padding-bottom'), MEDIA_QUERY.min('tablet', "\n            min-width: ".concat(pxToRem(256), ";\n            max-width: ").concat(pxToRem(326), ";\n            padding: ").concat(pxToRem(30), ";\n          ")))
    }, {
      children: jsx(NavigationSearch, _assign({}, searchProps, {
        onSubmit: handleSubmit,
        onSubmitItem: handleSubmitItem,
        isInputAutoFocused: true,
        renderInputRight: function renderInputRight() {
          return jsx("button", _assign({
            type: "button",
            onClick: handleDrawerClose,
            css: [/*#__PURE__*/css(templateObject_6$r || (templateObject_6$r = __makeTemplateObject(["\n                  ", "\n                  flex-shrink: 0;\n                  margin-left: ", ";\n                  padding: ", " ", " ", ";\n                  color: ", ";\n                  font-size: ", ";\n                  line-height: 1;\n                  font-weight: 700;\n                  outline: none;\n                  ", "\n                " + ( true ? "" : 0)], ["\n                  ", "\n                  flex-shrink: 0;\n                  margin-left: ", ";\n                  padding: ", " ", " ", ";\n                  color: ", ";\n                  font-size: ", ";\n                  line-height: 1;\n                  font-weight: 700;\n                  outline: none;\n                  ", "\n                " + ( true ? "" : 0)])), RESET_BUTTON, pxToRem(15), pxToRem(9), pxToRem(5), pxToRem(10), theme.content.base1, pxToRem(15), MEDIA_QUERY.min('tablet', "\n                    display: none;\n                  ")), FOCUS(templateObject_7$m || (templateObject_7$m = __makeTemplateObject(["\n                  & > span {\n                    box-shadow: 0 0 0 ", " ", ";\n                  }\n                "], ["\n                  & > span {\n                    box-shadow: 0 0 0 ", " ", ";\n                  }\n                "])), pxToRem(3), theme.interactive.primary1.thin)]
          }, {
            children: jsx("span", _assign({
              css: /*#__PURE__*/css(templateObject_8$g || (templateObject_8$g = __makeTemplateObject(["\n                display: inline-block;\n                margin: ", ";\n                padding: ", ";\n                border-radius: ", ";\n              " + ( true ? "" : 0)], ["\n                display: inline-block;\n                margin: ", ";\n                padding: ", ";\n                border-radius: ", ";\n              " + ( true ? "" : 0)])), pxToRem(-4), pxToRem(4), pxToRem(2))
            }, {
              children: "\uCDE8\uC18C"
            }))
          }));
        }
      }))
    }))]
  }));
}
var templateObject_1$1b, templateObject_2$X, templateObject_3$P, templateObject_4$I, templateObject_5$y, templateObject_6$r, templateObject_7$m, templateObject_8$g;

function UploadDropdownContentItem(_a) {
  var href = _a.href,
    icon = _a.icon,
    title = _a.title,
    subtitle = _a.subtitle,
    logId = _a.logId;
  var theme = useTheme();
  var LinkComponent = useLinkContext();
  var log = useLogContext();
  return jsxs(LinkComponent, _assign({
    href: href,
    css: [/*#__PURE__*/css(templateObject_1$1a || (templateObject_1$1a = __makeTemplateObject(["\n          display: flex;\n          align-items: center;\n          padding: ", ";\n          background-color: ", ";\n          border-radius: ", ";\n          transition: .1s background-color;\n          word-break: keep-all;\n          white-space: nowrap;\n          font-size: ", ";\n          line-height: 0;\n          outline: none;\n        " + ( true ? "" : 0)], ["\n          display: flex;\n          align-items: center;\n          padding: ", ";\n          background-color: ", ";\n          border-radius: ", ";\n          transition: .1s background-color;\n          word-break: keep-all;\n          white-space: nowrap;\n          font-size: ", ";\n          line-height: 0;\n          outline: none;\n        " + ( true ? "" : 0)])), pxToRem(15), theme.background.base, pxToRem(2), pxToRem(15)), HOVER(templateObject_2$W || (templateObject_2$W = __makeTemplateObject(["\n          background-color: ", ";\n        "], ["\n          background-color: ", ";\n        "])), theme.background.groupedBase), FOCUS(templateObject_3$O || (templateObject_3$O = __makeTemplateObject(["\n          background-color: ", ";\n        "], ["\n          background-color: ", ";\n        "])), theme.background.groupedBase)],
    onClick: function onClick() {
      if (logId) {
        log({
          key: logId,
          category: 'click'
        });
      }
    }
  }, {
    children: [jsx("div", _assign({
      css: /*#__PURE__*/css(templateObject_4$H || (templateObject_4$H = __makeTemplateObject(["\n          position: relative;\n        " + ( true ? "" : 0)], ["\n          position: relative;\n        " + ( true ? "" : 0)])))
    }, {
      children: icon
    })), jsxs("div", _assign({
      css: /*#__PURE__*/css(templateObject_5$x || (templateObject_5$x = __makeTemplateObject(["\n          margin-left: ", ";\n        " + ( true ? "" : 0)], ["\n          margin-left: ", ";\n        " + ( true ? "" : 0)])), pxToRem(12))
    }, {
      children: [jsx("div", _assign({
        css: /*#__PURE__*/css(templateObject_6$q || (templateObject_6$q = __makeTemplateObject(["\n            font-size: ", ";\n            font-weight: bold;\n            line-height: ", ";\n            color: ", ";\n          " + ( true ? "" : 0)], ["\n            font-size: ", ";\n            font-weight: bold;\n            line-height: ", ";\n            color: ", ";\n          " + ( true ? "" : 0)])), pxToRem(15), pxToRem(21), theme.content.base1)
      }, {
        children: title
      })), jsx("div", _assign({
        css: /*#__PURE__*/css(templateObject_7$l || (templateObject_7$l = __makeTemplateObject(["\n            margin: ", " 0 0;\n            font-size: ", ";\n            line-height: ", ";\n            color: ", ";\n          " + ( true ? "" : 0)], ["\n            margin: ", " 0 0;\n            font-size: ", ";\n            line-height: ", ";\n            color: ", ";\n          " + ( true ? "" : 0)])), pxToRem(4), pxToRem(12), pxToRem(16), theme.content.base2)
      }, {
        children: subtitle
      }))]
    }))]
  }));
}
var templateObject_1$1a, templateObject_2$W, templateObject_3$O, templateObject_4$H, templateObject_5$x, templateObject_6$q, templateObject_7$l;

var BUTTON_SIZE = 40;
function UploadDropdownContentButton(_a) {
  var uploadMenuLinks = _a.uploadMenuLinks;
  var theme = useTheme();
  var log = useLogContext();
  var _b = getWithIconOptions(BUTTON_SIZE),
    gap = _b.gap,
    iconSize = _b.iconSize;
  return jsx(Popper, _assign({
    usePortal: false,
    renderButton: function renderButton(_a) {
      var _onClick = _a.onClick;
      return jsxs(Button$2, _assign({
        variant: "primary1",
        size: BUTTON_SIZE,
        type: "button",
        css: [/*#__PURE__*/css(templateObject_1$19 || (templateObject_1$19 = __makeTemplateObject(["\n              outline: none;\n              overflow: hidden;\n            " + ( true ? "" : 0)], ["\n              outline: none;\n              overflow: hidden;\n            " + ( true ? "" : 0)]))), FOCUS(templateObject_2$V || (templateObject_2$V = __makeTemplateObject(["\n              box-shadow: 0 0 0 ", " ", ";\n            "], ["\n              box-shadow: 0 0 0 ", " ", ";\n            "])), pxToRem(3), theme.interactive.primary1.thin)],
        onClick: function onClick() {
          _onClick();
          log({
            key: 'primary.right.upload',
            category: 'click'
          });
        }
      }, {
        children: [jsx("span", _assign({
          css: /*#__PURE__*/css(templateObject_3$N || (templateObject_3$N = __makeTemplateObject(["\n              vertical-align: middle;\n              white-space: nowrap;\n              ", "\n            " + ( true ? "" : 0)], ["\n              vertical-align: middle;\n              white-space: nowrap;\n              ", "\n            " + ( true ? "" : 0)])), MEDIA_QUERY.min('laptop', "\n                margin-right: ".concat(pxToRem(gap), ";\n              ")))
        }, {
          children: "\uAE00\uC4F0\uAE30"
        })), jsx(Icon, {
          css: /*#__PURE__*/css(templateObject_4$G || (templateObject_4$G = __makeTemplateObject(["\n              vertical-align: middle;\n              display: none;\n              ", "\n            " + ( true ? "" : 0)], ["\n              vertical-align: middle;\n              display: none;\n              ", "\n            " + ( true ? "" : 0)])), MEDIA_QUERY.min('laptop', "\n                display: inline-block;\n              ")),
          name: "chevron_down",
          size: iconSize
        })]
      }));
    }
  }, {
    children: uploadMenuLinks && uploadMenuLinks.map(function (item) {
      return jsx(UploadDropdownContentItem, _assign({}, item), item.title);
    })
  }));
}
var templateObject_1$19, templateObject_2$V, templateObject_3$N, templateObject_4$G;

function UserDropdownContentItem(_a) {
  var bullet = _a.bullet,
    title = _a.title,
    href = _a.href,
    _onClick = _a.onClick,
    logKey = _a.logKey;
  var theme = useTheme();
  var LinkComponent = useLinkContext();
  var log = useLogContext();
  var Component = href ? LinkComponent : 'button';
  return jsxs(Component, _assign({}, Component === LinkComponent ? {
    href: href
  } : {
    type: 'button'
  }, {
    css: [/*#__PURE__*/css(templateObject_1$18 || (templateObject_1$18 = __makeTemplateObject(["\n          display: block;\n          position: relative;\n          width: 100%;\n          margin: 0;\n          padding: ", " ", " ", ";\n          box-sizing: border-box;\n          border: none;\n          background: ", ";\n          color: ", ";\n          font-family: inherit;\n          font-weight: normal;\n          font-size: ", ";\n          line-height: ", ";\n          text-decoration: none;\n          text-align: left;\n          cursor: pointer;\n          border-radius: ", ";\n          outline: none;\n        " + ( true ? "" : 0)], ["\n          display: block;\n          position: relative;\n          width: 100%;\n          margin: 0;\n          padding: ", " ", " ", ";\n          box-sizing: border-box;\n          border: none;\n          background: ", ";\n          color: ", ";\n          font-family: inherit;\n          font-weight: normal;\n          font-size: ", ";\n          line-height: ", ";\n          text-decoration: none;\n          text-align: left;\n          cursor: pointer;\n          border-radius: ", ";\n          outline: none;\n        " + ( true ? "" : 0)])), pxToRem(10), pxToRem(14), pxToRem(11), theme.background.base, theme.content.base1, pxToRem(15), pxToRem(21), pxToRem(2)), HOVER(templateObject_2$U || (templateObject_2$U = __makeTemplateObject(["\n          background: ", ";\n        "], ["\n          background: ", ";\n        "])), theme.background.groupedBase), FOCUS(templateObject_3$M || (templateObject_3$M = __makeTemplateObject(["\n          background: ", ";\n        "], ["\n          background: ", ";\n        "])), theme.background.groupedBase)],
    onClick: function onClick() {
      if (logKey) {
        log({
          key: logKey,
          category: 'click'
        });
      }
      if (_onClick) {
        _onClick();
      }
    }
  }, {
    children: [title, bullet === 'new' && jsx(NewIcon, {
      css: /*#__PURE__*/css(templateObject_4$F || (templateObject_4$F = __makeTemplateObject(["\n            vertical-align: middle;\n            margin: 0 1.5px 1.5px 0;\n          " + ( true ? "" : 0)], ["\n            vertical-align: middle;\n            margin: 0 1.5px 1.5px 0;\n          " + ( true ? "" : 0)])))
    })]
  }));
}
var templateObject_1$18, templateObject_2$U, templateObject_3$M, templateObject_4$F;

var DEFAULT_PROFILE_URL = 'https://image.ohou.se/i/bucketplace-v2-development/uploads/users/profile_images1542987307_LkcmI.jpeg';
function UserDropdownContentButton(_a) {
  var profileUrl = _a.profileUrl,
    userMenu = _a.userMenu;
  var theme = useTheme();
  var items = useMemo(function () {
    return userMenu.filter(function (menu) {
      var _a;
      return (_a = menu.showOn) === null || _a === void 0 ? void 0 : _a.includes('bar');
    });
  }, [userMenu]);
  return jsx(Popper, _assign({
    usePortal: false,
    renderButton: function renderButton(_a) {
      var onClick = _a.onClick;
      return jsx("button", _assign({
        css: [/*#__PURE__*/css(templateObject_1$17 || (templateObject_1$17 = __makeTemplateObject(["\n              ", "\n              position: relative;\n              overflow: hidden;\n              width: ", ";\n              height: ", ";\n              border-radius: 100%;\n              outline: none;\n              &:after {\n                content: '';\n                display: none;\n                position: absolute;\n                top: 0;\n                left: 0;\n                width: 100%;\n                height: 100%;\n                border-radius: 100%;\n                border: ", " solid ", ";\n                box-sizing: border-box;\n              }\n            " + ( true ? "" : 0)], ["\n              ", "\n              position: relative;\n              overflow: hidden;\n              width: ", ";\n              height: ", ";\n              border-radius: 100%;\n              outline: none;\n              &:after {\n                content: '';\n                display: none;\n                position: absolute;\n                top: 0;\n                left: 0;\n                width: 100%;\n                height: 100%;\n                border-radius: 100%;\n                border: ", " solid ", ";\n                box-sizing: border-box;\n              }\n            " + ( true ? "" : 0)])), RESET_BUTTON, pxToRem(40), pxToRem(40), pxToRem(2), theme.content.primary1.basic), HOVER(templateObject_2$T || (templateObject_2$T = __makeTemplateObject(["\n              &:after {\n                display: block;\n              }\n            "], ["\n              &:after {\n                display: block;\n              }\n            "]))), FOCUS(templateObject_3$L || (templateObject_3$L = __makeTemplateObject(["\n              &:after {\n                display: block;\n              }\n            "], ["\n              &:after {\n                display: block;\n              }\n            "])))],
        type: "button",
        onClick: onClick,
        "aria-label": "\uD504\uB85C\uD544 \uBA54\uB274"
      }, {
        children: jsx(ResizeImage, {
          width: 40,
          aspect: 1,
          src: profileUrl || DEFAULT_PROFILE_URL,
          alt: "\uD504\uB85C\uD544 \uC0AC\uC9C4",
          css: /*#__PURE__*/css(templateObject_4$E || (templateObject_4$E = __makeTemplateObject(["\n              vertical-align: middle;\n              width: 100%;\n              height: 100%;\n              object-fit: cover;\n            " + ( true ? "" : 0)], ["\n              vertical-align: middle;\n              width: 100%;\n              height: 100%;\n              object-fit: cover;\n            " + ( true ? "" : 0)])))
        })
      }));
    }
  }, {
    children: jsx("div", _assign({
      css: /*#__PURE__*/css(templateObject_5$w || (templateObject_5$w = __makeTemplateObject(["\n          width: ", ";\n        " + ( true ? "" : 0)], ["\n          width: ", ";\n        " + ( true ? "" : 0)])), pxToRem(184))
    }, {
      children: items.map(function (item, index) {
        return jsx(UserDropdownContentItem, _assign({}, item), index);
      })
    }))
  }));
}
var templateObject_1$17, templateObject_2$T, templateObject_3$L, templateObject_4$E, templateObject_5$w;

/**
 * @deprecated ODS의 CircleBadge 컴포넌트를 사용해 주세요.
 */
function NumberNotification(_a) {
  var count = _a.count,
    maxCount = _a.maxCount,
    rest = (0,common.e)(_a, ["count", "maxCount"]);
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CircleBadge, (0,common.a)({}, rest, {
    size: 16,
    type: "fill",
    variant: "primary2",
    css: /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)(templateObject_1$16 || (templateObject_1$16 = (0,common._)(["\n        position: absolute;\n      " + ( true ? "" : 0)], ["\n        position: absolute;\n      " + ( true ? "" : 0)])))
  }, {
    children: maxCount < count ? "+".concat(maxCount) : count
  }));
}
var templateObject_1$16;

var NotificationType = {
  Dot: 'DOT',
  Number: 'NUMBER',
  None: 'NONE'
};
function IconNotification(_a) {
  var _b = _a.component,
    component = _b === void 0 ? 'div' : _b,
    iconName = _a.iconName,
    type = _a.type,
    _c = _a.count,
    count = _c === void 0 ? 0 : _c,
    restProps = (0,common.e)(_a, ["component", "iconName", "type", "count"]);
  var theme = (0,emotion_element_5486c51c_browser_esm.u)();
  var Component = component;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Component
  // FIXME: 이거 IconNotification에서 높이를 임의로 지정하면 안될 것 같아요
  // NOTE: 디자인에서는 아이콘마다 14px의 거리를 규정하고 있습니다. 즉, 각 아이콘이
  //       한 방향에서 가질 수 있는 가로 padding+margin은 7px까지입니다.
  , (0,common.a)({
    // FIXME: 이거 IconNotification에서 높이를 임의로 지정하면 안될 것 같아요
    // NOTE: 디자인에서는 아이콘마다 14px의 거리를 규정하고 있습니다. 즉, 각 아이콘이
    //       한 방향에서 가질 수 있는 가로 padding+margin은 7px까지입니다.
    css: [/*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)(templateObject_1$15 || (templateObject_1$15 = (0,common._)(["\n          position: relative;\n          display: inline-block;\n          padding: ", ";\n          margin: ", " ", ";\n          color: ", ";\n          line-height: 0;\n          outline: none;\n          ", "\n        " + ( true ? "" : 0)], ["\n          position: relative;\n          display: inline-block;\n          padding: ", ";\n          margin: ", " ", ";\n          color: ", ";\n          line-height: 0;\n          outline: none;\n          ", "\n        " + ( true ? "" : 0)])), (0,foundation.p)(6), (0,foundation.p)(3), (0,foundation.p)(1), theme.content.base1, foundation.M.min('tablet', "\n            margin: ".concat((0,foundation.p)(9), " ").concat((0,foundation.p)(1), ";\n          "))), (0,foundation.H)(templateObject_2$S || (templateObject_2$S = (0,common._)(["\n          color: ", ";\n        "], ["\n          color: ", ";\n        "])), theme.content.primary1.basic), (0,foundation.g)(templateObject_3$K || (templateObject_3$K = (0,common._)(["\n          color: ", ";\n        "], ["\n          color: ", ";\n        "])), theme.content.primary1.basic)]
  }, restProps, {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Icon, {
      css: /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)(templateObject_4$D || (templateObject_4$D = (0,common._)(["\n          font-size: ", ";\n        " + ( true ? "" : 0)], ["\n          font-size: ", ";\n        " + ( true ? "" : 0)])), (0,foundation.p)(24)),
      name: iconName,
      size: 24
    }), type === NotificationType.Dot && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DotNotification, {}), type === NotificationType.Number && count > 0 && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", (0,common.a)({
      css: /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)(templateObject_5$v || (templateObject_5$v = (0,common._)(["\n            position: absolute;\n            top: 0;\n            right: ", ";\n          " + ( true ? "" : 0)], ["\n            position: absolute;\n            top: 0;\n            right: ", ";\n          " + ( true ? "" : 0)])), (0,foundation.p)(20))
    }, {
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(NumberNotification, {
        count: count,
        maxCount: 99
      })
    }))]
  }));
}
var templateObject_1$15, templateObject_2$S, templateObject_3$K, templateObject_4$D, templateObject_5$v;

function NoLoginMenuItem(_a) {
  var _b = _a.component,
    component = _b === void 0 ? 'a' : _b,
    label = _a.label,
    href = _a.href,
    logKey = _a.logKey,
    rest = __rest(_a, ["component", "label", "href", "logKey"]);
  var theme = useTheme();
  var Component = component;
  var log = useLogContext();
  return jsx(Component, _assign({}, rest, {
    href: href,
    css: /*#__PURE__*/css(templateObject_1$14 || (templateObject_1$14 = __makeTemplateObject(["\n        ", ";\n        color: ", ";\n        padding: 0 10px;\n        border-left: 1px solid ", ";\n        &:first-of-type {\n          border-left: none;\n        }\n      " + ( true ? "" : 0)], ["\n        ", ";\n        color: ", ";\n        padding: 0 10px;\n        border-left: 1px solid ", ";\n        &:first-of-type {\n          border-left: none;\n        }\n      " + ( true ? "" : 0)])), FONT_STYLE.subTitle2, theme.content.base1, theme.content.base4),
    onClick: function onClick() {
      return log({
        key: logKey,
        category: 'click'
      });
    }
  }, {
    children: label
  }));
}
var templateObject_1$14;

var SELLER_USERABLE_TYPE = 'SalesUser';
var SellerButton = /*#__PURE__*/(/* unused pure expression or super */ null && (memo(function (_a) {
  var userableType = _a.userableType,
    rest = __rest(_a, ["userableType"]);
  if (userableType !== SELLER_USERABLE_TYPE) {
    return null;
  }
  return jsx(OutlineAnchorButton, _assign({
    css: /*#__PURE__*/css(templateObject_1$13 || (templateObject_1$13 = __makeTemplateObject(["\n        display: none;\n        margin-left: 8px;\n        ", "\n      " + ( true ? "" : 0)], ["\n        display: none;\n        margin-left: 8px;\n        ", "\n      " + ( true ? "" : 0)])), MEDIA_QUERY.min('laptop', "\n          display: flex;\n          align-items: center;\n        ")),
    variant: "base1",
    size: 40
  }, rest, {
    children: "\uD310\uB9E4\uC790 \uC804\uC6A9\uC11C\uBE44\uC2A4"
  }));
})));
var templateObject_1$13;

function PrimaryRight(_a) {
  var searchProps = _a.searchProps,
    userProfile = _a.userProfile,
    userMenu = _a.userMenu,
    scrap = _a.scrap,
    cart = _a.cart,
    notification = _a.notification,
    signin = _a.signin,
    signup = _a.signup,
    cs = _a.cs,
    seller = _a.seller,
    uploadMenuLinks = _a.uploadMenuLinks;
  var LinkComponent = useLinkContext();
  var log = useLogContext();
  var _b = userProfile || {},
    userId = _b.userId,
    imageUrl = _b.imageUrl;
  var loggedIn = userId != null;
  return jsxs("div", _assign({
    css: /*#__PURE__*/css(templateObject_1$12 || (templateObject_1$12 = __makeTemplateObject(["\n        display: flex;\n        align-items: center;\n        justify-content: flex-end;\n        line-height: 0;\n      " + ( true ? "" : 0)], ["\n        display: flex;\n        align-items: center;\n        justify-content: flex-end;\n        line-height: 0;\n      " + ( true ? "" : 0)])))
  }, {
    children: [searchProps && jsxs(Fragment$1, {
      children: [jsx(NavigationSearch, _assign({
        css: /*#__PURE__*/css(templateObject_2$R || (templateObject_2$R = __makeTemplateObject(["\n              flex: 1 1 0px;\n              min-width: 0;\n              margin-right: ", ";\n              ", "\n              ", "\n            " + ( true ? "" : 0)], ["\n              flex: 1 1 0px;\n              min-width: 0;\n              margin-right: ", ";\n              ", "\n              ", "\n            " + ( true ? "" : 0)])), pxToRem(9), MEDIA_QUERY.min('desktop', "\n                margin-right: ".concat(pxToRem(14), ";\n              ")), MEDIA_QUERY.max('tablet', "\n                display: none;\n              "))
      }, searchProps)), jsx(SearchDrawer, _assign({
        css: /*#__PURE__*/css(templateObject_3$J || (templateObject_3$J = __makeTemplateObject(["\n              ", "\n            " + ( true ? "" : 0)], ["\n              ", "\n            " + ( true ? "" : 0)])), MEDIA_QUERY.min('laptop', "\n                display: none;\n              "))
      }, searchProps))]
    }), scrap && jsx("div", _assign({
      css: /*#__PURE__*/css(templateObject_4$C || (templateObject_4$C = __makeTemplateObject(["\n          ", "\n        " + ( true ? "" : 0)], ["\n          ", "\n        " + ( true ? "" : 0)])), MEDIA_QUERY.max('mobile', "\n            display: none;\n          "))
    }, {
      children: jsx(IconNotification, {
        iconName: "scrap_outline",
        type: NotificationType.None,
        component: LinkComponent,
        "aria-label": "\uC2A4\uD06C\uB7A9\uBD81 \uD398\uC774\uC9C0 \uB9C1\uD06C \uBC84\uD2BC",
        href: scrap.href,
        onClick: function onClick() {
          return log({
            key: 'primary.right.scrap',
            category: 'click'
          });
        }
      })
    })), notification && jsx("div", _assign({
      css: /*#__PURE__*/css(templateObject_5$u || (templateObject_5$u = __makeTemplateObject(["\n            ", "\n          " + ( true ? "" : 0)], ["\n            ", "\n          " + ( true ? "" : 0)])), MEDIA_QUERY.max('mobile', "\n              display: none;\n            "))
    }, {
      children: jsx(IconNotification, {
        iconName: "notification_outline",
        type: NotificationType.Number,
        count: notification.count,
        component: LinkComponent,
        href: notification.href,
        "aria-label": "\uB0B4\uC18C\uC2DD \uD398\uC774\uC9C0 \uB9C1\uD06C \uBC84\uD2BC",
        onClick: function onClick() {
          return log({
            key: 'primary.right.notification',
            category: 'click'
          });
        }
      })
    })), cart && jsx(IconNotification, {
      iconName: "cart",
      type: NotificationType.Number,
      count: cart.count,
      component: LinkComponent,
      href: cart.href,
      "aria-label": "\uC7A5\uBC14\uAD6C\uB2C8 \uD398\uC774\uC9C0 \uB9C1\uD06C \uBC84\uD2BC",
      onClick: function onClick() {
        return log({
          key: 'primary.right.cart',
          category: 'click'
        });
      }
    }), jsxs("div", _assign({
      css: /*#__PURE__*/css(templateObject_6$p || (templateObject_6$p = __makeTemplateObject(["\n          display: flex;\n          align-items: center;\n          ", "\n        " + ( true ? "" : 0)], ["\n          display: flex;\n          align-items: center;\n          ", "\n        " + ( true ? "" : 0)])), MEDIA_QUERY.max('mobile', "\n            display: none;\n          "))
    }, {
      children: [loggedIn && jsx("div", _assign({
        css: /*#__PURE__*/css(templateObject_7$k || (templateObject_7$k = __makeTemplateObject(["\n              margin: 0 ", " 0 ", ";\n              ", "\n              ", "\n            " + ( true ? "" : 0)], ["\n              margin: 0 ", " 0 ", ";\n              ", "\n              ", "\n            " + ( true ? "" : 0)])), pxToRem(12), pxToRem(5), MEDIA_QUERY.min('laptop', "\n                margin: 0 ".concat(pxToRem(16), " 0 ").concat(pxToRem(9), ";\n              ")), MEDIA_QUERY.min('desktop', "\n                margin: 0 ".concat(pxToRem(20), " 0 ").concat(pxToRem(13), ";\n              ")))
      }, {
        children: jsx(UserDropdownContentButton, {
          profileUrl: imageUrl,
          userMenu: userMenu
        })
      })), jsxs("div", _assign({
        css: /*#__PURE__*/css(templateObject_8$f || (templateObject_8$f = __makeTemplateObject(["\n          display: flex;\n          margin: 0 10px 0 8px;\n        " + ( true ? "" : 0)], ["\n          display: flex;\n          margin: 0 10px 0 8px;\n        " + ( true ? "" : 0)])))
      }, {
        children: [signin && jsx(NoLoginMenuItem, {
          label: "\uB85C\uADF8\uC778",
          href: signin.href,
          component: LinkComponent,
          logKey: "primary.right.login"
        }), signup && jsx(NoLoginMenuItem, {
          label: "\uD68C\uC6D0\uAC00\uC785",
          href: signup.href,
          component: LinkComponent,
          logKey: "primary.right.signup"
        }), cs && jsx(NoLoginMenuItem, {
          label: "\uACE0\uAC1D\uC13C\uD130",
          href: cs.href,
          component: LinkComponent,
          logKey: "primary.right.cs",
          css: /*#__PURE__*/css(templateObject_9$b || (templateObject_9$b = __makeTemplateObject(["\n                ", "\n              " + ( true ? "" : 0)], ["\n                ", "\n              " + ( true ? "" : 0)])), MEDIA_QUERY.max('laptop', "\n                  display: none;\n                "))
        })]
      })), uploadMenuLinks && uploadMenuLinks.length > 0 && jsx(UploadDropdownContentButton, {
        uploadMenuLinks: uploadMenuLinks
      }), seller && jsx(SellerButton, {
        href: seller.href
      })]
    }))]
  }));
}
var templateObject_1$12, templateObject_2$R, templateObject_3$J, templateObject_4$C, templateObject_5$u, templateObject_6$p, templateObject_7$k, templateObject_8$f, templateObject_9$b;

var _path, _rect, _path2, _path3;
function _extends$1() { _extends$1 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1.apply(this, arguments); }
var SvgLogo$1 = function SvgLogo(props) {
  return /*#__PURE__*/react.createElement("svg", _extends$1({
    xmlns: "http://www.w3.org/2000/svg",
    width: 74,
    height: 30,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/react.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M14.2 25.17H9.28V20.7a1.45 1.45 0 0 0-2.9 0v4.47H1.44a1.45 1.45 0 1 0 0 2.9H14.2a1.45 1.45 0 0 0 0-2.9M4.5 9.15c0-4.6 2.08-5.28 3.33-5.28 1.24 0 3.33.69 3.33 5.28v.36c0 4.6-2.09 5.28-3.33 5.28-1.25 0-3.34-.69-3.34-5.28v-.36zm3.33 8.54c3.84 0 6.23-3.13 6.23-8.18v-.36c0-5.05-2.39-8.18-6.23-8.18-3.85 0-6.24 3.13-6.24 8.18v.36c0 5.05 2.39 8.18 6.24 8.18m25.54-7.34H17.81a1.45 1.45 0 0 0 0 2.9h15.56a1.45 1.45 0 1 0 0-2.9m-1.55 15.49c-7.08 1.84-9.45.8-10.14.26-.45-.35-.65-.8-.65-1.48v-.87h10.25c.8 0 1.46-.65 1.46-1.45v-5.08c0-.8-.65-1.45-1.46-1.45h-11.7a1.45 1.45 0 1 0 0 2.9h10.25v2.18H19.57c-.8 0-1.45.65-1.45 1.45v2.32a4.6 4.6 0 0 0 1.78 3.78c1.2.92 2.94 1.39 5.21 1.39 2.05 0 4.54-.38 7.44-1.13a1.45 1.45 0 1 0-.73-2.82M20.3 7.83h10.82a1.45 1.45 0 1 0 0-2.9h-9.36V1.44a1.45 1.45 0 1 0-2.9 0v4.93c0 .8.65 1.45 1.45 1.45z",
    clipRule: "evenodd"
  })), _rect || (_rect = /*#__PURE__*/react.createElement("rect", {
    width: 3,
    height: 15,
    x: 70,
    fill: "currentColor",
    rx: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/react.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M64.5 13.28a1.45 1.45 0 0 0 2.73-1c-.05-.13-1-2.68-3.38-4.5l3.7-4.1a1.45 1.45 0 0 0-1.09-2.42h-9.05a1.45 1.45 0 1 0 0 2.9h5.8l-6.88 7.64a1.45 1.45 0 1 0 2.16 1.95l3.41-3.8a8 8 0 0 1 2.6 3.33m5.06 13.24h-7.01a.82.82 0 0 1-.82-.82v-1.95h8.65v1.95c0 .45-.37.82-.82.82m2.27-9.37c-.8 0-1.45.65-1.45 1.45v2.25h-8.65V18.6a1.45 1.45 0 1 0-2.9 0v7.1a3.72 3.72 0 0 0 3.72 3.72h7.01a3.72 3.72 0 0 0 3.72-3.72v-7.1c0-.8-.65-1.45-1.45-1.45M42.46 3.87c2.22 0 2.33 4.24 2.33 5.08 0 .85-.11 5.09-2.33 5.09-2.21 0-2.32-4.24-2.32-5.09 0-.84.11-5.08 2.32-5.08m0 13.07c1.76 0 3.23-.93 4.14-2.62.71-1.34 1.1-3.2 1.1-5.37 0-2.16-.39-4.02-1.1-5.36A4.59 4.59 0 0 0 42.46.97c-1.75 0-3.22.93-4.13 2.62-.72 1.34-1.1 3.2-1.1 5.36 0 2.17.38 4.03 1.1 5.37a4.59 4.59 0 0 0 4.13 2.62",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/react.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M51.4.49c-.8 0-1.45.65-1.45 1.45v17.78c-1.93.6-5.75 1.12-10.38 1.12h-2.2a1.45 1.45 0 0 0 0 2.91h2.2c2.64 0 7.21-.23 10.38-1.02v4.84a1.45 1.45 0 0 0 2.9 0V1.94c0-.8-.65-1.45-1.45-1.45",
    clipRule: "evenodd"
  })));
};
var LogoIcon$1 = SvgLogo$1;

function Logo(_a) {
  var logo = _a.logo,
    children = _a.children,
    rest = (0,common.e)(_a, ["logo", "children"]);
  var theme = (0,emotion_element_5486c51c_browser_esm.u)();
  var Link = useLinkContext();
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Link, (0,common.a)({}, rest, {
    href: (logo === null || logo === void 0 ? void 0 : logo.href) || 'https://ohou.se',
    "aria-label": "\uC624\uB298\uC758\uC9D1 \uB85C\uACE0",
    css: [/*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)(templateObject_1$11 || (templateObject_1$11 = (0,common._)(["\n          ", "\n          display: inline-flex;\n          align-items: center;\n          margin: ", ";\n          padding: ", ";\n          font-size: 0;\n          line-height: 0;\n          color: ", ";\n          outline: none;\n        " + ( true ? "" : 0)], ["\n          ", "\n          display: inline-flex;\n          align-items: center;\n          margin: ", ";\n          padding: ", ";\n          font-size: 0;\n          line-height: 0;\n          color: ", ";\n          outline: none;\n        " + ( true ? "" : 0)])), foundation.R, (0,foundation.p)(-4), (0,foundation.p)(4), theme.interactive.base1), (0,foundation.g)(templateObject_2$Q || (templateObject_2$Q = (0,common._)(["\n          box-shadow: 0 0 0 ", " ", ";\n          border-radius: ", ";\n        "], ["\n          box-shadow: 0 0 0 ", " ", ";\n          border-radius: ", ";\n        "])), (0,foundation.p)(3), theme.interactive.primary1.thin, (0,foundation.p)(3))]
  }, {
    children: children || (logo === null || logo === void 0 ? void 0 : logo.item) || (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LogoIcon$1, {
      css: /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)(templateObject_3$I || (templateObject_3$I = (0,common._)(["\n          vertical-align: top;\n          height: ", ";\n          ", "\n        " + ( true ? "" : 0)], ["\n          vertical-align: top;\n          height: ", ";\n          ", "\n        " + ( true ? "" : 0)])), (0,foundation.p)(26), foundation.M.min('tablet', "\n            height: ".concat((0,foundation.p)(30), ";\n          ")))
    })
  }));
}
var templateObject_1$11, templateObject_2$Q, templateObject_3$I;

function useFocusedLatch(onChange) {
  var focusRef = useRef(null);
  var handleFocusIn = useCallback(function () {
    if (focusRef.current != null) {
      cancelAnimationFrame(focusRef.current);
    }
    onChange(true);
  }, [onChange]);
  var handleFocusOut = useCallback(function () {
    if (focusRef.current != null) {
      cancelAnimationFrame(focusRef.current);
    }
    focusRef.current = requestAnimationFrame(function () {
      return onChange(false);
    });
  }, [onChange]);
  return [handleFocusIn, handleFocusOut];
}

function NavigationBar(props) {
  var _a;
  var log = useLogContext();
  var logo = props.logo,
    primaryLeftmost = props.primaryLeftmost,
    menuSchema = props.menuSchema,
    fallbackMenuSchema = props.fallbackMenuSchema,
    searchOptions = props.searchOptions,
    supplementary = props.supplementary;
  var _b = useState({
      isHovered: false,
      selectedIds: null
    }),
    _c = _b[0],
    isHovered = _c.isHovered,
    selectedIds = _c.selectedIds,
    setState = _b[1];
  var setHovered = useCallback(function (value) {
    setState(function (prevState) {
      return _assign(_assign({}, prevState), {
        isHovered: value,
        selectedIds: !value ? null : prevState.selectedIds
      });
    });
  }, []);
  var _d = useFocusedLatch(setHovered),
    onMouseEnter = _d[0],
    onMouseLeave = _d[1];
  var activeIds = useMemo(function () {
    return getActiveIds(menuSchema, fallbackMenuSchema);
  }, [menuSchema, fallbackMenuSchema]);
  var currentSelectedIds = selectedIds == null ? activeIds : selectedIds;
  var primaryEntries = menuSchema;
  var activePrimaryItem = activeIds[0] != null ? primaryEntries[activeIds[0]] : null;
  var primaryItem = currentSelectedIds[0] != null ? primaryEntries[currentSelectedIds[0]] : null;
  var secondaryEntries = getSecondaryEntries({
    primary: primaryItem,
    activeIds: activeIds,
    fallbackMenuSchema: fallbackMenuSchema
  });
  var secondaryItem = currentSelectedIds[1] != null ? secondaryEntries[currentSelectedIds[1]] : null;
  var hasFallbackMenuSchema = fallbackMenuSchema != null && fallbackMenuSchema.length > 0;
  var handlePrimarySelect = useCallback(function (_, index) {
    setState(function (prevState) {
      return _assign(_assign({}, prevState), {
        selectedIds: [index]
      });
    });
  }, []);
  var handleSecondarySelect = useCallback(function (_, index) {
    setState(function (prevState) {
      return _assign(_assign({}, prevState), {
        selectedIds: [currentSelectedIds[0], index]
      });
    });
  }, [currentSelectedIds]);
  var CustomPrimaryRight = (_a = supplementary.primaryRight) !== null && _a !== void 0 ? _a : null;
  var showTertiary = selectedIds != null && selectedIds[1] != null && secondaryItem != null && secondaryItem.renderBarChild != null;
  var secondaryRightElement = supplementary.secondaryRight != null ? /*#__PURE__*/React__default.createElement(supplementary.secondaryRight) : null;
  var hasItemInActivedPrimaryItem = activePrimaryItem != null && activePrimaryItem.entries != null ? activePrimaryItem.entries.length > 0 : false;
  var hasItemInHoveredPrimaryItem = primaryItem != null && primaryItem.entries != null ? primaryItem.entries.length > 0 : false;
  return jsxs("header", {
    children: [jsx(NavigationBarPrimary, {
      leftmost: primaryLeftmost,
      left: jsx(StyledLogo, {
        logo: logo,
        onClick: function onClick() {
          log({
            key: 'logo',
            category: 'click'
          });
        }
      }),
      right: CustomPrimaryRight ? jsx(CustomPrimaryRightContainer, {
        children: jsx(CustomPrimaryRight, {})
      }) : jsx(PrimaryRight, _assign({
        searchProps: searchOptions
      }, supplementary)),
      menuEntries: primaryEntries,
      activeId: activeIds[0],
      selectedId: currentSelectedIds[0],
      onMouseEnter: onMouseEnter,
      onMouseLeave: onMouseLeave,
      onSelect: handlePrimarySelect
    }), jsx(NavigationBarSecondary, {
      right: secondaryRightElement,
      menuEntries: secondaryEntries,
      hasItems: hasItemInActivedPrimaryItem || hasItemInHoveredPrimaryItem || hasFallbackMenuSchema,
      activeId: currentSelectedIds[0] === activeIds[0] ? activeIds[1] : null,
      primaryId: currentSelectedIds[0],
      isForceOpened: isHovered && secondaryEntries.length > 0,
      isFallback: currentSelectedIds[0] == null && hasFallbackMenuSchema,
      onMouseEnter: onMouseEnter,
      onMouseLeave: onMouseLeave,
      onSelect: handleSecondarySelect,
      scrollableEntries: primaryItem === null || primaryItem === void 0 ? void 0 : primaryItem.scrollableEntries
    }), showTertiary && jsx(NavigationBarTertiary, {
      item: showTertiary ? secondaryItem : null,
      isOpen: showTertiary,
      onMouseEnter: onMouseEnter,
      onMouseLeave: onMouseLeave
    })]
  });
}
var StyledLogo = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Logo,  true ? {
  target: "e4qy2et1"
} : 0)(templateObject_2$P || (templateObject_2$P = (0,common._)(["\n  height: ", ";\n  ", "\n"], ["\n  height: ", ";\n  ", "\n"])), (0,foundation.p)(26), foundation.M.min('tablet', /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)(templateObject_1$10 || (templateObject_1$10 = (0,common._)(["\n    height: ", ";\n  " + ( true ? "" : 0)], ["\n    height: ", ";\n  " + ( true ? "" : 0)])), (0,foundation.p)(30))));
var CustomPrimaryRightContainer = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e4qy2et0"
} : 0)(templateObject_4$B || (templateObject_4$B = (0,common._)(["\n  ", "\n"], ["\n  ", "\n"])), foundation.M.max('mobile', /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)(templateObject_3$H || (templateObject_3$H = (0,common._)(["\n    display: none;\n  " + ( true ? "" : 0)], ["\n    display: none;\n  " + ( true ? "" : 0)])))));
/** Secondary 메뉴 스키마를 리턴합니다 */
function getSecondaryEntries(_a) {
  var _b;
  var primary = _a.primary,
    activeIds = _a.activeIds,
    fallbackMenuSchema = _a.fallbackMenuSchema;
  if (primary != null) {
    return (_b = primary.entries) !== null && _b !== void 0 ? _b : [];
  }
  if (activeIds[1] != null) {
    return fallbackMenuSchema !== null && fallbackMenuSchema !== void 0 ? fallbackMenuSchema : [];
  }
  return [];
}
var templateObject_1$10, templateObject_2$P, templateObject_3$H, templateObject_4$B;

function StoreCategory(_a) {
  var categories = _a.categories;
  var Link = useLinkContext();
  var log = useLogContext();
  var theme = (0,emotion_element_5486c51c_browser_esm.u)();
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", (0,common.a)({
    css: /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)(templateObject_1$$ || (templateObject_1$$ = (0,common._)(["overflow: auto;" + ( true ? "" : 0)], ["overflow: auto;" + ( true ? "" : 0)])))
  }, {
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("ul", (0,common.a)({
      css: /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)(templateObject_3$G || (templateObject_3$G = (0,common._)(["\n        display: flex;\n        justify-content: space-between;\n        margin: 0 auto;\n        padding: 10px 0 10px 40px;\n        box-sizing: border-box;\n        ", "\n      " + ( true ? "" : 0)], ["\n        display: flex;\n        justify-content: space-between;\n        margin: 0 auto;\n        padding: 10px 0 10px 40px;\n        box-sizing: border-box;\n        ", "\n      " + ( true ? "" : 0)])), foundation.M.min('laptop', /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)(templateObject_2$O || (templateObject_2$O = (0,common._)(["\n          max-width: 1276px;\n          padding: 10px 0 10px 60px;\n        " + ( true ? "" : 0)], ["\n          max-width: 1276px;\n          padding: 10px 0 10px 60px;\n        " + ( true ? "" : 0)])))))
    }, {
      children: categories.map(function (category, index) {
        return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("li", (0,common.a)({
          css: /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)(templateObject_5$t || (templateObject_5$t = (0,common._)(["\n              flex: 0 0 auto;\n              margin: 0;\n              padding: 0 0 0 10px;\n              color: ", ";\n              &:last-of-type {\n                padding-right: 40px;\n                ", "\n              }\n              &:hover {\n                color: ", ";\n              }\n            " + ( true ? "" : 0)], ["\n              flex: 0 0 auto;\n              margin: 0;\n              padding: 0 0 0 10px;\n              color: ", ";\n              &:last-of-type {\n                padding-right: 40px;\n                ", "\n              }\n              &:hover {\n                color: ", ";\n              }\n            " + ( true ? "" : 0)])), category.active ? theme.content.primary1.basic : theme.content.base1, foundation.M.min('laptop', /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)(templateObject_4$A || (templateObject_4$A = (0,common._)(["\n                  padding-right: 60px;\n                " + ( true ? "" : 0)], ["\n                  padding-right: 60px;\n                " + ( true ? "" : 0)])))), theme.content.primary1.basic)
        }, {
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Link, (0,common.a)({
            href: category.href,
            onClick: function onClick() {
              log({
                key: 'tertiary.store.category.item',
                category: 'click',
                params: {
                  id: category.logId,
                  index: index
                }
              });
            },
            css: /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)(templateObject_6$o || (templateObject_6$o = (0,common._)(["\n                display: block;\n                padding: 10px 0;\n                font-size: 14px;\n                font-weight: bold;\n                text-align: center;\n              " + ( true ? "" : 0)], ["\n                display: block;\n                padding: 10px 0;\n                font-size: 14px;\n                font-weight: bold;\n                text-align: center;\n              " + ( true ? "" : 0)])))
          }, {
            children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", (0,common.a)({
              css: /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)(templateObject_7$j || (templateObject_7$j = (0,common._)(["\n                position: relative;\n                display: block;\n                width: 80px;\n                height: 80px;\n                & > img {\n                  position: absolute;\n                  top: 0;\n                  left: 0;\n                  width: 100%;\n                  border: 0;\n                }\n              " + ( true ? "" : 0)], ["\n                position: relative;\n                display: block;\n                width: 80px;\n                height: 80px;\n                & > img {\n                  position: absolute;\n                  top: 0;\n                  left: 0;\n                  width: 100%;\n                  border: 0;\n                }\n              " + ( true ? "" : 0)])))
            }, {
              children: category.icon
            })), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", (0,common.a)({
              css: /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)(templateObject_8$e || (templateObject_8$e = (0,common._)(["\n                display: block;\n                margin: 20px -10px 0;\n                line-height: 1;\n              " + ( true ? "" : 0)], ["\n                display: block;\n                margin: 20px -10px 0;\n                line-height: 1;\n              " + ( true ? "" : 0)])))
            }, {
              children: category.title
            }))]
          }))
        }), category.title);
      })
    }))
  }));
}
var templateObject_1$$, templateObject_2$O, templateObject_3$G, templateObject_4$A, templateObject_5$t, templateObject_6$o, templateObject_7$j, templateObject_8$e;

function NavigationDrawerDivider() {
  return jsx(Divider$1, {
    variant: "thin",
    css: /*#__PURE__*/css(templateObject_1$_ || (templateObject_1$_ = __makeTemplateObject(["margin: ", " 0;" + ( true ? "" : 0)], ["margin: ", " 0;" + ( true ? "" : 0)])), pxToRem(20))
  });
}
var templateObject_1$_;

function NavigationDrawerMenuAccordion(_a) {
  var children = _a.children,
    isExpanded = _a.isExpanded,
    onTransitionStart = _a.onTransitionStart,
    onTransitionEnd = _a.onTransitionEnd;
  var container = useRef(null);
  var content = useRef(null);
  var isExpanding = useRef(false);
  var isCollapsing = useRef(false);
  var expand = useCallback(function () {
    if (!container.current || !content.current) return;
    if (isExpanding.current) return;
    if (isCollapsing.current) return;
    isExpanding.current = true;
    container.current.style.display = 'block';
    container.current.style.height = "".concat(content.current.clientHeight, "px");
    onTransitionStart();
  }, [onTransitionStart]);
  var collapse = useCallback(function () {
    if (!container.current || !content.current) return;
    if (isExpanding.current) return;
    if (isCollapsing.current) return;
    isCollapsing.current = true;
    container.current.style.height = "".concat(content.current.clientHeight, "px");
    setTimeout(function () {
      if (!container.current) return;
      container.current.style.height = '0px';
      onTransitionStart();
    }, 50);
  }, [onTransitionStart]);
  var handleTransitionEnd = useCallback(function () {
    if (!container.current || !content.current) return;
    if (isExpanding.current) {
      container.current.style.height = 'auto';
      isExpanding.current = false;
    } else if (isCollapsing.current) {
      container.current.style.display = 'none';
      isCollapsing.current = false;
    }
    onTransitionEnd();
  }, [onTransitionEnd]);
  useEffect(function () {
    if (!container.current) return;
    if (!container.current.style.transition) return;
    (isExpanded ? expand : collapse)();
  }, [isExpanded, expand, collapse]);
  useEffect(function () {
    if (!container.current) return;
    container.current.style.height = isExpanded ? 'auto' : '0px';
    container.current.style.display = isExpanded ? 'block' : 'none';
    setTimeout(function () {
      if (!container.current) return;
      container.current.style.transition = 'height .3s';
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return jsx("div", _assign({
    ref: container,
    css: /*#__PURE__*/css(templateObject_1$Z || (templateObject_1$Z = __makeTemplateObject(["\n        overflow: hidden;\n      " + ( true ? "" : 0)], ["\n        overflow: hidden;\n      " + ( true ? "" : 0)]))),
    onTransitionEnd: handleTransitionEnd
  }, {
    children: jsx("div", _assign({
      ref: content
    }, {
      children: children
    }))
  }));
}
var templateObject_1$Z;

function NavigationDrawerMenu(_a) {
  var items = _a.items,
    indents = _a.indents,
    fontStyles = _a.fontStyles,
    onClose = _a.onClose;
  var _b = useState(function () {
      return items.findIndex(function (item) {
        return item.active;
      });
    }),
    expandedIndex = _b[0],
    setExpandedIndex = _b[1];
  return jsx("ul", _assign({
    css: /*#__PURE__*/css(templateObject_1$Y || (templateObject_1$Y = __makeTemplateObject(["\n      padding: 0;\n    " + ( true ? "" : 0)], ["\n      padding: 0;\n    " + ( true ? "" : 0)])))
  }, {
    children: items.map(function (item, index) {
      return jsx(NavigationDrawerMenuItem, {
        title: item.title,
        icon: item.icon,
        bullet: item.bullet,
        href: item.href,
        isActive: item.active,
        items: item.entries,
        renderChild: item.renderDrawerChild,
        indents: indents,
        fontStyles: fontStyles,
        isExpanded: index === expandedIndex,
        onExpand: function onExpand() {
          return setExpandedIndex(index);
        },
        onCollapse: function onCollapse() {
          return setExpandedIndex(-1);
        },
        onClick: function onClick() {
          var _a;
          (_a = item.onClick) === null || _a === void 0 ? void 0 : _a.call(item, {
            item: item,
            index: index
          });
          !item.entries && (onClose === null || onClose === void 0 ? void 0 : onClose());
        },
        onClose: onClose
      }, index);
    })
  }));
}
function NavigationDrawerMenuItem(_a) {
  var title = _a.title,
    icon = _a.icon,
    href = _a.href,
    bullet = _a.bullet,
    items = _a.items,
    _b = _a.indents,
    indents = _b === void 0 ? [] : _b,
    _c = _a.fontStyles,
    fontStyles = _c === void 0 ? [] : _c,
    isActive = _a.isActive,
    isExpanded = _a.isExpanded,
    onExpand = _a.onExpand,
    onCollapse = _a.onCollapse,
    renderChild = _a.renderChild,
    _onClick = _a.onClick,
    onClose = _a.onClose;
  var theme = useTheme();
  var Link = useLinkContext();
  var isAccordionTransitioning = useRef(false);
  var handleAccordionTransitionStart = useCallback(function () {
    isAccordionTransitioning.current = true;
  }, []);
  var handleAccordionTransitionEnd = useCallback(function () {
    isAccordionTransitioning.current = false;
  }, []);
  var handleAccordionToggle = useCallback(function () {
    if (isAccordionTransitioning.current) return;
    (isExpanded ? onCollapse : onExpand)();
  }, [isExpanded, onCollapse, onExpand]);
  var renderTitle = function renderTitle() {
    return jsxs("div", _assign({
      css: /*#__PURE__*/css(templateObject_2$N || (templateObject_2$N = __makeTemplateObject(["\n        display: flex;\n        flex-wrap: wrap;\n        align-items: center;\n        width: 100%;\n        height: 100%;\n        line-height: 1;\n      " + ( true ? "" : 0)], ["\n        display: flex;\n        flex-wrap: wrap;\n        align-items: center;\n        width: 100%;\n        height: 100%;\n        line-height: 1;\n      " + ( true ? "" : 0)])))
    }, {
      children: [icon && jsx("span", _assign({
        css: /*#__PURE__*/css(templateObject_3$F || (templateObject_3$F = __makeTemplateObject(["\n            display: inline-block;\n            margin-right: ", ";\n            border-radius: ", ";\n          " + ( true ? "" : 0)], ["\n            display: inline-block;\n            margin-right: ", ";\n            border-radius: ", ";\n          " + ( true ? "" : 0)])), pxToRem(8), pxToRem(4))
      }, {
        children: icon
      })), title, bullet === 'new' && jsx(NewIcon, {
        css: /*#__PURE__*/css(templateObject_4$z || (templateObject_4$z = __makeTemplateObject(["margin-left: 1.5px" + ( true ? "" : 0)], ["margin-left: 1.5px" + ( true ? "" : 0)])))
      })]
    }));
  };
  var indent = indents[0];
  var _d = fontStyles[0],
    fontStyle = _d === void 0 ? {} : _d;
  return jsx("li", _assign({
    css: /*#__PURE__*/css(templateObject_5$s || (templateObject_5$s = __makeTemplateObject(["\n      margin: ", " 0 0;\n      padding: 0;\n      font-size: ", ";\n      font-weight: ", ";\n      color: ", ";\n    " + ( true ? "" : 0)], ["\n      margin: ", " 0 0;\n      padding: 0;\n      font-size: ", ";\n      font-weight: ", ";\n      color: ", ";\n    " + ( true ? "" : 0)])), pxToRem(4), pxToRem(fontStyle.size || 14), isActive ? 'bold' : fontStyle.weight || 'normal', fontStyle.color || theme.content.base1)
  }, {
    children: items && items.length || renderChild ? jsxs(Fragment$1, {
      children: [jsxs("button", _assign({
        type: "button",
        onClick: function onClick() {
          handleAccordionToggle();
          _onClick === null || _onClick === void 0 ? void 0 : _onClick();
        },
        css: /*#__PURE__*/css(templateObject_9$a || (templateObject_9$a = __makeTemplateObject(["\n                ", "\n                overflow: hidden;\n                position: relative;\n                display: block;\n                width: 100%;\n                height: ", ";\n                margin: 0;\n                padding: 0 ", " 0 ", ";\n                color: inherit;\n                text-align: left;\n                text-overflow: ellipsis;\n                white-space: nowrap;\n                box-sizing: border-box;\n                outline: none;\n                border-radius: 4px;\n                ", "\n                " + ( true ? "" : 0)], ["\n                ", "\n                overflow: hidden;\n                position: relative;\n                display: block;\n                width: 100%;\n                height: ", ";\n                margin: 0;\n                padding: 0 ", " 0 ", ";\n                color: inherit;\n                text-align: left;\n                text-overflow: ellipsis;\n                white-space: nowrap;\n                box-sizing: border-box;\n                outline: none;\n                border-radius: 4px;\n                ", "\n                " + ( true ? "" : 0)])), RESET_BUTTON, pxToRem(40), pxToRem(40), pxToRem(indent || 14), isActive ? /*#__PURE__*/css(templateObject_7$i || (templateObject_7$i = __makeTemplateObject(["\n                    background-color: ", ";\n                    ", "\n                  " + ( true ? "" : 0)], ["\n                    background-color: ", ";\n                    ", "\n                  " + ( true ? "" : 0)])), theme.interactive.transparent, HOVER(templateObject_6$n || (templateObject_6$n = __makeTemplateObject(["\n                      background-color: ", ";\n                    "], ["\n                      background-color: ", ";\n                    "])), theme.content.base5)) : HOVER(templateObject_8$d || (templateObject_8$d = __makeTemplateObject(["\n                    background-color: ", ";\n                  "], ["\n                    background-color: ", ";\n                  "])), theme.content.base5))
      }, {
        children: [renderTitle(), jsx(Icon, {
          size: 12,
          name: isExpanded ? 'chevron_thick_up' : 'chevron_thick_down',
          css: /*#__PURE__*/css(templateObject_10$9 || (templateObject_10$9 = __makeTemplateObject(["\n                  position: absolute;\n                  top: ", ";\n                  right: ", ";\n                  color: ", ";\n                " + ( true ? "" : 0)], ["\n                  position: absolute;\n                  top: ", ";\n                  right: ", ";\n                  color: ", ";\n                " + ( true ? "" : 0)])), pxToRem(14), pxToRem(14), theme.content.base1)
        })]
      })), jsx(NavigationDrawerMenuAccordion, _assign({
        isExpanded: isExpanded,
        onTransitionStart: handleAccordionTransitionStart,
        onTransitionEnd: handleAccordionTransitionEnd
      }, {
        children: items && jsx(NavigationDrawerMenu, {
          items: items,
          fontStyles: fontStyles.slice(1),
          indents: indents.length > 1 ? indents.slice(1) : indents.slice(-1),
          onClose: onClose
        }) || renderChild && renderChild()
      }))]
    }) : jsx(Link, _assign({
      href: href,
      onClick: _onClick,
      css: /*#__PURE__*/css(templateObject_14 || (templateObject_14 = __makeTemplateObject(["\n              overflow: hidden;\n              display: block;\n              width: 100%;\n              height: ", ";\n              padding: 0 ", " 0 ", ";\n              color: inherit;\n              text-overflow: ellipsis;\n              white-space: nowrap;\n              box-sizing: border-box;\n              outline: none;\n              border-radius: 4px;\n              ", "\n            " + ( true ? "" : 0)], ["\n              overflow: hidden;\n              display: block;\n              width: 100%;\n              height: ", ";\n              padding: 0 ", " 0 ", ";\n              color: inherit;\n              text-overflow: ellipsis;\n              white-space: nowrap;\n              box-sizing: border-box;\n              outline: none;\n              border-radius: 4px;\n              ", "\n            " + ( true ? "" : 0)])), pxToRem(40), pxToRem(14), pxToRem(indent || 14), isActive ? /*#__PURE__*/css(templateObject_12$2 || (templateObject_12$2 = __makeTemplateObject(["\n                background-color: ", ";\n                ", "\n              " + ( true ? "" : 0)], ["\n                background-color: ", ";\n                ", "\n              " + ( true ? "" : 0)])), theme.interactive.transparent, HOVER(templateObject_11$4 || (templateObject_11$4 = __makeTemplateObject(["\n                  background-color: ", ";\n                "], ["\n                  background-color: ", ";\n                "])), theme.content.base5)) : HOVER(templateObject_13$2 || (templateObject_13$2 = __makeTemplateObject(["\n                background-color: ", ";\n              "], ["\n                background-color: ", ";\n              "])), theme.content.base5))
    }, {
      children: renderTitle()
    }))
  }));
}
var templateObject_1$Y, templateObject_2$N, templateObject_3$F, templateObject_4$z, templateObject_5$s, templateObject_6$n, templateObject_7$i, templateObject_8$d, templateObject_9$a, templateObject_10$9, templateObject_11$4, templateObject_12$2, templateObject_13$2, templateObject_14;

/**
 * @deprecated ODS의 Avatar 컴포넌트를 사용해 주세요.
 */
function Avatar(_a) {
  var size = _a.size,
    src = _a.src,
    rest = (0,common.e)(_a, ["size", "src"]);
  if (!src) return null;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(esm_Loading.R, (0,common.a)({}, rest, {
    src: src,
    intrinsicAspect: 1,
    objectFit: "cover",
    css: /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)(templateObject_1$X || (templateObject_1$X = (0,common._)(["\n        width: ", ";\n        height: ", ";\n        border-radius: 50%;\n      " + ( true ? "" : 0)], ["\n        width: ", ";\n        height: ", ";\n        border-radius: 50%;\n      " + ( true ? "" : 0)])), (0,foundation.p)(size), (0,foundation.p)(size))
  }));
}
var templateObject_1$X;

function NavigationDrawerHeader(_a) {
  var logo = _a.logo,
    action = _a.action,
    supplementary = _a.supplementary;
  var log = useLogContext();
  var userProfile = supplementary.userProfile,
    signup = supplementary.signup,
    signin = supplementary.signin;
  return jsxs(Fragment$1, {
    children: [jsxs("div", _assign({
      css: /*#__PURE__*/css(templateObject_1$W || (templateObject_1$W = __makeTemplateObject(["\n        position: relative;\n        font-size: ", ";\n        line-height: ", ";\n      " + ( true ? "" : 0)], ["\n        position: relative;\n        font-size: ", ";\n        line-height: ", ";\n      " + ( true ? "" : 0)])), pxToRem(14), pxToRem(18))
    }, {
      children: [jsx(Logo, _assign({}, logo, {
        onClick: function onClick() {
          return log({
            key: 'drawer.logo',
            category: 'click'
          });
        }
      })), action && function (_a) {
        var text = _a.text,
          rest = __rest(_a, ["text"]);
        return jsxs(TextButton, _assign({}, rest, {
          size: 32,
          variant: "primary1",
          css: /*#__PURE__*/css(templateObject_2$M || (templateObject_2$M = __makeTemplateObject(["\n              position: absolute;\n              top: 0;\n              right: 0;\n              display: flex;\n              align-items: center;\n              outline: none;\n            " + ( true ? "" : 0)], ["\n              position: absolute;\n              top: 0;\n              right: 0;\n              display: flex;\n              align-items: center;\n              outline: none;\n            " + ( true ? "" : 0)])))
        }, {
          children: [text, jsx(Icon, {
            name: "chevron_right",
            size: 12,
            fill: function fill(theme) {
              return theme.content.primary1.basic;
            },
            css: /*#__PURE__*/css(templateObject_3$E || (templateObject_3$E = __makeTemplateObject(["\n                margin-left: ", ";\n              " + ( true ? "" : 0)], ["\n                margin-left: ", ";\n              " + ( true ? "" : 0)])), pxToRem(4))
          })]
        }));
      }(action)]
    })), userProfile == null ? jsxs("div", _assign({
      css: /*#__PURE__*/css(templateObject_4$y || (templateObject_4$y = __makeTemplateObject(["\n          display: flex;\n          justify-content: space-between;\n          width: 100%;\n          margin: ", " 0 ", ";\n        " + ( true ? "" : 0)], ["\n          display: flex;\n          justify-content: space-between;\n          width: 100%;\n          margin: ", " 0 ", ";\n        " + ( true ? "" : 0)])), pxToRem(20), pxToRem(10))
    }, {
      children: [signin && jsx(OutlineAnchorButton, _assign({
        href: signin.href,
        size: 44,
        variant: "primary1",
        onClick: function onClick() {
          // to signIn page
        },
        css: /*#__PURE__*/css(templateObject_5$r || (templateObject_5$r = __makeTemplateObject(["\n                font-weight: bold;\n                outline: none;\n                display: flex;\n                flex: 1;\n                justify-content: center;\n                align-items: center;\n                height: ", ";\n              " + ( true ? "" : 0)], ["\n                font-weight: bold;\n                outline: none;\n                display: flex;\n                flex: 1;\n                justify-content: center;\n                align-items: center;\n                height: ", ";\n              " + ( true ? "" : 0)])), pxToRem(42))
      }, {
        children: "\uB85C\uADF8\uC778"
      })), signup && jsx(AnchorButton, _assign({
        href: signup.href,
        size: 44,
        variant: "primary1",
        onClick: function onClick() {
          // to signUp page
        },
        css: /*#__PURE__*/css(templateObject_6$m || (templateObject_6$m = __makeTemplateObject(["\n                margin-left: ", ";\n                font-weight: bold;\n                outline: none;\n                display: flex;\n                flex: 1;\n                justify-content: center;\n                align-items: center;\n              " + ( true ? "" : 0)], ["\n                margin-left: ", ";\n                font-weight: bold;\n                outline: none;\n                display: flex;\n                flex: 1;\n                justify-content: center;\n                align-items: center;\n              " + ( true ? "" : 0)])), pxToRem(8))
      }, {
        children: "\uD68C\uC6D0\uAC00\uC785"
      }))]
    })) : jsxs("div", _assign({
      css: /*#__PURE__*/css(templateObject_7$h || (templateObject_7$h = __makeTemplateObject(["\n          display: flex;\n          align-items: center;\n          margin: ", " 0 ", ";\n        " + ( true ? "" : 0)], ["\n          display: flex;\n          align-items: center;\n          margin: ", " 0 ", ";\n        " + ( true ? "" : 0)])), pxToRem(24), pxToRem(20))
    }, {
      children: [jsx(Avatar, {
        size: 20,
        src: userProfile.imageUrl
      }), jsx("p", _assign({
        css: /*#__PURE__*/css(templateObject_8$c || (templateObject_8$c = __makeTemplateObject(["\n            font-size: ", ";\n            line-height: ", ";\n            margin-left: ", ";\n          " + ( true ? "" : 0)], ["\n            font-size: ", ";\n            line-height: ", ";\n            margin-left: ", ";\n          " + ( true ? "" : 0)])), pxToRem(14), pxToRem(20), pxToRem(4))
      }, {
        children: userProfile.nickname
      }))]
    }))]
  });
}
var templateObject_1$W, templateObject_2$M, templateObject_3$E, templateObject_4$y, templateObject_5$r, templateObject_6$m, templateObject_7$h, templateObject_8$c;

function NavigationDrawerFooterListItem(_a) {
  var title = _a.title,
    href = _a.href,
    onClick = _a.onClick,
    onClose = _a.onClose;
  var theme = useTheme();
  var LinkComponent = useLinkContext();
  return jsx("li", _assign({
    css: [/*#__PURE__*/css(templateObject_1$V || (templateObject_1$V = __makeTemplateObject(["\n        display: inline-block;\n        padding: ", ";\n        border-radius: ", ";\n        margin: 0 0 0 ", ";\n        line-height: ", ";\n        &:first-of-type {\n          margin: 0;\n        }\n      " + ( true ? "" : 0)], ["\n        display: inline-block;\n        padding: ", ";\n        border-radius: ", ";\n        margin: 0 0 0 ", ";\n        line-height: ", ";\n        &:first-of-type {\n          margin: 0;\n        }\n      " + ( true ? "" : 0)])), pxToRem(6), pxToRem(4), pxToRem(7), pxToRem(18)), HOVER(templateObject_2$L || (templateObject_2$L = __makeTemplateObject(["\n        background-color: ", ";\n      "], ["\n        background-color: ", ";\n      "])), theme.background.groupedBase)]
  }, {
    children: href != null ? jsx(LinkComponent, _assign({
      href: href,
      css: /*#__PURE__*/css(templateObject_3$D || (templateObject_3$D = __makeTemplateObject(["\n            ", "\n            outline: none;\n            vertical-align: middle;\n            white-space: nowrap;\n          " + ( true ? "" : 0)], ["\n            ", "\n            outline: none;\n            vertical-align: middle;\n            white-space: nowrap;\n          " + ( true ? "" : 0)])), FONT_STYLE.subTitle2),
      onClick: onClose
    }, {
      children: title
    })) : jsx("button", _assign({
      css: /*#__PURE__*/css(templateObject_4$x || (templateObject_4$x = __makeTemplateObject(["\n            ", "\n            ", "\n            color: ", ";\n            outline: none;\n            cursor: pointer;\n            vertical-align: middle;\n            white-space: nowrap;\n          " + ( true ? "" : 0)], ["\n            ", "\n            ", "\n            color: ", ";\n            outline: none;\n            cursor: pointer;\n            vertical-align: middle;\n            white-space: nowrap;\n          " + ( true ? "" : 0)])), RESET_BUTTON, FONT_STYLE.subTitle2, theme.content.base1),
      onClick: onClick,
      type: "button"
    }, {
      children: title
    }))
  }));
}
function NavigationDrawerFooter(_a) {
  var items = _a.items,
    onClose = _a.onClose;
  return jsx("ul", _assign({
    css: /*#__PURE__*/css(templateObject_5$q || (templateObject_5$q = __makeTemplateObject(["\n      padding: 0;\n      margin-top: ", ";\n      display: flex;\n      align-items: center;\n      > button {\n        font-size: ", ";\n        font-weight: normal;\n      }\n    " + ( true ? "" : 0)], ["\n      padding: 0;\n      margin-top: ", ";\n      display: flex;\n      align-items: center;\n      > button {\n        font-size: ", ";\n        font-weight: normal;\n      }\n    " + ( true ? "" : 0)])), pxToRem(14), pxToRem(14))
  }, {
    children: items.map(function (item, index) {
      return jsx(NavigationDrawerFooterListItem, _assign({
        onClose: onClose
      }, item), index);
    })
  }));
}
var templateObject_1$V, templateObject_2$L, templateObject_3$D, templateObject_4$x, templateObject_5$q;

function NavigationDrawer(_a) {
  var open = _a.open,
    logo = _a.logo,
    menuSchema = _a.menuSchema,
    supplementary = _a.supplementary,
    onClose = _a.onClose,
    onAppDownload = _a.onAppDownload,
    rest = __rest(_a, ["open", "logo", "menuSchema", "supplementary", "onClose", "onAppDownload"]);
  var userMenu = supplementary.userMenu,
    _b = supplementary.showAppDownloadButton,
    showAppDownloadButton = _b === void 0 ? true : _b;
  var log = useLogContext();
  var t = useTranslation().t;
  var drawerMenu = useMemo(function () {
    return menuSchema.map(function (mainMenu) {
      var _a;
      return _assign(_assign({}, mainMenu), {
        onClick: function onClick(_a) {
          var index = _a.index;
          log({
            key: 'drawer.main.item',
            category: 'click',
            params: {
              index: index
            }
          });
        },
        entries: (_a = mainMenu.entries) === null || _a === void 0 ? void 0 : _a.map(function (subMenu) {
          return _assign(_assign({}, subMenu), {
            onClick: function onClick(_a) {
              var href = _a.item.href,
                index = _a.index;
              log({
                key: 'drawer.sub.item',
                category: 'click',
                params: {
                  index: index,
                  href: href
                }
              });
            }
          });
        })
      });
    });
  }, [menuSchema, log]);
  var drawerUserMenu = useMemo(function () {
    return userMenu.filter(function (menu) {
      var _a;
      return (_a = menu.showOn) === null || _a === void 0 ? void 0 : _a.includes('drawer');
    }).map(function (_a) {
      var title = _a.title,
        href = _a.href,
        bullet = _a.bullet;
      return {
        title: title,
        href: href,
        bullet: bullet,
        onClick: function onClick(_a) {
          var index = _a.index;
          log({
            key: 'drawer.user.item',
            category: 'click',
            params: {
              index: index
            }
          });
        }
      };
    });
  }, [userMenu, log]);
  var drawerFooterMenu = useMemo(function () {
    return userMenu.filter(function (menu) {
      return menu.type === 'bottom';
    });
  }, [userMenu]);
  return jsxs(Drawer, _assign({
    open: open,
    width: 270,
    onClose: onClose
  }, rest, {
    children: [jsx(NavigationDrawerHeader, {
      logo: {
        logo: logo,
        onClick: function onClick() {
          return window.open((logo === null || logo === void 0 ? void 0 : logo.href) || 'https://ohou.se');
        }
      },
      action: showAppDownloadButton ? {
        text: t('COMMON__DOWNLOADAPP', '앱다운로드'),
        onClick: function onClick() {
          log({
            key: 'drawer.user.profile',
            category: 'click'
          });
          onAppDownload === null || onAppDownload === void 0 ? void 0 : onAppDownload();
        }
      } : undefined,
      supplementary: supplementary
    }), jsx(NavigationDrawerDivider, {}), jsx(NavigationDrawerMenu, {
      items: drawerMenu,
      fontStyles: [{
        size: 16,
        weight: 'bold'
      }],
      indents: [14, 42, 50],
      onClose: onClose
    }), drawerUserMenu.length > 0 && jsx(NavigationDrawerDivider, {}), jsx(NavigationDrawerMenu, {
      items: drawerUserMenu,
      onClose: onClose
    }), jsx(NavigationDrawerDivider, {}), jsx(NavigationDrawerFooter, {
      items: drawerFooterMenu,
      onClose: onClose
    })]
  }));
}

function Navigation(props) {
  var logo = props.logo,
    menuSchema = props.menuSchema,
    searchOptions = props.searchOptions,
    supplementary = props.supplementary,
    fallbackMenuSchema = props.fallbackMenuSchema,
    linkComponent = props.linkComponent,
    onLog = props.onLog,
    onAppDownload = props.onAppDownload,
    location = props.location;
  var _a = useState(false),
    isDrawerOpen = _a[0],
    setDrawerOpen = _a[1];
  var handleDrawerToggle = useCallback(function () {
    setDrawerOpen(function (v) {
      return !v;
    });
  }, []);
  var handleDrawerClose = useCallback(function () {
    setDrawerOpen(false);
  }, []);
  var isInApp = useIsInApp(location);
  if (isInApp) {
    return null;
  }
  return jsx(LinkProvider, _assign({
    linkComponent: linkComponent
  }, {
    children: jsx(LogProvider, _assign({
      onLog: onLog
    }, {
      children: jsxs(Fragment$1, {
        children: [jsx(NavigationBar, {
          logo: logo,
          menuSchema: menuSchema,
          primaryLeftmost: jsx(Button$1, _assign({
            type: "button",
            onClick: function onClick() {
              onLog({
                key: 'drawer.button',
                category: 'click'
              });
              handleDrawerToggle();
            }
          }, {
            children: jsx(Icon, {
              size: 24,
              name: "menu"
            })
          })),
          searchOptions: searchOptions,
          supplementary: supplementary,
          fallbackMenuSchema: fallbackMenuSchema
        }), jsx(NavigationDrawer, {
          open: isDrawerOpen,
          logo: logo,
          menuSchema: menuSchema,
          supplementary: supplementary,
          onOpen: handleDrawerToggle,
          onClose: handleDrawerClose,
          onAppDownload: onAppDownload
        })]
      })
    }))
  }));
}
var Button$1 = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("button",  true ? {
  target: "ebs7dy10"
} : 0)(templateObject_1$U || (templateObject_1$U = (0,common._)(["\n  ", "\n  padding: ", ";\n  margin: ", " ", ";\n  color: ", ";\n  outline: none;\n"], ["\n  ", "\n  padding: ", ";\n  margin: ", " ", ";\n  color: ", ";\n  outline: none;\n"])), foundation.R, (0,foundation.p)(6), (0,foundation.p)(3), (0,foundation.p)(1), function (_a) {
  var theme = _a.theme;
  return theme.content.base1;
});
var templateObject_1$U;

var NavigationRightButton = /*#__PURE__*/(/* unused pure expression or super */ null && (memo(function (_a) {
  var title = _a.title,
    href = _a.href;
  var theme = useTheme();
  var LinkComponent = useLinkContext();
  var log = useLogContext();
  return jsx(LinkComponent, _assign({
    href: href,
    css: [/*#__PURE__*/css(templateObject_1$T || (templateObject_1$T = __makeTemplateObject(["\n          display: flex;\n          align-items: center;\n          ", ";\n          color: ", ";\n          font-weight: 700;\n          outline: none;\n        " + ( true ? "" : 0)], ["\n          display: flex;\n          align-items: center;\n          ", ";\n          color: ", ";\n          font-weight: 700;\n          outline: none;\n        " + ( true ? "" : 0)])), FONT_STYLE.subTitle1, theme.content.primary1.basic), FOCUS(templateObject_2$K || (templateObject_2$K = __makeTemplateObject(["\n          & > span {\n            box-shadow: 0 0 0 ", " ", ";\n          }\n        "], ["\n          & > span {\n            box-shadow: 0 0 0 ", " ", ";\n          }\n        "])), pxToRem(3), theme.content.primary1.thin)],
    onClick: function onClick() {
      return log({
        key: 'secondary.interior',
        category: 'click'
      });
    }
  }, {
    children: jsxs("span", _assign({
      css: /*#__PURE__*/css(templateObject_3$C || (templateObject_3$C = __makeTemplateObject(["\n        display: inline-block;\n        padding: ", ";\n        margin: ", ";\n        border-radius: ", ";\n      " + ( true ? "" : 0)], ["\n        display: inline-block;\n        padding: ", ";\n        margin: ", ";\n        border-radius: ", ";\n      " + ( true ? "" : 0)])), pxToRem(4), pxToRem(-4), pxToRem(3))
    }, {
      children: [title, jsx(Icon, {
        css: /*#__PURE__*/css(templateObject_4$w || (templateObject_4$w = __makeTemplateObject(["\n          margin-left: 8px;\n          line-height: 0;\n        " + ( true ? "" : 0)], ["\n          margin-left: 8px;\n          line-height: 0;\n        " + ( true ? "" : 0)]))),
        name: "chevron_thick_right",
        size: 18
      })]
    }))
  }));
})));
var templateObject_1$T, templateObject_2$K, templateObject_3$C, templateObject_4$w;

var TYPE_MAP = {
  'logo': function logo() {
    return {
      click: {
        bucket: {
          section: '로고'
        }
      }
    };
  },
  // primary
  'primary.item': function primaryItem(_a) {
    var index = _a.index;
    return {
      click: {
        bucket: {
          section: '메인 메뉴',
          index: index
        }
      }
    };
  },
  'primary.right.search.input': function primaryRightSearchInput(_a) {
    var search_type = _a.search_type;
    return {
      click: {
        bucket: {
          section: '검색'
        },
        amplitude: {
          type: '검색 필드 Clicked',
          search_type: search_type
        }
      }
    };
  },
  'primary.right.search.autocomplete.query': function primaryRightSearchAutocompleteQuery(_a) {
    var id = _a.id,
      type = _a.type,
      index = _a.index;
    return {
      click: {
        bucket: {
          section: '자동완성',
          id: id,
          type: type,
          index: index
        }
      }
    };
  },
  'primary.right.search.autocomplete.category': function primaryRightSearchAutocompleteCategory(_a) {
    var id = _a.id,
      type = _a.type,
      index = _a.index;
    return {
      click: {
        bucket: {
          section: '추천 카테고리',
          id: id,
          type: type,
          index: index
        }
      }
    };
  },
  'primary.right.search.history': function primaryRightSearchHistory(_a) {
    var id = _a.id,
      type = _a.type,
      index = _a.index;
    return {
      click: {
        bucket: {
          section: '최근 검색어',
          id: id,
          type: type,
          index: index
        }
      },
      impression: {
        bucket: {
          section: '최근 검색어',
          type: type
        }
      }
    };
  },
  'primary.right.scrap': function primaryRightScrap() {
    return {
      click: {
        bucket: {
          section: '스크랩북'
        },
        amplitude: {
          type: '스크랩북 Viewed',
          data: {
            source: {
              page: {
                tab: {
                  main: '스크랩북'
                }
              },
              referrer: {
                type: '바로가기'
              }
            }
          }
        }
      }
    };
  },
  'primary.right.cart': function primaryRightCart() {
    return {
      click: {
        bucket: {
          section: '장바구니'
        }
      }
    };
  },
  'primary.right.notification': function primaryRightNotification() {
    return {
      click: {
        bucket: {
          section: '알림'
        },
        amplitude: {
          type: '알림 리스트 Viewed'
        }
      }
    };
  },
  'primary.right.login': function primaryRightLogin() {
    return {
      click: {
        bucket: {
          section: '로그인'
        }
      }
    };
  },
  'primary.right.signup': function primaryRightSignup() {
    return {
      click: {
        bucket: {
          section: '회원가입'
        }
      }
    };
  },
  'primary.right.cs': function primaryRightCs() {
    return {
      click: {
        bucket: {
          section: '고객센터'
        }
      }
    };
  },
  'primary.right.mypage': function primaryRightMypage() {
    return {
      click: {
        amplitude: {
          type: '계정 Viewed'
        }
      }
    };
  },
  'primary.right.logout': function primaryRightLogout() {
    return {
      click: {
        amplitude: {
          type: '계정 Logout'
        }
      }
    };
  },
  'primary.right.upload': function primaryRightUpload() {
    return {
      click: {
        bucket: {
          section: '글쓰기'
        }
      }
    };
  },
  'primary.right.upload.photo': function primaryRightUploadPhoto() {
    return {
      click: {
        bucket: {
          section: '사진 올리기'
        }
      }
    };
  },
  // secondary
  'secondary.item': function secondaryItem(_a) {
    var index = _a.index,
      href = _a.href,
      rest = (0,common.e)(_a, ["index", "href"]);
    return {
      click: {
        bucket: (0,common.a)({
          index: index,
          url: typeof href === 'string' ? href : '/'
        }, rest)
      },
      impression: {
        bucket: (0,common.a)({
          index: index
        }, rest)
      }
    };
  },
  'secondary.interior': function secondaryInterior() {
    return {
      click: {
        bucket: {
          section: '3D인테리어'
        }
      }
    };
  },
  'secondary.more.button': function secondaryMoreButton() {
    return {
      click: {
        bucket: {
          section: '토픽',
          section_id: 'TOPIC',
          type: 'button',
          id: 'more_button'
        }
      }
    };
  },
  // tertiary
  'tertiary.store.category.item': function tertiaryStoreCategoryItem(_a) {
    var id = _a.id,
      index = _a.index;
    return {
      click: {
        bucket: {
          section: '카테고리 메뉴',
          type: 'category',
          id: id,
          index: index
        }
      }
    };
  },
  // drawer
  'drawer.logo': function drawerLogo() {
    return {
      click: {
        bucket: {
          section: 'drawer 로고'
        }
      }
    };
  },
  'drawer.button': function drawerButton() {
    return {
      click: {
        bucket: {
          section: '햄버거 메뉴'
        }
      }
    };
  },
  'drawer.main.item': function drawerMainItem(_a) {
    var index = _a.index;
    return {
      click: {
        bucket: {
          section: '메인 메뉴',
          index: index
        }
      }
    };
  },
  'drawer.sub.item': function drawerSubItem(_a) {
    var index = _a.index,
      href = _a.href;
    return {
      click: {
        bucket: {
          section: '서브 메뉴',
          index: index,
          url: typeof href === 'string' ? href : '/'
        }
      }
    };
  },
  'drawer.user.item': function drawerUserItem(_a) {
    var index = _a.index;
    return {
      click: {
        bucket: {
          section: '유저 메뉴',
          index: index
        }
      }
    };
  },
  'drawer.user.profile': function drawerUserProfile() {
    return {
      click: {
        bucket: {
          section: '유저 프로필'
        },
        amplitude: {
          type: '계정 Viewed'
        }
      }
    };
  }
};

var _g;
function bds_extends() { bds_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return bds_extends.apply(this, arguments); }
var SvgLogo = function SvgLogo(props) {
  return /*#__PURE__*/react.createElement("svg", bds_extends({
    className: "logo_svg__icon",
    viewBox: "0 0 20 20"
  }, props), _g || (_g = /*#__PURE__*/react.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/react.createElement("path", {
    fill: "#35C5F0",
    d: "M16.41 0H3.59A3.59 3.59 0 0 0 0 3.59v12.82A3.59 3.59 0 0 0 3.59 20h12.82A3.59 3.59 0 0 0 20 16.41V3.59A3.59 3.59 0 0 0 16.41 0"
  }), /*#__PURE__*/react.createElement("path", {
    fill: "#FFF",
    d: "M14.75 10.34c-.74 0-1.33-.6-1.33-1.34s.6-1.34 1.33-1.34 1.32.6 1.32 1.34-.59 1.34-1.32 1.34m-1 3.53H6.12V8.75l3.82-2.7 2.2 1.55a3 3 0 0 0-.35 1.4 3 3 0 0 0 1.98 2.83v2.04zm1-7.87c-.34 0-.66.06-.97.17l-3.17-2.24a1.18 1.18 0 0 0-1.35 0L4.5 7.28a1.2 1.2 0 0 0-.51.98v6.54c0 .66.53 1.2 1.19 1.2h9.5a1.2 1.2 0 0 0 1.18-1.2v-3.02A3 3 0 0 0 17.7 9c0-1.65-1.32-3-2.96-3z"
  }))));
};
var LogoIcon = SvgLogo;

function AppDownloadPopup(_a) {
  var _b, _c, _d, _e;
  var isOpen = _a.isOpen,
    onClose = _a.onClose,
    _f = _a.onAppOpen,
    onAppOpen = _f === void 0 ? function () {
      //
    } : _f,
    localeData = _a.localeData;
  var theme = (0,emotion_element_5486c51c_browser_esm.u)();
  var _g = (0,react.useState)(false),
    hasBottomPadding = _g[0],
    setHasBottomPadding = _g[1];
  var isDescriptionShown = (0,react.useMemo)(function () {
    return localeData == null || (localeData === null || localeData === void 0 ? void 0 : localeData.description) != null;
  }, [localeData]);
  (0,react.useEffect)(function () {
    if (/(?:iPad|iPhone|iPod).*Instagram/gi.test(navigator.userAgent)) {
      setHasBottomPadding(true);
    }
  }, []);
  if (!isOpen) return null;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Modal, (0,common.a)({
    width: 400
  }, {
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", (0,common.a)({
      css: /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)(templateObject_2$J || (templateObject_2$J = (0,common._)(["\n        box-sizing: content-box;\n        max-width: ", ";\n        margin: 0 auto;\n        padding: ", " ", ";\n        text-align: left;\n        ", "\n      " + ( true ? "" : 0)], ["\n        box-sizing: content-box;\n        max-width: ", ";\n        margin: 0 auto;\n        padding: ", " ", ";\n        text-align: left;\n        ", "\n      " + ( true ? "" : 0)])), (0,foundation.p)(325), (0,foundation.p)(30), (0,foundation.p)(36), hasBottomPadding && /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)(templateObject_1$S || (templateObject_1$S = (0,common._)(["\n          padding-bottom: ", ";\n        " + ( true ? "" : 0)], ["\n          padding-bottom: ", ";\n        " + ( true ? "" : 0)])), (0,foundation.p)(100)))
    }, {
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", (0,common.a)({
        css: /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)(templateObject_3$B || (templateObject_3$B = (0,common._)(["\n          display: flex;\n          justify-content: center;\n          margin-bottom: ", ";\n        " + ( true ? "" : 0)], ["\n          display: flex;\n          justify-content: center;\n          margin-bottom: ", ";\n        " + ( true ? "" : 0)])), (0,foundation.p)(28))
      }, {
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LogoIcon, {
          css: /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)(templateObject_4$v || (templateObject_4$v = (0,common._)(["\n              flex: 0 0 auto;\n              width: ", ";\n              height: ", ";\n              margin-right: ", ";\n            " + ( true ? "" : 0)], ["\n              flex: 0 0 auto;\n              width: ", ";\n              height: ", ";\n              margin-right: ", ";\n            " + ( true ? "" : 0)])), (0,foundation.p)(70), (0,foundation.p)(70), (0,foundation.p)(12))
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", (0,common.a)({
          css: /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)(templateObject_5$p || (templateObject_5$p = (0,common._)(["\n            flex: 0 1 auto;\n            min-width: 0;\n            display: flex;\n            flex-direction: column;\n            justify-content: center;\n          " + ( true ? "" : 0)], ["\n            flex: 0 1 auto;\n            min-width: 0;\n            display: flex;\n            flex-direction: column;\n            justify-content: center;\n          " + ( true ? "" : 0)])))
        }, {
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", (0,common.a)({
            "data-testid": "popup-title",
            css: /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)(templateObject_6$l || (templateObject_6$l = (0,common._)(["\n                ", "\n                font-weight: 700;\n                color: ", ";\n                white-space: pre-line;\n                word-break: break-word;\n              " + ( true ? "" : 0)], ["\n                ", "\n                font-weight: 700;\n                color: ", ";\n                white-space: pre-line;\n                word-break: break-word;\n              " + ( true ? "" : 0)])), foundation.F.title3, theme.content.base1)
          }, {
            children: (_b = localeData === null || localeData === void 0 ? void 0 : localeData.title) !== null && _b !== void 0 ? _b : '앱에서는 1초만에!\n간편하게 로그인하기'
          })), isDescriptionShown && (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", (0,common.a)({
            css: /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)(templateObject_7$g || (templateObject_7$g = (0,common._)(["\n                  display: flex;\n                  align-items: center;\n                  font-size: ", ";\n                  line-height: 1;\n                  gap: ", ";\n                  margin-top: ", ";\n                " + ( true ? "" : 0)], ["\n                  display: flex;\n                  align-items: center;\n                  font-size: ", ";\n                  line-height: 1;\n                  gap: ", ";\n                  margin-top: ", ";\n                " + ( true ? "" : 0)])), (0,foundation.p)(11), (0,foundation.p)(2), (0,foundation.p)(8))
          }, {
            children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", (0,common.a)({
              css: /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)(templateObject_8$b || (templateObject_8$b = (0,common._)(["\n                      display: flex;\n                      gap: ", ";\n                    " + ( true ? "" : 0)], ["\n                      display: flex;\n                      gap: ", ";\n                    " + ( true ? "" : 0)])), (0,foundation.p)(2))
            }, {
              children: new Array(5).fill(0).map(function (_, index) {
                return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(icons.aQ, {
                  size: 12,
                  fill: function fill(theme) {
                    return theme.content.primary1.basic;
                  }
                }, index);
              })
            })), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", (0,common.a)({
              "data-testid": "popup-description",
              css: /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)(templateObject_9$9 || (templateObject_9$9 = (0,common._)(["\n                    ", "\n                    display: inline-block;\n                    color: ", ";\n                    font-weight: 400;\n                  " + ( true ? "" : 0)], ["\n                    ", "\n                    display: inline-block;\n                    color: ", ";\n                    font-weight: 400;\n                  " + ( true ? "" : 0)])), foundation.F.caption2, theme.content.base2)
            }, {
              children: (_c = localeData === null || localeData === void 0 ? void 0 : localeData.description) !== null && _c !== void 0 ? _c : '특가, 쿠폰 등 앱 전용 혜택까지'
            }))]
          }))]
        }))]
      })), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Button$2, (0,common.a)({
        type: "button",
        size: 44,
        variant: "primary1",
        full: true,
        onClick: onAppOpen,
        "aria-label": "\uC624\uB298\uC758\uC9D1 \uC571\uC73C\uB85C \uBCF4\uAE30"
      }, {
        children: (_d = localeData === null || localeData === void 0 ? void 0 : localeData.appDownloadButtonText) !== null && _d !== void 0 ? _d : '편리한 앱으로 보기'
      })), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("button", (0,common.a)({
        css: /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)(templateObject_10$8 || (templateObject_10$8 = (0,common._)(["\n            ", "\n            ", "\n            color: ", ";\n            text-align: center;\n            width: 100%;\n            margin-top: ", ";\n            font-weight: 500;\n          " + ( true ? "" : 0)], ["\n            ", "\n            ", "\n            color: ", ";\n            text-align: center;\n            width: 100%;\n            margin-top: ", ";\n            font-weight: 500;\n          " + ( true ? "" : 0)])), foundation.R, foundation.F.body14L18, theme.content.base2, (0,foundation.p)(12)),
        type: "button",
        onClick: function onClick() {
          onClose();
        },
        "aria-label": "\uB2EB\uAE30"
      }, {
        children: (_e = localeData === null || localeData === void 0 ? void 0 : localeData.remainWebButtonText) !== null && _e !== void 0 ? _e : '모바일 웹으로 볼래요'
      }))]
    }))
  }));
}
var templateObject_1$S, templateObject_2$J, templateObject_3$B, templateObject_4$v, templateObject_5$p, templateObject_6$l, templateObject_7$g, templateObject_8$b, templateObject_9$9, templateObject_10$8;

function AppDownloadPopupContainer(props) {
  var onCheck = props.onCheck,
    onAppOpen = props.onAppOpen,
    onClose = props.onClose,
    localeData = props.localeData;
  var _a = (0,react.useState)(false),
    isOpen = _a[0],
    setOpen = _a[1];
  var checked = onCheck();
  (0,react.useEffect)(function () {
    setOpen(checked);
  }, [checked]);
  var handleClose = (0,react.useCallback)(function () {
    onClose();
    setOpen(false);
  }, [onClose]);
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AppDownloadPopup, {
    isOpen: isOpen,
    onClose: handleClose,
    onAppOpen: onAppOpen,
    localeData: localeData
  });
}

/** FIXME: imageSrc 제거 */
function MobileTopBanner(_a) {
  var _b, _c;
  var isOpen = _a.isOpen,
    onClose = _a.onClose,
    _d = _a.onAppOpen,
    onAppOpen = _d === void 0 ? function () {
      //
    } : _d;
    _a.imageSrc;
    var className = _a.className,
    localeData = _a.localeData;
  var theme = (0,emotion_element_5486c51c_browser_esm.u)();
  if (!isOpen) return null;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", (0,common.a)({
    className: className,
    css: /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)(templateObject_1$R || (templateObject_1$R = (0,common._)(["\n        ", "\n        position: relative;\n        width: 100%;\n        box-sizing: border-box;\n        z-index: ", ";\n        background-color: ", ";\n        display: none;\n        overflow: hidden;\n        padding: ", " ", " ", " 0;\n        ", "\n      " + ( true ? "" : 0)], ["\n        ", "\n        position: relative;\n        width: 100%;\n        box-sizing: border-box;\n        z-index: ", ";\n        background-color: ", ";\n        display: none;\n        overflow: hidden;\n        padding: ", " ", " ", " 0;\n        ", "\n      " + ( true ? "" : 0)])), foundation.R, common.Z.banner, theme.background.groupedBase, (0,foundation.p)(18), (0,foundation.p)(16), (0,foundation.p)(18), foundation.M.max('mobile', "\n          display: flex;\n        "))
  }, {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("button", {
      type: "button",
      css: /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)(templateObject_2$I || (templateObject_2$I = (0,common._)(["\n          ", "\n          position: absolute;\n          width: 100%;\n          height: 100%;\n          top: 0;\n          left: 0;\n        " + ( true ? "" : 0)], ["\n          ", "\n          position: absolute;\n          width: 100%;\n          height: 100%;\n          top: 0;\n          left: 0;\n        " + ( true ? "" : 0)])), foundation.R),
      "aria-label": "\uC624\uB298\uC758\uC9D1 \uC571\uC73C\uB85C \uBCF4\uAE30",
      onClick: onAppOpen
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("button", (0,common.a)({
      type: "button",
      css: /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)(templateObject_3$A || (templateObject_3$A = (0,common._)(["\n          ", "\n          display: flex;\n          color: ", ";\n          width: 44px;\n          align-items: center;\n          flex-shrink: 0;\n          z-index: 1;\n          padding: 0 16px;\n        " + ( true ? "" : 0)], ["\n          ", "\n          display: flex;\n          color: ", ";\n          width: 44px;\n          align-items: center;\n          flex-shrink: 0;\n          z-index: 1;\n          padding: 0 16px;\n        " + ( true ? "" : 0)])), foundation.R, theme.content.base2),
      "aria-label": "\uB2EB\uAE30",
      onClick: function onClick(e) {
        onClose();
        e.stopPropagation();
      }
    }, {
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(icons.T, {
        size: 12,
        fill: function fill(theme) {
          return theme.content.base2;
        }
      })
    })), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", (0,common.a)({
      css: /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)(templateObject_4$u || (templateObject_4$u = (0,common._)(["\n          display: flex;\n          align-items: center;\n          width: calc(100% - ", ");\n        " + ( true ? "" : 0)], ["\n          display: flex;\n          align-items: center;\n          width: calc(100% - ", ");\n        " + ( true ? "" : 0)])), (0,foundation.p)(44))
    }, {
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LogoIcon, {
        css: /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)(templateObject_5$o || (templateObject_5$o = (0,common._)(["\n            width: ", ";\n            height: ", ";\n            margin-right: ", ";\n            flex-shrink: 0;\n          " + ( true ? "" : 0)], ["\n            width: ", ";\n            height: ", ";\n            margin-right: ", ";\n            flex-shrink: 0;\n          " + ( true ? "" : 0)])), (0,foundation.p)(40), (0,foundation.p)(40), (0,foundation.p)(8))
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", (0,common.a)({
        "data-testid": "banner-title",
        css: /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)(templateObject_6$k || (templateObject_6$k = (0,common._)(["\n          ", "\n          color: ", ";\n          font-weight: 600;\n          white-space: pre-line;\n          word-break: break-word;\n          text-align: left;\n          flex-grow: 1;\n        " + ( true ? "" : 0)], ["\n          ", "\n          color: ", ";\n          font-weight: 600;\n          white-space: pre-line;\n          word-break: break-word;\n          text-align: left;\n          flex-grow: 1;\n        " + ( true ? "" : 0)])), foundation.F.body2_small, theme.content.base1)
      }, {
        children: (_b = localeData === null || localeData === void 0 ? void 0 : localeData.title) !== null && _b !== void 0 ? _b : '앱에서 1초만에!\n간편하게 로그인하기'
      })), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Button$2, (0,common.a)({
        "data-testid": "banner-button",
        size: 32,
        variant: "primary1",
        css: /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)(templateObject_7$f || (templateObject_7$f = (0,common._)(["\n            font-weight: 700;\n            flex-shrink: 0;\n            margin-left: ", ";\n          " + ( true ? "" : 0)], ["\n            font-weight: 700;\n            flex-shrink: 0;\n            margin-left: ", ";\n          " + ( true ? "" : 0)])), (0,foundation.p)(16)),
        onClick: onAppOpen
      }, {
        children: (_c = localeData === null || localeData === void 0 ? void 0 : localeData.appDownloadButtonText) !== null && _c !== void 0 ? _c : '앱으로 보기'
      }))]
    }))]
  }));
}
var templateObject_1$R, templateObject_2$I, templateObject_3$A, templateObject_4$u, templateObject_5$o, templateObject_6$k, templateObject_7$f;

var getContentsUrl = function getContentsUrl(_a) {
  var contentId = _a.contentId,
    contentType = _a.contentType,
    contentUrl = _a.contentUrl,
    isUserLoggedIn = _a.isUserLoggedIn,
    origin = _a.origin;
  switch (contentType === null || contentType === void 0 ? void 0 : contentType.split(/(?=[A-Z])/).join('_').toLowerCase()) {
    case 'competition':
      return "".concat(origin, "/competitions/").concat(contentId);
    case 'production':
      return "".concat(origin, "/productions/").concat(contentId, "/selling");
    case 'exhibition':
      return "".concat(origin, "/exhibitions/").concat(contentId);
    case 'advice':
      return "".concat(origin, "/advices/").concat(contentId);
    case 'project':
      return "".concat(origin, "/projects/").concat(contentId, "/detail");
    case 'card_collection':
      return "".concat(origin, "/contents/card_collections/").concat(contentId);
    case 'invite_friend':
      if (!isUserLoggedIn) {
        return "".concat(origin, "/users/sign_in?redirect_to=/invite_codes/recommend_code");
      }
      return "".concat(origin, "/invite_codes/recommend_code");
    default:
      return contentUrl || '';
  }
};
function PCTopBanner(_a) {
  var className = _a.className,
    isOpen = _a.isOpen,
    onClose = _a.onClose,
    _onClick = _a.onClick,
    contentList = _a.contentList,
    linkComponent = _a.linkComponent,
    isUserLoggedIn = _a.isUserLoggedIn,
    origin = _a.origin;
  var LinkComponent = linkComponent;
  var backgroundContent = [contentList[0], contentList[contentList.length - 1]];
  if (!isOpen) return null;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", (0,common.a)({
    className: className,
    css: /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)(templateObject_1$Q || (templateObject_1$Q = (0,common._)(["\n        position: relative;\n        display: none;\n        z-index: ", ";\n        ", "\n      " + ( true ? "" : 0)], ["\n        position: relative;\n        display: none;\n        z-index: ", ";\n        ", "\n      " + ( true ? "" : 0)])), common.Z.banner, foundation.M.min('tablet', "\n          display: block;\n        "))
  }, {
    children: [backgroundContent.map(function (content, index) {
      /* 왼쪽, 오른쪽 배너의 끝 부분을 채워주기 위해 필요합니다. */
      var pcGradientColor = content.pcGradientColor;
      var url = getContentsUrl((0,common.a)((0,common.a)({}, content), {
        isUserLoggedIn: isUserLoggedIn,
        origin: origin
      }));
      var isFirst = index === 0;
      return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LinkComponent, {
        href: url,
        "aria-label": "PC \uCD5C\uC0C1\uB2E8 \uBC30\uB108",
        onClick: function onClick() {
          return _onClick && _onClick(content, index >= 1 ? contentList.length - 1 : 0);
        },
        css: /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)(templateObject_2$H || (templateObject_2$H = (0,common._)(["\n              position: absolute;\n              top: 0;\n              bottom: 0;\n              width: 50%;\n              background-color: ", ";\n              ", "\n            " + ( true ? "" : 0)], ["\n              position: absolute;\n              top: 0;\n              bottom: 0;\n              width: 50%;\n              background-color: ", ";\n              ", "\n            " + ( true ? "" : 0)])), pcGradientColor, isFirst ? 'left: 0;' : 'right: 0;')
      }, index);
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", (0,common.a)({
      css: /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)(templateObject_3$z || (templateObject_3$z = (0,common._)(["\n          display: flex;\n          max-width: ", ";\n          margin: 0 auto;\n          padding: 0 ", ";\n          ", "\n        " + ( true ? "" : 0)], ["\n          display: flex;\n          max-width: ", ";\n          margin: 0 auto;\n          padding: 0 ", ";\n          ", "\n        " + ( true ? "" : 0)])), (0,foundation.p)(1156), (0,foundation.p)(40), foundation.M.min('laptop', "\n            padding: 0 ".concat((0,foundation.p)(60), ";\n          ")))
    }, {
      children: contentList.map(function (content, index) {
        var coverImageUrl = content.coverImageUrl,
          pcGradientColor = content.pcGradientColor;
        var url = getContentsUrl((0,common.a)((0,common.a)({}, content), {
          isUserLoggedIn: isUserLoggedIn,
          origin: origin
        }));
        return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LinkComponent, {
          href: url,
          onClick: function onClick() {
            return _onClick && _onClick(content, index);
          },
          "aria-label": "PC \uCD5C\uC0C1\uB2E8 \uBC30\uB108",
          css: /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)(templateObject_4$t || (templateObject_4$t = (0,common._)(["\n                  flex: 1 0 0;\n                  background-image: url(", ");\n                  background-color: ", ";\n                  position: relative;\n                  height: ", ";\n                  background-size: auto 100%;\n                  background-repeat: no-repeat;\n                  background-position: center;\n                  z-index: 1;\n                " + ( true ? "" : 0)], ["\n                  flex: 1 0 0;\n                  background-image: url(", ");\n                  background-color: ", ";\n                  position: relative;\n                  height: ", ";\n                  background-size: auto 100%;\n                  background-repeat: no-repeat;\n                  background-position: center;\n                  z-index: 1;\n                " + ( true ? "" : 0)])), coverImageUrl, pcGradientColor, (0,foundation.p)(50))
        }, index);
      })
    })), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("button", (0,common.a)({
      css: /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)(templateObject_5$n || (templateObject_5$n = (0,common._)(["\n          ", "\n          position: absolute;\n          top: 50%;\n          right: ", ";\n          display: block;\n          margin: -", " 0 0;\n          padding: ", ";\n          color: white;\n          width: ", ";\n          height: ", ";\n          box-sizing: border-box;\n          font-size: 0;\n          line-height: 0;\n        " + ( true ? "" : 0)], ["\n          ", "\n          position: absolute;\n          top: 50%;\n          right: ", ";\n          display: block;\n          margin: -", " 0 0;\n          padding: ", ";\n          color: white;\n          width: ", ";\n          height: ", ";\n          box-sizing: border-box;\n          font-size: 0;\n          line-height: 0;\n        " + ( true ? "" : 0)])), foundation.R, (0,foundation.p)(8), (0,foundation.p)(25), (0,foundation.p)(12), (0,foundation.p)(48), (0,foundation.p)(48)),
      type: "button",
      "aria-label": "\uB2EB\uAE30",
      onClick: function onClick() {
        onClose();
      }
    }, {
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Icon, {
        size: 24,
        name: "dismiss_thick",
        fill: function fill(theme) {
          return theme.background.base;
        }
      })
    }))]
  }));
}
var templateObject_1$Q, templateObject_2$H, templateObject_3$z, templateObject_4$t, templateObject_5$n;

function TopBannerContainer(props) {
  var pathname = props.pathname,
    isVisible = props.isVisible,
    onCheck = props.onCheck,
    onClose = props.onClose,
    ssrCheckLiteral = props.ssrCheckLiteral,
    ssrClassName = props.ssrClassName,
    children = props.children;
  /**
   * isOpen과 isUnsure은 무엇인가요? ...
   * React에서 자체적으로 배너 상태를 관리하고 있긴 하지만, 유저가 오늘의집에 들어와서 로딩하는
   * 시점에는 아직 React가 로딩되지 않은 상황이기 때문에, 이 때 layout shift를 최소화하기
   * 위해 배너의 동작을 <script> 태그를 통해서 제어하고 있습니다.
   *
   * script 태그 안에서는 유저가 앱 다운로드 팝업을 봤는지, 배너를 닫았는지 등 여러가지를
   * 판단해서 배너가 보여져야 하는지, 아니면 숨겨져야 하는지 결정해서, 만약 숨겨져야 한다면
   * style 태그를 추가해서 노드를 숨겨버립니다.
   *
   * 문제는 이 style 태그는 지워지지 않기 때문에, React에서 다시 배너를 표출하려고 할 때
   * 이슈가 생기게 됩니다.
   * PC 배너와 달리, 모바일 배너는 앱 다운로드 팝업을 닫고, 유저가 다른 페이지로 이동했을 때
   * 다시 보여지는데요, 다른 페이지로 이동하는 것의 인식을 'pathname'을 통해서 하고 있습니다.
   *
   * 즉, 실제 reload가 아닌, SPA 안에서 페이지가 바뀌어도 배너가 보여져야 합니다. 하지만
   * 이 때 페이지 진입 시 배너를 강제로 숨겨버렸기 때문에, React에서 다시 배너를 보여줄 수
   * 없는 상황이 되어버립니다.
   *
   * 이를 해결하기 위해, SSR 시점의 배너 로직은 순전히 SSR 과정중 layout shift를 막는
   * 용도로만 쓰고, React가 로딩되고 나면 이 스타일에 영향받지 않도록 구성하면 됩니다.
   *
   * 이를 위해 "isUnsure" 플래그가 추가되었습니다. 아직 리액트가 렌더링되지 않은 상황에서는
   * isUnsure가 true라서 클래스 네임이 입력되겠지만, 리액트가 초기화된 뒤에는 리액트가
   * 자유롭게 제어할 수 있도록 클래스 네임을 해제합니다.
   */
  var _a = (0,react.useState)({
      isOpen: false,
      isUnsure: true
    }),
    _b = _a[0],
    isOpen = _b.isOpen,
    isUnsure = _b.isUnsure,
    setState = _a[1];
  (0,react.useEffect)(function () {
    setState({
      isOpen: onCheck(),
      isUnsure: false
    });
  }, [pathname, onCheck]);
  var handleClose = (0,react.useCallback)(function () {
    setState({
      isOpen: false,
      isUnsure: false
    });
    onClose();
  }, [onClose]);
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
    children: [ssrCheckLiteral && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("script", {
      dangerouslySetInnerHTML: {
        __html: "(function() {\n  if (!(".concat(ssrCheckLiteral, ")) {\n    var style = document.createElement('style');\n    style.append('.").concat(ssrClassName, " { display: none !important; }');\n    document.head.appendChild(style);\n  }\n})();")
      }
    }), children({
      className: isUnsure ? ssrClassName : '',
      isOpen: isVisible && (isOpen || isUnsure),
      onClose: handleClose
    })]
  });
}

// TODO: I'm putting all marketing-specific code in here
function isMarketingHidden(search) {
  var triggered = false;
  try {
    triggered = sessionStorage.marketingHiddenTriggered === 'yes';
  } catch (e) {
    //
  }
  var searchObj = (0,lib.parse)(search.slice(1));
  if (triggered || searchObj.pro_app != null) {
    try {
      sessionStorage.marketingHiddenTriggered = 'yes';
    } catch (e) {
      //
    }
    return true;
  }
  return false;
}
function isMobile() {
  if (typeof window === 'undefined') return false;
  if (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1) {
    return true;
  }
  return /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
}
function getCookie(name) {
  if (typeof window !== 'undefined') {
    var cookies = (document.cookie || '').split('; ');
    for (var i = 0; i < cookies.length; i += 1) {
      var match = /([^=]+)=(.+)/.exec(cookies[i]);
      if (match && match[1] === name) {
        return match[2];
      }
    }
  }
  return null;
}
function setCookie(name, value, delay, domain) {
  var cookieStr = "".concat(name, "=").concat(value, "; path=/; ") + "expires=".concat(new Date(Date.now() + delay).toUTCString(), ";");
  if (domain) {
    cookieStr += " domain=".concat(domain);
  }
  document.cookie = cookieStr;
}
function NavigationTopBanner(props) {
  var location = props.location,
    _onAppOpen = props.onAppOpen,
    mobileImageSrc = props.mobileImageSrc,
    _a = props.pcContentList,
    pcContentList = _a === void 0 ? [] : _a,
    linkComponent = props.linkComponent,
    onLog = props.onLog,
    isUserLoggedIn = props.isUserLoggedIn,
    onClosePCTopBanner = props.onClosePCTopBanner,
    onCloseMobileTopBanner = props.onCloseMobileTopBanner,
    onCloseAppDownloadPopup = props.onCloseAppDownloadPopup,
    localeData = props.localeData;
  var cookieDomain = location.origin ? ".".concat(location.origin.split(/\.|\/\//).slice(-2).join('.')) : '.ohou.se';
  var isInApp = (0,hooks.e)(location);
  var hiddenAppBanner = isInApp || utils.A.test(location.pathname) || utils.e.test(location.search);
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TopBannerContainer, (0,common.a)({
      pathname: location.pathname,
      isVisible: !isInApp && pcContentList.length > 0,
      onCheck: function onCheck() {
        return getCookie('ohsTopBannerClosed') !== 'yes' && !isMarketingHidden(location.search);
      },
      onClose: function onClose() {
        onLog('banner.top.pc.close', {});
        setCookie('ohsTopBannerClosed', 'yes', 24 * 3600 * 1000, cookieDomain);
        onClosePCTopBanner === null || onClosePCTopBanner === void 0 ? void 0 : onClosePCTopBanner();
      },
      ssrClassName: "gnb-pc-top-banner--unsure",
      // eslint-disable-next-line max-len
      ssrCheckLiteral: "!/(^|;)ohsTopBannerClosed=yes($|;)/.test(document.cookie)"
    }, {
      children: function children(props) {
        return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PCTopBanner, (0,common.a)({}, props, {
          contentList: pcContentList,
          linkComponent: linkComponent,
          onClick: function onClick(content, index) {
            onLog('banner.top.pc.click', {
              content: content,
              index: index
            });
          },
          isUserLoggedIn: isUserLoggedIn,
          origin: location.origin || 'https://ohou.se'
        }));
      }
    })), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TopBannerContainer, (0,common.a)({
      pathname: location.pathname,
      isVisible: !hiddenAppBanner,
      onCheck: function onCheck() {
        return getCookie('ohsAppDownloadPopupClosed') === 'yes' && getCookie('ohsTopBannerClosed') !== 'yes' && !isMarketingHidden(location.search);
      },
      onClose: function onClose() {
        onLog('banner.top.mobile.close', {});
        setCookie('ohsTopBannerClosed', 'yes', 12 * 3600 * 1000, cookieDomain);
        onCloseMobileTopBanner === null || onCloseMobileTopBanner === void 0 ? void 0 : onCloseMobileTopBanner();
      },
      ssrClassName: "gnb-mobile-top-banner--unsure",
      ssrCheckLiteral: '/(^|;)ohsAppDownloadPopupClosed=yes($|;)/.test(document.cookie) ' + '&& !/(^|;)ohsTopBannerClosed=yes($|;)/.test(document.cookie)'
    }, {
      children: function children(props) {
        return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MobileTopBanner, (0,common.a)({}, props, {
          imageSrc: mobileImageSrc,
          onAppOpen: function onAppOpen() {
            onLog('banner.top.mobile.click', {});
            _onAppOpen('banner.top.mobile.click');
          },
          localeData: localeData === null || localeData === void 0 ? void 0 : localeData.mobileBanner
        }));
      }
    })), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AppDownloadPopupContainer, {
      onCheck: function onCheck() {
        return isMobile() && !hiddenAppBanner && getCookie('ohsAppDownloadPopupClosed') !== 'yes' && !isMarketingHidden(location.search);
      },
      onClose: function onClose() {
        onLog('banner.bottom.mobile.close', {});
        setCookie('ohsAppDownloadPopupClosed', 'yes', 12 * 3600 * 1000, cookieDomain);
        onCloseAppDownloadPopup === null || onCloseAppDownloadPopup === void 0 ? void 0 : onCloseAppDownloadPopup();
      },
      onAppOpen: function onAppOpen() {
        onLog('banner.bottom.mobile.click', {});
        _onAppOpen('banner.bottom.mobile.click');
      },
      localeData: localeData === null || localeData === void 0 ? void 0 : localeData.mobilePopup
    })]
  });
}

function NotSupportedBrowserBanner(_a) {
  var buttons = _a.buttons;
  var theme = useTheme();
  return jsx(Sticky, _assign({
    direction: "top",
    offset: 0,
    zIndex: ZINDEX.appBar + 3,
    disableNativeSticky: true,
    disableBottom: true
  }, {
    children: jsxs("div", _assign({
      css: /*#__PURE__*/css(templateObject_1$P || (templateObject_1$P = __makeTemplateObject(["\n          display: flex;\n          flex-wrap: wrap;\n          align-items: center;\n          justify-content: center;\n          width: 100%;\n          padding: ", ";\n          box-sizing: border-box;\n          background: ", "\n        " + ( true ? "" : 0)], ["\n          display: flex;\n          flex-wrap: wrap;\n          align-items: center;\n          justify-content: center;\n          width: 100%;\n          padding: ", ";\n          box-sizing: border-box;\n          background: ", "\n        " + ( true ? "" : 0)])), pxToRem(18), theme.content.base4)
    }, {
      children: [jsx("p", _assign({
        css: [FONT_STYLE.body1_1, /*#__PURE__*/css(templateObject_2$G || (templateObject_2$G = __makeTemplateObject(["\n              margin: ", " ", ";\n              color: ", ";\n              font-weight: 500;\n              text-align: center;\n            " + ( true ? "" : 0)], ["\n              margin: ", " ", ";\n              color: ", ";\n              font-weight: 500;\n              text-align: center;\n            " + ( true ? "" : 0)])), pxToRem(6), pxToRem(12), theme.content.base1), MEDIA_QUERY.max('mobile', /*#__PURE__*/css(templateObject_3$y || (templateObject_3$y = __makeTemplateObject(["\n              white-space: pre-wrap;\n            " + ( true ? "" : 0)], ["\n              white-space: pre-wrap;\n            " + ( true ? "" : 0)]))))]
      }, {
        children: '이 브라우저는 지원이 종료되었습니다.\n다른 브라우저를 이용해 주세요.'
      })), jsx("div", _assign({
        css: /*#__PURE__*/css(templateObject_4$s || (templateObject_4$s = __makeTemplateObject(["\n            margin: ", " ", ";\n            text-align: center;\n            line-height: 0;\n          " + ( true ? "" : 0)], ["\n            margin: ", " ", ";\n            text-align: center;\n            line-height: 0;\n          " + ( true ? "" : 0)])), pxToRem(2), pxToRem(12))
      }, {
        children: buttons.map(function (button) {
          return jsx(Button$2, _assign({
            variant: "base1",
            size: 32,
            onClick: button.onClick,
            css: /*#__PURE__*/css(templateObject_5$m || (templateObject_5$m = __makeTemplateObject(["\n                margin: ", ";\n              " + ( true ? "" : 0)], ["\n                margin: ", ";\n              " + ( true ? "" : 0)])), pxToRem(4))
          }, {
            children: button.text
          }), button.id);
        })
      }))]
    }))
  }));
}
var templateObject_1$P, templateObject_2$G, templateObject_3$y, templateObject_4$s, templateObject_5$m;

function NotSupportedBrowserPopup(_a) {
  var buttons = _a.buttons,
    onClose = _a.onClose;
  var isMobile = useResponsive().breakpoint === 'mobile';
  var modalWidthProps = useMemo(function () {
    return isMobile ? {
      width: 300,
      isPopupInMobile: true
    } : {
      width: 400
    };
  }, [isMobile]);
  return jsx(Modal, _assign({}, modalWidthProps, {
    header: {
      title: '브라우저 지원 종료 안내',
      onClose: onClose
    },
    footer: {
      // IE flex 버그 때문에 height 고정
      style: /*#__PURE__*/css(templateObject_1$O || (templateObject_1$O = __makeTemplateObject(["\n          height: ", ";\n          box-sizing: border-box;\n        " + ( true ? "" : 0)], ["\n          height: ", ";\n          box-sizing: border-box;\n        " + ( true ? "" : 0)])), pxToRem(76)),
      action: {
        secondary: [buttons[0], buttons[1]]
      }
    }
  }, {
    children: jsx("p", _assign({
      css: /*#__PURE__*/css(templateObject_2$F || (templateObject_2$F = __makeTemplateObject(["\n          padding: ", " ", ";\n          word-break: keep-all;\n          white-space: pre-wrap;\n        " + ( true ? "" : 0)], ["\n          padding: ", " ", ";\n          word-break: keep-all;\n          white-space: pre-wrap;\n        " + ( true ? "" : 0)])), pxToRem(10), pxToRem(16))
    }, {
      children: '이 브라우저(인터넷 익스플로러)는\n서비스 지원이 종료되었습니다.\n다른 브라우저로 오늘의집을 이용해 주세요.'
    }))
  }));
}
var templateObject_1$O, templateObject_2$F;

var POPUP_CLOSED_FLAG_SESSION_KEY = 'ohsNotSupportedBrowserPopupClosed';
function NotSupportedBrowser() {
  var _a = useState(false),
    isPopupOpened = _a[0],
    setPopupOpened = _a[1];
  var isWindowsOS = useWindowsOSDetector();
  useEffect(function () {
    setPopupOpened(window.sessionStorage.getItem(POPUP_CLOSED_FLAG_SESSION_KEY) !== 'true');
  }, []);
  var buttons = useMemo(function () {
    return [{
      id: 'chrome',
      text: '크롬 설치하기',
      onClick: function onClick() {
        window.location.href = 'https://www.google.co.kr/chrome';
      }
    }, {
      id: 'edge',
      text: isWindowsOS ? '엣지로 열기' : '엣지 설치하기',
      onClick: isWindowsOS ? function () {
        window.location.href = 'microsoft-edge:https://ohou.se';
      } : function () {
        window.location.href = 'https://www.microsoft.com/edge';
      }
    }];
  }, [isWindowsOS]);
  var handlePopupClose = useCallback(function () {
    window.sessionStorage.setItem(POPUP_CLOSED_FLAG_SESSION_KEY, 'true');
    setPopupOpened(false);
  }, []);
  return jsxs(Fragment$1, {
    children: [jsx(NotSupportedBrowserBanner, {
      buttons: buttons
    }), isPopupOpened && jsx(NotSupportedBrowserPopup, {
      buttons: buttons,
      onClose: handlePopupClose
    })]
  });
}

function Hint(_a) {
  var children = _a.children,
    error = _a.error,
    rest = (0,common.e)(_a, ["children", "error"]);
  var theme = (0,emotion_element_5486c51c_browser_esm.u)();
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", (0,common.a)({}, rest, {
    css: /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)(templateObject_1$N || (templateObject_1$N = (0,common._)(["\n        ", "\n        color: ", ";\n      " + ( true ? "" : 0)], ["\n        ", "\n        color: ", ";\n      " + ( true ? "" : 0)])), foundation.F.caption1, error ? theme.content.primary2.thick : theme.content.base2)
  }, {
    children: [error && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Icon, {
      name: "alert",
      size: 18,
      css: /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)(templateObject_2$E || (templateObject_2$E = (0,common._)(["\n            vertical-align: middle;\n            margin-right: ", ";\n          " + ( true ? "" : 0)], ["\n            vertical-align: middle;\n            margin-right: ", ";\n          " + ( true ? "" : 0)])), (0,foundation.p)(6))
    }), children]
  }));
}
var templateObject_1$N, templateObject_2$E;

function CounterHint(_a) {
  var children = _a.children,
    count = _a.count,
    maxCount = _a.maxCount,
    rest = (0,common.e)(_a, ["children", "count", "maxCount"]);
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Hint, (0,common.a)({}, rest, {
    css: /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)(templateObject_1$M || (templateObject_1$M = (0,common._)(["\n        display: flex;\n        white-space: nowrap;\n      " + ( true ? "" : 0)], ["\n        display: flex;\n        white-space: nowrap;\n      " + ( true ? "" : 0)])))
  }, {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", (0,common.a)({
      css: /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)(templateObject_2$D || (templateObject_2$D = (0,common._)(["\n          flex: 1;\n          overflow: hidden;\n          text-overflow: ellipsis;\n        " + ( true ? "" : 0)], ["\n          flex: 1;\n          overflow: hidden;\n          text-overflow: ellipsis;\n        " + ( true ? "" : 0)])))
    }, {
      children: children
    })), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("span", (0,common.a)({
      css: /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)(templateObject_3$x || (templateObject_3$x = (0,common._)(["\n          text-align: right;\n          padding-left: ", ";\n        " + ( true ? "" : 0)], ["\n          text-align: right;\n          padding-left: ", ";\n        " + ( true ? "" : 0)])), (0,foundation.p)(10))
    }, {
      children: [count, "/", maxCount]
    }))]
  }));
}
var templateObject_1$M, templateObject_2$D, templateObject_3$x;

function DimLoading(_a) {
  var className = _a.className,
    rest = __rest(_a, ["className"]);
  var theme = useTheme();
  return jsx(BodyPortal, {
    children: jsx(Dim, {
      children: jsx("div", _assign({
        className: className,
        css: /*#__PURE__*/css(templateObject_1$L || (templateObject_1$L = __makeTemplateObject(["\n            position: relative;\n            display: inline-block;\n            vertical-align: middle;\n            width: ", ";\n            height: ", ";\n            border-radius: ", ";\n            background-color: ", ";\n          " + ( true ? "" : 0)], ["\n            position: relative;\n            display: inline-block;\n            vertical-align: middle;\n            width: ", ";\n            height: ", ";\n            border-radius: ", ";\n            background-color: ", ";\n          " + ( true ? "" : 0)])), pxToRem(80), pxToRem(80), pxToRem(8), theme.dim.basic)
      }, {
        children: jsx(Loading, _assign({}, rest, {
          css: /*#__PURE__*/css(templateObject_2$C || (templateObject_2$C = __makeTemplateObject(["\n              position: absolute;\n              top: ", ";\n              left: ", ";\n            " + ( true ? "" : 0)], ["\n              position: absolute;\n              top: ", ";\n              left: ", ";\n            " + ( true ? "" : 0)])), pxToRem(28), pxToRem(28))
        }))
      }))
    })
  });
}
var templateObject_1$L, templateObject_2$C;

var ICON_SIZE$1 = 24;
var SELECT_PADDING = {
  32: 13,
  40: 13,
  44: 15,
  50: 15
};
function Select(_a) {
  var _onChange = _a.onChange,
    onValue = _a.onValue,
    error = _a.error,
    size = _a.size,
    value = _a.value,
    options = _a.options,
    className = _a.className,
    placeholder = _a.placeholder,
    forwardedRef = _a.forwardedRef,
    rest = (0,common.e)(_a, ["onChange", "onValue", "error", "size", "value", "options", "className", "placeholder", "forwardedRef"]);
  var theme = (0,emotion_element_5486c51c_browser_esm.u)();
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", (0,common.a)({
    className: className,
    css: /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)(templateObject_1$K || (templateObject_1$K = (0,common._)(["\n        position: relative;\n        display: inline-block;\n        line-height: 0;\n        &:hover {\n          background-color: ", ";\n        }\n      " + ( true ? "" : 0)], ["\n        position: relative;\n        display: inline-block;\n        line-height: 0;\n        &:hover {\n          background-color: ", ";\n        }\n      " + ( true ? "" : 0)])), theme.interactive.transparent)
  }, {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Icon, {
      size: ICON_SIZE$1,
      name: "dropdown",
      css: /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)(templateObject_2$B || (templateObject_2$B = (0,common._)(["\n          position: absolute;\n          top: ", ";\n          right: ", ";\n          color: ", ";\n        " + ( true ? "" : 0)], ["\n          position: absolute;\n          top: ", ";\n          right: ", ";\n          color: ", ";\n        " + ( true ? "" : 0)])), (0,foundation.p)(size / 2 - ICON_SIZE$1 / 2), (0,foundation.p)(SELECT_PADDING[size]), theme.content.base2)
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("select", (0,common.a)({}, rest, {
      value: value,
      ref: forwardedRef,
      onChange: function onChange(e) {
        return (0,common.j)(e, {
          onChange: _onChange,
          onValue: onValue
        });
      },
      css: [/*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)(templateObject_3$w || (templateObject_3$w = (0,common._)(["\n            ", "\n          " + ( true ? "" : 0)], ["\n            ", "\n          " + ( true ? "" : 0)])), foundation.a), size === 32 ? foundation.F.body2 : foundation.F.subTitle1, /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)(templateObject_4$r || (templateObject_4$r = (0,common._)(["\n            position: relative;\n            appearance: none;\n            width: 100%;\n            height: ", ";\n            border-radius: ", ";\n            border: ", " solid ", ";\n            color: ", ";\n            padding-left: ", ";\n            padding-right: ", ";\n          " + ( true ? "" : 0)], ["\n            position: relative;\n            appearance: none;\n            width: 100%;\n            height: ", ";\n            border-radius: ", ";\n            border: ", " solid ", ";\n            color: ", ";\n            padding-left: ", ";\n            padding-right: ", ";\n          " + ( true ? "" : 0)])), (0,foundation.p)(size), (0,foundation.p)(4), (0,foundation.p)(1), theme.border, value !== '' ? theme.content.base1 : theme.content.base3, (0,foundation.p)(SELECT_PADDING[size]), (0,foundation.p)(ICON_SIZE$1 + SELECT_PADDING[size])), error ? /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)(templateObject_5$l || (templateObject_5$l = (0,common._)(["border-color: ", ";" + ( true ? "" : 0)], ["border-color: ", ";" + ( true ? "" : 0)])), theme.content.primary2.basic) : /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)(templateObject_6$j || (templateObject_6$j = (0,common._)(["\n                &:disabled {\n                  background-color: ", ";\n                }\n                &:focus {\n                  border-color: ", ";\n                }\n              " + ( true ? "" : 0)], ["\n                &:disabled {\n                  background-color: ", ";\n                }\n                &:focus {\n                  border-color: ", ";\n                }\n              " + ( true ? "" : 0)])), theme.interactive.transparent, theme.content.primary1.basic)]
    }, {
      children: [placeholder && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("option", (0,common.a)({
        value: "",
        hidden: true,
        disabled: true
      }, {
        children: placeholder
      })), options.map(function (option) {
        return typeof option === 'number' || typeof option === 'string' ? (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("option", (0,common.a)({
          value: option
        }, {
          children: option
        }), option) : (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("option", (0,common.a)({
          value: option.value
        }, {
          children: option.text
        }), option.value);
      })]
    }))]
  }));
}
var templateObject_1$K, templateObject_2$B, templateObject_3$w, templateObject_4$r, templateObject_5$l, templateObject_6$j;

function cssBaseIconButton(size) {
  return /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)(templateObject_1$J || (templateObject_1$J = (0,common._)(["\n    width: ", ";\n    padding: 0;\n  " + ( true ? "" : 0)], ["\n    width: ", ";\n    padding: 0;\n  " + ( true ? "" : 0)])), (0,foundation.p)(size));
}
var templateObject_1$J;

/**
 * @deprecated ODS의 IconButton을 사용해주세요. 만약 디자인상 ODS의 IconButton을 사용할 수 없는 경우, 디자인시스템 담당 디자이너에게 문의해주세요.
 */
function OutlineIconButton(_a) {
  var size = _a.size,
    icon = _a.icon,
    rest = (0,common.e)(_a, ["size", "icon"]);
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(OutlineButton, (0,common.a)({}, rest, {
    size: size,
    css: cssBaseIconButton(size)
  }, {
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Icon, {
      size: 18,
      name: icon
    })
  }));
}

var SIZE = 32;
var GAP = 10;

function PageButton(_a) {
  var page = _a.page,
    selected = _a.selected,
    onClick = _a.onClick;
  var pageButtonCss = /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)(templateObject_1$I || (templateObject_1$I = (0,common._)(["\n    width: ", ";\n    padding: 0;\n    vertical-align: middle;\n    margin-right: ", ";\n  " + ( true ? "" : 0)], ["\n    width: ", ";\n    padding: 0;\n    vertical-align: middle;\n    margin-right: ", ";\n  " + ( true ? "" : 0)])), (0,foundation.p)(SIZE), (0,foundation.p)(GAP));
  return selected ? (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Button$2, (0,common.a)({
    size: SIZE,
    variant: "primary1",
    onClick: onClick,
    css: pageButtonCss
  }, {
    children: page
  })) : (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TextButton, (0,common.a)({
    size: SIZE,
    variant: "base1",
    onClick: onClick,
    css: pageButtonCss
  }, {
    children: page
  }));
}
var templateObject_1$I;

function firstPage(page, lastPage, pageCount) {
  var halfPage = Math.floor(pageCount / 2);
  if (page <= halfPage) {
    return 1;
  }
  if (lastPage < page + halfPage) {
    return lastPage - pageCount + 1;
  }
  return page - halfPage;
}
function Pagination$1(_a) {
  var page = _a.page,
    total = _a.total,
    _b = _a.pageCount,
    pageCount = _b === void 0 ? 10 : _b,
    onPageChange = _a.onPageChange,
    _c = _a.row,
    row = _c === void 0 ? 10 : _c,
    rowOptions = _a.rowOptions,
    onRowChange = _a.onRowChange,
    rest = (0,common.e)(_a, ["page", "total", "pageCount", "onPageChange", "row", "rowOptions", "onRowChange"]);
  var lastPage = Math.ceil(total / row);
  var actualPageCount = Math.min(lastPage, pageCount);
  (0,react.useEffect)(function () {
    if (lastPage < page) {
      onPageChange(Math.max(lastPage, 1));
    }
  }, [page, lastPage, onPageChange]);
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", (0,common.a)({}, rest, {
    children: [rowOptions && onRowChange && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Select, {
      size: SIZE,
      value: row,
      options: rowOptions,
      onValue: function onValue(value) {
        return onRowChange(parseInt(value));
      },
      css: /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)(templateObject_1$H || (templateObject_1$H = (0,common._)(["\n            vertical-align: middle;\n            margin-right: ", ";\n          " + ( true ? "" : 0)], ["\n            vertical-align: middle;\n            margin-right: ", ";\n          " + ( true ? "" : 0)])), (0,foundation.p)(16))
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(OutlineIconButton, {
      disabled: page === 1,
      size: SIZE,
      variant: "base1",
      icon: "chevron_left",
      css: /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)(templateObject_2$A || (templateObject_2$A = (0,common._)(["\n          vertical-align: middle;\n          margin-right: ", ";\n        " + ( true ? "" : 0)], ["\n          vertical-align: middle;\n          margin-right: ", ";\n        " + ( true ? "" : 0)])), (0,foundation.p)(GAP)),
      onClick: function onClick() {
        return onPageChange(page - 1);
      }
    }), Array(actualPageCount).fill(firstPage(page, lastPage, actualPageCount)).map(function (v, i) {
      return v + i;
    }).map(function (pageNumber) {
      return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PageButton, {
        page: pageNumber,
        selected: page === pageNumber,
        onClick: function onClick() {
          return onPageChange(pageNumber);
        }
      }, pageNumber);
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(OutlineIconButton, {
      disabled: page === lastPage,
      size: SIZE,
      variant: "base1",
      icon: "chevron_right",
      css: /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)(templateObject_3$v || (templateObject_3$v = (0,common._)(["\n          vertical-align: middle;\n        " + ( true ? "" : 0)], ["\n          vertical-align: middle;\n        " + ( true ? "" : 0)]))),
      onClick: function onClick() {
        return onPageChange(page + 1);
      }
    })]
  }));
}
var templateObject_1$H, templateObject_2$A, templateObject_3$v;

function withHint(Component) {
  return function (_a) {
    var className = _a.className,
      hint = _a.hint,
      error = _a.error,
      rest = (0,common.e)(_a, ["className", "hint", "error"]);
    return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", (0,common.a)({
      className: className
    }, {
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Component, (0,common.a)({}, rest, {
        error: error,
        css: /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)(templateObject_1$G || (templateObject_1$G = (0,common._)(["width: 100%;" + ( true ? "" : 0)], ["width: 100%;" + ( true ? "" : 0)])))
      })), hint && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Hint, (0,common.a)({
        error: error,
        css: /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)(templateObject_2$z || (templateObject_2$z = (0,common._)(["margin-top: ", ";" + ( true ? "" : 0)], ["margin-top: ", ";" + ( true ? "" : 0)])), (0,foundation.p)(8))
      }, {
        children: hint
      }))]
    }));
  };
}
var templateObject_1$G, templateObject_2$z;

var SelectWithHint = withHint(Select);

/**
 * @deprecated ODS의 Input 컴포넌트를 사용해주세요. 만약 디자인상 ODS의 Input를 사용할 수 없는 경우, 디자인시스템 담당 디자이너에게 문의해주세요.
 */
var InputWithHint = withHint(Input$1);

function withCountHint(Component) {
  return function (_a) {
    var className = _a.className,
      value = _a.value,
      hint = _a.hint,
      error = _a.error,
      maxCount = _a.maxCount,
      rest = (0,common.e)(_a, ["className", "value", "hint", "error", "maxCount"]);
    var data = typeof value === 'string' ? value.substring(0, maxCount) : value;
    return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", (0,common.a)({
      className: className
    }, {
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Component, (0,common.a)({}, rest, {
        error: error,
        value: data,
        css: /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)(templateObject_1$F || (templateObject_1$F = (0,common._)(["width: 100%;" + ( true ? "" : 0)], ["width: 100%;" + ( true ? "" : 0)])))
      })), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CounterHint, (0,common.a)({
        error: error,
        count: data ? "".concat(data).length : 0,
        maxCount: maxCount,
        css: /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)(templateObject_2$y || (templateObject_2$y = (0,common._)(["margin-top: ", ";" + ( true ? "" : 0)], ["margin-top: ", ";" + ( true ? "" : 0)])), (0,foundation.p)(8))
      }, {
        children: hint
      }))]
    }));
  };
}
var templateObject_1$F, templateObject_2$y;

/**
 * @deprecated ODS의 Input 컴포넌트를 사용해주세요. 만약 디자인상 ODS의 Input를 사용할 수 없는 경우, 디자인시스템 담당 디자이너에게 문의해주세요.
 */
var InputWithCountHint = withCountHint(Input$1);

function withThumbnail(Component) {
  return function (_a) {
    var className = _a.className,
      _b = _a.error,
      error = _b === void 0 ? false : _b,
      _c = _a.disabled,
      disabled = _c === void 0 ? false : _c,
      _d = _a.readOnly,
      readOnly = _d === void 0 ? false : _d,
      _e = _a.onDimmed,
      onDimmed = _e === void 0 ? false : _e,
      thumbnail = _a.thumbnail,
      onThumbnailDelete = _a.onThumbnailDelete,
      props = (0,common.e)(_a, ["className", "error", "disabled", "readOnly", "onDimmed", "thumbnail", "onThumbnailDelete"]);
    var _f = (0,react.useState)(false),
      focused = _f[0],
      setFocused = _f[1];
    var theme = (0,emotion_element_5486c51c_browser_esm.u)();
    return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", (0,common.a)({
      className: className,
      css: [cssBaseTextField(theme, onDimmed, {
        error: error,
        disabled: disabled,
        readOnly: readOnly,
        focused: focused
      }), /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)(templateObject_1$E || (templateObject_1$E = (0,common._)(["\n            display: block;\n            padding: ", " ", ";\n            cursor: text;\n          " + ( true ? "" : 0)], ["\n            display: block;\n            padding: ", " ", ";\n            cursor: text;\n          " + ( true ? "" : 0)])), (0,foundation.p)(0), (0,foundation.p)(16))]
    }, {
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Component, (0,common.a)({}, props, {
        size: 44,
        error: error,
        disabled: disabled,
        readOnly: readOnly,
        onFocus: function onFocus(e) {
          var _a;
          setFocused(true);
          (_a = props.onFocus) === null || _a === void 0 ? void 0 : _a.call(props, e);
        },
        onBlur: function onBlur(e) {
          var _a;
          setFocused(false);
          (_a = props.onBlur) === null || _a === void 0 ? void 0 : _a.call(props, e);
        },
        css: /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)(templateObject_2$x || (templateObject_2$x = (0,common._)(["\n            width: 100%;\n            padding: 0;\n            border: 0;\n          " + ( true ? "" : 0)], ["\n            width: 100%;\n            padding: 0;\n            border: 0;\n          " + ( true ? "" : 0)])))
      })), thumbnail && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", (0,common.a)({
        css: /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)(templateObject_3$u || (templateObject_3$u = (0,common._)(["margin-bottom: ", ";" + ( true ? "" : 0)], ["margin-bottom: ", ";" + ( true ? "" : 0)])), (0,foundation.p)(12))
      }, {
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("span", (0,common.a)({
          css: /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)(templateObject_4$q || (templateObject_4$q = (0,common._)(["\n                overflow: hidden;\n                position: relative;\n                display: inline-block;\n                width: ", ";\n                height: ", ";\n              " + ( true ? "" : 0)], ["\n                overflow: hidden;\n                position: relative;\n                display: inline-block;\n                width: ", ";\n                height: ", ";\n              " + ( true ? "" : 0)])), (0,foundation.p)(100), (0,foundation.p)(100))
        }, {
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Image, {
            aspectRatio: "1:1",
            src: thumbnail,
            radius: 4,
            css: /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)(templateObject_5$k || (templateObject_5$k = (0,common._)(["\n                  width: 100%;\n                  height: 100%;\n                " + ( true ? "" : 0)], ["\n                  width: 100%;\n                  height: 100%;\n                " + ( true ? "" : 0)])))
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("button", (0,common.a)({
            type: "button",
            title: "\uC0AD\uC81C",
            css: /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)(templateObject_6$i || (templateObject_6$i = (0,common._)(["\n                  position: absolute;\n                  top: 0;\n                  right: 0;\n                  width: ", ";\n                  height: ", ";\n                  margin: 0;\n                  padding: 0;\n                  border: 0;\n                  background: none;\n                " + ( true ? "" : 0)], ["\n                  position: absolute;\n                  top: 0;\n                  right: 0;\n                  width: ", ";\n                  height: ", ";\n                  margin: 0;\n                  padding: 0;\n                  border: 0;\n                  background: none;\n                " + ( true ? "" : 0)])), (0,foundation.p)(32), (0,foundation.p)(32)),
            onClick: function onClick(e) {
              e.stopPropagation();
              onThumbnailDelete === null || onThumbnailDelete === void 0 ? void 0 : onThumbnailDelete();
            }
          }, {
            children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Icon, {
              name: "dismiss_circle",
              size: 18,
              fill: function fill(theme) {
                return theme.content.base1;
              }
            })
          }))]
        }))
      }))]
    }));
  };
}
var templateObject_1$E, templateObject_2$x, templateObject_3$u, templateObject_4$q, templateObject_5$k, templateObject_6$i;

var InputWithThumbnail = withThumbnail(Input$1);

var ContentEditable = /*#__PURE__*/(0,react.forwardRef)(function (_a, ref) {
  var className = _a.className,
    _b = _a.value,
    value = _b === void 0 ? '' : _b,
    disabled = _a.disabled,
    readOnly = _a.readOnly,
    placeholder = _a.placeholder,
    _onCut = _a.onCut,
    _onPaste = _a.onPaste,
    _onInput = _a.onInput,
    onValue = _a.onValue,
    onFocus = _a.onFocus,
    onBlur = _a.onBlur,
    props = (0,common.e)(_a, ["className", "value", "disabled", "readOnly", "placeholder", "onCut", "onPaste", "onInput", "onValue", "onFocus", "onBlur"]);
  var theme = (0,emotion_element_5486c51c_browser_esm.u)();
  var node = (0,react.useRef)(null);
  (0,react.useImperativeHandle)(ref, function () {
    return node.current;
  });
  var innerValue = (0,react.useRef)('');
  var handleUpdate = (0,react.useCallback)(function () {
    var _a;
    var newValue = ((_a = node.current) === null || _a === void 0 ? void 0 : _a.innerHTML) || '';
    innerValue.current = newValue;
    onValue === null || onValue === void 0 ? void 0 : onValue(newValue);
  }, [onValue]);
  (0,react.useEffect)(function () {
    if (!node.current) return;
    if (innerValue.current !== value) {
      node.current.innerHTML = value;
      handleUpdate();
    }
  }, [value, handleUpdate]);
  (0,react.useEffect)(function () {
    if (!node.current) return;
    var observer = new MutationObserver(function (mutations) {
      for (var _i = 0, mutations_1 = mutations; _i < mutations_1.length; _i++) {
        var mutation = mutations_1[_i];
        if (mutation.type === 'childList') {
          handleUpdate();
        }
      }
    });
    observer.observe(node.current, {
      childList: true,
      subtree: true
    });
    return function () {
      observer.disconnect();
    };
  }, [handleUpdate]);
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", (0,common.a)({
    ref: node,
    contentEditable: !readOnly && !disabled,
    onCut: function onCut(e) {
      handleUpdate();
      _onCut === null || _onCut === void 0 ? void 0 : _onCut(e);
    },
    onPaste: function onPaste(e) {
      handleUpdate();
      _onPaste === null || _onPaste === void 0 ? void 0 : _onPaste(e);
    },
    onInput: function onInput(e) {
      handleUpdate();
      _onInput === null || _onInput === void 0 ? void 0 : _onInput(e);
    },
    onFocus: onFocus,
    onBlur: onBlur,
    "data-placeholder": placeholder,
    className: className,
    css: /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)(templateObject_1$D || (templateObject_1$D = (0,common._)(["\n        word-break: break-word;\n        cursor: ", ";\n        &&:empty:before {\n          content: attr(data-placeholder);\n          color: ", ";\n          pointer-events: none;\n        }\n      " + ( true ? "" : 0)], ["\n        word-break: break-word;\n        cursor: ", ";\n        &&:empty:before {\n          content: attr(data-placeholder);\n          color: ", ";\n          pointer-events: none;\n        }\n      " + ( true ? "" : 0)])), disabled ? 'default' : 'text', theme.content.base3)
  }, props));
});
var templateObject_1$D;

function cssTextareaField(theme, _a) {
  var autoHeight = _a.autoHeight,
    height = _a.height;
  return /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)(templateObject_2$w || (templateObject_2$w = (0,common._)(["\n    ", "\n    ", "\n    overflow-y: auto;\n    flex: 1 0 0%;\n    height: ", ";\n    min-height: ", ";\n    margin: ", " 0;\n    box-sizing: border-box;\n    resize: none;\n    vertical-align: top;\n    ", "\n  " + ( true ? "" : 0)], ["\n    ", "\n    ", "\n    overflow-y: auto;\n    flex: 1 0 0%;\n    height: ", ";\n    min-height: ", ";\n    margin: ", " 0;\n    box-sizing: border-box;\n    resize: none;\n    vertical-align: top;\n    ", "\n  " + ( true ? "" : 0)])), cssTextField(theme), foundation.F.body1_1, (0,foundation.p)(78), (0,foundation.p)(24), (0,foundation.p)(9), autoHeight && /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)(templateObject_1$C || (templateObject_1$C = (0,common._)(["\n      height: ", ";\n    " + ( true ? "" : 0)], ["\n      height: ", ";\n    " + ( true ? "" : 0)])), (0,foundation.p)(height)));
}
function Textarea(_a) {
  var _b;
  var className = _a.className,
    _c = _a.autoHeight,
    autoHeight = _c === void 0 ? false : _c,
    maxRows = _a.maxRows,
    _d = _a.disabled,
    disabled = _d === void 0 ? false : _d,
    _e = _a.readOnly,
    readOnly = _e === void 0 ? false : _e,
    _f = _a.error,
    error = _f === void 0 ? false : _f,
    value = _a.value,
    action = _a.action,
    onValue = _a.onValue,
    useContentEditable = _a.useContentEditable,
    _g = _a.onDimmed,
    onDimmed = _g === void 0 ? false : _g,
    rest = (0,common.e)(_a, ["className", "autoHeight", "maxRows", "disabled", "readOnly", "error", "value", "action", "onValue", "useContentEditable", "onDimmed"]);
  var theme = (0,emotion_element_5486c51c_browser_esm.u)();
  var _h = (0,react.useState)(null),
    element = _h[0],
    setElement = _h[1];
  var _j = (0,react.useState)(0),
    height = _j[0],
    setHeight = _j[1];
  var _k = (0,react.useState)(false),
    focused = _k[0],
    setFocused = _k[1];
  var actions = Array.isArray(action) ? action : [action];
  var updateHeight = (0,react.useCallback)(function (element) {
    var _a, _b;
    element.style.height = '0';
    if (maxRows) {
      var lineHeight = window.getComputedStyle(element).lineHeight;
      var maxHeight = maxRows * parseInt(lineHeight, 10);
      setHeight(Math.min(element.scrollHeight, maxHeight));
    } else {
      setHeight(element.scrollHeight);
    }
    element.style.height = (_b = (_a = rest.style) === null || _a === void 0 ? void 0 : _a.height) !== null && _b !== void 0 ? _b : null;
  }, [maxRows, (_b = rest.style) === null || _b === void 0 ? void 0 : _b.height]);
  var handleValue = (0,react.useCallback)(function (value) {
    if (autoHeight && element) {
      updateHeight(element);
    }
    onValue === null || onValue === void 0 ? void 0 : onValue(value);
  }, [autoHeight, element, updateHeight, onValue]);
  (0,react.useEffect)(function () {
    if (!value) return;
    handleValue(value);
  }, [value, handleValue]);
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", (0,common.a)({
    className: className,
    css: [cssBaseTextField(theme, onDimmed, {
      error: error,
      focused: focused,
      disabled: disabled,
      readOnly: readOnly
    }), /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)(templateObject_3$t || (templateObject_3$t = (0,common._)(["\n          align-items: flex-start;\n          padding: ", " ", ";\n        " + ( true ? "" : 0)], ["\n          align-items: flex-start;\n          padding: ", " ", ";\n        " + ( true ? "" : 0)])), (0,foundation.p)(6), (0,foundation.p)(15))]
  }, {
    children: [!useContentEditable ? function () {
      var _a = rest,
        forwardedRef = _a.forwardedRef,
        _onFocus = _a.onFocus,
        _onBlur = _a.onBlur,
        _onChange = _a.onChange,
        assertedRest = (0,common.e)(_a, ["forwardedRef", "onFocus", "onBlur", "onChange"]);
      return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("textarea", (0,common.a)({}, assertedRest, {
        ref: function ref(el) {
          setElement(el);
          if (forwardedRef) {
            if (typeof forwardedRef === 'function') {
              forwardedRef(el);
            } else {
              forwardedRef.current = el;
            }
          }
        },
        value: value,
        disabled: disabled,
        readOnly: readOnly,
        onFocus: function onFocus(e) {
          if (_onFocus) {
            _onFocus(e);
          }
          setFocused(true);
        },
        onBlur: function onBlur(e) {
          if (_onBlur) {
            _onBlur(e);
          }
          setFocused(false);
        },
        onChange: function onChange(e) {
          return (0,common.j)(e, {
            onChange: _onChange,
            onValue: handleValue
          });
        },
        css: cssTextareaField(theme, {
          autoHeight: autoHeight,
          height: height
        })
      }));
    }() : function () {
      var _a = rest,
        forwardedRef = _a.forwardedRef,
        _onFocus2 = _a.onFocus,
        _onBlur2 = _a.onBlur,
        assertedRest = (0,common.e)(_a, ["forwardedRef", "onFocus", "onBlur"]);
      return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ContentEditable, (0,common.a)({}, assertedRest, {
        ref: function ref(el) {
          setElement(el);
          if (forwardedRef) {
            if (typeof forwardedRef === 'function') {
              forwardedRef(el);
            } else {
              forwardedRef.current = el;
            }
          }
        },
        value: value,
        disabled: disabled,
        readOnly: readOnly,
        onFocus: function onFocus(e) {
          if (_onFocus2) {
            _onFocus2(e);
          }
          setFocused(true);
        },
        onBlur: function onBlur(e) {
          if (_onBlur2) {
            _onBlur2(e);
          }
          setFocused(false);
        },
        onValue: handleValue,
        css: [cssTextareaField(theme, {
          autoHeight: autoHeight,
          height: height
        }), /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)(templateObject_4$p || (templateObject_4$p = (0,common._)(["\n                  min-width: ", ";\n                " + ( true ? "" : 0)], ["\n                  min-width: ", ";\n                " + ( true ? "" : 0)])), (0,foundation.p)(100))]
      }));
    }(), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", (0,common.a)({
      css: /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)(templateObject_5$j || (templateObject_5$j = (0,common._)(["\n          box-sizing: border-box;\n          display: flex;\n          align-items: center;\n          height: ", ";\n          padding: ", " 0;\n          &:not(:empty) {\n            margin-left: ", ";\n          }\n        " + ( true ? "" : 0)], ["\n          box-sizing: border-box;\n          display: flex;\n          align-items: center;\n          height: ", ";\n          padding: ", " 0;\n          &:not(:empty) {\n            margin-left: ", ";\n          }\n        " + ( true ? "" : 0)])), (0,foundation.p)(42), (0,foundation.p)(9), (0,foundation.p)(8))
    }, {
      children: actions.map(function (action, i) {
        return !!action && (isIconAction(action) ? (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("button", (0,common.a)({
          type: action.type || 'button',
          disabled: disabled || action.disabled,
          css: /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)(templateObject_6$h || (templateObject_6$h = (0,common._)(["\n                  ", ";\n                  vertical-align: top;\n                  width: ", ";\n                  height: ", ";\n                  margin-left: ", ";\n                  &:first-of-type {\n                    margin-left: 0;\n                  }\n                " + ( true ? "" : 0)], ["\n                  ", ";\n                  vertical-align: top;\n                  width: ", ";\n                  height: ", ";\n                  margin-left: ", ";\n                  &:first-of-type {\n                    margin-left: 0;\n                  }\n                " + ( true ? "" : 0)])), foundation.R, (0,foundation.p)(24), (0,foundation.p)(24), (0,foundation.p)(12)),
          onClick: function onClick(e) {
            var _a;
            e.stopPropagation();
            (_a = action.onClick) === null || _a === void 0 ? void 0 : _a.call(action, e);
          }
        }, {
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Icon, {
            size: 24,
            name: action.icon,
            css: /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)(templateObject_7$e || (templateObject_7$e = (0,common._)(["\n                    color: ", ";\n                  " + ( true ? "" : 0)], ["\n                    color: ", ";\n                  " + ( true ? "" : 0)])), action.color || theme.content.base2)
          })
        }), i) : (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TextButton, (0,common.a)({
          size: 30,
          variant: "primary1",
          type: action.type || 'button',
          disabled: disabled || action.disabled,
          css: /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)(templateObject_8$a || (templateObject_8$a = (0,common._)(["\n                  flex-shrink: 0;\n                  margin-left: ", ";\n                  padding: 0;\n                  &:first-of-type {\n                    margin-left: 0;\n                  }\n                " + ( true ? "" : 0)], ["\n                  flex-shrink: 0;\n                  margin-left: ", ";\n                  padding: 0;\n                  &:first-of-type {\n                    margin-left: 0;\n                  }\n                " + ( true ? "" : 0)])), (0,foundation.p)(12)),
          onClick: function onClick(e) {
            var _a;
            e.stopPropagation();
            (_a = action.onClick) === null || _a === void 0 ? void 0 : _a.call(action, e);
          }
        }, {
          children: action.text
        }), i));
      })
    }))]
  }));
}
var templateObject_1$C, templateObject_2$w, templateObject_3$t, templateObject_4$p, templateObject_5$j, templateObject_6$h, templateObject_7$e, templateObject_8$a;

var TextareaWithHint = withHint(Textarea);

var TextareaWithCountHint = withCountHint(Textarea);

var TextareaWithThumbnail = withThumbnail(Textarea);

function Table(_a) {
  var header = _a.header,
    body = _a.body,
    footer = _a.footer,
    rest = (0,common.e)(_a, ["header", "body", "footer"]);
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("table", (0,common.a)({}, rest, {
    css: [foundation.F.subTitle1, /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)(templateObject_1$B || (templateObject_1$B = (0,common._)(["\n          width: 100%;\n          border-collapse: collapse;\n        " + ( true ? "" : 0)], ["\n          width: 100%;\n          border-collapse: collapse;\n        " + ( true ? "" : 0)])))]
  }, {
    children: [header && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("thead", {
      children: header
    }), body && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("tbody", {
      children: body
    }), footer && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("tfoot", {
      children: footer
    })]
  }));
}
var templateObject_1$B;

var TABLE_HEADER_CLASS_NAME = 'bucketplace-table-header';
var TABLE_DATA_CLASS_NAME = 'bucketplace-table-data';

/**
 * 테이블 강조 표시 방법에 따른 스타일
 */
var TABLE_HIGHLIGHT_STYLE = {
  none: function none(theme) {
    return /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)(templateObject_1$A || (templateObject_1$A = (0,common._)(["" + ( true ? "" : 0)], ["" + ( true ? "" : 0)])));
  },
  "default": function _default(theme) {
    return /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)(templateObject_2$v || (templateObject_2$v = (0,common._)(["\n    background-color: ", ";\n  " + ( true ? "" : 0)], ["\n    background-color: ", ";\n  " + ( true ? "" : 0)])), theme.colors.backgroundWeak);
  },
  emphasis: function emphasis(theme) {
    return /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)(templateObject_3$s || (templateObject_3$s = (0,common._)(["\n    background-color: ", ";\n  " + ( true ? "" : 0)], ["\n    background-color: ", ";\n  " + ( true ? "" : 0)])), theme.colors.backgroundEmphasisWeak);
  },
  critical: function critical(theme) {
    return /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)(templateObject_4$o || (templateObject_4$o = (0,common._)(["\n    background-color: ", ";\n  " + ( true ? "" : 0)], ["\n    background-color: ", ";\n  " + ( true ? "" : 0)])), theme.colors.backgroundCriticalWeak);
  },
  attention: function attention(theme) {
    return /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)(templateObject_5$i || (templateObject_5$i = (0,common._)(["\n    background-color: ", ";\n  " + ( true ? "" : 0)], ["\n    background-color: ", ";\n  " + ( true ? "" : 0)])), theme.colors.backgroundAttentionWeak);
  }
};
function TableRowImpl(_a, ref) {
  var emphasized = _a.emphasized,
    children = _a.children,
    _b = _a.highlight,
    highlight = _b === void 0 ? emphasized ? 'default' : 'none' : _b,
    rest = (0,common.e)(_a, ["emphasized", "children", "highlight"]);
  var theme = (0,emotion_element_5486c51c_browser_esm.u)();
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("tr", (0,common.a)({}, rest, {
    ref: ref,
    css: [/*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)(templateObject_6$g || (templateObject_6$g = (0,common._)(["\n          > .", ", > .", " {\n            color: ", ";\n            border: ", " solid ", ";\n          }\n        " + ( true ? "" : 0)], ["\n          > .", ", > .", " {\n            color: ", ";\n            border: ", " solid ", ";\n          }\n        " + ( true ? "" : 0)])), TABLE_HEADER_CLASS_NAME, TABLE_DATA_CLASS_NAME, theme.content.base1, (0,foundation.p)(1), theme.content.base4), TABLE_HIGHLIGHT_STYLE[highlight](theme)]
  }, {
    children: children
  }));
}
var TableRow = /*#__PURE__*/(0,react.forwardRef)(TableRowImpl);
var templateObject_1$A, templateObject_2$v, templateObject_3$s, templateObject_4$o, templateObject_5$i, templateObject_6$g;

function TableHeader(_a) {
  var className = _a.className,
    children = _a.children,
    rest = (0,common.e)(_a, ["className", "children"]);
  var theme = (0,emotion_element_5486c51c_browser_esm.u)();
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("th", (0,common.a)({}, rest, {
    className: spaces(className, TABLE_HEADER_CLASS_NAME),
    css: /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)(templateObject_1$z || (templateObject_1$z = (0,common._)(["\n        text-align: left;\n        font-weight: 700;\n        height: ", ";\n        padding: 0 ", ";\n        background-color: ", ";\n        &:hover {\n          background-color: ", ";\n        }\n      " + ( true ? "" : 0)], ["\n        text-align: left;\n        font-weight: 700;\n        height: ", ";\n        padding: 0 ", ";\n        background-color: ", ";\n        &:hover {\n          background-color: ", ";\n        }\n      " + ( true ? "" : 0)])), (0,foundation.p)(56), (0,foundation.p)(16), theme.content.base5, theme.interactive.base5)
  }, {
    children: children
  }));
}
var templateObject_1$z;

var ACTION_BUTTON_SIZE = 18;
function TableHeaderWithAction(_a) {
  var text = _a.text,
    action = _a.action,
    rest = __rest(_a, ["text", "action"]);
  var theme = useTheme();
  return jsxs(TableHeader, _assign({}, rest, {
    children: [jsx("span", _assign({
      css: /*#__PURE__*/css(templateObject_1$y || (templateObject_1$y = __makeTemplateObject(["\n          margin-right: ", ";\n        " + ( true ? "" : 0)], ["\n          margin-right: ", ";\n        " + ( true ? "" : 0)])), pxToRem(6))
    }, {
      children: text
    })), jsx("button", _assign({
      type: "button",
      css: /*#__PURE__*/css(templateObject_2$u || (templateObject_2$u = __makeTemplateObject(["\n          ", ";\n          width: ", ";\n          height: ", ";\n        " + ( true ? "" : 0)], ["\n          ", ";\n          width: ", ";\n          height: ", ";\n        " + ( true ? "" : 0)])), RESET_BUTTON, pxToRem(ACTION_BUTTON_SIZE), pxToRem(ACTION_BUTTON_SIZE)),
      onClick: action.onClick
    }, {
      children: jsx(Icon, {
        size: ACTION_BUTTON_SIZE,
        name: action.icon,
        css: /*#__PURE__*/css(templateObject_3$r || (templateObject_3$r = __makeTemplateObject(["\n            color: ", ";\n          " + ( true ? "" : 0)], ["\n            color: ", ";\n          " + ( true ? "" : 0)])), theme.content.base1)
      })
    }))]
  }));
}
var templateObject_1$y, templateObject_2$u, templateObject_3$r;

function TableDataImpl(_a, ref) {
  var className = _a.className,
    children = _a.children,
    rest = (0,common.e)(_a, ["className", "children"]);
  var theme = (0,emotion_element_5486c51c_browser_esm.u)();
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("td", (0,common.a)({}, rest, {
    ref: ref,
    className: spaces(className, TABLE_DATA_CLASS_NAME),
    css: /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)(templateObject_1$x || (templateObject_1$x = (0,common._)(["\n        height: ", ";\n        padding: 0 ", ";\n\n        @media (hover: hover) and (pointer: fine) {\n          &:hover {\n            background-color: ", ";\n          }\n        }\n      " + ( true ? "" : 0)], ["\n        height: ", ";\n        padding: 0 ", ";\n\n        @media (hover: hover) and (pointer: fine) {\n          &:hover {\n            background-color: ", ";\n          }\n        }\n      " + ( true ? "" : 0)])), (0,foundation.p)(52), (0,foundation.p)(16), theme.colors.backgroundOverlay)
  }, {
    children: children
  }));
}
var TableData = /*#__PURE__*/(0,react.forwardRef)(TableDataImpl);
var templateObject_1$x;

var THUMBNAIL_LEFT_MARGIN = 4;
var calcSidePadding = function calcSidePadding(size) {
  switch (size) {
    case 32:
      return 12;
    case 38:
      return 14;
    case 48:
      return 16;
    default:
      return 0;
  }
};
var calcThumbnailRightMargin = function calcThumbnailRightMargin(size) {
  switch (size) {
    case 32:
      return 4;
    case 38:
      return 6;
    case 48:
      return 8;
    default:
      return 0;
  }
};
var getFontStyle = function getFontStyle(size) {
  if (size === 48) {
    return foundation.F.subTitle1;
  }
  return foundation.F.subTitle2;
};
var getChipSpacing = function getChipSpacing(size) {
  return /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)(templateObject_1$w || (templateObject_1$w = (0,common._)(["\n    margin-left: -", ";\n    margin-right: ", ";\n  " + ( true ? "" : 0)], ["\n    margin-left: -", ";\n    margin-right: ", ";\n  " + ( true ? "" : 0)])), (0,foundation.p)(calcSidePadding(size) - THUMBNAIL_LEFT_MARGIN), (0,foundation.p)(calcThumbnailRightMargin(size)));
};
function cssBaseChip(size) {
  return /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)(templateObject_2$t || (templateObject_2$t = (0,common._)(["\n    display: inline-block;\n    position: relative;\n    height: ", ";\n    border-radius: ", ";\n    padding-left: ", ";\n    padding-right: ", ";\n    line-height: 0;\n    &::before {\n      content: \"\";\n      height: 100%;\n      display: inline-block;\n      vertical-align: middle;\n    }\n  " + ( true ? "" : 0)], ["\n    display: inline-block;\n    position: relative;\n    height: ", ";\n    border-radius: ", ";\n    padding-left: ", ";\n    padding-right: ", ";\n    line-height: 0;\n    &::before {\n      content: \"\";\n      height: 100%;\n      display: inline-block;\n      vertical-align: middle;\n    }\n  " + ( true ? "" : 0)])), (0,foundation.p)(size), (0,foundation.p)(size / 2), (0,foundation.p)(calcSidePadding(size)), (0,foundation.p)(calcSidePadding(size)));
}
function Text(_a) {
  var size = _a.size,
    children = _a.children,
    rest = (0,common.e)(_a, ["size", "children"]);
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", (0,common.a)({}, rest, {
    css: [getFontStyle(size), /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)(templateObject_3$q || (templateObject_3$q = (0,common._)(["\n          vertical-align: middle;\n          white-space: nowrap;\n          cursor: inherit;\n        " + ( true ? "" : 0)], ["\n          vertical-align: middle;\n          white-space: nowrap;\n          cursor: inherit;\n        " + ( true ? "" : 0)])))]
  }, {
    children: children
  }));
}
function Checkbox(_a) {
  var checked = _a.checked,
    _onChange = _a.onChange,
    onCheck = _a.onCheck,
    rest = (0,common.e)(_a, ["checked", "onChange", "onCheck"]);
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("input", (0,common.a)({}, rest, {
    type: "checkbox",
    css: /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)(templateObject_4$n || (templateObject_4$n = (0,common._)(["\n        position: absolute;\n        top: 0;\n        left: 0;\n        width: 0;\n        height: 0;\n        opacity: 0;\n      " + ( true ? "" : 0)], ["\n        position: absolute;\n        top: 0;\n        left: 0;\n        width: 0;\n        height: 0;\n        opacity: 0;\n      " + ( true ? "" : 0)]))),
    checked: checked,
    onChange: function onChange(e) {
      return (0,common.o)(e, {
        onChange: _onChange,
        onCheck: onCheck
      });
    }
  }));
}
function Thumbnail(_a) {
  var size = _a.size,
    rest = (0,common.e)(_a, ["size"]);
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CircleImage, (0,common.a)({}, rest, {
    css: [getChipSpacing(size), /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)(templateObject_5$h || (templateObject_5$h = (0,common._)(["\n          width: ", ";\n          vertical-align: middle;\n      " + ( true ? "" : 0)], ["\n          width: ", ";\n          vertical-align: middle;\n      " + ( true ? "" : 0)])), (0,foundation.p)(size - 8))]
  }));
}
function RemoveButton(_a) {
  var fill = _a.fill;
    _a.size;
    var rest = (0,common.e)(_a, ["fill", "size"]);
  var theme = (0,emotion_element_5486c51c_browser_esm.u)();
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("button", (0,common.a)({}, rest, {
    type: "button",
    css: /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)(templateObject_6$f || (templateObject_6$f = (0,common._)(["\n        ", "\n        width: ", ";\n        height: ", ";\n        margin-left: ", ";\n        margin-right: ", ";\n        vertical-align: middle;\n      " + ( true ? "" : 0)], ["\n        ", "\n        width: ", ";\n        height: ", ";\n        margin-left: ", ";\n        margin-right: ", ";\n        vertical-align: middle;\n      " + ( true ? "" : 0)])), foundation.R, (0,foundation.p)(12), (0,foundation.p)(12), (0,foundation.p)(4), (0,foundation.p)(-4))
  }, {
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Icon, {
      size: 12,
      name: "dismiss",
      css: /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)(templateObject_7$d || (templateObject_7$d = (0,common._)(["\n          vertical-align: top;\n          color: ", ";\n        " + ( true ? "" : 0)], ["\n          vertical-align: top;\n          color: ", ";\n        " + ( true ? "" : 0)])), theme.content[fill])
    })
  }));
}
var templateObject_1$w, templateObject_2$t, templateObject_3$q, templateObject_4$n, templateObject_5$h, templateObject_6$f, templateObject_7$d;

function cssVariant$2(_a) {
  var theme = _a.theme,
    variant = _a.variant,
    hasInteraction = _a.hasInteraction;
  switch (variant) {
    case 'default':
      return /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)(templateObject_2$s || (templateObject_2$s = (0,common._)(["\n        color: ", ";\n        background-color: ", ";\n        ", "\n      " + ( true ? "" : 0)], ["\n        color: ", ";\n        background-color: ", ";\n        ", "\n      " + ( true ? "" : 0)])), theme.content.base1, theme.content.base5, hasInteraction && /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)(templateObject_1$v || (templateObject_1$v = (0,common._)(["\n          &:hover {\n            background-color: ", ";\n          }\n        " + ( true ? "" : 0)], ["\n          &:hover {\n            background-color: ", ";\n          }\n        " + ( true ? "" : 0)])), theme.interactive.base5));
    case 'outline':
      return /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)(templateObject_4$m || (templateObject_4$m = (0,common._)(["\n        color: ", ";\n        border: ", " solid ", ";\n        ", "\n      " + ( true ? "" : 0)], ["\n        color: ", ";\n        border: ", " solid ", ";\n        ", "\n      " + ( true ? "" : 0)])), theme.content.base1, (0,foundation.p)(1), theme.border, hasInteraction && /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)(templateObject_3$p || (templateObject_3$p = (0,common._)(["\n          &:hover {\n            background-color: ", ";\n          }\n        " + ( true ? "" : 0)], ["\n          &:hover {\n            background-color: ", ";\n          }\n        " + ( true ? "" : 0)])), theme.interactive.transparent));
    case 'primary1':
    case 'primary3':
    case 'primary4':
      return /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)(templateObject_6$e || (templateObject_6$e = (0,common._)(["\n        color: ", ";\n        background-color: ", ";\n        ", "\n      " + ( true ? "" : 0)], ["\n        color: ", ";\n        background-color: ", ";\n        ", "\n      " + ( true ? "" : 0)])), theme.content.white, theme.content[variant].basic, hasInteraction && /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)(templateObject_5$g || (templateObject_5$g = (0,common._)(["\n          &:hover {\n            background-color: ", ";\n          }\n        " + ( true ? "" : 0)], ["\n          &:hover {\n            background-color: ", ";\n          }\n        " + ( true ? "" : 0)])), theme.interactive[variant].basic));
  }
}
/**
 * @deprecated ODS의 Chip 컴포넌트를 사용해 주세요. 만약 디자인상 ODS의 Chip 컴포넌트를 사용할 수 없는 경우, 디자인시스템 담당 디자이너에게 문의해주세요.
 */
function Chip(_a) {
  var children = _a.children,
    size = _a.size,
    _b = _a.variant,
    variant = _b === void 0 ? 'default' : _b,
    thumbnail = _a.thumbnail,
    onRemove = _a.onRemove,
    onClick = _a.onClick,
    rest = (0,common.e)(_a, ["children", "size", "variant", "thumbnail", "onRemove", "onClick"]);
  var theme = (0,emotion_element_5486c51c_browser_esm.u)();
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", (0,common.a)({
    css: [cssBaseChip(size), cssVariant$2({
      theme: theme,
      variant: variant,
      hasInteraction: !!onClick
    }), /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)(templateObject_7$c || (templateObject_7$c = (0,common._)(["cursor: ", ";" + ( true ? "" : 0)], ["cursor: ", ";" + ( true ? "" : 0)])), onClick ? 'pointer' : 'default')],
    onClick: onClick
  }, rest, {
    children: [thumbnail && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Thumbnail, {
      src: thumbnail,
      size: size
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text, (0,common.a)({
      size: size
    }, {
      children: children
    })), onRemove && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(RemoveButton, {
      size: size,
      fill: {
        "default": 'base2',
        outline: 'base2',
        primary1: 'white',
        primary3: 'white',
        primary4: 'white'
      }[variant],
      onClick: onRemove
    })]
  }));
}
var templateObject_1$v, templateObject_2$s, templateObject_3$p, templateObject_4$m, templateObject_5$g, templateObject_6$e, templateObject_7$c;

/**
 * @deprecated ODS에서는 더이상 사용되지 않는 컴포넌트입니다. 디자이너에 문의해주세요.
 */
function InputChip(_a) {
  var className = _a.className,
    prefix = _a.prefix,
    value = _a.value,
    placeholder = _a.placeholder,
    _onChange = _a.onChange,
    onValue = _a.onValue,
    _onFocus = _a.onFocus,
    _onBlur = _a.onBlur,
    onRemove = _a.onRemove,
    rest = __rest(_a, ["className", "prefix", "value", "placeholder", "onChange", "onValue", "onFocus", "onBlur", "onRemove"]);
  var theme = useTheme();
  var ref = useRef(null);
  var _b = useState(0),
    width = _b[0],
    setWidth = _b[1];
  var _c = useState(false),
    focused = _c[0],
    setFocused = _c[1];
  useEffect(function () {
    if (ref.current) {
      ref.current.style.width = '0';
      setWidth(ref.current.scrollWidth);
      ref.current.removeAttribute('style');
    }
  }, [value, placeholder]);
  return jsxs("div", _assign({
    className: className,
    css: [FONT_STYLE.subTitle2, cssBaseChip(32), /*#__PURE__*/css(templateObject_1$u || (templateObject_1$u = __makeTemplateObject(["\n          position: relative;\n          white-space: nowrap;\n          color: ", ";\n          border: ", " solid\n            ", ";\n          background-color: ", ";\n          &:hover {\n            border-color: ", ";\n            background-color: ", ";\n          }\n        " + ( true ? "" : 0)], ["\n          position: relative;\n          white-space: nowrap;\n          color: ", ";\n          border: ", " solid\n            ", ";\n          background-color: ", ";\n          &:hover {\n            border-color: ", ";\n            background-color: ", ";\n          }\n        " + ( true ? "" : 0)])), theme.content.base1, pxToRem(1), focused ? theme.content.primary1.basic : theme.content.base5, theme.content.base5, focused ? theme.content.primary1.basic : theme.interactive.base5, theme.interactive.base5)]
  }, {
    children: [jsx("span", _assign({
      ref: ref,
      css: /*#__PURE__*/css(templateObject_2$r || (templateObject_2$r = __makeTemplateObject(["\n          position: absolute;\n          display: inline-block;\n          white-space: pre;\n          visibility: hidden;\n          top: 0;\n          left: 0;\n        " + ( true ? "" : 0)], ["\n          position: absolute;\n          display: inline-block;\n          white-space: pre;\n          visibility: hidden;\n          top: 0;\n          left: 0;\n        " + ( true ? "" : 0)])))
    }, {
      children: value || placeholder
    })), prefix && jsx(Text, _assign({
      size: 32,
      css: /*#__PURE__*/css(templateObject_3$o || (templateObject_3$o = __makeTemplateObject(["\n            margin-right: ", ";\n          " + ( true ? "" : 0)], ["\n            margin-right: ", ";\n          " + ( true ? "" : 0)])), pxToRem(1))
    }, {
      children: prefix
    })), jsx("input", _assign({}, rest, {
      value: value,
      placeholder: placeholder,
      onFocus: function onFocus(e) {
        if (_onFocus) {
          _onFocus(e);
        }
        setFocused(true);
      },
      onBlur: function onBlur(e) {
        if (_onBlur) {
          _onBlur(e);
        }
        setFocused(false);
      },
      onChange: function onChange(e) {
        return onValueHandler(e, {
          onChange: _onChange,
          onValue: onValue
        });
      },
      css: /*#__PURE__*/css(templateObject_4$l || (templateObject_4$l = __makeTemplateObject(["\n          ", "\n          width: ", ";\n          font: inherit;\n          color: inherit;\n          vertical-align: middle;\n          &::placeholder {\n            color: ", ";\n          }\n        " + ( true ? "" : 0)], ["\n          ", "\n          width: ", ";\n          font: inherit;\n          color: inherit;\n          vertical-align: middle;\n          &::placeholder {\n            color: ", ";\n          }\n        " + ( true ? "" : 0)])), RESET_INPUT, pxToRem(width), theme.content.base3)
    })), onRemove && jsx(RemoveButton, {
      fill: "base2",
      onClick: onRemove
    })]
  }));
}
var templateObject_1$u, templateObject_2$r, templateObject_3$o, templateObject_4$l;

function cssVariant$1(theme, variant) {
  switch (variant) {
    case 'primary1':
    case 'primary3':
      return /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)(templateObject_1$t || (templateObject_1$t = (0,common._)(["\n        color: ", ";\n        background-color: ", ";\n        @media (hover: hover) and (pointer: fine) {\n          &:hover {\n            background-color: ", ";\n          }\n        }\n      " + ( true ? "" : 0)], ["\n        color: ", ";\n        background-color: ", ";\n        @media (hover: hover) and (pointer: fine) {\n          &:hover {\n            background-color: ", ";\n          }\n        }\n      " + ( true ? "" : 0)])), theme.content.white, theme.content[variant].basic, theme.interactive[variant].basic);
    case 'primary4':
      return /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)(templateObject_2$q || (templateObject_2$q = (0,common._)(["\n        color: ", ";\n        background-color: ", ";\n        @media (hover: hover) and (pointer: fine) {\n          &:hover {\n            background-color: ", ";\n          }\n        }\n      " + ( true ? "" : 0)], ["\n        color: ", ";\n        background-color: ", ";\n        @media (hover: hover) and (pointer: fine) {\n          &:hover {\n            background-color: ", ";\n          }\n        }\n      " + ( true ? "" : 0)])), theme.content.white, theme.content.primary4.thick, theme.interactive.primary4.thick);
    case 'base1':
      return /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)(templateObject_3$n || (templateObject_3$n = (0,common._)(["\n        color: ", ";\n        background-color: ", ";\n        @media (hover: hover) and (pointer: fine) {\n          &:hover {\n            background-color: ", ";\n          }\n        }\n      " + ( true ? "" : 0)], ["\n        color: ", ";\n        background-color: ", ";\n        @media (hover: hover) and (pointer: fine) {\n          &:hover {\n            background-color: ", ";\n          }\n        }\n      " + ( true ? "" : 0)])), theme.content.white, theme.content[variant], theme.interactive[variant]);
  }
}
/**
 * @deprecated ODS에서는 더이상 사용되지 않는 컴포넌트입니다. 디자이너에 문의해주세요.
 */
function SelectChip(_a) {
  var id = _a.id,
    children = _a.children,
    className = _a.className,
    size = _a.size,
    variant = _a.variant,
    thumbnail = _a.thumbnail,
    extraText = _a.extraText,
    checked = _a.checked,
    onChange = _a.onChange,
    onCheck = _a.onCheck,
    rest = (0,common.e)(_a, ["id", "children", "className", "size", "variant", "thumbnail", "extraText", "checked", "onChange", "onCheck"]);
  var theme = (0,emotion_element_5486c51c_browser_esm.u)();
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("label", (0,common.a)({
    className: className,
    htmlFor: id,
    css: [cssBaseChip(size), checked ? cssVariant$1(theme, variant) : /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)(templateObject_4$k || (templateObject_4$k = (0,common._)(["\n              color: ", ";\n              background-color: ", ";\n              &:hover {\n                background-color: ", ";\n              }\n            " + ( true ? "" : 0)], ["\n              color: ", ";\n              background-color: ", ";\n              &:hover {\n                background-color: ", ";\n              }\n            " + ( true ? "" : 0)])), theme.content.base1, theme.content.base5, theme.interactive.base5), /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)(templateObject_5$f || (templateObject_5$f = (0,common._)(["cursor: pointer;" + ( true ? "" : 0)], ["cursor: pointer;" + ( true ? "" : 0)])))]
  }, {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Checkbox, (0,common.a)({}, rest, {
      id: id,
      checked: checked,
      onCheck: onCheck,
      onChange: onChange
    })), thumbnail && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Thumbnail, {
      src: thumbnail,
      size: size
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text, (0,common.a)({
      size: size
    }, {
      children: children
    })), extraText && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text, (0,common.a)({
      size: size,
      css: [checked ? /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)(templateObject_6$d || (templateObject_6$d = (0,common._)(["\n                  color: ", ";\n                " + ( true ? "" : 0)], ["\n                  color: ", ";\n                " + ( true ? "" : 0)])), theme.content.white) : /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)(templateObject_7$b || (templateObject_7$b = (0,common._)(["\n                  color: ", ";                  \n                " + ( true ? "" : 0)], ["\n                  color: ", ";                  \n                " + ( true ? "" : 0)])), variant === 'base1' ? theme.content.base1 : theme.content[variant].thick), /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)(templateObject_8$9 || (templateObject_8$9 = (0,common._)(["\n              margin-left: ", ";\n            " + ( true ? "" : 0)], ["\n              margin-left: ", ";\n            " + ( true ? "" : 0)])), (0,foundation.p)(2))]
    }, {
      children: extraText
    }))]
  }));
}
var templateObject_1$t, templateObject_2$q, templateObject_3$n, templateObject_4$k, templateObject_5$f, templateObject_6$d, templateObject_7$b, templateObject_8$9;

function cssVariant(theme, variant) {
  switch (variant) {
    case 'primary1':
    case 'primary4':
      return /*#__PURE__*/css(templateObject_1$s || (templateObject_1$s = __makeTemplateObject(["\n        color: ", ";\n        background-color: ", ";\n        border: ", " solid ", ";\n        @media(hover: hover) and (pointer: fine) {\n          &:hover {\n            background-color: ", ";\n          }\n        }\n      " + ( true ? "" : 0)], ["\n        color: ", ";\n        background-color: ", ";\n        border: ", " solid ", ";\n        @media(hover: hover) and (pointer: fine) {\n          &:hover {\n            background-color: ", ";\n          }\n        }\n      " + ( true ? "" : 0)])), theme.content[variant].thick, theme.content[variant].thin, pxToRem(1), theme.content[variant].thick, theme.interactive[variant].thin);
    case 'primary3':
      return /*#__PURE__*/css(templateObject_2$p || (templateObject_2$p = __makeTemplateObject(["\n        color: ", ";\n        background-color: ", ";\n        border: ", " solid ", ";\n        @media(hover: hover) and (pointer: fine) {\n          &:hover {\n            background-color: ", ";\n          }\n        }\n      " + ( true ? "" : 0)], ["\n        color: ", ";\n        background-color: ", ";\n        border: ", " solid ", ";\n        @media(hover: hover) and (pointer: fine) {\n          &:hover {\n            background-color: ", ";\n          }\n        }\n      " + ( true ? "" : 0)])), theme.content[variant].basic, theme.content[variant].thin, pxToRem(1), theme.content[variant].basic, theme.interactive[variant].thin);
    case 'base1':
      return /*#__PURE__*/css(templateObject_3$m || (templateObject_3$m = __makeTemplateObject(["\n        color: ", ";\n        background-color: ", ";\n        border: ", " solid ", ";\n        @media(hover: hover) and (pointer: fine) {\n          &:hover {\n            background-color: ", ";\n          }\n        }\n      " + ( true ? "" : 0)], ["\n        color: ", ";\n        background-color: ", ";\n        border: ", " solid ", ";\n        @media(hover: hover) and (pointer: fine) {\n          &:hover {\n            background-color: ", ";\n          }\n        }\n      " + ( true ? "" : 0)])), theme.content.base1, theme.content.base5, pxToRem(1), theme.content.base1, theme.interactive.base5);
  }
}
/**
 * @deprecated ODS에서는 더이상 사용되지 않는 컴포넌트입니다. 디자이너에 문의해주세요.
 */
function OutlineSelectChip(_a) {
  var id = _a.id,
    children = _a.children,
    size = _a.size,
    variant = _a.variant,
    thumbnail = _a.thumbnail,
    extraText = _a.extraText,
    _b = _a.checked,
    checked = _b === void 0 ? false : _b,
    onChange = _a.onChange,
    onCheck = _a.onCheck,
    className = _a.className,
    rest = __rest(_a, ["id", "children", "size", "variant", "thumbnail", "extraText", "checked", "onChange", "onCheck", "className"]);
  var theme = useTheme();
  return jsxs("label", _assign({
    className: className,
    htmlFor: id,
    css: [cssBaseChip(size), checked ? cssVariant(theme, variant) : /*#__PURE__*/css(templateObject_4$j || (templateObject_4$j = __makeTemplateObject(["\n              color: ", ";\n              border: ", " solid ", ";\n              @media(hover: hover) and (pointer: fine) {\n                &:hover {\n                  background-color: ", ";\n                }\n              }\n            " + ( true ? "" : 0)], ["\n              color: ", ";\n              border: ", " solid ", ";\n              @media(hover: hover) and (pointer: fine) {\n                &:hover {\n                  background-color: ", ";\n                }\n              }\n            " + ( true ? "" : 0)])), theme.content.base1, pxToRem(1), theme.border, theme.interactive.base5), /*#__PURE__*/css(templateObject_5$e || (templateObject_5$e = __makeTemplateObject(["cursor: pointer;" + ( true ? "" : 0)], ["cursor: pointer;" + ( true ? "" : 0)])))]
  }, {
    children: [jsx(Checkbox, _assign({}, rest, {
      id: id,
      checked: checked,
      onCheck: onCheck,
      onChange: onChange
    })), thumbnail && jsx(Thumbnail, {
      src: thumbnail,
      size: size
    }), jsx(Text, _assign({
      size: size
    }, {
      children: children
    })), extraText && jsx(Text, _assign({
      size: size,
      css: [/*#__PURE__*/css(templateObject_6$c || (templateObject_6$c = __makeTemplateObject(["color: ", ";" + ( true ? "" : 0)], ["color: ", ";" + ( true ? "" : 0)])), variant === 'primary3' ? theme.content[variant].basic : variant !== 'base1' ? theme.content[variant].thick : theme.content[variant]), /*#__PURE__*/css(templateObject_7$a || (templateObject_7$a = __makeTemplateObject(["\n              margin-left: ", ";\n            " + ( true ? "" : 0)], ["\n              margin-left: ", ";\n            " + ( true ? "" : 0)])), pxToRem(2))]
    }, {
      children: extraText
    }))]
  }));
}
var templateObject_1$s, templateObject_2$p, templateObject_3$m, templateObject_4$j, templateObject_5$e, templateObject_6$c, templateObject_7$a;

/**
 * @deprecated ODS에서는 더이상 사용되지 않는 컴포넌트입니다. 디자이너에 문의해주세요.
 */
function FillOutlineSelectChip(props) {
  var checked = props.checked;
  return checked ? jsx(SelectChip, _assign({}, props)) : jsx(OutlineSelectChip, _assign({}, props));
}

var cat1x1 = "https://assets.ohou.se/design-system/4115b98dcf15cece.png";

var cat1x2 = "https://assets.ohou.se/design-system/0d544e95b1db25b2.png";

var cat1x3 = "https://assets.ohou.se/design-system/266288958944af51.png";

var man1x1 = "https://assets.ohou.se/design-system/23babe1bcb31c86f.png";

var man1x2 = "https://assets.ohou.se/design-system/b3ed77dde9be5229.png";

var man1x3 = "https://assets.ohou.se/design-system/5a7ef2ef9bba815e.png";

function EmptyImage(_a) {
  var image = _a.image;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Image, {
    aspectRatio: "1:1",
    css: /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)(templateObject_1$r || (templateObject_1$r = (0,common._)(["\n        width: ", ";\n        vertical-align: top;\n      " + ( true ? "" : 0)], ["\n        width: ", ";\n        vertical-align: top;\n      " + ( true ? "" : 0)])), (0,foundation.p)(100)),
    src: {
      cat1: cat1x1,
      man1: man1x1
    }[image],
    src2x: {
      cat1: cat1x2,
      man1: man1x2
    }[image],
    src3x: {
      cat1: cat1x3,
      man1: man1x3
    }[image]
  });
}
var templateObject_1$r;

/**
 * @deprecated ODS의 Empty 컴포넌트를 사용해 주세요. 만약 디자인상 ODS의 Empty 컴포넌트를 사용할 수 없는 경우, 디자인시스템 담당 디자이너에게 문의해주세요.
 */
function EmptyPage(_a) {
  var image = _a.image,
    title = _a.title,
    description = _a.description,
    action = _a.action,
    subAction = _a.subAction,
    rest = (0,common.e)(_a, ["image", "title", "description", "action", "subAction"]);
  var theme = (0,emotion_element_5486c51c_browser_esm.u)();
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", (0,common.a)({}, rest, {
    css: /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)(templateObject_1$q || (templateObject_1$q = (0,common._)(["\n        width: ", ";\n        margin: 0 auto;\n        text-align: center;\n      " + ( true ? "" : 0)], ["\n        width: ", ";\n        margin: 0 auto;\n        text-align: center;\n      " + ( true ? "" : 0)])), (0,foundation.p)(343))
  }, {
    children: [image && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", (0,common.a)({
      css: /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)(templateObject_2$o || (templateObject_2$o = (0,common._)(["\n            margin-bottom: ", ";\n          " + ( true ? "" : 0)], ["\n            margin-bottom: ", ";\n          " + ( true ? "" : 0)])), (0,foundation.p)(10))
    }, {
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(EmptyImage, {
        image: image
      })
    })), title && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("p", (0,common.a)({
      css: [foundation.F.title1, /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)(templateObject_3$l || (templateObject_3$l = (0,common._)(["\n            color: ", ";\n            white-space: pre-wrap;\n          " + ( true ? "" : 0)], ["\n            color: ", ";\n            white-space: pre-wrap;\n          " + ( true ? "" : 0)])), theme.content.base1)]
    }, {
      children: title
    })), description && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("p", (0,common.a)({
      css: [foundation.F.body1_1, /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)(templateObject_4$i || (templateObject_4$i = (0,common._)(["\n            margin-top: ", ";\n            color: ", ";\n            white-space: pre-wrap;\n          " + ( true ? "" : 0)], ["\n            margin-top: ", ";\n            color: ", ";\n            white-space: pre-wrap;\n          " + ( true ? "" : 0)])), (0,foundation.p)(10), theme.content.base2)]
    }, {
      children: description
    })), action && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", (0,common.a)({
      css: /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)(templateObject_5$d || (templateObject_5$d = (0,common._)(["\n            margin-top: ", ";\n          " + ( true ? "" : 0)], ["\n            margin-top: ", ";\n          " + ( true ? "" : 0)])), (0,foundation.p)(10))
    }, {
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Button$2, (0,common.a)({
        size: 44,
        variant: "primary1",
        onClick: action.onClick
      }, {
        children: action.text
      }))
    })), subAction && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", (0,common.a)({
      css: /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)(templateObject_6$b || (templateObject_6$b = (0,common._)(["\n            margin-top: ", ";\n          " + ( true ? "" : 0)], ["\n            margin-top: ", ";\n          " + ( true ? "" : 0)])), (0,foundation.p)(3))
    }, {
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TextButton, (0,common.a)({
        size: 32,
        variant: "primary1",
        onClick: subAction.onClick
      }, {
        children: subAction.text
      }))
    }))]
  }));
}
var templateObject_1$q, templateObject_2$o, templateObject_3$l, templateObject_4$i, templateObject_5$d, templateObject_6$b;

function SocialLink(_a) {
  var type = _a.type,
    href = _a.href;
  var theme = (0,emotion_element_5486c51c_browser_esm.u)();
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("a", (0,common.a)({
    href: href,
    target: "_blank",
    css: /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)(templateObject_1$p || (templateObject_1$p = (0,common._)(["\n        display: inline-block;\n        margin-right: ", ";\n      " + ( true ? "" : 0)], ["\n        display: inline-block;\n        margin-right: ", ";\n      " + ( true ? "" : 0)])), (0,foundation.p)(12)),
    rel: "noreferrer",
    "data-testid": "SocialLink-".concat(type)
  }, {
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("svg", (0,common.a)({
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      css: /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)(templateObject_2$n || (templateObject_2$n = (0,common._)(["\n        vertical-align: top;\n        color: ", ";\n        &:hover {\n          color: ", ";\n        }\n      " + ( true ? "" : 0)], ["\n        vertical-align: top;\n        color: ", ";\n        &:hover {\n          color: ", ";\n        }\n      " + ( true ? "" : 0)])), theme.content.base2, theme.interactive.base2)
    }, {
      children: [type === 'KakaoStory' && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(KakaoStorySvg, {}), type === 'Facebook' && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FacebookSvg, {}), type === 'Instagram' && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(InstagramSvg, {}), type === 'NaverPost' && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(NaverPostSvg, {}), type === 'Youtube' && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(YoutubeSvg, {}), type === 'Pinterest' && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PinterestSvg, {}), type === 'TikTok' && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TikTokSvg, {})]
    }))
  }));
}
function KakaoStorySvg() {
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("circle", {
      cx: "12",
      cy: "12",
      r: "11",
      fill: "currentColor"
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
      d: "M14.6548 6.5H9.34617C8.98953 6.5 8.70036 6.77492 8.70036 7.11427V12.4991C8.70036 12.8382 8.98953 13.1132 9.34617 13.1132H11.7936C11.7768 13.7122 11.5225 14.3691 11.1359 14.9432C10.7632 15.4965 10.1507 16.0415 9.81838 16.3021C9.80983 16.3089 9.80136 16.3154 9.79337 16.3217C9.72167 16.3871 9.66939 16.4632 9.66826 16.5686C9.66714 16.6486 9.71075 16.7105 9.75928 16.7761L9.77173 16.7896L11.4662 18.6074C11.4662 18.6074 11.549 18.6908 11.6175 18.7066C11.6948 18.7243 11.7823 18.7265 11.8429 18.6818C14.7987 16.5067 15.2256 13.7794 15.2999 12.3034C15.3001 12.295 15.3004 7.11427 15.3004 7.11427C15.3004 6.77492 15.0114 6.5 14.6548 6.5Z",
      fill: "white"
    })]
  });
}
function FacebookSvg() {
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("g", (0,common.a)({
      clipPath: "url(#clip0_21132_87052)"
    }, {
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
        d: "M23 12C23 5.92486 18.0751 1 12 1C5.92486 1 1 5.92486 1 12C1 17.4903 5.02252 22.0412 10.2812 22.8664V15.1797H7.48828V12H10.2812V9.57656C10.2812 6.81969 11.9235 5.29688 14.4361 5.29688C15.6397 5.29688 16.8984 5.51172 16.8984 5.51172V8.21875H15.5114C14.145 8.21875 13.7188 9.06674 13.7188 9.93664V12H16.7695L16.2818 15.1797H13.7188V22.8664C18.9775 22.0412 23 17.4905 23 12Z",
        fill: "currentColor"
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
        d: "M16.2818 15.1797L16.7695 12H13.7188V9.93664C13.7188 9.06674 14.145 8.21875 15.5114 8.21875H16.8984V5.51172C16.8984 5.51172 15.6397 5.29688 14.4361 5.29688C11.9235 5.29688 10.2812 6.81969 10.2812 9.57656V12H7.48828V15.1797H10.2812V22.8664C10.8413 22.9542 11.4152 23 12 23C12.5848 23 13.1587 22.9542 13.7188 22.8664V15.1797H16.2818Z",
        fill: "white"
      })]
    })), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("defs", {
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("clipPath", (0,common.a)({
        id: "clip0_21132_87052"
      }, {
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("rect", {
          width: "22",
          height: "22",
          fill: "white",
          transform: "translate(1 1)"
        })
      }))
    })]
  });
}
function InstagramSvg() {
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("circle", {
      cx: "12",
      cy: "12",
      r: "11",
      fill: "currentColor"
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
      d: "M9.10061 5.04896C8.3558 5.0841 7.84718 5.20296 7.40253 5.37768C6.94235 5.55702 6.5523 5.79768 6.16422 6.18717C5.77614 6.57665 5.53715 6.96698 5.35907 7.42786C5.18673 7.87349 5.06997 8.38253 5.03707 9.12776C5.00417 9.87299 4.99689 10.1125 5.00053 12.0135C5.00417 13.9144 5.01257 14.1527 5.04869 14.8995C5.08425 15.6441 5.20269 16.1526 5.37741 16.5974C5.55703 17.0576 5.79742 17.4475 6.18704 17.8357C6.57666 18.2239 6.96671 18.4624 7.42871 18.6407C7.87392 18.8128 8.3831 18.9301 9.12819 18.9627C9.87328 18.9953 10.1131 19.0029 12.0135 18.9993C13.9139 18.9956 14.1531 18.9872 14.8997 18.9518C15.6464 18.9164 16.1522 18.7971 16.5971 18.6232C17.0573 18.4432 17.4475 18.2032 17.8354 17.8134C18.2234 17.4237 18.4622 17.0331 18.6402 16.5719C18.8126 16.1267 18.9298 15.6175 18.9622 14.873C18.9948 14.1258 19.0025 13.8872 18.9988 11.9866C18.9952 10.0859 18.9867 9.84765 18.9513 9.10116C18.9158 8.35467 18.7972 7.84773 18.6227 7.40266C18.4428 6.94248 18.2027 6.55285 17.8132 6.16435C17.4237 5.77584 17.0328 5.53714 16.5718 5.35962C16.1263 5.18728 15.6174 5.06982 14.8723 5.03762C14.1272 5.00542 13.8874 4.99716 11.9863 5.0008C10.0852 5.00444 9.84724 5.01256 9.10061 5.04896ZM9.18237 17.7034C8.49986 17.6737 8.12928 17.5603 7.88232 17.4654C7.55527 17.3394 7.32231 17.1871 7.07619 16.9433C6.83007 16.6996 6.67886 16.4658 6.55118 16.1394C6.45528 15.8925 6.33978 15.5223 6.30786 14.8398C6.27314 14.1021 6.26586 13.8807 6.2618 12.0118C6.25774 10.1429 6.26488 9.92171 6.29722 9.18376C6.32634 8.50181 6.44044 8.13081 6.53522 7.88399C6.66122 7.55652 6.81299 7.32398 7.05729 7.078C7.30159 6.83201 7.53469 6.68053 7.86132 6.55285C8.108 6.45653 8.47816 6.34201 9.16039 6.30953C9.89862 6.27453 10.1198 6.26753 11.9884 6.26347C13.857 6.25941 14.0788 6.26641 14.8173 6.29889C15.4992 6.32857 15.8704 6.44155 16.1169 6.53689C16.4441 6.66289 16.6769 6.81423 16.9229 7.05896C17.1689 7.30368 17.3205 7.53594 17.4482 7.86327C17.5447 8.10925 17.6592 8.47927 17.6914 9.16192C17.7265 9.90015 17.7345 10.1215 17.7379 11.9899C17.7412 13.8584 17.7346 14.0803 17.7023 14.818C17.6725 15.5005 17.5594 15.8712 17.4643 16.1184C17.3383 16.4454 17.1864 16.6785 16.9419 16.9243C16.6975 17.1701 16.4647 17.3216 16.1379 17.4493C15.8915 17.5455 15.5209 17.6603 14.8393 17.6928C14.101 17.7275 13.8798 17.7348 12.0105 17.7388C10.1412 17.7429 9.92074 17.7353 9.18251 17.7034M14.889 8.25877C14.8898 8.72273 15.2664 9.09822 15.7304 9.09738C16.1943 9.09654 16.5698 8.71993 16.569 8.25597C16.5681 7.792 16.1915 7.41652 15.7276 7.41736C15.7276 7.41736 15.7274 7.41736 15.7273 7.41736C15.2635 7.41834 14.8881 7.79494 14.889 8.25877ZM8.4055 12.007C8.40942 13.9922 10.0217 15.5979 12.0065 15.5941C13.9913 15.5904 15.5981 13.9782 15.5943 11.993C15.5905 10.0078 13.9778 8.40171 11.9928 8.40563C10.0077 8.40955 8.40172 10.0221 8.4055 12.007ZM9.66635 12.0045C9.66383 10.7158 10.7064 9.669 11.9951 9.66648C13.2839 9.66396 14.3306 10.7066 14.3332 11.9953C14.3357 13.284 13.2931 14.3308 12.0044 14.3333C10.7158 14.336 9.66901 13.2936 9.66635 12.0051V12.0045Z",
      fill: "white"
    })]
  });
}
function NaverPostSvg() {
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("circle", {
      cx: "12",
      cy: "12",
      r: "11",
      fill: "currentColor"
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
      d: "M7.96631 5.76685H16.033V13.8335H7.96631V5.76685ZM12.5913 8.24889V9.81433L11.4126 8.24889H10.1381V11.3515H11.4082V9.78601L12.5872 11.3515H13.8612V8.24889H12.5913Z",
      fill: "white"
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
      d: "M7.96631 14.454H16.033L14.5204 16.3156H9.47869L7.96631 14.454Z",
      fill: "white"
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
      d: "M9.98281 16.9361H14.0161L11.9993 19.4181L9.98281 16.9361Z",
      fill: "white"
    })]
  });
}
function YoutubeSvg() {
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("circle", {
      cx: "12",
      cy: "12",
      r: "11",
      fill: "currentColor"
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
      d: "M18.7086 8.63031C18.5472 8.02758 18.0736 7.55392 17.4709 7.39258C16.3783 7.09985 12.0002 7.09985 12.0002 7.09985C12.0002 7.09985 7.62199 7.09985 6.53062 7.39258C5.92789 7.55392 5.45423 8.02758 5.29289 8.63031C5.00016 9.72168 5.00016 12.0001 5.00016 12.0001C5.00016 12.0001 5.00016 14.2785 5.29289 15.3699C5.45423 15.9726 5.92789 16.4462 6.53062 16.6076C7.62199 16.9003 12.0002 16.9003 12.0002 16.9003C12.0002 16.9003 16.3783 16.9003 17.4697 16.6076C18.0724 16.4462 18.5461 15.9726 18.7074 15.3699C19.0002 14.2785 19.0002 12.0001 19.0002 12.0001C19.0002 12.0001 19.0002 9.72168 18.7074 8.63031H18.7086Z",
      fill: "white"
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
      d: "M10.6013 14.0994L14.2396 11.9997L10.6013 9.8999V14.0994Z",
      fill: "currentColor"
    })]
  });
}
function PinterestSvg() {
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("g", (0,common.a)({
    id: "mdi:pinterest"
  }, {
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
      id: "Vector",
      d: "M8.744 22.494C9.8 22.813 10.867 23 12 23C14.9174 23 17.7153 21.8411 19.7782 19.7782C21.8411 17.7153 23 14.9174 23 12C23 10.5555 22.7155 9.12506 22.1627 7.79048C21.6099 6.4559 20.7996 5.24327 19.7782 4.22183C18.7567 3.20038 17.5441 2.39013 16.2095 1.83733C14.8749 1.28452 13.4445 1 12 1C10.5555 1 9.12506 1.28452 7.79048 1.83733C6.4559 2.39013 5.24327 3.20038 4.22183 4.22183C2.15893 6.28473 1 9.08262 1 12C1 16.675 3.937 20.69 8.084 22.274C7.985 21.416 7.886 19.997 8.084 19.018L9.349 13.584C9.349 13.584 9.03 12.946 9.03 11.934C9.03 10.416 9.976 9.283 11.054 9.283C12 9.283 12.44 9.976 12.44 10.867C12.44 11.813 11.813 13.166 11.494 14.464C11.307 15.542 12.066 16.488 13.166 16.488C15.124 16.488 16.642 14.398 16.642 11.45C16.642 8.81 14.75 7.006 12.033 7.006C8.931 7.006 7.105 9.316 7.105 11.747C7.105 12.693 7.413 13.65 7.919 14.277C8.018 14.343 8.018 14.431 7.985 14.596L7.666 15.795C7.666 15.982 7.545 16.048 7.358 15.916C5.95 15.3 5.136 13.298 5.136 11.681C5.136 8.205 7.6 5.048 12.352 5.048C16.136 5.048 19.084 7.765 19.084 11.373C19.084 15.157 16.741 18.193 13.386 18.193C12.319 18.193 11.274 17.621 10.9 16.95L10.163 19.557C9.91 20.503 9.217 21.768 8.744 22.527V22.494Z",
      fill: "currentColor"
    })
  }));
}
function TikTokSvg() {
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 23C18.0751 23 23 18.0751 23 12C23 5.92487 18.0751 1 12 1C5.92487 1 1 5.92487 1 12C1 18.0751 5.92487 23 12 23ZM14.9105 4.41289V4.40002H12.3471V14.4163C12.3471 14.8779 12.2999 15.2892 12.2051 15.6499C11.3685 17.4927 8.97015 17.2094 8.38751 15.9032C7.74726 14.4685 8.5531 12.4646 10.9619 12.8189C10.9619 11.4282 10.9615 11.4283 10.9611 11.4284C10.9607 11.4285 10.9603 11.4286 10.9603 10.0384C5.12937 9.11658 3.19974 17.7295 9.00693 19.4666C10.015 19.6869 10.6155 19.6726 11.2824 19.5463C13.6628 19.095 14.9342 16.855 14.9027 14.571L14.9067 9.52692C16.1836 10.6659 18.2357 10.8143 18.5 10.7985C18.5 9.5631 18.4996 9.62598 18.4992 9.69178C18.4988 9.76398 18.4984 9.83969 18.4984 8.20747C14.9792 7.99822 14.9112 4.64478 14.9105 4.41289Z",
    fill: "currentColor"
  });
}
var templateObject_1$p, templateObject_2$n;

var CUSTOMER_CENTER_EMAIL = 'cs@bucketplace.net';
function ServiceCenter(_a) {
  var phone = _a.phone,
    openingHour = _a.openingHour,
    ohouseFooterLinks = _a.ohouseFooterLinks;
  var openKakaoChat = (0,hooks.l)().openKakaoChat;
  var isApp = (0,utils.g)().isApp;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(ServiceCenterContainer, {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(ServiceCenterAnchorContainer, {
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ServiceCenterAnchor, (0,common.a)({
        href: ohouseFooterLinks === null || ohouseFooterLinks === void 0 ? void 0 : ohouseFooterLinks.serviceCenter
      }, {
        children: "\uACE0\uAC1D\uC13C\uD130"
      })), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Icon, {
        name: "chevron_thick_right",
        size: 12
      })]
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(ServiceCenterInfo, {
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ServiceCenterNumberAnchor, (0,common.a)({
        href: "tel:".concat(phone)
      }, {
        children: phone
      })), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ServiceCenterTime, (0,common.a)({
        dateTime: openingHour.start
      }, {
        children: openingHour.start
      })), "~", (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ServiceCenterTime, (0,common.a)({
        dateTime: openingHour.end
      }, {
        children: openingHour.end
      }))]
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(ServiceCenterDescription, {
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(WorkingDay, {
        children: "\uD3C9\uC77C: \uC804\uCCB4 \uBB38\uC758 \uC0C1\uB2F4"
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(WorkingDay, {
        children: "\uD1A0\uC694\uC77C, \uACF5\uD734\uC77C: \uC624\uB298\uC758\uC9D1 \uC9C1\uC811\uBC30\uC1A1 \uC8FC\uBB38\uAC74 \uC0C1\uB2F4"
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(WorkingDay, {
        children: "\uC77C\uC694\uC77C: \uD734\uBB34"
      })]
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(AnchorContainer, {
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(OutlineButton, (0,common.a)({
        variant: "base1",
        size: 32,
        onClick: openKakaoChat,
        css: cssServiceButton
      }, {
        children: "\uCE74\uD1A1 \uC0C1\uB2F4(\uD3C9\uC77C 09:00~18:00)"
      })), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(OutlineAnchorButton, (0,common.a)({
        href: !isApp || (0,utils.i)({
          AOS: '0',
          iOS: '8.8'
        }) ? ohouseFooterLinks === null || ohouseFooterLinks === void 0 ? void 0 : ohouseFooterLinks.voiceOfCustomer : "mailto:".concat(CUSTOMER_CENTER_EMAIL),
        variant: "base1",
        size: 32,
        css: cssServiceButton
      }, {
        children: "\uC774\uBA54\uC77C \uBB38\uC758"
      }))]
    })]
  });
}
var ServiceCenterContainer = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e18sae9p8"
} : 0)(templateObject_1$o || (templateObject_1$o = (0,common._)(["\n  color: ", ";\n"], ["\n  color: ", ";\n"])), function (_a) {
  var theme = _a.theme;
  return theme.content.base1;
});
var ServiceCenterAnchor = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("a",  true ? {
  target: "e18sae9p7"
} : 0)(templateObject_2$m || (templateObject_2$m = (0,common._)(["\n  ", "\n  font-weight: 700;\n  display: flex;\n  align-items: center;\n"], ["\n  ", "\n  font-weight: 700;\n  display: flex;\n  align-items: center;\n"])), foundation.F.title3);
var ServiceCenterNumberAnchor = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("a",  true ? {
  target: "e18sae9p6"
} : 0)(templateObject_3$k || (templateObject_3$k = (0,common._)(["\n  ", "\n  font-weight: 700;\n  white-space: nowrap;\n  margin-right: ", ";\n"], ["\n  ", "\n  font-weight: 700;\n  white-space: nowrap;\n  margin-right: ", ";\n"])), foundation.F.subTitle1, (0,foundation.p)(6));
var ServiceCenterInfo = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e18sae9p5"
} : 0)(templateObject_4$h || (templateObject_4$h = (0,common._)(["\n  display: flex;\n  align-items: center;\n  margin: ", " 0 ", ";\n"], ["\n  display: flex;\n  align-items: center;\n  margin: ", " 0 ", ";\n"])), (0,foundation.p)(20), (0,foundation.p)(8));
var ServiceCenterTime = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("time",  true ? {
  target: "e18sae9p4"
} : 0)(templateObject_5$c || (templateObject_5$c = (0,common._)(["\n  ", "\n"], ["\n  ", "\n"])), foundation.F.body2);
var ServiceCenterDescription = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e18sae9p3"
} : 0)(templateObject_6$a || (templateObject_6$a = (0,common._)(["\n  ", "\n  white-space: pre-wrap;\n  margin-bottom: ", ";\n  ", "\n"], ["\n  ", "\n  white-space: pre-wrap;\n  margin-bottom: ", ";\n  ", "\n"])), foundation.F.body3, (0,foundation.p)(12), foundation.M.min('desktop', "\n    padding-right: ".concat((0,foundation.p)(10), ";\n  ")));
var AnchorContainer = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e18sae9p2"
} : 0)(templateObject_7$9 || (templateObject_7$9 = (0,common._)(["\n  display: flex;\n  flex-direction: column;\n  gap: ", ";\n  margin-top: ", ";\n  ", "\n"], ["\n  display: flex;\n  flex-direction: column;\n  gap: ", ";\n  margin-top: ", ";\n  ", "\n"])), (0,foundation.p)(12), (0,foundation.p)(12), foundation.M.max('mobile', "\n    flex-direction: row;\n  "));
var cssServiceButton = /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)(templateObject_8$8 || (templateObject_8$8 = (0,common._)(["\n  width: fit-content;\n  white-space: nowrap;\n  ", "\n" + ( true ? "" : 0)], ["\n  width: fit-content;\n  white-space: nowrap;\n  ", "\n" + ( true ? "" : 0)])), foundation.M.max('mobile', "\n    white-space: normal;\n  "));
var ServiceCenterAnchorContainer = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e18sae9p1"
} : 0)(templateObject_9$8 || (templateObject_9$8 = (0,common._)(["\n  display: flex;\n  align-items: center;\n  gap: ", ";\n"], ["\n  display: flex;\n  align-items: center;\n  gap: ", ";\n"])), (0,foundation.p)(2));
var WorkingDay = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e18sae9p0"
} : 0)(templateObject_10$7 || (templateObject_10$7 = (0,common._)(["\n  position: relative;\n  padding-left: ", ";\n  &:before {\n    content: '\u2022';\n    position: absolute;\n    font-size: ", ";\n    left: ", ";\n  }\n"], ["\n  position: relative;\n  padding-left: ", ";\n  &:before {\n    content: '\\u2022';\n    position: absolute;\n    font-size: ", ";\n    left: ", ";\n  }\n"])), (0,foundation.p)(20), (0,foundation.p)(10), (0,foundation.p)(7));
var templateObject_1$o, templateObject_2$m, templateObject_3$k, templateObject_4$h, templateObject_5$c, templateObject_6$a, templateObject_7$9, templateObject_8$8, templateObject_9$8, templateObject_10$7;

function Certification(_a) {
  var certification = _a.certification;
  var img = certification.imgSrc && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Img, {
    src: certification.imgSrc,
    width: 32,
    height: 32,
    alt: "".concat(certification.id, " \uC778\uC99D \uB9C8\uD06C")
  });
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Container$3, {
    children: [certification.imgLink && img ? (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("a", (0,common.a)({
      href: certification.imgLink,
      target: "_blank",
      rel: "noreferrer"
    }, {
      children: img
    })) : img, (certification.title || certification.date) && (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Description, {
      children: [certification.title, (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("br", {}), certification.date]
    })]
  });
}
var Container$3 = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "eqedtio2"
} : 0)(templateObject_1$n || (templateObject_1$n = (0,common._)(["\n  display: flex;\n  height: ", ";\n  padding: 0 ", ";\n  gap: ", ";\n  align-items: center;\n  justify-content: center;\n  border: ", " solid ", ";\n"], ["\n  display: flex;\n  height: ", ";\n  padding: 0 ", ";\n  gap: ", ";\n  align-items: center;\n  justify-content: center;\n  border: ", " solid ", ";\n"])), (0,foundation.p)(40), (0,foundation.p)(6), (0,foundation.p)(6), (0,foundation.p)(1), function (_a) {
  var theme = _a.theme;
  return theme.outline;
});
var Img = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("img",  true ? {
  target: "eqedtio1"
} : 0)(templateObject_2$l || (templateObject_2$l = (0,common._)(["\n  border: none;\n"], ["\n  border: none;\n"])));
var Description = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "eqedtio0"
} : 0)(templateObject_3$j || (templateObject_3$j = (0,common._)(["\n  ", "\n  color: ", ";\n"], ["\n  ", "\n  color: ", ";\n"])), foundation.F.caption2, function (_a) {
  var theme = _a.theme;
  return theme.content.base2;
});
var templateObject_1$n, templateObject_2$l, templateObject_3$j;

function Responsive(_a) {
  var mobile = _a.mobile,
    _b = _a.tablet,
    tablet = _b === void 0 ? mobile : _b,
    _c = _a.laptop,
    laptop = _c === void 0 ? tablet : _c,
    _d = _a.desktop,
    desktop = _d === void 0 ? laptop : _d,
    defaultBreakpoint = _a.defaultBreakpoint,
    preventSyncOnInitialRender = _a.preventSyncOnInitialRender;
  var breakpoint = (0,hooks.m)({
    fallbackBreakpoint: defaultBreakpoint !== null && defaultBreakpoint !== void 0 ? defaultBreakpoint : 'mobile',
    preventSyncOnInitialRender: preventSyncOnInitialRender
  }).breakpoint;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
    children: [breakpoint === 'mobile' && mobile, breakpoint === 'tablet' && tablet, breakpoint === 'laptop' && laptop, breakpoint === 'desktop' && desktop]
  });
}

function CompanyInfo(_a) {
  var companyInfo = _a.companyInfo;
  var _b = (0,react.useState)(false),
    isOpenCompanyInfo = _b[0],
    setOpenCompanyInfo = _b[1];
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Responsive, {
    mobile: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Button, (0,common.a)({
        type: "button",
        onClick: function onClick() {
          return setOpenCompanyInfo(function (isOpenCompanyInfo) {
            return !isOpenCompanyInfo;
          });
        }
      }, {
        children: [companyInfo['상호명'], (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Icon, {
          name: isOpenCompanyInfo ? 'chevron_thick_up' : 'chevron_thick_down',
          size: 12
        })]
      })), isOpenCompanyInfo && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", (0,common.a)({
        css: /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)(templateObject_1$m || (templateObject_1$m = (0,common._)(["margin-top: ", ";" + ( true ? "" : 0)], ["margin-top: ", ";" + ( true ? "" : 0)])), (0,foundation.p)(12))
      }, {
        children: Object.keys(companyInfo).map(function (key) {
          return key !== '상호명' && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CompanyInfoItem, {
            children: companyInfo[key]
          }, key);
        })
      }))]
    }),
    tablet: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", (0,common.a)({
      css: /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)(templateObject_2$k || (templateObject_2$k = (0,common._)(["margin-left: ", ";" + ( true ? "" : 0)], ["margin-left: ", ";" + ( true ? "" : 0)])), (0,foundation.p)(-9))
    }, {
      children: Object.keys(companyInfo).map(function (key) {
        return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CompanyInfoItem, {
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", (0,common.a)({
            css: /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)(templateObject_3$i || (templateObject_3$i = (0,common._)(["margin: 0 ", ";" + ( true ? "" : 0)], ["margin: 0 ", ";" + ( true ? "" : 0)])), (0,foundation.p)(4))
          }, {
            children: "|"
          })), companyInfo[key]]
        }, key);
      })
    }))
  });
}
var CompanyInfoItem = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1jtu31t1"
} : 0)(templateObject_4$g || (templateObject_4$g = (0,common._)(["\n  ", "\n  display: inline-block;\n  white-space: nowrap;\n  ", "\n"], ["\n  ", "\n  display: inline-block;\n  white-space: nowrap;\n  ", "\n"])), foundation.F.body3, foundation.M.max('mobile', "\n    display: block;\n  "));
var Button = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("button",  true ? {
  target: "e1jtu31t0"
} : 0)(templateObject_5$b || (templateObject_5$b = (0,common._)(["\n  ", "\n  ", "\n  color: ", ";\n  font-weight: 700;\n  display: flex;\n  gap: ", ";\n  align-items: center;\n"], ["\n  ", "\n  ", "\n  color: ", ";\n  font-weight: 700;\n  display: flex;\n  gap: ", ";\n  align-items: center;\n"])), foundation.R, foundation.F.caption1, function (_a) {
  var theme = _a.theme;
  return theme.content.base1;
}, (0,foundation.p)(2));
var templateObject_1$m, templateObject_2$k, templateObject_3$i, templateObject_4$g, templateObject_5$b;

function Footer(_a) {
  var copyright = _a.copyright,
    serviceCenter = _a.serviceCenter,
    socialLinks = _a.socialLinks,
    companyLinks = _a.companyLinks,
    companyInfo = _a.companyInfo,
    responsibilityInfo = _a.responsibilityInfo,
    paymentGuarantee = _a.paymentGuarantee,
    certifications = _a.certifications,
    rest = (0,common.e)(_a, ["copyright", "serviceCenter", "socialLinks", "companyLinks", "companyInfo", "responsibilityInfo", "paymentGuarantee", "certifications"]);
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FooterComponenet, (0,common.a)({}, rest, {
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(StyledContainer, {
      children: [serviceCenter && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ServiceCenter, (0,common.a)({}, serviceCenter)), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Divider, {
        css: /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)(templateObject_1$l || (templateObject_1$l = (0,common._)(["\n          ", "\n        " + ( true ? "" : 0)], ["\n          ", "\n        " + ( true ? "" : 0)])), foundation.M.max('mobile', "\n            grid-column-start: 1;\n            grid-column-end: 2;\n            width: 100%;\n            height: ".concat((0,foundation.p)(1), ";\n          ")))
      }), companyLinks && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CompanyLinksContainer, {
        children: companyLinks.map(function (_a) {
          var text = _a.text,
            href = _a.href,
            target = _a.target,
            isBold = _a.isBold;
          return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CompanyLink, (0,common.a)({
            href: href,
            target: target || '_self',
            isBold: !!isBold
          }, {
            children: text
          }), text);
        })
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Divider, {
        css: /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)(templateObject_2$j || (templateObject_2$j = (0,common._)(["\n          ", "\n          ", "" + ( true ? "" : 0)], ["\n          ", "\n          ", "" + ( true ? "" : 0)])), foundation.M.max('tablet', "\n            grid-column-start: 1;\n            grid-column-end: 4;\n            width: 100%;\n            height: ".concat((0,foundation.p)(1), ";\n          ")), foundation.M.max('mobile', "\n            grid-column-start: 1;\n            grid-column-end: 2;\n          "))
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(InfoContainer, {
        children: [companyInfo && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", (0,common.a)({
          css: /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)(templateObject_3$h || (templateObject_3$h = (0,common._)(["overflow-x: hidden;" + ( true ? "" : 0)], ["overflow-x: hidden;" + ( true ? "" : 0)])))
        }, {
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CompanyInfo, {
            companyInfo: companyInfo
          })
        })), paymentGuarantee && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
          children: paymentGuarantee
        }), certifications && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CertificationContainer, {
          children: certifications.map(function (certification) {
            return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Certification, {
              certification: certification
            }, certification.id);
          })
        }), responsibilityInfo && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
          children: responsibilityInfo
        }), socialLinks && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
          children: socialLinks.map(function (socialLink) {
            return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SocialLink, (0,common.a)({}, socialLink), socialLink.href);
          })
        }), copyright && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("p", {
          children: copyright
        })]
      })]
    })
  }));
}
var FooterComponenet = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("footer",  true ? {
  target: "e1nsvcrd6"
} : 0)(templateObject_4$f || (templateObject_4$f = (0,common._)(["\n  padding: ", " 0;\n  background-color: ", ";\n  ", "\n  & a:hover {\n    text-decoration: underline;\n  }\n"], ["\n  padding: ", " 0;\n  background-color: ", ";\n  ", "\n  & a:hover {\n    text-decoration: underline;\n  }\n"])), (0,foundation.p)(40), function (_a) {
  var theme = _a.theme;
  return theme.content.base5;
}, foundation.M.max('mobile', "\n    padding: ".concat((0,foundation.p)(30), " 0;\n  ")));
var StyledContainer = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Container$4,  true ? {
  target: "e1nsvcrd5"
} : 0)(templateObject_5$a || (templateObject_5$a = (0,common._)(["\n  ", ";\n  display: grid;\n  grid-template-columns: ", " 1px ", " 1px 2fr;\n  grid-column-gap: ", ";\n\n  ", "\n\n  ", "\n"], ["\n  ", ";\n  display: grid;\n  grid-template-columns: ", " 1px ", " 1px 2fr;\n  grid-column-gap: ", ";\n\n  ", "\n\n  ", "\n"])), foundation.F.caption1, (0,foundation.p)(256), (0,foundation.p)(256), (0,foundation.p)(24), foundation.M.max('tablet', "\n    grid-template-columns: 1fr 1px 1fr;\n    grid-row-gap: ".concat((0,foundation.p)(24), ";\n  ")), foundation.M.max('mobile', "\n    padding: 0 ".concat((0,foundation.p)(16), ";\n    grid-template-columns: 1fr;\n    grid-row-gap: ").concat((0,foundation.p)(20), ";\n  ")));
var InfoContainer = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1nsvcrd4"
} : 0)(templateObject_6$9 || (templateObject_6$9 = (0,common._)(["\n  ", "\n  display: flex;\n  flex-direction: column;\n  gap: ", ";\n  color: ", ";\n  ", "\n  ", "\n"], ["\n  ", "\n  display: flex;\n  flex-direction: column;\n  gap: ", ";\n  color: ", ";\n  ", "\n  ", "\n"])), foundation.F.caption2, (0,foundation.p)(12), function (_a) {
  var theme = _a.theme;
  return theme.content.base2;
}, foundation.M.max('tablet', "\n    grid-column-start: 1;\n    grid-column-end: 4;\n  "), foundation.M.max('mobile', "\n    grid-column-start: 1;\n    grid-column-end: 2;\n  "));
var CompanyLinksContainer = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1nsvcrd3"
} : 0)(templateObject_7$8 || (templateObject_7$8 = (0,common._)(["\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  grid-template-rows: repeat(6, min-content);\n  grid-auto-flow: column;\n  grid-column-gap: ", ";\n  grid-row-gap: ", ";\n\n  ", "\n"], ["\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  grid-template-rows: repeat(6, min-content);\n  grid-auto-flow: column;\n  grid-column-gap: ", ";\n  grid-row-gap: ", ";\n\n  ", "\n"])), (0,foundation.p)(8), (0,foundation.p)(20), foundation.M.max('mobile', "\n    display: block;\n    grid-column-gap: ".concat((0,foundation.p)(10), ";\n  ")));
var CompanyLink = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("a",  true ? {
  target: "e1nsvcrd2"
} : 0)(templateObject_8$7 || (templateObject_8$7 = (0,common._)(["\n  ", "\n  display: inline-block;\n  color: ", ";\n  white-space: nowrap;\n  font-weight: ", ";\n  ", "\n"], ["\n  ", "\n  display: inline-block;\n  color: ", ";\n  white-space: nowrap;\n  font-weight: ", ";\n  ", "\n"])), foundation.F.caption1, function (_a) {
  var theme = _a.theme;
  return theme.content.base1;
}, function (_a) {
  var isBold = _a.isBold;
  return isBold && '700';
}, foundation.M.max('mobile', "\n    margin: ".concat((0,foundation.p)(8), " ").concat((0,foundation.p)(12), " ").concat((0,foundation.p)(8), " 0;\n  ")));
var CertificationContainer = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1nsvcrd1"
} : 0)(templateObject_9$7 || (templateObject_9$7 = (0,common._)(["\n  display: grid;\n  grid-column-gap: ", ";\n  grid-template-columns: max-content minmax(min-content, ", ") minmax(min-content, ", ");\n  ", "\n"], ["\n  display: grid;\n  grid-column-gap: ", ";\n  grid-template-columns: max-content minmax(min-content, ", ") minmax(min-content, ", ");\n  ", "\n"])), (0,foundation.p)(6), (0,foundation.p)(116), (0,foundation.p)(116), foundation.M.max('mobile', "\n    grid-template-columns: 1fr;\n  "));
var Divider = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1nsvcrd0"
} : 0)(templateObject_10$6 || (templateObject_10$6 = (0,common._)(["\n  width: ", ";\n  background-color: ", ";\n"], ["\n  width: ", ";\n  background-color: ", ";\n"])), (0,foundation.p)(1), function (_a) {
  var theme = _a.theme;
  return theme.divider;
});
var templateObject_1$l, templateObject_2$j, templateObject_3$h, templateObject_4$f, templateObject_5$a, templateObject_6$9, templateObject_7$8, templateObject_8$7, templateObject_9$7, templateObject_10$6;

var markIsmsSrc = "https://assets.ohou.se/design-system/8f5b2c2e98ea1196.png";

var markIso27001Src = "https://assets.ohou.se/design-system/d5fb816a58bb6a06.png";

var markPcrSrc = "https://assets.ohou.se/design-system/ad1cf869a6c58058.png";

var PHONE_NUMBER = '1670-0876';
var ADDRESS = '서울 서초구 서초대로74길 4 삼성생명서초타워 25층, 27층';
var COPYRIGHT_TEXT = 'Copyright 2014. bucketplace, Co., Ltd. All rights reserved.';
var BUCKETPLACE_HOMEPAGE_URL = 'https://www.bucketplace.com';
var OPENING_HOUR = {
  START: '09:00',
  END: '18:00'
};
var EMAIL = {
  CS: 'cs@bucketplace.net',
  CONTACT: 'contact@bucketplace.net'
};
/**
 * ohouse 서비스 도메인과 연결된 link schema를 create합니다.
 * @param ohs prod, stage 등 환경에 따른 `ohou.se` url
 * @param pro prod, stage 등 환경에 따른 `o2o-partner.ohou.se` url (pro.ohou.se deprecated)
 * @returns 서비스 도메인과 연결된 link schema
 */
function createOhouseFooterLinkSchema(_a) {
  var ohs = _a.ohs,
    pro = _a.pro;
  return {
    serviceCenter: "".concat(ohs, "/customer_center"),
    usepolicy: "".concat(ohs, "/usepolicy"),
    privacy: "".concat(ohs, "/privacy"),
    partnerPrivacy: "".concat(ohs, "/partner_privacy"),
    notice: "".concat(ohs, "/customer_notices"),
    inquiry: "".concat(ohs, "/contacts/new?type=request"),
    voiceOfCustomer: "".concat(ohs, "/contacts/new"),
    pro: "".concat(pro, "/intro?utm_source=ohouse&utm_medium=web&utm_campaign=prosignup&utm_content=footer")
  };
}
function OhouseFooter(props) {
  var ohouseFooterLinks = props.ohouseFooterLinks,
    restProps = (0,common.e)(props, ["ohouseFooterLinks"]);
  var theme = (0,emotion_element_5486c51c_browser_esm.u)();
  var isMobile = (0,hooks.m)().breakpoint === 'mobile';
  var paymentGuarantee = (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
      children: "\uACE0\uAC1D\uB2D8\uC774 \uD604\uAE08\uACB0\uC81C\uD55C \uAE08\uC561\uC5D0 \uB300\uD574 \uC6B0\uB9AC\uC740\uD589\uACFC \uCC44\uBB34\uC9C0\uAE09\uBCF4\uC99D \uACC4\uC57D\uC744 \uCCB4\uACB0\uD558\uC5EC \uC548\uC804\uAC70\uB798\uB97C \uBCF4\uC7A5\uD558\uACE0 \uC788\uC2B5\uB2C8\uB2E4."
    }), ' ', (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("a", (0,common.a)({
      target: "_blank",
      href: "https://ohouse.notion.site/da111ffbfc7c45a0a1327e23a7bd5dde",
      css: /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)(templateObject_1$k || (templateObject_1$k = (0,common._)(["\n            font-weight: 700;\n            color: ", ";\n          " + ( true ? "" : 0)], ["\n            font-weight: 700;\n            color: ", ";\n          " + ( true ? "" : 0)])), theme.content.base2),
      rel: "noreferrer"
    }, {
      children: "\uC11C\uBE44\uC2A4\uAC00\uC785\uC0AC\uC2E4\uD655\uC778"
    }))]
  });
  var iso27001 = {
    id: 'iso27001',
    imgSrc: markIso27001Src
  };
  var isms = {
    id: 'isms',
    imgSrc: markIsmsSrc,
    title: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
      children: "\uC624\uB298\uC758\uC9D1 \uC11C\uBE44\uC2A4 \uC6B4\uC601"
    }),
    date: '2024. 09. 08 ~ 2027. 09. 07'
  };
  var pcr = {
    id: 'pcr',
    imgSrc: markPcrSrc,
    imgLink: 'https://www.pipc.go.kr/np/cop/bbs/selectBoardArticle.do?bbsId=BS213&mCode=C040050000&nttId=8926'
  };
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Footer, (0,common.a)({}, restProps, {
    copyright: COPYRIGHT_TEXT,
    serviceCenter: {
      phone: PHONE_NUMBER,
      openingHour: {
        start: OPENING_HOUR.START,
        end: OPENING_HOUR.END
      },
      ohouseFooterLinks: ohouseFooterLinks
    },
    socialLinks: [{
      type: 'Youtube',
      href: 'https://www.youtube.com/channel/UCBKtitA1RwY7F32rCniV1dA'
    }, {
      type: 'Instagram',
      href: 'https://www.instagram.com/todayhouse'
    }, {
      type: 'Facebook',
      href: 'https://www.facebook.com/interiortoday'
    }, {
      type: 'KakaoStory',
      href: 'https://story.kakao.com/ch/bucketplace'
    }, {
      type: 'NaverPost',
      href: 'https://naver.me/51ckkDZh'
    }],
    companyLinks: [{
      text: '회사소개',
      href: BUCKETPLACE_HOMEPAGE_URL
    }, {
      text: '채용정보',
      href: "".concat(BUCKETPLACE_HOMEPAGE_URL, "/careers")
    }, {
      text: '이용약관',
      href: ohouseFooterLinks.usepolicy
    }, {
      text: '개인정보 처리방침',
      href: ohouseFooterLinks.privacy,
      isBold: true
    }, {
      text: '공지사항',
      href: ohouseFooterLinks.notice
    }, {
      text: '안전거래센터',
      href: 'https://safetybucketplace.zendesk.com/hc/ko',
      target: 'blank'
    }, {
      text: '입점신청',
      href: 'https://partnerbucketplace.zendesk.com/hc/ko/articles/19259629646361-오늘의집-입점안내'
    }, {
      text: '제휴/광고 문의',
      href: ohouseFooterLinks.inquiry
    }, {
      text: '시공파트너 안내',
      href: ohouseFooterLinks.pro
    }, {
      text: '파트너 개인정보 처리방침',
      href: ohouseFooterLinks.partnerPrivacy,
      isBold: true
    }, {
      text: '상품광고 소개',
      href: 'https://ohouse-ad.oopy.io'
    }, {
      text: '고객의 소리',
      href: ohouseFooterLinks.voiceOfCustomer
    }],
    companyInfo: {
      상호명: '(주)버킷플레이스',
      대표이사: '대표이사 이승재',
      주소: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("address", (0,common.a)({
        css: /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)(templateObject_2$i || (templateObject_2$i = (0,common._)(["\n              display: inline-block;\n              font-style: normal;\n            " + ( true ? "" : 0)], ["\n              display: inline-block;\n              font-style: normal;\n            " + ( true ? "" : 0)])))
      }, {
        children: ADDRESS
      })),
      이메일: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("a", (0,common.a)({
        href: "mailto:contact@bucketplace.net"
      }, {
        children: EMAIL.CONTACT
      })),
      사업자등록번호: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
          children: "\uC0AC\uC5C5\uC790\uB4F1\uB85D\uBC88\uD638 119-86-91245"
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("a", (0,common.a)({
          target: "_blank",
          href: "https://www.ftc.go.kr/bizCommPop.do?wrkr_no=1198691245",
          css: /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)(templateObject_3$g || (templateObject_3$g = (0,common._)(["\n                font-weight: 700;\n                color: ", ";\n              " + ( true ? "" : 0)], ["\n                font-weight: 700;\n                color: ", ";\n              " + ( true ? "" : 0)])), theme.content.base2),
          rel: "noreferrer"
        }, {
          children: [' ', "\uC0AC\uC5C5\uC790\uC815\uBCF4\uD655\uC778"]
        }))]
      }),
      통신판매업신고번호: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
        children: "\uD1B5\uC2E0\uD310\uB9E4\uC5C5\uC2E0\uACE0\uBC88\uD638 \uC81C2018-\uC11C\uC6B8\uC11C\uCD08-0580\uD638"
      })
    },
    responsibilityInfo: "(\uC8FC)\uBC84\uD0B7\uD50C\uB808\uC774\uC2A4\uB294 \uD1B5\uC2E0\uD310\uB9E4\uC911\uAC1C\uC790\uB85C \uAC70\uB798 \uB2F9\uC0AC\uC790\uAC00 \uC544\uB2C8\uBBC0\uB85C, \uD310\uB9E4\uC790\uAC00 \uB4F1\uB85D\uD55C \uC0C1\uD488\uC815\uBCF4 \uBC0F \uAC70\uB798 \uB4F1\uC5D0 \uB300\uD574 \uCC45\uC784\uC744 \uC9C0\uC9C0 \uC54A\uC2B5\uB2C8\uB2E4. \uB2E8, (\uC8FC)\uBC84\uD0B7\uD50C\uB808\uC774\uC2A4\uAC00 \uD310\uB9E4\uC790\uB85C \uB4F1\uB85D \uD310\uB9E4\uD55C \uC0C1\uD488\uC740 \uD310\uB9E4\uC790\uB85C\uC11C \uCC45\uC784\uC744 \uBD80\uB2F4\uD569\uB2C8\uB2E4.",
    paymentGuarantee: paymentGuarantee,
    certifications: !isMobile ? [isms, iso27001, pcr] : undefined
  }));
}
var templateObject_1$k, templateObject_2$i, templateObject_3$g;

function ListItem(_a) {
  var _b = _a.size,
    size = _b === void 0 ? 'basic' : _b,
    selected = _a.selected,
    disabled = _a.disabled,
    forwardedRef = _a.forwardedRef,
    children = _a.children,
    props = (0,common.e)(_a, ["size", "selected", "disabled", "forwardedRef", "children"]);
  var theme = (0,emotion_element_5486c51c_browser_esm.u)();
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", (0,common.a)({
    ref: forwardedRef,
    css: /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)(templateObject_1$j || (templateObject_1$j = (0,common._)(["\n        padding: ", " ", ";\n        color: ", ";\n        ", "\n        transition: background-color .2s ease-in-out;\n        ", "\n        &:hover, &:focus {\n          background-color: ", ";\n        }\n        ", "\n      " + ( true ? "" : 0)], ["\n        padding: ", " ", ";\n        color: ", ";\n        ", "\n        transition: background-color .2s ease-in-out;\n        ", "\n        &:hover, &:focus {\n          background-color: ", ";\n        }\n        ", "\n      " + ( true ? "" : 0)])), (0,foundation.p)({
      basic: 16,
      compact: 11
    }[size]), (0,foundation.p)(16), theme.content.base1, foundation.F.subTitle1, disabled && "\n          color: ".concat(theme.content.base3, ";\n        "), theme.content.base5, selected && "\n          background-color: ".concat(theme.content.base5, ";\n        "))
  }, props, {
    children: children
  }));
}
var templateObject_1$j;

function DividerListItem(_a) {
  var _b = _a.variant,
    variant = _b === void 0 ? 'thin' : _b,
    props = (0,common.e)(_a, ["variant"]);
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ListItem, (0,common.a)({}, props)), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Divider$1, {
      variant: variant
    })]
  });
}

var Dropdown = function Dropdown(_a) {
  var dropdownRef = _a.dropdownRef,
    title = _a.title,
    items = _a.items,
    _onClick = _a.onClick,
    onCloseDropdown = _a.onCloseDropdown,
    onClose = _a.onClose,
    _b = _a.selectedItemId,
    selectedItemId = _b === void 0 ? -1 : _b,
    _c = _a.isPopupInMobile,
    isPopupInMobile = _c === void 0 ? false : _c;
  var isMobile = (0,hooks.m)().breakpoint === 'mobile';
  var listItemRef = (0,react.useRef)(null);
  var listItemHeight = (0,lib_esm/* useNodeHeight */.XP)(listItemRef);
  // PC의 경우 최대 10.5개의 아이템 노출
  var maxDropdownHeight = (0,react.useMemo)(function () {
    return listItemHeight * 10.5;
  }, [listItemHeight]);
  var modalWidthProps = (0,react.useMemo)(function () {
    return isMobile && isPopupInMobile ? {
      width: 300,
      isPopupInMobile: true
    } : {
      width: 600
    };
  }, [isMobile, isPopupInMobile]);
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", (0,common.a)({
    ref: dropdownRef,
    onClick: function onClick(e) {
      return onCloseDropdown(e);
    }
  }, {
    children: isMobile ? (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Modal, (0,common.a)({}, modalWidthProps, {
      onBlur: onClose,
      header: {
        title: title,
        onClose: onClose
      }
    }, {
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ListItemWrapper, {
        children: items.map(function (item) {
          return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Item, (0,common.a)({
            size: "basic",
            onClick: function onClick() {
              return _onClick(item.id);
            },
            selected: item.id === selectedItemId
          }, {
            children: item.value
          }), item.id);
        })
      })
    })) : (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Container$2, (0,common.a)({
      maxDropdownHeight: maxDropdownHeight
    }, {
      children: items.map(function (item) {
        return (
          // TODO: disabled 기능 추가
          (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Item, (0,common.a)({
            size: "basic",
            onClick: function onClick() {
              return _onClick(item.id);
            },
            forwardedRef: listItemRef,
            selected: item.id === selectedItemId
          }, {
            children: item.value
          }), item.id)
        );
      })
    }))
  }));
};
var Container$2 = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1uoa6tb2"
} : 0)(templateObject_2$h || (templateObject_2$h = (0,common._)(["\n  border-radius: ", ";\n  max-height: ", ";\n  overflow-y: auto;\n  z-index: 1;\n  ", "\n"], ["\n  border-radius: ", ";\n  max-height: ", ";\n  overflow-y: auto;\n  z-index: 1;\n  ", "\n"])), (0,foundation.p)(4), function (_a) {
  var maxDropdownHeight = _a.maxDropdownHeight;
  return (0,foundation.p)(maxDropdownHeight);
}, function (_a) {
  var theme = _a.theme;
  return /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)(templateObject_1$i || (templateObject_1$i = (0,common._)(["\n    border: ", " solid ", ";\n    background-color: ", ";\n    box-shadow: ", ";\n  " + ( true ? "" : 0)], ["\n    border: ", " solid ", ";\n    background-color: ", ";\n    box-shadow: ", ";\n  " + ( true ? "" : 0)])), (0,foundation.p)(1), theme.content.base4, theme.background.elevated, theme.shadow.thin);
});
var ListItemWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1uoa6tb1"
} : 0)(templateObject_3$f || (templateObject_3$f = (0,common._)(["\n  overflow-y: auto;\n"], ["\n  overflow-y: auto;\n"])));
var Item = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(ListItem,  true ? {
  target: "e1uoa6tb0"
} : 0)(templateObject_4$e || (templateObject_4$e = (0,common._)(["\n  cursor: pointer;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  text-align: left; \n  &:active {\n    font-weight: 700;\n  };\n"], ["\n  cursor: pointer;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  text-align: left; \n  &:active {\n    font-weight: 700;\n  };\n"])));
var templateObject_1$i, templateObject_2$h, templateObject_3$f, templateObject_4$e;

var ICON_SIZE = 24;
function SimpleFooter(_a) {
  var companyLinks = _a.companyLinks,
    socialLinks = _a.socialLinks,
    localeSelection = _a.localeSelection;
  var dropdownRef = useRef(null);
  var _b = useState(false),
    isDropdownOpen = _b[0],
    setIsDropdownOpen = _b[1];
  var _c = useState(-1),
    selectedItemId = _c[0],
    setSelectedItemId = _c[1];
  var dropdownItems = React__default.useMemo(function () {
    return localeSelection ? localeSelection.locales.map(function (item, index) {
      return {
        id: index,
        value: item.text
      };
    }) : [];
  }, [localeSelection]);
  var currentLocaleText = React__default.useMemo(function () {
    var _a;
    return (_a = localeSelection === null || localeSelection === void 0 ? void 0 : localeSelection.locales[selectedItemId]) === null || _a === void 0 ? void 0 : _a.text;
  }, [localeSelection, selectedItemId]);
  var getLocaleByDropdownItemId = function getLocaleByDropdownItemId(id) {
    return localeSelection === null || localeSelection === void 0 ? void 0 : localeSelection.locales[id].locale;
  };
  var handleLocaleButtonClick = function handleLocaleButtonClick() {
    setIsDropdownOpen(!isDropdownOpen);
  };
  var handleCloseDropdown = function handleCloseDropdown() {
    setIsDropdownOpen(false);
  };
  var handleClick = function handleClick(id) {
    setIsDropdownOpen(false);
    if (selectedItemId === id) return;
    setSelectedItemId(id);
    var locale = getLocaleByDropdownItemId(id);
    if (locale) localeSelection === null || localeSelection === void 0 ? void 0 : localeSelection.onLocaleChange(locale);
  };
  useEffect(function () {
    if (localeSelection === null || localeSelection === void 0 ? void 0 : localeSelection.initialLocale) {
      setSelectedItemId(localeSelection.locales.findIndex(function (item) {
        return item.locale === localeSelection.initialLocale;
      }));
    }
  }, [localeSelection]);
  return jsxs(FooterContainer, {
    children: [jsxs(CompanyLinksAndLocaleContainer, {
      children: [localeSelection && jsx(LocaleContainer, {
        children: jsxs(LocaleButton, _assign({
          onClick: handleLocaleButtonClick
        }, {
          children: [currentLocaleText, jsx(ArrowIcon, {
            size: ICON_SIZE,
            name: "dropdown"
          }), isDropdownOpen && jsx(DropdownWrapper, {
            children: jsx(Dropdown, {
              title: "",
              dropdownRef: dropdownRef,
              items: dropdownItems,
              onCloseDropdown: handleCloseDropdown,
              onClose: function onClose() {
                return setIsDropdownOpen(false);
              },
              onClick: handleClick,
              selectedItemId: selectedItemId
            })
          })]
        }))
      }), companyLinks === null || companyLinks === void 0 ? void 0 : companyLinks.map(function (_a) {
        var text = _a.text,
          href = _a.href,
          target = _a.target,
          isBold = _a.isBold;
        return jsx(GlobalCompanyLink, _assign({
          href: href,
          target: target || '_self',
          isBold: !!isBold
        }, {
          children: text
        }), text);
      })]
    }), socialLinks && jsx(SocialLinkContainer, {
      children: socialLinks.map(function (socialLink) {
        return jsx(SocialLink, _assign({}, socialLink), socialLink.href);
      })
    })]
  });
}
var FooterContainer = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1blcm897"
} : 0)(templateObject_4$d || (templateObject_4$d = (0,common._)(["\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  background-color: ", ";\n  ", " \n  ", " \n  ", " \n"], ["\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  background-color: ", ";\n  ", " \n  ", " \n  ", " \n"])), function (_a) {
  var theme = _a.theme;
  return theme.background.groupedBase;
}, foundation.M.only('mobile', /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)(templateObject_1$h || (templateObject_1$h = (0,common._)(["\n    flex-direction: column;\n    align-items: flex-start;\n    padding: 28px 16px;\n  " + ( true ? "" : 0)], ["\n    flex-direction: column;\n    align-items: flex-start;\n    padding: 28px 16px;\n  " + ( true ? "" : 0)])))), foundation.M.only('tablet', /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)(templateObject_2$g || (templateObject_2$g = (0,common._)(["\n    flex-direction: row;\n    gap: ", ";\n    padding: 40px;\n  " + ( true ? "" : 0)], ["\n    flex-direction: row;\n    gap: ", ";\n    padding: 40px;\n  " + ( true ? "" : 0)])), (0,foundation.p)(10))), foundation.M.min('laptop', /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)(templateObject_3$e || (templateObject_3$e = (0,common._)(["\n    flex-direction: row;\n    gap: ", ";\n    padding: 40px 60px;\n  " + ( true ? "" : 0)], ["\n    flex-direction: row;\n    gap: ", ";\n    padding: 40px 60px;\n  " + ( true ? "" : 0)])), (0,foundation.p)(10))));
var SocialLinkContainer = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1blcm896"
} : 0)(templateObject_5$9 || (templateObject_5$9 = (0,common._)(["\n  display: flex;\n  flex-wrap: wrap;\n  margin-right: -12px;\n"], ["\n  display: flex;\n  flex-wrap: wrap;\n  margin-right: -12px;\n"])));
var CompanyLinksAndLocaleContainer = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1blcm895"
} : 0)(templateObject_7$7 || (templateObject_7$7 = (0,common._)(["\n  ", "\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  padding: 4px 0px;\n  color: ", ";\n  gap:  ", " ", ";\n  ", " \n"], ["\n  ", "\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  padding: 4px 0px;\n  color: ", ";\n  gap:  ", " ", ";\n  ", " \n"])), foundation.F.caption1, function (_a) {
  var theme = _a.theme;
  return theme.content.base1;
}, (0,foundation.p)(10), (0,foundation.p)(20), foundation.M.only('mobile', /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)(templateObject_6$8 || (templateObject_6$8 = (0,common._)(["\n    margin-bottom: 16px;\n  " + ( true ? "" : 0)], ["\n    margin-bottom: 16px;\n  " + ( true ? "" : 0)])))));
var LocaleContainer = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1blcm894"
} : 0)(templateObject_9$6 || (templateObject_9$6 = (0,common._)(["\n  ", "\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  color: ", ";\n  ", "\n"], ["\n  ", "\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  color: ", ";\n  ", "\n"])), foundation.F.caption1, function (_a) {
  var theme = _a.theme;
  return theme.content.base1;
}, foundation.M.min('tablet', /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)(templateObject_8$6 || (templateObject_8$6 = (0,common._)(["\n    gap: ", ";\n  " + ( true ? "" : 0)], ["\n    gap: ", ";\n  " + ( true ? "" : 0)])), (0,foundation.p)(20))));
var LocaleButton = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1blcm893"
} : 0)(templateObject_10$5 || (templateObject_10$5 = (0,common._)(["\n  display: flex;\n  position: relative;\n  align-items: center;\n  justify-content: space-between;\n  cursor: pointer;\n  &:hover {\n    background-color: ", ";\n  }\n"], ["\n  display: flex;\n  position: relative;\n  align-items: center;\n  justify-content: space-between;\n  cursor: pointer;\n  &:hover {\n    background-color: ", ";\n  }\n"])), function (_a) {
  var theme = _a.theme;
  return theme.interactive.transparent;
});
var ArrowIcon = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Icon,  true ? {
  target: "e1blcm892"
} : 0)(templateObject_11$3 || (templateObject_11$3 = (0,common._)(["\n  color: ", ";\n"], ["\n  color: ", ";\n"])), function (_a) {
  var theme = _a.theme;
  return theme.content.base2;
});
var DropdownWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1blcm891"
} : 0)(templateObject_12$1 || (templateObject_12$1 = (0,common._)(["\n  position: absolute;\n  bottom: calc(100%);\n  left: 0px;\n"], ["\n  position: absolute;\n  bottom: calc(100%);\n  left: 0px;\n"])));
var GlobalCompanyLink = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("a",  true ? {
  target: "e1blcm890"
} : 0)(templateObject_13$1 || (templateObject_13$1 = (0,common._)(["\n  ", "\n  display: inline-block;\n  color: ", ";\n  white-space: nowrap;\n  font-weight: ", ";\n"], ["\n  ", "\n  display: inline-block;\n  color: ", ";\n  white-space: nowrap;\n  font-weight: ", ";\n"])), foundation.F.caption1, function (_a) {
  var theme = _a.theme;
  return theme.content.base1;
}, function (_a) {
  var isBold = _a.isBold;
  return isBold && '700';
});
var templateObject_1$h, templateObject_2$g, templateObject_3$e, templateObject_4$d, templateObject_5$9, templateObject_6$8, templateObject_7$7, templateObject_8$6, templateObject_9$6, templateObject_10$5, templateObject_11$3, templateObject_12$1, templateObject_13$1;

/**
 * @deprecated ODS의 CautionBox 컴포넌트를 사용해 주세요.
 */
function Callout(_a) {
  var title = _a.title,
    _b = _a.type,
    type = _b === void 0 ? 'notice' : _b,
    icon = _a.icon,
    children = _a.children,
    rest = (0,common.e)(_a, ["title", "type", "icon", "children"]);
  var theme = (0,emotion_element_5486c51c_browser_esm.u)();
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", (0,common.a)({}, rest, {
    css: /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)(templateObject_1$g || (templateObject_1$g = (0,common._)(["\n        color: ", ";\n        padding: ", ";\n        border-radius: ", ";\n        background-color: ", ";\n      " + ( true ? "" : 0)], ["\n        color: ", ";\n        padding: ", ";\n        border-radius: ", ";\n        background-color: ", ";\n      " + ( true ? "" : 0)])), theme.content.base1, (0,foundation.p)(16), (0,foundation.p)(4), {
      notice: theme.content.base5,
      confirm: theme.content.base5,
      alert: theme.content.primary2.thin
    }[type])
  }, {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", (0,common.a)({
      css: foundation.F.subTitle1
    }, {
      children: [icon && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Icon, {
        size: 18,
        name: icon,
        css: /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)(templateObject_2$f || (templateObject_2$f = (0,common._)(["\n              vertical-align: middle;\n              margin-right: ", ";\n              color: ", ";\n            " + ( true ? "" : 0)], ["\n              vertical-align: middle;\n              margin-right: ", ";\n              color: ", ";\n            " + ( true ? "" : 0)])), (0,foundation.p)(6), {
          notice: theme.content.base1,
          confirm: theme.content.primary1.basic,
          alert: theme.content.primary2.thick
        }[type])
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", (0,common.a)({
        css: /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)(templateObject_3$d || (templateObject_3$d = (0,common._)(["\n            font-weight: 700;\n            vertical-align: middle;\n          " + ( true ? "" : 0)], ["\n            font-weight: 700;\n            vertical-align: middle;\n          " + ( true ? "" : 0)])))
      }, {
        children: title
      }))]
    })), children && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", (0,common.a)({
      css: [foundation.F.body1_1, /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)(templateObject_4$c || (templateObject_4$c = (0,common._)(["margin-top: ", ";" + ( true ? "" : 0)], ["margin-top: ", ";" + ( true ? "" : 0)])), (0,foundation.p)(12))]
    }, {
      children: children
    }))]
  }));
}
var templateObject_1$g, templateObject_2$f, templateObject_3$d, templateObject_4$c;

function cssSize$2(size) {
  return /*#__PURE__*/css(templateObject_4$b || (templateObject_4$b = __makeTemplateObject(["\n    ", "\n  " + ( true ? "" : 0)], ["\n    ", "\n  " + ( true ? "" : 0)])), {
    small: /*#__PURE__*/css(templateObject_1$f || (templateObject_1$f = __makeTemplateObject(["\n      padding: ", " ", ";\n      font-size: ", ";\n      height: ", ";\n      border-radius: ", ";\n    " + ( true ? "" : 0)], ["\n      padding: ", " ", ";\n      font-size: ", ";\n      height: ", ";\n      border-radius: ", ";\n    " + ( true ? "" : 0)])), pxToRem(4), pxToRem(8), pxToRem(12), pxToRem(24), pxToRem(12)),
    medium: /*#__PURE__*/css(templateObject_2$e || (templateObject_2$e = __makeTemplateObject(["\n      padding: ", " ", ";\n      font-size: ", ";\n      height: ", ";\n      border-radius: ", ";\n    " + ( true ? "" : 0)], ["\n      padding: ", " ", ";\n      font-size: ", ";\n      height: ", ";\n      border-radius: ", ";\n    " + ( true ? "" : 0)])), pxToRem(4), pxToRem(10), pxToRem(14), pxToRem(26), pxToRem(13)),
    large: /*#__PURE__*/css(templateObject_3$c || (templateObject_3$c = __makeTemplateObject(["\n      padding: ", " ", ";\n      font-size: ", ";\n      height: ", ";\n      border-radius: ", ";\n    " + ( true ? "" : 0)], ["\n      padding: ", " ", ";\n      font-size: ", ";\n      height: ", ";\n      border-radius: ", ";\n    " + ( true ? "" : 0)])), pxToRem(4), pxToRem(12), pxToRem(16), pxToRem(28), pxToRem(14))
  }[size]);
}
function cssDimmed(dimmed, theme) {
  return /*#__PURE__*/css(templateObject_7$6 || (templateObject_7$6 = __makeTemplateObject(["\n    ", "\n  " + ( true ? "" : 0)], ["\n    ", "\n  " + ( true ? "" : 0)])), {
    basic: /*#__PURE__*/css(templateObject_5$8 || (templateObject_5$8 = __makeTemplateObject(["\n      background-color: ", ";\n    " + ( true ? "" : 0)], ["\n      background-color: ", ";\n    " + ( true ? "" : 0)])), theme.dim.basic),
    thick: /*#__PURE__*/css(templateObject_6$7 || (templateObject_6$7 = __makeTemplateObject(["\n      background-color: ", ";\n    " + ( true ? "" : 0)], ["\n      background-color: ", ";\n    " + ( true ? "" : 0)])), theme.dim.thick)
  }[dimmed]);
}
function cssFontWeight(fontWeight) {
  return /*#__PURE__*/css(templateObject_10$4 || (templateObject_10$4 = __makeTemplateObject(["\n    ", "\n  " + ( true ? "" : 0)], ["\n    ", "\n  " + ( true ? "" : 0)])), {
    regular: /*#__PURE__*/css(templateObject_8$5 || (templateObject_8$5 = __makeTemplateObject(["\n      font-weight: 400;\n    " + ( true ? "" : 0)], ["\n      font-weight: 400;\n    " + ( true ? "" : 0)]))),
    bold: /*#__PURE__*/css(templateObject_9$5 || (templateObject_9$5 = __makeTemplateObject(["\n      font-weight: 700;\n    " + ( true ? "" : 0)], ["\n      font-weight: 700;\n    " + ( true ? "" : 0)])))
  }[fontWeight]);
}
function IndicatorNumber(_a) {
  var _b = _a.currentPage,
    currentPage = _b === void 0 ? 1 : _b,
    _c = _a.maxPage,
    maxPage = _c === void 0 ? 1 : _c,
    _d = _a.size,
    size = _d === void 0 ? 'small' : _d,
    _e = _a.dimmed,
    dimmed = _e === void 0 ? 'basic' : _e,
    _f = _a.fontWeight,
    fontWeight = _f === void 0 ? 'regular' : _f,
    children = _a.children,
    rest = __rest(_a, ["currentPage", "maxPage", "size", "dimmed", "fontWeight", "children"]);
  var theme = useTheme();
  return jsx("span", _assign({
    css: [cssSize$2(size), cssDimmed(dimmed, theme), cssFontWeight(fontWeight), /*#__PURE__*/css(templateObject_11$2 || (templateObject_11$2 = __makeTemplateObject(["\n          display: inline-flex;\n          align-items: center;\n          text-overflow: ellipsis;\n          white-space: nowrap;\n          word-wrap: normal;\n          line-height: 0;\n          overflow: hidden;\n          max-width: 100%;\n          color: ", ";\n          box-sizing: border-box;\n        " + ( true ? "" : 0)], ["\n          display: inline-flex;\n          align-items: center;\n          text-overflow: ellipsis;\n          white-space: nowrap;\n          word-wrap: normal;\n          line-height: 0;\n          overflow: hidden;\n          max-width: 100%;\n          color: ", ";\n          box-sizing: border-box;\n        " + ( true ? "" : 0)])), theme.content.white)]
  }, rest, {
    children: children || "".concat(currentPage, "/").concat(maxPage)
  }));
}
var templateObject_1$f, templateObject_2$e, templateObject_3$c, templateObject_4$b, templateObject_5$8, templateObject_6$7, templateObject_7$6, templateObject_8$5, templateObject_9$5, templateObject_10$4, templateObject_11$2;

function getGap(size) {
  return {
    small: 2,
    medium: 2,
    large: 4
  }[size];
}
function getIconSize(size) {
  return {
    small: 12,
    medium: 12,
    large: 18
  }[size];
}
function getIconName(fontWeight) {
  return {
    regular: 'add',
    bold: 'add_thick'
  }[fontWeight];
}
function cssSize$1(size) {
  return /*#__PURE__*/css(templateObject_4$a || (templateObject_4$a = __makeTemplateObject(["\n    ", "\n  " + ( true ? "" : 0)], ["\n    ", "\n  " + ( true ? "" : 0)])), {
    small: /*#__PURE__*/css(templateObject_1$e || (templateObject_1$e = __makeTemplateObject(["\n      padding: ", " ", " ", " ", ";\n    " + ( true ? "" : 0)], ["\n      padding: ", " ", " ", " ", ";\n    " + ( true ? "" : 0)])), pxToRem(4), pxToRem(6), pxToRem(4), pxToRem(8)),
    medium: /*#__PURE__*/css(templateObject_2$d || (templateObject_2$d = __makeTemplateObject(["\n      padding: ", " ", " ", " ", ";\n    " + ( true ? "" : 0)], ["\n      padding: ", " ", " ", " ", ";\n    " + ( true ? "" : 0)])), pxToRem(4), pxToRem(8), pxToRem(4), pxToRem(10)),
    large: /*#__PURE__*/css(templateObject_3$b || (templateObject_3$b = __makeTemplateObject(["\n      padding: ", " ", " ", " ", ";\n    " + ( true ? "" : 0)], ["\n      padding: ", " ", " ", " ", ";\n    " + ( true ? "" : 0)])), pxToRem(4), pxToRem(8), pxToRem(4), pxToRem(12))
  }[size]);
}
function cssIcon(size) {
  return /*#__PURE__*/css(templateObject_8$4 || (templateObject_8$4 = __makeTemplateObject(["\n  ", "\n  " + ( true ? "" : 0)], ["\n  ", "\n  " + ( true ? "" : 0)])), {
    small: /*#__PURE__*/css(templateObject_5$7 || (templateObject_5$7 = __makeTemplateObject(["\n      vertical-align: middle;\n    " + ( true ? "" : 0)], ["\n      vertical-align: middle;\n    " + ( true ? "" : 0)]))),
    medium: /*#__PURE__*/css(templateObject_6$6 || (templateObject_6$6 = __makeTemplateObject(["\n      vertical-align: middle;\n    " + ( true ? "" : 0)], ["\n      vertical-align: middle;\n    " + ( true ? "" : 0)]))),
    large: /*#__PURE__*/css(templateObject_7$5 || (templateObject_7$5 = __makeTemplateObject(["" + ( true ? "" : 0)], ["" + ( true ? "" : 0)])))
  }[size]);
}
function IndicatorNumberWithIcon(_a) {
  var currentPage = _a.currentPage,
    maxPage = _a.maxPage,
    _b = _a.size,
    size = _b === void 0 ? 'small' : _b,
    _c = _a.fontWeight,
    fontWeight = _c === void 0 ? 'regular' : _c,
    rest = __rest(_a, ["currentPage", "maxPage", "size", "fontWeight"]);
  return jsxs(IndicatorNumber, _assign({
    size: size,
    currentPage: currentPage,
    maxPage: maxPage,
    fontWeight: fontWeight,
    css: [cssSize$1(size), /*#__PURE__*/css(templateObject_9$4 || (templateObject_9$4 = __makeTemplateObject(["\n          cursor: pointer;\n        " + ( true ? "" : 0)], ["\n          cursor: pointer;\n        " + ( true ? "" : 0)])))]
  }, rest, {
    children: [jsxs("span", _assign({
      css: /*#__PURE__*/css(templateObject_10$3 || (templateObject_10$3 = __makeTemplateObject(["\n          vertical-align: middle;\n          margin-right: ", ";\n        " + ( true ? "" : 0)], ["\n          vertical-align: middle;\n          margin-right: ", ";\n        " + ( true ? "" : 0)])), pxToRem(getGap(size)))
    }, {
      children: [currentPage, "/", maxPage]
    })), jsx(Icon, {
      name: getIconName(fontWeight),
      size: getIconSize(size),
      css: cssIcon(size)
    })]
  }));
}
var templateObject_1$e, templateObject_2$d, templateObject_3$b, templateObject_4$a, templateObject_5$7, templateObject_6$6, templateObject_7$5, templateObject_8$4, templateObject_9$4, templateObject_10$3;

var visibleCount = 6;
function dotSize(index, maxPage, activeIndex) {
  var isLeftEnd = activeIndex < visibleCount / 2;
  var isRightEnd = activeIndex > maxPage - visibleCount / 2;
  var getVisibleCount = isLeftEnd || isRightEnd ? visibleCount : visibleCount + 1 ;
  var visibleStartIndex = function () {
    if (isLeftEnd) {
      return 0;
    } else if (isRightEnd) {
      return maxPage - getVisibleCount;
    } else {
      return activeIndex - Math.floor(getVisibleCount / 2);
    }
  }();
  var visibleLastIndex = visibleStartIndex + getVisibleCount - 1;
  var isCurrentDot = index === activeIndex;
  if (isCurrentDot) {
    return 8;
  }
  var isHiddenDot = index < visibleStartIndex || visibleLastIndex < index;
  if (isHiddenDot) {
    return 0;
  }
  var isMoreDot = isLeftEnd ? index === visibleLastIndex : isRightEnd ? index === visibleStartIndex : index === visibleStartIndex || index === visibleLastIndex;
  if (isMoreDot) {
    return 4;
  }
  return 6;
}
/**
 * ODS의 IndicatorDots 컴포넌트를 사용해 주세요.
 */
function IndicatorDots(_a) {
  var _b = _a.variant,
    variant = _b === void 0 ? 'basic' : _b,
    rest = __rest(_a, ["variant"]);
  var theme = useTheme();
  return makeIndicatorDots({
    dotSize: dotSize,
    dotBackgroundColor: variant === 'basic' ? theme.content.base3 : theme.dim.onDark.thick,
    activeDotBackgroundColor: variant === 'basic' ? theme.content.base1 : theme.content.white,
    boxShadow: variant === 'onDimmed' ? "".concat(pxToRem(0), " ").concat(pxToRem(1), " ").concat(pxToRem(6), " ").concat(theme.shadow.basic) : ''
  })(rest);
}

function MoreAnchor(_a) {
  var rest = __rest(_a, []);
  var theme = useTheme();
  return jsxs("a", _assign({
    css: [/*#__PURE__*/css(templateObject_1$d || (templateObject_1$d = __makeTemplateObject(["\n          color: ", ";\n          display: inline-block;\n          font-weight: 500;\n          padding: ", " ", ";\n          &:hover{\n            & > div:first-of-type {\n              background-color: ", ";\n            }\n          }\n        " + ( true ? "" : 0)], ["\n          color: ", ";\n          display: inline-block;\n          font-weight: 500;\n          padding: ", " ", ";\n          &:hover{\n            & > div:first-of-type {\n              background-color: ", ";\n            }\n          }\n        " + ( true ? "" : 0)])), theme.content.base1, pxToRem(6), pxToRem(16), theme.interactive.base4)]
  }, rest, {
    children: [jsx("div", _assign({
      css: /*#__PURE__*/css(templateObject_2$c || (templateObject_2$c = __makeTemplateObject(["\n        width: ", ";\n        height: ", ";\n        border-radius: ", ";\n        background-color: ", ";\n        margin-bottom: ", ";\n        position: relative;\n      " + ( true ? "" : 0)], ["\n        width: ", ";\n        height: ", ";\n        border-radius: ", ";\n        background-color: ", ";\n        margin-bottom: ", ";\n        position: relative;\n      " + ( true ? "" : 0)])), pxToRem(40), pxToRem(40), pxToRem(20), theme.content.base4, pxToRem(6))
    }, {
      children: jsx(Icon, {
        name: "arrow_right",
        size: 18,
        css: /*#__PURE__*/css(templateObject_3$a || (templateObject_3$a = __makeTemplateObject(["\n            position: absolute;\n            top: 50%;\n            left: 50%;\n            transform: translate(-50%, -50%);\n        " + ( true ? "" : 0)], ["\n            position: absolute;\n            top: 50%;\n            left: 50%;\n            transform: translate(-50%, -50%);\n        " + ( true ? "" : 0)])))
      })
    })), jsx("div", _assign({
      css: FONT_STYLE.body2
    }, {
      children: "\uB354\uBCF4\uAE30"
    }))]
  }));
}
var templateObject_1$d, templateObject_2$c, templateObject_3$a;

function cssSize(size) {
  return /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)(templateObject_3$9 || (templateObject_3$9 = (0,common._)(["\n  ", "\n  " + ( true ? "" : 0)], ["\n  ", "\n  " + ( true ? "" : 0)])), {
    72: /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)(templateObject_1$c || (templateObject_1$c = (0,common._)(["\n      border-radius: ", ";\n    "], ["\n      border-radius: ", ";\n    "])), (0,foundation.p)(24)),
    100: /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)(templateObject_2$b || (templateObject_2$b = (0,common._)(["\n      border-radius: ", ";\n    "], ["\n      border-radius: ", ";\n    "])), (0,foundation.p)(32))
  }[size]);
}
function cssLabel(size) {
  return /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)(templateObject_4$9 || (templateObject_4$9 = (0,common._)(["\n  ", "\n  " + ( true ? "" : 0)], ["\n  ", "\n  " + ( true ? "" : 0)])), {
    72: foundation.F.subTitle2,
    100: foundation.F.subTitle1
  }[size]);
}
function ThumbnailAnchor(_a) {
  var thumbnail = _a.thumbnail,
    size = _a.size,
    label = _a.label,
    _b = _a.hasHoverEffect,
    hasHoverEffect = _b === void 0 ? true : _b,
    _c = _a.hasBorder,
    hasBorder = _c === void 0 ? true : _c,
    active = _a.active,
    children = _a.children,
    rest = (0,common.e)(_a, ["thumbnail", "size", "label", "hasHoverEffect", "hasBorder", "active", "children"]);
  var theme = (0,emotion_element_5486c51c_browser_esm.u)();
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("a", (0,common.a)({
    css: [/*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)(templateObject_5$6 || (templateObject_5$6 = (0,common._)(["\n          display: flex;\n          flex-direction: column;\n          margin-top: ", ";\n          max-width: ", ";\n        " + ( true ? "" : 0)], ["\n          display: flex;\n          flex-direction: column;\n          margin-top: ", ";\n          max-width: ", ";\n        " + ( true ? "" : 0)])), (0,foundation.p)(12), (0,foundation.p)(size)), hasHoverEffect && (0,foundation.H)(templateObject_6$5 || (templateObject_6$5 = (0,common._)(["\n          & > div:first-of-type:after {\n            border: ", " solid ", ";\n          }\n          & > div:first-of-type > figure {\n            transition: transform ease-in-out 0.2s;\n            transform: scale(1.05);\n          }\n        "], ["\n          & > div:first-of-type:after {\n            border: ", " solid ", ";\n          }\n          & > div:first-of-type > figure {\n            transition: transform ease-in-out 0.2s;\n            transform: scale(1.05);\n          }\n        "])), (0,foundation.p)(2), theme.content.primary1.basic), active && /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)(templateObject_7$4 || (templateObject_7$4 = (0,common._)(["\n          & > div:first-of-type:after {\n            border: ", " solid ", ";\n          }\n        " + ( true ? "" : 0)], ["\n          & > div:first-of-type:after {\n            border: ", " solid ", ";\n          }\n        " + ( true ? "" : 0)])), (0,foundation.p)(2), theme.content.primary1.basic)]
  }, rest, {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", (0,common.a)({
      css: [/*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)(templateObject_8$3 || (templateObject_8$3 = (0,common._)(["\n            overflow: hidden;\n            position: relative;\n            box-sizing: border-box;\n            width: ", ";\n            height: ", ";\n            " + ( true ? "" : 0)], ["\n            overflow: hidden;\n            position: relative;\n            box-sizing: border-box;\n            width: ", ";\n            height: ", ";\n            " + ( true ? "" : 0)])), (0,foundation.p)(size), (0,foundation.p)(size)), hasBorder && /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)(templateObject_9$3 || (templateObject_9$3 = (0,common._)(["\n            &:after {\n              content: \"\";\n              position: absolute;\n              top: 0;\n              left: 0;\n              right: 0;\n              bottom: 0;\n              border-radius: inherit;\n              border: ", " solid ", ";\n            }\n            " + ( true ? "" : 0)], ["\n            &:after {\n              content: \"\";\n              position: absolute;\n              top: 0;\n              left: 0;\n              right: 0;\n              bottom: 0;\n              border-radius: inherit;\n              border: ", " solid ", ";\n            }\n            " + ( true ? "" : 0)])), (0,foundation.p)(1), theme.outline), cssSize(size)]
    }, {
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Image, {
        src: thumbnail,
        aspectRatio: "1:1",
        css: /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)(templateObject_10$2 || (templateObject_10$2 = (0,common._)(["\n            box-sizing: border-box;\n            border-radius: inherit;\n            width: ", ";\n            height: ", ";\n          " + ( true ? "" : 0)], ["\n            box-sizing: border-box;\n            border-radius: inherit;\n            width: ", ";\n            height: ", ";\n          " + ( true ? "" : 0)])), (0,foundation.p)(size), (0,foundation.p)(size))
      })
    })), label && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", (0,common.a)({
      css: [cssLabel(size), /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)(templateObject_11$1 || (templateObject_11$1 = (0,common._)(["\n            text-align: center;\n            margin-top: ", ";\n            color: ", ";\n            overflow: hidden;\n            word-break: break-all;\n            text-overflow: ellipsis;\n            display: -webkit-box;\n            -webkit-line-clamp: 2;\n            -webkit-box-orient: vertical;\n          " + ( true ? "" : 0)], ["\n            text-align: center;\n            margin-top: ", ";\n            color: ", ";\n            overflow: hidden;\n            word-break: break-all;\n            text-overflow: ellipsis;\n            display: -webkit-box;\n            -webkit-line-clamp: 2;\n            -webkit-box-orient: vertical;\n          " + ( true ? "" : 0)])), (0,foundation.p)(10), theme.content.base1)]
    }, {
      children: label
    })), children]
  }));
}
var templateObject_1$c, templateObject_2$b, templateObject_3$9, templateObject_4$9, templateObject_5$6, templateObject_6$5, templateObject_7$4, templateObject_8$3, templateObject_9$3, templateObject_10$2, templateObject_11$1;

function cssBadgePosition(badgePosition) {
  if (badgePosition === void 0) {
    badgePosition = 'right';
  }
  return /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)(templateObject_3$8 || (templateObject_3$8 = (0,common._)(["\n  ", "\n  " + ( true ? "" : 0)], ["\n  ", "\n  " + ( true ? "" : 0)])), {
    center: /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)(templateObject_1$b || (templateObject_1$b = (0,common._)(["\n      top: ", ";\n      left: 50%;\n      transform: translateX(-50%);\n      position: absolute;\n      display: flex;\n      min-width: fit-content;\n    " + ( true ? "" : 0)], ["\n      top: ", ";\n      left: 50%;\n      transform: translateX(-50%);\n      position: absolute;\n      display: flex;\n      min-width: fit-content;\n    " + ( true ? "" : 0)])), (0,foundation.p)(-12)),
    right: /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)(templateObject_2$a || (templateObject_2$a = (0,common._)(["\n      top: 0;\n      right: 0;\n      position: absolute;\n      display: flex;\n      min-width: fit-content;\n    " + ( true ? "" : 0)], ["\n      top: 0;\n      right: 0;\n      position: absolute;\n      display: flex;\n      min-width: fit-content;\n    " + ( true ? "" : 0)])))
  }[badgePosition]);
}
function withBadge(Component, cssBadgeVariant) {
  return function (_a) {
    var rest = (0,common.e)(_a, []);
    var badge = rest.badge,
      props = (0,common.e)(rest, ["badge"]);
    return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Component, (0,common.a)({}, props, {
      css: /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)(templateObject_4$8 || (templateObject_4$8 = (0,common._)(["position: relative;" + ( true ? "" : 0)], ["position: relative;" + ( true ? "" : 0)])))
    }, {
      children: [badge.component === 'SquareBadge' && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SquareBadge, (0,common.a)({
        size: 24
      }, badge, {
        css: [cssBadgePosition(badge.position), cssBadgeVariant(rest)]
      }, {
        children: badge.label
      })), badge.component === 'PillBadge' && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PillBadge, (0,common.a)({
        size: 24
      }, badge, {
        css: [cssBadgePosition(badge.position), cssBadgeVariant(rest)]
      }, {
        children: badge.label
      }))]
    }));
  };
}
var templateObject_1$b, templateObject_2$a, templateObject_3$8, templateObject_4$8;

function cssBadgeVariant(size, position) {
  if (position === void 0) {
    position = 'right';
  }
  return /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)(templateObject_5$5 || (templateObject_5$5 = (0,common._)(["\n  ", "" + ( true ? "" : 0)], ["\n  ", "" + ( true ? "" : 0)])), {
    center: /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)(templateObject_1$a || (templateObject_1$a = (0,common._)(["" + ( true ? "" : 0)], ["" + ( true ? "" : 0)]))),
    right: /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)(templateObject_4$7 || (templateObject_4$7 = (0,common._)(["\n  ", "" + ( true ? "" : 0)], ["\n  ", "" + ( true ? "" : 0)])), {
      72: /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)(templateObject_2$9 || (templateObject_2$9 = (0,common._)(["\n    top: ", ";\n    right: ", ";\n  "], ["\n    top: ", ";\n    right: ", ";\n  "])), (0,foundation.p)(-8), (0,foundation.p)(-8)),
      100: /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)(templateObject_3$7 || (templateObject_3$7 = (0,common._)(["\n    top: ", ";\n    right: ", ";\n  "], ["\n    top: ", ";\n    right: ", ";\n  "])), (0,foundation.p)(-6), (0,foundation.p)(-6))
    }[size])
  }[position]);
}
var ThumbnailAnchorWithBadge = withBadge(ThumbnailAnchor, function (_a) {
  var size = _a.size,
    badge = _a.badge;
  return cssBadgeVariant(size, badge.position);
});
var templateObject_1$a, templateObject_2$9, templateObject_3$7, templateObject_4$7, templateObject_5$5;

var DEFAULT_AUTO_PLAY_INTERVAL = 3000;

/**
 * 현재 캐러셀에서 가능한 currentOffset의 범위를 계산합니다.
 * @return [가능한 currentOffset의 최솟값, 가능한 currentOffset의 최댓값]
 */
var getCurrentOffsetBounds = function getCurrentOffsetBounds(_a) {
  var align = _a.align,
    _b = _a.itemRatio,
    itemRatio = _b === void 0 ? 1 : _b,
    _c = _a.edgeSpaceRatio,
    edgeSpaceRatio = _c === void 0 ? 0 : _c,
    childrenLength = _a.childrenLength;
  var visibleChildrenCount = 1 / itemRatio;
  switch (align) {
    case 'centerConstrained':
      {
        var left = (visibleChildrenCount - 1) / 2;
        return [left - edgeSpaceRatio, Math.max(0, childrenLength - visibleChildrenCount) + left + edgeSpaceRatio];
      }
    case 'left':
      return [0, Math.max(0, childrenLength - visibleChildrenCount)];
    case 'center':
      return [0, Math.max(0, childrenLength - 1)];
    default:
      return [0, 0];
  }
};

function useOffset(_a) {
  var loop = _a.loop,
    childrenLength = _a.childrenLength,
    align = _a.align,
    _b = _a.itemRatio,
    itemRatio = _b === void 0 ? 1 : _b,
    _c = _a.edgeSpaceRatio,
    edgeSpaceRatio = _c === void 0 ? 0 : _c;
  var _d = useMemo(function () {
      return getCurrentOffsetBounds({
        align: align,
        itemRatio: itemRatio,
        edgeSpaceRatio: edgeSpaceRatio,
        childrenLength: childrenLength
      });
    }, [align, edgeSpaceRatio, itemRatio, childrenLength]),
    minCurrentOffset = _d[0],
    maxCurrentOffset = _d[1];
  var getLimitOffset = useCallback(function (offset) {
    if (!loop) {
      return Math.min(maxCurrentOffset, Math.max(minCurrentOffset, offset));
    }
    return offset;
  }, [loop, minCurrentOffset, maxCurrentOffset]);
  var getLimitOffsetData = useCallback(function (prevOffset, newOffset) {
    var fromOffset = getLimitOffset(prevOffset);
    var toOffset = typeof newOffset === 'number' ? getLimitOffset(newOffset) : null;
    return {
      currentOffset: fromOffset,
      fromOffset: fromOffset,
      toOffset: toOffset
    };
  }, [getLimitOffset]);
  var getMinMaxOffset = function getMinMaxOffset(offsetData) {
    var currentOffset = offsetData.currentOffset,
      fromOffset = offsetData.fromOffset,
      toOffset = offsetData.toOffset;
    var offset = currentOffset;
    var newToOffset = toOffset;
    if (!loop) {
      offset = Math.min(maxCurrentOffset, Math.max(minCurrentOffset, offset));
      if (newToOffset !== null) {
        newToOffset = Math.min(maxCurrentOffset, Math.max(minCurrentOffset, newToOffset));
      }
    }
    var minOffset = offset;
    var maxOffset = offset;
    if (newToOffset !== null && fromOffset !== null) {
      minOffset = Math.min(offset, fromOffset, newToOffset);
      maxOffset = Math.max(offset, fromOffset, newToOffset);
    }
    return [minOffset, maxOffset];
  };
  var offsetMargin = useMemo(function () {
    if (['center', 'centerConstrained'].includes(align)) {
      return (1 - itemRatio) / (2 * itemRatio);
    }
    return 0;
  }, [align, itemRatio]);
  return {
    getLimitOffset: getLimitOffset,
    getLimitOffsetData: getLimitOffsetData,
    getMinMaxOffset: getMinMaxOffset,
    offsetMargin: offsetMargin
  };
}

function useInteract(_a) {
  var align = _a.align,
    _b = _a.itemRatio,
    itemRatio = _b === void 0 ? 1 : _b,
    _c = _a.edgeSpaceRatio,
    edgeSpaceRatio = _c === void 0 ? 0 : _c,
    loop = _a.loop,
    disableSwipe = _a.disableSwipe,
    childrenLength = _a.childrenLength,
    setOffsetData = _a.setOffsetData,
    onDrag = _a.onDrag,
    onEnd = _a.onEnd;
  var interactRef = useRef(null);
  var lastVelocityX = useRef(0);
  var baseProps = {
    align: align,
    loop: loop,
    itemRatio: itemRatio,
    edgeSpaceRatio: edgeSpaceRatio,
    childrenLength: childrenLength
  };
  var _d = getCurrentOffsetBounds(baseProps),
    minCurrentOffset = _d[0],
    maxCurrentOffset = _d[1];
  var getLimitOffsetData = useOffset(baseProps).getLimitOffsetData;
  var handlePan = useCallback(function (event) {
    onDrag === null || onDrag === void 0 ? void 0 : onDrag(event);
    setOffsetData(function (_a) {
      var _b, _c;
      var fromOffset = _a.fromOffset,
        currentOffset = _a.currentOffset;
      if (fromOffset === null) {
        return {
          currentOffset: currentOffset,
          fromOffset: fromOffset,
          toOffset: null
        };
      }
      var _d = ((_c = (_b = interactRef.current) === null || _b === void 0 ? void 0 : _b.getBoundingClientRect()) !== null && _c !== void 0 ? _c : {}).width,
        width = _d === void 0 ? 0 : _d;
      var dx = event.dx,
        velocityX = event.velocityX;
      var newOffset = fromOffset - dx / width / itemRatio;
      lastVelocityX.current = velocityX;
      return {
        currentOffset: newOffset,
        fromOffset: fromOffset,
        toOffset: null
      };
    });
  }, [itemRatio, onDrag, setOffsetData]);
  var handlePanEnd = useCallback(function (event) {
    onEnd === null || onEnd === void 0 ? void 0 : onEnd(event);
    setOffsetData(function (_a) {
      var fromOffset = _a.fromOffset,
        currentOffset = _a.currentOffset;
      if (fromOffset === null) {
        return {
          currentOffset: currentOffset,
          fromOffset: fromOffset,
          toOffset: null
        };
      }
      var velocity = event.velocity;
      var newOffset = Math.round(currentOffset);
      var direction = velocity.x < 0 ? 'right' : 'left';
      if (Math.abs(lastVelocityX.current) > 0.5 || Math.abs(event.velocityX) > 0.5) {
        newOffset = direction === 'left' ? Math.floor(currentOffset) : Math.ceil(currentOffset);
      }
      var offsetDelta;
      if (!loop) {
        if (currentOffset < minCurrentOffset) {
          offsetDelta = -Math.log(-currentOffset + minCurrentOffset + 1) / Math.log(8);
        } else if (currentOffset > maxCurrentOffset) {
          offsetDelta = Math.log(currentOffset - maxCurrentOffset + 1) / Math.log(8);
        }
      }
      lastVelocityX.current = 0;
      return getLimitOffsetData(currentOffset, newOffset, offsetDelta);
    });
  }, [getLimitOffsetData, loop, maxCurrentOffset, minCurrentOffset, onEnd, setOffsetData]);
  var handleInteract = useCallback(function (event) {
    var isScrolling = Math.abs(event.dy) > Math.abs(event.dx);
    if (isScrolling) {
      event.preventDefault();
      handlePanEnd(event);
      return;
    }
    switch (event.type) {
      case 'dragstart':
        setOffsetData(function (_a) {
          var currentOffset = _a.currentOffset;
          return getLimitOffsetData(currentOffset, null);
        });
        break;
      case 'dragmove':
        handlePan(event);
        break;
      case 'dragend':
        handlePanEnd(event);
        break;
    }
  }, [getLimitOffsetData, handlePan, handlePanEnd, setOffsetData]);
  useEffect(function () {
    if (disableSwipe) return;
    var node = interactRef.current;
    if (node) {
      interact(node).draggable({
        onstart: function onstart(event) {
          return handleInteract(event);
        },
        onmove: function onmove(event) {
          return handleInteract(event);
        },
        onend: function onend(event) {
          return handleInteract(event);
        },
        startAxis: 'x'
      });
    }
    return function () {
      if (node) {
        interact(node).unset();
      }
      lastVelocityX.current = 0;
    };
  }, [disableSwipe, handleInteract]);
  return {
    interactRef: interactRef
  };
}

function useAutoPlay(_a) {
  var autoPlay = _a.autoPlay,
    autoPlayInterval = _a.autoPlayInterval,
    move = _a.move;
  var autoPlayRef = useRef(null);
  var cleanupAutoPlay = useCallback(function () {
    if (autoPlayRef.current) {
      window.clearInterval(autoPlayRef.current);
      autoPlayRef.current = null;
    }
  }, []);
  var setupAutoPlay = useCallback(function () {
    if (!autoPlayRef.current) {
      autoPlayRef.current = window.setInterval(function () {
        return move('right');
      }, autoPlayInterval);
    }
  }, [autoPlayInterval, move]);
  useEffect(function () {
    if (autoPlay) {
      setupAutoPlay();
    }
    return function () {
      return cleanupAutoPlay();
    };
  }, [autoPlay, cleanupAutoPlay, setupAutoPlay]);
  return {
    cleanupAutoPlay: cleanupAutoPlay,
    setupAutoPlay: setupAutoPlay
  };
}

var Carousel = /*#__PURE__*/(/* unused pure expression or super */ null && (React__default.forwardRef(function (props, ref) {
  var _a = props.itemRatio,
    initialItemRatio = _a === void 0 ? 1 : _a,
    _b = props.edgeSpaceRatio,
    edgeSpaceRatio = _b === void 0 ? 0 : _b,
    _c = props.duration,
    initialDuration = _c === void 0 ? 350 : _c,
    _d = props.loop,
    loop = _d === void 0 ? false : _d,
    _e = props.autoPlay,
    autoPlay = _e === void 0 ? false : _e,
    _f = props.autoPlayInterval,
    autoPlayInterval = _f === void 0 ? DEFAULT_AUTO_PLAY_INTERVAL : _f,
    _g = props.align,
    align = _g === void 0 ? 'center' : _g,
    children = props.children,
    renderControl = props.renderControl,
    renderPagination = props.renderPagination,
    className = props.className,
    initialOffset = props.initialOffset,
    onOffsetChange = props.onOffsetChange,
    _h = props.disableSwipe,
    disableSwipe = _h === void 0 ? false : _h,
    renderEdgeDecoration = props.renderEdgeDecoration,
    nodeRef = props.nodeRef,
    length = props.length,
    _j = props.preloadCount,
    preloadCount = _j === void 0 ? 0 : _j,
    onRowsRendered = props.onRowsRendered;
  var _k = useState({
      // 현재 offset
      currentOffset: initialOffset !== null && initialOffset !== void 0 ? initialOffset : 0,
      // duration 시작 전 offset
      fromOffset: null,
      // duration 끝나고 최종적으로 변경될 offset
      toOffset: null
    }),
    offsetData = _k[0],
    setOffsetData = _k[1];
  var _l = useState(0),
    progressOffset = _l[0],
    setProgressOffset = _l[1];
  var _m = useState(initialDuration),
    duration = _m[0],
    setDuration = _m[1];
  var currentOffset = offsetData.currentOffset,
    fromOffset = offsetData.fromOffset,
    toOffset = offsetData.toOffset;
  var childrenList = React__default.Children.toArray(children);
  if (!loop && renderEdgeDecoration) {
    childrenList = __spreadArray(__spreadArray([renderEdgeDecoration(0)], childrenList, true), [renderEdgeDecoration(childrenList.length + 1)], false);
  }
  var childrenLength = length !== null && length !== void 0 ? length : childrenList.length;
  var itemRatio = initialItemRatio === 0 ? 1 : Math.min(initialItemRatio, 1);
  var visibleChildrenCount = 1 / itemRatio;
  var baseProps = {
    align: align,
    loop: loop,
    itemRatio: itemRatio,
    edgeSpaceRatio: edgeSpaceRatio,
    childrenLength: childrenLength
  };
  var _o = getCurrentOffsetBounds(baseProps),
    minCurrentOffset = _o[0],
    maxCurrentOffset = _o[1];
  var _p = useOffset(baseProps),
    getLimitOffset = _p.getLimitOffset,
    getLimitOffsetData = _p.getLimitOffsetData,
    getMinMaxOffset = _p.getMinMaxOffset,
    offsetMargin = _p.offsetMargin;
  var centerOffset = loop ? (Math.round(currentOffset) % childrenLength + childrenLength) % childrenLength : Math.round(currentOffset);
  var move = useCallback(function (direction, delta) {
    if (delta === void 0) {
      delta = 1;
    }
    setDuration(null);
    setOffsetData(function (_a) {
      var currentOffset = _a.currentOffset;
      var deltaOffset = Math.abs(delta) * (direction === 'right' ? 1 : -1);
      var newOffset = Math.round(currentOffset + deltaOffset);
      return getLimitOffsetData(currentOffset, newOffset);
    });
  }, [getLimitOffsetData]);
  var _q = useAutoPlay({
      autoPlay: autoPlay,
      autoPlayInterval: autoPlayInterval,
      move: move
    }),
    cleanupAutoPlay = _q.cleanupAutoPlay,
    setupAutoPlay = _q.setupAutoPlay;
  var isDragging = useRef(false);
  var handleDrag = useCallback(function () {
    isDragging.current = true;
    setDuration(null);
    if (autoPlay) {
      cleanupAutoPlay();
    }
  }, [autoPlay, cleanupAutoPlay]);
  var handleDragEnd = useCallback(function () {
    if (autoPlay) {
      setupAutoPlay();
    }
    setTimeout(function () {
      isDragging.current = false;
    });
  }, [autoPlay, setupAutoPlay]);
  var interactRef = useInteract(_assign(_assign({}, baseProps), {
    disableSwipe: disableSwipe,
    setOffsetData: setOffsetData,
    onDrag: handleDrag,
    onEnd: handleDragEnd
  })).interactRef;
  var _r = getMinMaxOffset(offsetData),
    minOffset = _r[0],
    maxOffset = _r[1];
  var baseOffset = minOffset - offsetMargin - preloadCount;
  var startIndex = Math.floor(baseOffset);
  var renderedItemCount = useMemo(function () {
    return Math.ceil(baseOffset + visibleChildrenCount + (maxOffset - minOffset) + 2 * preloadCount) - startIndex;
  }, [baseOffset, maxOffset, minOffset, startIndex, preloadCount, visibleChildrenCount]);
  var isOverflow = useCallback(function (offset) {
    return !loop && (offset < 0 || offset > childrenLength - 1);
  }, [childrenLength, loop]);
  var virtualChildren = useMemo(function () {
    if (onRowsRendered) {
      onRowsRendered(startIndex, startIndex + renderedItemCount - 1);
    }
    return Array.from({
      length: Math.ceil(renderedItemCount)
    }).map(function (_, renderedIndex) {
      /** 전체 캐러셀 아이템 중 기준 아이템(baseOffset이 0) 위치 기준으로 측정된 index
       * @example
       * 전체 캐러셀 아이템이 10개 이고, 화면에 노출 중인 아이템 2개, preload count가 2이라면
       * |--preload 아이템--|--preload 아이템--|--노출 중인 아이템--|--노출 중인 아이템--|--preload 아이템--|--preload 아이템--|
       *  actualIndex: -2   actualIndex: -1   actualIndex: 0   actualIndex: 1   actualIndex: 2   actualIndex: 3
       *  index: 8          index: 9         index: 0          index: 1          index: 2         index: 3
       */
      var actualIndex = startIndex + renderedIndex;
      /** 전체 캐러셀 아이템 리스트에서 몇 번째 인지 */
      var index = (startIndex % childrenLength + childrenLength + renderedIndex) % childrenLength;
      return jsx(CarouselListItem, _assign({
        css: /*#__PURE__*/css(templateObject_1$9 || (templateObject_1$9 = __makeTemplateObject(["width: ", "%;" + ( true ? "" : 0)], ["width: ", "%;" + ( true ? "" : 0)])), itemRatio * 100),
        role: "group",
        "aria-roledescription": "slide",
        "aria-label": "".concat(index, " of ").concat(childrenLength),
        onClickCapture: function onClickCapture(e) {
          if (isDragging.current) {
            e.preventDefault();
            e.stopPropagation();
          }
        }
      }, {
        children: !isOverflow(actualIndex) && childrenList[index]
      }), actualIndex);
    });
  }, [renderedItemCount, startIndex, childrenLength, childrenList, itemRatio, isOverflow, onRowsRendered]);
  var set = function set(targetOffset) {
    var deltaOffset = currentOffset - targetOffset;
    var direction = deltaOffset <= 0 ? 'right' : 'left';
    move(direction, deltaOffset);
  };
  var getProgress = useCallback(function () {
    var offset = loop ? currentOffset : Math.min(maxCurrentOffset, Math.max(minCurrentOffset, currentOffset));
    var baseOffset = minOffset - offsetMargin;
    var progressOffset = (baseOffset - startIndex + (offset - minOffset)) * itemRatio;
    return progressOffset;
  }, [itemRatio, currentOffset, loop, minOffset, minCurrentOffset, maxCurrentOffset, offsetMargin, startIndex]);
  var handleTransitionEnd = function handleTransitionEnd() {
    if (onOffsetChange) {
      onOffsetChange(currentOffset);
    }
    setOffsetData(function (_a) {
      var currentOffset = _a.currentOffset;
      return {
        currentOffset: currentOffset,
        fromOffset: null,
        toOffset: null
      };
    });
    setDuration(null);
  };
  useEffect(function () {
    if (loop) {
      return;
    }
    setOffsetData(function (_a) {
      var currentOffset = _a.currentOffset,
        toOffset = _a.toOffset;
      return getLimitOffsetData(currentOffset, toOffset);
    });
  }, [align, getLimitOffsetData, loop]);
  useEffect(function () {
    var animationId = requestAnimationFrame(function () {
      if (toOffset === null) {
        return;
      }
      setDuration(initialDuration);
      setOffsetData(function (_a) {
        var toOffset = _a.toOffset,
          currentOffset = _a.currentOffset;
        return {
          currentOffset: toOffset !== null && toOffset !== void 0 ? toOffset : currentOffset,
          fromOffset: fromOffset,
          toOffset: toOffset
        };
      });
    });
    return function () {
      return cancelAnimationFrame(animationId);
    };
  }, [toOffset, currentOffset, fromOffset, initialDuration]);
  useLayoutEffect(function () {
    var progress = getProgress();
    setProgressOffset(progress);
  }, [currentOffset, toOffset, getProgress]);
  useImperativeHandle(ref, function () {
    return {
      set: set
    };
  });
  var controlProps = {
    prev: function prev(countOfSlides) {
      return move('left', countOfSlides);
    },
    next: function next(countOfSlides) {
      return move('right', countOfSlides);
    },
    set: set,
    offset: getLimitOffset(centerOffset),
    length: childrenLength,
    isLeftEnd: !loop && getLimitOffset(fromOffset !== null && fromOffset !== void 0 ? fromOffset : currentOffset) === minCurrentOffset,
    isRightEnd: !loop && getLimitOffset(fromOffset !== null && fromOffset !== void 0 ? fromOffset : currentOffset) === maxCurrentOffset
  };
  var paginationProps = {
    currentPage: Math.floor(currentOffset) % childrenLength + 1,
    maxPage: childrenLength,
    onClick: function onClick(index) {
      return set(index);
    }
  };
  return jsxs(Container$1, _assign({
    role: "region",
    "aria-roledescription": "carousel",
    className: className,
    ref: function ref(node) {
      if (nodeRef) {
        nodeRef(node);
      }
    }
  }, {
    children: [jsx(CarouselListWrapper, _assign({
      ref: interactRef
    }, {
      children: jsx(CarouselList, _assign({
        style: {
          transform: "translateX(".concat(progressOffset * -100, "%)"),
          transition: "".concat(duration ? "transform ".concat(duration, "ms") : '')
        },
        onTransitionEnd: handleTransitionEnd,
        "aria-live": autoPlay ? 'off' : 'polite'
      }, {
        children: virtualChildren
      }))
    })), renderControl && renderControl(controlProps), renderPagination && jsx(Pagination, _assign({
      css: renderPagination(paginationProps).props.variant === 'onDimmed' ? {
        top: "".concat(pxToRem(-18))
      } : undefined
    }, {
      children: renderPagination(paginationProps)
    }))]
  }));
})));
var Container$1 = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "ec0uc7i4"
} : 0)(templateObject_2$8 || (templateObject_2$8 = (0,common._)(["\n  position: relative;\n"], ["\n  position: relative;\n"])));
var CarouselListWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "ec0uc7i3"
} : 0)(templateObject_3$6 || (templateObject_3$6 = (0,common._)(["\n  overflow: hidden;\n"], ["\n  overflow: hidden;\n"])));
var CarouselList = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("ul",  true ? {
  target: "ec0uc7i2"
} : 0)(templateObject_4$6 || (templateObject_4$6 = (0,common._)(["\n  display: flex;\n  flex-wrap: nowrap;\n  align-items: stretch;\n  min-height: 100%;\n  padding: 0;\n  margin: 0;\n"], ["\n  display: flex;\n  flex-wrap: nowrap;\n  align-items: stretch;\n  min-height: 100%;\n  padding: 0;\n  margin: 0;\n"])));
var CarouselListItem = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("li",  true ? {
  target: "ec0uc7i1"
} : 0)(templateObject_5$4 || (templateObject_5$4 = (0,common._)(["\n  flex: 0 0 auto;\n  -moz-user-select: -moz-none;\n  -webkit-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n  box-sizing: border-box;\n  padding: 0;\n  margin: 0;\n  * {\n    -webkit-user-drag: none;\n    -khtml-user-drag: none;\n    -moz-user-drag: none;\n    -o-user-drag: none;\n    user-drag: none;\n  }\n"], ["\n  flex: 0 0 auto;\n  -moz-user-select: -moz-none;\n  -webkit-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n  box-sizing: border-box;\n  padding: 0;\n  margin: 0;\n  * {\n    -webkit-user-drag: none;\n    -khtml-user-drag: none;\n    -moz-user-drag: none;\n    -o-user-drag: none;\n    user-drag: none;\n  }\n"])));
var Pagination = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "ec0uc7i0"
} : 0)(templateObject_6$4 || (templateObject_6$4 = (0,common._)(["\n  position: relative;\n  top: ", ";\n"], ["\n  position: relative;\n  top: ", ";\n"])), (0,foundation.p)(18));
var templateObject_1$9, templateObject_2$8, templateObject_3$6, templateObject_4$6, templateObject_5$4, templateObject_6$4;

/**
 * @deprecated ODS의 IconButton을 사용해주세요. 만약 디자인상 ODS의 IconButton을 사용할 수 없는 경우, 디자인시스템 담당 디자이너에게 문의해주세요.
 */
function IconButton(_a) {
  var _b;
  var size = _a.size,
    icon = _a.icon,
    rest = (0,common.e)(_a, ["size", "icon"]);
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Button$2, (0,common.a)({}, rest, {
    size: size,
    css: cssBaseIconButton(size)
  }, {
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Icon, {
      size: (_b = icon.size) !== null && _b !== void 0 ? _b : 18,
      name: icon.name,
      fill: icon === null || icon === void 0 ? void 0 : icon.fill
    })
  }));
}

function cssButton(theme, variant) {
  switch (variant) {
    case 'basic':
      return /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)(templateObject_1$8 || (templateObject_1$8 = (0,common._)(["\n        border-radius: ", ";\n        background-color: ", ";\n        box-shadow: 0 ", " ", " ", ";\n      " + ( true ? "" : 0)], ["\n        border-radius: ", ";\n        background-color: ", ";\n        box-shadow: 0 ", " ", " ", ";\n      " + ( true ? "" : 0)])), (0,foundation.p)(24), theme.content.base6, (0,foundation.p)(2), (0,foundation.p)(5), theme.shadow.basic);
    case 'onContents':
      return /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)(templateObject_2$7 || (templateObject_2$7 = (0,common._)(["\n        border-radius: ", ";\n        background-color: ", ";\n      " + ( true ? "" : 0)], ["\n        border-radius: ", ";\n        background-color: ", ";\n      " + ( true ? "" : 0)])), (0,foundation.p)(24), theme.dim.thin);
    case 'list':
      return /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)(templateObject_3$5 || (templateObject_3$5 = (0,common._)(["\n        background-color: ", ";\n        border: ", " solid ", ";\n        border-radius: 0;\n      " + ( true ? "" : 0)], ["\n        background-color: ", ";\n        border: ", " solid ", ";\n        border-radius: 0;\n      " + ( true ? "" : 0)])), theme.content.base6, (0,foundation.p)(1), theme.content.base4);
  }
}
function cssHoverButton(theme, variant) {
  switch (variant) {
    case 'basic':
      return (0,foundation.H)(templateObject_4$5 || (templateObject_4$5 = (0,common._)(["\n          background-color: ", ";\n      "], ["\n          background-color: ", ";\n      "])), theme.interactive.transparent);
    case 'onContents':
      return (0,foundation.H)(templateObject_5$3 || (templateObject_5$3 = (0,common._)(["\n        background-color: ", ";\n      "], ["\n        background-color: ", ";\n      "])), theme.dim.basic);
    case 'list':
      return (0,foundation.H)(templateObject_6$3 || (templateObject_6$3 = (0,common._)(["\n        background-color: ", ";\n      "], ["\n        background-color: ", ";\n      "])), theme.interactive.transparent);
  }
}
function cssFont(theme, variant) {
  switch (variant) {
    case 'basic':
      return theme.content.base1;
    case 'onContents':
      return theme.content.white;
    case 'list':
      return theme.content.base1;
  }
}
function CarouselControlButton(_a) {
  var iconName = _a.iconName,
    position = _a.position,
    _b = _a.hidden,
    hidden = _b === void 0 ? false : _b,
    _c = _a.variant,
    variant = _c === void 0 ? 'basic' : _c,
    className = _a.className,
    rest = (0,common.e)(_a, ["iconName", "position", "hidden", "variant", "className"]);
  var theme = (0,emotion_element_5486c51c_browser_esm.u)();
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", (0,common.a)({
    css: [/*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)(templateObject_7$3 || (templateObject_7$3 = (0,common._)(["\n          position: absolute;\n          top: 50%;\n          transform: translate(-50%, -50%);\n          left: ", "%;\n        " + ( true ? "" : 0)], ["\n          position: absolute;\n          top: 50%;\n          transform: translate(-50%, -50%);\n          left: ", "%;\n        " + ( true ? "" : 0)])), position === 'left' ? '0' : '100'), hidden && /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)(templateObject_8$2 || (templateObject_8$2 = (0,common._)(["display: none;" + ( true ? "" : 0)], ["display: none;" + ( true ? "" : 0)])))],
    className: className
  }, {
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(IconButton, (0,common.a)({
      type: "button",
      size: 50,
      variant: "primary1",
      icon: {
        name: iconName,
        size: 24,
        fill: function fill(theme) {
          return cssFont(theme, variant);
        }
      },
      css: [/*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)(templateObject_9$2 || (templateObject_9$2 = (0,common._)(["\n            width: ", ";\n            height: ", ";\n            display: flex;\n            align-items: center;\n            justify-content:center;\n          " + ( true ? "" : 0)], ["\n            width: ", ";\n            height: ", ";\n            display: flex;\n            align-items: center;\n            justify-content:center;\n          " + ( true ? "" : 0)])), (0,foundation.p)(48), (0,foundation.p)(48)), cssButton(theme, variant), cssHoverButton(theme, variant)]
    }, rest))
  }));
}
var templateObject_1$8, templateObject_2$7, templateObject_3$5, templateObject_4$5, templateObject_5$3, templateObject_6$3, templateObject_7$3, templateObject_8$2, templateObject_9$2;

function CarouselControl(_a) {
  var prev = _a.prev,
    next = _a.next,
    variant = _a.variant,
    _b = _a.isLeftEnd,
    isLeftEnd = _b === void 0 ? false : _b,
    _c = _a.isRightEnd,
    isRightEnd = _c === void 0 ? false : _c;
  return jsxs(Fragment$1, {
    children: [jsx(CarouselControlButton, {
      iconName: "chevron_left",
      position: "left",
      onClick: function onClick() {
        return prev();
      },
      "aria-label": "\uC774\uC804",
      variant: variant,
      hidden: isLeftEnd
    }), jsx(CarouselControlButton, {
      iconName: "chevron_right",
      position: "right",
      onClick: function onClick() {
        return next();
      },
      "aria-label": "\uB2E4\uC74C",
      variant: variant,
      hidden: isRightEnd
    })]
  });
}

var CarouselScrollControl = /*#__PURE__*/react.forwardRef(function (_a, ref) {
  var contentRef = _a.contentRef,
    children = _a.children,
    _b = _a.gradation,
    gradation = _b === void 0 ? true : _b,
    _c = _a.gap,
    gap = _c === void 0 ? 8 : _c,
    _d = _a.fixed,
    fixed = _d === void 0 ? false : _d,
    _e = _a.variant,
    variant = _e === void 0 ? 'basic' : _e,
    _f = _a.hiddenBreakpoints,
    hiddenBreakpoints = _f === void 0 ? ['mobile', 'tablet'] : _f,
    className = _a.className,
    contentClassName = _a.contentClassName,
    itemClassName = _a.itemClassName,
    buttonClassName = _a.buttonClassName,
    rest = (0,common.e)(_a, ["contentRef", "children", "gradation", "gap", "fixed", "variant", "hiddenBreakpoints", "className", "contentClassName", "itemClassName", "buttonClassName"]);
  var _g = (0,react.useState)({
      startIdx: 0,
      endIdx: 0
    }),
    fullVisibleItem = _g[0],
    setFullVisibleItem = _g[1];
  var _h = (0,react.useState)(false),
    hovered = _h[0],
    setHovered = _h[1];
  var animateRef = (0,react.useRef)(null);
  var carouselRef = (0,react.useRef)(null);
  var carouselItemRefs = (0,react.useRef)([]);
  var breakpoint = (0,hooks.m)().breakpoint;
  var matches = (0,hooks.g)('(pointer: coarse)').matches;
  var isHidden = matches || hiddenBreakpoints.some(function (hiddenBreakpoint) {
    return hiddenBreakpoint === breakpoint;
  });
  var theme = (0,emotion_element_5486c51c_browser_esm.u)();
  var childrenCount = react.Children.count(children);
  var updatePosition = (0,react.useCallback)(function () {
    var carousel = carouselRef.current;
    if (!carousel) return;
    var carouselRect = carousel.getBoundingClientRect();
    var carouselStartX = carouselRect.left;
    var carouselEndX = carouselStartX + carouselRect.width;
    var startItemIdx;
    var endItemIdx;
    for (var i = 0; i < childrenCount; i += 1) {
      var item = carouselItemRefs.current[i];
      var itemRect = (item === null || item === void 0 ? void 0 : item.getBoundingClientRect()) || {
        left: 0,
        width: 0
      };
      var itemStartX = itemRect.left;
      var itemEndX = itemStartX + itemRect.width;
      var isFullVisibleItem = item && Math.floor(carouselStartX) <= Math.floor(itemStartX) && Math.floor(itemEndX) <= Math.floor(carouselEndX);
      if (isFullVisibleItem) {
        if (startItemIdx === undefined) {
          startItemIdx = i;
        }
        endItemIdx = i;
      }
    }
    setFullVisibleItem({
      startIdx: startItemIdx !== null && startItemIdx !== void 0 ? startItemIdx : 0,
      endIdx: endItemIdx !== null && endItemIdx !== void 0 ? endItemIdx : 0
    });
  }, [setFullVisibleItem, childrenCount]);
  var scrollToOffset = (0,react.useCallback)(function (targetOffset) {
    if (animateRef.current) {
      cancelAnimationFrame(animateRef.current);
    }
    var startTime = Date.now();
    var carousel = carouselRef.current;
    if (!carousel) return;
    var currentCarouselStartX = carousel.scrollLeft;
    var lastCarouselStartX = carousel.scrollWidth - carousel.offsetWidth;
    var nextCarouselStartX = Math.max(0, Math.min(lastCarouselStartX, targetOffset));
    var handleScroll = function handleScroll() {
      var elapsed = Date.now() - startTime;
      var progress = Math.min(elapsed / 350, 1);
      var carousel = carouselRef.current;
      if (carousel) {
        carousel.scrollLeft = currentCarouselStartX + (nextCarouselStartX - currentCarouselStartX) * (0,eases.quadInOut)(progress);
      }
      if (progress < 1) {
        animateRef.current = requestAnimationFrame(handleScroll);
      }
    };
    animateRef.current = requestAnimationFrame(handleScroll);
  }, []);
  var moveRight = (0,react.useCallback)(function (basis) {
    var _a, _b;
    var startItemIdx = basis !== null && basis !== void 0 ? basis : fullVisibleItem.endIdx + 1;
    if (startItemIdx >= childrenCount) return;
    if (!carouselRef.current) return;
    var startItem = carouselItemRefs.current[startItemIdx];
    if (!startItem) return;
    var carouselWidth = carouselRef.current.offsetWidth;
    var endItemIdx = startItemIdx;
    var endItemOffsetRight = 0;
    while (endItemIdx < childrenCount) {
      var item = carouselItemRefs.current[endItemIdx];
      var itemOffsetRight = ((_a = item === null || item === void 0 ? void 0 : item.offsetLeft) !== null && _a !== void 0 ? _a : 0) + ((_b = item === null || item === void 0 ? void 0 : item.offsetWidth) !== null && _b !== void 0 ? _b : 0);
      var carouselOffsetRight = startItem.offsetLeft + carouselWidth;
      var isNotFullVisibleItem = !item || carouselOffsetRight < itemOffsetRight;
      if (isNotFullVisibleItem || !item) break;
      endItemOffsetRight = (item === null || item === void 0 ? void 0 : item.offsetLeft) + (item === null || item === void 0 ? void 0 : item.offsetWidth);
      endItemIdx += 1;
    }
    endItemIdx -= 1;
    var carouselOffsetLeft = (startItem.offsetLeft + endItemOffsetRight) / 2 - carouselWidth / 2;
    scrollToOffset(carouselOffsetLeft);
    setFullVisibleItem({
      startIdx: startItemIdx,
      endIdx: endItemIdx
    });
  }, [fullVisibleItem, childrenCount, scrollToOffset]);
  var moveLeft = (0,react.useCallback)(function (basis) {
    var endItemIdx = basis !== null && basis !== void 0 ? basis : fullVisibleItem.startIdx - 1;
    if (endItemIdx < 0) return;
    if (!carouselRef.current) return;
    var endItem = carouselItemRefs.current[endItemIdx];
    if (!endItem) return;
    var endItemOffsetRight = endItem.offsetLeft + endItem.offsetWidth;
    var carouselWidth = carouselRef.current.offsetWidth;
    var startItemIdx = endItemIdx;
    var startItemOffsetLeft = 0;
    while (startItemIdx >= 0) {
      var item = carouselItemRefs.current[startItemIdx];
      var carouselOffsetLeft_1 = endItemOffsetRight - carouselWidth;
      var isNotFullVisibleItem = !item || item.offsetLeft < carouselOffsetLeft_1;
      if (isNotFullVisibleItem || !item) break;
      startItemOffsetLeft = item.offsetLeft;
      startItemIdx -= 1;
    }
    startItemIdx += 1;
    var carouselOffsetLeft = (startItemOffsetLeft + endItemOffsetRight) / 2 - carouselWidth / 2;
    scrollToOffset(carouselOffsetLeft);
    setFullVisibleItem({
      startIdx: startItemIdx,
      endIdx: endItemIdx
    });
  }, [fullVisibleItem, scrollToOffset]);
  var scrollTo = (0,react.useCallback)(function (index) {
    if (index < fullVisibleItem.startIdx) {
      moveRight(index);
    } else if (index > fullVisibleItem.endIdx) {
      moveLeft(index);
    } else ;
  }, [fullVisibleItem, moveLeft, moveRight]);
  var getFullVisibleItem = (0,react.useCallback)(function () {
    return fullVisibleItem;
  }, [fullVisibleItem]);
  (0,react.useImperativeHandle)(ref, function () {
    return {
      getFullVisibleItem: getFullVisibleItem,
      scrollTo: scrollTo,
      moveLeft: moveLeft,
      moveRight: moveRight
    };
  });
  (0,react.useEffect)(function () {
    updatePosition();
    var resizeAnimationId = null;
    var handleResize = function handleResize() {
      if (resizeAnimationId) {
        cancelAnimationFrame(resizeAnimationId);
      }
      resizeAnimationId = requestAnimationFrame(function () {
        resizeAnimationId = null;
        updatePosition();
      });
    };
    var resizeObserver = null;
    var carousel = carouselRef.current;
    if (window.ResizeObserver && carousel) {
      resizeObserver = new ResizeObserver(handleResize);
      resizeObserver.observe(carousel);
    } else {
      window.addEventListener('resize', handleResize);
    }
    return function () {
      if (animateRef.current) {
        cancelAnimationFrame(animateRef.current);
      }
      if (resizeAnimationId) {
        cancelAnimationFrame(resizeAnimationId);
      }
      if (resizeObserver) {
        resizeObserver.disconnect();
      } else {
        window.removeEventListener('resize', handleResize);
      }
    };
  }, [updatePosition]);
  var isLeftEnd = fullVisibleItem.startIdx === 0;
  var isRightEnd = fullVisibleItem.endIdx === childrenCount - 1;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", (0,common.a)({
    css: /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)(templateObject_1$7 || (templateObject_1$7 = (0,common._)(["\n        position: relative;\n      " + ( true ? "" : 0)], ["\n        position: relative;\n      " + ( true ? "" : 0)]))),
    onMouseEnter: function onMouseEnter() {
      return setHovered(true);
    },
    onMouseLeave: function onMouseLeave() {
      return setHovered(false);
    },
    className: className
  }, rest, {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", (0,common.a)({
      css: /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)(templateObject_2$6 || (templateObject_2$6 = (0,common._)(["\n          position: relative;\n          z-index: 0;\n        " + ( true ? "" : 0)], ["\n          position: relative;\n          z-index: 0;\n        " + ( true ? "" : 0)])))
    }, {
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("ul", (0,common.a)({
        onScroll: updatePosition,
        className: contentClassName,
        ref: function ref(node) {
          carouselRef.current = node;
          if (contentRef) {
            contentRef(node);
          }
        },
        css: [/*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)(templateObject_3$4 || (templateObject_3$4 = (0,common._)(["\n              display: flex;\n              margin: 0;\n              padding: 0;\n              overflow: hidden;\n              & > li:last-of-type {\n                margin-right: 0;\n              }\n            " + ( true ? "" : 0)], ["\n              display: flex;\n              margin: 0;\n              padding: 0;\n              overflow: hidden;\n              & > li:last-of-type {\n                margin-right: 0;\n              }\n            " + ( true ? "" : 0)]))), isHidden && /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)(templateObject_4$4 || (templateObject_4$4 = (0,common._)(["\n              scroll-snap-type: x mandatory;\n              overflow: auto;\n              -ms-overflow-style: none;\n              scrollbar-width: none;\n              &::-webkit-scrollbar {\n                display: none;\n              }\n            " + ( true ? "" : 0)], ["\n              scroll-snap-type: x mandatory;\n              overflow: auto;\n              -ms-overflow-style: none;\n              scrollbar-width: none;\n              &::-webkit-scrollbar {\n                display: none;\n              }\n            " + ( true ? "" : 0)]))), !isRightEnd && gradation && /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)(templateObject_5$2 || (templateObject_5$2 = (0,common._)(["\n            &:after {\n              content:'';\n              position: absolute;\n              top: 0;\n              right: -1px;\n              width: 100px;\n              height: 100%;\n              background: ", ";\n              pointer-events: none;\n              padding: 0;\n              margin: 0;\n            }\n          " + ( true ? "" : 0)], ["\n            &:after {\n              content:'';\n              position: absolute;\n              top: 0;\n              right: -1px;\n              width: 100px;\n              height: 100%;\n              background: ", ";\n              pointer-events: none;\n              padding: 0;\n              margin: 0;\n            }\n          " + ( true ? "" : 0)])), "linear-gradient(90deg, ".concat((0,foundation.h)(theme.background.base, 0), " 0%, ").concat(theme.background.base, " 100%)"))]
      }, {
        children: react.Children.map(children, function (child, index) {
          return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("li", (0,common.a)({
            className: itemClassName,
            css: /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)(templateObject_7$2 || (templateObject_7$2 = (0,common._)(["\n                margin: 0 ", " 0 0;\n                padding: 0;\n                flex-shrink: 0;\n                scroll-snap-align: start;\n                ", "\n              " + ( true ? "" : 0)], ["\n                margin: 0 ", " 0 0;\n                padding: 0;\n                flex-shrink: 0;\n                scroll-snap-align: start;\n                ", "\n              " + ( true ? "" : 0)])), (0,foundation.p)(gap), foundation.M.min('tablet', /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)(templateObject_6$2 || (templateObject_6$2 = (0,common._)(["\n                  @media(hover: hover) {\n                    &:hover {\n                      z-index: 1;\n                    }\n                  }\n                " + ( true ? "" : 0)], ["\n                  @media(hover: hover) {\n                    &:hover {\n                      z-index: 1;\n                    }\n                  }\n                " + ( true ? "" : 0)]))))),
            ref: function ref(node) {
              carouselItemRefs.current[index] = node;
            }
          }, {
            children: child
          }), (0,common.k)(child) === 'object' && child != null && 'key' in child ? child.key : undefined);
        })
      }))
    })), (fixed || hovered) && (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CarouselControlButton, {
        iconName: "chevron_left",
        position: "left",
        onClick: function onClick() {
          return moveLeft();
        },
        "aria-label": "\uC774\uC804",
        hidden: isHidden || isLeftEnd,
        variant: variant,
        className: buttonClassName
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CarouselControlButton, {
        iconName: "chevron_right",
        position: "right",
        onClick: function onClick() {
          return moveRight();
        },
        "aria-label": "\uB2E4\uC74C",
        hidden: isHidden || isRightEnd,
        variant: variant,
        className: buttonClassName
      })]
    })]
  }));
});
var templateObject_1$7, templateObject_2$6, templateObject_3$4, templateObject_4$4, templateObject_5$2, templateObject_6$2, templateObject_7$2;

function Ranking(_a) {
  var number = _a.number,
    variant = _a.variant,
    props = __rest(_a, ["number", "variant"]);
  var theme = useTheme();
  return jsxs("div", _assign({}, props, {
    css: /*#__PURE__*/css(templateObject_1$6 || (templateObject_1$6 = __makeTemplateObject(["\n        position: relative;\n        display: inline-block;\n        font-size: 0;\n        line-height: 1;\n      " + ( true ? "" : 0)], ["\n        position: relative;\n        display: inline-block;\n        font-size: 0;\n        line-height: 1;\n      " + ( true ? "" : 0)])))
  }, {
    children: [jsx("svg", _assign({
      width: 26,
      height: 30,
      fill: "none"
    }, {
      children: jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "m13 24.25-13 5V0h26v29.25l-13-5Z",
        fill: function () {
          switch (variant) {
            case 'primary1':
              return hexToRgba(theme.content.primary1.basic, 0.86);
            case 'dim':
              return theme.dim.basic;
            default:
              return;
          }
        }()
      })
    })), jsx("span", _assign({
      css: /*#__PURE__*/css(templateObject_2$5 || (templateObject_2$5 = __makeTemplateObject(["\n          position: absolute;\n          top: ", ";\n          left: 0;\n          right: 0;\n          ", ";\n          font-weight: 700;\n          color: ", ";\n          text-align: center;\n        " + ( true ? "" : 0)], ["\n          position: absolute;\n          top: ", ";\n          left: 0;\n          right: 0;\n          ", ";\n          font-weight: 700;\n          color: ", ";\n          text-align: center;\n        " + ( true ? "" : 0)])), pxToRem(4), FONT_STYLE.body3, theme.content.white)
    }, {
      children: number
    }))]
  }));
}
var templateObject_1$6, templateObject_2$5;

function SectionTitle(_a) {
  var className = _a.className,
    size = _a.size,
    title = _a.title,
    caption = _a.caption,
    badge = _a.badge,
    count = _a.count,
    moreButton = _a.moreButton,
    customButton = _a.customButton,
    hasArrow = _a.hasArrow,
    _onClick = _a.onClick;
  var theme = useTheme();
  var isMobile = useResponsive().breakpoint === 'mobile';
  var handleClickChild = function handleClickChild(e) {
    if (!_onClick) return;
    e.stopPropagation();
    _onClick(e);
  };
  return jsxs("div", _assign({
    className: className,
    onClick: function onClick() {
      if (!isMobile) return;
      _onClick === null || _onClick === void 0 ? void 0 : _onClick();
    },
    css: [/*#__PURE__*/css(templateObject_1$5 || (templateObject_1$5 = __makeTemplateObject(["\n          display: flex;\n          align-items: center;\n          justify-content: space-between;\n          width: 100%;\n          padding: ", " 0;\n          font-size: 0;\n          line-height: 1;\n        " + ( true ? "" : 0)], ["\n          display: flex;\n          align-items: center;\n          justify-content: space-between;\n          width: 100%;\n          padding: ", " 0;\n          font-size: 0;\n          line-height: 1;\n        " + ( true ? "" : 0)])), pxToRem(20))]
  }, {
    children: [!!badge && jsx(CircleBadge, _assign({
      type: "fill",
      variant: "primary2",
      size: 24,
      css: /*#__PURE__*/css(templateObject_2$4 || (templateObject_2$4 = __makeTemplateObject(["\n            margin-right: ", ";\n          " + ( true ? "" : 0)], ["\n            margin-right: ", ";\n          " + ( true ? "" : 0)])), pxToRem(8))
    }, {
      children: badge
    })), jsxs("div", _assign({
      css: /*#__PURE__*/css(templateObject_3$3 || (templateObject_3$3 = __makeTemplateObject(["\n          flex: 1;\n          display: flex;\n          align-items: flex-start;\n          flex-direction: column;\n          min-width: 0;\n        " + ( true ? "" : 0)], ["\n          flex: 1;\n          display: flex;\n          align-items: flex-start;\n          flex-direction: column;\n          min-width: 0;\n        " + ( true ? "" : 0)])))
    }, {
      children: [jsxs("div", _assign({
        onClick: handleClickChild,
        css: [/*#__PURE__*/css(templateObject_4$3 || (templateObject_4$3 = __makeTemplateObject(["\n              display: inline-flex;\n              align-items: center;\n              max-width: 100%;\n            " + ( true ? "" : 0)], ["\n              display: inline-flex;\n              align-items: center;\n              max-width: 100%;\n            " + ( true ? "" : 0)]))), _onClick && cssClickable]
      }, {
        children: [jsx("strong", _assign({
          css: [/*#__PURE__*/css(templateObject_5$1 || (templateObject_5$1 = __makeTemplateObject(["\n                overflow: hidden;\n                display: inline-block;\n                font-weight: 700;\n                color: ", ";\n                letter-spacing: ", ";\n                white-space: nowrap;\n                text-overflow: ellipsis;\n              " + ( true ? "" : 0)], ["\n                overflow: hidden;\n                display: inline-block;\n                font-weight: 700;\n                color: ", ";\n                letter-spacing: ", ";\n                white-space: nowrap;\n                text-overflow: ellipsis;\n              " + ( true ? "" : 0)])), theme.content.base1, pxToRem(-0.3)), cssFontSize(size)]
        }, {
          children: title
        })), !!count && jsx("span", _assign({
          css: [/*#__PURE__*/css(templateObject_6$1 || (templateObject_6$1 = __makeTemplateObject(["\n                  display: inline-block;\n                  margin-left: ", ";\n                  ", ";\n                  ", ";\n                  font-weight: 700;\n                  color: ", ";\n                  letter-spacing: ", ";\n                " + ( true ? "" : 0)], ["\n                  display: inline-block;\n                  margin-left: ", ";\n                  ", ";\n                  ", ";\n                  font-weight: 700;\n                  color: ", ";\n                  letter-spacing: ", ";\n                " + ( true ? "" : 0)])), pxToRem(6), size === 'large' && FONT_STYLE.title2, size === 'small' && FONT_STYLE.title3, theme.content.primary1.basic, pxToRem(-0.3)), cssFontSize(size)]
        }, {
          children: count
        }))]
      })), caption && jsxs("div", _assign({
        onClick: function onClick(e) {
          if (!caption.onClick) return;
          e.stopPropagation();
          caption.onClick(e);
        },
        css: [/*#__PURE__*/css(templateObject_7$1 || (templateObject_7$1 = __makeTemplateObject(["\n                display: inline-flex;\n                align-items: center;\n                max-width: 100%;\n                margin-top: ", ";\n              " + ( true ? "" : 0)], ["\n                display: inline-flex;\n                align-items: center;\n                max-width: 100%;\n                margin-top: ", ";\n              " + ( true ? "" : 0)])), pxToRem(4)), caption.onClick && cssClickable]
      }, {
        children: [jsx("span", _assign({
          css: /*#__PURE__*/css(templateObject_8$1 || (templateObject_8$1 = __makeTemplateObject(["\n                overflow: hidden;\n                display: inline-block;\n                ", ";\n                font-weight: 400;\n                color: ", ";\n                letter-spacing: ", ";\n                white-space: nowrap;\n                text-overflow: ellipsis;\n              " + ( true ? "" : 0)], ["\n                overflow: hidden;\n                display: inline-block;\n                ", ";\n                font-weight: 400;\n                color: ", ";\n                letter-spacing: ", ";\n                white-space: nowrap;\n                text-overflow: ellipsis;\n              " + ( true ? "" : 0)])), FONT_STYLE.subTitle2, theme.content.base1, pxToRem(-0.3))
        }, {
          children: caption.text
        })), caption.icon && jsx(Icon, {
          name: caption.icon,
          size: 18,
          css: /*#__PURE__*/css(templateObject_9$1 || (templateObject_9$1 = __makeTemplateObject(["\n                  margin-left: ", ";\n                  color: ", ";\n                " + ( true ? "" : 0)], ["\n                  margin-left: ", ";\n                  color: ", ";\n                " + ( true ? "" : 0)])), pxToRem(2), theme.content.base1)
        })]
      }))]
    })), jsxs("div", _assign({
      css: /*#__PURE__*/css(templateObject_10$1 || (templateObject_10$1 = __makeTemplateObject(["\n          display: flex;\n          align-items: center;\n          height: 0;\n          margin-left: ", ";\n          &:empty {\n            margin-left: 0;\n          }\n        " + ( true ? "" : 0)], ["\n          display: flex;\n          align-items: center;\n          height: 0;\n          margin-left: ", ";\n          &:empty {\n            margin-left: 0;\n          }\n        " + ( true ? "" : 0)])), pxToRem(10))
    }, {
      children: [moreButton && jsx("button", _assign({
        type: "button",
        onClick: handleClickChild,
        css: [/*#__PURE__*/css(templateObject_11 || (templateObject_11 = __makeTemplateObject(["\n                ", "\n                ", "\n                font-weight: 700;\n                color: ", ";\n              " + ( true ? "" : 0)], ["\n                ", "\n                ", "\n                font-weight: 700;\n                color: ", ";\n              " + ( true ? "" : 0)])), RESET_BUTTON, FONT_STYLE.subTitle1, theme.content.primary1.basic), cssClickable]
      }, {
        children: _typeof(moreButton) === 'object' && moreButton.text || '더보기'
      })), customButton && function () {
        var component = customButton.component,
          props = __rest(customButton, ["component"]);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        var CustomButton = component;
        return jsx(CustomButton, _assign({}, props, {
          size: 32,
          onClick: handleClickChild
        }));
      }(), hasArrow && jsx(Icon, {
        size: 24,
        name: "chevron_thick_right",
        fill: function fill(theme) {
          return theme.content.base1;
        },
        onClick: handleClickChild,
        css: /*#__PURE__*/css(templateObject_12 || (templateObject_12 = __makeTemplateObject(["\n              cursor: pointer;\n            " + ( true ? "" : 0)], ["\n              cursor: pointer;\n            " + ( true ? "" : 0)])))
      })]
    }))]
  }));
}
var cssFontSize = function cssFontSize(size) {
  switch (size) {
    case 'large':
      return FONT_STYLE.title2;
    case 'small':
      return FONT_STYLE.title3;
    default:
      return;
  }
};
var cssClickable = /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)(templateObject_13 || (templateObject_13 = (0,common._)(["\n  cursor: pointer;\n  @media(hover: hover) {\n    &:hover {\n      opacity: .5;\n    }\n  }\n" + ( true ? "" : 0)], ["\n  cursor: pointer;\n  @media(hover: hover) {\n    &:hover {\n      opacity: .5;\n    }\n  }\n" + ( true ? "" : 0)])));
var templateObject_1$5, templateObject_2$4, templateObject_3$3, templateObject_4$3, templateObject_5$1, templateObject_6$1, templateObject_7$1, templateObject_8$1, templateObject_9$1, templateObject_10$1, templateObject_11, templateObject_12, templateObject_13;

function ImageUploadButtonImpl(_a, ref) {
  var multiple = _a.multiple,
    _b = _a.type,
    type = _b === void 0 ? 'button' : _b,
    _c = _a.accept,
    accept = _c === void 0 ? 'image/*' : _c,
    onFileSelected = _a.onFileSelected,
    onButtonClick = _a.onClick,
    buttonProps = __rest(_a, ["multiple", "type", "accept", "onFileSelected", "onClick"]);
  var inputRef = useRef(null);
  var theme = useTheme();
  var handleClickButton = function handleClickButton(ev) {
    var _a;
    (_a = inputRef.current) === null || _a === void 0 ? void 0 : _a.click();
    onButtonClick === null || onButtonClick === void 0 ? void 0 : onButtonClick(ev);
  };
  return jsxs("button", _assign({
    ref: ref,
    onClick: handleClickButton,
    css: /*#__PURE__*/css(templateObject_2$3 || (templateObject_2$3 = __makeTemplateObject(["\n        ", ";\n        ", ";\n        width: ", ";\n        height: ", ";\n        font-weight: 700;\n        text-align: center;\n        border-radius: ", ";\n        color: ", ";\n        border: ", " solid ", ";\n        cursor: pointer;\n        ", ";\n        &:disabled {\n          color: ", ";\n          pointer-events: none;\n          background-color: ", ";\n          border: none;\n        }\n      " + ( true ? "" : 0)], ["\n        ", ";\n        ", ";\n        width: ", ";\n        height: ", ";\n        font-weight: 700;\n        text-align: center;\n        border-radius: ", ";\n        color: ", ";\n        border: ", " solid ", ";\n        cursor: pointer;\n        ", ";\n        &:disabled {\n          color: ", ";\n          pointer-events: none;\n          background-color: ", ";\n          border: none;\n        }\n      " + ( true ? "" : 0)])), RESET_BUTTON, FONT_STYLE.body3, pxToRem(72), pxToRem(72), pxToRem(4), theme.content.base1, pxToRem(1), theme.border, HOVER(templateObject_1$4 || (templateObject_1$4 = __makeTemplateObject(["\n          background-color: ", ";\n        "], ["\n          background-color: ", ";\n        "])), theme.interactive.transparent), theme.content.base3, theme.content.base4),
    type: type
  }, buttonProps, {
    children: [jsx("input", {
      hidden: true,
      ref: inputRef,
      type: "file",
      multiple: multiple,
      accept: accept,
      onChange: onFileSelected
    }), jsx(Icon, {
      size: 24,
      css: /*#__PURE__*/css(templateObject_3$2 || (templateObject_3$2 = __makeTemplateObject(["  \n          margin-bottom: ", ";\n        " + ( true ? "" : 0)], ["  \n          margin-bottom: ", ";\n        " + ( true ? "" : 0)])), pxToRem(6.5)),
      name: "camera"
    }), jsx("span", _assign({
      css: /*#__PURE__*/css(templateObject_4$2 || (templateObject_4$2 = __makeTemplateObject(["display: block;" + ( true ? "" : 0)], ["display: block;" + ( true ? "" : 0)])))
    }, {
      children: "\uC0AC\uC9C4 \uC62C\uB9AC\uAE30"
    }))]
  }));
}
var ImageUploadButton = /*#__PURE__*/(/* unused pure expression or super */ null && (memo( /*#__PURE__*/forwardRef(ImageUploadButtonImpl))));
var templateObject_1$4, templateObject_2$3, templateObject_3$2, templateObject_4$2;

function ImageAttachedItem(_a) {
  var imageUrl = _a.imageUrl,
    onDelete = _a.onDelete,
    _b = _a.deletable,
    deletable = _b === void 0 ? true : _b,
    className = _a.className,
    alt = _a.alt;
  var theme = useTheme();
  return jsxs("figure", _assign({
    className: className,
    css: /*#__PURE__*/css(templateObject_1$3 || (templateObject_1$3 = __makeTemplateObject(["\n        width: ", ";\n        height: ", ";\n        display: inline-block;\n        vertical-align: bottom;\n        position: relative;\n        overflow: hidden;\n        &:after {\n          position: absolute;\n          content: \"\";\n          top: 0;\n          left: 0;\n          right: 0;\n          bottom: 0;\n          border-radius: ", ";\n          border: ", " solid ", ";\n        }\n      " + ( true ? "" : 0)], ["\n        width: ", ";\n        height: ", ";\n        display: inline-block;\n        vertical-align: bottom;\n        position: relative;\n        overflow: hidden;\n        &:after {\n          position: absolute;\n          content: \"\";\n          top: 0;\n          left: 0;\n          right: 0;\n          bottom: 0;\n          border-radius: ", ";\n          border: ", " solid ", ";\n        }\n      " + ( true ? "" : 0)])), pxToRem(72), pxToRem(72), pxToRem(4), pxToRem(1), theme.outline)
  }, {
    children: [jsx(ResizeImage$1, {
      src: imageUrl,
      intrinsicAspect: 1,
      intrinsicInitialHeight: 72,
      quality: 70,
      objectFit: "cover",
      alt: alt,
      css: /*#__PURE__*/css(templateObject_2$2 || (templateObject_2$2 = __makeTemplateObject(["\n          box-sizing: border-box;\n          width: ", ";\n          height: ", ";\n          border-radius: ", ";\n        " + ( true ? "" : 0)], ["\n          box-sizing: border-box;\n          width: ", ";\n          height: ", ";\n          border-radius: ", ";\n        " + ( true ? "" : 0)])), pxToRem(72), pxToRem(72), pxToRem(4))
    }), deletable && jsx("button", _assign({
      css: /*#__PURE__*/css(templateObject_3$1 || (templateObject_3$1 = __makeTemplateObject(["\n            ", ";\n            display: flex;\n            z-index: 3;\n            align-items: center;\n            justify-content: center;\n            position: absolute;\n            top: ", ";\n            right: ", ";\n            cursor: pointer;\n            &:hover {\n              opacity: 0.6;\n            }\n            &:before {\n              content: '';\n              position: absolute;;\n              background-color: ", ";\n              border-radius: 50%;\n              width: ", ";\n              height: ", ";\n            }\n          " + ( true ? "" : 0)], ["\n            ", ";\n            display: flex;\n            z-index: 3;\n            align-items: center;\n            justify-content: center;\n            position: absolute;\n            top: ", ";\n            right: ", ";\n            cursor: pointer;\n            &:hover {\n              opacity: 0.6;\n            }\n            &:before {\n              content: '';\n              position: absolute;;\n              background-color: ", ";\n              border-radius: 50%;\n              width: ", ";\n              height: ", ";\n            }\n          " + ( true ? "" : 0)])), RESET_BUTTON, pxToRem(6), pxToRem(6), theme.content.white, pxToRem(15), pxToRem(15)),
      onClick: onDelete
    }, {
      children: jsx(DismissCircleIcon, {
        css: /*#__PURE__*/css(templateObject_4$1 || (templateObject_4$1 = __makeTemplateObject(["\n              color: ", ";\n              border-radius: 50%;\n              position:relative;\n           " + ( true ? "" : 0)], ["\n              color: ", ";\n              border-radius: 50%;\n              position:relative;\n           " + ( true ? "" : 0)])), theme.content.base1),
        size: 24
      })
    }))]
  }));
}
var templateObject_1$3, templateObject_2$2, templateObject_3$1, templateObject_4$1;

function LinearProgressBar(_a) {
  var total = _a.total,
    variant = _a.variant,
    currentStep = _a.currentStep,
    width = _a.width,
    className = _a.className;
  var theme = useTheme();
  var progress = Math.max(Math.min(currentStep / total * 100, 100), 0);
  return jsx("div", _assign({
    className: className,
    css: /*#__PURE__*/css(templateObject_1$2 || (templateObject_1$2 = __makeTemplateObject(["\n        background-color: ", ";\n        width: ", ";\n        height: ", ";\n        margin-top: auto;\n        margin-bottom: auto;\n      " + ( true ? "" : 0)], ["\n        background-color: ", ";\n        width: ", ";\n        height: ", ";\n        margin-top: auto;\n        margin-bottom: auto;\n      " + ( true ? "" : 0)])), theme.content.base5, typeof width === 'number' ? pxToRem(width) : '100%', pxToRem(6))
  }, {
    children: jsx(StyledDiv, {
      progress: progress,
      variant: variant
    })
  }));
}
var StyledDiv = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e80j02f0"
} : 0)(templateObject_2$1 || (templateObject_2$1 = (0,common._)(["\n  transform: scaleX(", ");\n  transform-origin: center left;\n  transition: transform 1.5s ease;\n  background-color: ", ";\n  border-top-right-radius: ", ";\n  border-bottom-right-radius: ", ";\n  height: 100%;\n  transition-duration: 0.2s;\n  transition-timing-function: ease-in-out;\n"], ["\n  transform: scaleX(", ");\n  transform-origin: center left;\n  transition: transform 1.5s ease;\n  background-color: ", ";\n  border-top-right-radius: ", ";\n  border-bottom-right-radius: ", ";\n  height: 100%;\n  transition-duration: 0.2s;\n  transition-timing-function: ease-in-out;\n"])), function (_a) {
  var progress = _a.progress;
  return progress / 100;
}, function (_a) {
  var theme = _a.theme,
    variant = _a.variant;
  return theme.content[variant].basic;
}, (0,foundation.p)(10), (0,foundation.p)(10));
var templateObject_1$2, templateObject_2$1;

var FETCH_STATUS = {
  LOADED: 'loaded',
  NON_LOAD: 'non-load'
};

var createScrollStorage = function createScrollStorage(tabId) {
  var sessionKey = "scroll-".concat(tabId);
  return {
    get: function get() {
      var scrollInfo = sessionStorage.getItem(sessionKey);
      return scrollInfo ? JSON.parse(scrollInfo) : undefined;
    },
    set: function set(value) {
      sessionStorage.setItem(sessionKey, value);
    },
    reset: function reset() {
      sessionStorage.removeItem(sessionKey);
    }
  };
};
/**
 * @param length
 * @returns length개의 null을 채운 배열
 */
var createNullArray = function createNullArray(length) {
  return Array.from({
    length: length
  }).map(function (_) {
    return null;
  });
};
/**
 * findPageByIndex
 * index보다 작으면서 가장 가까운 배열 요소의 index(page)를 찾아서 반환합니다.
 * @param {number[]} array 각 page의 offset이 담긴 배열
 * @param {number} index 찾고자 하는 아이템 index
 */
var findPageByIndex = function findPageByIndex(array, index) {
  var start = 0;
  var end = array.length - 1;
  while (start <= end) {
    var mid = Math.floor((start + end) / 2);
    var isLastItem = array.length - 1 === mid;
    var currValue = array[mid];
    var nextValue = isLastItem ? Number.MAX_SAFE_INTEGER : array[mid + 1];
    if (index < currValue) {
      end = mid - 1;
    } else if (currValue <= index && index < nextValue) {
      return mid;
    } else {
      start = mid + 1;
    }
  }
  return 0;
};

var MIN_PAGE$1 = 1;
/**
 * info의 개수가 per보다 큰 경우, info를 per개씩 나누어 저장한 pageInfo를 리턴합니다.
 */
var formatPageInfo = function formatPageInfo(_a) {
  var page = _a.page,
    info = _a.info,
    per = _a.per;
  var itemStatus = info.itemStatus,
    items = info.items,
    hasNext = info.hasNext;
  var pageCount = items.length !== 0 ? Math.ceil(items.length / per) : 0;
  var formattedPageInfo = {};
  Array.from({
    length: pageCount
  }).forEach(function (_, index) {
    var _a;
    var isLastPage = index === pageCount - 1;
    formattedPageInfo = _assign(_assign({}, formattedPageInfo), (_a = {}, _a[page + index] = {
      itemStatus: itemStatus,
      items: items.slice(index * per, (index + 1) * per),
      hasNext: isLastPage ? hasNext : true
    }, _a));
  });
  return formattedPageInfo;
};
var getInitialDataInfo = function getInitialDataInfo(initialData, per) {
  if (!initialData) return {};
  var page = initialData.page,
    pageInfo = __rest(initialData, ["page"]);
  return formatPageInfo({
    page: page,
    info: _assign({
      itemStatus: FETCH_STATUS.LOADED
    }, pageInfo),
    per: per
  });
};
function usePageInfo(_a) {
  var per = _a.per,
    tabId = _a.tabId,
    originalInitialData = _a.initialData;
  var _b = useState(getInitialDataInfo(originalInitialData, per)),
    pageInfo = _b[0],
    setPageInfo = _b[1];
  var maxPage = useRef(null);
  useEffect(function () {
    var actualMaxPage = maxPage.current;
    if (actualMaxPage == null) return;
    var isPageInfoAlreadyFiltered = Number(findLastKey(pageInfo)) <= actualMaxPage;
    if (isPageInfoAlreadyFiltered) return;
    setPageInfo(function (pageInfo) {
      var pageList = Object.keys(pageInfo);
      var omittedPageList = pageList.filter(function (page) {
        return Number(page) > actualMaxPage;
      }).map(function (page) {
        return Number(page);
      });
      return omit(pageInfo, omittedPageList);
    });
  }, [pageInfo]);
  var sessionScrollStorage = useMemo(function () {
    return createScrollStorage(tabId);
  }, [tabId]);
  var count = useMemo(function () {
    return Object.values(pageInfo).reduce(function (prev, _a) {
      var items = _a.items;
      return prev + items.length;
    }, 0);
  }, [pageInfo]);
  var getPageInfo = useCallback(function (page) {
    return pageInfo[page];
  }, [pageInfo]);
  var resetPageInfo = useCallback(function () {
    setPageInfo({});
  }, []);
  var addPageInfo = useCallback(function (_a) {
    var page = _a.page,
      info = _a.info;
    setPageInfo(function (pageInfo) {
      var _a;
      return _assign(_assign({}, pageInfo), (_a = {}, _a[page] = info, _a));
    });
  }, []);
  var getPageFromIndex = useCallback(function (index) {
    var page = 1;
    for (var i = 0; i < Object.values(pageInfo).length; i++) {
      var items = Object.values(pageInfo)[i].items;
      if (index + 1 <= items.length) break;
      index -= items.length;
      page++;
    }
    return {
      page: page,
      pageIndex: index
    };
  }, [pageInfo]);
  var getInitialPageInfo = useCallback(function () {
    if (originalInitialData === null) return {};
    return getInitialDataInfo(originalInitialData, per);
  }, [originalInitialData, per]);
  var createNonLoadPageInfo = useCallback(function (itemCount) {
    return formatPageInfo({
      page: MIN_PAGE$1,
      info: {
        itemStatus: FETCH_STATUS.NON_LOAD,
        items: createNullArray(itemCount),
        hasNext: true
      },
      per: per
    });
  }, [per]);
  /**
   * 스크롤 복귀할 page index와 initialData의 마지막 page index를 비교한 후
   * 더 큰 page까지 non-load로 데이터를 채워 반환합니다.
   */
  var getInitialNonLoadPageInfo = useCallback(function () {
    var _a;
    var initialLastPage = (_a = originalInitialData === null || originalInitialData === void 0 ? void 0 : originalInitialData.page) !== null && _a !== void 0 ? _a : 1;
    var scrollInfo = sessionScrollStorage.get();
    if (!(scrollInfo === null || scrollInfo === void 0 ? void 0 : scrollInfo.scrollEndItemIndex)) {
      return createNonLoadPageInfo(initialLastPage * per);
    }
    var scrollItemIndex = Number(scrollInfo.scrollEndItemIndex);
    var scrollPage = Math.floor(scrollItemIndex / per) + 1;
    return createNonLoadPageInfo(Math.max(scrollPage, initialLastPage) * per);
  }, [originalInitialData, sessionScrollStorage, createNonLoadPageInfo, per]);
  var initPageInfo = useCallback(function () {
    var initialPageInfo = getInitialPageInfo();
    var initialNonLoadPageInfo = getInitialNonLoadPageInfo();
    maxPage.current = null;
    setPageInfo(_assign(_assign({}, initialNonLoadPageInfo), initialPageInfo));
  }, [getInitialNonLoadPageInfo, getInitialPageInfo]);
  return {
    maxPage: maxPage,
    count: count,
    getPageInfo: getPageInfo,
    addPageInfo: addPageInfo,
    resetPageInfo: resetPageInfo,
    initPageInfo: initPageInfo,
    getPageFromIndex: getPageFromIndex
  };
}

function useLoadingPageList() {
  var loadingPageList = useRef(new Set());
  var addLoadingPage = useCallback(function (newPage) {
    loadingPageList.current.add(newPage);
  }, []);
  var removeLoadingPage = useCallback(function (targetPage) {
    loadingPageList.current["delete"](targetPage);
  }, []);
  var isLoadingPage = useCallback(function (page) {
    return loadingPageList.current.has(page);
  }, []);
  return {
    addLoadingPage: addLoadingPage,
    removeLoadingPage: removeLoadingPage,
    isLoadingPage: isLoadingPage
  };
}

function usePagedInfiniteList(_a) {
  var _this = this;
  var initialData = _a.initialData,
    initialDataPending = _a.initialDataPending,
    per = _a.per,
    tabId = _a.tabId,
    getItemList = _a.getItemList;
  var _b = useState(),
    error = _b[0],
    setError = _b[1];
  var shouldInit = useRef(true);
  var tabIdChanged = useChanged(tabId);
  var initialDataChanged = useChanged(initialData, isEqual);
  if (tabIdChanged || initialDataChanged) {
    shouldInit.current = true;
  }
  var _c = usePageInfo({
      per: per,
      tabId: tabId,
      initialData: initialData
    }),
    maxPage = _c.maxPage,
    count = _c.count,
    getPageInfo = _c.getPageInfo,
    addPageInfo = _c.addPageInfo,
    initPageInfo = _c.initPageInfo,
    getPageFromIndex = _c.getPageFromIndex;
  var _d = useLoadingPageList(),
    addLoadingPage = _d.addLoadingPage,
    removeLoadingPage = _d.removeLoadingPage,
    isLoadingPage = _d.isLoadingPage;
  /**
   * @param page fetch 할 페이지
   * @param fetchStatus fetch하는 status(non-load/loaded)
   */
  var fetchPageItemList = useCallback(function (_a) {
    var page = _a.page,
      _b = _a.fetchStatus,
      fetchStatus = _b === void 0 ? FETCH_STATUS.LOADED : _b;
    return __awaiter(_this, void 0, void 0, function () {
      var _c, _d, items, hasNext, error_1;
      var _e;
      return __generator(this, function (_f) {
        switch (_f.label) {
          case 0:
            if (error == null) {
              addPageInfo({
                page: page,
                info: {
                  itemStatus: FETCH_STATUS.NON_LOAD,
                  items: createNullArray(per),
                  hasNext: true
                }
              });
            }
            if (fetchStatus === FETCH_STATUS.NON_LOAD) return [2 /*return*/];
            addLoadingPage(page);
            _f.label = 1;
          case 1:
            _f.trys.push([1, 3, 4, 5]);
            return [4 /*yield*/, getItemList(page, per)];
          case 2:
            _c = _f.sent(), _d = _c.items, items = _d === void 0 ? [] : _d, hasNext = _c.hasNext;
            addPageInfo({
              page: page,
              info: {
                itemStatus: FETCH_STATUS.LOADED,
                items: items,
                hasNext: hasNext
              }
            });
            if (hasNext === false) {
              maxPage.current = Math.min((_e = maxPage.current) !== null && _e !== void 0 ? _e : Number.MAX_SAFE_INTEGER, page);
            }
            if (page === (error === null || error === void 0 ? void 0 : error.errorPage)) {
              setError(undefined);
            }
            return [3 /*break*/, 5];
          case 3:
            error_1 = _f.sent();
            setError({
              error: error_1,
              errorPage: page
            });
            return [3 /*break*/, 5];
          case 4:
            removeLoadingPage(page);
            return [7 /*endfinally*/];
          case 5:
            return [2 /*return*/];
        }
      });
    });
  }, [addLoadingPage, addPageInfo, error, getItemList, maxPage, per, removeLoadingPage]);
  var handleLoadItemList = useCallback(function (_a) {
    var startItemIndex = _a.startItemIndex,
      _b = _a.endItemIndex,
      endItemIndex = _b === void 0 ? startItemIndex : _b,
      _c = _a.fetchStatus,
      fetchStatus = _c === void 0 ? FETCH_STATUS.LOADED : _c;
    return __awaiter(_this, void 0, void 0, function () {
      var startItemPage, endItemPage, pageCount;
      return __generator(this, function (_d) {
        if (startItemIndex > endItemIndex) return [2 /*return*/];
        startItemPage = getPageFromIndex(startItemIndex).page;
        endItemPage = getPageFromIndex(endItemIndex).page;
        pageCount = endItemPage - startItemPage + 1;
        Array.from({
          length: pageCount
        }).forEach(function (_, index) {
          var _a;
          var page = index + startItemPage;
          var isPageAlreadyFetched = ((_a = getPageInfo(page)) === null || _a === void 0 ? void 0 : _a.itemStatus) === FETCH_STATUS.LOADED;
          var isPageLoading = isLoadingPage(page);
          var isPageNotInRange = page < MIN_PAGE$1 || maxPage.current != null && page > maxPage.current;
          if (isPageAlreadyFetched || isPageLoading || isPageNotInRange || error) return;
          fetchPageItemList({
            page: page,
            fetchStatus: fetchStatus
          });
        });
        return [2 /*return*/];
      });
    });
  }, [error, fetchPageItemList, getPageFromIndex, getPageInfo, isLoadingPage, maxPage]);
  var handleReloadErrorPage = useCallback(function () {
    if (!error) return;
    fetchPageItemList({
      page: error.errorPage
    });
  }, [error, fetchPageItemList]);
  var handleGetItem = useCallback(function (index) {
    var _a;
    var _b = getPageFromIndex(index),
      page = _b.page,
      pageIndex = _b.pageIndex;
    return (_a = getPageInfo(page)) === null || _a === void 0 ? void 0 : _a.items[pageIndex];
  }, [getPageFromIndex, getPageInfo]);
  /**
   * 기존 데이터를 reset하고, initial 데이터와 현재 스크롤 위치에서의 데이터를 reFetching합니다.
   * 중간 데이터들은 전부 non-load로 처리합니다.
   */
  var handleReloadItemList = useCallback(function () {
    initPageInfo();
  }, [initPageInfo]);
  useEffect(function () {
    if (initialDataPending || !initialData || !shouldInit.current) return;
    initPageInfo();
    shouldInit.current = false;
  }, [initPageInfo, initialData, initialDataPending]);
  return {
    count: count,
    loadItemList: handleLoadItemList,
    reloadItemList: handleReloadItemList,
    reloadError: handleReloadErrorPage,
    getItem: handleGetItem,
    error: error === null || error === void 0 ? void 0 : error.error
  };
}

var MIN_PAGE = 0;
var getInitialCursorInfo = function getInitialCursorInfo(initialData) {
  var _a;
  if (initialData === null) return {};
  return _a = {}, _a[MIN_PAGE] = _assign({
    itemStatus: FETCH_STATUS.LOADED,
    offset: 0,
    cursor: null
  }, initialData), _a;
};
function useCursorInfo(_a) {
  var initialData = _a.initialData;
  var _b = useState(getInitialCursorInfo(initialData)),
    cursorInfo = _b[0],
    setCursorInfo = _b[1];
  var _c = useMemo(function () {
      var _a;
      var lastCursorInfo = (_a = findLast(cursorInfo)) !== null && _a !== void 0 ? _a : {
        offset: 0,
        items: [],
        nextCursor: null,
        itemStatus: FETCH_STATUS.NON_LOAD
      };
      var count = lastCursorInfo.offset + lastCursorInfo.items.length;
      var nextCursor = lastCursorInfo.nextCursor || null;
      var hasNext = !(lastCursorInfo.itemStatus === 'loaded' && nextCursor === null);
      return {
        count: count,
        nextCursor: nextCursor,
        hasNext: hasNext
      };
    }, [cursorInfo]),
    count = _c.count,
    nextCursor = _c.nextCursor,
    hasNext = _c.hasNext;
  var lastPage = useMemo(function () {
    var _a;
    return Number((_a = findLastKey(cursorInfo)) !== null && _a !== void 0 ? _a : 0);
  }, [cursorInfo]);
  var getCursorInfo = useCallback(function (page) {
    return cursorInfo[page];
  }, [cursorInfo]);
  var resetCursorInfo = useCallback(function () {
    setCursorInfo({});
  }, []);
  var addCursorInfo = useCallback(function (_a) {
    var page = _a.page,
      info = _a.info;
    var prevCursorInfo = cursorInfo[page - 1];
    var offset = prevCursorInfo ? prevCursorInfo.offset + prevCursorInfo.items.length : 0;
    setCursorInfo(function (cursorInfo) {
      var _a;
      return _assign(_assign({}, cursorInfo), (_a = {}, _a[page] = _assign(_assign({}, info), {
        offset: offset
      }), _a));
    });
  }, [cursorInfo]);
  var getPageFromIndex = useCallback(function (index) {
    var offsetArray = __spreadArray(__spreadArray([], Object.values(cursorInfo).map(function (_a) {
      var offset = _a.offset;
      return offset;
    }), true), [count], false);
    var page = findPageByIndex(offsetArray, index);
    var isOverCount = page === size(cursorInfo);
    if (isOverCount) return null;
    return page;
  }, [cursorInfo, count]);
  var removeCursorInfo = useCallback(function (page) {
    setCursorInfo(function (cursorInfo) {
      return omit(cursorInfo, page);
    });
  }, []);
  var initCursorInfo = useCallback(function () {
    if (!initialData) return;
    var initialCursorInfo = getInitialCursorInfo(initialData);
    setCursorInfo(initialCursorInfo);
  }, [initialData]);
  return {
    nextCursor: nextCursor,
    count: count,
    lastPage: lastPage,
    hasNext: hasNext,
    getCursorInfo: getCursorInfo,
    addCursorInfo: addCursorInfo,
    removeCursorInfo: removeCursorInfo,
    resetCursorInfo: resetCursorInfo,
    initCursorInfo: initCursorInfo,
    getPageFromIndex: getPageFromIndex
  };
}

function usePagedCursorInfiniteList(_a) {
  var _this = this;
  var initialData = _a.initialData,
    initialDataPending = _a.initialDataPending,
    per = _a.per,
    tabId = _a.tabId,
    getItemList = _a.getItemList;
  var _b = useState(),
    error = _b[0],
    setError = _b[1];
  var _c = useState(null),
    scrollTargetIndex = _c[0],
    setScrollTargetIndex = _c[1];
  var shouldInit = useRef(true);
  var tabIdChanged = useChanged(tabId);
  var initialDataChanged = useChanged(initialData, isEqual);
  if (tabIdChanged || initialDataChanged) {
    shouldInit.current = true;
  }
  var sessionScrollStorage = useMemo(function () {
    return createScrollStorage(tabId);
  }, [tabId]);
  var _d = useCursorInfo({
      initialData: initialData
    }),
    targetCursor = _d.nextCursor,
    count = _d.count,
    lastPage = _d.lastPage,
    hasNext = _d.hasNext,
    getCursorInfo = _d.getCursorInfo,
    addCursorInfo = _d.addCursorInfo,
    removeCursorInfo = _d.removeCursorInfo,
    initCursorInfo = _d.initCursorInfo,
    getPageFromIndex = _d.getPageFromIndex;
  var _e = useLoadingPageList(),
    addLoadingPage = _e.addLoadingPage,
    removeLoadingPage = _e.removeLoadingPage,
    isLoadingPage = _e.isLoadingPage;
  var visibleCount = useMemo(function () {
    if (hasNext && scrollTargetIndex !== null) {
      return Math.max(count, scrollTargetIndex + 1);
    }
    return count;
  }, [count, hasNext, scrollTargetIndex]);
  var fetchCursorItemList = useCallback(function (_a) {
    var page = _a.page,
      cursor = _a.cursor;
    return __awaiter(_this, void 0, void 0, function () {
      var _b, _c, items, hasNext_1, nextCursor, error_1;
      return __generator(this, function (_d) {
        switch (_d.label) {
          case 0:
            if (!cursor || !initialData) return [2 /*return*/];
            addCursorInfo({
              page: page,
              info: {
                itemStatus: FETCH_STATUS.NON_LOAD,
                items: createNullArray(per !== null && per !== void 0 ? per : initialData.items.length),
                hasNext: true,
                nextCursor: null,
                cursor: cursor
              }
            });
            addLoadingPage(page);
            _d.label = 1;
          case 1:
            _d.trys.push([1, 3, 4, 5]);
            return [4 /*yield*/, getItemList(cursor, per)];
          case 2:
            _b = _d.sent(), _c = _b.items, items = _c === void 0 ? [] : _c, hasNext_1 = _b.hasNext, nextCursor = _b.nextCursor;
            addCursorInfo({
              page: page,
              info: {
                itemStatus: FETCH_STATUS.LOADED,
                items: items,
                hasNext: hasNext_1,
                nextCursor: nextCursor,
                cursor: cursor
              }
            });
            if ((error === null || error === void 0 ? void 0 : error.errorPage) === page) {
              setError(undefined);
            }
            return [3 /*break*/, 5];
          case 3:
            error_1 = _d.sent();
            setError({
              error: error_1,
              errorPage: page
            });
            return [3 /*break*/, 5];
          case 4:
            removeLoadingPage(page);
            return [7 /*endfinally*/];
          case 5:
            return [2 /*return*/];
        }
      });
    });
  }, [initialData, addCursorInfo, per, addLoadingPage, getItemList, error === null || error === void 0 ? void 0 : error.errorPage, removeLoadingPage]);
  var handleLoadItemList = useCallback(function (_a) {
    var endItemIndex = _a.endItemIndex;
    return __awaiter(_this, void 0, void 0, function () {
      var targetPage;
      return __generator(this, function (_b) {
        targetPage = lastPage + 1;
        if (!targetCursor || isLoadingPage(targetPage) || endItemIndex < count) return [2 /*return*/];
        fetchCursorItemList({
          page: targetPage,
          cursor: targetCursor
        });
        return [2 /*return*/];
      });
    });
  }, [count, fetchCursorItemList, isLoadingPage, lastPage, targetCursor]);
  var handleReloadErrorPage = useCallback(function () {
    var _a;
    if (!error) return;
    setError(undefined);
    removeCursorInfo(error.errorPage);
    var cursorData = getCursorInfo(error.errorPage);
    var errorCursor = (_a = cursorData === null || cursorData === void 0 ? void 0 : cursorData.cursor) !== null && _a !== void 0 ? _a : null;
    fetchCursorItemList({
      page: error.errorPage,
      cursor: errorCursor
    });
  }, [error, fetchCursorItemList, getCursorInfo, removeCursorInfo]);
  var handleGetItem = useCallback(function (index) {
    var page = getPageFromIndex(index);
    if (page === null) return null;
    var cursorInfo = getCursorInfo(page);
    if (!cursorInfo) return null;
    var itemIndexInPage = index - cursorInfo.offset;
    return cursorInfo.items[itemIndexInPage];
  }, [getCursorInfo, getPageFromIndex]);
  var initScrollTarget = useCallback(function () {
    var scrollInfo = sessionScrollStorage.get();
    if (!(scrollInfo === null || scrollInfo === void 0 ? void 0 : scrollInfo.scrollEndItemIndex)) {
      setScrollTargetIndex(0);
      return;
    }
    var scrollEndItemIndex = Number(scrollInfo.scrollEndItemIndex);
    setScrollTargetIndex(scrollEndItemIndex);
  }, [sessionScrollStorage]);
  var handleReloadItemList = useCallback(function () {
    initCursorInfo();
    initScrollTarget();
  }, [initCursorInfo, initScrollTarget]);
  useEffect(function () {
    if (!shouldInit.current || initialDataPending || !initialData) return;
    initCursorInfo();
    initScrollTarget();
    shouldInit.current = false;
  }, [initCursorInfo, initScrollTarget, initialData, initialDataPending]);
  return {
    count: visibleCount,
    // 이슈 대응을 위해 임시로 필드를 추가 반환합니다. (DESYSWEB-428 참조)
    itemCount: count,
    loadItemList: handleLoadItemList,
    reloadItemList: handleReloadItemList,
    reloadError: handleReloadErrorPage,
    getItem: handleGetItem,
    error: error === null || error === void 0 ? void 0 : error.error
  };
}

var SCROLL_THROTTLE_MILLISECONDS = 500;
/**
 * useVirtualizedScroll
 * 페이지를 벗어날 때 스크롤 위치를 저장하고, 페이지 재접근 시 스크롤 위치를 복귀시키는 역할을 수행합니다.
 */
var useVirtualizedScroll = function useVirtualizedScroll(_a) {
  var tabId = _a.tabId,
    columnCount = _a.columnCount,
    containerRef = _a.containerRef,
    renderedRowList = _a.renderedRowList,
    disableSaveScroll = _a.disableSaveScroll;
  var _b = useState(null),
    targetScrollTop = _b[0],
    setTargetScrollTop = _b[1];
  var scrollIntervalId = useRef(null);
  var scrollDone = useRef(false);
  var sessionScrollStorage = useMemo(function () {
    return createScrollStorage(tabId);
  }, [tabId]);
  /**
   * 현재 scroll 위치 정보를 sessionStorage에 저장합니다.
   */
  var saveScrollInfo = useCallback(function () {
    var _a, _b, _c;
    if (!scrollDone.current || !containerRef.current || !renderedRowList.current || renderedRowList.current.length === 0 || disableSaveScroll) return;
    var offsetTop = (_b = (_a = containerRef.current) === null || _a === void 0 ? void 0 : _a.offsetTop) !== null && _b !== void 0 ? _b : 0;
    /** 화면 최상단에서부터 scrollTop */
    var scrollTop = document.documentElement.scrollTop;
    /** 현재 보이는 화면 "상단" 선 기준 VirtualizedList 컴포넌트 최상단에서부터의 scrollTop */
    var scrollTopFromStart = scrollTop - offsetTop;
    /** 현재 보이는 화면 "하단" 선 기준 VirtualizedList 컴포넌트 최상단에서부터의 scrollTop */
    var scrollBottomFromStart = scrollTopFromStart + window.innerHeight;
    var lastRenderedRow = renderedRowList.current[renderedRowList.current.length - 1];
    var visibleEndRowIndex = ((_c = renderedRowList.current.find(function (_a) {
      var offset = _a.offset,
        size = _a.size;
      return offset <= scrollBottomFromStart && scrollBottomFromStart < offset + size;
    })) !== null && _c !== void 0 ? _c : lastRenderedRow).index;
    /** 화면에 보이는 마지막 아이템 item */
    var endItemIndex = (visibleEndRowIndex + 1) * columnCount - 1;
    var scrollInfo = {
      scrollTop: scrollTop,
      scrollEndItemIndex: endItemIndex
    };
    var bottom = containerRef.current.getBoundingClientRect().bottom;
    var isScrollAfterList = bottom < 0;
    if (isScrollAfterList) {
      var prevScrollInfo = sessionScrollStorage.get();
      var prevEndItemIndex = prevScrollInfo === null || prevScrollInfo === void 0 ? void 0 : prevScrollInfo.scrollEndItemIndex;
      if (prevEndItemIndex) {
        scrollInfo.scrollEndItemIndex = Math.max(prevEndItemIndex, endItemIndex);
      }
    }
    sessionScrollStorage.set(JSON.stringify(scrollInfo));
  }, [columnCount, containerRef, disableSaveScroll, renderedRowList, sessionScrollStorage]);
  useEffect(function () {
    var scrollInfo = sessionScrollStorage.get();
    if ((scrollInfo === null || scrollInfo === void 0 ? void 0 : scrollInfo.scrollTop) == null) {
      scrollDone.current = true;
      return;
    }
    scrollDone.current = false;
    setTargetScrollTop(scrollInfo.scrollTop);
  }, [sessionScrollStorage]);
  useEffect(function () {
    if (scrollIntervalId.current) {
      clearInterval(scrollIntervalId.current);
    }
    if (scrollDone.current) return;
    var intervalId = setInterval(function () {
      if (targetScrollTop == null) return;
      var scrollTop = document.documentElement.scrollTop;
      var isClearInterval = scrollTop !== 0 && scrollTop <= targetScrollTop || scrollTop === targetScrollTop;
      if (isClearInterval) {
        scrollDone.current = true;
        clearInterval(intervalId);
        return;
      }
      window.scrollTo({
        top: targetScrollTop
      });
    }, 10);
    scrollIntervalId.current = intervalId;
    return function () {
      clearInterval(intervalId);
    };
  }, [targetScrollTop]);
  useEffect(function () {
    var throttleSaveScrollInfo = throttle(saveScrollInfo, SCROLL_THROTTLE_MILLISECONDS);
    window.addEventListener('scroll', throttleSaveScrollInfo);
    if (disableSaveScroll) {
      window.removeEventListener('scroll', throttleSaveScrollInfo);
    }
    return function () {
      window.removeEventListener('scroll', throttleSaveScrollInfo);
    };
  }, [saveScrollInfo, disableSaveScroll, sessionScrollStorage]);
};

var DEFAULT_FAST_SCROLLING_VELOCITY = 4000; // (px/s)
var DEFAULT_OVERSCAN_HEIGHT = 500;
/**
 * Grid 컴포넌트는 autoHeight와 연동되지 않으므로,
 * List의 한 row당 grid만큼의 아이템을 가질 수 있도록 그리드 형태를 구현
 */
function VirtualizedList(_a) {
  var _this = this;
  var _b = _a.initialBreakpoint,
    initialBreakpoint = _b === void 0 ? 'desktop' : _b,
    grid = _a.grid,
    tabId = _a.tabId,
    count = _a.count,
    loadItemList = _a.loadItemList,
    _c = _a.disableSaveScroll,
    disableSaveScroll = _c === void 0 ? false : _c,
    _d = _a.disableUseWindowScroll,
    disableUseWindowScroll = _d === void 0 ? false : _d,
    _e = _a.overscanHeight,
    overscanHeight = _e === void 0 ? DEFAULT_OVERSCAN_HEIGHT : _e,
    _f = _a.insertedItemList,
    insertedItemList = _f === void 0 ? [] : _f,
    renderItem = _a.renderItem,
    _g = _a.fastScrollingVelocity,
    fastScrollingVelocity = _g === void 0 ? DEFAULT_FAST_SCROLLING_VELOCITY : _g,
    props = __rest(_a, ["initialBreakpoint", "grid", "tabId", "count", "loadItemList", "disableSaveScroll", "disableUseWindowScroll", "overscanHeight", "insertedItemList", "renderItem", "fastScrollingVelocity"]);
  var containerRef = useRef(null);
  var renderedRowList = useRef([]);
  var _h = useState(false),
    isFastScrolling = _h[0],
    setIsFastScrolling = _h[1];
  var breakpoint = useResponsive().breakpoint;
  var columnCount = useMemo(function () {
    return grid[breakpoint !== null && breakpoint !== void 0 ? breakpoint : initialBreakpoint];
  }, [breakpoint, grid, initialBreakpoint]);
  var itemRowCount = useMemo(function () {
    return Math.ceil(count / columnCount);
  }, [columnCount, count]);
  var insertedItemObject = useMemo(function () {
    return insertedItemList.reduce(function (prev, curr) {
      var _a;
      return _assign(_assign({}, prev), (_a = {}, _a[curr.rowIndex] = curr, _a));
    }, {});
  }, [insertedItemList]);
  var insertedItemRowCount = useMemo(function () {
    var _a;
    return (_a = Object.keys(insertedItemObject).length) !== null && _a !== void 0 ? _a : 0;
  }, [insertedItemObject]);
  useVirtualizedScroll({
    tabId: tabId,
    columnCount: columnCount,
    containerRef: containerRef,
    renderedRowList: renderedRowList,
    disableSaveScroll: disableSaveScroll
  });
  /**
   * grid개의 아이템을 포함한 index번째 row를 생성합니다.
   */
  var createRowContent = useCallback(function (rowIndex) {
    var hasInsertedItem = Object.keys(insertedItemObject).includes("".concat(rowIndex));
    if (hasInsertedItem) {
      return jsx(Row, {
        children: insertedItemObject[rowIndex].component
      });
    }
    // 현재 rowIndex 보다 위에 존재하는 insertedItem의 개수
    var nowInsertedItemCount = Object.keys(insertedItemObject).filter(function (embedIndex) {
      return Number(embedIndex) < rowIndex;
    }).length;
    return jsx(Row, _assign({
      columnCount: columnCount
    }, {
      children: Array.from({
        length: columnCount
      }).map(function (_, columnIndex) {
        var index = columnCount * (rowIndex - nowInsertedItemCount) + columnIndex;
        var lastItemIndex = count - 1;
        if (index > lastItemIndex) return null;
        return jsx(Fragment, {
          children: renderItem(index, rowIndex, isFastScrolling)
        }, "item".concat(index));
      })
    }));
  }, [insertedItemObject, columnCount, count, isFastScrolling, renderItem]);
  var fetchItemList = useCallback(function (renderedRowList, isFastScrolling) {
    return __awaiter(_this, void 0, void 0, function () {
      var startRow, endRow, startItemIndex, endItemIndex;
      return __generator(this, function (_a) {
        if (renderedRowList.length < 1 || !loadItemList) return [2 /*return*/];
        startRow = renderedRowList[0].index;
        endRow = renderedRowList[renderedRowList.length - 1].index;
        startItemIndex = startRow * columnCount;
        endItemIndex = (endRow + 1) * columnCount;
        loadItemList({
          startItemIndex: startItemIndex,
          endItemIndex: endItemIndex,
          fetchStatus: isFastScrolling ? FETCH_STATUS.NON_LOAD : FETCH_STATUS.LOADED
        });
        return [2 /*return*/];
      });
    });
  }, [columnCount, loadItemList]);
  var handleItemsRendered = useCallback(function (items) {
    if (items.length < 1) return;
    renderedRowList.current = items;
    fetchItemList(items, isFastScrolling);
  }, [fetchItemList, isFastScrolling]);
  return jsx("div", _assign({
    ref: containerRef,
    style: disableUseWindowScroll ? {
      height: '100%',
      overflow: 'hidden'
    } : {}
  }, {
    children: jsx(Virtuoso, _assign({}, props, {
      itemContent: createRowContent,
      totalCount: itemRowCount + insertedItemRowCount,
      useWindowScroll: !disableUseWindowScroll,
      itemsRendered: handleItemsRendered,
      initialItemCount: itemRowCount,
      scrollSeekConfiguration: {
        enter: function enter(velocity) {
          setIsFastScrolling(Math.abs(velocity) > fastScrollingVelocity);
          return false;
        },
        exit: function exit(velocity) {
          setIsFastScrolling(Math.abs(velocity) > fastScrollingVelocity);
          return false;
        }
      },
      isScrolling: function isScrolling(_isScrolling) {
        if (_isScrolling) return;
        setIsFastScrolling(false);
        fetchItemList(renderedRowList.current, false);
      },
      increaseViewportBy: {
        top: overscanHeight,
        bottom: overscanHeight
      },
      style: disableUseWindowScroll ? {
        height: '100%'
      } : {
        height: 'fit-content'
      }
    }))
  }));
}
var Row = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1qabbed0"
} : 0)(templateObject_1$1 || (templateObject_1$1 = (0,common._)(["\n  width: 100%;\n  display: flex;\n  & > * {\n    width: ", "%;\n  }\n"], ["\n  width: 100%;\n  display: flex;\n  & > * {\n    width: ", "%;\n  }\n"])), function (_a) {
  var _b = _a.columnCount,
    columnCount = _b === void 0 ? 1 : _b;
  return 100 / columnCount;
});
var templateObject_1$1;

var TOOLTIP_MIN_WIDTH = 92;
var TOOLTIP_MIN_HEIGHT = 36;
var TOOLTIP_MARGIN = 8;
var ARROW_SIZE = {
  width: 14,
  height: 10
};
var Tooltip = function Tooltip(_a) {
  var _b;
  var arrow = _a.arrow,
    variant = _a.variant,
    _c = _a.hasRoundBorder,
    hasRoundBorder = _c === void 0 ? false : _c,
    _d = _a.isTwoLine,
    isTwoLine = _d === void 0 ? false : _d,
    children = _a.children,
    onClose = _a.onClose;
  var options = {
    arrow: arrow,
    variant: variant
  };
  var placement = arrow.placement;
  var tooltipRef = (0,react.useRef)(null);
  var tooltipWidth = ((_b = (0,lib_esm/* useNodeSize */.se)(tooltipRef, [TOOLTIP_MIN_WIDTH, TOOLTIP_MIN_HEIGHT])) === null || _b === void 0 ? void 0 : _b[0]) || 0;
  var tooltipHeight = (0,lib_esm/* useNodeHeight */.XP)(tooltipRef) || 0;
  // arrow 방향에 따라 width || height 값을 넘겨줌
  var tooltipSize = placement === 'bottom' || placement === 'top' ? tooltipWidth : tooltipHeight;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Container, {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Content, (0,common.a)({
      variant: variant,
      hasRoundBorder: hasRoundBorder,
      isTwoLine: isTwoLine,
      ref: tooltipRef
    }, {
      children: [children, onClose && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CloseButton, {
        type: "button",
        size: 32,
        icon: {
          name: 'dismiss',
          size: 16
        },
        onClick: onClose,
        isTwoLine: isTwoLine,
        variant: "base1"
      })]
    })), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ArrowContainer, {
      options: options,
      tooltipSize: tooltipSize
    })]
  });
};
var Container = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1rflc093"
} : 0)(templateObject_1 || (templateObject_1 = (0,common._)(["\n  ", ";\n  letter-spacing: ", ";\n  position: relative;\n  gap: ", ";\n  display: inline-block;\n"], ["\n  ", ";\n  letter-spacing: ", ";\n  position: relative;\n  gap: ", ";\n  display: inline-block;\n"])), foundation.F.body2, (0,foundation.p)(-0.3), (0,foundation.p)(10));
var cssBackgroundColor = function cssBackgroundColor(theme, variant) {
  switch (variant) {
    case 'dark':
      return theme.layer.dark;
    case 'light':
      return theme.layer.light;
  }
};
var cssFontColor = function cssFontColor(theme, variant) {
  switch (variant) {
    case 'dark':
      return theme.content.white;
    case 'light':
      return theme.content.base1;
  }
};
var Content = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1rflc092"
} : 0)(templateObject_2 || (templateObject_2 = (0,common._)(["\n  padding: ", " ", ";\n  border-radius: ", ";\n  color: ", ";\n  background-color: ", ";\n  align-items: ", ";\n  margin: auto;\n  white-space: pre-line;\n  display: flex;\n  flex-direction: row;\n"], ["\n  padding: ", " ", ";\n  border-radius: ", ";\n  color: ", ";\n  background-color: ", ";\n  align-items: ", ";\n  margin: auto;\n  white-space: pre-line;\n  display: flex;\n  flex-direction: row;\n"])), (0,foundation.p)(8), (0,foundation.p)(12), function (_a) {
  var hasRoundBorder = _a.hasRoundBorder;
  return hasRoundBorder ? (0,foundation.p)(20) : (0,foundation.p)(4);
}, function (_a) {
  var theme = _a.theme,
    variant = _a.variant;
  return cssFontColor(theme, variant);
}, function (_a) {
  var theme = _a.theme,
    variant = _a.variant;
  return cssBackgroundColor(theme, variant);
}, function (_a) {
  var isTwoLine = _a.isTwoLine;
  return isTwoLine ? 'flex-start' : 'center';
});
var CloseButton = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(IconButton,  true ? {
  shouldForwardProp: function shouldForwardProp(props) {
    return props !== 'isTwoLine';
  },
  target: "e1rflc091"
} : 0)(templateObject_3 || (templateObject_3 = (0,common._)(["\n  margin-top: ", ";\n  margin-right: ", ";\n  cursor: pointer;\n"], ["\n  margin-top: ", ";\n  margin-right: ", ";\n  cursor: pointer;\n"])), function (_a) {
  var isTwoLine = _a.isTwoLine;
  return isTwoLine && "".concat((0,foundation.p)(-6));
}, (0,foundation.p)(-8));
var createArrowShape = function createArrowShape(theme, options) {
  var arrow = options.arrow,
    variant = options.variant;
  switch (arrow.placement) {
    case 'top':
      return /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)(templateObject_4 || (templateObject_4 = (0,common._)(["\n        border-bottom: ", " solid ", ";\n        border-left: ", " solid transparent;\n        border-right: ", " solid transparent;\n      " + ( true ? "" : 0)], ["\n        border-bottom: ", " solid ", ";\n        border-left: ", " solid transparent;\n        border-right: ", " solid transparent;\n      " + ( true ? "" : 0)])), (0,foundation.p)(ARROW_SIZE.height), cssBackgroundColor(theme, variant), (0,foundation.p)(ARROW_SIZE.width / 2), (0,foundation.p)(ARROW_SIZE.width / 2));
    case 'left':
      return /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)(templateObject_5 || (templateObject_5 = (0,common._)(["\n        border-right: ", " solid ", ";\n        border-bottom: ", " solid transparent;\n        border-top: ", " solid transparent;\n        " + ( true ? "" : 0)], ["\n        border-right: ", " solid ", ";\n        border-bottom: ", " solid transparent;\n        border-top: ", " solid transparent;\n        " + ( true ? "" : 0)])), (0,foundation.p)(ARROW_SIZE.height), cssBackgroundColor(theme, variant), (0,foundation.p)(ARROW_SIZE.width / 2), (0,foundation.p)(ARROW_SIZE.width / 2));
    case 'right':
      return /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)(templateObject_6 || (templateObject_6 = (0,common._)(["\n        border-left: ", " solid ", ";\n        border-bottom: ", " solid transparent;\n        border-top: ", " solid transparent; \n        " + ( true ? "" : 0)], ["\n        border-left: ", " solid ", ";\n        border-bottom: ", " solid transparent;\n        border-top: ", " solid transparent; \n        " + ( true ? "" : 0)])), (0,foundation.p)(ARROW_SIZE.height), cssBackgroundColor(theme, variant), (0,foundation.p)(ARROW_SIZE.width / 2), (0,foundation.p)(ARROW_SIZE.width / 2));
    case 'bottom':
      return /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)(templateObject_7 || (templateObject_7 = (0,common._)(["\n        border-top: ", " solid ", ";\n        border-left: ", " solid transparent;\n        border-right: ", " solid transparent;\n        " + ( true ? "" : 0)], ["\n        border-top: ", " solid ", ";\n        border-left: ", " solid transparent;\n        border-right: ", " solid transparent;\n        " + ( true ? "" : 0)])), (0,foundation.p)(ARROW_SIZE.height), cssBackgroundColor(theme, variant), (0,foundation.p)(ARROW_SIZE.width / 2), (0,foundation.p)(ARROW_SIZE.width / 2));
  }
};
var createArrowPlacement = function createArrowPlacement(tooltipSize, options) {
  var arrow = options.arrow;
  var placement = arrow.placement,
    align = arrow.align,
    alignLocation = arrow.alignLocation;
  var bottomHeight = placement === 'bottom' ? ARROW_SIZE.height : 0;
  var arrowLocation = align === 'center' ? 'left' : align;
  var arrowAlign = align !== 'center' && alignLocation ? Math.min(alignLocation, tooltipSize) : tooltipSize / 2 - TOOLTIP_MARGIN;
  switch (placement) {
    case 'top':
    case 'bottom':
      return /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)(templateObject_8 || (templateObject_8 = (0,common._)(["\n        ", ": ", ";\n        ", ": ", ";\n      " + ( true ? "" : 0)], ["\n        ", ": ", ";\n        ", ": ", ";\n      " + ( true ? "" : 0)])), placement, (0,foundation.p)(-10 + bottomHeight), arrowLocation, (0,foundation.p)(arrowAlign));
    case 'right':
    case 'left':
      return /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)(templateObject_9 || (templateObject_9 = (0,common._)(["\n        top: ", ";\n        ", ": ", ";\n      " + ( true ? "" : 0)], ["\n        top: ", ";\n        ", ": ", ";\n      " + ( true ? "" : 0)])), (0,foundation.p)(arrowAlign), placement, (0,foundation.p)(-10));
  }
};
var ArrowContainer = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1rflc090"
} : 0)(templateObject_10 || (templateObject_10 = (0,common._)(["\n  width: ", ";\n  height: ", ";\n  &::after {\n    content: '';\n    position: absolute;\n    ", "\n    ", "\n  }\n"], ["\n  width: ", ";\n  height: ", ";\n  &::after {\n    content: '';\n    position: absolute;\n    ", "\n    ", "\n  }\n"])), (0,foundation.p)(ARROW_SIZE.width), (0,foundation.p)(ARROW_SIZE.height), function (_a) {
  var theme = _a.theme,
    options = _a.options;
  return createArrowShape(theme, options);
}, function (_a) {
  var tooltipSize = _a.tooltipSize,
    options = _a.options;
  return createArrowPlacement(tooltipSize, options);
});
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10;

var SEARCH_TYPE = {
  TOTAL: 'total',
  STORE: 'store',
  EXPERT: 'expert_user'
};


//# sourceMappingURL=bds.js.map


/***/ }),

/***/ 68479:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "B": function() { return /* binding */ BodyPortal; },
  "I": function() { return /* binding */ common_IntersectionObserver; },
  "O": function() { return /* binding */ OverlayProvider; },
  "Z": function() { return /* binding */ ZINDEX; },
  "_": function() { return /* binding */ __makeTemplateObject; },
  "a": function() { return /* binding */ _assign; },
  "b": function() { return /* binding */ __spreadArray; },
  "c": function() { return /* binding */ __awaiter; },
  "d": function() { return /* binding */ __generator; },
  "e": function() { return /* binding */ __rest; },
  "f": function() { return /* binding */ _wrapRegExp; },
  "h": function() { return /* binding */ OverlayPortal; },
  "j": function() { return /* binding */ onValueHandler; },
  "k": function() { return /* binding */ _typeof; },
  "o": function() { return /* binding */ onCheckHandler; }
});

// UNUSED EXPORTS: P, g, i

// EXTERNAL MODULE: ./node_modules/.pnpm/@emotion+react@11.13.3_@types+react@18.3.12_react@18.3.1/node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(83128);
// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.3.1/node_modules/react/index.js
var react = __webpack_require__(75271);
// EXTERNAL MODULE: ./node_modules/.pnpm/@emotion+react@11.13.3_@types+react@18.3.12_react@18.3.1/node_modules/@emotion/react/dist/emotion-react.browser.esm.js
var emotion_react_browser_esm = __webpack_require__(52814);
;// CONCATENATED MODULE: ./node_modules/.pnpm/react-intersection-observer@9.13.1_react-dom@18.3.1_react@18.3.1/node_modules/react-intersection-observer/dist/index.mjs
"use client";
var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);

// src/InView.tsx


// src/observe.ts
var observerMap = /* @__PURE__ */ new Map();
var RootIds = /* @__PURE__ */ new WeakMap();
var rootId = 0;
var unsupportedValue = void 0;
function defaultFallbackInView(inView) {
  unsupportedValue = inView;
}
function getRootId(root) {
  if (!root) return "0";
  if (RootIds.has(root)) return RootIds.get(root);
  rootId += 1;
  RootIds.set(root, rootId.toString());
  return RootIds.get(root);
}
function optionsToId(options) {
  return Object.keys(options).sort().filter(
    (key) => options[key] !== void 0
  ).map((key) => {
    return `${key}_${key === "root" ? getRootId(options.root) : options[key]}`;
  }).toString();
}
function createObserver(options) {
  const id = optionsToId(options);
  let instance = observerMap.get(id);
  if (!instance) {
    const elements = /* @__PURE__ */ new Map();
    let thresholds;
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        var _a;
        const inView = entry.isIntersecting && thresholds.some((threshold) => entry.intersectionRatio >= threshold);
        if (options.trackVisibility && typeof entry.isVisible === "undefined") {
          entry.isVisible = inView;
        }
        (_a = elements.get(entry.target)) == null ? void 0 : _a.forEach((callback) => {
          callback(inView, entry);
        });
      });
    }, options);
    thresholds = observer.thresholds || (Array.isArray(options.threshold) ? options.threshold : [options.threshold || 0]);
    instance = {
      id,
      observer,
      elements
    };
    observerMap.set(id, instance);
  }
  return instance;
}
function observe(element, callback, options = {}, fallbackInView = unsupportedValue) {
  if (typeof window.IntersectionObserver === "undefined" && fallbackInView !== void 0) {
    const bounds = element.getBoundingClientRect();
    callback(fallbackInView, {
      isIntersecting: fallbackInView,
      target: element,
      intersectionRatio: typeof options.threshold === "number" ? options.threshold : 0,
      time: 0,
      boundingClientRect: bounds,
      intersectionRect: bounds,
      rootBounds: bounds
    });
    return () => {
    };
  }
  const { id, observer, elements } = createObserver(options);
  const callbacks = elements.get(element) || [];
  if (!elements.has(element)) {
    elements.set(element, callbacks);
  }
  callbacks.push(callback);
  observer.observe(element);
  return function unobserve() {
    callbacks.splice(callbacks.indexOf(callback), 1);
    if (callbacks.length === 0) {
      elements.delete(element);
      observer.unobserve(element);
    }
    if (elements.size === 0) {
      observer.disconnect();
      observerMap.delete(id);
    }
  };
}

// src/InView.tsx
function isPlainChildren(props) {
  return typeof props.children !== "function";
}
var InView = class extends react.Component {
  constructor(props) {
    super(props);
    __publicField(this, "node", null);
    __publicField(this, "_unobserveCb", null);
    __publicField(this, "handleNode", (node) => {
      if (this.node) {
        this.unobserve();
        if (!node && !this.props.triggerOnce && !this.props.skip) {
          this.setState({ inView: !!this.props.initialInView, entry: void 0 });
        }
      }
      this.node = node ? node : null;
      this.observeNode();
    });
    __publicField(this, "handleChange", (inView, entry) => {
      if (inView && this.props.triggerOnce) {
        this.unobserve();
      }
      if (!isPlainChildren(this.props)) {
        this.setState({ inView, entry });
      }
      if (this.props.onChange) {
        this.props.onChange(inView, entry);
      }
    });
    this.state = {
      inView: !!props.initialInView,
      entry: void 0
    };
  }
  componentDidMount() {
    this.unobserve();
    this.observeNode();
  }
  componentDidUpdate(prevProps) {
    if (prevProps.rootMargin !== this.props.rootMargin || prevProps.root !== this.props.root || prevProps.threshold !== this.props.threshold || prevProps.skip !== this.props.skip || prevProps.trackVisibility !== this.props.trackVisibility || prevProps.delay !== this.props.delay) {
      this.unobserve();
      this.observeNode();
    }
  }
  componentWillUnmount() {
    this.unobserve();
  }
  observeNode() {
    if (!this.node || this.props.skip) return;
    const {
      threshold,
      root,
      rootMargin,
      trackVisibility,
      delay,
      fallbackInView
    } = this.props;
    this._unobserveCb = observe(
      this.node,
      this.handleChange,
      {
        threshold,
        root,
        rootMargin,
        // @ts-ignore
        trackVisibility,
        // @ts-ignore
        delay
      },
      fallbackInView
    );
  }
  unobserve() {
    if (this._unobserveCb) {
      this._unobserveCb();
      this._unobserveCb = null;
    }
  }
  render() {
    const { children } = this.props;
    if (typeof children === "function") {
      const { inView, entry } = this.state;
      return children({ inView, entry, ref: this.handleNode });
    }
    const {
      as,
      triggerOnce,
      threshold,
      root,
      rootMargin,
      onChange,
      skip,
      trackVisibility,
      delay,
      initialInView,
      fallbackInView,
      ...props
    } = this.props;
    return React.createElement(
      as || "div",
      { ref: this.handleNode, ...props },
      children
    );
  }
};

// src/useInView.tsx

function useInView({
  threshold,
  delay,
  trackVisibility,
  rootMargin,
  root,
  triggerOnce,
  skip,
  initialInView,
  fallbackInView,
  onChange
} = {}) {
  var _a;
  const [ref, setRef] = react.useState(null);
  const callback = react.useRef();
  const [state, setState] = react.useState({
    inView: !!initialInView,
    entry: void 0
  });
  callback.current = onChange;
  react.useEffect(
    () => {
      if (skip || !ref) return;
      let unobserve;
      unobserve = observe(
        ref,
        (inView, entry) => {
          setState({
            inView,
            entry
          });
          if (callback.current) callback.current(inView, entry);
          if (entry.isIntersecting && triggerOnce && unobserve) {
            unobserve();
            unobserve = void 0;
          }
        },
        {
          root,
          rootMargin,
          threshold,
          // @ts-ignore
          trackVisibility,
          // @ts-ignore
          delay
        },
        fallbackInView
      );
      return () => {
        if (unobserve) {
          unobserve();
        }
      };
    },
    // We break the rule here, because we aren't including the actual `threshold` variable
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
      // If the threshold is an array, convert it to a string, so it won't change between renders.
      Array.isArray(threshold) ? threshold.toString() : threshold,
      ref,
      root,
      rootMargin,
      triggerOnce,
      skip,
      trackVisibility,
      fallbackInView,
      delay
    ]
  );
  const entryTarget = (_a = state.entry) == null ? void 0 : _a.target;
  const previousEntryTarget = react.useRef();
  if (!ref && entryTarget && !triggerOnce && !skip && previousEntryTarget.current !== entryTarget) {
    previousEntryTarget.current = entryTarget;
    setState({
      inView: !!initialInView,
      entry: void 0
    });
  }
  const result = [setRef, state.inView, state.entry];
  result.ref = result[0];
  result.inView = result[1];
  result.entry = result[2];
  return result;
}

//# sourceMappingURL=index.mjs.map
// EXTERNAL MODULE: ./node_modules/.pnpm/react-dom@18.3.1_react@18.3.1/node_modules/react-dom/index.js
var react_dom = __webpack_require__(30967);
;// CONCATENATED MODULE: ./node_modules/.pnpm/@bucketplace+design-system@5.3.3_@bucketplace+ui@1.0.9_@emotion+react@11.13.3_@emotion+styled_gws5alfnqy5ixwsabrkna3jsv4/node_modules/@bucketplace/design-system/dist/esm/common.js






function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _wrapRegExp() {
  _wrapRegExp = function (e, r) {
    return new BabelRegExp(e, void 0, r);
  };
  var e = RegExp.prototype,
    r = new WeakMap();
  function BabelRegExp(e, t, p) {
    var o = new RegExp(e, t);
    return r.set(o, p || r.get(e)), _setPrototypeOf(o, BabelRegExp.prototype);
  }
  function buildGroups(e, t) {
    var p = r.get(t);
    return Object.keys(p).reduce(function (r, t) {
      var o = p[t];
      if ("number" == typeof o) r[t] = e[o];else {
        for (var i = 0; void 0 === e[o[i]] && i + 1 < o.length;) i++;
        r[t] = e[o[i]];
      }
      return r;
    }, Object.create(null));
  }
  return _inherits(BabelRegExp, RegExp), BabelRegExp.prototype.exec = function (r) {
    var t = e.exec.call(this, r);
    if (t) {
      t.groups = buildGroups(t, this);
      var p = t.indices;
      p && (p.groups = buildGroups(p, this));
    }
    return t;
  }, BabelRegExp.prototype[Symbol.replace] = function (t, p) {
    if ("string" == typeof p) {
      var o = r.get(this);
      return e[Symbol.replace].call(this, t, p.replace(/\$<([^>]+)>/g, function (e, r) {
        var t = o[r];
        return "$" + (Array.isArray(t) ? t.join("$") : t);
      }));
    }
    if ("function" == typeof p) {
      var i = this;
      return e[Symbol.replace].call(this, t, function () {
        var e = arguments;
        return "object" != typeof e[e.length - 1] && (e = [].slice.call(e)).push(buildGroups(e, i)), p.apply(this, e);
      });
    }
    return e[Symbol.replace].call(this, t, p);
  }, _wrapRegExp.apply(this, arguments);
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  Object.defineProperty(subClass, "prototype", {
    writable: false
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return _setPrototypeOf(o, p);
}

var _assign = function __assign() {
  _assign = Object.assign || function __assign(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return _assign.apply(this, arguments);
};
function __rest(s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
}
function __awaiter(thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
}
function __generator(thisArg, body) {
  var _ = {
      label: 0,
      sent: function sent() {
        if (t[0] & 1) throw t[1];
        return t[1];
      },
      trys: [],
      ops: []
    },
    f,
    y,
    t,
    g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;
  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }
  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");
    while (g && (g = 0, op[0] && (_ = 0)), _) try {
      if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
      if (y = 0, t) op = [op[0] & 2, t.value];
      switch (op[0]) {
        case 0:
        case 1:
          t = op;
          break;
        case 4:
          _.label++;
          return {
            value: op[1],
            done: false
          };
        case 5:
          _.label++;
          y = op[1];
          op = [0];
          continue;
        case 7:
          op = _.ops.pop();
          _.trys.pop();
          continue;
        default:
          if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
            _ = 0;
            continue;
          }
          if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
            _.label = op[1];
            break;
          }
          if (op[0] === 6 && _.label < t[1]) {
            _.label = t[1];
            t = op;
            break;
          }
          if (t && _.label < t[2]) {
            _.label = t[2];
            _.ops.push(op);
            break;
          }
          if (t[2]) _.ops.pop();
          _.trys.pop();
          continue;
      }
      op = body.call(thisArg, _);
    } catch (e) {
      op = [6, e];
      y = 0;
    } finally {
      f = t = 0;
    }
    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
}
function __spreadArray(to, from, pack) {
  if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
    if (ar || !(i in from)) {
      if (!ar) ar = Array.prototype.slice.call(from, 0, i);
      ar[i] = from[i];
    }
  }
  return to.concat(ar || Array.prototype.slice.call(from));
}
function __makeTemplateObject(cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
}
typeof SuppressedError === "function" ? SuppressedError : function (error, suppressed, message) {
  var e = new Error(message);
  return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};

var common_IntersectionObserver = function IntersectionObserver(_a) {
  var children = _a.children,
    onIntersect = _a.onIntersect,
    style = _a.style,
    className = _a.className,
    options = __rest(_a, ["children", "onIntersect", "style", "className"]);
  var _b = useInView(_assign({
      triggerOnce: true,
      threshold: 0.5
    }, options)),
    ref = _b.ref,
    inView = _b.inView;
  (0,react.useEffect)(function () {
    if (inView) {
      onIntersect();
    }
  }, [inView, onIntersect]);
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", _assign({
    ref: ref,
    css: /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["height: inherit; display: block;" + ( true ? "" : 0)], ["height: inherit; display: block;" + ( true ? "" : 0)]))),
    style: style,
    className: className
  }, {
    children: children
  }));
};
var templateObject_1;

function Portal(_a) {
  var children = _a.children,
    container = _a.container;
  return /*#__PURE__*/(0,react_dom.createPortal)(children, container);
}

function BodyPortal(_a) {
  var children = _a.children;
  var _b = (0,react.useState)(false),
    mounted = _b[0],
    setMounted = _b[1];
  (0,react.useEffect)(function () {
    setMounted(true);
    return function () {
      setMounted(false);
    };
  }, []);
  return mounted ? (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Portal, _assign({
    container: document.body
  }, {
    children: children
  })) : (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {});
}

var ZINDEX = {
  dropdown: 900,
  banner: 1000,
  appBar: 1100,
  drawer: 1200,
  modal: 1300,
  snackbar: 1400,
  tooltip: 1500
};

var OverlayContext = /*#__PURE__*/(0,react.createContext)(null);
function OverlayProvider(_a) {
  var children = _a.children;
  var _b = (0,react.useState)(null),
    container = _b[0],
    setContainer = _b[1];
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(OverlayContext.Provider, _assign({
    value: container
  }, {
    children: [children, (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(BodyPortal, {
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
        ref: function ref(container) {
          if (container !== null) {
            setContainer(container);
          }
        }
      })
    })]
  }));
}
function OverlayPortal(_a) {
  var children = _a.children;
  var container = (0,react.useContext)(OverlayContext);
  return container ? (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Portal, _assign({
    container: container
  }, {
    children: children
  })) : (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
    children: children
  });
}

function onCheckHandler(event, callback) {
  if (callback.onChange) {
    callback.onChange(event);
  }
  if (callback.onCheck) {
    callback.onCheck(event.target.checked);
  }
}

function onEnterHandler(event, callback) {
  if (callback.onKeyDown) {
    callback.onKeyDown(event);
  }
  if (callback.onEnter && event.code === 'Enter') {
    callback.onEnter(event);
  }
}

function onValueHandler(event, callback) {
  if (callback.onChange) {
    callback.onChange(event);
  }
  if (callback.onValue) {
    callback.onValue(event.target.value);
  }
}


//# sourceMappingURL=common.js.map


/***/ }),

/***/ 54939:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "B": function() { return /* binding */ BREAK_POINT; },
/* harmony export */   "D": function() { return /* binding */ DARK_THEME; },
/* harmony export */   "F": function() { return /* binding */ FONT_STYLE; },
/* harmony export */   "H": function() { return /* binding */ HOVER; },
/* harmony export */   "L": function() { return /* binding */ LIGHT_THEME; },
/* harmony export */   "M": function() { return /* binding */ MEDIA_QUERY; },
/* harmony export */   "O": function() { return /* binding */ ODS_FONT_STYLE; },
/* harmony export */   "R": function() { return /* binding */ RESET_BUTTON; },
/* harmony export */   "S": function() { return /* binding */ SHADOW_STYLE; },
/* harmony export */   "a": function() { return /* binding */ RESET_INPUT; },
/* harmony export */   "b": function() { return /* binding */ BREAK_POINT_NAMES; },
/* harmony export */   "g": function() { return /* binding */ FOCUS; },
/* harmony export */   "h": function() { return /* binding */ hexToRgba; },
/* harmony export */   "p": function() { return /* binding */ pxToRem; },
/* harmony export */   "r": function() { return /* binding */ rgba; },
/* harmony export */   "s": function() { return /* binding */ safeAreaInset; }
/* harmony export */ });
/* unused harmony exports G, P, c, d, e, f, i, j */
/* harmony import */ var _common_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(68479);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52814);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(75271);




function pxToRem(px) {
  return "".concat(px, "px");
}
function safeAreaInset(direction, cssProp) {
  return "\n    ".concat(cssProp, ": constant(safe-area-inset-").concat(direction, ");\n    ").concat(cssProp, ": env(safe-area-inset-").concat(direction, ");\n  ");
}
var BREAK_POINT_NAMES = ['mobile', 'tablet', 'laptop', 'desktop'];
var BREAK_POINT = {
  mobile: 0,
  tablet: 768,
  laptop: 1024,
  desktop: 1256
};
var MEDIA_QUERY = {
  min: function min(breakPoint, arg) {
    return /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_1__/* .css */ .iv)(templateObject_1$3 || (templateObject_1$3 = (0,_common_js__WEBPACK_IMPORTED_MODULE_2__._)(["\n    @media (min-width: ", "px) {\n      ", "\n    }\n  " + ( true ? "" : 0)], ["\n    @media (min-width: ", "px) {\n      ", "\n    }\n  " + ( true ? "" : 0)])), BREAK_POINT[breakPoint], arg);
  },
  max: function max(breakPoint, arg) {
    var nextValue = BREAK_POINT[BREAK_POINT_NAMES[BREAK_POINT_NAMES.indexOf(breakPoint) + 1]];
    if (nextValue == null) {
      return /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_1__/* .css */ .iv)(templateObject_2$3 || (templateObject_2$3 = (0,_common_js__WEBPACK_IMPORTED_MODULE_2__._)(["", "" + ( true ? "" : 0)], ["", "" + ( true ? "" : 0)])), arg);
    }
    return /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_1__/* .css */ .iv)(templateObject_3$2 || (templateObject_3$2 = (0,_common_js__WEBPACK_IMPORTED_MODULE_2__._)(["\n      @media (max-width: ", "px) {\n        ", "\n      }\n    " + ( true ? "" : 0)], ["\n      @media (max-width: ", "px) {\n        ", "\n      }\n    " + ( true ? "" : 0)])), nextValue - 1, arg);
  },
  only: function only(breakPoint, arg) {
    var nextValue = BREAK_POINT[BREAK_POINT_NAMES[BREAK_POINT_NAMES.indexOf(breakPoint) + 1]];
    if (nextValue == null) {
      return MEDIA_QUERY.min(breakPoint, arg);
    }
    if (BREAK_POINT[breakPoint] === 0) {
      return MEDIA_QUERY.max(breakPoint, arg);
    }
    return /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_1__/* .css */ .iv)(templateObject_4$1 || (templateObject_4$1 = (0,_common_js__WEBPACK_IMPORTED_MODULE_2__._)(["\n      @media (min-width: ", "px) and (max-width: ", "px) {\n        ", "\n      }\n    " + ( true ? "" : 0)], ["\n      @media (min-width: ", "px) and (max-width: ", "px) {\n        ", "\n      }\n    " + ( true ? "" : 0)])), BREAK_POINT[breakPoint], nextValue - 1, arg);
  }
};
var templateObject_1$3, templateObject_2$3, templateObject_3$2, templateObject_4$1;

var BDS_FONT_STYLE = {
  /** @deprecated */
  largeTitle: /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_1__/* .css */ .iv)(templateObject_1$2 || (templateObject_1$2 = (0,_common_js__WEBPACK_IMPORTED_MODULE_2__._)(["\n    font-size: ", ";\n    line-height: ", ";\n  " + ( true ? "" : 0)], ["\n    font-size: ", ";\n    line-height: ", ";\n  " + ( true ? "" : 0)])), pxToRem(32), pxToRem(42)),
  /** @deprecated */
  title1: /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_1__/* .css */ .iv)(templateObject_2$2 || (templateObject_2$2 = (0,_common_js__WEBPACK_IMPORTED_MODULE_2__._)(["\n    font-size: ", ";\n    line-height: ", ";\n  " + ( true ? "" : 0)], ["\n    font-size: ", ";\n    line-height: ", ";\n  " + ( true ? "" : 0)])), pxToRem(24), pxToRem(32)),
  /** @deprecated */
  title2: /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_1__/* .css */ .iv)(templateObject_3$1 || (templateObject_3$1 = (0,_common_js__WEBPACK_IMPORTED_MODULE_2__._)(["\n    font-size: ", ";\n    line-height: ", ";\n  " + ( true ? "" : 0)], ["\n    font-size: ", ";\n    line-height: ", ";\n  " + ( true ? "" : 0)])), pxToRem(20), pxToRem(28)),
  /** @deprecated */
  title3: /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_1__/* .css */ .iv)(templateObject_4 || (templateObject_4 = (0,_common_js__WEBPACK_IMPORTED_MODULE_2__._)(["\n    font-size: ", ";\n    line-height: ", ";\n  " + ( true ? "" : 0)], ["\n    font-size: ", ";\n    line-height: ", ";\n  " + ( true ? "" : 0)])), pxToRem(18), pxToRem(24)),
  /** @deprecated */
  title4: /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_1__/* .css */ .iv)(templateObject_5 || (templateObject_5 = (0,_common_js__WEBPACK_IMPORTED_MODULE_2__._)(["\n    font-size: ", ";\n    line-height: ", ";\n  " + ( true ? "" : 0)], ["\n    font-size: ", ";\n    line-height: ", ";\n  " + ( true ? "" : 0)])), pxToRem(17), pxToRem(26)),
  /** @deprecated */
  subTitle1: /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_1__/* .css */ .iv)(templateObject_6 || (templateObject_6 = (0,_common_js__WEBPACK_IMPORTED_MODULE_2__._)(["\n    font-size: ", ";\n    line-height: ", ";\n  " + ( true ? "" : 0)], ["\n    font-size: ", ";\n    line-height: ", ";\n  " + ( true ? "" : 0)])), pxToRem(16), pxToRem(20)),
  /** @deprecated */
  subTitle2: /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_1__/* .css */ .iv)(templateObject_7 || (templateObject_7 = (0,_common_js__WEBPACK_IMPORTED_MODULE_2__._)(["\n    font-size: ", ";\n    line-height: ", ";\n  " + ( true ? "" : 0)], ["\n    font-size: ", ";\n    line-height: ", ";\n  " + ( true ? "" : 0)])), pxToRem(14), pxToRem(18)),
  /** @deprecated */
  body1_1: /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_1__/* .css */ .iv)(templateObject_8 || (templateObject_8 = (0,_common_js__WEBPACK_IMPORTED_MODULE_2__._)(["\n    font-size: ", ";\n    line-height: ", ";\n  " + ( true ? "" : 0)], ["\n    font-size: ", ";\n    line-height: ", ";\n  " + ( true ? "" : 0)])), pxToRem(16), pxToRem(24)),
  /** @deprecated */
  body1_2: /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_1__/* .css */ .iv)(templateObject_9 || (templateObject_9 = (0,_common_js__WEBPACK_IMPORTED_MODULE_2__._)(["\n    font-size: ", ";\n    line-height: ", ";\n  " + ( true ? "" : 0)], ["\n    font-size: ", ";\n    line-height: ", ";\n  " + ( true ? "" : 0)])), pxToRem(16), pxToRem(28)),
  /** @deprecated */
  body1_3: /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_1__/* .css */ .iv)(templateObject_10 || (templateObject_10 = (0,_common_js__WEBPACK_IMPORTED_MODULE_2__._)(["\n    font-size: ", ";\n    line-height: ", ";\n  " + ( true ? "" : 0)], ["\n    font-size: ", ";\n    line-height: ", ";\n  " + ( true ? "" : 0)])), pxToRem(16), pxToRem(32)),
  /** @deprecated */
  body1_small: /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_1__/* .css */ .iv)(templateObject_11 || (templateObject_11 = (0,_common_js__WEBPACK_IMPORTED_MODULE_2__._)(["\n    font-size: ", ";\n    line-height: ", ";\n  " + ( true ? "" : 0)], ["\n    font-size: ", ";\n    line-height: ", ";\n  " + ( true ? "" : 0)])), pxToRem(15), pxToRem(24)),
  /** @deprecated */
  body2: /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_1__/* .css */ .iv)(templateObject_12 || (templateObject_12 = (0,_common_js__WEBPACK_IMPORTED_MODULE_2__._)(["\n    font-size: ", ";\n    line-height: ", ";\n  " + ( true ? "" : 0)], ["\n    font-size: ", ";\n    line-height: ", ";\n  " + ( true ? "" : 0)])), pxToRem(14), pxToRem(20)),
  /** @deprecated */
  body2_small: /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_1__/* .css */ .iv)(templateObject_13 || (templateObject_13 = (0,_common_js__WEBPACK_IMPORTED_MODULE_2__._)(["\n    font-size: ", ";\n    line-height: ", ";\n  " + ( true ? "" : 0)], ["\n    font-size: ", ";\n    line-height: ", ";\n  " + ( true ? "" : 0)])), pxToRem(13), pxToRem(18)),
  /** @deprecated */
  body3: /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_1__/* .css */ .iv)(templateObject_14 || (templateObject_14 = (0,_common_js__WEBPACK_IMPORTED_MODULE_2__._)(["\n    font-size: ", ";\n    line-height: ", ";\n  " + ( true ? "" : 0)], ["\n    font-size: ", ";\n    line-height: ", ";\n  " + ( true ? "" : 0)])), pxToRem(12), pxToRem(20)),
  /** @deprecated */
  caption1: /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_1__/* .css */ .iv)(templateObject_15 || (templateObject_15 = (0,_common_js__WEBPACK_IMPORTED_MODULE_2__._)(["\n    font-size: ", ";\n    line-height: ", ";\n  " + ( true ? "" : 0)], ["\n    font-size: ", ";\n    line-height: ", ";\n  " + ( true ? "" : 0)])), pxToRem(12), pxToRem(16)),
  /** @deprecated */
  caption1_small: /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_1__/* .css */ .iv)(templateObject_16 || (templateObject_16 = (0,_common_js__WEBPACK_IMPORTED_MODULE_2__._)(["\n    font-size: ", ";\n    line-height: ", ";\n  " + ( true ? "" : 0)], ["\n    font-size: ", ";\n    line-height: ", ";\n  " + ( true ? "" : 0)])), pxToRem(11), pxToRem(14)),
  /** @deprecated */
  caption2: /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_1__/* .css */ .iv)(templateObject_17 || (templateObject_17 = (0,_common_js__WEBPACK_IMPORTED_MODULE_2__._)(["\n    font-size: ", ";\n    line-height: ", ";\n  " + ( true ? "" : 0)], ["\n    font-size: ", ";\n    line-height: ", ";\n  " + ( true ? "" : 0)])), pxToRem(10), pxToRem(14))
};
var ODS_FONT_STYLE = {
  heading32: /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_1__/* .css */ .iv)(templateObject_18 || (templateObject_18 = (0,_common_js__WEBPACK_IMPORTED_MODULE_2__._)(["\n    font-size: ", ";\n    line-height: ", ";\n  " + ( true ? "" : 0)], ["\n    font-size: ", ";\n    line-height: ", ";\n  " + ( true ? "" : 0)])), pxToRem(32), pxToRem(42)),
  heading24: /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_1__/* .css */ .iv)(templateObject_19 || (templateObject_19 = (0,_common_js__WEBPACK_IMPORTED_MODULE_2__._)(["\n    font-size: ", ";\n    line-height: ", ";\n  " + ( true ? "" : 0)], ["\n    font-size: ", ";\n    line-height: ", ";\n  " + ( true ? "" : 0)])), pxToRem(24), pxToRem(32)),
  heading20: /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_1__/* .css */ .iv)(templateObject_20 || (templateObject_20 = (0,_common_js__WEBPACK_IMPORTED_MODULE_2__._)(["\n    font-size: ", ";\n    line-height: ", ";\n  " + ( true ? "" : 0)], ["\n    font-size: ", ";\n    line-height: ", ";\n  " + ( true ? "" : 0)])), pxToRem(20), pxToRem(28)),
  heading18: /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_1__/* .css */ .iv)(templateObject_21 || (templateObject_21 = (0,_common_js__WEBPACK_IMPORTED_MODULE_2__._)(["\n    font-size: ", ";\n    line-height: ", ";\n  " + ( true ? "" : 0)], ["\n    font-size: ", ";\n    line-height: ", ";\n  " + ( true ? "" : 0)])), pxToRem(18), pxToRem(24)),
  heading17: /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_1__/* .css */ .iv)(templateObject_22 || (templateObject_22 = (0,_common_js__WEBPACK_IMPORTED_MODULE_2__._)(["\n    font-size: ", ";\n    line-height: ", ";\n  " + ( true ? "" : 0)], ["\n    font-size: ", ";\n    line-height: ", ";\n  " + ( true ? "" : 0)])), pxToRem(17), pxToRem(26)),
  body16L28: /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_1__/* .css */ .iv)(templateObject_23 || (templateObject_23 = (0,_common_js__WEBPACK_IMPORTED_MODULE_2__._)(["\n    font-size: ", ";\n    line-height: ", ";\n  " + ( true ? "" : 0)], ["\n    font-size: ", ";\n    line-height: ", ";\n  " + ( true ? "" : 0)])), pxToRem(16), pxToRem(28)),
  body16L24: /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_1__/* .css */ .iv)(templateObject_24 || (templateObject_24 = (0,_common_js__WEBPACK_IMPORTED_MODULE_2__._)(["\n    font-size: ", ";\n    line-height: ", ";\n  " + ( true ? "" : 0)], ["\n    font-size: ", ";\n    line-height: ", ";\n  " + ( true ? "" : 0)])), pxToRem(16), pxToRem(24)),
  body16L20: /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_1__/* .css */ .iv)(templateObject_25 || (templateObject_25 = (0,_common_js__WEBPACK_IMPORTED_MODULE_2__._)(["\n    font-size: ", ";\n    line-height: ", ";\n  " + ( true ? "" : 0)], ["\n    font-size: ", ";\n    line-height: ", ";\n  " + ( true ? "" : 0)])), pxToRem(16), pxToRem(20)),
  body15L24: /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_1__/* .css */ .iv)(templateObject_26 || (templateObject_26 = (0,_common_js__WEBPACK_IMPORTED_MODULE_2__._)(["\n    font-size: ", ";\n    line-height: ", ";\n  " + ( true ? "" : 0)], ["\n    font-size: ", ";\n    line-height: ", ";\n  " + ( true ? "" : 0)])), pxToRem(15), pxToRem(24)),
  body14L20: /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_1__/* .css */ .iv)(templateObject_27 || (templateObject_27 = (0,_common_js__WEBPACK_IMPORTED_MODULE_2__._)(["\n    font-size: ", ";\n    line-height: ", ";\n  " + ( true ? "" : 0)], ["\n    font-size: ", ";\n    line-height: ", ";\n  " + ( true ? "" : 0)])), pxToRem(14), pxToRem(20)),
  body14L18: /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_1__/* .css */ .iv)(templateObject_28 || (templateObject_28 = (0,_common_js__WEBPACK_IMPORTED_MODULE_2__._)(["\n    font-size: ", "; \n    line-height: ", ";\n  " + ( true ? "" : 0)], ["\n    font-size: ", "; \n    line-height: ", ";\n  " + ( true ? "" : 0)])), pxToRem(14), pxToRem(18)),
  detail13L18: /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_1__/* .css */ .iv)(templateObject_29 || (templateObject_29 = (0,_common_js__WEBPACK_IMPORTED_MODULE_2__._)(["\n    font-size: ", ";\n    line-height: ", ";\n  " + ( true ? "" : 0)], ["\n    font-size: ", ";\n    line-height: ", ";\n  " + ( true ? "" : 0)])), pxToRem(13), pxToRem(18)),
  detail12L20: /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_1__/* .css */ .iv)(templateObject_30 || (templateObject_30 = (0,_common_js__WEBPACK_IMPORTED_MODULE_2__._)(["\n    font-size: ", ";\n    line-height: ", ";\n  " + ( true ? "" : 0)], ["\n    font-size: ", ";\n    line-height: ", ";\n  " + ( true ? "" : 0)])), pxToRem(12), pxToRem(20)),
  detail12L16: /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_1__/* .css */ .iv)(templateObject_31 || (templateObject_31 = (0,_common_js__WEBPACK_IMPORTED_MODULE_2__._)(["\n    font-size: ", ";\n    line-height: ", ";\n  " + ( true ? "" : 0)], ["\n    font-size: ", ";\n    line-height: ", ";\n  " + ( true ? "" : 0)])), pxToRem(12), pxToRem(16)),
  detail11L14: /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_1__/* .css */ .iv)(templateObject_32 || (templateObject_32 = (0,_common_js__WEBPACK_IMPORTED_MODULE_2__._)(["\n    font-size: ", ";\n    line-height: ", ";\n  " + ( true ? "" : 0)], ["\n    font-size: ", ";\n    line-height: ", ";\n  " + ( true ? "" : 0)])), pxToRem(11), pxToRem(14)),
  detail10L14: /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_1__/* .css */ .iv)(templateObject_33 || (templateObject_33 = (0,_common_js__WEBPACK_IMPORTED_MODULE_2__._)(["\n    font-size: ", ";\n    line-height: ", ";\n  " + ( true ? "" : 0)], ["\n    font-size: ", ";\n    line-height: ", ";\n  " + ( true ? "" : 0)])), pxToRem(10), pxToRem(14))
};
var FONT_STYLE = (0,_common_js__WEBPACK_IMPORTED_MODULE_2__.a)((0,_common_js__WEBPACK_IMPORTED_MODULE_2__.a)({}, BDS_FONT_STYLE), ODS_FONT_STYLE);
var templateObject_1$2, templateObject_2$2, templateObject_3$1, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13, templateObject_14, templateObject_15, templateObject_16, templateObject_17, templateObject_18, templateObject_19, templateObject_20, templateObject_21, templateObject_22, templateObject_23, templateObject_24, templateObject_25, templateObject_26, templateObject_27, templateObject_28, templateObject_29, templateObject_30, templateObject_31, templateObject_32, templateObject_33;

var PALETTE = {
  skyblue: {
    50: '#ECF7FC',
    100: '#DFF2FA',
    150: '#CCECF9',
    200: '#AFE4F9',
    250: '#8CDBF7',
    300: '#5ED1F8',
    350: '#35C5F0',
    400: '#2EB0D6',
    450: '#259ABD',
    500: '#2188A7',
    550: '#1A7590',
    600: '#16637A',
    650: '#104F62',
    700: '#0C4151',
    750: '#073340',
    800: '#052833',
    850: '#041F28',
    900: '#03171E',
    950: '#021116'
  },
  gray: {
    50: '#F5F5F5',
    100: '#EEEEEE',
    150: '#E6E6E6',
    200: '#DBDBDB',
    250: '#CECECE',
    300: '#C1C1C1',
    350: '#B1B1B1',
    400: '#A0A0A0',
    450: '#8C8C8C',
    500: '#7C7C7C',
    550: '#6A6A6A',
    600: '#595959',
    650: '#484848',
    700: '#3A3A3A',
    750: '#2E2E2E',
    800: '#242424',
    850: '#1C1C1C',
    900: '#141414',
    950: '#0E0E0E'
  },
  blue: {
    50: '#F0F6FC',
    100: '#E5F0FB',
    150: '#D6E9FB',
    200: '#C1DFFB',
    250: '#A8D3FC',
    300: '#8DC7FD',
    350: '#67B8FF',
    400: '#36A6FF',
    450: '#0097F5',
    500: '#0280D1',
    550: '#006EB5',
    600: '#025D99',
    650: '#014A7D',
    700: '#013D67',
    750: '#003053',
    800: '#002643',
    850: '#011D35',
    900: '#011528',
    950: '#010F1E'
  },
  red: {
    50: '#FCF3F1',
    100: '#FAEAE8',
    150: '#FADFDB',
    200: '#FACFC9',
    250: '#FBBCB4',
    300: '#FCA89E',
    350: '#FE8B81',
    400: '#FD6868',
    450: '#FD2840',
    500: '#E30F32',
    550: '#C60D2A',
    600: '#A80822',
    650: '#89051A',
    700: '#720414',
    750: '#5C020C',
    800: '#4A0205',
    850: '#3B0301',
    900: '#290601',
    950: '#1F0501'
  },
  yellow: {
    50: '#FFF5D7',
    100: '#FFEEBF',
    150: '#FFE4A1',
    200: '#FFD577',
    250: '#FFC33A',
    300: '#F7B401',
    350: '#E6A306',
    400: '#D39104',
    450: '#BC7E02',
    500: '#A96D01',
    550: '#935D03',
    600: '#7F4C00',
    650: '#683C01',
    700: '#573001',
    750: '#462401',
    800: '#391B00',
    850: '#2E1300',
    900: '#230D00',
    950: '#1C0800'
  },
  blackAlpha: {
    50: 'rgba(0, 0, 0, 0.05)',
    100: 'rgba(0, 0, 0, 0.1)',
    150: 'rgba(0, 0, 0, 0.15)',
    200: 'rgba(0, 0, 0, 0.2)',
    250: 'rgba(0, 0, 0, 0.25)',
    300: 'rgba(0, 0, 0, 0.3)',
    350: 'rgba(0, 0, 0, 0.35)',
    400: 'rgba(0, 0, 0, 0.4)',
    450: 'rgba(0, 0, 0, 0.45)',
    500: 'rgba(0, 0, 0, 0.5)',
    550: 'rgba(0, 0, 0, 0.55)',
    600: 'rgba(0, 0, 0, 0.6)',
    650: 'rgba(0, 0, 0, 0.65)',
    700: 'rgba(0, 0, 0, 0.7)',
    750: 'rgba(0, 0, 0, 0.75)',
    800: 'rgba(0, 0, 0, 0.8)',
    850: 'rgba(0, 0, 0, 0.85)',
    900: 'rgba(0, 0, 0, 0.9)',
    950: 'rgba(0, 0, 0, 0.95)'
  },
  whiteAlpha: {
    50: 'rgba(255, 255, 255, 0.05)',
    100: 'rgba(255, 255, 255, 0.1)',
    150: 'rgba(255, 255, 255, 0.15)',
    200: 'rgba(255, 255, 255, 0.2)',
    250: 'rgba(255, 255, 255, 0.25)',
    300: 'rgba(255, 255, 255, 0.3)',
    350: 'rgba(255, 255, 255, 0.35)',
    400: 'rgba(255, 255, 255, 0.4)',
    450: 'rgba(255, 255, 255, 0.45)',
    500: 'rgba(255, 255, 255, 0.5)',
    550: 'rgba(255, 255, 255, 0.55)',
    600: 'rgba(255, 255, 255, 0.6)',
    650: 'rgba(255, 255, 255, 0.65)',
    700: 'rgba(255, 255, 255, 0.7)',
    750: 'rgba(255, 255, 255, 0.75)',
    800: 'rgba(255, 255, 255, 0.8)',
    850: 'rgba(255, 255, 255, 0.85)',
    900: 'rgba(255, 255, 255, 0.9)',
    950: 'rgba(255, 255, 255, 0.95)'
  },
  white: '#FFFFFF',
  black: '#000000'
};
/** @deprecated */
var LEGACY_PALETTE = {
  white: '#FFFFFF',
  black: '#000000',
  transparent: 'transparent',
  skyblue50: '#EFFBFF',
  skyblue100: '#E5F8FF',
  skyblue200: '#C7EFFB',
  skyblue300: '#AEE7F8',
  skyblue400: '#77D7F4',
  skyblue500: '#35C5F0',
  skyblue600: '#009FCE',
  skyblue700: '#0080A3',
  skyblue800: '#005364',
  skyblue900: '#003640',
  blue50: '#E3F3FD',
  blue100: '#C5E4FD',
  blue200: '#70BFFD',
  blue300: '#1494FD',
  blue400: '#0987DC',
  blue500: '#0987D1',
  blue600: '#09609C',
  blue700: '#004E83',
  blue800: '#003D63',
  blue900: '#002F43',
  indigo50: '#F7FAFF',
  indigo100: '#D9E6FF',
  indigo200: '#BDD4FF',
  indigo300: '#87B1FF',
  indigo400: '#6391E6',
  indigo500: '#4F78C2',
  indigo600: '#4566A3',
  indigo700: '#37507D',
  indigo800: '#22314D',
  indigo900: '#192438',
  red50: '#FFF6F6',
  red100: '#FFEDED',
  red200: '#FFD9D9',
  red300: '#FFB2B2',
  red400: '#FF9494',
  red500: '#FF7777',
  red600: '#F05656',
  red700: '#DB3D3D',
  red800: '#552222',
  red900: '#331818',
  gray50: '#F7F9FA',
  gray100: '#F4F7F8',
  gray200: '#EAEDEF',
  gray250: '#DADDE0',
  gray300: '#C2C8CC',
  gray350: '#A4ACB3',
  gray400: '#828C94',
  gray500: '#656E75',
  gray600: '#525B61',
  gray650: '#3F474D',
  gray700: '#2F3438',
  gray800: '#212629',
  gray900: '#131517',
  elevation0: '#0B0C0E',
  elevation10: '#17181A',
  elevation20: '#1C1D1F',
  elevation30: '#1F1F21',
  elevation40: '#212224',
  elevation50: '#262729',
  elevation60: '#28292B',
  elevation70: '#2D2E30',
  elevation80: '#303032',
  elevation90: '#323335',
  elevation100: '#3C3D3E'
};

var RESET_BUTTON = "\n  display: inline-block;\n  margin: 0;\n  padding: 0;\n  border: none;\n  background: none;\n  font: inherit;\n";
var RESET_INPUT = "\n  display: inline-block;\n  margin: 0;\n  padding: 0;\n  border: none;\n  background: none;\n  font: inherit;\n";

function rgba(r, g, b, a) {
  return "rgba(".concat(r, ", ").concat(g, ", ").concat(b, ", ").concat(a, ")");
}
function hexToRgba(hex, opacity) {
  var r = parseInt(hex.slice(1, 3), 16);
  var g = parseInt(hex.slice(3, 5), 16);
  var b = parseInt(hex.slice(5, 7), 16);
  return rgba(r, g, b, opacity);
}
var DEPRECATED_KEYS = (/* unused pure expression or super */ null && (['thin', 'thick', 'content', 'interactive']));
var LIGHT_THEME = {
  mode: 'light',
  colors: {
    background: PALETTE.white,
    backgroundWeak: LEGACY_PALETTE.gray50,
    backgroundDisabled: LEGACY_PALETTE.gray200,
    backgroundInverse: LEGACY_PALETTE.gray700,
    backgroundBrand: LEGACY_PALETTE.skyblue500,
    backgroundBrandStrong: LEGACY_PALETTE.skyblue600,
    backgroundBrandWeak: LEGACY_PALETTE.skyblue50,
    backgroundEmphasis: PALETTE.blue[400],
    backgroundEmphasisWeak: PALETTE.blue[50],
    backgroundCritical: LEGACY_PALETTE.red500,
    backgroundCriticalWeak: LEGACY_PALETTE.red100,
    backgroundDim: PALETTE.blackAlpha[400],
    backgroundOverlay: PALETTE.blackAlpha[50],
    backgroundAttention: PALETTE.yellow[400],
    backgroundAttentionWeak: PALETTE.yellow[50],
    backgroundBrandO2OResponsibility: '#12B667',
    border: LEGACY_PALETTE.gray200,
    borderStrong: LEGACY_PALETTE.gray700,
    borderInverse: PALETTE.white,
    borderBrand: LEGACY_PALETTE.skyblue500,
    borderEmphasis: PALETTE.blue[400],
    borderCritical: LEGACY_PALETTE.red500,
    borderAttention: PALETTE.yellow[400],
    borderBrandO2OResponsibility: '#12B667',
    foreground: LEGACY_PALETTE.gray700,
    foregroundWeak: LEGACY_PALETTE.gray400,
    foregroundDisabled: LEGACY_PALETTE.gray300,
    foregroundInverse: PALETTE.white,
    foregroundBrand: LEGACY_PALETTE.skyblue500,
    foregroundEmphasis: PALETTE.blue[400],
    foregroundCritical: LEGACY_PALETTE.red600,
    foregroundAttention: PALETTE.yellow[450],
    foregroundBrandO2OResponsibility: '#12B667'
  },
  /** @deprecated */
  background: {
    base: LEGACY_PALETTE.white,
    groupedBase: LEGACY_PALETTE.gray50,
    groupedContents: LEGACY_PALETTE.white,
    elevated: LEGACY_PALETTE.white
  },
  /** @deprecated */
  layer: {
    dark: LEGACY_PALETTE.gray700,
    light: LEGACY_PALETTE.white
  },
  /** @deprecated */
  divider: LEGACY_PALETTE.gray200,
  /** @deprecated */
  dim: {
    thin: hexToRgba(LEGACY_PALETTE.gray800, 0.15),
    thick: hexToRgba(LEGACY_PALETTE.gray800, 0.8),
    basic: hexToRgba(LEGACY_PALETTE.gray800, 0.5),
    disabled: hexToRgba(LEGACY_PALETTE.gray500, 0.75),
    thumbnail: hexToRgba(LEGACY_PALETTE.gray800, 0.05),
    lighten: hexToRgba(LEGACY_PALETTE.gray800, 0.15),
    darken: hexToRgba(LEGACY_PALETTE.gray800, 0.8),
    onDark: {
      thick: hexToRgba(LEGACY_PALETTE.white, 0.7),
      basic: hexToRgba(LEGACY_PALETTE.white, 0.5),
      thin: hexToRgba(LEGACY_PALETTE.white, 0.15),
      heavy: hexToRgba(LEGACY_PALETTE.white, 0.9)
    }
  },
  /** @deprecated */
  content: {
    base0: LEGACY_PALETTE.black,
    base1: LEGACY_PALETTE.gray700,
    base2: LEGACY_PALETTE.gray400,
    base3: LEGACY_PALETTE.gray300,
    base4: LEGACY_PALETTE.gray200,
    base4Second: LEGACY_PALETTE.gray100,
    base5: LEGACY_PALETTE.gray50,
    base6: LEGACY_PALETTE.white,
    white: LEGACY_PALETTE.white,
    primary1: {
      thick: LEGACY_PALETTE.skyblue600,
      basic: LEGACY_PALETTE.skyblue500,
      thin: LEGACY_PALETTE.skyblue50
    },
    primary2: {
      thick: LEGACY_PALETTE.red600,
      basic: LEGACY_PALETTE.red500,
      thin: LEGACY_PALETTE.red100
    },
    primary3: {
      thick: LEGACY_PALETTE.blue700,
      basic: LEGACY_PALETTE.blue600,
      thin: LEGACY_PALETTE.blue50
    },
    primary4: {
      thick: LEGACY_PALETTE.indigo700,
      basic: LEGACY_PALETTE.indigo400,
      thin: LEGACY_PALETTE.indigo50
    }
  },
  /** @deprecated */
  shadow: {
    thick: hexToRgba(LEGACY_PALETTE.gray650, 0.25),
    thin: hexToRgba(LEGACY_PALETTE.gray650, 0.05),
    basic: hexToRgba(LEGACY_PALETTE.gray650, 0.15),
    lighten: hexToRgba(LEGACY_PALETTE.gray650, 0.05),
    darken: hexToRgba(LEGACY_PALETTE.gray650, 0.25)
  },
  /** @deprecated */
  interactive: {
    primary1: {
      thick: LEGACY_PALETTE.skyblue800,
      basic: LEGACY_PALETTE.skyblue600,
      thin: LEGACY_PALETTE.skyblue100,
      transparent: LEGACY_PALETTE.skyblue50
    },
    primary2: {
      thick: LEGACY_PALETTE.red700,
      basic: LEGACY_PALETTE.red600,
      thin: LEGACY_PALETTE.red200,
      transparent: LEGACY_PALETTE.red100
    },
    primary3: {
      thick: LEGACY_PALETTE.blue800,
      basic: LEGACY_PALETTE.blue700,
      thin: LEGACY_PALETTE.blue100,
      transparent: LEGACY_PALETTE.blue50
    },
    primary4: {
      thick: LEGACY_PALETTE.indigo800,
      basic: LEGACY_PALETTE.indigo500,
      thin: LEGACY_PALETTE.indigo200,
      transparent: LEGACY_PALETTE.indigo50
    },
    transparent: LEGACY_PALETTE.gray50,
    onDark: hexToRgba(LEGACY_PALETTE.white, 0.1),
    base1: LEGACY_PALETTE.gray800,
    base2: LEGACY_PALETTE.gray500,
    base3: LEGACY_PALETTE.gray350,
    base4: LEGACY_PALETTE.gray250,
    base5: LEGACY_PALETTE.gray200,
    dim: {
      thick: hexToRgba(LEGACY_PALETTE.gray800, 0.9)
    }
  },
  /** @deprecated */
  outline: hexToRgba(LEGACY_PALETTE.black, 0.08),
  /** @deprecated */
  border: PALETTE.gray[150],
  /** @deprecated */
  disabled: {
    filled1: LEGACY_PALETTE.gray200,
    outlined1: LEGACY_PALETTE.gray50
  },
  /** @deprecated */
  base: {
    neutral0: LEGACY_PALETTE.white,
    neutral100: LEGACY_PALETTE.gray50,
    neutral200: LEGACY_PALETTE.gray100,
    neutral300: LEGACY_PALETTE.gray200,
    neutral400: LEGACY_PALETTE.gray300,
    neutral500: LEGACY_PALETTE.gray400,
    neutral600: LEGACY_PALETTE.gray700,
    neutral700: LEGACY_PALETTE.black
  },
  /** @deprecated */
  primary: {
    basic: LEGACY_PALETTE.skyblue500,
    lighten: LEGACY_PALETTE.skyblue50,
    darken: LEGACY_PALETTE.skyblue600
  },
  /** @deprecated */
  secondary: {
    basic: LEGACY_PALETTE.blue600,
    lighten: LEGACY_PALETTE.blue50,
    darken: LEGACY_PALETTE.blue700
  },
  /** @deprecated */
  tertiary: {
    basic: LEGACY_PALETTE.indigo400,
    lighten: LEGACY_PALETTE.indigo50,
    darken: LEGACY_PALETTE.indigo700
  },
  /** @deprecated */
  accent: {
    basic: LEGACY_PALETTE.red500,
    lighten: LEGACY_PALETTE.red100,
    darken: LEGACY_PALETTE.red600
  }
};
var DARK_THEME = {
  mode: 'dark',
  colors: {
    background: PALETTE.gray[950],
    backgroundWeak: PALETTE.gray[900],
    backgroundDisabled: PALETTE.gray[850],
    backgroundInverse: PALETTE.gray[50],
    backgroundBrand: PALETTE.skyblue[350],
    backgroundBrandStrong: PALETTE.skyblue[300],
    backgroundBrandWeak: PALETTE.skyblue[800],
    backgroundEmphasis: PALETTE.blue[450],
    backgroundEmphasisWeak: PALETTE.blue[800],
    backgroundCritical: PALETTE.red[450],
    backgroundCriticalWeak: PALETTE.red[800],
    backgroundDim: PALETTE.blackAlpha[800],
    backgroundOverlay: PALETTE.whiteAlpha[50],
    backgroundAttention: PALETTE.yellow[450],
    backgroundAttentionWeak: PALETTE.yellow[800],
    backgroundBrandO2OResponsibility: '#12B667',
    border: PALETTE.gray[750],
    borderStrong: PALETTE.gray[50],
    borderInverse: PALETTE.gray[950],
    borderBrand: PALETTE.skyblue[350],
    borderEmphasis: PALETTE.blue[450],
    borderCritical: PALETTE.red[450],
    borderAttention: PALETTE.yellow[450],
    borderBrandO2OResponsibility: '#12B667',
    foreground: PALETTE.gray[50],
    foregroundWeak: PALETTE.gray[300],
    foregroundDisabled: PALETTE.gray[500],
    foregroundInverse: PALETTE.gray[950],
    foregroundBrand: PALETTE.skyblue[350],
    foregroundEmphasis: PALETTE.blue[450],
    foregroundCritical: PALETTE.red[450],
    foregroundAttention: PALETTE.yellow[350],
    foregroundBrandO2OResponsibility: '#12B667'
  },
  /** @deprecated */
  background: {
    base: LEGACY_PALETTE.elevation10,
    groupedBase: LEGACY_PALETTE.elevation0,
    groupedContents: LEGACY_PALETTE.elevation10,
    elevated: LEGACY_PALETTE.elevation50
  },
  /** @deprecated */
  layer: {
    dark: LEGACY_PALETTE.gray650,
    light: LEGACY_PALETTE.gray650
  },
  /** @deprecated */
  divider: LEGACY_PALETTE.gray300,
  /** @deprecated */
  dim: {
    thick: hexToRgba(LEGACY_PALETTE.black, 0.75),
    thin: hexToRgba(LEGACY_PALETTE.black, 0.15),
    basic: hexToRgba(LEGACY_PALETTE.black, 0.5),
    lighten: hexToRgba(LEGACY_PALETTE.black, 0.15),
    darken: hexToRgba(LEGACY_PALETTE.black, 0.75),
    disabled: hexToRgba(LEGACY_PALETTE.gray500, 0.75),
    thumbnail: LEGACY_PALETTE.black,
    onDark: {
      thick: hexToRgba(LEGACY_PALETTE.white, 0.65),
      basic: hexToRgba(LEGACY_PALETTE.white, 0.5),
      thin: hexToRgba(LEGACY_PALETTE.white, 0.15),
      heavy: hexToRgba(LEGACY_PALETTE.white, 0.9)
    }
  },
  /** @deprecated */
  content: {
    base0: LEGACY_PALETTE.white,
    base1: LEGACY_PALETTE.gray50,
    base2: LEGACY_PALETTE.gray300,
    base3: LEGACY_PALETTE.gray400,
    base4: LEGACY_PALETTE.gray650,
    base4Second: LEGACY_PALETTE.gray700,
    base5: LEGACY_PALETTE.gray800,
    base6: LEGACY_PALETTE.gray900,
    white: LEGACY_PALETTE.gray50,
    primary1: {
      thick: LEGACY_PALETTE.skyblue300,
      basic: LEGACY_PALETTE.skyblue600,
      thin: LEGACY_PALETTE.skyblue900
    },
    primary2: {
      thick: LEGACY_PALETTE.red500,
      basic: LEGACY_PALETTE.red600,
      thin: LEGACY_PALETTE.red900
    },
    primary3: {
      thick: LEGACY_PALETTE.blue100,
      basic: LEGACY_PALETTE.blue500,
      thin: LEGACY_PALETTE.blue900
    },
    primary4: {
      thick: LEGACY_PALETTE.indigo400,
      basic: LEGACY_PALETTE.indigo700,
      thin: LEGACY_PALETTE.indigo900
    }
  },
  /** @deprecated */
  shadow: {
    thick: LEGACY_PALETTE.transparent,
    basic: LEGACY_PALETTE.transparent,
    thin: LEGACY_PALETTE.transparent,
    lighten: LEGACY_PALETTE.transparent,
    darken: LEGACY_PALETTE.transparent
  },
  /** @deprecated */
  interactive: {
    primary1: {
      thick: LEGACY_PALETTE.skyblue200,
      basic: LEGACY_PALETTE.skyblue500,
      thin: LEGACY_PALETTE.skyblue800,
      transparent: LEGACY_PALETTE.skyblue900
    },
    primary2: {
      thick: LEGACY_PALETTE.red400,
      basic: LEGACY_PALETTE.red500,
      thin: LEGACY_PALETTE.red800,
      transparent: LEGACY_PALETTE.red900
    },
    primary3: {
      thick: LEGACY_PALETTE.blue50,
      basic: LEGACY_PALETTE.blue300,
      thin: LEGACY_PALETTE.blue800,
      transparent: LEGACY_PALETTE.blue900
    },
    primary4: {
      thick: LEGACY_PALETTE.indigo300,
      basic: LEGACY_PALETTE.indigo600,
      thin: LEGACY_PALETTE.indigo800,
      transparent: LEGACY_PALETTE.indigo900
    },
    transparent: LEGACY_PALETTE.gray700,
    onDark: hexToRgba(LEGACY_PALETTE.white, 0.1),
    base1: LEGACY_PALETTE.white,
    base2: LEGACY_PALETTE.gray250,
    base3: LEGACY_PALETTE.gray350,
    base4: LEGACY_PALETTE.gray700,
    base5: LEGACY_PALETTE.gray700,
    dim: {
      thick: hexToRgba(LEGACY_PALETTE.black, 0.55)
    }
  },
  /** @deprecated */
  outline: hexToRgba(LEGACY_PALETTE.white, 0.12),
  /** @deprecated */
  border: PALETTE.gray[750],
  /** @deprecated */
  disabled: {
    filled1: LEGACY_PALETTE.elevation100,
    outlined1: LEGACY_PALETTE.transparent
  },
  /** @deprecated */
  base: {
    neutral0: LEGACY_PALETTE.gray900,
    neutral100: LEGACY_PALETTE.gray800,
    neutral200: LEGACY_PALETTE.gray700,
    neutral300: LEGACY_PALETTE.gray650,
    neutral400: LEGACY_PALETTE.gray400,
    neutral500: LEGACY_PALETTE.gray300,
    neutral600: LEGACY_PALETTE.gray50,
    neutral700: LEGACY_PALETTE.white
  },
  /** @deprecated */
  primary: {
    basic: LEGACY_PALETTE.skyblue600,
    lighten: LEGACY_PALETTE.skyblue900,
    darken: LEGACY_PALETTE.skyblue300
  },
  /** @deprecated */
  secondary: {
    basic: LEGACY_PALETTE.blue400,
    lighten: LEGACY_PALETTE.blue900,
    darken: LEGACY_PALETTE.blue100
  },
  /** @deprecated */
  tertiary: {
    basic: LEGACY_PALETTE.indigo700,
    lighten: LEGACY_PALETTE.indigo900,
    darken: LEGACY_PALETTE.indigo400
  },
  /** @deprecated */
  accent: {
    basic: LEGACY_PALETTE.red600,
    lighten: LEGACY_PALETTE.red900,
    darken: LEGACY_PALETTE.red500
  }
};

var SHADOW_STYLE = {
  depth10: function depth10(theme) {
    return /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_1__/* .css */ .iv)(templateObject_1$1 || (templateObject_1$1 = (0,_common_js__WEBPACK_IMPORTED_MODULE_2__._)(["\n      box-shadow: 0 ", " ", " ", ";\n    " + ( true ? "" : 0)], ["\n      box-shadow: 0 ", " ", " ", ";\n    " + ( true ? "" : 0)])), pxToRem(2), pxToRem(6), theme.shadow.thin);
  },
  depth20: function depth20(theme) {
    return /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_1__/* .css */ .iv)(templateObject_2$1 || (templateObject_2$1 = (0,_common_js__WEBPACK_IMPORTED_MODULE_2__._)(["\n      box-shadow: 0 ", " ", " ", ";\n    " + ( true ? "" : 0)], ["\n      box-shadow: 0 ", " ", " ", ";\n    " + ( true ? "" : 0)])), pxToRem(2), pxToRem(6), theme.shadow.basic);
  },
  depth30: function depth30(theme) {
    return /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_1__/* .css */ .iv)(templateObject_3 || (templateObject_3 = (0,_common_js__WEBPACK_IMPORTED_MODULE_2__._)(["\n      box-shadow: 0 ", " ", " ", ";\n    " + ( true ? "" : 0)], ["\n      box-shadow: 0 ", " ", " ", ";\n    " + ( true ? "" : 0)])), pxToRem(2), pxToRem(10), theme.shadow.thick);
  }
};
var templateObject_1$1, templateObject_2$1, templateObject_3;

var GLOBAL_IMPORT_ICON = "\n  @import \"https://assets.ohou.se/design-system/bbf3fca1e650ee6d.css\";\n";
var GLOBAL_STYLE_ICON = "\n  @font-face {\n    font-family: OhouseIcon;\n    src: url(https://assets.ohou.se/design-system/3298ed52addbc709.eot);\n    src:\n      url(https://assets.ohou.se/design-system/3298ed52addbc709.eot#iefix) format(\"embedded-opentype\"),\n      url(https://assets.ohou.se/design-system/d8923b386a66fd50.woff2) format(\"woff2\"),\n      url(https://assets.ohou.se/design-system/9e79341d6a2fe0d2.woff) format(\"woff\"),\n      url(https://assets.ohou.se/design-system/5355f736e6a7bc5b.ttf) format(\"truetype\"),\n      url(https://assets.ohou.se/design-system/3ba7913eab100858.svg#OhouseIcon) format(\"svg\");\n  }\n";
var GLOBAL_IMPORT_FONT = "\n  @import \"https://assets.ohou.se/fonts/pretendard/v1.3.8/pretendardvariable-dynamic-subset.css\";\n";
var GLOBAL_STYLE_FONT = "\n  html {\n    font-family: 'Pretendard Variable', sans-serif;\n    letter-spacing: ".concat(pxToRem(-0.3), ";\n    -webkit-font-smoothing: antialiased;\n  }\n");
var GLOBAL_STYLE = "\n  ".concat(GLOBAL_IMPORT_ICON, "\n  ").concat(GLOBAL_IMPORT_FONT, "\n  ").concat(GLOBAL_STYLE_ICON, "\n  ").concat(GLOBAL_STYLE_FONT, "\n  * {\n    box-sizing: border-box;\n  }\n  html, body { height: 100%; }\n  body, figure, input, p, h1, h2, h3, h4, h5, h6, hr,\n  ul {\n    margin: 0;\n  }\n  input,\n  textarea,\n  button,\n  ul {\n    padding: 0;\n  }\n  button,\n  hr,\n  input,\n  textarea,\n  select {\n    border: none;\n  }\n  button,\n  input,\n  textarea,\n  select {\n    background: none;\n  }\n  input,\n  textarea,\n  select {\n    outline: none;\n  }\n  button,\n  input,\n  textarea {\n    font-family: inherit;\n  }\n  ol,\n  ul {\n    list-style: none;\n  }\n  a {\n    text-decoration: none;\n    color: inherit;\n  }\n  a,\n  button:enabled {\n    cursor: pointer;\n    touch-action: manipulation;\n  }\n");

function HOVER(template) {
  var args = [];
  for (var _i = 1; _i < arguments.length; _i++) {
    args[_i - 1] = arguments[_i];
  }
  // NOTE: I'm unable to use MEDIA_QUERY.min here because it must consume
  // SerializedStyles to allow emotion's selectors to propagate.
  return /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_1__/* .css */ .iv)(templateObject_1 || (templateObject_1 = (0,_common_js__WEBPACK_IMPORTED_MODULE_2__._)(["\n    &.focus-visible:focus {\n      ", "\n    }\n    @media (hover: hover) and (pointer: fine) {\n      &:hover, &:active {\n        ", "\n      }\n    }\n  " + ( true ? "" : 0)], ["\n    &.focus-visible:focus {\n      ", "\n    }\n    @media (hover: hover) and (pointer: fine) {\n      &:hover, &:active {\n        ", "\n      }\n    }\n  " + ( true ? "" : 0)])), _emotion_react__WEBPACK_IMPORTED_MODULE_1__/* .css.apply */ .iv.apply(void 0, (0,_common_js__WEBPACK_IMPORTED_MODULE_2__.b)([template], args, false)), _emotion_react__WEBPACK_IMPORTED_MODULE_1__/* .css.apply */ .iv.apply(void 0, (0,_common_js__WEBPACK_IMPORTED_MODULE_2__.b)([template], args, false)));
}
function FOCUS(template) {
  var args = [];
  for (var _i = 1; _i < arguments.length; _i++) {
    args[_i - 1] = arguments[_i];
  }
  return /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_1__/* .css */ .iv)(templateObject_2 || (templateObject_2 = (0,_common_js__WEBPACK_IMPORTED_MODULE_2__._)(["\n    &::-moz-focus-inner {\n      border: 0;\n    }\n    &.focus-visible:focus,\n    &:focus-visible {\n      ", "\n    }\n  " + ( true ? "" : 0)], ["\n    &::-moz-focus-inner {\n      border: 0;\n    }\n    &.focus-visible:focus,\n    &:focus-visible {\n      ", "\n    }\n  " + ( true ? "" : 0)])), _emotion_react__WEBPACK_IMPORTED_MODULE_1__/* .css.apply */ .iv.apply(void 0, (0,_common_js__WEBPACK_IMPORTED_MODULE_2__.b)([template], args, false)));
}
var templateObject_1, templateObject_2;

var _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
var SvgIcon = function SvgIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("font", {
    id: "icon_svg__Ohouse",
    horizAdvX: 1024
  }, /*#__PURE__*/React.createElement("fontFace", {
    ascent: 960,
    descent: -64,
    unitsPerEm: 1024
  }), /*#__PURE__*/React.createElement("glyph", {
    horizAdvX: 512
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M89.583 725.333C89.583 819.59 165.994 896 260.25 896h503.467c94.259 0 170.667-76.41 170.667-170.667v-384C934.384 152.82 781.564 0 593.051 0H260.252C165.995 0 89.584 76.407 89.584 170.667zm209.084-204.766h426.667V631.5H298.667zm0-260.3H605.85V371.2H298.667z",
    glyphName: "datalist_12",
    unicode: "\\uE900"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M227.556 903.111c-62.838 0-113.778-50.94-113.778-113.778V106.666c0-62.839 50.94-113.778 113.778-113.778h364.089c188.513 0 341.333 152.821 341.333 341.333v455.111c0 62.838-50.938 113.778-113.778 113.778H227.556zm506.311-267.378H312.889v73.956h420.978zm0-210.5H312.889v73.956h420.978zM614.4 214.756H312.889v73.956H614.4z",
    glyphName: "datalist_18",
    unicode: "\\uE901"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M213.333 874.667c-47.128 0-85.333-38.205-85.333-85.333V106.667c0-47.13 38.205-85.333 85.333-85.333h341.333c188.514 0 341.333 152.819 341.333 341.333v426.667c0 47.128-38.204 85.333-85.333 85.333zM704 618.658H320v55.467h384zm0-192H320v55.467h384zm-106.667-192H320v55.467h277.333z",
    glyphName: "datalist_24",
    unicode: "\\uE902"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M763.716 785.067H260.249c-32.989 0-59.733-26.743-59.733-59.733V170.667c0-32.99 26.744-59.733 59.734-59.733h332.799c127.247 0 230.4 103.153 230.4 230.4v384c0 32.99-26.743 59.733-59.733 59.733M260.25 896h503.467c94.259 0 170.667-76.41 170.667-170.667v-384C934.384 152.82 781.564 0 593.051 0H260.252C165.995 0 89.584 76.407 89.584 170.667v554.667c0 94.257 76.411 170.667 170.667 170.667zm439.466-375.433H324.249V631.5h375.467zM605.85 285.9h-281.6v110.933h281.6z",
    glyphName: "datalist_outline_12",
    unicode: "\\uE903"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M819.2 829.156c21.993 0 39.822-17.829 39.822-39.822V334.223c0-147.666-119.711-267.378-267.378-267.378H227.555c-21.993 0-39.822 17.829-39.822 39.822v682.667c0 21.993 17.829 39.822 39.822 39.822zm-591.644 73.955c-62.838 0-113.778-50.94-113.778-113.778V106.666c0-62.839 50.94-113.778 113.778-113.778h364.089c188.513 0 341.333 152.821 341.333 341.333v455.111c0 62.838-50.938 113.778-113.778 113.778H227.556zm477.866-295.822H341.333v73.956h364.089zm0-182.034H341.333v73.956h364.089zM614.4 243.211H341.333v73.956H614.4z",
    glyphName: "datalist_outline_18",
    unicode: "\\uE904"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M810.667 819.2c16.495 0 29.867-13.372 29.867-29.867V362.666c0-157.879-127.987-285.867-285.867-285.867H213.334c-16.495 0-29.867 13.372-29.867 29.867v682.667c0 16.495 13.372 29.867 29.867 29.867zm-597.334 55.467c-47.128 0-85.333-38.205-85.333-85.333V106.667c0-47.13 38.205-85.333 85.333-85.333h341.333c188.514 0 341.333 152.819 341.333 341.333v426.667c0 47.128-38.204 85.333-85.333 85.333zm469.334-277.334H341.334V652.8h341.333zm0-170.666H341.334v55.467h341.333zM597.333 256h-256v55.467h256z",
    glyphName: "datalist_outline_24",
    unicode: "\\uE905"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M919.347 479.738 138.055 870.911a35.48 35.48 0 0 1-38.355-4.267c-5.063-4.25-8.842-9.829-10.912-16.111s-2.35-13.018-.806-19.45l94.11-347.433h401.655v-71.122H182.092L86.561 66.159a35.6 35.6 0 0 1-.493-16.452 35.5 35.5 0 0 1 6.962-14.916c3.454-4.361 7.881-7.851 12.925-10.18s10.565-3.447 16.119-3.26a35.4 35.4 0 0 1 15.981 3.917L919.347 416.44a35.5 35.5 0 0 1 14.106 13.102c3.413 5.584 5.214 12.002 5.214 18.547s-1.801 12.963-5.214 18.547a35.5 35.5 0 0 1-14.106 13.102",
    glyphName: "send_12",
    unicode: "\\uE906"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M919.347 479.738 138.054 870.911a35.47 35.47 0 0 1-38.354-4.268c-5.063-4.249-8.842-9.829-10.912-16.111s-2.35-13.018-.807-19.45l94.11-347.432h401.657v-71.122H182.091L86.56 66.162a35.6 35.6 0 0 1 6.469-31.374c3.454-4.358 7.882-7.845 12.926-10.177s10.565-3.447 16.118-3.254a35.5 35.5 0 0 1 15.981 3.908L919.347 416.44a35.6 35.6 0 0 1 14.108 13.102c3.408 5.584 5.211 12.002 5.211 18.547s-1.803 12.963-5.211 18.547a35.6 35.6 0 0 1-14.108 13.103z",
    glyphName: "send_18",
    unicode: "\\uE907"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M919.347 479.74 138.054 870.911a35.48 35.48 0 0 1-38.354-4.267c-5.064-4.249-8.843-9.829-10.913-16.111s-2.35-13.018-.807-19.45l94.11-347.435h401.653v-71.121H182.09L86.559 66.163c-1.448-5.372-1.617-11.012-.494-16.461s3.508-10.556 6.963-14.916c3.454-4.356 7.881-7.842 12.926-10.176s10.565-3.447 16.118-3.255a35.5 35.5 0 0 1 15.981 3.913L919.346 416.44c5.815 2.982 10.697 7.518 14.106 13.103a35.6 35.6 0 0 1 0 37.094 35.55 35.55 0 0 1-14.106 13.103z",
    glyphName: "send_24",
    unicode: "\\uE908"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M76.792 789.384c0 75.405 61.128 136.533 136.533 136.533h366.933c75.406 0 136.533-61.128 136.533-136.533V672.051h-102.4v117.333c0 18.851-15.281 34.133-34.133 34.133H213.325c-18.851 0-34.133-15.282-34.133-34.133V98.714c0-18.85 15.282-34.133 34.133-34.133h366.933c18.852 0 34.133 15.283 34.133 34.133v117.337h102.4V98.714c0-75.401-61.128-136.533-136.533-136.533H213.325c-75.405 0-136.533 61.133-136.533 136.533zM959.65 495.458 805.653 649.457l-72.408-72.408 81.592-81.591H402.12V393.057h413.133l-82.008-82.007 72.408-72.408 169.203 169.204c19.994 19.994 19.994 52.413 0 72.407l-14.874 14.87v.335h-.333z",
    glyphName: "signout_12",
    unicode: "\\uE909"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M79.667 777.922c0 81.689 66.222 147.911 147.911 147.911h351.267c81.687 0 147.911-66.222 147.911-147.911V681.22h-68.267v96.702c0 43.986-35.658 79.644-79.644 79.644H227.578c-43.986 0-79.644-35.658-79.644-79.644V110.939c0-43.986 35.658-79.644 79.644-79.644h351.267c43.986 0 79.644 35.658 79.644 79.644v96.7h68.267v-96.7c0-81.692-66.224-147.911-147.911-147.911H227.578c-81.689 0-147.911 66.219-147.911 147.911zm900.216-309.377L797.89 650.541l-48.27-48.271 123.557-123.562H417.562v-68.267h455.945L749.62 286.55l48.27-48.27 181.993 181.994c13.329 13.33 13.329 34.942 0 48.272z",
    glyphName: "signout_18",
    unicode: "\\uE90A"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M102.417 789.359c0 61.267 49.667 110.933 110.933 110.933h386.667c61.265 0 110.933-49.667 110.933-110.933V672.026h-51.2v117.333c0 32.989-26.743 59.733-59.733 59.733H213.35c-32.99 0-59.733-26.744-59.733-59.733V98.693c0-32.99 26.743-59.733 59.733-59.733h386.667c32.99 0 59.733 26.743 59.733 59.733v117.333h51.2V98.693c0-61.269-49.668-110.933-110.933-110.933H213.35c-61.267 0-110.933 49.664-110.933 110.933zm854.37-327.232L786.688 632.229l-36.203-36.204 126.251-126.257H427.755v-51.2h449.276L750.486 292.023l36.203-36.203 170.099 170.103c10.001 9.997 10.001 26.206 0 36.203z",
    glyphName: "signout_24",
    unicode: "\\uE90B"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M469.333 64v768h85.333V64zM128 490.667h768v-85.333H128z",
    glyphName: "add_12",
    unicode: "\\uE90C"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M475.022 64v768h73.956V64zM128 484.978h768v-73.956H128z",
    glyphName: "add_18",
    unicode: "\\uE90D"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M484.267 64v768h55.467V64zM128 475.733h768v-55.467H128z",
    glyphName: "add_24",
    unicode: "\\uE90E"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M485.333 64v768h53.333V64zM128 474.667h768v-53.333H128z",
    glyphName: "add_48",
    unicode: "\\uE90F"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M85.333 448c0 235.641 191.025 426.667 426.667 426.667S938.667 683.642 938.667 448 747.642 21.333 512 21.333 85.333 212.358 85.333 448m383.999-213.333h85.333v170.672h170.668v85.333H554.665v170.662h-85.333V490.672H298.666v-85.333h170.666z",
    glyphName: "add_circle_12",
    unicode: "\\uE910"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M85.333 448c0 235.642 191.025 426.667 426.667 426.667 235.639 0 426.667-191.025 426.667-426.667C938.667 212.361 747.64 21.333 512 21.333 276.358 21.333 85.333 212.36 85.333 448m389.689-213.333h73.956v176.358h162.133v73.956H548.978v176.353h-73.956V484.981H284.444v-73.956h190.578z",
    glyphName: "add_circle_18",
    unicode: "\\uE911"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M85.333 448c0 235.642 191.025 426.667 426.667 426.667 235.639 0 426.667-191.025 426.667-426.667C938.667 212.361 747.64 21.333 512 21.333 276.358 21.333 85.333 212.36 85.333 448m398.934-213.333h55.467v185.6h185.6v55.467h-185.6v185.6h-55.467v-185.6h-185.6v-55.467h185.6z",
    glyphName: "add_circle_24",
    unicode: "\\uE912"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M85.333 448c0 235.642 191.025 426.667 426.667 426.667S938.667 683.642 938.667 448 747.642 21.333 512 21.333 85.333 212.358 85.333 448m400.002-213.333h53.333v186.665h186.665v53.333H538.668v186.669h-53.333V474.665H298.666v-53.333h186.669z",
    glyphName: "add_circle_48",
    unicode: "\\uE913"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M170.667 448c0 188.513 152.82 341.333 341.333 341.333S853.333 636.513 853.333 448 700.513 106.667 512 106.667 170.667 259.487 170.667 448M512 874.667C276.359 874.667 85.333 683.642 85.333 448S276.358 21.333 512 21.333 938.667 212.358 938.667 448 747.642 874.667 512 874.667m-42.668-640.011v426.667h85.333V234.656zM298.667 490.662h426.667v-85.333H298.667z",
    glyphName: "add_circle_outline_12",
    unicode: "\\uE914"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M159.289 448.007c0 194.797 157.914 352.711 352.711 352.711 194.799 0 352.711-157.914 352.711-352.711 0-194.794-157.912-352.712-352.711-352.712-194.797 0-352.711 157.918-352.711 352.712M512 874.673c-235.642 0-426.667-191.025-426.667-426.667S276.358 21.338 512 21.338c235.639 0 426.667 191.027 426.667 426.668S747.64 874.673 512 874.673m-36.978-640.012V661.33h73.956V234.661zM298.667 484.979h426.667v-73.956H298.667z",
    glyphName: "add_circle_outline_18",
    unicode: "\\uE915"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M140.8 448c0 205.008 166.192 371.2 371.2 371.2S883.2 653.008 883.2 448c0-205.009-166.191-371.2-371.2-371.2S140.8 242.991 140.8 448M512 874.667C276.358 874.667 85.333 683.642 85.333 448 85.333 212.361 276.358 21.333 512 21.333c235.639 0 426.667 191.027 426.667 426.667 0 235.642-191.027 426.667-426.667 426.667m-27.733-640v426.667h55.467V234.667zm-185.6 241.066h426.667v-55.467H298.667z",
    glyphName: "add_circle_outline_24",
    unicode: "\\uE916"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M138.667 447.998c0 206.187 167.147 373.333 373.333 373.333s373.333-167.146 373.333-373.333S718.186 74.665 512 74.665 138.667 241.812 138.667 447.998M512 874.664c-235.642 0-426.667-191.025-426.667-426.666S276.358 21.331 512 21.331s426.667 191.025 426.667 426.667S747.642 874.664 512 874.664m-26.667-639.995v426.667h53.333V234.669zM298.665 474.667h426.667v-53.333H298.665z",
    glyphName: "add_circle_outline_48",
    unicode: "\\uE917"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M448 512v320h128V512h320V384H576V64H448v320H128v128z",
    glyphName: "add_thick_12",
    unicode: "\\uE918"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M455.111 64v768h113.778V64zM128 504.889h768V391.111H128z",
    glyphName: "add_thick_18",
    unicode: "\\uE919"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M469.333 64v768h85.333V64zM128 490.667h768v-85.333H128z",
    glyphName: "add_thick_24",
    unicode: "\\uE91A"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M480 64v768h64V64zM128 480h768v-64H128z",
    glyphName: "add_thick_48",
    unicode: "\\uE91B"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M549.297 895.387a42.668 42.668 0 0 1-74.594 0l-426.667-768c-7.342-13.215-7.142-29.331.524-42.361S70.215 64 85.333 64h853.333a42.65 42.65 0 0 1 36.77 21.026 42.67 42.67 0 0 1 .529 42.361zM484.25 597.333h55.467V320H484.25zm0-320h55.467v-64H484.25z",
    glyphName: "alert_12",
    unicode: "\\uE91C"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M544.33 892.647a36.978 36.978 0 0 1-64.648 0L53.015 124.649a36.977 36.977 0 0 1 32.324-54.937h853.333a36.978 36.978 0 0 1 32.324 54.937zm-60.052-295.314h55.467V320h-55.467zm0-320h55.467v-64h-55.467z",
    glyphName: "alert_18",
    unicode: "\\uE91D"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M536.247 888.152c-4.89 8.804-14.17 14.265-24.243 14.265s-19.354-5.46-24.243-14.265L61.094 120.154a27.735 27.735 0 0 1 24.243-41.203H938.67a27.735 27.735 0 0 1 24.243 41.203L536.246 888.152zm-51.976-290.819h55.467V320h-55.467zm0-320h55.467v-64h-55.467z",
    glyphName: "alert_24",
    unicode: "\\uE91E"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M512 901.333c9.685 0 18.607-5.25 23.311-13.716l426.667-767.999A26.667 26.667 0 0 0 938.667 80H85.334a26.668 26.668 0 0 0-23.311 39.618L488.69 887.617a26.67 26.67 0 0 0 23.311 13.716zm-27.729-304V320h55.467v277.333zm0-320v-64h55.467v64z",
    glyphName: "alert_48",
    unicode: "\\uE91F"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M469.333 213.333v64h85.333v-64zm0 106.667v277.333h85.333V320zM512 917.333a42.67 42.67 0 0 0 37.297-21.946l426.668-768a42.67 42.67 0 0 0-.529-42.361A42.65 42.65 0 0 0 938.666 64H85.333c-15.118 0-29.107 7.996-36.773 21.026s-7.866 29.146-.524 42.361l426.667 768A42.67 42.67 0 0 0 512 917.333m-354.154-768H866.15L512 786.811z",
    glyphName: "alert_outline_12",
    unicode: "\\uE920"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M475.028 213.356v64h73.956v-64zm0 106.667v277.333h73.956V320.023zm36.978 591.644a36.98 36.98 0 0 0 32.324-19.02l426.667-767.998a36.982 36.982 0 0 0-32.324-54.937H85.34a36.98 36.98 0 0 0-32.324 54.937l426.667 767.998a36.98 36.98 0 0 0 32.324 19.02zm-363.823-768h727.644l-363.822 654.88z",
    glyphName: "alert_outline_18",
    unicode: "\\uE921"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M484.271 213.35v64h55.467v-64zm0 106.667V597.35h55.467V320.017zm27.733 582.4a27.73 27.73 0 0 0 24.243-14.265l426.667-767.998c4.77-8.593 4.642-19.063-.341-27.533s-14.076-13.67-23.902-13.67H85.338a27.736 27.736 0 0 0-24.243 41.203l426.667 767.998a27.73 27.73 0 0 0 24.243 14.265zm-379.533-768h759.066l-379.533 683.16z",
    glyphName: "alert_outline_24",
    unicode: "\\uE922"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M485.333 213.333v64h53.333v-64zm0 106.667v277.333h53.333V320zM512 901.333c9.685 0 18.607-5.25 23.311-13.716l426.667-767.999A26.667 26.667 0 0 0 938.667 80H85.334a26.668 26.668 0 0 0-23.311 39.618L488.69 887.617a26.67 26.67 0 0 0 23.311 13.716zm-381.346-768h762.692L512 819.756z",
    glyphName: "alert_outline_48",
    unicode: "\\uE923"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M128 448c0 212.077 171.923 384 384 384 106.024 0 201.997-42.93 271.528-112.468l-52.768-52.768c-10.751-10.751-3.137-29.135 12.068-29.135h178.764c9.429 0 17.067 7.642 17.067 17.067v178.768c0 15.205-18.381 22.819-29.133 12.068l-65.66-65.662C758.975 864.753 641.616 917.333 512 917.333 252.794 917.333 42.667 707.206 42.667 448S252.794-21.333 512-21.333 981.333 188.794 981.333 448H896c0-212.077-171.923-384-384-384S128 235.923 128 448",
    glyphName: "arrow_clockwise_12",
    unicode: "\\uE924"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M128.011 448.003c0 212.077 171.922 384 384 384 106.03 0 202.007-42.939 271.531-112.472l-65.001-65.004c-7.168-7.167-2.094-19.423 8.044-19.423h195.032c6.281 0 11.378 5.094 11.378 11.378v195.03c0 10.136-12.26 15.213-19.428 8.045l-77.733-77.735c-82.836 82.833-197.348 134.135-323.823 134.135-252.922 0-457.956-205.034-457.956-457.955 0-252.919 205.034-457.958 457.956-457.958s457.956 205.039 457.956 457.958h-73.956c0-212.079-171.924-384.003-384-384.003-212.078 0-384 171.924-384 384.003z",
    glyphName: "arrow_clockwise_18",
    unicode: "\\uE925"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M155.738 447.996c0 196.761 159.506 356.267 356.267 356.267 98.372 0 187.422-39.844 251.921-104.347l-66.688-66.685c-5.376-5.376-1.566-14.567 6.033-14.567h184.201a8.53 8.53 0 0 1 8.533 8.533v184.199c0 7.602-9.19 11.409-14.566 6.034l-78.293-78.294c-74.483 74.478-177.434 120.594-291.14 120.594-227.394 0-411.733-184.339-411.733-411.733 0-227.392 184.339-411.733 411.733-411.733 227.392 0 411.733 184.341 411.733 411.733h-55.467c0-196.762-159.505-356.267-356.267-356.267S155.738 251.235 155.738 447.997z",
    glyphName: "arrow_clockwise_24",
    unicode: "\\uE926"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M124.798 448.002c0 213.845 173.355 387.2 387.2 387.2 106.916 0 203.701-43.312 273.794-113.408l-73.065-73.065c-6.72-6.72-1.961-18.208 7.543-18.208h191.729c5.892 0 10.667 4.774 10.667 10.667v191.729c0 9.503-11.49 14.262-18.208 7.542l-85.481-85.481c-78.541 78.537-187.089 127.156-306.98 127.156-239.765 0-434.133-194.368-434.133-434.133S272.232 13.868 511.997 13.868 946.13 208.236 946.13 448.001h-46.933c0-213.845-173.355-387.2-387.2-387.2s-387.2 173.355-387.2 387.2z",
    glyphName: "arrow_clockwise_48",
    unicode: "\\uE927"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "m543.875 35.652 341.33 384.002-63.776 56.692-266.778-300.124V832h-85.333V176.222L202.541 476.346l-63.779-56.692L480.095 35.652c8.096-9.105 19.702-14.319 31.889-14.319s23.793 5.214 31.89 14.319z",
    glyphName: "arrow_down_12",
    unicode: "\\uE928"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M539.639 39.435 880.97 423.433l-55.273 49.134-276.718-311.31V832h-73.956V161.257l-276.718 311.31-55.275-49.134L484.363 39.435a36.973 36.973 0 0 1 55.275 0z",
    glyphName: "arrow_down_18",
    unicode: "\\uE929"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "m532.727 45.577 341.333 384-41.455 36.847-292.873-329.481V832h-55.467V136.943L191.394 466.424l-41.456-36.847 341.333-384a27.74 27.74 0 0 1 20.727-9.31 27.72 27.72 0 0 1 20.727 9.31z",
    glyphName: "arrow_down_24",
    unicode: "\\uE92A"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "m531.927 46.283 341.333 384-39.861 35.435L538.662 134.14V832h-53.333V134.14L190.594 465.718l-39.862-35.435 341.334-384a26.668 26.668 0 0 1 39.862 0z",
    glyphName: "arrow_down_48",
    unicode: "\\uE92B"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "m142.321 479.875 384 341.333 56.692-63.779-300.124-266.778h655.778v-85.333H282.889l300.124-266.777-56.692-63.782-384 341.336a42.665 42.665 0 0 0 0 63.779z",
    glyphName: "arrow_left_12",
    unicode: "\\uE92C"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "m103.439 475.639 384 341.333 49.133-55.275-311.307-276.718h670.741v-73.956H225.265l311.307-276.72-49.133-55.273-384 341.334a36.978 36.978 0 0 0 0 55.275",
    glyphName: "arrow_left_18",
    unicode: "\\uE92D"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "m109.579 468.727 384.002 341.335 36.847-41.456-329.479-292.873h695.056v-55.467H200.949l329.479-292.873-36.847-41.455-384.002 341.333a27.74 27.74 0 0 0-9.308 20.727 27.72 27.72 0 0 0 9.308 20.727z",
    glyphName: "arrow_left_24",
    unicode: "\\uE92E"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M110.284 467.927 494.283 809.26l35.435-39.862-331.579-294.736H896v-53.333H198.139l331.579-294.735-35.435-39.861-383.999 341.333a26.665 26.665 0 0 0 0 39.862z",
    glyphName: "arrow_left_48",
    unicode: "\\uE92F"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M783.778 490.652 483.654 757.43l56.692 63.779 384.002-341.333c9.105-8.097 14.319-19.703 14.319-31.89s-5.214-23.793-14.319-31.889L540.346 74.761l-56.692 63.782L783.778 405.32H128v85.333h655.778z",
    glyphName: "arrow_right_12",
    unicode: "\\uE930"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "m798.743 484.979-311.31 276.718 49.134 55.275 383.998-341.333a36.973 36.973 0 0 0 0-55.275L536.567 79.03l-49.134 55.273 311.31 276.72H128v73.956z",
    glyphName: "arrow_right_18",
    unicode: "\\uE931"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M823.057 475.733 493.576 768.606l36.847 41.456 384-341.335a27.72 27.72 0 0 0 9.31-20.727 27.74 27.74 0 0 0-9.31-20.727l-384-341.333-36.847 41.455 329.481 292.873H128v55.467h695.057z",
    glyphName: "arrow_right_24",
    unicode: "\\uE932"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M825.86 474.662 494.282 769.398l35.435 39.862 384-341.333a26.67 26.67 0 0 0 0-39.862l-384-341.333-35.435 39.861L825.86 421.328H128v53.333h697.86z",
    glyphName: "arrow_right_48",
    unicode: "\\uE933"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "m480.096 860.346-341.333-384 63.779-56.692 266.777 300.124V64h85.333v655.778L821.43 419.654l63.776 56.692-341.331 384a42.665 42.665 0 0 1-63.778 0z",
    glyphName: "arrow_up_12",
    unicode: "\\uE934"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "m539.636 856.561 341.334-384-55.273-49.133-276.72 311.307V63.994h-73.956v670.741L198.303 423.428l-55.275 49.133 341.333 384a36.978 36.978 0 0 0 55.275 0",
    glyphName: "arrow_up_18",
    unicode: "\\uE935"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M532.727 850.421 874.06 466.419l-41.455-36.847-292.873 329.479V63.995h-55.467v695.056L191.392 429.572l-41.456 36.847 341.335 384.002a27.73 27.73 0 0 0 20.727 9.308 27.74 27.74 0 0 0 20.727-9.308z",
    glyphName: "arrow_up_24",
    unicode: "\\uE936"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "m531.934 849.716 341.333-383.999-39.861-35.435-294.735 331.579V64h-53.333v697.861L190.602 430.282l-39.862 35.435 341.333 383.999a26.666 26.666 0 0 0 39.862 0z",
    glyphName: "arrow_up_48",
    unicode: "\\uE937"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "m161.813 575.072 703.996 149.333 17.715-83.476-670.191-142.16V397.233l670.191-142.16-17.715-83.476L161.813 320.93C142.099 325.112 128 342.516 128 362.668v170.667c0 20.152 14.1 37.556 33.813 41.738zM832 128v640h85.333V128zm-597.333 21.333V320H320V192h256v64h85.333V149.333c0-23.564-19.103-42.667-42.667-42.667H277.333c-23.564 0-42.667 19.103-42.667 42.667z",
    glyphName: "bullhorn_outline_12",
    unicode: "\\uE938"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M928.694 39.959v80.219l-256.495 54.409V67.516c0-20.417-16.56-36.978-36.978-36.978H194.589c-20.423 0-36.978 16.56-36.978 36.978v216.223l-108.39 22.989c-17.085 3.624-29.305 18.711-29.305 36.176v220.315c0 17.465 12.22 32.548 29.305 36.173l879.473 186.555v80.193h73.956V39.96h-73.956zm-697.127 228.09V104.493h366.677v85.777zm697.127 442.296L93.872 533.261v-160.4l834.822-177.084z",
    glyphName: "bullhorn_outline_18",
    unicode: "\\uE939"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M900.032 70.43v75.226l-239.966 50.901V95.958c0-18.33-14.857-33.186-33.186-33.186H218.431c-18.328 0-33.187 14.857-33.187 33.186v201.318l-101.34 21.495c-15.334 3.255-26.3 16.789-26.3 32.465v204.226c0 15.674 10.967 29.212 26.3 32.464l816.128 173.117v75.227h66.372V70.429h-66.372zM251.618 283.196V129.144h342.076v81.493zm648.414 409.998L123.977 528.576V378.121l776.055-164.617z",
    glyphName: "bullhorn_outline_24",
    unicode: "\\uE93A"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M915.198 61.577v84.439l-263.371 55.868V87.424c0-12.962-10.507-23.467-23.467-23.467H214.621c-12.959 0-23.466 10.505-23.466 23.467v221.909l25.031-15.042L80.46 323.082c-10.842 2.3-18.597 11.872-18.597 22.955v206.869c0 11.083 7.755 20.655 18.597 22.957l834.736 177.064v84.406h46.933V61.576h-46.933zM238.089 289.645V110.891h366.805V211.84zm677.109 415.304-806.4-171.053V365.049l806.4-171.055z",
    glyphName: "bullhorn_outline_48",
    unicode: "\\uE93B"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M128 874.667c0 23.564 19.103 42.667 42.667 42.667h682.667c23.561 0 42.667-19.103 42.667-42.667V21.334c0-23.561-19.106-42.667-42.667-42.667H170.667C147.103-21.333 128-2.227 128 21.334zM213.333 832V64h597.333v768zm85.334-85.333h426.667v-85.333H298.667zm0-170.667H384v-85.333h-85.333zm0-170.667H384V320h-85.333zm0-170.666H384v-85.333h-85.333zM469.333 576h85.333v-85.333h-85.333zm0-170.667h85.333V320h-85.333zm0-170.666h85.333v-85.333h-85.333zM640 576h85.333v-85.333H640zm0-170.667h85.333V320H640zm0-170.666h85.333v-85.333H640z",
    glyphName: "calculator_12",
    unicode: "\\uE93C"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M133.695 874.689c0 20.423 16.555 36.978 36.978 36.978H853.34c20.423 0 36.978-16.555 36.978-36.978V21.356c0-20.423-16.555-36.978-36.978-36.978H170.673c-20.423 0-36.978 16.555-36.978 36.978zm73.955-36.978V58.334h608.711v779.377zm91.022-91.022h426.667v-85.333H298.672zm0-170.667h85.333v-85.333h-85.333zm0-170.666h85.333v-85.333h-85.333zm0-170.667h85.333v-85.333h-85.333zm170.667 341.333h85.333v-85.333h-85.333zm0-170.666h85.333v-85.333h-85.333zm0-170.667h85.333v-85.333h-85.333zm170.667 341.333h85.333v-85.333h-85.333zm0-170.666h85.333v-85.333h-85.333zm0-170.667h85.333v-85.333h-85.333z",
    glyphName: "calculator_18",
    unicode: "\\uE93D"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M142.938 874.683c0 15.317 12.416 27.733 27.733 27.733h682.667c15.317 0 27.733-12.416 27.733-27.733V21.35c0-15.317-12.416-27.733-27.733-27.733H170.671c-15.317 0-27.733 12.416-27.733 27.733zm55.466-27.733V49.084h627.2V846.95zm100.267-100.267h426.667V661.35H298.671zm0-170.666h85.333v-85.333h-85.333zm0-170.667h85.333v-85.333h-85.333zm0-170.666h85.333v-85.333h-85.333zm170.667 341.333h85.333v-85.333h-85.333zm0-170.667h85.333v-85.333h-85.333zm0-170.666h85.333v-85.333h-85.333zm170.666 341.333h85.333v-85.333h-85.333zm0-170.667h85.333v-85.333h-85.333zm0-170.666h85.333v-85.333h-85.333z",
    glyphName: "calculator_24",
    unicode: "\\uE93E"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M144 874.667V21.334c0-14.729 11.939-26.667 26.667-26.667h682.667c14.729 0 26.667 11.938 26.667 26.667v853.333c0 14.728-11.938 26.667-26.667 26.667H170.667c-14.728 0-26.667-11.939-26.667-26.667M197.333 848h629.333V48H197.333zm101.334-101.333h426.667v-85.333H298.667zm0-170.667H384v-85.333h-85.333zm0-170.667H384V320h-85.333zm0-170.666H384v-85.333h-85.333zM469.333 576h85.333v-85.333h-85.333zm0-170.667h85.333V320h-85.333zm0-170.666h85.333v-85.333h-85.333zM640 576h85.333v-85.333H640zm0-170.667h85.333V320H640zm0-170.666h85.333v-85.333H640z",
    glyphName: "calculator_48",
    unicode: "\\uE93F"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M298.667 674.125H384v42.667h256v-42.667h85.333v42.667h85.333v-85.333H213.333v85.333h85.333v-42.667zm341.333 128H384v42.667h-85.333v-42.667h-128c-23.564 0-42.667-19.103-42.667-42.667V76.791c0-23.561 19.103-42.667 42.667-42.667h682.667c23.561 0 42.667 19.106 42.667 42.667v682.667c0 23.564-19.106 42.667-42.667 42.667h-128v42.667h-85.333v-42.667zm-426.667-256h597.333V119.458H213.333z",
    glyphName: "calendar_outline_12",
    unicode: "\\uE940"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M645.689 812.083H378.311v42.667h-73.956v-42.667H170.666c-23.564 0-42.667-19.102-42.667-42.667V86.749c0-23.563 19.103-42.667 42.667-42.667h682.667c23.563 0 42.667 19.103 42.667 42.667v682.667c0 23.565-19.103 42.667-42.667 42.667H719.644v42.667h-73.956zm-341.333-128h73.956v54.044H645.69v-54.044h73.956v54.044h102.4v-102.4H201.957v102.4h102.4zm-102.4-122.311h620.089V118.039H201.956z",
    glyphName: "calendar_outline_18",
    unicode: "\\uE941"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M654.933 810.667H369.066v42.667h-55.467v-42.667H170.666c-23.564 0-42.667-19.103-42.667-42.667V85.333c0-23.565 19.103-42.667 42.667-42.667h682.667c23.565 0 42.667 19.102 42.667 42.667V768c0 23.564-19.102 42.667-42.667 42.667H710.4v42.667h-55.467zm-341.333-128h55.467V755.2h285.867v-72.533h55.467V755.2h130.133V625.067H183.467V755.2H313.6zM183.467 569.6h657.067V98.133H183.467z",
    glyphName: "calendar_outline_24",
    unicode: "\\uE942"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M656 810.667H368v42.667h-53.333v-42.667h-144C147.103 810.667 128 791.564 128 768V85.333c0-23.565 19.103-42.667 42.667-42.667h682.667c23.565 0 42.667 19.102 42.667 42.667V768c0 23.564-19.102 42.667-42.667 42.667h-144v42.667h-53.333v-42.667zm-341.333-128H368v74.667h288v-74.667h53.333v74.667h133.333V624.001H181.333v133.333h133.333v-74.667zm-133.334-112h661.333V96H181.333z",
    glyphName: "calendar_outline_48",
    unicode: "\\uE943"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M512 262.391c74.227 0 134.4 60.173 134.4 134.4s-60.173 134.4-134.4 134.4-134.4-60.173-134.4-134.4 60.173-134.4 134.4-134.4m-97.287 582.4a89.6 89.6 0 0 1-63.357-26.243l-63.357-63.357h-179.2c-24.742 0-44.8-20.058-44.8-44.8v-627.2c0-24.738 20.058-44.8 44.8-44.8h806.4c24.738 0 44.8 20.062 44.8 44.8v627.2c0 24.742-20.062 44.8-44.8 44.8h-179.2l-63.357 63.357a89.6 89.6 0 0 1-63.357 26.243H414.711zm97.287-672c-123.712 0-224 100.288-224 224s100.288 224 224 224 224-100.288 224-224-100.288-224-224-224",
    glyphName: "camera_12",
    unicode: "\\uE944"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M513.417 269.517c74.229 0 134.4 60.171 134.4 134.4 0 74.227-60.171 134.4-134.4 134.4-74.227 0-134.4-60.173-134.4-134.4 0-74.229 60.173-134.4 134.4-134.4m-109.658 582.4a59.74 59.74 0 0 1-42.238-17.496l-72.104-72.104h-179.2c-24.742 0-44.8-20.058-44.8-44.8v-627.2c0-24.741 20.058-44.8 44.8-44.8h806.4c24.741 0 44.8 20.059 44.8 44.8v627.2c0 24.742-20.059 44.8-44.8 44.8h-179.2l-72.107 72.104a59.72 59.72 0 0 1-42.234 17.496zm109.658-672c-123.712 0-224 100.289-224 224s100.288 224 224 224c123.711 0 224-100.288 224-224s-100.289-224-224-224",
    glyphName: "camera_18",
    unicode: "\\uE945"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M512 270.933c74.227 0 134.4 60.173 134.4 134.4s-60.173 134.4-134.4 134.4-134.4-60.173-134.4-134.4 60.173-134.4 134.4-134.4m-115.843 582.4a44.8 44.8 0 0 1-31.678-13.122l-76.478-76.478h-179.2c-24.742 0-44.8-20.058-44.8-44.8v-627.2c0-24.742 20.058-44.8 44.8-44.8h806.4c24.742 0 44.8 20.058 44.8 44.8v627.2c0 24.742-20.058 44.8-44.8 44.8h-179.2l-76.48 76.478a44.8 44.8 0 0 1-31.676 13.122zm115.843-672c-123.712 0-224 100.288-224 224s100.288 224 224 224 224-100.288 224-224-100.288-224-224-224",
    glyphName: "camera_24",
    unicode: "\\uE946"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M512 270.933c74.227 0 134.4 60.173 134.4 134.4s-60.173 134.4-134.4 134.4-134.4-60.173-134.4-134.4 60.173-134.4 134.4-134.4m-125.122 582.4a22.4 22.4 0 0 1-15.838-6.561L288 763.733H108.8c-24.742 0-44.8-20.058-44.8-44.8v-627.2c0-24.742 20.058-44.8 44.8-44.8h806.4c24.742 0 44.8 20.058 44.8 44.8v627.2c0 24.742-20.058 44.8-44.8 44.8H736l-83.04 83.039a22.4 22.4 0 0 1-15.838 6.561zm125.122-672c-123.712 0-224 100.288-224 224s100.288 224 224 224 224-100.288 224-224-100.288-224-224-224",
    glyphName: "camera_48",
    unicode: "\\uE947"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M700.654 669.858h174.013V123.725H149.334v546.133h174.013l89.6 89.6h198.108l89.6-89.6zM288 755.191H108.8c-24.742 0-44.8-20.058-44.8-44.8v-627.2c0-24.738 20.058-44.8 44.8-44.8h806.4c24.738 0 44.8 20.062 44.8 44.8v627.2c0 24.742-20.062 44.8-44.8 44.8H736l-64.607 64.607a85.33 85.33 0 0 1-60.339 24.993H412.946a85.33 85.33 0 0 1-60.339-24.993zm443.709-358.382c0-121.356-98.378-219.733-219.733-219.733s-219.733 98.377-219.733 219.733c0 121.355 98.377 219.733 219.733 219.733s219.733-98.378 219.733-219.733m-85.334 0c0 74.227-60.173 134.4-134.4 134.4s-134.4-60.173-134.4-134.4 60.173-134.4 134.4-134.4 134.4 60.173 134.4 134.4",
    glyphName: "camera_outline_12",
    unicode: "\\uE948"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M706.782 688.361h180.679V119.472H139.372v568.889H320.05l89.6 89.6h207.532zm-417.365 73.956h-179.2c-24.742 0-44.8-20.058-44.8-44.8v-627.2c0-24.741 20.058-44.8 44.8-44.8h806.4c24.741 0 44.8 20.059 44.8 44.8v627.2c0 24.742-20.059 44.8-44.8 44.8h-179.2l-72.937 72.937a56.89 56.89 0 0 1-40.226 16.663H402.582a56.9 56.9 0 0 1-40.227-16.663zm432.366-352.739c0-115.07-93.286-208.356-208.356-208.356-115.072 0-208.356 93.286-208.356 208.356 0 115.071 93.284 208.356 208.356 208.356 115.069 0 208.356-93.284 208.356-208.356m-73.955 0c0 74.227-60.171 134.4-134.4 134.4-74.227 0-134.4-60.173-134.4-134.4 0-74.229 60.173-134.401 134.4-134.401 74.229 0 134.4 60.171 134.4 134.401",
    glyphName: "camera_outline_18",
    unicode: "\\uE949"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M713.024 708.267h191.509V102.4H119.466v605.867h191.508l89.6 89.6h222.849zM288 763.733H108.8c-24.742 0-44.8-20.058-44.8-44.8v-627.2c0-24.742 20.058-44.8 44.8-44.8h806.4c24.742 0 44.8 20.058 44.8 44.8v627.2c0 24.742-20.058 44.8-44.8 44.8H736l-77.103 77.103a42.67 42.67 0 0 1-30.17 12.497H395.272a42.67 42.67 0 0 1-30.17-12.497zm413.867-358.4c0-104.862-85.005-189.867-189.867-189.867s-189.867 85.005-189.867 189.867S407.139 595.2 512 595.2c104.862 0 189.867-85.005 189.867-189.867m-55.467 0c0 74.227-60.173 134.4-134.4 134.4s-134.4-60.173-134.4-134.4 60.173-134.4 134.4-134.4 134.4 60.173 134.4 134.4",
    glyphName: "camera_outline_24",
    unicode: "\\uE94A"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M716.559 716.8h196.508V93.867H110.934V716.8h196.508l89.6 89.6H626.96l89.6-89.6zM736 763.733l-83.351 83.352a21.33 21.33 0 0 1-15.085 6.248H386.437a21.34 21.34 0 0 1-15.085-6.248l-83.351-83.352h-179.2c-24.742 0-44.8-20.058-44.8-44.8v-627.2c0-24.742 20.058-44.8 44.8-44.8h806.4c24.742 0 44.8 20.058 44.8 44.8v627.2c0 24.742-20.058 44.8-44.8 44.8zm-42.667-358.4c0 100.147-81.186 181.333-181.333 181.333S330.667 505.48 330.667 405.333 411.853 224 512 224s181.333 81.186 181.333 181.333m-46.933 0c0-74.227-60.173-134.4-134.4-134.4s-134.4 60.173-134.4 134.4 60.173 134.4 134.4 134.4 134.4-60.173 134.4-134.4",
    glyphName: "camera_outline_48",
    unicode: "\\uE94B"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M65.741 813.807H0V896h79.667c32.143 0 59.575-23.238 64.86-54.944l10.953-65.721h768.288c37.862 0 65.399-35.936 55.552-72.492L876.877 322.319c-24.157-89.716-105.508-152.062-198.419-152.062H387.424c-92.911 0-174.263 62.346-198.417 152.062L80.459 725.498l-14.718 88.311zm202.633-470.121c14.493-53.83 63.304-91.238 119.05-91.238h291.034c55.747 0 104.557 37.408 119.049 91.238l94.081 349.455H174.29zM429.481 77.047c0-40.858-33.119-73.975-73.974-73.975s-73.973 33.118-73.973 73.975c0 40.852 33.119 73.97 73.973 73.97s73.974-33.119 73.974-73.97M677.295 3.072c40.855 0 73.974 33.118 73.974 73.975 0 40.852-33.119 73.97-73.974 73.97s-73.973-33.119-73.973-73.97c0-40.858 33.119-73.975 73.973-73.975",
    glyphName: "cart_12",
    unicode: "\\uE94C"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M67.02 837.69H0v73.956h83.888c26.419 0 48.965-19.1 53.309-45.16l12.142-72.854h760.257c31.824 0 54.966-30.202 46.694-60.927L845.135 319.846c-17.721-65.826-77.403-111.565-145.573-111.565H342.894c-68.166 0-127.851 45.739-145.572 111.565L81.837 748.788 67.02 837.689zm201.715-498.621c9.028-33.53 39.434-56.832 74.16-56.832h356.668c34.725 0 65.132 23.302 74.16 56.832l102.474 380.607H166.264zM373.707-10.439c54.314 0 98.345 44.032 98.345 98.344 0 54.318-44.031 98.35-98.345 98.35s-98.346-44.032-98.346-98.35c0-54.312 44.031-98.344 98.346-98.344m-24.39 98.344c0 13.471 10.92 24.394 24.39 24.394s24.389-10.923 24.389-24.394-10.92-24.388-24.389-24.388-24.39 10.917-24.39 24.388m437.456 0c0-54.312-44.032-98.344-98.344-98.344-54.318 0-98.344 44.032-98.344 98.344 0 54.318 44.026 98.35 98.344 98.35 54.312 0 98.344-44.032 98.344-98.35m-98.343 24.394c-13.471 0-24.388-10.923-24.388-24.394s10.917-24.388 24.388-24.388 24.388 10.917 24.388 24.388-10.917 24.394-24.388 24.394",
    glyphName: "cart_18",
    unicode: "\\uE94D"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M77.236 855.159H0v51.508h88.983c18.4 0 34.103-13.303 37.128-31.452l14.569-87.411h780.075c22.161 0 38.285-21.035 32.521-42.433L833.08 298.924c-12.343-45.845-53.909-77.7-101.385-77.7H318.267c-47.475 0-89.044 31.855-101.386 77.7L93.667 756.573 77.236 855.16zm189.382-542.848c6.287-23.356 27.464-39.582 51.649-39.582h413.428c24.183 0 45.359 16.226 51.648 39.582l114.15 423.984H152.468zM376.401-10.564c54.703 0 99.051 44.348 99.051 99.055 0 54.703-44.348 99.051-99.051 99.051-54.705 0-99.053-44.348-99.053-99.051 0-54.707 44.348-99.055 99.053-99.055m-47.546 99.055c0 26.257 21.287 47.543 47.545 47.543s47.546-21.286 47.546-47.543-21.287-47.548-47.546-47.548-47.545 21.291-47.545 47.548m463.567 0c0 54.703-44.348 99.051-99.051 99.051-54.707 0-99.055-44.348-99.055-99.051 0-54.707 44.348-99.055 99.055-99.055 54.703 0 99.051 44.348 99.051 99.055m-99.05 47.543c26.257 0 47.543-21.286 47.543-47.543s-21.286-47.548-47.543-47.548c-26.261 0-47.548 21.291-47.548 47.548s21.286 47.543 47.548 47.543",
    glyphName: "cart_24",
    unicode: "\\uE94E"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M79.979 862.293H0v46.933h94.436c14.6 0 27.06-10.555 29.46-24.957l15.812-94.873h793.39c18.251 0 31.524-17.321 26.78-34.943L830.026 272.14c-7.774-28.875-33.956-48.941-63.859-48.941H292.33c-29.903 0-56.085 20.066-63.859 48.941l-131.6 488.798zm193.811-577.95a19.2 19.2 0 0 1 18.541-14.21h473.837a19.2 19.2 0 0 1 18.539 14.21l123.341 458.121H150.451l123.34-458.121zM798.863 86.895c0-55.151-44.708-99.859-99.859-99.859s-99.857 44.708-99.857 99.859c0 55.149 44.706 99.857 99.857 99.857s99.859-44.708 99.859-99.857m-99.859 52.924c-29.229 0-52.924-23.695-52.924-52.924 0-29.231 23.695-52.926 52.924-52.926s52.926 23.695 52.926 52.926c0 29.229-23.697 52.924-52.926 52.924M379.462-12.964c55.151 0 99.857 44.708 99.857 99.859 0 55.149-44.706 99.857-99.857 99.857s-99.859-44.708-99.859-99.857c0-55.151 44.708-99.859 99.859-99.859m-52.925 99.859c0 29.229 23.697 52.924 52.926 52.924s52.924-23.695 52.924-52.924c0-29.231-23.695-52.926-52.924-52.926s-52.926 23.695-52.926 52.926",
    glyphName: "cart_48",
    unicode: "\\uE94F"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M232.727 832c-16.459 0-32.245-6.473-43.884-17.995s-18.177-27.15-18.177-43.445V125.44c0-16.295 6.538-31.923 18.177-43.443S216.267 64 232.727 64h558.546c16.459 0 32.245 6.477 43.884 17.997s18.177 27.148 18.177 43.443v645.12c0 16.295-6.538 31.922-18.177 43.445S807.733 832 791.273 832zm108.606-170.667h73.956V576h-73.956zm113.792 0H682.68V576H455.125zm227.555-352.75V223.25H455.125v85.333zm-341.347 0h73.956V223.25h-73.956zM682.68 485v-85.333H455.125V485zm-341.347 0h73.956v-85.333h-73.956z",
    glyphName: "category_12",
    unicode: "\\uE950"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M186.182 846.222c-19.203 0-37.619-6.713-51.198-18.662s-21.206-28.155-21.206-45.054V113.493c0-16.896 7.628-33.104 21.206-45.056 13.579-11.947 31.995-18.66 51.198-18.66H837.82c19.2 0 37.615 6.713 51.194 18.66 13.579 11.952 21.208 28.16 21.208 45.056v669.013c0 16.898-7.629 33.105-21.208 45.054s-31.994 18.662-51.194 18.662zm98.262-184.889H358.4v-73.956h-73.956zm130.834 0h324.267v-73.956H415.278zm324.266-352.722v-73.956H415.277v73.956zm-455.1 0H358.4v-73.956h-73.956zM739.544 485v-73.956H415.277V485zm-455.1 0H358.4v-73.956h-73.956z",
    glyphName: "category_18",
    unicode: "\\uE951"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M232.727 832h558.547c16.457 0 32.243-6.473 43.883-17.996s18.176-27.15 18.176-43.444V125.44c0-16.294-6.537-31.923-18.176-43.443C823.518 70.473 807.731 64 791.274 64H232.727c-16.46 0-32.245 6.473-43.884 17.997-11.639 11.52-18.177 27.149-18.177 43.443v645.12c0 16.295 6.539 31.922 18.177 43.444S216.267 832 232.727 832m108.606-170.667v-55.467H396.8v55.467zm98.125 0v-55.467h243.2v55.467zm243.2-371.208h-243.2v-55.467h243.2zm-341.325 0v-55.467H396.8v55.467zm341.325 183.458h-243.2v-55.467h243.2zm-341.325 0v-55.467H396.8v55.467z",
    glyphName: "category_24",
    unicode: "\\uE952"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M232.727 832c-16.459 0-32.245-6.473-43.884-17.995s-18.177-27.15-18.177-43.445V125.44c0-16.294 6.538-31.923 18.177-43.445S216.268 64 232.727 64h558.545c16.459 0 32.245 6.473 43.883 17.995s18.178 27.151 18.178 43.445v645.12c0 16.295-6.539 31.922-18.178 43.445C823.518 825.527 807.731 832 791.272 832zm108.606-170.667h53.333V608h-53.333zm98.125 0h243.2V608h-243.2zm243.2-371.208v-53.333h-243.2v53.333zm-341.325 0h53.333v-53.333h-53.333zm341.325 183.458V420.25h-243.2v53.333zm-341.325 0h53.333V420.25h-53.333z",
    glyphName: "category_48",
    unicode: "\\uE953"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M415.289 661.333h-73.956V576h73.956zm267.391 0H455.125V576H682.68zm-227.555-352.75H682.68V223.25H455.125zm-39.836 0h-73.956V223.25h73.956zM455.125 485H682.68v-85.333H455.125zm-39.836 0h-73.956v-85.333h73.956zM232.727 832h558.546c16.459 0 32.245-6.473 43.884-17.995s18.177-27.15 18.177-43.445V125.44c0-16.295-6.538-31.923-18.177-43.443S807.733 64 791.273 64H232.727c-16.459 0-32.245 6.477-43.884 17.997s-18.177 27.148-18.177 43.443v645.12c0 16.295 6.538 31.922 18.177 43.445S216.267 832 232.727 832M256 149.333h512v597.333H256z",
    glyphName: "category_outline_12",
    unicode: "\\uE954"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M358.4 661.333h-73.956v-73.956H358.4zm381.144 0H415.277v-73.956h324.267zM415.278 308.611h324.267v-73.956H415.278zm-56.878 0h-73.956v-73.956H358.4zM415.278 485h324.267v-73.956H415.278zm-56.878 0h-73.956v-73.956H358.4zM186.182 846.222H837.82c19.2 0 37.615-6.713 51.194-18.662s21.208-28.155 21.208-45.054V113.493c0-16.896-7.629-33.104-21.208-45.056-13.579-11.947-31.994-18.66-51.194-18.66H186.182c-19.203 0-37.619 6.713-51.198 18.66-13.578 11.952-21.206 28.16-21.206 45.056v669.013c0 16.898 7.628 33.105 21.206 45.054s31.995 18.662 51.198 18.662m1.551-722.489h648.533v648.533H187.733z",
    glyphName: "category_outline_18",
    unicode: "\\uE955"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M396.8 661.333h-55.467v-55.467H396.8zm285.858 0h-243.2v-55.467h243.2zm-243.2-371.208h243.2v-55.467h-243.2zm-42.658 0h-55.467v-55.467H396.8zm42.658 183.458h243.2v-55.467h-243.2zm-42.658 0h-55.467v-55.467H396.8zM791.275 832c16.457 0 32.243-6.473 43.883-17.996s18.176-27.15 18.176-43.444V125.44c0-16.294-6.537-31.923-18.176-43.443C823.519 70.473 807.732 64 791.275 64H232.728c-16.46 0-32.245 6.473-43.884 17.997-11.639 11.52-18.177 27.149-18.177 43.443v645.12c0 16.295 6.539 31.922 18.177 43.444S216.268 832 232.728 832zM226.133 125.44c0-1.404.558-2.863 1.734-4.028 1.195-1.182 2.933-1.946 4.861-1.946h558.547c1.924 0 3.665.764 4.86 1.946 1.173 1.165 1.732 2.624 1.732 4.028v645.12c0 1.403-.559 2.863-1.732 4.027-1.195 1.183-2.935 1.946-4.86 1.946H232.728c-1.928 0-3.665-.763-4.861-1.946-1.176-1.164-1.734-2.624-1.734-4.027z",
    glyphName: "category_outline_24",
    unicode: "\\uE956"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M341.333 661.333h53.333V608h-53.333zm98.125 0h243.2V608h-243.2zm243.2-371.208h-243.2v-53.333h243.2zm-341.325 0h53.333v-53.333h-53.333zm341.325 183.458h-243.2V420.25h243.2zm-341.325 0h53.333V420.25h-53.333zM791.273 832H232.728c-16.459 0-32.245-6.473-43.884-17.995s-18.177-27.15-18.177-43.445V125.44c0-16.294 6.538-31.923 18.177-43.445S216.269 64 232.728 64h558.545c16.459 0 32.245 6.473 43.883 17.995s18.178 27.151 18.178 43.445v645.12c0 16.295-6.539 31.922-18.178 43.445C823.519 825.527 807.732 832 791.273 832m-564.907-55.897c1.596 1.58 3.874 2.563 6.362 2.563h558.545c2.487 0 4.766-.983 6.362-2.563 1.579-1.562 2.366-3.567 2.366-5.543V125.44c0-1.975-.787-3.981-2.366-5.542-1.598-1.581-3.874-2.564-6.362-2.564H232.728c-2.487 0-4.766.983-6.362 2.564-1.579 1.562-2.366 3.567-2.366 5.542v645.12c0 1.976.787 3.981 2.366 5.543",
    glyphName: "category_outline_48",
    unicode: "\\uE957"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M926.165 652.494 435.497 161.827a42.67 42.67 0 0 0-61.622 1.339l-234.667 256 62.903 57.661 204.555-223.151 459.159 459.157z",
    glyphName: "check_12",
    unicode: "\\uE958"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M907.93 656.525 417.262 165.859a36.98 36.98 0 0 0-52.707.415L144.111 393.831l53.118 51.458 194.303-200.571 464.099 464.101 52.298-52.295z",
    glyphName: "check_18",
    unicode: "\\uE959"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M872.951 663.06 382.283 172.394c-10.831-10.833-28.39-10.833-39.221 0l-192 192 39.221 39.219 172.39-172.39 471.055 471.058z",
    glyphName: "check_24",
    unicode: "\\uE95A"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M872.192 663.808 381.525 173.141c-10.415-10.413-27.298-10.413-37.713 0l-192 192 37.712 37.713 173.144-173.143 471.81 471.81z",
    glyphName: "check_48",
    unicode: "\\uE95B"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M941.244 637.407 450.581 146.74c-24.994-24.993-65.516-24.993-90.51 0L85.334 405.333l90.51 90.51 229.483-213.338 445.412 445.412z",
    glyphName: "check_thick_12",
    unicode: "\\uE95C"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M917.123 642.436 426.458 151.768c-22.217-22.215-58.237-22.215-80.453 0L113.778 395.991l80.453 80.453 192.001-203.998 450.439 450.442z",
    glyphName: "check_thick_18",
    unicode: "\\uE95D"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M883.507 652.494 392.839 161.826c-16.662-16.661-43.677-16.661-60.34 0l-192 192 60.34 60.339 161.83-161.83 460.498 460.498 60.339-60.34z",
    glyphName: "check_thick_24",
    unicode: "\\uE95E"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M875.964 660.036 385.297 169.369c-12.497-12.497-32.759-12.497-45.254 0l-192.001 192 45.255 45.254 169.372-169.372L830.71 705.289z",
    glyphName: "check_thick_48",
    unicode: "\\uE95F"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "m170.673 679 341.333-341.333L853.341 679l60.339-60.34-401.674-401.673L110.333 618.66z",
    glyphName: "chevron_down_12",
    unicode: "\\uE960"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "m170.656 670.958 341.333-341.333 341.333 341.333 52.292-52.295-393.625-393.628-393.628 393.628z",
    glyphName: "chevron_down_18",
    unicode: "\\uE961"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "m170.659 657.885 341.333-341.333 341.333 341.333 39.219-39.221-380.553-380.555-380.554 380.555z",
    glyphName: "chevron_down_24",
    unicode: "\\uE962"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "m170.671 656.38 341.334-341.333L853.338 656.38l37.713-37.711-379.046-379.046-379.046 379.046z",
    glyphName: "chevron_down_48",
    unicode: "\\uE963"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "m785.582 785.783-380.013-337.79 380.013-337.789-56.692-63.782-451.765 401.572L728.89 849.563l56.692-63.779z",
    glyphName: "chevron_left_12",
    unicode: "\\uE964"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M777.529 786.266 396.984 448.004l380.545-338.26-49.135-55.279-442.728 393.539 442.728 393.537z",
    glyphName: "chevron_left_18",
    unicode: "\\uE965"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M764.48 787.033 383.072 448.004 764.48 108.975l-36.851-41.459-428.046 380.489L727.629 828.49z",
    glyphName: "chevron_left_24",
    unicode: "\\uE966"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "m762.985 787.117-381.508-339.12 381.508-339.119-35.433-39.861-426.353 378.98 426.353 378.981z",
    glyphName: "chevron_left_48",
    unicode: "\\uE967"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "m337.776 849.562 451.765-401.569L337.776 46.421l-56.692 63.782 380.013 337.789-380.013 337.79 56.692 63.779z",
    glyphName: "chevron_right_12",
    unicode: "\\uE968"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "m338.272 841.541 442.733-393.537L338.272 54.465l-49.133 55.279 380.546 338.26-380.546 338.262z",
    glyphName: "chevron_right_18",
    unicode: "\\uE969"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "m339.037 828.489 428.049-380.485L339.037 67.515l-36.85 41.459 381.409 339.029-381.409 339.029z",
    glyphName: "chevron_right_24",
    unicode: "\\uE96A"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "m339.121 826.979 426.353-378.981-426.353-378.98-35.433 39.861 381.508 339.119-381.508 339.12z",
    glyphName: "chevron_right_48",
    unicode: "\\uE96B"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "m170.676 709.167 341.333-341.333 341.332 341.333 90.513-90.51-431.846-431.843L80.165 618.657l90.509 90.51z",
    glyphName: "chevron_thick_down_12",
    unicode: "\\uE96C"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "m170.675 699.125 341.333-341.334 341.336 341.334 80.452-80.453-421.788-421.785L90.222 618.672z",
    glyphName: "chevron_thick_down_18",
    unicode: "\\uE96D"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "m170.673 679.011 341.335-341.334 341.333 341.334 60.339-60.34-401.673-401.672-401.675 401.672z",
    glyphName: "chevron_thick_down_24",
    unicode: "\\uE96E"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "m170.672 663.921 341.333-341.333 341.333 341.333 45.254-45.254-386.588-386.588-386.588 386.588 45.255 45.254z",
    glyphName: "chevron_thick_down_48",
    unicode: "\\uE96F"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M730.628 879.688 244.98 448.001 730.628 16.316l85.038 95.666-378.021 336.019 378.021 336.018z",
    glyphName: "chevron_thick_left_12",
    unicode: "\\uE970"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M730.078 869.625 255.724 447.977 730.078 26.328l75.588 85.038-378.684 336.612 378.684 336.609z",
    glyphName: "chevron_thick_left_18",
    unicode: "\\uE971"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M728.87 849.573 277.105 448.004 728.87 46.434l56.691 63.778-380.013 337.792 380.013 337.79z",
    glyphName: "chevron_thick_left_24",
    unicode: "\\uE972"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M727.991 834.511 293.166 448 727.991 61.491l42.519 47.834L389.499 448 770.51 786.676z",
    glyphName: "chevron_thick_left_48",
    unicode: "\\uE973"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "m336.038 879.688 485.648-431.687L336.038 16.316 251 111.982l378.021 336.019L251 784.019z",
    glyphName: "chevron_thick_right_12",
    unicode: "\\uE974"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "m336.618 869.625 474.356-421.648L336.618 26.328l-75.59 85.038 378.688 336.612-378.688 336.609z",
    glyphName: "chevron_thick_right_18",
    unicode: "\\uE975"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "m337.797 849.573 451.767-401.569-451.767-401.57-56.692 63.778 380.016 337.792-380.016 337.79z",
    glyphName: "chevron_thick_right_24",
    unicode: "\\uE976"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M338.675 834.511 773.5 448 338.675 61.491l-42.519 47.834L677.167 448 296.156 786.676z",
    glyphName: "chevron_thick_right_48",
    unicode: "\\uE977"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "m512.009 709.167 431.846-431.843-90.513-90.51L512.01 528.147 170.677 186.814l-90.509 90.51 431.843 431.843z",
    glyphName: "chevron_thick_up_12",
    unicode: "\\uE978"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "m512.009 699.125 421.788-421.786-80.452-80.452-341.336 341.332-341.333-341.332-80.453 80.452z",
    glyphName: "chevron_thick_up_18",
    unicode: "\\uE979"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "m512.009 679.011 401.673-401.673-60.339-60.339L512.01 558.331 170.675 216.999l-60.34 60.339z",
    glyphName: "chevron_thick_up_24",
    unicode: "\\uE97A"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "m512.004 663.921 386.588-386.588-45.254-45.254-341.333 341.333-341.333-341.333-45.255 45.254 386.588 386.588z",
    glyphName: "chevron_thick_up_48",
    unicode: "\\uE97B"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "m512.007 679 401.674-401.673-60.339-60.339-341.335 341.333-341.333-341.333-60.34 60.339z",
    glyphName: "chevron_up_12",
    unicode: "\\uE97C"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "m511.989 670.958 393.625-393.625-52.292-52.298-341.333 341.334-341.333-341.334-52.295 52.298z",
    glyphName: "chevron_up_18",
    unicode: "\\uE97D"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "m511.991 657.885 380.553-380.552-39.219-39.223-341.333 341.334L170.659 238.11l-39.221 39.223z",
    glyphName: "chevron_up_24",
    unicode: "\\uE97E"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M512.004 656.38 891.05 277.336l-37.713-37.713-341.333 341.333L170.67 239.623l-37.712 37.713z",
    glyphName: "chevron_up_48",
    unicode: "\\uE97F"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M853.333 448c0-188.513-152.82-341.333-341.333-341.333S170.667 259.487 170.667 448 323.487 789.333 512 789.333 853.333 636.513 853.333 448",
    glyphName: "circle_12",
    unicode: "\\uE980"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M938.667 448C938.667 212.361 747.64 21.333 512 21.333 276.358 21.333 85.333 212.36 85.333 448c0 235.642 191.025 426.667 426.667 426.667 235.639 0 426.667-191.025 426.667-426.667",
    glyphName: "circle_18",
    unicode: "\\uE981"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M938.667 448C938.667 212.361 747.64 21.333 512 21.333 276.358 21.333 85.333 212.36 85.333 448c0 235.642 191.025 426.667 426.667 426.667 235.639 0 426.667-191.025 426.667-426.667",
    glyphName: "circle_24",
    unicode: "\\uE982"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M938.667 448c0-235.642-191.025-426.667-426.667-426.667S85.333 212.358 85.333 448 276.358 874.667 512 874.667 938.667 683.642 938.667 448",
    glyphName: "circle_48",
    unicode: "\\uE983"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M512 21.333c235.641 0 426.667 191.025 426.667 426.667S747.642 874.667 512 874.667 85.333 683.642 85.333 448 276.358 21.333 512 21.333m-69.368 225.799c-16.663-16.662-43.678-16.662-60.34 0l-128 128 60.34 60.34 97.83-97.83 296.941 296.941 60.34-60.339z",
    glyphName: "circle_check_12",
    unicode: "\\uE984"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M512 21.333c235.639 0 426.667 191.027 426.667 426.667 0 235.642-191.027 426.667-426.667 426.667-235.642 0-426.667-191.025-426.667-426.667C85.333 212.361 276.358 21.333 512 21.333m-73.428 229.871c-14.441-14.438-37.854-14.438-52.295 0l-128 128 52.295 52.296 101.853-101.852 300.962 300.963 52.298-52.295z",
    glyphName: "circle_check_18",
    unicode: "\\uE985"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M512 21.333c235.639 0 426.667 191.027 426.667 426.667 0 235.642-191.027 426.667-426.667 426.667-235.642 0-426.667-191.025-426.667-426.667C85.333 212.361 276.358 21.333 512 21.333m-79.945 236.378c-10.832-10.833-28.392-10.833-39.222 0l-128 128 39.221 39.219 108.39-108.39 307.501 307.502 39.219-39.221z",
    glyphName: "circle_check_24",
    unicode: "\\uE986"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M512 21.333c235.642 0 426.667 191.025 426.667 426.667S747.642 874.667 512 874.667 85.333 683.642 85.333 448 276.358 21.333 512 21.333M431.296 258.49c-10.415-10.415-27.298-10.415-37.713 0l-128 128 37.713 37.711 109.143-109.143 308.256 308.256 37.711-37.713z",
    glyphName: "circle_check_48",
    unicode: "\\uE987"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M512 21.333c235.641 0 426.667 191.025 426.667 426.667S747.642 874.667 512 874.667 85.333 683.642 85.333 448 276.358 21.333 512 21.333M448 704h85.333V448.003H704V362.67H490.667c-23.564 0-42.667 19.102-42.667 42.667z",
    glyphName: "clock_12",
    unicode: "\\uE988"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M512.006-15.65c256.063 0 463.644 207.582 463.644 463.644 0 256.064-207.582 463.645-463.644 463.645-256.064 0-463.645-207.581-463.645-463.645S255.942-15.65 512.006-15.65m-63.359 741.831h80.365V441.815h191.639v-80.366H488.829c-22.192 0-40.182 17.988-40.182 40.183z",
    glyphName: "clock_18",
    unicode: "\\uE989"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M512 21.333c235.639 0 426.667 191.027 426.667 426.667 0 235.642-191.027 426.667-426.667 426.667-235.642 0-426.667-191.025-426.667-426.667C85.333 212.361 276.358 21.333 512 21.333M462.938 704h55.467V433.071h185.6v-55.467H490.672c-15.317 0-27.733 12.416-27.733 27.733v298.662z",
    glyphName: "clock_24",
    unicode: "\\uE98A"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M512 21.333c235.642 0 426.667 191.025 426.667 426.667S747.642 874.667 512 874.667 85.333 683.642 85.333 448 276.358 21.333 512 21.333M464 704h53.333V432.002H704v-53.333H490.667c-14.729 0-26.667 11.94-26.667 26.667z",
    glyphName: "clock_48",
    unicode: "\\uE98B"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M512 106.667c-188.513 0-341.333 152.82-341.333 341.333S323.487 789.333 512 789.333 853.333 636.513 853.333 448 700.513 106.667 512 106.667m0-85.334c235.641 0 426.667 191.025 426.667 426.667S747.642 874.667 512 874.667 85.333 683.642 85.333 448 276.358 21.333 512 21.333m-64 384.003V704h85.333V448.003H704V362.67H490.667c-23.564 0-42.667 19.102-42.667 42.667z",
    glyphName: "clock_outline_12",
    unicode: "\\uE98C"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M512.006 837.683c-215.219 0-389.689-174.47-389.689-389.689 0-215.216 174.47-389.689 389.689-389.689 215.216 0 389.689 174.473 389.689 389.689 0 215.219-174.473 389.689-389.689 389.689M48.361 447.994c0 256.064 207.581 463.645 463.645 463.645S975.65 704.058 975.65 447.994 768.068-15.65 512.006-15.65c-256.064 0-463.645 207.582-463.645 463.644m405.334-42.664v298.664h73.956V442.307h176.356v-73.958H490.674c-20.423 0-36.978 16.56-36.978 36.98z",
    glyphName: "clock_outline_18",
    unicode: "\\uE98D"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M512 76.8c-205.008 0-371.2 166.191-371.2 371.2S306.992 819.2 512 819.2c205.009 0 371.2-166.192 371.2-371.2S717.009 76.8 512 76.8m0-55.467c235.639 0 426.667 191.027 426.667 426.667 0 235.642-191.027 426.667-426.667 426.667-235.642 0-426.667-191.025-426.667-426.667C85.333 212.361 276.358 21.333 512 21.333m-49.067 384.005V704H518.4V433.071H704v-55.467H490.667c-15.317 0-27.733 12.416-27.733 27.733z",
    glyphName: "clock_outline_24",
    unicode: "\\uE98E"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M512 74.667c-206.187 0-373.333 167.147-373.333 373.333S305.814 821.333 512 821.333 885.333 654.186 885.333 448 718.186 74.667 512 74.667m0-53.334c235.642 0 426.667 191.025 426.667 426.667S747.642 874.667 512 874.667 85.333 683.642 85.333 448 276.358 21.333 512 21.333m-48 384.002V704h53.333V432.002H704v-53.333H490.667c-14.729 0-26.667 11.938-26.667 26.667z",
    glyphName: "clock_outline_48",
    unicode: "\\uE98F"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "m548.594 52.446 60.434 100.721c207.905 35.272 363.78 181.575 363.78 356.7 0 201.474-206.307 364.8-460.8 364.8s-460.8-163.326-460.8-364.8c0-175.125 155.875-321.428 363.78-356.7l60.434-100.721c16.572-27.622 56.601-27.622 73.172 0",
    glyphName: "comment_12",
    unicode: "\\uE990"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M497.365 26.761c6.629-11.048 22.641-11.048 29.269 0l81.189 135.316C813.158 196.91 967.11 341.408 967.11 514.371c0 198.986-203.759 360.296-455.111 360.296S56.888 713.357 56.888 514.371c0-172.963 153.95-317.461 359.289-352.294l81.187-135.316z",
    glyphName: "comment_18",
    unicode: "\\uE991"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M610.816 152.597c211.755 35.925 370.517 184.939 370.517 363.307 0 205.203-210.129 371.554-469.333 371.554-259.206 0-469.333-166.351-469.333-371.554 0-178.368 158.761-327.381 370.516-363.307l80.526-134.208c8.286-13.807 28.297-13.807 36.582 0z",
    glyphName: "comment_24",
    unicode: "\\uE992"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M610.816 152.608c211.757 35.923 370.517 184.937 370.517 363.305 0 205.205-210.127 371.556-469.333 371.556S42.667 721.118 42.667 515.913c0-178.368 158.761-327.381 370.517-363.305l80.523-134.206c8.286-13.811 28.301-13.811 36.587 0z",
    glyphName: "comment_48",
    unicode: "\\uE993"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "m556.052 230.732 38.703 6.566c182.449 30.953 292.72 153.092 292.72 272.569 0 136.837-148.441 279.467-375.467 279.467s-375.467-142.63-375.467-279.467c0-119.477 110.271-241.616 292.72-272.569l38.702-6.566 44.045-73.407zm52.976-77.565L548.594 52.446c-16.572-27.622-56.601-27.622-73.172 0l-60.434 100.721c-207.904 35.272-363.78 181.575-363.78 356.7 0 201.474 206.307 364.8 460.8 364.8s460.8-163.326 460.8-364.8c0-175.125-155.875-321.428-363.78-356.7",
    glyphName: "comment_outline_12",
    unicode: "\\uE994"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "m561.91 229.296 33.541 5.689C778.73 266.08 893.156 389.637 893.156 514.37c0 142.968-153.611 286.341-381.156 286.341S130.844 657.338 130.844 514.37c0-124.733 114.427-248.29 297.703-279.385l33.543-5.689L512 146.113zM526.635 26.761c-6.629-11.048-22.641-11.048-29.269 0l-81.187 135.316C210.84 196.91 56.89 341.408 56.89 514.371c0 198.986 203.76 360.296 455.111 360.296s455.111-161.31 455.111-360.296c0-172.963-153.953-317.461-359.287-352.294L526.636 26.761z",
    glyphName: "comment_outline_18",
    unicode: "\\uE995"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "m576.371 203.017 25.161 4.267c195.209 33.118 324.331 166.421 324.331 308.621 0 163.19-172.514 316.087-413.862 316.087-241.353 0-413.867-152.897-413.867-316.087 0-142.195 129.114-275.494 324.315-308.617l25.155-4.267L511.988 95.71zm34.436-50.42L530.282 18.393c-8.286-13.811-28.301-13.811-36.587 0l-80.526 134.208C201.42 188.531 42.665 337.54 42.665 515.903c0 205.204 210.127 371.554 469.333 371.554 259.204 0 469.329-166.35 469.329-371.554 0-178.368-158.763-327.381-370.522-363.307z",
    glyphName: "comment_outline_24",
    unicode: "\\uE996"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "m581.679 195.268 21.289 3.612c197.754 33.549 331.433 169.271 331.433 317.033 0 169.655-178.302 324.623-422.4 324.623s-422.4-154.967-422.4-324.623c0-147.761 133.679-283.484 331.433-317.033l21.289-3.612 69.679-116.132 69.679 116.132zm29.137-42.66L530.293 18.402c-8.286-13.811-28.301-13.811-36.587 0l-80.523 134.206C201.427 188.531 42.666 337.545 42.666 515.913c0 205.205 210.127 371.556 469.333 371.556s469.333-166.351 469.333-371.556c0-178.368-158.761-327.381-370.517-363.305z",
    glyphName: "comment_outline_48",
    unicode: "\\uE997"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M938.667 661.333H256v85.333h682.667zm0-256H256v85.333h682.667zm0-256H256v85.333h682.667zM170.667 704c0-23.564-19.103-42.667-42.667-42.667S85.333 680.436 85.333 704s19.103 42.667 42.667 42.667 42.667-19.103 42.667-42.667m0-256c0-23.564-19.103-42.667-42.667-42.667S85.333 424.436 85.333 448s19.103 42.667 42.667 42.667 42.667-19.103 42.667-42.667m0-256c0-23.564-19.103-42.667-42.667-42.667S85.333 168.436 85.333 192s19.103 42.667 42.667 42.667 42.667-19.103 42.667-42.667",
    glyphName: "contentlist_12",
    unicode: "\\uE998"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M938.667 667.022H256v73.956h682.667zm0-256H256v73.956h682.667zm0-256H256v73.956h682.667zM170.667 704c0-23.564-19.103-42.667-42.667-42.667S85.333 680.436 85.333 704s19.103 42.667 42.667 42.667 42.667-19.103 42.667-42.667m0-256c0-23.564-19.103-42.667-42.667-42.667S85.333 424.436 85.333 448s19.103 42.667 42.667 42.667 42.667-19.103 42.667-42.667m0-256c0-23.563-19.103-42.667-42.667-42.667S85.333 168.436 85.333 192c0 23.563 19.103 42.667 42.667 42.667s42.667-19.103 42.667-42.667",
    glyphName: "contentlist_18",
    unicode: "\\uE999"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M938.667 676.267H256v55.467h682.667zm0-256H256v55.467h682.667zm0-256H256v55.467h682.667zM170.667 704c0-23.564-19.103-42.667-42.667-42.667S85.333 680.436 85.333 704s19.103 42.667 42.667 42.667 42.667-19.103 42.667-42.667m0-256c0-23.565-19.103-42.667-42.667-42.667S85.333 424.435 85.333 448s19.103 42.667 42.667 42.667 42.667-19.102 42.667-42.667m0-256c0-23.565-19.103-42.667-42.667-42.667S85.333 168.435 85.333 192s19.103 42.667 42.667 42.667 42.667-19.102 42.667-42.667",
    glyphName: "contentlist_24",
    unicode: "\\uE99A"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M938.667 677.333H256v53.333h682.667zm0-256H256v53.333h682.667zm0-256H256v53.333h682.667zM170.667 704c0-23.565-19.103-42.667-42.667-42.667S85.333 680.435 85.333 704s19.103 42.667 42.667 42.667 42.667-19.102 42.667-42.667m0-256c0-23.565-19.103-42.667-42.667-42.667S85.333 424.435 85.333 448s19.103 42.667 42.667 42.667 42.667-19.102 42.667-42.667m0-256c0-23.565-19.103-42.667-42.667-42.667S85.333 168.435 85.333 192s19.103 42.667 42.667 42.667 42.667-19.102 42.667-42.667",
    glyphName: "contentlist_48",
    unicode: "\\uE99B"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M746.667 789.333c-11.782 0-21.059-9.7-23.967-21.117C713.302 731.302 679.84 704 640 704s-73.302 27.302-82.7 64.216c-2.907 11.418-12.185 21.117-23.967 21.117h-448c-23.564 0-42.667-19.103-42.667-42.667V149.333c0-23.564 19.103-42.667 42.667-42.667h448c11.782 0 21.059 9.7 23.967 21.117 9.398 36.914 42.86 64.216 82.7 64.216s73.302-27.302 82.7-64.216c2.907-11.418 12.185-21.117 23.967-21.117h192c23.561 0 42.667 19.103 42.667 42.667v597.333c0 23.564-19.106 42.667-42.667 42.667z",
    glyphName: "coupon_121",
    unicode: "\\uE99C"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M746.667 789.333c-11.782 0-21.06-9.7-23.967-21.118-9.398-36.914-42.86-64.216-82.699-64.216s-73.302 27.302-82.701 64.216c-2.906 11.418-12.184 21.118-23.966 21.118h-448c-23.564 0-42.667-19.103-42.667-42.667V149.333c0-23.563 19.103-42.667 42.667-42.667h448c11.782 0 21.06 9.7 23.966 21.117 9.398 36.915 42.861 64.216 82.701 64.216s73.301-27.301 82.699-64.216c2.907-11.418 12.186-21.117 23.967-21.117h192c23.563 0 42.667 19.103 42.667 42.667v597.333c0 23.564-19.103 42.667-42.667 42.667z",
    glyphName: "coupon_181",
    unicode: "\\uE99D"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M746.667 789.333c-11.78 0-21.06-9.699-23.966-21.117C713.302 731.302 679.838 704 640 704s-73.301 27.302-82.701 64.216c-2.906 11.418-12.186 21.117-23.966 21.117h-448c-23.564 0-42.667-19.103-42.667-42.667V149.333c0-23.565 19.103-42.667 42.667-42.667h448c11.78 0 21.06 9.698 23.966 21.116C566.698 164.697 600.162 192 640 192s73.301-27.302 82.701-64.218c2.906-11.418 12.186-21.116 23.966-21.116h192c23.565 0 42.667 19.102 42.667 42.667v597.333c0 23.564-19.102 42.667-42.667 42.667z",
    glyphName: "coupon_241",
    unicode: "\\uE99E"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M746.667 789.333c-11.782 0-21.06-9.7-23.966-21.117C713.304 731.303 679.84 704 640 704s-73.303 27.302-82.701 64.216c-2.906 11.418-12.183 21.117-23.966 21.117h-448c-23.564 0-42.667-19.103-42.667-42.667V149.333c0-23.565 19.103-42.667 42.667-42.667h448c11.782 0 21.06 9.7 23.966 21.118 9.397 36.913 42.861 64.215 82.701 64.215s73.303-27.302 82.701-64.215c2.906-11.418 12.183-21.118 23.966-21.118h192c23.565 0 42.667 19.102 42.667 42.667v597.333c0 23.564-19.102 42.667-42.667 42.667z",
    glyphName: "coupon_481",
    unicode: "\\uE99F"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M787.807 704c-29.489-50.991-84.57-85.333-147.807-85.333S521.683 653.009 492.193 704H128V192h364.193c29.489 50.991 84.57 85.333 147.807 85.333S758.317 242.991 787.807 192H896v512zM722.7 768.216c2.907 11.418 12.185 21.117 23.967 21.117h192c23.561 0 42.667-19.103 42.667-42.667V149.333c0-23.564-19.106-42.667-42.667-42.667h-192c-11.782 0-21.059 9.7-23.967 21.117-9.398 36.914-42.86 64.216-82.7 64.216s-73.302-27.302-82.7-64.216c-2.907-11.418-12.185-21.117-23.967-21.117h-448c-23.564 0-42.667 19.103-42.667 42.667v597.333c0 23.564 19.103 42.667 42.667 42.667h448c11.782 0 21.059-9.7 23.967-21.117C566.698 731.302 600.16 704 640 704s73.302 27.302 82.7 64.216",
    glyphName: "coupon_outline_121",
    unicode: "\\uE9A0"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M781.09 715.378c-26.624-50.71-79.753-85.333-141.09-85.333s-114.464 34.624-141.092 85.333H116.622V180.622h382.286c26.628 50.711 79.754 85.333 141.092 85.333s114.466-34.623 141.09-85.333h126.288v534.756zm-58.391 52.838c2.907 11.418 12.186 21.118 23.967 21.118h192c23.563 0 42.667-19.103 42.667-42.667V149.334c0-23.563-19.103-42.667-42.667-42.667h-192c-11.782 0-21.06 9.7-23.967 21.117C713.301 164.699 679.839 192 640 192s-73.302-27.301-82.701-64.216c-2.906-11.418-12.184-21.117-23.966-21.117h-448c-23.564 0-42.667 19.103-42.667 42.667v597.333c0 23.564 19.103 42.667 42.667 42.667h448c11.782 0 21.06-9.7 23.966-21.118C566.697 731.302 600.16 704 640 704s73.301 27.302 82.699 64.216",
    glyphName: "coupon_outline_181",
    unicode: "\\uE9A1"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M769.434 733.867c-21.525-50.163-71.317-85.333-129.434-85.333s-107.908 35.171-129.434 85.333H98.133V162.134h412.433c21.525 50.163 71.317 85.333 129.434 85.333s107.908-35.17 129.434-85.333h156.433v571.733zm-46.733 34.349c2.906 11.418 12.186 21.117 23.966 21.117h192c23.565 0 42.667-19.103 42.667-42.667V149.333c0-23.565-19.102-42.667-42.667-42.667h-192c-11.78 0-21.06 9.698-23.966 21.116C713.302 164.697 679.838 192 640 192s-73.301-27.302-82.701-64.218c-2.906-11.418-12.186-21.116-23.966-21.116h-448c-23.564 0-42.667 19.102-42.667 42.667v597.333c0 23.564 19.103 42.667 42.667 42.667h448c11.78 0 21.06-9.699 23.966-21.117C566.698 731.302 600.162 704 640 704s73.301 27.302 82.701 64.216",
    glyphName: "coupon_outline_241",
    unicode: "\\uE9A2"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M768.021 736c-20.894-50.091-70.289-85.333-128.021-85.333S532.873 685.91 511.979 736H96V160h415.979c20.894 50.091 70.289 85.333 128.021 85.333S747.127 210.09 768.021 160H928v576zm-45.32 32.216c2.906 11.418 12.183 21.117 23.966 21.117h192c23.565 0 42.667-19.103 42.667-42.667V149.333c0-23.565-19.102-42.667-42.667-42.667h-192c-11.782 0-21.06 9.7-23.966 21.118-9.397 36.913-42.861 64.215-82.701 64.215s-73.303-27.302-82.701-64.215c-2.906-11.418-12.183-21.118-23.966-21.118h-448c-23.564 0-42.667 19.102-42.667 42.667v597.333c0 23.564 19.103 42.667 42.667 42.667h448c11.782 0 21.06-9.7 23.966-21.117C566.696 731.303 600.16 704 640 704s73.303 27.302 82.701 64.216",
    glyphName: "coupon_outline_481",
    unicode: "\\uE9A3"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M108.8 802.125c-24.742 0-44.8-20.058-44.8-44.8v-134.4h896v134.4c0 24.742-20.062 44.8-44.8 44.8zm851.2-268.8H64v-403.2c0-24.738 20.058-44.8 44.8-44.8h806.4c24.738 0 44.8 20.062 44.8 44.8zm-328.384-179.2v89.6H870.4v-89.6z",
    glyphName: "credit_12",
    unicode: "\\uE9A4"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M128 789.333c-23.564 0-42.667-19.103-42.667-42.667V612.971h853.333v133.695c0 23.564-19.103 42.667-42.667 42.667h-768zm810.667-250.316H85.334V149.334c0-23.563 19.103-42.667 42.667-42.667h768c23.563 0 42.667 19.103 42.667 42.667v389.683zM625.92 368.35v73.956h227.413V368.35z",
    glyphName: "credit_18",
    unicode: "\\uE9A5"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M108.8 804.271c-24.742 0-44.8-20.058-44.8-44.8V609.387h896v150.084c0 24.742-20.058 44.8-44.8 44.8zM960 551.147H64V132.271c0-24.742 20.058-44.8 44.8-44.8h806.4c24.742 0 44.8 20.058 44.8 44.8zm-328.384-179.2v58.24H870.4v-58.24z",
    glyphName: "credit_24",
    unicode: "\\uE9A6"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M108.8 806.396c-24.742 0-44.8-20.058-44.8-44.8v-151.2h896v151.2c0 24.742-20.058 44.8-44.8 44.8zm851.2-252H64v-420c0-24.742 20.058-44.8 44.8-44.8h806.4c24.742 0 44.8 20.058 44.8 44.8zm-328.384-179.2v56H870.4v-56z",
    glyphName: "credit_48",
    unicode: "\\uE9A7"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M149.333 522.658v-352h725.333v352zM64 759.458c0 23.564 19.103 42.667 42.667 42.667h810.667c23.561 0 42.667-19.103 42.667-42.667V127.991c0-23.561-19.106-42.667-42.667-42.667H106.667C83.103 85.324 64 104.43 64 127.991zm810.667-125.867v83.2H149.334v-83.2zm-49.05-277.3H586.833v85.333h238.784z",
    glyphName: "credit_outline_12",
    unicode: "\\uE9A8"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M526.361 368.378h227.411v73.955H526.361zm412.306 378.289c0 23.564-19.103 42.667-42.667 42.667H128c-23.564 0-42.667-19.103-42.667-42.667V149.334c0-23.563 19.103-42.667 42.667-42.667h768c23.563 0 42.667 19.103 42.667 42.667zm-779.378-31.289h705.422V613H159.289zm0-534.756v358.422h705.422V180.622z",
    glyphName: "credit_outline_18",
    unicode: "\\uE9A9"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M119.467 552.559v-409.6h785.067v409.6zM64 761.625c0 23.564 19.103 42.667 42.667 42.667h810.667c23.565 0 42.667-19.103 42.667-42.667V130.159c0-23.565-19.102-42.667-42.667-42.667H106.667C83.103 87.492 64 106.594 64 130.159zm840.533-153.6v140.8H119.466v-140.8zM825.596 373.35H586.812v55.467h238.784z",
    glyphName: "credit_outline_24",
    unicode: "\\uE9AA"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M110.933 550.396V136.529h802.133v413.867zM64 763.729c0 23.564 19.103 42.667 42.667 42.667h810.667c23.565 0 42.667-19.103 42.667-42.667V132.262c0-23.565-19.102-42.667-42.667-42.667H106.667C83.103 89.595 64 108.697 64 132.262zm849.067-149.333v145.067H110.934V614.396zm-87.471-237.875H586.812v53.333h238.784z",
    glyphName: "credit_outline_48",
    unicode: "\\uE9AB"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M682.667 448c0-94.257-76.41-170.667-170.667-170.667S341.333 353.743 341.333 448 417.743 618.667 512 618.667 682.667 542.257 682.667 448M469.333 786.692C314.934 767.439 192.56 645.065 173.307 490.666H85.333v-85.333h87.974C192.56 250.934 314.934 128.56 469.333 109.307V21.333h85.333v87.974c154.399 19.253 276.773 141.627 296.026 296.026h87.974v85.333h-87.974c-19.253 154.399-141.627 276.773-296.026 296.026v87.974h-85.333zM512 192c-141.385 0-256 114.615-256 256s114.615 256 256 256 256-114.615 256-256-114.615-256-256-256",
    glyphName: "current_location_12",
    unicode: "\\uE9AC"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M682.667 448c0-94.259-76.407-170.667-170.667-170.667-94.256 0-170.667 76.407-170.667 170.667 0 94.256 76.41 170.667 170.667 170.667 94.259 0 170.667-76.41 170.667-170.667M475.022 787.354c-158.975-17.125-285.251-143.401-302.376-302.376H85.333v-73.956h87.313c17.125-158.976 143.401-285.252 302.376-302.376V21.333h73.956v87.313c158.976 17.124 285.252 143.4 302.376 302.376h87.313v73.956h-87.313c-17.124 158.975-143.4 285.251-302.376 302.376v87.313h-73.956zM512 180.622c-147.669 0-267.378 119.711-267.378 267.378 0 147.669 119.709 267.378 267.378 267.378 147.666 0 267.378-119.709 267.378-267.378 0-147.666-119.711-267.378-267.378-267.378",
    glyphName: "current_location_18",
    unicode: "\\uE9AD"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M682.667 448c0-94.255-76.412-170.667-170.667-170.667-94.257 0-170.667 76.412-170.667 170.667 0 94.257 76.41 170.667 170.667 170.667 94.255 0 170.667-76.41 170.667-170.667m-198.4 340.223c-166.395-13.379-299.11-146.094-312.489-312.489H85.334v-55.467h86.444c13.379-166.396 146.094-299.11 312.489-312.491V21.333h55.467v86.443c166.396 13.38 299.11 146.095 312.491 312.491h86.443v55.467h-86.443c-13.38 166.395-146.095 299.11-312.491 312.489v86.444h-55.467zM512 162.133c-157.88 0-285.867 127.987-285.867 285.867S354.12 733.867 512 733.867c157.879 0 285.867-127.987 285.867-285.867S669.88 162.133 512 162.133",
    glyphName: "current_location_24",
    unicode: "\\uE9AE"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M682.667 448c0-94.257-76.41-170.667-170.667-170.667S341.333 353.743 341.333 448 417.743 618.667 512 618.667 682.667 542.257 682.667 448M485.333 788.307c-167.251-12.924-300.716-146.389-313.64-313.64h-86.36v-53.333h86.36c12.924-167.251 146.389-300.717 313.64-313.641V21.334h53.333v86.359c167.251 12.924 300.717 146.389 313.641 313.641h86.359v53.333h-86.359c-12.924 167.251-146.389 300.716-313.641 313.64v86.36h-53.333zM512 160c-159.057 0-288 128.943-288 288s128.943 288 288 288 288-128.943 288-288-128.943-288-288-288",
    glyphName: "current_location_48",
    unicode: "\\uE9AF"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M384 832h256v85.333H384zm512-128h-42.667V64c0-23.561-19.103-42.667-42.667-42.667H213.333c-23.564 0-42.667 19.106-42.667 42.667v640h-42.667v85.333h768zM362.667 576V234.667H448V576zM576 576V234.667h85.333V576z",
    glyphName: "delete_12",
    unicode: "\\uE9B0"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M384 837.711h256v73.956H384zm512-128h-48.356V64.023c0-20.423-16.555-36.978-36.978-36.978H213.333c-20.423 0-36.978 16.555-36.978 36.978v645.688h-48.356v73.956h768zM368.361 576V234.667h73.956V576zm213.334 0V234.667h73.956V576z",
    glyphName: "delete_18",
    unicode: "\\uE9B1"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M384 846.95h256v55.467H384zm512-128h-57.6V64.017c0-15.317-12.416-27.733-27.733-27.733H213.334c-15.317 0-27.733 12.416-27.733 27.733V718.95h-57.6v55.467h768V718.95zM377.604 576V234.667h55.467V576zm213.334 0V234.667h55.467V576z",
    glyphName: "delete_24",
    unicode: "\\uE9B2"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M384 848h256v53.333H384zm512-128h-58.667V64c0-14.729-11.938-26.667-26.667-26.667H213.333c-14.728 0-26.667 11.938-26.667 26.667v656h-58.667v53.333h768zM378.667 576V234.667H432V576zM592 576V234.667h53.333V576z",
    glyphName: "delete_48",
    unicode: "\\uE9B3"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M170.667 746.667c0 23.564 19.103 42.667 42.667 42.667h597.333c23.564 0 42.667-19.103 42.667-42.667V64c0-23.561-19.103-42.667-42.667-42.667H213.334c-23.564 0-42.667 19.106-42.667 42.667zM256 704V106.667h512V704zm106.667-469.333H448V576h-85.333zm213.333 0V576h85.333V234.667zM896 704H128v85.333h768zM640 832v85.333H384V832z",
    glyphName: "delete_outline_12",
    unicode: "\\uE9B4"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M176.356 746.689c0 20.423 16.555 36.978 36.978 36.978h597.333c20.423 0 36.978-16.555 36.978-36.978V64.023c0-20.423-16.555-36.978-36.978-36.978H213.334c-20.423 0-36.978 16.555-36.978 36.978zm73.955-36.978V101h523.378v608.711zm118.045-475.022v341.333h73.956V234.689zm213.333 0v341.333h73.956V234.689zM896 709.711H128v73.956h768zm-256 128H384v73.956h256z",
    glyphName: "delete_outline_18",
    unicode: "\\uE9B5"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M185.6 746.683c0 15.317 12.416 27.733 27.733 27.733h597.333c15.317 0 27.733-12.416 27.733-27.733V64.017c0-15.317-12.416-27.733-27.733-27.733H213.333c-15.317 0-27.733 12.416-27.733 27.733zm55.467-27.733V91.75h541.867v627.2zM377.6 234.684v341.333h55.467V234.684zm213.333 0H646.4v341.333h-55.467zM896 718.95H128v55.467h768zm-256 128H384v55.467h256z",
    glyphName: "delete_outline_24",
    unicode: "\\uE9B6"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M186.667 746.667c0 14.728 11.939 26.667 26.667 26.667h597.333c14.729 0 26.667-11.939 26.667-26.667V64c0-14.729-11.938-26.667-26.667-26.667H213.334c-14.728 0-26.667 11.938-26.667 26.667zM240 720V90.667h544V720zm138.667-485.333V576H432V234.667zm213.333 0V576h53.333V234.667zM896 720H128v53.333h768zM640 848H384v53.333h256z",
    glyphName: "delete_outline_48",
    unicode: "\\uE9B7"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "m140.5 136.834 60.34-60.341 311.165 311.165L823.17 76.493l60.338 60.341-311.163 311.165 311.163 311.162-60.341 60.34-311.162-311.163-311.162 311.163-60.34-60.34 311.163-311.162-311.165-311.165z",
    glyphName: "dismiss_12",
    unicode: "\\uE9B8"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M512.009 395.697 196.823 80.509l-52.295 52.298 315.186 315.185-315.185 315.185 52.295 52.295 315.185-315.185 315.184 315.185 52.298-52.295-315.188-315.185 315.188-315.185-52.298-52.298z",
    glyphName: "dismiss_18",
    unicode: "\\uE9B9"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M472.785 448 151.063 769.722l39.221 39.22 321.721-321.723 321.724 321.723 39.223-39.22L551.228 448l321.724-321.724-39.223-39.219-321.724 321.719L190.284 87.057l-39.221 39.219z",
    glyphName: "dismiss_24",
    unicode: "\\uE9BA"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "m151.812 125.525 37.712-37.711 322.477 322.477L834.478 87.814l37.713 37.711-322.477 322.479L872.191 770.48l-37.713 37.712-322.477-322.477-322.477 322.477-37.712-37.712 322.476-322.476z",
    glyphName: "dismiss_48",
    unicode: "\\uE9BB"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M85.333 448c0 235.641 191.025 426.667 426.667 426.667S938.667 683.642 938.667 448 747.642 21.333 512 21.333 85.333 212.358 85.333 448m426.674-60.34 119.166-119.166 60.34 60.34L572.346 448l119.16 119.16-60.34 60.34-119.159-119.16-119.16 119.16-60.34-60.34L451.667 448 332.5 328.834l60.34-60.34z",
    glyphName: "dismiss_circle_12",
    unicode: "\\uE9BC"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M85.333 448c0 235.642 191.025 426.667 426.667 426.667 235.639 0 426.667-191.025 426.667-426.667C938.667 212.361 747.64 21.333 512 21.333 276.358 21.333 85.333 212.36 85.333 448m426.656-52.295 123.192-123.196 52.298 52.298L564.283 448l123.179 123.178-52.298 52.295-123.175-123.178-123.178 123.178-52.295-52.295L459.694 448 336.499 324.807l52.295-52.298z",
    glyphName: "dismiss_circle_18",
    unicode: "\\uE9BD"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M85.333 448c0 235.642 191.025 426.667 426.667 426.667 235.639 0 426.667-191.025 426.667-426.667C938.667 212.361 747.64 21.333 512 21.333 276.358 21.333 85.333 212.36 85.333 448m426.658-39.219 129.728-129.732 39.223 39.223L551.21 448l129.719 129.716-39.223 39.221-129.715-129.718-129.716 129.718-39.221-39.221L472.772 448 343.041 318.272l39.221-39.223z",
    glyphName: "dismiss_circle_24",
    unicode: "\\uE9BE"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M85.333 448c0 235.642 191.025 426.667 426.667 426.667S938.667 683.642 938.667 448 747.642 21.333 512 21.333 85.333 212.358 85.333 448m426.669-37.705 130.477-130.477 37.713 37.713-130.477 130.477 130.477 130.477-37.713 37.713-130.477-130.477-130.477 130.477-37.713-37.713 130.477-130.477-130.477-130.477 37.713-37.713z",
    glyphName: "dismiss_circle_48",
    unicode: "\\uE9BF"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M631.166 268.494 512.003 387.658 392.839 268.494l-60.34 60.34 119.164 119.163-119.164 119.164 60.34 60.34 119.164-119.164 119.163 119.164 60.34-60.34-119.164-119.164 119.164-119.163zM85.333 448c0 235.641 191.025 426.667 426.667 426.667S938.667 683.642 938.667 448 747.642 21.333 512 21.333 85.333 212.358 85.333 448M512 789.333c-188.513 0-341.333-152.82-341.333-341.333S323.487 106.667 512 106.667 853.333 259.487 853.333 448 700.513 789.333 512 789.333",
    glyphName: "dismiss_circle_outline_12",
    unicode: "\\uE9C0"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "m564.303 447.991 123.188 123.186-52.298 52.295-123.184-123.186-123.186 123.186-52.295-52.295 123.186-123.186-123.186-123.184 52.295-52.298 123.186 123.188 123.184-123.188 52.298 52.298zM512 874.667C276.358 874.667 85.333 683.642 85.333 448 85.333 212.361 276.358 21.333 512 21.333c235.639 0 426.667 191.027 426.667 426.667 0 235.642-191.027 426.667-426.667 426.667M159.289 448c0 194.797 157.914 352.711 352.711 352.711 194.799 0 352.711-157.914 352.711-352.711 0-194.799-157.912-352.711-352.711-352.711-194.797 0-352.711 157.912-352.711 352.711",
    glyphName: "dismiss_circle_outline_18",
    unicode: "\\uE9C1"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M641.728 279.061 512.004 408.785 382.283 279.061l-39.221 39.219 129.722 129.724-129.722 129.723 39.221 39.221 129.721-129.725 129.724 129.725 39.223-39.221-129.724-129.723L680.951 318.28zM85.333 448c0 235.642 191.025 426.667 426.667 426.667 235.639 0 426.667-191.025 426.667-426.667C938.667 212.361 747.64 21.333 512 21.333 276.358 21.333 85.333 212.36 85.333 448M512 819.2c-205.008 0-371.2-166.192-371.2-371.2S306.992 76.8 512 76.8c205.009 0 371.2 166.191 371.2 371.2S717.009 819.2 512 819.2",
    glyphName: "dismiss_circle_outline_24",
    unicode: "\\uE9C2"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M512 847.997c-220.913 0-400-179.087-400-400 0-220.915 179.087-400 400-400s400 179.085 400 400c0 220.913-179.087 400-400 400M58.667 447.998c0 250.368 202.963 453.333 453.333 453.333 250.368 0 453.333-202.965 453.333-453.333C965.333 197.628 762.368-5.335 512-5.335c-250.37 0-453.333 202.963-453.333 453.333m453.331 37.717 130.477 130.477 37.713-37.713-130.477-130.477 130.477-130.477-37.711-37.713-130.479 130.479-130.477-130.479-37.713 37.713 130.479 130.477L343.81 578.479l37.711 37.713z",
    glyphName: "dismiss_circle_outline_48",
    unicode: "\\uE9C3"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M512.005 357.485 808.084 61.406l90.511 90.511-296.079 296.079 296.079 296.079-90.511 90.51-296.079-296.079-296.079 296.079-90.51-90.51 296.079-296.079-296.079-296.079 90.51-90.511z",
    glyphName: "dismiss_thick_12",
    unicode: "\\uE9C4"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M512.005 367.548 813.113 66.441l80.452 80.458-301.107 301.104L893.565 749.11l-80.452 80.453-301.108-301.107-301.107 301.107-80.453-80.453 301.107-301.107-301.107-301.104 80.453-80.458z",
    glyphName: "dismiss_thick_18",
    unicode: "\\uE9C5"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "m140.5 136.841 60.34-60.343 311.165 311.164L823.169 76.498l60.339 60.343L572.344 448l311.164 311.165-60.339 60.34-311.164-311.162L200.84 819.505l-60.34-60.34L451.665 448z",
    glyphName: "dismiss_thick_24",
    unicode: "\\uE9C6"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M875.964 129.295 830.71 84.038 512.003 402.745 193.298 84.038l-45.255 45.257L466.749 448 148.043 766.706l45.255 45.255 318.706-318.707 318.707 318.707 45.254-45.255L557.258 448l318.707-318.705z",
    glyphName: "dismiss_thick_48",
    unicode: "\\uE9C7"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M725.333 533.333H298.666L511.999 320z",
    glyphName: "dropdown_12",
    unicode: "\\uE9C8"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M725.333 533.333H298.666L511.999 320z",
    glyphName: "dropdown_18",
    unicode: "\\uE9C9"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M725.333 533.333H298.666L511.999 320z",
    glyphName: "dropdown_24",
    unicode: "\\uE9CA"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M156.628 685.252a27.74 27.74 0 0 0 27.533.341l384-213.333a27.733 27.733 0 0 0 0-48.487l-384-213.333a27.735 27.735 0 0 0-41.203 24.244v426.667c0 9.826 5.2 18.919 13.67 23.902zm298.636 0a27.74 27.74 0 0 0 27.533.341L866.8 472.26a27.74 27.74 0 0 0 0-48.487L482.797 210.44a27.735 27.735 0 0 0-41.202 24.244v426.667a27.73 27.73 0 0 0 13.669 23.902z",
    glyphName: "fastplay_12",
    unicode: "\\uE9CB"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M156.613 685.225a27.74 27.74 0 0 0 27.533.341l384-213.333a27.735 27.735 0 0 0 0-48.487l-384-213.33a27.73 27.73 0 0 0-41.202 24.241v426.667c0 9.827 5.2 18.92 13.669 23.903zm298.667 0a27.74 27.74 0 0 0 27.533.341L866.81 472.233a27.73 27.73 0 0 0 0-48.487l-383.997-213.33a27.73 27.73 0 0 0-41.202 24.241v426.667c0 9.827 5.2 18.92 13.669 23.903z",
    glyphName: "fastplay_18",
    unicode: "\\uE9CC"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M156.606 685.253a27.73 27.73 0 0 0 27.533.34L568.14 472.26a27.74 27.74 0 0 0 14.263-24.243 27.73 27.73 0 0 0-14.263-24.243L184.139 210.441a27.733 27.733 0 0 0-41.202 24.243V661.35c0 9.827 5.2 18.919 13.669 23.903m298.669 0a27.73 27.73 0 0 0 27.533.34l384-213.333a27.74 27.74 0 0 0 14.263-24.243 27.73 27.73 0 0 0-14.263-24.243l-384-213.333c-8.593-4.774-19.063-4.642-27.533.341s-13.67 14.076-13.67 23.902V661.35a27.74 27.74 0 0 0 13.67 23.903",
    glyphName: "fastplay_24",
    unicode: "\\uE9CD"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M156.607 685.231a27.73 27.73 0 0 0 27.533.341l257.465-143.036v118.793a27.733 27.733 0 0 0 41.201 24.243l384-213.333c8.804-4.892 14.266-14.172 14.266-24.243s-5.461-19.351-14.266-24.243l-384-213.333a27.735 27.735 0 0 0-41.201 24.243v118.793L184.14 210.42a27.735 27.735 0 0 0-41.202 24.243V661.33c0 9.826 5.2 18.918 13.669 23.902z",
    glyphName: "fastplay_48",
    unicode: "\\uE9CE"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M128 789.333C128 812.897 147.103 832 170.667 832h682.667c23.561 0 42.667-19.103 42.667-42.667V618.666a42.69 42.69 0 0 0-12.493-30.17L640.001 344.992V63.999c0-23.561-19.103-42.667-42.667-42.667H426.667C403.103 21.332 384 40.438 384 63.999v280.993L140.497 588.496A42.66 42.66 0 0 0 128 618.666z",
    glyphName: "filter_12",
    unicode: "\\uE9CF"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M133.695 789.328c0 20.423 16.555 36.978 36.978 36.978H853.34c20.423 0 36.978-16.555 36.978-36.978V618.661a36.98 36.98 0 0 0-10.832-26.147L634.318 347.347V63.995c0-20.423-16.555-36.978-36.978-36.978H426.673c-20.423 0-36.978 16.555-36.978 36.978v283.352L144.526 592.514a36.98 36.98 0 0 0-10.831 26.147z",
    glyphName: "filter_18",
    unicode: "\\uE9D0"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M142.938 789.329c0 15.317 12.416 27.733 27.733 27.733h682.667c15.317 0 27.733-12.416 27.733-27.733V618.662a27.73 27.73 0 0 0-8.124-19.61L625.071 351.177V63.996c0-15.317-12.416-27.733-27.733-27.733H426.671c-15.317 0-27.733 12.416-27.733 27.733v287.181L151.061 599.052a27.73 27.73 0 0 0-8.123 19.61z",
    glyphName: "filter_24",
    unicode: "\\uE9D1"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M144 789.333C144 804.061 155.939 816 170.667 816h682.667c14.729 0 26.667-11.939 26.667-26.667V618.666c0-7.072-2.81-13.856-7.81-18.857l-248.19-248.19V63.999c0-14.729-11.938-26.667-26.667-26.667H426.667C411.938 37.332 400 49.27 400 63.999v287.62l-248.189 248.19A26.67 26.67 0 0 0 144 618.666z",
    glyphName: "filter_48",
    unicode: "\\uE9D2"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M128 789.333C128 812.897 147.103 832 170.667 832h682.667c23.561 0 42.667-19.103 42.667-42.667V618.666a42.69 42.69 0 0 0-12.493-30.17L640.001 344.992V63.999c0-23.561-19.103-42.667-42.667-42.667H426.667C403.103 21.332 384 40.438 384 63.999v280.993L140.497 588.496A42.66 42.66 0 0 0 128 618.666zm85.333-42.666V636.34l243.503-243.504a42.66 42.66 0 0 0 12.497-30.17v-256h85.333v256a42.66 42.66 0 0 0 12.497 30.17L810.666 636.34v110.327z",
    glyphName: "filter_outline_12",
    unicode: "\\uE9D3"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M133.695 789.328c0 20.423 16.555 36.978 36.978 36.978H853.34c20.423 0 36.978-16.555 36.978-36.978V618.661a36.98 36.98 0 0 0-10.832-26.147L634.318 347.347V63.995c0-20.423-16.555-36.978-36.978-36.978H426.673c-20.423 0-36.978 16.555-36.978 36.978v283.352L144.526 592.514a36.98 36.98 0 0 0-10.831 26.147zm73.955-36.978V633.978l245.169-245.171a36.97 36.97 0 0 0 10.831-26.146V100.972h96.711v261.689a36.97 36.97 0 0 0 10.832 26.146l245.168 245.171V752.35z",
    glyphName: "filter_outline_18",
    unicode: "\\uE9D4"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M142.938 789.329c0 15.317 12.416 27.733 27.733 27.733h682.667c15.317 0 27.733-12.416 27.733-27.733V618.662a27.73 27.73 0 0 0-8.124-19.61L625.071 351.177V63.996c0-15.317-12.416-27.733-27.733-27.733H426.671c-15.317 0-27.733 12.416-27.733 27.733v287.181L151.061 599.052a27.73 27.73 0 0 0-8.123 19.61zm55.466-27.733V630.15L446.28 382.272a27.73 27.73 0 0 0 8.124-19.61V91.729h115.2v270.933a27.73 27.73 0 0 0 8.124 19.61L825.604 630.15v131.446z",
    glyphName: "filter_outline_24",
    unicode: "\\uE9D5"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M144 789.333C144 804.061 155.939 816 170.667 816h682.667c14.729 0 26.667-11.939 26.667-26.667V618.666c0-7.072-2.81-13.856-7.81-18.857l-248.19-248.19V63.999c0-14.729-11.938-26.667-26.667-26.667H426.667C411.938 37.332 400 49.27 400 63.999v287.62l-248.189 248.19A26.67 26.67 0 0 0 144 618.666zm53.333-26.666V629.713l248.19-248.19a26.67 26.67 0 0 0 7.81-18.857v-272h117.333v272c0 7.072 2.81 13.856 7.81 18.857l248.19 248.19v132.954z",
    glyphName: "filter_outline_48",
    unicode: "\\uE9D6"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M563.703 47.095c103.062 54.238 331.469 189.725 416.41 363.803C1009.374 477.014 1024 527.434 1024 590.222c0 156.967-130.679 284.444-291.596 284.444-64.323 0-123.467-20.465-171.58-54.765A296.5 296.5 0 0 1 512 776.204a296.7 296.7 0 0 1-48.824 43.697c-48.113 34.301-107.255 54.765-171.58 54.765C130.682 874.666 0 747.189 0 590.222c0-62.787 14.629-113.207 43.886-179.324C128.47 236.792 357.132 101.29 460.284 47.061c32.606-17.135 70.822-17.126 103.42.034z",
    glyphName: "heart_12",
    unicode: "\\uE9D7"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M707.914 832c-78.45 0-148.235-34.933-195.914-89.272C464.321 797.067 394.538 832 316.085 832 173.05 832 56.888 716.421 56.888 574.104c0-56.927 13.003-102.641 39.009-162.587C177.343 240.52 409.07 110.598 486.472 70.918c16.183-8.3 34.87-8.294 51.048.011 77.334 39.697 308.787 169.609 390.581 340.588 26.004 59.946 39.009 105.66 39.009 162.587C967.11 716.421 850.949 832 707.913 832z",
    glyphName: "heart_18",
    unicode: "\\uE9D8"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M981.333 578.84c0-59.647-13.41-107.549-40.23-170.358C856.875 229.585 618.744 93.593 538.658 51.793c-16.866-8.802-36.45-8.806-53.321-.013-80.157 41.783-318.57 177.783-402.442 356.702-26.819 62.81-40.229 110.711-40.229 170.358 0 149.119 119.792 270.222 267.296 270.222 60.957 0 116.84-20.778 161.717-55.376a275.6 275.6 0 0 0 40.32-38.162 275.6 275.6 0 0 0 40.32 38.162c44.877 34.598 100.762 55.376 161.715 55.376 147.507 0 267.298-121.103 267.298-270.222z",
    glyphName: "heart_24",
    unicode: "\\uE9D9"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M525.666 41.065C590.385 72.811 866.797 217.246 960.61 411.25c28.038 63.938 42.057 112.698 42.057 173.414 0 151.795-125.237 275.071-279.445 275.071-66.724 0-127.631-23.186-175.61-61.428A285.4 285.4 0 0 1 512 764.519a285 285 0 0 1-35.612 33.788c-47.979 38.243-108.885 61.428-175.61 61.428-154.208 0-279.445-123.276-279.445-275.071 0-60.717 14.019-109.476 42.057-173.414C156.799 217.23 433.559 72.788 498.331 41.057c8.717-4.271 18.62-4.267 27.334.009z",
    glyphName: "heart_48",
    unicode: "\\uE9DA"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M512 690.871a85.34 85.34 0 0 0-63.587 28.425c-38.235 42.723-93.984 70.036-156.817 70.036-115.796 0-206.263-91.257-206.263-199.111 0-46.205 9.86-84.142 35.947-143.343 34.038-69.21 99.953-136.447 176.076-195.373 75.282-58.274 153.524-103.09 202.636-128.91 7.732-4.065 16.234-4.064 23.967.007 49.068 25.827 127.236 70.647 202.501 128.925 76.072 58.905 142.054 126.152 176.29 195.421 26.061 59.161 35.917 97.085 35.917 143.273 0 107.854-90.467 199.111-206.263 199.111-62.833 0-118.582-27.313-156.817-70.036A85.34 85.34 0 0 0 512 690.871m468.113-279.972c-84.941-174.078-313.347-309.565-416.41-363.803-32.597-17.161-70.814-17.169-103.42-.034-103.152 54.229-331.814 189.731-416.398 363.837C14.628 477.015-.001 527.435-.001 590.223c0 156.967 130.682 284.444 291.596 284.444 64.324 0 123.467-20.465 171.58-54.765a296.5 296.5 0 0 0 48.824-43.697 296.7 296.7 0 0 0 48.824 43.697c48.113 34.301 107.256 54.765 171.58 54.765 160.916 0 291.596-127.477 291.596-284.444 0-62.787-14.626-113.207-43.887-179.324z",
    glyphName: "heart_outline_12",
    unicode: "\\uE9DB"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M512 668.773a73.96 73.96 0 0 0-55.591 25.18c-34.503 39.323-84.442 64.092-140.324 64.092-102.542 0-185.241-82.818-185.241-183.941 0-42.832 9.027-77.907 32.362-131.912 31.951-66.315 94.806-130.059 165.765-184.86 70.131-54.164 141.703-94.697 182.275-115.957a2.6 2.6 0 0 1 .556-.228.7.7 0 0 1 .151-.023c-.007 0 .01 0 0 0 .03 0 .11 0 .202.023.089.023.275.08.557.228 40.536 21.271 112.036 61.804 182.151 115.974 70.906 54.784 133.825 118.534 165.956 184.903 23.313 53.971 32.336 89.036 32.336 131.853 0 101.122-82.699 183.941-185.242 183.941-55.882 0-105.819-24.769-140.323-64.092a73.96 73.96 0 0 0-55.591-25.18zm416.102-257.256c-78.66-164.432-295.731-290.879-381.031-335.633-22.142-11.617-48.004-11.622-70.152-.017-85.374 44.737-302.694 171.201-381.021 335.65-26.006 59.946-39.009 105.66-39.009 162.587C56.889 716.421 173.05 832 316.086 832c53.424 0 102.829-16.199 143.97-43.695A265.2 265.2 0 0 0 512 742.728a265.2 265.2 0 0 0 51.944 45.577C605.087 815.801 654.489 832 707.914 832c143.036 0 259.197-115.579 259.197-257.896 0-56.927-13.005-102.641-39.009-162.587",
    glyphName: "heart_outline_18",
    unicode: "\\uE9DC"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M512 700.057a55.47 55.47 0 0 1 41.98 19.215c39.398 45.622 96.41 74.324 160.055 74.324 116.305 0 211.831-95.699 211.831-214.755 0-49.219-10.505-89.232-35.366-147.621-36.655-77.235-108.736-149.111-185.988-208.525-76.57-58.893-153.045-101.649-191.518-121.728-.567-.299-.887-.311-1.011-.311-.119 0-.439.013-1.007.311-38.507 20.07-115.065 62.822-191.66 121.711-77.3 59.43-149.332 131.302-185.799 208.499-24.873 58.411-35.384 98.432-35.384 147.664 0 119.057 95.526 214.755 211.83 214.755 63.648 0 120.659-28.702 160.057-74.324A55.47 55.47 0 0 1 512 700.057m429.103-291.575c26.82 62.81 40.23 110.711 40.23 170.358 0 149.119-119.791 270.222-267.298 270.222-60.954 0-116.838-20.778-161.715-55.376A275.6 275.6 0 0 1 512 755.524a275.6 275.6 0 0 1-40.32 38.162c-44.877 34.598-100.76 55.376-161.717 55.376-147.505 0-267.296-121.103-267.296-270.222 0-59.647 13.41-107.549 40.229-170.358C166.768 229.564 405.181 93.564 485.338 51.78c16.87-8.794 36.454-8.789 53.321.013 80.085 41.801 318.217 177.792 402.445 356.689z",
    glyphName: "heart_outline_24",
    unicode: "\\uE9DD"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M512 715.452a49.07 49.07 0 0 0-36.708 16.508c-42.598 48.031-104.713 78.708-174.513 78.708-127.843 0-230.379-102.034-230.379-226.004 0-51.251 11.315-92.881 37.569-152.894 41.459-85.542 125.68-164.019 212.383-226.714 79.33-57.365 155.953-98.142 191.633-116.006 35.652 17.871 112.188 58.65 191.484 116.015 86.643 62.682 170.908 141.163 212.578 226.743 26.242 59.991 37.553 101.615 37.553 152.855 0 123.97-102.537 226.004-230.379 226.004-69.801 0-131.915-30.677-174.513-78.708A49.07 49.07 0 0 0 512 715.451zm448.61-304.203C866.797 217.246 590.385 72.811 525.666 41.064c-8.715-4.275-18.618-4.279-27.334-.009C433.56 72.786 156.8 217.228 63.391 411.248c-28.038 63.938-42.057 112.698-42.057 173.414 0 151.795 125.237 275.071 279.445 275.071 66.724 0 127.631-23.186 175.61-61.428a285.4 285.4 0 0 0 35.612-33.788 285 285 0 0 0 35.612 33.788c47.979 38.243 108.885 61.428 175.61 61.428 154.208 0 279.445-123.276 279.445-275.071 0-60.717-14.018-109.476-42.057-173.414z",
    glyphName: "heart_outline_48",
    unicode: "\\uE9DE"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M538.874 886.65c-15.582 12.466-37.724 12.466-53.307 0L25.583 518.663l53.307-66.634 49.33 39.464V68.266c0-37.7 30.564-68.267 68.267-68.267h631.467c37.701 0 68.268 30.566 68.268 68.267v423.227l49.331-39.464 53.308 66.634zm272.014-326.89V85.333H213.555V559.76l298.667 238.933z",
    glyphName: "home_outline_12",
    unicode: "\\uE9DF"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M535.425 846.675c-13.505 10.804-32.695 10.804-46.199 0L71.111 512.183l46.199-57.75 46.659 37.327V106.695c0-36.13 29.29-65.422 65.422-65.422h565.893c36.136 0 65.422 29.292 65.422 65.422v385.044l46.632-37.305 46.199 57.75zm251.326-295.772V115.228H237.925v435.696l274.401 219.521z",
    glyphName: "home_outline_18",
    unicode: "\\uE9E0"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M529.327 875.006c-10.129 8.103-24.521 8.103-34.65 0L46.354 516.347l34.65-43.311 61.931 49.545V85.35c0-38.882 31.519-70.4 70.4-70.4h597.332c38.882 0 70.4 31.518 70.4 70.4v437.231l61.935-49.545 34.65 43.311zM825.6 566.954V85.351c0-8.247-6.686-14.933-14.933-14.933H213.335c-8.247 0-14.933 6.686-14.933 14.933v481.603L512 817.834z",
    glyphName: "home_outline_24",
    unicode: "\\uE9E1"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M526.581 898.316c-8.572 6.856-20.749 6.856-29.318 0L25.604 520.99l29.319-36.649 70.865 56.691V39.991c0-24.742 20.058-44.8 44.8-44.8h682.666c24.742 0 44.8 20.058 44.8 44.8v501.041l70.865-56.691 29.318 36.649zm324.54-319.737V42.125h-678.4v536.454l339.2 271.36z",
    glyphName: "home_outline_48",
    unicode: "\\uE9E2"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M512 21.333c235.641 0 426.667 191.025 426.667 426.667S747.642 874.667 512 874.667 85.333 683.642 85.333 448 276.358 21.333 512 21.333m-42.667 640h85.333v-64h-85.333zm0-106.666h85.333v-320h-85.333z",
    glyphName: "info_12",
    unicode: "\\uE9E3"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M512 21.333c235.639 0 426.667 191.027 426.667 426.667 0 235.642-191.027 426.667-426.667 426.667-235.642 0-426.667-191.025-426.667-426.667C85.333 212.361 276.358 21.333 512 21.333m-36.972 640h73.956v-64h-73.956zm0-106.666h73.956v-320h-73.956z",
    glyphName: "info_18",
    unicode: "\\uE9E4"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M512 21.333c235.639 0 426.667 191.027 426.667 426.667 0 235.642-191.027 426.667-426.667 426.667-235.642 0-426.667-191.025-426.667-426.667C85.333 212.361 276.358 21.333 512 21.333m-27.729 640h55.467v-64h-55.467zm0-106.666h55.467v-320h-55.467z",
    glyphName: "info_24",
    unicode: "\\uE9E5"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M512 21.333c235.642 0 426.667 191.025 426.667 426.667S747.642 874.667 512 874.667 85.333 683.642 85.333 448 276.358 21.333 512 21.333m-26.667 640h53.333v-64h-53.333zm0-106.666h53.333v-320h-53.333z",
    glyphName: "info_48",
    unicode: "\\uE9E6"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M512 106.667c-188.513 0-341.333 152.82-341.333 341.333S323.487 789.333 512 789.333 853.333 636.513 853.333 448 700.513 106.667 512 106.667m0-85.334c235.641 0 426.667 191.025 426.667 426.667S747.642 874.667 512 874.667 85.333 683.642 85.333 448 276.358 21.333 512 21.333m-42.667 576v64h85.333v-64zm0-362.666v320h85.333v-320z",
    glyphName: "info_outline_12",
    unicode: "\\uE9E7"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M512 95.289c-194.797 0-352.711 157.912-352.711 352.711 0 194.797 157.914 352.711 352.711 352.711 194.799 0 352.711-157.914 352.711-352.711 0-194.799-157.912-352.711-352.711-352.711m0-73.956c235.639 0 426.667 191.027 426.667 426.667 0 235.642-191.027 426.667-426.667 426.667-235.642 0-426.667-191.025-426.667-426.667C85.333 212.361 276.358 21.333 512 21.333m-36.978 576v64h73.956v-64zm0-362.666v320h73.956v-320z",
    glyphName: "info_outline_18",
    unicode: "\\uE9E8"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M512 76.8c-205.008 0-371.2 166.191-371.2 371.2S306.992 819.2 512 819.2c205.009 0 371.2-166.192 371.2-371.2S717.009 76.8 512 76.8m0-55.467c235.639 0 426.667 191.027 426.667 426.667 0 235.642-191.027 426.667-426.667 426.667-235.642 0-426.667-191.025-426.667-426.667C85.333 212.361 276.358 21.333 512 21.333m-27.733 576v64h55.467v-64zm0-362.666v320h55.467v-320z",
    glyphName: "info_outline_24",
    unicode: "\\uE9E9"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M512 74.667c-206.187 0-373.333 167.147-373.333 373.333S305.814 821.333 512 821.333 885.333 654.186 885.333 448 718.186 74.667 512 74.667m0-53.334c235.642 0 426.667 191.025 426.667 426.667S747.642 874.667 512 874.667 85.333 683.642 85.333 448 276.358 21.333 512 21.333m-26.667 576v64h53.333v-64zm0-362.666v320h53.333v-320z",
    glyphName: "info_outline_48",
    unicode: "\\uE9EA"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M106.667 725.333V128c0-47.13 38.205-85.333 85.333-85.333h597.333c47.129 0 85.333 38.204 85.333 85.333v298.667h-85.333V128H192v597.333h298.667v85.333H192c-47.128 0-85.333-38.205-85.333-85.333M771.66 768H618.667v85.333h256c23.561 0 42.667-19.103 42.667-42.667v-256h-85.333v152.993l-289.83-289.83-60.339 60.339 289.83 289.83z",
    glyphName: "launch_12",
    unicode: "\\uE9EB"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M184.895 738.128a5.69 5.69 0 0 1-5.689-5.689V135.106a5.69 5.69 0 0 1 5.689-5.689h597.333a5.69 5.69 0 0 1 5.689 5.689v298.667h73.956V135.106c0-43.986-35.658-79.644-79.644-79.644H184.896c-43.986 0-79.644 35.658-79.644 79.644v597.333c0 43.986 35.658 79.644 79.644 79.644h298.667v-73.956zm593.396 42.666h-166.73v73.956h256c20.423 0 36.978-16.555 36.978-36.978v-256h-73.956V728.5L531.041 428.958l-52.295 52.295L778.29 780.795z",
    glyphName: "launch_18",
    unicode: "\\uE9EC"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M192.004 740.262c-8.247 0-14.933-6.686-14.933-14.933V127.996c0-8.247 6.686-14.933 14.933-14.933h597.333c8.247 0 14.933 6.686 14.933 14.933v298.667h55.467V127.996c0-38.882-31.518-70.4-70.4-70.4H192.004c-38.881 0-70.4 31.518-70.4 70.4v597.333c0 38.881 31.519 70.4 70.4 70.4h298.667v-55.467zm615.714 42.667H618.671v55.467h256c15.317 0 27.733-12.416 27.733-27.733v-256h-55.467v189.046L531.613 428.387l-39.219 39.219L807.718 782.93z",
    glyphName: "launch_24",
    unicode: "\\uE9ED"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M192 741.333c-8.836 0-16-7.164-16-16V128c0-8.836 7.164-16 16-16h597.333c8.836 0 16 7.164 16 16v298.667h53.333V128c0-38.291-31.042-69.333-69.333-69.333H192c-38.292 0-69.333 31.042-69.333 69.333v597.333c0 38.292 31.041 69.333 69.333 69.333h298.667v-53.333zM810.287 784h-191.62v53.333h256c14.729 0 26.667-11.939 26.667-26.667v-256h-53.333v191.62L530.858 429.143l-37.713 37.713 317.143 317.143z",
    glyphName: "launch_48",
    unicode: "\\uE9EE"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M85.333 448c0 117.821 95.513 213.333 213.333 213.333h128V576h-128c-70.693 0-128-57.307-128-128s57.307-128 128-128h128v-85.333h-128C180.845 234.667 85.333 330.18 85.333 448m640-42.667H298.666v85.333h426.667zM938.667 448c0 117.821-95.513 213.333-213.333 213.333h-128V576h128c70.693 0 128-57.307 128-128s-57.307-128-128-128h-128v-85.333h128c117.821 0 213.333 95.513 213.333 213.333",
    glyphName: "link_12",
    unicode: "\\uE9EF"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M91.028 448.022c0 114.679 92.966 207.644 207.644 207.644h128V581.71h-128c-73.834 0-133.689-59.855-133.689-133.689 0-73.836 59.855-133.688 133.689-133.688h128v-73.956h-128c-114.679 0-207.644 92.968-207.644 207.644zm634.311-36.978H298.672V485h426.667zm207.644 36.978c0 114.679-92.968 207.644-207.644 207.644h-128V581.71h128c73.836 0 133.689-59.855 133.689-133.689 0-73.836-59.853-133.688-133.689-133.688h-128v-73.956h128c114.677 0 207.644 92.968 207.644 207.644z",
    glyphName: "link_18",
    unicode: "\\uE9F0"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M725.338 420.284H298.671v55.467h426.667zm-625.067 27.733c0 109.573 88.826 198.4 198.4 198.4h128V590.95h-128c-78.94 0-142.933-63.995-142.933-142.933 0-78.942 63.993-142.933 142.933-142.933h128v-55.467h-128c-109.574 0-198.4 88.828-198.4 198.4m823.467 0c0 109.573-88.828 198.4-198.4 198.4h-128V590.95h128c78.942 0 142.933-63.995 142.933-142.933 0-78.942-63.991-142.933-142.933-142.933h-128v-55.467h128c109.572 0 198.4 88.828 198.4 198.4",
    glyphName: "link_24",
    unicode: "\\uE9F1"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M725.333 421.333H298.666v53.333h426.667zm-624 26.667c0 108.983 88.349 197.333 197.333 197.333h128V592h-128c-79.529 0-144-64.471-144-144s64.471-144 144-144h128v-53.333h-128c-108.984 0-197.333 88.35-197.333 197.333m821.334 0c0 108.983-88.35 197.333-197.333 197.333h-128V592h128c79.529 0 144-64.471 144-144s-64.471-144-144-144h-128v-53.333h128c108.983 0 197.333 88.35 197.333 197.333",
    glyphName: "link_48",
    unicode: "\\uE9F2"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M559.621 49.408c98.404 79.664 315.046 277.524 315.046 475.383 0 188.513-162.371 341.333-362.667 341.333s-362.667-152.82-362.667-341.333c0-197.86 216.642-395.72 315.046-475.383 28.066-22.724 67.176-22.724 95.242 0M512 375.458c-70.693 0-128 57.308-128 128s57.307 128 128 128 128-57.307 128-128-57.307-128-128-128",
    glyphName: "location_12",
    unicode: "\\uE9F3"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M544.233 39.76c88.571 69.518 330.713 278.699 330.713 487.879 0 188.513-162.372 341.333-362.668 341.333s-362.667-152.82-362.667-341.333c0-209.18 242.141-418.361 330.712-487.879 18.938-14.859 44.972-14.859 63.91 0m-31.955 338.545c-70.692 0-128 57.308-128 128s57.308 128 128 128c70.691 0 128.001-57.308 128.001-128s-57.31-128-128.001-128",
    glyphName: "location_18",
    unicode: "\\uE9F4"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M536.098 35.072c81.028 62.532 338.569 278.263 338.569 493.99 0 188.513-162.372 341.333-362.667 341.333s-362.667-152.82-362.667-341.333c0-215.727 257.54-431.458 338.569-493.99 14.293-11.034 33.903-11.034 48.196 0M512 379.729c-70.694 0-128 57.306-128 128s57.306 128 128 128 128-57.307 128-128c0-70.694-57.306-128-128-128",
    glyphName: "location_24",
    unicode: "\\uE9F5"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M523.927 30.082c62.645 46.916 350.739 275.083 350.739 503.251 0 188.514-162.372 341.333-362.667 341.333S149.332 721.847 149.332 533.333c0-228.169 288.096-456.335 350.739-503.251 7.226-5.412 16.629-5.412 23.855 0zM512 384c-70.692 0-128 57.308-128 128s57.308 128 128 128 128-57.308 128-128-57.308-128-128-128",
    glyphName: "location_48",
    unicode: "\\uE9F6"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M789.333 524.791c0 136.585-119.219 256-277.333 256s-277.333-119.415-277.333-256c0-69.795 39.552-149.729 102.256-229.129 58.37-73.91 128.149-136.525 175.078-174.987 46.929 38.462 116.708 101.077 175.078 174.988 62.704 79.398 102.256 159.333 102.256 229.128zm85.334 0c0-197.86-216.642-395.72-315.046-475.383-28.066-22.724-67.176-22.724-95.242 0-98.404 79.664-315.046 277.524-315.046 475.383 0 188.513 162.371 341.333 362.667 341.333s362.667-152.82 362.667-341.333m-320-21.333c0 23.564-19.103 42.667-42.667 42.667s-42.667-19.103-42.667-42.667 19.103-42.667 42.667-42.667 42.667 19.103 42.667 42.667m85.333 0c0-70.692-57.307-128-128-128s-128 57.308-128 128 57.307 128 128 128 128-57.307 128-128",
    glyphName: "location_outline_12",
    unicode: "\\uE9F7"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M800.99 527.639c0 143.509-124.974 267.378-288.712 267.378S223.567 671.148 223.567 527.639c0-78.164 46.678-165.831 115.323-249.355 60.101-73.131 129.312-133.82 173.388-169.426 44.076 35.607 113.29 96.296 173.387 169.426 68.648 83.524 115.325 171.191 115.325 249.355m73.955 0c0-209.18-242.142-418.361-330.713-487.879-18.938-14.859-44.972-14.859-63.91 0-88.57 69.518-330.712 278.699-330.712 487.879 0 188.513 162.372 341.333 362.667 341.333s362.668-152.82 362.668-341.333m-308.623-21.334c0 29.848-24.197 54.044-54.044 54.044s-54.044-24.197-54.044-54.044c0-29.848 24.197-54.044 54.044-54.044s54.044 24.197 54.044 54.044m73.957 0c0-70.692-57.31-128-128.001-128s-128 57.308-128 128 57.308 128 128 128c70.691 0 128.001-57.308 128.001-128",
    glyphName: "location_outline_18",
    unicode: "\\uE9F8"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M819.2 529.062c0 154.76-134.323 285.867-307.2 285.867S204.8 683.822 204.8 529.062c0-87.548 53.468-182.528 125.904-268.77C396.099 182.434 470.246 119.556 512 86.622c41.754 32.934 115.9 95.812 181.295 173.67C765.73 346.534 819.2 441.514 819.2 529.062m55.467 0c0-215.727-257.54-431.458-338.569-493.99-14.293-11.034-33.903-11.034-48.196 0-81.029 62.532-338.569 278.263-338.569 493.99 0 188.513 162.371 341.333 362.667 341.333s362.667-152.82 362.667-341.333m-290.134-21.333c0-40.06-32.474-72.533-72.533-72.533s-72.533 32.474-72.533 72.533 32.474 72.533 72.533 72.533 72.533-32.474 72.533-72.533m55.467 0c0 70.693-57.306 128-128 128s-128-57.307-128-128c0-70.694 57.306-128 128-128s128 57.306 128 128",
    glyphName: "location_outline_24",
    unicode: "\\uE9F9"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M827.733 533.333c0 159.953-138.637 294.4-315.733 294.4s-315.733-134.447-315.733-294.4c0-96.117 61.939-199.01 140.292-288.721C402.278 169.369 473.856 109.794 512 80.047c38.144 29.747 109.722 89.323 175.441 164.565 78.353 89.711 140.292 192.604 140.292 288.721m46.934 0c0-228.169-288.094-456.335-350.739-503.251-7.226-5.412-16.629-5.412-23.855 0-62.643 46.916-350.739 275.083-350.739 503.251 0 188.514 162.372 341.333 362.667 341.333s362.667-152.819 362.667-341.333zM593.067 512c0 44.772-36.294 81.067-81.067 81.067S430.933 556.773 430.933 512s36.294-81.067 81.067-81.067 81.067 36.294 81.067 81.067M640 512c0-70.692-57.308-128-128-128s-128 57.308-128 128 57.308 128 128 128 128-57.308 128-128",
    glyphName: "location_outline_48",
    unicode: "\\uE9FA"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M275.692 684.308c0 108.757 88.166 196.923 196.923 196.923s196.923-88.166 196.923-196.923v-39.385h118.154c21.748 0 39.385-17.633 39.385-39.385v-512c0-21.748-17.636-39.385-39.385-39.385H157.538c-21.751 0-39.385 17.636-39.385 39.385v512c0 21.751 17.633 39.385 39.385 39.385h118.154zm315.077-39.385v39.385c0 65.255-52.899 118.154-118.154 118.154s-118.154-52.899-118.154-118.154v-39.385zM472.615 270.769c43.503 0 78.769 35.267 78.769 78.769s-35.267 78.769-78.769 78.769-78.769-35.267-78.769-78.769 35.267-78.769 78.769-78.769",
    glyphName: "lock_12",
    horizAdvX: 945,
    unicode: "\\uE9FB"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M288.342 690.547c0 108.643 88.073 196.716 196.716 196.716 108.641 0 196.716-88.073 196.716-196.716v-45.811h126.653c19.348 0 35.032-15.684 35.032-35.032V84.231c0-19.348-15.683-35.032-35.032-35.032H161.69c-19.348 0-35.032 15.683-35.032 35.032v525.473c0 19.348 15.684 35.032 35.032 35.032h126.653v45.811zm323.369-45.81v45.811c0 69.948-56.703 126.653-126.653 126.653-69.948 0-126.653-56.704-126.653-126.653v-45.811zM485.053 266.105c44.648 0 80.842 36.196 80.842 80.842s-36.194 80.842-80.842 80.842-80.842-36.196-80.842-80.842 36.194-80.842 80.842-80.842",
    glyphName: "lock_18",
    horizAdvX: 970,
    unicode: "\\uE9FC"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M301.06 693.776c0 105.19 85.273 190.464 190.464 190.464 105.189 0 190.464-85.274 190.464-190.464V638.48h137.216c14.705 0 26.624-11.92 26.624-26.624V79.376c0-14.705-11.919-26.624-26.624-26.624h-655.36c-14.704 0-26.624 11.919-26.624 26.624v532.48c0 14.704 11.92 26.624 26.624 26.624H301.06zm327.68-55.296v55.296c0 75.782-61.432 137.216-137.216 137.216s-137.216-61.434-137.216-137.216V638.48zm-137.22-374.8c45.244 0 81.92 36.676 81.92 81.92s-36.676 81.92-81.92 81.92-81.92-36.676-81.92-81.92 36.676-81.92 81.92-81.92",
    glyphName: "lock_24",
    horizAdvX: 983,
    unicode: "\\uE9FD"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M314.404 682.404C314.404 791.533 402.871 880 512 880s197.596-88.467 197.596-197.596v-58.01h143.213c15.017 0 27.191-12.175 27.191-27.194V43.389c0-15.019-12.175-27.194-27.191-27.194H171.193c-15.018 0-27.192 12.175-27.192 27.194V597.2c0 15.019 12.174 27.194 27.192 27.194h143.212zm340.809-58.009v58.01c0 79.093-64.119 143.212-143.213 143.212s-143.213-64.118-143.213-143.212v-58.01zM512 235.093c47.055 0 85.201 38.146 85.201 85.203 0 47.055-38.146 85.201-85.201 85.201s-85.201-38.146-85.201-85.201c0-47.057 38.146-85.203 85.201-85.203",
    glyphName: "lock_48",
    unicode: "\\uE9FE"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M298.667 704c0 117.821 95.513 213.333 213.333 213.333S725.333 821.82 725.333 704V576H298.666zM512 832c-70.693 0-128-57.307-128-128v-42.667h256V704c0 70.693-57.307 128-128 128M128 618.667c0 23.564 19.103 42.667 42.667 42.667h682.667c23.561 0 42.667-19.103 42.667-42.667V64c0-23.561-19.106-42.667-42.667-42.667H170.667C147.103 21.333 128 40.439 128 64zM213.333 576V106.667h597.333V576zm384-234.667C597.333 294.205 559.128 256 512 256s-85.333 38.205-85.333 85.333 38.205 85.333 85.333 85.333 85.333-38.205 85.333-85.333",
    glyphName: "lock_outline_12",
    unicode: "\\uE9FF"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M304.361 704.022c0 114.679 92.966 207.645 207.644 207.645s207.644-92.966 207.644-207.645V581.711H304.36zm207.645 133.689c-73.834 0-133.689-59.855-133.689-133.689v-48.356h267.378v48.356c0 73.834-59.853 133.689-133.689 133.689M133.695 618.689c0 20.423 16.555 36.978 36.978 36.978H853.34c20.423 0 36.978-16.555 36.978-36.978V64.023c0-20.423-16.555-36.978-36.978-36.978H170.673c-20.423 0-36.978 16.555-36.978 36.978zm73.955-36.978V101h608.711v480.711zm389.689-240.355c0-47.127-38.205-85.333-85.333-85.333s-85.333 38.207-85.333 85.333c0 47.127 38.205 85.333 85.333 85.333s85.333-38.206 85.333-85.333",
    glyphName: "lock_outline_18",
    unicode: "\\uEA00"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M313.604 704.017c0 109.573 88.826 198.4 198.4 198.4 109.572 0 198.4-88.827 198.4-198.4V590.95h-396.8zm198.4 142.933c-78.942 0-142.933-63.994-142.933-142.933v-57.6h285.867v57.6c0 78.94-63.991 142.933-142.933 142.933zM142.938 618.683c0 15.317 12.416 27.733 27.733 27.733h682.667c15.317 0 27.733-12.416 27.733-27.733V64.017c0-15.317-12.416-27.733-27.733-27.733H170.671c-15.317 0-27.733 12.416-27.733 27.733zm55.466-27.733V91.75h627.2v499.2zm398.934-249.6c0-47.13-38.204-85.333-85.333-85.333s-85.333 38.204-85.333 85.333c0 47.13 38.204 85.333 85.333 85.333s85.333-38.204 85.333-85.333",
    glyphName: "lock_outline_24",
    unicode: "\\uEA01"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M314.667 682.667C314.667 791.651 403.017 880 512 880s197.333-88.349 197.333-197.333v-112H314.666zm197.333 144c-79.529 0-144-64.471-144-144V624h288v58.667c0 79.529-64.471 144-144 144M144 597.333C144 612.062 155.939 624 170.667 624h682.667c14.729 0 26.667-11.938 26.667-26.667V42.666c0-14.729-11.938-26.667-26.667-26.667H170.667C155.939 15.999 144 27.937 144 42.666zm53.333-26.666V69.334h629.333v501.333zm400-250.667c0-47.127-38.206-85.333-85.333-85.333S426.667 272.873 426.667 320s38.206 85.333 85.333 85.333 85.333-38.206 85.333-85.333",
    glyphName: "lock_outline_48",
    unicode: "\\uEA02"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M938.667 746.667H85.334V832h853.333zm0-341.334H85.334v85.333h853.333zm0-341.333H85.334v85.333h853.333z",
    glyphName: "menu_12",
    unicode: "\\uEA03"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M938.667 752.378H85.334v73.956h853.333zm0-341.334H85.334V485h853.333zm0-341.332H85.334v73.956h853.333z",
    glyphName: "menu_18",
    unicode: "\\uEA04"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M938.667 761.617H85.334v55.467h853.333zm0-341.333H85.334v55.467h853.333zm0-341.334H85.334v55.467h853.333z",
    glyphName: "menu_24",
    unicode: "\\uEA05"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M938.667 762.667H85.334V816h853.333zm0-341.334H85.334v53.333h853.333zm0-341.333H85.334v53.333h853.333z",
    glyphName: "menu_48",
    unicode: "\\uEA06"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M298.667 448c0-47.128-38.205-85.333-85.333-85.333S128.001 400.872 128.001 448s38.205 85.333 85.333 85.333 85.333-38.205 85.333-85.333m298.666 0c0-47.128-38.205-85.333-85.333-85.333S426.667 400.872 426.667 448s38.205 85.333 85.333 85.333 85.333-38.205 85.333-85.333m213.334-85.333c47.13 0 85.333 38.205 85.333 85.333s-38.204 85.333-85.333 85.333-85.333-38.205-85.333-85.333 38.205-85.333 85.333-85.333",
    glyphName: "more_horizontal_12",
    unicode: "\\uEA07"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M298.667 448c0-47.128-38.205-85.333-85.333-85.333S128.001 400.872 128.001 448s38.205 85.333 85.333 85.333 85.333-38.205 85.333-85.333m298.666 0c0-47.128-38.205-85.333-85.333-85.333S426.667 400.872 426.667 448s38.205 85.333 85.333 85.333 85.333-38.205 85.333-85.333m213.334-85.333C857.794 362.667 896 400.872 896 448s-38.207 85.333-85.333 85.333c-47.127 0-85.333-38.205-85.333-85.333s38.207-85.333 85.333-85.333",
    glyphName: "more_horizontal_18",
    unicode: "\\uEA08"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M298.667 448c0-47.13-38.205-85.333-85.333-85.333S128.001 400.871 128.001 448c0 47.13 38.205 85.333 85.333 85.333s85.333-38.204 85.333-85.333m298.666 0c0-47.13-38.204-85.333-85.333-85.333S426.667 400.871 426.667 448c0 47.13 38.204 85.333 85.333 85.333s85.333-38.204 85.333-85.333m213.334-85.333c47.13 0 85.333 38.204 85.333 85.333s-38.204 85.333-85.333 85.333c-47.13 0-85.333-38.204-85.333-85.333s38.204-85.333 85.333-85.333",
    glyphName: "more_horizontal_24",
    unicode: "\\uEA09"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M298.667 448c0-47.127-38.206-85.333-85.333-85.333S128.001 400.873 128.001 448s38.205 85.333 85.333 85.333 85.333-38.206 85.333-85.333m298.666 0c0-47.127-38.206-85.333-85.333-85.333S426.667 400.873 426.667 448s38.206 85.333 85.333 85.333 85.333-38.206 85.333-85.333m213.334-85.333C857.794 362.667 896 400.873 896 448s-38.206 85.333-85.333 85.333-85.333-38.206-85.333-85.333 38.206-85.333 85.333-85.333",
    glyphName: "more_horizontal_48",
    unicode: "\\uEA0A"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M512 661.333c-47.128 0-85.333 38.205-85.333 85.333s38.205 85.333 85.333 85.333 85.333-38.205 85.333-85.333-38.205-85.333-85.333-85.333m0-298.666c-47.128 0-85.333 38.205-85.333 85.333s38.205 85.333 85.333 85.333 85.333-38.205 85.333-85.333-38.205-85.333-85.333-85.333m-85.333-213.334C426.667 102.203 464.872 64 512 64s85.333 38.204 85.333 85.333-38.205 85.333-85.333 85.333-85.333-38.205-85.333-85.333",
    glyphName: "more_vertical_12",
    unicode: "\\uEA0B"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M512 661.333c-47.128 0-85.333 38.205-85.333 85.333s38.205 85.333 85.333 85.333 85.333-38.205 85.333-85.333-38.205-85.333-85.333-85.333m0-298.666c-47.128 0-85.333 38.205-85.333 85.333s38.205 85.333 85.333 85.333 85.333-38.205 85.333-85.333-38.205-85.333-85.333-85.333m-85.333-213.334C426.667 102.206 464.872 64 512 64s85.333 38.207 85.333 85.333c0 47.127-38.205 85.333-85.333 85.333s-85.333-38.207-85.333-85.333",
    glyphName: "more_vertical_18",
    unicode: "\\uEA0C"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M512 661.333c-47.13 0-85.333 38.205-85.333 85.333s38.204 85.333 85.333 85.333c47.13 0 85.333-38.205 85.333-85.333S559.129 661.333 512 661.333m0-298.666c-47.13 0-85.333 38.204-85.333 85.333s38.204 85.333 85.333 85.333c47.13 0 85.333-38.204 85.333-85.333S559.129 362.667 512 362.667m-85.333-213.334C426.667 102.203 464.871 64 512 64s85.333 38.204 85.333 85.333c0 47.13-38.204 85.333-85.333 85.333s-85.333-38.204-85.333-85.333",
    glyphName: "more_vertical_24",
    unicode: "\\uEA0D"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M512 661.333c-47.127 0-85.333 38.206-85.333 85.333s38.206 85.333 85.333 85.333 85.333-38.205 85.333-85.333-38.206-85.333-85.333-85.333m0-298.666c-47.127 0-85.333 38.206-85.333 85.333s38.206 85.333 85.333 85.333 85.333-38.206 85.333-85.333-38.206-85.333-85.333-85.333m-85.333-213.334C426.667 102.206 464.873 64 512 64s85.333 38.206 85.333 85.333-38.206 85.333-85.333 85.333-85.333-38.206-85.333-85.333",
    glyphName: "more_vertical_48",
    unicode: "\\uEA0E"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M938.522 237.4c3.712 221.794-61.261 503.077-308.279 566.811-15.448 60.472-63.735 104.591-120.911 104.591-57.867 0-106.63-45.193-121.456-106.794-285.14-73.039-304.871-387.424-302.362-558.227.685-46.659 39.747-84.065 86.412-84.065h84.073v.711h426.667v-.711h173.833c44.092 0 81.28 33.594 82.022 77.684zM659.581 75.093H362.289c11.418-19.789 26.481-35.917 43.065-48.486 34.235-25.958 75.267-37.248 105.58-37.248S582.28.649 616.515 26.607c16.585 12.57 31.648 28.698 43.065 48.486z",
    glyphName: "notification_12",
    unicode: "\\uEA0F"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M937.768 205.773c9.301 225.206-50.762 526.477-307.496 592.74-15.445 60.476-63.734 104.599-120.912 104.599-57.865 0-106.626-45.189-121.454-106.787C86.192 719.063 81.609 371.605 86.129 209.886c.869-31.101 26.638-55.859 57.747-55.859h169.013v.427h398.222v-.427h171.327c29.4 0 54.113 22.374 55.33 51.746M659.081 80.498h-296.28c11.395-22.932 27.74-41.205 45.996-55.046 33.217-25.185 73.035-36.09 102.143-36.09S579.868.268 613.085 25.452c18.256 13.841 34.6 32.114 45.995 55.046z",
    glyphName: "notification_18",
    unicode: "\\uEA10"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M84.431 192.081c-4.963 155.034-9.455 522.203 302.09 601.987 14.865 61.75 63.744 107.052 121.754 107.052 57.318 0 105.728-44.231 121.212-104.856 262.4-67.721 319.859-380.332 307.627-607.344-1.182-22.016-19.686-38.733-41.737-38.733H665.613l-311.467-.004-226.414.004c-23.333 0-42.554 18.573-43.3 41.894zm279.226-97.365c10.488-28.382 28.661-50.206 49.467-65.98C444.753 4.757 482.675-5.551 509.88-5.551s65.126 10.308 96.755 34.287c20.804 15.774 38.98 37.598 49.468 65.98z",
    glyphName: "notification_24",
    unicode: "\\uEA11"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M926.208 175.827c16.066 222.441-35.759 542.624-298.739 610.49-15.095 59.099-62.285 102.216-118.161 102.216-56.548 0-104.201-44.163-118.692-104.36C79.271 704.437 91.707 330.267 96.492 186.32c.104-3.127.204-6.15.298-9.056.375-11.659 9.906-20.777 21.572-20.777h211.244v.311l575.556-.311c11.025 0 20.252 8.343 21.047 19.339zm-274.007-65.96H369.545c9.513-30.05 27.889-52.802 49.163-68.93 30.195-22.893 66.4-32.7 92.164-32.7s61.971 9.807 92.166 32.7c21.274 16.128 39.65 38.88 49.163 68.93",
    glyphName: "notification_48",
    unicode: "\\uEA12"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M547.581 783.089c-8.044 31.491-28.447 40.379-38.232 40.379-9.866 0-30.725-9.164-38.491-41.426l-12.024-49.948-49.768-12.746C300.4 691.517 242.131 620.082 208.884 530.013c-34.511-93.494-39.246-201.421-38.052-284.45.201-.195.438-.343.636-.425.146-.061.267-.088.46-.088h681.354c1.05 101.827-13.763 211.541-52.977 300.65-39.15 88.963-99.672 152.219-191.367 175.882l-48.866 12.611-12.49 48.897zM85.515 243.783c-2.51 170.805 17.222 485.199 302.379 558.23 14.828 61.599 63.59 106.789 121.455 106.789 57.177 0 105.464-44.12 120.911-104.594 247.009-63.743 311.974-345.017 308.262-566.807-.742-44.09-37.931-77.684-82.022-77.684H171.928c-46.665 0-85.727 37.406-86.412 84.066zm425.42-169.091c-12.249 0-35.058 5.53-54.025 19.917-17.241 13.068-30.993 32.965-30.993 65.099h-85.333c0-61.891 28.809-105.837 64.771-133.101C439.59.649 480.622-10.641 510.935-10.641S582.281.649 616.516 26.607c35.962 27.264 64.771 71.211 64.771 133.101h-85.333c0-32.134-13.752-52.031-30.993-65.099-18.967-14.387-41.777-19.917-54.026-19.917",
    glyphName: "notification_outline_12",
    unicode: "\\uEA13"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M558.605 780.214c-9.031 35.355-33.153 48.942-49.256 48.942-16.266 0-40.846-13.968-49.554-50.142l-10.42-43.288-43.133-11.047c-119.347-30.566-180.806-112.4-213.792-212.959-31.783-96.89-34.407-204.708-32.785-283.738h704.814c2.207 101.262-10.98 212.934-49.095 305.649-39.873 96.981-104.055 167.587-203.605 193.277l-42.348 10.929-10.824 42.378zM86.129 209.886c-4.52 161.712.063 509.168 301.765 586.436 14.828 61.599 63.589 106.789 121.456 106.789 57.177 0 105.466-44.12 120.912-104.594 256.745-66.256 316.809-367.533 307.507-592.744-1.217-29.372-25.93-51.746-55.33-51.746H143.877c-31.11 0-56.878 24.764-57.747 55.859zM510.963 63.312c-13.454 0-37.478 5.922-57.463 21.072-18.488 14.017-33.245 35.521-33.245 69.638h-73.956c0-59.91 27.806-102.252 62.52-128.569C442.036.268 481.854-10.643 510.963-10.643S579.891.268 613.108 25.453c34.714 26.317 62.515 68.659 62.515 128.569h-73.956c0-34.116-14.751-55.62-33.242-69.638-19.985-15.15-44.01-21.072-57.463-21.072z",
    glyphName: "notification_outline_18",
    unicode: "\\uEA14"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M575.744 782.538c-10.671 41.786-40.956 63.115-67.469 63.115-26.807 0-57.553-21.885-67.827-64.567l-7.817-32.467-32.349-8.285C269.01 706.717 203.343 614.217 169.809 505.01c-32.529-105.933-32.511-221.602-30.298-299.358h742.865c4.215 105.421-7.68 225.51-47.646 326.212-41.25 103.94-110.007 182.535-219.106 210.691l-31.761 8.198zM84.431 192.081c-4.963 155.034-9.455 522.203 302.09 601.987 14.865 61.75 63.744 107.052 121.754 107.052 57.318 0 105.728-44.231 121.212-104.856 262.4-67.721 319.859-380.332 307.627-607.344-1.182-22.016-19.686-38.733-41.737-38.733H127.732c-23.333 0-42.554 18.573-43.3 41.894zM509.875 49.916c-15.462 0-41.54 6.562-63.245 23.019-20.582 15.607-37.022 39.791-37.022 77.248h-55.467c0-56.798 26.227-96.614 58.978-121.446C444.748 4.758 482.67-5.55 509.875-5.55s65.126 10.308 96.755 34.287c32.751 24.832 58.978 64.649 58.978 121.446h-55.467c0-37.457-16.439-61.641-37.022-77.248-21.705-16.457-47.782-23.019-63.245-23.019z",
    glyphName: "notification_outline_24",
    unicode: "\\uEA15"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M581.993 774.704c-11.023 43.158-42.876 66.896-72.685 66.896-30.15 0-62.455-24.348-73.062-68.41l-6.613-27.471-27.373-7.01C267.956 704.311 202.419 607.84 170.084 496.262c-30.619-105.655-29.439-219.168-27.185-292.838H880.84c4.787 101.769-5.641 219.149-43.279 319.072-40.316 107.031-109.634 189.427-221.82 218.379l-26.878 6.936-6.869 26.893zM96.491 186.321C91.706 330.27 79.27 704.437 390.615 784.174c14.49 60.197 62.142 104.359 118.692 104.359 55.874 0 103.063-43.116 118.159-102.214 262.982-67.866 314.807-388.049 298.741-610.49-.796-10.997-10.022-19.339-21.047-19.339h-786.8c-11.666 0-21.197 9.116-21.572 20.777-.093 2.906-.194 5.929-.298 9.054zM510.874 55.17c-15.829 0-42.012 6.641-63.81 23.166-20.847 15.806-37.504 40.388-37.504 78.148h-46.933c0-54.127 24.939-91.934 56.083-115.548 30.195-22.893 66.4-32.7 92.164-32.7s61.971 9.807 92.166 32.7c31.145 23.614 56.081 61.421 56.081 115.548h-46.933c0-37.76-16.655-62.342-37.504-78.148-21.796-16.525-47.981-23.166-63.81-23.166",
    glyphName: "notification_outline_48",
    unicode: "\\uEA16"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M191.793 868.83a42.67 42.67 0 0 0 42.458.358l682.664-384c13.44-7.557 21.751-21.773 21.751-37.187s-8.311-29.63-21.751-37.187L234.251 26.813c-13.211-7.433-29.373-7.296-42.458.358s-21.127 21.675-21.127 36.83v768a42.67 42.67 0 0 0 21.127 36.83z",
    glyphName: "play_12",
    unicode: "\\uEA17"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M194.671 863.914a36.98 36.98 0 0 0 36.797.309l682.668-384c11.639-6.55 18.847-18.87 18.847-32.229s-7.208-25.68-18.847-32.229L231.468 31.766a36.977 36.977 0 0 0-55.107 32.227v768a36.98 36.98 0 0 0 18.31 31.92z",
    glyphName: "play_18",
    unicode: "\\uEA18"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M199.337 855.936a27.74 27.74 0 0 0 27.598.232l682.668-384.001a27.736 27.736 0 0 0 0-48.342l-682.668-384a27.733 27.733 0 0 0-41.33 24.17v768a27.73 27.73 0 0 0 13.732 23.94z",
    glyphName: "play_24",
    unicode: "\\uEA19"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M199.337 855.936a27.73 27.73 0 0 0 27.597.232l682.667-383.999a27.734 27.734 0 0 0 0-48.344l-682.667-384a27.733 27.733 0 0 0-41.329 24.17v768a27.73 27.73 0 0 0 13.732 23.94z",
    glyphName: "play_48",
    unicode: "\\uEA1A"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M418.909 277.333c-3.6 0-7.054 1.498-9.599 4.166s-3.977 6.284-3.977 10.057v312.887c0 2.472.614 4.901 1.783 7.048s2.852 3.937 4.882 5.195c2.031 1.259 4.339 1.94 6.699 1.979s4.687-.567 6.754-1.759l271.514-156.444c2.13-1.227 3.907-3.031 5.144-5.223s1.89-4.692 1.89-7.239-.653-5.047-1.89-7.239-3.014-3.996-5.144-5.223L425.451 279.094a13.1 13.1 0 0 0-6.543-1.76zM512 106.667c-188.513 0-341.333 152.82-341.333 341.333S323.487 789.333 512 789.333 853.333 636.513 853.333 448 700.513 106.667 512 106.667m0-85.334c235.641 0 426.667 191.025 426.667 426.667S747.642 874.667 512 874.667 85.333 683.642 85.333 448 276.358 21.333 512 21.333",
    glyphName: "play_circle_outline_12",
    unicode: "\\uEA1B"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M418.909 277.333c-3.6 0-7.054 1.496-9.6 4.164s-3.976 6.286-3.976 10.058v312.888c0 2.472.614 4.9 1.783 7.047s2.851 3.938 4.882 5.196 4.339 1.94 6.698 1.979 4.687-.568 6.754-1.758l271.518-156.444a13.93 13.93 0 0 0 5.143-5.224c1.234-2.192 1.889-4.692 1.889-7.239s-.654-5.047-1.889-7.239a13.93 13.93 0 0 0-5.143-5.224L425.45 279.09a13.15 13.15 0 0 0-6.542-1.758zM512 95.289c-194.797 0-352.711 157.912-352.711 352.711 0 194.797 157.914 352.711 352.711 352.711 194.799 0 352.711-157.914 352.711-352.711 0-194.799-157.912-352.711-352.711-352.711m0-73.956c235.639 0 426.667 191.027 426.667 426.667 0 235.642-191.027 426.667-426.667 426.667-235.642 0-426.667-191.025-426.667-426.667C85.333 212.361 276.358 21.333 512 21.333",
    glyphName: "play_circle_outline_18",
    unicode: "\\uEA1C"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M418.909 277.333c-3.601 0-7.054 1.498-9.6 4.164s-3.976 6.285-3.976 10.057v312.889c0 2.472.614 4.901 1.783 7.048s2.851 3.937 4.882 5.196 4.339 1.94 6.698 1.978 4.687-.567 6.754-1.759l271.513-156.443a13.9 13.9 0 0 0 5.146-5.222c1.237-2.193 1.89-4.693 1.89-7.241s-.653-5.047-1.89-7.241a13.9 13.9 0 0 0-5.146-5.222L425.45 279.095a13.1 13.1 0 0 0-6.542-1.762zM512 76.8c-205.008 0-371.2 166.191-371.2 371.2S306.992 819.2 512 819.2c205.009 0 371.2-166.192 371.2-371.2S717.009 76.8 512 76.8m0-55.467c235.639 0 426.667 191.027 426.667 426.667 0 235.642-191.027 426.667-426.667 426.667-235.642 0-426.667-191.025-426.667-426.667C85.333 212.361 276.358 21.333 512 21.333",
    glyphName: "play_circle_outline_24",
    unicode: "\\uEA1D"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M418.91 277.333c-3.601 0-7.055 1.498-9.6 4.166-2.547 2.667-3.977 6.285-3.977 10.057v312.887c0 2.47.614 4.9 1.783 7.046a13.94 13.94 0 0 0 4.883 5.197c2.029 1.257 4.339 1.939 6.697 1.978s4.687-.567 6.754-1.758l271.516-156.444a13.9 13.9 0 0 0 5.143-5.225c1.237-2.191 1.89-4.691 1.89-7.238s-.653-5.047-1.89-7.238a13.9 13.9 0 0 0-5.143-5.225L425.45 279.092a13.1 13.1 0 0 0-6.541-1.76zM512 74.667c-206.187 0-373.333 167.147-373.333 373.333S305.814 821.333 512 821.333 885.333 654.186 885.333 448 718.186 74.667 512 74.667m0-53.334c235.642 0 426.667 191.025 426.667 426.667S747.642 874.667 512 874.667 85.333 683.642 85.333 448 276.358 21.333 512 21.333",
    glyphName: "play_circle_outline_48",
    unicode: "\\uEA1E"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M469.333 618.667V448h85.333c47.128 0 85.333 38.205 85.333 85.333s-38.205 85.333-85.333 85.333h-85.333zM512 21.333c235.641 0 426.667 191.025 426.667 426.667S747.642 874.667 512 874.667 85.333 683.642 85.333 448 276.358 21.333 512 21.333M554.667 704c94.257 0 170.667-76.41 170.667-170.667s-76.41-170.667-170.667-170.667h-85.333v-128h-85.333v469.333h170.667z",
    glyphName: "point_12",
    unicode: "\\uEA1F"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M463.65 442.333h91.022c50.273 0 91.022 40.752 91.022 91.022s-40.75 91.022-91.022 91.022H463.65zm48.35-421c235.639 0 426.667 191.027 426.667 426.667 0 235.642-191.027 426.667-426.667 426.667-235.642 0-426.667-191.025-426.667-426.667C85.333 212.361 276.358 21.333 512 21.333m42.672 677c91.113 0 164.978-73.863 164.978-164.978s-73.865-164.977-164.978-164.977H463.65V234.689h-73.956v463.644z",
    glyphName: "point_18",
    unicode: "\\uEA20"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M454.404 433.084h100.267c55.377 0 100.267 44.89 100.267 100.266s-44.89 100.267-100.267 100.267H454.404zM512 21.333c235.639 0 426.667 191.027 426.667 426.667 0 235.642-191.027 426.667-426.667 426.667-235.642 0-426.667-191.025-426.667-426.667C85.333 212.361 276.358 21.333 512 21.333m42.671 667.75c86.007 0 155.733-69.724 155.733-155.733 0-86.007-69.726-155.733-155.733-155.733H454.404V234.684h-55.467v454.4H554.67z",
    glyphName: "point_24",
    unicode: "\\uEA21"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M453.333 432v202.667h101.333c55.966 0 101.333-45.367 101.333-101.333s-45.367-101.333-101.333-101.333H453.333zM512 21.333c235.642 0 426.667 191.025 426.667 426.667S747.642 874.667 512 874.667 85.333 683.642 85.333 448 276.358 21.333 512 21.333M554.667 688c85.421 0 154.667-69.246 154.667-154.667s-69.246-154.667-154.667-154.667H453.334v-144h-53.333v453.333h154.667z",
    glyphName: "point_48",
    unicode: "\\uEA22"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M512 106.667c188.513 0 341.333 152.82 341.333 341.333S700.513 789.333 512 789.333 170.667 636.513 170.667 448 323.487 106.667 512 106.667m0-85.334C276.359 21.333 85.333 212.358 85.333 448S276.358 874.667 512 874.667 938.667 683.642 938.667 448 747.642 21.333 512 21.333m-42.667 640V234.666H384v426.667zM384 704h170.667c94.257 0 170.667-76.41 170.667-170.667s-76.41-170.667-170.667-170.667H384zm85.333-85.333V448h85.333c47.128 0 85.333 38.205 85.333 85.333s-38.205 85.333-85.333 85.333h-85.333z",
    glyphName: "point_outline_12",
    unicode: "\\uEA23"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M512 95.289c-194.797 0-352.711 157.912-352.711 352.711 0 194.797 157.914 352.711 352.711 352.711 194.799 0 352.711-157.914 352.711-352.711 0-194.799-157.912-352.711-352.711-352.711m0-73.956c235.639 0 426.667 191.027 426.667 426.667 0 235.642-191.027 426.667-426.667 426.667-235.642 0-426.667-191.025-426.667-426.667C85.333 212.361 276.358 21.333 512 21.333m-48.356 640V234.666h-73.956v426.667zm-73.955 36.978h164.978c91.113 0 164.978-73.863 164.978-164.978S645.78 368.355 554.667 368.355H389.689zm73.955-73.955V442.312h91.022c50.273 0 91.022 40.752 91.022 91.022s-40.75 91.022-91.022 91.022z",
    glyphName: "point_outline_18",
    unicode: "\\uEA24"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M512 76.8c-205.008 0-371.2 166.191-371.2 371.2S306.992 819.2 512 819.2c205.009 0 371.2-166.192 371.2-371.2S717.009 76.8 512 76.8m0-55.467c235.639 0 426.667 191.027 426.667 426.667 0 235.642-191.027 426.667-426.667 426.667-235.642 0-426.667-191.025-426.667-426.667C85.333 212.361 276.358 21.333 512 21.333m-57.6 640V234.666h-55.467v426.667zm-55.467 27.734h155.733c86.007 0 155.733-69.724 155.733-155.733 0-86.007-69.726-155.733-155.733-155.733H398.933zM454.4 633.6V433.067h100.267c55.377 0 100.267 44.89 100.267 100.267s-44.89 100.267-100.267 100.267H454.4z",
    glyphName: "point_outline_24",
    unicode: "\\uEA25"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M512 74.667c-206.187 0-373.333 167.147-373.333 373.333S305.814 821.333 512 821.333 885.333 654.186 885.333 448 718.186 74.667 512 74.667m0-53.334c235.642 0 426.667 191.025 426.667 426.667S747.642 874.667 512 874.667 85.333 683.642 85.333 448 276.358 21.333 512 21.333m-58.667 640V234.666H400v426.667zM400 688h154.667c85.421 0 154.667-69.246 154.667-154.667s-69.246-154.667-154.667-154.667H400zm53.333-53.333V432h101.333c55.966 0 101.333 45.367 101.333 101.333s-45.367 101.333-101.333 101.333H453.333z",
    glyphName: "point_outline_48",
    unicode: "\\uEA26"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M256 725.333c0 82.475 66.859 149.333 149.333 149.333 41.785 0 79.562-17.162 106.667-44.821 27.104 27.659 64.881 44.821 106.667 44.821 82.475 0 149.333-66.859 149.333-149.333 0-28.973-8.251-56.02-22.531-78.916h150.557c15.317 0 27.733-12.417 27.733-27.733V448.017c0-15.317-12.416-27.733-27.733-27.733l-341.359-.006v241.056h64c35.346 0 64 28.654 64 64s-28.654 64-64 64-64-28.654-64-64v-64h-85.333v64c0 35.346-28.654 64-64 64s-64-28.654-64-64 28.654-64 64-64h64V420.278l-341.309.006c-15.316 0-27.733 12.416-27.733 27.733v170.667c0 15.316 12.417 27.733 27.733 27.733h150.507c-14.281 22.897-22.531 49.943-22.531 78.916zm213.333-360.522H142.958V64.017c0-15.317 12.417-27.733 27.733-27.733h298.642zm85.334-328.527h298.692c15.317 0 27.733 12.416 27.733 27.733v300.794H554.666V36.284z",
    glyphName: "present_12",
    unicode: "\\uEA27"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M261.696 725.356C261.696 804.689 326.008 869 405.34 869c42.327 0 80.378-18.307 106.667-47.435C538.296 850.693 576.347 869 618.673 869c79.332 0 143.644-64.312 143.644-143.644 0-29.148-8.681-56.269-23.598-78.917h157.292c15.314 0 27.733-12.417 27.733-27.733V448.039c0-15.316-12.419-27.733-27.733-27.733l-347.028-.019v235.381h-73.954v69.689c0 38.488-31.201 69.689-69.689 69.689s-69.689-31.201-69.689-69.689 31.201-69.689 69.689-69.689h69.689l-.001-235.381-347.017.019c-15.317 0-27.733 12.417-27.733 27.733v170.667c0 15.317 12.417 27.733 27.733 27.733h157.285c-14.919 22.648-23.601 49.769-23.601 78.917zm287.287-69.689h69.689c38.491 0 69.689 31.201 69.689 69.689s-31.198 69.689-69.689 69.689c-38.485 0-69.688-31.201-69.688-69.689zm-73.955-290.85H142.945V64.04c0-15.32 12.417-27.733 27.733-27.733h304.35v328.511zm73.955-328.511h304.361c15.314 0 27.733 12.413 27.733 27.733v300.777H548.982V36.305z",
    glyphName: "present_18",
    unicode: "\\uEA28"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M270.938 725.35c0 74.227 60.173 134.4 134.4 134.4 43.456 0 82.095-20.624 106.662-52.618 24.567 31.994 63.206 52.618 106.662 52.618 74.227 0 134.4-60.173 134.4-134.4 0-29.495-9.502-56.77-25.609-78.933h168.55c15.317 0 27.733-12.416 27.733-27.733V448.018c0-15.317-12.416-27.733-27.733-27.733l-356.267-.004v226.137h78.925c43.593 0 78.933 35.34 78.933 78.933s-35.341 78.933-78.933 78.933c-43.285 0-78.434-34.843-78.929-78.013l.004-.92v-78.933h-55.467V420.281l-356.267.004c-15.317 0-27.733 12.416-27.733 27.733v170.666c0 15.317 12.416 27.733 27.733 27.733h168.542c-16.108 22.163-25.609 49.439-25.609 78.933zm213.329.92c-.495 43.17-35.644 78.013-78.929 78.013-43.594 0-78.933-35.34-78.933-78.933s35.34-78.933 78.933-78.933h78.933l-.009 78.933.004.92zm.004-361.457H142.938V64.017c0-15.317 12.416-27.733 27.733-27.733h313.6zm55.467-328.529h313.6c15.317 0 27.733 12.416 27.733 27.733v300.796H539.738z",
    glyphName: "present_24",
    unicode: "\\uEA29"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M405.333 858.667C331.695 858.667 272 798.972 272 725.334c0-29.532 9.6-56.821 25.852-78.916H128.005c-15.317 0-27.733-12.416-27.733-27.733V448.018c0-15.317 12.417-27.733 27.733-27.733h356.267v226.112h55.467V420.285h356.267c15.317 0 27.733 12.416 27.733 27.733v170.667c0 15.317-12.416 27.733-27.733 27.733H726.15c16.252 22.095 25.852 49.385 25.852 78.916 0 73.638-59.695 133.333-133.333 133.333-43.616 0-82.34-20.943-106.667-53.32-24.326 32.378-63.051 53.32-106.667 53.32zm-13.196-212.25c-37.903 6.291-66.803 39.228-66.803 78.916 0 44.183 35.817 80 80 80s80-35.817 80-80v-78.916zm146.53 0v78.916c0 44.183 35.817 80 80 80s80-35.817 80-80c0-39.689-28.9-72.625-66.803-78.916zm-54.396-281.591H142.938V64.017c0-15.317 12.417-27.733 27.733-27.733h313.6zm55.467-328.542v328.542h341.333V64.017c0-15.317-12.416-27.733-27.733-27.733z",
    glyphName: "present_48",
    unicode: "\\uEA2A"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M256 725.333c0 82.475 66.859 149.333 149.333 149.333 41.785 0 79.562-17.162 106.667-44.821 27.104 27.659 64.881 44.821 106.667 44.821 82.475 0 149.333-66.859 149.333-149.333 0-22.903-5.156-44.603-14.371-64H896c23.561 0 42.667-19.103 42.667-42.667V447.999c0-23.564-19.106-42.667-42.667-42.667V63.999c0-23.561-19.106-42.667-42.667-42.667H170.666c-23.564 0-42.667 19.106-42.667 42.667v341.333c-23.564 0-42.667 19.103-42.667 42.667v170.667c0 23.564 19.103 42.667 42.667 42.667H270.37c-9.215 19.397-14.371 41.097-14.371 64zm-85.333-234.666h298.667V576H170.667zm384 0h298.667V576H554.667zm-341.334-85.334V106.666h256v298.667zm341.334 0V106.666h256v298.667zm128 320c0 35.346-28.654 64-64 64s-64-28.654-64-64v-64h64c35.346 0 64 28.654 64 64m-213.334 0c0 35.346-28.654 64-64 64s-64-28.654-64-64 28.654-64 64-64h64z",
    glyphName: "present_outline_12",
    unicode: "\\uEA2B"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M261.695 725.356c0 79.333 64.312 143.644 143.644 143.644 42.326 0 80.378-18.307 106.667-47.435C538.295 850.693 576.347 869 618.673 869c79.332 0 143.644-64.312 143.644-143.644 0-25.288-6.537-49.05-18.005-69.689h151.694c20.423 0 36.978-16.555 36.978-36.978V448.022c0-20.422-16.555-36.978-36.978-36.978h-5.689V64.022c0-20.423-16.555-36.978-36.978-36.978H170.672c-20.423 0-36.978 16.555-36.978 36.978v347.022h-5.689c-20.423 0-36.978 16.556-36.978 36.978v170.667c0 20.423 16.555 36.978 36.978 36.978h151.696c-11.473 20.639-18.007 44.401-18.007 69.689zm287.288-624.355h267.378v310.044H548.983zm-73.955 310.043H207.65V101h267.378zM548.983 485h310.044v96.711H548.983zm-73.955 96.711H164.984V485h310.044zm-69.689 73.956h69.689v69.689c0 38.488-31.201 69.689-69.689 69.689s-69.689-31.201-69.689-69.689 31.201-69.689 69.689-69.689m143.644 0h69.689c38.485 0 69.689 31.201 69.689 69.689s-31.204 69.689-69.689 69.689c-38.491 0-69.689-31.201-69.689-69.689z",
    glyphName: "present_outline_18",
    unicode: "\\uEA2C"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M270.938 725.35c0 74.227 60.173 134.4 134.4 134.4 43.46 0 82.099-20.626 106.667-52.623 24.567 31.997 63.206 52.623 106.667 52.623 74.227 0 134.4-60.173 134.4-134.4 0-29.495-9.502-56.77-25.609-78.933h168.542c15.317 0 27.733-12.416 27.733-27.733V448.018c0-15.317-12.416-27.733-27.733-27.733h-14.933V64.018c0-15.317-12.416-27.733-27.733-27.733H170.672c-15.317 0-27.733 12.416-27.733 27.733v356.267h-14.933c-15.317 0-27.733 12.416-27.733 27.733v170.666c0 15.317 12.416 27.733 27.733 27.733h168.542c-16.108 22.163-25.609 49.439-25.609 78.933zm213.333-249.6v115.2H155.738v-115.2zm55.467 0h328.533v115.2H539.738zm-341.334-55.466V91.751h285.867v328.533zm341.334 0V91.751h285.867v328.533zM697.604 725.35c0 43.594-35.341 78.933-78.933 78.933s-78.933-35.34-78.933-78.933v-78.933h78.933c43.593 0 78.933 35.34 78.933 78.933m-213.333 0c0 43.594-35.341 78.933-78.933 78.933-43.594 0-78.933-35.34-78.933-78.933s35.34-78.933 78.933-78.933h78.933z",
    glyphName: "present_outline_24",
    unicode: "\\uEA2D"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M272 725.333c0 73.638 59.695 133.333 133.333 133.333 43.616 0 82.34-20.943 106.667-53.32 24.326 32.378 63.051 53.32 106.667 53.32 73.638 0 133.333-59.695 133.333-133.333 0-30.016-9.918-57.715-26.656-80H896c14.729 0 26.667-11.938 26.667-26.667V447.999c0-14.729-11.938-26.667-26.667-26.667h-16V63.999c0-14.729-11.938-26.667-26.667-26.667H170.666c-14.728 0-26.667 11.938-26.667 26.667v357.333h-16c-14.728 0-26.667 11.938-26.667 26.667v170.667c0 14.729 11.939 26.667 26.667 26.667h170.656c-16.738 22.285-26.656 49.984-26.656 80zM538.667 90.667h288v330.667h-288zm-53.334 330.666h-288V90.666h288zm53.334 53.334h330.667V592H538.667zM485.333 592H154.666V474.667h330.667zm213.334 133.333c0 44.183-35.817 80-80 80s-80-35.817-80-80v-80h80c44.183 0 80 35.817 80 80m-213.334 0c0 44.183-35.817 80-80 80s-80-35.817-80-80 35.817-80 80-80h80z",
    glyphName: "present_outline_48",
    unicode: "\\uEA2E"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M556.232 874.667h-88.428c-24.419 0-44.215-20.485-44.215-45.755V538.364h-44.214v286.818C264.823 777.197 180.09 668.913 161.931 538.364h-47.858c-15.873 0-28.739-13.315-28.739-29.74s12.867-29.741 28.739-29.741h795.854c15.872 0 28.74 13.315 28.74 29.741s-12.868 29.74-28.74 29.74h-47.821C843.945 668.913 759.213 777.197 644.66 825.182V538.364h-44.215v290.548c0 25.27-19.796 45.755-44.214 45.755zM190.485 446.854h643.029l5.897-21.681c7.069-25.983 10.826-53.224 10.826-81.267 0-180.604-153.912-322.572-338.238-322.572S173.761 163.302 173.761 343.906c0 28.043 3.757 55.284 10.825 81.267zm188.89-132.685v-22.878c0-18.952 14.846-34.316 33.161-34.316s33.161 15.364 33.161 34.316v22.878c0 18.953-14.846 34.316-33.161 34.316s-33.161-15.363-33.161-34.316M611.5 348.485c-18.314 0-33.161-15.363-33.161-34.316v-22.878c0-18.952 14.847-34.316 33.161-34.316s33.161 15.364 33.161 34.316v22.878c0 18.953-14.847 34.316-33.161 34.316",
    glyphName: "pro_12",
    unicode: "\\uEA2F"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M553.283 846.222c22.791 0 41.269-19.119 41.269-42.705V532.339h41.262v267.697c106.917-44.786 186.004-145.851 202.951-267.697H883.4c14.814 0 26.823-12.428 26.823-27.758s-12.009-27.758-26.823-27.758H140.602c-14.814 0-26.823 12.428-26.823 27.758s12.009 27.758 26.823 27.758h44.668c16.948 121.846 96.032 222.911 202.948 267.697V532.339h41.267v271.178c0 23.586 18.475 42.705 41.267 42.705h82.533zM211.92 446.93l-5.505-20.237c-6.597-24.251-10.104-49.674-10.104-75.849 0-168.562 143.652-301.067 315.689-301.067s315.688 132.506 315.688 301.067c0 26.175-3.504 51.598-10.103 75.849l-5.507 20.237zm176.297-123.841c0 17.692 13.856 32.028 30.95 32.028s30.95-14.336 30.95-32.028v-21.35c0-17.687-13.857-32.028-30.95-32.028s-30.95 14.342-30.95 32.028zm216.648 32.029c17.095 0 30.948-14.336 30.948-32.028v-21.35c0-17.687-13.852-32.028-30.948-32.028s-30.948 14.342-30.948 32.028v21.35c0 17.692 13.852 32.028 30.948 32.028",
    glyphName: "pro_18",
    unicode: "\\uEA30"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M556.233 832c24.418 0 44.211-19.461 44.211-43.467V512.512h44.215v272.477c114.551-45.586 199.283-148.456 217.446-272.477h47.821c15.872 0 28.74-12.651 28.74-28.254s-12.868-28.254-28.74-28.254H114.072c-15.872 0-28.739 12.651-28.739 28.254s12.867 28.254 28.739 28.254h47.858c18.159 124.022 102.892 226.891 217.444 272.477V512.512h44.214v276.021c0 24.006 19.794 43.467 44.212 43.467h88.431zM190.486 425.579h643.029l5.897-20.599a279.9 279.9 0 0 0 10.829-77.201c0-171.575-153.916-306.445-338.24-306.445-184.326 0-338.238 134.869-338.238 306.445 0 26.641 3.758 52.518 10.826 77.201zm188.889-126.05v-21.734c0-18.005 14.846-32.602 33.161-32.602 18.313 0 33.161 14.596 33.161 32.602v21.734c0 18.005-14.848 32.597-33.161 32.597s-33.161-14.592-33.161-32.597m232.124 32.597c-18.313 0-33.161-14.592-33.161-32.597v-21.734c0-18.005 14.848-32.602 33.161-32.602s33.161 14.596 33.161 32.602v21.734c0 18.005-14.848 32.597-33.161 32.597",
    glyphName: "pro_24",
    unicode: "\\uEA31"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M555.125 853.333c23.808 0 43.108-19.461 43.108-43.467V533.845h43.11v272.477c111.689-45.586 194.302-148.456 212.006-272.477h46.628c15.475 0 28.021-12.649 28.021-28.254 0-15.603-12.546-28.254-28.021-28.254H124.019c-15.475 0-28.021 12.651-28.021 28.254 0 15.605 12.545 28.254 28.021 28.254h46.662C188.386 657.866 271 760.736 382.689 806.322V533.845h43.108v276.021c0 24.006 19.3 43.467 43.11 43.467zM198.524 446.912h626.953l5.751-20.597c6.891-24.685 10.554-50.564 10.554-77.205 0-171.573-150.063-306.443-329.781-306.443S182.219 177.536 182.219 349.11c0 26.641 3.664 52.521 10.555 77.205l5.751 20.597zM382.69 320.86v-21.732c0-18.005 14.475-32.602 32.333-32.602 17.856 0 32.331 14.596 32.331 32.602v21.732c0 18.005-14.475 32.602-32.331 32.602-17.858 0-32.333-14.596-32.333-32.602m226.321 32.601c-17.856 0-32.331-14.596-32.331-32.602v-21.732c0-18.005 14.475-32.602 32.331-32.602s32.333 14.596 32.333 32.602v21.732c0 18.005-14.477 32.602-32.333 32.602",
    glyphName: "pro_48",
    unicode: "\\uEA32"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M384 726.601c-78.69-37.934-128-108.617-128-184.759 0-23.564-19.103-42.667-42.667-42.667s-42.667 19.103-42.667 42.667c0 129.751 92.794 235.364 216.192 277.975 9.696 36.475 42.947 63.351 82.475 63.351h85.333c39.526 0 72.776-26.874 82.474-63.346 123.403-42.609 216.201-148.224 216.201-277.979 0-23.564-19.101-42.667-42.665-42.667s-42.667 19.103-42.667 42.667c0 76.145-49.314 146.831-128.01 184.765V541.836c0-23.564-19.103-42.667-42.667-42.667s-42.667 19.103-42.667 42.667v256h-85.333v-9.692q.021-.935 0-1.864V541.836c0-23.564-19.103-42.667-42.667-42.667s-42.667 19.103-42.667 42.667v184.767zm0-417.268c0 17.673 14.327 32 32 32s32-14.327 32-32V288c0-17.673-14.327-32-32-32s-32 14.327-32 32zm224 32c-17.673 0-32-14.327-32-32V288c0-17.673 14.327-32 32-32s32 14.327 32 32v21.333c0 17.673-14.327 32-32 32M85.333 430.916c0 23.565 19.103 42.667 42.667 42.667h768c23.561 0 42.667-19.102 42.667-42.667S919.561 388.249 896 388.249h-47.134a294.7 294.7 0 0 0 4.467-51.194c0-177.893-156.5-315.731-341.333-315.731S170.667 159.162 170.667 337.055a294.7 294.7 0 0 0 4.467 51.194H128c-23.564 0-42.667 19.103-42.667 42.667m177.009-42.666A208.9 208.9 0 0 1 256 337.056c0-123.728 110.936-230.397 256-230.397s256 106.669 256 230.397c0 17.628-2.194 34.755-6.342 51.194z",
    glyphName: "pro_outline_12",
    unicode: "\\uEA33"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M236.095 541.846c0 99.749 61.469 188.035 153.6 231.445V541.855c0-20.422 16.555-36.978 36.978-36.978s36.978 16.556 36.978 36.978v283.586q.02.827 0 1.657v13.424a5.69 5.69 0 0 0 5.689 5.689h85.333a5.69 5.69 0 0 0 5.689-5.689V541.855c0-20.422 16.555-36.978 36.978-36.978s36.978 16.556 36.978 36.978v231.44c92.137-43.408 153.611-131.697 153.611-231.45 0-20.422 16.555-36.978 36.978-36.978 20.417 0 36.978 16.556 36.978 36.978 0 143.745-96.228 264.281-228.648 311.818-6.263 37.733-39.054 66.503-78.564 66.503H469.34c-39.512 0-72.303-28.771-78.566-66.506C258.363 806.121 162.14 685.587 162.14 541.846c0-20.422 16.555-36.978 36.978-36.978s36.978 16.556 36.978 36.978zM384 309.333c0 17.675 14.327 32 32 32s32-14.325 32-32V288c0-17.675-14.327-32-32-32s-32 14.325-32 32zm224 32c-17.675 0-32-14.325-32-32V288c0-17.675 14.325-32 32-32s32 14.325 32 32v21.333c0 17.675-14.325 32-32 32M85.333 419.578c0 20.423 16.779 36.978 37.477 36.978h778.378c20.702 0 37.478-16.555 37.478-36.978s-16.777-36.977-37.478-36.977h-45.801a277.8 277.8 0 0 0 6.485-59.745c0-175.798-161.53-310.044-349.867-310.044S162.138 147.058 162.138 322.856a277.7 277.7 0 0 0 6.485 59.745h-45.814c-20.698 0-37.477 16.555-37.477 36.977zm159.624-36.977a37 37 0 0 0-.515-1.934 203.9 203.9 0 0 1-8.347-57.81c0-125.821 118.641-236.089 275.911-236.089s275.911 110.268 275.911 236.089c0 19.968-2.896 39.322-8.346 57.81a34 34 0 0 0-.518 1.934H244.956z",
    glyphName: "pro_outline_18",
    unicode: "\\uEA34"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M386.75 776.195c-112.807-41.533-188.346-136.367-188.346-242.849 0-15.317-12.417-27.733-27.733-27.733s-27.733 12.416-27.733 27.733c0 141.283 104.178 257.887 244.335 301.566 4.45 38.01 36.767 67.505 75.972 67.505h97.523c39.211 0 71.526-29.498 75.972-67.512 140.147-43.685 244.314-160.284 244.314-301.559 0-15.317-12.416-27.733-27.733-27.733s-27.733 12.416-27.733 27.733c0 106.474-75.529 201.302-188.322 242.84V533.35c0-15.317-12.416-27.733-27.733-27.733S581.8 518.033 581.8 533.35v279.218a26 26 0 0 0 0 2.428v10.926c0 11.614-9.417 21.029-21.03 21.029h-97.523c-11.614 0-21.026-9.415-21.026-21.029v-11.689q.006-.451 0-.901V533.351c0-15.317-12.42-27.733-27.735-27.733s-27.733 12.416-27.733 27.733v242.845zm-19.646-481.001c0 19.729 15.993 35.725 35.721 35.725s35.72-15.996 35.72-35.725v-23.812c0-19.729-15.992-35.721-35.72-35.721s-35.721 15.991-35.721 35.721zm250.035 35.724c-19.729 0-35.721-15.996-35.721-35.725v-23.812c0-19.729 15.991-35.721 35.721-35.721 19.725 0 35.721 15.991 35.721 35.721v23.812c0 19.729-15.996 35.725-35.721 35.725M158.621 403.2a308.5 308.5 0 0 1-9.746-77.06c0-185.95 164.074-332.553 361.128-332.553 197.056 0 361.131 146.603 361.131 332.553 0 26.505-3.375 52.309-9.749 77.06h77.278c15.313 0 27.733 12.416 27.733 27.733s-12.42 27.733-27.733 27.733H81.359c-15.317 0-27.733-12.416-27.733-27.733S66.042 403.2 81.359 403.2zm56.218 0h590.327a27.9 27.9 0 0 1 1.033-8.371 253 253 0 0 0 9.468-68.689c0-150.746-134.46-277.086-305.664-277.086S204.342 175.394 204.342 326.14c0 23.735 3.287 46.741 9.466 68.689a27.7 27.7 0 0 1 1.032 8.371z",
    glyphName: "pro_outline_24",
    unicode: "\\uEA35"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M400 742.377c-96.158-36.663-160-118.091-160-209.033 0-14.726-11.938-26.667-26.667-26.667s-26.667 11.94-26.667 26.667c0 124.403 91.332 226.877 214.007 265.7 4.723 33.695 33.664 59.623 68.659 59.623h85.333c34.997 0 63.936-25.929 68.659-59.624 122.673-38.825 214.003-141.296 214.003-265.699 0-14.726-11.938-26.667-26.667-26.667-14.726 0-26.667 11.94-26.667 26.667 0 90.94-63.84 172.367-159.996 209.03V533.333c0-14.729-11.938-26.667-26.667-26.667s-26.667 11.938-26.667 26.667v244.649q-.021.74 0 1.485v9.866c0 8.836-7.164 16-16 16H469.33c-8.836 0-16-7.164-16-16v-10.026q.014-.585 0-1.165V533.333c0-14.729-11.938-26.667-26.667-26.667s-26.667 11.938-26.667 26.667v209.043zm-16-433.044c0 17.673 14.327 32 32 32s32-14.327 32-32V288c0-17.673-14.327-32-32-32s-32 14.327-32 32zm224 32c-17.673 0-32-14.327-32-32V288c0-17.673 14.327-32 32-32s32 14.327 32 32v21.333c0 17.673-14.327 32-32 32M128 404.25h66.874a278.2 278.2 0 0 1-8.207-67.189c0-167.738 147.955-299.733 325.333-299.733s325.333 131.996 325.333 299.733c0 23.081-2.835 45.574-8.207 67.189H896c14.729 0 26.667 11.94 26.667 26.667 0 14.729-11.938 26.667-26.667 26.667H128c-14.728 0-26.667-11.938-26.667-26.667 0-14.726 11.939-26.667 26.667-26.667m120.412-6.149c.576 2.048.898 4.111.981 6.148h525.214c.083-2.037.405-4.1.981-6.148A224.8 224.8 0 0 0 784 337.06c0-133.884-119.479-246.4-272-246.4s-272 112.516-272 246.4c0 21.094 2.921 41.538 8.412 61.041",
    glyphName: "pro_outline_48",
    unicode: "\\uEA36"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M512 21.333c235.641 0 426.667 191.025 426.667 426.667S747.642 874.667 512 874.667 85.333 683.642 85.333 448 276.358 21.333 512 21.333m-72.02 518.75h-53.437c3.437 67.5 48.437 121.25 136.249 121.25 78.751 0 132.5-48.75 132.5-113.125 0-49.062-25.312-83.75-65.312-107.813-39.688-23.438-50.938-40.938-50.938-73.75v-25.312h-54.687v33.75c-.313 41.25 19.687 69.375 62.5 95 36.25 22.188 50.313 41.875 50.313 75.313 0 38.75-30.001 67.187-76.563 67.187-47.188 0-77.187-27.813-80.625-72.5m44.273-241.416h55.467v-64h-55.467z",
    glyphName: "question_12",
    unicode: "\\uEA37"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M512 21.333c235.639 0 426.667 191.027 426.667 426.667 0 235.642-191.027 426.667-426.667 426.667-235.642 0-426.667-191.025-426.667-426.667C85.333 212.361 276.358 21.333 512 21.333m-72.007 518.75h-53.437c3.438 67.5 48.437 121.25 136.25 121.25 78.749 0 132.498-48.75 132.498-113.125 0-49.062-25.31-83.75-65.308-107.812-39.689-23.437-50.939-40.937-50.939-73.752v-25.31h-54.688v33.752c-.312 41.248 19.688 69.373 62.5 94.998 36.248 22.188 50.311 41.875 50.311 75.313 0 38.75-29.999 67.187-76.562 67.187-47.188 0-77.187-27.813-80.625-72.5zm44.267-241.416h55.467v-64H484.26z",
    glyphName: "question_18",
    unicode: "\\uEA38"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M512 21.333c235.639 0 426.667 191.027 426.667 426.667 0 235.642-191.027 426.667-426.667 426.667-235.642 0-426.667-191.025-426.667-426.667C85.333 212.361 276.358 21.333 512 21.333m-72 518.75h-53.437c3.437 67.5 48.437 121.25 136.249 121.25 78.75 0 132.501-48.75 132.501-113.125 0-49.064-25.314-83.752-65.314-107.811-39.689-23.437-50.935-40.939-50.935-73.749v-25.314h-54.69v33.749c-.311 41.25 19.691 69.376 62.502 95.002 36.25 22.187 50.313 41.873 50.313 75.311 0 38.75-29.999 67.188-76.565 67.188-47.185 0-77.184-27.812-80.623-72.5zm44.271-241.416h55.467v-64h-55.467z",
    glyphName: "question_24",
    unicode: "\\uEA39"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M512 21.333c235.642 0 426.667 191.025 426.667 426.667S747.642 874.667 512 874.667 85.333 683.642 85.333 448 276.358 21.333 512 21.333m-72 518.75h-53.438c3.437 67.501 48.437 121.25 136.25 121.25 78.75 0 132.501-48.751 132.501-113.124 0-49.062-25.314-83.75-65.314-107.812-39.686-23.439-50.935-40.939-50.935-73.751v-25.312h-54.688v33.749c-.314 41.25 19.686 69.376 62.5 95.002 36.25 22.187 50.313 41.873 50.313 75.311 0 38.75-30.001 67.187-76.563 67.187-47.187 0-77.188-27.812-80.625-72.499zm45.333-241.416h53.333v-64h-53.333z",
    glyphName: "question_48",
    unicode: "\\uEA3A"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M512 76.8c-205.008 0-371.2 166.192-371.2 371.2S306.992 819.2 512 819.2 883.2 653.008 883.2 448 717.008 76.8 512 76.8m0-55.467c235.641 0 426.667 191.025 426.667 426.667S747.642 874.667 512 874.667 85.333 683.642 85.333 448 276.358 21.333 512 21.333m-27.733 213.334v64h55.467v-64zm-97.711 305.416h53.437c3.437 44.687 33.437 72.5 80.625 72.5 46.563 0 76.563-28.437 76.563-67.187 0-33.438-14.063-53.125-50.313-75.313-42.813-25.625-62.812-53.75-62.5-95v-33.75h54.688v25.312c0 32.812 11.249 50.313 50.937 73.75 40 24.062 65.312 58.75 65.312 107.813 0 64.375-53.75 113.125-132.5 113.125-87.813 0-132.813-53.75-136.25-121.25z",
    glyphName: "question_outline_12",
    unicode: "\\uEA3B"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M512 76.8c-205.008 0-371.2 166.19-371.2 371.2 0 205.008 166.192 371.2 371.2 371.2 205.01 0 371.2-166.192 371.2-371.2 0-205.01-166.19-371.2-371.2-371.2m0-55.467c235.639 0 426.667 191.027 426.667 426.667 0 235.642-191.027 426.667-426.667 426.667-235.642 0-426.667-191.025-426.667-426.667C85.333 212.361 276.358 21.333 512 21.333m-27.733 213.334v64h55.467v-64zm-97.705 305.416H440c3.437 44.687 33.437 72.5 80.625 72.5 46.562 0 76.56-28.438 76.56-67.187 0-33.438-14.063-53.125-50.31-75.313-42.813-25.625-62.813-53.75-62.5-94.998v-33.752h54.688v25.31c0 32.815 11.25 50.315 50.938 73.752 39.999 24.063 65.314 58.75 65.314 107.812 0 64.375-53.754 113.125-132.502 113.125-87.813 0-132.812-53.75-136.25-121.25z",
    glyphName: "question_outline_18",
    unicode: "\\uEA3C"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M512 76.8c-205.008 0-371.2 166.191-371.2 371.2S306.992 819.2 512 819.2c205.009 0 371.2-166.192 371.2-371.2S717.009 76.8 512 76.8m0-55.467c235.639 0 426.667 191.027 426.667 426.667 0 235.642-191.027 426.667-426.667 426.667-235.642 0-426.667-191.025-426.667-426.667C85.333 212.361 276.358 21.333 512 21.333m-27.733 213.334v64h55.467v-64zM386.56 540.083h53.436c3.439 44.688 33.438 72.5 80.627 72.5 46.562 0 76.561-28.437 76.561-67.188 0-33.438-14.063-53.125-50.313-75.311-42.812-25.626-62.81-53.751-62.498-95.002v-33.749h54.686v25.314c0 32.811 11.251 50.313 50.94 73.749 40 24.06 65.31 58.748 65.31 107.811 0 64.375-53.747 113.125-132.497 113.125-87.812 0-132.814-53.75-136.252-121.25z",
    glyphName: "question_outline_24",
    unicode: "\\uEA3D"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M512 74.667c-206.187 0-373.333 167.147-373.333 373.333S305.814 821.333 512 821.333 885.333 654.186 885.333 448 718.186 74.667 512 74.667m0-53.334c235.642 0 426.667 191.025 426.667 426.667S747.642 874.667 512 874.667 85.333 683.642 85.333 448 276.358 21.333 512 21.333m-26.667 213.334v64h53.333v-64zm-98.771 305.416H440c3.437 44.687 33.438 72.499 80.625 72.499 46.562 0 76.563-28.437 76.563-67.187 0-33.438-14.063-53.124-50.313-75.311-42.814-25.626-62.814-53.751-62.5-95.002v-33.749h54.688v25.312c0 32.813 11.249 50.313 50.935 73.751 40 24.062 65.314 58.75 65.314 107.812 0 64.373-53.751 113.124-132.501 113.124-87.812 0-132.813-53.749-136.25-121.25z",
    glyphName: "question_outline_48",
    unicode: "\\uEA3E"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M110.916 789.333c0 47.129 38.205 85.333 85.333 85.333h631.467c47.13 0 85.333-38.205 85.333-85.333V55.919c0-32.529-34.953-53.094-63.387-37.299L553.425 183.199a85.33 85.33 0 0 1-82.883 0L174.305 18.62c-28.439-15.795-63.388 4.77-63.388 37.299z",
    glyphName: "scrap_12",
    unicode: "\\uEA3F"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M113.778 797.861c0 31.419 25.47 56.889 56.889 56.889h682.667c31.42 0 56.889-25.47 56.889-56.889V65.542c0-21.39-22.727-35.129-41.665-25.185L538.445 213.669a56.89 56.89 0 0 1-52.887 0L155.446 40.357c-18.941-9.944-41.667 3.794-41.667 25.185v732.319z",
    glyphName: "scrap_18",
    unicode: "\\uEA40"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M853.333 842.667H170.666c-23.564 0-42.667-19.102-42.667-42.667V71.561c0-16.043 17.044-26.347 31.25-18.889l332.919 174.784a42.66 42.66 0 0 0 39.663 0L864.75 52.672c14.204-7.458 31.249 2.846 31.249 18.889V800c0 23.564-19.102 42.667-42.667 42.667z",
    glyphName: "scrap_24",
    unicode: "\\uEA41"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M128 822.396c0 11.782 9.551 21.333 21.333 21.333h725.333c11.782 0 21.333-9.551 21.333-21.333V72.623c0-16.043-17.045-26.345-31.249-18.889L521.915 233.723a21.33 21.33 0 0 1-19.831 0L159.249 53.734c-14.205-7.456-31.25 2.846-31.25 18.889v749.773z",
    glyphName: "scrap_48",
    unicode: "\\uEA42"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M85.333 106.667V448h85.333V149.333h682.667V448h85.333V106.667C938.666 83.106 919.56 64 895.999 64h-768c-23.564 0-42.667 19.106-42.667 42.667zM481.83 862.17c16.662 16.663 43.677 16.663 60.339 0l234.667-234.667-60.339-60.339-161.83 161.83v-451.66h-85.333v451.66l-161.83-161.83-60.339 60.339L481.832 862.17z",
    glyphName: "share2_12",
    unicode: "\\uEA43"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M91.028 106.661v341.333h73.956V143.638h694.044v304.356h73.956V106.661c0-20.423-16.555-36.978-36.978-36.978h-768c-20.423 0-36.978 16.555-36.978 36.978m394.83 751.481c14.441 14.441 37.854 14.441 52.295 0l234.666-234.667-52.292-52.295-171.543 171.542V277.328h-73.956v465.394L303.486 571.18l-52.295 52.295z",
    glyphName: "share2_18",
    unicode: "\\uEA44"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M100.271 106.662v341.333h55.467v-313.6h712.533v313.6h55.467V106.662c0-15.317-12.416-27.733-27.733-27.733h-768c-15.317 0-27.733 12.416-27.733 27.733zm392.124 744.944c10.829 10.831 28.39 10.831 39.219 0l234.667-234.667-39.219-39.221-187.324 187.323V277.329h-55.467v487.712L296.948 577.718l-39.221 39.221z",
    glyphName: "share2_24",
    unicode: "\\uEA45"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M101.333 106.667V448h53.333V133.333h714.667V448h53.333V106.667c0-14.729-11.938-26.667-26.667-26.667h-768c-14.728 0-26.667 11.938-26.667 26.667zm391.81 744.189c10.415 10.414 27.298 10.414 37.713 0L765.523 616.19l-37.713-37.713-189.143 189.144V277.333h-53.333v490.288L296.191 578.477l-37.713 37.713 234.667 234.666z",
    glyphName: "share2_48",
    unicode: "\\uEA46"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M827.716 789.333V128.432l-232.85 129.361c-51.545 28.636-114.221 28.636-165.766 0L196.249 128.432v660.901zM196.25 874.667c-47.128 0-85.333-38.205-85.333-85.333V55.92c0-32.529 34.949-53.094 63.388-37.299L470.542 183.2a85.33 85.33 0 0 0 82.883 0L849.662 18.621c28.435-15.795 63.387 4.77 63.387 37.299v733.414c0 47.128-38.204 85.333-85.333 85.333z",
    glyphName: "scrap_outline_12",
    unicode: "\\uEA47"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M187.733 780.794h648.533V140.84L572.819 279.148a130.86 130.86 0 0 1-121.641 0L187.732 140.84zm-17.066 73.956c-31.419 0-56.889-25.47-56.889-56.889V65.542c0-21.39 22.726-35.129 41.667-25.185l330.112 173.312a56.89 56.89 0 0 0 52.887 0L868.557 40.357c18.938-9.944 41.665 3.794 41.665 25.185v732.319c0 31.419-25.469 56.889-56.889 56.889H170.666z",
    glyphName: "scrap_outline_18",
    unicode: "\\uEA48"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M183.467 787.2V128.034l282.918 148.531a98.14 98.14 0 0 0 91.23 0l282.918-148.531V787.2H183.466zm-12.8 55.467h682.667c23.565 0 42.667-19.103 42.667-42.667V71.561c0-16.043-17.045-26.347-31.249-18.889L531.833 227.456a42.66 42.66 0 0 1-39.663 0L159.251 52.672c-14.205-7.458-31.25 2.846-31.25 18.889V800c0 23.564 19.103 42.667 42.667 42.667z",
    glyphName: "scrap_outline_24",
    unicode: "\\uEA49"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M174.933 796.796h674.133V114.978L543.733 275.277a68.27 68.27 0 0 1-63.467 0L174.933 114.978zm-25.6 46.933c-11.782 0-21.333-9.551-21.333-21.333V72.623c0-16.043 17.044-26.345 31.25-18.889l342.835 179.989a21.33 21.33 0 0 0 19.831 0L864.751 53.734C878.955 46.278 896 56.58 896 72.623v749.773c0 11.782-9.551 21.333-21.333 21.333H149.334z",
    glyphName: "scrap_outline_48",
    unicode: "\\uEA4A"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M753.964 508.352c0 155.181-125.8 280.981-280.982 280.981s-280.981-125.8-280.981-280.981c0-155.182 125.8-280.982 280.981-280.982s280.982 125.8 280.982 280.982m-67.825-297.946c-60.047-43.036-133.644-68.37-213.158-68.37-202.31 0-366.315 164.005-366.315 366.316s164.005 366.315 366.315 366.315c202.311 0 366.316-164.005 366.316-366.315 0-92.022-33.931-176.118-89.964-240.46L967.134 50.099l-60.348-60.348z",
    glyphName: "search_12",
    unicode: "\\uEA4B"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M765.343 508.352c0 161.465-130.896 292.359-292.362 292.359S180.622 669.817 180.622 508.352c0-161.466 130.894-292.362 292.359-292.362s292.362 130.896 292.362 292.362M690.796 213.8c-60.882-45.096-136.234-71.765-217.814-71.765-202.31 0-366.315 164.005-366.315 366.317 0 202.31 164.005 366.315 366.315 366.315 202.312 0 366.317-164.005 366.317-366.315 0-94.07-35.459-179.858-93.742-244.729L963.106 46.074 910.814-6.218z",
    glyphName: "search_18",
    unicode: "\\uEA4C"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M766.511 517.009c0 166.896-135.292 302.191-302.187 302.191S162.133 683.905 162.133 517.009s135.295-302.187 302.191-302.187 302.187 135.292 302.187 302.187M683.716 234.53c-60.574-47.117-136.708-75.174-219.392-75.174-197.53 0-357.658 160.128-357.658 357.653 0 197.53 160.128 357.658 357.658 357.658 197.525 0 357.653-160.128 357.653-357.658 0-94.857-36.928-181.09-97.19-245.107L936.943 59.746l-39.219-39.219z",
    glyphName: "search_24",
    unicode: "\\uEA4D"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M792.363 508.352c0 176.388-142.991 319.381-319.381 319.381-176.388 0-319.381-142.993-319.381-319.381 0-176.39 142.993-319.381 319.381-319.381 176.39 0 319.381 142.991 319.381 319.381m-90.769-286.24C638.932 172 559.456 142.037 472.982 142.037c-202.31 0-366.315 164.004-366.315 366.315s164.004 366.315 366.315 366.315c202.31 0 366.315-164.004 366.315-366.315 0-98.931-39.217-188.702-102.955-254.615L953.554 36.525 920.368 3.337z",
    glyphName: "search_48",
    unicode: "\\uEA4E"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M512 362.667c47.128 0 85.333 38.205 85.333 85.333S559.128 533.333 512 533.333 426.667 495.128 426.667 448s38.205-85.333 85.333-85.333M682.667 448c0-94.257-76.41-170.667-170.667-170.667S341.333 353.743 341.333 448 417.743 618.667 512 618.667 682.667 542.257 682.667 448M568.464 172.08l168.605 93.3 67.856-15.727c13.109 17.375 24.498 35.894 33.978 55.341l-46.615 46.876v192.053l46.623 46.884c-9.487 19.484-20.885 38.038-33.999 55.433l-67.843-15.724-168.605 93.3-19.591 63.684A373 373 0 0 1 512 789.332c-12.414 0-24.717-.624-36.883-1.825l-19.566-63.683-168.62-93.309-67.855 15.727c-13.119-17.393-24.517-35.937-34.002-55.421l46.638-46.899v-191.95l-46.622-46.883c9.481-19.464 20.865-37.989 33.956-55.341l67.885 15.734 168.62-93.309 19.576-63.717A379 379 0 0 1 512 106.665c12.421 0 24.73.625 36.903 1.827l19.561 63.586zm46.462-139.193C581.873 25.463 547.421 21.333 512 21.333s-69.873 4.028-102.926 11.554l-24.977 81.3-109.816 60.768-85.914-19.913c-47.156 47.769-82.9 106.061-103.033 170.749l61.045 61.387v121.536l-61.045 61.387c20.133 64.792 55.877 122.981 103.033 170.853l85.914-19.913 109.816 60.768 24.977 81.3c33.053 7.428 67.505 11.555 102.926 11.555s69.873-4.127 102.926-11.658l24.978-81.196 109.815-60.768 85.914 19.913c47.157-47.872 82.903-106.164 103.033-170.853l-61.047-61.387V387.076l61.047-61.387C918.536 261 882.79 202.812 835.633 154.94l-85.914 19.913-109.815-60.768z",
    glyphName: "setting_outline_12",
    unicode: "\\uEA4F"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M512 351.289c53.412 0 96.711 43.299 96.711 96.711S565.412 544.711 512 544.711 415.289 501.412 415.289 448s43.299-96.711 96.711-96.711M682.667 448c0-94.259-76.407-170.667-170.667-170.667-94.256 0-170.667 76.407-170.667 170.667 0 94.256 76.41 170.667 170.667 170.667 94.259 0 170.667-76.41 170.667-170.667M577.991 164.346l160.762 88.963 70.719-16.39c17.146 21.771 31.653 45.386 43.133 70.434l-48.942 49.209v182.666l48.947 49.217c-11.492 25.087-25.998 48.742-43.145 70.529l-70.713-16.388-160.762 88.962-20.442 66.448a385 385 0 0 1-45.549 2.714c-15.375 0-30.577-.928-45.559-2.701l-20.417-66.454-160.78-88.97-70.718 16.39c-17.156-21.784-31.665-45.424-43.149-70.517l48.956-49.231V356.669l-48.942-49.22c11.483-25.071 25.981-48.697 43.105-70.434l70.748 16.395 160.78-88.969 20.429-66.497a390 390 0 0 1 45.546-2.657c15.382 0 30.589.927 45.577 2.702l20.415 66.355zm36.932-131.459C581.871 25.457 547.42 21.333 512 21.333s-69.873 4.022-102.926 11.554l-24.978 81.3-109.815 60.769-85.915-19.911c-47.156 47.77-82.9 106.058-103.033 170.746l61.045 61.389v121.536l-61.045 61.387c20.133 64.792 55.877 122.981 103.033 170.853l85.915-19.912 109.815 60.768 24.978 81.299c33.052 7.429 67.505 11.555 102.926 11.555s69.871-4.127 102.923-11.658l24.98-81.196 109.818-60.768 85.914 19.912c47.155-47.872 82.898-106.164 103.031-170.853l-61.047-61.387V387.077l61.047-61.389C918.533 261 882.79 202.814 835.635 154.942l-85.914 19.911-109.818-60.769z",
    glyphName: "setting_outline_18",
    unicode: "\\uEA50"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M512 332.8c63.625 0 115.2 51.575 115.2 115.2S575.625 563.2 512 563.2 396.8 511.625 396.8 448 448.375 332.8 512 332.8M682.667 448c0-94.255-76.412-170.667-170.667-170.667-94.257 0-170.667 76.412-170.667 170.667 0 94.257 76.41 170.667 170.667 170.667 94.255 0 170.667-76.41 170.667-170.667m-89.199-296.218 148.028 81.911 75.042-17.391c24.085 28.685 43.725 60.71 58.039 95.172l-52.42 52.719V531.6l52.425 52.718c-14.323 34.499-33.967 66.575-58.052 95.273L741.496 662.2l-148.028 81.914-21.726 70.63A404 404 0 0 1 512 819.199c-20.258 0-40.209-1.537-59.75-4.428l-21.709-70.651-148.037-81.92-75.04 17.392c-24.094-28.697-43.738-60.745-58.055-95.262l52.435-52.73V364.295l-52.424-52.719c14.32-34.492 33.957-66.543 58.018-95.177l75.066 17.399 148.037-81.92 21.722-70.699a408 408 0 0 1 59.738-4.382c20.262 0 40.218 1.536 59.763 4.429l21.705 70.554zm21.457-118.895C581.871 25.459 547.422 21.333 512 21.333s-69.871 4.023-102.925 11.554l-24.978 81.301-109.816 60.766-85.914-19.913c-47.156 47.77-82.9 106.061-103.033 170.752l61.044 61.385v121.536l-61.044 61.389c20.133 64.791 55.877 122.981 103.033 170.852l85.914-19.912 109.816 60.768 24.978 81.299c33.054 7.429 67.503 11.555 102.925 11.555s69.871-4.127 102.925-11.658l24.977-81.196 109.815-60.768 85.918 19.912c47.155-47.872 82.897-106.164 103.031-170.852l-61.043-61.389V387.076l61.043-61.385C918.532 261 882.79 202.811 835.635 154.939l-85.918 19.913-109.815-60.766z",
    glyphName: "setting_outline_24",
    unicode: "\\uEA51"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M512 330.667c64.802 0 117.333 52.531 117.333 117.333S576.802 565.333 512 565.333 394.667 512.802 394.667 448 447.198 330.667 512 330.667M682.667 448c0-94.257-76.41-170.667-170.667-170.667S341.333 353.743 341.333 448 417.743 618.667 512 618.667 682.667 542.257 682.667 448m-87.414-297.668 146.56 81.101 75.514-17.502c24.913 29.466 45.152 62.473 59.763 98.044l-52.802 53.099v165.647l52.804 53.101c-14.618 35.607-34.861 68.666-59.772 98.144l-75.507-17.5-146.56 81.101-21.869 71.088a406.5 406.5 0 0 1-61.385 4.679c-20.828 0-41.329-1.616-61.395-4.65l-21.85-71.113-146.569-81.105-75.513 17.502c-24.923-29.478-45.165-62.507-59.778-98.135l52.815-53.111V365.177l-52.804-53.101c14.616-35.599 34.852-68.634 59.742-98.046l75.538 17.506 146.569-81.105 21.865-71.162a410.6 410.6 0 0 1 61.38-4.602c20.832 0 41.338 1.617 61.408 4.653zM614.925 32.89C581.873 25.46 547.422 21.334 512 21.334s-69.873 4.023-102.925 11.556l-24.979 81.299-109.815 60.768-85.914-19.913c-47.156 47.767-82.9 106.061-103.033 170.75l61.045 61.387v121.536l-61.045 61.387c20.133 64.791 55.877 122.98 103.033 170.852l85.914-19.913 109.815 60.769 24.979 81.299c33.052 7.428 67.503 11.555 102.925 11.555s69.873-4.127 102.925-11.658l24.979-81.196 109.815-60.769 85.914 19.913c47.157-47.872 82.901-106.163 103.034-170.852l-61.045-61.387V387.076l61.045-61.387C918.535 261 882.791 202.811 835.633 154.939l-85.914 19.913-109.815-60.768-24.979-81.195z",
    glyphName: "setting_outline_48",
    unicode: "\\uEA52"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M128 448v257.28c0 23.04 18.347 41.387 41.387 42.667C397.654 760.32 512 874.667 512 874.667s114.347-114.347 342.613-126.72C877.653 746.667 896 728.32 896 705.28V448s0-298.667-384-426.667C128 149.333 128 448 128 448",
    glyphName: "shield_12",
    unicode: "\\uEA53"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M128 448v257.28c0 23.04 18.347 41.387 41.387 42.667C397.654 760.32 512 874.667 512 874.667s114.347-114.347 342.613-126.72C877.653 746.667 896 728.32 896 705.28V448s0-298.667-384-426.667C128 149.333 128 448 128 448",
    glyphName: "shield_18",
    unicode: "\\uEA54"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M128 448v257.28c0 23.04 18.347 41.387 41.387 42.667C397.654 760.32 512 874.667 512 874.667s114.347-114.347 342.613-126.72C877.653 746.667 896 728.32 896 705.28V448s0-298.667-384-426.667C128 149.333 128 448 128 448",
    glyphName: "shield_24",
    unicode: "\\uEA55"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M128 448v257.28c0 23.04 18.347 41.387 41.387 42.667C397.654 760.32 512 874.667 512 874.667s114.347-114.347 342.613-126.72C877.653 746.667 896 728.32 896 705.28V448s0-298.667-384-426.667C128 149.333 128 448 128 448",
    glyphName: "shield_48",
    unicode: "\\uEA56"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M896 448v257.28c0 23.04-18.347 41.387-41.387 42.667C626.346 760.32 512 874.667 512 874.667S397.653 760.32 169.387 747.947C146.347 746.667 128 728.32 128 705.28V448s0-298.667 384-426.667C896 149.333 896 448 896 448M512 111.849c-152.303 57.285-224.748 143.054-260.583 210.744-19.481 36.797-29.057 70.055-33.741 93.475-2.336 11.678-3.425 20.767-3.93 26.423a125 125 0 0 0-.413 6.189v217.162c108.776 11.322 193.181 43.191 252.776 74.629 17.447 9.204 32.742 18.357 45.891 26.926 13.148-8.569 28.443-17.722 45.891-26.926 59.595-31.439 144-63.307 252.776-74.628V448.68a125.277 125.277 0 0 0-.413-6.189c-.504-5.656-1.594-14.745-3.93-26.423-4.684-23.42-14.26-56.678-33.741-93.475C736.747 254.902 664.304 169.134 512 111.849",
    glyphName: "shield_outline_12",
    unicode: "\\uEA57"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M896 448v257.28c0 23.04-18.347 41.387-41.387 42.667C626.346 760.32 512 874.667 512 874.667S397.653 760.32 169.387 747.947C146.347 746.667 128 728.32 128 705.28V448s0-298.667 384-426.667C896 149.333 896 448 896 448M512 99.703c-157.668 58.271-233.206 146.859-270.639 217.566-20.083 37.934-29.982 72.272-34.842 96.568-2.424 12.121-3.569 21.619-4.106 27.643a137 137 0 0 0-.43 6.256l-.028.81v227.619c112.118 10.171 198.541 42.556 258.845 74.369 19.954 10.527 37.019 20.973 51.199 30.507 14.181-9.533 31.246-19.98 51.199-30.507 60.303-31.813 146.728-64.199 258.845-74.369V448.546l-.028-.81a128 128 0 0 0-.432-6.256c-.535-6.024-1.678-15.523-4.102-27.643-4.858-24.296-14.757-58.634-34.844-96.568-37.433-70.707-112.97-159.295-270.638-217.566z",
    glyphName: "shield_outline_18",
    unicode: "\\uEA58"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M896 448v257.28c0 23.04-18.347 41.387-41.387 42.667C626.346 760.32 512 874.667 512 874.667S397.653 760.32 169.387 747.947C146.347 746.667 128 728.32 128 705.28V448s0-298.667 384-426.667C896 149.333 896 448 896 448M512 80.026c-166.336 59.802-246.933 152.951-286.979 228.595-21.062 39.782-31.486 75.866-36.631 101.589-2.568 12.843-3.802 23.006-4.392 29.628a155 155 0 0 0-.487 7.117 61 61 0 0 0-.044 1.323v244.964c117.646 8.064 207.342 41.274 268.706 73.647 24.486 12.918 44.429 25.681 59.827 36.628 15.398-10.947 35.341-23.71 59.827-36.628 61.363-32.373 151.061-65.583 268.706-73.647v-244.96c-.004-.179-.013-.627-.043-1.327-.06-1.399-.192-3.81-.486-7.117-.593-6.622-1.826-16.785-4.395-29.628-5.146-25.724-15.569-61.807-36.629-101.589C758.933 232.977 678.336 139.827 512 80.026",
    glyphName: "shield_outline_24",
    unicode: "\\uEA59"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M896 448v257.28c0 23.04-18.347 41.387-41.387 42.667C626.346 760.32 512 874.667 512 874.667S397.653 760.32 169.387 747.947C146.347 746.667 128 728.32 128 705.28V448s0-298.667 384-426.667C896 149.333 896 448 896 448M512 77.76c-167.332 59.974-248.516 153.647-288.864 229.86-21.176 39.998-31.661 76.286-36.838 102.172-2.585 12.924-3.828 23.168-4.425 29.858a156 156 0 0 0-.493 7.215c-.03.717-.042 1.178-.046 1.372v246.999c118.291 7.799 208.365 41.105 269.845 73.539 25.058 13.219 45.329 26.272 60.821 37.361 15.492-11.089 35.763-24.143 60.821-37.361 61.481-32.433 151.554-65.739 269.845-73.539V448.237a57 57 0 0 0-.047-1.372c-.06-1.431-.194-3.874-.493-7.215-.595-6.69-1.839-16.934-4.425-29.858-5.178-25.886-15.663-62.174-36.838-102.172-40.348-76.213-121.532-169.886-288.864-229.86z",
    glyphName: "shield_outline_48",
    unicode: "\\uEA5A"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "m725.333 817.5 33.001-123.162 123.176-33.004-33.006-123.171 90.162-90.162-90.166-90.166 33.001-123.172-123.162-33.002-33.002-123.162L602.165 111.5l-90.166-90.166-90.162 90.162L298.666 78.49l-33.004 123.176L142.5 234.667l33.002 123.165L85.334 448l90.164 90.164-33.002 123.165 123.172 33.004 33.004 123.172 123.165-33.002 90.164 90.164 90.168-90.168 123.165 33.002zM457.03 288.686l276 256L675 607.25 428.015 378.162l-78.985 73.261L291 388.859l108-100.174c16.365-15.18 41.665-15.18 58.03 0z",
    glyphName: "signed_12",
    unicode: "\\uEA5B"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "m725.333 817.5 33.001-123.163 123.176-33.004-33.007-123.171L938.666 448l-90.169-90.169 33.007-123.17L758.34 201.66 725.339 78.496l-123.17 33.007L512 21.334l-90.162 90.163L298.667 78.49l-33.004 123.176L142.5 234.667l33.002 123.164L85.334 448l90.164 90.164-33.002 123.165 123.171 33.004 33.004 123.171 123.165-33.002L512 874.666l90.169-90.168zM453.154 292.887l276.002 256.002-50.295 54.222-250.853-232.673-82.854 76.847-50.293-54.222 108-100.176c14.184-13.153 36.11-13.153 50.293 0",
    glyphName: "signed_18",
    unicode: "\\uEA5C"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "m725.333 817.504 33.003-123.168 123.17-33.003-33.003-123.168L938.666 448l-90.167-90.163 33.007-123.17-123.17-33.003-33.003-123.17-123.17 33.003L512 21.334l-90.165 90.163-123.168-33.003-33.003 123.17-123.168 33.003 33.003 123.17L85.334 448l90.165 90.165-33.003 123.168 123.168 33.003 33.003 123.168 123.168-33.003L512 874.666l90.167-90.165zM446.865 299.665l276.002 256.002-37.722 40.666-257.139-238.505-89.141 82.679-37.719-40.666 108-100.177c10.637-9.865 27.082-9.865 37.719 0z",
    glyphName: "signed_24",
    unicode: "\\uEA5D"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "m725.333 817.5 33.001-123.162 123.174-33.005-33.003-123.172L938.666 448l-90.165-90.165 33.003-123.172L758.34 201.66 725.337 78.496l-123.172 33.003L512 21.334l-90.161 90.161-123.172-33.003-33.005 123.174L142.5 234.667l33.002 123.164-90.169 90.17 90.164 90.165-33.002 123.164 123.17 33.005 33.005 123.17 123.164-33.002 90.165 90.164 90.17-90.169zm-279.2-517.061 276 256-36.269 39.102-257.865-239.179-89.867 83.354-36.269-39.104 108-100.173c10.229-9.487 26.042-9.487 36.269 0z",
    glyphName: "signed_48",
    unicode: "\\uEA5E"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M758.334 694.338 725.333 817.5l-123.165-33.002L512 874.666l-90.164-90.164-123.165 33.002-33.004-123.172-123.172-33.004 33.002-123.165-90.164-90.164 90.168-90.168-33.002-123.165 123.162-33.001 33.004-123.176 123.171 33.006 90.162-90.162 90.166 90.166 123.172-33.001 33.002 123.162L881.5 234.662l-33.001 123.172L938.665 448l-90.162 90.162 33.006 123.171-123.176 33.004zm18.663-93.345-23.669-88.334 64.66-64.66-64.664-64.664 23.669-88.334-88.328-23.667-23.667-88.328-88.334 23.669L512 142.011l-64.66 64.66-88.334-23.669-23.67 88.336-88.325 23.667 23.667 88.328-64.666 64.666 64.662 64.662-23.667 88.327 88.334 23.67 23.67 88.334 88.327-23.667L512 753.987l64.666-64.666 88.328 23.667 23.667-88.325zm-84.16-55.163L479.504 332.497c-16.222-16.222-42.366-16.713-59.185-1.113l-108 100.175 58.03 62.564 77.872-72.229L632.497 606.17l60.34-60.339z",
    glyphName: "signed_outline_12",
    unicode: "\\uEA5F"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M758.335 694.337 725.334 817.5 602.17 784.498l-90.169 90.168-90.164-90.164-123.165 33.002-33.004-123.171-123.171-33.004 33.002-123.165L85.335 448l90.168-90.169-33.002-123.164 123.163-33.001L298.668 78.49l123.171 33.007 90.162-90.163 90.169 90.169 123.17-33.007 33.001 123.164 123.164 33.001-33.007 123.17L938.667 448l-90.163 90.162 33.007 123.171zm32.597-85.298L766.02 516.06 834.076 448l-68.062-68.062 24.912-92.979-92.974-24.912-24.912-92.974-92.979 24.912-68.062-68.062-68.06 68.056-92.979-24.912-24.914 92.979-92.97 24.912 24.912 92.974L189.922 448l68.062 68.062-24.912 92.972 92.979 24.913 24.913 92.979 92.972-24.912 68.062 68.062 68.068-68.066 92.974 24.912 24.912-92.97 92.979-24.914zm-61.787-60.15L453.147 292.887c-14.184-13.153-36.11-13.153-50.293 0l-108 100.176 50.293 54.222 82.854-76.847 250.855 232.673z",
    glyphName: "signed_outline_18",
    unicode: "\\uEA60"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "m758.336 694.336-33.003 123.168-123.166-33.003L512 874.666l-90.165-90.165-123.168 33.003-33.003-123.168-123.168-33.003 33.003-123.168L85.334 448l90.165-90.163-33.003-123.17 123.168-33.003 33.003-123.17 123.168 33.003L512 21.334l90.163 90.163 123.17-33.003 33.003 123.17 123.17 33.003-33.007 123.17L938.666 448l-90.163 90.165 33.003 123.168zm55.236-72.224-26.935-100.525L860.224 448l-73.587-73.587 26.935-100.527-100.523-26.935-26.935-100.523-100.527 26.935L512 99.776l-73.587 73.587-100.525-26.935-26.935 100.523-100.524 26.935 26.935 100.527L163.776 448l73.588 73.587-26.935 100.525 100.524 26.935 26.935 100.524 100.525-26.935L512 796.224l73.587-73.588 100.527 26.935 26.935-100.524zm-90.713-66.445L446.861 299.665c-10.637-9.865-27.083-9.865-37.721 0l-108 100.177 37.72 40.666 89.138-82.679 257.143 238.505 37.717-40.666z",
    glyphName: "signed_outline_24",
    unicode: "\\uEA61"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M758.334 694.338 725.333 817.5l-123.164-33.002-90.17 90.169-90.165-90.164-123.164 33.002-33.005-123.17-123.17-33.005 33.002-123.164-90.164-90.165 90.169-90.17L142.5 234.667l123.162-33.001 33.005-123.174 123.172 33.003L512 21.334l90.165 90.165 123.172-33.003L758.34 201.66l123.164 33.003-33.003 123.172L938.666 448l-90.161 90.161 33.003 123.172zm57.854-70.718L789.02 522.223 863.243 448l-74.227-74.227 27.168-101.397-101.391-27.168-27.168-101.391-101.397 27.168-74.227-74.227-74.223 74.223-101.397-27.168-27.17 101.399-101.39 27.168 27.167 101.391L160.759 448l74.224 74.225-27.167 101.391 101.398 27.17 27.17 101.398 101.391-27.167L512 799.241l74.229-74.229 101.391 27.167 27.168-101.39 101.399-27.17zm-94.053-67.172-276-256c-10.229-9.487-26.042-9.487-36.271 0l-108 100.175 36.271 39.102L428 356.371l257.865 239.181z",
    glyphName: "signed_outline_48",
    unicode: "\\uEA62"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M328.842 793.919a42.667 42.667 0 0 1-60.34.001L55.167 580.585l60.34-60.34 140.499 140.499V123.745h85.333v536.997L481.83 520.247l60.341 60.338zM755.509 93.577c-8.002-7.996-18.854-12.493-30.17-12.493s-22.169 4.497-30.17 12.493L481.834 306.915l60.34 60.34 140.499-140.499v536.999h85.333V226.758l140.488 140.495 60.348-60.338L755.51 93.576z",
    glyphName: "sorting_12",
    unicode: "\\uEA63"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M310.592 846.222a36.98 36.98 0 0 0 26.148-10.831l170.661-170.667-52.295-52.293L347.57 719.97V49.777h-73.956v670.194L166.072 612.429l-52.295 52.295 170.667 170.667a36.98 36.98 0 0 0 26.147 10.831zM713.415 49.778a36.97 36.97 0 0 1 26.146 10.832l170.661 170.667-52.298 52.292-107.531-107.537v670.191h-73.956V176.026L568.894 283.569l-52.295-52.292L687.269 60.61a36.97 36.97 0 0 1 26.146-10.832",
    glyphName: "sorting_18",
    unicode: "\\uEA64"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M318.277 874.667c7.356 0 14.41-2.922 19.611-8.123l170.66-170.667-39.219-39.22L346.01 779.978V21.334h-55.467V779.98L167.22 656.657l-39.221 39.221 170.667 170.667a27.73 27.73 0 0 0 19.61 8.123zM705.728 21.333a27.73 27.73 0 0 1 19.61 8.124L896 200.124l-39.223 39.219-123.315-123.319v758.643h-55.467V116.02L554.671 239.344l-39.219-39.219L686.119 29.458a27.73 27.73 0 0 1 19.61-8.124z",
    glyphName: "sorting_24",
    unicode: "\\uEA65"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M299.264 809.106a23.47 23.47 0 0 1-33.188 0L36.74 579.77l33.187-33.186L259.203 735.86V104.504h46.933v631.354l189.269-189.274 33.188 33.186zM757.931 87.919a23.47 23.47 0 0 0-33.188 0L495.408 317.257l33.186 33.186L717.87 161.167v631.355h46.933V161.167l189.269 189.276 33.188-33.186z",
    glyphName: "sorting_48",
    unicode: "\\uEA66"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M886.406 75.635v67.149l-219.341 46.522v-88.442c0-22.976-18.63-41.6-41.603-41.6H222.068c-22.975 0-41.6 18.624-41.6 41.6v191.661l-93.094 19.75c-19.22 4.077-32.968 21.044-32.968 40.692v201.697c0 19.648 13.747 36.618 32.968 40.694L886.406 764.85v67.149h83.2V75.634h-83.2zM263.668 274.88V142.464h320.194v64.493zM886.406 679.8l-748.8-158.836V386.67l748.8-158.835z",
    glyphName: "bullhorn_outline_16",
    unicode: "\\uEA67"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M170.667 122.333c0 14.908 12.689 26.999 28.331 26.999h626.005c15.642 0 28.331-12.092 28.331-26.999V76.954c0-30.72-26.121-55.62-58.368-55.62H229.035c-32.239 0-58.368 24.892-58.368 55.62zm720.708 723.311C963.533 851.088 1024 793.343 1024 721.595c0-55.689-36.412-102.946-86.443-118.775l-89.225-383.77c-1.86-15.445-14.848-27.051-30.259-27.051H207.308c-15.386 0-28.339 11.554-30.251 26.965L86.86 602.682C36.607 618.383-.001 665.743-.001 721.577c0 71.765 60.467 129.527 132.642 124.083 59.836-4.523 108.271-52.992 113.314-113.365 1.432-16.537-.451-33.194-5.539-48.993s-13.277-30.426-24.089-43.022l140.715-57.344 93.611 58.359a124.7 124.7 0 0 0-63.778 108.945c0 71.765 60.484 129.536 132.676 124.066 59.964-4.557 108.484-53.274 113.314-113.818 2.034-24.457-3.193-48.973-15.027-70.473s-29.747-39.033-51.499-50.401l90.923-56.687 147.951 60.297a124.7 124.7 0 0 0-27.349 86.383c3.84 61.474 52.693 111.437 113.51 116.036z",
    glyphName: "crown_12",
    unicode: "\\uEA68"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M170.667 122.355c0 14.906 12.689 27.002 28.33 27.002h626.008c15.642 0 28.326-12.096 28.326-27.002V76.973c0-30.72-26.118-55.616-58.368-55.616H229.035c-32.239 0-58.368 24.89-58.368 55.616zm720.706 723.31C963.533 851.109 1024 793.364 1024 721.616c0-55.688-36.41-102.946-86.445-118.776l-89.222-383.768c-1.862-15.443-14.848-27.053-30.259-27.053H207.309c-15.386 0-28.339 11.558-30.251 26.97L86.861 602.704C36.608 618.405 0 665.765 0 721.599c0 71.766 60.467 129.528 132.642 124.083 59.836-4.522 108.271-52.992 113.315-113.365a124.75 124.75 0 0 0-29.628-92.015l140.715-57.344 93.611 58.359a124.69 124.69 0 0 0-63.779 108.945c0 71.765 60.484 129.536 132.676 124.066 59.964-4.557 108.484-53.274 113.314-113.818a124.72 124.72 0 0 0-66.526-120.875l90.92-56.687 147.955 60.297a124.7 124.7 0 0 0-27.354 86.383c3.84 61.474 52.698 111.437 113.51 116.036z",
    glyphName: "crown_16",
    unicode: "\\uEA69"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M170.667 122.334c0 14.905 12.689 26.999 28.331 26.999h626.005c15.644 0 28.331-12.095 28.331-26.999v-45.38c0-30.72-26.123-55.62-58.368-55.62H229.035c-32.239 0-58.368 24.889-58.368 55.62zm720.708 723.31C963.533 851.088 1024 793.343 1024 721.595c0-55.689-36.409-102.946-86.443-118.775l-89.225-383.769C846.472 203.606 833.484 192 818.073 192H207.308c-15.386 0-28.339 11.554-30.251 26.965L86.86 602.683C36.607 618.384-.001 665.744-.001 721.578c0 71.765 60.467 129.527 132.642 124.083 59.836-4.523 108.271-52.992 113.314-113.365a124.75 124.75 0 0 0-29.628-92.015l140.715-57.344 93.611 58.359a124.69 124.69 0 0 0-63.779 108.945c0 71.765 60.484 129.536 132.676 124.066 59.964-4.557 108.484-53.274 113.314-113.818a124.7 124.7 0 0 0-15.024-70.474 124.8 124.8 0 0 0-51.502-50.401l90.92-56.687 147.957 60.297a124.7 124.7 0 0 0-27.352 86.383c3.84 61.474 52.69 111.437 113.51 116.036z",
    glyphName: "crown_18",
    unicode: "\\uEA6A"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M199.111 142.362c0 13.666 11.631 24.751 25.969 24.751h573.84c14.336 0 25.967-11.085 25.967-24.751v-41.6c0-28.16-23.94-50.982-53.504-50.982H252.615c-29.553 0-53.504 22.814-53.504 50.982zm660.648 663.034c66.146 4.991 121.574-47.942 121.574-113.711 0-51.048-33.378-94.368-79.241-108.878l-81.788-351.788c-1.707-14.157-13.611-24.798-27.738-24.798H232.698c-14.103 0-25.978 10.594-27.73 24.721l-82.681 351.74c-46.065 14.393-79.622 57.806-79.622 108.987 0 65.785 55.428 118.734 121.588 113.743 54.85-4.146 99.249-48.576 103.872-103.918a114.354 114.354 0 0 0-27.159-84.347l128.989-52.565 85.809 53.496a114.3 114.3 0 0 0-58.463 99.867c0 65.785 55.446 118.741 121.622 113.727 54.963-4.177 99.443-48.834 103.868-104.333a114.335 114.335 0 0 0-60.979-110.802l83.345-51.963 135.62 55.272a114.34 114.34 0 0 0-25.071 79.185c3.52 56.351 48.303 102.15 104.051 106.366z",
    glyphName: "crown_24",
    unicode: "\\uEA6B"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M184.889 111.014c0 14.287 12.16 25.873 27.15 25.873h599.923c14.989 0 27.149-11.586 27.149-25.873v-43.49c0-29.44-25.03-53.303-55.936-53.303H240.826c-30.896 0-55.937 23.855-55.937 53.303zm690.678 693.173c69.152 5.217 127.1-50.122 127.1-118.881 0-53.367-34.895-98.656-82.842-113.826l-85.506-367.778c-1.783-14.803-14.229-25.924-28.998-25.924H220.005c-14.745 0-27.158 11.072-28.99 25.841L104.576 571.35c-48.159 15.046-83.242 60.433-83.242 113.941 0 68.775 57.948 124.13 127.115 118.913 57.343-4.334 103.76-50.784 108.592-108.643a119.532 119.532 0 0 0-28.393-88.18L363.5 552.426l89.709 55.927a119.5 119.5 0 0 0-61.12 104.405c0 68.775 57.965 124.138 127.149 118.897 57.463-4.367 103.964-51.054 108.591-109.075a119.52 119.52 0 0 0-63.753-115.838l87.134-54.325L792.996 610.2a119.53 119.53 0 0 0-26.21 82.784c3.68 58.913 50.498 106.793 108.781 111.201z",
    glyphName: "crown_48",
    unicode: "\\uEA6C"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M85.333 106.667v170.667h85.333v-128h682.667v128h85.333V106.667C938.666 83.106 919.56 64 895.999 64h-768c-23.564 0-42.667 19.106-42.667 42.667zM542.167 289.83c-16.663-16.663-43.678-16.663-60.34 0L247.16 524.497l60.34 60.339 161.83-161.83v451.66h85.333v-451.66l161.83 161.83 60.34-60.339z",
    glyphName: "download_12",
    unicode: "\\uEA6D"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M128 128v192h64V160h640v160h64V128c0-17.67-14.33-32-32-32H160c-17.673 0-32 14.33-32 32m406.625 201.373c-12.497-12.496-32.758-12.496-45.255 0L288 530.745 333.255 576l146.742-146.745V832h64V429.255L690.745 576l45.254-45.255-201.375-201.372z",
    glyphName: "download_16",
    unicode: "\\uEA6E"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M91.028 106.661v170.667h73.956V143.639h694.044v133.689h73.956V106.661c0-20.423-16.555-36.978-36.978-36.978h-768c-20.423 0-36.978 16.555-36.978 36.978m447.111 181.47c-14.441-14.438-37.854-14.438-52.295 0L251.177 522.798l52.295 52.294L475.014 403.55v465.394h73.956V403.55l171.54 171.542 52.298-52.295z",
    glyphName: "download_18",
    unicode: "\\uEA6F"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M100.271 106.662v170.667h55.467V134.396h712.533v142.933h55.467V106.662c0-15.317-12.416-27.733-27.733-27.733h-768c-15.317 0-27.733 12.416-27.733 27.733zm431.356 178.791c-10.833-10.833-28.39-10.833-39.223 0L257.738 520.12l39.221 39.22L484.28 372.015v487.714h55.467V372.015L727.071 559.34l39.223-39.22z",
    glyphName: "download_24",
    unicode: "\\uEA70"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M101.333 106.667v192h53.333V133.334h714.667v165.333h53.333v-192c0-14.729-11.938-26.667-26.667-26.667h-768c-14.728 0-26.667 11.938-26.667 26.667zm429.521 178.476c-10.415-10.413-27.298-10.413-37.713 0L258.474 519.81l37.713 37.713L485.33 368.38v490.287h53.333V368.38l189.143 189.143 37.713-37.713-234.667-234.667z",
    glyphName: "download_48",
    unicode: "\\uEA71"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M722.7 768.216c2.907 11.418 12.185 21.117 23.967 21.117h192c23.561 0 42.667-19.103 42.667-42.667V149.333c0-23.564-19.106-42.667-42.667-42.667h-192c-11.782 0-21.059 9.7-23.967 21.117-9.398 36.914-42.86 64.216-82.7 64.216s-73.302-27.302-82.7-64.216c-2.907-11.418-12.185-21.117-23.967-21.117h-192v682.667h192c11.782 0 21.059-9.7 23.967-21.117C566.698 731.302 600.16 704 640 704s73.302 27.302 82.7 64.216M256 789.333H85.333c-23.564 0-42.667-19.103-42.667-42.667V149.333c0-23.564 19.103-42.667 42.667-42.667H256z",
    glyphName: "coupon_12",
    unicode: "\\uEA72"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M722.699 768.216c2.907 11.418 12.186 21.118 23.967 21.118h192c23.563 0 42.667-19.103 42.667-42.667V149.334c0-23.563-19.103-42.667-42.667-42.667h-192c-11.782 0-21.06 9.7-23.967 21.117C713.301 164.699 679.839 192 640 192s-73.302-27.301-82.701-64.216c-2.906-11.418-12.184-21.117-23.966-21.117H301.511v682.667h231.822c11.782 0 21.06-9.7 23.966-21.118C566.697 731.302 600.16 704 640 704s73.301 27.302 82.699 64.216m-495.143 21.117H85.334c-23.564 0-42.667-19.103-42.667-42.667V149.333c0-23.563 19.103-42.667 42.667-42.667h142.222z",
    glyphName: "coupon_18",
    unicode: "\\uEA73"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M722.701 768.216c2.906 11.418 12.186 21.117 23.966 21.117h192c23.565 0 42.667-19.103 42.667-42.667V149.333c0-23.565-19.102-42.667-42.667-42.667h-192c-11.78 0-21.06 9.698-23.966 21.116C713.302 164.697 679.838 192 640 192s-73.301-27.302-82.701-64.218c-2.906-11.418-12.186-21.116-23.966-21.116H311.466v682.667h221.867c11.78 0 21.06-9.699 23.966-21.117C566.698 731.302 600.162 704 640 704s73.301 27.302 82.701 64.216M256 789.333H85.333c-23.564 0-42.667-19.103-42.667-42.667V149.333c0-23.565 19.103-42.667 42.667-42.667H256z",
    glyphName: "coupon_24",
    unicode: "\\uEA74"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "m528.427 877.342 131.022-264.385c2.707-5.396 7.58-9.173 13.536-9.713l292.904-42.625c14.618-2.159 20.574-20.504 10.291-30.755L764.483 323.752c-4.332-4.317-5.955-10.252-5.414-16.187l49.81-290.823c2.708-14.566-12.994-25.899-26.529-18.884L520.307 134.905c-5.414 2.698-11.37 2.698-16.784 0L241.48-2.142c-13.536-7.014-28.695 4.318-26.529 18.884l49.81 290.823c1.083 5.935-1.083 11.87-5.414 16.187L48.196 529.864c-10.828 10.251-4.873 28.596 10.287 30.755l292.905 42.625c5.955 1.079 10.828 4.317 13.535 9.713l131.023 264.385c6.496 13.489 25.987 13.489 32.485 0z",
    glyphName: "star_12",
    unicode: "\\uEA75"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "m528.427 881.619 131.024-264.385c2.708-5.395 7.578-9.172 13.534-9.712l292.904-42.625c14.62-2.158 20.577-20.503 10.286-30.755L764.486 328.027c-4.335-4.312-5.956-10.251-5.416-16.185L808.882 21.02c2.702-14.569-12.993-25.902-26.533-18.887L520.307 139.184c-5.414 2.697-11.37 2.697-16.784 0L241.479 2.133c-13.535-7.014-28.695 4.318-26.529 18.887l49.81 290.822c1.083 5.934-1.083 11.873-5.414 16.185L48.195 534.142c-10.828 10.252-4.873 28.597 10.287 30.755l292.904 42.625c5.956 1.079 10.828 4.317 13.536 9.712l131.022 264.385c6.497 13.489 25.987 13.489 32.485 0z",
    glyphName: "star_18",
    unicode: "\\uEA76"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "m528.427 885.883 131.021-264.385c2.709-5.396 7.582-9.173 13.538-9.712l292.902-42.625c14.618-2.159 20.574-20.503 10.287-30.755L764.484 332.292c-4.335-4.314-5.956-10.249-5.414-16.188l49.809-290.82c2.705-14.571-12.996-25.899-26.53-18.884L520.307 143.445c-5.414 2.701-11.371 2.701-16.785 0L241.477 6.4c-13.535-7.014-28.695 4.314-26.529 18.884l49.81 290.82c1.082 5.939-1.083 11.874-5.414 16.188L48.193 538.406c-10.828 10.252-4.873 28.596 10.287 30.755l292.904 42.625c5.956 1.079 10.828 4.317 13.536 9.712l131.02 264.385c6.498 13.489 25.988 13.489 32.486 0z",
    glyphName: "star_24",
    unicode: "\\uEA77"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "m528.427 883.748 131.021-264.386c2.707-5.395 7.58-9.171 13.536-9.711l292.905-42.626c14.618-2.159 20.574-20.503 10.287-30.754L764.483 330.159c-4.331-4.318-5.954-10.253-5.414-16.188L808.88 23.149c2.707-14.569-12.994-25.901-26.53-18.886l-262.044 137.05c-5.414 2.697-11.369 2.697-16.783 0L241.479 4.263c-13.536-7.014-28.696 4.318-26.53 18.886l49.811 290.822c1.082 5.935-1.084 11.87-5.414 16.188L48.194 536.271c-10.828 10.251-4.873 28.595 10.287 30.754l292.903 42.626c5.956 1.079 10.829 4.316 13.536 9.711l131.023 264.386c6.496 13.489 25.986 13.489 32.484 0",
    glyphName: "star_48",
    unicode: "\\uEA78"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M128 768c0 11.782 9.551 21.333 21.333 21.333h206.991V562.162c0-63.05-51.113-114.162-114.162-114.162S128 499.112 128 562.162zm269.838 21.333h228.325V562.162c0-63.05-51.112-114.162-114.162-114.162s-114.162 51.112-114.162 114.162zM896 768c0 11.782-9.549 21.333-21.333 21.333H667.676V562.162c0-63.05 51.112-114.162 114.162-114.162S896 499.112 896 562.162zM781.821 409.155c9.883 0 19.531 1.01 28.845 2.934V138.226c0-23.565-19.103-42.669-42.667-42.669h-512c-23.564 0-42.667 19.104-42.667 42.669v273.856a142.5 142.5 0 0 1 28.812-2.927c62.983 0 116.381 41.034 134.919 97.826 18.539-56.792 71.937-97.826 134.919-97.826s116.381 41.034 134.92 97.826c18.538-56.792 71.936-97.826 134.919-97.826",
    glyphName: "store_12",
    unicode: "\\uEA79"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M113.778 787.099c0 12.219 9.905 22.124 22.124 22.124h214.657V573.638c0-65.385-53.005-118.39-118.39-118.39s-118.39 53.005-118.39 118.39v213.461zm279.832 22.123h236.782V573.637c0-65.385-53.009-118.39-118.391-118.39-65.385 0-118.39 53.005-118.39 118.39v235.585zm516.612-22.123c0 12.219-9.904 22.124-22.124 22.124H673.439V573.638c0-65.385 53.009-118.39 118.391-118.39 65.388 0 118.391 53.005 118.391 118.39v213.461zM791.814 414.963c10.251 0 20.258 1.048 29.912 3.042V134.001c0-24.439-19.809-44.248-44.242-44.248H246.519c-24.437 0-44.246 19.809-44.246 44.248v283.996a147.8 147.8 0 0 1 29.879-3.035c65.315 0 120.691 42.553 139.916 101.449 19.224-58.895 74.601-101.449 139.916-101.449s120.69 42.553 139.918 101.449c19.223-58.896 74.598-101.449 139.913-101.449z",
    glyphName: "store_18",
    unicode: "\\uEA7A"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M128 768c0 11.782 9.551 21.333 21.333 21.333h206.991V562.162C356.324 499.11 305.212 448 242.162 448S128 499.11 128 562.162zm269.838 21.333h228.326V562.162C626.164 499.11 575.049 448 512.001 448s-114.162 51.11-114.162 114.162zM896 768c0 11.782-9.553 21.333-21.333 21.333H667.674V562.162C667.674 499.11 718.789 448 781.837 448 844.89 448 896 499.11 896 562.162zM781.82 409.156c9.886 0 19.533 1.007 28.847 2.931v-273.86c0-23.565-19.102-42.667-42.667-42.667H256c-23.564 0-42.667 19.102-42.667 42.667v273.856a142.4 142.4 0 0 1 28.812-2.927c62.982 0 116.381 41.033 134.919 97.826 18.538-56.794 71.938-97.826 134.918-97.826 62.985 0 116.382 41.033 134.921 97.826 18.539-56.794 71.936-97.826 134.916-97.826z",
    glyphName: "store_24",
    unicode: "\\uEA7B"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M106.667 788.148c0 12.437 10.082 22.519 22.519 22.519h218.49V570.876c0-66.554-53.952-120.506-120.506-120.506-66.552 0-120.503 53.952-120.503 120.506zm284.83 22.519h241.007V570.876c0-66.554-53.95-120.506-120.503-120.506s-120.503 53.952-120.503 120.506v239.791zm525.836-22.519c0 12.437-10.082 22.519-22.519 22.519h-218.49V570.876c0-66.554 53.952-120.506 120.503-120.506 66.554 0 120.506 53.952 120.506 120.506zM796.811 409.367c10.434 0 20.617 1.067 30.449 3.095V123.385c0-24.873-20.164-45.037-45.037-45.037H241.777c-24.873 0-45.036 20.164-45.036 45.037v289.071a150.3 150.3 0 0 1 30.412-3.089c66.481 0 122.846 43.313 142.415 103.26 19.569-59.947 75.934-103.26 142.415-103.26s122.846 43.313 142.415 103.26c19.567-59.947 75.932-103.26 142.413-103.26",
    glyphName: "store_48",
    unicode: "\\uEA7C"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M128 832c-23.564 0-42.667-19.103-42.667-42.667v-256c0-63.171 34.321-118.326 85.333-147.835V106.666c0-23.561 19.103-42.667 42.667-42.667h597.333c23.564 0 42.667 19.106 42.667 42.667v278.832c51.012 29.509 85.333 84.664 85.333 147.835v256c0 23.564-19.106 42.667-42.667 42.667h-768zm640-469.333V149.334H256v213.333c50.974 0 96.728 22.347 128 57.778 31.272-35.431 77.026-57.778 128-57.778s96.728 22.347 128 57.778c31.272-35.431 77.026-57.778 128-57.778M768 448c-47.128 0-85.333 38.205-85.333 85.333v213.333h170.667V533.333c0-47.128-38.205-85.333-85.333-85.333zM426.667 746.667h170.667V533.334c0-47.128-38.205-85.333-85.333-85.333s-85.333 38.205-85.333 85.333v213.333zm-85.334 0V533.334c0-47.128-38.205-85.333-85.333-85.333s-85.333 38.205-85.333 85.333v213.333z",
    glyphName: "store_outline_12",
    unicode: "\\uEA7D"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M113.783 883.222c-20.423 0-36.978-16.555-36.978-36.978V580.762c0-63.015 34.343-118.009 85.333-147.286V49.777c0-20.423 16.555-36.978 36.978-36.978h625.778c20.423 0 36.978 16.555 36.978 36.978v383.699c50.99 29.277 85.333 84.271 85.333 147.286v265.482c0 20.423-16.555 36.978-36.978 36.978zM787.917 411.36V86.756H236.095V411.36q5.175-.314 10.429-.315c53.738 0 101.643 24.976 132.741 63.953 31.097-38.977 79.003-63.953 132.741-63.953s101.643 24.976 132.739 63.953c31.101-38.977 79.002-63.953 132.745-63.953 3.499 0 6.98.106 10.428.315zm-180.15 397.907V580.763c0-52.888-42.873-95.763-95.761-95.763s-95.763 42.874-95.763 95.763v228.504zm73.955-228.504v228.504H873.25V580.763c0-52.888-42.877-95.763-95.761-95.763-52.89 0-95.767 42.874-95.767 95.763M342.287 809.267V580.763c0-52.888-42.874-95.763-95.763-95.763s-95.763 42.874-95.763 95.763v228.504z",
    glyphName: "store_outline_18",
    unicode: "\\uEA7E"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M128.004 817.083c-15.317 0-27.733-12.416-27.733-27.733v-256c0-60.676 34.698-113.245 85.333-138.952V106.667c0-15.317 12.416-27.733 27.733-27.733H810.67c15.317 0 27.733 12.416 27.733 27.733v287.731c50.637 25.707 85.333 78.276 85.333 138.952v256c0 15.317-12.416 27.733-27.733 27.733h-768zm654.934-438.758V134.4H241.071v243.925c4.915-.469 9.896-.708 14.933-.708 53.035 0 99.878 26.509 128 67.004 28.122-40.495 74.965-67.004 128-67.004s99.878 26.509 128 67.004c28.122-40.495 74.965-67.004 128-67.004 5.039 0 10.018.239 14.933.708zm-14.934 54.759c-55.377 0-100.267 44.89-100.267 100.266v228.267H868.27V533.35c0-55.377-44.89-100.266-100.267-100.266zM411.738 761.617h200.533V533.35c0-55.377-44.89-100.266-100.267-100.266s-100.267 44.89-100.267 100.266v228.267zm-55.467 0V533.35c0-55.377-44.891-100.266-100.267-100.266s-100.267 44.89-100.267 100.266v228.267H356.27z",
    glyphName: "store_outline_24",
    unicode: "\\uEA7F"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M128 816c-14.728 0-26.667-11.939-26.667-26.667v-256c0-60.493 34.727-112.873 85.333-138.293V106.667c0-14.729 11.939-26.667 26.667-26.667h597.333c14.729 0 26.667 11.938 26.667 26.667V395.04c50.607 25.421 85.333 77.801 85.333 138.293v256c0 14.728-11.938 26.667-26.667 26.667h-768zm656-436.516v-246.15H240v246.15c5.259-.54 10.598-.817 16-.817 53.227 0 100.173 26.886 128 67.819 27.827-40.932 74.773-67.819 128-67.819s100.173 26.886 128 67.819c27.827-40.932 74.773-67.819 128-67.819 5.402 0 10.741.277 16 .817M768 432c-55.966 0-101.333 45.367-101.333 101.333v229.333h202.667V533.333c0-55.966-45.367-101.333-101.333-101.333zM410.667 762.667h202.667V533.334c0-55.966-45.367-101.333-101.333-101.333s-101.333 45.367-101.333 101.333v229.333zm-53.334 0V533.334c0-55.966-45.367-101.333-101.333-101.333s-101.333 45.367-101.333 101.333v229.333z",
    glyphName: "store_outline_48",
    unicode: "\\uEA80"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M128 490.667h768v-85.333H128z",
    glyphName: "subtract_12",
    unicode: "\\uEA81"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M128 485h768v-73.956H128z",
    glyphName: "subtract_18",
    unicode: "\\uEA82"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M128 475.75h768v-55.467H128z",
    glyphName: "subtract_24",
    unicode: "\\uEA83"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M128 474.667h768v-53.333H128z",
    glyphName: "subtract_48",
    unicode: "\\uEA84"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M128 512h768V384H128z",
    glyphName: "subtract_thick_12",
    unicode: "\\uEA85"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M128 504.889h768V391.111H128z",
    glyphName: "subtract_thick_18",
    unicode: "\\uEA86"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M128 490.667h768v-85.333H128z",
    glyphName: "subtract_thick_24",
    unicode: "\\uEA87"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M128 480h768v-64H128z",
    glyphName: "subtract_thick_48",
    unicode: "\\uEA88"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M85.333 832V465.673a42.66 42.66 0 0 1 12.497-30.17l384-383.996c16.662-16.666 43.677-16.666 60.339 0L908.492 417.83c16.666 16.662 16.666 43.677 0 60.339l-383.996 384a42.67 42.67 0 0 1-30.17 12.497H127.999c-23.564 0-42.667-19.103-42.667-42.667zm149.334-170.667c-35.346 0-64 28.654-64 64s28.654 64 64 64 64-28.654 64-64-28.654-64-64-64",
    glyphName: "tag_12",
    unicode: "\\uEA89"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M85.333 832V465.673a42.67 42.67 0 0 1 12.497-30.17l384-384.002c16.662-16.663 43.678-16.663 60.34 0L908.499 417.83c16.663 16.662 16.663 43.678 0 60.34l-384.002 384a42.67 42.67 0 0 1-30.17 12.497H128c-23.564 0-42.667-19.103-42.667-42.667m149.334-170.667c-35.346 0-64 28.654-64 64s28.654 64 64 64 64-28.654 64-64-28.654-64-64-64",
    glyphName: "tag_18",
    unicode: "\\uEA8A"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M85.333 832c0 23.564 19.103 42.667 42.667 42.667h366.327a42.66 42.66 0 0 0 30.17-12.497l384-384c16.661-16.661 16.661-43.678 0-60.339L542.17 51.504c-16.661-16.661-43.678-16.661-60.339 0l-384 384a42.67 42.67 0 0 0-12.497 30.17v366.327zm149.334-170.667c35.346 0 64 28.654 64 64s-28.654 64-64 64-64-28.654-64-64 28.654-64 64-64",
    glyphName: "tag_24",
    unicode: "\\uEA8B"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M85.333 832V465.673a42.67 42.67 0 0 1 12.497-30.17l384-384c16.661-16.661 43.678-16.661 60.339 0L908.496 417.83c16.661 16.661 16.661 43.678 0 60.339l-384 384a42.67 42.67 0 0 1-30.17 12.497H127.999c-23.564 0-42.667-19.103-42.667-42.667zm149.334-170.667c-35.346 0-64 28.653-64 64s28.654 64 64 64 64-28.654 64-64-28.653-64-64-64",
    glyphName: "tag_48",
    unicode: "\\uEA8C"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M149.333 832c0 35.346 28.654 64 64 64h320c141.385 0 256-114.615 256-256s-114.615-256-256-256h-320c-35.346 0-64 28.654-64 64zm128-64V512h256c70.693 0 128 57.307 128 128s-57.307 128-128 128zm-128-320c0 35.346 28.654 64 64 64h405.333c141.385 0 256-114.615 256-256S760.051 0 618.666 0H213.333c-35.346 0-64 28.655-64 64zm128-64V128h341.333c70.693 0 128 57.307 128 128s-57.307 128-128 128z",
    glyphName: "text_bold_12",
    unicode: "\\uEA8D"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M142.222 832c0 39.274 31.837 71.111 71.111 71.111h320c145.311 0 263.111-117.799 263.111-263.111s-117.8-263.111-263.111-263.111h-320c-39.274 0-71.111 31.837-71.111 71.111zm142.222-71.111V519.111h248.889c66.765 0 120.889 54.124 120.889 120.889s-54.124 120.889-120.889 120.889zM142.222 448c0 39.274 31.837 71.111 71.111 71.111h405.333c145.311 0 263.111-117.799 263.111-263.111S763.977-7.111 618.666-7.111H213.333c-39.274 0-71.111 31.835-71.111 71.111zm142.222-71.111V135.111h334.222c66.765 0 120.889 54.124 120.889 120.889s-54.124 120.889-120.889 120.889z",
    glyphName: "text_bold_18",
    unicode: "\\uEA8E"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M160 832c0 29.455 23.878 53.333 53.333 53.333h320c135.492 0 245.333-109.839 245.333-245.333 0-135.492-109.841-245.333-245.333-245.333h-320C183.878 394.667 160 418.543 160 448zm106.667-53.333V501.334h266.667c76.582 0 138.667 62.083 138.667 138.667s-62.084 138.667-138.667 138.667zM160 448c0 29.457 23.878 53.333 53.333 53.333h405.333c135.492 0 245.333-109.841 245.333-245.333S754.158 10.667 618.666 10.667H213.333C183.878 10.667 160 34.543 160 64zm106.667-53.333V117.334h352c76.582 0 138.667 62.084 138.667 138.667S695.25 394.668 618.667 394.668h-352z",
    glyphName: "text_bold_24",
    unicode: "\\uEA8F"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M160 832c0 29.455 23.878 53.333 53.333 53.333h320c135.494 0 245.333-109.84 245.333-245.333S668.827 394.667 533.333 394.667h-320C183.878 394.667 160 418.545 160 448zm106.667-53.333V501.334h266.667c76.585 0 138.667 62.082 138.667 138.667s-62.082 138.667-138.667 138.667zM160 448c0 29.455 23.878 53.333 53.333 53.333h405.333c135.494 0 245.333-109.839 245.333-245.333S754.16 10.667 618.666 10.667H213.333C183.878 10.667 160 34.545 160 64zm106.667-53.333V117.334h352c76.585 0 138.667 62.082 138.667 138.667S695.25 394.668 618.667 394.668h-352z",
    glyphName: "text_bold_48",
    unicode: "\\uEA90"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "m344.385 165.18 256 640 79.23-31.693-256-639.999zm252.948-58.513H170.666V192h426.667zm256 640H426.666V832h426.667z",
    glyphName: "text_italic_12",
    unicode: "\\uEA91"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "m349.667 163.089 256.001 639.999 68.665-27.466-255.999-639.999zm247.666-50.711H170.666v73.956h426.667zm256 640H426.666v73.956h426.667z",
    glyphName: "text_italic_18",
    unicode: "\\uEA92"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "m358.251 159.65 256 640 51.499-20.599-255.999-640zm239.082-38.033H170.666v55.467h426.667zm256 640H426.666v55.467h426.667z",
    glyphName: "text_italic_24",
    unicode: "\\uEA93"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "m359.241 159.236 256 640.001 49.519-19.808-256-639.999zm238.092-36.569H170.666V176h426.667zm256 640H426.666V816h426.667z",
    glyphName: "text_italic_48",
    unicode: "\\uEA94"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M298.667 832V448c0-117.821 95.513-213.333 213.333-213.333S725.333 330.18 725.333 448v384h85.333V448c0-164.949-133.717-298.667-298.667-298.667S213.332 283.05 213.332 448v384h85.333zM768 21.333H256v85.333h512z",
    glyphName: "text_underline_12",
    unicode: "\\uEA95"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M292.983 832V448c0-120.963 98.059-219.022 219.022-219.022S731.027 327.037 731.027 448v384h73.956V448c0-161.809-131.169-292.978-292.978-292.978-161.807 0-292.978 131.169-292.978 292.978v384zM768.006 27.022h-512v73.956h512z",
    glyphName: "text_underline_18",
    unicode: "\\uEA96"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M283.738 832V448c0-126.067 102.198-228.267 228.267-228.267 126.067 0 228.267 102.199 228.267 228.267v384h55.467V448c0-156.702-127.031-283.733-283.733-283.733S228.273 291.298 228.273 448v384h55.467zM768.004 36.267h-512v55.467h512z",
    glyphName: "text_underline_24",
    unicode: "\\uEA97"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M282.667 832V448c0-126.658 102.675-229.333 229.333-229.333S741.333 321.342 741.333 448v384h53.333V448c0-156.113-126.554-282.667-282.667-282.667S229.332 291.887 229.332 448v384h53.333zM768 37.333H256v53.333h512z",
    glyphName: "text_underline_48",
    unicode: "\\uEA98"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M156.444 820.611c-23.564 0-42.667-19.102-42.667-42.667V223.277c0-23.563 19.103-42.667 42.667-42.667h57.6c0-62.447 50.621-113.067 113.067-113.067s113.067 50.62 113.067 113.067h157.867c0-62.447 50.62-113.067 113.067-113.067s113.067 50.62 113.067 113.067h57.6c23.563 0 42.667 19.103 42.667 42.667v256L808.239 711.691a42.66 42.66 0 0 1-38.161 23.586H668.446v42.667c0 23.565-19.103 42.667-42.667 42.667H156.446zm605.719-140.8 72.533-145.066H681.244v145.066zm-435.052-441.6c31.812 0 57.6-25.788 57.6-57.6s-25.788-57.6-57.6-57.6-57.6 25.788-57.6 57.6 25.788 57.6 57.6 57.6m326.4-57.6c0 31.812 25.788 57.6 57.6 57.6s57.6-25.788 57.6-57.6-25.788-57.6-57.6-57.6-57.6 25.788-57.6 57.6",
    glyphName: "truck_18",
    unicode: "\\uEA99"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M170.667 789.333c-23.564 0-42.667-19.103-42.667-42.667V191.999c0-23.565 19.103-42.667 42.667-42.667h57.6c0-62.447 50.622-113.067 113.067-113.067s113.067 50.62 113.067 113.067h157.867c0-62.447 50.62-113.067 113.067-113.067s113.067 50.62 113.067 113.067h57.6c23.565 0 42.667 19.102 42.667 42.667v256L822.462 680.413a42.67 42.67 0 0 1-38.161 23.586H682.669v42.667c0 23.564-19.102 42.667-42.667 42.667H170.669zm605.721-140.8 72.533-145.067H695.466v145.067zm-435.055-441.6c31.811 0 57.6-25.788 57.6-57.6s-25.789-57.6-57.6-57.6-57.6 25.788-57.6 57.6 25.789 57.6 57.6 57.6m326.4-57.6c0 31.812 25.788 57.6 57.6 57.6s57.6-25.788 57.6-57.6-25.788-57.6-57.6-57.6-57.6 25.788-57.6 57.6",
    glyphName: "truck_24",
    unicode: "\\uEA9A"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M149.333 825.604c-23.564 0-42.667-19.103-42.667-42.667V228.27c0-23.565 19.103-42.667 42.667-42.667h57.6c0-62.445 50.622-113.067 113.067-113.067s113.067 50.622 113.067 113.067h157.867c0-62.445 50.622-113.067 113.067-113.067s113.067 50.622 113.067 113.067h57.6c23.565 0 42.667 19.102 42.667 42.667v256L801.128 716.684a42.67 42.67 0 0 1-38.163 23.586h-101.63v42.667c0 23.564-19.102 42.667-42.667 42.667H149.335zm605.72-140.8 72.533-145.067H674.133v145.067zM320 243.204c31.812 0 57.6-25.788 57.6-57.6s-25.788-57.6-57.6-57.6-57.6 25.788-57.6 57.6 25.788 57.6 57.6 57.6m326.4-57.6c0 31.812 25.788 57.6 57.6 57.6s57.6-25.788 57.6-57.6-25.788-57.6-57.6-57.6-57.6 25.788-57.6 57.6",
    glyphName: "truck_48",
    unicode: "\\uEA9B"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M170.672 826.333c-43.986 0-79.644-35.658-79.644-79.644V192.023c0-43.986 35.658-79.644 79.644-79.644h54.044c15.673-49.476 61.96-85.333 116.622-85.333s100.949 35.857 116.622 85.333h150.756c15.673-49.476 61.958-85.333 116.622-85.333 54.659 0 100.949 35.857 116.622 85.333h96.711c20.423 0 36.978 16.555 36.978 36.978v298.666a37 37 0 0 1-3.903 16.537L865.079 677.893a36.98 36.98 0 0 1-33.075 20.441h-69.689v48.356c0 43.986-35.658 79.644-79.644 79.644h-512zm671.289-639.999c-11.981 37.808-41.836 67.664-79.644 79.644v145.066h139.378V186.333h-59.733zm-153.6 79.644c-37.808-11.981-67.669-41.836-79.644-79.644H457.961c-15.673 49.476-61.96 85.333-116.622 85.333S240.39 235.81 224.717 186.334h-54.044a5.69 5.69 0 0 0-5.689 5.689v554.666a5.69 5.69 0 0 0 5.689 5.689h512a5.69 5.69 0 0 0 5.689-5.689zm73.956 358.4h46.837L878.843 485H762.317zM341.339 197.712c26.706 0 48.356-21.652 48.356-48.356 0-26.709-21.65-48.356-48.356-48.356s-48.356 21.646-48.356 48.356c0 26.704 21.65 48.356 48.356 48.356m335.644-48.356c0 26.704 21.652 48.356 48.356 48.356s48.356-21.652 48.356-48.356c0-26.709-21.652-48.356-48.356-48.356s-48.356 21.646-48.356 48.356",
    glyphName: "truck_outline_18",
    unicode: "\\uEA9C"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M170.671 817.083c-38.881 0-70.4-31.519-70.4-70.4V192.017c0-38.882 31.519-70.4 70.4-70.4h61.026c12.365-49.037 56.764-85.333 109.641-85.333s97.276 36.297 109.641 85.333h164.719c12.365-49.037 56.764-85.333 109.641-85.333s97.276 36.297 109.641 85.333h103.693c15.317 0 27.733 12.416 27.733 27.733v298.667c0 4.305-1.003 8.55-2.927 12.403L856.812 673.752a27.74 27.74 0 0 1-24.806 15.331h-78.933v57.6c0 38.881-31.518 70.4-70.4 70.4h-512zm664.307-639.999c-10.129 40.162-41.745 71.778-81.907 81.907v161.293h157.867v-243.2h-75.959zm-137.374 81.907c-40.162-10.129-71.778-41.745-81.907-81.907H450.978c-12.365 49.037-56.764 85.333-109.641 85.333s-97.275-36.297-109.641-85.333H170.67c-8.247 0-14.933 6.686-14.933 14.933v554.666c0 8.247 6.686 14.933 14.933 14.933h512c8.247 0 14.933-6.686 14.933-14.933V258.991zm55.467 374.626h61.794l78.933-157.866H753.071zM341.338 206.95c31.811 0 57.6-25.788 57.6-57.6s-25.789-57.6-57.6-57.6c-31.812 0-57.6 25.788-57.6 57.6s25.788 57.6 57.6 57.6m326.4-57.6c0 31.812 25.788 57.6 57.6 57.6s57.6-25.788 57.6-57.6-25.788-57.6-57.6-57.6-57.6 25.788-57.6 57.6",
    glyphName: "truck_outline_24",
    unicode: "\\uEA9D"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M170.667 816c-38.292 0-69.333-31.041-69.333-69.333V192c0-38.291 31.042-69.333 69.333-69.333h61.86c11.964-48.981 56.141-85.333 108.806-85.333s96.843 36.352 108.806 85.333h166.387c11.964-48.981 56.141-85.333 108.806-85.333s96.843 36.352 108.806 85.333h104.527c14.729 0 26.667 11.938 26.667 26.667v298.667c0 4.141-.964 8.222-2.816 11.925L855.849 673.259A26.66 26.66 0 0 1 831.998 688h-80v58.667c0 38.292-31.042 69.333-69.333 69.333h-512zM834.14 176c-9.877 40.435-41.705 72.262-82.14 82.14v163.194h160V176.001zm-135.473 82.14c-40.435-9.877-72.262-41.705-82.14-82.14H450.14c-11.964 48.981-56.141 85.333-108.806 85.333S244.491 224.981 232.528 176h-61.86c-8.836 0-16 7.164-16 16v554.667c0 8.836 7.164 16 16 16h512c8.836 0 16-7.164 16-16V258.14zM752 634.667h63.52l80-160H752zM341.333 208C373.734 208 400 181.734 400 149.333s-26.266-58.667-58.667-58.667-58.667 26.266-58.667 58.667S308.932 208 341.333 208m325.334-58.667c0 32.401 26.266 58.667 58.667 58.667s58.667-26.266 58.667-58.667-26.266-58.667-58.667-58.667-58.667 26.266-58.667 58.667",
    glyphName: "truck_outline_48",
    unicode: "\\uEA9E"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "m97.83 606.167 256 256 60.339-60.34-225.83-225.83 225.83-225.83-60.339-60.34-256 256c-16.663 16.662-16.663 43.677 0 60.34m584.837-72.837H128v85.333h554.667c141.385 0 256-114.615 256-256s-114.615-255.997-256-255.997H512v85.33h170.667c94.257 0 170.667 76.41 170.667 170.667S776.924 533.33 682.667 533.33",
    glyphName: "undo_12",
    unicode: "\\uEA9F"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "m101.858 602.167 256 256 52.295-52.295L180.3 576.019l229.853-229.85-52.295-52.298-256 256.001c-14.441 14.441-14.441 37.854 0 52.295m580.814-63.125H128.005v73.956h554.667c138.24 0 250.311-112.068 250.311-250.313 0-138.24-112.071-250.311-250.311-250.311H512.005v73.956h170.667c97.399 0 176.356 78.962 176.356 176.356 0 97.401-78.956 176.358-176.356 176.358z",
    glyphName: "undo_18",
    unicode: "\\uEAA0"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "m108.394 595.625 256 256 39.221-39.221-236.39-236.39 236.39-236.388-39.221-39.223-256 256.001c-10.831 10.831-10.831 28.39 0 39.221m574.277-47.344H128.004v55.467h554.667c133.137 0 241.067-107.927 241.067-241.068 0-133.137-107.93-241.067-241.067-241.067H512.004v55.467h170.667c102.502 0 185.6 83.098 185.6 185.6 0 102.507-83.098 185.602-185.6 185.602z",
    glyphName: "undo_24",
    unicode: "\\uEAA1"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "m109.144 594.854 256 256 37.713-37.712-237.144-237.144 237.144-237.143-37.713-37.713-256 256c-10.414 10.415-10.414 27.298 0 37.713zm573.523-45.523H128v53.333h554.667c132.548 0 240-107.452 240-240s-107.452-240-240-240H512v53.333h170.667c103.093 0 186.667 83.573 186.667 186.667s-83.573 186.667-186.667 186.667",
    glyphName: "undo_48",
    unicode: "\\uEAA2"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M512 448c117.821 0 213.333 95.513 213.333 213.333S629.82 874.666 512 874.666c-117.821 0-213.333-95.513-213.333-213.333S394.18 448 512 448m-128-64c-106.039 0-192-85.961-192-192V0h640v192c0 106.039-85.961 192-192 192z",
    glyphName: "user_12",
    unicode: "\\uEAA3"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M512 448c117.823 0 213.333 95.512 213.333 213.333S629.822 874.666 512 874.666c-117.821 0-213.333-95.512-213.333-213.333S394.179 448 512 448m-128-64c-106.039 0-192-85.959-192-192V0h640v192c0 106.041-85.959 192-192 192z",
    glyphName: "user_18",
    unicode: "\\uEAA4"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M512 448c117.82 0 213.333 95.513 213.333 213.333S629.819 874.666 512 874.666c-117.821 0-213.333-95.513-213.333-213.333S394.18 448 512 448m-128-64c-106.039 0-192-85.961-192-192V0h640v192c0 106.039-85.961 192-192 192z",
    glyphName: "user_24",
    unicode: "\\uEAA5"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M512 448c117.82 0 213.333 95.514 213.333 213.333 0 117.821-95.514 213.333-213.333 213.333s-213.333-95.513-213.333-213.333S394.181 448 512 448m-128-64c-106.039 0-192-85.961-192-192V0h640v192c0 106.039-85.961 192-192 192z",
    glyphName: "user_48",
    unicode: "\\uEAA6"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M512 533.333c-70.693 0-128 57.307-128 128s57.307 128 128 128 128-57.307 128-128-57.307-128-128-128M512 448c117.821 0 213.333 95.513 213.333 213.333S629.82 874.666 512 874.666c-117.821 0-213.333-95.513-213.333-213.333S394.18 448 512 448M170.667 192c0 117.821 95.513 213.333 213.333 213.333h256c117.821 0 213.333-95.513 213.333-213.333V21.333H768V192c0 70.693-57.307 128-128 128H384c-70.693 0-128-57.307-128-128V21.333h-85.333z",
    glyphName: "user_outline_12",
    unicode: "\\uEAA7"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M512.006 521.956c-76.976 0-139.378 62.401-139.378 139.378s62.401 139.378 139.378 139.378 139.378-62.401 139.378-139.378-62.401-139.378-139.378-139.378m0-73.956c117.823 0 213.333 95.512 213.333 213.333s-95.511 213.333-213.333 213.333c-117.821 0-213.333-95.512-213.333-213.333S394.185 448 512.006 448M176.361 192c0 114.677 92.966 207.644 207.644 207.644h256c114.677 0 207.644-92.968 207.644-207.644V21.333h-73.956V192c0 73.836-59.853 133.689-133.689 133.689h-256c-73.834 0-133.689-59.853-133.689-133.689V21.333h-73.956V192z",
    glyphName: "user_outline_18",
    unicode: "\\uEAA8"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M512.004 503.467c-87.188 0-157.867 70.679-157.867 157.867s70.679 157.867 157.867 157.867c87.189 0 157.867-70.679 157.867-157.867s-70.677-157.867-157.867-157.867m0-55.467c117.82 0 213.333 95.513 213.333 213.333s-95.514 213.333-213.333 213.333c-117.821 0-213.333-95.513-213.333-213.333S394.183 448 512.004 448m-326.4-256c0 109.572 88.826 198.4 198.4 198.4h256c109.572 0 198.4-88.828 198.4-198.4V21.333h-55.467V192c0 78.942-63.991 142.933-142.933 142.933h-256c-78.94 0-142.933-63.991-142.933-142.933V21.333h-55.467z",
    glyphName: "user_outline_24",
    unicode: "\\uEAA9"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M512 501.333c-88.365 0-160 71.635-160 160s71.635 160 160 160 160-71.634 160-160-71.635-160-160-160M512 448c117.82 0 213.333 95.514 213.333 213.333 0 117.821-95.514 213.333-213.333 213.333s-213.333-95.513-213.333-213.333S394.181 448 512 448M186.667 192c0 108.983 88.35 197.333 197.333 197.333h256c108.983 0 197.333-88.35 197.333-197.333V21.333H784V192c0 79.529-64.471 144-144 144H384c-79.529 0-144-64.471-144-144V21.333h-53.333z",
    glyphName: "user_outline_48",
    unicode: "\\uEAAA"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M128 789.333C128 812.897 147.103 832 170.667 832h682.667c23.561 0 42.667-19.103 42.667-42.667v-256c0-23.564-19.106-42.667-42.667-42.667H170.667c-23.564 0-42.667 19.103-42.667 42.667zm0-426.666c0 23.564 19.103 42.667 42.667 42.667h682.667c23.561 0 42.667-19.103 42.667-42.667v-256c0-23.561-19.106-42.667-42.667-42.667H170.667C147.103 64 128 83.106 128 106.667z",
    glyphName: "view_list_12",
    unicode: "\\uEAAB"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M128 789.333C128 812.897 147.103 832 170.667 832h682.667c23.563 0 42.667-19.103 42.667-42.667v-256c0-23.564-19.103-42.667-42.667-42.667H170.667c-23.564 0-42.667 19.103-42.667 42.667zm0-426.666c0 23.563 19.103 42.667 42.667 42.667h682.667c23.563 0 42.667-19.103 42.667-42.667v-256c0-23.563-19.103-42.667-42.667-42.667H170.667C147.103 64 128 83.103 128 106.667z",
    glyphName: "view_list_18",
    unicode: "\\uEAAC"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M128 789.333C128 812.897 147.103 832 170.667 832h682.667c23.565 0 42.667-19.103 42.667-42.667v-256c0-23.565-19.102-42.667-42.667-42.667H170.667c-23.564 0-42.667 19.102-42.667 42.667zm0-426.666c0 23.565 19.103 42.667 42.667 42.667h682.667c23.565 0 42.667-19.102 42.667-42.667v-256c0-23.565-19.102-42.667-42.667-42.667H170.667C147.103 64 128 83.102 128 106.667z",
    glyphName: "view_list_24",
    unicode: "\\uEAAD"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M128 789.333C128 812.897 147.103 832 170.667 832h682.667c23.565 0 42.667-19.103 42.667-42.667v-256c0-23.565-19.102-42.667-42.667-42.667H170.667c-23.564 0-42.667 19.102-42.667 42.667zm0-426.666c0 23.565 19.103 42.667 42.667 42.667h682.667c23.565 0 42.667-19.102 42.667-42.667v-256c0-23.565-19.102-42.667-42.667-42.667H170.667C147.103 64 128 83.102 128 106.667z",
    glyphName: "view_list_48",
    unicode: "\\uEAAE"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M128 789.333C128 812.897 147.103 832 170.667 832h256c23.564 0 42.667-19.103 42.667-42.667v-256c0-23.564-19.103-42.667-42.667-42.667h-256c-23.564 0-42.667 19.103-42.667 42.667zm0-426.666c0 23.564 19.103 42.667 42.667 42.667h256c23.564 0 42.667-19.103 42.667-42.667v-256c0-23.561-19.103-42.667-42.667-42.667h-256C147.103 64 128 83.106 128 106.667zm426.667 426.666c0 23.564 19.103 42.667 42.667 42.667h256c23.561 0 42.667-19.103 42.667-42.667v-256c0-23.564-19.106-42.667-42.667-42.667h-256c-23.564 0-42.667 19.103-42.667 42.667zm0-426.666c0 23.564 19.103 42.667 42.667 42.667h256c23.561 0 42.667-19.103 42.667-42.667v-256c0-23.561-19.106-42.667-42.667-42.667h-256c-23.564 0-42.667 19.106-42.667 42.667z",
    glyphName: "view_thumbnail_12",
    unicode: "\\uEAAF"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M128 789.333C128 812.897 147.103 832 170.667 832h256c23.564 0 42.667-19.103 42.667-42.667v-256c0-23.564-19.103-42.667-42.667-42.667h-256c-23.564 0-42.667 19.103-42.667 42.667zm0-426.672c0 23.563 19.103 42.667 42.667 42.667h256c23.564 0 42.667-19.104 42.667-42.667v-256c0-23.563-19.103-42.667-42.667-42.667h-256c-23.564 0-42.667 19.103-42.667 42.667zm426.666 426.672c0 23.564 19.104 42.667 42.667 42.667h256C876.896 832 896 812.897 896 789.333v-256c0-23.564-19.103-42.667-42.667-42.667h-256c-23.563 0-42.667 19.103-42.667 42.667zm0-426.672c0 23.563 19.104 42.667 42.667 42.667h256c23.563 0 42.667-19.104 42.667-42.667v-256c0-23.563-19.103-42.667-42.667-42.667h-256c-23.563 0-42.667 19.103-42.667 42.667z",
    glyphName: "view_thumbnail_18",
    unicode: "\\uEAB0"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M128 789.333C128 812.897 147.103 832 170.667 832h256c23.565 0 42.667-19.103 42.667-42.667v-256c0-23.565-19.102-42.667-42.667-42.667h-256c-23.564 0-42.667 19.102-42.667 42.667zm0-426.666c0 23.565 19.103 42.667 42.667 42.667h256c23.565 0 42.667-19.102 42.667-42.667v-256c0-23.565-19.102-42.667-42.667-42.667h-256C147.103 64 128 83.102 128 106.667zm426.667 426.666c0 23.564 19.102 42.667 42.667 42.667h256c23.565 0 42.667-19.103 42.667-42.667v-256c0-23.565-19.102-42.667-42.667-42.667h-256c-23.565 0-42.667 19.102-42.667 42.667zm0-426.666c0 23.565 19.102 42.667 42.667 42.667h256c23.565 0 42.667-19.102 42.667-42.667v-256c0-23.565-19.102-42.667-42.667-42.667h-256c-23.565 0-42.667 19.102-42.667 42.667z",
    glyphName: "view_thumbnail_24",
    unicode: "\\uEAB1"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M128 789.333C128 812.897 147.103 832 170.667 832h256c23.565 0 42.667-19.103 42.667-42.667v-256c0-23.565-19.102-42.667-42.667-42.667h-256c-23.564 0-42.667 19.102-42.667 42.667zm0-426.666c0 23.565 19.103 42.667 42.667 42.667h256c23.565 0 42.667-19.102 42.667-42.667v-256c0-23.565-19.102-42.667-42.667-42.667h-256C147.103 64 128 83.102 128 106.667zm426.667 426.666c0 23.564 19.102 42.667 42.667 42.667h256c23.565 0 42.667-19.103 42.667-42.667v-256c0-23.565-19.102-42.667-42.667-42.667h-256c-23.565 0-42.667 19.102-42.667 42.667zm0-426.666c0 23.565 19.102 42.667 42.667 42.667h256c23.565 0 42.667-19.102 42.667-42.667v-256c0-23.565-19.102-42.667-42.667-42.667h-256c-23.565 0-42.667 19.102-42.667 42.667z",
    glyphName: "view_thumbnail_48",
    unicode: "\\uEAB2"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M682.667 874.666c0 17.257-10.395 32.815-26.339 39.418s-34.295 2.954-46.497-9.249L366.327 661.332H128c-23.564 0-42.667-19.103-42.667-42.667V277.332c0-23.565 19.103-42.667 42.667-42.667h238.327L609.831-8.841c12.203-12.203 30.554-15.846 46.497-9.25a42.68 42.68 0 0 1 26.339 39.424zM908.501 311.16l-76.498 76.497-76.497-76.497-60.34 60.34 76.497 76.496-76.497 76.497 60.34 60.34 76.497-76.497 76.498 76.497 60.339-60.34-76.501-76.497L968.84 371.5z",
    glyphName: "volume_mute_12",
    unicode: "\\uEAB3"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M676.983 874.688a36.98 36.98 0 0 1-22.83 34.163 36.97 36.97 0 0 1-40.294-8.016L368.688 655.666H128.005c-20.423 0-36.978-16.555-36.978-36.978V277.356c0-20.423 16.555-36.978 36.978-36.978h240.683L613.859-4.79c10.576-10.576 26.482-13.744 40.294-8.021a36.99 36.99 0 0 1 22.83 34.167zm235.543-559.484-80.521 80.521-80.515-80.521-52.298 52.298 80.521 80.517-80.521 80.519 52.298 52.295 80.515-80.519 80.521 80.519 52.298-52.295-80.521-80.519 80.521-80.517z",
    glyphName: "volume_mute_18",
    unicode: "\\uEAB4"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M667.738 874.682a27.733 27.733 0 0 1-47.343 19.61L372.517 646.415H128.005c-15.317 0-27.733-12.416-27.733-27.733V277.35c0-15.317 12.416-27.733 27.733-27.733h244.512L620.395 1.741a27.72 27.72 0 0 1 30.221-6.012 27.73 27.73 0 0 1 17.122 25.621zm251.323-552.945-87.057 87.057-87.053-87.057-39.223 39.223 87.057 87.053-87.057 87.058 39.223 39.221 87.053-87.055 87.057 87.055 39.223-39.221-87.057-87.058 87.057-87.053z",
    glyphName: "volume_mute_24",
    unicode: "\\uEAB5"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M666.667 874.666a26.668 26.668 0 0 1-45.523 18.857l-248.19-248.189H128c-14.728 0-26.667-11.94-26.667-26.667V277.334c0-14.729 11.939-26.667 26.667-26.667h244.954l248.19-248.19a26.667 26.667 0 0 1 45.523 18.857zm253.145-552.191-87.81 87.81-87.81-87.81-37.713 37.713 87.81 87.81-87.81 87.81 37.713 37.713 87.81-87.81 87.81 87.81 37.713-37.713-87.81-87.81 87.81-87.81z",
    glyphName: "volume_mute_48",
    unicode: "\\uEAB6"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M656.328 914.084a42.67 42.67 0 0 0 26.339-39.418V21.334a42.68 42.68 0 0 0-26.339-39.424c-15.944-6.596-34.295-2.953-46.497 9.25L366.327 234.666H128c-23.564 0-42.667 19.102-42.667 42.667v341.333c0 23.564 19.103 42.667 42.667 42.667h238.327l243.504 243.503a42.665 42.665 0 0 0 46.497 9.249zm184.508-222.582c134.609-134.609 134.609-352.397 0-487.006l-60.339 60.34c101.286 101.284 101.286 265.042 0 366.326zm-71.722-114.389c71.281-71.281 71.281-186.954 0-258.237l-60.34 60.34c37.957 37.957 37.957 99.6 0 137.557z",
    glyphName: "volume_on_12",
    unicode: "\\uEAB7"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M654.154 908.823a36.98 36.98 0 0 0 22.83-34.163V21.328a36.98 36.98 0 0 0-22.83-34.162 36.97 36.97 0 0 0-40.294 8.016L368.689 240.35H128.006c-20.423 0-36.978 16.555-36.978 36.978V618.66c0 20.423 16.555 36.978 36.978 36.978h240.683L613.86 900.807a36.97 36.97 0 0 0 40.294 8.016m182.664-221.349c132.386-132.387 132.386-346.573 0-478.959l-52.292 52.292c103.504 103.509 103.504 270.867 0 374.372zM765.11 573.099c69.063-69.06 69.063-181.131 0-250.192l-52.292 52.292c40.175 40.182 40.175 105.426 0 145.605z",
    glyphName: "volume_on_18",
    unicode: "\\uEAB8"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M650.615 900.284a27.735 27.735 0 0 0 17.122-25.623V21.329a27.73 27.73 0 0 0-17.122-25.621 27.73 27.73 0 0 0-30.221 6.012L372.516 249.596H128.004c-15.317 0-27.733 12.416-27.733 27.733v341.332c0 15.317 12.416 27.733 27.733 27.733h244.512l247.878 247.877a27.73 27.73 0 0 0 30.221 6.012zm179.666-219.345c128.777-128.777 128.777-337.109 0-465.886l-39.219 39.219c107.115 107.119 107.115 280.33 0 387.446zm-71.719-114.38c65.451-65.452 65.451-171.666 0-237.117l-39.219 39.219c43.789 43.789 43.789 114.889 0 158.677z",
    glyphName: "volume_on_24",
    unicode: "\\uEAB9"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M650.206 899.303a26.67 26.67 0 0 0 16.461-24.637V21.334a26.668 26.668 0 0 0-45.523-18.857l-248.19 248.19H128c-14.728 0-26.667 11.938-26.667 26.667v341.333c0 14.726 11.939 26.667 26.667 26.667h244.954l248.19 248.189a26.67 26.67 0 0 0 29.062 5.78m179.317-219.115c128.361-128.361 128.361-336.017 0-464.378l-37.713 37.713c107.533 107.533 107.533 281.421 0 388.954zm-71.708-114.375c65.033-65.033 65.033-170.575 0-235.61l-37.713 37.713c44.205 44.205 44.205 115.979 0 160.186z",
    glyphName: "volume_on_48",
    unicode: "\\uEABA"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M866.462 408.641H78.77v78.769h787.692zM277.208 161.516 119.67 712.898l75.738 21.64 119.669-418.843 119.669 418.843h75.738l119.669-418.843 119.669 418.843 75.741-21.64-157.542-551.382h-75.738l-119.669 418.84-119.669-418.84h-75.738z",
    glyphName: "won_12",
    horizAdvX: 945,
    unicode: "\\uEABB"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M889.263 412.974H80.842v70.065h808.421zM289.685 155.438 128.001 721.331l67.367 19.248 128.001-448.001L451.37 740.579h67.367l128.001-448.001 128 448.001 67.368-19.248-161.684-565.893h-67.368l-128 448.001-128.001-448.001h-67.367z",
    glyphName: "won_18",
    horizAdvX: 970,
    unicode: "\\uEABC"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M309.266 893.716c-26.755 18.405-55.452 17.262-77.245 10.54-21.038-6.49-38.374-18.76-48.641-28.592l-88.358-88.857C50.488 739.32 44.074 677.308 57.333 615.825c13.153-60.992 46.341-126.111 88.171-188.258 83.769-124.457 208.592-246.31 305.349-313.325C607.83 5.521 732.747-10.299 775.214-12.672c43.799-2.449 76.006 22.69 88.146 37.111l.162.196c20.659 24.934 68.565 83.626 92.467 116.249 19.191 26.184 19.541 54.31 12.817 76.577-6.255 20.731-18.697 37.342-28.86 47.151-29.798 29.961-97.521 97.633-130.96 129.574-12.961 12.38-27.972 19.906-44.102 22.263-15.764 2.303-30.286-.655-42.303-5.408-22.595-8.937-40.319-25.713-50.414-38.362a12938 12938 0 0 0-32.893-36.89 5270 5270 0 0 0-11.024-12.274c-4.139 2.035-9.279 4.84-15.432 8.624-23.819 14.647-59.564 41.956-105.89 88.533-36.685 36.884-63.117 70.474-80.553 97.529-10.453 16.22-16.961 28.997-20.756 38.077l43.349 43.546c7.043 7.135 34.157 35.205 36.719 73.832 2.487 37.52-18.036 66.347-30.481 78.359-17.233 18.715-44.494 47.554-71.54 74.607-26.611 26.619-55.602 54.163-74.4 67.095z",
    glyphName: "call_12",
    unicode: "\\uEABD"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "m236.818 820.512-86.134-86.601c-21.007-22.697-28.291-55.284-18.25-101.844 10.234-47.458 37.552-103.24 76.809-161.564C287.62 354.058 405.641 239.049 494.608 177.43 637.998 78.114 748.646 65.783 779.525 64.06c5.783-.324 11.366 1.186 16.482 3.823a39 39 0 0 1 6.37 4.087c1.475 1.161 2.278 2.014 2.278 2.014 20.929 25.259 67.145 81.958 89.417 112.352 1.562 2.129 1.801 3.398 1.886 4.047.111.898.094 2.478-.649 4.934-.759 2.524-2.116 5.38-3.968 8.226-1.877 2.875-3.738 4.946-4.762 5.926l-.794.755c-29.781 29.948-97.11 97.238-129.818 128.479-1.118 1.067-1.866 1.567-2.259 1.78-.403-.039-1.318-.199-2.853-.806-2.767-1.095-6.297-3.179-10.107-6.298-3.764-3.081-6.839-6.388-8.767-8.854a43 43 0 0 0-1.715-2.059c-16.518-18.6-53.604-60.244-59.701-66.374-8.095-8.139-17.267-11.224-22.988-12.46-5.905-1.276-11.139-1.254-14.831-1-7.357.505-14.274 2.357-19.926 4.268-11.671 3.944-25.227 10.66-40.207 19.872-30.285 18.624-70.734 50.148-120.112 99.795-39.974 40.19-69.935 77.932-90.656 110.085-19.668 30.521-33.929 60.446-36.89 84.273a42.66 42.66 0 0 0 12.103 35.366l57.34 57.598c2.407 2.443 6.297 6.68 9.602 11.942 3.453 5.498 4.881 9.922 5.082 12.959.219 3.308-.609 7.113-2.61 11.185a32.7 32.7 0 0 1-3.068 5.036c-.847 1.136-1.381 1.679-1.381 1.679l.115-.104a43 43 0 0 0-2.621 2.613c-16.62 18.074-43.569 46.606-70.136 73.18-27.649 27.656-51.662 49.895-63.615 58.119-2.009 1.382-4.62 2.418-11.081.426-7.206-2.223-14.275-7.069-17.867-10.409zm-7.286 91.95c23.497 7.248 55.094 8.633 84.597-11.664 19.558-13.455 49.103-41.589 75.599-68.092 27.063-27.069 54.322-55.902 71.625-74.689 13.629-13.257 35.569-44.257 32.876-84.875-2.787-42.03-32.072-72.081-39.16-79.262l-.126-.128-39.134-39.31c3.693-7.954 9.349-18.505 17.766-31.567 17.071-26.488 43.111-59.618 79.43-96.134 45.988-46.237 81.21-73.077 104.311-87.282a210 210 0 0 1 9.04-5.271c2.102 2.34 4.314 4.805 6.589 7.346a12997 12997 0 0 1 32.724 36.699c10.723 13.384 29.511 31.187 53.802 40.794 13.056 5.164 29.103 8.485 46.675 5.917 18.029-2.634 34.633-11.04 48.763-24.536 33.51-32.006 101.239-99.688 131.063-129.666 10.965-10.608 24.277-28.402 31.036-50.763 7.33-24.287 6.98-55.318-14.106-84.087-24.081-32.862-72.132-91.733-92.783-116.651l-.205-.247c-13.269-15.761-47.863-42.778-95.148-40.141-43.756 2.449-170.258 18.654-328.744 128.425-97.623 67.614-223.201 190.228-307.569 315.576-42.115 62.572-75.956 128.728-89.434 191.223-13.61 63.11-7.309 128.378 39.806 178.617l.871.902 87.807 88.284c11.021 10.553 29.477 23.624 52.029 30.581z",
    glyphName: "call_outline_12",
    unicode: "\\uEABE"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M287.891 899.701c-21.699 14.927-45.093 14.291-64.015 8.454-18.568-5.728-34.165-16.75-43.196-25.397L88.651 790.22C47.892 746.758 40.894 689.218 54 628.443c13.056-60.545 46.388-126.508 89.644-190.774 86.564-128.607 215.872-254.79 315.454-323.763C620.414 2.181 747.892-13.531 789.485-15.854c37.888-2.118 66.157 19.923 76.262 31.936l.077.09c21.741 26.227 71.667 87.424 96.371 121.126 15.744 21.485 16.109 44.262 10.464 62.944-5.427 17.978-16.442 32.666-25.222 41.107-31.245 31.411-102.349 102.459-137.299 135.844-10.893 10.407-22.95 16.262-35.469 18.091-12.352 1.804-24.051-.461-34.253-4.496-19.757-7.813-35.891-23.02-45.037-34.598-15.763-17.75-44.685-50.188-55.908-62.438q-.947.267-2.163.678c-6.471 2.189-16.436 6.816-29.837 15.059-26.68 16.406-65.427 46.169-114.858 95.868-39.369 39.582-68.034 75.924-87.19 105.649-15.922 24.707-24.584 43.782-27.981 55.882l54.262 54.508c7.289 7.384 30.713 32.252 32.877 64.897 2.132 32.154-16.099 57.37-26.38 67.066-17.924 19.48-46.585 49.811-74.976 78.21-28.21 28.218-57.364 55.769-75.334 68.131z",
    glyphName: "call_16",
    unicode: "\\uEABF"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "m225.576 833.204-87.489-87.963c-24.716-26.591-31.994-63.873-21.348-113.238 10.788-50.024 39.303-107.865 79.426-167.476 80.143-119.069 200.631-236.515 291.846-299.689C635.175 62.912 749.287 49.913 782.24 48.07c8.256-.461 15.891 1.722 22.445 5.101 6.758 3.482 11.014 7.546 12.115 8.826 21.107 25.472 68.256 83.296 91.078 114.445 4.653 6.342 4.998 12.154 2.944 18.95-2.419 8.013-7.936 15.469-11.827 19.187l-.595.57c-30.138 30.304-98.413 98.534-131.648 130.282-4.019 3.839-6.79 4.591-8.307 4.812-1.856.271-4.659.098-8.723-1.509-8.96-3.543-18.33-11.84-23.814-18.861a37 37 0 0 0-1.286-1.544c-16.928-19.055-54.138-60.835-60.013-66.742-6.176-6.208-13.21-8.595-17.702-9.568-4.634-.998-8.812-.998-11.884-.787-6.125.422-12.118 1.99-17.356 3.757-10.751 3.635-23.691 9.99-38.429 19.053-29.72 18.278-69.988 49.581-119.539 99.4-39.994 40.211-69.815 77.818-90.316 109.63-19.712 30.588-32.977 59.123-35.652 80.641a32 32 0 0 0 9.077 26.524l58.078 58.34c2.708 2.747 7.283 7.702 11.247 14.015 4.079 6.494 6.469 12.776 6.838 18.337.382 5.763-1.101 11.581-3.768 17.006-2.785 5.665-6.068 9.274-6.883 10.019a31 31 0 0 0-1.966 1.96c-16.909 18.389-44.305 47.393-71.337 74.432-27.843 27.85-52.882 51.142-65.983 60.154-5.642 3.882-12.09 4.614-20.867 1.907-9.321-2.876-17.999-8.884-22.589-13.202zm3.724 74.358c21.555 6.649 49.742 7.733 76.006-10.334 18.805-12.936 47.992-40.648 74.972-67.634 27.38-27.389 54.986-56.592 72.412-75.519 12.244-11.789 32.596-40.323 30.14-77.38-2.526-38.088-29.328-65.916-36.445-73.125l-.095-.096-44.988-45.191c3.834-9.52 10.666-23.144 21.877-40.541 17.763-27.564 44.643-61.712 81.896-99.167 47.007-47.263 83.356-75.052 107.688-90.015 7.162-4.404 13.018-7.534 17.581-9.692 3.683 4.082 7.946 8.828 12.454 13.86a13371 13371 0 0 1 33.357 37.41c10.035 12.587 27.661 29.263 50.029 38.11 11.853 4.689 26.099 7.576 41.517 5.324 15.763-2.303 30.483-9.658 43.258-21.859 33.837-32.319 102.4-100.832 132.57-131.162 10.042-9.696 22.374-26.157 28.563-46.662 6.624-21.939 6.272-49.542-12.589-75.277-24.154-32.96-72.602-92.333-93.536-117.581l-.154-.186c-11.942-14.195-43.84-39.091-87.136-36.672-42.618 2.381-168.618 18.285-327.105 128.051-97.707 67.674-223.864 190.822-308.5 316.567-42.267 62.796-75.674 128.419-88.894 189.721-13.319 61.764-6.791 123.573 37.525 170.828l.653.676 88.713 89.193c10.17 9.739 27.386 21.922 48.232 28.352z",
    glyphName: "call_outline_16",
    unicode: "\\uEAC0"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M293.687 897.909c-24.422 16.8-50.657 15.85-70.948 9.591-19.685-6.072-35.994-17.62-45.591-26.81l-.241-.231-86.919-87.406c-42.132-44.927-48.561-103.845-35.707-163.45 12.769-59.209 45.111-122.848 86.271-184.001 82.41-122.439 205.309-242.394 300.367-308.238C595.063 30.606 717.437 15.246 758.488 12.954c40.732-2.276 70.821 21.202 81.983 34.463l.131.159c20.452 24.673 67.709 82.586 91.233 114.682 17.573 23.979 17.914 49.641 11.719 70.167-5.825 19.297-17.476 34.85-26.926 43.958-29.463 29.616-96.438 96.546-129.462 128.089-11.952 11.418-25.617 18.208-40.164 20.334-14.251 2.082-27.483-.576-38.599-4.972-21.083-8.34-37.825-24.168-47.343-36.136a13332 13332 0 0 0-32.666-36.631 4569 4569 0 0 0-14.057-15.633c-4.955 2.179-11.662 5.638-20.144 10.854-24.087 14.814-59.831 42.172-105.903 88.493-36.555 36.754-62.99 70.319-80.506 97.499-11.9 18.466-18.93 32.826-22.626 42.611l45.79 45.996c6.932 7.022 32.14 33.317 34.506 68.997 2.308 34.805-16.935 61.703-28.361 72.659-16.991 18.457-43.962 46.992-70.705 73.743-26.406 26.414-54.671 53.22-72.699 65.622z",
    glyphName: "call_18",
    unicode: "\\uEAC1"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "m228.796 825.347-83.372-83.824c-21.617-23.315-28.623-56.447-18.734-102.304 10.055-46.627 36.788-101.068 74.88-157.661 76.063-113.009 190.528-224.563 276.963-284.427 139.366-96.529 247.12-108.646 277.612-110.347 6.502-.364 12.658 1.343 18.125 4.159a42.5 42.5 0 0 1 6.849 4.403 30 30 0 0 1 2.105 1.815c.398.381.614.614.671.683 20.196 24.371 65.018 79.354 86.659 108.88 1.934 2.64 2.441 4.545 2.611 5.899.199 1.564.085 3.698-.774 6.537-1.923 6.377-6.485 12.578-9.58 15.531l-.677.666c-28.786 28.945-93.912 94.02-125.577 124.262-2.901 2.776-4.352 2.879-4.415 2.884-.41.057-1.946.165-5.046-1.058-3.18-1.263-6.969-3.538-10.9-6.753-3.891-3.186-7.083-6.61-9.136-9.239q-.717-.911-1.485-1.781c-16.043-18.068-51.763-58.175-57.549-63.989-7.054-7.088-15.058-9.791-20.093-10.883-5.2-1.121-9.83-1.104-13.147-.876-6.605.449-12.908 2.122-18.187 3.908-10.877 3.675-23.677 9.995-37.997 18.802-28.915 17.783-67.755 48.02-115.318 95.841-38.459 38.669-67.225 74.922-87.073 105.72-18.936 29.383-32.274 57.639-35.013 79.679a36.98 36.98 0 0 0 10.489 30.651l55.385 55.634.049.049c2.43 2.466 6.434 6.816 9.865 12.279 3.56 5.668 5.3 10.631 5.557 14.514.273 4.116-.773 8.545-2.951 12.976a36 36 0 0 1-3.375 5.537c-.968 1.298-1.637 1.985-1.76 2.112-.025.026-.023.021 0 0a37 37 0 0 0-2.276 2.272c-16.097 17.506-42.19 45.13-67.922 70.869-26.67 26.677-50.158 48.47-62.094 56.681-3.317 2.281-7.29 3.163-14.387.973-7.735-2.386-15.148-7.49-18.983-11.073zm-2.817 81.744c21.862 6.744 50.956 7.961 78.102-10.713 18.526-12.745 46.809-39.646 72.48-65.324 26.152-26.159 52.503-54.032 69.194-72.157 12.584-12.195 33.084-41.074 30.583-78.789-2.582-38.927-29.805-66.987-36.634-73.905l-.11-.111-39.908-40.087c3.645-8.26 9.547-19.561 18.69-33.748 16.684-25.89 42.052-58.145 77.344-93.627 44.624-44.867 78.932-71.047 101.625-84.997 4.585-2.822 8.55-5.057 11.913-6.804 2.674 2.981 5.586 6.218 8.607 9.597a11936 11936 0 0 1 31.716 35.569c10.052 12.57 27.682 29.267 50.318 38.22 12.1 4.787 26.852 7.815 42.934 5.465 16.475-2.408 31.733-10.093 44.806-22.581 32.358-30.907 97.826-96.329 126.64-125.297 10.2-9.853 22.636-26.465 28.917-47.263 6.781-22.471 6.446-51.012-12.993-77.534-23.188-31.642-69.564-88.468-89.532-112.56l-.176-.21c-12.265-14.569-44.51-39.743-88.474-37.291-41.654 2.327-163.146 17.801-315.597 123.392-93.935 65.058-214.95 183.205-296.207 303.929-40.569 60.273-72.955 123.706-85.821 183.366-12.981 60.193-6.833 121.657 37.421 168.846l.755.782 84.815 85.259c10.278 9.841 27.55 22.084 48.593 28.575z",
    glyphName: "call_outline_18",
    unicode: "\\uEAC2"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M305.66 888.465c-24.692 16.986-51.216 16.025-71.732 9.697-19.902-6.139-36.391-17.815-46.095-27.106l-.244-.234-87.878-88.372C57.113 737.027 50.614 677.459 63.61 617.196c12.909-59.864 45.609-124.205 87.224-186.033C234.153 307.374 358.41 186.09 454.519 119.526 610.363 11.584 734.088-3.943 775.594-6.264c41.182-2.3 71.599 21.436 82.884 34.846l.137.162c20.676 24.947 68.454 83.499 92.237 115.947 17.766 24.243 18.116 50.189 11.849 70.942-5.888 19.507-17.668 35.234-27.221 44.442-29.786 29.948-97.506 97.617-130.893 129.506-12.087 11.546-25.903 18.411-40.606 20.557-14.409 2.108-27.785-.58-39.023-5.026-21.321-8.431-38.246-24.435-47.872-36.531a12804 12804 0 0 0-33.024-37.039 4748 4748 0 0 0-14.212-15.804c-5.005 2.202-11.793 5.7-20.365 10.97-24.354 14.98-60.493 42.641-107.072 89.472-36.962 37.163-63.689 71.095-81.396 98.577-12.032 18.67-19.14 33.189-22.876 43.081l46.297 46.505c7.006 7.1 32.495 33.685 34.884 69.759 2.334 35.189-17.122 62.385-28.672 73.461-17.182 18.661-44.449 47.511-71.488 74.557-26.698 26.705-55.274 53.807-73.502 66.347z",
    glyphName: "call_24",
    unicode: "\\uEAC3"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "m226.408 831.197-86.499-86.967c-25.606-27.512-32.758-65.818-22.079-115.34 10.802-50.089 39.261-107.686 79.018-166.754 79.425-118.003 198.769-234.342 289.253-297.011C632.132 63.979 745.553 50.97 778.688 49.119c8.981-.499 17.207 1.877 24.154 5.457 7.138 3.678 11.75 8.026 13.154 9.673 20.834 25.131 67.49 82.355 90.116 113.229 5.453 7.441 5.794 14.498 3.49 22.127-2.62 8.683-8.495 16.602-12.715 20.634l-.508.499c-29.76 29.922-97.233 97.34-130.103 128.734-4.497 4.297-7.957 5.44-10.317 5.786-2.65.388-6.118.051-10.603-1.724-9.69-3.831-19.46-12.565-25.148-19.844-.354-.457-.73-.9-1.114-1.335-16.785-18.901-53.419-60.023-59.123-65.762-5.397-5.423-11.563-7.531-15.552-8.393-4.109-.887-7.851-.892-10.654-.695-5.594.384-11.162 1.822-16.171 3.516-10.249 3.465-22.758 9.583-37.167 18.445-29.026 17.852-68.561 48.555-117.346 97.604-39.333 39.548-68.608 76.48-88.689 107.644-19.398 30.101-32.094 57.674-34.624 78.025a27.73 27.73 0 0 0 7.867 22.988l57.364 57.623c2.768 2.807 7.508 7.932 11.64 14.511 4.23 6.735 6.917 13.562 7.338 19.913.433 6.527-1.255 12.953-4.11 18.76-2.957 6.016-6.488 9.974-7.66 11.045a28 28 0 0 0-1.704 1.699c-16.729 18.193-43.824 46.878-70.568 73.63-27.447 27.454-52.428 50.726-65.712 59.864-6.82 4.692-14.503 5.305-23.945 2.393-9.909-3.057-19.005-9.373-23.87-13.964zm7.521 66.965c20.515 6.328 47.04 7.289 71.732-9.697 18.228-12.539 46.804-39.642 73.502-66.347 27.039-27.046 54.306-55.896 71.488-74.557 11.55-11.076 31.006-38.272 28.672-73.461-2.389-36.074-27.878-62.659-34.884-69.759l-.085-.083-46.211-46.421c3.736-9.892 10.845-24.411 22.876-43.081 17.708-27.482 44.434-61.414 81.396-98.577 46.579-46.831 82.718-74.492 107.072-89.472 8.572-5.269 15.36-8.768 20.365-10.97 4.041 4.467 8.96 9.941 14.212 15.804a12672 12672 0 0 1 33.024 37.039c9.626 12.096 26.551 28.1 47.872 36.531 11.238 4.446 24.614 7.134 39.023 5.026 14.703-2.146 28.518-9.011 40.606-20.557 33.387-31.889 101.103-99.554 130.893-129.502 9.553-9.212 21.333-24.934 27.221-44.446 6.268-20.753 5.918-46.699-11.849-70.942-23.782-32.448-71.561-90.999-92.237-115.947l-.137-.162c-11.285-13.41-41.702-37.146-82.884-34.846-41.506 2.321-165.231 17.847-321.075 125.79-96.109 66.564-220.366 187.849-303.685 311.637-41.615 61.828-74.315 126.169-87.224 186.033-12.996 60.263-6.496 119.832 36.101 165.254l.566.586 87.556 88.019c9.703 9.291 26.192 20.967 46.095 27.106z",
    glyphName: "call_outline_24",
    unicode: "\\uEAC4"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M282.846 929.375c-25.924 17.834-53.796 16.886-75.597 10.161-21.21-6.543-38.845-19.025-49.18-28.92l-.235-.225-96.555-97.094C15.583 764.571 8.383 700.511 22.52 634.954c14.054-65.173 49.73-135.482 95.378-203.302 91.382-135.767 227.724-268.836 333.053-341.79C621.701-28.401 757.089-45.308 802.162-47.825c43.733-2.443 76.119 22.822 88.023 36.966l.128.156c22.754 27.452 75.241 91.776 101.321 127.36 18.692 25.506 19.076 52.738 12.457 74.66-6.257 20.723-18.82 37.489-28.962 47.258-32.757 32.934-107.245 107.366-143.938 142.415-12.77 12.198-27.251 19.354-42.573 21.591-15.034 2.197-29.065-.595-40.958-5.301-22.682-8.971-40.821-26.108-51.13-39.087-14.925-16.806-40.427-45.412-53.877-60.258-5.929 2.409-14.406 6.62-25.434 13.402-27.117 16.676-67.102 47.313-118.494 98.982-40.819 41.041-70.396 78.579-90.039 109.06-14.195 22.027-22.364 39.078-26.381 50.449l52.636 52.873c7.689 7.789 34.748 36.143 37.278 74.291 2.473 37.308-18.287 66.246-30.455 77.866-18.863 20.494-48.866 52.237-78.605 81.986-29.421 29.428-60.606 58.975-80.314 72.533z",
    glyphName: "call_48",
    unicode: "\\uEAC5"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "m192.929 874.574-95.306-95.822c-30.344-32.535-38.142-77.378-26.096-133.241 12.15-56.339 43.993-120.55 87.961-185.875 87.862-130.539 219.764-259.14 320.007-328.57C641.377 18.944 767.45 4.314 804.956 2.219c23.174-1.295 41.502 12.864 46.818 19.13 22.88 27.607 74.377 90.756 99.422 124.932 7.561 10.317 7.938 20.476 4.9 30.534-3.305 10.948-10.537 20.666-15.863 25.754q-.121.115-.239.233l-.19.188c-32.727 32.905-107.01 107.13-143.243 141.737-5.911 5.647-11.031 7.631-15.191 8.237-4.41.646-9.481-.021-15.27-2.313-12.19-4.821-23.878-15.413-30.62-24.041a24 24 0 0 0-.945-1.131c-18.586-20.93-58.671-65.922-64.762-72.047-4.666-4.691-10.031-6.543-13.604-7.315-3.674-.794-7.083-.809-9.749-.627-5.318.367-10.812 1.756-16.013 3.514-10.607 3.586-23.87 10.037-39.45 19.618-31.339 19.273-74.394 52.659-127.778 106.334-42.965 43.198-74.846 83.445-96.634 117.257-21.212 32.913-34.438 62.135-37.02 82.884a23.47 23.47 0 0 0 6.658 19.45l63.113 63.398c7.43 7.533 21.696 24.226 22.899 42.355 1.193 18.007-10.061 33.728-15.223 38.447a24 24 0 0 0-1.44 1.438c-18.453 20.067-48.329 51.695-77.828 81.204-30.097 30.105-58.033 56.189-73.274 66.673-9.771 6.721-20.612 7.196-32.405 3.559-12.181-3.758-23.142-11.402-29.097-17.046zm15.264 61.894c21.162 6.528 47.946 7.385 72.84-9.74 19.424-13.361 50.4-42.688 79.863-72.159 29.741-29.748 59.748-61.501 78.583-81.967 11.721-11.149 31.945-39.272 29.547-75.411-2.445-36.873-28.689-64.482-36.361-72.254l-.07-.07-53.961-54.204c3.904-11.782 12.365-29.758 27.362-53.028 19.782-30.697 49.504-68.407 90.46-109.585 51.52-51.797 91.701-82.611 119.087-99.452 12.446-7.652 21.781-12.132 27.998-14.458 13.075 14.391 40.019 44.614 55.443 61.982 10.071 12.704 27.812 29.451 49.854 38.17 11.505 4.55 24.962 7.209 39.319 5.109 14.607-2.133 28.491-8.958 40.823-20.738 36.67-35.025 111.155-109.455 143.904-142.381 9.839-9.47 22.071-25.792 28.145-45.903 6.389-21.165 6.005-47.307-11.977-71.842-26.014-35.499-78.443-99.753-101.201-127.211l-.113-.137c-11.479-13.641-42.972-38.204-85.399-35.834-44.589 2.49-179.381 19.253-349.566 137.124-105.005 72.727-241.063 205.513-332.22 340.945-45.541 67.661-80.972 137.581-94.905 202.191-14.006 64.947-6.763 127.785 37.965 175.479q.236.252.479.496l95.781 96.3q.202.203.409.401c10.052 9.626 27.268 21.807 47.91 28.174z",
    glyphName: "call_outline_48",
    unicode: "\\uEAC6"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M243.209 887.5c-94.257 0-170.667-76.41-170.667-170.667V183.5c0-94.258 76.41-170.666 170.667-170.666h533.333c94.259 0 170.667 76.407 170.667 170.666v533.333c0 94.257-76.407 170.667-170.667 170.667zm218.073-631.741v157.658H315.5v85.333h145.782v145.749h85.333V498.75H704.24v-85.333H546.615V255.759z",
    glyphName: "upload_12",
    unicode: "\\uEAC7"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M244.611 886.056c-94.256 0-170.667-76.41-170.667-170.667V182.056c0-94.259 76.41-170.667 170.667-170.667h533.333c94.259 0 170.667 76.407 170.667 170.667v533.333c0 94.256-76.407 170.667-170.667 170.667zm221.285-631.683v151.96H316.889v73.956h149.007v162.822h73.956V480.289h165.775v-73.956H539.852v-151.96z",
    glyphName: "upload_18",
    unicode: "\\uEAC8"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M245.333 885.333c-94.257 0-170.667-76.41-170.667-170.667V181.333c0-94.255 76.41-170.667 170.667-170.667h533.333c94.255 0 170.667 76.412 170.667 170.667v533.333c0 94.257-76.412 170.667-170.667 170.667zm235.081-631.697v162.778H317.646v63.168h162.768v162.793h63.168V479.582h162.803v-63.168H543.582V253.636z",
    glyphName: "upload_24",
    unicode: "\\uEAC9"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M245.333 885.333c-94.257 0-170.667-76.41-170.667-170.667V181.333c0-94.257 76.41-170.667 170.667-170.667h533.333c94.257 0 170.667 76.41 170.667 170.667v533.333c0 94.257-76.41 170.667-170.667 170.667zm235.089-631.699v179.012H317.636v46.933h162.786v162.795h46.933V479.579h179.021v-46.933H527.355V253.634z",
    glyphName: "upload_48",
    unicode: "\\uEACA"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M776.542 802.083c47.128 0 85.333-38.205 85.333-85.333V183.417c0-47.128-38.205-85.334-85.333-85.334H243.209c-47.129 0-85.333 38.206-85.333 85.334V716.75c0 47.129 38.205 85.333 85.333 85.333zm-533.333 85.334c-94.257 0-170.667-76.41-170.667-170.667V183.417c0-94.26 76.41-170.668 170.667-170.668h533.333c94.259 0 170.667 76.407 170.667 170.668V716.75c0 94.257-76.407 170.667-170.667 170.667zm218.083-388.75v145.75h85.333v-145.75H704.25v-85.333H546.625V255.676h-85.333v157.658H315.509v85.333z",
    glyphName: "upload_outline_12",
    unicode: "\\uEACB"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M777.973 812.1c53.413 0 96.711-43.299 96.711-96.711V182.056c0-53.413-43.298-96.711-96.711-96.711H244.639c-53.412 0-96.711 43.298-96.711 96.711v533.333c0 53.412 43.299 96.711 96.711 96.711zm-533.334 73.956c-94.256 0-170.667-76.41-170.667-170.667V182.056c0-94.259 76.41-170.667 170.667-170.667h533.334c94.254 0 170.667 76.407 170.667 170.667v533.333c0 94.256-76.413 170.667-170.667 170.667zm221.305-405.778v162.834H539.9V480.278h165.767v-73.956H539.9V254.373h-73.956v151.949H316.925v73.956z",
    glyphName: "upload_outline_18",
    unicode: "\\uEACC"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M778.667 829.867c63.625 0 115.2-51.577 115.2-115.2V181.334c0-63.625-51.575-115.2-115.2-115.2H245.334c-63.623 0-115.2 51.575-115.2 115.2v533.333c0 63.623 51.577 115.2 115.2 115.2zm-533.334 55.466c-94.257 0-170.667-76.41-170.667-170.667V181.333c0-94.255 76.41-170.667 170.667-170.667h533.333c94.255 0 170.667 76.412 170.667 170.667v533.333c0 94.257-76.412 170.667-170.667 170.667zm235.081-468.919V253.636h63.168v162.778h162.803v63.168H543.582v162.793h-63.168V479.582H317.646v-63.168z",
    glyphName: "upload_outline_24",
    unicode: "\\uEACD"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M778.667 838.4c68.337 0 123.733-55.397 123.733-123.733V181.334c0-68.337-55.396-123.733-123.733-123.733H245.334c-68.336 0-123.733 55.396-123.733 123.733v533.333c0 68.336 55.397 123.733 123.733 123.733zm-533.334 46.933c-94.257 0-170.667-76.41-170.667-170.667V181.333c0-94.257 76.41-170.667 170.667-170.667h533.333c94.257 0 170.667 76.41 170.667 170.667v533.333c0 94.257-76.41 170.667-170.667 170.667zm235.083-405.749v162.79h46.933v-162.79h179.025v-46.933H527.349V253.634h-46.933v179.017H317.634v46.933z",
    glyphName: "upload_outline_48",
    unicode: "\\uEACE"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M480 416V64h64v352h352v64H544v352h-64V480H128v-64z",
    glyphName: "add_16",
    unicode: "\\uEACF"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M217.844 742.156c-162.458-162.458-162.458-425.855 0-588.313s425.855-162.458 588.313 0 162.458 425.855 0 588.313-425.855 162.458-588.313 0M738.278 416H544.003V221.728h-64V416H285.729v64h194.274v194.274h64V480h194.275z",
    glyphName: "add_circle_16",
    unicode: "\\uEAD0"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M480 416H285.729v64H480v194.271h64V480h194.278v-64H544V221.722h-64zM217.844 742.156c-162.458-162.458-162.458-425.855 0-588.313s425.855-162.458 588.313 0 162.458 425.855 0 588.313-425.855 162.458-588.313 0m45.254-543.058c-137.464 137.466-137.464 360.339 0 497.804s360.339 137.464 497.804 0c137.466-137.465 137.466-360.339 0-497.804s-360.339-137.466-497.804 0",
    glyphName: "add_circle_outline_16",
    unicode: "\\uEAD1"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M464 400H128v96h336v336h96V496h336v-96H560V64h-96z",
    glyphName: "add_thick_16",
    unicode: "\\uEAD2"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M556.641 160.826 851.156 484.5l45.504-41.407L548.632 60.609c-5.83-6.406-14.091-10.061-22.753-10.061s-16.924 3.654-22.753 10.061L155.095 443.093l45.507 41.407 294.515-323.674v685.455h61.526V160.826z",
    glyphName: "arrow_down_16",
    unicode: "\\uEAD3"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "m238.281 417.64 323.671-294.517-41.407-45.504L138.059 425.65a30.763 30.763 0 0 0 0 45.506l382.486 348.031 41.407-45.507-323.671-294.515h685.45v-61.526h-685.45z",
    glyphName: "arrow_left_16",
    unicode: "\\uEAD4"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M813.453 479.166 489.782 773.681l41.407 45.507 382.488-348.031c6.406-5.83 10.054-14.091 10.054-22.753s-3.648-16.923-10.054-22.753L531.189 77.62l-41.407 45.504 323.671 294.517H128v61.526z",
    glyphName: "arrow_right_16",
    unicode: "\\uEAD5"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M495.115 736.001 200.6 412.33l-45.507 41.407 348.031 382.485a30.763 30.763 0 0 0 45.506 0l348.028-382.485-45.504-41.407-294.515 323.671V50.548h-61.526v685.453z",
    glyphName: "arrow_up_16",
    unicode: "\\uEAD6"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "m895.987 680.072-518.88-538.024c-6.031-6.259-14.346-9.786-23.034-9.786s-17.002 3.526-23.034 9.786l-203.04 210.53 46.067 44.428 180.006-186.65 495.846 514.145 46.067-44.428z",
    glyphName: "check_16",
    unicode: "\\uEAD7"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M918.054 679.949 384.146 116.32a48.004 48.004 0 0 0-69.694 0l-208.92 220.552 69.695 66.02L349.299 219.13l499.06 526.839z",
    glyphName: "check_thick_16",
    unicode: "\\uEAD8"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M901.12 421.38H81.92v53.248h819.2zM302.08 153.973 138.24 727.412l51.199 14.628 138.24-483.84 138.24 483.84h51.2l138.24-483.84 138.24 483.84 51.2-14.628-163.84-573.439h-51.2l-138.24 483.84-138.24-483.84z",
    glyphName: "won_24",
    horizAdvX: 983,
    unicode: "\\uEAD9"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M938.669 421.871H85.336v52.245h853.333zM316.22 142.15 145.553 739.485l50.235 14.352 145.549-509.423 145.55 509.423h50.235L682.67 244.414l145.55 509.423 50.235-14.352L707.788 142.15h-50.235L512.005 651.573 366.455 142.15z",
    glyphName: "won_48",
    unicode: "\\uEADA"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M170.667 114.71v137.015c0 3.395 1.348 6.65 3.749 9.05l365.536 365.536 155.117-155.117-365.536-365.536a12.8 12.8 0 0 0-9.05-3.746H183.468c-7.069 0-12.8 5.728-12.8 12.797zm584.741 416.825 95.183 95.183c9.995 9.998 9.995 26.207 0 36.204L731.678 781.835c-9.998 9.998-26.207 9.998-36.204 0l-95.183-95.183z",
    glyphName: "write_12",
    unicode: "\\uEADB"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M693.568 82.797 291.844 448l401.724 365.204 43.053-47.356L386.987 448l349.634-317.849z",
    glyphName: "chevron_left_16",
    unicode: "\\uEADC"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "m330.645 813.203 401.726-365.204L330.645 82.796l-43.052 47.354 349.633 317.849-349.633 317.848z",
    glyphName: "chevron_right_16",
    unicode: "\\uEADD"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M512 106.667c188.513 0 341.333 152.82 341.333 341.333S700.513 789.333 512 789.333 170.667 636.513 170.667 448 323.487 106.667 512 106.667M938.667 448c0-235.641-191.025-426.667-426.667-426.667S85.333 212.358 85.333 448 276.358 874.667 512 874.667 938.667 683.642 938.667 448m-184.26 96.772-309.333-288c-16.812-15.653-43-15.185-59.244 1.058L247.163 396.497l60.339 60.339 109.555-109.554 279.201 259.946z",
    glyphName: "circle_check_outline_12",
    unicode: "\\uEADE"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M512 95.289c194.799 0 352.711 157.912 352.711 352.711 0 194.797-157.912 352.711-352.711 352.711-194.797 0-352.711-157.914-352.711-352.711 0-194.799 157.914-352.711 352.711-352.711M938.667 448C938.667 212.361 747.64 21.333 512 21.333 276.358 21.333 85.333 212.36 85.333 448c0 235.642 191.025 426.667 426.667 426.667 235.639 0 426.667-191.025 426.667-426.667M739.556 561.778 442.148 261.854c-14.441-14.444-37.854-14.444-52.295 0L251.186 400.52l52.295 52.295L416 340.293l271.263 273.78 52.292-52.295z",
    glyphName: "circle_check_outline_18",
    unicode: "\\uEADF"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M512 76.8c205.009 0 371.2 166.191 371.2 371.2S717.009 819.2 512 819.2 140.8 653.008 140.8 448 306.992 76.8 512 76.8M938.667 448C938.667 212.361 747.64 21.333 512 21.333 276.358 21.333 85.333 212.36 85.333 448c0 235.642 191.025 426.667 426.667 426.667 235.639 0 426.667-191.025 426.667-426.667M766.276 599.056 435.609 268.39c-10.83-10.833-28.39-10.833-39.22 0L257.722 407.057l39.221 39.219 119.056-119.057 311.057 311.058z",
    glyphName: "circle_check_outline_24",
    unicode: "\\uEAE0"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M512 74.667c206.187 0 373.333 167.147 373.333 373.333S718.186 821.333 512 821.333 138.667 654.186 138.667 448 305.814 74.667 512 74.667M938.667 448c0-235.642-191.025-426.667-426.667-426.667S85.333 212.358 85.333 448 276.358 874.667 512 874.667 938.667 683.642 938.667 448M765.523 599.81l-37.713 37.713L416 325.713l-119.81 119.81-37.713-37.713 138.667-138.667c10.415-10.413 27.298-10.413 37.713 0z",
    glyphName: "circle_check_outline_48",
    unicode: "\\uEAE1"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M512.005 402.745 214.63 105.37l-45.255 45.254L466.75 448 169.38 745.37l45.255 45.255 297.37-297.37 297.371 297.37 45.254-45.255L557.259 448l297.377-297.376-45.254-45.254z",
    glyphName: "dismiss_16",
    unicode: "\\uEAE2"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M512 864C282.25 864 96 677.75 96 448 96 218.246 282.25 32 512 32c229.754 0 416 186.246 416 416 0 229.75-186.246 416-416 416m137.376-598.63L512.003 402.743 374.63 265.37l-45.255 45.254 137.373 137.373L329.375 585.37l45.255 45.255 137.373-137.373 137.373 137.373 45.254-45.255-137.373-137.373L694.63 310.624z",
    glyphName: "dismiss_circle_16",
    unicode: "\\uEAE3"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "m466.745 448-137.37 137.37 45.255 45.255L512 493.255l137.37 137.37 45.254-45.255L557.255 448 694.63 310.624l-45.254-45.254L512 402.745 374.625 265.37l-45.255 45.254zM512 864C282.25 864 96 677.75 96 448 96 218.246 282.25 32 512 32c229.754 0 416 186.246 416 416 0 229.75-186.246 416-416 416M160 448c0 194.404 157.596 352 352 352 194.406 0 352-157.596 352-352 0-194.406-157.594-352-352-352-194.404 0-352 157.594-352 352",
    glyphName: "dismiss_circle_outline_16",
    unicode: "\\uEAE4"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M512.007 380.118 225.945 94.055l-67.882 67.885 286.062 286.061L158.07 734.056l67.882 67.882 286.055-286.055 286.054 286.055 67.885-67.882L579.89 448.001 865.953 161.94l-67.885-67.885z",
    glyphName: "dismiss_thick_16",
    unicode: "\\uEAE5"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M142.938 849.062c-17.673 0-32-14.327-32-32V633.344c0-8.972 3.692-17.081 9.64-22.892l267.16-265.979V36.261c0-17.67 14.327-32 32-32h184.533c17.673 0 32 14.33 32 32v308.212l267.16 265.976c5.946 5.811 9.638 13.923 9.638 22.897v183.715c0 17.673-14.323 32-32 32z",
    glyphName: "filter_16",
    unicode: "\\uEAE6"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M110.938 817.062c0 17.673 14.327 32 32 32h738.131c17.677 0 32-14.327 32-32V633.347c0-8.973-3.693-17.086-9.638-22.897l-267.16-265.976V36.262c0-17.67-14.327-32-32-32H419.738c-17.673 0-32 14.33-32 32v308.212l-267.16 265.979c-5.948 5.811-9.64 13.92-9.64 22.892zm64-170.419 267.377-266.195a32 32 0 0 0 9.423-22.678V68.262h120.533V357.77a32 32 0 0 0 9.423 22.678l267.375 266.195v138.419H174.938z",
    glyphName: "filter_outline_16",
    unicode: "\\uEAE7"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M714.029 849.062c-80.906 0-152.871-36.294-202.039-92.751-49.169 56.457-121.133 92.751-202.037 92.751-147.505 0-267.296-120.083-267.296-267.947 0-59.145 13.41-106.641 40.229-168.923 79.698-168.583 298.939-298.74 389.337-346.823 25.004-13.306 54.53-13.293 79.526.019 90.319 48.102 309.308 178.246 389.346 346.804 26.816 62.282 40.23 109.778 40.23 168.923 0 147.864-119.795 267.947-267.296 267.947",
    glyphName: "heart_16",
    unicode: "\\uEAE8"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M511.99 692.312a64 64 0 0 1 48.262 21.968c37.826 43.433 92.58 70.783 153.777 70.783 112.006 0 203.296-91.283 203.296-203.947 0-47.015-10.01-85.35-34.534-142.497-33.907-70.725-99.334-137.658-172-194.631-72.028-56.474-145.814-99.046-189.126-122.112-6.203-3.302-13.185-3.302-19.386-.006-43.349 23.059-117.21 65.626-189.258 122.099-72.713 56.986-138.086 123.916-171.811 194.599-24.541 57.175-34.554 95.519-34.554 142.548 0 112.664 91.284 203.947 203.297 203.947 61.196 0 115.948-27.35 153.774-70.783a64 64 0 0 1 48.263-21.968m429.104-280.119c26.816 62.282 40.23 109.778 40.23 168.923 0 147.864-119.795 267.947-267.296 267.947-57.805 0-111.046-18.527-154.669-49.697a274.5 274.5 0 0 1-47.37-43.053 274.5 274.5 0 0 1-47.37 43.053c-43.623 31.171-96.863 49.697-154.667 49.697-147.505 0-267.296-120.083-267.296-267.947 0-59.145 13.41-106.641 40.229-168.923C162.583 243.61 381.824 113.453 472.222 65.37c25.004-13.306 54.53-13.293 79.526.019 90.319 48.102 309.308 178.246 389.346 346.804",
    glyphName: "heart_outline_16",
    unicode: "\\uEAE9"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M485.567 886.65c15.583 12.466 37.725 12.466 53.307 0l459.987-367.987-53.308-66.634-49.331 39.464V68.266c0-37.7-30.566-68.267-68.268-68.267H196.487c-37.703 0-68.267 30.566-68.267 68.267v423.227l-49.33-39.464-53.307 66.634z",
    glyphName: "home_12",
    unicode: "\\uEAEA"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M493.524 882.613c11.687 9.349 28.293 9.349 39.98 0L988.62 518.518l-39.981-49.976-59.008 47.206V104.376c0-53.018-42.976-96-96-96H233.425c-53.02 0-96 42.982-96 96v411.396l-59.039-47.231-39.98 49.976z",
    glyphName: "home_16",
    unicode: "\\uEAEB"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M489.226 846.675c13.505 10.804 32.695 10.804 46.199 0l418.112-334.492-46.199-57.75-46.632 37.305V106.694c0-36.13-29.286-65.422-65.422-65.422H229.391c-36.132 0-65.422 29.292-65.422 65.422v385.065l-46.659-37.327-46.199 57.75z",
    glyphName: "home_18",
    unicode: "\\uEAEC"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M494.677 875.006c10.129 8.103 24.521 8.103 34.65 0l448.324-358.659-34.65-43.311-61.935 49.545V85.35c0-38.882-31.518-70.4-70.4-70.4H213.334c-38.881 0-70.4 31.518-70.4 70.4v437.231l-61.931-49.545-34.65 43.311z",
    glyphName: "home_24",
    unicode: "\\uEAED"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M497.263 898.316c8.57 6.856 20.747 6.856 29.318 0L998.238 520.99l-29.318-36.649-70.865 56.691V39.991c0-24.742-20.058-44.8-44.8-44.8H170.589c-24.742 0-44.8 20.058-44.8 44.8v501.041l-70.865-56.691-29.319 36.649 471.659 377.326z",
    glyphName: "home_48",
    unicode: "\\uEAEE"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M533.505 882.613c-11.687 9.349-28.293 9.349-39.98 0L38.407 518.518l39.98-49.976 59.039 47.231V104.377c0-53.018 42.98-96 96-96h560.206c53.024 0 96 42.982 96 96v411.372l59.008-47.206 39.981 49.976zm292.127-315.664V104.377c0-17.67-14.323-32-32-32H233.426c-17.673 0-32 14.33-32 32v462.596l312.088 249.671z",
    glyphName: "home_outline_16",
    unicode: "\\uEAEF"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M298.667 448.01c0-47.128-38.205-85.333-85.334-85.333S128 400.882 128 448.01s38.205 85.334 85.333 85.334 85.334-38.205 85.334-85.334m298.666 0c0-47.128-38.205-85.333-85.333-85.333s-85.333 38.205-85.333 85.333 38.205 85.334 85.333 85.334 85.333-38.205 85.333-85.334m213.336-85.333c47.123 0 85.331 38.205 85.331 85.333s-38.208 85.334-85.331 85.334c-47.13 0-85.338-38.205-85.338-85.334s38.208-85.333 85.338-85.333",
    glyphName: "more_horizontal_16",
    unicode: "\\uEAF0"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M511.99 661.333c-47.128 0-85.334 38.205-85.334 85.334S464.861 832 511.99 832c47.128 0 85.333-38.205 85.333-85.333s-38.205-85.334-85.333-85.334m0-298.666c-47.128 0-85.334 38.205-85.334 85.333s38.205 85.333 85.334 85.333c47.128 0 85.333-38.205 85.333-85.333s-38.205-85.333-85.333-85.333m-85.334-213.336c0-47.123 38.205-85.331 85.334-85.331s85.333 38.208 85.333 85.331c0 47.13-38.205 85.338-85.333 85.338s-85.334-38.208-85.334-85.338",
    glyphName: "more_vertical_16",
    unicode: "\\uEAF1"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M418.909 277.333c-3.6 0-7.054 1.498-9.599 4.166s-3.977 6.284-3.977 10.057v312.887c0 2.472.614 4.901 1.783 7.048s2.852 3.937 4.882 5.195c2.031 1.259 4.339 1.94 6.699 1.979s4.687-.567 6.754-1.759l271.514-156.444c2.13-1.227 3.907-3.031 5.144-5.223s1.89-4.692 1.89-7.239-.653-5.047-1.89-7.239-3.014-3.996-5.144-5.223L425.451 279.094a13.1 13.1 0 0 0-6.543-1.76zM512 106.667c-188.513 0-341.333 152.82-341.333 341.333S323.487 789.333 512 789.333 853.333 636.513 853.333 448 700.513 106.667 512 106.667m0-85.334c235.641 0 426.667 191.025 426.667 426.667S747.642 874.667 512 874.667 85.333 683.642 85.333 448 276.358 21.333 512 21.333",
    glyphName: "playcircle_12",
    unicode: "\\uEAF2"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M418.909 277.333c-3.6 0-7.054 1.496-9.6 4.164s-3.976 6.286-3.976 10.058v312.888c0 2.472.614 4.9 1.783 7.047s2.851 3.938 4.882 5.196 4.339 1.94 6.698 1.979 4.687-.568 6.754-1.758l271.518-156.444a13.93 13.93 0 0 0 5.143-5.224c1.234-2.192 1.889-4.692 1.889-7.239s-.654-5.047-1.889-7.239a13.93 13.93 0 0 0-5.143-5.224L425.45 279.09a13.15 13.15 0 0 0-6.542-1.758zM512 95.289c-194.797 0-352.711 157.912-352.711 352.711 0 194.797 157.914 352.711 352.711 352.711 194.799 0 352.711-157.914 352.711-352.711 0-194.799-157.912-352.711-352.711-352.711m0-73.956c235.639 0 426.667 191.027 426.667 426.667 0 235.642-191.027 426.667-426.667 426.667-235.642 0-426.667-191.025-426.667-426.667C85.333 212.361 276.358 21.333 512 21.333",
    glyphName: "playcircle_18",
    unicode: "\\uEAF3"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M418.909 277.333c-3.601 0-7.054 1.498-9.6 4.164s-3.976 6.285-3.976 10.057v312.889c0 2.472.614 4.901 1.783 7.048s2.851 3.937 4.882 5.196 4.339 1.94 6.698 1.978 4.687-.567 6.754-1.759l271.513-156.443a13.9 13.9 0 0 0 5.146-5.222c1.237-2.193 1.89-4.693 1.89-7.241s-.653-5.047-1.89-7.241a13.9 13.9 0 0 0-5.146-5.222L425.45 279.095a13.1 13.1 0 0 0-6.542-1.762zM512 76.8c-205.008 0-371.2 166.191-371.2 371.2S306.992 819.2 512 819.2c205.009 0 371.2-166.192 371.2-371.2S717.009 76.8 512 76.8m0-55.467c235.639 0 426.667 191.027 426.667 426.667 0 235.642-191.027 426.667-426.667 426.667-235.642 0-426.667-191.025-426.667-426.667C85.333 212.361 276.358 21.333 512 21.333",
    glyphName: "playcircle_24",
    unicode: "\\uEAF4"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M418.91 277.333c-3.601 0-7.055 1.498-9.6 4.166-2.547 2.667-3.977 6.285-3.977 10.057v312.887c0 2.47.614 4.9 1.783 7.046a13.94 13.94 0 0 0 4.883 5.197c2.029 1.257 4.339 1.939 6.697 1.978s4.687-.567 6.754-1.758l271.516-156.444a13.9 13.9 0 0 0 5.143-5.225c1.237-2.191 1.89-4.691 1.89-7.238s-.653-5.047-1.89-7.238a13.9 13.9 0 0 0-5.143-5.225L425.45 279.092a13.1 13.1 0 0 0-6.541-1.76zM512 74.667c-206.187 0-373.333 167.147-373.333 373.333S305.814 821.333 512 821.333 885.333 654.186 885.333 448 718.186 74.667 512 74.667m0-53.334c235.642 0 426.667 191.025 426.667 426.667S747.642 874.667 512 874.667 85.333 683.642 85.333 448 276.358 21.333 512 21.333",
    glyphName: "playcircle_48",
    unicode: "\\uEAF5"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M156.444 116.173v135.026c0 4.528 1.798 8.869 4.999 12.066l389.61 389.614 159.164-159.163-389.612-389.609a17.06 17.06 0 0 0-12.068-5.001H173.511c-9.426 0-17.067 7.64-17.067 17.067M762.51 546.01l90.049 90.052c11.11 11.108 11.11 29.118 0 40.226L733.627 795.224c-11.11 11.109-29.121 11.109-40.226 0l-90.055-90.052z",
    glyphName: "write_18",
    unicode: "\\uEAF6"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M138.667 92.339v140.497a21.34 21.34 0 0 0 6.249 15.087l422.142 422.139 170.667-170.666-422.142-422.14a21.33 21.33 0 0 0-15.085-6.251H160.001c-11.782 0-21.333 9.553-21.333 21.333zm638.276 446.278 99.554 99.553c16.661 16.662 16.661 43.677 0 60.34L766.17 808.837c-16.661 16.662-43.678 16.662-60.339 0l-99.554-99.553z",
    glyphName: "write_24",
    unicode: "\\uEAF7"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M149.333 99.441v140.653c0 4.527 1.798 8.866 4.999 12.068L565.12 662.948l164.787-164.787L319.121 87.373a17.07 17.07 0 0 0-12.068-4.998H166.4c-9.426 0-17.067 7.642-17.067 17.067zm613.76 431.906 105.158 105.158c12.497 12.497 12.497 32.759 0 45.254L748.718 801.293c-12.497 12.497-32.757 12.497-45.254 0L598.306 696.135z",
    glyphName: "write_48",
    unicode: "\\uEAF8"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "m290.437 187.244 352.021 352.02-34.438 34.438L256 221.682v-34.438zm412.361 412.36 45.216 45.216-34.438 34.437-45.216-45.216zM170.667 251.726c0 3.395 1.348 6.65 3.749 9.05l521.059 521.059c9.998 9.998 26.207 9.998 36.204 0l118.913-118.913c9.995-9.998 9.995-26.207 0-36.204L329.533 105.66a12.8 12.8 0 0 0-9.05-3.746H183.468c-7.069 0-12.8 5.728-12.8 12.797v137.015z",
    glyphName: "write_outline_12",
    unicode: "\\uEAF9"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M156.444 251.199c0 4.528 1.798 8.869 4.999 12.066l531.958 531.959c11.105 11.109 29.116 11.109 40.226 0l118.932-118.936c11.11-11.108 11.11-29.118 0-40.226L320.605 104.107a17.06 17.06 0 0 0-12.068-5.001H173.511c-9.426 0-17.067 7.64-17.067 17.067zm128.53-78.137 369.988 369.99-54.574 54.574L230.4 227.636v-54.574zM707.26 595.346l60.826 60.829-54.574 54.574-60.826-60.829z",
    glyphName: "write_outline_18",
    unicode: "\\uEAFA"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M286.358 126.473h-92.225v92.224l412.143 412.145 92.224-92.225zm451.366 451.365L645.5 670.063l90.5 90.502 92.224-92.225zM138.667 232.836V92.339c0-11.78 9.551-21.333 21.333-21.333h140.497a21.33 21.33 0 0 1 15.085 6.251L876.497 638.17c16.661 16.662 16.661 43.677 0 60.34L766.17 808.837c-16.661 16.662-43.678 16.662-60.339 0L144.916 247.924a21.34 21.34 0 0 1-6.249-15.087z",
    glyphName: "write_outline_24",
    unicode: "\\uEAFB"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M196.267 129.308h98.415l529.824 529.826-98.413 98.414-529.826-529.825zm-46.934-29.867v140.653c0 4.527 1.798 8.866 4.999 12.068l549.133 549.132c12.497 12.497 32.757 12.497 45.254 0L868.252 681.76c12.497-12.495 12.497-32.757 0-45.254L319.121 87.373a17.07 17.07 0 0 0-12.068-4.998H166.4c-9.426 0-17.067 7.642-17.067 17.067zM709.495 518.95l-123.59 123.593 33.186 33.186 123.59-123.59z",
    glyphName: "write_outline_48",
    unicode: "\\uEAFC"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M725.333 362.667H298.666L511.999 576z",
    glyphName: "triangleup_12",
    unicode: "\\uEAFD"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M725.333 362.667H298.666L511.999 576z",
    glyphName: "triangleup_18",
    unicode: "\\uEAFE"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M725.333 362.667H298.666L511.999 576z",
    glyphName: "triangleup_24",
    unicode: "\\uEAFF"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M298.667 533.333h426.667v-128H298.667z",
    glyphName: "unconverted_12",
    unicode: "\\uEB00"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M298.667 490.667h426.667v-85.333H298.667z",
    glyphName: "unconverted_18",
    unicode: "\\uEB01"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M128 778.656c0 35.347 28.654 64 64 64h640c35.347 0 64-28.653 64-64V102.848c0-23.962-25.37-39.424-46.669-28.435L541.34 233.28a63.98 63.98 0 0 1-58.68 0L174.67 74.413C153.372 63.424 128 78.887 128 102.848z",
    glyphName: "scrap_16",
    unicode: "\\uEB02"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M832 778.656V155.36L570.68 290.163a128.01 128.01 0 0 1-117.359 0L192.001 155.36v623.296h640zm-640 64c-35.346 0-64-28.653-64-64V102.848c0-23.962 25.372-39.424 46.67-28.435L482.66 233.28a63.98 63.98 0 0 0 58.68 0L849.331 74.413C870.63 63.424 896 78.887 896 102.848v675.808c0 35.347-28.653 64-64 64z",
    glyphName: "scrap_outline_16",
    unicode: "\\uEB03"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M775.283 508.349c0 166.964-135.348 302.316-302.312 302.316S170.655 675.314 170.655 508.349s135.351-302.314 302.316-302.314 302.312 135.35 302.312 302.314M694.81 216.826c-61.567-46.925-138.449-74.79-221.838-74.79-202.31 0-366.316 164.006-366.316 366.314 0 202.31 164.005 366.316 366.316 366.316 202.312 0 366.312-164.005 366.312-366.316 0-95.857-36.813-183.116-97.082-248.4L959.591 42.561 914.33-2.693z",
    glyphName: "search_16",
    unicode: "\\uEB04"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M298.667 490.667h426.667v-85.333H298.667z",
    glyphName: "unconverted_24",
    unicode: "\\uEB05"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M981.333 448c0-259.206-210.127-469.333-469.333-469.333S42.667 188.794 42.667 448 252.794 917.333 512 917.333 981.333 707.206 981.333 448m-455.78 120.283c32.784 0 62.41-13.05 84.151-34.363l77.658 79.217c-41.638 40.817-98.829 66.079-161.81 66.079-127.662 0-231.153-103.491-231.153-231.153S397.89 216.91 525.552 216.91c62.981 0 120.172 25.261 161.81 66.08l-77.658 79.217c-21.741-21.314-51.367-34.364-84.151-34.364-66.395 0-120.219 53.824-120.219 120.22s53.824 120.219 120.219 120.219z",
    glyphName: "cash_12",
    unicode: "\\uEB06"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M967.111 448C967.111 196.648 763.352-7.111 512-7.111S56.889 196.648 56.889 448c0 251.351 203.76 455.111 455.111 455.111S967.111 699.351 967.111 448M512 638.578c51.954 0 98.987-20.741 133.404-54.476l51.769 52.812C649.5 683.653 584.084 712.534 512 712.534c-146.097 0-264.533-118.436-264.533-264.533S365.903 183.468 512 183.468c72.084 0 137.5 28.882 185.173 75.622l-51.769 52.81c-34.418-33.735-81.451-54.477-133.404-54.477-105.253 0-190.578 85.322-190.578 190.578 0 105.253 85.325 190.578 190.578 190.578z",
    glyphName: "cash_18",
    unicode: "\\uEB07"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M512 0C264.576 0 64 200.576 64 448s200.576 448 448 448 448-200.576 448-448S759.424 0 512 0M315.738 448.017c0 108.395 87.872 196.266 196.267 196.266 53.5 0 101.956-21.37 137.387-56.103l38.827 39.609c-45.376 44.485-107.614 71.961-176.213 71.961-139.028 0-251.733-112.705-251.733-251.733s112.705-251.733 251.733-251.733c68.599 0 130.837 27.477 176.213 71.962l-38.827 39.607c-35.43-34.731-83.887-56.102-137.387-56.102-108.395 0-196.267 87.872-196.267 196.267z",
    glyphName: "cash_24",
    unicode: "\\uEB08"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M938.667 448c0-235.642-191.025-426.667-426.667-426.667S85.333 212.358 85.333 448 276.358 874.667 512 874.667 938.667 683.642 938.667 448M512 637.867c51.755 0 98.635-20.676 132.907-54.274l32.853 33.515c-42.688 41.85-101.229 67.693-165.76 67.693-130.782 0-236.8-106.018-236.8-236.8s106.018-236.8 236.8-236.8c64.531 0 123.072 25.843 165.76 67.693l-32.853 33.515c-34.272-33.598-81.152-54.274-132.907-54.274-104.86 0-189.867 85.007-189.867 189.867S407.14 637.869 512 637.869z",
    glyphName: "cash_48",
    unicode: "\\uEB09"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M512 89.6c-197.939 0-358.4 160.461-358.4 358.4S314.061 806.4 512 806.4 870.4 645.939 870.4 448 709.939 89.6 512 89.6m0-110.933c259.206 0 469.333 210.127 469.333 469.333S771.206 917.333 512 917.333 42.667 707.206 42.667 448 252.794-21.333 512-21.333m13.553 589.616c-66.395 0-120.219-53.824-120.219-120.219s53.824-120.22 120.219-120.22c32.784 0 62.41 13.05 84.151 34.364l77.658-79.217c-41.638-40.818-98.829-66.08-161.81-66.08-127.662 0-231.153 103.491-231.153 231.153S397.89 679.217 525.552 679.217c62.981 0 120.172-25.261 161.81-66.079l-77.658-79.217c-21.741 21.313-51.367 34.363-84.151 34.363z",
    glyphName: "cash_outline_12",
    unicode: "\\uEB0A"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M512 66.844c-210.507 0-381.156 170.65-381.156 381.156S301.493 829.156 512 829.156c210.506 0 381.156-170.649 381.156-381.156S722.506 66.844 512 66.844m0-73.955c251.352 0 455.111 203.759 455.111 455.111S763.352 903.111 512 903.111c-251.351 0-455.111-203.76-455.111-455.111S260.649-7.111 512-7.111m0 645.689c-105.253 0-190.578-85.325-190.578-190.578 0-105.256 85.325-190.578 190.578-190.578 51.954 0 98.987 20.742 133.404 54.477l51.769-52.81C649.5 212.349 584.084 183.467 512 183.467c-146.097 0-264.533 118.437-264.533 264.533S365.903 712.533 512 712.533c72.084 0 137.5-28.881 185.173-75.62l-51.769-52.812c-34.418 33.736-81.451 54.476-133.404 54.476z",
    glyphName: "cash_outline_18",
    unicode: "\\uEB0B"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M512 55.467c-216.79 0-392.533 175.744-392.533 392.533S295.21 840.533 512 840.533c216.789 0 392.533-175.743 392.533-392.533S728.789 55.467 512 55.467M512 0c247.424 0 448 200.576 448 448S759.424 896 512 896 64 695.424 64 448 264.576 0 512 0m0 644.267c-108.395 0-196.267-87.872-196.267-196.267S403.605 251.733 512 251.733c53.5 0 101.956 21.372 137.387 56.102l38.827-39.607c-45.376-44.484-107.614-71.962-176.213-71.962-139.028 0-251.733 112.704-251.733 251.733s112.705 251.733 251.733 251.733c68.599 0 130.837-27.476 176.213-71.961l-38.827-39.609C613.957 622.894 565.5 644.265 512 644.265z",
    glyphName: "cash_outline_24",
    unicode: "\\uEB0C"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M512 68.267c-209.722 0-379.733 170.012-379.733 379.733S302.279 827.733 512 827.733c209.722 0 379.733-170.012 379.733-379.733S721.721 68.267 512 68.267m0-46.934c235.642 0 426.667 191.025 426.667 426.667S747.642 874.667 512 874.667 85.333 683.642 85.333 448 276.358 21.333 512 21.333m0 616.534c-104.86 0-189.867-85.007-189.867-189.867S407.14 258.133 512 258.133c51.755 0 98.635 20.676 132.907 54.274l32.853-33.515c-42.688-41.85-101.229-67.693-165.76-67.693-130.782 0-236.8 106.018-236.8 236.8s106.018 236.8 236.8 236.8c64.531 0 123.072-25.843 165.76-67.693l-32.853-33.515c-34.272 33.598-81.152 54.274-132.907 54.274z",
    glyphName: "cash_outline_48",
    unicode: "\\uEB0D"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M85.333 832.889c0 23.073 18.704 41.777 41.777 41.777h584.889c23.073 0 41.777-18.704 41.777-41.777V248c0-23.073-18.704-41.777-41.777-41.777H127.11c-23.073 0-41.777 18.704-41.777 41.777zm853.334-171.556V64c0-23.561-19.106-42.667-42.667-42.667H298.667v85.333h554.667v554.667z",
    glyphName: "stackedimages_12",
    unicode: "\\uEB0E"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M128 790.222C128 813.296 146.704 832 169.778 832h584.887c23.074 0 41.779-18.704 41.779-41.778V205.335c0-23.074-18.705-41.779-41.779-41.779H169.778c-23.074 0-41.778 18.705-41.778 41.779zm804.978-128.889V64c0-20.423-16.555-36.978-36.978-36.978H298.667v73.956h560.356v560.356h73.956z",
    glyphName: "stackedimages_18",
    unicode: "\\uEB0F"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M128 789.333C128 812.897 147.103 832 170.667 832H768c23.565 0 42.667-19.103 42.667-42.667V192c0-23.565-19.102-42.667-42.667-42.667H170.667C147.103 149.333 128 168.435 128 192zm795.733-128V64c0-15.317-12.416-27.733-27.733-27.733H298.667v55.467h569.6v569.6h55.467z",
    glyphName: "stackedimages_24",
    unicode: "\\uEB10"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M128 789.333C128 812.897 147.103 832 170.667 832H768c23.565 0 42.667-19.103 42.667-42.667V192c0-23.565-19.102-42.667-42.667-42.667H170.667C147.103 149.333 128 168.435 128 192zm794.667-128V64c0-14.729-11.938-26.667-26.667-26.667H298.667v53.333h570.667v570.667z",
    glyphName: "stackedimages_48",
    unicode: "\\uEB11"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M170.667 789.333V291.556h497.777v497.777zm-43.556 85.334H712c23.073 0 41.777-18.704 41.777-41.777V248.001c0-23.073-18.704-41.777-41.777-41.777H127.111c-23.073 0-41.777 18.704-41.777 41.777V832.89c0 23.073 18.704 41.777 41.777 41.777m811.556-213.334V64c0-23.561-19.106-42.667-42.667-42.667H298.667v85.333h554.667v554.667z",
    glyphName: "stackedimages_outline_12",
    unicode: "\\uEB12"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M201.956 758.044h520.533V237.511H201.956zM169.778 832C146.704 832 128 813.296 128 790.222V205.335c0-23.074 18.704-41.779 41.778-41.779h584.887c23.074 0 41.779 18.705 41.779 41.779v584.887c0 23.074-18.705 41.778-41.779 41.778zm763.2-170.667V64c0-20.423-16.555-36.978-36.978-36.978H298.667v73.956h560.356v560.356h73.956z",
    glyphName: "stackedimages_outline_18",
    unicode: "\\uEB13"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M183.467 776.533H755.2V204.8H183.467zM170.667 832C147.103 832 128 812.897 128 789.333V192c0-23.565 19.103-42.667 42.667-42.667H768c23.565 0 42.667 19.102 42.667 42.667v597.333C810.667 812.897 791.565 832 768 832zm753.066-170.667V64c0-15.317-12.416-27.733-27.733-27.733H298.667v55.467h569.6v569.6h55.467z",
    glyphName: "stackedimages_outline_24",
    unicode: "\\uEB14"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M181.333 778.667h576v-576h-576zM170.667 832C147.103 832 128 812.897 128 789.333V192c0-23.565 19.103-42.667 42.667-42.667H768c23.565 0 42.667 19.102 42.667 42.667v597.333C810.667 812.897 791.565 832 768 832zm752-170.667V64c0-14.729-11.938-26.667-26.667-26.667H298.667v53.333h570.667v570.667z",
    glyphName: "stackedimages_outline_48",
    unicode: "\\uEB15"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M512-21.333c259.206 0 469.333 210.127 469.333 469.333S771.206 917.333 512 917.333 42.667 707.206 42.667 448 252.794-21.333 512-21.333M359.418 639.25l58.703-205.458 44.637 156.228c6.28 21.98 26.37 37.134 49.23 37.134s42.95-15.153 49.231-37.134l44.636-156.228 58.703 205.458 98.46-28.131-35.653-124.785h70.495v-102.4h-99.752l-43.022-150.578c-6.281-21.98-26.371-37.135-49.231-37.135s-42.95 15.154-49.23 37.135l-44.637 156.228-44.636-156.228c-6.281-21.98-26.371-37.135-49.231-37.135s-42.95 15.154-49.23 37.135l-43.023 150.578h-99.744v102.4h70.486l-35.652 124.785 98.459 28.131z",
    glyphName: "circle_won_12",
    unicode: "\\uEB16"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M512 32c229.754 0 416 186.246 416 416 0 229.75-186.246 416-416 416-229.75 0-416-186.25-416-416C96 218.246 282.25 32 512 32M348.189 644.063l68.712-240.494 58.163 203.571c4.71 16.485 19.778 27.851 36.923 27.851s32.212-11.366 36.922-27.851l58.163-203.571 68.71 240.494 73.85-21.099-37.312-130.589h75.782v-76.8h-97.728l-46.381-162.333c-4.708-16.486-19.776-27.853-36.921-27.853s-32.212 11.366-36.922 27.853l-58.163 203.571-58.163-203.571c-4.71-16.486-19.778-27.853-36.923-27.853s-32.212 11.366-36.922 27.853l-46.381 162.333h-97.722v76.8h75.78l-37.311 130.589 73.845 21.099z",
    glyphName: "circle_won_16",
    unicode: "\\uEB17"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M512-7.111c251.352 0 455.111 203.759 455.111 455.111S763.352 903.111 512 903.111c-251.351 0-455.111-203.76-455.111-455.111S260.649-7.111 512-7.111M329.332 656.222l78.629-275.203 68.47 239.648c4.536 15.874 19.045 26.819 35.555 26.819s31.02-10.945 35.555-26.819l68.469-239.648 78.632 275.203 71.111-20.317-41.279-144.461h84.554v-73.956H703.346l-51.78-181.229c-4.534-15.872-19.046-26.817-35.556-26.817s-31.016 10.945-35.556 26.817l-68.468 239.648-68.47-239.648c-4.535-15.872-19.045-26.817-35.555-26.817s-31.019 10.945-35.555 26.817l-51.779 181.229H214.945v73.956h84.552l-41.275 144.461z",
    glyphName: "circle_won_18",
    unicode: "\\uEB18"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M512 0c247.424 0 448 200.576 448 448S759.424 896 512 896 64 695.424 64 448 264.576 0 512 0M326.228 642.292l83.353-291.734 75.735 265.068a27.73 27.73 0 0 0 26.667 20.114 27.73 27.73 0 0 0 26.662-20.114l75.738-265.068 83.349 291.734 53.333-15.238-41.408-144.929h86.101v-55.467H693.81l-52.766-184.67a27.725 27.725 0 0 0-26.662-20.113 27.73 27.73 0 0 0-26.667 20.113l-75.733 265.067-75.738-265.067c-3.401-11.908-14.282-20.113-26.664-20.113s-23.265 8.205-26.667 20.113l-52.763 184.67H228.29v55.467h86.012l-41.408 144.929 53.332 15.238z",
    glyphName: "circle_won_24",
    unicode: "\\uEB19"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M160 480h704v-64H160z",
    glyphName: "subtract_16",
    unicode: "\\uEB1A"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M160 496h704v-96H160z",
    glyphName: "subtract_thick_16",
    unicode: "\\uEB1B"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "m409.598 335.01-20.087 70.306h40.175l-20.087-70.306zm102.4 187.559 20.092-70.319h-40.183l20.092 70.319zm102.4-187.559-20.087 70.306h40.175zM512 21.333c235.642 0 426.667 191.025 426.667 426.667S747.642 874.667 512 874.667 85.333 683.642 85.333 448 276.358 21.333 512 21.333M323.315 637.001 376.1 452.25h66.995l46.338 162.187a23.467 23.467 0 0 0 45.128 0l46.338-162.187h66.995l52.785 184.751 45.129-12.894-49.103-171.857h94.758v-46.933H683.297l-46.336-162.174a23.467 23.467 0 0 0-45.128 0l-46.334 162.174h-67.002l-46.336-162.174a23.467 23.467 0 0 0-45.128 0l-46.334 162.174H232.53v46.933h94.758l-49.103 171.857 45.129 12.894z",
    glyphName: "circle_won_48",
    unicode: "\\uEB1C"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M298.667 789.333c-23.565 0-42.667-19.103-42.667-42.667V149.333c0-23.565 19.102-42.667 42.667-42.667h106.667c23.565 0 42.667 19.102 42.667 42.667v597.333c0 23.564-19.102 42.667-42.667 42.667zm320 0c-23.565 0-42.667-19.103-42.667-42.667V149.333c0-23.565 19.102-42.667 42.667-42.667h106.667c23.565 0 42.667 19.102 42.667 42.667v597.333c0 23.564-19.102 42.667-42.667 42.667z",
    glyphName: "pause_48",
    unicode: "\\uEB1D"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M298.667 789.333c-23.564 0-42.667-19.103-42.667-42.667V149.333c0-23.565 19.103-42.667 42.667-42.667h106.667c23.565 0 42.667 19.102 42.667 42.667v597.333c0 23.564-19.102 42.667-42.667 42.667zm320 0c-23.565 0-42.667-19.103-42.667-42.667V149.333c0-23.565 19.102-42.667 42.667-42.667h106.667c23.565 0 42.667 19.102 42.667 42.667v597.333c0 23.564-19.102 42.667-42.667 42.667z",
    glyphName: "pause_24",
    unicode: "\\uEB1E"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M298.667 789.333c-23.564 0-42.667-19.103-42.667-42.667V149.333c0-23.563 19.103-42.667 42.667-42.667h106.667c23.564 0 42.667 19.103 42.667 42.667v597.333c0 23.564-19.103 42.667-42.667 42.667zm320 0c-23.563 0-42.667-19.103-42.667-42.667V149.333c0-23.563 19.103-42.667 42.667-42.667h106.667c23.563 0 42.667 19.103 42.667 42.667v597.333c0 23.564-19.103 42.667-42.667 42.667z",
    glyphName: "pause_18",
    unicode: "\\uEB1F"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M298.667 789.333c-23.564 0-42.667-19.103-42.667-42.667V149.333c0-23.564 19.103-42.667 42.667-42.667h106.667c23.564 0 42.667 19.103 42.667 42.667v597.333c0 23.564-19.103 42.667-42.667 42.667zm320 0c-23.564 0-42.667-19.103-42.667-42.667V149.333c0-23.564 19.103-42.667 42.667-42.667h106.667c23.564 0 42.667 19.103 42.667 42.667v597.333c0 23.564-19.103 42.667-42.667 42.667z",
    glyphName: "pause_12",
    unicode: "\\uEB20"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M722.701 768.216c2.906 11.418 12.183 21.117 23.966 21.117h192c23.565 0 42.667-19.103 42.667-42.667V149.333c0-23.565-19.102-42.667-42.667-42.667h-192c-11.782 0-21.06 9.7-23.966 21.118-9.397 36.913-42.861 64.215-82.701 64.215s-73.303-27.302-82.701-64.215c-2.906-11.418-12.183-21.118-23.966-21.118H281.6v682.667h251.733c11.782 0 21.06-9.7 23.966-21.117C566.696 731.303 600.16 704 640 704s73.303 27.302 82.701 64.216m-488.034 21.117H85.334c-23.564 0-42.667-19.103-42.667-42.667V149.333c0-23.565 19.103-42.667 42.667-42.667h149.333z",
    glyphName: "coupon_48",
    unicode: "\\uEB21"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M787.807 704c-29.489-50.991-84.57-85.333-147.807-85.333S521.683 653.009 492.193 704H128V192h364.193c29.489 50.991 84.57 85.333 147.807 85.333S758.317 242.991 787.807 192H896v512zM722.7 768.216c2.907 11.418 12.185 21.117 23.967 21.117h192c23.561 0 42.667-19.103 42.667-42.667V149.333c0-23.564-19.106-42.667-42.667-42.667h-192c-11.782 0-21.059 9.7-23.967 21.117-9.398 36.914-42.86 64.216-82.7 64.216s-73.302-27.302-82.7-64.216c-2.907-11.418-12.185-21.117-23.967-21.117h-448c-23.564 0-42.667 19.103-42.667 42.667v597.333c0 23.564 19.103 42.667 42.667 42.667h448c11.782 0 21.059-9.7 23.967-21.117C566.698 731.302 600.16 704 640 704s73.302 27.302 82.7 64.216M256 789.333h85.333V106.666H256z",
    glyphName: "coupon_outline_12",
    unicode: "\\uEB22"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M781.09 715.378c-26.624-50.71-79.753-85.333-141.09-85.333s-114.464 34.624-141.092 85.333H116.622V180.622h382.286c26.628 50.711 79.754 85.333 141.092 85.333s114.466-34.623 141.09-85.333h126.288v534.756zm-58.391 52.838c2.907 11.418 12.186 21.118 23.967 21.118h192c23.563 0 42.667-19.103 42.667-42.667V149.334c0-23.563-19.103-42.667-42.667-42.667h-192c-11.782 0-21.06 9.7-23.967 21.117C713.301 164.699 679.839 192 640 192s-73.302-27.301-82.701-64.216c-2.906-11.418-12.184-21.117-23.966-21.117h-448c-23.564 0-42.667 19.103-42.667 42.667v597.333c0 23.564 19.103 42.667 42.667 42.667h448c11.782 0 21.06-9.7 23.966-21.118C566.697 731.302 600.16 704 640 704s73.301 27.302 82.699 64.216m-495.143 21.117h73.956V106.666h-73.956z",
    glyphName: "coupon_outline_18",
    unicode: "\\uEB23"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M769.434 733.867c-21.525-50.163-71.317-85.333-129.434-85.333s-107.908 35.171-129.434 85.333H98.133V162.134h412.433c21.525 50.163 71.317 85.333 129.434 85.333s107.908-35.17 129.434-85.333h156.433v571.733zm-46.733 34.349c2.906 11.418 12.186 21.117 23.966 21.117h192c23.565 0 42.667-19.103 42.667-42.667V149.333c0-23.565-19.102-42.667-42.667-42.667h-192c-11.78 0-21.06 9.698-23.966 21.116C713.302 164.697 679.838 192 640 192s-73.301-27.302-82.701-64.218c-2.906-11.418-12.186-21.116-23.966-21.116h-448c-23.564 0-42.667 19.102-42.667 42.667v597.333c0 23.564 19.103 42.667 42.667 42.667h448c11.78 0 21.06-9.699 23.966-21.117C566.698 731.302 600.162 704 640 704s73.301 27.302 82.701 64.216M256 789.333h55.467V106.666H256z",
    glyphName: "coupon_outline_24",
    unicode: "\\uEB24"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M768.021 736c-20.894-50.091-70.289-85.333-128.021-85.333S532.873 685.91 511.979 736H96V160h415.979c20.894 50.091 70.289 85.333 128.021 85.333S747.127 210.09 768.021 160H928v576zm-45.32 32.216c2.906 11.418 12.183 21.117 23.966 21.117h192c23.565 0 42.667-19.103 42.667-42.667V149.333c0-23.565-19.102-42.667-42.667-42.667h-192c-11.782 0-21.06 9.7-23.966 21.118-9.397 36.913-42.861 64.215-82.701 64.215s-73.303-27.302-82.701-64.215c-2.906-11.418-12.183-21.118-23.966-21.118h-448c-23.564 0-42.667 19.102-42.667 42.667v597.333c0 23.564 19.103 42.667 42.667 42.667h448c11.782 0 21.06-9.7 23.966-21.117C566.696 731.303 600.16 704 640 704s73.303 27.302 82.701 64.216m-488.034 21.117H281.6V106.666h-46.933z",
    glyphName: "coupon_outline_48",
    unicode: "\\uEB25"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M731.43 635.117c-48.474 0-87.77 39.296-87.77 87.77s39.296 87.771 87.77 87.771 87.771-39.297 87.771-87.771-39.297-87.77-87.771-87.77m0-76.799c90.889 0 164.57 73.68 164.57 164.57s-73.681 164.571-164.57 164.571-164.57-73.68-164.57-164.571c0-24.756 5.466-48.236 15.258-69.297l-158.874-86.659c-30.079 39.226-77.423 64.517-130.673 64.517-90.89 0-164.57-73.681-164.57-164.57s73.68-164.57 164.57-164.57c41.254 0 78.963 15.18 107.846 40.259l181.701-98.964c-9.792-21.062-15.258-44.541-15.258-69.297 0-90.891 73.681-164.568 164.57-164.568S896 83.416 896 174.307c0 90.889-73.681 164.57-164.57 164.57-37.899 0-72.806-12.811-100.626-34.338L445.335 405.554c7.615 18.953 11.806 39.65 11.806 61.326 0 10.109-.912 20.006-2.657 29.612l176.313 96.172c27.822-21.53 62.731-34.343 100.633-34.343zM292.57 379.106c-48.474 0-87.771 39.297-87.771 87.771s39.297 87.77 87.771 87.77 87.77-39.296 87.77-87.77-39.296-87.771-87.77-87.771m526.631-204.802c0-48.474-39.297-87.768-87.771-87.768s-87.77 39.293-87.77 87.768c0 48.474 39.296 87.77 87.77 87.77s87.771-39.296 87.771-87.77",
    glyphName: "share_12",
    unicode: "\\uEF01"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M741.344 630.409c-61.856 0-112 50.143-112 111.999s50.144 111.999 112 111.999 112-50.144 112-111.999-50.144-111.999-112-111.999m0-64c97.197 0 176 78.797 176 175.999s-78.803 175.999-176 175.999c-97.203 0-176-78.797-176-175.999 0-29.704 7.359-57.69 20.353-82.234l-168.573-91.948c-31.729 46.143-84.893 76.399-145.125 76.399C174.798 644.625 96 565.828 96 468.626s78.797-175.999 175.999-175.999c47.615 0 90.813 18.906 122.497 49.626l191.192-104.289c-12.988-24.538-20.343-52.518-20.343-82.214 0-97.203 78.797-176 176-176 97.197 0 176 78.797 176 176s-78.803 175.999-176 175.999c-44.058 0-84.339-16.191-115.21-42.943L431.812 394.8c10.388 22.451 16.186 47.461 16.186 73.825 0 14.092-1.656 27.795-4.784 40.929l182.937 99.784c30.867-26.746 71.142-42.93 115.194-42.93zM271.999 356.627C210.144 356.627 160 406.771 160 468.626s50.143 111.999 111.999 111.999 111.999-50.144 111.999-111.999-50.143-111.999-111.999-111.999M853.344 155.75c0-61.856-50.144-112-112-112s-112 50.144-112 112 50.144 112 112 112 112-50.144 112-112",
    glyphName: "share_16",
    unicode: "\\uEF02"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M739.556 635.733c53.413 0 96.711 43.299 96.711 96.711s-43.298 96.711-96.711 96.711-96.711-43.299-96.711-96.711 43.298-96.711 96.711-96.711m0-73.955c-40.425 0-77.562 14.053-106.803 37.54l-180.956-98.704a171.5 171.5 0 0 0 3.315-33.641c0-23.454-4.731-45.803-13.291-66.145l190.932-104.146c29.241 23.489 66.378 37.541 106.803 37.541 94.259 0 170.667-76.407 170.667-170.667S833.816-7.111 739.556-7.111c-94.259 0-170.667 76.407-170.667 170.667 0 26.681 6.121 51.934 17.038 74.428l-186.44 101.695 1.352 2.475c-30.489-28.444-71.409-45.847-116.395-45.847-94.256 0-170.667 76.407-170.667 170.667 0 94.256 76.41 170.667 170.667 170.667 56.256 0 106.155-27.218 137.246-69.205l164.237 89.585c-10.917 22.493-17.038 47.744-17.038 74.425 0 94.256 76.407 170.667 170.667 170.667s170.667-76.41 170.667-170.667c0-94.256-76.407-170.667-170.667-170.667zM284.444 370.261c53.412 0 96.711 43.299 96.711 96.711s-43.299 96.711-96.711 96.711-96.711-43.299-96.711-96.711 43.299-96.711 96.711-96.711m551.823-206.705c0 53.413-43.298 96.711-96.711 96.711s-96.711-43.298-96.711-96.711 43.298-96.711 96.711-96.711 96.711 43.298 96.711 96.711",
    glyphName: "share_18",
    unicode: "\\uEF03"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M745.604 620.8c-66.569 0-120.533 53.964-120.533 120.533s53.965 120.533 120.533 120.533c66.569 0 120.533-53.965 120.533-120.533S812.172 620.8 745.604 620.8m0-55.467c97.203 0 176 78.798 176 176s-78.797 176-176 176-176-78.798-176-176c0-31.224 8.132-60.549 22.391-85.973l-168.218-91.755c-31.408 48.138-85.742 79.955-147.507 79.955-97.202 0-176-78.798-176-176.002 0-97.199 78.798-176 176-176 49.213 0 93.708 20.198 125.648 52.757l190.077-103.676c-14.259-25.425-22.391-54.75-22.391-85.973 0-97.203 78.797-176 176-176s176 78.797 176 176-78.797 176-176 176c-45.683 0-87.305-17.408-118.588-45.948L434.239 389.87c11.546 23.428 18.031 49.801 18.031 77.687 0 15.629-2.035 30.784-5.862 45.21l180.608 98.513c31.283-28.542 72.905-45.948 118.588-45.948zM276.271 347.025c-66.569 0-120.533 53.965-120.533 120.533 0 66.57 53.964 120.535 120.533 120.535s120.533-53.964 120.533-120.535c0-66.569-53.965-120.533-120.533-120.533m589.867-192.358c0-66.569-53.965-120.533-120.533-120.533S625.072 88.099 625.072 154.667c0 66.569 53.965 120.533 120.533 120.533s120.533-53.965 120.533-120.533",
    glyphName: "share_24",
    unicode: "\\uEF04"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M749.724 613.028c-72.544 0-131.354 58.81-131.354 131.354 0 72.543 58.81 131.351 131.354 131.351s131.351-58.809 131.351-131.351c0-72.544-58.807-131.354-131.351-131.354m0-46.933c98.464 0 178.285 79.821 178.285 178.287 0 98.464-79.821 178.285-178.285 178.285s-178.287-79.821-178.287-178.285c0-33.286 9.122-64.444 25.003-91.104l-170.249-92.864c-31.383 50.946-87.678 84.909-151.906 84.909C175.821 645.323 96 565.502 96 467.038c0-98.466 79.821-178.287 178.285-178.287 51.586 0 98.054 21.909 130.609 56.928l191.554-104.484c-15.885-26.665-25.011-57.824-25.011-91.117 0-98.464 79.823-178.285 178.287-178.285s178.285 79.821 178.285 178.285c0 98.466-79.821 178.287-178.285 178.287-48.021 0-91.61-18.987-123.665-49.86l-193.841 105.73c12.998 24.742 20.354 52.913 20.354 82.803 0 17.491-2.519 34.396-7.215 50.37l180.691 98.558c32.058-30.88 75.648-49.871 123.676-49.871M274.285 335.684c-72.543 0-131.351 58.81-131.351 131.354s58.809 131.351 131.351 131.351c72.544 0 131.354-58.807 131.354-131.351s-58.81-131.354-131.354-131.354m606.79-185.606c0-72.542-58.807-131.351-131.351-131.351S618.37 77.537 618.37 150.078c0 72.544 58.81 131.354 131.354 131.354s131.351-58.81 131.351-131.354",
    glyphName: "share_48",
    unicode: "\\uEF05"
  })))));
};


//# sourceMappingURL=foundation.js.map


/***/ }),

/***/ 65081:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "e": function() { return /* binding */ useIsInApp; },
/* harmony export */   "g": function() { return /* binding */ useMatchMedia; },
/* harmony export */   "h": function() { return /* binding */ useMedia; },
/* harmony export */   "i": function() { return /* binding */ useNodeSizeObserver; },
/* harmony export */   "j": function() { return /* binding */ useResize; },
/* harmony export */   "l": function() { return /* binding */ useKakaoChat; },
/* harmony export */   "m": function() { return /* binding */ useResponsive; },
/* harmony export */   "u": function() { return /* binding */ useAutoComplete; }
/* harmony export */ });
/* unused harmony exports a, b, c, d, f, k */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(75271);
/* harmony import */ var _common_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(68479);
/* harmony import */ var qs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(93672);
/* harmony import */ var qs__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(qs__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(32699);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _bucketplace_lib__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(94834);
/* harmony import */ var _utils_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(85353);
/* harmony import */ var _foundation_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(54939);








var HANGUL_INITIAL = 'rRseEfaqQtTdwWczxvg'.split('');
var HANGUL_MEDIAL = 'k,o,i,O,j,p,u,P,h,hk,ho,hl,y,n,nj,np,nl,b,m,ml,l'.split(',');
var HANGUL_FINAL = (',r,R,rt,s,sw,sg,e,f,fr,fa,fq,ft,fx,fv,fg,a,q,qt,t,T,' + 'd,w,c,z,x,v,g').split(',');
var HANGUL_JAMO = (',r,R,rt,s,sw,sg,e,E,f,fr,fa,fq,ft,fx,fv,fg,a,q,Q,qt,t,' + 'T,d,w,W,c,z,x,v,g,k,o,i,O,j,p,u,P,h,hk,ho,hl,y,n,nj,np,nl,b,m,ml,l').split(',');
function decomposeHangul(input) {
  return input.split('').map(function (char) {
    var code = char.charCodeAt(0);
    if (code >= 0xAC00 && code <= 0xD7A3) {
      // Decompose hangul to dubeolsik characters.
      code -= 0xAC00;
      var final = HANGUL_FINAL[code % HANGUL_FINAL.length];
      code = code / HANGUL_FINAL.length | 0;
      var medial = HANGUL_MEDIAL[code % HANGUL_MEDIAL.length];
      code = code / HANGUL_MEDIAL.length | 0;
      var initial = HANGUL_INITIAL[code % HANGUL_INITIAL.length];
      return [initial, medial, final].join('');
    } else if (code >= 0x3130 && code <= 0x3163) {
      return HANGUL_JAMO[code - 0x3130];
    }
    return char;
  }).join('');
}

/**
 * Determines if the given value has changed.
 * @param {any} value The value to compare against.
 * @param {function} isEqual The checking mechanism. Defaults to shallow equal.
 * @return {boolean} Whether if the value has changed.
 */
function useChanged(value, isEqual) {
  if (isEqual === void 0) {
    isEqual = function isEqual(a, b) {
      return a === b;
    };
  }
  var prevValueRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)();
  if (prevValueRef.current == null) {
    prevValueRef.current = {
      value: value
    };
    return false;
  }
  var prevValue = prevValueRef.current.value;
  var changed = !isEqual(prevValue, value);
  prevValueRef.current.value = value;
  return changed;
}

function useFocused() {
  var _a = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false),
    isFocused = _a[0],
    setFocused = _a[1];
  var wasClicked = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(false);
  var handleFocus = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function () {
    setFocused(true);
  }, []);
  var handleClick = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function () {
    wasClicked.current = true;
  }, []);
  var handleKeyDown = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function (e) {
    if (e.keyCode === 9) {
      // Tab
      setFocused(false);
    }
  }, []);
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    if (isFocused) {
      var handleClickCapture_1 = function handleClickCapture_1() {
        wasClicked.current = false;
      };
      var handleClick_1 = function handleClick_1() {
        if (!wasClicked.current) {
          setFocused(false);
        }
      };
      window.addEventListener('click', handleClick_1);
      window.addEventListener('click', handleClickCapture_1, true);
      return function () {
        window.removeEventListener('click', handleClick_1);
        window.removeEventListener('click', handleClickCapture_1, true);
      };
    }
  }, [isFocused]);
  return [isFocused, setFocused, {
    handleFocus: handleFocus,
    handleClick: handleClick,
    handleKeyDown: handleKeyDown
  }];
}

function canInferQuery(query, oldQuery) {
  if (query == null || oldQuery == null) {
    return false;
  }
  var queryDecompsed = decomposeHangul(query);
  var oldQueryDecomposed = decomposeHangul(oldQuery);
  return queryDecompsed.startsWith(oldQueryDecomposed);
}
// Creates simple query cache for useAutoCompleteFetch.
function createCachedFetch(onFetch, shouldCache) {
  var cache = {};
  return function (query) {
    var queryDecomposed = query == null ? '' : decomposeHangul(query);
    if (cache[queryDecomposed] != null) {
      return Promise.resolve(cache[queryDecomposed]);
    }
    return onFetch(query).then(function (value) {
      if (shouldCache != null && !shouldCache(query)) {
        return value;
      }
      cache[queryDecomposed] = value;
      return value;
    });
  };
}
function useAutoCompleteFetch(pageKey, query, isEnabled, onFetch, isValueEmpty) {
  var hasDisabledRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(false);
  var pendingRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(false);
  var _a = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(function () {
      return {
        pageKey: null,
        query: null,
        value: null
      };
    }),
    data = _a[0],
    setData = _a[1];
  var handleSetData = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function (data) {
    return setData(function (prev) {
      return {
        pageKey: prev.pageKey,
        query: prev.query,
        value: typeof data === 'function' ? data(prev.value) : data
      };
    });
  }, []);
  var shouldLoad = isEnabled && (data == null || pageKey !== data.pageKey || query !== data.query || hasDisabledRef.current);
  // If the query completely extends previous query and previous query was
  // empty, the query would be empty too - don't fetch if that's the case.
  if (shouldLoad && !hasDisabledRef.current && data != null && data.value != null && pageKey === data.pageKey && canInferQuery(query, data.query) && isValueEmpty != null) {
    shouldLoad = !isValueEmpty(data.value);
  }
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    if (shouldLoad) {
      if (pendingRef.current) {
        return;
      }
      (function () {
        return (0,_common_js__WEBPACK_IMPORTED_MODULE_3__.c)(this, void 0, void 0, function () {
          var result, e_1;
          return (0,_common_js__WEBPACK_IMPORTED_MODULE_3__.d)(this, function (_a) {
            switch (_a.label) {
              case 0:
                pendingRef.current = true;
                _a.label = 1;
              case 1:
                _a.trys.push([1, 3,, 4]);
                return [4 /*yield*/, onFetch(query)];
              case 2:
                result = _a.sent();
                setData({
                  pageKey: pageKey,
                  query: query,
                  value: result
                });
                hasDisabledRef.current = false;
                pendingRef.current = false;
                return [3 /*break*/, 4];
              case 3:
                e_1 = _a.sent();
                hasDisabledRef.current = false;
                pendingRef.current = false;
                throw e_1;
              case 4:
                return [2 /*return*/];
            }
          });
        });
      })();
    }
  }, [pageKey, query, data, isEnabled, onFetch, shouldLoad]);
  if (!isEnabled) {
    hasDisabledRef.current = true;
    return [null, handleSetData];
  }
  if (data == null || pageKey !== data.pageKey) {
    return [null, handleSetData];
  }
  // Otherwise, return the current value.
  return [data.value, handleSetData];
}

function useAutoComplete(inputRef, options) {
  var pageKey = options.pageKey,
    isAlwaysFocused = options.isAlwaysFocused,
    onFetch = options.onFetch,
    getItemQuery = options.getItemQuery,
    inputQuery = options.query,
    _a = options.initialQuery,
    initialQuery = _a === void 0 ? null : _a,
    onFocus = options.onFocus,
    onSubmit = options.onSubmit,
    onSubmitItem = options.onSubmitItem;
  var _b = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(initialQuery),
    currentQuery = _b[0],
    setQuery = _b[1];
  var query = currentQuery == null ? inputQuery : currentQuery;
  var _c = useFocused(),
    isCurrentlyFocused = _c[0],
    setFocused = _c[1],
    focusCallbacks = _c[2];
  var _d = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false),
    isOpened = _d[0],
    setOpened = _d[1];
  var ignoreMouseUntilRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(0);
  var isFocused = isAlwaysFocused || isCurrentlyFocused;
  var _e = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)({
      selected: -1,
      hovered: -1
    }),
    currentIndex = _e[0],
    setIndex = _e[1];
  var setSelectedIndex = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function (index) {
    setIndex(function (prev) {
      var nextIndex = typeof index === 'function' ? index(prev.hovered) : index;
      return {
        selected: nextIndex,
        hovered: nextIndex
      };
    });
  }, []);
  var setHoveredIndex = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function (index) {
    if (Date.now() > ignoreMouseUntilRef.current) {
      setIndex(function (prev) {
        return {
          selected: prev.selected,
          hovered: index
        };
      });
    }
  }, []);
  var handleSubmit = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function (value) {
    if (value == null || value.trim() === '') {
      // Do nothing if value is empty
      return;
    }
    if (inputRef.current != null) {
      inputRef.current.blur();
    }
    setFocused(false);
    setOpened(false);
    onSubmit(value);
  }, [onSubmit, inputRef, setFocused]);
  var handleSubmitItem = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function (item, index) {
    if (inputRef.current != null) {
      inputRef.current.blur();
    }
    setFocused(false);
    setOpened(false);
    onSubmitItem(item, index);
  }, [onSubmitItem, inputRef, setFocused]);
  var handleReset = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function () {
    setQuery(null);
  }, []);
  var data = useAutoCompleteFetch(pageKey, query, isFocused, onFetch)[0];
  var maxIndex = data == null ? 0 : data.length;
  var shownQuery = currentIndex.selected >= 0 && isOpened && data != null && data[currentIndex.selected] != null ? getItemQuery(data[currentIndex.selected]) : query;
  var handleInputChange = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function (value) {
    setFocused(true);
    setQuery(value);
    setSelectedIndex(-1);
  }, [setQuery, setSelectedIndex, setFocused]);
  if (isOpened && !isFocused) {
    setOpened(false);
  }
  var hasDataChanged = useChanged(data);
  if (hasDataChanged && maxIndex > 0) {
    setTimeout(function () {
      ignoreMouseUntilRef.current = Date.now() + 100;
      setSelectedIndex(-1);
      setOpened(true);
    });
  }
  var hasPageChanged = useChanged(pageKey);
  if (hasPageChanged) {
    setQuery(null);
  }
  var handleInputKeyDown = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function (e) {
    focusCallbacks.handleKeyDown(e);
    switch (e.keyCode) {
      case 27:
        // ESC
        setOpened(false);
        break;
      case 13:
        // Return
        if (data != null && currentIndex.hovered >= 0) {
          handleSubmitItem(data[currentIndex.hovered], currentIndex.hovered);
        } else {
          handleSubmit(shownQuery);
        }
        e.preventDefault();
        break;
      case 9:
        // Tab
        // Commit current shownQuery
        if (query !== shownQuery) {
          setQuery(shownQuery);
        }
        break;
      case 38:
        // Up arrow
        e.preventDefault();
        ignoreMouseUntilRef.current = Date.now() + 100;
        if (isOpened) {
          setSelectedIndex(function (prev) {
            return prev <= -1 ? maxIndex - 1 : prev - 1;
          });
        } else if (maxIndex > 0) {
          setOpened(true);
          setSelectedIndex(maxIndex - 1);
        }
        break;
      case 40:
        // Down arrow
        e.preventDefault();
        ignoreMouseUntilRef.current = Date.now() + 100;
        if (isOpened) {
          setSelectedIndex(function (prev) {
            return prev >= maxIndex - 1 ? 0 : prev + 1;
          });
        } else if (maxIndex > 0) {
          setOpened(true);
          setSelectedIndex(0);
        }
        break;
      case 37:
        // Left arrow
        setQuery(shownQuery);
        setSelectedIndex(-1);
        break;
      case 39:
        // Right arrow
        setQuery(shownQuery);
        setSelectedIndex(-1);
        break;
    }
  }, [maxIndex, data, isOpened, query, shownQuery, currentIndex.hovered, handleSubmit, handleSubmitItem, focusCallbacks, setSelectedIndex]);
  var handleListMouseEnter = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function (_, i) {
    return setHoveredIndex(i);
  }, [setHoveredIndex]);
  var handleInputFocus = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function (e) {
    focusCallbacks.handleFocus(e);
    if (onFocus != null) {
      onFocus();
    }
  }, [focusCallbacks, onFocus]);
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    setQuery(initialQuery);
  }, [initialQuery]);
  return {
    isOpened: isOpened && maxIndex > 0,
    isFocused: isFocused,
    shownQuery: shownQuery,
    selectedIndex: currentIndex.selected,
    hoveredIndex: currentIndex.hovered,
    items: data || [],
    onInputFocus: handleInputFocus,
    onInputClick: focusCallbacks.handleClick,
    onInputKeyDown: handleInputKeyDown,
    onInputChange: handleInputChange,
    onListMouseEnter: handleListMouseEnter,
    onListClick: handleSubmitItem,
    onReset: handleReset
  };
}

function useForkRef() {
  var refs = [];
  for (var _i = 0; _i < arguments.length; _i++) {
    refs[_i] = arguments[_i];
  }
  return useCallback(function (v) {
    return refs.forEach(function (ref) {
      if (typeof ref === 'function') {
        ref(v);
      } else if (ref != null) {
        ref.current = v;
      }
    });
  }, [refs]);
}

function isInApp(query) {
  if (typeof window === 'undefined') {
    if (query != null) {
      return query.os_type != null || query.app != null;
    }
    return false;
  }
  // NOTE: It's fine to use sessionStorage here because webview will always
  // try to set these parameters.
  var triggered = false;
  try {
    triggered = sessionStorage.webviewTriggered === 'yes';
  } catch (e) {
    //
  }
  var search = (0,qs__WEBPACK_IMPORTED_MODULE_4__.parse)(location.search.slice(1));
  var isExpertCenterAndroid = search.pro_app != null && search.os_type === 'Android';
  if (!isExpertCenterAndroid && (triggered || search.os_type != null && search.os_type !== '' || search.app != null)) {
    try {
      sessionStorage.webviewTriggered = 'yes';
    } catch (e) {
      //
    }
    return true;
  }
  return false;
}
function useIsInApp(location) {
  var _a = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(function () {
      return (0,qs__WEBPACK_IMPORTED_MODULE_4__.parse)(location.search.slice(1)).app != null;
    }),
    inApp = _a[0],
    setInApp = _a[1];
  var useIsomorphicLayoutEffect = typeof window !== 'undefined' ? react__WEBPACK_IMPORTED_MODULE_0__.useLayoutEffect : react__WEBPACK_IMPORTED_MODULE_0__.useEffect;
  useIsomorphicLayoutEffect(function () {
    setInApp(isInApp());
  }, []);
  return inApp;
}

/**
 * 현재 브라우저가 IE 인지를 체크합니다.
 * @param {boolean} [UseIEDetectorOptions] 체크 옵션
 * @param {boolean} [UseIEDetectorOptions.includeEdge] 엣지 포함 여부
 * @return {boolean} IE 체크 결과
 */
function useIEDetector(_a) {
  var _b = _a === void 0 ? {} : _a,
    _c = _b.includeEdge,
    includeEdge = _c === void 0 ? false : _c;
  var _d = useState(false),
    isIE = _d[0],
    setIE = _d[1];
  useEffect(function () {
    var ua = window.navigator.userAgent;
    var isIE = /MSIE|Trident\//i.test(ua);
    var isEdge = /Edge\//i.test(ua);
    setIE(isIE || includeEdge && isEdge);
  }, [includeEdge]);
  return isIE;
}

function useMatchMedia(query, options) {
  var _a = options || {},
    fallback = _a.fallback,
    populateOnInitialRender = _a.populateOnInitialRender;
  var _b = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(function () {
      if (!populateOnInitialRender || typeof window === 'undefined') {
        return fallback != null ? fallback : undefined;
      }
      var mediaInstance = window.matchMedia(query);
      return mediaInstance.matches;
    }),
    matches = _b[0],
    setMatches = _b[1];
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    var mediaInstance = window.matchMedia(query);
    var handleChange = function handleChange() {
      return setMatches(mediaInstance.matches);
    };
    mediaInstance.addListener(handleChange);
    setMatches(mediaInstance.matches);
    return function () {
      mediaInstance.removeListener(handleChange);
    };
  }, [query]);
  return {
    matches: matches
  };
}

function useMedia(mediaQuery, initialValue) {
  if (initialValue === void 0) {
    initialValue = false;
  }
  var _a = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(initialValue),
    isMatched = _a[0],
    setMatched = _a[1];
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    var queryList = window.matchMedia(mediaQuery);
    var handleChange = function handleChange() {
      setMatched(queryList.matches);
    };
    handleChange();
    queryList.addListener(handleChange);
    return function () {
      queryList.removeListener(handleChange);
    };
  }, [mediaQuery]);
  return isMatched;
}

function useResize(ref, handleResize) {
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    var targetNode = ref.current;
    var resizeObserver = null;
    if (window.ResizeObserver != null && targetNode != null) {
      resizeObserver = new ResizeObserver(handleResize);
      resizeObserver.observe(targetNode);
    } else {
      window.addEventListener('resize', handleResize);
    }
    return function () {
      if (resizeObserver != null) {
        resizeObserver.disconnect();
      } else {
        window.removeEventListener('resize', handleResize);
      }
    };
  }, [ref, handleResize]);
}

function useNodeSizeObserver(callback, deps) {
  if (deps === void 0) {
    deps = [];
  }
  var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
  var triggerCallback = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function () {
    if (!ref.current) return;
    callback({
      width: ref.current.clientWidth,
      height: ref.current.clientHeight
    });
  }, [callback]);
  var setRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function (element) {
    ref.current = element;
    triggerCallback();
  }, [triggerCallback]);
  var handleResize = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(function () {
    return (0,lodash__WEBPACK_IMPORTED_MODULE_1__.debounce)(triggerCallback, 500);
  }, [triggerCallback]);
  useResize(ref, handleResize);
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    triggerCallback();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, (0,_common_js__WEBPACK_IMPORTED_MODULE_3__.b)([triggerCallback], deps, true));
  return setRef;
}

/**
 * OS 타입이 Windows 인지 체크합니다.
 */
function useWindowsOSDetector() {
  var _a = useState(false),
    isWindowsOS = _a[0],
    setWindowsOS = _a[1];
  useEffect(function () {
    var ua = window.navigator.userAgent;
    var isWindowsOS = /'Win32|Win64|Windows|Windows NT|WinCE/gi.test(ua);
    setWindowsOS(isWindowsOS);
  }, []);
  return isWindowsOS;
}

var bizchannelUUID = '@오늘의집_고객센터';
var bizChannelURL = "https://bizmessage.kakao.com/chat/open/".concat(bizchannelUUID);
var channelPublicId = '_TsNUK';
var channelUrl = "https://pf.kakao.com/".concat(channelPublicId, "/chat");
/**
 * iOS 8.34보다 낮은 버전의 app / 그외 를 구분하여 기기에 따른 알맞은 카카오톡 상담하기 채팅창을 엽니다.
 * @param query
 * @returns 카카오톡 상담하기 채팅창을 여는 함수
 */
var useKakaoChat = function useKakaoChat(query) {
  var isApp = (0,_utils_js__WEBPACK_IMPORTED_MODULE_5__.g)(query).isApp;
  var openKakaoChat = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function () {
    if (!isApp || (0,_utils_js__WEBPACK_IMPORTED_MODULE_5__.i)({
      AOS: '0',
      iOS: '8.34',
      query: query
    })) {
      try {
        var popup = (0,_bucketplace_lib__WEBPACK_IMPORTED_MODULE_2__/* .openPopup */ .Mw)({
          url: bizChannelURL,
          popupOption: 'width=1024, height=800'
        });
        if (!popup) {
          window.location.href = bizChannelURL;
        }
      } catch (_a) {
        window.location.href = bizChannelURL;
      }
    } else {
      window.location.href = channelUrl;
    }
  }, [query, isApp]);
  return {
    openKakaoChat: openKakaoChat
  };
};

var BREAKPOINTS = [['desktop', _foundation_js__WEBPACK_IMPORTED_MODULE_6__.B.desktop], ['laptop', _foundation_js__WEBPACK_IMPORTED_MODULE_6__.B.laptop], ['tablet', _foundation_js__WEBPACK_IMPORTED_MODULE_6__.B.tablet], ['mobile', _foundation_js__WEBPACK_IMPORTED_MODULE_6__.B.mobile]];
/**
 * Returns the current breakpoint of the viewport. (mobile, tablet, laptop)
 */
function useResponsive(options) {
  var _a = options !== null && options !== void 0 ? options : {},
    fallbackBreakpoint = _a.fallbackBreakpoint,
    populateOnInitialRender = _a.populateOnInitialRender,
    preventSyncOnInitialRender = _a.preventSyncOnInitialRender;
  var _b = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(function () {
      if (!populateOnInitialRender) {
        return undefined;
      }
      if (typeof window === 'undefined') {
        return fallbackBreakpoint || undefined;
      }
      var matchingBreakpoint = BREAKPOINTS.find(function (_a) {
        var minWidth = _a[1];
        return window.matchMedia("(min-width: ".concat(minWidth, "px)")).matches;
      });
      return matchingBreakpoint != null ? matchingBreakpoint[0] : fallbackBreakpoint || undefined;
    }),
    breakpoint = _b[0],
    setBreakpoint = _b[1];
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    var mediaRefs = BREAKPOINTS.map(function (_a) {
      var breakpoint = _a[0],
        minWidth = _a[1];
      return [breakpoint, window.matchMedia("(min-width: ".concat(minWidth, "px)"))];
    });
    function update() {
      var hasMatch = false;
      for (var _i = 0, mediaRefs_2 = mediaRefs; _i < mediaRefs_2.length; _i++) {
        var _a = mediaRefs_2[_i],
          breakpoint_1 = _a[0],
          media = _a[1];
        if (!hasMatch && media.matches) {
          setBreakpoint(breakpoint_1);
          hasMatch = true;
        }
      }
    }
    for (var _i = 0, mediaRefs_1 = mediaRefs; _i < mediaRefs_1.length; _i++) {
      var _a = mediaRefs_1[_i],
        media = _a[1];
      media.addListener(update);
    }
    if (!preventSyncOnInitialRender) {
      update();
    }
    return function () {
      for (var _i = 0, mediaRefs_3 = mediaRefs; _i < mediaRefs_3.length; _i++) {
        var _a = mediaRefs_3[_i],
          media = _a[1];
        media.removeListener(update);
      }
    };
  }, [preventSyncOnInitialRender]);
  return {
    breakpoint: breakpoint
  };
}


//# sourceMappingURL=hooks.js.map


/***/ }),

/***/ 62471:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A": function() { return /* binding */ AlertFilledIcon; },
/* harmony export */   "I": function() { return /* binding */ InfoIcon; },
/* harmony export */   "T": function() { return /* binding */ DismissIcon; },
/* harmony export */   "U": function() { return /* binding */ DismissCircleIcon; },
/* harmony export */   "aH": function() { return /* binding */ SignOutIcon; },
/* harmony export */   "aQ": function() { return /* binding */ StarFilledIcon; },
/* harmony export */   "ah": function() { return /* binding */ MenuFoldIcon; },
/* harmony export */   "ai": function() { return /* binding */ MenuOpenIcon; },
/* harmony export */   "ax": function() { return /* binding */ ScrapFilledIcon; },
/* harmony export */   "b8": function() { return /* binding */ HandlerIcon; }
/* harmony export */ });
/* unused harmony exports $, B, C, D, E, F, G, H, J, K, L, M, N, O, P, Q, R, S, V, W, X, Y, Z, _, a, a$, a0, a1, a2, a3, a4, a5, a6, a7, a8, a9, aA, aB, aC, aD, aE, aF, aG, aI, aJ, aK, aL, aM, aN, aO, aP, aR, aS, aT, aU, aV, aW, aX, aY, aZ, a_, aa, ab, ac, ad, ae, af, ag, aj, ak, al, am, an, ao, ap, aq, ar, as, at, au, av, aw, ay, az, b, b0, b1, b2, b3, b4, b5, b6, b7, c, d, e, f, g, h, i, j, k, l, m, n, o, p, q, r, s, t, u, v, w, x, y, z */
/* harmony import */ var _common_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(68479);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(83128);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(75271);
/* harmony import */ var _emotion_styled_base__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(12851);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(57834);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(52814);






var BaseIconTemplate = function BaseIconTemplate(_a) {
  var icons = _a.icons,
    size = _a.size,
    fill = _a.fill,
    rest = (0,_common_js__WEBPACK_IMPORTED_MODULE_2__.e)(_a, ["icons", "size", "fill"]);
  var Icon = icons[size];
  var theme = (0,_emotion_react__WEBPACK_IMPORTED_MODULE_3__.u)();
  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(Icon, (0,_common_js__WEBPACK_IMPORTED_MODULE_2__.a)({}, rest, {
    css: [fill && /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_5__/* .css */ .iv)(templateObject_1 || (templateObject_1 = (0,_common_js__WEBPACK_IMPORTED_MODULE_2__._)(["color: ", ";" + ( true ? "" : 0)], ["color: ", ";" + ( true ? "" : 0)])), fill(theme))]
  }));
};
var IconTemplate = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(BaseIconTemplate,  true ? {
  target: "ey1aqhe0"
} : 0)(templateObject_2 || (templateObject_2 = (0,_common_js__WEBPACK_IMPORTED_MODULE_2__._)(["\n  *[fill] {\n    fill: currentColor;\n  }\n"], ["\n  *[fill] {\n    fill: currentColor;\n  }\n"])));
var templateObject_1, templateObject_2;

var _path$bG, _path2$3S;
function _extends$bV() { _extends$bV = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$bV.apply(this, arguments); }
var SvgInfo12 = function SvgInfo12(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends$bV({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none"
  }, props), _path$bG || (_path$bG = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: "#2F3438",
    d: "M5.4 7.9a.6.6 0 0 0 1.2 0v-2a.6.6 0 1 0-1.2 0zM5.4 4.3a.6.6 0 0 0 1.2 0v-.05a.6.6 0 1 0-1.2 0z"
  })), _path2$3S || (_path2$3S = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M11 6A5 5 0 1 1 1 6a5 5 0 0 1 10 0M9.8 6a3.8 3.8 0 1 1-7.6 0 3.8 3.8 0 0 1 7.6 0",
    clipRule: "evenodd"
  })));
};
var Info12 = SvgInfo12;

var _path$bF, _path2$3R;
function _extends$bU() { _extends$bU = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$bU.apply(this, arguments); }
var SvgInfo16 = function SvgInfo16(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends$bU({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path$bF || (_path$bF = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: "#2F3438",
    d: "M8 6.45a.75.75 0 0 1-.75-.75v-.067a.75.75 0 0 1 1.5 0V5.7a.75.75 0 0 1-.75.75M7.25 10.5a.75.75 0 0 0 1.5 0V7.7a.75.75 0 0 0-1.5 0z"
  })), _path2$3R || (_path2$3R = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M8 14.667A6.667 6.667 0 1 0 8 1.334a6.667 6.667 0 0 0 0 13.333m0-1.5A5.167 5.167 0 1 0 8 2.833a5.167 5.167 0 0 0 0 10.334",
    clipRule: "evenodd"
  })));
};
var Info16 = SvgInfo16;

var _path$bE, _path2$3Q;
function _extends$bT() { _extends$bT = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$bT.apply(this, arguments); }
var SvgInfo18 = function SvgInfo18(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends$bT({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _path$bE || (_path$bE = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: "#2F3438",
    d: "M9 7.2a.8.8 0 0 1-.8-.8v-.075a.8.8 0 0 1 1.6 0V6.4a.8.8 0 0 1-.8.8M8.2 11.7a.8.8 0 0 0 1.6 0V8.55a.8.8 0 1 0-1.6 0z"
  })), _path2$3Q || (_path2$3Q = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M9 16.5a7.5 7.5 0 1 0 0-15 7.5 7.5 0 0 0 0 15m0-1.6A5.9 5.9 0 1 0 9 3.1a5.9 5.9 0 0 0 0 11.8",
    clipRule: "evenodd"
  })));
};
var Info18 = SvgInfo18;

var _path$bD, _path2$3P;
function _extends$bS() { _extends$bS = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$bS.apply(this, arguments); }
var SvgInfo24 = function SvgInfo24(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends$bS({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path$bD || (_path$bD = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: "#2F3438",
    d: "M12 9.7a.9.9 0 0 1-.9-.9v-.1a.9.9 0 1 1 1.8 0v.1a.9.9 0 0 1-.9.9M11.1 15.5a.9.9 0 1 0 1.8 0v-4.2a.9.9 0 1 0-1.8 0z"
  })), _path2$3P || (_path2$3P = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10m0-1.8a8.2 8.2 0 1 0 0-16.4 8.2 8.2 0 0 0 0 16.4",
    clipRule: "evenodd"
  })));
};
var Info24 = SvgInfo24;

var _path$bC, _path2$3O;
function _extends$bR() { _extends$bR = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$bR.apply(this, arguments); }
var SvgInfo32 = function SvgInfo32(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends$bR({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _path$bC || (_path$bC = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: "#2F3438",
    d: "M16 12.733a1 1 0 0 1-1-1V11.6a1 1 0 1 1 2 0v.133a1 1 0 0 1-1 1M15 20.5a1 1 0 1 0 2 0v-5.6a1 1 0 1 0-2 0z"
  })), _path2$3O || (_path2$3O = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M16 29.333c7.364 0 13.333-5.97 13.333-13.333S23.363 2.667 16 2.667 2.667 8.636 2.667 16 8.636 29.333 16 29.333m0-2c6.26 0 11.333-5.074 11.333-11.333S22.26 4.667 16 4.667 4.667 9.74 4.667 16 9.74 27.333 16 27.333",
    clipRule: "evenodd"
  })));
};
var Info32 = SvgInfo32;

var _path$bB, _path2$3N;
function _extends$bQ() { _extends$bQ = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$bQ.apply(this, arguments); }
var SvgInfo48 = function SvgInfo48(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends$bQ({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none"
  }, props), _path$bB || (_path$bB = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: "#2F3438",
    d: "M24 19a1.2 1.2 0 0 1-1.2-1.2v-.2a1.2 1.2 0 0 1 2.4 0v.2A1.2 1.2 0 0 1 24 19M22.8 30.4a1.2 1.2 0 0 0 2.4 0V22a1.2 1.2 0 0 0-2.4 0z"
  })), _path2$3N || (_path2$3N = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M24 44c11.045 0 20-8.954 20-20S35.045 4 24 4 4 12.954 4 24s8.954 20 20 20m0-2.4c9.72 0 17.6-7.88 17.6-17.6S33.72 6.4 24 6.4 6.4 14.28 6.4 24 14.28 41.6 24 41.6",
    clipRule: "evenodd"
  })));
};
var Info48 = SvgInfo48;

var InfoIcon = function InfoIcon(props) {
  var info = {
    12: Info12,
    16: Info16,
    18: Info18,
    24: Info24,
    32: Info32,
    48: Info48
  };
  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(IconTemplate, (0,_common_js__WEBPACK_IMPORTED_MODULE_2__.a)({
    icons: info
  }, props));
};

var _path$bA;
function _extends$bP() { _extends$bP = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$bP.apply(this, arguments); }
var SvgAlertFilled12 = function SvgAlertFilled12(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends$bP({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none"
  }, props), _path$bA || (_path$bA = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "m1.066 7.435 2.822-5.08C4.802.71 7.169.71 8.084 2.356l2.822 5.08c.888 1.6-.269 3.565-2.098 3.565H3.164c-1.83 0-2.986-1.966-2.098-3.565M6 4a.6.6 0 0 1 .6.6v2.1a.6.6 0 0 1-1.2 0V4.6A.6.6 0 0 1 6 4m0 3.8a.6.6 0 0 1 .6.6v.05a.6.6 0 1 1-1.2 0V8.4a.6.6 0 0 1 .6-.6",
    clipRule: "evenodd"
  })));
};
var AlertFilled12 = SvgAlertFilled12;

var _path$bz;
function _extends$bO() { _extends$bO = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$bO.apply(this, arguments); }
var SvgAlertFilled16 = function SvgAlertFilled16(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends$bO({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path$bz || (_path$bz = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M1.51 9.961 5.271 3.19c1.18-2.126 4.238-2.126 5.42 0l3.762 6.772c1.147 2.067-.347 4.606-2.71 4.606H4.219c-2.363 0-3.858-2.54-2.71-4.606M8 5.351a.75.75 0 0 1 .75.75v2.8a.75.75 0 0 1-1.5 0V6.1A.75.75 0 0 1 8 5.35m0 4.899a.75.75 0 0 1 .75.75v.067a.75.75 0 0 1-1.5 0V11a.75.75 0 0 1 .75-.75",
    clipRule: "evenodd"
  })));
};
var AlertFilled16 = SvgAlertFilled16;

var _path$by;
function _extends$bN() { _extends$bN = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$bN.apply(this, arguments); }
var SvgAlertFilled18 = function SvgAlertFilled18(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends$bN({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _path$by || (_path$by = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "m1.746 11.816 4.742-8.537c1.086-1.954 3.897-1.954 4.983 0l4.742 8.537c1.055 1.9-.318 4.234-2.491 4.234H4.237c-2.173 0-3.547-2.335-2.491-4.234M9 6a.8.8 0 0 1 .8.8v3.15a.8.8 0 0 1-1.6 0V6.8A.8.8 0 0 1 9 6m0 5.4a.8.8 0 0 1 .8.8v.075a.8.8 0 0 1-1.6 0V12.2a.8.8 0 0 1 .8-.8",
    clipRule: "evenodd"
  })));
};
var AlertFilled18 = SvgAlertFilled18;

var _path$bx;
function _extends$bM() { _extends$bM = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$bM.apply(this, arguments); }
var SvgAlertFilled24 = function SvgAlertFilled24(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends$bM({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path$bx || (_path$bx = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M2.657 15.16 8.301 5.002c1.6-2.88 5.742-2.88 7.342 0l5.644 10.158c1.555 2.8-.47 6.24-3.672 6.24H6.33c-3.203 0-5.227-3.44-3.672-6.24M12 8.8a.9.9 0 0 1 .9.9v4.2a.9.9 0 1 1-1.8 0V9.7a.9.9 0 0 1 .9-.9m0 6.7a.9.9 0 0 1 .9.9v.1a.9.9 0 1 1-1.8 0v-.1a.9.9 0 0 1 .9-.9",
    clipRule: "evenodd"
  })));
};
var AlertFilled24 = SvgAlertFilled24;

var _path$bw;
function _extends$bL() { _extends$bL = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$bL.apply(this, arguments); }
var SvgAlertFilled32 = function SvgAlertFilled32(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends$bL({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _path$bw || (_path$bw = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "m3.893 20.408 7.524-13.544c1.982-3.567 7.11-3.567 9.092 0l7.524 13.544c1.926 3.466-.58 7.725-4.546 7.725H8.439c-3.964 0-6.47-4.26-4.545-7.725M16 11.933a1 1 0 0 1 1 1v5.6a1 1 0 1 1-2 0v-5.6a1 1 0 0 1 1-1m0 8.934a1 1 0 0 1 1 1V22a1 1 0 1 1-2 0v-.133a1 1 0 0 1 1-1",
    clipRule: "evenodd"
  })));
};
var AlertFilled32 = SvgAlertFilled32;

var _path$bv;
function _extends$bK() { _extends$bK = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$bK.apply(this, arguments); }
var SvgAlertFilled48 = function SvgAlertFilled48(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends$bK({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none"
  }, props), _path$bv || (_path$bv = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M6.364 30.903 17.65 10.587c2.743-4.938 9.844-4.938 12.587 0l11.287 20.316c2.666 4.8-.804 10.697-6.294 10.697H12.658c-5.49 0-8.96-5.898-6.294-10.697M24 18.1a1.3 1.3 0 0 1 1.3 1.3v8.4a1.3 1.3 0 1 1-2.6 0v-8.4a1.3 1.3 0 0 1 1.3-1.3m0 13.4a1.3 1.3 0 0 1 1.3 1.3v.2a1.3 1.3 0 1 1-2.6 0v-.2a1.3 1.3 0 0 1 1.3-1.3",
    clipRule: "evenodd"
  })));
};
var AlertFilled48 = SvgAlertFilled48;

var AlertFilledIcon = function AlertFilledIcon(props) {
  var alertFilled = {
    12: AlertFilled12,
    16: AlertFilled16,
    18: AlertFilled18,
    24: AlertFilled24,
    32: AlertFilled32,
    48: AlertFilled48
  };
  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(IconTemplate, (0,_common_js__WEBPACK_IMPORTED_MODULE_2__.a)({
    icons: alertFilled
  }, props));
};

var _g$e, _defs$e;
function _extends$bJ() { _extends$bJ = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$bJ.apply(this, arguments); }
var SvgAdd12 = function SvgAdd12(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$bJ({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none"
  }, props), _g$e || (_g$e = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#add_12_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M6.6 1.5a.6.6 0 0 0-1.2 0v3.9H1.5a.6.6 0 0 0 0 1.2h3.9v3.9a.6.6 0 1 0 1.2 0V6.6h3.9a.6.6 0 1 0 0-1.2H6.6z"
  }))), _defs$e || (_defs$e = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "add_12_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h12v12H0z"
  })))));
};
var Add12 = (/* unused pure expression or super */ null && (SvgAdd12));

var _path$bu;
function _extends$bI() { _extends$bI = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$bI.apply(this, arguments); }
var SvgAdd16 = function SvgAdd16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$bI({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path$bu || (_path$bu = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M8.75 2a.75.75 0 0 0-1.5 0v5.25H2a.75.75 0 0 0 0 1.5h5.25V14a.75.75 0 0 0 1.5 0V8.75H14a.75.75 0 0 0 0-1.5H8.75z"
  })));
};
var Add16 = (/* unused pure expression or super */ null && (SvgAdd16));

var _path$bt;
function _extends$bH() { _extends$bH = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$bH.apply(this, arguments); }
var SvgAdd18 = function SvgAdd18(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$bH({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _path$bt || (_path$bt = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M9.8 2.25a.8.8 0 1 0-1.6 0V8.2H2.25a.8.8 0 0 0 0 1.6H8.2v5.95a.8.8 0 0 0 1.6 0V9.8h5.95a.8.8 0 0 0 0-1.6H9.8z"
  })));
};
var Add18 = (/* unused pure expression or super */ null && (SvgAdd18));

var _path$bs;
function _extends$bG() { _extends$bG = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$bG.apply(this, arguments); }
var SvgAdd24 = function SvgAdd24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$bG({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path$bs || (_path$bs = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M12.9 3a.9.9 0 1 0-1.8 0v8.1H3a.9.9 0 1 0 0 1.8h8.1V21a.9.9 0 0 0 1.8 0v-8.1H21a.9.9 0 0 0 0-1.8h-8.1z"
  })));
};
var Add24 = (/* unused pure expression or super */ null && (SvgAdd24));

var _path$br;
function _extends$bF() { _extends$bF = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$bF.apply(this, arguments); }
var SvgAdd32 = function SvgAdd32(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$bF({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _path$br || (_path$br = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M17 4a1 1 0 1 0-2 0v11H4a1 1 0 1 0 0 2h11v11a1 1 0 1 0 2 0V17h11a1 1 0 1 0 0-2H17z"
  })));
};
var Add32 = (/* unused pure expression or super */ null && (SvgAdd32));

var _path$bq;
function _extends$bE() { _extends$bE = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$bE.apply(this, arguments); }
var SvgAdd48 = function SvgAdd48(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$bE({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none"
  }, props), _path$bq || (_path$bq = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M25.2 6a1.2 1.2 0 1 0-2.4 0v16.8H6a1.2 1.2 0 0 0 0 2.4h16.8V42a1.2 1.2 0 0 0 2.4 0V25.2H42a1.2 1.2 0 1 0 0-2.4H25.2z"
  })));
};
var Add48 = (/* unused pure expression or super */ null && (SvgAdd48));

var AddIcon = function AddIcon(props) {
  var add = {
    12: Add12,
    16: Add16,
    18: Add18,
    24: Add24,
    32: Add32,
    48: Add48
  };
  return jsx(IconTemplate, _assign({
    icons: add
  }, props));
};

var _path$bp, _path2$3M, _path3$t;
function _extends$bD() { _extends$bD = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$bD.apply(this, arguments); }
var SvgAddCircle12 = function SvgAddCircle12(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$bD({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none"
  }, props), _path$bp || (_path$bp = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M2.2 6a3.8 3.8 0 1 0 7.6 0 3.8 3.8 0 0 0-7.6 0M6 1a5 5 0 1 0 0 10A5 5 0 0 0 6 1",
    clipRule: "evenodd"
  })), _path2$3M || (_path2$3M = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M6 3.8a.45.45 0 0 1 .45.45v3.5a.45.45 0 1 1-.9 0v-3.5A.45.45 0 0 1 6 3.8",
    clipRule: "evenodd"
  })), _path3$t || (_path3$t = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M8.2 6a.45.45 0 0 1-.45.45h-3.5a.45.45 0 1 1 0-.9h3.5A.45.45 0 0 1 8.2 6",
    clipRule: "evenodd"
  })));
};
var AddCircle12 = (/* unused pure expression or super */ null && (SvgAddCircle12));

var _path$bo, _path2$3L, _path3$s;
function _extends$bC() { _extends$bC = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$bC.apply(this, arguments); }
var SvgAddCircle16 = function SvgAddCircle16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$bC({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path$bo || (_path$bo = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M2.834 8a5.167 5.167 0 1 0 10.333 0A5.167 5.167 0 0 0 2.834 8M8 1.333a6.667 6.667 0 1 0 0 13.333A6.667 6.667 0 0 0 8 1.333",
    clipRule: "evenodd"
  })), _path2$3L || (_path2$3L = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M8 4.9a.6.6 0 0 1 .6.6v5a.6.6 0 0 1-1.2 0v-5a.6.6 0 0 1 .6-.6",
    clipRule: "evenodd"
  })), _path3$s || (_path3$s = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M11.1 8a.6.6 0 0 1-.6.6h-5a.6.6 0 0 1 0-1.2h5a.6.6 0 0 1 .6.6",
    clipRule: "evenodd"
  })));
};
var AddCircle16 = (/* unused pure expression or super */ null && (SvgAddCircle16));

var _path$bn, _path2$3K, _path3$r;
function _extends$bB() { _extends$bB = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$bB.apply(this, arguments); }
var SvgAddCircle18 = function SvgAddCircle18(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$bB({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _path$bn || (_path$bn = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M3.1 9a5.9 5.9 0 1 0 11.8 0A5.9 5.9 0 0 0 3.1 9M9 1.5a7.5 7.5 0 1 0 0 15 7.5 7.5 0 0 0 0-15",
    clipRule: "evenodd"
  })), _path2$3K || (_path2$3K = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M9 5.6a.65.65 0 0 1 .65.65v5.5a.65.65 0 1 1-1.3 0v-5.5A.65.65 0 0 1 9 5.6",
    clipRule: "evenodd"
  })), _path3$r || (_path3$r = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M12.4 9a.65.65 0 0 1-.65.65h-5.5a.65.65 0 0 1 0-1.3h5.5a.65.65 0 0 1 .65.65",
    clipRule: "evenodd"
  })));
};
var AddCircle18 = (/* unused pure expression or super */ null && (SvgAddCircle18));

var _path$bm, _path2$3J, _path3$q;
function _extends$bA() { _extends$bA = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$bA.apply(this, arguments); }
var SvgAddCircle24 = function SvgAddCircle24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$bA({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path$bm || (_path$bm = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M3.8 12a8.2 8.2 0 1 0 16.4 0 8.2 8.2 0 0 0-16.4 0M12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2",
    clipRule: "evenodd"
  })), _path2$3J || (_path2$3J = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M12 7.2a.8.8 0 0 1 .8.8v8a.8.8 0 0 1-1.6 0V8a.8.8 0 0 1 .8-.8",
    clipRule: "evenodd"
  })), _path3$q || (_path3$q = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M16.8 12a.8.8 0 0 1-.8.8H8a.8.8 0 0 1 0-1.6h8a.8.8 0 0 1 .8.8",
    clipRule: "evenodd"
  })));
};
var AddCircle24 = (/* unused pure expression or super */ null && (SvgAddCircle24));

var _path$bl, _path2$3I, _path3$p;
function _extends$bz() { _extends$bz = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$bz.apply(this, arguments); }
var SvgAddCircle32 = function SvgAddCircle32(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$bz({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _path$bl || (_path$bl = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M4.667 16c0 6.26 5.074 11.333 11.333 11.333S27.333 22.26 27.333 16 22.26 4.667 16 4.667 4.667 9.74 4.667 16M16 2.667C8.636 2.666 2.667 8.636 2.667 16S8.636 29.333 16 29.333 29.333 23.363 29.333 16 23.363 2.667 16 2.667",
    clipRule: "evenodd"
  })), _path2$3I || (_path2$3I = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M16 9.05a.95.95 0 0 1 .95.95v12a.95.95 0 0 1-1.9 0V10a.95.95 0 0 1 .95-.95",
    clipRule: "evenodd"
  })), _path3$p || (_path3$p = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M22.95 16a.95.95 0 0 1-.95.95H10a.95.95 0 1 1 0-1.9h12a.95.95 0 0 1 .95.95",
    clipRule: "evenodd"
  })));
};
var AddCircle32 = (/* unused pure expression or super */ null && (SvgAddCircle32));

var _path$bk, _path2$3H, _path3$o;
function _extends$by() { _extends$by = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$by.apply(this, arguments); }
var SvgAddCircle48 = function SvgAddCircle48(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$by({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none"
  }, props), _path$bk || (_path$bk = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M6.4 24c0 9.72 7.88 17.6 17.6 17.6S41.6 33.72 41.6 24 33.72 6.4 24 6.4 6.4 14.28 6.4 24M24 4C12.954 4 4 12.954 4 24s8.954 20 20 20 20-8.954 20-20S35.046 4 24 4",
    clipRule: "evenodd"
  })), _path2$3H || (_path2$3H = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M24 13.9a1.1 1.1 0 0 1 1.1 1.1v18a1.1 1.1 0 0 1-2.2 0V15a1.1 1.1 0 0 1 1.1-1.1",
    clipRule: "evenodd"
  })), _path3$o || (_path3$o = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M34.1 24a1.1 1.1 0 0 1-1.1 1.1H15a1.1 1.1 0 0 1 0-2.2h18a1.1 1.1 0 0 1 1.1 1.1",
    clipRule: "evenodd"
  })));
};
var AddCircle48 = (/* unused pure expression or super */ null && (SvgAddCircle48));

var AddCircleIcon = function AddCircleIcon(props) {
  var addCircle = {
    12: AddCircle12,
    16: AddCircle16,
    18: AddCircle18,
    24: AddCircle24,
    32: AddCircle32,
    48: AddCircle48
  };
  return jsx(IconTemplate, _assign({
    icons: addCircle
  }, props));
};

var _path$bj;
function _extends$bx() { _extends$bx = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$bx.apply(this, arguments); }
var SvgAddCircleFilled12 = function SvgAddCircleFilled12(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$bx({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none"
  }, props), _path$bj || (_path$bj = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M6 1a5 5 0 1 0 0 10A5 5 0 0 0 6 1m.45 3.25a.45.45 0 1 0-.9 0v1.3h-1.3a.45.45 0 1 0 0 .9h1.3v1.3a.45.45 0 1 0 .9 0v-1.3h1.3a.45.45 0 1 0 0-.9h-1.3z",
    clipRule: "evenodd"
  })));
};
var AddCircleFilled12 = (/* unused pure expression or super */ null && (SvgAddCircleFilled12));

var _path$bi;
function _extends$bw() { _extends$bw = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$bw.apply(this, arguments); }
var SvgAddCircleFilled16 = function SvgAddCircleFilled16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$bw({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path$bi || (_path$bi = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M8 1.333a6.667 6.667 0 1 0 0 13.333A6.667 6.667 0 0 0 8 1.333M8.6 5.5a.6.6 0 0 0-1.2 0v1.9H5.5a.6.6 0 0 0 0 1.2h1.9v1.9a.6.6 0 0 0 1.2 0V8.6h1.9a.6.6 0 1 0 0-1.2H8.6z",
    clipRule: "evenodd"
  })));
};
var AddCircleFilled16 = (/* unused pure expression or super */ null && (SvgAddCircleFilled16));

var _path$bh;
function _extends$bv() { _extends$bv = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$bv.apply(this, arguments); }
var SvgAddCircleFilled18 = function SvgAddCircleFilled18(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$bv({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _path$bh || (_path$bh = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M9 1.5a7.5 7.5 0 1 0 0 15 7.5 7.5 0 0 0 0-15m.65 4.75a.65.65 0 0 0-1.3 0v2.1h-2.1a.65.65 0 1 0 0 1.3h2.1v2.1a.65.65 0 1 0 1.3 0v-2.1h2.1a.65.65 0 1 0 0-1.3h-2.1z",
    clipRule: "evenodd"
  })));
};
var AddCircleFilled18 = (/* unused pure expression or super */ null && (SvgAddCircleFilled18));

var _path$bg;
function _extends$bu() { _extends$bu = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$bu.apply(this, arguments); }
var SvgAddCircleFilled24 = function SvgAddCircleFilled24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$bu({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path$bg || (_path$bg = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2m.8 6a.8.8 0 0 0-1.6 0v3.2H8a.8.8 0 1 0 0 1.6h3.2V16a.8.8 0 1 0 1.6 0v-3.2H16a.8.8 0 0 0 0-1.6h-3.2z",
    clipRule: "evenodd"
  })));
};
var AddCircleFilled24 = (/* unused pure expression or super */ null && (SvgAddCircleFilled24));

var _path$bf;
function _extends$bt() { _extends$bt = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$bt.apply(this, arguments); }
var SvgAddCircleFilled32 = function SvgAddCircleFilled32(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$bt({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _path$bf || (_path$bf = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M16 2.667C8.636 2.667 2.667 8.637 2.667 16S8.636 29.334 16 29.334 29.333 23.364 29.333 16 23.363 2.667 16 2.667M16.95 10a.95.95 0 0 0-1.9 0v5.05H10a.95.95 0 0 0 0 1.9h5.05V22a.95.95 0 0 0 1.9 0v-5.05H22a.95.95 0 1 0 0-1.9h-5.05z",
    clipRule: "evenodd"
  })));
};
var AddCircleFilled32 = (/* unused pure expression or super */ null && (SvgAddCircleFilled32));

var _path$be;
function _extends$bs() { _extends$bs = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$bs.apply(this, arguments); }
var SvgAddCircleFilled48 = function SvgAddCircleFilled48(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$bs({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none"
  }, props), _path$be || (_path$be = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M24 4C12.954 4 4 12.954 4 24s8.954 20 20 20 20-8.954 20-20S35.046 4 24 4m1.1 11a1.1 1.1 0 0 0-2.2 0v7.9H15a1.1 1.1 0 0 0 0 2.2h7.9V33a1.1 1.1 0 0 0 2.2 0v-7.9H33a1.1 1.1 0 0 0 0-2.2h-7.9z",
    clipRule: "evenodd"
  })));
};
var AddCircleFilled48 = (/* unused pure expression or super */ null && (SvgAddCircleFilled48));

var AddCircleFilledIcon = function AddCircleFilledIcon(props) {
  var addCircleFilled = {
    12: AddCircleFilled12,
    16: AddCircleFilled16,
    18: AddCircleFilled18,
    24: AddCircleFilled24,
    32: AddCircleFilled32,
    48: AddCircleFilled48
  };
  return jsx(IconTemplate, _assign({
    icons: addCircleFilled
  }, props));
};

var _path$bd, _path2$3G;
function _extends$br() { _extends$br = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$br.apply(this, arguments); }
var SvgAlert12 = function SvgAlert12(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$br({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none"
  }, props), _path$bd || (_path$bd = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M6 4a.6.6 0 0 1 .6.6v2.1a.6.6 0 0 1-1.2 0V4.6A.6.6 0 0 1 6 4M6 7.65a.6.6 0 0 1 .6.6v.05a.6.6 0 0 1-1.2 0v-.05a.6.6 0 0 1 .6-.6"
  })), _path2$3G || (_path2$3G = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M3.888 2.356 1.066 7.435C.178 9.035 1.334 11 3.164 11h5.644c1.83 0 2.986-1.966 2.098-3.565l-2.822-5.08C7.169.71 4.802.71 3.888 2.356M3.164 9.8a1.2 1.2 0 0 1-1.049-1.783l2.822-5.079a1.2 1.2 0 0 1 2.098 0l2.822 5.08A1.2 1.2 0 0 1 8.807 9.8z",
    clipRule: "evenodd"
  })));
};
var Alert12 = (/* unused pure expression or super */ null && (SvgAlert12));

var _path$bc, _path2$3F;
function _extends$bq() { _extends$bq = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$bq.apply(this, arguments); }
var SvgAlert16 = function SvgAlert16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$bq({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path$bc || (_path$bc = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M8 5.35a.75.75 0 0 1 .75.75v2.8a.75.75 0 0 1-1.5 0V6.1A.75.75 0 0 1 8 5.35M8 10.05a.75.75 0 0 1 .75.75v.067a.75.75 0 0 1-1.5 0V10.8a.75.75 0 0 1 .75-.75"
  })), _path2$3F || (_path2$3F = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M5.272 3.19 1.509 9.96c-1.148 2.066.347 4.606 2.71 4.606h7.525c2.363 0 3.858-2.54 2.71-4.606L10.69 3.19c-1.18-2.126-4.238-2.126-5.42 0m-2.451 7.5 3.762-6.772c.61-1.098 2.188-1.098 2.797 0l3.762 6.772a1.6 1.6 0 0 1-1.398 2.377H4.219a1.6 1.6 0 0 1-1.398-2.377",
    clipRule: "evenodd"
  })));
};
var Alert16 = (/* unused pure expression or super */ null && (SvgAlert16));

var _path$bb, _path2$3E;
function _extends$bp() { _extends$bp = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$bp.apply(this, arguments); }
var SvgAlert18 = function SvgAlert18(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$bp({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _path$bb || (_path$bb = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M9 6a.8.8 0 0 1 .8.8v3.15a.8.8 0 0 1-1.6 0V6.8A.8.8 0 0 1 9 6M9 11.2a.8.8 0 0 1 .8.8v.075a.8.8 0 0 1-1.6 0V12a.8.8 0 0 1 .8-.8"
  })), _path2$3E || (_path2$3E = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "m6.182 3.315-4.573 8.23C.425 13.68 1.967 16.3 4.407 16.3h9.145c2.44 0 3.982-2.621 2.797-4.754l-4.572-8.23c-1.22-2.195-4.376-2.195-5.595 0m4.196.777 4.572 8.23a1.6 1.6 0 0 1-1.398 2.378H4.407a1.6 1.6 0 0 1-1.399-2.377l4.573-8.23c.61-1.098 2.187-1.098 2.797 0",
    clipRule: "evenodd"
  })));
};
var Alert18 = (/* unused pure expression or super */ null && (SvgAlert18));

var _path$ba, _path2$3D;
function _extends$bo() { _extends$bo = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$bo.apply(this, arguments); }
var SvgAlert24 = function SvgAlert24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$bo({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path$ba || (_path$ba = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M12 8.8a.9.9 0 0 1 .9.9v4.2a.9.9 0 1 1-1.8 0V9.7a.9.9 0 0 1 .9-.9M12 15.5a.9.9 0 0 1 .9.9v.1a.9.9 0 1 1-1.8 0v-.1a.9.9 0 0 1 .9-.9"
  })), _path2$3D || (_path2$3D = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M8.3 5.002 2.658 15.16c-1.555 2.8.47 6.24 3.672 6.24h11.286c3.203 0 5.227-3.44 3.672-6.24L15.643 5.002c-1.6-2.88-5.742-2.88-7.342 0M4.23 16.034 9.875 5.876c.914-1.646 3.282-1.646 4.196 0l5.643 10.158c.89 1.6-.268 3.566-2.098 3.566H6.33c-1.83 0-2.987-1.966-2.098-3.566",
    clipRule: "evenodd"
  })));
};
var Alert24 = (/* unused pure expression or super */ null && (SvgAlert24));

var _path$b9, _path2$3C;
function _extends$bn() { _extends$bn = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$bn.apply(this, arguments); }
var SvgAlert32 = function SvgAlert32(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$bn({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _path$b9 || (_path$b9 = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M16 11.933a1 1 0 0 1 1 1v5.6a1 1 0 1 1-2 0v-5.6a1 1 0 0 1 1-1M16 20.867a1 1 0 0 1 1 1V22a1 1 0 1 1-2 0v-.133a1 1 0 0 1 1-1"
  })), _path2$3C || (_path2$3C = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M11.417 6.864 3.893 20.408c-1.926 3.466.58 7.725 4.545 7.725h15.05c3.964 0 6.47-4.26 4.545-7.725L20.51 6.864c-1.982-3.567-7.11-3.567-9.092 0M5.641 21.379l7.525-13.544c1.219-2.195 4.375-2.195 5.594 0l7.525 13.544c1.185 2.133-.358 4.754-2.797 4.754H8.438c-2.44 0-3.982-2.621-2.797-4.754",
    clipRule: "evenodd"
  })));
};
var Alert32 = (/* unused pure expression or super */ null && (SvgAlert32));

var _path$b8, _path2$3B;
function _extends$bm() { _extends$bm = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$bm.apply(this, arguments); }
var SvgAlert48 = function SvgAlert48(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$bm({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none"
  }, props), _path$b8 || (_path$b8 = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M24 18.2a1.2 1.2 0 0 1 1.2 1.2v8.4a1.2 1.2 0 0 1-2.4 0v-8.4a1.2 1.2 0 0 1 1.2-1.2M24 31.5a1.3 1.3 0 0 1 1.3 1.3v.2a1.3 1.3 0 1 1-2.6 0v-.2a1.3 1.3 0 0 1 1.3-1.3"
  })), _path2$3B || (_path2$3B = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M17.65 10.587 6.365 30.903c-2.666 4.8.804 10.697 6.294 10.697H35.23c5.49 0 8.96-5.898 6.294-10.697L30.238 10.587c-2.743-4.938-9.844-4.938-12.587 0M8.463 32.07l11.286-20.316c1.83-3.292 6.563-3.292 8.392 0l11.287 20.316c1.778 3.2-.536 7.131-4.196 7.131H12.658c-3.66 0-5.974-3.932-4.196-7.131",
    clipRule: "evenodd"
  })));
};
var Alert48 = (/* unused pure expression or super */ null && (SvgAlert48));

var AlertIcon = function AlertIcon(props) {
  var alert = {
    12: Alert12,
    16: Alert16,
    18: Alert18,
    24: Alert24,
    32: Alert32,
    48: Alert48
  };
  return jsx(IconTemplate, _assign({
    icons: alert
  }, props));
};

var _path$b7;
function _extends$bl() { _extends$bl = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$bl.apply(this, arguments); }
var SvgArrowClockwise12 = function SvgArrowClockwise12(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$bl({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none"
  }, props), _path$b7 || (_path$b7 = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M2.15 6a3.85 3.85 0 0 1 6.47-2.82l-.308.308A.3.3 0 0 0 8.524 4H10a.3.3 0 0 0 .3-.3V2.224a.3.3 0 0 0-.512-.212l-.248.248A5.15 5.15 0 1 0 11.15 6a.65.65 0 1 0-1.3 0 3.85 3.85 0 0 1-7.7 0"
  })));
};
var ArrowClockwise12 = (/* unused pure expression or super */ null && (SvgArrowClockwise12));

var _path$b6;
function _extends$bk() { _extends$bk = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$bk.apply(this, arguments); }
var SvgArrowClockwise16 = function SvgArrowClockwise16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$bk({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path$b6 || (_path$b6 = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M2.8 8a5.2 5.2 0 0 1 8.746-3.803l-.453.454a.4.4 0 0 0 .283.683h1.967a.4.4 0 0 0 .4-.4V2.966a.4.4 0 0 0-.683-.283l-.382.382A6.8 6.8 0 1 0 14.8 8a.8.8 0 0 0-1.6 0A5.2 5.2 0 0 1 2.8 8"
  })));
};
var ArrowClockwise16 = (/* unused pure expression or super */ null && (SvgArrowClockwise16));

var _path$b5;
function _extends$bj() { _extends$bj = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$bj.apply(this, arguments); }
var SvgArrowClockwise18 = function SvgArrowClockwise18(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$bj({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _path$b5 || (_path$b5 = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M3.05 9a5.95 5.95 0 0 1 10.03-4.33l-.476.477a.5.5 0 0 0 .353.853H15a.5.5 0 0 0 .5-.5V3.457a.5.5 0 0 0-.854-.353l-.434.434A7.55 7.55 0 1 0 16.55 9a.8.8 0 0 0-1.6 0 5.95 5.95 0 0 1-11.9 0"
  })));
};
var ArrowClockwise18 = (/* unused pure expression or super */ null && (SvgArrowClockwise18));

var _path$b4;
function _extends$bi() { _extends$bi = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$bi.apply(this, arguments); }
var SvgArrowClockwise24 = function SvgArrowClockwise24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$bi({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path$b4 || (_path$b4 = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M3.9 12a8.1 8.1 0 0 1 13.727-5.827l-.632.632A.7.7 0 0 0 17.49 8h2.61a.7.7 0 0 0 .7-.7V4.69a.7.7 0 0 0-1.195-.495L18.9 4.9A9.87 9.87 0 0 0 12 2.1c-5.468 0-9.9 4.432-9.9 9.9s4.432 9.9 9.9 9.9 9.9-4.432 9.9-9.9a.9.9 0 1 0-1.8 0 8.1 8.1 0 0 1-16.2 0"
  })));
};
var ArrowClockwise24 = (/* unused pure expression or super */ null && (SvgArrowClockwise24));

var _path$b3;
function _extends$bh() { _extends$bh = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$bh.apply(this, arguments); }
var SvgArrowClockwise32 = function SvgArrowClockwise32(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$bh({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _path$b3 || (_path$b3 = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M5 16C5 9.925 9.925 5 16 5a10.96 10.96 0 0 1 7.61 3.057l-.903.903c-.63.63-.184 1.707.707 1.707h3.253a1 1 0 0 0 1-1V6.414c0-.89-1.078-1.337-1.707-.707l-.936.935A12.96 12.96 0 0 0 16 3C8.82 3 3 8.82 3 16s5.82 13 13 13 13-5.82 13-13a1 1 0 1 0-2 0c0 6.075-4.925 11-11 11S5 22.075 5 16"
  })));
};
var ArrowClockwise32 = (/* unused pure expression or super */ null && (SvgArrowClockwise32));

var _path$b2;
function _extends$bg() { _extends$bg = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$bg.apply(this, arguments); }
var SvgArrowClockwise48 = function SvgArrowClockwise48(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$bg({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none"
  }, props), _path$b2 || (_path$b2 = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M7.2 24C7.2 14.72 14.722 7.2 24 7.2a16.74 16.74 0 0 1 11.627 4.673l-1.566 1.566c-.945.945-.276 2.56 1.06 2.56H40a1.5 1.5 0 0 0 1.5-1.5V9.622c0-1.336-1.616-2.005-2.56-1.06l-1.616 1.615A19.14 19.14 0 0 0 24 4.8C13.396 4.8 4.8 13.396 4.8 24S13.396 43.2 24 43.2 43.2 34.604 43.2 24a1.2 1.2 0 0 0-2.4 0c0 9.278-7.522 16.8-16.8 16.8S7.2 33.278 7.2 24"
  })));
};
var ArrowClockwise48 = (/* unused pure expression or super */ null && (SvgArrowClockwise48));

var ArrowClockwiseIcon = function ArrowClockwiseIcon(props) {
  var arrowClockwise = {
    12: ArrowClockwise12,
    16: ArrowClockwise16,
    18: ArrowClockwise18,
    24: ArrowClockwise24,
    32: ArrowClockwise32,
    48: ArrowClockwise48
  };
  return jsx(IconTemplate, _assign({
    icons: arrowClockwise
  }, props));
};

var _path$b1;
function _extends$bf() { _extends$bf = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$bf.apply(this, arguments); }
var SvgArrowDown12 = function SvgArrowDown12(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$bf({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none"
  }, props), _path$b1 || (_path$b1 = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M10.672 5.432a.6.6 0 0 0-.847.05l-3.218 3.62V1.33a.6.6 0 0 0-1.2 0v7.772l-3.218-3.62a.6.6 0 0 0-.897.797l4.266 4.8a.6.6 0 0 0 .897 0l4.267-4.8a.6.6 0 0 0-.05-.847",
    clipRule: "evenodd"
  })));
};
var ArrowDown12 = (/* unused pure expression or super */ null && (SvgArrowDown12));

var _path$b0;
function _extends$be() { _extends$be = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$be.apply(this, arguments); }
var SvgArrowDown16 = function SvgArrowDown16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$be({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path$b0 || (_path$b0 = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M14.186 7.276a.75.75 0 0 0-1.059.062L8.75 12.264V1.77a.75.75 0 1 0-1.5 0v10.494L2.87 7.338a.75.75 0 1 0-1.121.997l5.688 6.4a.75.75 0 0 0 1.122 0l5.688-6.4a.75.75 0 0 0-.062-1.059",
    clipRule: "evenodd"
  })));
};
var ArrowDown16 = (/* unused pure expression or super */ null && (SvgArrowDown16));

var _path$a$;
function _extends$bd() { _extends$bd = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$bd.apply(this, arguments); }
var SvgArrowDown18 = function SvgArrowDown18(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$bd({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _path$a$ || (_path$a$ = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M15.931 8.217a.8.8 0 0 0-1.13.066L9.8 13.911V1.99a.8.8 0 1 0-1.6 0v11.92L3.198 8.284a.8.8 0 1 0-1.196 1.063l6.4 7.2a.8.8 0 0 0 1.196 0l6.4-7.2a.8.8 0 0 0-.067-1.129",
    clipRule: "evenodd"
  })));
};
var ArrowDown18 = (/* unused pure expression or super */ null && (SvgArrowDown18));

var _path$a_;
function _extends$bc() { _extends$bc = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$bc.apply(this, arguments); }
var SvgArrowDown24 = function SvgArrowDown24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$bc({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path$a_ || (_path$a_ = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M21.125 11.087a.9.9 0 0 0-1.27.075l-6.962 7.83V2.66a.9.9 0 1 0-1.8 0v16.333l-6.96-7.831a.9.9 0 0 0-1.346 1.196l8.534 9.6a.9.9 0 0 0 1.345 0l8.533-9.6a.9.9 0 0 0-.074-1.27",
    clipRule: "evenodd"
  })));
};
var ArrowDown24 = (/* unused pure expression or super */ null && (SvgArrowDown24));

var _path$aZ;
function _extends$bb() { _extends$bb = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$bb.apply(this, arguments); }
var SvgArrowDown32 = function SvgArrowDown32(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$bb({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _path$aZ || (_path$aZ = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M28.04 14.926a1 1 0 0 0-1.412.083l-9.63 10.834V3.54a1 1 0 1 0-2 0v22.303L5.368 15.01a1 1 0 1 0-1.495 1.329l11.378 12.8a1 1 0 0 0 1.494 0l11.378-12.8a1 1 0 0 0-.083-1.412",
    clipRule: "evenodd"
  })));
};
var ArrowDown32 = (/* unused pure expression or super */ null && (SvgArrowDown32));

var _path$aY;
function _extends$ba() { _extends$ba = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$ba.apply(this, arguments); }
var SvgArrowDown48 = function SvgArrowDown48(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$ba({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none"
  }, props), _path$aY || (_path$aY = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M41.87 22.613a1.2 1.2 0 0 0-1.693.1l-14.97 16.84V5.31a1.2 1.2 0 1 0-2.4 0v34.244L7.837 22.713a1.2 1.2 0 0 0-1.794 1.594l17.067 19.2a1.2 1.2 0 0 0 1.794 0l17.067-19.2a1.2 1.2 0 0 0-.1-1.694",
    clipRule: "evenodd"
  })));
};
var ArrowDown48 = (/* unused pure expression or super */ null && (SvgArrowDown48));

var ArrowDownIcon = function ArrowDownIcon(props) {
  var arrowDown = {
    12: ArrowDown12,
    16: ArrowDown16,
    18: ArrowDown18,
    24: ArrowDown24,
    32: ArrowDown32,
    48: ArrowDown48
  };
  return jsx(IconTemplate, _assign({
    icons: arrowDown
  }, props));
};

var _path$aX;
function _extends$b9() { _extends$b9 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$b9.apply(this, arguments); }
var SvgArrowLeft12 = function SvgArrowLeft12(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$b9({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none"
  }, props), _path$aX || (_path$aX = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M6.648 1.331a.6.6 0 0 1-.05.847l-3.62 3.219h7.772a.6.6 0 1 1 0 1.2H2.978l3.62 3.218a.6.6 0 1 1-.797.897l-4.8-4.267a.6.6 0 0 1 0-.897l4.8-4.267a.6.6 0 0 1 .847.05",
    clipRule: "evenodd"
  })));
};
var ArrowLeft12 = (/* unused pure expression or super */ null && (SvgArrowLeft12));

var _path$aW;
function _extends$b8() { _extends$b8 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$b8.apply(this, arguments); }
var SvgArrowLeft16 = function SvgArrowLeft16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$b8({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path$aW || (_path$aW = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M8.83 1.808a.75.75 0 0 1-.062 1.06L3.843 7.245h10.494a.75.75 0 0 1 0 1.5H3.843l4.925 4.378a.75.75 0 1 1-.996 1.121l-6.4-5.689a.75.75 0 0 1 0-1.121l6.4-5.689a.75.75 0 0 1 1.059.062",
    clipRule: "evenodd"
  })));
};
var ArrowLeft16 = (/* unused pure expression or super */ null && (SvgArrowLeft16));

var _path$aV;
function _extends$b7() { _extends$b7 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$b7.apply(this, arguments); }
var SvgArrowLeft18 = function SvgArrowLeft18(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$b7({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _path$aV || (_path$aV = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M9.898 2.063a.8.8 0 0 1-.066 1.13L4.204 8.195h11.921a.8.8 0 1 1 0 1.6H4.205l5.627 5.002a.8.8 0 1 1-1.063 1.196l-7.2-6.4a.8.8 0 0 1 0-1.196l7.2-6.4a.8.8 0 0 1 1.129.066",
    clipRule: "evenodd"
  })));
};
var ArrowLeft18 = (/* unused pure expression or super */ null && (SvgArrowLeft18));

var _path$aU;
function _extends$b6() { _extends$b6 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$b6.apply(this, arguments); }
var SvgArrowLeft24 = function SvgArrowLeft24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$b6({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path$aU || (_path$aU = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M13.073 2.862a.9.9 0 0 1-.075 1.27l-7.83 6.961H21.5a.9.9 0 1 1 0 1.8H5.167l7.83 6.961a.9.9 0 1 1-1.195 1.345l-9.6-8.533a.9.9 0 0 1 0-1.345l9.6-8.534a.9.9 0 0 1 1.27.075",
    clipRule: "evenodd"
  })));
};
var ArrowLeft24 = (/* unused pure expression or super */ null && (SvgArrowLeft24));

var _path$aT;
function _extends$b5() { _extends$b5 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$b5.apply(this, arguments); }
var SvgArrowLeft32 = function SvgArrowLeft32(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$b5({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _path$aT || (_path$aT = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M17.277 3.949a1 1 0 0 1-.083 1.412L6.36 14.99h22.303a1 1 0 1 1 0 2H6.36l10.834 9.63a1 1 0 0 1-1.328 1.495l-12.8-11.378a1 1 0 0 1 0-1.494l12.8-11.378a1 1 0 0 1 1.411.083",
    clipRule: "evenodd"
  })));
};
var ArrowLeft32 = (/* unused pure expression or super */ null && (SvgArrowLeft32));

var _path$aS;
function _extends$b4() { _extends$b4 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$b4.apply(this, arguments); }
var SvgArrowLeft48 = function SvgArrowLeft48(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$b4({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none"
  }, props), _path$aS || (_path$aS = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M25.697 6.123a1.2 1.2 0 0 1-.1 1.694l-16.84 14.97H43a1.2 1.2 0 0 1 0 2.4H8.756l16.841 14.97a1.2 1.2 0 1 1-1.594 1.793l-19.2-17.067a1.2 1.2 0 0 1 0-1.793l19.2-17.067a1.2 1.2 0 0 1 1.694.1",
    clipRule: "evenodd"
  })));
};
var ArrowLeft48 = (/* unused pure expression or super */ null && (SvgArrowLeft48));

var ArrowLeftIcon = function ArrowLeftIcon(props) {
  var arrowLeft = {
    12: ArrowLeft12,
    16: ArrowLeft16,
    18: ArrowLeft18,
    24: ArrowLeft24,
    32: ArrowLeft32,
    48: ArrowLeft48
  };
  return jsx(IconTemplate, _assign({
    icons: arrowLeft
  }, props));
};

var _path$aR;
function _extends$b3() { _extends$b3 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$b3.apply(this, arguments); }
var SvgArrowRight12 = function SvgArrowRight12(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$b3({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none"
  }, props), _path$aR || (_path$aR = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M5.351 1.331a.6.6 0 0 0 .05.847l3.62 3.219H1.25a.6.6 0 0 0 0 1.2h7.772l-3.62 3.218a.6.6 0 1 0 .797.897l4.8-4.267a.6.6 0 0 0 0-.897l-4.8-4.267a.6.6 0 0 0-.848.05",
    clipRule: "evenodd"
  })));
};
var ArrowRight12 = (/* unused pure expression or super */ null && (SvgArrowRight12));

var _path$aQ;
function _extends$b2() { _extends$b2 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$b2.apply(this, arguments); }
var SvgArrowRight16 = function SvgArrowRight16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$b2({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path$aQ || (_path$aQ = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M7.173 1.808a.75.75 0 0 0 .062 1.06l4.926 4.378H1.667a.75.75 0 1 0 0 1.5H12.16l-4.926 4.378a.75.75 0 1 0 .997 1.121l6.4-5.689a.75.75 0 0 0 0-1.121l-6.4-5.689a.75.75 0 0 0-1.06.062",
    clipRule: "evenodd"
  })));
};
var ArrowRight16 = (/* unused pure expression or super */ null && (SvgArrowRight16));

var _path$aP;
function _extends$b1() { _extends$b1 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$b1.apply(this, arguments); }
var SvgArrowRight18 = function SvgArrowRight18(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$b1({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _path$aP || (_path$aP = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M8.102 2.063a.8.8 0 0 0 .066 1.13l5.628 5.002H1.875a.8.8 0 1 0 0 1.6h11.92l-5.627 5.002a.8.8 0 0 0 1.063 1.196l7.2-6.4a.8.8 0 0 0 0-1.196l-7.2-6.4a.8.8 0 0 0-1.129.066",
    clipRule: "evenodd"
  })));
};
var ArrowRight18 = (/* unused pure expression or super */ null && (SvgArrowRight18));

var _path$aO;
function _extends$b0() { _extends$b0 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$b0.apply(this, arguments); }
var SvgArrowRight24 = function SvgArrowRight24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$b0({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path$aO || (_path$aO = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M10.927 2.862a.9.9 0 0 0 .075 1.27l7.83 6.961H2.5a.9.9 0 1 0 0 1.8h16.333l-7.83 6.961a.9.9 0 1 0 1.195 1.345l9.6-8.533a.9.9 0 0 0 0-1.345l-9.6-8.534a.9.9 0 0 0-1.27.075",
    clipRule: "evenodd"
  })));
};
var ArrowRight24 = (/* unused pure expression or super */ null && (SvgArrowRight24));

var _path$aN;
function _extends$a$() { _extends$a$ = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$a$.apply(this, arguments); }
var SvgArrowRight32 = function SvgArrowRight32(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$a$({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _path$aN || (_path$aN = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M14.72 3.949a1 1 0 0 0 .082 1.412l10.834 9.63H3.333a1 1 0 1 0 0 2h22.303l-10.834 9.63a1 1 0 0 0 1.329 1.495l12.8-11.378a1 1 0 0 0 0-1.494L16.13 3.866a1 1 0 0 0-1.412.083",
    clipRule: "evenodd"
  })));
};
var ArrowRight32 = (/* unused pure expression or super */ null && (SvgArrowRight32));

var _path$aM;
function _extends$a_() { _extends$a_ = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$a_.apply(this, arguments); }
var SvgArrowRight48 = function SvgArrowRight48(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$a_({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none"
  }, props), _path$aM || (_path$aM = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M22.303 6.123a1.2 1.2 0 0 0 .1 1.694l16.84 14.97H5a1.2 1.2 0 0 0 0 2.4h34.244l-16.841 14.97a1.2 1.2 0 0 0 1.594 1.793l19.2-17.067a1.2 1.2 0 0 0 0-1.793l-19.2-17.067a1.2 1.2 0 0 0-1.694.1",
    clipRule: "evenodd"
  })));
};
var ArrowRight48 = (/* unused pure expression or super */ null && (SvgArrowRight48));

var ArrowRightIcon = function ArrowRightIcon(props) {
  var arrowRight = {
    12: ArrowRight12,
    16: ArrowRight16,
    18: ArrowRight18,
    24: ArrowRight24,
    32: ArrowRight32,
    48: ArrowRight48
  };
  return jsx(IconTemplate, _assign({
    icons: arrowRight
  }, props));
};

var _g$d, _defs$d;
function _extends$aZ() { _extends$aZ = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$aZ.apply(this, arguments); }
var SvgArrowLeftArrowRight12 = function SvgArrowLeftArrowRight12(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$aZ({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none",
    viewBox: "0 0 480 480"
  }, props), _g$d || (_g$d = /*#__PURE__*/React.createElement("g", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 48,
    clipPath: "url(#arrowLeftArrowRight_12_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M98 146h284m-284 0 88 88m-88-88 88-88m196 276H98m284 0-88-88m88 88-88 88"
  }))), _defs$d || (_defs$d = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "arrowLeftArrowRight_12_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h480v480H0z"
  })))));
};
var ArrowLeftArrowRight12 = (/* unused pure expression or super */ null && (SvgArrowLeftArrowRight12));

var _g$c, _defs$c;
function _extends$aY() { _extends$aY = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$aY.apply(this, arguments); }
var SvgArrowLeftArrowRight16 = function SvgArrowLeftArrowRight16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$aY({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 480 480"
  }, props), _g$c || (_g$c = /*#__PURE__*/React.createElement("g", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 45,
    clipPath: "url(#arrowLeftArrowRight_16_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M98 146h284m-284 0 88 88m-88-88 88-88m196 276H98m284 0-88-88m88 88-88 88"
  }))), _defs$c || (_defs$c = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "arrowLeftArrowRight_16_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h480v480H0z"
  })))));
};
var ArrowLeftArrowRight16 = (/* unused pure expression or super */ null && (SvgArrowLeftArrowRight16));

var _g$b, _defs$b;
function _extends$aX() { _extends$aX = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$aX.apply(this, arguments); }
var SvgArrowLeftArrowRight18 = function SvgArrowLeftArrowRight18(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$aX({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none",
    viewBox: "0 0 480 480"
  }, props), _g$b || (_g$b = /*#__PURE__*/React.createElement("g", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 42.67,
    clipPath: "url(#arrowLeftArrowRight_18_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M98 146h284m-284 0 88 88m-88-88 88-88m196 276H98m284 0-88-88m88 88-88 88"
  }))), _defs$b || (_defs$b = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "arrowLeftArrowRight_18_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h480v480H0z"
  })))));
};
var ArrowLeftArrowRight18 = (/* unused pure expression or super */ null && (SvgArrowLeftArrowRight18));

var _g$a, _defs$a;
function _extends$aW() { _extends$aW = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$aW.apply(this, arguments); }
var SvgArrowLeftArrowRight24 = function SvgArrowLeftArrowRight24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$aW({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 480 480"
  }, props), _g$a || (_g$a = /*#__PURE__*/React.createElement("g", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 36,
    clipPath: "url(#arrowLeftArrowRight_24_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M98 146h284m-284 0 88 88m-88-88 88-88m196 276H98m284 0-88-88m88 88-88 88"
  }))), _defs$a || (_defs$a = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "arrowLeftArrowRight_24_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h480v480H0z"
  })))));
};
var ArrowLeftArrowRight24 = (/* unused pure expression or super */ null && (SvgArrowLeftArrowRight24));

var _g$9, _defs$9;
function _extends$aV() { _extends$aV = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$aV.apply(this, arguments); }
var SvgArrowLeftArrowRight32 = function SvgArrowLeftArrowRight32(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$aV({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none",
    viewBox: "0 0 480 480"
  }, props), _g$9 || (_g$9 = /*#__PURE__*/React.createElement("g", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 30,
    clipPath: "url(#arrowLeftArrowRight_32_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M98 146h284m-284 0 88 88m-88-88 88-88m196 276H98m284 0-88-88m88 88-88 88"
  }))), _defs$9 || (_defs$9 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "arrowLeftArrowRight_32_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h480v480H0z"
  })))));
};
var ArrowLeftArrowRight32 = (/* unused pure expression or super */ null && (SvgArrowLeftArrowRight32));

var _g$8, _defs$8;
function _extends$aU() { _extends$aU = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$aU.apply(this, arguments); }
var SvgArrowLeftArrowRight48 = function SvgArrowLeftArrowRight48(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$aU({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none",
    viewBox: "0 0 480 480"
  }, props), _g$8 || (_g$8 = /*#__PURE__*/React.createElement("g", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 24,
    clipPath: "url(#arrowLeftArrowRight_48_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M98 146h284m-284 0 88 88m-88-88 88-88m196 276H98m284 0-88-88m88 88-88 88"
  }))), _defs$8 || (_defs$8 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "arrowLeftArrowRight_48_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h480v480H0z"
  })))));
};
var ArrowLeftArrowRight48 = (/* unused pure expression or super */ null && (SvgArrowLeftArrowRight48));

var ArrowLeftArrowRightIcon = function ArrowLeftArrowRightIcon(props) {
  var arrowRight = {
    12: ArrowLeftArrowRight12,
    16: ArrowLeftArrowRight16,
    18: ArrowLeftArrowRight18,
    24: ArrowLeftArrowRight24,
    32: ArrowLeftArrowRight32,
    48: ArrowLeftArrowRight48
  };
  return jsx(IconTemplate, _assign({
    icons: arrowRight
  }, props));
};

var _path$aL;
function _extends$aT() { _extends$aT = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$aT.apply(this, arguments); }
var SvgArrowUp12 = function SvgArrowUp12(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$aT({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none"
  }, props), _path$aL || (_path$aL = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M1.341 6.57a.6.6 0 0 0 .847-.05L5.407 2.9v7.772a.6.6 0 0 0 1.2 0V2.9l3.218 3.62a.6.6 0 0 0 .897-.797L6.455.923a.6.6 0 0 0-.897 0l-4.267 4.8a.6.6 0 0 0 .05.847",
    clipRule: "evenodd"
  })));
};
var ArrowUp12 = (/* unused pure expression or super */ null && (SvgArrowUp12));

var _path$aK;
function _extends$aS() { _extends$aS = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$aS.apply(this, arguments); }
var SvgArrowUp16 = function SvgArrowUp16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$aS({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path$aK || (_path$aK = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M1.812 8.723A.75.75 0 0 0 2.87 8.66l4.378-4.925v10.494a.75.75 0 0 0 1.5 0V3.735l4.378 4.925a.75.75 0 1 0 1.121-.996l-5.688-6.4a.75.75 0 0 0-1.122 0l-5.688 6.4a.75.75 0 0 0 .062 1.059",
    clipRule: "evenodd"
  })));
};
var ArrowUp16 = (/* unused pure expression or super */ null && (SvgArrowUp16));

var _path$aJ;
function _extends$aR() { _extends$aR = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$aR.apply(this, arguments); }
var SvgArrowUp18 = function SvgArrowUp18(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$aR({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _path$aJ || (_path$aJ = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M2.069 9.78a.8.8 0 0 0 1.129-.066L8.2 4.087v11.92a.8.8 0 0 0 1.6 0V4.088l5.002 5.627a.8.8 0 0 0 1.196-1.063l-6.4-7.2a.8.8 0 0 0-1.196 0l-6.4 7.2a.8.8 0 0 0 .067 1.13",
    clipRule: "evenodd"
  })));
};
var ArrowUp18 = (/* unused pure expression or super */ null && (SvgArrowUp18));

var _path$aI;
function _extends$aQ() { _extends$aQ = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$aQ.apply(this, arguments); }
var SvgArrowUp24 = function SvgArrowUp24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$aQ({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path$aI || (_path$aI = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M2.862 12.916a.9.9 0 0 0 1.27-.075l6.961-7.83v16.332a.9.9 0 0 0 1.8 0V5.01l6.961 7.831a.9.9 0 1 0 1.345-1.196l-8.533-9.6a.9.9 0 0 0-1.345 0l-8.534 9.6a.9.9 0 0 0 .075 1.27",
    clipRule: "evenodd"
  })));
};
var ArrowUp24 = (/* unused pure expression or super */ null && (SvgArrowUp24));

var _path$aH;
function _extends$aP() { _extends$aP = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$aP.apply(this, arguments); }
var SvgArrowUp32 = function SvgArrowUp32(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$aP({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _path$aH || (_path$aH = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M3.956 17.072a1 1 0 0 0 1.412-.083l9.63-10.834v22.303a1 1 0 1 0 2 0V6.155l9.63 10.834a1 1 0 1 0 1.495-1.329L16.745 2.86a1 1 0 0 0-1.495 0L3.874 15.66a1 1 0 0 0 .083 1.412",
    clipRule: "evenodd"
  })));
};
var ArrowUp32 = (/* unused pure expression or super */ null && (SvgArrowUp32));

var _path$aG;
function _extends$aO() { _extends$aO = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$aO.apply(this, arguments); }
var SvgArrowUp48 = function SvgArrowUp48(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$aO({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none"
  }, props), _path$aG || (_path$aG = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M6.143 25.384a1.2 1.2 0 0 0 1.694-.1l14.97-16.84v34.243a1.2 1.2 0 1 0 2.4 0V8.443l14.97 16.841a1.2 1.2 0 0 0 1.793-1.594L24.904 4.49a1.2 1.2 0 0 0-1.794 0L6.043 23.69a1.2 1.2 0 0 0 .1 1.694",
    clipRule: "evenodd"
  })));
};
var ArrowUp48 = (/* unused pure expression or super */ null && (SvgArrowUp48));

var ArrowUpIcon = function ArrowUpIcon(props) {
  var arrowUp = {
    12: ArrowUp12,
    16: ArrowUp16,
    18: ArrowUp18,
    24: ArrowUp24,
    32: ArrowUp32,
    48: ArrowUp48
  };
  return jsx(IconTemplate, _assign({
    icons: arrowUp
  }, props));
};

var _path$aF, _path2$3A, _path3$n;
function _extends$aN() { _extends$aN = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$aN.apply(this, arguments); }
var SvgAttach12 = function SvgAttach12(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$aN({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none"
  }, props), _path$aF || (_path$aF = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M5.576 2.04A3.1 3.1 0 0 1 9.96 6.424L7.065 9.32l-.848-.848L9.11 5.576a1.9 1.9 0 0 0-2.687-2.687L3.242 6.07a.6.6 0 1 1-.848-.849z",
    clipRule: "evenodd"
  })), _path2$3A || (_path2$3A = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M2.659 7.432a2.225 2.225 0 0 0 3.147 3.147l1.259-1.26-.848-.848-1.26 1.26a1.025 1.025 0 1 1-1.45-1.45l3.448-3.448-.849-.848z",
    clipRule: "evenodd"
  })), _path3$n || (_path3$n = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M6.636 3.455a1.35 1.35 0 1 1 1.91 1.909L5.54 8.369a.6.6 0 1 1-.848-.849l3.005-3.005a.15.15 0 1 0-.212-.212L5.069 6.72l-.849-.848z",
    clipRule: "evenodd"
  })));
};
var Attach12 = (/* unused pure expression or super */ null && (SvgAttach12));

var _path$aE, _path2$3z, _path3$m;
function _extends$aM() { _extends$aM = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$aM.apply(this, arguments); }
var SvgAttach16 = function SvgAttach16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$aM({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path$aE || (_path$aE = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M7.47 2.756a4.083 4.083 0 0 1 5.774 5.774l-3.86 3.86-1.06-1.06 3.86-3.86A2.583 2.583 0 1 0 8.53 3.816L4.288 8.06a.75.75 0 1 1-1.061-1.06z",
    clipRule: "evenodd"
  })), _path2$3z || (_path2$3z = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M3.58 9.944a2.917 2.917 0 0 0 4.125 4.125l1.68-1.68-1.061-1.06-1.68 1.68a1.417 1.417 0 0 1-2.003-2.004L9.237 6.41l-1.06-1.06z",
    clipRule: "evenodd"
  })), _path3$m || (_path3$m = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M8.884 4.641a1.75 1.75 0 1 1 2.475 2.475l-4.007 4.007a.75.75 0 1 1-1.06-1.06l4.006-4.008a.25.25 0 0 0-.353-.353L6.724 8.923l-1.061-1.06z",
    clipRule: "evenodd"
  })));
};
var Attach16 = (/* unused pure expression or super */ null && (SvgAttach16));

var _path$aD, _path2$3y, _path3$l;
function _extends$aL() { _extends$aL = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$aL.apply(this, arguments); }
var SvgAttach18 = function SvgAttach18(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$aL({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _path$aD || (_path$aD = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M8.434 3.131a4.55 4.55 0 1 1 6.435 6.435l-4.342 4.342-1.131-1.132 4.342-4.342a2.95 2.95 0 0 0-4.172-4.172L4.793 9.035a.8.8 0 0 1-1.131-1.131z",
    clipRule: "evenodd"
  })), _path2$3y || (_path2$3y = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M4.06 11.219a3.237 3.237 0 1 0 4.578 4.578l1.89-1.89-1.132-1.13-1.89 1.889A1.637 1.637 0 1 1 5.19 12.35l5.171-5.17L9.23 6.047z",
    clipRule: "evenodd"
  })), _path3$l || (_path3$l = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M10.026 5.252a1.925 1.925 0 1 1 2.722 2.723L8.24 12.483a.8.8 0 0 1-1.131-1.132l4.508-4.508a.325.325 0 0 0-.46-.46l-3.624 3.625-1.131-1.132z",
    clipRule: "evenodd"
  })));
};
var Attach18 = (/* unused pure expression or super */ null && (SvgAttach18));

var _path$aC, _path2$3x, _path3$k;
function _extends$aK() { _extends$aK = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$aK.apply(this, arguments); }
var SvgAttach24 = function SvgAttach24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$aK({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path$aC || (_path$aC = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M11.363 4.293a5.9 5.9 0 0 1 8.344 8.343l-5.79 5.79-1.272-1.273 5.79-5.79a4.1 4.1 0 1 0-5.799-5.798L6.272 11.93A.9.9 0 0 1 5 10.656z",
    clipRule: "evenodd"
  })), _path2$3x || (_path2$3x = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M5.53 15.076a4.15 4.15 0 0 0 5.869 5.869l2.519-2.52-1.273-1.272-2.52 2.52a2.35 2.35 0 0 1-3.322-3.324l6.894-6.895-1.273-1.272z",
    clipRule: "evenodd"
  })), _path3$k || (_path3$k = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M13.485 7.12a2.4 2.4 0 1 1 3.394 3.395l-6.01 6.01a.9.9 0 0 1-1.273-1.272l6.01-6.01a.6.6 0 0 0-.848-.85l-4.832 4.833-1.273-1.273z",
    clipRule: "evenodd"
  })));
};
var Attach24 = (/* unused pure expression or super */ null && (SvgAttach24));

var _path$aB, _path2$3w, _path3$j;
function _extends$aJ() { _extends$aJ = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$aJ.apply(this, arguments); }
var SvgAttach32 = function SvgAttach32(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$aJ({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _path$aB || (_path$aB = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M15.293 5.865a7.667 7.667 0 1 1 10.843 10.842l-7.72 7.72-1.414-1.415 7.72-7.72a5.667 5.667 0 1 0-8.015-8.013l-8.485 8.485a1 1 0 1 1-1.414-1.414z",
    clipRule: "evenodd"
  })), _path2$3w || (_path2$3w = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M7.515 20.243a5.333 5.333 0 0 0 7.542 7.542l3.36-3.359-1.415-1.414-3.359 3.359a3.333 3.333 0 0 1-4.714-4.714l9.193-9.193-1.415-1.414z",
    clipRule: "evenodd"
  })), _path3$j || (_path3$j = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M18.122 9.636a3 3 0 1 1 4.242 4.243l-8.014 8.013a1 1 0 0 1-1.414-1.414l8.014-8.014a1 1 0 0 0-1.414-1.414l-6.443 6.443-1.414-1.415z",
    clipRule: "evenodd"
  })));
};
var Attach32 = (/* unused pure expression or super */ null && (SvgAttach32));

var _path$aA, _path2$3v, _path3$i;
function _extends$aI() { _extends$aI = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$aI.apply(this, arguments); }
var SvgAttach48 = function SvgAttach48(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$aI({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none"
  }, props), _path$aA || (_path$aA = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M23.151 9.01c4.374-4.374 11.466-4.374 15.84 0 4.373 4.373 4.373 11.465 0 15.839L27.41 36.428l-1.696-1.698 11.578-11.578a8.8 8.8 0 1 0-12.445-12.445L12.12 23.434a1.2 1.2 0 1 1-1.697-1.697z",
    clipRule: "evenodd"
  })), _path2$3v || (_path2$3v = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M11.484 30.576a7.7 7.7 0 0 0 10.89 10.89l5.038-5.038-1.697-1.698-5.039 5.039a5.3 5.3 0 0 1-7.495-7.496L26.97 18.485l-1.697-1.697z",
    clipRule: "evenodd"
  })), _path3$i || (_path3$i = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M27.394 14.666a4.2 4.2 0 0 1 5.94 5.94l-12.021 12.02a1.2 1.2 0 1 1-1.697-1.696l12.02-12.021a1.8 1.8 0 0 0-2.545-2.546l-9.664 9.664-1.697-1.697z",
    clipRule: "evenodd"
  })));
};
var Attach48 = (/* unused pure expression or super */ null && (SvgAttach48));

var AttachIcon = function AttachIcon(props) {
  var attach = {
    12: Attach12,
    16: Attach16,
    18: Attach18,
    24: Attach24,
    32: Attach32,
    48: Attach48
  };
  return jsx(IconTemplate, _assign({
    icons: attach
  }, props));
};

var _path$az;
function _extends$aH() { _extends$aH = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$aH.apply(this, arguments); }
var SvgBullhorn12 = function SvgBullhorn12(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$aH({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none"
  }, props), _path$az || (_path$az = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M8.192 1.312A2.1 2.1 0 0 1 11.1 3.25v4.5A2.1 2.1 0 0 1 8.192 9.69L7.1 9.233V9.5A1.1 1.1 0 0 1 6 10.6H5a1.1 1.1 0 0 1-1.1-1.1V8.1H1.5a.6.6 0 0 1-.6-.6v-4a.6.6 0 0 1 .6-.6h2.88zM3.9 4.1H2.1v2.8h1.8zm1.2 4.3.8.333V9.4h-.8zm0-1.3V3.9l3.554-1.48a.9.9 0 0 1 1.246.83v4.5a.9.9 0 0 1-1.246.83z",
    clipRule: "evenodd"
  })));
};
var Bullhorn12 = (/* unused pure expression or super */ null && (SvgBullhorn12));

var _path$ay;
function _extends$aG() { _extends$aG = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$aG.apply(this, arguments); }
var SvgBullhorn16 = function SvgBullhorn16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$aG({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path$ay || (_path$ay = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M10.942 1.795c1.812-.755 3.808.576 3.808 2.538v6c0 1.963-1.996 3.294-3.808 2.539l-1.525-.636v.43c0 .783-.635 1.417-1.417 1.417H6.667a1.417 1.417 0 0 1-1.417-1.416V10.75H2a.75.75 0 0 1-.75-.75V4.667a.75.75 0 0 1 .75-.75h3.85zM5.25 5.417h-2.5V9.25h2.5zm1.5 5.708 1.167.486v.972H6.75zm0-1.625V5.167l4.77-1.987a1.25 1.25 0 0 1 1.73 1.153v6a1.25 1.25 0 0 1-1.73 1.154z",
    clipRule: "evenodd"
  })));
};
var Bullhorn16 = (/* unused pure expression or super */ null && (SvgBullhorn16));

var _path$ax;
function _extends$aF() { _extends$aF = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$aF.apply(this, arguments); }
var SvgBullhorn18 = function SvgBullhorn18(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$aF({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _path$ax || (_path$ax = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M12.077 2.06c2.009-.838 4.223.639 4.223 2.815v6.75c0 2.176-2.214 3.652-4.223 2.815L10.3 13.7v.55a1.55 1.55 0 0 1-1.55 1.55h-1.5a1.55 1.55 0 0 1-1.55-1.55v-2.2H2a.8.8 0 0 1-.8-.8v-6a.8.8 0 0 1 .8-.8h4.34zM5.7 6.05H2.8v4.4h2.9zm1.6 6.4 1.4.583V14.2H7.3zm0-1.733V5.783l5.392-2.247A1.45 1.45 0 0 1 14.7 4.875v6.75a1.45 1.45 0 0 1-2.008 1.338z",
    clipRule: "evenodd"
  })));
};
var Bullhorn18 = (/* unused pure expression or super */ null && (SvgBullhorn18));

var _path$aw;
function _extends$aE() { _extends$aE = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$aE.apply(this, arguments); }
var SvgBullhorn24 = function SvgBullhorn24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$aE({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path$aw || (_path$aw = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M16.5 2.9c2.569-1.07 5.4.817 5.4 3.6v9c0 2.783-2.831 4.67-5.4 3.6l-2.6-1.083V19a1.9 1.9 0 0 1-1.9 1.9h-2A1.9 1.9 0 0 1 8.1 19v-3.1H3a.9.9 0 0 1-.9-.9V7a.9.9 0 0 1 .9-.9h5.82zm-8.4 5H3.9v6.2h4.2zm1.8 8.45 2.2.917V19a.1.1 0 0 1-.1.1h-2a.1.1 0 0 1-.1-.1zm0-1.95V7.6l7.292-3.038A2.1 2.1 0 0 1 20.1 6.5v9a2.1 2.1 0 0 1-2.908 1.939z",
    clipRule: "evenodd"
  })));
};
var Bullhorn24 = (/* unused pure expression or super */ null && (SvgBullhorn24));

var _path$av;
function _extends$aD() { _extends$aD = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$aD.apply(this, arguments); }
var SvgBullhorn32 = function SvgBullhorn32(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$aD({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _path$av || (_path$av = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M22.077 4.051C25.37 2.68 29 5.1 29 8.667v12c0 3.568-3.63 5.987-6.923 4.615l-3.744-1.56v1.611A2.333 2.333 0 0 1 16 27.668h-2.667A2.333 2.333 0 0 1 11 25.333V21H4a1 1 0 0 1-1-1V9.333a1 1 0 0 1 1-1h7.8zM11 10.334H5V19h6zM13 21.5l3.333 1.389v2.445c0 .184-.149.333-.333.333h-2.667a.333.333 0 0 1-.333-.334zm0-2.166V10l9.846-4.102C24.822 5.074 27 6.526 27 8.667v12c0 2.14-2.178 3.592-4.154 2.769z",
    clipRule: "evenodd"
  })));
};
var Bullhorn32 = (/* unused pure expression or super */ null && (SvgBullhorn32));

var _path$au;
function _extends$aC() { _extends$aC = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$aC.apply(this, arguments); }
var SvgBullhorn48 = function SvgBullhorn48(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$aC({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none"
  }, props), _path$au || (_path$au = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M33.23 6.354C37.974 4.378 43.2 7.862 43.2 13v18c0 5.138-5.227 8.622-9.97 6.646l-6.03-2.513V38a3.2 3.2 0 0 1-3.2 3.2h-4a3.2 3.2 0 0 1-3.2-3.2v-6.8H6A1.2 1.2 0 0 1 4.8 30V14A1.2 1.2 0 0 1 6 12.8h11.76zM16.8 15.2H7.2v13.6h9.6zm2.4 16.6 5.6 2.333V38a.8.8 0 0 1-.8.8h-4a.8.8 0 0 1-.8-.8zm0-2.6V14.8l14.954-6.23C37.316 7.251 40.8 9.574 40.8 13v18c0 3.425-3.484 5.748-6.646 4.43z",
    clipRule: "evenodd"
  })));
};
var Bullhorn48 = (/* unused pure expression or super */ null && (SvgBullhorn48));

var BullhornIcon = function BullhornIcon(props) {
  var bullhorn = {
    12: Bullhorn12,
    16: Bullhorn16,
    18: Bullhorn18,
    24: Bullhorn24,
    32: Bullhorn32,
    48: Bullhorn48
  };
  return jsx(IconTemplate, _assign({
    icons: bullhorn
  }, props));
};

var _path$at, _path2$3u, _path3$h;
function _extends$aB() { _extends$aB = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$aB.apply(this, arguments); }
var SvgCalculator12 = function SvgCalculator12(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$aB({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none"
  }, props), _path$at || (_path$at = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M8.318 2.2h-4.5a.8.8 0 0 0-.8.8v6a.8.8 0 0 0 .8.8h4.5a.8.8 0 0 0 .8-.8V3a.8.8 0 0 0-.8-.8M3.818 1a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h4.5a2 2 0 0 0 2-2V3a2 2 0 0 0-2-2z",
    clipRule: "evenodd"
  })), _path2$3u || (_path2$3u = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M4.1 3.9a.6.6 0 0 1 .6-.6h2.74a.6.6 0 0 1 0 1.2H4.7a.6.6 0 0 1-.6-.6",
    clipRule: "evenodd"
  })), _path3$h || (_path3$h = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M5.72 6.15a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0M7.92 6.15a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0"
  })));
};
var Calculator12 = (/* unused pure expression or super */ null && (SvgCalculator12));

var _path$as, _path2$3t, _path3$g;
function _extends$aA() { _extends$aA = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$aA.apply(this, arguments); }
var SvgCalculator16 = function SvgCalculator16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$aA({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path$as || (_path$as = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M11 2.5H5A1.5 1.5 0 0 0 3.5 4v8.667a1.5 1.5 0 0 0 1.5 1.5h6a1.5 1.5 0 0 0 1.5-1.5V4A1.5 1.5 0 0 0 11 2.5M5 1a3 3 0 0 0-3 3v8.667a3 3 0 0 0 3 3h6a3 3 0 0 0 3-3V4a3 3 0 0 0-3-3z",
    clipRule: "evenodd"
  })), _path2$3t || (_path2$3t = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M5 5a.75.75 0 0 1 .75-.75h4.5a.75.75 0 0 1 0 1.5h-4.5A.75.75 0 0 1 5 5",
    clipRule: "evenodd"
  })), _path3$g || (_path3$g = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M7.4 8.25a1 1 0 1 1-2 0 1 1 0 0 1 2 0M10.6 8.25a1 1 0 1 1-2 0 1 1 0 0 1 2 0M7.4 11.45a1 1 0 1 1-2 0 1 1 0 0 1 2 0M10.6 11.45a1 1 0 1 1-2 0 1 1 0 0 1 2 0"
  })));
};
var Calculator16 = (/* unused pure expression or super */ null && (SvgCalculator16));

var _path$ar, _path2$3s, _path3$f;
function _extends$az() { _extends$az = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$az.apply(this, arguments); }
var SvgCalculator18 = function SvgCalculator18(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$az({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _path$ar || (_path$ar = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M12.53 2.8h-7a1.4 1.4 0 0 0-1.4 1.4v9.89a1.4 1.4 0 0 0 1.4 1.4h7a1.4 1.4 0 0 0 1.4-1.4V4.2a1.4 1.4 0 0 0-1.4-1.4m-7-1.6a3 3 0 0 0-3 3v9.89a3 3 0 0 0 3 3h7a3 3 0 0 0 3-3V4.2a3 3 0 0 0-3-3z",
    clipRule: "evenodd"
  })), _path2$3s || (_path2$3s = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M5.78 5.546a.8.8 0 0 1 .8-.8h4.9a.8.8 0 0 1 0 1.6h-4.9a.8.8 0 0 1-.8-.8",
    clipRule: "evenodd"
  })), _path3$f || (_path3$f = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M8.36 8.915a1.065 1.065 0 1 1-2.13 0 1.065 1.065 0 0 1 2.13 0M11.89 8.915a1.065 1.065 0 1 1-2.13 0 1.065 1.065 0 0 1 2.13 0M8.36 12.445a1.065 1.065 0 1 1-2.13 0 1.065 1.065 0 0 1 2.13 0M11.89 12.445a1.065 1.065 0 1 1-2.13 0 1.065 1.065 0 0 1 2.13 0"
  })));
};
var Calculator18 = (/* unused pure expression or super */ null && (SvgCalculator18));

var _path$aq, _path2$3r, _path3$e;
function _extends$ay() { _extends$ay = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$ay.apply(this, arguments); }
var SvgCalculator24 = function SvgCalculator24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$ay({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path$aq || (_path$aq = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M18 2.8H6A1.2 1.2 0 0 0 4.8 4v16A1.2 1.2 0 0 0 6 21.2h12a1.2 1.2 0 0 0 1.2-1.2V4A1.2 1.2 0 0 0 18 2.8M6 1a3 3 0 0 0-3 3v16a3 3 0 0 0 3 3h12a3 3 0 0 0 3-3V4a3 3 0 0 0-3-3z",
    clipRule: "evenodd"
  })), _path2$3r || (_path2$3r = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M7.25 6.35a.9.9 0 0 1 .9-.9h7.7a.9.9 0 1 1 0 1.8h-7.7a.9.9 0 0 1-.9-.9",
    clipRule: "evenodd"
  })), _path3$e || (_path3$e = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M9.5 10.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0M13 10.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0M16.5 10.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0M9.5 14a1 1 0 1 1-2 0 1 1 0 0 1 2 0M13 14a1 1 0 1 1-2 0 1 1 0 0 1 2 0M16.5 14a1 1 0 1 1-2 0 1 1 0 0 1 2 0M9.5 17.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0M13 17.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0M16.5 17.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0"
  })));
};
var Calculator24 = (/* unused pure expression or super */ null && (SvgCalculator24));

var _path$ap, _path2$3q, _path3$d;
function _extends$ax() { _extends$ax = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$ax.apply(this, arguments); }
var SvgCalculator32 = function SvgCalculator32(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$ax({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _path$ap || (_path$ap = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M24 3.734H8a1.6 1.6 0 0 0-1.6 1.6v21.333a1.6 1.6 0 0 0 1.6 1.6h16a1.6 1.6 0 0 0 1.6-1.6V5.334a1.6 1.6 0 0 0-1.6-1.6m-16-2.4a4 4 0 0 0-4 4v21.333a4 4 0 0 0 4 4h16a4 4 0 0 0 4-4V5.334a4 4 0 0 0-4-4z",
    clipRule: "evenodd"
  })), _path2$3q || (_path2$3q = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M9.667 8.467a1.2 1.2 0 0 1 1.2-1.2h10.266a1.2 1.2 0 1 1 0 2.4H10.867a1.2 1.2 0 0 1-1.2-1.2",
    clipRule: "evenodd"
  })), _path3$d || (_path3$d = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M12.667 14A1.333 1.333 0 1 1 10 14a1.333 1.333 0 0 1 2.667 0M17.333 14a1.333 1.333 0 1 1-2.666 0 1.333 1.333 0 0 1 2.666 0M22 14a1.333 1.333 0 1 1-2.667 0A1.333 1.333 0 0 1 22 14M12.667 18.667a1.333 1.333 0 1 1-2.667 0 1.333 1.333 0 0 1 2.667 0M17.333 18.667a1.333 1.333 0 1 1-2.666 0 1.333 1.333 0 0 1 2.666 0M22 18.667a1.333 1.333 0 1 1-2.667 0 1.333 1.333 0 0 1 2.667 0M12.667 23.334a1.333 1.333 0 1 1-2.667 0 1.333 1.333 0 0 1 2.667 0M17.333 23.334a1.333 1.333 0 1 1-2.666 0 1.333 1.333 0 0 1 2.666 0M22 23.334a1.333 1.333 0 1 1-2.667 0 1.333 1.333 0 0 1 2.667 0"
  })));
};
var Calculator32 = (/* unused pure expression or super */ null && (SvgCalculator32));

var _path$ao, _path2$3p, _path3$c;
function _extends$aw() { _extends$aw = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$aw.apply(this, arguments); }
var SvgCalculator48 = function SvgCalculator48(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$aw({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none"
  }, props), _path$ao || (_path$ao = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M35 5.4H13A3.6 3.6 0 0 0 9.4 9v29.556a3.6 3.6 0 0 0 3.6 3.6h22a3.6 3.6 0 0 0 3.6-3.6V9A3.6 3.6 0 0 0 35 5.4M13 3a6 6 0 0 0-6 6v29.556a6 6 0 0 0 6 6h22a6 6 0 0 0 6-6V9a6 6 0 0 0-6-6z",
    clipRule: "evenodd"
  })), _path2$3p || (_path2$3p = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M15.028 12.606a1.2 1.2 0 0 1 1.2-1.2h15.544a1.2 1.2 0 1 1 0 2.4H16.228a1.2 1.2 0 0 1-1.2-1.2",
    clipRule: "evenodd"
  })), _path3$c || (_path3$c = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M19.278 20.944a1.889 1.889 0 1 1-3.778 0 1.889 1.889 0 0 1 3.778 0M25.889 20.944a1.889 1.889 0 1 1-3.778 0 1.889 1.889 0 0 1 3.778 0M32.5 20.944a1.889 1.889 0 1 1-3.778 0 1.889 1.889 0 0 1 3.778 0M19.278 27.556a1.889 1.889 0 1 1-3.778 0 1.889 1.889 0 0 1 3.778 0M25.889 27.556a1.889 1.889 0 1 1-3.778 0 1.889 1.889 0 0 1 3.778 0M32.5 27.556a1.889 1.889 0 1 1-3.778 0 1.889 1.889 0 0 1 3.778 0M19.278 34.167a1.889 1.889 0 1 1-3.778 0 1.889 1.889 0 0 1 3.778 0M25.889 34.167a1.889 1.889 0 1 1-3.778 0 1.889 1.889 0 0 1 3.778 0M32.5 34.167a1.889 1.889 0 1 1-3.778 0 1.889 1.889 0 0 1 3.778 0"
  })));
};
var Calculator48 = (/* unused pure expression or super */ null && (SvgCalculator48));

var CalculatorIcon = function CalculatorIcon(props) {
  var calculator = {
    12: Calculator12,
    16: Calculator16,
    18: Calculator18,
    24: Calculator24,
    32: Calculator32,
    48: Calculator48
  };
  return jsx(IconTemplate, _assign({
    icons: calculator
  }, props));
};

var _path$an;
function _extends$av() { _extends$av = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$av.apply(this, arguments); }
var SvgCalendar12 = function SvgCalendar12(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$av({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none"
  }, props), _path$an || (_path$an = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M4 .65a.6.6 0 0 1 .6.6v.25h2.8v-.25a.6.6 0 0 1 1.2 0v.25H9A1.5 1.5 0 0 1 10.5 3v6A1.5 1.5 0 0 1 9 10.5H3A1.5 1.5 0 0 1 1.5 9V3A1.5 1.5 0 0 1 3 1.5h.4v-.25a.6.6 0 0 1 .6-.6M7.4 2.7v.05a.6.6 0 0 0 1.2 0V2.7H9a.3.3 0 0 1 .3.3v.4H2.7V3a.3.3 0 0 1 .3-.3h.4v.05a.6.6 0 0 0 1.2 0V2.7zM2.7 4.6V9a.3.3 0 0 0 .3.3h6a.3.3 0 0 0 .3-.3V4.6z",
    clipRule: "evenodd"
  })));
};
var Calendar12 = (/* unused pure expression or super */ null && (SvgCalendar12));

var _path$am;
function _extends$au() { _extends$au = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$au.apply(this, arguments); }
var SvgCalendar16 = function SvgCalendar16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$au({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path$am || (_path$am = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M5.333.967a.7.7 0 0 1 .7.7V2h3.934v-.333a.7.7 0 1 1 1.4 0V2H12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h.633v-.333a.7.7 0 0 1 .7-.7M9.967 3.4v.267a.7.7 0 1 0 1.4 0V3.4H12a.6.6 0 0 1 .6.6v.633H3.4V4a.6.6 0 0 1 .6-.6h.633v.267a.7.7 0 1 0 1.4 0V3.4zM3.4 6.033V12a.6.6 0 0 0 .6.6h8a.6.6 0 0 0 .6-.6V6.033z",
    clipRule: "evenodd"
  })));
};
var Calendar16 = (/* unused pure expression or super */ null && (SvgCalendar16));

var _path$al;
function _extends$at() { _extends$at = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$at.apply(this, arguments); }
var SvgCalendar18 = function SvgCalendar18(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$at({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _path$al || (_path$al = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M6 1.125a.75.75 0 0 1 .75.75v.375h4.5v-.375a.75.75 0 0 1 1.5 0v.375h.75a2.25 2.25 0 0 1 2.25 2.25v9a2.25 2.25 0 0 1-2.25 2.25h-9a2.25 2.25 0 0 1-2.25-2.25v-9A2.25 2.25 0 0 1 4.5 2.25h.75v-.375a.75.75 0 0 1 .75-.75m5.25 2.625v.375a.75.75 0 0 0 1.5 0V3.75h.75a.75.75 0 0 1 .75.75v.75H3.75V4.5a.75.75 0 0 1 .75-.75h.75v.375a.75.75 0 0 0 1.5 0V3.75zm-7.5 3v6.75c0 .414.336.75.75.75h9a.75.75 0 0 0 .75-.75V6.75z",
    clipRule: "evenodd"
  })));
};
var Calendar18 = (/* unused pure expression or super */ null && (SvgCalendar18));

var _path$ak;
function _extends$as() { _extends$as = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$as.apply(this, arguments); }
var SvgCalendar24 = function SvgCalendar24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$as({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path$ak || (_path$ak = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M8 1.6a.9.9 0 0 1 .9.9V3h6.2v-.5a.9.9 0 1 1 1.8 0V3H18a3 3 0 0 1 3 3v12a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3V6a3 3 0 0 1 3-3h1.1v-.5a.9.9 0 0 1 .9-.9m7.1 3.2v.7a.9.9 0 1 0 1.8 0v-.7H18A1.2 1.2 0 0 1 19.2 6v1.1H4.8V6A1.2 1.2 0 0 1 6 4.8h1.1v.7a.9.9 0 0 0 1.8 0v-.7zM4.8 8.9V18A1.2 1.2 0 0 0 6 19.2h12a1.2 1.2 0 0 0 1.2-1.2V8.9z",
    clipRule: "evenodd"
  })));
};
var Calendar24 = (/* unused pure expression or super */ null && (SvgCalendar24));

var _path$aj;
function _extends$ar() { _extends$ar = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$ar.apply(this, arguments); }
var SvgCalendar32 = function SvgCalendar32(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$ar({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _path$aj || (_path$aj = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M10.667 2.333a1 1 0 0 1 1 1V4h8.666v-.667a1 1 0 1 1 2 0V4H24a4 4 0 0 1 4 4v16a4 4 0 0 1-4 4H8a4 4 0 0 1-4-4V8a4 4 0 0 1 4-4h1.667v-.667a1 1 0 0 1 1-1M20.333 6v1.333a1 1 0 1 0 2 0V6H24a2 2 0 0 1 2 2v1.666H6V8a2 2 0 0 1 2-2h1.667v1.333a1 1 0 1 0 2 0V6zM6 11.666V24a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V11.667z",
    clipRule: "evenodd"
  })));
};
var Calendar32 = (/* unused pure expression or super */ null && (SvgCalendar32));

var _path$ai;
function _extends$aq() { _extends$aq = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$aq.apply(this, arguments); }
var SvgCalendar48 = function SvgCalendar48(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$aq({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none"
  }, props), _path$ai || (_path$ai = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M16 3.8A1.2 1.2 0 0 1 17.2 5v1h13.6V5a1.2 1.2 0 0 1 2.4 0v1H36a6 6 0 0 1 6 6v24a6 6 0 0 1-6 6H12a6 6 0 0 1-6-6V12a6 6 0 0 1 6-6h2.8V5A1.2 1.2 0 0 1 16 3.8m14.8 4.6V11a1.2 1.2 0 0 0 2.4 0V8.4H36a3.6 3.6 0 0 1 3.6 3.6v2.8H8.4V12A3.6 3.6 0 0 1 12 8.4h2.8V11a1.2 1.2 0 0 0 2.4 0V8.4zM8.4 17.2V36a3.6 3.6 0 0 0 3.6 3.6h24a3.6 3.6 0 0 0 3.6-3.6V17.2z",
    clipRule: "evenodd"
  })));
};
var Calendar48 = (/* unused pure expression or super */ null && (SvgCalendar48));

var CalendarIcon = function CalendarIcon(props) {
  var calendar = {
    12: Calendar12,
    16: Calendar16,
    18: Calendar18,
    24: Calendar24,
    32: Calendar32,
    48: Calendar48
  };
  return jsx(IconTemplate, _assign({
    icons: calendar
  }, props));
};

var _path$ah;
function _extends$ap() { _extends$ap = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$ap.apply(this, arguments); }
var SvgCall12 = function SvgCall12(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$ap({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none"
  }, props), _path$ah || (_path$ah = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M2.31 3.013q-.017.025-.015.025c-.117.304-.06.874.368 1.704.411.796 1.1 1.706 2 2.605 1.165 1.166 2.264 1.809 3.096 2.12.418.156.757.225.996.24a1 1 0 0 0 .263-.01c.181-.15.406-.374.6-.579a15 15 0 0 0 .322-.35l.019-.02.004-.006.001-.001.013-.015.011-.01-.018-.021-1.331-1.33-.006-.006-.017-.011-.627.627c-.272.271-.616.219-.787.166a2 2 0 0 1-.538-.29c-.364-.26-.874-.712-1.588-1.427-.555-.554-.851-1.058-.94-1.526-.094-.493.057-.87.234-1.109.028-.038.081-.104.112-.143l.023-.029a.5.5 0 0 0 .047-.067l.044-.09.068-.069-.018-.02L3.315 2.04l-.009-.007-.014-.01-.913.914a1 1 0 0 0-.069.076m8.546 6.532-.02.021a20 20 0 0 1-.348.379 8 8 0 0 1-.752.715c-.162.13-.353.19-.514.22a2.2 2.2 0 0 1-.543.025 4.8 4.8 0 0 1-1.34-.314c-1.009-.377-2.25-1.12-3.525-2.395-.96-.96-1.734-1.968-2.217-2.904-.465-.902-.731-1.877-.423-2.682.09-.239.245-.41.356-.522l.919-.918c.258-.258.57-.37.877-.356.385.017.683.223.837.377l1.331 1.331c.307.307.415.675.367 1.02-.036.26-.154.472-.275.618a2 2 0 0 1-.132.191c-.035.046-.054.07-.07.088l-.05.065c-.009.012-.041.055-.02.17.028.142.148.44.61.902.706.705 1.157 1.098 1.435 1.296l.021.015.393-.393c.316-.316.699-.4 1.038-.337.302.056.538.22.676.358l1.331 1.331c.307.307.415.675.367 1.02-.041.298-.191.534-.33.679",
    clipRule: "evenodd"
  })));
};
var Call12 = (/* unused pure expression or super */ null && (SvgCall12));

var _path$ag;
function _extends$ao() { _extends$ao = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$ao.apply(this, arguments); }
var SvgCall16 = function SvgCall16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$ao({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path$ag || (_path$ag = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M3.08 4.017a.2.2 0 0 0-.02.033c-.156.406-.08 1.165.491 2.272.548 1.061 1.467 2.275 2.665 3.474 1.555 1.554 3.02 2.412 4.13 2.827.557.208 1.01.299 1.328.32a1.4 1.4 0 0 0 .35-.015c.241-.2.54-.498.8-.77a21 21 0 0 0 .43-.467l.024-.028.006-.007.002-.002.017-.02.014-.014-.024-.027-1.774-1.775-.009-.007-.022-.014-.837.836a1.2 1.2 0 0 1-.678.337c-.29.041-.584-.019-.87-.136-.55-.226-1.252-.744-2.217-1.708-1.269-1.27-1.692-2.17-1.763-2.807-.066-.591.3-1.002.473-1.175l.623-.623-.025-.027L4.42 2.72l-.012-.01-.019-.012-1.217 1.217a1 1 0 0 0-.092.102m11.394 8.709-.025.028-.106.118c-.09.099-.215.235-.36.387-.281.297-.664.682-1.002.953-.216.174-.47.254-.684.293a3 3 0 0 1-.725.034c-.508-.032-1.117-.167-1.787-.418-1.345-.503-3-1.495-4.7-3.194-1.28-1.28-2.312-2.624-2.956-3.872-.62-1.202-.974-2.503-.564-3.576.122-.318.327-.547.475-.695l1.225-1.225c.344-.344.76-.492 1.17-.474.513.023.91.297 1.116.503l1.774 1.774c.41.41.553.9.49 1.36-.058.413-.27.736-.46.926l-.614.613c.075.241.342.8 1.276 1.734.891.89 1.406 1.23 1.664 1.346l.683-.683c.421-.422.931-.534 1.384-.45.403.076.718.295.902.479l1.774 1.774c.41.41.553.9.49 1.36a1.66 1.66 0 0 1-.44.905",
    clipRule: "evenodd"
  })));
};
var Call16 = (/* unused pure expression or super */ null && (SvgCall16));

var _path$af;
function _extends$an() { _extends$an = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$an.apply(this, arguments); }
var SvgCall18 = function SvgCall18(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$an({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _path$af || (_path$af = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M3.497 4.334a.6.6 0 0 0-.149.187c-.19.498-.087 1.386.558 2.637.622 1.206 1.663 2.58 3.016 3.933 1.758 1.758 3.419 2.731 4.682 3.203.634.237 1.152.343 1.522.366.186.012.318.002.4-.013l.047-.01c.28-.23.628-.578.926-.891a23 23 0 0 0 .485-.527l.029-.032.007-.008.001-.002.018-.02.018-.018a.2.2 0 0 0 .036-.073v-.004a.3.3 0 0 0-.068-.09l-1.997-1.997a.3.3 0 0 0-.123-.069.3.3 0 0 0-.044.037l-.95.949a1.23 1.23 0 0 1-.705.35c-.304.044-.616-.018-.926-.146-.6-.246-1.38-.817-2.463-1.9-1.42-1.42-1.878-2.414-1.954-3.098-.07-.617.311-1.048.503-1.24l.705-.705a.2.2 0 0 0 .036-.073v-.004a.3.3 0 0 0-.068-.09L5.042 2.988l-.024-.02a.4.4 0 0 0-.046-.029.2.2 0 0 0-.053-.02l-.005.003a.3.3 0 0 0-.039.033zm9.415 6.569h-.002zm3.298 3.346-.03.033q-.042.049-.119.132c-.1.11-.24.264-.402.434-.317.333-.744.762-1.118 1.063a1.6 1.6 0 0 1-.726.31c-.242.044-.51.054-.79.036-.56-.036-1.235-.185-1.982-.464-1.498-.56-3.35-1.668-5.252-3.57-1.434-1.434-2.589-2.94-3.307-4.331-.695-1.347-1.076-2.776-.63-3.942.129-.338.349-.584.512-.747l1.378-1.378c.367-.368.807-.523 1.24-.504.545.024.97.317 1.19.536L8.17 3.854c.44.439.59.96.522 1.445-.06.439-.288.783-.49.985l-.704.705-.027.027c.067.261.346.917 1.478 2.049 1.047 1.047 1.643 1.43 1.939 1.552l.026.01.816-.816c.45-.45.99-.567 1.468-.477.429.08.766.314.962.51l1.996 1.996c.44.439.59.96.522 1.445-.059.424-.272.76-.468.964",
    clipRule: "evenodd"
  })));
};
var Call18 = (/* unused pure expression or super */ null && (SvgCall18));

var _path$ae;
function _extends$am() { _extends$am = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$am.apply(this, arguments); }
var SvgCall24 = function SvgCall24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$am({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path$ae || (_path$ae = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M4.545 5.661c-.152.152-.212.245-.236.308-.28.734-.114 1.974.751 3.652.84 1.627 2.24 3.473 4.052 5.285 2.359 2.359 4.593 3.67 6.301 4.31.857.32 1.565.465 2.078.497.258.017.447.003.573-.02a1 1 0 0 0 .115-.03c.386-.313.868-.793 1.274-1.22a31 31 0 0 0 .65-.707l.039-.043.01-.01.021-.026.021-.02a.4.4 0 0 0 .056-.08.3.3 0 0 0 .04-.113.2.2 0 0 0-.008-.082.5.5 0 0 0-.13-.185l-2.663-2.662a.56.56 0 0 0-.252-.137.15.15 0 0 0-.073 0 .33.33 0 0 0-.134.094l-1.266 1.267a1.47 1.47 0 0 1-.846.419c-.368.052-.753-.021-1.148-.184-.768-.315-1.789-1.057-3.229-2.497-1.883-1.883-2.463-3.174-2.558-4.032-.083-.74.373-1.267.623-1.517l.94-.94a.4.4 0 0 0 .056-.08.4.4 0 0 0 .04-.112.2.2 0 0 0-.008-.082.5.5 0 0 0-.13-.185L6.84 3.867a.6.6 0 0 0-.136-.095.4.4 0 0 0-.147-.046.1.1 0 0 0-.053.009.4.4 0 0 0-.123.09zm16.946 13.224-.042.047q-.056.064-.157.175c-.133.147-.32.35-.534.576-.422.443-.984 1.009-1.474 1.402-.27.217-.599.324-.893.379-.307.056-.65.069-1.014.046-.727-.047-1.61-.24-2.594-.609-1.974-.738-4.422-2.2-6.944-4.722-1.903-1.904-3.431-3.897-4.379-5.733-.92-1.786-1.4-3.635-.832-5.12.16-.418.433-.726.644-.938L5.11 2.551c.458-.458 1-.647 1.529-.623.672.03 1.202.392 1.476.666l2.662 2.662c.55.55.73 1.192.648 1.787a2.2 2.2 0 0 1-.605 1.218l-.94.94a1 1 0 0 0-.097.11c.062.335.392 1.254 2.032 2.893 1.4 1.4 2.213 1.93 2.64 2.106q.09.036.144.05l1.16-1.16c.559-.56 1.222-.701 1.81-.591.53.099.95.39 1.194.633l2.662 2.663c.55.549.73 1.19.649 1.786a2.2 2.2 0 0 1-.582 1.194",
    clipRule: "evenodd"
  })));
};
var Call24 = (/* unused pure expression or super */ null && (SvgCall24));

var _path$ad;
function _extends$al() { _extends$al = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$al.apply(this, arguments); }
var SvgCall32 = function SvgCall32(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$al({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _path$ad || (_path$ad = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M5.919 7.407c-.21.209-.313.357-.36.48-.407 1.062-.15 2.783 1.01 5.032 1.131 2.193 3.012 4.67 5.44 7.097 3.162 3.163 6.165 4.929 8.472 5.792 1.157.432 2.12.63 2.828.676.355.022.625.005.813-.03.156-.028.216-.062.221-.063.53-.427 1.19-1.085 1.74-1.663a41 41 0 0 0 .871-.947l.052-.058.013-.015.025-.028.023-.024a.72.72 0 0 0 .184-.37.4.4 0 0 0-.02-.201.9.9 0 0 0-.221-.323l-3.55-3.55a.94.94 0 0 0-.44-.238.4.4 0 0 0-.192.006.64.64 0 0 0-.262.175l-1.689 1.688a1.76 1.76 0 0 1-1.015.503c-.444.063-.92-.024-1.426-.232-.987-.405-2.324-1.37-4.24-3.286-2.498-2.498-3.233-4.18-3.354-5.257-.1-.89.449-1.533.774-1.86L12.87 9.46a.72.72 0 0 0 .183-.37.4.4 0 0 0-.019-.202.9.9 0 0 0-.222-.323l-3.55-3.55a1 1 0 0 0-.231-.163.7.7 0 0 0-.278-.083.4.4 0 0 0-.153.025.7.7 0 0 0-.232.164zm22.588 17.638-.002.001-.056.064a37 37 0 0 1-.917.996c-.561.59-1.303 1.335-1.946 1.851-.325.261-.726.395-1.102.464-.389.072-.83.089-1.302.059-.945-.06-2.104-.314-3.401-.8-2.602-.972-5.843-2.905-9.187-6.25-2.528-2.528-4.551-5.168-5.802-7.594C3.57 11.467 2.965 9.069 3.69 7.173c.198-.518.539-.905.815-1.18l2.449-2.45c.572-.572 1.24-.802 1.888-.773.83.037 1.492.488 1.835.83l3.55 3.55c.689.689.908 1.483.807 2.213a2.7 2.7 0 0 1-.75 1.51l-1.253 1.253a1 1 0 0 0-.198.249c.059.443.458 1.72 2.778 4.039 1.87 1.87 2.978 2.6 3.585 2.85.169.07.276.092.333.1l1.623-1.623c.695-.696 1.513-.868 2.235-.733a2.94 2.94 0 0 1 1.488.79l3.55 3.55c.688.689.908 1.482.807 2.212a2.7 2.7 0 0 1-.725 1.485",
    clipRule: "evenodd"
  })));
};
var Call32 = (/* unused pure expression or super */ null && (SvgCall32));

var _path$ac;
function _extends$ak() { _extends$ak = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$ak.apply(this, arguments); }
var SvgCall48 = function SvgCall48(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$ak({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none"
  }, props), _path$ac || (_path$ac = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M8.666 10.898c-.324.324-.515.581-.609.825-.656 1.718-.22 4.401 1.53 7.793 1.715 3.325 4.557 7.065 8.213 10.72 4.772 4.772 9.311 7.445 12.816 8.756 1.757.657 3.23.963 4.329 1.033.55.035.98.009 1.292-.049.155-.028.268-.062.347-.093.08-.032.107-.055.104-.052.814-.653 1.822-1.659 2.653-2.532a62 62 0 0 0 1.315-1.428l.078-.088.02-.023.005-.006.026-.03.028-.028c.137-.136.318-.418.36-.726.033-.237.005-.59-.446-1.04l-5.324-5.324a1.7 1.7 0 0 0-.82-.44c-.254-.048-.566-.027-.947.354l-2.532 2.533c-.29.29-.728.58-1.353.669-.598.085-1.257-.03-1.984-.329-1.422-.584-3.394-1.997-6.26-4.863-3.728-3.728-4.776-6.19-4.946-7.707-.133-1.19.598-2.066 1.076-2.543l1.88-1.88c.136-.137.317-.419.36-.726.033-.237.004-.59-.447-1.04L14.106 7.31a1.8 1.8 0 0 0-.423-.301 1.3 1.3 0 0 0-.54-.157.84.84 0 0 0-.353.058c-.12.047-.273.137-.45.313zM42.54 37.363l-.007.008-.084.095c-.073.082-.178.2-.31.345-.263.29-.633.693-1.059 1.141-.84.884-1.942 1.99-2.889 2.75-.434.349-.982.536-1.519.635-.553.102-1.188.127-1.88.083-1.383-.088-3.09-.46-5.016-1.18-3.86-1.443-8.684-4.317-13.673-9.307-3.777-3.777-6.79-7.713-8.65-11.317-1.823-3.535-2.677-7.03-1.637-9.75.274-.717.75-1.262 1.153-1.666l3.674-3.674c.799-.798 1.72-1.111 2.606-1.072 1.149.052 2.074.678 2.554 1.159l5.325 5.324c.969.969 1.265 2.066 1.126 3.066a3.78 3.78 0 0 1-1.04 2.094l-1.88 1.88a1.9 1.9 0 0 0-.34.426c-.053.1-.049.14-.047.154.08.727.688 2.708 4.256 6.276 2.813 2.812 4.51 3.943 5.477 4.34.468.193.684.18.733.173l.004-.001 2.522-2.522c.97-.97 2.095-1.202 3.086-1.017.915.171 1.651.68 2.075 1.103l5.324 5.324c.969.97 1.265 2.067 1.127 3.066a3.8 3.8 0 0 1-1.01 2.064",
    clipRule: "evenodd"
  })));
};
var Call48 = (/* unused pure expression or super */ null && (SvgCall48));

var CallIcon = function CallIcon(props) {
  var call = {
    12: Call12,
    16: Call16,
    18: Call18,
    24: Call24,
    32: Call32,
    48: Call48
  };
  return jsx(IconTemplate, _assign({
    icons: call
  }, props));
};

var _path$ab;
function _extends$aj() { _extends$aj = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$aj.apply(this, arguments); }
var SvgCallFilled12 = function SvgCallFilled12(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$aj({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none"
  }, props), _path$ab || (_path$ab = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M2.785 1.505 1.718 2.572l-.008.014c-.345.59-.205 1.434.237 2.343.445.919 1.216 1.944 2.202 2.93 1.232 1.232 2.417 1.936 3.356 2.287.47.175.88.263 1.204.284q.246.015.427-.018a.7.7 0 0 0 .302-.123c.227-.182.496-.451.705-.672a16 16 0 0 0 .338-.367l.021-.023.005-.006a.77.77 0 0 0 .207-.42c.027-.195-.027-.415-.232-.62l-1.33-1.33a.85.85 0 0 0-.428-.228.67.67 0 0 0-.615.206l-.634.633a.16.16 0 0 1-.097.047.54.54 0 0 1-.275-.054c-.275-.113-.719-.416-1.426-1.123-.702-.703-.97-1.18-1.067-1.471a.8.8 0 0 1-.05-.299.3.3 0 0 1 .007-.049L5.18 3.9a.77.77 0 0 0 .21-.424c.027-.194-.027-.414-.232-.618l-1.33-1.331a.83.83 0 0 0-.523-.239.68.68 0 0 0-.52.217",
    clipRule: "evenodd"
  })));
};
var CallFilled12 = (/* unused pure expression or super */ null && (SvgCallFilled12));

var _path$aa;
function _extends$ai() { _extends$ai = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$ai.apply(this, arguments); }
var SvgCallFilled16 = function SvgCallFilled16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$ai({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path$aa || (_path$aa = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M3.713 2.007 2.29 3.43l-.01.018c-.46.788-.273 1.912.316 3.125.594 1.224 1.621 2.591 2.937 3.907 1.642 1.642 3.222 2.58 4.474 3.048.625.234 1.172.352 1.605.38q.327.02.57-.025c.159-.03.3-.081.402-.164.303-.243.661-.602.94-.896.14-.147.263-.28.35-.376l.101-.113.028-.031.006-.007c.113-.115.243-.315.277-.561.036-.26-.037-.553-.31-.825l-1.774-1.775a1.14 1.14 0 0 0-.57-.303c-.259-.049-.554.008-.82.274l-.845.844a.22.22 0 0 1-.13.063c-.07.01-.185.002-.366-.072-.366-.151-.959-.555-1.901-1.498-.937-.937-1.295-1.574-1.424-1.962a1.1 1.1 0 0 1-.066-.397.4.4 0 0 1 .009-.066l.817-.817c.114-.114.246-.316.281-.565.036-.26-.037-.553-.31-.825L5.104 2.036a1.1 1.1 0 0 0-.697-.318.9.9 0 0 0-.693.29",
    clipRule: "evenodd"
  })));
};
var CallFilled16 = (/* unused pure expression or super */ null && (SvgCallFilled16));

var _path$a9;
function _extends$ah() { _extends$ah = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$ah.apply(this, arguments); }
var SvgCallFilled18 = function SvgCallFilled18(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$ah({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _path$a9 || (_path$a9 = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "m4.177 2.258-1.6 1.6-.013.021c-.517.886-.306 2.151.356 3.515.669 1.378 1.824 2.915 3.304 4.395 1.847 1.848 3.625 2.903 5.034 3.43.704.263 1.318.396 1.806.427.244.015.46.005.64-.028s.337-.091.453-.184c.34-.274.744-.677 1.058-1.008a24 24 0 0 0 .507-.55l.031-.036.007-.008c.127-.129.273-.354.312-.63.04-.292-.042-.622-.349-.93l-1.996-1.996a1.28 1.28 0 0 0-.64-.34c-.292-.055-.625.009-.924.308l-.95.95a.24.24 0 0 1-.146.07c-.079.012-.208.003-.412-.081-.412-.17-1.079-.624-2.14-1.685-1.053-1.054-1.455-1.77-1.6-2.207a1.2 1.2 0 0 1-.075-.447 1 1 0 0 1 .01-.074l.92-.92c.128-.127.277-.355.315-.635.04-.291-.041-.622-.348-.928L5.741 2.29a1.24 1.24 0 0 0-.784-.357c-.258-.012-.532.077-.78.325",
    clipRule: "evenodd"
  })));
};
var CallFilled18 = (/* unused pure expression or super */ null && (SvgCallFilled18));

var _path$a8;
function _extends$ag() { _extends$ag = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$ag.apply(this, arguments); }
var SvgCallFilled24 = function SvgCallFilled24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$ag({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path$a8 || (_path$a8 = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M5.569 3.01 3.435 5.145l-.016.028c-.69 1.182-.408 2.868.474 4.687.892 1.837 2.433 3.887 4.406 5.86 2.463 2.463 4.834 3.871 6.712 4.573.938.351 1.758.528 2.408.569q.49.03.854-.037c.238-.044.449-.122.604-.246.453-.364.99-.902 1.41-1.343a32 32 0 0 0 .676-.735l.041-.046.01-.01a1.54 1.54 0 0 0 .415-.842c.053-.389-.056-.829-.464-1.238l-2.663-2.662a1.7 1.7 0 0 0-.854-.455c-.388-.072-.832.013-1.23.412l-1.267 1.266a.33.33 0 0 1-.195.094c-.105.015-.277.003-.55-.108-.55-.226-1.438-.833-2.852-2.247-1.405-1.405-1.941-2.36-2.135-2.942-.096-.29-.107-.484-.1-.597a1 1 0 0 1 .014-.098l1.226-1.226c.171-.17.37-.474.421-.848.054-.388-.055-.828-.464-1.237L7.654 3.054c-.2-.2-.585-.457-1.045-.477-.343-.015-.709.103-1.04.434"
  })));
};
var CallFilled24 = (/* unused pure expression or super */ null && (SvgCallFilled24));

var _path$a7;
function _extends$af() { _extends$af = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$af.apply(this, arguments); }
var SvgCallFilled32 = function SvgCallFilled32(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$af({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _path$a7 || (_path$a7 = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M7.426 4.014 4.58 6.86l-.022.037c-.92 1.575-.545 3.824.632 6.25 1.189 2.448 3.243 5.182 5.875 7.813 3.283 3.284 6.444 5.16 8.948 6.097 1.251.468 2.344.703 3.21.758.434.028.818.01 1.14-.049.317-.058.599-.162.805-.328.605-.486 1.322-1.203 1.88-1.79a42 42 0 0 0 .902-.98l.055-.062.012-.014c.226-.23.485-.63.554-1.122.071-.518-.074-1.105-.62-1.65l-3.549-3.55a2.27 2.27 0 0 0-1.139-.606c-.517-.097-1.109.017-1.64.549l-1.69 1.688a.43.43 0 0 1-.26.126c-.139.02-.369.004-.731-.145-.734-.302-1.918-1.11-3.804-2.996-1.873-1.873-2.588-3.147-2.846-3.922-.129-.386-.143-.646-.133-.796a1 1 0 0 1 .018-.131l1.635-1.635c.227-.227.492-.632.561-1.13.072-.518-.074-1.105-.619-1.65l-3.55-3.55c-.266-.267-.78-.608-1.393-.635-.458-.02-.945.137-1.386.578",
    clipRule: "evenodd"
  })));
};
var CallFilled32 = (/* unused pure expression or super */ null && (SvgCallFilled32));

var _path$a6;
function _extends$ae() { _extends$ae = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$ae.apply(this, arguments); }
var SvgCallFilled48 = function SvgCallFilled48(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$ae({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none"
  }, props), _path$a6 || (_path$a6 = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "m11.138 6.022-4.267 4.267-.033.056c-1.38 2.362-.817 5.735.949 9.373 1.783 3.674 4.865 7.774 8.811 11.72 4.926 4.927 9.667 7.742 13.423 9.147 1.876.701 3.516 1.054 4.816 1.137.65.041 1.225.015 1.708-.074.477-.087.899-.243 1.208-.492.908-.729 1.983-1.805 2.82-2.686A64 64 0 0 0 41.926 37l.082-.092.02-.022c.338-.343.727-.944.83-1.683.107-.777-.111-1.657-.929-2.475l-5.324-5.324a3.4 3.4 0 0 0-1.709-.91c-.776-.144-1.663.026-2.462.824l-2.532 2.533a.65.65 0 0 1-.39.188c-.21.03-.555.006-1.098-.218-1.1-.452-2.877-1.665-5.705-4.493-2.81-2.81-3.883-4.72-4.27-5.884-.193-.578-.215-.969-.2-1.194q.011-.134.028-.196l2.452-2.452c.341-.341.738-.948.842-1.695.108-.777-.11-1.657-.928-2.475l-5.324-5.324c-.401-.401-1.171-.913-2.09-.954-.688-.03-1.418.205-2.08.868"
  })));
};
var CallFilled48 = (/* unused pure expression or super */ null && (SvgCallFilled48));

var CallFilledIcon = function CallFilledIcon(props) {
  var callFilled = {
    12: CallFilled12,
    16: CallFilled16,
    18: CallFilled18,
    24: CallFilled24,
    32: CallFilled32,
    48: CallFilled48
  };
  return jsx(IconTemplate, _assign({
    icons: callFilled
  }, props));
};

var _path$a5, _path2$3o;
function _extends$ad() { _extends$ad = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$ad.apply(this, arguments); }
var SvgCamera12 = function SvgCamera12(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$ad({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none"
  }, props), _path$a5 || (_path$a5 = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "m4.864 2.8-.487.925a.61.61 0 0 1-.539.323H2.372a.4.4 0 0 0-.404.4V8.8c0 .221.18.4.404.4h7.255c.224 0 .405-.179.405-.4V4.448c0-.22-.181-.4-.405-.4H8.136a.61.61 0 0 1-.534-.315l-.51-.933zm-1.048-.608c.191-.364.572-.592.986-.592h2.35c.408 0 .784.221.978.577l.368.671h1.13a1.61 1.61 0 0 1 1.617 1.6V8.8c0 .884-.724 1.6-1.618 1.6H2.372A1.61 1.61 0 0 1 .754 8.8V4.448c0-.884.725-1.6 1.618-1.6H3.47z",
    clipRule: "evenodd"
  })), _path2$3o || (_path2$3o = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M5.987 7.175a.805.805 0 0 0 .81-.8c0-.442-.363-.8-.81-.8a.805.805 0 0 0-.809.8c0 .442.362.8.81.8m0 1.2a2.01 2.01 0 0 0 2.023-2c0-1.104-.906-2-2.023-2a2.01 2.01 0 0 0-2.022 2c0 1.105.905 2 2.022 2",
    clipRule: "evenodd"
  })));
};
var Camera12 = (/* unused pure expression or super */ null && (SvgCamera12));

var _path$a4, _path2$3n;
function _extends$ac() { _extends$ac = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$ac.apply(this, arguments); }
var SvgCamera16 = function SvgCamera16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$ac({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path$a4 || (_path$a4 = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "m6.485 3.733-.65 1.234a.81.81 0 0 1-.717.43H3.163a.536.536 0 0 0-.539.534v5.802c0 .295.241.534.54.534h9.673c.298 0 .54-.24.54-.534V5.93a.536.536 0 0 0-.54-.533h-1.989a.81.81 0 0 1-.711-.42l-.681-1.244zm-1.397-.81c.256-.486.763-.79 1.315-.79h3.133c.545 0 1.046.295 1.305.77l.49.894h1.506c1.191 0 2.157.955 2.157 2.133v5.803c0 1.178-.966 2.134-2.157 2.134H3.163c-1.191 0-2.157-.956-2.157-2.134V5.931c0-1.179.966-2.134 2.157-2.134h1.464z",
    clipRule: "evenodd"
  })), _path2$3n || (_path2$3n = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M7.983 9.567c.596 0 1.079-.478 1.079-1.067 0-.59-.483-1.067-1.079-1.067-.595 0-1.078.478-1.078 1.067 0 .59.483 1.067 1.078 1.067m0 1.6c1.49 0 2.697-1.194 2.697-2.667S9.472 5.833 7.983 5.833 5.287 7.027 5.287 8.5s1.207 2.667 2.696 2.667",
    clipRule: "evenodd"
  })));
};
var Camera16 = (/* unused pure expression or super */ null && (SvgCamera16));

var _path$a3, _path2$3m;
function _extends$ab() { _extends$ab = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$ab.apply(this, arguments); }
var SvgCamera18 = function SvgCamera18(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$ab({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _path$a3 || (_path$a3 = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "m7.234 4.1-.759 1.441a.81.81 0 0 1-.717.43h-2.2a.704.704 0 0 0-.707.7V13.2c0 .387.317.7.708.7H14.44c.391 0 .708-.313.708-.7V6.672c0-.387-.317-.7-.708-.7h-2.237a.81.81 0 0 1-.712-.42L10.699 4.1zm-1.42-.766a1.57 1.57 0 0 1 1.39-.834h3.524a1.57 1.57 0 0 1 1.379.813l.58 1.059h1.754c1.285 0 2.326 1.03 2.326 2.3V13.2c0 1.27-1.041 2.3-2.326 2.3H3.56c-1.285 0-2.326-1.03-2.326-2.3V6.672c0-1.27 1.041-2.3 2.326-2.3h1.708z",
    clipRule: "evenodd"
  })), _path2$3m || (_path2$3m = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M8.981 10.963c.782 0 1.416-.627 1.416-1.4 0-.774-.634-1.4-1.416-1.4s-1.416.626-1.416 1.4.634 1.4 1.416 1.4m0 1.6c1.675 0 3.034-1.344 3.034-3 0-1.657-1.359-3-3.034-3s-3.033 1.343-3.033 3c0 1.656 1.358 3 3.033 3",
    clipRule: "evenodd"
  })));
};
var Camera18 = (/* unused pure expression or super */ null && (SvgCamera18));

var _path$a2, _path2$3l;
function _extends$aa() { _extends$aa = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$aa.apply(this, arguments); }
var SvgCamera24 = function SvgCamera24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$aa({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path$a2 || (_path$a2 = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M9.605 5.3a.1.1 0 0 0-.09.054l-1.03 1.958a.91.91 0 0 1-.808.484H4.745c-.614 0-1.112.492-1.112 1.1V17.6c0 .607.498 1.1 1.112 1.1h14.51c.614 0 1.112-.492 1.112-1.1V8.896c0-.608-.498-1.1-1.112-1.1h-2.983a.91.91 0 0 1-.8-.472l-1.079-1.972a.1.1 0 0 0-.089-.052zm-1.704-.778A1.92 1.92 0 0 1 9.605 3.5h4.7c.705 0 1.354.382 1.69.996l.82 1.5h2.44c1.62 0 2.933 1.298 2.933 2.9V17.6c0 1.602-1.313 2.9-2.933 2.9H4.745c-1.62 0-2.932-1.298-2.932-2.9V8.896c0-1.602 1.312-2.9 2.932-2.9h2.38z",
    clipRule: "evenodd"
  })), _path2$3l || (_path2$3l = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M11.975 14.95c1.228 0 2.224-.985 2.224-2.2s-.996-2.2-2.224-2.2-2.225.985-2.225 2.2.996 2.2 2.225 2.2m0 1.8c2.234 0 4.045-1.79 4.045-4s-1.811-4-4.045-4-4.045 1.79-4.045 4 1.811 4 4.045 4",
    clipRule: "evenodd"
  })));
};
var Camera24 = (/* unused pure expression or super */ null && (SvgCamera24));

var _path$a1, _path2$3k;
function _extends$a9() { _extends$a9 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$a9.apply(this, arguments); }
var SvgCamera32 = function SvgCamera32(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$a9({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _path$a1 || (_path$a1 = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M12.807 6.867c-.126 0-.241.069-.3.179l-1.374 2.61c-.174.331-.52.538-.897.538h-3.91c-.93 0-1.685.747-1.685 1.667v11.606c0 .92.755 1.666 1.686 1.666h19.347c.93 0 1.685-.746 1.685-1.666V11.86c0-.92-.755-1.667-1.686-1.667h-3.977c-.371 0-.713-.2-.89-.524L19.37 7.041a.34.34 0 0 0-.296-.174zm-2.093-.745a2.36 2.36 0 0 1 2.093-1.255h6.266c.866 0 1.663.47 2.075 1.223l1.15 2.104h3.376c2.047 0 3.707 1.642 3.707 3.667v11.606c0 2.025-1.66 3.666-3.707 3.666H6.326c-2.048 0-3.708-1.641-3.708-3.666V11.86c0-2.025 1.66-3.667 3.708-3.667h3.296z",
    clipRule: "evenodd"
  })), _path2$3k || (_path2$3k = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M15.966 20.333c1.862 0 3.371-1.492 3.371-3.333 0-1.84-1.51-3.333-3.37-3.333-1.862 0-3.371 1.492-3.371 3.333s1.509 3.333 3.37 3.333m0 2c2.979 0 5.393-2.387 5.393-5.333 0-2.945-2.414-5.333-5.393-5.333S10.574 14.055 10.574 17s2.414 5.333 5.392 5.333",
    clipRule: "evenodd"
  })));
};
var Camera32 = (/* unused pure expression or super */ null && (SvgCamera32));

var _path$a0, _path2$3j;
function _extends$a8() { _extends$a8 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$a8.apply(this, arguments); }
var SvgCamera48 = function SvgCamera48(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$a8({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none"
  }, props), _path$a0 || (_path$a0 = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M19.21 10a.81.81 0 0 0-.717.43l-2.062 3.916a1.22 1.22 0 0 1-1.077.646H9.49c-1.564 0-2.831 1.253-2.831 2.8V35.2c0 1.546 1.267 2.8 2.83 2.8H38.51c1.564 0 2.832-1.254 2.832-2.8V17.792c0-1.547-1.268-2.8-2.832-2.8h-5.966c-.445 0-.855-.242-1.067-.63L29.32 10.42A.81.81 0 0 0 28.61 10zm-2.87-.678A3.24 3.24 0 0 1 19.21 7.6h9.399c1.188 0 2.28.644 2.846 1.678l1.813 3.314h5.242c2.904 0 5.258 2.328 5.258 5.2V35.2c0 2.872-2.354 5.2-5.258 5.2H9.49c-2.904 0-5.258-2.328-5.258-5.2V17.792c0-2.872 2.354-5.2 5.258-5.2h5.128z",
    clipRule: "evenodd"
  })), _path2$3j || (_path2$3j = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M23.95 31.1c3.127 0 5.662-2.507 5.662-5.6s-2.535-5.6-5.662-5.6c-3.128 0-5.663 2.507-5.663 5.6s2.535 5.6 5.663 5.6m0 2.4c4.467 0 8.089-3.582 8.089-8s-3.622-8-8.09-8c-4.467 0-8.089 3.582-8.089 8s3.622 8 8.09 8",
    clipRule: "evenodd"
  })));
};
var Camera48 = (/* unused pure expression or super */ null && (SvgCamera48));

var CameraIcon = function CameraIcon(props) {
  var camera = {
    12: Camera12,
    16: Camera16,
    18: Camera18,
    24: Camera24,
    32: Camera32,
    48: Camera48
  };
  return jsx(IconTemplate, _assign({
    icons: camera
  }, props));
};

var _path$9$;
function _extends$a7() { _extends$a7 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$a7.apply(this, arguments); }
var SvgCameraFilled12 = function SvgCameraFilled12(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$a7({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none"
  }, props), _path$9$ || (_path$9$ = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M2 2.86h1.67l.569-1.091a.5.5 0 0 1 .443-.269h2.587a.5.5 0 0 1 .44.262l.593 1.098H10a1 1 0 0 1 1 1v5.173a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V3.86a1 1 0 0 1 1-1M7.166 6.3a1.18 1.18 0 1 1-2.36 0 1.18 1.18 0 0 1 2.36 0m1 0a2.18 2.18 0 1 1-4.36 0 2.18 2.18 0 0 1 4.36 0",
    clipRule: "evenodd"
  })));
};
var CameraFilled12 = (/* unused pure expression or super */ null && (SvgCameraFilled12));

var _path$9_;
function _extends$a6() { _extends$a6 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$a6.apply(this, arguments); }
var SvgCameraFilled16 = function SvgCameraFilled16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$a6({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path$9_ || (_path$9_ = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M2.833 3.813h2.06l.665-1.275A1 1 0 0 1 6.445 2h3.048a1 1 0 0 1 .88.524l.697 1.29h2.097a1.5 1.5 0 0 1 1.5 1.5v6.564a1.5 1.5 0 0 1-1.5 1.5H2.833a1.5 1.5 0 0 1-1.5-1.5V5.313a1.5 1.5 0 0 1 1.5-1.5m6.655 4.588a1.506 1.506 0 1 1-3.013 0 1.506 1.506 0 0 1 3.013 0m1.4 0a2.906 2.906 0 1 1-5.813 0 2.906 2.906 0 0 1 5.813 0",
    clipRule: "evenodd"
  })));
};
var CameraFilled16 = (/* unused pure expression or super */ null && (SvgCameraFilled16));

var _path$9Z;
function _extends$a5() { _extends$a5 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$a5.apply(this, arguments); }
var SvgCameraFilled18 = function SvgCameraFilled18(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$a5({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _path$9Z || (_path$9Z = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M3 4.29h2.505l.783-1.502a1 1 0 0 1 .887-.538h3.58a1 1 0 0 1 .879.524l.82 1.516H15a1.5 1.5 0 0 1 1.5 1.5v7.76a1.5 1.5 0 0 1-1.5 1.5H3a1.5 1.5 0 0 1-1.5-1.5V5.79A1.5 1.5 0 0 1 3 4.29m7.65 5.16a1.67 1.67 0 1 1-3.34 0 1.67 1.67 0 0 1 3.34 0m1.6 0a3.27 3.27 0 1 1-6.54 0 3.27 3.27 0 0 1 6.54 0",
    clipRule: "evenodd"
  })));
};
var CameraFilled18 = (/* unused pure expression or super */ null && (SvgCameraFilled18));

var _path$9Y;
function _extends$a4() { _extends$a4 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$a4.apply(this, arguments); }
var SvgCameraFilled24 = function SvgCameraFilled24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$a4({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path$9Y || (_path$9Y = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M4 5.72h3.34l1.137-2.182A1 1 0 0 1 9.364 3h5.173a1 1 0 0 1 .88.524l1.188 2.196H20a2 2 0 0 1 2 2v10.347a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V7.72a2 2 0 0 1 2-2m10.533 6.88a2.56 2.56 0 1 1-5.12 0 2.56 2.56 0 0 1 5.12 0m1.8 0a4.36 4.36 0 1 1-8.72 0 4.36 4.36 0 0 1 8.72 0",
    clipRule: "evenodd"
  })));
};
var CameraFilled24 = (/* unused pure expression or super */ null && (SvgCameraFilled24));

var _path$9X;
function _extends$a3() { _extends$a3 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$a3.apply(this, arguments); }
var SvgCameraFilled32 = function SvgCameraFilled32(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$a3({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _path$9X || (_path$9X = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M5.167 7.627h4.62l1.469-2.82A1.5 1.5 0 0 1 12.586 4h6.698a1.5 1.5 0 0 1 1.32.786l1.536 2.84h4.693a2.5 2.5 0 0 1 2.5 2.5v14.13a2.5 2.5 0 0 1-2.5 2.5H5.167a2.5 2.5 0 0 1-2.5-2.5v-14.13a2.5 2.5 0 0 1 2.5-2.5m14.61 9.174a3.813 3.813 0 1 1-7.626 0 3.813 3.813 0 0 1 7.625 0m2 0a5.813 5.813 0 1 1-11.626 0 5.813 5.813 0 0 1 11.625 0",
    clipRule: "evenodd"
  })));
};
var CameraFilled32 = (/* unused pure expression or super */ null && (SvgCameraFilled32));

var _path$9W;
function _extends$a2() { _extends$a2 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$a2.apply(this, arguments); }
var SvgCameraFilled48 = function SvgCameraFilled48(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$a2({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none"
  }, props), _path$9W || (_path$9W = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M8 11.44h6.681l2.273-4.364A2 2 0 0 1 18.728 6h10.347a2 2 0 0 1 1.76 1.048l2.375 4.392H40a4 4 0 0 1 4 4v20.694a4 4 0 0 1-4 4H8a4 4 0 0 1-4-4V15.44a4 4 0 0 1 4-4m22.265 13.762a6.32 6.32 0 1 1-12.639 0 6.32 6.32 0 0 1 12.639 0m2.4 0a8.72 8.72 0 1 1-17.439 0 8.72 8.72 0 0 1 17.439 0",
    clipRule: "evenodd"
  })));
};
var CameraFilled48 = (/* unused pure expression or super */ null && (SvgCameraFilled48));

var CameraFilledIcon = function CameraFilledIcon(props) {
  var cameraFilled = {
    12: CameraFilled12,
    16: CameraFilled16,
    18: CameraFilled18,
    24: CameraFilled24,
    32: CameraFilled32,
    48: CameraFilled48
  };
  return jsx(IconTemplate, _assign({
    icons: cameraFilled
  }, props));
};

var _path$9V, _path2$3i;
function _extends$a1() { _extends$a1 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$a1.apply(this, arguments); }
var SvgCard12 = function SvgCard12(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$a1({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none"
  }, props), _path$9V || (_path$9V = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M9.5 3.2h-7a.3.3 0 0 0-.3.3v5a.3.3 0 0 0 .3.3h7a.3.3 0 0 0 .3-.3v-5a.3.3 0 0 0-.3-.3M2.5 2A1.5 1.5 0 0 0 1 3.5v5A1.5 1.5 0 0 0 2.5 10h7A1.5 1.5 0 0 0 11 8.5v-5A1.5 1.5 0 0 0 9.5 2z",
    clipRule: "evenodd"
  })), _path2$3i || (_path2$3i = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M1.5 4.9a.6.6 0 0 1 .6-.6h7.8a.6.6 0 1 1 0 1.2H2.1a.6.6 0 0 1-.6-.6M6.7 6.8a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 0 1h-1a.5.5 0 0 1-.5-.5",
    clipRule: "evenodd"
  })));
};
var Card12 = (/* unused pure expression or super */ null && (SvgCard12));

var _path$9U, _path2$3h;
function _extends$a0() { _extends$a0 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$a0.apply(this, arguments); }
var SvgCard16 = function SvgCard16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$a0({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path$9U || (_path$9U = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M12.667 4.167H3.333a.5.5 0 0 0-.5.5v6.666a.5.5 0 0 0 .5.5h9.334a.5.5 0 0 0 .5-.5V4.667a.5.5 0 0 0-.5-.5m-9.334-1.5a2 2 0 0 0-2 2v6.666a2 2 0 0 0 2 2h9.334a2 2 0 0 0 2-2V4.667a2 2 0 0 0-2-2z",
    clipRule: "evenodd"
  })), _path2$3h || (_path2$3h = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M2 5.917a.75.75 0 0 1 .75-.75h10.5a.75.75 0 0 1 0 1.5H2.75a.75.75 0 0 1-.75-.75M10 8.25a.75.75 0 0 1 .75-.75h1.167a.75.75 0 0 1 0 1.5H10.75a.75.75 0 0 1-.75-.75",
    clipRule: "evenodd"
  })));
};
var Card16 = (/* unused pure expression or super */ null && (SvgCard16));

var _path$9T, _path2$3g;
function _extends$9$() { _extends$9$ = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$9$.apply(this, arguments); }
var SvgCard18 = function SvgCard18(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$9$({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _path$9T || (_path$9T = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M14.25 4.6H3.75a.65.65 0 0 0-.65.65v7.5c0 .359.291.65.65.65h10.5a.65.65 0 0 0 .65-.65v-7.5a.65.65 0 0 0-.65-.65M3.75 3A2.25 2.25 0 0 0 1.5 5.25v7.5A2.25 2.25 0 0 0 3.75 15h10.5a2.25 2.25 0 0 0 2.25-2.25v-7.5A2.25 2.25 0 0 0 14.25 3z",
    clipRule: "evenodd"
  })), _path2$3g || (_path2$3g = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M2.25 6.7a.8.8 0 0 1 .8-.8h11.9a.8.8 0 0 1 0 1.6H3.05a.8.8 0 0 1-.8-.8M11.25 9.325a.8.8 0 0 1 .8-.8h1.4a.8.8 0 0 1 0 1.6h-1.4a.8.8 0 0 1-.8-.8",
    clipRule: "evenodd"
  })));
};
var Card18 = (/* unused pure expression or super */ null && (SvgCard18));

var _path$9S, _path2$3f;
function _extends$9_() { _extends$9_ = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$9_.apply(this, arguments); }
var SvgCard24 = function SvgCard24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$9_({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path$9S || (_path$9S = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M19 5.8H5A1.2 1.2 0 0 0 3.8 7v10A1.2 1.2 0 0 0 5 18.2h14a1.2 1.2 0 0 0 1.2-1.2V7A1.2 1.2 0 0 0 19 5.8M5 4a3 3 0 0 0-3 3v10a3 3 0 0 0 3 3h14a3 3 0 0 0 3-3V7a3 3 0 0 0-3-3z",
    clipRule: "evenodd"
  })), _path2$3f || (_path2$3f = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M3 9.1a.9.9 0 0 1 .9-.9h16.2a.9.9 0 1 1 0 1.8H3.9a.9.9 0 0 1-.9-.9M15 12.6a.9.9 0 0 1 .9-.9h2.2a.9.9 0 1 1 0 1.8h-2.2a.9.9 0 0 1-.9-.9",
    clipRule: "evenodd"
  })));
};
var Card24 = (/* unused pure expression or super */ null && (SvgCard24));

var _path$9R, _path2$3e;
function _extends$9Z() { _extends$9Z = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$9Z.apply(this, arguments); }
var SvgCard32 = function SvgCard32(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$9Z({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _path$9R || (_path$9R = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M25.333 7.334H6.667a2 2 0 0 0-2 2v13.333a2 2 0 0 0 2 2h18.666a2 2 0 0 0 2-2V9.334a2 2 0 0 0-2-2m-18.666-2a4 4 0 0 0-4 4v13.333a4 4 0 0 0 4 4h18.666a4 4 0 0 0 4-4V9.334a4 4 0 0 0-4-4z",
    clipRule: "evenodd"
  })), _path2$3e || (_path2$3e = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M4 12.334a1 1 0 0 1 1-1h22a1 1 0 1 1 0 2H5a1 1 0 0 1-1-1M20 17a1 1 0 0 1 1-1h3.333a1 1 0 1 1 0 2H21a1 1 0 0 1-1-1",
    clipRule: "evenodd"
  })));
};
var Card32 = (/* unused pure expression or super */ null && (SvgCard32));

var _path$9Q, _path2$3d;
function _extends$9Y() { _extends$9Y = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$9Y.apply(this, arguments); }
var SvgCard48 = function SvgCard48(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$9Y({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none"
  }, props), _path$9Q || (_path$9Q = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M38 10.4H10A3.6 3.6 0 0 0 6.4 14v20a3.6 3.6 0 0 0 3.6 3.6h28a3.6 3.6 0 0 0 3.6-3.6V14a3.6 3.6 0 0 0-3.6-3.6M10 8a6 6 0 0 0-6 6v20a6 6 0 0 0 6 6h28a6 6 0 0 0 6-6V14a6 6 0 0 0-6-6z",
    clipRule: "evenodd"
  })), _path2$3d || (_path2$3d = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M5 18.8a1.2 1.2 0 0 1 1.2-1.2h35.6a1.2 1.2 0 0 1 0 2.4H6.2A1.2 1.2 0 0 1 5 18.8M30 25.8a1.2 1.2 0 0 1 1.2-1.2h5.6a1.2 1.2 0 0 1 0 2.4h-5.6a1.2 1.2 0 0 1-1.2-1.2",
    clipRule: "evenodd"
  })));
};
var Card48 = (/* unused pure expression or super */ null && (SvgCard48));

var CardIcon = function CardIcon(props) {
  var card = {
    12: Card12,
    16: Card16,
    18: Card18,
    24: Card24,
    32: Card32,
    48: Card48
  };
  return jsx(IconTemplate, _assign({
    icons: card
  }, props));
};

var _path$9P;
function _extends$9X() { _extends$9X = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$9X.apply(this, arguments); }
var SvgCardFilled12 = function SvgCardFilled12(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$9X({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none"
  }, props), _path$9P || (_path$9P = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M2.5 2A1.5 1.5 0 0 0 1 3.5v.7h10v-.7A1.5 1.5 0 0 0 9.5 2zM11 5.2H1v3.3A1.5 1.5 0 0 0 2.5 10h7A1.5 1.5 0 0 0 11 8.5zM7 6.8a.5.5 0 0 1 .5-.5h1.2a.5.5 0 0 1 0 1H7.5a.5.5 0 0 1-.5-.5",
    clipRule: "evenodd"
  })));
};
var CardFilled12 = (/* unused pure expression or super */ null && (SvgCardFilled12));

var _path$9O, _path2$3c;
function _extends$9W() { _extends$9W = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$9W.apply(this, arguments); }
var SvgCardFilled16 = function SvgCardFilled16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$9W({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path$9O || (_path$9O = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M3.333 2.667a2 2 0 0 0-2 2v.8h13.334v-.8a2 2 0 0 0-2-2z"
  })), _path2$3c || (_path2$3c = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M14.667 6.667H1.333v4.666a2 2 0 0 0 2 2h9.334a2 2 0 0 0 2-2zM10.933 7.8a.6.6 0 1 0 0 1.2H12.4a.6.6 0 1 0 0-1.2z",
    clipRule: "evenodd"
  })));
};
var CardFilled16 = (/* unused pure expression or super */ null && (SvgCardFilled16));

var _path$9N, _path2$3b;
function _extends$9V() { _extends$9V = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$9V.apply(this, arguments); }
var SvgCardFilled18 = function SvgCardFilled18(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$9V({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _path$9N || (_path$9N = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M3.75 3A2.25 2.25 0 0 0 1.5 5.25v.875h15V5.25A2.25 2.25 0 0 0 14.25 3z"
  })), _path2$3b || (_path2$3b = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M16.5 7.525h-15v5.225A2.25 2.25 0 0 0 3.75 15h10.5a2.25 2.25 0 0 0 2.25-2.25zm-4.275 1.3a.7.7 0 1 0 0 1.4h1.8a.7.7 0 1 0 0-1.4z",
    clipRule: "evenodd"
  })));
};
var CardFilled18 = (/* unused pure expression or super */ null && (SvgCardFilled18));

var _path$9M, _path2$3a;
function _extends$9U() { _extends$9U = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$9U.apply(this, arguments); }
var SvgCardFilled24 = function SvgCardFilled24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$9U({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path$9M || (_path$9M = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M5 4a3 3 0 0 0-3 3v1.3h20V7a3 3 0 0 0-3-3z"
  })), _path2$3a || (_path2$3a = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M22 9.9H2V17a3 3 0 0 0 3 3h14a3 3 0 0 0 3-3zm-5.7 2a.8.8 0 0 0 0 1.6h2.4a.8.8 0 0 0 0-1.6z",
    clipRule: "evenodd"
  })));
};
var CardFilled24 = (/* unused pure expression or super */ null && (SvgCardFilled24));

var _path$9L, _path2$39;
function _extends$9T() { _extends$9T = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$9T.apply(this, arguments); }
var SvgCardFilled32 = function SvgCardFilled32(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$9T({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _path$9L || (_path$9L = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M6.667 5.333a4 4 0 0 0-4 4v2h26.666v-2a4 4 0 0 0-4-4z"
  })), _path2$39 || (_path2$39 = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M29.333 13.333H2.667v9.334a4 4 0 0 0 4 4h18.666a4 4 0 0 0 4-4zM20.667 17a1 1 0 0 1 1-1H25a1 1 0 1 1 0 2h-3.333a1 1 0 0 1-1-1",
    clipRule: "evenodd"
  })));
};
var CardFilled32 = (/* unused pure expression or super */ null && (SvgCardFilled32));

var _path$9K, _path2$38;
function _extends$9S() { _extends$9S = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$9S.apply(this, arguments); }
var SvgCardFilled48 = function SvgCardFilled48(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$9S({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none"
  }, props), _path$9K || (_path$9K = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M10 8a6 6 0 0 0-6 6v3.6h40V14a6 6 0 0 0-6-6z"
  })), _path2$38 || (_path2$38 = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M44 20H4v14a6 6 0 0 0 6 6h28a6 6 0 0 0 6-6zm-13 5.8a1.2 1.2 0 0 1 1.2-1.2h5.6a1.2 1.2 0 1 1 0 2.4h-5.6a1.2 1.2 0 0 1-1.2-1.2",
    clipRule: "evenodd"
  })));
};
var CardFilled48 = (/* unused pure expression or super */ null && (SvgCardFilled48));

var CardFilledIcon = function CardFilledIcon(props) {
  var cardFilled = {
    12: CardFilled12,
    16: CardFilled16,
    18: CardFilled18,
    24: CardFilled24,
    32: CardFilled32,
    48: CardFilled48
  };
  return jsx(IconTemplate, _assign({
    icons: cardFilled
  }, props));
};

var _path$9J, _path2$37;
function _extends$9R() { _extends$9R = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$9R.apply(this, arguments); }
var SvgCart12 = function SvgCart12(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$9R({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none"
  }, props), _path$9J || (_path$9J = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M.15 1.5a.6.6 0 0 1 .6-.6h1.307a.75.75 0 0 1 .733.591l.136.625h7.165a1.1 1.1 0 0 1 1.059 1.397l-.934 3.33a2.1 2.1 0 0 1-2.022 1.534H4.998a2.1 2.1 0 0 1-2.022-1.533L1.859 2.86l-.164-.76H.75a.6.6 0 0 1-.6-.6m3.083 1.816.898 3.204a.9.9 0 0 0 .867.657h3.196a.9.9 0 0 0 .867-.657l.898-3.204z",
    clipRule: "evenodd"
  })), _path2$37 || (_path2$37 = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M5.6 9.65a.9.9 0 1 1-1.8 0 .9.9 0 0 1 1.8 0M9.457 9.65a.9.9 0 1 1-1.8 0 .9.9 0 0 1 1.8 0"
  })));
};
var Cart12 = (/* unused pure expression or super */ null && (SvgCart12));

var _path$9I, _path2$36;
function _extends$9Q() { _extends$9Q = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$9Q.apply(this, arguments); }
var SvgCart16 = function SvgCart16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$9Q({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path$9I || (_path$9I = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M.25 2A.75.75 0 0 1 1 1.25h1.743a.95.95 0 0 1 .929.749l.189.872h9.593c.938 0 1.617.896 1.364 1.799l-1.245 4.442a2.75 2.75 0 0 1-2.648 2.007H6.664a2.75 2.75 0 0 1-2.648-2.007l-1.488-5.31L2.3 2.75H1A.75.75 0 0 1 .25 2m3.995 2.371L5.46 8.707c.151.54.643.912 1.204.912h4.262a1.25 1.25 0 0 0 1.203-.912l1.215-4.336z",
    clipRule: "evenodd"
  })), _path2$36 || (_path2$36 = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M7.3 12.817a1.15 1.15 0 1 1-2.3 0 1.15 1.15 0 0 1 2.3 0M11.293 13.967a1.15 1.15 0 1 0 0-2.3 1.15 1.15 0 0 0 0 2.3"
  })));
};
var Cart16 = (/* unused pure expression or super */ null && (SvgCart16));

var _path$9H, _path2$35;
function _extends$9P() { _extends$9P = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$9P.apply(this, arguments); }
var SvgCart18 = function SvgCart18(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$9P({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _path$9H || (_path$9H = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M.325 2.25a.8.8 0 0 1 .8-.8h1.962c.482 0 .9.337 1.001.808l.22 1.016h10.828c1.027 0 1.77.98 1.493 1.968l-1.4 4.997a3.05 3.05 0 0 1-2.938 2.227H7.497a3.05 3.05 0 0 1-2.937-2.227L2.886 4.267 2.623 3.05H1.125a.8.8 0 0 1-.8-.8m4.393 2.624 1.383 4.933a1.45 1.45 0 0 0 1.396 1.059h4.794c.65 0 1.221-.433 1.397-1.059l1.382-4.933z",
    clipRule: "evenodd"
  })), _path2$35 || (_path2$35 = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M8.3 14.375a1.25 1.25 0 1 1-2.5 0 1.25 1.25 0 0 1 2.5 0M12.836 15.625a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5"
  })));
};
var Cart18 = (/* unused pure expression or super */ null && (SvgCart18));

var _path$9G;
function _extends$9O() { _extends$9O = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$9O.apply(this, arguments); }
var SvgCart24 = function SvgCart24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$9O({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path$9G || (_path$9G = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M.1 2.5a.9.9 0 0 1 .9-.9h2.758a1.2 1.2 0 0 1 1.173.946l.348 1.607h15.402a1.9 1.9 0 0 1 1.83 2.413l-2.01 7.168a3.9 3.9 0 0 1-3.754 2.848h-6.94a3.9 3.9 0 0 1-3.755-2.848L3.679 5.27 3.274 3.4H1a.9.9 0 0 1-.9-.9m5.64 3.453 2.045 7.296a2.1 2.1 0 0 0 2.022 1.533h6.94a2.1 2.1 0 0 0 2.022-1.533l2.009-7.169a.1.1 0 0 0-.097-.127zM9.38 22.19a2.095 2.095 0 1 0 0-4.19 2.095 2.095 0 0 0 0 4.19m0-1.6a.495.495 0 1 1 0-.99.495.495 0 0 1 0 .99M19.19 20.095a2.095 2.095 0 1 1-4.19 0 2.095 2.095 0 0 1 4.19 0m-1.6 0a.495.495 0 1 0-.99 0 .495.495 0 0 0 .99 0"
  })));
};
var Cart24 = (/* unused pure expression or super */ null && (SvgCart24));

var _path$9F;
function _extends$9N() { _extends$9N = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$9N.apply(this, arguments); }
var SvgCart32 = function SvgCart32(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$9N({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _path$9F || (_path$9F = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M1 4a1 1 0 0 1 1-1h3.487a1.4 1.4 0 0 1 1.368 1.104l.464 2.138h19.59a2.333 2.333 0 0 1 2.246 2.963l-2.49 8.883a5 5 0 0 1-4.814 3.65h-8.523a5 5 0 0 1-4.815-3.65L5.541 7.483 5.003 5H2a1 1 0 0 1-1-1m6.83 4.242 2.609 9.306a3 3 0 0 0 2.889 2.19h8.523a3 3 0 0 0 2.889-2.19l2.49-8.883a.333.333 0 0 0-.322-.423zM12.508 28.92a2.794 2.794 0 1 0 0-5.587 2.794 2.794 0 0 0 0 5.588m0-2a.794.794 0 1 0 0-1.587.794.794 0 0 0 0 1.588M25.587 26.127a2.794 2.794 0 1 1-5.587 0 2.794 2.794 0 0 1 5.587 0m-2 0a.794.794 0 1 1-1.587 0 .794.794 0 0 1 1.587 0",
    clipRule: "evenodd"
  })));
};
var Cart32 = (/* unused pure expression or super */ null && (SvgCart32));

var _path$9E;
function _extends$9M() { _extends$9M = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$9M.apply(this, arguments); }
var SvgCart48 = function SvgCart48(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$9M({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none"
  }, props), _path$9E || (_path$9E = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M1.8 6A1.2 1.2 0 0 1 3 4.8h5.23a1.8 1.8 0 0 1 1.76 1.419l.746 3.444h29.626a3.2 3.2 0 0 1 3.081 4.064L39.71 27.05a7.2 7.2 0 0 1-6.933 5.257H19.991a7.2 7.2 0 0 1-6.933-5.257L8.603 11.152 7.746 7.2H3A1.2 1.2 0 0 1 1.8 6m9.55 6.063 4.02 14.34a4.8 4.8 0 0 0 4.621 3.505h12.785a4.8 4.8 0 0 0 4.622-3.505l3.735-13.324a.8.8 0 0 0-.77-1.016zM18.762 43.38a4.19 4.19 0 1 0 0-8.38 4.19 4.19 0 0 0 0 8.38m0-2.4a1.79 1.79 0 1 0 0-3.58 1.79 1.79 0 0 0 0 3.58M38.38 39.19a4.19 4.19 0 1 1-8.38 0 4.19 4.19 0 0 1 8.38 0m-2.4 0a1.79 1.79 0 1 1-3.58 0 1.79 1.79 0 0 1 3.58 0",
    clipRule: "evenodd"
  })));
};
var Cart48 = (/* unused pure expression or super */ null && (SvgCart48));

var CartIcon = function CartIcon(props) {
  var cart = {
    12: Cart12,
    16: Cart16,
    18: Cart18,
    24: Cart24,
    32: Cart32,
    48: Cart48
  };
  return jsx(IconTemplate, _assign({
    icons: cart
  }, props));
};

var _path$9D;
function _extends$9L() { _extends$9L = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$9L.apply(this, arguments); }
var SvgCash12 = function SvgCash12(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$9L({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none"
  }, props), _path$9D || (_path$9D = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M8.178 4.685a.6.6 0 0 1-.848.008 1.83 1.83 0 1 0 0 2.614.6.6 0 1 1 .84.857 3.03 3.03 0 1 1 0-4.328.6.6 0 0 1 .008.849M6 9.8a3.8 3.8 0 1 0 0-7.6 3.8 3.8 0 0 0 0 7.6M6 11A5 5 0 1 0 6 1a5 5 0 0 0 0 10",
    clipRule: "evenodd"
  })));
};
var Cash12 = (/* unused pure expression or super */ null && (SvgCash12));

var _path$9C;
function _extends$9K() { _extends$9K = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$9K.apply(this, arguments); }
var SvgCash16 = function SvgCash16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$9K({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path$9C || (_path$9C = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M10.87 6.211a.75.75 0 0 1-1.062.01 2.49 2.49 0 1 0 0 3.556.75.75 0 0 1 1.05 1.072 3.99 3.99 0 1 1 0-5.699c.296.29.301.766.011 1.061M8 13.167A5.167 5.167 0 1 0 8 2.833a5.167 5.167 0 0 0 0 10.334m0 1.5A6.667 6.667 0 1 0 8 1.334a6.667 6.667 0 0 0 0 13.333",
    clipRule: "evenodd"
  })));
};
var Cash16 = (/* unused pure expression or super */ null && (SvgCash16));

var _path$9B;
function _extends$9J() { _extends$9J = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$9J.apply(this, arguments); }
var SvgCash18 = function SvgCash18(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$9J({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _path$9B || (_path$9B = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M12.196 6.957a.8.8 0 0 1-1.131.011 2.845 2.845 0 1 0 0 4.063.8.8 0 0 1 1.12 1.143 4.445 4.445 0 1 1 0-6.349.8.8 0 0 1 .011 1.132M9 14.9A5.9 5.9 0 1 0 9 3.1a5.9 5.9 0 0 0 0 11.8m0 1.6a7.5 7.5 0 1 0 0-15 7.5 7.5 0 0 0 0 15",
    clipRule: "evenodd"
  })));
};
var Cash18 = (/* unused pure expression or super */ null && (SvgCash18));

var _path$9A;
function _extends$9I() { _extends$9I = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$9I.apply(this, arguments); }
var SvgCash24 = function SvgCash24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$9I({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path$9A || (_path$9A = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M16.112 9.13a.857.857 0 0 1-1.212.011 4.003 4.003 0 1 0 0 5.717.857.857 0 0 1 1.2 1.225 5.717 5.717 0 1 1 0-8.166.857.857 0 0 1 .012 1.212M12 20.285a8.286 8.286 0 1 0 0-16.572 8.286 8.286 0 0 0 0 16.572M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10",
    clipRule: "evenodd"
  })));
};
var Cash24 = (/* unused pure expression or super */ null && (SvgCash24));

var _path$9z;
function _extends$9H() { _extends$9H = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$9H.apply(this, arguments); }
var SvgCash32 = function SvgCash32(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$9H({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _path$9z || (_path$9z = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M21.38 12.072a1 1 0 0 1-1.414.014 5.48 5.48 0 1 0 0 7.827 1 1 0 0 1 1.4 1.428 7.48 7.48 0 1 1 0-10.683 1 1 0 0 1 .015 1.414M16 27.333c6.26 0 11.333-5.074 11.333-11.333S22.26 4.667 16 4.667 4.667 9.74 4.667 16 9.74 27.333 16 27.333m0 2c7.364 0 13.333-5.97 13.333-13.333S23.363 2.667 16 2.667 2.667 8.636 2.667 16 8.636 29.333 16 29.333",
    clipRule: "evenodd"
  })));
};
var Cash32 = (/* unused pure expression or super */ null && (SvgCash32));

var _path$9y;
function _extends$9G() { _extends$9G = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$9G.apply(this, arguments); }
var SvgCash48 = function SvgCash48(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$9G({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none"
  }, props), _path$9y || (_path$9y = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M31.857 17.899a1.2 1.2 0 0 1-1.697.017 8.5 8.5 0 0 0-5.964-2.436 8.52 8.52 0 0 0 0 17.04 8.5 8.5 0 0 0 5.964-2.436 1.2 1.2 0 1 1 1.68 1.714 10.9 10.9 0 0 1-7.644 3.122c-6.03 0-10.92-4.89-10.92-10.92s4.89-10.92 10.92-10.92c2.976 0 5.676 1.192 7.644 3.122a1.2 1.2 0 0 1 .017 1.697M24 41.6c9.72 0 17.6-7.88 17.6-17.6S33.72 6.4 24 6.4 6.4 14.28 6.4 24 14.28 41.6 24 41.6m0 2.4c11.046 0 20-8.954 20-20S35.046 4 24 4 4 12.954 4 24s8.954 20 20 20",
    clipRule: "evenodd"
  })));
};
var Cash48 = (/* unused pure expression or super */ null && (SvgCash48));

var CashIcon = function CashIcon(props) {
  var cash = {
    12: Cash12,
    16: Cash16,
    18: Cash18,
    24: Cash24,
    32: Cash32,
    48: Cash48
  };
  return jsx(IconTemplate, _assign({
    icons: cash
  }, props));
};

var _path$9x;
function _extends$9F() { _extends$9F = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$9F.apply(this, arguments); }
var SvgCashFilled12 = function SvgCashFilled12(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$9F({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none"
  }, props), _path$9x || (_path$9x = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M6 11A5 5 0 1 0 6 1a5 5 0 0 0 0 10M4.219 6A1.83 1.83 0 0 1 7.33 4.693a.6.6 0 0 0 .84-.857 3.03 3.03 0 1 0 0 4.328.6.6 0 0 0-.84-.857A1.83 1.83 0 0 1 4.22 6",
    clipRule: "evenodd"
  })));
};
var CashFilled12 = (/* unused pure expression or super */ null && (SvgCashFilled12));

var _path$9w;
function _extends$9E() { _extends$9E = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$9E.apply(this, arguments); }
var SvgCashFilled16 = function SvgCashFilled16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$9E({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path$9w || (_path$9w = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M8 14.666A6.667 6.667 0 1 0 8 1.333a6.667 6.667 0 0 0 0 13.333M5.575 8A2.49 2.49 0 0 1 9.808 6.22a.75.75 0 1 0 1.05-1.07 3.99 3.99 0 1 0 0 5.699.75.75 0 0 0-1.05-1.072A2.49 2.49 0 0 1 5.575 8",
    clipRule: "evenodd"
  })));
};
var CashFilled16 = (/* unused pure expression or super */ null && (SvgCashFilled16));

var _path$9v;
function _extends$9D() { _extends$9D = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$9D.apply(this, arguments); }
var SvgCashFilled18 = function SvgCashFilled18(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$9D({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _path$9v || (_path$9v = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M9 16.5a7.5 7.5 0 1 0 0-15 7.5 7.5 0 0 0 0 15M6.229 9a2.845 2.845 0 0 1 4.836-2.032.8.8 0 0 0 1.12-1.142 4.445 4.445 0 1 0 0 6.349.8.8 0 1 0-1.12-1.143A2.845 2.845 0 0 1 6.229 9",
    clipRule: "evenodd"
  })));
};
var CashFilled18 = (/* unused pure expression or super */ null && (SvgCashFilled18));

var _path$9u;
function _extends$9C() { _extends$9C = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$9C.apply(this, arguments); }
var SvgCashFilled24 = function SvgCashFilled24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$9C({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path$9u || (_path$9u = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10M8.138 12a3.96 3.96 0 0 1 6.732-2.828.9.9 0 0 0 1.26-1.285 5.76 5.76 0 1 0 0 8.227.9.9 0 1 0-1.26-1.286A3.96 3.96 0 0 1 8.138 12",
    clipRule: "evenodd"
  })));
};
var CashFilled24 = (/* unused pure expression or super */ null && (SvgCashFilled24));

var _path$9t;
function _extends$9B() { _extends$9B = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$9B.apply(this, arguments); }
var SvgCashFilled32 = function SvgCashFilled32(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$9B({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _path$9t || (_path$9t = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M16.333 29.667c7.364 0 13.334-5.97 13.334-13.334S23.697 3 16.333 3 3 8.97 3 16.333s5.97 13.334 13.333 13.334m-5.349-13.334A5.48 5.48 0 0 1 20.3 12.42a1 1 0 1 0 1.4-1.428 7.48 7.48 0 1 0 0 10.683 1 1 0 1 0-1.4-1.428 5.48 5.48 0 0 1-9.316-3.913",
    clipRule: "evenodd"
  })));
};
var CashFilled32 = (/* unused pure expression or super */ null && (SvgCashFilled32));

var _path$9s;
function _extends$9A() { _extends$9A = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$9A.apply(this, arguments); }
var SvgCashFilled48 = function SvgCashFilled48(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$9A({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none"
  }, props), _path$9s || (_path$9s = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M24 44c11.046 0 20-8.954 20-20S35.046 4 24 4 4 12.954 4 24s8.954 20 20 20m-8.324-20a8.52 8.52 0 0 1 8.52-8.52c2.322 0 4.426.928 5.964 2.436a1.2 1.2 0 1 0 1.68-1.714 10.9 10.9 0 0 0-7.644-3.122c-6.03 0-10.92 4.89-10.92 10.92s4.89 10.92 10.92 10.92c2.976 0 5.676-1.192 7.644-3.122a1.2 1.2 0 1 0-1.68-1.713 8.5 8.5 0 0 1-5.964 2.435 8.52 8.52 0 0 1-8.52-8.52",
    clipRule: "evenodd"
  })));
};
var CashFilled48 = (/* unused pure expression or super */ null && (SvgCashFilled48));

var CashFilledIcon = function CashFilledIcon(props) {
  var cashFilled = {
    12: CashFilled12,
    16: CashFilled16,
    18: CashFilled18,
    24: CashFilled24,
    32: CashFilled32,
    48: CashFilled48
  };
  return jsx(IconTemplate, _assign({
    icons: cashFilled
  }, props));
};

var _path$9r;
function _extends$9z() { _extends$9z = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$9z.apply(this, arguments); }
var SvgCheck12 = function SvgCheck12(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$9z({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none"
  }, props), _path$9r || (_path$9r = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M10.424 3.243a.6.6 0 0 1 0 .848L5.091 9.424a.6.6 0 0 1-.849 0L1.576 6.758a.6.6 0 1 1 .848-.849l2.243 2.243 4.909-4.91a.6.6 0 0 1 .848 0",
    clipRule: "evenodd"
  })));
};
var Check12 = (/* unused pure expression or super */ null && (SvgCheck12));

var _path$9q;
function _extends$9y() { _extends$9y = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$9y.apply(this, arguments); }
var SvgCheck16 = function SvgCheck16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$9y({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path$9q || (_path$9q = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M13.828 4.394a.7.7 0 0 1 0 .99l-7.11 7.111a.7.7 0 0 1-.99 0L2.171 8.94a.7.7 0 1 1 .99-.99l3.06 3.06 6.616-6.616a.7.7 0 0 1 .99 0",
    clipRule: "evenodd"
  })));
};
var Check16 = (/* unused pure expression or super */ null && (SvgCheck16));

var _path$9p;
function _extends$9x() { _extends$9x = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$9x.apply(this, arguments); }
var SvgCheck18 = function SvgCheck18(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$9x({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _path$9p || (_path$9p = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M15.566 4.935a.8.8 0 0 1 0 1.13l-8 8a.8.8 0 0 1-1.132 0l-4-4a.8.8 0 0 1 1.132-1.13L7 12.369l7.434-7.434a.8.8 0 0 1 1.132 0",
    clipRule: "evenodd"
  })));
};
var Check18 = (/* unused pure expression or super */ null && (SvgCheck18));

var _path$9o;
function _extends$9w() { _extends$9w = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$9w.apply(this, arguments); }
var SvgCheck24 = function SvgCheck24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$9w({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path$9o || (_path$9o = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M20.637 6.697a.9.9 0 0 1 0 1.273L9.97 18.636a.9.9 0 0 1-1.273 0l-5.333-5.333a.9.9 0 0 1 1.272-1.273l4.697 4.697 10.03-10.03a.9.9 0 0 1 1.274 0",
    clipRule: "evenodd"
  })));
};
var Check24 = (/* unused pure expression or super */ null && (SvgCheck24));

var _path$9n;
function _extends$9v() { _extends$9v = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$9v.apply(this, arguments); }
var SvgCheck32 = function SvgCheck32(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$9v({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _path$9n || (_path$9n = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M27.374 9.07a1 1 0 0 1 0 1.415L13.152 24.707a1 1 0 0 1-1.415 0l-7.11-7.11a1 1 0 0 1 1.413-1.415l6.404 6.404L25.96 9.07a1 1 0 0 1 1.415 0",
    clipRule: "evenodd"
  })));
};
var Check32 = (/* unused pure expression or super */ null && (SvgCheck32));

var _path$9m;
function _extends$9u() { _extends$9u = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$9u.apply(this, arguments); }
var SvgCheck48 = function SvgCheck48(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$9u({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none"
  }, props), _path$9m || (_path$9m = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M40.884 13.783a1.25 1.25 0 0 1 0 1.767L19.55 36.884a1.25 1.25 0 0 1-1.768 0L7.116 26.217a1.25 1.25 0 0 1 1.768-1.768l9.783 9.783 20.45-20.45a1.25 1.25 0 0 1 1.767 0",
    clipRule: "evenodd"
  })));
};
var Check48 = (/* unused pure expression or super */ null && (SvgCheck48));

var CheckIcon = function CheckIcon(props) {
  var check = {
    12: Check12,
    16: Check16,
    18: Check18,
    24: Check24,
    32: Check32,
    48: Check48
  };
  return jsx(IconTemplate, _assign({
    icons: check
  }, props));
};

var _path$9l;
function _extends$9t() { _extends$9t = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$9t.apply(this, arguments); }
var SvgChevronDown12 = function SvgChevronDown12(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$9t({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none"
  }, props), _path$9l || (_path$9l = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M1.201 3.182a.6.6 0 0 1 .847.05l3.996 4.495 3.997-4.496a.6.6 0 1 1 .896.798l-4.07 4.58a1.1 1.1 0 0 1-1.645 0l-4.07-4.58a.6.6 0 0 1 .05-.847",
    clipRule: "evenodd"
  })));
};
var ChevronDown12 = (/* unused pure expression or super */ null && (SvgChevronDown12));

var _path$9k;
function _extends$9s() { _extends$9s = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$9s.apply(this, arguments); }
var SvgChevronDown16 = function SvgChevronDown16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$9s({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path$9k || (_path$9k = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M1.552 4.24a.75.75 0 0 0-.063 1.058l5.552 6.247a1.25 1.25 0 0 0 1.869 0l5.552-6.247a.75.75 0 1 0-1.12-.996l-5.366 6.036L2.61 4.302a.75.75 0 0 0-1.058-.062",
    clipRule: "evenodd"
  })));
};
var ChevronDown16 = (/* unused pure expression or super */ null && (SvgChevronDown16));

var _path$9j;
function _extends$9r() { _extends$9r = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$9r.apply(this, arguments); }
var SvgChevronDown18 = function SvgChevronDown18(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$9r({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _path$9j || (_path$9j = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M1.809 4.782a.8.8 0 0 1 1.129.067l6.069 6.827 6.069-6.827a.8.8 0 1 1 1.195 1.063l-6.293 7.08a1.3 1.3 0 0 1-1.943 0l-6.293-7.08a.8.8 0 0 1 .067-1.13",
    clipRule: "evenodd"
  })));
};
var ChevronDown18 = (/* unused pure expression or super */ null && (SvgChevronDown18));

var _path$9i;
function _extends$9q() { _extends$9q = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$9q.apply(this, arguments); }
var SvgChevronDown24 = function SvgChevronDown24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$9q({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path$9i || (_path$9i = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M2.502 6.467a.9.9 0 0 1 1.27.075l8.217 9.243 8.216-9.243a.9.9 0 0 1 1.346 1.196l-8.515 9.58a1.4 1.4 0 0 1-2.093 0l-8.515-9.58a.9.9 0 0 1 .074-1.27"
  })));
};
var ChevronDown24 = (/* unused pure expression or super */ null && (SvgChevronDown24));

var _path$9h;
function _extends$9p() { _extends$9p = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$9p.apply(this, arguments); }
var SvgChevronDown32 = function SvgChevronDown32(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$9p({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _path$9h || (_path$9h = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M3.486 8.714a1 1 0 0 1 1.411.083L16.002 21.29 27.106 8.797a1 1 0 0 1 1.495 1.329L17.123 23.039a1.5 1.5 0 0 1-2.242 0L3.403 10.126a1 1 0 0 1 .083-1.412",
    clipRule: "evenodd"
  })));
};
var ChevronDown32 = (/* unused pure expression or super */ null && (SvgChevronDown32));

var _path$9g;
function _extends$9o() { _extends$9o = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$9o.apply(this, arguments); }
var SvgChevronDown48 = function SvgChevronDown48(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$9o({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none"
  }, props), _path$9g || (_path$9g = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M5.423 13.453a1.2 1.2 0 0 1 1.694.1l16.88 18.99 16.882-18.99a1.2 1.2 0 1 1 1.794 1.594l-17.405 19.58a1.7 1.7 0 0 1-2.54 0L5.322 15.147a1.2 1.2 0 0 1 .1-1.694"
  })));
};
var ChevronDown48 = (/* unused pure expression or super */ null && (SvgChevronDown48));

var ChevronDownIcon = function ChevronDownIcon(props) {
  var chevronDown = {
    12: ChevronDown12,
    16: ChevronDown16,
    18: ChevronDown18,
    24: ChevronDown24,
    32: ChevronDown32,
    48: ChevronDown48
  };
  return jsx(IconTemplate, _assign({
    icons: chevronDown
  }, props));
};

var _path$9f;
function _extends$9n() { _extends$9n = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$9n.apply(this, arguments); }
var SvgChevronLeft12 = function SvgChevronLeft12(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$9n({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none"
  }, props), _path$9f || (_path$9f = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M8.449 1.151a.6.6 0 0 1-.05.847L3.903 5.994 8.4 9.99a.6.6 0 0 1-.797.897l-4.58-4.07a1.1 1.1 0 0 1 0-1.645l4.58-4.07a.6.6 0 0 1 .847.05",
    clipRule: "evenodd"
  })));
};
var ChevronLeft12 = (/* unused pure expression or super */ null && (SvgChevronLeft12));

var _path$9e;
function _extends$9m() { _extends$9m = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$9m.apply(this, arguments); }
var SvgChevronLeft16 = function SvgChevronLeft16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$9m({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path$9e || (_path$9e = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M11.225 1.572a.75.75 0 0 0-1.06-.062L3.92 7.062a1.25 1.25 0 0 0 0 1.868l6.246 5.553a.75.75 0 1 0 .996-1.122L5.126 7.996l6.036-5.365a.75.75 0 0 0 .063-1.06",
    clipRule: "evenodd"
  })));
};
var ChevronLeft16 = (/* unused pure expression or super */ null && (SvgChevronLeft16));

var _path$9d;
function _extends$9l() { _extends$9l = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$9l.apply(this, arguments); }
var SvgChevronLeft18 = function SvgChevronLeft18(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$9l({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _path$9d || (_path$9d = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M12.596 1.809a.8.8 0 0 1-.067 1.129L5.702 9.007l6.827 6.069a.8.8 0 1 1-1.063 1.195l-7.08-6.293a1.3 1.3 0 0 1 0-1.943l7.08-6.293a.8.8 0 0 1 1.13.067",
    clipRule: "evenodd"
  })));
};
var ChevronLeft18 = (/* unused pure expression or super */ null && (SvgChevronLeft18));

var _path$9c;
function _extends$9k() { _extends$9k = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$9k.apply(this, arguments); }
var SvgChevronLeft24 = function SvgChevronLeft24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$9k({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path$9c || (_path$9c = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M16.673 2.502a.9.9 0 0 1-.075 1.27L7.355 11.99l9.243 8.216a.9.9 0 0 1-1.196 1.345l-9.58-8.515a1.4 1.4 0 0 1 0-2.092l9.58-8.516a.9.9 0 0 1 1.27.075"
  })));
};
var ChevronLeft24 = (/* unused pure expression or super */ null && (SvgChevronLeft24));

var _path$9b;
function _extends$9j() { _extends$9j = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$9j.apply(this, arguments); }
var SvgChevronLeft32 = function SvgChevronLeft32(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$9j({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _path$9b || (_path$9b = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M22.078 3.486a1 1 0 0 1-.083 1.411L9.503 16.002l12.492 11.104a1 1 0 1 1-1.329 1.495L7.753 17.123a1.5 1.5 0 0 1 0-2.242L20.666 3.403a1 1 0 0 1 1.412.083",
    clipRule: "evenodd"
  })));
};
var ChevronLeft32 = (/* unused pure expression or super */ null && (SvgChevronLeft32));

var _path$9a;
function _extends$9i() { _extends$9i = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$9i.apply(this, arguments); }
var SvgChevronLeft48 = function SvgChevronLeft48(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$9i({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none"
  }, props), _path$9a || (_path$9a = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M32.897 5.203a1.2 1.2 0 0 1-.1 1.694l-18.99 16.88 18.99 16.882a1.2 1.2 0 1 1-1.594 1.794l-19.58-17.405a1.7 1.7 0 0 1 0-2.54l19.58-17.405a1.2 1.2 0 0 1 1.694.1"
  })));
};
var ChevronLeft48 = (/* unused pure expression or super */ null && (SvgChevronLeft48));

var ChevronLeftIcon = function ChevronLeftIcon(props) {
  var chevronLeft = {
    12: ChevronLeft12,
    16: ChevronLeft16,
    18: ChevronLeft18,
    24: ChevronLeft24,
    32: ChevronLeft32,
    48: ChevronLeft48
  };
  return jsx(IconTemplate, _assign({
    icons: chevronLeft
  }, props));
};

var _path$99;
function _extends$9h() { _extends$9h = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$9h.apply(this, arguments); }
var SvgChevronRight12 = function SvgChevronRight12(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$9h({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none"
  }, props), _path$99 || (_path$99 = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M3.551 1.151a.6.6 0 0 0 .05.847l4.496 3.996L3.6 9.99a.6.6 0 0 0 .798.897l4.58-4.07a1.1 1.1 0 0 0 0-1.645l-4.58-4.07a.6.6 0 0 0-.848.05",
    clipRule: "evenodd"
  })));
};
var ChevronRight12 = (/* unused pure expression or super */ null && (SvgChevronRight12));

var _path$98;
function _extends$9g() { _extends$9g = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$9g.apply(this, arguments); }
var SvgChevronRight16 = function SvgChevronRight16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$9g({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path$98 || (_path$98 = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M4.773 1.572a.75.75 0 0 1 1.059-.062l6.246 5.552a1.25 1.25 0 0 1 0 1.868l-6.246 5.553a.75.75 0 1 1-.997-1.122l6.036-5.365-6.036-5.365a.75.75 0 0 1-.062-1.06",
    clipRule: "evenodd"
  })));
};
var ChevronRight16 = (/* unused pure expression or super */ null && (SvgChevronRight16));

var _path$97;
function _extends$9f() { _extends$9f = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$9f.apply(this, arguments); }
var SvgChevronRight18 = function SvgChevronRight18(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$9f({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _path$97 || (_path$97 = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M5.402 1.809a.8.8 0 0 0 .067 1.129l6.827 6.069-6.827 6.069a.8.8 0 1 0 1.063 1.195l7.08-6.293a1.3 1.3 0 0 0 0-1.943l-7.08-6.293a.8.8 0 0 0-1.13.067",
    clipRule: "evenodd"
  })));
};
var ChevronRight18 = (/* unused pure expression or super */ null && (SvgChevronRight18));

var _path$96;
function _extends$9e() { _extends$9e = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$9e.apply(this, arguments); }
var SvgChevronRight24 = function SvgChevronRight24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$9e({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path$96 || (_path$96 = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M7.327 2.502a.9.9 0 0 0 .075 1.27l9.243 8.217-9.243 8.216a.9.9 0 1 0 1.196 1.345l9.58-8.515a1.4 1.4 0 0 0 0-2.092l-9.58-8.516a.9.9 0 0 0-1.27.075"
  })));
};
var ChevronRight24 = (/* unused pure expression or super */ null && (SvgChevronRight24));

var _path$95;
function _extends$9d() { _extends$9d = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$9d.apply(this, arguments); }
var SvgChevronRight32 = function SvgChevronRight32(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$9d({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _path$95 || (_path$95 = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M9.92 3.486a1 1 0 0 0 .082 1.411l12.493 11.105-12.493 11.104a1 1 0 1 0 1.329 1.495l12.913-11.478a1.5 1.5 0 0 0 0-2.242L11.33 3.403a1 1 0 0 0-1.412.083",
    clipRule: "evenodd"
  })));
};
var ChevronRight32 = (/* unused pure expression or super */ null && (SvgChevronRight32));

var _path$94;
function _extends$9c() { _extends$9c = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$9c.apply(this, arguments); }
var SvgChevronRight48 = function SvgChevronRight48(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$9c({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none"
  }, props), _path$94 || (_path$94 = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M15.103 5.203a1.2 1.2 0 0 0 .1 1.694l18.99 16.88-18.99 16.881a1.2 1.2 0 1 0 1.594 1.794l19.58-17.404a1.7 1.7 0 0 0 0-2.541L16.797 5.103a1.2 1.2 0 0 0-1.694.1",
    clipRule: "evenodd"
  })));
};
var ChevronRight48 = (/* unused pure expression or super */ null && (SvgChevronRight48));

var ChevronRightIcon = function ChevronRightIcon(props) {
  var chevronRight = {
    12: ChevronRight12,
    16: ChevronRight16,
    18: ChevronRight18,
    24: ChevronRight24,
    32: ChevronRight32,
    48: ChevronRight48
  };
  return jsx(IconTemplate, _assign({
    icons: chevronRight
  }, props));
};

var _path$93;
function _extends$9b() { _extends$9b = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$9b.apply(this, arguments); }
var SvgChevronUp12 = function SvgChevronUp12(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$9b({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none"
  }, props), _path$93 || (_path$93 = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M10.888 8.816a.6.6 0 0 1-.848-.05L6.044 4.272 2.048 8.767a.6.6 0 0 1-.896-.798l4.07-4.58a1.1 1.1 0 0 1 1.645 0l4.07 4.58a.6.6 0 0 1-.05.847",
    clipRule: "evenodd"
  })));
};
var ChevronUp12 = (/* unused pure expression or super */ null && (SvgChevronUp12));

var _path$92;
function _extends$9a() { _extends$9a = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$9a.apply(this, arguments); }
var SvgChevronUp16 = function SvgChevronUp16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$9a({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path$92 || (_path$92 = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M14.4 11.764a.75.75 0 0 0 .063-1.06L8.91 4.46a1.25 1.25 0 0 0-1.868 0L1.49 10.705a.75.75 0 1 0 1.12.996l5.366-6.036 5.365 6.036a.75.75 0 0 0 1.06.063",
    clipRule: "evenodd"
  })));
};
var ChevronUp16 = (/* unused pure expression or super */ null && (SvgChevronUp16));

var _path$91;
function _extends$99() { _extends$99 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$99.apply(this, arguments); }
var SvgChevronUp18 = function SvgChevronUp18(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$99({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _path$91 || (_path$91 = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M16.205 13.228a.8.8 0 0 1-1.13-.066L9.008 6.335l-6.069 6.827a.8.8 0 1 1-1.196-1.063l6.293-7.08a1.3 1.3 0 0 1 1.943 0l6.293 7.08a.8.8 0 0 1-.066 1.13",
    clipRule: "evenodd"
  })));
};
var ChevronUp18 = (/* unused pure expression or super */ null && (SvgChevronUp18));

var _path$90;
function _extends$98() { _extends$98 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$98.apply(this, arguments); }
var SvgChevronUp24 = function SvgChevronUp24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$98({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path$90 || (_path$90 = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M21.476 17.535a.9.9 0 0 1-1.27-.075l-8.217-9.243-8.216 9.243a.9.9 0 0 1-1.346-1.195l8.516-9.58a1.4 1.4 0 0 1 2.092 0l8.515 9.58a.9.9 0 0 1-.074 1.27"
  })));
};
var ChevronUp24 = (/* unused pure expression or super */ null && (SvgChevronUp24));

var _path$8$;
function _extends$97() { _extends$97 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$97.apply(this, arguments); }
var SvgChevronUp32 = function SvgChevronUp32(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$97({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _path$8$ || (_path$8$ = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M28.518 23.29a1 1 0 0 1-1.412-.084L16.002 10.714 4.897 23.206a1 1 0 1 1-1.495-1.328L14.881 8.965a1.5 1.5 0 0 1 2.242 0L28.6 21.878a1 1 0 0 1-.083 1.412",
    clipRule: "evenodd"
  })));
};
var ChevronUp32 = (/* unused pure expression or super */ null && (SvgChevronUp32));

var _path$8_;
function _extends$96() { _extends$96 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$96.apply(this, arguments); }
var SvgChevronUp48 = function SvgChevronUp48(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$96({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none"
  }, props), _path$8_ || (_path$8_ = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M42.573 34.548a1.2 1.2 0 0 1-1.694-.1l-16.881-18.99-16.881 18.99a1.2 1.2 0 1 1-1.794-1.594l17.404-19.58a1.7 1.7 0 0 1 2.541 0l17.405 19.58a1.2 1.2 0 0 1-.1 1.694"
  })));
};
var ChevronUp48 = (/* unused pure expression or super */ null && (SvgChevronUp48));

var ChevronUpIcon = function ChevronUpIcon(props) {
  var chevronUp = {
    12: ChevronUp12,
    16: ChevronUp16,
    18: ChevronUp18,
    24: ChevronUp24,
    32: ChevronUp32,
    48: ChevronUp48
  };
  return jsx(IconTemplate, _assign({
    icons: chevronUp
  }, props));
};

var _path$8Z;
function _extends$95() { _extends$95 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$95.apply(this, arguments); }
var SvgCircleCheckFilled12 = function SvgCircleCheckFilled12(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$95({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none"
  }, props), _path$8Z || (_path$8Z = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M6 11A5 5 0 1 0 6 1a5 5 0 0 0 0 10m3.038-6.462a.525.525 0 1 0-.743-.743L4.833 7.257 3.705 6.13a.525.525 0 0 0-.743.742l1.5 1.5a.525.525 0 0 0 .743 0z",
    clipRule: "evenodd"
  })));
};
var CircleCheckFilled12 = (/* unused pure expression or super */ null && (SvgCircleCheckFilled12));

var _path$8Y;
function _extends$94() { _extends$94 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$94.apply(this, arguments); }
var SvgCircleCheckFilled16 = function SvgCircleCheckFilled16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$94({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path$8Y || (_path$8Y = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M8 14.666A6.667 6.667 0 1 0 8 1.333a6.667 6.667 0 0 0 0 13.333m4.015-8.651a.65.65 0 0 0-.92-.92l-4.65 4.652-1.541-1.54a.65.65 0 1 0-.92.919l2 2a.65.65 0 0 0 .92 0z",
    clipRule: "evenodd"
  })));
};
var CircleCheckFilled16 = (/* unused pure expression or super */ null && (SvgCircleCheckFilled16));

var _path$8X;
function _extends$93() { _extends$93 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$93.apply(this, arguments); }
var SvgCircleCheckFilled18 = function SvgCircleCheckFilled18(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$93({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _path$8X || (_path$8X = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M9 16.5a7.5 7.5 0 1 0 0-15 7.5 7.5 0 0 0 0 15m4.53-9.72a.75.75 0 0 0-1.06-1.06l-5.22 5.22-1.72-1.72a.75.75 0 0 0-1.06 1.06l2.25 2.25a.75.75 0 0 0 1.06 0z",
    clipRule: "evenodd"
  })));
};
var CircleCheckFilled18 = (/* unused pure expression or super */ null && (SvgCircleCheckFilled18));

var _path$8W;
function _extends$92() { _extends$92 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$92.apply(this, arguments); }
var SvgCircleCheckFilled24 = function SvgCircleCheckFilled24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$92({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path$8W || (_path$8W = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10m5.987-13.012a.925.925 0 1 0-1.308-1.309l-7.012 7.013-2.346-2.346a.925.925 0 0 0-1.308 1.308l3 3a.925.925 0 0 0 1.308 0z",
    clipRule: "evenodd"
  })));
};
var CircleCheckFilled24 = (/* unused pure expression or super */ null && (SvgCircleCheckFilled24));

var _path$8V;
function _extends$91() { _extends$91 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$91.apply(this, arguments); }
var SvgCircleCheckFilled32 = function SvgCircleCheckFilled32(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$91({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _path$8V || (_path$8V = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M16 29.334c7.364 0 13.334-5.97 13.334-13.334S23.364 2.667 16 2.667 2.667 8.637 2.667 16 8.637 29.334 16 29.334m7.89-17.445a1.1 1.1 0 1 0-1.556-1.555l-9.445 9.444-3.222-3.222a1.1 1.1 0 1 0-1.556 1.555l4 4a1.1 1.1 0 0 0 1.556 0z",
    clipRule: "evenodd"
  })));
};
var CircleCheckFilled32 = (/* unused pure expression or super */ null && (SvgCircleCheckFilled32));

var _path$8U;
function _extends$90() { _extends$90 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$90.apply(this, arguments); }
var SvgCircleCheckFilled48 = function SvgCircleCheckFilled48(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$90({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none"
  }, props), _path$8U || (_path$8U = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M24 44c11.046 0 20-8.954 20-20S35.046 4 24 4 4 12.954 4 24s8.954 20 20 20m11.674-26.326a1.425 1.425 0 1 0-2.015-2.015L19.333 29.985l-4.992-4.993a1.425 1.425 0 0 0-2.015 2.016l6 6a1.425 1.425 0 0 0 2.015 0z",
    clipRule: "evenodd"
  })));
};
var CircleCheckFilled48 = (/* unused pure expression or super */ null && (SvgCircleCheckFilled48));

var CircleCheckFilledIcon = function CircleCheckFilledIcon(props) {
  var circleCheckFilled = {
    12: CircleCheckFilled12,
    16: CircleCheckFilled16,
    18: CircleCheckFilled18,
    24: CircleCheckFilled24,
    32: CircleCheckFilled32,
    48: CircleCheckFilled48
  };
  return jsx(IconTemplate, _assign({
    icons: circleCheckFilled
  }, props));
};

var _path$8T;
function _extends$8$() { _extends$8$ = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$8$.apply(this, arguments); }
var SvgCircleFilled12 = function SvgCircleFilled12(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$8$({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none"
  }, props), _path$8T || (_path$8T = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M10 6a4 4 0 1 1-8 0 4 4 0 0 1 8 0"
  })));
};
var CircleFilled12 = (/* unused pure expression or super */ null && (SvgCircleFilled12));

var _path$8S;
function _extends$8_() { _extends$8_ = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$8_.apply(this, arguments); }
var SvgCircleFilled16 = function SvgCircleFilled16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$8_({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path$8S || (_path$8S = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M13.333 8A5.333 5.333 0 1 1 2.667 8a5.333 5.333 0 0 1 10.666 0"
  })));
};
var CircleFilled16 = (/* unused pure expression or super */ null && (SvgCircleFilled16));

var _path$8R;
function _extends$8Z() { _extends$8Z = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$8Z.apply(this, arguments); }
var SvgCircleFilled18 = function SvgCircleFilled18(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$8Z({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _path$8R || (_path$8R = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M16.5 9a7.5 7.5 0 1 1-15 0 7.5 7.5 0 0 1 15 0"
  })));
};
var CircleFilled18 = (/* unused pure expression or super */ null && (SvgCircleFilled18));

var _path$8Q;
function _extends$8Y() { _extends$8Y = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$8Y.apply(this, arguments); }
var SvgCircleFilled24 = function SvgCircleFilled24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$8Y({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path$8Q || (_path$8Q = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M22 12c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10"
  })));
};
var CircleFilled24 = (/* unused pure expression or super */ null && (SvgCircleFilled24));

var _path$8P;
function _extends$8X() { _extends$8X = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$8X.apply(this, arguments); }
var SvgCircleFilled32 = function SvgCircleFilled32(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$8X({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _path$8P || (_path$8P = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M29.333 16c0 7.364-5.97 13.333-13.333 13.333S2.667 23.363 2.667 16 8.637 2.667 16 2.667 29.333 8.637 29.333 16"
  })));
};
var CircleFilled32 = (/* unused pure expression or super */ null && (SvgCircleFilled32));

var _path$8O;
function _extends$8W() { _extends$8W = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$8W.apply(this, arguments); }
var SvgCircleFilled48 = function SvgCircleFilled48(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$8W({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none"
  }, props), _path$8O || (_path$8O = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M44 24c0 11.046-8.954 20-20 20S4 35.046 4 24 12.954 4 24 4s20 8.954 20 20"
  })));
};
var CircleFilled48 = (/* unused pure expression or super */ null && (SvgCircleFilled48));

var CircleFilledIcon = function CircleFilledIcon(props) {
  var circleFilled = {
    12: CircleFilled12,
    16: CircleFilled16,
    18: CircleFilled18,
    24: CircleFilled24,
    32: CircleFilled32,
    48: CircleFilled48
  };
  return jsx(IconTemplate, _assign({
    icons: circleFilled
  }, props));
};

var _path$8N;
function _extends$8V() { _extends$8V = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$8V.apply(this, arguments); }
var SvgCircleWonFilled12 = function SvgCircleWonFilled12(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$8V({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none"
  }, props), _path$8N || (_path$8N = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M6 11A5 5 0 1 0 6 1a5 5 0 0 0 0 10M4.352 4.134a.6.6 0 1 0-1.153.333l.255.883H3.22a.6.6 0 0 0 0 1.2h.58l.511 1.767a.6.6 0 0 0 1.153 0L6 6.462l.536 1.855a.6.6 0 0 0 1.153 0l.51-1.767h.582a.6.6 0 0 0 0-1.2h-.235l.255-.883a.6.6 0 1 0-1.153-.333l-.536 1.854-.536-1.854a.6.6 0 0 0-1.152 0l-.536 1.854z",
    clipRule: "evenodd"
  })));
};
var CircleWonFilled12 = (/* unused pure expression or super */ null && (SvgCircleWonFilled12));

var _path$8M;
function _extends$8U() { _extends$8U = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$8U.apply(this, arguments); }
var SvgCircleWonFilled16 = function SvgCircleWonFilled16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$8U({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path$8M || (_path$8M = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14M5.567 5.064a.75.75 0 1 0-1.441.416l.399 1.38h-.466a.75.75 0 1 0 0 1.5h.899l.744 2.577a.75.75 0 0 0 1.441 0L8 7.974l.856 2.963a.75.75 0 0 0 1.441 0l.745-2.577h.9a.75.75 0 0 0 0-1.5h-.467l.399-1.38a.75.75 0 1 0-1.441-.417l-.856 2.963-.856-2.962a.75.75 0 0 0-1.441 0l-.856 2.962z",
    clipRule: "evenodd"
  })));
};
var CircleWonFilled16 = (/* unused pure expression or super */ null && (SvgCircleWonFilled16));

var _path$8L;
function _extends$8T() { _extends$8T = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$8T.apply(this, arguments); }
var SvgCircleWonFilled18 = function SvgCircleWonFilled18(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$8T({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _path$8L || (_path$8L = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M9 17A8 8 0 1 0 9 1a8 8 0 0 0 0 16M6.128 5.965a.8.8 0 0 0-1.537.445l.485 1.677H4.45a.8.8 0 1 0 0 1.6h1.088l.873 3.023a.8.8 0 0 0 1.537 0L9 9.07l1.051 3.64a.8.8 0 0 0 1.537 0l.873-3.023h1.09a.8.8 0 1 0 0-1.6h-.627l.484-1.677a.8.8 0 0 0-1.537-.445l-1.051 3.64-1.052-3.64a.8.8 0 0 0-1.537 0l-1.052 3.64z",
    clipRule: "evenodd"
  })));
};
var CircleWonFilled18 = (/* unused pure expression or super */ null && (SvgCircleWonFilled18));

var _path$8K;
function _extends$8S() { _extends$8S = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$8S.apply(this, arguments); }
var SvgCircleWonFilled24 = function SvgCircleWonFilled24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$8S({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path$8K || (_path$8K = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10M8.01 8a.9.9 0 0 0-1.729.5l.708 2.45H5.934a.9.9 0 1 0 0 1.8h1.575l1.2 4.15a.9.9 0 0 0 1.728 0L12 11.493l1.562 5.407a.9.9 0 0 0 1.73 0l1.198-4.15h1.578a.9.9 0 0 0 0-1.8H17.01l.708-2.45a.9.9 0 0 0-1.73-.5l-1.562 5.407L12.864 8a.9.9 0 0 0-1.729 0l-1.562 5.407z",
    clipRule: "evenodd"
  })));
};
var CircleWonFilled24 = (/* unused pure expression or super */ null && (SvgCircleWonFilled24));

var _path$8J;
function _extends$8R() { _extends$8R = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$8R.apply(this, arguments); }
var SvgCircleWonFilled32 = function SvgCircleWonFilled32(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$8R({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _path$8J || (_path$8J = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M16 29c7.18 0 13-5.82 13-13S23.18 3 16 3 3 8.82 3 16s5.82 13 13 13m-5.51-18.278a1 1 0 0 0-1.922.556L9.586 14.8H7.912a1 1 0 1 0 0 2h2.251l1.64 5.677a1 1 0 0 0 1.922 0L16 14.604l2.275 7.874a1 1 0 0 0 1.922 0l1.64-5.677h2.254a1 1 0 0 0 0-2h-1.676l1.017-3.523a1 1 0 1 0-1.921-.555l-2.275 7.875-2.275-7.875a1 1 0 0 0-1.921 0l-2.275 7.875z",
    clipRule: "evenodd"
  })));
};
var CircleWonFilled32 = (/* unused pure expression or super */ null && (SvgCircleWonFilled32));

var _path$8I;
function _extends$8Q() { _extends$8Q = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$8Q.apply(this, arguments); }
var SvgCircleWonFilled48 = function SvgCircleWonFilled48(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$8Q({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none"
  }, props), _path$8I || (_path$8I = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M24 44c11.046 0 20-8.954 20-20S35.046 4 24 4 4 12.954 4 24s8.954 20 20 20m-8.554-27.833a1.2 1.2 0 0 0-2.306.666l1.637 5.667h-2.91a1.2 1.2 0 0 0 0 2.4h3.604l2.523 8.733a1.2 1.2 0 0 0 2.305 0L24 20.823l3.701 12.81a1.2 1.2 0 0 0 2.306 0l2.523-8.734h3.606a1.2 1.2 0 0 0 0-2.4h-2.913l1.637-5.666a1.2 1.2 0 0 0-2.305-.666l-3.701 12.81-3.7-12.81a1.2 1.2 0 0 0-2.307 0l-3.7 12.81z",
    clipRule: "evenodd"
  })));
};
var CircleWonFilled48 = (/* unused pure expression or super */ null && (SvgCircleWonFilled48));

var CircleWonFilledIcon = function CircleWonFilledIcon(props) {
  var circleWonFilled = {
    12: CircleWonFilled12,
    16: CircleWonFilled16,
    18: CircleWonFilled18,
    24: CircleWonFilled24,
    32: CircleWonFilled32,
    48: CircleWonFilled48
  };
  return jsx(IconTemplate, _assign({
    icons: circleWonFilled
  }, props));
};

var _g$7, _defs$7;
function _extends$8P() { _extends$8P = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$8P.apply(this, arguments); }
var SvgClock12 = function SvgClock12(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$8P({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none"
  }, props), _g$7 || (_g$7 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clock_12_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M6 2.1a3.9 3.9 0 1 0 0 7.8 3.9 3.9 0 0 0 0-7.8M.9 6a5.1 5.1 0 1 1 10.2 0A5.1 5.1 0 0 1 .9 6m4.85-3.6a.6.6 0 0 1 .6.6v2.5c0 .22.179.4.4.4h1.5a.6.6 0 1 1 0 1.2h-1.5a1.6 1.6 0 0 1-1.6-1.6V3a.6.6 0 0 1 .6-.6",
    clipRule: "evenodd"
  }))), _defs$7 || (_defs$7 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clock_12_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h12v12H0z"
  })))));
};
var Clock12 = (/* unused pure expression or super */ null && (SvgClock12));

var _path$8H;
function _extends$8O() { _extends$8O = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$8O.apply(this, arguments); }
var SvgClock16 = function SvgClock16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$8O({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path$8H || (_path$8H = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M8 2.75a5.25 5.25 0 1 0 0 10.5 5.25 5.25 0 0 0 0-10.5M1.25 8a6.75 6.75 0 1 1 13.5 0 6.75 6.75 0 0 1-13.5 0m6.417-4.75a.75.75 0 0 1 .75.75v3.333c0 .322.26.584.583.584h2a.75.75 0 0 1 0 1.5H9a2.083 2.083 0 0 1-2.083-2.084V4a.75.75 0 0 1 .75-.75",
    clipRule: "evenodd"
  })));
};
var Clock16 = (/* unused pure expression or super */ null && (SvgClock16));

var _path$8G;
function _extends$8N() { _extends$8N = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$8N.apply(this, arguments); }
var SvgClock18 = function SvgClock18(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$8N({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _path$8G || (_path$8G = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M9 3.05a5.95 5.95 0 1 0 0 11.9 5.95 5.95 0 0 0 0-11.9M1.45 9a7.55 7.55 0 1 1 15.1 0 7.55 7.55 0 0 1-15.1 0m7.175-5.3a.8.8 0 0 1 .8.8v3.75a.7.7 0 0 0 .7.7h2.25a.8.8 0 0 1 0 1.6h-2.25a2.3 2.3 0 0 1-2.3-2.3V4.5a.8.8 0 0 1 .8-.8",
    clipRule: "evenodd"
  })));
};
var Clock18 = (/* unused pure expression or super */ null && (SvgClock18));

var _path$8F;
function _extends$8M() { _extends$8M = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$8M.apply(this, arguments); }
var SvgClock24 = function SvgClock24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$8M({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path$8F || (_path$8F = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M12 3.9a8.1 8.1 0 1 0 0 16.2 8.1 8.1 0 0 0 0-16.2M2.1 12c0-5.468 4.432-9.9 9.9-9.9s9.9 4.432 9.9 9.9-4.432 9.9-9.9 9.9-9.9-4.432-9.9-9.9m9.4-6.9a.9.9 0 0 1 .9.9v5a1.1 1.1 0 0 0 1.1 1.1h3a.9.9 0 0 1 0 1.8h-3a2.9 2.9 0 0 1-2.9-2.9V6a.9.9 0 0 1 .9-.9",
    clipRule: "evenodd"
  })));
};
var Clock24 = (/* unused pure expression or super */ null && (SvgClock24));

var _path$8E;
function _extends$8L() { _extends$8L = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$8L.apply(this, arguments); }
var SvgClock32 = function SvgClock32(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$8L({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _path$8E || (_path$8E = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M16 5C9.925 5 5 9.925 5 16s4.925 11 11 11 11-4.925 11-11S22.075 5 16 5M3 16C3 8.82 8.82 3 16 3s13 5.82 13 13-5.82 13-13 13S3 23.18 3 16m12.333-9a1 1 0 0 1 1 1v6.667c0 .92.747 1.666 1.667 1.666h4a1 1 0 1 1 0 2h-4a3.667 3.667 0 0 1-3.667-3.666V8a1 1 0 0 1 1-1",
    clipRule: "evenodd"
  })));
};
var Clock32 = (/* unused pure expression or super */ null && (SvgClock32));

var _path$8D;
function _extends$8K() { _extends$8K = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$8K.apply(this, arguments); }
var SvgClock48 = function SvgClock48(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$8K({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none"
  }, props), _path$8D || (_path$8D = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M24 7.2C14.722 7.2 7.2 14.722 7.2 24S14.722 40.8 24 40.8 40.8 33.278 40.8 24 33.278 7.2 24 7.2M4.8 24C4.8 13.396 13.396 4.8 24 4.8S43.2 13.396 43.2 24 34.604 43.2 24 43.2 4.8 34.604 4.8 24M23 10.8a1.2 1.2 0 0 1 1.2 1.2v10a2.8 2.8 0 0 0 2.8 2.8h6a1.2 1.2 0 1 1 0 2.4h-6a5.2 5.2 0 0 1-5.2-5.2V12a1.2 1.2 0 0 1 1.2-1.2",
    clipRule: "evenodd"
  })));
};
var Clock48 = (/* unused pure expression or super */ null && (SvgClock48));

var ClockIcon = function ClockIcon(props) {
  var clock = {
    12: Clock12,
    16: Clock16,
    18: Clock18,
    24: Clock24,
    32: Clock32,
    48: Clock48
  };
  return jsx(IconTemplate, _assign({
    icons: clock
  }, props));
};

var _path$8C;
function _extends$8J() { _extends$8J = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$8J.apply(this, arguments); }
var SvgClockFilled12 = function SvgClockFilled12(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$8J({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none"
  }, props), _path$8C || (_path$8C = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M6 11A5 5 0 1 0 6 1a5 5 0 0 0 0 10m.35-8a.6.6 0 0 0-1.2 0v2.5a1.6 1.6 0 0 0 1.6 1.6h1.5a.6.6 0 0 0 0-1.2h-1.5a.4.4 0 0 1-.4-.4z",
    clipRule: "evenodd"
  })));
};
var ClockFilled12 = (/* unused pure expression or super */ null && (SvgClockFilled12));

var _path$8B;
function _extends$8I() { _extends$8I = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$8I.apply(this, arguments); }
var SvgClockFilled16 = function SvgClockFilled16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$8I({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path$8B || (_path$8B = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M8 14.667A6.667 6.667 0 1 0 8 1.333a6.667 6.667 0 0 0 0 13.334M8.417 4a.75.75 0 0 0-1.5 0v3.334c0 1.15.932 2.083 2.083 2.083h2a.75.75 0 0 0 0-1.5H9a.583.583 0 0 1-.583-.583z",
    clipRule: "evenodd"
  })));
};
var ClockFilled16 = (/* unused pure expression or super */ null && (SvgClockFilled16));

var _path$8A;
function _extends$8H() { _extends$8H = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$8H.apply(this, arguments); }
var SvgClockFilled18 = function SvgClockFilled18(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$8H({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _path$8A || (_path$8A = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M9.5 16.5a7.5 7.5 0 1 0 0-15 7.5 7.5 0 0 0 0 15m.425-12a.8.8 0 1 0-1.6 0v3.75a2.3 2.3 0 0 0 2.3 2.3h2.25a.8.8 0 0 0 0-1.6h-2.25a.7.7 0 0 1-.7-.7z",
    clipRule: "evenodd"
  })));
};
var ClockFilled18 = (/* unused pure expression or super */ null && (SvgClockFilled18));

var _path$8z;
function _extends$8G() { _extends$8G = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$8G.apply(this, arguments); }
var SvgClockFilled24 = function SvgClockFilled24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$8G({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path$8z || (_path$8z = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10m.4-16a.9.9 0 1 0-1.8 0v5a2.9 2.9 0 0 0 2.9 2.9h3a.9.9 0 1 0 0-1.8h-3a1.1 1.1 0 0 1-1.1-1.1z",
    clipRule: "evenodd"
  })));
};
var ClockFilled24 = (/* unused pure expression or super */ null && (SvgClockFilled24));

var _path$8y;
function _extends$8F() { _extends$8F = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$8F.apply(this, arguments); }
var SvgClockFilled32 = function SvgClockFilled32(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$8F({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _path$8y || (_path$8y = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M16 29.333c7.364 0 13.334-5.97 13.334-13.333S23.364 2.667 16 2.667 2.667 8.637 2.667 16 8.637 29.333 16 29.333M16.334 8a1 1 0 1 0-2 0v6.667A3.666 3.666 0 0 0 18 18.333h4a1 1 0 0 0 0-2h-4c-.921 0-1.666-.745-1.666-1.666z",
    clipRule: "evenodd"
  })));
};
var ClockFilled32 = (/* unused pure expression or super */ null && (SvgClockFilled32));

var _path$8x;
function _extends$8E() { _extends$8E = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$8E.apply(this, arguments); }
var SvgClockFilled48 = function SvgClockFilled48(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$8E({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none"
  }, props), _path$8x || (_path$8x = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M24 44c11.046 0 20-8.954 20-20S35.046 4 24 4 4 12.954 4 24s8.954 20 20 20m.2-32a1.2 1.2 0 1 0-2.4 0v10.001A5.2 5.2 0 0 0 27 27.2h6a1.2 1.2 0 1 0 0-2.4h-6A2.8 2.8 0 0 1 24.2 22z",
    clipRule: "evenodd"
  })));
};
var ClockFilled48 = (/* unused pure expression or super */ null && (SvgClockFilled48));

var ClockFilledIcon = function ClockFilledIcon(props) {
  var clockFilled = {
    12: ClockFilled12,
    16: ClockFilled16,
    18: ClockFilled18,
    24: ClockFilled24,
    32: ClockFilled32,
    48: ClockFilled48
  };
  return jsx(IconTemplate, _assign({
    icons: clockFilled
  }, props));
};

var _path$8w;
function _extends$8D() { _extends$8D = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$8D.apply(this, arguments); }
var SvgComment12 = function SvgComment12(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$8D({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none"
  }, props), _path$8w || (_path$8w = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "m8.877 7.883.208-.413a3.636 3.636 0 1 0-1.577 1.595l.418-.217 1.316.363zM8.06 10.13a4.836 4.836 0 1 1 2.095-2.12l.576 2.091c.1.365-.235.7-.6.6z",
    clipRule: "evenodd"
  })));
};
var Comment12 = (/* unused pure expression or super */ null && (SvgComment12));

var _path$8v;
function _extends$8C() { _extends$8C = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$8C.apply(this, arguments); }
var SvgComment16 = function SvgComment16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$8C({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path$8v || (_path$8v = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "m11.942 10.521.26-.516a4.948 4.948 0 1 0-2.145 2.17l.523-.27 1.886.519zm-1.193 2.986a6.448 6.448 0 1 1 2.794-2.827l.767 2.789a.65.65 0 0 1-.8.798z",
    clipRule: "evenodd"
  })));
};
var Comment16 = (/* unused pure expression or super */ null && (SvgComment16));

var _path$8u;
function _extends$8B() { _extends$8B = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$8B.apply(this, arguments); }
var SvgComment18 = function SvgComment18(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$8B({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _path$8u || (_path$8u = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "m13.528 11.846.278-.55a5.654 5.654 0 1 0-2.451 2.48l.557-.29 2.237.616zm-1.436 3.35a7.254 7.254 0 1 1 3.143-3.18l.863 3.136a.73.73 0 0 1-.899.899z",
    clipRule: "evenodd"
  })));
};
var Comment18 = (/* unused pure expression or super */ null && (SvgComment18));

var _path$8t;
function _extends$8A() { _extends$8A = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$8A.apply(this, arguments); }
var SvgComment24 = function SvgComment24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$8A({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path$8t || (_path$8t = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "m18.393 15.83.313-.62a7.8 7.8 0 0 0 .838-3.538 7.872 7.872 0 1 0-7.872 7.872 7.8 7.8 0 0 0 3.621-.88l.627-.326 3.423.942zm-2.27 4.43a9.6 9.6 0 0 1-4.451 1.083C6.33 21.344 2 17.014 2 11.673 2 6.33 6.33 2 11.672 2c5.341 0 9.671 4.33 9.671 9.672a9.6 9.6 0 0 1-1.03 4.349l1.151 4.182a.974.974 0 0 1-1.198 1.198z"
  })));
};
var Comment24 = (/* unused pure expression or super */ null && (SvgComment24));

var _path$8s;
function _extends$8z() { _extends$8z = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$8z.apply(this, arguments); }
var SvgComment32 = function SvgComment32(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$8z({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _path$8s || (_path$8s = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "m24.95 21.149.348-.688a10.84 10.84 0 0 0 1.16-4.899c0-6.017-4.878-10.895-10.896-10.895-6.017 0-10.895 4.878-10.895 10.895 0 6.018 4.878 10.896 10.895 10.896 1.812 0 3.515-.44 5.013-1.219l.696-.361 5.092 1.401zm-3.453 5.865a12.84 12.84 0 0 1-5.935 1.444c-7.122 0-12.895-5.773-12.895-12.896 0-7.122 5.773-12.895 12.895-12.895S28.458 8.44 28.458 15.562c0 2.086-.495 4.056-1.374 5.8l1.535 5.575a1.3 1.3 0 0 1-1.598 1.598z",
    clipRule: "evenodd"
  })));
};
var Comment32 = (/* unused pure expression or super */ null && (SvgComment32));

var _path$8r;
function _extends$8y() { _extends$8y = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$8y.apply(this, arguments); }
var SvgComment48 = function SvgComment48(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$8y({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none"
  }, props), _path$8r || (_path$8r = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "m38.066 31.787.417-.826a16.86 16.86 0 0 0 1.804-7.617c0-9.358-7.586-16.944-16.943-16.944S6.4 13.986 6.4 23.344s7.586 16.943 16.944 16.943c2.815 0 5.464-.685 7.795-1.895l.836-.434 8.428 2.32zm-5.82 8.734a19.26 19.26 0 0 1-8.903 2.166C12.66 42.687 4 34.027 4 23.344S12.66 4 23.344 4c10.683 0 19.343 8.66 19.343 19.344 0 3.128-.743 6.083-2.061 8.698l2.302 8.364c.401 1.458-.938 2.797-2.396 2.396z",
    clipRule: "evenodd"
  })));
};
var Comment48 = (/* unused pure expression or super */ null && (SvgComment48));

var CommentIcon = function CommentIcon(props) {
  var comment = {
    12: Comment12,
    16: Comment16,
    18: Comment18,
    24: Comment24,
    32: Comment32,
    48: Comment48
  };
  return jsx(IconTemplate, _assign({
    icons: comment
  }, props));
};

var _path$8q;
function _extends$8x() { _extends$8x = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$8x.apply(this, arguments); }
var SvgCommentFilled12 = function SvgCommentFilled12(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$8x({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none"
  }, props), _path$8q || (_path$8q = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M10.156 8.01a4.836 4.836 0 1 0-2.095 2.12l2.072.57c.364.1.7-.234.599-.598z"
  })));
};
var CommentFilled12 = (/* unused pure expression or super */ null && (SvgCommentFilled12));

var _path$8p;
function _extends$8w() { _extends$8w = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$8w.apply(this, arguments); }
var SvgCommentFilled16 = function SvgCommentFilled16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$8w({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path$8p || (_path$8p = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M13.542 10.68a6.448 6.448 0 1 0-2.793 2.827l2.762.76a.65.65 0 0 0 .798-.798z"
  })));
};
var CommentFilled16 = (/* unused pure expression or super */ null && (SvgCommentFilled16));

var _path$8o;
function _extends$8v() { _extends$8v = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$8v.apply(this, arguments); }
var SvgCommentFilled18 = function SvgCommentFilled18(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$8v({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _path$8o || (_path$8o = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M15.235 12.016a7.254 7.254 0 1 0-3.143 3.18l3.107.855a.73.73 0 0 0 .899-.899z"
  })));
};
var CommentFilled18 = (/* unused pure expression or super */ null && (SvgCommentFilled18));

var _path$8n;
function _extends$8u() { _extends$8u = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$8u.apply(this, arguments); }
var SvgCommentFilled24 = function SvgCommentFilled24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$8u({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path$8n || (_path$8n = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M20.313 16.02a9.6 9.6 0 0 0 1.03-4.348C21.344 6.33 17.014 2 11.673 2 6.33 2 2 6.33 2 11.672c0 5.341 4.33 9.671 9.672 9.671a9.6 9.6 0 0 0 4.45-1.082l4.144 1.14a.974.974 0 0 0 1.198-1.198z"
  })));
};
var CommentFilled24 = (/* unused pure expression or super */ null && (SvgCommentFilled24));

var _path$8m;
function _extends$8t() { _extends$8t = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$8t.apply(this, arguments); }
var SvgCommentFilled32 = function SvgCommentFilled32(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$8t({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _path$8m || (_path$8m = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M27.084 21.361a12.84 12.84 0 0 0 1.374-5.799c0-7.122-5.774-12.895-12.896-12.895S2.667 8.44 2.667 15.562c0 7.123 5.773 12.896 12.895 12.896 2.14 0 4.158-.521 5.935-1.444l5.524 1.52a1.3 1.3 0 0 0 1.598-1.597z"
  })));
};
var CommentFilled32 = (/* unused pure expression or super */ null && (SvgCommentFilled32));

var _path$8l;
function _extends$8s() { _extends$8s = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$8s.apply(this, arguments); }
var SvgCommentFilled48 = function SvgCommentFilled48(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$8s({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none"
  }, props), _path$8l || (_path$8l = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M40.626 32.042a19.26 19.26 0 0 0 2.061-8.699C42.687 12.66 34.027 4 23.344 4S4 12.66 4 23.344c0 10.683 8.66 19.343 19.344 19.343 3.21 0 6.237-.782 8.901-2.166l8.287 2.281c1.458.401 2.797-.938 2.396-2.396z"
  })));
};
var CommentFilled48 = (/* unused pure expression or super */ null && (SvgCommentFilled48));

var CommentFilledIcon = function CommentFilledIcon(props) {
  var commentFilled = {
    12: CommentFilled12,
    16: CommentFilled16,
    18: CommentFilled18,
    24: CommentFilled24,
    32: CommentFilled32,
    48: CommentFilled48
  };
  return jsx(IconTemplate, _assign({
    icons: commentFilled
  }, props));
};

var _path$8k, _path2$34;
function _extends$8r() { _extends$8r = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$8r.apply(this, arguments); }
var SvgContentList12 = function SvgContentList12(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$8r({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none"
  }, props), _path$8k || (_path$8k = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M2.95 3a.6.6 0 0 1 .6-.6h6.8a.6.6 0 1 1 0 1.2h-6.8a.6.6 0 0 1-.6-.6M2.95 6a.6.6 0 0 1 .6-.6h6.8a.6.6 0 1 1 0 1.2h-6.8a.6.6 0 0 1-.6-.6M2.95 9a.6.6 0 0 1 .6-.6h6.8a.6.6 0 1 1 0 1.2h-6.8a.6.6 0 0 1-.6-.6",
    clipRule: "evenodd"
  })), _path2$34 || (_path2$34 = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M2.2 3A.6.6 0 1 1 1 3a.6.6 0 0 1 1.2 0M2.2 6.05a.6.6 0 1 1-1.2 0 .6.6 0 0 1 1.2 0M2.2 9.05a.6.6 0 1 1-1.2 0 .6.6 0 0 1 1.2 0"
  })));
};
var ContentList12 = (/* unused pure expression or super */ null && (SvgContentList12));

var _path$8j, _path2$33;
function _extends$8q() { _extends$8q = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$8q.apply(this, arguments); }
var SvgContentList16 = function SvgContentList16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$8q({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path$8j || (_path$8j = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M3.6 4a.75.75 0 0 1 .75-.75h9.5a.75.75 0 0 1 0 1.5h-9.5A.75.75 0 0 1 3.6 4M3.6 8a.75.75 0 0 1 .75-.75h9.5a.75.75 0 0 1 0 1.5h-9.5A.75.75 0 0 1 3.6 8M3.6 12a.75.75 0 0 1 .75-.75h9.5a.75.75 0 0 1 0 1.5h-9.5A.75.75 0 0 1 3.6 12",
    clipRule: "evenodd"
  })), _path2$33 || (_path2$33 = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M2.834 4.05a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0M2.834 8.05a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0M2.834 12.05a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0"
  })));
};
var ContentList16 = (/* unused pure expression or super */ null && (SvgContentList16));

var _path$8i, _path2$32;
function _extends$8p() { _extends$8p = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$8p.apply(this, arguments); }
var SvgContentList18 = function SvgContentList18(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$8p({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _path$8i || (_path$8i = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M3.7 4.5a.8.8 0 0 1 .8-.8h11.25a.8.8 0 0 1 0 1.6H4.5a.8.8 0 0 1-.8-.8M3.7 9a.8.8 0 0 1 .8-.8h11.25a.8.8 0 0 1 0 1.6H4.5a.8.8 0 0 1-.8-.8M3.7 13.5a.8.8 0 0 1 .8-.8h11.25a.8.8 0 1 1 0 1.6H4.5a.8.8 0 0 1-.8-.8",
    clipRule: "evenodd"
  })), _path2$32 || (_path2$32 = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M3.1 4.55a.8.8 0 1 1-1.6 0 .8.8 0 0 1 1.6 0M3.1 8.95a.8.8 0 1 1-1.6 0 .8.8 0 0 1 1.6 0M3.1 13.45a.8.8 0 1 1-1.6 0 .8.8 0 0 1 1.6 0"
  })));
};
var ContentList18 = (/* unused pure expression or super */ null && (SvgContentList18));

var _path$8h, _path2$31;
function _extends$8o() { _extends$8o = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$8o.apply(this, arguments); }
var SvgContentList24 = function SvgContentList24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$8o({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path$8h || (_path$8h = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M5.1 6a.9.9 0 0 1 .9-.9h15a.9.9 0 1 1 0 1.8H6a.9.9 0 0 1-.9-.9M5.1 12a.9.9 0 0 1 .9-.9h15a.9.9 0 1 1 0 1.8H6a.9.9 0 0 1-.9-.9M5.1 18a.9.9 0 0 1 .9-.9h15a.9.9 0 1 1 0 1.8H6a.9.9 0 0 1-.9-.9",
    clipRule: "evenodd"
  })), _path2$31 || (_path2$31 = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M4 6a1 1 0 1 1-2 0 1 1 0 0 1 2 0M4 12a1 1 0 1 1-2 0 1 1 0 0 1 2 0M4 18a1 1 0 1 1-2 0 1 1 0 0 1 2 0"
  })));
};
var ContentList24 = (/* unused pure expression or super */ null && (SvgContentList24));

var _path$8g, _path2$30;
function _extends$8n() { _extends$8n = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$8n.apply(this, arguments); }
var SvgContentList32 = function SvgContentList32(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$8n({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _path$8g || (_path$8g = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M7 8a1 1 0 0 1 1-1h20a1 1 0 1 1 0 2H8a1 1 0 0 1-1-1M7 16a1 1 0 0 1 1-1h20a1 1 0 1 1 0 2H8a1 1 0 0 1-1-1M7 24a1 1 0 0 1 1-1h20a1 1 0 1 1 0 2H8a1 1 0 0 1-1-1",
    clipRule: "evenodd"
  })), _path2$30 || (_path2$30 = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M5 8a1 1 0 1 1-2 0 1 1 0 0 1 2 0M5 16a1 1 0 1 1-2 0 1 1 0 0 1 2 0M5 24a1 1 0 1 1-2 0 1 1 0 0 1 2 0"
  })));
};
var ContentList32 = (/* unused pure expression or super */ null && (SvgContentList32));

var _path$8f, _path2$2$;
function _extends$8m() { _extends$8m = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$8m.apply(this, arguments); }
var SvgContentList48 = function SvgContentList48(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$8m({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none"
  }, props), _path$8f || (_path$8f = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M8.6 12a1.2 1.2 0 0 1 1.2-1.2h33a1.2 1.2 0 0 1 0 2.4h-33A1.2 1.2 0 0 1 8.6 12M8.6 24a1.2 1.2 0 0 1 1.2-1.2h33a1.2 1.2 0 0 1 0 2.4h-33A1.2 1.2 0 0 1 8.6 24M8.6 36a1.2 1.2 0 0 1 1.2-1.2h33a1.2 1.2 0 0 1 0 2.4h-33A1.2 1.2 0 0 1 8.6 36",
    clipRule: "evenodd"
  })), _path2$2$ || (_path2$2$ = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M6.4 12A1.2 1.2 0 1 1 4 12a1.2 1.2 0 0 1 2.4 0M6.4 24A1.2 1.2 0 1 1 4 24a1.2 1.2 0 0 1 2.4 0M6.4 36A1.2 1.2 0 1 1 4 36a1.2 1.2 0 0 1 2.4 0"
  })));
};
var ContentList48 = (/* unused pure expression or super */ null && (SvgContentList48));

var ContentListIcon = function ContentListIcon(props) {
  var contentList = {
    12: ContentList12,
    16: ContentList16,
    18: ContentList18,
    24: ContentList24,
    32: ContentList32,
    48: ContentList48
  };
  return jsx(IconTemplate, _assign({
    icons: contentList
  }, props));
};

var _path$8e, _path2$2_;
function _extends$8l() { _extends$8l = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$8l.apply(this, arguments); }
var SvgCoupon12 = function SvgCoupon12(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$8l({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none"
  }, props), _path$8e || (_path$8e = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M7.7 5.85a.6.6 0 0 0-1.2 0v.133a.6.6 0 0 0 1.2 0z"
  })), _path2$2_ || (_path2$2_ = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M1.8 2h3.465c.465 0 .833.354 1.128.714.18.22.408.353.657.353s.478-.132.657-.353C8.002 2.354 8.37 2 8.835 2H10.2c.58 0 1.05.478 1.05 1.067v5.866c0 .59-.47 1.067-1.05 1.067H8.835c-.465 0-.833-.354-1.128-.714-.18-.22-.408-.353-.657-.353s-.478.132-.657.353c-.295.36-.663.714-1.128.714H1.8C1.22 10 .75 9.522.75 8.933V3.067C.75 2.477 1.22 2 1.8 2m.15 6.8V3.2h3.248a1 1 0 0 1 .108.095q.071.073.157.178c.34.417.883.794 1.587.794s1.247-.377 1.587-.794q.087-.106.157-.178a1 1 0 0 1 .108-.095h1.148v5.6H8.902a1 1 0 0 1-.108-.095 3 3 0 0 1-.157-.178c-.34-.417-.883-.794-1.587-.794s-1.247.377-1.587.794q-.087.105-.157.178a1 1 0 0 1-.108.095z",
    clipRule: "evenodd"
  })));
};
var Coupon12 = (/* unused pure expression or super */ null && (SvgCoupon12));

var _path$8d, _path2$2Z;
function _extends$8k() { _extends$8k = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$8k.apply(this, arguments); }
var SvgCoupon16 = function SvgCoupon16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$8k({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path$8d || (_path$8d = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M10.267 7.863a.8.8 0 0 0-1.6 0v.267a.8.8 0 1 0 1.6 0z"
  })), _path2$2Z || (_path2$2Z = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M2.4 2.667h4.885c.465 0 .845.338 1.086.736.256.422.622.686 1.029.686s.773-.264 1.029-.686c.24-.398.62-.736 1.086-.736H13.6c.773 0 1.4.637 1.4 1.422v7.822c0 .786-.627 1.422-1.4 1.422h-2.085c-.465 0-.845-.338-1.086-.735-.256-.423-.622-.687-1.029-.687s-.773.264-1.029.687c-.24.397-.62.735-1.086.735H2.4c-.773 0-1.4-.636-1.4-1.422V4.09c0-.786.627-1.422 1.4-1.422m.1 9.166V4.167h4.58l.008.013c.42.69 1.2 1.409 2.312 1.409s1.893-.718 2.312-1.41l.008-.012h1.78v7.666h-1.78l-.008-.013c-.42-.69-1.2-1.409-2.312-1.409s-1.893.718-2.312 1.41l-.008.012z",
    clipRule: "evenodd"
  })));
};
var Coupon16 = (/* unused pure expression or super */ null && (SvgCoupon16));

var _path$8c, _path2$2Y;
function _extends$8j() { _extends$8j = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$8j.apply(this, arguments); }
var SvgCoupon18 = function SvgCoupon18(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$8j({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _path$8c || (_path$8c = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M10.55 6.837a.8.8 0 0 1 .8.8v.1a.8.8 0 0 1-1.6 0v-.1a.8.8 0 0 1 .8-.8M10.55 9.462a.8.8 0 0 1 .8.8v.1a.8.8 0 0 1-1.6 0v-.1a.8.8 0 0 1 .8-.8"
  })), _path2$2Y || (_path2$2Y = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M2.7 3h5.595c.465 0 .849.334 1.073.742.289.524.722.858 1.207.858s.918-.334 1.207-.858c.225-.408.608-.742 1.073-.742H15.3c.87 0 1.575.716 1.575 1.6v8.8c0 .884-.705 1.6-1.575 1.6h-2.445c-.465 0-.848-.334-1.073-.742-.289-.524-.722-.858-1.207-.858s-.918.334-1.207.858c-.224.408-.608.742-1.073.742H2.7c-.87 0-1.575-.716-1.575-1.6V4.6c0-.884.705-1.6 1.575-1.6m.025 10.4V4.6h5.29c.462.788 1.322 1.6 2.56 1.6s2.098-.812 2.56-1.6h2.14v8.8h-2.14c-.462-.788-1.322-1.6-2.56-1.6s-2.098.812-2.56 1.6z",
    clipRule: "evenodd"
  })));
};
var Coupon18 = (/* unused pure expression or super */ null && (SvgCoupon18));

var _path$8b, _path2$2X;
function _extends$8i() { _extends$8i = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$8i.apply(this, arguments); }
var SvgCoupon24 = function SvgCoupon24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$8i({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path$8b || (_path$8b = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M13.9 11.25a.9.9 0 0 1-.9-.9v-.2a.9.9 0 1 1 1.8 0v.2a.9.9 0 0 1-.9.9M13.9 14.75a.9.9 0 0 1-.9-.9v-.2a.9.9 0 1 1 1.8 0v.2a.9.9 0 0 1-.9.9"
  })), _path2$2X || (_path2$2X = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M10.884 5.8c.575 1.068 1.65 2.133 3.216 2.133s2.64-1.065 3.216-2.133H20.4c.14 0 .3.122.3.333v11.734c0 .21-.16.333-.3.333h-3.084c-.575-1.068-1.65-2.133-3.216-2.133s-2.64 1.065-3.216 2.133H3.6c-.14 0-.3-.122-.3-.333V6.133c0-.21.16-.333.3-.333zm.44-1.8H3.6c-1.16 0-2.1.955-2.1 2.133v11.734C1.5 19.045 2.44 20 3.6 20h7.725c.465 0 .855-.328 1.047-.752.379-.835 1.012-1.381 1.728-1.381s1.35.546 1.728 1.38c.192.425.582.753 1.047.753H20.4c1.16 0 2.1-.955 2.1-2.133V6.133C22.5 4.955 21.56 4 20.4 4h-3.525c-.465 0-.855.329-1.047.752-.379.835-1.012 1.381-1.728 1.381s-1.35-.546-1.728-1.38C12.18 4.328 11.79 4 11.325 4"
  })));
};
var Coupon24 = (/* unused pure expression or super */ null && (SvgCoupon24));

var _path$8a, _path2$2W;
function _extends$8h() { _extends$8h = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$8h.apply(this, arguments); }
var SvgCoupon32 = function SvgCoupon32(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$8h({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _path$8a || (_path$8a = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M18.333 12.333a1 1 0 0 1 1 1V14a1 1 0 1 1-2 0v-.667a1 1 0 0 1 1-1M18.333 17a1 1 0 0 1 1 1v.667a1 1 0 1 1-2 0V18a1 1 0 0 1 1-1",
    clipRule: "evenodd"
  })), _path2$2W || (_path2$2W = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M14.757 7.333H4.8c-.412 0-.8.349-.8.845v15.644c0 .496.388.845.8.845h9.957c.712-1.444 2.064-2.845 4.043-2.845s3.33 1.4 4.043 2.845H27.2c.412 0 .8-.349.8-.845V8.178c0-.496-.388-.845-.8-.845h-4.357c-.712 1.444-2.064 2.845-4.043 2.845s-3.33-1.4-4.043-2.845m.608-2H4.8C3.254 5.333 2 6.607 2 8.178v15.644c0 1.571 1.254 2.845 2.8 2.845h10.565c.465 0 .859-.326 1.028-.76.488-1.248 1.384-2.085 2.407-2.085s1.919.837 2.407 2.086c.17.433.563.759 1.028.759H27.2c1.546 0 2.8-1.274 2.8-2.845V8.178c0-1.571-1.254-2.845-2.8-2.845h-4.965c-.465 0-.858.326-1.028.76-.488 1.248-1.384 2.085-2.407 2.085s-1.919-.837-2.407-2.086c-.17-.433-.563-.759-1.028-.759",
    clipRule: "evenodd"
  })));
};
var Coupon32 = (/* unused pure expression or super */ null && (SvgCoupon32));

var _path$89, _path2$2V;
function _extends$8g() { _extends$8g = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$8g.apply(this, arguments); }
var SvgCoupon48 = function SvgCoupon48(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$8g({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none"
  }, props), _path$89 || (_path$89 = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M29.4 17.7a1.2 1.2 0 0 0-2.4 0v1.6a1.2 1.2 0 0 0 2.4 0zM29.4 23.2a1.2 1.2 0 0 0-2.4 0v1.6a1.2 1.2 0 0 0 2.4 0zM28.2 27.5a1.2 1.2 0 0 1 1.2 1.2v1.6a1.2 1.2 0 0 1-2.4 0v-1.6a1.2 1.2 0 0 1 1.2-1.2"
  })), _path2$2V || (_path2$2V = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M7.2 8h16.244c.466 0 .863.324 1.01.765.694 2.078 2.111 3.502 3.746 3.502s3.052-1.424 3.746-3.502c.147-.441.544-.765 1.01-.765H40.8c2.32 0 4.2 1.91 4.2 4.267v23.466C45 38.09 43.12 40 40.8 40h-7.844c-.466 0-.863-.324-1.01-.765-.694-2.078-2.111-3.502-3.746-3.502s-3.052 1.424-3.746 3.502c-.147.441-.544.765-1.01.765H7.2C4.88 40 3 38.09 3 35.733V12.267C3 9.91 4.88 8 7.2 8m0 2.4h15.318c.982 2.202 2.893 4.267 5.682 4.267s4.7-2.065 5.682-4.267H40.8c.959 0 1.8.8 1.8 1.867v23.466c0 1.067-.841 1.867-1.8 1.867h-6.918c-.982-2.202-2.893-4.267-5.682-4.267s-4.7 2.065-5.682 4.267H7.2c-.959 0-1.8-.8-1.8-1.867V12.267c0-1.067.841-1.867 1.8-1.867",
    clipRule: "evenodd"
  })));
};
var Coupon48 = (/* unused pure expression or super */ null && (SvgCoupon48));

var CouponIcon = function CouponIcon(props) {
  var coupon = {
    12: Coupon12,
    16: Coupon16,
    18: Coupon18,
    24: Coupon24,
    32: Coupon32,
    48: Coupon48
  };
  return jsx(IconTemplate, _assign({
    icons: coupon
  }, props));
};

var _path$88;
function _extends$8f() { _extends$8f = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$8f.apply(this, arguments); }
var SvgCouponFilled12 = function SvgCouponFilled12(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$8f({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none"
  }, props), _path$88 || (_path$88 = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M5.662 2H1.8C1.22 2 .75 2.478.75 3.067v5.866C.75 9.523 1.22 10 1.8 10h3.862c.233 0 .428-.164.524-.376.19-.417.506-.69.864-.69s.675.273.864.69c.096.212.29.376.524.376H10.2c.58 0 1.05-.478 1.05-1.067V3.067c0-.59-.47-1.067-1.05-1.067H8.438c-.233 0-.428.164-.524.376-.19.417-.506.69-.864.69s-.675-.273-.864-.69C6.09 2.164 5.896 2 5.662 2M7.4 5.075a.45.45 0 1 0-.9 0v.1a.45.45 0 1 0 .9 0zm-.45 1.3a.45.45 0 0 1 .45.45v.1a.45.45 0 1 1-.9 0v-.1a.45.45 0 0 1 .45-.45",
    clipRule: "evenodd"
  })));
};
var CouponFilled12 = (/* unused pure expression or super */ null && (SvgCouponFilled12));

var _path$87;
function _extends$8e() { _extends$8e = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$8e.apply(this, arguments); }
var SvgCouponFilled16 = function SvgCouponFilled16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$8e({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path$87 || (_path$87 = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M7.55 2.667H2.4c-.773 0-1.4.637-1.4 1.422v7.822c0 .786.627 1.422 1.4 1.422h5.15c.31 0 .57-.219.698-.501.253-.556.674-.92 1.152-.92s.9.364 1.152.92c.128.282.388.501.698.501h2.35c.773 0 1.4-.636 1.4-1.422V4.09c0-.786-.627-1.422-1.4-1.422h-2.35c-.31 0-.57.219-.698.501-.253.557-.674.921-1.152.921s-.9-.364-1.152-.92c-.128-.283-.388-.502-.698-.502m2.317 4.1a.6.6 0 0 0-1.2 0V6.9a.6.6 0 0 0 1.2 0zm-.6 1.733a.6.6 0 0 1 .6.6v.133a.6.6 0 0 1-1.2 0V9.1a.6.6 0 0 1 .6-.6",
    clipRule: "evenodd"
  })));
};
var CouponFilled16 = (/* unused pure expression or super */ null && (SvgCouponFilled16));

var _path$86;
function _extends$8d() { _extends$8d = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$8d.apply(this, arguments); }
var SvgCouponFilled18 = function SvgCouponFilled18(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$8d({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _path$86 || (_path$86 = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M8.494 3H2.7c-.87 0-1.575.716-1.575 1.6v8.8c0 .884.705 1.6 1.575 1.6h5.794c.349 0 .64-.246.785-.564.284-.626.759-1.036 1.296-1.036s1.012.41 1.296 1.036c.144.318.436.564.785.564H15.3c.87 0 1.575-.716 1.575-1.6V4.6c0-.884-.705-1.6-1.575-1.6h-2.644c-.349 0-.64.246-.785.564-.284.626-.759 1.036-1.296 1.036s-1.012-.41-1.296-1.036C9.135 3.246 8.843 3 8.494 3M11.1 7.613a.675.675 0 1 0-1.35 0v.15a.675.675 0 1 0 1.35 0zm-.675 1.95c.373 0 .675.302.675.675v.15a.675.675 0 1 1-1.35 0v-.15c0-.373.302-.675.675-.675",
    clipRule: "evenodd"
  })));
};
var CouponFilled18 = (/* unused pure expression or super */ null && (SvgCouponFilled18));

var _path$85;
function _extends$8c() { _extends$8c = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$8c.apply(this, arguments); }
var SvgCouponFilled24 = function SvgCouponFilled24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$8c({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path$85 || (_path$85 = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M11.325 4H3.6c-1.16 0-2.1.955-2.1 2.133v11.734C1.5 19.045 2.44 20 3.6 20h7.725c.465 0 .855-.328 1.047-.752.379-.835 1.012-1.381 1.728-1.381s1.35.546 1.728 1.38c.192.425.582.753 1.047.753H20.4c1.16 0 2.1-.955 2.1-2.133V6.133C22.5 4.955 21.56 4 20.4 4h-3.525c-.465 0-.855.329-1.047.752-.379.835-1.012 1.381-1.728 1.381s-1.35-.546-1.728-1.38C12.18 4.328 11.79 4 11.325 4m3.475 6.15a.9.9 0 1 0-1.8 0v.2a.9.9 0 1 0 1.8 0zm-.9 2.6a.9.9 0 0 1 .9.9v.2a.9.9 0 1 1-1.8 0v-.2a.9.9 0 0 1 .9-.9",
    clipRule: "evenodd"
  })));
};
var CouponFilled24 = (/* unused pure expression or super */ null && (SvgCouponFilled24));

var _path$84;
function _extends$8b() { _extends$8b = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$8b.apply(this, arguments); }
var SvgCouponFilled32 = function SvgCouponFilled32(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$8b({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _path$84 || (_path$84 = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M15.1 5.333H4.8C3.254 5.333 2 6.607 2 8.178v15.644c0 1.571 1.254 2.845 2.8 2.845h10.3c.62 0 1.14-.439 1.396-1.003.505-1.113 1.349-1.842 2.304-1.842s1.799.729 2.304 1.842c.257.564.776 1.003 1.396 1.003h4.7c1.546 0 2.8-1.274 2.8-2.845V8.178c0-1.571-1.254-2.845-2.8-2.845h-4.7c-.62 0-1.14.438-1.396 1.003C20.6 7.45 19.755 8.178 18.8 8.178s-1.799-.73-2.304-1.842c-.257-.565-.776-1.003-1.396-1.003m4.633 8.2a1.2 1.2 0 1 0-2.4 0v.267a1.2 1.2 0 1 0 2.4 0zM18.533 17a1.2 1.2 0 0 1 1.2 1.2v.267a1.2 1.2 0 1 1-2.4 0V18.2a1.2 1.2 0 0 1 1.2-1.2",
    clipRule: "evenodd"
  })));
};
var CouponFilled32 = (/* unused pure expression or super */ null && (SvgCouponFilled32));

var _path$83;
function _extends$8a() { _extends$8a = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$8a.apply(this, arguments); }
var SvgCouponFilled48 = function SvgCouponFilled48(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$8a({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none"
  }, props), _path$83 || (_path$83 = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M22.65 8H7.2C4.88 8 3 9.91 3 12.267v23.466C3 38.09 4.88 40 7.2 40h15.45c.93 0 1.71-.657 2.094-1.504.758-1.67 2.023-2.763 3.456-2.763s2.698 1.094 3.456 2.763C32.041 39.343 32.82 40 33.75 40h7.05c2.32 0 4.2-1.91 4.2-4.267V12.267C45 9.91 43.12 8 40.8 8h-7.05c-.93 0-1.71.657-2.094 1.504-.758 1.67-2.023 2.763-3.456 2.763s-2.698-1.094-3.456-2.763C24.359 8.657 23.58 8 22.65 8m6.95 12.3a1.8 1.8 0 0 0-3.6 0v.4a1.8 1.8 0 0 0 3.6 0zm-1.8 5.2a1.8 1.8 0 0 1 1.8 1.8v.4a1.8 1.8 0 0 1-3.6 0v-.4a1.8 1.8 0 0 1 1.8-1.8",
    clipRule: "evenodd"
  })));
};
var CouponFilled48 = (/* unused pure expression or super */ null && (SvgCouponFilled48));

var CouponFilledIcon = function CouponFilledIcon(props) {
  var couponFilled = {
    12: CouponFilled12,
    16: CouponFilled16,
    18: CouponFilled18,
    24: CouponFilled24,
    32: CouponFilled32,
    48: CouponFilled48
  };
  return jsx(IconTemplate, _assign({
    icons: couponFilled
  }, props));
};

var _path$82;
function _extends$89() { _extends$89 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$89.apply(this, arguments); }
var SvgCrownFilled12 = function SvgCrownFilled12(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$89({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none"
  }, props), _path$82 || (_path$82 = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M2 9.816c0-.174.149-.316.332-.316h7.336c.183 0 .332.142.332.316v.532c0 .36-.306.652-.684.652H2.684C2.306 11 2 10.708 2 10.348zm8.446-8.476A1.45 1.45 0 0 1 12 2.794a1.46 1.46 0 0 1-1.013 1.392L9.941 8.683A.36.36 0 0 1 9.587 9H2.429a.36.36 0 0 1-.354-.316L1.018 4.187A1.46 1.46 0 0 1 0 2.794c0-.841.709-1.518 1.554-1.454a1.455 1.455 0 0 1 1.263 1.903c-.06.185-.155.356-.282.504l1.65.672 1.096-.684a1.46 1.46 0 0 1-.747-1.277c0-.84.708-1.518 1.555-1.454a1.462 1.462 0 0 1 .548 2.75l1.065.665 1.734-.707a1.461 1.461 0 0 1 1.01-2.372"
  })));
};
var CrownFilled12 = (/* unused pure expression or super */ null && (SvgCrownFilled12));

var _path$81;
function _extends$88() { _extends$88 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$88.apply(this, arguments); }
var SvgCrownFilled16 = function SvgCrownFilled16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$88({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path$81 || (_path$81 = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M2.667 13.089c0-.234.198-.422.442-.422h9.782c.244 0 .442.188.442.422v.708c0 .48-.408.87-.912.87H3.58c-.504 0-.912-.39-.912-.87zm11.26-11.302A1.935 1.935 0 0 1 16 3.725c0 .87-.569 1.609-1.35 1.856l-1.395 5.996a.48.48 0 0 1-.473.423H3.24a.48.48 0 0 1-.472-.421l-1.41-5.996A1.945 1.945 0 0 1 0 3.725c0-1.121.945-2.024 2.073-1.939a1.95 1.95 0 0 1 1.308 3.21l2.198.896L7.04 4.98a1.95 1.95 0 0 1-.996-1.703c0-1.12.945-2.024 2.073-1.938a1.94 1.94 0 0 1 1.77 1.778A1.95 1.95 0 0 1 8.85 5.006l1.42.886 2.313-.942a1.95 1.95 0 0 1-.428-1.35 1.94 1.94 0 0 1 1.774-1.813"
  })));
};
var CrownFilled16 = (/* unused pure expression or super */ null && (SvgCrownFilled16));

var _path$80;
function _extends$87() { _extends$87 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$87.apply(this, arguments); }
var SvgCrownFilled18 = function SvgCrownFilled18(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$87({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _path$80 || (_path$80 = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M3 14.725c0-.262.223-.475.498-.475h11.004c.275 0 .498.213.498.475v.797c0 .54-.46.978-1.026.978H4.026C3.459 16.5 3 16.063 3 15.522zM15.669 2.01C16.937 1.914 18 2.93 18 4.19c0 .98-.64 1.81-1.52 2.089l-1.568 6.746a.54.54 0 0 1-.532.475H3.644a.54.54 0 0 1-.532-.474L1.527 6.281A2.19 2.19 0 0 1 0 4.191C0 2.93 1.063 1.914 2.332 2.01a2.18 2.18 0 0 1 1.991 1.993 2.2 2.2 0 0 1-.52 1.617l2.473 1.008 1.646-1.026A2.19 2.19 0 0 1 6.8 3.687c0-1.261 1.063-2.277 2.332-2.18a2.18 2.18 0 0 1 1.992 2 2.19 2.19 0 0 1-1.17 2.125l1.598.996 2.601-1.06a2.2 2.2 0 0 1-.48-1.518 2.18 2.18 0 0 1 1.995-2.04"
  })));
};
var CrownFilled18 = (/* unused pure expression or super */ null && (SvgCrownFilled18));

var _path$7$;
function _extends$86() { _extends$86 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$86.apply(this, arguments); }
var SvgCrownFilled24 = function SvgCrownFilled24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$86({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path$7$ || (_path$7$ = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M4.667 19.163c0-.32.272-.58.608-.58h13.45c.336 0 .608.26.608.58v.975c0 .66-.56 1.195-1.254 1.195H5.921c-.693 0-1.254-.534-1.254-1.195zM20.15 3.623C21.7 3.508 23 4.748 23 6.29a2.675 2.675 0 0 1-1.857 2.551l-1.917 8.246a.657.657 0 0 1-.65.58H5.454a.66.66 0 0 1-.65-.579L2.866 8.843A2.675 2.675 0 0 1 1 6.29c0-1.542 1.3-2.783 2.85-2.666 1.285.097 2.326 1.139 2.434 2.436a2.68 2.68 0 0 1-.636 1.977L8.67 9.268l2.011-1.254a2.68 2.68 0 0 1-1.37-2.34c0-1.543 1.3-2.784 2.85-2.666 1.288.098 2.331 1.144 2.435 2.445a2.68 2.68 0 0 1-1.43 2.597l1.954 1.218 3.178-1.296a2.68 2.68 0 0 1-.587-1.856c.082-1.32 1.132-2.394 2.439-2.492"
  })));
};
var CrownFilled24 = (/* unused pure expression or super */ null && (SvgCrownFilled24));

var _path$7_;
function _extends$85() { _extends$85 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$85.apply(this, arguments); }
var SvgCrownFilled32 = function SvgCrownFilled32(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$85({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _path$7_ || (_path$7_ = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M6.222 25.551c0-.427.364-.773.812-.773h17.932c.448 0 .812.346.812.773v1.3c0 .88-.748 1.594-1.672 1.594H7.894c-.923 0-1.672-.714-1.672-1.594zm20.645-20.72c2.067-.156 3.8 1.499 3.8 3.554a3.57 3.57 0 0 1-2.477 3.402l-2.556 10.994a.876.876 0 0 1-.866.775H7.272a.876.876 0 0 1-.867-.773L3.821 11.791a3.57 3.57 0 0 1-2.488-3.406c0-2.055 1.732-3.71 3.8-3.554 1.714.13 3.101 1.518 3.246 3.247a3.57 3.57 0 0 1-.849 2.636l4.031 1.643 2.682-1.672a3.57 3.57 0 0 1-1.827-3.12c0-2.057 1.732-3.711 3.8-3.555 1.718.13 3.108 1.526 3.246 3.26a3.57 3.57 0 0 1-1.905 3.463l2.604 1.624L24.4 10.63a3.57 3.57 0 0 1-.783-2.475c.11-1.76 1.51-3.192 3.251-3.324"
  })));
};
var CrownFilled32 = (/* unused pure expression or super */ null && (SvgCrownFilled32));

var _path$7Z;
function _extends$84() { _extends$84 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$84.apply(this, arguments); }
var SvgCrownFilled48 = function SvgCrownFilled48(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$84({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none"
  }, props), _path$7Z || (_path$7Z = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M8.667 39.796c0-.67.57-1.213 1.272-1.213h28.122c.702 0 1.272.544 1.272 1.213v2.039c0 1.38-1.173 2.498-2.622 2.498H11.29c-1.449 0-2.622-1.118-2.622-2.498zM41.042 7.304C44.284 7.059 47 9.654 47 12.876a5.59 5.59 0 0 1-3.883 5.336l-4.008 17.24a1.374 1.374 0 0 1-1.36 1.215H10.313a1.374 1.374 0 0 1-1.36-1.212L4.903 18.218A5.59 5.59 0 0 1 1 12.877c0-3.224 2.716-5.819 5.959-5.574 2.687.203 4.863 2.38 5.09 5.093a5.6 5.6 0 0 1-1.331 4.133l6.321 2.576 4.205-2.622a5.6 5.6 0 0 1-2.865-4.894c0-3.223 2.717-5.819 5.96-5.573 2.694.205 4.874 2.393 5.09 5.113a5.6 5.6 0 0 1-2.988 5.43l4.085 2.546 6.646-2.708a5.6 5.6 0 0 1-1.229-3.88c.173-2.762 2.367-5.007 5.1-5.213"
  })));
};
var CrownFilled48 = (/* unused pure expression or super */ null && (SvgCrownFilled48));

var CrownFilledIcon = function CrownFilledIcon(props) {
  var crownFilled = {
    12: CrownFilled12,
    16: CrownFilled16,
    18: CrownFilled18,
    24: CrownFilled24,
    32: CrownFilled32,
    48: CrownFilled48
  };
  return jsx(IconTemplate, _assign({
    icons: crownFilled
  }, props));
};

var _path$7Y, _path2$2U;
function _extends$83() { _extends$83 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$83.apply(this, arguments); }
var SvgDataList12 = function SvgDataList12(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$83({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none"
  }, props), _path$7Y || (_path$7Y = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M9 2.2H3a.3.3 0 0 0-.3.3v7a.3.3 0 0 0 .3.3h3.5A2.8 2.8 0 0 0 9.3 7V2.5a.3.3 0 0 0-.3-.3M3 1a1.5 1.5 0 0 0-1.5 1.5v7A1.5 1.5 0 0 0 3 11h3.5a4 4 0 0 0 4-4V2.5A1.5 1.5 0 0 0 9 1z",
    clipRule: "evenodd"
  })), _path2$2U || (_path2$2U = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M4 4.4a.6.6 0 0 1 .6-.6h2.8a.6.6 0 0 1 0 1.2H4.6a.6.6 0 0 1-.6-.6M4 6.9a.6.6 0 0 1 .6-.6h1.8a.6.6 0 0 1 0 1.2H4.6a.6.6 0 0 1-.6-.6",
    clipRule: "evenodd"
  })));
};
var DataList12 = (/* unused pure expression or super */ null && (SvgDataList12));

var _path$7X, _path2$2T;
function _extends$82() { _extends$82 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$82.apply(this, arguments); }
var SvgDataList16 = function SvgDataList16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$82({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path$7X || (_path$7X = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M12 2.833H4a.5.5 0 0 0-.5.5v9.334a.5.5 0 0 0 .5.5h4.667A3.833 3.833 0 0 0 12.5 9.333v-6a.5.5 0 0 0-.5-.5m-8-1.5a2 2 0 0 0-2 2v9.334a2 2 0 0 0 2 2h4.667A5.333 5.333 0 0 0 14 9.333v-6a2 2 0 0 0-2-2z",
    clipRule: "evenodd"
  })), _path2$2T || (_path2$2T = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M5.333 6.25a.75.75 0 0 1 .75-.75h3.834a.75.75 0 1 1 0 1.5H6.083a.75.75 0 0 1-.75-.75M5.333 9.75a.75.75 0 0 1 .75-.75h2.5a.75.75 0 1 1 0 1.5h-2.5a.75.75 0 0 1-.75-.75",
    clipRule: "evenodd"
  })));
};
var DataList16 = (/* unused pure expression or super */ null && (SvgDataList16));

var _path$7W, _path2$2S;
function _extends$81() { _extends$81 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$81.apply(this, arguments); }
var SvgDataList18 = function SvgDataList18(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$81({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _path$7W || (_path$7W = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M13.5 3.1h-9a.65.65 0 0 0-.65.65v10.5c0 .359.291.65.65.65h5.25a4.4 4.4 0 0 0 4.4-4.4V3.75a.65.65 0 0 0-.65-.65m-9-1.6a2.25 2.25 0 0 0-2.25 2.25v10.5A2.25 2.25 0 0 0 4.5 16.5h5.25a6 6 0 0 0 6-6V3.75A2.25 2.25 0 0 0 13.5 1.5z",
    clipRule: "evenodd"
  })), _path2$2S || (_path2$2S = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M6 5.8a.8.8 0 0 1 .8-.8h4.4a.8.8 0 0 1 0 1.6H6.8a.8.8 0 0 1-.8-.8M6 8.8a.8.8 0 0 1 .8-.8h4.4a.8.8 0 0 1 0 1.6H6.8a.8.8 0 0 1-.8-.8M6 11.8a.8.8 0 0 1 .8-.8h2.9a.8.8 0 0 1 0 1.6H6.8a.8.8 0 0 1-.8-.8",
    clipRule: "evenodd"
  })));
};
var DataList18 = (/* unused pure expression or super */ null && (SvgDataList18));

var _path$7V, _path2$2R;
function _extends$80() { _extends$80 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$80.apply(this, arguments); }
var SvgDataList24 = function SvgDataList24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$80({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path$7V || (_path$7V = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M18 3.8H6A1.2 1.2 0 0 0 4.8 5v14A1.2 1.2 0 0 0 6 20.2h7a6.2 6.2 0 0 0 6.2-6.2V5A1.2 1.2 0 0 0 18 3.8M6 2a3 3 0 0 0-3 3v14a3 3 0 0 0 3 3h7a8 8 0 0 0 8-8V5a3 3 0 0 0-3-3z",
    clipRule: "evenodd"
  })), _path2$2R || (_path2$2R = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M8 7.6a.9.9 0 0 1 .9-.9h6.2a.9.9 0 1 1 0 1.8H8.9a.9.9 0 0 1-.9-.9M8 11.6a.9.9 0 0 1 .9-.9h6.2a.9.9 0 1 1 0 1.8H8.9a.9.9 0 0 1-.9-.9M8 15.6a.9.9 0 0 1 .9-.9h4.2a.9.9 0 1 1 0 1.8H8.9a.9.9 0 0 1-.9-.9",
    clipRule: "evenodd"
  })));
};
var DataList24 = (/* unused pure expression or super */ null && (SvgDataList24));

var _path$7U, _path2$2Q;
function _extends$7$() { _extends$7$ = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$7$.apply(this, arguments); }
var SvgDataList32 = function SvgDataList32(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$7$({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _path$7U || (_path$7U = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M24 4.667H8a2 2 0 0 0-2 2v18.666a2 2 0 0 0 2 2h9.333A8.667 8.667 0 0 0 26 18.667v-12a2 2 0 0 0-2-2m-16-2a4 4 0 0 0-4 4v18.666a4 4 0 0 0 4 4h9.333C23.224 29.333 28 24.558 28 18.667v-12a4 4 0 0 0-4-4z",
    clipRule: "evenodd"
  })), _path2$2Q || (_path2$2Q = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M10.667 10.333a1 1 0 0 1 1-1h8.666a1 1 0 1 1 0 2h-8.666a1 1 0 0 1-1-1M10.667 15.667a1 1 0 0 1 1-1h8.666a1 1 0 0 1 0 2h-8.666a1 1 0 0 1-1-1M10.667 21a1 1 0 0 1 1-1h6a1 1 0 1 1 0 2h-6a1 1 0 0 1-1-1",
    clipRule: "evenodd"
  })));
};
var DataList32 = (/* unused pure expression or super */ null && (SvgDataList32));

var _path$7T, _path2$2P;
function _extends$7_() { _extends$7_ = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$7_.apply(this, arguments); }
var SvgDataList48 = function SvgDataList48(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$7_({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none"
  }, props), _path$7T || (_path$7T = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M36 6.4H12A3.6 3.6 0 0 0 8.4 10v28a3.6 3.6 0 0 0 3.6 3.6h14c7.511 0 13.6-6.089 13.6-13.6V10A3.6 3.6 0 0 0 36 6.4M12 4a6 6 0 0 0-6 6v28a6 6 0 0 0 6 6h14c8.837 0 16-7.163 16-16V10a6 6 0 0 0-6-6z",
    clipRule: "evenodd"
  })), _path2$2P || (_path2$2P = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M16 15.8a1.2 1.2 0 0 1 1.2-1.2h13.6a1.2 1.2 0 0 1 0 2.4H17.2a1.2 1.2 0 0 1-1.2-1.2M16 23.8a1.2 1.2 0 0 1 1.2-1.2h13.6a1.2 1.2 0 0 1 0 2.4H17.2a1.2 1.2 0 0 1-1.2-1.2M16 31.8a1.2 1.2 0 0 1 1.2-1.2h9.6a1.2 1.2 0 0 1 0 2.4h-9.6a1.2 1.2 0 0 1-1.2-1.2",
    clipRule: "evenodd"
  })));
};
var DataList48 = (/* unused pure expression or super */ null && (SvgDataList48));

var DataListIcon = function DataListIcon(props) {
  var dataList = {
    12: DataList12,
    16: DataList16,
    18: DataList18,
    24: DataList24,
    32: DataList32,
    48: DataList48
  };
  return jsx(IconTemplate, _assign({
    icons: dataList
  }, props));
};

var _path$7S;
function _extends$7Z() { _extends$7Z = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$7Z.apply(this, arguments); }
var SvgDataListFilled12 = function SvgDataListFilled12(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$7Z({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none"
  }, props), _path$7S || (_path$7S = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M1.5 2a1 1 0 0 1 1-1h7a1 1 0 0 1 1 1v5a4 4 0 0 1-4 4h-4a1 1 0 0 1-1-1zM4 4.4a.6.6 0 0 1 .6-.6h2.8a.6.6 0 0 1 0 1.2H4.6a.6.6 0 0 1-.6-.6m.6 2a.6.6 0 0 0 0 1.2h1.8a.6.6 0 0 0 0-1.2z",
    clipRule: "evenodd"
  })));
};
var DataListFilled12 = (/* unused pure expression or super */ null && (SvgDataListFilled12));

var _path$7R;
function _extends$7Y() { _extends$7Y = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$7Y.apply(this, arguments); }
var SvgDataListFilled16 = function SvgDataListFilled16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$7Y({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path$7R || (_path$7R = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M2 2.667c0-.737.597-1.334 1.333-1.334h9.334c.736 0 1.333.597 1.333 1.334v6.666a5.333 5.333 0 0 1-5.333 5.334H3.333A1.333 1.333 0 0 1 2 13.333zM5.334 6.25a.75.75 0 0 1 .75-.75h3.833a.75.75 0 0 1 0 1.5H6.084a.75.75 0 0 1-.75-.75m.75 2.85a.75.75 0 1 0 0 1.5h2.5a.75.75 0 0 0 0-1.5z",
    clipRule: "evenodd"
  })));
};
var DataListFilled16 = (/* unused pure expression or super */ null && (SvgDataListFilled16));

var _path$7Q;
function _extends$7X() { _extends$7X = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$7X.apply(this, arguments); }
var SvgDataListFilled18 = function SvgDataListFilled18(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$7X({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _path$7Q || (_path$7Q = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M4 1.5a1.75 1.75 0 0 0-1.75 1.75v11.5c0 .966.784 1.75 1.75 1.75h5.75a6 6 0 0 0 6-6V3.25A1.75 1.75 0 0 0 14 1.5zm2.7 3.475a.7.7 0 1 0 0 1.4h4.6a.7.7 0 1 0 0-1.4zm-.7 3.7a.7.7 0 0 1 .7-.7h4.6a.7.7 0 1 1 0 1.4H6.7a.7.7 0 0 1-.7-.7m.7 2.3a.7.7 0 1 0 0 1.4h3.1a.7.7 0 1 0 0-1.4z",
    clipRule: "evenodd"
  })));
};
var DataListFilled18 = (/* unused pure expression or super */ null && (SvgDataListFilled18));

var _path$7P;
function _extends$7W() { _extends$7W = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$7W.apply(this, arguments); }
var SvgDataListFilled24 = function SvgDataListFilled24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$7W({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path$7P || (_path$7P = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M5 2a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h8a8 8 0 0 0 8-8V4a2 2 0 0 0-2-2zm3.9 4.7a.9.9 0 1 0 0 1.8h6.2a.9.9 0 1 0 0-1.8zM8 11.6a.9.9 0 0 1 .9-.9h6.2a.9.9 0 1 1 0 1.8H8.9a.9.9 0 0 1-.9-.9m.9 3.1a.9.9 0 1 0 0 1.8h4.2a.9.9 0 1 0 0-1.8z",
    clipRule: "evenodd"
  })));
};
var DataListFilled24 = (/* unused pure expression or super */ null && (SvgDataListFilled24));

var _path$7O;
function _extends$7V() { _extends$7V = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$7V.apply(this, arguments); }
var SvgDataListFilled32 = function SvgDataListFilled32(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$7V({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _path$7O || (_path$7O = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M6.667 2.667A2.667 2.667 0 0 0 4 5.333v21.334a2.667 2.667 0 0 0 2.667 2.666h10.666C23.224 29.333 28 24.558 28 18.667V5.333a2.667 2.667 0 0 0-2.667-2.666zm5 6.666a1 1 0 1 0 0 2h8.666a1 1 0 1 0 0-2zm-1 6.334a1 1 0 0 1 1-1h8.666a1 1 0 0 1 0 2h-8.666a1 1 0 0 1-1-1m1 4.333a1 1 0 1 0 0 2h6a1 1 0 1 0 0-2z",
    clipRule: "evenodd"
  })));
};
var DataListFilled32 = (/* unused pure expression or super */ null && (SvgDataListFilled32));

var _path$7N;
function _extends$7U() { _extends$7U = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$7U.apply(this, arguments); }
var SvgDataListFilled48 = function SvgDataListFilled48(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$7U({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none"
  }, props), _path$7N || (_path$7N = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M10 4a4 4 0 0 0-4 4v32a4 4 0 0 0 4 4h16c8.837 0 16-7.163 16-16V8a4 4 0 0 0-4-4zm7.2 10.6a1.2 1.2 0 0 0 0 2.4h13.6a1.2 1.2 0 0 0 0-2.4zM16 23.8a1.2 1.2 0 0 1 1.2-1.2h13.6a1.2 1.2 0 0 1 0 2.4H17.2a1.2 1.2 0 0 1-1.2-1.2m1.2 6.8a1.2 1.2 0 0 0 0 2.4h9.6a1.2 1.2 0 0 0 0-2.4z",
    clipRule: "evenodd"
  })));
};
var DataListFilled48 = (/* unused pure expression or super */ null && (SvgDataListFilled48));

var DataListFilledIcon = function DataListFilledIcon(props) {
  var dataListFilled = {
    12: DataListFilled12,
    16: DataListFilled16,
    18: DataListFilled18,
    24: DataListFilled24,
    32: DataListFilled32,
    48: DataListFilled48
  };
  return jsx(IconTemplate, _assign({
    icons: dataListFilled
  }, props));
};

var _path$7M, _path2$2O;
function _extends$7T() { _extends$7T = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$7T.apply(this, arguments); }
var SvgDelete12 = function SvgDelete12(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$7T({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none"
  }, props), _path$7M || (_path$7M = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M4.5.9a.6.6 0 1 0 0 1.2h3a.6.6 0 0 0 0-1.2z"
  })), _path2$2O || (_path2$2O = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M.9 3.5a.6.6 0 0 1 .6-.6h9a.6.6 0 1 1 0 1.2H10v5.4A1.5 1.5 0 0 1 8.5 11h-5A1.5 1.5 0 0 1 2 9.5V4.1h-.5a.6.6 0 0 1-.6-.6m2.3.6h5.6v5.4a.3.3 0 0 1-.3.3h-5a.3.3 0 0 1-.3-.3z",
    clipRule: "evenodd"
  })));
};
var Delete12 = (/* unused pure expression or super */ null && (SvgDelete12));

var _path$7L, _path2$2N;
function _extends$7S() { _extends$7S = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$7S.apply(this, arguments); }
var SvgDelete16 = function SvgDelete16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$7S({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path$7L || (_path$7L = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M6 1.25a.75.75 0 0 0 0 1.5h4a.75.75 0 0 0 0-1.5zM6.333 6.361a.75.75 0 0 1 .75.75v4a.75.75 0 0 1-1.5 0v-4a.75.75 0 0 1 .75-.75M10.417 7.111a.75.75 0 1 0-1.5 0v4a.75.75 0 0 0 1.5 0z"
  })), _path2$2N || (_path2$2N = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M1.25 4.333a.75.75 0 0 1 .75-.75h12a.75.75 0 0 1 0 1.5h-.667v7.584a2 2 0 0 1-2 2H4.667a2 2 0 0 1-2-2V5.083H2a.75.75 0 0 1-.75-.75m10.583.9H4.167v7.434a.5.5 0 0 0 .5.5h6.666a.5.5 0 0 0 .5-.5z",
    clipRule: "evenodd"
  })));
};
var Delete16 = (/* unused pure expression or super */ null && (SvgDelete16));

var _path$7K, _path2$2M;
function _extends$7R() { _extends$7R = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$7R.apply(this, arguments); }
var SvgDelete18 = function SvgDelete18(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$7R({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _path$7K || (_path$7K = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M6.75 1.45a.8.8 0 1 0 0 1.6h4.5a.8.8 0 0 0 0-1.6zM7.125 7.2a.8.8 0 0 1 .8.8v4.5a.8.8 0 0 1-1.6 0V8a.8.8 0 0 1 .8-.8M11.675 8a.8.8 0 0 0-1.6 0v4.5a.8.8 0 1 0 1.6 0z"
  })), _path2$2M || (_path2$2M = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M1.45 4.875a.8.8 0 0 1 .8-.8h13.5a.8.8 0 0 1 0 1.6H15v8.575a2.25 2.25 0 0 1-2.25 2.25h-7.5A2.25 2.25 0 0 1 3 14.25V5.675h-.75a.8.8 0 0 1-.8-.8M13.4 5.8H4.6v8.45c0 .359.291.65.65.65h7.5a.65.65 0 0 0 .65-.65z",
    clipRule: "evenodd"
  })));
};
var Delete18 = (/* unused pure expression or super */ null && (SvgDelete18));

var _path$7J, _path2$2L;
function _extends$7Q() { _extends$7Q = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$7Q.apply(this, arguments); }
var SvgDelete24 = function SvgDelete24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$7Q({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path$7J || (_path$7J = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M9 2.1a.9.9 0 1 0 0 1.8h6a.9.9 0 1 0 0-1.8zM9.5 9.1a.9.9 0 0 1 .9.9v7.5a.9.9 0 1 1-1.8 0V10a.9.9 0 0 1 .9-.9M15.4 10a.9.9 0 1 0-1.8 0v7.5a.9.9 0 1 0 1.8 0z"
  })), _path2$2L || (_path2$2L = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M2.1 6.5a.9.9 0 0 1 .9-.9h18a.9.9 0 1 1 0 1.8h-1V19a3 3 0 0 1-3 3H7a3 3 0 0 1-3-3V7.4H3a.9.9 0 0 1-.9-.9m3.7.9h12.4V19a1.2 1.2 0 0 1-1.2 1.2H7A1.2 1.2 0 0 1 5.8 19z",
    clipRule: "evenodd"
  })));
};
var Delete24 = (/* unused pure expression or super */ null && (SvgDelete24));

var _path$7I, _path2$2K;
function _extends$7P() { _extends$7P = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$7P.apply(this, arguments); }
var SvgDelete32 = function SvgDelete32(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$7P({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _path$7I || (_path$7I = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M12 3a1 1 0 1 0 0 2h8a1 1 0 1 0 0-2zM12.667 12.333a1 1 0 0 1 1 1v10a1 1 0 1 1-2 0v-10a1 1 0 0 1 1-1M20.333 13.333a1 1 0 0 0-2 0v10a1 1 0 1 0 2 0z"
  })), _path2$2K || (_path2$2K = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M3 8.5a1 1 0 0 1 1-1h24a1 1 0 1 1 0 2h-1.333v15.833a4 4 0 0 1-4 4H9.333a4 4 0 0 1-4-4V9.5H4a1 1 0 0 1-1-1m4.333 1h17.334v15.833a2 2 0 0 1-2 2H9.333a2 2 0 0 1-2-2z",
    clipRule: "evenodd"
  })));
};
var Delete32 = (/* unused pure expression or super */ null && (SvgDelete32));

var _path$7H, _path2$2J;
function _extends$7O() { _extends$7O = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$7O.apply(this, arguments); }
var SvgDelete48 = function SvgDelete48(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$7O({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none"
  }, props), _path$7H || (_path$7H = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M18 4.8a1.2 1.2 0 0 0 0 2.4h12a1.2 1.2 0 1 0 0-2.4zM19 18.8a1.2 1.2 0 0 1 1.2 1.2v15a1.2 1.2 0 1 1-2.4 0V20a1.2 1.2 0 0 1 1.2-1.2M30.2 20a1.2 1.2 0 1 0-2.4 0v15a1.2 1.2 0 1 0 2.4 0z"
  })), _path2$2J || (_path2$2J = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M4.8 12A1.2 1.2 0 0 1 6 10.8h36a1.2 1.2 0 1 1 0 2.4h-2V38a6 6 0 0 1-6 6H14a6 6 0 0 1-6-6V13.2H6A1.2 1.2 0 0 1 4.8 12m32.8 1.3H10.4V38a3.6 3.6 0 0 0 3.6 3.6h20a3.6 3.6 0 0 0 3.6-3.6z",
    clipRule: "evenodd"
  })));
};
var Delete48 = (/* unused pure expression or super */ null && (SvgDelete48));

var DeleteIcon = function DeleteIcon(props) {
  var deleteIcon = {
    12: Delete12,
    16: Delete16,
    18: Delete18,
    24: Delete24,
    32: Delete32,
    48: Delete48
  };
  return jsx(IconTemplate, _assign({
    icons: deleteIcon
  }, props));
};

var _path$7G;
function _extends$7N() { _extends$7N = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$7N.apply(this, arguments); }
var SvgDeleteFilled12 = function SvgDeleteFilled12(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$7N({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none"
  }, props), _path$7G || (_path$7G = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M4.5.9a.6.6 0 1 0 0 1.2h3a.6.6 0 0 0 0-1.2zM.9 3.5a.6.6 0 0 1 .6-.6h9a.6.6 0 1 1 0 1.2H10v5.4A1.5 1.5 0 0 1 8.5 11h-5A1.5 1.5 0 0 1 2 9.5V4.1h-.5a.6.6 0 0 1-.6-.6"
  })));
};
var DeleteFilled12 = (/* unused pure expression or super */ null && (SvgDeleteFilled12));

var _path$7F, _path2$2I;
function _extends$7M() { _extends$7M = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$7M.apply(this, arguments); }
var SvgDeleteFilled16 = function SvgDeleteFilled16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$7M({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path$7F || (_path$7F = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M5.25 2A.75.75 0 0 1 6 1.25h4a.75.75 0 0 1 0 1.5H6A.75.75 0 0 1 5.25 2"
  })), _path2$2I || (_path2$2I = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M1.25 4.333a.75.75 0 0 1 .75-.75h12a.75.75 0 0 1 0 1.5h-.667v7.584a2 2 0 0 1-2 2H4.667a2 2 0 0 1-2-2V5.083H2a.75.75 0 0 1-.75-.75m5.833 2.778a.75.75 0 1 0-1.5 0v4a.75.75 0 0 0 1.5 0zm2.584-.75a.75.75 0 0 1 .75.75v4a.75.75 0 1 1-1.5 0v-4a.75.75 0 0 1 .75-.75",
    clipRule: "evenodd"
  })));
};
var DeleteFilled16 = (/* unused pure expression or super */ null && (SvgDeleteFilled16));

var _path$7E, _path2$2H;
function _extends$7L() { _extends$7L = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$7L.apply(this, arguments); }
var SvgDeleteFilled18 = function SvgDeleteFilled18(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$7L({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _path$7E || (_path$7E = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M5.95 2.25a.8.8 0 0 1 .8-.8h4.5a.8.8 0 0 1 0 1.6h-4.5a.8.8 0 0 1-.8-.8"
  })), _path2$2H || (_path2$2H = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M1.45 4.875a.8.8 0 0 1 .8-.8h13.5a.8.8 0 0 1 0 1.6H15v8.575a2.25 2.25 0 0 1-2.25 2.25h-7.5A2.25 2.25 0 0 1 3 14.25V5.675h-.75a.8.8 0 0 1-.8-.8M7.925 8a.8.8 0 0 0-1.6 0v4.5a.8.8 0 0 0 1.6 0zm2.95-.8a.8.8 0 0 1 .8.8v4.5a.8.8 0 0 1-1.6 0V8a.8.8 0 0 1 .8-.8",
    clipRule: "evenodd"
  })));
};
var DeleteFilled18 = (/* unused pure expression or super */ null && (SvgDeleteFilled18));

var _path$7D, _path2$2G;
function _extends$7K() { _extends$7K = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$7K.apply(this, arguments); }
var SvgDeleteFilled24 = function SvgDeleteFilled24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$7K({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path$7D || (_path$7D = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M9 2.1a.9.9 0 1 0 0 1.8h6a.9.9 0 1 0 0-1.8z"
  })), _path2$2G || (_path2$2G = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M2.1 6.5a.9.9 0 0 1 .9-.9h18a.9.9 0 1 1 0 1.8h-1V19a3 3 0 0 1-3 3H7a3 3 0 0 1-3-3V7.4H3a.9.9 0 0 1-.9-.9m7.4 2.6a.9.9 0 0 1 .9.9v7.5a.9.9 0 1 1-1.8 0V10a.9.9 0 0 1 .9-.9m5.9.9a.9.9 0 1 0-1.8 0v7.5a.9.9 0 1 0 1.8 0z",
    clipRule: "evenodd"
  })));
};
var DeleteFilled24 = (/* unused pure expression or super */ null && (SvgDeleteFilled24));

var _path$7C, _path2$2F;
function _extends$7J() { _extends$7J = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$7J.apply(this, arguments); }
var SvgDeleteFilled32 = function SvgDeleteFilled32(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$7J({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _path$7C || (_path$7C = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M12 3a1 1 0 1 0 0 2h8a1 1 0 1 0 0-2z"
  })), _path2$2F || (_path2$2F = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M3 8.5a1 1 0 0 1 1-1h24a1 1 0 1 1 0 2h-1.333v15.833a4 4 0 0 1-4 4H9.333a4 4 0 0 1-4-4V9.5H4a1 1 0 0 1-1-1m9.667 3.833a1 1 0 0 1 1 1v10a1 1 0 1 1-2 0v-10a1 1 0 0 1 1-1m7.666 1a1 1 0 0 0-2 0v10a1 1 0 1 0 2 0z",
    clipRule: "evenodd"
  })));
};
var DeleteFilled32 = (/* unused pure expression or super */ null && (SvgDeleteFilled32));

var _path$7B, _path2$2E;
function _extends$7I() { _extends$7I = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$7I.apply(this, arguments); }
var SvgDeleteFilled48 = function SvgDeleteFilled48(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$7I({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none"
  }, props), _path$7B || (_path$7B = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M18 4.8a1.2 1.2 0 0 0 0 2.4h12a1.2 1.2 0 0 0 0-2.4z"
  })), _path2$2E || (_path2$2E = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M4.8 12A1.2 1.2 0 0 1 6 10.8h36a1.2 1.2 0 0 1 0 2.4h-2V38a6 6 0 0 1-6 6H14a6 6 0 0 1-6-6V13.2H6A1.2 1.2 0 0 1 4.8 12M19 18.8a1.2 1.2 0 0 1 1.2 1.2v15a1.2 1.2 0 1 1-2.4 0V20a1.2 1.2 0 0 1 1.2-1.2M30.2 20a1.2 1.2 0 0 0-2.4 0v15a1.2 1.2 0 1 0 2.4 0z",
    clipRule: "evenodd"
  })));
};
var DeleteFilled48 = (/* unused pure expression or super */ null && (SvgDeleteFilled48));

var DeleteFilledIcon = function DeleteFilledIcon(props) {
  var deleteFilled = {
    12: DeleteFilled12,
    16: DeleteFilled16,
    18: DeleteFilled18,
    24: DeleteFilled24,
    32: DeleteFilled32,
    48: DeleteFilled48
  };
  return jsx(IconTemplate, _assign({
    icons: deleteFilled
  }, props));
};

var _g$6, _defs$6;
function _extends$7H() { _extends$7H = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$7H.apply(this, arguments); }
var SvgDismiss12 = function SvgDismiss12(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends$7H({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none"
  }, props), _g$6 || (_g$6 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("g", {
    fill: "#2F3438",
    fillRule: "evenodd",
    clipPath: "url(#dismiss_12_svg__a)",
    clipRule: "evenodd"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M1.076 1.076a.6.6 0 0 1 .848 0l9 9a.6.6 0 0 1-.848.848l-9-9a.6.6 0 0 1 0-.848"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M10.924 1.076a.6.6 0 0 0-.848 0l-9 9a.6.6 0 0 0 .848.848l9-9a.6.6 0 0 0 0-.848"
  }))), _defs$6 || (_defs$6 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("defs", null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("clipPath", {
    id: "dismiss_12_svg__a"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: "#fff",
    d: "M0 0h12v12H0z"
  })))));
};
var Dismiss12 = SvgDismiss12;

var _path$7A, _path2$2D;
function _extends$7G() { _extends$7G = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$7G.apply(this, arguments); }
var SvgDismiss16 = function SvgDismiss16(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends$7G({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path$7A || (_path$7A = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M1.47 1.47a.75.75 0 0 1 1.06 0l12 12a.75.75 0 1 1-1.06 1.06l-12-12a.75.75 0 0 1 0-1.06",
    clipRule: "evenodd"
  })), _path2$2D || (_path2$2D = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M14.53 1.47a.75.75 0 0 0-1.06 0l-12 12a.75.75 0 1 0 1.06 1.06l12-12a.75.75 0 0 0 0-1.06",
    clipRule: "evenodd"
  })));
};
var Dismiss16 = SvgDismiss16;

var _path$7z, _path2$2C;
function _extends$7F() { _extends$7F = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$7F.apply(this, arguments); }
var SvgDismiss18 = function SvgDismiss18(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends$7F({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _path$7z || (_path$7z = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M1.684 1.684a.8.8 0 0 1 1.132 0l13.5 13.5a.8.8 0 1 1-1.132 1.132l-13.5-13.5a.8.8 0 0 1 0-1.132",
    clipRule: "evenodd"
  })), _path2$2C || (_path2$2C = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M16.316 1.684a.8.8 0 0 0-1.132 0l-13.5 13.5a.8.8 0 1 0 1.132 1.132l13.5-13.5a.8.8 0 0 0 0-1.132",
    clipRule: "evenodd"
  })));
};
var Dismiss18 = SvgDismiss18;

var _path$7y, _path2$2B;
function _extends$7E() { _extends$7E = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$7E.apply(this, arguments); }
var SvgDismiss24 = function SvgDismiss24(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends$7E({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path$7y || (_path$7y = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M2.364 2.364a.9.9 0 0 1 1.272 0l18 18a.9.9 0 1 1-1.272 1.273l-18-18a.9.9 0 0 1 0-1.273",
    clipRule: "evenodd"
  })), _path2$2B || (_path2$2B = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M21.637 2.364a.9.9 0 0 0-1.273 0l-18 18a.9.9 0 0 0 1.272 1.273l18-18a.9.9 0 0 0 0-1.273",
    clipRule: "evenodd"
  })));
};
var Dismiss24 = SvgDismiss24;

var _path$7x, _path2$2A;
function _extends$7D() { _extends$7D = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$7D.apply(this, arguments); }
var SvgDismiss32 = function SvgDismiss32(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends$7D({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _path$7x || (_path$7x = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M3.293 3.293a1 1 0 0 1 1.414 0l24 24a1 1 0 0 1-1.414 1.414l-24-24a1 1 0 0 1 0-1.414",
    clipRule: "evenodd"
  })), _path2$2A || (_path2$2A = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M28.707 3.293a1 1 0 0 0-1.414 0l-24 24a1 1 0 1 0 1.414 1.414l24-24a1 1 0 0 0 0-1.414",
    clipRule: "evenodd"
  })));
};
var Dismiss32 = SvgDismiss32;

var _path$7w, _path2$2z;
function _extends$7C() { _extends$7C = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$7C.apply(this, arguments); }
var SvgDismiss48 = function SvgDismiss48(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends$7C({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none"
  }, props), _path$7w || (_path$7w = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M5.152 5.152a1.2 1.2 0 0 1 1.697 0l36 36a1.2 1.2 0 0 1-1.697 1.697l-36-36a1.2 1.2 0 0 1 0-1.697",
    clipRule: "evenodd"
  })), _path2$2z || (_path2$2z = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M42.849 5.152a1.2 1.2 0 0 0-1.697 0l-36 36a1.2 1.2 0 0 0 1.697 1.697l36-36a1.2 1.2 0 0 0 0-1.697",
    clipRule: "evenodd"
  })));
};
var Dismiss48 = SvgDismiss48;

var DismissIcon = function DismissIcon(props) {
  var dismiss = {
    12: Dismiss12,
    16: Dismiss16,
    18: Dismiss18,
    24: Dismiss24,
    32: Dismiss32,
    48: Dismiss48
  };
  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(IconTemplate, (0,_common_js__WEBPACK_IMPORTED_MODULE_2__.a)({
    icons: dismiss
  }, props));
};

var _path$7v;
function _extends$7B() { _extends$7B = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$7B.apply(this, arguments); }
var SvgDismissCircle12 = function SvgDismissCircle12(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends$7B({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none"
  }, props), _path$7v || (_path$7v = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M6 1a5 5 0 1 0 0 10A5 5 0 0 0 6 1M4.674 3.826a.6.6 0 1 0-.848.848L5.15 6 3.826 7.326a.6.6 0 1 0 .848.848L6 6.85l1.326 1.325a.6.6 0 1 0 .848-.848L6.85 6l1.325-1.326a.6.6 0 1 0-.848-.848L6 5.15z",
    clipRule: "evenodd"
  })));
};
var DismissCircle12 = SvgDismissCircle12;

var _path$7u;
function _extends$7A() { _extends$7A = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$7A.apply(this, arguments); }
var SvgDismissCircle16 = function SvgDismissCircle16(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends$7A({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path$7u || (_path$7u = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M8 1.334a6.667 6.667 0 1 0 0 13.333A6.667 6.667 0 0 0 8 1.334M6.197 5.136a.75.75 0 0 0-1.06 1.06L6.938 8 5.136 9.803a.75.75 0 1 0 1.061 1.06L8 9.06l1.803 1.803a.75.75 0 1 0 1.06-1.06L9.062 8l1.803-1.803a.75.75 0 0 0-1.06-1.06L8 6.938z",
    clipRule: "evenodd"
  })));
};
var DismissCircle16 = SvgDismissCircle16;

var _path$7t;
function _extends$7z() { _extends$7z = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$7z.apply(this, arguments); }
var SvgDismissCircle18 = function SvgDismissCircle18(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends$7z({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _path$7t || (_path$7t = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M9 1.5a7.5 7.5 0 1 0 0 15 7.5 7.5 0 0 0 0-15M6.94 5.81a.8.8 0 0 0-1.13 1.13L7.868 9l-2.06 2.06a.8.8 0 0 0 1.132 1.13L9 10.132l2.06 2.06a.8.8 0 0 0 1.13-1.132L10.132 9l2.06-2.06a.8.8 0 0 0-1.132-1.13L9 7.868z",
    clipRule: "evenodd"
  })));
};
var DismissCircle18 = SvgDismissCircle18;

var _path$7s;
function _extends$7y() { _extends$7y = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$7y.apply(this, arguments); }
var SvgDismissCircle24 = function SvgDismissCircle24(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends$7y({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path$7s || (_path$7s = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2M9.136 7.864a.9.9 0 0 0-1.272 1.272L10.727 12l-2.863 2.864a.9.9 0 0 0 1.272 1.272L12 13.273l2.864 2.863a.9.9 0 1 0 1.272-1.272L13.273 12l2.863-2.864a.9.9 0 1 0-1.272-1.272L12 10.727z",
    clipRule: "evenodd"
  })));
};
var DismissCircle24 = SvgDismissCircle24;

var _path$7r;
function _extends$7x() { _extends$7x = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$7x.apply(this, arguments); }
var SvgDismissCircle32 = function SvgDismissCircle32(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends$7x({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _path$7r || (_path$7r = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M16 2.667C8.636 2.667 2.667 8.636 2.667 16S8.637 29.333 16 29.333 29.333 23.363 29.333 16 23.363 2.667 16 2.667m-3.96 7.96a1 1 0 0 0-1.414 1.414l3.96 3.96-3.96 3.959a1 1 0 0 0 1.414 1.414l3.96-3.96 3.96 3.96a1 1 0 1 0 1.414-1.414L17.414 16l3.96-3.96a1 1 0 0 0-1.415-1.414L16 14.586z",
    clipRule: "evenodd"
  })));
};
var DismissCircle32 = SvgDismissCircle32;

var _path$7q;
function _extends$7w() { _extends$7w = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$7w.apply(this, arguments); }
var SvgDismissCircle48 = function SvgDismissCircle48(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends$7w({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none"
  }, props), _path$7q || (_path$7q = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M24 4C12.954 4 4 12.954 4 24s8.954 20 20 20 20-8.954 20-20S35.046 4 24 4m-6.151 12.151a1.2 1.2 0 1 0-1.698 1.698L22.304 24l-6.152 6.151a1.2 1.2 0 1 0 1.698 1.698L24 25.697l6.151 6.152a1.2 1.2 0 1 0 1.698-1.698L25.697 24l6.152-6.151a1.2 1.2 0 1 0-1.698-1.698L24 22.304z",
    clipRule: "evenodd"
  })));
};
var DismissCircle48 = SvgDismissCircle48;

var DismissCircleIcon = function DismissCircleIcon(props) {
  var dismissCircle = {
    12: DismissCircle12,
    16: DismissCircle16,
    18: DismissCircle18,
    24: DismissCircle24,
    32: DismissCircle32,
    48: DismissCircle48
  };
  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(IconTemplate, (0,_common_js__WEBPACK_IMPORTED_MODULE_2__.a)({
    icons: dismissCircle
  }, props));
};

var _path$7p;
function _extends$7v() { _extends$7v = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$7v.apply(this, arguments); }
var SvgDownload12 = function SvgDownload12(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$7v({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none"
  }, props), _path$7p || (_path$7p = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M7.826 5.076a.6.6 0 1 1 .848.848l-2.25 2.25a.6.6 0 0 1-.848 0l-2.25-2.25a.6.6 0 0 1 .848-.848L5.4 6.3V2a.6.6 0 0 1 1.2 0V6.3zM2.1 8A.6.6 0 0 0 .9 8v1a1.6 1.6 0 0 0 1.6 1.6h7A1.6 1.6 0 0 0 11.1 9V8a.6.6 0 1 0-1.2 0v1a.4.4 0 0 1-.4.4h-7a.4.4 0 0 1-.4-.4z",
    clipRule: "evenodd"
  })));
};
var Download12 = (/* unused pure expression or super */ null && (SvgDownload12));

var _path$7o;
function _extends$7u() { _extends$7u = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$7u.apply(this, arguments); }
var SvgDownload16 = function SvgDownload16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$7u({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path$7o || (_path$7o = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M10.47 6.803a.75.75 0 1 1 1.06 1.06l-3 3a.75.75 0 0 1-1.06 0l-3-3a.75.75 0 0 1 1.06-1.06l1.72 1.72V2.667a.75.75 0 0 1 1.5 0v5.856zm-7.72 3.863a.75.75 0 0 0-1.5 0v1.267a2.15 2.15 0 0 0 2.15 2.15h9.2a2.15 2.15 0 0 0 2.15-2.15v-1.267a.75.75 0 0 0-1.5 0v1.267a.65.65 0 0 1-.65.65H3.4a.65.65 0 0 1-.65-.65z",
    clipRule: "evenodd"
  })));
};
var Download16 = (/* unused pure expression or super */ null && (SvgDownload16));

var _path$7n;
function _extends$7t() { _extends$7t = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$7t.apply(this, arguments); }
var SvgDownload18 = function SvgDownload18(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$7t({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _path$7n || (_path$7n = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M11.81 7.685a.8.8 0 0 1 1.13 1.13l-3.375 3.376a.8.8 0 0 1-1.13 0L5.058 8.816A.8.8 0 1 1 6.19 7.685L8.2 9.694V3a.8.8 0 0 1 1.6 0v6.694zM3.05 12a.8.8 0 0 0-1.6 0v1.6a2.2 2.2 0 0 0 2.2 2.2h10.7a2.2 2.2 0 0 0 2.2-2.2V12a.8.8 0 0 0-1.6 0v1.6a.6.6 0 0 1-.6.6H3.65a.6.6 0 0 1-.6-.6z",
    clipRule: "evenodd"
  })));
};
var Download18 = (/* unused pure expression or super */ null && (SvgDownload18));

var _path$7m;
function _extends$7s() { _extends$7s = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$7s.apply(this, arguments); }
var SvgDownload24 = function SvgDownload24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$7s({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path$7m || (_path$7m = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M15.864 10.364a.9.9 0 1 1 1.272 1.272l-4.5 4.5a.9.9 0 0 1-1.272 0l-4.5-4.5a.9.9 0 1 1 1.272-1.272l2.964 2.963V4a.9.9 0 1 1 1.8 0v9.327zM3.9 16a.9.9 0 0 0-1.8 0v2.2a2.7 2.7 0 0 0 2.7 2.7h14.4a2.7 2.7 0 0 0 2.7-2.7V16a.9.9 0 0 0-1.8 0v2.2a.9.9 0 0 1-.9.9H4.8a.9.9 0 0 1-.9-.9z",
    clipRule: "evenodd"
  })));
};
var Download24 = (/* unused pure expression or super */ null && (SvgDownload24));

var _path$7l;
function _extends$7r() { _extends$7r = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$7r.apply(this, arguments); }
var SvgDownload32 = function SvgDownload32(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$7r({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _path$7l || (_path$7l = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M21.293 13.96a1 1 0 0 1 1.414 1.414l-6 6a1 1 0 0 1-1.414 0l-6-6a1 1 0 1 1 1.414-1.414L15 18.253V5.333a1 1 0 1 1 2 0v12.92zM5 21.334a1 1 0 1 0-2 0v3.333a3 3 0 0 0 3 3h20a3 3 0 0 0 3-3v-3.334a1 1 0 1 0-2 0v3.334a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1z",
    clipRule: "evenodd"
  })));
};
var Download32 = (/* unused pure expression or super */ null && (SvgDownload32));

var _path$7k;
function _extends$7q() { _extends$7q = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$7q.apply(this, arguments); }
var SvgDownload48 = function SvgDownload48(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$7q({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none"
  }, props), _path$7k || (_path$7k = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M32.152 21.151a1.2 1.2 0 1 1 1.697 1.697l-9 9a1.2 1.2 0 0 1-1.697 0l-9-9a1.2 1.2 0 1 1 1.697-1.697l6.951 6.952V8a1.2 1.2 0 0 1 2.4 0v20.103zM7.2 32a1.2 1.2 0 1 0-2.4 0v5A4.2 4.2 0 0 0 9 41.2h30a4.2 4.2 0 0 0 4.2-4.2v-5a1.2 1.2 0 1 0-2.4 0v5a1.8 1.8 0 0 1-1.8 1.8H9A1.8 1.8 0 0 1 7.2 37z",
    clipRule: "evenodd"
  })));
};
var Download48 = (/* unused pure expression or super */ null && (SvgDownload48));

var DownloadIcon = function DownloadIcon(props) {
  var download = {
    12: Download12,
    16: Download16,
    18: Download18,
    24: Download24,
    32: Download32,
    48: Download48
  };
  return jsx(IconTemplate, _assign({
    icons: download
  }, props));
};

var _path$7j;
function _extends$7p() { _extends$7p = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$7p.apply(this, arguments); }
var SvgDropdownDown12 = function SvgDropdownDown12(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$7p({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none"
  }, props), _path$7j || (_path$7j = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M8.5 5h-5L6 7.5z"
  })));
};
var DropdownDown12 = (/* unused pure expression or super */ null && (SvgDropdownDown12));

var _path$7i;
function _extends$7o() { _extends$7o = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$7o.apply(this, arguments); }
var SvgDropdownDown16 = function SvgDropdownDown16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$7o({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path$7i || (_path$7i = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M11.333 6.667H4.667L8 10z"
  })));
};
var DropdownDown16 = (/* unused pure expression or super */ null && (SvgDropdownDown16));

var _path$7h;
function _extends$7n() { _extends$7n = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$7n.apply(this, arguments); }
var SvgDropdownDown18 = function SvgDropdownDown18(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$7n({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _path$7h || (_path$7h = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M12.75 7.5h-7.5L9 11.25z"
  })));
};
var DropdownDown18 = (/* unused pure expression or super */ null && (SvgDropdownDown18));

var _path$7g;
function _extends$7m() { _extends$7m = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$7m.apply(this, arguments); }
var SvgDropdownDown24 = function SvgDropdownDown24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$7m({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path$7g || (_path$7g = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M17 10H7l5 5z"
  })));
};
var DropdownDown24 = (/* unused pure expression or super */ null && (SvgDropdownDown24));

var _path$7f;
function _extends$7l() { _extends$7l = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$7l.apply(this, arguments); }
var SvgDropdownDown32 = function SvgDropdownDown32(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$7l({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _path$7f || (_path$7f = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M22.667 13.334H9.333L16 20z"
  })));
};
var DropdownDown32 = (/* unused pure expression or super */ null && (SvgDropdownDown32));

var _path$7e;
function _extends$7k() { _extends$7k = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$7k.apply(this, arguments); }
var SvgDropdownDown48 = function SvgDropdownDown48(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$7k({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none"
  }, props), _path$7e || (_path$7e = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M34 20H14l10 10z"
  })));
};
var DropdownDown48 = (/* unused pure expression or super */ null && (SvgDropdownDown48));

var DropdownDownIcon = function DropdownDownIcon(props) {
  var dropdownDown = {
    12: DropdownDown12,
    16: DropdownDown16,
    18: DropdownDown18,
    24: DropdownDown24,
    32: DropdownDown32,
    48: DropdownDown48
  };
  return jsx(IconTemplate, _assign({
    icons: dropdownDown
  }, props));
};

var _path$7d;
function _extends$7j() { _extends$7j = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$7j.apply(this, arguments); }
var SvgDropdownRight12 = function SvgDropdownRight12(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$7j({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none"
  }, props), _path$7d || (_path$7d = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M5 3.5v5L7.5 6z"
  })));
};
var DropdownRight12 = (/* unused pure expression or super */ null && (SvgDropdownRight12));

var _path$7c;
function _extends$7i() { _extends$7i = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$7i.apply(this, arguments); }
var SvgDropdownRight16 = function SvgDropdownRight16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$7i({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path$7c || (_path$7c = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M6.667 4.667v6.667L10 8z"
  })));
};
var DropdownRight16 = (/* unused pure expression or super */ null && (SvgDropdownRight16));

var _path$7b;
function _extends$7h() { _extends$7h = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$7h.apply(this, arguments); }
var SvgDropdownRight18 = function SvgDropdownRight18(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$7h({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _path$7b || (_path$7b = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M7.5 5.25v7.5L11.25 9z"
  })));
};
var DropdownRight18 = (/* unused pure expression or super */ null && (SvgDropdownRight18));

var _path$7a;
function _extends$7g() { _extends$7g = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$7g.apply(this, arguments); }
var SvgDropdownRight24 = function SvgDropdownRight24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$7g({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path$7a || (_path$7a = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M10 7v10l5-5z"
  })));
};
var DropdownRight24 = (/* unused pure expression or super */ null && (SvgDropdownRight24));

var _path$79;
function _extends$7f() { _extends$7f = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$7f.apply(this, arguments); }
var SvgDropdownRight32 = function SvgDropdownRight32(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$7f({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _path$79 || (_path$79 = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M13.333 9.333v13.333L20 16z"
  })));
};
var DropdownRight32 = (/* unused pure expression or super */ null && (SvgDropdownRight32));

var _path$78;
function _extends$7e() { _extends$7e = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$7e.apply(this, arguments); }
var SvgDropdownRight48 = function SvgDropdownRight48(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$7e({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none"
  }, props), _path$78 || (_path$78 = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M20 14v20l10-10z"
  })));
};
var DropdownRight48 = (/* unused pure expression or super */ null && (SvgDropdownRight48));

var DropdownRightIcon = function DropdownRightIcon(props) {
  var dropdownRight = {
    12: DropdownRight12,
    16: DropdownRight16,
    18: DropdownRight18,
    24: DropdownRight24,
    32: DropdownRight32,
    48: DropdownRight48
  };
  return jsx(IconTemplate, _assign({
    icons: dropdownRight
  }, props));
};

var _path$77;
function _extends$7d() { _extends$7d = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$7d.apply(this, arguments); }
var SvgDropdownUp12 = function SvgDropdownUp12(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$7d({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none"
  }, props), _path$77 || (_path$77 = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M3.5 7h5L6 4.5z"
  })));
};
var DropdownUp12 = (/* unused pure expression or super */ null && (SvgDropdownUp12));

var _path$76;
function _extends$7c() { _extends$7c = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$7c.apply(this, arguments); }
var SvgDropdownUp16 = function SvgDropdownUp16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$7c({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path$76 || (_path$76 = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M4.667 9.334h6.666L8 6z"
  })));
};
var DropdownUp16 = (/* unused pure expression or super */ null && (SvgDropdownUp16));

var _path$75;
function _extends$7b() { _extends$7b = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$7b.apply(this, arguments); }
var SvgDropdownUp18 = function SvgDropdownUp18(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$7b({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _path$75 || (_path$75 = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M5.25 10.5h7.5L9 6.75z"
  })));
};
var DropdownUp18 = (/* unused pure expression or super */ null && (SvgDropdownUp18));

var _path$74;
function _extends$7a() { _extends$7a = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$7a.apply(this, arguments); }
var SvgDropdownUp24 = function SvgDropdownUp24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$7a({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path$74 || (_path$74 = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M7 14h10l-5-5z"
  })));
};
var DropdownUp24 = (/* unused pure expression or super */ null && (SvgDropdownUp24));

var _path$73;
function _extends$79() { _extends$79 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$79.apply(this, arguments); }
var SvgDropdownUp32 = function SvgDropdownUp32(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$79({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _path$73 || (_path$73 = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M9.333 18.667h13.334L16 12z"
  })));
};
var DropdownUp32 = (/* unused pure expression or super */ null && (SvgDropdownUp32));

var _path$72;
function _extends$78() { _extends$78 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$78.apply(this, arguments); }
var SvgDropdownUp48 = function SvgDropdownUp48(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$78({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none"
  }, props), _path$72 || (_path$72 = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M14 28h20L24 18z"
  })));
};
var DropdownUp48 = (/* unused pure expression or super */ null && (SvgDropdownUp48));

var DropdownUpIcon = function DropdownUpIcon(props) {
  var dropdownUp = {
    12: DropdownUp12,
    16: DropdownUp16,
    18: DropdownUp18,
    24: DropdownUp24,
    32: DropdownUp32,
    48: DropdownUp48
  };
  return jsx(IconTemplate, _assign({
    icons: dropdownUp
  }, props));
};

var _path$71;
function _extends$77() { _extends$77 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$77.apply(this, arguments); }
var SvgExpand12 = function SvgExpand12(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$77({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none"
  }, props), _path$71 || (_path$71 = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M6.355 2.133a.6.6 0 0 1 .6-.6h2.678a.6.6 0 0 1 .6.6v2.679a.6.6 0 1 1-1.2 0V2.733H6.955a.6.6 0 0 1-.6-.6M2.133 6.355a.6.6 0 0 1 .6.6v2.078h2.079a.6.6 0 0 1 0 1.2H2.133a.6.6 0 0 1-.6-.6V6.955a.6.6 0 0 1 .6-.6",
    clipRule: "evenodd"
  })));
};
var Expand12 = (/* unused pure expression or super */ null && (SvgExpand12));

var _path$70;
function _extends$76() { _extends$76 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$76.apply(this, arguments); }
var SvgExpand16 = function SvgExpand16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$76({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path$70 || (_path$70 = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M8.871 2.5a.7.7 0 0 1 .7-.7H13.5a.7.7 0 0 1 .7.7v3.928a.7.7 0 1 1-1.4 0V3.2H9.571a.7.7 0 0 1-.7-.7M2.5 8.87a.7.7 0 0 1 .7.7V12.8H6.43a.7.7 0 1 1 0 1.4H2.5a.7.7 0 0 1-.7-.7V9.57a.7.7 0 0 1 .7-.7",
    clipRule: "evenodd"
  })));
};
var Expand16 = (/* unused pure expression or super */ null && (SvgExpand16));

var _path$6$;
function _extends$75() { _extends$75 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$75.apply(this, arguments); }
var SvgExpand18 = function SvgExpand18(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$75({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _path$6$ || (_path$6$ = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M10.107 2.5a.75.75 0 0 1 .75-.75H15.5a.75.75 0 0 1 .75.75v4.643a.75.75 0 0 1-1.5 0V3.25h-3.893a.75.75 0 0 1-.75-.75M2.5 10.107a.75.75 0 0 1 .75.75v3.893h3.893a.75.75 0 0 1 0 1.5H2.5a.75.75 0 0 1-.75-.75v-4.643a.75.75 0 0 1 .75-.75",
    clipRule: "evenodd"
  })));
};
var Expand18 = (/* unused pure expression or super */ null && (SvgExpand18));

var _path$6_;
function _extends$74() { _extends$74 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$74.apply(this, arguments); }
var SvgExpand24 = function SvgExpand24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$74({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path$6_ || (_path$6_ = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M13.529 3.5a.9.9 0 0 1 .9-.9H20.5a.9.9 0 0 1 .9.9v6.072a.9.9 0 1 1-1.8 0V4.4H14.43a.9.9 0 0 1-.9-.9M3.5 13.53a.9.9 0 0 1 .9.9V19.6h5.172a.9.9 0 1 1 0 1.8H3.5a.9.9 0 0 1-.9-.9V14.43a.9.9 0 0 1 .9-.9",
    clipRule: "evenodd"
  })));
};
var Expand24 = (/* unused pure expression or super */ null && (SvgExpand24));

var _path$6Z;
function _extends$73() { _extends$73 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$73.apply(this, arguments); }
var SvgExpand32 = function SvgExpand32(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$73({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _path$6Z || (_path$6Z = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M18.238 4.667a1 1 0 0 1 1-1h8.095a1 1 0 0 1 1 1v8.095a1 1 0 1 1-2 0V5.667h-7.095a1 1 0 0 1-1-1M4.667 18.237a1 1 0 0 1 1 1v7.096h7.095a1 1 0 1 1 0 2H4.667a1 1 0 0 1-1-1v-8.095a1 1 0 0 1 1-1",
    clipRule: "evenodd"
  })));
};
var Expand32 = (/* unused pure expression or super */ null && (SvgExpand32));

var _path$6Y;
function _extends$72() { _extends$72 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$72.apply(this, arguments); }
var SvgExpand48 = function SvgExpand48(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$72({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none"
  }, props), _path$6Y || (_path$6Y = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M27.657 7a1.2 1.2 0 0 1 1.2-1.2H41A1.2 1.2 0 0 1 42.2 7v12.143a1.2 1.2 0 0 1-2.4 0V8.2H28.857a1.2 1.2 0 0 1-1.2-1.2M7 27.657a1.2 1.2 0 0 1 1.2 1.2V39.8h10.943a1.2 1.2 0 0 1 0 2.4H7A1.2 1.2 0 0 1 5.8 41V28.857a1.2 1.2 0 0 1 1.2-1.2",
    clipRule: "evenodd"
  })));
};
var Expand48 = (/* unused pure expression or super */ null && (SvgExpand48));

var ExpandIcon = function ExpandIcon(props) {
  var expand = {
    12: Expand12,
    16: Expand16,
    18: Expand18,
    24: Expand24,
    32: Expand32,
    48: Expand48
  };
  return jsx(IconTemplate, _assign({
    icons: expand
  }, props));
};

var _path$6X, _path2$2y;
function _extends$71() { _extends$71 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$71.apply(this, arguments); }
var SvgExport12 = function SvgExport12(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$71({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none"
  }, props), _path$6X || (_path$6X = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M2 4.778a.6.6 0 0 1 .6.6v3.389a.9.9 0 0 0 .9.9h5a.9.9 0 0 0 .9-.9v-3.39a.6.6 0 0 1 1.2 0v3.39a2.1 2.1 0 0 1-2.1 2.1h-5a2.1 2.1 0 0 1-2.1-2.1v-3.39a.6.6 0 0 1 .6-.6M6 .885l2.557 2.557a.6.6 0 1 1-.848.849l-1.71-1.71-1.708 1.71a.6.6 0 1 1-.849-.849z",
    clipRule: "evenodd"
  })), _path2$2y || (_path2$2y = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M6 1.85a.6.6 0 0 1 .6.6v3.9a.6.6 0 0 1-1.2 0v-3.9a.6.6 0 0 1 .6-.6",
    clipRule: "evenodd"
  })));
};
var Export12 = (/* unused pure expression or super */ null && (SvgExport12));

var _path$6W, _path2$2x;
function _extends$70() { _extends$70 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$70.apply(this, arguments); }
var SvgExport16 = function SvgExport16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$70({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path$6W || (_path$6W = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M2.667 6.42a.75.75 0 0 1 .75.75v4.519c0 .69.56 1.25 1.25 1.25h6.666c.69 0 1.25-.56 1.25-1.25V7.17a.75.75 0 0 1 1.5 0v4.519a2.75 2.75 0 0 1-2.75 2.75H4.667a2.75 2.75 0 0 1-2.75-2.75V7.17a.75.75 0 0 1 .75-.75M8 1.25l3.375 3.375a.75.75 0 1 1-1.06 1.06L8 3.373 5.686 5.686a.75.75 0 1 1-1.06-1.06z",
    clipRule: "evenodd"
  })), _path2$2x || (_path2$2x = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M8 2.517a.75.75 0 0 1 .75.75v5.2a.75.75 0 1 1-1.5 0v-5.2a.75.75 0 0 1 .75-.75",
    clipRule: "evenodd"
  })));
};
var Export16 = (/* unused pure expression or super */ null && (SvgExport16));

var _path$6V, _path2$2w;
function _extends$6$() { _extends$6$ = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$6$.apply(this, arguments); }
var SvgExport18 = function SvgExport18(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$6$({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _path$6V || (_path$6V = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M3 7.267a.8.8 0 0 1 .8.8v5.083c0 .801.65 1.45 1.45 1.45h7.5c.8 0 1.45-.649 1.45-1.45V8.067a.8.8 0 1 1 1.6 0v5.083a3.05 3.05 0 0 1-3.05 3.05h-7.5a3.05 3.05 0 0 1-3.05-3.05V8.067a.8.8 0 0 1 .8-.8M9 1.469l3.766 3.765a.8.8 0 0 1-1.132 1.132L9 3.73 6.366 6.366a.8.8 0 1 1-1.132-1.132z",
    clipRule: "evenodd"
  })), _path2$2w || (_path2$2w = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M9 2.875a.8.8 0 0 1 .8.8v5.85a.8.8 0 0 1-1.6 0v-5.85a.8.8 0 0 1 .8-.8",
    clipRule: "evenodd"
  })));
};
var Export18 = (/* unused pure expression or super */ null && (SvgExport18));

var _path$6U, _path2$2v;
function _extends$6_() { _extends$6_ = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$6_.apply(this, arguments); }
var SvgExport24 = function SvgExport24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$6_({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path$6U || (_path$6U = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M4 9.856a.9.9 0 0 1 .9.9v6.777c0 1.16.94 2.1 2.1 2.1h10a2.1 2.1 0 0 0 2.1-2.1v-6.778a.9.9 0 0 1 1.8 0v6.778a3.9 3.9 0 0 1-3.9 3.9H7a3.9 3.9 0 0 1-3.9-3.9v-6.778a.9.9 0 0 1 .9-.9M12 2.194l4.903 4.903A.9.9 0 0 1 15.63 8.37L12 4.74 8.37 8.37a.9.9 0 0 1-1.273-1.273z",
    clipRule: "evenodd"
  })), _path2$2v || (_path2$2v = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M12 4a.9.9 0 0 1 .9.9v7.8a.9.9 0 0 1-1.8 0V4.9A.9.9 0 0 1 12 4",
    clipRule: "evenodd"
  })));
};
var Export24 = (/* unused pure expression or super */ null && (SvgExport24));

var _path$6T, _path2$2u;
function _extends$6Z() { _extends$6Z = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$6Z.apply(this, arguments); }
var SvgExport32 = function SvgExport32(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$6Z({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _path$6T || (_path$6T = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M5.333 13.24a1.1 1.1 0 0 1 1.1 1.1v9.038a2.9 2.9 0 0 0 2.9 2.9h13.334a2.9 2.9 0 0 0 2.9-2.9V14.34a1.1 1.1 0 0 1 2.2 0v9.037a5.1 5.1 0 0 1-5.1 5.1H9.333a5.1 5.1 0 0 1-5.1-5.1V14.34a1.1 1.1 0 0 1 1.1-1.1M16 3.066l6.467 6.467a1.1 1.1 0 1 1-1.556 1.556L16 6.178l-4.911 4.91a1.1 1.1 0 0 1-1.556-1.555z",
    clipRule: "evenodd"
  })), _path2$2u || (_path2$2u = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M16 5.433a1.1 1.1 0 0 1 1.1 1.1v10.4a1.1 1.1 0 0 1-2.2 0v-10.4a1.1 1.1 0 0 1 1.1-1.1",
    clipRule: "evenodd"
  })));
};
var Export32 = (/* unused pure expression or super */ null && (SvgExport32));

var _path$6S, _path2$2t;
function _extends$6Y() { _extends$6Y = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$6Y.apply(this, arguments); }
var SvgExport48 = function SvgExport48(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$6Y({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none"
  }, props), _path$6S || (_path$6S = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M8.3 22.116a1.3 1.3 0 0 1 1.3 1.3v13.556a4.7 4.7 0 0 0 4.7 4.7h20a4.7 4.7 0 0 0 4.7-4.7V23.416a1.3 1.3 0 0 1 2.6 0v13.556a7.3 7.3 0 0 1-7.3 7.3h-20a7.3 7.3 0 0 1-7.3-7.3V23.416a1.3 1.3 0 0 1 1.3-1.3M24.3 7l9.452 9.453a1.3 1.3 0 1 1-1.838 1.838L24.3 10.677l-7.614 7.614a1.3 1.3 0 0 1-1.839-1.838z",
    clipRule: "evenodd"
  })), _path2$2t || (_path2$2t = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M24.3 10.405a1.3 1.3 0 0 1 1.3 1.3v15.6a1.3 1.3 0 0 1-2.6 0v-15.6a1.3 1.3 0 0 1 1.3-1.3",
    clipRule: "evenodd"
  })));
};
var Export48 = (/* unused pure expression or super */ null && (SvgExport48));

var ExportIcon = function ExportIcon(props) {
  var exportIcon = {
    12: Export12,
    16: Export16,
    18: Export18,
    24: Export24,
    32: Export32,
    48: Export48
  };
  return jsx(IconTemplate, _assign({
    icons: exportIcon
  }, props));
};

var _path$6R, _path2$2s;
function _extends$6X() { _extends$6X = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$6X.apply(this, arguments); }
var SvgFastForwardFilled12 = function SvgFastForwardFilled12(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$6X({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none"
  }, props), _path$6R || (_path$6R = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M1.696 2.983a.6.6 0 0 1 .595-.008l4.5 2.5a.6.6 0 0 1 0 1.05l-4.5 2.5A.6.6 0 0 1 1.4 8.5v-5a.6.6 0 0 1 .296-.517",
    clipRule: "evenodd"
  })), _path2$2s || (_path2$2s = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M5.696 2.983a.6.6 0 0 1 .595-.008l4.5 2.5a.6.6 0 0 1 0 1.05l-4.5 2.5A.6.6 0 0 1 5.4 8.5v-5a.6.6 0 0 1 .296-.517",
    clipRule: "evenodd"
  })));
};
var FastForwardFilled12 = (/* unused pure expression or super */ null && (SvgFastForwardFilled12));

var _path$6Q, _path2$2r;
function _extends$6W() { _extends$6W = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$6W.apply(this, arguments); }
var SvgFastForwardFilled16 = function SvgFastForwardFilled16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$6W({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path$6Q || (_path$6Q = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M2.376 3.85a.75.75 0 0 1 .752.002l6 3.5a.75.75 0 0 1 0 1.296l-6 3.5A.75.75 0 0 1 2 11.5v-7a.75.75 0 0 1 .376-.65",
    clipRule: "evenodd"
  })), _path2$2r || (_path2$2r = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M7.626 3.85a.75.75 0 0 1 .752.002l6 3.5a.75.75 0 0 1 0 1.296l-6 3.5A.75.75 0 0 1 7.25 11.5v-7a.75.75 0 0 1 .376-.65",
    clipRule: "evenodd"
  })));
};
var FastForwardFilled16 = (/* unused pure expression or super */ null && (SvgFastForwardFilled16));

var _path$6P, _path2$2q;
function _extends$6V() { _extends$6V = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$6V.apply(this, arguments); }
var SvgFastForwardFilled18 = function SvgFastForwardFilled18(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$6V({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _path$6P || (_path$6P = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M2.594 4.56a.8.8 0 0 1 .794-.01l6.75 3.75a.8.8 0 0 1 0 1.4l-6.75 3.75a.8.8 0 0 1-1.188-.7v-7.5a.8.8 0 0 1 .394-.69",
    clipRule: "evenodd"
  })), _path2$2q || (_path2$2q = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M8.594 4.56a.8.8 0 0 1 .794-.01l6.75 3.75a.8.8 0 0 1 0 1.4l-6.75 3.75a.8.8 0 0 1-1.188-.7v-7.5a.8.8 0 0 1 .394-.69",
    clipRule: "evenodd"
  })));
};
var FastForwardFilled18 = (/* unused pure expression or super */ null && (SvgFastForwardFilled18));

var _path$6O, _path2$2p;
function _extends$6U() { _extends$6U = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$6U.apply(this, arguments); }
var SvgFastForwardFilled24 = function SvgFastForwardFilled24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$6U({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path$6O || (_path$6O = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M3.544 6.224a.9.9 0 0 1 .893-.01l9 5a.9.9 0 0 1 0 1.573l-9 5A.9.9 0 0 1 3.1 17V7a.9.9 0 0 1 .444-.776",
    clipRule: "evenodd"
  })), _path2$2p || (_path2$2p = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M11.544 6.224a.9.9 0 0 1 .893-.01l9 5a.9.9 0 0 1 0 1.573l-9 5A.9.9 0 0 1 11.1 17V7a.9.9 0 0 1 .444-.776",
    clipRule: "evenodd"
  })));
};
var FastForwardFilled24 = (/* unused pure expression or super */ null && (SvgFastForwardFilled24));

var _path$6N, _path2$2o;
function _extends$6T() { _extends$6T = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$6T.apply(this, arguments); }
var SvgFastForwardFilled32 = function SvgFastForwardFilled32(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$6T({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _path$6N || (_path$6N = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M4.752 8.133a1 1 0 0 1 1.002.003l12 7a1 1 0 0 1 0 1.728l-12 7A1 1 0 0 1 4.25 23V9a1 1 0 0 1 .502-.867",
    clipRule: "evenodd"
  })), _path2$2o || (_path2$2o = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M15.752 8.133a1 1 0 0 1 1.002.003l12 7a1 1 0 0 1 0 1.728l-12 7A1 1 0 0 1 15.25 23V9a1 1 0 0 1 .502-.867",
    clipRule: "evenodd"
  })));
};
var FastForwardFilled32 = (/* unused pure expression or super */ null && (SvgFastForwardFilled32));

var _path$6M, _path2$2n;
function _extends$6S() { _extends$6S = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$6S.apply(this, arguments); }
var SvgFastForwardFilled48 = function SvgFastForwardFilled48(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$6S({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none"
  }, props), _path$6M || (_path$6M = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M6.902 12.46a1.2 1.2 0 0 1 1.203.003l18 10.5a1.2 1.2 0 0 1 0 2.074l-18 10.5A1.2 1.2 0 0 1 6.3 34.5v-21c0-.43.23-.826.602-1.04",
    clipRule: "evenodd"
  })), _path2$2n || (_path2$2n = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M23.902 12.46a1.2 1.2 0 0 1 1.203.003l18 10.5a1.2 1.2 0 0 1 0 2.074l-18 10.5A1.2 1.2 0 0 1 23.3 34.5v-21c0-.43.23-.826.602-1.04",
    clipRule: "evenodd"
  })));
};
var FastForwardFilled48 = (/* unused pure expression or super */ null && (SvgFastForwardFilled48));

var FastForwardFilledIcon = function FastForwardFilledIcon(props) {
  var fastForwardFilled = {
    12: FastForwardFilled12,
    16: FastForwardFilled16,
    18: FastForwardFilled18,
    24: FastForwardFilled24,
    32: FastForwardFilled32,
    48: FastForwardFilled48
  };
  return jsx(IconTemplate, _assign({
    icons: fastForwardFilled
  }, props));
};

var _path$6L;
function _extends$6R() { _extends$6R = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$6R.apply(this, arguments); }
var SvgFilter12 = function SvgFilter12(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$6R({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none"
  }, props), _path$6L || (_path$6L = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "m6.675 6.247 2.414-2.628a.8.8 0 0 0 .211-.541V2.2H2.7v.878a.8.8 0 0 0 .21.541l2.415 2.628V9.8h1.35zM9.973 4.43a2 2 0 0 0 .527-1.353V2a1 1 0 0 0-1-1h-7a1 1 0 0 0-1 1v1.078a2 2 0 0 0 .527 1.353l2.098 2.283V10a1 1 0 0 0 1 1h1.75a1 1 0 0 0 1-1V6.714z",
    clipRule: "evenodd"
  })));
};
var Filter12 = (/* unused pure expression or super */ null && (SvgFilter12));

var _path$6K;
function _extends$6Q() { _extends$6Q = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$6Q.apply(this, arguments); }
var SvgFilter16 = function SvgFilter16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$6Q({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path$6K || (_path$6K = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "m8.896 8.326 3.22-3.44a.5.5 0 0 0 .134-.341V3.25h-8.5v1.295a.5.5 0 0 0 .135.341l3.22 3.44v4.47h1.79zm1.5.593L13.21 5.91a2 2 0 0 0 .54-1.366V3.25a1.5 1.5 0 0 0-1.5-1.5h-8.5a1.5 1.5 0 0 0-1.5 1.5v1.295a2 2 0 0 0 .54 1.366L5.604 8.92v3.877a1.5 1.5 0 0 0 1.5 1.5h1.792a1.5 1.5 0 0 0 1.5-1.5z",
    clipRule: "evenodd"
  })));
};
var Filter16 = (/* unused pure expression or super */ null && (SvgFilter16));

var _path$6J;
function _extends$6P() { _extends$6P = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$6P.apply(this, arguments); }
var SvgFilter18 = function SvgFilter18(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$6P({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _path$6J || (_path$6J = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "m10.108 9.362 3.682-3.884a.4.4 0 0 0 .11-.275V3.6H4.1v1.603c0 .102.04.2.11.275l3.682 3.884V14.4h2.216zm1.6.638 3.243-3.421a2 2 0 0 0 .549-1.376V3.5A1.5 1.5 0 0 0 14 2H4a1.5 1.5 0 0 0-1.5 1.5v1.703a2 2 0 0 0 .548 1.376L6.292 10v4.5a1.5 1.5 0 0 0 1.5 1.5h2.416a1.5 1.5 0 0 0 1.5-1.5z",
    clipRule: "evenodd"
  })));
};
var Filter18 = (/* unused pure expression or super */ null && (SvgFilter18));

var _path$6I;
function _extends$6O() { _extends$6O = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$6O.apply(this, arguments); }
var SvgFilter24 = function SvgFilter24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$6O({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path$6I || (_path$6I = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "m13.575 13.691 5.567-5.656a.2.2 0 0 0 .058-.14V5a.2.2 0 0 0-.2-.2H5a.2.2 0 0 0-.2.2v2.895a.2.2 0 0 0 .057.14l5.568 5.656V21c0 .11.09.2.2.2h2.75a.2.2 0 0 0 .2-.2zm1.8.738 5.05-5.13A2 2 0 0 0 21 7.894V5a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v2.895a2 2 0 0 0 .575 1.403l5.05 5.13V21a2 2 0 0 0 2 2h2.75a2 2 0 0 0 2-2z",
    clipRule: "evenodd"
  })));
};
var Filter24 = (/* unused pure expression or super */ null && (SvgFilter24));

var _path$6H;
function _extends$6N() { _extends$6N = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$6N.apply(this, arguments); }
var SvgFilter32 = function SvgFilter32(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$6N({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _path$6H || (_path$6H = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "m18.1 18.255 7.423-7.541a.27.27 0 0 0 .077-.187v-3.86a.267.267 0 0 0-.267-.267H6.667a.267.267 0 0 0-.267.267v3.86c0 .07.028.137.077.187l7.423 7.541V28c0 .147.12.267.267.267h3.666c.148 0 .267-.12.267-.267zm2.4.983 6.734-6.84c.49-.5.766-1.171.766-1.871v-3.86A2.667 2.667 0 0 0 25.333 4H6.667A2.667 2.667 0 0 0 4 6.667v3.86c0 .7.275 1.372.766 1.87l6.734 6.841V28a2.667 2.667 0 0 0 2.667 2.667h3.666A2.667 2.667 0 0 0 20.5 28z",
    clipRule: "evenodd"
  })));
};
var Filter32 = (/* unused pure expression or super */ null && (SvgFilter32));

var _path$6G;
function _extends$6M() { _extends$6M = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$6M.apply(this, arguments); }
var SvgFilter48 = function SvgFilter48(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$6M({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none"
  }, props), _path$6G || (_path$6G = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M28.35 25.874 39.6 14.446V7a.6.6 0 0 0-.6-.6H9a.6.6 0 0 0-.6.6v7.445l11.25 11.43V41a.6.6 0 0 0 .6.6h7.5a.6.6 0 0 0 .6-.6zm2.4.983 10.675-10.845A2 2 0 0 0 42 14.61V7a3 3 0 0 0-3-3H9a3 3 0 0 0-3 3v7.61a2 2 0 0 0 .575 1.402L17.25 26.857V41a3 3 0 0 0 3 3h7.5a3 3 0 0 0 3-3z",
    clipRule: "evenodd"
  })));
};
var Filter48 = (/* unused pure expression or super */ null && (SvgFilter48));

var FilterIcon = function FilterIcon(props) {
  var filter = {
    12: Filter12,
    16: Filter16,
    18: Filter18,
    24: Filter24,
    32: Filter32,
    48: Filter48
  };
  return jsx(IconTemplate, _assign({
    icons: filter
  }, props));
};

var _path$6F, _path2$2m;
function _extends$6L() { _extends$6L = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$6L.apply(this, arguments); }
var SvgFilterFilled12 = function SvgFilterFilled12(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$6L({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none"
  }, props), _path$6F || (_path$6F = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M9.5 1h-7a1 1 0 0 0-1 1v1.078a2 2 0 0 0 .527 1.353l2.098 2.283V10a1 1 0 0 0 1 1h1.75a1 1 0 0 0 1-1V6.714l2.098-2.283a2 2 0 0 0 .527-1.353V2a1 1 0 0 0-1-1"
  })), _path2$2m || (_path2$2m = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "m6.675 6.247 2.414-2.628a.8.8 0 0 0 .211-.541V2.2H2.7v.878a.8.8 0 0 0 .21.541l2.415 2.628V9.8h1.35zM9.973 4.43a2 2 0 0 0 .527-1.353V2a1 1 0 0 0-1-1h-7a1 1 0 0 0-1 1v1.078a2 2 0 0 0 .527 1.353l2.098 2.283V10a1 1 0 0 0 1 1h1.75a1 1 0 0 0 1-1V6.714z",
    clipRule: "evenodd"
  })));
};
var FilterFilled12 = (/* unused pure expression or super */ null && (SvgFilterFilled12));

var _path$6E, _path2$2l;
function _extends$6K() { _extends$6K = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$6K.apply(this, arguments); }
var SvgFilterFilled16 = function SvgFilterFilled16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$6K({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path$6E || (_path$6E = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M12.25 1.75h-8.5a1.5 1.5 0 0 0-1.5 1.5v1.295a2 2 0 0 0 .54 1.366L5.604 8.92v3.877a1.5 1.5 0 0 0 1.5 1.5h1.792a1.5 1.5 0 0 0 1.5-1.5V8.919L13.21 5.91a2 2 0 0 0 .54-1.366V3.25a1.5 1.5 0 0 0-1.5-1.5"
  })), _path2$2l || (_path2$2l = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "m8.896 8.326 3.22-3.44a.5.5 0 0 0 .134-.341V3.25h-8.5v1.295a.5.5 0 0 0 .135.341l3.22 3.44v4.47h1.79zm1.5.593L13.21 5.91a2 2 0 0 0 .54-1.366V3.25a1.5 1.5 0 0 0-1.5-1.5h-8.5a1.5 1.5 0 0 0-1.5 1.5v1.295a2 2 0 0 0 .54 1.366L5.604 8.92v3.877a1.5 1.5 0 0 0 1.5 1.5h1.792a1.5 1.5 0 0 0 1.5-1.5z",
    clipRule: "evenodd"
  })));
};
var FilterFilled16 = (/* unused pure expression or super */ null && (SvgFilterFilled16));

var _path$6D, _path2$2k;
function _extends$6J() { _extends$6J = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$6J.apply(this, arguments); }
var SvgFilterFilled18 = function SvgFilterFilled18(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$6J({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _path$6D || (_path$6D = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M14 2H4a1.5 1.5 0 0 0-1.5 1.5v1.703a2 2 0 0 0 .548 1.376L6.292 10v4.5a1.5 1.5 0 0 0 1.5 1.5h2.416a1.5 1.5 0 0 0 1.5-1.5V10l3.243-3.421a2 2 0 0 0 .549-1.376V3.5A1.5 1.5 0 0 0 14 2"
  })), _path2$2k || (_path2$2k = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "m10.108 9.362 3.682-3.884a.4.4 0 0 0 .11-.275V3.6H4.1v1.603c0 .102.04.2.11.275l3.682 3.884V14.4h2.216zm1.6.638 3.243-3.421a2 2 0 0 0 .549-1.376V3.5A1.5 1.5 0 0 0 14 2H4a1.5 1.5 0 0 0-1.5 1.5v1.703a2 2 0 0 0 .548 1.376L6.292 10v4.5a1.5 1.5 0 0 0 1.5 1.5h2.416a1.5 1.5 0 0 0 1.5-1.5z",
    clipRule: "evenodd"
  })));
};
var FilterFilled18 = (/* unused pure expression or super */ null && (SvgFilterFilled18));

var _path$6C, _path2$2j;
function _extends$6I() { _extends$6I = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$6I.apply(this, arguments); }
var SvgFilterFilled24 = function SvgFilterFilled24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$6I({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path$6C || (_path$6C = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M19 3H5a2 2 0 0 0-2 2v2.895a2 2 0 0 0 .575 1.403l5.05 5.13V21a2 2 0 0 0 2 2h2.75a2 2 0 0 0 2-2v-6.571l5.05-5.13A2 2 0 0 0 21 7.894V5a2 2 0 0 0-2-2"
  })), _path2$2j || (_path2$2j = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "m13.575 13.691 5.567-5.656a.2.2 0 0 0 .058-.14V5a.2.2 0 0 0-.2-.2H5a.2.2 0 0 0-.2.2v2.895a.2.2 0 0 0 .057.14l5.568 5.656V21c0 .11.09.2.2.2h2.75a.2.2 0 0 0 .2-.2zm1.8.738 5.05-5.13A2 2 0 0 0 21 7.894V5a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v2.895a2 2 0 0 0 .575 1.403l5.05 5.13V21a2 2 0 0 0 2 2h2.75a2 2 0 0 0 2-2z",
    clipRule: "evenodd"
  })));
};
var FilterFilled24 = (/* unused pure expression or super */ null && (SvgFilterFilled24));

var _path$6B, _path2$2i;
function _extends$6H() { _extends$6H = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$6H.apply(this, arguments); }
var SvgFilterFilled32 = function SvgFilterFilled32(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$6H({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _path$6B || (_path$6B = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M25.333 4H6.667A2.667 2.667 0 0 0 4 6.667v3.86c0 .7.275 1.372.766 1.87l6.734 6.841V28a2.667 2.667 0 0 0 2.667 2.667h3.666A2.667 2.667 0 0 0 20.5 28v-8.762l6.734-6.84c.49-.5.766-1.171.766-1.871v-3.86A2.667 2.667 0 0 0 25.333 4"
  })), _path2$2i || (_path2$2i = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "m18.1 18.255 7.423-7.541a.27.27 0 0 0 .077-.187v-3.86a.267.267 0 0 0-.267-.267H6.667a.267.267 0 0 0-.267.267v3.86c0 .07.028.137.077.187l7.423 7.541V28c0 .147.12.267.267.267h3.666c.148 0 .267-.12.267-.267zm2.4.983 6.734-6.84c.49-.5.766-1.171.766-1.871v-3.86A2.667 2.667 0 0 0 25.333 4H6.667A2.667 2.667 0 0 0 4 6.667v3.86c0 .7.275 1.372.766 1.87l6.734 6.841V28a2.667 2.667 0 0 0 2.667 2.667h3.666A2.667 2.667 0 0 0 20.5 28z",
    clipRule: "evenodd"
  })));
};
var FilterFilled32 = (/* unused pure expression or super */ null && (SvgFilterFilled32));

var _path$6A, _path2$2h;
function _extends$6G() { _extends$6G = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$6G.apply(this, arguments); }
var SvgFilterFilled48 = function SvgFilterFilled48(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$6G({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none"
  }, props), _path$6A || (_path$6A = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M39 4H9a3 3 0 0 0-3 3v7.61a2 2 0 0 0 .575 1.402L17.25 26.857V41a3 3 0 0 0 3 3h7.5a3 3 0 0 0 3-3V26.857l10.675-10.845A2 2 0 0 0 42 14.61V7a3 3 0 0 0-3-3"
  })), _path2$2h || (_path2$2h = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M28.35 25.874 39.6 14.446V7a.6.6 0 0 0-.6-.6H9a.6.6 0 0 0-.6.6v7.445l11.25 11.43V41a.6.6 0 0 0 .6.6h7.5a.6.6 0 0 0 .6-.6zm2.4.983 10.675-10.845A2 2 0 0 0 42 14.61V7a3 3 0 0 0-3-3H9a3 3 0 0 0-3 3v7.61a2 2 0 0 0 .575 1.402L17.25 26.857V41a3 3 0 0 0 3 3h7.5a3 3 0 0 0 3-3z",
    clipRule: "evenodd"
  })));
};
var FilterFilled48 = (/* unused pure expression or super */ null && (SvgFilterFilled48));

var FilterFilledIcon = function FilterFilledIcon(props) {
  var filterFilled = {
    12: FilterFilled12,
    16: FilterFilled16,
    18: FilterFilled18,
    24: FilterFilled24,
    32: FilterFilled32,
    48: FilterFilled48
  };
  return jsx(IconTemplate, _assign({
    icons: filterFilled
  }, props));
};

var _path$6z, _path2$2g, _path3$b;
function _extends$6F() { _extends$6F = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$6F.apply(this, arguments); }
var SvgFilterNew12 = function SvgFilterNew12(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$6F({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none"
  }, props), _path$6z || (_path$6z = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M11.15 4.25a.6.6 0 0 1-.6.6H5.8a.6.6 0 0 1 0-1.2h4.75a.6.6 0 0 1 .6.6M3.85 4.25a.6.6 0 0 1-.6.6h-1.8a.6.6 0 0 1 0-1.2h1.8a.6.6 0 0 1 .6.6",
    clipRule: "evenodd"
  })), _path2$2g || (_path2$2g = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M4.65 4.8a.55.55 0 1 0 0-1.1.55.55 0 0 0 0 1.1m0 1.2a1.75 1.75 0 1 0 0-3.5 1.75 1.75 0 0 0 0 3.5M11.15 7.75a.6.6 0 0 1-.6.6H9a.6.6 0 0 1 0-1.2h1.55a.6.6 0 0 1 .6.6M6.85 7.75a.6.6 0 0 1-.6.6h-4.8a.6.6 0 0 1 0-1.2h4.8a.6.6 0 0 1 .6.6",
    clipRule: "evenodd"
  })), _path3$b || (_path3$b = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M7.45 8.3a.55.55 0 1 0 0-1.1.55.55 0 0 0 0 1.1m0 1.2a1.75 1.75 0 1 0 0-3.5 1.75 1.75 0 0 0 0 3.5",
    clipRule: "evenodd"
  })));
};
var FilterNew12 = (/* unused pure expression or super */ null && (SvgFilterNew12));

var _path$6y, _path2$2f, _path3$a;
function _extends$6E() { _extends$6E = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$6E.apply(this, arguments); }
var SvgFilterNew16 = function SvgFilterNew16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$6E({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path$6y || (_path$6y = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M14.867 5.667a.8.8 0 0 1-.8.8H7.733a.8.8 0 0 1 0-1.6h6.334a.8.8 0 0 1 .8.8M5.133 5.667a.8.8 0 0 1-.8.8h-2.4a.8.8 0 0 1 0-1.6h2.4a.8.8 0 0 1 .8.8",
    clipRule: "evenodd"
  })), _path2$2f || (_path2$2f = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M6.03 6.3a.7.7 0 1 0 0-1.4.7.7 0 0 0 0 1.4m0 1.6a2.3 2.3 0 1 0 0-4.6 2.3 2.3 0 0 0 0 4.6M14.867 10.333a.8.8 0 0 1-.8.8H12a.8.8 0 1 1 0-1.6h2.067a.8.8 0 0 1 .8.8M9.133 10.333a.8.8 0 0 1-.8.8h-6.4a.8.8 0 1 1 0-1.6h6.4a.8.8 0 0 1 .8.8",
    clipRule: "evenodd"
  })), _path3$a || (_path3$a = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M9.97 11a.7.7 0 1 0 0-1.4.7.7 0 0 0 0 1.4m0 1.6a2.3 2.3 0 1 0 0-4.6 2.3 2.3 0 0 0 0 4.6",
    clipRule: "evenodd"
  })));
};
var FilterNew16 = (/* unused pure expression or super */ null && (SvgFilterNew16));

var _path$6x;
function _extends$6D() { _extends$6D = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$6D.apply(this, arguments); }
var SvgFilterNew18 = function SvgFilterNew18(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$6D({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _path$6x || (_path$6x = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M9.092 7.175a2.438 2.438 0 0 1-4.459 0H2.175a.8.8 0 0 1 0-1.6h2.328a2.439 2.439 0 0 1 4.72 0h6.602a.8.8 0 0 1 0 1.6zM7.7 6.188a.837.837 0 1 1-1.675 0 .837.837 0 0 1 1.675 0M13.428 12.422a2.438 2.438 0 0 1-4.58.003H2.175a.8.8 0 0 1 0-1.6H8.82a2.439 2.439 0 0 1 4.633.002l.046-.002h2.325a.8.8 0 1 1 0 1.6H13.5zm-1.453-.835a.838.838 0 1 1-1.675 0 .838.838 0 0 1 1.675 0",
    clipRule: "evenodd"
  })));
};
var FilterNew18 = (/* unused pure expression or super */ null && (SvgFilterNew18));

var _path$6w, _path2$2e, _path3$9;
function _extends$6C() { _extends$6C = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$6C.apply(this, arguments); }
var SvgFilterNew24 = function SvgFilterNew24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$6C({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path$6w || (_path$6w = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M22 8.5a.9.9 0 0 1-.9.9h-9.5a.9.9 0 1 1 0-1.8h9.5a.9.9 0 0 1 .9.9M7.4 8.5a.9.9 0 0 1-.9.9H2.9a.9.9 0 1 1 0-1.8h3.6a.9.9 0 0 1 .9.9",
    clipRule: "evenodd"
  })), _path2$2e || (_path2$2e = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M9.15 9.7a1.45 1.45 0 1 0 0-2.9 1.45 1.45 0 0 0 0 2.9m0 1.8a3.25 3.25 0 1 0 0-6.5 3.25 3.25 0 0 0 0 6.5M22 15.5a.9.9 0 0 1-.9.9H18a.9.9 0 1 1 0-1.8h3.1a.9.9 0 0 1 .9.9M13.4 15.5a.9.9 0 0 1-.9.9H2.9a.9.9 0 1 1 0-1.8h9.6a.9.9 0 0 1 .9.9",
    clipRule: "evenodd"
  })), _path3$9 || (_path3$9 = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M14.85 16.9a1.45 1.45 0 1 0 0-2.9 1.45 1.45 0 0 0 0 2.9m0 1.8a3.25 3.25 0 1 0 0-6.5 3.25 3.25 0 0 0 0 6.5",
    clipRule: "evenodd"
  })));
};
var FilterNew24 = (/* unused pure expression or super */ null && (SvgFilterNew24));

var _path$6v, _path2$2d, _path3$8;
function _extends$6B() { _extends$6B = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$6B.apply(this, arguments); }
var SvgFilterNew32 = function SvgFilterNew32(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$6B({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _path$6v || (_path$6v = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M29.134 11.333a1 1 0 0 1-1 1H15.467a1 1 0 1 1 0-2h12.667a1 1 0 0 1 1 1M9.667 11.333a1 1 0 0 1-1 1h-4.8a1 1 0 1 1 0-2h4.8a1 1 0 0 1 1 1",
    clipRule: "evenodd"
  })), _path2$2d || (_path2$2d = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M12.2 13.333a2.333 2.333 0 1 0 0-4.666 2.333 2.333 0 0 0 0 4.666m0 2a4.333 4.333 0 1 0 0-8.666 4.333 4.333 0 0 0 0 8.666M29.133 20.667a1 1 0 0 1-1 1H24a1 1 0 1 1 0-2h4.133a1 1 0 0 1 1 1M17.667 20.667a1 1 0 0 1-1 1h-12.8a1 1 0 1 1 0-2h12.8a1 1 0 0 1 1 1",
    clipRule: "evenodd"
  })), _path3$8 || (_path3$8 = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M19.8 22.933a2.333 2.333 0 1 0 0-4.666 2.333 2.333 0 0 0 0 4.666m0 2a4.333 4.333 0 1 0 0-8.666 4.333 4.333 0 0 0 0 8.666",
    clipRule: "evenodd"
  })));
};
var FilterNew32 = (/* unused pure expression or super */ null && (SvgFilterNew32));

var _path$6u, _path2$2c, _path3$7;
function _extends$6A() { _extends$6A = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$6A.apply(this, arguments); }
var SvgFilterNew48 = function SvgFilterNew48(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$6A({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none"
  }, props), _path$6u || (_path$6u = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M43.4 17a1.2 1.2 0 0 1-1.2 1.2H24a1.2 1.2 0 0 1 0-2.4h18.2a1.2 1.2 0 0 1 1.2 1.2M14.2 17a1.2 1.2 0 0 1-1.2 1.2H5.8a1.2 1.2 0 0 1 0-2.4H13a1.2 1.2 0 0 1 1.2 1.2",
    clipRule: "evenodd"
  })), _path2$2c || (_path2$2c = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M18.3 20.6a4.1 4.1 0 1 0 0-8.2 4.1 4.1 0 0 0 0 8.2m0 2.4a6.5 6.5 0 1 0 0-13 6.5 6.5 0 0 0 0 13M43.4 31a1.2 1.2 0 0 1-1.2 1.2H36a1.2 1.2 0 0 1 0-2.4h6.2a1.2 1.2 0 0 1 1.2 1.2M24.7 31a1.2 1.2 0 0 1-1.2 1.2H5.8a1.2 1.2 0 0 1 0-2.4h17.7a1.2 1.2 0 0 1 1.2 1.2",
    clipRule: "evenodd"
  })), _path3$7 || (_path3$7 = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M29.7 35a4.1 4.1 0 1 0 0-8.2 4.1 4.1 0 0 0 0 8.2m0 2.4a6.5 6.5 0 1 0 0-13 6.5 6.5 0 0 0 0 13",
    clipRule: "evenodd"
  })));
};
var FilterNew48 = (/* unused pure expression or super */ null && (SvgFilterNew48));

var FilterNewIcon = function FilterNewIcon(props) {
  var filterNew = {
    12: FilterNew12,
    16: FilterNew16,
    18: FilterNew18,
    24: FilterNew24,
    32: FilterNew32,
    48: FilterNew48
  };
  return jsx(IconTemplate, _assign({
    icons: filterNew
  }, props));
};

var _path$6t;
function _extends$6z() { _extends$6z = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$6z.apply(this, arguments); }
var SvgHeart12 = function SvgHeart12(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$6z({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none"
  }, props), _path$6t || (_path$6t = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M2.296 3.274c-.257.296-.446.736-.446 1.36 0 .592.234 1.196.639 1.794.404.596.954 1.151 1.523 1.632A14.5 14.5 0 0 0 6 9.459q.172-.1.421-.257c.43-.272 1-.663 1.567-1.142.57-.48 1.12-1.036 1.523-1.632.404-.598.639-1.202.639-1.794 0-.624-.189-1.064-.447-1.36a1.7 1.7 0 0 0-1.025-.55 1.99 1.99 0 0 0-2.13 1.17.6.6 0 0 1-1.096 0 1.99 1.99 0 0 0-2.13-1.17c-.402.062-.765.25-1.026.55M6 10.148l-.28.53h-.002l-.004-.003-.012-.006-.044-.024-.16-.09a15.656 15.656 0 0 1-2.26-1.578C2.62 8.455 1.982 7.82 1.495 7.1 1.01 6.382.65 5.545.65 4.634c0-.88.273-1.61.74-2.148a2.9 2.9 0 0 1 1.747-.948A3.2 3.2 0 0 1 6 2.555a3.2 3.2 0 0 1 2.863-1.017 2.9 2.9 0 0 1 1.746.948c.468.538.74 1.268.74 2.148 0 .911-.358 1.748-.844 2.466-.487.72-1.125 1.355-1.743 1.877a15.7 15.7 0 0 1-2.42 1.668l-.044.024-.013.006-.003.002H6.28s-.001.001-.281-.53m0 0 .28.53a.6.6 0 0 1-.56 0z",
    clipRule: "evenodd"
  })));
};
var Heart12 = (/* unused pure expression or super */ null && (SvgHeart12));

var _path$6s;
function _extends$6y() { _extends$6y = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$6y.apply(this, arguments); }
var SvgHeart16 = function SvgHeart16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$6y({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path$6s || (_path$6s = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M3.024 4.332c-.352.405-.607 1.004-.607 1.846 0 .803.317 1.618.86 2.42.542.8 1.279 1.544 2.04 2.187A19.3 19.3 0 0 0 8 12.67a19.32 19.32 0 0 0 2.683-1.885c.76-.643 1.498-1.386 2.04-2.187.542-.802.86-1.617.86-2.42 0-.842-.255-1.44-.607-1.846a2.3 2.3 0 0 0-1.397-.75A2.705 2.705 0 0 0 8.684 5.17a.75.75 0 0 1-1.368 0A2.705 2.705 0 0 0 4.42 3.582a2.3 2.3 0 0 0-1.397.75M8 13.53l-.35.663h-.003l-.004-.003-.017-.01a11 11 0 0 1-.271-.15 20.809 20.809 0 0 1-3.006-2.098c-.822-.695-1.668-1.539-2.314-2.493C1.39 8.487.917 7.38.917 6.18c0-1.164.36-2.124.975-2.831A3.8 3.8 0 0 1 4.19 2.1 4.22 4.22 0 0 1 8 3.481a4.22 4.22 0 0 1 3.81-1.383 3.8 3.8 0 0 1 2.297 1.249c.616.707.976 1.667.976 2.83 0 1.202-.474 2.309-1.118 3.261-.646.954-1.493 1.798-2.315 2.492a21 21 0 0 1-3.277 2.25l-.016.009-.005.002h-.001s-.001.001-.351-.662m0 0 .35.663a.75.75 0 0 1-.7 0z",
    clipRule: "evenodd"
  })));
};
var Heart16 = (/* unused pure expression or super */ null && (SvgHeart16));

var _path$6r;
function _extends$6x() { _extends$6x = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$6x.apply(this, arguments); }
var SvgHeart18 = function SvgHeart18(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$6x({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _path$6r || (_path$6r = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M3.37 4.845c-.404.464-.695 1.149-.695 2.106 0 .914.362 1.84.976 2.747.613.905 1.445 1.744 2.303 2.468A22 22 0 0 0 9 14.304a21.774 21.774 0 0 0 3.046-2.138c.859-.724 1.69-1.563 2.303-2.468.614-.907.976-1.833.976-2.747 0-.957-.29-1.642-.694-2.106a2.63 2.63 0 0 0-1.598-.859A3.09 3.09 0 0 0 9.73 5.8a.8.8 0 0 1-1.46 0 3.09 3.09 0 0 0-3.303-1.813 2.63 2.63 0 0 0-1.597.859M9 15.22l-.374.708-.002-.002-.005-.002-.018-.01a11 11 0 0 1-.305-.17 23.368 23.368 0 0 1-3.375-2.356c-.922-.78-1.872-1.726-2.595-2.795-.722-1.067-1.25-2.303-1.25-3.643 0-1.3.402-2.369 1.086-3.156a4.23 4.23 0 0 1 2.559-1.39A4.7 4.7 0 0 1 9 3.985a4.7 4.7 0 0 1 4.279-1.58 4.23 4.23 0 0 1 2.558 1.39c.685.787 1.087 1.857 1.087 3.156 0 1.34-.528 2.576-1.25 3.644-.724 1.068-1.673 2.015-2.596 2.794a23.4 23.4 0 0 1-3.68 2.526l-.018.01-.005.002-.001.001zm0 0 .374.708a.8.8 0 0 1-.748 0z",
    clipRule: "evenodd"
  })));
};
var Heart18 = (/* unused pure expression or super */ null && (SvgHeart18));

var _path$6q;
function _extends$6w() { _extends$6w = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$6w.apply(this, arguments); }
var SvgHeart24 = function SvgHeart24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$6w({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path$6q || (_path$6q = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M4.367 6.35c-.568.653-.967 1.606-.967 2.917 0 1.265.5 2.531 1.33 3.757.828 1.223 1.95 2.353 3.1 3.325A29 29 0 0 0 12 19.265c.248-.143.592-.348 1.003-.608.867-.549 2.02-1.34 3.166-2.308 1.151-.972 2.273-2.102 3.101-3.325.83-1.226 1.33-2.492 1.33-3.757 0-1.311-.399-2.264-.966-2.917-.573-.659-1.364-1.065-2.231-1.2a4.28 4.28 0 0 0-4.582 2.513.9.9 0 0 1-1.642 0A4.28 4.28 0 0 0 6.597 5.15c-.867.135-1.657.541-2.23 1.2M12 20.295l-.42.796-.003-.002-.007-.003-.024-.013a14 14 0 0 1-.401-.224 31.003 31.003 0 0 1-4.475-3.124c-1.225-1.034-2.478-2.285-3.43-3.692-.953-1.407-1.64-3.022-1.64-4.766 0-1.696.525-3.082 1.408-4.098.879-1.01 2.068-1.603 3.312-1.798 2.022-.315 4.256.419 5.68 2.203 1.424-1.784 3.658-2.518 5.68-2.203 1.245.195 2.433.788 3.312 1.798.883 1.016 1.408 2.402 1.408 4.098 0 1.744-.687 3.36-1.639 4.766-.953 1.407-2.206 2.658-3.43 3.691a31 31 0 0 1-4.877 3.35l-.024.012-.007.003-.002.001zm0 0 .42.796a.9.9 0 0 1-.84 0z"
  })));
};
var Heart24 = (/* unused pure expression or super */ null && (SvgHeart24));

var _path$6p;
function _extends$6v() { _extends$6v = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$6v.apply(this, arguments); }
var SvgHeart32 = function SvgHeart32(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$6v({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _path$6p || (_path$6p = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M4.942 7.873C4.086 8.857 3.5 10.278 3.5 12.2c0 1.87.74 3.725 1.938 5.494 1.196 1.768 2.81 3.392 4.457 4.783a42 42 0 0 0 4.53 3.302A40 40 0 0 0 16 26.73l.083-.047c.358-.206.873-.51 1.491-.901a42 42 0 0 0 4.53-3.303c1.648-1.39 3.262-3.015 4.459-4.783 1.197-1.77 1.937-3.623 1.937-5.494 0-1.923-.586-3.344-1.442-4.328-.862-.991-2.047-1.597-3.337-1.799-2.597-.405-5.51.838-6.809 3.734a1 1 0 0 1-1.824 0c-1.3-2.896-4.212-4.139-6.809-3.734-1.29.202-2.475.808-3.337 1.799M16 27.872l-.467.884-.004-.002-.009-.005-.032-.017-.12-.066q-.159-.085-.445-.25c-.38-.217-.92-.536-1.567-.946a44 44 0 0 1-4.751-3.464c-1.728-1.459-3.489-3.218-4.824-5.19-1.333-1.97-2.281-4.212-2.281-6.615 0-2.35.726-4.253 1.933-5.64 1.2-1.382 2.828-2.196 4.538-2.463 2.887-.45 6.086.654 8.029 3.315 1.943-2.661 5.142-3.765 8.03-3.315 1.709.267 3.336 1.081 4.537 2.462 1.207 1.388 1.933 3.29 1.933 5.641 0 2.403-.948 4.645-2.281 6.615-1.335 1.972-3.096 3.731-4.824 5.19a44 44 0 0 1-4.75 3.464 42 42 0 0 1-2.012 1.197l-.12.065-.033.017-.01.005-.003.002zm0 0 .467.884a1 1 0 0 1-.934 0z"
  })));
};
var Heart32 = (/* unused pure expression or super */ null && (SvgHeart32));

var _path$6o;
function _extends$6u() { _extends$6u = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$6u.apply(this, arguments); }
var SvgHeart48 = function SvgHeart48(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$6u({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none"
  }, props), _path$6o || (_path$6o = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M8.28 12.307c-1.24 1.427-2.08 3.477-2.08 6.228 0 2.688 1.063 5.337 2.763 7.848 1.698 2.51 3.985 4.81 6.311 6.774 2.322 1.96 4.65 3.557 6.4 4.665A56 56 0 0 0 24 39.22l.22-.125c.506-.29 1.233-.72 2.107-1.273 1.75-1.108 4.077-2.705 6.399-4.665 2.326-1.964 4.613-4.265 6.312-6.774 1.7-2.51 2.762-5.16 2.762-7.848 0-2.751-.84-4.801-2.08-6.228-1.248-1.435-2.962-2.31-4.822-2.6-3.738-.583-7.933 1.206-9.803 5.374a1.2 1.2 0 0 1-2.19 0c-1.87-4.168-6.065-5.957-9.803-5.374-1.86.29-3.574 1.165-4.821 2.6M24 40.59l-.56 1.061-.006-.003-.012-.006-.045-.024-.168-.091q-.22-.12-.622-.35a59 59 0 0 1-2.198-1.328c-1.812-1.147-4.235-2.808-6.663-4.858-2.424-2.047-4.887-4.508-6.751-7.262C5.112 24.977 3.8 21.862 3.8 18.535c0-3.264 1.008-5.892 2.67-7.803 1.654-1.903 3.9-3.027 6.262-3.396 4.076-.636 8.601.969 11.268 4.818 2.667-3.85 7.192-5.454 11.268-4.818 2.363.369 4.608 1.493 6.263 3.396 1.661 1.911 2.67 4.539 2.67 7.803 0 3.327-1.313 6.442-3.176 9.194-1.864 2.754-4.327 5.215-6.75 7.262-2.43 2.05-4.852 3.711-6.664 4.858a59 59 0 0 1-2.198 1.328 39 39 0 0 1-.79.44l-.045.025-.012.006-.005.003zm0 0 .56 1.061c-.35.185-.77.185-1.12 0z",
    clipRule: "evenodd"
  })));
};
var Heart48 = (/* unused pure expression or super */ null && (SvgHeart48));

var HeartIcon = function HeartIcon(props) {
  var heart = {
    12: Heart12,
    16: Heart16,
    18: Heart18,
    24: Heart24,
    32: Heart32,
    48: Heart48
  };
  return jsx(IconTemplate, _assign({
    icons: heart
  }, props));
};

var _path$6n;
function _extends$6t() { _extends$6t = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$6t.apply(this, arguments); }
var SvgHeartFilled12 = function SvgHeartFilled12(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$6t({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none"
  }, props), _path$6n || (_path$6n = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "m6 10.148-.21.397h-.002l-.003-.002-.012-.006a5 5 0 0 1-.2-.113 15.503 15.503 0 0 1-2.237-1.562c-.613-.516-1.24-1.142-1.716-1.846C1.144 6.313.8 5.506.8 4.634c0-.848.262-1.541.704-2.05a2.74 2.74 0 0 1 1.656-.898A3.05 3.05 0 0 1 6 2.787a3.05 3.05 0 0 1 2.84-1.101 2.74 2.74 0 0 1 1.656.899c.442.508.704 1.2.704 2.049 0 .871-.344 1.68-.82 2.382-.476.704-1.103 1.33-1.715 1.846a15.5 15.5 0 0 1-2.438 1.675l-.012.006-.003.002H6.21zm0 0 .21.398a.45.45 0 0 1-.42 0z"
  })));
};
var HeartFilled12 = (/* unused pure expression or super */ null && (SvgHeartFilled12));

var _path$6m;
function _extends$6s() { _extends$6s = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$6s.apply(this, arguments); }
var SvgHeartFilled16 = function SvgHeartFilled16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$6s({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path$6m || (_path$6m = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "m8 13.53-.28.53h-.002l-.005-.003-.015-.008-.058-.031-.21-.119a20.661 20.661 0 0 1-2.983-2.083c-.817-.689-1.652-1.522-2.288-2.461-.634-.937-1.092-2.015-1.092-3.177 0-1.13.35-2.055.939-2.732a3.65 3.65 0 0 1 2.207-1.198A4.06 4.06 0 0 1 8 3.716a4.06 4.06 0 0 1 3.787-1.468c.83.13 1.622.525 2.207 1.198.59.677.94 1.602.94 2.732 0 1.162-.459 2.24-1.093 3.177-.636.939-1.471 1.772-2.287 2.461a20.7 20.7 0 0 1-3.252 2.233l-.015.008-.005.002-.001.001zm0 0 .28.53a.6.6 0 0 1-.56 0z"
  })));
};
var HeartFilled16 = (/* unused pure expression or super */ null && (SvgHeartFilled16));

var _path$6l;
function _extends$6r() { _extends$6r = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$6r.apply(this, arguments); }
var SvgHeartFilled18 = function SvgHeartFilled18(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$6r({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _path$6l || (_path$6l = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "m9 15.221-.315.597-.002-.001-.005-.003-.018-.01-.065-.034-.236-.133a23.266 23.266 0 0 1-3.356-2.343c-.919-.776-1.859-1.714-2.574-2.77C1.716 9.47 1.2 8.258 1.2 6.95c0-1.272.394-2.311 1.056-3.073A4.1 4.1 0 0 1 4.74 2.529 4.57 4.57 0 0 1 9 4.18a4.57 4.57 0 0 1 4.26-1.652c.934.145 1.825.59 2.484 1.348.663.762 1.056 1.801 1.056 3.073 0 1.308-.515 2.52-1.23 3.574-.714 1.056-1.654 1.994-2.572 2.77a23.3 23.3 0 0 1-3.658 2.51l-.017.01-.005.003h-.002zm0 0 .315.597a.68.68 0 0 1-.63 0z"
  })));
};
var HeartFilled18 = (/* unused pure expression or super */ null && (SvgHeartFilled18));

var _path$6k;
function _extends$6q() { _extends$6q = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$6q.apply(this, arguments); }
var SvgHeartFilled24 = function SvgHeartFilled24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$6q({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path$6k || (_path$6k = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "m12 20.295-.42.796-.003-.002-.007-.003-.024-.013a14 14 0 0 1-.401-.224 31.003 31.003 0 0 1-4.475-3.124c-1.225-1.034-2.478-2.285-3.43-3.692-.953-1.407-1.64-3.022-1.64-4.766 0-1.696.525-3.082 1.408-4.098.879-1.01 2.068-1.603 3.312-1.798 2.022-.315 4.256.419 5.68 2.203 1.424-1.784 3.658-2.518 5.68-2.203 1.245.195 2.433.788 3.312 1.798.883 1.016 1.408 2.402 1.408 4.098 0 1.744-.687 3.36-1.639 4.766-.953 1.407-2.206 2.658-3.43 3.691a31 31 0 0 1-4.877 3.35l-.024.012-.007.003-.002.001zm0 0 .42.796a.9.9 0 0 1-.84 0z"
  })));
};
var HeartFilled24 = (/* unused pure expression or super */ null && (SvgHeartFilled24));

var _path$6j;
function _extends$6p() { _extends$6p = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$6p.apply(this, arguments); }
var SvgHeartFilled32 = function SvgHeartFilled32(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$6p({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _path$6j || (_path$6j = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "m16 27.872-.467.884-.004-.002-.009-.005-.032-.017-.12-.066q-.159-.085-.445-.25c-.38-.217-.92-.536-1.567-.946a44 44 0 0 1-4.751-3.464c-1.728-1.459-3.489-3.218-4.824-5.19-1.333-1.97-2.281-4.212-2.281-6.615 0-2.35.726-4.253 1.933-5.64 1.2-1.382 2.828-2.196 4.538-2.463 2.887-.45 6.086.654 8.029 3.315 1.943-2.661 5.142-3.765 8.03-3.315 1.709.267 3.336 1.081 4.537 2.462 1.207 1.388 1.933 3.29 1.933 5.641 0 2.403-.948 4.645-2.281 6.615-1.335 1.972-3.096 3.731-4.824 5.19a44 44 0 0 1-4.75 3.464 42 42 0 0 1-2.012 1.197l-.12.065-.033.017-.01.005-.003.002zm0 0 .467.884a1 1 0 0 1-.934 0z",
    clipRule: "evenodd"
  })));
};
var HeartFilled32 = (/* unused pure expression or super */ null && (SvgHeartFilled32));

var _path$6i;
function _extends$6o() { _extends$6o = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$6o.apply(this, arguments); }
var SvgHeartFilled48 = function SvgHeartFilled48(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$6o({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none"
  }, props), _path$6i || (_path$6i = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "m24 41.808-.7 1.326-.006-.003-.014-.007-.049-.026-.18-.098a41 41 0 0 1-.667-.375 63 63 0 0 1-2.35-1.42c-1.938-1.226-4.528-3.003-7.127-5.196-2.592-2.188-5.233-4.826-7.235-7.785-2-2.955-3.422-6.318-3.422-9.922 0-3.526 1.09-6.38 2.9-8.461 1.8-2.072 4.242-3.293 6.806-3.693 4.331-.676 9.13.98 12.044 4.971 2.914-3.99 7.713-5.647 12.044-4.971 2.564.4 5.005 1.621 6.807 3.693 1.81 2.081 2.899 4.935 2.899 8.46 0 3.605-1.422 6.968-3.422 9.923-2.002 2.959-4.643 5.597-7.235 7.785-2.599 2.193-5.19 3.97-7.127 5.196a63 63 0 0 1-2.35 1.42 41 41 0 0 1-.847.473l-.05.026-.013.007-.005.003zm0 0 .7 1.326a1.5 1.5 0 0 1-1.4 0z",
    clipRule: "evenodd"
  })));
};
var HeartFilled48 = (/* unused pure expression or super */ null && (SvgHeartFilled48));

var HeartFilledIcon = function HeartFilledIcon(props) {
  var heartFilled = {
    12: HeartFilled12,
    16: HeartFilled16,
    18: HeartFilled18,
    24: HeartFilled24,
    32: HeartFilled32,
    48: HeartFilled48
  };
  return jsx(IconTemplate, _assign({
    icons: heartFilled
  }, props));
};

var _path$6h;
function _extends$6n() { _extends$6n = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$6n.apply(this, arguments); }
var SvgHome12 = function SvgHome12(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$6n({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none"
  }, props), _path$6h || (_path$6h = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M6.375.782a.6.6 0 0 0-.75 0l-4.75 3.8a.6.6 0 0 0 .725.955V8.85c0 1.118.907 2.025 2.025 2.025H5.05a.6.6 0 0 0 .6-.6v-2.85a.35.35 0 1 1 .7 0v2.85a.6.6 0 0 0 .6.6h1.425A2.025 2.025 0 0 0 10.4 8.85V5.537a.6.6 0 0 0 .725-.955zM9.2 4.578 6 2.018l-3.2 2.56V8.85c0 .456.37.825.825.825h.825v-2.25a1.55 1.55 0 0 1 3.1 0v2.25h.825c.456 0 .825-.37.825-.825z",
    clipRule: "evenodd"
  })));
};
var Home12 = (/* unused pure expression or super */ null && (SvgHome12));

var _path$6g;
function _extends$6m() { _extends$6m = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$6m.apply(this, arguments); }
var SvgHome16 = function SvgHome16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$6m({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path$6g || (_path$6g = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M8.469 1.081a.75.75 0 0 0-.937 0L1.198 6.148a.75.75 0 0 0 .937 1.17l.048-.038v4.52a2.65 2.65 0 0 0 2.65 2.65h1.9a.75.75 0 0 0 .75-.75V9.9a.517.517 0 1 1 1.034 0v3.8c0 .414.336.75.75.75h1.9a2.65 2.65 0 0 0 2.65-2.65V7.28l.048.039a.75.75 0 0 0 .937-1.171zm3.848 5L8 2.626 3.683 6.08v5.72c0 .635.515 1.15 1.15 1.15h1.15V9.9a2.017 2.017 0 0 1 4.034 0v3.05h1.15a1.15 1.15 0 0 0 1.15-1.15z",
    clipRule: "evenodd"
  })));
};
var Home16 = (/* unused pure expression or super */ null && (SvgHome16));

var _path$6f;
function _extends$6l() { _extends$6l = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$6l.apply(this, arguments); }
var SvgHome18 = function SvgHome18(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$6l({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _path$6f || (_path$6f = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M9.5 1.25a.8.8 0 0 0-1 0l-7.125 5.7a.8.8 0 0 0 1 1.25l.125-.1v5.175a2.937 2.937 0 0 0 2.937 2.937h2.138a.8.8 0 0 0 .8-.8v-4.275a.625.625 0 0 1 1.25 0v4.275a.8.8 0 0 0 .8.8h2.137a2.937 2.937 0 0 0 2.938-2.937V8.099l.125.1a.8.8 0 0 0 1-1.249zm4.4 5.57L9 2.9 4.1 6.82v6.455c0 .739.599 1.337 1.337 1.337h1.338v-3.475a2.225 2.225 0 0 1 4.45 0v3.475h1.338c.738 0 1.337-.598 1.337-1.337z",
    clipRule: "evenodd"
  })));
};
var Home18 = (/* unused pure expression or super */ null && (SvgHome18));

var _path$6e;
function _extends$6k() { _extends$6k = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$6k.apply(this, arguments); }
var SvgHome24 = function SvgHome24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$6k({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path$6e || (_path$6e = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M12.562 1.797a.9.9 0 0 0-1.125 0l-9.5 7.6a.9.9 0 1 0 1.125 1.406l.438-.35V17.7a3.75 3.75 0 0 0 3.75 3.75h2.85a.9.9 0 0 0 .9-.9v-5.7a1 1 0 1 1 2 0v5.7a.9.9 0 0 0 .9.9h2.85a3.75 3.75 0 0 0 3.75-3.75v-7.248l.437.35a.9.9 0 0 0 1.125-1.405zM18.7 9.012 12 3.652l-6.7 5.36V17.7a1.95 1.95 0 0 0 1.95 1.95H9.2v-4.8a2.8 2.8 0 1 1 5.6 0v4.8h1.95a1.95 1.95 0 0 0 1.95-1.95z",
    clipRule: "evenodd"
  })));
};
var Home24 = (/* unused pure expression or super */ null && (SvgHome24));

var _path$6d;
function _extends$6j() { _extends$6j = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$6j.apply(this, arguments); }
var SvgHome32 = function SvgHome32(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$6j({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _path$6d || (_path$6d = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M16.625 2.553a1 1 0 0 0-1.25 0L2.71 12.686a1 1 0 0 0 1.249 1.562l.909-.727V23.6a4.8 4.8 0 0 0 4.8 4.8h3.8a1 1 0 0 0 1-1v-7.6a1.533 1.533 0 0 1 3.066 0v7.6a1 1 0 0 0 1 1h3.8a4.8 4.8 0 0 0 4.8-4.8V13.52l.909.728a1 1 0 1 0 1.25-1.562zm8.508 9.368L16 4.614l-9.133 7.307V23.6a2.8 2.8 0 0 0 2.8 2.8h2.8v-6.6a3.533 3.533 0 1 1 7.066 0v6.6h2.8a2.8 2.8 0 0 0 2.8-2.8z",
    clipRule: "evenodd"
  })));
};
var Home32 = (/* unused pure expression or super */ null && (SvgHome32));

var _path$6c;
function _extends$6i() { _extends$6i = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$6i.apply(this, arguments); }
var SvgHome48 = function SvgHome48(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$6i({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none"
  }, props), _path$6c || (_path$6c = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M24.75 4.063a1.2 1.2 0 0 0-1.5 0l-19 15.2a1.2 1.2 0 0 0 1.5 1.874l1.85-1.48V35.4a6.9 6.9 0 0 0 6.9 6.9h5.7a1.2 1.2 0 0 0 1.2-1.2V29.7a2.6 2.6 0 1 1 5.2 0v11.4a1.2 1.2 0 0 0 1.2 1.2h5.7a6.9 6.9 0 0 0 6.9-6.9V19.657l1.85 1.48a1.2 1.2 0 1 0 1.5-1.874zM38 17.737l-14-11.2-14 11.2V35.4a4.5 4.5 0 0 0 4.5 4.5H19V29.7a5 5 0 1 1 10 0v10.2h4.5a4.5 4.5 0 0 0 4.5-4.5z",
    clipRule: "evenodd"
  })));
};
var Home48 = (/* unused pure expression or super */ null && (SvgHome48));

var HomeIcon = function HomeIcon(props) {
  var home = {
    12: Home12,
    16: Home16,
    18: Home18,
    24: Home24,
    32: Home32,
    48: Home48
  };
  return jsx(IconTemplate, _assign({
    icons: home
  }, props));
};

var _path$6b;
function _extends$6h() { _extends$6h = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$6h.apply(this, arguments); }
var SvgHomeFilled12 = function SvgHomeFilled12(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$6h({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none"
  }, props), _path$6b || (_path$6b = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M6.375.782a.6.6 0 0 0-.75 0l-4.75 3.8a.6.6 0 0 0 .725.955V8.85c0 1.118.907 2.025 2.025 2.025H5.05a.6.6 0 0 0 .6-.6v-2.85a.35.35 0 1 1 .7 0v2.85a.6.6 0 0 0 .6.6h1.425A2.025 2.025 0 0 0 10.4 8.85V5.537a.6.6 0 0 0 .725-.955z"
  })));
};
var HomeFilled12 = (/* unused pure expression or super */ null && (SvgHomeFilled12));

var _path$6a;
function _extends$6g() { _extends$6g = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$6g.apply(this, arguments); }
var SvgHomeFilled16 = function SvgHomeFilled16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$6g({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path$6a || (_path$6a = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M8.469 1.081a.75.75 0 0 0-.937 0L1.198 6.148a.75.75 0 0 0 .937 1.17l.048-.038v4.52a2.65 2.65 0 0 0 2.65 2.65h1.9a.75.75 0 0 0 .75-.75V9.9a.517.517 0 1 1 1.034 0v3.8c0 .414.336.75.75.75h1.9a2.65 2.65 0 0 0 2.65-2.65V7.28l.048.039a.75.75 0 0 0 .937-1.171z",
    clipRule: "evenodd"
  })));
};
var HomeFilled16 = (/* unused pure expression or super */ null && (SvgHomeFilled16));

var _path$69;
function _extends$6f() { _extends$6f = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$6f.apply(this, arguments); }
var SvgHomeFilled18 = function SvgHomeFilled18(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$6f({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _path$69 || (_path$69 = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M9.5 1.25a.8.8 0 0 0-1 0l-7.125 5.7a.8.8 0 1 0 1 1.25l.125-.1v5.175a2.937 2.937 0 0 0 2.938 2.937h2.137a.8.8 0 0 0 .8-.8v-4.275a.625.625 0 0 1 1.25 0v4.275a.8.8 0 0 0 .8.8h2.138a2.937 2.937 0 0 0 2.937-2.937V8.099l.126.1a.8.8 0 1 0 .999-1.249z"
  })));
};
var HomeFilled18 = (/* unused pure expression or super */ null && (SvgHomeFilled18));

var _path$68;
function _extends$6e() { _extends$6e = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$6e.apply(this, arguments); }
var SvgHomeFilled24 = function SvgHomeFilled24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$6e({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path$68 || (_path$68 = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M12.562 1.798a.9.9 0 0 0-1.125 0l-9.5 7.6a.9.9 0 0 0 1.125 1.405l.438-.35v7.098a3.9 3.9 0 0 0 3.9 3.9H10a.9.9 0 0 0 .9-.9V15a1.1 1.1 0 0 1 2.2 0v5.55a.9.9 0 0 0 .9.9h2.6a3.9 3.9 0 0 0 3.9-3.9v-7.098l.437.35a.9.9 0 0 0 1.125-1.405z"
  })));
};
var HomeFilled24 = (/* unused pure expression or super */ null && (SvgHomeFilled24));

var _path$67;
function _extends$6d() { _extends$6d = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$6d.apply(this, arguments); }
var SvgHomeFilled32 = function SvgHomeFilled32(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$6d({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _path$67 || (_path$67 = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M16.625 2.553a1 1 0 0 0-1.25 0L2.71 12.686a1 1 0 0 0 1.25 1.562l.908-.727V23.6a4.8 4.8 0 0 0 4.8 4.8h3.8a1 1 0 0 0 1-1v-7.6a1.533 1.533 0 1 1 3.066 0v7.6a1 1 0 0 0 1 1h3.8a4.8 4.8 0 0 0 4.8-4.8V13.52l.91.728a1 1 0 1 0 1.249-1.562z"
  })));
};
var HomeFilled32 = (/* unused pure expression or super */ null && (SvgHomeFilled32));

var _path$66;
function _extends$6c() { _extends$6c = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$6c.apply(this, arguments); }
var SvgHomeFilled48 = function SvgHomeFilled48(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$6c({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none"
  }, props), _path$66 || (_path$66 = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M24.75 4.063a1.2 1.2 0 0 0-1.5 0l-19 15.2a1.2 1.2 0 0 0 1.5 1.874l1.85-1.48V35.4a6.9 6.9 0 0 0 6.9 6.9h5.7a1.2 1.2 0 0 0 1.2-1.2V29.7a2.6 2.6 0 0 1 5.2 0v11.4a1.2 1.2 0 0 0 1.2 1.2h5.7a6.9 6.9 0 0 0 6.9-6.9V19.657l1.85 1.48a1.2 1.2 0 0 0 1.5-1.874z"
  })));
};
var HomeFilled48 = (/* unused pure expression or super */ null && (SvgHomeFilled48));

var HomeFilledIcon = function HomeFilledIcon(props) {
  var homeFilled = {
    12: HomeFilled12,
    16: HomeFilled16,
    18: HomeFilled18,
    24: HomeFilled24,
    32: HomeFilled32,
    48: HomeFilled48
  };
  return jsx(IconTemplate, _assign({
    icons: homeFilled
  }, props));
};

var _path$65;
function _extends$6b() { _extends$6b = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$6b.apply(this, arguments); }
var SvgInfoFilled12 = function SvgInfoFilled12(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$6b({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none"
  }, props), _path$65 || (_path$65 = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M6 11A5 5 0 1 0 6 1a5 5 0 0 0 0 10m0-2.3a.6.6 0 0 1-.6-.6v-2a.6.6 0 0 1 1.2 0v2a.6.6 0 0 1-.6.6m0-3.8a.6.6 0 0 1-.6-.6v-.05a.6.6 0 0 1 1.2 0v.05a.6.6 0 0 1-.6.6",
    clipRule: "evenodd"
  })));
};
var InfoFilled12 = (/* unused pure expression or super */ null && (SvgInfoFilled12));

var _path$64;
function _extends$6a() { _extends$6a = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$6a.apply(this, arguments); }
var SvgInfoFilled16 = function SvgInfoFilled16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$6a({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path$64 || (_path$64 = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M8 14.667A6.667 6.667 0 1 0 8 1.334a6.667 6.667 0 0 0 0 13.333M7.25 10.4a.75.75 0 0 0 1.5 0V7.6a.75.75 0 1 0-1.5 0zm0-4.8a.75.75 0 0 0 1.5 0v-.067a.75.75 0 1 0-1.5 0z",
    clipRule: "evenodd"
  })));
};
var InfoFilled16 = (/* unused pure expression or super */ null && (SvgInfoFilled16));

var _path$63;
function _extends$69() { _extends$69 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$69.apply(this, arguments); }
var SvgInfoFilled18 = function SvgInfoFilled18(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$69({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _path$63 || (_path$63 = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M9 16.5a7.5 7.5 0 1 0 0-15 7.5 7.5 0 0 0 0 15m-.8-4.7a.8.8 0 0 0 1.6 0V8.65a.8.8 0 1 0-1.6 0zm0-5.4a.8.8 0 1 0 1.6 0v-.075a.8.8 0 1 0-1.6 0z",
    clipRule: "evenodd"
  })));
};
var InfoFilled18 = (/* unused pure expression or super */ null && (SvgInfoFilled18));

var _path$62;
function _extends$68() { _extends$68 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$68.apply(this, arguments); }
var SvgInfoFilled24 = function SvgInfoFilled24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$68({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path$62 || (_path$62 = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10m-.9-6.5a.9.9 0 0 0 1.8 0v-4.2a.9.9 0 0 0-1.8 0zm0-6.7a.9.9 0 0 0 1.8 0v-.1a.9.9 0 1 0-1.8 0z",
    clipRule: "evenodd"
  })));
};
var InfoFilled24 = (/* unused pure expression or super */ null && (SvgInfoFilled24));

var _path$61;
function _extends$67() { _extends$67 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$67.apply(this, arguments); }
var SvgInfoFilled32 = function SvgInfoFilled32(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$67({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _path$61 || (_path$61 = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M16 29.333c7.363 0 13.333-5.97 13.333-13.333S23.363 2.667 15.999 2.667 2.666 8.636 2.666 16s5.97 13.333 13.333 13.333m0-7.666a1 1 0 0 1-1-1v-5.6a1 1 0 1 1 2 0v5.6a1 1 0 0 1-1 1m0-8.934a1 1 0 0 1-1-1V11.6a1 1 0 1 1 2 0v.133a1 1 0 0 1-1 1",
    clipRule: "evenodd"
  })));
};
var InfoFilled32 = (/* unused pure expression or super */ null && (SvgInfoFilled32));

var _path$60;
function _extends$66() { _extends$66 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$66.apply(this, arguments); }
var SvgInfoFilled48 = function SvgInfoFilled48(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$66({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none"
  }, props), _path$60 || (_path$60 = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M24 44c11.046 0 20-8.954 20-20S35.046 4 24 4 4 12.954 4 24s8.954 20 20 20m0-12.35c-.69 0-1.25-.56-1.25-1.25V22a1.25 1.25 0 1 1 2.5 0v8.4c0 .69-.56 1.25-1.25 1.25m0-12.8c-.69 0-1.25-.56-1.25-1.25v-.2a1.25 1.25 0 0 1 2.5 0v.2c0 .69-.56 1.25-1.25 1.25",
    clipRule: "evenodd"
  })));
};
var InfoFilled48 = (/* unused pure expression or super */ null && (SvgInfoFilled48));

var InfoFilledIcon = function InfoFilledIcon(props) {
  var infoFilled = {
    12: InfoFilled12,
    16: InfoFilled16,
    18: InfoFilled18,
    24: InfoFilled24,
    32: InfoFilled32,
    48: InfoFilled48
  };
  return jsx(IconTemplate, _assign({
    icons: infoFilled
  }, props));
};

var _path$5$, _path2$2b;
function _extends$65() { _extends$65 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$65.apply(this, arguments); }
var SvgLaunch12 = function SvgLaunch12(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$65({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none"
  }, props), _path$5$ || (_path$5$ = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M4 2.6A1.4 1.4 0 0 0 2.6 4v4A1.4 1.4 0 0 0 4 9.4h4A1.4 1.4 0 0 0 9.4 8V6.25a.6.6 0 1 1 1.2 0V8A2.6 2.6 0 0 1 8 10.6H4A2.6 2.6 0 0 1 1.4 8V4A2.6 2.6 0 0 1 4 1.4h1.75a.6.6 0 0 1 0 1.2z",
    clipRule: "evenodd"
  })), _path2$2b || (_path2$2b = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M7.15 1.5a.6.6 0 0 1 .6-.6h2.75a.6.6 0 0 1 .6.6v2.75a.6.6 0 1 1-1.2 0V2.949L6.674 6.174a.6.6 0 0 1-.848-.848L9.052 2.1H7.75a.6.6 0 0 1-.6-.6",
    clipRule: "evenodd"
  })));
};
var Launch12 = (/* unused pure expression or super */ null && (SvgLaunch12));

var _path$5_, _path2$2a;
function _extends$64() { _extends$64 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$64.apply(this, arguments); }
var SvgLaunch16 = function SvgLaunch16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$64({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path$5_ || (_path$5_ = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M5.167 3.417a1.75 1.75 0 0 0-1.75 1.75v5.666c0 .967.783 1.75 1.75 1.75h5.666a1.75 1.75 0 0 0 1.75-1.75v-2.5a.75.75 0 0 1 1.5 0v2.5a3.25 3.25 0 0 1-3.25 3.25H5.167a3.25 3.25 0 0 1-3.25-3.25V5.167a3.25 3.25 0 0 1 3.25-3.25h2.5a.75.75 0 1 1 0 1.5z",
    clipRule: "evenodd"
  })), _path2$2a || (_path2$2a = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M9.583 2a.75.75 0 0 1 .75-.75H14a.75.75 0 0 1 .75.75v3.667a.75.75 0 0 1-1.5 0V3.81L8.864 8.197a.75.75 0 0 1-1.06-1.06l4.385-4.387h-1.856a.75.75 0 0 1-.75-.75",
    clipRule: "evenodd"
  })));
};
var Launch16 = (/* unused pure expression or super */ null && (SvgLaunch16));

var _path$5Z, _path2$29;
function _extends$63() { _extends$63 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$63.apply(this, arguments); }
var SvgLaunch18 = function SvgLaunch18(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$63({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _path$5Z || (_path$5Z = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M6 3.8A2.2 2.2 0 0 0 3.8 6v6A2.2 2.2 0 0 0 6 14.2h6a2.2 2.2 0 0 0 2.2-2.2V9.375a.8.8 0 1 1 1.6 0V12a3.8 3.8 0 0 1-3.8 3.8H6A3.8 3.8 0 0 1 2.2 12V6A3.8 3.8 0 0 1 6 2.2h2.625a.8.8 0 1 1 0 1.6z",
    clipRule: "evenodd"
  })), _path2$29 || (_path2$29 = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M11.625 3.05a.8.8 0 1 1 0-1.6h4.125a.8.8 0 0 1 .8.8v4.125a.8.8 0 0 1-1.6 0V4.181l-5.01 5.01a.8.8 0 1 1-1.13-1.132l5.009-5.009z",
    clipRule: "evenodd"
  })));
};
var Launch18 = (/* unused pure expression or super */ null && (SvgLaunch18));

var _path$5Y, _path2$28;
function _extends$62() { _extends$62 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$62.apply(this, arguments); }
var SvgLaunch24 = function SvgLaunch24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$62({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path$5Y || (_path$5Y = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M8 4.9A3.1 3.1 0 0 0 4.9 8v8A3.1 3.1 0 0 0 8 19.1h8a3.1 3.1 0 0 0 3.1-3.1v-3.5a.9.9 0 1 1 1.8 0V16a4.9 4.9 0 0 1-4.9 4.9H8A4.9 4.9 0 0 1 3.1 16V8A4.9 4.9 0 0 1 8 3.1h3.5a.9.9 0 1 1 0 1.8z",
    clipRule: "evenodd"
  })), _path2$28 || (_path2$28 = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M14.6 3a.9.9 0 0 1 .9-.9H21a.9.9 0 0 1 .9.9v5.5a.9.9 0 1 1-1.8 0V5.173l-6.964 6.963a.9.9 0 0 1-1.272-1.272L18.827 3.9H15.5a.9.9 0 0 1-.9-.9",
    clipRule: "evenodd"
  })));
};
var Launch24 = (/* unused pure expression or super */ null && (SvgLaunch24));

var _path$5X, _path2$27;
function _extends$61() { _extends$61 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$61.apply(this, arguments); }
var SvgLaunch32 = function SvgLaunch32(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$61({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _path$5X || (_path$5X = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M10.333 6.333a4 4 0 0 0-4 4v11.334a4 4 0 0 0 4 4h11.334a4 4 0 0 0 4-4v-5a1 1 0 1 1 2 0v5a6 6 0 0 1-6 6H10.333a6 6 0 0 1-6-6V10.333a6 6 0 0 1 6-6h5a1 1 0 0 1 0 2z",
    clipRule: "evenodd"
  })), _path2$27 || (_path2$27 = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M19.667 4a1 1 0 0 1 1-1H28a1 1 0 0 1 1 1v7.333a1 1 0 1 1-2 0V6.414l-9.626 9.626a1 1 0 1 1-1.414-1.414L25.586 5h-4.92a1 1 0 0 1-1-1",
    clipRule: "evenodd"
  })));
};
var Launch32 = (/* unused pure expression or super */ null && (SvgLaunch32));

var _path$5W, _path2$26;
function _extends$60() { _extends$60 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$60.apply(this, arguments); }
var SvgLaunch48 = function SvgLaunch48(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$60({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none"
  }, props), _path$5W || (_path$5W = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M14 9.2A4.8 4.8 0 0 0 9.2 14v20a4.8 4.8 0 0 0 4.8 4.8h20a4.8 4.8 0 0 0 4.8-4.8v-9a1.2 1.2 0 0 1 2.4 0v9a7.2 7.2 0 0 1-7.2 7.2H14A7.2 7.2 0 0 1 6.8 34V14A7.2 7.2 0 0 1 14 6.8h9a1.2 1.2 0 1 1 0 2.4z",
    clipRule: "evenodd"
  })), _path2$26 || (_path2$26 = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M31 7.2a1.2 1.2 0 0 1 0-2.4h11A1.2 1.2 0 0 1 43.2 6v11a1.2 1.2 0 0 1-2.4 0V8.897L25.849 23.85a1.2 1.2 0 0 1-1.698-1.698l14.952-14.95z",
    clipRule: "evenodd"
  })));
};
var Launch48 = (/* unused pure expression or super */ null && (SvgLaunch48));

var LaunchIcon = function LaunchIcon(props) {
  var launch = {
    12: Launch12,
    16: Launch16,
    18: Launch18,
    24: Launch24,
    32: Launch32,
    48: Launch48
  };
  return jsx(IconTemplate, _assign({
    icons: launch
  }, props));
};

var _path$5V;
function _extends$5$() { _extends$5$ = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$5$.apply(this, arguments); }
var SvgLink12 = function SvgLink12(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$5$({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none"
  }, props), _path$5V || (_path$5V = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M.9 6a2.6 2.6 0 0 1 2.6-2.6H5a.6.6 0 0 1 0 1.2H3.5a1.4 1.4 0 0 0 0 2.8H5a.6.6 0 0 1 0 1.2H3.5A2.6 2.6 0 0 1 .9 6m5.5-2a.6.6 0 0 1 .6-.6h1.5a2.6 2.6 0 0 1 0 5.2H7a.6.6 0 1 1 0-1.2h1.5a1.4 1.4 0 1 0 0-2.8H7a.6.6 0 0 1-.6-.6M3 6a.6.6 0 0 1 .6-.6h4.8a.6.6 0 0 1 0 1.2H3.6A.6.6 0 0 1 3 6",
    clipRule: "evenodd"
  })));
};
var Link12 = (/* unused pure expression or super */ null && (SvgLink12));

var _path$5U;
function _extends$5_() { _extends$5_ = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$5_.apply(this, arguments); }
var SvgLink16 = function SvgLink16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$5_({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path$5U || (_path$5U = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M1.25 8a3.417 3.417 0 0 1 3.417-3.417h2a.75.75 0 0 1 0 1.5h-2a1.917 1.917 0 1 0 0 3.834h2a.75.75 0 0 1 0 1.5h-2A3.417 3.417 0 0 1 1.25 8m7.333-2.667a.75.75 0 0 1 .75-.75h2a3.417 3.417 0 1 1 0 6.834h-2a.75.75 0 0 1 0-1.5h2a1.917 1.917 0 1 0 0-3.834h-2a.75.75 0 0 1-.75-.75M3.917 8a.75.75 0 0 1 .75-.75h6.666a.75.75 0 0 1 0 1.5H4.667a.75.75 0 0 1-.75-.75",
    clipRule: "evenodd"
  })));
};
var Link16 = (/* unused pure expression or super */ null && (SvgLink16));

var _path$5T;
function _extends$5Z() { _extends$5Z = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$5Z.apply(this, arguments); }
var SvgLink18 = function SvgLink18(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$5Z({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _path$5T || (_path$5T = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M1.45 9a3.8 3.8 0 0 1 3.8-3.8H7.5a.8.8 0 1 1 0 1.6H5.25a2.2 2.2 0 1 0 0 4.4H7.5a.8.8 0 1 1 0 1.6H5.25A3.8 3.8 0 0 1 1.45 9M9.7 6a.8.8 0 0 1 .8-.8h2.25a3.8 3.8 0 0 1 0 7.6H10.5a.8.8 0 1 1 0-1.6h2.25a2.2 2.2 0 0 0 0-4.4H10.5a.8.8 0 0 1-.8-.8M4.45 9a.8.8 0 0 1 .8-.8h7.5a.8.8 0 0 1 0 1.6h-7.5a.8.8 0 0 1-.8-.8",
    clipRule: "evenodd"
  })));
};
var Link18 = (/* unused pure expression or super */ null && (SvgLink18));

var _path$5S;
function _extends$5Y() { _extends$5Y = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$5Y.apply(this, arguments); }
var SvgLink24 = function SvgLink24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$5Y({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path$5S || (_path$5S = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M2.1 12A4.9 4.9 0 0 1 7 7.1h3a.9.9 0 1 1 0 1.8H7a3.1 3.1 0 0 0 0 6.2h3a.9.9 0 1 1 0 1.8H7A4.9 4.9 0 0 1 2.1 12m11-4a.9.9 0 0 1 .9-.9h3a4.9 4.9 0 1 1 0 9.8h-3a.9.9 0 0 1 0-1.8h3a3.1 3.1 0 1 0 0-6.2h-3a.9.9 0 0 1-.9-.9m-7 4a.9.9 0 0 1 .9-.9h10a.9.9 0 1 1 0 1.8H7a.9.9 0 0 1-.9-.9",
    clipRule: "evenodd"
  })));
};
var Link24 = (/* unused pure expression or super */ null && (SvgLink24));

var _path$5R;
function _extends$5X() { _extends$5X = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$5X.apply(this, arguments); }
var SvgLink32 = function SvgLink32(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$5X({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _path$5R || (_path$5R = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M3 16a6.333 6.333 0 0 1 6.333-6.333h4a1 1 0 1 1 0 2h-4a4.333 4.333 0 0 0 0 8.666h4a1 1 0 1 1 0 2h-4A6.333 6.333 0 0 1 3 16m14.667-5.333a1 1 0 0 1 1-1h4a6.333 6.333 0 0 1 0 12.666h-4a1 1 0 1 1 0-2h4a4.333 4.333 0 0 0 0-8.666h-4a1 1 0 0 1-1-1M8.333 16a1 1 0 0 1 1-1h13.334a1 1 0 1 1 0 2H9.333a1 1 0 0 1-1-1",
    clipRule: "evenodd"
  })));
};
var Link32 = (/* unused pure expression or super */ null && (SvgLink32));

var _path$5Q;
function _extends$5W() { _extends$5W = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$5W.apply(this, arguments); }
var SvgLink48 = function SvgLink48(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$5W({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none"
  }, props), _path$5Q || (_path$5Q = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M5 24a9.2 9.2 0 0 1 9.2-9.2h6a1.2 1.2 0 0 1 0 2.4h-6a6.8 6.8 0 0 0 0 13.6h6a1.2 1.2 0 0 1 0 2.4h-6A9.2 9.2 0 0 1 5 24m22-8a1.2 1.2 0 0 1 1.2-1.2h6a9.2 9.2 0 0 1 0 18.4h-6a1.2 1.2 0 0 1 0-2.4h6a6.8 6.8 0 1 0 0-13.6h-6A1.2 1.2 0 0 1 27 16m-14 8a1.2 1.2 0 0 1 1.2-1.2h20a1.2 1.2 0 0 1 0 2.4h-20A1.2 1.2 0 0 1 13 24",
    clipRule: "evenodd"
  })));
};
var Link48 = (/* unused pure expression or super */ null && (SvgLink48));

var LinkIcon = function LinkIcon(props) {
  var link = {
    12: Link12,
    16: Link16,
    18: Link18,
    24: Link24,
    32: Link32,
    48: Link48
  };
  return jsx(IconTemplate, _assign({
    icons: link
  }, props));
};

var _path$5P, _path2$25;
function _extends$5V() { _extends$5V = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$5V.apply(this, arguments); }
var SvgLocation12 = function SvgLocation12(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$5V({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none"
  }, props), _path$5P || (_path$5P = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M6 5.55a.3.3 0 1 0 0-.6.3.3 0 0 0 0 .6m0 1.2a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3",
    clipRule: "evenodd"
  })), _path2$25 || (_path2$25 = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M8.043 7.368C8.686 6.508 9.05 5.69 9.05 5c0-1.479-1.296-2.8-3.05-2.8S2.95 3.521 2.95 5c0 .69.364 1.508 1.007 2.368.624.835 1.403 1.567 1.987 2.06.023.02.043.024.056.024a.1.1 0 0 0 .056-.023c.584-.494 1.363-1.226 1.987-2.061m-1.212 2.977C8.068 9.3 10.25 7.15 10.25 5c0-2.21-1.903-4-4.25-4S1.75 2.79 1.75 5c0 2.15 2.182 4.3 3.419 5.345.485.41 1.177.41 1.662 0",
    clipRule: "evenodd"
  })));
};
var Location12 = (/* unused pure expression or super */ null && (SvgLocation12));

var _path$5O, _path2$24;
function _extends$5U() { _extends$5U = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$5U.apply(this, arguments); }
var SvgLocation16 = function SvgLocation16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$5U({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path$5O || (_path$5O = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M8 7.5a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1M8 9a2 2 0 1 0 0-4 2 2 0 0 0 0 4",
    clipRule: "evenodd"
  })), _path2$24 || (_path2$24 = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M10.804 9.884c.862-1.153 1.363-2.265 1.363-3.217 0-2.033-1.779-3.834-4.167-3.834S3.833 4.634 3.833 6.667c0 .952.501 2.064 1.363 3.217.838 1.122 1.883 2.104 2.664 2.764.05.042.099.055.14.055s.09-.013.14-.055c.78-.66 1.826-1.642 2.664-2.764m-1.696 3.91c1.65-1.395 4.559-4.261 4.559-7.127 0-2.946-2.537-5.334-5.667-5.334S2.333 3.721 2.333 6.667c0 2.866 2.91 5.732 4.559 7.127.646.546 1.57.546 2.216 0",
    clipRule: "evenodd"
  })));
};
var Location16 = (/* unused pure expression or super */ null && (SvgLocation16));

var _path$5N, _path2$23;
function _extends$5T() { _extends$5T = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$5T.apply(this, arguments); }
var SvgLocation18 = function SvgLocation18(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$5T({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _path$5N || (_path$5N = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M9 8.525a.65.65 0 1 0 0-1.3.65.65 0 0 0 0 1.3m0 1.6a2.25 2.25 0 1 0 0-4.5 2.25 2.25 0 0 0 0 4.5",
    clipRule: "evenodd"
  })), _path2$23 || (_path2$23 = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M12.225 11.172c.973-1.303 1.55-2.572 1.55-3.672 0-2.34-2.045-4.4-4.775-4.4S4.225 5.16 4.225 7.5c0 1.1.577 2.37 1.55 3.672.949 1.27 2.13 2.379 3.012 3.124.071.06.146.083.213.083a.33.33 0 0 0 .213-.083c.882-.745 2.063-1.855 3.012-3.124m-1.979 4.346c1.856-1.57 5.129-4.794 5.129-8.018 0-3.314-2.854-6-6.375-6s-6.375 2.686-6.375 6c0 3.224 3.273 6.449 5.129 8.018a1.915 1.915 0 0 0 2.492 0",
    clipRule: "evenodd"
  })));
};
var Location18 = (/* unused pure expression or super */ null && (SvgLocation18));

var _path$5M, _path2$22;
function _extends$5S() { _extends$5S = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$5S.apply(this, arguments); }
var SvgLocation24 = function SvgLocation24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$5S({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path$5M || (_path$5M = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M12 11.7a1.2 1.2 0 1 0 0-2.4 1.2 1.2 0 0 0 0 2.4m0 1.8a3 3 0 1 0 0-6 3 3 0 0 0 0 6",
    clipRule: "evenodd"
  })), _path2$22 || (_path2$22 = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M16.567 15.095C17.881 13.337 18.7 11.573 18.7 10c0-3.323-2.895-6.2-6.7-6.2S5.3 6.677 5.3 10c0 1.573.82 3.337 2.133 5.095 1.286 1.721 2.883 3.22 4.067 4.22a.754.754 0 0 0 1 0c1.184-1 2.78-2.499 4.067-4.22m-2.905 5.595C16.136 18.598 20.5 14.3 20.5 10c0-4.418-3.806-8-8.5-8s-8.5 3.582-8.5 8c0 4.3 4.364 8.598 6.838 10.69.97.82 2.355.82 3.324 0",
    clipRule: "evenodd"
  })));
};
var Location24 = (/* unused pure expression or super */ null && (SvgLocation24));

var _path$5L, _path2$21;
function _extends$5R() { _extends$5R = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$5R.apply(this, arguments); }
var SvgLocation32 = function SvgLocation32(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$5R({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _path$5L || (_path$5L = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M16 16a2 2 0 1 0 0-4 2 2 0 0 0 0 4m0 2a4 4 0 1 0 0-8 4 4 0 0 0 0 8",
    clipRule: "evenodd"
  })), _path2$21 || (_path2$21 = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M22.41 20.366c1.77-2.37 2.923-4.807 2.923-7.033 0-4.674-4.062-8.666-9.333-8.666-5.27 0-9.333 3.992-9.333 8.666 0 2.226 1.152 4.664 2.923 7.033 1.74 2.329 3.894 4.348 5.485 5.694a1.406 1.406 0 0 0 1.85 0c1.59-1.346 3.745-3.365 5.485-5.694m-4.194 7.22c3.299-2.788 9.117-8.52 9.117-14.253 0-5.89-5.074-10.666-11.333-10.666S4.667 7.442 4.667 13.333c0 5.732 5.818 11.465 9.117 14.254a3.405 3.405 0 0 0 4.432 0",
    clipRule: "evenodd"
  })));
};
var Location32 = (/* unused pure expression or super */ null && (SvgLocation32));

var _path$5K, _path2$20;
function _extends$5Q() { _extends$5Q = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$5Q.apply(this, arguments); }
var SvgLocation48 = function SvgLocation48(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$5Q({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none"
  }, props), _path$5K || (_path$5K = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M24 24.6a3.6 3.6 0 1 0 0-7.2 3.6 3.6 0 0 0 0 7.2m0 2.4a6 6 0 1 0 0-12 6 6 0 0 0 0 12",
    clipRule: "evenodd"
  })), _path2$20 || (_path2$20 = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M34.095 30.909C36.78 27.316 38.6 23.53 38.6 20c0-7.376-6.398-13.6-14.6-13.6S9.4 12.624 9.4 20c0 3.53 1.82 7.316 4.505 10.909 2.648 3.544 5.917 6.606 8.32 8.639a2.71 2.71 0 0 0 3.55 0c2.404-2.033 5.672-5.096 8.32-8.64M27.324 41.38C32.272 37.196 41 28.598 41 20c0-8.837-7.611-16-17-16S7 11.163 7 20c0 8.598 8.728 17.196 13.676 21.38a5.11 5.11 0 0 0 6.648 0",
    clipRule: "evenodd"
  })));
};
var Location48 = (/* unused pure expression or super */ null && (SvgLocation48));

var LocationIcon = function LocationIcon(props) {
  var location = {
    12: Location12,
    16: Location16,
    18: Location18,
    24: Location24,
    32: Location32,
    48: Location48
  };
  return jsx(IconTemplate, _assign({
    icons: location
  }, props));
};

var _path$5J;
function _extends$5P() { _extends$5P = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$5P.apply(this, arguments); }
var SvgLocationFilled12 = function SvgLocationFilled12(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$5P({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none"
  }, props), _path$5J || (_path$5J = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M6.831 10.519c-.485.41-1.177.41-1.662 0C3.932 9.473 1.75 7.323 1.75 5.174c0-2.21 1.903-4 4.25-4s4.25 1.79 4.25 4c0 2.15-2.182 4.299-3.419 5.345M6 6.924a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3"
  })));
};
var LocationFilled12 = (/* unused pure expression or super */ null && (SvgLocationFilled12));

var _path$5I;
function _extends$5O() { _extends$5O = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$5O.apply(this, arguments); }
var SvgLocationFilled16 = function SvgLocationFilled16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$5O({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path$5I || (_path$5I = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M8 1.333c-3.13 0-5.667 2.388-5.667 5.334 0 2.866 2.91 5.732 4.559 7.127.646.546 1.57.546 2.216 0 1.65-1.395 4.559-4.261 4.559-7.127 0-2.946-2.537-5.334-5.667-5.334M8 9a2 2 0 1 1 0-4 2 2 0 0 1 0 4"
  })));
};
var LocationFilled16 = (/* unused pure expression or super */ null && (SvgLocationFilled16));

var _path$5H;
function _extends$5N() { _extends$5N = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$5N.apply(this, arguments); }
var SvgLocationFilled18 = function SvgLocationFilled18(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$5N({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _path$5H || (_path$5H = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M10.247 15.518a1.915 1.915 0 0 1-2.493 0c-1.856-1.57-5.129-4.794-5.129-8.018 0-3.314 2.854-6 6.375-6s6.375 2.686 6.375 6c0 3.224-3.273 6.449-5.129 8.018M9 10.125a2.25 2.25 0 1 0 0-4.5 2.25 2.25 0 0 0 0 4.5"
  })));
};
var LocationFilled18 = (/* unused pure expression or super */ null && (SvgLocationFilled18));

var _path$5G;
function _extends$5M() { _extends$5M = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$5M.apply(this, arguments); }
var SvgLocationFilled24 = function SvgLocationFilled24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$5M({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path$5G || (_path$5G = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M13.662 20.69c-.97.82-2.355.82-3.324 0C7.864 18.598 3.5 14.3 3.5 10c0-4.418 3.806-8 8.5-8s8.5 3.582 8.5 8c0 4.3-4.364 8.598-6.838 10.69M12 13.5a3 3 0 1 0 0-6 3 3 0 0 0 0 6"
  })));
};
var LocationFilled24 = (/* unused pure expression or super */ null && (SvgLocationFilled24));

var _path$5F;
function _extends$5L() { _extends$5L = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$5L.apply(this, arguments); }
var SvgLocationFilled32 = function SvgLocationFilled32(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$5L({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _path$5F || (_path$5F = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M18.216 27.587a3.405 3.405 0 0 1-4.432 0c-3.299-2.79-9.117-8.522-9.117-14.254C4.667 7.443 9.74 2.667 16 2.667s11.333 4.775 11.333 10.666c0 5.732-5.818 11.465-9.117 14.254M16 18a4 4 0 1 0 0-8 4 4 0 0 0 0 8"
  })));
};
var LocationFilled32 = (/* unused pure expression or super */ null && (SvgLocationFilled32));

var _path$5E;
function _extends$5K() { _extends$5K = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$5K.apply(this, arguments); }
var SvgLocationFilled48 = function SvgLocationFilled48(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$5K({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none"
  }, props), _path$5E || (_path$5E = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M27.324 41.38a5.11 5.11 0 0 1-6.648 0C15.728 37.196 7 28.598 7 20c0-8.837 7.611-16 17-16s17 7.163 17 16c0 8.598-8.728 17.196-13.676 21.38M24 27a6 6 0 1 0 0-12 6 6 0 0 0 0 12"
  })));
};
var LocationFilled48 = (/* unused pure expression or super */ null && (SvgLocationFilled48));

var LocationFilledIcon = function LocationFilledIcon(props) {
  var locationFilled = {
    12: LocationFilled12,
    16: LocationFilled16,
    18: LocationFilled18,
    24: LocationFilled24,
    32: LocationFilled32,
    48: LocationFilled48
  };
  return jsx(IconTemplate, _assign({
    icons: locationFilled
  }, props));
};

var _path$5D, _path2$1$;
function _extends$5J() { _extends$5J = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$5J.apply(this, arguments); }
var SvgLock12 = function SvgLock12(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$5J({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none"
  }, props), _path$5D || (_path$5D = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M6 8.25a1 1 0 1 0 0-2 1 1 0 0 0 0 2"
  })), _path2$1$ || (_path2$1$ = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M6 .9A2.1 2.1 0 0 0 3.9 3v.4h-.4a2.1 2.1 0 0 0-2.1 2.1V9c0 1.16.94 2.1 2.1 2.1h5A2.1 2.1 0 0 0 10.6 9V5.5a2.1 2.1 0 0 0-2.1-2.1h-.4V3A2.1 2.1 0 0 0 6 .9M6.9 3v.4H5.1V3a.9.9 0 0 1 1.8 0M2.6 5.5a.9.9 0 0 1 .9-.9h5a.9.9 0 0 1 .9.9V9a.9.9 0 0 1-.9.9h-5a.9.9 0 0 1-.9-.9z",
    clipRule: "evenodd"
  })));
};
var Lock12 = (/* unused pure expression or super */ null && (SvgLock12));

var _path$5C, _path2$1_;
function _extends$5I() { _extends$5I = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$5I.apply(this, arguments); }
var SvgLock16 = function SvgLock16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$5I({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path$5C || (_path$5C = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M8 11a1.333 1.333 0 1 0 0-2.667A1.333 1.333 0 0 0 8 11"
  })), _path2$1_ || (_path2$1_ = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M8 1.25A2.75 2.75 0 0 0 5.25 4v.583h-.583a2.75 2.75 0 0 0-2.75 2.75V12a2.75 2.75 0 0 0 2.75 2.75h6.667a2.75 2.75 0 0 0 2.75-2.75V7.333a2.75 2.75 0 0 0-2.75-2.75h-.584V4A2.75 2.75 0 0 0 8 1.25M9.25 4v.583h-2.5V4a1.25 1.25 0 1 1 2.5 0M3.417 7.333c0-.69.56-1.25 1.25-1.25h6.667c.69 0 1.25.56 1.25 1.25V12c0 .69-.56 1.25-1.25 1.25H4.667c-.69 0-1.25-.56-1.25-1.25z",
    clipRule: "evenodd"
  })));
};
var Lock16 = (/* unused pure expression or super */ null && (SvgLock16));

var _path$5B, _path2$1Z;
function _extends$5H() { _extends$5H = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$5H.apply(this, arguments); }
var SvgLock18 = function SvgLock18(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$5H({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _path$5B || (_path$5B = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M9 12.375a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3"
  })), _path2$1Z || (_path2$1Z = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M9 1.45A3.05 3.05 0 0 0 5.95 4.5v.7h-.7A3.05 3.05 0 0 0 2.2 8.25v5.25a3.05 3.05 0 0 0 3.05 3.05h7.5a3.05 3.05 0 0 0 3.05-3.05V8.25a3.05 3.05 0 0 0-3.05-3.05h-.7v-.7A3.05 3.05 0 0 0 9 1.45m1.45 3.05v.7h-2.9v-.7a1.45 1.45 0 1 1 2.9 0M3.8 8.25c0-.8.65-1.45 1.45-1.45h7.5c.801 0 1.45.65 1.45 1.45v5.25c0 .801-.649 1.45-1.45 1.45h-7.5c-.8 0-1.45-.649-1.45-1.45z",
    clipRule: "evenodd"
  })));
};
var Lock18 = (/* unused pure expression or super */ null && (SvgLock18));

var _path$5A, _path2$1Y;
function _extends$5G() { _extends$5G = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$5G.apply(this, arguments); }
var SvgLock24 = function SvgLock24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$5G({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path$5A || (_path$5A = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M12 16.5a2 2 0 1 0 0-4 2 2 0 0 0 0 4"
  })), _path2$1Y || (_path2$1Y = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M12 2.1A3.9 3.9 0 0 0 8.1 6v1.1H7A3.9 3.9 0 0 0 3.1 11v7A3.9 3.9 0 0 0 7 21.9h10a3.9 3.9 0 0 0 3.9-3.9v-7A3.9 3.9 0 0 0 17 7.1h-1.1V6A3.9 3.9 0 0 0 12 2.1M14.1 6v1.1H9.9V6a2.1 2.1 0 1 1 4.2 0m-9.2 5c0-1.16.94-2.1 2.1-2.1h10c1.16 0 2.1.94 2.1 2.1v7a2.1 2.1 0 0 1-2.1 2.1H7A2.1 2.1 0 0 1 4.9 18z",
    clipRule: "evenodd"
  })));
};
var Lock24 = (/* unused pure expression or super */ null && (SvgLock24));

var _path$5z, _path2$1X;
function _extends$5F() { _extends$5F = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$5F.apply(this, arguments); }
var SvgLock32 = function SvgLock32(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$5F({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _path$5z || (_path$5z = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M16 22a2.667 2.667 0 1 0 0-5.333A2.667 2.667 0 0 0 16 22"
  })), _path2$1X || (_path2$1X = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M16 3a5 5 0 0 0-5 5v1.667H9.333a5 5 0 0 0-5 5V24a5 5 0 0 0 5 5h13.333a5 5 0 0 0 5-5v-9.333a5 5 0 0 0-5-5H21V8a5 5 0 0 0-5-5m3 5v1.667h-6V8a3 3 0 1 1 6 0M6.333 14.667a3 3 0 0 1 3-3h13.333a3 3 0 0 1 3 3V24a3 3 0 0 1-3 3H9.333a3 3 0 0 1-3-3z",
    clipRule: "evenodd"
  })));
};
var Lock32 = (/* unused pure expression or super */ null && (SvgLock32));

var _path$5y, _path2$1W;
function _extends$5E() { _extends$5E = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$5E.apply(this, arguments); }
var SvgLock48 = function SvgLock48(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$5E({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none"
  }, props), _path$5y || (_path$5y = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M24 33a4 4 0 1 0 0-8 4 4 0 0 0 0 8"
  })), _path2$1W || (_path2$1W = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M24 4.8a7.2 7.2 0 0 0-7.2 7.2v2.8H14A7.2 7.2 0 0 0 6.8 22v14a7.2 7.2 0 0 0 7.2 7.2h20a7.2 7.2 0 0 0 7.2-7.2V22a7.2 7.2 0 0 0-7.2-7.2h-2.8V12A7.2 7.2 0 0 0 24 4.8m4.8 7.2v2.8h-9.6V12a4.8 4.8 0 1 1 9.6 0M9.2 22a4.8 4.8 0 0 1 4.8-4.8h20a4.8 4.8 0 0 1 4.8 4.8v14a4.8 4.8 0 0 1-4.8 4.8H14A4.8 4.8 0 0 1 9.2 36z",
    clipRule: "evenodd"
  })));
};
var Lock48 = (/* unused pure expression or super */ null && (SvgLock48));

var LockIcon = function LockIcon(props) {
  var lock = {
    12: Lock12,
    16: Lock16,
    18: Lock18,
    24: Lock24,
    32: Lock32,
    48: Lock48
  };
  return jsx(IconTemplate, _assign({
    icons: lock
  }, props));
};

var _path$5x;
function _extends$5D() { _extends$5D = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$5D.apply(this, arguments); }
var SvgLockFilled12 = function SvgLockFilled12(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$5D({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none"
  }, props), _path$5x || (_path$5x = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M6 .9A2.1 2.1 0 0 0 3.9 3v.55h-.4A1.95 1.95 0 0 0 1.55 5.5V9a1.95 1.95 0 0 0 1.95 1.95h5A1.95 1.95 0 0 0 10.45 9V5.5A1.95 1.95 0 0 0 8.5 3.55h-.4V3A2.1 2.1 0 0 0 6 .9M5.1 3a.9.9 0 0 1 1.8 0v.4H5.1zM6 8.25a1 1 0 1 0 0-2 1 1 0 0 0 0 2",
    clipRule: "evenodd"
  })));
};
var LockFilled12 = (/* unused pure expression or super */ null && (SvgLockFilled12));

var _path$5w;
function _extends$5C() { _extends$5C = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$5C.apply(this, arguments); }
var SvgLockFilled16 = function SvgLockFilled16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$5C({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path$5w || (_path$5w = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M8 1.25A2.75 2.75 0 0 0 5.25 4v.733h-.584a2.6 2.6 0 0 0-2.6 2.6V12a2.6 2.6 0 0 0 2.6 2.6h6.667a2.6 2.6 0 0 0 2.6-2.6V7.333a2.6 2.6 0 0 0-2.6-2.6h-.583V4A2.75 2.75 0 0 0 8 1.25M6.75 4a1.25 1.25 0 1 1 2.5 0v.583h-2.5zM8 11a1.333 1.333 0 1 0 0-2.667A1.333 1.333 0 0 0 8 11",
    clipRule: "evenodd"
  })));
};
var LockFilled16 = (/* unused pure expression or super */ null && (SvgLockFilled16));

var _path$5v;
function _extends$5B() { _extends$5B = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$5B.apply(this, arguments); }
var SvgLockFilled18 = function SvgLockFilled18(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$5B({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _path$5v || (_path$5v = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M9 1.45A3.05 3.05 0 0 0 5.95 4.5v.825h-.7A2.925 2.925 0 0 0 2.325 8.25v5.25a2.925 2.925 0 0 0 2.925 2.925h7.5a2.925 2.925 0 0 0 2.925-2.925V8.25a2.925 2.925 0 0 0-2.925-2.925h-.7V4.5A3.05 3.05 0 0 0 9 1.45M7.55 4.5a1.45 1.45 0 1 1 2.9 0v.7h-2.9zM9 12.375a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3",
    clipRule: "evenodd"
  })));
};
var LockFilled18 = (/* unused pure expression or super */ null && (SvgLockFilled18));

var _path$5u;
function _extends$5A() { _extends$5A = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$5A.apply(this, arguments); }
var SvgLockFilled24 = function SvgLockFilled24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$5A({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path$5u || (_path$5u = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M12 2.1A3.9 3.9 0 0 0 8.1 6v1.1H7A3.9 3.9 0 0 0 3.1 11v7A3.9 3.9 0 0 0 7 21.9h10a3.9 3.9 0 0 0 3.9-3.9v-7A3.9 3.9 0 0 0 17 7.1h-1.1V6A3.9 3.9 0 0 0 12 2.1m2.1 5V6a2.1 2.1 0 1 0-4.2 0v1.1zM12 16.5a2 2 0 1 0 0-4 2 2 0 0 0 0 4",
    clipRule: "evenodd"
  })));
};
var LockFilled24 = (/* unused pure expression or super */ null && (SvgLockFilled24));

var _path$5t;
function _extends$5z() { _extends$5z = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$5z.apply(this, arguments); }
var SvgLockFilled32 = function SvgLockFilled32(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$5z({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _path$5t || (_path$5t = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M16 3a5 5 0 0 0-5 5v1.467H9.334a5.2 5.2 0 0 0-5.2 5.2V24a5.2 5.2 0 0 0 5.2 5.2h13.333a5.2 5.2 0 0 0 5.2-5.2v-9.333a5.2 5.2 0 0 0-5.2-5.2H21V8a5 5 0 0 0-5-5m3 6.467V8a3 3 0 1 0-6 0v1.467zM16 22a2.667 2.667 0 1 0 0-5.333A2.667 2.667 0 0 0 16 22",
    clipRule: "evenodd"
  })));
};
var LockFilled32 = (/* unused pure expression or super */ null && (SvgLockFilled32));

var _path$5s;
function _extends$5y() { _extends$5y = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$5y.apply(this, arguments); }
var SvgLockFilled48 = function SvgLockFilled48(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$5y({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none"
  }, props), _path$5s || (_path$5s = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M24 4.8a7.2 7.2 0 0 0-7.2 7.2v2.2H14A7.8 7.8 0 0 0 6.2 22v14a7.8 7.8 0 0 0 7.8 7.8h20a7.8 7.8 0 0 0 7.8-7.8V22a7.8 7.8 0 0 0-7.8-7.8h-2.8V12A7.2 7.2 0 0 0 24 4.8m4.8 9.4V12a4.8 4.8 0 1 0-9.6 0v2.2zM24 33a4 4 0 1 0 0-8 4 4 0 0 0 0 8",
    clipRule: "evenodd"
  })));
};
var LockFilled48 = (/* unused pure expression or super */ null && (SvgLockFilled48));

var LockFilledIcon = function LockFilledIcon(props) {
  var lockFilled = {
    12: LockFilled12,
    16: LockFilled16,
    18: LockFilled18,
    24: LockFilled24,
    32: LockFilled32,
    48: LockFilled48
  };
  return jsx(IconTemplate, _assign({
    icons: lockFilled
  }, props));
};

var _path$5r, _path2$1V;
function _extends$5x() { _extends$5x = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$5x.apply(this, arguments); }
var SvgMedal12 = function SvgMedal12(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$5x({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none"
  }, props), _path$5r || (_path$5r = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "m9.74 6.485 1.627 1.626a.797.797 0 0 1-.294 1.313l-.81.292-.243.736a.797.797 0 0 1-1.32.313l-1.9-1.9.848-.85 1.438 1.439.1-.302a.8.8 0 0 1 .486-.499l.397-.143-1.177-1.177zM1.932 8.51l.397.143c.23.083.41.267.487.5l.1.3 1.437-1.437.849.848-1.9 1.9a.797.797 0 0 1-1.32-.312l-.244-.736-.81-.292A.797.797 0 0 1 .634 8.11L2.26 6.485l.848.848z",
    clipRule: "evenodd"
  })), _path2$1V || (_path2$1V = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M6 7.982A2.89 2.89 0 1 0 6 2.2a2.89 2.89 0 0 0 0 5.782m0 1.2A4.09 4.09 0 1 0 6 1a4.09 4.09 0 0 0 0 8.182",
    clipRule: "evenodd"
  })));
};
var Medal12 = (/* unused pure expression or super */ null && (SvgMedal12));

var _path$5q, _path2$1U;
function _extends$5w() { _extends$5w = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$5w.apply(this, arguments); }
var SvgMedal16 = function SvgMedal16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$5w({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path$5q || (_path$5q = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M7.588 4.147a.5.5 0 0 1 .824 0l.61.89a.5.5 0 0 0 .27.196l1.034.305a.5.5 0 0 1 .255.784l-.657.854a.5.5 0 0 0-.103.319l.03 1.077a.5.5 0 0 1-.668.485l-1.015-.361a.5.5 0 0 0-.335 0l-1.016.361a.5.5 0 0 1-.667-.485l.03-1.077a.5.5 0 0 0-.104-.319l-.657-.854a.5.5 0 0 1 .255-.784l1.033-.305a.5.5 0 0 0 .271-.197zm.38 1.568L8 5.668l.032.047a1.7 1.7 0 0 0 .921.67l.054.015-.034.045a1.7 1.7 0 0 0-.352 1.083l.002.056-.053-.019a1.7 1.7 0 0 0-1.14 0l-.053.02.002-.057a1.7 1.7 0 0 0-.352-1.083L6.993 6.4l.054-.016a1.7 1.7 0 0 0 .921-.67",
    clipRule: "evenodd"
  })), _path2$1U || (_path2$1U = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M8 12.455c.517 0 1.018-.069 1.494-.197l2.35 2.35c.539.539 1.458.32 1.698-.404l.355-1.072 1.175-.423a1.025 1.025 0 0 0 .378-1.69l-2.14-2.14a5.727 5.727 0 1 0-10.619 0l-2.14 2.14a1.025 1.025 0 0 0 .377 1.69l1.175.423.355 1.072c.24.725 1.16.943 1.699.403l2.35-2.35c.475.13.976.197 1.493.197m0-1.5A4.227 4.227 0 1 0 8 2.5a4.227 4.227 0 0 0 0 8.455m4.36 2.047-1.382-1.382c.6-.366 1.129-.84 1.557-1.394l1.325 1.325-.689.248a1.02 1.02 0 0 0-.626.642zM2.14 11.551l1.325-1.325a5.8 5.8 0 0 0 1.557 1.394L3.64 13.002l-.185-.56a1.02 1.02 0 0 0-.626-.643z",
    clipRule: "evenodd"
  })));
};
var Medal16 = (/* unused pure expression or super */ null && (SvgMedal16));

var _path$5p, _path2$1T;
function _extends$5v() { _extends$5v = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$5v.apply(this, arguments); }
var SvgMedal18 = function SvgMedal18(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$5v({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _path$5p || (_path$5p = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M8.588 4.636a.5.5 0 0 1 .824 0l.77 1.123a.5.5 0 0 0 .271.197l1.306.384a.5.5 0 0 1 .255.785l-.83 1.079a.5.5 0 0 0-.104.318l.037 1.361a.5.5 0 0 1-.667.485l-1.282-.456a.5.5 0 0 0-.336 0l-1.282.456a.5.5 0 0 1-.667-.485l.037-1.36a.5.5 0 0 0-.103-.32l-.83-1.078a.5.5 0 0 1 .254-.785l1.306-.384a.5.5 0 0 0 .271-.197zm.302 1.858.11-.16.11.16a1.8 1.8 0 0 0 .975.709l.186.054-.118.154a1.8 1.8 0 0 0-.373 1.147l.006.194-.183-.065a1.8 1.8 0 0 0-1.206 0l-.183.065.006-.194a1.8 1.8 0 0 0-.373-1.147l-.118-.154.186-.054a1.8 1.8 0 0 0 .975-.71",
    clipRule: "evenodd"
  })), _path2$1T || (_path2$1T = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M9 14.216c.614 0 1.208-.084 1.77-.242l2.663 2.662c.586.586 1.585.35 1.846-.438l.414-1.252 1.37-.494c.769-.276.988-1.259.41-1.836l-2.429-2.43a6.545 6.545 0 1 0-12.089 0l-2.428 2.43a1.115 1.115 0 0 0 .41 1.837l1.37.493.414 1.252a1.115 1.115 0 0 0 1.846.438l2.662-2.662A6.6 6.6 0 0 0 9 14.216m0-1.6a4.945 4.945 0 1 0 0-9.891 4.945 4.945 0 0 0 0 9.89m5.008 2.332-1.655-1.655a6.6 6.6 0 0 0 1.865-1.67l1.583 1.583-.872.314a1.12 1.12 0 0 0-.68.699zm-11.81-1.742 1.584-1.583a6.6 6.6 0 0 0 1.865 1.67l-1.654 1.655-.242-.73a1.12 1.12 0 0 0-.68-.697z",
    clipRule: "evenodd"
  })));
};
var Medal18 = (/* unused pure expression or super */ null && (SvgMedal18));

var _path$5o, _path2$1S, _path3$6;
function _extends$5u() { _extends$5u = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$5u.apply(this, arguments); }
var SvgMedal24 = function SvgMedal24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$5u({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path$5o || (_path$5o = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "m19.932 13.864 3.578 3.577c.69.69.428 1.865-.491 2.196l-1.975.711-.6 1.814a1.333 1.333 0 0 1-2.207.524l-4.181-4.181 1.272-1.273 3.645 3.645.434-1.31c.128-.389.428-.696.813-.835l1.496-.539-3.057-3.057zm-17.648 4.33 1.496.538c.385.139.685.447.813.835l.434 1.31 3.645-3.645 1.272 1.273-4.18 4.18a1.332 1.332 0 0 1-2.208-.523l-.6-1.814-1.975-.71a1.333 1.333 0 0 1-.49-2.197l3.577-3.577 1.273 1.272z"
  })), _path2$1S || (_path2$1S = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M12 17.7a7.2 7.2 0 1 0 0-14.4 7.2 7.2 0 0 0 0 14.4m0 1.8a9 9 0 1 1 0-18 9 9 0 0 1 0 18"
  })), _path3$6 || (_path3$6 = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "m12 8.33-.243.354a2.6 2.6 0 0 1-1.41 1.024l-.41.122.261.34a2.6 2.6 0 0 1 .538 1.656l-.011.43.404-.144c.563-.2 1.179-.2 1.742 0l.404.143-.011-.429a2.6 2.6 0 0 1 .538-1.657l.261-.34-.411-.12a2.6 2.6 0 0 1-1.41-1.025zm.825-1.626.737 1.076a1 1 0 0 0 .542.394l1.252.368a1 1 0 0 1 .51 1.57l-.796 1.033a1 1 0 0 0-.207.638l.036 1.303a1 1 0 0 1-1.335.97l-1.229-.437a1 1 0 0 0-.67 0l-1.23.437a1 1 0 0 1-1.334-.97l.036-1.303a1 1 0 0 0-.207-.638l-.796-1.034a1 1 0 0 1 .51-1.569l1.252-.368a1 1 0 0 0 .542-.394l.737-1.076a1 1 0 0 1 1.65 0"
  })));
};
var Medal24 = (/* unused pure expression or super */ null && (SvgMedal24));

var _path$5n, _path2$1R;
function _extends$5t() { _extends$5t = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$5t.apply(this, arguments); }
var SvgMedal32 = function SvgMedal32(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$5t({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _path$5n || (_path$5n = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M15.01 8.778a1.2 1.2 0 0 1 1.98 0l1.12 1.634a1.2 1.2 0 0 0 .65.473l1.9.56a1.2 1.2 0 0 1 .613 1.883l-1.209 1.57a1.2 1.2 0 0 0-.248.765l.055 1.98a1.2 1.2 0 0 1-1.602 1.164l-1.867-.664a1.2 1.2 0 0 0-.804 0l-1.867.664a1.2 1.2 0 0 1-1.601-1.164l.054-1.98a1.2 1.2 0 0 0-.248-.765l-1.209-1.57a1.2 1.2 0 0 1 .612-1.883l1.9-.56a1.2 1.2 0 0 0 .651-.473zm.53 2.765.46-.672.46.672a3.2 3.2 0 0 0 1.735 1.26l.78.23-.496.645a3.2 3.2 0 0 0-.662 2.04l.022.813-.767-.272a3.2 3.2 0 0 0-2.144 0l-.767.272.022-.813a3.2 3.2 0 0 0-.662-2.04l-.497-.645.781-.23a3.2 3.2 0 0 0 1.735-1.26",
    clipRule: "evenodd"
  })), _path2$1R || (_path2$1R = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M16 26c1.31 0 2.572-.21 3.752-.598l4.705 4.704c.83.83 2.243.495 2.612-.62l.83-2.51 2.725-.982a1.577 1.577 0 0 0 .58-2.598l-4.325-4.325C27.6 17.53 28 15.812 28 14c0-6.627-5.372-12-12-12C9.373 2 4 7.373 4 14c0 1.812.402 3.53 1.12 5.07L.796 23.397a1.577 1.577 0 0 0 .581 2.599l2.725.981.83 2.51a1.577 1.577 0 0 0 2.612.62l4.705-4.704C13.428 25.79 14.69 26 16 26m0-2c5.523 0 10-4.477 10-10S21.523 4 16 4 6 8.477 6 14s4.477 10 10 10m9.386 4.206-3.659-3.658a12.06 12.06 0 0 0 4.117-3.684l3.475 3.475-2.29.825c-.456.164-.811.528-.963.988zM2.68 24.34l3.475-3.475a12.06 12.06 0 0 0 4.117 3.684l-3.659 3.659-.68-2.055a1.58 1.58 0 0 0-.962-.988z",
    clipRule: "evenodd"
  })));
};
var Medal32 = (/* unused pure expression or super */ null && (SvgMedal32));

var _path$5m, _path2$1Q;
function _extends$5s() { _extends$5s = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$5s.apply(this, arguments); }
var SvgMedal48 = function SvgMedal48(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$5s({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none"
  }, props), _path$5m || (_path$5m = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M22.35 13.407a2 2 0 0 1 3.3 0l1.475 2.152a2 2 0 0 0 1.084.788l2.502.738a2 2 0 0 1 1.02 3.138L30.14 22.29a2 2 0 0 0-.414 1.275l.072 2.608a2 2 0 0 1-2.67 1.94l-2.458-.875a2 2 0 0 0-1.34 0l-2.458.874a2 2 0 0 1-2.67-1.939l.072-2.608a2 2 0 0 0-.414-1.275l-1.591-2.067a2 2 0 0 1 1.02-3.138l2.502-.738a2 2 0 0 0 1.084-.788zm.505 3.509L24 15.246l1.145 1.67a4.4 4.4 0 0 0 2.385 1.733l1.943.573-1.235 1.605a4.4 4.4 0 0 0-.911 2.804l.055 2.025-1.908-.679a4.4 4.4 0 0 0-2.948 0l-1.908.679.055-2.025a4.4 4.4 0 0 0-.91-2.804l-1.236-1.605 1.943-.573a4.4 4.4 0 0 0 2.385-1.733",
    clipRule: "evenodd"
  })), _path2$1Q || (_path2$1Q = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M24 39a18 18 0 0 0 5.945-1.005l6.952 6.952c1.087 1.087 2.938.648 3.421-.811l1.292-3.905 4.224-1.521a2.065 2.065 0 0 0 .76-3.404l-6.412-6.413A17.9 17.9 0 0 0 42 21c0-9.941-8.059-18-18-18S6 11.059 6 21c0 2.831.654 5.51 1.818 7.893l-6.413 6.414a2.065 2.065 0 0 0 .76 3.403L6.39 40.23l1.292 3.905c.483 1.46 2.334 1.898 3.42.811l6.953-6.952A18 18 0 0 0 24 39m0-2.4c8.616 0 15.6-6.984 15.6-15.6S32.616 5.4 24 5.4 8.4 12.384 8.4 21 15.384 36.6 24 36.6m14.21 6.266-5.896-5.897a18.1 18.1 0 0 0 6.625-5.924l5.586 5.585-3.881 1.398a2.07 2.07 0 0 0-1.261 1.294zM3.475 36.63l5.586-5.585a18.1 18.1 0 0 0 6.626 5.924L9.79 42.866l-1.173-3.544a2.07 2.07 0 0 0-1.26-1.294z",
    clipRule: "evenodd"
  })));
};
var Medal48 = (/* unused pure expression or super */ null && (SvgMedal48));

var MedalIcon = function MedalIcon(props) {
  var medal = {
    12: Medal12,
    16: Medal16,
    18: Medal18,
    24: Medal24,
    32: Medal32,
    48: Medal48
  };
  return jsx(IconTemplate, _assign({
    icons: medal
  }, props));
};

var _g$5, _defs$5;
function _extends$5r() { _extends$5r = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$5r.apply(this, arguments); }
var SvgMedalFilled12 = function SvgMedalFilled12(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$5r({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none"
  }, props), _g$5 || (_g$5 = /*#__PURE__*/React.createElement("g", {
    fill: "#2F3438",
    clipPath: "url(#medalFilled_12_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.264 7.631.21 8.685a.716.716 0 0 0 .264 1.18l.964.348.293.884a.716.716 0 0 0 1.186.281l1.18-1.18a5.32 5.32 0 0 1-2.833-2.567M7.903 10.198l1.18 1.18a.716.716 0 0 0 1.187-.281l.292-.884.965-.347a.716.716 0 0 0 .263-1.18L10.736 7.63a5.32 5.32 0 0 1-2.833 2.567"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M6 9.75a4.5 4.5 0 1 0 0-9 4.5 4.5 0 0 0 0 9m.713-5.71-.383-.559a.4.4 0 0 0-.66 0l-.383.56a.4.4 0 0 1-.217.157l-.65.192a.4.4 0 0 0-.204.627l.413.537a.4.4 0 0 1 .083.255l-.018.678a.4.4 0 0 0 .533.388l.639-.227a.4.4 0 0 1 .268 0l.639.227a.4.4 0 0 0 .533-.388l-.018-.678a.4.4 0 0 1 .083-.255l.413-.537a.4.4 0 0 0-.204-.627l-.65-.192a.4.4 0 0 1-.217-.158",
    clipRule: "evenodd"
  }))), _defs$5 || (_defs$5 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "medalFilled_12_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h12v12H0z"
  })))));
};
var MedalFilled12 = (/* unused pure expression or super */ null && (SvgMedalFilled12));

var _path$5l, _path2$1P, _path3$5;
function _extends$5q() { _extends$5q = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$5q.apply(this, arguments); }
var SvgMedalFilled16 = function SvgMedalFilled16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$5q({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path$5l || (_path$5l = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "m1.766 10.188-1.44 1.44a.888.888 0 0 0 .328 1.463l1.317.475.4 1.209a.888.888 0 0 0 1.471.349l1.604-1.604a7.03 7.03 0 0 1-3.68-3.332m.706 3.052.02-.007-.011-.029z",
    clipRule: "evenodd"
  })), _path2$1P || (_path2$1P = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "m10.554 13.52 1.604 1.604a.888.888 0 0 0 1.471-.35l.4-1.208 1.317-.475a.888.888 0 0 0 .327-1.464l-1.44-1.439a7.03 7.03 0 0 1-3.68 3.332"
  })), _path3$5 || (_path3$5 = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M8 13A6 6 0 1 0 8 1a6 6 0 0 0 0 12m.937-7.632-.442-.646a.6.6 0 0 0-.99 0l-.442.646a.6.6 0 0 1-.326.236l-.75.221a.6.6 0 0 0-.306.942l.477.62a.6.6 0 0 1 .124.383l-.021.782a.6.6 0 0 0 .8.582L7.8 8.87a.6.6 0 0 1 .402 0l.737.263a.6.6 0 0 0 .801-.582l-.021-.782a.6.6 0 0 1 .124-.383l.477-.62a.6.6 0 0 0-.306-.942l-.75-.22a.6.6 0 0 1-.326-.237",
    clipRule: "evenodd"
  })));
};
var MedalFilled16 = (/* unused pure expression or super */ null && (SvgMedalFilled16));

var _path$5k, _path2$1O, _path3$4;
function _extends$5p() { _extends$5p = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$5p.apply(this, arguments); }
var SvgMedalFilled18 = function SvgMedalFilled18(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$5p({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _path$5k || (_path$5k = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M1.994 11.42.35 13.063c-.53.531-.329 1.434.377 1.688l1.47.53.446 1.348c.24.724 1.158.942 1.697.403L6.172 15.2a7.88 7.88 0 0 1-4.178-3.78",
    clipRule: "evenodd"
  })), _path2$1O || (_path2$1O = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "m11.828 15.2 1.832 1.832c.539.539 1.457.321 1.697-.403l.446-1.348 1.47-.53a1.024 1.024 0 0 0 .377-1.688l-1.644-1.644a7.88 7.88 0 0 1-4.178 3.781"
  })), _path3$4 || (_path3$4 = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M9 14.625a6.75 6.75 0 1 0 0-13.5 6.75 6.75 0 0 0 0 13.5m1.05-8.594-.473-.688a.7.7 0 0 0-1.154 0l-.473.688a.7.7 0 0 1-.379.276l-.801.236a.7.7 0 0 0-.357 1.099l.51.661a.7.7 0 0 1 .144.447l-.023.834a.7.7 0 0 0 .935.68l.786-.28a.7.7 0 0 1 .47 0l.786.28a.7.7 0 0 0 .935-.68l-.023-.834a.7.7 0 0 1 .145-.447l.509-.661a.7.7 0 0 0-.357-1.099l-.801-.236a.7.7 0 0 1-.38-.276",
    clipRule: "evenodd"
  })));
};
var MedalFilled18 = (/* unused pure expression or super */ null && (SvgMedalFilled18));

var _path$5j, _path2$1N;
function _extends$5o() { _extends$5o = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$5o.apply(this, arguments); }
var SvgMedalFilled24 = function SvgMedalFilled24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$5o({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path$5j || (_path$5j = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M2.724 15.208.49 17.44c-.69.69-.428 1.865.491 2.196l1.975.711.6 1.814a1.333 1.333 0 0 0 2.207.524l2.484-2.484a10.44 10.44 0 0 1-5.523-4.995M15.753 20.202l2.483 2.484a1.333 1.333 0 0 0 2.208-.524l.6-1.814 1.975-.711a1.332 1.332 0 0 0 .49-2.196l-2.233-2.233a10.44 10.44 0 0 1-5.523 4.994"
  })), _path2$1N || (_path2$1N = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M12 19.5a9 9 0 1 0 0-18 9 9 0 0 0 0 18m1.386-11.478-.561-.818a1 1 0 0 0-1.65 0l-.561.818a1 1 0 0 1-.542.394l-.952.28a1 1 0 0 0-.51 1.57l.605.787a1 1 0 0 1 .207.637l-.027.992a1 1 0 0 0 1.335.97l.935-.333a1 1 0 0 1 .67 0l.935.333a1 1 0 0 0 1.335-.97l-.027-.992a1 1 0 0 1 .207-.637l.605-.787a1 1 0 0 0-.51-1.57l-.952-.28a1 1 0 0 1-.542-.394",
    clipRule: "evenodd"
  })));
};
var MedalFilled24 = (/* unused pure expression or super */ null && (SvgMedalFilled24));

var _path$5i, _path2$1M;
function _extends$5n() { _extends$5n = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$5n.apply(this, arguments); }
var SvgMedalFilled32 = function SvgMedalFilled32(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$5n({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _path$5i || (_path$5i = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "m3.827 20.506-2.96 2.961a1.477 1.477 0 0 0 .543 2.434l2.77.997.846 2.557a1.477 1.477 0 0 0 2.447.58l3.271-3.271a13.85 13.85 0 0 1-6.917-6.258M21.256 26.764l3.272 3.271c.777.778 2.1.464 2.446-.58l.846-2.557 2.77-.997a1.477 1.477 0 0 0 .544-2.434l-2.96-2.96a13.85 13.85 0 0 1-6.918 6.257"
  })), _path2$1M || (_path2$1M = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M16 26c6.627 0 12-5.373 12-12S22.627 2 16 2 4 7.373 4 14s5.373 12 12 12m1.875-15.264-.885-1.292a1.2 1.2 0 0 0-1.98 0l-.885 1.291a1.2 1.2 0 0 1-.65.473l-1.502.443a1.2 1.2 0 0 0-.612 1.883l.955 1.24a1.2 1.2 0 0 1 .248.765l-.043 1.565a1.2 1.2 0 0 0 1.602 1.163l1.475-.524a1.2 1.2 0 0 1 .804 0l1.475.524a1.2 1.2 0 0 0 1.602-1.163l-.043-1.565a1.2 1.2 0 0 1 .248-.765l.955-1.24a1.2 1.2 0 0 0-.612-1.883l-1.502-.443a1.2 1.2 0 0 1-.65-.473",
    clipRule: "evenodd"
  })));
};
var MedalFilled32 = (/* unused pure expression or super */ null && (SvgMedalFilled32));

var _path$5h, _path2$1L;
function _extends$5m() { _extends$5m = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$5m.apply(this, arguments); }
var SvgMedalFilled48 = function SvgMedalFilled48(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$5m({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none"
  }, props), _path$5h || (_path$5h = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "m6.187 30.95-4.57 4.569a1.765 1.765 0 0 0 .65 2.909l4.362 1.57 1.338 4.044a1.765 1.765 0 0 0 2.923.693l5.008-5.007a20.48 20.48 0 0 1-9.711-8.779M32.102 39.728l5.007 5.007a1.765 1.765 0 0 0 2.924-.694l1.338-4.043 4.362-1.57a1.765 1.765 0 0 0 .65-2.91l-4.57-4.568a20.48 20.48 0 0 1-9.71 8.778"
  })), _path2$1L || (_path2$1L = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M24 39c9.941 0 18-8.059 18-18S33.941 3 24 3 6 11.059 6 21s8.059 18 18 18m2.852-22.838-1.532-2.236a1.6 1.6 0 0 0-2.64 0l-1.532 2.236a1.6 1.6 0 0 1-.868.63l-2.6.767a1.6 1.6 0 0 0-.816 2.51l1.653 2.149c.225.291.342.652.332 1.02l-.075 2.71a1.6 1.6 0 0 0 2.136 1.551l2.554-.908a1.6 1.6 0 0 1 1.072 0l2.554.908a1.6 1.6 0 0 0 2.136-1.552l-.075-2.71a1.6 1.6 0 0 1 .332-1.02l1.653-2.148a1.6 1.6 0 0 0-.816-2.51l-2.6-.767a1.6 1.6 0 0 1-.868-.63",
    clipRule: "evenodd"
  })));
};
var MedalFilled48 = (/* unused pure expression or super */ null && (SvgMedalFilled48));

var MedalFilledIcon = function MedalFilledIcon(props) {
  var medalFilled = {
    12: MedalFilled12,
    16: MedalFilled16,
    18: MedalFilled18,
    24: MedalFilled24,
    32: MedalFilled32,
    48: MedalFilled48
  };
  return jsx(IconTemplate, _assign({
    icons: medalFilled
  }, props));
};

var _g$4, _defs$4;
function _extends$5l() { _extends$5l = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$5l.apply(this, arguments); }
var SvgMenu12 = function SvgMenu12(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$5l({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none"
  }, props), _g$4 || (_g$4 = /*#__PURE__*/React.createElement("g", {
    stroke: "#2F3438",
    strokeLinecap: "round",
    strokeWidth: 1.2,
    clipPath: "url(#menu_12_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.25 2.75h9.5M1.25 6h9.5M1.25 9.25h9.5"
  }))), _defs$4 || (_defs$4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "menu_12_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h12v12H0z"
  })))));
};
var Menu12 = (/* unused pure expression or super */ null && (SvgMenu12));

var _path$5g;
function _extends$5k() { _extends$5k = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$5k.apply(this, arguments); }
var SvgMenu16 = function SvgMenu16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$5k({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path$5g || (_path$5g = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M.917 3.667a.75.75 0 0 1 .75-.75h12.666a.75.75 0 0 1 0 1.5H1.667a.75.75 0 0 1-.75-.75M.917 8a.75.75 0 0 1 .75-.75h12.666a.75.75 0 0 1 0 1.5H1.667A.75.75 0 0 1 .917 8M.917 12.333a.75.75 0 0 1 .75-.75h12.666a.75.75 0 1 1 0 1.5H1.667a.75.75 0 0 1-.75-.75",
    clipRule: "evenodd"
  })));
};
var Menu16 = (/* unused pure expression or super */ null && (SvgMenu16));

var _path$5f;
function _extends$5j() { _extends$5j = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$5j.apply(this, arguments); }
var SvgMenu18 = function SvgMenu18(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$5j({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _path$5f || (_path$5f = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M1.075 4.125a.8.8 0 0 1 .8-.8h14.25a.8.8 0 0 1 0 1.6H1.875a.8.8 0 0 1-.8-.8M1.075 9a.8.8 0 0 1 .8-.8h14.25a.8.8 0 0 1 0 1.6H1.875a.8.8 0 0 1-.8-.8M1.075 13.875a.8.8 0 0 1 .8-.8h14.25a.8.8 0 0 1 0 1.6H1.875a.8.8 0 0 1-.8-.8",
    clipRule: "evenodd"
  })));
};
var Menu18 = (/* unused pure expression or super */ null && (SvgMenu18));

var _path$5e;
function _extends$5i() { _extends$5i = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$5i.apply(this, arguments); }
var SvgMenu24 = function SvgMenu24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$5i({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path$5e || (_path$5e = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M1.6 5.5a.9.9 0 0 1 .9-.9h19a.9.9 0 0 1 0 1.8h-19a.9.9 0 0 1-.9-.9M1.6 12a.9.9 0 0 1 .9-.9h19a.9.9 0 0 1 0 1.8h-19a.9.9 0 0 1-.9-.9M1.6 18.5a.9.9 0 0 1 .9-.9h19a.9.9 0 0 1 0 1.8h-19a.9.9 0 0 1-.9-.9",
    clipRule: "evenodd"
  })));
};
var Menu24 = (/* unused pure expression or super */ null && (SvgMenu24));

var _path$5d;
function _extends$5h() { _extends$5h = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$5h.apply(this, arguments); }
var SvgMenu32 = function SvgMenu32(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$5h({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _path$5d || (_path$5d = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M2.333 7.333a1 1 0 0 1 1-1h25.334a1 1 0 1 1 0 2H3.333a1 1 0 0 1-1-1m0 8.667a1 1 0 0 1 1-1h25.334a1 1 0 1 1 0 2H3.333a1 1 0 0 1-1-1m0 8.667a1 1 0 0 1 1-1h25.334a1 1 0 0 1 0 2H3.333a1 1 0 0 1-1-1",
    clipRule: "evenodd"
  })));
};
var Menu32 = (/* unused pure expression or super */ null && (SvgMenu32));

var _path$5c;
function _extends$5g() { _extends$5g = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$5g.apply(this, arguments); }
var SvgMenu48 = function SvgMenu48(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$5g({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none"
  }, props), _path$5c || (_path$5c = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M3.8 11A1.2 1.2 0 0 1 5 9.8h38a1.2 1.2 0 0 1 0 2.4H5A1.2 1.2 0 0 1 3.8 11m0 13A1.2 1.2 0 0 1 5 22.8h38a1.2 1.2 0 1 1 0 2.4H5A1.2 1.2 0 0 1 3.8 24m0 13A1.2 1.2 0 0 1 5 35.8h38a1.2 1.2 0 0 1 0 2.4H5A1.2 1.2 0 0 1 3.8 37",
    clipRule: "evenodd"
  })));
};
var Menu48 = (/* unused pure expression or super */ null && (SvgMenu48));

var MenuIcon = function MenuIcon(props) {
  var menu = {
    12: Menu12,
    16: Menu16,
    18: Menu18,
    24: Menu24,
    32: Menu32,
    48: Menu48
  };
  return jsx(IconTemplate, _assign({
    icons: menu
  }, props));
};

var _path$5b;
function _extends$5f() { _extends$5f = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$5f.apply(this, arguments); }
var SvgMenuFold12 = function SvgMenuFold12(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends$5f({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none"
  }, props), _path$5b || (_path$5b = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M5.339 2.667a.6.6 0 0 1 .6-.6h4.394a.6.6 0 1 1 0 1.2H5.94a.6.6 0 0 1-.6-.6m-1.037.872a.6.6 0 0 1-.029.849L3.19 5.4h7.144a.6.6 0 1 1 0 1.2H3.19l1.084 1.013a.6.6 0 0 1-.819.877L1.257 6.44a.6.6 0 0 1 0-.877L3.454 3.51a.6.6 0 0 1 .848.03m6.031 6.395H5.94a.6.6 0 0 1 0-1.2h4.394a.6.6 0 1 1 0 1.2",
    clipRule: "evenodd"
  })));
};
var MenuFold12 = SvgMenuFold12;

var _path$5a;
function _extends$5e() { _extends$5e = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$5e.apply(this, arguments); }
var SvgMenuFold16 = function SvgMenuFold16(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends$5e({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path$5a || (_path$5a = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M7.219 3.555a.7.7 0 0 1 .7-.7h5.859a.7.7 0 1 1 0 1.4h-5.86a.7.7 0 0 1-.7-.7M5.663 4.787a.7.7 0 0 1-.034.99L3.998 7.3h9.78a.7.7 0 1 1 0 1.4h-9.78l1.631 1.523a.7.7 0 0 1-.955 1.024l-2.93-2.735a.7.7 0 0 1 0-1.024l2.93-2.735a.7.7 0 0 1 .99.034m8.115 8.357h-5.86a.7.7 0 1 1 0-1.4h5.86a.7.7 0 1 1 0 1.4",
    clipRule: "evenodd"
  })));
};
var MenuFold16 = SvgMenuFold16;

var _path$59;
function _extends$5d() { _extends$5d = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$5d.apply(this, arguments); }
var SvgMenuFold18 = function SvgMenuFold18(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends$5d({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _path$59 || (_path$59 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M8.108 4a.8.8 0 0 1 .8-.8H15.5a.8.8 0 0 1 0 1.6H8.908a.8.8 0 0 1-.8-.8M6.38 5.377a.8.8 0 0 1-.038 1.131L4.529 8.2H15.5a.8.8 0 0 1 0 1.6H4.53l1.812 1.692a.8.8 0 1 1-1.092 1.17L1.954 9.585a.8.8 0 0 1 0-1.17L5.25 5.34a.8.8 0 0 1 1.13.038M8.108 14a.8.8 0 0 1 .8-.8H15.5a.8.8 0 0 1 0 1.6H8.908a.8.8 0 0 1-.8-.8",
    clipRule: "evenodd"
  })));
};
var MenuFold18 = SvgMenuFold18;

var _path$58;
function _extends$5c() { _extends$5c = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$5c.apply(this, arguments); }
var SvgMenuFold24 = function SvgMenuFold24(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends$5c({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path$58 || (_path$58 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M10.978 5.333a.9.9 0 0 1 .9-.9h8.789a.9.9 0 0 1 0 1.8h-8.789a.9.9 0 0 1-.9-.9m-2.592 1.95a.9.9 0 0 1-.044 1.272L5.616 11.1h15.05a.9.9 0 0 1 0 1.8H5.617l2.726 2.544a.9.9 0 1 1-1.228 1.316l-4.395-4.102a.9.9 0 0 1 0-1.316l4.395-4.103a.9.9 0 0 1 1.272.044m12.28 12.283h-8.788a.9.9 0 1 1 0-1.8h8.789a.9.9 0 0 1 0 1.8",
    clipRule: "evenodd"
  })));
};
var MenuFold24 = SvgMenuFold24;

var _path$57;
function _extends$5b() { _extends$5b = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$5b.apply(this, arguments); }
var SvgMenuFold32 = function SvgMenuFold32(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends$5b({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _path$57 || (_path$57 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M14.837 7.111a1 1 0 0 1 1-1h11.718a1 1 0 1 1 0 2H15.837a1 1 0 0 1-1-1m-3.802 2.737a1 1 0 0 1-.05 1.413l-4.004 3.74h20.574a1 1 0 1 1 0 2H6.981l4.005 3.738a1 1 0 0 1-1.365 1.462l-5.86-5.47a1 1 0 0 1 0-1.462l5.86-5.47a1 1 0 0 1 1.413.049m16.52 16.041H15.837a1 1 0 0 1 0-2h11.718a1 1 0 1 1 0 2",
    clipRule: "evenodd"
  })));
};
var MenuFold32 = SvgMenuFold32;

var _path$56;
function _extends$5a() { _extends$5a = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$5a.apply(this, arguments); }
var SvgMenuFold48 = function SvgMenuFold48(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends$5a({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none"
  }, props), _path$56 || (_path$56 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M22.506 10.667c0-.69.56-1.25 1.25-1.25h17.577a1.25 1.25 0 1 1 0 2.5H23.756c-.69 0-1.25-.56-1.25-1.25m-6.137 4.275a1.25 1.25 0 0 1-.06 1.766L9.836 22.75h31.496a1.25 1.25 0 0 1 0 2.5H9.837l6.471 6.041a1.25 1.25 0 0 1-1.706 1.828l-8.788-8.205a1.25 1.25 0 0 1 0-1.828l8.789-8.205a1.25 1.25 0 0 1 1.766.06m24.964 23.641H23.756a1.25 1.25 0 0 1 0-2.5h17.577a1.25 1.25 0 1 1 0 2.5",
    clipRule: "evenodd"
  })));
};
var MenuFold48 = SvgMenuFold48;

var MenuFoldIcon = function MenuFoldIcon(props) {
  var menuFold = {
    12: MenuFold12,
    16: MenuFold16,
    18: MenuFold18,
    24: MenuFold24,
    32: MenuFold32,
    48: MenuFold48
  };
  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(IconTemplate, (0,_common_js__WEBPACK_IMPORTED_MODULE_2__.a)({
    icons: menuFold
  }, props));
};

var _path$55;
function _extends$59() { _extends$59 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$59.apply(this, arguments); }
var SvgMenuOpen12 = function SvgMenuOpen12(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends$59({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none"
  }, props), _path$55 || (_path$55 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M6.661 9.333a.6.6 0 0 1-.6.6H1.667a.6.6 0 0 1 0-1.2H6.06a.6.6 0 0 1 .6.6m1.037-.872a.6.6 0 0 1 .029-.849L8.81 6.6H1.667a.6.6 0 0 1 0-1.2H8.81L7.727 4.387a.6.6 0 0 1 .819-.877l2.197 2.051a.6.6 0 0 1 0 .877L8.546 8.49a.6.6 0 0 1-.848-.03M1.667 2.066H6.06a.6.6 0 0 1 0 1.2H1.667a.6.6 0 0 1 0-1.2",
    clipRule: "evenodd"
  })));
};
var MenuOpen12 = SvgMenuOpen12;

var _path$54;
function _extends$58() { _extends$58 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$58.apply(this, arguments); }
var SvgMenuOpen16 = function SvgMenuOpen16(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends$58({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path$54 || (_path$54 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M8.781 12.445a.7.7 0 0 1-.7.7H2.222a.7.7 0 1 1 0-1.4h5.86a.7.7 0 0 1 .7.7m1.555-1.232a.7.7 0 0 1 .034-.99L12.003 8.7h-9.78a.7.7 0 1 1 0-1.4h9.78L10.37 5.777a.7.7 0 1 1 .956-1.024l2.93 2.735a.7.7 0 0 1 0 1.024l-2.93 2.735a.7.7 0 0 1-.99-.034M2.222 2.856h5.86a.7.7 0 1 1 0 1.4h-5.86a.7.7 0 1 1 0-1.4",
    clipRule: "evenodd"
  })));
};
var MenuOpen16 = SvgMenuOpen16;

var _path$53;
function _extends$57() { _extends$57 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$57.apply(this, arguments); }
var SvgMenuOpen18 = function SvgMenuOpen18(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends$57({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _path$53 || (_path$53 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M9.892 14a.8.8 0 0 1-.8.8H2.5a.8.8 0 0 1 0-1.6h6.592a.8.8 0 0 1 .8.8m1.728-1.377a.8.8 0 0 1 .038-1.131L13.471 9.8H2.5a.8.8 0 1 1-.001-1.6h10.97l-1.812-1.692a.8.8 0 0 1 1.092-1.17l3.296 3.077a.8.8 0 0 1 0 1.17L12.75 12.66a.8.8 0 0 1-1.13-.038M9.892 4a.8.8 0 0 1-.8.8H2.5a.8.8 0 1 1 0-1.6h6.592a.8.8 0 0 1 .8.8",
    clipRule: "evenodd"
  })));
};
var MenuOpen18 = SvgMenuOpen18;

var _path$52;
function _extends$56() { _extends$56 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$56.apply(this, arguments); }
var SvgMenuOpen24 = function SvgMenuOpen24(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends$56({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path$52 || (_path$52 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M13.022 18.667a.9.9 0 0 1-.9.9H3.333a.9.9 0 0 1 0-1.8h8.79a.9.9 0 0 1 .9.9m2.592-1.95a.9.9 0 0 1 .044-1.272l2.726-2.545H3.334a.9.9 0 1 1 0-1.8h15.05l-2.726-2.544a.9.9 0 0 1 1.229-1.316l4.394 4.102a.9.9 0 0 1 0 1.316l-4.394 4.103a.9.9 0 0 1-1.273-.044M3.334 4.434h8.788a.9.9 0 0 1 0 1.8H3.333a.9.9 0 1 1 0-1.8",
    clipRule: "evenodd"
  })));
};
var MenuOpen24 = SvgMenuOpen24;

var _path$51;
function _extends$55() { _extends$55 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$55.apply(this, arguments); }
var SvgMenuOpen32 = function SvgMenuOpen32(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends$55({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _path$51 || (_path$51 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M17.163 24.889a1 1 0 0 1-1 1H4.445a1 1 0 1 1 0-2h11.718a1 1 0 0 1 1 1m3.803-2.737a1 1 0 0 1 .048-1.413l4.005-3.74H4.445a1 1 0 1 1 0-2h20.574l-4.005-3.738a1 1 0 0 1 1.365-1.462l5.86 5.47a1 1 0 0 1 0 1.462l-5.86 5.47a1 1 0 0 1-1.413-.049M4.445 6.111h11.718a1 1 0 0 1 0 2H4.445a1 1 0 1 1 0-2",
    clipRule: "evenodd"
  })));
};
var MenuOpen32 = SvgMenuOpen32;

var _path$50;
function _extends$54() { _extends$54 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$54.apply(this, arguments); }
var SvgMenuOpen48 = function SvgMenuOpen48(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends$54({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none"
  }, props), _path$50 || (_path$50 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M25.494 37.334c0 .69-.56 1.25-1.25 1.25H6.667a1.25 1.25 0 1 1 0-2.5h17.577c.69 0 1.25.56 1.25 1.25m6.137-4.276a1.25 1.25 0 0 1 .06-1.766l6.472-6.042H6.667a1.25 1.25 0 0 1 0-2.5h31.496l-6.471-6.041a1.25 1.25 0 0 1 1.706-1.828l8.788 8.206a1.25 1.25 0 0 1 0 1.827l-8.788 8.205a1.25 1.25 0 0 1-1.767-.06M6.667 9.417h17.577a1.25 1.25 0 0 1 0 2.5H6.667a1.25 1.25 0 1 1 0-2.5",
    clipRule: "evenodd"
  })));
};
var MenuOpen48 = SvgMenuOpen48;

var MenuOpenIcon = function MenuOpenIcon(props) {
  var menuOpen = {
    12: MenuOpen12,
    16: MenuOpen16,
    18: MenuOpen18,
    24: MenuOpen24,
    32: MenuOpen32,
    48: MenuOpen48
  };
  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(IconTemplate, (0,_common_js__WEBPACK_IMPORTED_MODULE_2__.a)({
    icons: menuOpen
  }, props));
};

var _path$4$;
function _extends$53() { _extends$53 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$53.apply(this, arguments); }
var SvgMoreHorizontal12 = function SvgMoreHorizontal12(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$53({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none"
  }, props), _path$4$ || (_path$4$ = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M3.5 6a1 1 0 1 1-2 0 1 1 0 0 1 2 0M7 6a1 1 0 1 1-2 0 1 1 0 0 1 2 0M10.5 6a1 1 0 1 1-2 0 1 1 0 0 1 2 0"
  })));
};
var MoreHorizontal12 = (/* unused pure expression or super */ null && (SvgMoreHorizontal12));

var _path$4_;
function _extends$52() { _extends$52 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$52.apply(this, arguments); }
var SvgMoreHorizontal16 = function SvgMoreHorizontal16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$52({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path$4_ || (_path$4_ = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M4.667 8A1.333 1.333 0 1 1 2 8a1.333 1.333 0 0 1 2.667 0M9.333 8a1.333 1.333 0 1 1-2.666 0 1.333 1.333 0 0 1 2.666 0M14 8a1.333 1.333 0 1 1-2.667 0A1.333 1.333 0 0 1 14 8"
  })));
};
var MoreHorizontal16 = (/* unused pure expression or super */ null && (SvgMoreHorizontal16));

var _path$4Z;
function _extends$51() { _extends$51 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$51.apply(this, arguments); }
var SvgMoreHorizontal18 = function SvgMoreHorizontal18(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$51({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _path$4Z || (_path$4Z = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M5.25 9a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0M10.5 9a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0M15.75 9a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0"
  })));
};
var MoreHorizontal18 = (/* unused pure expression or super */ null && (SvgMoreHorizontal18));

var _path$4Y;
function _extends$50() { _extends$50 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$50.apply(this, arguments); }
var SvgMoreHorizontal24 = function SvgMoreHorizontal24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$50({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path$4Y || (_path$4Y = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M7 12a2 2 0 1 1-4 0 2 2 0 0 1 4 0M14 12a2 2 0 1 1-4 0 2 2 0 0 1 4 0M21 12a2 2 0 1 1-4 0 2 2 0 0 1 4 0"
  })));
};
var MoreHorizontal24 = (/* unused pure expression or super */ null && (SvgMoreHorizontal24));

var _path$4X;
function _extends$4$() { _extends$4$ = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$4$.apply(this, arguments); }
var SvgMoreHorizontal32 = function SvgMoreHorizontal32(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$4$({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _path$4X || (_path$4X = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M9.5 16a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0M18.5 16a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0M27.5 16a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0"
  })));
};
var MoreHorizontal32 = (/* unused pure expression or super */ null && (SvgMoreHorizontal32));

var _path$4W;
function _extends$4_() { _extends$4_ = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$4_.apply(this, arguments); }
var SvgMoreHorizontal48 = function SvgMoreHorizontal48(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$4_({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none"
  }, props), _path$4W || (_path$4W = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M15 24a3 3 0 1 1-6 0 3 3 0 0 1 6 0M27 24a3 3 0 1 1-6 0 3 3 0 0 1 6 0M39 24a3 3 0 1 1-6 0 3 3 0 0 1 6 0"
  })));
};
var MoreHorizontal48 = (/* unused pure expression or super */ null && (SvgMoreHorizontal48));

var MoreHorizontalIcon = function MoreHorizontalIcon(props) {
  var moreHorizontal = {
    12: MoreHorizontal12,
    16: MoreHorizontal16,
    18: MoreHorizontal18,
    24: MoreHorizontal24,
    32: MoreHorizontal32,
    48: MoreHorizontal48
  };
  return jsx(IconTemplate, _assign({
    icons: moreHorizontal
  }, props));
};

var _path$4V;
function _extends$4Z() { _extends$4Z = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$4Z.apply(this, arguments); }
var SvgMoreVertical12 = function SvgMoreVertical12(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$4Z({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none"
  }, props), _path$4V || (_path$4V = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M6 8.5a1 1 0 1 1 0 2 1 1 0 0 1 0-2M6 5a1 1 0 1 1 0 2 1 1 0 0 1 0-2M6 1.5a1 1 0 1 1 0 2 1 1 0 0 1 0-2"
  })));
};
var MoreVertical12 = (/* unused pure expression or super */ null && (SvgMoreVertical12));

var _path$4U;
function _extends$4Y() { _extends$4Y = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$4Y.apply(this, arguments); }
var SvgMoreVertical16 = function SvgMoreVertical16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$4Y({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path$4U || (_path$4U = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M8 11.334A1.333 1.333 0 1 1 8 14a1.333 1.333 0 0 1 0-2.666M8 6.667a1.333 1.333 0 1 1 0 2.667 1.333 1.333 0 0 1 0-2.667M8 2a1.333 1.333 0 1 1 0 2.667A1.333 1.333 0 0 1 8 2"
  })));
};
var MoreVertical16 = (/* unused pure expression or super */ null && (SvgMoreVertical16));

var _path$4T;
function _extends$4X() { _extends$4X = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$4X.apply(this, arguments); }
var SvgMoreVertical18 = function SvgMoreVertical18(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$4X({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _path$4T || (_path$4T = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M9 12.75a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3M9 7.5a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3M9 2.25a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3"
  })));
};
var MoreVertical18 = (/* unused pure expression or super */ null && (SvgMoreVertical18));

var _path$4S;
function _extends$4W() { _extends$4W = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$4W.apply(this, arguments); }
var SvgMoreVertical24 = function SvgMoreVertical24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$4W({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path$4S || (_path$4S = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M12 17a2 2 0 1 1 0 4 2 2 0 0 1 0-4M12 10a2 2 0 1 1 0 4 2 2 0 0 1 0-4M12 3a2 2 0 1 1 0 4 2 2 0 0 1 0-4"
  })));
};
var MoreVertical24 = (/* unused pure expression or super */ null && (SvgMoreVertical24));

var _path$4R;
function _extends$4V() { _extends$4V = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$4V.apply(this, arguments); }
var SvgMoreVertical32 = function SvgMoreVertical32(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$4V({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _path$4R || (_path$4R = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M16 22.5a2.5 2.5 0 1 1 0 5 2.5 2.5 0 0 1 0-5M16 13.5a2.5 2.5 0 1 1 0 5 2.5 2.5 0 0 1 0-5M16 4.5a2.5 2.5 0 1 1 0 5 2.5 2.5 0 0 1 0-5"
  })));
};
var MoreVertical32 = (/* unused pure expression or super */ null && (SvgMoreVertical32));

var _path$4Q;
function _extends$4U() { _extends$4U = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$4U.apply(this, arguments); }
var SvgMoreVertical48 = function SvgMoreVertical48(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$4U({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none"
  }, props), _path$4Q || (_path$4Q = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M24 33a3 3 0 1 1 0 6 3 3 0 0 1 0-6M24 21a3 3 0 1 1 0 6 3 3 0 0 1 0-6M24 9a3 3 0 1 1 0 6 3 3 0 0 1 0-6"
  })));
};
var MoreVertical48 = (/* unused pure expression or super */ null && (SvgMoreVertical48));

var MoreVerticalIcon = function MoreVerticalIcon(props) {
  var moreVertical = {
    12: MoreVertical12,
    16: MoreVertical16,
    18: MoreVertical18,
    24: MoreVertical24,
    32: MoreVertical32,
    48: MoreVertical48
  };
  return jsx(IconTemplate, _assign({
    icons: moreVertical
  }, props));
};

var _path$4P;
function _extends$4T() { _extends$4T = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$4T.apply(this, arguments); }
var SvgNotification12 = function SvgNotification12(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$4T({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none"
  }, props), _path$4P || (_path$4P = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M6 2a2.99 2.99 0 0 0-2.987 2.988v1.907c0 .25-.1.49-.277.667l-.2.2L2.5 7.8v.176h7v-.176l-.036-.037-.2-.2a.94.94 0 0 1-.276-.667V4.988A2.99 2.99 0 0 0 6 2M1.813 4.988a4.188 4.188 0 0 1 8.375 0v1.801l.124.125.013.012a1.113 1.113 0 0 1 .375.906v.062c0 .147.002.346-.058.524-.111.329-.368.588-.698.699-.178.06-.377.059-.523.058H8.136a2.138 2.138 0 0 1-4.272 0H2.58c-.146 0-.345.002-.523-.058a1.11 1.11 0 0 1-.699-.699c-.06-.178-.059-.377-.058-.524v-.062c0-.066 0-.158.015-.25.027-.168.094-.329.194-.468.054-.076.12-.14.167-.188l.012-.012.125-.125zm3.254 4.187a.938.938 0 0 0 1.867 0z",
    clipRule: "evenodd"
  })));
};
var Notification12 = (/* unused pure expression or super */ null && (SvgNotification12));

var _path$4O;
function _extends$4S() { _extends$4S = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$4S.apply(this, arguments); }
var SvgNotification16 = function SvgNotification16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$4S({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path$4O || (_path$4O = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M8 2.617A4.033 4.033 0 0 0 3.967 6.65v2.544c0 .32-.128.628-.354.854l-.266.266-.05.05-.013.014v.304l.213.002h9.007c.098 0 .163 0 .211-.002.002-.049.002-.115.002-.215v-.09l-.013-.012-.05-.05-.267-.267a1.2 1.2 0 0 1-.354-.854V6.65A4.033 4.033 0 0 0 8 2.617M2.467 6.65a5.533 5.533 0 0 1 11.067 0v2.423l.18.18.017.018a1.433 1.433 0 0 1 .466.847c.02.118.02.236.02.326v.081c0 .197.002.454-.075.683a1.43 1.43 0 0 1-.9.9c-.229.078-.485.077-.681.076h-1.762a2.8 2.8 0 0 1-5.598 0H3.439c-.195 0-.451.002-.68-.075a1.43 1.43 0 0 1-.9-.9c-.078-.23-.077-.487-.076-.684v-.082c0-.089 0-.207.02-.325.035-.217.12-.424.25-.604.07-.097.153-.18.216-.244l.017-.017.18-.18zm4.235 5.534a1.3 1.3 0 0 0 2.596 0z",
    clipRule: "evenodd"
  })));
};
var Notification16 = (/* unused pure expression or super */ null && (SvgNotification16));

var _path$4N;
function _extends$4R() { _extends$4R = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$4R.apply(this, arguments); }
var SvgNotification18 = function SvgNotification18(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$4R({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _path$4N || (_path$4N = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M9 2.9a4.58 4.58 0 0 0-4.581 4.581v2.862c0 .35-.14.684-.386.93l-.3.3-.082.084-.001.119c0 .141 0 .224.003.284.059.002.14.003.28.003h10.134c.139 0 .22 0 .28-.003a8 8 0 0 0 .002-.404l-.083-.084-.3-.299a1.32 1.32 0 0 1-.385-.93V7.481A4.58 4.58 0 0 0 9 2.9M2.819 7.481a6.181 6.181 0 0 1 12.362 0v2.744l.216.216.02.02c.07.07.163.162.239.268.142.198.234.425.273.66.021.13.021.26.021.36v.091c.001.224.002.505-.082.755-.157.463-.52.829-.985.986-.25.084-.53.083-.752.082h-2.024a3.106 3.106 0 0 1-6.213 0H3.869c-.221 0-.502.002-.751-.082a1.57 1.57 0 0 1-.986-.986c-.084-.25-.083-.531-.082-.755v-.092c0-.1 0-.23.02-.358.04-.238.133-.465.274-.661.077-.107.168-.198.24-.27l.019-.018.216-.216zm4.675 6.182a1.506 1.506 0 0 0 3.012 0z",
    clipRule: "evenodd"
  })));
};
var Notification18 = (/* unused pure expression or super */ null && (SvgNotification18));

var _path$4M;
function _extends$4Q() { _extends$4Q = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$4Q.apply(this, arguments); }
var SvgNotification24 = function SvgNotification24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$4Q({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path$4M || (_path$4M = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M12 3.7a6.275 6.275 0 0 0-6.275 6.275v3.816c0 .421-.168.825-.465 1.122l-.4.4-.139.142a.1.1 0 0 0-.019.046v.023l-.002.177c0 .208 0 .326.005.413l.006.061a.13.13 0 0 0 .064.065l.06.005c.086.005.204.005.41.005h13.51c.207 0 .324 0 .411-.005l.06-.005a.12.12 0 0 0 .064-.064l.005-.061c.005-.088.005-.206.005-.414l-.001-.176-.001-.024a.1.1 0 0 0-.019-.046l-.016-.017-.124-.126-.399-.4a1.59 1.59 0 0 1-.465-1.121V9.975A6.275 6.275 0 0 0 12 3.7M3.925 9.975a8.075 8.075 0 0 1 16.15 0v3.727l.337.337.025.025c.096.096.209.209.302.338.175.243.288.521.335.811.026.159.026.317.026.455v.117c.001.304.002.65-.101.956a1.92 1.92 0 0 1-1.208 1.209c-.305.102-.65.101-.952.1h-2.863v.125a3.975 3.975 0 1 1-7.95 0v-.125H5.16c-.301.001-.646.002-.95-.1A1.93 1.93 0 0 1 3 16.74c-.103-.305-.102-.651-.101-.955v-.12c0-.136 0-.294.025-.452.048-.292.163-.57.336-.81.094-.131.206-.243.303-.34l.024-.024.337-.337zm5.9 8.075v.125a2.175 2.175 0 0 0 4.35 0v-.125z",
    clipRule: "evenodd"
  })));
};
var Notification24 = (/* unused pure expression or super */ null && (SvgNotification24));

var _path$4L;
function _extends$4P() { _extends$4P = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$4P.apply(this, arguments); }
var SvgNotification32 = function SvgNotification32(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$4P({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _path$4L || (_path$4L = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M16 4.733A8.567 8.567 0 0 0 7.433 13.3v5.088c0 .508-.202.995-.56 1.354l-.533.533a8 8 0 0 0-.2.205l-.004.005v.001a.37.37 0 0 0-.067.207c-.002.052-.002.12-.002.241 0 .275 0 .44.007.563a1 1 0 0 0 .013.123c.037.106.12.19.227.227.007.002.04.008.121.013.122.007.285.007.558.007h18.015c.272 0 .436 0 .558-.007a1 1 0 0 0 .122-.013.37.37 0 0 0 .225-.225s.008-.031.013-.125c.007-.123.007-.288.007-.563a9 9 0 0 0-.003-.271v-.014l-.002-.007v-.001a.4.4 0 0 0-.063-.155c.002.003-.003-.005-.035-.04l-.17-.171-.532-.533a1.92 1.92 0 0 1-.56-1.355V13.3A8.567 8.567 0 0 0 16 4.733M5.433 13.3C5.433 7.464 10.164 2.733 16 2.733S26.567 7.464 26.567 13.3v5.053l.508.507.032.032c.13.13.269.269.383.428.214.298.353.64.412.997.032.194.032.389.031.576v.15c.002.413.003.84-.124 1.214a2.37 2.37 0 0 1-1.485 1.486c-.373.126-.8.125-1.21.124H21.1v.367a5.1 5.1 0 1 1-10.2 0v-.367H6.886c-.41.001-.835.002-1.209-.124a2.37 2.37 0 0 1-1.486-1.486c-.126-.375-.125-.801-.124-1.214v-.154c0-.184 0-.379.031-.572.059-.36.2-.7.413-.997a3.5 3.5 0 0 1 .415-.46l.507-.508zM12.9 23.867v.367a3.1 3.1 0 0 0 6.2 0v-.367z",
    clipRule: "evenodd"
  })));
};
var Notification32 = (/* unused pure expression or super */ null && (SvgNotification32));

var _path$4K;
function _extends$4O() { _extends$4O = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$4O.apply(this, arguments); }
var SvgNotification48 = function SvgNotification48(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$4O({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none"
  }, props), _path$4K || (_path$4K = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M24 6.8c-7.262 0-13.15 5.888-13.15 13.15v7.631c0 .684-.272 1.338-.754 1.82l-.799.799c-.27.27-.31.316-.338.354a.85.85 0 0 0-.148.358c-.007.046-.011.105-.011.49 0 .887.016 1.035.045 1.12a.85.85 0 0 0 .534.534c.084.029.23.044 1.11.044h27.022c.88 0 1.028-.015 1.112-.044a.85.85 0 0 0 .532-.533c.03-.086.045-.234.045-1.121 0-.383-.004-.443-.012-.49a.85.85 0 0 0-.147-.358c-.026-.037-.066-.082-.338-.354l-.799-.799a2.57 2.57 0 0 1-.754-1.82v-7.63C37.15 12.687 31.264 6.8 24 6.8M8.45 19.95C8.45 11.362 15.412 4.4 24 4.4s15.55 6.962 15.55 15.55v7.631c0 .046.019.09.052.123l.798.799.044.044c.2.2.39.39.547.607.294.41.485.88.566 1.37.043.266.043.534.043.822v.207c.001.636.002 1.225-.17 1.737a3.25 3.25 0 0 1-2.04 2.04c-.51.173-1.098.172-1.729.17h-6.31v.85a7.35 7.35 0 0 1-14.7 0v-.85H10.34c-.631.002-1.217.003-1.728-.17a3.25 3.25 0 0 1-2.042-2.04c-.172-.512-.171-1.101-.17-1.737v-.214c0-.284 0-.551.043-.815.08-.494.274-.962.567-1.37.157-.218.347-.408.55-.61l.04-.041.799-.799a.17.17 0 0 0 .051-.123zm10.6 15.55v.85a4.95 4.95 0 0 0 9.9 0v-.85z",
    clipRule: "evenodd"
  })));
};
var Notification48 = (/* unused pure expression or super */ null && (SvgNotification48));

var NotificationIcon = function NotificationIcon(props) {
  var notification = {
    12: Notification12,
    16: Notification16,
    18: Notification18,
    24: Notification24,
    32: Notification32,
    48: Notification48
  };
  return jsx(IconTemplate, _assign({
    icons: notification
  }, props));
};

var _path$4J;
function _extends$4N() { _extends$4N = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$4N.apply(this, arguments); }
var SvgNotificationFilled12 = function SvgNotificationFilled12(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$4N({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none"
  }, props), _path$4J || (_path$4J = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M5.997.95a4.144 4.144 0 0 0-4.144 4.144V7.02l-.19.19c-.05.05-.107.107-.155.173a1 1 0 0 0-.17.412c-.013.08-.013.16-.013.23v.062c0 .157-.001.332.051.488.098.29.325.516.614.614.155.052.33.051.486.051h1.488v.001H8.03v-.001h1.488c.156 0 .331.001.486-.051a.98.98 0 0 0 .614-.614c.052-.156.052-.331.051-.488v-.06c0-.071 0-.152-.013-.232a1 1 0 0 0-.17-.412 1.4 1.4 0 0 0-.154-.173l-.19-.19V5.094A4.144 4.144 0 0 0 5.997.95M7.933 9.94H4.061a2.034 2.034 0 0 0 3.872 0"
  })));
};
var NotificationFilled12 = (/* unused pure expression or super */ null && (SvgNotificationFilled12));

var _path$4I;
function _extends$4M() { _extends$4M = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$4M.apply(this, arguments); }
var SvgNotificationFilled16 = function SvgNotificationFilled16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$4M({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path$4I || (_path$4I = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M7.996 1.267A5.526 5.526 0 0 0 2.47 6.793v2.566l-.252.252c-.067.067-.143.143-.207.231a1.3 1.3 0 0 0-.227.55 2 2 0 0 0-.017.307v.082c-.001.21-.002.444.068.65.13.387.433.69.819.82.206.069.44.068.647.068h1.984v.001h5.422v-.002h1.984c.208.001.442.002.648-.068.387-.13.688-.434.818-.818.07-.207.07-.442.069-.65V10.7c0-.095 0-.202-.018-.31a1.3 1.3 0 0 0-.227-.549c-.063-.087-.14-.164-.205-.23l-.254-.253V6.793a5.526 5.526 0 0 0-5.526-5.526M10.578 13.253H5.415a2.712 2.712 0 0 0 5.163 0"
  })));
};
var NotificationFilled16 = (/* unused pure expression or super */ null && (SvgNotificationFilled16));

var _path$4H;
function _extends$4L() { _extends$4L = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$4L.apply(this, arguments); }
var SvgNotificationFilled18 = function SvgNotificationFilled18(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$4L({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _path$4H || (_path$4H = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M8.995 1.425A6.217 6.217 0 0 0 2.78 7.642v2.887l-.284.284c-.076.075-.161.16-.233.26-.132.184-.22.395-.256.617-.02.12-.02.241-.019.347v.092c0 .235-.002.499.077.732.146.434.487.774.921.92.233.079.495.078.729.077h2.231v.002h6.1v-.002h2.232c.234.001.497.002.73-.076.434-.147.774-.488.92-.921.078-.233.077-.497.077-.732v-.09c0-.107 0-.228-.02-.348a1.5 1.5 0 0 0-.255-.618c-.071-.1-.157-.185-.232-.26l-.285-.284V7.642a6.217 6.217 0 0 0-6.217-6.217M11.9 14.91H6.09a3.051 3.051 0 0 0 5.808 0"
  })));
};
var NotificationFilled18 = (/* unused pure expression or super */ null && (SvgNotificationFilled18));

var _path$4G;
function _extends$4K() { _extends$4K = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$4K.apply(this, arguments); }
var SvgNotificationFilled24 = function SvgNotificationFilled24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$4K({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path$4G || (_path$4G = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M11.994 1.9a8.29 8.29 0 0 0-8.289 8.289v3.85l-.379.378c-.1.1-.214.214-.31.347a1.96 1.96 0 0 0-.34.823c-.027.16-.026.322-.026.462v.123c-.001.313-.002.665.102.975.196.58.65 1.033 1.229 1.228.31.105.66.104.97.103h2.9770000000000003v.002h8.133v-.002h2.976c.31 0 .662.002.972-.103a1.95 1.95 0 0 0 1.227-1.227c.104-.311.104-.663.102-.976v-.12c0-.143 0-.304-.026-.465a1.95 1.95 0 0 0-.34-.823 3 3 0 0 0-.309-.345l-.38-.38v-3.85A8.29 8.29 0 0 0 11.994 1.9M15.866 19.88H8.122a4.068 4.068 0 0 0 7.744 0"
  })));
};
var NotificationFilled24 = (/* unused pure expression or super */ null && (SvgNotificationFilled24));

var _path$4F;
function _extends$4J() { _extends$4J = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$4J.apply(this, arguments); }
var SvgNotificationFilled32 = function SvgNotificationFilled32(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$4J({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _path$4F || (_path$4F = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M15.992 2.533c-6.103 0-11.051 4.948-11.051 11.052v5.133l-.506.505a4 4 0 0 0-.413.462c-.234.327-.39.703-.454 1.098a4 4 0 0 0-.035.616v.163c-.001.418-.003.887.137 1.301.26.772.867 1.378 1.638 1.638.413.139.88.138 1.295.136h3.967v.003h10.845v-.003h3.967c.415.002.883.003 1.296-.136a2.6 2.6 0 0 0 1.636-1.638c.14-.414.139-.883.137-1.3v-.161c0-.19 0-.404-.034-.619a2.6 2.6 0 0 0-.454-1.098c-.127-.176-.28-.328-.412-.46l-.507-.507v-5.133c0-6.104-4.948-11.052-11.052-11.052M21.155 26.507H10.83a5.425 5.425 0 0 0 10.325 0"
  })));
};
var NotificationFilled32 = (/* unused pure expression or super */ null && (SvgNotificationFilled32));

var _path$4E;
function _extends$4I() { _extends$4I = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$4I.apply(this, arguments); }
var SvgNotificationFilled48 = function SvgNotificationFilled48(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$4I({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none"
  }, props), _path$4E || (_path$4E = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M23.988 3.8c-9.155 0-16.577 7.422-16.577 16.578v7.698l-.758.758c-.202.201-.43.428-.62.693a3.9 3.9 0 0 0-.682 1.648c-.052.32-.052.642-.052.923v.245c-.002.627-.004 1.33.206 1.952A3.91 3.91 0 0 0 7.96 36.75c.62.209 1.32.207 1.943.205h5.9510000000000005v.004h16.267v-.004h5.9510000000000005c.623.002 1.325.004 1.944-.205a3.91 3.91 0 0 0 2.455-2.456c.209-.621.207-1.325.205-1.952v-.24c0-.285 0-.606-.052-.928a3.9 3.9 0 0 0-.681-1.648c-.19-.263-.419-.492-.617-.69l-.76-.76v-7.7c0-9.155-7.423-16.577-16.579-16.577M31.733 39.76H16.244a8.137 8.137 0 0 0 15.489 0"
  })));
};
var NotificationFilled48 = (/* unused pure expression or super */ null && (SvgNotificationFilled48));

var NotificationFilledIcon = function NotificationFilledIcon(props) {
  var notificationFilled = {
    12: NotificationFilled12,
    16: NotificationFilled16,
    18: NotificationFilled18,
    24: NotificationFilled24,
    32: NotificationFilled32,
    48: NotificationFilled48
  };
  return jsx(IconTemplate, _assign({
    icons: notificationFilled
  }, props));
};

var _path$4D, _path2$1K;
function _extends$4H() { _extends$4H = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$4H.apply(this, arguments); }
var SvgPhoto12 = function SvgPhoto12(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$4H({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none"
  }, props), _path$4D || (_path$4D = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M1.5 3.5a2 2 0 0 1 2-2h5a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2h-5a2 2 0 0 1-2-2zm2-.8h5a.8.8 0 0 1 .8.8v2.973l-.527-.517a.6.6 0 0 0-.764-.063l-1.239.868-2.232-2.19a.6.6 0 0 0-.84 0L2.7 5.55V3.5a.8.8 0 0 1 .8-.8m-.8 4.527V8.5a.8.8 0 0 0 .8.8h5a.8.8 0 0 0 .8-.8v-.365a.6.6 0 0 1-.099-.078l-.912-.895-1.239.868a.6.6 0 0 1-.764-.063L4.118 5.84 2.743 7.19z",
    clipRule: "evenodd"
  })), _path2$1K || (_path2$1K = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M8 4.25a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0"
  })));
};
var Photo12 = (/* unused pure expression or super */ null && (SvgPhoto12));

var _path$4C, _path2$1J;
function _extends$4G() { _extends$4G = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$4G.apply(this, arguments); }
var SvgPhoto16 = function SvgPhoto16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$4G({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path$4C || (_path$4C = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M11.5 3.5h-7a1 1 0 0 0-1 1v7a1 1 0 0 0 1 1h7a1 1 0 0 0 1-1v-7a1 1 0 0 0-1-1M4.5 2A2.5 2.5 0 0 0 2 4.5v7A2.5 2.5 0 0 0 4.5 14h7a2.5 2.5 0 0 0 2.5-2.5v-7A2.5 2.5 0 0 0 11.5 2z",
    clipRule: "evenodd"
  })), _path2$1J || (_path2$1J = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M5.647 6.25c.205 0 .4.084.542.232l2.777 2.904 1.526-1.14a.75.75 0 0 1 .991.082l2.06 2.154a.75.75 0 1 1-1.085 1.036l-1.6-1.673-1.527 1.14a.75.75 0 0 1-.99-.082L5.646 8.085l-2.105 2.202a.75.75 0 0 1-1.084-1.036l2.647-2.77a.75.75 0 0 1 .542-.231M9.5 5.8a.3.3 0 1 0 0-.6.3.3 0 0 0 0 .6m0 1.2a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3",
    clipRule: "evenodd"
  })));
};
var Photo16 = (/* unused pure expression or super */ null && (SvgPhoto16));

var _path$4B, _path2$1I;
function _extends$4F() { _extends$4F = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$4F.apply(this, arguments); }
var SvgPhoto18 = function SvgPhoto18(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$4F({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _path$4B || (_path$4B = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M13.25 3.85h-8.5a.9.9 0 0 0-.9.9v8.5a.9.9 0 0 0 .9.9h8.5a.9.9 0 0 0 .9-.9v-8.5a.9.9 0 0 0-.9-.9m-8.5-1.6a2.5 2.5 0 0 0-2.5 2.5v8.5a2.5 2.5 0 0 0 2.5 2.5h8.5a2.5 2.5 0 0 0 2.5-2.5v-8.5a2.5 2.5 0 0 0-2.5-2.5z",
    clipRule: "evenodd"
  })), _path2$1I || (_path2$1I = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M5.434 6.934a.8.8 0 0 1 1.13-.002l3.559 3.535 1.915-1.49a.8.8 0 0 1 1.11.124l2.203 2.692a.8.8 0 0 1-1.239 1.014l-1.707-2.088-1.855 1.443a.8.8 0 0 1-1.055-.064L6.002 8.63l-2.236 2.237a.8.8 0 0 1-1.132-1.132zM10.688 6.575a.388.388 0 1 0 0-.775.388.388 0 0 0 0 .775m0 1.3a1.687 1.687 0 1 0 0-3.375 1.687 1.687 0 0 0 0 3.375",
    clipRule: "evenodd"
  })));
};
var Photo18 = (/* unused pure expression or super */ null && (SvgPhoto18));

var _path$4A, _path2$1H;
function _extends$4E() { _extends$4E = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$4E.apply(this, arguments); }
var SvgPhoto24 = function SvgPhoto24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$4E({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path$4A || (_path$4A = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M18 4.8H6A1.2 1.2 0 0 0 4.8 6v12A1.2 1.2 0 0 0 6 19.2h12a1.2 1.2 0 0 0 1.2-1.2V6A1.2 1.2 0 0 0 18 4.8M6 3a3 3 0 0 0-3 3v12a3 3 0 0 0 3 3h12a3 3 0 0 0 3-3V6a3 3 0 0 0-3-3z",
    clipRule: "evenodd"
  })), _path2$1H || (_path2$1H = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M7.605 9.357a.9.9 0 0 1 1.26 0l4.643 4.554 2.682-1.879a.9.9 0 0 1 1.146.095l3.294 3.23a.9.9 0 1 1-1.26 1.285l-2.76-2.706-2.682 1.878a.9.9 0 0 1-1.146-.095l-4.547-4.458-3.605 3.535a.9.9 0 0 1-1.26-1.285zM14.25 8.8a.55.55 0 1 0 0-1.1.55.55 0 0 0 0 1.1m0 1.7a2.25 2.25 0 1 0 0-4.5 2.25 2.25 0 0 0 0 4.5",
    clipRule: "evenodd"
  })));
};
var Photo24 = (/* unused pure expression or super */ null && (SvgPhoto24));

var _path$4z, _path2$1G;
function _extends$4D() { _extends$4D = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$4D.apply(this, arguments); }
var SvgPhoto32 = function SvgPhoto32(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$4D({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _path$4z || (_path$4z = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M24 6H8a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2M8 4a4 4 0 0 0-4 4v16a4 4 0 0 0 4 4h16a4 4 0 0 0 4-4V8a4 4 0 0 0-4-4z",
    clipRule: "evenodd"
  })), _path2$1G || (_path2$1G = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M10.28 12.62a1 1 0 0 1 1.4 0l6.31 6.187 3.71-2.6a1 1 0 0 1 1.275.105l4.392 4.307a1 1 0 0 1-1.4 1.428l-3.8-3.726-3.711 2.6a1 1 0 0 1-1.274-.104l-6.202-6.083-4.947 4.852a1 1 0 1 1-1.4-1.428zM19 12a1 1 0 1 0 0-2 1 1 0 0 0 0 2m0 2a3 3 0 1 0 0-6 3 3 0 0 0 0 6",
    clipRule: "evenodd"
  })));
};
var Photo32 = (/* unused pure expression or super */ null && (SvgPhoto32));

var _path$4y, _path2$1F;
function _extends$4C() { _extends$4C = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$4C.apply(this, arguments); }
var SvgPhoto48 = function SvgPhoto48(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$4C({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none"
  }, props), _path$4y || (_path$4y = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M37 8.4H11A2.6 2.6 0 0 0 8.4 11v26a2.6 2.6 0 0 0 2.6 2.6h26a2.6 2.6 0 0 0 2.6-2.6V11A2.6 2.6 0 0 0 37 8.4M11 6a5 5 0 0 0-5 5v26a5 5 0 0 0 5 5h26a5 5 0 0 0 5-5V11a5 5 0 0 0-5-5z",
    clipRule: "evenodd"
  })), _path2$1F || (_path2$1F = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M15.152 19.152a1.2 1.2 0 0 1 1.697 0l10.28 10.28 6.174-4.408a1.2 1.2 0 0 1 1.546.127l6.5 6.5a1.2 1.2 0 1 1-1.697 1.698l-5.782-5.782-6.172 4.41a1.2 1.2 0 0 1-1.547-.128L16 21.697 8.349 29.35A1.2 1.2 0 1 1 6.65 27.65zM28.5 18.6a2.1 2.1 0 1 0 0-4.2 2.1 2.1 0 0 0 0 4.2m0 2.4a4.5 4.5 0 1 0 0-9 4.5 4.5 0 0 0 0 9",
    clipRule: "evenodd"
  })));
};
var Photo48 = (/* unused pure expression or super */ null && (SvgPhoto48));

var PhotoIcon = function PhotoIcon(props) {
  var photo = {
    12: Photo12,
    16: Photo16,
    18: Photo18,
    24: Photo24,
    32: Photo32,
    48: Photo48
  };
  return jsx(IconTemplate, _assign({
    icons: photo
  }, props));
};

var _path$4x, _path2$1E;
function _extends$4B() { _extends$4B = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$4B.apply(this, arguments); }
var SvgPlayCircle12 = function SvgPlayCircle12(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$4B({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none"
  }, props), _path$4x || (_path$4x = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M6 9.8a3.8 3.8 0 1 0 0-7.6 3.8 3.8 0 0 0 0 7.6M6 11A5 5 0 1 0 6 1a5 5 0 0 0 0 10",
    clipRule: "evenodd"
  })), _path2$1E || (_path2$1E = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M7.6 5.48a.6.6 0 0 1 0 1.04L5.65 7.645a.6.6 0 0 1-.9-.52v-2.25a.6.6 0 0 1 .9-.52z"
  })));
};
var PlayCircle12 = (/* unused pure expression or super */ null && (SvgPlayCircle12));

var _path$4w, _path2$1D;
function _extends$4A() { _extends$4A = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$4A.apply(this, arguments); }
var SvgPlayCircle16 = function SvgPlayCircle16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$4A({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path$4w || (_path$4w = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M8 13.167A5.167 5.167 0 1 0 8 2.833a5.167 5.167 0 0 0 0 10.334m0 1.5A6.667 6.667 0 1 0 8 1.333a6.667 6.667 0 0 0 0 13.334",
    clipRule: "evenodd"
  })), _path2$1D || (_path2$1D = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M10.433 7.48a.6.6 0 0 1 0 1.04l-3.2 1.847a.6.6 0 0 1-.9-.52V6.154a.6.6 0 0 1 .9-.52z"
  })));
};
var PlayCircle16 = (/* unused pure expression or super */ null && (SvgPlayCircle16));

var _path$4v, _path2$1C;
function _extends$4z() { _extends$4z = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$4z.apply(this, arguments); }
var SvgPlayCircle18 = function SvgPlayCircle18(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$4z({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _path$4v || (_path$4v = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M9 14.9A5.9 5.9 0 1 0 9 3.1a5.9 5.9 0 0 0 0 11.8m0 1.6a7.5 7.5 0 1 0 0-15 7.5 7.5 0 0 0 0 15",
    clipRule: "evenodd"
  })), _path2$1C || (_path2$1C = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M11.55 8.307a.8.8 0 0 1 0 1.386l-3.225 1.862a.8.8 0 0 1-1.2-.693V7.138a.8.8 0 0 1 1.2-.693z"
  })));
};
var PlayCircle18 = (/* unused pure expression or super */ null && (SvgPlayCircle18));

var _path$4u, _path2$1B;
function _extends$4y() { _extends$4y = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$4y.apply(this, arguments); }
var SvgPlayCircle24 = function SvgPlayCircle24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$4y({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path$4u || (_path$4u = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M12 20.2a8.2 8.2 0 1 0 0-16.4 8.2 8.2 0 0 0 0 16.4m0 1.8c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10",
    clipRule: "evenodd"
  })), _path2$1B || (_path2$1B = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M15.5 11.134a1 1 0 0 1 0 1.732L11 15.464a1 1 0 0 1-1.5-.866V9.402a1 1 0 0 1 1.5-.866z"
  })));
};
var PlayCircle24 = (/* unused pure expression or super */ null && (SvgPlayCircle24));

var _path$4t, _path2$1A;
function _extends$4x() { _extends$4x = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$4x.apply(this, arguments); }
var SvgPlayCircle32 = function SvgPlayCircle32(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$4x({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _path$4t || (_path$4t = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M16 27.333c6.26 0 11.333-5.074 11.333-11.333S22.26 4.667 16 4.667 4.667 9.74 4.667 16 9.74 27.333 16 27.333m0 2c7.364 0 13.333-5.97 13.333-13.333S23.363 2.667 16 2.667 2.667 8.637 2.667 16 8.637 29.333 16 29.333",
    clipRule: "evenodd"
  })), _path2$1A || (_path2$1A = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M20.417 14.7c1 .578 1 2.022 0 2.599l-5.5 3.175a1.5 1.5 0 0 1-2.25-1.299v-6.35a1.5 1.5 0 0 1 2.25-1.3z"
  })));
};
var PlayCircle32 = (/* unused pure expression or super */ null && (SvgPlayCircle32));

var _path$4s, _path2$1z;
function _extends$4w() { _extends$4w = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$4w.apply(this, arguments); }
var SvgPlayCircle48 = function SvgPlayCircle48(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$4w({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none"
  }, props), _path$4s || (_path$4s = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M24 41.6c9.72 0 17.6-7.88 17.6-17.6S33.72 6.4 24 6.4 6.4 14.28 6.4 24 14.28 41.6 24 41.6m0 2.4c11.046 0 20-8.954 20-20S35.046 4 24 4 4 12.954 4 24s8.954 20 20 20",
    clipRule: "evenodd"
  })), _path2$1z || (_path2$1z = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M31 22.268c1.333.77 1.333 2.694 0 3.464l-9 5.196c-1.333.77-3-.192-3-1.732V18.804c0-1.54 1.667-2.502 3-1.732z"
  })));
};
var PlayCircle48 = (/* unused pure expression or super */ null && (SvgPlayCircle48));

var PlayCircleIcon = function PlayCircleIcon(props) {
  var playCircle = {
    12: PlayCircle12,
    16: PlayCircle16,
    18: PlayCircle18,
    24: PlayCircle24,
    32: PlayCircle32,
    48: PlayCircle48
  };
  return jsx(IconTemplate, _assign({
    icons: playCircle
  }, props));
};

var _path$4r;
function _extends$4v() { _extends$4v = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$4v.apply(this, arguments); }
var SvgPlayFilled12 = function SvgPlayFilled12(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$4v({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none"
  }, props), _path$4r || (_path$4r = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M2.25 8.814V3.185a1.25 1.25 0 0 1 1.884-1.077l5.15 3.03a1 1 0 0 1 0 1.724l-5.15 3.03A1.25 1.25 0 0 1 2.25 8.814"
  })));
};
var PlayFilled12 = (/* unused pure expression or super */ null && (SvgPlayFilled12));

var _path$4q;
function _extends$4u() { _extends$4u = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$4u.apply(this, arguments); }
var SvgPlayFilled16 = function SvgPlayFilled16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$4u({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path$4q || (_path$4q = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M3 11.753V4.247c0-1.289 1.4-2.09 2.512-1.436l6.868 4.04a1.333 1.333 0 0 1 0 2.298l-6.868 4.04C4.4 13.843 3 13.042 3 11.753"
  })));
};
var PlayFilled16 = (/* unused pure expression or super */ null && (SvgPlayFilled16));

var _path$4p;
function _extends$4t() { _extends$4t = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$4t.apply(this, arguments); }
var SvgPlayFilled18 = function SvgPlayFilled18(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$4t({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _path$4p || (_path$4p = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M3.375 13.222V4.778c0-1.45 1.576-2.351 2.826-1.616l7.726 4.545a1.5 1.5 0 0 1 0 2.586l-7.726 4.545c-1.25.735-2.826-.166-2.826-1.616"
  })));
};
var PlayFilled18 = (/* unused pure expression or super */ null && (SvgPlayFilled18));

var _path$4o;
function _extends$4s() { _extends$4s = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$4s.apply(this, arguments); }
var SvgPlayFilled24 = function SvgPlayFilled24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$4s({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path$4o || (_path$4o = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M4.5 17.629V6.371c0-1.934 2.101-3.135 3.768-2.155l10.301 6.06c1.315.773 1.315 2.675 0 3.448l-10.301 6.06c-1.667.98-3.768-.221-3.768-2.155"
  })));
};
var PlayFilled24 = (/* unused pure expression or super */ null && (SvgPlayFilled24));

var _path$4n;
function _extends$4r() { _extends$4r = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$4r.apply(this, arguments); }
var SvgPlayFilled32 = function SvgPlayFilled32(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$4r({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _path$4n || (_path$4n = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M6 23.505V8.495c0-2.578 2.801-4.18 5.023-2.873l13.736 8.08c1.753 1.03 1.753 3.565 0 4.596l-13.736 8.08C8.801 27.685 6 26.083 6 23.505"
  })));
};
var PlayFilled32 = (/* unused pure expression or super */ null && (SvgPlayFilled32));

var _path$4m;
function _extends$4q() { _extends$4q = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$4q.apply(this, arguments); }
var SvgPlayFilled48 = function SvgPlayFilled48(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$4q({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none"
  }, props), _path$4m || (_path$4m = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M9 35.258V12.742c0-3.867 4.202-6.27 7.535-4.31l20.604 12.12c2.63 1.547 2.63 5.349 0 6.896l-20.604 12.12C13.202 41.528 9 39.125 9 35.258"
  })));
};
var PlayFilled48 = (/* unused pure expression or super */ null && (SvgPlayFilled48));

var PlayFilledIcon = function PlayFilledIcon(props) {
  var playFilled = {
    12: PlayFilled12,
    16: PlayFilled16,
    18: PlayFilled18,
    24: PlayFilled24,
    32: PlayFilled32,
    48: PlayFilled48
  };
  return jsx(IconTemplate, _assign({
    icons: playFilled
  }, props));
};

var _path$4l, _path2$1y;
function _extends$4p() { _extends$4p = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$4p.apply(this, arguments); }
var SvgPoint12 = function SvgPoint12(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$4p({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none"
  }, props), _path$4l || (_path$4l = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M5.05 3.55h1.3a1.8 1.8 0 1 1 0 3.6h-.7v1a.6.6 0 0 1-1.2 0v-4a.6.6 0 0 1 .6-.6m.6 2.4v-1.2h.7a.6.6 0 0 1 0 1.2z",
    clipRule: "evenodd"
  })), _path2$1y || (_path2$1y = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M11 6A5 5 0 1 1 1 6a5 5 0 0 1 10 0M9.8 6a3.8 3.8 0 1 1-7.6 0 3.8 3.8 0 0 1 7.6 0",
    clipRule: "evenodd"
  })));
};
var Point12 = (/* unused pure expression or super */ null && (SvgPoint12));

var _path$4k, _path2$1x;
function _extends$4o() { _extends$4o = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$4o.apply(this, arguments); }
var SvgPoint16 = function SvgPoint16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$4o({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path$4k || (_path$4k = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M5.983 5.533a.75.75 0 0 1 .807-.75h1.677a2.35 2.35 0 1 1 0 4.7h-.984v1.384a.75.75 0 0 1-1.5 0zm1.5.75v1.7h.984a.85.85 0 0 0 0-1.7z",
    clipRule: "evenodd"
  })), _path2$1x || (_path2$1x = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M8 14.667A6.667 6.667 0 1 0 8 1.333a6.667 6.667 0 0 0 0 13.334m0-1.5A5.167 5.167 0 1 0 8 2.833a5.167 5.167 0 0 0 0 10.334",
    clipRule: "evenodd"
  })));
};
var Point16 = (/* unused pure expression or super */ null && (SvgPoint16));

var _path$4j, _path2$1w;
function _extends$4n() { _extends$4n = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$4n.apply(this, arguments); }
var SvgPoint18 = function SvgPoint18(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$4n({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _path$4j || (_path$4j = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M6.775 6.225a.8.8 0 0 1 .831-.8h1.919a2.6 2.6 0 0 1 0 5.2h-1.15v1.6a.8.8 0 1 1-1.6 0zm1.6.8v2h1.15a1 1 0 1 0 0-2z",
    clipRule: "evenodd"
  })), _path2$1w || (_path2$1w = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M9 16.5a7.5 7.5 0 1 0 0-15 7.5 7.5 0 0 0 0 15m0-1.6A5.9 5.9 0 1 0 9 3.1a5.9 5.9 0 0 0 0 11.8",
    clipRule: "evenodd"
  })));
};
var Point18 = (/* unused pure expression or super */ null && (SvgPoint18));

var _path$4i, _path2$1v, _path3$3;
function _extends$4m() { _extends$4m = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$4m.apply(this, arguments); }
var SvgPoint24 = function SvgPoint24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$4m({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path$4i || (_path$4i = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M12 20.2a8.2 8.2 0 1 0 0-16.4 8.2 8.2 0 0 0 0 16.4m0 1.8C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10"
  })), _path2$1v || (_path2$1v = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M10.1 7.4a.9.9 0 0 1 .9.9v8a.9.9 0 1 1-1.8 0v-8a.9.9 0 0 1 .9-.9"
  })), _path3$3 || (_path3$3 = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M9.2 8.385c0-.544.44-.985.985-.985H12.7a3.3 3.3 0 0 1 0 6.6H9.2zM11 9.2v3h1.7a1.5 1.5 0 1 0 0-3z"
  })));
};
var Point24 = (/* unused pure expression or super */ null && (SvgPoint24));

var _path$4h, _path2$1u;
function _extends$4l() { _extends$4l = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$4l.apply(this, arguments); }
var SvgPoint32 = function SvgPoint32(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$4l({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _path$4h || (_path$4h = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "m13.467 10.067.055.001.058-.001h3.353a4.2 4.2 0 1 1 0 8.4h-2.466v3.266a1 1 0 1 1-2 0V11.067a1 1 0 0 1 1-1m1 6.4v-4.4h2.466a2.2 2.2 0 1 1 0 4.4z",
    clipRule: "evenodd"
  })), _path2$1u || (_path2$1u = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M29.333 16c0 7.364-5.97 13.333-13.333 13.333S2.667 23.363 2.667 16 8.637 2.667 16 2.667 29.333 8.637 29.333 16m-2 0c0 6.26-5.074 11.333-11.333 11.333S4.667 22.26 4.667 16 9.74 4.667 16 4.667 27.333 9.74 27.333 16",
    clipRule: "evenodd"
  })));
};
var Point32 = (/* unused pure expression or super */ null && (SvgPoint32));

var _path$4g, _path2$1t;
function _extends$4k() { _extends$4k = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$4k.apply(this, arguments); }
var SvgPoint48 = function SvgPoint48(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$4k({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none"
  }, props), _path$4g || (_path$4g = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M19 16.6a1.2 1.2 0 0 1 1.282-1.197l.087-.003H25.4a6 6 0 0 1 0 12h-4v5.2a1.2 1.2 0 0 1-2.4 0zm2.4 1.2V25h4a3.6 3.6 0 0 0 0-7.2z",
    clipRule: "evenodd"
  })), _path2$1t || (_path2$1t = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M24 44c11.046 0 20-8.954 20-20S35.046 4 24 4 4 12.954 4 24s8.954 20 20 20m0-2.4c9.72 0 17.6-7.88 17.6-17.6S33.72 6.4 24 6.4 6.4 14.28 6.4 24 14.28 41.6 24 41.6",
    clipRule: "evenodd"
  })));
};
var Point48 = (/* unused pure expression or super */ null && (SvgPoint48));

var PointIcon = function PointIcon(props) {
  var point = {
    12: Point12,
    16: Point16,
    18: Point18,
    24: Point24,
    32: Point32,
    48: Point48
  };
  return jsx(IconTemplate, _assign({
    icons: point
  }, props));
};

var _path$4f;
function _extends$4j() { _extends$4j = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$4j.apply(this, arguments); }
var SvgPointFilled12 = function SvgPointFilled12(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$4j({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none"
  }, props), _path$4f || (_path$4f = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M6 11A5 5 0 1 0 6 1a5 5 0 0 0 0 10m-.95-7.45h1.3a1.8 1.8 0 1 1 0 3.6h-.7v1a.6.6 0 0 1-1.2 0v-4a.6.6 0 0 1 .6-.6m.6 2.4v-1.2h.7a.6.6 0 1 1 0 1.2z",
    clipRule: "evenodd"
  })));
};
var PointFilled12 = (/* unused pure expression or super */ null && (SvgPointFilled12));

var _path$4e;
function _extends$4i() { _extends$4i = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$4i.apply(this, arguments); }
var SvgPointFilled16 = function SvgPointFilled16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$4i({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path$4e || (_path$4e = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M8 14.666A6.667 6.667 0 1 0 8 1.333a6.667 6.667 0 0 0 0 13.333M6.733 4.783h1.734a2.35 2.35 0 0 1 0 4.7h-.984v1.383a.75.75 0 1 1-1.5 0V5.534a.75.75 0 0 1 .75-.75m.75 3.2v-1.7h.984a.85.85 0 0 1 0 1.7z",
    clipRule: "evenodd"
  })));
};
var PointFilled16 = (/* unused pure expression or super */ null && (SvgPointFilled16));

var _path$4d;
function _extends$4h() { _extends$4h = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$4h.apply(this, arguments); }
var SvgPointFilled18 = function SvgPointFilled18(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$4h({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _path$4d || (_path$4d = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M9 16.5a7.5 7.5 0 1 0 0-15 7.5 7.5 0 0 0 0 15M7.575 5.425h1.95a2.6 2.6 0 0 1 0 5.2h-1.15v1.6a.8.8 0 1 1-1.6 0v-6a.8.8 0 0 1 .8-.8m.8 3.6v-2h1.15a1 1 0 1 1 0 2z",
    clipRule: "evenodd"
  })));
};
var PointFilled18 = (/* unused pure expression or super */ null && (SvgPointFilled18));

var _path$4c;
function _extends$4g() { _extends$4g = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$4g.apply(this, arguments); }
var SvgPointFilled24 = function SvgPointFilled24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$4g({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path$4c || (_path$4c = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10M10.1 7.4l.042.001H12.7a3.3 3.3 0 0 1 0 6.6H11v2.3a.9.9 0 1 1-1.8 0v-8a.9.9 0 0 1 .9-.9m.9 4.8v-3h1.7a1.5 1.5 0 0 1 0 3z",
    clipRule: "evenodd"
  })));
};
var PointFilled24 = (/* unused pure expression or super */ null && (SvgPointFilled24));

var _path$4b;
function _extends$4f() { _extends$4f = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$4f.apply(this, arguments); }
var SvgPointFilled32 = function SvgPointFilled32(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$4f({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _path$4b || (_path$4b = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M16 29.334c7.364 0 13.333-5.97 13.333-13.334S23.363 2.667 16 2.667 2.667 8.637 2.667 16 8.636 29.334 16 29.334m-2.533-19.267.055.001.058-.001h3.353a4.2 4.2 0 1 1 0 8.4h-2.466v3.267a1 1 0 0 1-2 0V11.067a1 1 0 0 1 1-1m1 6.4v-4.4h2.466a2.2 2.2 0 0 1 0 4.4z",
    clipRule: "evenodd"
  })));
};
var PointFilled32 = (/* unused pure expression or super */ null && (SvgPointFilled32));

var _path$4a;
function _extends$4e() { _extends$4e = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$4e.apply(this, arguments); }
var SvgPointFilled48 = function SvgPointFilled48(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$4e({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none"
  }, props), _path$4a || (_path$4a = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M24 44c11.046 0 20-8.954 20-20S35.046 4 24 4 4 12.954 4 24s8.954 20 20 20m-3.8-28.6q.041 0 .082.003l.087-.003H25.4a6 6 0 0 1 0 12h-4v5.2a1.2 1.2 0 1 1-2.4 0v-16a1.2 1.2 0 0 1 1.2-1.2m1.2 9.6v-7.2h4a3.6 3.6 0 0 1 0 7.2z",
    clipRule: "evenodd"
  })));
};
var PointFilled48 = (/* unused pure expression or super */ null && (SvgPointFilled48));

var PointFilledIcon = function PointFilledIcon(props) {
  var pointFilled = {
    12: PointFilled12,
    16: PointFilled16,
    18: PointFilled18,
    24: PointFilled24,
    32: PointFilled32,
    48: PointFilled48
  };
  return jsx(IconTemplate, _assign({
    icons: pointFilled
  }, props));
};

var _g$3, _defs$3;
function _extends$4d() { _extends$4d = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$4d.apply(this, arguments); }
var SvgPresent12 = function SvgPresent12(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$4d({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none"
  }, props), _g$3 || (_g$3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#present_12_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M2.9 2.75A1.85 1.85 0 0 1 6 1.386 1.85 1.85 0 0 1 8.983 3.4H10.5a.6.6 0 0 1 .6.6v2a.6.6 0 0 1-.5.592V9a2.1 2.1 0 0 1-2.1 2.1h-5A2.1 2.1 0 0 1 1.4 9V6.592A.6.6 0 0 1 .9 6V4a.6.6 0 0 1 .6-.6h1.517a1.9 1.9 0 0 1-.117-.65m1.85.65h.65v-.65a.65.65 0 1 0-.65.65m1.85-.65v.65h.65a.65.65 0 1 0-.65-.65M5.4 4.6H2.1v.8h3.3zm1.2.8v-.8h3.3v.8zM5.4 6.6H2.6V9a.9.9 0 0 0 .9.9h1.9zm1.2 3.3V6.6h2.8V9a.9.9 0 0 1-.9.9z",
    clipRule: "evenodd"
  }))), _defs$3 || (_defs$3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "present_12_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h12v12H0z"
  })))));
};
var Present12 = (/* unused pure expression or super */ null && (SvgPresent12));

var _path$49;
function _extends$4c() { _extends$4c = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$4c.apply(this, arguments); }
var SvgPresent16 = function SvgPresent16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$4c({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path$49 || (_path$49 = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M3.917 3.667A2.417 2.417 0 0 1 8 1.917a2.417 2.417 0 0 1 3.903 2.667H14a.75.75 0 0 1 .75.75V8a.75.75 0 0 1-.667.745V12a2.75 2.75 0 0 1-2.75 2.75H4.667A2.75 2.75 0 0 1 1.917 12V8.745A.75.75 0 0 1 1.25 8V5.333a.75.75 0 0 1 .75-.75h2.097a2.4 2.4 0 0 1-.18-.916m2.416.916h.917v-.916a.917.917 0 1 0-.917.916m2.417-.916v.916h.917a.917.917 0 1 0-.917-.916m-1.5 2.416h-4.5V7.25h4.5zm1.5 1.167V6.083h4.5V7.25zm-1.5 1.5H3.417V12c0 .69.56 1.25 1.25 1.25H7.25zm1.5 4.5v-4.5h3.833V12c0 .69-.56 1.25-1.25 1.25z",
    clipRule: "evenodd"
  })));
};
var Present16 = (/* unused pure expression or super */ null && (SvgPresent16));

var _path$48;
function _extends$4b() { _extends$4b = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$4b.apply(this, arguments); }
var SvgPresent18 = function SvgPresent18(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$4b({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _path$48 || (_path$48 = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M4.45 4.125A2.675 2.675 0 0 1 9 2.217 2.675 2.675 0 0 1 13.325 5.2h2.425a.8.8 0 0 1 .8.8v3a.8.8 0 0 1-.75.798V13.5a3.05 3.05 0 0 1-3.05 3.05h-7.5A3.05 3.05 0 0 1 2.2 13.5V9.798A.8.8 0 0 1 1.45 9V6a.8.8 0 0 1 .8-.8h2.425a2.7 2.7 0 0 1-.225-1.075M7.125 5.2H8.2V4.125A1.075 1.075 0 1 0 7.125 5.2M9.8 4.125V5.2h1.075A1.075 1.075 0 1 0 9.8 4.125M8.2 6.8H3.05v1.4H8.2zm1.6 1.4V6.8h5.15v1.4zM8.2 9.8H3.8v3.7c0 .8.65 1.45 1.45 1.45H8.2zm1.6 5.15V9.8h4.4v3.7c0 .8-.65 1.45-1.45 1.45z",
    clipRule: "evenodd"
  })));
};
var Present18 = (/* unused pure expression or super */ null && (SvgPresent18));

var _path$47, _path2$1s, _path3$2, _path4$1;
function _extends$4a() { _extends$4a = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$4a.apply(this, arguments); }
var SvgPresent24 = function SvgPresent24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$4a({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path$47 || (_path$47 = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M2.1 8a.9.9 0 0 1 .9-.9h18a.9.9 0 0 1 .9.9v4a.9.9 0 0 1-.9.9H3a.9.9 0 0 1-.9-.9zm1.8.9v2.2h16.2V8.9z",
    clipRule: "evenodd"
  })), _path2$1s || (_path2$1s = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M6.1 5.5a3.4 3.4 0 1 1 6.8 0v3.4H9.5a3.4 3.4 0 0 1-3.4-3.4m3.4-1.6a1.6 1.6 0 1 0 0 3.2h1.6V5.5a1.6 1.6 0 0 0-1.6-1.6",
    clipRule: "evenodd"
  })), _path3$2 || (_path3$2 = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M17.9 5.5a3.4 3.4 0 1 0-6.8 0v3.4h3.4a3.4 3.4 0 0 0 3.4-3.4m-3.4-1.6a1.6 1.6 0 1 1 0 3.2h-1.6V5.5a1.6 1.6 0 0 1 1.6-1.6M3.1 12a.9.9 0 0 1 .9-.9h16a.9.9 0 0 1 .9.9v6a3.9 3.9 0 0 1-3.9 3.9H7A3.9 3.9 0 0 1 3.1 18zm1.8.9V18c0 1.16.94 2.1 2.1 2.1h10a2.1 2.1 0 0 0 2.1-2.1v-5.1z",
    clipRule: "evenodd"
  })), _path4$1 || (_path4$1 = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M12 7.1a.9.9 0 0 1 .9.9v13a.9.9 0 1 1-1.8 0V8a.9.9 0 0 1 .9-.9",
    clipRule: "evenodd"
  })));
};
var Present24 = (/* unused pure expression or super */ null && (SvgPresent24));

var _path$46;
function _extends$49() { _extends$49 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$49.apply(this, arguments); }
var SvgPresent32 = function SvgPresent32(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$49({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _path$46 || (_path$46 = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M8.333 7.333A4.333 4.333 0 0 1 16 4.564a4.333 4.333 0 0 1 6.985 5.102H28a1 1 0 0 1 1 1V16a1 1 0 0 1-1 1h-.333v7a5 5 0 0 1-5 5H9.333a5 5 0 0 1-5-5v-7H4a1 1 0 0 1-1-1v-5.333a1 1 0 0 1 1-1h5.015a4.3 4.3 0 0 1-.682-2.334m4.334 2.334H15V7.333a2.333 2.333 0 1 0-2.333 2.334M17 7.333v2.334h2.333A2.333 2.333 0 1 0 17 7.333m-2 4.334H5V15h10zM17 15v-3.333h10V15zm-2 2H6.333v7a3 3 0 0 0 3 3H15zm2 10V17h8.667v7a3 3 0 0 1-3 3z",
    clipRule: "evenodd"
  })));
};
var Present32 = (/* unused pure expression or super */ null && (SvgPresent32));

var _path$45;
function _extends$48() { _extends$48 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$48.apply(this, arguments); }
var SvgPresent48 = function SvgPresent48(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$48({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none"
  }, props), _path$45 || (_path$45 = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M12.8 11A6.2 6.2 0 0 1 24 7.333a6.2 6.2 0 1 1 9.9 7.467H42a1.2 1.2 0 0 1 1.2 1.2v8a1.2 1.2 0 0 1-1.2 1.2h-.8V36a7.2 7.2 0 0 1-7.2 7.2H14A7.2 7.2 0 0 1 6.8 36V25.2H6A1.2 1.2 0 0 1 4.8 24v-8A1.2 1.2 0 0 1 6 14.8h8.1a6.17 6.17 0 0 1-1.3-3.8m6.2 3.8h3.8V11a3.8 3.8 0 1 0-3.8 3.8m6.2-3.8v3.8H29a3.8 3.8 0 1 0-3.8-3.8m-2.4 6.2H7.2v5.6h15.6zm2.4 5.6v-5.6h15.6v5.6zm-2.4 2.4H9.2V36a4.8 4.8 0 0 0 4.8 4.8h8.8zm2.4 15.6V25.2h13.6V36a4.8 4.8 0 0 1-4.8 4.8z",
    clipRule: "evenodd"
  })));
};
var Present48 = (/* unused pure expression or super */ null && (SvgPresent48));

var PresentIcon = function PresentIcon(props) {
  var present = {
    12: Present12,
    16: Present16,
    18: Present18,
    24: Present24,
    32: Present32,
    48: Present48
  };
  return jsx(IconTemplate, _assign({
    icons: present
  }, props));
};

var _path$44, _path2$1r;
function _extends$47() { _extends$47 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$47.apply(this, arguments); }
var SvgPresentFilled12 = function SvgPresentFilled12(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$47({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none"
  }, props), _path$44 || (_path$44 = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M4.75.9A1.85 1.85 0 0 0 3.08 3.55H1.5a.45.45 0 0 0-.45.45v2a.45.45 0 0 0 .438.45H5.4V3.4h1.2v3.05h3.911A.45.45 0 0 0 10.95 6V4a.45.45 0 0 0-.45-.45H8.919A1.85 1.85 0 0 0 6 1.386 1.84 1.84 0 0 0 4.75.9m.65 2.5v-.65a.65.65 0 1 0-.65.65zm2.5-.65a.65.65 0 0 0-1.3 0v.65h.65a.65.65 0 0 0 .65-.65",
    clipRule: "evenodd"
  })), _path2$1r || (_path2$1r = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M10.45 7.65H6.6v3.3h1.9A1.95 1.95 0 0 0 10.45 9zM5.4 10.95v-3.3H1.55V9a1.95 1.95 0 0 0 1.95 1.95z"
  })));
};
var PresentFilled12 = (/* unused pure expression or super */ null && (SvgPresentFilled12));

var _path$43, _path2$1q;
function _extends$46() { _extends$46 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$46.apply(this, arguments); }
var SvgPresentFilled16 = function SvgPresentFilled16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$46({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path$43 || (_path$43 = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M6.333 1.25a2.417 2.417 0 0 0-2.169 3.483H2a.6.6 0 0 0-.6.6V8a.6.6 0 0 0 .6.6h5.25V4.583h1.5V8.6H14a.6.6 0 0 0 .6-.6V5.333a.6.6 0 0 0-.6-.6h-2.164A2.417 2.417 0 0 0 8 1.916a2.4 2.4 0 0 0-1.667-.666m-.917 2.417a.917.917 0 0 1 1.834 0v.916h-.917a.917.917 0 0 1-.917-.916m5.168 0a.917.917 0 1 0-1.834 0v.916h.917c.506 0 .917-.41.917-.916",
    clipRule: "evenodd"
  })), _path2$1q || (_path2$1q = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M13.934 10.1H8.75v4.5h2.584a2.6 2.6 0 0 0 2.6-2.6zM7.25 14.6v-4.5H2.067V12a2.6 2.6 0 0 0 2.6 2.6z"
  })));
};
var PresentFilled16 = (/* unused pure expression or super */ null && (SvgPresentFilled16));

var _path$42;
function _extends$45() { _extends$45 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$45.apply(this, arguments); }
var SvgPresentFilled18 = function SvgPresentFilled18(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$45({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _path$42 || (_path$42 = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M15.675 11.3H9.8v5.125h2.95a2.925 2.925 0 0 0 2.925-2.925zM8.2 16.425V11.3H2.325v2.2a2.925 2.925 0 0 0 2.925 2.925zM7.125 1.45a2.675 2.675 0 0 0-2.391 3.875H2.25A.675.675 0 0 0 1.575 6v3c0 .373.302.675.675.675h.075L8.2 9.7V5.2H7.125A1.075 1.075 0 1 1 8.2 4.1v1.0999999999999999h1.6V4.1a1.075 1.075 0 1 1 1.075 1.1H9.8v4.5l5.875-.025h.075A.675.675 0 0 0 16.425 9V6a.675.675 0 0 0-.675-.675h-2.484A2.675 2.675 0 0 0 9 2.217a2.67 2.67 0 0 0-1.875-.767"
  })));
};
var PresentFilled18 = (/* unused pure expression or super */ null && (SvgPresentFilled18));

var _path$41;
function _extends$44() { _extends$44 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$44.apply(this, arguments); }
var SvgPresentFilled24 = function SvgPresentFilled24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$44({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path$41 || (_path$41 = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M9.5 2.1a3.4 3.4 0 0 0-3 5H3a.9.9 0 0 0-.9.9v4a.9.9 0 0 0 .9.9h8.1V7.1h1.8v5.8H21a.9.9 0 0 0 .9-.9V8a.9.9 0 0 0-.9-.9h-3.5A3.4 3.4 0 0 0 12 3.196 3.4 3.4 0 0 0 9.5 2.1m11.4 12.6h-8v7.2H17a3.9 3.9 0 0 0 3.9-3.9zm-9.8 7.2v-7.2h-8V18A3.9 3.9 0 0 0 7 21.9zm1.8-14.8V5.48a1.6 1.6 0 1 1 1.6 1.62zm-1.8 0H9.5a1.6 1.6 0 1 1 1.6-1.62V7.1",
    clipRule: "evenodd"
  })));
};
var PresentFilled24 = (/* unused pure expression or super */ null && (SvgPresentFilled24));

var _path$40, _path2$1p;
function _extends$43() { _extends$43 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$43.apply(this, arguments); }
var SvgPresentFilled32 = function SvgPresentFilled32(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$43({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _path$40 || (_path$40 = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M12.667 2.8a4.333 4.333 0 0 0-3.652 6.667H4a1.2 1.2 0 0 0-1.2 1.2V16A1.2 1.2 0 0 0 4 17.2h11V9.46h2v7.74h11a1.2 1.2 0 0 0 1.2-1.2v-5.333a1.2 1.2 0 0 0-1.2-1.2h-5.015A4.333 4.333 0 0 0 16 4.365 4.32 4.32 0 0 0 12.667 2.8m-.028 6.667h2.36V7.133L15 7.102a2.333 2.333 0 1 0-2.361 2.365m4.361 0h2.361A2.333 2.333 0 1 0 17 7.102v2.365",
    clipRule: "evenodd"
  })), _path2$1p || (_path2$1p = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M27.867 19.2H17v10h-2v-10H4.133V24a5.2 5.2 0 0 0 5.2 5.2h13.334a5.2 5.2 0 0 0 5.2-5.2z"
  })));
};
var PresentFilled32 = (/* unused pure expression or super */ null && (SvgPresentFilled32));

var _path$3$, _path2$1o;
function _extends$42() { _extends$42 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$42.apply(this, arguments); }
var SvgPresentFilled48 = function SvgPresentFilled48(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$42({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none"
  }, props), _path$3$ || (_path$3$ = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M19 4.2a6.2 6.2 0 0 0-4.9 10H6A1.8 1.8 0 0 0 4.2 16v8A1.8 1.8 0 0 0 6 25.8h16.8V14.2h2.4v11.6H42a1.8 1.8 0 0 0 1.8-1.8v-8a1.8 1.8 0 0 0-1.8-1.8h-8.1A6.2 6.2 0 1 0 24 6.733 6.19 6.19 0 0 0 19 4.2m3.8 10v-3.8a3.8 3.8 0 1 0-3.8 3.8zm6.2 0h-3.8v-3.8a3.8 3.8 0 1 1 3.8 3.8",
    clipRule: "evenodd"
  })), _path2$1o || (_path2$1o = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M41.8 28.2H25.2v15.6H34a7.8 7.8 0 0 0 7.8-7.8zM22.8 43.8V28.2H6.2V36a7.8 7.8 0 0 0 7.8 7.8z"
  })));
};
var PresentFilled48 = (/* unused pure expression or super */ null && (SvgPresentFilled48));

var PresentFilledIcon = function PresentFilledIcon(props) {
  var presentFilled = {
    12: PresentFilled12,
    16: PresentFilled16,
    18: PresentFilled18,
    24: PresentFilled24,
    32: PresentFilled32,
    48: PresentFilled48
  };
  return jsx(IconTemplate, _assign({
    icons: presentFilled
  }, props));
};

var _path$3_, _path2$1n;
function _extends$41() { _extends$41 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$41.apply(this, arguments); }
var SvgQuestion12 = function SvgQuestion12(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$41({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none"
  }, props), _path$3_ || (_path$3_ = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M6.386 6.824c-.055.245-.198.388-.458.388-.311 0-.495-.212-.495-.513v-.051c0-.432.224-.718.656-.97.472-.282.615-.466.615-.803 0-.358-.278-.607-.68-.607-.36 0-.602.175-.719.501-.091.235-.256.337-.48.337-.289 0-.468-.18-.468-.458 0-.157.036-.296.11-.435.234-.484.82-.795 1.607-.795 1.04 0 1.74.571 1.74 1.425 0 .553-.267.93-.784 1.234-.487.282-.597.44-.644.747M6.536 8.267a.584.584 0 0 1-.6.575.583.583 0 0 1-.598-.575c0-.323.268-.575.597-.575.333 0 .6.252.6.575"
  })), _path2$1n || (_path2$1n = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M11 6A5 5 0 1 1 1 6a5 5 0 0 1 10 0M9.9 6a3.9 3.9 0 1 1-7.8 0 3.9 3.9 0 0 1 7.8 0",
    clipRule: "evenodd"
  })));
};
var Question12 = (/* unused pure expression or super */ null && (SvgQuestion12));

var _path$3Z, _path2$1m;
function _extends$40() { _extends$40 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$40.apply(this, arguments); }
var SvgQuestion16 = function SvgQuestion16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$40({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path$3Z || (_path$3Z = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M8.422 8.956c-.049.322-.215.522-.547.522-.371 0-.576-.263-.576-.62v-.093c0-.605.303-1.005.913-1.367.605-.366.81-.635.81-1.103 0-.533-.415-.904-1.015-.904-.542 0-.903.269-1.06.762-.107.303-.288.425-.556.425-.337 0-.537-.205-.537-.532 0-.21.043-.391.136-.577.303-.664 1.065-1.074 2.07-1.074 1.324 0 2.232.752 2.232 1.856 0 .747-.371 1.26-1.035 1.655-.64.371-.796.605-.835 1.05M8.593 10.904a.696.696 0 0 1-.708.693.7.7 0 0 1-.713-.693c0-.386.317-.688.713-.688s.708.302.708.688"
  })), _path2$1m || (_path2$1m = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M14.666 8A6.667 6.667 0 1 1 1.333 8a6.667 6.667 0 0 1 13.333 0m-1.35 0A5.317 5.317 0 1 1 2.683 8a5.317 5.317 0 0 1 10.633 0",
    clipRule: "evenodd"
  })));
};
var Question16 = (/* unused pure expression or super */ null && (SvgQuestion16));

var _path$3Y, _path2$1l;
function _extends$3$() { _extends$3$ = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3$.apply(this, arguments); }
var SvgQuestion18 = function SvgQuestion18(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$3$({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _path$3Y || (_path$3Y = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M9.563 10.138c-.055.363-.242.588-.616.588-.417 0-.648-.297-.648-.698v-.104c0-.681.34-1.132 1.027-1.538.681-.412.912-.714.912-1.242 0-.599-.467-1.016-1.142-1.016-.61 0-1.017.302-1.192.857-.121.34-.325.478-.627.478-.379 0-.604-.23-.604-.599 0-.236.05-.44.154-.648.34-.747 1.197-1.209 2.329-1.209 1.489 0 2.51.846 2.51 2.088 0 .84-.417 1.417-1.164 1.862-.72.417-.896.681-.94 1.18M9.755 12.33c0 .434-.352.78-.797.78a.79.79 0 0 1-.802-.78c0-.434.357-.775.802-.775s.797.34.797.775"
  })), _path2$1l || (_path2$1l = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M16.5 9a7.5 7.5 0 1 1-15 0 7.5 7.5 0 0 1 15 0m-1.45 0a6.05 6.05 0 1 1-12.1 0 6.05 6.05 0 0 1 12.1 0",
    clipRule: "evenodd"
  })));
};
var Question18 = (/* unused pure expression or super */ null && (SvgQuestion18));

var _path$3X, _path2$1k;
function _extends$3_() { _extends$3_ = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3_.apply(this, arguments); }
var SvgQuestion24 = function SvgQuestion24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$3_({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path$3X || (_path$3X = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M12.733 13.684c-.073.484-.322.784-.82.784-.557 0-.864-.396-.864-.93v-.14c0-.908.454-1.508 1.37-2.05.908-.55 1.215-.953 1.215-1.656 0-.798-.622-1.355-1.523-1.355-.813 0-1.355.403-1.59 1.143-.16.454-.432.637-.834.637-.506 0-.806-.307-.806-.798 0-.315.066-.586.205-.864.454-.997 1.597-1.612 3.105-1.612 1.985 0 3.348 1.128 3.348 2.783 0 1.121-.557 1.89-1.553 2.483-.96.557-1.194.909-1.253 1.575M12.99 16.606c0 .58-.469 1.04-1.062 1.04s-1.07-.46-1.07-1.04c0-.578.476-1.032 1.07-1.032.593 0 1.062.454 1.062 1.032"
  })), _path2$1k || (_path2$1k = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M22 12c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10m-1.8 0a8.2 8.2 0 1 1-16.4 0 8.2 8.2 0 0 1 16.4 0",
    clipRule: "evenodd"
  })));
};
var Question24 = (/* unused pure expression or super */ null && (SvgQuestion24));

var _path$3W, _path2$1j;
function _extends$3Z() { _extends$3Z = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3Z.apply(this, arguments); }
var SvgQuestion32 = function SvgQuestion32(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$3Z({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _path$3W || (_path$3W = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M16.788 18.294c-.05.625-.342 1.036-.977 1.036-.684 0-1.025-.498-1.025-1.143v-.225c0-1.25.605-2.08 1.874-2.841 1.182-.713 1.602-1.3 1.602-2.256 0-1.153-.889-1.944-2.187-1.944-1.182 0-1.963.586-2.276 1.65-.195.606-.498.821-.986.821-.606 0-.947-.361-.947-.957 0-.42.088-.762.263-1.142.596-1.348 2.08-2.168 4.034-2.168 2.548 0 4.316 1.494 4.316 3.652 0 1.514-.762 2.549-2.05 3.32-1.26.742-1.593 1.24-1.641 2.197M17.1 22.22c0 .713-.557 1.26-1.29 1.26-.712 0-1.278-.547-1.278-1.26s.566-1.26 1.279-1.26c.732 0 1.289.547 1.289 1.26"
  })), _path2$1j || (_path2$1j = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M29.334 16c0 7.364-5.97 13.334-13.334 13.334S2.667 23.364 2.667 16 8.637 2.667 16 2.667 29.334 8.637 29.334 16m-2 0c0 6.26-5.074 11.334-11.334 11.334S4.667 22.26 4.667 16 9.741 4.667 16 4.667 27.334 9.741 27.334 16",
    clipRule: "evenodd"
  })));
};
var Question32 = (/* unused pure expression or super */ null && (SvgQuestion32));

var _path$3V, _path2$1i;
function _extends$3Y() { _extends$3Y = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3Y.apply(this, arguments); }
var SvgQuestion48 = function SvgQuestion48(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$3Y({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none"
  }, props), _path$3V || (_path$3V = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M25.056 27.441c-.074.938-.513 1.553-1.465 1.553-1.026 0-1.538-.747-1.538-1.714v-.337c0-1.875.908-3.12 2.812-4.262 1.773-1.07 2.403-1.949 2.403-3.384 0-1.729-1.333-2.915-3.282-2.915-1.772 0-2.944.879-3.413 2.475-.293.909-.747 1.23-1.48 1.23-.907 0-1.42-.541-1.42-1.435 0-.63.132-1.142.395-1.713.894-2.022 3.12-3.252 6.05-3.252 3.823 0 6.475 2.24 6.475 5.478 0 2.27-1.143 3.823-3.076 4.98-1.89 1.114-2.388 1.86-2.461 3.296M25.524 33.33c0 1.07-.835 1.89-1.933 1.89-1.07 0-1.92-.82-1.92-1.89s.85-1.89 1.92-1.89c1.098 0 1.933.82 1.933 1.89"
  })), _path2$1i || (_path2$1i = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M44 24c0 11.046-8.954 20-20 20S4 35.046 4 24 12.954 4 24 4s20 8.954 20 20m-2.4 0c0 9.72-7.88 17.6-17.6 17.6S6.4 33.72 6.4 24 14.28 6.4 24 6.4 41.6 14.28 41.6 24",
    clipRule: "evenodd"
  })));
};
var Question48 = (/* unused pure expression or super */ null && (SvgQuestion48));

var QuestionIcon = function QuestionIcon(props) {
  var question = {
    12: Question12,
    16: Question16,
    18: Question18,
    24: Question24,
    32: Question32,
    48: Question48
  };
  return jsx(IconTemplate, _assign({
    icons: question
  }, props));
};

var _path$3U;
function _extends$3X() { _extends$3X = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3X.apply(this, arguments); }
var SvgQuestionFilled12 = function SvgQuestionFilled12(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$3X({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none"
  }, props), _path$3U || (_path$3U = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    stroke: "#2F3438",
    strokeWidth: 0.65,
    d: "M6.626 6.886a.8.8 0 0 1-.181.47.62.62 0 0 1-.332.198.79.79 0 0 1 .63.779c0 .453-.36.797-.808.797a.796.796 0 0 1-.805-.797c0-.392.272-.702.63-.78a.66.66 0 0 1-.363-.22.8.8 0 0 1-.171-.513v-.084c0-.292.072-.552.228-.784.153-.225.372-.404.632-.56m.54 1.494L6.254 5.67m.372 1.216v-.01c.007-.14.032-.208.075-.266.052-.071.154-.16.38-.294h.003c.555-.333.927-.816.927-1.525 0-.5-.208-.933-.566-1.236-.355-.3-.838-.458-1.378-.458-.816 0-1.517.346-1.809 1.004m2.368 2.785L4.555 4.235m1.531 1.157.168.278m-.168-.278.168.278m-.168-.278c.208-.125.313-.22.37-.299a.43.43 0 0 0 .073-.269.36.36 0 0 0-.118-.283.56.56 0 0 0-.377-.12c-.167 0-.28.04-.357.097a.52.52 0 0 0-.184.288l-.003.008a.8.8 0 0 1-.25.393.67.67 0 0 1-.43.14.68.68 0 0 1-.494-.193.7.7 0 0 1-.185-.49c0-.211.046-.385.127-.563m1.996 1.57c.443-.268.6-.488.6-.847 0-.432-.333-.729-.82-.729-.443 0-.736.22-.853.62-.073.226-.187.307-.37.307-.227 0-.355-.136-.355-.359 0-.157.033-.286.099-.428M4.258 4.1v.002l.297.132M4.258 4.1l.001-.003.296.137M10.675 6a4.675 4.675 0 1 1-9.35 0 4.675 4.675 0 0 1 9.35 0Z"
  })));
};
var QuestionFilled12 = (/* unused pure expression or super */ null && (SvgQuestionFilled12));

var _path$3T;
function _extends$3W() { _extends$3W = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3W.apply(this, arguments); }
var SvgQuestionFilled16 = function SvgQuestionFilled16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$3W({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path$3T || (_path$3T = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    stroke: "#2F3438",
    strokeWidth: 0.867,
    d: "M8.8 9.014v-.012c.01-.188.044-.278.1-.355.07-.095.206-.214.508-.392l.003-.002c.74-.443 1.236-1.086 1.236-2.032 0-.666-.277-1.244-.754-1.648-.473-.4-1.117-.611-1.837-.611-1.088 0-2.023.462-2.412 1.339a1.7 1.7 0 0 0-.17.75c0 .23.067.47.247.653.18.185.422.258.66.258a.9.9 0 0 0 .573-.187c.172-.138.27-.33.332-.523l.004-.011a.7.7 0 0 1 .246-.385c.102-.074.253-.129.476-.129.237 0 .402.072.502.16a.48.48 0 0 1 .158.378.57.57 0 0 1-.098.359c-.076.106-.216.231-.493.398-.347.209-.639.447-.842.748a1.8 1.8 0 0 0-.305 1.044v.113c0 .232.061.483.228.683.127.152.294.251.483.295a1.056 1.056 0 0 0-.838 1.038 1.06 1.06 0 0 0 1.073 1.063c.597 0 1.078-.458 1.078-1.063 0-.522-.36-.935-.842-1.038a.83.83 0 0 0 .443-.263c.164-.186.225-.42.241-.628ZM14.233 8A6.233 6.233 0 1 1 1.766 8a6.233 6.233 0 0 1 12.467 0Z"
  })));
};
var QuestionFilled16 = (/* unused pure expression or super */ null && (SvgQuestionFilled16));

var _path$3S;
function _extends$3V() { _extends$3V = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3V.apply(this, arguments); }
var SvgQuestionFilled18 = function SvgQuestionFilled18(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$3V({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _path$3S || (_path$3S = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    stroke: "#2F3438",
    strokeWidth: 0.975,
    d: "M9.988 10.203v-.013c.012-.211.05-.313.114-.4.078-.107.23-.24.57-.44l.003-.002c.834-.499 1.391-1.223 1.391-2.286 0-.75-.312-1.4-.849-1.855-.531-.45-1.257-.687-2.066-.687-1.224 0-2.276.52-2.713 1.506a1.9 1.9 0 0 0-.192.844c0 .259.076.529.278.735.203.208.475.29.742.29.211 0 .442-.047.645-.21.194-.156.304-.371.374-.589l.004-.012c.063-.215.163-.35.277-.433s.284-.145.535-.145c.267 0 .453.08.565.18a.54.54 0 0 1 .178.425c0 .188-.038.301-.11.404-.086.119-.244.26-.555.447-.39.235-.719.503-.947.841a2.04 2.04 0 0 0-.344 1.176v.126c0 .262.07.544.258.77.142.17.33.281.543.33a1.19 1.19 0 0 0-.943 1.169c0 .68.546 1.196 1.207 1.196.671 0 1.212-.516 1.212-1.196 0-.588-.403-1.053-.946-1.169a.94.94 0 0 0 .498-.295c.185-.21.253-.472.271-.707ZM16.013 9A7.012 7.012 0 1 1 1.987 9a7.012 7.012 0 0 1 14.025 0Z"
  })));
};
var QuestionFilled18 = (/* unused pure expression or super */ null && (SvgQuestionFilled18));

var _path$3R;
function _extends$3U() { _extends$3U = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3U.apply(this, arguments); }
var SvgQuestionFilled24 = function SvgQuestionFilled24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$3U({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path$3R || (_path$3R = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    stroke: "#2F3438",
    strokeWidth: 1.3,
    d: "m13.3 13.771.002-.008v-.01c.014-.281.065-.416.15-.533.104-.142.308-.32.761-.587l.004-.002c1.111-.665 1.854-1.63 1.854-3.048 0-1-.415-1.867-1.132-2.473-.708-.6-1.675-.917-2.755-.917-1.631 0-3.033.694-3.617 2.009a2.6 2.6 0 0 0-.256 1.124c0 .346.101.706.37.981.272.277.634.387.99.387.282 0 .59-.064.86-.28.258-.208.406-.495.5-.786l.002-.008.002-.008c.085-.287.217-.466.37-.577.153-.112.379-.194.713-.194.357 0 .604.107.754.24a.72.72 0 0 1 .237.567c0 .251-.051.402-.148.538-.113.159-.324.347-.739.597-.52.313-.958.67-1.263 1.122-.313.463-.458.983-.458 1.567v.168c0 .35.093.725.343 1.026.19.227.44.376.724.442a1.58 1.58 0 0 0-1.257 1.557c0 .907.729 1.595 1.61 1.595.895 0 1.616-.688 1.616-1.595 0-.783-.538-1.403-1.262-1.558.253-.059.483-.186.665-.393.246-.28.337-.63.36-.943ZM21.35 12a9.35 9.35 0 1 1-18.7 0 9.35 9.35 0 0 1 18.7 0Z"
  })));
};
var QuestionFilled24 = (/* unused pure expression or super */ null && (SvgQuestionFilled24));

var _path$3Q;
function _extends$3T() { _extends$3T = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3T.apply(this, arguments); }
var SvgQuestionFilled32 = function SvgQuestionFilled32(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$3T({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _path$3Q || (_path$3Q = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    stroke: "#2F3438",
    strokeWidth: 1.733,
    d: "M17.652 18.362v-.012l.001-.011c.02-.377.086-.557.2-.712.14-.19.41-.427 1.015-.783l.005-.003c1.482-.887 2.473-2.173 2.473-4.064 0-1.334-.554-2.489-1.51-3.297-.944-.8-2.234-1.222-3.673-1.222-2.176 0-4.045.925-4.824 2.678a3.44 3.44 0 0 0-.34 1.5c0 .46.135.94.493 1.307.362.37.845.516 1.32.516.376 0 .787-.085 1.147-.374.344-.277.54-.66.665-1.047l.003-.011.004-.011c.112-.382.289-.62.492-.77.204-.149.506-.258.952-.258.475 0 .805.143 1.005.32.19.17.315.417.315.757 0 .334-.068.535-.197.717-.15.211-.431.462-.984.796-.695.417-1.279.893-1.685 1.495-.418.618-.61 1.312-.61 2.09v.224c0 .465.123.966.457 1.368.253.303.586.5.966.589a2.11 2.11 0 0 0-1.677 2.076c0 1.21.972 2.127 2.146 2.127 1.193 0 2.156-.918 2.156-2.127a2.104 2.104 0 0 0-1.683-2.077c.337-.079.644-.249.886-.525.328-.373.449-.84.481-1.256ZM28.466 16c0 6.886-5.581 12.467-12.467 12.467-6.885 0-12.466-5.581-12.466-12.467C3.534 9.115 9.115 3.534 16 3.534c6.886 0 12.467 5.581 12.467 12.466Z"
  })));
};
var QuestionFilled32 = (/* unused pure expression or super */ null && (SvgQuestionFilled32));

var _path$3P;
function _extends$3S() { _extends$3S = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3S.apply(this, arguments); }
var SvgQuestionFilled48 = function SvgQuestionFilled48(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$3S({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none"
  }, props), _path$3P || (_path$3P = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    stroke: "#2F3438",
    strokeWidth: 2.6,
    d: "m26.352 27.543.001-.018.001-.017c.029-.564.13-.835.3-1.068.209-.285.616-.64 1.523-1.174l.007-.005c2.223-1.33 3.709-3.26 3.709-6.096 0-2-.83-3.733-2.264-4.946-1.417-1.198-3.351-1.832-5.51-1.832-3.264 0-6.068 1.387-7.235 4.016-.328.712-.511 1.407-.511 2.25 0 .69.202 1.41.74 1.961.543.555 1.267.774 1.98.774.563 0 1.18-.128 1.72-.561.516-.415.81-.99.998-1.57l.005-.017.005-.016c.168-.574.433-.931.737-1.154.308-.225.76-.388 1.428-.388.713 0 1.209.215 1.508.48.287.256.474.625.474 1.135 0 .502-.102.803-.296 1.076-.226.317-.648.693-1.477 1.194-1.042.625-1.918 1.34-2.527 2.243-.627.927-.915 1.967-.915 3.133v.337c0 .698.184 1.45.686 2.052.378.454.88.752 1.448.884a3.17 3.17 0 0 0-2.515 3.114c0 1.814 1.458 3.19 3.219 3.19 1.79 0 3.233-1.376 3.233-3.19 0-1.566-1.077-2.806-2.524-3.115a2.5 2.5 0 0 0 1.33-.788c.491-.56.673-1.26.722-1.884ZM42.7 24c0 10.328-8.372 18.7-18.7 18.7S5.3 34.328 5.3 24 13.672 5.3 24 5.3 42.7 13.672 42.7 24Z"
  })));
};
var QuestionFilled48 = (/* unused pure expression or super */ null && (SvgQuestionFilled48));

var QuestionFilledIcon = function QuestionFilledIcon(props) {
  var questionFilled = {
    12: QuestionFilled12,
    16: QuestionFilled16,
    18: QuestionFilled18,
    24: QuestionFilled24,
    32: QuestionFilled32,
    48: QuestionFilled48
  };
  return jsx(IconTemplate, _assign({
    icons: questionFilled
  }, props));
};

var _path$3O;
function _extends$3R() { _extends$3R = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3R.apply(this, arguments); }
var SvgScrap12 = function SvgScrap12(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$3R({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none"
  }, props), _path$3O || (_path$3O = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M8.5 2.3h-5a.3.3 0 0 0-.3.3v6.435l1.635-1.021a2.2 2.2 0 0 1 2.332 0L8.8 9.034V2.6a.3.3 0 0 0-.3-.3m-5-1.2A1.5 1.5 0 0 0 2 2.6v7.698a.5.5 0 0 0 .765.424l2.706-1.69a1 1 0 0 1 1.06 0l2.704 1.69a.5.5 0 0 0 .765-.424V2.6a1.5 1.5 0 0 0-1.5-1.5z",
    clipRule: "evenodd"
  })));
};
var Scrap12 = (/* unused pure expression or super */ null && (SvgScrap12));

var _path$3N;
function _extends$3Q() { _extends$3Q = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3Q.apply(this, arguments); }
var SvgScrap16 = function SvgScrap16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$3Q({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path$3N || (_path$3N = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M11.333 2.967H4.667a.5.5 0 0 0-.5.5v8.76l2.332-1.457a2.83 2.83 0 0 1 3.004 0l2.33 1.457v-8.76a.5.5 0 0 0-.5-.5m-6.666-1.5a2 2 0 0 0-2 2V13.73c0 .523.576.842 1.02.565l3.607-2.254c.433-.27.981-.27 1.414 0l3.605 2.254a.667.667 0 0 0 1.02-.566V3.467a2 2 0 0 0-2-2z",
    clipRule: "evenodd"
  })));
};
var Scrap16 = (/* unused pure expression or super */ null && (SvgScrap16));

var _path$3M;
function _extends$3P() { _extends$3P = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3P.apply(this, arguments); }
var SvgScrap18 = function SvgScrap18(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$3P({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _path$3M || (_path$3M = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M12.75 3.25h-7.5a.65.65 0 0 0-.65.65v10.014l2.758-1.724a3.1 3.1 0 0 1 3.286 0l2.756 1.723V3.9a.65.65 0 0 0-.65-.65m-7.5-1.6A2.25 2.25 0 0 0 3 3.9v11.547a.75.75 0 0 0 1.147.636l4.059-2.536a1.5 1.5 0 0 1 1.59 0l4.057 2.536A.75.75 0 0 0 15 15.447V3.9a2.25 2.25 0 0 0-2.25-2.25z",
    clipRule: "evenodd"
  })));
};
var Scrap18 = (/* unused pure expression or super */ null && (SvgScrap18));

var _path$3L;
function _extends$3O() { _extends$3O = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3O.apply(this, arguments); }
var SvgScrap24 = function SvgScrap24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$3O({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path$3L || (_path$3L = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M17 4H7a1.2 1.2 0 0 0-1.2 1.2v13.953l4.187-2.617a3.8 3.8 0 0 1 4.028 0l4.185 2.616V5.2A1.2 1.2 0 0 0 17 4M7 2.2a3 3 0 0 0-3 3v15.396a1 1 0 0 0 1.53.848l5.411-3.382a2 2 0 0 1 2.12 0l5.409 3.381a1 1 0 0 0 1.53-.848V5.2a3 3 0 0 0-3-3z",
    clipRule: "evenodd"
  })));
};
var Scrap24 = (/* unused pure expression or super */ null && (SvgScrap24));

var _path$3K;
function _extends$3N() { _extends$3N = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3N.apply(this, arguments); }
var SvgScrap32 = function SvgScrap32(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$3N({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _path$3K || (_path$3K = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M22.667 4.933H9.333a2 2 0 0 0-2 2V26.26l6.195-3.872a4.67 4.67 0 0 1 4.947 0l6.192 3.87V6.934a2 2 0 0 0-2-2m-13.334-2a4 4 0 0 0-4 4v20.528a1.333 1.333 0 0 0 2.04 1.131l7.215-4.509a2.67 2.67 0 0 1 2.827 0l7.212 4.508a1.333 1.333 0 0 0 2.04-1.13V6.933a4 4 0 0 0-4-4z",
    clipRule: "evenodd"
  })));
};
var Scrap32 = (/* unused pure expression or super */ null && (SvgScrap32));

var _path$3J;
function _extends$3M() { _extends$3M = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3M.apply(this, arguments); }
var SvgScrap48 = function SvgScrap48(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$3M({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none"
  }, props), _path$3J || (_path$3J = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M34 6.8H14a3.6 3.6 0 0 0-3.6 3.6v30.07l10.21-6.38a6.4 6.4 0 0 1 6.785 0L37.6 40.47V10.4A3.6 3.6 0 0 0 34 6.8M14 4.4a6 6 0 0 0-6 6v30.792c0 1.57 1.728 2.528 3.06 1.696l10.823-6.763a4 4 0 0 1 4.24 0l10.817 6.762c1.332.833 3.06-.125 3.06-1.696V10.4a6 6 0 0 0-6-6z",
    clipRule: "evenodd"
  })));
};
var Scrap48 = (/* unused pure expression or super */ null && (SvgScrap48));

var ScrapIcon = function ScrapIcon(props) {
  var scrap = {
    12: Scrap12,
    16: Scrap16,
    18: Scrap18,
    24: Scrap24,
    32: Scrap32,
    48: Scrap48
  };
  return jsx(IconTemplate, _assign({
    icons: scrap
  }, props));
};

var _path$3I;
function _extends$3L() { _extends$3L = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3L.apply(this, arguments); }
var SvgScrapFilled12 = function SvgScrapFilled12(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends$3L({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none"
  }, props), _path$3I || (_path$3I = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M3.5 1.1A1.5 1.5 0 0 0 2 2.6v7.698a.5.5 0 0 0 .765.424l2.706-1.69a1 1 0 0 1 1.06 0l2.704 1.69a.5.5 0 0 0 .765-.424V2.6a1.5 1.5 0 0 0-1.5-1.5z",
    clipRule: "evenodd"
  })));
};
var ScrapFilled12 = SvgScrapFilled12;

var _path$3H;
function _extends$3K() { _extends$3K = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3K.apply(this, arguments); }
var SvgScrapFilled16 = function SvgScrapFilled16(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends$3K({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path$3H || (_path$3H = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M4.667 1.467a2 2 0 0 0-2 2V13.73c0 .523.576.842 1.02.565l3.607-2.254c.433-.27.981-.27 1.414 0l3.605 2.254a.667.667 0 0 0 1.02-.566V3.467a2 2 0 0 0-2-2z",
    clipRule: "evenodd"
  })));
};
var ScrapFilled16 = SvgScrapFilled16;

var _path$3G;
function _extends$3J() { _extends$3J = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3J.apply(this, arguments); }
var SvgScrapFilled18 = function SvgScrapFilled18(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends$3J({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _path$3G || (_path$3G = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M5.25 1.65A2.25 2.25 0 0 0 3 3.9v11.547a.75.75 0 0 0 1.147.636l4.059-2.536a1.5 1.5 0 0 1 1.59 0l4.057 2.536A.75.75 0 0 0 15 15.447V3.9a2.25 2.25 0 0 0-2.25-2.25z",
    clipRule: "evenodd"
  })));
};
var ScrapFilled18 = SvgScrapFilled18;

var _path$3F;
function _extends$3I() { _extends$3I = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3I.apply(this, arguments); }
var SvgScrapFilled24 = function SvgScrapFilled24(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends$3I({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path$3F || (_path$3F = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M7 2.2a3 3 0 0 0-3 3v15.396a1 1 0 0 0 1.53.848l5.411-3.382a2 2 0 0 1 2.12 0l5.409 3.381a1 1 0 0 0 1.53-.848V5.2a3 3 0 0 0-3-3z",
    clipRule: "evenodd"
  })));
};
var ScrapFilled24 = SvgScrapFilled24;

var _path$3E;
function _extends$3H() { _extends$3H = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3H.apply(this, arguments); }
var SvgScrapFilled32 = function SvgScrapFilled32(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends$3H({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _path$3E || (_path$3E = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M9.334 2.933a4 4 0 0 0-4 4v20.528a1.333 1.333 0 0 0 2.04 1.13l7.215-4.508a2.67 2.67 0 0 1 2.826 0l7.212 4.508a1.333 1.333 0 0 0 2.04-1.13V6.933a4 4 0 0 0-4-4z",
    clipRule: "evenodd"
  })));
};
var ScrapFilled32 = SvgScrapFilled32;

var _path$3D;
function _extends$3G() { _extends$3G = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3G.apply(this, arguments); }
var SvgScrapFilled48 = function SvgScrapFilled48(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends$3G({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none"
  }, props), _path$3D || (_path$3D = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M14 4.4a6 6 0 0 0-6 6v30.792c0 1.57 1.728 2.528 3.06 1.696l10.823-6.763a4 4 0 0 1 4.24 0l10.817 6.762c1.332.833 3.06-.125 3.06-1.696V10.4a6 6 0 0 0-6-6z",
    clipRule: "evenodd"
  })));
};
var ScrapFilled48 = SvgScrapFilled48;

var ScrapFilledIcon = function ScrapFilledIcon(props) {
  var scrapFilled = {
    12: ScrapFilled12,
    16: ScrapFilled16,
    18: ScrapFilled18,
    24: ScrapFilled24,
    32: ScrapFilled32,
    48: ScrapFilled48
  };
  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(IconTemplate, (0,_common_js__WEBPACK_IMPORTED_MODULE_2__.a)({
    icons: scrapFilled
  }, props));
};

var _path$3C;
function _extends$3F() { _extends$3F = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3F.apply(this, arguments); }
var SvgSearch12 = function SvgSearch12(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$3F({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none"
  }, props), _path$3C || (_path$3C = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M7.443 8.292a3.75 3.75 0 1 1 .849-.849l2.632 2.633a.6.6 0 0 1-.848.848zM7.8 5.25a2.55 2.55 0 1 1-5.1 0 2.55 2.55 0 0 1 5.1 0",
    clipRule: "evenodd"
  })));
};
var Search12 = (/* unused pure expression or super */ null && (SvgSearch12));

var _path$3B;
function _extends$3E() { _extends$3E = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3E.apply(this, arguments); }
var SvgSearch16 = function SvgSearch16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$3E({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path$3B || (_path$3B = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M9.965 11.026a5 5 0 1 1 1.06-1.06l3.505 3.504a.75.75 0 1 1-1.06 1.06zM10.5 7a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0",
    clipRule: "evenodd"
  })));
};
var Search16 = (/* unused pure expression or super */ null && (SvgSearch16));

var _path$3A;
function _extends$3D() { _extends$3D = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3D.apply(this, arguments); }
var SvgSearch18 = function SvgSearch18(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$3D({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _path$3A || (_path$3A = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M11.247 12.378a5.625 5.625 0 1 1 1.131-1.131l3.938 3.937a.8.8 0 0 1-1.132 1.132zm.653-4.503a4.025 4.025 0 1 1-8.05 0 4.025 4.025 0 0 1 8.05 0",
    clipRule: "evenodd"
  })));
};
var Search18 = (/* unused pure expression or super */ null && (SvgSearch18));

var _path$3z;
function _extends$3C() { _extends$3C = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3C.apply(this, arguments); }
var SvgSearch24 = function SvgSearch24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$3C({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path$3z || (_path$3z = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M15.129 16.402a7.5 7.5 0 1 1 1.273-1.273l5.235 5.235a.9.9 0 1 1-1.273 1.272zM16.2 10.5a5.7 5.7 0 1 1-11.4 0 5.7 5.7 0 0 1 11.4 0",
    clipRule: "evenodd"
  })));
};
var Search24 = (/* unused pure expression or super */ null && (SvgSearch24));

var _path$3y;
function _extends$3B() { _extends$3B = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3B.apply(this, arguments); }
var SvgSearch32 = function SvgSearch32(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$3B({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _path$3y || (_path$3y = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M20.329 21.743A9.96 9.96 0 0 1 14 24C8.477 24 4 19.523 4 14S8.477 4 14 4s10 4.477 10 10a9.96 9.96 0 0 1-2.257 6.329l6.964 6.964a1 1 0 0 1-1.414 1.414zM22 14a8 8 0 1 1-16 0 8 8 0 0 1 16 0",
    clipRule: "evenodd"
  })));
};
var Search32 = (/* unused pure expression or super */ null && (SvgSearch32));

var _circle, _path$3x;
function _extends$3A() { _extends$3A = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3A.apply(this, arguments); }
var SvgSearch48 = function SvgSearch48(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$3A({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 21,
    r: 13.8,
    stroke: "#2F3438",
    strokeWidth: 2.4
  })), _path$3x || (_path$3x = /*#__PURE__*/React.createElement("path", {
    stroke: "#2F3438",
    strokeLinecap: "round",
    strokeWidth: 2.4,
    d: "m31 31 11 11"
  })));
};
var Search48 = (/* unused pure expression or super */ null && (SvgSearch48));

var SearchIcon = function SearchIcon(props) {
  var search = {
    12: Search12,
    16: Search16,
    18: Search18,
    24: Search24,
    32: Search32,
    48: Search48
  };
  return jsx(IconTemplate, _assign({
    icons: search
  }, props));
};

var _path$3w, _path2$1h;
function _extends$3z() { _extends$3z = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3z.apply(this, arguments); }
var SvgSearchImage12 = function SvgSearchImage12(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$3z({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none"
  }, props), _path$3w || (_path$3w = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M2.6 3.5a.9.9 0 0 1 .9-.9h1a.6.6 0 0 0 0-1.2h-1a2.1 2.1 0 0 0-2.1 2.1v1a.6.6 0 0 0 1.2 0zM9.4 3.5a.9.9 0 0 0-.9-.9H7.55a.6.6 0 0 1 0-1.2H8.5c1.16 0 2.1.94 2.1 2.1v1a.6.6 0 1 1-1.2 0zM3.5 9.4a.9.9 0 0 1-.9-.9v-1a.6.6 0 0 0-1.2 0v1c0 1.16.94 2.1 2.1 2.1h1a.6.6 0 1 0 0-1.2zM9.4 8.5a.9.9 0 0 1-.9.9H8a.6.6 0 0 0 0 1.2h.5a2.1 2.1 0 0 0 2.1-2.1V8a.6.6 0 1 0-1.2 0z"
  })), _path2$1h || (_path2$1h = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M7.57 6.722a2.25 2.25 0 1 0-.876.82l.733.734a.6.6 0 1 0 .849-.849zM5.65 6.6a1.05 1.05 0 1 0 0-2.1 1.05 1.05 0 0 0 0 2.1",
    clipRule: "evenodd"
  })));
};
var SearchImage12 = (/* unused pure expression or super */ null && (SvgSearchImage12));

var _path$3v, _path2$1g;
function _extends$3y() { _extends$3y = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3y.apply(this, arguments); }
var SvgSearchImage16 = function SvgSearchImage16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$3y({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path$3v || (_path$3v = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M3.5 2.75a.75.75 0 0 0-.75.75v1.833a.75.75 0 1 1-1.5 0V3.5A2.25 2.25 0 0 1 3.5 1.25h1.833a.75.75 0 1 1 0 1.5zM12.432 2.75a.75.75 0 0 1 .75.75v1.833a.75.75 0 0 0 1.5 0V3.5a2.25 2.25 0 0 0-2.25-2.25h-1.765a.75.75 0 0 0 0 1.5zM3.5 13.25a.75.75 0 0 1-.75-.75v-1.833a.75.75 0 0 0-1.5 0V12.5a2.25 2.25 0 0 0 2.25 2.25h1.833a.75.75 0 0 0 0-1.5zM12.432 13.25a.75.75 0 0 0 .75-.75v-1.833a.75.75 0 0 1 1.5 0V12.5a2.25 2.25 0 0 1-2.25 2.25h-1.765a.75.75 0 0 1 0-1.5z",
    clipRule: "evenodd"
  })), _path2$1g || (_path2$1g = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M9.292 10.255a3.53 3.53 0 1 1 1.112-1.01l1.373 1.374a.75.75 0 1 1-1.06 1.06zm.267-3.059a2.03 2.03 0 1 1-4.059 0 2.03 2.03 0 0 1 4.059 0",
    clipRule: "evenodd"
  })));
};
var SearchImage16 = (/* unused pure expression or super */ null && (SvgSearchImage16));

var _path$3u, _path2$1f;
function _extends$3x() { _extends$3x = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3x.apply(this, arguments); }
var SvgSearchImage18 = function SvgSearchImage18(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$3x({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _path$3u || (_path$3u = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M4.25 3.05a1.2 1.2 0 0 0-1.2 1.2V6a.8.8 0 1 1-1.6 0V4.25a2.8 2.8 0 0 1 2.8-2.8H6a.8.8 0 1 1 0 1.6zM13.673 3.05a1.2 1.2 0 0 1 1.2 1.2V6a.8.8 0 0 0 1.6 0V4.25a2.8 2.8 0 0 0-2.8-2.8H12a.8.8 0 0 0 0 1.6zM4.25 14.95a1.2 1.2 0 0 1-1.2-1.2V12a.8.8 0 0 0-1.6 0v1.75a2.8 2.8 0 0 0 2.8 2.8H6a.8.8 0 0 0 0-1.6zM13.673 14.95a1.2 1.2 0 0 0 1.2-1.2V12a.8.8 0 0 1 1.6 0v1.75a2.8 2.8 0 0 1-2.8 2.8H12a.8.8 0 0 1 0-1.6z",
    clipRule: "evenodd"
  })), _path2$1f || (_path2$1f = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M10.493 11.514a3.97 3.97 0 1 1 1.186-1.077l1.74 1.74a.8.8 0 1 1-1.132 1.131zm.348-3.418a2.37 2.37 0 1 1-4.741 0 2.37 2.37 0 0 1 4.741 0",
    clipRule: "evenodd"
  })));
};
var SearchImage18 = (/* unused pure expression or super */ null && (SvgSearchImage18));

var _path$3t, _path2$1e;
function _extends$3w() { _extends$3w = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3w.apply(this, arguments); }
var SvgSearchImage24 = function SvgSearchImage24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$3w({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path$3t || (_path$3t = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M6 3.9A2.1 2.1 0 0 0 3.9 6v2a.9.9 0 0 1-1.8 0V6A3.9 3.9 0 0 1 6 2.1h2a.9.9 0 0 1 0 1.8zM17.898 3.9c1.16 0 2.1.94 2.1 2.1v2a.9.9 0 1 0 1.8 0V6a3.9 3.9 0 0 0-3.9-3.9H16a.9.9 0 1 0 0 1.8zM6 20.1A2.1 2.1 0 0 1 3.9 18v-2a.9.9 0 1 0-1.8 0v2A3.9 3.9 0 0 0 6 21.9h2a.9.9 0 0 0 0-1.8zM17.898 20.1a2.1 2.1 0 0 0 2.1-2.1v-2a.9.9 0 1 1 1.8 0v2a3.9 3.9 0 0 1-3.9 3.9H16a.9.9 0 0 1 0-1.8z",
    clipRule: "evenodd"
  })), _path2$1e || (_path2$1e = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M14.788 10.794a3.494 3.494 0 1 1-6.988 0 3.494 3.494 0 0 1 6.988 0m-.652 4.468a5.294 5.294 0 1 1 1.333-1.212l2.638 2.637a.9.9 0 1 1-1.273 1.273z",
    clipRule: "evenodd"
  })));
};
var SearchImage24 = (/* unused pure expression or super */ null && (SvgSearchImage24));

var _path$3s, _path2$1d;
function _extends$3v() { _extends$3v = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3v.apply(this, arguments); }
var SvgSearchImage32 = function SvgSearchImage32(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$3v({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _path$3s || (_path$3s = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M5 8a3 3 0 0 1 3-3h2.667a1 1 0 1 0 0-2H8a5 5 0 0 0-5 5v2.667a1 1 0 1 0 2 0zM26.864 8a3 3 0 0 0-3-3h-2.53a1 1 0 1 1 0-2h2.53a5 5 0 0 1 5 5v2.667a1 1 0 0 1-2 0zM8 27a3 3 0 0 1-3-3v-2.667a1 1 0 1 0-2 0V24a5 5 0 0 0 5 5h2.667a1 1 0 1 0 0-2zM26.864 24a3 3 0 0 1-3 3h-2.53a1 1 0 1 0 0 2h2.53a5 5 0 0 0 5-5v-2.667a1 1 0 0 0-2 0z"
  })), _path2$1d || (_path2$1d = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M20.5 18.89a7.059 7.059 0 1 0-1.481 1.347l3.568 3.568A1 1 0 0 0 24 22.391zm-5.441.561a5.059 5.059 0 1 0 0-10.117 5.059 5.059 0 0 0 0 10.117",
    clipRule: "evenodd"
  })));
};
var SearchImage32 = (/* unused pure expression or super */ null && (SvgSearchImage32));

var _path$3r, _path2$1c;
function _extends$3u() { _extends$3u = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3u.apply(this, arguments); }
var SvgSearchImage48 = function SvgSearchImage48(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$3u({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none"
  }, props), _path$3r || (_path$3r = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M7.2 12A4.8 4.8 0 0 1 12 7.2h4a1.2 1.2 0 0 0 0-2.4h-4A7.2 7.2 0 0 0 4.8 12v4a1.2 1.2 0 0 0 2.4 0zM40.596 12a4.8 4.8 0 0 0-4.8-4.8H32a1.2 1.2 0 0 1 0-2.4h3.796a7.2 7.2 0 0 1 7.2 7.2v4a1.2 1.2 0 0 1-2.4 0zM12 40.8A4.8 4.8 0 0 1 7.2 36v-4a1.2 1.2 0 0 0-2.4 0v4a7.2 7.2 0 0 0 7.2 7.2h4a1.2 1.2 0 0 0 0-2.4zM40.596 36a4.8 4.8 0 0 1-4.8 4.8H32a1.2 1.2 0 0 0 0 2.4h3.796a7.2 7.2 0 0 0 7.2-7.2v-4a1.2 1.2 0 0 0-2.4 0z"
  })), _path2$1c || (_path2$1c = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M30.554 28.563a10.55 10.55 0 0 0 2.622-6.975c0-5.847-4.74-10.588-10.588-10.588S12 15.74 12 21.588s4.74 10.588 10.588 10.588c2.31 0 4.448-.74 6.19-1.996l5.315 5.316a1.2 1.2 0 1 0 1.697-1.697zm-7.966 1.213a8.188 8.188 0 1 0 0-16.376 8.188 8.188 0 0 0 0 16.377",
    clipRule: "evenodd"
  })));
};
var SearchImage48 = (/* unused pure expression or super */ null && (SvgSearchImage48));

var SearchImageIcon = function SearchImageIcon(props) {
  var searchImage = {
    12: SearchImage12,
    16: SearchImage16,
    18: SearchImage18,
    24: SearchImage24,
    32: SearchImage32,
    48: SearchImage48
  };
  return jsx(IconTemplate, _assign({
    icons: searchImage
  }, props));
};

var _g$2, _defs$2;
function _extends$3t() { _extends$3t = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3t.apply(this, arguments); }
var SvgSendFilled12 = function SvgSendFilled12(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$3t({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none"
  }, props), _g$2 || (_g$2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#sendFilled_12_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M2.325 1.003a.97.97 0 0 0-1.053.117l-.006.005a.98.98 0 0 0-.322.975l.004.017L2.002 5.6H6a.4.4 0 1 1 0 .8H2L.935 9.861l-.002.01A.976.976 0 0 0 1.9 11.1a1 1 0 0 0 .427-.106l8.238-4.125.005-.002a.974.974 0 0 0 0-1.736z",
    clipRule: "evenodd"
  }))), _defs$2 || (_defs$2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "sendFilled_12_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h12v12H0z"
  })))));
};
var SendFilled12 = (/* unused pure expression or super */ null && (SvgSendFilled12));

var _path$3q;
function _extends$3s() { _extends$3s = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3s.apply(this, arguments); }
var SvgSendFilled16 = function SvgSendFilled16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$3s({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path$3q || (_path$3q = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M3.06 1.417a1.21 1.21 0 0 0-1.308.145l-.007.006a1.21 1.21 0 0 0-.4 1.21l.006.02L2.803 7.6h5.42a.4.4 0 1 1 0 .8H2.8l-1.466 4.773-.003.011a1.212 1.212 0 0 0 1.2 1.527 1.2 1.2 0 0 0 .531-.132l10.985-5.5.006-.002a1.21 1.21 0 0 0 0-2.156z",
    clipRule: "evenodd"
  })));
};
var SendFilled16 = (/* unused pure expression or super */ null && (SvgSendFilled16));

var _path$3p;
function _extends$3r() { _extends$3r = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3r.apply(this, arguments); }
var SvgSendFilled18 = function SvgSendFilled18(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$3r({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _path$3p || (_path$3p = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M3.442 1.594a1.36 1.36 0 0 0-1.471.164l-.008.006a1.36 1.36 0 0 0-.45 1.362l.006.023L3.153 8.55H9.25a.45.45 0 1 1 0 .9h-6.1L1.5 14.82l-.003.013a1.363 1.363 0 0 0 1.35 1.716 1.36 1.36 0 0 0 .598-.147l12.358-6.187.006-.004a1.362 1.362 0 0 0 0-2.425z",
    clipRule: "evenodd"
  })));
};
var SendFilled18 = (/* unused pure expression or super */ null && (SvgSendFilled18));

var _path$3o;
function _extends$3q() { _extends$3q = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3q.apply(this, arguments); }
var SvgSendFilled24 = function SvgSendFilled24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$3q({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path$3o || (_path$3o = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M4.515 2.274a1.65 1.65 0 0 0-1.782.199l-.008.007a1.65 1.65 0 0 0-.544 1.65l.006.025L4.378 11.4H12.5a.6.6 0 1 1 0 1.2H4.374l-2.213 7.205-.004.015a1.65 1.65 0 0 0 1.636 2.08c.252-.004.5-.065.725-.18l16.478-8.25.007-.004a1.65 1.65 0 0 0 .655-2.328 1.65 1.65 0 0 0-.655-.608z",
    clipRule: "evenodd"
  })));
};
var SendFilled24 = (/* unused pure expression or super */ null && (SvgSendFilled24));

var _path$3n;
function _extends$3p() { _extends$3p = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3p.apply(this, arguments); }
var SvgSendFilled32 = function SvgSendFilled32(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$3p({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _path$3n || (_path$3n = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M5.93 3.211a2 2 0 0 0-2.16.24l-.009.009a2 2 0 0 0-.659 2l.007.027 2.953 9.763h10.855a.75.75 0 0 1 0 1.5H6.057l-2.984 9.712-.004.017a2.002 2.002 0 0 0 1.985 2.52 2 2 0 0 0 .88-.217l21.97-11 .01-.005a2 2 0 0 0 0-3.56z",
    clipRule: "evenodd"
  })));
};
var SendFilled32 = (/* unused pure expression or super */ null && (SvgSendFilled32));

var _path$3m;
function _extends$3o() { _extends$3o = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3o.apply(this, arguments); }
var SvgSendFilled48 = function SvgSendFilled48(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$3o({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none"
  }, props), _path$3m || (_path$3m = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M7.256 4.817a2.7 2.7 0 0 1 1.505.268l32.972 16.508a2.7 2.7 0 0 1 0 4.806l-.01.005-32.957 16.5c-.37.19-.777.29-1.192.295a2.696 2.696 0 0 1-2.718-2.154 2.7 2.7 0 0 1 .037-1.248l.006-.02L9.345 25.3H25.5a1.3 1.3 0 1 0 0-2.6H9.353l-4.4-14.547-.008-.034a2.7 2.7 0 0 1 .89-2.7l.005-.005.006-.004c.403-.33.893-.536 1.41-.593"
  })));
};
var SendFilled48 = (/* unused pure expression or super */ null && (SvgSendFilled48));

var SendFilledIcon = function SendFilledIcon(props) {
  var sendFilled = {
    12: SendFilled12,
    16: SendFilled16,
    18: SendFilled18,
    24: SendFilled24,
    32: SendFilled32,
    48: SendFilled48
  };
  return jsx(IconTemplate, _assign({
    icons: sendFilled
  }, props));
};

var _g$1, _defs$1;
function _extends$3n() { _extends$3n = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3n.apply(this, arguments); }
var SvgSetting12 = function SvgSetting12(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$3n({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none"
  }, props), _g$1 || (_g$1 = /*#__PURE__*/React.createElement("g", {
    fill: "#2F3438",
    fillRule: "evenodd",
    clipPath: "url(#setting_12_svg__a)",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6 8a2 2 0 1 0 0-4 2 2 0 0 0 0 4m.8-2a.8.8 0 1 1-1.6 0 .8.8 0 0 1 1.6 0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m4.564 10.555-.138-.447-1.351-.748-.513.119c-.338.078-.699-.02-.915-.292a5.2 5.2 0 0 1-.684-1.12c-.151-.338-.05-.728.212-.99l.326-.329V5.253l-.326-.329c-.262-.262-.364-.651-.213-.99.18-.401.41-.777.684-1.12.217-.272.578-.37.917-.292l.512.118 1.351-.747.137-.446c.106-.343.386-.61.742-.654a5.7 5.7 0 0 1 1.392 0c.355.045.634.311.74.653l.137.447 1.351.747.512-.118c.339-.079.7.02.917.292.273.343.504.719.683 1.12.151.339.05.728-.212.99l-.326.329V6.75l.326.328c.262.263.364.652.212.99q-.272.604-.683 1.12c-.217.271-.578.37-.917.292l-.512-.119-1.351.748-.137.444c-.105.343-.386.61-.742.654a5.7 5.7 0 0 1-1.392 0c-.355-.043-.634-.31-.74-.652m4.183-2.467L6.57 9.293l-.229.744a4.4 4.4 0 0 1-.68 0l-.229-.745-2.178-1.205-.795.184a4 4 0 0 1-.298-.483l.541-.545V4.758l-.541-.545q.131-.252.298-.484l.795.184L5.43 2.708l.229-.745a4.5 4.5 0 0 1 .68 0l.23.745 2.177 1.205.795-.184q.165.233.298.485l-.541.544v2.487l.54.544q-.13.251-.297.483z"
  }))), _defs$1 || (_defs$1 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "setting_12_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h12v12H0z"
  })))));
};
var Setting12 = (/* unused pure expression or super */ null && (SvgSetting12));

var _path$3l, _path2$1b;
function _extends$3m() { _extends$3m = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3m.apply(this, arguments); }
var SvgSetting16 = function SvgSetting16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$3m({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path$3l || (_path$3l = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M8 10.667a2.667 2.667 0 1 0 0-5.334 2.667 2.667 0 0 0 0 5.334M9.167 8a1.167 1.167 0 1 1-2.334 0 1.167 1.167 0 0 1 2.334 0",
    clipRule: "evenodd"
  })), _path2$1b || (_path2$1b = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "m1.425 9.578.577-.58V7.004l-.577-.58c-.262-.263-.362-.651-.22-.993a7 7 0 0 1 1.108-1.824.93.93 0 0 1 .923-.287l.864.2 1.802-.997.239-.779a.93.93 0 0 1 .74-.66 7.6 7.6 0 0 1 2.24 0 .93.93 0 0 1 .738.66l.24.78 1.801.996.864-.2a.92.92 0 0 1 .923.287c.46.547.835 1.16 1.109 1.823.14.343.04.731-.22.994l-.578.58V9l.577.58c.262.262.362.65.22.993a7 7 0 0 1-1.108 1.821.93.93 0 0 1-.923.288l-.864-.2-1.802.996-.239.778a.93.93 0 0 1-.74.66 7.6 7.6 0 0 1-2.24.001.93.93 0 0 1-.737-.66l-.24-.78L4.1 12.48l-.865.2a.92.92 0 0 1-.921-.287 7 7 0 0 1-1.11-1.822c-.14-.342-.04-.73.22-.993m10.253 1.312-2.835 1.569-.313 1.018a6 6 0 0 1-1.059 0l-.313-1.02-2.836-1.569-1.087.252a5.4 5.4 0 0 1-.477-.776l.744-.747V6.385l-.744-.748q.205-.407.477-.777l1.087.252 2.836-1.57.313-1.019a6 6 0 0 1 1.058 0l.314 1.02 2.835 1.569 1.086-.252q.272.37.478.777l-.744.748v3.233l.744.748q-.206.406-.477.776z",
    clipRule: "evenodd"
  })));
};
var Setting16 = (/* unused pure expression or super */ null && (SvgSetting16));

var _path$3k, _path2$1a;
function _extends$3l() { _extends$3l = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3l.apply(this, arguments); }
var SvgSetting18 = function SvgSetting18(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$3l({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _path$3k || (_path$3k = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M9 12a3 3 0 1 0 0-6 3 3 0 0 0 0 6m1.4-3a1.4 1.4 0 1 1-2.8 0 1.4 1.4 0 0 1 2.8 0",
    clipRule: "evenodd"
  })), _path2$1a || (_path2$1a = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "m1.55 10.828.702-.705V7.879l-.703-.706a.93.93 0 0 1-.223-.994 7.8 7.8 0 0 1 1.322-2.174.93.93 0 0 1 .924-.286l1.04.241L6.64 2.84l.29-.946a.94.94 0 0 1 .741-.663 8.6 8.6 0 0 1 2.662 0c.353.057.632.32.738.663l.29.946 2.027 1.121 1.04-.24a.93.93 0 0 1 .925.285 7.8 7.8 0 0 1 1.321 2.174.93.93 0 0 1-.223.994l-.702.706v2.246l.702.705c.262.263.361.651.223.995a7.8 7.8 0 0 1-1.321 2.172.93.93 0 0 1-.924.286l-1.04-.242-2.027 1.122-.29.944a.94.94 0 0 1-.741.663 8.6 8.6 0 0 1-2.662.001.94.94 0 0 1-.738-.662l-.29-.948-2.028-1.121-1.04.24a.93.93 0 0 1-.924-.284 7.8 7.8 0 0 1-1.321-2.173.93.93 0 0 1 .223-.995m11.6 1.516-3.129 1.732-.359 1.167a7 7 0 0 1-1.324 0l-.359-1.17-3.13-1.73-1.246.288a6 6 0 0 1-.607-.988l.856-.86V7.219l-.856-.86q.256-.523.608-.99l1.246.289 3.129-1.732.36-1.17a7 7 0 0 1 1.323.001l.36 1.17 3.128 1.73 1.246-.288q.35.468.607.99l-.855.86v3.566l.855.86a6 6 0 0 1-.607.988z",
    clipRule: "evenodd"
  })));
};
var Setting18 = (/* unused pure expression or super */ null && (SvgSetting18));

var _path$3j, _path2$19;
function _extends$3k() { _extends$3k = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3k.apply(this, arguments); }
var SvgSetting24 = function SvgSetting24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$3k({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path$3j || (_path$3j = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M12 14.2a2.2 2.2 0 1 0 0-4.4 2.2 2.2 0 0 0 0 4.4m4-2.2a4 4 0 1 1-8 0 4 4 0 0 1 8 0",
    clipRule: "evenodd"
  })), _path2$19 || (_path2$19 = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "m13.64 18.994 3.943-2.182 1.746.405a8.6 8.6 0 0 0 1.077-1.76l-1.208-1.215V9.763l1.208-1.215a8.6 8.6 0 0 0-1.078-1.762l-1.745.404-3.942-2.182-.505-1.64a9.5 9.5 0 0 0-2.272 0l-.504 1.64L6.417 7.19l-1.745-.404a8.6 8.6 0 0 0-1.078 1.762l1.208 1.215v4.476l-1.208 1.215a8.6 8.6 0 0 0 1.077 1.76l1.746-.404 3.943 2.182.504 1.64a9.6 9.6 0 0 0 2.273 0zm4.21-.272-2.702 1.495-.444 1.444a.95.95 0 0 1-.74.668 11.5 11.5 0 0 1-3.93 0 .95.95 0 0 1-.737-.666l-.445-1.448-2.702-1.496-1.57.364a.95.95 0 0 1-.927-.281 10.4 10.4 0 0 1-1.957-3.225.94.94 0 0 1 .229-.997l1.077-1.083v-2.991L1.925 9.422a.94.94 0 0 1-.23-.996 10.4 10.4 0 0 1 1.958-3.227c.231-.26.59-.36.928-.282l1.569.364 2.702-1.496.445-1.446a.95.95 0 0 1 .74-.668 11.335 11.335 0 0 1 3.93.002.95.95 0 0 1 .736.666l.445 1.446 2.702 1.496 1.57-.364a.95.95 0 0 1 .927.282c.84.947 1.507 2.037 1.957 3.227a.94.94 0 0 1-.229.996l-1.077 1.084v2.993l1.077 1.084c.262.263.36.65.229.996a10.4 10.4 0 0 1-1.957 3.224.95.95 0 0 1-.928.283z",
    clipRule: "evenodd"
  })));
};
var Setting24 = (/* unused pure expression or super */ null && (SvgSetting24));

var _path$3i, _path2$18;
function _extends$3j() { _extends$3j = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3j.apply(this, arguments); }
var SvgSetting32 = function SvgSetting32(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$3j({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _path$3i || (_path$3i = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M16 19.533a3.533 3.533 0 1 0 0-7.066 3.533 3.533 0 0 0 0 7.066M21.333 16a5.333 5.333 0 1 1-10.666 0 5.333 5.333 0 0 1 10.666 0",
    clipRule: "evenodd"
  })), _path2$18 || (_path2$18 = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "m18.69 25.733 4.843-2.68 2.467.572a12 12 0 0 0 1.92-3.15l-1.723-1.733v-5.477l1.724-1.733A12 12 0 0 0 26 8.379l-2.467.571-4.843-2.68-.714-2.322a13.3 13.3 0 0 0-3.952 0L13.31 6.27 8.467 8.95 6 8.38a12 12 0 0 0-1.921 3.152l1.724 1.734v5.473l-1.724 1.734A12 12 0 0 0 6 23.622l2.468-.572 4.843 2.68.714 2.324a13.4 13.4 0 0 0 3.952-.001zm5.11-.77-3.603 1.994-.65 2.11a.96.96 0 0 1-.738.67 15.192 15.192 0 0 1-5.62 0 .96.96 0 0 1-.736-.669l-.65-2.115L8.2 24.96l-2.275.527a.96.96 0 0 1-.93-.279 13.8 13.8 0 0 1-2.803-4.626.96.96 0 0 1 .233-.998l1.578-1.587v-3.988L2.424 12.42a.96.96 0 0 1-.233-.997c.62-1.721 1.581-3.287 2.805-4.63a.96.96 0 0 1 .93-.28l2.274.528 3.603-1.994.65-2.113a.96.96 0 0 1 .738-.672 15.131 15.131 0 0 1 5.62.002c.352.067.631.33.736.671l.65 2.112L23.8 7.04l2.274-.527a.96.96 0 0 1 .93.28 13.9 13.9 0 0 1 2.804 4.629.96.96 0 0 1-.233.998l-1.578 1.587v3.991l1.578 1.587c.262.263.359.65.233.998a13.9 13.9 0 0 1-2.804 4.626.96.96 0 0 1-.93.28z",
    clipRule: "evenodd"
  })));
};
var Setting32 = (/* unused pure expression or super */ null && (SvgSetting32));

var _path$3h, _path2$17;
function _extends$3i() { _extends$3i = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3i.apply(this, arguments); }
var SvgSetting48 = function SvgSetting48(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$3i({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none"
  }, props), _path$3h || (_path$3h = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M24 32a8 8 0 1 0 0-16 8 8 0 0 0 0 16m5.6-8a5.6 5.6 0 1 1-11.2 0 5.6 5.6 0 0 1 11.2 0",
    clipRule: "evenodd"
  })), _path2$17 || (_path2$17 = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "m30.295 40.435 5.405-2.991 3.684.854a.97.97 0 0 0 .933-.278 20.8 20.8 0 0 0 4.496-7.428.97.97 0 0 0-.238-1L41.995 27v-5.987l2.58-2.595a.97.97 0 0 0 .237-1 20.8 20.8 0 0 0-4.495-7.432.97.97 0 0 0-.933-.278l-3.684.854-5.405-2.99-1.06-3.445a.98.98 0 0 0-.734-.674 22.7 22.7 0 0 0-9-.004.98.98 0 0 0-.737.675l-1.06 3.447-5.404 2.991-3.683-.854a.97.97 0 0 0-.933.278 20.8 20.8 0 0 0-4.497 7.433.97.97 0 0 0 .238 1l2.58 2.594v5.982l-2.58 2.594a.97.97 0 0 0-.237 1 20.8 20.8 0 0 0 4.496 7.428.97.97 0 0 0 .932.277l3.684-.854 5.405 2.99 1.06 3.45a.98.98 0 0 0 .735.674 22.8 22.8 0 0 0 8.999-.001.98.98 0 0 0 .738-.675zm5.05-5.537-7.059 3.906-1.09 3.543a20.5 20.5 0 0 1-6.39.002l-1.091-3.55-7.06-3.906-3.766.873a18.4 18.4 0 0 1-3.123-5.13l2.639-2.652V20.02l-2.64-2.653a18.4 18.4 0 0 1 3.125-5.134l3.766.873 7.059-3.906 1.09-3.548a20.242 20.242 0 0 1 6.39.002L28.286 9.2l7.058 3.906 3.766-.873a18.4 18.4 0 0 1 3.124 5.134l-2.639 2.653v7.968l2.639 2.653a18.4 18.4 0 0 1-3.124 5.129z",
    clipRule: "evenodd"
  })));
};
var Setting48 = (/* unused pure expression or super */ null && (SvgSetting48));

var SettingIcon = function SettingIcon(props) {
  var setting = {
    12: Setting12,
    16: Setting16,
    18: Setting18,
    24: Setting24,
    32: Setting32,
    48: Setting48
  };
  return jsx(IconTemplate, _assign({
    icons: setting
  }, props));
};

var _path$3g;
function _extends$3h() { _extends$3h = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3h.apply(this, arguments); }
var SvgShare12 = function SvgShare12(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$3h({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none"
  }, props), _path$3g || (_path$3g = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M8.257 4.566a2.143 2.143 0 1 0-1.984-1.333L4.18 4.374a2.143 2.143 0 1 0-.177 2.95l-.082.15 2.35 1.281a2.143 2.143 0 1 0 .763-.95L4.569 6.457a2.14 2.14 0 0 0 .1-.983l2.368-1.291c.346.24.767.381 1.221.381m0-1.2a.943.943 0 1 0 0-1.886.943.943 0 0 0 0 1.886M2.543 6.699a.943.943 0 1 0 0-1.886.943.943 0 0 0 0 1.886M9.2 9.565a.943.943 0 1 1-1.886 0 .943.943 0 0 1 1.886 0",
    clipRule: "evenodd"
  })));
};
var Share12 = (/* unused pure expression or super */ null && (SvgShare12));

var _path$3f;
function _extends$3g() { _extends$3g = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3g.apply(this, arguments); }
var SvgShare16 = function SvgShare16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$3g({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path$3f || (_path$3f = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M10.976 6.38A2.857 2.857 0 1 0 8.37 4.697L5.605 6.204a2.857 2.857 0 1 0-.3 3.853l-.06.113 3.125 1.705a2.857 2.857 0 1 0 .888-1.11L6.022 9a2.85 2.85 0 0 0 .152-1.511l3.084-1.682c.478.36 1.073.574 1.718.574m0-1.4a1.457 1.457 0 1 0 0-2.914 1.457 1.457 0 0 0 0 2.915M3.357 9.426a1.457 1.457 0 1 0 0-2.914 1.457 1.457 0 0 0 0 2.914m9.076 3.622a1.457 1.457 0 1 1-2.914 0 1.457 1.457 0 0 1 2.914 0",
    clipRule: "evenodd"
  })));
};
var Share16 = (/* unused pure expression or super */ null && (SvgShare16));

var _path$3e;
function _extends$3f() { _extends$3f = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3f.apply(this, arguments); }
var SvgShare18 = function SvgShare18(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$3f({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _path$3e || (_path$3e = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M12.586 6.828a3.214 3.214 0 1 0-2.917-1.86L6.566 6.66a3.214 3.214 0 1 0-.36 4.305l-.05.093 3.513 1.917a3.214 3.214 0 1 0 .95-1.19L7 9.81a3.2 3.2 0 0 0 .177-1.774l3.444-1.878a3.2 3.2 0 0 0 1.966.67m0-1.5a1.714 1.714 0 1 0 0-3.428 1.714 1.714 0 0 0 0 3.428m-8.572 5a1.714 1.714 0 1 0 0-3.428 1.714 1.714 0 0 0 0 3.428m10.286 4a1.714 1.714 0 1 1-3.429 0 1.714 1.714 0 0 1 3.429 0",
    clipRule: "evenodd"
  })));
};
var Share18 = (/* unused pure expression or super */ null && (SvgShare18));

var _path$3d;
function _extends$3e() { _extends$3e = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3e.apply(this, arguments); }
var SvgShare24 = function SvgShare24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$3e({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path$3d || (_path$3d = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M16.714 9.071a4.286 4.286 0 1 0-3.845-2.39L8.75 8.927a4.286 4.286 0 1 0-.54 5.659l-.02.037 4.68 2.553a4.286 4.286 0 1 0 1.14-1.429l-4.782-2.609a4.27 4.27 0 0 0 .255-2.56l4.526-2.47c.738.602 1.68.962 2.706.962m0-1.8a2.486 2.486 0 1 0 0-4.971 2.486 2.486 0 0 0 0 4.971M5.286 13.938a2.486 2.486 0 1 0 0-4.972 2.486 2.486 0 0 0 0 4.972M19.2 19.07a2.486 2.486 0 1 1-4.971 0 2.486 2.486 0 0 1 4.971 0",
    clipRule: "evenodd"
  })));
};
var Share24 = (/* unused pure expression or super */ null && (SvgShare24));

var _path$3c;
function _extends$3d() { _extends$3d = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3d.apply(this, arguments); }
var SvgShare32 = function SvgShare32(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$3d({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _path$3c || (_path$3c = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M28.267 6.514a5.714 5.714 0 0 1-9.486 4.293l-5.917 3.228a5.73 5.73 0 0 1-.377 3.8l6.294 3.434a5.714 5.714 0 1 1-1.264 1.589l-6.196-3.38a5.714 5.714 0 1 1 .728-7.276l5.468-2.984a5.714 5.714 0 1 1 10.75-2.704M7.314 19.117a3.714 3.714 0 1 0 0-7.429 3.714 3.714 0 0 0 0 7.43m15.238-8.889a3.714 3.714 0 1 0 0-7.428 3.714 3.714 0 0 0 0 7.428m0 19.048a3.714 3.714 0 1 0 0-7.429 3.714 3.714 0 0 0 0 7.429",
    clipRule: "evenodd"
  })));
};
var Share32 = (/* unused pure expression or super */ null && (SvgShare32));

var _path$3b;
function _extends$3c() { _extends$3c = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3c.apply(this, arguments); }
var SvgShare48 = function SvgShare48(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$3c({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none"
  }, props), _path$3b || (_path$3b = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M42 9.672a8.571 8.571 0 0 1-14.463 6.225l-8.72 4.757c.212.747.326 1.535.326 2.35a8.5 8.5 0 0 1-.946 3.919l9.34 5.094a8.571 8.571 0 1 1-1.514 1.908l-9.224-5.031a8.571 8.571 0 1 1 1.038-10.44l8.186-4.465A8.571 8.571 0 1 1 42 9.672M10.571 29.176a6.171 6.171 0 1 0 0-12.343 6.171 6.171 0 0 0 0 12.343M33.43 15.843a6.171 6.171 0 1 0 0-12.343 6.171 6.171 0 0 0 0 12.343m0 28.571a6.171 6.171 0 1 0 0-12.342 6.171 6.171 0 0 0 0 12.342",
    clipRule: "evenodd"
  })));
};
var Share48 = (/* unused pure expression or super */ null && (SvgShare48));

var ShareIcon = function ShareIcon(props) {
  var share = {
    12: Share12,
    16: Share16,
    18: Share18,
    24: Share24,
    32: Share32,
    48: Share48
  };
  return jsx(IconTemplate, _assign({
    icons: share
  }, props));
};

var _path$3a;
function _extends$3b() { _extends$3b = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3b.apply(this, arguments); }
var SvgShield12 = function SvgShield12(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$3b({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none"
  }, props), _path$3a || (_path$3a = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M10.5 6V2.985a.505.505 0 0 0-.485-.5c-1.843-.1-3.052-.767-3.626-1.172a.69.69 0 0 0-.778 0c-.574.405-1.783 1.072-3.626 1.172a.505.505 0 0 0-.485.5V6s0 3.251 4.029 4.83c.302.118.64.118.942 0C10.5 9.25 10.5 6 10.5 6m-7.8-.012.003.053c.005.054.016.146.039.267.046.24.14.59.336.98.377.756 1.164 1.749 2.888 2.424.021.008.047.008.068 0 1.724-.675 2.511-1.668 2.888-2.424.195-.39.29-.74.336-.98a3 3 0 0 0 .042-.32V3.626C7.789 3.439 6.687 2.923 6 2.494c-.687.429-1.789.945-3.3 1.132z",
    clipRule: "evenodd"
  })));
};
var Shield12 = (/* unused pure expression or super */ null && (SvgShield12));

var _path$39;
function _extends$3a() { _extends$3a = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3a.apply(this, arguments); }
var SvgShield16 = function SvgShield16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$3a({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path$39 || (_path$39 = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M14 8V3.98a.674.674 0 0 0-.647-.667C10.897 3.18 9.284 2.291 8.52 1.751a.925.925 0 0 0-1.038 0c-.765.54-2.378 1.43-4.834 1.562A.674.674 0 0 0 2 3.98V8s0 4.335 5.371 6.44c.403.157.855.157 1.258 0C14 12.334 14 8 14 8M3.714 7.982l.005.062c.005.07.019.188.049.344.06.314.184.768.438 1.278.49.984 1.519 2.287 3.79 3.177h.007c2.272-.89 3.3-2.193 3.791-3.177.255-.51.378-.964.438-1.278a3 3 0 0 0 .054-.406V4.935C10.346 4.679 8.916 4.02 8 3.46c-.915.561-2.346 1.219-4.286 1.475z",
    clipRule: "evenodd"
  })));
};
var Shield16 = (/* unused pure expression or super */ null && (SvgShield16));

var _path$38;
function _extends$39() { _extends$39 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$39.apply(this, arguments); }
var SvgShield18 = function SvgShield18(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$39({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _path$38 || (_path$38 = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M15.75 9V4.478a.76.76 0 0 0-.727-.75c-2.764-.15-4.578-1.15-5.44-1.759a1.04 1.04 0 0 0-1.167 0c-.861.609-2.675 1.609-5.438 1.759a.76.76 0 0 0-.728.75V9s0 4.877 6.043 7.244c.453.178.96.178 1.414 0C15.75 13.877 15.75 9 15.75 9m-11.9-.014v.004l.006.088c.008.088.024.233.06.42.072.378.22.918.521 1.522.587 1.178 1.804 2.702 4.44 3.735.078.03.168.03.246 0 2.636-1.033 3.853-2.557 4.44-3.735.301-.604.449-1.144.521-1.521a4 4 0 0 0 .066-.509V5.261C11.745 4.995 10.025 4.163 9 3.505c-1.025.658-2.745 1.49-5.15 1.756z",
    clipRule: "evenodd"
  })));
};
var Shield18 = (/* unused pure expression or super */ null && (SvgShield18));

var _path$37;
function _extends$38() { _extends$38 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$38.apply(this, arguments); }
var SvgShield24 = function SvgShield24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$38({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path$37 || (_path$37 = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M21 12V5.97c0-.54-.43-.97-.97-1-3.685-.2-6.103-1.533-7.252-2.344a1.39 1.39 0 0 0-1.556 0c-1.149.81-3.567 2.144-7.252 2.344-.54.03-.97.46-.97 1V12s0 6.502 8.057 9.659a2.6 2.6 0 0 0 1.886 0C21 18.502 21 12 21 12m-16.2-.014v.015q.001.035.01.131c.01.128.034.333.084.595.1.527.306 1.277.724 2.115.818 1.64 2.502 3.733 6.096 5.14.182.072.39.072.572 0 3.594-1.407 5.278-3.5 6.096-5.14a8.3 8.3 0 0 0 .724-2.115 6 6 0 0 0 .093-.726l.001-.015V6.713c-3.452-.325-5.857-1.543-7.2-2.438-1.343.895-3.748 2.113-7.2 2.438z",
    clipRule: "evenodd"
  })));
};
var Shield24 = (/* unused pure expression or super */ null && (SvgShield24));

var _path$36;
function _extends$37() { _extends$37 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$37.apply(this, arguments); }
var SvgShield32 = function SvgShield32(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$37({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _path$36 || (_path$36 = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M28 16V7.96c0-.72-.573-1.293-1.293-1.333-4.914-.267-8.138-2.045-9.67-3.126a1.85 1.85 0 0 0-2.075 0c-1.53 1.081-4.755 2.86-9.669 3.126C4.573 6.667 4 7.24 4 7.96V16s0 8.67 10.743 12.878a3.46 3.46 0 0 0 2.514 0C28 24.67 28 16 28 16m-22-.012.001.03q.001.053.013.192c.015.184.049.47.118.835a11.4 11.4 0 0 0 1 2.923c1.133 2.272 3.452 5.133 8.34 7.048.337.132.719.132 1.055 0 4.889-1.915 7.208-4.776 8.34-7.047.576-1.156.86-2.192 1-2.924A8 8 0 0 0 26 16.017v-.026l.001-.003V8.584c-4.922-.388-8.262-2.166-10-3.368-1.738 1.202-5.078 2.98-10 3.368z",
    clipRule: "evenodd"
  })));
};
var Shield32 = (/* unused pure expression or super */ null && (SvgShield32));

var _path$35;
function _extends$36() { _extends$36 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$36.apply(this, arguments); }
var SvgShield48 = function SvgShield48(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$36({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none"
  }, props), _path$35 || (_path$35 = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M42 24V11.94c0-1.08-.86-1.94-1.94-2-7.37-.4-12.207-3.067-14.503-4.688-.902-.637-2.211-.637-3.114 0C20.147 6.873 15.31 9.54 7.94 9.94c-1.08.06-1.94.92-1.94 2V24s0 13.004 16.115 19.318a5.18 5.18 0 0 0 3.77 0C42 37.004 42 24 42 24m-33.6-.011.002.061q.003.096.02.316c.026.294.078.744.187 1.314.218 1.142.66 2.75 1.553 4.54 1.762 3.534 5.35 7.934 12.828 10.863a2.78 2.78 0 0 0 2.02 0c7.478-2.93 11.066-7.329 12.828-10.862a17.7 17.7 0 0 0 1.553-4.54c.109-.57.161-1.02.186-1.315a7 7 0 0 0 .023-.376V12.317c-7.729-.49-12.88-3.307-15.427-5.105A.33.33 0 0 0 24 7.174a.33.33 0 0 0-.173.038C21.281 9.01 16.13 11.828 8.4 12.317z",
    clipRule: "evenodd"
  })));
};
var Shield48 = (/* unused pure expression or super */ null && (SvgShield48));

var ShieldIcon = function ShieldIcon(props) {
  var shield = {
    12: Shield12,
    16: Shield16,
    18: Shield18,
    24: Shield24,
    32: Shield32,
    48: Shield48
  };
  return jsx(IconTemplate, _assign({
    icons: shield
  }, props));
};

var _path$34;
function _extends$35() { _extends$35 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$35.apply(this, arguments); }
var SvgShieldFilled12 = function SvgShieldFilled12(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$35({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none"
  }, props), _path$34 || (_path$34 = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M1.5 6V2.985c0-.27.215-.485.485-.5 1.843-.1 3.052-.767 3.626-1.172a.69.69 0 0 1 .778 0c.574.405 1.783 1.072 3.626 1.172.27.015.485.23.485.5V6s0 3.251-4.029 4.83c-.302.118-.64.118-.942 0C1.5 9.25 1.5 6 1.5 6"
  })));
};
var ShieldFilled12 = (/* unused pure expression or super */ null && (SvgShieldFilled12));

var _path$33;
function _extends$34() { _extends$34 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$34.apply(this, arguments); }
var SvgShieldFilled16 = function SvgShieldFilled16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$34({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path$33 || (_path$33 = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M2 8V3.98c0-.36.287-.647.647-.667C5.103 3.18 6.716 2.291 7.48 1.751a.925.925 0 0 1 1.038 0c.765.54 2.378 1.43 4.834 1.562.36.02.647.307.647.667V8s0 4.335-5.371 6.44a1.73 1.73 0 0 1-1.258 0C2 12.334 2 8 2 8"
  })));
};
var ShieldFilled16 = (/* unused pure expression or super */ null && (SvgShieldFilled16));

var _path$32;
function _extends$33() { _extends$33 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$33.apply(this, arguments); }
var SvgShieldFilled18 = function SvgShieldFilled18(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$33({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _path$32 || (_path$32 = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M2.25 9V4.477c0-.405.322-.727.728-.75 2.763-.15 4.577-1.15 5.438-1.758a1.04 1.04 0 0 1 1.168 0c.861.608 2.675 1.609 5.439 1.758a.76.76 0 0 1 .727.75V9s0 4.877-6.043 7.244c-.453.178-.96.178-1.414 0C2.25 13.877 2.25 9 2.25 9"
  })));
};
var ShieldFilled18 = (/* unused pure expression or super */ null && (SvgShieldFilled18));

var _path$31;
function _extends$32() { _extends$32 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$32.apply(this, arguments); }
var SvgShieldFilled24 = function SvgShieldFilled24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$32({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path$31 || (_path$31 = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M3 12V5.97c0-.54.43-.97.97-1 3.685-.2 6.103-1.533 7.252-2.344a1.39 1.39 0 0 1 1.556 0c1.149.81 3.567 2.144 7.252 2.344.54.03.97.46.97 1V12s0 6.502-8.057 9.659a2.6 2.6 0 0 1-1.886 0C3 18.502 3 12 3 12"
  })));
};
var ShieldFilled24 = (/* unused pure expression or super */ null && (SvgShieldFilled24));

var _path$30;
function _extends$31() { _extends$31 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$31.apply(this, arguments); }
var SvgShieldFilled32 = function SvgShieldFilled32(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$31({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _path$30 || (_path$30 = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M4 16V7.96c0-.72.573-1.293 1.293-1.333 4.914-.267 8.138-2.045 9.67-3.126a1.85 1.85 0 0 1 2.075 0c1.53 1.081 4.755 2.86 9.669 3.126.72.04 1.293.613 1.293 1.333V16s0 8.67-10.743 12.878a3.46 3.46 0 0 1-2.514 0C4 24.67 4 16 4 16"
  })));
};
var ShieldFilled32 = (/* unused pure expression or super */ null && (SvgShieldFilled32));

var _path$2$;
function _extends$30() { _extends$30 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$30.apply(this, arguments); }
var SvgShieldFilled48 = function SvgShieldFilled48(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$30({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none"
  }, props), _path$2$ || (_path$2$ = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M6 24V11.94c0-1.08.86-1.94 1.94-2 7.37-.4 12.207-3.067 14.503-4.688.902-.637 2.211-.637 3.114 0C27.853 6.873 32.69 9.54 40.06 9.94c1.08.06 1.94.92 1.94 2V24s0 13.004-16.114 19.318a5.18 5.18 0 0 1-3.771 0C6 37.004 6 24 6 24"
  })));
};
var ShieldFilled48 = (/* unused pure expression or super */ null && (SvgShieldFilled48));

var ShieldFilledIcon = function ShieldFilledIcon(props) {
  var shieldFilled = {
    12: ShieldFilled12,
    16: ShieldFilled16,
    18: ShieldFilled18,
    24: ShieldFilled24,
    32: ShieldFilled32,
    48: ShieldFilled48
  };
  return jsx(IconTemplate, _assign({
    icons: shieldFilled
  }, props));
};

var _path$2_, _path2$16;
function _extends$2$() { _extends$2$ = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2$.apply(this, arguments); }
var SvgSigned12 = function SvgSigned12(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$2$({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none"
  }, props), _path$2_ || (_path$2_ = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M6.68 8.84a1.2 1.2 0 0 1 .85-.351h.959v-.96a1.2 1.2 0 0 1 .351-.848l.679-.679-.679-.678a1.2 1.2 0 0 1-.351-.849v-.96h-.96a1.2 1.2 0 0 1-.848-.35l-.679-.68-.678.68a1.2 1.2 0 0 1-.849.35h-.96v.96a1.2 1.2 0 0 1-.35.849l-.68.678.68.679a1.2 1.2 0 0 1 .35.848v.96h.96a1.2 1.2 0 0 1 .849.351l.678.679zM1.497 6.71l.82.82v1.159a1 1 0 0 0 1 1h1.16l.82.82a1 1 0 0 0 1.413 0l.82-.82h1.16a1 1 0 0 0 1-1v-1.16l.82-.82a1 1 0 0 0 0-1.414l-.82-.82v-1.16a1 1 0 0 0-1-1h-1.16l-.82-.82a1 1 0 0 0-1.414 0l-.82.82h-1.16a1 1 0 0 0-1 1v1.16l-.82.82a1 1 0 0 0 0 1.414",
    clipRule: "evenodd"
  })), _path2$16 || (_path2$16 = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M7.822 4.574a.6.6 0 0 1 .004.848l-1.98 2a.6.6 0 0 1-.869-.016l-.919-1a.6.6 0 0 1 .884-.812l.493.537 1.539-1.553a.6.6 0 0 1 .848-.004",
    clipRule: "evenodd"
  })));
};
var Signed12 = (/* unused pure expression or super */ null && (SvgSigned12));

var _path$2Z, _path2$15;
function _extends$2_() { _extends$2_ = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2_.apply(this, arguments); }
var SvgSigned16 = function SvgSigned16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$2_({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path$2Z || (_path$2Z = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M8.978 11.858a1.5 1.5 0 0 1 1.061-.44h1.38V10.04c0-.398.158-.78.439-1.06l.975-.976-.975-.975a1.5 1.5 0 0 1-.44-1.061v-1.38H10.04a1.5 1.5 0 0 1-1.06-.439l-.976-.975-.975.975a1.5 1.5 0 0 1-1.061.44h-1.38v1.379a1.5 1.5 0 0 1-.439 1.06l-.975.976.975.975a1.5 1.5 0 0 1 .44 1.061v1.38h1.38a1.5 1.5 0 0 1 1.06.439l.975.975zm-1.682-10.1a1 1 0 0 1 1.414 0l1.33 1.33h1.879a1 1 0 0 1 1 1v1.879l1.328 1.329a1 1 0 0 1 0 1.414L12.92 10.04v1.88a1 1 0 0 1-1 1h-1.88L8.71 14.247a1 1 0 0 1-1.414 0L5.967 12.92h-1.88a1 1 0 0 1-1-1v-1.88L1.76 8.71a1 1 0 0 1 0-1.414l1.329-1.33V4.089a1 1 0 0 1 1-1h1.879z",
    clipRule: "evenodd"
  })), _path2$15 || (_path2$15 = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M10.395 6.134a.75.75 0 0 1 .005 1.06L7.758 9.861a.75.75 0 0 1-1.085-.02L5.448 8.507a.75.75 0 0 1 1.104-1.014l.694.754 2.088-2.108a.75.75 0 0 1 1.06-.005",
    clipRule: "evenodd"
  })));
};
var Signed16 = (/* unused pure expression or super */ null && (SvgSigned16));

var _path$2Y, _path2$14;
function _extends$2Z() { _extends$2Z = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2Z.apply(this, arguments); }
var SvgSigned18 = function SvgSigned18(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$2Z({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _path$2Y || (_path$2Y = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M12.916 6.215a1.6 1.6 0 0 1-1.131-1.131l-.166-.62-.62.166a1.6 1.6 0 0 1-1.545-.414L9 3.763l-.453.453A1.6 1.6 0 0 1 7 4.63l-.62-.166-.166.62a1.6 1.6 0 0 1-1.13 1.131l-.62.166.166.62a1.6 1.6 0 0 1-.415 1.545L3.763 9l.453.454a1.6 1.6 0 0 1 .415 1.545l-.167.62.62.166a1.6 1.6 0 0 1 1.131 1.131l.166.62.62-.166a1.6 1.6 0 0 1 1.546.414l.453.453.454-.453a1.6 1.6 0 0 1 1.545-.414l.62.166.166-.62a1.6 1.6 0 0 1 1.131-1.131l.62-.166-.166-.62a1.6 1.6 0 0 1 .414-1.545L14.237 9l-.453-.454a1.6 1.6 0 0 1-.414-1.545l.166-.62zm-2.331-3.13-.878-.878a1 1 0 0 0-1.414 0l-.878.878-1.199-.321a1 1 0 0 0-1.225.707L4.67 4.67l-1.489.399a.7.7 0 0 0-.495.857l.399 1.489-.878.878a1 1 0 0 0 0 1.414l.878.878-.321 1.199a1 1 0 0 0 .707 1.225l1.199.321.399 1.489a.7.7 0 0 0 .857.495l1.49-.399.877.878a1 1 0 0 0 1.414 0l.878-.878 1.2.321a1 1 0 0 0 1.224-.707l.321-1.199 1.49-.399a.7.7 0 0 0 .494-.857l-.399-1.49.878-.877a1 1 0 0 0 0-1.414l-.878-.878.322-1.2a1 1 0 0 0-.708-1.224L13.33 4.67l-.399-1.49a.7.7 0 0 0-.857-.494z",
    clipRule: "evenodd"
  })), _path2$14 || (_path2$14 = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M11.663 6.932a.8.8 0 0 1 .005 1.131l-2.971 3a.8.8 0 0 1-1.158-.022l-1.378-1.5A.8.8 0 0 1 7.339 8.46l.811.882 2.382-2.404a.8.8 0 0 1 1.131-.005",
    clipRule: "evenodd"
  })));
};
var Signed18 = (/* unused pure expression or super */ null && (SvgSigned18));

var _path$2X, _path2$13;
function _extends$2Y() { _extends$2Y = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2Y.apply(this, arguments); }
var SvgSigned24 = function SvgSigned24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$2Y({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path$2X || (_path$2X = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M17.308 7.965a1.8 1.8 0 0 1-1.273-1.273l-.308-1.148-1.148.308a1.8 1.8 0 0 1-1.738-.466l-.84-.84-.841.84a1.8 1.8 0 0 1-1.739.466l-1.148-.308-.308 1.148a1.8 1.8 0 0 1-1.273 1.273l-1.148.308.308 1.148a1.8 1.8 0 0 1-.466 1.739l-.84.84.84.84a1.8 1.8 0 0 1 .466 1.74l-.308 1.147 1.148.308a1.8 1.8 0 0 1 1.273 1.273l.308 1.148 1.148-.308a1.8 1.8 0 0 1 1.739.466l.84.84.84-.84a1.8 1.8 0 0 1 1.74-.466l1.147.308.308-1.148a1.8 1.8 0 0 1 1.273-1.273l1.148-.308-.308-1.148a1.8 1.8 0 0 1 .466-1.739l.84-.84-.84-.84a1.8 1.8 0 0 1-.466-1.74l.308-1.147zm.466-1.739-.515-1.92a1 1 0 0 0-1.225-.707l-1.92.514-1.407-1.406a1 1 0 0 0-1.414 0L9.887 4.113 7.966 3.6a1 1 0 0 0-1.225.707l-.514 1.92-1.921.515a1 1 0 0 0-.707 1.225l.514 1.92-1.406 1.407a1 1 0 0 0 0 1.414l1.406 1.406-.514 1.921a1 1 0 0 0 .707 1.225l1.92.514.515 1.921a1 1 0 0 0 1.225.707l1.92-.514 1.407 1.406a1 1 0 0 0 1.414 0l1.406-1.406 1.921.514a1 1 0 0 0 1.225-.707l.515-1.92 1.92-.515a1 1 0 0 0 .707-1.225l-.514-1.92 1.406-1.407a1 1 0 0 0 0-1.414l-1.406-1.406.514-1.921a1 1 0 0 0-.707-1.225z",
    clipRule: "evenodd"
  })), _path2$13 || (_path2$13 = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M15.434 9.36a.9.9 0 0 1 .006 1.273l-3.963 4a.9.9 0 0 1-1.302-.024l-1.838-2a.9.9 0 0 1 1.326-1.218l1.2 1.305 3.298-3.33a.9.9 0 0 1 1.273-.005",
    clipRule: "evenodd"
  })));
};
var Signed24 = (/* unused pure expression or super */ null && (SvgSigned24));

var _path$2W, _path2$12;
function _extends$2X() { _extends$2X = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2X.apply(this, arguments); }
var SvgSigned32 = function SvgSigned32(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$2X({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _path$2W || (_path$2W = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M22.961 10.015A2 2 0 0 1 21.547 8.6l-.514-1.917-1.917.513a2 2 0 0 1-1.931-.517L15.78 5.276 14.378 6.68a2 2 0 0 1-1.932.517l-1.917-.513-.514 1.917A2 2 0 0 1 8.6 10.015l-1.917.514.513 1.917a2 2 0 0 1-.517 1.932L5.276 15.78l1.404 1.403a2 2 0 0 1 .517 1.932l-.513 1.918 1.917.513a2 2 0 0 1 1.414 1.414l.514 1.918 1.917-.514a2 2 0 0 1 1.932.518l1.403 1.403 1.403-1.404a2 2 0 0 1 1.932-.517l1.918.514.513-1.918a2 2 0 0 1 1.414-1.414l1.918-.514-.514-1.917a2 2 0 0 1 .518-1.931l1.403-1.404-1.404-1.403a2 2 0 0 1-.517-1.932l.514-1.917zm-6.708 16.742h-.002zm2.346-21.492-1.875-1.874a1.333 1.333 0 0 0-1.886 0l-1.875 1.874-2.56-.686a1.333 1.333 0 0 0-1.634.943l-.686 2.561-2.561.686a1.333 1.333 0 0 0-.943 1.633l.686 2.561-1.874 1.875c-.521.52-.521 1.365 0 1.886l1.874 1.875-.686 2.56c-.19.712.232 1.443.943 1.634l2.561.686.686 2.561c.19.711.922 1.134 1.633.943l2.561-.686 1.875 1.875c.52.52 1.365.52 1.886 0l1.875-1.875 2.56.686a1.333 1.333 0 0 0 1.634-.943l.686-2.56 2.561-.687a1.333 1.333 0 0 0 .943-1.633l-.686-2.561 1.875-1.875c.52-.52.52-1.365 0-1.886l-1.875-1.875.686-2.56a1.333 1.333 0 0 0-.943-1.634l-2.561-.686-.686-2.561a1.333 1.333 0 0 0-1.633-.943z",
    clipRule: "evenodd"
  })), _path2$12 || (_path2$12 = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M20.455 12.641a1 1 0 0 1-.03 1.414l-5.558 5.333a1 1 0 0 1-1.384 0l-2.175-2.087a1 1 0 1 1 1.384-1.443l1.483 1.423 4.866-4.67a1 1 0 0 1 1.414.03",
    clipRule: "evenodd"
  })));
};
var Signed32 = (/* unused pure expression or super */ null && (SvgSigned32));

var _path$2V, _path2$11;
function _extends$2W() { _extends$2W = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2W.apply(this, arguments); }
var SvgSigned48 = function SvgSigned48(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$2W({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none"
  }, props), _path$2V || (_path$2V = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M34.926 14.771a2.4 2.4 0 0 1-1.697-1.697l-.9-3.359a.1.1 0 0 0-.123-.07l-3.358.9a2.4 2.4 0 0 1-2.318-.621l-2.46-2.46a.1.1 0 0 0-.14 0l-2.46 2.46a2.4 2.4 0 0 1-2.318.62l-3.358-.9a.1.1 0 0 0-.123.071l-.9 3.36a2.4 2.4 0 0 1-1.697 1.696l-3.358.9a.1.1 0 0 0-.071.123l.9 3.358a2.4 2.4 0 0 1-.621 2.319l-2.46 2.458a.1.1 0 0 0 0 .142l2.46 2.458a2.4 2.4 0 0 1 .62 2.319l-.9 3.358a.1.1 0 0 0 .072.123l3.358.9a2.4 2.4 0 0 1 1.697 1.697l.9 3.358a.1.1 0 0 0 .123.071l3.358-.9a2.4 2.4 0 0 1 2.319.621l2.458 2.46a.1.1 0 0 0 .142 0l2.459-2.46a2.4 2.4 0 0 1 2.318-.62l3.358.9a.1.1 0 0 0 .123-.072l.9-3.358a2.4 2.4 0 0 1 1.697-1.697l3.359-.9a.1.1 0 0 0 .07-.123l-.9-3.358a2.4 2.4 0 0 1 .622-2.319l2.458-2.458a.1.1 0 0 0 0-.142l-2.458-2.458a2.4 2.4 0 0 1-.622-2.319l.9-3.358a.1.1 0 0 0-.07-.123zM19.774 8.226l-3.36-.9a2.5 2.5 0 0 0-3.06 1.768l-.9 3.359-3.36.9a2.5 2.5 0 0 0-1.767 3.062l.9 3.358-2.46 2.46a2.5 2.5 0 0 0 0 3.535l2.46 2.459-.9 3.358a2.5 2.5 0 0 0 1.767 3.062l3.36.9.9 3.359a2.5 2.5 0 0 0 3.06 1.767l3.36-.9 2.458 2.46a2.5 2.5 0 0 0 3.536 0l2.459-2.46 3.358.9a2.5 2.5 0 0 0 3.062-1.767l.9-3.359 3.359-.9a2.5 2.5 0 0 0 1.768-3.062l-.9-3.358 2.458-2.46a2.5 2.5 0 0 0 0-3.535l-2.458-2.459.9-3.358a2.5 2.5 0 0 0-1.768-3.062l-3.359-.9-.9-3.359a2.5 2.5 0 0 0-3.062-1.767l-3.358.9-2.46-2.46a2.5 2.5 0 0 0-3.535 0z",
    clipRule: "evenodd"
  })), _path2$11 || (_path2$11 = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M30.445 19.148a1.2 1.2 0 0 1 .008 1.697l-7.925 8a1.2 1.2 0 0 1-1.736-.033l-3.676-4a1.2 1.2 0 0 1 1.768-1.624l2.824 3.074 7.04-7.107a1.2 1.2 0 0 1 1.697-.008",
    clipRule: "evenodd"
  })));
};
var Signed48 = (/* unused pure expression or super */ null && (SvgSigned48));

var SignedIcon = function SignedIcon(props) {
  var signed = {
    12: Signed12,
    16: Signed16,
    18: Signed18,
    24: Signed24,
    32: Signed32,
    48: Signed48
  };
  return jsx(IconTemplate, _assign({
    icons: signed
  }, props));
};

var _path$2U;
function _extends$2V() { _extends$2V = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2V.apply(this, arguments); }
var SvgSignedFilled12 = function SvgSignedFilled12(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$2V({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none"
  }, props), _path$2U || (_path$2U = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M6.71 10.509a1 1 0 0 1-1.415 0l-.82-.82h-1.16a1 1 0 0 1-1-1v-1.16l-.82-.82a1 1 0 0 1 0-1.414l.82-.82v-1.16a1 1 0 0 1 1-1h1.16l.82-.82a1 1 0 0 1 1.414 0l.82.82h1.16a1 1 0 0 1 1 1v1.16l.82.82a1 1 0 0 1 0 1.414l-.82.82v1.16a1 1 0 0 1-1 1h-1.16zm1.116-5.087a.6.6 0 1 0-.852-.844L5.435 6.13l-.493-.537a.6.6 0 0 0-.884.812l.919 1a.6.6 0 0 0 .868.016z",
    clipRule: "evenodd"
  })));
};
var SignedFilled12 = (/* unused pure expression or super */ null && (SvgSignedFilled12));

var _path$2T;
function _extends$2U() { _extends$2U = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2U.apply(this, arguments); }
var SvgSignedFilled16 = function SvgSignedFilled16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$2U({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path$2T || (_path$2T = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M8.71 14.247a1 1 0 0 1-1.414 0L5.967 12.92h-1.88a1 1 0 0 1-1-1v-1.88L1.76 8.71a1 1 0 0 1 0-1.414l1.329-1.33V4.089a1 1 0 0 1 1-1h1.879l1.329-1.33a1 1 0 0 1 1.414 0l1.33 1.33h1.879a1 1 0 0 1 1 1v1.879l1.328 1.329a1 1 0 0 1 0 1.414L12.92 10.04v1.88a1 1 0 0 1-1 1h-1.88zm1.69-7.053A.75.75 0 0 0 9.334 6.14L7.246 8.247l-.694-.754a.75.75 0 0 0-1.104 1.014l1.225 1.334a.75.75 0 0 0 1.085.02z",
    clipRule: "evenodd"
  })));
};
var SignedFilled16 = (/* unused pure expression or super */ null && (SvgSignedFilled16));

var _path$2S;
function _extends$2T() { _extends$2T = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2T.apply(this, arguments); }
var SvgSignedFilled18 = function SvgSignedFilled18(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$2T({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _path$2S || (_path$2S = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M9.707 2.207a1 1 0 0 0-1.414 0l-.878.878-1.2-.321a1 1 0 0 0-1.224.707L4.67 4.67l-1.2.321a1 1 0 0 0-.707 1.225l.322 1.199-.878.878a1 1 0 0 0 0 1.414l.878.878-.322 1.199a1 1 0 0 0 .708 1.225l1.199.321.321 1.2a1 1 0 0 0 1.225.706l1.199-.321.878.878a1 1 0 0 0 1.414 0l.878-.878 1.199.321a1 1 0 0 0 1.225-.707l.321-1.199 1.2-.321a1 1 0 0 0 .706-1.225l-.321-1.2.878-.877a1 1 0 0 0 0-1.414l-.878-.878.321-1.2a1 1 0 0 0-.707-1.224L13.33 4.67l-.321-1.2a1 1 0 0 0-1.225-.706l-1.2.32zm1.961 5.856a.8.8 0 0 0-1.136-1.126L8.15 9.341l-.811-.882A.8.8 0 0 0 6.16 9.54l1.378 1.5a.8.8 0 0 0 1.157.022z",
    clipRule: "evenodd"
  })));
};
var SignedFilled18 = (/* unused pure expression or super */ null && (SvgSignedFilled18));

var _path$2R;
function _extends$2S() { _extends$2S = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2S.apply(this, arguments); }
var SvgSignedFilled24 = function SvgSignedFilled24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$2S({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path$2R || (_path$2R = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M12.707 2.707a1 1 0 0 0-1.414 0L9.887 4.113 7.966 3.6a1 1 0 0 0-1.225.707l-.515 1.92-1.92.515a1 1 0 0 0-.708 1.225l.515 1.92-1.406 1.407a1 1 0 0 0 0 1.414l1.406 1.406-.515 1.921a1 1 0 0 0 .708 1.225l1.92.514.515 1.921a1 1 0 0 0 1.225.707l1.92-.514 1.407 1.406a1 1 0 0 0 1.414 0l1.406-1.406 1.92.514a1 1 0 0 0 1.226-.707l.514-1.92 1.921-.515a1 1 0 0 0 .707-1.225l-.514-1.92 1.406-1.407a1 1 0 0 0 0-1.414l-1.406-1.406.514-1.921a1 1 0 0 0-.707-1.225l-1.92-.515-.515-1.92a1 1 0 0 0-1.225-.707l-1.92.514zm2.732 7.926a.9.9 0 1 0-1.278-1.266l-3.299 3.33-1.2-1.306a.9.9 0 0 0-1.325 1.218l1.838 2a.9.9 0 0 0 1.302.024z",
    clipRule: "evenodd"
  })));
};
var SignedFilled24 = (/* unused pure expression or super */ null && (SvgSignedFilled24));

var _path$2Q;
function _extends$2R() { _extends$2R = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2R.apply(this, arguments); }
var SvgSignedFilled32 = function SvgSignedFilled32(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$2R({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _path$2Q || (_path$2Q = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M16.94 3.607a1.33 1.33 0 0 0-1.88 0l-1.878 1.877-2.564-.687a1.33 1.33 0 0 0-1.629.94l-.687 2.565-2.564.687c-.71.19-1.13.92-.94 1.629l.687 2.564-1.878 1.877a1.33 1.33 0 0 0 0 1.881l1.878 1.878-.688 2.564c-.19.71.231 1.439.94 1.629l2.565.687.687 2.564c.19.71.92 1.13 1.63.94l2.563-.686 1.878 1.877c.52.52 1.361.52 1.88 0l1.878-1.877 2.564.687a1.33 1.33 0 0 0 1.63-.94l.686-2.565 2.564-.687c.71-.19 1.131-.92.941-1.629l-.687-2.564 1.877-1.878a1.33 1.33 0 0 0 0-1.88l-1.877-1.878.687-2.564a1.33 1.33 0 0 0-.94-1.629l-2.565-.687-.687-2.564a1.33 1.33 0 0 0-1.629-.94l-2.564.686zm3.504 10.43a1 1 0 0 0-1.42-1.408l-4.546 4.59-1.741-1.896a1 1 0 0 0-1.473 1.354l2.45 2.666a1 1 0 0 0 1.447.027z",
    clipRule: "evenodd"
  })));
};
var SignedFilled32 = (/* unused pure expression or super */ null && (SvgSignedFilled32));

var _path$2P;
function _extends$2Q() { _extends$2Q = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2Q.apply(this, arguments); }
var SvgSignedFilled48 = function SvgSignedFilled48(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$2Q({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none"
  }, props), _path$2P || (_path$2P = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M25.768 5.768a2.5 2.5 0 0 0-3.536 0l-2.458 2.458-3.36-.9a2.5 2.5 0 0 0-3.06 1.768l-.9 3.359-3.36.9a2.5 2.5 0 0 0-1.767 3.062l.9 3.358-2.46 2.46a2.5 2.5 0 0 0 0 3.535l2.46 2.459-.9 3.358a2.5 2.5 0 0 0 1.767 3.062l3.36.9.9 3.359a2.5 2.5 0 0 0 3.06 1.767l3.36-.9 2.458 2.46a2.5 2.5 0 0 0 3.536 0l2.459-2.46 3.358.9a2.5 2.5 0 0 0 3.062-1.767l.9-3.359 3.359-.9a2.5 2.5 0 0 0 1.768-3.062l-.9-3.358 2.458-2.46a2.5 2.5 0 0 0 0-3.535l-2.458-2.459.9-3.358a2.5 2.5 0 0 0-1.768-3.062l-3.359-.9-.9-3.359a2.5 2.5 0 0 0-3.062-1.767l-3.358.9zm4.685 15.077a1.2 1.2 0 1 0-1.705-1.69l-7.04 7.107-2.824-3.074a1.2 1.2 0 1 0-1.768 1.624l3.676 4a1.2 1.2 0 0 0 1.736.032z",
    clipRule: "evenodd"
  })));
};
var SignedFilled48 = (/* unused pure expression or super */ null && (SvgSignedFilled48));

var SignedFilledIcon = function SignedFilledIcon(props) {
  var signedFilled = {
    12: SignedFilled12,
    16: SignedFilled16,
    18: SignedFilled18,
    24: SignedFilled24,
    32: SignedFilled32,
    48: SignedFilled48
  };
  return jsx(IconTemplate, _assign({
    icons: signedFilled
  }, props));
};

var _path$2O;
function _extends$2P() { _extends$2P = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2P.apply(this, arguments); }
var SvgSignOut12 = function SvgSignOut12(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends$2P({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none"
  }, props), _path$2O || (_path$2O = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M.9 3.25c0-1.16.94-2.1 2.1-2.1h3.5c1.16 0 2.1.94 2.1 2.1v.153a.6.6 0 0 1-1.2 0V3.25a.9.9 0 0 0-.9-.9H3a.9.9 0 0 0-.9.9v5.5a.9.9 0 0 0 .9.9h3.5a.9.9 0 0 0 .9-.9v-.153a.6.6 0 0 1 1.2 0v.153a2.1 2.1 0 0 1-2.1 2.1H3a2.1 2.1 0 0 1-2.1-2.1zm8.176.826a.6.6 0 0 1 .848 0l1.5 1.5a.6.6 0 0 1 0 .848l-1.5 1.5a.6.6 0 0 1-.848-.848L9.55 6.6H5.5a.6.6 0 1 1 0-1.2H9.55l-.475-.476a.6.6 0 0 1 0-.848",
    clipRule: "evenodd"
  })));
};
var SignOut12 = SvgSignOut12;

var _path$2N;
function _extends$2O() { _extends$2O = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2O.apply(this, arguments); }
var SvgSignOut16 = function SvgSignOut16(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends$2O({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path$2N || (_path$2N = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M1.25 4.333A2.75 2.75 0 0 1 4 1.583h4.667a2.75 2.75 0 0 1 2.75 2.75v.204a.75.75 0 0 1-1.5 0v-.204c0-.69-.56-1.25-1.25-1.25H4c-.69 0-1.25.56-1.25 1.25v7.334c0 .69.56 1.25 1.25 1.25h4.667c.69 0 1.25-.56 1.25-1.25v-.204a.75.75 0 0 1 1.5 0v.204a2.75 2.75 0 0 1-2.75 2.75H4a2.75 2.75 0 0 1-2.75-2.75zM12.136 5.47a.75.75 0 0 1 1.061 0l2 2a.75.75 0 0 1 0 1.06l-2 2a.75.75 0 0 1-1.06-1.06l.719-.72H7.333a.75.75 0 0 1 0-1.5h5.523l-.72-.72a.75.75 0 0 1 0-1.06",
    clipRule: "evenodd"
  })));
};
var SignOut16 = SvgSignOut16;

var _path$2M;
function _extends$2N() { _extends$2N = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2N.apply(this, arguments); }
var SvgSignOut18 = function SvgSignOut18(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends$2N({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _path$2M || (_path$2M = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M1.45 4.875a3.05 3.05 0 0 1 3.05-3.05h5.25a3.05 3.05 0 0 1 3.05 3.05v.23a.8.8 0 1 1-1.6 0v-.23c0-.8-.65-1.45-1.45-1.45H4.5c-.8 0-1.45.65-1.45 1.45v8.25c0 .8.65 1.45 1.45 1.45h5.25c.8 0 1.45-.65 1.45-1.45v-.23a.8.8 0 0 1 1.6 0v.23a3.05 3.05 0 0 1-3.05 3.05H4.5a3.05 3.05 0 0 1-3.05-3.05zm12.234 1.31a.8.8 0 0 1 1.132 0l2.25 2.25a.8.8 0 0 1 0 1.13l-2.25 2.25a.8.8 0 1 1-1.132-1.13l.885-.885h-6.32a.8.8 0 1 1 0-1.6h6.32l-.885-.884a.8.8 0 0 1 0-1.132",
    clipRule: "evenodd"
  })));
};
var SignOut18 = SvgSignOut18;

var _path$2L;
function _extends$2M() { _extends$2M = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2M.apply(this, arguments); }
var SvgSignOut24 = function SvgSignOut24(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends$2M({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path$2L || (_path$2L = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M2.1 6.5A3.9 3.9 0 0 1 6 2.6h7a3.9 3.9 0 0 1 3.9 3.9v.306a.9.9 0 1 1-1.8 0V6.5A2.1 2.1 0 0 0 13 4.4H6a2.1 2.1 0 0 0-2.1 2.1v11c0 1.16.94 2.1 2.1 2.1h7a2.1 2.1 0 0 0 2.1-2.1v-.306a.9.9 0 0 1 1.8 0v.306a3.9 3.9 0 0 1-3.9 3.9H6a3.9 3.9 0 0 1-3.9-3.9zm16.264 1.864a.9.9 0 0 1 1.273 0l3 3a.9.9 0 0 1 0 1.272l-3 3a.9.9 0 0 1-1.273-1.272l1.463-1.464H11a.9.9 0 0 1 0-1.8h8.827l-1.463-1.464a.9.9 0 0 1 0-1.272",
    clipRule: "evenodd"
  })));
};
var SignOut24 = SvgSignOut24;

var _path$2K;
function _extends$2L() { _extends$2L = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2L.apply(this, arguments); }
var SvgSignOut32 = function SvgSignOut32(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends$2L({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _path$2K || (_path$2K = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M3 8.667a5 5 0 0 1 5-5h9.333a5 5 0 0 1 5 5v.407a1 1 0 1 1-2 0v-.407a3 3 0 0 0-3-3H8a3 3 0 0 0-3 3v14.666a3 3 0 0 0 3 3h9.333a3 3 0 0 0 3-3v-.407a1 1 0 1 1 2 0v.407a5 5 0 0 1-5 5H8a5 5 0 0 1-5-5zm21.626 2.626a1 1 0 0 1 1.414 0l4 4a1 1 0 0 1 0 1.414l-4 4a1 1 0 0 1-1.414-1.414L26.92 17H14.667a1 1 0 0 1 0-2h12.252l-2.293-2.293a1 1 0 0 1 0-1.414",
    clipRule: "evenodd"
  })));
};
var SignOut32 = SvgSignOut32;

var _path$2J;
function _extends$2K() { _extends$2K = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2K.apply(this, arguments); }
var SvgSignOut48 = function SvgSignOut48(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends$2K({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none"
  }, props), _path$2J || (_path$2J = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M4.8 13A7.2 7.2 0 0 1 12 5.8h14a7.2 7.2 0 0 1 7.2 7.2v.611a1.2 1.2 0 1 1-2.4 0v-.61A4.8 4.8 0 0 0 26 8.2H12A4.8 4.8 0 0 0 7.2 13v22a4.8 4.8 0 0 0 4.8 4.8h14a4.8 4.8 0 0 0 4.8-4.8v-.611a1.2 1.2 0 0 1 2.4 0V35a7.2 7.2 0 0 1-7.2 7.2H12A7.2 7.2 0 0 1 4.8 35zm32.352 4.151a1.2 1.2 0 0 1 1.697 0l6 6a1.2 1.2 0 0 1 0 1.698l-6 6a1.2 1.2 0 0 1-1.697-1.698l3.951-3.95H22a1.2 1.2 0 0 1 0-2.401h19.103l-3.952-3.951a1.2 1.2 0 0 1 0-1.698",
    clipRule: "evenodd"
  })));
};
var SignOut48 = SvgSignOut48;

var SignOutIcon = function SignOutIcon(props) {
  var signOut = {
    12: SignOut12,
    16: SignOut16,
    18: SignOut18,
    24: SignOut24,
    32: SignOut32,
    48: SignOut48
  };
  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(IconTemplate, (0,_common_js__WEBPACK_IMPORTED_MODULE_2__.a)({
    icons: signOut
  }, props));
};

var _path$2I;
function _extends$2J() { _extends$2J = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2J.apply(this, arguments); }
var SvgSorting12 = function SvgSorting12(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$2J({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none"
  }, props), _path$2I || (_path$2I = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M3.576 2.576a.6.6 0 0 1 .848 0l1.75 1.75a.6.6 0 0 1-.848.848L4.6 4.448V9a.6.6 0 0 1-1.2 0V4.448l-.726.726a.6.6 0 0 1-.848-.848zM8.424 9.424a.6.6 0 0 1-.848 0l-1.75-1.75a.6.6 0 1 1 .848-.848l.726.725V3a.6.6 0 0 1 1.2 0V7.55l.726-.725a.6.6 0 0 1 .848.848z",
    clipRule: "evenodd"
  })));
};
var Sorting12 = (/* unused pure expression or super */ null && (SvgSorting12));

var _path$2H;
function _extends$2I() { _extends$2I = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2I.apply(this, arguments); }
var SvgSorting16 = function SvgSorting16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$2I({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path$2H || (_path$2H = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M5.333 3.25a.75.75 0 0 1 .53.22l2.334 2.333a.75.75 0 0 1-1.06 1.06L6.082 5.812V12a.75.75 0 0 1-1.5 0V5.81L3.53 6.865a.75.75 0 1 1-1.06-1.061L4.803 3.47a.75.75 0 0 1 .53-.22M10.667 12.75a.75.75 0 0 1-.53-.22l-2.334-2.333a.75.75 0 0 1 1.06-1.06l1.054 1.052V4a.75.75 0 0 1 1.5 0v6.19l1.053-1.054a.75.75 0 1 1 1.06 1.061l-2.333 2.333a.75.75 0 0 1-.53.22",
    clipRule: "evenodd"
  })));
};
var Sorting16 = (/* unused pure expression or super */ null && (SvgSorting16));

var _path$2G;
function _extends$2H() { _extends$2H = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2H.apply(this, arguments); }
var SvgSorting18 = function SvgSorting18(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$2H({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _path$2G || (_path$2G = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M5.435 3.935a.8.8 0 0 1 1.13 0L9.192 6.56A.8.8 0 1 1 8.06 7.69L6.8 6.433V13.5a.8.8 0 0 1-1.6 0V6.432L3.94 7.69A.8.8 0 1 1 2.81 6.56zM12.566 14.066a.8.8 0 0 1-1.132 0L8.81 11.44a.8.8 0 0 1 1.13-1.132l1.26 1.26V4.5a.8.8 0 0 1 1.6 0v7.069l1.26-1.26a.8.8 0 0 1 1.13 1.132z",
    clipRule: "evenodd"
  })));
};
var Sorting18 = (/* unused pure expression or super */ null && (SvgSorting18));

var _path$2F;
function _extends$2G() { _extends$2G = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2G.apply(this, arguments); }
var SvgSorting24 = function SvgSorting24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$2G({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path$2F || (_path$2F = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M7.364 5.364a.9.9 0 0 1 1.272 0l3.5 3.5a.9.9 0 1 1-1.272 1.272L8.9 8.174V18a.9.9 0 1 1-1.8 0V8.173l-1.964 1.963a.9.9 0 1 1-1.272-1.272zM16.637 18.637a.9.9 0 0 1-1.273 0l-3.5-3.5a.9.9 0 1 1 1.272-1.273l1.964 1.963V6a.9.9 0 1 1 1.8 0v9.827l1.964-1.963a.9.9 0 1 1 1.273 1.272z",
    clipRule: "evenodd"
  })));
};
var Sorting24 = (/* unused pure expression or super */ null && (SvgSorting24));

var _path$2E;
function _extends$2F() { _extends$2F = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2F.apply(this, arguments); }
var SvgSorting32 = function SvgSorting32(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$2F({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _path$2E || (_path$2E = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M10.667 7a1 1 0 0 1 .707.293l4.666 4.667a1 1 0 1 1-1.414 1.414l-2.96-2.96V24a1 1 0 1 1-2 0V10.414l-2.959 2.96a1 1 0 0 1-1.414-1.414L9.96 7.293A1 1 0 0 1 10.667 7M21.333 25a1 1 0 0 1-.707-.293L15.96 20.04a1 1 0 1 1 1.414-1.414l2.96 2.96V8a1 1 0 0 1 2 0v13.586l2.959-2.96a1 1 0 0 1 1.414 1.414l-4.667 4.667a1 1 0 0 1-.707.293",
    clipRule: "evenodd"
  })));
};
var Sorting32 = (/* unused pure expression or super */ null && (SvgSorting32));

var _path$2D;
function _extends$2E() { _extends$2E = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2E.apply(this, arguments); }
var SvgSorting48 = function SvgSorting48(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$2E({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none"
  }, props), _path$2D || (_path$2D = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M15.151 11.151a1.2 1.2 0 0 1 1.697 0l7 7a1.2 1.2 0 1 1-1.697 1.697L17.2 14.897V36a1.2 1.2 0 0 1-2.4 0V14.897l-4.952 4.951a1.2 1.2 0 1 1-1.697-1.697zM32.848 36.848a1.2 1.2 0 0 1-1.697 0l-7-7a1.2 1.2 0 1 1 1.697-1.697l4.952 4.952V12a1.2 1.2 0 0 1 2.4 0v21.103l4.951-4.952a1.2 1.2 0 1 1 1.697 1.697z",
    clipRule: "evenodd"
  })));
};
var Sorting48 = (/* unused pure expression or super */ null && (SvgSorting48));

var SortingIcon = function SortingIcon(props) {
  var sorting = {
    12: Sorting12,
    16: Sorting16,
    18: Sorting18,
    24: Sorting24,
    32: Sorting32,
    48: Sorting48
  };
  return jsx(IconTemplate, _assign({
    icons: sorting
  }, props));
};

var _path$2C;
function _extends$2D() { _extends$2D = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2D.apply(this, arguments); }
var SvgSoundMuteFilled12 = function SvgSoundMuteFilled12(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$2D({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none"
  }, props), _path$2C || (_path$2C = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M6.175 1.708 3.5 4H2.25C1.56 4 1 4.56 1 5.25v1.5C1 7.44 1.56 8 2.25 8H3.5l2.675 2.293A.5.5 0 0 0 7 9.913V2.087a.5.5 0 0 0-.825-.38M8.283 7.245a.4.4 0 0 1 0-.565l.832-.832-.832-.832a.4.4 0 0 1 .566-.566l.831.832.832-.832a.4.4 0 0 1 .566.566l-.832.832.832.832a.4.4 0 0 1-.566.565l-.832-.831-.831.831a.4.4 0 0 1-.566 0"
  })));
};
var SoundMuteFilled12 = (/* unused pure expression or super */ null && (SvgSoundMuteFilled12));

var _path$2B;
function _extends$2C() { _extends$2C = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2C.apply(this, arguments); }
var SvgSoundMuteFilled16 = function SvgSoundMuteFilled16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$2C({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path$2B || (_path$2B = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "m4.667 5.333 3.566-3.056a.667.667 0 0 1 1.1.506v10.434c0 .57-.668.877-1.1.506l-3.566-3.056H3c-.92 0-1.667-.746-1.667-1.667V7c0-.92.746-1.667 1.667-1.667zM11.798 5.934a.533.533 0 0 0-.754.754l1.109 1.11-1.11 1.109a.533.533 0 0 0 .755.754l1.11-1.11 1.108 1.11a.533.533 0 0 0 .755-.754l-1.11-1.11 1.11-1.109a.533.533 0 1 0-.755-.754l-1.109 1.11z"
  })));
};
var SoundMuteFilled16 = (/* unused pure expression or super */ null && (SvgSoundMuteFilled16));

var _path$2A;
function _extends$2B() { _extends$2B = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2B.apply(this, arguments); }
var SvgSoundMuteFilled18 = function SvgSoundMuteFilled18(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$2B({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _path$2A || (_path$2A = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M5.25 6 9.262 2.56a.75.75 0 0 1 1.238.57v11.738a.75.75 0 0 1-1.238.57L5.25 12H3.375A1.875 1.875 0 0 1 1.5 10.125v-2.25C1.5 6.839 2.34 6 3.375 6zM13.273 6.676a.6.6 0 1 0-.849.848l1.248 1.248-1.248 1.248a.6.6 0 0 0 .849.848l1.248-1.247 1.247 1.247a.6.6 0 0 0 .849-.848l-1.248-1.248 1.248-1.248a.6.6 0 0 0-.849-.848l-1.247 1.247z"
  })));
};
var SoundMuteFilled18 = (/* unused pure expression or super */ null && (SvgSoundMuteFilled18));

var _path$2z;
function _extends$2A() { _extends$2A = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2A.apply(this, arguments); }
var SvgSoundMuteFilled24 = function SvgSoundMuteFilled24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$2A({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path$2z || (_path$2z = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "m7 8 5.35-4.585a1 1 0 0 1 1.65.76v15.65a1 1 0 0 1-1.65.76L7 16H4.5A2.5 2.5 0 0 1 2 13.5v-3A2.5 2.5 0 0 1 4.5 8zM17.697 8.901a.8.8 0 0 0-1.131 1.131l1.663 1.664-1.663 1.664a.8.8 0 0 0 1.131 1.131l1.664-1.664 1.663 1.664a.8.8 0 1 0 1.132-1.131l-1.664-1.664 1.664-1.664a.8.8 0 1 0-1.131-1.131l-1.664 1.664z"
  })));
};
var SoundMuteFilled24 = (/* unused pure expression or super */ null && (SvgSoundMuteFilled24));

var _path$2y;
function _extends$2z() { _extends$2z = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2z.apply(this, arguments); }
var SvgSoundMuteFilled32 = function SvgSoundMuteFilled32(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$2z({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _path$2y || (_path$2y = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "m9.333 10.667 7.133-6.114c.865-.741 2.2-.127 2.2 1.013v20.868c0 1.14-1.335 1.754-2.2 1.013l-7.133-6.114H6A3.333 3.333 0 0 1 2.667 18v-4A3.333 3.333 0 0 1 6 10.667zM22.088 17.813a1.067 1.067 0 1 0 1.508 1.508l2.218-2.218 2.219 2.218a1.067 1.067 0 1 0 1.508-1.508l-2.218-2.218 2.218-2.219a1.067 1.067 0 0 0-1.508-1.508l-2.219 2.218-2.218-2.218a1.067 1.067 0 0 0-1.508 1.508l2.218 2.219z"
  })));
};
var SoundMuteFilled32 = (/* unused pure expression or super */ null && (SvgSoundMuteFilled32));

var _path$2x;
function _extends$2y() { _extends$2y = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2y.apply(this, arguments); }
var SvgSoundMuteFilled48 = function SvgSoundMuteFilled48(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$2y({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none"
  }, props), _path$2x || (_path$2x = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "m14 16 10.698-9.17C25.996 5.718 28 6.64 28 8.348v31.304c0 1.708-2.004 2.63-3.302 1.518L14 32H9a5 5 0 0 1-5-5v-6a5 5 0 0 1 5-5zM33.132 26.72a1.6 1.6 0 0 0 2.262 2.262l3.328-3.327 3.327 3.327a1.6 1.6 0 1 0 2.263-2.262l-3.328-3.328 3.328-3.327a1.6 1.6 0 0 0-2.263-2.263l-3.327 3.327-3.328-3.327a1.6 1.6 0 1 0-2.262 2.263l3.327 3.327z"
  })));
};
var SoundMuteFilled48 = (/* unused pure expression or super */ null && (SvgSoundMuteFilled48));

var SoundMuteFilledIcon = function SoundMuteFilledIcon(props) {
  var soundMuteFilled = {
    12: SoundMuteFilled12,
    16: SoundMuteFilled16,
    18: SoundMuteFilled18,
    24: SoundMuteFilled24,
    32: SoundMuteFilled32,
    48: SoundMuteFilled48
  };
  return jsx(IconTemplate, _assign({
    icons: soundMuteFilled
  }, props));
};

var _path$2w, _path2$10;
function _extends$2x() { _extends$2x = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2x.apply(this, arguments); }
var SvgSoundOffFilled12 = function SvgSoundOffFilled12(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$2x({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none"
  }, props), _path$2w || (_path$2w = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M1.842.824a.6.6 0 0 1 .849 0l7.825 7.825a.6.6 0 1 1-.848.849L1.842 1.673a.6.6 0 0 1 0-.849M2.485 4H2.25C1.56 4 1 4.56 1 5.25v1.5C1 7.44 1.56 8 2.25 8H3.5l2.675 2.293A.5.5 0 0 0 7 9.913V8.515z"
  })), _path2$10 || (_path2$10 = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M7 6.818v-4.73a.5.5 0 0 0-.825-.38L3.867 3.684z"
  })));
};
var SoundOffFilled12 = (/* unused pure expression or super */ null && (SvgSoundOffFilled12));

var _path$2v, _path2$$;
function _extends$2w() { _extends$2w = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2w.apply(this, arguments); }
var SvgSoundOffFilled16 = function SvgSoundOffFilled16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$2w({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path$2v || (_path$2v = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M2.456 1.1a.8.8 0 0 1 1.132 0L14.02 11.532a.8.8 0 0 1-1.131 1.131L2.456 2.23a.8.8 0 0 1 0-1.13M3.313 5.333H3c-.92 0-1.667.747-1.667 1.667v2c0 .92.746 1.667 1.667 1.667h1.667l3.566 3.056a.667.667 0 0 0 1.1-.506v-1.863z"
  })), _path2$$ || (_path2$$ = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M9.333 9.09V2.784a.667.667 0 0 0-1.1-.506L5.156 4.914z"
  })));
};
var SoundOffFilled16 = (/* unused pure expression or super */ null && (SvgSoundOffFilled16));

var _path$2u, _path2$_;
function _extends$2v() { _extends$2v = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2v.apply(this, arguments); }
var SvgSoundOffFilled18 = function SvgSoundOffFilled18(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$2v({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _path$2u || (_path$2u = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M2.764 1.236a.9.9 0 0 1 1.272 0l11.738 11.738a.9.9 0 1 1-1.273 1.273L2.764 2.509a.9.9 0 0 1 0-1.273M3.727 6h-.352C2.339 6 1.5 6.84 1.5 7.875v2.25C1.5 11.161 2.34 12 3.375 12H5.25l4.012 3.439a.75.75 0 0 0 1.238-.57v-2.096z"
  })), _path2$_ || (_path2$_ = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M10.5 10.227V3.131a.75.75 0 0 0-1.238-.57L5.8 5.528z"
  })));
};
var SoundOffFilled18 = (/* unused pure expression or super */ null && (SvgSoundOffFilled18));

var _path$2t, _path2$Z;
function _extends$2u() { _extends$2u = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2u.apply(this, arguments); }
var SvgSoundOffFilled24 = function SvgSoundOffFilled24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$2u({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path$2t || (_path$2t = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M3.685 1.648a1.2 1.2 0 0 1 1.697 0l15.65 15.65a1.2 1.2 0 1 1-1.697 1.698L3.685 3.346a1.2 1.2 0 0 1 0-1.698M4.97 8H4.5A2.5 2.5 0 0 0 2 10.5v3A2.5 2.5 0 0 0 4.5 16H7l5.35 4.585a1 1 0 0 0 1.65-.76V17.03z"
  })), _path2$Z || (_path2$Z = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M14 13.636V4.174a1 1 0 0 0-1.65-.76L7.733 7.37z"
  })));
};
var SoundOffFilled24 = (/* unused pure expression or super */ null && (SvgSoundOffFilled24));

var _path$2s, _path2$Y;
function _extends$2t() { _extends$2t = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2t.apply(this, arguments); }
var SvgSoundOffFilled32 = function SvgSoundOffFilled32(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$2t({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _path$2s || (_path$2s = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M4.913 2.198a1.6 1.6 0 0 1 2.263 0l20.867 20.867a1.6 1.6 0 1 1-2.263 2.263L4.913 4.46a1.6 1.6 0 0 1 0-2.263M6.626 10.667H6A3.333 3.333 0 0 0 2.667 14v4A3.333 3.333 0 0 0 6 21.333h3.333l7.133 6.114c.865.741 2.2.126 2.2-1.013v-3.727z"
  })), _path2$Y || (_path2$Y = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M18.667 18.182V5.566c0-1.14-1.336-1.754-2.201-1.013l-6.154 5.274z"
  })));
};
var SoundOffFilled32 = (/* unused pure expression or super */ null && (SvgSoundOffFilled32));

var _path$2r, _path2$X;
function _extends$2s() { _extends$2s = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2s.apply(this, arguments); }
var SvgSoundOffFilled48 = function SvgSoundOffFilled48(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$2s({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none"
  }, props), _path$2r || (_path$2r = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M7.37 3.297a2.4 2.4 0 0 1 3.394 0l31.3 31.3a2.4 2.4 0 1 1-3.394 3.395l-31.3-31.3a2.4 2.4 0 0 1 0-3.395M9.94 16H9a5 5 0 0 0-5 5v6a5 5 0 0 0 5 5h5l10.698 9.17c1.298 1.112 3.302.19 3.302-1.519v-5.59z"
  })), _path2$X || (_path2$X = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M28 27.273V8.348c0-1.708-2.004-2.63-3.302-1.518l-9.23 7.911z"
  })));
};
var SoundOffFilled48 = (/* unused pure expression or super */ null && (SvgSoundOffFilled48));

var SoundOffFilledIcon = function SoundOffFilledIcon(props) {
  var soundOffFilled = {
    12: SoundOffFilled12,
    16: SoundOffFilled16,
    18: SoundOffFilled18,
    24: SoundOffFilled24,
    32: SoundOffFilled32,
    48: SoundOffFilled48
  };
  return jsx(IconTemplate, _assign({
    icons: soundOffFilled
  }, props));
};

var _path$2q, _path2$W;
function _extends$2r() { _extends$2r = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2r.apply(this, arguments); }
var SvgSoundOnFilled12 = function SvgSoundOnFilled12(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$2r({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none"
  }, props), _path$2q || (_path$2q = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "m3.5 4 2.675-2.293a.5.5 0 0 1 .825.38v7.826a.5.5 0 0 1-.825.38L3.5 8H2.25C1.56 8 1 7.44 1 6.75v-1.5C1 4.56 1.56 4 2.25 4z"
  })), _path2$W || (_path2$W = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M9.432 3.182a.45.45 0 0 1 .636 0 3.983 3.983 0 0 1 0 5.636.45.45 0 0 1-.636-.636 3.083 3.083 0 0 0 0-4.364.45.45 0 0 1 0-.636m-1.25 1.34a.45.45 0 0 1 .636 0 2.09 2.09 0 0 1 0 2.956.45.45 0 0 1-.636-.637 1.19 1.19 0 0 0 0-1.682.45.45 0 0 1 0-.637",
    clipRule: "evenodd"
  })));
};
var SoundOnFilled12 = (/* unused pure expression or super */ null && (SvgSoundOnFilled12));

var _path$2p, _path2$V;
function _extends$2q() { _extends$2q = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2q.apply(this, arguments); }
var SvgSoundOnFilled16 = function SvgSoundOnFilled16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$2q({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path$2p || (_path$2p = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "m4.667 5.333 3.566-3.056a.667.667 0 0 1 1.1.506v10.434c0 .57-.668.877-1.1.506l-3.566-3.056H3c-.92 0-1.667-.747-1.667-1.667V7c0-.92.746-1.667 1.667-1.667z"
  })), _path2$V || (_path2$V = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M12.576 4.242a.6.6 0 0 1 .848 0 5.31 5.31 0 0 1 0 7.516.6.6 0 1 1-.848-.85 4.11 4.11 0 0 0 0-5.817.6.6 0 0 1 0-.849M10.909 6.03a.6.6 0 0 1 .848 0 2.787 2.787 0 0 1 0 3.941.6.6 0 1 1-.848-.848c.62-.62.62-1.625 0-2.244a.6.6 0 0 1 0-.849",
    clipRule: "evenodd"
  })));
};
var SoundOnFilled16 = (/* unused pure expression or super */ null && (SvgSoundOnFilled16));

var _path$2o, _path2$U;
function _extends$2p() { _extends$2p = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2p.apply(this, arguments); }
var SvgSoundOnFilled18 = function SvgSoundOnFilled18(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$2p({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _path$2o || (_path$2o = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M5.25 6 9.262 2.56a.75.75 0 0 1 1.238.57v11.738a.75.75 0 0 1-1.238.57L5.25 12H3.375A1.875 1.875 0 0 1 1.5 10.125v-2.25C1.5 6.839 2.34 6 3.375 6z"
  })), _path2$U || (_path2$U = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M14.148 4.773a.675.675 0 0 1 .954 0 5.974 5.974 0 0 1 0 8.454.675.675 0 0 1-.954-.954 4.624 4.624 0 0 0 0-6.546.675.675 0 0 1 0-.954m-1.875 2.01a.675.675 0 0 1 .954 0 3.136 3.136 0 0 1 0 4.434.675.675 0 0 1-.954-.955 1.786 1.786 0 0 0 0-2.524.675.675 0 0 1 0-.955",
    clipRule: "evenodd"
  })));
};
var SoundOnFilled18 = (/* unused pure expression or super */ null && (SvgSoundOnFilled18));

var _path$2n, _path2$T;
function _extends$2o() { _extends$2o = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2o.apply(this, arguments); }
var SvgSoundOnFilled24 = function SvgSoundOnFilled24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$2o({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path$2n || (_path$2n = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "m7 8 5.35-4.585a1 1 0 0 1 1.65.76v15.65a1 1 0 0 1-1.65.76L7 16H4.5A2.5 2.5 0 0 1 2 13.5v-3A2.5 2.5 0 0 1 4.5 8z"
  })), _path2$T || (_path2$T = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M18.864 6.364a.9.9 0 0 1 1.272 0 7.966 7.966 0 0 1 0 11.272.9.9 0 1 1-1.272-1.273 6.166 6.166 0 0 0 0-8.727.9.9 0 0 1 0-1.272m-2.5 2.68a.9.9 0 0 1 1.272 0 4.18 4.18 0 0 1 0 5.911.9.9 0 0 1-1.272-1.272 2.38 2.38 0 0 0 0-3.366.9.9 0 0 1 0-1.273",
    clipRule: "evenodd"
  })));
};
var SoundOnFilled24 = (/* unused pure expression or super */ null && (SvgSoundOnFilled24));

var _path$2m, _path2$S;
function _extends$2n() { _extends$2n = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2n.apply(this, arguments); }
var SvgSoundOnFilled32 = function SvgSoundOnFilled32(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$2n({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _path$2m || (_path$2m = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "m9.333 10.667 7.133-6.114c.865-.741 2.2-.127 2.2 1.013v20.868c0 1.14-1.335 1.754-2.2 1.013l-7.133-6.114H6A3.333 3.333 0 0 1 2.667 18v-4A3.333 3.333 0 0 1 6 10.667z"
  })), _path2$S || (_path2$S = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M25.152 8.485a1.2 1.2 0 0 1 1.697 0 10.62 10.62 0 0 1 0 15.03 1.2 1.2 0 1 1-1.697-1.697 8.22 8.22 0 0 0 0-11.636 1.2 1.2 0 0 1 0-1.697m-3.334 3.574a1.2 1.2 0 0 1 1.697 0 5.574 5.574 0 0 1 0 7.881 1.2 1.2 0 1 1-1.697-1.697 3.174 3.174 0 0 0 0-4.487 1.2 1.2 0 0 1 0-1.697",
    clipRule: "evenodd"
  })));
};
var SoundOnFilled32 = (/* unused pure expression or super */ null && (SvgSoundOnFilled32));

var _path$2l, _path2$R;
function _extends$2m() { _extends$2m = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2m.apply(this, arguments); }
var SvgSoundOnFilled48 = function SvgSoundOnFilled48(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$2m({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none"
  }, props), _path$2l || (_path$2l = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "m14 16 10.698-9.17C25.996 5.718 28 6.64 28 8.348v31.303c0 1.71-2.004 2.63-3.302 1.519L14 32H9a5 5 0 0 1-5-5v-6a5 5 0 0 1 5-5z"
  })), _path2$R || (_path2$R = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M37.727 12.727a1.8 1.8 0 0 1 2.546 0c6.231 6.232 6.231 16.314 0 22.546a1.8 1.8 0 0 1-2.546-2.546 12.33 12.33 0 0 0 0-17.454 1.8 1.8 0 0 1 0-2.546m-5 5.362a1.8 1.8 0 0 1 2.546 0 8.36 8.36 0 0 1 0 11.822 1.8 1.8 0 0 1-2.546-2.546 4.76 4.76 0 0 0 0-6.73 1.8 1.8 0 0 1 0-2.546",
    clipRule: "evenodd"
  })));
};
var SoundOnFilled48 = (/* unused pure expression or super */ null && (SvgSoundOnFilled48));

var SoundOnFilledIcon = function SoundOnFilledIcon(props) {
  var soundOnFilled = {
    12: SoundOnFilled12,
    16: SoundOnFilled16,
    18: SoundOnFilled18,
    24: SoundOnFilled24,
    32: SoundOnFilled32,
    48: SoundOnFilled48
  };
  return jsx(IconTemplate, _assign({
    icons: soundOnFilled
  }, props));
};

var _path$2k, _path2$Q;
function _extends$2l() { _extends$2l = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2l.apply(this, arguments); }
var SvgSquareAndPencil12 = function SvgSquareAndPencil12(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$2l({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none"
  }, props), _path$2k || (_path$2k = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M3.4 2.55a.85.85 0 0 0-.85.85v5.2c0 .47.38.85.85.85h5.2c.47 0 .85-.38.85-.85V6a.6.6 0 0 1 1.2 0v2.6a2.05 2.05 0 0 1-2.05 2.05H3.4A2.05 2.05 0 0 1 1.35 8.6V3.4A2.05 2.05 0 0 1 3.4 1.35H6a.6.6 0 0 1 0 1.2z",
    clipRule: "evenodd"
  })), _path2$Q || (_path2$Q = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M4.42 5.637a.6.6 0 0 1 .176-.425l4.143-4.144a1.55 1.55 0 1 1 2.192 2.192L6.789 7.404a.6.6 0 0 1-.425.176L5.02 7.578a.6.6 0 0 1-.6-.6zm1.2.247.001.495h.494l2.872-2.871-.495-.495zm3.72-3.72.496.495.247-.247a.35.35 0 1 0-.495-.495z",
    clipRule: "evenodd"
  })));
};
var SquareAndPencil12 = (/* unused pure expression or super */ null && (SvgSquareAndPencil12));

var _path$2j, _path2$P;
function _extends$2k() { _extends$2k = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2k.apply(this, arguments); }
var SvgSquareAndPencil16 = function SvgSquareAndPencil16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$2k({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path$2j || (_path$2j = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M4.533 3.35c-.653 0-1.183.53-1.183 1.183v6.933c0 .654.53 1.184 1.183 1.184h6.934c.653 0 1.183-.53 1.183-1.184V8a.75.75 0 0 1 1.5 0v3.466a2.683 2.683 0 0 1-2.683 2.684H4.533a2.683 2.683 0 0 1-2.683-2.684V4.533A2.683 2.683 0 0 1 4.533 1.85H8a.75.75 0 0 1 0 1.5z",
    clipRule: "evenodd"
  })), _path2$P || (_path2$P = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M5.943 7.516c0-.2.08-.39.22-.531l5.525-5.525a2.017 2.017 0 1 1 2.852 2.852L9.015 9.837a.75.75 0 0 1-.531.22l-1.79-.003a.75.75 0 0 1-.748-.749zm1.5.31.002.729h.73L12.12 4.61l-.73-.73zm5.007-5.007.73.73.3-.298a.517.517 0 1 0-.732-.73z",
    clipRule: "evenodd"
  })));
};
var SquareAndPencil16 = (/* unused pure expression or super */ null && (SvgSquareAndPencil16));

var _path$2i, _path2$O;
function _extends$2j() { _extends$2j = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2j.apply(this, arguments); }
var SvgSquareAndPencil18 = function SvgSquareAndPencil18(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$2j({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _path$2i || (_path$2i = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M5.1 3.725c-.76 0-1.375.615-1.375 1.375v7.8c0 .759.616 1.375 1.375 1.375h7.8c.76 0 1.375-.616 1.375-1.375V9a.8.8 0 0 1 1.6 0v3.9a2.975 2.975 0 0 1-2.975 2.975H5.1A2.975 2.975 0 0 1 2.125 12.9V5.1A2.975 2.975 0 0 1 5.1 2.125H9a.8.8 0 0 1 0 1.6z",
    clipRule: "evenodd"
  })), _path2$O || (_path2$O = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M6.73 8.455a.8.8 0 0 1 .234-.566l6.216-6.216a2.225 2.225 0 1 1 3.146 3.147l-6.215 6.215a.8.8 0 0 1-.567.235l-2.012-.003a.8.8 0 0 1-.8-.799zm1.6.33.002.883.882.001 4.558-4.558-.884-.883zm5.69-5.689.884.884.291-.292a.625.625 0 1 0-.884-.883z",
    clipRule: "evenodd"
  })));
};
var SquareAndPencil18 = (/* unused pure expression or super */ null && (SvgSquareAndPencil18));

var _path$2h, _path2$N;
function _extends$2i() { _extends$2i = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2i.apply(this, arguments); }
var SvgSquareAndPencil24 = function SvgSquareAndPencil24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$2i({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path$2h || (_path$2h = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M6.8 4.8a2 2 0 0 0-2 2v10.4a2 2 0 0 0 2 2h10.4a2 2 0 0 0 2-2V12a.9.9 0 0 1 1.8 0v5.2a3.8 3.8 0 0 1-3.8 3.8H6.8A3.8 3.8 0 0 1 3 17.2V6.8A3.8 3.8 0 0 1 6.8 3H12a.9.9 0 1 1 0 1.8z",
    clipRule: "evenodd"
  })), _path2$N || (_path2$N = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M9.14 11.274a.9.9 0 0 1 .264-.637l8.287-8.288a2.8 2.8 0 1 1 3.96 3.96l-8.287 8.287a.9.9 0 0 1-.638.264l-2.684-.003a.9.9 0 0 1-.899-.9zm1.8.371.002 1.413 1.413.002 6.343-6.344-1.414-1.414zm7.617-7.616 1.414 1.414.407-.407a1 1 0 0 0-1.414-1.414z",
    clipRule: "evenodd"
  })));
};
var SquareAndPencil24 = (/* unused pure expression or super */ null && (SvgSquareAndPencil24));

var _path$2g, _path2$M;
function _extends$2h() { _extends$2h = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2h.apply(this, arguments); }
var SvgSquareAndPencil32 = function SvgSquareAndPencil32(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$2h({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _path$2g || (_path$2g = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M9.067 6.2A2.867 2.867 0 0 0 6.2 9.067v13.867A2.867 2.867 0 0 0 9.067 25.8h13.866a2.867 2.867 0 0 0 2.867-2.866V16a1 1 0 0 1 2 0v6.934a4.867 4.867 0 0 1-4.867 4.866H9.067A4.867 4.867 0 0 1 4.2 22.934V9.067A4.867 4.867 0 0 1 9.067 4.2H16a1 1 0 0 1 0 2z",
    clipRule: "evenodd"
  })), _path2$M || (_path2$M = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M12.387 15.032a1 1 0 0 1 .293-.708l11.05-11.05a3.533 3.533 0 0 1 4.996 4.997l-11.05 11.05a1 1 0 0 1-.708.292l-3.578-.004a1 1 0 0 1-.999-.999zm2 .412.003 2.166 2.166.003 8.658-8.658-2.168-2.169zM24.46 5.373l2.168 2.168.684-.683a1.533 1.533 0 0 0-2.169-2.169z",
    clipRule: "evenodd"
  })));
};
var SquareAndPencil32 = (/* unused pure expression or super */ null && (SvgSquareAndPencil32));

var _path$2f, _path2$L;
function _extends$2g() { _extends$2g = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2g.apply(this, arguments); }
var SvgSquareAndPencil48 = function SvgSquareAndPencil48(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$2g({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none"
  }, props), _path$2f || (_path$2f = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M13.6 9A4.6 4.6 0 0 0 9 13.6v20.8a4.6 4.6 0 0 0 4.6 4.6h20.8a4.6 4.6 0 0 0 4.6-4.6V24a1.2 1.2 0 0 1 2.4 0v10.4a7 7 0 0 1-7 7H13.6a7 7 0 0 1-7-7V13.6a7 7 0 0 1 7-7H24A1.2 1.2 0 0 1 24 9z",
    clipRule: "evenodd"
  })), _path2$L || (_path2$L = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M18.88 22.547a1.2 1.2 0 0 1 .352-.85L35.806 5.123a5 5 0 0 1 7.071 7.07L26.303 28.769a1.2 1.2 0 0 1-.85.352l-5.368-.007a1.2 1.2 0 0 1-1.198-1.199zm2.4.495.005 3.672 3.673.005 13.288-13.288-3.677-3.677zM36.267 8.057l3.677 3.677 1.237-1.237a2.6 2.6 0 1 0-3.677-3.677z",
    clipRule: "evenodd"
  })));
};
var SquareAndPencil48 = (/* unused pure expression or super */ null && (SvgSquareAndPencil48));

var SquareAndPencilIcon = function SquareAndPencilIcon(props) {
  var squareAndPencil = {
    12: SquareAndPencil12,
    16: SquareAndPencil16,
    18: SquareAndPencil18,
    24: SquareAndPencil24,
    32: SquareAndPencil32,
    48: SquareAndPencil48
  };
  return jsx(IconTemplate, _assign({
    icons: squareAndPencil
  }, props));
};

var _path$2e, _path2$K;
function _extends$2f() { _extends$2f = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2f.apply(this, arguments); }
var SvgStackedImages12 = function SvgStackedImages12(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$2f({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none"
  }, props), _path$2e || (_path$2e = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M7.6 2.4H3a.3.3 0 0 0-.3.3v4.6a.3.3 0 0 0 .3.3h4.6a.3.3 0 0 0 .3-.3V2.7a.3.3 0 0 0-.3-.3M3 1.2a1.5 1.5 0 0 0-1.5 1.5v4.6A1.5 1.5 0 0 0 3 8.8h4.6a1.5 1.5 0 0 0 1.5-1.5V2.7a1.5 1.5 0 0 0-1.5-1.5z",
    clipRule: "evenodd"
  })), _path2$K || (_path2$K = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M10.5 2.6a.6.6 0 0 1 .6.6v4.45a3.15 3.15 0 0 1-3.15 3.15H3.5a.6.6 0 0 1 0-1.2h4.45A1.95 1.95 0 0 0 9.9 7.65V3.2a.6.6 0 0 1 .6-.6",
    clipRule: "evenodd"
  })));
};
var StackedImages12 = (/* unused pure expression or super */ null && (SvgStackedImages12));

var _path$2d, _path2$J;
function _extends$2e() { _extends$2e = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2e.apply(this, arguments); }
var SvgStackedImages16 = function SvgStackedImages16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$2e({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path$2d || (_path$2d = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M10.5 3.125H4a.5.5 0 0 0-.5.5v6.5a.5.5 0 0 0 .5.5h6.5a.5.5 0 0 0 .5-.5v-6.5a.5.5 0 0 0-.5-.5M4 1.625a2 2 0 0 0-2 2v6.5a2 2 0 0 0 2 2h6.5a2 2 0 0 0 2-2v-6.5a2 2 0 0 0-2-2z",
    clipRule: "evenodd"
  })), _path2$J || (_path2$J = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M14 3.875a.75.75 0 0 1 .75.75v6a3.75 3.75 0 0 1-3.75 3.75H5a.75.75 0 0 1 0-1.5h6a2.25 2.25 0 0 0 2.25-2.25v-6a.75.75 0 0 1 .75-.75",
    clipRule: "evenodd"
  })));
};
var StackedImages16 = (/* unused pure expression or super */ null && (SvgStackedImages16));

var _path$2c, _path2$I;
function _extends$2d() { _extends$2d = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2d.apply(this, arguments); }
var SvgStackedImages18 = function SvgStackedImages18(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$2d({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _path$2c || (_path$2c = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M11.55 3.45h-6.8a.9.9 0 0 0-.9.9v6.8a.9.9 0 0 0 .9.9h6.8a.9.9 0 0 0 .9-.9v-6.8a.9.9 0 0 0-.9-.9m-6.8-1.6a2.5 2.5 0 0 0-2.5 2.5v6.8a2.5 2.5 0 0 0 2.5 2.5h6.8a2.5 2.5 0 0 0 2.5-2.5v-6.8a2.5 2.5 0 0 0-2.5-2.5z",
    clipRule: "evenodd"
  })), _path2$I || (_path2$I = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M15.75 4.05a.8.8 0 0 1 .8.8v7a4.3 4.3 0 0 1-4.3 4.3h-7a.8.8 0 0 1 0-1.6h7a2.7 2.7 0 0 0 2.7-2.7v-7a.8.8 0 0 1 .8-.8",
    clipRule: "evenodd"
  })));
};
var StackedImages18 = (/* unused pure expression or super */ null && (SvgStackedImages18));

var _path$2b, _path2$H;
function _extends$2c() { _extends$2c = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2c.apply(this, arguments); }
var SvgStackedImages24 = function SvgStackedImages24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$2c({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path$2b || (_path$2b = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M16 4.35H6a1.2 1.2 0 0 0-1.2 1.2v10a1.2 1.2 0 0 0 1.2 1.2h10a1.2 1.2 0 0 0 1.2-1.2v-10a1.2 1.2 0 0 0-1.2-1.2M6 2.55a3 3 0 0 0-3 3v10a3 3 0 0 0 3 3h10a3 3 0 0 0 3-3v-10a3 3 0 0 0-3-3z",
    clipRule: "evenodd"
  })), _path2$H || (_path2$H = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M21 5.65a.9.9 0 0 1 .9.9v9.5a5.4 5.4 0 0 1-5.4 5.4H7a.9.9 0 1 1 0-1.8h9.5a3.6 3.6 0 0 0 3.6-3.6v-9.5a.9.9 0 0 1 .9-.9",
    clipRule: "evenodd"
  })));
};
var StackedImages24 = (/* unused pure expression or super */ null && (SvgStackedImages24));

var _path$2a, _path2$G;
function _extends$2b() { _extends$2b = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2b.apply(this, arguments); }
var SvgStackedImages32 = function SvgStackedImages32(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$2b({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _path$2a || (_path$2a = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M21.5 5.5H8a2 2 0 0 0-2 2V21a2 2 0 0 0 2 2h13.5a2 2 0 0 0 2-2V7.5a2 2 0 0 0-2-2M8 3.5a4 4 0 0 0-4 4V21a4 4 0 0 0 4 4h13.5a4 4 0 0 0 4-4V7.5a4 4 0 0 0-4-4z",
    clipRule: "evenodd"
  })), _path2$G || (_path2$G = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M28 8.5a1 1 0 0 1 1 1v12a7 7 0 0 1-7 7H10a1 1 0 1 1 0-2h12a5 5 0 0 0 5-5v-12a1 1 0 0 1 1-1",
    clipRule: "evenodd"
  })));
};
var StackedImages32 = (/* unused pure expression or super */ null && (SvgStackedImages32));

var _path$29, _path2$F;
function _extends$2a() { _extends$2a = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2a.apply(this, arguments); }
var SvgStackedImages48 = function SvgStackedImages48(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$2a({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none"
  }, props), _path$29 || (_path$29 = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M32 8.3H12a3.6 3.6 0 0 0-3.6 3.6v20a3.6 3.6 0 0 0 3.6 3.6h20a3.6 3.6 0 0 0 3.6-3.6v-20A3.6 3.6 0 0 0 32 8.3M12 5.9a6 6 0 0 0-6 6v20a6 6 0 0 0 6 6h20a6 6 0 0 0 6-6v-20a6 6 0 0 0-6-6z",
    clipRule: "evenodd"
  })), _path2$F || (_path2$F = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M41 11.7a1.2 1.2 0 0 1 1.2 1.2v20a9.2 9.2 0 0 1-9.2 9.2H13a1.2 1.2 0 1 1 0-2.4h20a6.8 6.8 0 0 0 6.8-6.8v-20a1.2 1.2 0 0 1 1.2-1.2",
    clipRule: "evenodd"
  })));
};
var StackedImages48 = (/* unused pure expression or super */ null && (SvgStackedImages48));

var StackedImagesIcon = function StackedImagesIcon(props) {
  var stackedImages = {
    12: StackedImages12,
    16: StackedImages16,
    18: StackedImages18,
    24: StackedImages24,
    32: StackedImages32,
    48: StackedImages48
  };
  return jsx(IconTemplate, _assign({
    icons: stackedImages
  }, props));
};

var _path$28, _path2$E;
function _extends$29() { _extends$29 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$29.apply(this, arguments); }
var SvgStackedImagesFilled12 = function SvgStackedImagesFilled12(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$29({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none"
  }, props), _path$28 || (_path$28 = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M1.5 2.7A1.5 1.5 0 0 1 3 1.2h4.6a1.5 1.5 0 0 1 1.5 1.5v4.6a1.5 1.5 0 0 1-1.5 1.5H3a1.5 1.5 0 0 1-1.5-1.5z"
  })), _path2$E || (_path2$E = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M10.5 2.6a.6.6 0 0 1 .6.6v4.5A3.1 3.1 0 0 1 8 10.8H3.5a.6.6 0 0 1 0-1.2H8a1.9 1.9 0 0 0 1.9-1.9V3.2a.6.6 0 0 1 .6-.6",
    clipRule: "evenodd"
  })));
};
var StackedImagesFilled12 = (/* unused pure expression or super */ null && (SvgStackedImagesFilled12));

var _path$27, _path2$D;
function _extends$28() { _extends$28 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$28.apply(this, arguments); }
var SvgStackedImagesFilled16 = function SvgStackedImagesFilled16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$28({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path$27 || (_path$27 = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M2 3.625a2 2 0 0 1 2-2h6.5a2 2 0 0 1 2 2v6.5a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2z"
  })), _path2$D || (_path2$D = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M14 3.875a.75.75 0 0 1 .75.75v6a3.75 3.75 0 0 1-3.75 3.75H5a.75.75 0 0 1 0-1.5h6a2.25 2.25 0 0 0 2.25-2.25v-6a.75.75 0 0 1 .75-.75",
    clipRule: "evenodd"
  })));
};
var StackedImagesFilled16 = (/* unused pure expression or super */ null && (SvgStackedImagesFilled16));

var _path$26, _path2$C;
function _extends$27() { _extends$27 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$27.apply(this, arguments); }
var SvgStackedImagesFilled18 = function SvgStackedImagesFilled18(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$27({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _path$26 || (_path$26 = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M2.25 4.35a2.5 2.5 0 0 1 2.5-2.5h6.8a2.5 2.5 0 0 1 2.5 2.5v6.8a2.5 2.5 0 0 1-2.5 2.5h-6.8a2.5 2.5 0 0 1-2.5-2.5z"
  })), _path2$C || (_path2$C = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M15.75 4.05a.8.8 0 0 1 .8.8v7a4.3 4.3 0 0 1-4.3 4.3h-7a.8.8 0 0 1 0-1.6h7a2.7 2.7 0 0 0 2.7-2.7v-7a.8.8 0 0 1 .8-.8",
    clipRule: "evenodd"
  })));
};
var StackedImagesFilled18 = (/* unused pure expression or super */ null && (SvgStackedImagesFilled18));

var _path$25, _path2$B;
function _extends$26() { _extends$26 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$26.apply(this, arguments); }
var SvgStackedImagesFilled24 = function SvgStackedImagesFilled24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$26({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path$25 || (_path$25 = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M3 5.55a3 3 0 0 1 3-3h10a3 3 0 0 1 3 3v10a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3z"
  })), _path2$B || (_path2$B = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M21 5.65a.9.9 0 0 1 .9.9v9.5a5.4 5.4 0 0 1-5.4 5.4H7a.9.9 0 1 1 0-1.8h9.5a3.6 3.6 0 0 0 3.6-3.6v-9.5a.9.9 0 0 1 .9-.9",
    clipRule: "evenodd"
  })));
};
var StackedImagesFilled24 = (/* unused pure expression or super */ null && (SvgStackedImagesFilled24));

var _path$24, _path2$A;
function _extends$25() { _extends$25 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$25.apply(this, arguments); }
var SvgStackedImagesFilled32 = function SvgStackedImagesFilled32(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$25({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _path$24 || (_path$24 = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M4 7.5a4 4 0 0 1 4-4h13.5a4 4 0 0 1 4 4V21a4 4 0 0 1-4 4H8a4 4 0 0 1-4-4z"
  })), _path2$A || (_path2$A = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M28 8.5a1 1 0 0 1 1 1v12a7 7 0 0 1-7 7H10a1 1 0 1 1 0-2h12a5 5 0 0 0 5-5v-12a1 1 0 0 1 1-1",
    clipRule: "evenodd"
  })));
};
var StackedImagesFilled32 = (/* unused pure expression or super */ null && (SvgStackedImagesFilled32));

var _path$23, _path2$z;
function _extends$24() { _extends$24 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$24.apply(this, arguments); }
var SvgStackedImagesFilled48 = function SvgStackedImagesFilled48(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$24({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none"
  }, props), _path$23 || (_path$23 = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M6 11.9a6 6 0 0 1 6-6h20a6 6 0 0 1 6 6v20a6 6 0 0 1-6 6H12a6 6 0 0 1-6-6z"
  })), _path2$z || (_path2$z = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M41 11.7a1.2 1.2 0 0 1 1.2 1.2v20a9.2 9.2 0 0 1-9.2 9.2H13a1.2 1.2 0 0 1 0-2.4h20a6.8 6.8 0 0 0 6.8-6.8v-20a1.2 1.2 0 0 1 1.2-1.2",
    clipRule: "evenodd"
  })));
};
var StackedImagesFilled48 = (/* unused pure expression or super */ null && (SvgStackedImagesFilled48));

var StackedImagesFilledIcon = function StackedImagesFilledIcon(props) {
  var stackedImagesFilled = {
    12: StackedImagesFilled12,
    16: StackedImagesFilled16,
    18: StackedImagesFilled18,
    24: StackedImagesFilled24,
    32: StackedImagesFilled32,
    48: StackedImagesFilled48
  };
  return jsx(IconTemplate, _assign({
    icons: stackedImagesFilled
  }, props));
};

var _path$22;
function _extends$23() { _extends$23 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$23.apply(this, arguments); }
var SvgStar12 = function SvgStar12(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$23({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none"
  }, props), _path$22 || (_path$22 = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M4.987 1.852c.38-.895 1.647-.895 2.026 0l.855 2.016 2.127.236c.931.104 1.315 1.248.636 1.892L9.004 7.538l.449 2.226c.19.94-.83 1.655-1.649 1.158L6 9.828l-1.804 1.094c-.82.497-1.838-.219-1.649-1.158l.45-2.226-1.628-1.542c-.68-.644-.295-1.788.636-1.892l2.127-.236zM6 2.537l-.786 1.854a1.1 1.1 0 0 1-.891.664l-1.972.218 1.51 1.432a1.1 1.1 0 0 1 .322 1.016L3.77 9.778l1.66-1.008a1.1 1.1 0 0 1 1.141 0l1.662 1.008-.415-2.057a1.1 1.1 0 0 1 .321-1.016l1.51-1.432-1.97-.218a1.1 1.1 0 0 1-.892-.664z",
    clipRule: "evenodd"
  })));
};
var Star12 = (/* unused pure expression or super */ null && (SvgStar12));

var _path$21;
function _extends$22() { _extends$22 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$22.apply(this, arguments); }
var SvgStar16 = function SvgStar16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$22({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path$21 || (_path$21 = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M6.617 2.334c.546-1.225 2.285-1.225 2.832 0l1.153 2.587a.05.05 0 0 0 .04.03l2.818.297c1.334.14 1.871 1.795.875 2.693L12.23 9.837a.05.05 0 0 0-.015.048l.588 2.771c.278 1.313-1.129 2.335-2.291 1.665l-2.454-1.416a.05.05 0 0 0-.05 0l-2.454 1.416c-1.162.67-2.57-.352-2.29-1.665l.587-2.771a.05.05 0 0 0-.015-.048L1.73 7.941c-.996-.898-.459-2.552.875-2.693l2.817-.297a.05.05 0 0 0 .04-.03zm1.38.593-.01.018-1.153 2.587a1.55 1.55 0 0 1-1.253.91l-2.817.298-.02.004-.007.004a.1.1 0 0 0-.016.026.1.1 0 0 0-.002.03q0 .004.003.007l.013.016L4.84 8.723c.41.37.593.932.478 1.473l-.587 2.771-.002.021.001.007a.1.1 0 0 0 .02.023.1.1 0 0 0 .028.012h.007l.02-.009 2.454-1.415a1.55 1.55 0 0 1 1.548 0l2.454 1.415.02.008.007.001a.1.1 0 0 0 .028-.012.1.1 0 0 0 .02-.023l.001-.007-.002-.02-.588-2.772a1.55 1.55 0 0 1 .48-1.473l2.104-1.896.013-.016.003-.007a.1.1 0 0 0-.002-.03.1.1 0 0 0-.016-.026l-.006-.004-.02-.004-2.818-.298a1.55 1.55 0 0 1-1.253-.91L8.079 2.945l-.011-.018-.006-.005a.1.1 0 0 0-.03-.007.1.1 0 0 0-.028.007z",
    clipRule: "evenodd"
  })));
};
var Star16 = (/* unused pure expression or super */ null && (SvgStar16));

var _path$20;
function _extends$21() { _extends$21 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$21.apply(this, arguments); }
var SvgStar18 = function SvgStar18(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$21({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _path$20 || (_path$20 = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M7.356 2.723c.634-1.422 2.654-1.422 3.288 0l1.2 2.693a.2.2 0 0 0 .162.117l2.93.31c1.55.163 2.174 2.084 1.017 3.127l-2.19 1.973a.2.2 0 0 0-.061.19l.611 2.883c.323 1.524-1.31 2.711-2.66 1.933L9.1 14.476a.2.2 0 0 0-.2 0L6.347 15.95c-1.35.778-2.984-.409-2.66-1.933l.611-2.883a.2.2 0 0 0-.061-.19L2.047 8.97C.89 7.927 1.514 6.006 3.063 5.842l2.931-.309a.2.2 0 0 0 .162-.117zm1.827.652a.2.2 0 0 0-.366 0l-1.2 2.692a1.8 1.8 0 0 1-1.455 1.057l-2.931.31a.2.2 0 0 0-.113.347l2.19 1.973a1.8 1.8 0 0 1 .555 1.71l-.611 2.884a.2.2 0 0 0 .295.215l2.554-1.473a1.8 1.8 0 0 1 1.798 0l2.554 1.473a.2.2 0 0 0 .295-.215l-.611-2.883a1.8 1.8 0 0 1 .555-1.71l2.19-1.974a.2.2 0 0 0-.113-.347l-2.931-.31a1.8 1.8 0 0 1-1.455-1.057z",
    clipRule: "evenodd"
  })));
};
var Star18 = (/* unused pure expression or super */ null && (SvgStar18));

var _path$1$;
function _extends$20() { _extends$20 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$20.apply(this, arguments); }
var SvgStar24 = function SvgStar24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$20({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path$1$ || (_path$1$ = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M10.265 3.933c.67-1.502 2.801-1.502 3.47 0l1.753 3.931a.1.1 0 0 0 .08.059l4.282.452c1.635.172 2.294 2.2 1.072 3.3l-3.198 2.882a.1.1 0 0 0-.03.095l.893 4.211c.34 1.609-1.384 2.862-2.808 2.04l-3.729-2.15a.1.1 0 0 0-.1 0l-3.729 2.15c-1.424.822-3.149-.431-2.808-2.04l.894-4.21a.1.1 0 0 0-.031-.096l-3.198-2.881c-1.222-1.101-.563-3.129 1.073-3.301l4.28-.452a.1.1 0 0 0 .081-.059zm1.679.687c-.009.005-.022.015-.035.045l-1.753 3.932A1.9 1.9 0 0 1 8.62 9.713l-4.28.452c-.033.003-.047.013-.054.02a.1.1 0 0 0-.031.048.1.1 0 0 0-.004.058c.002.01.008.025.032.048l3.198 2.881a1.9 1.9 0 0 1 .586 1.806l-.893 4.21c-.007.033-.002.049.002.058q.007.021.037.044.031.022.054.022c.01 0 .026 0 .055-.016l3.729-2.15a1.9 1.9 0 0 1 1.898 0l3.73 2.15c.028.017.044.017.054.016a.1.1 0 0 0 .054-.022.1.1 0 0 0 .037-.044c.004-.01.009-.025.002-.057l-.893-4.211a1.9 1.9 0 0 1 .587-1.806l3.197-2.881c.025-.023.03-.038.032-.048a.1.1 0 0 0-.004-.058.1.1 0 0 0-.03-.049c-.008-.006-.022-.016-.054-.02l-4.281-.451a1.9 1.9 0 0 1-1.536-1.116L12.09 4.665c-.013-.03-.026-.04-.034-.045A.1.1 0 0 0 12 4.606a.1.1 0 0 0-.056.014",
    clipRule: "evenodd"
  })));
};
var Star24 = (/* unused pure expression or super */ null && (SvgStar24));

var _path$1_;
function _extends$1$() { _extends$1$ = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1$.apply(this, arguments); }
var SvgStar32 = function SvgStar32(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1$({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _path$1_ || (_path$1_ = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M13.686 5.244c.893-2.003 3.735-2.003 4.628 0l2.337 5.242c.019.043.06.073.107.078l5.708.602c2.18.23 3.059 2.934 1.43 4.402l-4.264 3.842a.13.13 0 0 0-.04.127l1.19 5.614c.455 2.145-1.844 3.816-3.744 2.72l-4.971-2.867a.13.13 0 0 0-.134 0l-4.971 2.867c-1.9 1.096-4.2-.575-3.744-2.72l1.19-5.614a.13.13 0 0 0-.04-.127l-4.264-3.842c-1.629-1.468-.75-4.171 1.43-4.402l5.708-.602a.13.13 0 0 0 .107-.078zm2.239.917c-.011.006-.029.02-.047.06l-2.337 5.242a2.53 2.53 0 0 1-2.048 1.488l-5.707.602c-.044.005-.062.017-.072.026a.15.15 0 0 0-.041.066.14.14 0 0 0-.005.077c.003.013.01.033.042.063l4.264 3.842c.672.605.97 1.523.782 2.408l-1.19 5.614c-.01.043-.003.064.002.076.007.017.023.04.05.06.026.02.053.027.072.029.012 0 .034 0 .072-.022l4.972-2.867a2.53 2.53 0 0 1 2.532 0l4.971 2.867c.038.022.06.022.073.021a.15.15 0 0 0 .072-.028.14.14 0 0 0 .05-.06c.005-.012.012-.033.002-.076l-1.19-5.614a2.53 2.53 0 0 1 .782-2.408l4.263-3.842c.033-.03.04-.05.043-.063a.14.14 0 0 0-.005-.077.15.15 0 0 0-.042-.066c-.01-.009-.027-.021-.07-.026l-5.709-.602a2.53 2.53 0 0 1-2.048-1.488L16.122 6.22c-.018-.04-.036-.054-.047-.06A.15.15 0 0 0 16 6.14c-.033 0-.06.01-.075.02",
    clipRule: "evenodd"
  })));
};
var Star32 = (/* unused pure expression or super */ null && (SvgStar32));

var _path$1Z;
function _extends$1_() { _extends$1_ = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1_.apply(this, arguments); }
var SvgStar48 = function SvgStar48(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1_({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none"
  }, props), _path$1Z || (_path$1Z = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M21.077 5.11c1.128-2.53 4.718-2.53 5.846 0l4.334 9.722a.8.8 0 0 0 .646.47l10.586 1.117c2.755.291 3.864 3.706 1.807 5.56l-7.908 7.126a.8.8 0 0 0-.247.76l2.209 10.413c.575 2.71-2.33 4.82-4.73 3.436l-9.22-5.318a.8.8 0 0 0-.8 0l-9.22 5.318c-2.4 1.384-5.304-.727-4.73-3.436l2.209-10.413a.8.8 0 0 0-.247-.76l-7.908-7.126c-2.057-1.854-.947-5.269 1.807-5.56l10.586-1.117a.8.8 0 0 0 .646-.47zm3.654.977a.8.8 0 0 0-1.462 0l-4.333 9.722a3.2 3.2 0 0 1-2.587 1.88L5.763 18.806a.8.8 0 0 0-.452 1.39l7.908 7.126a3.2 3.2 0 0 1 .988 3.041l-2.209 10.413a.8.8 0 0 0 1.182.86l9.221-5.32a3.2 3.2 0 0 1 3.198 0l9.22 5.32a.8.8 0 0 0 1.183-.86l-2.209-10.413a3.2 3.2 0 0 1 .989-3.04l7.907-7.127a.8.8 0 0 0-.452-1.39l-10.586-1.117a3.2 3.2 0 0 1-2.586-1.88z",
    clipRule: "evenodd"
  })));
};
var Star48 = (/* unused pure expression or super */ null && (SvgStar48));

var StarIcon = function StarIcon(props) {
  var star = {
    12: Star12,
    16: Star16,
    18: Star18,
    24: Star24,
    32: Star32,
    48: Star48
  };
  return jsx(IconTemplate, _assign({
    icons: star
  }, props));
};

var _path$1Y, _path2$y;
function _extends$1Z() { _extends$1Z = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1Z.apply(this, arguments); }
var SvgStarFilled12 = function SvgStarFilled12(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends$1Z({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none"
  }, props), _path$1Y || (_path$1Y = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: "#2F3438",
    d: "M5.54 2.086a.5.5 0 0 1 .92 0l.878 2.07a.5.5 0 0 0 .405.302l2.186.243a.5.5 0 0 1 .289.86L8.551 7.14a.5.5 0 0 0-.146.461l.46 2.28a.5.5 0 0 1-.75.527L6.26 9.283a.5.5 0 0 0-.518 0L3.885 10.41a.5.5 0 0 1-.75-.526l.46-2.28a.5.5 0 0 0-.146-.463L1.782 5.56a.5.5 0 0 1 .289-.86l2.186-.242a.5.5 0 0 0 .405-.301z"
  })), _path2$y || (_path2$y = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M4.987 1.852c.38-.894 1.647-.894 2.026 0l.855 2.016 2.127.237c.931.103 1.315 1.247.636 1.891L9.004 7.538l.449 2.226c.19.94-.83 1.655-1.649 1.158L6 9.828l-1.804 1.094c-.82.497-1.838-.219-1.649-1.158l.45-2.226-1.628-1.542c-.68-.644-.295-1.788.636-1.891l2.127-.237zM6 2.537l-.786 1.854a1.1 1.1 0 0 1-.891.664l-1.972.219 1.51 1.43a1.1 1.1 0 0 1 .322 1.017L3.77 9.778l1.66-1.008a1.1 1.1 0 0 1 1.141 0l1.662 1.008-.415-2.057a1.1 1.1 0 0 1 .321-1.016l1.51-1.431-1.97-.22a1.1 1.1 0 0 1-.892-.663z",
    clipRule: "evenodd"
  })));
};
var StarFilled12 = SvgStarFilled12;

var _path$1X, _path2$x;
function _extends$1Y() { _extends$1Y = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1Y.apply(this, arguments); }
var SvgStarFilled16 = function SvgStarFilled16(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends$1Y({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path$1X || (_path$1X = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: "#2F3438",
    d: "M7.302 2.64a.8.8 0 0 1 1.462 0l1.153 2.587a.8.8 0 0 0 .647.47l2.817.297a.8.8 0 0 1 .452 1.39L11.728 9.28a.8.8 0 0 0-.247.76l.588 2.772a.8.8 0 0 1-1.182.859l-2.454-1.415a.8.8 0 0 0-.8 0L5.18 13.67a.8.8 0 0 1-1.182-.859l.588-2.771a.8.8 0 0 0-.247-.76L2.233 7.383a.8.8 0 0 1 .452-1.39l2.817-.297a.8.8 0 0 0 .647-.47z"
  })), _path2$x || (_path2$x = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M6.617 2.334c.546-1.225 2.285-1.225 2.832 0l1.153 2.588a.05.05 0 0 0 .04.029l2.818.297c1.334.141 1.871 1.795.875 2.693L12.23 9.838a.05.05 0 0 0-.015.047l.588 2.771c.278 1.313-1.129 2.335-2.291 1.665l-2.454-1.416a.05.05 0 0 0-.05 0l-2.454 1.416c-1.162.67-2.57-.352-2.29-1.665l.587-2.77a.05.05 0 0 0-.015-.048L1.73 7.94c-.996-.898-.459-2.552.875-2.693l2.817-.297a.05.05 0 0 0 .04-.03zm1.38.593-.01.018-1.153 2.587a1.55 1.55 0 0 1-1.253.91l-2.817.298-.02.005-.007.003a.1.1 0 0 0-.016.026.1.1 0 0 0-.002.03q0 .004.003.007l.013.016L4.84 8.723c.41.37.593.932.478 1.473l-.587 2.772-.002.02.001.008a.1.1 0 0 0 .02.022.1.1 0 0 0 .028.012h.007l.02-.009 2.454-1.415a1.55 1.55 0 0 1 1.548 0l2.454 1.415.02.009h.007a.1.1 0 0 0 .028-.011.1.1 0 0 0 .02-.023l.001-.008-.002-.02-.588-2.772a1.55 1.55 0 0 1 .48-1.473l2.104-1.896.013-.016.003-.007a.1.1 0 0 0-.002-.03.1.1 0 0 0-.016-.026l-.006-.003-.02-.005-2.818-.297a1.55 1.55 0 0 1-1.253-.91L8.079 2.944l-.011-.018-.006-.005a.1.1 0 0 0-.03-.007.1.1 0 0 0-.028.007z",
    clipRule: "evenodd"
  })));
};
var StarFilled16 = SvgStarFilled16;

var _path$1W, _path2$w;
function _extends$1X() { _extends$1X = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1X.apply(this, arguments); }
var SvgStarFilled18 = function SvgStarFilled18(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends$1X({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _path$1W || (_path$1W = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: "#2F3438",
    d: "M8.087 3.05c.352-.791 1.474-.791 1.826 0l1.2 2.691a1 1 0 0 0 .809.588l2.931.309c.86.09 1.207 1.158.565 1.737l-2.19 1.973a1 1 0 0 0-.309.95l.612 2.884c.18.847-.728 1.506-1.478 1.074L9.5 13.783a1 1 0 0 0-1 0l-2.553 1.473c-.75.432-1.657-.227-1.478-1.074l.612-2.883a1 1 0 0 0-.309-.95l-2.19-1.974c-.642-.58-.296-1.646.565-1.737l2.931-.31a1 1 0 0 0 .809-.587z"
  })), _path2$w || (_path2$w = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M7.356 2.723c.634-1.422 2.654-1.422 3.288 0l1.2 2.693a.2.2 0 0 0 .162.117l2.93.31c1.55.163 2.174 2.084 1.017 3.127l-2.19 1.973a.2.2 0 0 0-.061.19l.611 2.883c.323 1.524-1.31 2.711-2.66 1.933L9.1 14.476a.2.2 0 0 0-.2 0L6.347 15.95c-1.35.778-2.984-.409-2.66-1.933l.611-2.883a.2.2 0 0 0-.061-.19L2.047 8.97C.89 7.927 1.514 6.006 3.063 5.842l2.931-.309a.2.2 0 0 0 .162-.117zm1.827.652a.2.2 0 0 0-.366 0l-1.2 2.692a1.8 1.8 0 0 1-1.455 1.057l-2.931.31a.2.2 0 0 0-.113.347l2.19 1.973a1.8 1.8 0 0 1 .555 1.71l-.611 2.884a.2.2 0 0 0 .295.215l2.554-1.473a1.8 1.8 0 0 1 1.798 0l2.554 1.473a.2.2 0 0 0 .295-.215l-.611-2.883a1.8 1.8 0 0 1 .555-1.71l2.19-1.974a.2.2 0 0 0-.113-.347l-2.931-.31a1.8 1.8 0 0 1-1.455-1.057z",
    clipRule: "evenodd"
  })));
};
var StarFilled18 = SvgStarFilled18;

var _path$1V, _path2$v;
function _extends$1W() { _extends$1W = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1W.apply(this, arguments); }
var SvgStarFilled24 = function SvgStarFilled24(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends$1W({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path$1V || (_path$1V = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: "#2F3438",
    d: "M11.087 4.299c.352-.79 1.474-.79 1.826 0l1.753 3.932a1 1 0 0 0 .808.587l4.281.452c.86.09 1.207 1.158.565 1.737l-3.198 2.882a1 1 0 0 0-.309.95l.893 4.211c.18.847-.728 1.506-1.477 1.074l-3.73-2.15a1 1 0 0 0-.999 0l-3.728 2.15c-.75.432-1.658-.227-1.478-1.074l.893-4.21a1 1 0 0 0-.309-.951L3.68 11.007c-.642-.58-.296-1.646.565-1.737l4.28-.452a1 1 0 0 0 .81-.587z"
  })), _path2$v || (_path2$v = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M10.265 3.933c.67-1.502 2.801-1.502 3.47 0l1.753 3.931a.1.1 0 0 0 .08.059l4.282.452c1.635.172 2.294 2.2 1.072 3.3l-3.198 2.882a.1.1 0 0 0-.03.095l.893 4.211c.34 1.609-1.384 2.862-2.808 2.04l-3.729-2.15a.1.1 0 0 0-.1 0l-3.729 2.15c-1.424.822-3.149-.431-2.808-2.04l.894-4.21a.1.1 0 0 0-.031-.096l-3.198-2.881c-1.222-1.101-.563-3.129 1.073-3.301l4.28-.452a.1.1 0 0 0 .081-.059zm1.679.687c-.009.005-.022.015-.035.045l-1.753 3.932A1.9 1.9 0 0 1 8.62 9.713l-4.28.452c-.033.003-.047.013-.054.02a.1.1 0 0 0-.031.048.1.1 0 0 0-.004.058c.002.01.008.025.032.048l3.198 2.881a1.9 1.9 0 0 1 .586 1.806l-.893 4.21c-.007.033-.002.049.002.058q.007.021.037.044.031.022.054.022c.01 0 .026 0 .055-.016l3.729-2.15a1.9 1.9 0 0 1 1.898 0l3.73 2.15c.028.017.044.017.054.016a.1.1 0 0 0 .054-.022.1.1 0 0 0 .037-.044c.004-.01.009-.025.002-.057l-.893-4.211a1.9 1.9 0 0 1 .587-1.806l3.197-2.881c.025-.023.03-.038.032-.048a.1.1 0 0 0-.004-.058.1.1 0 0 0-.03-.049c-.008-.006-.022-.016-.054-.02l-4.281-.451a1.9 1.9 0 0 1-1.536-1.116L12.09 4.665c-.013-.03-.026-.04-.034-.045A.1.1 0 0 0 12 4.606a.1.1 0 0 0-.056.014",
    clipRule: "evenodd"
  })));
};
var StarFilled24 = SvgStarFilled24;

var _path$1U, _path2$u;
function _extends$1V() { _extends$1V = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1V.apply(this, arguments); }
var SvgStarFilled32 = function SvgStarFilled32(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends$1V({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _path$1U || (_path$1U = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: "#2F3438",
    d: "M14.782 5.732c.47-1.054 1.966-1.054 2.436 0l2.336 5.242c.194.435.605.733 1.078.784l5.708.602c1.148.121 1.61 1.544.753 2.316l-4.264 3.843c-.353.318-.51.801-.412 1.267l1.191 5.614c.24 1.13-.97 2.008-1.97 1.432l-4.972-2.868a1.33 1.33 0 0 0-1.332 0l-4.972 2.868c-1 .576-2.21-.303-1.97-1.432l1.19-5.614a1.33 1.33 0 0 0-.411-1.267l-4.264-3.843c-.857-.772-.395-2.195.753-2.316l5.708-.602c.473-.05.884-.349 1.077-.784z"
  })), _path2$u || (_path2$u = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M13.686 5.244c.893-2.003 3.735-2.003 4.628 0l2.337 5.242c.019.043.06.073.107.078l5.708.602c2.18.23 3.059 2.934 1.43 4.402l-4.264 3.842a.13.13 0 0 0-.04.127l1.19 5.614c.455 2.145-1.844 3.816-3.744 2.72l-4.971-2.867a.13.13 0 0 0-.134 0l-4.971 2.867c-1.9 1.096-4.2-.575-3.744-2.72l1.19-5.614a.13.13 0 0 0-.04-.127l-4.264-3.842c-1.629-1.468-.75-4.171 1.43-4.401l5.708-.603a.13.13 0 0 0 .107-.078zm2.239.917c-.011.007-.029.02-.047.06l-2.337 5.242a2.53 2.53 0 0 1-2.048 1.488l-5.707.602c-.044.005-.062.018-.072.026a.14.14 0 0 0-.041.066.14.14 0 0 0-.005.077c.003.013.01.034.042.063l4.264 3.842c.672.606.97 1.523.782 2.408l-1.19 5.614c-.01.043-.003.064.002.076.007.017.023.04.05.06.026.02.053.027.072.029.012 0 .034 0 .072-.022l4.972-2.867a2.53 2.53 0 0 1 2.532 0l4.971 2.867c.038.022.06.023.073.022a.14.14 0 0 0 .072-.03.14.14 0 0 0 .05-.059c.005-.012.012-.033.002-.076l-1.19-5.614a2.53 2.53 0 0 1 .782-2.408l4.263-3.842c.033-.03.04-.05.043-.063a.14.14 0 0 0-.005-.077.14.14 0 0 0-.042-.066c-.01-.008-.027-.021-.07-.026l-5.709-.602a2.53 2.53 0 0 1-2.048-1.488L16.122 6.22c-.018-.04-.036-.053-.047-.06A.14.14 0 0 0 16 6.14c-.033 0-.06.01-.075.02",
    clipRule: "evenodd"
  })));
};
var StarFilled32 = SvgStarFilled32;

var _path$1T, _path2$t;
function _extends$1U() { _extends$1U = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1U.apply(this, arguments); }
var SvgStarFilled48 = function SvgStarFilled48(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends$1U({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none"
  }, props), _path$1T || (_path$1T = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: "#2F3438",
    d: "M22.173 5.598c.705-1.58 2.95-1.58 3.654 0l4.334 9.723a2 2 0 0 0 1.616 1.174l10.586 1.118c1.722.181 2.415 2.316 1.13 3.474l-7.908 7.127a2 2 0 0 0-.618 1.9l2.209 10.413c.36 1.694-1.456 3.012-2.956 2.148L25 37.356a2 2 0 0 0-2 0l-9.22 5.319c-1.5.864-3.315-.454-2.956-2.148l2.209-10.413a2 2 0 0 0-.618-1.9l-7.907-7.127c-1.286-1.158-.593-3.293 1.129-3.474l10.586-1.118a2 2 0 0 0 1.617-1.174z"
  })), _path2$t || (_path2$t = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M21.077 5.11c1.128-2.53 4.718-2.53 5.846 0l4.334 9.722a.8.8 0 0 0 .646.47l10.586 1.117c2.755.291 3.864 3.706 1.807 5.56l-7.908 7.126a.8.8 0 0 0-.247.76l2.209 10.413c.575 2.71-2.33 4.82-4.73 3.436l-9.22-5.318a.8.8 0 0 0-.8 0l-9.22 5.318c-2.4 1.384-5.304-.727-4.73-3.436l2.209-10.413a.8.8 0 0 0-.247-.76l-7.908-7.126c-2.057-1.854-.947-5.269 1.807-5.56l10.586-1.117a.8.8 0 0 0 .646-.47zm3.654.977a.8.8 0 0 0-1.462 0l-4.333 9.722a3.2 3.2 0 0 1-2.587 1.88L5.763 18.806a.8.8 0 0 0-.452 1.39l7.908 7.126a3.2 3.2 0 0 1 .988 3.041l-2.209 10.413a.8.8 0 0 0 1.182.86l9.221-5.32a3.2 3.2 0 0 1 3.198 0l9.22 5.32a.8.8 0 0 0 1.183-.86l-2.209-10.413a3.2 3.2 0 0 1 .989-3.04l7.907-7.127a.8.8 0 0 0-.452-1.39l-10.586-1.117a3.2 3.2 0 0 1-2.586-1.88z",
    clipRule: "evenodd"
  })));
};
var StarFilled48 = SvgStarFilled48;

var StarFilledIcon = function StarFilledIcon(props) {
  var starFilled = {
    12: StarFilled12,
    16: StarFilled16,
    18: StarFilled18,
    24: StarFilled24,
    32: StarFilled32,
    48: StarFilled48
  };
  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(IconTemplate, (0,_common_js__WEBPACK_IMPORTED_MODULE_2__.a)({
    icons: starFilled
  }, props));
};

var _path$1S;
function _extends$1T() { _extends$1T = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1T.apply(this, arguments); }
var SvgStat12 = function SvgStat12(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1T({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none"
  }, props), _path$1S || (_path$1S = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M3 5.9a.6.6 0 0 1 .6.6v3a.6.6 0 0 1-1.2 0v-3a.6.6 0 0 1 .6-.6M6 3.9a.6.6 0 0 1 .6.6v5a.6.6 0 0 1-1.2 0v-5a.6.6 0 0 1 .6-.6M9 1.9a.6.6 0 0 1 .6.6v7a.6.6 0 0 1-1.2 0v-7a.6.6 0 0 1 .6-.6",
    clipRule: "evenodd"
  })));
};
var Stat12 = (/* unused pure expression or super */ null && (SvgStat12));

var _path$1R;
function _extends$1S() { _extends$1S = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1S.apply(this, arguments); }
var SvgStat16 = function SvgStat16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1S({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path$1R || (_path$1R = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M4 7.917a.75.75 0 0 1 .75.75v4a.75.75 0 0 1-1.5 0v-4a.75.75 0 0 1 .75-.75M8 5.25a.75.75 0 0 1 .75.75v6.667a.75.75 0 0 1-1.5 0V6A.75.75 0 0 1 8 5.25M12 2.584a.75.75 0 0 1 .75.75v9.333a.75.75 0 0 1-1.5 0V3.334a.75.75 0 0 1 .75-.75",
    clipRule: "evenodd"
  })));
};
var Stat16 = (/* unused pure expression or super */ null && (SvgStat16));

var _path$1Q;
function _extends$1R() { _extends$1R = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1R.apply(this, arguments); }
var SvgStat18 = function SvgStat18(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1R({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _path$1Q || (_path$1Q = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M4.5 8.95a.8.8 0 0 1 .8.8v4.5a.8.8 0 0 1-1.6 0v-4.5a.8.8 0 0 1 .8-.8M9 5.95a.8.8 0 0 1 .8.8v7.5a.8.8 0 0 1-1.6 0v-7.5a.8.8 0 0 1 .8-.8M13.5 2.95a.8.8 0 0 1 .8.8v10.5a.8.8 0 0 1-1.6 0V3.75a.8.8 0 0 1 .8-.8",
    clipRule: "evenodd"
  })));
};
var Stat18 = (/* unused pure expression or super */ null && (SvgStat18));

var _path$1P;
function _extends$1Q() { _extends$1Q = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1Q.apply(this, arguments); }
var SvgStat24 = function SvgStat24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1Q({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path$1P || (_path$1P = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M6 12.1a.9.9 0 0 1 .9.9v6a.9.9 0 1 1-1.8 0v-6a.9.9 0 0 1 .9-.9M12 8.1a.9.9 0 0 1 .9.9v10a.9.9 0 1 1-1.8 0V9a.9.9 0 0 1 .9-.9M18 4.1a.9.9 0 0 1 .9.9v14a.9.9 0 1 1-1.8 0V5a.9.9 0 0 1 .9-.9",
    clipRule: "evenodd"
  })));
};
var Stat24 = (/* unused pure expression or super */ null && (SvgStat24));

var _path$1O;
function _extends$1P() { _extends$1P = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1P.apply(this, arguments); }
var SvgStat32 = function SvgStat32(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1P({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _path$1O || (_path$1O = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M8 16.333a1 1 0 0 1 1 1v8a1 1 0 1 1-2 0v-8a1 1 0 0 1 1-1M16 11a1 1 0 0 1 1 1v13.333a1 1 0 1 1-2 0V12a1 1 0 0 1 1-1M24 5.667a1 1 0 0 1 1 1v18.666a1 1 0 1 1-2 0V6.667a1 1 0 0 1 1-1",
    clipRule: "evenodd"
  })));
};
var Stat32 = (/* unused pure expression or super */ null && (SvgStat32));

var _path$1N;
function _extends$1O() { _extends$1O = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1O.apply(this, arguments); }
var SvgStat48 = function SvgStat48(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1O({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none"
  }, props), _path$1N || (_path$1N = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M12 24.797a1.2 1.2 0 0 1 1.2 1.2v12a1.2 1.2 0 0 1-2.4 0v-12a1.2 1.2 0 0 1 1.2-1.2M24 16.799a1.2 1.2 0 0 1 1.2 1.2v20a1.2 1.2 0 1 1-2.4 0v-20a1.2 1.2 0 0 1 1.2-1.2M36 8.8a1.2 1.2 0 0 1 1.2 1.2v28a1.2 1.2 0 0 1-2.4 0V10A1.2 1.2 0 0 1 36 8.8",
    clipRule: "evenodd"
  })));
};
var Stat48 = (/* unused pure expression or super */ null && (SvgStat48));

var StatIcon = function StatIcon(props) {
  var stat = {
    12: Stat12,
    16: Stat16,
    18: Stat18,
    24: Stat24,
    32: Stat32,
    48: Stat48
  };
  return jsx(IconTemplate, _assign({
    icons: stat
  }, props));
};

var _path$1M;
function _extends$1N() { _extends$1N = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1N.apply(this, arguments); }
var SvgStore12 = function SvgStore12(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1N({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none"
  }, props), _path$1M || (_path$1M = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M1.528 1.3a.727.727 0 0 0-.728.728V5c0 .772.398 1.452 1 1.844V8a2.7 2.7 0 0 0 2.7 2.7h3A2.7 2.7 0 0 0 10.2 8V6.844c.602-.392 1-1.072 1-1.844V2a.7.7 0 0 0-.7-.7H1.528M8.8 7.191a2.2 2.2 0 0 1-1.3-.582c-.393.367-.92.591-1.5.591s-1.107-.224-1.5-.59c-.347.323-.8.536-1.3.581V8a1.3 1.3 0 0 0 1.3 1.3h3A1.3 1.3 0 0 0 8.8 8zm-2-4.49V5a.8.8 0 1 1-1.6 0V2.7zM8.2 5V2.7h1.6V5a.8.8 0 1 1-1.6 0M3.8 2.7H2.2V5a.8.8 0 1 0 1.6 0z",
    clipRule: "evenodd"
  })));
};
var Store12 = (/* unused pure expression or super */ null && (SvgStore12));

var _path$1L;
function _extends$1M() { _extends$1M = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1M.apply(this, arguments); }
var SvgStore16 = function SvgStore16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1M({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path$1L || (_path$1L = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M2.037 1.867a.837.837 0 0 0-.837.836v3.964c0 1.008.533 1.892 1.333 2.385v1.615A3.467 3.467 0 0 0 6 14.133h4a3.467 3.467 0 0 0 3.467-3.466V9.052A2.8 2.8 0 0 0 14.8 6.667v-4a.8.8 0 0 0-.8-.8zm9.83 7.597A2.8 2.8 0 0 1 10 8.626a2.8 2.8 0 0 1-2 .84 2.8 2.8 0 0 1-2-.84 2.8 2.8 0 0 1-1.867.838v1.203c0 1.03.836 1.866 1.867 1.866h4a1.867 1.867 0 0 0 1.867-1.866zM12 7.867a1.2 1.2 0 0 1-1.2-1.2v-3.2h2.4v3.2a1.2 1.2 0 0 1-1.2 1.2m-5.2-4.4h2.4v3.2a1.2 1.2 0 0 1-2.4 0zm-1.6 0H2.8v3.2a1.2 1.2 0 0 0 2.4 0z",
    clipRule: "evenodd"
  })));
};
var Store16 = (/* unused pure expression or super */ null && (SvgStore16));

var _path$1K;
function _extends$1L() { _extends$1L = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1L.apply(this, arguments); }
var SvgStore18 = function SvgStore18(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1L({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _path$1K || (_path$1K = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M2.291 2.2a.84.84 0 0 0-.841.841V7.5c0 1.119.602 2.096 1.5 2.627V12a3.8 3.8 0 0 0 3.8 3.8h4.5a3.8 3.8 0 0 0 3.8-3.8v-1.873a3.05 3.05 0 0 0 1.5-2.627V3a.8.8 0 0 0-.8-.8zm11.159 8.35a3.04 3.04 0 0 1-2.2-.99c-.558.608-1.36.99-2.25.99s-1.692-.382-2.25-.99a3.04 3.04 0 0 1-2.2.99V12a2.2 2.2 0 0 0 2.2 2.2h4.5a2.2 2.2 0 0 0 2.2-2.2zm-3-6.75v3.7a1.45 1.45 0 0 1-2.9 0V3.8zm1.6 3.7V3.8h2.9v3.7a1.45 1.45 0 0 1-2.9 0m-6.1-3.7h-2.9v3.7a1.45 1.45 0 0 0 2.9 0z",
    clipRule: "evenodd"
  })));
};
var Store18 = (/* unused pure expression or super */ null && (SvgStore18));

var _path$1J;
function _extends$1K() { _extends$1K = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1K.apply(this, arguments); }
var SvgStore24 = function SvgStore24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1K({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path$1J || (_path$1J = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M3.055 3.1a.955.955 0 0 0-.955.955V10c0 1.464.807 2.74 2 3.407V17A3.9 3.9 0 0 0 8 20.9h8a3.9 3.9 0 0 0 3.9-3.9v-3.593a3.9 3.9 0 0 0 2-3.407V4a.9.9 0 0 0-.9-.9zM18.1 13.9l-.1.001a3.9 3.9 0 0 1-3-1.408 3.9 3.9 0 0 1-3 1.408 3.9 3.9 0 0 1-3-1.408A3.9 3.9 0 0 1 5.9 13.9V17c0 1.16.94 2.1 2.1 2.1h8a2.1 2.1 0 0 0 2.1-2.1zM18 12.1a2.1 2.1 0 0 1-2.1-2.1V4.9h4.2V10a2.1 2.1 0 0 1-2.1 2.1M9.9 4.9h4.2V10a2.1 2.1 0 1 1-4.2 0zm-1.8 0H3.9V10a2.1 2.1 0 1 0 4.2 0z",
    clipRule: "evenodd"
  })));
};
var Store24 = (/* unused pure expression or super */ null && (SvgStore24));

var _path$1I;
function _extends$1J() { _extends$1J = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1J.apply(this, arguments); }
var SvgStore32 = function SvgStore32(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1J({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _path$1I || (_path$1I = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M4.073 4.334C3.481 4.334 3 4.813 3 5.406v7.927a5 5 0 0 0 2.667 4.423v5.91a4 4 0 0 0 4 4h12.666a4 4 0 0 0 4-4v-5.91A5 5 0 0 0 29 13.333v-8a1 1 0 0 0-1-1zm20.26 13.989q-.165.01-.333.01a5 5 0 0 1-4-1.999 5 5 0 0 1-4 2 5 5 0 0 1-4-2 4.99 4.99 0 0 1-4.333 1.989v5.344a2 2 0 0 0 2 2h12.666a2 2 0 0 0 2-2zM19 6.333v7a3 3 0 1 1-6 0v-7zm2 7v-7h6v7a3 3 0 1 1-6 0m-10-7H5v7a3 3 0 1 0 6 0z",
    clipRule: "evenodd"
  })));
};
var Store32 = (/* unused pure expression or super */ null && (SvgStore32));

var _path$1H;
function _extends$1I() { _extends$1I = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1I.apply(this, arguments); }
var SvgStore48 = function SvgStore48(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1I({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none"
  }, props), _path$1H || (_path$1H = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M6.11 6.85a1.26 1.26 0 0 0-1.26 1.26V20a7.15 7.15 0 0 0 4 6.42V37A4.15 4.15 0 0 0 13 41.15h22A4.15 4.15 0 0 0 39.15 37V26.42a7.15 7.15 0 0 0 4-6.42V8A1.15 1.15 0 0 0 42 6.85zM36.85 27.1q-.418.05-.85.05a7.14 7.14 0 0 1-6-3.26 7.14 7.14 0 0 1-6 3.26 7.14 7.14 0 0 1-6-3.26 7.14 7.14 0 0 1-6.85 3.21V37A1.85 1.85 0 0 0 13 38.85h22A1.85 1.85 0 0 0 36.85 37zM36 24.85A4.85 4.85 0 0 1 31.15 20V9.15h9.7V20A4.85 4.85 0 0 1 36 24.85M19.15 9.15h9.7V20a4.85 4.85 0 1 1-9.7 0zm-2.3 0h-9.7V20a4.85 4.85 0 1 0 9.7 0z",
    clipRule: "evenodd"
  })));
};
var Store48 = (/* unused pure expression or super */ null && (SvgStore48));

var StoreIcon = function StoreIcon(props) {
  var store = {
    12: Store12,
    16: Store16,
    18: Store18,
    24: Store24,
    32: Store32,
    48: Store48
  };
  return jsx(IconTemplate, _assign({
    icons: store
  }, props));
};

var _path$1G;
function _extends$1H() { _extends$1H = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1H.apply(this, arguments); }
var SvgStoreFilled12 = function SvgStoreFilled12(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1H({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none"
  }, props), _path$1G || (_path$1G = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "m9.422 6.435-.022.003h-.003zM2 2.1h2.076v2.562a1.238 1.238 0 1 1-2.476 0V2.5c0-.22.18-.4.4-.4m2.762 0h2.476v2.562a1.238 1.238 0 0 1-2.476 0zm3.162 0H10c.221 0 .4.18.4.4v2.162a1.238 1.238 0 0 1-2.476 0zm1.238 4.455q.12 0 .238-.016V8.63a1.4 1.4 0 0 1-1.4 1.4H4a1.4 1.4 0 0 1-1.4-1.4V6.54q.117.015.238.015c.693 0 1.293-.4 1.58-.982a1.763 1.763 0 0 0 3.163 0c.288.582.888.982 1.581.982",
    clipRule: "evenodd"
  })));
};
var StoreFilled12 = (/* unused pure expression or super */ null && (SvgStoreFilled12));

var _path$1F, _path2$s;
function _extends$1G() { _extends$1G = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1G.apply(this, arguments); }
var SvgStoreFilled16 = function SvgStoreFilled16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1G({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path$1F || (_path$1F = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M2.1 3.333c0-.313.254-.566.567-.566h2.8v3.45a1.684 1.684 0 0 1-3.367 0zM6.316 6.216v-3.45h3.368v3.45a1.684 1.684 0 0 1-3.368 0M10.532 6.216v-3.45h2.801c.313 0 .567.254.567.567v2.883a1.684 1.684 0 0 1-3.368 0"
  })), _path2$s || (_path2$s = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M8 8.707c.936 0 1.742-.555 2.108-1.354a2.32 2.32 0 0 0 2.458 1.328v2.826a1.9 1.9 0 0 1-1.9 1.9H5.333a1.9 1.9 0 0 1-1.9-1.9V8.68q.171.026.35.026c.937 0 1.743-.555 2.108-1.354A2.32 2.32 0 0 0 8 8.707"
  })));
};
var StoreFilled16 = (/* unused pure expression or super */ null && (SvgStoreFilled16));

var _path$1E, _path2$r;
function _extends$1F() { _extends$1F = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1F.apply(this, arguments); }
var SvgStoreFilled18 = function SvgStoreFilled18(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1F({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _path$1E || (_path$1E = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M2.4 3.75a.6.6 0 0 1 .6-.6h3.113v3.843a1.857 1.857 0 0 1-3.713 0zM7.143 6.993V3.15h3.714v3.843a1.857 1.857 0 0 1-3.714 0M11.886 6.993V3.15H15a.6.6 0 0 1 .6.6v3.243a1.857 1.857 0 0 1-3.714 0"
  })), _path2$r || (_path2$r = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M9 9.833c1.04 0 1.94-.6 2.371-1.474A2.64 2.64 0 0 0 14.1 9.81v3.136a2.1 2.1 0 0 1-2.1 2.1H6a2.1 2.1 0 0 1-2.1-2.1V9.81q.176.024.356.024c1.04 0 1.94-.6 2.372-1.474A2.64 2.64 0 0 0 9 9.833"
  })));
};
var StoreFilled18 = (/* unused pure expression or super */ null && (SvgStoreFilled18));

var _path$1D, _path2$q;
function _extends$1E() { _extends$1E = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1E.apply(this, arguments); }
var SvgStoreFilled24 = function SvgStoreFilled24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1E({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path$1D || (_path$1D = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M15.334 12.11A4.13 4.13 0 0 1 12 13.8a4.13 4.13 0 0 1-3.333-1.689A4.13 4.13 0 0 1 4.1 13.613v3.386A3.9 3.9 0 0 0 8 20.9h8a3.9 3.9 0 0 0 3.9-3.9v-3.386a4.128 4.128 0 0 1-4.567-1.502M21.125 10.282a2.54 2.54 0 0 1-2.458 1.918 2.533 2.533 0 0 1-2.533-2.534V3.8H20.2a1 1 0 0 1 1 1v4.866q0 .32-.075.616M4.1 11.88a2.533 2.533 0 0 0 3.767-2.19V3.8H3.8a1 1 0 0 0-1 1v4.866c0 .951.525 1.78 1.3 2.214"
  })), _path2$q || (_path2$q = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M9.467 9.69a2.533 2.533 0 0 0 5.066-.024V3.8H9.467v5.889"
  })));
};
var StoreFilled24 = (/* unused pure expression or super */ null && (SvgStoreFilled24));

var _path$1C, _path2$p, _path3$1, _path4;
function _extends$1D() { _extends$1D = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1D.apply(this, arguments); }
var SvgStoreFilled32 = function SvgStoreFilled32(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1D({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _path$1C || (_path$1C = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M4 6.667c0-.737.597-1.334 1.333-1.334h5.802v7.1a3.567 3.567 0 1 1-7.135 0zM12.432 5.333h7.136v7.1a3.568 3.568 0 0 1-7.136 0zM28 6.667c0-.737-.597-1.334-1.333-1.334h-5.802v7.1a3.567 3.567 0 1 0 7.135 0z"
  })), _path2$p || (_path2$p = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M24.432 17.214q.464-.001.901-.092v5.892a4 4 0 0 1-4 4H10.667a4 4 0 0 1-4-4v-5.892q.437.091.9.092a4.44 4.44 0 0 0 4.216-3.057 4.436 4.436 0 0 0 8.433 0 4.44 4.44 0 0 0 4.216 3.057"
  })), _path3$1 || (_path3$1 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeWidth: 0.5,
    d: "M4 6.667c0-.737.597-1.334 1.333-1.334h5.802v7.1a3.567 3.567 0 1 1-7.135 0zM12.432 5.333h7.136v7.1a3.568 3.568 0 0 1-7.136 0zM28 6.667c0-.737-.597-1.334-1.333-1.334h-5.802v7.1a3.567 3.567 0 1 0 7.135 0z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeWidth: 0.5,
    d: "M24.432 17.214q.464-.001.901-.092v5.892a4 4 0 0 1-4 4H10.667a4 4 0 0 1-4-4v-5.892q.437.091.9.092a4.44 4.44 0 0 0 4.216-3.057 4.436 4.436 0 0 0 8.433 0 4.44 4.44 0 0 0 4.216 3.057Z"
  })));
};
var StoreFilled32 = (/* unused pure expression or super */ null && (SvgStoreFilled32));

var _path$1B, _path2$o;
function _extends$1C() { _extends$1C = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1C.apply(this, arguments); }
var SvgStoreFilled48 = function SvgStoreFilled48(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1C({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none"
  }, props), _path$1B || (_path$1B = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M6 10a2 2 0 0 1 2-2h8.703v10.649a5.351 5.351 0 0 1-10.703 0zM18.649 8H29.35v10.649a5.351 5.351 0 0 1-10.702 0zM42 10a2 2 0 0 0-2-2h-8.703v10.649a5.351 5.351 0 0 0 10.703 0z"
  })), _path2$o || (_path2$o = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M36.648 25.82q.696-.001 1.352-.137v8.838a6 6 0 0 1-6 6H16a6 6 0 0 1-6-6v-8.837q.656.136 1.35.137a6.65 6.65 0 0 0 6.325-4.586 6.654 6.654 0 0 0 12.648 0 6.65 6.65 0 0 0 6.325 4.586"
  })));
};
var StoreFilled48 = (/* unused pure expression or super */ null && (SvgStoreFilled48));

var StoreFilledIcon = function StoreFilledIcon(props) {
  var storeFilled = {
    12: StoreFilled12,
    16: StoreFilled16,
    18: StoreFilled18,
    24: StoreFilled24,
    32: StoreFilled32,
    48: StoreFilled48
  };
  return jsx(IconTemplate, _assign({
    icons: storeFilled
  }, props));
};

var _path$1A;
function _extends$1B() { _extends$1B = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1B.apply(this, arguments); }
var SvgSubtract12 = function SvgSubtract12(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1B({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none"
  }, props), _path$1A || (_path$1A = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M11.1 6a.6.6 0 0 1-.6.6h-9a.6.6 0 1 1 0-1.2h9a.6.6 0 0 1 .6.6",
    clipRule: "evenodd"
  })));
};
var Subtract12 = (/* unused pure expression or super */ null && (SvgSubtract12));

var _path$1z;
function _extends$1A() { _extends$1A = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1A.apply(this, arguments); }
var SvgSubtract16 = function SvgSubtract16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1A({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path$1z || (_path$1z = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M14.75 8a.75.75 0 0 1-.75.75H2a.75.75 0 0 1 0-1.5h12a.75.75 0 0 1 .75.75",
    clipRule: "evenodd"
  })));
};
var Subtract16 = (/* unused pure expression or super */ null && (SvgSubtract16));

var _path$1y;
function _extends$1z() { _extends$1z = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1z.apply(this, arguments); }
var SvgSubtract18 = function SvgSubtract18(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1z({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _path$1y || (_path$1y = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M16.55 9a.8.8 0 0 1-.8.8H2.25a.8.8 0 1 1 0-1.6h13.5a.8.8 0 0 1 .8.8",
    clipRule: "evenodd"
  })));
};
var Subtract18 = (/* unused pure expression or super */ null && (SvgSubtract18));

var _path$1x;
function _extends$1y() { _extends$1y = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1y.apply(this, arguments); }
var SvgSubtract24 = function SvgSubtract24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1y({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path$1x || (_path$1x = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M21.9 12a.9.9 0 0 1-.9.9H3a.9.9 0 0 1 0-1.8h18a.9.9 0 0 1 .9.9",
    clipRule: "evenodd"
  })));
};
var Subtract24 = (/* unused pure expression or super */ null && (SvgSubtract24));

var _path$1w;
function _extends$1x() { _extends$1x = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1x.apply(this, arguments); }
var SvgSubtract32 = function SvgSubtract32(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1x({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _path$1w || (_path$1w = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M29 16a1 1 0 0 1-1 1H4a1 1 0 1 1 0-2h24a1 1 0 0 1 1 1",
    clipRule: "evenodd"
  })));
};
var Subtract32 = (/* unused pure expression or super */ null && (SvgSubtract32));

var _path$1v;
function _extends$1w() { _extends$1w = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1w.apply(this, arguments); }
var SvgSubtract48 = function SvgSubtract48(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1w({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none"
  }, props), _path$1v || (_path$1v = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M43.2 24a1.2 1.2 0 0 1-1.2 1.2H6a1.2 1.2 0 1 1 0-2.4h36a1.2 1.2 0 0 1 1.2 1.2",
    clipRule: "evenodd"
  })));
};
var Subtract48 = (/* unused pure expression or super */ null && (SvgSubtract48));

var SubtractIcon = function SubtractIcon(props) {
  var subtract = {
    12: Subtract12,
    16: Subtract16,
    18: Subtract18,
    24: Subtract24,
    32: Subtract32,
    48: Subtract48
  };
  return jsx(IconTemplate, _assign({
    icons: subtract
  }, props));
};

var _path$1u;
function _extends$1v() { _extends$1v = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1v.apply(this, arguments); }
var SvgTagFilled12 = function SvgTagFilled12(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1v({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none"
  }, props), _path$1u || (_path$1u = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M1 2.5v2.879c0 .398.158.779.44 1.06l3.5 3.5a1.5 1.5 0 0 0 2.12 0l2.88-2.878a1.5 1.5 0 0 0 0-2.122l-3.5-3.5A1.5 1.5 0 0 0 5.378 1H2.5A1.5 1.5 0 0 0 1 2.5m1.75 1a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5",
    clipRule: "evenodd"
  })));
};
var TagFilled12 = (/* unused pure expression or super */ null && (SvgTagFilled12));

var _path$1t;
function _extends$1u() { _extends$1u = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1u.apply(this, arguments); }
var SvgTagFilled16 = function SvgTagFilled16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1u({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path$1t || (_path$1t = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M1.334 3.334v3.838a2 2 0 0 0 .585 1.414l4.667 4.667a2 2 0 0 0 2.828 0l3.839-3.839a2 2 0 0 0 0-2.828L8.586 1.919a2 2 0 0 0-1.414-.586H3.333a2 2 0 0 0-2 2m2.333 1.333a1 1 0 1 0 0-2 1 1 0 0 0 0 2",
    clipRule: "evenodd"
  })));
};
var TagFilled16 = (/* unused pure expression or super */ null && (SvgTagFilled16));

var _path$1s;
function _extends$1t() { _extends$1t = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1t.apply(this, arguments); }
var SvgTagFilled18 = function SvgTagFilled18(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1t({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _path$1s || (_path$1s = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M1.5 3.75v4.318c0 .597.237 1.17.659 1.591l5.25 5.25a2.25 2.25 0 0 0 3.182 0l4.318-4.318a2.25 2.25 0 0 0 0-3.182l-5.25-5.25A2.25 2.25 0 0 0 8.068 1.5H3.75A2.25 2.25 0 0 0 1.5 3.75m2.625 1.5a1.125 1.125 0 1 0 0-2.25 1.125 1.125 0 0 0 0 2.25",
    clipRule: "evenodd"
  })));
};
var TagFilled18 = (/* unused pure expression or super */ null && (SvgTagFilled18));

var _path$1r;
function _extends$1s() { _extends$1s = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1s.apply(this, arguments); }
var SvgTagFilled24 = function SvgTagFilled24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1s({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path$1r || (_path$1r = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M2 5v5.757a3 3 0 0 0 .879 2.122l7 7a3 3 0 0 0 4.242 0l5.758-5.758a3 3 0 0 0 0-4.242l-7-7A3 3 0 0 0 10.757 2H5a3 3 0 0 0-3 3m3.5 2a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3",
    clipRule: "evenodd"
  })));
};
var TagFilled24 = (/* unused pure expression or super */ null && (SvgTagFilled24));

var _path$1q;
function _extends$1r() { _extends$1r = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1r.apply(this, arguments); }
var SvgTagFilled32 = function SvgTagFilled32(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1r({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _path$1q || (_path$1q = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M2.667 6.667v7.676a4 4 0 0 0 1.171 2.828l9.333 9.334a4 4 0 0 0 5.657 0l7.677-7.677a4 4 0 0 0 0-5.657L17.17 3.838a4 4 0 0 0-2.828-1.171H6.667a4 4 0 0 0-4 4m4.667 2.667a2 2 0 1 0 0-4 2 2 0 0 0 0 4",
    clipRule: "evenodd"
  })));
};
var TagFilled32 = (/* unused pure expression or super */ null && (SvgTagFilled32));

var _path$1p;
function _extends$1q() { _extends$1q = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1q.apply(this, arguments); }
var SvgTagFilled48 = function SvgTagFilled48(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1q({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none"
  }, props), _path$1p || (_path$1p = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M4 10v11.515a6 6 0 0 0 1.757 4.242l14 14a6 6 0 0 0 8.486 0l11.514-11.514a6 6 0 0 0 0-8.486l-14-14A6 6 0 0 0 21.515 4H10a6 6 0 0 0-6 6m7 4a3 3 0 1 0 0-6 3 3 0 0 0 0 6",
    clipRule: "evenodd"
  })));
};
var TagFilled48 = (/* unused pure expression or super */ null && (SvgTagFilled48));

var TagFilledIcon = function TagFilledIcon(props) {
  var tagFilled = {
    12: TagFilled12,
    16: TagFilled16,
    18: TagFilled18,
    24: TagFilled24,
    32: TagFilled32,
    48: TagFilled48
  };
  return jsx(IconTemplate, _assign({
    icons: tagFilled
  }, props));
};

var _path$1o;
function _extends$1p() { _extends$1p = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1p.apply(this, arguments); }
var SvgTextBold12 = function SvgTextBold12(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1p({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none"
  }, props), _path$1o || (_path$1o = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M2.4 2.79c0-.768.622-1.39 1.39-1.39H6a2.6 2.6 0 0 1 2.037 4.215A2.6 2.6 0 0 1 7 10.6H3.947A1.547 1.547 0 0 1 2.4 9.053zM3.6 6.6v2.453c0 .191.155.347.347.347H7a1.4 1.4 0 1 0 0-2.8zm0-1.2H6a1.4 1.4 0 1 0 0-2.8H3.79a.19.19 0 0 0-.19.19z",
    clipRule: "evenodd"
  })));
};
var TextBold12 = (/* unused pure expression or super */ null && (SvgTextBold12));

var _path$1n;
function _extends$1o() { _extends$1o = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1o.apply(this, arguments); }
var SvgTextBold16 = function SvgTextBold16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1o({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path$1n || (_path$1n = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M3.25 3.72c0-.996.807-1.803 1.803-1.803H8a3.417 3.417 0 0 1 2.636 5.59 3.418 3.418 0 0 1-1.303 6.576h-4.07A2.013 2.013 0 0 1 3.25 12.07zm1.5 5.03v3.32c0 .284.23.513.513.513h4.07a1.917 1.917 0 1 0 0-3.833zm0-1.5H8a1.917 1.917 0 1 0 0-3.833H5.053a.303.303 0 0 0-.303.302z",
    clipRule: "evenodd"
  })));
};
var TextBold16 = (/* unused pure expression or super */ null && (SvgTextBold16));

var _path$1m;
function _extends$1n() { _extends$1n = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1n.apply(this, arguments); }
var SvgTextBold18 = function SvgTextBold18(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1n({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _path$1m || (_path$1m = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M3.7 4.184c0-1.096.888-1.984 1.984-1.984H9a3.8 3.8 0 0 1 2.893 6.264A3.801 3.801 0 0 1 10.5 15.8H5.921A2.22 2.22 0 0 1 3.7 13.579zM5.3 9.8v3.779c0 .343.278.621.621.621H10.5a2.2 2.2 0 0 0 0-4.4zm0-1.6H9a2.2 2.2 0 1 0 0-4.4H5.684a.384.384 0 0 0-.384.384z",
    clipRule: "evenodd"
  })));
};
var TextBold18 = (/* unused pure expression or super */ null && (SvgTextBold18));

var _path$1l;
function _extends$1m() { _extends$1m = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1m.apply(this, arguments); }
var SvgTextBold24 = function SvgTextBold24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1m({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path$1l || (_path$1l = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M5.1 5.579C5.1 4.21 6.21 3.1 7.58 3.1H12a4.9 4.9 0 0 1 3.57 8.257A4.902 4.902 0 0 1 14 20.9H7.895A2.795 2.795 0 0 1 5.1 18.105zM6.9 12.9v5.205c0 .55.445.995.995.995H14a3.1 3.1 0 1 0 0-6.2zm0-1.8H12a3.1 3.1 0 1 0 0-6.2H7.58a.68.68 0 0 0-.679.679z",
    clipRule: "evenodd"
  })));
};
var TextBold24 = (/* unused pure expression or super */ null && (SvgTextBold24));

var _path$1k;
function _extends$1l() { _extends$1l = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1l.apply(this, arguments); }
var SvgTextBold32 = function SvgTextBold32(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1l({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _path$1k || (_path$1k = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M7 7.439a3.105 3.105 0 0 1 3.105-3.106H16a6.333 6.333 0 0 1 4.386 10.903 6.333 6.333 0 0 1-1.719 12.43h-8.14A3.526 3.526 0 0 1 7 24.14zm2 9.56v7.141c0 .843.683 1.527 1.526 1.527h8.14a4.333 4.333 0 0 0 0-8.667zm0-2h7a4.333 4.333 0 0 0 0-8.666h-5.895C9.495 6.333 9 6.828 9 7.44z",
    clipRule: "evenodd"
  })));
};
var TextBold32 = (/* unused pure expression or super */ null && (SvgTextBold32));

var _path$1j;
function _extends$1k() { _extends$1k = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1k.apply(this, arguments); }
var SvgTextBold48 = function SvgTextBold48(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1k({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none"
  }, props), _path$1j || (_path$1j = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M10.8 11.158A4.36 4.36 0 0 1 15.158 6.8H24a9.2 9.2 0 0 1 5.96 16.21c4.14.897 7.24 4.581 7.24 8.99a9.2 9.2 0 0 1-9.2 9.2H15.79a4.99 4.99 0 0 1-4.99-4.99zM13.2 25.2v11.01a2.59 2.59 0 0 0 2.59 2.59H28a6.8 6.8 0 1 0 0-13.6zm0-2.4H24a6.8 6.8 0 1 0 0-13.6h-8.842a1.96 1.96 0 0 0-1.958 1.958z",
    clipRule: "evenodd"
  })));
};
var TextBold48 = (/* unused pure expression or super */ null && (SvgTextBold48));

var TextBoldIcon = function TextBoldIcon(props) {
  var textBold = {
    12: TextBold12,
    16: TextBold16,
    18: TextBold18,
    24: TextBold24,
    32: TextBold32,
    48: TextBold48
  };
  return jsx(IconTemplate, _assign({
    icons: textBold
  }, props));
};

var _path$1i;
function _extends$1j() { _extends$1j = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1j.apply(this, arguments); }
var SvgTextItalic12 = function SvgTextItalic12(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1j({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none"
  }, props), _path$1i || (_path$1i = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M6.986 1.9H4.5a.6.6 0 0 0 0 1.2h1.704L4.547 8.9H2.5a.6.6 0 0 0 0 1.2h5a.6.6 0 0 0 0-1.2H5.795l1.657-5.8H9.5a.6.6 0 0 0 0-1.2H6.986",
    clipRule: "evenodd"
  })));
};
var TextItalic12 = (/* unused pure expression or super */ null && (SvgTextItalic12));

var _path$1h;
function _extends$1i() { _extends$1i = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1i.apply(this, arguments); }
var SvgTextItalic16 = function SvgTextItalic16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1i({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path$1h || (_path$1h = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M9.315 2.583H6a.75.75 0 1 0 0 1.5h2.339l-2.238 7.834H3.333a.75.75 0 1 0 0 1.5H10a.75.75 0 0 0 0-1.5H7.66L9.9 4.083h2.768a.75.75 0 0 0 0-1.5H9.315",
    clipRule: "evenodd"
  })));
};
var TextItalic16 = (/* unused pure expression or super */ null && (SvgTextItalic16));

var _path$1g;
function _extends$1h() { _extends$1h = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1h.apply(this, arguments); }
var SvgTextItalic18 = function SvgTextItalic18(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1h({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _path$1g || (_path$1g = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M10.48 2.95H6.75a.8.8 0 1 0 0 1.6h2.69l-2.543 8.9H3.75a.8.8 0 0 0 0 1.6h7.5a.8.8 0 1 0 0-1.6H8.56l2.543-8.9h3.147a.8.8 0 1 0 0-1.6H10.48",
    clipRule: "evenodd"
  })));
};
var TextItalic18 = (/* unused pure expression or super */ null && (SvgTextItalic18));

var _path$1f;
function _extends$1g() { _extends$1g = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1g.apply(this, arguments); }
var SvgTextItalic24 = function SvgTextItalic24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1g({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path$1f || (_path$1f = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M13.978 4.1H9a.9.9 0 1 0 0 1.8h3.807L9.32 18.1h-4.32a.9.9 0 0 0 0 1.8H15a.9.9 0 1 0 0-1.8h-3.807L14.68 5.9H19a.9.9 0 1 0 0-1.8h-5.022",
    clipRule: "evenodd"
  })));
};
var TextItalic24 = (/* unused pure expression or super */ null && (SvgTextItalic24));

var _path$1e;
function _extends$1f() { _extends$1f = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1f.apply(this, arguments); }
var SvgTextItalic32 = function SvgTextItalic32(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1f({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _path$1e || (_path$1e = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M18.642 5.667H12a1 1 0 1 0 0 2h5.341l-4.762 16.666H6.667a1 1 0 1 0 0 2H20a1 1 0 1 0 0-2h-5.34L19.42 7.667h5.912a1 1 0 1 0 0-2h-6.691",
    clipRule: "evenodd"
  })));
};
var TextItalic32 = (/* unused pure expression or super */ null && (SvgTextItalic32));

var _path$1d;
function _extends$1e() { _extends$1e = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1e.apply(this, arguments); }
var SvgTextItalic48 = function SvgTextItalic48(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1e({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none"
  }, props), _path$1d || (_path$1d = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M27.97 8.8H18a1.2 1.2 0 0 0 0 2.4h8.41l-7.315 25.6H10a1.2 1.2 0 0 0 0 2.4h20a1.2 1.2 0 1 0 0-2.4h-8.41l7.315-25.6H38a1.2 1.2 0 1 0 0-2.4H27.97",
    clipRule: "evenodd"
  })));
};
var TextItalic48 = (/* unused pure expression or super */ null && (SvgTextItalic48));

var TextItalicIcon = function TextItalicIcon(props) {
  var textItalic = {
    12: TextItalic12,
    16: TextItalic16,
    18: TextItalic18,
    24: TextItalic24,
    32: TextItalic32,
    48: TextItalic48
  };
  return jsx(IconTemplate, _assign({
    icons: textItalic
  }, props));
};

var _path$1c;
function _extends$1d() { _extends$1d = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1d.apply(this, arguments); }
var SvgTextUnderline12 = function SvgTextUnderline12(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1d({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none"
  }, props), _path$1c || (_path$1c = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M3 1.9a.6.6 0 0 1 .6.6V6a2.4 2.4 0 1 0 4.8 0V2.5a.6.6 0 0 1 1.2 0V6a3.6 3.6 0 1 1-7.2 0V2.5a.6.6 0 0 1 .6-.6m-.6 8.6a.6.6 0 0 1 .6-.6h6a.6.6 0 1 1 0 1.2H3a.6.6 0 0 1-.6-.6",
    clipRule: "evenodd"
  })));
};
var TextUnderline12 = (/* unused pure expression or super */ null && (SvgTextUnderline12));

var _path$1b;
function _extends$1c() { _extends$1c = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1c.apply(this, arguments); }
var SvgTextUnderline16 = function SvgTextUnderline16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1c({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path$1b || (_path$1b = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M4 2.583a.75.75 0 0 1 .75.75V8a3.25 3.25 0 0 0 6.5 0V3.333a.75.75 0 0 1 1.5 0V8a4.75 4.75 0 1 1-9.5 0V3.333a.75.75 0 0 1 .75-.75M3.25 14a.75.75 0 0 1 .75-.75h8a.75.75 0 0 1 0 1.5H4a.75.75 0 0 1-.75-.75",
    clipRule: "evenodd"
  })));
};
var TextUnderline16 = (/* unused pure expression or super */ null && (SvgTextUnderline16));

var _path$1a;
function _extends$1b() { _extends$1b = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1b.apply(this, arguments); }
var SvgTextUnderline18 = function SvgTextUnderline18(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1b({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _path$1a || (_path$1a = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M4.5 2.95a.8.8 0 0 1 .8.8V9a3.7 3.7 0 1 0 7.4 0V3.75a.8.8 0 1 1 1.6 0V9A5.3 5.3 0 1 1 3.7 9V3.75a.8.8 0 0 1 .8-.8m-.8 12.8a.8.8 0 0 1 .8-.8h9a.8.8 0 1 1 0 1.6h-9a.8.8 0 0 1-.8-.8",
    clipRule: "evenodd"
  })));
};
var TextUnderline18 = (/* unused pure expression or super */ null && (SvgTextUnderline18));

var _path$19;
function _extends$1a() { _extends$1a = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1a.apply(this, arguments); }
var SvgTextUnderline24 = function SvgTextUnderline24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1a({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path$19 || (_path$19 = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M6 4.1a.9.9 0 0 1 .9.9v7a5.1 5.1 0 0 0 10.2 0V5a.9.9 0 1 1 1.8 0v7a6.9 6.9 0 1 1-13.8 0V5a.9.9 0 0 1 .9-.9M5.1 21a.9.9 0 0 1 .9-.9h12a.9.9 0 0 1 0 1.8H6a.9.9 0 0 1-.9-.9",
    clipRule: "evenodd"
  })));
};
var TextUnderline24 = (/* unused pure expression or super */ null && (SvgTextUnderline24));

var _path$18;
function _extends$19() { _extends$19 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$19.apply(this, arguments); }
var SvgTextUnderline32 = function SvgTextUnderline32(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$19({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _path$18 || (_path$18 = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M8 5.667a1 1 0 0 1 1 1V16a7 7 0 1 0 14 0V6.667a1 1 0 1 1 2 0V16a9 9 0 0 1-18 0V6.667a1 1 0 0 1 1-1M7 28a1 1 0 0 1 1-1h16a1 1 0 1 1 0 2H8a1 1 0 0 1-1-1",
    clipRule: "evenodd"
  })));
};
var TextUnderline32 = (/* unused pure expression or super */ null && (SvgTextUnderline32));

var _path$17;
function _extends$18() { _extends$18 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$18.apply(this, arguments); }
var SvgTextUnderline48 = function SvgTextUnderline48(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$18({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none"
  }, props), _path$17 || (_path$17 = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M12 8.8a1.2 1.2 0 0 1 1.2 1.2v14c0 5.965 4.835 10.8 10.8 10.8S34.8 29.965 34.8 24V10a1.2 1.2 0 0 1 2.4 0v14c0 7.29-5.91 13.2-13.2 13.2S10.8 31.29 10.8 24V10A1.2 1.2 0 0 1 12 8.8M10.8 42a1.2 1.2 0 0 1 1.2-1.2h24a1.2 1.2 0 1 1 0 2.4H12a1.2 1.2 0 0 1-1.2-1.2",
    clipRule: "evenodd"
  })));
};
var TextUnderline48 = (/* unused pure expression or super */ null && (SvgTextUnderline48));

var TextUnderlineIcon = function TextUnderlineIcon(props) {
  var textUnderline = {
    12: TextUnderline12,
    16: TextUnderline16,
    18: TextUnderline18,
    24: TextUnderline24,
    32: TextUnderline32,
    48: TextUnderline48
  };
  return jsx(IconTemplate, _assign({
    icons: textUnderline
  }, props));
};

var _g, _defs;
function _extends$17() { _extends$17 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$17.apply(this, arguments); }
var SvgThumbsUp12 = function SvgThumbsUp12(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$17({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#2F3438",
    fillRule: "evenodd",
    clipPath: "url(#thumbsUp_12_svg__a)",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.158 2.125a.3.3 0 0 0-.254.135L4.17 4.832a.9.9 0 0 0-.153.5v4.531H8.4a.91.91 0 0 0 .894-.732l.551-2.865a.903.903 0 0 0-.894-1.068H8.1c-1.212 0-2.089-1.146-1.759-2.3l.111-.388a.303.303 0 0 0-.294-.385m-1.264-.53a1.52 1.52 0 0 1 1.264-.67c1.008 0 1.736.952 1.462 1.911l-.111.389a.61.61 0 0 0 .59.773h.852c1.332 0 2.335 1.198 2.086 2.492l-.55 2.866A2.12 2.12 0 0 1 8.4 11.063H2.803V5.331c0-.415.124-.82.357-1.165z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.138 6.225v3.65h.606v-3.65zm-.203-1.2c-.558 0-1.01.448-1.01 1v4.05c0 .552.452 1 1.01 1h2.023v-6.05z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "thumbsUp_12_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h12v12H0z"
  })))));
};
var ThumbsUp12 = (/* unused pure expression or super */ null && (SvgThumbsUp12));

var _path$16, _path2$n;
function _extends$16() { _extends$16 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$16.apply(this, arguments); }
var SvgThumbsUp16 = function SvgThumbsUp16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$16({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path$16 || (_path$16 = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M8.213 2.84a.41.41 0 0 0-.34.18L5.561 6.45a1.2 1.2 0 0 0-.203.665v6.043h5.844a1.21 1.21 0 0 0 1.192-.976l.735-3.821a1.204 1.204 0 0 0-1.192-1.424h-1.135c-1.617 0-2.785-1.528-2.345-3.066l.148-.518a.404.404 0 0 0-.392-.513m-1.686-.708a2.03 2.03 0 0 1 1.686-.892c1.343 0 2.314 1.27 1.949 2.548l-.148.518a.812.812 0 0 0 .788 1.03h1.135c1.775 0 3.113 1.598 2.781 3.324l-.734 3.82a2.82 2.82 0 0 1-2.782 2.278H3.74V7.115c0-.553.165-1.093.475-1.553z",
    clipRule: "evenodd"
  })), _path2$n || (_path2$n = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M2.849 7.811v5.349h.88V7.811zm-.27-1.6a1.34 1.34 0 0 0-1.348 1.333v5.883a1.34 1.34 0 0 0 1.348 1.333h2.769V6.211z",
    clipRule: "evenodd"
  })));
};
var ThumbsUp16 = (/* unused pure expression or super */ null && (SvgThumbsUp16));

var _path$15, _path2$m;
function _extends$15() { _extends$15 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$15.apply(this, arguments); }
var SvgThumbsUp18 = function SvgThumbsUp18(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$15({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _path$15 || (_path$15 = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M9.339 3.096a.56.56 0 0 0-.466.247L6.272 7.2c-.16.238-.246.518-.246.804v6.899h6.676c.704 0 1.309-.495 1.44-1.18l.827-4.298a1.455 1.455 0 0 0-1.44-1.72h-1.277c-1.752 0-3.018-1.656-2.541-3.323l.166-.582a.555.555 0 0 0-.538-.705m-1.812-.64a2.18 2.18 0 0 1 1.812-.96c1.444 0 2.488 1.366 2.095 2.74l-.166.582a1.014 1.014 0 0 0 .984 1.287h1.276c1.935 0 3.391 1.74 3.03 3.62l-.826 4.298a3.075 3.075 0 0 1-3.03 2.48H4.408V8.006c0-.602.18-1.19.518-1.691z",
    clipRule: "evenodd"
  })), _path2$m || (_path2$m = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M3.005 8.589v6.307H4.39V8.59zm-.101-1.6c-.838 0-1.517.672-1.517 1.5v6.507c0 .829.68 1.5 1.517 1.5h3.104V6.99z",
    clipRule: "evenodd"
  })));
};
var ThumbsUp18 = (/* unused pure expression or super */ null && (SvgThumbsUp18));

var _path$14, _path2$l;
function _extends$14() { _extends$14 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$14.apply(this, arguments); }
var SvgThumbsUp24 = function SvgThumbsUp24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$14({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path$14 || (_path$14 = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M12.367 3.96a.92.92 0 0 0-.761.403L8.138 9.507c-.233.345-.357.75-.357 1.165v9.365h9.07c1.02 0 1.896-.717 2.087-1.708l1.101-5.732c.25-1.294-.754-2.492-2.086-2.492h-1.702c-2.223 0-3.83-2.102-3.226-4.217l.222-.777a.907.907 0 0 0-.88-1.151m-2.276-.596a2.74 2.74 0 0 1 2.276-1.204c1.814 0 3.125 1.715 2.632 3.44l-.222.777c-.277.967.458 1.928 1.474 1.928h1.702c2.474 0 4.336 2.225 3.875 4.628l-1.102 5.732c-.354 1.84-1.98 3.172-3.874 3.172H5.962V10.672c0-.77.23-1.523.662-2.163z",
    clipRule: "evenodd"
  })), _path2$l || (_path2$l = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M5.93 11.117H4.125a.2.2 0 0 0-.202.2v8.523c0 .11.09.2.202.2h1.807zm-1.806-1.8a2.01 2.01 0 0 0-2.022 2v8.523c0 1.105.905 2 2.022 2h3.627V9.317z",
    clipRule: "evenodd"
  })));
};
var ThumbsUp24 = (/* unused pure expression or super */ null && (SvgThumbsUp24));

var _path$13, _path2$k;
function _extends$13() { _extends$13 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$13.apply(this, arguments); }
var SvgThumbsUp32 = function SvgThumbsUp32(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$13({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _path$13 || (_path$13 = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M16.59 5.075c-.475 0-.919.235-1.183.626l-4.624 6.86a2.98 2.98 0 0 0-.509 1.663v12.687H22.57a3.025 3.025 0 0 0 2.98-2.44l1.469-7.642c.355-1.849-1.078-3.56-2.98-3.56h-2.27c-2.83 0-4.877-2.676-4.106-5.37l.296-1.035c.257-.898-.425-1.789-1.369-1.789m-2.865-.483a3.46 3.46 0 0 1 2.865-1.517c2.285 0 3.937 2.16 3.315 4.333l-.296 1.036c-.406 1.417.671 2.824 2.16 2.824h2.27c3.17 0 5.559 2.853 4.967 5.934l-1.47 7.642c-.453 2.36-2.538 4.067-4.966 4.067H8.252V14.224c0-.987.295-1.952.849-2.773z",
    clipRule: "evenodd"
  })), _path2$k || (_path2$k = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M8.413 14.417H5.6a.67.67 0 0 0-.674.667v11.174a.67.67 0 0 0 .674.667h2.813zm-2.813-2c-1.489 0-2.696 1.194-2.696 2.667v11.174c0 1.473 1.207 2.667 2.696 2.667h4.836V12.417z",
    clipRule: "evenodd"
  })));
};
var ThumbsUp32 = (/* unused pure expression or super */ null && (SvgThumbsUp32));

var _path$12, _path2$j;
function _extends$12() { _extends$12 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$12.apply(this, arguments); }
var SvgThumbsUp48 = function SvgThumbsUp48(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$12({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none"
  }, props), _path$12 || (_path$12 = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M25.29 7.323c-.814 0-1.575.403-2.027 1.073l-6.936 10.289a4.76 4.76 0 0 0-.815 2.663v19.329H34.26c2.331 0 4.333-1.64 4.769-3.904L41.23 25.31c.568-2.957-1.724-5.696-4.768-5.696h-3.405c-4.044 0-6.968-3.823-5.867-7.672l.444-1.553c.44-1.538-.729-3.066-2.345-3.066m-4.046-.258a4.88 4.88 0 0 1 4.046-2.142c3.226 0 5.558 3.05 4.68 6.119l-.444 1.553c-.663 2.317 1.097 4.619 3.532 4.619h3.405c4.566 0 8.005 4.108 7.152 8.544l-2.203 11.463c-.653 3.397-3.656 5.856-7.153 5.856H13.085v-21.73c0-1.42.426-2.81 1.223-3.993z",
    clipRule: "evenodd"
  })), _path2$j || (_path2$j = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M13.126 21.037H8.299a1.61 1.61 0 0 0-1.618 1.6v16.436c0 .884.725 1.6 1.618 1.6h4.827zm-4.827-2.4c-2.233 0-4.044 1.79-4.044 4v16.436c0 2.21 1.81 4 4.044 4h7.253V18.637z",
    clipRule: "evenodd"
  })));
};
var ThumbsUp48 = (/* unused pure expression or super */ null && (SvgThumbsUp48));

var ThumbsUpIcon = function ThumbsUpIcon(props) {
  var thumbsUp = {
    12: ThumbsUp12,
    16: ThumbsUp16,
    18: ThumbsUp18,
    24: ThumbsUp24,
    32: ThumbsUp32,
    48: ThumbsUp48
  };
  return jsx(IconTemplate, _assign({
    icons: thumbsUp
  }, props));
};

var _path$11, _path2$i;
function _extends$11() { _extends$11 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$11.apply(this, arguments); }
var SvgTag12 = function SvgTag12(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$11({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none"
  }, props), _path$11 || (_path$11 = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M1.44 6.44A1.5 1.5 0 0 1 1 5.378V2.5A1.5 1.5 0 0 1 2.5 1h2.879a1.5 1.5 0 0 1 1.06.44l3.5 3.5a1.5 1.5 0 0 1 0 2.12L7.061 9.94a1.5 1.5 0 0 1-2.122 0zM2.2 2.5v2.879a.3.3 0 0 0 .088.212l3.5 3.5a.3.3 0 0 0 .424 0l2.879-2.879a.3.3 0 0 0 0-.424l-3.5-3.5a.3.3 0 0 0-.212-.088H2.5a.3.3 0 0 0-.3.3",
    clipRule: "evenodd"
  })), _path2$i || (_path2$i = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M4.5 3.75a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0"
  })));
};
var Tag12 = (/* unused pure expression or super */ null && (SvgTag12));

var _path$10, _path2$h;
function _extends$10() { _extends$10 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$10.apply(this, arguments); }
var SvgTag16 = function SvgTag16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$10({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path$10 || (_path$10 = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M2.834 3.332V7.17a.5.5 0 0 0 .146.354l4.667 4.667a.5.5 0 0 0 .707 0l3.838-3.839a.5.5 0 0 0 0-.707L7.525 2.978a.5.5 0 0 0-.353-.146H3.333a.5.5 0 0 0-.5.5m-.915 5.252a2 2 0 0 1-.586-1.414V3.332a2 2 0 0 1 2-2h3.839a2 2 0 0 1 1.414.586l4.667 4.666a2 2 0 0 1 0 2.829L9.414 13.25a2 2 0 0 1-2.828 0z",
    clipRule: "evenodd"
  })), _path2$h || (_path2$h = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M6 5a1 1 0 1 1-2 0 1 1 0 0 1 2 0"
  })));
};
var Tag16 = (/* unused pure expression or super */ null && (SvgTag16));

var _path$$, _path2$g;
function _extends$$() { _extends$$ = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$$.apply(this, arguments); }
var SvgTag18 = function SvgTag18(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$$({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _path$$ || (_path$$ = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M3.1 3.75v4.318a.65.65 0 0 0 .19.46l5.25 5.25a.65.65 0 0 0 .92 0l4.318-4.318a.65.65 0 0 0 0-.92l-5.25-5.25a.65.65 0 0 0-.46-.19H3.75a.65.65 0 0 0-.65.65M1.5 8.068V3.75A2.25 2.25 0 0 1 3.75 1.5h4.318a2.25 2.25 0 0 1 1.591.659l5.25 5.25a2.25 2.25 0 0 1 0 3.182l-4.318 4.318a2.25 2.25 0 0 1-3.182 0l-5.25-5.25A2.25 2.25 0 0 1 1.5 8.068",
    clipRule: "evenodd"
  })), _path2$g || (_path2$g = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M6.75 5.625a1.125 1.125 0 1 1-2.25 0 1.125 1.125 0 0 1 2.25 0"
  })));
};
var Tag18 = (/* unused pure expression or super */ null && (SvgTag18));

var _path$_, _path2$f;
function _extends$_() { _extends$_ = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$_.apply(this, arguments); }
var SvgTag24 = function SvgTag24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$_({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path$_ || (_path$_ = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M3.8 5v5.757c0 .319.126.624.351.849l7 7a1.2 1.2 0 0 0 1.697 0l5.758-5.758a1.2 1.2 0 0 0 0-1.697l-7-7a1.2 1.2 0 0 0-.849-.351H5A1.2 1.2 0 0 0 3.8 5m9.079-2.121 7 7a3 3 0 0 1 0 4.242L14.12 19.88a3 3 0 0 1-4.242 0l-7-7A3 3 0 0 1 2 10.757V5a3 3 0 0 1 3-3h5.757a3 3 0 0 1 2.122.879",
    clipRule: "evenodd"
  })), _path2$f || (_path2$f = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M8.5 7a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0"
  })));
};
var Tag24 = (/* unused pure expression or super */ null && (SvgTag24));

var _path$Z, _path2$e;
function _extends$Z() { _extends$Z = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$Z.apply(this, arguments); }
var SvgTag32 = function SvgTag32(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$Z({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _path$Z || (_path$Z = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M4.667 6.668v7.676a2 2 0 0 0 .585 1.415l9.334 9.333a2 2 0 0 0 2.828 0l7.676-7.676a2 2 0 0 0 0-2.829l-9.333-9.333a2 2 0 0 0-1.414-.586H6.667a2 2 0 0 0-2 2m-2 7.676V6.668a4 4 0 0 1 4-4h7.676a4 4 0 0 1 2.828 1.172l9.334 9.333a4 4 0 0 1 0 5.657l-7.677 7.676a4 4 0 0 1-5.657 0l-9.333-9.333a4 4 0 0 1-1.171-2.829",
    clipRule: "evenodd"
  })), _path2$e || (_path2$e = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M11 9a2 2 0 1 1-4 0 2 2 0 0 1 4 0"
  })));
};
var Tag32 = (/* unused pure expression or super */ null && (SvgTag32));

var _path$Y, _path2$d;
function _extends$Y() { _extends$Y = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$Y.apply(this, arguments); }
var SvgTag48 = function SvgTag48(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$Y({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none"
  }, props), _path$Y || (_path$Y = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M6.4 10v11.515a3.6 3.6 0 0 0 1.054 2.545l14 14a3.6 3.6 0 0 0 5.092 0L38.06 26.546a3.6 3.6 0 0 0 0-5.092l-14-14A3.6 3.6 0 0 0 21.515 6.4H10A3.6 3.6 0 0 0 6.4 10M4 21.515V10a6 6 0 0 1 6-6h11.515a6 6 0 0 1 4.242 1.757l14 14a6 6 0 0 1 0 8.486L28.243 39.757a6 6 0 0 1-8.486 0l-14-14A6 6 0 0 1 4 21.515",
    clipRule: "evenodd"
  })), _path2$d || (_path2$d = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M15.5 12.5a3 3 0 1 1-6 0 3 3 0 0 1 6 0"
  })));
};
var Tag48 = (/* unused pure expression or super */ null && (SvgTag48));

var TagIcon = function TagIcon(props) {
  var tag = {
    12: Tag12,
    16: Tag16,
    18: Tag18,
    24: Tag24,
    32: Tag32,
    48: Tag48
  };
  return jsx(IconTemplate, _assign({
    icons: tag
  }, props));
};

var _path$X;
function _extends$X() { _extends$X = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$X.apply(this, arguments); }
var SvgTruck12 = function SvgTruck12(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$X({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none"
  }, props), _path$X || (_path$X = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M1.4 3A1.6 1.6 0 0 1 3 1.4h3.333a1.6 1.6 0 0 1 1.578 1.333h.05A2.1 2.1 0 0 1 9.84 3.894l.538 1.076a2.1 2.1 0 0 1 .222.94v1.756a1.6 1.6 0 0 1-1.498 1.597 1.334 1.334 0 0 1-2.649.004H5.102a1.334 1.334 0 0 1-2.656-.1 1.6 1.6 0 0 1-1.046-1.5zm7.207 5.066H9a.4.4 0 0 0 .4-.4v-.91H7.95v1.033c.246.031.471.13.657.277m-1.124 1.2a.333.333 0 1 0 .59-.31.333.333 0 0 0-.59.31M4.11 9.111a.333.333 0 1 0-.667 0 .333.333 0 0 0 .667 0m2.622-1.044V3a.4.4 0 0 0-.4-.4H3a.4.4 0 0 0-.4.4v4.667a.4.4 0 0 0 .352.397c.227-.18.514-.286.826-.286.313 0 .601.108.829.289zm2.594-2.512-.022-.048-.538-1.076a.9.9 0 0 0-.805-.498H7.95v1.622z"
  })));
};
var Truck12 = (/* unused pure expression or super */ null && (SvgTruck12));

var _path$W;
function _extends$W() { _extends$W = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$W.apply(this, arguments); }
var SvgTruck16 = function SvgTruck16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$W({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path$W || (_path$W = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M1.25 3.667c0-.967.784-1.75 1.75-1.75h7.333c.967 0 1.75.783 1.75 1.75v.25h.299a1.75 1.75 0 0 1 1.565.967l1.285 2.57c.121.243.185.51.185.782v3.43a1.75 1.75 0 0 1-1.75 1.75h-.39a2.084 2.084 0 0 1-3.888 0H7.278a2.084 2.084 0 0 1-3.889 0H3a1.75 1.75 0 0 1-1.75-1.75zM12.083 7.25h1.37l-.848-1.695a.25.25 0 0 0-.223-.138h-.299zm0 1.5v1.973a2.1 2.1 0 0 1 1.195 1.194h.389a.25.25 0 0 0 .25-.25V8.75zm-1.5-5.083a.25.25 0 0 0-.25-.25H3a.25.25 0 0 0-.25.25v8c0 .138.112.25.25.25h.39a2.084 2.084 0 0 1 3.888 0h2.111a2.1 2.1 0 0 1 1.194-1.194V3.665m-5.25 8.416a.583.583 0 1 0 0 1.167.583.583 0 0 0 0-1.167m6 0a.583.583 0 1 0 0 1.167.583.583 0 0 0 0-1.167"
  })));
};
var Truck16 = (/* unused pure expression or super */ null && (SvgTruck16));

var _path$V;
function _extends$V() { _extends$V = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$V.apply(this, arguments); }
var SvgTruck18 = function SvgTruck18(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$V({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _path$V || (_path$V = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M1.45 4.125c0-1.063.862-1.925 1.925-1.925h8.25c1.063 0 1.925.862 1.925 1.925v.325h.38c.729 0 1.395.412 1.721 1.064l1.446 2.89c.133.268.203.563.203.862v3.859a1.925 1.925 0 0 1-1.925 1.925h-.468a2.3 2.3 0 0 1-4.314 0H8.157a2.3 2.3 0 0 1-4.314 0h-.468a1.925 1.925 0 0 1-1.925-1.925zm12.1 1.925V8.2h1.656l-.986-1.97a.33.33 0 0 0-.29-.18zm2.15 7.075V9.8h-2.15v2.293c.627.232 1.124.73 1.357 1.357h.468c.18 0 .325-.146.325-.325M11.625 3.8h-8.25a.325.325 0 0 0-.325.325v9c0 .18.145.325.325.325h.468a2.3 2.3 0 0 1 4.314 0h2.436a2.3 2.3 0 0 1 1.357-1.357V4.125a.325.325 0 0 0-.325-.325M6 13.55a.7.7 0 1 0 0 1.4.7.7 0 0 0 0-1.4m6.75 0a.7.7 0 1 0 0 1.4.7.7 0 0 0 0-1.4"
  })));
};
var Truck18 = (/* unused pure expression or super */ null && (SvgTruck18));

var _path$U;
function _extends$U() { _extends$U = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$U.apply(this, arguments); }
var SvgTruck24 = function SvgTruck24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$U({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path$U || (_path$U = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M2.1 5.5a2.4 2.4 0 0 1 2.4-2.4h11a2.4 2.4 0 0 1 2.4 2.4v.6h.673a2.4 2.4 0 0 1 2.147 1.327l1.927 3.854c.166.333.253.7.253 1.073V17.5a2.4 2.4 0 0 1-2.4 2.4h-.742a2.901 2.901 0 0 1-5.516 0h-3.484a2.901 2.901 0 0 1-5.516 0H4.5a2.4 2.4 0 0 1-2.4-2.4zm15.8 2.4v3.2h2.644L19.11 8.232a.6.6 0 0 0-.537-.332zm3.2 9.6v-4.6h-3.2v3.342c.878.287 1.571.98 1.858 1.858h.742a.6.6 0 0 0 .6-.6M15.5 4.9h-11a.6.6 0 0 0-.6.6v12a.6.6 0 0 0 .6.6h.742a2.901 2.901 0 0 1 5.516 0h3.484a2.9 2.9 0 0 1 1.858-1.858V5.5a.6.6 0 0 0-.6-.6m1.5 13a1.1 1.1 0 1 0 0 2.2 1.1 1.1 0 0 0 0-2.2M6.9 19a1.099 1.099 0 1 0 2.2 0 1.099 1.099 0 0 0-1.733-.9c-.282.2-.467.528-.467.9"
  })));
};
var Truck24 = (/* unused pure expression or super */ null && (SvgTruck24));

var _path$T;
function _extends$T() { _extends$T = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$T.apply(this, arguments); }
var SvgTruck32 = function SvgTruck32(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$T({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _path$T || (_path$T = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M3 7.333a3 3 0 0 1 3-3h14.667a3 3 0 0 1 3 3v1h1.097a3 3 0 0 1 2.683 1.659l2.57 5.138a3 3 0 0 1 .316 1.342v6.861a3 3 0 0 1-3 3h-1.138a3.668 3.668 0 0 1-7.057 0h-4.943a3.668 3.668 0 0 1-7.057 0H6a3 3 0 0 1-3-3zm20.667 3V15h4.048l-2.057-4.114a1 1 0 0 0-.894-.553zm-1 13.334a1.667 1.667 0 1 0 0 3.333 1.667 1.667 0 0 0 0-3.333m-12 0A1.664 1.664 0 0 0 9 25.333a1.664 1.664 0 0 0 3 1c.21-.278.333-.624.333-1a1.664 1.664 0 0 0-1.667-1.667M6 6.333a1 1 0 0 0-1 1v16a1 1 0 0 0 1 1h1.138a3.668 3.668 0 0 1 7.057 0h4.943a3.67 3.67 0 0 1 2.529-2.528V7.333a1 1 0 0 0-1-1zM23.667 17v4.805a3.67 3.67 0 0 1 2.528 2.528h1.138a1 1 0 0 0 1-1V17z"
  })));
};
var Truck32 = (/* unused pure expression or super */ null && (SvgTruck32));

var _path$S;
function _extends$S() { _extends$S = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$S.apply(this, arguments); }
var SvgTruck48 = function SvgTruck48(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$S({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none"
  }, props), _path$S || (_path$S = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M9 6.8A4.2 4.2 0 0 0 4.8 11v24A4.2 4.2 0 0 0 9 39.2h1.94a5.202 5.202 0 0 0 10.12 0h7.88a5.202 5.202 0 0 0 10.12 0H41a4.2 4.2 0 0 0 4.2-4.2V24.708a4.2 4.2 0 0 0-.443-1.878l-3.854-7.708a4.2 4.2 0 0 0-3.757-2.322H35.2V11A4.2 4.2 0 0 0 31 6.8zm30.06 30a5.21 5.21 0 0 0-3.86-3.86V25.2h7.6V35a1.8 1.8 0 0 1-1.8 1.8zm-6.26-3.86a5.21 5.21 0 0 0-3.86 3.86h-7.88a5.202 5.202 0 0 0-10.12 0H9A1.8 1.8 0 0 1 7.2 35V11A1.8 1.8 0 0 1 9 9.2h22a1.8 1.8 0 0 1 1.8 1.8zm2.4-17.74h1.946a1.8 1.8 0 0 1 1.61.995l3.302 6.605H35.2zM16 35.2a2.8 2.8 0 1 1 0 5.6 2.8 2.8 0 0 1 0-5.6M31.2 38a2.8 2.8 0 1 1 5.6 0 2.8 2.8 0 0 1-5.6 0"
  })));
};
var Truck48 = (/* unused pure expression or super */ null && (SvgTruck48));

var TruckIcon = function TruckIcon(props) {
  var truck = {
    12: Truck12,
    16: Truck16,
    18: Truck18,
    24: Truck24,
    32: Truck32,
    48: Truck48
  };
  return jsx(IconTemplate, _assign({
    icons: truck
  }, props));
};

var _path$R;
function _extends$R() { _extends$R = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$R.apply(this, arguments); }
var SvgTruckFilled12 = function SvgTruckFilled12(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$R({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none"
  }, props), _path$R || (_path$R = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M3 1.4A1.6 1.6 0 0 0 1.4 3v4.667a1.6 1.6 0 0 0 1.046 1.5 1.333 1.333 0 0 0 2.656.1h1.351a1.334 1.334 0 0 0 2.65-.004A1.6 1.6 0 0 0 10.6 7.666V5.91a2.1 2.1 0 0 0-.222-.939l-.61-1.222a1.84 1.84 0 0 0-1.855-1.003A1.6 1.6 0 0 0 6.333 1.4zm6.327 4.155H7.933V3.963a.635.635 0 0 1 .76.322l.612 1.222z",
    clipRule: "evenodd"
  })));
};
var TruckFilled12 = (/* unused pure expression or super */ null && (SvgTruckFilled12));

var _path$Q;
function _extends$Q() { _extends$Q = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$Q.apply(this, arguments); }
var SvgTruckFilled16 = function SvgTruckFilled16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$Q({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path$Q || (_path$Q = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M1.25 3.667c0-.967.784-1.75 1.75-1.75h6.6c.966 0 1.75.783 1.75 1.75v.4h.52c.511 0 .979.289 1.207.746l1.38 2.76c.094.188.143.395.143.604v3.74a1.35 1.35 0 0 1-1.27 1.347 2.084 2.084 0 0 1-3.941.152H7.498a.8.8 0 0 1-.21-.029 2.084 2.084 0 0 1-3.899.03H3a1.75 1.75 0 0 1-1.75-1.75zM13.33 8l-1.326-2.65a.15.15 0 0 0-.134-.083h-.52V8zM4.75 12.703a.583.583 0 1 0 .058-.292 1 1 0 0 0-.058.292m5.999-.036a.583.583 0 1 1 1.167 0 .583.583 0 0 1-1.167 0",
    clipRule: "evenodd"
  })));
};
var TruckFilled16 = (/* unused pure expression or super */ null && (SvgTruckFilled16));

var _path$P;
function _extends$P() { _extends$P = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$P.apply(this, arguments); }
var SvgTruckFilled18 = function SvgTruckFilled18(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$P({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _path$P || (_path$P = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M1.45 4a1.8 1.8 0 0 1 1.8-1.8H11A1.8 1.8 0 0 1 12.8 4v.45h.457a1.8 1.8 0 0 1 1.61.995l1.493 2.986c.125.25.19.526.19.805v4.014a1.8 1.8 0 0 1-1.64 1.793 2.301 2.301 0 0 1-4.317.007H8.157a2.301 2.301 0 0 1-4.314 0H3.25a1.8 1.8 0 0 1-1.8-1.8zm13.406 5-1.42-2.84a.2.2 0 0 0-.18-.11H12.8V9zM5.3 14.25a.7.7 0 1 1 1.4 0 .7.7 0 0 1-1.4 0m6.75 0a.7.7 0 1 1 1.4 0 .7.7 0 0 1-1.4 0",
    clipRule: "evenodd"
  })));
};
var TruckFilled18 = (/* unused pure expression or super */ null && (SvgTruckFilled18));

var _path$O;
function _extends$O() { _extends$O = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$O.apply(this, arguments); }
var SvgTruckFilled24 = function SvgTruckFilled24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$O({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path$O || (_path$O = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M2.35 5.5A2.15 2.15 0 0 1 4.5 3.35h11a2.15 2.15 0 0 1 2.15 2.15v.601a2.4 2.4 0 0 1 2.07 1.326l1.927 3.854c.166.333.253.7.253 1.073V17.5a2.4 2.4 0 0 1-2.138 2.386 2.901 2.901 0 0 1-5.589-.236h-3.346a2.901 2.901 0 0 1-5.654 0H4.5a2.15 2.15 0 0 1-2.15-2.15zM19.994 12 18.11 8.232a.6.6 0 0 0-.46-.327V12zM6.9 19a1.1 1.1 0 1 1 2.2 0 1.1 1.1 0 0 1-2.2 0m9 0a1.1 1.1 0 1 1 2.2 0 1.1 1.1 0 0 1-2.2 0",
    clipRule: "evenodd"
  })));
};
var TruckFilled24 = (/* unused pure expression or super */ null && (SvgTruckFilled24));

var _path$N;
function _extends$N() { _extends$N = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$N.apply(this, arguments); }
var SvgTruckFilled32 = function SvgTruckFilled32(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$N({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _path$N || (_path$N = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M3.133 7.333A2.867 2.867 0 0 1 6 4.467h14.667a2.867 2.867 0 0 1 2.866 2.866v1.002a3 3 0 0 1 2.58 1.657l2.57 5.139A3 3 0 0 1 29 16.472v6.861a3 3 0 0 1-2.803 2.994 3.668 3.668 0 0 1-7.094-.127H14.23a3.668 3.668 0 0 1-7.127 0H6a2.867 2.867 0 0 1-2.867-2.866zM26.882 16l-2.557-5.114a1 1 0 0 0-.792-.547V16zM9 25.334a1.667 1.667 0 1 1 3.333 0 1.667 1.667 0 0 1-3.333 0m12 0a1.667 1.667 0 1 1 3.333 0 1.667 1.667 0 0 1-3.333 0",
    clipRule: "evenodd"
  })));
};
var TruckFilled32 = (/* unused pure expression or super */ null && (SvgTruckFilled32));

var _path$M;
function _extends$M() { _extends$M = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$M.apply(this, arguments); }
var SvgTruckFilled48 = function SvgTruckFilled48(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$M({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none"
  }, props), _path$M || (_path$M = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M9 6.7A4.3 4.3 0 0 0 4.7 11v24A4.3 4.3 0 0 0 9 39.3h1.964a5.202 5.202 0 0 0 10.072 0h7.928a5.202 5.202 0 0 0 10.097-.1H40a4.19 4.19 0 0 0 2.94-1.2H43v-.06A4.19 4.19 0 0 0 44.2 35V24.708a4.2 4.2 0 0 0-.443-1.878l-3.854-7.708a4.2 4.2 0 0 0-3.757-2.322H35.3V11A4.3 4.3 0 0 0 31 6.7zm32.61 17.203q.023.048.045.097H35.3v-8.8h.846a1.8 1.8 0 0 1 1.61.995zM16 35.2a2.8 2.8 0 1 0 0 5.6 2.8 2.8 0 0 0 0-5.6m18 0a2.8 2.8 0 1 0 0 5.6 2.8 2.8 0 0 0 0-5.6",
    clipRule: "evenodd"
  })));
};
var TruckFilled48 = (/* unused pure expression or super */ null && (SvgTruckFilled48));

var TruckFilledIcon = function TruckFilledIcon(props) {
  var truckFilled = {
    12: TruckFilled12,
    16: TruckFilled16,
    18: TruckFilled18,
    24: TruckFilled24,
    32: TruckFilled32,
    48: TruckFilled48
  };
  return jsx(IconTemplate, _assign({
    icons: truckFilled
  }, props));
};

var _path$L;
function _extends$L() { _extends$L = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$L.apply(this, arguments); }
var SvgUndo12 = function SvgUndo12(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$L({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none"
  }, props), _path$L || (_path$L = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M4.424 1.576a.6.6 0 0 1 0 .848L2.95 3.9H7.5a3.1 3.1 0 1 1 0 6.2H6.25a.6.6 0 0 1 0-1.2H7.5a1.9 1.9 0 0 0 0-3.8H2.95l1.475 1.476a.6.6 0 1 1-.848.848L1.429 5.278a1.1 1.1 0 0 1 0-1.556l2.147-2.146a.6.6 0 0 1 .848 0",
    clipRule: "evenodd"
  })));
};
var Undo12 = (/* unused pure expression or super */ null && (SvgUndo12));

var _path$K;
function _extends$K() { _extends$K = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$K.apply(this, arguments); }
var SvgUndo16 = function SvgUndo16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$K({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path$K || (_path$K = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M5.864 2.136a.75.75 0 0 1 0 1.061L3.81 5.25H10a4.083 4.083 0 0 1 0 8.167H8.333a.75.75 0 1 1 0-1.5H10a2.583 2.583 0 1 0 0-5.167H3.81l2.054 2.053a.75.75 0 1 1-1.061 1.06L1.941 7.003a1.417 1.417 0 0 1 0-2.004l2.862-2.862a.75.75 0 0 1 1.06 0",
    clipRule: "evenodd"
  })));
};
var Undo16 = (/* unused pure expression or super */ null && (SvgUndo16));

var _path$J;
function _extends$J() { _extends$J = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$J.apply(this, arguments); }
var SvgUndo18 = function SvgUndo18(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$J({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _path$J || (_path$J = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M6.566 2.434a.8.8 0 0 1 0 1.132L4.18 5.95h7.07a4.55 4.55 0 0 1 0 9.1H9.374a.8.8 0 0 1 0-1.6h1.875a2.95 2.95 0 0 0 0-5.9H4.181l2.385 2.384a.8.8 0 1 1-1.132 1.132l-3.22-3.22a1.55 1.55 0 0 1 0-2.192l3.22-3.22a.8.8 0 0 1 1.132 0",
    clipRule: "evenodd"
  })));
};
var Undo18 = (/* unused pure expression or super */ null && (SvgUndo18));

var _path$I;
function _extends$I() { _extends$I = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$I.apply(this, arguments); }
var SvgUndo24 = function SvgUndo24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$I({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path$I || (_path$I = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M8.636 3.364a.9.9 0 0 1 0 1.272L5.173 8.1H15a5.9 5.9 0 1 1 0 11.8h-2.5a.9.9 0 0 1 0-1.8H15a4.1 4.1 0 1 0 0-8.2H5.173l3.463 3.464a.9.9 0 0 1-1.272 1.272L3.07 10.345a1.9 1.9 0 0 1 0-2.687l4.293-4.293a.9.9 0 0 1 1.272 0",
    clipRule: "evenodd"
  })));
};
var Undo24 = (/* unused pure expression or super */ null && (SvgUndo24));

var _path$H;
function _extends$H() { _extends$H = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$H.apply(this, arguments); }
var SvgUndo32 = function SvgUndo32(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$H({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _path$H || (_path$H = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M11.374 4.626a1 1 0 0 1 0 1.414L6.414 11H20a7.667 7.667 0 0 1 0 15.333h-3.333a1 1 0 0 1 0-2H20A5.667 5.667 0 0 0 20 13H6.414l4.96 4.96a1 1 0 1 1-1.414 1.414L4.236 13.65a2.333 2.333 0 0 1 0-3.3L9.96 4.626a1 1 0 0 1 1.414 0",
    clipRule: "evenodd"
  })));
};
var Undo32 = (/* unused pure expression or super */ null && (SvgUndo32));

var _path$G;
function _extends$G() { _extends$G = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$G.apply(this, arguments); }
var SvgUndo48 = function SvgUndo48(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$G({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none"
  }, props), _path$G || (_path$G = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M16.849 7.152a1.2 1.2 0 0 1 0 1.697L8.897 16.8H30c6.186 0 11.2 5.014 11.2 11.2S36.186 39.2 30 39.2h-5a1.2 1.2 0 0 1 0-2.4h5a8.8 8.8 0 1 0 0-17.6H8.897l7.952 7.951a1.2 1.2 0 0 1-1.697 1.698l-8.586-8.586a3.2 3.2 0 0 1 0-4.526l8.586-8.585a1.2 1.2 0 0 1 1.697 0",
    clipRule: "evenodd"
  })));
};
var Undo48 = (/* unused pure expression or super */ null && (SvgUndo48));

var UndoIcon = function UndoIcon(props) {
  var undo = {
    12: Undo12,
    16: Undo16,
    18: Undo18,
    24: Undo24,
    32: Undo32,
    48: Undo48
  };
  return jsx(IconTemplate, _assign({
    icons: undo
  }, props));
};

var _path$F, _path2$c;
function _extends$F() { _extends$F = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$F.apply(this, arguments); }
var SvgUpload12 = function SvgUpload12(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$F({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none"
  }, props), _path$F || (_path$F = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M6 4a.7.7 0 0 1 .7.7v.6h.6a.7.7 0 1 1 0 1.4h-.6v.6a.7.7 0 1 1-1.4 0v-.6h-.6a.7.7 0 1 1 0-1.4h.6v-.6A.7.7 0 0 1 6 4"
  })), _path2$c || (_path2$c = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M3.5 1.5a2 2 0 0 0-2 2v5a2 2 0 0 0 2 2h5a2 2 0 0 0 2-2v-5a2 2 0 0 0-2-2zm5 1.4h-5a.6.6 0 0 0-.6.6v5a.6.6 0 0 0 .6.6h5a.6.6 0 0 0 .6-.6v-5a.6.6 0 0 0-.6-.6",
    clipRule: "evenodd"
  })));
};
var Upload12 = (/* unused pure expression or super */ null && (SvgUpload12));

var _path$E, _path2$b;
function _extends$E() { _extends$E = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$E.apply(this, arguments); }
var SvgUpload16 = function SvgUpload16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$E({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path$E || (_path$E = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M8 5.333a.8.8 0 0 1 .8.8V7.2h1.067a.8.8 0 0 1 0 1.6H8.8v1.067a.8.8 0 0 1-1.6 0V8.8H6.133a.8.8 0 0 1 0-1.6H7.2V6.133a.8.8 0 0 1 .8-.8"
  })), _path2$b || (_path2$b = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M4.667 2A2.667 2.667 0 0 0 2 4.667v6.666A2.667 2.667 0 0 0 4.667 14h6.666A2.667 2.667 0 0 0 14 11.333V4.667A2.667 2.667 0 0 0 11.333 2zm6.666 1.6H4.667c-.59 0-1.067.478-1.067 1.067v6.666c0 .59.478 1.067 1.067 1.067h6.666c.59 0 1.067-.478 1.067-1.067V4.667c0-.59-.478-1.067-1.067-1.067",
    clipRule: "evenodd"
  })));
};
var Upload16 = (/* unused pure expression or super */ null && (SvgUpload16));

var _path$D, _path2$a;
function _extends$D() { _extends$D = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$D.apply(this, arguments); }
var SvgUpload18 = function SvgUpload18(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$D({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _path$D || (_path$D = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M9 6a.8.8 0 0 1 .8.8v1.4h1.4a.8.8 0 0 1 0 1.6H9.8v1.4a.8.8 0 0 1-1.6 0V9.8H6.8a.8.8 0 1 1 0-1.6h1.4V6.8A.8.8 0 0 1 9 6"
  })), _path2$a || (_path2$a = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M5.25 2.25a3 3 0 0 0-3 3v7.5a3 3 0 0 0 3 3h7.5a3 3 0 0 0 3-3v-7.5a3 3 0 0 0-3-3zm7.5 1.6h-7.5a1.4 1.4 0 0 0-1.4 1.4v7.5a1.4 1.4 0 0 0 1.4 1.4h7.5a1.4 1.4 0 0 0 1.4-1.4v-7.5a1.4 1.4 0 0 0-1.4-1.4",
    clipRule: "evenodd"
  })));
};
var Upload18 = (/* unused pure expression or super */ null && (SvgUpload18));

var _path$C, _path2$9;
function _extends$C() { _extends$C = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$C.apply(this, arguments); }
var SvgUpload24 = function SvgUpload24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$C({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path$C || (_path$C = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M12.2 8a.9.9 0 0 1 .9.9v2.2h2a.9.9 0 0 1 0 1.8h-2v2.2a.9.9 0 0 1-1.8 0v-2.2H8.9a.9.9 0 1 1 0-1.8h2.4V8.9a.9.9 0 0 1 .9-.9"
  })), _path2$9 || (_path2$9 = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M7 3a4 4 0 0 0-4 4v10a4 4 0 0 0 4 4h10a4 4 0 0 0 4-4V7a4 4 0 0 0-4-4zm10 1.8H7A2.2 2.2 0 0 0 4.8 7v10A2.2 2.2 0 0 0 7 19.2h10a2.2 2.2 0 0 0 2.2-2.2V7A2.2 2.2 0 0 0 17 4.8",
    clipRule: "evenodd"
  })));
};
var Upload24 = (/* unused pure expression or super */ null && (SvgUpload24));

var _path$B, _path2$8;
function _extends$B() { _extends$B = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$B.apply(this, arguments); }
var SvgUpload32 = function SvgUpload32(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$B({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _path$B || (_path$B = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M16 10.667a1 1 0 0 1 1 1V15h3.333a1 1 0 1 1 0 2H17v3.333a1 1 0 1 1-2 0V17h-3.333a1 1 0 0 1 0-2H15v-3.333a1 1 0 0 1 1-1"
  })), _path2$8 || (_path2$8 = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M9.333 4A5.333 5.333 0 0 0 4 9.333v13.334A5.333 5.333 0 0 0 9.333 28h13.334A5.333 5.333 0 0 0 28 22.667V9.333A5.333 5.333 0 0 0 22.667 4zm13.334 2H9.333A3.333 3.333 0 0 0 6 9.333v13.334A3.333 3.333 0 0 0 9.333 26h13.334A3.333 3.333 0 0 0 26 22.667V9.333A3.333 3.333 0 0 0 22.667 6",
    clipRule: "evenodd"
  })));
};
var Upload32 = (/* unused pure expression or super */ null && (SvgUpload32));

var _path$A, _path2$7, _path3;
function _extends$A() { _extends$A = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$A.apply(this, arguments); }
var SvgUpload48 = function SvgUpload48(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$A({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none"
  }, props), _path$A || (_path$A = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M34 8.4H14A5.6 5.6 0 0 0 8.4 14v20a5.6 5.6 0 0 0 5.6 5.6h20a5.6 5.6 0 0 0 5.6-5.6V14A5.6 5.6 0 0 0 34 8.4M14 6a8 8 0 0 0-8 8v20a8 8 0 0 0 8 8h20a8 8 0 0 0 8-8V14a8 8 0 0 0-8-8z",
    clipRule: "evenodd"
  })), _path2$7 || (_path2$7 = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M24 16a1.2 1.2 0 0 1 1.2 1.2v13.6a1.2 1.2 0 0 1-2.4 0V17.2A1.2 1.2 0 0 1 24 16",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M32 24a1.2 1.2 0 0 1-1.2 1.2H17.2a1.2 1.2 0 0 1 0-2.4h13.6A1.2 1.2 0 0 1 32 24",
    clipRule: "evenodd"
  })));
};
var Upload48 = (/* unused pure expression or super */ null && (SvgUpload48));

var UploadIcon = function UploadIcon(props) {
  var upload = {
    12: Upload12,
    16: Upload16,
    18: Upload18,
    24: Upload24,
    32: Upload32,
    48: Upload48
  };
  return jsx(IconTemplate, _assign({
    icons: upload
  }, props));
};

var _path$z;
function _extends$z() { _extends$z = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$z.apply(this, arguments); }
var SvgViewListFilled12 = function SvgViewListFilled12(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$z({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none"
  }, props), _path$z || (_path$z = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M1.5 3A1.5 1.5 0 0 1 3 1.5h6A1.5 1.5 0 0 1 10.5 3v1A1.5 1.5 0 0 1 9 5.5H3A1.5 1.5 0 0 1 1.5 4zM1.5 8A1.5 1.5 0 0 1 3 6.5h6A1.5 1.5 0 0 1 10.5 8v1A1.5 1.5 0 0 1 9 10.5H3A1.5 1.5 0 0 1 1.5 9z"
  })));
};
var ViewListFilled12 = (/* unused pure expression or super */ null && (SvgViewListFilled12));

var _path$y;
function _extends$y() { _extends$y = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$y.apply(this, arguments); }
var SvgViewListFilled16 = function SvgViewListFilled16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$y({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path$y || (_path$y = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M2 4a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v1.333a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2zM2 10.667a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2V12a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2z"
  })));
};
var ViewListFilled16 = (/* unused pure expression or super */ null && (SvgViewListFilled16));

var _path$x;
function _extends$x() { _extends$x = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$x.apply(this, arguments); }
var SvgViewListFilled18 = function SvgViewListFilled18(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$x({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _path$x || (_path$x = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M2.25 4.5A2.25 2.25 0 0 1 4.5 2.25h9a2.25 2.25 0 0 1 2.25 2.25V6a2.25 2.25 0 0 1-2.25 2.25h-9A2.25 2.25 0 0 1 2.25 6zM2.25 12A2.25 2.25 0 0 1 4.5 9.75h9A2.25 2.25 0 0 1 15.75 12v1.5a2.25 2.25 0 0 1-2.25 2.25h-9a2.25 2.25 0 0 1-2.25-2.25z"
  })));
};
var ViewListFilled18 = (/* unused pure expression or super */ null && (SvgViewListFilled18));

var _path$w;
function _extends$w() { _extends$w = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$w.apply(this, arguments); }
var SvgViewListFilled24 = function SvgViewListFilled24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$w({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path$w || (_path$w = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M3 6a3 3 0 0 1 3-3h12a3 3 0 0 1 3 3v2a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3zM3 16a3 3 0 0 1 3-3h12a3 3 0 0 1 3 3v2a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3z"
  })));
};
var ViewListFilled24 = (/* unused pure expression or super */ null && (SvgViewListFilled24));

var _path$v;
function _extends$v() { _extends$v = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$v.apply(this, arguments); }
var SvgViewListFilled32 = function SvgViewListFilled32(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$v({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _path$v || (_path$v = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M4 8a4 4 0 0 1 4-4h16a4 4 0 0 1 4 4v2.667a4 4 0 0 1-4 4H8a4 4 0 0 1-4-4zM4 21.333a4 4 0 0 1 4-4h16a4 4 0 0 1 4 4V24a4 4 0 0 1-4 4H8a4 4 0 0 1-4-4z"
  })));
};
var ViewListFilled32 = (/* unused pure expression or super */ null && (SvgViewListFilled32));

var _path$u;
function _extends$u() { _extends$u = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$u.apply(this, arguments); }
var SvgViewListFilled48 = function SvgViewListFilled48(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$u({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none"
  }, props), _path$u || (_path$u = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M6 12a6 6 0 0 1 6-6h24a6 6 0 0 1 6 6v4a6 6 0 0 1-6 6H12a6 6 0 0 1-6-6zM6 32a6 6 0 0 1 6-6h24a6 6 0 0 1 6 6v4a6 6 0 0 1-6 6H12a6 6 0 0 1-6-6z"
  })));
};
var ViewListFilled48 = (/* unused pure expression or super */ null && (SvgViewListFilled48));

var ViewListFilledIcon = function ViewListFilledIcon(props) {
  var viewListFilled = {
    12: ViewListFilled12,
    16: ViewListFilled16,
    18: ViewListFilled18,
    24: ViewListFilled24,
    32: ViewListFilled32,
    48: ViewListFilled48
  };
  return jsx(IconTemplate, _assign({
    icons: viewListFilled
  }, props));
};

var _path$t;
function _extends$t() { _extends$t = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$t.apply(this, arguments); }
var SvgViewThumbnailFilled12 = function SvgViewThumbnailFilled12(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$t({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none"
  }, props), _path$t || (_path$t = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M1.5 2.5a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1zM1.5 7.5a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1zM6.5 2.5a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1zM6.5 7.5a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1z"
  })));
};
var ViewThumbnailFilled12 = (/* unused pure expression or super */ null && (SvgViewThumbnailFilled12));

var _path$s;
function _extends$s() { _extends$s = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$s.apply(this, arguments); }
var SvgViewThumbnailFilled16 = function SvgViewThumbnailFilled16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$s({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path$s || (_path$s = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M2 3.3A1.3 1.3 0 0 1 3.3 2h2.9a1.3 1.3 0 0 1 1.3 1.3v2.9a1.3 1.3 0 0 1-1.3 1.3H3.3A1.3 1.3 0 0 1 2 6.2zM2 9.8a1.3 1.3 0 0 1 1.3-1.3h2.9a1.3 1.3 0 0 1 1.3 1.3v2.9A1.3 1.3 0 0 1 6.2 14H3.3A1.3 1.3 0 0 1 2 12.7zM8.5 3.3A1.3 1.3 0 0 1 9.8 2h2.9A1.3 1.3 0 0 1 14 3.3v2.9a1.3 1.3 0 0 1-1.3 1.3H9.8a1.3 1.3 0 0 1-1.3-1.3zM8.5 9.8a1.3 1.3 0 0 1 1.3-1.3h2.9A1.3 1.3 0 0 1 14 9.8v2.9a1.3 1.3 0 0 1-1.3 1.3H9.8a1.3 1.3 0 0 1-1.3-1.3z"
  })));
};
var ViewThumbnailFilled16 = (/* unused pure expression or super */ null && (SvgViewThumbnailFilled16));

var _path$r;
function _extends$r() { _extends$r = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$r.apply(this, arguments); }
var SvgViewThumbnailFilled18 = function SvgViewThumbnailFilled18(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$r({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _path$r || (_path$r = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M2.25 3.75a1.5 1.5 0 0 1 1.5-1.5h3a1.5 1.5 0 0 1 1.5 1.5v3a1.5 1.5 0 0 1-1.5 1.5h-3a1.5 1.5 0 0 1-1.5-1.5zM2.25 11.25a1.5 1.5 0 0 1 1.5-1.5h3a1.5 1.5 0 0 1 1.5 1.5v3a1.5 1.5 0 0 1-1.5 1.5h-3a1.5 1.5 0 0 1-1.5-1.5zM9.75 3.75a1.5 1.5 0 0 1 1.5-1.5h3a1.5 1.5 0 0 1 1.5 1.5v3a1.5 1.5 0 0 1-1.5 1.5h-3a1.5 1.5 0 0 1-1.5-1.5zM9.75 11.25a1.5 1.5 0 0 1 1.5-1.5h3a1.5 1.5 0 0 1 1.5 1.5v3a1.5 1.5 0 0 1-1.5 1.5h-3a1.5 1.5 0 0 1-1.5-1.5z"
  })));
};
var ViewThumbnailFilled18 = (/* unused pure expression or super */ null && (SvgViewThumbnailFilled18));

var _path$q;
function _extends$q() { _extends$q = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$q.apply(this, arguments); }
var SvgViewThumbnailFilled24 = function SvgViewThumbnailFilled24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$q({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path$q || (_path$q = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M3 5a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2zM3 15a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2zM13 5a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2h-4a2 2 0 0 1-2-2zM13 15a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2h-4a2 2 0 0 1-2-2z"
  })));
};
var ViewThumbnailFilled24 = (/* unused pure expression or super */ null && (SvgViewThumbnailFilled24));

var _path$p;
function _extends$p() { _extends$p = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$p.apply(this, arguments); }
var SvgViewThumbnailFilled32 = function SvgViewThumbnailFilled32(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$p({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _path$p || (_path$p = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M4 7a3 3 0 0 1 3-3h4.6a3 3 0 0 1 3 3v4.6a3 3 0 0 1-3 3H7a3 3 0 0 1-3-3zM4 20.4a3 3 0 0 1 3-3h4.6a3 3 0 0 1 3 3V25a3 3 0 0 1-3 3H7a3 3 0 0 1-3-3zM17.4 7a3 3 0 0 1 3-3H25a3 3 0 0 1 3 3v4.6a3 3 0 0 1-3 3h-4.6a3 3 0 0 1-3-3zM17.4 20.4a3 3 0 0 1 3-3H25a3 3 0 0 1 3 3V25a3 3 0 0 1-3 3h-4.6a3 3 0 0 1-3-3z"
  })));
};
var ViewThumbnailFilled32 = (/* unused pure expression or super */ null && (SvgViewThumbnailFilled32));

var _path$o;
function _extends$o() { _extends$o = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$o.apply(this, arguments); }
var SvgViewThumbnailFilled48 = function SvgViewThumbnailFilled48(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$o({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none"
  }, props), _path$o || (_path$o = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M6 10a4 4 0 0 1 4-4h8a4 4 0 0 1 4 4v8a4 4 0 0 1-4 4h-8a4 4 0 0 1-4-4zM6 30a4 4 0 0 1 4-4h8a4 4 0 0 1 4 4v8a4 4 0 0 1-4 4h-8a4 4 0 0 1-4-4zM26 10a4 4 0 0 1 4-4h8a4 4 0 0 1 4 4v8a4 4 0 0 1-4 4h-8a4 4 0 0 1-4-4zM26 30a4 4 0 0 1 4-4h8a4 4 0 0 1 4 4v8a4 4 0 0 1-4 4h-8a4 4 0 0 1-4-4z"
  })));
};
var ViewThumbnailFilled48 = (/* unused pure expression or super */ null && (SvgViewThumbnailFilled48));

var ViewThumbnailFilledIcon = function ViewThumbnailFilledIcon(props) {
  var viewThumbnailFilled = {
    12: ViewThumbnailFilled12,
    16: ViewThumbnailFilled16,
    18: ViewThumbnailFilled18,
    24: ViewThumbnailFilled24,
    32: ViewThumbnailFilled32,
    48: ViewThumbnailFilled48
  };
  return jsx(IconTemplate, _assign({
    icons: viewThumbnailFilled
  }, props));
};

var _path$n;
function _extends$n() { _extends$n = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$n.apply(this, arguments); }
var SvgWon12 = function SvgWon12(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$n({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none"
  }, props), _path$n || (_path$n = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M1.87 1.914a.6.6 0 0 1 .716.456l.673 3.03h1.482l.673-3.03a.6.6 0 0 1 1.172 0l.673 3.03h1.482l.673-3.03a.6.6 0 0 1 1.172.26L9.97 5.4H11a.6.6 0 1 1 0 1.2H9.703l-.63 2.834c-.255 1.148-1.892 1.148-2.147 0L6.296 6.6h-.593l-.63 2.834c-.255 1.148-1.892 1.148-2.147 0L2.296 6.6H1a.6.6 0 0 1 0-1.2h1.03l-.616-2.77a.6.6 0 0 1 .456-.716M3.526 6.6 4 8.734 4.474 6.6zM5.97 5.4h.06L6 5.266zm1.556 1.2L8 8.734 8.474 6.6z",
    clipRule: "evenodd"
  })));
};
var Won12 = (/* unused pure expression or super */ null && (SvgWon12));

var _path$m;
function _extends$m() { _extends$m = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$m.apply(this, arguments); }
var SvgWon16 = function SvgWon16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$m({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path$m || (_path$m = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M2.504 2.601a.75.75 0 0 1 .895.57l.906 4.08h2.056l.907-4.08a.75.75 0 0 1 1.464 0l.907 4.08h2.056l.906-4.08a.75.75 0 0 1 1.464.325l-.834 3.754h1.436a.75.75 0 0 1 0 1.5h-1.77l-.848 3.818c-.328 1.479-2.437 1.479-2.765 0L8.435 8.75h-.87l-.849 3.818c-.329 1.479-2.437 1.479-2.766 0L3.102 8.75H1.333a.75.75 0 0 1 0-1.5H2.77l-.835-3.754a.75.75 0 0 1 .57-.895m2.135 6.15.694 3.125.695-3.126zm3.259-1.5h.204L8 6.79zm2.074 1.5.695 3.125.694-3.126z",
    clipRule: "evenodd"
  })));
};
var Won16 = (/* unused pure expression or super */ null && (SvgWon16));

var _path$l;
function _extends$l() { _extends$l = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$l.apply(this, arguments); }
var SvgWon18 = function SvgWon18(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$l({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _path$l || (_path$l = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M2.826 2.969a.8.8 0 0 1 .955.607L4.808 8.2h2.384l1.027-4.624a.8.8 0 0 1 1.562 0L10.808 8.2h2.383l1.028-4.624a.8.8 0 1 1 1.562.347L14.83 8.2H16.5a.8.8 0 0 1 0 1.6h-2.025l-.962 4.329c-.36 1.618-2.666 1.618-3.026 0l-.962-4.33h-1.05l-.962 4.33c-.36 1.618-2.667 1.618-3.026 0l-.962-4.33H1.5a.8.8 0 1 1 0-1.6h1.67l-.951-4.276a.8.8 0 0 1 .607-.954m2.338 6.83L6 13.563 6.836 9.8zM8.83 8.2h.338L9 7.439zm2.333 1.6L12 13.563l.836-3.762z",
    clipRule: "evenodd"
  })));
};
var Won18 = (/* unused pure expression or super */ null && (SvgWon18));

var _path$k, _path2$6;
function _extends$k() { _extends$k = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$k.apply(this, arguments); }
var SvgWon24 = function SvgWon24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$k({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path$k || (_path$k = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M1.1 12a.9.9 0 0 1 .9-.9h20a.9.9 0 0 1 0 1.8H2a.9.9 0 0 1-.9-.9",
    clipRule: "evenodd"
  })), _path2$6 || (_path2$6 = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M3.805 4.121a.9.9 0 0 1 1.074.684l3.023 13.607q.012.043.018.049l.01.01a.12.12 0 0 0 .07.02.12.12 0 0 0 .07-.02l.01-.01a.2.2 0 0 0 .018-.049L11.12 4.805a.9.9 0 0 1 1.758 0l3.024 13.607q.01.043.017.049l.01.01a.12.12 0 0 0 .07.02c.037 0 .06-.012.07-.02l.01-.01a.2.2 0 0 0 .018-.049l3.024-13.607a.9.9 0 0 1 1.757.39l-3.024 13.607c-.441 1.984-3.269 1.984-3.71 0L12 9.15l-2.145 9.653c-.441 1.984-3.269 1.984-3.71 0L3.122 5.195a.9.9 0 0 1 .683-1.074",
    clipRule: "evenodd"
  })));
};
var Won24 = (/* unused pure expression or super */ null && (SvgWon24));

var _path$j, _path2$5;
function _extends$j() { _extends$j = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$j.apply(this, arguments); }
var SvgWon32 = function SvgWon32(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$j({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _path$j || (_path$j = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M1.667 16a1 1 0 0 1 1-1h26.666a1 1 0 1 1 0 2H2.667a1 1 0 0 1-1-1",
    clipRule: "evenodd"
  })), _path2$5 || (_path2$5 = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M5.117 3.69a1 1 0 0 1 1.193.76l4.357 19.607L15.024 4.45a1 1 0 0 1 1.952 0l4.358 19.607L25.69 4.45a1 1 0 0 1 1.952.434L23.286 24.49c-.464 2.088-3.44 2.088-3.905 0l-3.38-15.215-3.382 15.215c-.464 2.088-3.44 2.088-3.905 0L4.357 4.884a1 1 0 0 1 .76-1.193",
    clipRule: "evenodd"
  })));
};
var Won32 = (/* unused pure expression or super */ null && (SvgWon32));

var _path$i;
function _extends$i() { _extends$i = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$i.apply(this, arguments); }
var SvgWon48 = function SvgWon48(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$i({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none"
  }, props), _path$i || (_path$i = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M9.171 6.74a1.2 1.2 0 1 0-2.342.52l3.453 15.54H4a1.2 1.2 0 0 0 0 2.4h6.815l3.037 13.668c.51 2.296 3.785 2.296 4.296 0L21.185 25.2h5.63l3.037 13.668c.51 2.296 3.785 2.296 4.296 0L37.185 25.2H44a1.2 1.2 0 0 0 0-2.4h-6.282l3.453-15.54a1.2 1.2 0 0 0-2.342-.52l-3.57 16.06H28.74L25.172 6.74a1.2 1.2 0 0 0-2.343 0l-3.57 16.06H12.74zm4.103 18.46L16 37.468 18.726 25.2zm8.444-2.4h4.564L24 12.532zm7.556 2.4L32 37.468 34.726 25.2z",
    clipRule: "evenodd"
  })));
};
var Won48 = (/* unused pure expression or super */ null && (SvgWon48));

var WonIcon = function WonIcon(props) {
  var won = {
    12: Won12,
    16: Won16,
    18: Won18,
    24: Won24,
    32: Won32,
    48: Won48
  };
  return jsx(IconTemplate, _assign({
    icons: won
  }, props));
};

var _path$h;
function _extends$h() { _extends$h = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$h.apply(this, arguments); }
var SvgWrite12 = function SvgWrite12(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$h({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none"
  }, props), _path$h || (_path$h = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M3.2 9.3h.303L9.15 3.65a.214.214 0 1 0-.302-.303L3.2 8.997zM2 10V8.707a.5.5 0 0 1 .146-.354L8 2.5a1.414 1.414 0 1 1 2 2l-5.854 5.854a.5.5 0 0 1-.353.146H2.5A.5.5 0 0 1 2 10",
    clipRule: "evenodd"
  })));
};
var Write12 = (/* unused pure expression or super */ null && (SvgWrite12));

var _path$g, _path2$4;
function _extends$g() { _extends$g = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$g.apply(this, arguments); }
var SvgWrite16 = function SvgWrite16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$g({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path$g || (_path$g = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M4.167 12.5h.545l7.56-7.56a.386.386 0 0 0-.545-.546l-7.56 7.56zm-1.5.833V11.61c0-.176.07-.346.195-.471l7.804-7.805A1.886 1.886 0 0 1 13.333 6l-7.805 7.805a.67.67 0 0 1-.471.195H3.333a.667.667 0 0 1-.667-.667",
    clipRule: "evenodd"
  })), _path2$4 || (_path2$4 = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "m11.47 7.197-2-2 1.06-1.06 2 2z",
    clipRule: "evenodd"
  })));
};
var Write16 = (/* unused pure expression or super */ null && (SvgWrite16));

var _path$f, _path2$3;
function _extends$f() { _extends$f = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$f.apply(this, arguments); }
var SvgWrite18 = function SvgWrite18(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$f({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _path$f || (_path$f = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M4.6 14.15h.737l8.532-8.531L15 6.75l-8.707 8.707a1 1 0 0 1-.707.293H4a1 1 0 0 1-1-1v-1.586a1 1 0 0 1 .293-.707L12 3.75a2.121 2.121 0 0 1 3 3l-1.131-1.131a.521.521 0 0 0-.738-.738L4.6 13.413z",
    clipRule: "evenodd"
  })), _path2$3 || (_path2$3 = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "m12.934 8.066-2.25-2.25 1.132-1.132 2.25 2.25z",
    clipRule: "evenodd"
  })));
};
var Write18 = (/* unused pure expression or super */ null && (SvgWrite18));

var _path$e, _path2$2;
function _extends$e() { _extends$e = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$e.apply(this, arguments); }
var SvgWrite24 = function SvgWrite24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$e({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path$e || (_path$e = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M5.8 19.2h1.454L18.727 7.727a1.028 1.028 0 0 0-1.454-1.454L5.8 17.746zM4 20v-2.586a1 1 0 0 1 .293-.707L16 5a2.828 2.828 0 1 1 4 4L8.293 20.707a1 1 0 0 1-.707.293H5a1 1 0 0 1-1-1",
    clipRule: "evenodd"
  })), _path2$2 || (_path2$2 = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "m17.364 10.637-3-3 1.272-1.273 3 3z",
    clipRule: "evenodd"
  })));
};
var Write24 = (/* unused pure expression or super */ null && (SvgWrite24));

var _path$d, _path2$1;
function _extends$d() { _extends$d = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$d.apply(this, arguments); }
var SvgWrite32 = function SvgWrite32(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$d({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _path$d || (_path$d = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M7.333 23.495V26h2.505l15.414-15.414a1.77 1.77 0 0 0 0-2.505l1.415-1.414a3.77 3.77 0 0 1 0 5.333L11.252 27.414A2 2 0 0 1 9.838 28H7.333a2 2 0 0 1-2-2v-2.505a2 2 0 0 1 .586-1.414L21.333 6.667a3.77 3.77 0 0 1 5.334 0L25.252 8.08a1.77 1.77 0 0 0-2.504 0z",
    clipRule: "evenodd"
  })), _path2$1 || (_path2$1 = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "m23.293 14.04-4-4 1.414-1.414 4 4z",
    clipRule: "evenodd"
  })));
};
var Write32 = (/* unused pure expression or super */ null && (SvgWrite32));

var _path$c, _path2;
function _extends$c() { _extends$c = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$c.apply(this, arguments); }
var SvgWrite48 = function SvgWrite48(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$c({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none"
  }, props), _path$c || (_path$c = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M10.4 35.243V39a.6.6 0 0 0 .6.6h3.757a.6.6 0 0 0 .425-.176l23.12-23.12a3.257 3.257 0 0 0-4.605-4.607L10.576 34.818a.6.6 0 0 0-.176.425M8 39v-3.757a3 3 0 0 1 .879-2.122L32 10.001a5.657 5.657 0 0 1 8 8L16.879 41.12a3 3 0 0 1-2.122.88H11a3 3 0 0 1-3-3",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "m35.152 20.849-6-6 1.697-1.697 6 6z",
    clipRule: "evenodd"
  })));
};
var Write48 = (/* unused pure expression or super */ null && (SvgWrite48));

var WriteIcon = function WriteIcon(props) {
  var write = {
    12: Write12,
    16: Write16,
    18: Write18,
    24: Write24,
    32: Write32,
    48: Write48
  };
  return jsx(IconTemplate, _assign({
    icons: write
  }, props));
};

var _path$b;
function _extends$b() { _extends$b = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$b.apply(this, arguments); }
var SvgWriteFilled12 = function SvgWriteFilled12(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$b({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none"
  }, props), _path$b || (_path$b = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M2 10.25V8.603a.25.25 0 0 1 .073-.176l4.594-4.594a.5.5 0 0 1 .707 0l1.293 1.293a.5.5 0 0 1 0 .707l-4.594 4.594a.25.25 0 0 1-.177.073H2.25a.25.25 0 0 1-.25-.25m7.126-5.583a.5.5 0 0 0 .707 0l.813-.814a.5.5 0 0 0 0-.707L9.354 1.853a.5.5 0 0 0-.708 0l-.813.814a.5.5 0 0 0 0 .707z"
  })));
};
var WriteFilled12 = (/* unused pure expression or super */ null && (SvgWriteFilled12));

var _path$a;
function _extends$a() { _extends$a = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$a.apply(this, arguments); }
var SvgWriteFilled16 = function SvgWriteFilled16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$a({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path$a || (_path$a = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M2.667 13.667V11.47c0-.088.035-.173.097-.235L8.89 5.11c.26-.26.682-.26.943 0l1.724 1.724c.26.26.26.682 0 .943L5.43 13.902a.33.33 0 0 1-.236.098H3a.333.333 0 0 1-.333-.333m9.501-7.445c.26.26.683.26.943 0l1.084-1.084a.667.667 0 0 0 0-.943l-1.723-1.724a.667.667 0 0 0-.943 0l-1.084 1.084a.667.667 0 0 0 0 .943z"
  })));
};
var WriteFilled16 = (/* unused pure expression or super */ null && (SvgWriteFilled16));

var _path$9;
function _extends$9() { _extends$9 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$9.apply(this, arguments); }
var SvgWriteFilled18 = function SvgWriteFilled18(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$9({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _path$9 || (_path$9 = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M3 15.375v-2.47c0-.1.04-.195.11-.265L10 5.75a.75.75 0 0 1 1.06 0L13 7.69a.75.75 0 0 1 0 1.06l-6.89 6.89a.38.38 0 0 1-.265.11h-2.47A.375.375 0 0 1 3 15.375M13.69 7a.75.75 0 0 0 1.06 0l1.22-1.22a.75.75 0 0 0 0-1.06l-1.94-1.94a.75.75 0 0 0-1.06 0L11.75 4a.75.75 0 0 0 0 1.06z"
  })));
};
var WriteFilled18 = (/* unused pure expression or super */ null && (SvgWriteFilled18));

var _path$8;
function _extends$8() { _extends$8 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$8.apply(this, arguments); }
var SvgWriteFilled24 = function SvgWriteFilled24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$8({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path$8 || (_path$8 = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M4 20.5v-3.293a.5.5 0 0 1 .146-.353l9.187-9.187a1 1 0 0 1 1.415 0l2.585 2.586a1 1 0 0 1 0 1.414l-9.187 9.187a.5.5 0 0 1-.353.146H4.5a.5.5 0 0 1-.5-.5M18.253 9.333a1 1 0 0 0 1.414 0l1.626-1.626a1 1 0 0 0 0-1.414l-2.586-2.586a1 1 0 0 0-1.414 0l-1.626 1.626a1 1 0 0 0 0 1.415z"
  })));
};
var WriteFilled24 = (/* unused pure expression or super */ null && (SvgWriteFilled24));

var _path$7;
function _extends$7() { _extends$7 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$7.apply(this, arguments); }
var SvgWriteFilled32 = function SvgWriteFilled32(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$7({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _path$7 || (_path$7 = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M5.333 27.333v-4.39c0-.177.07-.347.196-.472l12.249-12.249c.52-.52 1.364-.52 1.885 0l3.448 3.448c.52.52.52 1.365 0 1.886l-12.25 12.249a.67.67 0 0 1-.47.195H6a.667.667 0 0 1-.667-.667m19.004-14.889c.52.521 1.364.521 1.885 0l2.168-2.168c.521-.52.521-1.365 0-1.886l-3.447-3.447a1.333 1.333 0 0 0-1.886 0L20.89 7.11c-.52.52-.52 1.365 0 1.886z"
  })));
};
var WriteFilled32 = (/* unused pure expression or super */ null && (SvgWriteFilled32));

var _path$6;
function _extends$6() { _extends$6 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$6.apply(this, arguments); }
var SvgWriteFilled48 = function SvgWriteFilled48(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$6({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none"
  }, props), _path$6 || (_path$6 = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M8 41v-6.586a1 1 0 0 1 .293-.707l18.374-18.374a2 2 0 0 1 2.828 0l5.172 5.172a2 2 0 0 1 0 2.828L16.293 41.707a1 1 0 0 1-.707.293H9a1 1 0 0 1-1-1m28.505-22.333a2 2 0 0 0 2.828 0l3.253-3.253a2 2 0 0 0 0-2.828l-5.172-5.172a2 2 0 0 0-2.828 0l-3.252 3.252a2 2 0 0 0 0 2.829z"
  })));
};
var WriteFilled48 = (/* unused pure expression or super */ null && (SvgWriteFilled48));

var WriteFilledIcon = function WriteFilledIcon(props) {
  var writeFilled = {
    12: WriteFilled12,
    16: WriteFilled16,
    18: WriteFilled18,
    24: WriteFilled24,
    32: WriteFilled32,
    48: WriteFilled48
  };
  return jsx(IconTemplate, _assign({
    icons: writeFilled
  }, props));
};

var _path$5;
function _extends$5() { _extends$5 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$5.apply(this, arguments); }
var SvgHandler12 = function SvgHandler12(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends$5({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none"
  }, props), _path$5 || (_path$5 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: "#2F3438",
    d: "M4.333 3a1 1 0 1 0 0-2 1 1 0 0 0 0 2M4.333 7a1 1 0 1 0 0-2 1 1 0 0 0 0 2M5.333 10a1 1 0 1 1-2 0 1 1 0 0 1 2 0M7.667 3a1 1 0 1 0 0-2 1 1 0 0 0 0 2M8.667 6a1 1 0 1 1-2 0 1 1 0 0 1 2 0M7.667 11a1 1 0 1 0 0-2 1 1 0 0 0 0 2"
  })));
};
var Handler12 = SvgHandler12;

var _path$4;
function _extends$4() { _extends$4 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$4.apply(this, arguments); }
var SvgHandler16 = function SvgHandler16(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends$4({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path$4 || (_path$4 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: "#2F3438",
    d: "M5.778 4a1.333 1.333 0 1 0 0-2.666 1.333 1.333 0 0 0 0 2.666M5.778 9.334a1.333 1.333 0 1 0 0-2.667 1.333 1.333 0 0 0 0 2.667M7.111 13.334a1.333 1.333 0 1 1-2.667 0 1.333 1.333 0 0 1 2.667 0M10.222 4a1.333 1.333 0 1 0 0-2.666 1.333 1.333 0 0 0 0 2.666M11.555 8A1.333 1.333 0 1 1 8.89 8a1.333 1.333 0 0 1 2.666 0M10.222 14.667a1.333 1.333 0 1 0 0-2.667 1.333 1.333 0 0 0 0 2.667"
  })));
};
var Handler16 = SvgHandler16;

var _path$3;
function _extends$3() { _extends$3 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3.apply(this, arguments); }
var SvgHandler18 = function SvgHandler18(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends$3({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _path$3 || (_path$3 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: "#2F3438",
    d: "M6.5 4.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3M6.5 10.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3M8 15a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0M11.5 4.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3M13 9a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0M11.5 16.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3"
  })));
};
var Handler18 = SvgHandler18;

var _path$2;
function _extends$2() { _extends$2 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2.apply(this, arguments); }
var SvgHandler24 = function SvgHandler24(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends$2({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path$2 || (_path$2 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: "#2F3438",
    d: "M8.667 6a2 2 0 1 0 0-4 2 2 0 0 0 0 4M8.667 14a2 2 0 1 0 0-4 2 2 0 0 0 0 4M10.667 20a2 2 0 1 1-4 0 2 2 0 0 1 4 0M15.333 6a2 2 0 1 0 0-4 2 2 0 0 0 0 4M17.333 12a2 2 0 1 1-4 0 2 2 0 0 1 4 0M15.333 22a2 2 0 1 0 0-4 2 2 0 0 0 0 4"
  })));
};
var Handler24 = SvgHandler24;

var _path$1;
function _extends$1() { _extends$1 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1.apply(this, arguments); }
var SvgHandler32 = function SvgHandler32(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends$1({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _path$1 || (_path$1 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: "#2F3438",
    d: "M11.556 8a2.667 2.667 0 1 0 0-5.333 2.667 2.667 0 0 0 0 5.333M11.556 18.667a2.667 2.667 0 1 0 0-5.334 2.667 2.667 0 0 0 0 5.333M14.222 26.667a2.667 2.667 0 1 1-5.333 0 2.667 2.667 0 0 1 5.333 0M20.445 8a2.667 2.667 0 1 0 0-5.333 2.667 2.667 0 0 0 0 5.333M23.111 16a2.667 2.667 0 1 1-5.333 0 2.667 2.667 0 0 1 5.333 0M20.445 29.333a2.667 2.667 0 1 0 0-5.333 2.667 2.667 0 0 0 0 5.333"
  })));
};
var Handler32 = SvgHandler32;

var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
var SvgHandler48 = function SvgHandler48(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: "#2F3438",
    d: "M17.333 12a4 4 0 1 0 0-8 4 4 0 0 0 0 8M17.333 28a4 4 0 1 0 0-8 4 4 0 0 0 0 8M21.333 40a4 4 0 1 1-8 0 4 4 0 0 1 8 0M30.667 12a4 4 0 1 0 0-8 4 4 0 0 0 0 8M34.667 24a4 4 0 1 1-8 0 4 4 0 0 1 8 0M30.667 44a4 4 0 1 0 0-8 4 4 0 0 0 0 8"
  })));
};
var Handler48 = SvgHandler48;

var HandlerIcon = function HandlerIcon(props) {
  var handler = {
    12: Handler12,
    16: Handler16,
    18: Handler18,
    24: Handler24,
    32: Handler32,
    48: Handler48
  };
  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(IconTemplate, (0,_common_js__WEBPACK_IMPORTED_MODULE_2__.a)({
    icons: handler
  }, props));
};


//# sourceMappingURL=icons.js.map


/***/ }),

/***/ 53700:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ds_": function() { return /* binding */ useSnackbar; },
/* harmony export */   "hOb": function() { return /* binding */ DesignSystemProvider; }
/* harmony export */ });
/* unused harmony exports Avatar, BdsProvider, BoxButton, CautionBox, Chip, CircleBadge, Divider, DotBadge, Empty, HoverInteraction, IconButton, IndicatorDots, Input, PillBadge, SNACKBAR_PLACEMENT, SnackbarContext, SnackbarProvider, SquareBadge, TextButton, dotSize */
/* harmony import */ var _emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(12851);
/* harmony import */ var _common_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(68479);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(83128);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(75271);
/* harmony import */ var _Loading_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(33328);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(57834);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(52814);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(82187);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _bucketplace_lib__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(94834);
/* harmony import */ var _foundation_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(54939);
/* harmony import */ var _emotion_is_prop_valid__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(2366);
/* harmony import */ var _icons_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(62471);
/* harmony import */ var _bucketplace_ui__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(28746);
/* harmony import */ var react_dom__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(30967);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(32699);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_6__);























var placeholderIconSize = {
  18: 12,
  24: 16,
  30: 18,
  40: 24,
  80: 48
};
var Avatar = /*#__PURE__*/(/* unused pure expression or super */ null && (forwardRef(function (_a, ref) {
  var size = _a.size,
    PlaceholderIcon = _a.placeholderIcon,
    src = _a.src,
    className = _a.className,
    rest = __rest(_a, ["size", "placeholderIcon", "src", "className"]);
  return jsx(Container$6, _assign({
    ref: ref
  }, rest, {
    className: className,
    size: size
  }, {
    children: src ? jsx(ResizeImage, {
      src: src,
      alt: "\uC544\uBC14\uD0C0 \uC0AC\uC9C4",
      style: {
        width: '100%',
        height: '100%',
        borderRadius: '50%'
      },
      "aria-label": "avatar"
    }) : jsx(PlaceholderIcon, {
      size: placeholderIconSize[size],
      fill: function fill(theme) {
        return theme.base.neutral500;
      },
      "aria-label": "avatar-placeholder"
    })
  }));
})));
var Container$6 = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("div",  true ? {
  target: "egjvr3j0"
} : 0)(templateObject_1$g || (templateObject_1$g = (0,_common_js__WEBPACK_IMPORTED_MODULE_7__._)(["\n  width: ", "px;\n  height: ", "px;\n  border-radius: 50%;\n  background-color: ", ";\n  display: flex;\n  align-items: center;\n  justify-content: center;\n"], ["\n  width: ", "px;\n  height: ", "px;\n  border-radius: 50%;\n  background-color: ", ";\n  display: flex;\n  align-items: center;\n  justify-content: center;\n"])), function (_a) {
  var size = _a.size;
  return size;
}, function (_a) {
  var size = _a.size;
  return size;
}, function (_a) {
  var theme = _a.theme;
  return theme.base.neutral300;
});
var templateObject_1$g;

/**
 * children에 hover interaction을 적용합니다.
 * children component에 className props가 필요합니다.
 * 타겟이 되는 컴포넌트의 position을 relative로 설정하고, hover interaction을 적용합니다.
 * 만약 relative가 아닌 다른 position을 사용하고 싶다면, HoverInteraction을 한번더 Wrapper로 감싸서 적용해주세요.
 * @param children
 * @param disabled
 * @constructor
 */
var HoverInteraction = function HoverInteraction(_a) {
  var _children = _a.children,
    disabled = _a.disabled;
  var theme = (0,_emotion_react__WEBPACK_IMPORTED_MODULE_8__.u)();
  var childRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
  var _b = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(0),
    borderWidth = _b[0],
    setBorderWidth = _b[1];
  (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function () {
    if (childRef.current && typeof window !== 'undefined') {
      var computedStyle = window.getComputedStyle(childRef.current);
      var border = computedStyle.getPropertyValue('border-width');
      setBorderWidth(parseFloat(border));
    }
  }, []);
  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsx */ .tZ)(_emotion_react__WEBPACK_IMPORTED_MODULE_10__/* .ClassNames */ .ms, {
    children: function children(_a) {
      var css = _a.css;
      return /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_1__.cloneElement)(_children, {
        ref: childRef,
        className: classnames__WEBPACK_IMPORTED_MODULE_2___default()(!disabled && css(templateObject_1$f || (templateObject_1$f = (0,_common_js__WEBPACK_IMPORTED_MODULE_7__._)(["\n              position: relative;\n              @media (hover: hover) or (pointer: fine) {\n                cursor: pointer;\n                &::after {\n                  content: '';\n                  position: absolute;\n                  left: -", ";\n                  top: -", ";\n                  right: -", ";\n                  bottom: -", ";\n                  transition: background-color 0.1s ease-in-out;\n                  border-radius: inherit;\n                  background-color: initial;\n                }\n                &:hover::after {\n                  // TODO \uCEEC\uB7EC ODS \uC801\uC6A9\n                  background-color: ", ";\n                }\n              }\n            "], ["\n              position: relative;\n              @media (hover: hover) or (pointer: fine) {\n                cursor: pointer;\n                &::after {\n                  content: '';\n                  position: absolute;\n                  left: -", ";\n                  top: -", ";\n                  right: -", ";\n                  bottom: -", ";\n                  transition: background-color 0.1s ease-in-out;\n                  border-radius: inherit;\n                  background-color: initial;\n                }\n                &:hover::after {\n                  // TODO \uCEEC\uB7EC ODS \uC801\uC6A9\n                  background-color: ", ";\n                }\n              }\n            "])), (0,_foundation_js__WEBPACK_IMPORTED_MODULE_11__.p)(borderWidth), (0,_foundation_js__WEBPACK_IMPORTED_MODULE_11__.p)(borderWidth), (0,_foundation_js__WEBPACK_IMPORTED_MODULE_11__.p)(borderWidth), (0,_foundation_js__WEBPACK_IMPORTED_MODULE_11__.p)(borderWidth), theme.dim.thin), _children.props.className)
      });
    }
  });
};
var templateObject_1$f;

var getColorTokenProps = function getColorTokenProps(variant, theme) {
  var colorTokens = {
    primary_thin: {
      backgroundColor: theme.primary.lighten,
      textColor: theme.primary.darken,
      borderColor: theme.primary.darken,
      numberColor: theme.primary.darken
    },
    white: {
      backgroundColor: theme.base.neutral0,
      textColor: theme.base.neutral700,
      borderColor: theme.border,
      numberColor: theme.primary.darken
    },
    base5: {
      backgroundColor: theme.base.neutral100,
      textColor: theme.base.neutral700,
      borderColor: theme.base.neutral100,
      numberColor: theme.primary.darken
    },
    base1: {
      backgroundColor: theme.base.neutral600,
      textColor: theme.base.neutral0,
      borderColor: theme.base.neutral600,
      numberColor: theme.primary.darken
    }
  };
  return colorTokens[variant];
};
var Chip = /*#__PURE__*/(/* unused pure expression or super */ null && (forwardRef(function (_a, ref) {
  var text = _a.text,
    number = _a.number,
    variant = _a.variant,
    leftIcon = _a.leftIcon,
    rightIcon = _a.rightIcon,
    className = _a.className,
    restProps = __rest(_a, ["text", "number", "variant", "leftIcon", "rightIcon", "className"]);
  var theme = useTheme();
  return jsx(HoverInteraction, {
    children: jsxs(Container$5, _assign({
      ref: ref
    }, restProps, getColorTokenProps(variant, theme), {
      className: classNames(className, {
        clickable: !!restProps.onClick
      })
    }, {
      children: [leftIcon && /*#__PURE__*/cloneElement(leftIcon, {
        size: 12,
        className: 'left-icon'
      }), text, typeof number === 'number' && jsx("span", _assign({
        className: "chip-number"
      }, {
        children: formatComma(number)
      })), rightIcon && /*#__PURE__*/cloneElement(rightIcon, {
        size: 12,
        className: 'right-icon'
      })]
    }))
  });
})));
var Container$5 = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("span",  true ? {
  target: "e1grob030"
} : 0)(templateObject_2$a || (templateObject_2$a = (0,_common_js__WEBPACK_IMPORTED_MODULE_7__._)(["\n  ", ";\n  position: relative;\n  display: inline-flex;\n  align-items: center;\n  background-color: ", ";\n  color: ", ";\n  border-radius: 50px;\n  box-sizing: border-box;\n  height: 38px;\n  padding: 10px 14px;\n  ", "\n  \n  &::before {\n    content: '';\n    position: absolute;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    border: 1px solid ", ";\n    border-radius: inherit;\n  }\n  \n  &.clickable {\n    cursor: pointer;\n  }\n  \n  .chip-number {\n    color: ", ";\n    margin-left: 2px;\n  }\n  \n  .left-icon {\n    margin-right: 4px;\n  }\n  \n  .right-icon {\n    margin-left: 4px\n  }\n"], ["\n  ", ";\n  position: relative;\n  display: inline-flex;\n  align-items: center;\n  background-color: ", ";\n  color: ", ";\n  border-radius: 50px;\n  box-sizing: border-box;\n  height: 38px;\n  padding: 10px 14px;\n  ", "\n  \n  &::before {\n    content: '';\n    position: absolute;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    border: 1px solid ", ";\n    border-radius: inherit;\n  }\n  \n  &.clickable {\n    cursor: pointer;\n  }\n  \n  .chip-number {\n    color: ", ";\n    margin-left: 2px;\n  }\n  \n  .left-icon {\n    margin-right: 4px;\n  }\n  \n  .right-icon {\n    margin-left: 4px\n  }\n"])), _foundation_js__WEBPACK_IMPORTED_MODULE_11__.F.body14L18, function (_a) {
  var backgroundColor = _a.backgroundColor;
  return backgroundColor;
}, function (_a) {
  var textColor = _a.textColor;
  return textColor;
}, _foundation_js__WEBPACK_IMPORTED_MODULE_11__.M.max('mobile', /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_10__/* .css */ .iv)(templateObject_1$e || (templateObject_1$e = (0,_common_js__WEBPACK_IMPORTED_MODULE_7__._)(["\n    border-radius: 100px;\n    height: 32px;\n    padding: 7px 12px;\n  " + ( true ? "" : 0)], ["\n    border-radius: 100px;\n    height: 32px;\n    padding: 7px 12px;\n  " + ( true ? "" : 0)])))), function (_a) {
  var borderColor = _a.borderColor;
  return borderColor;
}, function (_a) {
  var numberColor = _a.numberColor;
  return numberColor;
});
var templateObject_1$e, templateObject_2$a;

var BadgeBaseContainer = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("span",  true ? {
  target: "e6n7lej1"
} : 0)(templateObject_1$d || (templateObject_1$d = (0,_common_js__WEBPACK_IMPORTED_MODULE_7__._)(["\n  background: ", ";\n  color: ", ";\n  font-weight: 700;\n  letter-spacing: -0.3px;\n\n  display: inline-flex;\n  justify-content: center;\n  align-items: center;\n"], ["\n  background: ", ";\n  color: ", ";\n  font-weight: 700;\n  letter-spacing: -0.3px;\n\n  display: inline-flex;\n  justify-content: center;\n  align-items: center;\n"])), function (_a) {
  var theme = _a.theme;
  return theme.accent.basic;
}, function (_a) {
  var theme = _a.theme;
  return theme.base.neutral0;
});
var CircleBadgeContainer = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(BadgeBaseContainer,  true ? {
  target: "e6n7lej0"
} : 0)(templateObject_4$5 || (templateObject_4$5 = (0,_common_js__WEBPACK_IMPORTED_MODULE_7__._)(["\n  border-radius: 47px;\n  flex-direction: column;\n\n  ", "\n"], ["\n  border-radius: 47px;\n  flex-direction: column;\n\n  ", "\n"])), function (_a) {
  var size = _a.size;
  switch (size) {
    case 16:
      {
        return /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_10__/* .css */ .iv)(templateObject_2$9 || (templateObject_2$9 = (0,_common_js__WEBPACK_IMPORTED_MODULE_7__._)(["\n          ", "\n          height: 16px;\n          padding: 0px 6px;\n        " + ( true ? "" : 0)], ["\n          ", "\n          height: 16px;\n          padding: 0px 6px;\n        " + ( true ? "" : 0)])), _foundation_js__WEBPACK_IMPORTED_MODULE_11__.F.detail10L14);
      }
    case 20:
      {
        return /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_10__/* .css */ .iv)(templateObject_3$6 || (templateObject_3$6 = (0,_common_js__WEBPACK_IMPORTED_MODULE_7__._)(["\n          ", ";\n          height: 20px;\n          padding: 0px 7px;\n        " + ( true ? "" : 0)], ["\n          ", ";\n          height: 20px;\n          padding: 0px 7px;\n        " + ( true ? "" : 0)])), _foundation_js__WEBPACK_IMPORTED_MODULE_11__.F.detail12L16);
      }
  }
});
var templateObject_1$d, templateObject_2$9, templateObject_3$6, templateObject_4$5;

var MAX_VALUE = 99;
var CircleBadge = /*#__PURE__*/(/* unused pure expression or super */ null && (forwardRef(function (props, ref) {
  var size = props.size,
    value = props.value,
    rest = __rest(props, ["size", "value"]);
  return jsx(CircleBadgeContainer, _assign({
    ref: ref
  }, rest, {
    size: size
  }, {
    children: value > MAX_VALUE ? "".concat(MAX_VALUE, "+") : value
  }));
})));

var SquareBadge = function SquareBadge(props) {
  var size = props.size,
    variant = props.variant,
    children = props.children,
    leftIcon = props.leftIcon,
    rightIcon = props.rightIcon,
    className = props.className,
    rest = __rest(props, ["size", "variant", "children", "leftIcon", "rightIcon", "className"]);
  var iconSize = size === 24 ? 16 : 12;
  return jsxs(SquareBadgeContainer, _assign({}, rest, {
    size: size,
    className: classNames(className, variant)
  }, {
    children: [leftIcon && /*#__PURE__*/cloneElement(leftIcon, {
      size: iconSize,
      className: 'left-icon'
    }), children, rightIcon && /*#__PURE__*/cloneElement(rightIcon, {
      size: iconSize,
      className: 'right-icon'
    })]
  }));
};
var FontStyleBySize = {
  16: /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_10__/* .css */ .iv)(templateObject_1$c || (templateObject_1$c = (0,_common_js__WEBPACK_IMPORTED_MODULE_7__._)(["\n    ", "\n    height: 16px;\n    padding: 0px 4px;" + ( true ? "" : 0)], ["\n    ", "\n    height: 16px;\n    padding: 0px 4px;" + ( true ? "" : 0)])), _foundation_js__WEBPACK_IMPORTED_MODULE_11__.F.detail10L14),
  20: /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_10__/* .css */ .iv)(templateObject_2$8 || (templateObject_2$8 = (0,_common_js__WEBPACK_IMPORTED_MODULE_7__._)(["\n    ", ";\n    height: 20px;\n    padding: 0px 6px;" + ( true ? "" : 0)], ["\n    ", ";\n    height: 20px;\n    padding: 0px 6px;" + ( true ? "" : 0)])), _foundation_js__WEBPACK_IMPORTED_MODULE_11__.F.detail12L16),
  24: /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_10__/* .css */ .iv)(templateObject_3$5 || (templateObject_3$5 = (0,_common_js__WEBPACK_IMPORTED_MODULE_7__._)(["\n    ", ";\n    height: 24px;\n    padding: 0px 6px;" + ( true ? "" : 0)], ["\n    ", ";\n    height: 24px;\n    padding: 0px 6px;" + ( true ? "" : 0)])), _foundation_js__WEBPACK_IMPORTED_MODULE_11__.F.detail12L16)
};
var SquareBadgeContainer = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(BadgeBaseContainer,  true ? {
  target: "e15u479s0"
} : 0)(templateObject_4$4 || (templateObject_4$4 = (0,_common_js__WEBPACK_IMPORTED_MODULE_7__._)(["\n  border-radius: 4px;\n  flex-direction: row;\n  gap: 4px;\n  flex-shrink: 0;\n\n  &.primary {\n    background: ", ";\n  }\n\n  &.accent {\n    background: ", ";\n  }\n\n  &.dim_dark {\n    background: ", ";\n  }\n\n  &.neutral300 {\n    background: ", ";\n    color: ", ";\n  }\n\n  &.neutral500 {\n    background: ", ";\n  }\n\n  ", "\n"], ["\n  border-radius: 4px;\n  flex-direction: row;\n  gap: 4px;\n  flex-shrink: 0;\n\n  &.primary {\n    background: ", ";\n  }\n\n  &.accent {\n    background: ", ";\n  }\n\n  &.dim_dark {\n    background: ", ";\n  }\n\n  &.neutral300 {\n    background: ", ";\n    color: ", ";\n  }\n\n  &.neutral500 {\n    background: ", ";\n  }\n\n  ", "\n"])), function (_a) {
  var theme = _a.theme;
  return theme.primary.basic;
}, function (_a) {
  var theme = _a.theme;
  return theme.accent.basic;
}, function (_a) {
  var theme = _a.theme;
  return theme.interactive.dim.thick;
}, function (_a) {
  var theme = _a.theme;
  return theme.base.neutral300;
}, function (_a) {
  var theme = _a.theme;
  return theme.base.neutral500;
}, function (_a) {
  var theme = _a.theme;
  return theme.base.neutral500;
}, function (_a) {
  var size = _a.size;
  return FontStyleBySize[size];
});
var templateObject_1$c, templateObject_2$8, templateObject_3$5, templateObject_4$4;

var PillBadge = /*#__PURE__*/(/* unused pure expression or super */ null && (forwardRef(function (props, ref) {
  var size = props.size,
    value = props.value,
    rest = __rest(props, ["size", "value"]);
  return jsx(CircleBadgeContainer, _assign({
    ref: ref
  }, rest, {
    size: size
  }, {
    children: value
  }));
})));

var DotBadge = /*#__PURE__*/(/* unused pure expression or super */ null && (forwardRef(function (props, ref) {
  var rest = __rest(props, []);
  return jsx(Container$4, _assign({
    ref: ref
  }, rest, {
    "data-testid": "dot-badge"
  }));
})));
var Container$4 = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("span",  true ? {
  target: "e78z9x80"
} : 0)(templateObject_1$b || (templateObject_1$b = (0,_common_js__WEBPACK_IMPORTED_MODULE_7__._)(["\n  display: inline-block;\n  background-color: ", ";\n  width: 4px;\n  height: 4px;\n  border-radius: 50%;\n"], ["\n  display: inline-block;\n  background-color: ", ";\n  width: 4px;\n  height: 4px;\n  border-radius: 50%;\n"])), function (_a) {
  var theme = _a.theme;
  return theme.accent.basic;
});
var templateObject_1$b;

/**
 * Divider
 * @see {@link https://www.figma.com/design/aTdWM1sgdScr68GZdQ2sWO/ODS-(Ohouse-Design-System)-Master?node-id=21462-14943&t=DjaawziSis6vCaS1-0}
 */
var Divider = /*#__PURE__*/(/* unused pure expression or super */ null && (forwardRef(function (props, ref) {
  return jsx(DividerContainer, _assign({
    ref: ref
  }, props));
})));
var DividerContainer = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("hr",  true ? {
  target: "e15zb1dk0"
} : 0)(templateObject_1$a || (templateObject_1$a = (0,_common_js__WEBPACK_IMPORTED_MODULE_7__._)(["\n  margin: 0;\n  padding: 0;\n  height: ", "px;\n  border: none;\n  background-color: ", ";\n"], ["\n  margin: 0;\n  padding: 0;\n  height: ", "px;\n  border: none;\n  background-color: ", ";\n"])), function (_a) {
  var height = _a.height;
  return height;
}, function (_a) {
  var theme = _a.theme,
    height = _a.height;
  return height === 1 ? theme.base.neutral300 : theme.base.neutral100;
});
var templateObject_1$a;

function dotSize(index, maxPage, activeIndex) {
  if (maxPage <= 4) {
    return index === activeIndex ? 8 : 6;
  }
  // activeIndex의 왼쪽.
  if (index <= activeIndex) {
    var delta = activeIndex - index;
    if (activeIndex === maxPage - 1) {
      if (delta <= 2) {
        return 8;
      } else if (delta === 3) {
        return 6;
      } else if (delta === 4) {
        return 4;
      }
      return 0;
    } else {
      if (delta <= 2) {
        return 8;
      } else if (delta === 3) {
        return 6;
      }
      return 0;
    }
  }
  // activeIndex의 오른쪽.
  if (activeIndex <= 2) {
    if (index <= 2) {
      return 8;
    } else if (index === 3) {
      return 6;
    } else if (index === 4) {
      return 4;
    }
    return 0;
  } else {
    return index - activeIndex === 1 ? 6 : 0;
  }
}
function IndicatorDots(props) {
  var theme = useTheme();
  return makeIndicatorDots({
    dotSize: dotSize,
    dotBackgroundColor: theme.dim.onDark.thick,
    activeDotBackgroundColor: PALETTE.white,
    boxShadow: "".concat(pxToRem(0), " ").concat(pxToRem(2), " ").concat(pxToRem(5), " ").concat(theme.shadow.basic)
  })(props);
}

/**
 * 스낵바 메시지 위치 옵션
 * - basic : 바텀 하단에 스낵바 메시지 노출
 * - fab : FAB 가 보이도록 메시지 노출
 */
var SNACKBAR_PLACEMENT = {
  basic: 'basic',
  fab: 'fab'
};

function snackBarReducer(state, action) {
  switch (action.type) {
    case 'open':
      {
        var newItem = {
          id: state.id,
          state: 'open',
          options: action.options
        };
        state.items.forEach(function (item) {
          var _a, _b;
          (_b = (_a = item.options).onClose) === null || _b === void 0 ? void 0 : _b.call(_a);
        });
        var items = [newItem];
        return (0,_common_js__WEBPACK_IMPORTED_MODULE_7__.a)((0,_common_js__WEBPACK_IMPORTED_MODULE_7__.a)({}, state), {
          id: state.id + 1,
          items: items,
          placement: getPlacement(items)
        });
      }
    case 'close':
      {
        var items = state.items.map(function (v) {
          if (v.id === action.id) {
            return (0,_common_js__WEBPACK_IMPORTED_MODULE_7__.a)((0,_common_js__WEBPACK_IMPORTED_MODULE_7__.a)({}, v), {
              state: 'closing'
            });
          }
          return v;
        });
        return (0,_common_js__WEBPACK_IMPORTED_MODULE_7__.a)((0,_common_js__WEBPACK_IMPORTED_MODULE_7__.a)({}, state), {
          items: items,
          placement: getPlacement(items)
        });
      }
    case 'closeAll':
      {
        return (0,_common_js__WEBPACK_IMPORTED_MODULE_7__.a)((0,_common_js__WEBPACK_IMPORTED_MODULE_7__.a)({}, state), {
          items: state.items.map(function (v) {
            return (0,_common_js__WEBPACK_IMPORTED_MODULE_7__.a)((0,_common_js__WEBPACK_IMPORTED_MODULE_7__.a)({}, v), {
              state: 'closing'
            });
          })
        });
      }
    case 'closed':
      {
        var entry = state.items.find(function (v) {
          return v.id === action.id;
        });
        if (entry != null && entry.options.onClose != null) {
          entry.options.onClose();
        }
        var items = state.items.filter(function (v) {
          return v.id !== action.id;
        });
        return (0,_common_js__WEBPACK_IMPORTED_MODULE_7__.a)((0,_common_js__WEBPACK_IMPORTED_MODULE_7__.a)({}, state), {
          isEngaged: state.items.length > 1 ? state.isEngaged : false,
          items: items,
          placement: getPlacement(items)
        });
      }
    case 'engage':
      return (0,_common_js__WEBPACK_IMPORTED_MODULE_7__.a)((0,_common_js__WEBPACK_IMPORTED_MODULE_7__.a)({}, state), {
        isEngaged: true
      });
    case 'disengage':
      return (0,_common_js__WEBPACK_IMPORTED_MODULE_7__.a)((0,_common_js__WEBPACK_IMPORTED_MODULE_7__.a)({}, state), {
        isEngaged: false
      });
    case 'shift':
      {
        var closeItem = state.items.find(function (v) {
          return v.state === 'open';
        });
        if (closeItem == null) return state;
        return snackBarReducer(state, {
          type: 'close',
          id: closeItem.id
        });
      }
    default:
      return state;
  }
}
/**
 * 스낵바 상태를 관리하는 훅입니다.
 * 스낵바는 queue 형태로 관리하고 있으나, queue내에 한번에 존재할 수 있는 스낵바는 1개로 제한됩니다.
 * 기존 스낵바가 shift 된기 전에 새로운 스낵바가 들어오면 기존 스낵바는 곧바로 shift되어 별도의 closing 상태(fadeout 애니메이션)를 거치지 않고 제거됩니다.
 * 또한, 유저가 스낵바와 인터렉션 중인 상태일 때에는 (engaged) 스낵바가 closing 상태로 변경되지 않도록 isEngaged 상태를 관리합니다.
 * @returns SnackbarStateResult
 */
function useSnackbarState() {
  var _a = (0,react__WEBPACK_IMPORTED_MODULE_1__.useReducer)(snackBarReducer, {
      id: 0,
      isEngaged: false,
      items: [],
      placement: SNACKBAR_PLACEMENT.basic
    }),
    state = _a[0],
    dispatch = _a[1];
  var handleEngage = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function () {
    dispatch({
      type: 'engage'
    });
  }, [dispatch]);
  var handleDisengage = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function () {
    dispatch({
      type: 'disengage'
    });
  }, [dispatch]);
  var handleOpen = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function (options) {
    dispatch({
      type: 'open',
      options: options
    });
  }, [dispatch]);
  var handleClose = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function (id) {
    dispatch({
      type: 'close',
      id: id
    });
  }, [dispatch]);
  var handleClosed = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function (id) {
    dispatch({
      type: 'closed',
      id: id
    });
  }, [dispatch]);
  var handleCloseAll = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function () {
    dispatch({
      type: 'closeAll'
    });
  }, [dispatch]);
  (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function () {
    if (state.isEngaged || state.items.length === 0) return;
    var closeItem = state.items.find(function (v) {
      return v.state === 'open';
    });
    if (closeItem != null) {
      // If it's not engaged, try to remove items every few seconds
      var duration = closeItem.options.duration || 3000;
      var timer_1 = setTimeout(function () {
        return dispatch({
          type: 'shift'
        });
      }, duration);
      return function () {
        clearTimeout(timer_1);
      };
    }
  }, [dispatch, state]);
  var result = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function () {
    return {
      state: state,
      closeAll: handleCloseAll,
      close: handleClose,
      closed: handleClosed,
      open: handleOpen,
      engage: handleEngage,
      disengage: handleDisengage
    };
  }, [state, handleCloseAll, handleClose, handleClosed, handleOpen, handleEngage, handleDisengage]);
  return result;
}
/**
 * 오픈된 스낵바 아이템을 순회하여 스낵바를 노출할 위치를 리턴합니다.
 * fab가 하나라도 존재하면 fab로 리턴하고, 그렇지 않으면 basic을 리턴합니다.
 */
function getPlacement(items) {
  return items.some(function (item) {
    return item.options.placement === SNACKBAR_PLACEMENT.fab;
  }) ? SNACKBAR_PLACEMENT.fab : SNACKBAR_PLACEMENT.basic;
}

// TODO Button 을 Anchor로도 사용 가능한 형태로 개선 필요.
var BaseButton = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_1__.forwardRef)(function (_a, ref) {
  var children = _a.children,
    restProps = (0,_common_js__WEBPACK_IMPORTED_MODULE_7__.e)(_a, ["children"]);
  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsx */ .tZ)(HoverInteraction, (0,_common_js__WEBPACK_IMPORTED_MODULE_7__.a)({
    disabled: restProps.disabled
  }, {
    children: (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsx */ .tZ)(ResetButton, (0,_common_js__WEBPACK_IMPORTED_MODULE_7__.a)({}, restProps, {
      ref: ref
    }, {
      children: children
    }))
  }));
});
var ResetButton = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("button",  true ? {
  target: "e117vx0e0"
} : 0)(templateObject_1$9 || (templateObject_1$9 = (0,_common_js__WEBPACK_IMPORTED_MODULE_7__._)(["\n  ", ";\n  cursor: pointer;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  box-sizing: border-box;\n"], ["\n  ", ";\n  cursor: pointer;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  box-sizing: border-box;\n"])), _foundation_js__WEBPACK_IMPORTED_MODULE_11__.R);
var templateObject_1$9;

var iconSize = {
  14: 12,
  16: 16
};
var TextButton = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_1__.forwardRef)(function (props, ref) {
  var children = props.children,
    size = props.size,
    variant = props.variant,
    RightIcon = props.rightIcon,
    LeftIcon = props.leftIcon,
    className = props.className,
    restProps = (0,_common_js__WEBPACK_IMPORTED_MODULE_7__.e)(props, ["children", "size", "variant", "rightIcon", "leftIcon", "className"]);
  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsxs */ .BX)(TextButtonContainer, (0,_common_js__WEBPACK_IMPORTED_MODULE_7__.a)({
    className: classnames__WEBPACK_IMPORTED_MODULE_2___default()([variant, "size-".concat(size), className])
  }, restProps, {
    ref: ref
  }, {
    children: [LeftIcon && (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsx */ .tZ)(LeftIcon, {
      "data-testid": "left-icon",
      className: "left-icon",
      size: iconSize[size]
    }), children, RightIcon && (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsx */ .tZ)(RightIcon, {
      "data-testid": "right-icon",
      className: "right-icon",
      size: iconSize[size]
    })]
  }));
});
var TextButtonContainer = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(BaseButton,  true ? {
  target: "e1wbybap0"
} : 0)(templateObject_1$8 || (templateObject_1$8 = (0,_common_js__WEBPACK_IMPORTED_MODULE_7__._)(["\n  padding: ", " ", ";\n  border-radius: 4px;\n  \n  &.primary {\n    color: ", ";\n  }\n  &.neutral-500 {\n    color: ", ";\n  }\n  &.neutral-600 {\n    color: ", ";\n  }\n  &:disabled {\n    color: ", ";\n  }\n  \n  &.size-14 {\n    ", ";\n  }\n  &.size-16 {\n    ", ";\n    font-weight: 500;\n  }\n  \n  .left-icon {\n    margin-right: ", ";\n  }\n  .right-icon {\n    margin-left: ", ";\n  }\n"], ["\n  padding: ", " ", ";\n  border-radius: 4px;\n  \n  &.primary {\n    color: ", ";\n  }\n  &.neutral-500 {\n    color: ", ";\n  }\n  &.neutral-600 {\n    color: ", ";\n  }\n  &:disabled {\n    color: ", ";\n  }\n  \n  &.size-14 {\n    ", ";\n  }\n  &.size-16 {\n    ", ";\n    font-weight: 500;\n  }\n  \n  .left-icon {\n    margin-right: ", ";\n  }\n  .right-icon {\n    margin-left: ", ";\n  }\n"])), (0,_foundation_js__WEBPACK_IMPORTED_MODULE_11__.p)(4), (0,_foundation_js__WEBPACK_IMPORTED_MODULE_11__.p)(8), function (_a) {
  var theme = _a.theme;
  return theme.primary.basic;
}, function (_a) {
  var theme = _a.theme;
  return theme.base.neutral500;
}, function (_a) {
  var theme = _a.theme;
  return theme.base.neutral600;
}, function (_a) {
  var theme = _a.theme;
  return theme.base.neutral400;
}, _foundation_js__WEBPACK_IMPORTED_MODULE_11__.F.body14L18, _foundation_js__WEBPACK_IMPORTED_MODULE_11__.F.body16L20, (0,_foundation_js__WEBPACK_IMPORTED_MODULE_11__.p)(4), (0,_foundation_js__WEBPACK_IMPORTED_MODULE_11__.p)(4));
var templateObject_1$8;

var fadeIn = (0,_emotion_react__WEBPACK_IMPORTED_MODULE_10__/* .keyframes */ .F4)(templateObject_1$7 || (templateObject_1$7 = (0,_common_js__WEBPACK_IMPORTED_MODULE_7__._)(["\n  0% {\n    opacity: 0;\n  }\n  100% {\n    opacity: 1;\n  }\n"], ["\n  0% {\n    opacity: 0;\n  }\n  100% {\n    opacity: 1;\n  }\n"])));
var fadeOut = (0,_emotion_react__WEBPACK_IMPORTED_MODULE_10__/* .keyframes */ .F4)(templateObject_2$7 || (templateObject_2$7 = (0,_common_js__WEBPACK_IMPORTED_MODULE_7__._)(["\n  0% {\n    opacity: 1;\n  }\n\n  100% {\n    opacity: 0;\n  }\n"], ["\n  0% {\n    opacity: 1;\n  }\n\n  100% {\n    opacity: 0;\n  }\n"])));
function cssAnimation(isClosing) {
  if (!isClosing) return /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_10__/* .css */ .iv)(templateObject_3$4 || (templateObject_3$4 = (0,_common_js__WEBPACK_IMPORTED_MODULE_7__._)(["animation: ", " 0.3s 0.1s cubic-bezier(0.33, 1, 0.68, 1) both;" + ( true ? "" : 0)], ["animation: ", " 0.3s 0.1s cubic-bezier(0.33, 1, 0.68, 1) both;" + ( true ? "" : 0)])), fadeIn);
  return /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_10__/* .css */ .iv)(templateObject_4$3 || (templateObject_4$3 = (0,_common_js__WEBPACK_IMPORTED_MODULE_7__._)(["animation: ", " 0.2s cubic-bezier(0.215, 0.61, 0.355, 1)  forwards;" + ( true ? "" : 0)], ["animation: ", " 0.2s cubic-bezier(0.215, 0.61, 0.355, 1)  forwards;" + ( true ? "" : 0)])), fadeOut);
}
function SnackbarItem(_a) {
  var className = _a.className,
    PrefixIcon = _a.prefixIcon,
    content = _a.content,
    buttons = _a.buttons,
    onClick = _a.onClick,
    onCloseAnimationEnd = _a.onCloseAnimationEnd,
    isClosing = _a.isClosing,
    suffixButton = _a.suffixButton;
  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsxs */ .BX)(SnackbarWrapper, (0,_common_js__WEBPACK_IMPORTED_MODULE_7__.a)({
    "data-testid": "snackbar-item",
    className: className,
    css: [cssAnimation(isClosing)],
    onClick: onClick,
    onAnimationEnd: isClosing ? onCloseAnimationEnd : undefined
  }, {
    children: [!!PrefixIcon && (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsx */ .tZ)(PrefixIcon, {
      "data-testid": "snackbar-item-icon",
      className: "prefix-icon",
      size: 18
    }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsx */ .tZ)(Content, {
      children: content
    }), suffixButton && (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsx */ .tZ)(SnackbarButton, (0,_common_js__WEBPACK_IMPORTED_MODULE_7__.a)({
      size: 14,
      variant: "primary",
      type: "button",
      onClick: suffixButton.onClick
    }, {
      children: suffixButton.title
    })), buttons && (buttons === null || buttons === void 0 ? void 0 : buttons.length) > 0 && (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsx */ .tZ)(ButtonWrapper$2, {
      children: buttons.map(function (buttonProps, i) {
        return /** FIXME TextButton 구현 후 적용 */(
          (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsx */ .tZ)(SnackbarButton, (0,_common_js__WEBPACK_IMPORTED_MODULE_7__.a)({
            size: 14,
            variant: "primary",
            type: "button"
          }, buttonProps), i)
        );
      })
    })]
  }));
}
var SnackbarWrapper = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("div",  true ? {
  target: "efmkyib3"
} : 0)(templateObject_7$2 || (templateObject_7$2 = (0,_common_js__WEBPACK_IMPORTED_MODULE_7__._)(["\n  box-sizing: border-box;\n  display: flex;\n  padding: ", " ", ";\n  background-color: ", ";\n  border-radius: ", ";\n  ", ";\n  color: ", ";\n\n  margin-top: ", ";\n  width: ", ";\n  ", "\n  ", "\n  \n  .prefix-icon {\n    margin-right: ", ";\n  }\n"], ["\n  box-sizing: border-box;\n  display: flex;\n  padding: ", " ", ";\n  background-color: ", ";\n  border-radius: ", ";\n  ", ";\n  color: ", ";\n\n  margin-top: ", ";\n  width: ", ";\n  ", "\n  ", "\n  \n  .prefix-icon {\n    margin-right: ", ";\n  }\n"])), (0,_foundation_js__WEBPACK_IMPORTED_MODULE_11__.p)(14), (0,_foundation_js__WEBPACK_IMPORTED_MODULE_11__.p)(16), function (_a) {
  var theme = _a.theme;
  return theme.layer.dark;
}, (0,_foundation_js__WEBPACK_IMPORTED_MODULE_11__.p)(4), _foundation_js__WEBPACK_IMPORTED_MODULE_11__.F.body14L18, function (_a) {
  var theme = _a.theme;
  return theme.base.neutral0;
}, (0,_foundation_js__WEBPACK_IMPORTED_MODULE_11__.p)(15), (0,_foundation_js__WEBPACK_IMPORTED_MODULE_11__.p)(470), _foundation_js__WEBPACK_IMPORTED_MODULE_11__.M.max('tablet', /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_10__/* .css */ .iv)(templateObject_5$2 || (templateObject_5$2 = (0,_common_js__WEBPACK_IMPORTED_MODULE_7__._)(["\n    width: ", ";\n  " + ( true ? "" : 0)], ["\n    width: ", ";\n  " + ( true ? "" : 0)])), (0,_foundation_js__WEBPACK_IMPORTED_MODULE_11__.p)(350))), _foundation_js__WEBPACK_IMPORTED_MODULE_11__.M.max('mobile', /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_10__/* .css */ .iv)(templateObject_6$2 || (templateObject_6$2 = (0,_common_js__WEBPACK_IMPORTED_MODULE_7__._)(["\n    width: 100%\n  " + ( true ? "" : 0)], ["\n    width: 100%\n  " + ( true ? "" : 0)])))), (0,_foundation_js__WEBPACK_IMPORTED_MODULE_11__.p)(6));
var Content = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("div",  true ? {
  target: "efmkyib2"
} : 0)(templateObject_8$1 || (templateObject_8$1 = (0,_common_js__WEBPACK_IMPORTED_MODULE_7__._)(["\n  flex: 1 1;\n  white-space: pre-line;\n  word-break: keep-all;\n  overflow-wrap: break-word;\n"], ["\n  flex: 1 1;\n  white-space: pre-line;\n  word-break: keep-all;\n  overflow-wrap: break-word;\n"])));
var ButtonWrapper$2 = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("div",  true ? {
  target: "efmkyib1"
} : 0)(templateObject_9 || (templateObject_9 = (0,_common_js__WEBPACK_IMPORTED_MODULE_7__._)(["\n  margin-left: ", ";\n"], ["\n  margin-left: ", ";\n"])), (0,_foundation_js__WEBPACK_IMPORTED_MODULE_11__.p)(4));
var SnackbarButton = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(TextButton,  true ? {
  target: "efmkyib0"
} : 0)(templateObject_10 || (templateObject_10 = (0,_common_js__WEBPACK_IMPORTED_MODULE_7__._)(["\n  padding: 0;\n  &:not(:first-of-type) {\n  margin-left: ", ";\n}"], ["\n  padding: 0;\n  &:not(:first-of-type) {\n  margin-left: ", ";\n}"])), (0,_foundation_js__WEBPACK_IMPORTED_MODULE_11__.p)(8));
var templateObject_1$7, templateObject_2$7, templateObject_3$4, templateObject_4$3, templateObject_5$2, templateObject_6$2, templateObject_7$2, templateObject_8$1, templateObject_9, templateObject_10;

var convertBdsOptionAsOds = function convertBdsOptionAsOds(props) {
  var icon = props.icon,
    type = props.type,
    multiline = props.multiline,
    rest = (0,_common_js__WEBPACK_IMPORTED_MODULE_7__.e)(props, ["icon", "type", "multiline"]);
  var newProps = rest;
  if (icon) {
    console.warn('Snackbar: icon is deprecated. Use prefixIcon instead.');
    newProps = (0,_common_js__WEBPACK_IMPORTED_MODULE_7__.a)((0,_common_js__WEBPACK_IMPORTED_MODULE_7__.a)({}, newProps), {
      prefixIcon: _icons_js__WEBPACK_IMPORTED_MODULE_12__.I
    });
  }
  if (type) {
    console.warn('Snackbar: type is deprecated. Only normal type design is allowed.');
  }
  // deprecated 되어야 할 대상이지만, 하위호환성을 위해 실제 구현 단에서는 활용하도록 남겨둡니다.
  if (rest.buttons) {
    console.warn('Snackbar: buttons is deprecated. Use button props instead.');
  }
  if (multiline) {
    console.warn('Snackbar: multiline is deprecated. Do not use multiline.');
  }
  return newProps;
};

var _a;
/** 스낵바 위치 */
var BOTTOM_SIZE = (_a = {}, _a[SNACKBAR_PLACEMENT.basic] = {
  mobile: 8,
  pc: 40
}, _a[SNACKBAR_PLACEMENT.fab] = {
  mobile: 70,
  pc: 40
}, _a);
function SnackbarList(props) {
  var _a = props.state,
    items = _a.items,
    placement = _a.placement,
    close = props.close,
    closed = props.closed,
    engage = props.engage,
    disengage = props.disengage;
  // TODO 사용되는 서비스들에서 마이그레이션 완료 후 제거
  var odsItems = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function () {
    return items.map(function (item) {
      return (0,_common_js__WEBPACK_IMPORTED_MODULE_7__.a)((0,_common_js__WEBPACK_IMPORTED_MODULE_7__.a)({}, item), {
        options: convertBdsOptionAsOds(item.options)
      });
    });
  }, [items]);
  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsx */ .tZ)(_common_js__WEBPACK_IMPORTED_MODULE_7__.B, {
    children: (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsx */ .tZ)(Wrapper, (0,_common_js__WEBPACK_IMPORTED_MODULE_7__.a)({
      "data-testid": "snackbar-list-wrapper"
    }, props, {
      onMouseEnter: engage,
      onMouseLeave: disengage,
      placement: placement
    }, {
      children: odsItems.map(function (_a, index) {
        var id = _a.id,
          state = _a.state,
          options = _a.options;
        return (0,_emotion_react__WEBPACK_IMPORTED_MODULE_10__/* .createElement */ .az)(SnackbarItem, (0,_common_js__WEBPACK_IMPORTED_MODULE_7__.a)({}, options, {
          key: id,
          isClosing: state === 'closing',
          onClick: function onClick() {
            var _a;
            (_a = options.onClick) === null || _a === void 0 ? void 0 : _a.call(options);
            close(id);
          },
          onCloseAnimationEnd: function onCloseAnimationEnd() {
            return closed(id);
          }
        }));
      })
    }))
  });
}
var Wrapper = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)('div',  true ? {
  shouldForwardProp: function shouldForwardProp(prop) {
    return (0,_emotion_is_prop_valid__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)(prop) && !['open'].includes(prop);
  },
  target: "e1z07hv00"
} : 0)(function (_a) {
  var placement = _a.placement;
  return /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_10__/* .css */ .iv)(templateObject_2$6 || (templateObject_2$6 = (0,_common_js__WEBPACK_IMPORTED_MODULE_7__._)(["\n    position: fixed;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  bottom: ", ";\n  padding-inline: 8px;\n  z-index: ", ";\n  left: 0;\n  right: 0;\n  ", "\n" + ( true ? "" : 0)], ["\n    position: fixed;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  bottom: ", ";\n  padding-inline: 8px;\n  z-index: ", ";\n  left: 0;\n  right: 0;\n  ", "\n" + ( true ? "" : 0)])), (0,_foundation_js__WEBPACK_IMPORTED_MODULE_11__.p)(BOTTOM_SIZE[placement].pc), _common_js__WEBPACK_IMPORTED_MODULE_7__.Z.snackbar, _foundation_js__WEBPACK_IMPORTED_MODULE_11__.M.max('tablet', /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_10__/* .css */ .iv)(templateObject_1$6 || (templateObject_1$6 = (0,_common_js__WEBPACK_IMPORTED_MODULE_7__._)(["\n    bottom: ", ";\n    ", "\n  " + ( true ? "" : 0)], ["\n    bottom: ", ";\n    ", "\n  " + ( true ? "" : 0)])), (0,_foundation_js__WEBPACK_IMPORTED_MODULE_11__.p)(BOTTOM_SIZE[placement].mobile), (0,_foundation_js__WEBPACK_IMPORTED_MODULE_11__.s)('bottom', 'padding-bottom'))));
});
var templateObject_1$6, templateObject_2$6;

var SnackbarContext = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_1__.createContext)(null);
function SnackbarProvider(_a) {
  var children = _a.children;
  var state = useSnackbarState();
  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsxs */ .BX)(SnackbarContext.Provider, (0,_common_js__WEBPACK_IMPORTED_MODULE_7__.a)({
    value: state
  }, {
    children: [children, (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsx */ .tZ)(SnackbarList, (0,_common_js__WEBPACK_IMPORTED_MODULE_7__.a)({}, state))]
  }));
}
function useSnackbar() {
  var result = (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(SnackbarContext);
  if (result == null) {
    throw new Error('SnackbarContext is not mounted');
  }
  return result;
}

var IconButton = /*#__PURE__*/(/* unused pure expression or super */ null && (forwardRef(function (_a, ref) {
  var IconElement = _a.icon,
    value = _a.value,
    _b = _a.valueAlignment,
    valueAlignment = _b === void 0 ? 'horizontal' : _b,
    className = _a.className,
    isActive = _a.isActive,
    ActiveIcon = _a.activeIcon,
    _c = _a.hasBorder,
    hasBorder = _c === void 0 ? false : _c,
    rest = __rest(_a, ["icon", "value", "valueAlignment", "className", "isActive", "activeIcon", "hasBorder"]);
  return jsxs(Container$3, _assign({
    ref: ref
  }, rest, {
    className: classNames(className, {
      horizontal: valueAlignment === 'horizontal',
      vertical: valueAlignment === 'vertical'
    }),
    type: "button"
  }, {
    children: [jsx(IconWrapper, _assign({
      className: classNames({
        border: hasBorder
      }),
      "data-testid": "icon-wrapper"
    }, {
      children: ActiveIcon && isActive ? jsx(ActiveIcon, {
        size: 24,
        "data-testid": "active-icon",
        fill: function fill(theme) {
          return theme.primary.basic;
        }
      }) : jsx(IconElement, {
        size: 24,
        "data-testid": "inactive-icon",
        fill: function fill(theme) {
          return theme.base.neutral700;
        }
      })
    })), value && jsx(ValueText, {
      children: formatComma(value)
    })]
  }));
})));
var Container$3 = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("button",  true ? {
  target: "e2itrfe2"
} : 0)(templateObject_1$5 || (templateObject_1$5 = (0,_common_js__WEBPACK_IMPORTED_MODULE_7__._)(["\n  background: none;\n  border: none;\n  color: ", ";\n  font-family: inherit;\n  padding: 0;\n  margin: 0;\n\n  display: inline-flex;\n  justify-content: center;\n  align-items: center;\n  gap: 4px;\n\n  &.vertical {\n    flex-direction: column;\n  }\n\n  &.horizontal {\n    flex-direction: row;\n  }\n"], ["\n  background: none;\n  border: none;\n  color: ", ";\n  font-family: inherit;\n  padding: 0;\n  margin: 0;\n\n  display: inline-flex;\n  justify-content: center;\n  align-items: center;\n  gap: 4px;\n\n  &.vertical {\n    flex-direction: column;\n  }\n\n  &.horizontal {\n    flex-direction: row;\n  }\n"])), function (_a) {
  var theme = _a.theme;
  return theme.base.neutral700;
});
var IconWrapper = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("div",  true ? {
  target: "e2itrfe1"
} : 0)(templateObject_2$5 || (templateObject_2$5 = (0,_common_js__WEBPACK_IMPORTED_MODULE_7__._)(["\n  &.border {\n    padding: 10px;\n    border: 1px solid ", ";\n    border-radius: 50%;\n  }\n\n  > svg {\n    vertical-align: middle;\n  }\n"], ["\n  &.border {\n    padding: 10px;\n    border: 1px solid ", ";\n    border-radius: 50%;\n  }\n\n  > svg {\n    vertical-align: middle;\n  }\n"])), function (_a) {
  var theme = _a.theme;
  return theme.border;
});
var ValueText = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("p",  true ? {
  target: "e2itrfe0"
} : 0)(templateObject_3$3 || (templateObject_3$3 = (0,_common_js__WEBPACK_IMPORTED_MODULE_7__._)(["\n  ", ";\n"], ["\n  ", ";\n"])), _foundation_js__WEBPACK_IMPORTED_MODULE_11__.F.detail12L16);
var templateObject_1$5, templateObject_2$5, templateObject_3$3;

var boxButtonColorLookup = function boxButtonColorLookup(theme) {
  return {
    filled: {
      'primary': {
        backgroundColor: theme.primary.basic,
        disabledBorderColor: theme.disabled.filled1,
        borderColor: theme.primary.basic,
        textColor: theme.base.neutral0,
        disabledBackgroundColor: theme.disabled.filled1,
        disabledTextColor: theme.base.neutral400
      },
      'neutral-600': {
        backgroundColor: '',
        disabledBorderColor: '',
        borderColor: '',
        textColor: '',
        disabledBackgroundColor: '',
        disabledTextColor: ''
      }
    },
    outlined: {
      'primary': {
        borderColor: theme.primary.basic,
        textColor: theme.primary.basic,
        disabledBorderColor: theme.border,
        disabledTextColor: theme.base.neutral400,
        backgroundColor: 'inherit',
        disabledBackgroundColor: 'inherit'
      },
      'neutral-600': {
        borderColor: theme.border,
        textColor: theme.base.neutral600,
        disabledBorderColor: theme.border,
        disabledTextColor: theme.base.neutral400,
        backgroundColor: 'inherit',
        disabledBackgroundColor: 'inherit'
      }
    }
  };
};
var boxButtonSizeLookup = {
  28: {
    paddingInline: 8,
    paddingBlock: 4,
    fontWeight: 500,
    fontSize: _foundation_js__WEBPACK_IMPORTED_MODULE_11__.F.body14L20
  },
  32: {
    paddingInline: 8,
    paddingBlock: 6,
    fontWeight: 600,
    fontSize: _foundation_js__WEBPACK_IMPORTED_MODULE_11__.F.body14L20
  },
  40: {
    paddingInline: 16,
    paddingBlock: 10,
    fontWeight: 600,
    fontSize: _foundation_js__WEBPACK_IMPORTED_MODULE_11__.F.body14L20
  },
  44: {
    paddingInline: 16,
    paddingBlock: 12,
    fontWeight: 700,
    fontSize: _foundation_js__WEBPACK_IMPORTED_MODULE_11__.F.body16L20
  },
  50: {
    paddingInline: 16,
    paddingBlock: 15,
    fontWeight: 700,
    fontSize: _foundation_js__WEBPACK_IMPORTED_MODULE_11__.F.body16L20
  }
};
/**
 * 버튼의 타입에 따른 style을 반환합니다.
 * @param variant
 * @param shape
 * @param theme
 */
var getBoxButtonVariantStyle = function getBoxButtonVariantStyle(_a) {
  var variant = _a.variant,
    shape = _a.shape,
    theme = _a.theme;
  var colors = boxButtonColorLookup(theme)[shape][variant];
  return /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_10__/* .css */ .iv)(templateObject_1$4 || (templateObject_1$4 = (0,_common_js__WEBPACK_IMPORTED_MODULE_7__._)(["\n    color: ", ";\n    background-color: ", ";\n    border: 1px solid ", ";\n    &:disabled {\n      background-color: ", ";\n      color: ", ";\n      border-color: ", ";\n    }\n  " + ( true ? "" : 0)], ["\n    color: ", ";\n    background-color: ", ";\n    border: 1px solid ", ";\n    &:disabled {\n      background-color: ", ";\n      color: ", ";\n      border-color: ", ";\n    }\n  " + ( true ? "" : 0)])), colors.textColor, colors.backgroundColor, colors.borderColor, colors.disabledBackgroundColor, colors.disabledTextColor, colors.disabledBorderColor);
};
/**
 * BoxButton의 size에 따른 style을 반환합니다.
 * @param size
 */
var getButtonSizeStyle = function getButtonSizeStyle(size) {
  var _a = boxButtonSizeLookup[size],
    fontSize = _a.fontSize,
    fontWeight = _a.fontWeight,
    paddingBlock = _a.paddingBlock,
    paddingInline = _a.paddingInline;
  return /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_10__/* .css */ .iv)(templateObject_2$4 || (templateObject_2$4 = (0,_common_js__WEBPACK_IMPORTED_MODULE_7__._)(["\n    ", ";\n    font-weight: ", ";\n    padding: ", " ", ";\n    height: ", ";\n  " + ( true ? "" : 0)], ["\n    ", ";\n    font-weight: ", ";\n    padding: ", " ", ";\n    height: ", ";\n  " + ( true ? "" : 0)])), fontSize, fontWeight, (0,_foundation_js__WEBPACK_IMPORTED_MODULE_11__.p)(paddingBlock), (0,_foundation_js__WEBPACK_IMPORTED_MODULE_11__.p)(paddingInline), (0,_foundation_js__WEBPACK_IMPORTED_MODULE_11__.p)(size));
};
/**
 * BoxButton내 아이콘의 사이즈를 button size에 알맞은 값으로 반환합니다.
 * @param buttonSize
 */
var getBoxButtonIconSize = function getBoxButtonIconSize(buttonSize) {
  switch (buttonSize) {
    case 28:
    case 32:
    case 40:
      return 16;
    case 44:
    case 50:
      return 18;
    default:
      throw new Error('Invalid button size');
  }
};
/**
 * BoxButton의 variant에 대응하는 loading variant를 반환합니다.
 * @param variant
 * @param shape
 */
var getBoxButtonLoadingVariant = function getBoxButtonLoadingVariant(_a) {
  var variant = _a.variant,
    shape = _a.shape;
  switch (shape) {
    case 'filled':
      switch (variant) {
        case 'primary':
          return 'white';
        case 'neutral-600':
          return 'base1';
      }
      break;
    case 'outlined':
      switch (variant) {
        case 'primary':
          return 'primary1';
        case 'neutral-600':
          return 'base1';
      }
      break;
  }
};
var templateObject_1$4, templateObject_2$4;

var BoxButton = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_1__.forwardRef)(function (props, ref) {
  var theme = (0,_emotion_react__WEBPACK_IMPORTED_MODULE_8__.u)();
  var children = props.children,
    LeftIcon = props.leftIcon,
    RightIcon = props.rightIcon,
    shape = props.shape,
    variant = props.variant,
    size = props.size,
    width = props.width,
    isLoading = props.isLoading,
    className = props.className,
    restProps = (0,_common_js__WEBPACK_IMPORTED_MODULE_7__.e)(props, ["children", "leftIcon", "rightIcon", "shape", "variant", "size", "width", "isLoading", "className"]);
  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsxs */ .BX)(BoxButtonContainer, (0,_common_js__WEBPACK_IMPORTED_MODULE_7__.a)({
    ref: ref,
    css: [getBoxButtonVariantStyle({
      variant: variant,
      shape: shape,
      theme: theme
    }), getButtonSizeStyle(size), width && /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_10__/* .css */ .iv)({
      width: width
    },  true ? "" : 0)],
    className: classnames__WEBPACK_IMPORTED_MODULE_2___default()(className, {
      loading: isLoading
    })
  }, restProps, {
    children: [LeftIcon && (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsx */ .tZ)(LeftIcon, {
      "data-testid": "left-icon",
      className: "left-icon",
      size: getBoxButtonIconSize(size)
    }), children, RightIcon && (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsx */ .tZ)(RightIcon, {
      "data-testid": "right-icon",
      className: "right-icon",
      size: getBoxButtonIconSize(size)
    }), !restProps.disabled && isLoading && (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsx */ .tZ)(LoadingContainer, {
      children: (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsx */ .tZ)(_Loading_js__WEBPACK_IMPORTED_MODULE_14__.L, {
        "data-testid": "button-loading",
        variant: getBoxButtonLoadingVariant({
          variant: variant,
          shape: shape
        })
      })
    })]
  }));
});
var BoxButtonContainer = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(BaseButton,  true ? {
  target: "e5j3oup1"
} : 0)(templateObject_1$3 || (templateObject_1$3 = (0,_common_js__WEBPACK_IMPORTED_MODULE_7__._)(["\n  border-radius: ", ";\n  &.loading {\n    pointer-events: none;\n    cursor: default;\n    color: transparent;\n  }\n  \n  .left-icon {\n    margin-right: ", ";\n  }\n  .right-icon {\n    margin-left: ", ";\n  }\n"], ["\n  border-radius: ", ";\n  &.loading {\n    pointer-events: none;\n    cursor: default;\n    color: transparent;\n  }\n  \n  .left-icon {\n    margin-right: ", ";\n  }\n  .right-icon {\n    margin-left: ", ";\n  }\n"])), (0,_foundation_js__WEBPACK_IMPORTED_MODULE_11__.p)(4), (0,_foundation_js__WEBPACK_IMPORTED_MODULE_11__.p)(4), (0,_foundation_js__WEBPACK_IMPORTED_MODULE_11__.p)(4));
var LoadingContainer = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("span",  true ? {
  target: "e5j3oup0"
} : 0)(templateObject_2$3 || (templateObject_2$3 = (0,_common_js__WEBPACK_IMPORTED_MODULE_7__._)(["\n  position: absolute;\n  left: 0;\n  right: 0;\n  top: 0;\n  bottom: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  pointer-events: none;\n"], ["\n  position: absolute;\n  left: 0;\n  right: 0;\n  top: 0;\n  bottom: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  pointer-events: none;\n"])));
var templateObject_1$3, templateObject_2$3;

var CautionBox = /*#__PURE__*/(/* unused pure expression or super */ null && (forwardRef(function (props, ref) {
  var title = props.title,
    description = props.description,
    className = props.className,
    buttonText = props.buttonText,
    onButtonClick = props.onButtonClick,
    rest = __rest(props, ["title", "description", "className", "buttonText", "onButtonClick"]);
  return jsxs(Container$2, _assign({
    ref: ref
  }, rest, {
    className: className
  }, {
    children: [jsxs(Header, {
      children: [jsx(StyledAlertFilledIcon, {
        size: 18,
        fill: function fill(theme) {
          return theme.accent.darken;
        }
      }), jsx(TopText, {
        children: title ? jsx(Title$2, {
          children: title
        }) : jsx(Description$1, _assign({
          as: "span"
        }, {
          children: description
        }))
      })]
    }), title && description && jsx(Description$1, {
      children: description
    }), buttonText && jsx(ButtonWrapper$1, _assign({
      variant: "neutral-600",
      shape: "outlined",
      size: 40,
      onClick: onButtonClick
    }, {
      children: buttonText
    }))]
  }));
})));
var Container$2 = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("div",  true ? {
  target: "e1x05w0q6"
} : 0)(templateObject_1$2 || (templateObject_1$2 = (0,_common_js__WEBPACK_IMPORTED_MODULE_7__._)(["\n  padding: 12px 16px;\n  border: 1px solid ", ";\n  border-radius: 4px;\n  background-color: ", ";\n"], ["\n  padding: 12px 16px;\n  border: 1px solid ", ";\n  border-radius: 4px;\n  background-color: ", ";\n"])), function (_a) {
  var theme = _a.theme;
  return theme.base.neutral200;
}, function (_a) {
  var theme = _a.theme;
  return theme.base.neutral100;
});
var Header = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("div",  true ? {
  target: "e1x05w0q5"
} : 0)(templateObject_2$2 || (templateObject_2$2 = (0,_common_js__WEBPACK_IMPORTED_MODULE_7__._)(["\n"], ["\n"])));
var StyledAlertFilledIcon = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_icons_js__WEBPACK_IMPORTED_MODULE_12__.A,  true ? {
  target: "e1x05w0q4"
} : 0)(templateObject_3$2 || (templateObject_3$2 = (0,_common_js__WEBPACK_IMPORTED_MODULE_7__._)(["\n  margin-right: 6px;\n  vertical-align: middle;\n"], ["\n  margin-right: 6px;\n  vertical-align: middle;\n"])));
var TopText = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("span",  true ? {
  target: "e1x05w0q3"
} : 0)(templateObject_4$2 || (templateObject_4$2 = (0,_common_js__WEBPACK_IMPORTED_MODULE_7__._)(["\n  color: ", ";\n"], ["\n  color: ", ";\n"])), function (_a) {
  var theme = _a.theme;
  return theme.base.neutral600;
});
var Title$2 = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("span",  true ? {
  target: "e1x05w0q2"
} : 0)(templateObject_5$1 || (templateObject_5$1 = (0,_common_js__WEBPACK_IMPORTED_MODULE_7__._)(["\n  ", ";\n  vertical-align: middle;\n  font-weight: 700;\n"], ["\n  ", ";\n  vertical-align: middle;\n  font-weight: 700;\n"])), _foundation_js__WEBPACK_IMPORTED_MODULE_11__.F.body16L24);
var Description$1 = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("div",  true ? {
  target: "e1x05w0q1"
} : 0)(templateObject_6$1 || (templateObject_6$1 = (0,_common_js__WEBPACK_IMPORTED_MODULE_7__._)(["\n  ", ";\n  font-weight: 400;\n  margin-top: 4px;\n"], ["\n  ", ";\n  font-weight: 400;\n  margin-top: 4px;\n"])), _foundation_js__WEBPACK_IMPORTED_MODULE_11__.F.body15L24);
var ButtonWrapper$1 = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(BoxButton,  true ? {
  target: "e1x05w0q0"
} : 0)(templateObject_7$1 || (templateObject_7$1 = (0,_common_js__WEBPACK_IMPORTED_MODULE_7__._)(["\n  width: 100%;\n  margin-top: 8px;\n"], ["\n  width: 100%;\n  margin-top: 8px;\n"])));
var templateObject_1$2, templateObject_2$2, templateObject_3$2, templateObject_4$2, templateObject_5$1, templateObject_6$1, templateObject_7$1;

var Input = /*#__PURE__*/(/* unused pure expression or super */ null && (forwardRef(function (props, ref) {
  var size = props.size,
    width = props.width,
    title = props.title,
    placeholder = props.placeholder,
    icon = props.icon,
    textButton = props.textButton,
    hint = props.hint,
    _a = props.error,
    error = _a === void 0 ? false : _a,
    _b = props.disabled,
    disabled = _b === void 0 ? false : _b,
    count = props.count,
    _c = props.value,
    value = _c === void 0 ? '' : _c,
    _onFocus = props.onFocus,
    _onBlur = props.onBlur,
    className = props.className,
    rest = __rest(props, ["size", "width", "title", "placeholder", "icon", "textButton", "hint", "error", "disabled", "count", "value", "onFocus", "onBlur", "className"]);
  var _d = useState(false),
    focused = _d[0],
    setFocused = _d[1];
  var _e = icon || {},
    IconComponent = _e.iconComponent,
    onIconClick = _e.onClick;
  var _f = textButton || {},
    text = _f.text,
    onTextButtonClick = _f.onClick;
  var _g = count || {},
    showCount = _g.showCount,
    max = _g.max;
  var isError = error || showCount && "".concat(value).length > max;
  return jsxs(Container$1, _assign({
    className: className,
    css: [width && /*#__PURE__*/css({
      width: width
    },  true ? "" : 0)],
    "data-testid": "input-container"
  }, {
    children: [title && jsx(Title$1, {
      children: title
    }), jsxs(InputWrapper, _assign({
      className: classNames('input-wrapper', {
        focused: focused,
        error: isError,
        disabled: disabled
      }),
      "data-testid": "input-wrapper"
    }, {
      children: [jsx(StyledInput, _assign({
        ref: ref,
        size: size,
        "data-testid": "input"
      }, rest, {
        value: value,
        disabled: disabled,
        placeholder: placeholder,
        onFocus: function onFocus(e) {
          if (_onFocus) {
            _onFocus(e);
          }
          setFocused(true);
        },
        onBlur: function onBlur(e) {
          if (_onBlur) {
            _onBlur(e);
          }
          setFocused(false);
        }
      })), IconComponent && jsx(IconComponent, {
        size: 18,
        className: classNames('input-icon'),
        "data-testid": "input-icon",
        fill: function fill(theme) {
          return theme.base.neutral500;
        },
        onClick: onIconClick,
        style: {
          verticalAlign: 'middle',
          margin: "auto ".concat(text ? '0' : '6px', " auto auto"),
          cursor: 'pointer'
        }
      }), text && jsx(TextButton, _assign({
        size: 14,
        className: classNames('input-text-button'),
        "data-testid": "input-text-button",
        variant: "primary",
        onClick: onTextButtonClick,
        disabled: value === '' || disabled,
        style: {
          verticalAlign: 'middle',
          margin: 'auto 4px auto auto',
          width: 'max-content'
        }
      }, {
        children: text
      }))]
    })), jsxs(StyledHelper, {
      children: [hint && jsx(StyledHint, _assign({
        className: classNames('input-hint', {
          error: isError
        })
      }, {
        children: hint
      })), showCount && jsxs(StyledHint, _assign({
        className: classNames('input-count', {
          error: isError
        }),
        style: {
          textAlign: 'right'
        }
      }, {
        children: ["".concat(value).length, "/", max]
      }))]
    })]
  }));
})));
var Container$1 = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("div",  true ? {
  target: "eagkmyb5"
} : 0)(templateObject_1$1 || (templateObject_1$1 = (0,_common_js__WEBPACK_IMPORTED_MODULE_7__._)(["\n  user-select: none;\n  display: inline-block;\n"], ["\n  user-select: none;\n  display: inline-block;\n"])));
var Title$1 = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("div",  true ? {
  target: "eagkmyb4"
} : 0)(templateObject_2$1 || (templateObject_2$1 = (0,_common_js__WEBPACK_IMPORTED_MODULE_7__._)(["\n  ", ";\n  margin-bottom: 4px;\n  color: ", ";\n"], ["\n  ", ";\n  margin-bottom: 4px;\n  color: ", ";\n"])), _foundation_js__WEBPACK_IMPORTED_MODULE_11__.F.body14L18, function (_a) {
  var theme = _a.theme;
  return theme.base.neutral500;
});
var InputWrapper = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("div",  true ? {
  target: "eagkmyb3"
} : 0)(templateObject_3$1 || (templateObject_3$1 = (0,_common_js__WEBPACK_IMPORTED_MODULE_7__._)(["\n  border: 1px solid ", ";\n  border-radius: 4px;\n  display: flex;\n  width: 100%;\n\n  &.focused {\n    border-color: ", ";\n  }\n\n  &.error {\n    border-color: ", ";\n  }\n\n  &.disabled {\n    border-color: ", ";\n    background-color: ", ";\n    color: ", ";\n  }\n"], ["\n  border: 1px solid ", ";\n  border-radius: 4px;\n  display: flex;\n  width: 100%;\n\n  &.focused {\n    border-color: ", ";\n  }\n\n  &.error {\n    border-color: ", ";\n  }\n\n  &.disabled {\n    border-color: ", ";\n    background-color: ", ";\n    color: ", ";\n  }\n"])), function (_a) {
  var theme = _a.theme;
  return theme.border;
}, function (_a) {
  var theme = _a.theme;
  return theme.primary.basic;
}, function (_a) {
  var theme = _a.theme;
  return theme.accent.basic;
}, function (_a) {
  var theme = _a.theme;
  return theme.base.neutral300;
}, function (_a) {
  var theme = _a.theme;
  return theme.base.neutral100;
}, function (_a) {
  var theme = _a.theme;
  return theme.base.neutral400;
});
var StyledInput = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("input",  true ? {
  target: "eagkmyb2"
} : 0)(templateObject_6 || (templateObject_6 = (0,_common_js__WEBPACK_IMPORTED_MODULE_7__._)(["\n  ", ";\n  box-sizing: border-box;\n  color: ", ";\n  min-width: 0;\n  flex: 1 1;\n\n  ", "\n\n  ::placeholder {\n    color: ", ";\n  }\n\n  :focus {\n    outline: none;\n  }\n"], ["\n  ", ";\n  box-sizing: border-box;\n  color: ", ";\n  min-width: 0;\n  flex: 1 1;\n\n  ", "\n\n  ::placeholder {\n    color: ", ";\n  }\n\n  :focus {\n    outline: none;\n  }\n"])), _foundation_js__WEBPACK_IMPORTED_MODULE_11__.a, function (_a) {
  var theme = _a.theme;
  return theme.base.neutral700;
}, function (_a) {
  var size = _a.size;
  switch (size) {
    case 32:
      return /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_10__/* .css */ .iv)(templateObject_4$1 || (templateObject_4$1 = (0,_common_js__WEBPACK_IMPORTED_MODULE_7__._)(["\n          ", ";\n          height: 32px;\n          padding: 6px 12px;\n        " + ( true ? "" : 0)], ["\n          ", ";\n          height: 32px;\n          padding: 6px 12px;\n        " + ( true ? "" : 0)])), _foundation_js__WEBPACK_IMPORTED_MODULE_11__.F.body14L20);
    case 40:
      return /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_10__/* .css */ .iv)(templateObject_5 || (templateObject_5 = (0,_common_js__WEBPACK_IMPORTED_MODULE_7__._)(["\n          ", ";\n          height: 40px;\n          padding: 8px 12px;\n        " + ( true ? "" : 0)], ["\n          ", ";\n          height: 40px;\n          padding: 8px 12px;\n        " + ( true ? "" : 0)])), _foundation_js__WEBPACK_IMPORTED_MODULE_11__.F.body16L24);
  }
}, function (_a) {
  var theme = _a.theme;
  return theme.base.neutral400;
});
var StyledHelper = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("div",  true ? {
  target: "eagkmyb1"
} : 0)(templateObject_7 || (templateObject_7 = (0,_common_js__WEBPACK_IMPORTED_MODULE_7__._)(["\n  display: flex;\n"], ["\n  display: flex;\n"])));
var StyledHint = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("div",  true ? {
  target: "eagkmyb0"
} : 0)(templateObject_8 || (templateObject_8 = (0,_common_js__WEBPACK_IMPORTED_MODULE_7__._)(["\n  ", ";\n  color: ", ";\n  margin-top: 4px;\n  flex-grow: 1;\n\n  &.error {\n    color: ", ";\n  }\n"], ["\n  ", ";\n  color: ", ";\n  margin-top: 4px;\n  flex-grow: 1;\n\n  &.error {\n    color: ", ";\n  }\n"])), _foundation_js__WEBPACK_IMPORTED_MODULE_11__.F.detail12L16, function (_a) {
  var theme = _a.theme;
  return theme.base.neutral500;
}, function (_a) {
  var theme = _a.theme;
  return theme.accent.basic;
});
var templateObject_1$1, templateObject_2$1, templateObject_3$1, templateObject_4$1, templateObject_5, templateObject_6, templateObject_7, templateObject_8;

var Empty = /*#__PURE__*/(/* unused pure expression or super */ null && (forwardRef(function (props, ref) {
  var title = props.title,
    description = props.description,
    className = props.className,
    buttonText = props.buttonText,
    onButtonClick = props.onButtonClick,
    rest = __rest(props, ["title", "description", "className", "buttonText", "onButtonClick"]);
  return jsxs(Container, _assign({
    ref: ref
  }, rest, {
    className: className
  }, {
    children: [title && jsx(Title, {
      children: title
    }), description && jsx(Description, {
      children: description
    }), buttonText && jsx(ButtonWrapper, _assign({
      variant: "primary",
      shape: "filled",
      size: 44,
      onClick: onButtonClick
    }, {
      children: buttonText
    }))]
  }));
})));
var Container = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("div",  true ? {
  target: "e1ijkmt13"
} : 0)(templateObject_1 || (templateObject_1 = (0,_common_js__WEBPACK_IMPORTED_MODULE_7__._)(["\n  padding: 12px 16px;\n  text-align: center;\n"], ["\n  padding: 12px 16px;\n  text-align: center;\n"])));
var Title = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("div",  true ? {
  target: "e1ijkmt12"
} : 0)(templateObject_2 || (templateObject_2 = (0,_common_js__WEBPACK_IMPORTED_MODULE_7__._)(["\n  ", ";\n  font-weight: 600;\n  vertical-align: middle;\n  color: ", ";\n"], ["\n  ", ";\n  font-weight: 600;\n  vertical-align: middle;\n  color: ", ";\n"])), _foundation_js__WEBPACK_IMPORTED_MODULE_11__.F.heading20, function (_a) {
  var theme = _a.theme;
  return theme.base.neutral700;
});
var Description = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("div",  true ? {
  target: "e1ijkmt11"
} : 0)(templateObject_3 || (templateObject_3 = (0,_common_js__WEBPACK_IMPORTED_MODULE_7__._)(["\n  ", ";\n  vertical-align: middle;\n  color: ", ";\n"], ["\n  ", ";\n  vertical-align: middle;\n  color: ", ";\n"])), _foundation_js__WEBPACK_IMPORTED_MODULE_11__.F.body16L24, function (_a) {
  var theme = _a.theme;
  return theme.base.neutral500;
});
var ButtonWrapper = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(BoxButton,  true ? {
  target: "e1ijkmt10"
} : 0)(templateObject_4 || (templateObject_4 = (0,_common_js__WEBPACK_IMPORTED_MODULE_7__._)(["\n  margin-top: 8px;\n"], ["\n  margin-top: 8px;\n"])));
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;

function DesignSystemProvider(_a) {
  var mode = _a.mode,
    children = _a.children;
  var theme = mode === 'dark' ? _foundation_js__WEBPACK_IMPORTED_MODULE_11__.D : _foundation_js__WEBPACK_IMPORTED_MODULE_11__.L;
  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsx */ .tZ)(_emotion_react__WEBPACK_IMPORTED_MODULE_8__.a, (0,_common_js__WEBPACK_IMPORTED_MODULE_7__.a)({
    theme: theme
  }, {
    children: (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsx */ .tZ)(SnackbarProvider, {
      children: (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsx */ .tZ)(_bucketplace_ui__WEBPACK_IMPORTED_MODULE_4__/* .StickyProvider */ .nK, {
        children: (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsx */ .tZ)(_common_js__WEBPACK_IMPORTED_MODULE_7__.O, {
          children: children
        })
      })
    })
  }));
}
/**
 * @deprecated DesignSystemProvider 컴포넌트를 사용해 주세요.
 */
var BdsProvider = (/* unused pure expression or super */ null && (DesignSystemProvider));


//# sourceMappingURL=index.js.map


/***/ }),

/***/ 85353:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A": function() { return /* binding */ APP_BANNER_PATHNAME_BLACKLIST; },
/* harmony export */   "a": function() { return /* binding */ getImageUrl; },
/* harmony export */   "b": function() { return /* binding */ getImageSrcSet; },
/* harmony export */   "c": function() { return /* binding */ getNearestSize; },
/* harmony export */   "d": function() { return /* binding */ calcImageSize; },
/* harmony export */   "e": function() { return /* binding */ APP_BANNER_SEARCH_BLACKLIST; },
/* harmony export */   "g": function() { return /* binding */ getDeviceInfo; },
/* harmony export */   "i": function() { return /* binding */ isHigherAppVersion; }
/* harmony export */ });
/* harmony import */ var qs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93672);
/* harmony import */ var qs__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(qs__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _common_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(68479);



/**
 * app인지 web인지 확인하고, app일 경우 추가로 app의 osType, osVersion도 확인합니다.
 * @param query query
 * @returns app이라면 isApp: true, osType, osVersion을 return. web이라면 isApp: false를 return.
 */
function getDeviceInfo(query) {
  var osType = null;
  var osVersion = null;
  if (typeof window === 'undefined') {
    if (query != null) {
      osType = query.os_type;
      osVersion = query.version;
    }
  } else {
    var search = (0,qs__WEBPACK_IMPORTED_MODULE_0__.parse)(location.search.slice(1));
    if (search.os_type != null) {
      osType = search.os_type;
      sessionStorage.os_type = search.os_type;
    } else {
      osType = sessionStorage.os_type;
    }
    if (search.os_version != null) {
      osVersion = search.version;
      sessionStorage.os_version = search.version;
    } else {
      osVersion = sessionStorage.os_version;
    }
  }
  if (osVersion == null && osType == null) {
    return {
      isApp: false
    };
  } else {
    return {
      isApp: true,
      osType: osType,
      osVersion: osVersion
    };
  }
}
/**
 * params로 받은 AOS, iOS 버전보다 높은 버전의 app인지 확인합니다.
 * @param AOS 기준 AOS 버전
 * @param iOS 기준 iOS 버전
 * @param query query
 * @returns params로 받은 AOS, iOS 버전보다 높은 버전인 App일 경우 true. Web or MWeb or 기준보다 낮은 버전일 경우 false.
 */
function isHigherAppVersion(_a) {
  var AOS = _a.AOS,
    iOS = _a.iOS,
    query = _a.query;
  var _b = getDeviceInfo(query),
    isApp = _b.isApp,
    osType = _b.osType,
    osVersion = _b.osVersion;
  if (!isApp || !osType || !osVersion) return false;
  var targetSelected;
  if (osType === 'Android') {
    targetSelected = AOS;
  } else if (osType === 'iOS') {
    targetSelected = iOS;
  } else {
    return false;
  }
  var currentVersion = /^\d+(\.(\d+))+/.exec(osVersion);
  if (!currentVersion) {
    return false;
  }
  var targetFragments = targetSelected.split('.');
  var versionFragments = currentVersion[0].split('.');
  for (var i = 0; i < targetFragments.length; i += 1) {
    var targetFragment = parseInt(targetFragments[i], 10);
    var versionFragment = parseInt(versionFragments[i], 10);
    if (targetFragment > versionFragment) {
      return false;
    } else if (targetFragment < versionFragment) {
      return true;
    }
  }
  return false;
}

// e.g. https://prs.ohou.se/kr/any/examples/v1-141430605185088.jpg
// e.g. https://prs.ohouse.com/apne2/any/uploads/commerce/event/raffle/v1-175699276497024.png
var PRS_IMAGE_PATTERN = /*#__PURE__*/(0,_common_js__WEBPACK_IMPORTED_MODULE_1__.f)(/^(https?:\/\/(?:\w+\x2D)?prs\.(?:ohou\.se|ohouse\.com)\/[^?]+).*/, {
  src: 1
});
// e.g. https://image.ohou.se/i/{bucketplace-v2-development}/*
var IMAGE_OHOUSE_PATTERN = /*#__PURE__*/(0,_common_js__WEBPACK_IMPORTED_MODULE_1__.f)(/^(https?:\/\/(?:image\.ohou\.se\/i|(?:\w+\x2D)?image\.ohouse\.com)\/[^?]+).*/, {
  src: 1
});
// e.g. /oh-s3-video-{envPath}/*
// /oh-s3-video-apne2-stage-thumbnail/65685e94888fb53cb1f2e33c/65685e94888fb53cb1f2e33c.0000001.jpg
var VIDEO_THUMBNAIL_PATTERN = /*#__PURE__*/(0,_common_js__WEBPACK_IMPORTED_MODULE_1__.f)(/^(\/oh\x2Ds3\x2Dvideo[^?]+).*/, {
  path: 1
});
// e.g.
// https://image.ohou.se/image/central_crop/{bucketplace-v2-development}/*
// https://image.ohou.se/image/resize/{bucketplace-v2-development}/*
var IMAGE_OHOUSE_LEGACY_PATTERN = /*#__PURE__*/(0,_common_js__WEBPACK_IMPORTED_MODULE_1__.f)(/^https?:\/\/image\.ohou\.se\/image\/(?:central_crop|resize)\/([^/]+)\/([^/]+)\/.*/, {
  bucket: 1,
  path: 2
});
// e.g. https://s3-{region}.amazonaws.com/{bucket}/{path}
var S3_LOCAL_PATTERN = /*#__PURE__*/(0,_common_js__WEBPACK_IMPORTED_MODULE_1__.f)(/^https?:\/\/s3\x2D(?:[^.]+)\.amazonaws.com\/([^?/]+)\/([^?]+).*/, {
  bucket: 1,
  path: 2
});
// e.g.
// https://{bucket}.cloudfront.net/*
// https://{bucket}.s3.amazonaws.com/*
// https://{bucket}.s3.{region}.amazonaws.com/{path}
var S3_LOCAL_PATTERN_2 = /*#__PURE__*/(0,_common_js__WEBPACK_IMPORTED_MODULE_1__.f)(/^https?:\/\/([^.]+)\.(?:cloudfront.net|s3\.(?:[^.]+\.)?amazonaws\.com)\/([^?]+)/, {
  bucket: 1,
  path: 2
});
var OLD_BUCKET_NAMES = ['d224jl0o7z9gbn', 'd12gkpu9h0k5iq'];
var NEW_BUCKET_NAME = 'bucketplace-v2-development';
var IMAGE_HOST = 'image.ohou.se';
var GLOBAL_IMAGE_HOST = 'image.ohouse.com';
var GLOBAL_QA_IMAGE_HOST = 'qa-image.ohouse.com';
var GLOBAL_BUCKET_LIST = ['video-service-prd-s3-bucket-thumbnail', 'oh-image-stage', 'oh-image-ap-northeast-2', 'oh-image-ap-southeast-1', 'oh-image-eu-central-1', 'oh-image-us-east-1', 'oh-image-us-west-2', 'oh-s3-video-qa-thumbnail'];
/**
 * @param imageOptions 이미지 옵션
 * @returns {string} 변환된 이미지 경로
 *
 * getImageUrl은 다음과 같은 규칙으로 이미지 경로를 변환합니다.
 * 1. prs를 사용하는 이미지 경로라면 imageOptions 만 query로 추가하여 반환합니다.
 * 2. 이미 이미지서버를 사용하고 있는 이미지 경로라면 imageOptions 만 query로 추가하여 반환합니다.
 * 3. 비디오 서버 썸네일에 해당하는 이미지 절대경로라면 국외향 이미지서버 url로 변환합니다.
 * 4. 이전 이미지 서버나 S3 버킷에 해당하는 이미지 경로라면 추출된 버킷에 따라 국내향 또는 국외향 이미지서버 url로 변환합니다.
 * 5. 위의 조건 중 어디에도 해당하지 않는다면 src를 그대로 반환합니다.
 */
function getImageUrl(imageOptions) {
  var src = imageOptions.src;
  if (src === '') {
    return src;
  }
  var optionQueries = buildCdnOptionsQuerystring(imageOptions);
  var extraQueries = extractQuerystring(src);
  var query = "?".concat(optionQueries, "&").concat(extraQueries).replace(/(&|\?|\?&)$/, '');
  var match;
  // Use PRS CDN if possible
  if (match = PRS_IMAGE_PATTERN.exec(src), (match === null || match === void 0 ? void 0 : match.groups) != null) {
    var src_1 = match.groups.src;
    return "".concat(src_1).concat(query);
  }
  // Use src if it is already from image-server
  if (match = IMAGE_OHOUSE_PATTERN.exec(src), (match === null || match === void 0 ? void 0 : match.groups) != null) {
    var src_2 = match.groups.src;
    return "".concat(src_2).concat(query);
  }
  // Use global image-server if it starts with '/oh-s3-video'
  if (match = VIDEO_THUMBNAIL_PATTERN.exec(src), (match === null || match === void 0 ? void 0 : match.groups) != null) {
    var path = match.groups.path;
    var preProdEnv = ['dev', 'stage', 'qa'].find(function (env) {
      return src.includes(env);
    });
    if (preProdEnv != null) {
      return "https://".concat(preProdEnv, "-").concat(GLOBAL_IMAGE_HOST).concat(path).concat(query);
    }
    // prod 일 경우
    return "https://".concat(GLOBAL_IMAGE_HOST).concat(path).concat(query);
  }
  // Convert to image-server if it is legacy image server url or s3 bucket url
  if (match = IMAGE_OHOUSE_LEGACY_PATTERN.exec(src), (match === null || match === void 0 ? void 0 : match.groups) != null) {
    var _a = match.groups,
      bucket = _a.bucket,
      path = _a.path;
    return "https://".concat(IMAGE_HOST, "/i/").concat(bucket, "/").concat(path.replace(/-/g, '/')).concat(query);
  } else if (match = S3_LOCAL_PATTERN.exec(src), (match === null || match === void 0 ? void 0 : match.groups) != null) {
    var _b = match.groups,
      bucket = _b.bucket,
      path = _b.path;
    var bucketName = OLD_BUCKET_NAMES.includes(bucket) ? NEW_BUCKET_NAME : bucket;
    var isDomestic = bucketName === NEW_BUCKET_NAME;
    var host = isDomestic ? "".concat(IMAGE_HOST, "/i") : GLOBAL_IMAGE_HOST;
    return "https://".concat(host, "/").concat(bucketName, "/").concat(path).concat(query);
  } else if (match = S3_LOCAL_PATTERN_2.exec(src), (match === null || match === void 0 ? void 0 : match.groups) != null) {
    var _c = match.groups,
      bucket = _c.bucket,
      path = _c.path;
    var bucketName = OLD_BUCKET_NAMES.includes(bucket) ? NEW_BUCKET_NAME : bucket;
    var isDomestic_1 = !GLOBAL_BUCKET_LIST.includes(bucketName);
    var isQA_1 = bucketName.includes('qa');
    var host = function () {
      if (isDomestic_1) return "".concat(IMAGE_HOST, "/i");
      if (isQA_1) return GLOBAL_QA_IMAGE_HOST;
      return GLOBAL_IMAGE_HOST;
    }();
    return "https://".concat(host, "/").concat(bucketName, "/").concat(path).concat(query);
  }
  return src;
}
function buildCdnOptionsQuerystring(_a) {
  var width = _a.width,
    height = _a.height,
    mode = _a.mode,
    quality = _a.quality;
  var query = {};
  if (width != null) query.w = String(width);
  if (height != null) query.h = String(height);
  if (mode != null) query.c = String(mode[0]);
  if (quality != null) query.q = String(quality);
  return (0,qs__WEBPACK_IMPORTED_MODULE_0__.stringify)(query);
}
function extractQuerystring(src) {
  var match = src.match(/\?(.+)/);
  return match ? match[1] : '';
}

var getImageSrcSet = function getImageSrcSet(imageOptions, ratios) {
  return ratios.map(function (ratio) {
    return "".concat(getImageUrl((0,_common_js__WEBPACK_IMPORTED_MODULE_1__.a)((0,_common_js__WEBPACK_IMPORTED_MODULE_1__.a)((0,_common_js__WEBPACK_IMPORTED_MODULE_1__.a)({}, imageOptions), imageOptions.width && {
      width: imageOptions.width * ratio
    }), imageOptions.height && {
      height: imageOptions.height * ratio
    })), " ").concat(ratio, "x");
  }).join(',');
};

var IMAGE_SIZES = [36, 72, 144, 180, 256, 360, 480, 512, 640, 720, 850, 960, 1024, 1280, 1360, 1440, 1536, 1700, 1920, 2048, 2560];
function getNearestSize(originSize) {
  var _a;
  return (_a = IMAGE_SIZES.find(function (size) {
    return size >= originSize;
  })) !== null && _a !== void 0 ? _a : IMAGE_SIZES[IMAGE_SIZES.length - 1];
}

var calcImageSize = function calcImageSize(_a) {
  var width = _a.width,
    height = _a.height,
    aspect = _a.aspect;
  if (height) {
    var nearestHeight = getNearestSize(height);
    return (0,_common_js__WEBPACK_IMPORTED_MODULE_1__.a)({
      height: nearestHeight
    }, aspect && {
      width: Math.ceil(nearestHeight * aspect)
    });
  }
  var nearestWidth = getNearestSize(width);
  return (0,_common_js__WEBPACK_IMPORTED_MODULE_1__.a)({
    width: nearestWidth
  }, aspect && {
    height: Math.ceil(nearestWidth / aspect)
  });
};

var APP_BANNER_PATHNAME_BLACKLIST = /^\/normal_users|^\/sessions|^\/orders|^\/contacts|^\/exhibitions|^\/cart|^\/3d_intro|^\/interior3ds|^\/payment_personal_info/;
var APP_BANNER_SEARCH_BLACKLIST = /utm_source=(naver_shop|kakao_shop)|no_app_banner=true/;


//# sourceMappingURL=utils.js.map


/***/ }),

/***/ 94834:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Mw": function() { return /* binding */ openPopup; }
/* harmony export */ });
/* unused harmony exports ENDPOINT, MOBILE_USER_AGENT_REGEX, asyncCopyText, calculateExponentStep, copyText, copyTextToClipboard, decomposeHangul, filter, formatComma, formatLargeNumber, getLoginURL, getOutdatedBrowserNoticeScript, getQuery, groupBy, isArray, isBoolean, isBrowser, isEmpty, isError, isFunction, isIE, isIOS, isInApp, isInteger, isMobileDevice, isNaN, isNil, isNull, isNumber, isObject, isSafari, isString, isSymbol, isUndefined, keyBy, map, mapValues, memoize, omit, pick, scrollToElement, sendEventIpc, smoothPageScrollWithDuration, stringToNumber, subscribeEventIpc, upload, uploadFile, uploadImage */
/* module decorator */ module = __webpack_require__.hmd(module);
'use client';
/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function arrayMap(array, iteratee) {
  var index = -1,
    length = array == null ? 0 : array.length,
    result = Array(length);
  while (++index < length) {
    result[index] = iteratee(array[index], index, array);
  }
  return result;
}

function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
function _arrayWithHoles(r) {
  if (Array.isArray(r)) return r;
}
function _arrayWithoutHoles(r) {
  if (Array.isArray(r)) return _arrayLikeToArray(r);
}
function asyncGeneratorStep(n, t, e, r, o, a, c) {
  try {
    var i = n[a](c),
      u = i.value;
  } catch (n) {
    return void e(n);
  }
  i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function _asyncToGenerator(n) {
  return function () {
    var t = this,
      e = arguments;
    return new Promise(function (r, o) {
      var a = n.apply(t, e);
      function _next(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
      }
      function _throw(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
      }
      _next(void 0);
    });
  };
}
function _createForOfIteratorHelper(r, e) {
  var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (!t) {
    if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
      t && (r = t);
      var n = 0,
        F = function () {};
      return {
        s: F,
        n: function () {
          return n >= r.length ? {
            done: !0
          } : {
            done: !1,
            value: r[n++]
          };
        },
        e: function (r) {
          throw r;
        },
        f: F
      };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var o,
    a = !0,
    u = !1;
  return {
    s: function () {
      t = t.call(r);
    },
    n: function () {
      var r = t.next();
      return a = r.done, r;
    },
    e: function (r) {
      u = !0, o = r;
    },
    f: function () {
      try {
        a || null == t.return || t.return();
      } finally {
        if (u) throw o;
      }
    }
  };
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function _iterableToArray(r) {
  if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}
function _iterableToArrayLimit(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (null != t) {
    var e,
      n,
      i,
      u,
      a = [],
      f = !0,
      o = !1;
    try {
      if (i = (t = t.call(r)).next, 0 === l) {
        if (Object(t) !== t) return;
        f = !1;
      } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
    } catch (r) {
      o = !0, n = r;
    } finally {
      try {
        if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return;
      } finally {
        if (o) throw n;
      }
    }
    return a;
  }
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _regeneratorRuntime() {
  _regeneratorRuntime = function () {
    return e;
  };
  var t,
    e = {},
    r = Object.prototype,
    n = r.hasOwnProperty,
    o = Object.defineProperty || function (t, e, r) {
      t[e] = r.value;
    },
    i = "function" == typeof Symbol ? Symbol : {},
    a = i.iterator || "@@iterator",
    c = i.asyncIterator || "@@asyncIterator",
    u = i.toStringTag || "@@toStringTag";
  function define(t, e, r) {
    return Object.defineProperty(t, e, {
      value: r,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }), t[e];
  }
  try {
    define({}, "");
  } catch (t) {
    define = function (t, e, r) {
      return t[e] = r;
    };
  }
  function wrap(t, e, r, n) {
    var i = e && e.prototype instanceof Generator ? e : Generator,
      a = Object.create(i.prototype),
      c = new Context(n || []);
    return o(a, "_invoke", {
      value: makeInvokeMethod(t, r, c)
    }), a;
  }
  function tryCatch(t, e, r) {
    try {
      return {
        type: "normal",
        arg: t.call(e, r)
      };
    } catch (t) {
      return {
        type: "throw",
        arg: t
      };
    }
  }
  e.wrap = wrap;
  var h = "suspendedStart",
    l = "suspendedYield",
    f = "executing",
    s = "completed",
    y = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  var p = {};
  define(p, a, function () {
    return this;
  });
  var d = Object.getPrototypeOf,
    v = d && d(d(values([])));
  v && v !== r && n.call(v, a) && (p = v);
  var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p);
  function defineIteratorMethods(t) {
    ["next", "throw", "return"].forEach(function (e) {
      define(t, e, function (t) {
        return this._invoke(e, t);
      });
    });
  }
  function AsyncIterator(t, e) {
    function invoke(r, o, i, a) {
      var c = tryCatch(t[r], t, o);
      if ("throw" !== c.type) {
        var u = c.arg,
          h = u.value;
        return h && "object" == typeof h && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) {
          invoke("next", t, i, a);
        }, function (t) {
          invoke("throw", t, i, a);
        }) : e.resolve(h).then(function (t) {
          u.value = t, i(u);
        }, function (t) {
          return invoke("throw", t, i, a);
        });
      }
      a(c.arg);
    }
    var r;
    o(this, "_invoke", {
      value: function (t, n) {
        function callInvokeWithMethodAndArg() {
          return new e(function (e, r) {
            invoke(t, n, e, r);
          });
        }
        return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
      }
    });
  }
  function makeInvokeMethod(e, r, n) {
    var o = h;
    return function (i, a) {
      if (o === f) throw Error("Generator is already running");
      if (o === s) {
        if ("throw" === i) throw a;
        return {
          value: t,
          done: !0
        };
      }
      for (n.method = i, n.arg = a;;) {
        var c = n.delegate;
        if (c) {
          var u = maybeInvokeDelegate(c, n);
          if (u) {
            if (u === y) continue;
            return u;
          }
        }
        if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) {
          if (o === h) throw o = s, n.arg;
          n.dispatchException(n.arg);
        } else "return" === n.method && n.abrupt("return", n.arg);
        o = f;
        var p = tryCatch(e, r, n);
        if ("normal" === p.type) {
          if (o = n.done ? s : l, p.arg === y) continue;
          return {
            value: p.arg,
            done: n.done
          };
        }
        "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg);
      }
    };
  }
  function maybeInvokeDelegate(e, r) {
    var n = r.method,
      o = e.iterator[n];
    if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y;
    var i = tryCatch(o, e.iterator, r.arg);
    if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y;
    var a = i.arg;
    return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y);
  }
  function pushTryEntry(t) {
    var e = {
      tryLoc: t[0]
    };
    1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e);
  }
  function resetTryEntry(t) {
    var e = t.completion || {};
    e.type = "normal", delete e.arg, t.completion = e;
  }
  function Context(t) {
    this.tryEntries = [{
      tryLoc: "root"
    }], t.forEach(pushTryEntry, this), this.reset(!0);
  }
  function values(e) {
    if (e || "" === e) {
      var r = e[a];
      if (r) return r.call(e);
      if ("function" == typeof e.next) return e;
      if (!isNaN(e.length)) {
        var o = -1,
          i = function next() {
            for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next;
            return next.value = t, next.done = !0, next;
          };
        return i.next = i;
      }
    }
    throw new TypeError(typeof e + " is not iterable");
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", {
    value: GeneratorFunctionPrototype,
    configurable: !0
  }), o(GeneratorFunctionPrototype, "constructor", {
    value: GeneratorFunction,
    configurable: !0
  }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) {
    var e = "function" == typeof t && t.constructor;
    return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name));
  }, e.mark = function (t) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t;
  }, e.awrap = function (t) {
    return {
      __await: t
    };
  }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () {
    return this;
  }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) {
    void 0 === i && (i = Promise);
    var a = new AsyncIterator(wrap(t, r, n, o), i);
    return e.isGeneratorFunction(r) ? a : a.next().then(function (t) {
      return t.done ? t.value : a.next();
    });
  }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () {
    return this;
  }), define(g, "toString", function () {
    return "[object Generator]";
  }), e.keys = function (t) {
    var e = Object(t),
      r = [];
    for (var n in e) r.push(n);
    return r.reverse(), function next() {
      for (; r.length;) {
        var t = r.pop();
        if (t in e) return next.value = t, next.done = !1, next;
      }
      return next.done = !0, next;
    };
  }, e.values = values, Context.prototype = {
    constructor: Context,
    reset: function (e) {
      if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t);
    },
    stop: function () {
      this.done = !0;
      var t = this.tryEntries[0].completion;
      if ("throw" === t.type) throw t.arg;
      return this.rval;
    },
    dispatchException: function (e) {
      if (this.done) throw e;
      var r = this;
      function handle(n, o) {
        return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o;
      }
      for (var o = this.tryEntries.length - 1; o >= 0; --o) {
        var i = this.tryEntries[o],
          a = i.completion;
        if ("root" === i.tryLoc) return handle("end");
        if (i.tryLoc <= this.prev) {
          var c = n.call(i, "catchLoc"),
            u = n.call(i, "finallyLoc");
          if (c && u) {
            if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
            if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
          } else if (c) {
            if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
          } else {
            if (!u) throw Error("try statement without catch or finally");
            if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
          }
        }
      }
    },
    abrupt: function (t, e) {
      for (var r = this.tryEntries.length - 1; r >= 0; --r) {
        var o = this.tryEntries[r];
        if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) {
          var i = o;
          break;
        }
      }
      i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null);
      var a = i ? i.completion : {};
      return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a);
    },
    complete: function (t, e) {
      if ("throw" === t.type) throw t.arg;
      return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y;
    },
    finish: function (t) {
      for (var e = this.tryEntries.length - 1; e >= 0; --e) {
        var r = this.tryEntries[e];
        if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y;
      }
    },
    catch: function (t) {
      for (var e = this.tryEntries.length - 1; e >= 0; --e) {
        var r = this.tryEntries[e];
        if (r.tryLoc === t) {
          var n = r.completion;
          if ("throw" === n.type) {
            var o = n.arg;
            resetTryEntry(r);
          }
          return o;
        }
      }
      throw Error("illegal catch attempt");
    },
    delegateYield: function (e, r, n) {
      return this.delegate = {
        iterator: values(e),
        resultName: r,
        nextLoc: n
      }, "next" === this.method && (this.arg = t), y;
    }
  }, e;
}
function _slicedToArray(r, e) {
  return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest();
}
function _toConsumableArray(r) {
  return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread();
}
function _toPrimitive(t, r) {
  if ("object" != typeof t || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != typeof i) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == typeof i ? i : i + "";
}
function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
  this.size = 0;
}

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || value !== value && other !== other;
}

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

/** Used for built-in method references. */
var arrayProto = Array.prototype;

/** Built-in value references. */
var splice = arrayProto.splice;

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
    index = assocIndexOf(data, key);
  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  --this.size;
  return true;
}

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
    index = assocIndexOf(data, key);
  return index < 0 ? undefined : data[index][1];
}

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
    index = assocIndexOf(data, key);
  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
    length = entries == null ? 0 : entries.length;
  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear() {
  this.__data__ = new ListCache();
  this.size = 0;
}

/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function stackDelete(key) {
  var data = this.__data__,
    result = data['delete'](key);
  this.size = data.size;
  return result;
}

/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function stackGet(key) {
  return this.__data__.get(key);
}

/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function stackHas(key) {
  return this.__data__.has(key);
}

/** Detect free variable `global` from Node.js. */
var freeGlobal = (typeof __webpack_require__.g === "undefined" ? "undefined" : _typeof(__webpack_require__.g)) == 'object' && __webpack_require__.g && __webpack_require__.g.Object === Object && __webpack_require__.g;
var freeGlobal$1 = freeGlobal;

/** Detect free variable `self`. */
var freeSelf = (typeof self === "undefined" ? "undefined" : _typeof(self)) == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal$1 || freeSelf || Function('return this')();
var root$1 = root;

/** Built-in value references. */
var _Symbol = root$1.Symbol;
var _Symbol$1 = _Symbol;

/** Used for built-in method references. */
var objectProto$h = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$e = objectProto$h.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString$1 = objectProto$h.toString;

/** Built-in value references. */
var symToStringTag$1 = _Symbol$1 ? _Symbol$1.toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty$e.call(value, symToStringTag$1),
    tag = value[symToStringTag$1];
  try {
    value[symToStringTag$1] = undefined;
    var unmasked = true;
  } catch (e) {}
  var result = nativeObjectToString$1.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag$1] = tag;
    } else {
      delete value[symToStringTag$1];
    }
  }
  return result;
}

/** Used for built-in method references. */
var objectProto$g = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto$g.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

/** `Object#toString` result references. */
var nullTag = '[object Null]',
  undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = _Symbol$1 ? _Symbol$1.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return symToStringTag && symToStringTag in Object(value) ? getRawTag(value) : objectToString(value);
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject$1(value) {
  var type = _typeof(value);
  return value != null && (type == 'object' || type == 'function');
}

/** `Object#toString` result references. */
var asyncTag = '[object AsyncFunction]',
  funcTag$2 = '[object Function]',
  genTag$1 = '[object GeneratorFunction]',
  proxyTag = '[object Proxy]';

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction$1(value) {
  if (!isObject$1(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = baseGetTag(value);
  return tag == funcTag$2 || tag == genTag$1 || tag == asyncTag || tag == proxyTag;
}

/** Used to detect overreaching core-js shims. */
var coreJsData = root$1['__core-js_shared__'];
var coreJsData$1 = coreJsData;

/** Used to detect methods masquerading as native. */
var maskSrcKey = function () {
  var uid = /[^.]+$/.exec(coreJsData$1 && coreJsData$1.keys && coreJsData$1.keys.IE_PROTO || '');
  return uid ? 'Symbol(src)_1.' + uid : '';
}();

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && maskSrcKey in func;
}

/** Used for built-in method references. */
var funcProto$2 = Function.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString$2 = funcProto$2.toString;

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString$2.call(func);
    } catch (e) {}
    try {
      return func + '';
    } catch (e) {}
  }
  return '';
}

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used for built-in method references. */
var funcProto$1 = Function.prototype,
  objectProto$f = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString$1 = funcProto$1.toString;

/** Used to check objects for own properties. */
var hasOwnProperty$d = objectProto$f.hasOwnProperty;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' + funcToString$1.call(hasOwnProperty$d).replace(reRegExpChar, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject$1(value) || isMasked(value)) {
    return false;
  }
  var pattern = isFunction$1(value) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

/* Built-in method references that are verified to be native. */
var Map = getNative(root$1, 'Map');
var Map$1 = Map;

/* Built-in method references that are verified to be native. */
var nativeCreate = getNative(Object, 'create');
var nativeCreate$1 = nativeCreate;

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate$1 ? nativeCreate$1(null) : {};
  this.size = 0;
}

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED$2 = '__lodash_hash_undefined__';

/** Used for built-in method references. */
var objectProto$e = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$c = objectProto$e.hasOwnProperty;

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate$1) {
    var result = data[key];
    return result === HASH_UNDEFINED$2 ? undefined : result;
  }
  return hasOwnProperty$c.call(data, key) ? data[key] : undefined;
}

/** Used for built-in method references. */
var objectProto$d = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$b = objectProto$d.hasOwnProperty;

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate$1 ? data[key] !== undefined : hasOwnProperty$b.call(data, key);
}

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED$1 = '__lodash_hash_undefined__';

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = nativeCreate$1 && value === undefined ? HASH_UNDEFINED$1 : value;
  return this;
}

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
    length = entries == null ? 0 : entries.length;
  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.size = 0;
  this.__data__ = {
    'hash': new Hash(),
    'map': new (Map$1 || ListCache)(),
    'string': new Hash()
  };
}

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = _typeof(value);
  return type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean' ? value !== '__proto__' : value === null;
}

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key) ? data[typeof key == 'string' ? 'string' : 'hash'] : data.map;
}

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  var result = getMapData(this, key)['delete'](key);
  this.size -= result ? 1 : 0;
  return result;
}

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  var data = getMapData(this, key),
    size = data.size;
  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
    length = entries == null ? 0 : entries.length;
  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet(key, value) {
  var data = this.__data__;
  if (data instanceof ListCache) {
    var pairs = data.__data__;
    if (!Map$1 || pairs.length < LARGE_ARRAY_SIZE - 1) {
      pairs.push([key, value]);
      this.size = ++data.size;
      return this;
    }
    data = this.__data__ = new MapCache(pairs);
  }
  data.set(key, value);
  this.size = data.size;
  return this;
}

/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack(entries) {
  var data = this.__data__ = new ListCache(entries);
  this.size = data.size;
}

// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype['delete'] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */
function setCacheAdd(value) {
  this.__data__.set(value, HASH_UNDEFINED);
  return this;
}

/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */
function setCacheHas(value) {
  return this.__data__.has(value);
}

/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */
function SetCache(values) {
  var index = -1,
    length = values == null ? 0 : values.length;
  this.__data__ = new MapCache();
  while (++index < length) {
    this.add(values[index]);
  }
}

// Add methods to `SetCache`.
SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
SetCache.prototype.has = setCacheHas;

/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */
function arraySome(array, predicate) {
  var index = -1,
    length = array == null ? 0 : array.length;
  while (++index < length) {
    if (predicate(array[index], index, array)) {
      return true;
    }
  }
  return false;
}

/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function cacheHas(cache, key) {
  return cache.has(key);
}

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG$5 = 1,
  COMPARE_UNORDERED_FLAG$3 = 2;

/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */
function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG$5,
    arrLength = array.length,
    othLength = other.length;
  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
    return false;
  }
  // Check that cyclic values are equal.
  var arrStacked = stack.get(array);
  var othStacked = stack.get(other);
  if (arrStacked && othStacked) {
    return arrStacked == other && othStacked == array;
  }
  var index = -1,
    result = true,
    seen = bitmask & COMPARE_UNORDERED_FLAG$3 ? new SetCache() : undefined;
  stack.set(array, other);
  stack.set(other, array);

  // Ignore non-index properties.
  while (++index < arrLength) {
    var arrValue = array[index],
      othValue = other[index];
    if (customizer) {
      var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
    }
    if (compared !== undefined) {
      if (compared) {
        continue;
      }
      result = false;
      break;
    }
    // Recursively compare arrays (susceptible to call stack limits).
    if (seen) {
      if (!arraySome(other, function (othValue, othIndex) {
        if (!cacheHas(seen, othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
          return seen.push(othIndex);
        }
      })) {
        result = false;
        break;
      }
    } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
      result = false;
      break;
    }
  }
  stack['delete'](array);
  stack['delete'](other);
  return result;
}

/** Built-in value references. */
var Uint8Array = root$1.Uint8Array;
var Uint8Array$1 = Uint8Array;

/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */
function mapToArray(map) {
  var index = -1,
    result = Array(map.size);
  map.forEach(function (value, key) {
    result[++index] = [key, value];
  });
  return result;
}

/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */
function setToArray(set) {
  var index = -1,
    result = Array(set.size);
  set.forEach(function (value) {
    result[++index] = value;
  });
  return result;
}

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG$4 = 1,
  COMPARE_UNORDERED_FLAG$2 = 2;

/** `Object#toString` result references. */
var boolTag$4 = '[object Boolean]',
  dateTag$3 = '[object Date]',
  errorTag$3 = '[object Error]',
  mapTag$6 = '[object Map]',
  numberTag$4 = '[object Number]',
  regexpTag$3 = '[object RegExp]',
  setTag$6 = '[object Set]',
  stringTag$4 = '[object String]',
  symbolTag$3 = '[object Symbol]';
var arrayBufferTag$3 = '[object ArrayBuffer]',
  dataViewTag$4 = '[object DataView]';

/** Used to convert symbols to primitives and strings. */
var symbolProto$2 = _Symbol$1 ? _Symbol$1.prototype : undefined,
  symbolValueOf$1 = symbolProto$2 ? symbolProto$2.valueOf : undefined;

/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
  switch (tag) {
    case dataViewTag$4:
      if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) {
        return false;
      }
      object = object.buffer;
      other = other.buffer;
    case arrayBufferTag$3:
      if (object.byteLength != other.byteLength || !equalFunc(new Uint8Array$1(object), new Uint8Array$1(other))) {
        return false;
      }
      return true;
    case boolTag$4:
    case dateTag$3:
    case numberTag$4:
      // Coerce booleans to `1` or `0` and dates to milliseconds.
      // Invalid dates are coerced to `NaN`.
      return eq(+object, +other);
    case errorTag$3:
      return object.name == other.name && object.message == other.message;
    case regexpTag$3:
    case stringTag$4:
      // Coerce regexes to strings and treat strings, primitives and objects,
      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
      // for more details.
      return object == other + '';
    case mapTag$6:
      var convert = mapToArray;
    case setTag$6:
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG$4;
      convert || (convert = setToArray);
      if (object.size != other.size && !isPartial) {
        return false;
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(object);
      if (stacked) {
        return stacked == other;
      }
      bitmask |= COMPARE_UNORDERED_FLAG$2;

      // Recursively compare objects (susceptible to call stack limits).
      stack.set(object, other);
      var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
      stack['delete'](object);
      return result;
    case symbolTag$3:
      if (symbolValueOf$1) {
        return symbolValueOf$1.call(object) == symbolValueOf$1.call(other);
      }
  }
  return false;
}

/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */
function arrayPush(array, values) {
  var index = -1,
    length = values.length,
    offset = array.length;
  while (++index < length) {
    array[offset + index] = values[index];
  }
  return array;
}

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray$1 = Array.isArray;
var isArray$2 = isArray$1;

/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */
function baseGetAllKeys(object, keysFunc, symbolsFunc) {
  var result = keysFunc(object);
  return isArray$2(object) ? result : arrayPush(result, symbolsFunc(object));
}

/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */
function arrayFilter(array, predicate) {
  var index = -1,
    length = array == null ? 0 : array.length,
    resIndex = 0,
    result = [];
  while (++index < length) {
    var value = array[index];
    if (predicate(value, index, array)) {
      result[resIndex++] = value;
    }
  }
  return result;
}

/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */
function stubArray() {
  return [];
}

/** Used for built-in method references. */
var objectProto$c = Object.prototype;

/** Built-in value references. */
var propertyIsEnumerable$1 = objectProto$c.propertyIsEnumerable;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols$1 = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbols = !nativeGetSymbols$1 ? stubArray : function (object) {
  if (object == null) {
    return [];
  }
  object = Object(object);
  return arrayFilter(nativeGetSymbols$1(object), function (symbol) {
    return propertyIsEnumerable$1.call(object, symbol);
  });
};
var getSymbols$1 = getSymbols;

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
    result = Array(n);
  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && _typeof(value) == 'object';
}

/** `Object#toString` result references. */
var argsTag$3 = '[object Arguments]';

/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */
function baseIsArguments(value) {
  return isObjectLike(value) && baseGetTag(value) == argsTag$3;
}

/** Used for built-in method references. */
var objectProto$b = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$a = objectProto$b.hasOwnProperty;

/** Built-in value references. */
var propertyIsEnumerable = objectProto$b.propertyIsEnumerable;

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
var isArguments = baseIsArguments(function () {
  return arguments;
}()) ? baseIsArguments : function (value) {
  return isObjectLike(value) && hasOwnProperty$a.call(value, 'callee') && !propertyIsEnumerable.call(value, 'callee');
};
var isArguments$1 = isArguments;

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

/** Detect free variable `exports`. */
var freeExports$2 = (typeof exports === "undefined" ? "undefined" : _typeof(exports)) == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule$2 = freeExports$2 && ( false ? 0 : _typeof(module)) == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports$2 = freeModule$2 && freeModule$2.exports === freeExports$2;

/** Built-in value references. */
var Buffer$1 = moduleExports$2 ? root$1.Buffer : undefined;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeIsBuffer = Buffer$1 ? Buffer$1.isBuffer : undefined;

/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */
var isBuffer = nativeIsBuffer || stubFalse;
var isBuffer$1 = isBuffer;

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER$1 = 9007199254740991;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  var type = _typeof(value);
  length = length == null ? MAX_SAFE_INTEGER$1 : length;
  return !!length && (type == 'number' || type != 'symbol' && reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

/** `Object#toString` result references. */
var argsTag$2 = '[object Arguments]',
  arrayTag$2 = '[object Array]',
  boolTag$3 = '[object Boolean]',
  dateTag$2 = '[object Date]',
  errorTag$2 = '[object Error]',
  funcTag$1 = '[object Function]',
  mapTag$5 = '[object Map]',
  numberTag$3 = '[object Number]',
  objectTag$4 = '[object Object]',
  regexpTag$2 = '[object RegExp]',
  setTag$5 = '[object Set]',
  stringTag$3 = '[object String]',
  weakMapTag$2 = '[object WeakMap]';
var arrayBufferTag$2 = '[object ArrayBuffer]',
  dataViewTag$3 = '[object DataView]',
  float32Tag$2 = '[object Float32Array]',
  float64Tag$2 = '[object Float64Array]',
  int8Tag$2 = '[object Int8Array]',
  int16Tag$2 = '[object Int16Array]',
  int32Tag$2 = '[object Int32Array]',
  uint8Tag$2 = '[object Uint8Array]',
  uint8ClampedTag$2 = '[object Uint8ClampedArray]',
  uint16Tag$2 = '[object Uint16Array]',
  uint32Tag$2 = '[object Uint32Array]';

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags = {};
typedArrayTags[float32Tag$2] = typedArrayTags[float64Tag$2] = typedArrayTags[int8Tag$2] = typedArrayTags[int16Tag$2] = typedArrayTags[int32Tag$2] = typedArrayTags[uint8Tag$2] = typedArrayTags[uint8ClampedTag$2] = typedArrayTags[uint16Tag$2] = typedArrayTags[uint32Tag$2] = true;
typedArrayTags[argsTag$2] = typedArrayTags[arrayTag$2] = typedArrayTags[arrayBufferTag$2] = typedArrayTags[boolTag$3] = typedArrayTags[dataViewTag$3] = typedArrayTags[dateTag$2] = typedArrayTags[errorTag$2] = typedArrayTags[funcTag$1] = typedArrayTags[mapTag$5] = typedArrayTags[numberTag$3] = typedArrayTags[objectTag$4] = typedArrayTags[regexpTag$2] = typedArrayTags[setTag$5] = typedArrayTags[stringTag$3] = typedArrayTags[weakMapTag$2] = false;

/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */
function baseIsTypedArray(value) {
  return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
}

/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function baseUnary(func) {
  return function (value) {
    return func(value);
  };
}

/** Detect free variable `exports`. */
var freeExports$1 = (typeof exports === "undefined" ? "undefined" : _typeof(exports)) == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule$1 = freeExports$1 && ( false ? 0 : _typeof(module)) == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports$1 = freeModule$1 && freeModule$1.exports === freeExports$1;

/** Detect free variable `process` from Node.js. */
var freeProcess = moduleExports$1 && freeGlobal$1.process;

/** Used to access faster Node.js helpers. */
var nodeUtil = function () {
  try {
    // Use `util.types` for Node.js 10+.
    var types = freeModule$1 && freeModule$1.require && freeModule$1.require('util').types;
    if (types) {
      return types;
    }

    // Legacy `process.binding('util')` for Node.js < 10.
    return freeProcess && freeProcess.binding && freeProcess.binding('util');
  } catch (e) {}
}();
var nodeUtil$1 = nodeUtil;

/* Node.js helper references. */
var nodeIsTypedArray = nodeUtil$1 && nodeUtil$1.isTypedArray;

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
var isTypedArray$1 = isTypedArray;

/** Used for built-in method references. */
var objectProto$a = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$9 = objectProto$a.hasOwnProperty;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  var isArr = isArray$2(value),
    isArg = !isArr && isArguments$1(value),
    isBuff = !isArr && !isArg && isBuffer$1(value),
    isType = !isArr && !isArg && !isBuff && isTypedArray$1(value),
    skipIndexes = isArr || isArg || isBuff || isType,
    result = skipIndexes ? baseTimes(value.length, String) : [],
    length = result.length;
  for (var key in value) {
    if ((inherited || hasOwnProperty$9.call(value, key)) && !(skipIndexes && (
    // Safari 9 has enumerable `arguments.length` in strict mode.
    key == 'length' ||
    // Node.js 0.10 has enumerable non-index properties on buffers.
    isBuff && (key == 'offset' || key == 'parent') ||
    // PhantomJS 2 has enumerable non-index properties on typed arrays.
    isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset') ||
    // Skip index properties.
    isIndex(key, length)))) {
      result.push(key);
    }
  }
  return result;
}

/** Used for built-in method references. */
var objectProto$9 = Object.prototype;

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
    proto = typeof Ctor == 'function' && Ctor.prototype || objectProto$9;
  return value === proto;
}

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function (arg) {
    return func(transform(arg));
  };
}

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys = overArg(Object.keys, Object);
var nativeKeys$1 = nativeKeys;

/** Used for built-in method references. */
var objectProto$8 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$8 = objectProto$8.hasOwnProperty;

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!isPrototype(object)) {
    return nativeKeys$1(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty$8.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction$1(value);
}

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}

/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeys(object) {
  return baseGetAllKeys(object, keys, getSymbols$1);
}

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG$3 = 1;

/** Used for built-in method references. */
var objectProto$7 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$7 = objectProto$7.hasOwnProperty;

/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG$3,
    objProps = getAllKeys(object),
    objLength = objProps.length,
    othProps = getAllKeys(other),
    othLength = othProps.length;
  if (objLength != othLength && !isPartial) {
    return false;
  }
  var index = objLength;
  while (index--) {
    var key = objProps[index];
    if (!(isPartial ? key in other : hasOwnProperty$7.call(other, key))) {
      return false;
    }
  }
  // Check that cyclic values are equal.
  var objStacked = stack.get(object);
  var othStacked = stack.get(other);
  if (objStacked && othStacked) {
    return objStacked == other && othStacked == object;
  }
  var result = true;
  stack.set(object, other);
  stack.set(other, object);
  var skipCtor = isPartial;
  while (++index < objLength) {
    key = objProps[index];
    var objValue = object[key],
      othValue = other[key];
    if (customizer) {
      var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
    }
    // Recursively compare objects (susceptible to call stack limits).
    if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
      result = false;
      break;
    }
    skipCtor || (skipCtor = key == 'constructor');
  }
  if (result && !skipCtor) {
    var objCtor = object.constructor,
      othCtor = other.constructor;

    // Non `Object` object instances with different constructors are not equal.
    if (objCtor != othCtor && 'constructor' in object && 'constructor' in other && !(typeof objCtor == 'function' && objCtor instanceof objCtor && typeof othCtor == 'function' && othCtor instanceof othCtor)) {
      result = false;
    }
  }
  stack['delete'](object);
  stack['delete'](other);
  return result;
}

/* Built-in method references that are verified to be native. */
var DataView = getNative(root$1, 'DataView');
var DataView$1 = DataView;

/* Built-in method references that are verified to be native. */
var Promise$1 = getNative(root$1, 'Promise');
var Promise$2 = Promise$1;

/* Built-in method references that are verified to be native. */
var Set = getNative(root$1, 'Set');
var Set$1 = Set;

/* Built-in method references that are verified to be native. */
var WeakMap = getNative(root$1, 'WeakMap');
var WeakMap$1 = WeakMap;

/** `Object#toString` result references. */
var mapTag$4 = '[object Map]',
  objectTag$3 = '[object Object]',
  promiseTag = '[object Promise]',
  setTag$4 = '[object Set]',
  weakMapTag$1 = '[object WeakMap]';
var dataViewTag$2 = '[object DataView]';

/** Used to detect maps, sets, and weakmaps. */
var dataViewCtorString = toSource(DataView$1),
  mapCtorString = toSource(Map$1),
  promiseCtorString = toSource(Promise$2),
  setCtorString = toSource(Set$1),
  weakMapCtorString = toSource(WeakMap$1);

/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
var getTag = baseGetTag;

// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if (DataView$1 && getTag(new DataView$1(new ArrayBuffer(1))) != dataViewTag$2 || Map$1 && getTag(new Map$1()) != mapTag$4 || Promise$2 && getTag(Promise$2.resolve()) != promiseTag || Set$1 && getTag(new Set$1()) != setTag$4 || WeakMap$1 && getTag(new WeakMap$1()) != weakMapTag$1) {
  getTag = function getTag(value) {
    var result = baseGetTag(value),
      Ctor = result == objectTag$3 ? value.constructor : undefined,
      ctorString = Ctor ? toSource(Ctor) : '';
    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString:
          return dataViewTag$2;
        case mapCtorString:
          return mapTag$4;
        case promiseCtorString:
          return promiseTag;
        case setCtorString:
          return setTag$4;
        case weakMapCtorString:
          return weakMapTag$1;
      }
    }
    return result;
  };
}
var getTag$1 = getTag;

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG$2 = 1;

/** `Object#toString` result references. */
var argsTag$1 = '[object Arguments]',
  arrayTag$1 = '[object Array]',
  objectTag$2 = '[object Object]';

/** Used for built-in method references. */
var objectProto$6 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$6 = objectProto$6.hasOwnProperty;

/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
  var objIsArr = isArray$2(object),
    othIsArr = isArray$2(other),
    objTag = objIsArr ? arrayTag$1 : getTag$1(object),
    othTag = othIsArr ? arrayTag$1 : getTag$1(other);
  objTag = objTag == argsTag$1 ? objectTag$2 : objTag;
  othTag = othTag == argsTag$1 ? objectTag$2 : othTag;
  var objIsObj = objTag == objectTag$2,
    othIsObj = othTag == objectTag$2,
    isSameTag = objTag == othTag;
  if (isSameTag && isBuffer$1(object)) {
    if (!isBuffer$1(other)) {
      return false;
    }
    objIsArr = true;
    objIsObj = false;
  }
  if (isSameTag && !objIsObj) {
    stack || (stack = new Stack());
    return objIsArr || isTypedArray$1(object) ? equalArrays(object, other, bitmask, customizer, equalFunc, stack) : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
  }
  if (!(bitmask & COMPARE_PARTIAL_FLAG$2)) {
    var objIsWrapped = objIsObj && hasOwnProperty$6.call(object, '__wrapped__'),
      othIsWrapped = othIsObj && hasOwnProperty$6.call(other, '__wrapped__');
    if (objIsWrapped || othIsWrapped) {
      var objUnwrapped = objIsWrapped ? object.value() : object,
        othUnwrapped = othIsWrapped ? other.value() : other;
      stack || (stack = new Stack());
      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
    }
  }
  if (!isSameTag) {
    return false;
  }
  stack || (stack = new Stack());
  return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
}

/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */
function baseIsEqual(value, other, bitmask, customizer, stack) {
  if (value === other) {
    return true;
  }
  if (value == null || other == null || !isObjectLike(value) && !isObjectLike(other)) {
    return value !== value && other !== other;
  }
  return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
}

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG$1 = 1,
  COMPARE_UNORDERED_FLAG$1 = 2;

/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */
function baseIsMatch(object, source, matchData, customizer) {
  var index = matchData.length,
    length = index,
    noCustomizer = !customizer;
  if (object == null) {
    return !length;
  }
  object = Object(object);
  while (index--) {
    var data = matchData[index];
    if (noCustomizer && data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) {
      return false;
    }
  }
  while (++index < length) {
    data = matchData[index];
    var key = data[0],
      objValue = object[key],
      srcValue = data[1];
    if (noCustomizer && data[2]) {
      if (objValue === undefined && !(key in object)) {
        return false;
      }
    } else {
      var stack = new Stack();
      if (customizer) {
        var result = customizer(objValue, srcValue, key, object, source, stack);
      }
      if (!(result === undefined ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG$1 | COMPARE_UNORDERED_FLAG$1, customizer, stack) : result)) {
        return false;
      }
    }
  }
  return true;
}

/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */
function isStrictComparable(value) {
  return value === value && !isObject$1(value);
}

/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */
function getMatchData(object) {
  var result = keys(object),
    length = result.length;
  while (length--) {
    var key = result[length],
      value = object[key];
    result[length] = [key, value, isStrictComparable(value)];
  }
  return result;
}

/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function matchesStrictComparable(key, srcValue) {
  return function (object) {
    if (object == null) {
      return false;
    }
    return object[key] === srcValue && (srcValue !== undefined || key in Object(object));
  };
}

/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatches(source) {
  var matchData = getMatchData(source);
  if (matchData.length == 1 && matchData[0][2]) {
    return matchesStrictComparable(matchData[0][0], matchData[0][1]);
  }
  return function (object) {
    return object === source || baseIsMatch(object, source, matchData);
  };
}

/** `Object#toString` result references. */
var symbolTag$2 = '[object Symbol]';

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol$1(value) {
  return _typeof(value) == 'symbol' || isObjectLike(value) && baseGetTag(value) == symbolTag$2;
}

/** Used to match property names within property paths. */
var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
  reIsPlainProp = /^\w*$/;

/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */
function isKey(value, object) {
  if (isArray$2(value)) {
    return false;
  }
  var type = _typeof(value);
  if (type == 'number' || type == 'symbol' || type == 'boolean' || value == null || isSymbol$1(value)) {
    return true;
  }
  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) || object != null && value in Object(object);
}

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */
function memoize$1(func, resolver) {
  if (typeof func != 'function' || resolver != null && typeof resolver != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  var memoized = function memoized() {
    var args = arguments,
      key = resolver ? resolver.apply(this, args) : args[0],
      cache = memoized.cache;
    if (cache.has(key)) {
      return cache.get(key);
    }
    var result = func.apply(this, args);
    memoized.cache = cache.set(key, result) || cache;
    return result;
  };
  memoized.cache = new (memoize$1.Cache || MapCache)();
  return memoized;
}

// Expose `MapCache`.
memoize$1.Cache = MapCache;

/** Used as the maximum memoize cache size. */
var MAX_MEMOIZE_SIZE = 500;

/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */
function memoizeCapped(func) {
  var result = memoize$1(func, function (key) {
    if (cache.size === MAX_MEMOIZE_SIZE) {
      cache.clear();
    }
    return key;
  });
  var cache = result.cache;
  return result;
}

/** Used to match property names within property paths. */
var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

/** Used to match backslashes in property paths. */
var reEscapeChar = /\\(\\)?/g;

/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */
var stringToPath = memoizeCapped(function (string) {
  var result = [];
  if (string.charCodeAt(0) === 46 /* . */) {
    result.push('');
  }
  string.replace(rePropName, function (match, number, quote, subString) {
    result.push(quote ? subString.replace(reEscapeChar, '$1') : number || match);
  });
  return result;
});
var stringToPath$1 = stringToPath;

/** Used as references for various `Number` constants. */
var INFINITY$2 = 1 / 0;

/** Used to convert symbols to primitives and strings. */
var symbolProto$1 = _Symbol$1 ? _Symbol$1.prototype : undefined,
  symbolToString = symbolProto$1 ? symbolProto$1.toString : undefined;

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isArray$2(value)) {
    // Recursively convert values (susceptible to call stack limits).
    return arrayMap(value, baseToString) + '';
  }
  if (isSymbol$1(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = value + '';
  return result == '0' && 1 / value == -INFINITY$2 ? '-0' : result;
}

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString(value) {
  return value == null ? '' : baseToString(value);
}

/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */
function castPath(value, object) {
  if (isArray$2(value)) {
    return value;
  }
  return isKey(value, object) ? [value] : stringToPath$1(toString(value));
}

/** Used as references for various `Number` constants. */
var INFINITY$1 = 1 / 0;

/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */
function toKey(value) {
  if (typeof value == 'string' || isSymbol$1(value)) {
    return value;
  }
  var result = value + '';
  return result == '0' && 1 / value == -INFINITY$1 ? '-0' : result;
}

/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */
function baseGet(object, path) {
  path = castPath(path, object);
  var index = 0,
    length = path.length;
  while (object != null && index < length) {
    object = object[toKey(path[index++])];
  }
  return index && index == length ? object : undefined;
}

/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */
function get(object, path, defaultValue) {
  var result = object == null ? undefined : baseGet(object, path);
  return result === undefined ? defaultValue : result;
}

/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */
function baseHasIn(object, key) {
  return object != null && key in Object(object);
}

/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */
function hasPath(object, path, hasFunc) {
  path = castPath(path, object);
  var index = -1,
    length = path.length,
    result = false;
  while (++index < length) {
    var key = toKey(path[index]);
    if (!(result = object != null && hasFunc(object, key))) {
      break;
    }
    object = object[key];
  }
  if (result || ++index != length) {
    return result;
  }
  length = object == null ? 0 : object.length;
  return !!length && isLength(length) && isIndex(key, length) && (isArray$2(object) || isArguments$1(object));
}

/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */
function hasIn(object, path) {
  return object != null && hasPath(object, path, baseHasIn);
}

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
  COMPARE_UNORDERED_FLAG = 2;

/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatchesProperty(path, srcValue) {
  if (isKey(path) && isStrictComparable(srcValue)) {
    return matchesStrictComparable(toKey(path), srcValue);
  }
  return function (object) {
    var objValue = get(object, path);
    return objValue === undefined && objValue === srcValue ? hasIn(object, path) : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
  };
}

/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function identity(value) {
  return value;
}

/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function baseProperty(key) {
  return function (object) {
    return object == null ? undefined : object[key];
  };
}

/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function basePropertyDeep(path) {
  return function (object) {
    return baseGet(object, path);
  };
}

/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */
function property(path) {
  return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
}

/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */
function baseIteratee(value) {
  // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
  // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
  if (typeof value == 'function') {
    return value;
  }
  if (value == null) {
    return identity;
  }
  if (_typeof(value) == 'object') {
    return isArray$2(value) ? baseMatchesProperty(value[0], value[1]) : baseMatches(value);
  }
  return property(value);
}

/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseFor(fromRight) {
  return function (object, iteratee, keysFunc) {
    var index = -1,
      iterable = Object(object),
      props = keysFunc(object),
      length = props.length;
    while (length--) {
      var key = props[fromRight ? length : ++index];
      if (iteratee(iterable[key], key, iterable) === false) {
        break;
      }
    }
    return object;
  };
}

/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */
var baseFor = createBaseFor();
var baseFor$1 = baseFor;

/**
 * The base implementation of `_.forOwn` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */
function baseForOwn(object, iteratee) {
  return object && baseFor$1(object, iteratee, keys);
}

/**
 * Creates a `baseEach` or `baseEachRight` function.
 *
 * @private
 * @param {Function} eachFunc The function to iterate over a collection.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseEach(eachFunc, fromRight) {
  return function (collection, iteratee) {
    if (collection == null) {
      return collection;
    }
    if (!isArrayLike(collection)) {
      return eachFunc(collection, iteratee);
    }
    var length = collection.length,
      index = fromRight ? length : -1,
      iterable = Object(collection);
    while (fromRight ? index-- : ++index < length) {
      if (iteratee(iterable[index], index, iterable) === false) {
        break;
      }
    }
    return collection;
  };
}

/**
 * The base implementation of `_.forEach` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 */
var baseEach = createBaseEach(baseForOwn);
var baseEach$1 = baseEach;

/**
 * The base implementation of `_.map` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function baseMap(collection, iteratee) {
  var index = -1,
    result = isArrayLike(collection) ? Array(collection.length) : [];
  baseEach$1(collection, function (value, key, collection) {
    result[++index] = iteratee(value, key, collection);
  });
  return result;
}

/**
 * Creates an array of values by running each element in `collection` thru
 * `iteratee`. The iteratee is invoked with three arguments:
 * (value, index|key, collection).
 *
 * Many lodash methods are guarded to work as iteratees for methods like
 * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
 *
 * The guarded methods are:
 * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
 * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
 * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
 * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 * @example
 *
 * function square(n) {
 *   return n * n;
 * }
 *
 * _.map([4, 8], square);
 * // => [16, 64]
 *
 * _.map({ 'a': 4, 'b': 8 }, square);
 * // => [16, 64] (iteration order is not guaranteed)
 *
 * var users = [
 *   { 'user': 'barney' },
 *   { 'user': 'fred' }
 * ];
 *
 * // The `_.property` iteratee shorthand.
 * _.map(users, 'user');
 * // => ['barney', 'fred']
 */
function map$1(collection, iteratee) {
  var func = isArray$2(collection) ? arrayMap : baseMap;
  return func(collection, baseIteratee(iteratee));
}

/**
 * 주어진 컬렉션(배열 또는 객체)의 각 요소에 iteratee 함수를 적용한 결과를 새 배열로 반환합니다.
 * @param {Array|Object} collection - 처리할 컬렉션 (배열 또는 객체).
 * @param {Function} iteratee - 각 요소에 적용할 함수.
 * @returns {Array} iteratee 함수를 적용한 결과를 담은 새 배열.
 *
 * @example
 * 배열에 대해 map 함수 사용:
 * map([1, 2, 3], x => x * 2); // [2, 4, 6]
 *
 * 객체에 대해 map 함수 사용:
 * map({ 'a': 1, 'b': 2, 'c': 3 }, (value, key) => value * 2); // [2, 4, 6]
 */
var map = (/* unused pure expression or super */ null && (map$1));

var defineProperty = function () {
  try {
    var func = getNative(Object, 'defineProperty');
    func({}, '', {});
    return func;
  } catch (e) {}
}();
var defineProperty$1 = defineProperty;

/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function baseAssignValue(object, key, value) {
  if (key == '__proto__' && defineProperty$1) {
    defineProperty$1(object, key, {
      'configurable': true,
      'enumerable': true,
      'value': value,
      'writable': true
    });
  } else {
    object[key] = value;
  }
}

/**
 * A specialized version of `baseAggregator` for arrays.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} setter The function to set `accumulator` values.
 * @param {Function} iteratee The iteratee to transform keys.
 * @param {Object} accumulator The initial aggregated object.
 * @returns {Function} Returns `accumulator`.
 */
function arrayAggregator(array, setter, iteratee, accumulator) {
  var index = -1,
    length = array == null ? 0 : array.length;
  while (++index < length) {
    var value = array[index];
    setter(accumulator, value, iteratee(value), array);
  }
  return accumulator;
}

/**
 * Aggregates elements of `collection` on `accumulator` with keys transformed
 * by `iteratee` and values set by `setter`.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} setter The function to set `accumulator` values.
 * @param {Function} iteratee The iteratee to transform keys.
 * @param {Object} accumulator The initial aggregated object.
 * @returns {Function} Returns `accumulator`.
 */
function baseAggregator(collection, setter, iteratee, accumulator) {
  baseEach$1(collection, function (value, key, collection) {
    setter(accumulator, value, iteratee(value), collection);
  });
  return accumulator;
}

/**
 * Creates a function like `_.groupBy`.
 *
 * @private
 * @param {Function} setter The function to set accumulator values.
 * @param {Function} [initializer] The accumulator object initializer.
 * @returns {Function} Returns the new aggregator function.
 */
function createAggregator(setter, initializer) {
  return function (collection, iteratee) {
    var func = isArray$2(collection) ? arrayAggregator : baseAggregator,
      accumulator = initializer ? initializer() : {};
    return func(collection, setter, baseIteratee(iteratee), accumulator);
  };
}

/** Used for built-in method references. */
var objectProto$5 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$5 = objectProto$5.hasOwnProperty;

/**
 * Creates an object composed of keys generated from the results of running
 * each element of `collection` thru `iteratee`. The order of grouped values
 * is determined by the order they occur in `collection`. The corresponding
 * value of each key is an array of elements responsible for generating the
 * key. The iteratee is invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
 * @returns {Object} Returns the composed aggregate object.
 * @example
 *
 * _.groupBy([6.1, 4.2, 6.3], Math.floor);
 * // => { '4': [4.2], '6': [6.1, 6.3] }
 *
 * // The `_.property` iteratee shorthand.
 * _.groupBy(['one', 'two', 'three'], 'length');
 * // => { '3': ['one', 'two'], '5': ['three'] }
 */
var groupBy$1 = createAggregator(function (result, value, key) {
  if (hasOwnProperty$5.call(result, key)) {
    result[key].push(value);
  } else {
    baseAssignValue(result, key, [value]);
  }
});
var groupBy$2 = (/* unused pure expression or super */ null && (groupBy$1));

/**
 * groupBy(collection, [iteratee=_.identity])
 * 컬렉션의 요소를 iteratee가 반환하는 기준에 따라 그룹화합니다.
 * 결과는 각 그룹의 키를 속성으로 가지고, 해당 키에 해당하는 요소들의 배열을 값으로 가지는 객체입니다.
 *
 * @param {Array|Object} collection - 그룹화할 컬렉션.
 * @param {Function|Object|string} [iteratee=_.identity] - 각 요소를 그룹화할 기준을 제공하는 함수, 객체, 또는 속성 이름.
 * @returns {Object} 그룹화된 객체.
 *
 * @example
 * groupBy([6.1, 4.2, 6.3], Math.floor); // => { '4': [4.2], '6': [6.1, 6.3] }
 *
 * @example
 * // `_.property` iteratee shorthand를 사용하는 예시.
 * groupBy(['one', 'two', 'three'], 'length'); // => { '3': ['one', 'two'], '5': ['three'] }
 *
 * @see [Lodash Documentation for groupBy]{@link https://lodash.com/docs/4.17.15#groupBy}
 *
 * Lodash 문서에 따른 추가 설명:
 * Creates an object composed of keys generated from the results of running each element of collection thru iteratee.
 * The corresponding value of each key is an array of the elements responsible for generating the key.
 * The iteratee is invoked with one argument: (value).
 */
var groupBy = (/* unused pure expression or super */ null && (groupBy$2));

/**
 * The base implementation of `_.filter` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */
function baseFilter(collection, predicate) {
  var result = [];
  baseEach$1(collection, function (value, index, collection) {
    if (predicate(value, index, collection)) {
      result.push(value);
    }
  });
  return result;
}

/**
 * Iterates over elements of `collection`, returning an array of all elements
 * `predicate` returns truthy for. The predicate is invoked with three
 * arguments: (value, index|key, collection).
 *
 * **Note:** Unlike `_.remove`, this method returns a new array.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 * @see _.reject
 * @example
 *
 * var users = [
 *   { 'user': 'barney', 'age': 36, 'active': true },
 *   { 'user': 'fred',   'age': 40, 'active': false }
 * ];
 *
 * _.filter(users, function(o) { return !o.active; });
 * // => objects for ['fred']
 *
 * // The `_.matches` iteratee shorthand.
 * _.filter(users, { 'age': 36, 'active': true });
 * // => objects for ['barney']
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.filter(users, ['active', false]);
 * // => objects for ['fred']
 *
 * // The `_.property` iteratee shorthand.
 * _.filter(users, 'active');
 * // => objects for ['barney']
 *
 * // Combining several predicates using `_.overEvery` or `_.overSome`.
 * _.filter(users, _.overSome([{ 'age': 36 }, ['age', 40]]));
 * // => objects for ['fred', 'barney']
 */
function filter$1(collection, predicate) {
  var func = isArray$2(collection) ? arrayFilter : baseFilter;
  return func(collection, baseIteratee(predicate));
}

/**
 * `filter(collection, predicate)`
 *
 * 컬렉션(배열 또는 객체)의 각 요소에 대해 조건 함수(predicate)를 실행하고,
 * 그 결과가 참인 요소들만을 모아 새로운 배열로 반환합니다. `predicate`는 각 요소에 대해 호출되며,
 * 배열에서는 요소 값, 객체에서는 요소의 값이 조건 함수에 전달됩니다.
 *
 * `predicate`는 다양한 방식으로 지정할 수 있습니다:
 * - 함수: 각 요소에 대해 실행할 함수 (value, index|key, collection)를 인자로 받습니다.
 * - 객체: `_.matches`의 shorthand. 요소가 주어진 객체와 일치하는지 확인합니다.
 * - 배열: `_.matchesProperty`의 shorthand. 주어진 경로의 값이 주어진 값과 일치하는지 확인합니다.
 * - 문자열: `_.property`의 shorthand. 주어진 경로의 속성 값이 truthy인지 확인합니다.
 *
 * @param {Array|Object} collection - 필터링할 컬렉션.
 * @param {Function|Object|Array|string} predicate - 각 요소를 평가할 조건.
 * @returns {Array} 조건을 만족하는 요소들로 구성된 새 배열.
 *
 * @example
 * filter([1, 2, 3, 4], n => n % 2 === 0); // => [2, 4]
 *
 * @example
 * const users = { 'fred': { 'age': 40, 'active': false }, 'barney': { 'age': 36, 'active': true } };
 * // 객체 속성 값에 대해 조건 함수를 적용하는 예시
 * filter(users, ({ age }) => age < 40); // => [{ 'age': 36, 'active': true }]
 *
 * @example
 * const users = [{ 'user': 'barney', 'age': 36, 'active': true }, { 'user': 'fred', 'age': 40, 'active': false }];
 * // `_.matches` shorthand 사용 예시
 * filter(users, { 'age': 36, 'active': true }); // => [{ 'user': 'barney', 'age': 36, 'active': true }]
 *
 * // `_.matchesProperty` shorthand 사용 예시
 * filter(users, ['active', false]); // => [{ 'user': 'fred', 'age': 40, 'active': false }]
 *
 * // `_.property` shorthand 사용 예시
 * filter(users, 'active'); // => [{ 'user': 'barney', 'age': 36, 'active': true }]
 *
 * @see [Lodash Documentation for filter]{@link https://lodash.com/docs/latest#filter}
 *
 * Lodash 문서에 따른 추가 설명:
 * Iterates over elements of collection, returning an array of all elements predicate returns truthy for.
 * The predicate is invoked with three arguments: (value, index|key, collection).
 * Can be used with functions, objects, arrays, or strings as predicate to filter items.
 */
var filter = (/* unused pure expression or super */ null && (filter$1));

/**
 * Creates an object composed of keys generated from the results of running
 * each element of `collection` thru `iteratee`. The corresponding value of
 * each key is the last element responsible for generating the key. The
 * iteratee is invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
 * @returns {Object} Returns the composed aggregate object.
 * @example
 *
 * var array = [
 *   { 'dir': 'left', 'code': 97 },
 *   { 'dir': 'right', 'code': 100 }
 * ];
 *
 * _.keyBy(array, function(o) {
 *   return String.fromCharCode(o.code);
 * });
 * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
 *
 * _.keyBy(array, 'dir');
 * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
 */
var keyBy$1 = createAggregator(function (result, value, key) {
  baseAssignValue(result, key, value);
});
var keyBy$2 = (/* unused pure expression or super */ null && (keyBy$1));

/**
 * `keyBy(collection, iteratee)`
 *
 * 컬렉션(주로 배열)의 각 요소를 iteratee에 의해 반환된 키로 매핑하여 객체로 변환합니다.
 * iteratee는 각 요소에 대해 호출되며, 반환된 값은 객체의 키로 사용됩니다. 이 함수는 배열의 요소를
 * 객체의 속성으로 정리하고 싶을 때 유용하게 사용될 수 있습니다.
 *
 * @param {Array|Object} collection - 키로 매핑할 컬렉션.
 * @param {Function|Object|string} iteratee - 각 요소에 대해 실행할 함수 또는 속성 이름.
 * @returns {Object} 요소들이 키로 매핑된 객체.
 *
 * @example
 * const array = [{ 'dir': 'left', 'code': 97 }, { 'dir': 'right', 'code': 100 }];
 * keyBy(array, function(o) { return String.fromCharCode(o.code); });
 * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
 *
 * @example
 * keyBy(array, 'dir');
 * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
 *
 * @see [Lodash Documentation for keyBy]{@link https://lodash.com/docs/latest#keyBy}
 *
 * Lodash 문서에 따른 추가 설명:
 * Creates an object composed of keys generated from the results of running each element of collection through iteratee.
 * The order of grouped values is determined by the order they occur in the collection.
 * The iteratee is invoked with one argument: (value).
 */
var keyBy = (/* unused pure expression or super */ null && (keyBy$2));

var queryString = {};

var strictUriEncode = function strictUriEncode(str) {
  return encodeURIComponent(str).replace(/[!'()*]/g, function (x) {
    return "%".concat(x.charCodeAt(0).toString(16).toUpperCase());
  });
};

var token = '%[a-f0-9]{2}';
var singleMatcher = new RegExp('(' + token + ')|([^%]+?)', 'gi');
var multiMatcher = new RegExp('(' + token + ')+', 'gi');
function decodeComponents(components, split) {
  try {
    // Try to decode the entire string first
    return [decodeURIComponent(components.join(''))];
  } catch (err) {
    // Do nothing
  }
  if (components.length === 1) {
    return components;
  }
  split = split || 1;

  // Split the array in 2 parts
  var left = components.slice(0, split);
  var right = components.slice(split);
  return Array.prototype.concat.call([], decodeComponents(left), decodeComponents(right));
}
function decode(input) {
  try {
    return decodeURIComponent(input);
  } catch (err) {
    var tokens = input.match(singleMatcher) || [];
    for (var i = 1; i < tokens.length; i++) {
      input = decodeComponents(tokens, i).join('');
      tokens = input.match(singleMatcher) || [];
    }
    return input;
  }
}
function customDecodeURIComponent(input) {
  // Keep track of all the replacements and prefill the map with the `BOM`
  var replaceMap = {
    '%FE%FF': "\uFFFD\uFFFD",
    '%FF%FE': "\uFFFD\uFFFD"
  };
  var match = multiMatcher.exec(input);
  while (match) {
    try {
      // Decode as big chunks as possible
      replaceMap[match[0]] = decodeURIComponent(match[0]);
    } catch (err) {
      var result = decode(match[0]);
      if (result !== match[0]) {
        replaceMap[match[0]] = result;
      }
    }
    match = multiMatcher.exec(input);
  }

  // Add `%C2` at the end of the map to make sure it does not replace the combinator before everything else
  replaceMap['%C2'] = "\uFFFD";
  var entries = Object.keys(replaceMap);
  for (var i = 0; i < entries.length; i++) {
    // Replace all decoded components
    var key = entries[i];
    input = input.replace(new RegExp(key, 'g'), replaceMap[key]);
  }
  return input;
}
var decodeUriComponent = function decodeUriComponent(encodedURI) {
  if (typeof encodedURI !== 'string') {
    throw new TypeError('Expected `encodedURI` to be of type `string`, got `' + _typeof(encodedURI) + '`');
  }
  try {
    encodedURI = encodedURI.replace(/\+/g, ' ');

    // Try the built in decoder first
    return decodeURIComponent(encodedURI);
  } catch (err) {
    // Fallback to a more advanced decoder
    return customDecodeURIComponent(encodedURI);
  }
};

var splitOnFirst = function splitOnFirst(string, separator) {
  if (!(typeof string === 'string' && typeof separator === 'string')) {
    throw new TypeError('Expected the arguments to be of type `string`');
  }
  if (separator === '') {
    return [string];
  }
  var separatorIndex = string.indexOf(separator);
  if (separatorIndex === -1) {
    return [string];
  }
  return [string.slice(0, separatorIndex), string.slice(separatorIndex + separator.length)];
};

var filterObj = function filterObj(obj, predicate) {
  var ret = {};
  var keys = Object.keys(obj);
  var isArr = Array.isArray(predicate);
  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    var val = obj[key];
    if (isArr ? predicate.indexOf(key) !== -1 : predicate(key, val, obj)) {
      ret[key] = val;
    }
  }
  return ret;
};

(function (exports) {

  var strictUriEncode$1 = strictUriEncode;
  var decodeComponent = decodeUriComponent;
  var splitOnFirst$1 = splitOnFirst;
  var filterObject = filterObj;
  var isNullOrUndefined = function isNullOrUndefined(value) {
    return value === null || value === undefined;
  };
  var encodeFragmentIdentifier = Symbol('encodeFragmentIdentifier');
  function encoderForArrayFormat(options) {
    switch (options.arrayFormat) {
      case 'index':
        return function (key) {
          return function (result, value) {
            var index = result.length;
            if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === '') {
              return result;
            }
            if (value === null) {
              return [].concat(_toConsumableArray(result), [[encode(key, options), '[', index, ']'].join('')]);
            }
            return [].concat(_toConsumableArray(result), [[encode(key, options), '[', encode(index, options), ']=', encode(value, options)].join('')]);
          };
        };
      case 'bracket':
        return function (key) {
          return function (result, value) {
            if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === '') {
              return result;
            }
            if (value === null) {
              return [].concat(_toConsumableArray(result), [[encode(key, options), '[]'].join('')]);
            }
            return [].concat(_toConsumableArray(result), [[encode(key, options), '[]=', encode(value, options)].join('')]);
          };
        };
      case 'colon-list-separator':
        return function (key) {
          return function (result, value) {
            if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === '') {
              return result;
            }
            if (value === null) {
              return [].concat(_toConsumableArray(result), [[encode(key, options), ':list='].join('')]);
            }
            return [].concat(_toConsumableArray(result), [[encode(key, options), ':list=', encode(value, options)].join('')]);
          };
        };
      case 'comma':
      case 'separator':
      case 'bracket-separator':
        {
          var keyValueSep = options.arrayFormat === 'bracket-separator' ? '[]=' : '=';
          return function (key) {
            return function (result, value) {
              if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === '') {
                return result;
              }

              // Translate null to an empty string so that it doesn't serialize as 'null'
              value = value === null ? '' : value;
              if (result.length === 0) {
                return [[encode(key, options), keyValueSep, encode(value, options)].join('')];
              }
              return [[result, encode(value, options)].join(options.arrayFormatSeparator)];
            };
          };
        }
      default:
        return function (key) {
          return function (result, value) {
            if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === '') {
              return result;
            }
            if (value === null) {
              return [].concat(_toConsumableArray(result), [encode(key, options)]);
            }
            return [].concat(_toConsumableArray(result), [[encode(key, options), '=', encode(value, options)].join('')]);
          };
        };
    }
  }
  function parserForArrayFormat(options) {
    var result;
    switch (options.arrayFormat) {
      case 'index':
        return function (key, value, accumulator) {
          result = /\[(\d*)\]$/.exec(key);
          key = key.replace(/\[\d*\]$/, '');
          if (!result) {
            accumulator[key] = value;
            return;
          }
          if (accumulator[key] === undefined) {
            accumulator[key] = {};
          }
          accumulator[key][result[1]] = value;
        };
      case 'bracket':
        return function (key, value, accumulator) {
          result = /(\[\])$/.exec(key);
          key = key.replace(/\[\]$/, '');
          if (!result) {
            accumulator[key] = value;
            return;
          }
          if (accumulator[key] === undefined) {
            accumulator[key] = [value];
            return;
          }
          accumulator[key] = [].concat(accumulator[key], value);
        };
      case 'colon-list-separator':
        return function (key, value, accumulator) {
          result = /(:list)$/.exec(key);
          key = key.replace(/:list$/, '');
          if (!result) {
            accumulator[key] = value;
            return;
          }
          if (accumulator[key] === undefined) {
            accumulator[key] = [value];
            return;
          }
          accumulator[key] = [].concat(accumulator[key], value);
        };
      case 'comma':
      case 'separator':
        return function (key, value, accumulator) {
          var isArray = typeof value === 'string' && value.includes(options.arrayFormatSeparator);
          var isEncodedArray = typeof value === 'string' && !isArray && decode(value, options).includes(options.arrayFormatSeparator);
          value = isEncodedArray ? decode(value, options) : value;
          var newValue = isArray || isEncodedArray ? value.split(options.arrayFormatSeparator).map(function (item) {
            return decode(item, options);
          }) : value === null ? value : decode(value, options);
          accumulator[key] = newValue;
        };
      case 'bracket-separator':
        return function (key, value, accumulator) {
          var isArray = /(\[\])$/.test(key);
          key = key.replace(/\[\]$/, '');
          if (!isArray) {
            accumulator[key] = value ? decode(value, options) : value;
            return;
          }
          var arrayValue = value === null ? [] : value.split(options.arrayFormatSeparator).map(function (item) {
            return decode(item, options);
          });
          if (accumulator[key] === undefined) {
            accumulator[key] = arrayValue;
            return;
          }
          accumulator[key] = [].concat(accumulator[key], arrayValue);
        };
      default:
        return function (key, value, accumulator) {
          if (accumulator[key] === undefined) {
            accumulator[key] = value;
            return;
          }
          accumulator[key] = [].concat(accumulator[key], value);
        };
    }
  }
  function validateArrayFormatSeparator(value) {
    if (typeof value !== 'string' || value.length !== 1) {
      throw new TypeError('arrayFormatSeparator must be single character string');
    }
  }
  function encode(value, options) {
    if (options.encode) {
      return options.strict ? strictUriEncode$1(value) : encodeURIComponent(value);
    }
    return value;
  }
  function decode(value, options) {
    if (options.decode) {
      return decodeComponent(value);
    }
    return value;
  }
  function keysSorter(input) {
    if (Array.isArray(input)) {
      return input.sort();
    }
    if (_typeof(input) === 'object') {
      return keysSorter(Object.keys(input)).sort(function (a, b) {
        return Number(a) - Number(b);
      }).map(function (key) {
        return input[key];
      });
    }
    return input;
  }
  function removeHash(input) {
    var hashStart = input.indexOf('#');
    if (hashStart !== -1) {
      input = input.slice(0, hashStart);
    }
    return input;
  }
  function getHash(url) {
    var hash = '';
    var hashStart = url.indexOf('#');
    if (hashStart !== -1) {
      hash = url.slice(hashStart);
    }
    return hash;
  }
  function extract(input) {
    input = removeHash(input);
    var queryStart = input.indexOf('?');
    if (queryStart === -1) {
      return '';
    }
    return input.slice(queryStart + 1);
  }
  function parseValue(value, options) {
    if (options.parseNumbers && !Number.isNaN(Number(value)) && typeof value === 'string' && value.trim() !== '') {
      value = Number(value);
    } else if (options.parseBooleans && value !== null && (value.toLowerCase() === 'true' || value.toLowerCase() === 'false')) {
      value = value.toLowerCase() === 'true';
    }
    return value;
  }
  function parse(query, options) {
    options = Object.assign({
      decode: true,
      sort: true,
      arrayFormat: 'none',
      arrayFormatSeparator: ',',
      parseNumbers: false,
      parseBooleans: false
    }, options);
    validateArrayFormatSeparator(options.arrayFormatSeparator);
    var formatter = parserForArrayFormat(options);

    // Create an object with no prototype
    var ret = Object.create(null);
    if (typeof query !== 'string') {
      return ret;
    }
    query = query.trim().replace(/^[?#&]/, '');
    if (!query) {
      return ret;
    }
    var _iterator = _createForOfIteratorHelper(query.split('&')),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var param = _step.value;
        if (param === '') {
          continue;
        }
        var _splitOnFirst = splitOnFirst$1(options.decode ? param.replace(/\+/g, ' ') : param, '='),
          _splitOnFirst2 = _slicedToArray(_splitOnFirst, 2),
          _key = _splitOnFirst2[0],
          _value = _splitOnFirst2[1];

        // Missing `=` should be `null`:
        // http://w3.org/TR/2012/WD-url-20120524/#collect-url-parameters
        _value = _value === undefined ? null : ['comma', 'separator', 'bracket-separator'].includes(options.arrayFormat) ? _value : decode(_value, options);
        formatter(decode(_key, options), _value, ret);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
    for (var _i = 0, _Object$keys = Object.keys(ret); _i < _Object$keys.length; _i++) {
      var key = _Object$keys[_i];
      var value = ret[key];
      if (_typeof(value) === 'object' && value !== null) {
        for (var _i2 = 0, _Object$keys2 = Object.keys(value); _i2 < _Object$keys2.length; _i2++) {
          var k = _Object$keys2[_i2];
          value[k] = parseValue(value[k], options);
        }
      } else {
        ret[key] = parseValue(value, options);
      }
    }
    if (options.sort === false) {
      return ret;
    }
    return (options.sort === true ? Object.keys(ret).sort() : Object.keys(ret).sort(options.sort)).reduce(function (result, key) {
      var value = ret[key];
      if (Boolean(value) && _typeof(value) === 'object' && !Array.isArray(value)) {
        // Sort object keys, not values
        result[key] = keysSorter(value);
      } else {
        result[key] = value;
      }
      return result;
    }, Object.create(null));
  }
  exports.extract = extract;
  exports.parse = parse;
  exports.stringify = function (object, options) {
    if (!object) {
      return '';
    }
    options = Object.assign({
      encode: true,
      strict: true,
      arrayFormat: 'none',
      arrayFormatSeparator: ','
    }, options);
    validateArrayFormatSeparator(options.arrayFormatSeparator);
    var shouldFilter = function shouldFilter(key) {
      return options.skipNull && isNullOrUndefined(object[key]) || options.skipEmptyString && object[key] === '';
    };
    var formatter = encoderForArrayFormat(options);
    var objectCopy = {};
    for (var _i3 = 0, _Object$keys3 = Object.keys(object); _i3 < _Object$keys3.length; _i3++) {
      var key = _Object$keys3[_i3];
      if (!shouldFilter(key)) {
        objectCopy[key] = object[key];
      }
    }
    var keys = Object.keys(objectCopy);
    if (options.sort !== false) {
      keys.sort(options.sort);
    }
    return keys.map(function (key) {
      var value = object[key];
      if (value === undefined) {
        return '';
      }
      if (value === null) {
        return encode(key, options);
      }
      if (Array.isArray(value)) {
        if (value.length === 0 && options.arrayFormat === 'bracket-separator') {
          return encode(key, options) + '[]';
        }
        return value.reduce(formatter(key), []).join('&');
      }
      return encode(key, options) + '=' + encode(value, options);
    }).filter(function (x) {
      return x.length > 0;
    }).join('&');
  };
  exports.parseUrl = function (url, options) {
    options = Object.assign({
      decode: true
    }, options);
    var _splitOnFirst3 = splitOnFirst$1(url, '#'),
      _splitOnFirst4 = _slicedToArray(_splitOnFirst3, 2),
      url_ = _splitOnFirst4[0],
      hash = _splitOnFirst4[1];
    return Object.assign({
      url: url_.split('?')[0] || '',
      query: parse(extract(url), options)
    }, options && options.parseFragmentIdentifier && hash ? {
      fragmentIdentifier: decode(hash, options)
    } : {});
  };
  exports.stringifyUrl = function (object, options) {
    options = Object.assign(_defineProperty({
      encode: true,
      strict: true
    }, encodeFragmentIdentifier, true), options);
    var url = removeHash(object.url).split('?')[0] || '';
    var queryFromUrl = exports.extract(object.url);
    var parsedQueryFromUrl = exports.parse(queryFromUrl, {
      sort: false
    });
    var query = Object.assign(parsedQueryFromUrl, object.query);
    var queryString = exports.stringify(query, options);
    if (queryString) {
      queryString = "?".concat(queryString);
    }
    var hash = getHash(object.url);
    if (object.fragmentIdentifier) {
      hash = "#".concat(options[encodeFragmentIdentifier] ? encode(object.fragmentIdentifier, options) : object.fragmentIdentifier);
    }
    return "".concat(url).concat(queryString).concat(hash);
  };
  exports.pick = function (input, filter, options) {
    options = Object.assign(_defineProperty({
      parseFragmentIdentifier: true
    }, encodeFragmentIdentifier, false), options);
    var _exports$parseUrl = exports.parseUrl(input, options),
      url = _exports$parseUrl.url,
      query = _exports$parseUrl.query,
      fragmentIdentifier = _exports$parseUrl.fragmentIdentifier;
    return exports.stringifyUrl({
      url: url,
      query: filterObject(query, filter),
      fragmentIdentifier: fragmentIdentifier
    }, options);
  };
  exports.exclude = function (input, filter, options) {
    var exclusionFilter = Array.isArray(filter) ? function (key) {
      return !filter.includes(key);
    } : function (key, value) {
      return !filter(key, value);
    };
    return exports.pick(input, exclusionFilter, options);
  };
})(queryString);

/**
 * 웹 페이지가 모바일 앱 내의 웹뷰에서 실행되고 있는지 여부를 확인합니다.
 * 이 함수는 서버 사이드와 클라이언트 사이드 렌더링 환경 모두에서 사용 가능합니다.
 *
 * @param {Object} query - 서버 사이드 렌더링 시 사용할 쿼리 파라미터 객체입니다. (선택적)
 * @returns {boolean} 웹 페이지가 앱 내의 웹뷰에서 실행되고 있다면 true, 그렇지 않다면 false를 반환합니다.
 */
function isInApp(query) {
  if (typeof window === 'undefined') {
    if (query != null) {
      return query['os_type'] != null || query['app'] != null;
    }
    return false;
  }
  var triggered = false;
  try {
    triggered = sessionStorage['webviewTriggered'] === 'yes';
  } catch (e) {
    console.error(e);
  }
  var search = queryString.parse(location.search);
  var isExpertCenterAndroid = search['pro_app'] != null && search['os_type'] === 'Android';
  if (!isExpertCenterAndroid && (triggered || search['os_type'] != null && search['os_type'] !== '' || search['app'] != null)) {
    try {
      sessionStorage['webviewTriggered'] = 'yes';
    } catch (e) {
      console.error(e);
    }
    return true;
  }
  return false;
}

/**
 * 이 함수는 사용자의 기기가 iOS 기기인지를 판단합니다.
 * 사용자 에이전트 문자열을 통해 iPad, iPhone, 또는 iPod을 포함하고 있는지 검사합니다.
 * @param ua - userAgent로 옵셔널한 값입니다.
 *
 * @returns {boolean} 사용자 기기가 iOS 기기이면 true를, 그렇지 않으면 false를 반환합니다.
 */
function isIOS(ua) {
  return /iPad|iPhone|iPod/.test(ua !== null && ua !== void 0 ? ua : window.navigator.userAgent);
}

// 모바일 장치를 포괄하는 정규 표현식
var MOBILE_USER_AGENT_REGEX = /iPhone|iPad|iPod|Android|webOS|BlackBerry|IEMobile|Opera Mini|Windows Phone|Kindle|Silk|PlayBook/;
/**
 * 브라우저의 사용자 에이전트 또는 제공된 사용자 에이전트 문자열을 기반으로 현재 환경이 모바일 장치인지 여부를 확인합니다.
 *
 * @param {string} [userAgent=''] - (선택적) 확인할 사용자 에이전트입니다.
 * @returns {boolean} 모바일 장치면 true, 그렇지 않으면 false를 반환합니다.
 *
 * @example
 * 브라우저 환경에서 사용할 경우:
 * isMobile();
 *
 * 사용자 에이전트 문자열을 제공할 경우:
 * isMobile("Mozilla/5.0 (iPhone; CPU iPhone OS 10_3 like Mac OS X)");
 */
function isMobileDevice() {
  var userAgent = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  if (userAgent !== '') {
    return MOBILE_USER_AGENT_REGEX.test(userAgent);
  }
  // 브라우저 환경에서 실행 중인지 확인
  if (typeof window !== 'undefined' && navigator) {
    var isMobileUA = MOBILE_USER_AGENT_REGEX.test(navigator.userAgent);
    // 터치 기능에 대한 추가 검사
    var isTouchDevice = 'ontouchstart' in window || navigator.maxTouchPoints > 0;
    // 모바일 장치를 나타내는 검사 중 하나라도 참이면 true 반환
    return isMobileUA || isTouchDevice;
  }
  return false;
}

/**
 * 웹에서 발생한 이벤트를 앱에 전달
 * @param item 앱으로 전달할 이벤트
 * @returns void
 */
function sendEventIpc(item) {
  try {
    var _windowObj$webkit, _windowObj$webkit$pos, _windowObj$ohouseEven, _windowObj$ohouseEven2;
    if (typeof window === 'undefined') {
      return;
    }
    var windowObj = window;
    (_windowObj$webkit = windowObj.webkit) === null || _windowObj$webkit === void 0 || (_windowObj$webkit = _windowObj$webkit.messageHandlers) === null || _windowObj$webkit === void 0 || (_windowObj$webkit = _windowObj$webkit.ohouseEventInterface) === null || _windowObj$webkit === void 0 || (_windowObj$webkit$pos = _windowObj$webkit.postMessage) === null || _windowObj$webkit$pos === void 0 || _windowObj$webkit$pos.call(_windowObj$webkit, item);
    (_windowObj$ohouseEven = windowObj.ohouseEventInterface) === null || _windowObj$ohouseEven === void 0 || (_windowObj$ohouseEven2 = _windowObj$ohouseEven.sendEvent) === null || _windowObj$ohouseEven2 === void 0 || _windowObj$ohouseEven2.call(_windowObj$ohouseEven, JSON.stringify(item));
  } catch (e) {
    // noop
  }
}

/**
 * 앱에서 웹으로 전송하는 이벤트를 구독하는 함수
 * @param callback EventIpcItem을 활용하여 처리하는 함수
 * @returns void
 * @example
 * ```
 * subscribeEventIpc((event) => console.log(event));
 * ```
 */
function subscribeEventIpc(callback) {
  var windowObj = window;
  if (windowObj.BucketUtils == null) {
    windowObj.BucketUtils = {};
  }
  if (windowObj.BucketUtils.sendEvent == null) {
    // Set up global handler if it doesn't exist
    windowObj.BucketUtils.sendEvent = function (event) {
      var func = windowObj.BucketUtils.sendEvent;
      (func.callbacks || []).forEach(function (callback) {
        return callback(event);
      });
    };
    windowObj.BucketUtils.sendEvent.callbacks = [];
  }
  // Then, attach callback to it
  var callbacks = windowObj.BucketUtils.sendEvent.callbacks;
  callbacks.push(callback);
  return function () {
    var index = callbacks.indexOf(callback);
    if (index !== -1) {
      callbacks.splice(index, 1);
    }
  };
}

/**
 * memoize(func, [resolver])
 * 주어진 함수의 결과를 캐싱함으로써, 동일한 인자로 재호출될 때 이전에 계산된 결과를 반환합니다.
 * resolver가 제공되면, 이를 사용하여 캐시 키를 결정합니다. resolver가 제공되지 않으면, 첫 번째 인자만을 캐시 키로 사용합니다.
 *
 * @param {Function} func - 메모이제이션을 적용할 함수.
 * @param {Function} [resolver] - 캐시 키를 결정하는 데 사용할 함수.
 * @returns {Function} 메모이제이션된 함수.
 *
 * @example
 * const memoized = memoize(function(val) {
 *   return val * 2;
 * });
 * memoized(2);   // 계산 수행
 * memoized(2);   // 캐시된 결과 반환
 *
 * @see [Lodash Documentation for memoize]{@link https://lodash.com/docs/4.17.15#memoize}
 *
 * Lodash 문서에 따른 추가 설명:
 * Creates a function that memoizes the result of func. If resolver is provided,
 * it determines the cache key for storing the result based on the arguments provided to the memoized function.
 * By default, the first argument provided to the memoized function is used as the map cache key.
 * The func is invoked with the this binding of the memoized function.
 */
var memoize = (/* unused pure expression or super */ null && (memoize$1));

/**
 * 주어진 값이 배열인지 여부를 확인합니다.
 * @param {any} value - 검사할 값.
 * @returns {boolean} 값이 배열이면 true, 그렇지 않으면 false를 반환합니다.
 *
 * @example
 * // 배열인 경우
 * isArray([1, 2, 3]); // true
 *
 * @example
 * // 배열이 아닌 경우
 * isArray({ 'a': 1, 'b': 2, 'c': 3 }); // false
 *
 * @example
 * // null 값을 검사하는 경우
 * isArray(null); // false
 */
var isArray = (/* unused pure expression or super */ null && (isArray$2));

/** `Object#toString` result references. */
var boolTag$2 = '[object Boolean]';

/**
 * Checks if `value` is classified as a boolean primitive or object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
 * @example
 *
 * _.isBoolean(false);
 * // => true
 *
 * _.isBoolean(null);
 * // => false
 */
function isBoolean$1(value) {
  return value === true || value === false || isObjectLike(value) && baseGetTag(value) == boolTag$2;
}

/**
 * 주어진 값이 불리언 타입인지 여부를 확인합니다.
 * @param {any} value - 검사할 값.
 * @returns {boolean} 값이 불리언 타입이면 true, 그렇지 않으면 false를 반환합니다.
 *
 * @example
 * // 불리언 타입인 경우
 * isBoolean(true); // true
 * isBoolean(false); // true
 *
 * @example
 * // 불리언 타입이 아닌 경우
 * isBoolean('true'); // false
 * isBoolean(1); // false
 * isBoolean(null); // false
 */
var isBoolean = (/* unused pure expression or super */ null && (isBoolean$1));

/** `Object#toString` result references. */
var mapTag$3 = '[object Map]',
  setTag$3 = '[object Set]';

/** Used for built-in method references. */
var objectProto$4 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$4 = objectProto$4.hasOwnProperty;

/**
 * Checks if `value` is an empty object, collection, map, or set.
 *
 * Objects are considered empty if they have no own enumerable string keyed
 * properties.
 *
 * Array-like values such as `arguments` objects, arrays, buffers, strings, or
 * jQuery-like collections are considered empty if they have a `length` of `0`.
 * Similarly, maps and sets are considered empty if they have a `size` of `0`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is empty, else `false`.
 * @example
 *
 * _.isEmpty(null);
 * // => true
 *
 * _.isEmpty(true);
 * // => true
 *
 * _.isEmpty(1);
 * // => true
 *
 * _.isEmpty([1, 2, 3]);
 * // => false
 *
 * _.isEmpty({ 'a': 1 });
 * // => false
 */
function isEmpty$1(value) {
  if (value == null) {
    return true;
  }
  if (isArrayLike(value) && (isArray$2(value) || typeof value == 'string' || typeof value.splice == 'function' || isBuffer$1(value) || isTypedArray$1(value) || isArguments$1(value))) {
    return !value.length;
  }
  var tag = getTag$1(value);
  if (tag == mapTag$3 || tag == setTag$3) {
    return !value.size;
  }
  if (isPrototype(value)) {
    return !baseKeys(value).length;
  }
  for (var key in value) {
    if (hasOwnProperty$4.call(value, key)) {
      return false;
    }
  }
  return true;
}

/**
 * 주어진 값이 비어있는지 여부를 확인합니다. 비어있다는 것은 배열, 문자열, 객체 또는 Map/Set이 비어있거나,
 * 값이 `null`, `undefined`인 경우를 의미합니다.
 *
 * @param {any} value - 검사할 값.
 * @returns {boolean} 값이 비어있으면 true, 그렇지 않으면 false를 반환합니다.
 *
 * @example
 * isEmpty([]); // true
 * isEmpty({}); // true
 * isEmpty(''); // true
 * isEmpty(new Map()); // true
 *
 * @example
 * isEmpty([1, 2, 3]); // false
 * isEmpty({ 'a': 1 }); // false
 * isEmpty('text'); // false
 * isEmpty(new Map([[1, 'one']])); // false
 */
var isEmpty = (/* unused pure expression or super */ null && (isEmpty$1));

/** Built-in value references. */
var getPrototype = overArg(Object.getPrototypeOf, Object);
var getPrototype$1 = getPrototype;

/** `Object#toString` result references. */
var objectTag$1 = '[object Object]';

/** Used for built-in method references. */
var funcProto = Function.prototype,
  objectProto$3 = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty$3 = objectProto$3.hasOwnProperty;

/** Used to infer the `Object` constructor. */
var objectCtorString = funcToString.call(Object);

/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */
function isPlainObject(value) {
  if (!isObjectLike(value) || baseGetTag(value) != objectTag$1) {
    return false;
  }
  var proto = getPrototype$1(value);
  if (proto === null) {
    return true;
  }
  var Ctor = hasOwnProperty$3.call(proto, 'constructor') && proto.constructor;
  return typeof Ctor == 'function' && Ctor instanceof Ctor && funcToString.call(Ctor) == objectCtorString;
}

/** `Object#toString` result references. */
var domExcTag = '[object DOMException]',
  errorTag$1 = '[object Error]';

/**
 * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
 * `SyntaxError`, `TypeError`, or `URIError` object.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
 * @example
 *
 * _.isError(new Error);
 * // => true
 *
 * _.isError(Error);
 * // => false
 */
function isError$1(value) {
  if (!isObjectLike(value)) {
    return false;
  }
  var tag = baseGetTag(value);
  return tag == errorTag$1 || tag == domExcTag || typeof value.message == 'string' && typeof value.name == 'string' && !isPlainObject(value);
}

/**
 * 주어진 값이 Error 객체인지 여부를 확인합니다.
 *
 * @param {any} value - 검사할 값.
 * @returns {boolean} 값이 Error 객체이면 true, 그렇지 않으면 false를 반환합니다.
 *
 * @example
 * isError(new Error()); // true
 * isError(new CustomError('Custom message')); // true, CustomError가 Error를 상속하는 경우
 *
 * @example
 * isError({ name: 'Error', message: 'Something went wrong' }); // false
 * isError('Error message'); // false
 * isError(null); // false
 */
var isError = (/* unused pure expression or super */ null && (isError$1));

/**
 * 주어진 값이 함수인지 여부를 확인합니다.
 *
 * @param {any} value - 검사할 값.
 * @returns {boolean} 값이 함수이면 true, 그렇지 않으면 false를 반환합니다.
 *
 * @example
 * isFunction(function() {}); // true
 * isFunction(() => {}); // true
 * isFunction(class MyClass {}); // true
 *
 * @example
 * isFunction({}); // false
 * isFunction('function'); // false
 * isFunction(null); // false
 * isFunction(undefined); // false
 */
var isFunction = (/* unused pure expression or super */ null && (isFunction$1));

/** Used to match a single whitespace character. */
var reWhitespace = /\s/;

/**
 * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
 * character of `string`.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {number} Returns the index of the last non-whitespace character.
 */
function trimmedEndIndex(string) {
  var index = string.length;
  while (index-- && reWhitespace.test(string.charAt(index))) {}
  return index;
}

/** Used to match leading whitespace. */
var reTrimStart = /^\s+/;

/**
 * The base implementation of `_.trim`.
 *
 * @private
 * @param {string} string The string to trim.
 * @returns {string} Returns the trimmed string.
 */
function baseTrim(string) {
  return string ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, '') : string;
}

/** Used as references for various `Number` constants. */
var NAN = (/* unused pure expression or super */ null && (0 / 0));

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol$1(value)) {
    return NAN;
  }
  if (isObject$1(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject$1(other) ? other + '' : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = baseTrim(value);
  var isBinary = reIsBinary.test(value);
  return isBinary || reIsOctal.test(value) ? freeParseInt(value.slice(2), isBinary ? 2 : 8) : reIsBadHex.test(value) ? NAN : +value;
}

/** Used as references for various `Number` constants. */
var INFINITY = (/* unused pure expression or super */ null && (1 / 0)),
  MAX_INTEGER = 1.7976931348623157e+308;

/**
 * Converts `value` to a finite number.
 *
 * @static
 * @memberOf _
 * @since 4.12.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted number.
 * @example
 *
 * _.toFinite(3.2);
 * // => 3.2
 *
 * _.toFinite(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toFinite(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toFinite('3.2');
 * // => 3.2
 */
function toFinite(value) {
  if (!value) {
    return value === 0 ? value : 0;
  }
  value = toNumber(value);
  if (value === INFINITY || value === -INFINITY) {
    var sign = value < 0 ? -1 : 1;
    return sign * MAX_INTEGER;
  }
  return value === value ? value : 0;
}

/**
 * Converts `value` to an integer.
 *
 * **Note:** This method is loosely based on
 * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted integer.
 * @example
 *
 * _.toInteger(3.2);
 * // => 3
 *
 * _.toInteger(Number.MIN_VALUE);
 * // => 0
 *
 * _.toInteger(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toInteger('3.2');
 * // => 3
 */
function toInteger(value) {
  var result = toFinite(value),
    remainder = result % 1;
  return result === result ? remainder ? result - remainder : result : 0;
}

/**
 * Checks if `value` is an integer.
 *
 * **Note:** This method is based on
 * [`Number.isInteger`](https://mdn.io/Number/isInteger).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
 * @example
 *
 * _.isInteger(3);
 * // => true
 *
 * _.isInteger(Number.MIN_VALUE);
 * // => false
 *
 * _.isInteger(Infinity);
 * // => false
 *
 * _.isInteger('3');
 * // => false
 */
function isInteger$1(value) {
  return typeof value == 'number' && value == toInteger(value);
}

/**
 * 주어진 값이 정수인지 여부를 확인합니다.
 *
 * @param {any} value - 검사할 값.
 * @returns {boolean} 값이 정수이면 true, 그렇지 않으면 false를 반환합니다.
 *
 * @example
 * isInteger(3); // true
 * isInteger(3.0); // true, 3.0은 정수로 간주
 * isInteger(-15); // true
 *
 * @example
 * isInteger(3.5); // false
 * isInteger('3'); // false
 * isInteger(NaN); // false
 * isInteger(null); // false
 */
var isInteger = (/* unused pure expression or super */ null && (isInteger$1));

/** `Object#toString` result references. */
var numberTag$2 = '[object Number]';

/**
 * Checks if `value` is classified as a `Number` primitive or object.
 *
 * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
 * classified as numbers, use the `_.isFinite` method.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a number, else `false`.
 * @example
 *
 * _.isNumber(3);
 * // => true
 *
 * _.isNumber(Number.MIN_VALUE);
 * // => true
 *
 * _.isNumber(Infinity);
 * // => true
 *
 * _.isNumber('3');
 * // => false
 */
function isNumber$1(value) {
  return typeof value == 'number' || isObjectLike(value) && baseGetTag(value) == numberTag$2;
}

/**
 * Checks if `value` is `NaN`.
 *
 * **Note:** This method is based on
 * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
 * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
 * `undefined` and other non-number values.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
 * @example
 *
 * _.isNaN(NaN);
 * // => true
 *
 * _.isNaN(new Number(NaN));
 * // => true
 *
 * isNaN(undefined);
 * // => true
 *
 * _.isNaN(undefined);
 * // => false
 */
function isNaN$2(value) {
  // An `NaN` primitive is the only value that is not equal to itself.
  // Perform the `toStringTag` check first to avoid errors with some
  // ActiveX objects in IE.
  return isNumber$1(value) && value != +value;
}

/**
 * 주어진 값이 NaN (Not a Number)인지 여부를 확인합니다.
 *
 * @param {any} value - 검사할 값.
 * @returns {boolean} 값이 NaN이면 true, 그렇지 않으면 false를 반환합니다.
 *
 * @example
 * isNaN(NaN); // true
 * isNaN(Number.NaN); // true
 *
 * @example
 * isNaN(0); // false
 * isNaN('NaN'); // false
 * isNaN(undefined); // false
 * isNaN({}); // false
 */
var isNaN$1 = (/* unused pure expression or super */ null && (isNaN$2));

/**
 * Checks if `value` is `null` or `undefined`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
 * @example
 *
 * _.isNil(null);
 * // => true
 *
 * _.isNil(void 0);
 * // => true
 *
 * _.isNil(NaN);
 * // => false
 */
function isNil$1(value) {
  return value == null;
}

/**
 * 주어진 값이 null 또는 undefined인지 여부를 확인합니다.
 *
 * @param {any} value - 검사할 값.
 * @returns {boolean} 값이 null 또는 undefined이면 true, 그렇지 않으면 false를 반환합니다.
 *
 * @example
 * isNil(null); // true
 * isNil(undefined); // true
 *
 * @example
 * isNil(0); // false
 * isNil(false); // false
 * isNil(''); // false
 * isNil(NaN); // false
 */
var isNil = (/* unused pure expression or super */ null && (isNil$1));

/**
 * Checks if `value` is `null`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
 * @example
 *
 * _.isNull(null);
 * // => true
 *
 * _.isNull(void 0);
 * // => false
 */
function isNull$1(value) {
  return value === null;
}

/**
 * 주어진 값이 null인지 여부를 확인합니다.
 *
 * @param {any} value - 검사할 값.
 * @returns {boolean} 값이 null이면 true, 그렇지 않으면 false를 반환합니다.
 *
 * @example
 * isNull(null); // true
 *
 * @example
 * isNull(undefined); // false
 * isNull(0); // false
 * isNull(''); // false
 * isNull(false); // false
 */
var isNull = (/* unused pure expression or super */ null && (isNull$1));

/**
 * 주어진 값이 숫자 타입인지 여부를 확인합니다.
 *
 * @param {any} value - 검사할 값.
 * @returns {boolean} 값이 숫자 타입이면 true, 그렇지 않으면 false를 반환합니다.
 *
 * @example
 * isNumber(5); // true
 * isNumber(Number(5)); // true
 *
 * @example
 * isNumber('5'); // false
 * isNumber(null); // false
 * isNumber(undefined); // false
 * isNumber(NaN); // true
 */
var isNumber = (/* unused pure expression or super */ null && (isNumber$1));

/**
 * 주어진 값이 객체인지 여부를 확인합니다. JavaScript에서 객체는 배열, 함수, 객체 리터럴 등을 포함합니다.
 * null은 객체로 간주되지 않습니다.
 *
 * @param {any} value - 검사할 값.
 * @returns {boolean} 값이 객체이면 true, 그렇지 않으면 false를 반환합니다.
 *
 * @example
 * isObject({}); // true
 * isObject([1, 2, 3]); // true
 * isObject(() => {}); // true
 * isObject(new Date()); // true
 *
 * @example
 * isObject(null); // false
 * isObject('Hello'); // false
 * isObject(123); // false
 */
var isObject = (/* unused pure expression or super */ null && (isObject$1));

/** `Object#toString` result references. */
var stringTag$2 = '[object String]';

/**
 * Checks if `value` is classified as a `String` primitive or object.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a string, else `false`.
 * @example
 *
 * _.isString('abc');
 * // => true
 *
 * _.isString(1);
 * // => false
 */
function isString$1(value) {
  return typeof value == 'string' || !isArray$2(value) && isObjectLike(value) && baseGetTag(value) == stringTag$2;
}

/**
 * 주어진 값이 문자열인지 여부를 확인합니다.
 *
 * @param {any} value - 검사할 값.
 * @returns {boolean} 값이 문자열이면 true, 그렇지 않으면 false를 반환합니다.
 *
 * @example
 * isString('Hello'); // true
 * isString(''); // true
 *
 * @example
 * isString(123); // false
 * isString(true); // false
 * isString({}); // false
 * isString([]); // false
 * isString(() => {}); // false
 */
var isString = (/* unused pure expression or super */ null && (isString$1));

/**
 * 주어진 값이 심볼(Symbol) 타입인지 여부를 확인합니다.
 *
 * @param {any} value - 검사할 값.
 * @returns {boolean} 값이 심볼이면 true, 그렇지 않으면 false를 반환합니다.
 *
 * @example
 * isSymbol(Symbol.iterator); // true
 * isSymbol(Symbol('description')); // true
 *
 * @example
 * isSymbol('Hello'); // false
 * isSymbol(123); // false
 * isSymbol({}); // false
 * isSymbol([]); // false
 * isSymbol(() => {}); // false
 */
var isSymbol = (/* unused pure expression or super */ null && (isSymbol$1));

/**
 * Checks if `value` is `undefined`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
 * @example
 *
 * _.isUndefined(void 0);
 * // => true
 *
 * _.isUndefined(null);
 * // => false
 */
function isUndefined$1(value) {
  return value === undefined;
}

/**
 * 주어진 값이 undefined인지 여부를 확인합니다.
 *
 * @param {any} value - 검사할 값.
 * @returns {boolean} 값이 undefined이면 true, 그렇지 않으면 false를 반환합니다.
 *
 * @example
 * isUndefined(undefined); // true
 *
 * @example
 * isUndefined(null); // false
 * isUndefined(0); // false
 * isUndefined(''); // false
 * isUndefined(false); // false
 * isUndefined({}); // false
 */
var isUndefined = (/* unused pure expression or super */ null && (isUndefined$1));

/** Used for built-in method references. */
var objectProto$2 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$2 = objectProto$2.hasOwnProperty;

/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignValue(object, key, value) {
  var objValue = object[key];
  if (!(hasOwnProperty$2.call(object, key) && eq(objValue, value)) || value === undefined && !(key in object)) {
    baseAssignValue(object, key, value);
  }
}

/**
 * The base implementation of `_.set`.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to set.
 * @param {*} value The value to set.
 * @param {Function} [customizer] The function to customize path creation.
 * @returns {Object} Returns `object`.
 */
function baseSet(object, path, value, customizer) {
  if (!isObject$1(object)) {
    return object;
  }
  path = castPath(path, object);
  var index = -1,
    length = path.length,
    lastIndex = length - 1,
    nested = object;
  while (nested != null && ++index < length) {
    var key = toKey(path[index]),
      newValue = value;
    if (key === '__proto__' || key === 'constructor' || key === 'prototype') {
      return object;
    }
    if (index != lastIndex) {
      var objValue = nested[key];
      newValue = customizer ? customizer(objValue, key, nested) : undefined;
      if (newValue === undefined) {
        newValue = isObject$1(objValue) ? objValue : isIndex(path[index + 1]) ? [] : {};
      }
    }
    assignValue(nested, key, newValue);
    nested = nested[key];
  }
  return object;
}

/**
 * The base implementation of  `_.pickBy` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The source object.
 * @param {string[]} paths The property paths to pick.
 * @param {Function} predicate The function invoked per property.
 * @returns {Object} Returns the new object.
 */
function basePickBy(object, paths, predicate) {
  var index = -1,
    length = paths.length,
    result = {};
  while (++index < length) {
    var path = paths[index],
      value = baseGet(object, path);
    if (predicate(value, path)) {
      baseSet(result, castPath(path, object), value);
    }
  }
  return result;
}

/**
 * The base implementation of `_.pick` without support for individual
 * property identifiers.
 *
 * @private
 * @param {Object} object The source object.
 * @param {string[]} paths The property paths to pick.
 * @returns {Object} Returns the new object.
 */
function basePick(object, paths) {
  return basePickBy(object, paths, function (value, path) {
    return hasIn(object, path);
  });
}

/** Built-in value references. */
var spreadableSymbol = _Symbol$1 ? _Symbol$1.isConcatSpreadable : undefined;

/**
 * Checks if `value` is a flattenable `arguments` object or array.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
 */
function isFlattenable(value) {
  return isArray$2(value) || isArguments$1(value) || !!(spreadableSymbol && value && value[spreadableSymbol]);
}

/**
 * The base implementation of `_.flatten` with support for restricting flattening.
 *
 * @private
 * @param {Array} array The array to flatten.
 * @param {number} depth The maximum recursion depth.
 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
 * @param {Array} [result=[]] The initial result value.
 * @returns {Array} Returns the new flattened array.
 */
function baseFlatten(array, depth, predicate, isStrict, result) {
  var index = -1,
    length = array.length;
  predicate || (predicate = isFlattenable);
  result || (result = []);
  while (++index < length) {
    var value = array[index];
    if (depth > 0 && predicate(value)) {
      if (depth > 1) {
        // Recursively flatten arrays (susceptible to call stack limits).
        baseFlatten(value, depth - 1, predicate, isStrict, result);
      } else {
        arrayPush(result, value);
      }
    } else if (!isStrict) {
      result[result.length] = value;
    }
  }
  return result;
}

/**
 * Flattens `array` a single level deep.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to flatten.
 * @returns {Array} Returns the new flattened array.
 * @example
 *
 * _.flatten([1, [2, [3, [4]], 5]]);
 * // => [1, 2, [3, [4]], 5]
 */
function flatten(array) {
  var length = array == null ? 0 : array.length;
  return length ? baseFlatten(array, 1) : [];
}

/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */
function apply(func, thisArg, args) {
  switch (args.length) {
    case 0:
      return func.call(thisArg);
    case 1:
      return func.call(thisArg, args[0]);
    case 2:
      return func.call(thisArg, args[0], args[1]);
    case 3:
      return func.call(thisArg, args[0], args[1], args[2]);
  }
  return func.apply(thisArg, args);
}

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */
function overRest(func, start, transform) {
  start = nativeMax(start === undefined ? func.length - 1 : start, 0);
  return function () {
    var args = arguments,
      index = -1,
      length = nativeMax(args.length - start, 0),
      array = Array(length);
    while (++index < length) {
      array[index] = args[start + index];
    }
    index = -1;
    var otherArgs = Array(start + 1);
    while (++index < start) {
      otherArgs[index] = args[index];
    }
    otherArgs[start] = transform(array);
    return apply(func, this, otherArgs);
  };
}

/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */
function constant(value) {
  return function () {
    return value;
  };
}

/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var baseSetToString = !defineProperty$1 ? identity : function (func, string) {
  return defineProperty$1(func, 'toString', {
    'configurable': true,
    'enumerable': false,
    'value': constant(string),
    'writable': true
  });
};
var baseSetToString$1 = baseSetToString;

/** Used to detect hot functions by number of calls within a span of milliseconds. */
var HOT_COUNT = 800,
  HOT_SPAN = 16;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeNow = Date.now;

/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */
function shortOut(func) {
  var count = 0,
    lastCalled = 0;
  return function () {
    var stamp = nativeNow(),
      remaining = HOT_SPAN - (stamp - lastCalled);
    lastCalled = stamp;
    if (remaining > 0) {
      if (++count >= HOT_COUNT) {
        return arguments[0];
      }
    } else {
      count = 0;
    }
    return func.apply(undefined, arguments);
  };
}

/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var setToString = shortOut(baseSetToString$1);
var setToString$1 = setToString;

/**
 * A specialized version of `baseRest` which flattens the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @returns {Function} Returns the new function.
 */
function flatRest(func) {
  return setToString$1(overRest(func, undefined, flatten), func + '');
}

/**
 * Creates an object composed of the picked `object` properties.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The source object.
 * @param {...(string|string[])} [paths] The property paths to pick.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.pick(object, ['a', 'c']);
 * // => { 'a': 1, 'c': 3 }
 */
var pick$1 = flatRest(function (object, paths) {
  return object == null ? {} : basePick(object, paths);
});
var pick$2 = (/* unused pure expression or super */ null && (pick$1));

/**
 * 주어진 객체에서 선택된 키들에 해당하는 속성들만을 포함하는 새 객체를 반환합니다.
 * @param {Object} object - 원본 객체.
 * @param {string[]} paths - 선택할 속성의 키들을 나타내는 문자열 배열.
 * @returns {Object} 선택된 속성들만을 포함하는 새 객체.
 *
 * @example
 * // 객체에서 'a'와 'c' 속성을 선택
 * pick({ 'a': 1, 'b': '2', 'c': 3 }, ['a', 'c']); // { 'a': 1, 'c': 3 }
 *
 * @example
 * // 객체에서 'color' 속성을 선택
 * pick({ 'name': 'apple', 'color': 'red', 'weight': 100 }, ['color']); // { 'color': 'red' }
 */
var pick = (/* unused pure expression or super */ null && (pick$2));

/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */
function arrayEach(array, iteratee) {
  var index = -1,
    length = array == null ? 0 : array.length;
  while (++index < length) {
    if (iteratee(array[index], index, array) === false) {
      break;
    }
  }
  return array;
}

/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */
function copyObject(source, props, object, customizer) {
  var isNew = !object;
  object || (object = {});
  var index = -1,
    length = props.length;
  while (++index < length) {
    var key = props[index];
    var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined;
    if (newValue === undefined) {
      newValue = source[key];
    }
    if (isNew) {
      baseAssignValue(object, key, newValue);
    } else {
      assignValue(object, key, newValue);
    }
  }
  return object;
}

/**
 * The base implementation of `_.assign` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */
function baseAssign(object, source) {
  return object && copyObject(source, keys(source), object);
}

/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function nativeKeysIn(object) {
  var result = [];
  if (object != null) {
    for (var key in Object(object)) {
      result.push(key);
    }
  }
  return result;
}

/** Used for built-in method references. */
var objectProto$1 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$1 = objectProto$1.hasOwnProperty;

/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeysIn(object) {
  if (!isObject$1(object)) {
    return nativeKeysIn(object);
  }
  var isProto = isPrototype(object),
    result = [];
  for (var key in object) {
    if (!(key == 'constructor' && (isProto || !hasOwnProperty$1.call(object, key)))) {
      result.push(key);
    }
  }
  return result;
}

/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */
function keysIn(object) {
  return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
}

/**
 * The base implementation of `_.assignIn` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */
function baseAssignIn(object, source) {
  return object && copyObject(source, keysIn(source), object);
}

/** Detect free variable `exports`. */
var freeExports = (typeof exports === "undefined" ? "undefined" : _typeof(exports)) == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && ( false ? 0 : _typeof(module)) == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? root$1.Buffer : undefined,
  allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;

/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */
function cloneBuffer(buffer, isDeep) {
  if (isDeep) {
    return buffer.slice();
  }
  var length = buffer.length,
    result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
  buffer.copy(result);
  return result;
}

/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */
function copyArray(source, array) {
  var index = -1,
    length = source.length;
  array || (array = Array(length));
  while (++index < length) {
    array[index] = source[index];
  }
  return array;
}

/**
 * Copies own symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */
function copySymbols(source, object) {
  return copyObject(source, getSymbols$1(source), object);
}

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own and inherited enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbolsIn = !nativeGetSymbols ? stubArray : function (object) {
  var result = [];
  while (object) {
    arrayPush(result, getSymbols$1(object));
    object = getPrototype$1(object);
  }
  return result;
};
var getSymbolsIn$1 = getSymbolsIn;

/**
 * Copies own and inherited symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */
function copySymbolsIn(source, object) {
  return copyObject(source, getSymbolsIn$1(source), object);
}

/**
 * Creates an array of own and inherited enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeysIn(object) {
  return baseGetAllKeys(object, keysIn, getSymbolsIn$1);
}

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Initializes an array clone.
 *
 * @private
 * @param {Array} array The array to clone.
 * @returns {Array} Returns the initialized clone.
 */
function initCloneArray(array) {
  var length = array.length,
    result = new array.constructor(length);

  // Add properties assigned by `RegExp#exec`.
  if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
    result.index = array.index;
    result.input = array.input;
  }
  return result;
}

/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */
function cloneArrayBuffer(arrayBuffer) {
  var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
  new Uint8Array$1(result).set(new Uint8Array$1(arrayBuffer));
  return result;
}

/**
 * Creates a clone of `dataView`.
 *
 * @private
 * @param {Object} dataView The data view to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned data view.
 */
function cloneDataView(dataView, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
  return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
}

/** Used to match `RegExp` flags from their coerced string values. */
var reFlags = /\w*$/;

/**
 * Creates a clone of `regexp`.
 *
 * @private
 * @param {Object} regexp The regexp to clone.
 * @returns {Object} Returns the cloned regexp.
 */
function cloneRegExp(regexp) {
  var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
  result.lastIndex = regexp.lastIndex;
  return result;
}

/** Used to convert symbols to primitives and strings. */
var symbolProto = _Symbol$1 ? _Symbol$1.prototype : undefined,
  symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

/**
 * Creates a clone of the `symbol` object.
 *
 * @private
 * @param {Object} symbol The symbol object to clone.
 * @returns {Object} Returns the cloned symbol object.
 */
function cloneSymbol(symbol) {
  return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
}

/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */
function cloneTypedArray(typedArray, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
  return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}

/** `Object#toString` result references. */
var boolTag$1 = '[object Boolean]',
  dateTag$1 = '[object Date]',
  mapTag$2 = '[object Map]',
  numberTag$1 = '[object Number]',
  regexpTag$1 = '[object RegExp]',
  setTag$2 = '[object Set]',
  stringTag$1 = '[object String]',
  symbolTag$1 = '[object Symbol]';
var arrayBufferTag$1 = '[object ArrayBuffer]',
  dataViewTag$1 = '[object DataView]',
  float32Tag$1 = '[object Float32Array]',
  float64Tag$1 = '[object Float64Array]',
  int8Tag$1 = '[object Int8Array]',
  int16Tag$1 = '[object Int16Array]',
  int32Tag$1 = '[object Int32Array]',
  uint8Tag$1 = '[object Uint8Array]',
  uint8ClampedTag$1 = '[object Uint8ClampedArray]',
  uint16Tag$1 = '[object Uint16Array]',
  uint32Tag$1 = '[object Uint32Array]';

/**
 * Initializes an object clone based on its `toStringTag`.
 *
 * **Note:** This function only supports cloning values with tags of
 * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
 *
 * @private
 * @param {Object} object The object to clone.
 * @param {string} tag The `toStringTag` of the object to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneByTag(object, tag, isDeep) {
  var Ctor = object.constructor;
  switch (tag) {
    case arrayBufferTag$1:
      return cloneArrayBuffer(object);
    case boolTag$1:
    case dateTag$1:
      return new Ctor(+object);
    case dataViewTag$1:
      return cloneDataView(object, isDeep);
    case float32Tag$1:
    case float64Tag$1:
    case int8Tag$1:
    case int16Tag$1:
    case int32Tag$1:
    case uint8Tag$1:
    case uint8ClampedTag$1:
    case uint16Tag$1:
    case uint32Tag$1:
      return cloneTypedArray(object, isDeep);
    case mapTag$2:
      return new Ctor();
    case numberTag$1:
    case stringTag$1:
      return new Ctor(object);
    case regexpTag$1:
      return cloneRegExp(object);
    case setTag$2:
      return new Ctor();
    case symbolTag$1:
      return cloneSymbol(object);
  }
}

/** Built-in value references. */
var objectCreate = Object.create;

/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */
var baseCreate = function () {
  function object() {}
  return function (proto) {
    if (!isObject$1(proto)) {
      return {};
    }
    if (objectCreate) {
      return objectCreate(proto);
    }
    object.prototype = proto;
    var result = new object();
    object.prototype = undefined;
    return result;
  };
}();
var baseCreate$1 = baseCreate;

/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneObject(object) {
  return typeof object.constructor == 'function' && !isPrototype(object) ? baseCreate$1(getPrototype$1(object)) : {};
}

/** `Object#toString` result references. */
var mapTag$1 = '[object Map]';

/**
 * The base implementation of `_.isMap` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 */
function baseIsMap(value) {
  return isObjectLike(value) && getTag$1(value) == mapTag$1;
}

/* Node.js helper references. */
var nodeIsMap = nodeUtil$1 && nodeUtil$1.isMap;

/**
 * Checks if `value` is classified as a `Map` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 * @example
 *
 * _.isMap(new Map);
 * // => true
 *
 * _.isMap(new WeakMap);
 * // => false
 */
var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;
var isMap$1 = isMap;

/** `Object#toString` result references. */
var setTag$1 = '[object Set]';

/**
 * The base implementation of `_.isSet` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 */
function baseIsSet(value) {
  return isObjectLike(value) && getTag$1(value) == setTag$1;
}

/* Node.js helper references. */
var nodeIsSet = nodeUtil$1 && nodeUtil$1.isSet;

/**
 * Checks if `value` is classified as a `Set` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 * @example
 *
 * _.isSet(new Set);
 * // => true
 *
 * _.isSet(new WeakSet);
 * // => false
 */
var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;
var isSet$1 = isSet;

/** Used to compose bitmasks for cloning. */
var CLONE_DEEP_FLAG$1 = 1,
  CLONE_FLAT_FLAG$1 = 2,
  CLONE_SYMBOLS_FLAG$1 = 4;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
  arrayTag = '[object Array]',
  boolTag = '[object Boolean]',
  dateTag = '[object Date]',
  errorTag = '[object Error]',
  funcTag = '[object Function]',
  genTag = '[object GeneratorFunction]',
  mapTag = '[object Map]',
  numberTag = '[object Number]',
  objectTag = '[object Object]',
  regexpTag = '[object RegExp]',
  setTag = '[object Set]',
  stringTag = '[object String]',
  symbolTag = '[object Symbol]',
  weakMapTag = '[object WeakMap]';
var arrayBufferTag = '[object ArrayBuffer]',
  dataViewTag = '[object DataView]',
  float32Tag = '[object Float32Array]',
  float64Tag = '[object Float64Array]',
  int8Tag = '[object Int8Array]',
  int16Tag = '[object Int16Array]',
  int32Tag = '[object Int32Array]',
  uint8Tag = '[object Uint8Array]',
  uint8ClampedTag = '[object Uint8ClampedArray]',
  uint16Tag = '[object Uint16Array]',
  uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values supported by `_.clone`. */
var cloneableTags = {};
cloneableTags[argsTag] = cloneableTags[arrayTag] = cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] = cloneableTags[boolTag] = cloneableTags[dateTag] = cloneableTags[float32Tag] = cloneableTags[float64Tag] = cloneableTags[int8Tag] = cloneableTags[int16Tag] = cloneableTags[int32Tag] = cloneableTags[mapTag] = cloneableTags[numberTag] = cloneableTags[objectTag] = cloneableTags[regexpTag] = cloneableTags[setTag] = cloneableTags[stringTag] = cloneableTags[symbolTag] = cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] = cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
cloneableTags[errorTag] = cloneableTags[funcTag] = cloneableTags[weakMapTag] = false;

/**
 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
 * traversed objects.
 *
 * @private
 * @param {*} value The value to clone.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Deep clone
 *  2 - Flatten inherited properties
 *  4 - Clone symbols
 * @param {Function} [customizer] The function to customize cloning.
 * @param {string} [key] The key of `value`.
 * @param {Object} [object] The parent object of `value`.
 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
 * @returns {*} Returns the cloned value.
 */
function baseClone(value, bitmask, customizer, key, object, stack) {
  var result,
    isDeep = bitmask & CLONE_DEEP_FLAG$1,
    isFlat = bitmask & CLONE_FLAT_FLAG$1,
    isFull = bitmask & CLONE_SYMBOLS_FLAG$1;
  if (customizer) {
    result = object ? customizer(value, key, object, stack) : customizer(value);
  }
  if (result !== undefined) {
    return result;
  }
  if (!isObject$1(value)) {
    return value;
  }
  var isArr = isArray$2(value);
  if (isArr) {
    result = initCloneArray(value);
    if (!isDeep) {
      return copyArray(value, result);
    }
  } else {
    var tag = getTag$1(value),
      isFunc = tag == funcTag || tag == genTag;
    if (isBuffer$1(value)) {
      return cloneBuffer(value, isDeep);
    }
    if (tag == objectTag || tag == argsTag || isFunc && !object) {
      result = isFlat || isFunc ? {} : initCloneObject(value);
      if (!isDeep) {
        return isFlat ? copySymbolsIn(value, baseAssignIn(result, value)) : copySymbols(value, baseAssign(result, value));
      }
    } else {
      if (!cloneableTags[tag]) {
        return object ? value : {};
      }
      result = initCloneByTag(value, tag, isDeep);
    }
  }
  // Check for circular references and return its corresponding clone.
  stack || (stack = new Stack());
  var stacked = stack.get(value);
  if (stacked) {
    return stacked;
  }
  stack.set(value, result);
  if (isSet$1(value)) {
    value.forEach(function (subValue) {
      result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
    });
  } else if (isMap$1(value)) {
    value.forEach(function (subValue, key) {
      result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
    });
  }
  var keysFunc = isFull ? isFlat ? getAllKeysIn : getAllKeys : isFlat ? keysIn : keys;
  var props = isArr ? undefined : keysFunc(value);
  arrayEach(props || value, function (subValue, key) {
    if (props) {
      key = subValue;
      subValue = value[key];
    }
    // Recursively populate clone (susceptible to call stack limits).
    assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
  });
  return result;
}

/**
 * Gets the last element of `array`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to query.
 * @returns {*} Returns the last element of `array`.
 * @example
 *
 * _.last([1, 2, 3]);
 * // => 3
 */
function last(array) {
  var length = array == null ? 0 : array.length;
  return length ? array[length - 1] : undefined;
}

/**
 * The base implementation of `_.slice` without an iteratee call guard.
 *
 * @private
 * @param {Array} array The array to slice.
 * @param {number} [start=0] The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the slice of `array`.
 */
function baseSlice(array, start, end) {
  var index = -1,
    length = array.length;
  if (start < 0) {
    start = -start > length ? 0 : length + start;
  }
  end = end > length ? length : end;
  if (end < 0) {
    end += length;
  }
  length = start > end ? 0 : end - start >>> 0;
  start >>>= 0;
  var result = Array(length);
  while (++index < length) {
    result[index] = array[index + start];
  }
  return result;
}

/**
 * Gets the parent value at `path` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array} path The path to get the parent value of.
 * @returns {*} Returns the parent value.
 */
function parent(object, path) {
  return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
}

/**
 * The base implementation of `_.unset`.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {Array|string} path The property path to unset.
 * @returns {boolean} Returns `true` if the property is deleted, else `false`.
 */
function baseUnset(object, path) {
  path = castPath(path, object);
  object = parent(object, path);
  return object == null || delete object[toKey(last(path))];
}

/**
 * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
 * objects.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {string} key The key of the property to inspect.
 * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
 */
function customOmitClone(value) {
  return isPlainObject(value) ? undefined : value;
}

/** Used to compose bitmasks for cloning. */
var CLONE_DEEP_FLAG = 1,
  CLONE_FLAT_FLAG = 2,
  CLONE_SYMBOLS_FLAG = 4;

/**
 * The opposite of `_.pick`; this method creates an object composed of the
 * own and inherited enumerable property paths of `object` that are not omitted.
 *
 * **Note:** This method is considerably slower than `_.pick`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The source object.
 * @param {...(string|string[])} [paths] The property paths to omit.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.omit(object, ['a', 'c']);
 * // => { 'b': '2' }
 */
var omit$1 = flatRest(function (object, paths) {
  var result = {};
  if (object == null) {
    return result;
  }
  var isDeep = false;
  paths = arrayMap(paths, function (path) {
    path = castPath(path, object);
    isDeep || (isDeep = path.length > 1);
    return path;
  });
  copyObject(object, getAllKeysIn(object), result);
  if (isDeep) {
    result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
  }
  var length = paths.length;
  while (length--) {
    baseUnset(result, paths[length]);
  }
  return result;
});
var omit$2 = (/* unused pure expression or super */ null && (omit$1));

/**
 * 주어진 객체에서 선택된 키들에 해당하는 속성들을 제외한 나머지 속성들을 포함하는 새 객체를 반환합니다.
 * @param {Object} object - 원본 객체.
 * @param {string[]} paths - 제외할 속성의 키들을 나타내는 문자열 배열.
 * @returns {Object} 제외된 속성들을 제외한 나머지 속성들을 포함하는 새 객체.
 *
 * @example
 * // 객체에서 'b' 속성을 제외
 * omit({ 'a': 1, 'b': '2', 'c': 3 }, ['b']); // { 'a': 1, 'c': 3 }
 *
 * @example
 * // 객체에서 여러 속성을 제외
 * omit({ 'name': 'apple', 'color': 'red', 'weight': 100 }, ['color', 'weight']); // { 'name': 'apple' }
 */
var omit = (/* unused pure expression or super */ null && (omit$2));

/**
 * Creates an object with the same keys as `object` and values generated
 * by running each own enumerable string keyed property of `object` thru
 * `iteratee`. The iteratee is invoked with three arguments:
 * (value, key, object).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Object
 * @param {Object} object The object to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Object} Returns the new mapped object.
 * @see _.mapKeys
 * @example
 *
 * var users = {
 *   'fred':    { 'user': 'fred',    'age': 40 },
 *   'pebbles': { 'user': 'pebbles', 'age': 1 }
 * };
 *
 * _.mapValues(users, function(o) { return o.age; });
 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
 *
 * // The `_.property` iteratee shorthand.
 * _.mapValues(users, 'age');
 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
 */
function mapValues$1(object, iteratee) {
  var result = {};
  iteratee = baseIteratee(iteratee);
  baseForOwn(object, function (value, key, object) {
    baseAssignValue(result, key, iteratee(value, key, object));
  });
  return result;
}

/**
 * mapValues(object, iteratee)
 * 객체의 각 속성 값에 iteratee 함수를 적용하여 결과를 새로운 객체로 매핑합니다.
 * Iteratee는 (value, key, object)를 인자로 받습니다.
 *
 * @param {Object} object - 처리할 객체.
 * @param {Function|Object|string} iteratee - 각 속성 값에 적용할 함수 또는 속성 이름.
 * @returns {Object} 각 속성 값에 iteratee를 적용한 새 객체.
 *
 * @example
 * const users = { 'fred': { 'user': 'fred', 'age': 40 }, 'pebbles': { 'user': 'pebbles', 'age': 1 } };
 * mapValues(users, o => o.age); // => { 'fred': 40, 'pebbles': 1 }
 *
 * @example
 * // `_.property` iteratee shorthand를 사용하는 예시
 * mapValues(users, 'age'); // => { 'fred': 40, 'pebbles': 1 }
 *
 * @see [Lodash Documentation for mapValues]{@link https://lodash.com/docs/4.17.15#mapValues}
 *
 * Lodash 문서에 따른 추가 설명:
 * The iteratee is invoked with three arguments: (value, key, object).
 * Creates an object with the same keys as object and values generated by running each property of object thru iteratee.
 */
var mapValues = (/* unused pure expression or super */ null && (mapValues$1));

/**
 * 숫자에 천자리 단위 (,)를 추가합니다.
 * @param x 천자리 단위 (,) 넣을 숫자
 * @returns 천자리 단위 (,) 포함된 숫자
 * @example
 * ```
 * formatComma(1000000);
 * 1,000,000
 * ```
 */
function formatComma(x) {
  if (x == null || Number.isNaN(Number(x))) {
    return '';
  }
  return x.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
}

/**
 * Convert string to number (e.g., remove comma)
 * @param value 문자로된 숫자
 * @return comma 제거된 숫자
 * @example
 * ```
 * stringToNumber(1,000,000)
 * 1000000
 * ```
 */
function stringToNumber(value) {
  var numberValue = parseFloat(value.replace(/,/g, ''));
  return isNaN(numberValue) ? undefined : numberValue;
}

var HANGUL_INITIAL = 'rRseEfaqQtTdwWczxvg'.split('');
var HANGUL_MEDIAL = 'k,o,i,O,j,p,u,P,h,hk,ho,hl,y,n,nj,np,nl,b,m,ml,l'.split(',');
var HANGUL_FINAL = (',r,R,rt,s,sw,sg,e,f,fr,fa,fq,ft,fx,fv,fg,a,q,qt,t,T,' + 'd,w,c,z,x,v,g').split(',');
var HANGUL_JAMO = (',r,R,rt,s,sw,sg,e,E,f,fr,fa,fq,ft,fx,fv,fg,a,q,Q,qt,t,' + 'T,d,w,W,c,z,x,v,g,k,o,i,O,j,p,u,P,h,hk,ho,hl,y,n,nj,np,nl,b,m,ml,l').split(',');
/**
 * 주어진 문자열에서 각 한글 문자를 로마자 표기법으로 변환된 자음과 모음으로 분해합니다.
 *
 * @param input 분해할 한글 문자열입니다.
 * - 한글 음절 문자(가-힣)는 초성, 중성, 종성으로 분해되어 로마자로 표기됩니다.
 * - 한글 자모 문자(ㄱ-ㅣ)는 해당하는 로마자로 변환됩니다.
 * - 한글이 아닌 문자는 변경 없이 반환됩니다.
 *
 * @return 분해되고 로마자로 변환된 문자열을 반환합니다. 각 한글 음절 문자는 로마자 표기법에 따른 초성, 중성, 종성 순으로 분해되며,
 * 나머지 문자는 원래의 문자 그대로 반환됩니다.
 *
 * @example
 * decomposeHangul('안녕하세요');
 * 반환값: 'ㅇㅏㄴㅅㅕㅇㅎㅏㅅㅔㅇㅛ'
 */
function decomposeHangul(input) {
  return input.split('').map(function (char) {
    var code = char.charCodeAt(0);
    if (code >= 0xAC00 && code <= 0xD7A3) {
      // Decompose hangul to dubeolsik characters.
      code -= 0xAC00;
      var final = HANGUL_FINAL[code % HANGUL_FINAL.length];
      code = code / HANGUL_FINAL.length | 0;
      var medial = HANGUL_MEDIAL[code % HANGUL_MEDIAL.length];
      code = code / HANGUL_MEDIAL.length | 0;
      var initial = HANGUL_INITIAL[code % HANGUL_INITIAL.length];
      return [initial, medial, final].join('');
    } else if (code >= 0x3130 && code <= 0x3163) {
      return HANGUL_JAMO[code - 0x3130];
    }
    return char;
  }).join('');
}

/**
 * 주어진 숫자를 지정된 기준(base)를 기반으로 승수(step)를 구하고 정규화된 값을 반환합니다.
 *
 * 정규화된 값은 입력된 숫자를 해당 숫자를 나누는 기준(base)의 최고 차수로 나눈 결과입니다.
 * 단계는 입력된 숫자를 나누는 기준(base)의 최고 차수의 지수를 나타냅니다.
 *
 * @example calculateExponentStep(2312111, 1000) -> [2.3, 2]
 *
 * @param input 계산할 숫자
 * @param base 기준 값
 * @returns 정규화된 값과 단계를 포함하는 배열을 반환합니다.
 */
function calculateExponentStep(input, base) {
  if (input === 0) {
    return [0, 0];
  }
  var step = Math.floor(Math.log10(Math.abs(input)) / Math.log10(base));
  var divisor = Math.pow(base, step);
  return [input / divisor, step];
}

/**
 * 큰 수를 줄임 표기 형태로 변환합니다.
 *
 * @example 2312111 -> 2.3M
 * @example 126057 -> 126K
 *
 * @param number 변환할 숫자
 * @param base 기준값
 * @params markers 기준값에 따른 표기
 * @returns 변환된 문자열
 */
function formatLargeNumber(number) {
  var base = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1000;
  var markers = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : ['', 'K', 'M', 'B'];
  var formatNumber = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : function (n) {
    return String(Math.floor(n * 10) / 10);
  };
  var _calculateExponentSte = calculateExponentStep(number, base),
    _calculateExponentSte2 = _slicedToArray(_calculateExponentSte, 2),
    value = _calculateExponentSte2[0],
    step = _calculateExponentSte2[1];
  if (step >= markers.length) {
    var cappedStep = markers.length - 1;
    var accumulated = value * Math.pow(base, step - cappedStep);
    return "".concat(accumulated.toFixed(1)).concat(markers[cappedStep]);
  }
  return "".concat(formatNumber(value)).concat(markers[step]);
}

var ENDPOINT = 'https://upload.ohou.se';
/**
 * 구 upload 함수, prs/pfs로 전환해야 합니다.
 * @param url 업로드 url
 * @param data 업로드 대상
 * @param onProgress progress callback
 * @returns void
 */
function upload(url, data, onProgress) {
  return new Promise(function (resolve, reject) {
    var xhr = new XMLHttpRequest();
    xhr.addEventListener('readystatechange', function () {
      if (xhr.readyState === 4) {
        if (xhr.status === 200) {
          try {
            var body = JSON.parse(xhr.responseText);
            resolve(body);
          } catch (e) {
            reject(e);
          }
        } else {
          reject(new Error(xhr.responseText));
        }
      }
    });
    if (xhr.upload != null) {
      xhr.upload.addEventListener('progress', function (event) {
        if (onProgress != null) {
          onProgress(event.loaded / event.total);
        }
      });
    }
    xhr.addEventListener('error', function (err) {
      reject(err);
    });
    xhr.open('POST', url);
    xhr.send(data);
  });
}

/**
 * 구 파일 업로드
 * @param bucket bucket 정보 e.g bucketplace-v2-development
 * @param key key
 * @param name file name
 * @param blob file blob
 * @param onProgress onProgress callback
 * @returns void
 */
function uploadFile(bucket, key, name, blob, onProgress) {
  var formData = new FormData();
  formData.append('file', blob, name);
  return upload("".concat(ENDPOINT, "/u/").concat(bucket).concat(key != null && key !== '' ? "/".concat(key) : ''), formData, onProgress);
}

/**
 * 구 이미지 업로드 함수
 * @param bucket bucket 정보 e.g bucketplace-v2-development
 * @param file 파일
 * @param onProgress onProgress callback
 * @param filePath 파일 path
 * @returns void
 */
function uploadImage(_ref) {
  var bucket = _ref.bucket,
    file = _ref.file,
    onProgress = _ref.onProgress,
    filePath = _ref.filePath;
  var formData = new FormData();
  formData.append('file', file);
  return upload("".concat(ENDPOINT, "/i/").concat(bucket).concat(filePath != null && filePath !== '' ? "/".concat(filePath) : ''), formData, onProgress);
}

/**
 * IE미지원 관련 스크립트를 제공합니다.
 * @returns {string} ie 미지원 스크립트
 * @example
 * ```
 * <Script
 *   id="ie-support"
 *   strategy="beforeInteractive"
 * >
 *   { getOutdatedBrowserNoticeScript() }
 * </Script>
 * ```
 */
var getOutdatedBrowserNoticeScript = function getOutdatedBrowserNoticeScript() {
  return "\n    const agent = navigator.userAgent.toLowerCase();\n    const isIE = (navigator.appName === \"Netscape\" && agent.indexOf(\"trident\") !== -1) || (agent.indexOf(\"msie\") !== -1);\n\n    if (isIE) {\n      alert(\"\uC774 \uBE0C\uB77C\uC6B0\uC800(\uC778\uD130\uB137 \uC775\uC2A4\uD50C\uB85C\uB7EC)\uB294 \uC11C\uBE44\uC2A4 \uC9C0\uC6D0\uC774 \uC885\uB8CC\uB418\uC5C8\uC2B5\uB2C8\uB2E4. \uB2E4\uB978 \uBE0C\uB77C\uC6B0\uC800\uB85C \uC624\uB298\uC758\uC9D1\uC744 \uC774\uC6A9\uD574 \uC8FC\uC138\uC694.\");\n      window.location.href = \"https://www.microsoft.com/edge\";\n    }\n  ";
};

/** Browser 인지 여부를 판단합니다.
 * @returns {boolean} Browser 여부
 * @example
 * ```
 * isBrowser(); // true / false
 */
var isBrowser = function isBrowser() {
  return typeof window !== 'undefined';
};

/**
 * IE 여부를 판단합니다.
 * @param userAgent user-agent
 * @returns IE 여부
 * @example
 * ```
 * isIE(usergAgent);
 * // true / false
 * ```
 */
var IE_REGEX = /MSIE|Trident/;
var isIE = function isIE() {
  var userAgent = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  if (userAgent !== '') {
    return IE_REGEX.test(userAgent);
  }
  return typeof window !== 'undefined' ? IE_REGEX.test(navigator.userAgent) : false;
};

/**
 * 이 함수는 사용자 브라우저가 Safari인지 확인합니다.
 * 사용자 에이전트 문자열을 확인하여 WebKit 엔진을 사용하고,
 * Chrome, Firefox, Opera, Mercury 브라우저가 아닌지 확인합니다.
 *
 * @returns {boolean} 사용자 Safari 브라우저를 사용하면 true를, 그렇지 않으면 false를 반환합니다.
 */
function isSafari() {
  var ua = window.navigator.userAgent;
  return /WebKit/i.test(ua) && !/(CriOS|FxiOS|OPiOS|mercury)/i.test(ua);
}

/**
 * 새 브라우저 창(팝업)을 열거나, 선택적으로 바로 닫는 함수입니다.
 *
 * @param url - 팝업에 로드할 URL입니다. 기본값은 'about:blank'로, 빈 페이지를 의미합니다.
 * @param target - 팝업창의 이름입니다. 기본값은 'popupWindow' 입니다.
 * @param popupOption - 팝업 창에 대한 옵션 문자열입니다(창 크기, 위치, 스크롤바 존재 여부 등). 이 값은 선택 사항입니다.
 *
 * @return 팝업 창이 성공적으로 열렸으면 Window 객체를, 실패하면 null을 반환합니다.
 *
 * @example
 * openPopup({ url: 'https://www.example.com', popupOption: 'width=600,height=400' });
 * 반환값: Window 객체 (팝업 창이 성공적으로 열렸을 경우)
 */
var openPopup = function openPopup(_ref) {
  var _ref$url = _ref.url,
    url = _ref$url === void 0 ? 'about:blank' : _ref$url,
    _ref$target = _ref.target,
    target = _ref$target === void 0 ? 'popupWindow' : _ref$target,
    popupOption = _ref.popupOption;
  return window.open(url, target, popupOption);
};

/**
 * 지정된 HTML 요소가 보이도록 웹페이지를 스크롤합니다. 최종 스크롤 위치를 조정하기 위해 선택적으로 오프셋을 제공할 수 있습니다.
 * @param elementNode - 스크롤하려는 대상 HTML 요소입니다.
 * @param offset - 목표 요소의 최종 위치에서 스크롤 위치를 조정하는 데 사용되는 오프셋 값입니다. 기본값은 100입니다. 이 값은 스크롤될 요소가 뷰포트 상단에 바로 위치하지 않게 하거나, 페이지의 고정된 요소에 의해 가려지지 않도록 하기 위해 사용됩니다.
 *
 * @returns 없음 (void)
 *
 * @example
 * ```typescript
 * // 요소를 찾아 해당 요소로 스크롤
 * const element = document.getElementById('target-element');
 * scrollToElement(element, 150);
 *
 * // 기본 오프셋(100)을 사용하여 스크롤
 * scrollToElement(element);
 * ```
 */
function scrollToElement(elementNode) {
  var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 100;
  if (elementNode != null) {
    var scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    var targetOffset = elementNode.getBoundingClientRect().top;
    window.scrollTo({
      top: scrollTop - offset + targetOffset,
      behavior: 'smooth'
    });
  }
}

var nextTick = null;
var sineIn = function sineIn(t) {
  var value = Math.cos(t * Math.PI * 0.5);
  return Math.abs(value) < 1e-14 ? 1 : 1 - value;
};
var clearSmoothScroll = function clearSmoothScroll() {
  if (nextTick) {
    cancelAnimationFrame(nextTick);
    nextTick = null;
  }
};
/**
 * 특정 위치로 스크롤이 자연스럽게 이동할 수 있도록 하는 함수입니다.
 * @param endPoint 이동할 위치
 * @param duration 이동에 걸리는 시간
 * @param ease 이동 시 모션에 사용할 함수
 * @param handle 이동 시에 계속 실행될 콜백 함수
 * @returns 없음 (void)
 * @example
 * ```typescript
 * // 이징 함수 정의 (예: ease-in 함수)
 * const easeInQuad = (t: number): number => t * t;
 *
 * // smoothPageScrollWithDuration을 호출하여 500px 지점으로 300ms 동안 부드럽게 스크롤
 * smoothPageScrollWithDuration({
 *   endPoint: 500,
 *   duration: 300,
 *   ease: easeInQuad,
 *   handle: () => console.log('스크롤 완료!')
 * });
 * ```
 */
var smoothPageScrollWithDuration = function smoothPageScrollWithDuration(_ref) {
  var endPoint = _ref.endPoint,
    duration = _ref.duration,
    _ref$ease = _ref.ease,
    ease = _ref$ease === void 0 ? sineIn : _ref$ease,
    handle = _ref.handle;
  var start = document.documentElement.scrollTop;
  var startTime = Date.now();
  var scrollAmount = endPoint - start;
  if (Math.abs(scrollAmount) < 1) {
    handle === null || handle === void 0 || handle();
    return;
  }
  clearSmoothScroll();
  var tick = function tick() {
    var elapsed = Date.now() - startTime;
    var top = ease(Math.min(1, elapsed / duration)) * scrollAmount + start;
    window.scrollTo(0, top);
    if (elapsed < duration) {
      nextTick = requestAnimationFrame(tick);
    } else {
      nextTick = null;
      handle === null || handle === void 0 || handle();
    }
  };
  nextTick = requestAnimationFrame(tick);
};

/**
 * text를 clipboard로 복사합니다.
 * @param text 복사할 text
 * @returns 성공 여부
 * @example
 * ```
 * copyTextToClipboard('오늘의집')
 * true or false
 * ```
 */
var copyTextToClipboard = function copyTextToClipboard(text) {
  var textArea = document.createElement('textarea');
  textArea.style.position = 'fixed';
  textArea.style.top = '0';
  textArea.style.left = '0';
  textArea.style.width = '20em';
  textArea.style.height = '20em';
  textArea.style.padding = '0';
  textArea.style.border = 'none';
  textArea.style.outline = 'none';
  textArea.style.boxShadow = 'none';
  textArea.style.background = 'transparent';
  textArea.value = text;
  document.body.appendChild(textArea);
  if (navigator.userAgent.match(/ipad|ipod|iphone/i)) {
    textArea.contentEditable = 'true';
    textArea.readOnly = true;
    var range = document.createRange();
    range.selectNodeContents(textArea);
    var selection = window.getSelection();
    selection.removeAllRanges();
    selection.addRange(range);
    textArea.setSelectionRange(0, 9999999);
  } else {
    textArea.select();
  }
  var successful = false;
  try {
    /** execCommand: deprecated된 메소드 입니다. */
    successful = document.execCommand('copy');
  } catch (err) {
    throw new Error('Unable to copy');
  } finally {
    window.document.body.removeChild(textArea);
  }
  return successful;
};

/**
 * text를 clipboard로 복사합니다.
 * @param {string} text 복사할 text
 * @returns {boolean} 성공 여부
 * @example
 * ```
 * copyText(text)
 * ```
 */
var copyText = /*#__PURE__*/(/* unused pure expression or super */ null && (function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(text) {
    var isSuccess;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.prev = 0;
          _context.next = 3;
          return window.navigator.clipboard.writeText(text);
        case 3:
          _context.next = 11;
          break;
        case 5:
          _context.prev = 5;
          _context.t0 = _context["catch"](0);
          console.error(_context.t0);
          isSuccess = copyTextToClipboard(text);
          if (isSuccess) {
            _context.next = 11;
            break;
          }
          throw new Error('Unable to copy');
        case 11:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[0, 5]]);
  }));
  return function copyText(_x) {
    return _ref.apply(this, arguments);
  };
}()));
/**
 * async한 text를 clipboard로 복사합니다.
 * @param {Promise<string>} asyncText 복사할 text
 * @returns {Promise<boolean>} 성공 여부
 * @example
 * ```
 * const text = createShareLink().then(response => response.data.url);
 * const result = await asyncCopyText(text);
 * ```
 */
var asyncCopyText = /*#__PURE__*/(/* unused pure expression or super */ null && (function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(asyncText) {
    var urlToCopy, isIos, clipboardItem;
    return _regeneratorRuntime().wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          urlToCopy = '';
          isIos = navigator.userAgent.match(/ipad|ipod|iphone|safari/i) && !navigator.userAgent.match(/android/i);
          /** @ https://wolfgangrittner.dev/how-to-use-clipboard-api-in-firefox/ */
          if (!(isIos && (typeof ClipboardItem === "undefined" ? "undefined" : _typeof(ClipboardItem)) && navigator.clipboard.write)) {
            _context2.next = 7;
            break;
          }
          // NOTE: Safari locks down the clipboard API to only work when triggered
          //   by a direct user interaction. You can't use it async in a promise.
          //   But! You can wrap the promise in a ClipboardItem, and give that to
          //   the clipboard API.
          //   Found this on https://developer.apple.com/forums/thread/691873
          clipboardItem = new ClipboardItem({
            'text/plain': asyncText.then(function (text) {
              urlToCopy = text;
              return new Blob([text], {
                type: 'text/plain'
              });
            })
          });
          return _context2.abrupt("return", navigator.clipboard.write([clipboardItem]).then(function () {
            return true;
          }).catch(function () {
            try {
              return copyTextToClipboard(urlToCopy);
            } catch (err) {
              console.error('Could not copy text: ', err);
              return false;
            }
          }));
        case 7:
          _context2.next = 9;
          return asyncText;
        case 9:
          urlToCopy = _context2.sent;
          return _context2.abrupt("return", navigator.clipboard.writeText(urlToCopy).then(function () {
            return true;
          }).catch(function () {
            try {
              copyTextToClipboard(urlToCopy);
              return true;
            } catch (err) {
              console.error('Could not copy text: ', err);
              return false;
            }
          }));
        case 11:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));
  return function asyncCopyText(_x2) {
    return _ref2.apply(this, arguments);
  };
}()));

/**
 * url에서 쿼리 파라미터를 추출하여 객체 형태로 변환합니다.
 * @param {string} url url
 * @returns url 쿼리 객체
 * @example
 * ```
 * getQuery('https://ohou.se?a=1&b=2');
 * { a: 1, b: 2 }
 * ```
 */
var getQuery = memoize$1(function (url) {
  var search = (/\?(.+)$/.exec(url) || ['', ''])[1];
  return queryString.parse(search.replace(/&amp;/g, '&'));
});

/**
 * 환경별 OHS_URL
 */
var OHS_URL = {
  prod: 'https://ohou.se',
  stage: 'https://stage-web.dailyhou.se',
  qa: 'https://qa-web.dailyhou.se',
  dev: 'https://dev-web.dailyhou.se',
  local: 'https://local.dev-web.dailyhou.se'
};

/**
 * 로그인 URL을 생성합니다.
 * @param env 환경
 * @param path 로그인 후 path 돌아올 path
 * @param bridgePath ohou.se/bridgePath/path를 활용하는 path
 * login 후 ohou.se로밖에 갈 수 없기 때문에 redirection 필요
 * @returns redirectPath
 */
var getLoginURL = function getLoginURL(_ref) {
  var env = _ref.env,
    path = _ref.path,
    bridgePath = _ref.bridgePath;
  var redirectUrl = "/".concat(bridgePath).concat(path);
  return "".concat(OHS_URL[env], "/users/sign_in?redirect_to=").concat(encodeURIComponent(redirectUrl));
};


//# sourceMappingURL=index.es.js.map


/***/ }),

/***/ 28746:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "lr": function() { return /* reexport */ Carousel; },
  "O8": function() { return /* reexport */ stickyEmulation_DEFAULT_STICKY_STATE; },
  "w4": function() { return /* reexport */ FocusTrapChild; },
  "Dw": function() { return /* reexport */ FocusTrapContainer; },
  "ux": function() { return /* reexport */ ResizeImage; },
  "tH": function() { return /* reexport */ ScrollLock; },
  "Le": function() { return /* reexport */ Sticky_Sticky; },
  "nK": function() { return /* reexport */ StickyProvider; },
  "Jd": function() { return /* reexport */ VirtualizedList; },
  "aB": function() { return /* reexport */ useGetStickyHeight; },
  "XP": function() { return /* reexport */ useNodeHeight_useNodeHeight; },
  "se": function() { return /* reexport */ useNodeSize_useNodeSize; },
  "mw": function() { return /* reexport */ usePagedInfiniteList; },
  "C7": function() { return /* reexport */ useScrollDirection_useScrollDirection; },
  "KG": function() { return /* reexport */ useStickyHeight; }
});

// UNUSED EXPORTS: BaseSticky, CoverResizeImage, FocusTrapContext, IS_IOS, NATIVE_STICKY_NAME, ResizeImageDiv, STICKY_OPTIONS_KEYS, ScrollSticky, ScrollStickyCompat, StickyCompat, StickyControlContext, StickyValueContext, assertStickyParentPosition, getImageUrl, getStickyChildStyle, getStickyContainerStyle, getUpdatedStickyState, hasStickyStateChanged, useBaseSticky, useExpandableView, useFocusTrapChild, useForkRef, useHasObjectFit, usePagedCursorInfiniteList, usePixelRatio, useScrollAppear, useSticky

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.3.1/node_modules/react/index.js
var react = __webpack_require__(75271);
// EXTERNAL MODULE: ./node_modules/.pnpm/classnames@2.5.1/node_modules/classnames/index.js
var classnames = __webpack_require__(82187);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/.pnpm/@emotion+styled@11.13.0_@emotion+react@11.13.3_@types+react@18.3.12_react@18.3.1/node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js
var emotion_styled_browser_esm = __webpack_require__(81909);
// EXTERNAL MODULE: ./node_modules/.pnpm/@typed-decorators+autobind@0.3.0/node_modules/@typed-decorators/autobind/dist/autobind.js
var autobind = __webpack_require__(31226);
;// CONCATENATED MODULE: ./node_modules/.pnpm/@bucketplace+ui@1.0.9_@emotion+react@11.13.3_@emotion+styled@11.13.0_react-dom@18.3.1_react@18.3.1_scheduler@0.23.2/node_modules/@bucketplace/ui/lib-esm/utils/focus.js
function getFocusableNodes(element) {
    return Array.from(element.querySelectorAll('a:not([disabled]), button:not([disabled]), ' +
        'input[type=text]:not([disabled]), ' +
        '[tabindex]:not([disabled]):not([tabindex="-1"])'));
}
//# sourceMappingURL=focus.js.map
;// CONCATENATED MODULE: ./node_modules/.pnpm/@bucketplace+ui@1.0.9_@emotion+react@11.13.3_@emotion+styled@11.13.0_react-dom@18.3.1_react@18.3.1_scheduler@0.23.2/node_modules/@bucketplace/ui/lib-esm/components/Carousel/Carousel.js
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};





/**
 * Renders a carousel object which is used to cycle through multiple elements,
 * usually used for jumbotron and banners.
 *
 * It provides auto play, dragging in both mobile and PC,
 * ability to render controls, and wrapping at the border of the carousel.
 */
class Carousel extends react.PureComponent {
    constructor(props) {
        super(props);
        this.autoPlayTimer = null;
        this.touchStartPos = null;
        this.touchStartAt = 0;
        this.touchDelta = 0;
        this.touchTouches = [];
        this.touchTarget = null;
        this.touchScrolling = null;
        this.preventUntil = 0;
        this.node = null;
        this.listNode = null;
        this.listWrapNode = null;
        this.entryNodes = [];
        this.hadKeyEvent = false;
        this.state = {
            offset: props.initialOffset || 0,
            fromOffset: null,
            toOffset: null,
            offsetDelta: 0,
            animating: false,
            animatingDuration: '.35s',
            dragging: false,
            mainFocused: false,
            focused: false,
            focusVisible: false,
            autoPlaying: !!props.autoPlay,
        };
    }
    componentDidMount() {
        const { autoPlay } = this.props;
        this.toggleAutoPlayHandler(!!autoPlay);
        document.addEventListener('keydown', this.handleDocumentKeyDown, true);
        if (this.node != null) {
            this.node.addEventListener('touchstart', this.handleTouchStart, {
                passive: false,
            });
            this.node.addEventListener('touchmove', this.handleTouchMove, {
                passive: false,
            });
            this.node.addEventListener('focusin', this.handleMainFocusIn);
            this.node.addEventListener('focusout', this.handleMainFocusOut);
        }
        if (this.listNode != null) {
            this.listNode.addEventListener('focusin', this.handleFocusIn);
            this.listNode.addEventListener('focusout', this.handleFocusOut);
        }
    }
    componentDidUpdate() {
        const { autoPlaying, dragging } = this.state;
        // Disable auto play if it's dragging or autoPlay is disabled.
        this.toggleAutoPlayHandler(!!autoPlaying && !dragging);
    }
    componentWillUnmount() {
        this.toggleAutoPlayHandler(false);
        document.removeEventListener('keydown', this.handleDocumentKeyDown, true);
        if (this.node != null) {
            this.node.removeEventListener('touchstart', this.handleTouchStart);
            this.node.removeEventListener('touchmove', this.handleTouchMove);
            this.node.removeEventListener('focusin', this.handleMainFocusIn);
            this.node.removeEventListener('focusout', this.handleMainFocusOut);
        }
        if (this.listNode != null) {
            this.listNode.removeEventListener('focusin', this.handleFocusIn);
            this.listNode.removeEventListener('focusout', this.handleFocusOut);
        }
    }
    setAutoPlaying(enabled) {
        this.setState({ autoPlaying: enabled });
        this.toggleAutoPlayHandler(enabled);
    }
    toggleAutoPlayHandler(enabled) {
        const { autoPlayInterval } = this.props;
        if (enabled && this.autoPlayTimer == null) {
            this.autoPlayTimer = window.setInterval(this.next, autoPlayInterval || 3000);
        }
        else if (!enabled && this.autoPlayTimer != null) {
            clearInterval(this.autoPlayTimer);
            this.autoPlayTimer = null;
        }
    }
    handleTouchStart(e) {
        const { onInteract, disableSwipe, disableWrap } = this.props;
        const { offset } = this.state;
        const count = this.getLength();
        if (count <= 1) {
            // There's no point to perform dragging when count is lower than 2
            return;
        }
        if (disableSwipe) {
            return;
        }
        if (onInteract != null) {
            onInteract();
        }
        this.setState({ dragging: true });
        if (this.touchStartPos == null) {
            let newOffset = offset;
            if (disableWrap) {
                const bounds = this.getOffsetBounds();
                newOffset = Math.max(bounds[0], Math.min(bounds[1], newOffset));
            }
            this.touchStartPos = newOffset;
            this.touchStartAt = Date.now();
            this.touchScrolling = null;
            this.touchDelta = 0;
            if ('touches' in e) {
                this.touchTouches = Array.from(e.touches).map((touch) => ({
                    identifier: touch.identifier,
                    clientX: touch.clientX,
                    clientY: touch.clientY,
                }));
                // Attach touch events to the target.
                this.touchTarget = e.touches[0].target;
                this.touchTarget.addEventListener('touchmove', this.handleTouchMove);
                this.touchTarget.addEventListener('touchend', this.handleTouchEnd);
                this.touchTarget.addEventListener('touchcancel', this.handleTouchEnd);
                // Safari doesn't emit touchend in the touch target.
                window.addEventListener('touchend', this.handleTouchEnd);
                window.addEventListener('touchcancel', this.handleTouchEnd);
            }
            else {
                this.touchTouches = [
                    {
                        identifier: 0,
                        clientX: e.nativeEvent.clientX,
                        clientY: e.nativeEvent.clientY,
                    },
                ];
                // Attach touch events to the window.
                window.addEventListener('mousemove', this.handleTouchMove);
                window.addEventListener('mouseup', this.handleTouchEnd);
            }
            e.stopPropagation();
        }
    }
    handleTouchMove(e) {
        const { disableSwipe, disableWrap, childWidthRatio = 1 } = this.props;
        if (e.defaultPrevented)
            return;
        if (disableSwipe)
            return;
        if (this.node == null || this.touchStartPos == null)
            return;
        let touches = [];
        if ('touches' in e) {
            touches = Array.from(e.touches).map((v) => ({
                identifier: v.identifier,
                clientX: v.clientX,
                clientY: v.clientY,
            }));
        }
        else {
            touches = [
                {
                    identifier: 0,
                    clientX: e.clientX,
                    clientY: e.clientY,
                },
            ];
        }
        const { x: sumX, y: sumY, count } = touches
            .map((touch) => {
            const prev = this.touchTouches
                .find((v) => v.identifier === touch.identifier);
            if (prev == null)
                return null;
            return {
                x: touch.clientX - prev.clientX,
                y: touch.clientY - prev.clientY,
            };
        })
            .reduce((p, v) => (v != null
            ? ({ x: p.x + v.x, y: p.y + v.y, count: p.count + 1 })
            : p), { x: 0, y: 0, count: 0 });
        this.touchTouches = touches;
        if (count === 0)
            return;
        const diffX = sumX / count;
        const diffY = sumY / count;
        if ('touches' in e) {
            if (this.touchScrolling === null) {
                this.touchScrolling =
                    Math.abs(diffX) > Math.abs(diffY);
            }
            if (this.touchScrolling) {
                e.stopPropagation();
                e.preventDefault();
            }
            else {
                return;
            }
        }
        const { width } = this.node.getBoundingClientRect();
        this.touchDelta += diffX;
        const delta = this.touchDelta;
        let newOffset = this.touchStartPos - delta / width / childWidthRatio;
        let offsetDelta = 0;
        if (disableWrap) {
            const bounds = this.getOffsetBounds();
            // Apply offset bouncing effect if threshold is reached
            if (newOffset < bounds[0]) {
                offsetDelta = -Math.log(-newOffset + bounds[0] + 1) / Math.log(8);
            }
            else if (newOffset > bounds[1]) {
                offsetDelta = Math.log(newOffset - bounds[1] + 1) / Math.log(8);
            }
            newOffset = Math.max(bounds[0], Math.min(bounds[1], newOffset));
        }
        this.setState({
            offset: newOffset,
            offsetDelta,
            fromOffset: null,
            toOffset: null,
            animating: false,
            dragging: true,
        });
    }
    handleTouchEnd(e) {
        const { disableSwipe, childWidthRatio = 1, allowSwipeJump } = this.props;
        if (disableSwipe)
            return;
        if ('touches' in e && e.touches.length >= 1)
            return;
        if (this.node == null || this.touchStartPos == null)
            return;
        const { offset, dragging } = this.state;
        if (!dragging) {
            return;
        }
        const deltaX = this.touchDelta;
        const deltaTime = Date.now() - this.touchStartAt;
        let newOffset = Math.round(offset);
        const deltaOffset = newOffset - Math.round(this.touchStartPos);
        const { width } = this.node.getBoundingClientRect();
        const deltaValue = deltaX / deltaTime / width / childWidthRatio * 1000;
        let duration = '.35s';
        if (Math.abs(deltaValue) > 1) {
            const sign = deltaValue > 0 ? 1 : -1;
            let absDeltaValue = Math.abs(deltaValue);
            if (!allowSwipeJump) {
                absDeltaValue = 1;
            }
            const appliedDelta = Math.ceil(absDeltaValue / 3) * sign;
            if (Math.abs(deltaOffset) < Math.abs(appliedDelta)) {
                newOffset = Math.round(this.touchStartPos) - appliedDelta;
                duration = `${0.35 + Math.abs(appliedDelta) * 0.01}s cubic-bezier(.19,.18,.24,1)`;
            }
        }
        this.setState({ dragging: false });
        this.setOffset(newOffset, false, duration);
        // To prevent immediately firing click event, disable click event for
        // a short period if it moved far enough
        if (Math.abs(deltaX) > 5) {
            e.preventDefault();
            this.preventUntil = Date.now() + 200;
        }
        // Remove events if no more touches are left.
        if (!('touches' in e)) {
            this.touchStartPos = null;
            window.removeEventListener('mousemove', this.handleTouchMove);
            window.removeEventListener('mouseup', this.handleTouchEnd);
        }
        else if (e.touches.length === 0) {
            this.touchStartPos = null;
            if (this.touchTarget != null) {
                this.touchTarget.removeEventListener('touchmove', this.handleTouchMove);
                this.touchTarget.removeEventListener('touchend', this.handleTouchEnd);
                this.touchTarget.removeEventListener('touchcancel', this.handleTouchEnd);
            }
            window.removeEventListener('touchend', this.handleTouchEnd);
            window.removeEventListener('touchcancel', this.handleTouchEnd);
        }
    }
    handleClick(e) {
        if (Date.now() < this.preventUntil) {
            e.preventDefault();
            e.stopPropagation();
        }
    }
    handleDragStart(e) {
        e.preventDefault();
    }
    handleTransitionEnd() {
        const { autoPlay } = this.props;
        const { focused, toOffset, offset } = this.state;
        if (toOffset === offset) {
            this.setState({ fromOffset: null, toOffset: null, animating: false }, () => {
                if (focused && !autoPlay) {
                    // If we've had focus, set the focus to current node.
                    const { offset } = this.state;
                    this.focusNode(offset);
                }
            });
        }
    }
    handleMainFocusIn() {
        this.setState({ mainFocused: true });
        if (this.hadKeyEvent) {
            this.setState({ focusVisible: true });
        }
    }
    handleMainFocusOut() {
        this.setState({ mainFocused: false });
        const { toOffset } = this.state;
        if (toOffset == null) {
            this.setState({ focusVisible: false });
        }
    }
    handleFocusIn() {
        this.setState({ focused: true });
    }
    handleFocusOut() {
        this.setState({ focused: false });
    }
    handleKeyDown(e) {
        this.setState({ focusVisible: true });
        switch (e.keyCode) {
            case 37:
                // left
                this.prev();
                break;
            case 39:
                // right
                this.next();
                break;
            default:
        }
    }
    handleDocumentKeyDown() {
        this.hadKeyEvent = true;
        requestAnimationFrame(() => {
            this.hadKeyEvent = false;
        });
    }
    focusNode(offset) {
        const length = this.getLength();
        const newOffset = ((offset % length) + length) % length;
        const targetNode = this.entryNodes[newOffset];
        if (targetNode == null) {
            return;
        }
        const focusNodes = getFocusableNodes(targetNode);
        if (focusNodes.length > 0 && this.listWrapNode != null) {
            focusNodes[0].focus();
            this.listWrapNode.scrollLeft = 0;
        }
    }
    getLength() {
        const { children, length } = this.props;
        if (typeof children === 'function') {
            return length;
        }
        return react.Children.count(children);
    }
    getOffsetBounds() {
        const { childWidthRatio = 1, borderWidthRatio = 0, align = 'center', } = this.props;
        const length = this.getLength();
        if (align === 'center') {
            return [0, Math.max(0, length - 1)];
        }
        else if (align === 'left') {
            return [
                -borderWidthRatio,
                Math.max(0, length - 1 / childWidthRatio) + borderWidthRatio,
            ];
        }
        else if (align === 'centerConstrained') {
            const left = (1 / childWidthRatio - 1) / 2;
            return [
                left - borderWidthRatio,
                Math.max(0, length - 1 / childWidthRatio) + left + borderWidthRatio,
            ];
        }
        return [0, 0];
    }
    /**
     * Returns the "effective" bounds of the constrained layout. Effective bounds
     * is basically the meaningful bounds of the index.
     *
     * For example, if childWidthRatio is 1/2, and wrapping is disabled,
     * 0 and 1 position is effectively same, since 0 position can fully display
     * 1 position.
     *
     * The rightmost side is the same, length - 1, and length - 2 position
     * is redundant.
     *
     * If this redundant index is not resolved, the user have to press "next"
     * button twice to go to next page. Hence, this limits the bounds of the
     * min / max position. If the index is smaller / bigger than min / max,
     * it automatically changes to 0 / length - 1.
     *
     * @return {[number, number]} The min/max bounds of the offset.
     */
    getEffectiveBounds() {
        const { disableWrap, align, childWidthRatio = 1, } = this.props;
        const length = this.getLength();
        if (!disableWrap) {
            return [0, length - 1];
        }
        switch (align) {
            case 'centerConstrained':
                return [
                    Math.ceil((Math.floor(1 / childWidthRatio) - 1) / 2),
                    length - Math.ceil((Math.floor(1 / childWidthRatio) - 1) / 2) - 1,
                ];
            case 'left':
                return [
                    0,
                    length - Math.floor(1 / childWidthRatio),
                ];
            case 'center':
            default:
                return [0, length - 1];
        }
    }
    getEffectiveOffset(offset) {
        const { disableWrap } = this.props;
        if (disableWrap) {
            const bounds = this.getEffectiveBounds();
            return Math.max(bounds[0], Math.min(bounds[1], offset));
        }
        return offset;
    }
    setOffset(newOffset, wrap = true, inputDuration) {
        const { disableWrap, childWidthRatio = 1, animationDuration = '0.35s', } = this.props;
        const duration = inputDuration || animationDuration;
        const { focused, offset } = this.state;
        if (offset === newOffset) {
            // Bailout - do nothing if two offsets are same.
            return;
        }
        const length = this.getLength();
        this.setState((state) => {
            const wrappedOffset = wrap
                ? ((state.offset % length) + length) % length
                : state.offset;
            let fromOffset = wrappedOffset;
            let toOffset = typeof newOffset === 'function'
                ? newOffset(this.getEffectiveOffset(wrappedOffset))
                : newOffset;
            if (disableWrap) {
                const bounds = this.getOffsetBounds();
                fromOffset = Math.min(bounds[1], Math.max(bounds[0], fromOffset)) +
                    state.offsetDelta;
                const effectiveBounds = this.getEffectiveBounds();
                if (toOffset <= effectiveBounds[0])
                    toOffset = 0;
                if (toOffset >= effectiveBounds[1])
                    toOffset = length - 1;
            }
            // Optimization: If we're traveling too far distance, forcibly crop the
            // travel distance - otherwise the browser will draw too many nodes
            // at once.
            const travelDistance = Math.ceil(1 / childWidthRatio * 5);
            fromOffset = Math.max(toOffset - travelDistance, Math.min(toOffset + travelDistance, fromOffset));
            return {
                offset: fromOffset,
                fromOffset,
                toOffset,
                offsetDelta: state.offsetDelta,
                animating: false,
            };
        }, () => requestAnimationFrame(() => {
            requestAnimationFrame(() => {
                const { onOffsetChange, autoPlay } = this.props;
                const { toOffset } = this.state;
                const wrappedOffset = (((toOffset ?? 0) % length) + length) % length;
                if (toOffset != null) {
                    if (focused && !autoPlay) {
                        // If we've had focus, set the focus to current node.
                        this.focusNode(wrappedOffset);
                    }
                    if (onOffsetChange != null) {
                        onOffsetChange(wrappedOffset);
                    }
                    this.setState((state) => ({
                        offset: state.toOffset,
                        offsetDelta: 0,
                        animating: true,
                        animatingDuration: duration,
                    }));
                }
            });
        }));
    }
    prev(duration) {
        const { autoPlay, autoPlayInterval } = this.props;
        if (autoPlay && this.autoPlayTimer != null) {
            clearInterval(this.autoPlayTimer);
            this.autoPlayTimer = null;
            this.autoPlayTimer = window.setInterval(this.next, autoPlayInterval || 3000);
        }
        this.setOffset((offset) => Math.round(offset - 1), false, duration);
    }
    next(duration) {
        const { autoPlay, autoPlayInterval } = this.props;
        if (autoPlay && this.autoPlayTimer != null) {
            clearInterval(this.autoPlayTimer);
            this.autoPlayTimer = null;
            this.autoPlayTimer = window.setInterval(this.next, autoPlayInterval || 3000);
        }
        this.setOffset((offset) => Math.round(offset + 1), false, duration);
    }
    handleOnMouseEnter() {
        const { autoPlay } = this.props;
        if (autoPlay) {
            this.setAutoPlaying(false);
        }
    }
    handleOnMouseLeave() {
        const { autoPlay } = this.props;
        if (autoPlay) {
            this.setAutoPlaying(true);
        }
    }
    render() {
        const { children, length, className, wrapperClassName, listClassName, entryClassName, nodeRef, renderControls, childWidthRatio = 1, childLookahead = 0, disableWrap, wrappedChildren, onRowsRendered, align = 'center', } = this.props;
        let { offset, toOffset } = this.state;
        const { fromOffset, offsetDelta, animating, animatingDuration, autoPlaying, mainFocused, focused, focusVisible } = this.state;
        let childrenRender;
        let childrenLength;
        if (typeof children === 'function') {
            childrenRender = children;
            childrenLength = length;
        }
        else {
            const childrenList = react.Children.toArray(children);
            childrenRender = (index) => childrenList[index];
            childrenLength = childrenList.length;
        }
        const rawOffset = offset;
        if (disableWrap) {
            const bounds = this.getOffsetBounds();
            offset = Math.min(bounds[1], Math.max(bounds[0], offset)) + offsetDelta;
            if (toOffset != null) {
                toOffset = Math.min(bounds[1], Math.max(bounds[0], toOffset));
            }
        }
        let minOffset = offset;
        let maxOffset = offset;
        if (toOffset != null && fromOffset != null) {
            minOffset = Math.min(offset, fromOffset, toOffset);
            maxOffset = Math.max(offset, fromOffset, toOffset);
        }
        // Determine the required nodes to render current offset.
        const centerOffset = disableWrap
            ? Math.round(rawOffset)
            : ((Math.round(rawOffset) % childrenLength) + childrenLength) %
                childrenLength;
        let baseOffset;
        if (align === 'center' || align === 'centerConstrained') {
            // Wrap the offset
            const offsetMargin = (1 - childWidthRatio) / (2 * childWidthRatio);
            baseOffset = minOffset - offsetMargin - childLookahead;
        }
        else {
            baseOffset = minOffset - childLookahead;
        }
        // How many nodes should be visible for given offset?
        const startIndex = Math.floor(baseOffset);
        const visibleCount = Math.ceil(baseOffset +
            1 / childWidthRatio +
            (maxOffset - minOffset) +
            childLookahead * 2) -
            startIndex;
        // Then.. how much should we move left?
        const leftOffset = (baseOffset - startIndex + (offset - minOffset) + childLookahead) *
            childWidthRatio;
        const effectiveBounds = this.getEffectiveBounds();
        const controlProps = {
            prev: this.prev,
            next: this.next,
            set: this.setOffset,
            offset: this.getEffectiveOffset(centerOffset),
            length: childrenLength,
            min: effectiveBounds[0],
            max: effectiveBounds[1],
            animating: animating || toOffset != null,
        };
        // onRowsRendered is called in render phase.
        // TODO Refactor this.
        if (onRowsRendered != null) {
            onRowsRendered(startIndex, startIndex + visibleCount - 1);
        }
        const nodes = [];
        for (let i = 0; i < visibleCount; ++i) {
            const actualIndex = startIndex + i;
            const index = ((startIndex % childrenLength) + childrenLength + i) % childrenLength;
            const epoch = Math.floor(((startIndex % childrenLength) + childrenLength + i) / childrenLength);
            const isWrapped = (actualIndex <= -1 || actualIndex >= childrenLength);
            nodes.push(react.createElement(CarouselListItem, { className: classnames_default()('carousel__list__entry', epoch !== 1 && disableWrap && 'wrapped', focused && 'focus', focusVisible && 'focus-visible', entryClassName), key: actualIndex, style: { width: `${childWidthRatio * 100}%` }, ref: (node) => {
                    this.entryNodes[index] = node;
                }, onMouseEnter: this.handleOnMouseEnter, onMouseLeave: this.handleOnMouseLeave, role: 'group', "aria-roledescription": 'slide', "aria-label": isWrapped && disableWrap
                    ? undefined
                    : (`${index + 1} of ${childrenLength}`) }, isWrapped && disableWrap
                // If disableWrap is true and epoch has exceeded, don't render
                // anything but leftmost / rightmost entry.
                ? ((actualIndex === -1 || actualIndex === childrenLength) &&
                    wrappedChildren != null && wrappedChildren(actualIndex))
                : childrenRender(index, actualIndex, controlProps)));
        }
        return (react.createElement(CarouselContainer, { className: classnames_default()((mainFocused || focused) && 'focus', focused && 'focus-entry', focusVisible && 'focus-visible', className), ref: (node) => {
                this.node = node;
                if (nodeRef != null) {
                    nodeRef(node);
                }
            }, role: 'region', "aria-roledescription": 'carousel' },
            react.createElement(CarouselListWrapper, { className: classnames_default()('carousel__list-wrap', wrapperClassName), ref: (node) => {
                    this.listWrapNode = node;
                } },
                react.createElement(CarouselList, { className: classnames_default()('carousel__list', listClassName), onTouchMove: () => { }, onTouchEnd: () => { }, onMouseDown: this.handleTouchStart, onClickCapture: this.handleClick, onDragStart: this.handleDragStart, onTransitionEnd: this.handleTransitionEnd, onKeyDown: this.handleKeyDown, "aria-live": autoPlaying ? 'off' : 'polite', ref: (node) => {
                        this.listNode = node;
                    }, style: {
                        transform: `translateX(${leftOffset * -100}%)`,
                        transition: animating
                            ? `transform ${animatingDuration}`
                            : '',
                    } }, nodes)),
            renderControls != null &&
                renderControls(controlProps)));
    }
}
__decorate([
    autobind/* autobind */.N
], Carousel.prototype, "handleTouchStart", null);
__decorate([
    autobind/* autobind */.N
], Carousel.prototype, "handleTouchMove", null);
__decorate([
    autobind/* autobind */.N
], Carousel.prototype, "handleTouchEnd", null);
__decorate([
    autobind/* autobind */.N
], Carousel.prototype, "handleClick", null);
__decorate([
    autobind/* autobind */.N
], Carousel.prototype, "handleDragStart", null);
__decorate([
    autobind/* autobind */.N
], Carousel.prototype, "handleTransitionEnd", null);
__decorate([
    autobind/* autobind */.N
], Carousel.prototype, "handleMainFocusIn", null);
__decorate([
    autobind/* autobind */.N
], Carousel.prototype, "handleMainFocusOut", null);
__decorate([
    autobind/* autobind */.N
], Carousel.prototype, "handleFocusIn", null);
__decorate([
    autobind/* autobind */.N
], Carousel.prototype, "handleFocusOut", null);
__decorate([
    autobind/* autobind */.N
], Carousel.prototype, "handleKeyDown", null);
__decorate([
    autobind/* autobind */.N
], Carousel.prototype, "handleDocumentKeyDown", null);
__decorate([
    autobind/* autobind */.N
], Carousel.prototype, "setOffset", null);
__decorate([
    autobind/* autobind */.N
], Carousel.prototype, "prev", null);
__decorate([
    autobind/* autobind */.N
], Carousel.prototype, "next", null);
__decorate([
    autobind/* autobind */.N
], Carousel.prototype, "handleOnMouseEnter", null);
__decorate([
    autobind/* autobind */.N
], Carousel.prototype, "handleOnMouseLeave", null);
const CarouselContainer = emotion_styled_browser_esm/* default.div */.Z.div `
  position: relative;
`;
const CarouselListWrapper = emotion_styled_browser_esm/* default.div */.Z.div `
  overflow: hidden;
`;
const CarouselList = emotion_styled_browser_esm/* default.div */.Z.div `
  display: flex;
  flex-wrap: nowrap;
  align-items: stretch;
  min-height: 100%;
`;
const CarouselListItem = emotion_styled_browser_esm/* default.div */.Z.div `
  flex: 0 0 auto;
  -moz-user-select: -moz-none;
  -webkit-user-select: none;
  -ms-user-select: none;
  user-select: none;
  box-sizing: border-box;
`;
//# sourceMappingURL=Carousel.js.map
;// CONCATENATED MODULE: ./node_modules/.pnpm/@bucketplace+ui@1.0.9_@emotion+react@11.13.3_@emotion+styled@11.13.0_react-dom@18.3.1_react@18.3.1_scheduler@0.23.2/node_modules/@bucketplace/ui/lib-esm/components/Carousel/index.js

//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ./node_modules/.pnpm/@bucketplace+ui@1.0.9_@emotion+react@11.13.3_@emotion+styled@11.13.0_react-dom@18.3.1_react@18.3.1_scheduler@0.23.2/node_modules/@bucketplace/ui/lib-esm/components/VirtualizedList/VirtualizedList.js
var VirtualizedList_decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};


function intersectRect(a, b) {
    const top = Math.max(a.top, b.top);
    const bottom = Math.min(a.bottom, b.bottom);
    const left = Math.max(a.left, b.left);
    const right = Math.min(a.right, b.right);
    const width = right - left;
    const height = bottom - top;
    return { top, bottom, left, right, width, height };
}
function getRootRect() {
    const html = document.documentElement;
    const { body } = document;
    const width = html.clientWidth || body.clientWidth;
    const height = html.clientHeight || body.clientHeight;
    return { top: 0, left: 0, right: width, bottom: height, width, height };
}
// Try to locate the position using getValue, count, targetValue.
// This should perform within O(log n).
function binarySearch(count, getValue, targetValue) {
    let min = 0;
    let max = count;
    while (min < max) {
        const mid = (min + max) >> 1;
        const value = getValue(mid);
        if (value < targetValue) {
            min = mid + 1;
        }
        else if (value > targetValue) {
            max = mid - 1;
        }
        else {
            return mid;
        }
    }
    return min;
}
function getWindowWidth() {
    return window.innerWidth ||
        document.documentElement.clientWidth ||
        document.getElementsByTagName('body')[0].clientWidth;
}
function getWindowHeight() {
    return window.innerHeight ||
        document.documentElement.clientHeight ||
        document.getElementsByTagName('body')[0].clientHeight;
}
// Size list becomes unbelivably large if the user goes down too much -
// 1000 items is about 5KB, if 'null' is considered.
// Obviously this is not acceptable to store into sessionStorage, therefore
// we need very simple compression to compact this down to few hundred bytes.
//
// - s (n) - set stripe (sizeStep), if set, each 'w' will write N more '0'
// - w (n) - write N
// - n (n) - write null N times
// For example, 's3w100w100w200n100' becomes...
// [100, 0, 0, 0, 100, 0, 0, 0, 200, 0, 0, 0, ... 100 null items]
function encodeRLE(input) {
    let sizeStep = 1;
    const result = [];
    // First, determine size step...
    {
        let i = 0;
        while (input[i] == null || input[i] === 0) {
            i += 1;
            if (i > input.length) {
                break;
            }
        }
        while (input[i + sizeStep] === 0) {
            sizeStep += 1;
        }
    }
    result.push(`s${sizeStep}`);
    // Then process the data.
    let nullSize = 0;
    for (let i = 0; i < input.length; i += 1) {
        if (input[i] == null) {
            nullSize += 1;
        }
        else {
            if (nullSize > 0) {
                result.push(`n${nullSize}`);
                nullSize = 0;
            }
            result.push(`w${input[i]}`);
            i += sizeStep - 1;
        }
    }
    if (nullSize > 0) {
        result.push(`n${nullSize}`);
        nullSize = 0;
    }
    return result.join('');
}
function decodeRLE(input) {
    let sizeStep = 1;
    const output = [];
    for (let i = 0; i < input.length; i += 1) {
        const char = input[i];
        // Try to digest parameter number
        let numBuffer = '';
        while (input[i + 1] >= '0' && input[i + 1] <= '9') {
            numBuffer += input[i + 1];
            i += 1;
        }
        const num = parseInt(numBuffer, 10) || 0;
        switch (char) {
            case 's':
                sizeStep = num;
                break;
            case 'n':
                for (let j = 0; j < num; j += 1) {
                    output.push(null);
                }
                break;
            case 'w':
                output.push(num);
                for (let j = 1; j < sizeStep; j += 1) {
                    output.push(0);
                }
                break;
            default:
        }
    }
    return output;
}
class VirtualizedList extends react.PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            paddingTop: 0,
            paddingBottom: 0,
            startIndex: 0,
            endIndex: 24,
            tempDelta: 0,
            forceRecalculate: false,
            fastScrolling: false,
        };
        this.anchorIndex = 0;
        this.prevWindowWidth = 0;
        this.sizeList = [];
        this.sizeCount = 0;
        this.sizeSum = 0;
        this.sizeAccList = [];
        this.sizeInvalidated = null;
        this.sizeStep = null;
        this.sizeVersion = 0;
        this.prevScrollAt = 0;
        this.prevScrollPos = 0;
        this.tempDelta = 0;
        this.overridenCount = null;
        this.scrollRestore = null;
        this.scrollRestoreJump = false;
        this.scrollPending = false;
        this.resizePending = false;
        this.containerNode = null;
        this.itemLoadeds = [];
        this.itemNodes = [];
        this.itemRefs = [];
        this.resizeId = null;
        this.scrollId = null;
        this.scrollEndId = null;
        this.scrollStabilizeId = null;
        this.stabilizeId = null;
        this.beforeScrollRestoration = null;
        this.loadSaveData();
    }
    resetVirtualizedList() {
        const { tabId } = this.props;
        sessionStorage.removeItem(`vlist-data-${tabId}`);
        this.setState({
            paddingTop: 0,
            paddingBottom: 0,
            startIndex: 0,
            endIndex: 24,
            tempDelta: 0,
            forceRecalculate: false,
            fastScrolling: false,
        });
        this.scrollRestoreJump = false;
        window.scrollTo(0, 0);
    }
    loadSaveData() {
        const { tabId, disableRestore } = this.props;
        let value = null;
        try {
            value = JSON.parse(sessionStorage[`vlist-data-${tabId}`] || 'null');
        }
        catch (e) {
            // Do nothing if failed
        }
        this.overridenCount = null;
        if (value != null) {
            // Restore save data...
            if (getWindowWidth() === value.windowWidth) {
                this.sizeList = decodeRLE(value.sizeList);
                this.sizeInvalidated = 0;
                const { sum, count } = this.sizeList.reduce((p, v) => (v != null
                    ? { count: p.count + 1, sum: p.sum + v }
                    : p), { count: 0, sum: 0 });
                this.sizeSum = sum;
                this.sizeCount = count;
            }
            this.overridenCount = value.count;
            if (!disableRestore) {
                this.scrollRestore = {
                    pos: value.anchorPos,
                    offset: value.anchorOffset,
                };
            }
        }
    }
    saveSaveData(tabId) {
        if (tabId == null || this.containerNode == null) {
            return;
        }
        const { count } = this.props;
        const containerTop = this.containerNode.getBoundingClientRect().top;
        const anchorOffset = this.getAccPos(this.anchorIndex - 1) + containerTop;
        const value = {
            sizeList: encodeRLE(this.sizeList),
            windowWidth: getWindowWidth(),
            count,
            anchorPos: this.anchorIndex,
            anchorOffset,
        };
        try {
            sessionStorage[`vlist-data-${tabId}`] = JSON.stringify(value);
        }
        catch (e) {
            // Do nothing if failed
        }
    }
    updateSize(index, size) {
        const previousSize = this.getSize(index);
        if (previousSize === size) {
            return;
        }
        this.sizeVersion += 1;
        if (previousSize == null) {
            this.sizeCount += 1;
            this.sizeSum += size;
        }
        else {
            this.sizeSum += size - previousSize;
        }
        this.sizeList[index] = size;
        if (this.sizeInvalidated == null) {
            this.sizeInvalidated = index;
        }
        else {
            this.sizeInvalidated = Math.min(this.sizeInvalidated, index);
        }
    }
    getSizeLength() {
        return this.sizeList.length;
    }
    getSize(index) {
        const current = this.sizeList[index];
        return current;
    }
    getAverageSize() {
        return (this.sizeSum / this.sizeCount) || 100;
    }
    getSizeStep() {
        if (this.sizeStep == null) {
            this.sizeStep = 1;
            let i = 0;
            while (this.getSize(i) === 0 || this.getSize(i) == null) {
                i += 1;
                if (i > this.getSizeLength()) {
                    this.sizeStep = null;
                    return 1;
                }
            }
            while (this.getSize(this.sizeStep + i) === 0) {
                this.sizeStep += 1;
            }
            if (this.sizeStep >= this.getSizeLength()) {
                this.sizeStep = null;
                return 1;
            }
        }
        return this.sizeStep;
    }
    getAccPos(index) {
        const { length } = this.sizeAccList;
        if (index < 0) {
            return 0;
        }
        // Try to get direct value, otherwise get inferred value.
        if (length > index) {
            return this.sizeAccList[index];
        }
        const sizeStep = this.getSizeStep();
        const accSize = this.getAverageSize() * (Math.ceil(index / sizeStep) * sizeStep -
            Math.floor(length / sizeStep) * sizeStep);
        if (length === 0) {
            return accSize;
        }
        return this.sizeAccList[length - 1] + accSize;
    }
    recalculateAccSize() {
        if (this.sizeInvalidated == null) {
            return;
        }
        const startIndex = Math.min(this.sizeInvalidated || 0, this.sizeAccList.length);
        let prev = 0;
        if (startIndex > 0) {
            prev = this.sizeAccList[startIndex - 1];
        }
        const sizeStep = this.getSizeStep();
        for (let i = startIndex; i < this.getSizeLength(); i += 1) {
            let entrySize = this.getSize(i);
            if (entrySize == null) {
                entrySize = i % sizeStep === 0
                    ? this.getAverageSize() * sizeStep
                    : 0;
            }
            const current = prev + entrySize;
            this.sizeAccList[i] = current;
            prev = current;
        }
        // Remaining values can be inferred from
        // sizeAccList[size] + avg * (i - size), therefore it's a waste of
        // computation to pre-compute this values.
        this.sizeInvalidated = null;
    }
    recalculateSizeImpl() {
        if (this.containerNode == null) {
            return;
        }
        // Recalculate all visible nodes for now
        // TODO Calculate new nodes only
        const { count } = this.props;
        const { paddingTop, paddingBottom, startIndex, endIndex } = this.state;
        const maxIndex = Math.min(endIndex, count);
        let shouldAcceptNonLoaded = false;
        // If there's nothing in the size buffer, and there is not a single
        // loaded item, we must use currently loaded items to correctly approximate
        // current position.
        if (this.sizeList.length === 0) {
            let hasLoaded = false;
            for (let i = startIndex; i <= maxIndex; i += 1) {
                if (this.itemNodes[i] != null && this.itemLoadeds[i]) {
                    hasLoaded = true;
                    break;
                }
            }
            shouldAcceptNonLoaded = !hasLoaded;
        }
        // Size is calculated by 'how much it influences the total height' -
        // Therefore in a grid, only the leftmost one receives the height.
        // This is acheived by comparing using the node's top position.
        // +                  - Initial position -> padding top
        // +---+ +---+ +---+  - v 0th, 1st, 2nd
        // |   | |   | |   |  - |
        // +---+ +---+ +---+  - |
        // +---+              - v 3rd
        // |   |              - |
        // +---+              - |
        // +                  - v end
        // However, because it shifts the position (even though 0th influences
        // the height, 3rd gets the value), the position needs to be adjusted
        // as well. This can be acheived by memorizing first non-zero index.
        const containerRect = this.containerNode.getBoundingClientRect();
        let pos = containerRect.top + paddingTop;
        let currentNonZeroIndex = startIndex;
        for (let i = startIndex; i <= maxIndex; i += 1) {
            const node = this.itemNodes[i];
            if (node == null) {
                return;
            }
            const nodePos = node.getBoundingClientRect().top;
            const diff = Math.round(nodePos - pos);
            if (diff !== 0) {
                // Adjust the position if all non-zero indices are loaded.
                let isLoaded = true;
                for (let j = currentNonZeroIndex; j < i; j += 1) {
                    if (!this.itemLoadeds[j]) {
                        isLoaded = false;
                        break;
                    }
                }
                if (isLoaded || shouldAcceptNonLoaded) {
                    this.updateSize(currentNonZeroIndex, diff);
                    for (let j = currentNonZeroIndex + 1; j < i; j += 1) {
                        this.updateSize(j, 0);
                    }
                }
                currentNonZeroIndex = i;
            }
            pos = nodePos;
        }
        // Compare the bottom position of the container, then set the last index.
        const endPos = containerRect.bottom - paddingBottom;
        {
            let isEndLoaded = true;
            for (let j = currentNonZeroIndex; j <= maxIndex; j += 1) {
                if (!this.itemLoadeds[j]) {
                    isEndLoaded = false;
                    break;
                }
            }
            if (isEndLoaded) {
                this.updateSize(currentNonZeroIndex, Math.round(endPos - pos));
                for (let j = currentNonZeroIndex + 1; j <= maxIndex; j += 1) {
                    this.updateSize(j, 0);
                }
            }
        }
    }
    recalculateSize() {
        // Pick the anchor index and memorize its position
        const anchorPos = this.getAccPos(this.anchorIndex - 1);
        // Actually run the size calculation logic
        this.recalculateSizeImpl();
        // Try to locate the anchor node and move to it. This accounts for
        // resizing due to the layout changes - Howevver, we still need to
        // calculate the size of nodes that aren't rendered. To account
        // for this, we compare approximate accumulated sizes and scroll until
        // there.
        this.recalculateAccSize();
        if (anchorPos != null) {
            const nextAnchorPos = this.getAccPos(this.anchorIndex - 1);
            const deltaDiff = anchorPos - nextAnchorPos;
            this.tempDelta += deltaDiff;
        }
    }
    invalidateSize() {
        // Pick the anchor index and memorize its position
        const anchorPos = this.getAccPos(this.anchorIndex - 1);
        // Reset store...
        this.sizeList = [];
        this.sizeCount = 0;
        this.sizeSum = 0;
        this.sizeAccList = [];
        this.sizeInvalidated = null;
        this.sizeStep = null;
        // Actually run the size calculation logic
        this.recalculateSizeImpl();
        // Try to locate the anchor node and move to it. This accounts for
        // resizing due to the layout changes - Howevver, we still need to
        // calculate the size of nodes that aren't rendered. To account
        // for this, we compare approximate accumulated sizes and scroll until
        // there.
        this.recalculateAccSize();
        if (anchorPos != null) {
            const nextAnchorPos = this.getAccPos(this.anchorIndex - 1);
            const deltaDiff = anchorPos - nextAnchorPos;
            this.tempDelta += deltaDiff;
        }
    }
    getViewportIntersection() {
        // Calculate which portion of nodes are visible, and set the padding /
        // visible nodes according to it.
        // Since VirtualizedList lacks declared 'parent' container, the only way to
        // calculate visible offset is to try intersection with all parent nodes...
        if (this.containerNode == null) {
            throw new Error('containerNode is null');
        }
        let currentNode = this.containerNode;
        let currentRect = this.containerNode.getBoundingClientRect();
        while (currentNode != null) {
            const parentNode = currentNode.parentElement;
            if (parentNode === document.body ||
                parentNode === document.documentElement ||
                parentNode == null) {
                break;
            }
            const parentStyle = window.getComputedStyle(parentNode);
            if (parentStyle.overflow === 'auto' || parentStyle.overflow === 'scroll') {
                currentRect = intersectRect(currentRect, parentNode.getBoundingClientRect());
            }
            currentNode = parentNode;
        }
        currentRect = intersectRect(currentRect, getRootRect());
        // currentRect contains viewable area of the node - use this to calculate
        // total visible area of the node.
        return currentRect;
    }
    scrollToAnchor(pos, offset) {
        if (this.containerNode == null)
            return 0;
        const scrollY = window.scrollY || document.documentElement.scrollTop;
        const containerTop = this.containerNode.getBoundingClientRect().top;
        const anchorPos = this.getAccPos(pos - 1);
        const targetY = scrollY + containerTop +
            anchorPos - offset;
        window.scrollTo(0, targetY);
        return targetY;
    }
    recalculateViewport() {
        if (this.containerNode == null)
            return;
        this.recalculateAccSize();
        const containerTop = this.containerNode.getBoundingClientRect().top;
        let currentRect = this.getViewportIntersection();
        let scrollVelocity = 0;
        // If scrollRestore is specified, don't do any viewport bounds check.
        // Instead, render directly to the desired position, then set the scroll
        // position to there once it's rendered. (This shall be handled inside
        // componentDidUpdate, I think?)
        if (this.scrollRestore != null) {
            // We (should) have scroll restoration information in current stage,
            // as it's determined from accumulated size information, which is
            // (hopefully) provided from the saved data, or, augmented from first
            // few nodes. If it's augmented, it's still okay, since scroll correction
            // logic can continously adapt scroll position to the expected position.
            const anchorPos = this.getAccPos(this.scrollRestore.pos);
            const top = anchorPos + containerTop - this.scrollRestore.offset;
            const windowHeight = getWindowHeight();
            currentRect = {
                ...currentRect,
                top,
                bottom: top + windowHeight,
                height: windowHeight,
            };
            this.scrollPending = true;
            this.prevScrollAt = 0;
            // this.scrollToAnchor(this.scrollRestore.pos, this.scrollRestore.offset);
            // this.scrollRestore = null;
            this.scrollRestoreJump = true;
        }
        else {
            // Determine the current scrolling velocity using previous data.
            const scrollDiff = Date.now() - this.prevScrollAt;
            if (scrollDiff < 500) {
                scrollVelocity = this.prevScrollPos - containerTop;
            }
            this.prevScrollPos = containerTop;
            this.prevScrollAt = Date.now();
            // User is scrolling too fast; trigger fast scrolling mode.
            // TODO Unset this once the user slows down
            if (Math.abs(scrollVelocity / (scrollDiff / 1000)) > 4000) {
                const { fastScrolling } = this.state;
                if (!fastScrolling) {
                    this.setState({ fastScrolling: true });
                }
            }
        }
        // Translate viewable rect to scroll position including velocity and
        // overscanning.
        const { count, overscanHeight = 500 } = this.props;
        const maxCount = this.overridenCount != null
            ? Math.max(this.overridenCount, count)
            : count;
        const { tempDelta: committedTempDelta, startIndex: prevStartIndex, endIndex: prevEndIndex, } = this.state;
        const visibleTop = currentRect.top - containerTop - overscanHeight +
            committedTempDelta - this.tempDelta +
            (scrollVelocity < 0
                ? Math.max(-800, scrollVelocity * 1.5)
                : Math.min(800, scrollVelocity * 0.8));
        const visibleBottom = currentRect.bottom - containerTop + overscanHeight +
            committedTempDelta - this.tempDelta +
            (scrollVelocity > 0
                ? Math.min(800, scrollVelocity * 1.5)
                : Math.max(-800, scrollVelocity * 0.8));
        let visibleTopPos = binarySearch(count, (v) => this.getAccPos(v), visibleTop);
        let visibleBottomPos = binarySearch(count, (v) => this.getAccPos(v), visibleBottom);
        const sizeStep = this.getSizeStep();
        // Try to snap the position to cloest non-zero value.
        // This is necessary to prevent non-aligned position access, therefore
        // allowing the node to wrap and breaking the whole layout.
        visibleTopPos -= sizeStep;
        visibleTopPos = Math.floor(visibleTopPos / sizeStep) * sizeStep;
        // Find the next non-zero value for bottom, and navigate to its end...
        visibleBottomPos += sizeStep * 2;
        visibleBottomPos = Math.ceil(visibleBottomPos / sizeStep) * sizeStep - 1;
        visibleTopPos = Math.max(0, visibleTopPos);
        visibleBottomPos = Math.min(count, visibleBottomPos);
        // Calculate anchor index separately...
        const anchorTop = currentRect.top - containerTop +
            committedTempDelta - this.tempDelta;
        this.anchorIndex =
            Math.ceil(binarySearch(count, (v) => this.getAccPos(v), anchorTop) /
                sizeStep) * sizeStep;
        const { onRowsRendered } = this.props;
        const paddingTop = Math.round(this.getAccPos(visibleTopPos - 1));
        const paddingBottom = Math.round(this.getAccPos(maxCount) -
            this.getAccPos(visibleBottomPos));
        if (onRowsRendered != null &&
            !this.resizePending &&
            (prevStartIndex !== visibleTopPos ||
                prevEndIndex !== visibleBottomPos)) {
            onRowsRendered(visibleTopPos, visibleBottomPos);
        }
        let shouldForceRecalculate = false;
        for (let i = visibleTopPos; i < prevStartIndex; i += 1) {
            if (this.getSize(i) == null) {
                shouldForceRecalculate = true;
                break;
            }
        }
        this.setState({
            startIndex: visibleTopPos,
            endIndex: visibleBottomPos,
            paddingTop,
            paddingBottom,
            tempDelta: this.tempDelta,
            forceRecalculate: shouldForceRecalculate,
        });
    }
    commitTempDelta() {
        if (this.tempDelta === 0) {
            return;
        }
        const delta = this.tempDelta;
        const scrollY = window.scrollY || document.documentElement.scrollTop;
        this.tempDelta = 0;
        window.scrollTo(0, scrollY - delta);
    }
    attachListeners() {
        this.prevWindowWidth = document.documentElement.clientWidth;
        if ('scrollRestoration' in history) {
            this.beforeScrollRestoration = history.scrollRestoration;
            history.scrollRestoration = 'manual';
        }
        window.addEventListener('unload', this.handleUnload);
        window.addEventListener('resize', this.handleResize, true);
        document.addEventListener('scroll', this.handleScroll, true);
    }
    detachListeners() {
        if ('scrollRestoration' in history &&
            this.beforeScrollRestoration != null) {
            history.scrollRestoration = this.beforeScrollRestoration;
        }
        window.removeEventListener('unload', this.handleUnload);
        window.removeEventListener('resize', this.handleResize, true);
        document.removeEventListener('scroll', this.handleScroll, true);
    }
    componentDidMount() {
        this.recalculateSize();
        this.recalculateViewport();
        this.attachListeners();
    }
    getSnapshotBeforeUpdate(prevProps) {
        const { tabId } = this.props;
        if (prevProps.tabId !== tabId) {
            this.saveSaveData(prevProps.tabId);
        }
        return null;
    }
    componentDidUpdate(prevProps) {
        const { tabId } = this.props;
        const { forceRecalculate } = this.state;
        if (tabId != null && prevProps.tabId !== tabId) {
            this.invalidateSize();
            this.loadSaveData();
            this.recalculateViewport();
            this.tempDelta = 0;
        }
        else {
            if (this.resizePending) {
                return;
            }
            if (this.scrollRestoreJump && this.scrollRestore != null) {
                this.scrollToAnchor(this.scrollRestore.pos, this.scrollRestore.offset);
                this.scrollRestoreJump = false;
                this.scrollRestore = null;
                this.overridenCount = null;
                return;
            }
            if (forceRecalculate) {
                this.recalculateSize();
                this.recalculateViewport();
            }
            else if (this.stabilizeId == null) {
                this.stabilizeId = requestAnimationFrame(() => {
                    this.stabilizeId = requestAnimationFrame(() => {
                        this.stabilizeId = null;
                        this.recalculateSize();
                        if (!this.scrollPending) {
                            this.recalculateViewport();
                        }
                    });
                });
            }
        }
    }
    componentWillUnmount() {
        const { tabId } = this.props;
        this.saveSaveData(tabId);
        this.detachListeners();
        if (this.resizeId != null) {
            cancelAnimationFrame(this.resizeId);
        }
        if (this.scrollId != null) {
            window.clearTimeout(this.scrollId);
        }
        if (this.scrollEndId != null) {
            window.clearTimeout(this.scrollEndId);
        }
        if (this.stabilizeId != null) {
            cancelAnimationFrame(this.stabilizeId);
        }
        if (this.scrollStabilizeId != null) {
            cancelAnimationFrame(this.scrollStabilizeId);
        }
    }
    handleScroll() {
        if (this.resizePending) {
            return;
        }
        this.scrollPending = true;
        if (this.scrollEndId != null) {
            window.clearTimeout(this.scrollEndId);
            this.scrollEndId = null;
        }
        if (this.scrollId != null) {
            return;
        }
        this.scrollId = window.setTimeout(() => {
            this.scrollId = null;
            if (this.scrollStabilizeId != null) {
                return;
            }
            this.scrollStabilizeId = requestAnimationFrame(() => {
                this.scrollStabilizeId = null;
                if (this.scrollEndId != null) {
                    window.clearTimeout(this.scrollEndId);
                }
                if (this.resizePending) {
                    return;
                }
                this.scrollEndId = window.setTimeout(this.handleScrollEnd, 200);
                this.recalculateViewport();
            });
        }, 50);
    }
    handleScrollEnd() {
        this.scrollEndId = null;
        this.scrollPending = false;
        this.setState({ fastScrolling: false, forceRecalculate: false });
        if (this.resizePending) {
            return;
        }
        this.commitTempDelta();
        this.recalculateViewport();
    }
    handleResize() {
        // We need to invalidate entire size data!
        if (this.resizeId == null) {
            this.resizePending = true;
            this.resizeId = requestAnimationFrame(() => {
                this.resizeId = null;
                const currentWidth = document.documentElement.clientWidth;
                if (currentWidth !== this.prevWindowWidth) {
                    this.invalidateSize();
                }
                this.recalculateViewport();
                this.prevWindowWidth = currentWidth;
                this.resizePending = false;
            });
        }
    }
    handleUnload() {
        const { tabId } = this.props;
        this.saveSaveData(tabId);
    }
    getStyle() {
        const { style } = this.props;
        const { paddingTop, paddingBottom, tempDelta } = this.state;
        return {
            ...style || {},
            paddingTop: `${paddingTop}px`,
            paddingBottom: `${paddingBottom}px`,
            transform: tempDelta != null
                ? `translateY(${tempDelta}px)`
                : undefined,
        };
    }
    renderItems() {
        const { count, innerClassName, innerStyle, renderItem, isLoaded } = this.props;
        const { startIndex, endIndex, fastScrolling } = this.state;
        const maxIndex = Math.min(endIndex, count - 1);
        const output = [];
        for (let i = startIndex; i <= maxIndex; i += 1) {
            // TODO Store ref functions and reuse them for the sake of optimization
            let ref = this.itemRefs[i];
            if (ref == null) {
                ref = this.itemRefs[i] = (node) => {
                    this.itemNodes[i] = node;
                };
            }
            const itemLoaded = isLoaded != null ? isLoaded(i) : true;
            this.itemLoadeds[i] = itemLoaded;
            let style = innerStyle;
            if (!itemLoaded && this.getSizeLength() > i) {
                const sizeStep = this.getSizeStep();
                const inferredHeight = this.getSize(Math.floor(i / sizeStep) * sizeStep);
                style = { ...(innerStyle || {}), height: `${inferredHeight}px` };
            }
            output.push(react.createElement("div", { className: innerClassName, ref: ref, style: style, key: i }, renderItem({ index: i, fastScrolling })));
        }
        return output;
    }
    render() {
        const { className } = this.props;
        return (react.createElement("div", { className: className, style: this.getStyle(), ref: (node) => {
                this.containerNode = node;
            } }, this.renderItems()));
    }
}
VirtualizedList_decorate([
    autobind/* autobind */.N
], VirtualizedList.prototype, "resetVirtualizedList", null);
VirtualizedList_decorate([
    autobind/* autobind */.N
], VirtualizedList.prototype, "handleScroll", null);
VirtualizedList_decorate([
    autobind/* autobind */.N
], VirtualizedList.prototype, "handleScrollEnd", null);
VirtualizedList_decorate([
    autobind/* autobind */.N
], VirtualizedList.prototype, "handleResize", null);
VirtualizedList_decorate([
    autobind/* autobind */.N
], VirtualizedList.prototype, "handleUnload", null);
//# sourceMappingURL=VirtualizedList.js.map
;// CONCATENATED MODULE: ./node_modules/.pnpm/@bucketplace+ui@1.0.9_@emotion+react@11.13.3_@emotion+styled@11.13.0_react-dom@18.3.1_react@18.3.1_scheduler@0.23.2/node_modules/@bucketplace/ui/lib-esm/components/VirtualizedList/index.js

//# sourceMappingURL=index.js.map
// EXTERNAL MODULE: ./node_modules/.pnpm/querystring@0.2.1/node_modules/querystring/index.js
var querystring = __webpack_require__(97150);
;// CONCATENATED MODULE: ./node_modules/.pnpm/@bucketplace+ui@1.0.9_@emotion+react@11.13.3_@emotion+styled@11.13.0_react-dom@18.3.1_react@18.3.1_scheduler@0.23.2/node_modules/@bucketplace/ui/lib-esm/components/ResizeImage/getImageUrl.js

const IMAGE_SIZES = [
    36,
    72,
    144,
    180,
    256,
    360,
    480,
    512,
    640,
    720,
    850,
    960,
    1024,
    1280,
    1360,
    1440,
    1536,
    1700,
    1920,
    2048,
    2560,
];
/**
 * Returns nearest image resize width for the given width.
 * @param {number} width The given width.
 * @return {number} The image width.
 */
function getNearestWidth(width) {
    for (let i = 0; i < IMAGE_SIZES.length; ++i) {
        if (IMAGE_SIZES[i] >= width) {
            return IMAGE_SIZES[i];
        }
    }
    return IMAGE_SIZES[IMAGE_SIZES.length - 1];
}
const IMAGE_OHOUSE_LEGACY_PATTERN = /^https?:\/\/image\.ohou\.se\/image\/(?:central_crop|resize)\/([^/]+)\/([^/]+)\/.+\/.*$/;
const IMAGE_OHOUSE_PATTERN = /^https?:\/\/image\.ohou\.se\/i\/([^/]+)\/([^?]+)(?:\?.*)?$/;
const S3_LOCAL_PATTERN = /^https?:\/\/s3-ap-northeast-1\.amazonaws\.com\/([^/]+)\/([^?]+)(?:\?.*)?$/;
const S3_GLOBAL_PATTERN = /^https?:\/\/([^.]+)\.(?:s3\.amazonaws\.com|cloudfront\.net)\/([^?]+)(?:\?.*)?$/;
const IMAGE_PREFIX = 'https://image.ohou.se';
/**
 * Returns the resized image URL for the given image. It can convert server-
 * converted image URL, or raw S3 image URL.
 * @param {string} src The original image URL.
 * @param {number} width The image width to use.
 * @param {number} aspect The aspect ratio for height - provide null to retain
 *   original width.
 * @param {number} quality The quality of the image.
 * @return {string} The resized image URL.
 */
function getImageUrl_getImageUrl(src, width, height, mode, quality, webp, gif) {
    let path;
    let match;
    const alignWidth = width != null ? getNearestWidth(width) : null;
    const alignHeight = height != null ? getNearestWidth(height) : height;
    if (!src) {
        return undefined;
    }
    if (match = IMAGE_OHOUSE_LEGACY_PATTERN.exec(src), match != null) {
        path = `${match[1]}/${match[2].replace(/-/g, '/')}`;
    }
    else if (match = IMAGE_OHOUSE_PATTERN.exec(src), match != null) {
        path = `${match[1]}/${match[2]}`;
    }
    else if (match = S3_LOCAL_PATTERN.exec(src), match != null) {
        path = `${match[1]}/${match[2]}`;
    }
    else if (match = S3_GLOBAL_PATTERN.exec(src), match != null) {
        // eslint-disable-next-line prefer-destructuring
        let bucketName = match[1];
        // Change old bucket name to new name
        if (bucketName === 'd224jl0o7z9gbn' || bucketName === 'd12gkpu9h0k5iq') {
            bucketName = 'bucketplace-v2-development';
        }
        path = `${bucketName}/${match[2]}`;
    }
    else {
        return src;
    }
    const url = `${IMAGE_PREFIX}/i/${path}?`;
    const query = {};
    if (alignWidth != null)
        query.w = String(alignWidth);
    if (alignHeight != null)
        query.h = String(alignHeight);
    if (mode != null)
        query.c = String(mode);
    if (quality != null)
        query.q = String(quality);
    if (webp)
        query.webp = '1';
    if (gif)
        query.gif = '1';
    return url + querystring.stringify(query);
}
function getImageUrlSingleAxis(src, width, aspect, quality, useHeight, webp, gif) {
    if (aspect != null) {
        if (useHeight) {
            return getImageUrl_getImageUrl(src, width * aspect, width, 'c', quality, webp, gif);
        }
        return getImageUrl_getImageUrl(src, width, width * aspect, 'c', quality, webp, gif);
    }
    if (useHeight) {
        return getImageUrl_getImageUrl(src, undefined, width, undefined, quality, webp, gif);
    }
    return getImageUrl_getImageUrl(src, width, undefined, undefined, quality, webp, gif);
}
//# sourceMappingURL=getImageUrl.js.map
;// CONCATENATED MODULE: ./node_modules/.pnpm/@bucketplace+ui@1.0.9_@emotion+react@11.13.3_@emotion+styled@11.13.0_react-dom@18.3.1_react@18.3.1_scheduler@0.23.2/node_modules/@bucketplace/ui/lib-esm/components/ResizeImage/useNodeSize.js

let disableSSR = false;
function useNodeSize_useNodeSize(ref, defaultSize = [240, 240]) {
    const [size, setSize] = (0,react.useState)(null);
    const handleRecalculate = (0,react.useCallback)(() => {
        const node = ref.current;
        if (node == null)
            return;
        const nodeSize = [node.clientWidth, node.clientHeight];
        setSize((size) => {
            if (size == null || nodeSize[0] > size[0] || nodeSize[1] > size[1]) {
                return [
                    Math.max(nodeSize[0], defaultSize[0]),
                    Math.max(nodeSize[1], defaultSize[1]),
                ];
            }
            return size;
        });
    }, [ref]);
    (0,react.useEffect)(() => {
        let initId = requestAnimationFrame(() => {
            initId = null;
            disableSSR = true;
            handleRecalculate();
        });
        let recalcTimeoutId = null;
        const handleResize = () => {
            if (recalcTimeoutId != null) {
                window.clearTimeout(recalcTimeoutId);
            }
            recalcTimeoutId = window.setTimeout(() => {
                recalcTimeoutId = null;
                handleRecalculate();
            }, 500);
        };
        let resizeObserver = null;
        const targetNode = ref.current;
        if (window.ResizeObserver != null && targetNode != null) {
            resizeObserver = new ResizeObserver(handleResize);
            resizeObserver.observe(targetNode);
        }
        else {
            window.addEventListener('resize', handleResize);
        }
        return () => {
            if (initId != null)
                cancelAnimationFrame(initId);
            if (recalcTimeoutId != null) {
                window.clearTimeout(recalcTimeoutId);
            }
            if (resizeObserver != null) {
                resizeObserver.disconnect();
            }
            else {
                window.removeEventListener('resize', handleResize);
            }
        };
    }, [ref, handleRecalculate]);
    if (!disableSSR && size == null)
        return defaultSize;
    return size;
}
//# sourceMappingURL=useNodeSize.js.map
;// CONCATENATED MODULE: ./node_modules/.pnpm/@bucketplace+ui@1.0.9_@emotion+react@11.13.3_@emotion+styled@11.13.0_react-dom@18.3.1_react@18.3.1_scheduler@0.23.2/node_modules/@bucketplace/ui/lib-esm/components/ResizeImage/ResizeImage.js



function ResizeImageImpl(props) {
    const { src, width, maxWidth, aspect, quality, useHeight, gif = false, ...otherProps } = props;
    const nodeRef = (0,react.useRef)(null);
    const actualSize = useNodeSize_useNodeSize(nodeRef, width != null ? [width, width] : undefined);
    function getUrl(multiplier = 1, useWebp = false) {
        if (actualSize == null)
            return undefined;
        const nextSize = actualSize.map((v) => {
            const value = v * multiplier;
            if (maxWidth != null && maxWidth < value)
                return maxWidth;
            return value;
        });
        if (useHeight) {
            return getImageUrlSingleAxis(src, nextSize[1], aspect, quality, true, useWebp, gif);
        }
        return getImageUrlSingleAxis(src, nextSize[0], aspect, quality, false, useWebp, gif);
    }
    const isGifFile = (0,react.useMemo)(() => (src?.indexOf('.gif') > -1 && gif), [src, gif]);
    const imageUrl = getUrl(1);
    const srcSet = actualSize != null && src != null
        ? [1.5, 2, 3].map((size) => `${getUrl(size)} ${size}x`).join(',')
        : undefined;
    const webpImageUrl = getUrl(1, true);
    const webpSrcSet = actualSize != null && src != null
        ? [1.5, 2, 3].map((size) => `${getUrl(size, true)} ${size}x`).join(',')
        : undefined;
    return (react.createElement("picture", null,
        !isGifFile && (react.createElement("source", { src: webpImageUrl, srcSet: webpSrcSet, type: 'image/webp' })),
        react.createElement("img", Object.assign({}, otherProps, { src: imageUrl, srcSet: srcSet, ref: nodeRef }))));
}
const ResizeImage = react.memo(ResizeImageImpl);
//# sourceMappingURL=ResizeImage.js.map
;// CONCATENATED MODULE: ./node_modules/.pnpm/@bucketplace+ui@1.0.9_@emotion+react@11.13.3_@emotion+styled@11.13.0_react-dom@18.3.1_react@18.3.1_scheduler@0.23.2/node_modules/@bucketplace/ui/lib-esm/components/ResizeImage/usePixelRatio.js

function usePixelRatio_usePixelRatio() {
    const [pixelRatio, setPixelRatio] = (0,react.useState)(1);
    (0,react.useEffect)(() => {
        let mediaQuery = null;
        const handleUpdate = () => {
            setPixelRatio(window.devicePixelRatio);
            if (mediaQuery != null) {
                mediaQuery.removeListener(handleUpdate);
            }
            mediaQuery =
                window.matchMedia(`(resolution: ${window.devicePixelRatio}dppx)`);
            mediaQuery.addListener(handleUpdate);
        };
        handleUpdate();
        return () => {
            if (mediaQuery != null) {
                mediaQuery.removeListener(handleUpdate);
            }
        };
    }, []);
    return pixelRatio;
}
//# sourceMappingURL=usePixelRatio.js.map
;// CONCATENATED MODULE: ./node_modules/.pnpm/@bucketplace+ui@1.0.9_@emotion+react@11.13.3_@emotion+styled@11.13.0_react-dom@18.3.1_react@18.3.1_scheduler@0.23.2/node_modules/@bucketplace/ui/lib-esm/components/ResizeImage/ResizeImageDiv.js




function ResizeImageDivImpl(props) {
    const { src, width, maxWidth, aspect, quality, useHeight, style, ...otherProps } = props;
    const nodeRef = (0,react.useRef)(null);
    const pixelRatio = usePixelRatio_usePixelRatio();
    const actualSize = useNodeSize_useNodeSize(nodeRef, width != null ? [width, width] : undefined);
    function getUrl(multiplier = 1) {
        if (actualSize == null)
            return undefined;
        const nextSize = actualSize.map((v) => {
            const value = v * multiplier;
            if (maxWidth != null && maxWidth < value)
                return maxWidth;
            return value;
        });
        if (useHeight) {
            return getImageUrlSingleAxis(src, nextSize[1], aspect, quality, true);
        }
        return getImageUrlSingleAxis(src, nextSize[0], aspect, quality, false);
    }
    const imageUrl = getUrl(pixelRatio);
    return (react.createElement("div", Object.assign({}, otherProps, { ref: nodeRef, style: imageUrl != null
            ? {
                ...style,
                backgroundImage: `url(${imageUrl})`,
                backgroundSize: 'cover',
                backgroundRepeat: 'no-repeat',
            }
            : style })));
}
const ResizeImageDiv = react.memo(ResizeImageDivImpl);
//# sourceMappingURL=ResizeImageDiv.js.map
;// CONCATENATED MODULE: ./node_modules/.pnpm/@bucketplace+ui@1.0.9_@emotion+react@11.13.3_@emotion+styled@11.13.0_react-dom@18.3.1_react@18.3.1_scheduler@0.23.2/node_modules/@bucketplace/ui/lib-esm/components/ResizeImage/useHasObjectFit.js

let isChecked = false;
let isSupported = true;
function useHasObjectFit_useHasObjectFit() {
    const [isEnabled, setEnabled] = useState(isSupported);
    useEffect(() => {
        if (!isChecked) {
            const image = new Image();
            isChecked = true;
            isSupported = 'object-position' in image.style;
        }
        setEnabled(isSupported);
    }, []);
    return isEnabled;
}
//# sourceMappingURL=useHasObjectFit.js.map
;// CONCATENATED MODULE: ./node_modules/.pnpm/@bucketplace+ui@1.0.9_@emotion+react@11.13.3_@emotion+styled@11.13.0_react-dom@18.3.1_react@18.3.1_scheduler@0.23.2/node_modules/@bucketplace/ui/lib-esm/components/ResizeImage/CoverResizeImage.js





function calculateBounds(width, height, containerWidth, containerHeight) {
    const imageRatio = width / height;
    const containerRatio = containerWidth / containerHeight;
    if (imageRatio > containerRatio) {
        const heightPercent = containerRatio / imageRatio;
        return [0, (1 - heightPercent) / 2, 1, heightPercent];
    }
    const widthPercent = imageRatio / containerRatio;
    return [(1 - widthPercent) / 2, 0, widthPercent, 1];
}
function CoverResizeImage(props) {
    const { src, size, maxSize, quality, focus, fit = 'cover', className, style, innerClassName, innerStyle, children, } = props;
    const nodeRef = useRef(null);
    const imageRef = useRef(null);
    const pixelRatio = usePixelRatio();
    const hasObjectFit = useHasObjectFit();
    const actualSize = useNodeSize(nodeRef, size);
    const [imageSize, setImageSize] = useState([1, 1]);
    function getUrl(multiplier = 1) {
        if (actualSize == null)
            return undefined;
        const nextSize = actualSize.map((v, i) => {
            const value = v * multiplier;
            if (maxSize != null && maxSize[i] < value)
                return maxSize[i];
            return value;
        });
        return getImageUrl(src, nextSize[0], nextSize[1], 'o', quality);
    }
    const imageUrl = getUrl(1);
    const srcSet = actualSize != null && src != null
        ? [1.5, 2, 3].map((size) => `${getUrl(size)} ${size}x`).join(',')
        : undefined;
    const handleImageLoad = useCallback(() => {
        const image = imageRef.current;
        if (image == null)
            return;
        setImageSize([image.naturalWidth, image.naturalHeight]);
    }, []);
    useEffect(() => {
        if (hasObjectFit)
            return;
        const url = getUrl(pixelRatio);
        if (url == null)
            return;
        const image = new Image();
        image.onloadedmetadata = () => {
            setImageSize([image.naturalWidth, image.naturalHeight]);
        };
        image.onload = () => {
            setImageSize([image.naturalWidth, image.naturalHeight]);
        };
        image.src = url;
        return () => {
            image.src = '';
        };
    }, [imageUrl, hasObjectFit, pixelRatio]);
    return (React.createElement("div", { ref: nodeRef, className: className, style: {
            position: 'relative',
            ...(style ?? {}),
        } },
        hasObjectFit ? (React.createElement("img", { className: innerClassName, src: imageUrl, srcSet: srcSet, onLoadedMetadata: handleImageLoad, onLoad: handleImageLoad, ref: imageRef, style: {
                position: 'absolute',
                top: '0',
                left: '0',
                width: '100%',
                height: '100%',
                objectFit: fit,
                objectPosition: focus != null
                    ? `${focus[0] * 100}% ${focus[1] * 100}%`
                    : 'center center',
                ...(innerStyle ?? {}),
            } })) : (React.createElement("div", { className: innerClassName, style: {
                position: 'absolute',
                top: '0',
                left: '0',
                width: '100%',
                height: '100%',
                backgroundImage: `url(${getUrl(pixelRatio)})`,
                backgroundSize: fit,
                backgroundRepeat: 'no-repeat',
                backgroundPosition: focus != null
                    ? `${focus[0] * 100}% ${focus[1] * 100}%`
                    : 'center center',
                ...(innerStyle ?? {}),
            } })),
        typeof children === 'function'
            ? children({
                width: imageSize[0],
                height: imageSize[1],
                containerWidth: actualSize != null ? actualSize[0] : 0,
                containerHeight: actualSize != null ? actualSize[1] : 0,
                bounds: calculateBounds(imageSize[0], imageSize[1], actualSize != null ? actualSize[0] : 0, actualSize != null ? actualSize[1] : 0),
            })
            : children));
}
//# sourceMappingURL=CoverResizeImage.js.map
;// CONCATENATED MODULE: ./node_modules/.pnpm/@bucketplace+ui@1.0.9_@emotion+react@11.13.3_@emotion+styled@11.13.0_react-dom@18.3.1_react@18.3.1_scheduler@0.23.2/node_modules/@bucketplace/ui/lib-esm/components/ResizeImage/index.js







//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ./node_modules/.pnpm/@bucketplace+ui@1.0.9_@emotion+react@11.13.3_@emotion+styled@11.13.0_react-dom@18.3.1_react@18.3.1_scheduler@0.23.2/node_modules/@bucketplace/ui/lib-esm/components/ScrollLock/ScrollLock.js

let refCount = 0;
let refTopOffset = 0;
class ScrollLock extends react.PureComponent {
    constructor() {
        super(...arguments);
        this.isIos = false;
        this.currentRef = null;
    }
    enable() {
        refCount += 1;
        this.currentRef = {
            getElement: () => (this.props?.getElement != null
                ? this.props?.getElement()
                : null),
        };
        if (refCount === 1) {
            const documentWidth = document.documentElement.clientWidth;
            const windowWidth = window.innerWidth;
            const scrollBarWidth = windowWidth - documentWidth;
            document.body.style.paddingRight = `${scrollBarWidth}px`;
            document.body.style.overflow = 'hidden';
            // Implement scroll prevention specially for iOS devices
            if (this.isIos) {
                refTopOffset = window.scrollY;
                const html = document.querySelector('html');
                if (html) {
                    html.style.height = `${window.innerHeight - 1}px`;
                }
                document.body.style.position = 'fixed';
                document.body.style.top = `-${refTopOffset}px`;
                document.body.style.left = '0';
                document.body.style.right = '0';
            }
        }
    }
    disable() {
        refCount -= 1;
        if (refCount === 0) {
            document.body.style.overflow = '';
            document.body.style.paddingRight = '';
            if (this.isIos) {
                document.body.style.position = 'static';
                window.scrollTo(0, refTopOffset);
            }
        }
    }
    componentDidMount() {
        const { enabled } = this.props;
        this.isIos = !!navigator.userAgent.match(/iPad|iPhone|iPod/gi);
        if (enabled) {
            this.enable();
        }
    }
    componentDidUpdate(prevProps) {
        const { enabled } = this.props;
        if (enabled !== prevProps.enabled) {
            if (enabled) {
                this.enable();
            }
            else {
                this.disable();
            }
        }
    }
    componentWillUnmount() {
        const { enabled } = this.props;
        if (enabled) {
            this.disable();
        }
    }
    render() {
        return null;
    }
}
//# sourceMappingURL=ScrollLock.js.map
;// CONCATENATED MODULE: ./node_modules/.pnpm/@bucketplace+ui@1.0.9_@emotion+react@11.13.3_@emotion+styled@11.13.0_react-dom@18.3.1_react@18.3.1_scheduler@0.23.2/node_modules/@bucketplace/ui/lib-esm/components/ScrollLock/index.js

//# sourceMappingURL=index.js.map
// EXTERNAL MODULE: ./node_modules/.pnpm/react-dom@18.3.1_react@18.3.1/node_modules/react-dom/index.js
var react_dom = __webpack_require__(30967);
;// CONCATENATED MODULE: ./node_modules/.pnpm/@bucketplace+ui@1.0.9_@emotion+react@11.13.3_@emotion+styled@11.13.0_react-dom@18.3.1_react@18.3.1_scheduler@0.23.2/node_modules/@bucketplace/ui/lib-esm/components/FocusTrap/FocusTrapContext.js

const FocusTrapContext_FocusTrapContext = react.createContext({
    register: () => { },
    unregister: () => { },
});
//# sourceMappingURL=FocusTrapContext.js.map
;// CONCATENATED MODULE: ./node_modules/.pnpm/@bucketplace+ui@1.0.9_@emotion+react@11.13.3_@emotion+styled@11.13.0_react-dom@18.3.1_react@18.3.1_scheduler@0.23.2/node_modules/@bucketplace/ui/lib-esm/components/FocusTrap/FocusTrapChild.js
/* eslint-disable react/no-find-dom-node */



// This needs to use findDOMNode() to emulate FocusTrap's behavior, and
// findDOMNode() requires React.Component.
class FocusTrapChildImpl extends react.PureComponent {
    constructor(props) {
        super(props);
        this.prevElem = null;
    }
    componentDidMount() {
        const { register } = this.props;
        const elem = (0,react_dom.findDOMNode)(this);
        if (elem instanceof HTMLElement) {
            this.prevElem = elem;
            register(elem);
        }
    }
    componentDidUpdate() {
        const { register, unregister } = this.props;
        const elem = (0,react_dom.findDOMNode)(this);
        if (elem instanceof HTMLElement && elem !== this.prevElem) {
            if (this.prevElem != null) {
                unregister(this.prevElem);
            }
            this.prevElem = elem;
            register(elem);
        }
    }
    componentWillUnmount() {
        const { unregister } = this.props;
        if (this.prevElem != null) {
            unregister(this.prevElem);
            this.prevElem = null;
        }
    }
    render() {
        const { children } = this.props;
        return (
        // eslint-disable-next-line react/jsx-no-useless-fragment
        react.createElement(react.Fragment, null, children));
    }
}
function FocusTrapChild(props) {
    const context = (0,react.useContext)(FocusTrapContext_FocusTrapContext);
    return (react.createElement(FocusTrapChildImpl, Object.assign({}, props, context)));
}
//# sourceMappingURL=FocusTrapChild.js.map
// EXTERNAL MODULE: ./node_modules/.pnpm/focus-trap-react@8.11.3_prop-types@15.8.1_react-dom@18.3.1_react@18.3.1/node_modules/focus-trap-react/dist/focus-trap-react.js
var focus_trap_react = __webpack_require__(51749);
var focus_trap_react_default = /*#__PURE__*/__webpack_require__.n(focus_trap_react);
;// CONCATENATED MODULE: ./node_modules/.pnpm/@bucketplace+ui@1.0.9_@emotion+react@11.13.3_@emotion+styled@11.13.0_react-dom@18.3.1_react@18.3.1_scheduler@0.23.2/node_modules/@bucketplace/ui/lib-esm/components/FocusTrap/FocusTrapContainer.js



function FocusTrapContainer(props) {
    const [containerElements, setElements] = (0,react.useState)([]);
    const register = (0,react.useCallback)((elem) => {
        setElements((prev) => {
            if (prev.includes(elem))
                return prev;
            return [...prev, elem];
        });
    }, []);
    const unregister = (0,react.useCallback)((elem) => {
        setElements((prev) => prev.filter((v) => v !== elem));
    }, []);
    const contextValue = (0,react.useMemo)(() => ({
        register,
        unregister,
    }), [register, unregister]);
    return (react.createElement(FocusTrapContext_FocusTrapContext.Provider, { value: contextValue },
        react.createElement((focus_trap_react_default()), Object.assign({}, props, { containerElements: [
                // eslint-disable-next-line react/destructuring-assignment
                ...(props.containerElements ?? []),
                ...containerElements,
            ] }))));
}
//# sourceMappingURL=FocusTrapContainer.js.map
;// CONCATENATED MODULE: ./node_modules/.pnpm/@bucketplace+ui@1.0.9_@emotion+react@11.13.3_@emotion+styled@11.13.0_react-dom@18.3.1_react@18.3.1_scheduler@0.23.2/node_modules/@bucketplace/ui/lib-esm/components/FocusTrap/useFocusTrapChild.js


function useFocusTrapChild(ref) {
    const context = useContext(FocusTrapContext);
    const prevRef = useRef(null);
    useEffect(() => {
        if (ref.current !== prevRef.current) {
            if (prevRef.current != null) {
                context.unregister(prevRef.current);
            }
            if (ref.current != null) {
                context.register(ref.current);
            }
            prevRef.current = ref.current;
        }
    });
    useEffect(() => {
        return () => {
            if (prevRef.current != null) {
                context.unregister(prevRef.current);
            }
        };
    }, []);
}
//# sourceMappingURL=useFocusTrapChild.js.map
;// CONCATENATED MODULE: ./node_modules/.pnpm/@bucketplace+ui@1.0.9_@emotion+react@11.13.3_@emotion+styled@11.13.0_react-dom@18.3.1_react@18.3.1_scheduler@0.23.2/node_modules/@bucketplace/ui/lib-esm/components/FocusTrap/index.js




//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ./node_modules/.pnpm/@bucketplace+ui@1.0.9_@emotion+react@11.13.3_@emotion+styled@11.13.0_react-dom@18.3.1_react@18.3.1_scheduler@0.23.2/node_modules/@bucketplace/ui/lib-esm/hooks/useForkRef.js

function useForkRef_useForkRef(...refs) {
    return (0,react.useCallback)((v) => refs.forEach((ref) => {
        if (typeof ref === 'function') {
            ref(v);
        }
        else if (ref != null) {
            ref.current = v;
        }
    }), refs);
}
//# sourceMappingURL=useForkRef.js.map
;// CONCATENATED MODULE: ./node_modules/.pnpm/@bucketplace+ui@1.0.9_@emotion+react@11.13.3_@emotion+styled@11.13.0_react-dom@18.3.1_react@18.3.1_scheduler@0.23.2/node_modules/@bucketplace/ui/lib-esm/components/Sticky/utils.js
/**
 * IE11 tends to calculate numbers with very bad precision.
 * (For example, 1 + 2 becomes 2.99999999475, etc)
 * We try to fix this problem using Math.round, but it allows 0.25 precision.
 */
function quantizeSize(size) {
    return Math.round(size * 4) / 4;
}
//# sourceMappingURL=utils.js.map
;// CONCATENATED MODULE: ./node_modules/.pnpm/@bucketplace+ui@1.0.9_@emotion+react@11.13.3_@emotion+styled@11.13.0_react-dom@18.3.1_react@18.3.1_scheduler@0.23.2/node_modules/@bucketplace/ui/lib-esm/components/Sticky/stickyEmulation.js

const NATIVE_STICKY_NAME = (() => {
    if (typeof window === 'undefined') {
        return false;
    }
    const node = document.createElement('div');
    const result = ['', '-webkit-', '-moz-', '-ms-'].find((prefix) => {
        try {
            node.style.position = `${prefix}sticky`;
        }
        catch (e) {
            // Do nothing
        }
        return node.style.position !== '';
    });
    if (result == null)
        return false;
    return `${result}sticky`;
})();
const IS_IOS = (() => {
    if (typeof window === 'undefined') {
        return false;
    }
    return /ios|iphone|ipad/i.test(navigator.userAgent);
})();
const stickyEmulation_DEFAULT_STICKY_STATE = {
    disabled: true,
    emulatedDisabled: true,
    bottom: false,
    isAbsolute: false,
    isNativeSticky: false,
    offset: 0,
    emulatedOffset: 0,
    height: null,
    width: null,
    beginY: 0,
};
const stickyEmulation_STICKY_OPTIONS_KEYS = [
    'type',
    'shouldInfluenceScroll',
    'direction',
    'offset',
    'offsetRange',
    'disableNativeSticky',
    'disableBottom',
    'disableHeight',
    'disabled',
    'iosWorkaround',
    'alwaysStick',
    'fit',
    'fitHeight',
    'transition',
    'zIndex',
];
function stickyEmulation_getStickyContainerStyle(state, options) {
    if (state.disabled) {
        return {};
    }
    if (state.isNativeSticky) {
        return {
            position: NATIVE_STICKY_NAME,
            [options.direction]: `${state.offset}px`,
            transform: 'scaleZ(0px)',
            transition: `${options.transition || 0.1}s ${options.direction}`,
            zIndex: options.zIndex,
        };
    }
    if (state.emulatedDisabled || options.disableHeight) {
        return {};
    }
    return {
        height: `${state.height}px`,
    };
}
function stickyEmulation_getStickyChildStyle(state, options) {
    if (state.disabled) {
        return {};
    }
    if (state.isNativeSticky) {
        return {
            position: 'relative',
            height: options.fitHeight ? `${state.height}px` : undefined,
            boxSizing: options.fitHeight ? 'border-box' : undefined,
        };
    }
    if (state.emulatedDisabled) {
        const style = {
            position: 'relative',
            zIndex: options.zIndex,
            height: options.fitHeight ? `${state.height}px` : undefined,
            boxSizing: options.fitHeight ? 'border-box' : undefined,
        };
        return style;
    }
    const style = {
        position: state.isAbsolute || state.bottom ? 'absolute' : 'fixed',
        transform: 'scaleZ(0px)',
        height: options.fitHeight ? `${state.height}px` : undefined,
        boxSizing: options.fitHeight ? 'border-box' : undefined,
        transition: `${options.transition || 0.1}s ${options.direction}`,
        zIndex: options.zIndex,
    };
    if (state.bottom) {
        style[options.direction === 'top' ? 'bottom' : 'top'] = '0px';
    }
    else {
        style[options.direction] = `${state.emulatedOffset}px`;
    }
    if (options.fit) {
        style.left = '0px';
        style.right = '0px';
    }
    else {
        style.width = `${state.width}px`;
    }
    return style;
}
function getUpdatedStickyState(options, containerElem, childElem) {
    // Check if both elements are available
    if (containerElem == null || childElem == null) {
        return stickyEmulation_DEFAULT_STICKY_STATE;
    }
    // Check if the container is visible. If it's not shown, there's no need to
    // calculate floating state.
    const containerElemParent = containerElem.parentElement;
    if (containerElem.offsetParent == null || containerElemParent == null) {
        return stickyEmulation_DEFAULT_STICKY_STATE;
    }
    // If disabled, don't do anything.
    if (options.disabled) {
        return stickyEmulation_DEFAULT_STICKY_STATE;
    }
    const windowHeight = window.innerHeight;
    let emulatedDisabled;
    let bottom;
    let height = null;
    const childRect = childElem.getBoundingClientRect();
    const containerRect = containerElem.getBoundingClientRect();
    const { top: containerTop, bottom: containerBottom, } = containerRect;
    // Math.round is for avoiding precision issues
    // (we don't need subpixel accuracy)
    const beginY = Math.round(containerTop +
        (window.scrollY || document.documentElement.scrollTop));
    const containerWidth = containerRect.right - containerRect.left;
    if (options.direction === 'bottom') {
        emulatedDisabled = !options.alwaysStick &&
            containerBottom - options.offset < windowHeight;
        bottom = false;
    }
    else {
        // Defaults to top
        const { bottom: parentBottom, } = containerElemParent.getBoundingClientRect();
        emulatedDisabled = !options.alwaysStick &&
            containerTop - options.offset > 0;
        if (options.fitHeight) {
            const bottomDiff = Math.max(0, windowHeight - parentBottom);
            height = quantizeSize(Math.min(parentBottom - containerTop, windowHeight - options.offset - bottomDiff));
            const style = window.getComputedStyle(childElem);
            const minHeight = parseInt(style.minHeight, 10);
            bottom =
                !options.disableBottom &&
                    Math.max(height, minHeight) + options.offset > parentBottom;
        }
        else {
            const childHeight = childRect.bottom - childRect.top;
            bottom =
                !options.disableBottom &&
                    childHeight + options.offset > parentBottom;
        }
    }
    const isIosWorkaround = options.iosWorkaround && IS_IOS;
    const isNative = !isIosWorkaround &&
        !options.disableNativeSticky && NATIVE_STICKY_NAME;
    if (!options.fitHeight) {
        // eslint-disable-next-line prefer-destructuring
        height = quantizeSize(childRect.height);
    }
    if (isNative) {
        return {
            disabled: false,
            bottom,
            emulatedDisabled,
            offset: options.offset,
            emulatedOffset: quantizeSize(options.offset),
            height,
            width: null,
            isAbsolute: false,
            isNativeSticky: true,
            beginY,
        };
    }
    const containerStyle = getComputedStyle(containerElem);
    const width = quantizeSize(containerWidth -
        parseFloat(containerStyle.paddingLeft) -
        parseFloat(containerStyle.paddingRight));
    if (isIosWorkaround) {
        // Run iOS workaround routine. ...
        const offsetDiff = containerElemParent.getBoundingClientRect().top -
            document.body.getBoundingClientRect().top;
        return {
            disabled: false,
            bottom,
            emulatedDisabled,
            offset: options.offset,
            emulatedOffset: quantizeSize(options.offset + window.scrollY - offsetDiff),
            height,
            width,
            isAbsolute: true,
            isNativeSticky: false,
            beginY,
        };
    }
    return {
        disabled: false,
        bottom,
        emulatedDisabled,
        offset: options.offset,
        emulatedOffset: quantizeSize(options.offset),
        height,
        width,
        isAbsolute: false,
        isNativeSticky: false,
        beginY,
    };
}
function hasStickyStateChanged(prevState, nextState) {
    let key;
    for (key in nextState) {
        if (nextState[key] !== prevState[key]) {
            return true;
        }
    }
    return false;
}
function assertStickyParentPosition(options, containerElem) {
    // Do nothing in production mode
    if (true) {
        return;
    }
    if (options.disableNativeSticky && options.disableBottom) {
        return;
    }
    if (containerElem == null) {
        return;
    }
    // Check if the container is visible. If it's not shown, do nothing.
    const containerElemParent = containerElem.parentElement;
    if (containerElem.offsetParent == null || containerElemParent == null) {
        return;
    }
    // Retrieve style info...
    const styleInfo = window.getComputedStyle(containerElemParent);
    if (!['relative', 'absolute'].includes(styleInfo.position)) {
        throw new Error('Container node\'s parent must be set to ' +
            'position: relative or absolute to ' +
            'emulate native sticky\'s behavior. ' +
            'set disableNativeSticky and disableBottom if you want to avoid ' +
            'native sticky behavior (sticking at the bottom of parent node)');
    }
}
//# sourceMappingURL=stickyEmulation.js.map
;// CONCATENATED MODULE: ./node_modules/.pnpm/@bucketplace+ui@1.0.9_@emotion+react@11.13.3_@emotion+styled@11.13.0_react-dom@18.3.1_react@18.3.1_scheduler@0.23.2/node_modules/@bucketplace/ui/lib-esm/components/Sticky/useBaseSticky.js


function useBaseSticky_useBaseSticky(state, onChange, options, containerRef, childRef) {
    const stateRef = (0,react.useRef)(state);
    stateRef.current = state;
    const optionsRef = (0,react.useRef)(options);
    optionsRef.current = options;
    (0,react.useEffect)(() => {
        assertStickyParentPosition(options, containerRef.current);
    }, []);
    (0,react.useEffect)(() => {
        let timerId = null;
        const update = () => {
            timerId = null;
            const nextState = getUpdatedStickyState(optionsRef.current, containerRef.current, childRef.current);
            if (hasStickyStateChanged(stateRef.current, nextState)) {
                onChange(nextState);
            }
        };
        const scheduleUpdate = () => {
            if (timerId != null) {
                cancelAnimationFrame(timerId);
            }
            timerId = requestAnimationFrame(update);
        };
        window.addEventListener('scroll', scheduleUpdate);
        window.addEventListener('resize', scheduleUpdate);
        return () => {
            if (timerId != null) {
                cancelAnimationFrame(timerId);
            }
            window.removeEventListener('scroll', scheduleUpdate);
            window.removeEventListener('resize', scheduleUpdate);
        };
    }, [onChange]);
    (0,react.useEffect)(() => {
        const nextState = getUpdatedStickyState(optionsRef.current, containerRef.current, childRef.current);
        if (hasStickyStateChanged(stateRef.current, nextState)) {
            onChange(nextState);
        }
    }, [options, onChange]);
}
//# sourceMappingURL=useBaseSticky.js.map
;// CONCATENATED MODULE: ./node_modules/.pnpm/@bucketplace+ui@1.0.9_@emotion+react@11.13.3_@emotion+styled@11.13.0_react-dom@18.3.1_react@18.3.1_scheduler@0.23.2/node_modules/@bucketplace/ui/lib-esm/components/Sticky/BaseSticky.js





function BaseSticky(props) {
    const { containerClassName, containerStyle, containerRef, forwardRef, style, ...restProps } = omitKeys(props, STICKY_OPTIONS_KEYS);
    const containerStickyRef = useRef(null);
    const containerForkRef = useForkRef(containerRef, containerStickyRef);
    const childStickyRef = useRef(null);
    const childForkRef = useForkRef(forwardRef, childStickyRef);
    const [stickyState, setStickyState] = useState(DEFAULT_STICKY_STATE);
    useBaseSticky(stickyState, setStickyState, props, containerStickyRef, childStickyRef);
    return (React.createElement("div", { className: containerClassName, style: {
            ...getStickyContainerStyle(stickyState, props),
            ...containerStyle || {},
        }, ref: containerForkRef },
        React.createElement("div", Object.assign({}, restProps, { style: {
                ...getStickyChildStyle(stickyState, props),
                ...style || {},
            }, ref: childForkRef }))));
}
//# sourceMappingURL=BaseSticky.js.map
;// CONCATENATED MODULE: ./node_modules/.pnpm/@bucketplace+ui@1.0.9_@emotion+react@11.13.3_@emotion+styled@11.13.0_react-dom@18.3.1_react@18.3.1_scheduler@0.23.2/node_modules/@bucketplace/ui/lib-esm/utils/object.js
function mapArrayToObject(input, getKey = (_, index) => index, ignoreUndefinedOrNull = false) {
    return input.reduce((res, elem, index) => {
        const key = getKey(elem, index);
        if (ignoreUndefinedOrNull && key == null) {
            return res;
        }
        res[key] = elem;
        return res;
    }, {});
}
function groupBy(input, getKey = (_, index) => index) {
    return input.reduce((res, elem, index) => {
        const key = getKey(elem, index);
        res[key] = [...(res[key] ?? []), elem];
        return res;
    }, {});
}
function mapValues(input, mapper, target = {}) {
    return Object.entries(input)
        .reduce((target, [key, value]) => {
        const [newKey, newValue] = mapper(key, value, input);
        target[newKey] = newValue;
        return target;
    }, target);
}
function filterKeys(input, filter, target = {}) {
    return Object.entries(input)
        .reduce((res, [key, value]) => {
        const flag = filter(key, value, input);
        if (flag) {
            res[key] = value;
        }
        return res;
    }, target);
}
function object_omitKeys(object, keys) {
    return Object.keys(object)
        .filter((key) => !keys.includes(key))
        .reduce((merge, key) => {
        const rKey = key;
        merge[rKey] = object[rKey];
        return merge;
    }, {});
}
function shallowEqual(a, b) {
    if (a == null || b == null) {
        return a === b;
    }
    if (Array.isArray(a) && Array.isArray(b)) {
        if (a.length !== b.length) {
            return false;
        }
        return a.every((e, i) => e === b[i]);
    }
    if (typeof a === 'object' && typeof b === 'object') {
        const keysA = Object.keys(a);
        const keysB = Object.keys(b);
        if (keysA.length !== keysB.length) {
            return false;
        }
        // @ts-ignore
        return keysA.every((keyA, i) => keysB[i] === keyA && a[keyA] === b[keyA]);
    }
    return a === b;
}
function map(input, map) {
    const output = {};
    for (const key in input) {
        if (Object.prototype.hasOwnProperty.call(input, key)) {
            output[key] = map(input[key], key);
        }
    }
    return output;
}
//# sourceMappingURL=object.js.map
// EXTERNAL MODULE: ./node_modules/.pnpm/use-context-selector@1.4.4_react-dom@18.3.1_react@18.3.1_scheduler@0.23.2/node_modules/use-context-selector/dist/index.modern.mjs
var index_modern = __webpack_require__(64356);
;// CONCATENATED MODULE: ./node_modules/.pnpm/@bucketplace+ui@1.0.9_@emotion+react@11.13.3_@emotion+styled@11.13.0_react-dom@18.3.1_react@18.3.1_scheduler@0.23.2/node_modules/@bucketplace/ui/lib-esm/components/Sticky/StickyContext.js

const StickyValueContext = (0,index_modern/* createContext */.kr)(null);
const StickyControlContext = (0,index_modern/* createContext */.kr)(null);
//# sourceMappingURL=StickyContext.js.map
;// CONCATENATED MODULE: ./node_modules/.pnpm/@bucketplace+ui@1.0.9_@emotion+react@11.13.3_@emotion+styled@11.13.0_react-dom@18.3.1_react@18.3.1_scheduler@0.23.2/node_modules/@bucketplace/ui/lib-esm/components/Sticky/useSticky.js

// eslint-disable-next-line @typescript-eslint/camelcase






function useSticky_useSticky(options, containerRef, childRef, initialState = stickyEmulation_DEFAULT_STICKY_STATE) {
    const stickyControlContext = (0,index_modern/* useContext */.qp)(StickyControlContext);
    if (stickyControlContext == null) {
        throw new Error('StickyContext is not provided');
    }
    const stickyIdRef = (0,react.useRef)(null);
    const stickyId = stickyIdRef.current || stickyControlContext.register();
    stickyIdRef.current = stickyId;
    const [state, setState] = (0,react.useState)(initialState);
    const itemState = (0,index_modern/* useContextSelector */.Sz)(StickyValueContext, (context) => {
        if (context == null) {
            return null;
        }
        return context.entries[stickyId];
    });
    const handleUpdate = (0,react.useCallback)((state) => {
        (0,react_dom.unstable_batchedUpdates)(() => {
            stickyControlContext.update(stickyId, containerRef, options, state);
            setState(state);
        });
    }, [
        stickyControlContext.update,
        stickyId,
        containerRef,
        options,
        setState,
    ]);
    const augmentedOptions = (0,react.useMemo)(() => ({
        ...options,
        offset: quantizeSize(((itemState && itemState.accumulatedOffset) || 0) + options.offset),
    }), [options, itemState && itemState.accumulatedOffset]);
    useBaseSticky_useBaseSticky(state, handleUpdate, augmentedOptions, containerRef, childRef);
    (0,react.useEffect)(() => {
        // Unregister on unmount
        return () => {
            stickyControlContext.unregister(stickyId);
        };
    }, [stickyId]);
    return state;
}
//# sourceMappingURL=useSticky.js.map
;// CONCATENATED MODULE: ./node_modules/.pnpm/@bucketplace+ui@1.0.9_@emotion+react@11.13.3_@emotion+styled@11.13.0_react-dom@18.3.1_react@18.3.1_scheduler@0.23.2/node_modules/@bucketplace/ui/lib-esm/components/Sticky/Sticky.js






function Sticky_Sticky(props) {
    const { containerClassName, containerStyle, containerRef, forwardRef, style, initialState, ...restProps } = object_omitKeys(props, stickyEmulation_STICKY_OPTIONS_KEYS);
    const containerStickyRef = (0,react.useRef)(null);
    const containerForkRef = useForkRef_useForkRef(containerRef, containerStickyRef);
    const childStickyRef = (0,react.useRef)(null);
    const childForkRef = useForkRef_useForkRef(forwardRef, childStickyRef);
    const stickyState = useSticky_useSticky(props, containerStickyRef, childStickyRef, initialState);
    return (react.createElement("div", { className: classnames_default()('sticky-container', containerClassName), style: {
            ...stickyEmulation_getStickyContainerStyle(stickyState, props),
            ...containerStyle || {},
        }, ref: containerForkRef },
        react.createElement("div", Object.assign({}, restProps, { style: {
                ...stickyEmulation_getStickyChildStyle(stickyState, props),
                ...style || {},
            }, ref: childForkRef }))));
}
//# sourceMappingURL=Sticky.js.map
;// CONCATENATED MODULE: ./node_modules/.pnpm/@bucketplace+ui@1.0.9_@emotion+react@11.13.3_@emotion+styled@11.13.0_react-dom@18.3.1_react@18.3.1_scheduler@0.23.2/node_modules/@bucketplace/ui/lib-esm/components/Sticky/useNodeHeight.js

function useNodeHeight_useNodeHeight(childRef, initialHeight = 0, 
/**
 * Whether to disable useNodeHeight hook. This is provided to optimize
 * useless updates when the results are not used due to responsive design, etc
 */
disabled = false) {
    const [height, setHeight] = (0,react.useState)(initialHeight);
    (0,react.useEffect)(() => {
        if (disabled)
            return;
        const childElem = childRef.current;
        if (childElem == null)
            return;
        let timerId = null;
        const update = () => {
            timerId = null;
            const rect = childElem.getBoundingClientRect();
            const newHeight = rect.bottom - rect.top;
            if (newHeight !== height) {
                setHeight(newHeight);
            }
        };
        const scheduleUpdate = () => {
            if (timerId != null) {
                cancelAnimationFrame(timerId);
            }
            timerId = requestAnimationFrame(update);
        };
        window.addEventListener('resize', scheduleUpdate);
        update();
        return () => {
            if (timerId != null) {
                cancelAnimationFrame(timerId);
            }
            window.removeEventListener('resize', scheduleUpdate);
        };
    });
    return height;
}
//# sourceMappingURL=useNodeHeight.js.map
;// CONCATENATED MODULE: ./node_modules/.pnpm/@bucketplace+ui@1.0.9_@emotion+react@11.13.3_@emotion+styled@11.13.0_react-dom@18.3.1_react@18.3.1_scheduler@0.23.2/node_modules/@bucketplace/ui/lib-esm/hooks/useScrollDirection.js

function useScrollDirection_useScrollDirection(threshold = 10, disabled = false) {
    const [state, setState] = (0,react.useState)('down');
    (0,react.useEffect)(() => {
        if (disabled)
            return;
        let lastScroll = window.pageYOffset || document.documentElement.scrollTop;
        let timerId = null;
        const handleUpdate = () => {
            timerId = null;
            const currentScroll = window.pageYOffset || document.documentElement.scrollTop;
            if (Math.abs(lastScroll - currentScroll) > threshold) {
                const delta = currentScroll - lastScroll;
                lastScroll = currentScroll;
                setState(delta > 0 ? 'down' : 'up');
            }
        };
        const handleScroll = () => {
            if (timerId != null) {
                cancelAnimationFrame(timerId);
            }
            timerId = requestAnimationFrame(handleUpdate);
        };
        document.addEventListener('scroll', handleScroll, { passive: true });
        return () => {
            if (timerId != null) {
                cancelAnimationFrame(timerId);
            }
            document.removeEventListener('scroll', handleScroll);
        };
    }, [disabled, threshold]);
    return state;
}
//# sourceMappingURL=useScrollDirection.js.map
;// CONCATENATED MODULE: ./node_modules/.pnpm/@bucketplace+ui@1.0.9_@emotion+react@11.13.3_@emotion+styled@11.13.0_react-dom@18.3.1_react@18.3.1_scheduler@0.23.2/node_modules/@bucketplace/ui/lib-esm/components/Sticky/useScrollAppear.js



function useScrollAppear_useScrollAppear(childRef, options = {}) {
    const { offset = 0, threshold = 10, initialHeight = 0, disabled = false, } = options;
    const scrollDir = useScrollDirection(threshold, disabled);
    const height = useNodeHeight(childRef, initialHeight, disabled);
    const result = useMemo(() => ({
        offset: scrollDir === 'down' ? -height : offset,
        offsetRange: [-height, offset],
    }), [scrollDir, height, offset]);
    return result;
}
//# sourceMappingURL=useScrollAppear.js.map
;// CONCATENATED MODULE: ./node_modules/.pnpm/@bucketplace+ui@1.0.9_@emotion+react@11.13.3_@emotion+styled@11.13.0_react-dom@18.3.1_react@18.3.1_scheduler@0.23.2/node_modules/@bucketplace/ui/lib-esm/components/Sticky/ScrollSticky.js




function ScrollSticky(props) {
    const { initialHeight, threshold, offset, disabled, forwardRef, ...restProps } = props;
    const childStickyRef = useRef(null);
    const childForkRef = useForkRef(forwardRef, childStickyRef);
    const offsets = useScrollAppear(childStickyRef, { offset, threshold, initialHeight, disabled });
    return (React.createElement(Sticky, Object.assign({}, restProps, offsets, { forwardRef: childForkRef })));
}
//# sourceMappingURL=ScrollSticky.js.map
;// CONCATENATED MODULE: ./node_modules/.pnpm/@bucketplace+ui@1.0.9_@emotion+react@11.13.3_@emotion+styled@11.13.0_react-dom@18.3.1_react@18.3.1_scheduler@0.23.2/node_modules/@bucketplace/ui/lib-esm/components/Sticky/StickyProvider.js


const STICKY_ENTRY_STATE_KEYS = [
    'disabled',
    'emulatedDisabled',
    'height',
    'bottom',
    'beginY',
];
const DIRECTIONS = ['top', 'bottom'];
function StickyProvider(props) {
    const { children } = props;
    const [entries, setEntries] = (0,react.useState)({});
    const entriesRef = (0,react.useRef)(entries);
    entriesRef.current = entries;
    const shouldSortEntriesRef = (0,react.useRef)(false);
    const entriesOrderRef = (0,react.useRef)({
        top: { ids: [], parentIndices: [] },
        bottom: { ids: [], parentIndices: [] },
    });
    const updateEntries = (0,react.useCallback)((getState) => {
        return setEntries((prevState) => {
            // top/bottom sticky objects are unrelated with each other. Therefore
            // run entire routine for each direction.
            const nextState = getState(prevState);
            if (nextState === prevState) {
                return prevState;
            }
            const entriesMap = nextState;
            const resultSet = { ...nextState };
            DIRECTIONS.forEach((direction) => {
                const orders = entriesOrderRef.current[direction];
                if (shouldSortEntriesRef.current) {
                    // Sort the sticky entries according to the DOM order.
                    // ... This can be done relatively easily IF we had shared className,
                    // or attribute available to search using querySelectorAll().
                    // However, we can't determine that's the case - this can be provided
                    // with HTMLElement - no other requirements are specified - therefore
                    // we have to handle every case.
                    // Therefore... we must implement graph traversal.
                    // - The sorting algorithm doesn't need to be implemented, as
                    //   array.sort() can receive comparator function.
                    // - While sorthing through array.sort(), comparator function gets
                    //   called O(n log n) times. Since we can assume that sticky nodes
                    //   exist on the screen AT MOST 10, this is pretty much negligble.
                    // - The comparator function should just call
                    //   'compareDocumentPosition()' method to compare the position
                    //   between two elements.
                    // Note that .sort() method is mutable.
                    // NOTE: This routine will not work properly if the sticky element is
                    // between multiple document, for example, iframes, or window.open().
                    // Since we can assume that this will not happen, we can ignore this.
                    // However this is pretty trivial to resolve since we just need to
                    // attach new StickyProvider onto the new document's elements.
                    const dirEntries = Object.keys(entriesMap)
                        .map((key) => entriesMap[key])
                        .filter((item) => item.direction === direction);
                    const orderedItems = dirEntries.sort((a, b) => {
                        const aElem = a.ref.current;
                        const bElem = b.ref.current;
                        if (aElem == null)
                            return 1;
                        if (bElem == null)
                            return -1;
                        const compareResult = aElem.compareDocumentPosition(bElem);
                        if (compareResult & Node.DOCUMENT_POSITION_FOLLOWING) {
                            return -1;
                        }
                        if (compareResult & Node.DOCUMENT_POSITION_PRECEDING) {
                            return 1;
                        }
                        return 0;
                    });
                    let ids = orderedItems.map((v) => v.id);
                    // Flip the list if the direction is bottom.
                    if (direction === 'bottom') {
                        ids = ids.reverse();
                    }
                    // Determine the Sticky dependency graph parent indices. Since the
                    // 'orders.ids' already stores sorted IDs, we can use that to quickly
                    // derive parent indices.
                    // NOTE: While it should be possible to determine parent IDs and order
                    // at the same time, the logic is already mind-boggling at this
                    // point. To avoid making this difficult, sorting -> backreferencing
                    // can be applied to quickly determine the parents of the Sticky node.
                    const parentIndices = [];
                    for (let i = 0; i < ids.length; i += 1) {
                        const item = entriesMap[ids[i]];
                        if (item == null)
                            continue;
                        const itemElem = item.ref.current;
                        if (itemElem == null)
                            continue;
                        // For each node, determine the "parent" node, excluding the
                        // siblings.
                        // Due to this nested loop, the time complexity would be
                        // O(n^2 log m). Still, this is acceptable as n is already too
                        // small.
                        let targetIndex = -1;
                        for (let j = i - 1; j >= 0; j -= 1) {
                            const target = entriesMap[ids[j]];
                            if (target == null)
                                continue;
                            const targetElem = target.ref.current;
                            if (targetElem == null)
                                continue;
                            const targetParentElem = targetElem.parentElement;
                            if (targetParentElem == null)
                                continue;
                            // Check if the target:
                            // - "has no bottom" therefore it should always stick regardless
                            //   of DOM node hierarchy
                            // - 's parent element contains itemElem. When this is true,
                            //   target element is on the top/bottom of the item element -
                            //   which means that the offset should use data from there.
                            //
                            // Let's skip "disableBottom" for now - the "contains" logic
                            // works like this:
                            //
                            // 1. In the following case, B should be below A since
                            //    A will always be visible while looking at B.
                            // div
                            //  +------+------------+
                            //        A             B
                            //
                            // 2. It doesn't matter if B is below some node too.
                            // div
                            //  +------+------------+
                            //         A           div
                            //                      +--------+
                            //                               B
                            //
                            // 3. HOWEVER, if A is below some node, it should not stick
                            //    with each other, as A and B will never intersect, since
                            //    the Sticky's scope only expand's to its parent element.
                            //
                            // div
                            //  +------+------------+
                            //        div           B
                            //         +
                            //         A
                            //
                            // For these cases, A.parentElement.contains(B) should check
                            // all these (as the nodes are already ordered at this point)
                            // and return the correct result. Therefore, we're just
                            // only relying on this logic.
                            // NOTE: This WILL break if the code uses
                            // flex-direction: row-reverse or something like that. We hope
                            // that will never happen...
                            if (target.disableBottom ||
                                targetParentElem.contains(itemElem)) {
                                // Found an adequate item, set the index and break
                                targetIndex = j;
                                break;
                            }
                        }
                        parentIndices[i] = targetIndex;
                    }
                    orders.ids = ids;
                    orders.parentIndices = parentIndices;
                    entriesOrderRef.current[direction] = orders;
                }
                // Determine the new accumulatedOffset...
                const accumulatedOffsets = [];
                const accumulatedOffsetRanges = [];
                orders.ids.forEach((key, order) => {
                    const parentIndex = orders.parentIndices[order];
                    const parentOffset = parentIndex === -1 ? 0 : accumulatedOffsets[parentIndex] ?? 0;
                    const parentOffsetRange = parentIndex === -1
                        ? [0, 0]
                        : accumulatedOffsetRanges[parentIndex] ?? [0, 0];
                    const item = entriesMap[key];
                    if (item == null || parentIndex == null)
                        return;
                    if (item.accumulatedOffset !== parentOffset ||
                        item.order !== order) {
                        resultSet[key] = {
                            ...item,
                            accumulatedOffset: parentOffset,
                            accumulatedOffsetRange: parentOffsetRange,
                            order,
                        };
                    }
                    if (!item.disabled && !item.bottom) {
                        accumulatedOffsets[order] =
                            parentOffset + item.offset + (item.height ?? 0);
                        accumulatedOffsetRanges[order] = [
                            parentOffsetRange[0] + (item.height ?? 0) +
                                (item.offsetRange?.[0] ?? item.offset),
                            parentOffsetRange[1] + (item.height ?? 0) +
                                (item.offsetRange?.[1] ?? item.offset),
                        ];
                    }
                    else {
                        accumulatedOffsets[order] = parentOffset;
                        accumulatedOffsetRanges[order] = parentOffsetRange;
                    }
                });
            });
            shouldSortEntriesRef.current = false;
            return resultSet;
        });
    }, []);
    const handleRegister = (0,react.useCallback)(() => {
        shouldSortEntriesRef.current = true;
        // Assign a random ID
        // NOTE: This is NOT deterministic and therefore there can be
        // inconsistencies between the server and the client while doing SSR.
        // However, this ID is never exposed outside React state and therefore
        // there won't be any discrepancies in the resulting HTML itself.
        return String((Math.random() * 0x7FFFFFFF) | 0);
    }, [setEntries]);
    const handleUpdate = (0,react.useCallback)((id, containerRef, options, state) => {
        updateEntries((prevState) => {
            // Check if the related state has changed so that we have to recalculate
            // the accumulatedOffset of sibling states.
            let prevItem = prevState[id];
            if (prevItem == null) {
                // New item has appended
                shouldSortEntriesRef.current = true;
                prevItem = {
                    id,
                    type: undefined,
                    shouldInfluenceScroll: true,
                    direction: null,
                    disabled: true,
                    emulatedDisabled: true,
                    disableBottom: false,
                    bottom: false,
                    height: 0,
                    offset: 0,
                    accumulatedOffset: 0,
                    accumulatedOffsetRange: [0, 0],
                    beginY: 0,
                    ref: containerRef,
                    order: 0,
                };
            }
            const hasChanged = STICKY_ENTRY_STATE_KEYS.some((key) => prevItem[key] !== state[key]) ||
                prevItem.direction !== options.direction ||
                prevItem.offset !== options.offset ||
                prevItem.disableBottom !== options.disableBottom ||
                prevItem.type !== options.type ||
                prevItem.shouldInfluenceScroll !==
                    (options.shouldInfluenceScroll ?? true);
            // offsetRange is omitted from diff calculation, as it can trigger
            // unnecessary updates
            if (!hasChanged) {
                // Nothing has changed; do nothing
                return prevState;
            }
            if (prevItem.direction !== options.direction) {
                // The sticky's direction has changed - re-sort the set
                shouldSortEntriesRef.current = true;
            }
            // Overwrite the related value
            return {
                ...prevState,
                [id]: {
                    ...prevItem,
                    direction: options.direction,
                    disabled: state.disabled,
                    emulatedDisabled: state.emulatedDisabled,
                    height: state.height,
                    bottom: state.bottom,
                    beginY: state.beginY,
                    offset: options.offset,
                    offsetRange: options.offsetRange,
                    disableBottom: options.disableBottom,
                    type: options.type,
                    shouldInfluenceScroll: options.shouldInfluenceScroll ?? true,
                },
            };
        });
    }, [updateEntries]);
    const handleUnregister = (0,react.useCallback)((id) => {
        shouldSortEntriesRef.current = true;
        updateEntries((prevState) => {
            const newState = { ...prevState };
            delete newState[id];
            return newState;
        });
    }, [updateEntries]);
    const handleGetState = (0,react.useCallback)(() => {
        return { entries: entriesRef.current };
    }, []);
    const controlValue = (0,react.useMemo)(() => ({
        register: handleRegister,
        update: handleUpdate,
        unregister: handleUnregister,
        getState: handleGetState,
    }), [handleRegister, handleUpdate, handleUnregister, handleGetState]);
    return (react.createElement(StickyControlContext.Provider, { value: controlValue },
        react.createElement(StickyValueContext.Provider, { value: { entries } }, children)));
}
//# sourceMappingURL=StickyProvider.js.map
;// CONCATENATED MODULE: ./node_modules/.pnpm/@bucketplace+ui@1.0.9_@emotion+react@11.13.3_@emotion+styled@11.13.0_react-dom@18.3.1_react@18.3.1_scheduler@0.23.2/node_modules/@bucketplace/ui/lib-esm/components/Sticky/useGetStickyHeight.js



function useGetStickyHeight(direction = 'top') {
    const stickyControlContext = (0,index_modern/* useContext */.qp)(StickyControlContext);
    if (stickyControlContext == null) {
        throw new Error('StickyContext is not provided');
    }
    // TODO: This will be inaccurate if there are non-overlapping
    // sticky on the document. The difference will be minor if there aren't
    // too much of them, however, to correctly implement that, we basically have
    // to rewrite sticky emulation here. Because of this, I'm leaving this as-is,
    // yet, to allow future updates without breaking change, this accepts targetY
    // as the target position of the document. This can be implemented later,
    // and the upgrade path would be simple enough.
    return (0,react.useCallback)((targetY, filterEntry) => {
        const { entries } = stickyControlContext.getState();
        const entryList = Object.keys(entries)
            .map((key) => entries[key])
            .filter((entry) => {
            if (entry.direction !== direction)
                return false;
            if (!entry.shouldInfluenceScroll)
                return false;
            if (filterEntry != null && !filterEntry(entry))
                return false;
            return true;
        });
        const height = entryList.reduce((prev, entry) => {
            if (entry.disabled)
                return prev;
            if (entry.beginY > targetY) {
                return prev;
            }
            const maxOffset = entry.offsetRange != null ? entry.offsetRange[1] : entry.offset;
            return prev + maxOffset + (entry.height || 0);
        }, 0);
        return height;
    }, [stickyControlContext, direction]);
}
//# sourceMappingURL=useGetStickyHeight.js.map
;// CONCATENATED MODULE: ./node_modules/.pnpm/@bucketplace+ui@1.0.9_@emotion+react@11.13.3_@emotion+styled@11.13.0_react-dom@18.3.1_react@18.3.1_scheduler@0.23.2/node_modules/@bucketplace/ui/lib-esm/components/Sticky/useStickyHeight.js





function useStickyHeight(ref, direction = 'top') {
    const stickyControlContext = (0,index_modern/* useContext */.qp)(StickyControlContext);
    if (stickyControlContext == null) {
        throw new Error('StickyContext is not provided');
    }
    const stickyIdRef = (0,react.useRef)(null);
    const stickyId = stickyIdRef.current || stickyControlContext.register();
    stickyIdRef.current = stickyId;
    const itemState = (0,index_modern/* useContextSelector */.Sz)(StickyValueContext, (context) => {
        if (context == null) {
            return null;
        }
        return context.entries[stickyId];
    });
    (0,react.useEffect)(() => {
        stickyControlContext.update(stickyId, ref, {
            shouldInfluenceScroll: false,
            direction,
            offset: 0,
        }, stickyEmulation_DEFAULT_STICKY_STATE);
    }, [stickyControlContext.update, stickyId, ref, direction]);
    (0,react.useEffect)(() => {
        // Unregister on unmount
        return () => {
            stickyControlContext.unregister(stickyId);
        };
    }, [stickyId]);
    return {
        min: quantizeSize(itemState?.accumulatedOffsetRange?.[0] ?? 0),
        max: quantizeSize(itemState?.accumulatedOffsetRange?.[1] ?? 0),
        current: quantizeSize(itemState?.accumulatedOffset ?? 0),
    };
}
//# sourceMappingURL=useStickyHeight.js.map
;// CONCATENATED MODULE: ./node_modules/.pnpm/@bucketplace+ui@1.0.9_@emotion+react@11.13.3_@emotion+styled@11.13.0_react-dom@18.3.1_react@18.3.1_scheduler@0.23.2/node_modules/@bucketplace/ui/lib-esm/components/Sticky/StickyCompat.js






/**
 * The compatibility component for older versions of Sticky. This is provided
 * because there are more than 60 instances of Sticky in the codebase, and it is
 * not possible to convert them one by one.
 * However, please do note that this only tries to match the observed behavior
 * in the ohou.se-client.
 *
 * Furthermore, offset functions, for example, offset={() => {}} is omitted
 * because it is fundamentally incompatible from current Sticky design, and it
 * is not possible to make escape hatch for it.
 * Instead, we provide ScrollStickyCompat for exactly this purpose, so please
 * use that instead.
 * @deprecated Please convert this to Sticky, as this is only provided for
 *   compatibility reasons.
 */
function StickyCompat_StickyCompat(props) {
    const { className, enabledClassName, innerClassName, children, containerRef, innerRef, onEnabledChange, containerStyle, style, initialState, ...restProps } = omitKeys(props, STICKY_OPTIONS_KEYS);
    const containerStickyRef = useRef(null);
    const containerForkRef = useForkRef(containerRef, containerStickyRef);
    const childStickyRef = useRef(null);
    const childForkRef = useForkRef(innerRef, childStickyRef);
    // disabled can receive both function and boolean; defer it if it's function
    const { disabled: disabledProp } = props;
    const [disabledState, setDisabled] = useState(true);
    const disabled = 
    // eslint-disable-next-line react/destructuring-assignment
    typeof disabledProp === 'function' ? disabledState : disabledProp;
    const stickyOptions = { ...props, disabled };
    const stickyState = useSticky(stickyOptions, containerStickyRef, childStickyRef, initialState);
    useEffect(() => {
        if (onEnabledChange != null) {
            onEnabledChange(stickyState.emulatedDisabled);
        }
    }, [onEnabledChange, stickyState.emulatedDisabled]);
    useEffect(() => {
        if (typeof disabledProp === 'function') {
            setDisabled(disabledProp());
        }
    }, [disabledProp]);
    return (React.createElement("div", { className: classNames('sticky-container', !stickyState.emulatedDisabled && enabledClassName, className), style: {
            ...getStickyContainerStyle(stickyState, stickyOptions),
            ...containerStyle || {},
        }, ref: containerForkRef },
        React.createElement("div", Object.assign({}, restProps, { className: classNames('sticky-child', innerClassName), style: {
                ...getStickyChildStyle(stickyState, stickyOptions),
                ...style || {},
            }, ref: childForkRef }), children)));
}
//# sourceMappingURL=StickyCompat.js.map
;// CONCATENATED MODULE: ./node_modules/.pnpm/@bucketplace+ui@1.0.9_@emotion+react@11.13.3_@emotion+styled@11.13.0_react-dom@18.3.1_react@18.3.1_scheduler@0.23.2/node_modules/@bucketplace/ui/lib-esm/components/Sticky/ScrollStickyCompat.js




/**
 * The compatibility component for older versions of Sticky, with the scroll-to-
 * appear feature.
 * @deprecated Please convert this to Sticky, as this is only provided for
 *   compatibility reasons.
 */
function ScrollStickyCompat(props) {
    const { innerRef, offset, threshold, initialHeight, ...restProps } = props;
    const childStickyRef = useRef(null);
    const childForkRef = useForkRef(innerRef, childStickyRef);
    const offsets = useScrollAppear(childStickyRef, { offset, threshold, initialHeight });
    return (React.createElement(StickyCompat, Object.assign({}, restProps, offsets, { innerRef: childForkRef })));
}
//# sourceMappingURL=ScrollStickyCompat.js.map
;// CONCATENATED MODULE: ./node_modules/.pnpm/@bucketplace+ui@1.0.9_@emotion+react@11.13.3_@emotion+styled@11.13.0_react-dom@18.3.1_react@18.3.1_scheduler@0.23.2/node_modules/@bucketplace/ui/lib-esm/components/Sticky/index.js














//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ./node_modules/.pnpm/@bucketplace+ui@1.0.9_@emotion+react@11.13.3_@emotion+styled@11.13.0_react-dom@18.3.1_react@18.3.1_scheduler@0.23.2/node_modules/@bucketplace/ui/lib-esm/components/index.js






//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ./node_modules/.pnpm/@bucketplace+ui@1.0.9_@emotion+react@11.13.3_@emotion+styled@11.13.0_react-dom@18.3.1_react@18.3.1_scheduler@0.23.2/node_modules/@bucketplace/ui/lib-esm/hooks/useChanged.js

/**
 * Determines if the given value has changed.
 * @param {any} value The value to compare against.
 * @param {function} isEqual The checking mechanism. Defaults to shallow equal.
 * @return {boolean} Whether if the value has changed.
 */
function useChanged_useChanged(value, isEqual = (a, b) => a === b) {
    const prevValueRef = (0,react.useRef)();
    if (prevValueRef.current == null) {
        prevValueRef.current = { value };
        return false;
    }
    const prevValue = prevValueRef.current.value;
    const changed = !isEqual(prevValue, value);
    prevValueRef.current.value = value;
    return changed;
}
//# sourceMappingURL=useChanged.js.map
;// CONCATENATED MODULE: ./node_modules/.pnpm/@bucketplace+ui@1.0.9_@emotion+react@11.13.3_@emotion+styled@11.13.0_react-dom@18.3.1_react@18.3.1_scheduler@0.23.2/node_modules/@bucketplace/ui/lib-esm/hooks/usePagedInfiniteList.js


function insertChunk(list, item) {
    const output = [];
    let currentPos = 0;
    let currentOffset = 0;
    // 1. Traverse until the target offset is reached. If target offset is
    // reached, we have to slice the chunk to fit the new entry.
    //             v cut
    // ----####------#######
    //             #####
    while (currentPos < list.length) {
        const chunk = list[currentPos];
        // NOTE There is an invariant property: List of chunks must be continious.
        // That is, while we allow 'empty' chunks, there must be 'empty' chunk
        // explaining the count and offset of the chunk. There must be no 'gaps',
        // i.e. sudden jump of offset.
        if (chunk.count + chunk.offset >= item.offset) {
            if (chunk.offset >= item.offset) {
                // It immediately reaches threshold at the beginning - don't
                // insert anything.
                break;
            }
            const remaining = item.offset - chunk.offset;
            // Slice the output to meet the criteria.
            currentOffset = chunk.offset + remaining;
            if (chunk.type === 'page') {
                output.push({
                    ...chunk,
                    count: remaining,
                    items: chunk.items.slice(0, remaining),
                });
            }
            else {
                output.push({
                    ...chunk,
                    count: remaining,
                });
            }
            break;
        }
        // It does not reach any threshold; just output them.
        output.push(chunk);
        currentPos += 1;
        currentOffset = chunk.offset + chunk.count;
    }
    // 1-2. If it hasn't reached any threshold yet, insert a empty chunk to
    // reach the target offset.
    if (currentOffset !== item.offset) {
        output.push({
            type: 'empty',
            offset: currentOffset,
            count: item.offset - currentOffset,
        });
    }
    // 2. Insert the new item to the output.
    output.push(item);
    // 3. Insert the remaining chunks, while slicing / skipping when
    // necessary.
    const exitOffset = item.offset + item.count;
    for (; currentPos < list.length; currentPos += 1) {
        const chunk = list[currentPos];
        if (chunk.offset < exitOffset) {
            if (chunk.offset + chunk.count <= exitOffset) {
                // It immediately reaches threshold at the beginning - don't
                // insert anything.
                continue;
            }
            const remaining = exitOffset - chunk.offset;
            // Slice the output to meet the criteria.
            if (chunk.type === 'page') {
                output.push({
                    ...chunk,
                    offset: exitOffset,
                    count: chunk.count - remaining,
                    items: chunk.items.slice(remaining),
                });
            }
            else {
                output.push({
                    ...chunk,
                    offset: exitOffset,
                    count: chunk.count - remaining,
                });
            }
            continue;
        }
        // It does not reach any threshold; just output them.
        output.push(chunk);
    }
    return output;
}
function mapHintChunks(chunks) {
    // eslint-disable-next-line array-callback-return
    return chunks.map((v) => {
        // eslint-disable-next-line default-case
        switch (v.type) {
            case 'page':
                return { type: 'page', page: v.page, count: v.count };
            case 'empty':
                return { type: 'empty', count: v.count };
        }
    });
}
function getChunkIndex(chunks, offset) {
    // Run a binary search to find the right chunk.
    let minPos = 0;
    let maxPos = chunks.length - 1;
    while (minPos <= maxPos) {
        const middle = (minPos + maxPos) >> 1;
        const middleItem = chunks[middle];
        if (middleItem.offset > offset) {
            maxPos = middle - 1;
        }
        else if (middleItem.offset + middleItem.count <= offset) {
            minPos = middle + 1;
        }
        else {
            // Found the right item.
            return middle;
        }
    }
    return -1;
}
function getLoadablePage(state, per, totalCount, targetStartIndex, targetEndIndex) {
    // Determine which page to load. This can be determined using:
    // 1. Using nearest loaded page. This can be used when nearest page is
    //    not far enough (<20 items)
    // 2. Using hint chunks. This can be used when hint chunks covers that
    //    range.
    // 3. Using heuristics. Since we can *usually* assume that pages are divided
    //    by 'per' count, we can skip from nearest loaded page.
    // Note that load request doesn't have to cover all items between
    // startIndex and endIndex - it's fine to load just a part of it -
    // loadMore will be triggered again anyway.
    // Note that endIndex is inclusive; [0, 0] means 0th item must be loaded.
    const startIndex = Math.max(0, targetStartIndex);
    let endIndex = targetEndIndex;
    if (totalCount != null) {
        endIndex = Math.min(endIndex, totalCount - 1);
    }
    if (state.totalCount != null) {
        endIndex = Math.min(endIndex, state.totalCount - 1);
    }
    if ((totalCount != null && startIndex > totalCount) ||
        (state.totalCount != null && startIndex > state.totalCount)) {
        return null;
    }
    let lastOffset = startIndex;
    // Retrieve the first page to load. If there is no page left to load,
    // do nothing.
    let chunkIndex = getChunkIndex(state.chunks, startIndex);
    let chunkPage = null;
    let chunkOffset = null;
    // Scroll until the end is reached.
    if (chunkIndex !== -1) {
        while (chunkIndex < state.chunks.length && lastOffset <= endIndex) {
            const chunkItem = state.chunks[chunkIndex];
            // Empty item immediately fails the test.
            if (chunkItem.type === 'empty') {
                // This assumes that 'empty' chunk item is not consecutive.
                // Determine which page to load. It can:
                // 1. Snap to the start of empty chunk (or end of page chunk)
                // 2. Snap to the end of empty chunk (or start of page chunk)
                // 3. Snap to neither
                // For 1 or 2 to succeed, it must be within 'per' range.
                //
                // |-per-............-per-|
                // |...---here---.........|
                //
                // For the above case, it'll snap to start of chunk because it's
                // within 'per' radius.
                //
                // |-per-............-per-|
                // |.....---here---.......|
                //
                // This does not snap, therefore heuristics will be used. (Note, this
                // may generate fragmentation or other data integrity errors)
                const prevItem = state.chunks[chunkIndex - 1];
                const nextItem = state.chunks[chunkIndex + 1];
                // Check leftmost
                if (prevItem != null && prevItem.type === 'page' &&
                    startIndex <= chunkItem.offset + per) {
                    chunkPage = prevItem.page + 1;
                    chunkOffset = chunkItem.offset;
                    break;
                }
                // Check rightmost
                if (nextItem != null && nextItem.type === 'page' &&
                    endIndex >= chunkItem.offset + chunkItem.count - per) {
                    chunkPage = nextItem.page - 1;
                    chunkOffset = chunkItem.offset + chunkItem.count - per;
                    break;
                }
                // Nothing matches; use heuristics
                lastOffset = Math.max(startIndex, chunkItem.offset);
                break;
            }
            else if (chunkItem.type === 'page' &&
                chunkIndex === state.chunks.length - 1) {
                // Last page has reached; since startIndex already intersects with
                // the pages, just load next page.
                chunkPage = chunkItem.page + 1;
                chunkOffset = chunkItem.offset + chunkItem.count;
            }
            lastOffset = chunkItem.offset + chunkItem.count;
            chunkIndex += 1;
        }
    }
    else {
        // Nothing matched! ... If last chunk is page chunk, and startIndex is
        // within bounds, use that.
        const lastItem = state.chunks[state.chunks.length - 1];
        if (lastItem != null && lastItem.type === 'page' &&
            endIndex <= lastItem.offset + lastItem.count + per) {
            chunkPage = lastItem.page + 1;
            chunkOffset = lastItem.offset + lastItem.count;
        }
    }
    if (lastOffset > endIndex) {
        return null;
    }
    // Check if page number is determined yet...
    if (chunkPage == null || chunkOffset == null) {
        // It still didn't match. It can use hint information to resurrect
        // the given page, or if even that doesn't exist, heuristics can be used.
        // While we store hint chunks, heuristics are pretty reliable for now -
        // there is no need for hint chunk implementation for yet.
        chunkPage = Math.floor(lastOffset / per) + 1;
        chunkOffset = (chunkPage - 1) * per;
    }
    return { page: chunkPage, offset: chunkOffset };
}
function initPagedInfiniteListState(chunk) {
    if (chunk != null) {
        const chunks = insertChunk([], {
            type: 'page',
            page: chunk.page,
            offset: chunk.offset ?? 0,
            count: chunk.items.length,
            items: chunk.items,
        });
        const hasNext = chunk.hasNext != null
            ? chunk.hasNext
            : chunk.items.length > 0;
        const afterOffset = (chunk.offset ?? 0) + chunk.items.length;
        return {
            chunks,
            hintChunks: mapHintChunks(chunks),
            count: afterOffset,
            scrolledCount: null,
            totalCount: !hasNext ? afterOffset : null,
            epoch: 0,
            error: null,
        };
    }
    return {
        chunks: [],
        hintChunks: [],
        count: 0,
        scrolledCount: null,
        totalCount: null,
        epoch: 0,
        error: null,
    };
}
function pagedInfiniteListReducer(state, action) {
    // eslint-disable-next-line default-case
    switch (action.type) {
        case 'load': {
            // Try to insert the chunk information at the designated offset.
            // If there is any empty space between chunks, insert 'empty' chunk
            // between it.
            // If target offset is already occupied, overwrite over the chunk.
            // TODO Remove any duplicate items if possible to do so
            const { offset, page, items, hasNext } = action.item;
            const targetOffset = action.targetOffset != null
                ? action.targetOffset
                : offset;
            const outputChunks = insertChunk(state.chunks, {
                type: 'page',
                page,
                offset: targetOffset ?? 0,
                count: items.length,
                items,
            });
            const lastChunk = outputChunks[outputChunks.length - 1];
            let nextTotalCount = state.totalCount;
            if (hasNext != null ? !hasNext : items.length === 0) {
                const offset = lastChunk.offset + lastChunk.count;
                nextTotalCount = nextTotalCount != null
                    ? Math.min(nextTotalCount, offset)
                    : offset;
            }
            return {
                ...state,
                chunks: outputChunks,
                hintChunks: mapHintChunks(outputChunks),
                count: lastChunk.offset + lastChunk.count,
                totalCount: nextTotalCount,
                epoch: action.isAsync ? state.epoch + 1 : state.epoch,
            };
        }
        case 'end': {
            return {
                ...state,
                totalCount: state.totalCount != null
                    ? Math.min(state.totalCount, action.offset)
                    : action.offset,
                epoch: action.isAsync ? state.epoch + 1 : state.epoch,
            };
        }
        case 'setHint': {
            return {
                ...state,
                hintChunks: action.hintChunks,
                scrolledCount: action.scrolledCount,
            };
        }
        case 'reset': {
            return initPagedInfiniteListState();
        }
        case 'error': {
            return { ...state, error: action.error };
        }
        case 'clearError': {
            return { ...state, error: null };
        }
    }
}
function usePagedInfiniteList(tabId, pending, loadMore, getInitialData, per, loadThreshold = 5, 
/**
 * The absolute total count of the items passed from the server. The client
 * will not request any more pages further from this.
 * Note this can be omitted - most pages don't even have totalCount value.
 * When this is omitted, it may send additional requests and therefore
 * a placeholder 'flicker' might be visible when the end of the list is
 * reached.
 */
totalCount) {
    // TODO Reload when location changes
    const initialDataFilled = (0,react.useRef)(false);
    const initialRendered = (0,react.useRef)(false);
    const innerPending = (0,react.useRef)(false);
    const locationChanged = useChanged_useChanged(tabId);
    const changedEpoch = (0,react.useRef)(0);
    const stateEpoch = (0,react.useRef)(0);
    const displayedRef = (0,react.useRef)([0, 0]);
    const mountedRef = (0,react.useRef)(true);
    const [state, dispatch] = (0,react.useReducer)(pagedInfiniteListReducer, undefined, () => initPagedInfiniteListState(getInitialData()));
    const stateRef = (0,react.useRef)(state);
    stateRef.current = state;
    if (locationChanged) {
        changedEpoch.current += 1;
        innerPending.current = false;
    }
    // Unmount handler
    (0,react.useEffect)(() => {
        return () => {
            mountedRef.current = false;
        };
    }, []);
    (0,react.useEffect)(() => {
        if (changedEpoch.current > 0) {
            dispatch({ type: 'reset' });
            initialDataFilled.current = false;
            initialRendered.current = false;
        }
        if (tabId != null) {
            // Reload hint data, if available.
            let value;
            try {
                value = JSON.parse(sessionStorage[`plist-hint-${tabId}`] || 'null');
            }
            catch (e) {
                // Do nothing if failed
            }
            if (value != null) {
                dispatch({
                    type: 'setHint',
                    hintChunks: value.hintChunks,
                    scrolledCount: value.scrolledCount,
                });
            }
        }
    }, [changedEpoch.current, tabId]);
    (0,react.useEffect)(() => {
        const prevEpoch = stateEpoch.current;
        if (stateEpoch.current !== state.epoch) {
            stateEpoch.current = state.epoch;
            if (prevEpoch < state.epoch && tabId != null) {
                const timerId = window.setTimeout(() => {
                    try {
                        sessionStorage[`plist-hint-${tabId}`] = JSON.stringify({
                            hintChunks: state.hintChunks,
                            scrolledCount: state.count,
                        });
                    }
                    catch (e) {
                        // Do nothing if failed
                    }
                }, 200);
                return () => window.clearTimeout(timerId);
            }
        }
    }, [state.epoch, tabId, state]);
    const handleGetItem = (0,react.useMemo)(() => {
        // To avoid running binary search every time an item lookup is needed, we
        // memoize last index of the item. This can reduce time complexity from
        // O(m log n) to O(m + log n), with space complexity of O(1).
        let currentItem = null;
        return (index) => {
            // If the index is out of bounds, return null immediately.
            if (index < 0 || index >= state.count) {
                return null;
            }
            // If the index is already within bounds, return the item.
            if (currentItem != null &&
                currentItem.offset <= index &&
                currentItem.offset + currentItem.count > index) {
                if (currentItem.type === 'page') {
                    return currentItem.items[index - currentItem.offset];
                }
                return null;
            }
            // Run a binary search to find the right chunk.
            const chunkIndex = getChunkIndex(state.chunks, index);
            if (chunkIndex === -1) {
                return null;
            }
            currentItem = state.chunks[chunkIndex];
            if (currentItem.type === 'page') {
                return currentItem.items[index - currentItem.offset];
            }
            return null;
        };
    }, [state]);
    const handleLoadMore = (0,react.useCallback)(async (startIndex, endIndex) => {
        // Reset the currently displayed index.
        displayedRef.current = [startIndex, endIndex];
        if (innerPending.current || pending || !initialDataFilled.current ||
            stateRef.current.error != null) {
            return;
        }
        let nextPage;
        const currentEpoch = changedEpoch.current;
        // Lock
        innerPending.current = true;
        do {
            if (!mountedRef.current ||
                stateRef.current.error != null ||
                changedEpoch.current !== currentEpoch) {
                break;
            }
            const [start, end] = displayedRef.current;
            nextPage =
                getLoadablePage(stateRef.current, per, totalCount, start, end + 1);
            // Digest remaining...
            // If there are anything to load, perform loading.
            if (nextPage == null) {
                break;
            }
            try {
                const result = await loadMore(nextPage.page);
                if (changedEpoch.current !== currentEpoch) {
                    break;
                }
                dispatch({
                    type: 'load',
                    item: {
                        ...result,
                        offset: result.offset || nextPage.offset,
                    },
                    isAsync: true,
                });
            }
            catch (e) {
                const error = e;
                // Handle error
                console.error(`${error.toString()}\n${error.stack}`);
                dispatch({ type: 'error', error });
            }
        } while (nextPage != null);
        // Unlock
        innerPending.current = false;
    }, [pending, loadMore, handleGetItem]);
    (0,react.useEffect)(() => {
        if (!pending) {
            if (!initialDataFilled.current) {
                const chunk = getInitialData();
                if (chunk != null) {
                    if (chunk.items.length === 0) {
                        dispatch({
                            type: 'end',
                            offset: chunk.offset ?? 0,
                            isAsync: true,
                        });
                    }
                    else {
                        dispatch({ type: 'load', item: chunk });
                    }
                    initialDataFilled.current = true;
                }
                else {
                    initialDataFilled.current = true;
                    initialRendered.current = true;
                    handleLoadMore(displayedRef.current[0], displayedRef.current[1]);
                }
            }
            else if (!initialRendered.current) {
                initialRendered.current = true;
                handleLoadMore(displayedRef.current[0], displayedRef.current[1]);
            }
        }
    }, [pending, getInitialData, handleLoadMore]);
    const handleRowsRendered = (0,react.useCallback)((startIndex, endIndex) => {
        handleLoadMore(startIndex - loadThreshold, endIndex + loadThreshold);
    }, [loadThreshold, handleLoadMore]);
    const reloadData = (0,react.useCallback)(async () => {
        changedEpoch.current += 1;
        dispatch({ type: 'reset' });
        await handleLoadMore(0, 1);
    }, [handleLoadMore]);
    const handleClearError = (0,react.useCallback)(() => {
        dispatch({ type: 'clearError' });
        handleLoadMore(displayedRef.current[0], displayedRef.current[1]);
    }, [handleLoadMore]);
    const count = Math.max([state.count + per, state.totalCount, totalCount]
        .reduce((p, v) => (v == null ? p : Math.min(v, p)), Infinity), state.scrolledCount ?? 0);
    const loadedCount = state.count;
    return {
        state,
        count: state.error != null ? loadedCount : count,
        loadedCount,
        getItem: handleGetItem,
        loadMore: handleLoadMore,
        handleRowsRendered,
        error: state.error,
        reloadData,
        clearError: handleClearError,
    };
}
//# sourceMappingURL=usePagedInfiniteList.js.map
;// CONCATENATED MODULE: ./node_modules/.pnpm/@bucketplace+ui@1.0.9_@emotion+react@11.13.3_@emotion+styled@11.13.0_react-dom@18.3.1_react@18.3.1_scheduler@0.23.2/node_modules/@bucketplace/ui/lib-esm/hooks/usePagedCursorInfiniteList.js


function usePagedCursorInfiniteList_insertChunk(list, item, direction) {
    const output = [];
    let outputIndex = 0;
    let currentPos = 0;
    let currentOffset = 0;
    // 1. Traverse until the target offset is reached. If target offset is
    // reached, we have to slice the chunk to fit the new entry.
    //             v cut
    // ----####------#######
    //             #####
    while (currentPos < list.length) {
        const chunk = list[currentPos];
        // NOTE There is an invariant property: List of chunks must be continious.
        // That is, while we allow 'empty' chunks, there must be 'empty' chunk
        // explaining the count and offset of the chunk. There must be no 'gaps',
        // i.e. sudden jump of offset.
        if (chunk.count + chunk.offset >= item.offset) {
            if (chunk.offset >= item.offset) {
                // It immediately reaches threshold at the beginning - don't
                // insert anything.
                break;
            }
            const remaining = item.offset - chunk.offset;
            // Slice the output to meet the criteria.
            currentOffset = chunk.offset + remaining;
            if (chunk.type === 'page') {
                output.push({
                    ...chunk,
                    count: remaining,
                    items: chunk.items.slice(0, remaining),
                });
            }
            else {
                output.push({
                    ...chunk,
                    count: remaining,
                });
            }
            break;
        }
        // It does not reach any threshold; just output them.
        output.push(chunk);
        currentPos += 1;
        currentOffset = chunk.offset + chunk.count;
    }
    // 1-2. If it hasn't reached any threshold yet, insert a empty chunk to
    // reach the target offset.
    if (currentOffset !== item.offset) {
        output.push({
            type: 'empty',
            offset: currentOffset,
            count: item.offset - currentOffset,
        });
    }
    // 2. Insert the new item to the output.
    output.push(item);
    outputIndex = output.length;
    // 3. Insert the remaining chunks, while slicing / skipping when
    // necessary.
    const exitOffset = item.offset + item.count;
    for (; currentPos < list.length; currentPos += 1) {
        const chunk = list[currentPos];
        if (chunk.offset < exitOffset) {
            if (chunk.offset + chunk.count <= exitOffset) {
                // It immediately reaches threshold at the beginning - don't
                // insert anything.
                continue;
            }
            const remaining = exitOffset - chunk.offset;
            // Slice the output to meet the criteria.
            if (chunk.type === 'page') {
                output.push({
                    ...chunk,
                    offset: exitOffset,
                    count: chunk.count - remaining,
                    items: chunk.items.slice(remaining),
                });
            }
            else {
                output.push({
                    ...chunk,
                    offset: exitOffset,
                    count: chunk.count - remaining,
                });
            }
            continue;
        }
        // It does not reach any threshold; just output them.
        output.push(chunk);
    }
    // 4. If the item was empty and it can be merged, try to merge it.
    if (item.type === 'page' && item.count === 0) {
        if (direction === 'next') {
            // 4-2. If the direction is next, and the previous item is a 'page' type,
            // Remove current chunk and replace the nextCursor.
            const prevItem = output[outputIndex - 1];
            if (prevItem?.type === 'page') {
                output[outputIndex - 1] = {
                    ...prevItem,
                    nextCursor: item.nextCursor,
                };
                output.splice(outputIndex, 1);
            }
        }
        else if (direction === 'prev') {
            // 4-2. If the direction is prev, and the next item is a 'page' type,
            // Remove current chunk and replace the prevCursor.
            const nextItem = output[outputIndex + 1];
            if (nextItem?.type === 'page') {
                output[outputIndex + 1] = {
                    ...nextItem,
                    prevCursor: item.prevCursor,
                };
                output.splice(outputIndex, 1);
            }
        }
    }
    return output;
}
function usePagedCursorInfiniteList_mapHintChunks(chunks) {
    // eslint-disable-next-line array-callback-return
    return chunks.map((v) => {
        // eslint-disable-next-line default-case
        switch (v.type) {
            case 'page':
                return {
                    type: 'page',
                    nextCursor: v.nextCursor,
                    prevCursor: v.prevCursor,
                    count: v.count,
                    offset: v.offset,
                };
            case 'empty':
                return { type: 'empty', count: v.count, offset: v.offset };
        }
    });
}
function usePagedCursorInfiniteList_getChunkIndex(chunks, offset) {
    // Run a binary search to find the right chunk.
    let minPos = 0;
    let maxPos = chunks.length - 1;
    while (minPos <= maxPos) {
        const middle = (minPos + maxPos) >> 1;
        const middleItem = chunks[middle];
        if (middleItem.offset > offset) {
            maxPos = middle - 1;
        }
        else if (middleItem.offset + middleItem.count <= offset) {
            minPos = middle + 1;
        }
        else {
            // Found the right item.
            return middle;
        }
    }
    return -1;
}
function getLoadablePageImpl(chunks, per, 
// How many consecutive page loading is allowed?
loadThreshold, startIndex, endIndex) {
    let lastOffset = startIndex;
    const perThreshold = per * loadThreshold;
    // Retrieve the first page to load. If there is no page left to load,
    // do nothing.
    let chunkIndex = usePagedCursorInfiniteList_getChunkIndex(chunks, startIndex);
    let chunkLoadable = null;
    // Scroll until the end is reached.
    if (chunkIndex !== -1) {
        while (chunkIndex < chunks.length && lastOffset <= endIndex) {
            const chunkItem = chunks[chunkIndex];
            // Empty item immediately fails the test.
            if (chunkItem.type === 'empty') {
                // This assumes that 'empty' chunk item is not consecutive.
                // Determine which page to load. It can:
                // 1. Snap to the start of empty chunk (or end of page chunk)
                // 2. Snap to the end of empty chunk (or start of page chunk)
                // 3. Snap to neither
                // For 1 or 2 to succeed, it must be within 'per' range.
                //
                // |-per-............-per-|
                // |...---here---.........|
                //
                // For the above case, it'll snap to start of chunk because it's
                // within 'per' radius.
                //
                // |-per-............-per-|
                // |.....---here---.......|
                //
                // This does not snap, therefore heuristics will be used. (Note, this
                // may generate fragmentation or other data integrity errors)
                const prevItem = chunks[chunkIndex - 1];
                const nextItem = chunks[chunkIndex + 1];
                // Check leftmost
                if (prevItem != null && prevItem.type === 'page' &&
                    startIndex <= chunkItem.offset + perThreshold) {
                    chunkLoadable = {
                        direction: 'next',
                        cursor: prevItem.nextCursor,
                        offset: chunkItem.offset,
                        per,
                    };
                    break;
                }
                // Load from the beginning
                if (prevItem == null &&
                    startIndex <= chunkItem.offset + perThreshold) {
                    chunkLoadable = {
                        direction: 'next',
                        cursor: null,
                        offset: chunkItem.offset,
                        per,
                    };
                    break;
                }
                // Check rightmost
                if (nextItem != null && nextItem.type === 'page' &&
                    nextItem.prevCursor != null &&
                    endIndex >= chunkItem.offset + chunkItem.count - perThreshold) {
                    chunkLoadable = {
                        direction: 'prev',
                        cursor: nextItem.prevCursor,
                        offset: chunkItem.offset + chunkItem.count - per,
                        per,
                    };
                    break;
                }
                // Nothing matches; use heuristics
                lastOffset = Math.max(startIndex, chunkItem.offset);
                break;
            }
            else if (chunkItem.type === 'page' &&
                chunkIndex === chunks.length - 1) {
                // Last page has reached; since startIndex already intersects with
                // the pages, just load next page.
                chunkLoadable = {
                    direction: 'next',
                    cursor: chunkItem.nextCursor,
                    offset: chunkItem.offset + chunkItem.count,
                    per,
                };
            }
            lastOffset = chunkItem.offset + chunkItem.count;
            chunkIndex += 1;
        }
    }
    else {
        // Nothing matched! ... If last chunk is page chunk, and startIndex is
        // within bounds, use that.
        const lastItem = chunks[chunks.length - 1];
        if (lastItem != null && lastItem.type === 'page' &&
            endIndex <= lastItem.offset + lastItem.count + perThreshold) {
            chunkLoadable = {
                direction: 'next',
                cursor: lastItem.nextCursor,
                offset: lastItem.offset + lastItem.count,
                per,
            };
        }
    }
    if (lastOffset > endIndex) {
        return null;
    }
    return chunkLoadable;
}
function usePagedCursorInfiniteList_getLoadablePage(state, per, totalCount, targetStartIndex, targetEndIndex) {
    // Determine which page to load. This can be determined using:
    // 1. Using nearest loaded page. This can be used when nearest page is
    //    not far enough (<20 items)
    // 2. Using hint chunks. This can be used when hint chunks covers that
    //    range.
    // 3. Using heuristics. Since we can *usually* assume that pages are divided
    //    by 'per' count, we can skip from nearest loaded page.
    // Note that load request doesn't have to cover all items between
    // startIndex and endIndex - it's fine to load just a part of it -
    // loadMore will be triggered again anyway.
    // Note that endIndex is inclusive; [0, 0] means 0th item must be loaded.
    const startIndex = Math.max(0, targetStartIndex);
    let endIndex = targetEndIndex;
    if (totalCount != null) {
        endIndex = Math.min(endIndex, totalCount - 1);
    }
    if (state.totalCount != null) {
        endIndex = Math.min(endIndex, state.totalCount - 1);
    }
    if ((totalCount != null && startIndex > totalCount) ||
        (state.totalCount != null && startIndex > state.totalCount)) {
        return null;
    }
    const mainLoadable = getLoadablePageImpl(state.chunks, per, 3, startIndex, endIndex);
    if (mainLoadable != null)
        return mainLoadable;
    const hintLoadable = getLoadablePageImpl(state.hintChunks, per, Infinity, startIndex, endIndex);
    if (hintLoadable != null)
        return hintLoadable;
    // Ran out of things to do; Use heuristics maybe?
    // If we have absolutely nothing in the chunks, just load the first page.
    if (state.chunks.length === 0) {
        return {
            cursor: null,
            direction: 'next',
            offset: 0,
            per,
        };
    }
    // In cursor based pagination, this is the only thing we can do - try it
    // again in main chunks state.
    const mainSecondLoadable = getLoadablePageImpl(state.chunks, per, Infinity, startIndex, endIndex);
    if (mainSecondLoadable != null)
        return hintLoadable;
    return null;
}
function usePagedCursorInfiniteList_initPagedInfiniteListState(chunk) {
    if (chunk != null) {
        const chunks = usePagedCursorInfiniteList_insertChunk([], {
            type: 'page',
            prevCursor: chunk.prevCursor,
            nextCursor: chunk.nextCursor,
            offset: chunk.offset ?? 0,
            count: chunk.items.length,
            items: chunk.items,
        });
        const hasNext = chunk.hasNext != null
            ? chunk.hasNext
            : chunk.items.length > 0;
        const afterOffset = (chunk.offset ?? 0) + chunk.items.length;
        return {
            chunks,
            hintChunks: usePagedCursorInfiniteList_mapHintChunks(chunks),
            count: (chunk.offset ?? 0) + chunk.items.length,
            scrolledCount: null,
            totalCount: !hasNext ? afterOffset : null,
            epoch: 0,
            error: null,
        };
    }
    return {
        chunks: [],
        hintChunks: [],
        count: 0,
        scrolledCount: null,
        totalCount: null,
        epoch: 0,
        error: null,
    };
}
function usePagedCursorInfiniteList_pagedInfiniteListReducer(state, action) {
    // eslint-disable-next-line default-case
    switch (action.type) {
        case 'load': {
            // Try to insert the chunk information at the designated offset.
            // If there is any empty space between chunks, insert 'empty' chunk
            // between it.
            // If target offset is already occupied, overwrite over the chunk.
            // TODO Remove any duplicate items if possible to do so
            const { offset, nextCursor, prevCursor, items, hasNext } = action.item;
            const targetOffset = action.targetOffset != null
                ? action.targetOffset
                : offset;
            const outputChunks = usePagedCursorInfiniteList_insertChunk(state.chunks, {
                type: 'page',
                nextCursor,
                prevCursor,
                offset: targetOffset ?? 0,
                count: items.length,
                items,
            }, action.direction);
            const lastChunk = outputChunks[outputChunks.length - 1];
            let nextTotalCount = state.totalCount;
            if (hasNext != null ? !hasNext : items.length === 0) {
                const offset = lastChunk.offset + lastChunk.count;
                nextTotalCount = nextTotalCount != null
                    ? Math.min(nextTotalCount, offset)
                    : offset;
            }
            return {
                ...state,
                chunks: outputChunks,
                hintChunks: usePagedCursorInfiniteList_mapHintChunks(outputChunks),
                count: lastChunk.offset + lastChunk.count,
                totalCount: nextTotalCount,
                epoch: action.isAsync ? state.epoch + 1 : state.epoch,
            };
        }
        case 'end': {
            return {
                ...state,
                totalCount: state.totalCount != null
                    ? Math.min(state.totalCount, action.offset)
                    : action.offset,
                epoch: action.isAsync ? state.epoch + 1 : state.epoch,
            };
        }
        case 'setHint': {
            return {
                ...state,
                hintChunks: action.hintChunks,
                scrolledCount: action.scrolledCount,
            };
        }
        case 'reset': {
            return usePagedCursorInfiniteList_initPagedInfiniteListState();
        }
        case 'error': {
            return { ...state, error: action.error };
        }
        case 'clearError': {
            return { ...state, error: null };
        }
    }
}
function usePagedCursorInfiniteList(tabId, pending, loadMore, getInitialData, per, loadThreshold = 5, 
/**
 * The absolute total count of the items passed from the server. The client
 * will not request any more pages further from this.
 * Note this can be omitted - most pages don't even have totalCount value.
 * When this is omitted, it may send additional requests and therefore
 * a placeholder 'flicker' might be visible when the end of the list is
 * reached.
 */
totalCount) {
    // TODO Reload when location changes
    const initialDataFilled = useRef(false);
    const initialRendered = useRef(false);
    const innerPending = useRef(false);
    const locationChanged = useChanged(tabId);
    const changedEpoch = useRef(0);
    const stateEpoch = useRef(0);
    const displayedRef = useRef([0, 0]);
    const mountedRef = useRef(true);
    const [state, dispatch] = useReducer(usePagedCursorInfiniteList_pagedInfiniteListReducer, undefined, () => usePagedCursorInfiniteList_initPagedInfiniteListState(getInitialData()));
    const stateRef = useRef(state);
    stateRef.current = state;
    if (locationChanged) {
        changedEpoch.current += 1;
        innerPending.current = false;
    }
    // Unmount handler
    useEffect(() => {
        return () => {
            mountedRef.current = false;
        };
    }, []);
    useEffect(() => {
        if (changedEpoch.current > 0) {
            dispatch({ type: 'reset' });
            initialDataFilled.current = false;
            initialRendered.current = false;
        }
        if (tabId != null) {
            // Reload hint data, if available.
            let value;
            try {
                value = JSON.parse(sessionStorage[`plist-hint-${tabId}`] || 'null');
            }
            catch (e) {
                // Do nothing if failed
            }
            if (value != null) {
                dispatch({
                    type: 'setHint',
                    hintChunks: value.hintChunks,
                    scrolledCount: value.scrolledCount,
                });
            }
        }
    }, [changedEpoch.current, tabId]);
    useEffect(() => {
        const prevEpoch = stateEpoch.current;
        if (stateEpoch.current !== state.epoch) {
            stateEpoch.current = state.epoch;
            if (prevEpoch < state.epoch && tabId != null) {
                const timerId = window.setTimeout(() => {
                    try {
                        sessionStorage[`plist-hint-${tabId}`] = JSON.stringify({
                            hintChunks: state.hintChunks,
                            scrolledCount: state.count,
                        });
                    }
                    catch (e) {
                        // Do nothing if failed
                    }
                }, 200);
                return () => window.clearTimeout(timerId);
            }
        }
    }, [state.epoch, tabId, state]);
    const handleGetItem = useMemo(() => {
        // To avoid running binary search every time an item lookup is needed, we
        // memoize last index of the item. This can reduce time complexity from
        // O(m log n) to O(m + log n), with space complexity of O(1).
        let currentItem = null;
        return (index) => {
            // If the index is out of bounds, return null immediately.
            if (index < 0 || index >= state.count) {
                return null;
            }
            // If the index is already within bounds, return the item.
            if (currentItem != null &&
                currentItem.offset <= index &&
                currentItem.offset + currentItem.count > index) {
                if (currentItem.type === 'page') {
                    return currentItem.items[index - currentItem.offset];
                }
                return null;
            }
            // Run a binary search to find the right chunk.
            const chunkIndex = usePagedCursorInfiniteList_getChunkIndex(state.chunks, index);
            if (chunkIndex === -1) {
                return null;
            }
            currentItem = state.chunks[chunkIndex];
            if (currentItem.type === 'page') {
                return currentItem.items[index - currentItem.offset];
            }
            return null;
        };
    }, [state]);
    const handleLoadMore = useCallback(async (startIndex, endIndex) => {
        // Reset the currently displayed index.
        displayedRef.current = [startIndex, endIndex];
        if (innerPending.current || pending || !initialDataFilled.current ||
            stateRef.current.error != null) {
            return;
        }
        let nextPage;
        const currentEpoch = changedEpoch.current;
        // Lock
        innerPending.current = true;
        do {
            if (!mountedRef.current ||
                stateRef.current.error != null ||
                changedEpoch.current !== currentEpoch) {
                break;
            }
            const [start, end] = displayedRef.current;
            nextPage =
                usePagedCursorInfiniteList_getLoadablePage(stateRef.current, per, totalCount, start, end + 1);
            // Digest remaining...
            // If there are anything to load, perform loading.
            if (nextPage == null) {
                break;
            }
            try {
                const result = await loadMore(nextPage);
                if (changedEpoch.current !== currentEpoch) {
                    break;
                }
                dispatch({
                    type: 'load',
                    item: {
                        ...result,
                        offset: result.offset || nextPage.offset,
                    },
                    isAsync: true,
                    direction: nextPage.direction,
                });
            }
            catch (e) {
                const error = e;
                // Handle error
                console.error(`${error.toString()}\n${error.stack}`);
                dispatch({ type: 'error', error });
            }
        } while (nextPage != null);
        // Unlock
        innerPending.current = false;
    }, [pending, loadMore, handleGetItem]);
    useEffect(() => {
        if (!pending) {
            if (!initialDataFilled.current) {
                const chunk = getInitialData();
                if (chunk != null) {
                    if (chunk.items.length === 0) {
                        dispatch({
                            type: 'end',
                            offset: chunk.offset ?? 0,
                            isAsync: true,
                        });
                    }
                    else {
                        dispatch({ type: 'load', item: chunk });
                    }
                }
                initialDataFilled.current = true;
            }
            else if (!initialRendered.current) {
                initialRendered.current = true;
                handleLoadMore(displayedRef.current[0], displayedRef.current[1]);
            }
        }
    }, [pending, getInitialData, handleLoadMore]);
    const handleRowsRendered = useCallback((startIndex, endIndex) => {
        handleLoadMore(startIndex - loadThreshold, endIndex + loadThreshold);
    }, [loadThreshold, handleLoadMore]);
    const reloadData = useCallback(async () => {
        dispatch({ type: 'reset' });
        await handleLoadMore(0, 1);
    }, [handleLoadMore]);
    const handleClearError = useCallback(() => {
        dispatch({ type: 'clearError' });
        handleLoadMore(displayedRef.current[0], displayedRef.current[1]);
    }, [handleLoadMore]);
    const count = Math.max([state.count + per, state.totalCount, totalCount]
        .reduce((p, v) => (v == null ? p : Math.min(v, p)), Infinity), state.scrolledCount ?? 0);
    const loadedCount = state.count;
    return {
        state,
        count: state.error != null ? loadedCount : count,
        loadedCount,
        getItem: handleGetItem,
        loadMore: handleLoadMore,
        handleRowsRendered,
        error: state.error,
        reloadData,
        clearError: handleClearError,
    };
}
//# sourceMappingURL=usePagedCursorInfiniteList.js.map
;// CONCATENATED MODULE: ./node_modules/.pnpm/@bucketplace+ui@1.0.9_@emotion+react@11.13.3_@emotion+styled@11.13.0_react-dom@18.3.1_react@18.3.1_scheduler@0.23.2/node_modules/@bucketplace/ui/lib-esm/hooks/useExpandableView.js

const useExpandableView = ({ ref, }) => {
    const [isWidthOverflowed, setIsWidthOverflowed] = useState(false);
    const [isHeightOverflowed, setIsHeightOverflowed] = useState(false);
    const handleResize = useCallback(() => {
        if (ref.current != null) {
            const { offsetWidth, scrollWidth, offsetHeight, scrollHeight, } = ref.current;
            setIsWidthOverflowed(offsetWidth < scrollWidth);
            setIsHeightOverflowed(offsetHeight < scrollHeight);
        }
    }, [ref]);
    useEffect(() => {
        handleResize();
        document.addEventListener('resize', handleResize);
        return () => {
            document.removeEventListener('resize', handleResize);
        };
    }, [ref]);
    return {
        isWidthOverflowed,
        isHeightOverflowed,
    };
};
//# sourceMappingURL=useExpandableView.js.map
;// CONCATENATED MODULE: ./node_modules/.pnpm/@bucketplace+ui@1.0.9_@emotion+react@11.13.3_@emotion+styled@11.13.0_react-dom@18.3.1_react@18.3.1_scheduler@0.23.2/node_modules/@bucketplace/ui/lib-esm/hooks/index.js





//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ./node_modules/.pnpm/@bucketplace+ui@1.0.9_@emotion+react@11.13.3_@emotion+styled@11.13.0_react-dom@18.3.1_react@18.3.1_scheduler@0.23.2/node_modules/@bucketplace/ui/lib-esm/index.js


//# sourceMappingURL=index.js.map

/***/ }),

/***/ 56738:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "XB": function() { return /* binding */ V; }
/* harmony export */ });
/* unused harmony exports extractVisitorIdFromCookie, formatOsType, getEnv, getExperimentType, initVisitorId, initXPC */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(75271);
/* harmony import */ var querystring__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(97150);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(52676);
/* harmony import */ var react_dom__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(30967);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(81909);
function l(){l=function(){return t};var t={},e=Object.prototype,n=e.hasOwnProperty,r=Object.defineProperty||function(t,e,n){t[e]=n.value},o="function"==typeof Symbol?Symbol:{},i=o.iterator||"@@iterator",a=o.asyncIterator||"@@asyncIterator",c=o.toStringTag||"@@toStringTag";function u(t,e,n){return Object.defineProperty(t,e,{value:n,enumerable:!0,configurable:!0,writable:!0}),t[e]}try{u({},"")}catch(t){u=function(t,e,n){return t[e]=n}}function s(t,e,n,o){var i=e&&e.prototype instanceof f?e:f,a=Object.create(i.prototype),c=new S(o||[]);return r(a,"_invoke",{value:L(t,n,c)}),a}function d(t,e,n){try{return{type:"normal",arg:t.call(e,n)}}catch(t){return{type:"throw",arg:t}}}t.wrap=s;var p={};function f(){}function h(){}function v(){}var m={};u(m,i,(function(){return this}));var g=Object.getPrototypeOf,y=g&&g(g(_([])));y&&y!==e&&n.call(y,i)&&(m=y);var b=v.prototype=f.prototype=Object.create(m);function w(t){["next","throw","return"].forEach((function(e){u(t,e,(function(t){return this._invoke(e,t)}))}))}function x(t,e){function o(r,i,a,c){var u=d(t[r],t,i);if("throw"!==u.type){var s=u.arg,l=s.value;return l&&"object"==typeof l&&n.call(l,"__await")?e.resolve(l.__await).then((function(t){o("next",t,a,c)}),(function(t){o("throw",t,a,c)})):e.resolve(l).then((function(t){s.value=t,a(s)}),(function(t){return o("throw",t,a,c)}))}c(u.arg)}var i;r(this,"_invoke",{value:function(t,n){function r(){return new e((function(e,r){o(t,n,e,r)}))}return i=i?i.then(r,r):r()}})}function L(t,e,n){var r="suspendedStart";return function(o,i){if("executing"===r)throw new Error("Generator is already running");if("completed"===r){if("throw"===o)throw i;return E()}for(n.method=o,n.arg=i;;){var a=n.delegate;if(a){var c=k(a,n);if(c){if(c===p)continue;return c}}if("next"===n.method)n.sent=n._sent=n.arg;else if("throw"===n.method){if("suspendedStart"===r)throw r="completed",n.arg;n.dispatchException(n.arg)}else"return"===n.method&&n.abrupt("return",n.arg);r="executing";var u=d(t,e,n);if("normal"===u.type){if(r=n.done?"completed":"suspendedYield",u.arg===p)continue;return{value:u.arg,done:n.done}}"throw"===u.type&&(r="completed",n.method="throw",n.arg=u.arg)}}}function k(t,e){var n=e.method,r=t.iterator[n];if(void 0===r)return e.delegate=null,"throw"===n&&t.iterator.return&&(e.method="return",e.arg=void 0,k(t,e),"throw"===e.method)||"return"!==n&&(e.method="throw",e.arg=new TypeError("The iterator does not provide a '"+n+"' method")),p;var o=d(r,t.iterator,e.arg);if("throw"===o.type)return e.method="throw",e.arg=o.arg,e.delegate=null,p;var i=o.arg;return i?i.done?(e[t.resultName]=i.value,e.next=t.nextLoc,"return"!==e.method&&(e.method="next",e.arg=void 0),e.delegate=null,p):i:(e.method="throw",e.arg=new TypeError("iterator result is not an object"),e.delegate=null,p)}function O(t){var e={tryLoc:t[0]};1 in t&&(e.catchLoc=t[1]),2 in t&&(e.finallyLoc=t[2],e.afterLoc=t[3]),this.tryEntries.push(e)}function j(t){var e=t.completion||{};e.type="normal",delete e.arg,t.completion=e}function S(t){this.tryEntries=[{tryLoc:"root"}],t.forEach(O,this),this.reset(!0)}function _(t){if(t){var e=t[i];if(e)return e.call(t);if("function"==typeof t.next)return t;if(!isNaN(t.length)){var r=-1,o=function e(){for(;++r<t.length;)if(n.call(t,r))return e.value=t[r],e.done=!1,e;return e.value=void 0,e.done=!0,e};return o.next=o}}return{next:E}}function E(){return{value:void 0,done:!0}}return h.prototype=v,r(b,"constructor",{value:v,configurable:!0}),r(v,"constructor",{value:h,configurable:!0}),h.displayName=u(v,c,"GeneratorFunction"),t.isGeneratorFunction=function(t){var e="function"==typeof t&&t.constructor;return!!e&&(e===h||"GeneratorFunction"===(e.displayName||e.name))},t.mark=function(t){return Object.setPrototypeOf?Object.setPrototypeOf(t,v):(t.__proto__=v,u(t,c,"GeneratorFunction")),t.prototype=Object.create(b),t},t.awrap=function(t){return{__await:t}},w(x.prototype),u(x.prototype,a,(function(){return this})),t.AsyncIterator=x,t.async=function(e,n,r,o,i){void 0===i&&(i=Promise);var a=new x(s(e,n,r,o),i);return t.isGeneratorFunction(n)?a:a.next().then((function(t){return t.done?t.value:a.next()}))},w(b),u(b,c,"Generator"),u(b,i,(function(){return this})),u(b,"toString",(function(){return"[object Generator]"})),t.keys=function(t){var e=Object(t),n=[];for(var r in e)n.push(r);return n.reverse(),function t(){for(;n.length;){var r=n.pop();if(r in e)return t.value=r,t.done=!1,t}return t.done=!0,t}},t.values=_,S.prototype={constructor:S,reset:function(t){if(this.prev=0,this.next=0,this.sent=this._sent=void 0,this.done=!1,this.delegate=null,this.method="next",this.arg=void 0,this.tryEntries.forEach(j),!t)for(var e in this)"t"===e.charAt(0)&&n.call(this,e)&&!isNaN(+e.slice(1))&&(this[e]=void 0)},stop:function(){this.done=!0;var t=this.tryEntries[0].completion;if("throw"===t.type)throw t.arg;return this.rval},dispatchException:function(t){if(this.done)throw t;var e=this;function r(n,r){return a.type="throw",a.arg=t,e.next=n,r&&(e.method="next",e.arg=void 0),!!r}for(var o=this.tryEntries.length-1;o>=0;--o){var i=this.tryEntries[o],a=i.completion;if("root"===i.tryLoc)return r("end");if(i.tryLoc<=this.prev){var c=n.call(i,"catchLoc"),u=n.call(i,"finallyLoc");if(c&&u){if(this.prev<i.catchLoc)return r(i.catchLoc,!0);if(this.prev<i.finallyLoc)return r(i.finallyLoc)}else if(c){if(this.prev<i.catchLoc)return r(i.catchLoc,!0)}else{if(!u)throw new Error("try statement without catch or finally");if(this.prev<i.finallyLoc)return r(i.finallyLoc)}}}},abrupt:function(t,e){for(var r=this.tryEntries.length-1;r>=0;--r){var o=this.tryEntries[r];if(o.tryLoc<=this.prev&&n.call(o,"finallyLoc")&&this.prev<o.finallyLoc){var i=o;break}}i&&("break"===t||"continue"===t)&&i.tryLoc<=e&&e<=i.finallyLoc&&(i=null);var a=i?i.completion:{};return a.type=t,a.arg=e,i?(this.method="next",this.next=i.finallyLoc,p):this.complete(a)},complete:function(t,e){if("throw"===t.type)throw t.arg;return"break"===t.type||"continue"===t.type?this.next=t.arg:"return"===t.type?(this.rval=this.arg=t.arg,this.method="return",this.next="end"):"normal"===t.type&&e&&(this.next=e),p},finish:function(t){for(var e=this.tryEntries.length-1;e>=0;--e){var n=this.tryEntries[e];if(n.finallyLoc===t)return this.complete(n.completion,n.afterLoc),j(n),p}},catch:function(t){for(var e=this.tryEntries.length-1;e>=0;--e){var n=this.tryEntries[e];if(n.tryLoc===t){var r=n.completion;if("throw"===r.type){var o=r.arg;j(n)}return o}}throw new Error("illegal catch attempt")},delegateYield:function(t,e,n){return this.delegate={iterator:_(t),resultName:e,nextLoc:n},"next"===this.method&&(this.arg=void 0),p}},t}function d(t,e,n,r,o,i,a){try{var c=t[i](a),u=c.value}catch(t){return void n(t)}c.done?e(u):Promise.resolve(u).then(r,o)}function p(t){return function(){var e=this,n=arguments;return new Promise((function(r,o){var i=t.apply(e,n);function a(t){d(i,r,o,a,c,"next",t)}function c(t){d(i,r,o,a,c,"throw",t)}a(void 0)}))}}function f(t,e,n){return(e=function(t){var e=function(t,e){if("object"!=typeof t||null===t)return t;var n=t[Symbol.toPrimitive];if(void 0!==n){var r=n.call(t,e||"default");if("object"!=typeof r)return r;throw new TypeError("@@toPrimitive must return a primitive value.")}return("string"===e?String:Number)(t)}(t,"string");return"symbol"==typeof e?e:String(e)}(e))in t?Object.defineProperty(t,e,{value:n,enumerable:!0,configurable:!0,writable:!0}):t[e]=n,t}function h(t,e){return e||(e=t.slice(0)),Object.freeze(Object.defineProperties(t,{raw:{value:Object.freeze(e)}}))}function v(t,e){return function(t){if(Array.isArray(t))return t}(t)||function(t,e){var n=null==t?null:"undefined"!=typeof Symbol&&t[Symbol.iterator]||t["@@iterator"];if(null!=n){var r,o,i,a,c=[],u=!0,s=!1;try{if(i=(n=n.call(t)).next,0===e){if(Object(n)!==n)return;u=!1}else for(;!(u=(r=i.call(n)).done)&&(c.push(r.value),c.length!==e);u=!0);}catch(t){s=!0,o=t}finally{try{if(!u&&null!=n.return&&(a=n.return(),Object(a)!==a))return}finally{if(s)throw o}}return c}}(t,e)||function(t,e){if(!t)return;if("string"==typeof t)return m(t,e);var n=Object.prototype.toString.call(t).slice(8,-1);"Object"===n&&t.constructor&&(n=t.constructor.name);if("Map"===n||"Set"===n)return Array.from(t);if("Arguments"===n||/^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))return m(t,e)}(t,e)||function(){throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")}()}function m(t,e){(null==e||e>t.length)&&(e=t.length);for(var n=0,r=new Array(e);n<e;n++)r[n]=t[n];return r}var g,y,b,w,x,L,k,O={prod:"https://ab-log.datahou.se/log",stage:"https://ab-log.stage.datahou.se/log",qa:"https://ab-log.qa.datahou.se/log"},j={prod:"https://ab-split.datahou.se/v2",stage:"https://ab-split.stage.datahou.se/v2",qa:"https://ab-split.qa.datahou.se/v2"},S="bucket_xpc_log",_="xpcLogDataInserted",E=function(){var t=p(l().mark((function t(e){var n,r,o,i,a,c,u,s,d;return l().wrap((function(t){for(;;)switch(t.prev=t.next){case 0:return n=e.experimentKey,r=e.version,o=e.group,i=e.visitorId,a=e.platform,c=e.platformVersion,u=e.env,s=JSON.stringify({experiment_id:n.toString(),experiment_version:r.toString(),platform:a,platform_version:c,variation_group:o,key:i}),t.prev=2,d=O[u],t.next=6,fetch(d,{method:"POST",headers:{"Content-Type":"application/json"},body:s});case 6:t.next=10;break;case 8:t.prev=8,t.t0=t.catch(2);case 10:case"end":return t.stop()}}),t,null,[[2,8]])})));return function(e){return t.apply(this,arguments)}}(),T=function(t){try{var e=JSON.parse(localStorage.getItem(S));null==e?e=[t]:e.unshift(t),e.length>100&&(e=e.slice(-100)),localStorage.setItem(S,JSON.stringify(e))}catch(t){}},I={},P=function(){var t=p(l().mark((function t(e){var n,r,o,i,a,c,u,s,d,f,h,v;return l().wrap((function(t){for(;;)switch(t.prev=t.next){case 0:if(n=e.experimentKey,r=e.visitorId,o=e.platform,i=e.platformVersion,a=e.env,c=e.type,!((u="".concat(r,"::").concat(n,"::").concat(c,"::").concat(o,"::").concat(i))in I)){t.next=7;break}return t.next=5,I[u];case 5:return s=t.sent,t.abrupt("return",{items:s,cacheHit:!0});case 7:if(d="".concat(j[a],"/").concat(r,"?experiment_id=").concat(n,"&platform=").concat(o),i&&(d+="&platform_version=".concat(i)),f=function(){var t=p(l().mark((function t(){var e,n;return l().wrap((function(t){for(;;)switch(t.prev=t.next){case 0:return t.prev=0,t.next=3,fetch(d,{credentials:"same-origin",headers:{Accept:"application/json","Content-Type":"application/json"}});case 3:return e=t.sent,t.next=6,e.json();case 6:if(n=t.sent,e.ok){t.next=9;break}return t.abrupt("return",[]);case 9:return t.abrupt("return",n);case 12:return t.prev=12,t.t0=t.catch(0),console.error(t.t0),t.abrupt("return",[]);case 16:case"end":return t.stop()}}),t,null,[[0,12]])})));return function(){return t.apply(this,arguments)}}(),"undefined"!=typeof window){t.next=16;break}return t.next=14,f();case 14:return h=t.sent,t.abrupt("return",{items:h,cacheHit:!1});case 16:return I[u]=f(),t.next=19,I[u];case 19:return v=t.sent,t.abrupt("return",{items:v,cacheHit:!1});case 21:case"end":return t.stop()}}),t)})));return function(e){return t.apply(this,arguments)}}(),A="b_visitor_id",C=function(t){var e=Object.fromEntries(t.split(";").map((function(t){return t.trim().split("=")})));return e.b_uuid||e[A]},N=function(t,e){var n;if(t.headers.cookie&&C(t.headers.cookie))return;var r="w".concat(Date.now()).concat("000000".concat(1e6*Math.random()|0).slice(-6)),o="".concat(A,"=").concat(r);t.headers.cookie=t.headers.cookie?"".concat(t.headers.cookie,"; ").concat(o):o;var i=(null===(n=t.headers.host.match(/(ohou\.se|dailyhou\.se)/))||void 0===n?void 0:n[0])||t.headers.host,a=new Date(Date.now()+63072e6).toUTCString();e.setHeader("Set-Cookie","".concat(o,"; Path=/; Domain=").concat(i,"; Expires=").concat(a))},F=function(t){switch(t){case"Android":return"aos";case"iOS":return"ios";case"mWebIOS":case"mWebAndroid":return"mweb";default:return"web"}},D=function(){var t=p(l().mark((function t(e){var n,r,o,i,a,c,u,s,d,p,h,v,m,g,y,b,w,x,L;return l().wrap((function(t){for(;;)switch(t.prev=t.next){case 0:return n=e.env,r=e.experimentKey,o=e.type,i=e.platform,a=void 0===i?"web":i,c=e.platformVersion,u=void 0===c?null:c,s=e.cookie,d=C(s),t.next=4,P({experimentKey:r,visitorId:d,platform:a,platformVersion:u,env:n,type:o});case 4:return p=t.sent,h=p.items,v=p.cacheHit,(null==(m=h.find((function(t){return t.type===o})))?void 0:m.experiment_type)&&(g=m.experiment_name,y=m.experiment_type,b=m.type,w=m.version,x=m.visitor_id,L={experimentKey:r,version:w,group:y,visitorId:x,platform:a,platformVersion:u,env:n},T(Object.assign(Object.assign({},L),{experimentName:g,type:b,cacheHit:v,accessTime:Date.now()})),v||E(L)),t.abrupt("return",f({},r,m.experiment_type));case 10:case"end":return t.stop()}}),t)})));return function(e){return t.apply(this,arguments)}}(),K=function(t){return/(^|\.)(ohou\.se|ohouse.com)$/.test(t)?"prod":/(^|\.)qa-?/.test(t)?"qa":"stage"},V=function(t){var o=t.env,a=t.cookie,c=t.isDisabled,u=void 0!==c&&c,s=t.type,d=t.onRequestEnd,f=t.platform,h=t.platformVersion,m=t.experimentKey,g=v((0,react__WEBPACK_IMPORTED_MODULE_0__.useState)((function(){return{experimentType:void 0,pending:!u,error:void 0}})),2),y=g[0],b=g[1],w=(0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(0);return (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)((function(){var t=function(){var t=querystring__WEBPACK_IMPORTED_MODULE_1__.parse(location.search.slice(1)),e=null,n=null,r=!1;try{r=!!sessionStorage.os_type}catch(t){}if(null!=t.os_type&&""!==t.os_type){e=t.os_type,n=t.version;try{sessionStorage.os_type=t.os_type,sessionStorage.os_version=t.version}catch(t){}}else r?(e=sessionStorage.os_type,n=sessionStorage.os_version):"MacIntel"===navigator.platform&&navigator.maxTouchPoints>1||/iPhone|iPad|iPod/.test(navigator.userAgent)?e="mWebIOS":/Android/.test(navigator.userAgent)&&(e="mWebAndroid");return{osType:e,osVersion:n}}(),e=t.osType,n=t.osVersion,r=null!=f?f:F(e),c=null!=h?h:n,v=++w.current,g=o||function(){if("undefined"==typeof window)throw Error("xpc-sdk: cannot find env in server side");return K(window.location.host)}(),y=a||("undefined"!=typeof window?window.document.cookie:void 0);u?b({experimentType:void 0,pending:!1,error:void 0}):p(l().mark((function t(){var e,n,o;return l().wrap((function(t){for(;;)switch(t.prev=t.next){case 0:return t.prev=0,b((function(t){return Object.assign(Object.assign({},t),{pending:!0})})),t.next=4,D({env:g,cookie:y,type:s,platform:r,platformVersion:c,experimentKey:m});case 4:o=t.sent,e=o[m],t.next=11;break;case 8:t.prev=8,t.t0=t.catch(0),n=t.t0;case 11:v===w.current&&(b((function(t){return Object.assign(Object.assign({},t),{experimentType:null!=e?e:void 0,pending:!1,error:n})})),null==d||d());case 12:case"end":return t.stop()}}),t,null,[[0,8]])})))()}),[u,s,d,f,h,m,o,a]),y},q=function(e){var n=e.selectedLog;return a("div",{children:Object.keys(n).map((function(e){return c(t.Fragment,{children:[a(G,{children:e}),a(H,{children:"".concat(n[e])})]},e)}))})},G=_emotion_styled__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div */ .Z.div(g||(g=h(["\n  padding: 5px 5px 0;\n  border-bottom: 1px dashed gray;\n  font-weight: 700;\n"]))),H=_emotion_styled__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div */ .Z.div(y||(y=h(["\n  padding: 5px;\n  margin-left: 10px;\n"]))),z=[{id:1,label:"실험 타입",value:"type",width:"8%"},{id:2,label:"실험 제목",value:"experimentName",width:"39%"},{id:3,label:"실험 키",value:"experimentKey",width:"10%"},{id:4,label:"결과 그룹",value:"group",width:"8%"},{id:5,label:"시간",value:"accessTime",width:"35%"}],J=function(t){var e=t.logList,n=t.selectedLog,r=t.setSelectedLog,o=n?"".concat(n.type,"::").concat(n.experimentKey,"::").concat(n.accessTime,"::").concat(n.cacheHit):"";return c(M,{children:[a("colgroup",{children:z.map((function(t){var e=t.width,n=t.id;return a("col",{width:e},n)}))}),a(W,{children:a("tr",{children:z.map((function(t){var e=t.label,n=t.id;return a(B,{children:e},n)}))})}),a("tbody",{children:e.map((function(t){var e=function(t){return Object.assign(Object.assign({},t),{accessTime:new Date(t.accessTime).toLocaleString()})}(t),n="".concat(t.type,"::").concat(t.experimentKey,"::").concat(t.accessTime,"::").concat(t.cacheHit);return a(R,Object.assign({onClick:function(){return r(t)},active:o===n},{children:z.map((function(t){var n=t.value,r=t.id;return a(Y,{children:e[n]},r)}))}),n)}))})]})},M=_emotion_styled__WEBPACK_IMPORTED_MODULE_4__/* ["default"].table */ .Z.table(b||(b=h(["\n  width: 100%;\n  position: relative;\n"]))),W=_emotion_styled__WEBPACK_IMPORTED_MODULE_4__/* ["default"].thead */ .Z.thead(w||(w=h(["\n  position: sticky;\n  top: 0;\n  background-color: white;\n"]))),B=_emotion_styled__WEBPACK_IMPORTED_MODULE_4__/* ["default"].th */ .Z.th(x||(x=h(["\n  padding: 5px;\n"]))),R=_emotion_styled__WEBPACK_IMPORTED_MODULE_4__/* ["default"].tr */ .Z.tr(L||(L=h(["\n  cursor: pointer;\n  background-color: #75BDFF;\n  ","\n"])),(function(t){return!t.active&&"\n    background-color: #E9F4FA;\n    &:nth-of-type(2n) {\n      background-color: #F3F3F3;\n    }\n  "})),Y=_emotion_styled__WEBPACK_IMPORTED_MODULE_4__/* ["default"].td */ .Z.td(k||(k=h(["\n  padding: 5px;\n"])));var U,$,X,Q,Z,tt,et,nt,rt=function(){var t=function(t){var n=v(e(arguments.length>1&&void 0!==arguments[1]&&arguments[1]),2),o=n[0],i=n[1];return r((function(){var e=window.matchMedia(t),n=function(){i(e.matches)};return n(),e.addListener(n),function(){e.removeListener(n)}}),[t]),o}("(max-width: 767px)"),i=function(){var t=v(e([]),2),n=t[0],i=t[1],a=o((function(t){var e,n=null===(e=t.detail)||void 0===e?void 0:e.value;null!=n&&i(n)}),[]),c=o((function(){localStorage.removeItem(S),i([])}),[]);return r((function(){var t,e=JSON.parse(null!==(t=localStorage.getItem(S))&&void 0!==t?t:"[]");return null!=e&&i(e),document.addEventListener(_,a,!1),function(){document.removeEventListener(_,a)}}),[a]),{logList:n,deleteLogAll:c}}(),u=i.logList,s=i.deleteLogAll,l=v(e(),2),d=l[0],p=l[1],f=function(t,i){var a=v(e(!1),2),c=a[0],u=a[1],s=v(e(t),2),l=s[0],d=s[1],p=n(null),f=o((function(){u(!0)}),[]),h=o((function(){u(!1)}),[]),m=o((function(t){var e,n;if(c)if("bottom"!==i){var r=null===(n=null==p?void 0:p.current)||void 0===n?void 0:n.getBoundingClientRect().right;(r||0===r)&&d(r-t.clientX)}else{var o=(null===(e=null==p?void 0:p.current)||void 0===e?void 0:e.getBoundingClientRect().bottom)||0;d(o-t.clientY)}}),[c,i]);return r((function(){return window.addEventListener("mousemove",m),window.addEventListener("mouseup",h),function(){window.removeEventListener("mousemove",m),window.removeEventListener("mouseup",h)}}),[m,h]),[p,f,l]}(300,"bottom"),h=v(f,3),m=h[0],g=h[1],y=h[2],b=v(e(!0),2),w=b[0],x=b[1];return u?c(ot,Object.assign({height:y,isOpen:w,ref:m},{children:[!t&&a(it,{onMouseDown:g}),c(at,{children:[a(lt,Object.assign({type:"button",onClick:s},{children:"모두 삭제"})),t&&a(ct,Object.assign({onClick:function(){x((function(t){return!t}))}},{children:w?"🔻":"🔺"}))]}),!(t&&!w)&&c(ut,{children:[a(st,{children:a(J,{logList:u,selectedLog:d,setSelectedLog:p})}),a(dt,{children:d?a(q,{selectedLog:d}):a("div",{children:"자세한 정보를 보시려면 왼쪽 리스트에서 로그를 선택해주세요."})})]})]})):a("div",{children:"loading..."})},ot=_emotion_styled__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div */ .Z.div(U||(U=h(["\n  position: fixed;\n  bottom: 0;\n  left: 0;\n  box-sizing: content-box;\n  width: 100%;\n  background-color: white;\n  z-index: 10000;\n  border-top: 5px solid lightgray;\n  height: ","px;\n  @media(max-width: 767px) {\n    height: "," !important;\n    transition: height .3s ease-in-out;\n  }\n"])),(function(t){return t.height}),(function(t){return t.isOpen?"80%":"50px"})),it=_emotion_styled__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div */ .Z.div($||($=h(["\n  position: absolute; \n  top: -4px;\n  right: 0;\n  width: 100%;\n  height: 4px;\n  background: #C2C7CC;\n  cursor: row-resize;\n  &:hover, \n  &:active {\n    background: #35C5F0;\n  }\n  @media (max-width: 767px) {\n    display: none;\n  }\n"]))),at=_emotion_styled__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div */ .Z.div(X||(X=h(["\n  position: relative;\n  width: 100%;\n  height: 30px;\n  border-bottom: 1px solid lightgray;\n  display: flex;\n  align-items: center;\n"]))),ct=_emotion_styled__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div */ .Z.div(Q||(Q=h(["\n  position: absolute;\n  width: 100%;\n  text-align: center;\n  cursor: pointer;\n"]))),ut=_emotion_styled__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div */ .Z.div(Z||(Z=h(["\n  width: 100%;\n  height: calc(100% - 30px);\n  padding-bottom: 10px;\n  display: flex;\n  @media (max-width: 767px) {\n    flex-direction: column;\n  }\n"]))),st=_emotion_styled__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div */ .Z.div(tt||(tt=h(["\n  flex: 5;\n  overflow-y: scroll;\n"]))),lt=_emotion_styled__WEBPACK_IMPORTED_MODULE_4__/* ["default"].button */ .Z.button(et||(et=h(["\n  background-color: transparent;\n  border: none;\n  cursor: pointer;\n"]))),dt=_emotion_styled__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div */ .Z.div(nt||(nt=h(["\n  flex: 1;\n  min-width: 300px;\n  overflow-y: scroll;\n  padding: 10px;\n  @media (max-width: 767px) {\n    border-top: 2px solid lightgray;\n    flex: 5;\n  }\n"]))),pt=function(){if("true"===i.parse(location.search.slice(1)).bucket_xpc_debug){var t,e=localStorage.setItem;localStorage.setItem=function(t,n){var r=new CustomEvent(_,{detail:{key:S,value:JSON.parse(n)}});t===S&&document.dispatchEvent(r),e.apply(this,[t,n])},(t=document.createElement("div")).id="xpc-debug-tool",t&&u.render(a(rt,{}),t),document.body.appendChild(t)}},ft=function(){"undefined"!=typeof window&&pt()};


/***/ }),

/***/ 5099:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/*

The MIT License (MIT)

Original Library
  - Copyright (c) Marak Squires

Additional functionality
 - Copyright (c) Sindre Sorhus <sindresorhus@gmail.com> (sindresorhus.com)

Permission is hereby granted, free of charge, to any person obtaining a copy
of this software and associated documentation files (the "Software"), to deal
in the Software without restriction, including without limitation the rights
to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
copies of the Software, and to permit persons to whom the Software is
furnished to do so, subject to the following conditions:

The above copyright notice and this permission notice shall be included in
all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
THE SOFTWARE.

*/

var colors = {};
module['exports'] = colors;

colors.themes = {};

var util = __webpack_require__(93585);
var ansiStyles = colors.styles = __webpack_require__(96538);
var defineProps = Object.defineProperties;
var newLineRegex = new RegExp(/[\r\n]+/g);

colors.supportsColor = (__webpack_require__(5981).supportsColor);

if (typeof colors.enabled === 'undefined') {
  colors.enabled = colors.supportsColor() !== false;
}

colors.enable = function() {
  colors.enabled = true;
};

colors.disable = function() {
  colors.enabled = false;
};

colors.stripColors = colors.strip = function(str) {
  return ('' + str).replace(/\x1B\[\d+m/g, '');
};

// eslint-disable-next-line no-unused-vars
var stylize = colors.stylize = function stylize(str, style) {
  if (!colors.enabled) {
    return str+'';
  }

  var styleMap = ansiStyles[style];

  // Stylize should work for non-ANSI styles, too
  if (!styleMap && style in colors) {
    // Style maps like trap operate as functions on strings;
    // they don't have properties like open or close.
    return colors[style](str);
  }

  return styleMap.open + str + styleMap.close;
};

var matchOperatorsRe = /[|\\{}()[\]^$+*?.]/g;
var escapeStringRegexp = function(str) {
  if (typeof str !== 'string') {
    throw new TypeError('Expected a string');
  }
  return str.replace(matchOperatorsRe, '\\$&');
};

function build(_styles) {
  var builder = function builder() {
    return applyStyle.apply(builder, arguments);
  };
  builder._styles = _styles;
  // __proto__ is used because we must return a function, but there is
  // no way to create a function with a different prototype.
  builder.__proto__ = proto;
  return builder;
}

var styles = (function() {
  var ret = {};
  ansiStyles.grey = ansiStyles.gray;
  Object.keys(ansiStyles).forEach(function(key) {
    ansiStyles[key].closeRe =
      new RegExp(escapeStringRegexp(ansiStyles[key].close), 'g');
    ret[key] = {
      get: function() {
        return build(this._styles.concat(key));
      },
    };
  });
  return ret;
})();

var proto = defineProps(function colors() {}, styles);

function applyStyle() {
  var args = Array.prototype.slice.call(arguments);

  var str = args.map(function(arg) {
    // Use weak equality check so we can colorize null/undefined in safe mode
    if (arg != null && arg.constructor === String) {
      return arg;
    } else {
      return util.inspect(arg);
    }
  }).join(' ');

  if (!colors.enabled || !str) {
    return str;
  }

  var newLinesPresent = str.indexOf('\n') != -1;

  var nestedStyles = this._styles;

  var i = nestedStyles.length;
  while (i--) {
    var code = ansiStyles[nestedStyles[i]];
    str = code.open + str.replace(code.closeRe, code.open) + code.close;
    if (newLinesPresent) {
      str = str.replace(newLineRegex, function(match) {
        return code.close + match + code.open;
      });
    }
  }

  return str;
}

colors.setTheme = function(theme) {
  if (typeof theme === 'string') {
    console.log('colors.setTheme now only accepts an object, not a string.  ' +
      'If you are trying to set a theme from a file, it is now your (the ' +
      'caller\'s) responsibility to require the file.  The old syntax ' +
      'looked like colors.setTheme(__dirname + ' +
      '\'/../themes/generic-logging.js\'); The new syntax looks like '+
      'colors.setTheme(require(__dirname + ' +
      '\'/../themes/generic-logging.js\'));');
    return;
  }
  for (var style in theme) {
    (function(style) {
      colors[style] = function(str) {
        if (typeof theme[style] === 'object') {
          var out = str;
          for (var i in theme[style]) {
            out = colors[theme[style][i]](out);
          }
          return out;
        }
        return colors[theme[style]](str);
      };
    })(style);
  }
};

function init() {
  var ret = {};
  Object.keys(styles).forEach(function(name) {
    ret[name] = {
      get: function() {
        return build([name]);
      },
    };
  });
  return ret;
}

var sequencer = function sequencer(map, str) {
  var exploded = str.split('');
  exploded = exploded.map(map);
  return exploded.join('');
};

// custom formatter methods
colors.trap = __webpack_require__(26597);
colors.zalgo = __webpack_require__(58754);

// maps
colors.maps = {};
colors.maps.america = __webpack_require__(94015)(colors);
colors.maps.zebra = __webpack_require__(58561)(colors);
colors.maps.rainbow = __webpack_require__(92356)(colors);
colors.maps.random = __webpack_require__(52618)(colors);

for (var map in colors.maps) {
  (function(map) {
    colors[map] = function(str) {
      return sequencer(colors.maps[map], str);
    };
  })(map);
}

defineProps(colors, init());


/***/ }),

/***/ 26597:
/***/ (function(module) {

module['exports'] = function runTheTrap(text, options) {
  var result = '';
  text = text || 'Run the trap, drop the bass';
  text = text.split('');
  var trap = {
    a: ['\u0040', '\u0104', '\u023a', '\u0245', '\u0394', '\u039b', '\u0414'],
    b: ['\u00df', '\u0181', '\u0243', '\u026e', '\u03b2', '\u0e3f'],
    c: ['\u00a9', '\u023b', '\u03fe'],
    d: ['\u00d0', '\u018a', '\u0500', '\u0501', '\u0502', '\u0503'],
    e: ['\u00cb', '\u0115', '\u018e', '\u0258', '\u03a3', '\u03be', '\u04bc',
      '\u0a6c'],
    f: ['\u04fa'],
    g: ['\u0262'],
    h: ['\u0126', '\u0195', '\u04a2', '\u04ba', '\u04c7', '\u050a'],
    i: ['\u0f0f'],
    j: ['\u0134'],
    k: ['\u0138', '\u04a0', '\u04c3', '\u051e'],
    l: ['\u0139'],
    m: ['\u028d', '\u04cd', '\u04ce', '\u0520', '\u0521', '\u0d69'],
    n: ['\u00d1', '\u014b', '\u019d', '\u0376', '\u03a0', '\u048a'],
    o: ['\u00d8', '\u00f5', '\u00f8', '\u01fe', '\u0298', '\u047a', '\u05dd',
      '\u06dd', '\u0e4f'],
    p: ['\u01f7', '\u048e'],
    q: ['\u09cd'],
    r: ['\u00ae', '\u01a6', '\u0210', '\u024c', '\u0280', '\u042f'],
    s: ['\u00a7', '\u03de', '\u03df', '\u03e8'],
    t: ['\u0141', '\u0166', '\u0373'],
    u: ['\u01b1', '\u054d'],
    v: ['\u05d8'],
    w: ['\u0428', '\u0460', '\u047c', '\u0d70'],
    x: ['\u04b2', '\u04fe', '\u04fc', '\u04fd'],
    y: ['\u00a5', '\u04b0', '\u04cb'],
    z: ['\u01b5', '\u0240'],
  };
  text.forEach(function(c) {
    c = c.toLowerCase();
    var chars = trap[c] || [' '];
    var rand = Math.floor(Math.random() * chars.length);
    if (typeof trap[c] !== 'undefined') {
      result += trap[c][rand];
    } else {
      result += c;
    }
  });
  return result;
};


/***/ }),

/***/ 58754:
/***/ (function(module) {

// please no
module['exports'] = function zalgo(text, options) {
  text = text || '   he is here   ';
  var soul = {
    'up': [
      '̍', '̎', '̄', '̅',
      '̿', '̑', '̆', '̐',
      '͒', '͗', '͑', '̇',
      '̈', '̊', '͂', '̓',
      '̈', '͊', '͋', '͌',
      '̃', '̂', '̌', '͐',
      '̀', '́', '̋', '̏',
      '̒', '̓', '̔', '̽',
      '̉', 'ͣ', 'ͤ', 'ͥ',
      'ͦ', 'ͧ', 'ͨ', 'ͩ',
      'ͪ', 'ͫ', 'ͬ', 'ͭ',
      'ͮ', 'ͯ', '̾', '͛',
      '͆', '̚',
    ],
    'down': [
      '̖', '̗', '̘', '̙',
      '̜', '̝', '̞', '̟',
      '̠', '̤', '̥', '̦',
      '̩', '̪', '̫', '̬',
      '̭', '̮', '̯', '̰',
      '̱', '̲', '̳', '̹',
      '̺', '̻', '̼', 'ͅ',
      '͇', '͈', '͉', '͍',
      '͎', '͓', '͔', '͕',
      '͖', '͙', '͚', '̣',
    ],
    'mid': [
      '̕', '̛', '̀', '́',
      '͘', '̡', '̢', '̧',
      '̨', '̴', '̵', '̶',
      '͜', '͝', '͞',
      '͟', '͠', '͢', '̸',
      '̷', '͡', ' ҉',
    ],
  };
  var all = [].concat(soul.up, soul.down, soul.mid);

  function randomNumber(range) {
    var r = Math.floor(Math.random() * range);
    return r;
  }

  function isChar(character) {
    var bool = false;
    all.filter(function(i) {
      bool = (i === character);
    });
    return bool;
  }


  function heComes(text, options) {
    var result = '';
    var counts;
    var l;
    options = options || {};
    options['up'] =
      typeof options['up'] !== 'undefined' ? options['up'] : true;
    options['mid'] =
      typeof options['mid'] !== 'undefined' ? options['mid'] : true;
    options['down'] =
      typeof options['down'] !== 'undefined' ? options['down'] : true;
    options['size'] =
      typeof options['size'] !== 'undefined' ? options['size'] : 'maxi';
    text = text.split('');
    for (l in text) {
      if (isChar(l)) {
        continue;
      }
      result = result + text[l];
      counts = {'up': 0, 'down': 0, 'mid': 0};
      switch (options.size) {
        case 'mini':
          counts.up = randomNumber(8);
          counts.mid = randomNumber(2);
          counts.down = randomNumber(8);
          break;
        case 'maxi':
          counts.up = randomNumber(16) + 3;
          counts.mid = randomNumber(4) + 1;
          counts.down = randomNumber(64) + 3;
          break;
        default:
          counts.up = randomNumber(8) + 1;
          counts.mid = randomNumber(6) / 2;
          counts.down = randomNumber(8) + 1;
          break;
      }

      var arr = ['up', 'mid', 'down'];
      for (var d in arr) {
        var index = arr[d];
        for (var i = 0; i <= counts[index]; i++) {
          if (options[index]) {
            result = result + soul[index][randomNumber(soul[index].length)];
          }
        }
      }
    }
    return result;
  }
  // don't summon him
  return heComes(text, options);
};



/***/ }),

/***/ 94015:
/***/ (function(module) {

module['exports'] = function(colors) {
  return function(letter, i, exploded) {
    if (letter === ' ') return letter;
    switch (i%3) {
      case 0: return colors.red(letter);
      case 1: return colors.white(letter);
      case 2: return colors.blue(letter);
    }
  };
};


/***/ }),

/***/ 92356:
/***/ (function(module) {

module['exports'] = function(colors) {
  // RoY G BiV
  var rainbowColors = ['red', 'yellow', 'green', 'blue', 'magenta'];
  return function(letter, i, exploded) {
    if (letter === ' ') {
      return letter;
    } else {
      return colors[rainbowColors[i++ % rainbowColors.length]](letter);
    }
  };
};



/***/ }),

/***/ 52618:
/***/ (function(module) {

module['exports'] = function(colors) {
  var available = ['underline', 'inverse', 'grey', 'yellow', 'red', 'green',
    'blue', 'white', 'cyan', 'magenta', 'brightYellow', 'brightRed',
    'brightGreen', 'brightBlue', 'brightWhite', 'brightCyan', 'brightMagenta'];
  return function(letter, i, exploded) {
    return letter === ' ' ? letter :
      colors[
          available[Math.round(Math.random() * (available.length - 2))]
      ](letter);
  };
};


/***/ }),

/***/ 58561:
/***/ (function(module) {

module['exports'] = function(colors) {
  return function(letter, i, exploded) {
    return i % 2 === 0 ? letter : colors.inverse(letter);
  };
};


/***/ }),

/***/ 96538:
/***/ (function(module) {

/*
The MIT License (MIT)

Copyright (c) Sindre Sorhus <sindresorhus@gmail.com> (sindresorhus.com)

Permission is hereby granted, free of charge, to any person obtaining a copy
of this software and associated documentation files (the "Software"), to deal
in the Software without restriction, including without limitation the rights
to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
copies of the Software, and to permit persons to whom the Software is
furnished to do so, subject to the following conditions:

The above copyright notice and this permission notice shall be included in
all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
THE SOFTWARE.

*/

var styles = {};
module['exports'] = styles;

var codes = {
  reset: [0, 0],

  bold: [1, 22],
  dim: [2, 22],
  italic: [3, 23],
  underline: [4, 24],
  inverse: [7, 27],
  hidden: [8, 28],
  strikethrough: [9, 29],

  black: [30, 39],
  red: [31, 39],
  green: [32, 39],
  yellow: [33, 39],
  blue: [34, 39],
  magenta: [35, 39],
  cyan: [36, 39],
  white: [37, 39],
  gray: [90, 39],
  grey: [90, 39],

  brightRed: [91, 39],
  brightGreen: [92, 39],
  brightYellow: [93, 39],
  brightBlue: [94, 39],
  brightMagenta: [95, 39],
  brightCyan: [96, 39],
  brightWhite: [97, 39],

  bgBlack: [40, 49],
  bgRed: [41, 49],
  bgGreen: [42, 49],
  bgYellow: [43, 49],
  bgBlue: [44, 49],
  bgMagenta: [45, 49],
  bgCyan: [46, 49],
  bgWhite: [47, 49],
  bgGray: [100, 49],
  bgGrey: [100, 49],

  bgBrightRed: [101, 49],
  bgBrightGreen: [102, 49],
  bgBrightYellow: [103, 49],
  bgBrightBlue: [104, 49],
  bgBrightMagenta: [105, 49],
  bgBrightCyan: [106, 49],
  bgBrightWhite: [107, 49],

  // legacy styles for colors pre v1.0.0
  blackBG: [40, 49],
  redBG: [41, 49],
  greenBG: [42, 49],
  yellowBG: [43, 49],
  blueBG: [44, 49],
  magentaBG: [45, 49],
  cyanBG: [46, 49],
  whiteBG: [47, 49],

};

Object.keys(codes).forEach(function(key) {
  var val = codes[key];
  var style = styles[key] = [];
  style.open = '\u001b[' + val[0] + 'm';
  style.close = '\u001b[' + val[1] + 'm';
});


/***/ }),

/***/ 56096:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
/* provided dependency */ var process = __webpack_require__(14224);
/*
MIT License

Copyright (c) Sindre Sorhus <sindresorhus@gmail.com> (sindresorhus.com)

Permission is hereby granted, free of charge, to any person obtaining a copy of
this software and associated documentation files (the "Software"), to deal in
the Software without restriction, including without limitation the rights to
use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies
of the Software, and to permit persons to whom the Software is furnished to do
so, subject to the following conditions:

The above copyright notice and this permission notice shall be included in all
copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
SOFTWARE.
*/



module.exports = function(flag, argv) {
  argv = argv || process.argv || [];

  var terminatorPos = argv.indexOf('--');
  var prefix = /^-{1,2}/.test(flag) ? '' : '--';
  var pos = argv.indexOf(prefix + flag);

  return pos !== -1 && (terminatorPos === -1 ? true : pos < terminatorPos);
};


/***/ }),

/***/ 5981:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
/* provided dependency */ var process = __webpack_require__(14224);
/*
The MIT License (MIT)

Copyright (c) Sindre Sorhus <sindresorhus@gmail.com> (sindresorhus.com)

Permission is hereby granted, free of charge, to any person obtaining a copy
of this software and associated documentation files (the "Software"), to deal
in the Software without restriction, including without limitation the rights
to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
copies of the Software, and to permit persons to whom the Software is
furnished to do so, subject to the following conditions:

The above copyright notice and this permission notice shall be included in
all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
THE SOFTWARE.

*/



var os = __webpack_require__(25597);
var hasFlag = __webpack_require__(56096);

var env = process.env;

var forceColor = void 0;
if (hasFlag('no-color') || hasFlag('no-colors') || hasFlag('color=false')) {
  forceColor = false;
} else if (hasFlag('color') || hasFlag('colors') || hasFlag('color=true')
           || hasFlag('color=always')) {
  forceColor = true;
}
if ('FORCE_COLOR' in env) {
  forceColor = env.FORCE_COLOR.length === 0
    || parseInt(env.FORCE_COLOR, 10) !== 0;
}

function translateLevel(level) {
  if (level === 0) {
    return false;
  }

  return {
    level: level,
    hasBasic: true,
    has256: level >= 2,
    has16m: level >= 3,
  };
}

function supportsColor(stream) {
  if (forceColor === false) {
    return 0;
  }

  if (hasFlag('color=16m') || hasFlag('color=full')
      || hasFlag('color=truecolor')) {
    return 3;
  }

  if (hasFlag('color=256')) {
    return 2;
  }

  if (stream && !stream.isTTY && forceColor !== true) {
    return 0;
  }

  var min = forceColor ? 1 : 0;

  if (process.platform === 'win32') {
    // Node.js 7.5.0 is the first version of Node.js to include a patch to
    // libuv that enables 256 color output on Windows. Anything earlier and it
    // won't work. However, here we target Node.js 8 at minimum as it is an LTS
    // release, and Node.js 7 is not. Windows 10 build 10586 is the first
    // Windows release that supports 256 colors. Windows 10 build 14931 is the
    // first release that supports 16m/TrueColor.
    var osRelease = os.release().split('.');
    if (Number(process.versions.node.split('.')[0]) >= 8
        && Number(osRelease[0]) >= 10 && Number(osRelease[2]) >= 10586) {
      return Number(osRelease[2]) >= 14931 ? 3 : 2;
    }

    return 1;
  }

  if ('CI' in env) {
    if (['TRAVIS', 'CIRCLECI', 'APPVEYOR', 'GITLAB_CI'].some(function(sign) {
      return sign in env;
    }) || env.CI_NAME === 'codeship') {
      return 1;
    }

    return min;
  }

  if ('TEAMCITY_VERSION' in env) {
    return (/^(9\.(0*[1-9]\d*)\.|\d{2,}\.)/.test(env.TEAMCITY_VERSION) ? 1 : 0
    );
  }

  if ('TERM_PROGRAM' in env) {
    var version = parseInt((env.TERM_PROGRAM_VERSION || '').split('.')[0], 10);

    switch (env.TERM_PROGRAM) {
      case 'iTerm.app':
        return version >= 3 ? 3 : 2;
      case 'Hyper':
        return 3;
      case 'Apple_Terminal':
        return 2;
      // No default
    }
  }

  if (/-256(color)?$/i.test(env.TERM)) {
    return 2;
  }

  if (/^screen|^xterm|^vt100|^rxvt|color|ansi|cygwin|linux/i.test(env.TERM)) {
    return 1;
  }

  if ('COLORTERM' in env) {
    return 1;
  }

  if (env.TERM === 'dumb') {
    return min;
  }

  return min;
}

function getSupportLevel(stream) {
  var level = supportsColor(stream);
  return translateLevel(level);
}

module.exports = {
  supportsColor: getSupportLevel,
  stdout: getSupportLevel(process.stdout),
  stderr: getSupportLevel(process.stderr),
};


/***/ }),

/***/ 87972:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

//
// Remark: Requiring this file will use the "safe" colors API,
// which will not touch String.prototype.
//
//   var colors = require('colors/safe');
//   colors.red("foo")
//
//
var colors = __webpack_require__(5099);
module['exports'] = colors;


/***/ }),

/***/ 24169:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

//
// Select the correct build version depending on the environment.
//
if (true) {
  module.exports = __webpack_require__(69183);
} else {}


/***/ }),

/***/ 69183:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var create = __webpack_require__(15991);

/**
 * Create a new diagnostics logger.
 *
 * @param {String} namespace The namespace it should enable.
 * @param {Object} options Additional options.
 * @returns {Function} The logger.
 * @public
 */
var diagnostics = create(function prod(namespace, options) {
  options = options || {};
  options.namespace = namespace;
  options.prod = true;
  options.dev = false;

  if (!(options.force || prod.force)) return prod.nope(options);
  return prod.yep(options);
});

//
// Expose the diagnostics logger.
//
module.exports = diagnostics;


/***/ }),

/***/ 15991:
/***/ (function(module) {

/**
 * Contains all configured adapters for the given environment.
 *
 * @type {Array}
 * @public
 */
var adapters = [];

/**
 * Contains all modifier functions.
 *
 * @typs {Array}
 * @public
 */
var modifiers = [];

/**
 * Our default logger.
 *
 * @public
 */
var logger = function devnull() {};

/**
 * Register a new adapter that will used to find environments.
 *
 * @param {Function} adapter A function that will return the possible env.
 * @returns {Boolean} Indication of a successful add.
 * @public
 */
function use(adapter) {
  if (~adapters.indexOf(adapter)) return false;

  adapters.push(adapter);
  return true;
}

/**
 * Assign a new log method.
 *
 * @param {Function} custom The log method.
 * @public
 */
function set(custom) {
  logger = custom;
}

/**
 * Check if the namespace is allowed by any of our adapters.
 *
 * @param {String} namespace The namespace that needs to be enabled
 * @returns {Boolean|Promise} Indication if the namespace is enabled by our adapters.
 * @public
 */
function enabled(namespace) {
  var async = [];

  for (var i = 0; i < adapters.length; i++) {
    if (adapters[i].async) {
      async.push(adapters[i]);
      continue;
    }

    if (adapters[i](namespace)) return true;
  }

  if (!async.length) return false;

  //
  // Now that we know that we Async functions, we know we run in an ES6
  // environment and can use all the API's that they offer, in this case
  // we want to return a Promise so that we can `await` in React-Native
  // for an async adapter.
  //
  return new Promise(function pinky(resolve) {
    Promise.all(
      async.map(function prebind(fn) {
        return fn(namespace);
      })
    ).then(function resolved(values) {
      resolve(values.some(Boolean));
    });
  });
}

/**
 * Add a new message modifier to the debugger.
 *
 * @param {Function} fn Modification function.
 * @returns {Boolean} Indication of a successful add.
 * @public
 */
function modify(fn) {
  if (~modifiers.indexOf(fn)) return false;

  modifiers.push(fn);
  return true;
}

/**
 * Write data to the supplied logger.
 *
 * @param {Object} meta Meta information about the log.
 * @param {Array} args Arguments for console.log.
 * @public
 */
function write() {
  logger.apply(logger, arguments);
}

/**
 * Process the message with the modifiers.
 *
 * @param {Mixed} message The message to be transformed by modifers.
 * @returns {String} Transformed message.
 * @public
 */
function process(message) {
  for (var i = 0; i < modifiers.length; i++) {
    message = modifiers[i].apply(modifiers[i], arguments);
  }

  return message;
}

/**
 * Introduce options to the logger function.
 *
 * @param {Function} fn Calback function.
 * @param {Object} options Properties to introduce on fn.
 * @returns {Function} The passed function
 * @public
 */
function introduce(fn, options) {
  var has = Object.prototype.hasOwnProperty;

  for (var key in options) {
    if (has.call(options, key)) {
      fn[key] = options[key];
    }
  }

  return fn;
}

/**
 * Nope, we're not allowed to write messages.
 *
 * @returns {Boolean} false
 * @public
 */
function nope(options) {
  options.enabled = false;
  options.modify = modify;
  options.set = set;
  options.use = use;

  return introduce(function diagnopes() {
    return false;
  }, options);
}

/**
 * Yep, we're allowed to write debug messages.
 *
 * @param {Object} options The options for the process.
 * @returns {Function} The function that does the logging.
 * @public
 */
function yep(options) {
  /**
   * The function that receives the actual debug information.
   *
   * @returns {Boolean} indication that we're logging.
   * @public
   */
  function diagnostics() {
    var args = Array.prototype.slice.call(arguments, 0);

    write.call(write, options, process(args, options));
    return true;
  }

  options.enabled = true;
  options.modify = modify;
  options.set = set;
  options.use = use;

  return introduce(diagnostics, options);
}

/**
 * Simple helper function to introduce various of helper methods to our given
 * diagnostics function.
 *
 * @param {Function} diagnostics The diagnostics function.
 * @returns {Function} diagnostics
 * @public
 */
module.exports = function create(diagnostics) {
  diagnostics.introduce = introduce;
  diagnostics.enabled = enabled;
  diagnostics.process = process;
  diagnostics.modify = modify;
  diagnostics.write = write;
  diagnostics.nope = nope;
  diagnostics.yep = yep;
  diagnostics.set = set;
  diagnostics.use = use;

  return diagnostics;
}


/***/ }),

/***/ 93491:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ createCache; }
});

;// CONCATENATED MODULE: ./node_modules/.pnpm/@emotion+sheet@1.4.0/node_modules/@emotion/sheet/dist/emotion-sheet.esm.js
var isDevelopment = false;

/*

Based off glamor's StyleSheet, thanks Sunil ❤️

high performance StyleSheet for css-in-js systems

- uses multiple style tags behind the scenes for millions of rules
- uses `insertRule` for appending in production for *much* faster performance

// usage

import { StyleSheet } from '@emotion/sheet'

let styleSheet = new StyleSheet({ key: '', container: document.head })

styleSheet.insert('#box { border: 1px solid red; }')
- appends a css rule into the stylesheet

styleSheet.flush()
- empties the stylesheet of all its contents

*/

function sheetForTag(tag) {
  if (tag.sheet) {
    return tag.sheet;
  } // this weirdness brought to you by firefox

  /* istanbul ignore next */


  for (var i = 0; i < document.styleSheets.length; i++) {
    if (document.styleSheets[i].ownerNode === tag) {
      return document.styleSheets[i];
    }
  } // this function should always return with a value
  // TS can't understand it though so we make it stop complaining here


  return undefined;
}

function createStyleElement(options) {
  var tag = document.createElement('style');
  tag.setAttribute('data-emotion', options.key);

  if (options.nonce !== undefined) {
    tag.setAttribute('nonce', options.nonce);
  }

  tag.appendChild(document.createTextNode(''));
  tag.setAttribute('data-s', '');
  return tag;
}

var StyleSheet = /*#__PURE__*/function () {
  // Using Node instead of HTMLElement since container may be a ShadowRoot
  function StyleSheet(options) {
    var _this = this;

    this._insertTag = function (tag) {
      var before;

      if (_this.tags.length === 0) {
        if (_this.insertionPoint) {
          before = _this.insertionPoint.nextSibling;
        } else if (_this.prepend) {
          before = _this.container.firstChild;
        } else {
          before = _this.before;
        }
      } else {
        before = _this.tags[_this.tags.length - 1].nextSibling;
      }

      _this.container.insertBefore(tag, before);

      _this.tags.push(tag);
    };

    this.isSpeedy = options.speedy === undefined ? !isDevelopment : options.speedy;
    this.tags = [];
    this.ctr = 0;
    this.nonce = options.nonce; // key is the value of the data-emotion attribute, it's used to identify different sheets

    this.key = options.key;
    this.container = options.container;
    this.prepend = options.prepend;
    this.insertionPoint = options.insertionPoint;
    this.before = null;
  }

  var _proto = StyleSheet.prototype;

  _proto.hydrate = function hydrate(nodes) {
    nodes.forEach(this._insertTag);
  };

  _proto.insert = function insert(rule) {
    // the max length is how many rules we have per style tag, it's 65000 in speedy mode
    // it's 1 in dev because we insert source maps that map a single rule to a location
    // and you can only have one source map per style tag
    if (this.ctr % (this.isSpeedy ? 65000 : 1) === 0) {
      this._insertTag(createStyleElement(this));
    }

    var tag = this.tags[this.tags.length - 1];

    if (this.isSpeedy) {
      var sheet = sheetForTag(tag);

      try {
        // this is the ultrafast version, works across browsers
        // the big drawback is that the css won't be editable in devtools
        sheet.insertRule(rule, sheet.cssRules.length);
      } catch (e) {
      }
    } else {
      tag.appendChild(document.createTextNode(rule));
    }

    this.ctr++;
  };

  _proto.flush = function flush() {
    this.tags.forEach(function (tag) {
      var _tag$parentNode;

      return (_tag$parentNode = tag.parentNode) == null ? void 0 : _tag$parentNode.removeChild(tag);
    });
    this.tags = [];
    this.ctr = 0;
  };

  return StyleSheet;
}();



;// CONCATENATED MODULE: ./node_modules/.pnpm/stylis@4.2.0/node_modules/stylis/src/Utility.js
/**
 * @param {number}
 * @return {number}
 */
var abs = Math.abs

/**
 * @param {number}
 * @return {string}
 */
var Utility_from = String.fromCharCode

/**
 * @param {object}
 * @return {object}
 */
var Utility_assign = Object.assign

/**
 * @param {string} value
 * @param {number} length
 * @return {number}
 */
function hash (value, length) {
	return Utility_charat(value, 0) ^ 45 ? (((((((length << 2) ^ Utility_charat(value, 0)) << 2) ^ Utility_charat(value, 1)) << 2) ^ Utility_charat(value, 2)) << 2) ^ Utility_charat(value, 3) : 0
}

/**
 * @param {string} value
 * @return {string}
 */
function trim (value) {
	return value.trim()
}

/**
 * @param {string} value
 * @param {RegExp} pattern
 * @return {string?}
 */
function Utility_match (value, pattern) {
	return (value = pattern.exec(value)) ? value[0] : value
}

/**
 * @param {string} value
 * @param {(string|RegExp)} pattern
 * @param {string} replacement
 * @return {string}
 */
function Utility_replace (value, pattern, replacement) {
	return value.replace(pattern, replacement)
}

/**
 * @param {string} value
 * @param {string} search
 * @return {number}
 */
function indexof (value, search) {
	return value.indexOf(search)
}

/**
 * @param {string} value
 * @param {number} index
 * @return {number}
 */
function Utility_charat (value, index) {
	return value.charCodeAt(index) | 0
}

/**
 * @param {string} value
 * @param {number} begin
 * @param {number} end
 * @return {string}
 */
function Utility_substr (value, begin, end) {
	return value.slice(begin, end)
}

/**
 * @param {string} value
 * @return {number}
 */
function Utility_strlen (value) {
	return value.length
}

/**
 * @param {any[]} value
 * @return {number}
 */
function Utility_sizeof (value) {
	return value.length
}

/**
 * @param {any} value
 * @param {any[]} array
 * @return {any}
 */
function Utility_append (value, array) {
	return array.push(value), value
}

/**
 * @param {string[]} array
 * @param {function} callback
 * @return {string}
 */
function Utility_combine (array, callback) {
	return array.map(callback).join('')
}

;// CONCATENATED MODULE: ./node_modules/.pnpm/stylis@4.2.0/node_modules/stylis/src/Tokenizer.js


var line = 1
var column = 1
var Tokenizer_length = 0
var position = 0
var character = 0
var characters = ''

/**
 * @param {string} value
 * @param {object | null} root
 * @param {object | null} parent
 * @param {string} type
 * @param {string[] | string} props
 * @param {object[] | string} children
 * @param {number} length
 */
function node (value, root, parent, type, props, children, length) {
	return {value: value, root: root, parent: parent, type: type, props: props, children: children, line: line, column: column, length: length, return: ''}
}

/**
 * @param {object} root
 * @param {object} props
 * @return {object}
 */
function Tokenizer_copy (root, props) {
	return Utility_assign(node('', null, null, '', null, null, 0), root, {length: -root.length}, props)
}

/**
 * @return {number}
 */
function Tokenizer_char () {
	return character
}

/**
 * @return {number}
 */
function prev () {
	character = position > 0 ? Utility_charat(characters, --position) : 0

	if (column--, character === 10)
		column = 1, line--

	return character
}

/**
 * @return {number}
 */
function next () {
	character = position < Tokenizer_length ? Utility_charat(characters, position++) : 0

	if (column++, character === 10)
		column = 1, line++

	return character
}

/**
 * @return {number}
 */
function peek () {
	return Utility_charat(characters, position)
}

/**
 * @return {number}
 */
function caret () {
	return position
}

/**
 * @param {number} begin
 * @param {number} end
 * @return {string}
 */
function slice (begin, end) {
	return Utility_substr(characters, begin, end)
}

/**
 * @param {number} type
 * @return {number}
 */
function token (type) {
	switch (type) {
		// \0 \t \n \r \s whitespace token
		case 0: case 9: case 10: case 13: case 32:
			return 5
		// ! + , / > @ ~ isolate token
		case 33: case 43: case 44: case 47: case 62: case 64: case 126:
		// ; { } breakpoint token
		case 59: case 123: case 125:
			return 4
		// : accompanied token
		case 58:
			return 3
		// " ' ( [ opening delimit token
		case 34: case 39: case 40: case 91:
			return 2
		// ) ] closing delimit token
		case 41: case 93:
			return 1
	}

	return 0
}

/**
 * @param {string} value
 * @return {any[]}
 */
function alloc (value) {
	return line = column = 1, Tokenizer_length = Utility_strlen(characters = value), position = 0, []
}

/**
 * @param {any} value
 * @return {any}
 */
function dealloc (value) {
	return characters = '', value
}

/**
 * @param {number} type
 * @return {string}
 */
function delimit (type) {
	return trim(slice(position - 1, delimiter(type === 91 ? type + 2 : type === 40 ? type + 1 : type)))
}

/**
 * @param {string} value
 * @return {string[]}
 */
function Tokenizer_tokenize (value) {
	return dealloc(tokenizer(alloc(value)))
}

/**
 * @param {number} type
 * @return {string}
 */
function whitespace (type) {
	while (character = peek())
		if (character < 33)
			next()
		else
			break

	return token(type) > 2 || token(character) > 3 ? '' : ' '
}

/**
 * @param {string[]} children
 * @return {string[]}
 */
function tokenizer (children) {
	while (next())
		switch (token(character)) {
			case 0: append(identifier(position - 1), children)
				break
			case 2: append(delimit(character), children)
				break
			default: append(from(character), children)
		}

	return children
}

/**
 * @param {number} index
 * @param {number} count
 * @return {string}
 */
function escaping (index, count) {
	while (--count && next())
		// not 0-9 A-F a-f
		if (character < 48 || character > 102 || (character > 57 && character < 65) || (character > 70 && character < 97))
			break

	return slice(index, caret() + (count < 6 && peek() == 32 && next() == 32))
}

/**
 * @param {number} type
 * @return {number}
 */
function delimiter (type) {
	while (next())
		switch (character) {
			// ] ) " '
			case type:
				return position
			// " '
			case 34: case 39:
				if (type !== 34 && type !== 39)
					delimiter(character)
				break
			// (
			case 40:
				if (type === 41)
					delimiter(type)
				break
			// \
			case 92:
				next()
				break
		}

	return position
}

/**
 * @param {number} type
 * @param {number} index
 * @return {number}
 */
function commenter (type, index) {
	while (next())
		// //
		if (type + character === 47 + 10)
			break
		// /*
		else if (type + character === 42 + 42 && peek() === 47)
			break

	return '/*' + slice(index, position - 1) + '*' + Utility_from(type === 47 ? type : next())
}

/**
 * @param {number} index
 * @return {string}
 */
function identifier (index) {
	while (!token(peek()))
		next()

	return slice(index, position)
}

;// CONCATENATED MODULE: ./node_modules/.pnpm/stylis@4.2.0/node_modules/stylis/src/Enum.js
var Enum_MS = '-ms-'
var Enum_MOZ = '-moz-'
var Enum_WEBKIT = '-webkit-'

var COMMENT = 'comm'
var Enum_RULESET = 'rule'
var Enum_DECLARATION = 'decl'

var PAGE = '@page'
var MEDIA = '@media'
var IMPORT = '@import'
var CHARSET = '@charset'
var VIEWPORT = '@viewport'
var SUPPORTS = '@supports'
var DOCUMENT = '@document'
var NAMESPACE = '@namespace'
var Enum_KEYFRAMES = '@keyframes'
var FONT_FACE = '@font-face'
var COUNTER_STYLE = '@counter-style'
var FONT_FEATURE_VALUES = '@font-feature-values'
var LAYER = '@layer'

;// CONCATENATED MODULE: ./node_modules/.pnpm/stylis@4.2.0/node_modules/stylis/src/Serializer.js



/**
 * @param {object[]} children
 * @param {function} callback
 * @return {string}
 */
function Serializer_serialize (children, callback) {
	var output = ''
	var length = Utility_sizeof(children)

	for (var i = 0; i < length; i++)
		output += callback(children[i], i, children, callback) || ''

	return output
}

/**
 * @param {object} element
 * @param {number} index
 * @param {object[]} children
 * @param {function} callback
 * @return {string}
 */
function stringify (element, index, children, callback) {
	switch (element.type) {
		case LAYER: if (element.children.length) break
		case IMPORT: case Enum_DECLARATION: return element.return = element.return || element.value
		case COMMENT: return ''
		case Enum_KEYFRAMES: return element.return = element.value + '{' + Serializer_serialize(element.children, callback) + '}'
		case Enum_RULESET: element.value = element.props.join(',')
	}

	return Utility_strlen(children = Serializer_serialize(element.children, callback)) ? element.return = element.value + '{' + children + '}' : ''
}

;// CONCATENATED MODULE: ./node_modules/.pnpm/stylis@4.2.0/node_modules/stylis/src/Middleware.js






/**
 * @param {function[]} collection
 * @return {function}
 */
function middleware (collection) {
	var length = Utility_sizeof(collection)

	return function (element, index, children, callback) {
		var output = ''

		for (var i = 0; i < length; i++)
			output += collection[i](element, index, children, callback) || ''

		return output
	}
}

/**
 * @param {function} callback
 * @return {function}
 */
function rulesheet (callback) {
	return function (element) {
		if (!element.root)
			if (element = element.return)
				callback(element)
	}
}

/**
 * @param {object} element
 * @param {number} index
 * @param {object[]} children
 * @param {function} callback
 */
function prefixer (element, index, children, callback) {
	if (element.length > -1)
		if (!element.return)
			switch (element.type) {
				case DECLARATION: element.return = prefix(element.value, element.length, children)
					return
				case KEYFRAMES:
					return serialize([copy(element, {value: replace(element.value, '@', '@' + WEBKIT)})], callback)
				case RULESET:
					if (element.length)
						return combine(element.props, function (value) {
							switch (match(value, /(::plac\w+|:read-\w+)/)) {
								// :read-(only|write)
								case ':read-only': case ':read-write':
									return serialize([copy(element, {props: [replace(value, /:(read-\w+)/, ':' + MOZ + '$1')]})], callback)
								// :placeholder
								case '::placeholder':
									return serialize([
										copy(element, {props: [replace(value, /:(plac\w+)/, ':' + WEBKIT + 'input-$1')]}),
										copy(element, {props: [replace(value, /:(plac\w+)/, ':' + MOZ + '$1')]}),
										copy(element, {props: [replace(value, /:(plac\w+)/, MS + 'input-$1')]})
									], callback)
							}

							return ''
						})
			}
}

/**
 * @param {object} element
 * @param {number} index
 * @param {object[]} children
 */
function namespace (element) {
	switch (element.type) {
		case RULESET:
			element.props = element.props.map(function (value) {
				return combine(tokenize(value), function (value, index, children) {
					switch (charat(value, 0)) {
						// \f
						case 12:
							return substr(value, 1, strlen(value))
						// \0 ( + > ~
						case 0: case 40: case 43: case 62: case 126:
							return value
						// :
						case 58:
							if (children[++index] === 'global')
								children[index] = '', children[++index] = '\f' + substr(children[index], index = 1, -1)
						// \s
						case 32:
							return index === 1 ? '' : value
						default:
							switch (index) {
								case 0: element = value
									return sizeof(children) > 1 ? '' : value
								case index = sizeof(children) - 1: case 2:
									return index === 2 ? value + element + element : value + element
								default:
									return value
							}
					}
				})
			})
	}
}

;// CONCATENATED MODULE: ./node_modules/.pnpm/stylis@4.2.0/node_modules/stylis/src/Parser.js




/**
 * @param {string} value
 * @return {object[]}
 */
function compile (value) {
	return dealloc(parse('', null, null, null, [''], value = alloc(value), 0, [0], value))
}

/**
 * @param {string} value
 * @param {object} root
 * @param {object?} parent
 * @param {string[]} rule
 * @param {string[]} rules
 * @param {string[]} rulesets
 * @param {number[]} pseudo
 * @param {number[]} points
 * @param {string[]} declarations
 * @return {object}
 */
function parse (value, root, parent, rule, rules, rulesets, pseudo, points, declarations) {
	var index = 0
	var offset = 0
	var length = pseudo
	var atrule = 0
	var property = 0
	var previous = 0
	var variable = 1
	var scanning = 1
	var ampersand = 1
	var character = 0
	var type = ''
	var props = rules
	var children = rulesets
	var reference = rule
	var characters = type

	while (scanning)
		switch (previous = character, character = next()) {
			// (
			case 40:
				if (previous != 108 && Utility_charat(characters, length - 1) == 58) {
					if (indexof(characters += Utility_replace(delimit(character), '&', '&\f'), '&\f') != -1)
						ampersand = -1
					break
				}
			// " ' [
			case 34: case 39: case 91:
				characters += delimit(character)
				break
			// \t \n \r \s
			case 9: case 10: case 13: case 32:
				characters += whitespace(previous)
				break
			// \
			case 92:
				characters += escaping(caret() - 1, 7)
				continue
			// /
			case 47:
				switch (peek()) {
					case 42: case 47:
						Utility_append(comment(commenter(next(), caret()), root, parent), declarations)
						break
					default:
						characters += '/'
				}
				break
			// {
			case 123 * variable:
				points[index++] = Utility_strlen(characters) * ampersand
			// } ; \0
			case 125 * variable: case 59: case 0:
				switch (character) {
					// \0 }
					case 0: case 125: scanning = 0
					// ;
					case 59 + offset: if (ampersand == -1) characters = Utility_replace(characters, /\f/g, '')
						if (property > 0 && (Utility_strlen(characters) - length))
							Utility_append(property > 32 ? declaration(characters + ';', rule, parent, length - 1) : declaration(Utility_replace(characters, ' ', '') + ';', rule, parent, length - 2), declarations)
						break
					// @ ;
					case 59: characters += ';'
					// { rule/at-rule
					default:
						Utility_append(reference = ruleset(characters, root, parent, index, offset, rules, points, type, props = [], children = [], length), rulesets)

						if (character === 123)
							if (offset === 0)
								parse(characters, root, reference, reference, props, rulesets, length, points, children)
							else
								switch (atrule === 99 && Utility_charat(characters, 3) === 110 ? 100 : atrule) {
									// d l m s
									case 100: case 108: case 109: case 115:
										parse(value, reference, reference, rule && Utility_append(ruleset(value, reference, reference, 0, 0, rules, points, type, rules, props = [], length), children), rules, children, length, points, rule ? props : children)
										break
									default:
										parse(characters, reference, reference, reference, [''], children, 0, points, children)
								}
				}

				index = offset = property = 0, variable = ampersand = 1, type = characters = '', length = pseudo
				break
			// :
			case 58:
				length = 1 + Utility_strlen(characters), property = previous
			default:
				if (variable < 1)
					if (character == 123)
						--variable
					else if (character == 125 && variable++ == 0 && prev() == 125)
						continue

				switch (characters += Utility_from(character), character * variable) {
					// &
					case 38:
						ampersand = offset > 0 ? 1 : (characters += '\f', -1)
						break
					// ,
					case 44:
						points[index++] = (Utility_strlen(characters) - 1) * ampersand, ampersand = 1
						break
					// @
					case 64:
						// -
						if (peek() === 45)
							characters += delimit(next())

						atrule = peek(), offset = length = Utility_strlen(type = characters += identifier(caret())), character++
						break
					// -
					case 45:
						if (previous === 45 && Utility_strlen(characters) == 2)
							variable = 0
				}
		}

	return rulesets
}

/**
 * @param {string} value
 * @param {object} root
 * @param {object?} parent
 * @param {number} index
 * @param {number} offset
 * @param {string[]} rules
 * @param {number[]} points
 * @param {string} type
 * @param {string[]} props
 * @param {string[]} children
 * @param {number} length
 * @return {object}
 */
function ruleset (value, root, parent, index, offset, rules, points, type, props, children, length) {
	var post = offset - 1
	var rule = offset === 0 ? rules : ['']
	var size = Utility_sizeof(rule)

	for (var i = 0, j = 0, k = 0; i < index; ++i)
		for (var x = 0, y = Utility_substr(value, post + 1, post = abs(j = points[i])), z = value; x < size; ++x)
			if (z = trim(j > 0 ? rule[x] + ' ' + y : Utility_replace(y, /&\f/g, rule[x])))
				props[k++] = z

	return node(value, root, parent, offset === 0 ? Enum_RULESET : type, props, children, length)
}

/**
 * @param {number} value
 * @param {object} root
 * @param {object?} parent
 * @return {object}
 */
function comment (value, root, parent) {
	return node(value, root, parent, COMMENT, Utility_from(Tokenizer_char()), Utility_substr(value, 2, -2), 0)
}

/**
 * @param {string} value
 * @param {object} root
 * @param {object?} parent
 * @param {number} length
 * @return {object}
 */
function declaration (value, root, parent, length) {
	return node(value, root, parent, Enum_DECLARATION, Utility_substr(value, 0, length), Utility_substr(value, length + 1, -1), length)
}

;// CONCATENATED MODULE: ./node_modules/.pnpm/@emotion+cache@11.13.1/node_modules/@emotion/cache/dist/emotion-cache.browser.esm.js





var identifierWithPointTracking = function identifierWithPointTracking(begin, points, index) {
  var previous = 0;
  var character = 0;

  while (true) {
    previous = character;
    character = peek(); // &\f

    if (previous === 38 && character === 12) {
      points[index] = 1;
    }

    if (token(character)) {
      break;
    }

    next();
  }

  return slice(begin, position);
};

var toRules = function toRules(parsed, points) {
  // pretend we've started with a comma
  var index = -1;
  var character = 44;

  do {
    switch (token(character)) {
      case 0:
        // &\f
        if (character === 38 && peek() === 12) {
          // this is not 100% correct, we don't account for literal sequences here - like for example quoted strings
          // stylis inserts \f after & to know when & where it should replace this sequence with the context selector
          // and when it should just concatenate the outer and inner selectors
          // it's very unlikely for this sequence to actually appear in a different context, so we just leverage this fact here
          points[index] = 1;
        }

        parsed[index] += identifierWithPointTracking(position - 1, points, index);
        break;

      case 2:
        parsed[index] += delimit(character);
        break;

      case 4:
        // comma
        if (character === 44) {
          // colon
          parsed[++index] = peek() === 58 ? '&\f' : '';
          points[index] = parsed[index].length;
          break;
        }

      // fallthrough

      default:
        parsed[index] += Utility_from(character);
    }
  } while (character = next());

  return parsed;
};

var getRules = function getRules(value, points) {
  return dealloc(toRules(alloc(value), points));
}; // WeakSet would be more appropriate, but only WeakMap is supported in IE11


var fixedElements = /* #__PURE__ */new WeakMap();
var compat = function compat(element) {
  if (element.type !== 'rule' || !element.parent || // positive .length indicates that this rule contains pseudo
  // negative .length indicates that this rule has been already prefixed
  element.length < 1) {
    return;
  }

  var value = element.value,
      parent = element.parent;
  var isImplicitRule = element.column === parent.column && element.line === parent.line;

  while (parent.type !== 'rule') {
    parent = parent.parent;
    if (!parent) return;
  } // short-circuit for the simplest case


  if (element.props.length === 1 && value.charCodeAt(0) !== 58
  /* colon */
  && !fixedElements.get(parent)) {
    return;
  } // if this is an implicitly inserted rule (the one eagerly inserted at the each new nested level)
  // then the props has already been manipulated beforehand as they that array is shared between it and its "rule parent"


  if (isImplicitRule) {
    return;
  }

  fixedElements.set(element, true);
  var points = [];
  var rules = getRules(value, points);
  var parentRules = parent.props;

  for (var i = 0, k = 0; i < rules.length; i++) {
    for (var j = 0; j < parentRules.length; j++, k++) {
      element.props[k] = points[i] ? rules[i].replace(/&\f/g, parentRules[j]) : parentRules[j] + " " + rules[i];
    }
  }
};
var removeLabel = function removeLabel(element) {
  if (element.type === 'decl') {
    var value = element.value;

    if ( // charcode for l
    value.charCodeAt(0) === 108 && // charcode for b
    value.charCodeAt(2) === 98) {
      // this ignores label
      element["return"] = '';
      element.value = '';
    }
  }
};

/* eslint-disable no-fallthrough */

function emotion_cache_browser_esm_prefix(value, length) {
  switch (hash(value, length)) {
    // color-adjust
    case 5103:
      return Enum_WEBKIT + 'print-' + value + value;
    // animation, animation-(delay|direction|duration|fill-mode|iteration-count|name|play-state|timing-function)

    case 5737:
    case 4201:
    case 3177:
    case 3433:
    case 1641:
    case 4457:
    case 2921: // text-decoration, filter, clip-path, backface-visibility, column, box-decoration-break

    case 5572:
    case 6356:
    case 5844:
    case 3191:
    case 6645:
    case 3005: // mask, mask-image, mask-(mode|clip|size), mask-(repeat|origin), mask-position, mask-composite,

    case 6391:
    case 5879:
    case 5623:
    case 6135:
    case 4599:
    case 4855: // background-clip, columns, column-(count|fill|gap|rule|rule-color|rule-style|rule-width|span|width)

    case 4215:
    case 6389:
    case 5109:
    case 5365:
    case 5621:
    case 3829:
      return Enum_WEBKIT + value + value;
    // appearance, user-select, transform, hyphens, text-size-adjust

    case 5349:
    case 4246:
    case 4810:
    case 6968:
    case 2756:
      return Enum_WEBKIT + value + Enum_MOZ + value + Enum_MS + value + value;
    // flex, flex-direction

    case 6828:
    case 4268:
      return Enum_WEBKIT + value + Enum_MS + value + value;
    // order

    case 6165:
      return Enum_WEBKIT + value + Enum_MS + 'flex-' + value + value;
    // align-items

    case 5187:
      return Enum_WEBKIT + value + Utility_replace(value, /(\w+).+(:[^]+)/, Enum_WEBKIT + 'box-$1$2' + Enum_MS + 'flex-$1$2') + value;
    // align-self

    case 5443:
      return Enum_WEBKIT + value + Enum_MS + 'flex-item-' + Utility_replace(value, /flex-|-self/, '') + value;
    // align-content

    case 4675:
      return Enum_WEBKIT + value + Enum_MS + 'flex-line-pack' + Utility_replace(value, /align-content|flex-|-self/, '') + value;
    // flex-shrink

    case 5548:
      return Enum_WEBKIT + value + Enum_MS + Utility_replace(value, 'shrink', 'negative') + value;
    // flex-basis

    case 5292:
      return Enum_WEBKIT + value + Enum_MS + Utility_replace(value, 'basis', 'preferred-size') + value;
    // flex-grow

    case 6060:
      return Enum_WEBKIT + 'box-' + Utility_replace(value, '-grow', '') + Enum_WEBKIT + value + Enum_MS + Utility_replace(value, 'grow', 'positive') + value;
    // transition

    case 4554:
      return Enum_WEBKIT + Utility_replace(value, /([^-])(transform)/g, '$1' + Enum_WEBKIT + '$2') + value;
    // cursor

    case 6187:
      return Utility_replace(Utility_replace(Utility_replace(value, /(zoom-|grab)/, Enum_WEBKIT + '$1'), /(image-set)/, Enum_WEBKIT + '$1'), value, '') + value;
    // background, background-image

    case 5495:
    case 3959:
      return Utility_replace(value, /(image-set\([^]*)/, Enum_WEBKIT + '$1' + '$`$1');
    // justify-content

    case 4968:
      return Utility_replace(Utility_replace(value, /(.+:)(flex-)?(.*)/, Enum_WEBKIT + 'box-pack:$3' + Enum_MS + 'flex-pack:$3'), /s.+-b[^;]+/, 'justify') + Enum_WEBKIT + value + value;
    // (margin|padding)-inline-(start|end)

    case 4095:
    case 3583:
    case 4068:
    case 2532:
      return Utility_replace(value, /(.+)-inline(.+)/, Enum_WEBKIT + '$1$2') + value;
    // (min|max)?(width|height|inline-size|block-size)

    case 8116:
    case 7059:
    case 5753:
    case 5535:
    case 5445:
    case 5701:
    case 4933:
    case 4677:
    case 5533:
    case 5789:
    case 5021:
    case 4765:
      // stretch, max-content, min-content, fill-available
      if (Utility_strlen(value) - 1 - length > 6) switch (Utility_charat(value, length + 1)) {
        // (m)ax-content, (m)in-content
        case 109:
          // -
          if (Utility_charat(value, length + 4) !== 45) break;
        // (f)ill-available, (f)it-content

        case 102:
          return Utility_replace(value, /(.+:)(.+)-([^]+)/, '$1' + Enum_WEBKIT + '$2-$3' + '$1' + Enum_MOZ + (Utility_charat(value, length + 3) == 108 ? '$3' : '$2-$3')) + value;
        // (s)tretch

        case 115:
          return ~indexof(value, 'stretch') ? emotion_cache_browser_esm_prefix(Utility_replace(value, 'stretch', 'fill-available'), length) + value : value;
      }
      break;
    // position: sticky

    case 4949:
      // (s)ticky?
      if (Utility_charat(value, length + 1) !== 115) break;
    // display: (flex|inline-flex)

    case 6444:
      switch (Utility_charat(value, Utility_strlen(value) - 3 - (~indexof(value, '!important') && 10))) {
        // stic(k)y
        case 107:
          return Utility_replace(value, ':', ':' + Enum_WEBKIT) + value;
        // (inline-)?fl(e)x

        case 101:
          return Utility_replace(value, /(.+:)([^;!]+)(;|!.+)?/, '$1' + Enum_WEBKIT + (Utility_charat(value, 14) === 45 ? 'inline-' : '') + 'box$3' + '$1' + Enum_WEBKIT + '$2$3' + '$1' + Enum_MS + '$2box$3') + value;
      }

      break;
    // writing-mode

    case 5936:
      switch (Utility_charat(value, length + 11)) {
        // vertical-l(r)
        case 114:
          return Enum_WEBKIT + value + Enum_MS + Utility_replace(value, /[svh]\w+-[tblr]{2}/, 'tb') + value;
        // vertical-r(l)

        case 108:
          return Enum_WEBKIT + value + Enum_MS + Utility_replace(value, /[svh]\w+-[tblr]{2}/, 'tb-rl') + value;
        // horizontal(-)tb

        case 45:
          return Enum_WEBKIT + value + Enum_MS + Utility_replace(value, /[svh]\w+-[tblr]{2}/, 'lr') + value;
      }

      return Enum_WEBKIT + value + Enum_MS + value + value;
  }

  return value;
}

var emotion_cache_browser_esm_prefixer = function prefixer(element, index, children, callback) {
  if (element.length > -1) if (!element["return"]) switch (element.type) {
    case Enum_DECLARATION:
      element["return"] = emotion_cache_browser_esm_prefix(element.value, element.length);
      break;

    case Enum_KEYFRAMES:
      return Serializer_serialize([Tokenizer_copy(element, {
        value: Utility_replace(element.value, '@', '@' + Enum_WEBKIT)
      })], callback);

    case Enum_RULESET:
      if (element.length) return Utility_combine(element.props, function (value) {
        switch (Utility_match(value, /(::plac\w+|:read-\w+)/)) {
          // :read-(only|write)
          case ':read-only':
          case ':read-write':
            return Serializer_serialize([Tokenizer_copy(element, {
              props: [Utility_replace(value, /:(read-\w+)/, ':' + Enum_MOZ + '$1')]
            })], callback);
          // :placeholder

          case '::placeholder':
            return Serializer_serialize([Tokenizer_copy(element, {
              props: [Utility_replace(value, /:(plac\w+)/, ':' + Enum_WEBKIT + 'input-$1')]
            }), Tokenizer_copy(element, {
              props: [Utility_replace(value, /:(plac\w+)/, ':' + Enum_MOZ + '$1')]
            }), Tokenizer_copy(element, {
              props: [Utility_replace(value, /:(plac\w+)/, Enum_MS + 'input-$1')]
            })], callback);
        }

        return '';
      });
  }
};

var defaultStylisPlugins = [emotion_cache_browser_esm_prefixer];

var createCache = function
  /*: EmotionCache */
createCache(options
/*: Options */
) {
  var key = options.key;

  if (key === 'css') {
    var ssrStyles = document.querySelectorAll("style[data-emotion]:not([data-s])"); // get SSRed styles out of the way of React's hydration
    // document.head is a safe place to move them to(though note document.head is not necessarily the last place they will be)
    // note this very very intentionally targets all style elements regardless of the key to ensure
    // that creating a cache works inside of render of a React component

    Array.prototype.forEach.call(ssrStyles, function (node
    /*: HTMLStyleElement */
    ) {
      // we want to only move elements which have a space in the data-emotion attribute value
      // because that indicates that it is an Emotion 11 server-side rendered style elements
      // while we will already ignore Emotion 11 client-side inserted styles because of the :not([data-s]) part in the selector
      // Emotion 10 client-side inserted styles did not have data-s (but importantly did not have a space in their data-emotion attributes)
      // so checking for the space ensures that loading Emotion 11 after Emotion 10 has inserted some styles
      // will not result in the Emotion 10 styles being destroyed
      var dataEmotionAttribute = node.getAttribute('data-emotion');

      if (dataEmotionAttribute.indexOf(' ') === -1) {
        return;
      }

      document.head.appendChild(node);
      node.setAttribute('data-s', '');
    });
  }

  var stylisPlugins = options.stylisPlugins || defaultStylisPlugins;

  var inserted = {};
  var container;
  /* : Node */

  var nodesToHydrate = [];

  {
    container = options.container || document.head;
    Array.prototype.forEach.call( // this means we will ignore elements which don't have a space in them which
    // means that the style elements we're looking at are only Emotion 11 server-rendered style elements
    document.querySelectorAll("style[data-emotion^=\"" + key + " \"]"), function (node
    /*: HTMLStyleElement */
    ) {
      var attrib = node.getAttribute("data-emotion").split(' ');

      for (var i = 1; i < attrib.length; i++) {
        inserted[attrib[i]] = true;
      }

      nodesToHydrate.push(node);
    });
  }

  var _insert;
  /*: (
  selector: string,
  serialized: SerializedStyles,
  sheet: StyleSheet,
  shouldCache: boolean
  ) => string | void */


  var omnipresentPlugins = [compat, removeLabel];

  {
    var currentSheet;
    var finalizingPlugins = [stringify, rulesheet(function (rule) {
      currentSheet.insert(rule);
    })];
    var serializer = middleware(omnipresentPlugins.concat(stylisPlugins, finalizingPlugins));

    var stylis = function stylis(styles) {
      return Serializer_serialize(compile(styles), serializer);
    };

    _insert = function
      /*: void */
    insert(selector
    /*: string */
    , serialized
    /*: SerializedStyles */
    , sheet
    /*: StyleSheet */
    , shouldCache
    /*: boolean */
    ) {
      currentSheet = sheet;

      stylis(selector ? selector + "{" + serialized.styles + "}" : serialized.styles);

      if (shouldCache) {
        cache.inserted[serialized.name] = true;
      }
    };
  }

  var cache
  /*: EmotionCache */
  = {
    key: key,
    sheet: new StyleSheet({
      key: key,
      container: container,
      nonce: options.nonce,
      speedy: options.speedy,
      prepend: options.prepend,
      insertionPoint: options.insertionPoint
    }),
    nonce: options.nonce,
    inserted: inserted,
    registered: {},
    insert: _insert
  };
  cache.sheet.hydrate(nodesToHydrate);
  return cache;
};




/***/ }),

/***/ 2366:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ isPropValid; }
/* harmony export */ });
/* harmony import */ var _emotion_memoize__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(36154);


// eslint-disable-next-line no-undef
var reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|disableRemotePlayback|download|draggable|encType|enterKeyHint|fetchpriority|fetchPriority|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/; // https://esbench.com/bench/5bfee68a4cd7e6009ef61d23

var isPropValid = /* #__PURE__ */(0,_emotion_memoize__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(function (prop) {
  return reactPropsRegex.test(prop) || prop.charCodeAt(0) === 111
  /* o */
  && prop.charCodeAt(1) === 110
  /* n */
  && prop.charCodeAt(2) < 91;
}
/* Z+1 */
);




/***/ }),

/***/ 36154:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ memoize; }
/* harmony export */ });
function memoize(fn) {
  var cache = Object.create(null);
  return function (arg) {
    if (cache[arg] === undefined) cache[arg] = fn(arg);
    return cache[arg];
  };
}




/***/ }),

/***/ 57834:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "E": function() { return /* binding */ Emotion$1; },
  "T": function() { return /* binding */ ThemeContext; },
  "a": function() { return /* binding */ ThemeProvider; },
  "c": function() { return /* binding */ createEmotionProps; },
  "h": function() { return /* binding */ hasOwn; },
  "i": function() { return /* binding */ isDevelopment; },
  "u": function() { return /* binding */ useTheme; },
  "w": function() { return /* binding */ withEmotionCache; }
});

// UNUSED EXPORTS: C, _, b

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.3.1/node_modules/react/index.js
var react = __webpack_require__(75271);
// EXTERNAL MODULE: ./node_modules/.pnpm/@emotion+cache@11.13.1/node_modules/@emotion/cache/dist/emotion-cache.browser.esm.js + 7 modules
var emotion_cache_browser_esm = __webpack_require__(93491);
// EXTERNAL MODULE: ./node_modules/.pnpm/@babel+runtime@7.26.0/node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(2053);
;// CONCATENATED MODULE: ./node_modules/.pnpm/@emotion+weak-memoize@0.4.0/node_modules/@emotion/weak-memoize/dist/emotion-weak-memoize.esm.js
var weakMemoize = function weakMemoize(func) {
  var cache = new WeakMap();
  return function (arg) {
    if (cache.has(arg)) {
      // Use non-null assertion because we just checked that the cache `has` it
      // This allows us to remove `undefined` from the return value
      return cache.get(arg);
    }

    var ret = func(arg);
    cache.set(arg, ret);
    return ret;
  };
};



// EXTERNAL MODULE: ./node_modules/.pnpm/@emotion+utils@1.4.1/node_modules/@emotion/utils/dist/emotion-utils.browser.esm.js
var emotion_utils_browser_esm = __webpack_require__(53757);
// EXTERNAL MODULE: ./node_modules/.pnpm/@emotion+serialize@1.3.2/node_modules/@emotion/serialize/dist/emotion-serialize.esm.js + 2 modules
var emotion_serialize_esm = __webpack_require__(54969);
// EXTERNAL MODULE: ./node_modules/.pnpm/@emotion+use-insertion-effect-with-fallbacks@1.1.0_react@18.3.1/node_modules/@emotion/use-insertion-effect-with-fallbacks/dist/emotion-use-insertion-effect-with-fallbacks.browser.esm.js
var emotion_use_insertion_effect_with_fallbacks_browser_esm = __webpack_require__(28368);
;// CONCATENATED MODULE: ./node_modules/.pnpm/@emotion+react@11.13.3_@types+react@18.3.12_react@18.3.1/node_modules/@emotion/react/dist/emotion-element-5486c51c.browser.esm.js










var isDevelopment = false;

/* import { type EmotionCache } from '@emotion/utils' */
var EmotionCacheContext
/*: React.Context<EmotionCache | null> */
= /* #__PURE__ */react.createContext( // we're doing this to avoid preconstruct's dead code elimination in this one case
// because this module is primarily intended for the browser and node
// but it's also required in react native and similar environments sometimes
// and we could have a special build just for that
// but this is much easier and the native packages
// might use a different theme context in the future anyway
typeof HTMLElement !== 'undefined' ? /* #__PURE__ */(0,emotion_cache_browser_esm/* default */.Z)({
  key: 'css'
}) : null);

var CacheProvider = EmotionCacheContext.Provider;
var __unsafe_useEmotionCache = function useEmotionCache()
/*: EmotionCache | null*/
{
  return useContext(EmotionCacheContext);
};

var withEmotionCache = function withEmotionCache
/* <Props, Ref: React.Ref<*>> */
(func
/*: (props: Props, cache: EmotionCache, ref: Ref) => React.Node */
)
/*: React.AbstractComponent<Props> */
{
  return /*#__PURE__*/(0,react.forwardRef)(function (props
  /*: Props */
  , ref
  /*: Ref */
  ) {
    // the cache will never be null in the browser
    var cache = (0,react.useContext)(EmotionCacheContext);
    return func(props, cache, ref);
  });
};

var ThemeContext = /* #__PURE__ */react.createContext({});

var useTheme = function useTheme() {
  return react.useContext(ThemeContext);
};

var getTheme = function getTheme(outerTheme
/*: Object */
, theme
/*: Object | (Object => Object) */
) {
  if (typeof theme === 'function') {
    var mergedTheme = theme(outerTheme);

    return mergedTheme;
  }

  return (0,esm_extends/* default */.Z)({}, outerTheme, theme);
};

var createCacheWithTheme = /* #__PURE__ */weakMemoize(function (outerTheme) {
  return weakMemoize(function (theme) {
    return getTheme(outerTheme, theme);
  });
});
/*
type ThemeProviderProps = {
  theme: Object | (Object => Object),
  children: React.Node
}
*/

var ThemeProvider = function ThemeProvider(props
/*: ThemeProviderProps */
) {
  var theme = react.useContext(ThemeContext);

  if (props.theme !== theme) {
    theme = createCacheWithTheme(theme)(props.theme);
  }

  return /*#__PURE__*/react.createElement(ThemeContext.Provider, {
    value: theme
  }, props.children);
};
function withTheme
/* <Config: {}> */
(Component
/*: React.AbstractComponent<Config> */
)
/*: React.AbstractComponent<$Diff<Config, { theme: Object }>> */
{
  var componentName = Component.displayName || Component.name || 'Component';

  var render = function render(props, ref) {
    var theme = React.useContext(ThemeContext);
    return /*#__PURE__*/React.createElement(Component, _extends({
      theme: theme,
      ref: ref
    }, props));
  };

  var WithTheme = /*#__PURE__*/React.forwardRef(render);
  WithTheme.displayName = "WithTheme(" + componentName + ")";
  return hoistNonReactStatics(WithTheme, Component);
}

var hasOwn = {}.hasOwnProperty;

var typePropName = '__EMOTION_TYPE_PLEASE_DO_NOT_USE__';
var createEmotionProps = function createEmotionProps(type
/*: React.ElementType */
, props
/*: Object */
) {

  var newProps
  /*: any */
  = {};

  for (var key in props) {
    if (hasOwn.call(props, key)) {
      newProps[key] = props[key];
    }
  }

  newProps[typePropName] = type; // Runtime labeling is an opt-in feature because:

  return newProps;
};

var Insertion = function Insertion(_ref) {
  var cache = _ref.cache,
      serialized = _ref.serialized,
      isStringTag = _ref.isStringTag;
  (0,emotion_utils_browser_esm/* registerStyles */.hC)(cache, serialized, isStringTag);
  (0,emotion_use_insertion_effect_with_fallbacks_browser_esm/* useInsertionEffectAlwaysWithSyncFallback */.L)(function () {
    return (0,emotion_utils_browser_esm/* insertStyles */.My)(cache, serialized, isStringTag);
  });

  return null;
};

var Emotion = /* #__PURE__ */withEmotionCache(
/* <any, any> */
function (props, cache, ref) {
  var cssProp = props.css; // so that using `css` from `emotion` and passing the result to the css prop works
  // not passing the registered cache to serializeStyles because it would
  // make certain babel optimisations not possible

  if (typeof cssProp === 'string' && cache.registered[cssProp] !== undefined) {
    cssProp = cache.registered[cssProp];
  }

  var WrappedComponent = props[typePropName];
  var registeredStyles = [cssProp];
  var className = '';

  if (typeof props.className === 'string') {
    className = (0,emotion_utils_browser_esm/* getRegisteredStyles */.fp)(cache.registered, registeredStyles, props.className);
  } else if (props.className != null) {
    className = props.className + " ";
  }

  var serialized = (0,emotion_serialize_esm/* serializeStyles */.O)(registeredStyles, undefined, react.useContext(ThemeContext));

  className += cache.key + "-" + serialized.name;
  var newProps = {};

  for (var key in props) {
    if (hasOwn.call(props, key) && key !== 'css' && key !== typePropName && (!isDevelopment )) {
      newProps[key] = props[key];
    }
  }

  newProps.className = className;

  if (ref) {
    newProps.ref = ref;
  }

  return /*#__PURE__*/react.createElement(react.Fragment, null, /*#__PURE__*/react.createElement(Insertion, {
    cache: cache,
    serialized: serialized,
    isStringTag: typeof WrappedComponent === 'string'
  }), /*#__PURE__*/react.createElement(WrappedComponent, newProps));
});

var Emotion$1 = Emotion;




/***/ }),

/***/ 52814:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "F4": function() { return /* binding */ keyframes; },
/* harmony export */   "az": function() { return /* binding */ jsx; },
/* harmony export */   "iv": function() { return /* binding */ css; },
/* harmony export */   "ms": function() { return /* binding */ ClassNames; }
/* harmony export */ });
/* unused harmony exports Global, jsx */
/* harmony import */ var _emotion_element_5486c51c_browser_esm_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(57834);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(75271);
/* harmony import */ var _emotion_utils__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(53757);
/* harmony import */ var _emotion_use_insertion_effect_with_fallbacks__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(28368);
/* harmony import */ var _emotion_serialize__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(54969);
/* harmony import */ var _emotion_cache__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(93491);
/* harmony import */ var hoist_non_react_statics__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(72535);
/* harmony import */ var hoist_non_react_statics__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(hoist_non_react_statics__WEBPACK_IMPORTED_MODULE_4__);












var jsx
/*: typeof React.createElement */
= function jsx
/*: typeof React.createElement */
(type
/*: React.ElementType */
, props
/*: Object */
) {
  var args = arguments;

  if (props == null || !_emotion_element_5486c51c_browser_esm_js__WEBPACK_IMPORTED_MODULE_5__.h.call(props, 'css')) {
    return react__WEBPACK_IMPORTED_MODULE_0__.createElement.apply(undefined, args);
  }

  var argsLength = args.length;
  var createElementArgArray = new Array(argsLength);
  createElementArgArray[0] = _emotion_element_5486c51c_browser_esm_js__WEBPACK_IMPORTED_MODULE_5__.E;
  createElementArgArray[1] = (0,_emotion_element_5486c51c_browser_esm_js__WEBPACK_IMPORTED_MODULE_5__.c)(type, props);

  for (var i = 2; i < argsLength; i++) {
    createElementArgArray[i] = args[i];
  }

  return react__WEBPACK_IMPORTED_MODULE_0__.createElement.apply(null, createElementArgArray);
};

// initial render from browser, insertBefore context.sheet.tags[0] or if a style hasn't been inserted there yet, appendChild
// initial client-side render from SSR, use place of hydrating tag

var Global
/*: React.AbstractComponent<
GlobalProps
> */
= /* #__PURE__ */(/* unused pure expression or super */ null && (withEmotionCache(function (props
/*: GlobalProps */
, cache) {

  var styles = props.styles;
  var serialized = serializeStyles([styles], undefined, React.useContext(ThemeContext));
  // but it is based on a constant that will never change at runtime
  // it's effectively like having two implementations and switching them out
  // so it's not actually breaking anything


  var sheetRef = React.useRef();
  useInsertionEffectWithLayoutFallback(function () {
    var key = cache.key + "-global"; // use case of https://github.com/emotion-js/emotion/issues/2675

    var sheet = new cache.sheet.constructor({
      key: key,
      nonce: cache.sheet.nonce,
      container: cache.sheet.container,
      speedy: cache.sheet.isSpeedy
    });
    var rehydrating = false;
    var node
    /*: HTMLStyleElement | null*/
    = document.querySelector("style[data-emotion=\"" + key + " " + serialized.name + "\"]");

    if (cache.sheet.tags.length) {
      sheet.before = cache.sheet.tags[0];
    }

    if (node !== null) {
      rehydrating = true; // clear the hash so this node won't be recognizable as rehydratable by other <Global/>s

      node.setAttribute('data-emotion', key);
      sheet.hydrate([node]);
    }

    sheetRef.current = [sheet, rehydrating];
    return function () {
      sheet.flush();
    };
  }, [cache]);
  useInsertionEffectWithLayoutFallback(function () {
    var sheetRefCurrent = sheetRef.current;
    var sheet = sheetRefCurrent[0],
        rehydrating = sheetRefCurrent[1];

    if (rehydrating) {
      sheetRefCurrent[1] = false;
      return;
    }

    if (serialized.next !== undefined) {
      // insert keyframes
      insertStyles(cache, serialized.next, true);
    }

    if (sheet.tags.length) {
      // if this doesn't exist then it will be null so the style element will be appended
      var element = sheet.tags[sheet.tags.length - 1].nextElementSibling;
      sheet.before = element;
      sheet.flush();
    }

    cache.insert("", serialized, sheet, false);
  }, [cache, serialized.name]);
  return null;
})));

/* import type { Interpolation, SerializedStyles } from '@emotion/utils' */

function css()
/*: SerializedStyles */
{
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  return (0,_emotion_serialize__WEBPACK_IMPORTED_MODULE_2__/* .serializeStyles */ .O)(args);
}

/*
type Keyframes = {|
  name: string,
  styles: string,
  anim: 1,
  toString: () => string
|} & string
*/

var keyframes = function
  /*: Keyframes */
keyframes() {
  var insertable = css.apply(void 0, arguments);
  var name = "animation-" + insertable.name;
  return {
    name: name,
    styles: "@keyframes " + name + "{" + insertable.styles + "}",
    anim: 1,
    toString: function toString() {
      return "_EMO_" + this.name + "_" + this.styles + "_EMO_";
    }
  };
};

/*
type ClassNameArg =
  | string
  | boolean
  | { [key: string]: boolean }
  | Array<ClassNameArg>
  | null
  | void
*/

var classnames = function
  /*: string */
classnames(args
/*: Array<ClassNameArg> */
) {
  var len = args.length;
  var i = 0;
  var cls = '';

  for (; i < len; i++) {
    var arg = args[i];
    if (arg == null) continue;
    var toAdd = void 0;

    switch (typeof arg) {
      case 'boolean':
        break;

      case 'object':
        {
          if (Array.isArray(arg)) {
            toAdd = classnames(arg);
          } else {

            toAdd = '';

            for (var k in arg) {
              if (arg[k] && k) {
                toAdd && (toAdd += ' ');
                toAdd += k;
              }
            }
          }

          break;
        }

      default:
        {
          toAdd = arg;
        }
    }

    if (toAdd) {
      cls && (cls += ' ');
      cls += toAdd;
    }
  }

  return cls;
};

function merge(registered
/*: Object */
, css
/*: (...args: Array<any>) => string */
, className
/*: string */
) {
  var registeredStyles = [];
  var rawClassName = (0,_emotion_utils__WEBPACK_IMPORTED_MODULE_6__/* .getRegisteredStyles */ .fp)(registered, registeredStyles, className);

  if (registeredStyles.length < 2) {
    return className;
  }

  return rawClassName + css(registeredStyles);
}

var Insertion = function Insertion(_ref) {
  var cache = _ref.cache,
      serializedArr = _ref.serializedArr;
  (0,_emotion_use_insertion_effect_with_fallbacks__WEBPACK_IMPORTED_MODULE_1__/* .useInsertionEffectAlwaysWithSyncFallback */ .L)(function () {

    for (var i = 0; i < serializedArr.length; i++) {
      (0,_emotion_utils__WEBPACK_IMPORTED_MODULE_6__/* .insertStyles */ .My)(cache, serializedArr[i], false);
    }
  });

  return null;
};
/*
type Props = {
  children: ({
    css: (...args: any) => string,
    cx: (...args: Array<ClassNameArg>) => string,
    theme: Object
  }) => React.Node
} */


var ClassNames
/*: React.AbstractComponent<Props>*/
= /* #__PURE__ */(0,_emotion_element_5486c51c_browser_esm_js__WEBPACK_IMPORTED_MODULE_5__.w)(function (props, cache) {
  var hasRendered = false;
  var serializedArr = [];

  var css = function css() {
    if (hasRendered && _emotion_element_5486c51c_browser_esm_js__WEBPACK_IMPORTED_MODULE_5__.i) {
      throw new Error('css can only be used during render');
    }

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var serialized = (0,_emotion_serialize__WEBPACK_IMPORTED_MODULE_2__/* .serializeStyles */ .O)(args, cache.registered);
    serializedArr.push(serialized); // registration has to happen here as the result of this might get consumed by `cx`

    (0,_emotion_utils__WEBPACK_IMPORTED_MODULE_6__/* .registerStyles */ .hC)(cache, serialized, false);
    return cache.key + "-" + serialized.name;
  };

  var cx = function cx() {
    if (hasRendered && _emotion_element_5486c51c_browser_esm_js__WEBPACK_IMPORTED_MODULE_5__.i) {
      throw new Error('cx can only be used during render');
    }

    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    return merge(cache.registered, css, classnames(args));
  };

  var content = {
    css: css,
    cx: cx,
    theme: react__WEBPACK_IMPORTED_MODULE_0__.useContext(_emotion_element_5486c51c_browser_esm_js__WEBPACK_IMPORTED_MODULE_5__.T)
  };
  var ele = props.children(content);
  hasRendered = true;
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(Insertion, {
    cache: cache,
    serializedArr: serializedArr
  }), ele);
});




/***/ }),

/***/ 83128:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "BX": function() { return /* binding */ jsxs; },
/* harmony export */   "HY": function() { return /* binding */ Fragment; },
/* harmony export */   "tZ": function() { return /* binding */ jsx; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52676);
/* harmony import */ var _dist_emotion_element_5486c51c_browser_esm_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(57834);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(75271);
/* harmony import */ var _emotion_cache__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(93491);
/* harmony import */ var hoist_non_react_statics__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(72535);
/* harmony import */ var hoist_non_react_statics__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(hoist_non_react_statics__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _emotion_serialize__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(54969);
/* harmony import */ var _emotion_use_insertion_effect_with_fallbacks__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(28368);












var Fragment = react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment;
function jsx(type, props, key) {
  if (!_dist_emotion_element_5486c51c_browser_esm_js__WEBPACK_IMPORTED_MODULE_6__.h.call(props, 'css')) {
    return react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx(type, props, key);
  }

  return react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx(_dist_emotion_element_5486c51c_browser_esm_js__WEBPACK_IMPORTED_MODULE_6__.E, (0,_dist_emotion_element_5486c51c_browser_esm_js__WEBPACK_IMPORTED_MODULE_6__.c)(type, props), key);
}
function jsxs(type, props, key) {
  if (!_dist_emotion_element_5486c51c_browser_esm_js__WEBPACK_IMPORTED_MODULE_6__.h.call(props, 'css')) {
    return react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs(type, props, key);
  }

  return react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs(_dist_emotion_element_5486c51c_browser_esm_js__WEBPACK_IMPORTED_MODULE_6__.E, (0,_dist_emotion_element_5486c51c_browser_esm_js__WEBPACK_IMPORTED_MODULE_6__.c)(type, props), key);
}




/***/ }),

/***/ 54969:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "O": function() { return /* binding */ serializeStyles; }
});

;// CONCATENATED MODULE: ./node_modules/.pnpm/@emotion+hash@0.9.2/node_modules/@emotion/hash/dist/emotion-hash.esm.js
/* eslint-disable */
// Inspired by https://github.com/garycourt/murmurhash-js
// Ported from https://github.com/aappleby/smhasher/blob/61a0530f28277f2e850bfc39600ce61d02b518de/src/MurmurHash2.cpp#L37-L86
function murmur2(str) {
  // 'm' and 'r' are mixing constants generated offline.
  // They're not really 'magic', they just happen to work well.
  // const m = 0x5bd1e995;
  // const r = 24;
  // Initialize the hash
  var h = 0; // Mix 4 bytes at a time into the hash

  var k,
      i = 0,
      len = str.length;

  for (; len >= 4; ++i, len -= 4) {
    k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
    k =
    /* Math.imul(k, m): */
    (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16);
    k ^=
    /* k >>> r: */
    k >>> 24;
    h =
    /* Math.imul(k, m): */
    (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16) ^
    /* Math.imul(h, m): */
    (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
  } // Handle the last few bytes of the input array


  switch (len) {
    case 3:
      h ^= (str.charCodeAt(i + 2) & 0xff) << 16;

    case 2:
      h ^= (str.charCodeAt(i + 1) & 0xff) << 8;

    case 1:
      h ^= str.charCodeAt(i) & 0xff;
      h =
      /* Math.imul(h, m): */
      (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
  } // Do a few final mixes of the hash to ensure the last few
  // bytes are well-incorporated.


  h ^= h >>> 13;
  h =
  /* Math.imul(h, m): */
  (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
  return ((h ^ h >>> 15) >>> 0).toString(36);
}



;// CONCATENATED MODULE: ./node_modules/.pnpm/@emotion+unitless@0.10.0/node_modules/@emotion/unitless/dist/emotion-unitless.esm.js
var unitlessKeys = {
  animationIterationCount: 1,
  aspectRatio: 1,
  borderImageOutset: 1,
  borderImageSlice: 1,
  borderImageWidth: 1,
  boxFlex: 1,
  boxFlexGroup: 1,
  boxOrdinalGroup: 1,
  columnCount: 1,
  columns: 1,
  flex: 1,
  flexGrow: 1,
  flexPositive: 1,
  flexShrink: 1,
  flexNegative: 1,
  flexOrder: 1,
  gridRow: 1,
  gridRowEnd: 1,
  gridRowSpan: 1,
  gridRowStart: 1,
  gridColumn: 1,
  gridColumnEnd: 1,
  gridColumnSpan: 1,
  gridColumnStart: 1,
  msGridRow: 1,
  msGridRowSpan: 1,
  msGridColumn: 1,
  msGridColumnSpan: 1,
  fontWeight: 1,
  lineHeight: 1,
  opacity: 1,
  order: 1,
  orphans: 1,
  scale: 1,
  tabSize: 1,
  widows: 1,
  zIndex: 1,
  zoom: 1,
  WebkitLineClamp: 1,
  // SVG-related properties
  fillOpacity: 1,
  floodOpacity: 1,
  stopOpacity: 1,
  strokeDasharray: 1,
  strokeDashoffset: 1,
  strokeMiterlimit: 1,
  strokeOpacity: 1,
  strokeWidth: 1
};



// EXTERNAL MODULE: ./node_modules/.pnpm/@emotion+memoize@0.9.0/node_modules/@emotion/memoize/dist/emotion-memoize.esm.js
var emotion_memoize_esm = __webpack_require__(36154);
;// CONCATENATED MODULE: ./node_modules/.pnpm/@emotion+serialize@1.3.2/node_modules/@emotion/serialize/dist/emotion-serialize.esm.js




var isDevelopment = false;

var hyphenateRegex = /[A-Z]|^ms/g;
var animationRegex = /_EMO_([^_]+?)_([^]*?)_EMO_/g;

var isCustomProperty = function isCustomProperty(property) {
  return property.charCodeAt(1) === 45;
};

var isProcessableValue = function isProcessableValue(value) {
  return value != null && typeof value !== 'boolean';
};

var processStyleName = /* #__PURE__ */(0,emotion_memoize_esm/* default */.Z)(function (styleName) {
  return isCustomProperty(styleName) ? styleName : styleName.replace(hyphenateRegex, '-$&').toLowerCase();
});

var processStyleValue = function processStyleValue(key, value) {
  switch (key) {
    case 'animation':
    case 'animationName':
      {
        if (typeof value === 'string') {
          return value.replace(animationRegex, function (match, p1, p2) {
            cursor = {
              name: p1,
              styles: p2,
              next: cursor
            };
            return p1;
          });
        }
      }
  }

  if (unitlessKeys[key] !== 1 && !isCustomProperty(key) && typeof value === 'number' && value !== 0) {
    return value + 'px';
  }

  return value;
};

var noComponentSelectorMessage = 'Component selectors can only be used in conjunction with ' + '@emotion/babel-plugin, the swc Emotion plugin, or another Emotion-aware ' + 'compiler transform.';

function handleInterpolation(mergedProps, registered, interpolation) {
  if (interpolation == null) {
    return '';
  }

  var componentSelector = interpolation;

  if (componentSelector.__emotion_styles !== undefined) {

    return componentSelector;
  }

  switch (typeof interpolation) {
    case 'boolean':
      {
        return '';
      }

    case 'object':
      {
        var keyframes = interpolation;

        if (keyframes.anim === 1) {
          cursor = {
            name: keyframes.name,
            styles: keyframes.styles,
            next: cursor
          };
          return keyframes.name;
        }

        var serializedStyles = interpolation;

        if (serializedStyles.styles !== undefined) {
          var next = serializedStyles.next;

          if (next !== undefined) {
            // not the most efficient thing ever but this is a pretty rare case
            // and there will be very few iterations of this generally
            while (next !== undefined) {
              cursor = {
                name: next.name,
                styles: next.styles,
                next: cursor
              };
              next = next.next;
            }
          }

          var styles = serializedStyles.styles + ";";

          return styles;
        }

        return createStringFromObject(mergedProps, registered, interpolation);
      }

    case 'function':
      {
        if (mergedProps !== undefined) {
          var previousCursor = cursor;
          var result = interpolation(mergedProps);
          cursor = previousCursor;
          return handleInterpolation(mergedProps, registered, result);
        }

        break;
      }
  } // finalize string values (regular strings and functions interpolated into css calls)


  var asString = interpolation;

  if (registered == null) {
    return asString;
  }

  var cached = registered[asString];
  return cached !== undefined ? cached : asString;
}

function createStringFromObject(mergedProps, registered, obj) {
  var string = '';

  if (Array.isArray(obj)) {
    for (var i = 0; i < obj.length; i++) {
      string += handleInterpolation(mergedProps, registered, obj[i]) + ";";
    }
  } else {
    for (var key in obj) {
      var value = obj[key];

      if (typeof value !== 'object') {
        var asString = value;

        if (registered != null && registered[asString] !== undefined) {
          string += key + "{" + registered[asString] + "}";
        } else if (isProcessableValue(asString)) {
          string += processStyleName(key) + ":" + processStyleValue(key, asString) + ";";
        }
      } else {
        if (key === 'NO_COMPONENT_SELECTOR' && isDevelopment) {
          throw new Error(noComponentSelectorMessage);
        }

        if (Array.isArray(value) && typeof value[0] === 'string' && (registered == null || registered[value[0]] === undefined)) {
          for (var _i = 0; _i < value.length; _i++) {
            if (isProcessableValue(value[_i])) {
              string += processStyleName(key) + ":" + processStyleValue(key, value[_i]) + ";";
            }
          }
        } else {
          var interpolated = handleInterpolation(mergedProps, registered, value);

          switch (key) {
            case 'animation':
            case 'animationName':
              {
                string += processStyleName(key) + ":" + interpolated + ";";
                break;
              }

            default:
              {

                string += key + "{" + interpolated + "}";
              }
          }
        }
      }
    }
  }

  return string;
}

var labelPattern = /label:\s*([^\s;{]+)\s*(;|$)/g;
// keyframes are stored on the SerializedStyles object as a linked list


var cursor;
function serializeStyles(args, registered, mergedProps) {
  if (args.length === 1 && typeof args[0] === 'object' && args[0] !== null && args[0].styles !== undefined) {
    return args[0];
  }

  var stringMode = true;
  var styles = '';
  cursor = undefined;
  var strings = args[0];

  if (strings == null || strings.raw === undefined) {
    stringMode = false;
    styles += handleInterpolation(mergedProps, registered, strings);
  } else {
    var asTemplateStringsArr = strings;

    styles += asTemplateStringsArr[0];
  } // we start at 1 since we've already handled the first arg


  for (var i = 1; i < args.length; i++) {
    styles += handleInterpolation(mergedProps, registered, args[i]);

    if (stringMode) {
      var templateStringsArr = strings;

      styles += templateStringsArr[i];
    }
  }


  labelPattern.lastIndex = 0;
  var identifierName = '';
  var match; // https://esbench.com/bench/5b809c2cf2949800a0f61fb5

  while ((match = labelPattern.exec(styles)) !== null) {
    identifierName += '-' + match[1];
  }

  var name = murmur2(styles) + identifierName;

  return {
    name: name,
    styles: styles,
    next: cursor
  };
}




/***/ }),

/***/ 12851:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ createStyled; }
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(2053);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(75271);
/* harmony import */ var _emotion_is_prop_valid__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(2366);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(57834);
/* harmony import */ var _emotion_utils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(53757);
/* harmony import */ var _emotion_serialize__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(54969);
/* harmony import */ var _emotion_use_insertion_effect_with_fallbacks__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(28368);








/* import type {
  ElementType,
  StatelessFunctionalComponent,
  AbstractComponent
} from 'react' */
/*
export type Interpolations = Array<any>

export type StyledElementType<Props> =
  | string
  | AbstractComponent<{ ...Props, className: string }, mixed>

export type StyledOptions = {
  label?: string,
  shouldForwardProp?: string => boolean,
  target?: string
}

export type StyledComponent<Props> = StatelessFunctionalComponent<Props> & {
  defaultProps: any,
  toString: () => string,
  withComponent: (
    nextTag: StyledElementType<Props>,
    nextOptions?: StyledOptions
  ) => StyledComponent<Props>
}

export type PrivateStyledComponent<Props> = StyledComponent<Props> & {
  __emotion_real: StyledComponent<Props>,
  __emotion_base: any,
  __emotion_styles: any,
  __emotion_forwardProp: any
}
*/

var testOmitPropsOnStringTag = _emotion_is_prop_valid__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z;

var testOmitPropsOnComponent = function testOmitPropsOnComponent(key
/*: string */
) {
  return key !== 'theme';
};

var getDefaultShouldForwardProp = function getDefaultShouldForwardProp(tag
/*: ElementType */
) {
  return typeof tag === 'string' && // 96 is one less than the char code
  // for "a" so this is checking that
  // it's a lowercase character
  tag.charCodeAt(0) > 96 ? testOmitPropsOnStringTag : testOmitPropsOnComponent;
};
var composeShouldForwardProps = function composeShouldForwardProps(tag
/*: PrivateStyledComponent<any> */
, options
/*: StyledOptions | void */
, isReal
/*: boolean */
) {
  var shouldForwardProp;

  if (options) {
    var optionsShouldForwardProp = options.shouldForwardProp;
    shouldForwardProp = tag.__emotion_forwardProp && optionsShouldForwardProp ? function (propName
    /*: string */
    ) {
      return tag.__emotion_forwardProp(propName) && optionsShouldForwardProp(propName);
    } : optionsShouldForwardProp;
  }

  if (typeof shouldForwardProp !== 'function' && isReal) {
    shouldForwardProp = tag.__emotion_forwardProp;
  }

  return shouldForwardProp;
};
/*
export type CreateStyledComponent = <Props>(
  ...args: Interpolations
) => StyledComponent<Props>

export type CreateStyled = {
  <Props>(
    tag: StyledElementType<Props>,
    options?: StyledOptions
  ): (...args: Interpolations) => StyledComponent<Props>,
  [key: string]: CreateStyledComponent,
  bind: () => CreateStyled
}
*/

var isDevelopment = false;

var Insertion = function Insertion(_ref) {
  var cache = _ref.cache,
      serialized = _ref.serialized,
      isStringTag = _ref.isStringTag;
  (0,_emotion_utils__WEBPACK_IMPORTED_MODULE_4__/* .registerStyles */ .hC)(cache, serialized, isStringTag);
  (0,_emotion_use_insertion_effect_with_fallbacks__WEBPACK_IMPORTED_MODULE_2__/* .useInsertionEffectAlwaysWithSyncFallback */ .L)(function () {
    return (0,_emotion_utils__WEBPACK_IMPORTED_MODULE_4__/* .insertStyles */ .My)(cache, serialized, isStringTag);
  });

  return null;
};

var createStyled
/*: CreateStyled */
= function createStyled
/*: CreateStyled */
(tag
/*: any */
, options
/* ?: StyledOptions */
) {

  var isReal = tag.__emotion_real === tag;
  var baseTag = isReal && tag.__emotion_base || tag;
  var identifierName;
  var targetClassName;

  if (options !== undefined) {
    identifierName = options.label;
    targetClassName = options.target;
  }

  var shouldForwardProp = composeShouldForwardProps(tag, options, isReal);
  var defaultShouldForwardProp = shouldForwardProp || getDefaultShouldForwardProp(baseTag);
  var shouldUseAs = !defaultShouldForwardProp('as');
  /* return function<Props>(): PrivateStyledComponent<Props> { */

  return function () {
    var args = arguments;
    var styles = isReal && tag.__emotion_styles !== undefined ? tag.__emotion_styles.slice(0) : [];

    if (identifierName !== undefined) {
      styles.push("label:" + identifierName + ";");
    }

    if (args[0] == null || args[0].raw === undefined) {
      styles.push.apply(styles, args);
    } else {

      styles.push(args[0][0]);
      var len = args.length;
      var i = 1;

      for (; i < len; i++) {

        styles.push(args[i], args[0][i]);
      }
    }

    var Styled
    /*: PrivateStyledComponent<Props> */
    = (0,_emotion_react__WEBPACK_IMPORTED_MODULE_5__.w)(function (props, cache, ref) {
      var FinalTag = shouldUseAs && props.as || baseTag;
      var className = '';
      var classInterpolations = [];
      var mergedProps = props;

      if (props.theme == null) {
        mergedProps = {};

        for (var key in props) {
          mergedProps[key] = props[key];
        }

        mergedProps.theme = react__WEBPACK_IMPORTED_MODULE_0__.useContext(_emotion_react__WEBPACK_IMPORTED_MODULE_5__.T);
      }

      if (typeof props.className === 'string') {
        className = (0,_emotion_utils__WEBPACK_IMPORTED_MODULE_4__/* .getRegisteredStyles */ .fp)(cache.registered, classInterpolations, props.className);
      } else if (props.className != null) {
        className = props.className + " ";
      }

      var serialized = (0,_emotion_serialize__WEBPACK_IMPORTED_MODULE_1__/* .serializeStyles */ .O)(styles.concat(classInterpolations), cache.registered, mergedProps);
      className += cache.key + "-" + serialized.name;

      if (targetClassName !== undefined) {
        className += " " + targetClassName;
      }

      var finalShouldForwardProp = shouldUseAs && shouldForwardProp === undefined ? getDefaultShouldForwardProp(FinalTag) : defaultShouldForwardProp;
      var newProps = {};

      for (var _key in props) {
        if (shouldUseAs && _key === 'as') continue;

        if (finalShouldForwardProp(_key)) {
          newProps[_key] = props[_key];
        }
      }

      newProps.className = className;

      if (ref) {
        newProps.ref = ref;
      }

      return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(Insertion, {
        cache: cache,
        serialized: serialized,
        isStringTag: typeof FinalTag === 'string'
      }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(FinalTag, newProps));
    });
    Styled.displayName = identifierName !== undefined ? identifierName : "Styled(" + (typeof baseTag === 'string' ? baseTag : baseTag.displayName || baseTag.name || 'Component') + ")";
    Styled.defaultProps = tag.defaultProps;
    Styled.__emotion_real = Styled;
    Styled.__emotion_base = baseTag;
    Styled.__emotion_styles = styles;
    Styled.__emotion_forwardProp = shouldForwardProp;
    Object.defineProperty(Styled, 'toString', {
      value: function value() {
        if (targetClassName === undefined && isDevelopment) {
          return 'NO_COMPONENT_SELECTOR';
        }

        return "." + targetClassName;
      }
    });

    Styled.withComponent = function (nextTag
    /*: StyledElementType<Props> */
    , nextOptions
    /* ?: StyledOptions */
    ) {
      return createStyled(nextTag, (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, options, nextOptions, {
        shouldForwardProp: composeShouldForwardProps(Styled, nextOptions, true)
      })).apply(void 0, styles);
    };

    return Styled;
  };
};




/***/ }),

/***/ 81909:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ newStyled; }
/* harmony export */ });
/* harmony import */ var _base_dist_emotion_styled_base_browser_esm_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(12851);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(75271);
/* harmony import */ var _emotion_serialize__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(54969);
/* harmony import */ var _emotion_use_insertion_effect_with_fallbacks__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(28368);









var tags = ['a', 'abbr', 'address', 'area', 'article', 'aside', 'audio', 'b', 'base', 'bdi', 'bdo', 'big', 'blockquote', 'body', 'br', 'button', 'canvas', 'caption', 'cite', 'code', 'col', 'colgroup', 'data', 'datalist', 'dd', 'del', 'details', 'dfn', 'dialog', 'div', 'dl', 'dt', 'em', 'embed', 'fieldset', 'figcaption', 'figure', 'footer', 'form', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'head', 'header', 'hgroup', 'hr', 'html', 'i', 'iframe', 'img', 'input', 'ins', 'kbd', 'keygen', 'label', 'legend', 'li', 'link', 'main', 'map', 'mark', 'marquee', 'menu', 'menuitem', 'meta', 'meter', 'nav', 'noscript', 'object', 'ol', 'optgroup', 'option', 'output', 'p', 'param', 'picture', 'pre', 'progress', 'q', 'rp', 'rt', 'ruby', 's', 'samp', 'script', 'section', 'select', 'small', 'source', 'span', 'strong', 'style', 'sub', 'summary', 'sup', 'table', 'tbody', 'td', 'textarea', 'tfoot', 'th', 'thead', 'time', 'title', 'tr', 'track', 'u', 'ul', 'var', 'video', 'wbr', // SVG
'circle', 'clipPath', 'defs', 'ellipse', 'foreignObject', 'g', 'image', 'line', 'linearGradient', 'mask', 'path', 'pattern', 'polygon', 'polyline', 'radialGradient', 'rect', 'stop', 'svg', 'text', 'tspan'];

var newStyled = _base_dist_emotion_styled_base_browser_esm_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"].bind */ .Z.bind();
tags.forEach(function (tagName) {
  newStyled[tagName] = newStyled(tagName);
});




/***/ }),

/***/ 28368:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
var react__WEBPACK_IMPORTED_MODULE_0___namespace_cache;
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "L": function() { return /* binding */ useInsertionEffectAlwaysWithSyncFallback; }
/* harmony export */ });
/* unused harmony export useInsertionEffectWithLayoutFallback */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(75271);


var syncFallback = function syncFallback(create) {
  return create();
};

var useInsertionEffect = /*#__PURE__*/ (react__WEBPACK_IMPORTED_MODULE_0___namespace_cache || (react__WEBPACK_IMPORTED_MODULE_0___namespace_cache = __webpack_require__.t(react__WEBPACK_IMPORTED_MODULE_0__, 2)))['useInsertion' + 'Effect'] ? /*#__PURE__*/ (react__WEBPACK_IMPORTED_MODULE_0___namespace_cache || (react__WEBPACK_IMPORTED_MODULE_0___namespace_cache = __webpack_require__.t(react__WEBPACK_IMPORTED_MODULE_0__, 2)))['useInsertion' + 'Effect'] : false;
var useInsertionEffectAlwaysWithSyncFallback = useInsertionEffect || syncFallback;
var useInsertionEffectWithLayoutFallback = useInsertionEffect || react__WEBPACK_IMPORTED_MODULE_0__.useLayoutEffect;




/***/ }),

/***/ 53757:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "My": function() { return /* binding */ insertStyles; },
/* harmony export */   "fp": function() { return /* binding */ getRegisteredStyles; },
/* harmony export */   "hC": function() { return /* binding */ registerStyles; }
/* harmony export */ });
var isBrowser = true;

function getRegisteredStyles(registered, registeredStyles, classNames) {
  var rawClassName = '';
  classNames.split(' ').forEach(function (className) {
    if (registered[className] !== undefined) {
      registeredStyles.push(registered[className] + ";");
    } else if (className) {
      rawClassName += className + " ";
    }
  });
  return rawClassName;
}
var registerStyles = function registerStyles(cache, serialized, isStringTag) {
  var className = cache.key + "-" + serialized.name;

  if ( // we only need to add the styles to the registered cache if the
  // class name could be used further down
  // the tree but if it's a string tag, we know it won't
  // so we don't have to add it to registered cache.
  // this improves memory usage since we can avoid storing the whole style string
  (isStringTag === false || // we need to always store it if we're in compat mode and
  // in node since emotion-server relies on whether a style is in
  // the registered cache to know whether a style is global or not
  // also, note that this check will be dead code eliminated in the browser
  isBrowser === false ) && cache.registered[className] === undefined) {
    cache.registered[className] = serialized.styles;
  }
};
var insertStyles = function insertStyles(cache, serialized, isStringTag) {
  registerStyles(cache, serialized, isStringTag);
  var className = cache.key + "-" + serialized.name;

  if (cache.inserted[serialized.name] === undefined) {
    var current = serialized;

    do {
      cache.insert(serialized === current ? "." + className : '', current, cache.sheet, true);

      current = current.next;
    } while (current !== undefined);
  }
};




/***/ }),

/***/ 31226:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
function autobind(_target, name, descriptor) {
    var enumerable = descriptor.enumerable, configurable = descriptor.configurable, value = descriptor.value;
    var boundMethod = Symbol("boundMethod." + name);
    return {
        enumerable: enumerable,
        configurable: configurable,
        get: function () {
            return this[boundMethod] || (this[boundMethod] = value.bind(this));
        },
        set: function (value) {
            Object.defineProperty(this, name, {
                writable: true,
                enumerable: true,
                configurable: true,
                value: value,
            });
        },
    };
}
exports.N = autobind;
//# sourceMappingURL=autobind.js.map

/***/ }),

/***/ 21366:
/***/ (function(module) {

"use strict";
/*globals self, window */


/*eslint-disable @mysticatea/prettier */
const { AbortController, AbortSignal } =
    typeof self !== "undefined" ? self :
    typeof window !== "undefined" ? window :
    /* otherwise */ undefined
/*eslint-enable @mysticatea/prettier */

module.exports = AbortController
module.exports.AbortSignal = AbortSignal
module.exports["default"] = AbortController


/***/ }),

/***/ 47990:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (factory) {
   true ? !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
		__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
		(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
		__WEBPACK_AMD_DEFINE_FACTORY__),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) :
  0;
})((function () { 'use strict';

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  function _defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
      writable: false
    });
    return Constructor;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function");
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        writable: true,
        configurable: true
      }
    });
    Object.defineProperty(subClass, "prototype", {
      writable: false
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
  }

  function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
      return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
  }

  function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
      o.__proto__ = p;
      return o;
    };
    return _setPrototypeOf(o, p);
  }

  function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  function _assertThisInitialized(self) {
    if (self === void 0) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return self;
  }

  function _possibleConstructorReturn(self, call) {
    if (call && (typeof call === "object" || typeof call === "function")) {
      return call;
    } else if (call !== void 0) {
      throw new TypeError("Derived constructors may only return object or undefined");
    }

    return _assertThisInitialized(self);
  }

  function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();

    return function _createSuperInternal() {
      var Super = _getPrototypeOf(Derived),
          result;

      if (hasNativeReflectConstruct) {
        var NewTarget = _getPrototypeOf(this).constructor;

        result = Reflect.construct(Super, arguments, NewTarget);
      } else {
        result = Super.apply(this, arguments);
      }

      return _possibleConstructorReturn(this, result);
    };
  }

  function _superPropBase(object, property) {
    while (!Object.prototype.hasOwnProperty.call(object, property)) {
      object = _getPrototypeOf(object);
      if (object === null) break;
    }

    return object;
  }

  function _get() {
    if (typeof Reflect !== "undefined" && Reflect.get) {
      _get = Reflect.get.bind();
    } else {
      _get = function _get(target, property, receiver) {
        var base = _superPropBase(target, property);

        if (!base) return;
        var desc = Object.getOwnPropertyDescriptor(base, property);

        if (desc.get) {
          return desc.get.call(arguments.length < 3 ? target : receiver);
        }

        return desc.value;
      };
    }

    return _get.apply(this, arguments);
  }

  var Emitter = /*#__PURE__*/function () {
    function Emitter() {
      _classCallCheck(this, Emitter);

      Object.defineProperty(this, 'listeners', {
        value: {},
        writable: true,
        configurable: true
      });
    }

    _createClass(Emitter, [{
      key: "addEventListener",
      value: function addEventListener(type, callback, options) {
        if (!(type in this.listeners)) {
          this.listeners[type] = [];
        }

        this.listeners[type].push({
          callback: callback,
          options: options
        });
      }
    }, {
      key: "removeEventListener",
      value: function removeEventListener(type, callback) {
        if (!(type in this.listeners)) {
          return;
        }

        var stack = this.listeners[type];

        for (var i = 0, l = stack.length; i < l; i++) {
          if (stack[i].callback === callback) {
            stack.splice(i, 1);
            return;
          }
        }
      }
    }, {
      key: "dispatchEvent",
      value: function dispatchEvent(event) {
        if (!(event.type in this.listeners)) {
          return;
        }

        var stack = this.listeners[event.type];
        var stackToCall = stack.slice();

        for (var i = 0, l = stackToCall.length; i < l; i++) {
          var listener = stackToCall[i];

          try {
            listener.callback.call(this, event);
          } catch (e) {
            Promise.resolve().then(function () {
              throw e;
            });
          }

          if (listener.options && listener.options.once) {
            this.removeEventListener(event.type, listener.callback);
          }
        }

        return !event.defaultPrevented;
      }
    }]);

    return Emitter;
  }();

  var AbortSignal = /*#__PURE__*/function (_Emitter) {
    _inherits(AbortSignal, _Emitter);

    var _super = _createSuper(AbortSignal);

    function AbortSignal() {
      var _this;

      _classCallCheck(this, AbortSignal);

      _this = _super.call(this); // Some versions of babel does not transpile super() correctly for IE <= 10, if the parent
      // constructor has failed to run, then "this.listeners" will still be undefined and then we call
      // the parent constructor directly instead as a workaround. For general details, see babel bug:
      // https://github.com/babel/babel/issues/3041
      // This hack was added as a fix for the issue described here:
      // https://github.com/Financial-Times/polyfill-library/pull/59#issuecomment-477558042

      if (!_this.listeners) {
        Emitter.call(_assertThisInitialized(_this));
      } // Compared to assignment, Object.defineProperty makes properties non-enumerable by default and
      // we want Object.keys(new AbortController().signal) to be [] for compat with the native impl


      Object.defineProperty(_assertThisInitialized(_this), 'aborted', {
        value: false,
        writable: true,
        configurable: true
      });
      Object.defineProperty(_assertThisInitialized(_this), 'onabort', {
        value: null,
        writable: true,
        configurable: true
      });
      Object.defineProperty(_assertThisInitialized(_this), 'reason', {
        value: undefined,
        writable: true,
        configurable: true
      });
      return _this;
    }

    _createClass(AbortSignal, [{
      key: "toString",
      value: function toString() {
        return '[object AbortSignal]';
      }
    }, {
      key: "dispatchEvent",
      value: function dispatchEvent(event) {
        if (event.type === 'abort') {
          this.aborted = true;

          if (typeof this.onabort === 'function') {
            this.onabort.call(this, event);
          }
        }

        _get(_getPrototypeOf(AbortSignal.prototype), "dispatchEvent", this).call(this, event);
      }
    }]);

    return AbortSignal;
  }(Emitter);
  var AbortController = /*#__PURE__*/function () {
    function AbortController() {
      _classCallCheck(this, AbortController);

      // Compared to assignment, Object.defineProperty makes properties non-enumerable by default and
      // we want Object.keys(new AbortController()) to be [] for compat with the native impl
      Object.defineProperty(this, 'signal', {
        value: new AbortSignal(),
        writable: true,
        configurable: true
      });
    }

    _createClass(AbortController, [{
      key: "abort",
      value: function abort(reason) {
        var event;

        try {
          event = new Event('abort');
        } catch (e) {
          if (typeof document !== 'undefined') {
            if (!document.createEvent) {
              // For Internet Explorer 8:
              event = document.createEventObject();
              event.type = 'abort';
            } else {
              // For Internet Explorer 11:
              event = document.createEvent('Event');
              event.initEvent('abort', false, false);
            }
          } else {
            // Fallback where document isn't available:
            event = {
              type: 'abort',
              bubbles: false,
              cancelable: false
            };
          }
        }

        var signalReason = reason;

        if (signalReason === undefined) {
          if (typeof document === 'undefined') {
            signalReason = new Error('This operation was aborted');
            signalReason.name = 'AbortError';
          } else {
            try {
              signalReason = new DOMException('signal is aborted without reason');
            } catch (err) {
              // IE 11 does not support calling the DOMException constructor, use a
              // regular error object on it instead.
              signalReason = new Error('This operation was aborted');
              signalReason.name = 'AbortError';
            }
          }
        }

        this.signal.reason = signalReason;
        this.signal.dispatchEvent(event);
      }
    }, {
      key: "toString",
      value: function toString() {
        return '[object AbortController]';
      }
    }]);

    return AbortController;
  }();

  if (typeof Symbol !== 'undefined' && Symbol.toStringTag) {
    // These are necessary to make sure that we get correct output for:
    // Object.prototype.toString.call(new AbortController())
    AbortController.prototype[Symbol.toStringTag] = 'AbortController';
    AbortSignal.prototype[Symbol.toStringTag] = 'AbortSignal';
  }

  function polyfillNeeded(self) {
    if (self.__FORCE_INSTALL_ABORTCONTROLLER_POLYFILL) {
      console.log('__FORCE_INSTALL_ABORTCONTROLLER_POLYFILL=true is set, will force install polyfill');
      return true;
    } // Note that the "unfetch" minimal fetch polyfill defines fetch() without
    // defining window.Request, and this polyfill need to work on top of unfetch
    // so the below feature detection needs the !self.AbortController part.
    // The Request.prototype check is also needed because Safari versions 11.1.2
    // up to and including 12.1.x has a window.AbortController present but still
    // does NOT correctly implement abortable fetch:
    // https://bugs.webkit.org/show_bug.cgi?id=174980#c2


    return typeof self.Request === 'function' && !self.Request.prototype.hasOwnProperty('signal') || !self.AbortController;
  }

  /**
   * Note: the "fetch.Request" default value is available for fetch imported from
   * the "node-fetch" package and not in browsers. This is OK since browsers
   * will be importing umd-polyfill.js from that path "self" is passed the
   * decorator so the default value will not be used (because browsers that define
   * fetch also has Request). One quirky setup where self.fetch exists but
   * self.Request does not is when the "unfetch" minimal fetch polyfill is used
   * on top of IE11; for this case the browser will try to use the fetch.Request
   * default value which in turn will be undefined but then then "if (Request)"
   * will ensure that you get a patched fetch but still no Request (as expected).
   * @param {fetch, Request = fetch.Request}
   * @returns {fetch: abortableFetch, Request: AbortableRequest}
   */

  function abortableFetchDecorator(patchTargets) {
    if ('function' === typeof patchTargets) {
      patchTargets = {
        fetch: patchTargets
      };
    }

    var _patchTargets = patchTargets,
        fetch = _patchTargets.fetch,
        _patchTargets$Request = _patchTargets.Request,
        NativeRequest = _patchTargets$Request === void 0 ? fetch.Request : _patchTargets$Request,
        NativeAbortController = _patchTargets.AbortController,
        _patchTargets$__FORCE = _patchTargets.__FORCE_INSTALL_ABORTCONTROLLER_POLYFILL,
        __FORCE_INSTALL_ABORTCONTROLLER_POLYFILL = _patchTargets$__FORCE === void 0 ? false : _patchTargets$__FORCE;

    if (!polyfillNeeded({
      fetch: fetch,
      Request: NativeRequest,
      AbortController: NativeAbortController,
      __FORCE_INSTALL_ABORTCONTROLLER_POLYFILL: __FORCE_INSTALL_ABORTCONTROLLER_POLYFILL
    })) {
      return {
        fetch: fetch,
        Request: Request
      };
    }

    var Request = NativeRequest; // Note that the "unfetch" minimal fetch polyfill defines fetch() without
    // defining window.Request, and this polyfill need to work on top of unfetch
    // hence we only patch it if it's available. Also we don't patch it if signal
    // is already available on the Request prototype because in this case support
    // is present and the patching below can cause a crash since it assigns to
    // request.signal which is technically a read-only property. This latter error
    // happens when you run the main5.js node-fetch example in the repo
    // "abortcontroller-polyfill-examples". The exact error is:
    //   request.signal = init.signal;
    //   ^
    // TypeError: Cannot set property signal of #<Request> which has only a getter

    if (Request && !Request.prototype.hasOwnProperty('signal') || __FORCE_INSTALL_ABORTCONTROLLER_POLYFILL) {
      Request = function Request(input, init) {
        var signal;

        if (init && init.signal) {
          signal = init.signal; // Never pass init.signal to the native Request implementation when the polyfill has
          // been installed because if we're running on top of a browser with a
          // working native AbortController (i.e. the polyfill was installed due to
          // __FORCE_INSTALL_ABORTCONTROLLER_POLYFILL being set), then passing our
          // fake AbortSignal to the native fetch will trigger:
          // TypeError: Failed to construct 'Request': member signal is not of type AbortSignal.

          delete init.signal;
        }

        var request = new NativeRequest(input, init);

        if (signal) {
          Object.defineProperty(request, 'signal', {
            writable: false,
            enumerable: false,
            configurable: true,
            value: signal
          });
        }

        return request;
      };

      Request.prototype = NativeRequest.prototype;
    }

    var realFetch = fetch;

    var abortableFetch = function abortableFetch(input, init) {
      var signal = Request && Request.prototype.isPrototypeOf(input) ? input.signal : init ? init.signal : undefined;

      if (signal) {
        var abortError;

        try {
          abortError = new DOMException('Aborted', 'AbortError');
        } catch (err) {
          // IE 11 does not support calling the DOMException constructor, use a
          // regular error object on it instead.
          abortError = new Error('Aborted');
          abortError.name = 'AbortError';
        } // Return early if already aborted, thus avoiding making an HTTP request


        if (signal.aborted) {
          return Promise.reject(abortError);
        } // Turn an event into a promise, reject it once `abort` is dispatched


        var cancellation = new Promise(function (_, reject) {
          signal.addEventListener('abort', function () {
            return reject(abortError);
          }, {
            once: true
          });
        });

        if (init && init.signal) {
          // Never pass .signal to the native implementation when the polyfill has
          // been installed because if we're running on top of a browser with a
          // working native AbortController (i.e. the polyfill was installed due to
          // __FORCE_INSTALL_ABORTCONTROLLER_POLYFILL being set), then passing our
          // fake AbortSignal to the native fetch will trigger:
          // TypeError: Failed to execute 'fetch' on 'Window': member signal is not of type AbortSignal.
          delete init.signal;
        } // Return the fastest promise (don't need to wait for request to finish)


        return Promise.race([cancellation, realFetch(input, init)]);
      }

      return realFetch(input, init);
    };

    return {
      fetch: abortableFetch,
      Request: Request
    };
  }

  (function (self) {

    if (!polyfillNeeded(self)) {
      return;
    }

    if (!self.fetch) {
      console.warn('fetch() is not available, cannot install abortcontroller-polyfill');
      return;
    }

    var _abortableFetch = abortableFetchDecorator(self),
        fetch = _abortableFetch.fetch,
        Request = _abortableFetch.Request;

    self.fetch = fetch;
    self.Request = Request;
    Object.defineProperty(self, 'AbortController', {
      writable: true,
      enumerable: false,
      configurable: true,
      value: AbortController
    });
    Object.defineProperty(self, 'AbortSignal', {
      writable: true,
      enumerable: false,
      configurable: true,
      value: AbortSignal
    });
  })(typeof self !== 'undefined' ? self : __webpack_require__.g);

}));


/***/ }),

/***/ 29774:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var objectAssign = __webpack_require__(49681)();

// compare and isBuffer taken from https://github.com/feross/buffer/blob/680e9e5e488f22aac27599a57dc844a6315928dd/index.js
// original notice:

/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <feross@feross.org> <http://feross.org>
 * @license  MIT
 */
function compare(a, b) {
  if (a === b) {
    return 0;
  }

  var x = a.length;
  var y = b.length;

  for (var i = 0, len = Math.min(x, y); i < len; ++i) {
    if (a[i] !== b[i]) {
      x = a[i];
      y = b[i];
      break;
    }
  }

  if (x < y) {
    return -1;
  }
  if (y < x) {
    return 1;
  }
  return 0;
}
function isBuffer(b) {
  if (__webpack_require__.g.Buffer && typeof __webpack_require__.g.Buffer.isBuffer === 'function') {
    return __webpack_require__.g.Buffer.isBuffer(b);
  }
  return !!(b != null && b._isBuffer);
}

// based on node assert, original notice:
// NB: The URL to the CommonJS spec is kept just for tradition.
//     node-assert has evolved a lot since then, both in API and behavior.

// http://wiki.commonjs.org/wiki/Unit_Testing/1.0
//
// THIS IS NOT TESTED NOR LIKELY TO WORK OUTSIDE V8!
//
// Originally from narwhal.js (http://narwhaljs.org)
// Copyright (c) 2009 Thomas Robinson <280north.com>
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the 'Software'), to
// deal in the Software without restriction, including without limitation the
// rights to use, copy, modify, merge, publish, distribute, sublicense, and/or
// sell copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED 'AS IS', WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN
// ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION
// WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.

var util = __webpack_require__(86011);
var hasOwn = Object.prototype.hasOwnProperty;
var pSlice = Array.prototype.slice;
var functionsHaveNames = (function () {
  return function foo() {}.name === 'foo';
}());
function pToString (obj) {
  return Object.prototype.toString.call(obj);
}
function isView(arrbuf) {
  if (isBuffer(arrbuf)) {
    return false;
  }
  if (typeof __webpack_require__.g.ArrayBuffer !== 'function') {
    return false;
  }
  if (typeof ArrayBuffer.isView === 'function') {
    return ArrayBuffer.isView(arrbuf);
  }
  if (!arrbuf) {
    return false;
  }
  if (arrbuf instanceof DataView) {
    return true;
  }
  if (arrbuf.buffer && arrbuf.buffer instanceof ArrayBuffer) {
    return true;
  }
  return false;
}
// 1. The assert module provides functions that throw
// AssertionError's when particular conditions are not met. The
// assert module must conform to the following interface.

var assert = module.exports = ok;

// 2. The AssertionError is defined in assert.
// new assert.AssertionError({ message: message,
//                             actual: actual,
//                             expected: expected })

var regex = /\s*function\s+([^\(\s]*)\s*/;
// based on https://github.com/ljharb/function.prototype.name/blob/adeeeec8bfcc6068b187d7d9fb3d5bb1d3a30899/implementation.js
function getName(func) {
  if (!util.isFunction(func)) {
    return;
  }
  if (functionsHaveNames) {
    return func.name;
  }
  var str = func.toString();
  var match = str.match(regex);
  return match && match[1];
}
assert.AssertionError = function AssertionError(options) {
  this.name = 'AssertionError';
  this.actual = options.actual;
  this.expected = options.expected;
  this.operator = options.operator;
  if (options.message) {
    this.message = options.message;
    this.generatedMessage = false;
  } else {
    this.message = getMessage(this);
    this.generatedMessage = true;
  }
  var stackStartFunction = options.stackStartFunction || fail;
  if (Error.captureStackTrace) {
    Error.captureStackTrace(this, stackStartFunction);
  } else {
    // non v8 browsers so we can have a stacktrace
    var err = new Error();
    if (err.stack) {
      var out = err.stack;

      // try to strip useless frames
      var fn_name = getName(stackStartFunction);
      var idx = out.indexOf('\n' + fn_name);
      if (idx >= 0) {
        // once we have located the function frame
        // we need to strip out everything before it (and its line)
        var next_line = out.indexOf('\n', idx + 1);
        out = out.substring(next_line + 1);
      }

      this.stack = out;
    }
  }
};

// assert.AssertionError instanceof Error
util.inherits(assert.AssertionError, Error);

function truncate(s, n) {
  if (typeof s === 'string') {
    return s.length < n ? s : s.slice(0, n);
  } else {
    return s;
  }
}
function inspect(something) {
  if (functionsHaveNames || !util.isFunction(something)) {
    return util.inspect(something);
  }
  var rawname = getName(something);
  var name = rawname ? ': ' + rawname : '';
  return '[Function' +  name + ']';
}
function getMessage(self) {
  return truncate(inspect(self.actual), 128) + ' ' +
         self.operator + ' ' +
         truncate(inspect(self.expected), 128);
}

// At present only the three keys mentioned above are used and
// understood by the spec. Implementations or sub modules can pass
// other keys to the AssertionError's constructor - they will be
// ignored.

// 3. All of the following functions must throw an AssertionError
// when a corresponding condition is not met, with a message that
// may be undefined if not provided.  All assertion methods provide
// both the actual and expected values to the assertion error for
// display purposes.

function fail(actual, expected, message, operator, stackStartFunction) {
  throw new assert.AssertionError({
    message: message,
    actual: actual,
    expected: expected,
    operator: operator,
    stackStartFunction: stackStartFunction
  });
}

// EXTENSION! allows for well behaved errors defined elsewhere.
assert.fail = fail;

// 4. Pure assertion tests whether a value is truthy, as determined
// by !!guard.
// assert.ok(guard, message_opt);
// This statement is equivalent to assert.equal(true, !!guard,
// message_opt);. To test strictly for the value true, use
// assert.strictEqual(true, guard, message_opt);.

function ok(value, message) {
  if (!value) fail(value, true, message, '==', assert.ok);
}
assert.ok = ok;

// 5. The equality assertion tests shallow, coercive equality with
// ==.
// assert.equal(actual, expected, message_opt);

assert.equal = function equal(actual, expected, message) {
  if (actual != expected) fail(actual, expected, message, '==', assert.equal);
};

// 6. The non-equality assertion tests for whether two objects are not equal
// with != assert.notEqual(actual, expected, message_opt);

assert.notEqual = function notEqual(actual, expected, message) {
  if (actual == expected) {
    fail(actual, expected, message, '!=', assert.notEqual);
  }
};

// 7. The equivalence assertion tests a deep equality relation.
// assert.deepEqual(actual, expected, message_opt);

assert.deepEqual = function deepEqual(actual, expected, message) {
  if (!_deepEqual(actual, expected, false)) {
    fail(actual, expected, message, 'deepEqual', assert.deepEqual);
  }
};

assert.deepStrictEqual = function deepStrictEqual(actual, expected, message) {
  if (!_deepEqual(actual, expected, true)) {
    fail(actual, expected, message, 'deepStrictEqual', assert.deepStrictEqual);
  }
};

function _deepEqual(actual, expected, strict, memos) {
  // 7.1. All identical values are equivalent, as determined by ===.
  if (actual === expected) {
    return true;
  } else if (isBuffer(actual) && isBuffer(expected)) {
    return compare(actual, expected) === 0;

  // 7.2. If the expected value is a Date object, the actual value is
  // equivalent if it is also a Date object that refers to the same time.
  } else if (util.isDate(actual) && util.isDate(expected)) {
    return actual.getTime() === expected.getTime();

  // 7.3 If the expected value is a RegExp object, the actual value is
  // equivalent if it is also a RegExp object with the same source and
  // properties (`global`, `multiline`, `lastIndex`, `ignoreCase`).
  } else if (util.isRegExp(actual) && util.isRegExp(expected)) {
    return actual.source === expected.source &&
           actual.global === expected.global &&
           actual.multiline === expected.multiline &&
           actual.lastIndex === expected.lastIndex &&
           actual.ignoreCase === expected.ignoreCase;

  // 7.4. Other pairs that do not both pass typeof value == 'object',
  // equivalence is determined by ==.
  } else if ((actual === null || typeof actual !== 'object') &&
             (expected === null || typeof expected !== 'object')) {
    return strict ? actual === expected : actual == expected;

  // If both values are instances of typed arrays, wrap their underlying
  // ArrayBuffers in a Buffer each to increase performance
  // This optimization requires the arrays to have the same type as checked by
  // Object.prototype.toString (aka pToString). Never perform binary
  // comparisons for Float*Arrays, though, since e.g. +0 === -0 but their
  // bit patterns are not identical.
  } else if (isView(actual) && isView(expected) &&
             pToString(actual) === pToString(expected) &&
             !(actual instanceof Float32Array ||
               actual instanceof Float64Array)) {
    return compare(new Uint8Array(actual.buffer),
                   new Uint8Array(expected.buffer)) === 0;

  // 7.5 For all other Object pairs, including Array objects, equivalence is
  // determined by having the same number of owned properties (as verified
  // with Object.prototype.hasOwnProperty.call), the same set of keys
  // (although not necessarily the same order), equivalent values for every
  // corresponding key, and an identical 'prototype' property. Note: this
  // accounts for both named and indexed properties on Arrays.
  } else if (isBuffer(actual) !== isBuffer(expected)) {
    return false;
  } else {
    memos = memos || {actual: [], expected: []};

    var actualIndex = memos.actual.indexOf(actual);
    if (actualIndex !== -1) {
      if (actualIndex === memos.expected.indexOf(expected)) {
        return true;
      }
    }

    memos.actual.push(actual);
    memos.expected.push(expected);

    return objEquiv(actual, expected, strict, memos);
  }
}

function isArguments(object) {
  return Object.prototype.toString.call(object) == '[object Arguments]';
}

function objEquiv(a, b, strict, actualVisitedObjects) {
  if (a === null || a === undefined || b === null || b === undefined)
    return false;
  // if one is a primitive, the other must be same
  if (util.isPrimitive(a) || util.isPrimitive(b))
    return a === b;
  if (strict && Object.getPrototypeOf(a) !== Object.getPrototypeOf(b))
    return false;
  var aIsArgs = isArguments(a);
  var bIsArgs = isArguments(b);
  if ((aIsArgs && !bIsArgs) || (!aIsArgs && bIsArgs))
    return false;
  if (aIsArgs) {
    a = pSlice.call(a);
    b = pSlice.call(b);
    return _deepEqual(a, b, strict);
  }
  var ka = objectKeys(a);
  var kb = objectKeys(b);
  var key, i;
  // having the same number of owned properties (keys incorporates
  // hasOwnProperty)
  if (ka.length !== kb.length)
    return false;
  //the same set of keys (although not necessarily the same order),
  ka.sort();
  kb.sort();
  //~~~cheap key test
  for (i = ka.length - 1; i >= 0; i--) {
    if (ka[i] !== kb[i])
      return false;
  }
  //equivalent values for every corresponding key, and
  //~~~possibly expensive deep test
  for (i = ka.length - 1; i >= 0; i--) {
    key = ka[i];
    if (!_deepEqual(a[key], b[key], strict, actualVisitedObjects))
      return false;
  }
  return true;
}

// 8. The non-equivalence assertion tests for any deep inequality.
// assert.notDeepEqual(actual, expected, message_opt);

assert.notDeepEqual = function notDeepEqual(actual, expected, message) {
  if (_deepEqual(actual, expected, false)) {
    fail(actual, expected, message, 'notDeepEqual', assert.notDeepEqual);
  }
};

assert.notDeepStrictEqual = notDeepStrictEqual;
function notDeepStrictEqual(actual, expected, message) {
  if (_deepEqual(actual, expected, true)) {
    fail(actual, expected, message, 'notDeepStrictEqual', notDeepStrictEqual);
  }
}


// 9. The strict equality assertion tests strict equality, as determined by ===.
// assert.strictEqual(actual, expected, message_opt);

assert.strictEqual = function strictEqual(actual, expected, message) {
  if (actual !== expected) {
    fail(actual, expected, message, '===', assert.strictEqual);
  }
};

// 10. The strict non-equality assertion tests for strict inequality, as
// determined by !==.  assert.notStrictEqual(actual, expected, message_opt);

assert.notStrictEqual = function notStrictEqual(actual, expected, message) {
  if (actual === expected) {
    fail(actual, expected, message, '!==', assert.notStrictEqual);
  }
};

function expectedException(actual, expected) {
  if (!actual || !expected) {
    return false;
  }

  if (Object.prototype.toString.call(expected) == '[object RegExp]') {
    return expected.test(actual);
  }

  try {
    if (actual instanceof expected) {
      return true;
    }
  } catch (e) {
    // Ignore.  The instanceof check doesn't work for arrow functions.
  }

  if (Error.isPrototypeOf(expected)) {
    return false;
  }

  return expected.call({}, actual) === true;
}

function _tryBlock(block) {
  var error;
  try {
    block();
  } catch (e) {
    error = e;
  }
  return error;
}

function _throws(shouldThrow, block, expected, message) {
  var actual;

  if (typeof block !== 'function') {
    throw new TypeError('"block" argument must be a function');
  }

  if (typeof expected === 'string') {
    message = expected;
    expected = null;
  }

  actual = _tryBlock(block);

  message = (expected && expected.name ? ' (' + expected.name + ').' : '.') +
            (message ? ' ' + message : '.');

  if (shouldThrow && !actual) {
    fail(actual, expected, 'Missing expected exception' + message);
  }

  var userProvidedMessage = typeof message === 'string';
  var isUnwantedException = !shouldThrow && util.isError(actual);
  var isUnexpectedException = !shouldThrow && actual && !expected;

  if ((isUnwantedException &&
      userProvidedMessage &&
      expectedException(actual, expected)) ||
      isUnexpectedException) {
    fail(actual, expected, 'Got unwanted exception' + message);
  }

  if ((shouldThrow && actual && expected &&
      !expectedException(actual, expected)) || (!shouldThrow && actual)) {
    throw actual;
  }
}

// 11. Expected to throw an error:
// assert.throws(block, Error_opt, message_opt);

assert.throws = function(block, /*optional*/error, /*optional*/message) {
  _throws(true, block, error, message);
};

// EXTENSION! This is annoying to write outside this module.
assert.doesNotThrow = function(block, /*optional*/error, /*optional*/message) {
  _throws(false, block, error, message);
};

assert.ifError = function(err) { if (err) throw err; };

// Expose a strict only variant of assert
function strict(value, message) {
  if (!value) fail(value, true, message, '==', strict);
}
assert.strict = objectAssign(strict, assert, {
  equal: assert.strictEqual,
  deepEqual: assert.deepStrictEqual,
  notEqual: assert.notStrictEqual,
  notDeepEqual: assert.notDeepStrictEqual
});
assert.strict.strict = assert.strict;

var objectKeys = Object.keys || function (obj) {
  var keys = [];
  for (var key in obj) {
    if (hasOwn.call(obj, key)) keys.push(key);
  }
  return keys;
};


/***/ }),

/***/ 23697:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports["default"] = asyncify;

var _initialParams = __webpack_require__(75067);

var _initialParams2 = _interopRequireDefault(_initialParams);

var _setImmediate = __webpack_require__(39892);

var _setImmediate2 = _interopRequireDefault(_setImmediate);

var _wrapAsync = __webpack_require__(37879);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Take a sync function and make it async, passing its return value to a
 * callback. This is useful for plugging sync functions into a waterfall,
 * series, or other async functions. Any arguments passed to the generated
 * function will be passed to the wrapped function (except for the final
 * callback argument). Errors thrown will be passed to the callback.
 *
 * If the function passed to `asyncify` returns a Promise, that promises's
 * resolved/rejected state will be used to call the callback, rather than simply
 * the synchronous return value.
 *
 * This also means you can asyncify ES2017 `async` functions.
 *
 * @name asyncify
 * @static
 * @memberOf module:Utils
 * @method
 * @alias wrapSync
 * @category Util
 * @param {Function} func - The synchronous function, or Promise-returning
 * function to convert to an {@link AsyncFunction}.
 * @returns {AsyncFunction} An asynchronous wrapper of the `func`. To be
 * invoked with `(args..., callback)`.
 * @example
 *
 * // passing a regular synchronous function
 * async.waterfall([
 *     async.apply(fs.readFile, filename, "utf8"),
 *     async.asyncify(JSON.parse),
 *     function (data, next) {
 *         // data is the result of parsing the text.
 *         // If there was a parsing error, it would have been caught.
 *     }
 * ], callback);
 *
 * // passing a function returning a promise
 * async.waterfall([
 *     async.apply(fs.readFile, filename, "utf8"),
 *     async.asyncify(function (contents) {
 *         return db.model.create(contents);
 *     }),
 *     function (model, next) {
 *         // `model` is the instantiated model object.
 *         // If there was an error, this function would be skipped.
 *     }
 * ], callback);
 *
 * // es2017 example, though `asyncify` is not needed if your JS environment
 * // supports async functions out of the box
 * var q = async.queue(async.asyncify(async function(file) {
 *     var intermediateStep = await processFile(file);
 *     return await somePromise(intermediateStep)
 * }));
 *
 * q.push(files);
 */
function asyncify(func) {
    if ((0, _wrapAsync.isAsync)(func)) {
        return function (...args /*, callback*/) {
            const callback = args.pop();
            const promise = func.apply(this, args);
            return handlePromise(promise, callback);
        };
    }

    return (0, _initialParams2.default)(function (args, callback) {
        var result;
        try {
            result = func.apply(this, args);
        } catch (e) {
            return callback(e);
        }
        // if result is Promise object
        if (result && typeof result.then === 'function') {
            return handlePromise(result, callback);
        } else {
            callback(null, result);
        }
    });
}

function handlePromise(promise, callback) {
    return promise.then(value => {
        invokeCallback(callback, null, value);
    }, err => {
        invokeCallback(callback, err && (err instanceof Error || err.message) ? err : new Error(err));
    });
}

function invokeCallback(callback, error, value) {
    try {
        callback(error, value);
    } catch (err) {
        (0, _setImmediate2.default)(e => {
            throw e;
        }, err);
    }
}
module.exports = exports.default;

/***/ }),

/***/ 24078:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
    value: true
}));

var _isArrayLike = __webpack_require__(87597);

var _isArrayLike2 = _interopRequireDefault(_isArrayLike);

var _breakLoop = __webpack_require__(48284);

var _breakLoop2 = _interopRequireDefault(_breakLoop);

var _eachOfLimit = __webpack_require__(80050);

var _eachOfLimit2 = _interopRequireDefault(_eachOfLimit);

var _once = __webpack_require__(50612);

var _once2 = _interopRequireDefault(_once);

var _onlyOnce = __webpack_require__(41029);

var _onlyOnce2 = _interopRequireDefault(_onlyOnce);

var _wrapAsync = __webpack_require__(37879);

var _wrapAsync2 = _interopRequireDefault(_wrapAsync);

var _awaitify = __webpack_require__(67327);

var _awaitify2 = _interopRequireDefault(_awaitify);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// eachOf implementation optimized for array-likes
function eachOfArrayLike(coll, iteratee, callback) {
    callback = (0, _once2.default)(callback);
    var index = 0,
        completed = 0,
        { length } = coll,
        canceled = false;
    if (length === 0) {
        callback(null);
    }

    function iteratorCallback(err, value) {
        if (err === false) {
            canceled = true;
        }
        if (canceled === true) return;
        if (err) {
            callback(err);
        } else if (++completed === length || value === _breakLoop2.default) {
            callback(null);
        }
    }

    for (; index < length; index++) {
        iteratee(coll[index], index, (0, _onlyOnce2.default)(iteratorCallback));
    }
}

// a generic version of eachOf which can handle array, object, and iterator cases.
function eachOfGeneric(coll, iteratee, callback) {
    return (0, _eachOfLimit2.default)(coll, Infinity, iteratee, callback);
}

/**
 * Like [`each`]{@link module:Collections.each}, except that it passes the key (or index) as the second argument
 * to the iteratee.
 *
 * @name eachOf
 * @static
 * @memberOf module:Collections
 * @method
 * @alias forEachOf
 * @category Collection
 * @see [async.each]{@link module:Collections.each}
 * @param {Array|Iterable|AsyncIterable|Object} coll - A collection to iterate over.
 * @param {AsyncFunction} iteratee - A function to apply to each
 * item in `coll`.
 * The `key` is the item's key, or index in the case of an array.
 * Invoked with (item, key, callback).
 * @param {Function} [callback] - A callback which is called when all
 * `iteratee` functions have finished, or an error occurs. Invoked with (err).
 * @returns {Promise} a promise, if a callback is omitted
 * @example
 *
 * // dev.json is a file containing a valid json object config for dev environment
 * // dev.json is a file containing a valid json object config for test environment
 * // prod.json is a file containing a valid json object config for prod environment
 * // invalid.json is a file with a malformed json object
 *
 * let configs = {}; //global variable
 * let validConfigFileMap = {dev: 'dev.json', test: 'test.json', prod: 'prod.json'};
 * let invalidConfigFileMap = {dev: 'dev.json', test: 'test.json', invalid: 'invalid.json'};
 *
 * // asynchronous function that reads a json file and parses the contents as json object
 * function parseFile(file, key, callback) {
 *     fs.readFile(file, "utf8", function(err, data) {
 *         if (err) return calback(err);
 *         try {
 *             configs[key] = JSON.parse(data);
 *         } catch (e) {
 *             return callback(e);
 *         }
 *         callback();
 *     });
 * }
 *
 * // Using callbacks
 * async.forEachOf(validConfigFileMap, parseFile, function (err) {
 *     if (err) {
 *         console.error(err);
 *     } else {
 *         console.log(configs);
 *         // configs is now a map of JSON data, e.g.
 *         // { dev: //parsed dev.json, test: //parsed test.json, prod: //parsed prod.json}
 *     }
 * });
 *
 * //Error handing
 * async.forEachOf(invalidConfigFileMap, parseFile, function (err) {
 *     if (err) {
 *         console.error(err);
 *         // JSON parse error exception
 *     } else {
 *         console.log(configs);
 *     }
 * });
 *
 * // Using Promises
 * async.forEachOf(validConfigFileMap, parseFile)
 * .then( () => {
 *     console.log(configs);
 *     // configs is now a map of JSON data, e.g.
 *     // { dev: //parsed dev.json, test: //parsed test.json, prod: //parsed prod.json}
 * }).catch( err => {
 *     console.error(err);
 * });
 *
 * //Error handing
 * async.forEachOf(invalidConfigFileMap, parseFile)
 * .then( () => {
 *     console.log(configs);
 * }).catch( err => {
 *     console.error(err);
 *     // JSON parse error exception
 * });
 *
 * // Using async/await
 * async () => {
 *     try {
 *         let result = await async.forEachOf(validConfigFileMap, parseFile);
 *         console.log(configs);
 *         // configs is now a map of JSON data, e.g.
 *         // { dev: //parsed dev.json, test: //parsed test.json, prod: //parsed prod.json}
 *     }
 *     catch (err) {
 *         console.log(err);
 *     }
 * }
 *
 * //Error handing
 * async () => {
 *     try {
 *         let result = await async.forEachOf(invalidConfigFileMap, parseFile);
 *         console.log(configs);
 *     }
 *     catch (err) {
 *         console.log(err);
 *         // JSON parse error exception
 *     }
 * }
 *
 */
function eachOf(coll, iteratee, callback) {
    var eachOfImplementation = (0, _isArrayLike2.default)(coll) ? eachOfArrayLike : eachOfGeneric;
    return eachOfImplementation(coll, (0, _wrapAsync2.default)(iteratee), callback);
}

exports["default"] = (0, _awaitify2.default)(eachOf, 3);
module.exports = exports.default;

/***/ }),

/***/ 80050:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
    value: true
}));

var _eachOfLimit2 = __webpack_require__(78007);

var _eachOfLimit3 = _interopRequireDefault(_eachOfLimit2);

var _wrapAsync = __webpack_require__(37879);

var _wrapAsync2 = _interopRequireDefault(_wrapAsync);

var _awaitify = __webpack_require__(67327);

var _awaitify2 = _interopRequireDefault(_awaitify);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * The same as [`eachOf`]{@link module:Collections.eachOf} but runs a maximum of `limit` async operations at a
 * time.
 *
 * @name eachOfLimit
 * @static
 * @memberOf module:Collections
 * @method
 * @see [async.eachOf]{@link module:Collections.eachOf}
 * @alias forEachOfLimit
 * @category Collection
 * @param {Array|Iterable|AsyncIterable|Object} coll - A collection to iterate over.
 * @param {number} limit - The maximum number of async operations at a time.
 * @param {AsyncFunction} iteratee - An async function to apply to each
 * item in `coll`. The `key` is the item's key, or index in the case of an
 * array.
 * Invoked with (item, key, callback).
 * @param {Function} [callback] - A callback which is called when all
 * `iteratee` functions have finished, or an error occurs. Invoked with (err).
 * @returns {Promise} a promise, if a callback is omitted
 */
function eachOfLimit(coll, limit, iteratee, callback) {
    return (0, _eachOfLimit3.default)(limit)(coll, (0, _wrapAsync2.default)(iteratee), callback);
}

exports["default"] = (0, _awaitify2.default)(eachOfLimit, 4);
module.exports = exports.default;

/***/ }),

/***/ 31479:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
    value: true
}));

var _eachOfLimit = __webpack_require__(80050);

var _eachOfLimit2 = _interopRequireDefault(_eachOfLimit);

var _awaitify = __webpack_require__(67327);

var _awaitify2 = _interopRequireDefault(_awaitify);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * The same as [`eachOf`]{@link module:Collections.eachOf} but runs only a single async operation at a time.
 *
 * @name eachOfSeries
 * @static
 * @memberOf module:Collections
 * @method
 * @see [async.eachOf]{@link module:Collections.eachOf}
 * @alias forEachOfSeries
 * @category Collection
 * @param {Array|Iterable|AsyncIterable|Object} coll - A collection to iterate over.
 * @param {AsyncFunction} iteratee - An async function to apply to each item in
 * `coll`.
 * Invoked with (item, key, callback).
 * @param {Function} [callback] - A callback which is called when all `iteratee`
 * functions have finished, or an error occurs. Invoked with (err).
 * @returns {Promise} a promise, if a callback is omitted
 */
function eachOfSeries(coll, iteratee, callback) {
    return (0, _eachOfLimit2.default)(coll, 1, iteratee, callback);
}
exports["default"] = (0, _awaitify2.default)(eachOfSeries, 3);
module.exports = exports.default;

/***/ }),

/***/ 42777:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
    value: true
}));

var _eachOf = __webpack_require__(24078);

var _eachOf2 = _interopRequireDefault(_eachOf);

var _withoutIndex = __webpack_require__(74925);

var _withoutIndex2 = _interopRequireDefault(_withoutIndex);

var _wrapAsync = __webpack_require__(37879);

var _wrapAsync2 = _interopRequireDefault(_wrapAsync);

var _awaitify = __webpack_require__(67327);

var _awaitify2 = _interopRequireDefault(_awaitify);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Applies the function `iteratee` to each item in `coll`, in parallel.
 * The `iteratee` is called with an item from the list, and a callback for when
 * it has finished. If the `iteratee` passes an error to its `callback`, the
 * main `callback` (for the `each` function) is immediately called with the
 * error.
 *
 * Note, that since this function applies `iteratee` to each item in parallel,
 * there is no guarantee that the iteratee functions will complete in order.
 *
 * @name each
 * @static
 * @memberOf module:Collections
 * @method
 * @alias forEach
 * @category Collection
 * @param {Array|Iterable|AsyncIterable|Object} coll - A collection to iterate over.
 * @param {AsyncFunction} iteratee - An async function to apply to
 * each item in `coll`. Invoked with (item, callback).
 * The array index is not passed to the iteratee.
 * If you need the index, use `eachOf`.
 * @param {Function} [callback] - A callback which is called when all
 * `iteratee` functions have finished, or an error occurs. Invoked with (err).
 * @returns {Promise} a promise, if a callback is omitted
 * @example
 *
 * // dir1 is a directory that contains file1.txt, file2.txt
 * // dir2 is a directory that contains file3.txt, file4.txt
 * // dir3 is a directory that contains file5.txt
 * // dir4 does not exist
 *
 * const fileList = [ 'dir1/file2.txt', 'dir2/file3.txt', 'dir/file5.txt'];
 * const withMissingFileList = ['dir1/file1.txt', 'dir4/file2.txt'];
 *
 * // asynchronous function that deletes a file
 * const deleteFile = function(file, callback) {
 *     fs.unlink(file, callback);
 * };
 *
 * // Using callbacks
 * async.each(fileList, deleteFile, function(err) {
 *     if( err ) {
 *         console.log(err);
 *     } else {
 *         console.log('All files have been deleted successfully');
 *     }
 * });
 *
 * // Error Handling
 * async.each(withMissingFileList, deleteFile, function(err){
 *     console.log(err);
 *     // [ Error: ENOENT: no such file or directory ]
 *     // since dir4/file2.txt does not exist
 *     // dir1/file1.txt could have been deleted
 * });
 *
 * // Using Promises
 * async.each(fileList, deleteFile)
 * .then( () => {
 *     console.log('All files have been deleted successfully');
 * }).catch( err => {
 *     console.log(err);
 * });
 *
 * // Error Handling
 * async.each(fileList, deleteFile)
 * .then( () => {
 *     console.log('All files have been deleted successfully');
 * }).catch( err => {
 *     console.log(err);
 *     // [ Error: ENOENT: no such file or directory ]
 *     // since dir4/file2.txt does not exist
 *     // dir1/file1.txt could have been deleted
 * });
 *
 * // Using async/await
 * async () => {
 *     try {
 *         await async.each(files, deleteFile);
 *     }
 *     catch (err) {
 *         console.log(err);
 *     }
 * }
 *
 * // Error Handling
 * async () => {
 *     try {
 *         await async.each(withMissingFileList, deleteFile);
 *     }
 *     catch (err) {
 *         console.log(err);
 *         // [ Error: ENOENT: no such file or directory ]
 *         // since dir4/file2.txt does not exist
 *         // dir1/file1.txt could have been deleted
 *     }
 * }
 *
 */
function eachLimit(coll, iteratee, callback) {
    return (0, _eachOf2.default)(coll, (0, _withoutIndex2.default)((0, _wrapAsync2.default)(iteratee)), callback);
}

exports["default"] = (0, _awaitify2.default)(eachLimit, 3);
module.exports = exports.default;

/***/ }),

/***/ 28182:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports["default"] = asyncEachOfLimit;

var _breakLoop = __webpack_require__(48284);

var _breakLoop2 = _interopRequireDefault(_breakLoop);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// for async generators
function asyncEachOfLimit(generator, limit, iteratee, callback) {
    let done = false;
    let canceled = false;
    let awaiting = false;
    let running = 0;
    let idx = 0;

    function replenish() {
        //console.log('replenish')
        if (running >= limit || awaiting || done) return;
        //console.log('replenish awaiting')
        awaiting = true;
        generator.next().then(({ value, done: iterDone }) => {
            //console.log('got value', value)
            if (canceled || done) return;
            awaiting = false;
            if (iterDone) {
                done = true;
                if (running <= 0) {
                    //console.log('done nextCb')
                    callback(null);
                }
                return;
            }
            running++;
            iteratee(value, idx, iterateeCallback);
            idx++;
            replenish();
        }).catch(handleError);
    }

    function iterateeCallback(err, result) {
        //console.log('iterateeCallback')
        running -= 1;
        if (canceled) return;
        if (err) return handleError(err);

        if (err === false) {
            done = true;
            canceled = true;
            return;
        }

        if (result === _breakLoop2.default || done && running <= 0) {
            done = true;
            //console.log('done iterCb')
            return callback(null);
        }
        replenish();
    }

    function handleError(err) {
        if (canceled) return;
        awaiting = false;
        done = true;
        callback(err);
    }

    replenish();
}
module.exports = exports.default;

/***/ }),

/***/ 67327:
/***/ (function(module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports["default"] = awaitify;
// conditionally promisify a function.
// only return a promise if a callback is omitted
function awaitify(asyncFn, arity) {
    if (!arity) arity = asyncFn.length;
    if (!arity) throw new Error('arity is undefined');
    function awaitable(...args) {
        if (typeof args[arity - 1] === 'function') {
            return asyncFn.apply(this, args);
        }

        return new Promise((resolve, reject) => {
            args[arity - 1] = (err, ...cbArgs) => {
                if (err) return reject(err);
                resolve(cbArgs.length > 1 ? cbArgs : cbArgs[0]);
            };
            asyncFn.apply(this, args);
        });
    }

    return awaitable;
}
module.exports = exports.default;

/***/ }),

/***/ 48284:
/***/ (function(module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
    value: true
}));
// A temporary value used to identify if the loop should be broken.
// See #1064, #1293
const breakLoop = {};
exports["default"] = breakLoop;
module.exports = exports.default;

/***/ }),

/***/ 78007:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
    value: true
}));

var _once = __webpack_require__(50612);

var _once2 = _interopRequireDefault(_once);

var _iterator = __webpack_require__(43968);

var _iterator2 = _interopRequireDefault(_iterator);

var _onlyOnce = __webpack_require__(41029);

var _onlyOnce2 = _interopRequireDefault(_onlyOnce);

var _wrapAsync = __webpack_require__(37879);

var _asyncEachOfLimit = __webpack_require__(28182);

var _asyncEachOfLimit2 = _interopRequireDefault(_asyncEachOfLimit);

var _breakLoop = __webpack_require__(48284);

var _breakLoop2 = _interopRequireDefault(_breakLoop);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports["default"] = limit => {
    return (obj, iteratee, callback) => {
        callback = (0, _once2.default)(callback);
        if (limit <= 0) {
            throw new RangeError('concurrency limit cannot be less than 1');
        }
        if (!obj) {
            return callback(null);
        }
        if ((0, _wrapAsync.isAsyncGenerator)(obj)) {
            return (0, _asyncEachOfLimit2.default)(obj, limit, iteratee, callback);
        }
        if ((0, _wrapAsync.isAsyncIterable)(obj)) {
            return (0, _asyncEachOfLimit2.default)(obj[Symbol.asyncIterator](), limit, iteratee, callback);
        }
        var nextElem = (0, _iterator2.default)(obj);
        var done = false;
        var canceled = false;
        var running = 0;
        var looping = false;

        function iterateeCallback(err, value) {
            if (canceled) return;
            running -= 1;
            if (err) {
                done = true;
                callback(err);
            } else if (err === false) {
                done = true;
                canceled = true;
            } else if (value === _breakLoop2.default || done && running <= 0) {
                done = true;
                return callback(null);
            } else if (!looping) {
                replenish();
            }
        }

        function replenish() {
            looping = true;
            while (running < limit && !done) {
                var elem = nextElem();
                if (elem === null) {
                    done = true;
                    if (running <= 0) {
                        callback(null);
                    }
                    return;
                }
                running += 1;
                iteratee(elem.value, elem.key, (0, _onlyOnce2.default)(iterateeCallback));
            }
            looping = false;
        }

        replenish();
    };
};

module.exports = exports.default;

/***/ }),

/***/ 12896:
/***/ (function(module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
    value: true
}));

exports["default"] = function (coll) {
    return coll[Symbol.iterator] && coll[Symbol.iterator]();
};

module.exports = exports.default;

/***/ }),

/***/ 75067:
/***/ (function(module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
    value: true
}));

exports["default"] = function (fn) {
    return function (...args /*, callback*/) {
        var callback = args.pop();
        return fn.call(this, args, callback);
    };
};

module.exports = exports.default;

/***/ }),

/***/ 87597:
/***/ (function(module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports["default"] = isArrayLike;
function isArrayLike(value) {
    return value && typeof value.length === 'number' && value.length >= 0 && value.length % 1 === 0;
}
module.exports = exports.default;

/***/ }),

/***/ 43968:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports["default"] = createIterator;

var _isArrayLike = __webpack_require__(87597);

var _isArrayLike2 = _interopRequireDefault(_isArrayLike);

var _getIterator = __webpack_require__(12896);

var _getIterator2 = _interopRequireDefault(_getIterator);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function createArrayIterator(coll) {
    var i = -1;
    var len = coll.length;
    return function next() {
        return ++i < len ? { value: coll[i], key: i } : null;
    };
}

function createES2015Iterator(iterator) {
    var i = -1;
    return function next() {
        var item = iterator.next();
        if (item.done) return null;
        i++;
        return { value: item.value, key: i };
    };
}

function createObjectIterator(obj) {
    var okeys = obj ? Object.keys(obj) : [];
    var i = -1;
    var len = okeys.length;
    return function next() {
        var key = okeys[++i];
        if (key === '__proto__') {
            return next();
        }
        return i < len ? { value: obj[key], key } : null;
    };
}

function createIterator(coll) {
    if ((0, _isArrayLike2.default)(coll)) {
        return createArrayIterator(coll);
    }

    var iterator = (0, _getIterator2.default)(coll);
    return iterator ? createES2015Iterator(iterator) : createObjectIterator(coll);
}
module.exports = exports.default;

/***/ }),

/***/ 50612:
/***/ (function(module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports["default"] = once;
function once(fn) {
    function wrapper(...args) {
        if (fn === null) return;
        var callFn = fn;
        fn = null;
        callFn.apply(this, args);
    }
    Object.assign(wrapper, fn);
    return wrapper;
}
module.exports = exports.default;

/***/ }),

/***/ 41029:
/***/ (function(module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports["default"] = onlyOnce;
function onlyOnce(fn) {
    return function (...args) {
        if (fn === null) throw new Error("Callback was already called.");
        var callFn = fn;
        fn = null;
        callFn.apply(this, args);
    };
}
module.exports = exports.default;

/***/ }),

/***/ 5868:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
    value: true
}));

var _isArrayLike = __webpack_require__(87597);

var _isArrayLike2 = _interopRequireDefault(_isArrayLike);

var _wrapAsync = __webpack_require__(37879);

var _wrapAsync2 = _interopRequireDefault(_wrapAsync);

var _awaitify = __webpack_require__(67327);

var _awaitify2 = _interopRequireDefault(_awaitify);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports["default"] = (0, _awaitify2.default)((eachfn, tasks, callback) => {
    var results = (0, _isArrayLike2.default)(tasks) ? [] : {};

    eachfn(tasks, (task, key, taskCb) => {
        (0, _wrapAsync2.default)(task)((err, ...result) => {
            if (result.length < 2) {
                [result] = result;
            }
            results[key] = result;
            taskCb(err);
        });
    }, err => callback(err, results));
}, 3);
module.exports = exports.default;

/***/ }),

/***/ 39892:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
/* provided dependency */ var process = __webpack_require__(14224);


Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.fallback = fallback;
exports.wrap = wrap;
/* istanbul ignore file */

var hasQueueMicrotask = exports.hasQueueMicrotask = typeof queueMicrotask === 'function' && queueMicrotask;
var hasSetImmediate = exports.hasSetImmediate = typeof setImmediate === 'function' && setImmediate;
var hasNextTick = exports.hasNextTick = typeof process === 'object' && typeof process.nextTick === 'function';

function fallback(fn) {
    setTimeout(fn, 0);
}

function wrap(defer) {
    return (fn, ...args) => defer(() => fn(...args));
}

var _defer;

if (hasQueueMicrotask) {
    _defer = queueMicrotask;
} else if (hasSetImmediate) {
    _defer = setImmediate;
} else if (hasNextTick) {
    _defer = process.nextTick;
} else {
    _defer = fallback;
}

exports["default"] = wrap(_defer);

/***/ }),

/***/ 74925:
/***/ (function(module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports["default"] = _withoutIndex;
function _withoutIndex(iteratee) {
    return (value, index, callback) => iteratee(value, callback);
}
module.exports = exports.default;

/***/ }),

/***/ 37879:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.isAsyncIterable = exports.isAsyncGenerator = exports.isAsync = undefined;

var _asyncify = __webpack_require__(23697);

var _asyncify2 = _interopRequireDefault(_asyncify);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function isAsync(fn) {
    return fn[Symbol.toStringTag] === 'AsyncFunction';
}

function isAsyncGenerator(fn) {
    return fn[Symbol.toStringTag] === 'AsyncGenerator';
}

function isAsyncIterable(obj) {
    return typeof obj[Symbol.asyncIterator] === 'function';
}

function wrapAsync(asyncFn) {
    if (typeof asyncFn !== 'function') throw new Error('expected a function');
    return isAsync(asyncFn) ? (0, _asyncify2.default)(asyncFn) : asyncFn;
}

exports["default"] = wrapAsync;
exports.isAsync = isAsync;
exports.isAsyncGenerator = isAsyncGenerator;
exports.isAsyncIterable = isAsyncIterable;

/***/ }),

/***/ 18091:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports["default"] = series;

var _parallel2 = __webpack_require__(5868);

var _parallel3 = _interopRequireDefault(_parallel2);

var _eachOfSeries = __webpack_require__(31479);

var _eachOfSeries2 = _interopRequireDefault(_eachOfSeries);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Run the functions in the `tasks` collection in series, each one running once
 * the previous function has completed. If any functions in the series pass an
 * error to its callback, no more functions are run, and `callback` is
 * immediately called with the value of the error. Otherwise, `callback`
 * receives an array of results when `tasks` have completed.
 *
 * It is also possible to use an object instead of an array. Each property will
 * be run as a function, and the results will be passed to the final `callback`
 * as an object instead of an array. This can be a more readable way of handling
 *  results from {@link async.series}.
 *
 * **Note** that while many implementations preserve the order of object
 * properties, the [ECMAScript Language Specification](http://www.ecma-international.org/ecma-262/5.1/#sec-8.6)
 * explicitly states that
 *
 * > The mechanics and order of enumerating the properties is not specified.
 *
 * So if you rely on the order in which your series of functions are executed,
 * and want this to work on all platforms, consider using an array.
 *
 * @name series
 * @static
 * @memberOf module:ControlFlow
 * @method
 * @category Control Flow
 * @param {Array|Iterable|AsyncIterable|Object} tasks - A collection containing
 * [async functions]{@link AsyncFunction} to run in series.
 * Each function can complete with any number of optional `result` values.
 * @param {Function} [callback] - An optional callback to run once all the
 * functions have completed. This function gets a results array (or object)
 * containing all the result arguments passed to the `task` callbacks. Invoked
 * with (err, result).
 * @return {Promise} a promise, if no callback is passed
 * @example
 *
 * //Using Callbacks
 * async.series([
 *     function(callback) {
 *         setTimeout(function() {
 *             // do some async task
 *             callback(null, 'one');
 *         }, 200);
 *     },
 *     function(callback) {
 *         setTimeout(function() {
 *             // then do another async task
 *             callback(null, 'two');
 *         }, 100);
 *     }
 * ], function(err, results) {
 *     console.log(results);
 *     // results is equal to ['one','two']
 * });
 *
 * // an example using objects instead of arrays
 * async.series({
 *     one: function(callback) {
 *         setTimeout(function() {
 *             // do some async task
 *             callback(null, 1);
 *         }, 200);
 *     },
 *     two: function(callback) {
 *         setTimeout(function() {
 *             // then do another async task
 *             callback(null, 2);
 *         }, 100);
 *     }
 * }, function(err, results) {
 *     console.log(results);
 *     // results is equal to: { one: 1, two: 2 }
 * });
 *
 * //Using Promises
 * async.series([
 *     function(callback) {
 *         setTimeout(function() {
 *             callback(null, 'one');
 *         }, 200);
 *     },
 *     function(callback) {
 *         setTimeout(function() {
 *             callback(null, 'two');
 *         }, 100);
 *     }
 * ]).then(results => {
 *     console.log(results);
 *     // results is equal to ['one','two']
 * }).catch(err => {
 *     console.log(err);
 * });
 *
 * // an example using an object instead of an array
 * async.series({
 *     one: function(callback) {
 *         setTimeout(function() {
 *             // do some async task
 *             callback(null, 1);
 *         }, 200);
 *     },
 *     two: function(callback) {
 *         setTimeout(function() {
 *             // then do another async task
 *             callback(null, 2);
 *         }, 100);
 *     }
 * }).then(results => {
 *     console.log(results);
 *     // results is equal to: { one: 1, two: 2 }
 * }).catch(err => {
 *     console.log(err);
 * });
 *
 * //Using async/await
 * async () => {
 *     try {
 *         let results = await async.series([
 *             function(callback) {
 *                 setTimeout(function() {
 *                     // do some async task
 *                     callback(null, 'one');
 *                 }, 200);
 *             },
 *             function(callback) {
 *                 setTimeout(function() {
 *                     // then do another async task
 *                     callback(null, 'two');
 *                 }, 100);
 *             }
 *         ]);
 *         console.log(results);
 *         // results is equal to ['one','two']
 *     }
 *     catch (err) {
 *         console.log(err);
 *     }
 * }
 *
 * // an example using an object instead of an array
 * async () => {
 *     try {
 *         let results = await async.parallel({
 *             one: function(callback) {
 *                 setTimeout(function() {
 *                     // do some async task
 *                     callback(null, 1);
 *                 }, 200);
 *             },
 *            two: function(callback) {
 *                 setTimeout(function() {
 *                     // then do another async task
 *                     callback(null, 2);
 *                 }, 100);
 *            }
 *         });
 *         console.log(results);
 *         // results is equal to: { one: 1, two: 2 }
 *     }
 *     catch (err) {
 *         console.log(err);
 *     }
 * }
 *
 */
function series(tasks, callback) {
    return (0, _parallel3.default)(_eachOfSeries2.default, tasks, callback);
}
module.exports = exports.default;

/***/ }),

/***/ 65415:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


exports.byteLength = byteLength
exports.toByteArray = toByteArray
exports.fromByteArray = fromByteArray

var lookup = []
var revLookup = []
var Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array

var code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/'
for (var i = 0, len = code.length; i < len; ++i) {
  lookup[i] = code[i]
  revLookup[code.charCodeAt(i)] = i
}

// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
revLookup['-'.charCodeAt(0)] = 62
revLookup['_'.charCodeAt(0)] = 63

function getLens (b64) {
  var len = b64.length

  if (len % 4 > 0) {
    throw new Error('Invalid string. Length must be a multiple of 4')
  }

  // Trim off extra bytes after placeholder bytes are found
  // See: https://github.com/beatgammit/base64-js/issues/42
  var validLen = b64.indexOf('=')
  if (validLen === -1) validLen = len

  var placeHoldersLen = validLen === len
    ? 0
    : 4 - (validLen % 4)

  return [validLen, placeHoldersLen]
}

// base64 is 4/3 + up to two characters of the original data
function byteLength (b64) {
  var lens = getLens(b64)
  var validLen = lens[0]
  var placeHoldersLen = lens[1]
  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
}

function _byteLength (b64, validLen, placeHoldersLen) {
  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
}

function toByteArray (b64) {
  var tmp
  var lens = getLens(b64)
  var validLen = lens[0]
  var placeHoldersLen = lens[1]

  var arr = new Arr(_byteLength(b64, validLen, placeHoldersLen))

  var curByte = 0

  // if there are placeholders, only get up to the last complete 4 chars
  var len = placeHoldersLen > 0
    ? validLen - 4
    : validLen

  var i
  for (i = 0; i < len; i += 4) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 18) |
      (revLookup[b64.charCodeAt(i + 1)] << 12) |
      (revLookup[b64.charCodeAt(i + 2)] << 6) |
      revLookup[b64.charCodeAt(i + 3)]
    arr[curByte++] = (tmp >> 16) & 0xFF
    arr[curByte++] = (tmp >> 8) & 0xFF
    arr[curByte++] = tmp & 0xFF
  }

  if (placeHoldersLen === 2) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 2) |
      (revLookup[b64.charCodeAt(i + 1)] >> 4)
    arr[curByte++] = tmp & 0xFF
  }

  if (placeHoldersLen === 1) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 10) |
      (revLookup[b64.charCodeAt(i + 1)] << 4) |
      (revLookup[b64.charCodeAt(i + 2)] >> 2)
    arr[curByte++] = (tmp >> 8) & 0xFF
    arr[curByte++] = tmp & 0xFF
  }

  return arr
}

function tripletToBase64 (num) {
  return lookup[num >> 18 & 0x3F] +
    lookup[num >> 12 & 0x3F] +
    lookup[num >> 6 & 0x3F] +
    lookup[num & 0x3F]
}

function encodeChunk (uint8, start, end) {
  var tmp
  var output = []
  for (var i = start; i < end; i += 3) {
    tmp =
      ((uint8[i] << 16) & 0xFF0000) +
      ((uint8[i + 1] << 8) & 0xFF00) +
      (uint8[i + 2] & 0xFF)
    output.push(tripletToBase64(tmp))
  }
  return output.join('')
}

function fromByteArray (uint8) {
  var tmp
  var len = uint8.length
  var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
  var parts = []
  var maxChunkLength = 16383 // must be multiple of 3

  // go through the array every three bytes, we'll deal with trailing stuff later
  for (var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength) {
    parts.push(encodeChunk(uint8, i, (i + maxChunkLength) > len2 ? len2 : (i + maxChunkLength)))
  }

  // pad the end with zeros, but make sure to not forget the extra bytes
  if (extraBytes === 1) {
    tmp = uint8[len - 1]
    parts.push(
      lookup[tmp >> 2] +
      lookup[(tmp << 4) & 0x3F] +
      '=='
    )
  } else if (extraBytes === 2) {
    tmp = (uint8[len - 2] << 8) + uint8[len - 1]
    parts.push(
      lookup[tmp >> 10] +
      lookup[(tmp >> 4) & 0x3F] +
      lookup[(tmp << 2) & 0x3F] +
      '='
    )
  }

  return parts.join('')
}


/***/ }),

/***/ 55872:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */
/* eslint-disable no-proto */



const base64 = __webpack_require__(65415)
const ieee754 = __webpack_require__(30551)
const customInspectSymbol =
  (typeof Symbol === 'function' && typeof Symbol['for'] === 'function') // eslint-disable-line dot-notation
    ? Symbol['for']('nodejs.util.inspect.custom') // eslint-disable-line dot-notation
    : null

exports.Buffer = Buffer
exports.SlowBuffer = SlowBuffer
exports.INSPECT_MAX_BYTES = 50

const K_MAX_LENGTH = 0x7fffffff
exports.kMaxLength = K_MAX_LENGTH

/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */
Buffer.TYPED_ARRAY_SUPPORT = typedArraySupport()

if (!Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' &&
    typeof console.error === 'function') {
  console.error(
    'This browser lacks typed array (Uint8Array) support which is required by ' +
    '`buffer` v5.x. Use `buffer` v4.x if you require old browser support.'
  )
}

function typedArraySupport () {
  // Can typed array instances can be augmented?
  try {
    const arr = new Uint8Array(1)
    const proto = { foo: function () { return 42 } }
    Object.setPrototypeOf(proto, Uint8Array.prototype)
    Object.setPrototypeOf(arr, proto)
    return arr.foo() === 42
  } catch (e) {
    return false
  }
}

Object.defineProperty(Buffer.prototype, 'parent', {
  enumerable: true,
  get: function () {
    if (!Buffer.isBuffer(this)) return undefined
    return this.buffer
  }
})

Object.defineProperty(Buffer.prototype, 'offset', {
  enumerable: true,
  get: function () {
    if (!Buffer.isBuffer(this)) return undefined
    return this.byteOffset
  }
})

function createBuffer (length) {
  if (length > K_MAX_LENGTH) {
    throw new RangeError('The value "' + length + '" is invalid for option "size"')
  }
  // Return an augmented `Uint8Array` instance
  const buf = new Uint8Array(length)
  Object.setPrototypeOf(buf, Buffer.prototype)
  return buf
}

/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */

function Buffer (arg, encodingOrOffset, length) {
  // Common case.
  if (typeof arg === 'number') {
    if (typeof encodingOrOffset === 'string') {
      throw new TypeError(
        'The "string" argument must be of type string. Received type number'
      )
    }
    return allocUnsafe(arg)
  }
  return from(arg, encodingOrOffset, length)
}

Buffer.poolSize = 8192 // not used by this implementation

function from (value, encodingOrOffset, length) {
  if (typeof value === 'string') {
    return fromString(value, encodingOrOffset)
  }

  if (ArrayBuffer.isView(value)) {
    return fromArrayView(value)
  }

  if (value == null) {
    throw new TypeError(
      'The first argument must be one of type string, Buffer, ArrayBuffer, Array, ' +
      'or Array-like Object. Received type ' + (typeof value)
    )
  }

  if (isInstance(value, ArrayBuffer) ||
      (value && isInstance(value.buffer, ArrayBuffer))) {
    return fromArrayBuffer(value, encodingOrOffset, length)
  }

  if (typeof SharedArrayBuffer !== 'undefined' &&
      (isInstance(value, SharedArrayBuffer) ||
      (value && isInstance(value.buffer, SharedArrayBuffer)))) {
    return fromArrayBuffer(value, encodingOrOffset, length)
  }

  if (typeof value === 'number') {
    throw new TypeError(
      'The "value" argument must not be of type number. Received type number'
    )
  }

  const valueOf = value.valueOf && value.valueOf()
  if (valueOf != null && valueOf !== value) {
    return Buffer.from(valueOf, encodingOrOffset, length)
  }

  const b = fromObject(value)
  if (b) return b

  if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null &&
      typeof value[Symbol.toPrimitive] === 'function') {
    return Buffer.from(value[Symbol.toPrimitive]('string'), encodingOrOffset, length)
  }

  throw new TypeError(
    'The first argument must be one of type string, Buffer, ArrayBuffer, Array, ' +
    'or Array-like Object. Received type ' + (typeof value)
  )
}

/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/
Buffer.from = function (value, encodingOrOffset, length) {
  return from(value, encodingOrOffset, length)
}

// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf(Buffer.prototype, Uint8Array.prototype)
Object.setPrototypeOf(Buffer, Uint8Array)

function assertSize (size) {
  if (typeof size !== 'number') {
    throw new TypeError('"size" argument must be of type number')
  } else if (size < 0) {
    throw new RangeError('The value "' + size + '" is invalid for option "size"')
  }
}

function alloc (size, fill, encoding) {
  assertSize(size)
  if (size <= 0) {
    return createBuffer(size)
  }
  if (fill !== undefined) {
    // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === 'string'
      ? createBuffer(size).fill(fill, encoding)
      : createBuffer(size).fill(fill)
  }
  return createBuffer(size)
}

/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/
Buffer.alloc = function (size, fill, encoding) {
  return alloc(size, fill, encoding)
}

function allocUnsafe (size) {
  assertSize(size)
  return createBuffer(size < 0 ? 0 : checked(size) | 0)
}

/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */
Buffer.allocUnsafe = function (size) {
  return allocUnsafe(size)
}
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */
Buffer.allocUnsafeSlow = function (size) {
  return allocUnsafe(size)
}

function fromString (string, encoding) {
  if (typeof encoding !== 'string' || encoding === '') {
    encoding = 'utf8'
  }

  if (!Buffer.isEncoding(encoding)) {
    throw new TypeError('Unknown encoding: ' + encoding)
  }

  const length = byteLength(string, encoding) | 0
  let buf = createBuffer(length)

  const actual = buf.write(string, encoding)

  if (actual !== length) {
    // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual)
  }

  return buf
}

function fromArrayLike (array) {
  const length = array.length < 0 ? 0 : checked(array.length) | 0
  const buf = createBuffer(length)
  for (let i = 0; i < length; i += 1) {
    buf[i] = array[i] & 255
  }
  return buf
}

function fromArrayView (arrayView) {
  if (isInstance(arrayView, Uint8Array)) {
    const copy = new Uint8Array(arrayView)
    return fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength)
  }
  return fromArrayLike(arrayView)
}

function fromArrayBuffer (array, byteOffset, length) {
  if (byteOffset < 0 || array.byteLength < byteOffset) {
    throw new RangeError('"offset" is outside of buffer bounds')
  }

  if (array.byteLength < byteOffset + (length || 0)) {
    throw new RangeError('"length" is outside of buffer bounds')
  }

  let buf
  if (byteOffset === undefined && length === undefined) {
    buf = new Uint8Array(array)
  } else if (length === undefined) {
    buf = new Uint8Array(array, byteOffset)
  } else {
    buf = new Uint8Array(array, byteOffset, length)
  }

  // Return an augmented `Uint8Array` instance
  Object.setPrototypeOf(buf, Buffer.prototype)

  return buf
}

function fromObject (obj) {
  if (Buffer.isBuffer(obj)) {
    const len = checked(obj.length) | 0
    const buf = createBuffer(len)

    if (buf.length === 0) {
      return buf
    }

    obj.copy(buf, 0, 0, len)
    return buf
  }

  if (obj.length !== undefined) {
    if (typeof obj.length !== 'number' || numberIsNaN(obj.length)) {
      return createBuffer(0)
    }
    return fromArrayLike(obj)
  }

  if (obj.type === 'Buffer' && Array.isArray(obj.data)) {
    return fromArrayLike(obj.data)
  }
}

function checked (length) {
  // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
  // length is NaN (which is otherwise coerced to zero.)
  if (length >= K_MAX_LENGTH) {
    throw new RangeError('Attempt to allocate Buffer larger than maximum ' +
                         'size: 0x' + K_MAX_LENGTH.toString(16) + ' bytes')
  }
  return length | 0
}

function SlowBuffer (length) {
  if (+length != length) { // eslint-disable-line eqeqeq
    length = 0
  }
  return Buffer.alloc(+length)
}

Buffer.isBuffer = function isBuffer (b) {
  return b != null && b._isBuffer === true &&
    b !== Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
}

Buffer.compare = function compare (a, b) {
  if (isInstance(a, Uint8Array)) a = Buffer.from(a, a.offset, a.byteLength)
  if (isInstance(b, Uint8Array)) b = Buffer.from(b, b.offset, b.byteLength)
  if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) {
    throw new TypeError(
      'The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array'
    )
  }

  if (a === b) return 0

  let x = a.length
  let y = b.length

  for (let i = 0, len = Math.min(x, y); i < len; ++i) {
    if (a[i] !== b[i]) {
      x = a[i]
      y = b[i]
      break
    }
  }

  if (x < y) return -1
  if (y < x) return 1
  return 0
}

Buffer.isEncoding = function isEncoding (encoding) {
  switch (String(encoding).toLowerCase()) {
    case 'hex':
    case 'utf8':
    case 'utf-8':
    case 'ascii':
    case 'latin1':
    case 'binary':
    case 'base64':
    case 'ucs2':
    case 'ucs-2':
    case 'utf16le':
    case 'utf-16le':
      return true
    default:
      return false
  }
}

Buffer.concat = function concat (list, length) {
  if (!Array.isArray(list)) {
    throw new TypeError('"list" argument must be an Array of Buffers')
  }

  if (list.length === 0) {
    return Buffer.alloc(0)
  }

  let i
  if (length === undefined) {
    length = 0
    for (i = 0; i < list.length; ++i) {
      length += list[i].length
    }
  }

  const buffer = Buffer.allocUnsafe(length)
  let pos = 0
  for (i = 0; i < list.length; ++i) {
    let buf = list[i]
    if (isInstance(buf, Uint8Array)) {
      if (pos + buf.length > buffer.length) {
        if (!Buffer.isBuffer(buf)) buf = Buffer.from(buf)
        buf.copy(buffer, pos)
      } else {
        Uint8Array.prototype.set.call(
          buffer,
          buf,
          pos
        )
      }
    } else if (!Buffer.isBuffer(buf)) {
      throw new TypeError('"list" argument must be an Array of Buffers')
    } else {
      buf.copy(buffer, pos)
    }
    pos += buf.length
  }
  return buffer
}

function byteLength (string, encoding) {
  if (Buffer.isBuffer(string)) {
    return string.length
  }
  if (ArrayBuffer.isView(string) || isInstance(string, ArrayBuffer)) {
    return string.byteLength
  }
  if (typeof string !== 'string') {
    throw new TypeError(
      'The "string" argument must be one of type string, Buffer, or ArrayBuffer. ' +
      'Received type ' + typeof string
    )
  }

  const len = string.length
  const mustMatch = (arguments.length > 2 && arguments[2] === true)
  if (!mustMatch && len === 0) return 0

  // Use a for loop to avoid recursion
  let loweredCase = false
  for (;;) {
    switch (encoding) {
      case 'ascii':
      case 'latin1':
      case 'binary':
        return len
      case 'utf8':
      case 'utf-8':
        return utf8ToBytes(string).length
      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return len * 2
      case 'hex':
        return len >>> 1
      case 'base64':
        return base64ToBytes(string).length
      default:
        if (loweredCase) {
          return mustMatch ? -1 : utf8ToBytes(string).length // assume utf8
        }
        encoding = ('' + encoding).toLowerCase()
        loweredCase = true
    }
  }
}
Buffer.byteLength = byteLength

function slowToString (encoding, start, end) {
  let loweredCase = false

  // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
  // property of a typed array.

  // This behaves neither like String nor Uint8Array in that we set start/end
  // to their upper/lower bounds if the value passed is out of range.
  // undefined is handled specially as per ECMA-262 6th Edition,
  // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
  if (start === undefined || start < 0) {
    start = 0
  }
  // Return early if start > this.length. Done here to prevent potential uint32
  // coercion fail below.
  if (start > this.length) {
    return ''
  }

  if (end === undefined || end > this.length) {
    end = this.length
  }

  if (end <= 0) {
    return ''
  }

  // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
  end >>>= 0
  start >>>= 0

  if (end <= start) {
    return ''
  }

  if (!encoding) encoding = 'utf8'

  while (true) {
    switch (encoding) {
      case 'hex':
        return hexSlice(this, start, end)

      case 'utf8':
      case 'utf-8':
        return utf8Slice(this, start, end)

      case 'ascii':
        return asciiSlice(this, start, end)

      case 'latin1':
      case 'binary':
        return latin1Slice(this, start, end)

      case 'base64':
        return base64Slice(this, start, end)

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return utf16leSlice(this, start, end)

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
        encoding = (encoding + '').toLowerCase()
        loweredCase = true
    }
  }
}

// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
Buffer.prototype._isBuffer = true

function swap (b, n, m) {
  const i = b[n]
  b[n] = b[m]
  b[m] = i
}

Buffer.prototype.swap16 = function swap16 () {
  const len = this.length
  if (len % 2 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 16-bits')
  }
  for (let i = 0; i < len; i += 2) {
    swap(this, i, i + 1)
  }
  return this
}

Buffer.prototype.swap32 = function swap32 () {
  const len = this.length
  if (len % 4 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 32-bits')
  }
  for (let i = 0; i < len; i += 4) {
    swap(this, i, i + 3)
    swap(this, i + 1, i + 2)
  }
  return this
}

Buffer.prototype.swap64 = function swap64 () {
  const len = this.length
  if (len % 8 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 64-bits')
  }
  for (let i = 0; i < len; i += 8) {
    swap(this, i, i + 7)
    swap(this, i + 1, i + 6)
    swap(this, i + 2, i + 5)
    swap(this, i + 3, i + 4)
  }
  return this
}

Buffer.prototype.toString = function toString () {
  const length = this.length
  if (length === 0) return ''
  if (arguments.length === 0) return utf8Slice(this, 0, length)
  return slowToString.apply(this, arguments)
}

Buffer.prototype.toLocaleString = Buffer.prototype.toString

Buffer.prototype.equals = function equals (b) {
  if (!Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer')
  if (this === b) return true
  return Buffer.compare(this, b) === 0
}

Buffer.prototype.inspect = function inspect () {
  let str = ''
  const max = exports.INSPECT_MAX_BYTES
  str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim()
  if (this.length > max) str += ' ... '
  return '<Buffer ' + str + '>'
}
if (customInspectSymbol) {
  Buffer.prototype[customInspectSymbol] = Buffer.prototype.inspect
}

Buffer.prototype.compare = function compare (target, start, end, thisStart, thisEnd) {
  if (isInstance(target, Uint8Array)) {
    target = Buffer.from(target, target.offset, target.byteLength)
  }
  if (!Buffer.isBuffer(target)) {
    throw new TypeError(
      'The "target" argument must be one of type Buffer or Uint8Array. ' +
      'Received type ' + (typeof target)
    )
  }

  if (start === undefined) {
    start = 0
  }
  if (end === undefined) {
    end = target ? target.length : 0
  }
  if (thisStart === undefined) {
    thisStart = 0
  }
  if (thisEnd === undefined) {
    thisEnd = this.length
  }

  if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) {
    throw new RangeError('out of range index')
  }

  if (thisStart >= thisEnd && start >= end) {
    return 0
  }
  if (thisStart >= thisEnd) {
    return -1
  }
  if (start >= end) {
    return 1
  }

  start >>>= 0
  end >>>= 0
  thisStart >>>= 0
  thisEnd >>>= 0

  if (this === target) return 0

  let x = thisEnd - thisStart
  let y = end - start
  const len = Math.min(x, y)

  const thisCopy = this.slice(thisStart, thisEnd)
  const targetCopy = target.slice(start, end)

  for (let i = 0; i < len; ++i) {
    if (thisCopy[i] !== targetCopy[i]) {
      x = thisCopy[i]
      y = targetCopy[i]
      break
    }
  }

  if (x < y) return -1
  if (y < x) return 1
  return 0
}

// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function bidirectionalIndexOf (buffer, val, byteOffset, encoding, dir) {
  // Empty buffer means no match
  if (buffer.length === 0) return -1

  // Normalize byteOffset
  if (typeof byteOffset === 'string') {
    encoding = byteOffset
    byteOffset = 0
  } else if (byteOffset > 0x7fffffff) {
    byteOffset = 0x7fffffff
  } else if (byteOffset < -0x80000000) {
    byteOffset = -0x80000000
  }
  byteOffset = +byteOffset // Coerce to Number.
  if (numberIsNaN(byteOffset)) {
    // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : (buffer.length - 1)
  }

  // Normalize byteOffset: negative offsets start from the end of the buffer
  if (byteOffset < 0) byteOffset = buffer.length + byteOffset
  if (byteOffset >= buffer.length) {
    if (dir) return -1
    else byteOffset = buffer.length - 1
  } else if (byteOffset < 0) {
    if (dir) byteOffset = 0
    else return -1
  }

  // Normalize val
  if (typeof val === 'string') {
    val = Buffer.from(val, encoding)
  }

  // Finally, search either indexOf (if dir is true) or lastIndexOf
  if (Buffer.isBuffer(val)) {
    // Special case: looking for empty string/buffer always fails
    if (val.length === 0) {
      return -1
    }
    return arrayIndexOf(buffer, val, byteOffset, encoding, dir)
  } else if (typeof val === 'number') {
    val = val & 0xFF // Search for a byte value [0-255]
    if (typeof Uint8Array.prototype.indexOf === 'function') {
      if (dir) {
        return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset)
      } else {
        return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset)
      }
    }
    return arrayIndexOf(buffer, [val], byteOffset, encoding, dir)
  }

  throw new TypeError('val must be string, number or Buffer')
}

function arrayIndexOf (arr, val, byteOffset, encoding, dir) {
  let indexSize = 1
  let arrLength = arr.length
  let valLength = val.length

  if (encoding !== undefined) {
    encoding = String(encoding).toLowerCase()
    if (encoding === 'ucs2' || encoding === 'ucs-2' ||
        encoding === 'utf16le' || encoding === 'utf-16le') {
      if (arr.length < 2 || val.length < 2) {
        return -1
      }
      indexSize = 2
      arrLength /= 2
      valLength /= 2
      byteOffset /= 2
    }
  }

  function read (buf, i) {
    if (indexSize === 1) {
      return buf[i]
    } else {
      return buf.readUInt16BE(i * indexSize)
    }
  }

  let i
  if (dir) {
    let foundIndex = -1
    for (i = byteOffset; i < arrLength; i++) {
      if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
        if (foundIndex === -1) foundIndex = i
        if (i - foundIndex + 1 === valLength) return foundIndex * indexSize
      } else {
        if (foundIndex !== -1) i -= i - foundIndex
        foundIndex = -1
      }
    }
  } else {
    if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength
    for (i = byteOffset; i >= 0; i--) {
      let found = true
      for (let j = 0; j < valLength; j++) {
        if (read(arr, i + j) !== read(val, j)) {
          found = false
          break
        }
      }
      if (found) return i
    }
  }

  return -1
}

Buffer.prototype.includes = function includes (val, byteOffset, encoding) {
  return this.indexOf(val, byteOffset, encoding) !== -1
}

Buffer.prototype.indexOf = function indexOf (val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, true)
}

Buffer.prototype.lastIndexOf = function lastIndexOf (val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, false)
}

function hexWrite (buf, string, offset, length) {
  offset = Number(offset) || 0
  const remaining = buf.length - offset
  if (!length) {
    length = remaining
  } else {
    length = Number(length)
    if (length > remaining) {
      length = remaining
    }
  }

  const strLen = string.length

  if (length > strLen / 2) {
    length = strLen / 2
  }
  let i
  for (i = 0; i < length; ++i) {
    const parsed = parseInt(string.substr(i * 2, 2), 16)
    if (numberIsNaN(parsed)) return i
    buf[offset + i] = parsed
  }
  return i
}

function utf8Write (buf, string, offset, length) {
  return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length)
}

function asciiWrite (buf, string, offset, length) {
  return blitBuffer(asciiToBytes(string), buf, offset, length)
}

function base64Write (buf, string, offset, length) {
  return blitBuffer(base64ToBytes(string), buf, offset, length)
}

function ucs2Write (buf, string, offset, length) {
  return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length)
}

Buffer.prototype.write = function write (string, offset, length, encoding) {
  // Buffer#write(string)
  if (offset === undefined) {
    encoding = 'utf8'
    length = this.length
    offset = 0
  // Buffer#write(string, encoding)
  } else if (length === undefined && typeof offset === 'string') {
    encoding = offset
    length = this.length
    offset = 0
  // Buffer#write(string, offset[, length][, encoding])
  } else if (isFinite(offset)) {
    offset = offset >>> 0
    if (isFinite(length)) {
      length = length >>> 0
      if (encoding === undefined) encoding = 'utf8'
    } else {
      encoding = length
      length = undefined
    }
  } else {
    throw new Error(
      'Buffer.write(string, encoding, offset[, length]) is no longer supported'
    )
  }

  const remaining = this.length - offset
  if (length === undefined || length > remaining) length = remaining

  if ((string.length > 0 && (length < 0 || offset < 0)) || offset > this.length) {
    throw new RangeError('Attempt to write outside buffer bounds')
  }

  if (!encoding) encoding = 'utf8'

  let loweredCase = false
  for (;;) {
    switch (encoding) {
      case 'hex':
        return hexWrite(this, string, offset, length)

      case 'utf8':
      case 'utf-8':
        return utf8Write(this, string, offset, length)

      case 'ascii':
      case 'latin1':
      case 'binary':
        return asciiWrite(this, string, offset, length)

      case 'base64':
        // Warning: maxLength not taken into account in base64Write
        return base64Write(this, string, offset, length)

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return ucs2Write(this, string, offset, length)

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
        encoding = ('' + encoding).toLowerCase()
        loweredCase = true
    }
  }
}

Buffer.prototype.toJSON = function toJSON () {
  return {
    type: 'Buffer',
    data: Array.prototype.slice.call(this._arr || this, 0)
  }
}

function base64Slice (buf, start, end) {
  if (start === 0 && end === buf.length) {
    return base64.fromByteArray(buf)
  } else {
    return base64.fromByteArray(buf.slice(start, end))
  }
}

function utf8Slice (buf, start, end) {
  end = Math.min(buf.length, end)
  const res = []

  let i = start
  while (i < end) {
    const firstByte = buf[i]
    let codePoint = null
    let bytesPerSequence = (firstByte > 0xEF)
      ? 4
      : (firstByte > 0xDF)
          ? 3
          : (firstByte > 0xBF)
              ? 2
              : 1

    if (i + bytesPerSequence <= end) {
      let secondByte, thirdByte, fourthByte, tempCodePoint

      switch (bytesPerSequence) {
        case 1:
          if (firstByte < 0x80) {
            codePoint = firstByte
          }
          break
        case 2:
          secondByte = buf[i + 1]
          if ((secondByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0x1F) << 0x6 | (secondByte & 0x3F)
            if (tempCodePoint > 0x7F) {
              codePoint = tempCodePoint
            }
          }
          break
        case 3:
          secondByte = buf[i + 1]
          thirdByte = buf[i + 2]
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | (thirdByte & 0x3F)
            if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) {
              codePoint = tempCodePoint
            }
          }
          break
        case 4:
          secondByte = buf[i + 1]
          thirdByte = buf[i + 2]
          fourthByte = buf[i + 3]
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | (fourthByte & 0x3F)
            if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) {
              codePoint = tempCodePoint
            }
          }
      }
    }

    if (codePoint === null) {
      // we did not generate a valid codePoint so insert a
      // replacement char (U+FFFD) and advance only 1 byte
      codePoint = 0xFFFD
      bytesPerSequence = 1
    } else if (codePoint > 0xFFFF) {
      // encode to utf16 (surrogate pair dance)
      codePoint -= 0x10000
      res.push(codePoint >>> 10 & 0x3FF | 0xD800)
      codePoint = 0xDC00 | codePoint & 0x3FF
    }

    res.push(codePoint)
    i += bytesPerSequence
  }

  return decodeCodePointsArray(res)
}

// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
const MAX_ARGUMENTS_LENGTH = 0x1000

function decodeCodePointsArray (codePoints) {
  const len = codePoints.length
  if (len <= MAX_ARGUMENTS_LENGTH) {
    return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
  }

  // Decode in chunks to avoid "call stack size exceeded".
  let res = ''
  let i = 0
  while (i < len) {
    res += String.fromCharCode.apply(
      String,
      codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH)
    )
  }
  return res
}

function asciiSlice (buf, start, end) {
  let ret = ''
  end = Math.min(buf.length, end)

  for (let i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i] & 0x7F)
  }
  return ret
}

function latin1Slice (buf, start, end) {
  let ret = ''
  end = Math.min(buf.length, end)

  for (let i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i])
  }
  return ret
}

function hexSlice (buf, start, end) {
  const len = buf.length

  if (!start || start < 0) start = 0
  if (!end || end < 0 || end > len) end = len

  let out = ''
  for (let i = start; i < end; ++i) {
    out += hexSliceLookupTable[buf[i]]
  }
  return out
}

function utf16leSlice (buf, start, end) {
  const bytes = buf.slice(start, end)
  let res = ''
  // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
  for (let i = 0; i < bytes.length - 1; i += 2) {
    res += String.fromCharCode(bytes[i] + (bytes[i + 1] * 256))
  }
  return res
}

Buffer.prototype.slice = function slice (start, end) {
  const len = this.length
  start = ~~start
  end = end === undefined ? len : ~~end

  if (start < 0) {
    start += len
    if (start < 0) start = 0
  } else if (start > len) {
    start = len
  }

  if (end < 0) {
    end += len
    if (end < 0) end = 0
  } else if (end > len) {
    end = len
  }

  if (end < start) end = start

  const newBuf = this.subarray(start, end)
  // Return an augmented `Uint8Array` instance
  Object.setPrototypeOf(newBuf, Buffer.prototype)

  return newBuf
}

/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */
function checkOffset (offset, ext, length) {
  if ((offset % 1) !== 0 || offset < 0) throw new RangeError('offset is not uint')
  if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length')
}

Buffer.prototype.readUintLE =
Buffer.prototype.readUIntLE = function readUIntLE (offset, byteLength, noAssert) {
  offset = offset >>> 0
  byteLength = byteLength >>> 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  let val = this[offset]
  let mul = 1
  let i = 0
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul
  }

  return val
}

Buffer.prototype.readUintBE =
Buffer.prototype.readUIntBE = function readUIntBE (offset, byteLength, noAssert) {
  offset = offset >>> 0
  byteLength = byteLength >>> 0
  if (!noAssert) {
    checkOffset(offset, byteLength, this.length)
  }

  let val = this[offset + --byteLength]
  let mul = 1
  while (byteLength > 0 && (mul *= 0x100)) {
    val += this[offset + --byteLength] * mul
  }

  return val
}

Buffer.prototype.readUint8 =
Buffer.prototype.readUInt8 = function readUInt8 (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 1, this.length)
  return this[offset]
}

Buffer.prototype.readUint16LE =
Buffer.prototype.readUInt16LE = function readUInt16LE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 2, this.length)
  return this[offset] | (this[offset + 1] << 8)
}

Buffer.prototype.readUint16BE =
Buffer.prototype.readUInt16BE = function readUInt16BE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 2, this.length)
  return (this[offset] << 8) | this[offset + 1]
}

Buffer.prototype.readUint32LE =
Buffer.prototype.readUInt32LE = function readUInt32LE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 4, this.length)

  return ((this[offset]) |
      (this[offset + 1] << 8) |
      (this[offset + 2] << 16)) +
      (this[offset + 3] * 0x1000000)
}

Buffer.prototype.readUint32BE =
Buffer.prototype.readUInt32BE = function readUInt32BE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset] * 0x1000000) +
    ((this[offset + 1] << 16) |
    (this[offset + 2] << 8) |
    this[offset + 3])
}

Buffer.prototype.readBigUInt64LE = defineBigIntMethod(function readBigUInt64LE (offset) {
  offset = offset >>> 0
  validateNumber(offset, 'offset')
  const first = this[offset]
  const last = this[offset + 7]
  if (first === undefined || last === undefined) {
    boundsError(offset, this.length - 8)
  }

  const lo = first +
    this[++offset] * 2 ** 8 +
    this[++offset] * 2 ** 16 +
    this[++offset] * 2 ** 24

  const hi = this[++offset] +
    this[++offset] * 2 ** 8 +
    this[++offset] * 2 ** 16 +
    last * 2 ** 24

  return BigInt(lo) + (BigInt(hi) << BigInt(32))
})

Buffer.prototype.readBigUInt64BE = defineBigIntMethod(function readBigUInt64BE (offset) {
  offset = offset >>> 0
  validateNumber(offset, 'offset')
  const first = this[offset]
  const last = this[offset + 7]
  if (first === undefined || last === undefined) {
    boundsError(offset, this.length - 8)
  }

  const hi = first * 2 ** 24 +
    this[++offset] * 2 ** 16 +
    this[++offset] * 2 ** 8 +
    this[++offset]

  const lo = this[++offset] * 2 ** 24 +
    this[++offset] * 2 ** 16 +
    this[++offset] * 2 ** 8 +
    last

  return (BigInt(hi) << BigInt(32)) + BigInt(lo)
})

Buffer.prototype.readIntLE = function readIntLE (offset, byteLength, noAssert) {
  offset = offset >>> 0
  byteLength = byteLength >>> 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  let val = this[offset]
  let mul = 1
  let i = 0
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul
  }
  mul *= 0x80

  if (val >= mul) val -= Math.pow(2, 8 * byteLength)

  return val
}

Buffer.prototype.readIntBE = function readIntBE (offset, byteLength, noAssert) {
  offset = offset >>> 0
  byteLength = byteLength >>> 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  let i = byteLength
  let mul = 1
  let val = this[offset + --i]
  while (i > 0 && (mul *= 0x100)) {
    val += this[offset + --i] * mul
  }
  mul *= 0x80

  if (val >= mul) val -= Math.pow(2, 8 * byteLength)

  return val
}

Buffer.prototype.readInt8 = function readInt8 (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 1, this.length)
  if (!(this[offset] & 0x80)) return (this[offset])
  return ((0xff - this[offset] + 1) * -1)
}

Buffer.prototype.readInt16LE = function readInt16LE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 2, this.length)
  const val = this[offset] | (this[offset + 1] << 8)
  return (val & 0x8000) ? val | 0xFFFF0000 : val
}

Buffer.prototype.readInt16BE = function readInt16BE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 2, this.length)
  const val = this[offset + 1] | (this[offset] << 8)
  return (val & 0x8000) ? val | 0xFFFF0000 : val
}

Buffer.prototype.readInt32LE = function readInt32LE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset]) |
    (this[offset + 1] << 8) |
    (this[offset + 2] << 16) |
    (this[offset + 3] << 24)
}

Buffer.prototype.readInt32BE = function readInt32BE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset] << 24) |
    (this[offset + 1] << 16) |
    (this[offset + 2] << 8) |
    (this[offset + 3])
}

Buffer.prototype.readBigInt64LE = defineBigIntMethod(function readBigInt64LE (offset) {
  offset = offset >>> 0
  validateNumber(offset, 'offset')
  const first = this[offset]
  const last = this[offset + 7]
  if (first === undefined || last === undefined) {
    boundsError(offset, this.length - 8)
  }

  const val = this[offset + 4] +
    this[offset + 5] * 2 ** 8 +
    this[offset + 6] * 2 ** 16 +
    (last << 24) // Overflow

  return (BigInt(val) << BigInt(32)) +
    BigInt(first +
    this[++offset] * 2 ** 8 +
    this[++offset] * 2 ** 16 +
    this[++offset] * 2 ** 24)
})

Buffer.prototype.readBigInt64BE = defineBigIntMethod(function readBigInt64BE (offset) {
  offset = offset >>> 0
  validateNumber(offset, 'offset')
  const first = this[offset]
  const last = this[offset + 7]
  if (first === undefined || last === undefined) {
    boundsError(offset, this.length - 8)
  }

  const val = (first << 24) + // Overflow
    this[++offset] * 2 ** 16 +
    this[++offset] * 2 ** 8 +
    this[++offset]

  return (BigInt(val) << BigInt(32)) +
    BigInt(this[++offset] * 2 ** 24 +
    this[++offset] * 2 ** 16 +
    this[++offset] * 2 ** 8 +
    last)
})

Buffer.prototype.readFloatLE = function readFloatLE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 4, this.length)
  return ieee754.read(this, offset, true, 23, 4)
}

Buffer.prototype.readFloatBE = function readFloatBE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 4, this.length)
  return ieee754.read(this, offset, false, 23, 4)
}

Buffer.prototype.readDoubleLE = function readDoubleLE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 8, this.length)
  return ieee754.read(this, offset, true, 52, 8)
}

Buffer.prototype.readDoubleBE = function readDoubleBE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 8, this.length)
  return ieee754.read(this, offset, false, 52, 8)
}

function checkInt (buf, value, offset, ext, max, min) {
  if (!Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance')
  if (value > max || value < min) throw new RangeError('"value" argument is out of bounds')
  if (offset + ext > buf.length) throw new RangeError('Index out of range')
}

Buffer.prototype.writeUintLE =
Buffer.prototype.writeUIntLE = function writeUIntLE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset >>> 0
  byteLength = byteLength >>> 0
  if (!noAssert) {
    const maxBytes = Math.pow(2, 8 * byteLength) - 1
    checkInt(this, value, offset, byteLength, maxBytes, 0)
  }

  let mul = 1
  let i = 0
  this[offset] = value & 0xFF
  while (++i < byteLength && (mul *= 0x100)) {
    this[offset + i] = (value / mul) & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeUintBE =
Buffer.prototype.writeUIntBE = function writeUIntBE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset >>> 0
  byteLength = byteLength >>> 0
  if (!noAssert) {
    const maxBytes = Math.pow(2, 8 * byteLength) - 1
    checkInt(this, value, offset, byteLength, maxBytes, 0)
  }

  let i = byteLength - 1
  let mul = 1
  this[offset + i] = value & 0xFF
  while (--i >= 0 && (mul *= 0x100)) {
    this[offset + i] = (value / mul) & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeUint8 =
Buffer.prototype.writeUInt8 = function writeUInt8 (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0)
  this[offset] = (value & 0xff)
  return offset + 1
}

Buffer.prototype.writeUint16LE =
Buffer.prototype.writeUInt16LE = function writeUInt16LE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
  this[offset] = (value & 0xff)
  this[offset + 1] = (value >>> 8)
  return offset + 2
}

Buffer.prototype.writeUint16BE =
Buffer.prototype.writeUInt16BE = function writeUInt16BE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
  this[offset] = (value >>> 8)
  this[offset + 1] = (value & 0xff)
  return offset + 2
}

Buffer.prototype.writeUint32LE =
Buffer.prototype.writeUInt32LE = function writeUInt32LE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
  this[offset + 3] = (value >>> 24)
  this[offset + 2] = (value >>> 16)
  this[offset + 1] = (value >>> 8)
  this[offset] = (value & 0xff)
  return offset + 4
}

Buffer.prototype.writeUint32BE =
Buffer.prototype.writeUInt32BE = function writeUInt32BE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
  this[offset] = (value >>> 24)
  this[offset + 1] = (value >>> 16)
  this[offset + 2] = (value >>> 8)
  this[offset + 3] = (value & 0xff)
  return offset + 4
}

function wrtBigUInt64LE (buf, value, offset, min, max) {
  checkIntBI(value, min, max, buf, offset, 7)

  let lo = Number(value & BigInt(0xffffffff))
  buf[offset++] = lo
  lo = lo >> 8
  buf[offset++] = lo
  lo = lo >> 8
  buf[offset++] = lo
  lo = lo >> 8
  buf[offset++] = lo
  let hi = Number(value >> BigInt(32) & BigInt(0xffffffff))
  buf[offset++] = hi
  hi = hi >> 8
  buf[offset++] = hi
  hi = hi >> 8
  buf[offset++] = hi
  hi = hi >> 8
  buf[offset++] = hi
  return offset
}

function wrtBigUInt64BE (buf, value, offset, min, max) {
  checkIntBI(value, min, max, buf, offset, 7)

  let lo = Number(value & BigInt(0xffffffff))
  buf[offset + 7] = lo
  lo = lo >> 8
  buf[offset + 6] = lo
  lo = lo >> 8
  buf[offset + 5] = lo
  lo = lo >> 8
  buf[offset + 4] = lo
  let hi = Number(value >> BigInt(32) & BigInt(0xffffffff))
  buf[offset + 3] = hi
  hi = hi >> 8
  buf[offset + 2] = hi
  hi = hi >> 8
  buf[offset + 1] = hi
  hi = hi >> 8
  buf[offset] = hi
  return offset + 8
}

Buffer.prototype.writeBigUInt64LE = defineBigIntMethod(function writeBigUInt64LE (value, offset = 0) {
  return wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'))
})

Buffer.prototype.writeBigUInt64BE = defineBigIntMethod(function writeBigUInt64BE (value, offset = 0) {
  return wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'))
})

Buffer.prototype.writeIntLE = function writeIntLE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) {
    const limit = Math.pow(2, (8 * byteLength) - 1)

    checkInt(this, value, offset, byteLength, limit - 1, -limit)
  }

  let i = 0
  let mul = 1
  let sub = 0
  this[offset] = value & 0xFF
  while (++i < byteLength && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) {
      sub = 1
    }
    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeIntBE = function writeIntBE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) {
    const limit = Math.pow(2, (8 * byteLength) - 1)

    checkInt(this, value, offset, byteLength, limit - 1, -limit)
  }

  let i = byteLength - 1
  let mul = 1
  let sub = 0
  this[offset + i] = value & 0xFF
  while (--i >= 0 && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) {
      sub = 1
    }
    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeInt8 = function writeInt8 (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -0x80)
  if (value < 0) value = 0xff + value + 1
  this[offset] = (value & 0xff)
  return offset + 1
}

Buffer.prototype.writeInt16LE = function writeInt16LE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
  this[offset] = (value & 0xff)
  this[offset + 1] = (value >>> 8)
  return offset + 2
}

Buffer.prototype.writeInt16BE = function writeInt16BE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
  this[offset] = (value >>> 8)
  this[offset + 1] = (value & 0xff)
  return offset + 2
}

Buffer.prototype.writeInt32LE = function writeInt32LE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
  this[offset] = (value & 0xff)
  this[offset + 1] = (value >>> 8)
  this[offset + 2] = (value >>> 16)
  this[offset + 3] = (value >>> 24)
  return offset + 4
}

Buffer.prototype.writeInt32BE = function writeInt32BE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
  if (value < 0) value = 0xffffffff + value + 1
  this[offset] = (value >>> 24)
  this[offset + 1] = (value >>> 16)
  this[offset + 2] = (value >>> 8)
  this[offset + 3] = (value & 0xff)
  return offset + 4
}

Buffer.prototype.writeBigInt64LE = defineBigIntMethod(function writeBigInt64LE (value, offset = 0) {
  return wrtBigUInt64LE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'))
})

Buffer.prototype.writeBigInt64BE = defineBigIntMethod(function writeBigInt64BE (value, offset = 0) {
  return wrtBigUInt64BE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'))
})

function checkIEEE754 (buf, value, offset, ext, max, min) {
  if (offset + ext > buf.length) throw new RangeError('Index out of range')
  if (offset < 0) throw new RangeError('Index out of range')
}

function writeFloat (buf, value, offset, littleEndian, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -3.4028234663852886e+38)
  }
  ieee754.write(buf, value, offset, littleEndian, 23, 4)
  return offset + 4
}

Buffer.prototype.writeFloatLE = function writeFloatLE (value, offset, noAssert) {
  return writeFloat(this, value, offset, true, noAssert)
}

Buffer.prototype.writeFloatBE = function writeFloatBE (value, offset, noAssert) {
  return writeFloat(this, value, offset, false, noAssert)
}

function writeDouble (buf, value, offset, littleEndian, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -1.7976931348623157E+308)
  }
  ieee754.write(buf, value, offset, littleEndian, 52, 8)
  return offset + 8
}

Buffer.prototype.writeDoubleLE = function writeDoubleLE (value, offset, noAssert) {
  return writeDouble(this, value, offset, true, noAssert)
}

Buffer.prototype.writeDoubleBE = function writeDoubleBE (value, offset, noAssert) {
  return writeDouble(this, value, offset, false, noAssert)
}

// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
Buffer.prototype.copy = function copy (target, targetStart, start, end) {
  if (!Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer')
  if (!start) start = 0
  if (!end && end !== 0) end = this.length
  if (targetStart >= target.length) targetStart = target.length
  if (!targetStart) targetStart = 0
  if (end > 0 && end < start) end = start

  // Copy 0 bytes; we're done
  if (end === start) return 0
  if (target.length === 0 || this.length === 0) return 0

  // Fatal error conditions
  if (targetStart < 0) {
    throw new RangeError('targetStart out of bounds')
  }
  if (start < 0 || start >= this.length) throw new RangeError('Index out of range')
  if (end < 0) throw new RangeError('sourceEnd out of bounds')

  // Are we oob?
  if (end > this.length) end = this.length
  if (target.length - targetStart < end - start) {
    end = target.length - targetStart + start
  }

  const len = end - start

  if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') {
    // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end)
  } else {
    Uint8Array.prototype.set.call(
      target,
      this.subarray(start, end),
      targetStart
    )
  }

  return len
}

// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
Buffer.prototype.fill = function fill (val, start, end, encoding) {
  // Handle string cases:
  if (typeof val === 'string') {
    if (typeof start === 'string') {
      encoding = start
      start = 0
      end = this.length
    } else if (typeof end === 'string') {
      encoding = end
      end = this.length
    }
    if (encoding !== undefined && typeof encoding !== 'string') {
      throw new TypeError('encoding must be a string')
    }
    if (typeof encoding === 'string' && !Buffer.isEncoding(encoding)) {
      throw new TypeError('Unknown encoding: ' + encoding)
    }
    if (val.length === 1) {
      const code = val.charCodeAt(0)
      if ((encoding === 'utf8' && code < 128) ||
          encoding === 'latin1') {
        // Fast path: If `val` fits into a single byte, use that numeric value.
        val = code
      }
    }
  } else if (typeof val === 'number') {
    val = val & 255
  } else if (typeof val === 'boolean') {
    val = Number(val)
  }

  // Invalid ranges are not set to a default, so can range check early.
  if (start < 0 || this.length < start || this.length < end) {
    throw new RangeError('Out of range index')
  }

  if (end <= start) {
    return this
  }

  start = start >>> 0
  end = end === undefined ? this.length : end >>> 0

  if (!val) val = 0

  let i
  if (typeof val === 'number') {
    for (i = start; i < end; ++i) {
      this[i] = val
    }
  } else {
    const bytes = Buffer.isBuffer(val)
      ? val
      : Buffer.from(val, encoding)
    const len = bytes.length
    if (len === 0) {
      throw new TypeError('The value "' + val +
        '" is invalid for argument "value"')
    }
    for (i = 0; i < end - start; ++i) {
      this[i + start] = bytes[i % len]
    }
  }

  return this
}

// CUSTOM ERRORS
// =============

// Simplified versions from Node, changed for Buffer-only usage
const errors = {}
function E (sym, getMessage, Base) {
  errors[sym] = class NodeError extends Base {
    constructor () {
      super()

      Object.defineProperty(this, 'message', {
        value: getMessage.apply(this, arguments),
        writable: true,
        configurable: true
      })

      // Add the error code to the name to include it in the stack trace.
      this.name = `${this.name} [${sym}]`
      // Access the stack to generate the error message including the error code
      // from the name.
      this.stack // eslint-disable-line no-unused-expressions
      // Reset the name to the actual name.
      delete this.name
    }

    get code () {
      return sym
    }

    set code (value) {
      Object.defineProperty(this, 'code', {
        configurable: true,
        enumerable: true,
        value,
        writable: true
      })
    }

    toString () {
      return `${this.name} [${sym}]: ${this.message}`
    }
  }
}

E('ERR_BUFFER_OUT_OF_BOUNDS',
  function (name) {
    if (name) {
      return `${name} is outside of buffer bounds`
    }

    return 'Attempt to access memory outside buffer bounds'
  }, RangeError)
E('ERR_INVALID_ARG_TYPE',
  function (name, actual) {
    return `The "${name}" argument must be of type number. Received type ${typeof actual}`
  }, TypeError)
E('ERR_OUT_OF_RANGE',
  function (str, range, input) {
    let msg = `The value of "${str}" is out of range.`
    let received = input
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) {
      received = addNumericalSeparator(String(input))
    } else if (typeof input === 'bigint') {
      received = String(input)
      if (input > BigInt(2) ** BigInt(32) || input < -(BigInt(2) ** BigInt(32))) {
        received = addNumericalSeparator(received)
      }
      received += 'n'
    }
    msg += ` It must be ${range}. Received ${received}`
    return msg
  }, RangeError)

function addNumericalSeparator (val) {
  let res = ''
  let i = val.length
  const start = val[0] === '-' ? 1 : 0
  for (; i >= start + 4; i -= 3) {
    res = `_${val.slice(i - 3, i)}${res}`
  }
  return `${val.slice(0, i)}${res}`
}

// CHECK FUNCTIONS
// ===============

function checkBounds (buf, offset, byteLength) {
  validateNumber(offset, 'offset')
  if (buf[offset] === undefined || buf[offset + byteLength] === undefined) {
    boundsError(offset, buf.length - (byteLength + 1))
  }
}

function checkIntBI (value, min, max, buf, offset, byteLength) {
  if (value > max || value < min) {
    const n = typeof min === 'bigint' ? 'n' : ''
    let range
    if (byteLength > 3) {
      if (min === 0 || min === BigInt(0)) {
        range = `>= 0${n} and < 2${n} ** ${(byteLength + 1) * 8}${n}`
      } else {
        range = `>= -(2${n} ** ${(byteLength + 1) * 8 - 1}${n}) and < 2 ** ` +
                `${(byteLength + 1) * 8 - 1}${n}`
      }
    } else {
      range = `>= ${min}${n} and <= ${max}${n}`
    }
    throw new errors.ERR_OUT_OF_RANGE('value', range, value)
  }
  checkBounds(buf, offset, byteLength)
}

function validateNumber (value, name) {
  if (typeof value !== 'number') {
    throw new errors.ERR_INVALID_ARG_TYPE(name, 'number', value)
  }
}

function boundsError (value, length, type) {
  if (Math.floor(value) !== value) {
    validateNumber(value, type)
    throw new errors.ERR_OUT_OF_RANGE(type || 'offset', 'an integer', value)
  }

  if (length < 0) {
    throw new errors.ERR_BUFFER_OUT_OF_BOUNDS()
  }

  throw new errors.ERR_OUT_OF_RANGE(type || 'offset',
                                    `>= ${type ? 1 : 0} and <= ${length}`,
                                    value)
}

// HELPER FUNCTIONS
// ================

const INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g

function base64clean (str) {
  // Node takes equal signs as end of the Base64 encoding
  str = str.split('=')[0]
  // Node strips out invalid characters like \n and \t from the string, base64-js does not
  str = str.trim().replace(INVALID_BASE64_RE, '')
  // Node converts strings with length < 2 to ''
  if (str.length < 2) return ''
  // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
  while (str.length % 4 !== 0) {
    str = str + '='
  }
  return str
}

function utf8ToBytes (string, units) {
  units = units || Infinity
  let codePoint
  const length = string.length
  let leadSurrogate = null
  const bytes = []

  for (let i = 0; i < length; ++i) {
    codePoint = string.charCodeAt(i)

    // is surrogate component
    if (codePoint > 0xD7FF && codePoint < 0xE000) {
      // last char was a lead
      if (!leadSurrogate) {
        // no lead yet
        if (codePoint > 0xDBFF) {
          // unexpected trail
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
          continue
        } else if (i + 1 === length) {
          // unpaired lead
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
          continue
        }

        // valid lead
        leadSurrogate = codePoint

        continue
      }

      // 2 leads in a row
      if (codePoint < 0xDC00) {
        if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
        leadSurrogate = codePoint
        continue
      }

      // valid surrogate pair
      codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000
    } else if (leadSurrogate) {
      // valid bmp char, but last char was a lead
      if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
    }

    leadSurrogate = null

    // encode utf8
    if (codePoint < 0x80) {
      if ((units -= 1) < 0) break
      bytes.push(codePoint)
    } else if (codePoint < 0x800) {
      if ((units -= 2) < 0) break
      bytes.push(
        codePoint >> 0x6 | 0xC0,
        codePoint & 0x3F | 0x80
      )
    } else if (codePoint < 0x10000) {
      if ((units -= 3) < 0) break
      bytes.push(
        codePoint >> 0xC | 0xE0,
        codePoint >> 0x6 & 0x3F | 0x80,
        codePoint & 0x3F | 0x80
      )
    } else if (codePoint < 0x110000) {
      if ((units -= 4) < 0) break
      bytes.push(
        codePoint >> 0x12 | 0xF0,
        codePoint >> 0xC & 0x3F | 0x80,
        codePoint >> 0x6 & 0x3F | 0x80,
        codePoint & 0x3F | 0x80
      )
    } else {
      throw new Error('Invalid code point')
    }
  }

  return bytes
}

function asciiToBytes (str) {
  const byteArray = []
  for (let i = 0; i < str.length; ++i) {
    // Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF)
  }
  return byteArray
}

function utf16leToBytes (str, units) {
  let c, hi, lo
  const byteArray = []
  for (let i = 0; i < str.length; ++i) {
    if ((units -= 2) < 0) break

    c = str.charCodeAt(i)
    hi = c >> 8
    lo = c % 256
    byteArray.push(lo)
    byteArray.push(hi)
  }

  return byteArray
}

function base64ToBytes (str) {
  return base64.toByteArray(base64clean(str))
}

function blitBuffer (src, dst, offset, length) {
  let i
  for (i = 0; i < length; ++i) {
    if ((i + offset >= dst.length) || (i >= src.length)) break
    dst[i + offset] = src[i]
  }
  return i
}

// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function isInstance (obj, type) {
  return obj instanceof type ||
    (obj != null && obj.constructor != null && obj.constructor.name != null &&
      obj.constructor.name === type.name)
}
function numberIsNaN (obj) {
  // For IE11 support
  return obj !== obj // eslint-disable-line no-self-compare
}

// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
const hexSliceLookupTable = (function () {
  const alphabet = '0123456789abcdef'
  const table = new Array(256)
  for (let i = 0; i < 16; ++i) {
    const i16 = i * 16
    for (let j = 0; j < 16; ++j) {
      table[i16 + j] = alphabet[i] + alphabet[j]
    }
  }
  return table
})()

// Return not function with Error if BigInt not supported
function defineBigIntMethod (fn) {
  return typeof BigInt === 'undefined' ? BufferBigIntNotDefined : fn
}

function BufferBigIntNotDefined () {
  throw new Error('BigInt not supported')
}


/***/ }),

/***/ 74161:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var GetIntrinsic = __webpack_require__(67415);

var callBind = __webpack_require__(96350);

var $indexOf = callBind(GetIntrinsic('String.prototype.indexOf'));

module.exports = function callBoundIntrinsic(name, allowMissing) {
	var intrinsic = GetIntrinsic(name, !!allowMissing);
	if (typeof intrinsic === 'function' && $indexOf(name, '.prototype.') > -1) {
		return callBind(intrinsic);
	}
	return intrinsic;
};


/***/ }),

/***/ 96350:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var bind = __webpack_require__(48794);
var GetIntrinsic = __webpack_require__(67415);
var setFunctionLength = __webpack_require__(1118);

var $TypeError = __webpack_require__(29837);
var $apply = GetIntrinsic('%Function.prototype.apply%');
var $call = GetIntrinsic('%Function.prototype.call%');
var $reflectApply = GetIntrinsic('%Reflect.apply%', true) || bind.call($call, $apply);

var $defineProperty = __webpack_require__(2833);
var $max = GetIntrinsic('%Math.max%');

module.exports = function callBind(originalFunction) {
	if (typeof originalFunction !== 'function') {
		throw new $TypeError('a function is required');
	}
	var func = $reflectApply(bind, $call, arguments);
	return setFunctionLength(
		func,
		1 + $max(0, originalFunction.length - (arguments.length - 1)),
		true
	);
};

var applyBind = function applyBind() {
	return $reflectApply(bind, $apply, arguments);
};

if ($defineProperty) {
	$defineProperty(module.exports, 'apply', { value: applyBind });
} else {
	module.exports.apply = applyBind;
}


/***/ }),

/***/ 18003:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var $defineProperty = __webpack_require__(2833);

var $SyntaxError = __webpack_require__(75736);
var $TypeError = __webpack_require__(29837);

var gopd = __webpack_require__(70658);

/** @type {import('.')} */
module.exports = function defineDataProperty(
	obj,
	property,
	value
) {
	if (!obj || (typeof obj !== 'object' && typeof obj !== 'function')) {
		throw new $TypeError('`obj` must be an object or a function`');
	}
	if (typeof property !== 'string' && typeof property !== 'symbol') {
		throw new $TypeError('`property` must be a string or a symbol`');
	}
	if (arguments.length > 3 && typeof arguments[3] !== 'boolean' && arguments[3] !== null) {
		throw new $TypeError('`nonEnumerable`, if provided, must be a boolean or null');
	}
	if (arguments.length > 4 && typeof arguments[4] !== 'boolean' && arguments[4] !== null) {
		throw new $TypeError('`nonWritable`, if provided, must be a boolean or null');
	}
	if (arguments.length > 5 && typeof arguments[5] !== 'boolean' && arguments[5] !== null) {
		throw new $TypeError('`nonConfigurable`, if provided, must be a boolean or null');
	}
	if (arguments.length > 6 && typeof arguments[6] !== 'boolean') {
		throw new $TypeError('`loose`, if provided, must be a boolean');
	}

	var nonEnumerable = arguments.length > 3 ? arguments[3] : null;
	var nonWritable = arguments.length > 4 ? arguments[4] : null;
	var nonConfigurable = arguments.length > 5 ? arguments[5] : null;
	var loose = arguments.length > 6 ? arguments[6] : false;

	/* @type {false | TypedPropertyDescriptor<unknown>} */
	var desc = !!gopd && gopd(obj, property);

	if ($defineProperty) {
		$defineProperty(obj, property, {
			configurable: nonConfigurable === null && desc ? desc.configurable : !nonConfigurable,
			enumerable: nonEnumerable === null && desc ? desc.enumerable : !nonEnumerable,
			value: value,
			writable: nonWritable === null && desc ? desc.writable : !nonWritable
		});
	} else if (loose || (!nonEnumerable && !nonWritable && !nonConfigurable)) {
		// must fall back to [[Set]], and was not explicitly asked to make non-enumerable, non-writable, or non-configurable
		obj[property] = value; // eslint-disable-line no-param-reassign
	} else {
		throw new $SyntaxError('This environment does not support defining a property as non-configurable, non-writable, or non-enumerable.');
	}
};


/***/ }),

/***/ 87990:
/***/ (function(module) {

function backInOut(t) {
  var s = 1.70158 * 1.525
  if ((t *= 2) < 1)
    return 0.5 * (t * t * ((s + 1) * t - s))
  return 0.5 * ((t -= 2) * t * ((s + 1) * t + s) + 2)
}

module.exports = backInOut

/***/ }),

/***/ 21335:
/***/ (function(module) {

function backIn(t) {
  var s = 1.70158
  return t * t * ((s + 1) * t - s)
}

module.exports = backIn

/***/ }),

/***/ 21587:
/***/ (function(module) {

function backOut(t) {
  var s = 1.70158
  return --t * t * ((s + 1) * t + s) + 1
}

module.exports = backOut

/***/ }),

/***/ 11038:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var bounceOut = __webpack_require__(48099)

function bounceInOut(t) {
  return t < 0.5
    ? 0.5 * (1.0 - bounceOut(1.0 - t * 2.0))
    : 0.5 * bounceOut(t * 2.0 - 1.0) + 0.5
}

module.exports = bounceInOut

/***/ }),

/***/ 62580:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var bounceOut = __webpack_require__(48099)

function bounceIn(t) {
  return 1.0 - bounceOut(1.0 - t)
}

module.exports = bounceIn

/***/ }),

/***/ 48099:
/***/ (function(module) {

function bounceOut(t) {
  var a = 4.0 / 11.0
  var b = 8.0 / 11.0
  var c = 9.0 / 10.0

  var ca = 4356.0 / 361.0
  var cb = 35442.0 / 1805.0
  var cc = 16061.0 / 1805.0

  var t2 = t * t

  return t < a
    ? 7.5625 * t2
    : t < b
      ? 9.075 * t2 - 9.9 * t + 3.4
      : t < c
        ? ca * t2 - cb * t + cc
        : 10.8 * t * t - 20.52 * t + 10.72
}

module.exports = bounceOut

/***/ }),

/***/ 40344:
/***/ (function(module) {

function circInOut(t) {
  if ((t *= 2) < 1) return -0.5 * (Math.sqrt(1 - t * t) - 1)
  return 0.5 * (Math.sqrt(1 - (t -= 2) * t) + 1)
}

module.exports = circInOut

/***/ }),

/***/ 36580:
/***/ (function(module) {

function circIn(t) {
  return 1.0 - Math.sqrt(1.0 - t * t)
}

module.exports = circIn

/***/ }),

/***/ 21622:
/***/ (function(module) {

function circOut(t) {
  return Math.sqrt(1 - ( --t * t ))
}

module.exports = circOut

/***/ }),

/***/ 76277:
/***/ (function(module) {

function cubicInOut(t) {
  return t < 0.5
    ? 4.0 * t * t * t
    : 0.5 * Math.pow(2.0 * t - 2.0, 3.0) + 1.0
}

module.exports = cubicInOut

/***/ }),

/***/ 34658:
/***/ (function(module) {

function cubicIn(t) {
  return t * t * t
}

module.exports = cubicIn

/***/ }),

/***/ 45892:
/***/ (function(module) {

function cubicOut(t) {
  var f = t - 1.0
  return f * f * f + 1.0
}

module.exports = cubicOut

/***/ }),

/***/ 93313:
/***/ (function(module) {

function elasticInOut(t) {
  return t < 0.5
    ? 0.5 * Math.sin(+13.0 * Math.PI/2 * 2.0 * t) * Math.pow(2.0, 10.0 * (2.0 * t - 1.0))
    : 0.5 * Math.sin(-13.0 * Math.PI/2 * ((2.0 * t - 1.0) + 1.0)) * Math.pow(2.0, -10.0 * (2.0 * t - 1.0)) + 1.0
}

module.exports = elasticInOut

/***/ }),

/***/ 78323:
/***/ (function(module) {

function elasticIn(t) {
  return Math.sin(13.0 * t * Math.PI/2) * Math.pow(2.0, 10.0 * (t - 1.0))
}

module.exports = elasticIn

/***/ }),

/***/ 29341:
/***/ (function(module) {

function elasticOut(t) {
  return Math.sin(-13.0 * (t + 1.0) * Math.PI/2) * Math.pow(2.0, -10.0 * t) + 1.0
}

module.exports = elasticOut

/***/ }),

/***/ 97749:
/***/ (function(module) {

function expoInOut(t) {
  return (t === 0.0 || t === 1.0)
    ? t
    : t < 0.5
      ? +0.5 * Math.pow(2.0, (20.0 * t) - 10.0)
      : -0.5 * Math.pow(2.0, 10.0 - (t * 20.0)) + 1.0
}

module.exports = expoInOut

/***/ }),

/***/ 94490:
/***/ (function(module) {

function expoIn(t) {
  return t === 0.0 ? t : Math.pow(2.0, 10.0 * (t - 1.0))
}

module.exports = expoIn

/***/ }),

/***/ 41175:
/***/ (function(module) {

function expoOut(t) {
  return t === 1.0 ? t : 1.0 - Math.pow(2.0, -10.0 * t)
}

module.exports = expoOut

/***/ }),

/***/ 52075:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = {
	'backInOut': __webpack_require__(87990),
	'backIn': __webpack_require__(21335),
	'backOut': __webpack_require__(21587),
	'bounceInOut': __webpack_require__(11038),
	'bounceIn': __webpack_require__(62580),
	'bounceOut': __webpack_require__(48099),
	'circInOut': __webpack_require__(40344),
	'circIn': __webpack_require__(36580),
	'circOut': __webpack_require__(21622),
	'cubicInOut': __webpack_require__(76277),
	'cubicIn': __webpack_require__(34658),
	'cubicOut': __webpack_require__(45892),
	'elasticInOut': __webpack_require__(93313),
	'elasticIn': __webpack_require__(78323),
	'elasticOut': __webpack_require__(29341),
	'expoInOut': __webpack_require__(97749),
	'expoIn': __webpack_require__(94490),
	'expoOut': __webpack_require__(41175),
	'linear': __webpack_require__(35839),
	'quadInOut': __webpack_require__(20388),
	'quadIn': __webpack_require__(11088),
	'quadOut': __webpack_require__(6186),
	'quartInOut': __webpack_require__(74506),
	'quartIn': __webpack_require__(9008),
	'quartOut': __webpack_require__(36817),
	'quintInOut': __webpack_require__(48801),
	'quintIn': __webpack_require__(93074),
	'quintOut': __webpack_require__(51806),
	'sineInOut': __webpack_require__(3790),
	'sineIn': __webpack_require__(65460),
	'sineOut': __webpack_require__(34561)
}

/***/ }),

/***/ 35839:
/***/ (function(module) {

function linear(t) {
  return t
}

module.exports = linear

/***/ }),

/***/ 20388:
/***/ (function(module) {

function quadInOut(t) {
    t /= 0.5
    if (t < 1) return 0.5*t*t
    t--
    return -0.5 * (t*(t-2) - 1)
}

module.exports = quadInOut

/***/ }),

/***/ 11088:
/***/ (function(module) {

function quadIn(t) {
  return t * t
}

module.exports = quadIn

/***/ }),

/***/ 6186:
/***/ (function(module) {

function quadOut(t) {
  return -t * (t - 2.0)
}

module.exports = quadOut

/***/ }),

/***/ 74506:
/***/ (function(module) {

function quarticInOut(t) {
  return t < 0.5
    ? +8.0 * Math.pow(t, 4.0)
    : -8.0 * Math.pow(t - 1.0, 4.0) + 1.0
}

module.exports = quarticInOut

/***/ }),

/***/ 9008:
/***/ (function(module) {

function quarticIn(t) {
  return Math.pow(t, 4.0)
}

module.exports = quarticIn

/***/ }),

/***/ 36817:
/***/ (function(module) {

function quarticOut(t) {
  return Math.pow(t - 1.0, 3.0) * (1.0 - t) + 1.0
}

module.exports = quarticOut

/***/ }),

/***/ 48801:
/***/ (function(module) {

function qinticInOut(t) {
    if ( ( t *= 2 ) < 1 ) return 0.5 * t * t * t * t * t
    return 0.5 * ( ( t -= 2 ) * t * t * t * t + 2 )
}

module.exports = qinticInOut

/***/ }),

/***/ 93074:
/***/ (function(module) {

function qinticIn(t) {
  return t * t * t * t * t
}

module.exports = qinticIn

/***/ }),

/***/ 51806:
/***/ (function(module) {

function qinticOut(t) {
  return --t * t * t * t * t + 1
}

module.exports = qinticOut

/***/ }),

/***/ 3790:
/***/ (function(module) {

function sineInOut(t) {
  return -0.5 * (Math.cos(Math.PI*t) - 1)
}

module.exports = sineInOut

/***/ }),

/***/ 65460:
/***/ (function(module) {

function sineIn (t) {
  var v = Math.cos(t * Math.PI * 0.5)
  if (Math.abs(v) < 1e-14) return 1
  else return 1 - v
}

module.exports = sineIn


/***/ }),

/***/ 34561:
/***/ (function(module) {

function sineOut(t) {
  return Math.sin(t * Math.PI/2)
}

module.exports = sineOut

/***/ }),

/***/ 2833:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var GetIntrinsic = __webpack_require__(67415);

/** @type {import('.')} */
var $defineProperty = GetIntrinsic('%Object.defineProperty%', true) || false;
if ($defineProperty) {
	try {
		$defineProperty({}, 'a', { value: 1 });
	} catch (e) {
		// IE 8 has a broken defineProperty
		$defineProperty = false;
	}
}

module.exports = $defineProperty;


/***/ }),

/***/ 56731:
/***/ (function(module) {

"use strict";


/** @type {import('./eval')} */
module.exports = EvalError;


/***/ }),

/***/ 46392:
/***/ (function(module) {

"use strict";


/** @type {import('.')} */
module.exports = Error;


/***/ }),

/***/ 33996:
/***/ (function(module) {

"use strict";


/** @type {import('./range')} */
module.exports = RangeError;


/***/ }),

/***/ 90961:
/***/ (function(module) {

"use strict";


/** @type {import('./ref')} */
module.exports = ReferenceError;


/***/ }),

/***/ 75736:
/***/ (function(module) {

"use strict";


/** @type {import('./syntax')} */
module.exports = SyntaxError;


/***/ }),

/***/ 29837:
/***/ (function(module) {

"use strict";


/** @type {import('./type')} */
module.exports = TypeError;


/***/ }),

/***/ 37821:
/***/ (function(module) {

"use strict";


/** @type {import('./uri')} */
module.exports = URIError;


/***/ }),

/***/ 72100:
/***/ (function(module) {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.



var R = typeof Reflect === 'object' ? Reflect : null
var ReflectApply = R && typeof R.apply === 'function'
  ? R.apply
  : function ReflectApply(target, receiver, args) {
    return Function.prototype.apply.call(target, receiver, args);
  }

var ReflectOwnKeys
if (R && typeof R.ownKeys === 'function') {
  ReflectOwnKeys = R.ownKeys
} else if (Object.getOwnPropertySymbols) {
  ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target)
      .concat(Object.getOwnPropertySymbols(target));
  };
} else {
  ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target);
  };
}

function ProcessEmitWarning(warning) {
  if (console && console.warn) console.warn(warning);
}

var NumberIsNaN = Number.isNaN || function NumberIsNaN(value) {
  return value !== value;
}

function EventEmitter() {
  EventEmitter.init.call(this);
}
module.exports = EventEmitter;
module.exports.once = once;

// Backwards-compat with node 0.10.x
EventEmitter.EventEmitter = EventEmitter;

EventEmitter.prototype._events = undefined;
EventEmitter.prototype._eventsCount = 0;
EventEmitter.prototype._maxListeners = undefined;

// By default EventEmitters will print a warning if more than 10 listeners are
// added to it. This is a useful default which helps finding memory leaks.
var defaultMaxListeners = 10;

function checkListener(listener) {
  if (typeof listener !== 'function') {
    throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof listener);
  }
}

Object.defineProperty(EventEmitter, 'defaultMaxListeners', {
  enumerable: true,
  get: function() {
    return defaultMaxListeners;
  },
  set: function(arg) {
    if (typeof arg !== 'number' || arg < 0 || NumberIsNaN(arg)) {
      throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + arg + '.');
    }
    defaultMaxListeners = arg;
  }
});

EventEmitter.init = function() {

  if (this._events === undefined ||
      this._events === Object.getPrototypeOf(this)._events) {
    this._events = Object.create(null);
    this._eventsCount = 0;
  }

  this._maxListeners = this._maxListeners || undefined;
};

// Obviously not all Emitters should be limited to 10. This function allows
// that to be increased. Set to zero for unlimited.
EventEmitter.prototype.setMaxListeners = function setMaxListeners(n) {
  if (typeof n !== 'number' || n < 0 || NumberIsNaN(n)) {
    throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + n + '.');
  }
  this._maxListeners = n;
  return this;
};

function _getMaxListeners(that) {
  if (that._maxListeners === undefined)
    return EventEmitter.defaultMaxListeners;
  return that._maxListeners;
}

EventEmitter.prototype.getMaxListeners = function getMaxListeners() {
  return _getMaxListeners(this);
};

EventEmitter.prototype.emit = function emit(type) {
  var args = [];
  for (var i = 1; i < arguments.length; i++) args.push(arguments[i]);
  var doError = (type === 'error');

  var events = this._events;
  if (events !== undefined)
    doError = (doError && events.error === undefined);
  else if (!doError)
    return false;

  // If there is no 'error' event listener then throw.
  if (doError) {
    var er;
    if (args.length > 0)
      er = args[0];
    if (er instanceof Error) {
      // Note: The comments on the `throw` lines are intentional, they show
      // up in Node's output if this results in an unhandled exception.
      throw er; // Unhandled 'error' event
    }
    // At least give some kind of context to the user
    var err = new Error('Unhandled error.' + (er ? ' (' + er.message + ')' : ''));
    err.context = er;
    throw err; // Unhandled 'error' event
  }

  var handler = events[type];

  if (handler === undefined)
    return false;

  if (typeof handler === 'function') {
    ReflectApply(handler, this, args);
  } else {
    var len = handler.length;
    var listeners = arrayClone(handler, len);
    for (var i = 0; i < len; ++i)
      ReflectApply(listeners[i], this, args);
  }

  return true;
};

function _addListener(target, type, listener, prepend) {
  var m;
  var events;
  var existing;

  checkListener(listener);

  events = target._events;
  if (events === undefined) {
    events = target._events = Object.create(null);
    target._eventsCount = 0;
  } else {
    // To avoid recursion in the case that type === "newListener"! Before
    // adding it to the listeners, first emit "newListener".
    if (events.newListener !== undefined) {
      target.emit('newListener', type,
                  listener.listener ? listener.listener : listener);

      // Re-assign `events` because a newListener handler could have caused the
      // this._events to be assigned to a new object
      events = target._events;
    }
    existing = events[type];
  }

  if (existing === undefined) {
    // Optimize the case of one listener. Don't need the extra array object.
    existing = events[type] = listener;
    ++target._eventsCount;
  } else {
    if (typeof existing === 'function') {
      // Adding the second element, need to change to array.
      existing = events[type] =
        prepend ? [listener, existing] : [existing, listener];
      // If we've already got an array, just append.
    } else if (prepend) {
      existing.unshift(listener);
    } else {
      existing.push(listener);
    }

    // Check for listener leak
    m = _getMaxListeners(target);
    if (m > 0 && existing.length > m && !existing.warned) {
      existing.warned = true;
      // No error code for this since it is a Warning
      // eslint-disable-next-line no-restricted-syntax
      var w = new Error('Possible EventEmitter memory leak detected. ' +
                          existing.length + ' ' + String(type) + ' listeners ' +
                          'added. Use emitter.setMaxListeners() to ' +
                          'increase limit');
      w.name = 'MaxListenersExceededWarning';
      w.emitter = target;
      w.type = type;
      w.count = existing.length;
      ProcessEmitWarning(w);
    }
  }

  return target;
}

EventEmitter.prototype.addListener = function addListener(type, listener) {
  return _addListener(this, type, listener, false);
};

EventEmitter.prototype.on = EventEmitter.prototype.addListener;

EventEmitter.prototype.prependListener =
    function prependListener(type, listener) {
      return _addListener(this, type, listener, true);
    };

function onceWrapper() {
  if (!this.fired) {
    this.target.removeListener(this.type, this.wrapFn);
    this.fired = true;
    if (arguments.length === 0)
      return this.listener.call(this.target);
    return this.listener.apply(this.target, arguments);
  }
}

function _onceWrap(target, type, listener) {
  var state = { fired: false, wrapFn: undefined, target: target, type: type, listener: listener };
  var wrapped = onceWrapper.bind(state);
  wrapped.listener = listener;
  state.wrapFn = wrapped;
  return wrapped;
}

EventEmitter.prototype.once = function once(type, listener) {
  checkListener(listener);
  this.on(type, _onceWrap(this, type, listener));
  return this;
};

EventEmitter.prototype.prependOnceListener =
    function prependOnceListener(type, listener) {
      checkListener(listener);
      this.prependListener(type, _onceWrap(this, type, listener));
      return this;
    };

// Emits a 'removeListener' event if and only if the listener was removed.
EventEmitter.prototype.removeListener =
    function removeListener(type, listener) {
      var list, events, position, i, originalListener;

      checkListener(listener);

      events = this._events;
      if (events === undefined)
        return this;

      list = events[type];
      if (list === undefined)
        return this;

      if (list === listener || list.listener === listener) {
        if (--this._eventsCount === 0)
          this._events = Object.create(null);
        else {
          delete events[type];
          if (events.removeListener)
            this.emit('removeListener', type, list.listener || listener);
        }
      } else if (typeof list !== 'function') {
        position = -1;

        for (i = list.length - 1; i >= 0; i--) {
          if (list[i] === listener || list[i].listener === listener) {
            originalListener = list[i].listener;
            position = i;
            break;
          }
        }

        if (position < 0)
          return this;

        if (position === 0)
          list.shift();
        else {
          spliceOne(list, position);
        }

        if (list.length === 1)
          events[type] = list[0];

        if (events.removeListener !== undefined)
          this.emit('removeListener', type, originalListener || listener);
      }

      return this;
    };

EventEmitter.prototype.off = EventEmitter.prototype.removeListener;

EventEmitter.prototype.removeAllListeners =
    function removeAllListeners(type) {
      var listeners, events, i;

      events = this._events;
      if (events === undefined)
        return this;

      // not listening for removeListener, no need to emit
      if (events.removeListener === undefined) {
        if (arguments.length === 0) {
          this._events = Object.create(null);
          this._eventsCount = 0;
        } else if (events[type] !== undefined) {
          if (--this._eventsCount === 0)
            this._events = Object.create(null);
          else
            delete events[type];
        }
        return this;
      }

      // emit removeListener for all listeners on all events
      if (arguments.length === 0) {
        var keys = Object.keys(events);
        var key;
        for (i = 0; i < keys.length; ++i) {
          key = keys[i];
          if (key === 'removeListener') continue;
          this.removeAllListeners(key);
        }
        this.removeAllListeners('removeListener');
        this._events = Object.create(null);
        this._eventsCount = 0;
        return this;
      }

      listeners = events[type];

      if (typeof listeners === 'function') {
        this.removeListener(type, listeners);
      } else if (listeners !== undefined) {
        // LIFO order
        for (i = listeners.length - 1; i >= 0; i--) {
          this.removeListener(type, listeners[i]);
        }
      }

      return this;
    };

function _listeners(target, type, unwrap) {
  var events = target._events;

  if (events === undefined)
    return [];

  var evlistener = events[type];
  if (evlistener === undefined)
    return [];

  if (typeof evlistener === 'function')
    return unwrap ? [evlistener.listener || evlistener] : [evlistener];

  return unwrap ?
    unwrapListeners(evlistener) : arrayClone(evlistener, evlistener.length);
}

EventEmitter.prototype.listeners = function listeners(type) {
  return _listeners(this, type, true);
};

EventEmitter.prototype.rawListeners = function rawListeners(type) {
  return _listeners(this, type, false);
};

EventEmitter.listenerCount = function(emitter, type) {
  if (typeof emitter.listenerCount === 'function') {
    return emitter.listenerCount(type);
  } else {
    return listenerCount.call(emitter, type);
  }
};

EventEmitter.prototype.listenerCount = listenerCount;
function listenerCount(type) {
  var events = this._events;

  if (events !== undefined) {
    var evlistener = events[type];

    if (typeof evlistener === 'function') {
      return 1;
    } else if (evlistener !== undefined) {
      return evlistener.length;
    }
  }

  return 0;
}

EventEmitter.prototype.eventNames = function eventNames() {
  return this._eventsCount > 0 ? ReflectOwnKeys(this._events) : [];
};

function arrayClone(arr, n) {
  var copy = new Array(n);
  for (var i = 0; i < n; ++i)
    copy[i] = arr[i];
  return copy;
}

function spliceOne(list, index) {
  for (; index + 1 < list.length; index++)
    list[index] = list[index + 1];
  list.pop();
}

function unwrapListeners(arr) {
  var ret = new Array(arr.length);
  for (var i = 0; i < ret.length; ++i) {
    ret[i] = arr[i].listener || arr[i];
  }
  return ret;
}

function once(emitter, name) {
  return new Promise(function (resolve, reject) {
    function errorListener(err) {
      emitter.removeListener(name, resolver);
      reject(err);
    }

    function resolver() {
      if (typeof emitter.removeListener === 'function') {
        emitter.removeListener('error', errorListener);
      }
      resolve([].slice.call(arguments));
    };

    eventTargetAgnosticAddListener(emitter, name, resolver, { once: true });
    if (name !== 'error') {
      addErrorHandlerIfEventEmitter(emitter, errorListener, { once: true });
    }
  });
}

function addErrorHandlerIfEventEmitter(emitter, handler, flags) {
  if (typeof emitter.on === 'function') {
    eventTargetAgnosticAddListener(emitter, 'error', handler, flags);
  }
}

function eventTargetAgnosticAddListener(emitter, name, listener, flags) {
  if (typeof emitter.on === 'function') {
    if (flags.once) {
      emitter.once(name, listener);
    } else {
      emitter.on(name, listener);
    }
  } else if (typeof emitter.addEventListener === 'function') {
    // EventTarget does not have `error` event semantics like Node
    // EventEmitters, we do not listen for `error` events here.
    emitter.addEventListener(name, function wrapListener(arg) {
      // IE does not have builtin `{ once: true }` support so we
      // have to do it manually.
      if (flags.once) {
        emitter.removeEventListener(name, wrapListener);
      }
      listener(arg);
    });
  } else {
    throw new TypeError('The "emitter" argument must be of type EventEmitter. Received type ' + typeof emitter);
  }
}


/***/ }),

/***/ 68839:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "assign": function() { return /* binding */ assign; },
/* harmony export */   "defaultI18n": function() { return /* binding */ defaultI18n; },
/* harmony export */   "format": function() { return /* binding */ format; },
/* harmony export */   "parse": function() { return /* binding */ parse; },
/* harmony export */   "setGlobalDateI18n": function() { return /* binding */ setGlobalDateI18n; },
/* harmony export */   "setGlobalDateMasks": function() { return /* binding */ setGlobalDateMasks; }
/* harmony export */ });
var token = /d{1,4}|M{1,4}|YY(?:YY)?|S{1,3}|Do|ZZ|Z|([HhMsDm])\1?|[aA]|"[^"]*"|'[^']*'/g;
var twoDigitsOptional = "\\d\\d?";
var twoDigits = "\\d\\d";
var threeDigits = "\\d{3}";
var fourDigits = "\\d{4}";
var word = "[^\\s]+";
var literal = /\[([^]*?)\]/gm;
function shorten(arr, sLen) {
    var newArr = [];
    for (var i = 0, len = arr.length; i < len; i++) {
        newArr.push(arr[i].substr(0, sLen));
    }
    return newArr;
}
var monthUpdate = function (arrName) { return function (v, i18n) {
    var lowerCaseArr = i18n[arrName].map(function (v) { return v.toLowerCase(); });
    var index = lowerCaseArr.indexOf(v.toLowerCase());
    if (index > -1) {
        return index;
    }
    return null;
}; };
function assign(origObj) {
    var args = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        args[_i - 1] = arguments[_i];
    }
    for (var _a = 0, args_1 = args; _a < args_1.length; _a++) {
        var obj = args_1[_a];
        for (var key in obj) {
            // @ts-ignore ex
            origObj[key] = obj[key];
        }
    }
    return origObj;
}
var dayNames = [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday"
];
var monthNames = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December"
];
var monthNamesShort = shorten(monthNames, 3);
var dayNamesShort = shorten(dayNames, 3);
var defaultI18n = {
    dayNamesShort: dayNamesShort,
    dayNames: dayNames,
    monthNamesShort: monthNamesShort,
    monthNames: monthNames,
    amPm: ["am", "pm"],
    DoFn: function (dayOfMonth) {
        return (dayOfMonth +
            ["th", "st", "nd", "rd"][dayOfMonth % 10 > 3
                ? 0
                : ((dayOfMonth - (dayOfMonth % 10) !== 10 ? 1 : 0) * dayOfMonth) % 10]);
    }
};
var globalI18n = assign({}, defaultI18n);
var setGlobalDateI18n = function (i18n) {
    return (globalI18n = assign(globalI18n, i18n));
};
var regexEscape = function (str) {
    return str.replace(/[|\\{()[^$+*?.-]/g, "\\$&");
};
var pad = function (val, len) {
    if (len === void 0) { len = 2; }
    val = String(val);
    while (val.length < len) {
        val = "0" + val;
    }
    return val;
};
var formatFlags = {
    D: function (dateObj) { return String(dateObj.getDate()); },
    DD: function (dateObj) { return pad(dateObj.getDate()); },
    Do: function (dateObj, i18n) {
        return i18n.DoFn(dateObj.getDate());
    },
    d: function (dateObj) { return String(dateObj.getDay()); },
    dd: function (dateObj) { return pad(dateObj.getDay()); },
    ddd: function (dateObj, i18n) {
        return i18n.dayNamesShort[dateObj.getDay()];
    },
    dddd: function (dateObj, i18n) {
        return i18n.dayNames[dateObj.getDay()];
    },
    M: function (dateObj) { return String(dateObj.getMonth() + 1); },
    MM: function (dateObj) { return pad(dateObj.getMonth() + 1); },
    MMM: function (dateObj, i18n) {
        return i18n.monthNamesShort[dateObj.getMonth()];
    },
    MMMM: function (dateObj, i18n) {
        return i18n.monthNames[dateObj.getMonth()];
    },
    YY: function (dateObj) {
        return pad(String(dateObj.getFullYear()), 4).substr(2);
    },
    YYYY: function (dateObj) { return pad(dateObj.getFullYear(), 4); },
    h: function (dateObj) { return String(dateObj.getHours() % 12 || 12); },
    hh: function (dateObj) { return pad(dateObj.getHours() % 12 || 12); },
    H: function (dateObj) { return String(dateObj.getHours()); },
    HH: function (dateObj) { return pad(dateObj.getHours()); },
    m: function (dateObj) { return String(dateObj.getMinutes()); },
    mm: function (dateObj) { return pad(dateObj.getMinutes()); },
    s: function (dateObj) { return String(dateObj.getSeconds()); },
    ss: function (dateObj) { return pad(dateObj.getSeconds()); },
    S: function (dateObj) {
        return String(Math.round(dateObj.getMilliseconds() / 100));
    },
    SS: function (dateObj) {
        return pad(Math.round(dateObj.getMilliseconds() / 10), 2);
    },
    SSS: function (dateObj) { return pad(dateObj.getMilliseconds(), 3); },
    a: function (dateObj, i18n) {
        return dateObj.getHours() < 12 ? i18n.amPm[0] : i18n.amPm[1];
    },
    A: function (dateObj, i18n) {
        return dateObj.getHours() < 12
            ? i18n.amPm[0].toUpperCase()
            : i18n.amPm[1].toUpperCase();
    },
    ZZ: function (dateObj) {
        var offset = dateObj.getTimezoneOffset();
        return ((offset > 0 ? "-" : "+") +
            pad(Math.floor(Math.abs(offset) / 60) * 100 + (Math.abs(offset) % 60), 4));
    },
    Z: function (dateObj) {
        var offset = dateObj.getTimezoneOffset();
        return ((offset > 0 ? "-" : "+") +
            pad(Math.floor(Math.abs(offset) / 60), 2) +
            ":" +
            pad(Math.abs(offset) % 60, 2));
    }
};
var monthParse = function (v) { return +v - 1; };
var emptyDigits = [null, twoDigitsOptional];
var emptyWord = [null, word];
var amPm = [
    "isPm",
    word,
    function (v, i18n) {
        var val = v.toLowerCase();
        if (val === i18n.amPm[0]) {
            return 0;
        }
        else if (val === i18n.amPm[1]) {
            return 1;
        }
        return null;
    }
];
var timezoneOffset = [
    "timezoneOffset",
    "[^\\s]*?[\\+\\-]\\d\\d:?\\d\\d|[^\\s]*?Z?",
    function (v) {
        var parts = (v + "").match(/([+-]|\d\d)/gi);
        if (parts) {
            var minutes = +parts[1] * 60 + parseInt(parts[2], 10);
            return parts[0] === "+" ? minutes : -minutes;
        }
        return 0;
    }
];
var parseFlags = {
    D: ["day", twoDigitsOptional],
    DD: ["day", twoDigits],
    Do: ["day", twoDigitsOptional + word, function (v) { return parseInt(v, 10); }],
    M: ["month", twoDigitsOptional, monthParse],
    MM: ["month", twoDigits, monthParse],
    YY: [
        "year",
        twoDigits,
        function (v) {
            var now = new Date();
            var cent = +("" + now.getFullYear()).substr(0, 2);
            return +("" + (+v > 68 ? cent - 1 : cent) + v);
        }
    ],
    h: ["hour", twoDigitsOptional, undefined, "isPm"],
    hh: ["hour", twoDigits, undefined, "isPm"],
    H: ["hour", twoDigitsOptional],
    HH: ["hour", twoDigits],
    m: ["minute", twoDigitsOptional],
    mm: ["minute", twoDigits],
    s: ["second", twoDigitsOptional],
    ss: ["second", twoDigits],
    YYYY: ["year", fourDigits],
    S: ["millisecond", "\\d", function (v) { return +v * 100; }],
    SS: ["millisecond", twoDigits, function (v) { return +v * 10; }],
    SSS: ["millisecond", threeDigits],
    d: emptyDigits,
    dd: emptyDigits,
    ddd: emptyWord,
    dddd: emptyWord,
    MMM: ["month", word, monthUpdate("monthNamesShort")],
    MMMM: ["month", word, monthUpdate("monthNames")],
    a: amPm,
    A: amPm,
    ZZ: timezoneOffset,
    Z: timezoneOffset
};
// Some common format strings
var globalMasks = {
    default: "ddd MMM DD YYYY HH:mm:ss",
    shortDate: "M/D/YY",
    mediumDate: "MMM D, YYYY",
    longDate: "MMMM D, YYYY",
    fullDate: "dddd, MMMM D, YYYY",
    isoDate: "YYYY-MM-DD",
    isoDateTime: "YYYY-MM-DDTHH:mm:ssZ",
    shortTime: "HH:mm",
    mediumTime: "HH:mm:ss",
    longTime: "HH:mm:ss.SSS"
};
var setGlobalDateMasks = function (masks) { return assign(globalMasks, masks); };
/***
 * Format a date
 * @method format
 * @param {Date|number} dateObj
 * @param {string} mask Format of the date, i.e. 'mm-dd-yy' or 'shortDate'
 * @returns {string} Formatted date string
 */
var format = function (dateObj, mask, i18n) {
    if (mask === void 0) { mask = globalMasks["default"]; }
    if (i18n === void 0) { i18n = {}; }
    if (typeof dateObj === "number") {
        dateObj = new Date(dateObj);
    }
    if (Object.prototype.toString.call(dateObj) !== "[object Date]" ||
        isNaN(dateObj.getTime())) {
        throw new Error("Invalid Date pass to format");
    }
    mask = globalMasks[mask] || mask;
    var literals = [];
    // Make literals inactive by replacing them with @@@
    mask = mask.replace(literal, function ($0, $1) {
        literals.push($1);
        return "@@@";
    });
    var combinedI18nSettings = assign(assign({}, globalI18n), i18n);
    // Apply formatting rules
    mask = mask.replace(token, function ($0) {
        return formatFlags[$0](dateObj, combinedI18nSettings);
    });
    // Inline literal values back into the formatted value
    return mask.replace(/@@@/g, function () { return literals.shift(); });
};
/**
 * Parse a date string into a Javascript Date object /
 * @method parse
 * @param {string} dateStr Date string
 * @param {string} format Date parse format
 * @param {i18n} I18nSettingsOptional Full or subset of I18N settings
 * @returns {Date|null} Returns Date object. Returns null what date string is invalid or doesn't match format
 */
function parse(dateStr, format, i18n) {
    if (i18n === void 0) { i18n = {}; }
    if (typeof format !== "string") {
        throw new Error("Invalid format in fecha parse");
    }
    // Check to see if the format is actually a mask
    format = globalMasks[format] || format;
    // Avoid regular expression denial of service, fail early for really long strings
    // https://www.owasp.org/index.php/Regular_expression_Denial_of_Service_-_ReDoS
    if (dateStr.length > 1000) {
        return null;
    }
    // Default to the beginning of the year.
    var today = new Date();
    var dateInfo = {
        year: today.getFullYear(),
        month: 0,
        day: 1,
        hour: 0,
        minute: 0,
        second: 0,
        millisecond: 0,
        isPm: null,
        timezoneOffset: null
    };
    var parseInfo = [];
    var literals = [];
    // Replace all the literals with @@@. Hopefully a string that won't exist in the format
    var newFormat = format.replace(literal, function ($0, $1) {
        literals.push(regexEscape($1));
        return "@@@";
    });
    var specifiedFields = {};
    var requiredFields = {};
    // Change every token that we find into the correct regex
    newFormat = regexEscape(newFormat).replace(token, function ($0) {
        var info = parseFlags[$0];
        var field = info[0], regex = info[1], requiredField = info[3];
        // Check if the person has specified the same field twice. This will lead to confusing results.
        if (specifiedFields[field]) {
            throw new Error("Invalid format. " + field + " specified twice in format");
        }
        specifiedFields[field] = true;
        // Check if there are any required fields. For instance, 12 hour time requires AM/PM specified
        if (requiredField) {
            requiredFields[requiredField] = true;
        }
        parseInfo.push(info);
        return "(" + regex + ")";
    });
    // Check all the required fields are present
    Object.keys(requiredFields).forEach(function (field) {
        if (!specifiedFields[field]) {
            throw new Error("Invalid format. " + field + " is required in specified format");
        }
    });
    // Add back all the literals after
    newFormat = newFormat.replace(/@@@/g, function () { return literals.shift(); });
    // Check if the date string matches the format. If it doesn't return null
    var matches = dateStr.match(new RegExp(newFormat, "i"));
    if (!matches) {
        return null;
    }
    var combinedI18nSettings = assign(assign({}, globalI18n), i18n);
    // For each match, call the parser function for that date part
    for (var i = 1; i < matches.length; i++) {
        var _a = parseInfo[i - 1], field = _a[0], parser = _a[2];
        var value = parser
            ? parser(matches[i], combinedI18nSettings)
            : +matches[i];
        // If the parser can't make sense of the value, return null
        if (value == null) {
            return null;
        }
        dateInfo[field] = value;
    }
    if (dateInfo.isPm === 1 && dateInfo.hour != null && +dateInfo.hour !== 12) {
        dateInfo.hour = +dateInfo.hour + 12;
    }
    else if (dateInfo.isPm === 0 && +dateInfo.hour === 12) {
        dateInfo.hour = 0;
    }
    var dateTZ;
    if (dateInfo.timezoneOffset == null) {
        dateTZ = new Date(dateInfo.year, dateInfo.month, dateInfo.day, dateInfo.hour, dateInfo.minute, dateInfo.second, dateInfo.millisecond);
        var validateFields = [
            ["month", "getMonth"],
            ["day", "getDate"],
            ["hour", "getHours"],
            ["minute", "getMinutes"],
            ["second", "getSeconds"]
        ];
        for (var i = 0, len = validateFields.length; i < len; i++) {
            // Check to make sure the date field is within the allowed range. Javascript dates allows values
            // outside the allowed range. If the values don't match the value was invalid
            if (specifiedFields[validateFields[i][0]] &&
                dateInfo[validateFields[i][0]] !== dateTZ[validateFields[i][1]]()) {
                return null;
            }
        }
    }
    else {
        dateTZ = new Date(Date.UTC(dateInfo.year, dateInfo.month, dateInfo.day, dateInfo.hour, dateInfo.minute - dateInfo.timezoneOffset, dateInfo.second, dateInfo.millisecond));
        // We can't validate dates in another timezone unfortunately. Do a basic check instead
        if (dateInfo.month > 11 ||
            dateInfo.month < 0 ||
            dateInfo.day > 31 ||
            dateInfo.day < 1 ||
            dateInfo.hour > 23 ||
            dateInfo.hour < 0 ||
            dateInfo.minute > 59 ||
            dateInfo.minute < 0 ||
            dateInfo.second > 59 ||
            dateInfo.second < 0) {
            return null;
        }
    }
    // Don't allow invalid dates
    return dateTZ;
}
var fecha = {
    format: format,
    parse: parse,
    defaultI18n: defaultI18n,
    setGlobalDateI18n: setGlobalDateI18n,
    setGlobalDateMasks: setGlobalDateMasks
};

/* harmony default export */ __webpack_exports__["default"] = (fecha);

//# sourceMappingURL=fecha.js.map


/***/ }),

/***/ 17952:
/***/ (function(module) {

"use strict";


var toString = Object.prototype.toString;

/**
 * Extract names from functions.
 *
 * @param {Function} fn The function who's name we need to extract.
 * @returns {String} The name of the function.
 * @public
 */
module.exports = function name(fn) {
  if ('string' === typeof fn.displayName && fn.constructor.name) {
    return fn.displayName;
  } else if ('string' === typeof fn.name && fn.name) {
    return fn.name;
  }

  //
  // Check to see if the constructor has a name.
  //
  if (
       'object' === typeof fn
    && fn.constructor
    && 'string' === typeof fn.constructor.name
  ) return fn.constructor.name;

  //
  // toString the given function and attempt to parse it out of it, or determine
  // the class.
  //
  var named = fn.toString()
    , type = toString.call(fn).slice(8, -1);

  if ('Function' === type) {
    named = named.substring(named.indexOf('(') + 1, named.indexOf(')'));
  } else {
    named = type;
  }

  return named || 'anonymous';
};


/***/ }),

/***/ 51749:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var React = __webpack_require__(75271);

var ReactDOM = __webpack_require__(30967);

var PropTypes = __webpack_require__(40507);

var _require = __webpack_require__(60905),
    createFocusTrap = _require.createFocusTrap;

var _require2 = __webpack_require__(33699),
    isFocusable = _require2.isFocusable; // TODO: These issues are related to older React features which we'll likely need
//  to fix in order to move the code forward to the next major version of React.
//  @see https://github.com/davidtheclark/focus-trap-react/issues/77

/* eslint-disable react/no-find-dom-node */


var FocusTrap = /*#__PURE__*/function (_React$Component) {
  _inherits(FocusTrap, _React$Component);

  var _super = _createSuper(FocusTrap);

  function FocusTrap(props) {
    var _this;

    _classCallCheck(this, FocusTrap);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "getNodeForOption", function (optionName) {
      var _this$internalOptions;

      // use internal options first, falling back to original options
      var optionValue = (_this$internalOptions = this.internalOptions[optionName]) !== null && _this$internalOptions !== void 0 ? _this$internalOptions : this.originalOptions[optionName];

      if (typeof optionValue === 'function') {
        for (var _len = arguments.length, params = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
          params[_key - 1] = arguments[_key];
        }

        optionValue = optionValue.apply(void 0, params);
      }

      if (optionValue === true) {
        optionValue = undefined; // use default value
      }

      if (!optionValue) {
        if (optionValue === undefined || optionValue === false) {
          return optionValue;
        } // else, empty string (invalid), null (invalid), 0 (invalid)


        throw new Error("`".concat(optionName, "` was specified but was not a node, or did not return a node"));
      }

      var node = optionValue; // could be HTMLElement, SVGElement, or non-empty string at this point

      if (typeof optionValue === 'string') {
        var _this$getDocument;

        node = (_this$getDocument = this.getDocument()) === null || _this$getDocument === void 0 ? void 0 : _this$getDocument.querySelector(optionValue); // resolve to node, or null if fails

        if (!node) {
          throw new Error("`".concat(optionName, "` as selector refers to no known node"));
        }
      }

      return node;
    });

    _this.handleDeactivate = _this.handleDeactivate.bind(_assertThisInitialized(_this));
    _this.handlePostDeactivate = _this.handlePostDeactivate.bind(_assertThisInitialized(_this));
    _this.handleClickOutsideDeactivates = _this.handleClickOutsideDeactivates.bind(_assertThisInitialized(_this)); // focus-trap options used internally when creating the trap

    _this.internalOptions = {
      // We need to hijack the returnFocusOnDeactivate option,
      // because React can move focus into the element before we arrived at
      // this lifecycle hook (e.g. with autoFocus inputs). So the component
      // captures the previouslyFocusedElement in componentWillMount,
      // then (optionally) returns focus to it in componentWillUnmount.
      returnFocusOnDeactivate: false,
      // the rest of these are also related to deactivation of the trap, and we
      //  need to use them and control them as well
      checkCanReturnFocus: null,
      onDeactivate: _this.handleDeactivate,
      onPostDeactivate: _this.handlePostDeactivate,
      // we need to special-case this setting as well so that we can know if we should
      //  NOT return focus if the trap gets auto-deactivated as the result of an
      //  outside click (otherwise, we'll always think we should return focus because
      //  of how we manage that flag internally here)
      clickOutsideDeactivates: _this.handleClickOutsideDeactivates
    }; // original options provided by the consumer

    _this.originalOptions = {
      // because of the above `internalOptions`, we maintain our own flag for
      //  this option, and default it to `true` because that's focus-trap's default
      returnFocusOnDeactivate: true,
      // because of the above `internalOptions`, we keep these separate since
      //  they're part of the deactivation process which we configure (internally) to
      //  be shared between focus-trap and focus-trap-react
      onDeactivate: null,
      onPostDeactivate: null,
      checkCanReturnFocus: null,
      // the user's setting, defaulted to false since focus-trap defaults this to false
      clickOutsideDeactivates: false
    };
    var focusTrapOptions = props.focusTrapOptions;

    for (var optionName in focusTrapOptions) {
      if (!Object.prototype.hasOwnProperty.call(focusTrapOptions, optionName)) {
        continue;
      }

      if (optionName === 'returnFocusOnDeactivate' || optionName === 'onDeactivate' || optionName === 'onPostDeactivate' || optionName === 'checkCanReturnFocus' || optionName === 'clickOutsideDeactivates') {
        _this.originalOptions[optionName] = focusTrapOptions[optionName];
        continue; // exclude from internalOptions
      }

      _this.internalOptions[optionName] = focusTrapOptions[optionName];
    } // if set, `{ target: Node, allowDeactivation: boolean }` where `target` is the outside
    //  node that was clicked, and `allowDeactivation` is the result of the consumer's
    //  option (stored in `this.originalOptions.clickOutsideDeactivates`, which may be a
    //  function) whether to allow or deny auto-deactivation on click on this outside node


    _this.outsideClick = null; // elements from which to create the focus trap on mount; if a child is used
    //  instead of the `containerElements` prop, we'll get the child's related
    //  element when the trap renders and then is declared 'mounted'

    _this.focusTrapElements = props.containerElements || []; // now we remember what the currently focused element is, not relying on focus-trap

    _this.updatePreviousElement();

    return _this;
  }
  /**
   * Gets the configured document.
   * @returns {Document|undefined} Configured document, falling back to the main
   *  document, if it exists. During SSR, `undefined` is returned since the
   *  document doesn't exist.
   */


  _createClass(FocusTrap, [{
    key: "getDocument",
    value: function getDocument() {
      // SSR: careful to check if `document` exists before accessing it as a variable
      return this.props.focusTrapOptions.document || (typeof document !== 'undefined' ? document : undefined);
    }
    /**
     * Gets the node for the given option, which is expected to be an option that
     *  can be either a DOM node, a string that is a selector to get a node, `false`
     *  (if a node is explicitly NOT given), or a function that returns any of these
     *  values.
     * @param {string} optionName
     * @returns {undefined | false | HTMLElement | SVGElement} Returns
     *  `undefined` if the option is not specified; `false` if the option
     *  resolved to `false` (node explicitly not given); otherwise, the resolved
     *  DOM node.
     * @throws {Error} If the option is set, not `false`, and is not, or does not
     *  resolve to a node.
     */

  }, {
    key: "getReturnFocusNode",
    value: function getReturnFocusNode() {
      var node = this.getNodeForOption('setReturnFocus', this.previouslyFocusedElement);
      return node ? node : node === false ? false : this.previouslyFocusedElement;
    }
    /** Update the previously focused element with the currently focused element. */

  }, {
    key: "updatePreviousElement",
    value: function updatePreviousElement() {
      var currentDocument = this.getDocument();

      if (currentDocument) {
        this.previouslyFocusedElement = currentDocument.activeElement;
      }
    }
  }, {
    key: "deactivateTrap",
    value: function deactivateTrap() {
      // NOTE: it's possible the focus trap has already been deactivated without our knowing it,
      //  especially if the user set the `clickOutsideDeactivates: true` option on the trap,
      //  and the mouse was clicked on some element outside the trap; at that point, focus-trap
      //  will initiate its auto-deactivation process, which will call our own
      //  handleDeactivate(), which will call into this method
      if (!this.focusTrap || !this.focusTrap.active) {
        return;
      }

      this.focusTrap.deactivate({
        // NOTE: we never let the trap return the focus since we do that ourselves
        returnFocus: false,
        // we'll call this in our own post deactivate handler so make sure the trap doesn't
        //  do it prematurely
        checkCanReturnFocus: null,
        // let it call the user's original deactivate handler, if any, instead of
        //  our own which calls back into this function
        onDeactivate: this.originalOptions.onDeactivate // NOTE: for post deactivate, don't specify anything so that it calls the
        //  onPostDeactivate handler specified on `this.internalOptions`
        //  which will always be our own `handlePostDeactivate()` handler, which
        //  will finish things off by calling the user's provided onPostDeactivate
        //  handler, if any, at the right time
        // onPostDeactivate: NOTHING

      });
    }
  }, {
    key: "handleClickOutsideDeactivates",
    value: function handleClickOutsideDeactivates(event) {
      // use consumer's option (or call their handler) as the permission or denial
      var allowDeactivation = typeof this.originalOptions.clickOutsideDeactivates === 'function' ? this.originalOptions.clickOutsideDeactivates.call(null, event) // call out of context
      : this.originalOptions.clickOutsideDeactivates; // boolean

      if (allowDeactivation) {
        // capture the outside target that was clicked so we can use it in the deactivation
        //  process since the consumer allowed it to cause auto-deactivation
        this.outsideClick = {
          target: event.target,
          allowDeactivation: allowDeactivation
        };
      }

      return allowDeactivation;
    }
  }, {
    key: "handleDeactivate",
    value: function handleDeactivate() {
      if (this.originalOptions.onDeactivate) {
        this.originalOptions.onDeactivate.call(null); // call user's handler out of context
      }

      this.deactivateTrap();
    }
  }, {
    key: "handlePostDeactivate",
    value: function handlePostDeactivate() {
      var _this2 = this;

      var finishDeactivation = function finishDeactivation() {
        var returnFocusNode = _this2.getReturnFocusNode();

        var canReturnFocus = !!( // did the consumer allow it?
        _this2.originalOptions.returnFocusOnDeactivate && // can we actually focus the node?
        returnFocusNode !== null && returnFocusNode !== void 0 && returnFocusNode.focus && ( // was there an outside click that allowed deactivation?
        !_this2.outsideClick || // did the consumer allow deactivation when the outside node was clicked?
        _this2.outsideClick.allowDeactivation && // is the outside node NOT focusable (implying that it did NOT receive focus
        //  as a result of the click-through) -- in which case do NOT restore focus
        //  to `returnFocusNode` because focus should remain on the outside node
        !isFocusable(_this2.outsideClick.target, _this2.internalOptions.tabbableOptions)) // if no, the restore focus to `returnFocusNode` at this point
        );
        var _this2$internalOption = _this2.internalOptions.preventScroll,
            preventScroll = _this2$internalOption === void 0 ? false : _this2$internalOption;

        if (canReturnFocus) {
          // return focus to the element that had focus when the trap was activated
          returnFocusNode.focus({
            preventScroll: preventScroll
          });
        }

        if (_this2.originalOptions.onPostDeactivate) {
          _this2.originalOptions.onPostDeactivate.call(null); // don't call it in context of "this"

        }

        _this2.outsideClick = null; // reset: no longer needed
      };

      if (this.originalOptions.checkCanReturnFocus) {
        this.originalOptions.checkCanReturnFocus.call(null, this.getReturnFocusNode()) // call out of context
        .then(finishDeactivation, finishDeactivation);
      } else {
        finishDeactivation();
      }
    }
  }, {
    key: "setupFocusTrap",
    value: function setupFocusTrap() {
      if (!this.focusTrap) {
        var focusTrapElementDOMNodes = this.focusTrapElements.map( // NOTE: `findDOMNode()` does not support CSS selectors; it'll just return
        //  a new text node with the text wrapped in it instead of treating the
        //  string as a selector and resolving it to a node in the DOM
        ReactDOM.findDOMNode);
        var nodesExist = focusTrapElementDOMNodes.some(Boolean);

        if (nodesExist) {
          // eslint-disable-next-line react/prop-types -- _createFocusTrap is an internal prop
          this.focusTrap = this.props._createFocusTrap(focusTrapElementDOMNodes, this.internalOptions);

          if (this.props.active) {
            this.focusTrap.activate();
          }

          if (this.props.paused) {
            this.focusTrap.pause();
          }
        }
      }
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.props.active) {
        this.setupFocusTrap();
      } // else, wait for later activation in case the `focusTrapOptions` will be updated
      //  again before the trap is activated (e.g. if waiting to know what the document
      //  object will be, so the Trap must be rendered, but the consumer is waiting to
      //  activate until they have obtained the document from a ref)
      //  @see https://github.com/focus-trap/focus-trap-react/issues/539

    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (this.focusTrap) {
        if (prevProps.containerElements !== this.props.containerElements) {
          this.focusTrap.updateContainerElements(this.props.containerElements);
        }

        var hasActivated = !prevProps.active && this.props.active;
        var hasDeactivated = prevProps.active && !this.props.active;
        var hasPaused = !prevProps.paused && this.props.paused;
        var hasUnpaused = prevProps.paused && !this.props.paused;

        if (hasActivated) {
          this.updatePreviousElement();
          this.focusTrap.activate();
        }

        if (hasDeactivated) {
          this.deactivateTrap();
          return; // un/pause does nothing on an inactive trap
        }

        if (hasPaused) {
          this.focusTrap.pause();
        }

        if (hasUnpaused) {
          this.focusTrap.unpause();
        }
      } else {
        // NOTE: if we're in `componentDidUpdate` and we don't have a trap yet,
        //  it either means it shouldn't be active, or it should be but none of
        //  of given `containerElements` were present in the DOM the last time
        //  we tried to create the trap
        if (prevProps.containerElements !== this.props.containerElements) {
          this.focusTrapElements = this.props.containerElements;
        } // don't create the trap unless it should be active in case the consumer
        //  is still updating `focusTrapOptions`
        //  @see https://github.com/focus-trap/focus-trap-react/issues/539


        if (this.props.active) {
          this.updatePreviousElement();
          this.setupFocusTrap();
        }
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.deactivateTrap();
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var child = this.props.children ? React.Children.only(this.props.children) : undefined;

      if (child) {
        if (child.type && child.type === React.Fragment) {
          throw new Error('A focus-trap cannot use a Fragment as its child container. Try replacing it with a <div> element.');
        }

        var composedRefCallback = function composedRefCallback(element) {
          var containerElements = _this3.props.containerElements;

          if (child) {
            if (typeof child.ref === 'function') {
              child.ref(element);
            } else if (child.ref) {
              child.ref.current = element;
            }
          }

          _this3.focusTrapElements = containerElements ? containerElements : [element];
        };

        var childWithRef = React.cloneElement(child, {
          ref: composedRefCallback
        });
        return childWithRef;
      }

      return null;
    }
  }]);

  return FocusTrap;
}(React.Component); // support server-side rendering where `Element` will not be defined


var ElementType = typeof Element === 'undefined' ? Function : Element;
FocusTrap.propTypes = {
  active: PropTypes.bool,
  paused: PropTypes.bool,
  focusTrapOptions: PropTypes.shape({
    document: PropTypes.object,
    onActivate: PropTypes.func,
    onPostActivate: PropTypes.func,
    checkCanFocusTrap: PropTypes.func,
    onDeactivate: PropTypes.func,
    onPostDeactivate: PropTypes.func,
    checkCanReturnFocus: PropTypes.func,
    initialFocus: PropTypes.oneOfType([PropTypes.instanceOf(ElementType), PropTypes.string, PropTypes.bool, PropTypes.func]),
    fallbackFocus: PropTypes.oneOfType([PropTypes.instanceOf(ElementType), PropTypes.string, // NOTE: does not support `false` as value (or return value from function)
    PropTypes.func]),
    escapeDeactivates: PropTypes.oneOfType([PropTypes.bool, PropTypes.func]),
    clickOutsideDeactivates: PropTypes.oneOfType([PropTypes.bool, PropTypes.func]),
    returnFocusOnDeactivate: PropTypes.bool,
    setReturnFocus: PropTypes.oneOfType([PropTypes.instanceOf(ElementType), PropTypes.string, PropTypes.bool, PropTypes.func]),
    allowOutsideClick: PropTypes.oneOfType([PropTypes.bool, PropTypes.func]),
    preventScroll: PropTypes.bool,
    tabbableOptions: PropTypes.shape({
      displayCheck: PropTypes.oneOf(['full', 'non-zero-area', 'none']),
      getShadowRoot: PropTypes.oneOfType([PropTypes.bool, PropTypes.func])
    })
  }),
  containerElements: PropTypes.arrayOf(PropTypes.instanceOf(ElementType)),
  children: PropTypes.oneOfType([PropTypes.element, // React element
  PropTypes.instanceOf(ElementType) // DOM element
  ]) // NOTE: _createFocusTrap is internal, for testing purposes only, so we don't
  //  specify it here. It's expected to be set to the function returned from
  //  require('focus-trap'), or one with a compatible interface.

};
FocusTrap.defaultProps = {
  active: true,
  paused: false,
  focusTrapOptions: {},
  _createFocusTrap: createFocusTrap
};
module.exports = FocusTrap;

/***/ }),

/***/ 60905:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "createFocusTrap": function() { return /* binding */ createFocusTrap; }
/* harmony export */ });
/* harmony import */ var tabbable__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(33699);
/*!
* focus-trap 6.9.4
* @license MIT, https://github.com/focus-trap/focus-trap/blob/master/LICENSE
*/


function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var activeFocusTraps = function () {
  var trapQueue = [];
  return {
    activateTrap: function activateTrap(trap) {
      if (trapQueue.length > 0) {
        var activeTrap = trapQueue[trapQueue.length - 1];

        if (activeTrap !== trap) {
          activeTrap.pause();
        }
      }

      var trapIndex = trapQueue.indexOf(trap);

      if (trapIndex === -1) {
        trapQueue.push(trap);
      } else {
        // move this existing trap to the front of the queue
        trapQueue.splice(trapIndex, 1);
        trapQueue.push(trap);
      }
    },
    deactivateTrap: function deactivateTrap(trap) {
      var trapIndex = trapQueue.indexOf(trap);

      if (trapIndex !== -1) {
        trapQueue.splice(trapIndex, 1);
      }

      if (trapQueue.length > 0) {
        trapQueue[trapQueue.length - 1].unpause();
      }
    }
  };
}();

var isSelectableInput = function isSelectableInput(node) {
  return node.tagName && node.tagName.toLowerCase() === 'input' && typeof node.select === 'function';
};

var isEscapeEvent = function isEscapeEvent(e) {
  return e.key === 'Escape' || e.key === 'Esc' || e.keyCode === 27;
};

var isTabEvent = function isTabEvent(e) {
  return e.key === 'Tab' || e.keyCode === 9;
};

var delay = function delay(fn) {
  return setTimeout(fn, 0);
}; // Array.find/findIndex() are not supported on IE; this replicates enough
//  of Array.findIndex() for our needs


var findIndex = function findIndex(arr, fn) {
  var idx = -1;
  arr.every(function (value, i) {
    if (fn(value)) {
      idx = i;
      return false; // break
    }

    return true; // next
  });
  return idx;
};
/**
 * Get an option's value when it could be a plain value, or a handler that provides
 *  the value.
 * @param {*} value Option's value to check.
 * @param {...*} [params] Any parameters to pass to the handler, if `value` is a function.
 * @returns {*} The `value`, or the handler's returned value.
 */


var valueOrHandler = function valueOrHandler(value) {
  for (var _len = arguments.length, params = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    params[_key - 1] = arguments[_key];
  }

  return typeof value === 'function' ? value.apply(void 0, params) : value;
};

var getActualTarget = function getActualTarget(event) {
  // NOTE: If the trap is _inside_ a shadow DOM, event.target will always be the
  //  shadow host. However, event.target.composedPath() will be an array of
  //  nodes "clicked" from inner-most (the actual element inside the shadow) to
  //  outer-most (the host HTML document). If we have access to composedPath(),
  //  then use its first element; otherwise, fall back to event.target (and
  //  this only works for an _open_ shadow DOM; otherwise,
  //  composedPath()[0] === event.target always).
  return event.target.shadowRoot && typeof event.composedPath === 'function' ? event.composedPath()[0] : event.target;
};

var createFocusTrap = function createFocusTrap(elements, userOptions) {
  // SSR: a live trap shouldn't be created in this type of environment so this
  //  should be safe code to execute if the `document` option isn't specified
  var doc = (userOptions === null || userOptions === void 0 ? void 0 : userOptions.document) || document;

  var config = _objectSpread2({
    returnFocusOnDeactivate: true,
    escapeDeactivates: true,
    delayInitialFocus: true
  }, userOptions);

  var state = {
    // containers given to createFocusTrap()
    // @type {Array<HTMLElement>}
    containers: [],
    // list of objects identifying tabbable nodes in `containers` in the trap
    // NOTE: it's possible that a group has no tabbable nodes if nodes get removed while the trap
    //  is active, but the trap should never get to a state where there isn't at least one group
    //  with at least one tabbable node in it (that would lead to an error condition that would
    //  result in an error being thrown)
    // @type {Array<{
    //   container: HTMLElement,
    //   tabbableNodes: Array<HTMLElement>, // empty if none
    //   focusableNodes: Array<HTMLElement>, // empty if none
    //   firstTabbableNode: HTMLElement|null,
    //   lastTabbableNode: HTMLElement|null,
    //   nextTabbableNode: (node: HTMLElement, forward: boolean) => HTMLElement|undefined
    // }>}
    containerGroups: [],
    // same order/length as `containers` list
    // references to objects in `containerGroups`, but only those that actually have
    //  tabbable nodes in them
    // NOTE: same order as `containers` and `containerGroups`, but __not necessarily__
    //  the same length
    tabbableGroups: [],
    nodeFocusedBeforeActivation: null,
    mostRecentlyFocusedNode: null,
    active: false,
    paused: false,
    // timer ID for when delayInitialFocus is true and initial focus in this trap
    //  has been delayed during activation
    delayInitialFocusTimer: undefined
  };
  var trap; // eslint-disable-line prefer-const -- some private functions reference it, and its methods reference private functions, so we must declare here and define later

  /**
   * Gets a configuration option value.
   * @param {Object|undefined} configOverrideOptions If true, and option is defined in this set,
   *  value will be taken from this object. Otherwise, value will be taken from base configuration.
   * @param {string} optionName Name of the option whose value is sought.
   * @param {string|undefined} [configOptionName] Name of option to use __instead of__ `optionName`
   *  IIF `configOverrideOptions` is not defined. Otherwise, `optionName` is used.
   */

  var getOption = function getOption(configOverrideOptions, optionName, configOptionName) {
    return configOverrideOptions && configOverrideOptions[optionName] !== undefined ? configOverrideOptions[optionName] : config[configOptionName || optionName];
  };
  /**
   * Finds the index of the container that contains the element.
   * @param {HTMLElement} element
   * @returns {number} Index of the container in either `state.containers` or
   *  `state.containerGroups` (the order/length of these lists are the same); -1
   *  if the element isn't found.
   */


  var findContainerIndex = function findContainerIndex(element) {
    // NOTE: search `containerGroups` because it's possible a group contains no tabbable
    //  nodes, but still contains focusable nodes (e.g. if they all have `tabindex=-1`)
    //  and we still need to find the element in there
    return state.containerGroups.findIndex(function (_ref) {
      var container = _ref.container,
          tabbableNodes = _ref.tabbableNodes;
      return container.contains(element) || // fall back to explicit tabbable search which will take into consideration any
      //  web components if the `tabbableOptions.getShadowRoot` option was used for
      //  the trap, enabling shadow DOM support in tabbable (`Node.contains()` doesn't
      //  look inside web components even if open)
      tabbableNodes.find(function (node) {
        return node === element;
      });
    });
  };
  /**
   * Gets the node for the given option, which is expected to be an option that
   *  can be either a DOM node, a string that is a selector to get a node, `false`
   *  (if a node is explicitly NOT given), or a function that returns any of these
   *  values.
   * @param {string} optionName
   * @returns {undefined | false | HTMLElement | SVGElement} Returns
   *  `undefined` if the option is not specified; `false` if the option
   *  resolved to `false` (node explicitly not given); otherwise, the resolved
   *  DOM node.
   * @throws {Error} If the option is set, not `false`, and is not, or does not
   *  resolve to a node.
   */


  var getNodeForOption = function getNodeForOption(optionName) {
    var optionValue = config[optionName];

    if (typeof optionValue === 'function') {
      for (var _len2 = arguments.length, params = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
        params[_key2 - 1] = arguments[_key2];
      }

      optionValue = optionValue.apply(void 0, params);
    }

    if (optionValue === true) {
      optionValue = undefined; // use default value
    }

    if (!optionValue) {
      if (optionValue === undefined || optionValue === false) {
        return optionValue;
      } // else, empty string (invalid), null (invalid), 0 (invalid)


      throw new Error("`".concat(optionName, "` was specified but was not a node, or did not return a node"));
    }

    var node = optionValue; // could be HTMLElement, SVGElement, or non-empty string at this point

    if (typeof optionValue === 'string') {
      node = doc.querySelector(optionValue); // resolve to node, or null if fails

      if (!node) {
        throw new Error("`".concat(optionName, "` as selector refers to no known node"));
      }
    }

    return node;
  };

  var getInitialFocusNode = function getInitialFocusNode() {
    var node = getNodeForOption('initialFocus'); // false explicitly indicates we want no initialFocus at all

    if (node === false) {
      return false;
    }

    if (node === undefined) {
      // option not specified: use fallback options
      if (findContainerIndex(doc.activeElement) >= 0) {
        node = doc.activeElement;
      } else {
        var firstTabbableGroup = state.tabbableGroups[0];
        var firstTabbableNode = firstTabbableGroup && firstTabbableGroup.firstTabbableNode; // NOTE: `fallbackFocus` option function cannot return `false` (not supported)

        node = firstTabbableNode || getNodeForOption('fallbackFocus');
      }
    }

    if (!node) {
      throw new Error('Your focus-trap needs to have at least one focusable element');
    }

    return node;
  };

  var updateTabbableNodes = function updateTabbableNodes() {
    state.containerGroups = state.containers.map(function (container) {
      var tabbableNodes = (0,tabbable__WEBPACK_IMPORTED_MODULE_0__.tabbable)(container, config.tabbableOptions); // NOTE: if we have tabbable nodes, we must have focusable nodes; focusable nodes
      //  are a superset of tabbable nodes

      var focusableNodes = (0,tabbable__WEBPACK_IMPORTED_MODULE_0__.focusable)(container, config.tabbableOptions);
      return {
        container: container,
        tabbableNodes: tabbableNodes,
        focusableNodes: focusableNodes,
        firstTabbableNode: tabbableNodes.length > 0 ? tabbableNodes[0] : null,
        lastTabbableNode: tabbableNodes.length > 0 ? tabbableNodes[tabbableNodes.length - 1] : null,

        /**
         * Finds the __tabbable__ node that follows the given node in the specified direction,
         *  in this container, if any.
         * @param {HTMLElement} node
         * @param {boolean} [forward] True if going in forward tab order; false if going
         *  in reverse.
         * @returns {HTMLElement|undefined} The next tabbable node, if any.
         */
        nextTabbableNode: function nextTabbableNode(node) {
          var forward = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
          // NOTE: If tabindex is positive (in order to manipulate the tab order separate
          //  from the DOM order), this __will not work__ because the list of focusableNodes,
          //  while it contains tabbable nodes, does not sort its nodes in any order other
          //  than DOM order, because it can't: Where would you place focusable (but not
          //  tabbable) nodes in that order? They have no order, because they aren't tabbale...
          // Support for positive tabindex is already broken and hard to manage (possibly
          //  not supportable, TBD), so this isn't going to make things worse than they
          //  already are, and at least makes things better for the majority of cases where
          //  tabindex is either 0/unset or negative.
          // FYI, positive tabindex issue: https://github.com/focus-trap/focus-trap/issues/375
          var nodeIdx = focusableNodes.findIndex(function (n) {
            return n === node;
          });

          if (nodeIdx < 0) {
            return undefined;
          }

          if (forward) {
            return focusableNodes.slice(nodeIdx + 1).find(function (n) {
              return (0,tabbable__WEBPACK_IMPORTED_MODULE_0__.isTabbable)(n, config.tabbableOptions);
            });
          }

          return focusableNodes.slice(0, nodeIdx).reverse().find(function (n) {
            return (0,tabbable__WEBPACK_IMPORTED_MODULE_0__.isTabbable)(n, config.tabbableOptions);
          });
        }
      };
    });
    state.tabbableGroups = state.containerGroups.filter(function (group) {
      return group.tabbableNodes.length > 0;
    }); // throw if no groups have tabbable nodes and we don't have a fallback focus node either

    if (state.tabbableGroups.length <= 0 && !getNodeForOption('fallbackFocus') // returning false not supported for this option
    ) {
      throw new Error('Your focus-trap must have at least one container with at least one tabbable node in it at all times');
    }
  };

  var tryFocus = function tryFocus(node) {
    if (node === false) {
      return;
    }

    if (node === doc.activeElement) {
      return;
    }

    if (!node || !node.focus) {
      tryFocus(getInitialFocusNode());
      return;
    }

    node.focus({
      preventScroll: !!config.preventScroll
    });
    state.mostRecentlyFocusedNode = node;

    if (isSelectableInput(node)) {
      node.select();
    }
  };

  var getReturnFocusNode = function getReturnFocusNode(previousActiveElement) {
    var node = getNodeForOption('setReturnFocus', previousActiveElement);
    return node ? node : node === false ? false : previousActiveElement;
  }; // This needs to be done on mousedown and touchstart instead of click
  // so that it precedes the focus event.


  var checkPointerDown = function checkPointerDown(e) {
    var target = getActualTarget(e);

    if (findContainerIndex(target) >= 0) {
      // allow the click since it ocurred inside the trap
      return;
    }

    if (valueOrHandler(config.clickOutsideDeactivates, e)) {
      // immediately deactivate the trap
      trap.deactivate({
        // if, on deactivation, we should return focus to the node originally-focused
        //  when the trap was activated (or the configured `setReturnFocus` node),
        //  then assume it's also OK to return focus to the outside node that was
        //  just clicked, causing deactivation, as long as that node is focusable;
        //  if it isn't focusable, then return focus to the original node focused
        //  on activation (or the configured `setReturnFocus` node)
        // NOTE: by setting `returnFocus: false`, deactivate() will do nothing,
        //  which will result in the outside click setting focus to the node
        //  that was clicked, whether it's focusable or not; by setting
        //  `returnFocus: true`, we'll attempt to re-focus the node originally-focused
        //  on activation (or the configured `setReturnFocus` node)
        returnFocus: config.returnFocusOnDeactivate && !(0,tabbable__WEBPACK_IMPORTED_MODULE_0__.isFocusable)(target, config.tabbableOptions)
      });
      return;
    } // This is needed for mobile devices.
    // (If we'll only let `click` events through,
    // then on mobile they will be blocked anyways if `touchstart` is blocked.)


    if (valueOrHandler(config.allowOutsideClick, e)) {
      // allow the click outside the trap to take place
      return;
    } // otherwise, prevent the click


    e.preventDefault();
  }; // In case focus escapes the trap for some strange reason, pull it back in.


  var checkFocusIn = function checkFocusIn(e) {
    var target = getActualTarget(e);
    var targetContained = findContainerIndex(target) >= 0; // In Firefox when you Tab out of an iframe the Document is briefly focused.

    if (targetContained || target instanceof Document) {
      if (targetContained) {
        state.mostRecentlyFocusedNode = target;
      }
    } else {
      // escaped! pull it back in to where it just left
      e.stopImmediatePropagation();
      tryFocus(state.mostRecentlyFocusedNode || getInitialFocusNode());
    }
  }; // Hijack Tab events on the first and last focusable nodes of the trap,
  // in order to prevent focus from escaping. If it escapes for even a
  // moment it can end up scrolling the page and causing confusion so we
  // kind of need to capture the action at the keydown phase.


  var checkTab = function checkTab(e) {
    var target = getActualTarget(e);
    updateTabbableNodes();
    var destinationNode = null;

    if (state.tabbableGroups.length > 0) {
      // make sure the target is actually contained in a group
      // NOTE: the target may also be the container itself if it's focusable
      //  with tabIndex='-1' and was given initial focus
      var containerIndex = findContainerIndex(target);
      var containerGroup = containerIndex >= 0 ? state.containerGroups[containerIndex] : undefined;

      if (containerIndex < 0) {
        // target not found in any group: quite possible focus has escaped the trap,
        //  so bring it back in to...
        if (e.shiftKey) {
          // ...the last node in the last group
          destinationNode = state.tabbableGroups[state.tabbableGroups.length - 1].lastTabbableNode;
        } else {
          // ...the first node in the first group
          destinationNode = state.tabbableGroups[0].firstTabbableNode;
        }
      } else if (e.shiftKey) {
        // REVERSE
        // is the target the first tabbable node in a group?
        var startOfGroupIndex = findIndex(state.tabbableGroups, function (_ref2) {
          var firstTabbableNode = _ref2.firstTabbableNode;
          return target === firstTabbableNode;
        });

        if (startOfGroupIndex < 0 && (containerGroup.container === target || (0,tabbable__WEBPACK_IMPORTED_MODULE_0__.isFocusable)(target, config.tabbableOptions) && !(0,tabbable__WEBPACK_IMPORTED_MODULE_0__.isTabbable)(target, config.tabbableOptions) && !containerGroup.nextTabbableNode(target, false))) {
          // an exception case where the target is either the container itself, or
          //  a non-tabbable node that was given focus (i.e. tabindex is negative
          //  and user clicked on it or node was programmatically given focus)
          //  and is not followed by any other tabbable node, in which
          //  case, we should handle shift+tab as if focus were on the container's
          //  first tabbable node, and go to the last tabbable node of the LAST group
          startOfGroupIndex = containerIndex;
        }

        if (startOfGroupIndex >= 0) {
          // YES: then shift+tab should go to the last tabbable node in the
          //  previous group (and wrap around to the last tabbable node of
          //  the LAST group if it's the first tabbable node of the FIRST group)
          var destinationGroupIndex = startOfGroupIndex === 0 ? state.tabbableGroups.length - 1 : startOfGroupIndex - 1;
          var destinationGroup = state.tabbableGroups[destinationGroupIndex];
          destinationNode = destinationGroup.lastTabbableNode;
        }
      } else {
        // FORWARD
        // is the target the last tabbable node in a group?
        var lastOfGroupIndex = findIndex(state.tabbableGroups, function (_ref3) {
          var lastTabbableNode = _ref3.lastTabbableNode;
          return target === lastTabbableNode;
        });

        if (lastOfGroupIndex < 0 && (containerGroup.container === target || (0,tabbable__WEBPACK_IMPORTED_MODULE_0__.isFocusable)(target, config.tabbableOptions) && !(0,tabbable__WEBPACK_IMPORTED_MODULE_0__.isTabbable)(target, config.tabbableOptions) && !containerGroup.nextTabbableNode(target))) {
          // an exception case where the target is the container itself, or
          //  a non-tabbable node that was given focus (i.e. tabindex is negative
          //  and user clicked on it or node was programmatically given focus)
          //  and is not followed by any other tabbable node, in which
          //  case, we should handle tab as if focus were on the container's
          //  last tabbable node, and go to the first tabbable node of the FIRST group
          lastOfGroupIndex = containerIndex;
        }

        if (lastOfGroupIndex >= 0) {
          // YES: then tab should go to the first tabbable node in the next
          //  group (and wrap around to the first tabbable node of the FIRST
          //  group if it's the last tabbable node of the LAST group)
          var _destinationGroupIndex = lastOfGroupIndex === state.tabbableGroups.length - 1 ? 0 : lastOfGroupIndex + 1;

          var _destinationGroup = state.tabbableGroups[_destinationGroupIndex];
          destinationNode = _destinationGroup.firstTabbableNode;
        }
      }
    } else {
      // NOTE: the fallbackFocus option does not support returning false to opt-out
      destinationNode = getNodeForOption('fallbackFocus');
    }

    if (destinationNode) {
      e.preventDefault();
      tryFocus(destinationNode);
    } // else, let the browser take care of [shift+]tab and move the focus

  };

  var checkKey = function checkKey(e) {
    if (isEscapeEvent(e) && valueOrHandler(config.escapeDeactivates, e) !== false) {
      e.preventDefault();
      trap.deactivate();
      return;
    }

    if (isTabEvent(e)) {
      checkTab(e);
      return;
    }
  };

  var checkClick = function checkClick(e) {
    var target = getActualTarget(e);

    if (findContainerIndex(target) >= 0) {
      return;
    }

    if (valueOrHandler(config.clickOutsideDeactivates, e)) {
      return;
    }

    if (valueOrHandler(config.allowOutsideClick, e)) {
      return;
    }

    e.preventDefault();
    e.stopImmediatePropagation();
  }; //
  // EVENT LISTENERS
  //


  var addListeners = function addListeners() {
    if (!state.active) {
      return;
    } // There can be only one listening focus trap at a time


    activeFocusTraps.activateTrap(trap); // Delay ensures that the focused element doesn't capture the event
    // that caused the focus trap activation.

    state.delayInitialFocusTimer = config.delayInitialFocus ? delay(function () {
      tryFocus(getInitialFocusNode());
    }) : tryFocus(getInitialFocusNode());
    doc.addEventListener('focusin', checkFocusIn, true);
    doc.addEventListener('mousedown', checkPointerDown, {
      capture: true,
      passive: false
    });
    doc.addEventListener('touchstart', checkPointerDown, {
      capture: true,
      passive: false
    });
    doc.addEventListener('click', checkClick, {
      capture: true,
      passive: false
    });
    doc.addEventListener('keydown', checkKey, {
      capture: true,
      passive: false
    });
    return trap;
  };

  var removeListeners = function removeListeners() {
    if (!state.active) {
      return;
    }

    doc.removeEventListener('focusin', checkFocusIn, true);
    doc.removeEventListener('mousedown', checkPointerDown, true);
    doc.removeEventListener('touchstart', checkPointerDown, true);
    doc.removeEventListener('click', checkClick, true);
    doc.removeEventListener('keydown', checkKey, true);
    return trap;
  }; //
  // TRAP DEFINITION
  //


  trap = {
    get active() {
      return state.active;
    },

    get paused() {
      return state.paused;
    },

    activate: function activate(activateOptions) {
      if (state.active) {
        return this;
      }

      var onActivate = getOption(activateOptions, 'onActivate');
      var onPostActivate = getOption(activateOptions, 'onPostActivate');
      var checkCanFocusTrap = getOption(activateOptions, 'checkCanFocusTrap');

      if (!checkCanFocusTrap) {
        updateTabbableNodes();
      }

      state.active = true;
      state.paused = false;
      state.nodeFocusedBeforeActivation = doc.activeElement;

      if (onActivate) {
        onActivate();
      }

      var finishActivation = function finishActivation() {
        if (checkCanFocusTrap) {
          updateTabbableNodes();
        }

        addListeners();

        if (onPostActivate) {
          onPostActivate();
        }
      };

      if (checkCanFocusTrap) {
        checkCanFocusTrap(state.containers.concat()).then(finishActivation, finishActivation);
        return this;
      }

      finishActivation();
      return this;
    },
    deactivate: function deactivate(deactivateOptions) {
      if (!state.active) {
        return this;
      }

      var options = _objectSpread2({
        onDeactivate: config.onDeactivate,
        onPostDeactivate: config.onPostDeactivate,
        checkCanReturnFocus: config.checkCanReturnFocus
      }, deactivateOptions);

      clearTimeout(state.delayInitialFocusTimer); // noop if undefined

      state.delayInitialFocusTimer = undefined;
      removeListeners();
      state.active = false;
      state.paused = false;
      activeFocusTraps.deactivateTrap(trap);
      var onDeactivate = getOption(options, 'onDeactivate');
      var onPostDeactivate = getOption(options, 'onPostDeactivate');
      var checkCanReturnFocus = getOption(options, 'checkCanReturnFocus');
      var returnFocus = getOption(options, 'returnFocus', 'returnFocusOnDeactivate');

      if (onDeactivate) {
        onDeactivate();
      }

      var finishDeactivation = function finishDeactivation() {
        delay(function () {
          if (returnFocus) {
            tryFocus(getReturnFocusNode(state.nodeFocusedBeforeActivation));
          }

          if (onPostDeactivate) {
            onPostDeactivate();
          }
        });
      };

      if (returnFocus && checkCanReturnFocus) {
        checkCanReturnFocus(getReturnFocusNode(state.nodeFocusedBeforeActivation)).then(finishDeactivation, finishDeactivation);
        return this;
      }

      finishDeactivation();
      return this;
    },
    pause: function pause() {
      if (state.paused || !state.active) {
        return this;
      }

      state.paused = true;
      removeListeners();
      return this;
    },
    unpause: function unpause() {
      if (!state.paused || !state.active) {
        return this;
      }

      state.paused = false;
      updateTabbableNodes();
      addListeners();
      return this;
    },
    updateContainerElements: function updateContainerElements(containerElements) {
      var elementsAsArray = [].concat(containerElements).filter(Boolean);
      state.containers = elementsAsArray.map(function (element) {
        return typeof element === 'string' ? doc.querySelector(element) : element;
      });

      if (state.active) {
        updateTabbableNodes();
      }

      return this;
    }
  }; // initialize container elements

  trap.updateContainerElements(elements);
  return trap;
};


//# sourceMappingURL=focus-trap.esm.js.map


/***/ }),

/***/ 72904:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var isCallable = __webpack_require__(33655);

var toStr = Object.prototype.toString;
var hasOwnProperty = Object.prototype.hasOwnProperty;

var forEachArray = function forEachArray(array, iterator, receiver) {
    for (var i = 0, len = array.length; i < len; i++) {
        if (hasOwnProperty.call(array, i)) {
            if (receiver == null) {
                iterator(array[i], i, array);
            } else {
                iterator.call(receiver, array[i], i, array);
            }
        }
    }
};

var forEachString = function forEachString(string, iterator, receiver) {
    for (var i = 0, len = string.length; i < len; i++) {
        // no such thing as a sparse string.
        if (receiver == null) {
            iterator(string.charAt(i), i, string);
        } else {
            iterator.call(receiver, string.charAt(i), i, string);
        }
    }
};

var forEachObject = function forEachObject(object, iterator, receiver) {
    for (var k in object) {
        if (hasOwnProperty.call(object, k)) {
            if (receiver == null) {
                iterator(object[k], k, object);
            } else {
                iterator.call(receiver, object[k], k, object);
            }
        }
    }
};

var forEach = function forEach(list, iterator, thisArg) {
    if (!isCallable(iterator)) {
        throw new TypeError('iterator must be a function');
    }

    var receiver;
    if (arguments.length >= 3) {
        receiver = thisArg;
    }

    if (toStr.call(list) === '[object Array]') {
        forEachArray(list, iterator, receiver);
    } else if (typeof list === 'string') {
        forEachString(list, iterator, receiver);
    } else {
        forEachObject(list, iterator, receiver);
    }
};

module.exports = forEach;


/***/ }),

/***/ 60059:
/***/ (function(module) {

"use strict";


/* eslint no-invalid-this: 1 */

var ERROR_MESSAGE = 'Function.prototype.bind called on incompatible ';
var toStr = Object.prototype.toString;
var max = Math.max;
var funcType = '[object Function]';

var concatty = function concatty(a, b) {
    var arr = [];

    for (var i = 0; i < a.length; i += 1) {
        arr[i] = a[i];
    }
    for (var j = 0; j < b.length; j += 1) {
        arr[j + a.length] = b[j];
    }

    return arr;
};

var slicy = function slicy(arrLike, offset) {
    var arr = [];
    for (var i = offset || 0, j = 0; i < arrLike.length; i += 1, j += 1) {
        arr[j] = arrLike[i];
    }
    return arr;
};

var joiny = function (arr, joiner) {
    var str = '';
    for (var i = 0; i < arr.length; i += 1) {
        str += arr[i];
        if (i + 1 < arr.length) {
            str += joiner;
        }
    }
    return str;
};

module.exports = function bind(that) {
    var target = this;
    if (typeof target !== 'function' || toStr.apply(target) !== funcType) {
        throw new TypeError(ERROR_MESSAGE + target);
    }
    var args = slicy(arguments, 1);

    var bound;
    var binder = function () {
        if (this instanceof bound) {
            var result = target.apply(
                this,
                concatty(args, arguments)
            );
            if (Object(result) === result) {
                return result;
            }
            return this;
        }
        return target.apply(
            that,
            concatty(args, arguments)
        );

    };

    var boundLength = max(0, target.length - args.length);
    var boundArgs = [];
    for (var i = 0; i < boundLength; i++) {
        boundArgs[i] = '$' + i;
    }

    bound = Function('binder', 'return function (' + joiny(boundArgs, ',') + '){ return binder.apply(this,arguments); }')(binder);

    if (target.prototype) {
        var Empty = function Empty() {};
        Empty.prototype = target.prototype;
        bound.prototype = new Empty();
        Empty.prototype = null;
    }

    return bound;
};


/***/ }),

/***/ 48794:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var implementation = __webpack_require__(60059);

module.exports = Function.prototype.bind || implementation;


/***/ }),

/***/ 67415:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var undefined;

var $Error = __webpack_require__(46392);
var $EvalError = __webpack_require__(56731);
var $RangeError = __webpack_require__(33996);
var $ReferenceError = __webpack_require__(90961);
var $SyntaxError = __webpack_require__(75736);
var $TypeError = __webpack_require__(29837);
var $URIError = __webpack_require__(37821);

var $Function = Function;

// eslint-disable-next-line consistent-return
var getEvalledConstructor = function (expressionSyntax) {
	try {
		return $Function('"use strict"; return (' + expressionSyntax + ').constructor;')();
	} catch (e) {}
};

var $gOPD = Object.getOwnPropertyDescriptor;
if ($gOPD) {
	try {
		$gOPD({}, '');
	} catch (e) {
		$gOPD = null; // this is IE 8, which has a broken gOPD
	}
}

var throwTypeError = function () {
	throw new $TypeError();
};
var ThrowTypeError = $gOPD
	? (function () {
		try {
			// eslint-disable-next-line no-unused-expressions, no-caller, no-restricted-properties
			arguments.callee; // IE 8 does not throw here
			return throwTypeError;
		} catch (calleeThrows) {
			try {
				// IE 8 throws on Object.getOwnPropertyDescriptor(arguments, '')
				return $gOPD(arguments, 'callee').get;
			} catch (gOPDthrows) {
				return throwTypeError;
			}
		}
	}())
	: throwTypeError;

var hasSymbols = __webpack_require__(91143)();
var hasProto = __webpack_require__(65910)();

var getProto = Object.getPrototypeOf || (
	hasProto
		? function (x) { return x.__proto__; } // eslint-disable-line no-proto
		: null
);

var needsEval = {};

var TypedArray = typeof Uint8Array === 'undefined' || !getProto ? undefined : getProto(Uint8Array);

var INTRINSICS = {
	__proto__: null,
	'%AggregateError%': typeof AggregateError === 'undefined' ? undefined : AggregateError,
	'%Array%': Array,
	'%ArrayBuffer%': typeof ArrayBuffer === 'undefined' ? undefined : ArrayBuffer,
	'%ArrayIteratorPrototype%': hasSymbols && getProto ? getProto([][Symbol.iterator]()) : undefined,
	'%AsyncFromSyncIteratorPrototype%': undefined,
	'%AsyncFunction%': needsEval,
	'%AsyncGenerator%': needsEval,
	'%AsyncGeneratorFunction%': needsEval,
	'%AsyncIteratorPrototype%': needsEval,
	'%Atomics%': typeof Atomics === 'undefined' ? undefined : Atomics,
	'%BigInt%': typeof BigInt === 'undefined' ? undefined : BigInt,
	'%BigInt64Array%': typeof BigInt64Array === 'undefined' ? undefined : BigInt64Array,
	'%BigUint64Array%': typeof BigUint64Array === 'undefined' ? undefined : BigUint64Array,
	'%Boolean%': Boolean,
	'%DataView%': typeof DataView === 'undefined' ? undefined : DataView,
	'%Date%': Date,
	'%decodeURI%': decodeURI,
	'%decodeURIComponent%': decodeURIComponent,
	'%encodeURI%': encodeURI,
	'%encodeURIComponent%': encodeURIComponent,
	'%Error%': $Error,
	'%eval%': eval, // eslint-disable-line no-eval
	'%EvalError%': $EvalError,
	'%Float32Array%': typeof Float32Array === 'undefined' ? undefined : Float32Array,
	'%Float64Array%': typeof Float64Array === 'undefined' ? undefined : Float64Array,
	'%FinalizationRegistry%': typeof FinalizationRegistry === 'undefined' ? undefined : FinalizationRegistry,
	'%Function%': $Function,
	'%GeneratorFunction%': needsEval,
	'%Int8Array%': typeof Int8Array === 'undefined' ? undefined : Int8Array,
	'%Int16Array%': typeof Int16Array === 'undefined' ? undefined : Int16Array,
	'%Int32Array%': typeof Int32Array === 'undefined' ? undefined : Int32Array,
	'%isFinite%': isFinite,
	'%isNaN%': isNaN,
	'%IteratorPrototype%': hasSymbols && getProto ? getProto(getProto([][Symbol.iterator]())) : undefined,
	'%JSON%': typeof JSON === 'object' ? JSON : undefined,
	'%Map%': typeof Map === 'undefined' ? undefined : Map,
	'%MapIteratorPrototype%': typeof Map === 'undefined' || !hasSymbols || !getProto ? undefined : getProto(new Map()[Symbol.iterator]()),
	'%Math%': Math,
	'%Number%': Number,
	'%Object%': Object,
	'%parseFloat%': parseFloat,
	'%parseInt%': parseInt,
	'%Promise%': typeof Promise === 'undefined' ? undefined : Promise,
	'%Proxy%': typeof Proxy === 'undefined' ? undefined : Proxy,
	'%RangeError%': $RangeError,
	'%ReferenceError%': $ReferenceError,
	'%Reflect%': typeof Reflect === 'undefined' ? undefined : Reflect,
	'%RegExp%': RegExp,
	'%Set%': typeof Set === 'undefined' ? undefined : Set,
	'%SetIteratorPrototype%': typeof Set === 'undefined' || !hasSymbols || !getProto ? undefined : getProto(new Set()[Symbol.iterator]()),
	'%SharedArrayBuffer%': typeof SharedArrayBuffer === 'undefined' ? undefined : SharedArrayBuffer,
	'%String%': String,
	'%StringIteratorPrototype%': hasSymbols && getProto ? getProto(''[Symbol.iterator]()) : undefined,
	'%Symbol%': hasSymbols ? Symbol : undefined,
	'%SyntaxError%': $SyntaxError,
	'%ThrowTypeError%': ThrowTypeError,
	'%TypedArray%': TypedArray,
	'%TypeError%': $TypeError,
	'%Uint8Array%': typeof Uint8Array === 'undefined' ? undefined : Uint8Array,
	'%Uint8ClampedArray%': typeof Uint8ClampedArray === 'undefined' ? undefined : Uint8ClampedArray,
	'%Uint16Array%': typeof Uint16Array === 'undefined' ? undefined : Uint16Array,
	'%Uint32Array%': typeof Uint32Array === 'undefined' ? undefined : Uint32Array,
	'%URIError%': $URIError,
	'%WeakMap%': typeof WeakMap === 'undefined' ? undefined : WeakMap,
	'%WeakRef%': typeof WeakRef === 'undefined' ? undefined : WeakRef,
	'%WeakSet%': typeof WeakSet === 'undefined' ? undefined : WeakSet
};

if (getProto) {
	try {
		null.error; // eslint-disable-line no-unused-expressions
	} catch (e) {
		// https://github.com/tc39/proposal-shadowrealm/pull/384#issuecomment-1364264229
		var errorProto = getProto(getProto(e));
		INTRINSICS['%Error.prototype%'] = errorProto;
	}
}

var doEval = function doEval(name) {
	var value;
	if (name === '%AsyncFunction%') {
		value = getEvalledConstructor('async function () {}');
	} else if (name === '%GeneratorFunction%') {
		value = getEvalledConstructor('function* () {}');
	} else if (name === '%AsyncGeneratorFunction%') {
		value = getEvalledConstructor('async function* () {}');
	} else if (name === '%AsyncGenerator%') {
		var fn = doEval('%AsyncGeneratorFunction%');
		if (fn) {
			value = fn.prototype;
		}
	} else if (name === '%AsyncIteratorPrototype%') {
		var gen = doEval('%AsyncGenerator%');
		if (gen && getProto) {
			value = getProto(gen.prototype);
		}
	}

	INTRINSICS[name] = value;

	return value;
};

var LEGACY_ALIASES = {
	__proto__: null,
	'%ArrayBufferPrototype%': ['ArrayBuffer', 'prototype'],
	'%ArrayPrototype%': ['Array', 'prototype'],
	'%ArrayProto_entries%': ['Array', 'prototype', 'entries'],
	'%ArrayProto_forEach%': ['Array', 'prototype', 'forEach'],
	'%ArrayProto_keys%': ['Array', 'prototype', 'keys'],
	'%ArrayProto_values%': ['Array', 'prototype', 'values'],
	'%AsyncFunctionPrototype%': ['AsyncFunction', 'prototype'],
	'%AsyncGenerator%': ['AsyncGeneratorFunction', 'prototype'],
	'%AsyncGeneratorPrototype%': ['AsyncGeneratorFunction', 'prototype', 'prototype'],
	'%BooleanPrototype%': ['Boolean', 'prototype'],
	'%DataViewPrototype%': ['DataView', 'prototype'],
	'%DatePrototype%': ['Date', 'prototype'],
	'%ErrorPrototype%': ['Error', 'prototype'],
	'%EvalErrorPrototype%': ['EvalError', 'prototype'],
	'%Float32ArrayPrototype%': ['Float32Array', 'prototype'],
	'%Float64ArrayPrototype%': ['Float64Array', 'prototype'],
	'%FunctionPrototype%': ['Function', 'prototype'],
	'%Generator%': ['GeneratorFunction', 'prototype'],
	'%GeneratorPrototype%': ['GeneratorFunction', 'prototype', 'prototype'],
	'%Int8ArrayPrototype%': ['Int8Array', 'prototype'],
	'%Int16ArrayPrototype%': ['Int16Array', 'prototype'],
	'%Int32ArrayPrototype%': ['Int32Array', 'prototype'],
	'%JSONParse%': ['JSON', 'parse'],
	'%JSONStringify%': ['JSON', 'stringify'],
	'%MapPrototype%': ['Map', 'prototype'],
	'%NumberPrototype%': ['Number', 'prototype'],
	'%ObjectPrototype%': ['Object', 'prototype'],
	'%ObjProto_toString%': ['Object', 'prototype', 'toString'],
	'%ObjProto_valueOf%': ['Object', 'prototype', 'valueOf'],
	'%PromisePrototype%': ['Promise', 'prototype'],
	'%PromiseProto_then%': ['Promise', 'prototype', 'then'],
	'%Promise_all%': ['Promise', 'all'],
	'%Promise_reject%': ['Promise', 'reject'],
	'%Promise_resolve%': ['Promise', 'resolve'],
	'%RangeErrorPrototype%': ['RangeError', 'prototype'],
	'%ReferenceErrorPrototype%': ['ReferenceError', 'prototype'],
	'%RegExpPrototype%': ['RegExp', 'prototype'],
	'%SetPrototype%': ['Set', 'prototype'],
	'%SharedArrayBufferPrototype%': ['SharedArrayBuffer', 'prototype'],
	'%StringPrototype%': ['String', 'prototype'],
	'%SymbolPrototype%': ['Symbol', 'prototype'],
	'%SyntaxErrorPrototype%': ['SyntaxError', 'prototype'],
	'%TypedArrayPrototype%': ['TypedArray', 'prototype'],
	'%TypeErrorPrototype%': ['TypeError', 'prototype'],
	'%Uint8ArrayPrototype%': ['Uint8Array', 'prototype'],
	'%Uint8ClampedArrayPrototype%': ['Uint8ClampedArray', 'prototype'],
	'%Uint16ArrayPrototype%': ['Uint16Array', 'prototype'],
	'%Uint32ArrayPrototype%': ['Uint32Array', 'prototype'],
	'%URIErrorPrototype%': ['URIError', 'prototype'],
	'%WeakMapPrototype%': ['WeakMap', 'prototype'],
	'%WeakSetPrototype%': ['WeakSet', 'prototype']
};

var bind = __webpack_require__(48794);
var hasOwn = __webpack_require__(52957);
var $concat = bind.call(Function.call, Array.prototype.concat);
var $spliceApply = bind.call(Function.apply, Array.prototype.splice);
var $replace = bind.call(Function.call, String.prototype.replace);
var $strSlice = bind.call(Function.call, String.prototype.slice);
var $exec = bind.call(Function.call, RegExp.prototype.exec);

/* adapted from https://github.com/lodash/lodash/blob/4.17.15/dist/lodash.js#L6735-L6744 */
var rePropName = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g;
var reEscapeChar = /\\(\\)?/g; /** Used to match backslashes in property paths. */
var stringToPath = function stringToPath(string) {
	var first = $strSlice(string, 0, 1);
	var last = $strSlice(string, -1);
	if (first === '%' && last !== '%') {
		throw new $SyntaxError('invalid intrinsic syntax, expected closing `%`');
	} else if (last === '%' && first !== '%') {
		throw new $SyntaxError('invalid intrinsic syntax, expected opening `%`');
	}
	var result = [];
	$replace(string, rePropName, function (match, number, quote, subString) {
		result[result.length] = quote ? $replace(subString, reEscapeChar, '$1') : number || match;
	});
	return result;
};
/* end adaptation */

var getBaseIntrinsic = function getBaseIntrinsic(name, allowMissing) {
	var intrinsicName = name;
	var alias;
	if (hasOwn(LEGACY_ALIASES, intrinsicName)) {
		alias = LEGACY_ALIASES[intrinsicName];
		intrinsicName = '%' + alias[0] + '%';
	}

	if (hasOwn(INTRINSICS, intrinsicName)) {
		var value = INTRINSICS[intrinsicName];
		if (value === needsEval) {
			value = doEval(intrinsicName);
		}
		if (typeof value === 'undefined' && !allowMissing) {
			throw new $TypeError('intrinsic ' + name + ' exists, but is not available. Please file an issue!');
		}

		return {
			alias: alias,
			name: intrinsicName,
			value: value
		};
	}

	throw new $SyntaxError('intrinsic ' + name + ' does not exist!');
};

module.exports = function GetIntrinsic(name, allowMissing) {
	if (typeof name !== 'string' || name.length === 0) {
		throw new $TypeError('intrinsic name must be a non-empty string');
	}
	if (arguments.length > 1 && typeof allowMissing !== 'boolean') {
		throw new $TypeError('"allowMissing" argument must be a boolean');
	}

	if ($exec(/^%?[^%]*%?$/, name) === null) {
		throw new $SyntaxError('`%` may not be present anywhere but at the beginning and end of the intrinsic name');
	}
	var parts = stringToPath(name);
	var intrinsicBaseName = parts.length > 0 ? parts[0] : '';

	var intrinsic = getBaseIntrinsic('%' + intrinsicBaseName + '%', allowMissing);
	var intrinsicRealName = intrinsic.name;
	var value = intrinsic.value;
	var skipFurtherCaching = false;

	var alias = intrinsic.alias;
	if (alias) {
		intrinsicBaseName = alias[0];
		$spliceApply(parts, $concat([0, 1], alias));
	}

	for (var i = 1, isOwn = true; i < parts.length; i += 1) {
		var part = parts[i];
		var first = $strSlice(part, 0, 1);
		var last = $strSlice(part, -1);
		if (
			(
				(first === '"' || first === "'" || first === '`')
				|| (last === '"' || last === "'" || last === '`')
			)
			&& first !== last
		) {
			throw new $SyntaxError('property names with quotes must have matching quotes');
		}
		if (part === 'constructor' || !isOwn) {
			skipFurtherCaching = true;
		}

		intrinsicBaseName += '.' + part;
		intrinsicRealName = '%' + intrinsicBaseName + '%';

		if (hasOwn(INTRINSICS, intrinsicRealName)) {
			value = INTRINSICS[intrinsicRealName];
		} else if (value != null) {
			if (!(part in value)) {
				if (!allowMissing) {
					throw new $TypeError('base intrinsic for ' + name + ' exists, but the property is not available.');
				}
				return void undefined;
			}
			if ($gOPD && (i + 1) >= parts.length) {
				var desc = $gOPD(value, part);
				isOwn = !!desc;

				// By convention, when a data property is converted to an accessor
				// property to emulate a data property that does not suffer from
				// the override mistake, that accessor's getter is marked with
				// an `originalValue` property. Here, when we detect this, we
				// uphold the illusion by pretending to see that original data
				// property, i.e., returning the value rather than the getter
				// itself.
				if (isOwn && 'get' in desc && !('originalValue' in desc.get)) {
					value = desc.get;
				} else {
					value = value[part];
				}
			} else {
				isOwn = hasOwn(value, part);
				value = value[part];
			}

			if (isOwn && !skipFurtherCaching) {
				INTRINSICS[intrinsicRealName] = value;
			}
		}
	}
	return value;
};


/***/ }),

/***/ 70658:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var GetIntrinsic = __webpack_require__(67415);

var $gOPD = GetIntrinsic('%Object.getOwnPropertyDescriptor%', true);

if ($gOPD) {
	try {
		$gOPD([], 'length');
	} catch (e) {
		// IE 8 has a broken gOPD
		$gOPD = null;
	}
}

module.exports = $gOPD;


/***/ }),

/***/ 94074:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var $defineProperty = __webpack_require__(2833);

var hasPropertyDescriptors = function hasPropertyDescriptors() {
	return !!$defineProperty;
};

hasPropertyDescriptors.hasArrayLengthDefineBug = function hasArrayLengthDefineBug() {
	// node v0.6 has a bug where array lengths can be Set but not Defined
	if (!$defineProperty) {
		return null;
	}
	try {
		return $defineProperty([], 'length', { value: 1 }).length !== 1;
	} catch (e) {
		// In Firefox 4-22, defining length on an array throws an exception.
		return true;
	}
};

module.exports = hasPropertyDescriptors;


/***/ }),

/***/ 65910:
/***/ (function(module) {

"use strict";


var test = {
	__proto__: null,
	foo: {}
};

var $Object = Object;

/** @type {import('.')} */
module.exports = function hasProto() {
	// @ts-expect-error: TS errors on an inherited property for some reason
	return { __proto__: test }.foo === test.foo
		&& !(test instanceof $Object);
};


/***/ }),

/***/ 91143:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var origSymbol = typeof Symbol !== 'undefined' && Symbol;
var hasSymbolSham = __webpack_require__(79985);

module.exports = function hasNativeSymbols() {
	if (typeof origSymbol !== 'function') { return false; }
	if (typeof Symbol !== 'function') { return false; }
	if (typeof origSymbol('foo') !== 'symbol') { return false; }
	if (typeof Symbol('bar') !== 'symbol') { return false; }

	return hasSymbolSham();
};


/***/ }),

/***/ 79985:
/***/ (function(module) {

"use strict";


/* eslint complexity: [2, 18], max-statements: [2, 33] */
module.exports = function hasSymbols() {
	if (typeof Symbol !== 'function' || typeof Object.getOwnPropertySymbols !== 'function') { return false; }
	if (typeof Symbol.iterator === 'symbol') { return true; }

	var obj = {};
	var sym = Symbol('test');
	var symObj = Object(sym);
	if (typeof sym === 'string') { return false; }

	if (Object.prototype.toString.call(sym) !== '[object Symbol]') { return false; }
	if (Object.prototype.toString.call(symObj) !== '[object Symbol]') { return false; }

	// temp disabled per https://github.com/ljharb/object.assign/issues/17
	// if (sym instanceof Symbol) { return false; }
	// temp disabled per https://github.com/WebReflection/get-own-property-symbols/issues/4
	// if (!(symObj instanceof Symbol)) { return false; }

	// if (typeof Symbol.prototype.toString !== 'function') { return false; }
	// if (String(sym) !== Symbol.prototype.toString.call(sym)) { return false; }

	var symVal = 42;
	obj[sym] = symVal;
	for (sym in obj) { return false; } // eslint-disable-line no-restricted-syntax, no-unreachable-loop
	if (typeof Object.keys === 'function' && Object.keys(obj).length !== 0) { return false; }

	if (typeof Object.getOwnPropertyNames === 'function' && Object.getOwnPropertyNames(obj).length !== 0) { return false; }

	var syms = Object.getOwnPropertySymbols(obj);
	if (syms.length !== 1 || syms[0] !== sym) { return false; }

	if (!Object.prototype.propertyIsEnumerable.call(obj, sym)) { return false; }

	if (typeof Object.getOwnPropertyDescriptor === 'function') {
		var descriptor = Object.getOwnPropertyDescriptor(obj, sym);
		if (descriptor.value !== symVal || descriptor.enumerable !== true) { return false; }
	}

	return true;
};


/***/ }),

/***/ 47388:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var hasSymbols = __webpack_require__(79985);

/** @type {import('.')} */
module.exports = function hasToStringTagShams() {
	return hasSymbols() && !!Symbol.toStringTag;
};


/***/ }),

/***/ 52957:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var call = Function.prototype.call;
var $hasOwn = Object.prototype.hasOwnProperty;
var bind = __webpack_require__(48794);

/** @type {import('.')} */
module.exports = bind.call(call, $hasOwn);


/***/ }),

/***/ 72535:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var reactIs = __webpack_require__(56237);

/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
var REACT_STATICS = {
  childContextTypes: true,
  contextType: true,
  contextTypes: true,
  defaultProps: true,
  displayName: true,
  getDefaultProps: true,
  getDerivedStateFromError: true,
  getDerivedStateFromProps: true,
  mixins: true,
  propTypes: true,
  type: true
};
var KNOWN_STATICS = {
  name: true,
  length: true,
  prototype: true,
  caller: true,
  callee: true,
  arguments: true,
  arity: true
};
var FORWARD_REF_STATICS = {
  '$$typeof': true,
  render: true,
  defaultProps: true,
  displayName: true,
  propTypes: true
};
var MEMO_STATICS = {
  '$$typeof': true,
  compare: true,
  defaultProps: true,
  displayName: true,
  propTypes: true,
  type: true
};
var TYPE_STATICS = {};
TYPE_STATICS[reactIs.ForwardRef] = FORWARD_REF_STATICS;
TYPE_STATICS[reactIs.Memo] = MEMO_STATICS;

function getStatics(component) {
  // React v16.11 and below
  if (reactIs.isMemo(component)) {
    return MEMO_STATICS;
  } // React v16.12 and above


  return TYPE_STATICS[component['$$typeof']] || REACT_STATICS;
}

var defineProperty = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = Object.prototype;
function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
  if (typeof sourceComponent !== 'string') {
    // don't hoist over string (html) components
    if (objectPrototype) {
      var inheritedComponent = getPrototypeOf(sourceComponent);

      if (inheritedComponent && inheritedComponent !== objectPrototype) {
        hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
      }
    }

    var keys = getOwnPropertyNames(sourceComponent);

    if (getOwnPropertySymbols) {
      keys = keys.concat(getOwnPropertySymbols(sourceComponent));
    }

    var targetStatics = getStatics(targetComponent);
    var sourceStatics = getStatics(sourceComponent);

    for (var i = 0; i < keys.length; ++i) {
      var key = keys[i];

      if (!KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
        var descriptor = getOwnPropertyDescriptor(sourceComponent, key);

        try {
          // Avoid failures from read-only properties
          defineProperty(targetComponent, key, descriptor);
        } catch (e) {}
      }
    }
  }

  return targetComponent;
}

module.exports = hoistNonReactStatics;


/***/ }),

/***/ 87493:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;// =========
// = humps =
// =========
// Underscore-to-camelCase converter (and vice versa)
// for strings and object keys

// humps is copyright © 2012+ Dom Christie
// Released under the MIT license.


;(function(global) {

  var _processKeys = function(convert, obj, options) {
    if(!_isObject(obj) || _isDate(obj) || _isRegExp(obj) || _isBoolean(obj) || _isFunction(obj)) {
      return obj;
    }

    var output,
        i = 0,
        l = 0;

    if(_isArray(obj)) {
      output = [];
      for(l=obj.length; i<l; i++) {
        output.push(_processKeys(convert, obj[i], options));
      }
    }
    else {
      output = {};
      for(var key in obj) {
        if(Object.prototype.hasOwnProperty.call(obj, key)) {
          output[convert(key, options)] = _processKeys(convert, obj[key], options);
        }
      }
    }
    return output;
  };

  // String conversion methods

  var separateWords = function(string, options) {
    options = options || {};
    var separator = options.separator || '_';
    var split = options.split || /(?=[A-Z])/;

    return string.split(split).join(separator);
  };

  var camelize = function(string) {
    if (_isNumerical(string)) {
      return string;
    }
    string = string.replace(/[\-_\s]+(.)?/g, function(match, chr) {
      return chr ? chr.toUpperCase() : '';
    });
    // Ensure 1st char is always lowercase
    return string.substr(0, 1).toLowerCase() + string.substr(1);
  };

  var pascalize = function(string) {
    var camelized = camelize(string);
    // Ensure 1st char is always uppercase
    return camelized.substr(0, 1).toUpperCase() + camelized.substr(1);
  };

  var decamelize = function(string, options) {
    return separateWords(string, options).toLowerCase();
  };

  // Utilities
  // Taken from Underscore.js

  var toString = Object.prototype.toString;

  var _isFunction = function(obj) {
    return typeof(obj) === 'function';
  };
  var _isObject = function(obj) {
    return obj === Object(obj);
  };
  var _isArray = function(obj) {
    return toString.call(obj) == '[object Array]';
  };
  var _isDate = function(obj) {
    return toString.call(obj) == '[object Date]';
  };
  var _isRegExp = function(obj) {
    return toString.call(obj) == '[object RegExp]';
  };
  var _isBoolean = function(obj) {
    return toString.call(obj) == '[object Boolean]';
  };

  // Performant way to determine if obj coerces to a number
  var _isNumerical = function(obj) {
    obj = obj - 0;
    return obj === obj;
  };

  // Sets up function which handles processing keys
  // allowing the convert function to be modified by a callback
  var _processor = function(convert, options) {
    var callback = options && 'process' in options ? options.process : options;

    if(typeof(callback) !== 'function') {
      return convert;
    }

    return function(string, options) {
      return callback(string, convert, options);
    }
  };

  var humps = {
    camelize: camelize,
    decamelize: decamelize,
    pascalize: pascalize,
    depascalize: decamelize,
    camelizeKeys: function(object, options) {
      return _processKeys(_processor(camelize, options), object);
    },
    decamelizeKeys: function(object, options) {
      return _processKeys(_processor(decamelize, options), object, options);
    },
    pascalizeKeys: function(object, options) {
      return _processKeys(_processor(pascalize, options), object);
    },
    depascalizeKeys: function () {
      return this.decamelizeKeys.apply(this, arguments);
    }
  };

  if (true) {
    !(__WEBPACK_AMD_DEFINE_FACTORY__ = (humps),
		__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
		(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
		__WEBPACK_AMD_DEFINE_FACTORY__),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else {}

})(this);


/***/ }),

/***/ 30551:
/***/ (function(__unused_webpack_module, exports) {

/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */
exports.read = function (buffer, offset, isLE, mLen, nBytes) {
  var e, m
  var eLen = (nBytes * 8) - mLen - 1
  var eMax = (1 << eLen) - 1
  var eBias = eMax >> 1
  var nBits = -7
  var i = isLE ? (nBytes - 1) : 0
  var d = isLE ? -1 : 1
  var s = buffer[offset + i]

  i += d

  e = s & ((1 << (-nBits)) - 1)
  s >>= (-nBits)
  nBits += eLen
  for (; nBits > 0; e = (e * 256) + buffer[offset + i], i += d, nBits -= 8) {}

  m = e & ((1 << (-nBits)) - 1)
  e >>= (-nBits)
  nBits += mLen
  for (; nBits > 0; m = (m * 256) + buffer[offset + i], i += d, nBits -= 8) {}

  if (e === 0) {
    e = 1 - eBias
  } else if (e === eMax) {
    return m ? NaN : ((s ? -1 : 1) * Infinity)
  } else {
    m = m + Math.pow(2, mLen)
    e = e - eBias
  }
  return (s ? -1 : 1) * m * Math.pow(2, e - mLen)
}

exports.write = function (buffer, value, offset, isLE, mLen, nBytes) {
  var e, m, c
  var eLen = (nBytes * 8) - mLen - 1
  var eMax = (1 << eLen) - 1
  var eBias = eMax >> 1
  var rt = (mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0)
  var i = isLE ? 0 : (nBytes - 1)
  var d = isLE ? 1 : -1
  var s = value < 0 || (value === 0 && 1 / value < 0) ? 1 : 0

  value = Math.abs(value)

  if (isNaN(value) || value === Infinity) {
    m = isNaN(value) ? 1 : 0
    e = eMax
  } else {
    e = Math.floor(Math.log(value) / Math.LN2)
    if (value * (c = Math.pow(2, -e)) < 1) {
      e--
      c *= 2
    }
    if (e + eBias >= 1) {
      value += rt / c
    } else {
      value += rt * Math.pow(2, 1 - eBias)
    }
    if (value * c >= 2) {
      e++
      c /= 2
    }

    if (e + eBias >= eMax) {
      m = 0
      e = eMax
    } else if (e + eBias >= 1) {
      m = ((value * c) - 1) * Math.pow(2, mLen)
      e = e + eBias
    } else {
      m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen)
      e = 0
    }
  }

  for (; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8) {}

  e = (e << mLen) | m
  eLen += mLen
  for (; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8) {}

  buffer[offset + i - d] |= s * 128
}


/***/ }),

/***/ 9846:
/***/ (function(module) {

if (typeof Object.create === 'function') {
  // implementation from standard node.js 'util' module
  module.exports = function inherits(ctor, superCtor) {
    ctor.super_ = superCtor
    ctor.prototype = Object.create(superCtor.prototype, {
      constructor: {
        value: ctor,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
  };
} else {
  // old school shim for old browsers
  module.exports = function inherits(ctor, superCtor) {
    ctor.super_ = superCtor
    var TempCtor = function () {}
    TempCtor.prototype = superCtor.prototype
    ctor.prototype = new TempCtor()
    ctor.prototype.constructor = ctor
  }
}


/***/ }),

/***/ 2937:
/***/ (function(module) {

if (typeof Object.create === 'function') {
  // implementation from standard node.js 'util' module
  module.exports = function inherits(ctor, superCtor) {
    if (superCtor) {
      ctor.super_ = superCtor
      ctor.prototype = Object.create(superCtor.prototype, {
        constructor: {
          value: ctor,
          enumerable: false,
          writable: true,
          configurable: true
        }
      })
    }
  };
} else {
  // old school shim for old browsers
  module.exports = function inherits(ctor, superCtor) {
    if (superCtor) {
      ctor.super_ = superCtor
      var TempCtor = function () {}
      TempCtor.prototype = superCtor.prototype
      ctor.prototype = new TempCtor()
      ctor.prototype.constructor = ctor
    }
  }
}


/***/ }),

/***/ 42571:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var hasToStringTag = __webpack_require__(47388)();
var callBound = __webpack_require__(74161);

var $toString = callBound('Object.prototype.toString');

var isStandardArguments = function isArguments(value) {
	if (hasToStringTag && value && typeof value === 'object' && Symbol.toStringTag in value) {
		return false;
	}
	return $toString(value) === '[object Arguments]';
};

var isLegacyArguments = function isArguments(value) {
	if (isStandardArguments(value)) {
		return true;
	}
	return value !== null &&
		typeof value === 'object' &&
		typeof value.length === 'number' &&
		value.length >= 0 &&
		$toString(value) !== '[object Array]' &&
		$toString(value.callee) === '[object Function]';
};

var supportsStandardArguments = (function () {
	return isStandardArguments(arguments);
}());

isStandardArguments.isLegacyArguments = isLegacyArguments; // for tests

module.exports = supportsStandardArguments ? isStandardArguments : isLegacyArguments;


/***/ }),

/***/ 33655:
/***/ (function(module) {

"use strict";


var fnToStr = Function.prototype.toString;
var reflectApply = typeof Reflect === 'object' && Reflect !== null && Reflect.apply;
var badArrayLike;
var isCallableMarker;
if (typeof reflectApply === 'function' && typeof Object.defineProperty === 'function') {
	try {
		badArrayLike = Object.defineProperty({}, 'length', {
			get: function () {
				throw isCallableMarker;
			}
		});
		isCallableMarker = {};
		// eslint-disable-next-line no-throw-literal
		reflectApply(function () { throw 42; }, null, badArrayLike);
	} catch (_) {
		if (_ !== isCallableMarker) {
			reflectApply = null;
		}
	}
} else {
	reflectApply = null;
}

var constructorRegex = /^\s*class\b/;
var isES6ClassFn = function isES6ClassFunction(value) {
	try {
		var fnStr = fnToStr.call(value);
		return constructorRegex.test(fnStr);
	} catch (e) {
		return false; // not a function
	}
};

var tryFunctionObject = function tryFunctionToStr(value) {
	try {
		if (isES6ClassFn(value)) { return false; }
		fnToStr.call(value);
		return true;
	} catch (e) {
		return false;
	}
};
var toStr = Object.prototype.toString;
var objectClass = '[object Object]';
var fnClass = '[object Function]';
var genClass = '[object GeneratorFunction]';
var ddaClass = '[object HTMLAllCollection]'; // IE 11
var ddaClass2 = '[object HTML document.all class]';
var ddaClass3 = '[object HTMLCollection]'; // IE 9-10
var hasToStringTag = typeof Symbol === 'function' && !!Symbol.toStringTag; // better: use `has-tostringtag`

var isIE68 = !(0 in [,]); // eslint-disable-line no-sparse-arrays, comma-spacing

var isDDA = function isDocumentDotAll() { return false; };
if (typeof document === 'object') {
	// Firefox 3 canonicalizes DDA to undefined when it's not accessed directly
	var all = document.all;
	if (toStr.call(all) === toStr.call(document.all)) {
		isDDA = function isDocumentDotAll(value) {
			/* globals document: false */
			// in IE 6-8, typeof document.all is "object" and it's truthy
			if ((isIE68 || !value) && (typeof value === 'undefined' || typeof value === 'object')) {
				try {
					var str = toStr.call(value);
					return (
						str === ddaClass
						|| str === ddaClass2
						|| str === ddaClass3 // opera 12.16
						|| str === objectClass // IE 6-8
					) && value('') == null; // eslint-disable-line eqeqeq
				} catch (e) { /**/ }
			}
			return false;
		};
	}
}

module.exports = reflectApply
	? function isCallable(value) {
		if (isDDA(value)) { return true; }
		if (!value) { return false; }
		if (typeof value !== 'function' && typeof value !== 'object') { return false; }
		try {
			reflectApply(value, null, badArrayLike);
		} catch (e) {
			if (e !== isCallableMarker) { return false; }
		}
		return !isES6ClassFn(value) && tryFunctionObject(value);
	}
	: function isCallable(value) {
		if (isDDA(value)) { return true; }
		if (!value) { return false; }
		if (typeof value !== 'function' && typeof value !== 'object') { return false; }
		if (hasToStringTag) { return tryFunctionObject(value); }
		if (isES6ClassFn(value)) { return false; }
		var strClass = toStr.call(value);
		if (strClass !== fnClass && strClass !== genClass && !(/^\[object HTML/).test(strClass)) { return false; }
		return tryFunctionObject(value);
	};


/***/ }),

/***/ 89141:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var toStr = Object.prototype.toString;
var fnToStr = Function.prototype.toString;
var isFnRegex = /^\s*(?:function)?\*/;
var hasToStringTag = __webpack_require__(47388)();
var getProto = Object.getPrototypeOf;
var getGeneratorFunc = function () { // eslint-disable-line consistent-return
	if (!hasToStringTag) {
		return false;
	}
	try {
		return Function('return function*() {}')();
	} catch (e) {
	}
};
var GeneratorFunction;

module.exports = function isGeneratorFunction(fn) {
	if (typeof fn !== 'function') {
		return false;
	}
	if (isFnRegex.test(fnToStr.call(fn))) {
		return true;
	}
	if (!hasToStringTag) {
		var str = toStr.call(fn);
		return str === '[object GeneratorFunction]';
	}
	if (!getProto) {
		return false;
	}
	if (typeof GeneratorFunction === 'undefined') {
		var generatorFunc = getGeneratorFunc();
		GeneratorFunction = generatorFunc ? getProto(generatorFunc) : false;
	}
	return getProto(fn) === GeneratorFunction;
};


/***/ }),

/***/ 53528:
/***/ (function(module) {

"use strict";


const isStream = stream =>
	stream !== null &&
	typeof stream === 'object' &&
	typeof stream.pipe === 'function';

isStream.writable = stream =>
	isStream(stream) &&
	stream.writable !== false &&
	typeof stream._write === 'function' &&
	typeof stream._writableState === 'object';

isStream.readable = stream =>
	isStream(stream) &&
	stream.readable !== false &&
	typeof stream._read === 'function' &&
	typeof stream._readableState === 'object';

isStream.duplex = stream =>
	isStream.writable(stream) &&
	isStream.readable(stream);

isStream.transform = stream =>
	isStream.duplex(stream) &&
	typeof stream._transform === 'function';

module.exports = isStream;


/***/ }),

/***/ 37261:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var whichTypedArray = __webpack_require__(44418);

/** @type {import('.')} */
module.exports = function isTypedArray(value) {
	return !!whichTypedArray(value);
};


/***/ }),

/***/ 87269:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getNative = __webpack_require__(47758),
    root = __webpack_require__(29165);

/* Built-in method references that are verified to be native. */
var DataView = getNative(root, 'DataView');

module.exports = DataView;


/***/ }),

/***/ 51526:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var hashClear = __webpack_require__(71519),
    hashDelete = __webpack_require__(82999),
    hashGet = __webpack_require__(76111),
    hashHas = __webpack_require__(50506),
    hashSet = __webpack_require__(80845);

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

module.exports = Hash;


/***/ }),

/***/ 175:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var listCacheClear = __webpack_require__(2173),
    listCacheDelete = __webpack_require__(33752),
    listCacheGet = __webpack_require__(10548),
    listCacheHas = __webpack_require__(63410),
    listCacheSet = __webpack_require__(3564);

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

module.exports = ListCache;


/***/ }),

/***/ 35922:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getNative = __webpack_require__(47758),
    root = __webpack_require__(29165);

/* Built-in method references that are verified to be native. */
var Map = getNative(root, 'Map');

module.exports = Map;


/***/ }),

/***/ 9440:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var mapCacheClear = __webpack_require__(7140),
    mapCacheDelete = __webpack_require__(56504),
    mapCacheGet = __webpack_require__(88833),
    mapCacheHas = __webpack_require__(80953),
    mapCacheSet = __webpack_require__(70724);

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

module.exports = MapCache;


/***/ }),

/***/ 6795:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getNative = __webpack_require__(47758),
    root = __webpack_require__(29165);

/* Built-in method references that are verified to be native. */
var Promise = getNative(root, 'Promise');

module.exports = Promise;


/***/ }),

/***/ 81956:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getNative = __webpack_require__(47758),
    root = __webpack_require__(29165);

/* Built-in method references that are verified to be native. */
var Set = getNative(root, 'Set');

module.exports = Set;


/***/ }),

/***/ 78188:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var MapCache = __webpack_require__(9440),
    setCacheAdd = __webpack_require__(96659),
    setCacheHas = __webpack_require__(97230);

/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */
function SetCache(values) {
  var index = -1,
      length = values == null ? 0 : values.length;

  this.__data__ = new MapCache;
  while (++index < length) {
    this.add(values[index]);
  }
}

// Add methods to `SetCache`.
SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
SetCache.prototype.has = setCacheHas;

module.exports = SetCache;


/***/ }),

/***/ 5929:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var ListCache = __webpack_require__(175),
    stackClear = __webpack_require__(40551),
    stackDelete = __webpack_require__(4090),
    stackGet = __webpack_require__(47694),
    stackHas = __webpack_require__(86220),
    stackSet = __webpack_require__(68958);

/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack(entries) {
  var data = this.__data__ = new ListCache(entries);
  this.size = data.size;
}

// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype['delete'] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;

module.exports = Stack;


/***/ }),

/***/ 74396:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var root = __webpack_require__(29165);

/** Built-in value references. */
var Symbol = root.Symbol;

module.exports = Symbol;


/***/ }),

/***/ 92210:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var root = __webpack_require__(29165);

/** Built-in value references. */
var Uint8Array = root.Uint8Array;

module.exports = Uint8Array;


/***/ }),

/***/ 69477:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getNative = __webpack_require__(47758),
    root = __webpack_require__(29165);

/* Built-in method references that are verified to be native. */
var WeakMap = getNative(root, 'WeakMap');

module.exports = WeakMap;


/***/ }),

/***/ 93501:
/***/ (function(module) {

/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */
function apply(func, thisArg, args) {
  switch (args.length) {
    case 0: return func.call(thisArg);
    case 1: return func.call(thisArg, args[0]);
    case 2: return func.call(thisArg, args[0], args[1]);
    case 3: return func.call(thisArg, args[0], args[1], args[2]);
  }
  return func.apply(thisArg, args);
}

module.exports = apply;


/***/ }),

/***/ 21662:
/***/ (function(module) {

/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */
function arrayEach(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (iteratee(array[index], index, array) === false) {
      break;
    }
  }
  return array;
}

module.exports = arrayEach;


/***/ }),

/***/ 48969:
/***/ (function(module) {

/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */
function arrayFilter(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length,
      resIndex = 0,
      result = [];

  while (++index < length) {
    var value = array[index];
    if (predicate(value, index, array)) {
      result[resIndex++] = value;
    }
  }
  return result;
}

module.exports = arrayFilter;


/***/ }),

/***/ 79809:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseTimes = __webpack_require__(39739),
    isArguments = __webpack_require__(30353),
    isArray = __webpack_require__(24669),
    isBuffer = __webpack_require__(61563),
    isIndex = __webpack_require__(91010),
    isTypedArray = __webpack_require__(73806);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  var isArr = isArray(value),
      isArg = !isArr && isArguments(value),
      isBuff = !isArr && !isArg && isBuffer(value),
      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
      skipIndexes = isArr || isArg || isBuff || isType,
      result = skipIndexes ? baseTimes(value.length, String) : [],
      length = result.length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) &&
        !(skipIndexes && (
           // Safari 9 has enumerable `arguments.length` in strict mode.
           key == 'length' ||
           // Node.js 0.10 has enumerable non-index properties on buffers.
           (isBuff && (key == 'offset' || key == 'parent')) ||
           // PhantomJS 2 has enumerable non-index properties on typed arrays.
           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
           // Skip index properties.
           isIndex(key, length)
        ))) {
      result.push(key);
    }
  }
  return result;
}

module.exports = arrayLikeKeys;


/***/ }),

/***/ 75697:
/***/ (function(module) {

/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function arrayMap(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length,
      result = Array(length);

  while (++index < length) {
    result[index] = iteratee(array[index], index, array);
  }
  return result;
}

module.exports = arrayMap;


/***/ }),

/***/ 28486:
/***/ (function(module) {

/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */
function arrayPush(array, values) {
  var index = -1,
      length = values.length,
      offset = array.length;

  while (++index < length) {
    array[offset + index] = values[index];
  }
  return array;
}

module.exports = arrayPush;


/***/ }),

/***/ 84330:
/***/ (function(module) {

/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */
function arraySome(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (predicate(array[index], index, array)) {
      return true;
    }
  }
  return false;
}

module.exports = arraySome;


/***/ }),

/***/ 15989:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseProperty = __webpack_require__(17498);

/**
 * Gets the size of an ASCII `string`.
 *
 * @private
 * @param {string} string The string inspect.
 * @returns {number} Returns the string size.
 */
var asciiSize = baseProperty('length');

module.exports = asciiSize;


/***/ }),

/***/ 93719:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseAssignValue = __webpack_require__(30404),
    eq = __webpack_require__(42448);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignValue(object, key, value) {
  var objValue = object[key];
  if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
      (value === undefined && !(key in object))) {
    baseAssignValue(object, key, value);
  }
}

module.exports = assignValue;


/***/ }),

/***/ 62718:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var eq = __webpack_require__(42448);

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

module.exports = assocIndexOf;


/***/ }),

/***/ 43472:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var copyObject = __webpack_require__(92434),
    keys = __webpack_require__(50579);

/**
 * The base implementation of `_.assign` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */
function baseAssign(object, source) {
  return object && copyObject(source, keys(source), object);
}

module.exports = baseAssign;


/***/ }),

/***/ 7254:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var copyObject = __webpack_require__(92434),
    keysIn = __webpack_require__(37390);

/**
 * The base implementation of `_.assignIn` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */
function baseAssignIn(object, source) {
  return object && copyObject(source, keysIn(source), object);
}

module.exports = baseAssignIn;


/***/ }),

/***/ 30404:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var defineProperty = __webpack_require__(34082);

/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function baseAssignValue(object, key, value) {
  if (key == '__proto__' && defineProperty) {
    defineProperty(object, key, {
      'configurable': true,
      'enumerable': true,
      'value': value,
      'writable': true
    });
  } else {
    object[key] = value;
  }
}

module.exports = baseAssignValue;


/***/ }),

/***/ 67410:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var Stack = __webpack_require__(5929),
    arrayEach = __webpack_require__(21662),
    assignValue = __webpack_require__(93719),
    baseAssign = __webpack_require__(43472),
    baseAssignIn = __webpack_require__(7254),
    cloneBuffer = __webpack_require__(39767),
    copyArray = __webpack_require__(47165),
    copySymbols = __webpack_require__(8782),
    copySymbolsIn = __webpack_require__(2667),
    getAllKeys = __webpack_require__(69698),
    getAllKeysIn = __webpack_require__(21699),
    getTag = __webpack_require__(81887),
    initCloneArray = __webpack_require__(12195),
    initCloneByTag = __webpack_require__(46740),
    initCloneObject = __webpack_require__(36404),
    isArray = __webpack_require__(24669),
    isBuffer = __webpack_require__(61563),
    isMap = __webpack_require__(32924),
    isObject = __webpack_require__(36838),
    isSet = __webpack_require__(45380),
    keys = __webpack_require__(50579),
    keysIn = __webpack_require__(37390);

/** Used to compose bitmasks for cloning. */
var CLONE_DEEP_FLAG = 1,
    CLONE_FLAT_FLAG = 2,
    CLONE_SYMBOLS_FLAG = 4;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values supported by `_.clone`. */
var cloneableTags = {};
cloneableTags[argsTag] = cloneableTags[arrayTag] =
cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
cloneableTags[boolTag] = cloneableTags[dateTag] =
cloneableTags[float32Tag] = cloneableTags[float64Tag] =
cloneableTags[int8Tag] = cloneableTags[int16Tag] =
cloneableTags[int32Tag] = cloneableTags[mapTag] =
cloneableTags[numberTag] = cloneableTags[objectTag] =
cloneableTags[regexpTag] = cloneableTags[setTag] =
cloneableTags[stringTag] = cloneableTags[symbolTag] =
cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
cloneableTags[errorTag] = cloneableTags[funcTag] =
cloneableTags[weakMapTag] = false;

/**
 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
 * traversed objects.
 *
 * @private
 * @param {*} value The value to clone.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Deep clone
 *  2 - Flatten inherited properties
 *  4 - Clone symbols
 * @param {Function} [customizer] The function to customize cloning.
 * @param {string} [key] The key of `value`.
 * @param {Object} [object] The parent object of `value`.
 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
 * @returns {*} Returns the cloned value.
 */
function baseClone(value, bitmask, customizer, key, object, stack) {
  var result,
      isDeep = bitmask & CLONE_DEEP_FLAG,
      isFlat = bitmask & CLONE_FLAT_FLAG,
      isFull = bitmask & CLONE_SYMBOLS_FLAG;

  if (customizer) {
    result = object ? customizer(value, key, object, stack) : customizer(value);
  }
  if (result !== undefined) {
    return result;
  }
  if (!isObject(value)) {
    return value;
  }
  var isArr = isArray(value);
  if (isArr) {
    result = initCloneArray(value);
    if (!isDeep) {
      return copyArray(value, result);
    }
  } else {
    var tag = getTag(value),
        isFunc = tag == funcTag || tag == genTag;

    if (isBuffer(value)) {
      return cloneBuffer(value, isDeep);
    }
    if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
      result = (isFlat || isFunc) ? {} : initCloneObject(value);
      if (!isDeep) {
        return isFlat
          ? copySymbolsIn(value, baseAssignIn(result, value))
          : copySymbols(value, baseAssign(result, value));
      }
    } else {
      if (!cloneableTags[tag]) {
        return object ? value : {};
      }
      result = initCloneByTag(value, tag, isDeep);
    }
  }
  // Check for circular references and return its corresponding clone.
  stack || (stack = new Stack);
  var stacked = stack.get(value);
  if (stacked) {
    return stacked;
  }
  stack.set(value, result);

  if (isSet(value)) {
    value.forEach(function(subValue) {
      result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
    });
  } else if (isMap(value)) {
    value.forEach(function(subValue, key) {
      result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
    });
  }

  var keysFunc = isFull
    ? (isFlat ? getAllKeysIn : getAllKeys)
    : (isFlat ? keysIn : keys);

  var props = isArr ? undefined : keysFunc(value);
  arrayEach(props || value, function(subValue, key) {
    if (props) {
      key = subValue;
      subValue = value[key];
    }
    // Recursively populate clone (susceptible to call stack limits).
    assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
  });
  return result;
}

module.exports = baseClone;


/***/ }),

/***/ 91348:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isObject = __webpack_require__(36838);

/** Built-in value references. */
var objectCreate = Object.create;

/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */
var baseCreate = (function() {
  function object() {}
  return function(proto) {
    if (!isObject(proto)) {
      return {};
    }
    if (objectCreate) {
      return objectCreate(proto);
    }
    object.prototype = proto;
    var result = new object;
    object.prototype = undefined;
    return result;
  };
}());

module.exports = baseCreate;


/***/ }),

/***/ 92504:
/***/ (function(module) {

/**
 * The base implementation of `_.findIndex` and `_.findLastIndex` without
 * support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} predicate The function invoked per iteration.
 * @param {number} fromIndex The index to search from.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function baseFindIndex(array, predicate, fromIndex, fromRight) {
  var length = array.length,
      index = fromIndex + (fromRight ? 1 : -1);

  while ((fromRight ? index-- : ++index < length)) {
    if (predicate(array[index], index, array)) {
      return index;
    }
  }
  return -1;
}

module.exports = baseFindIndex;


/***/ }),

/***/ 99548:
/***/ (function(module) {

/**
 * The base implementation of methods like `_.findKey` and `_.findLastKey`,
 * without support for iteratee shorthands, which iterates over `collection`
 * using `eachFunc`.
 *
 * @private
 * @param {Array|Object} collection The collection to inspect.
 * @param {Function} predicate The function invoked per iteration.
 * @param {Function} eachFunc The function to iterate over `collection`.
 * @returns {*} Returns the found element or its key, else `undefined`.
 */
function baseFindKey(collection, predicate, eachFunc) {
  var result;
  eachFunc(collection, function(value, key, collection) {
    if (predicate(value, key, collection)) {
      result = key;
      return false;
    }
  });
  return result;
}

module.exports = baseFindKey;


/***/ }),

/***/ 98768:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var arrayPush = __webpack_require__(28486),
    isFlattenable = __webpack_require__(89465);

/**
 * The base implementation of `_.flatten` with support for restricting flattening.
 *
 * @private
 * @param {Array} array The array to flatten.
 * @param {number} depth The maximum recursion depth.
 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
 * @param {Array} [result=[]] The initial result value.
 * @returns {Array} Returns the new flattened array.
 */
function baseFlatten(array, depth, predicate, isStrict, result) {
  var index = -1,
      length = array.length;

  predicate || (predicate = isFlattenable);
  result || (result = []);

  while (++index < length) {
    var value = array[index];
    if (depth > 0 && predicate(value)) {
      if (depth > 1) {
        // Recursively flatten arrays (susceptible to call stack limits).
        baseFlatten(value, depth - 1, predicate, isStrict, result);
      } else {
        arrayPush(result, value);
      }
    } else if (!isStrict) {
      result[result.length] = value;
    }
  }
  return result;
}

module.exports = baseFlatten;


/***/ }),

/***/ 55471:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseForRight = __webpack_require__(63751),
    keys = __webpack_require__(50579);

/**
 * The base implementation of `_.forOwnRight` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */
function baseForOwnRight(object, iteratee) {
  return object && baseForRight(object, iteratee, keys);
}

module.exports = baseForOwnRight;


/***/ }),

/***/ 63751:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var createBaseFor = __webpack_require__(29);

/**
 * This function is like `baseFor` except that it iterates over properties
 * in the opposite order.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */
var baseForRight = createBaseFor(true);

module.exports = baseForRight;


/***/ }),

/***/ 97499:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var castPath = __webpack_require__(60399),
    toKey = __webpack_require__(77817);

/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */
function baseGet(object, path) {
  path = castPath(path, object);

  var index = 0,
      length = path.length;

  while (object != null && index < length) {
    object = object[toKey(path[index++])];
  }
  return (index && index == length) ? object : undefined;
}

module.exports = baseGet;


/***/ }),

/***/ 38084:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var arrayPush = __webpack_require__(28486),
    isArray = __webpack_require__(24669);

/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */
function baseGetAllKeys(object, keysFunc, symbolsFunc) {
  var result = keysFunc(object);
  return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
}

module.exports = baseGetAllKeys;


/***/ }),

/***/ 80732:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var Symbol = __webpack_require__(74396),
    getRawTag = __webpack_require__(31239),
    objectToString = __webpack_require__(57058);

/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? getRawTag(value)
    : objectToString(value);
}

module.exports = baseGetTag;


/***/ }),

/***/ 71664:
/***/ (function(module) {

/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */
function baseHasIn(object, key) {
  return object != null && key in Object(object);
}

module.exports = baseHasIn;


/***/ }),

/***/ 84742:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseGetTag = __webpack_require__(80732),
    isObjectLike = __webpack_require__(55073);

/** `Object#toString` result references. */
var argsTag = '[object Arguments]';

/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */
function baseIsArguments(value) {
  return isObjectLike(value) && baseGetTag(value) == argsTag;
}

module.exports = baseIsArguments;


/***/ }),

/***/ 6620:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseIsEqualDeep = __webpack_require__(83977),
    isObjectLike = __webpack_require__(55073);

/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */
function baseIsEqual(value, other, bitmask, customizer, stack) {
  if (value === other) {
    return true;
  }
  if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
    return value !== value && other !== other;
  }
  return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
}

module.exports = baseIsEqual;


/***/ }),

/***/ 83977:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var Stack = __webpack_require__(5929),
    equalArrays = __webpack_require__(22684),
    equalByTag = __webpack_require__(7456),
    equalObjects = __webpack_require__(18120),
    getTag = __webpack_require__(81887),
    isArray = __webpack_require__(24669),
    isBuffer = __webpack_require__(61563),
    isTypedArray = __webpack_require__(73806);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    objectTag = '[object Object]';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
  var objIsArr = isArray(object),
      othIsArr = isArray(other),
      objTag = objIsArr ? arrayTag : getTag(object),
      othTag = othIsArr ? arrayTag : getTag(other);

  objTag = objTag == argsTag ? objectTag : objTag;
  othTag = othTag == argsTag ? objectTag : othTag;

  var objIsObj = objTag == objectTag,
      othIsObj = othTag == objectTag,
      isSameTag = objTag == othTag;

  if (isSameTag && isBuffer(object)) {
    if (!isBuffer(other)) {
      return false;
    }
    objIsArr = true;
    objIsObj = false;
  }
  if (isSameTag && !objIsObj) {
    stack || (stack = new Stack);
    return (objIsArr || isTypedArray(object))
      ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
      : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
  }
  if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

    if (objIsWrapped || othIsWrapped) {
      var objUnwrapped = objIsWrapped ? object.value() : object,
          othUnwrapped = othIsWrapped ? other.value() : other;

      stack || (stack = new Stack);
      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
    }
  }
  if (!isSameTag) {
    return false;
  }
  stack || (stack = new Stack);
  return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
}

module.exports = baseIsEqualDeep;


/***/ }),

/***/ 64033:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getTag = __webpack_require__(81887),
    isObjectLike = __webpack_require__(55073);

/** `Object#toString` result references. */
var mapTag = '[object Map]';

/**
 * The base implementation of `_.isMap` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 */
function baseIsMap(value) {
  return isObjectLike(value) && getTag(value) == mapTag;
}

module.exports = baseIsMap;


/***/ }),

/***/ 27122:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var Stack = __webpack_require__(5929),
    baseIsEqual = __webpack_require__(6620);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */
function baseIsMatch(object, source, matchData, customizer) {
  var index = matchData.length,
      length = index,
      noCustomizer = !customizer;

  if (object == null) {
    return !length;
  }
  object = Object(object);
  while (index--) {
    var data = matchData[index];
    if ((noCustomizer && data[2])
          ? data[1] !== object[data[0]]
          : !(data[0] in object)
        ) {
      return false;
    }
  }
  while (++index < length) {
    data = matchData[index];
    var key = data[0],
        objValue = object[key],
        srcValue = data[1];

    if (noCustomizer && data[2]) {
      if (objValue === undefined && !(key in object)) {
        return false;
      }
    } else {
      var stack = new Stack;
      if (customizer) {
        var result = customizer(objValue, srcValue, key, object, source, stack);
      }
      if (!(result === undefined
            ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
            : result
          )) {
        return false;
      }
    }
  }
  return true;
}

module.exports = baseIsMatch;


/***/ }),

/***/ 58939:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isFunction = __webpack_require__(92042),
    isMasked = __webpack_require__(90654),
    isObject = __webpack_require__(36838),
    toSource = __webpack_require__(51059);

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

module.exports = baseIsNative;


/***/ }),

/***/ 28264:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getTag = __webpack_require__(81887),
    isObjectLike = __webpack_require__(55073);

/** `Object#toString` result references. */
var setTag = '[object Set]';

/**
 * The base implementation of `_.isSet` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 */
function baseIsSet(value) {
  return isObjectLike(value) && getTag(value) == setTag;
}

module.exports = baseIsSet;


/***/ }),

/***/ 22882:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseGetTag = __webpack_require__(80732),
    isLength = __webpack_require__(17216),
    isObjectLike = __webpack_require__(55073);

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
typedArrayTags[errorTag] = typedArrayTags[funcTag] =
typedArrayTags[mapTag] = typedArrayTags[numberTag] =
typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
typedArrayTags[setTag] = typedArrayTags[stringTag] =
typedArrayTags[weakMapTag] = false;

/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */
function baseIsTypedArray(value) {
  return isObjectLike(value) &&
    isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
}

module.exports = baseIsTypedArray;


/***/ }),

/***/ 5673:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseMatches = __webpack_require__(3772),
    baseMatchesProperty = __webpack_require__(30493),
    identity = __webpack_require__(48148),
    isArray = __webpack_require__(24669),
    property = __webpack_require__(51798);

/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */
function baseIteratee(value) {
  // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
  // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
  if (typeof value == 'function') {
    return value;
  }
  if (value == null) {
    return identity;
  }
  if (typeof value == 'object') {
    return isArray(value)
      ? baseMatchesProperty(value[0], value[1])
      : baseMatches(value);
  }
  return property(value);
}

module.exports = baseIteratee;


/***/ }),

/***/ 87473:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isPrototype = __webpack_require__(92963),
    nativeKeys = __webpack_require__(14457);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!isPrototype(object)) {
    return nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

module.exports = baseKeys;


/***/ }),

/***/ 52506:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isObject = __webpack_require__(36838),
    isPrototype = __webpack_require__(92963),
    nativeKeysIn = __webpack_require__(10814);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeysIn(object) {
  if (!isObject(object)) {
    return nativeKeysIn(object);
  }
  var isProto = isPrototype(object),
      result = [];

  for (var key in object) {
    if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
      result.push(key);
    }
  }
  return result;
}

module.exports = baseKeysIn;


/***/ }),

/***/ 3772:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseIsMatch = __webpack_require__(27122),
    getMatchData = __webpack_require__(67487),
    matchesStrictComparable = __webpack_require__(78857);

/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatches(source) {
  var matchData = getMatchData(source);
  if (matchData.length == 1 && matchData[0][2]) {
    return matchesStrictComparable(matchData[0][0], matchData[0][1]);
  }
  return function(object) {
    return object === source || baseIsMatch(object, source, matchData);
  };
}

module.exports = baseMatches;


/***/ }),

/***/ 30493:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseIsEqual = __webpack_require__(6620),
    get = __webpack_require__(65439),
    hasIn = __webpack_require__(28281),
    isKey = __webpack_require__(2610),
    isStrictComparable = __webpack_require__(92769),
    matchesStrictComparable = __webpack_require__(78857),
    toKey = __webpack_require__(77817);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatchesProperty(path, srcValue) {
  if (isKey(path) && isStrictComparable(srcValue)) {
    return matchesStrictComparable(toKey(path), srcValue);
  }
  return function(object) {
    var objValue = get(object, path);
    return (objValue === undefined && objValue === srcValue)
      ? hasIn(object, path)
      : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
  };
}

module.exports = baseMatchesProperty;


/***/ }),

/***/ 17498:
/***/ (function(module) {

/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function baseProperty(key) {
  return function(object) {
    return object == null ? undefined : object[key];
  };
}

module.exports = baseProperty;


/***/ }),

/***/ 71000:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseGet = __webpack_require__(97499);

/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function basePropertyDeep(path) {
  return function(object) {
    return baseGet(object, path);
  };
}

module.exports = basePropertyDeep;


/***/ }),

/***/ 56447:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var constant = __webpack_require__(64806),
    defineProperty = __webpack_require__(34082),
    identity = __webpack_require__(48148);

/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var baseSetToString = !defineProperty ? identity : function(func, string) {
  return defineProperty(func, 'toString', {
    'configurable': true,
    'enumerable': false,
    'value': constant(string),
    'writable': true
  });
};

module.exports = baseSetToString;


/***/ }),

/***/ 43846:
/***/ (function(module) {

/**
 * The base implementation of `_.slice` without an iteratee call guard.
 *
 * @private
 * @param {Array} array The array to slice.
 * @param {number} [start=0] The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the slice of `array`.
 */
function baseSlice(array, start, end) {
  var index = -1,
      length = array.length;

  if (start < 0) {
    start = -start > length ? 0 : (length + start);
  }
  end = end > length ? length : end;
  if (end < 0) {
    end += length;
  }
  length = start > end ? 0 : ((end - start) >>> 0);
  start >>>= 0;

  var result = Array(length);
  while (++index < length) {
    result[index] = array[index + start];
  }
  return result;
}

module.exports = baseSlice;


/***/ }),

/***/ 39739:
/***/ (function(module) {

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

module.exports = baseTimes;


/***/ }),

/***/ 73150:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var Symbol = __webpack_require__(74396),
    arrayMap = __webpack_require__(75697),
    isArray = __webpack_require__(24669),
    isSymbol = __webpack_require__(16764);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolToString = symbolProto ? symbolProto.toString : undefined;

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isArray(value)) {
    // Recursively convert values (susceptible to call stack limits).
    return arrayMap(value, baseToString) + '';
  }
  if (isSymbol(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

module.exports = baseToString;


/***/ }),

/***/ 33124:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var trimmedEndIndex = __webpack_require__(82996);

/** Used to match leading whitespace. */
var reTrimStart = /^\s+/;

/**
 * The base implementation of `_.trim`.
 *
 * @private
 * @param {string} string The string to trim.
 * @returns {string} Returns the trimmed string.
 */
function baseTrim(string) {
  return string
    ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, '')
    : string;
}

module.exports = baseTrim;


/***/ }),

/***/ 58792:
/***/ (function(module) {

/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function baseUnary(func) {
  return function(value) {
    return func(value);
  };
}

module.exports = baseUnary;


/***/ }),

/***/ 42933:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var castPath = __webpack_require__(60399),
    last = __webpack_require__(25674),
    parent = __webpack_require__(39118),
    toKey = __webpack_require__(77817);

/**
 * The base implementation of `_.unset`.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {Array|string} path The property path to unset.
 * @returns {boolean} Returns `true` if the property is deleted, else `false`.
 */
function baseUnset(object, path) {
  path = castPath(path, object);
  object = parent(object, path);
  return object == null || delete object[toKey(last(path))];
}

module.exports = baseUnset;


/***/ }),

/***/ 29880:
/***/ (function(module) {

/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function cacheHas(cache, key) {
  return cache.has(key);
}

module.exports = cacheHas;


/***/ }),

/***/ 60399:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isArray = __webpack_require__(24669),
    isKey = __webpack_require__(2610),
    stringToPath = __webpack_require__(77057),
    toString = __webpack_require__(8389);

/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */
function castPath(value, object) {
  if (isArray(value)) {
    return value;
  }
  return isKey(value, object) ? [value] : stringToPath(toString(value));
}

module.exports = castPath;


/***/ }),

/***/ 78925:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var Uint8Array = __webpack_require__(92210);

/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */
function cloneArrayBuffer(arrayBuffer) {
  var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
  new Uint8Array(result).set(new Uint8Array(arrayBuffer));
  return result;
}

module.exports = cloneArrayBuffer;


/***/ }),

/***/ 39767:
/***/ (function(module, exports, __webpack_require__) {

/* module decorator */ module = __webpack_require__.nmd(module);
var root = __webpack_require__(29165);

/** Detect free variable `exports`. */
var freeExports =  true && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && "object" == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined,
    allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;

/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */
function cloneBuffer(buffer, isDeep) {
  if (isDeep) {
    return buffer.slice();
  }
  var length = buffer.length,
      result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);

  buffer.copy(result);
  return result;
}

module.exports = cloneBuffer;


/***/ }),

/***/ 56157:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var cloneArrayBuffer = __webpack_require__(78925);

/**
 * Creates a clone of `dataView`.
 *
 * @private
 * @param {Object} dataView The data view to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned data view.
 */
function cloneDataView(dataView, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
  return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
}

module.exports = cloneDataView;


/***/ }),

/***/ 80101:
/***/ (function(module) {

/** Used to match `RegExp` flags from their coerced string values. */
var reFlags = /\w*$/;

/**
 * Creates a clone of `regexp`.
 *
 * @private
 * @param {Object} regexp The regexp to clone.
 * @returns {Object} Returns the cloned regexp.
 */
function cloneRegExp(regexp) {
  var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
  result.lastIndex = regexp.lastIndex;
  return result;
}

module.exports = cloneRegExp;


/***/ }),

/***/ 54920:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var Symbol = __webpack_require__(74396);

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

/**
 * Creates a clone of the `symbol` object.
 *
 * @private
 * @param {Object} symbol The symbol object to clone.
 * @returns {Object} Returns the cloned symbol object.
 */
function cloneSymbol(symbol) {
  return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
}

module.exports = cloneSymbol;


/***/ }),

/***/ 27136:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var cloneArrayBuffer = __webpack_require__(78925);

/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */
function cloneTypedArray(typedArray, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
  return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}

module.exports = cloneTypedArray;


/***/ }),

/***/ 47165:
/***/ (function(module) {

/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */
function copyArray(source, array) {
  var index = -1,
      length = source.length;

  array || (array = Array(length));
  while (++index < length) {
    array[index] = source[index];
  }
  return array;
}

module.exports = copyArray;


/***/ }),

/***/ 92434:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var assignValue = __webpack_require__(93719),
    baseAssignValue = __webpack_require__(30404);

/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */
function copyObject(source, props, object, customizer) {
  var isNew = !object;
  object || (object = {});

  var index = -1,
      length = props.length;

  while (++index < length) {
    var key = props[index];

    var newValue = customizer
      ? customizer(object[key], source[key], key, object, source)
      : undefined;

    if (newValue === undefined) {
      newValue = source[key];
    }
    if (isNew) {
      baseAssignValue(object, key, newValue);
    } else {
      assignValue(object, key, newValue);
    }
  }
  return object;
}

module.exports = copyObject;


/***/ }),

/***/ 8782:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var copyObject = __webpack_require__(92434),
    getSymbols = __webpack_require__(97482);

/**
 * Copies own symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */
function copySymbols(source, object) {
  return copyObject(source, getSymbols(source), object);
}

module.exports = copySymbols;


/***/ }),

/***/ 2667:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var copyObject = __webpack_require__(92434),
    getSymbolsIn = __webpack_require__(41288);

/**
 * Copies own and inherited symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */
function copySymbolsIn(source, object) {
  return copyObject(source, getSymbolsIn(source), object);
}

module.exports = copySymbolsIn;


/***/ }),

/***/ 36633:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var root = __webpack_require__(29165);

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

module.exports = coreJsData;


/***/ }),

/***/ 29:
/***/ (function(module) {

/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseFor(fromRight) {
  return function(object, iteratee, keysFunc) {
    var index = -1,
        iterable = Object(object),
        props = keysFunc(object),
        length = props.length;

    while (length--) {
      var key = props[fromRight ? length : ++index];
      if (iteratee(iterable[key], key, iterable) === false) {
        break;
      }
    }
    return object;
  };
}

module.exports = createBaseFor;


/***/ }),

/***/ 34715:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseIteratee = __webpack_require__(5673),
    isArrayLike = __webpack_require__(47428),
    keys = __webpack_require__(50579);

/**
 * Creates a `_.find` or `_.findLast` function.
 *
 * @private
 * @param {Function} findIndexFunc The function to find the collection index.
 * @returns {Function} Returns the new find function.
 */
function createFind(findIndexFunc) {
  return function(collection, predicate, fromIndex) {
    var iterable = Object(collection);
    if (!isArrayLike(collection)) {
      var iteratee = baseIteratee(predicate, 3);
      collection = keys(collection);
      predicate = function(key) { return iteratee(iterable[key], key, iterable); };
    }
    var index = findIndexFunc(collection, predicate, fromIndex);
    return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
  };
}

module.exports = createFind;


/***/ }),

/***/ 59211:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isPlainObject = __webpack_require__(69143);

/**
 * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
 * objects.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {string} key The key of the property to inspect.
 * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
 */
function customOmitClone(value) {
  return isPlainObject(value) ? undefined : value;
}

module.exports = customOmitClone;


/***/ }),

/***/ 34082:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getNative = __webpack_require__(47758);

var defineProperty = (function() {
  try {
    var func = getNative(Object, 'defineProperty');
    func({}, '', {});
    return func;
  } catch (e) {}
}());

module.exports = defineProperty;


/***/ }),

/***/ 22684:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var SetCache = __webpack_require__(78188),
    arraySome = __webpack_require__(84330),
    cacheHas = __webpack_require__(29880);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */
function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      arrLength = array.length,
      othLength = other.length;

  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
    return false;
  }
  // Check that cyclic values are equal.
  var arrStacked = stack.get(array);
  var othStacked = stack.get(other);
  if (arrStacked && othStacked) {
    return arrStacked == other && othStacked == array;
  }
  var index = -1,
      result = true,
      seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;

  stack.set(array, other);
  stack.set(other, array);

  // Ignore non-index properties.
  while (++index < arrLength) {
    var arrValue = array[index],
        othValue = other[index];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, arrValue, index, other, array, stack)
        : customizer(arrValue, othValue, index, array, other, stack);
    }
    if (compared !== undefined) {
      if (compared) {
        continue;
      }
      result = false;
      break;
    }
    // Recursively compare arrays (susceptible to call stack limits).
    if (seen) {
      if (!arraySome(other, function(othValue, othIndex) {
            if (!cacheHas(seen, othIndex) &&
                (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
              return seen.push(othIndex);
            }
          })) {
        result = false;
        break;
      }
    } else if (!(
          arrValue === othValue ||
            equalFunc(arrValue, othValue, bitmask, customizer, stack)
        )) {
      result = false;
      break;
    }
  }
  stack['delete'](array);
  stack['delete'](other);
  return result;
}

module.exports = equalArrays;


/***/ }),

/***/ 7456:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var Symbol = __webpack_require__(74396),
    Uint8Array = __webpack_require__(92210),
    eq = __webpack_require__(42448),
    equalArrays = __webpack_require__(22684),
    mapToArray = __webpack_require__(7523),
    setToArray = __webpack_require__(79967);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/** `Object#toString` result references. */
var boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]';

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
  switch (tag) {
    case dataViewTag:
      if ((object.byteLength != other.byteLength) ||
          (object.byteOffset != other.byteOffset)) {
        return false;
      }
      object = object.buffer;
      other = other.buffer;

    case arrayBufferTag:
      if ((object.byteLength != other.byteLength) ||
          !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
        return false;
      }
      return true;

    case boolTag:
    case dateTag:
    case numberTag:
      // Coerce booleans to `1` or `0` and dates to milliseconds.
      // Invalid dates are coerced to `NaN`.
      return eq(+object, +other);

    case errorTag:
      return object.name == other.name && object.message == other.message;

    case regexpTag:
    case stringTag:
      // Coerce regexes to strings and treat strings, primitives and objects,
      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
      // for more details.
      return object == (other + '');

    case mapTag:
      var convert = mapToArray;

    case setTag:
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
      convert || (convert = setToArray);

      if (object.size != other.size && !isPartial) {
        return false;
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(object);
      if (stacked) {
        return stacked == other;
      }
      bitmask |= COMPARE_UNORDERED_FLAG;

      // Recursively compare objects (susceptible to call stack limits).
      stack.set(object, other);
      var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
      stack['delete'](object);
      return result;

    case symbolTag:
      if (symbolValueOf) {
        return symbolValueOf.call(object) == symbolValueOf.call(other);
      }
  }
  return false;
}

module.exports = equalByTag;


/***/ }),

/***/ 18120:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getAllKeys = __webpack_require__(69698);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      objProps = getAllKeys(object),
      objLength = objProps.length,
      othProps = getAllKeys(other),
      othLength = othProps.length;

  if (objLength != othLength && !isPartial) {
    return false;
  }
  var index = objLength;
  while (index--) {
    var key = objProps[index];
    if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
      return false;
    }
  }
  // Check that cyclic values are equal.
  var objStacked = stack.get(object);
  var othStacked = stack.get(other);
  if (objStacked && othStacked) {
    return objStacked == other && othStacked == object;
  }
  var result = true;
  stack.set(object, other);
  stack.set(other, object);

  var skipCtor = isPartial;
  while (++index < objLength) {
    key = objProps[index];
    var objValue = object[key],
        othValue = other[key];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, objValue, key, other, object, stack)
        : customizer(objValue, othValue, key, object, other, stack);
    }
    // Recursively compare objects (susceptible to call stack limits).
    if (!(compared === undefined
          ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
          : compared
        )) {
      result = false;
      break;
    }
    skipCtor || (skipCtor = key == 'constructor');
  }
  if (result && !skipCtor) {
    var objCtor = object.constructor,
        othCtor = other.constructor;

    // Non `Object` object instances with different constructors are not equal.
    if (objCtor != othCtor &&
        ('constructor' in object && 'constructor' in other) &&
        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
      result = false;
    }
  }
  stack['delete'](object);
  stack['delete'](other);
  return result;
}

module.exports = equalObjects;


/***/ }),

/***/ 54874:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var flatten = __webpack_require__(22612),
    overRest = __webpack_require__(20323),
    setToString = __webpack_require__(71564);

/**
 * A specialized version of `baseRest` which flattens the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @returns {Function} Returns the new function.
 */
function flatRest(func) {
  return setToString(overRest(func, undefined, flatten), func + '');
}

module.exports = flatRest;


/***/ }),

/***/ 96476:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof __webpack_require__.g == 'object' && __webpack_require__.g && __webpack_require__.g.Object === Object && __webpack_require__.g;

module.exports = freeGlobal;


/***/ }),

/***/ 69698:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseGetAllKeys = __webpack_require__(38084),
    getSymbols = __webpack_require__(97482),
    keys = __webpack_require__(50579);

/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeys(object) {
  return baseGetAllKeys(object, keys, getSymbols);
}

module.exports = getAllKeys;


/***/ }),

/***/ 21699:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseGetAllKeys = __webpack_require__(38084),
    getSymbolsIn = __webpack_require__(41288),
    keysIn = __webpack_require__(37390);

/**
 * Creates an array of own and inherited enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeysIn(object) {
  return baseGetAllKeys(object, keysIn, getSymbolsIn);
}

module.exports = getAllKeysIn;


/***/ }),

/***/ 67707:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isKeyable = __webpack_require__(3880);

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

module.exports = getMapData;


/***/ }),

/***/ 67487:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isStrictComparable = __webpack_require__(92769),
    keys = __webpack_require__(50579);

/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */
function getMatchData(object) {
  var result = keys(object),
      length = result.length;

  while (length--) {
    var key = result[length],
        value = object[key];

    result[length] = [key, value, isStrictComparable(value)];
  }
  return result;
}

module.exports = getMatchData;


/***/ }),

/***/ 47758:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseIsNative = __webpack_require__(58939),
    getValue = __webpack_require__(9149);

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

module.exports = getNative;


/***/ }),

/***/ 11389:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var overArg = __webpack_require__(75542);

/** Built-in value references. */
var getPrototype = overArg(Object.getPrototypeOf, Object);

module.exports = getPrototype;


/***/ }),

/***/ 31239:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var Symbol = __webpack_require__(74396);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

module.exports = getRawTag;


/***/ }),

/***/ 97482:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var arrayFilter = __webpack_require__(48969),
    stubArray = __webpack_require__(68036);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
  if (object == null) {
    return [];
  }
  object = Object(object);
  return arrayFilter(nativeGetSymbols(object), function(symbol) {
    return propertyIsEnumerable.call(object, symbol);
  });
};

module.exports = getSymbols;


/***/ }),

/***/ 41288:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var arrayPush = __webpack_require__(28486),
    getPrototype = __webpack_require__(11389),
    getSymbols = __webpack_require__(97482),
    stubArray = __webpack_require__(68036);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own and inherited enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
  var result = [];
  while (object) {
    arrayPush(result, getSymbols(object));
    object = getPrototype(object);
  }
  return result;
};

module.exports = getSymbolsIn;


/***/ }),

/***/ 81887:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var DataView = __webpack_require__(87269),
    Map = __webpack_require__(35922),
    Promise = __webpack_require__(6795),
    Set = __webpack_require__(81956),
    WeakMap = __webpack_require__(69477),
    baseGetTag = __webpack_require__(80732),
    toSource = __webpack_require__(51059);

/** `Object#toString` result references. */
var mapTag = '[object Map]',
    objectTag = '[object Object]',
    promiseTag = '[object Promise]',
    setTag = '[object Set]',
    weakMapTag = '[object WeakMap]';

var dataViewTag = '[object DataView]';

/** Used to detect maps, sets, and weakmaps. */
var dataViewCtorString = toSource(DataView),
    mapCtorString = toSource(Map),
    promiseCtorString = toSource(Promise),
    setCtorString = toSource(Set),
    weakMapCtorString = toSource(WeakMap);

/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
var getTag = baseGetTag;

// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
    (Map && getTag(new Map) != mapTag) ||
    (Promise && getTag(Promise.resolve()) != promiseTag) ||
    (Set && getTag(new Set) != setTag) ||
    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
  getTag = function(value) {
    var result = baseGetTag(value),
        Ctor = result == objectTag ? value.constructor : undefined,
        ctorString = Ctor ? toSource(Ctor) : '';

    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString: return dataViewTag;
        case mapCtorString: return mapTag;
        case promiseCtorString: return promiseTag;
        case setCtorString: return setTag;
        case weakMapCtorString: return weakMapTag;
      }
    }
    return result;
  };
}

module.exports = getTag;


/***/ }),

/***/ 9149:
/***/ (function(module) {

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

module.exports = getValue;


/***/ }),

/***/ 18554:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var castPath = __webpack_require__(60399),
    isArguments = __webpack_require__(30353),
    isArray = __webpack_require__(24669),
    isIndex = __webpack_require__(91010),
    isLength = __webpack_require__(17216),
    toKey = __webpack_require__(77817);

/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */
function hasPath(object, path, hasFunc) {
  path = castPath(path, object);

  var index = -1,
      length = path.length,
      result = false;

  while (++index < length) {
    var key = toKey(path[index]);
    if (!(result = object != null && hasFunc(object, key))) {
      break;
    }
    object = object[key];
  }
  if (result || ++index != length) {
    return result;
  }
  length = object == null ? 0 : object.length;
  return !!length && isLength(length) && isIndex(key, length) &&
    (isArray(object) || isArguments(object));
}

module.exports = hasPath;


/***/ }),

/***/ 30080:
/***/ (function(module) {

/** Used to compose unicode character classes. */
var rsAstralRange = '\\ud800-\\udfff',
    rsComboMarksRange = '\\u0300-\\u036f',
    reComboHalfMarksRange = '\\ufe20-\\ufe2f',
    rsComboSymbolsRange = '\\u20d0-\\u20ff',
    rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
    rsVarRange = '\\ufe0e\\ufe0f';

/** Used to compose unicode capture groups. */
var rsZWJ = '\\u200d';

/** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange  + rsComboRange + rsVarRange + ']');

/**
 * Checks if `string` contains Unicode symbols.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {boolean} Returns `true` if a symbol is found, else `false`.
 */
function hasUnicode(string) {
  return reHasUnicode.test(string);
}

module.exports = hasUnicode;


/***/ }),

/***/ 71519:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var nativeCreate = __webpack_require__(37722);

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
  this.size = 0;
}

module.exports = hashClear;


/***/ }),

/***/ 82999:
/***/ (function(module) {

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = hashDelete;


/***/ }),

/***/ 76111:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var nativeCreate = __webpack_require__(37722);

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

module.exports = hashGet;


/***/ }),

/***/ 50506:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var nativeCreate = __webpack_require__(37722);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
}

module.exports = hashHas;


/***/ }),

/***/ 80845:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var nativeCreate = __webpack_require__(37722);

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

module.exports = hashSet;


/***/ }),

/***/ 12195:
/***/ (function(module) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Initializes an array clone.
 *
 * @private
 * @param {Array} array The array to clone.
 * @returns {Array} Returns the initialized clone.
 */
function initCloneArray(array) {
  var length = array.length,
      result = new array.constructor(length);

  // Add properties assigned by `RegExp#exec`.
  if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
    result.index = array.index;
    result.input = array.input;
  }
  return result;
}

module.exports = initCloneArray;


/***/ }),

/***/ 46740:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var cloneArrayBuffer = __webpack_require__(78925),
    cloneDataView = __webpack_require__(56157),
    cloneRegExp = __webpack_require__(80101),
    cloneSymbol = __webpack_require__(54920),
    cloneTypedArray = __webpack_require__(27136);

/** `Object#toString` result references. */
var boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/**
 * Initializes an object clone based on its `toStringTag`.
 *
 * **Note:** This function only supports cloning values with tags of
 * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
 *
 * @private
 * @param {Object} object The object to clone.
 * @param {string} tag The `toStringTag` of the object to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneByTag(object, tag, isDeep) {
  var Ctor = object.constructor;
  switch (tag) {
    case arrayBufferTag:
      return cloneArrayBuffer(object);

    case boolTag:
    case dateTag:
      return new Ctor(+object);

    case dataViewTag:
      return cloneDataView(object, isDeep);

    case float32Tag: case float64Tag:
    case int8Tag: case int16Tag: case int32Tag:
    case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
      return cloneTypedArray(object, isDeep);

    case mapTag:
      return new Ctor;

    case numberTag:
    case stringTag:
      return new Ctor(object);

    case regexpTag:
      return cloneRegExp(object);

    case setTag:
      return new Ctor;

    case symbolTag:
      return cloneSymbol(object);
  }
}

module.exports = initCloneByTag;


/***/ }),

/***/ 36404:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseCreate = __webpack_require__(91348),
    getPrototype = __webpack_require__(11389),
    isPrototype = __webpack_require__(92963);

/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneObject(object) {
  return (typeof object.constructor == 'function' && !isPrototype(object))
    ? baseCreate(getPrototype(object))
    : {};
}

module.exports = initCloneObject;


/***/ }),

/***/ 89465:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var Symbol = __webpack_require__(74396),
    isArguments = __webpack_require__(30353),
    isArray = __webpack_require__(24669);

/** Built-in value references. */
var spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined;

/**
 * Checks if `value` is a flattenable `arguments` object or array.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
 */
function isFlattenable(value) {
  return isArray(value) || isArguments(value) ||
    !!(spreadableSymbol && value && value[spreadableSymbol]);
}

module.exports = isFlattenable;


/***/ }),

/***/ 91010:
/***/ (function(module) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  var type = typeof value;
  length = length == null ? MAX_SAFE_INTEGER : length;

  return !!length &&
    (type == 'number' ||
      (type != 'symbol' && reIsUint.test(value))) &&
        (value > -1 && value % 1 == 0 && value < length);
}

module.exports = isIndex;


/***/ }),

/***/ 2610:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isArray = __webpack_require__(24669),
    isSymbol = __webpack_require__(16764);

/** Used to match property names within property paths. */
var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
    reIsPlainProp = /^\w*$/;

/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */
function isKey(value, object) {
  if (isArray(value)) {
    return false;
  }
  var type = typeof value;
  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
      value == null || isSymbol(value)) {
    return true;
  }
  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
    (object != null && value in Object(object));
}

module.exports = isKey;


/***/ }),

/***/ 3880:
/***/ (function(module) {

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

module.exports = isKeyable;


/***/ }),

/***/ 90654:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var coreJsData = __webpack_require__(36633);

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

module.exports = isMasked;


/***/ }),

/***/ 92963:
/***/ (function(module) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

module.exports = isPrototype;


/***/ }),

/***/ 92769:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isObject = __webpack_require__(36838);

/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */
function isStrictComparable(value) {
  return value === value && !isObject(value);
}

module.exports = isStrictComparable;


/***/ }),

/***/ 2173:
/***/ (function(module) {

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
  this.size = 0;
}

module.exports = listCacheClear;


/***/ }),

/***/ 33752:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(62718);

/** Used for built-in method references. */
var arrayProto = Array.prototype;

/** Built-in value references. */
var splice = arrayProto.splice;

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  --this.size;
  return true;
}

module.exports = listCacheDelete;


/***/ }),

/***/ 10548:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(62718);

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

module.exports = listCacheGet;


/***/ }),

/***/ 63410:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(62718);

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

module.exports = listCacheHas;


/***/ }),

/***/ 3564:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(62718);

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

module.exports = listCacheSet;


/***/ }),

/***/ 7140:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var Hash = __webpack_require__(51526),
    ListCache = __webpack_require__(175),
    Map = __webpack_require__(35922);

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.size = 0;
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map || ListCache),
    'string': new Hash
  };
}

module.exports = mapCacheClear;


/***/ }),

/***/ 56504:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getMapData = __webpack_require__(67707);

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  var result = getMapData(this, key)['delete'](key);
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = mapCacheDelete;


/***/ }),

/***/ 88833:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getMapData = __webpack_require__(67707);

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

module.exports = mapCacheGet;


/***/ }),

/***/ 80953:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getMapData = __webpack_require__(67707);

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

module.exports = mapCacheHas;


/***/ }),

/***/ 70724:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getMapData = __webpack_require__(67707);

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  var data = getMapData(this, key),
      size = data.size;

  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}

module.exports = mapCacheSet;


/***/ }),

/***/ 7523:
/***/ (function(module) {

/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */
function mapToArray(map) {
  var index = -1,
      result = Array(map.size);

  map.forEach(function(value, key) {
    result[++index] = [key, value];
  });
  return result;
}

module.exports = mapToArray;


/***/ }),

/***/ 78857:
/***/ (function(module) {

/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function matchesStrictComparable(key, srcValue) {
  return function(object) {
    if (object == null) {
      return false;
    }
    return object[key] === srcValue &&
      (srcValue !== undefined || (key in Object(object)));
  };
}

module.exports = matchesStrictComparable;


/***/ }),

/***/ 45171:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var memoize = __webpack_require__(34736);

/** Used as the maximum memoize cache size. */
var MAX_MEMOIZE_SIZE = 500;

/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */
function memoizeCapped(func) {
  var result = memoize(func, function(key) {
    if (cache.size === MAX_MEMOIZE_SIZE) {
      cache.clear();
    }
    return key;
  });

  var cache = result.cache;
  return result;
}

module.exports = memoizeCapped;


/***/ }),

/***/ 37722:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getNative = __webpack_require__(47758);

/* Built-in method references that are verified to be native. */
var nativeCreate = getNative(Object, 'create');

module.exports = nativeCreate;


/***/ }),

/***/ 14457:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var overArg = __webpack_require__(75542);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys = overArg(Object.keys, Object);

module.exports = nativeKeys;


/***/ }),

/***/ 10814:
/***/ (function(module) {

/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function nativeKeysIn(object) {
  var result = [];
  if (object != null) {
    for (var key in Object(object)) {
      result.push(key);
    }
  }
  return result;
}

module.exports = nativeKeysIn;


/***/ }),

/***/ 8478:
/***/ (function(module, exports, __webpack_require__) {

/* module decorator */ module = __webpack_require__.nmd(module);
var freeGlobal = __webpack_require__(96476);

/** Detect free variable `exports`. */
var freeExports =  true && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && "object" == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Detect free variable `process` from Node.js. */
var freeProcess = moduleExports && freeGlobal.process;

/** Used to access faster Node.js helpers. */
var nodeUtil = (function() {
  try {
    // Use `util.types` for Node.js 10+.
    var types = freeModule && freeModule.require && freeModule.require('util').types;

    if (types) {
      return types;
    }

    // Legacy `process.binding('util')` for Node.js < 10.
    return freeProcess && freeProcess.binding && freeProcess.binding('util');
  } catch (e) {}
}());

module.exports = nodeUtil;


/***/ }),

/***/ 57058:
/***/ (function(module) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

module.exports = objectToString;


/***/ }),

/***/ 75542:
/***/ (function(module) {

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

module.exports = overArg;


/***/ }),

/***/ 20323:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var apply = __webpack_require__(93501);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */
function overRest(func, start, transform) {
  start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
  return function() {
    var args = arguments,
        index = -1,
        length = nativeMax(args.length - start, 0),
        array = Array(length);

    while (++index < length) {
      array[index] = args[start + index];
    }
    index = -1;
    var otherArgs = Array(start + 1);
    while (++index < start) {
      otherArgs[index] = args[index];
    }
    otherArgs[start] = transform(array);
    return apply(func, this, otherArgs);
  };
}

module.exports = overRest;


/***/ }),

/***/ 39118:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseGet = __webpack_require__(97499),
    baseSlice = __webpack_require__(43846);

/**
 * Gets the parent value at `path` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array} path The path to get the parent value of.
 * @returns {*} Returns the parent value.
 */
function parent(object, path) {
  return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
}

module.exports = parent;


/***/ }),

/***/ 29165:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var freeGlobal = __webpack_require__(96476);

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

module.exports = root;


/***/ }),

/***/ 96659:
/***/ (function(module) {

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */
function setCacheAdd(value) {
  this.__data__.set(value, HASH_UNDEFINED);
  return this;
}

module.exports = setCacheAdd;


/***/ }),

/***/ 97230:
/***/ (function(module) {

/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */
function setCacheHas(value) {
  return this.__data__.has(value);
}

module.exports = setCacheHas;


/***/ }),

/***/ 79967:
/***/ (function(module) {

/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */
function setToArray(set) {
  var index = -1,
      result = Array(set.size);

  set.forEach(function(value) {
    result[++index] = value;
  });
  return result;
}

module.exports = setToArray;


/***/ }),

/***/ 71564:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseSetToString = __webpack_require__(56447),
    shortOut = __webpack_require__(15509);

/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var setToString = shortOut(baseSetToString);

module.exports = setToString;


/***/ }),

/***/ 15509:
/***/ (function(module) {

/** Used to detect hot functions by number of calls within a span of milliseconds. */
var HOT_COUNT = 800,
    HOT_SPAN = 16;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeNow = Date.now;

/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */
function shortOut(func) {
  var count = 0,
      lastCalled = 0;

  return function() {
    var stamp = nativeNow(),
        remaining = HOT_SPAN - (stamp - lastCalled);

    lastCalled = stamp;
    if (remaining > 0) {
      if (++count >= HOT_COUNT) {
        return arguments[0];
      }
    } else {
      count = 0;
    }
    return func.apply(undefined, arguments);
  };
}

module.exports = shortOut;


/***/ }),

/***/ 40551:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var ListCache = __webpack_require__(175);

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear() {
  this.__data__ = new ListCache;
  this.size = 0;
}

module.exports = stackClear;


/***/ }),

/***/ 4090:
/***/ (function(module) {

/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function stackDelete(key) {
  var data = this.__data__,
      result = data['delete'](key);

  this.size = data.size;
  return result;
}

module.exports = stackDelete;


/***/ }),

/***/ 47694:
/***/ (function(module) {

/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function stackGet(key) {
  return this.__data__.get(key);
}

module.exports = stackGet;


/***/ }),

/***/ 86220:
/***/ (function(module) {

/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function stackHas(key) {
  return this.__data__.has(key);
}

module.exports = stackHas;


/***/ }),

/***/ 68958:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var ListCache = __webpack_require__(175),
    Map = __webpack_require__(35922),
    MapCache = __webpack_require__(9440);

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet(key, value) {
  var data = this.__data__;
  if (data instanceof ListCache) {
    var pairs = data.__data__;
    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
      pairs.push([key, value]);
      this.size = ++data.size;
      return this;
    }
    data = this.__data__ = new MapCache(pairs);
  }
  data.set(key, value);
  this.size = data.size;
  return this;
}

module.exports = stackSet;


/***/ }),

/***/ 68905:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var asciiSize = __webpack_require__(15989),
    hasUnicode = __webpack_require__(30080),
    unicodeSize = __webpack_require__(43352);

/**
 * Gets the number of symbols in `string`.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {number} Returns the string size.
 */
function stringSize(string) {
  return hasUnicode(string)
    ? unicodeSize(string)
    : asciiSize(string);
}

module.exports = stringSize;


/***/ }),

/***/ 77057:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var memoizeCapped = __webpack_require__(45171);

/** Used to match property names within property paths. */
var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

/** Used to match backslashes in property paths. */
var reEscapeChar = /\\(\\)?/g;

/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */
var stringToPath = memoizeCapped(function(string) {
  var result = [];
  if (string.charCodeAt(0) === 46 /* . */) {
    result.push('');
  }
  string.replace(rePropName, function(match, number, quote, subString) {
    result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
  });
  return result;
});

module.exports = stringToPath;


/***/ }),

/***/ 77817:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isSymbol = __webpack_require__(16764);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */
function toKey(value) {
  if (typeof value == 'string' || isSymbol(value)) {
    return value;
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

module.exports = toKey;


/***/ }),

/***/ 51059:
/***/ (function(module) {

/** Used for built-in method references. */
var funcProto = Function.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

module.exports = toSource;


/***/ }),

/***/ 82996:
/***/ (function(module) {

/** Used to match a single whitespace character. */
var reWhitespace = /\s/;

/**
 * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
 * character of `string`.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {number} Returns the index of the last non-whitespace character.
 */
function trimmedEndIndex(string) {
  var index = string.length;

  while (index-- && reWhitespace.test(string.charAt(index))) {}
  return index;
}

module.exports = trimmedEndIndex;


/***/ }),

/***/ 43352:
/***/ (function(module) {

/** Used to compose unicode character classes. */
var rsAstralRange = '\\ud800-\\udfff',
    rsComboMarksRange = '\\u0300-\\u036f',
    reComboHalfMarksRange = '\\ufe20-\\ufe2f',
    rsComboSymbolsRange = '\\u20d0-\\u20ff',
    rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
    rsVarRange = '\\ufe0e\\ufe0f';

/** Used to compose unicode capture groups. */
var rsAstral = '[' + rsAstralRange + ']',
    rsCombo = '[' + rsComboRange + ']',
    rsFitz = '\\ud83c[\\udffb-\\udfff]',
    rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
    rsNonAstral = '[^' + rsAstralRange + ']',
    rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
    rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
    rsZWJ = '\\u200d';

/** Used to compose unicode regexes. */
var reOptMod = rsModifier + '?',
    rsOptVar = '[' + rsVarRange + ']?',
    rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
    rsSeq = rsOptVar + reOptMod + rsOptJoin,
    rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';

/** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');

/**
 * Gets the size of a Unicode `string`.
 *
 * @private
 * @param {string} string The string inspect.
 * @returns {number} Returns the string size.
 */
function unicodeSize(string) {
  var result = reUnicode.lastIndex = 0;
  while (reUnicode.test(string)) {
    ++result;
  }
  return result;
}

module.exports = unicodeSize;


/***/ }),

/***/ 64806:
/***/ (function(module) {

/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */
function constant(value) {
  return function() {
    return value;
  };
}

module.exports = constant;


/***/ }),

/***/ 66292:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isObject = __webpack_require__(36838),
    now = __webpack_require__(76668),
    toNumber = __webpack_require__(12448);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max,
    nativeMin = Math.min;

/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */
function debounce(func, wait, options) {
  var lastArgs,
      lastThis,
      maxWait,
      result,
      timerId,
      lastCallTime,
      lastInvokeTime = 0,
      leading = false,
      maxing = false,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  wait = toNumber(wait) || 0;
  if (isObject(options)) {
    leading = !!options.leading;
    maxing = 'maxWait' in options;
    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }

  function invokeFunc(time) {
    var args = lastArgs,
        thisArg = lastThis;

    lastArgs = lastThis = undefined;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }

  function leadingEdge(time) {
    // Reset any `maxWait` timer.
    lastInvokeTime = time;
    // Start the timer for the trailing edge.
    timerId = setTimeout(timerExpired, wait);
    // Invoke the leading edge.
    return leading ? invokeFunc(time) : result;
  }

  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime,
        timeWaiting = wait - timeSinceLastCall;

    return maxing
      ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke)
      : timeWaiting;
  }

  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime;

    // Either this is the first call, activity has stopped and we're at the
    // trailing edge, the system time has gone backwards and we're treating
    // it as the trailing edge, or we've hit the `maxWait` limit.
    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
  }

  function timerExpired() {
    var time = now();
    if (shouldInvoke(time)) {
      return trailingEdge(time);
    }
    // Restart the timer.
    timerId = setTimeout(timerExpired, remainingWait(time));
  }

  function trailingEdge(time) {
    timerId = undefined;

    // Only invoke if we have `lastArgs` which means `func` has been
    // debounced at least once.
    if (trailing && lastArgs) {
      return invokeFunc(time);
    }
    lastArgs = lastThis = undefined;
    return result;
  }

  function cancel() {
    if (timerId !== undefined) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = undefined;
  }

  function flush() {
    return timerId === undefined ? result : trailingEdge(now());
  }

  function debounced() {
    var time = now(),
        isInvoking = shouldInvoke(time);

    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time;

    if (isInvoking) {
      if (timerId === undefined) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        // Handle invocations in a tight loop.
        clearTimeout(timerId);
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === undefined) {
      timerId = setTimeout(timerExpired, wait);
    }
    return result;
  }
  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}

module.exports = debounce;


/***/ }),

/***/ 42448:
/***/ (function(module) {

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

module.exports = eq;


/***/ }),

/***/ 90469:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var createFind = __webpack_require__(34715),
    findLastIndex = __webpack_require__(31521);

/**
 * This method is like `_.find` except that it iterates over elements of
 * `collection` from right to left.
 *
 * @static
 * @memberOf _
 * @since 2.0.0
 * @category Collection
 * @param {Array|Object} collection The collection to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param {number} [fromIndex=collection.length-1] The index to search from.
 * @returns {*} Returns the matched element, else `undefined`.
 * @example
 *
 * _.findLast([1, 2, 3, 4], function(n) {
 *   return n % 2 == 1;
 * });
 * // => 3
 */
var findLast = createFind(findLastIndex);

module.exports = findLast;


/***/ }),

/***/ 31521:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseFindIndex = __webpack_require__(92504),
    baseIteratee = __webpack_require__(5673),
    toInteger = __webpack_require__(20426);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max,
    nativeMin = Math.min;

/**
 * This method is like `_.findIndex` except that it iterates over elements
 * of `collection` from right to left.
 *
 * @static
 * @memberOf _
 * @since 2.0.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param {number} [fromIndex=array.length-1] The index to search from.
 * @returns {number} Returns the index of the found element, else `-1`.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'active': true },
 *   { 'user': 'fred',    'active': false },
 *   { 'user': 'pebbles', 'active': false }
 * ];
 *
 * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
 * // => 2
 *
 * // The `_.matches` iteratee shorthand.
 * _.findLastIndex(users, { 'user': 'barney', 'active': true });
 * // => 0
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.findLastIndex(users, ['active', false]);
 * // => 2
 *
 * // The `_.property` iteratee shorthand.
 * _.findLastIndex(users, 'active');
 * // => 0
 */
function findLastIndex(array, predicate, fromIndex) {
  var length = array == null ? 0 : array.length;
  if (!length) {
    return -1;
  }
  var index = length - 1;
  if (fromIndex !== undefined) {
    index = toInteger(fromIndex);
    index = fromIndex < 0
      ? nativeMax(length + index, 0)
      : nativeMin(index, length - 1);
  }
  return baseFindIndex(array, baseIteratee(predicate, 3), index, true);
}

module.exports = findLastIndex;


/***/ }),

/***/ 94274:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseFindKey = __webpack_require__(99548),
    baseForOwnRight = __webpack_require__(55471),
    baseIteratee = __webpack_require__(5673);

/**
 * This method is like `_.findKey` except that it iterates over elements of
 * a collection in the opposite order.
 *
 * @static
 * @memberOf _
 * @since 2.0.0
 * @category Object
 * @param {Object} object The object to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @returns {string|undefined} Returns the key of the matched element,
 *  else `undefined`.
 * @example
 *
 * var users = {
 *   'barney':  { 'age': 36, 'active': true },
 *   'fred':    { 'age': 40, 'active': false },
 *   'pebbles': { 'age': 1,  'active': true }
 * };
 *
 * _.findLastKey(users, function(o) { return o.age < 40; });
 * // => returns 'pebbles' assuming `_.findKey` returns 'barney'
 *
 * // The `_.matches` iteratee shorthand.
 * _.findLastKey(users, { 'age': 36, 'active': true });
 * // => 'barney'
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.findLastKey(users, ['active', false]);
 * // => 'fred'
 *
 * // The `_.property` iteratee shorthand.
 * _.findLastKey(users, 'active');
 * // => 'pebbles'
 */
function findLastKey(object, predicate) {
  return baseFindKey(object, baseIteratee(predicate, 3), baseForOwnRight);
}

module.exports = findLastKey;


/***/ }),

/***/ 22612:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseFlatten = __webpack_require__(98768);

/**
 * Flattens `array` a single level deep.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to flatten.
 * @returns {Array} Returns the new flattened array.
 * @example
 *
 * _.flatten([1, [2, [3, [4]], 5]]);
 * // => [1, 2, [3, [4]], 5]
 */
function flatten(array) {
  var length = array == null ? 0 : array.length;
  return length ? baseFlatten(array, 1) : [];
}

module.exports = flatten;


/***/ }),

/***/ 65439:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseGet = __webpack_require__(97499);

/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */
function get(object, path, defaultValue) {
  var result = object == null ? undefined : baseGet(object, path);
  return result === undefined ? defaultValue : result;
}

module.exports = get;


/***/ }),

/***/ 28281:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseHasIn = __webpack_require__(71664),
    hasPath = __webpack_require__(18554);

/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */
function hasIn(object, path) {
  return object != null && hasPath(object, path, baseHasIn);
}

module.exports = hasIn;


/***/ }),

/***/ 48148:
/***/ (function(module) {

/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function identity(value) {
  return value;
}

module.exports = identity;


/***/ }),

/***/ 30353:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseIsArguments = __webpack_require__(84742),
    isObjectLike = __webpack_require__(55073);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
  return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
    !propertyIsEnumerable.call(value, 'callee');
};

module.exports = isArguments;


/***/ }),

/***/ 24669:
/***/ (function(module) {

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

module.exports = isArray;


/***/ }),

/***/ 47428:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isFunction = __webpack_require__(92042),
    isLength = __webpack_require__(17216);

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

module.exports = isArrayLike;


/***/ }),

/***/ 61563:
/***/ (function(module, exports, __webpack_require__) {

/* module decorator */ module = __webpack_require__.nmd(module);
var root = __webpack_require__(29165),
    stubFalse = __webpack_require__(84193);

/** Detect free variable `exports`. */
var freeExports =  true && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && "object" == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;

/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */
var isBuffer = nativeIsBuffer || stubFalse;

module.exports = isBuffer;


/***/ }),

/***/ 31223:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseIsEqual = __webpack_require__(6620);

/**
 * Performs a deep comparison between two values to determine if they are
 * equivalent.
 *
 * **Note:** This method supports comparing arrays, array buffers, booleans,
 * date objects, error objects, maps, numbers, `Object` objects, regexes,
 * sets, strings, symbols, and typed arrays. `Object` objects are compared
 * by their own, not inherited, enumerable properties. Functions and DOM
 * nodes are compared by strict equality, i.e. `===`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.isEqual(object, other);
 * // => true
 *
 * object === other;
 * // => false
 */
function isEqual(value, other) {
  return baseIsEqual(value, other);
}

module.exports = isEqual;


/***/ }),

/***/ 92042:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseGetTag = __webpack_require__(80732),
    isObject = __webpack_require__(36838);

/** `Object#toString` result references. */
var asyncTag = '[object AsyncFunction]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    proxyTag = '[object Proxy]';

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  if (!isObject(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = baseGetTag(value);
  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}

module.exports = isFunction;


/***/ }),

/***/ 17216:
/***/ (function(module) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

module.exports = isLength;


/***/ }),

/***/ 32924:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseIsMap = __webpack_require__(64033),
    baseUnary = __webpack_require__(58792),
    nodeUtil = __webpack_require__(8478);

/* Node.js helper references. */
var nodeIsMap = nodeUtil && nodeUtil.isMap;

/**
 * Checks if `value` is classified as a `Map` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 * @example
 *
 * _.isMap(new Map);
 * // => true
 *
 * _.isMap(new WeakMap);
 * // => false
 */
var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;

module.exports = isMap;


/***/ }),

/***/ 36838:
/***/ (function(module) {

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

module.exports = isObject;


/***/ }),

/***/ 55073:
/***/ (function(module) {

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

module.exports = isObjectLike;


/***/ }),

/***/ 69143:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseGetTag = __webpack_require__(80732),
    getPrototype = __webpack_require__(11389),
    isObjectLike = __webpack_require__(55073);

/** `Object#toString` result references. */
var objectTag = '[object Object]';

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to infer the `Object` constructor. */
var objectCtorString = funcToString.call(Object);

/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */
function isPlainObject(value) {
  if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
    return false;
  }
  var proto = getPrototype(value);
  if (proto === null) {
    return true;
  }
  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
    funcToString.call(Ctor) == objectCtorString;
}

module.exports = isPlainObject;


/***/ }),

/***/ 45380:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseIsSet = __webpack_require__(28264),
    baseUnary = __webpack_require__(58792),
    nodeUtil = __webpack_require__(8478);

/* Node.js helper references. */
var nodeIsSet = nodeUtil && nodeUtil.isSet;

/**
 * Checks if `value` is classified as a `Set` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 * @example
 *
 * _.isSet(new Set);
 * // => true
 *
 * _.isSet(new WeakSet);
 * // => false
 */
var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;

module.exports = isSet;


/***/ }),

/***/ 56549:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseGetTag = __webpack_require__(80732),
    isArray = __webpack_require__(24669),
    isObjectLike = __webpack_require__(55073);

/** `Object#toString` result references. */
var stringTag = '[object String]';

/**
 * Checks if `value` is classified as a `String` primitive or object.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a string, else `false`.
 * @example
 *
 * _.isString('abc');
 * // => true
 *
 * _.isString(1);
 * // => false
 */
function isString(value) {
  return typeof value == 'string' ||
    (!isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag);
}

module.exports = isString;


/***/ }),

/***/ 16764:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseGetTag = __webpack_require__(80732),
    isObjectLike = __webpack_require__(55073);

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && baseGetTag(value) == symbolTag);
}

module.exports = isSymbol;


/***/ }),

/***/ 73806:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseIsTypedArray = __webpack_require__(22882),
    baseUnary = __webpack_require__(58792),
    nodeUtil = __webpack_require__(8478);

/* Node.js helper references. */
var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

module.exports = isTypedArray;


/***/ }),

/***/ 50579:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var arrayLikeKeys = __webpack_require__(79809),
    baseKeys = __webpack_require__(87473),
    isArrayLike = __webpack_require__(47428);

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}

module.exports = keys;


/***/ }),

/***/ 37390:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var arrayLikeKeys = __webpack_require__(79809),
    baseKeysIn = __webpack_require__(52506),
    isArrayLike = __webpack_require__(47428);

/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */
function keysIn(object) {
  return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
}

module.exports = keysIn;


/***/ }),

/***/ 25674:
/***/ (function(module) {

/**
 * Gets the last element of `array`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to query.
 * @returns {*} Returns the last element of `array`.
 * @example
 *
 * _.last([1, 2, 3]);
 * // => 3
 */
function last(array) {
  var length = array == null ? 0 : array.length;
  return length ? array[length - 1] : undefined;
}

module.exports = last;


/***/ }),

/***/ 32699:
/***/ (function(module, exports, __webpack_require__) {

/* module decorator */ module = __webpack_require__.nmd(module);
var __WEBPACK_AMD_DEFINE_RESULT__;/**
 * @license
 * Lodash <https://lodash.com/>
 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */
;(function() {

  /** Used as a safe reference for `undefined` in pre-ES5 environments. */
  var undefined;

  /** Used as the semantic version number. */
  var VERSION = '4.17.21';

  /** Used as the size to enable large array optimizations. */
  var LARGE_ARRAY_SIZE = 200;

  /** Error message constants. */
  var CORE_ERROR_TEXT = 'Unsupported core-js use. Try https://npms.io/search?q=ponyfill.',
      FUNC_ERROR_TEXT = 'Expected a function',
      INVALID_TEMPL_VAR_ERROR_TEXT = 'Invalid `variable` option passed into `_.template`';

  /** Used to stand-in for `undefined` hash values. */
  var HASH_UNDEFINED = '__lodash_hash_undefined__';

  /** Used as the maximum memoize cache size. */
  var MAX_MEMOIZE_SIZE = 500;

  /** Used as the internal argument placeholder. */
  var PLACEHOLDER = '__lodash_placeholder__';

  /** Used to compose bitmasks for cloning. */
  var CLONE_DEEP_FLAG = 1,
      CLONE_FLAT_FLAG = 2,
      CLONE_SYMBOLS_FLAG = 4;

  /** Used to compose bitmasks for value comparisons. */
  var COMPARE_PARTIAL_FLAG = 1,
      COMPARE_UNORDERED_FLAG = 2;

  /** Used to compose bitmasks for function metadata. */
  var WRAP_BIND_FLAG = 1,
      WRAP_BIND_KEY_FLAG = 2,
      WRAP_CURRY_BOUND_FLAG = 4,
      WRAP_CURRY_FLAG = 8,
      WRAP_CURRY_RIGHT_FLAG = 16,
      WRAP_PARTIAL_FLAG = 32,
      WRAP_PARTIAL_RIGHT_FLAG = 64,
      WRAP_ARY_FLAG = 128,
      WRAP_REARG_FLAG = 256,
      WRAP_FLIP_FLAG = 512;

  /** Used as default options for `_.truncate`. */
  var DEFAULT_TRUNC_LENGTH = 30,
      DEFAULT_TRUNC_OMISSION = '...';

  /** Used to detect hot functions by number of calls within a span of milliseconds. */
  var HOT_COUNT = 800,
      HOT_SPAN = 16;

  /** Used to indicate the type of lazy iteratees. */
  var LAZY_FILTER_FLAG = 1,
      LAZY_MAP_FLAG = 2,
      LAZY_WHILE_FLAG = 3;

  /** Used as references for various `Number` constants. */
  var INFINITY = 1 / 0,
      MAX_SAFE_INTEGER = 9007199254740991,
      MAX_INTEGER = 1.7976931348623157e+308,
      NAN = 0 / 0;

  /** Used as references for the maximum length and index of an array. */
  var MAX_ARRAY_LENGTH = 4294967295,
      MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1,
      HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;

  /** Used to associate wrap methods with their bit flags. */
  var wrapFlags = [
    ['ary', WRAP_ARY_FLAG],
    ['bind', WRAP_BIND_FLAG],
    ['bindKey', WRAP_BIND_KEY_FLAG],
    ['curry', WRAP_CURRY_FLAG],
    ['curryRight', WRAP_CURRY_RIGHT_FLAG],
    ['flip', WRAP_FLIP_FLAG],
    ['partial', WRAP_PARTIAL_FLAG],
    ['partialRight', WRAP_PARTIAL_RIGHT_FLAG],
    ['rearg', WRAP_REARG_FLAG]
  ];

  /** `Object#toString` result references. */
  var argsTag = '[object Arguments]',
      arrayTag = '[object Array]',
      asyncTag = '[object AsyncFunction]',
      boolTag = '[object Boolean]',
      dateTag = '[object Date]',
      domExcTag = '[object DOMException]',
      errorTag = '[object Error]',
      funcTag = '[object Function]',
      genTag = '[object GeneratorFunction]',
      mapTag = '[object Map]',
      numberTag = '[object Number]',
      nullTag = '[object Null]',
      objectTag = '[object Object]',
      promiseTag = '[object Promise]',
      proxyTag = '[object Proxy]',
      regexpTag = '[object RegExp]',
      setTag = '[object Set]',
      stringTag = '[object String]',
      symbolTag = '[object Symbol]',
      undefinedTag = '[object Undefined]',
      weakMapTag = '[object WeakMap]',
      weakSetTag = '[object WeakSet]';

  var arrayBufferTag = '[object ArrayBuffer]',
      dataViewTag = '[object DataView]',
      float32Tag = '[object Float32Array]',
      float64Tag = '[object Float64Array]',
      int8Tag = '[object Int8Array]',
      int16Tag = '[object Int16Array]',
      int32Tag = '[object Int32Array]',
      uint8Tag = '[object Uint8Array]',
      uint8ClampedTag = '[object Uint8ClampedArray]',
      uint16Tag = '[object Uint16Array]',
      uint32Tag = '[object Uint32Array]';

  /** Used to match empty string literals in compiled template source. */
  var reEmptyStringLeading = /\b__p \+= '';/g,
      reEmptyStringMiddle = /\b(__p \+=) '' \+/g,
      reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;

  /** Used to match HTML entities and HTML characters. */
  var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g,
      reUnescapedHtml = /[&<>"']/g,
      reHasEscapedHtml = RegExp(reEscapedHtml.source),
      reHasUnescapedHtml = RegExp(reUnescapedHtml.source);

  /** Used to match template delimiters. */
  var reEscape = /<%-([\s\S]+?)%>/g,
      reEvaluate = /<%([\s\S]+?)%>/g,
      reInterpolate = /<%=([\s\S]+?)%>/g;

  /** Used to match property names within property paths. */
  var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
      reIsPlainProp = /^\w*$/,
      rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

  /**
   * Used to match `RegExp`
   * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
   */
  var reRegExpChar = /[\\^$.*+?()[\]{}|]/g,
      reHasRegExpChar = RegExp(reRegExpChar.source);

  /** Used to match leading whitespace. */
  var reTrimStart = /^\s+/;

  /** Used to match a single whitespace character. */
  var reWhitespace = /\s/;

  /** Used to match wrap detail comments. */
  var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/,
      reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/,
      reSplitDetails = /,? & /;

  /** Used to match words composed of alphanumeric characters. */
  var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;

  /**
   * Used to validate the `validate` option in `_.template` variable.
   *
   * Forbids characters which could potentially change the meaning of the function argument definition:
   * - "()," (modification of function parameters)
   * - "=" (default value)
   * - "[]{}" (destructuring of function parameters)
   * - "/" (beginning of a comment)
   * - whitespace
   */
  var reForbiddenIdentifierChars = /[()=,{}\[\]\/\s]/;

  /** Used to match backslashes in property paths. */
  var reEscapeChar = /\\(\\)?/g;

  /**
   * Used to match
   * [ES template delimiters](http://ecma-international.org/ecma-262/7.0/#sec-template-literal-lexical-components).
   */
  var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;

  /** Used to match `RegExp` flags from their coerced string values. */
  var reFlags = /\w*$/;

  /** Used to detect bad signed hexadecimal string values. */
  var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

  /** Used to detect binary string values. */
  var reIsBinary = /^0b[01]+$/i;

  /** Used to detect host constructors (Safari). */
  var reIsHostCtor = /^\[object .+?Constructor\]$/;

  /** Used to detect octal string values. */
  var reIsOctal = /^0o[0-7]+$/i;

  /** Used to detect unsigned integer values. */
  var reIsUint = /^(?:0|[1-9]\d*)$/;

  /** Used to match Latin Unicode letters (excluding mathematical operators). */
  var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;

  /** Used to ensure capturing order of template delimiters. */
  var reNoMatch = /($^)/;

  /** Used to match unescaped characters in compiled string literals. */
  var reUnescapedString = /['\n\r\u2028\u2029\\]/g;

  /** Used to compose unicode character classes. */
  var rsAstralRange = '\\ud800-\\udfff',
      rsComboMarksRange = '\\u0300-\\u036f',
      reComboHalfMarksRange = '\\ufe20-\\ufe2f',
      rsComboSymbolsRange = '\\u20d0-\\u20ff',
      rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
      rsDingbatRange = '\\u2700-\\u27bf',
      rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff',
      rsMathOpRange = '\\xac\\xb1\\xd7\\xf7',
      rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf',
      rsPunctuationRange = '\\u2000-\\u206f',
      rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000',
      rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde',
      rsVarRange = '\\ufe0e\\ufe0f',
      rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;

  /** Used to compose unicode capture groups. */
  var rsApos = "['\u2019]",
      rsAstral = '[' + rsAstralRange + ']',
      rsBreak = '[' + rsBreakRange + ']',
      rsCombo = '[' + rsComboRange + ']',
      rsDigits = '\\d+',
      rsDingbat = '[' + rsDingbatRange + ']',
      rsLower = '[' + rsLowerRange + ']',
      rsMisc = '[^' + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']',
      rsFitz = '\\ud83c[\\udffb-\\udfff]',
      rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
      rsNonAstral = '[^' + rsAstralRange + ']',
      rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
      rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
      rsUpper = '[' + rsUpperRange + ']',
      rsZWJ = '\\u200d';

  /** Used to compose unicode regexes. */
  var rsMiscLower = '(?:' + rsLower + '|' + rsMisc + ')',
      rsMiscUpper = '(?:' + rsUpper + '|' + rsMisc + ')',
      rsOptContrLower = '(?:' + rsApos + '(?:d|ll|m|re|s|t|ve))?',
      rsOptContrUpper = '(?:' + rsApos + '(?:D|LL|M|RE|S|T|VE))?',
      reOptMod = rsModifier + '?',
      rsOptVar = '[' + rsVarRange + ']?',
      rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
      rsOrdLower = '\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])',
      rsOrdUpper = '\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])',
      rsSeq = rsOptVar + reOptMod + rsOptJoin,
      rsEmoji = '(?:' + [rsDingbat, rsRegional, rsSurrPair].join('|') + ')' + rsSeq,
      rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';

  /** Used to match apostrophes. */
  var reApos = RegExp(rsApos, 'g');

  /**
   * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
   * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
   */
  var reComboMark = RegExp(rsCombo, 'g');

  /** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
  var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');

  /** Used to match complex or compound words. */
  var reUnicodeWord = RegExp([
    rsUpper + '?' + rsLower + '+' + rsOptContrLower + '(?=' + [rsBreak, rsUpper, '$'].join('|') + ')',
    rsMiscUpper + '+' + rsOptContrUpper + '(?=' + [rsBreak, rsUpper + rsMiscLower, '$'].join('|') + ')',
    rsUpper + '?' + rsMiscLower + '+' + rsOptContrLower,
    rsUpper + '+' + rsOptContrUpper,
    rsOrdUpper,
    rsOrdLower,
    rsDigits,
    rsEmoji
  ].join('|'), 'g');

  /** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
  var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange  + rsComboRange + rsVarRange + ']');

  /** Used to detect strings that need a more robust regexp to match words. */
  var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;

  /** Used to assign default `context` object properties. */
  var contextProps = [
    'Array', 'Buffer', 'DataView', 'Date', 'Error', 'Float32Array', 'Float64Array',
    'Function', 'Int8Array', 'Int16Array', 'Int32Array', 'Map', 'Math', 'Object',
    'Promise', 'RegExp', 'Set', 'String', 'Symbol', 'TypeError', 'Uint8Array',
    'Uint8ClampedArray', 'Uint16Array', 'Uint32Array', 'WeakMap',
    '_', 'clearTimeout', 'isFinite', 'parseInt', 'setTimeout'
  ];

  /** Used to make template sourceURLs easier to identify. */
  var templateCounter = -1;

  /** Used to identify `toStringTag` values of typed arrays. */
  var typedArrayTags = {};
  typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
  typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
  typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
  typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
  typedArrayTags[uint32Tag] = true;
  typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
  typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
  typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
  typedArrayTags[errorTag] = typedArrayTags[funcTag] =
  typedArrayTags[mapTag] = typedArrayTags[numberTag] =
  typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
  typedArrayTags[setTag] = typedArrayTags[stringTag] =
  typedArrayTags[weakMapTag] = false;

  /** Used to identify `toStringTag` values supported by `_.clone`. */
  var cloneableTags = {};
  cloneableTags[argsTag] = cloneableTags[arrayTag] =
  cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
  cloneableTags[boolTag] = cloneableTags[dateTag] =
  cloneableTags[float32Tag] = cloneableTags[float64Tag] =
  cloneableTags[int8Tag] = cloneableTags[int16Tag] =
  cloneableTags[int32Tag] = cloneableTags[mapTag] =
  cloneableTags[numberTag] = cloneableTags[objectTag] =
  cloneableTags[regexpTag] = cloneableTags[setTag] =
  cloneableTags[stringTag] = cloneableTags[symbolTag] =
  cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
  cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
  cloneableTags[errorTag] = cloneableTags[funcTag] =
  cloneableTags[weakMapTag] = false;

  /** Used to map Latin Unicode letters to basic Latin letters. */
  var deburredLetters = {
    // Latin-1 Supplement block.
    '\xc0': 'A',  '\xc1': 'A', '\xc2': 'A', '\xc3': 'A', '\xc4': 'A', '\xc5': 'A',
    '\xe0': 'a',  '\xe1': 'a', '\xe2': 'a', '\xe3': 'a', '\xe4': 'a', '\xe5': 'a',
    '\xc7': 'C',  '\xe7': 'c',
    '\xd0': 'D',  '\xf0': 'd',
    '\xc8': 'E',  '\xc9': 'E', '\xca': 'E', '\xcb': 'E',
    '\xe8': 'e',  '\xe9': 'e', '\xea': 'e', '\xeb': 'e',
    '\xcc': 'I',  '\xcd': 'I', '\xce': 'I', '\xcf': 'I',
    '\xec': 'i',  '\xed': 'i', '\xee': 'i', '\xef': 'i',
    '\xd1': 'N',  '\xf1': 'n',
    '\xd2': 'O',  '\xd3': 'O', '\xd4': 'O', '\xd5': 'O', '\xd6': 'O', '\xd8': 'O',
    '\xf2': 'o',  '\xf3': 'o', '\xf4': 'o', '\xf5': 'o', '\xf6': 'o', '\xf8': 'o',
    '\xd9': 'U',  '\xda': 'U', '\xdb': 'U', '\xdc': 'U',
    '\xf9': 'u',  '\xfa': 'u', '\xfb': 'u', '\xfc': 'u',
    '\xdd': 'Y',  '\xfd': 'y', '\xff': 'y',
    '\xc6': 'Ae', '\xe6': 'ae',
    '\xde': 'Th', '\xfe': 'th',
    '\xdf': 'ss',
    // Latin Extended-A block.
    '\u0100': 'A',  '\u0102': 'A', '\u0104': 'A',
    '\u0101': 'a',  '\u0103': 'a', '\u0105': 'a',
    '\u0106': 'C',  '\u0108': 'C', '\u010a': 'C', '\u010c': 'C',
    '\u0107': 'c',  '\u0109': 'c', '\u010b': 'c', '\u010d': 'c',
    '\u010e': 'D',  '\u0110': 'D', '\u010f': 'd', '\u0111': 'd',
    '\u0112': 'E',  '\u0114': 'E', '\u0116': 'E', '\u0118': 'E', '\u011a': 'E',
    '\u0113': 'e',  '\u0115': 'e', '\u0117': 'e', '\u0119': 'e', '\u011b': 'e',
    '\u011c': 'G',  '\u011e': 'G', '\u0120': 'G', '\u0122': 'G',
    '\u011d': 'g',  '\u011f': 'g', '\u0121': 'g', '\u0123': 'g',
    '\u0124': 'H',  '\u0126': 'H', '\u0125': 'h', '\u0127': 'h',
    '\u0128': 'I',  '\u012a': 'I', '\u012c': 'I', '\u012e': 'I', '\u0130': 'I',
    '\u0129': 'i',  '\u012b': 'i', '\u012d': 'i', '\u012f': 'i', '\u0131': 'i',
    '\u0134': 'J',  '\u0135': 'j',
    '\u0136': 'K',  '\u0137': 'k', '\u0138': 'k',
    '\u0139': 'L',  '\u013b': 'L', '\u013d': 'L', '\u013f': 'L', '\u0141': 'L',
    '\u013a': 'l',  '\u013c': 'l', '\u013e': 'l', '\u0140': 'l', '\u0142': 'l',
    '\u0143': 'N',  '\u0145': 'N', '\u0147': 'N', '\u014a': 'N',
    '\u0144': 'n',  '\u0146': 'n', '\u0148': 'n', '\u014b': 'n',
    '\u014c': 'O',  '\u014e': 'O', '\u0150': 'O',
    '\u014d': 'o',  '\u014f': 'o', '\u0151': 'o',
    '\u0154': 'R',  '\u0156': 'R', '\u0158': 'R',
    '\u0155': 'r',  '\u0157': 'r', '\u0159': 'r',
    '\u015a': 'S',  '\u015c': 'S', '\u015e': 'S', '\u0160': 'S',
    '\u015b': 's',  '\u015d': 's', '\u015f': 's', '\u0161': 's',
    '\u0162': 'T',  '\u0164': 'T', '\u0166': 'T',
    '\u0163': 't',  '\u0165': 't', '\u0167': 't',
    '\u0168': 'U',  '\u016a': 'U', '\u016c': 'U', '\u016e': 'U', '\u0170': 'U', '\u0172': 'U',
    '\u0169': 'u',  '\u016b': 'u', '\u016d': 'u', '\u016f': 'u', '\u0171': 'u', '\u0173': 'u',
    '\u0174': 'W',  '\u0175': 'w',
    '\u0176': 'Y',  '\u0177': 'y', '\u0178': 'Y',
    '\u0179': 'Z',  '\u017b': 'Z', '\u017d': 'Z',
    '\u017a': 'z',  '\u017c': 'z', '\u017e': 'z',
    '\u0132': 'IJ', '\u0133': 'ij',
    '\u0152': 'Oe', '\u0153': 'oe',
    '\u0149': "'n", '\u017f': 's'
  };

  /** Used to map characters to HTML entities. */
  var htmlEscapes = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#39;'
  };

  /** Used to map HTML entities to characters. */
  var htmlUnescapes = {
    '&amp;': '&',
    '&lt;': '<',
    '&gt;': '>',
    '&quot;': '"',
    '&#39;': "'"
  };

  /** Used to escape characters for inclusion in compiled string literals. */
  var stringEscapes = {
    '\\': '\\',
    "'": "'",
    '\n': 'n',
    '\r': 'r',
    '\u2028': 'u2028',
    '\u2029': 'u2029'
  };

  /** Built-in method references without a dependency on `root`. */
  var freeParseFloat = parseFloat,
      freeParseInt = parseInt;

  /** Detect free variable `global` from Node.js. */
  var freeGlobal = typeof __webpack_require__.g == 'object' && __webpack_require__.g && __webpack_require__.g.Object === Object && __webpack_require__.g;

  /** Detect free variable `self`. */
  var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

  /** Used as a reference to the global object. */
  var root = freeGlobal || freeSelf || Function('return this')();

  /** Detect free variable `exports`. */
  var freeExports =  true && exports && !exports.nodeType && exports;

  /** Detect free variable `module`. */
  var freeModule = freeExports && "object" == 'object' && module && !module.nodeType && module;

  /** Detect the popular CommonJS extension `module.exports`. */
  var moduleExports = freeModule && freeModule.exports === freeExports;

  /** Detect free variable `process` from Node.js. */
  var freeProcess = moduleExports && freeGlobal.process;

  /** Used to access faster Node.js helpers. */
  var nodeUtil = (function() {
    try {
      // Use `util.types` for Node.js 10+.
      var types = freeModule && freeModule.require && freeModule.require('util').types;

      if (types) {
        return types;
      }

      // Legacy `process.binding('util')` for Node.js < 10.
      return freeProcess && freeProcess.binding && freeProcess.binding('util');
    } catch (e) {}
  }());

  /* Node.js helper references. */
  var nodeIsArrayBuffer = nodeUtil && nodeUtil.isArrayBuffer,
      nodeIsDate = nodeUtil && nodeUtil.isDate,
      nodeIsMap = nodeUtil && nodeUtil.isMap,
      nodeIsRegExp = nodeUtil && nodeUtil.isRegExp,
      nodeIsSet = nodeUtil && nodeUtil.isSet,
      nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

  /*--------------------------------------------------------------------------*/

  /**
   * A faster alternative to `Function#apply`, this function invokes `func`
   * with the `this` binding of `thisArg` and the arguments of `args`.
   *
   * @private
   * @param {Function} func The function to invoke.
   * @param {*} thisArg The `this` binding of `func`.
   * @param {Array} args The arguments to invoke `func` with.
   * @returns {*} Returns the result of `func`.
   */
  function apply(func, thisArg, args) {
    switch (args.length) {
      case 0: return func.call(thisArg);
      case 1: return func.call(thisArg, args[0]);
      case 2: return func.call(thisArg, args[0], args[1]);
      case 3: return func.call(thisArg, args[0], args[1], args[2]);
    }
    return func.apply(thisArg, args);
  }

  /**
   * A specialized version of `baseAggregator` for arrays.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} setter The function to set `accumulator` values.
   * @param {Function} iteratee The iteratee to transform keys.
   * @param {Object} accumulator The initial aggregated object.
   * @returns {Function} Returns `accumulator`.
   */
  function arrayAggregator(array, setter, iteratee, accumulator) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      var value = array[index];
      setter(accumulator, value, iteratee(value), array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.forEach` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */
  function arrayEach(array, iteratee) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (iteratee(array[index], index, array) === false) {
        break;
      }
    }
    return array;
  }

  /**
   * A specialized version of `_.forEachRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */
  function arrayEachRight(array, iteratee) {
    var length = array == null ? 0 : array.length;

    while (length--) {
      if (iteratee(array[length], length, array) === false) {
        break;
      }
    }
    return array;
  }

  /**
   * A specialized version of `_.every` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if all elements pass the predicate check,
   *  else `false`.
   */
  function arrayEvery(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (!predicate(array[index], index, array)) {
        return false;
      }
    }
    return true;
  }

  /**
   * A specialized version of `_.filter` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {Array} Returns the new filtered array.
   */
  function arrayFilter(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length,
        resIndex = 0,
        result = [];

    while (++index < length) {
      var value = array[index];
      if (predicate(value, index, array)) {
        result[resIndex++] = value;
      }
    }
    return result;
  }

  /**
   * A specialized version of `_.includes` for arrays without support for
   * specifying an index to search from.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */
  function arrayIncludes(array, value) {
    var length = array == null ? 0 : array.length;
    return !!length && baseIndexOf(array, value, 0) > -1;
  }

  /**
   * This function is like `arrayIncludes` except that it accepts a comparator.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */
  function arrayIncludesWith(array, value, comparator) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (comparator(value, array[index])) {
        return true;
      }
    }
    return false;
  }

  /**
   * A specialized version of `_.map` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the new mapped array.
   */
  function arrayMap(array, iteratee) {
    var index = -1,
        length = array == null ? 0 : array.length,
        result = Array(length);

    while (++index < length) {
      result[index] = iteratee(array[index], index, array);
    }
    return result;
  }

  /**
   * Appends the elements of `values` to `array`.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {Array} values The values to append.
   * @returns {Array} Returns `array`.
   */
  function arrayPush(array, values) {
    var index = -1,
        length = values.length,
        offset = array.length;

    while (++index < length) {
      array[offset + index] = values[index];
    }
    return array;
  }

  /**
   * A specialized version of `_.reduce` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the first element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */
  function arrayReduce(array, iteratee, accumulator, initAccum) {
    var index = -1,
        length = array == null ? 0 : array.length;

    if (initAccum && length) {
      accumulator = array[++index];
    }
    while (++index < length) {
      accumulator = iteratee(accumulator, array[index], index, array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.reduceRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the last element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */
  function arrayReduceRight(array, iteratee, accumulator, initAccum) {
    var length = array == null ? 0 : array.length;
    if (initAccum && length) {
      accumulator = array[--length];
    }
    while (length--) {
      accumulator = iteratee(accumulator, array[length], length, array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.some` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if any element passes the predicate check,
   *  else `false`.
   */
  function arraySome(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (predicate(array[index], index, array)) {
        return true;
      }
    }
    return false;
  }

  /**
   * Gets the size of an ASCII `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */
  var asciiSize = baseProperty('length');

  /**
   * Converts an ASCII `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function asciiToArray(string) {
    return string.split('');
  }

  /**
   * Splits an ASCII `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */
  function asciiWords(string) {
    return string.match(reAsciiWord) || [];
  }

  /**
   * The base implementation of methods like `_.findKey` and `_.findLastKey`,
   * without support for iteratee shorthands, which iterates over `collection`
   * using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the found element or its key, else `undefined`.
   */
  function baseFindKey(collection, predicate, eachFunc) {
    var result;
    eachFunc(collection, function(value, key, collection) {
      if (predicate(value, key, collection)) {
        result = key;
        return false;
      }
    });
    return result;
  }

  /**
   * The base implementation of `_.findIndex` and `_.findLastIndex` without
   * support for iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {number} fromIndex The index to search from.
   * @param {boolean} [fromRight] Specify iterating from right to left.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseFindIndex(array, predicate, fromIndex, fromRight) {
    var length = array.length,
        index = fromIndex + (fromRight ? 1 : -1);

    while ((fromRight ? index-- : ++index < length)) {
      if (predicate(array[index], index, array)) {
        return index;
      }
    }
    return -1;
  }

  /**
   * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseIndexOf(array, value, fromIndex) {
    return value === value
      ? strictIndexOf(array, value, fromIndex)
      : baseFindIndex(array, baseIsNaN, fromIndex);
  }

  /**
   * This function is like `baseIndexOf` except that it accepts a comparator.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseIndexOfWith(array, value, fromIndex, comparator) {
    var index = fromIndex - 1,
        length = array.length;

    while (++index < length) {
      if (comparator(array[index], value)) {
        return index;
      }
    }
    return -1;
  }

  /**
   * The base implementation of `_.isNaN` without support for number objects.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
   */
  function baseIsNaN(value) {
    return value !== value;
  }

  /**
   * The base implementation of `_.mean` and `_.meanBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the mean.
   */
  function baseMean(array, iteratee) {
    var length = array == null ? 0 : array.length;
    return length ? (baseSum(array, iteratee) / length) : NAN;
  }

  /**
   * The base implementation of `_.property` without support for deep paths.
   *
   * @private
   * @param {string} key The key of the property to get.
   * @returns {Function} Returns the new accessor function.
   */
  function baseProperty(key) {
    return function(object) {
      return object == null ? undefined : object[key];
    };
  }

  /**
   * The base implementation of `_.propertyOf` without support for deep paths.
   *
   * @private
   * @param {Object} object The object to query.
   * @returns {Function} Returns the new accessor function.
   */
  function basePropertyOf(object) {
    return function(key) {
      return object == null ? undefined : object[key];
    };
  }

  /**
   * The base implementation of `_.reduce` and `_.reduceRight`, without support
   * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} accumulator The initial value.
   * @param {boolean} initAccum Specify using the first or last element of
   *  `collection` as the initial value.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the accumulated value.
   */
  function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
    eachFunc(collection, function(value, index, collection) {
      accumulator = initAccum
        ? (initAccum = false, value)
        : iteratee(accumulator, value, index, collection);
    });
    return accumulator;
  }

  /**
   * The base implementation of `_.sortBy` which uses `comparer` to define the
   * sort order of `array` and replaces criteria objects with their corresponding
   * values.
   *
   * @private
   * @param {Array} array The array to sort.
   * @param {Function} comparer The function to define sort order.
   * @returns {Array} Returns `array`.
   */
  function baseSortBy(array, comparer) {
    var length = array.length;

    array.sort(comparer);
    while (length--) {
      array[length] = array[length].value;
    }
    return array;
  }

  /**
   * The base implementation of `_.sum` and `_.sumBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the sum.
   */
  function baseSum(array, iteratee) {
    var result,
        index = -1,
        length = array.length;

    while (++index < length) {
      var current = iteratee(array[index]);
      if (current !== undefined) {
        result = result === undefined ? current : (result + current);
      }
    }
    return result;
  }

  /**
   * The base implementation of `_.times` without support for iteratee shorthands
   * or max array length checks.
   *
   * @private
   * @param {number} n The number of times to invoke `iteratee`.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the array of results.
   */
  function baseTimes(n, iteratee) {
    var index = -1,
        result = Array(n);

    while (++index < n) {
      result[index] = iteratee(index);
    }
    return result;
  }

  /**
   * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
   * of key-value pairs for `object` corresponding to the property names of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the key-value pairs.
   */
  function baseToPairs(object, props) {
    return arrayMap(props, function(key) {
      return [key, object[key]];
    });
  }

  /**
   * The base implementation of `_.trim`.
   *
   * @private
   * @param {string} string The string to trim.
   * @returns {string} Returns the trimmed string.
   */
  function baseTrim(string) {
    return string
      ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, '')
      : string;
  }

  /**
   * The base implementation of `_.unary` without support for storing metadata.
   *
   * @private
   * @param {Function} func The function to cap arguments for.
   * @returns {Function} Returns the new capped function.
   */
  function baseUnary(func) {
    return function(value) {
      return func(value);
    };
  }

  /**
   * The base implementation of `_.values` and `_.valuesIn` which creates an
   * array of `object` property values corresponding to the property names
   * of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the array of property values.
   */
  function baseValues(object, props) {
    return arrayMap(props, function(key) {
      return object[key];
    });
  }

  /**
   * Checks if a `cache` value for `key` exists.
   *
   * @private
   * @param {Object} cache The cache to query.
   * @param {string} key The key of the entry to check.
   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
   */
  function cacheHas(cache, key) {
    return cache.has(key);
  }

  /**
   * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the first unmatched string symbol.
   */
  function charsStartIndex(strSymbols, chrSymbols) {
    var index = -1,
        length = strSymbols.length;

    while (++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
    return index;
  }

  /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the last unmatched string symbol.
   */
  function charsEndIndex(strSymbols, chrSymbols) {
    var index = strSymbols.length;

    while (index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
    return index;
  }

  /**
   * Gets the number of `placeholder` occurrences in `array`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} placeholder The placeholder to search for.
   * @returns {number} Returns the placeholder count.
   */
  function countHolders(array, placeholder) {
    var length = array.length,
        result = 0;

    while (length--) {
      if (array[length] === placeholder) {
        ++result;
      }
    }
    return result;
  }

  /**
   * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
   * letters to basic Latin letters.
   *
   * @private
   * @param {string} letter The matched letter to deburr.
   * @returns {string} Returns the deburred letter.
   */
  var deburrLetter = basePropertyOf(deburredLetters);

  /**
   * Used by `_.escape` to convert characters to HTML entities.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */
  var escapeHtmlChar = basePropertyOf(htmlEscapes);

  /**
   * Used by `_.template` to escape characters for inclusion in compiled string literals.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */
  function escapeStringChar(chr) {
    return '\\' + stringEscapes[chr];
  }

  /**
   * Gets the value at `key` of `object`.
   *
   * @private
   * @param {Object} [object] The object to query.
   * @param {string} key The key of the property to get.
   * @returns {*} Returns the property value.
   */
  function getValue(object, key) {
    return object == null ? undefined : object[key];
  }

  /**
   * Checks if `string` contains Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a symbol is found, else `false`.
   */
  function hasUnicode(string) {
    return reHasUnicode.test(string);
  }

  /**
   * Checks if `string` contains a word composed of Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a word is found, else `false`.
   */
  function hasUnicodeWord(string) {
    return reHasUnicodeWord.test(string);
  }

  /**
   * Converts `iterator` to an array.
   *
   * @private
   * @param {Object} iterator The iterator to convert.
   * @returns {Array} Returns the converted array.
   */
  function iteratorToArray(iterator) {
    var data,
        result = [];

    while (!(data = iterator.next()).done) {
      result.push(data.value);
    }
    return result;
  }

  /**
   * Converts `map` to its key-value pairs.
   *
   * @private
   * @param {Object} map The map to convert.
   * @returns {Array} Returns the key-value pairs.
   */
  function mapToArray(map) {
    var index = -1,
        result = Array(map.size);

    map.forEach(function(value, key) {
      result[++index] = [key, value];
    });
    return result;
  }

  /**
   * Creates a unary function that invokes `func` with its argument transformed.
   *
   * @private
   * @param {Function} func The function to wrap.
   * @param {Function} transform The argument transform.
   * @returns {Function} Returns the new function.
   */
  function overArg(func, transform) {
    return function(arg) {
      return func(transform(arg));
    };
  }

  /**
   * Replaces all `placeholder` elements in `array` with an internal placeholder
   * and returns an array of their indexes.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {*} placeholder The placeholder to replace.
   * @returns {Array} Returns the new array of placeholder indexes.
   */
  function replaceHolders(array, placeholder) {
    var index = -1,
        length = array.length,
        resIndex = 0,
        result = [];

    while (++index < length) {
      var value = array[index];
      if (value === placeholder || value === PLACEHOLDER) {
        array[index] = PLACEHOLDER;
        result[resIndex++] = index;
      }
    }
    return result;
  }

  /**
   * Converts `set` to an array of its values.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the values.
   */
  function setToArray(set) {
    var index = -1,
        result = Array(set.size);

    set.forEach(function(value) {
      result[++index] = value;
    });
    return result;
  }

  /**
   * Converts `set` to its value-value pairs.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the value-value pairs.
   */
  function setToPairs(set) {
    var index = -1,
        result = Array(set.size);

    set.forEach(function(value) {
      result[++index] = [value, value];
    });
    return result;
  }

  /**
   * A specialized version of `_.indexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function strictIndexOf(array, value, fromIndex) {
    var index = fromIndex - 1,
        length = array.length;

    while (++index < length) {
      if (array[index] === value) {
        return index;
      }
    }
    return -1;
  }

  /**
   * A specialized version of `_.lastIndexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function strictLastIndexOf(array, value, fromIndex) {
    var index = fromIndex + 1;
    while (index--) {
      if (array[index] === value) {
        return index;
      }
    }
    return index;
  }

  /**
   * Gets the number of symbols in `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the string size.
   */
  function stringSize(string) {
    return hasUnicode(string)
      ? unicodeSize(string)
      : asciiSize(string);
  }

  /**
   * Converts `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function stringToArray(string) {
    return hasUnicode(string)
      ? unicodeToArray(string)
      : asciiToArray(string);
  }

  /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
   * character of `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the index of the last non-whitespace character.
   */
  function trimmedEndIndex(string) {
    var index = string.length;

    while (index-- && reWhitespace.test(string.charAt(index))) {}
    return index;
  }

  /**
   * Used by `_.unescape` to convert HTML entities to characters.
   *
   * @private
   * @param {string} chr The matched character to unescape.
   * @returns {string} Returns the unescaped character.
   */
  var unescapeHtmlChar = basePropertyOf(htmlUnescapes);

  /**
   * Gets the size of a Unicode `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */
  function unicodeSize(string) {
    var result = reUnicode.lastIndex = 0;
    while (reUnicode.test(string)) {
      ++result;
    }
    return result;
  }

  /**
   * Converts a Unicode `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function unicodeToArray(string) {
    return string.match(reUnicode) || [];
  }

  /**
   * Splits a Unicode `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */
  function unicodeWords(string) {
    return string.match(reUnicodeWord) || [];
  }

  /*--------------------------------------------------------------------------*/

  /**
   * Create a new pristine `lodash` function using the `context` object.
   *
   * @static
   * @memberOf _
   * @since 1.1.0
   * @category Util
   * @param {Object} [context=root] The context object.
   * @returns {Function} Returns a new `lodash` function.
   * @example
   *
   * _.mixin({ 'foo': _.constant('foo') });
   *
   * var lodash = _.runInContext();
   * lodash.mixin({ 'bar': lodash.constant('bar') });
   *
   * _.isFunction(_.foo);
   * // => true
   * _.isFunction(_.bar);
   * // => false
   *
   * lodash.isFunction(lodash.foo);
   * // => false
   * lodash.isFunction(lodash.bar);
   * // => true
   *
   * // Create a suped-up `defer` in Node.js.
   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
   */
  var runInContext = (function runInContext(context) {
    context = context == null ? root : _.defaults(root.Object(), context, _.pick(root, contextProps));

    /** Built-in constructor references. */
    var Array = context.Array,
        Date = context.Date,
        Error = context.Error,
        Function = context.Function,
        Math = context.Math,
        Object = context.Object,
        RegExp = context.RegExp,
        String = context.String,
        TypeError = context.TypeError;

    /** Used for built-in method references. */
    var arrayProto = Array.prototype,
        funcProto = Function.prototype,
        objectProto = Object.prototype;

    /** Used to detect overreaching core-js shims. */
    var coreJsData = context['__core-js_shared__'];

    /** Used to resolve the decompiled source of functions. */
    var funcToString = funcProto.toString;

    /** Used to check objects for own properties. */
    var hasOwnProperty = objectProto.hasOwnProperty;

    /** Used to generate unique IDs. */
    var idCounter = 0;

    /** Used to detect methods masquerading as native. */
    var maskSrcKey = (function() {
      var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
      return uid ? ('Symbol(src)_1.' + uid) : '';
    }());

    /**
     * Used to resolve the
     * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
     * of values.
     */
    var nativeObjectToString = objectProto.toString;

    /** Used to infer the `Object` constructor. */
    var objectCtorString = funcToString.call(Object);

    /** Used to restore the original `_` reference in `_.noConflict`. */
    var oldDash = root._;

    /** Used to detect if a method is native. */
    var reIsNative = RegExp('^' +
      funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
      .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
    );

    /** Built-in value references. */
    var Buffer = moduleExports ? context.Buffer : undefined,
        Symbol = context.Symbol,
        Uint8Array = context.Uint8Array,
        allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined,
        getPrototype = overArg(Object.getPrototypeOf, Object),
        objectCreate = Object.create,
        propertyIsEnumerable = objectProto.propertyIsEnumerable,
        splice = arrayProto.splice,
        spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined,
        symIterator = Symbol ? Symbol.iterator : undefined,
        symToStringTag = Symbol ? Symbol.toStringTag : undefined;

    var defineProperty = (function() {
      try {
        var func = getNative(Object, 'defineProperty');
        func({}, '', {});
        return func;
      } catch (e) {}
    }());

    /** Mocked built-ins. */
    var ctxClearTimeout = context.clearTimeout !== root.clearTimeout && context.clearTimeout,
        ctxNow = Date && Date.now !== root.Date.now && Date.now,
        ctxSetTimeout = context.setTimeout !== root.setTimeout && context.setTimeout;

    /* Built-in method references for those with the same name as other `lodash` methods. */
    var nativeCeil = Math.ceil,
        nativeFloor = Math.floor,
        nativeGetSymbols = Object.getOwnPropertySymbols,
        nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined,
        nativeIsFinite = context.isFinite,
        nativeJoin = arrayProto.join,
        nativeKeys = overArg(Object.keys, Object),
        nativeMax = Math.max,
        nativeMin = Math.min,
        nativeNow = Date.now,
        nativeParseInt = context.parseInt,
        nativeRandom = Math.random,
        nativeReverse = arrayProto.reverse;

    /* Built-in method references that are verified to be native. */
    var DataView = getNative(context, 'DataView'),
        Map = getNative(context, 'Map'),
        Promise = getNative(context, 'Promise'),
        Set = getNative(context, 'Set'),
        WeakMap = getNative(context, 'WeakMap'),
        nativeCreate = getNative(Object, 'create');

    /** Used to store function metadata. */
    var metaMap = WeakMap && new WeakMap;

    /** Used to lookup unminified function names. */
    var realNames = {};

    /** Used to detect maps, sets, and weakmaps. */
    var dataViewCtorString = toSource(DataView),
        mapCtorString = toSource(Map),
        promiseCtorString = toSource(Promise),
        setCtorString = toSource(Set),
        weakMapCtorString = toSource(WeakMap);

    /** Used to convert symbols to primitives and strings. */
    var symbolProto = Symbol ? Symbol.prototype : undefined,
        symbolValueOf = symbolProto ? symbolProto.valueOf : undefined,
        symbolToString = symbolProto ? symbolProto.toString : undefined;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a `lodash` object which wraps `value` to enable implicit method
     * chain sequences. Methods that operate on and return arrays, collections,
     * and functions can be chained together. Methods that retrieve a single value
     * or may return a primitive value will automatically end the chain sequence
     * and return the unwrapped value. Otherwise, the value must be unwrapped
     * with `_#value`.
     *
     * Explicit chain sequences, which must be unwrapped with `_#value`, may be
     * enabled using `_.chain`.
     *
     * The execution of chained methods is lazy, that is, it's deferred until
     * `_#value` is implicitly or explicitly called.
     *
     * Lazy evaluation allows several methods to support shortcut fusion.
     * Shortcut fusion is an optimization to merge iteratee calls; this avoids
     * the creation of intermediate arrays and can greatly reduce the number of
     * iteratee executions. Sections of a chain sequence qualify for shortcut
     * fusion if the section is applied to an array and iteratees accept only
     * one argument. The heuristic for whether a section qualifies for shortcut
     * fusion is subject to change.
     *
     * Chaining is supported in custom builds as long as the `_#value` method is
     * directly or indirectly included in the build.
     *
     * In addition to lodash methods, wrappers have `Array` and `String` methods.
     *
     * The wrapper `Array` methods are:
     * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
     *
     * The wrapper `String` methods are:
     * `replace` and `split`
     *
     * The wrapper methods that support shortcut fusion are:
     * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
     * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
     * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
     *
     * The chainable wrapper methods are:
     * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
     * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
     * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
     * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
     * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
     * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
     * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
     * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
     * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
     * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
     * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
     * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
     * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
     * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
     * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
     * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
     * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
     * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
     * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
     * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
     * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
     * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
     * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
     * `zipObject`, `zipObjectDeep`, and `zipWith`
     *
     * The wrapper methods that are **not** chainable by default are:
     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
     * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
     * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
     * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
     * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
     * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
     * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
     * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
     * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
     * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
     * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
     * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
     * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
     * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
     * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
     * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
     * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
     * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
     * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
     * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
     * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
     * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
     * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
     * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
     * `upperFirst`, `value`, and `words`
     *
     * @name _
     * @constructor
     * @category Seq
     * @param {*} value The value to wrap in a `lodash` instance.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2, 3]);
     *
     * // Returns an unwrapped value.
     * wrapped.reduce(_.add);
     * // => 6
     *
     * // Returns a wrapped value.
     * var squares = wrapped.map(square);
     *
     * _.isArray(squares);
     * // => false
     *
     * _.isArray(squares.value());
     * // => true
     */
    function lodash(value) {
      if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
        if (value instanceof LodashWrapper) {
          return value;
        }
        if (hasOwnProperty.call(value, '__wrapped__')) {
          return wrapperClone(value);
        }
      }
      return new LodashWrapper(value);
    }

    /**
     * The base implementation of `_.create` without support for assigning
     * properties to the created object.
     *
     * @private
     * @param {Object} proto The object to inherit from.
     * @returns {Object} Returns the new object.
     */
    var baseCreate = (function() {
      function object() {}
      return function(proto) {
        if (!isObject(proto)) {
          return {};
        }
        if (objectCreate) {
          return objectCreate(proto);
        }
        object.prototype = proto;
        var result = new object;
        object.prototype = undefined;
        return result;
      };
    }());

    /**
     * The function whose prototype chain sequence wrappers inherit from.
     *
     * @private
     */
    function baseLodash() {
      // No operation performed.
    }

    /**
     * The base constructor for creating `lodash` wrapper objects.
     *
     * @private
     * @param {*} value The value to wrap.
     * @param {boolean} [chainAll] Enable explicit method chain sequences.
     */
    function LodashWrapper(value, chainAll) {
      this.__wrapped__ = value;
      this.__actions__ = [];
      this.__chain__ = !!chainAll;
      this.__index__ = 0;
      this.__values__ = undefined;
    }

    /**
     * By default, the template delimiters used by lodash are like those in
     * embedded Ruby (ERB) as well as ES2015 template strings. Change the
     * following template settings to use alternative delimiters.
     *
     * @static
     * @memberOf _
     * @type {Object}
     */
    lodash.templateSettings = {

      /**
       * Used to detect `data` property values to be HTML-escaped.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'escape': reEscape,

      /**
       * Used to detect code to be evaluated.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'evaluate': reEvaluate,

      /**
       * Used to detect `data` property values to inject.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'interpolate': reInterpolate,

      /**
       * Used to reference the data object in the template text.
       *
       * @memberOf _.templateSettings
       * @type {string}
       */
      'variable': '',

      /**
       * Used to import variables into the compiled template.
       *
       * @memberOf _.templateSettings
       * @type {Object}
       */
      'imports': {

        /**
         * A reference to the `lodash` function.
         *
         * @memberOf _.templateSettings.imports
         * @type {Function}
         */
        '_': lodash
      }
    };

    // Ensure wrappers are instances of `baseLodash`.
    lodash.prototype = baseLodash.prototype;
    lodash.prototype.constructor = lodash;

    LodashWrapper.prototype = baseCreate(baseLodash.prototype);
    LodashWrapper.prototype.constructor = LodashWrapper;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
     *
     * @private
     * @constructor
     * @param {*} value The value to wrap.
     */
    function LazyWrapper(value) {
      this.__wrapped__ = value;
      this.__actions__ = [];
      this.__dir__ = 1;
      this.__filtered__ = false;
      this.__iteratees__ = [];
      this.__takeCount__ = MAX_ARRAY_LENGTH;
      this.__views__ = [];
    }

    /**
     * Creates a clone of the lazy wrapper object.
     *
     * @private
     * @name clone
     * @memberOf LazyWrapper
     * @returns {Object} Returns the cloned `LazyWrapper` object.
     */
    function lazyClone() {
      var result = new LazyWrapper(this.__wrapped__);
      result.__actions__ = copyArray(this.__actions__);
      result.__dir__ = this.__dir__;
      result.__filtered__ = this.__filtered__;
      result.__iteratees__ = copyArray(this.__iteratees__);
      result.__takeCount__ = this.__takeCount__;
      result.__views__ = copyArray(this.__views__);
      return result;
    }

    /**
     * Reverses the direction of lazy iteration.
     *
     * @private
     * @name reverse
     * @memberOf LazyWrapper
     * @returns {Object} Returns the new reversed `LazyWrapper` object.
     */
    function lazyReverse() {
      if (this.__filtered__) {
        var result = new LazyWrapper(this);
        result.__dir__ = -1;
        result.__filtered__ = true;
      } else {
        result = this.clone();
        result.__dir__ *= -1;
      }
      return result;
    }

    /**
     * Extracts the unwrapped value from its lazy wrapper.
     *
     * @private
     * @name value
     * @memberOf LazyWrapper
     * @returns {*} Returns the unwrapped value.
     */
    function lazyValue() {
      var array = this.__wrapped__.value(),
          dir = this.__dir__,
          isArr = isArray(array),
          isRight = dir < 0,
          arrLength = isArr ? array.length : 0,
          view = getView(0, arrLength, this.__views__),
          start = view.start,
          end = view.end,
          length = end - start,
          index = isRight ? end : (start - 1),
          iteratees = this.__iteratees__,
          iterLength = iteratees.length,
          resIndex = 0,
          takeCount = nativeMin(length, this.__takeCount__);

      if (!isArr || (!isRight && arrLength == length && takeCount == length)) {
        return baseWrapperValue(array, this.__actions__);
      }
      var result = [];

      outer:
      while (length-- && resIndex < takeCount) {
        index += dir;

        var iterIndex = -1,
            value = array[index];

        while (++iterIndex < iterLength) {
          var data = iteratees[iterIndex],
              iteratee = data.iteratee,
              type = data.type,
              computed = iteratee(value);

          if (type == LAZY_MAP_FLAG) {
            value = computed;
          } else if (!computed) {
            if (type == LAZY_FILTER_FLAG) {
              continue outer;
            } else {
              break outer;
            }
          }
        }
        result[resIndex++] = value;
      }
      return result;
    }

    // Ensure `LazyWrapper` is an instance of `baseLodash`.
    LazyWrapper.prototype = baseCreate(baseLodash.prototype);
    LazyWrapper.prototype.constructor = LazyWrapper;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a hash object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function Hash(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the hash.
     *
     * @private
     * @name clear
     * @memberOf Hash
     */
    function hashClear() {
      this.__data__ = nativeCreate ? nativeCreate(null) : {};
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the hash.
     *
     * @private
     * @name delete
     * @memberOf Hash
     * @param {Object} hash The hash to modify.
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function hashDelete(key) {
      var result = this.has(key) && delete this.__data__[key];
      this.size -= result ? 1 : 0;
      return result;
    }

    /**
     * Gets the hash value for `key`.
     *
     * @private
     * @name get
     * @memberOf Hash
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function hashGet(key) {
      var data = this.__data__;
      if (nativeCreate) {
        var result = data[key];
        return result === HASH_UNDEFINED ? undefined : result;
      }
      return hasOwnProperty.call(data, key) ? data[key] : undefined;
    }

    /**
     * Checks if a hash value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Hash
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function hashHas(key) {
      var data = this.__data__;
      return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
    }

    /**
     * Sets the hash `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Hash
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the hash instance.
     */
    function hashSet(key, value) {
      var data = this.__data__;
      this.size += this.has(key) ? 0 : 1;
      data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
      return this;
    }

    // Add methods to `Hash`.
    Hash.prototype.clear = hashClear;
    Hash.prototype['delete'] = hashDelete;
    Hash.prototype.get = hashGet;
    Hash.prototype.has = hashHas;
    Hash.prototype.set = hashSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates an list cache object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function ListCache(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the list cache.
     *
     * @private
     * @name clear
     * @memberOf ListCache
     */
    function listCacheClear() {
      this.__data__ = [];
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the list cache.
     *
     * @private
     * @name delete
     * @memberOf ListCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function listCacheDelete(key) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      if (index < 0) {
        return false;
      }
      var lastIndex = data.length - 1;
      if (index == lastIndex) {
        data.pop();
      } else {
        splice.call(data, index, 1);
      }
      --this.size;
      return true;
    }

    /**
     * Gets the list cache value for `key`.
     *
     * @private
     * @name get
     * @memberOf ListCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function listCacheGet(key) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      return index < 0 ? undefined : data[index][1];
    }

    /**
     * Checks if a list cache value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf ListCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function listCacheHas(key) {
      return assocIndexOf(this.__data__, key) > -1;
    }

    /**
     * Sets the list cache `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf ListCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the list cache instance.
     */
    function listCacheSet(key, value) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      if (index < 0) {
        ++this.size;
        data.push([key, value]);
      } else {
        data[index][1] = value;
      }
      return this;
    }

    // Add methods to `ListCache`.
    ListCache.prototype.clear = listCacheClear;
    ListCache.prototype['delete'] = listCacheDelete;
    ListCache.prototype.get = listCacheGet;
    ListCache.prototype.has = listCacheHas;
    ListCache.prototype.set = listCacheSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a map cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function MapCache(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the map.
     *
     * @private
     * @name clear
     * @memberOf MapCache
     */
    function mapCacheClear() {
      this.size = 0;
      this.__data__ = {
        'hash': new Hash,
        'map': new (Map || ListCache),
        'string': new Hash
      };
    }

    /**
     * Removes `key` and its value from the map.
     *
     * @private
     * @name delete
     * @memberOf MapCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function mapCacheDelete(key) {
      var result = getMapData(this, key)['delete'](key);
      this.size -= result ? 1 : 0;
      return result;
    }

    /**
     * Gets the map value for `key`.
     *
     * @private
     * @name get
     * @memberOf MapCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function mapCacheGet(key) {
      return getMapData(this, key).get(key);
    }

    /**
     * Checks if a map value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf MapCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function mapCacheHas(key) {
      return getMapData(this, key).has(key);
    }

    /**
     * Sets the map `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf MapCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the map cache instance.
     */
    function mapCacheSet(key, value) {
      var data = getMapData(this, key),
          size = data.size;

      data.set(key, value);
      this.size += data.size == size ? 0 : 1;
      return this;
    }

    // Add methods to `MapCache`.
    MapCache.prototype.clear = mapCacheClear;
    MapCache.prototype['delete'] = mapCacheDelete;
    MapCache.prototype.get = mapCacheGet;
    MapCache.prototype.has = mapCacheHas;
    MapCache.prototype.set = mapCacheSet;

    /*------------------------------------------------------------------------*/

    /**
     *
     * Creates an array cache object to store unique values.
     *
     * @private
     * @constructor
     * @param {Array} [values] The values to cache.
     */
    function SetCache(values) {
      var index = -1,
          length = values == null ? 0 : values.length;

      this.__data__ = new MapCache;
      while (++index < length) {
        this.add(values[index]);
      }
    }

    /**
     * Adds `value` to the array cache.
     *
     * @private
     * @name add
     * @memberOf SetCache
     * @alias push
     * @param {*} value The value to cache.
     * @returns {Object} Returns the cache instance.
     */
    function setCacheAdd(value) {
      this.__data__.set(value, HASH_UNDEFINED);
      return this;
    }

    /**
     * Checks if `value` is in the array cache.
     *
     * @private
     * @name has
     * @memberOf SetCache
     * @param {*} value The value to search for.
     * @returns {number} Returns `true` if `value` is found, else `false`.
     */
    function setCacheHas(value) {
      return this.__data__.has(value);
    }

    // Add methods to `SetCache`.
    SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
    SetCache.prototype.has = setCacheHas;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a stack cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function Stack(entries) {
      var data = this.__data__ = new ListCache(entries);
      this.size = data.size;
    }

    /**
     * Removes all key-value entries from the stack.
     *
     * @private
     * @name clear
     * @memberOf Stack
     */
    function stackClear() {
      this.__data__ = new ListCache;
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the stack.
     *
     * @private
     * @name delete
     * @memberOf Stack
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function stackDelete(key) {
      var data = this.__data__,
          result = data['delete'](key);

      this.size = data.size;
      return result;
    }

    /**
     * Gets the stack value for `key`.
     *
     * @private
     * @name get
     * @memberOf Stack
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function stackGet(key) {
      return this.__data__.get(key);
    }

    /**
     * Checks if a stack value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Stack
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function stackHas(key) {
      return this.__data__.has(key);
    }

    /**
     * Sets the stack `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Stack
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the stack cache instance.
     */
    function stackSet(key, value) {
      var data = this.__data__;
      if (data instanceof ListCache) {
        var pairs = data.__data__;
        if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
          pairs.push([key, value]);
          this.size = ++data.size;
          return this;
        }
        data = this.__data__ = new MapCache(pairs);
      }
      data.set(key, value);
      this.size = data.size;
      return this;
    }

    // Add methods to `Stack`.
    Stack.prototype.clear = stackClear;
    Stack.prototype['delete'] = stackDelete;
    Stack.prototype.get = stackGet;
    Stack.prototype.has = stackHas;
    Stack.prototype.set = stackSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates an array of the enumerable property names of the array-like `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @param {boolean} inherited Specify returning inherited property names.
     * @returns {Array} Returns the array of property names.
     */
    function arrayLikeKeys(value, inherited) {
      var isArr = isArray(value),
          isArg = !isArr && isArguments(value),
          isBuff = !isArr && !isArg && isBuffer(value),
          isType = !isArr && !isArg && !isBuff && isTypedArray(value),
          skipIndexes = isArr || isArg || isBuff || isType,
          result = skipIndexes ? baseTimes(value.length, String) : [],
          length = result.length;

      for (var key in value) {
        if ((inherited || hasOwnProperty.call(value, key)) &&
            !(skipIndexes && (
               // Safari 9 has enumerable `arguments.length` in strict mode.
               key == 'length' ||
               // Node.js 0.10 has enumerable non-index properties on buffers.
               (isBuff && (key == 'offset' || key == 'parent')) ||
               // PhantomJS 2 has enumerable non-index properties on typed arrays.
               (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
               // Skip index properties.
               isIndex(key, length)
            ))) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * A specialized version of `_.sample` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @returns {*} Returns the random element.
     */
    function arraySample(array) {
      var length = array.length;
      return length ? array[baseRandom(0, length - 1)] : undefined;
    }

    /**
     * A specialized version of `_.sampleSize` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */
    function arraySampleSize(array, n) {
      return shuffleSelf(copyArray(array), baseClamp(n, 0, array.length));
    }

    /**
     * A specialized version of `_.shuffle` for arrays.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */
    function arrayShuffle(array) {
      return shuffleSelf(copyArray(array));
    }

    /**
     * This function is like `assignValue` except that it doesn't assign
     * `undefined` values.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function assignMergeValue(object, key, value) {
      if ((value !== undefined && !eq(object[key], value)) ||
          (value === undefined && !(key in object))) {
        baseAssignValue(object, key, value);
      }
    }

    /**
     * Assigns `value` to `key` of `object` if the existing value is not equivalent
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function assignValue(object, key, value) {
      var objValue = object[key];
      if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
          (value === undefined && !(key in object))) {
        baseAssignValue(object, key, value);
      }
    }

    /**
     * Gets the index at which the `key` is found in `array` of key-value pairs.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {*} key The key to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     */
    function assocIndexOf(array, key) {
      var length = array.length;
      while (length--) {
        if (eq(array[length][0], key)) {
          return length;
        }
      }
      return -1;
    }

    /**
     * Aggregates elements of `collection` on `accumulator` with keys transformed
     * by `iteratee` and values set by `setter`.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform keys.
     * @param {Object} accumulator The initial aggregated object.
     * @returns {Function} Returns `accumulator`.
     */
    function baseAggregator(collection, setter, iteratee, accumulator) {
      baseEach(collection, function(value, key, collection) {
        setter(accumulator, value, iteratee(value), collection);
      });
      return accumulator;
    }

    /**
     * The base implementation of `_.assign` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */
    function baseAssign(object, source) {
      return object && copyObject(source, keys(source), object);
    }

    /**
     * The base implementation of `_.assignIn` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */
    function baseAssignIn(object, source) {
      return object && copyObject(source, keysIn(source), object);
    }

    /**
     * The base implementation of `assignValue` and `assignMergeValue` without
     * value checks.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function baseAssignValue(object, key, value) {
      if (key == '__proto__' && defineProperty) {
        defineProperty(object, key, {
          'configurable': true,
          'enumerable': true,
          'value': value,
          'writable': true
        });
      } else {
        object[key] = value;
      }
    }

    /**
     * The base implementation of `_.at` without support for individual paths.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {string[]} paths The property paths to pick.
     * @returns {Array} Returns the picked elements.
     */
    function baseAt(object, paths) {
      var index = -1,
          length = paths.length,
          result = Array(length),
          skip = object == null;

      while (++index < length) {
        result[index] = skip ? undefined : get(object, paths[index]);
      }
      return result;
    }

    /**
     * The base implementation of `_.clamp` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     */
    function baseClamp(number, lower, upper) {
      if (number === number) {
        if (upper !== undefined) {
          number = number <= upper ? number : upper;
        }
        if (lower !== undefined) {
          number = number >= lower ? number : lower;
        }
      }
      return number;
    }

    /**
     * The base implementation of `_.clone` and `_.cloneDeep` which tracks
     * traversed objects.
     *
     * @private
     * @param {*} value The value to clone.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Deep clone
     *  2 - Flatten inherited properties
     *  4 - Clone symbols
     * @param {Function} [customizer] The function to customize cloning.
     * @param {string} [key] The key of `value`.
     * @param {Object} [object] The parent object of `value`.
     * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
     * @returns {*} Returns the cloned value.
     */
    function baseClone(value, bitmask, customizer, key, object, stack) {
      var result,
          isDeep = bitmask & CLONE_DEEP_FLAG,
          isFlat = bitmask & CLONE_FLAT_FLAG,
          isFull = bitmask & CLONE_SYMBOLS_FLAG;

      if (customizer) {
        result = object ? customizer(value, key, object, stack) : customizer(value);
      }
      if (result !== undefined) {
        return result;
      }
      if (!isObject(value)) {
        return value;
      }
      var isArr = isArray(value);
      if (isArr) {
        result = initCloneArray(value);
        if (!isDeep) {
          return copyArray(value, result);
        }
      } else {
        var tag = getTag(value),
            isFunc = tag == funcTag || tag == genTag;

        if (isBuffer(value)) {
          return cloneBuffer(value, isDeep);
        }
        if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
          result = (isFlat || isFunc) ? {} : initCloneObject(value);
          if (!isDeep) {
            return isFlat
              ? copySymbolsIn(value, baseAssignIn(result, value))
              : copySymbols(value, baseAssign(result, value));
          }
        } else {
          if (!cloneableTags[tag]) {
            return object ? value : {};
          }
          result = initCloneByTag(value, tag, isDeep);
        }
      }
      // Check for circular references and return its corresponding clone.
      stack || (stack = new Stack);
      var stacked = stack.get(value);
      if (stacked) {
        return stacked;
      }
      stack.set(value, result);

      if (isSet(value)) {
        value.forEach(function(subValue) {
          result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
        });
      } else if (isMap(value)) {
        value.forEach(function(subValue, key) {
          result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
        });
      }

      var keysFunc = isFull
        ? (isFlat ? getAllKeysIn : getAllKeys)
        : (isFlat ? keysIn : keys);

      var props = isArr ? undefined : keysFunc(value);
      arrayEach(props || value, function(subValue, key) {
        if (props) {
          key = subValue;
          subValue = value[key];
        }
        // Recursively populate clone (susceptible to call stack limits).
        assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
      });
      return result;
    }

    /**
     * The base implementation of `_.conforms` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     */
    function baseConforms(source) {
      var props = keys(source);
      return function(object) {
        return baseConformsTo(object, source, props);
      };
    }

    /**
     * The base implementation of `_.conformsTo` which accepts `props` to check.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     */
    function baseConformsTo(object, source, props) {
      var length = props.length;
      if (object == null) {
        return !length;
      }
      object = Object(object);
      while (length--) {
        var key = props[length],
            predicate = source[key],
            value = object[key];

        if ((value === undefined && !(key in object)) || !predicate(value)) {
          return false;
        }
      }
      return true;
    }

    /**
     * The base implementation of `_.delay` and `_.defer` which accepts `args`
     * to provide to `func`.
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {Array} args The arguments to provide to `func`.
     * @returns {number|Object} Returns the timer id or timeout object.
     */
    function baseDelay(func, wait, args) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      return setTimeout(function() { func.apply(undefined, args); }, wait);
    }

    /**
     * The base implementation of methods like `_.difference` without support
     * for excluding multiple arrays or iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Array} values The values to exclude.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     */
    function baseDifference(array, values, iteratee, comparator) {
      var index = -1,
          includes = arrayIncludes,
          isCommon = true,
          length = array.length,
          result = [],
          valuesLength = values.length;

      if (!length) {
        return result;
      }
      if (iteratee) {
        values = arrayMap(values, baseUnary(iteratee));
      }
      if (comparator) {
        includes = arrayIncludesWith;
        isCommon = false;
      }
      else if (values.length >= LARGE_ARRAY_SIZE) {
        includes = cacheHas;
        isCommon = false;
        values = new SetCache(values);
      }
      outer:
      while (++index < length) {
        var value = array[index],
            computed = iteratee == null ? value : iteratee(value);

        value = (comparator || value !== 0) ? value : 0;
        if (isCommon && computed === computed) {
          var valuesIndex = valuesLength;
          while (valuesIndex--) {
            if (values[valuesIndex] === computed) {
              continue outer;
            }
          }
          result.push(value);
        }
        else if (!includes(values, computed, comparator)) {
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.forEach` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */
    var baseEach = createBaseEach(baseForOwn);

    /**
     * The base implementation of `_.forEachRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */
    var baseEachRight = createBaseEach(baseForOwnRight, true);

    /**
     * The base implementation of `_.every` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`
     */
    function baseEvery(collection, predicate) {
      var result = true;
      baseEach(collection, function(value, index, collection) {
        result = !!predicate(value, index, collection);
        return result;
      });
      return result;
    }

    /**
     * The base implementation of methods like `_.max` and `_.min` which accepts a
     * `comparator` to determine the extremum value.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The iteratee invoked per iteration.
     * @param {Function} comparator The comparator used to compare values.
     * @returns {*} Returns the extremum value.
     */
    function baseExtremum(array, iteratee, comparator) {
      var index = -1,
          length = array.length;

      while (++index < length) {
        var value = array[index],
            current = iteratee(value);

        if (current != null && (computed === undefined
              ? (current === current && !isSymbol(current))
              : comparator(current, computed)
            )) {
          var computed = current,
              result = value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.fill` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     */
    function baseFill(array, value, start, end) {
      var length = array.length;

      start = toInteger(start);
      if (start < 0) {
        start = -start > length ? 0 : (length + start);
      }
      end = (end === undefined || end > length) ? length : toInteger(end);
      if (end < 0) {
        end += length;
      }
      end = start > end ? 0 : toLength(end);
      while (start < end) {
        array[start++] = value;
      }
      return array;
    }

    /**
     * The base implementation of `_.filter` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     */
    function baseFilter(collection, predicate) {
      var result = [];
      baseEach(collection, function(value, index, collection) {
        if (predicate(value, index, collection)) {
          result.push(value);
        }
      });
      return result;
    }

    /**
     * The base implementation of `_.flatten` with support for restricting flattening.
     *
     * @private
     * @param {Array} array The array to flatten.
     * @param {number} depth The maximum recursion depth.
     * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
     * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
     * @param {Array} [result=[]] The initial result value.
     * @returns {Array} Returns the new flattened array.
     */
    function baseFlatten(array, depth, predicate, isStrict, result) {
      var index = -1,
          length = array.length;

      predicate || (predicate = isFlattenable);
      result || (result = []);

      while (++index < length) {
        var value = array[index];
        if (depth > 0 && predicate(value)) {
          if (depth > 1) {
            // Recursively flatten arrays (susceptible to call stack limits).
            baseFlatten(value, depth - 1, predicate, isStrict, result);
          } else {
            arrayPush(result, value);
          }
        } else if (!isStrict) {
          result[result.length] = value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `baseForOwn` which iterates over `object`
     * properties returned by `keysFunc` and invokes `iteratee` for each property.
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */
    var baseFor = createBaseFor();

    /**
     * This function is like `baseFor` except that it iterates over properties
     * in the opposite order.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */
    var baseForRight = createBaseFor(true);

    /**
     * The base implementation of `_.forOwn` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */
    function baseForOwn(object, iteratee) {
      return object && baseFor(object, iteratee, keys);
    }

    /**
     * The base implementation of `_.forOwnRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */
    function baseForOwnRight(object, iteratee) {
      return object && baseForRight(object, iteratee, keys);
    }

    /**
     * The base implementation of `_.functions` which creates an array of
     * `object` function property names filtered from `props`.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Array} props The property names to filter.
     * @returns {Array} Returns the function names.
     */
    function baseFunctions(object, props) {
      return arrayFilter(props, function(key) {
        return isFunction(object[key]);
      });
    }

    /**
     * The base implementation of `_.get` without support for default values.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @returns {*} Returns the resolved value.
     */
    function baseGet(object, path) {
      path = castPath(path, object);

      var index = 0,
          length = path.length;

      while (object != null && index < length) {
        object = object[toKey(path[index++])];
      }
      return (index && index == length) ? object : undefined;
    }

    /**
     * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
     * `keysFunc` and `symbolsFunc` to get the enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @param {Function} symbolsFunc The function to get the symbols of `object`.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function baseGetAllKeys(object, keysFunc, symbolsFunc) {
      var result = keysFunc(object);
      return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
    }

    /**
     * The base implementation of `getTag` without fallbacks for buggy environments.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */
    function baseGetTag(value) {
      if (value == null) {
        return value === undefined ? undefinedTag : nullTag;
      }
      return (symToStringTag && symToStringTag in Object(value))
        ? getRawTag(value)
        : objectToString(value);
    }

    /**
     * The base implementation of `_.gt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     */
    function baseGt(value, other) {
      return value > other;
    }

    /**
     * The base implementation of `_.has` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */
    function baseHas(object, key) {
      return object != null && hasOwnProperty.call(object, key);
    }

    /**
     * The base implementation of `_.hasIn` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */
    function baseHasIn(object, key) {
      return object != null && key in Object(object);
    }

    /**
     * The base implementation of `_.inRange` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to check.
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     */
    function baseInRange(number, start, end) {
      return number >= nativeMin(start, end) && number < nativeMax(start, end);
    }

    /**
     * The base implementation of methods like `_.intersection`, without support
     * for iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of shared values.
     */
    function baseIntersection(arrays, iteratee, comparator) {
      var includes = comparator ? arrayIncludesWith : arrayIncludes,
          length = arrays[0].length,
          othLength = arrays.length,
          othIndex = othLength,
          caches = Array(othLength),
          maxLength = Infinity,
          result = [];

      while (othIndex--) {
        var array = arrays[othIndex];
        if (othIndex && iteratee) {
          array = arrayMap(array, baseUnary(iteratee));
        }
        maxLength = nativeMin(array.length, maxLength);
        caches[othIndex] = !comparator && (iteratee || (length >= 120 && array.length >= 120))
          ? new SetCache(othIndex && array)
          : undefined;
      }
      array = arrays[0];

      var index = -1,
          seen = caches[0];

      outer:
      while (++index < length && result.length < maxLength) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        value = (comparator || value !== 0) ? value : 0;
        if (!(seen
              ? cacheHas(seen, computed)
              : includes(result, computed, comparator)
            )) {
          othIndex = othLength;
          while (--othIndex) {
            var cache = caches[othIndex];
            if (!(cache
                  ? cacheHas(cache, computed)
                  : includes(arrays[othIndex], computed, comparator))
                ) {
              continue outer;
            }
          }
          if (seen) {
            seen.push(computed);
          }
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.invert` and `_.invertBy` which inverts
     * `object` with values transformed by `iteratee` and set by `setter`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform values.
     * @param {Object} accumulator The initial inverted object.
     * @returns {Function} Returns `accumulator`.
     */
    function baseInverter(object, setter, iteratee, accumulator) {
      baseForOwn(object, function(value, key, object) {
        setter(accumulator, iteratee(value), key, object);
      });
      return accumulator;
    }

    /**
     * The base implementation of `_.invoke` without support for individual
     * method arguments.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {Array} args The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     */
    function baseInvoke(object, path, args) {
      path = castPath(path, object);
      object = parent(object, path);
      var func = object == null ? object : object[toKey(last(path))];
      return func == null ? undefined : apply(func, object, args);
    }

    /**
     * The base implementation of `_.isArguments`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     */
    function baseIsArguments(value) {
      return isObjectLike(value) && baseGetTag(value) == argsTag;
    }

    /**
     * The base implementation of `_.isArrayBuffer` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     */
    function baseIsArrayBuffer(value) {
      return isObjectLike(value) && baseGetTag(value) == arrayBufferTag;
    }

    /**
     * The base implementation of `_.isDate` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     */
    function baseIsDate(value) {
      return isObjectLike(value) && baseGetTag(value) == dateTag;
    }

    /**
     * The base implementation of `_.isEqual` which supports partial comparisons
     * and tracks traversed objects.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Unordered comparison
     *  2 - Partial comparison
     * @param {Function} [customizer] The function to customize comparisons.
     * @param {Object} [stack] Tracks traversed `value` and `other` objects.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     */
    function baseIsEqual(value, other, bitmask, customizer, stack) {
      if (value === other) {
        return true;
      }
      if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
        return value !== value && other !== other;
      }
      return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
    }

    /**
     * A specialized version of `baseIsEqual` for arrays and objects which performs
     * deep comparisons and tracks traversed objects enabling objects with circular
     * references to be compared.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} [stack] Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
      var objIsArr = isArray(object),
          othIsArr = isArray(other),
          objTag = objIsArr ? arrayTag : getTag(object),
          othTag = othIsArr ? arrayTag : getTag(other);

      objTag = objTag == argsTag ? objectTag : objTag;
      othTag = othTag == argsTag ? objectTag : othTag;

      var objIsObj = objTag == objectTag,
          othIsObj = othTag == objectTag,
          isSameTag = objTag == othTag;

      if (isSameTag && isBuffer(object)) {
        if (!isBuffer(other)) {
          return false;
        }
        objIsArr = true;
        objIsObj = false;
      }
      if (isSameTag && !objIsObj) {
        stack || (stack = new Stack);
        return (objIsArr || isTypedArray(object))
          ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
          : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
      }
      if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
        var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
            othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

        if (objIsWrapped || othIsWrapped) {
          var objUnwrapped = objIsWrapped ? object.value() : object,
              othUnwrapped = othIsWrapped ? other.value() : other;

          stack || (stack = new Stack);
          return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
        }
      }
      if (!isSameTag) {
        return false;
      }
      stack || (stack = new Stack);
      return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
    }

    /**
     * The base implementation of `_.isMap` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     */
    function baseIsMap(value) {
      return isObjectLike(value) && getTag(value) == mapTag;
    }

    /**
     * The base implementation of `_.isMatch` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Array} matchData The property names, values, and compare flags to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     */
    function baseIsMatch(object, source, matchData, customizer) {
      var index = matchData.length,
          length = index,
          noCustomizer = !customizer;

      if (object == null) {
        return !length;
      }
      object = Object(object);
      while (index--) {
        var data = matchData[index];
        if ((noCustomizer && data[2])
              ? data[1] !== object[data[0]]
              : !(data[0] in object)
            ) {
          return false;
        }
      }
      while (++index < length) {
        data = matchData[index];
        var key = data[0],
            objValue = object[key],
            srcValue = data[1];

        if (noCustomizer && data[2]) {
          if (objValue === undefined && !(key in object)) {
            return false;
          }
        } else {
          var stack = new Stack;
          if (customizer) {
            var result = customizer(objValue, srcValue, key, object, source, stack);
          }
          if (!(result === undefined
                ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
                : result
              )) {
            return false;
          }
        }
      }
      return true;
    }

    /**
     * The base implementation of `_.isNative` without bad shim checks.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     */
    function baseIsNative(value) {
      if (!isObject(value) || isMasked(value)) {
        return false;
      }
      var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
      return pattern.test(toSource(value));
    }

    /**
     * The base implementation of `_.isRegExp` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     */
    function baseIsRegExp(value) {
      return isObjectLike(value) && baseGetTag(value) == regexpTag;
    }

    /**
     * The base implementation of `_.isSet` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     */
    function baseIsSet(value) {
      return isObjectLike(value) && getTag(value) == setTag;
    }

    /**
     * The base implementation of `_.isTypedArray` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     */
    function baseIsTypedArray(value) {
      return isObjectLike(value) &&
        isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
    }

    /**
     * The base implementation of `_.iteratee`.
     *
     * @private
     * @param {*} [value=_.identity] The value to convert to an iteratee.
     * @returns {Function} Returns the iteratee.
     */
    function baseIteratee(value) {
      // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
      // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
      if (typeof value == 'function') {
        return value;
      }
      if (value == null) {
        return identity;
      }
      if (typeof value == 'object') {
        return isArray(value)
          ? baseMatchesProperty(value[0], value[1])
          : baseMatches(value);
      }
      return property(value);
    }

    /**
     * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function baseKeys(object) {
      if (!isPrototype(object)) {
        return nativeKeys(object);
      }
      var result = [];
      for (var key in Object(object)) {
        if (hasOwnProperty.call(object, key) && key != 'constructor') {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function baseKeysIn(object) {
      if (!isObject(object)) {
        return nativeKeysIn(object);
      }
      var isProto = isPrototype(object),
          result = [];

      for (var key in object) {
        if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.lt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     */
    function baseLt(value, other) {
      return value < other;
    }

    /**
     * The base implementation of `_.map` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     */
    function baseMap(collection, iteratee) {
      var index = -1,
          result = isArrayLike(collection) ? Array(collection.length) : [];

      baseEach(collection, function(value, key, collection) {
        result[++index] = iteratee(value, key, collection);
      });
      return result;
    }

    /**
     * The base implementation of `_.matches` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     */
    function baseMatches(source) {
      var matchData = getMatchData(source);
      if (matchData.length == 1 && matchData[0][2]) {
        return matchesStrictComparable(matchData[0][0], matchData[0][1]);
      }
      return function(object) {
        return object === source || baseIsMatch(object, source, matchData);
      };
    }

    /**
     * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
     *
     * @private
     * @param {string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */
    function baseMatchesProperty(path, srcValue) {
      if (isKey(path) && isStrictComparable(srcValue)) {
        return matchesStrictComparable(toKey(path), srcValue);
      }
      return function(object) {
        var objValue = get(object, path);
        return (objValue === undefined && objValue === srcValue)
          ? hasIn(object, path)
          : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
      };
    }

    /**
     * The base implementation of `_.merge` without support for multiple sources.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} [customizer] The function to customize merged values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */
    function baseMerge(object, source, srcIndex, customizer, stack) {
      if (object === source) {
        return;
      }
      baseFor(source, function(srcValue, key) {
        stack || (stack = new Stack);
        if (isObject(srcValue)) {
          baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
        }
        else {
          var newValue = customizer
            ? customizer(safeGet(object, key), srcValue, (key + ''), object, source, stack)
            : undefined;

          if (newValue === undefined) {
            newValue = srcValue;
          }
          assignMergeValue(object, key, newValue);
        }
      }, keysIn);
    }

    /**
     * A specialized version of `baseMerge` for arrays and objects which performs
     * deep merges and tracks traversed objects enabling objects with circular
     * references to be merged.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {string} key The key of the value to merge.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} mergeFunc The function to merge values.
     * @param {Function} [customizer] The function to customize assigned values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */
    function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
      var objValue = safeGet(object, key),
          srcValue = safeGet(source, key),
          stacked = stack.get(srcValue);

      if (stacked) {
        assignMergeValue(object, key, stacked);
        return;
      }
      var newValue = customizer
        ? customizer(objValue, srcValue, (key + ''), object, source, stack)
        : undefined;

      var isCommon = newValue === undefined;

      if (isCommon) {
        var isArr = isArray(srcValue),
            isBuff = !isArr && isBuffer(srcValue),
            isTyped = !isArr && !isBuff && isTypedArray(srcValue);

        newValue = srcValue;
        if (isArr || isBuff || isTyped) {
          if (isArray(objValue)) {
            newValue = objValue;
          }
          else if (isArrayLikeObject(objValue)) {
            newValue = copyArray(objValue);
          }
          else if (isBuff) {
            isCommon = false;
            newValue = cloneBuffer(srcValue, true);
          }
          else if (isTyped) {
            isCommon = false;
            newValue = cloneTypedArray(srcValue, true);
          }
          else {
            newValue = [];
          }
        }
        else if (isPlainObject(srcValue) || isArguments(srcValue)) {
          newValue = objValue;
          if (isArguments(objValue)) {
            newValue = toPlainObject(objValue);
          }
          else if (!isObject(objValue) || isFunction(objValue)) {
            newValue = initCloneObject(srcValue);
          }
        }
        else {
          isCommon = false;
        }
      }
      if (isCommon) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, newValue);
        mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
        stack['delete'](srcValue);
      }
      assignMergeValue(object, key, newValue);
    }

    /**
     * The base implementation of `_.nth` which doesn't coerce arguments.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {number} n The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     */
    function baseNth(array, n) {
      var length = array.length;
      if (!length) {
        return;
      }
      n += n < 0 ? length : 0;
      return isIndex(n, length) ? array[n] : undefined;
    }

    /**
     * The base implementation of `_.orderBy` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
     * @param {string[]} orders The sort orders of `iteratees`.
     * @returns {Array} Returns the new sorted array.
     */
    function baseOrderBy(collection, iteratees, orders) {
      if (iteratees.length) {
        iteratees = arrayMap(iteratees, function(iteratee) {
          if (isArray(iteratee)) {
            return function(value) {
              return baseGet(value, iteratee.length === 1 ? iteratee[0] : iteratee);
            }
          }
          return iteratee;
        });
      } else {
        iteratees = [identity];
      }

      var index = -1;
      iteratees = arrayMap(iteratees, baseUnary(getIteratee()));

      var result = baseMap(collection, function(value, key, collection) {
        var criteria = arrayMap(iteratees, function(iteratee) {
          return iteratee(value);
        });
        return { 'criteria': criteria, 'index': ++index, 'value': value };
      });

      return baseSortBy(result, function(object, other) {
        return compareMultiple(object, other, orders);
      });
    }

    /**
     * The base implementation of `_.pick` without support for individual
     * property identifiers.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @returns {Object} Returns the new object.
     */
    function basePick(object, paths) {
      return basePickBy(object, paths, function(value, path) {
        return hasIn(object, path);
      });
    }

    /**
     * The base implementation of  `_.pickBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @param {Function} predicate The function invoked per property.
     * @returns {Object} Returns the new object.
     */
    function basePickBy(object, paths, predicate) {
      var index = -1,
          length = paths.length,
          result = {};

      while (++index < length) {
        var path = paths[index],
            value = baseGet(object, path);

        if (predicate(value, path)) {
          baseSet(result, castPath(path, object), value);
        }
      }
      return result;
    }

    /**
     * A specialized version of `baseProperty` which supports deep paths.
     *
     * @private
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     */
    function basePropertyDeep(path) {
      return function(object) {
        return baseGet(object, path);
      };
    }

    /**
     * The base implementation of `_.pullAllBy` without support for iteratee
     * shorthands.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     */
    function basePullAll(array, values, iteratee, comparator) {
      var indexOf = comparator ? baseIndexOfWith : baseIndexOf,
          index = -1,
          length = values.length,
          seen = array;

      if (array === values) {
        values = copyArray(values);
      }
      if (iteratee) {
        seen = arrayMap(array, baseUnary(iteratee));
      }
      while (++index < length) {
        var fromIndex = 0,
            value = values[index],
            computed = iteratee ? iteratee(value) : value;

        while ((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1) {
          if (seen !== array) {
            splice.call(seen, fromIndex, 1);
          }
          splice.call(array, fromIndex, 1);
        }
      }
      return array;
    }

    /**
     * The base implementation of `_.pullAt` without support for individual
     * indexes or capturing the removed elements.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {number[]} indexes The indexes of elements to remove.
     * @returns {Array} Returns `array`.
     */
    function basePullAt(array, indexes) {
      var length = array ? indexes.length : 0,
          lastIndex = length - 1;

      while (length--) {
        var index = indexes[length];
        if (length == lastIndex || index !== previous) {
          var previous = index;
          if (isIndex(index)) {
            splice.call(array, index, 1);
          } else {
            baseUnset(array, index);
          }
        }
      }
      return array;
    }

    /**
     * The base implementation of `_.random` without support for returning
     * floating-point numbers.
     *
     * @private
     * @param {number} lower The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the random number.
     */
    function baseRandom(lower, upper) {
      return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
    }

    /**
     * The base implementation of `_.range` and `_.rangeRight` which doesn't
     * coerce arguments.
     *
     * @private
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @param {number} step The value to increment or decrement by.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the range of numbers.
     */
    function baseRange(start, end, step, fromRight) {
      var index = -1,
          length = nativeMax(nativeCeil((end - start) / (step || 1)), 0),
          result = Array(length);

      while (length--) {
        result[fromRight ? length : ++index] = start;
        start += step;
      }
      return result;
    }

    /**
     * The base implementation of `_.repeat` which doesn't coerce arguments.
     *
     * @private
     * @param {string} string The string to repeat.
     * @param {number} n The number of times to repeat the string.
     * @returns {string} Returns the repeated string.
     */
    function baseRepeat(string, n) {
      var result = '';
      if (!string || n < 1 || n > MAX_SAFE_INTEGER) {
        return result;
      }
      // Leverage the exponentiation by squaring algorithm for a faster repeat.
      // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
      do {
        if (n % 2) {
          result += string;
        }
        n = nativeFloor(n / 2);
        if (n) {
          string += string;
        }
      } while (n);

      return result;
    }

    /**
     * The base implementation of `_.rest` which doesn't validate or coerce arguments.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     */
    function baseRest(func, start) {
      return setToString(overRest(func, start, identity), func + '');
    }

    /**
     * The base implementation of `_.sample`.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     */
    function baseSample(collection) {
      return arraySample(values(collection));
    }

    /**
     * The base implementation of `_.sampleSize` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */
    function baseSampleSize(collection, n) {
      var array = values(collection);
      return shuffleSelf(array, baseClamp(n, 0, array.length));
    }

    /**
     * The base implementation of `_.set`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */
    function baseSet(object, path, value, customizer) {
      if (!isObject(object)) {
        return object;
      }
      path = castPath(path, object);

      var index = -1,
          length = path.length,
          lastIndex = length - 1,
          nested = object;

      while (nested != null && ++index < length) {
        var key = toKey(path[index]),
            newValue = value;

        if (key === '__proto__' || key === 'constructor' || key === 'prototype') {
          return object;
        }

        if (index != lastIndex) {
          var objValue = nested[key];
          newValue = customizer ? customizer(objValue, key, nested) : undefined;
          if (newValue === undefined) {
            newValue = isObject(objValue)
              ? objValue
              : (isIndex(path[index + 1]) ? [] : {});
          }
        }
        assignValue(nested, key, newValue);
        nested = nested[key];
      }
      return object;
    }

    /**
     * The base implementation of `setData` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */
    var baseSetData = !metaMap ? identity : function(func, data) {
      metaMap.set(func, data);
      return func;
    };

    /**
     * The base implementation of `setToString` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */
    var baseSetToString = !defineProperty ? identity : function(func, string) {
      return defineProperty(func, 'toString', {
        'configurable': true,
        'enumerable': false,
        'value': constant(string),
        'writable': true
      });
    };

    /**
     * The base implementation of `_.shuffle`.
     *
     * @private
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */
    function baseShuffle(collection) {
      return shuffleSelf(values(collection));
    }

    /**
     * The base implementation of `_.slice` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */
    function baseSlice(array, start, end) {
      var index = -1,
          length = array.length;

      if (start < 0) {
        start = -start > length ? 0 : (length + start);
      }
      end = end > length ? length : end;
      if (end < 0) {
        end += length;
      }
      length = start > end ? 0 : ((end - start) >>> 0);
      start >>>= 0;

      var result = Array(length);
      while (++index < length) {
        result[index] = array[index + start];
      }
      return result;
    }

    /**
     * The base implementation of `_.some` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     */
    function baseSome(collection, predicate) {
      var result;

      baseEach(collection, function(value, index, collection) {
        result = predicate(value, index, collection);
        return !result;
      });
      return !!result;
    }

    /**
     * The base implementation of `_.sortedIndex` and `_.sortedLastIndex` which
     * performs a binary search of `array` to determine the index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */
    function baseSortedIndex(array, value, retHighest) {
      var low = 0,
          high = array == null ? low : array.length;

      if (typeof value == 'number' && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
        while (low < high) {
          var mid = (low + high) >>> 1,
              computed = array[mid];

          if (computed !== null && !isSymbol(computed) &&
              (retHighest ? (computed <= value) : (computed < value))) {
            low = mid + 1;
          } else {
            high = mid;
          }
        }
        return high;
      }
      return baseSortedIndexBy(array, value, identity, retHighest);
    }

    /**
     * The base implementation of `_.sortedIndexBy` and `_.sortedLastIndexBy`
     * which invokes `iteratee` for `value` and each element of `array` to compute
     * their sort ranking. The iteratee is invoked with one argument; (value).
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} iteratee The iteratee invoked per element.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */
    function baseSortedIndexBy(array, value, iteratee, retHighest) {
      var low = 0,
          high = array == null ? 0 : array.length;
      if (high === 0) {
        return 0;
      }

      value = iteratee(value);
      var valIsNaN = value !== value,
          valIsNull = value === null,
          valIsSymbol = isSymbol(value),
          valIsUndefined = value === undefined;

      while (low < high) {
        var mid = nativeFloor((low + high) / 2),
            computed = iteratee(array[mid]),
            othIsDefined = computed !== undefined,
            othIsNull = computed === null,
            othIsReflexive = computed === computed,
            othIsSymbol = isSymbol(computed);

        if (valIsNaN) {
          var setLow = retHighest || othIsReflexive;
        } else if (valIsUndefined) {
          setLow = othIsReflexive && (retHighest || othIsDefined);
        } else if (valIsNull) {
          setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
        } else if (valIsSymbol) {
          setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
        } else if (othIsNull || othIsSymbol) {
          setLow = false;
        } else {
          setLow = retHighest ? (computed <= value) : (computed < value);
        }
        if (setLow) {
          low = mid + 1;
        } else {
          high = mid;
        }
      }
      return nativeMin(high, MAX_ARRAY_INDEX);
    }

    /**
     * The base implementation of `_.sortedUniq` and `_.sortedUniqBy` without
     * support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */
    function baseSortedUniq(array, iteratee) {
      var index = -1,
          length = array.length,
          resIndex = 0,
          result = [];

      while (++index < length) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        if (!index || !eq(computed, seen)) {
          var seen = computed;
          result[resIndex++] = value === 0 ? 0 : value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.toNumber` which doesn't ensure correct
     * conversions of binary, hexadecimal, or octal string values.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     */
    function baseToNumber(value) {
      if (typeof value == 'number') {
        return value;
      }
      if (isSymbol(value)) {
        return NAN;
      }
      return +value;
    }

    /**
     * The base implementation of `_.toString` which doesn't convert nullish
     * values to empty strings.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {string} Returns the string.
     */
    function baseToString(value) {
      // Exit early for strings to avoid a performance hit in some environments.
      if (typeof value == 'string') {
        return value;
      }
      if (isArray(value)) {
        // Recursively convert values (susceptible to call stack limits).
        return arrayMap(value, baseToString) + '';
      }
      if (isSymbol(value)) {
        return symbolToString ? symbolToString.call(value) : '';
      }
      var result = (value + '');
      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
    }

    /**
     * The base implementation of `_.uniqBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */
    function baseUniq(array, iteratee, comparator) {
      var index = -1,
          includes = arrayIncludes,
          length = array.length,
          isCommon = true,
          result = [],
          seen = result;

      if (comparator) {
        isCommon = false;
        includes = arrayIncludesWith;
      }
      else if (length >= LARGE_ARRAY_SIZE) {
        var set = iteratee ? null : createSet(array);
        if (set) {
          return setToArray(set);
        }
        isCommon = false;
        includes = cacheHas;
        seen = new SetCache;
      }
      else {
        seen = iteratee ? [] : result;
      }
      outer:
      while (++index < length) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        value = (comparator || value !== 0) ? value : 0;
        if (isCommon && computed === computed) {
          var seenIndex = seen.length;
          while (seenIndex--) {
            if (seen[seenIndex] === computed) {
              continue outer;
            }
          }
          if (iteratee) {
            seen.push(computed);
          }
          result.push(value);
        }
        else if (!includes(seen, computed, comparator)) {
          if (seen !== result) {
            seen.push(computed);
          }
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.unset`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The property path to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     */
    function baseUnset(object, path) {
      path = castPath(path, object);
      object = parent(object, path);
      return object == null || delete object[toKey(last(path))];
    }

    /**
     * The base implementation of `_.update`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to update.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */
    function baseUpdate(object, path, updater, customizer) {
      return baseSet(object, path, updater(baseGet(object, path)), customizer);
    }

    /**
     * The base implementation of methods like `_.dropWhile` and `_.takeWhile`
     * without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {Function} predicate The function invoked per iteration.
     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the slice of `array`.
     */
    function baseWhile(array, predicate, isDrop, fromRight) {
      var length = array.length,
          index = fromRight ? length : -1;

      while ((fromRight ? index-- : ++index < length) &&
        predicate(array[index], index, array)) {}

      return isDrop
        ? baseSlice(array, (fromRight ? 0 : index), (fromRight ? index + 1 : length))
        : baseSlice(array, (fromRight ? index + 1 : 0), (fromRight ? length : index));
    }

    /**
     * The base implementation of `wrapperValue` which returns the result of
     * performing a sequence of actions on the unwrapped `value`, where each
     * successive action is supplied the return value of the previous.
     *
     * @private
     * @param {*} value The unwrapped value.
     * @param {Array} actions Actions to perform to resolve the unwrapped value.
     * @returns {*} Returns the resolved value.
     */
    function baseWrapperValue(value, actions) {
      var result = value;
      if (result instanceof LazyWrapper) {
        result = result.value();
      }
      return arrayReduce(actions, function(result, action) {
        return action.func.apply(action.thisArg, arrayPush([result], action.args));
      }, result);
    }

    /**
     * The base implementation of methods like `_.xor`, without support for
     * iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of values.
     */
    function baseXor(arrays, iteratee, comparator) {
      var length = arrays.length;
      if (length < 2) {
        return length ? baseUniq(arrays[0]) : [];
      }
      var index = -1,
          result = Array(length);

      while (++index < length) {
        var array = arrays[index],
            othIndex = -1;

        while (++othIndex < length) {
          if (othIndex != index) {
            result[index] = baseDifference(result[index] || array, arrays[othIndex], iteratee, comparator);
          }
        }
      }
      return baseUniq(baseFlatten(result, 1), iteratee, comparator);
    }

    /**
     * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
     *
     * @private
     * @param {Array} props The property identifiers.
     * @param {Array} values The property values.
     * @param {Function} assignFunc The function to assign values.
     * @returns {Object} Returns the new object.
     */
    function baseZipObject(props, values, assignFunc) {
      var index = -1,
          length = props.length,
          valsLength = values.length,
          result = {};

      while (++index < length) {
        var value = index < valsLength ? values[index] : undefined;
        assignFunc(result, props[index], value);
      }
      return result;
    }

    /**
     * Casts `value` to an empty array if it's not an array like object.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Array|Object} Returns the cast array-like object.
     */
    function castArrayLikeObject(value) {
      return isArrayLikeObject(value) ? value : [];
    }

    /**
     * Casts `value` to `identity` if it's not a function.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Function} Returns cast function.
     */
    function castFunction(value) {
      return typeof value == 'function' ? value : identity;
    }

    /**
     * Casts `value` to a path array if it's not one.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {Object} [object] The object to query keys on.
     * @returns {Array} Returns the cast property path array.
     */
    function castPath(value, object) {
      if (isArray(value)) {
        return value;
      }
      return isKey(value, object) ? [value] : stringToPath(toString(value));
    }

    /**
     * A `baseRest` alias which can be replaced with `identity` by module
     * replacement plugins.
     *
     * @private
     * @type {Function}
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */
    var castRest = baseRest;

    /**
     * Casts `array` to a slice if it's needed.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {number} start The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the cast slice.
     */
    function castSlice(array, start, end) {
      var length = array.length;
      end = end === undefined ? length : end;
      return (!start && end >= length) ? array : baseSlice(array, start, end);
    }

    /**
     * A simple wrapper around the global [`clearTimeout`](https://mdn.io/clearTimeout).
     *
     * @private
     * @param {number|Object} id The timer id or timeout object of the timer to clear.
     */
    var clearTimeout = ctxClearTimeout || function(id) {
      return root.clearTimeout(id);
    };

    /**
     * Creates a clone of  `buffer`.
     *
     * @private
     * @param {Buffer} buffer The buffer to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Buffer} Returns the cloned buffer.
     */
    function cloneBuffer(buffer, isDeep) {
      if (isDeep) {
        return buffer.slice();
      }
      var length = buffer.length,
          result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);

      buffer.copy(result);
      return result;
    }

    /**
     * Creates a clone of `arrayBuffer`.
     *
     * @private
     * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
     * @returns {ArrayBuffer} Returns the cloned array buffer.
     */
    function cloneArrayBuffer(arrayBuffer) {
      var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
      new Uint8Array(result).set(new Uint8Array(arrayBuffer));
      return result;
    }

    /**
     * Creates a clone of `dataView`.
     *
     * @private
     * @param {Object} dataView The data view to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned data view.
     */
    function cloneDataView(dataView, isDeep) {
      var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
      return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
    }

    /**
     * Creates a clone of `regexp`.
     *
     * @private
     * @param {Object} regexp The regexp to clone.
     * @returns {Object} Returns the cloned regexp.
     */
    function cloneRegExp(regexp) {
      var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
      result.lastIndex = regexp.lastIndex;
      return result;
    }

    /**
     * Creates a clone of the `symbol` object.
     *
     * @private
     * @param {Object} symbol The symbol object to clone.
     * @returns {Object} Returns the cloned symbol object.
     */
    function cloneSymbol(symbol) {
      return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
    }

    /**
     * Creates a clone of `typedArray`.
     *
     * @private
     * @param {Object} typedArray The typed array to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned typed array.
     */
    function cloneTypedArray(typedArray, isDeep) {
      var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
      return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
    }

    /**
     * Compares values to sort them in ascending order.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {number} Returns the sort order indicator for `value`.
     */
    function compareAscending(value, other) {
      if (value !== other) {
        var valIsDefined = value !== undefined,
            valIsNull = value === null,
            valIsReflexive = value === value,
            valIsSymbol = isSymbol(value);

        var othIsDefined = other !== undefined,
            othIsNull = other === null,
            othIsReflexive = other === other,
            othIsSymbol = isSymbol(other);

        if ((!othIsNull && !othIsSymbol && !valIsSymbol && value > other) ||
            (valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol) ||
            (valIsNull && othIsDefined && othIsReflexive) ||
            (!valIsDefined && othIsReflexive) ||
            !valIsReflexive) {
          return 1;
        }
        if ((!valIsNull && !valIsSymbol && !othIsSymbol && value < other) ||
            (othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol) ||
            (othIsNull && valIsDefined && valIsReflexive) ||
            (!othIsDefined && valIsReflexive) ||
            !othIsReflexive) {
          return -1;
        }
      }
      return 0;
    }

    /**
     * Used by `_.orderBy` to compare multiple properties of a value to another
     * and stable sort them.
     *
     * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
     * specify an order of "desc" for descending or "asc" for ascending sort order
     * of corresponding values.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {boolean[]|string[]} orders The order to sort by for each property.
     * @returns {number} Returns the sort order indicator for `object`.
     */
    function compareMultiple(object, other, orders) {
      var index = -1,
          objCriteria = object.criteria,
          othCriteria = other.criteria,
          length = objCriteria.length,
          ordersLength = orders.length;

      while (++index < length) {
        var result = compareAscending(objCriteria[index], othCriteria[index]);
        if (result) {
          if (index >= ordersLength) {
            return result;
          }
          var order = orders[index];
          return result * (order == 'desc' ? -1 : 1);
        }
      }
      // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
      // that causes it, under certain circumstances, to provide the same value for
      // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
      // for more details.
      //
      // This also ensures a stable sort in V8 and other engines.
      // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
      return object.index - other.index;
    }

    /**
     * Creates an array that is the composition of partially applied arguments,
     * placeholders, and provided arguments into a single array of arguments.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to prepend to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */
    function composeArgs(args, partials, holders, isCurried) {
      var argsIndex = -1,
          argsLength = args.length,
          holdersLength = holders.length,
          leftIndex = -1,
          leftLength = partials.length,
          rangeLength = nativeMax(argsLength - holdersLength, 0),
          result = Array(leftLength + rangeLength),
          isUncurried = !isCurried;

      while (++leftIndex < leftLength) {
        result[leftIndex] = partials[leftIndex];
      }
      while (++argsIndex < holdersLength) {
        if (isUncurried || argsIndex < argsLength) {
          result[holders[argsIndex]] = args[argsIndex];
        }
      }
      while (rangeLength--) {
        result[leftIndex++] = args[argsIndex++];
      }
      return result;
    }

    /**
     * This function is like `composeArgs` except that the arguments composition
     * is tailored for `_.partialRight`.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to append to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */
    function composeArgsRight(args, partials, holders, isCurried) {
      var argsIndex = -1,
          argsLength = args.length,
          holdersIndex = -1,
          holdersLength = holders.length,
          rightIndex = -1,
          rightLength = partials.length,
          rangeLength = nativeMax(argsLength - holdersLength, 0),
          result = Array(rangeLength + rightLength),
          isUncurried = !isCurried;

      while (++argsIndex < rangeLength) {
        result[argsIndex] = args[argsIndex];
      }
      var offset = argsIndex;
      while (++rightIndex < rightLength) {
        result[offset + rightIndex] = partials[rightIndex];
      }
      while (++holdersIndex < holdersLength) {
        if (isUncurried || argsIndex < argsLength) {
          result[offset + holders[holdersIndex]] = args[argsIndex++];
        }
      }
      return result;
    }

    /**
     * Copies the values of `source` to `array`.
     *
     * @private
     * @param {Array} source The array to copy values from.
     * @param {Array} [array=[]] The array to copy values to.
     * @returns {Array} Returns `array`.
     */
    function copyArray(source, array) {
      var index = -1,
          length = source.length;

      array || (array = Array(length));
      while (++index < length) {
        array[index] = source[index];
      }
      return array;
    }

    /**
     * Copies properties of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy properties from.
     * @param {Array} props The property identifiers to copy.
     * @param {Object} [object={}] The object to copy properties to.
     * @param {Function} [customizer] The function to customize copied values.
     * @returns {Object} Returns `object`.
     */
    function copyObject(source, props, object, customizer) {
      var isNew = !object;
      object || (object = {});

      var index = -1,
          length = props.length;

      while (++index < length) {
        var key = props[index];

        var newValue = customizer
          ? customizer(object[key], source[key], key, object, source)
          : undefined;

        if (newValue === undefined) {
          newValue = source[key];
        }
        if (isNew) {
          baseAssignValue(object, key, newValue);
        } else {
          assignValue(object, key, newValue);
        }
      }
      return object;
    }

    /**
     * Copies own symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */
    function copySymbols(source, object) {
      return copyObject(source, getSymbols(source), object);
    }

    /**
     * Copies own and inherited symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */
    function copySymbolsIn(source, object) {
      return copyObject(source, getSymbolsIn(source), object);
    }

    /**
     * Creates a function like `_.groupBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} [initializer] The accumulator object initializer.
     * @returns {Function} Returns the new aggregator function.
     */
    function createAggregator(setter, initializer) {
      return function(collection, iteratee) {
        var func = isArray(collection) ? arrayAggregator : baseAggregator,
            accumulator = initializer ? initializer() : {};

        return func(collection, setter, getIteratee(iteratee, 2), accumulator);
      };
    }

    /**
     * Creates a function like `_.assign`.
     *
     * @private
     * @param {Function} assigner The function to assign values.
     * @returns {Function} Returns the new assigner function.
     */
    function createAssigner(assigner) {
      return baseRest(function(object, sources) {
        var index = -1,
            length = sources.length,
            customizer = length > 1 ? sources[length - 1] : undefined,
            guard = length > 2 ? sources[2] : undefined;

        customizer = (assigner.length > 3 && typeof customizer == 'function')
          ? (length--, customizer)
          : undefined;

        if (guard && isIterateeCall(sources[0], sources[1], guard)) {
          customizer = length < 3 ? undefined : customizer;
          length = 1;
        }
        object = Object(object);
        while (++index < length) {
          var source = sources[index];
          if (source) {
            assigner(object, source, index, customizer);
          }
        }
        return object;
      });
    }

    /**
     * Creates a `baseEach` or `baseEachRight` function.
     *
     * @private
     * @param {Function} eachFunc The function to iterate over a collection.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */
    function createBaseEach(eachFunc, fromRight) {
      return function(collection, iteratee) {
        if (collection == null) {
          return collection;
        }
        if (!isArrayLike(collection)) {
          return eachFunc(collection, iteratee);
        }
        var length = collection.length,
            index = fromRight ? length : -1,
            iterable = Object(collection);

        while ((fromRight ? index-- : ++index < length)) {
          if (iteratee(iterable[index], index, iterable) === false) {
            break;
          }
        }
        return collection;
      };
    }

    /**
     * Creates a base function for methods like `_.forIn` and `_.forOwn`.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */
    function createBaseFor(fromRight) {
      return function(object, iteratee, keysFunc) {
        var index = -1,
            iterable = Object(object),
            props = keysFunc(object),
            length = props.length;

        while (length--) {
          var key = props[fromRight ? length : ++index];
          if (iteratee(iterable[key], key, iterable) === false) {
            break;
          }
        }
        return object;
      };
    }

    /**
     * Creates a function that wraps `func` to invoke it with the optional `this`
     * binding of `thisArg`.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createBind(func, bitmask, thisArg) {
      var isBind = bitmask & WRAP_BIND_FLAG,
          Ctor = createCtor(func);

      function wrapper() {
        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
        return fn.apply(isBind ? thisArg : this, arguments);
      }
      return wrapper;
    }

    /**
     * Creates a function like `_.lowerFirst`.
     *
     * @private
     * @param {string} methodName The name of the `String` case method to use.
     * @returns {Function} Returns the new case function.
     */
    function createCaseFirst(methodName) {
      return function(string) {
        string = toString(string);

        var strSymbols = hasUnicode(string)
          ? stringToArray(string)
          : undefined;

        var chr = strSymbols
          ? strSymbols[0]
          : string.charAt(0);

        var trailing = strSymbols
          ? castSlice(strSymbols, 1).join('')
          : string.slice(1);

        return chr[methodName]() + trailing;
      };
    }

    /**
     * Creates a function like `_.camelCase`.
     *
     * @private
     * @param {Function} callback The function to combine each word.
     * @returns {Function} Returns the new compounder function.
     */
    function createCompounder(callback) {
      return function(string) {
        return arrayReduce(words(deburr(string).replace(reApos, '')), callback, '');
      };
    }

    /**
     * Creates a function that produces an instance of `Ctor` regardless of
     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
     *
     * @private
     * @param {Function} Ctor The constructor to wrap.
     * @returns {Function} Returns the new wrapped function.
     */
    function createCtor(Ctor) {
      return function() {
        // Use a `switch` statement to work with class constructors. See
        // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
        // for more details.
        var args = arguments;
        switch (args.length) {
          case 0: return new Ctor;
          case 1: return new Ctor(args[0]);
          case 2: return new Ctor(args[0], args[1]);
          case 3: return new Ctor(args[0], args[1], args[2]);
          case 4: return new Ctor(args[0], args[1], args[2], args[3]);
          case 5: return new Ctor(args[0], args[1], args[2], args[3], args[4]);
          case 6: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
          case 7: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
        }
        var thisBinding = baseCreate(Ctor.prototype),
            result = Ctor.apply(thisBinding, args);

        // Mimic the constructor's `return` behavior.
        // See https://es5.github.io/#x13.2.2 for more details.
        return isObject(result) ? result : thisBinding;
      };
    }

    /**
     * Creates a function that wraps `func` to enable currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {number} arity The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createCurry(func, bitmask, arity) {
      var Ctor = createCtor(func);

      function wrapper() {
        var length = arguments.length,
            args = Array(length),
            index = length,
            placeholder = getHolder(wrapper);

        while (index--) {
          args[index] = arguments[index];
        }
        var holders = (length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder)
          ? []
          : replaceHolders(args, placeholder);

        length -= holders.length;
        if (length < arity) {
          return createRecurry(
            func, bitmask, createHybrid, wrapper.placeholder, undefined,
            args, holders, undefined, undefined, arity - length);
        }
        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
        return apply(fn, this, args);
      }
      return wrapper;
    }

    /**
     * Creates a `_.find` or `_.findLast` function.
     *
     * @private
     * @param {Function} findIndexFunc The function to find the collection index.
     * @returns {Function} Returns the new find function.
     */
    function createFind(findIndexFunc) {
      return function(collection, predicate, fromIndex) {
        var iterable = Object(collection);
        if (!isArrayLike(collection)) {
          var iteratee = getIteratee(predicate, 3);
          collection = keys(collection);
          predicate = function(key) { return iteratee(iterable[key], key, iterable); };
        }
        var index = findIndexFunc(collection, predicate, fromIndex);
        return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
      };
    }

    /**
     * Creates a `_.flow` or `_.flowRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new flow function.
     */
    function createFlow(fromRight) {
      return flatRest(function(funcs) {
        var length = funcs.length,
            index = length,
            prereq = LodashWrapper.prototype.thru;

        if (fromRight) {
          funcs.reverse();
        }
        while (index--) {
          var func = funcs[index];
          if (typeof func != 'function') {
            throw new TypeError(FUNC_ERROR_TEXT);
          }
          if (prereq && !wrapper && getFuncName(func) == 'wrapper') {
            var wrapper = new LodashWrapper([], true);
          }
        }
        index = wrapper ? index : length;
        while (++index < length) {
          func = funcs[index];

          var funcName = getFuncName(func),
              data = funcName == 'wrapper' ? getData(func) : undefined;

          if (data && isLaziable(data[0]) &&
                data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) &&
                !data[4].length && data[9] == 1
              ) {
            wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
          } else {
            wrapper = (func.length == 1 && isLaziable(func))
              ? wrapper[funcName]()
              : wrapper.thru(func);
          }
        }
        return function() {
          var args = arguments,
              value = args[0];

          if (wrapper && args.length == 1 && isArray(value)) {
            return wrapper.plant(value).value();
          }
          var index = 0,
              result = length ? funcs[index].apply(this, args) : value;

          while (++index < length) {
            result = funcs[index].call(this, result);
          }
          return result;
        };
      });
    }

    /**
     * Creates a function that wraps `func` to invoke it with optional `this`
     * binding of `thisArg`, partial application, and currying.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [partialsRight] The arguments to append to those provided
     *  to the new function.
     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
      var isAry = bitmask & WRAP_ARY_FLAG,
          isBind = bitmask & WRAP_BIND_FLAG,
          isBindKey = bitmask & WRAP_BIND_KEY_FLAG,
          isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG),
          isFlip = bitmask & WRAP_FLIP_FLAG,
          Ctor = isBindKey ? undefined : createCtor(func);

      function wrapper() {
        var length = arguments.length,
            args = Array(length),
            index = length;

        while (index--) {
          args[index] = arguments[index];
        }
        if (isCurried) {
          var placeholder = getHolder(wrapper),
              holdersCount = countHolders(args, placeholder);
        }
        if (partials) {
          args = composeArgs(args, partials, holders, isCurried);
        }
        if (partialsRight) {
          args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
        }
        length -= holdersCount;
        if (isCurried && length < arity) {
          var newHolders = replaceHolders(args, placeholder);
          return createRecurry(
            func, bitmask, createHybrid, wrapper.placeholder, thisArg,
            args, newHolders, argPos, ary, arity - length
          );
        }
        var thisBinding = isBind ? thisArg : this,
            fn = isBindKey ? thisBinding[func] : func;

        length = args.length;
        if (argPos) {
          args = reorder(args, argPos);
        } else if (isFlip && length > 1) {
          args.reverse();
        }
        if (isAry && ary < length) {
          args.length = ary;
        }
        if (this && this !== root && this instanceof wrapper) {
          fn = Ctor || createCtor(fn);
        }
        return fn.apply(thisBinding, args);
      }
      return wrapper;
    }

    /**
     * Creates a function like `_.invertBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} toIteratee The function to resolve iteratees.
     * @returns {Function} Returns the new inverter function.
     */
    function createInverter(setter, toIteratee) {
      return function(object, iteratee) {
        return baseInverter(object, setter, toIteratee(iteratee), {});
      };
    }

    /**
     * Creates a function that performs a mathematical operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @param {number} [defaultValue] The value used for `undefined` arguments.
     * @returns {Function} Returns the new mathematical operation function.
     */
    function createMathOperation(operator, defaultValue) {
      return function(value, other) {
        var result;
        if (value === undefined && other === undefined) {
          return defaultValue;
        }
        if (value !== undefined) {
          result = value;
        }
        if (other !== undefined) {
          if (result === undefined) {
            return other;
          }
          if (typeof value == 'string' || typeof other == 'string') {
            value = baseToString(value);
            other = baseToString(other);
          } else {
            value = baseToNumber(value);
            other = baseToNumber(other);
          }
          result = operator(value, other);
        }
        return result;
      };
    }

    /**
     * Creates a function like `_.over`.
     *
     * @private
     * @param {Function} arrayFunc The function to iterate over iteratees.
     * @returns {Function} Returns the new over function.
     */
    function createOver(arrayFunc) {
      return flatRest(function(iteratees) {
        iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
        return baseRest(function(args) {
          var thisArg = this;
          return arrayFunc(iteratees, function(iteratee) {
            return apply(iteratee, thisArg, args);
          });
        });
      });
    }

    /**
     * Creates the padding for `string` based on `length`. The `chars` string
     * is truncated if the number of characters exceeds `length`.
     *
     * @private
     * @param {number} length The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padding for `string`.
     */
    function createPadding(length, chars) {
      chars = chars === undefined ? ' ' : baseToString(chars);

      var charsLength = chars.length;
      if (charsLength < 2) {
        return charsLength ? baseRepeat(chars, length) : chars;
      }
      var result = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
      return hasUnicode(chars)
        ? castSlice(stringToArray(result), 0, length).join('')
        : result.slice(0, length);
    }

    /**
     * Creates a function that wraps `func` to invoke it with the `this` binding
     * of `thisArg` and `partials` prepended to the arguments it receives.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {Array} partials The arguments to prepend to those provided to
     *  the new function.
     * @returns {Function} Returns the new wrapped function.
     */
    function createPartial(func, bitmask, thisArg, partials) {
      var isBind = bitmask & WRAP_BIND_FLAG,
          Ctor = createCtor(func);

      function wrapper() {
        var argsIndex = -1,
            argsLength = arguments.length,
            leftIndex = -1,
            leftLength = partials.length,
            args = Array(leftLength + argsLength),
            fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;

        while (++leftIndex < leftLength) {
          args[leftIndex] = partials[leftIndex];
        }
        while (argsLength--) {
          args[leftIndex++] = arguments[++argsIndex];
        }
        return apply(fn, isBind ? thisArg : this, args);
      }
      return wrapper;
    }

    /**
     * Creates a `_.range` or `_.rangeRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new range function.
     */
    function createRange(fromRight) {
      return function(start, end, step) {
        if (step && typeof step != 'number' && isIterateeCall(start, end, step)) {
          end = step = undefined;
        }
        // Ensure the sign of `-0` is preserved.
        start = toFinite(start);
        if (end === undefined) {
          end = start;
          start = 0;
        } else {
          end = toFinite(end);
        }
        step = step === undefined ? (start < end ? 1 : -1) : toFinite(step);
        return baseRange(start, end, step, fromRight);
      };
    }

    /**
     * Creates a function that performs a relational operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @returns {Function} Returns the new relational operation function.
     */
    function createRelationalOperation(operator) {
      return function(value, other) {
        if (!(typeof value == 'string' && typeof other == 'string')) {
          value = toNumber(value);
          other = toNumber(other);
        }
        return operator(value, other);
      };
    }

    /**
     * Creates a function that wraps `func` to continue currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {Function} wrapFunc The function to create the `func` wrapper.
     * @param {*} placeholder The placeholder value.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
      var isCurry = bitmask & WRAP_CURRY_FLAG,
          newHolders = isCurry ? holders : undefined,
          newHoldersRight = isCurry ? undefined : holders,
          newPartials = isCurry ? partials : undefined,
          newPartialsRight = isCurry ? undefined : partials;

      bitmask |= (isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG);
      bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);

      if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) {
        bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
      }
      var newData = [
        func, bitmask, thisArg, newPartials, newHolders, newPartialsRight,
        newHoldersRight, argPos, ary, arity
      ];

      var result = wrapFunc.apply(undefined, newData);
      if (isLaziable(func)) {
        setData(result, newData);
      }
      result.placeholder = placeholder;
      return setWrapToString(result, func, bitmask);
    }

    /**
     * Creates a function like `_.round`.
     *
     * @private
     * @param {string} methodName The name of the `Math` method to use when rounding.
     * @returns {Function} Returns the new round function.
     */
    function createRound(methodName) {
      var func = Math[methodName];
      return function(number, precision) {
        number = toNumber(number);
        precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);
        if (precision && nativeIsFinite(number)) {
          // Shift with exponential notation to avoid floating-point issues.
          // See [MDN](https://mdn.io/round#Examples) for more details.
          var pair = (toString(number) + 'e').split('e'),
              value = func(pair[0] + 'e' + (+pair[1] + precision));

          pair = (toString(value) + 'e').split('e');
          return +(pair[0] + 'e' + (+pair[1] - precision));
        }
        return func(number);
      };
    }

    /**
     * Creates a set object of `values`.
     *
     * @private
     * @param {Array} values The values to add to the set.
     * @returns {Object} Returns the new set.
     */
    var createSet = !(Set && (1 / setToArray(new Set([,-0]))[1]) == INFINITY) ? noop : function(values) {
      return new Set(values);
    };

    /**
     * Creates a `_.toPairs` or `_.toPairsIn` function.
     *
     * @private
     * @param {Function} keysFunc The function to get the keys of a given object.
     * @returns {Function} Returns the new pairs function.
     */
    function createToPairs(keysFunc) {
      return function(object) {
        var tag = getTag(object);
        if (tag == mapTag) {
          return mapToArray(object);
        }
        if (tag == setTag) {
          return setToPairs(object);
        }
        return baseToPairs(object, keysFunc(object));
      };
    }

    /**
     * Creates a function that either curries or invokes `func` with optional
     * `this` binding and partially applied arguments.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags.
     *    1 - `_.bind`
     *    2 - `_.bindKey`
     *    4 - `_.curry` or `_.curryRight` of a bound function
     *    8 - `_.curry`
     *   16 - `_.curryRight`
     *   32 - `_.partial`
     *   64 - `_.partialRight`
     *  128 - `_.rearg`
     *  256 - `_.ary`
     *  512 - `_.flip`
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to be partially applied.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
      var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
      if (!isBindKey && typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      var length = partials ? partials.length : 0;
      if (!length) {
        bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
        partials = holders = undefined;
      }
      ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
      arity = arity === undefined ? arity : toInteger(arity);
      length -= holders ? holders.length : 0;

      if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
        var partialsRight = partials,
            holdersRight = holders;

        partials = holders = undefined;
      }
      var data = isBindKey ? undefined : getData(func);

      var newData = [
        func, bitmask, thisArg, partials, holders, partialsRight, holdersRight,
        argPos, ary, arity
      ];

      if (data) {
        mergeData(newData, data);
      }
      func = newData[0];
      bitmask = newData[1];
      thisArg = newData[2];
      partials = newData[3];
      holders = newData[4];
      arity = newData[9] = newData[9] === undefined
        ? (isBindKey ? 0 : func.length)
        : nativeMax(newData[9] - length, 0);

      if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) {
        bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
      }
      if (!bitmask || bitmask == WRAP_BIND_FLAG) {
        var result = createBind(func, bitmask, thisArg);
      } else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) {
        result = createCurry(func, bitmask, arity);
      } else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) {
        result = createPartial(func, bitmask, thisArg, partials);
      } else {
        result = createHybrid.apply(undefined, newData);
      }
      var setter = data ? baseSetData : setData;
      return setWrapToString(setter(result, newData), func, bitmask);
    }

    /**
     * Used by `_.defaults` to customize its `_.assignIn` use to assign properties
     * of source objects to the destination object for all destination properties
     * that resolve to `undefined`.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to assign.
     * @param {Object} object The parent object of `objValue`.
     * @returns {*} Returns the value to assign.
     */
    function customDefaultsAssignIn(objValue, srcValue, key, object) {
      if (objValue === undefined ||
          (eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key))) {
        return srcValue;
      }
      return objValue;
    }

    /**
     * Used by `_.defaultsDeep` to customize its `_.merge` use to merge source
     * objects into destination objects that are passed thru.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to merge.
     * @param {Object} object The parent object of `objValue`.
     * @param {Object} source The parent object of `srcValue`.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     * @returns {*} Returns the value to assign.
     */
    function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
      if (isObject(objValue) && isObject(srcValue)) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, objValue);
        baseMerge(objValue, srcValue, undefined, customDefaultsMerge, stack);
        stack['delete'](srcValue);
      }
      return objValue;
    }

    /**
     * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
     * objects.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {string} key The key of the property to inspect.
     * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
     */
    function customOmitClone(value) {
      return isPlainObject(value) ? undefined : value;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for arrays with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Array} array The array to compare.
     * @param {Array} other The other array to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `array` and `other` objects.
     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
     */
    function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
          arrLength = array.length,
          othLength = other.length;

      if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
        return false;
      }
      // Check that cyclic values are equal.
      var arrStacked = stack.get(array);
      var othStacked = stack.get(other);
      if (arrStacked && othStacked) {
        return arrStacked == other && othStacked == array;
      }
      var index = -1,
          result = true,
          seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;

      stack.set(array, other);
      stack.set(other, array);

      // Ignore non-index properties.
      while (++index < arrLength) {
        var arrValue = array[index],
            othValue = other[index];

        if (customizer) {
          var compared = isPartial
            ? customizer(othValue, arrValue, index, other, array, stack)
            : customizer(arrValue, othValue, index, array, other, stack);
        }
        if (compared !== undefined) {
          if (compared) {
            continue;
          }
          result = false;
          break;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (seen) {
          if (!arraySome(other, function(othValue, othIndex) {
                if (!cacheHas(seen, othIndex) &&
                    (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
                  return seen.push(othIndex);
                }
              })) {
            result = false;
            break;
          }
        } else if (!(
              arrValue === othValue ||
                equalFunc(arrValue, othValue, bitmask, customizer, stack)
            )) {
          result = false;
          break;
        }
      }
      stack['delete'](array);
      stack['delete'](other);
      return result;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for comparing objects of
     * the same `toStringTag`.
     *
     * **Note:** This function only supports comparing values with tags of
     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {string} tag The `toStringTag` of the objects to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
      switch (tag) {
        case dataViewTag:
          if ((object.byteLength != other.byteLength) ||
              (object.byteOffset != other.byteOffset)) {
            return false;
          }
          object = object.buffer;
          other = other.buffer;

        case arrayBufferTag:
          if ((object.byteLength != other.byteLength) ||
              !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
            return false;
          }
          return true;

        case boolTag:
        case dateTag:
        case numberTag:
          // Coerce booleans to `1` or `0` and dates to milliseconds.
          // Invalid dates are coerced to `NaN`.
          return eq(+object, +other);

        case errorTag:
          return object.name == other.name && object.message == other.message;

        case regexpTag:
        case stringTag:
          // Coerce regexes to strings and treat strings, primitives and objects,
          // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
          // for more details.
          return object == (other + '');

        case mapTag:
          var convert = mapToArray;

        case setTag:
          var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
          convert || (convert = setToArray);

          if (object.size != other.size && !isPartial) {
            return false;
          }
          // Assume cyclic values are equal.
          var stacked = stack.get(object);
          if (stacked) {
            return stacked == other;
          }
          bitmask |= COMPARE_UNORDERED_FLAG;

          // Recursively compare objects (susceptible to call stack limits).
          stack.set(object, other);
          var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
          stack['delete'](object);
          return result;

        case symbolTag:
          if (symbolValueOf) {
            return symbolValueOf.call(object) == symbolValueOf.call(other);
          }
      }
      return false;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for objects with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
          objProps = getAllKeys(object),
          objLength = objProps.length,
          othProps = getAllKeys(other),
          othLength = othProps.length;

      if (objLength != othLength && !isPartial) {
        return false;
      }
      var index = objLength;
      while (index--) {
        var key = objProps[index];
        if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
          return false;
        }
      }
      // Check that cyclic values are equal.
      var objStacked = stack.get(object);
      var othStacked = stack.get(other);
      if (objStacked && othStacked) {
        return objStacked == other && othStacked == object;
      }
      var result = true;
      stack.set(object, other);
      stack.set(other, object);

      var skipCtor = isPartial;
      while (++index < objLength) {
        key = objProps[index];
        var objValue = object[key],
            othValue = other[key];

        if (customizer) {
          var compared = isPartial
            ? customizer(othValue, objValue, key, other, object, stack)
            : customizer(objValue, othValue, key, object, other, stack);
        }
        // Recursively compare objects (susceptible to call stack limits).
        if (!(compared === undefined
              ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
              : compared
            )) {
          result = false;
          break;
        }
        skipCtor || (skipCtor = key == 'constructor');
      }
      if (result && !skipCtor) {
        var objCtor = object.constructor,
            othCtor = other.constructor;

        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor &&
            ('constructor' in object && 'constructor' in other) &&
            !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
              typeof othCtor == 'function' && othCtor instanceof othCtor)) {
          result = false;
        }
      }
      stack['delete'](object);
      stack['delete'](other);
      return result;
    }

    /**
     * A specialized version of `baseRest` which flattens the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */
    function flatRest(func) {
      return setToString(overRest(func, undefined, flatten), func + '');
    }

    /**
     * Creates an array of own enumerable property names and symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function getAllKeys(object) {
      return baseGetAllKeys(object, keys, getSymbols);
    }

    /**
     * Creates an array of own and inherited enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function getAllKeysIn(object) {
      return baseGetAllKeys(object, keysIn, getSymbolsIn);
    }

    /**
     * Gets metadata for `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {*} Returns the metadata for `func`.
     */
    var getData = !metaMap ? noop : function(func) {
      return metaMap.get(func);
    };

    /**
     * Gets the name of `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {string} Returns the function name.
     */
    function getFuncName(func) {
      var result = (func.name + ''),
          array = realNames[result],
          length = hasOwnProperty.call(realNames, result) ? array.length : 0;

      while (length--) {
        var data = array[length],
            otherFunc = data.func;
        if (otherFunc == null || otherFunc == func) {
          return data.name;
        }
      }
      return result;
    }

    /**
     * Gets the argument placeholder value for `func`.
     *
     * @private
     * @param {Function} func The function to inspect.
     * @returns {*} Returns the placeholder value.
     */
    function getHolder(func) {
      var object = hasOwnProperty.call(lodash, 'placeholder') ? lodash : func;
      return object.placeholder;
    }

    /**
     * Gets the appropriate "iteratee" function. If `_.iteratee` is customized,
     * this function returns the custom method, otherwise it returns `baseIteratee`.
     * If arguments are provided, the chosen function is invoked with them and
     * its result is returned.
     *
     * @private
     * @param {*} [value] The value to convert to an iteratee.
     * @param {number} [arity] The arity of the created iteratee.
     * @returns {Function} Returns the chosen function or its result.
     */
    function getIteratee() {
      var result = lodash.iteratee || iteratee;
      result = result === iteratee ? baseIteratee : result;
      return arguments.length ? result(arguments[0], arguments[1]) : result;
    }

    /**
     * Gets the data for `map`.
     *
     * @private
     * @param {Object} map The map to query.
     * @param {string} key The reference key.
     * @returns {*} Returns the map data.
     */
    function getMapData(map, key) {
      var data = map.__data__;
      return isKeyable(key)
        ? data[typeof key == 'string' ? 'string' : 'hash']
        : data.map;
    }

    /**
     * Gets the property names, values, and compare flags of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the match data of `object`.
     */
    function getMatchData(object) {
      var result = keys(object),
          length = result.length;

      while (length--) {
        var key = result[length],
            value = object[key];

        result[length] = [key, value, isStrictComparable(value)];
      }
      return result;
    }

    /**
     * Gets the native function at `key` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the method to get.
     * @returns {*} Returns the function if it's native, else `undefined`.
     */
    function getNative(object, key) {
      var value = getValue(object, key);
      return baseIsNative(value) ? value : undefined;
    }

    /**
     * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the raw `toStringTag`.
     */
    function getRawTag(value) {
      var isOwn = hasOwnProperty.call(value, symToStringTag),
          tag = value[symToStringTag];

      try {
        value[symToStringTag] = undefined;
        var unmasked = true;
      } catch (e) {}

      var result = nativeObjectToString.call(value);
      if (unmasked) {
        if (isOwn) {
          value[symToStringTag] = tag;
        } else {
          delete value[symToStringTag];
        }
      }
      return result;
    }

    /**
     * Creates an array of the own enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */
    var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
      if (object == null) {
        return [];
      }
      object = Object(object);
      return arrayFilter(nativeGetSymbols(object), function(symbol) {
        return propertyIsEnumerable.call(object, symbol);
      });
    };

    /**
     * Creates an array of the own and inherited enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */
    var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
      var result = [];
      while (object) {
        arrayPush(result, getSymbols(object));
        object = getPrototype(object);
      }
      return result;
    };

    /**
     * Gets the `toStringTag` of `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */
    var getTag = baseGetTag;

    // Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
    if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
        (Map && getTag(new Map) != mapTag) ||
        (Promise && getTag(Promise.resolve()) != promiseTag) ||
        (Set && getTag(new Set) != setTag) ||
        (WeakMap && getTag(new WeakMap) != weakMapTag)) {
      getTag = function(value) {
        var result = baseGetTag(value),
            Ctor = result == objectTag ? value.constructor : undefined,
            ctorString = Ctor ? toSource(Ctor) : '';

        if (ctorString) {
          switch (ctorString) {
            case dataViewCtorString: return dataViewTag;
            case mapCtorString: return mapTag;
            case promiseCtorString: return promiseTag;
            case setCtorString: return setTag;
            case weakMapCtorString: return weakMapTag;
          }
        }
        return result;
      };
    }

    /**
     * Gets the view, applying any `transforms` to the `start` and `end` positions.
     *
     * @private
     * @param {number} start The start of the view.
     * @param {number} end The end of the view.
     * @param {Array} transforms The transformations to apply to the view.
     * @returns {Object} Returns an object containing the `start` and `end`
     *  positions of the view.
     */
    function getView(start, end, transforms) {
      var index = -1,
          length = transforms.length;

      while (++index < length) {
        var data = transforms[index],
            size = data.size;

        switch (data.type) {
          case 'drop':      start += size; break;
          case 'dropRight': end -= size; break;
          case 'take':      end = nativeMin(end, start + size); break;
          case 'takeRight': start = nativeMax(start, end - size); break;
        }
      }
      return { 'start': start, 'end': end };
    }

    /**
     * Extracts wrapper details from the `source` body comment.
     *
     * @private
     * @param {string} source The source to inspect.
     * @returns {Array} Returns the wrapper details.
     */
    function getWrapDetails(source) {
      var match = source.match(reWrapDetails);
      return match ? match[1].split(reSplitDetails) : [];
    }

    /**
     * Checks if `path` exists on `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @param {Function} hasFunc The function to check properties.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     */
    function hasPath(object, path, hasFunc) {
      path = castPath(path, object);

      var index = -1,
          length = path.length,
          result = false;

      while (++index < length) {
        var key = toKey(path[index]);
        if (!(result = object != null && hasFunc(object, key))) {
          break;
        }
        object = object[key];
      }
      if (result || ++index != length) {
        return result;
      }
      length = object == null ? 0 : object.length;
      return !!length && isLength(length) && isIndex(key, length) &&
        (isArray(object) || isArguments(object));
    }

    /**
     * Initializes an array clone.
     *
     * @private
     * @param {Array} array The array to clone.
     * @returns {Array} Returns the initialized clone.
     */
    function initCloneArray(array) {
      var length = array.length,
          result = new array.constructor(length);

      // Add properties assigned by `RegExp#exec`.
      if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
        result.index = array.index;
        result.input = array.input;
      }
      return result;
    }

    /**
     * Initializes an object clone.
     *
     * @private
     * @param {Object} object The object to clone.
     * @returns {Object} Returns the initialized clone.
     */
    function initCloneObject(object) {
      return (typeof object.constructor == 'function' && !isPrototype(object))
        ? baseCreate(getPrototype(object))
        : {};
    }

    /**
     * Initializes an object clone based on its `toStringTag`.
     *
     * **Note:** This function only supports cloning values with tags of
     * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
     *
     * @private
     * @param {Object} object The object to clone.
     * @param {string} tag The `toStringTag` of the object to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the initialized clone.
     */
    function initCloneByTag(object, tag, isDeep) {
      var Ctor = object.constructor;
      switch (tag) {
        case arrayBufferTag:
          return cloneArrayBuffer(object);

        case boolTag:
        case dateTag:
          return new Ctor(+object);

        case dataViewTag:
          return cloneDataView(object, isDeep);

        case float32Tag: case float64Tag:
        case int8Tag: case int16Tag: case int32Tag:
        case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
          return cloneTypedArray(object, isDeep);

        case mapTag:
          return new Ctor;

        case numberTag:
        case stringTag:
          return new Ctor(object);

        case regexpTag:
          return cloneRegExp(object);

        case setTag:
          return new Ctor;

        case symbolTag:
          return cloneSymbol(object);
      }
    }

    /**
     * Inserts wrapper `details` in a comment at the top of the `source` body.
     *
     * @private
     * @param {string} source The source to modify.
     * @returns {Array} details The details to insert.
     * @returns {string} Returns the modified source.
     */
    function insertWrapDetails(source, details) {
      var length = details.length;
      if (!length) {
        return source;
      }
      var lastIndex = length - 1;
      details[lastIndex] = (length > 1 ? '& ' : '') + details[lastIndex];
      details = details.join(length > 2 ? ', ' : ' ');
      return source.replace(reWrapComment, '{\n/* [wrapped with ' + details + '] */\n');
    }

    /**
     * Checks if `value` is a flattenable `arguments` object or array.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
     */
    function isFlattenable(value) {
      return isArray(value) || isArguments(value) ||
        !!(spreadableSymbol && value && value[spreadableSymbol]);
    }

    /**
     * Checks if `value` is a valid array-like index.
     *
     * @private
     * @param {*} value The value to check.
     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
     */
    function isIndex(value, length) {
      var type = typeof value;
      length = length == null ? MAX_SAFE_INTEGER : length;

      return !!length &&
        (type == 'number' ||
          (type != 'symbol' && reIsUint.test(value))) &&
            (value > -1 && value % 1 == 0 && value < length);
    }

    /**
     * Checks if the given arguments are from an iteratee call.
     *
     * @private
     * @param {*} value The potential iteratee value argument.
     * @param {*} index The potential iteratee index or key argument.
     * @param {*} object The potential iteratee object argument.
     * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
     *  else `false`.
     */
    function isIterateeCall(value, index, object) {
      if (!isObject(object)) {
        return false;
      }
      var type = typeof index;
      if (type == 'number'
            ? (isArrayLike(object) && isIndex(index, object.length))
            : (type == 'string' && index in object)
          ) {
        return eq(object[index], value);
      }
      return false;
    }

    /**
     * Checks if `value` is a property name and not a property path.
     *
     * @private
     * @param {*} value The value to check.
     * @param {Object} [object] The object to query keys on.
     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
     */
    function isKey(value, object) {
      if (isArray(value)) {
        return false;
      }
      var type = typeof value;
      if (type == 'number' || type == 'symbol' || type == 'boolean' ||
          value == null || isSymbol(value)) {
        return true;
      }
      return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
        (object != null && value in Object(object));
    }

    /**
     * Checks if `value` is suitable for use as unique object key.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
     */
    function isKeyable(value) {
      var type = typeof value;
      return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
        ? (value !== '__proto__')
        : (value === null);
    }

    /**
     * Checks if `func` has a lazy counterpart.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
     *  else `false`.
     */
    function isLaziable(func) {
      var funcName = getFuncName(func),
          other = lodash[funcName];

      if (typeof other != 'function' || !(funcName in LazyWrapper.prototype)) {
        return false;
      }
      if (func === other) {
        return true;
      }
      var data = getData(other);
      return !!data && func === data[0];
    }

    /**
     * Checks if `func` has its source masked.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` is masked, else `false`.
     */
    function isMasked(func) {
      return !!maskSrcKey && (maskSrcKey in func);
    }

    /**
     * Checks if `func` is capable of being masked.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `func` is maskable, else `false`.
     */
    var isMaskable = coreJsData ? isFunction : stubFalse;

    /**
     * Checks if `value` is likely a prototype object.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
     */
    function isPrototype(value) {
      var Ctor = value && value.constructor,
          proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

      return value === proto;
    }

    /**
     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` if suitable for strict
     *  equality comparisons, else `false`.
     */
    function isStrictComparable(value) {
      return value === value && !isObject(value);
    }

    /**
     * A specialized version of `matchesProperty` for source values suitable
     * for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {string} key The key of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */
    function matchesStrictComparable(key, srcValue) {
      return function(object) {
        if (object == null) {
          return false;
        }
        return object[key] === srcValue &&
          (srcValue !== undefined || (key in Object(object)));
      };
    }

    /**
     * A specialized version of `_.memoize` which clears the memoized function's
     * cache when it exceeds `MAX_MEMOIZE_SIZE`.
     *
     * @private
     * @param {Function} func The function to have its output memoized.
     * @returns {Function} Returns the new memoized function.
     */
    function memoizeCapped(func) {
      var result = memoize(func, function(key) {
        if (cache.size === MAX_MEMOIZE_SIZE) {
          cache.clear();
        }
        return key;
      });

      var cache = result.cache;
      return result;
    }

    /**
     * Merges the function metadata of `source` into `data`.
     *
     * Merging metadata reduces the number of wrappers used to invoke a function.
     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
     * may be applied regardless of execution order. Methods like `_.ary` and
     * `_.rearg` modify function arguments, making the order in which they are
     * executed important, preventing the merging of metadata. However, we make
     * an exception for a safe combined case where curried functions have `_.ary`
     * and or `_.rearg` applied.
     *
     * @private
     * @param {Array} data The destination metadata.
     * @param {Array} source The source metadata.
     * @returns {Array} Returns `data`.
     */
    function mergeData(data, source) {
      var bitmask = data[1],
          srcBitmask = source[1],
          newBitmask = bitmask | srcBitmask,
          isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);

      var isCombo =
        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_CURRY_FLAG)) ||
        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_REARG_FLAG) && (data[7].length <= source[8])) ||
        ((srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG)) && (source[7].length <= source[8]) && (bitmask == WRAP_CURRY_FLAG));

      // Exit early if metadata can't be merged.
      if (!(isCommon || isCombo)) {
        return data;
      }
      // Use source `thisArg` if available.
      if (srcBitmask & WRAP_BIND_FLAG) {
        data[2] = source[2];
        // Set when currying a bound function.
        newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
      }
      // Compose partial arguments.
      var value = source[3];
      if (value) {
        var partials = data[3];
        data[3] = partials ? composeArgs(partials, value, source[4]) : value;
        data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
      }
      // Compose partial right arguments.
      value = source[5];
      if (value) {
        partials = data[5];
        data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
        data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
      }
      // Use source `argPos` if available.
      value = source[7];
      if (value) {
        data[7] = value;
      }
      // Use source `ary` if it's smaller.
      if (srcBitmask & WRAP_ARY_FLAG) {
        data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
      }
      // Use source `arity` if one is not provided.
      if (data[9] == null) {
        data[9] = source[9];
      }
      // Use source `func` and merge bitmasks.
      data[0] = source[0];
      data[1] = newBitmask;

      return data;
    }

    /**
     * This function is like
     * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * except that it includes inherited enumerable properties.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function nativeKeysIn(object) {
      var result = [];
      if (object != null) {
        for (var key in Object(object)) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * Converts `value` to a string using `Object.prototype.toString`.
     *
     * @private
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     */
    function objectToString(value) {
      return nativeObjectToString.call(value);
    }

    /**
     * A specialized version of `baseRest` which transforms the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @param {Function} transform The rest array transform.
     * @returns {Function} Returns the new function.
     */
    function overRest(func, start, transform) {
      start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
      return function() {
        var args = arguments,
            index = -1,
            length = nativeMax(args.length - start, 0),
            array = Array(length);

        while (++index < length) {
          array[index] = args[start + index];
        }
        index = -1;
        var otherArgs = Array(start + 1);
        while (++index < start) {
          otherArgs[index] = args[index];
        }
        otherArgs[start] = transform(array);
        return apply(func, this, otherArgs);
      };
    }

    /**
     * Gets the parent value at `path` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array} path The path to get the parent value of.
     * @returns {*} Returns the parent value.
     */
    function parent(object, path) {
      return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
    }

    /**
     * Reorder `array` according to the specified indexes where the element at
     * the first index is assigned as the first element, the element at
     * the second index is assigned as the second element, and so on.
     *
     * @private
     * @param {Array} array The array to reorder.
     * @param {Array} indexes The arranged array indexes.
     * @returns {Array} Returns `array`.
     */
    function reorder(array, indexes) {
      var arrLength = array.length,
          length = nativeMin(indexes.length, arrLength),
          oldArray = copyArray(array);

      while (length--) {
        var index = indexes[length];
        array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
      }
      return array;
    }

    /**
     * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the property to get.
     * @returns {*} Returns the property value.
     */
    function safeGet(object, key) {
      if (key === 'constructor' && typeof object[key] === 'function') {
        return;
      }

      if (key == '__proto__') {
        return;
      }

      return object[key];
    }

    /**
     * Sets metadata for `func`.
     *
     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
     * period of time, it will trip its breaker and transition to an identity
     * function to avoid garbage collection pauses in V8. See
     * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
     * for more details.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */
    var setData = shortOut(baseSetData);

    /**
     * A simple wrapper around the global [`setTimeout`](https://mdn.io/setTimeout).
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @returns {number|Object} Returns the timer id or timeout object.
     */
    var setTimeout = ctxSetTimeout || function(func, wait) {
      return root.setTimeout(func, wait);
    };

    /**
     * Sets the `toString` method of `func` to return `string`.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */
    var setToString = shortOut(baseSetToString);

    /**
     * Sets the `toString` method of `wrapper` to mimic the source of `reference`
     * with wrapper details in a comment at the top of the source body.
     *
     * @private
     * @param {Function} wrapper The function to modify.
     * @param {Function} reference The reference function.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Function} Returns `wrapper`.
     */
    function setWrapToString(wrapper, reference, bitmask) {
      var source = (reference + '');
      return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
    }

    /**
     * Creates a function that'll short out and invoke `identity` instead
     * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
     * milliseconds.
     *
     * @private
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new shortable function.
     */
    function shortOut(func) {
      var count = 0,
          lastCalled = 0;

      return function() {
        var stamp = nativeNow(),
            remaining = HOT_SPAN - (stamp - lastCalled);

        lastCalled = stamp;
        if (remaining > 0) {
          if (++count >= HOT_COUNT) {
            return arguments[0];
          }
        } else {
          count = 0;
        }
        return func.apply(undefined, arguments);
      };
    }

    /**
     * A specialized version of `_.shuffle` which mutates and sets the size of `array`.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @param {number} [size=array.length] The size of `array`.
     * @returns {Array} Returns `array`.
     */
    function shuffleSelf(array, size) {
      var index = -1,
          length = array.length,
          lastIndex = length - 1;

      size = size === undefined ? length : size;
      while (++index < size) {
        var rand = baseRandom(index, lastIndex),
            value = array[rand];

        array[rand] = array[index];
        array[index] = value;
      }
      array.length = size;
      return array;
    }

    /**
     * Converts `string` to a property path array.
     *
     * @private
     * @param {string} string The string to convert.
     * @returns {Array} Returns the property path array.
     */
    var stringToPath = memoizeCapped(function(string) {
      var result = [];
      if (string.charCodeAt(0) === 46 /* . */) {
        result.push('');
      }
      string.replace(rePropName, function(match, number, quote, subString) {
        result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
      });
      return result;
    });

    /**
     * Converts `value` to a string key if it's not a string or symbol.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {string|symbol} Returns the key.
     */
    function toKey(value) {
      if (typeof value == 'string' || isSymbol(value)) {
        return value;
      }
      var result = (value + '');
      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
    }

    /**
     * Converts `func` to its source code.
     *
     * @private
     * @param {Function} func The function to convert.
     * @returns {string} Returns the source code.
     */
    function toSource(func) {
      if (func != null) {
        try {
          return funcToString.call(func);
        } catch (e) {}
        try {
          return (func + '');
        } catch (e) {}
      }
      return '';
    }

    /**
     * Updates wrapper `details` based on `bitmask` flags.
     *
     * @private
     * @returns {Array} details The details to modify.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Array} Returns `details`.
     */
    function updateWrapDetails(details, bitmask) {
      arrayEach(wrapFlags, function(pair) {
        var value = '_.' + pair[0];
        if ((bitmask & pair[1]) && !arrayIncludes(details, value)) {
          details.push(value);
        }
      });
      return details.sort();
    }

    /**
     * Creates a clone of `wrapper`.
     *
     * @private
     * @param {Object} wrapper The wrapper to clone.
     * @returns {Object} Returns the cloned wrapper.
     */
    function wrapperClone(wrapper) {
      if (wrapper instanceof LazyWrapper) {
        return wrapper.clone();
      }
      var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
      result.__actions__ = copyArray(wrapper.__actions__);
      result.__index__  = wrapper.__index__;
      result.__values__ = wrapper.__values__;
      return result;
    }

    /*------------------------------------------------------------------------*/

    /**
     * Creates an array of elements split into groups the length of `size`.
     * If `array` can't be split evenly, the final chunk will be the remaining
     * elements.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to process.
     * @param {number} [size=1] The length of each chunk
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the new array of chunks.
     * @example
     *
     * _.chunk(['a', 'b', 'c', 'd'], 2);
     * // => [['a', 'b'], ['c', 'd']]
     *
     * _.chunk(['a', 'b', 'c', 'd'], 3);
     * // => [['a', 'b', 'c'], ['d']]
     */
    function chunk(array, size, guard) {
      if ((guard ? isIterateeCall(array, size, guard) : size === undefined)) {
        size = 1;
      } else {
        size = nativeMax(toInteger(size), 0);
      }
      var length = array == null ? 0 : array.length;
      if (!length || size < 1) {
        return [];
      }
      var index = 0,
          resIndex = 0,
          result = Array(nativeCeil(length / size));

      while (index < length) {
        result[resIndex++] = baseSlice(array, index, (index += size));
      }
      return result;
    }

    /**
     * Creates an array with all falsey values removed. The values `false`, `null`,
     * `0`, `""`, `undefined`, and `NaN` are falsey.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to compact.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.compact([0, 1, false, 2, '', 3]);
     * // => [1, 2, 3]
     */
    function compact(array) {
      var index = -1,
          length = array == null ? 0 : array.length,
          resIndex = 0,
          result = [];

      while (++index < length) {
        var value = array[index];
        if (value) {
          result[resIndex++] = value;
        }
      }
      return result;
    }

    /**
     * Creates a new array concatenating `array` with any additional arrays
     * and/or values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to concatenate.
     * @param {...*} [values] The values to concatenate.
     * @returns {Array} Returns the new concatenated array.
     * @example
     *
     * var array = [1];
     * var other = _.concat(array, 2, [3], [[4]]);
     *
     * console.log(other);
     * // => [1, 2, 3, [4]]
     *
     * console.log(array);
     * // => [1]
     */
    function concat() {
      var length = arguments.length;
      if (!length) {
        return [];
      }
      var args = Array(length - 1),
          array = arguments[0],
          index = length;

      while (index--) {
        args[index - 1] = arguments[index];
      }
      return arrayPush(isArray(array) ? copyArray(array) : [array], baseFlatten(args, 1));
    }

    /**
     * Creates an array of `array` values not included in the other given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * **Note:** Unlike `_.pullAll`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.without, _.xor
     * @example
     *
     * _.difference([2, 1], [2, 3]);
     * // => [1]
     */
    var difference = baseRest(function(array, values) {
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true))
        : [];
    });

    /**
     * This method is like `_.difference` except that it accepts `iteratee` which
     * is invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * **Note:** Unlike `_.pullAllBy`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.differenceBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.differenceBy([{ 'x': 2 }, { 'x': 1 }], [{ 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */
    var differenceBy = baseRest(function(array, values) {
      var iteratee = last(values);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), getIteratee(iteratee, 2))
        : [];
    });

    /**
     * This method is like `_.difference` except that it accepts `comparator`
     * which is invoked to compare elements of `array` to `values`. The order and
     * references of result values are determined by the first array. The comparator
     * is invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.pullAllWith`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     *
     * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }]
     */
    var differenceWith = baseRest(function(array, values) {
      var comparator = last(values);
      if (isArrayLikeObject(comparator)) {
        comparator = undefined;
      }
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), undefined, comparator)
        : [];
    });

    /**
     * Creates a slice of `array` with `n` elements dropped from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.drop([1, 2, 3]);
     * // => [2, 3]
     *
     * _.drop([1, 2, 3], 2);
     * // => [3]
     *
     * _.drop([1, 2, 3], 5);
     * // => []
     *
     * _.drop([1, 2, 3], 0);
     * // => [1, 2, 3]
     */
    function drop(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      return baseSlice(array, n < 0 ? 0 : n, length);
    }

    /**
     * Creates a slice of `array` with `n` elements dropped from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.dropRight([1, 2, 3]);
     * // => [1, 2]
     *
     * _.dropRight([1, 2, 3], 2);
     * // => [1]
     *
     * _.dropRight([1, 2, 3], 5);
     * // => []
     *
     * _.dropRight([1, 2, 3], 0);
     * // => [1, 2, 3]
     */
    function dropRight(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      n = length - n;
      return baseSlice(array, 0, n < 0 ? 0 : n);
    }

    /**
     * Creates a slice of `array` excluding elements dropped from the end.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.dropRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropRightWhile(users, ['active', false]);
     * // => objects for ['barney']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropRightWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */
    function dropRightWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), true, true)
        : [];
    }

    /**
     * Creates a slice of `array` excluding elements dropped from the beginning.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.dropWhile(users, function(o) { return !o.active; });
     * // => objects for ['pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropWhile(users, ['active', false]);
     * // => objects for ['pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */
    function dropWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), true)
        : [];
    }

    /**
     * Fills elements of `array` with `value` from `start` up to, but not
     * including, `end`.
     *
     * **Note:** This method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Array
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.fill(array, 'a');
     * console.log(array);
     * // => ['a', 'a', 'a']
     *
     * _.fill(Array(3), 2);
     * // => [2, 2, 2]
     *
     * _.fill([4, 6, 8, 10], '*', 1, 3);
     * // => [4, '*', '*', 10]
     */
    function fill(array, value, start, end) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      if (start && typeof start != 'number' && isIterateeCall(array, value, start)) {
        start = 0;
        end = length;
      }
      return baseFill(array, value, start, end);
    }

    /**
     * This method is like `_.find` except that it returns the index of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.findIndex(users, function(o) { return o.user == 'barney'; });
     * // => 0
     *
     * // The `_.matches` iteratee shorthand.
     * _.findIndex(users, { 'user': 'fred', 'active': false });
     * // => 1
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findIndex(users, ['active', false]);
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.findIndex(users, 'active');
     * // => 2
     */
    function findIndex(array, predicate, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = fromIndex == null ? 0 : toInteger(fromIndex);
      if (index < 0) {
        index = nativeMax(length + index, 0);
      }
      return baseFindIndex(array, getIteratee(predicate, 3), index);
    }

    /**
     * This method is like `_.findIndex` except that it iterates over elements
     * of `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
     * // => 2
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
     * // => 0
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastIndex(users, ['active', false]);
     * // => 2
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastIndex(users, 'active');
     * // => 0
     */
    function findLastIndex(array, predicate, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = length - 1;
      if (fromIndex !== undefined) {
        index = toInteger(fromIndex);
        index = fromIndex < 0
          ? nativeMax(length + index, 0)
          : nativeMin(index, length - 1);
      }
      return baseFindIndex(array, getIteratee(predicate, 3), index, true);
    }

    /**
     * Flattens `array` a single level deep.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flatten([1, [2, [3, [4]], 5]]);
     * // => [1, 2, [3, [4]], 5]
     */
    function flatten(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseFlatten(array, 1) : [];
    }

    /**
     * Recursively flattens `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flattenDeep([1, [2, [3, [4]], 5]]);
     * // => [1, 2, 3, 4, 5]
     */
    function flattenDeep(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseFlatten(array, INFINITY) : [];
    }

    /**
     * Recursively flatten `array` up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * var array = [1, [2, [3, [4]], 5]];
     *
     * _.flattenDepth(array, 1);
     * // => [1, 2, [3, [4]], 5]
     *
     * _.flattenDepth(array, 2);
     * // => [1, 2, 3, [4], 5]
     */
    function flattenDepth(array, depth) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      depth = depth === undefined ? 1 : toInteger(depth);
      return baseFlatten(array, depth);
    }

    /**
     * The inverse of `_.toPairs`; this method returns an object composed
     * from key-value `pairs`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} pairs The key-value pairs.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.fromPairs([['a', 1], ['b', 2]]);
     * // => { 'a': 1, 'b': 2 }
     */
    function fromPairs(pairs) {
      var index = -1,
          length = pairs == null ? 0 : pairs.length,
          result = {};

      while (++index < length) {
        var pair = pairs[index];
        result[pair[0]] = pair[1];
      }
      return result;
    }

    /**
     * Gets the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias first
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the first element of `array`.
     * @example
     *
     * _.head([1, 2, 3]);
     * // => 1
     *
     * _.head([]);
     * // => undefined
     */
    function head(array) {
      return (array && array.length) ? array[0] : undefined;
    }

    /**
     * Gets the index at which the first occurrence of `value` is found in `array`
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. If `fromIndex` is negative, it's used as the
     * offset from the end of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.indexOf([1, 2, 1, 2], 2);
     * // => 1
     *
     * // Search from the `fromIndex`.
     * _.indexOf([1, 2, 1, 2], 2, 2);
     * // => 3
     */
    function indexOf(array, value, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = fromIndex == null ? 0 : toInteger(fromIndex);
      if (index < 0) {
        index = nativeMax(length + index, 0);
      }
      return baseIndexOf(array, value, index);
    }

    /**
     * Gets all but the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.initial([1, 2, 3]);
     * // => [1, 2]
     */
    function initial(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseSlice(array, 0, -1) : [];
    }

    /**
     * Creates an array of unique values that are included in all given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersection([2, 1], [2, 3]);
     * // => [2]
     */
    var intersection = baseRest(function(arrays) {
      var mapped = arrayMap(arrays, castArrayLikeObject);
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped)
        : [];
    });

    /**
     * This method is like `_.intersection` except that it accepts `iteratee`
     * which is invoked for each element of each `arrays` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersectionBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [2.1]
     *
     * // The `_.property` iteratee shorthand.
     * _.intersectionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }]
     */
    var intersectionBy = baseRest(function(arrays) {
      var iteratee = last(arrays),
          mapped = arrayMap(arrays, castArrayLikeObject);

      if (iteratee === last(mapped)) {
        iteratee = undefined;
      } else {
        mapped.pop();
      }
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped, getIteratee(iteratee, 2))
        : [];
    });

    /**
     * This method is like `_.intersection` except that it accepts `comparator`
     * which is invoked to compare elements of `arrays`. The order and references
     * of result values are determined by the first array. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.intersectionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }]
     */
    var intersectionWith = baseRest(function(arrays) {
      var comparator = last(arrays),
          mapped = arrayMap(arrays, castArrayLikeObject);

      comparator = typeof comparator == 'function' ? comparator : undefined;
      if (comparator) {
        mapped.pop();
      }
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped, undefined, comparator)
        : [];
    });

    /**
     * Converts all elements in `array` into a string separated by `separator`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to convert.
     * @param {string} [separator=','] The element separator.
     * @returns {string} Returns the joined string.
     * @example
     *
     * _.join(['a', 'b', 'c'], '~');
     * // => 'a~b~c'
     */
    function join(array, separator) {
      return array == null ? '' : nativeJoin.call(array, separator);
    }

    /**
     * Gets the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the last element of `array`.
     * @example
     *
     * _.last([1, 2, 3]);
     * // => 3
     */
    function last(array) {
      var length = array == null ? 0 : array.length;
      return length ? array[length - 1] : undefined;
    }

    /**
     * This method is like `_.indexOf` except that it iterates over elements of
     * `array` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.lastIndexOf([1, 2, 1, 2], 2);
     * // => 3
     *
     * // Search from the `fromIndex`.
     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
     * // => 1
     */
    function lastIndexOf(array, value, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = length;
      if (fromIndex !== undefined) {
        index = toInteger(fromIndex);
        index = index < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
      }
      return value === value
        ? strictLastIndexOf(array, value, index)
        : baseFindIndex(array, baseIsNaN, index, true);
    }

    /**
     * Gets the element at index `n` of `array`. If `n` is negative, the nth
     * element from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.11.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=0] The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     *
     * _.nth(array, 1);
     * // => 'b'
     *
     * _.nth(array, -2);
     * // => 'c';
     */
    function nth(array, n) {
      return (array && array.length) ? baseNth(array, toInteger(n)) : undefined;
    }

    /**
     * Removes all given values from `array` using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
     * to remove elements from an array by predicate.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...*} [values] The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pull(array, 'a', 'c');
     * console.log(array);
     * // => ['b', 'b']
     */
    var pull = baseRest(pullAll);

    /**
     * This method is like `_.pull` except that it accepts an array of values to remove.
     *
     * **Note:** Unlike `_.difference`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pullAll(array, ['a', 'c']);
     * console.log(array);
     * // => ['b', 'b']
     */
    function pullAll(array, values) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values)
        : array;
    }

    /**
     * This method is like `_.pullAll` except that it accepts `iteratee` which is
     * invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The iteratee is invoked with one argument: (value).
     *
     * **Note:** Unlike `_.differenceBy`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1 }, { 'x': 2 }, { 'x': 3 }, { 'x': 1 }];
     *
     * _.pullAllBy(array, [{ 'x': 1 }, { 'x': 3 }], 'x');
     * console.log(array);
     * // => [{ 'x': 2 }]
     */
    function pullAllBy(array, values, iteratee) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values, getIteratee(iteratee, 2))
        : array;
    }

    /**
     * This method is like `_.pullAll` except that it accepts `comparator` which
     * is invoked to compare elements of `array` to `values`. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.differenceWith`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1, 'y': 2 }, { 'x': 3, 'y': 4 }, { 'x': 5, 'y': 6 }];
     *
     * _.pullAllWith(array, [{ 'x': 3, 'y': 4 }], _.isEqual);
     * console.log(array);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 5, 'y': 6 }]
     */
    function pullAllWith(array, values, comparator) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values, undefined, comparator)
        : array;
    }

    /**
     * Removes elements from `array` corresponding to `indexes` and returns an
     * array of removed elements.
     *
     * **Note:** Unlike `_.at`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...(number|number[])} [indexes] The indexes of elements to remove.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     * var pulled = _.pullAt(array, [1, 3]);
     *
     * console.log(array);
     * // => ['a', 'c']
     *
     * console.log(pulled);
     * // => ['b', 'd']
     */
    var pullAt = flatRest(function(array, indexes) {
      var length = array == null ? 0 : array.length,
          result = baseAt(array, indexes);

      basePullAt(array, arrayMap(indexes, function(index) {
        return isIndex(index, length) ? +index : index;
      }).sort(compareAscending));

      return result;
    });

    /**
     * Removes all elements from `array` that `predicate` returns truthy for
     * and returns an array of the removed elements. The predicate is invoked
     * with three arguments: (value, index, array).
     *
     * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
     * to pull elements from an array by value.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = [1, 2, 3, 4];
     * var evens = _.remove(array, function(n) {
     *   return n % 2 == 0;
     * });
     *
     * console.log(array);
     * // => [1, 3]
     *
     * console.log(evens);
     * // => [2, 4]
     */
    function remove(array, predicate) {
      var result = [];
      if (!(array && array.length)) {
        return result;
      }
      var index = -1,
          indexes = [],
          length = array.length;

      predicate = getIteratee(predicate, 3);
      while (++index < length) {
        var value = array[index];
        if (predicate(value, index, array)) {
          result.push(value);
          indexes.push(index);
        }
      }
      basePullAt(array, indexes);
      return result;
    }

    /**
     * Reverses `array` so that the first element becomes the last, the second
     * element becomes the second to last, and so on.
     *
     * **Note:** This method mutates `array` and is based on
     * [`Array#reverse`](https://mdn.io/Array/reverse).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.reverse(array);
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */
    function reverse(array) {
      return array == null ? array : nativeReverse.call(array);
    }

    /**
     * Creates a slice of `array` from `start` up to, but not including, `end`.
     *
     * **Note:** This method is used instead of
     * [`Array#slice`](https://mdn.io/Array/slice) to ensure dense arrays are
     * returned.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */
    function slice(array, start, end) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      if (end && typeof end != 'number' && isIterateeCall(array, start, end)) {
        start = 0;
        end = length;
      }
      else {
        start = start == null ? 0 : toInteger(start);
        end = end === undefined ? length : toInteger(end);
      }
      return baseSlice(array, start, end);
    }

    /**
     * Uses a binary search to determine the lowest index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedIndex([30, 50], 40);
     * // => 1
     */
    function sortedIndex(array, value) {
      return baseSortedIndex(array, value);
    }

    /**
     * This method is like `_.sortedIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedIndexBy(objects, { 'x': 4 }, 'x');
     * // => 0
     */
    function sortedIndexBy(array, value, iteratee) {
      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2));
    }

    /**
     * This method is like `_.indexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedIndexOf([4, 5, 5, 5, 6], 5);
     * // => 1
     */
    function sortedIndexOf(array, value) {
      var length = array == null ? 0 : array.length;
      if (length) {
        var index = baseSortedIndex(array, value);
        if (index < length && eq(array[index], value)) {
          return index;
        }
      }
      return -1;
    }

    /**
     * This method is like `_.sortedIndex` except that it returns the highest
     * index at which `value` should be inserted into `array` in order to
     * maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedLastIndex([4, 5, 5, 5, 6], 5);
     * // => 4
     */
    function sortedLastIndex(array, value) {
      return baseSortedIndex(array, value, true);
    }

    /**
     * This method is like `_.sortedLastIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedLastIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 1
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedLastIndexBy(objects, { 'x': 4 }, 'x');
     * // => 1
     */
    function sortedLastIndexBy(array, value, iteratee) {
      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2), true);
    }

    /**
     * This method is like `_.lastIndexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedLastIndexOf([4, 5, 5, 5, 6], 5);
     * // => 3
     */
    function sortedLastIndexOf(array, value) {
      var length = array == null ? 0 : array.length;
      if (length) {
        var index = baseSortedIndex(array, value, true) - 1;
        if (eq(array[index], value)) {
          return index;
        }
      }
      return -1;
    }

    /**
     * This method is like `_.uniq` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniq([1, 1, 2]);
     * // => [1, 2]
     */
    function sortedUniq(array) {
      return (array && array.length)
        ? baseSortedUniq(array)
        : [];
    }

    /**
     * This method is like `_.uniqBy` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniqBy([1.1, 1.2, 2.3, 2.4], Math.floor);
     * // => [1.1, 2.3]
     */
    function sortedUniqBy(array, iteratee) {
      return (array && array.length)
        ? baseSortedUniq(array, getIteratee(iteratee, 2))
        : [];
    }

    /**
     * Gets all but the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.tail([1, 2, 3]);
     * // => [2, 3]
     */
    function tail(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseSlice(array, 1, length) : [];
    }

    /**
     * Creates a slice of `array` with `n` elements taken from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.take([1, 2, 3]);
     * // => [1]
     *
     * _.take([1, 2, 3], 2);
     * // => [1, 2]
     *
     * _.take([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.take([1, 2, 3], 0);
     * // => []
     */
    function take(array, n, guard) {
      if (!(array && array.length)) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      return baseSlice(array, 0, n < 0 ? 0 : n);
    }

    /**
     * Creates a slice of `array` with `n` elements taken from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.takeRight([1, 2, 3]);
     * // => [3]
     *
     * _.takeRight([1, 2, 3], 2);
     * // => [2, 3]
     *
     * _.takeRight([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.takeRight([1, 2, 3], 0);
     * // => []
     */
    function takeRight(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      n = length - n;
      return baseSlice(array, n < 0 ? 0 : n, length);
    }

    /**
     * Creates a slice of `array` with elements taken from the end. Elements are
     * taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.takeRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeRightWhile(users, ['active', false]);
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeRightWhile(users, 'active');
     * // => []
     */
    function takeRightWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), false, true)
        : [];
    }

    /**
     * Creates a slice of `array` with elements taken from the beginning. Elements
     * are taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.takeWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeWhile(users, ['active', false]);
     * // => objects for ['barney', 'fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeWhile(users, 'active');
     * // => []
     */
    function takeWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3))
        : [];
    }

    /**
     * Creates an array of unique values, in order, from all given arrays using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.union([2], [1, 2]);
     * // => [2, 1]
     */
    var union = baseRest(function(arrays) {
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
    });

    /**
     * This method is like `_.union` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which uniqueness is computed. Result values are chosen from the first
     * array in which the value occurs. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.unionBy([2.1], [1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */
    var unionBy = baseRest(function(arrays) {
      var iteratee = last(arrays);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), getIteratee(iteratee, 2));
    });

    /**
     * This method is like `_.union` except that it accepts `comparator` which
     * is invoked to compare elements of `arrays`. Result values are chosen from
     * the first array in which the value occurs. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.unionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */
    var unionWith = baseRest(function(arrays) {
      var comparator = last(arrays);
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined, comparator);
    });

    /**
     * Creates a duplicate-free version of an array, using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons, in which only the first occurrence of each element
     * is kept. The order of result values is determined by the order they occur
     * in the array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniq([2, 1, 2]);
     * // => [2, 1]
     */
    function uniq(array) {
      return (array && array.length) ? baseUniq(array) : [];
    }

    /**
     * This method is like `_.uniq` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * uniqueness is computed. The order of result values is determined by the
     * order they occur in the array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */
    function uniqBy(array, iteratee) {
      return (array && array.length) ? baseUniq(array, getIteratee(iteratee, 2)) : [];
    }

    /**
     * This method is like `_.uniq` except that it accepts `comparator` which
     * is invoked to compare elements of `array`. The order of result values is
     * determined by the order they occur in the array.The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.uniqWith(objects, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
     */
    function uniqWith(array, comparator) {
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return (array && array.length) ? baseUniq(array, undefined, comparator) : [];
    }

    /**
     * This method is like `_.zip` except that it accepts an array of grouped
     * elements and creates an array regrouping the elements to their pre-zip
     * configuration.
     *
     * @static
     * @memberOf _
     * @since 1.2.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     *
     * _.unzip(zipped);
     * // => [['a', 'b'], [1, 2], [true, false]]
     */
    function unzip(array) {
      if (!(array && array.length)) {
        return [];
      }
      var length = 0;
      array = arrayFilter(array, function(group) {
        if (isArrayLikeObject(group)) {
          length = nativeMax(group.length, length);
          return true;
        }
      });
      return baseTimes(length, function(index) {
        return arrayMap(array, baseProperty(index));
      });
    }

    /**
     * This method is like `_.unzip` except that it accepts `iteratee` to specify
     * how regrouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  regrouped values.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
     * // => [[1, 10, 100], [2, 20, 200]]
     *
     * _.unzipWith(zipped, _.add);
     * // => [3, 30, 300]
     */
    function unzipWith(array, iteratee) {
      if (!(array && array.length)) {
        return [];
      }
      var result = unzip(array);
      if (iteratee == null) {
        return result;
      }
      return arrayMap(result, function(group) {
        return apply(iteratee, undefined, group);
      });
    }

    /**
     * Creates an array excluding all given values using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.pull`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...*} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.xor
     * @example
     *
     * _.without([2, 1, 2, 3], 1, 2);
     * // => [3]
     */
    var without = baseRest(function(array, values) {
      return isArrayLikeObject(array)
        ? baseDifference(array, values)
        : [];
    });

    /**
     * Creates an array of unique values that is the
     * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
     * of the given arrays. The order of result values is determined by the order
     * they occur in the arrays.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.without
     * @example
     *
     * _.xor([2, 1], [2, 3]);
     * // => [1, 3]
     */
    var xor = baseRest(function(arrays) {
      return baseXor(arrayFilter(arrays, isArrayLikeObject));
    });

    /**
     * This method is like `_.xor` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which by which they're compared. The order of result values is determined
     * by the order they occur in the arrays. The iteratee is invoked with one
     * argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.xorBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2, 3.4]
     *
     * // The `_.property` iteratee shorthand.
     * _.xorBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */
    var xorBy = baseRest(function(arrays) {
      var iteratee = last(arrays);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(iteratee, 2));
    });

    /**
     * This method is like `_.xor` except that it accepts `comparator` which is
     * invoked to compare elements of `arrays`. The order of result values is
     * determined by the order they occur in the arrays. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.xorWith(objects, others, _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */
    var xorWith = baseRest(function(arrays) {
      var comparator = last(arrays);
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined, comparator);
    });

    /**
     * Creates an array of grouped elements, the first of which contains the
     * first elements of the given arrays, the second of which contains the
     * second elements of the given arrays, and so on.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     */
    var zip = baseRest(unzip);

    /**
     * This method is like `_.fromPairs` except that it accepts two arrays,
     * one of property identifiers and one of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 0.4.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObject(['a', 'b'], [1, 2]);
     * // => { 'a': 1, 'b': 2 }
     */
    function zipObject(props, values) {
      return baseZipObject(props || [], values || [], assignValue);
    }

    /**
     * This method is like `_.zipObject` except that it supports property paths.
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObjectDeep(['a.b[0].c', 'a.b[1].d'], [1, 2]);
     * // => { 'a': { 'b': [{ 'c': 1 }, { 'd': 2 }] } }
     */
    function zipObjectDeep(props, values) {
      return baseZipObject(props || [], values || [], baseSet);
    }

    /**
     * This method is like `_.zip` except that it accepts `iteratee` to specify
     * how grouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  grouped values.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zipWith([1, 2], [10, 20], [100, 200], function(a, b, c) {
     *   return a + b + c;
     * });
     * // => [111, 222]
     */
    var zipWith = baseRest(function(arrays) {
      var length = arrays.length,
          iteratee = length > 1 ? arrays[length - 1] : undefined;

      iteratee = typeof iteratee == 'function' ? (arrays.pop(), iteratee) : undefined;
      return unzipWith(arrays, iteratee);
    });

    /*------------------------------------------------------------------------*/

    /**
     * Creates a `lodash` wrapper instance that wraps `value` with explicit method
     * chain sequences enabled. The result of such sequences must be unwrapped
     * with `_#value`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Seq
     * @param {*} value The value to wrap.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36 },
     *   { 'user': 'fred',    'age': 40 },
     *   { 'user': 'pebbles', 'age': 1 }
     * ];
     *
     * var youngest = _
     *   .chain(users)
     *   .sortBy('age')
     *   .map(function(o) {
     *     return o.user + ' is ' + o.age;
     *   })
     *   .head()
     *   .value();
     * // => 'pebbles is 1'
     */
    function chain(value) {
      var result = lodash(value);
      result.__chain__ = true;
      return result;
    }

    /**
     * This method invokes `interceptor` and returns `value`. The interceptor
     * is invoked with one argument; (value). The purpose of this method is to
     * "tap into" a method chain sequence in order to modify intermediate results.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns `value`.
     * @example
     *
     * _([1, 2, 3])
     *  .tap(function(array) {
     *    // Mutate input array.
     *    array.pop();
     *  })
     *  .reverse()
     *  .value();
     * // => [2, 1]
     */
    function tap(value, interceptor) {
      interceptor(value);
      return value;
    }

    /**
     * This method is like `_.tap` except that it returns the result of `interceptor`.
     * The purpose of this method is to "pass thru" values replacing intermediate
     * results in a method chain sequence.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns the result of `interceptor`.
     * @example
     *
     * _('  abc  ')
     *  .chain()
     *  .trim()
     *  .thru(function(value) {
     *    return [value];
     *  })
     *  .value();
     * // => ['abc']
     */
    function thru(value, interceptor) {
      return interceptor(value);
    }

    /**
     * This method is the wrapper version of `_.at`.
     *
     * @name at
     * @memberOf _
     * @since 1.0.0
     * @category Seq
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _(object).at(['a[0].b.c', 'a[1]']).value();
     * // => [3, 4]
     */
    var wrapperAt = flatRest(function(paths) {
      var length = paths.length,
          start = length ? paths[0] : 0,
          value = this.__wrapped__,
          interceptor = function(object) { return baseAt(object, paths); };

      if (length > 1 || this.__actions__.length ||
          !(value instanceof LazyWrapper) || !isIndex(start)) {
        return this.thru(interceptor);
      }
      value = value.slice(start, +start + (length ? 1 : 0));
      value.__actions__.push({
        'func': thru,
        'args': [interceptor],
        'thisArg': undefined
      });
      return new LodashWrapper(value, this.__chain__).thru(function(array) {
        if (length && !array.length) {
          array.push(undefined);
        }
        return array;
      });
    });

    /**
     * Creates a `lodash` wrapper instance with explicit method chain sequences enabled.
     *
     * @name chain
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 }
     * ];
     *
     * // A sequence without explicit chaining.
     * _(users).head();
     * // => { 'user': 'barney', 'age': 36 }
     *
     * // A sequence with explicit chaining.
     * _(users)
     *   .chain()
     *   .head()
     *   .pick('user')
     *   .value();
     * // => { 'user': 'barney' }
     */
    function wrapperChain() {
      return chain(this);
    }

    /**
     * Executes the chain sequence and returns the wrapped result.
     *
     * @name commit
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2];
     * var wrapped = _(array).push(3);
     *
     * console.log(array);
     * // => [1, 2]
     *
     * wrapped = wrapped.commit();
     * console.log(array);
     * // => [1, 2, 3]
     *
     * wrapped.last();
     * // => 3
     *
     * console.log(array);
     * // => [1, 2, 3]
     */
    function wrapperCommit() {
      return new LodashWrapper(this.value(), this.__chain__);
    }

    /**
     * Gets the next value on a wrapped object following the
     * [iterator protocol](https://mdn.io/iteration_protocols#iterator).
     *
     * @name next
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the next iterator value.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 1 }
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 2 }
     *
     * wrapped.next();
     * // => { 'done': true, 'value': undefined }
     */
    function wrapperNext() {
      if (this.__values__ === undefined) {
        this.__values__ = toArray(this.value());
      }
      var done = this.__index__ >= this.__values__.length,
          value = done ? undefined : this.__values__[this.__index__++];

      return { 'done': done, 'value': value };
    }

    /**
     * Enables the wrapper to be iterable.
     *
     * @name Symbol.iterator
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the wrapper object.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped[Symbol.iterator]() === wrapped;
     * // => true
     *
     * Array.from(wrapped);
     * // => [1, 2]
     */
    function wrapperToIterator() {
      return this;
    }

    /**
     * Creates a clone of the chain sequence planting `value` as the wrapped value.
     *
     * @name plant
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @param {*} value The value to plant.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2]).map(square);
     * var other = wrapped.plant([3, 4]);
     *
     * other.value();
     * // => [9, 16]
     *
     * wrapped.value();
     * // => [1, 4]
     */
    function wrapperPlant(value) {
      var result,
          parent = this;

      while (parent instanceof baseLodash) {
        var clone = wrapperClone(parent);
        clone.__index__ = 0;
        clone.__values__ = undefined;
        if (result) {
          previous.__wrapped__ = clone;
        } else {
          result = clone;
        }
        var previous = clone;
        parent = parent.__wrapped__;
      }
      previous.__wrapped__ = value;
      return result;
    }

    /**
     * This method is the wrapper version of `_.reverse`.
     *
     * **Note:** This method mutates the wrapped array.
     *
     * @name reverse
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _(array).reverse().value()
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */
    function wrapperReverse() {
      var value = this.__wrapped__;
      if (value instanceof LazyWrapper) {
        var wrapped = value;
        if (this.__actions__.length) {
          wrapped = new LazyWrapper(this);
        }
        wrapped = wrapped.reverse();
        wrapped.__actions__.push({
          'func': thru,
          'args': [reverse],
          'thisArg': undefined
        });
        return new LodashWrapper(wrapped, this.__chain__);
      }
      return this.thru(reverse);
    }

    /**
     * Executes the chain sequence to resolve the unwrapped value.
     *
     * @name value
     * @memberOf _
     * @since 0.1.0
     * @alias toJSON, valueOf
     * @category Seq
     * @returns {*} Returns the resolved unwrapped value.
     * @example
     *
     * _([1, 2, 3]).value();
     * // => [1, 2, 3]
     */
    function wrapperValue() {
      return baseWrapperValue(this.__wrapped__, this.__actions__);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the number of times the key was returned by `iteratee`. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.countBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': 1, '6': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.countBy(['one', 'two', 'three'], 'length');
     * // => { '3': 2, '5': 1 }
     */
    var countBy = createAggregator(function(result, value, key) {
      if (hasOwnProperty.call(result, key)) {
        ++result[key];
      } else {
        baseAssignValue(result, key, 1);
      }
    });

    /**
     * Checks if `predicate` returns truthy for **all** elements of `collection`.
     * Iteration is stopped once `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * **Note:** This method returns `true` for
     * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
     * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
     * elements of empty collections.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`.
     * @example
     *
     * _.every([true, 1, null, 'yes'], Boolean);
     * // => false
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.every(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.every(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.every(users, 'active');
     * // => false
     */
    function every(collection, predicate, guard) {
      var func = isArray(collection) ? arrayEvery : baseEvery;
      if (guard && isIterateeCall(collection, predicate, guard)) {
        predicate = undefined;
      }
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Iterates over elements of `collection`, returning an array of all elements
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * **Note:** Unlike `_.remove`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.reject
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * _.filter(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, { 'age': 36, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.filter(users, 'active');
     * // => objects for ['barney']
     *
     * // Combining several predicates using `_.overEvery` or `_.overSome`.
     * _.filter(users, _.overSome([{ 'age': 36 }, ['age', 40]]));
     * // => objects for ['fred', 'barney']
     */
    function filter(collection, predicate) {
      var func = isArray(collection) ? arrayFilter : baseFilter;
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Iterates over elements of `collection`, returning the first element
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': true },
     *   { 'user': 'fred',    'age': 40, 'active': false },
     *   { 'user': 'pebbles', 'age': 1,  'active': true }
     * ];
     *
     * _.find(users, function(o) { return o.age < 40; });
     * // => object for 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.find(users, { 'age': 1, 'active': true });
     * // => object for 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.find(users, ['active', false]);
     * // => object for 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.find(users, 'active');
     * // => object for 'barney'
     */
    var find = createFind(findIndex);

    /**
     * This method is like `_.find` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=collection.length-1] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * _.findLast([1, 2, 3, 4], function(n) {
     *   return n % 2 == 1;
     * });
     * // => 3
     */
    var findLast = createFind(findLastIndex);

    /**
     * Creates a flattened array of values by running each element in `collection`
     * thru `iteratee` and flattening the mapped results. The iteratee is invoked
     * with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [n, n];
     * }
     *
     * _.flatMap([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */
    function flatMap(collection, iteratee) {
      return baseFlatten(map(collection, iteratee), 1);
    }

    /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDeep([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */
    function flatMapDeep(collection, iteratee) {
      return baseFlatten(map(collection, iteratee), INFINITY);
    }

    /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDepth([1, 2], duplicate, 2);
     * // => [[1, 1], [2, 2]]
     */
    function flatMapDepth(collection, iteratee, depth) {
      depth = depth === undefined ? 1 : toInteger(depth);
      return baseFlatten(map(collection, iteratee), depth);
    }

    /**
     * Iterates over elements of `collection` and invokes `iteratee` for each element.
     * The iteratee is invoked with three arguments: (value, index|key, collection).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * **Note:** As with other "Collections" methods, objects with a "length"
     * property are iterated like arrays. To avoid this behavior use `_.forIn`
     * or `_.forOwn` for object iteration.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias each
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEachRight
     * @example
     *
     * _.forEach([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `1` then `2`.
     *
     * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */
    function forEach(collection, iteratee) {
      var func = isArray(collection) ? arrayEach : baseEach;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.forEach` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @alias eachRight
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEach
     * @example
     *
     * _.forEachRight([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `2` then `1`.
     */
    function forEachRight(collection, iteratee) {
      var func = isArray(collection) ? arrayEachRight : baseEachRight;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The order of grouped values
     * is determined by the order they occur in `collection`. The corresponding
     * value of each key is an array of elements responsible for generating the
     * key. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.groupBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': [4.2], '6': [6.1, 6.3] }
     *
     * // The `_.property` iteratee shorthand.
     * _.groupBy(['one', 'two', 'three'], 'length');
     * // => { '3': ['one', 'two'], '5': ['three'] }
     */
    var groupBy = createAggregator(function(result, value, key) {
      if (hasOwnProperty.call(result, key)) {
        result[key].push(value);
      } else {
        baseAssignValue(result, key, [value]);
      }
    });

    /**
     * Checks if `value` is in `collection`. If `collection` is a string, it's
     * checked for a substring of `value`, otherwise
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * is used for equality comparisons. If `fromIndex` is negative, it's used as
     * the offset from the end of `collection`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {boolean} Returns `true` if `value` is found, else `false`.
     * @example
     *
     * _.includes([1, 2, 3], 1);
     * // => true
     *
     * _.includes([1, 2, 3], 1, 2);
     * // => false
     *
     * _.includes({ 'a': 1, 'b': 2 }, 1);
     * // => true
     *
     * _.includes('abcd', 'bc');
     * // => true
     */
    function includes(collection, value, fromIndex, guard) {
      collection = isArrayLike(collection) ? collection : values(collection);
      fromIndex = (fromIndex && !guard) ? toInteger(fromIndex) : 0;

      var length = collection.length;
      if (fromIndex < 0) {
        fromIndex = nativeMax(length + fromIndex, 0);
      }
      return isString(collection)
        ? (fromIndex <= length && collection.indexOf(value, fromIndex) > -1)
        : (!!length && baseIndexOf(collection, value, fromIndex) > -1);
    }

    /**
     * Invokes the method at `path` of each element in `collection`, returning
     * an array of the results of each invoked method. Any additional arguments
     * are provided to each invoked method. If `path` is a function, it's invoked
     * for, and `this` bound to, each element in `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array|Function|string} path The path of the method to invoke or
     *  the function invoked per iteration.
     * @param {...*} [args] The arguments to invoke each method with.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.invokeMap([[5, 1, 7], [3, 2, 1]], 'sort');
     * // => [[1, 5, 7], [1, 2, 3]]
     *
     * _.invokeMap([123, 456], String.prototype.split, '');
     * // => [['1', '2', '3'], ['4', '5', '6']]
     */
    var invokeMap = baseRest(function(collection, path, args) {
      var index = -1,
          isFunc = typeof path == 'function',
          result = isArrayLike(collection) ? Array(collection.length) : [];

      baseEach(collection, function(value) {
        result[++index] = isFunc ? apply(path, value, args) : baseInvoke(value, path, args);
      });
      return result;
    });

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the last element responsible for generating the key. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * var array = [
     *   { 'dir': 'left', 'code': 97 },
     *   { 'dir': 'right', 'code': 100 }
     * ];
     *
     * _.keyBy(array, function(o) {
     *   return String.fromCharCode(o.code);
     * });
     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
     *
     * _.keyBy(array, 'dir');
     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
     */
    var keyBy = createAggregator(function(result, value, key) {
      baseAssignValue(result, key, value);
    });

    /**
     * Creates an array of values by running each element in `collection` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
     *
     * The guarded methods are:
     * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
     * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
     * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
     * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * _.map([4, 8], square);
     * // => [16, 64]
     *
     * _.map({ 'a': 4, 'b': 8 }, square);
     * // => [16, 64] (iteration order is not guaranteed)
     *
     * var users = [
     *   { 'user': 'barney' },
     *   { 'user': 'fred' }
     * ];
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, 'user');
     * // => ['barney', 'fred']
     */
    function map(collection, iteratee) {
      var func = isArray(collection) ? arrayMap : baseMap;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.sortBy` except that it allows specifying the sort
     * orders of the iteratees to sort by. If `orders` is unspecified, all values
     * are sorted in ascending order. Otherwise, specify an order of "desc" for
     * descending or "asc" for ascending sort order of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @param {string[]} [orders] The sort orders of `iteratees`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 34 },
     *   { 'user': 'fred',   'age': 40 },
     *   { 'user': 'barney', 'age': 36 }
     * ];
     *
     * // Sort by `user` in ascending order and by `age` in descending order.
     * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
     */
    function orderBy(collection, iteratees, orders, guard) {
      if (collection == null) {
        return [];
      }
      if (!isArray(iteratees)) {
        iteratees = iteratees == null ? [] : [iteratees];
      }
      orders = guard ? undefined : orders;
      if (!isArray(orders)) {
        orders = orders == null ? [] : [orders];
      }
      return baseOrderBy(collection, iteratees, orders);
    }

    /**
     * Creates an array of elements split into two groups, the first of which
     * contains elements `predicate` returns truthy for, the second of which
     * contains elements `predicate` returns falsey for. The predicate is
     * invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of grouped elements.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': false },
     *   { 'user': 'fred',    'age': 40, 'active': true },
     *   { 'user': 'pebbles', 'age': 1,  'active': false }
     * ];
     *
     * _.partition(users, function(o) { return o.active; });
     * // => objects for [['fred'], ['barney', 'pebbles']]
     *
     * // The `_.matches` iteratee shorthand.
     * _.partition(users, { 'age': 1, 'active': false });
     * // => objects for [['pebbles'], ['barney', 'fred']]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.partition(users, ['active', false]);
     * // => objects for [['barney', 'pebbles'], ['fred']]
     *
     * // The `_.property` iteratee shorthand.
     * _.partition(users, 'active');
     * // => objects for [['fred'], ['barney', 'pebbles']]
     */
    var partition = createAggregator(function(result, value, key) {
      result[key ? 0 : 1].push(value);
    }, function() { return [[], []]; });

    /**
     * Reduces `collection` to a value which is the accumulated result of running
     * each element in `collection` thru `iteratee`, where each successive
     * invocation is supplied the return value of the previous. If `accumulator`
     * is not given, the first element of `collection` is used as the initial
     * value. The iteratee is invoked with four arguments:
     * (accumulator, value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.reduce`, `_.reduceRight`, and `_.transform`.
     *
     * The guarded methods are:
     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
     * and `sortBy`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduceRight
     * @example
     *
     * _.reduce([1, 2], function(sum, n) {
     *   return sum + n;
     * }, 0);
     * // => 3
     *
     * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     *   return result;
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
     */
    function reduce(collection, iteratee, accumulator) {
      var func = isArray(collection) ? arrayReduce : baseReduce,
          initAccum = arguments.length < 3;

      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEach);
    }

    /**
     * This method is like `_.reduce` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduce
     * @example
     *
     * var array = [[0, 1], [2, 3], [4, 5]];
     *
     * _.reduceRight(array, function(flattened, other) {
     *   return flattened.concat(other);
     * }, []);
     * // => [4, 5, 2, 3, 0, 1]
     */
    function reduceRight(collection, iteratee, accumulator) {
      var func = isArray(collection) ? arrayReduceRight : baseReduce,
          initAccum = arguments.length < 3;

      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEachRight);
    }

    /**
     * The opposite of `_.filter`; this method returns the elements of `collection`
     * that `predicate` does **not** return truthy for.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.filter
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': true }
     * ];
     *
     * _.reject(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.reject(users, { 'age': 40, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.reject(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.reject(users, 'active');
     * // => objects for ['barney']
     */
    function reject(collection, predicate) {
      var func = isArray(collection) ? arrayFilter : baseFilter;
      return func(collection, negate(getIteratee(predicate, 3)));
    }

    /**
     * Gets a random element from `collection`.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     * @example
     *
     * _.sample([1, 2, 3, 4]);
     * // => 2
     */
    function sample(collection) {
      var func = isArray(collection) ? arraySample : baseSample;
      return func(collection);
    }

    /**
     * Gets `n` random elements at unique keys from `collection` up to the
     * size of `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @param {number} [n=1] The number of elements to sample.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the random elements.
     * @example
     *
     * _.sampleSize([1, 2, 3], 2);
     * // => [3, 1]
     *
     * _.sampleSize([1, 2, 3], 4);
     * // => [2, 3, 1]
     */
    function sampleSize(collection, n, guard) {
      if ((guard ? isIterateeCall(collection, n, guard) : n === undefined)) {
        n = 1;
      } else {
        n = toInteger(n);
      }
      var func = isArray(collection) ? arraySampleSize : baseSampleSize;
      return func(collection, n);
    }

    /**
     * Creates an array of shuffled values, using a version of the
     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     * @example
     *
     * _.shuffle([1, 2, 3, 4]);
     * // => [4, 1, 3, 2]
     */
    function shuffle(collection) {
      var func = isArray(collection) ? arrayShuffle : baseShuffle;
      return func(collection);
    }

    /**
     * Gets the size of `collection` by returning its length for array-like
     * values or the number of own enumerable string keyed properties for objects.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @returns {number} Returns the collection size.
     * @example
     *
     * _.size([1, 2, 3]);
     * // => 3
     *
     * _.size({ 'a': 1, 'b': 2 });
     * // => 2
     *
     * _.size('pebbles');
     * // => 7
     */
    function size(collection) {
      if (collection == null) {
        return 0;
      }
      if (isArrayLike(collection)) {
        return isString(collection) ? stringSize(collection) : collection.length;
      }
      var tag = getTag(collection);
      if (tag == mapTag || tag == setTag) {
        return collection.size;
      }
      return baseKeys(collection).length;
    }

    /**
     * Checks if `predicate` returns truthy for **any** element of `collection`.
     * Iteration is stopped once `predicate` returns truthy. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     * @example
     *
     * _.some([null, 0, 'yes', false], Boolean);
     * // => true
     *
     * var users = [
     *   { 'user': 'barney', 'active': true },
     *   { 'user': 'fred',   'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.some(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.some(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.some(users, 'active');
     * // => true
     */
    function some(collection, predicate, guard) {
      var func = isArray(collection) ? arraySome : baseSome;
      if (guard && isIterateeCall(collection, predicate, guard)) {
        predicate = undefined;
      }
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Creates an array of elements, sorted in ascending order by the results of
     * running each element in a collection thru each iteratee. This method
     * performs a stable sort, that is, it preserves the original sort order of
     * equal elements. The iteratees are invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 30 },
     *   { 'user': 'barney', 'age': 34 }
     * ];
     *
     * _.sortBy(users, [function(o) { return o.user; }]);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 30]]
     *
     * _.sortBy(users, ['user', 'age']);
     * // => objects for [['barney', 34], ['barney', 36], ['fred', 30], ['fred', 48]]
     */
    var sortBy = baseRest(function(collection, iteratees) {
      if (collection == null) {
        return [];
      }
      var length = iteratees.length;
      if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) {
        iteratees = [];
      } else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) {
        iteratees = [iteratees[0]];
      }
      return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
    });

    /*------------------------------------------------------------------------*/

    /**
     * Gets the timestamp of the number of milliseconds that have elapsed since
     * the Unix epoch (1 January 1970 00:00:00 UTC).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Date
     * @returns {number} Returns the timestamp.
     * @example
     *
     * _.defer(function(stamp) {
     *   console.log(_.now() - stamp);
     * }, _.now());
     * // => Logs the number of milliseconds it took for the deferred invocation.
     */
    var now = ctxNow || function() {
      return root.Date.now();
    };

    /*------------------------------------------------------------------------*/

    /**
     * The opposite of `_.before`; this method creates a function that invokes
     * `func` once it's called `n` or more times.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {number} n The number of calls before `func` is invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var saves = ['profile', 'settings'];
     *
     * var done = _.after(saves.length, function() {
     *   console.log('done saving!');
     * });
     *
     * _.forEach(saves, function(type) {
     *   asyncSave({ 'type': type, 'complete': done });
     * });
     * // => Logs 'done saving!' after the two async saves have completed.
     */
    function after(n, func) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      n = toInteger(n);
      return function() {
        if (--n < 1) {
          return func.apply(this, arguments);
        }
      };
    }

    /**
     * Creates a function that invokes `func`, with up to `n` arguments,
     * ignoring any additional arguments.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @param {number} [n=func.length] The arity cap.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
     * // => [6, 8, 10]
     */
    function ary(func, n, guard) {
      n = guard ? undefined : n;
      n = (func && n == null) ? func.length : n;
      return createWrap(func, WRAP_ARY_FLAG, undefined, undefined, undefined, undefined, n);
    }

    /**
     * Creates a function that invokes `func`, with the `this` binding and arguments
     * of the created function, while it's called less than `n` times. Subsequent
     * calls to the created function return the result of the last `func` invocation.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {number} n The number of calls at which `func` is no longer invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * jQuery(element).on('click', _.before(5, addContactToList));
     * // => Allows adding up to 4 contacts to the list.
     */
    function before(n, func) {
      var result;
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      n = toInteger(n);
      return function() {
        if (--n > 0) {
          result = func.apply(this, arguments);
        }
        if (n <= 1) {
          func = undefined;
        }
        return result;
      };
    }

    /**
     * Creates a function that invokes `func` with the `this` binding of `thisArg`
     * and `partials` prepended to the arguments it receives.
     *
     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for partially applied arguments.
     *
     * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
     * property of bound functions.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to bind.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * function greet(greeting, punctuation) {
     *   return greeting + ' ' + this.user + punctuation;
     * }
     *
     * var object = { 'user': 'fred' };
     *
     * var bound = _.bind(greet, object, 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bind(greet, object, _, '!');
     * bound('hi');
     * // => 'hi fred!'
     */
    var bind = baseRest(function(func, thisArg, partials) {
      var bitmask = WRAP_BIND_FLAG;
      if (partials.length) {
        var holders = replaceHolders(partials, getHolder(bind));
        bitmask |= WRAP_PARTIAL_FLAG;
      }
      return createWrap(func, bitmask, thisArg, partials, holders);
    });

    /**
     * Creates a function that invokes the method at `object[key]` with `partials`
     * prepended to the arguments it receives.
     *
     * This method differs from `_.bind` by allowing bound functions to reference
     * methods that may be redefined or don't yet exist. See
     * [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
     * for more details.
     *
     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Function
     * @param {Object} object The object to invoke the method on.
     * @param {string} key The key of the method.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * var object = {
     *   'user': 'fred',
     *   'greet': function(greeting, punctuation) {
     *     return greeting + ' ' + this.user + punctuation;
     *   }
     * };
     *
     * var bound = _.bindKey(object, 'greet', 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * object.greet = function(greeting, punctuation) {
     *   return greeting + 'ya ' + this.user + punctuation;
     * };
     *
     * bound('!');
     * // => 'hiya fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bindKey(object, 'greet', _, '!');
     * bound('hi');
     * // => 'hiya fred!'
     */
    var bindKey = baseRest(function(object, key, partials) {
      var bitmask = WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG;
      if (partials.length) {
        var holders = replaceHolders(partials, getHolder(bindKey));
        bitmask |= WRAP_PARTIAL_FLAG;
      }
      return createWrap(key, bitmask, object, partials, holders);
    });

    /**
     * Creates a function that accepts arguments of `func` and either invokes
     * `func` returning its result, if at least `arity` number of arguments have
     * been provided, or returns a function that accepts the remaining `func`
     * arguments, and so on. The arity of `func` may be specified if `func.length`
     * is not sufficient.
     *
     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curry(abc);
     *
     * curried(1)(2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(1)(_, 3)(2);
     * // => [1, 2, 3]
     */
    function curry(func, arity, guard) {
      arity = guard ? undefined : arity;
      var result = createWrap(func, WRAP_CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
      result.placeholder = curry.placeholder;
      return result;
    }

    /**
     * This method is like `_.curry` except that arguments are applied to `func`
     * in the manner of `_.partialRight` instead of `_.partial`.
     *
     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curryRight(abc);
     *
     * curried(3)(2)(1);
     * // => [1, 2, 3]
     *
     * curried(2, 3)(1);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(3)(1, _)(2);
     * // => [1, 2, 3]
     */
    function curryRight(func, arity, guard) {
      arity = guard ? undefined : arity;
      var result = createWrap(func, WRAP_CURRY_RIGHT_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
      result.placeholder = curryRight.placeholder;
      return result;
    }

    /**
     * Creates a debounced function that delays invoking `func` until after `wait`
     * milliseconds have elapsed since the last time the debounced function was
     * invoked. The debounced function comes with a `cancel` method to cancel
     * delayed `func` invocations and a `flush` method to immediately invoke them.
     * Provide `options` to indicate whether `func` should be invoked on the
     * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
     * with the last arguments provided to the debounced function. Subsequent
     * calls to the debounced function return the result of the last `func`
     * invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the debounced function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.debounce` and `_.throttle`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to debounce.
     * @param {number} [wait=0] The number of milliseconds to delay.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=false]
     *  Specify invoking on the leading edge of the timeout.
     * @param {number} [options.maxWait]
     *  The maximum time `func` is allowed to be delayed before it's invoked.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new debounced function.
     * @example
     *
     * // Avoid costly calculations while the window size is in flux.
     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
     *
     * // Invoke `sendMail` when clicked, debouncing subsequent calls.
     * jQuery(element).on('click', _.debounce(sendMail, 300, {
     *   'leading': true,
     *   'trailing': false
     * }));
     *
     * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
     * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
     * var source = new EventSource('/stream');
     * jQuery(source).on('message', debounced);
     *
     * // Cancel the trailing debounced invocation.
     * jQuery(window).on('popstate', debounced.cancel);
     */
    function debounce(func, wait, options) {
      var lastArgs,
          lastThis,
          maxWait,
          result,
          timerId,
          lastCallTime,
          lastInvokeTime = 0,
          leading = false,
          maxing = false,
          trailing = true;

      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      wait = toNumber(wait) || 0;
      if (isObject(options)) {
        leading = !!options.leading;
        maxing = 'maxWait' in options;
        maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
      }

      function invokeFunc(time) {
        var args = lastArgs,
            thisArg = lastThis;

        lastArgs = lastThis = undefined;
        lastInvokeTime = time;
        result = func.apply(thisArg, args);
        return result;
      }

      function leadingEdge(time) {
        // Reset any `maxWait` timer.
        lastInvokeTime = time;
        // Start the timer for the trailing edge.
        timerId = setTimeout(timerExpired, wait);
        // Invoke the leading edge.
        return leading ? invokeFunc(time) : result;
      }

      function remainingWait(time) {
        var timeSinceLastCall = time - lastCallTime,
            timeSinceLastInvoke = time - lastInvokeTime,
            timeWaiting = wait - timeSinceLastCall;

        return maxing
          ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke)
          : timeWaiting;
      }

      function shouldInvoke(time) {
        var timeSinceLastCall = time - lastCallTime,
            timeSinceLastInvoke = time - lastInvokeTime;

        // Either this is the first call, activity has stopped and we're at the
        // trailing edge, the system time has gone backwards and we're treating
        // it as the trailing edge, or we've hit the `maxWait` limit.
        return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
          (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
      }

      function timerExpired() {
        var time = now();
        if (shouldInvoke(time)) {
          return trailingEdge(time);
        }
        // Restart the timer.
        timerId = setTimeout(timerExpired, remainingWait(time));
      }

      function trailingEdge(time) {
        timerId = undefined;

        // Only invoke if we have `lastArgs` which means `func` has been
        // debounced at least once.
        if (trailing && lastArgs) {
          return invokeFunc(time);
        }
        lastArgs = lastThis = undefined;
        return result;
      }

      function cancel() {
        if (timerId !== undefined) {
          clearTimeout(timerId);
        }
        lastInvokeTime = 0;
        lastArgs = lastCallTime = lastThis = timerId = undefined;
      }

      function flush() {
        return timerId === undefined ? result : trailingEdge(now());
      }

      function debounced() {
        var time = now(),
            isInvoking = shouldInvoke(time);

        lastArgs = arguments;
        lastThis = this;
        lastCallTime = time;

        if (isInvoking) {
          if (timerId === undefined) {
            return leadingEdge(lastCallTime);
          }
          if (maxing) {
            // Handle invocations in a tight loop.
            clearTimeout(timerId);
            timerId = setTimeout(timerExpired, wait);
            return invokeFunc(lastCallTime);
          }
        }
        if (timerId === undefined) {
          timerId = setTimeout(timerExpired, wait);
        }
        return result;
      }
      debounced.cancel = cancel;
      debounced.flush = flush;
      return debounced;
    }

    /**
     * Defers invoking the `func` until the current call stack has cleared. Any
     * additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to defer.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.defer(function(text) {
     *   console.log(text);
     * }, 'deferred');
     * // => Logs 'deferred' after one millisecond.
     */
    var defer = baseRest(function(func, args) {
      return baseDelay(func, 1, args);
    });

    /**
     * Invokes `func` after `wait` milliseconds. Any additional arguments are
     * provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.delay(function(text) {
     *   console.log(text);
     * }, 1000, 'later');
     * // => Logs 'later' after one second.
     */
    var delay = baseRest(function(func, wait, args) {
      return baseDelay(func, toNumber(wait) || 0, args);
    });

    /**
     * Creates a function that invokes `func` with arguments reversed.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to flip arguments for.
     * @returns {Function} Returns the new flipped function.
     * @example
     *
     * var flipped = _.flip(function() {
     *   return _.toArray(arguments);
     * });
     *
     * flipped('a', 'b', 'c', 'd');
     * // => ['d', 'c', 'b', 'a']
     */
    function flip(func) {
      return createWrap(func, WRAP_FLIP_FLAG);
    }

    /**
     * Creates a function that memoizes the result of `func`. If `resolver` is
     * provided, it determines the cache key for storing the result based on the
     * arguments provided to the memoized function. By default, the first argument
     * provided to the memoized function is used as the map cache key. The `func`
     * is invoked with the `this` binding of the memoized function.
     *
     * **Note:** The cache is exposed as the `cache` property on the memoized
     * function. Its creation may be customized by replacing the `_.memoize.Cache`
     * constructor with one whose instances implement the
     * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
     * method interface of `clear`, `delete`, `get`, `has`, and `set`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to have its output memoized.
     * @param {Function} [resolver] The function to resolve the cache key.
     * @returns {Function} Returns the new memoized function.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     * var other = { 'c': 3, 'd': 4 };
     *
     * var values = _.memoize(_.values);
     * values(object);
     * // => [1, 2]
     *
     * values(other);
     * // => [3, 4]
     *
     * object.a = 2;
     * values(object);
     * // => [1, 2]
     *
     * // Modify the result cache.
     * values.cache.set(object, ['a', 'b']);
     * values(object);
     * // => ['a', 'b']
     *
     * // Replace `_.memoize.Cache`.
     * _.memoize.Cache = WeakMap;
     */
    function memoize(func, resolver) {
      if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      var memoized = function() {
        var args = arguments,
            key = resolver ? resolver.apply(this, args) : args[0],
            cache = memoized.cache;

        if (cache.has(key)) {
          return cache.get(key);
        }
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result) || cache;
        return result;
      };
      memoized.cache = new (memoize.Cache || MapCache);
      return memoized;
    }

    // Expose `MapCache`.
    memoize.Cache = MapCache;

    /**
     * Creates a function that negates the result of the predicate `func`. The
     * `func` predicate is invoked with the `this` binding and arguments of the
     * created function.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} predicate The predicate to negate.
     * @returns {Function} Returns the new negated function.
     * @example
     *
     * function isEven(n) {
     *   return n % 2 == 0;
     * }
     *
     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
     * // => [1, 3, 5]
     */
    function negate(predicate) {
      if (typeof predicate != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      return function() {
        var args = arguments;
        switch (args.length) {
          case 0: return !predicate.call(this);
          case 1: return !predicate.call(this, args[0]);
          case 2: return !predicate.call(this, args[0], args[1]);
          case 3: return !predicate.call(this, args[0], args[1], args[2]);
        }
        return !predicate.apply(this, args);
      };
    }

    /**
     * Creates a function that is restricted to invoking `func` once. Repeat calls
     * to the function return the value of the first invocation. The `func` is
     * invoked with the `this` binding and arguments of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var initialize = _.once(createApplication);
     * initialize();
     * initialize();
     * // => `createApplication` is invoked once
     */
    function once(func) {
      return before(2, func);
    }

    /**
     * Creates a function that invokes `func` with its arguments transformed.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Function
     * @param {Function} func The function to wrap.
     * @param {...(Function|Function[])} [transforms=[_.identity]]
     *  The argument transforms.
     * @returns {Function} Returns the new function.
     * @example
     *
     * function doubled(n) {
     *   return n * 2;
     * }
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var func = _.overArgs(function(x, y) {
     *   return [x, y];
     * }, [square, doubled]);
     *
     * func(9, 3);
     * // => [81, 6]
     *
     * func(10, 5);
     * // => [100, 10]
     */
    var overArgs = castRest(function(func, transforms) {
      transforms = (transforms.length == 1 && isArray(transforms[0]))
        ? arrayMap(transforms[0], baseUnary(getIteratee()))
        : arrayMap(baseFlatten(transforms, 1), baseUnary(getIteratee()));

      var funcsLength = transforms.length;
      return baseRest(function(args) {
        var index = -1,
            length = nativeMin(args.length, funcsLength);

        while (++index < length) {
          args[index] = transforms[index].call(this, args[index]);
        }
        return apply(func, this, args);
      });
    });

    /**
     * Creates a function that invokes `func` with `partials` prepended to the
     * arguments it receives. This method is like `_.bind` except it does **not**
     * alter the `this` binding.
     *
     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 0.2.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var sayHelloTo = _.partial(greet, 'hello');
     * sayHelloTo('fred');
     * // => 'hello fred'
     *
     * // Partially applied with placeholders.
     * var greetFred = _.partial(greet, _, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     */
    var partial = baseRest(function(func, partials) {
      var holders = replaceHolders(partials, getHolder(partial));
      return createWrap(func, WRAP_PARTIAL_FLAG, undefined, partials, holders);
    });

    /**
     * This method is like `_.partial` except that partially applied arguments
     * are appended to the arguments it receives.
     *
     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var greetFred = _.partialRight(greet, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     *
     * // Partially applied with placeholders.
     * var sayHelloTo = _.partialRight(greet, 'hello', _);
     * sayHelloTo('fred');
     * // => 'hello fred'
     */
    var partialRight = baseRest(function(func, partials) {
      var holders = replaceHolders(partials, getHolder(partialRight));
      return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined, partials, holders);
    });

    /**
     * Creates a function that invokes `func` with arguments arranged according
     * to the specified `indexes` where the argument value at the first index is
     * provided as the first argument, the argument value at the second index is
     * provided as the second argument, and so on.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to rearrange arguments for.
     * @param {...(number|number[])} indexes The arranged argument indexes.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var rearged = _.rearg(function(a, b, c) {
     *   return [a, b, c];
     * }, [2, 0, 1]);
     *
     * rearged('b', 'c', 'a')
     * // => ['a', 'b', 'c']
     */
    var rearg = flatRest(function(func, indexes) {
      return createWrap(func, WRAP_REARG_FLAG, undefined, undefined, undefined, indexes);
    });

    /**
     * Creates a function that invokes `func` with the `this` binding of the
     * created function and arguments from `start` and beyond provided as
     * an array.
     *
     * **Note:** This method is based on the
     * [rest parameter](https://mdn.io/rest_parameters).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.rest(function(what, names) {
     *   return what + ' ' + _.initial(names).join(', ') +
     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
     * });
     *
     * say('hello', 'fred', 'barney', 'pebbles');
     * // => 'hello fred, barney, & pebbles'
     */
    function rest(func, start) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      start = start === undefined ? start : toInteger(start);
      return baseRest(func, start);
    }

    /**
     * Creates a function that invokes `func` with the `this` binding of the
     * create function and an array of arguments much like
     * [`Function#apply`](http://www.ecma-international.org/ecma-262/7.0/#sec-function.prototype.apply).
     *
     * **Note:** This method is based on the
     * [spread operator](https://mdn.io/spread_operator).
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Function
     * @param {Function} func The function to spread arguments over.
     * @param {number} [start=0] The start position of the spread.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.spread(function(who, what) {
     *   return who + ' says ' + what;
     * });
     *
     * say(['fred', 'hello']);
     * // => 'fred says hello'
     *
     * var numbers = Promise.all([
     *   Promise.resolve(40),
     *   Promise.resolve(36)
     * ]);
     *
     * numbers.then(_.spread(function(x, y) {
     *   return x + y;
     * }));
     * // => a Promise of 76
     */
    function spread(func, start) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      start = start == null ? 0 : nativeMax(toInteger(start), 0);
      return baseRest(function(args) {
        var array = args[start],
            otherArgs = castSlice(args, 0, start);

        if (array) {
          arrayPush(otherArgs, array);
        }
        return apply(func, this, otherArgs);
      });
    }

    /**
     * Creates a throttled function that only invokes `func` at most once per
     * every `wait` milliseconds. The throttled function comes with a `cancel`
     * method to cancel delayed `func` invocations and a `flush` method to
     * immediately invoke them. Provide `options` to indicate whether `func`
     * should be invoked on the leading and/or trailing edge of the `wait`
     * timeout. The `func` is invoked with the last arguments provided to the
     * throttled function. Subsequent calls to the throttled function return the
     * result of the last `func` invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the throttled function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.throttle` and `_.debounce`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to throttle.
     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=true]
     *  Specify invoking on the leading edge of the timeout.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new throttled function.
     * @example
     *
     * // Avoid excessively updating the position while scrolling.
     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
     *
     * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
     * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
     * jQuery(element).on('click', throttled);
     *
     * // Cancel the trailing throttled invocation.
     * jQuery(window).on('popstate', throttled.cancel);
     */
    function throttle(func, wait, options) {
      var leading = true,
          trailing = true;

      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      if (isObject(options)) {
        leading = 'leading' in options ? !!options.leading : leading;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
      }
      return debounce(func, wait, {
        'leading': leading,
        'maxWait': wait,
        'trailing': trailing
      });
    }

    /**
     * Creates a function that accepts up to one argument, ignoring any
     * additional arguments.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.unary(parseInt));
     * // => [6, 8, 10]
     */
    function unary(func) {
      return ary(func, 1);
    }

    /**
     * Creates a function that provides `value` to `wrapper` as its first
     * argument. Any additional arguments provided to the function are appended
     * to those provided to the `wrapper`. The wrapper is invoked with the `this`
     * binding of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {*} value The value to wrap.
     * @param {Function} [wrapper=identity] The wrapper function.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var p = _.wrap(_.escape, function(func, text) {
     *   return '<p>' + func(text) + '</p>';
     * });
     *
     * p('fred, barney, & pebbles');
     * // => '<p>fred, barney, &amp; pebbles</p>'
     */
    function wrap(value, wrapper) {
      return partial(castFunction(wrapper), value);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Casts `value` as an array if it's not one.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Lang
     * @param {*} value The value to inspect.
     * @returns {Array} Returns the cast array.
     * @example
     *
     * _.castArray(1);
     * // => [1]
     *
     * _.castArray({ 'a': 1 });
     * // => [{ 'a': 1 }]
     *
     * _.castArray('abc');
     * // => ['abc']
     *
     * _.castArray(null);
     * // => [null]
     *
     * _.castArray(undefined);
     * // => [undefined]
     *
     * _.castArray();
     * // => []
     *
     * var array = [1, 2, 3];
     * console.log(_.castArray(array) === array);
     * // => true
     */
    function castArray() {
      if (!arguments.length) {
        return [];
      }
      var value = arguments[0];
      return isArray(value) ? value : [value];
    }

    /**
     * Creates a shallow clone of `value`.
     *
     * **Note:** This method is loosely based on the
     * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
     * and supports cloning arrays, array buffers, booleans, date objects, maps,
     * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
     * arrays. The own enumerable properties of `arguments` objects are cloned
     * as plain objects. An empty object is returned for uncloneable values such
     * as error objects, functions, DOM nodes, and WeakMaps.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to clone.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeep
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var shallow = _.clone(objects);
     * console.log(shallow[0] === objects[0]);
     * // => true
     */
    function clone(value) {
      return baseClone(value, CLONE_SYMBOLS_FLAG);
    }

    /**
     * This method is like `_.clone` except that it accepts `customizer` which
     * is invoked to produce the cloned value. If `customizer` returns `undefined`,
     * cloning is handled by the method instead. The `customizer` is invoked with
     * up to four arguments; (value [, index|key, object, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeepWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(false);
     *   }
     * }
     *
     * var el = _.cloneWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 0
     */
    function cloneWith(value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseClone(value, CLONE_SYMBOLS_FLAG, customizer);
    }

    /**
     * This method is like `_.clone` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @returns {*} Returns the deep cloned value.
     * @see _.clone
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var deep = _.cloneDeep(objects);
     * console.log(deep[0] === objects[0]);
     * // => false
     */
    function cloneDeep(value) {
      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
    }

    /**
     * This method is like `_.cloneWith` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the deep cloned value.
     * @see _.cloneWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(true);
     *   }
     * }
     *
     * var el = _.cloneDeepWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 20
     */
    function cloneDeepWith(value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
    }

    /**
     * Checks if `object` conforms to `source` by invoking the predicate
     * properties of `source` with the corresponding property values of `object`.
     *
     * **Note:** This method is equivalent to `_.conforms` when `source` is
     * partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 1; } });
     * // => true
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 2; } });
     * // => false
     */
    function conformsTo(object, source) {
      return source == null || baseConformsTo(object, source, keys(source));
    }

    /**
     * Performs a
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * comparison between two values to determine if they are equivalent.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.eq(object, object);
     * // => true
     *
     * _.eq(object, other);
     * // => false
     *
     * _.eq('a', 'a');
     * // => true
     *
     * _.eq('a', Object('a'));
     * // => false
     *
     * _.eq(NaN, NaN);
     * // => true
     */
    function eq(value, other) {
      return value === other || (value !== value && other !== other);
    }

    /**
     * Checks if `value` is greater than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     * @see _.lt
     * @example
     *
     * _.gt(3, 1);
     * // => true
     *
     * _.gt(3, 3);
     * // => false
     *
     * _.gt(1, 3);
     * // => false
     */
    var gt = createRelationalOperation(baseGt);

    /**
     * Checks if `value` is greater than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than or equal to
     *  `other`, else `false`.
     * @see _.lte
     * @example
     *
     * _.gte(3, 1);
     * // => true
     *
     * _.gte(3, 3);
     * // => true
     *
     * _.gte(1, 3);
     * // => false
     */
    var gte = createRelationalOperation(function(value, other) {
      return value >= other;
    });

    /**
     * Checks if `value` is likely an `arguments` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     *  else `false`.
     * @example
     *
     * _.isArguments(function() { return arguments; }());
     * // => true
     *
     * _.isArguments([1, 2, 3]);
     * // => false
     */
    var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
      return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
        !propertyIsEnumerable.call(value, 'callee');
    };

    /**
     * Checks if `value` is classified as an `Array` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array, else `false`.
     * @example
     *
     * _.isArray([1, 2, 3]);
     * // => true
     *
     * _.isArray(document.body.children);
     * // => false
     *
     * _.isArray('abc');
     * // => false
     *
     * _.isArray(_.noop);
     * // => false
     */
    var isArray = Array.isArray;

    /**
     * Checks if `value` is classified as an `ArrayBuffer` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     * @example
     *
     * _.isArrayBuffer(new ArrayBuffer(2));
     * // => true
     *
     * _.isArrayBuffer(new Array(2));
     * // => false
     */
    var isArrayBuffer = nodeIsArrayBuffer ? baseUnary(nodeIsArrayBuffer) : baseIsArrayBuffer;

    /**
     * Checks if `value` is array-like. A value is considered array-like if it's
     * not a function and has a `value.length` that's an integer greater than or
     * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
     * @example
     *
     * _.isArrayLike([1, 2, 3]);
     * // => true
     *
     * _.isArrayLike(document.body.children);
     * // => true
     *
     * _.isArrayLike('abc');
     * // => true
     *
     * _.isArrayLike(_.noop);
     * // => false
     */
    function isArrayLike(value) {
      return value != null && isLength(value.length) && !isFunction(value);
    }

    /**
     * This method is like `_.isArrayLike` except that it also checks if `value`
     * is an object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array-like object,
     *  else `false`.
     * @example
     *
     * _.isArrayLikeObject([1, 2, 3]);
     * // => true
     *
     * _.isArrayLikeObject(document.body.children);
     * // => true
     *
     * _.isArrayLikeObject('abc');
     * // => false
     *
     * _.isArrayLikeObject(_.noop);
     * // => false
     */
    function isArrayLikeObject(value) {
      return isObjectLike(value) && isArrayLike(value);
    }

    /**
     * Checks if `value` is classified as a boolean primitive or object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
     * @example
     *
     * _.isBoolean(false);
     * // => true
     *
     * _.isBoolean(null);
     * // => false
     */
    function isBoolean(value) {
      return value === true || value === false ||
        (isObjectLike(value) && baseGetTag(value) == boolTag);
    }

    /**
     * Checks if `value` is a buffer.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
     * @example
     *
     * _.isBuffer(new Buffer(2));
     * // => true
     *
     * _.isBuffer(new Uint8Array(2));
     * // => false
     */
    var isBuffer = nativeIsBuffer || stubFalse;

    /**
     * Checks if `value` is classified as a `Date` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     * @example
     *
     * _.isDate(new Date);
     * // => true
     *
     * _.isDate('Mon April 23 2012');
     * // => false
     */
    var isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;

    /**
     * Checks if `value` is likely a DOM element.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
     * @example
     *
     * _.isElement(document.body);
     * // => true
     *
     * _.isElement('<body>');
     * // => false
     */
    function isElement(value) {
      return isObjectLike(value) && value.nodeType === 1 && !isPlainObject(value);
    }

    /**
     * Checks if `value` is an empty object, collection, map, or set.
     *
     * Objects are considered empty if they have no own enumerable string keyed
     * properties.
     *
     * Array-like values such as `arguments` objects, arrays, buffers, strings, or
     * jQuery-like collections are considered empty if they have a `length` of `0`.
     * Similarly, maps and sets are considered empty if they have a `size` of `0`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
     * @example
     *
     * _.isEmpty(null);
     * // => true
     *
     * _.isEmpty(true);
     * // => true
     *
     * _.isEmpty(1);
     * // => true
     *
     * _.isEmpty([1, 2, 3]);
     * // => false
     *
     * _.isEmpty({ 'a': 1 });
     * // => false
     */
    function isEmpty(value) {
      if (value == null) {
        return true;
      }
      if (isArrayLike(value) &&
          (isArray(value) || typeof value == 'string' || typeof value.splice == 'function' ||
            isBuffer(value) || isTypedArray(value) || isArguments(value))) {
        return !value.length;
      }
      var tag = getTag(value);
      if (tag == mapTag || tag == setTag) {
        return !value.size;
      }
      if (isPrototype(value)) {
        return !baseKeys(value).length;
      }
      for (var key in value) {
        if (hasOwnProperty.call(value, key)) {
          return false;
        }
      }
      return true;
    }

    /**
     * Performs a deep comparison between two values to determine if they are
     * equivalent.
     *
     * **Note:** This method supports comparing arrays, array buffers, booleans,
     * date objects, error objects, maps, numbers, `Object` objects, regexes,
     * sets, strings, symbols, and typed arrays. `Object` objects are compared
     * by their own, not inherited, enumerable properties. Functions and DOM
     * nodes are compared by strict equality, i.e. `===`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.isEqual(object, other);
     * // => true
     *
     * object === other;
     * // => false
     */
    function isEqual(value, other) {
      return baseIsEqual(value, other);
    }

    /**
     * This method is like `_.isEqual` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with up to
     * six arguments: (objValue, othValue [, index|key, object, other, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, othValue) {
     *   if (isGreeting(objValue) && isGreeting(othValue)) {
     *     return true;
     *   }
     * }
     *
     * var array = ['hello', 'goodbye'];
     * var other = ['hi', 'goodbye'];
     *
     * _.isEqualWith(array, other, customizer);
     * // => true
     */
    function isEqualWith(value, other, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      var result = customizer ? customizer(value, other) : undefined;
      return result === undefined ? baseIsEqual(value, other, undefined, customizer) : !!result;
    }

    /**
     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
     * `SyntaxError`, `TypeError`, or `URIError` object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
     * @example
     *
     * _.isError(new Error);
     * // => true
     *
     * _.isError(Error);
     * // => false
     */
    function isError(value) {
      if (!isObjectLike(value)) {
        return false;
      }
      var tag = baseGetTag(value);
      return tag == errorTag || tag == domExcTag ||
        (typeof value.message == 'string' && typeof value.name == 'string' && !isPlainObject(value));
    }

    /**
     * Checks if `value` is a finite primitive number.
     *
     * **Note:** This method is based on
     * [`Number.isFinite`](https://mdn.io/Number/isFinite).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
     * @example
     *
     * _.isFinite(3);
     * // => true
     *
     * _.isFinite(Number.MIN_VALUE);
     * // => true
     *
     * _.isFinite(Infinity);
     * // => false
     *
     * _.isFinite('3');
     * // => false
     */
    function isFinite(value) {
      return typeof value == 'number' && nativeIsFinite(value);
    }

    /**
     * Checks if `value` is classified as a `Function` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a function, else `false`.
     * @example
     *
     * _.isFunction(_);
     * // => true
     *
     * _.isFunction(/abc/);
     * // => false
     */
    function isFunction(value) {
      if (!isObject(value)) {
        return false;
      }
      // The use of `Object#toString` avoids issues with the `typeof` operator
      // in Safari 9 which returns 'object' for typed arrays and other constructors.
      var tag = baseGetTag(value);
      return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
    }

    /**
     * Checks if `value` is an integer.
     *
     * **Note:** This method is based on
     * [`Number.isInteger`](https://mdn.io/Number/isInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
     * @example
     *
     * _.isInteger(3);
     * // => true
     *
     * _.isInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isInteger(Infinity);
     * // => false
     *
     * _.isInteger('3');
     * // => false
     */
    function isInteger(value) {
      return typeof value == 'number' && value == toInteger(value);
    }

    /**
     * Checks if `value` is a valid array-like length.
     *
     * **Note:** This method is loosely based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
     * @example
     *
     * _.isLength(3);
     * // => true
     *
     * _.isLength(Number.MIN_VALUE);
     * // => false
     *
     * _.isLength(Infinity);
     * // => false
     *
     * _.isLength('3');
     * // => false
     */
    function isLength(value) {
      return typeof value == 'number' &&
        value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
    }

    /**
     * Checks if `value` is the
     * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
     * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
     * @example
     *
     * _.isObject({});
     * // => true
     *
     * _.isObject([1, 2, 3]);
     * // => true
     *
     * _.isObject(_.noop);
     * // => true
     *
     * _.isObject(null);
     * // => false
     */
    function isObject(value) {
      var type = typeof value;
      return value != null && (type == 'object' || type == 'function');
    }

    /**
     * Checks if `value` is object-like. A value is object-like if it's not `null`
     * and has a `typeof` result of "object".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
     * @example
     *
     * _.isObjectLike({});
     * // => true
     *
     * _.isObjectLike([1, 2, 3]);
     * // => true
     *
     * _.isObjectLike(_.noop);
     * // => false
     *
     * _.isObjectLike(null);
     * // => false
     */
    function isObjectLike(value) {
      return value != null && typeof value == 'object';
    }

    /**
     * Checks if `value` is classified as a `Map` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     * @example
     *
     * _.isMap(new Map);
     * // => true
     *
     * _.isMap(new WeakMap);
     * // => false
     */
    var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;

    /**
     * Performs a partial deep comparison between `object` and `source` to
     * determine if `object` contains equivalent property values.
     *
     * **Note:** This method is equivalent to `_.matches` when `source` is
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.isMatch(object, { 'b': 2 });
     * // => true
     *
     * _.isMatch(object, { 'b': 1 });
     * // => false
     */
    function isMatch(object, source) {
      return object === source || baseIsMatch(object, source, getMatchData(source));
    }

    /**
     * This method is like `_.isMatch` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with five
     * arguments: (objValue, srcValue, index|key, object, source).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, srcValue) {
     *   if (isGreeting(objValue) && isGreeting(srcValue)) {
     *     return true;
     *   }
     * }
     *
     * var object = { 'greeting': 'hello' };
     * var source = { 'greeting': 'hi' };
     *
     * _.isMatchWith(object, source, customizer);
     * // => true
     */
    function isMatchWith(object, source, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseIsMatch(object, source, getMatchData(source), customizer);
    }

    /**
     * Checks if `value` is `NaN`.
     *
     * **Note:** This method is based on
     * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
     * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
     * `undefined` and other non-number values.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
     * @example
     *
     * _.isNaN(NaN);
     * // => true
     *
     * _.isNaN(new Number(NaN));
     * // => true
     *
     * isNaN(undefined);
     * // => true
     *
     * _.isNaN(undefined);
     * // => false
     */
    function isNaN(value) {
      // An `NaN` primitive is the only value that is not equal to itself.
      // Perform the `toStringTag` check first to avoid errors with some
      // ActiveX objects in IE.
      return isNumber(value) && value != +value;
    }

    /**
     * Checks if `value` is a pristine native function.
     *
     * **Note:** This method can't reliably detect native functions in the presence
     * of the core-js package because core-js circumvents this kind of detection.
     * Despite multiple requests, the core-js maintainer has made it clear: any
     * attempt to fix the detection will be obstructed. As a result, we're left
     * with little choice but to throw an error. Unfortunately, this also affects
     * packages, like [babel-polyfill](https://www.npmjs.com/package/babel-polyfill),
     * which rely on core-js.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     * @example
     *
     * _.isNative(Array.prototype.push);
     * // => true
     *
     * _.isNative(_);
     * // => false
     */
    function isNative(value) {
      if (isMaskable(value)) {
        throw new Error(CORE_ERROR_TEXT);
      }
      return baseIsNative(value);
    }

    /**
     * Checks if `value` is `null`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
     * @example
     *
     * _.isNull(null);
     * // => true
     *
     * _.isNull(void 0);
     * // => false
     */
    function isNull(value) {
      return value === null;
    }

    /**
     * Checks if `value` is `null` or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
     * @example
     *
     * _.isNil(null);
     * // => true
     *
     * _.isNil(void 0);
     * // => true
     *
     * _.isNil(NaN);
     * // => false
     */
    function isNil(value) {
      return value == null;
    }

    /**
     * Checks if `value` is classified as a `Number` primitive or object.
     *
     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
     * classified as numbers, use the `_.isFinite` method.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a number, else `false`.
     * @example
     *
     * _.isNumber(3);
     * // => true
     *
     * _.isNumber(Number.MIN_VALUE);
     * // => true
     *
     * _.isNumber(Infinity);
     * // => true
     *
     * _.isNumber('3');
     * // => false
     */
    function isNumber(value) {
      return typeof value == 'number' ||
        (isObjectLike(value) && baseGetTag(value) == numberTag);
    }

    /**
     * Checks if `value` is a plain object, that is, an object created by the
     * `Object` constructor or one with a `[[Prototype]]` of `null`.
     *
     * @static
     * @memberOf _
     * @since 0.8.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * _.isPlainObject(new Foo);
     * // => false
     *
     * _.isPlainObject([1, 2, 3]);
     * // => false
     *
     * _.isPlainObject({ 'x': 0, 'y': 0 });
     * // => true
     *
     * _.isPlainObject(Object.create(null));
     * // => true
     */
    function isPlainObject(value) {
      if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
        return false;
      }
      var proto = getPrototype(value);
      if (proto === null) {
        return true;
      }
      var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
      return typeof Ctor == 'function' && Ctor instanceof Ctor &&
        funcToString.call(Ctor) == objectCtorString;
    }

    /**
     * Checks if `value` is classified as a `RegExp` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     * @example
     *
     * _.isRegExp(/abc/);
     * // => true
     *
     * _.isRegExp('/abc/');
     * // => false
     */
    var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;

    /**
     * Checks if `value` is a safe integer. An integer is safe if it's an IEEE-754
     * double precision number which isn't the result of a rounded unsafe integer.
     *
     * **Note:** This method is based on
     * [`Number.isSafeInteger`](https://mdn.io/Number/isSafeInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a safe integer, else `false`.
     * @example
     *
     * _.isSafeInteger(3);
     * // => true
     *
     * _.isSafeInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isSafeInteger(Infinity);
     * // => false
     *
     * _.isSafeInteger('3');
     * // => false
     */
    function isSafeInteger(value) {
      return isInteger(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER;
    }

    /**
     * Checks if `value` is classified as a `Set` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     * @example
     *
     * _.isSet(new Set);
     * // => true
     *
     * _.isSet(new WeakSet);
     * // => false
     */
    var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;

    /**
     * Checks if `value` is classified as a `String` primitive or object.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a string, else `false`.
     * @example
     *
     * _.isString('abc');
     * // => true
     *
     * _.isString(1);
     * // => false
     */
    function isString(value) {
      return typeof value == 'string' ||
        (!isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag);
    }

    /**
     * Checks if `value` is classified as a `Symbol` primitive or object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
     * @example
     *
     * _.isSymbol(Symbol.iterator);
     * // => true
     *
     * _.isSymbol('abc');
     * // => false
     */
    function isSymbol(value) {
      return typeof value == 'symbol' ||
        (isObjectLike(value) && baseGetTag(value) == symbolTag);
    }

    /**
     * Checks if `value` is classified as a typed array.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     * @example
     *
     * _.isTypedArray(new Uint8Array);
     * // => true
     *
     * _.isTypedArray([]);
     * // => false
     */
    var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

    /**
     * Checks if `value` is `undefined`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
     * @example
     *
     * _.isUndefined(void 0);
     * // => true
     *
     * _.isUndefined(null);
     * // => false
     */
    function isUndefined(value) {
      return value === undefined;
    }

    /**
     * Checks if `value` is classified as a `WeakMap` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
     * @example
     *
     * _.isWeakMap(new WeakMap);
     * // => true
     *
     * _.isWeakMap(new Map);
     * // => false
     */
    function isWeakMap(value) {
      return isObjectLike(value) && getTag(value) == weakMapTag;
    }

    /**
     * Checks if `value` is classified as a `WeakSet` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak set, else `false`.
     * @example
     *
     * _.isWeakSet(new WeakSet);
     * // => true
     *
     * _.isWeakSet(new Set);
     * // => false
     */
    function isWeakSet(value) {
      return isObjectLike(value) && baseGetTag(value) == weakSetTag;
    }

    /**
     * Checks if `value` is less than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     * @see _.gt
     * @example
     *
     * _.lt(1, 3);
     * // => true
     *
     * _.lt(3, 3);
     * // => false
     *
     * _.lt(3, 1);
     * // => false
     */
    var lt = createRelationalOperation(baseLt);

    /**
     * Checks if `value` is less than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than or equal to
     *  `other`, else `false`.
     * @see _.gte
     * @example
     *
     * _.lte(1, 3);
     * // => true
     *
     * _.lte(3, 3);
     * // => true
     *
     * _.lte(3, 1);
     * // => false
     */
    var lte = createRelationalOperation(function(value, other) {
      return value <= other;
    });

    /**
     * Converts `value` to an array.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Array} Returns the converted array.
     * @example
     *
     * _.toArray({ 'a': 1, 'b': 2 });
     * // => [1, 2]
     *
     * _.toArray('abc');
     * // => ['a', 'b', 'c']
     *
     * _.toArray(1);
     * // => []
     *
     * _.toArray(null);
     * // => []
     */
    function toArray(value) {
      if (!value) {
        return [];
      }
      if (isArrayLike(value)) {
        return isString(value) ? stringToArray(value) : copyArray(value);
      }
      if (symIterator && value[symIterator]) {
        return iteratorToArray(value[symIterator]());
      }
      var tag = getTag(value),
          func = tag == mapTag ? mapToArray : (tag == setTag ? setToArray : values);

      return func(value);
    }

    /**
     * Converts `value` to a finite number.
     *
     * @static
     * @memberOf _
     * @since 4.12.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted number.
     * @example
     *
     * _.toFinite(3.2);
     * // => 3.2
     *
     * _.toFinite(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toFinite(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toFinite('3.2');
     * // => 3.2
     */
    function toFinite(value) {
      if (!value) {
        return value === 0 ? value : 0;
      }
      value = toNumber(value);
      if (value === INFINITY || value === -INFINITY) {
        var sign = (value < 0 ? -1 : 1);
        return sign * MAX_INTEGER;
      }
      return value === value ? value : 0;
    }

    /**
     * Converts `value` to an integer.
     *
     * **Note:** This method is loosely based on
     * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toInteger(3.2);
     * // => 3
     *
     * _.toInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toInteger(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toInteger('3.2');
     * // => 3
     */
    function toInteger(value) {
      var result = toFinite(value),
          remainder = result % 1;

      return result === result ? (remainder ? result - remainder : result) : 0;
    }

    /**
     * Converts `value` to an integer suitable for use as the length of an
     * array-like object.
     *
     * **Note:** This method is based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toLength(3.2);
     * // => 3
     *
     * _.toLength(Number.MIN_VALUE);
     * // => 0
     *
     * _.toLength(Infinity);
     * // => 4294967295
     *
     * _.toLength('3.2');
     * // => 3
     */
    function toLength(value) {
      return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
    }

    /**
     * Converts `value` to a number.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     * @example
     *
     * _.toNumber(3.2);
     * // => 3.2
     *
     * _.toNumber(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toNumber(Infinity);
     * // => Infinity
     *
     * _.toNumber('3.2');
     * // => 3.2
     */
    function toNumber(value) {
      if (typeof value == 'number') {
        return value;
      }
      if (isSymbol(value)) {
        return NAN;
      }
      if (isObject(value)) {
        var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
        value = isObject(other) ? (other + '') : other;
      }
      if (typeof value != 'string') {
        return value === 0 ? value : +value;
      }
      value = baseTrim(value);
      var isBinary = reIsBinary.test(value);
      return (isBinary || reIsOctal.test(value))
        ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
        : (reIsBadHex.test(value) ? NAN : +value);
    }

    /**
     * Converts `value` to a plain object flattening inherited enumerable string
     * keyed properties of `value` to own properties of the plain object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Object} Returns the converted plain object.
     * @example
     *
     * function Foo() {
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.assign({ 'a': 1 }, new Foo);
     * // => { 'a': 1, 'b': 2 }
     *
     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
     * // => { 'a': 1, 'b': 2, 'c': 3 }
     */
    function toPlainObject(value) {
      return copyObject(value, keysIn(value));
    }

    /**
     * Converts `value` to a safe integer. A safe integer can be compared and
     * represented correctly.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toSafeInteger(3.2);
     * // => 3
     *
     * _.toSafeInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toSafeInteger(Infinity);
     * // => 9007199254740991
     *
     * _.toSafeInteger('3.2');
     * // => 3
     */
    function toSafeInteger(value) {
      return value
        ? baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER)
        : (value === 0 ? value : 0);
    }

    /**
     * Converts `value` to a string. An empty string is returned for `null`
     * and `undefined` values. The sign of `-0` is preserved.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.toString(null);
     * // => ''
     *
     * _.toString(-0);
     * // => '-0'
     *
     * _.toString([1, 2, 3]);
     * // => '1,2,3'
     */
    function toString(value) {
      return value == null ? '' : baseToString(value);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Assigns own enumerable string keyed properties of source objects to the
     * destination object. Source objects are applied from left to right.
     * Subsequent sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object` and is loosely based on
     * [`Object.assign`](https://mdn.io/Object/assign).
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assignIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assign({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'c': 3 }
     */
    var assign = createAssigner(function(object, source) {
      if (isPrototype(source) || isArrayLike(source)) {
        copyObject(source, keys(source), object);
        return;
      }
      for (var key in source) {
        if (hasOwnProperty.call(source, key)) {
          assignValue(object, key, source[key]);
        }
      }
    });

    /**
     * This method is like `_.assign` except that it iterates over own and
     * inherited source properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extend
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assign
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assignIn({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
     */
    var assignIn = createAssigner(function(object, source) {
      copyObject(source, keysIn(source), object);
    });

    /**
     * This method is like `_.assignIn` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extendWith
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignInWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
      copyObject(source, keysIn(source), object, customizer);
    });

    /**
     * This method is like `_.assign` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignInWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var assignWith = createAssigner(function(object, source, srcIndex, customizer) {
      copyObject(source, keys(source), object, customizer);
    });

    /**
     * Creates an array of values corresponding to `paths` of `object`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Array} Returns the picked values.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _.at(object, ['a[0].b.c', 'a[1]']);
     * // => [3, 4]
     */
    var at = flatRest(baseAt);

    /**
     * Creates an object that inherits from the `prototype` object. If a
     * `properties` object is given, its own enumerable string keyed properties
     * are assigned to the created object.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Object
     * @param {Object} prototype The object to inherit from.
     * @param {Object} [properties] The properties to assign to the object.
     * @returns {Object} Returns the new object.
     * @example
     *
     * function Shape() {
     *   this.x = 0;
     *   this.y = 0;
     * }
     *
     * function Circle() {
     *   Shape.call(this);
     * }
     *
     * Circle.prototype = _.create(Shape.prototype, {
     *   'constructor': Circle
     * });
     *
     * var circle = new Circle;
     * circle instanceof Circle;
     * // => true
     *
     * circle instanceof Shape;
     * // => true
     */
    function create(prototype, properties) {
      var result = baseCreate(prototype);
      return properties == null ? result : baseAssign(result, properties);
    }

    /**
     * Assigns own and inherited enumerable string keyed properties of source
     * objects to the destination object for all destination properties that
     * resolve to `undefined`. Source objects are applied from left to right.
     * Once a property is set, additional values of the same property are ignored.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaultsDeep
     * @example
     *
     * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var defaults = baseRest(function(object, sources) {
      object = Object(object);

      var index = -1;
      var length = sources.length;
      var guard = length > 2 ? sources[2] : undefined;

      if (guard && isIterateeCall(sources[0], sources[1], guard)) {
        length = 1;
      }

      while (++index < length) {
        var source = sources[index];
        var props = keysIn(source);
        var propsIndex = -1;
        var propsLength = props.length;

        while (++propsIndex < propsLength) {
          var key = props[propsIndex];
          var value = object[key];

          if (value === undefined ||
              (eq(value, objectProto[key]) && !hasOwnProperty.call(object, key))) {
            object[key] = source[key];
          }
        }
      }

      return object;
    });

    /**
     * This method is like `_.defaults` except that it recursively assigns
     * default properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaults
     * @example
     *
     * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
     * // => { 'a': { 'b': 2, 'c': 3 } }
     */
    var defaultsDeep = baseRest(function(args) {
      args.push(undefined, customDefaultsMerge);
      return apply(mergeWith, undefined, args);
    });

    /**
     * This method is like `_.find` except that it returns the key of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findKey(users, function(o) { return o.age < 40; });
     * // => 'barney' (iteration order is not guaranteed)
     *
     * // The `_.matches` iteratee shorthand.
     * _.findKey(users, { 'age': 1, 'active': true });
     * // => 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findKey(users, 'active');
     * // => 'barney'
     */
    function findKey(object, predicate) {
      return baseFindKey(object, getIteratee(predicate, 3), baseForOwn);
    }

    /**
     * This method is like `_.findKey` except that it iterates over elements of
     * a collection in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findLastKey(users, function(o) { return o.age < 40; });
     * // => returns 'pebbles' assuming `_.findKey` returns 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastKey(users, { 'age': 36, 'active': true });
     * // => 'barney'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastKey(users, 'active');
     * // => 'pebbles'
     */
    function findLastKey(object, predicate) {
      return baseFindKey(object, getIteratee(predicate, 3), baseForOwnRight);
    }

    /**
     * Iterates over own and inherited enumerable string keyed properties of an
     * object and invokes `iteratee` for each property. The iteratee is invoked
     * with three arguments: (value, key, object). Iteratee functions may exit
     * iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forInRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forIn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a', 'b', then 'c' (iteration order is not guaranteed).
     */
    function forIn(object, iteratee) {
      return object == null
        ? object
        : baseFor(object, getIteratee(iteratee, 3), keysIn);
    }

    /**
     * This method is like `_.forIn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forInRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'c', 'b', then 'a' assuming `_.forIn` logs 'a', 'b', then 'c'.
     */
    function forInRight(object, iteratee) {
      return object == null
        ? object
        : baseForRight(object, getIteratee(iteratee, 3), keysIn);
    }

    /**
     * Iterates over own enumerable string keyed properties of an object and
     * invokes `iteratee` for each property. The iteratee is invoked with three
     * arguments: (value, key, object). Iteratee functions may exit iteration
     * early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwnRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */
    function forOwn(object, iteratee) {
      return object && baseForOwn(object, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.forOwn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwnRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'b' then 'a' assuming `_.forOwn` logs 'a' then 'b'.
     */
    function forOwnRight(object, iteratee) {
      return object && baseForOwnRight(object, getIteratee(iteratee, 3));
    }

    /**
     * Creates an array of function property names from own enumerable properties
     * of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functionsIn
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functions(new Foo);
     * // => ['a', 'b']
     */
    function functions(object) {
      return object == null ? [] : baseFunctions(object, keys(object));
    }

    /**
     * Creates an array of function property names from own and inherited
     * enumerable properties of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functions
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functionsIn(new Foo);
     * // => ['a', 'b', 'c']
     */
    function functionsIn(object) {
      return object == null ? [] : baseFunctions(object, keysIn(object));
    }

    /**
     * Gets the value at `path` of `object`. If the resolved value is
     * `undefined`, the `defaultValue` is returned in its place.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.get(object, 'a[0].b.c');
     * // => 3
     *
     * _.get(object, ['a', '0', 'b', 'c']);
     * // => 3
     *
     * _.get(object, 'a.b.c', 'default');
     * // => 'default'
     */
    function get(object, path, defaultValue) {
      var result = object == null ? undefined : baseGet(object, path);
      return result === undefined ? defaultValue : result;
    }

    /**
     * Checks if `path` is a direct property of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = { 'a': { 'b': 2 } };
     * var other = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.has(object, 'a');
     * // => true
     *
     * _.has(object, 'a.b');
     * // => true
     *
     * _.has(object, ['a', 'b']);
     * // => true
     *
     * _.has(other, 'a');
     * // => false
     */
    function has(object, path) {
      return object != null && hasPath(object, path, baseHas);
    }

    /**
     * Checks if `path` is a direct or inherited property of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.hasIn(object, 'a');
     * // => true
     *
     * _.hasIn(object, 'a.b');
     * // => true
     *
     * _.hasIn(object, ['a', 'b']);
     * // => true
     *
     * _.hasIn(object, 'b');
     * // => false
     */
    function hasIn(object, path) {
      return object != null && hasPath(object, path, baseHasIn);
    }

    /**
     * Creates an object composed of the inverted keys and values of `object`.
     * If `object` contains duplicate values, subsequent values overwrite
     * property assignments of previous values.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Object
     * @param {Object} object The object to invert.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invert(object);
     * // => { '1': 'c', '2': 'b' }
     */
    var invert = createInverter(function(result, value, key) {
      if (value != null &&
          typeof value.toString != 'function') {
        value = nativeObjectToString.call(value);
      }

      result[value] = key;
    }, constant(identity));

    /**
     * This method is like `_.invert` except that the inverted object is generated
     * from the results of running each element of `object` thru `iteratee`. The
     * corresponding inverted value of each inverted key is an array of keys
     * responsible for generating the inverted value. The iteratee is invoked
     * with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Object
     * @param {Object} object The object to invert.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invertBy(object);
     * // => { '1': ['a', 'c'], '2': ['b'] }
     *
     * _.invertBy(object, function(value) {
     *   return 'group' + value;
     * });
     * // => { 'group1': ['a', 'c'], 'group2': ['b'] }
     */
    var invertBy = createInverter(function(result, value, key) {
      if (value != null &&
          typeof value.toString != 'function') {
        value = nativeObjectToString.call(value);
      }

      if (hasOwnProperty.call(result, value)) {
        result[value].push(key);
      } else {
        result[value] = [key];
      }
    }, getIteratee);

    /**
     * Invokes the method at `path` of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
     *
     * _.invoke(object, 'a[0].b.c.slice', 1, 3);
     * // => [2, 3]
     */
    var invoke = baseRest(baseInvoke);

    /**
     * Creates an array of the own enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects. See the
     * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * for more details.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keys(new Foo);
     * // => ['a', 'b'] (iteration order is not guaranteed)
     *
     * _.keys('hi');
     * // => ['0', '1']
     */
    function keys(object) {
      return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
    }

    /**
     * Creates an array of the own and inherited enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keysIn(new Foo);
     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
     */
    function keysIn(object) {
      return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
    }

    /**
     * The opposite of `_.mapValues`; this method creates an object with the
     * same values as `object` and keys generated by running each own enumerable
     * string keyed property of `object` thru `iteratee`. The iteratee is invoked
     * with three arguments: (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapValues
     * @example
     *
     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
     *   return key + value;
     * });
     * // => { 'a1': 1, 'b2': 2 }
     */
    function mapKeys(object, iteratee) {
      var result = {};
      iteratee = getIteratee(iteratee, 3);

      baseForOwn(object, function(value, key, object) {
        baseAssignValue(result, iteratee(value, key, object), value);
      });
      return result;
    }

    /**
     * Creates an object with the same keys as `object` and values generated
     * by running each own enumerable string keyed property of `object` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapKeys
     * @example
     *
     * var users = {
     *   'fred':    { 'user': 'fred',    'age': 40 },
     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
     * };
     *
     * _.mapValues(users, function(o) { return o.age; });
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     *
     * // The `_.property` iteratee shorthand.
     * _.mapValues(users, 'age');
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     */
    function mapValues(object, iteratee) {
      var result = {};
      iteratee = getIteratee(iteratee, 3);

      baseForOwn(object, function(value, key, object) {
        baseAssignValue(result, key, iteratee(value, key, object));
      });
      return result;
    }

    /**
     * This method is like `_.assign` except that it recursively merges own and
     * inherited enumerable string keyed properties of source objects into the
     * destination object. Source properties that resolve to `undefined` are
     * skipped if a destination value exists. Array and plain object properties
     * are merged recursively. Other objects and value types are overridden by
     * assignment. Source objects are applied from left to right. Subsequent
     * sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {
     *   'a': [{ 'b': 2 }, { 'd': 4 }]
     * };
     *
     * var other = {
     *   'a': [{ 'c': 3 }, { 'e': 5 }]
     * };
     *
     * _.merge(object, other);
     * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
     */
    var merge = createAssigner(function(object, source, srcIndex) {
      baseMerge(object, source, srcIndex);
    });

    /**
     * This method is like `_.merge` except that it accepts `customizer` which
     * is invoked to produce the merged values of the destination and source
     * properties. If `customizer` returns `undefined`, merging is handled by the
     * method instead. The `customizer` is invoked with six arguments:
     * (objValue, srcValue, key, object, source, stack).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} customizer The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   if (_.isArray(objValue)) {
     *     return objValue.concat(srcValue);
     *   }
     * }
     *
     * var object = { 'a': [1], 'b': [2] };
     * var other = { 'a': [3], 'b': [4] };
     *
     * _.mergeWith(object, other, customizer);
     * // => { 'a': [1, 3], 'b': [2, 4] }
     */
    var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
      baseMerge(object, source, srcIndex, customizer);
    });

    /**
     * The opposite of `_.pick`; this method creates an object composed of the
     * own and inherited enumerable property paths of `object` that are not omitted.
     *
     * **Note:** This method is considerably slower than `_.pick`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to omit.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omit(object, ['a', 'c']);
     * // => { 'b': '2' }
     */
    var omit = flatRest(function(object, paths) {
      var result = {};
      if (object == null) {
        return result;
      }
      var isDeep = false;
      paths = arrayMap(paths, function(path) {
        path = castPath(path, object);
        isDeep || (isDeep = path.length > 1);
        return path;
      });
      copyObject(object, getAllKeysIn(object), result);
      if (isDeep) {
        result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
      }
      var length = paths.length;
      while (length--) {
        baseUnset(result, paths[length]);
      }
      return result;
    });

    /**
     * The opposite of `_.pickBy`; this method creates an object composed of
     * the own and inherited enumerable string keyed properties of `object` that
     * `predicate` doesn't return truthy for. The predicate is invoked with two
     * arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omitBy(object, _.isNumber);
     * // => { 'b': '2' }
     */
    function omitBy(object, predicate) {
      return pickBy(object, negate(getIteratee(predicate)));
    }

    /**
     * Creates an object composed of the picked `object` properties.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pick(object, ['a', 'c']);
     * // => { 'a': 1, 'c': 3 }
     */
    var pick = flatRest(function(object, paths) {
      return object == null ? {} : basePick(object, paths);
    });

    /**
     * Creates an object composed of the `object` properties `predicate` returns
     * truthy for. The predicate is invoked with two arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pickBy(object, _.isNumber);
     * // => { 'a': 1, 'c': 3 }
     */
    function pickBy(object, predicate) {
      if (object == null) {
        return {};
      }
      var props = arrayMap(getAllKeysIn(object), function(prop) {
        return [prop];
      });
      predicate = getIteratee(predicate);
      return basePickBy(object, props, function(value, path) {
        return predicate(value, path[0]);
      });
    }

    /**
     * This method is like `_.get` except that if the resolved value is a
     * function it's invoked with the `this` binding of its parent object and
     * its result is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to resolve.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
     *
     * _.result(object, 'a[0].b.c1');
     * // => 3
     *
     * _.result(object, 'a[0].b.c2');
     * // => 4
     *
     * _.result(object, 'a[0].b.c3', 'default');
     * // => 'default'
     *
     * _.result(object, 'a[0].b.c3', _.constant('default'));
     * // => 'default'
     */
    function result(object, path, defaultValue) {
      path = castPath(path, object);

      var index = -1,
          length = path.length;

      // Ensure the loop is entered when path is empty.
      if (!length) {
        length = 1;
        object = undefined;
      }
      while (++index < length) {
        var value = object == null ? undefined : object[toKey(path[index])];
        if (value === undefined) {
          index = length;
          value = defaultValue;
        }
        object = isFunction(value) ? value.call(object) : value;
      }
      return object;
    }

    /**
     * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
     * it's created. Arrays are created for missing index properties while objects
     * are created for all other missing properties. Use `_.setWith` to customize
     * `path` creation.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.set(object, 'a[0].b.c', 4);
     * console.log(object.a[0].b.c);
     * // => 4
     *
     * _.set(object, ['x', '0', 'y', 'z'], 5);
     * console.log(object.x[0].y.z);
     * // => 5
     */
    function set(object, path, value) {
      return object == null ? object : baseSet(object, path, value);
    }

    /**
     * This method is like `_.set` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.setWith(object, '[0][1]', 'a', Object);
     * // => { '0': { '1': 'a' } }
     */
    function setWith(object, path, value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return object == null ? object : baseSet(object, path, value, customizer);
    }

    /**
     * Creates an array of own enumerable string keyed-value pairs for `object`
     * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
     * entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entries
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairs(new Foo);
     * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
     */
    var toPairs = createToPairs(keys);

    /**
     * Creates an array of own and inherited enumerable string keyed-value pairs
     * for `object` which can be consumed by `_.fromPairs`. If `object` is a map
     * or set, its entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entriesIn
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairsIn(new Foo);
     * // => [['a', 1], ['b', 2], ['c', 3]] (iteration order is not guaranteed)
     */
    var toPairsIn = createToPairs(keysIn);

    /**
     * An alternative to `_.reduce`; this method transforms `object` to a new
     * `accumulator` object which is the result of running each of its own
     * enumerable string keyed properties thru `iteratee`, with each invocation
     * potentially mutating the `accumulator` object. If `accumulator` is not
     * provided, a new object with the same `[[Prototype]]` will be used. The
     * iteratee is invoked with four arguments: (accumulator, value, key, object).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The custom accumulator value.
     * @returns {*} Returns the accumulated value.
     * @example
     *
     * _.transform([2, 3, 4], function(result, n) {
     *   result.push(n *= n);
     *   return n % 2 == 0;
     * }, []);
     * // => [4, 9]
     *
     * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] }
     */
    function transform(object, iteratee, accumulator) {
      var isArr = isArray(object),
          isArrLike = isArr || isBuffer(object) || isTypedArray(object);

      iteratee = getIteratee(iteratee, 4);
      if (accumulator == null) {
        var Ctor = object && object.constructor;
        if (isArrLike) {
          accumulator = isArr ? new Ctor : [];
        }
        else if (isObject(object)) {
          accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
        }
        else {
          accumulator = {};
        }
      }
      (isArrLike ? arrayEach : baseForOwn)(object, function(value, index, object) {
        return iteratee(accumulator, value, index, object);
      });
      return accumulator;
    }

    /**
     * Removes the property at `path` of `object`.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 7 } }] };
     * _.unset(object, 'a[0].b.c');
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     *
     * _.unset(object, ['a', '0', 'b', 'c']);
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     */
    function unset(object, path) {
      return object == null ? true : baseUnset(object, path);
    }

    /**
     * This method is like `_.set` except that accepts `updater` to produce the
     * value to set. Use `_.updateWith` to customize `path` creation. The `updater`
     * is invoked with one argument: (value).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.update(object, 'a[0].b.c', function(n) { return n * n; });
     * console.log(object.a[0].b.c);
     * // => 9
     *
     * _.update(object, 'x[0].y.z', function(n) { return n ? n + 1 : 0; });
     * console.log(object.x[0].y.z);
     * // => 0
     */
    function update(object, path, updater) {
      return object == null ? object : baseUpdate(object, path, castFunction(updater));
    }

    /**
     * This method is like `_.update` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.updateWith(object, '[0][1]', _.constant('a'), Object);
     * // => { '0': { '1': 'a' } }
     */
    function updateWith(object, path, updater, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return object == null ? object : baseUpdate(object, path, castFunction(updater), customizer);
    }

    /**
     * Creates an array of the own enumerable string keyed property values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.values(new Foo);
     * // => [1, 2] (iteration order is not guaranteed)
     *
     * _.values('hi');
     * // => ['h', 'i']
     */
    function values(object) {
      return object == null ? [] : baseValues(object, keys(object));
    }

    /**
     * Creates an array of the own and inherited enumerable string keyed property
     * values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.valuesIn(new Foo);
     * // => [1, 2, 3] (iteration order is not guaranteed)
     */
    function valuesIn(object) {
      return object == null ? [] : baseValues(object, keysIn(object));
    }

    /*------------------------------------------------------------------------*/

    /**
     * Clamps `number` within the inclusive `lower` and `upper` bounds.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Number
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     * @example
     *
     * _.clamp(-10, -5, 5);
     * // => -5
     *
     * _.clamp(10, -5, 5);
     * // => 5
     */
    function clamp(number, lower, upper) {
      if (upper === undefined) {
        upper = lower;
        lower = undefined;
      }
      if (upper !== undefined) {
        upper = toNumber(upper);
        upper = upper === upper ? upper : 0;
      }
      if (lower !== undefined) {
        lower = toNumber(lower);
        lower = lower === lower ? lower : 0;
      }
      return baseClamp(toNumber(number), lower, upper);
    }

    /**
     * Checks if `n` is between `start` and up to, but not including, `end`. If
     * `end` is not specified, it's set to `start` with `start` then set to `0`.
     * If `start` is greater than `end` the params are swapped to support
     * negative ranges.
     *
     * @static
     * @memberOf _
     * @since 3.3.0
     * @category Number
     * @param {number} number The number to check.
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     * @see _.range, _.rangeRight
     * @example
     *
     * _.inRange(3, 2, 4);
     * // => true
     *
     * _.inRange(4, 8);
     * // => true
     *
     * _.inRange(4, 2);
     * // => false
     *
     * _.inRange(2, 2);
     * // => false
     *
     * _.inRange(1.2, 2);
     * // => true
     *
     * _.inRange(5.2, 4);
     * // => false
     *
     * _.inRange(-3, -2, -6);
     * // => true
     */
    function inRange(number, start, end) {
      start = toFinite(start);
      if (end === undefined) {
        end = start;
        start = 0;
      } else {
        end = toFinite(end);
      }
      number = toNumber(number);
      return baseInRange(number, start, end);
    }

    /**
     * Produces a random number between the inclusive `lower` and `upper` bounds.
     * If only one argument is provided a number between `0` and the given number
     * is returned. If `floating` is `true`, or either `lower` or `upper` are
     * floats, a floating-point number is returned instead of an integer.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Number
     * @param {number} [lower=0] The lower bound.
     * @param {number} [upper=1] The upper bound.
     * @param {boolean} [floating] Specify returning a floating-point number.
     * @returns {number} Returns the random number.
     * @example
     *
     * _.random(0, 5);
     * // => an integer between 0 and 5
     *
     * _.random(5);
     * // => also an integer between 0 and 5
     *
     * _.random(5, true);
     * // => a floating-point number between 0 and 5
     *
     * _.random(1.2, 5.2);
     * // => a floating-point number between 1.2 and 5.2
     */
    function random(lower, upper, floating) {
      if (floating && typeof floating != 'boolean' && isIterateeCall(lower, upper, floating)) {
        upper = floating = undefined;
      }
      if (floating === undefined) {
        if (typeof upper == 'boolean') {
          floating = upper;
          upper = undefined;
        }
        else if (typeof lower == 'boolean') {
          floating = lower;
          lower = undefined;
        }
      }
      if (lower === undefined && upper === undefined) {
        lower = 0;
        upper = 1;
      }
      else {
        lower = toFinite(lower);
        if (upper === undefined) {
          upper = lower;
          lower = 0;
        } else {
          upper = toFinite(upper);
        }
      }
      if (lower > upper) {
        var temp = lower;
        lower = upper;
        upper = temp;
      }
      if (floating || lower % 1 || upper % 1) {
        var rand = nativeRandom();
        return nativeMin(lower + (rand * (upper - lower + freeParseFloat('1e-' + ((rand + '').length - 1)))), upper);
      }
      return baseRandom(lower, upper);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the camel cased string.
     * @example
     *
     * _.camelCase('Foo Bar');
     * // => 'fooBar'
     *
     * _.camelCase('--foo-bar--');
     * // => 'fooBar'
     *
     * _.camelCase('__FOO_BAR__');
     * // => 'fooBar'
     */
    var camelCase = createCompounder(function(result, word, index) {
      word = word.toLowerCase();
      return result + (index ? capitalize(word) : word);
    });

    /**
     * Converts the first character of `string` to upper case and the remaining
     * to lower case.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to capitalize.
     * @returns {string} Returns the capitalized string.
     * @example
     *
     * _.capitalize('FRED');
     * // => 'Fred'
     */
    function capitalize(string) {
      return upperFirst(toString(string).toLowerCase());
    }

    /**
     * Deburrs `string` by converting
     * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
     * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
     * letters to basic Latin letters and removing
     * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to deburr.
     * @returns {string} Returns the deburred string.
     * @example
     *
     * _.deburr('déjà vu');
     * // => 'deja vu'
     */
    function deburr(string) {
      string = toString(string);
      return string && string.replace(reLatin, deburrLetter).replace(reComboMark, '');
    }

    /**
     * Checks if `string` ends with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=string.length] The position to search up to.
     * @returns {boolean} Returns `true` if `string` ends with `target`,
     *  else `false`.
     * @example
     *
     * _.endsWith('abc', 'c');
     * // => true
     *
     * _.endsWith('abc', 'b');
     * // => false
     *
     * _.endsWith('abc', 'b', 2);
     * // => true
     */
    function endsWith(string, target, position) {
      string = toString(string);
      target = baseToString(target);

      var length = string.length;
      position = position === undefined
        ? length
        : baseClamp(toInteger(position), 0, length);

      var end = position;
      position -= target.length;
      return position >= 0 && string.slice(position, end) == target;
    }

    /**
     * Converts the characters "&", "<", ">", '"', and "'" in `string` to their
     * corresponding HTML entities.
     *
     * **Note:** No other characters are escaped. To escape additional
     * characters use a third-party library like [_he_](https://mths.be/he).
     *
     * Though the ">" character is escaped for symmetry, characters like
     * ">" and "/" don't need escaping in HTML and have no special meaning
     * unless they're part of a tag or unquoted attribute value. See
     * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
     * (under "semi-related fun fact") for more details.
     *
     * When working with HTML you should always
     * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
     * XSS vectors.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escape('fred, barney, & pebbles');
     * // => 'fred, barney, &amp; pebbles'
     */
    function escape(string) {
      string = toString(string);
      return (string && reHasUnescapedHtml.test(string))
        ? string.replace(reUnescapedHtml, escapeHtmlChar)
        : string;
    }

    /**
     * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
     * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escapeRegExp('[lodash](https://lodash.com/)');
     * // => '\[lodash\]\(https://lodash\.com/\)'
     */
    function escapeRegExp(string) {
      string = toString(string);
      return (string && reHasRegExpChar.test(string))
        ? string.replace(reRegExpChar, '\\$&')
        : string;
    }

    /**
     * Converts `string` to
     * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the kebab cased string.
     * @example
     *
     * _.kebabCase('Foo Bar');
     * // => 'foo-bar'
     *
     * _.kebabCase('fooBar');
     * // => 'foo-bar'
     *
     * _.kebabCase('__FOO_BAR__');
     * // => 'foo-bar'
     */
    var kebabCase = createCompounder(function(result, word, index) {
      return result + (index ? '-' : '') + word.toLowerCase();
    });

    /**
     * Converts `string`, as space separated words, to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.lowerCase('--Foo-Bar--');
     * // => 'foo bar'
     *
     * _.lowerCase('fooBar');
     * // => 'foo bar'
     *
     * _.lowerCase('__FOO_BAR__');
     * // => 'foo bar'
     */
    var lowerCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + word.toLowerCase();
    });

    /**
     * Converts the first character of `string` to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.lowerFirst('Fred');
     * // => 'fred'
     *
     * _.lowerFirst('FRED');
     * // => 'fRED'
     */
    var lowerFirst = createCaseFirst('toLowerCase');

    /**
     * Pads `string` on the left and right sides if it's shorter than `length`.
     * Padding characters are truncated if they can't be evenly divided by `length`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.pad('abc', 8);
     * // => '  abc   '
     *
     * _.pad('abc', 8, '_-');
     * // => '_-abc_-_'
     *
     * _.pad('abc', 3);
     * // => 'abc'
     */
    function pad(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      if (!length || strLength >= length) {
        return string;
      }
      var mid = (length - strLength) / 2;
      return (
        createPadding(nativeFloor(mid), chars) +
        string +
        createPadding(nativeCeil(mid), chars)
      );
    }

    /**
     * Pads `string` on the right side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padEnd('abc', 6);
     * // => 'abc   '
     *
     * _.padEnd('abc', 6, '_-');
     * // => 'abc_-_'
     *
     * _.padEnd('abc', 3);
     * // => 'abc'
     */
    function padEnd(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      return (length && strLength < length)
        ? (string + createPadding(length - strLength, chars))
        : string;
    }

    /**
     * Pads `string` on the left side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padStart('abc', 6);
     * // => '   abc'
     *
     * _.padStart('abc', 6, '_-');
     * // => '_-_abc'
     *
     * _.padStart('abc', 3);
     * // => 'abc'
     */
    function padStart(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      return (length && strLength < length)
        ? (createPadding(length - strLength, chars) + string)
        : string;
    }

    /**
     * Converts `string` to an integer of the specified radix. If `radix` is
     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a
     * hexadecimal, in which case a `radix` of `16` is used.
     *
     * **Note:** This method aligns with the
     * [ES5 implementation](https://es5.github.io/#x15.1.2.2) of `parseInt`.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category String
     * @param {string} string The string to convert.
     * @param {number} [radix=10] The radix to interpret `value` by.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.parseInt('08');
     * // => 8
     *
     * _.map(['6', '08', '10'], _.parseInt);
     * // => [6, 8, 10]
     */
    function parseInt(string, radix, guard) {
      if (guard || radix == null) {
        radix = 0;
      } else if (radix) {
        radix = +radix;
      }
      return nativeParseInt(toString(string).replace(reTrimStart, ''), radix || 0);
    }

    /**
     * Repeats the given string `n` times.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to repeat.
     * @param {number} [n=1] The number of times to repeat the string.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the repeated string.
     * @example
     *
     * _.repeat('*', 3);
     * // => '***'
     *
     * _.repeat('abc', 2);
     * // => 'abcabc'
     *
     * _.repeat('abc', 0);
     * // => ''
     */
    function repeat(string, n, guard) {
      if ((guard ? isIterateeCall(string, n, guard) : n === undefined)) {
        n = 1;
      } else {
        n = toInteger(n);
      }
      return baseRepeat(toString(string), n);
    }

    /**
     * Replaces matches for `pattern` in `string` with `replacement`.
     *
     * **Note:** This method is based on
     * [`String#replace`](https://mdn.io/String/replace).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to modify.
     * @param {RegExp|string} pattern The pattern to replace.
     * @param {Function|string} replacement The match replacement.
     * @returns {string} Returns the modified string.
     * @example
     *
     * _.replace('Hi Fred', 'Fred', 'Barney');
     * // => 'Hi Barney'
     */
    function replace() {
      var args = arguments,
          string = toString(args[0]);

      return args.length < 3 ? string : string.replace(args[1], args[2]);
    }

    /**
     * Converts `string` to
     * [snake case](https://en.wikipedia.org/wiki/Snake_case).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the snake cased string.
     * @example
     *
     * _.snakeCase('Foo Bar');
     * // => 'foo_bar'
     *
     * _.snakeCase('fooBar');
     * // => 'foo_bar'
     *
     * _.snakeCase('--FOO-BAR--');
     * // => 'foo_bar'
     */
    var snakeCase = createCompounder(function(result, word, index) {
      return result + (index ? '_' : '') + word.toLowerCase();
    });

    /**
     * Splits `string` by `separator`.
     *
     * **Note:** This method is based on
     * [`String#split`](https://mdn.io/String/split).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to split.
     * @param {RegExp|string} separator The separator pattern to split by.
     * @param {number} [limit] The length to truncate results to.
     * @returns {Array} Returns the string segments.
     * @example
     *
     * _.split('a-b-c', '-', 2);
     * // => ['a', 'b']
     */
    function split(string, separator, limit) {
      if (limit && typeof limit != 'number' && isIterateeCall(string, separator, limit)) {
        separator = limit = undefined;
      }
      limit = limit === undefined ? MAX_ARRAY_LENGTH : limit >>> 0;
      if (!limit) {
        return [];
      }
      string = toString(string);
      if (string && (
            typeof separator == 'string' ||
            (separator != null && !isRegExp(separator))
          )) {
        separator = baseToString(separator);
        if (!separator && hasUnicode(string)) {
          return castSlice(stringToArray(string), 0, limit);
        }
      }
      return string.split(separator, limit);
    }

    /**
     * Converts `string` to
     * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
     *
     * @static
     * @memberOf _
     * @since 3.1.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the start cased string.
     * @example
     *
     * _.startCase('--foo-bar--');
     * // => 'Foo Bar'
     *
     * _.startCase('fooBar');
     * // => 'Foo Bar'
     *
     * _.startCase('__FOO_BAR__');
     * // => 'FOO BAR'
     */
    var startCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + upperFirst(word);
    });

    /**
     * Checks if `string` starts with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=0] The position to search from.
     * @returns {boolean} Returns `true` if `string` starts with `target`,
     *  else `false`.
     * @example
     *
     * _.startsWith('abc', 'a');
     * // => true
     *
     * _.startsWith('abc', 'b');
     * // => false
     *
     * _.startsWith('abc', 'b', 1);
     * // => true
     */
    function startsWith(string, target, position) {
      string = toString(string);
      position = position == null
        ? 0
        : baseClamp(toInteger(position), 0, string.length);

      target = baseToString(target);
      return string.slice(position, position + target.length) == target;
    }

    /**
     * Creates a compiled template function that can interpolate data properties
     * in "interpolate" delimiters, HTML-escape interpolated data properties in
     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
     * properties may be accessed as free variables in the template. If a setting
     * object is given, it takes precedence over `_.templateSettings` values.
     *
     * **Note:** In the development build `_.template` utilizes
     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
     * for easier debugging.
     *
     * For more information on precompiling templates see
     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
     *
     * For more information on Chrome extension sandboxes see
     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The template string.
     * @param {Object} [options={}] The options object.
     * @param {RegExp} [options.escape=_.templateSettings.escape]
     *  The HTML "escape" delimiter.
     * @param {RegExp} [options.evaluate=_.templateSettings.evaluate]
     *  The "evaluate" delimiter.
     * @param {Object} [options.imports=_.templateSettings.imports]
     *  An object to import into the template as free variables.
     * @param {RegExp} [options.interpolate=_.templateSettings.interpolate]
     *  The "interpolate" delimiter.
     * @param {string} [options.sourceURL='lodash.templateSources[n]']
     *  The sourceURL of the compiled template.
     * @param {string} [options.variable='obj']
     *  The data object variable name.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the compiled template function.
     * @example
     *
     * // Use the "interpolate" delimiter to create a compiled template.
     * var compiled = _.template('hello <%= user %>!');
     * compiled({ 'user': 'fred' });
     * // => 'hello fred!'
     *
     * // Use the HTML "escape" delimiter to escape data property values.
     * var compiled = _.template('<b><%- value %></b>');
     * compiled({ 'value': '<script>' });
     * // => '<b>&lt;script&gt;</b>'
     *
     * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the internal `print` function in "evaluate" delimiters.
     * var compiled = _.template('<% print("hello " + user); %>!');
     * compiled({ 'user': 'barney' });
     * // => 'hello barney!'
     *
     * // Use the ES template literal delimiter as an "interpolate" delimiter.
     * // Disable support by replacing the "interpolate" delimiter.
     * var compiled = _.template('hello ${ user }!');
     * compiled({ 'user': 'pebbles' });
     * // => 'hello pebbles!'
     *
     * // Use backslashes to treat delimiters as plain text.
     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
     * compiled({ 'value': 'ignored' });
     * // => '<%- value %>'
     *
     * // Use the `imports` option to import `jQuery` as `jq`.
     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the `sourceURL` option to specify a custom sourceURL for the template.
     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
     * compiled(data);
     * // => Find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector.
     *
     * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
     * compiled.source;
     * // => function(data) {
     * //   var __t, __p = '';
     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
     * //   return __p;
     * // }
     *
     * // Use custom template delimiters.
     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
     * var compiled = _.template('hello {{ user }}!');
     * compiled({ 'user': 'mustache' });
     * // => 'hello mustache!'
     *
     * // Use the `source` property to inline compiled templates for meaningful
     * // line numbers in error messages and stack traces.
     * fs.writeFileSync(path.join(process.cwd(), 'jst.js'), '\
     *   var JST = {\
     *     "main": ' + _.template(mainText).source + '\
     *   };\
     * ');
     */
    function template(string, options, guard) {
      // Based on John Resig's `tmpl` implementation
      // (http://ejohn.org/blog/javascript-micro-templating/)
      // and Laura Doktorova's doT.js (https://github.com/olado/doT).
      var settings = lodash.templateSettings;

      if (guard && isIterateeCall(string, options, guard)) {
        options = undefined;
      }
      string = toString(string);
      options = assignInWith({}, options, settings, customDefaultsAssignIn);

      var imports = assignInWith({}, options.imports, settings.imports, customDefaultsAssignIn),
          importsKeys = keys(imports),
          importsValues = baseValues(imports, importsKeys);

      var isEscaping,
          isEvaluating,
          index = 0,
          interpolate = options.interpolate || reNoMatch,
          source = "__p += '";

      // Compile the regexp to match each delimiter.
      var reDelimiters = RegExp(
        (options.escape || reNoMatch).source + '|' +
        interpolate.source + '|' +
        (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + '|' +
        (options.evaluate || reNoMatch).source + '|$'
      , 'g');

      // Use a sourceURL for easier debugging.
      // The sourceURL gets injected into the source that's eval-ed, so be careful
      // to normalize all kinds of whitespace, so e.g. newlines (and unicode versions of it) can't sneak in
      // and escape the comment, thus injecting code that gets evaled.
      var sourceURL = '//# sourceURL=' +
        (hasOwnProperty.call(options, 'sourceURL')
          ? (options.sourceURL + '').replace(/\s/g, ' ')
          : ('lodash.templateSources[' + (++templateCounter) + ']')
        ) + '\n';

      string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
        interpolateValue || (interpolateValue = esTemplateValue);

        // Escape characters that can't be included in string literals.
        source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);

        // Replace delimiters with snippets.
        if (escapeValue) {
          isEscaping = true;
          source += "' +\n__e(" + escapeValue + ") +\n'";
        }
        if (evaluateValue) {
          isEvaluating = true;
          source += "';\n" + evaluateValue + ";\n__p += '";
        }
        if (interpolateValue) {
          source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
        }
        index = offset + match.length;

        // The JS engine embedded in Adobe products needs `match` returned in
        // order to produce the correct `offset` value.
        return match;
      });

      source += "';\n";

      // If `variable` is not specified wrap a with-statement around the generated
      // code to add the data object to the top of the scope chain.
      var variable = hasOwnProperty.call(options, 'variable') && options.variable;
      if (!variable) {
        source = 'with (obj) {\n' + source + '\n}\n';
      }
      // Throw an error if a forbidden character was found in `variable`, to prevent
      // potential command injection attacks.
      else if (reForbiddenIdentifierChars.test(variable)) {
        throw new Error(INVALID_TEMPL_VAR_ERROR_TEXT);
      }

      // Cleanup code by stripping empty strings.
      source = (isEvaluating ? source.replace(reEmptyStringLeading, '') : source)
        .replace(reEmptyStringMiddle, '$1')
        .replace(reEmptyStringTrailing, '$1;');

      // Frame code as the function body.
      source = 'function(' + (variable || 'obj') + ') {\n' +
        (variable
          ? ''
          : 'obj || (obj = {});\n'
        ) +
        "var __t, __p = ''" +
        (isEscaping
           ? ', __e = _.escape'
           : ''
        ) +
        (isEvaluating
          ? ', __j = Array.prototype.join;\n' +
            "function print() { __p += __j.call(arguments, '') }\n"
          : ';\n'
        ) +
        source +
        'return __p\n}';

      var result = attempt(function() {
        return Function(importsKeys, sourceURL + 'return ' + source)
          .apply(undefined, importsValues);
      });

      // Provide the compiled function's source by its `toString` method or
      // the `source` property as a convenience for inlining compiled templates.
      result.source = source;
      if (isError(result)) {
        throw result;
      }
      return result;
    }

    /**
     * Converts `string`, as a whole, to lower case just like
     * [String#toLowerCase](https://mdn.io/toLowerCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.toLower('--Foo-Bar--');
     * // => '--foo-bar--'
     *
     * _.toLower('fooBar');
     * // => 'foobar'
     *
     * _.toLower('__FOO_BAR__');
     * // => '__foo_bar__'
     */
    function toLower(value) {
      return toString(value).toLowerCase();
    }

    /**
     * Converts `string`, as a whole, to upper case just like
     * [String#toUpperCase](https://mdn.io/toUpperCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.toUpper('--foo-bar--');
     * // => '--FOO-BAR--'
     *
     * _.toUpper('fooBar');
     * // => 'FOOBAR'
     *
     * _.toUpper('__foo_bar__');
     * // => '__FOO_BAR__'
     */
    function toUpper(value) {
      return toString(value).toUpperCase();
    }

    /**
     * Removes leading and trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trim('  abc  ');
     * // => 'abc'
     *
     * _.trim('-_-abc-_-', '_-');
     * // => 'abc'
     *
     * _.map(['  foo  ', '  bar  '], _.trim);
     * // => ['foo', 'bar']
     */
    function trim(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return baseTrim(string);
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          chrSymbols = stringToArray(chars),
          start = charsStartIndex(strSymbols, chrSymbols),
          end = charsEndIndex(strSymbols, chrSymbols) + 1;

      return castSlice(strSymbols, start, end).join('');
    }

    /**
     * Removes trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimEnd('  abc  ');
     * // => '  abc'
     *
     * _.trimEnd('-_-abc-_-', '_-');
     * // => '-_-abc'
     */
    function trimEnd(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return string.slice(0, trimmedEndIndex(string) + 1);
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          end = charsEndIndex(strSymbols, stringToArray(chars)) + 1;

      return castSlice(strSymbols, 0, end).join('');
    }

    /**
     * Removes leading whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimStart('  abc  ');
     * // => 'abc  '
     *
     * _.trimStart('-_-abc-_-', '_-');
     * // => 'abc-_-'
     */
    function trimStart(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return string.replace(reTrimStart, '');
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          start = charsStartIndex(strSymbols, stringToArray(chars));

      return castSlice(strSymbols, start).join('');
    }

    /**
     * Truncates `string` if it's longer than the given maximum string length.
     * The last characters of the truncated string are replaced with the omission
     * string which defaults to "...".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to truncate.
     * @param {Object} [options={}] The options object.
     * @param {number} [options.length=30] The maximum string length.
     * @param {string} [options.omission='...'] The string to indicate text is omitted.
     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
     * @returns {string} Returns the truncated string.
     * @example
     *
     * _.truncate('hi-diddly-ho there, neighborino');
     * // => 'hi-diddly-ho there, neighbo...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': ' '
     * });
     * // => 'hi-diddly-ho there,...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': /,? +/
     * });
     * // => 'hi-diddly-ho there...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'omission': ' [...]'
     * });
     * // => 'hi-diddly-ho there, neig [...]'
     */
    function truncate(string, options) {
      var length = DEFAULT_TRUNC_LENGTH,
          omission = DEFAULT_TRUNC_OMISSION;

      if (isObject(options)) {
        var separator = 'separator' in options ? options.separator : separator;
        length = 'length' in options ? toInteger(options.length) : length;
        omission = 'omission' in options ? baseToString(options.omission) : omission;
      }
      string = toString(string);

      var strLength = string.length;
      if (hasUnicode(string)) {
        var strSymbols = stringToArray(string);
        strLength = strSymbols.length;
      }
      if (length >= strLength) {
        return string;
      }
      var end = length - stringSize(omission);
      if (end < 1) {
        return omission;
      }
      var result = strSymbols
        ? castSlice(strSymbols, 0, end).join('')
        : string.slice(0, end);

      if (separator === undefined) {
        return result + omission;
      }
      if (strSymbols) {
        end += (result.length - end);
      }
      if (isRegExp(separator)) {
        if (string.slice(end).search(separator)) {
          var match,
              substring = result;

          if (!separator.global) {
            separator = RegExp(separator.source, toString(reFlags.exec(separator)) + 'g');
          }
          separator.lastIndex = 0;
          while ((match = separator.exec(substring))) {
            var newEnd = match.index;
          }
          result = result.slice(0, newEnd === undefined ? end : newEnd);
        }
      } else if (string.indexOf(baseToString(separator), end) != end) {
        var index = result.lastIndexOf(separator);
        if (index > -1) {
          result = result.slice(0, index);
        }
      }
      return result + omission;
    }

    /**
     * The inverse of `_.escape`; this method converts the HTML entities
     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, and `&#39;` in `string` to
     * their corresponding characters.
     *
     * **Note:** No other HTML entities are unescaped. To unescape additional
     * HTML entities use a third-party library like [_he_](https://mths.be/he).
     *
     * @static
     * @memberOf _
     * @since 0.6.0
     * @category String
     * @param {string} [string=''] The string to unescape.
     * @returns {string} Returns the unescaped string.
     * @example
     *
     * _.unescape('fred, barney, &amp; pebbles');
     * // => 'fred, barney, & pebbles'
     */
    function unescape(string) {
      string = toString(string);
      return (string && reHasEscapedHtml.test(string))
        ? string.replace(reEscapedHtml, unescapeHtmlChar)
        : string;
    }

    /**
     * Converts `string`, as space separated words, to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.upperCase('--foo-bar');
     * // => 'FOO BAR'
     *
     * _.upperCase('fooBar');
     * // => 'FOO BAR'
     *
     * _.upperCase('__foo_bar__');
     * // => 'FOO BAR'
     */
    var upperCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + word.toUpperCase();
    });

    /**
     * Converts the first character of `string` to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.upperFirst('fred');
     * // => 'Fred'
     *
     * _.upperFirst('FRED');
     * // => 'FRED'
     */
    var upperFirst = createCaseFirst('toUpperCase');

    /**
     * Splits `string` into an array of its words.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {RegExp|string} [pattern] The pattern to match words.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the words of `string`.
     * @example
     *
     * _.words('fred, barney, & pebbles');
     * // => ['fred', 'barney', 'pebbles']
     *
     * _.words('fred, barney, & pebbles', /[^, ]+/g);
     * // => ['fred', 'barney', '&', 'pebbles']
     */
    function words(string, pattern, guard) {
      string = toString(string);
      pattern = guard ? undefined : pattern;

      if (pattern === undefined) {
        return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
      }
      return string.match(pattern) || [];
    }

    /*------------------------------------------------------------------------*/

    /**
     * Attempts to invoke `func`, returning either the result or the caught error
     * object. Any additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Function} func The function to attempt.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {*} Returns the `func` result or error object.
     * @example
     *
     * // Avoid throwing errors for invalid selectors.
     * var elements = _.attempt(function(selector) {
     *   return document.querySelectorAll(selector);
     * }, '>_>');
     *
     * if (_.isError(elements)) {
     *   elements = [];
     * }
     */
    var attempt = baseRest(function(func, args) {
      try {
        return apply(func, undefined, args);
      } catch (e) {
        return isError(e) ? e : new Error(e);
      }
    });

    /**
     * Binds methods of an object to the object itself, overwriting the existing
     * method.
     *
     * **Note:** This method doesn't set the "length" property of bound functions.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Object} object The object to bind and assign the bound methods to.
     * @param {...(string|string[])} methodNames The object method names to bind.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var view = {
     *   'label': 'docs',
     *   'click': function() {
     *     console.log('clicked ' + this.label);
     *   }
     * };
     *
     * _.bindAll(view, ['click']);
     * jQuery(element).on('click', view.click);
     * // => Logs 'clicked docs' when clicked.
     */
    var bindAll = flatRest(function(object, methodNames) {
      arrayEach(methodNames, function(key) {
        key = toKey(key);
        baseAssignValue(object, key, bind(object[key], object));
      });
      return object;
    });

    /**
     * Creates a function that iterates over `pairs` and invokes the corresponding
     * function of the first predicate to return truthy. The predicate-function
     * pairs are invoked with the `this` binding and arguments of the created
     * function.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Array} pairs The predicate-function pairs.
     * @returns {Function} Returns the new composite function.
     * @example
     *
     * var func = _.cond([
     *   [_.matches({ 'a': 1 }),           _.constant('matches A')],
     *   [_.conforms({ 'b': _.isNumber }), _.constant('matches B')],
     *   [_.stubTrue,                      _.constant('no match')]
     * ]);
     *
     * func({ 'a': 1, 'b': 2 });
     * // => 'matches A'
     *
     * func({ 'a': 0, 'b': 1 });
     * // => 'matches B'
     *
     * func({ 'a': '1', 'b': '2' });
     * // => 'no match'
     */
    function cond(pairs) {
      var length = pairs == null ? 0 : pairs.length,
          toIteratee = getIteratee();

      pairs = !length ? [] : arrayMap(pairs, function(pair) {
        if (typeof pair[1] != 'function') {
          throw new TypeError(FUNC_ERROR_TEXT);
        }
        return [toIteratee(pair[0]), pair[1]];
      });

      return baseRest(function(args) {
        var index = -1;
        while (++index < length) {
          var pair = pairs[index];
          if (apply(pair[0], this, args)) {
            return apply(pair[1], this, args);
          }
        }
      });
    }

    /**
     * Creates a function that invokes the predicate properties of `source` with
     * the corresponding property values of a given object, returning `true` if
     * all predicates return truthy, else `false`.
     *
     * **Note:** The created function is equivalent to `_.conformsTo` with
     * `source` partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 2, 'b': 1 },
     *   { 'a': 1, 'b': 2 }
     * ];
     *
     * _.filter(objects, _.conforms({ 'b': function(n) { return n > 1; } }));
     * // => [{ 'a': 1, 'b': 2 }]
     */
    function conforms(source) {
      return baseConforms(baseClone(source, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that returns `value`.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {*} value The value to return from the new function.
     * @returns {Function} Returns the new constant function.
     * @example
     *
     * var objects = _.times(2, _.constant({ 'a': 1 }));
     *
     * console.log(objects);
     * // => [{ 'a': 1 }, { 'a': 1 }]
     *
     * console.log(objects[0] === objects[1]);
     * // => true
     */
    function constant(value) {
      return function() {
        return value;
      };
    }

    /**
     * Checks `value` to determine whether a default value should be returned in
     * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
     * or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Util
     * @param {*} value The value to check.
     * @param {*} defaultValue The default value.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * _.defaultTo(1, 10);
     * // => 1
     *
     * _.defaultTo(undefined, 10);
     * // => 10
     */
    function defaultTo(value, defaultValue) {
      return (value == null || value !== value) ? defaultValue : value;
    }

    /**
     * Creates a function that returns the result of invoking the given functions
     * with the `this` binding of the created function, where each successive
     * invocation is supplied the return value of the previous.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flowRight
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flow([_.add, square]);
     * addSquare(1, 2);
     * // => 9
     */
    var flow = createFlow();

    /**
     * This method is like `_.flow` except that it creates a function that
     * invokes the given functions from right to left.
     *
     * @static
     * @since 3.0.0
     * @memberOf _
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flow
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flowRight([square, _.add]);
     * addSquare(1, 2);
     * // => 9
     */
    var flowRight = createFlow(true);

    /**
     * This method returns the first argument it receives.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {*} value Any value.
     * @returns {*} Returns `value`.
     * @example
     *
     * var object = { 'a': 1 };
     *
     * console.log(_.identity(object) === object);
     * // => true
     */
    function identity(value) {
      return value;
    }

    /**
     * Creates a function that invokes `func` with the arguments of the created
     * function. If `func` is a property name, the created function returns the
     * property value for a given element. If `func` is an array or object, the
     * created function returns `true` for elements that contain the equivalent
     * source properties, otherwise it returns `false`.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Util
     * @param {*} [func=_.identity] The value to convert to a callback.
     * @returns {Function} Returns the callback.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
     * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, _.iteratee(['user', 'fred']));
     * // => [{ 'user': 'fred', 'age': 40 }]
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, _.iteratee('user'));
     * // => ['barney', 'fred']
     *
     * // Create custom iteratee shorthands.
     * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
     *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
     *     return func.test(string);
     *   };
     * });
     *
     * _.filter(['abc', 'def'], /ef/);
     * // => ['def']
     */
    function iteratee(func) {
      return baseIteratee(typeof func == 'function' ? func : baseClone(func, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that performs a partial deep comparison between a given
     * object and `source`, returning `true` if the given object has equivalent
     * property values, else `false`.
     *
     * **Note:** The created function is equivalent to `_.isMatch` with `source`
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.filter(objects, _.matches({ 'a': 4, 'c': 6 }));
     * // => [{ 'a': 4, 'b': 5, 'c': 6 }]
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matches({ 'a': 1 }), _.matches({ 'a': 4 })]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */
    function matches(source) {
      return baseMatches(baseClone(source, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that performs a partial deep comparison between the
     * value at `path` of a given object to `srcValue`, returning `true` if the
     * object value is equivalent, else `false`.
     *
     * **Note:** Partial comparisons will match empty array and empty object
     * `srcValue` values against any array or object value, respectively. See
     * `_.isEqual` for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.find(objects, _.matchesProperty('a', 4));
     * // => { 'a': 4, 'b': 5, 'c': 6 }
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matchesProperty('a', 1), _.matchesProperty('a', 4)]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */
    function matchesProperty(path, srcValue) {
      return baseMatchesProperty(path, baseClone(srcValue, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that invokes the method at `path` of a given object.
     * Any additional arguments are provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': _.constant(2) } },
     *   { 'a': { 'b': _.constant(1) } }
     * ];
     *
     * _.map(objects, _.method('a.b'));
     * // => [2, 1]
     *
     * _.map(objects, _.method(['a', 'b']));
     * // => [2, 1]
     */
    var method = baseRest(function(path, args) {
      return function(object) {
        return baseInvoke(object, path, args);
      };
    });

    /**
     * The opposite of `_.method`; this method creates a function that invokes
     * the method at a given path of `object`. Any additional arguments are
     * provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Object} object The object to query.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var array = _.times(3, _.constant),
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
     * // => [2, 0]
     */
    var methodOf = baseRest(function(object, args) {
      return function(path) {
        return baseInvoke(object, path, args);
      };
    });

    /**
     * Adds all own enumerable string keyed function properties of a source
     * object to the destination object. If `object` is a function, then methods
     * are added to its prototype as well.
     *
     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
     * avoid conflicts caused by modifying the original.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Function|Object} [object=lodash] The destination object.
     * @param {Object} source The object of functions to add.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.chain=true] Specify whether mixins are chainable.
     * @returns {Function|Object} Returns `object`.
     * @example
     *
     * function vowels(string) {
     *   return _.filter(string, function(v) {
     *     return /[aeiou]/i.test(v);
     *   });
     * }
     *
     * _.mixin({ 'vowels': vowels });
     * _.vowels('fred');
     * // => ['e']
     *
     * _('fred').vowels().value();
     * // => ['e']
     *
     * _.mixin({ 'vowels': vowels }, { 'chain': false });
     * _('fred').vowels();
     * // => ['e']
     */
    function mixin(object, source, options) {
      var props = keys(source),
          methodNames = baseFunctions(source, props);

      if (options == null &&
          !(isObject(source) && (methodNames.length || !props.length))) {
        options = source;
        source = object;
        object = this;
        methodNames = baseFunctions(source, keys(source));
      }
      var chain = !(isObject(options) && 'chain' in options) || !!options.chain,
          isFunc = isFunction(object);

      arrayEach(methodNames, function(methodName) {
        var func = source[methodName];
        object[methodName] = func;
        if (isFunc) {
          object.prototype[methodName] = function() {
            var chainAll = this.__chain__;
            if (chain || chainAll) {
              var result = object(this.__wrapped__),
                  actions = result.__actions__ = copyArray(this.__actions__);

              actions.push({ 'func': func, 'args': arguments, 'thisArg': object });
              result.__chain__ = chainAll;
              return result;
            }
            return func.apply(object, arrayPush([this.value()], arguments));
          };
        }
      });

      return object;
    }

    /**
     * Reverts the `_` variable to its previous value and returns a reference to
     * the `lodash` function.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @returns {Function} Returns the `lodash` function.
     * @example
     *
     * var lodash = _.noConflict();
     */
    function noConflict() {
      if (root._ === this) {
        root._ = oldDash;
      }
      return this;
    }

    /**
     * This method returns `undefined`.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Util
     * @example
     *
     * _.times(2, _.noop);
     * // => [undefined, undefined]
     */
    function noop() {
      // No operation performed.
    }

    /**
     * Creates a function that gets the argument at index `n`. If `n` is negative,
     * the nth argument from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [n=0] The index of the argument to return.
     * @returns {Function} Returns the new pass-thru function.
     * @example
     *
     * var func = _.nthArg(1);
     * func('a', 'b', 'c', 'd');
     * // => 'b'
     *
     * var func = _.nthArg(-2);
     * func('a', 'b', 'c', 'd');
     * // => 'c'
     */
    function nthArg(n) {
      n = toInteger(n);
      return baseRest(function(args) {
        return baseNth(args, n);
      });
    }

    /**
     * Creates a function that invokes `iteratees` with the arguments it receives
     * and returns their results.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to invoke.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.over([Math.max, Math.min]);
     *
     * func(1, 2, 3, 4);
     * // => [4, 1]
     */
    var over = createOver(arrayMap);

    /**
     * Creates a function that checks if **all** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overEvery([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => false
     *
     * func(NaN);
     * // => false
     */
    var overEvery = createOver(arrayEvery);

    /**
     * Creates a function that checks if **any** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overSome([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => true
     *
     * func(NaN);
     * // => false
     *
     * var matchesFunc = _.overSome([{ 'a': 1 }, { 'a': 2 }])
     * var matchesPropertyFunc = _.overSome([['a', 1], ['a', 2]])
     */
    var overSome = createOver(arraySome);

    /**
     * Creates a function that returns the value at `path` of a given object.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': 2 } },
     *   { 'a': { 'b': 1 } }
     * ];
     *
     * _.map(objects, _.property('a.b'));
     * // => [2, 1]
     *
     * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
     * // => [1, 2]
     */
    function property(path) {
      return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
    }

    /**
     * The opposite of `_.property`; this method creates a function that returns
     * the value at a given path of `object`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} object The object to query.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var array = [0, 1, 2],
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
     * // => [2, 0]
     */
    function propertyOf(object) {
      return function(path) {
        return object == null ? undefined : baseGet(object, path);
      };
    }

    /**
     * Creates an array of numbers (positive and/or negative) progressing from
     * `start` up to, but not including, `end`. A step of `-1` is used if a negative
     * `start` is specified without an `end` or `step`. If `end` is not specified,
     * it's set to `start` with `start` then set to `0`.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.rangeRight
     * @example
     *
     * _.range(4);
     * // => [0, 1, 2, 3]
     *
     * _.range(-4);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 5);
     * // => [1, 2, 3, 4]
     *
     * _.range(0, 20, 5);
     * // => [0, 5, 10, 15]
     *
     * _.range(0, -4, -1);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.range(0);
     * // => []
     */
    var range = createRange();

    /**
     * This method is like `_.range` except that it populates values in
     * descending order.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.range
     * @example
     *
     * _.rangeRight(4);
     * // => [3, 2, 1, 0]
     *
     * _.rangeRight(-4);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 5);
     * // => [4, 3, 2, 1]
     *
     * _.rangeRight(0, 20, 5);
     * // => [15, 10, 5, 0]
     *
     * _.rangeRight(0, -4, -1);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.rangeRight(0);
     * // => []
     */
    var rangeRight = createRange(true);

    /**
     * This method returns a new empty array.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Array} Returns the new empty array.
     * @example
     *
     * var arrays = _.times(2, _.stubArray);
     *
     * console.log(arrays);
     * // => [[], []]
     *
     * console.log(arrays[0] === arrays[1]);
     * // => false
     */
    function stubArray() {
      return [];
    }

    /**
     * This method returns `false`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `false`.
     * @example
     *
     * _.times(2, _.stubFalse);
     * // => [false, false]
     */
    function stubFalse() {
      return false;
    }

    /**
     * This method returns a new empty object.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Object} Returns the new empty object.
     * @example
     *
     * var objects = _.times(2, _.stubObject);
     *
     * console.log(objects);
     * // => [{}, {}]
     *
     * console.log(objects[0] === objects[1]);
     * // => false
     */
    function stubObject() {
      return {};
    }

    /**
     * This method returns an empty string.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {string} Returns the empty string.
     * @example
     *
     * _.times(2, _.stubString);
     * // => ['', '']
     */
    function stubString() {
      return '';
    }

    /**
     * This method returns `true`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `true`.
     * @example
     *
     * _.times(2, _.stubTrue);
     * // => [true, true]
     */
    function stubTrue() {
      return true;
    }

    /**
     * Invokes the iteratee `n` times, returning an array of the results of
     * each invocation. The iteratee is invoked with one argument; (index).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} n The number of times to invoke `iteratee`.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.times(3, String);
     * // => ['0', '1', '2']
     *
     *  _.times(4, _.constant(0));
     * // => [0, 0, 0, 0]
     */
    function times(n, iteratee) {
      n = toInteger(n);
      if (n < 1 || n > MAX_SAFE_INTEGER) {
        return [];
      }
      var index = MAX_ARRAY_LENGTH,
          length = nativeMin(n, MAX_ARRAY_LENGTH);

      iteratee = getIteratee(iteratee);
      n -= MAX_ARRAY_LENGTH;

      var result = baseTimes(length, iteratee);
      while (++index < n) {
        iteratee(index);
      }
      return result;
    }

    /**
     * Converts `value` to a property path array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {*} value The value to convert.
     * @returns {Array} Returns the new property path array.
     * @example
     *
     * _.toPath('a.b.c');
     * // => ['a', 'b', 'c']
     *
     * _.toPath('a[0].b.c');
     * // => ['a', '0', 'b', 'c']
     */
    function toPath(value) {
      if (isArray(value)) {
        return arrayMap(value, toKey);
      }
      return isSymbol(value) ? [value] : copyArray(stringToPath(toString(value)));
    }

    /**
     * Generates a unique ID. If `prefix` is given, the ID is appended to it.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {string} [prefix=''] The value to prefix the ID with.
     * @returns {string} Returns the unique ID.
     * @example
     *
     * _.uniqueId('contact_');
     * // => 'contact_104'
     *
     * _.uniqueId();
     * // => '105'
     */
    function uniqueId(prefix) {
      var id = ++idCounter;
      return toString(prefix) + id;
    }

    /*------------------------------------------------------------------------*/

    /**
     * Adds two numbers.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {number} augend The first number in an addition.
     * @param {number} addend The second number in an addition.
     * @returns {number} Returns the total.
     * @example
     *
     * _.add(6, 4);
     * // => 10
     */
    var add = createMathOperation(function(augend, addend) {
      return augend + addend;
    }, 0);

    /**
     * Computes `number` rounded up to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round up.
     * @param {number} [precision=0] The precision to round up to.
     * @returns {number} Returns the rounded up number.
     * @example
     *
     * _.ceil(4.006);
     * // => 5
     *
     * _.ceil(6.004, 2);
     * // => 6.01
     *
     * _.ceil(6040, -2);
     * // => 6100
     */
    var ceil = createRound('ceil');

    /**
     * Divide two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} dividend The first number in a division.
     * @param {number} divisor The second number in a division.
     * @returns {number} Returns the quotient.
     * @example
     *
     * _.divide(6, 4);
     * // => 1.5
     */
    var divide = createMathOperation(function(dividend, divisor) {
      return dividend / divisor;
    }, 1);

    /**
     * Computes `number` rounded down to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round down.
     * @param {number} [precision=0] The precision to round down to.
     * @returns {number} Returns the rounded down number.
     * @example
     *
     * _.floor(4.006);
     * // => 4
     *
     * _.floor(0.046, 2);
     * // => 0.04
     *
     * _.floor(4060, -2);
     * // => 4000
     */
    var floor = createRound('floor');

    /**
     * Computes the maximum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * _.max([4, 2, 8, 6]);
     * // => 8
     *
     * _.max([]);
     * // => undefined
     */
    function max(array) {
      return (array && array.length)
        ? baseExtremum(array, identity, baseGt)
        : undefined;
    }

    /**
     * This method is like `_.max` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.maxBy(objects, function(o) { return o.n; });
     * // => { 'n': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.maxBy(objects, 'n');
     * // => { 'n': 2 }
     */
    function maxBy(array, iteratee) {
      return (array && array.length)
        ? baseExtremum(array, getIteratee(iteratee, 2), baseGt)
        : undefined;
    }

    /**
     * Computes the mean of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the mean.
     * @example
     *
     * _.mean([4, 2, 8, 6]);
     * // => 5
     */
    function mean(array) {
      return baseMean(array, identity);
    }

    /**
     * This method is like `_.mean` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be averaged.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the mean.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.meanBy(objects, function(o) { return o.n; });
     * // => 5
     *
     * // The `_.property` iteratee shorthand.
     * _.meanBy(objects, 'n');
     * // => 5
     */
    function meanBy(array, iteratee) {
      return baseMean(array, getIteratee(iteratee, 2));
    }

    /**
     * Computes the minimum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * _.min([4, 2, 8, 6]);
     * // => 2
     *
     * _.min([]);
     * // => undefined
     */
    function min(array) {
      return (array && array.length)
        ? baseExtremum(array, identity, baseLt)
        : undefined;
    }

    /**
     * This method is like `_.min` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.minBy(objects, function(o) { return o.n; });
     * // => { 'n': 1 }
     *
     * // The `_.property` iteratee shorthand.
     * _.minBy(objects, 'n');
     * // => { 'n': 1 }
     */
    function minBy(array, iteratee) {
      return (array && array.length)
        ? baseExtremum(array, getIteratee(iteratee, 2), baseLt)
        : undefined;
    }

    /**
     * Multiply two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} multiplier The first number in a multiplication.
     * @param {number} multiplicand The second number in a multiplication.
     * @returns {number} Returns the product.
     * @example
     *
     * _.multiply(6, 4);
     * // => 24
     */
    var multiply = createMathOperation(function(multiplier, multiplicand) {
      return multiplier * multiplicand;
    }, 1);

    /**
     * Computes `number` rounded to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round.
     * @param {number} [precision=0] The precision to round to.
     * @returns {number} Returns the rounded number.
     * @example
     *
     * _.round(4.006);
     * // => 4
     *
     * _.round(4.006, 2);
     * // => 4.01
     *
     * _.round(4060, -2);
     * // => 4100
     */
    var round = createRound('round');

    /**
     * Subtract two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {number} minuend The first number in a subtraction.
     * @param {number} subtrahend The second number in a subtraction.
     * @returns {number} Returns the difference.
     * @example
     *
     * _.subtract(6, 4);
     * // => 2
     */
    var subtract = createMathOperation(function(minuend, subtrahend) {
      return minuend - subtrahend;
    }, 0);

    /**
     * Computes the sum of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the sum.
     * @example
     *
     * _.sum([4, 2, 8, 6]);
     * // => 20
     */
    function sum(array) {
      return (array && array.length)
        ? baseSum(array, identity)
        : 0;
    }

    /**
     * This method is like `_.sum` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be summed.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the sum.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.sumBy(objects, function(o) { return o.n; });
     * // => 20
     *
     * // The `_.property` iteratee shorthand.
     * _.sumBy(objects, 'n');
     * // => 20
     */
    function sumBy(array, iteratee) {
      return (array && array.length)
        ? baseSum(array, getIteratee(iteratee, 2))
        : 0;
    }

    /*------------------------------------------------------------------------*/

    // Add methods that return wrapped values in chain sequences.
    lodash.after = after;
    lodash.ary = ary;
    lodash.assign = assign;
    lodash.assignIn = assignIn;
    lodash.assignInWith = assignInWith;
    lodash.assignWith = assignWith;
    lodash.at = at;
    lodash.before = before;
    lodash.bind = bind;
    lodash.bindAll = bindAll;
    lodash.bindKey = bindKey;
    lodash.castArray = castArray;
    lodash.chain = chain;
    lodash.chunk = chunk;
    lodash.compact = compact;
    lodash.concat = concat;
    lodash.cond = cond;
    lodash.conforms = conforms;
    lodash.constant = constant;
    lodash.countBy = countBy;
    lodash.create = create;
    lodash.curry = curry;
    lodash.curryRight = curryRight;
    lodash.debounce = debounce;
    lodash.defaults = defaults;
    lodash.defaultsDeep = defaultsDeep;
    lodash.defer = defer;
    lodash.delay = delay;
    lodash.difference = difference;
    lodash.differenceBy = differenceBy;
    lodash.differenceWith = differenceWith;
    lodash.drop = drop;
    lodash.dropRight = dropRight;
    lodash.dropRightWhile = dropRightWhile;
    lodash.dropWhile = dropWhile;
    lodash.fill = fill;
    lodash.filter = filter;
    lodash.flatMap = flatMap;
    lodash.flatMapDeep = flatMapDeep;
    lodash.flatMapDepth = flatMapDepth;
    lodash.flatten = flatten;
    lodash.flattenDeep = flattenDeep;
    lodash.flattenDepth = flattenDepth;
    lodash.flip = flip;
    lodash.flow = flow;
    lodash.flowRight = flowRight;
    lodash.fromPairs = fromPairs;
    lodash.functions = functions;
    lodash.functionsIn = functionsIn;
    lodash.groupBy = groupBy;
    lodash.initial = initial;
    lodash.intersection = intersection;
    lodash.intersectionBy = intersectionBy;
    lodash.intersectionWith = intersectionWith;
    lodash.invert = invert;
    lodash.invertBy = invertBy;
    lodash.invokeMap = invokeMap;
    lodash.iteratee = iteratee;
    lodash.keyBy = keyBy;
    lodash.keys = keys;
    lodash.keysIn = keysIn;
    lodash.map = map;
    lodash.mapKeys = mapKeys;
    lodash.mapValues = mapValues;
    lodash.matches = matches;
    lodash.matchesProperty = matchesProperty;
    lodash.memoize = memoize;
    lodash.merge = merge;
    lodash.mergeWith = mergeWith;
    lodash.method = method;
    lodash.methodOf = methodOf;
    lodash.mixin = mixin;
    lodash.negate = negate;
    lodash.nthArg = nthArg;
    lodash.omit = omit;
    lodash.omitBy = omitBy;
    lodash.once = once;
    lodash.orderBy = orderBy;
    lodash.over = over;
    lodash.overArgs = overArgs;
    lodash.overEvery = overEvery;
    lodash.overSome = overSome;
    lodash.partial = partial;
    lodash.partialRight = partialRight;
    lodash.partition = partition;
    lodash.pick = pick;
    lodash.pickBy = pickBy;
    lodash.property = property;
    lodash.propertyOf = propertyOf;
    lodash.pull = pull;
    lodash.pullAll = pullAll;
    lodash.pullAllBy = pullAllBy;
    lodash.pullAllWith = pullAllWith;
    lodash.pullAt = pullAt;
    lodash.range = range;
    lodash.rangeRight = rangeRight;
    lodash.rearg = rearg;
    lodash.reject = reject;
    lodash.remove = remove;
    lodash.rest = rest;
    lodash.reverse = reverse;
    lodash.sampleSize = sampleSize;
    lodash.set = set;
    lodash.setWith = setWith;
    lodash.shuffle = shuffle;
    lodash.slice = slice;
    lodash.sortBy = sortBy;
    lodash.sortedUniq = sortedUniq;
    lodash.sortedUniqBy = sortedUniqBy;
    lodash.split = split;
    lodash.spread = spread;
    lodash.tail = tail;
    lodash.take = take;
    lodash.takeRight = takeRight;
    lodash.takeRightWhile = takeRightWhile;
    lodash.takeWhile = takeWhile;
    lodash.tap = tap;
    lodash.throttle = throttle;
    lodash.thru = thru;
    lodash.toArray = toArray;
    lodash.toPairs = toPairs;
    lodash.toPairsIn = toPairsIn;
    lodash.toPath = toPath;
    lodash.toPlainObject = toPlainObject;
    lodash.transform = transform;
    lodash.unary = unary;
    lodash.union = union;
    lodash.unionBy = unionBy;
    lodash.unionWith = unionWith;
    lodash.uniq = uniq;
    lodash.uniqBy = uniqBy;
    lodash.uniqWith = uniqWith;
    lodash.unset = unset;
    lodash.unzip = unzip;
    lodash.unzipWith = unzipWith;
    lodash.update = update;
    lodash.updateWith = updateWith;
    lodash.values = values;
    lodash.valuesIn = valuesIn;
    lodash.without = without;
    lodash.words = words;
    lodash.wrap = wrap;
    lodash.xor = xor;
    lodash.xorBy = xorBy;
    lodash.xorWith = xorWith;
    lodash.zip = zip;
    lodash.zipObject = zipObject;
    lodash.zipObjectDeep = zipObjectDeep;
    lodash.zipWith = zipWith;

    // Add aliases.
    lodash.entries = toPairs;
    lodash.entriesIn = toPairsIn;
    lodash.extend = assignIn;
    lodash.extendWith = assignInWith;

    // Add methods to `lodash.prototype`.
    mixin(lodash, lodash);

    /*------------------------------------------------------------------------*/

    // Add methods that return unwrapped values in chain sequences.
    lodash.add = add;
    lodash.attempt = attempt;
    lodash.camelCase = camelCase;
    lodash.capitalize = capitalize;
    lodash.ceil = ceil;
    lodash.clamp = clamp;
    lodash.clone = clone;
    lodash.cloneDeep = cloneDeep;
    lodash.cloneDeepWith = cloneDeepWith;
    lodash.cloneWith = cloneWith;
    lodash.conformsTo = conformsTo;
    lodash.deburr = deburr;
    lodash.defaultTo = defaultTo;
    lodash.divide = divide;
    lodash.endsWith = endsWith;
    lodash.eq = eq;
    lodash.escape = escape;
    lodash.escapeRegExp = escapeRegExp;
    lodash.every = every;
    lodash.find = find;
    lodash.findIndex = findIndex;
    lodash.findKey = findKey;
    lodash.findLast = findLast;
    lodash.findLastIndex = findLastIndex;
    lodash.findLastKey = findLastKey;
    lodash.floor = floor;
    lodash.forEach = forEach;
    lodash.forEachRight = forEachRight;
    lodash.forIn = forIn;
    lodash.forInRight = forInRight;
    lodash.forOwn = forOwn;
    lodash.forOwnRight = forOwnRight;
    lodash.get = get;
    lodash.gt = gt;
    lodash.gte = gte;
    lodash.has = has;
    lodash.hasIn = hasIn;
    lodash.head = head;
    lodash.identity = identity;
    lodash.includes = includes;
    lodash.indexOf = indexOf;
    lodash.inRange = inRange;
    lodash.invoke = invoke;
    lodash.isArguments = isArguments;
    lodash.isArray = isArray;
    lodash.isArrayBuffer = isArrayBuffer;
    lodash.isArrayLike = isArrayLike;
    lodash.isArrayLikeObject = isArrayLikeObject;
    lodash.isBoolean = isBoolean;
    lodash.isBuffer = isBuffer;
    lodash.isDate = isDate;
    lodash.isElement = isElement;
    lodash.isEmpty = isEmpty;
    lodash.isEqual = isEqual;
    lodash.isEqualWith = isEqualWith;
    lodash.isError = isError;
    lodash.isFinite = isFinite;
    lodash.isFunction = isFunction;
    lodash.isInteger = isInteger;
    lodash.isLength = isLength;
    lodash.isMap = isMap;
    lodash.isMatch = isMatch;
    lodash.isMatchWith = isMatchWith;
    lodash.isNaN = isNaN;
    lodash.isNative = isNative;
    lodash.isNil = isNil;
    lodash.isNull = isNull;
    lodash.isNumber = isNumber;
    lodash.isObject = isObject;
    lodash.isObjectLike = isObjectLike;
    lodash.isPlainObject = isPlainObject;
    lodash.isRegExp = isRegExp;
    lodash.isSafeInteger = isSafeInteger;
    lodash.isSet = isSet;
    lodash.isString = isString;
    lodash.isSymbol = isSymbol;
    lodash.isTypedArray = isTypedArray;
    lodash.isUndefined = isUndefined;
    lodash.isWeakMap = isWeakMap;
    lodash.isWeakSet = isWeakSet;
    lodash.join = join;
    lodash.kebabCase = kebabCase;
    lodash.last = last;
    lodash.lastIndexOf = lastIndexOf;
    lodash.lowerCase = lowerCase;
    lodash.lowerFirst = lowerFirst;
    lodash.lt = lt;
    lodash.lte = lte;
    lodash.max = max;
    lodash.maxBy = maxBy;
    lodash.mean = mean;
    lodash.meanBy = meanBy;
    lodash.min = min;
    lodash.minBy = minBy;
    lodash.stubArray = stubArray;
    lodash.stubFalse = stubFalse;
    lodash.stubObject = stubObject;
    lodash.stubString = stubString;
    lodash.stubTrue = stubTrue;
    lodash.multiply = multiply;
    lodash.nth = nth;
    lodash.noConflict = noConflict;
    lodash.noop = noop;
    lodash.now = now;
    lodash.pad = pad;
    lodash.padEnd = padEnd;
    lodash.padStart = padStart;
    lodash.parseInt = parseInt;
    lodash.random = random;
    lodash.reduce = reduce;
    lodash.reduceRight = reduceRight;
    lodash.repeat = repeat;
    lodash.replace = replace;
    lodash.result = result;
    lodash.round = round;
    lodash.runInContext = runInContext;
    lodash.sample = sample;
    lodash.size = size;
    lodash.snakeCase = snakeCase;
    lodash.some = some;
    lodash.sortedIndex = sortedIndex;
    lodash.sortedIndexBy = sortedIndexBy;
    lodash.sortedIndexOf = sortedIndexOf;
    lodash.sortedLastIndex = sortedLastIndex;
    lodash.sortedLastIndexBy = sortedLastIndexBy;
    lodash.sortedLastIndexOf = sortedLastIndexOf;
    lodash.startCase = startCase;
    lodash.startsWith = startsWith;
    lodash.subtract = subtract;
    lodash.sum = sum;
    lodash.sumBy = sumBy;
    lodash.template = template;
    lodash.times = times;
    lodash.toFinite = toFinite;
    lodash.toInteger = toInteger;
    lodash.toLength = toLength;
    lodash.toLower = toLower;
    lodash.toNumber = toNumber;
    lodash.toSafeInteger = toSafeInteger;
    lodash.toString = toString;
    lodash.toUpper = toUpper;
    lodash.trim = trim;
    lodash.trimEnd = trimEnd;
    lodash.trimStart = trimStart;
    lodash.truncate = truncate;
    lodash.unescape = unescape;
    lodash.uniqueId = uniqueId;
    lodash.upperCase = upperCase;
    lodash.upperFirst = upperFirst;

    // Add aliases.
    lodash.each = forEach;
    lodash.eachRight = forEachRight;
    lodash.first = head;

    mixin(lodash, (function() {
      var source = {};
      baseForOwn(lodash, function(func, methodName) {
        if (!hasOwnProperty.call(lodash.prototype, methodName)) {
          source[methodName] = func;
        }
      });
      return source;
    }()), { 'chain': false });

    /*------------------------------------------------------------------------*/

    /**
     * The semantic version number.
     *
     * @static
     * @memberOf _
     * @type {string}
     */
    lodash.VERSION = VERSION;

    // Assign default placeholders.
    arrayEach(['bind', 'bindKey', 'curry', 'curryRight', 'partial', 'partialRight'], function(methodName) {
      lodash[methodName].placeholder = lodash;
    });

    // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
    arrayEach(['drop', 'take'], function(methodName, index) {
      LazyWrapper.prototype[methodName] = function(n) {
        n = n === undefined ? 1 : nativeMax(toInteger(n), 0);

        var result = (this.__filtered__ && !index)
          ? new LazyWrapper(this)
          : this.clone();

        if (result.__filtered__) {
          result.__takeCount__ = nativeMin(n, result.__takeCount__);
        } else {
          result.__views__.push({
            'size': nativeMin(n, MAX_ARRAY_LENGTH),
            'type': methodName + (result.__dir__ < 0 ? 'Right' : '')
          });
        }
        return result;
      };

      LazyWrapper.prototype[methodName + 'Right'] = function(n) {
        return this.reverse()[methodName](n).reverse();
      };
    });

    // Add `LazyWrapper` methods that accept an `iteratee` value.
    arrayEach(['filter', 'map', 'takeWhile'], function(methodName, index) {
      var type = index + 1,
          isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;

      LazyWrapper.prototype[methodName] = function(iteratee) {
        var result = this.clone();
        result.__iteratees__.push({
          'iteratee': getIteratee(iteratee, 3),
          'type': type
        });
        result.__filtered__ = result.__filtered__ || isFilter;
        return result;
      };
    });

    // Add `LazyWrapper` methods for `_.head` and `_.last`.
    arrayEach(['head', 'last'], function(methodName, index) {
      var takeName = 'take' + (index ? 'Right' : '');

      LazyWrapper.prototype[methodName] = function() {
        return this[takeName](1).value()[0];
      };
    });

    // Add `LazyWrapper` methods for `_.initial` and `_.tail`.
    arrayEach(['initial', 'tail'], function(methodName, index) {
      var dropName = 'drop' + (index ? '' : 'Right');

      LazyWrapper.prototype[methodName] = function() {
        return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
      };
    });

    LazyWrapper.prototype.compact = function() {
      return this.filter(identity);
    };

    LazyWrapper.prototype.find = function(predicate) {
      return this.filter(predicate).head();
    };

    LazyWrapper.prototype.findLast = function(predicate) {
      return this.reverse().find(predicate);
    };

    LazyWrapper.prototype.invokeMap = baseRest(function(path, args) {
      if (typeof path == 'function') {
        return new LazyWrapper(this);
      }
      return this.map(function(value) {
        return baseInvoke(value, path, args);
      });
    });

    LazyWrapper.prototype.reject = function(predicate) {
      return this.filter(negate(getIteratee(predicate)));
    };

    LazyWrapper.prototype.slice = function(start, end) {
      start = toInteger(start);

      var result = this;
      if (result.__filtered__ && (start > 0 || end < 0)) {
        return new LazyWrapper(result);
      }
      if (start < 0) {
        result = result.takeRight(-start);
      } else if (start) {
        result = result.drop(start);
      }
      if (end !== undefined) {
        end = toInteger(end);
        result = end < 0 ? result.dropRight(-end) : result.take(end - start);
      }
      return result;
    };

    LazyWrapper.prototype.takeRightWhile = function(predicate) {
      return this.reverse().takeWhile(predicate).reverse();
    };

    LazyWrapper.prototype.toArray = function() {
      return this.take(MAX_ARRAY_LENGTH);
    };

    // Add `LazyWrapper` methods to `lodash.prototype`.
    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
      var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName),
          isTaker = /^(?:head|last)$/.test(methodName),
          lodashFunc = lodash[isTaker ? ('take' + (methodName == 'last' ? 'Right' : '')) : methodName],
          retUnwrapped = isTaker || /^find/.test(methodName);

      if (!lodashFunc) {
        return;
      }
      lodash.prototype[methodName] = function() {
        var value = this.__wrapped__,
            args = isTaker ? [1] : arguments,
            isLazy = value instanceof LazyWrapper,
            iteratee = args[0],
            useLazy = isLazy || isArray(value);

        var interceptor = function(value) {
          var result = lodashFunc.apply(lodash, arrayPush([value], args));
          return (isTaker && chainAll) ? result[0] : result;
        };

        if (useLazy && checkIteratee && typeof iteratee == 'function' && iteratee.length != 1) {
          // Avoid lazy use if the iteratee has a "length" value other than `1`.
          isLazy = useLazy = false;
        }
        var chainAll = this.__chain__,
            isHybrid = !!this.__actions__.length,
            isUnwrapped = retUnwrapped && !chainAll,
            onlyLazy = isLazy && !isHybrid;

        if (!retUnwrapped && useLazy) {
          value = onlyLazy ? value : new LazyWrapper(this);
          var result = func.apply(value, args);
          result.__actions__.push({ 'func': thru, 'args': [interceptor], 'thisArg': undefined });
          return new LodashWrapper(result, chainAll);
        }
        if (isUnwrapped && onlyLazy) {
          return func.apply(this, args);
        }
        result = this.thru(interceptor);
        return isUnwrapped ? (isTaker ? result.value()[0] : result.value()) : result;
      };
    });

    // Add `Array` methods to `lodash.prototype`.
    arrayEach(['pop', 'push', 'shift', 'sort', 'splice', 'unshift'], function(methodName) {
      var func = arrayProto[methodName],
          chainName = /^(?:push|sort|unshift)$/.test(methodName) ? 'tap' : 'thru',
          retUnwrapped = /^(?:pop|shift)$/.test(methodName);

      lodash.prototype[methodName] = function() {
        var args = arguments;
        if (retUnwrapped && !this.__chain__) {
          var value = this.value();
          return func.apply(isArray(value) ? value : [], args);
        }
        return this[chainName](function(value) {
          return func.apply(isArray(value) ? value : [], args);
        });
      };
    });

    // Map minified method names to their real names.
    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
      var lodashFunc = lodash[methodName];
      if (lodashFunc) {
        var key = lodashFunc.name + '';
        if (!hasOwnProperty.call(realNames, key)) {
          realNames[key] = [];
        }
        realNames[key].push({ 'name': methodName, 'func': lodashFunc });
      }
    });

    realNames[createHybrid(undefined, WRAP_BIND_KEY_FLAG).name] = [{
      'name': 'wrapper',
      'func': undefined
    }];

    // Add methods to `LazyWrapper`.
    LazyWrapper.prototype.clone = lazyClone;
    LazyWrapper.prototype.reverse = lazyReverse;
    LazyWrapper.prototype.value = lazyValue;

    // Add chain sequence methods to the `lodash` wrapper.
    lodash.prototype.at = wrapperAt;
    lodash.prototype.chain = wrapperChain;
    lodash.prototype.commit = wrapperCommit;
    lodash.prototype.next = wrapperNext;
    lodash.prototype.plant = wrapperPlant;
    lodash.prototype.reverse = wrapperReverse;
    lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;

    // Add lazy aliases.
    lodash.prototype.first = lodash.prototype.head;

    if (symIterator) {
      lodash.prototype[symIterator] = wrapperToIterator;
    }
    return lodash;
  });

  /*--------------------------------------------------------------------------*/

  // Export lodash.
  var _ = runInContext();

  // Some AMD build optimizers, like r.js, check for condition patterns like:
  if (true) {
    // Expose Lodash on the global object to prevent errors when Lodash is
    // loaded by a script tag in the presence of an AMD loader.
    // See http://requirejs.org/docs/errors.html#mismatch for more details.
    // Use `_.noConflict` to remove Lodash from the global object.
    root._ = _;

    // Define as an anonymous module so, through path mapping, it can be
    // referenced as the "underscore" module.
    !(__WEBPACK_AMD_DEFINE_RESULT__ = (function() {
      return _;
    }).call(exports, __webpack_require__, exports, module),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  }
  // Check for `exports` after `define` in case a build optimizer adds it.
  else {}
}.call(this));


/***/ }),

/***/ 34736:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var MapCache = __webpack_require__(9440);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */
function memoize(func, resolver) {
  if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  var memoized = function() {
    var args = arguments,
        key = resolver ? resolver.apply(this, args) : args[0],
        cache = memoized.cache;

    if (cache.has(key)) {
      return cache.get(key);
    }
    var result = func.apply(this, args);
    memoized.cache = cache.set(key, result) || cache;
    return result;
  };
  memoized.cache = new (memoize.Cache || MapCache);
  return memoized;
}

// Expose `MapCache`.
memoize.Cache = MapCache;

module.exports = memoize;


/***/ }),

/***/ 76668:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var root = __webpack_require__(29165);

/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */
var now = function() {
  return root.Date.now();
};

module.exports = now;


/***/ }),

/***/ 59245:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var arrayMap = __webpack_require__(75697),
    baseClone = __webpack_require__(67410),
    baseUnset = __webpack_require__(42933),
    castPath = __webpack_require__(60399),
    copyObject = __webpack_require__(92434),
    customOmitClone = __webpack_require__(59211),
    flatRest = __webpack_require__(54874),
    getAllKeysIn = __webpack_require__(21699);

/** Used to compose bitmasks for cloning. */
var CLONE_DEEP_FLAG = 1,
    CLONE_FLAT_FLAG = 2,
    CLONE_SYMBOLS_FLAG = 4;

/**
 * The opposite of `_.pick`; this method creates an object composed of the
 * own and inherited enumerable property paths of `object` that are not omitted.
 *
 * **Note:** This method is considerably slower than `_.pick`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The source object.
 * @param {...(string|string[])} [paths] The property paths to omit.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.omit(object, ['a', 'c']);
 * // => { 'b': '2' }
 */
var omit = flatRest(function(object, paths) {
  var result = {};
  if (object == null) {
    return result;
  }
  var isDeep = false;
  paths = arrayMap(paths, function(path) {
    path = castPath(path, object);
    isDeep || (isDeep = path.length > 1);
    return path;
  });
  copyObject(object, getAllKeysIn(object), result);
  if (isDeep) {
    result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
  }
  var length = paths.length;
  while (length--) {
    baseUnset(result, paths[length]);
  }
  return result;
});

module.exports = omit;


/***/ }),

/***/ 51798:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseProperty = __webpack_require__(17498),
    basePropertyDeep = __webpack_require__(71000),
    isKey = __webpack_require__(2610),
    toKey = __webpack_require__(77817);

/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */
function property(path) {
  return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
}

module.exports = property;


/***/ }),

/***/ 81430:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseKeys = __webpack_require__(87473),
    getTag = __webpack_require__(81887),
    isArrayLike = __webpack_require__(47428),
    isString = __webpack_require__(56549),
    stringSize = __webpack_require__(68905);

/** `Object#toString` result references. */
var mapTag = '[object Map]',
    setTag = '[object Set]';

/**
 * Gets the size of `collection` by returning its length for array-like
 * values or the number of own enumerable string keyed properties for objects.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object|string} collection The collection to inspect.
 * @returns {number} Returns the collection size.
 * @example
 *
 * _.size([1, 2, 3]);
 * // => 3
 *
 * _.size({ 'a': 1, 'b': 2 });
 * // => 2
 *
 * _.size('pebbles');
 * // => 7
 */
function size(collection) {
  if (collection == null) {
    return 0;
  }
  if (isArrayLike(collection)) {
    return isString(collection) ? stringSize(collection) : collection.length;
  }
  var tag = getTag(collection);
  if (tag == mapTag || tag == setTag) {
    return collection.size;
  }
  return baseKeys(collection).length;
}

module.exports = size;


/***/ }),

/***/ 68036:
/***/ (function(module) {

/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */
function stubArray() {
  return [];
}

module.exports = stubArray;


/***/ }),

/***/ 84193:
/***/ (function(module) {

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

module.exports = stubFalse;


/***/ }),

/***/ 38209:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var debounce = __webpack_require__(66292),
    isObject = __webpack_require__(36838);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/**
 * Creates a throttled function that only invokes `func` at most once per
 * every `wait` milliseconds. The throttled function comes with a `cancel`
 * method to cancel delayed `func` invocations and a `flush` method to
 * immediately invoke them. Provide `options` to indicate whether `func`
 * should be invoked on the leading and/or trailing edge of the `wait`
 * timeout. The `func` is invoked with the last arguments provided to the
 * throttled function. Subsequent calls to the throttled function return the
 * result of the last `func` invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the throttled function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.throttle` and `_.debounce`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to throttle.
 * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=true]
 *  Specify invoking on the leading edge of the timeout.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new throttled function.
 * @example
 *
 * // Avoid excessively updating the position while scrolling.
 * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
 *
 * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
 * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
 * jQuery(element).on('click', throttled);
 *
 * // Cancel the trailing throttled invocation.
 * jQuery(window).on('popstate', throttled.cancel);
 */
function throttle(func, wait, options) {
  var leading = true,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  if (isObject(options)) {
    leading = 'leading' in options ? !!options.leading : leading;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }
  return debounce(func, wait, {
    'leading': leading,
    'maxWait': wait,
    'trailing': trailing
  });
}

module.exports = throttle;


/***/ }),

/***/ 70986:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var toNumber = __webpack_require__(12448);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0,
    MAX_INTEGER = 1.7976931348623157e+308;

/**
 * Converts `value` to a finite number.
 *
 * @static
 * @memberOf _
 * @since 4.12.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted number.
 * @example
 *
 * _.toFinite(3.2);
 * // => 3.2
 *
 * _.toFinite(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toFinite(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toFinite('3.2');
 * // => 3.2
 */
function toFinite(value) {
  if (!value) {
    return value === 0 ? value : 0;
  }
  value = toNumber(value);
  if (value === INFINITY || value === -INFINITY) {
    var sign = (value < 0 ? -1 : 1);
    return sign * MAX_INTEGER;
  }
  return value === value ? value : 0;
}

module.exports = toFinite;


/***/ }),

/***/ 20426:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var toFinite = __webpack_require__(70986);

/**
 * Converts `value` to an integer.
 *
 * **Note:** This method is loosely based on
 * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted integer.
 * @example
 *
 * _.toInteger(3.2);
 * // => 3
 *
 * _.toInteger(Number.MIN_VALUE);
 * // => 0
 *
 * _.toInteger(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toInteger('3.2');
 * // => 3
 */
function toInteger(value) {
  var result = toFinite(value),
      remainder = result % 1;

  return result === result ? (remainder ? result - remainder : result) : 0;
}

module.exports = toInteger;


/***/ }),

/***/ 12448:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseTrim = __webpack_require__(33124),
    isObject = __webpack_require__(36838),
    isSymbol = __webpack_require__(16764);

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = baseTrim(value);
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

module.exports = toNumber;


/***/ }),

/***/ 8389:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseToString = __webpack_require__(73150);

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString(value) {
  return value == null ? '' : baseToString(value);
}

module.exports = toString;


/***/ }),

/***/ 73052:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var format = __webpack_require__(25179);

/*
 * function align (info)
 * Returns a new instance of the align Format which adds a `\t`
 * delimiter before the message to properly align it in the same place.
 * It was previously { align: true } in winston < 3.0.0
 */
module.exports = format(function (info) {
  info.message = "\t".concat(info.message);
  return info;
});

/***/ }),

/***/ 9364:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


/*
 * @api public
 * @property {function} format
 * Both the construction method and set of exposed
 * formats.
 */
var format = exports.format = __webpack_require__(25179);

/*
 * @api public
 * @method {function} levels
 * Registers the specified levels with logform.
 */
exports.levels = __webpack_require__(81630);

//
// Setup all transports as eager-loaded exports
// so that they are static for the bundlers.
//
Object.defineProperty(format, 'align', {
  value: __webpack_require__(73052)
});
Object.defineProperty(format, 'cli', {
  value: __webpack_require__(52651)
});
Object.defineProperty(format, 'colorize', {
  value: __webpack_require__(5303)
});
Object.defineProperty(format, 'combine', {
  value: __webpack_require__(60461)
});
Object.defineProperty(format, 'errors', {
  value: __webpack_require__(73264)
});
Object.defineProperty(format, 'json', {
  value: __webpack_require__(46037)
});
Object.defineProperty(format, 'label', {
  value: __webpack_require__(56741)
});
Object.defineProperty(format, 'logstash', {
  value: __webpack_require__(9910)
});
Object.defineProperty(format, 'metadata', {
  value: __webpack_require__(77389)
});
Object.defineProperty(format, 'ms', {
  value: __webpack_require__(98484)
});
Object.defineProperty(format, 'padLevels', {
  value: __webpack_require__(91098)
});
Object.defineProperty(format, 'prettyPrint', {
  value: __webpack_require__(33520)
});
Object.defineProperty(format, 'printf', {
  value: __webpack_require__(54095)
});
Object.defineProperty(format, 'simple', {
  value: __webpack_require__(96611)
});
Object.defineProperty(format, 'splat', {
  value: __webpack_require__(34772)
});
Object.defineProperty(format, 'timestamp', {
  value: __webpack_require__(27563)
});
Object.defineProperty(format, 'uncolorize', {
  value: __webpack_require__(16481)
});

/***/ }),

/***/ 52651:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var _require = __webpack_require__(5303),
  Colorizer = _require.Colorizer;
var _require2 = __webpack_require__(91098),
  Padder = _require2.Padder;
var _require3 = __webpack_require__(27735),
  configs = _require3.configs,
  MESSAGE = _require3.MESSAGE;

/**
 * Cli format class that handles initial state for a a separate
 * Colorizer and Padder instance.
 */
var CliFormat = /*#__PURE__*/function () {
  function CliFormat() {
    var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    _classCallCheck(this, CliFormat);
    if (!opts.levels) {
      opts.levels = configs.cli.levels;
    }
    this.colorizer = new Colorizer(opts);
    this.padder = new Padder(opts);
    this.options = opts;
  }

  /*
   * function transform (info, opts)
   * Attempts to both:
   * 1. Pad the { level }
   * 2. Colorize the { level, message }
   * of the given `logform` info object depending on the `opts`.
   */
  _createClass(CliFormat, [{
    key: "transform",
    value: function transform(info, opts) {
      this.colorizer.transform(this.padder.transform(info, opts), opts);
      info[MESSAGE] = "".concat(info.level, ":").concat(info.message);
      return info;
    }
  }]);
  return CliFormat;
}();
/*
 * function cli (opts)
 * Returns a new instance of the CLI format that turns a log
 * `info` object into the same format previously available
 * in `winston.cli()` in `winston < 3.0.0`.
 */
module.exports = function (opts) {
  return new CliFormat(opts);
};

//
// Attach the CliFormat for registration purposes
//
module.exports.Format = CliFormat;

/***/ }),

/***/ 5303:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var colors = __webpack_require__(87972);
var _require = __webpack_require__(27735),
  LEVEL = _require.LEVEL,
  MESSAGE = _require.MESSAGE;

//
// Fix colors not appearing in non-tty environments
//
colors.enabled = true;

/**
 * @property {RegExp} hasSpace
 * Simple regex to check for presence of spaces.
 */
var hasSpace = /\s+/;

/*
 * Colorizer format. Wraps the `level` and/or `message` properties
 * of the `info` objects with ANSI color codes based on a few options.
 */
var Colorizer = /*#__PURE__*/function () {
  function Colorizer() {
    var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    _classCallCheck(this, Colorizer);
    if (opts.colors) {
      this.addColors(opts.colors);
    }
    this.options = opts;
  }

  /*
   * Adds the colors Object to the set of allColors
   * known by the Colorizer
   *
   * @param {Object} colors Set of color mappings to add.
   */
  _createClass(Colorizer, [{
    key: "addColors",
    value:
    /*
     * Adds the colors Object to the set of allColors
     * known by the Colorizer
     *
     * @param {Object} colors Set of color mappings to add.
     */
    function addColors(clrs) {
      return Colorizer.addColors(clrs);
    }

    /*
     * function colorize (lookup, level, message)
     * Performs multi-step colorization using @colors/colors/safe
     */
  }, {
    key: "colorize",
    value: function colorize(lookup, level, message) {
      if (typeof message === 'undefined') {
        message = level;
      }

      //
      // If the color for the level is just a string
      // then attempt to colorize the message with it.
      //
      if (!Array.isArray(Colorizer.allColors[lookup])) {
        return colors[Colorizer.allColors[lookup]](message);
      }

      //
      // If it is an Array then iterate over that Array, applying
      // the colors function for each item.
      //
      for (var i = 0, len = Colorizer.allColors[lookup].length; i < len; i++) {
        message = colors[Colorizer.allColors[lookup][i]](message);
      }
      return message;
    }

    /*
     * function transform (info, opts)
     * Attempts to colorize the { level, message } of the given
     * `logform` info object.
     */
  }, {
    key: "transform",
    value: function transform(info, opts) {
      if (opts.all && typeof info[MESSAGE] === 'string') {
        info[MESSAGE] = this.colorize(info[LEVEL], info.level, info[MESSAGE]);
      }
      if (opts.level || opts.all || !opts.message) {
        info.level = this.colorize(info[LEVEL], info.level);
      }
      if (opts.all || opts.message) {
        info.message = this.colorize(info[LEVEL], info.level, info.message);
      }
      return info;
    }
  }], [{
    key: "addColors",
    value: function addColors(clrs) {
      var nextColors = Object.keys(clrs).reduce(function (acc, level) {
        acc[level] = hasSpace.test(clrs[level]) ? clrs[level].split(hasSpace) : clrs[level];
        return acc;
      }, {});
      Colorizer.allColors = Object.assign({}, Colorizer.allColors || {}, nextColors);
      return Colorizer.allColors;
    }
  }]);
  return Colorizer;
}();
/*
 * function colorize (info)
 * Returns a new instance of the colorize Format that applies
 * level colors to `info` objects. This was previously exposed
 * as { colorize: true } to transports in `winston < 3.0.0`.
 */
module.exports = function (opts) {
  return new Colorizer(opts);
};

//
// Attach the Colorizer for registration purposes
//
module.exports.Colorizer = module.exports.Format = Colorizer;

/***/ }),

/***/ 60461:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var format = __webpack_require__(25179);

/*
 * function cascade(formats)
 * Returns a function that invokes the `._format` function in-order
 * for the specified set of `formats`. In this manner we say that Formats
 * are "pipe-like", but not a pure pumpify implementation. Since there is no back
 * pressure we can remove all of the "readable" plumbing in Node streams.
 */
function cascade(formats) {
  if (!formats.every(isValidFormat)) {
    return;
  }
  return function (info) {
    var obj = info;
    for (var i = 0; i < formats.length; i++) {
      obj = formats[i].transform(obj, formats[i].options);
      if (!obj) {
        return false;
      }
    }
    return obj;
  };
}

/*
 * function isValidFormat(format)
 * If the format does not define a `transform` function throw an error
 * with more detailed usage.
 */
function isValidFormat(fmt) {
  if (typeof fmt.transform !== 'function') {
    throw new Error(['No transform function found on format. Did you create a format instance?', 'const myFormat = format(formatFn);', 'const instance = myFormat();'].join('\n'));
  }
  return true;
}

/*
 * function combine (info)
 * Returns a new instance of the combine Format which combines the specified
 * formats into a new format. This is similar to a pipe-chain in transform streams.
 * We choose to combine the prototypes this way because there is no back pressure in
 * an in-memory transform chain.
 */
module.exports = function () {
  for (var _len = arguments.length, formats = new Array(_len), _key = 0; _key < _len; _key++) {
    formats[_key] = arguments[_key];
  }
  var combinedFormat = format(cascade(formats));
  var instance = combinedFormat();
  instance.Format = combinedFormat.Format;
  return instance;
};

//
// Export the cascade method for use in cli and other
// combined formats that should not be assumed to be
// singletons.
//
module.exports.cascade = cascade;

/***/ }),

/***/ 73264:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
/* eslint no-undefined: 0 */


function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var format = __webpack_require__(25179);
var _require = __webpack_require__(27735),
  LEVEL = _require.LEVEL,
  MESSAGE = _require.MESSAGE;

/*
 * function errors (info)
 * If the `message` property of the `info` object is an instance of `Error`,
 * replace the `Error` object its own `message` property.
 *
 * Optionally, the Error's `stack` and/or `cause` properties can also be appended to the `info` object.
 */
module.exports = format(function (einfo, _ref) {
  var stack = _ref.stack,
    cause = _ref.cause;
  if (einfo instanceof Error) {
    var info = Object.assign({}, einfo, _defineProperty(_defineProperty(_defineProperty({
      level: einfo.level
    }, LEVEL, einfo[LEVEL] || einfo.level), "message", einfo.message), MESSAGE, einfo[MESSAGE] || einfo.message));
    if (stack) info.stack = einfo.stack;
    if (cause) info.cause = einfo.cause;
    return info;
  }
  if (!(einfo.message instanceof Error)) return einfo;

  // Assign all enumerable properties and the
  // message property from the error provided.
  var err = einfo.message;
  Object.assign(einfo, err);
  einfo.message = err.message;
  einfo[MESSAGE] = err.message;

  // Assign the stack and/or cause if requested.
  if (stack) einfo.stack = err.stack;
  if (cause) einfo.cause = err.cause;
  return einfo;
});

/***/ }),

/***/ 25179:
/***/ (function(module) {

"use strict";


/*
 * Displays a helpful message and the source of
 * the format when it is invalid.
 */
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _wrapNativeSuper(Class) { var _cache = typeof Map === "function" ? new Map() : undefined; _wrapNativeSuper = function _wrapNativeSuper(Class) { if (Class === null || !_isNativeFunction(Class)) return Class; if (typeof Class !== "function") { throw new TypeError("Super expression must either be null or a function"); } if (typeof _cache !== "undefined") { if (_cache.has(Class)) return _cache.get(Class); _cache.set(Class, Wrapper); } function Wrapper() { return _construct(Class, arguments, _getPrototypeOf(this).constructor); } Wrapper.prototype = Object.create(Class.prototype, { constructor: { value: Wrapper, enumerable: false, writable: true, configurable: true } }); return _setPrototypeOf(Wrapper, Class); }; return _wrapNativeSuper(Class); }
function _construct(Parent, args, Class) { if (_isNativeReflectConstruct()) { _construct = Reflect.construct.bind(); } else { _construct = function _construct(Parent, args, Class) { var a = [null]; a.push.apply(a, args); var Constructor = Function.bind.apply(Parent, a); var instance = new Constructor(); if (Class) _setPrototypeOf(instance, Class.prototype); return instance; }; } return _construct.apply(null, arguments); }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _isNativeFunction(fn) { try { return Function.toString.call(fn).indexOf("[native code]") !== -1; } catch (e) { return typeof fn === "function"; } }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
var InvalidFormatError = /*#__PURE__*/function (_Error) {
  _inherits(InvalidFormatError, _Error);
  var _super = _createSuper(InvalidFormatError);
  function InvalidFormatError(formatFn) {
    var _this;
    _classCallCheck(this, InvalidFormatError);
    _this = _super.call(this, "Format functions must be synchronous taking a two arguments: (info, opts)\nFound: ".concat(formatFn.toString().split('\n')[0], "\n"));
    Error.captureStackTrace(_assertThisInitialized(_this), InvalidFormatError);
    return _this;
  }
  return _createClass(InvalidFormatError);
}( /*#__PURE__*/_wrapNativeSuper(Error));
/*
 * function format (formatFn)
 * Returns a create function for the `formatFn`.
 */
module.exports = function (formatFn) {
  if (formatFn.length > 2) {
    throw new InvalidFormatError(formatFn);
  }

  /*
   * function Format (options)
   * Base prototype which calls a `_format`
   * function and pushes the result.
   */
  function Format() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    this.options = options;
  }
  Format.prototype.transform = formatFn;

  //
  // Create a function which returns new instances of
  // FormatWrap for simple syntax like:
  //
  // require('winston').formats.json();
  //
  function createFormatWrap(opts) {
    return new Format(opts);
  }

  //
  // Expose the FormatWrap through the create function
  // for testability.
  //
  createFormatWrap.Format = Format;
  return createFormatWrap;
};

/***/ }),

/***/ 46037:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var format = __webpack_require__(25179);
var _require = __webpack_require__(27735),
  MESSAGE = _require.MESSAGE;
var stringify = __webpack_require__(34859);

/*
 * function replacer (key, value)
 * Handles proper stringification of Buffer and bigint output.
 */
function replacer(key, value) {
  // safe-stable-stringify does support BigInt, however, it doesn't wrap the value in quotes.
  // Leading to a loss in fidelity if the resulting string is parsed.
  // It would also be a breaking change for logform.
  if (typeof value === 'bigint') return value.toString();
  return value;
}

/*
 * function json (info)
 * Returns a new instance of the JSON format that turns a log `info`
 * object into pure JSON. This was previously exposed as { json: true }
 * to transports in `winston < 3.0.0`.
 */
module.exports = format(function (info, opts) {
  var jsonStringify = stringify.configure(opts);
  info[MESSAGE] = jsonStringify(info, opts.replacer || replacer, opts.space);
  return info;
});

/***/ }),

/***/ 56741:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var format = __webpack_require__(25179);

/*
 * function label (info)
 * Returns a new instance of the label Format which adds the specified
 * `opts.label` before the message. This was previously exposed as
 * { label: 'my label' } to transports in `winston < 3.0.0`.
 */
module.exports = format(function (info, opts) {
  if (opts.message) {
    info.message = "[".concat(opts.label, "] ").concat(info.message);
    return info;
  }
  info.label = opts.label;
  return info;
});

/***/ }),

/***/ 81630:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var _require = __webpack_require__(5303),
  Colorizer = _require.Colorizer;

/*
 * Simple method to register colors with a simpler require
 * path within the module.
 */
module.exports = function (config) {
  Colorizer.addColors(config.colors || config);
  return config;
};

/***/ }),

/***/ 9910:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var format = __webpack_require__(25179);
var _require = __webpack_require__(27735),
  MESSAGE = _require.MESSAGE;
var jsonStringify = __webpack_require__(34859);

/*
 * function logstash (info)
 * Returns a new instance of the LogStash Format that turns a
 * log `info` object into pure JSON with the appropriate logstash
 * options. This was previously exposed as { logstash: true }
 * to transports in `winston < 3.0.0`.
 */
module.exports = format(function (info) {
  var logstash = {};
  if (info.message) {
    logstash['@message'] = info.message;
    delete info.message;
  }
  if (info.timestamp) {
    logstash['@timestamp'] = info.timestamp;
    delete info.timestamp;
  }
  logstash['@fields'] = info;
  info[MESSAGE] = jsonStringify(logstash);
  return info;
});

/***/ }),

/***/ 77389:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var format = __webpack_require__(25179);
function fillExcept(info, fillExceptKeys, metadataKey) {
  var savedKeys = fillExceptKeys.reduce(function (acc, key) {
    acc[key] = info[key];
    delete info[key];
    return acc;
  }, {});
  var metadata = Object.keys(info).reduce(function (acc, key) {
    acc[key] = info[key];
    delete info[key];
    return acc;
  }, {});
  Object.assign(info, savedKeys, _defineProperty({}, metadataKey, metadata));
  return info;
}
function fillWith(info, fillWithKeys, metadataKey) {
  info[metadataKey] = fillWithKeys.reduce(function (acc, key) {
    acc[key] = info[key];
    delete info[key];
    return acc;
  }, {});
  return info;
}

/**
 * Adds in a "metadata" object to collect extraneous data, similar to the metadata
 * object in winston 2.x.
 */
module.exports = format(function (info) {
  var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var metadataKey = 'metadata';
  if (opts.key) {
    metadataKey = opts.key;
  }
  var fillExceptKeys = [];
  if (!opts.fillExcept && !opts.fillWith) {
    fillExceptKeys.push('level');
    fillExceptKeys.push('message');
  }
  if (opts.fillExcept) {
    fillExceptKeys = opts.fillExcept;
  }
  if (fillExceptKeys.length > 0) {
    return fillExcept(info, fillExceptKeys, metadataKey);
  }
  if (opts.fillWith) {
    return fillWith(info, opts.fillWith, metadataKey);
  }
  return info;
});

/***/ }),

/***/ 98484:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var _this = void 0;
var format = __webpack_require__(25179);
var ms = __webpack_require__(68946);

/*
 * function ms (info)
 * Returns an `info` with a `ms` property. The `ms` property holds the Value
 * of the time difference between two calls in milliseconds.
 */
module.exports = format(function (info) {
  var curr = +new Date();
  _this.diff = curr - (_this.prevTime || curr);
  _this.prevTime = curr;
  info.ms = "+".concat(ms(_this.diff));
  return info;
});

/***/ }),

/***/ 91098:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
/* eslint no-unused-vars: 0 */


function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var _require = __webpack_require__(27735),
  configs = _require.configs,
  LEVEL = _require.LEVEL,
  MESSAGE = _require.MESSAGE;
var Padder = /*#__PURE__*/function () {
  function Padder() {
    var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
      levels: configs.npm.levels
    };
    _classCallCheck(this, Padder);
    this.paddings = Padder.paddingForLevels(opts.levels, opts.filler);
    this.options = opts;
  }

  /**
   * Returns the maximum length of keys in the specified `levels` Object.
   * @param  {Object} levels Set of all levels to calculate longest level against.
   * @returns {Number} Maximum length of the longest level string.
   */
  _createClass(Padder, [{
    key: "transform",
    value:
    /**
     * Prepends the padding onto the `message` based on the `LEVEL` of
     * the `info`. This is based on the behavior of `winston@2` which also
     * prepended the level onto the message.
     *
     * See: https://github.com/winstonjs/winston/blob/2.x/lib/winston/logger.js#L198-L201
     *
     * @param  {Info} info Logform info object
     * @param  {Object} opts Options passed along to this instance.
     * @returns {Info} Modified logform info object.
     */
    function transform(info, opts) {
      info.message = "".concat(this.paddings[info[LEVEL]]).concat(info.message);
      if (info[MESSAGE]) {
        info[MESSAGE] = "".concat(this.paddings[info[LEVEL]]).concat(info[MESSAGE]);
      }
      return info;
    }
  }], [{
    key: "getLongestLevel",
    value: function getLongestLevel(levels) {
      var lvls = Object.keys(levels).map(function (level) {
        return level.length;
      });
      return Math.max.apply(Math, _toConsumableArray(lvls));
    }

    /**
     * Returns the padding for the specified `level` assuming that the
     * maximum length of all levels it's associated with is `maxLength`.
     * @param  {String} level Level to calculate padding for.
     * @param  {String} filler Repeatable text to use for padding.
     * @param  {Number} maxLength Length of the longest level
     * @returns {String} Padding string for the `level`
     */
  }, {
    key: "paddingForLevel",
    value: function paddingForLevel(level, filler, maxLength) {
      var targetLen = maxLength + 1 - level.length;
      var rep = Math.floor(targetLen / filler.length);
      var padding = "".concat(filler).concat(filler.repeat(rep));
      return padding.slice(0, targetLen);
    }

    /**
     * Returns an object with the string paddings for the given `levels`
     * using the specified `filler`.
     * @param  {Object} levels Set of all levels to calculate padding for.
     * @param  {String} filler Repeatable text to use for padding.
     * @returns {Object} Mapping of level to desired padding.
     */
  }, {
    key: "paddingForLevels",
    value: function paddingForLevels(levels) {
      var filler = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : ' ';
      var maxLength = Padder.getLongestLevel(levels);
      return Object.keys(levels).reduce(function (acc, level) {
        acc[level] = Padder.paddingForLevel(level, filler, maxLength);
        return acc;
      }, {});
    }
  }]);
  return Padder;
}();
/*
 * function padLevels (info)
 * Returns a new instance of the padLevels Format which pads
 * levels to be the same length. This was previously exposed as
 * { padLevels: true } to transports in `winston < 3.0.0`.
 */
module.exports = function (opts) {
  return new Padder(opts);
};
module.exports.Padder = module.exports.Format = Padder;

/***/ }),

/***/ 33520:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var inspect = (__webpack_require__(93585).inspect);
var format = __webpack_require__(25179);
var _require = __webpack_require__(27735),
  LEVEL = _require.LEVEL,
  MESSAGE = _require.MESSAGE,
  SPLAT = _require.SPLAT;

/*
 * function prettyPrint (info)
 * Returns a new instance of the prettyPrint Format that "prettyPrint"
 * serializes `info` objects. This was previously exposed as
 * { prettyPrint: true } to transports in `winston < 3.0.0`.
 */
module.exports = format(function (info) {
  var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  //
  // info[{LEVEL, MESSAGE, SPLAT}] are enumerable here. Since they
  // are internal, we remove them before util.inspect so they
  // are not printed.
  //
  var stripped = Object.assign({}, info);

  // Remark (indexzero): update this technique in April 2019
  // when node@6 is EOL
  delete stripped[LEVEL];
  delete stripped[MESSAGE];
  delete stripped[SPLAT];
  info[MESSAGE] = inspect(stripped, false, opts.depth || null, opts.colorize);
  return info;
});

/***/ }),

/***/ 54095:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var _require = __webpack_require__(27735),
  MESSAGE = _require.MESSAGE;
var Printf = /*#__PURE__*/function () {
  function Printf(templateFn) {
    _classCallCheck(this, Printf);
    this.template = templateFn;
  }
  _createClass(Printf, [{
    key: "transform",
    value: function transform(info) {
      info[MESSAGE] = this.template(info);
      return info;
    }
  }]);
  return Printf;
}();
/*
 * function printf (templateFn)
 * Returns a new instance of the printf Format that creates an
 * intermediate prototype to store the template string-based formatter
 * function.
 */
module.exports = function (opts) {
  return new Printf(opts);
};
module.exports.Printf = module.exports.Format = Printf;

/***/ }),

/***/ 96611:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
/* eslint no-undefined: 0 */


var format = __webpack_require__(25179);
var _require = __webpack_require__(27735),
  MESSAGE = _require.MESSAGE;
var jsonStringify = __webpack_require__(34859);

/*
 * function simple (info)
 * Returns a new instance of the simple format TransformStream
 * which writes a simple representation of logs.
 *
 *    const { level, message, splat, ...rest } = info;
 *
 *    ${level}: ${message}                            if rest is empty
 *    ${level}: ${message} ${JSON.stringify(rest)}    otherwise
 */
module.exports = format(function (info) {
  var stringifiedRest = jsonStringify(Object.assign({}, info, {
    level: undefined,
    message: undefined,
    splat: undefined
  }));
  var padding = info.padding && info.padding[info.level] || '';
  if (stringifiedRest !== '{}') {
    info[MESSAGE] = "".concat(info.level, ":").concat(padding, " ").concat(info.message, " ").concat(stringifiedRest);
  } else {
    info[MESSAGE] = "".concat(info.level, ":").concat(padding, " ").concat(info.message);
  }
  return info;
});

/***/ }),

/***/ 34772:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var util = __webpack_require__(93585);
var _require = __webpack_require__(27735),
  SPLAT = _require.SPLAT;

/**
 * Captures the number of format (i.e. %s strings) in a given string.
 * Based on `util.format`, see Node.js source:
 * https://github.com/nodejs/node/blob/b1c8f15c5f169e021f7c46eb7b219de95fe97603/lib/util.js#L201-L230
 * @type {RegExp}
 */
var formatRegExp = /%[scdjifoO%]/g;

/**
 * Captures the number of escaped % signs in a format string (i.e. %s strings).
 * @type {RegExp}
 */
var escapedPercent = /%%/g;
var Splatter = /*#__PURE__*/function () {
  function Splatter(opts) {
    _classCallCheck(this, Splatter);
    this.options = opts;
  }

  /**
     * Check to see if tokens <= splat.length, assign { splat, meta } into the
     * `info` accordingly, and write to this instance.
     *
     * @param  {Info} info Logform info message.
     * @param  {String[]} tokens Set of string interpolation tokens.
     * @returns {Info} Modified info message
     * @private
     */
  _createClass(Splatter, [{
    key: "_splat",
    value: function _splat(info, tokens) {
      var msg = info.message;
      var splat = info[SPLAT] || info.splat || [];
      var percents = msg.match(escapedPercent);
      var escapes = percents && percents.length || 0;

      // The expected splat is the number of tokens minus the number of escapes
      // e.g.
      // - { expectedSplat: 3 } '%d %s %j'
      // - { expectedSplat: 5 } '[%s] %d%% %d%% %s %j'
      //
      // Any "meta" will be arugments in addition to the expected splat size
      // regardless of type. e.g.
      //
      // logger.log('info', '%d%% %s %j', 100, 'wow', { such: 'js' }, { thisIsMeta: true });
      // would result in splat of four (4), but only three (3) are expected. Therefore:
      //
      // extraSplat = 3 - 4 = -1
      // metas = [100, 'wow', { such: 'js' }, { thisIsMeta: true }].splice(-1, -1 * -1);
      // splat = [100, 'wow', { such: 'js' }]
      var expectedSplat = tokens.length - escapes;
      var extraSplat = expectedSplat - splat.length;
      var metas = extraSplat < 0 ? splat.splice(extraSplat, -1 * extraSplat) : [];

      // Now that { splat } has been separated from any potential { meta }. we
      // can assign this to the `info` object and write it to our format stream.
      // If the additional metas are **NOT** objects or **LACK** enumerable properties
      // you are going to have a bad time.
      var metalen = metas.length;
      if (metalen) {
        for (var i = 0; i < metalen; i++) {
          Object.assign(info, metas[i]);
        }
      }
      info.message = util.format.apply(util, [msg].concat(_toConsumableArray(splat)));
      return info;
    }

    /**
      * Transforms the `info` message by using `util.format` to complete
      * any `info.message` provided it has string interpolation tokens.
      * If no tokens exist then `info` is immutable.
      *
      * @param  {Info} info Logform info message.
      * @param  {Object} opts Options for this instance.
      * @returns {Info} Modified info message
      */
  }, {
    key: "transform",
    value: function transform(info) {
      var msg = info.message;
      var splat = info[SPLAT] || info.splat;

      // No need to process anything if splat is undefined
      if (!splat || !splat.length) {
        return info;
      }

      // Extract tokens, if none available default to empty array to
      // ensure consistancy in expected results
      var tokens = msg && msg.match && msg.match(formatRegExp);

      // This condition will take care of inputs with info[SPLAT]
      // but no tokens present
      if (!tokens && (splat || splat.length)) {
        var metas = splat.length > 1 ? splat.splice(0) : splat;

        // Now that { splat } has been separated from any potential { meta }. we
        // can assign this to the `info` object and write it to our format stream.
        // If the additional metas are **NOT** objects or **LACK** enumerable properties
        // you are going to have a bad time.
        var metalen = metas.length;
        if (metalen) {
          for (var i = 0; i < metalen; i++) {
            Object.assign(info, metas[i]);
          }
        }
        return info;
      }
      if (tokens) {
        return this._splat(info, tokens);
      }
      return info;
    }
  }]);
  return Splatter;
}();
/*
 * function splat (info)
 * Returns a new instance of the splat format TransformStream
 * which performs string interpolation from `info` objects. This was
 * previously exposed implicitly in `winston < 3.0.0`.
 */
module.exports = function (opts) {
  return new Splatter(opts);
};

/***/ }),

/***/ 27563:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var fecha = __webpack_require__(68839);
var format = __webpack_require__(25179);

/*
 * function timestamp (info)
 * Returns a new instance of the timestamp Format which adds a timestamp
 * to the info. It was previously available in winston < 3.0.0 as:
 *
 * - { timestamp: true }             // `new Date.toISOString()`
 * - { timestamp: function:String }  // Value returned by `timestamp()`
 */
module.exports = format(function (info) {
  var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  if (opts.format) {
    info.timestamp = typeof opts.format === 'function' ? opts.format() : fecha.format(new Date(), opts.format);
  }
  if (!info.timestamp) {
    info.timestamp = new Date().toISOString();
  }
  if (opts.alias) {
    info[opts.alias] = info.timestamp;
  }
  return info;
});

/***/ }),

/***/ 16481:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var colors = __webpack_require__(87972);
var format = __webpack_require__(25179);
var _require = __webpack_require__(27735),
  MESSAGE = _require.MESSAGE;

/*
 * function uncolorize (info)
 * Returns a new instance of the uncolorize Format that strips colors
 * from `info` objects. This was previously exposed as { stripColors: true }
 * to transports in `winston < 3.0.0`.
 */
module.exports = format(function (info, opts) {
  if (opts.level !== false) {
    info.level = colors.strip(info.level);
  }
  if (opts.message !== false) {
    info.message = colors.strip(String(info.message));
  }
  if (opts.raw !== false && info[MESSAGE]) {
    info[MESSAGE] = colors.strip(String(info[MESSAGE]));
  }
  return info;
});

/***/ }),

/***/ 55954:
/***/ (function(module) {

"use strict";


/*
 * Displays a helpful message and the source of
 * the format when it is invalid.
 */
class InvalidFormatError extends Error {
  constructor(formatFn) {
    super(`Format functions must be synchronous taking a two arguments: (info, opts)
Found: ${formatFn.toString().split('\n')[0]}\n`);

    Error.captureStackTrace(this, InvalidFormatError);
  }
}

/*
 * function format (formatFn)
 * Returns a create function for the `formatFn`.
 */
module.exports = formatFn => {
  if (formatFn.length > 2) {
    throw new InvalidFormatError(formatFn);
  }

  /*
   * function Format (options)
   * Base prototype which calls a `_format`
   * function and pushes the result.
   */
  function Format(options = {}) {
    this.options = options;
  }

  Format.prototype.transform = formatFn;

  //
  // Create a function which returns new instances of
  // FormatWrap for simple syntax like:
  //
  // require('winston').formats.json();
  //
  function createFormatWrap(opts) {
    return new Format(opts);
  }

  //
  // Expose the FormatWrap through the create function
  // for testability.
  //
  createFormatWrap.Format = Format;
  return createFormatWrap;
};


/***/ }),

/***/ 58475:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


const format = __webpack_require__(55954);
const { MESSAGE } = __webpack_require__(27735);
const stringify = __webpack_require__(34859);

/*
 * function replacer (key, value)
 * Handles proper stringification of Buffer and bigint output.
 */
function replacer(key, value) {
  // safe-stable-stringify does support BigInt, however, it doesn't wrap the value in quotes.
  // Leading to a loss in fidelity if the resulting string is parsed.
  // It would also be a breaking change for logform.
  if (typeof value === 'bigint')
    return value.toString();
  return value;
}

/*
 * function json (info)
 * Returns a new instance of the JSON format that turns a log `info`
 * object into pure JSON. This was previously exposed as { json: true }
 * to transports in `winston < 3.0.0`.
 */
module.exports = format((info, opts) => {
  const jsonStringify = stringify.configure(opts);
  info[MESSAGE] = jsonStringify(info, opts.replacer || replacer, opts.space);
  return info;
});


/***/ }),

/***/ 68946:
/***/ (function(module) {

/**
 * Helpers.
 */

var s = 1000;
var m = s * 60;
var h = m * 60;
var d = h * 24;
var w = d * 7;
var y = d * 365.25;

/**
 * Parse or format the given `val`.
 *
 * Options:
 *
 *  - `long` verbose formatting [false]
 *
 * @param {String|Number} val
 * @param {Object} [options]
 * @throws {Error} throw an error if val is not a non-empty string or a number
 * @return {String|Number}
 * @api public
 */

module.exports = function (val, options) {
  options = options || {};
  var type = typeof val;
  if (type === 'string' && val.length > 0) {
    return parse(val);
  } else if (type === 'number' && isFinite(val)) {
    return options.long ? fmtLong(val) : fmtShort(val);
  }
  throw new Error(
    'val is not a non-empty string or a valid number. val=' +
      JSON.stringify(val)
  );
};

/**
 * Parse the given `str` and return milliseconds.
 *
 * @param {String} str
 * @return {Number}
 * @api private
 */

function parse(str) {
  str = String(str);
  if (str.length > 100) {
    return;
  }
  var match = /^(-?(?:\d+)?\.?\d+) *(milliseconds?|msecs?|ms|seconds?|secs?|s|minutes?|mins?|m|hours?|hrs?|h|days?|d|weeks?|w|years?|yrs?|y)?$/i.exec(
    str
  );
  if (!match) {
    return;
  }
  var n = parseFloat(match[1]);
  var type = (match[2] || 'ms').toLowerCase();
  switch (type) {
    case 'years':
    case 'year':
    case 'yrs':
    case 'yr':
    case 'y':
      return n * y;
    case 'weeks':
    case 'week':
    case 'w':
      return n * w;
    case 'days':
    case 'day':
    case 'd':
      return n * d;
    case 'hours':
    case 'hour':
    case 'hrs':
    case 'hr':
    case 'h':
      return n * h;
    case 'minutes':
    case 'minute':
    case 'mins':
    case 'min':
    case 'm':
      return n * m;
    case 'seconds':
    case 'second':
    case 'secs':
    case 'sec':
    case 's':
      return n * s;
    case 'milliseconds':
    case 'millisecond':
    case 'msecs':
    case 'msec':
    case 'ms':
      return n;
    default:
      return undefined;
  }
}

/**
 * Short format for `ms`.
 *
 * @param {Number} ms
 * @return {String}
 * @api private
 */

function fmtShort(ms) {
  var msAbs = Math.abs(ms);
  if (msAbs >= d) {
    return Math.round(ms / d) + 'd';
  }
  if (msAbs >= h) {
    return Math.round(ms / h) + 'h';
  }
  if (msAbs >= m) {
    return Math.round(ms / m) + 'm';
  }
  if (msAbs >= s) {
    return Math.round(ms / s) + 's';
  }
  return ms + 'ms';
}

/**
 * Long format for `ms`.
 *
 * @param {Number} ms
 * @return {String}
 * @api private
 */

function fmtLong(ms) {
  var msAbs = Math.abs(ms);
  if (msAbs >= d) {
    return plural(ms, msAbs, d, 'day');
  }
  if (msAbs >= h) {
    return plural(ms, msAbs, h, 'hour');
  }
  if (msAbs >= m) {
    return plural(ms, msAbs, m, 'minute');
  }
  if (msAbs >= s) {
    return plural(ms, msAbs, s, 'second');
  }
  return ms + ' ms';
}

/**
 * Pluralization helper.
 */

function plural(ms, msAbs, n, name) {
  var isPlural = msAbs >= n * 1.5;
  return Math.round(ms / n) + ' ' + name + (isPlural ? 's' : '');
}


/***/ }),

/***/ 5352:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(30354)


/***/ }),

/***/ 11793:
/***/ (function(module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.getDomainLocale = getDomainLocale;
var basePath = (/* unused pure expression or super */ null && ( false || ''));

function getDomainLocale(path, locale, locales, domainLocales) {
  if (false) { var finalLocale, proto, domain, target, detectDomainLocale, normalizeLocalePath; } else {
    return false;
  }
}

if ((typeof exports["default"] === 'function' || typeof exports["default"] === 'object' && exports["default"] !== null) && typeof exports["default"].__esModule === 'undefined') {
  Object.defineProperty(exports["default"], '__esModule', {
    value: true
  });
  Object.assign(exports["default"], exports);
  module.exports = exports["default"];
}

/***/ }),

/***/ 8490:
/***/ (function(module, exports, __webpack_require__) {

"client";
"use strict";

var _slicedToArray = __webpack_require__(15242);

Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;

var _interop_require_default = (__webpack_require__(57022)/* ["default"] */ .Z);

var _object_without_properties_loose = (__webpack_require__(5997)/* ["default"] */ .Z);

var _react = _interop_require_default(__webpack_require__(75271));

var _router = __webpack_require__(35800);

var _addLocale = __webpack_require__(38195);

var _routerContext = __webpack_require__(83077);

var _appRouterContext = __webpack_require__(57220);

var _useIntersection = __webpack_require__(93084);

var _getDomainLocale = __webpack_require__(11793);

var _addBasePath = __webpack_require__(5960);

'client';
var prefetched = {};

function prefetch(router, href, as, options) {
  if ( false || !router) return;
  if (!(0, _router).isLocalURL(href)) return; // Prefetch the JSON page if asked (only in the client)
  // We need to handle a prefetch error here since we may be
  // loading with priority which can reject but we don't
  // want to force navigation since this is only a prefetch

  Promise.resolve(router.prefetch(href, as, options))["catch"](function (err) {
    if (false) {}
  });
  var curLocale = options && typeof options.locale !== 'undefined' ? options.locale : router && router.locale; // Join on an invalid URI character

  prefetched[href + '%' + as + (curLocale ? '%' + curLocale : '')] = true;
}

function isModifiedEvent(event) {
  var target = event.currentTarget.target;
  return target && target !== '_self' || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.nativeEvent && event.nativeEvent.which === 2;
}

function linkClicked(e, router, href, as, replace, shallow, scroll, locale, isAppRouter, prefetchEnabled) {
  var nodeName = e.currentTarget.nodeName; // anchors inside an svg have a lowercase nodeName

  var isAnchorNodeName = nodeName.toUpperCase() === 'A';

  if (isAnchorNodeName && (isModifiedEvent(e) || !(0, _router).isLocalURL(href))) {
    // ignore click for browser’s default behavior
    return;
  }

  e.preventDefault();

  var navigate = function navigate() {
    // If the router is an NextRouter instance it will have `beforePopState`
    if ('beforePopState' in router) {
      router[replace ? 'replace' : 'push'](href, as, {
        shallow: shallow,
        locale: locale,
        scroll: scroll
      });
    } else {
      // If `beforePopState` doesn't exist on the router it's the AppRouter.
      var method = replace ? 'replace' : 'push';
      router[method](href, {
        forceOptimisticNavigation: !prefetchEnabled
      });
    }
  };

  if (isAppRouter) {
    // @ts-expect-error startTransition exists.
    _react["default"].startTransition(navigate);
  } else {
    navigate();
  }
}

var Link = /*#__PURE__*/_react["default"].forwardRef(function LinkComponent(props, forwardedRef) {
  if (false) { var hasWarned, optionalProps, optionalPropsGuard, requiredProps, requiredPropsGuard, createPropError; }

  var children;

  var hrefProp = props.href,
      asProp = props.as,
      childrenProp = props.children,
      prefetchProp = props.prefetch,
      passHref = props.passHref,
      replace = props.replace,
      shallow = props.shallow,
      scroll = props.scroll,
      locale = props.locale,
      _onClick = props.onClick,
      _onMouseEnter = props.onMouseEnter,
      _onTouchStart = props.onTouchStart,
      _props$legacyBehavior = props.legacyBehavior,
      legacyBehavior = _props$legacyBehavior === void 0 ? Boolean(false) !== true : _props$legacyBehavior,
      restProps = _object_without_properties_loose(props, ["href", "as", "children", "prefetch", "passHref", "replace", "shallow", "scroll", "locale", "onClick", "onMouseEnter", "onTouchStart", "legacyBehavior"]);

  children = childrenProp;

  if (legacyBehavior && (typeof children === 'string' || typeof children === 'number')) {
    children = /*#__PURE__*/_react["default"].createElement("a", null, children);
  }

  var p = prefetchProp !== false;

  var router = _react["default"].useContext(_routerContext.RouterContext); // TODO-APP: type error. Remove `as any`


  var appRouter = _react["default"].useContext(_appRouterContext.AppRouterContext);

  if (appRouter) {
    router = appRouter;
  }

  var _react$default$useMem = _react["default"].useMemo(function () {
    var _resolveHref = (0, _router).resolveHref(router, hrefProp, true),
        _resolveHref2 = _slicedToArray(_resolveHref, 2),
        resolvedHref = _resolveHref2[0],
        resolvedAs = _resolveHref2[1];

    return {
      href: resolvedHref,
      as: asProp ? (0, _router).resolveHref(router, asProp) : resolvedAs || resolvedHref
    };
  }, [router, hrefProp, asProp]),
      href = _react$default$useMem.href,
      as = _react$default$useMem.as;

  var previousHref = _react["default"].useRef(href);

  var previousAs = _react["default"].useRef(as); // This will return the first child, if multiple are provided it will throw an error


  var child;

  if (legacyBehavior) {
    if (false) {} else {
      child = _react["default"].Children.only(children);
    }
  }

  var childRef = legacyBehavior ? child && typeof child === 'object' && child.ref : forwardedRef;

  var _useIntersection2 = (0, _useIntersection).useIntersection({
    rootMargin: '200px'
  }),
      _useIntersection3 = _slicedToArray(_useIntersection2, 3),
      setIntersectionRef = _useIntersection3[0],
      isVisible = _useIntersection3[1],
      resetVisible = _useIntersection3[2];

  var setRef = _react["default"].useCallback(function (el) {
    // Before the link getting observed, check if visible state need to be reset
    if (previousAs.current !== as || previousHref.current !== href) {
      resetVisible();
      previousAs.current = as;
      previousHref.current = href;
    }

    setIntersectionRef(el);

    if (childRef) {
      if (typeof childRef === 'function') childRef(el);else if (typeof childRef === 'object') {
        childRef.current = el;
      }
    }
  }, [as, childRef, href, resetVisible, setIntersectionRef]);

  _react["default"].useEffect(function () {
    var shouldPrefetch = isVisible && p && (0, _router).isLocalURL(href);
    var curLocale = typeof locale !== 'undefined' ? locale : router && router.locale;
    var isPrefetched = prefetched[href + '%' + as + (curLocale ? '%' + curLocale : '')];

    if (shouldPrefetch && !isPrefetched) {
      prefetch(router, href, as, {
        locale: curLocale
      });
    }
  }, [as, href, isVisible, locale, p, router]);

  var childProps = {
    ref: setRef,
    onClick: function onClick(e) {
      if (false) {}

      if (!legacyBehavior && typeof _onClick === 'function') {
        _onClick(e);
      }

      if (legacyBehavior && child.props && typeof child.props.onClick === 'function') {
        child.props.onClick(e);
      }

      if (!e.defaultPrevented) {
        linkClicked(e, router, href, as, replace, shallow, scroll, locale, Boolean(appRouter), p);
      }
    },
    onMouseEnter: function onMouseEnter(e) {
      if (!legacyBehavior && typeof _onMouseEnter === 'function') {
        _onMouseEnter(e);
      }

      if (legacyBehavior && child.props && typeof child.props.onMouseEnter === 'function') {
        child.props.onMouseEnter(e);
      } // Check for not prefetch disabled in page using appRouter


      if (!(!p && appRouter)) {
        if ((0, _router).isLocalURL(href)) {
          prefetch(router, href, as, {
            priority: true
          });
        }
      }
    },
    onTouchStart: function onTouchStart(e) {
      if (!legacyBehavior && typeof _onTouchStart === 'function') {
        _onTouchStart(e);
      }

      if (legacyBehavior && child.props && typeof child.props.onTouchStart === 'function') {
        child.props.onTouchStart(e);
      } // Check for not prefetch disabled in page using appRouter


      if (!(!p && appRouter)) {
        if ((0, _router).isLocalURL(href)) {
          prefetch(router, href, as, {
            priority: true
          });
        }
      }
    }
  }; // If child is an <a> tag and doesn't have a href attribute, or if the 'passHref' property is
  // defined, we specify the current 'href', so that repetition is not needed by the user

  if (!legacyBehavior || passHref || child.type === 'a' && !('href' in child.props)) {
    var curLocale = typeof locale !== 'undefined' ? locale : router && router.locale; // we only render domain locales if we are currently on a domain locale
    // so that locale links are still visitable in development/preview envs

    var localeDomain = router && router.isLocaleDomain && (0, _getDomainLocale).getDomainLocale(as, curLocale, router.locales, router.domainLocales);
    childProps.href = localeDomain || (0, _addBasePath).addBasePath((0, _addLocale).addLocale(as, curLocale, router && router.defaultLocale));
  }

  return legacyBehavior ? /*#__PURE__*/_react["default"].cloneElement(child, childProps) : /*#__PURE__*/_react["default"].createElement("a", Object.assign({}, restProps, childProps), children);
});

var _default = Link;
exports["default"] = _default;

if ((typeof exports["default"] === 'function' || typeof exports["default"] === 'object' && exports["default"] !== null) && typeof exports["default"].__esModule === 'undefined') {
  Object.defineProperty(exports["default"], '__esModule', {
    value: true
  });
  Object.assign(exports["default"], exports);
  module.exports = exports["default"];
}

/***/ }),

/***/ 93084:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _slicedToArray = __webpack_require__(15242);

Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.useIntersection = useIntersection;

var _react = __webpack_require__(75271);

var _requestIdleCallback = __webpack_require__(16899);

var hasIntersectionObserver = typeof IntersectionObserver === 'function';
var observers = new Map();
var idList = [];

function createObserver(options) {
  var id = {
    root: options.root || null,
    margin: options.rootMargin || ''
  };
  var existing = idList.find(function (obj) {
    return obj.root === id.root && obj.margin === id.margin;
  });
  var instance;

  if (existing) {
    instance = observers.get(existing);

    if (instance) {
      return instance;
    }
  }

  var elements = new Map();
  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      var callback = elements.get(entry.target);
      var isVisible = entry.isIntersecting || entry.intersectionRatio > 0;

      if (callback && isVisible) {
        callback(isVisible);
      }
    });
  }, options);
  instance = {
    id: id,
    observer: observer,
    elements: elements
  };
  idList.push(id);
  observers.set(id, instance);
  return instance;
}

function observe(element, callback, options) {
  var _createObserver = createObserver(options),
      id = _createObserver.id,
      observer = _createObserver.observer,
      elements = _createObserver.elements;

  elements.set(element, callback);
  observer.observe(element);
  return function unobserve() {
    elements["delete"](element);
    observer.unobserve(element); // Destroy observer when there's nothing left to watch:

    if (elements.size === 0) {
      observer.disconnect();
      observers["delete"](id);
      var index = idList.findIndex(function (obj) {
        return obj.root === id.root && obj.margin === id.margin;
      });

      if (index > -1) {
        idList.splice(index, 1);
      }
    }
  };
}

function useIntersection(_ref) {
  var rootRef = _ref.rootRef,
      rootMargin = _ref.rootMargin,
      disabled = _ref.disabled;
  var isDisabled = disabled || !hasIntersectionObserver;

  var _useState = (0, _react).useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      visible = _useState2[0],
      setVisible = _useState2[1];

  var _useState3 = (0, _react).useState(null),
      _useState4 = _slicedToArray(_useState3, 2),
      element = _useState4[0],
      setElement = _useState4[1];

  (0, _react).useEffect(function () {
    if (hasIntersectionObserver) {
      if (isDisabled || visible) return;

      if (element && element.tagName) {
        var unobserve = observe(element, function (isVisible) {
          return isVisible && setVisible(isVisible);
        }, {
          root: rootRef == null ? void 0 : rootRef.current,
          rootMargin: rootMargin
        });
        return unobserve;
      }
    } else {
      if (!visible) {
        var idleCallback = (0, _requestIdleCallback).requestIdleCallback(function () {
          return setVisible(true);
        });
        return function () {
          return (0, _requestIdleCallback).cancelIdleCallback(idleCallback);
        };
      }
    }
  }, [element, isDisabled, rootMargin, rootRef, visible]);
  var resetVisible = (0, _react).useCallback(function () {
    setVisible(false);
  }, []);
  return [setElement, visible, resetVisible];
}

if ((typeof exports["default"] === 'function' || typeof exports["default"] === 'object' && exports["default"] !== null) && typeof exports["default"].__esModule === 'undefined') {
  Object.defineProperty(exports["default"], '__esModule', {
    value: true
  });
  Object.assign(exports["default"], exports);
  module.exports = exports["default"];
}

/***/ }),

/***/ 30354:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var _classCallCheck = __webpack_require__(47578);

var _createClass = __webpack_require__(48577);

var _inherits = __webpack_require__(29409);

var _possibleConstructorReturn = __webpack_require__(22221);

var _getPrototypeOf = __webpack_require__(80308);

var _regeneratorRuntime = __webpack_require__(78838);

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

Object.defineProperty(exports, "__esModule", ({
  value: true
}));
Object.defineProperty(exports, "AppInitialProps", ({
  enumerable: true,
  get: function get() {
    return _utils.AppInitialProps;
  }
}));
Object.defineProperty(exports, "NextWebVitalsMetric", ({
  enumerable: true,
  get: function get() {
    return _utils.NextWebVitalsMetric;
  }
}));
Object.defineProperty(exports, "AppType", ({
  enumerable: true,
  get: function get() {
    return _utils.AppType;
  }
}));
exports["default"] = void 0;

var _async_to_generator = (__webpack_require__(77156)/* ["default"] */ .Z);

var _interop_require_default = (__webpack_require__(57022)/* ["default"] */ .Z);

var _react = _interop_require_default(__webpack_require__(75271));

var _utils = __webpack_require__(46008);

function appGetInitialProps(_) {
  return _appGetInitialProps.apply(this, arguments);
}

function _appGetInitialProps() {
  _appGetInitialProps =
  /**
  * `App` component is used for initialize of pages. It allows for overwriting and full control of the `page` initialization.
  * This allows for keeping state between navigation, custom error handling, injecting additional data.
  */
  _async_to_generator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref) {
    var Component, ctx, pageProps;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            Component = _ref.Component, ctx = _ref.ctx;
            _context.next = 3;
            return (0, _utils).loadGetInitialProps(Component, ctx);

          case 3:
            pageProps = _context.sent;
            return _context.abrupt("return", {
              pageProps: pageProps
            });

          case 5:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _appGetInitialProps.apply(this, arguments);
}

var _Component;

var App = /*#__PURE__*/function (_Component2) {
  _inherits(App, _Component2);

  var _super = _createSuper(App);

  function App() {
    _classCallCheck(this, App);

    return _super.apply(this, arguments);
  }

  _createClass(App, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          Component = _this$props.Component,
          pageProps = _this$props.pageProps;
      return /*#__PURE__*/_react["default"].createElement(Component, Object.assign({}, pageProps));
    }
  }]);

  return App;
}(_Component = _react["default"].Component);

App.origGetInitialProps = appGetInitialProps;
App.getInitialProps = appGetInitialProps;
exports["default"] = App;

/***/ }),

/***/ 24533:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.AmpStateContext = void 0;

var _interop_require_default = (__webpack_require__(57022)/* ["default"] */ .Z);

var _react = _interop_require_default(__webpack_require__(75271));

var AmpStateContext = _react["default"].createContext({});

exports.AmpStateContext = AmpStateContext;

if (false) {}

/***/ }),

/***/ 81011:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.isInAmpMode = isInAmpMode;

function isInAmpMode() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$ampFirst = _ref.ampFirst,
      ampFirst = _ref$ampFirst === void 0 ? false : _ref$ampFirst,
      _ref$hybrid = _ref.hybrid,
      hybrid = _ref$hybrid === void 0 ? false : _ref$hybrid,
      _ref$hasQuery = _ref.hasQuery,
      hasQuery = _ref$hasQuery === void 0 ? false : _ref$hasQuery;

  return ampFirst || hybrid && hasQuery;
}

/***/ }),

/***/ 57220:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.TemplateContext = exports.GlobalLayoutRouterContext = exports.LayoutRouterContext = exports.AppRouterContext = void 0;

var _interop_require_default = (__webpack_require__(57022)/* ["default"] */ .Z);

var _react = _interop_require_default(__webpack_require__(75271));

var AppRouterContext = _react["default"].createContext(null);

exports.AppRouterContext = AppRouterContext;

var LayoutRouterContext = _react["default"].createContext(null);

exports.LayoutRouterContext = LayoutRouterContext;

var GlobalLayoutRouterContext = _react["default"].createContext(null);

exports.GlobalLayoutRouterContext = GlobalLayoutRouterContext;

var TemplateContext = _react["default"].createContext(null);

exports.TemplateContext = TemplateContext;

if (false) {}

/***/ }),

/***/ 58727:
/***/ (function(module, exports, __webpack_require__) {

"client";
"use strict";

Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.defaultHead = defaultHead;
exports["default"] = void 0;

var _extends = (__webpack_require__(5506)/* ["default"] */ .Z);

var _interop_require_default = (__webpack_require__(57022)/* ["default"] */ .Z);

var _interop_require_wildcard = (__webpack_require__(88889)/* ["default"] */ .Z);

var _react = _interop_require_wildcard(__webpack_require__(75271));

var _sideEffect = _interop_require_default(__webpack_require__(94475));

var _ampContext = __webpack_require__(24533);

var _headManagerContext = __webpack_require__(80420);

var _ampMode = __webpack_require__(81011);

var _utils = __webpack_require__(46008);

'client';

function defaultHead() {
  var inAmpMode = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  var head = [/*#__PURE__*/_react["default"].createElement("meta", {
    charSet: "utf-8"
  })];

  if (!inAmpMode) {
    head.push( /*#__PURE__*/_react["default"].createElement("meta", {
      name: "viewport",
      content: "width=device-width"
    }));
  }

  return head;
}

function onlyReactElement(list, child) {
  // React children can be "string" or "number" in this case we ignore them for backwards compat
  if (typeof child === 'string' || typeof child === 'number') {
    return list;
  } // Adds support for React.Fragment


  if (child.type === _react["default"].Fragment) {
    return list.concat(_react["default"].Children.toArray(child.props.children).reduce(function (fragmentList, fragmentChild) {
      if (typeof fragmentChild === 'string' || typeof fragmentChild === 'number') {
        return fragmentList;
      }

      return fragmentList.concat(fragmentChild);
    }, []));
  }

  return list.concat(child);
}

var METATYPES = ['name', 'httpEquiv', 'charSet', 'itemProp'];
/*
 returns a function for filtering head child elements
 which shouldn't be duplicated, like <title/>
 Also adds support for deduplicated `key` properties
*/

function unique() {
  var keys = new Set();
  var tags = new Set();
  var metaTypes = new Set();
  var metaCategories = {};
  return function (h) {
    var isUnique = true;
    var hasKey = false;

    if (h.key && typeof h.key !== 'number' && h.key.indexOf('$') > 0) {
      hasKey = true;
      var key = h.key.slice(h.key.indexOf('$') + 1);

      if (keys.has(key)) {
        isUnique = false;
      } else {
        keys.add(key);
      }
    } // eslint-disable-next-line default-case


    switch (h.type) {
      case 'title':
      case 'base':
        if (tags.has(h.type)) {
          isUnique = false;
        } else {
          tags.add(h.type);
        }

        break;

      case 'meta':
        for (var i = 0, len = METATYPES.length; i < len; i++) {
          var metatype = METATYPES[i];
          if (!h.props.hasOwnProperty(metatype)) continue;

          if (metatype === 'charSet') {
            if (metaTypes.has(metatype)) {
              isUnique = false;
            } else {
              metaTypes.add(metatype);
            }
          } else {
            var category = h.props[metatype];
            var categories = metaCategories[metatype] || new Set();

            if ((metatype !== 'name' || !hasKey) && categories.has(category)) {
              isUnique = false;
            } else {
              categories.add(category);
              metaCategories[metatype] = categories;
            }
          }
        }

        break;
    }

    return isUnique;
  };
}
/**
 *
 * @param headChildrenElements List of children of <Head>
 */


function reduceComponents(headChildrenElements, props) {
  var inAmpMode = props.inAmpMode;
  return headChildrenElements.reduce(onlyReactElement, []).reverse().concat(defaultHead(inAmpMode).reverse()).filter(unique()).reverse().map(function (c, i) {
    var key = c.key || i;

    if ( true && !inAmpMode) {
      if (c.type === 'link' && c.props['href'] && // TODO(prateekbh@): Replace this with const from `constants` when the tree shaking works.
      ['https://fonts.googleapis.com/css', 'https://use.typekit.net/'].some(function (url) {
        return c.props['href'].startsWith(url);
      })) {
        var newProps = _extends({}, c.props || {});

        newProps['data-href'] = newProps['href'];
        newProps['href'] = undefined; // Add this attribute to make it easy to identify optimized tags

        newProps['data-optimized-fonts'] = true;
        return /*#__PURE__*/_react["default"].cloneElement(c, newProps);
      }
    }

    if (false) { var srcMessage; }

    return /*#__PURE__*/_react["default"].cloneElement(c, {
      key: key
    });
  });
}
/**
 * This component injects elements to `<head>` of your page.
 * To avoid duplicated `tags` in `<head>` you can use the `key` property, which will make sure every tag is only rendered once.
 */


function Head(_ref) {
  var children = _ref.children;
  var ampState = (0, _react).useContext(_ampContext.AmpStateContext);
  var headManager = (0, _react).useContext(_headManagerContext.HeadManagerContext);
  return /*#__PURE__*/_react["default"].createElement(_sideEffect["default"], {
    reduceComponentsToState: reduceComponents,
    headManager: headManager,
    inAmpMode: (0, _ampMode).isInAmpMode(ampState)
  }, children);
}

var _default = Head;
exports["default"] = _default;

if ((typeof exports["default"] === 'function' || typeof exports["default"] === 'object' && exports["default"] !== null) && typeof exports["default"].__esModule === 'undefined') {
  Object.defineProperty(exports["default"], '__esModule', {
    value: true
  });
  Object.assign(exports["default"], exports);
  module.exports = exports["default"];
}

/***/ }),

/***/ 94475:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = SideEffect;

var _interop_require_wildcard = (__webpack_require__(88889)/* ["default"] */ .Z);

var _react = _interop_require_wildcard(__webpack_require__(75271));

function SideEffect(props) {
  var headManager = props.headManager,
      reduceComponentsToState = props.reduceComponentsToState;

  function emitChange() {
    if (headManager && headManager.mountedInstances) {
      var headElements = _react.Children.toArray(Array.from(headManager.mountedInstances).filter(Boolean));

      headManager.updateHead(reduceComponentsToState(headElements, props));
    }
  }

  if (isServer) {
    var ref;
    headManager == null ? void 0 : (ref = headManager.mountedInstances) == null ? void 0 : ref.add(props.children);
    emitChange();
  }

  useClientOnlyLayoutEffect(function () {
    var ref1;
    headManager == null ? void 0 : (ref1 = headManager.mountedInstances) == null ? void 0 : ref1.add(props.children);
    return function () {
      var ref;
      headManager == null ? void 0 : (ref = headManager.mountedInstances) == null ? void 0 : ref["delete"](props.children);
    };
  }); // We need to call `updateHead` method whenever the `SideEffect` is trigger in all
  // life-cycles: mount, update, unmount. However, if there are multiple `SideEffect`s
  // being rendered, we only trigger the method from the last one.
  // This is ensured by keeping the last unflushed `updateHead` in the `_pendingUpdate`
  // singleton in the layout effect pass, and actually trigger it in the effect pass.

  useClientOnlyLayoutEffect(function () {
    if (headManager) {
      headManager._pendingUpdate = emitChange;
    }

    return function () {
      if (headManager) {
        headManager._pendingUpdate = emitChange;
      }
    };
  });
  useClientOnlyEffect(function () {
    if (headManager && headManager._pendingUpdate) {
      headManager._pendingUpdate();

      headManager._pendingUpdate = null;
    }

    return function () {
      if (headManager && headManager._pendingUpdate) {
        headManager._pendingUpdate();

        headManager._pendingUpdate = null;
      }
    };
  });
  return null;
}

var isServer = false;
var useClientOnlyLayoutEffect = isServer ? function () {} : _react.useLayoutEffect;
var useClientOnlyEffect = isServer ? function () {} : _react.useEffect;

/***/ }),

/***/ 83899:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "_": function() { return /* binding */ fetcher; }
/* harmony export */ });
/* harmony import */ var _app_node_modules_pnpm_next_12_3_4_babel_core_7_26_0_react_dom_18_3_1_react_18_3_1_sass_1_80_4_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(6325);
/* harmony import */ var _app_node_modules_pnpm_next_12_3_4_babel_core_7_26_0_react_dom_18_3_1_react_18_3_1_sass_1_80_4_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(78838);
/* harmony import */ var _app_node_modules_pnpm_next_12_3_4_babel_core_7_26_0_react_dom_18_3_1_react_18_3_1_sass_1_80_4_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_app_node_modules_pnpm_next_12_3_4_babel_core_7_26_0_react_dom_18_3_1_react_18_3_1_sass_1_80_4_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var humps__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(87493);
/* harmony import */ var humps__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(humps__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var common_http__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(8585);




var fetcher = /*#__PURE__*/function () {
  var _ref = (0,_app_node_modules_pnpm_next_12_3_4_babel_core_7_26_0_react_dom_18_3_1_react_18_3_1_sass_1_80_4_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)( /*#__PURE__*/_app_node_modules_pnpm_next_12_3_4_babel_core_7_26_0_react_dom_18_3_1_react_18_3_1_sass_1_80_4_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(url) {
    var json;
    return _app_node_modules_pnpm_next_12_3_4_babel_core_7_26_0_react_dom_18_3_1_react_18_3_1_sass_1_80_4_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return common_http__WEBPACK_IMPORTED_MODULE_2__/* .clientHttp.get */ .J.get(url).json();

          case 2:
            json = _context.sent;
            return _context.abrupt("return", (0,humps__WEBPACK_IMPORTED_MODULE_1__.camelizeKeys)(json));

          case 4:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function fetcher(_x) {
    return _ref.apply(this, arguments);
  };
}();

/***/ }),

/***/ 9675:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "LQ": function() { return /* binding */ shareKakao; },
/* harmony export */   "cW": function() { return /* binding */ ANDROID_VERSION_ERROR_NAME; }
/* harmony export */ });
/* unused harmony export fetchKakaoAPI */
/* harmony import */ var common__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(23336);
/* harmony import */ var _utils_OSVersion__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(76823);


var KAKAO_API_SRC = '//developers.kakao.com/sdk/js/kakao.min.js';
var KAKAO_AUTH_TOKEN = "3019c756ec77dd7e0a24e56d9d784f77";
var ANDROID_VERSION_ERROR_NAME = 'Android Version Error';

var isKakaoShareVersionOkay = function isKakaoShareVersionOkay(current) {
  var versionArr = current.split('.');
  var targetVersionArr = common__WEBPACK_IMPORTED_MODULE_0__/* .ANDROID_KAKAO_SHARE_VERSION.split */ .Cl.split('.');
  if (versionArr.length !== targetVersionArr.length) return false;

  for (var i = 0; i < versionArr.length; i++) {
    var version = Number(versionArr[i]);
    var targetVersion = Number(targetVersionArr[i]);
    if (isNaN(version) || isNaN(targetVersion)) return false;
    if (version > targetVersion) return true;
  }

  return current === common__WEBPACK_IMPORTED_MODULE_0__/* .ANDROID_KAKAO_SHARE_VERSION */ .Cl;
};

var shareKakao = function shareKakao(_ref) {
  var templateId = _ref.templateId,
      templateArgs = _ref.templateArgs,
      onFail = _ref.onFail;
  fetchKakaoAPI().then(function () {
    var osInfo = (0,_utils_OSVersion__WEBPACK_IMPORTED_MODULE_1__/* .getAppOsInfo */ .Z)();
    var isAndroidOldVersion = osInfo.osType === 'Android' && !isKakaoShareVersionOkay(osInfo.osVersion);

    if (isAndroidOldVersion) {
      var versionError = new Error('Android version Error');
      versionError.name = ANDROID_VERSION_ERROR_NAME;
      throw versionError;
    }

    Kakao.Share.sendCustom({
      templateId: templateId,
      templateArgs: templateArgs
    });
  })["catch"](function (error) {
    onFail(error);
  });
};
var kakaoAPILoading = null;
var initialized = false;
var fetchKakaoAPI = function fetchKakaoAPI() {
  if (window.Kakao != null) {
    if (!initialized) {
      try {
        Kakao.init(KAKAO_AUTH_TOKEN);
      } catch (e) {//
      }

      initialized = true;
    }

    return Promise.resolve(window.Kakao);
  } else if (kakaoAPILoading != null) {
    return kakaoAPILoading;
  }

  kakaoAPILoading = new Promise(function (resolve) {
    // Load the script from daum...
    var script = document.createElement('script');
    script.addEventListener('load', function () {
      var _ref2 = window,
          Kakao = _ref2.Kakao;
      Kakao.init(KAKAO_AUTH_TOKEN);
      initialized = true;
      resolve(Kakao);
    });
    script.src = KAKAO_API_SRC;
    document.body.appendChild(script);
  });
  return kakaoAPILoading;
};

/***/ }),

/***/ 8585:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "J": function() { return /* binding */ clientHttp; }
});

// UNUSED EXPORTS: serverHttp

;// CONCATENATED MODULE: ./node_modules/.pnpm/ky@1.1.3/node_modules/ky/distribution/errors/HTTPError.js
// eslint-lint-disable-next-line @typescript-eslint/naming-convention
class HTTPError extends Error {
    constructor(response, request, options) {
        const code = (response.status || response.status === 0) ? response.status : '';
        const title = response.statusText || '';
        const status = `${code} ${title}`.trim();
        const reason = status ? `status code ${status}` : 'an unknown error';
        super(`Request failed with ${reason}`);
        Object.defineProperty(this, "response", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "request", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "options", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.name = 'HTTPError';
        this.response = response;
        this.request = request;
        this.options = options;
    }
}
//# sourceMappingURL=HTTPError.js.map
;// CONCATENATED MODULE: ./node_modules/.pnpm/ky@1.1.3/node_modules/ky/distribution/errors/TimeoutError.js
class TimeoutError extends Error {
    constructor(request) {
        super('Request timed out');
        Object.defineProperty(this, "request", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.name = 'TimeoutError';
        this.request = request;
    }
}
//# sourceMappingURL=TimeoutError.js.map
;// CONCATENATED MODULE: ./node_modules/.pnpm/ky@1.1.3/node_modules/ky/distribution/utils/is.js
// eslint-disable-next-line @typescript-eslint/ban-types
const isObject = (value) => value !== null && typeof value === 'object';
//# sourceMappingURL=is.js.map
;// CONCATENATED MODULE: ./node_modules/.pnpm/ky@1.1.3/node_modules/ky/distribution/utils/merge.js

const validateAndMerge = (...sources) => {
    for (const source of sources) {
        if ((!isObject(source) || Array.isArray(source)) && source !== undefined) {
            throw new TypeError('The `options` argument must be an object');
        }
    }
    return deepMerge({}, ...sources);
};
const mergeHeaders = (source1 = {}, source2 = {}) => {
    const result = new globalThis.Headers(source1);
    const isHeadersInstance = source2 instanceof globalThis.Headers;
    const source = new globalThis.Headers(source2);
    for (const [key, value] of source.entries()) {
        if ((isHeadersInstance && value === 'undefined') || value === undefined) {
            result.delete(key);
        }
        else {
            result.set(key, value);
        }
    }
    return result;
};
// TODO: Make this strongly-typed (no `any`).
const deepMerge = (...sources) => {
    let returnValue = {};
    let headers = {};
    for (const source of sources) {
        if (Array.isArray(source)) {
            if (!Array.isArray(returnValue)) {
                returnValue = [];
            }
            returnValue = [...returnValue, ...source];
        }
        else if (isObject(source)) {
            for (let [key, value] of Object.entries(source)) {
                if (isObject(value) && key in returnValue) {
                    value = deepMerge(returnValue[key], value);
                }
                returnValue = { ...returnValue, [key]: value };
            }
            if (isObject(source.headers)) {
                headers = mergeHeaders(headers, source.headers);
                returnValue.headers = headers;
            }
        }
    }
    return returnValue;
};
//# sourceMappingURL=merge.js.map
;// CONCATENATED MODULE: ./node_modules/.pnpm/ky@1.1.3/node_modules/ky/distribution/core/constants.js
const supportsRequestStreams = (() => {
    let duplexAccessed = false;
    let hasContentType = false;
    const supportsReadableStream = typeof globalThis.ReadableStream === 'function';
    const supportsRequest = typeof globalThis.Request === 'function';
    if (supportsReadableStream && supportsRequest) {
        hasContentType = new globalThis.Request('https://empty.invalid', {
            body: new globalThis.ReadableStream(),
            method: 'POST',
            // @ts-expect-error - Types are outdated.
            get duplex() {
                duplexAccessed = true;
                return 'half';
            },
        }).headers.has('Content-Type');
    }
    return duplexAccessed && !hasContentType;
})();
const supportsAbortController = typeof globalThis.AbortController === 'function';
const supportsResponseStreams = typeof globalThis.ReadableStream === 'function';
const supportsFormData = typeof globalThis.FormData === 'function';
const requestMethods = ['get', 'post', 'put', 'patch', 'head', 'delete'];
const validate = () => undefined;
validate();
const responseTypes = {
    json: 'application/json',
    text: 'text/*',
    formData: 'multipart/form-data',
    arrayBuffer: '*/*',
    blob: '*/*',
};
// The maximum value of a 32bit int (see issue #117)
const maxSafeTimeout = 2147483647;
const stop = Symbol('stop');
const kyOptionKeys = {
    json: true,
    parseJson: true,
    searchParams: true,
    prefixUrl: true,
    retry: true,
    timeout: true,
    hooks: true,
    throwHttpErrors: true,
    onDownloadProgress: true,
    fetch: true,
};
const requestOptionsRegistry = {
    method: true,
    headers: true,
    body: true,
    mode: true,
    credentials: true,
    cache: true,
    redirect: true,
    referrer: true,
    referrerPolicy: true,
    integrity: true,
    keepalive: true,
    signal: true,
    window: true,
    dispatcher: true,
    duplex: true,
};
//# sourceMappingURL=constants.js.map
;// CONCATENATED MODULE: ./node_modules/.pnpm/ky@1.1.3/node_modules/ky/distribution/utils/normalize.js

const normalizeRequestMethod = (input) => requestMethods.includes(input) ? input.toUpperCase() : input;
const retryMethods = ['get', 'put', 'head', 'delete', 'options', 'trace'];
const retryStatusCodes = [408, 413, 429, 500, 502, 503, 504];
const retryAfterStatusCodes = [413, 429, 503];
const defaultRetryOptions = {
    limit: 2,
    methods: retryMethods,
    statusCodes: retryStatusCodes,
    afterStatusCodes: retryAfterStatusCodes,
    maxRetryAfter: Number.POSITIVE_INFINITY,
    backoffLimit: Number.POSITIVE_INFINITY,
    delay: attemptCount => 0.3 * (2 ** (attemptCount - 1)) * 1000,
};
const normalizeRetryOptions = (retry = {}) => {
    if (typeof retry === 'number') {
        return {
            ...defaultRetryOptions,
            limit: retry,
        };
    }
    if (retry.methods && !Array.isArray(retry.methods)) {
        throw new Error('retry.methods must be an array');
    }
    if (retry.statusCodes && !Array.isArray(retry.statusCodes)) {
        throw new Error('retry.statusCodes must be an array');
    }
    return {
        ...defaultRetryOptions,
        ...retry,
        afterStatusCodes: retryAfterStatusCodes,
    };
};
//# sourceMappingURL=normalize.js.map
;// CONCATENATED MODULE: ./node_modules/.pnpm/ky@1.1.3/node_modules/ky/distribution/utils/timeout.js

// `Promise.race()` workaround (#91)
async function timeout(request, init, abortController, options) {
    return new Promise((resolve, reject) => {
        const timeoutId = setTimeout(() => {
            if (abortController) {
                abortController.abort();
            }
            reject(new TimeoutError(request));
        }, options.timeout);
        void options
            .fetch(request, init)
            .then(resolve)
            .catch(reject)
            .then(() => {
            clearTimeout(timeoutId);
        });
    });
}
//# sourceMappingURL=timeout.js.map
;// CONCATENATED MODULE: ./node_modules/.pnpm/ky@1.1.3/node_modules/ky/distribution/utils/delay.js
// https://github.com/sindresorhus/delay/tree/ab98ae8dfcb38e1593286c94d934e70d14a4e111
async function delay(ms, { signal }) {
    return new Promise((resolve, reject) => {
        if (signal) {
            signal.throwIfAborted();
            signal.addEventListener('abort', abortHandler, { once: true });
        }
        function abortHandler() {
            clearTimeout(timeoutId);
            reject(signal.reason);
        }
        const timeoutId = setTimeout(() => {
            signal?.removeEventListener('abort', abortHandler);
            resolve();
        }, ms);
    });
}
//# sourceMappingURL=delay.js.map
;// CONCATENATED MODULE: ./node_modules/.pnpm/ky@1.1.3/node_modules/ky/distribution/utils/options.js

const findUnknownOptions = (request, options) => {
    const unknownOptions = {};
    for (const key in options) {
        if (!(key in requestOptionsRegistry) && !(key in kyOptionKeys) && !(key in request)) {
            unknownOptions[key] = options[key];
        }
    }
    return unknownOptions;
};
//# sourceMappingURL=options.js.map
;// CONCATENATED MODULE: ./node_modules/.pnpm/ky@1.1.3/node_modules/ky/distribution/core/Ky.js








class Ky {
    static create(input, options) {
        const ky = new Ky(input, options);
        const fn = async () => {
            if (typeof ky._options.timeout === 'number' && ky._options.timeout > maxSafeTimeout) {
                throw new RangeError(`The \`timeout\` option cannot be greater than ${maxSafeTimeout}`);
            }
            // Delay the fetch so that body method shortcuts can set the Accept header
            await Promise.resolve();
            let response = await ky._fetch();
            for (const hook of ky._options.hooks.afterResponse) {
                // eslint-disable-next-line no-await-in-loop
                const modifiedResponse = await hook(ky.request, ky._options, ky._decorateResponse(response.clone()));
                if (modifiedResponse instanceof globalThis.Response) {
                    response = modifiedResponse;
                }
            }
            ky._decorateResponse(response);
            if (!response.ok && ky._options.throwHttpErrors) {
                let error = new HTTPError(response, ky.request, ky._options);
                for (const hook of ky._options.hooks.beforeError) {
                    // eslint-disable-next-line no-await-in-loop
                    error = await hook(error);
                }
                throw error;
            }
            // If `onDownloadProgress` is passed, it uses the stream API internally
            /* istanbul ignore next */
            if (ky._options.onDownloadProgress) {
                if (typeof ky._options.onDownloadProgress !== 'function') {
                    throw new TypeError('The `onDownloadProgress` option must be a function');
                }
                if (!supportsResponseStreams) {
                    throw new Error('Streams are not supported in your environment. `ReadableStream` is missing.');
                }
                return ky._stream(response.clone(), ky._options.onDownloadProgress);
            }
            return response;
        };
        const isRetriableMethod = ky._options.retry.methods.includes(ky.request.method.toLowerCase());
        const result = (isRetriableMethod ? ky._retry(fn) : fn());
        for (const [type, mimeType] of Object.entries(responseTypes)) {
            result[type] = async () => {
                // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing
                ky.request.headers.set('accept', ky.request.headers.get('accept') || mimeType);
                const awaitedResult = await result;
                const response = awaitedResult.clone();
                if (type === 'json') {
                    if (response.status === 204) {
                        return '';
                    }
                    const arrayBuffer = await response.clone().arrayBuffer();
                    const responseSize = arrayBuffer.byteLength;
                    if (responseSize === 0) {
                        return '';
                    }
                    if (options.parseJson) {
                        return options.parseJson(await response.text());
                    }
                }
                return response[type]();
            };
        }
        return result;
    }
    // eslint-disable-next-line complexity
    constructor(input, options = {}) {
        Object.defineProperty(this, "request", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "abortController", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "_retryCount", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: 0
        });
        Object.defineProperty(this, "_input", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "_options", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this._input = input;
        this._options = {
            // TODO: credentials can be removed when the spec change is implemented in all browsers. Context: https://www.chromestatus.com/feature/4539473312350208
            credentials: this._input.credentials || 'same-origin',
            ...options,
            headers: mergeHeaders(this._input.headers, options.headers),
            hooks: deepMerge({
                beforeRequest: [],
                beforeRetry: [],
                beforeError: [],
                afterResponse: [],
            }, options.hooks),
            method: normalizeRequestMethod(options.method ?? this._input.method),
            // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing
            prefixUrl: String(options.prefixUrl || ''),
            retry: normalizeRetryOptions(options.retry),
            throwHttpErrors: options.throwHttpErrors !== false,
            timeout: options.timeout ?? 10000,
            fetch: options.fetch ?? globalThis.fetch.bind(globalThis),
        };
        if (typeof this._input !== 'string' && !(this._input instanceof URL || this._input instanceof globalThis.Request)) {
            throw new TypeError('`input` must be a string, URL, or Request');
        }
        if (this._options.prefixUrl && typeof this._input === 'string') {
            if (this._input.startsWith('/')) {
                throw new Error('`input` must not begin with a slash when using `prefixUrl`');
            }
            if (!this._options.prefixUrl.endsWith('/')) {
                this._options.prefixUrl += '/';
            }
            this._input = this._options.prefixUrl + this._input;
        }
        if (supportsAbortController) {
            this.abortController = new globalThis.AbortController();
            if (this._options.signal) {
                const originalSignal = this._options.signal;
                this._options.signal.addEventListener('abort', () => {
                    this.abortController.abort(originalSignal.reason);
                });
            }
            this._options.signal = this.abortController.signal;
        }
        if (supportsRequestStreams) {
            // @ts-expect-error - Types are outdated.
            this._options.duplex = 'half';
        }
        this.request = new globalThis.Request(this._input, this._options);
        if (this._options.searchParams) {
            // eslint-disable-next-line unicorn/prevent-abbreviations
            const textSearchParams = typeof this._options.searchParams === 'string'
                ? this._options.searchParams.replace(/^\?/, '')
                : new URLSearchParams(this._options.searchParams).toString();
            // eslint-disable-next-line unicorn/prevent-abbreviations
            const searchParams = '?' + textSearchParams;
            const url = this.request.url.replace(/(?:\?.*?)?(?=#|$)/, searchParams);
            // To provide correct form boundary, Content-Type header should be deleted each time when new Request instantiated from another one
            if (((supportsFormData && this._options.body instanceof globalThis.FormData)
                || this._options.body instanceof URLSearchParams) && !(this._options.headers && this._options.headers['content-type'])) {
                this.request.headers.delete('content-type');
            }
            // The spread of `this.request` is required as otherwise it misses the `duplex` option for some reason and throws.
            this.request = new globalThis.Request(new globalThis.Request(url, { ...this.request }), this._options);
        }
        if (this._options.json !== undefined) {
            this._options.body = JSON.stringify(this._options.json);
            this.request.headers.set('content-type', this._options.headers.get('content-type') ?? 'application/json');
            this.request = new globalThis.Request(this.request, { body: this._options.body });
        }
    }
    _calculateRetryDelay(error) {
        this._retryCount++;
        if (this._retryCount < this._options.retry.limit && !(error instanceof TimeoutError)) {
            if (error instanceof HTTPError) {
                if (!this._options.retry.statusCodes.includes(error.response.status)) {
                    return 0;
                }
                const retryAfter = error.response.headers.get('Retry-After');
                if (retryAfter && this._options.retry.afterStatusCodes.includes(error.response.status)) {
                    let after = Number(retryAfter);
                    if (Number.isNaN(after)) {
                        after = Date.parse(retryAfter) - Date.now();
                    }
                    else {
                        after *= 1000;
                    }
                    if (this._options.retry.maxRetryAfter !== undefined && after > this._options.retry.maxRetryAfter) {
                        return 0;
                    }
                    return after;
                }
                if (error.response.status === 413) {
                    return 0;
                }
            }
            const retryDelay = this._options.retry.delay(this._retryCount);
            return Math.min(this._options.retry.backoffLimit, retryDelay);
        }
        return 0;
    }
    _decorateResponse(response) {
        if (this._options.parseJson) {
            response.json = async () => this._options.parseJson(await response.text());
        }
        return response;
    }
    async _retry(fn) {
        try {
            return await fn();
        }
        catch (error) {
            const ms = Math.min(this._calculateRetryDelay(error), maxSafeTimeout);
            if (ms !== 0 && this._retryCount > 0) {
                await delay(ms, { signal: this._options.signal });
                for (const hook of this._options.hooks.beforeRetry) {
                    // eslint-disable-next-line no-await-in-loop
                    const hookResult = await hook({
                        request: this.request,
                        options: this._options,
                        error: error,
                        retryCount: this._retryCount,
                    });
                    // If `stop` is returned from the hook, the retry process is stopped
                    if (hookResult === stop) {
                        return;
                    }
                }
                return this._retry(fn);
            }
            throw error;
        }
    }
    async _fetch() {
        for (const hook of this._options.hooks.beforeRequest) {
            // eslint-disable-next-line no-await-in-loop
            const result = await hook(this.request, this._options);
            if (result instanceof Request) {
                this.request = result;
                break;
            }
            if (result instanceof Response) {
                return result;
            }
        }
        const nonRequestOptions = findUnknownOptions(this.request, this._options);
        if (this._options.timeout === false) {
            return this._options.fetch(this.request.clone(), nonRequestOptions);
        }
        return timeout(this.request.clone(), nonRequestOptions, this.abortController, this._options);
    }
    /* istanbul ignore next */
    _stream(response, onDownloadProgress) {
        const totalBytes = Number(response.headers.get('content-length')) || 0;
        let transferredBytes = 0;
        if (response.status === 204) {
            if (onDownloadProgress) {
                onDownloadProgress({ percent: 1, totalBytes, transferredBytes }, new Uint8Array());
            }
            return new globalThis.Response(null, {
                status: response.status,
                statusText: response.statusText,
                headers: response.headers,
            });
        }
        return new globalThis.Response(new globalThis.ReadableStream({
            async start(controller) {
                const reader = response.body.getReader();
                if (onDownloadProgress) {
                    onDownloadProgress({ percent: 0, transferredBytes: 0, totalBytes }, new Uint8Array());
                }
                async function read() {
                    const { done, value } = await reader.read();
                    if (done) {
                        controller.close();
                        return;
                    }
                    if (onDownloadProgress) {
                        transferredBytes += value.byteLength;
                        const percent = totalBytes === 0 ? 0 : transferredBytes / totalBytes;
                        onDownloadProgress({ percent, transferredBytes, totalBytes }, value);
                    }
                    controller.enqueue(value);
                    await read();
                }
                await read();
            },
        }), {
            status: response.status,
            statusText: response.statusText,
            headers: response.headers,
        });
    }
}
//# sourceMappingURL=Ky.js.map
;// CONCATENATED MODULE: ./node_modules/.pnpm/ky@1.1.3/node_modules/ky/distribution/index.js
/*! MIT License © Sindre Sorhus */



const createInstance = (defaults) => {
    // eslint-disable-next-line @typescript-eslint/promise-function-async
    const ky = (input, options) => Ky.create(input, validateAndMerge(defaults, options));
    for (const method of requestMethods) {
        // eslint-disable-next-line @typescript-eslint/promise-function-async
        ky[method] = (input, options) => Ky.create(input, validateAndMerge(defaults, options, { method }));
    }
    ky.create = (newDefaults) => createInstance(validateAndMerge(newDefaults));
    ky.extend = (newDefaults) => createInstance(validateAndMerge(defaults, newDefaults));
    ky.stop = stop;
    return ky;
};
const ky = createInstance();
/* harmony default export */ var distribution = (ky);


//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ./node_modules/.pnpm/@bucketplace+jwt-auth@1.8.0_ky@1.1.3/node_modules/@bucketplace/jwt-auth/dist/ky.mjs


/**
 * Create a `ky` hooks object that will handle authentication.
 */
function createJwtAuthKyHooks(options) {
    var _a;
    const { beforeRequest, afterResponse, ...restHooks } = (_a = options === null || options === void 0 ? void 0 : options.hooks) !== null && _a !== void 0 ? _a : {};
    return {
        beforeRequest: [
            ...beforeRequest !== null && beforeRequest !== void 0 ? beforeRequest : [],
            createJwtAuthKyHookBeforeRequest({ jwtAuth: options === null || options === void 0 ? void 0 : options.jwtAuth }),
        ],
        afterResponse: [
            ...afterResponse !== null && afterResponse !== void 0 ? afterResponse : [],
            createJwtAuthKyHookAfterResponse({ jwtAuth: options === null || options === void 0 ? void 0 : options.jwtAuth }),
        ],
        ...restHooks,
    };
}
/**
 * Create a `ky` beforeRequest hook that will handle initial authentication.
 */
function createJwtAuthKyHookBeforeRequest(options) {
    return async (request, kyOptions) => {
        var _a;
        const jwtAuthInstance = (_a = kyOptions.jwtAuth) !== null && _a !== void 0 ? _a : options === null || options === void 0 ? void 0 : options.jwtAuth;
        if (jwtAuthInstance == null) {
            return request;
        }
        return jwtAuthInstance.handleAuth((context) => {
            for (const [name, value] of context.headers) {
                request.headers.set(name, value);
            }
            return new Request(request, {
                // Allow cookies to be sent with the request.
                credentials: 'include',
            });
        });
    };
}
/**
 * Create a `ky` afterResponse hook that will catch 401 responses and handle authentication.
 */
function createJwtAuthKyHookAfterResponse(options) {
    return async (request, kyOptions, response) => {
        var _a;
        const jwtAuthInstance = (_a = kyOptions.jwtAuth) !== null && _a !== void 0 ? _a : options === null || options === void 0 ? void 0 : options.jwtAuth;
        if (jwtAuthInstance == null) {
            return response;
        }
        if (response.status !== 401) {
            return response;
        }
        return jwtAuthInstance.handleAuth(async (context) => {
            for (const [name, value] of context.headers) {
                request.headers.set(name, value);
            }
            const res = await distribution(request, {
                // Allow cookies to be sent with the request.
                credentials: 'include',
                throwHttpErrors: false,
            });
            if (res.status === 401) {
                context.throwAuthErrorIfPossible();
            }
            return res;
        });
    };
}


//# sourceMappingURL=ky.mjs.map

// EXTERNAL MODULE: ./src/common/jwt-auth.ts + 2 modules
var jwt_auth = __webpack_require__(7799);
;// CONCATENATED MODULE: ./src/common/http.ts



var clientHttp = distribution.create({
  credentials: 'include',
  headers: {
    'content-type': 'application/json',
    'accept': 'application/json'
  },
  hooks: createJwtAuthKyHooks({
    jwtAuth: jwt_auth/* sessionManager */.c
  })
});
var serverHttp = distribution.create({
  credentials: 'include',
  headers: {
    'content-type': 'application/json',
    'accept': 'application/json'
  }
});

/***/ }),

/***/ 23336:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Cl": function() { return /* reexport */ ANDROID_KAKAO_SHARE_VERSION; },
  "iC": function() { return /* reexport */ APP_NAME; },
  "ui": function() { return /* reexport */ APP_PROFILE; },
  "Ji": function() { return /* reexport */ APP_VERSION; },
  "Ro": function() { return /* reexport */ CONTENT_HOST; },
  "w7": function() { return /* reexport */ DOMAINS; },
  "hE": function() { return /* reexport */ EVENT_HOST; },
  "al": function() { return /* reexport */ O2O_HOST; },
  "K2": function() { return /* reexport */ OHS_HOST; },
  "s2": function() { return /* reexport */ ONE_DAY; },
  "dV": function() { return /* reexport */ ONE_HOUR; },
  "yR": function() { return /* reexport */ ONE_MINUTE; },
  "WT": function() { return /* reexport */ ONE_SECOND; },
  "pN": function() { return /* reexport */ REDIRECT_PATH; },
  "O0": function() { return /* reexport */ SIGN_IN_URL; },
  "PH": function() { return /* reexport */ STORE_HOST; },
  "XK": function() { return /* reexport */ ZINDEX; }
});

// UNUSED EXPORTS: API_GATEWAY_HOST, EVENT_SELF_HOST, EVENT_SELF_PORT, HOST, PARTNERS_HOST, PRO_HOST, logger

;// CONCATENATED MODULE: ./node_modules/.pnpm/@bucketplace+config@0.1.2/node_modules/@bucketplace/config/dist/index.mjs
var n={HOME:"HOME",CONTENT:"CONTENT",STORE:"STORE",O2O:"O2O",EVENTS:"EVENTS",PAYMENT:"PAYMENT",EXPERT_PARTNER:"EXPERT_PARTNER",O2O_PARTNER:"O2O_PARTNER",ORORA:"ORORA",HOME_GLOBAL:"HOME_GLOBAL",CONTENT_GLOBAL:"CONTENT_GLOBAL",STORE_GLOBAL:"STORE_GLOBAL"},d={dev:"https://dev-web.dailyhou.se",stage:"https://stage-web.dailyhou.se",qa:"https://qa-web.dailyhou.se",prod:"https://ohou.se"},c={dev:"https://contents.dev-web.dailyhou.se",stage:"https://contents.stage-web.dailyhou.se",qa:"https://contents.qa-web.dailyhou.se",prod:"https://contents.ohou.se"},E={dev:"https://store.dev-web.dailyhou.se",stage:"https://store.stage-web.dailyhou.se",qa:"https://store.qa-web.dailyhou.se",prod:"https://store.ohou.se"},v={dev:"https://o2o.dev-web.dailyhou.se",stage:"https://o2o.stage-web.dailyhou.se",qa:"https://o2o.qa-web.dailyhou.se",prod:"https://o2o.ohou.se"},u={dev:"https://events.dev-web.dailyhou.se",stage:"https://events.stage-web.dailyhou.se",qa:"https://events.qa-web.dailyhou.se",prod:"https://events.ohou.se"},O={dev:"https://payment.dev-web.dailyhou.se",stage:"https://payment.stage-web.dailyhou.se",qa:"https://payment.qa-web.dailyhou.se",prod:"https://payment.ohou.se"},l={dev:"https://pro.dev-web.dailyhou.se",stage:"https://pro.stage-web.dailyhou.se",qa:"https://pro.qa-web.dailyhou.se",prod:"https://pro.ohou.se"},S={dev:"https://o2o-partner.dev-web.dailyhou.se",stage:"https://o2o-partner.stage-web.dailyhou.se",qa:"https://o2o-partner.qa-web.dailyhou.se",prod:"https://o2o-partner.ohou.se"},m={dev:"https://orora.dev-web.dailyhou.se",stage:"https://orora.dev-web.dailyhou.se",qa:"https://orora.qa-web.dailyhou.se",prod:"https://orora.ohou.se"},y={dev:"https://global.dev-web.dailyhou.se",stage:"https://global.stage-web.dailyhou.se",qa:"https://qa-web.ohouse.in",prod:"https://ohouse.com"},b={dev:"https://content-global.dev-web.dailyhou.se",stage:"https://content-global.stage-web.dailyhou.se",qa:"https://content.qa-web.ohouse.in",prod:"https://content.ohouse.com"},R={dev:"https://store-global.dev-web.dailyhou.se",stage:"https://store-global.stage-web.dailyhou.se",qa:"https://store.qa-web.ohouse.in",prod:"https://store.ohouse.com"},e={HOME:d,CONTENT:c,STORE:E,O2O:v,EVENTS:u,PAYMENT:O,EXPERT_PARTNER:l,O2O_PARTNER:S,ORORA:m,HOME_GLOBAL:y,CONTENT_GLOBAL:b,STORE_GLOBAL:R};var s=(/* unused pure expression or super */ null && (["ko","en","ja","id"]));function g({env:t}){return {env:t,locales:s,domain:o=>e[o][t]}}function N({env:t,override:o={}}){return Object.entries(e).reduce((a,[h,i])=>{var p;let r=h;return a[r]=(p=o[r])!=null?p:i[t],a},{})}


//# sourceMappingURL=out.js.map
//# sourceMappingURL=index.mjs.map
;// CONCATENATED MODULE: ./src/common/config.ts
var _process$env$APP_PROF, _HOST$match$, _HOST$match;



/**
 * 운영 환경
 * @example local, dev, prod
 */
var APP_PROFILE = (_process$env$APP_PROF = "prod") !== null && _process$env$APP_PROF !== void 0 ? _process$env$APP_PROF : 'local';
/**
 * 앱 이름
 */

var APP_NAME = 'event-web';
/**
 * 앱 버전
 */

var APP_VERSION = "24.23.0";
var HOST = "https://events.ohou.se";
var DOMAINS = N({
  env: APP_PROFILE === 'local' ? (_HOST$match$ = (_HOST$match = HOST.match(/(dev|stage|qa)/)) === null || _HOST$match === void 0 ? void 0 : _HOST$match[0]) !== null && _HOST$match$ !== void 0 ? _HOST$match$ : 'dev' : APP_PROFILE,
  override: {
    EVENTS: APP_PROFILE === 'local' ? HOST : undefined
  }
});
;// CONCATENATED MODULE: ./src/common/url.ts
var EVENT_SELF_PORT =  false ? 0 : '';
var OHS_HOST = "https://ohou.se" || 0;
var EVENT_HOST = "https://events.ohou.se" || 0;
var STORE_HOST = "https://store.ohou.se" || 0;
var O2O_HOST = "https://o2o.ohou.se" || 0;
var PRO_HOST = (/* unused pure expression or super */ null && ("https://pro.ohou.se" || 0));
var CONTENT_HOST = "https://contents.ohou.se" || 0;
var PARTNERS_HOST = 'https://partners.ohou.se';
var EVENT_SELF_HOST =  false ? 0 // in production, we need to use localhost as a host to prevent long network hops
: "http://localhost".concat(EVENT_SELF_PORT !== '' ? ":".concat(EVENT_SELF_PORT) : '');
var API_GATEWAY_HOST = (/* unused pure expression or super */ null && ("https://api.ohou.se" || 0));
var SIGN_IN_URL = "".concat(OHS_HOST, "/users/sign_in?redirect_to=/events");
;// CONCATENATED MODULE: ./src/common/constants.ts
var ANDROID_KAKAO_SHARE_VERSION = '9.64.1';
var REDIRECT_PATH = '/promotions/big-promotion';
var ONE_SECOND = 1000;
var ONE_MINUTE = 60 * ONE_SECOND;
var ONE_HOUR = 60 * ONE_MINUTE;
var ONE_DAY = 24 * ONE_HOUR;
var ZINDEX = {
  TAB: 100,
  MODAL: 1300
};
// EXTERNAL MODULE: ./node_modules/.pnpm/winston@3.15.0/node_modules/winston/dist/winston.js
var winston = __webpack_require__(28634);
;// CONCATENATED MODULE: ./src/common/logger.ts
 // https://docs.datadoghq.com/logs/log_collection/nodejs/?tab=winston30

var logger = (0,winston.createLogger)({
  level: 'info',
  exitOnError: false,
  format: winston.format.json(),
  transports: [new winston.transports.Console({
    format: winston.format.json()
  })]
});
/* harmony default export */ var common_logger = ((/* unused pure expression or super */ null && (logger)));
;// CONCATENATED MODULE: ./src/common/index.ts





/***/ }),

/***/ 7799:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "c": function() { return /* binding */ sessionManager; }
});

;// CONCATENATED MODULE: ./node_modules/.pnpm/@bucketplace+jwt-auth@1.8.0_ky@1.1.3/node_modules/@bucketplace/jwt-auth/dist/index.mjs
// https://www.notion.so/ohouse/auth-v1-refresh-4d1cea1de610404e910035924e3eae79
const API_PATH_POST_REFRESH_JWT = '/user/v1/auth/refresh';

const ACCESS_TOKEN_COOKIE_NAME = 'ohouse-aat';
const ACCESS_TOKEN_EXPIRY_COOKIE_NAME = 'ohouse-aat-expiry';
const REFRESH_TOKEN_COOKIE_NAME = 'ohouse-art';
// See: https://ohouse.atlassian.net/browse/OHSWEB-3430
// See also: https://www.notion.so/ohouse/Web-JWT-compliance-c0c7a1349e9b462d803aa6b4bf12a00b?pvs=4#45bca8f1d5684030961d7b39dd2d879a
const JWT_AUTH_MARKER_HEADER_NAME = 'x-ohouse-amk';
const DEFAULT_JWT_EXPIRATION_SAFE_MARGIN = (/* unused pure expression or super */ null && (1000 * 60)); // 1 min in milliseconds
// We are only allowed to set up to 400 days of expiration time for cookies.
// See: https://developer.chrome.com/blog/cookie-max-age-expires
const DEFAULT_SESSION_EXPIRATION_TIME = (/* unused pure expression or super */ null && (60 * 60 * 24 * 400)); // 400 days in seconds

class InvalidTokenError extends Error {
}
InvalidTokenError.prototype.name = "InvalidTokenError";
function b64DecodeUnicode(str) {
    return decodeURIComponent(atob(str).replace(/(.)/g, (m, p) => {
        let code = p.charCodeAt(0).toString(16).toUpperCase();
        if (code.length < 2) {
            code = "0" + code;
        }
        return "%" + code;
    }));
}
function base64UrlDecode(str) {
    let output = str.replace(/-/g, "+").replace(/_/g, "/");
    switch (output.length % 4) {
        case 0:
            break;
        case 2:
            output += "==";
            break;
        case 3:
            output += "=";
            break;
        default:
            throw new Error("base64 string is not of the correct length");
    }
    try {
        return b64DecodeUnicode(output);
    }
    catch (err) {
        return atob(output);
    }
}
function jwtDecode(token, options) {
    if (typeof token !== "string") {
        throw new InvalidTokenError("Invalid token specified: must be a string");
    }
    options || (options = {});
    const pos = options.header === true ? 0 : 1;
    const part = token.split(".")[pos];
    if (typeof part !== "string") {
        throw new InvalidTokenError(`Invalid token specified: missing part #${pos + 1}`);
    }
    let decoded;
    try {
        decoded = base64UrlDecode(part);
    }
    catch (e) {
        throw new InvalidTokenError(`Invalid token specified: invalid base64 for part #${pos + 1} (${e.message})`);
    }
    try {
        return JSON.parse(decoded);
    }
    catch (e) {
        throw new InvalidTokenError(`Invalid token specified: invalid json for part #${pos + 1} (${e.message})`);
    }
}

// JWT token validation algorithm:
// https://datatracker.ietf.org/doc/html/rfc7519#section-7.2
//
// Note: Since JWT uses "Base64 encoding with url", it will not include `=` for
// padding in the encoding of JWT’s.
// https://datatracker.ietf.org/doc/html/rfc4648#section-5
const JWT_REGEX = /^[A-Za-z0-9_-]{2,}(?:\.[A-Za-z0-9_-]{2,}){2}$/;
/**
 * Check if the input string is a valid JWT token.
 *
 * @param input The input string to check.
 * @returns `true` if the input is a valid JWT token, `false` otherwise.
 */
function isJwtToken(input) {
    return JWT_REGEX.test(input);
}
/**
 * Parse the input string as JWT token.
 *
 * @param input The input string to parse as JWT token.
 * @returns The parsed JWT token, or `undefined` if the input is not a valid JWT token.
 */
function parseJwtToken(input) {
    try {
        const payload = jwtDecode(input);
        // [RFC7519](https://www.rfc-editor.org/rfc/rfc7519#section-4.1.4) states
        // that `exp` is defined as the number of seconds, however `Date`
        // constructor accepts unix timestamp which is milliseconds.
        // So we need to multiply it by 1000.
        const expiresAt = new Date(payload.exp * 1000);
        return {
            raw: input,
            payload,
            expiresAt,
        };
    }
    catch (err) {
        return undefined;
    }
}
/**
 * Check if the date is expired.
 *
 * @param date The timestamp to check if it is expired.
 * @param safeMargin The safe margin in milliseconds that subtracted from the current time to consider the token as expired.
 * @returns `true` if the token is expired, `false` otherwise.
 */
function isDateExpired(date, safeMarginMs = DEFAULT_JWT_EXPIRATION_SAFE_MARGIN) {
    // `safeMarginMs` is used to prevent the token from being considered as valid
    // when the system clock is not accurate. e.g., Unix leap seconds, internet
    // time synchronization, etc.
    return date.getTime() <= (Date.now() + safeMarginMs);
}
/**
 * Check if the JWT token is expired.
 *
 * @param token The JWT token to check.
 * @param safeMargin The safe margin in milliseconds that subtracted from the current time to consider the token as expired.
 * @returns `true` if the token is expired, `false` otherwise.
 */
function isJwtTokenExpired(token, safeMarginMs) {
    // `safeMarginMs` is used to prevent the token from being considered as valid
    // when the system clock is not accurate. e.g., Unix leap seconds, internet
    // time synchronization, etc.
    return isDateExpired(token.expiresAt, safeMarginMs);
}

class Signal {
    constructor() {
        Object.defineProperty(this, "currentRun", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "locked", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "slots", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "buffer", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "busyRunning", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "busyRunningQueue", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "beforeEmitHooks", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "afterEmitHooks", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.currentRun = 0;
        this.locked = 0;
        this.slots = new Map();
        this.buffer = [];
        this.busyRunning = 0;
        this.busyRunningQueue = [];
        this.beforeEmitHooks = new Set();
        this.afterEmitHooks = new Set();
    }
    /**
     * Get all slots currently registered.
     */
    getSlots() {
        return this.slots;
    }
    /**
     * Get current buffer values.
     */
    getCurrentBuffer() {
        return this.buffer;
    }
    /**
     * Check if the buffer is empty.
     */
    isBufferEmpty() {
        return this.buffer.length < 1;
    }
    /**
     * Increase the lock count by 1.
     */
    lock() {
        this.locked++;
    }
    /**
     * Decrease the lock count by 1.
     */
    unlock() {
        this.locked--;
        this.flushBuffer();
    }
    /**
     * Starts a transaction that will automatically wraps the given callback `fn`
     * with locks and flush once all done.
     *
     * @param fn A callback invoked on the transaction starts.
     * @param parallel Whether to continue through without waiting for the `fn` to complete.
     */
    async transact(fn, parallel) {
        this.locked++;
        try {
            // When `parallel` options is set, it will not wait for the promise
            // returned by the `fn` to complete, resulting the `finally` statement to
            // be called as quickly as possible regardless of the promise is
            // fulfilled.
            //
            // Otherwise, it will wait for the returned promise before unlocking.
            if (parallel) {
                return fn();
            }
            else {
                return await fn();
            }
        }
        finally {
            this.locked--;
            this.flushBuffer();
        }
    }
    /**
     * Registers a callback to the slots.
     *
     * Note that, you can't register the same callback already registered to its
     * identity to prevent shadowing, which is no-op.
     *
     * However, you can still register the same callback within the same callback
     * while running itself.
     *
     * @param fn a slot function.
     */
    register(fn, options) {
        var _a, _b, _c, _d;
        // Prevent registering duplicates to not mistakenly run into race-conditions
        // in some circumstances.
        if (!this.slots.has(fn)) {
            this.slots.set(fn, {
                callback: fn,
                once: (_a = options === null || options === void 0 ? void 0 : options.once) !== null && _a !== void 0 ? _a : false,
                takeLatest: (_b = options === null || options === void 0 ? void 0 : options.takeLatest) !== null && _b !== void 0 ? _b : false,
                parallel: (_c = options === null || options === void 0 ? void 0 : options.parallel) !== null && _c !== void 0 ? _c : false,
                receiveTeardown: (_d = options === null || options === void 0 ? void 0 : options.receiveTeardownValue) !== null && _d !== void 0 ? _d : false,
            });
            this.flushBuffer();
        }
        return fn;
    }
    /**
     * Removes the given callback from the slots.
     *
     * This will not remove a slot that is being flushed in current run.
     */
    unregister(fn) {
        return this.slots.delete(fn);
    }
    /**
     * Clear out all registered callbacks from the slots.
     */
    unregisterAll() {
        this.slots.clear();
    }
    /**
     * Returns a promise that will be fulfilled once the signal is emitted.
     *
     * This is effectively a convenient wrapper over calling
     * `register(resolve, options)` in promise executor.
     *
     * If `fn` is provided, it will return promise that also waits for
     * the `fn` to complete. This is useful for situation where you want to
     * process only single instance of slots at a time.
     *
     * By default, `fn` will not be called when the emit value has been teardown.
     *
     * @param fn An optional callback that will be called while processing values.
     * @param options The options.
     */
    async waitOnce(fn, options) {
        return new Promise((resolve, reject) => {
            var _a, _b, _c, _d;
            const resolveEmpty = (_a = options === null || options === void 0 ? void 0 : options.resolveEmpty) !== null && _a !== void 0 ? _a : false;
            const cb = async (value, meta) => {
                if (fn != null) {
                    try {
                        // Just forward the value after execution of the handler.
                        resolve(await fn(value, meta));
                    }
                    catch (err) {
                        reject(err);
                    }
                }
                else {
                    resolve(value);
                }
            };
            if (resolveEmpty && this.isBufferEmpty()) {
                cb(undefined, {
                    index: -1,
                    length: -1,
                    currentRun: -1,
                    teardown: false,
                    tag: undefined,
                    isLast: true,
                    extra: undefined,
                });
                return;
            }
            this.slots.set(cb, {
                callback: cb,
                once: true,
                takeLatest: (_b = options === null || options === void 0 ? void 0 : options.takeLatest) !== null && _b !== void 0 ? _b : false,
                parallel: (_c = options === null || options === void 0 ? void 0 : options.parallel) !== null && _c !== void 0 ? _c : false,
                // Unless otherwise set, the `cb` will be called only when non-teardown value is emitted.
                receiveTeardown: (_d = options === null || options === void 0 ? void 0 : options.receiveTeardownValue) !== null && _d !== void 0 ? _d : false,
            });
            this.flushBuffer();
        });
    }
    /**
     * Emit a value of type.
     *
     * @param value A value to emit.
     * @param options Options for value emit.
     */
    emit(value, options) {
        return new Promise((resolve) => {
            var _a;
            const discard = (_a = options === null || options === void 0 ? void 0 : options.discardOnNoReceivers) !== null && _a !== void 0 ? _a : false;
            if (discard && this.slots.size < 1) {
                resolve();
                return;
            }
            this.buffer.push([value, { ...options }, resolve]);
            this.flushBuffer();
        });
    }
    /**
     * Register a hook that will be called right before the signal emits, which
     * can prevent the signal from firing values by returning `false`.
     *
     * If `false` is returned, the given value will be marked as `teardown` and will
     * be excluded from emitting.
     *
     * @param fn A callback that can be used to abort the signal from firing
     * values.
     * @returns A function to unregister the hook.
     */
    beforeEmit(fn) {
        if (!this.beforeEmitHooks.has(fn)) {
            this.beforeEmitHooks.add(fn);
        }
        return () => {
            this.beforeEmitHooks.delete(fn);
        };
    }
    /**
     * Register a hook that will be called after the signal emits.
     *
     * @param fn A callback that will be called after the signal emits.
     * @returns A function to unregister the hook.
     */
    afterEmit(fn) {
        if (!this.afterEmitHooks.has(fn)) {
            this.afterEmitHooks.add(fn);
        }
        return () => {
            this.afterEmitHooks.delete(fn);
        };
    }
    /**
     * Discards all buffer content.
     */
    discardBuffer() {
        this.buffer = [];
    }
    wrapHooks(fn) {
        return async (value, meta) => {
            let cancelExecution = meta.teardown;
            if (!cancelExecution) {
                for (const beforeEmit of this.beforeEmitHooks) {
                    const result = await beforeEmit(value, meta);
                    if (typeof result === 'boolean' && !result) {
                        cancelExecution = true;
                        break;
                    }
                }
            }
            await fn(value, { ...meta, teardown: cancelExecution });
            for (const afterEmit of this.afterEmitHooks) {
                await afterEmit(value, meta);
            }
        };
    }
    async flushBuffer() {
        var _a;
        const { locked, buffer, slots, currentRun, busyRunningQueue, } = this;
        const curRun = currentRun + 1;
        if (locked > 0 || buffer.length < 1 || slots.size < 1) {
            return;
        }
        this.currentRun = curRun;
        this.buffer = [];
        const snapshotSlots = new Map(slots);
        for (const { callback, once } of snapshotSlots.values()) {
            // We need to clean up all once(ephemeral) slots for next run
            if (once) {
                slots.delete(callback);
            }
        }
        // If there's already another instance of `flushBuffer()` is running, we
        // need to wait for it to complete.
        if (this.busyRunning > 0) {
            await new Promise((resolve) => {
                busyRunningQueue.push(resolve);
            });
        }
        this.busyRunning++;
        const runWithHook = this.wrapHooks(async (value, meta) => {
            const { teardown, isLast } = meta;
            for (const { callback, once, parallel, takeLatest, receiveTeardown } of snapshotSlots.values()) {
                if ((teardown && !receiveTeardown) || (takeLatest && !isLast)) {
                    continue;
                }
                if (once && snapshotSlots.has(callback)) {
                    snapshotSlots.delete(callback);
                }
                // Handles a thenable, so the user logic must not rely on the synchronous callback invocation.
                if (parallel) {
                    callback(value, meta);
                }
                else {
                    await callback(value, meta);
                }
            }
        });
        // Iterate over buffer in a FIFO-ish manner then calling over listeners respectively.
        for (const [index, [value, options, callback]] of buffer.entries()) {
            await runWithHook(value, {
                index,
                length: buffer.length,
                currentRun: curRun,
                teardown: (_a = options.markAsTeardown) !== null && _a !== void 0 ? _a : false,
                tag: options.tag,
                isLast: index === buffer.length - 1,
                extra: options.extra,
            });
            if (callback != null) {
                callback();
            }
        }
        this.busyRunning--;
        // Exhaust the next element remaining in the queue.
        if (this.busyRunning < 1 && busyRunningQueue.length > 0) {
            const next = busyRunningQueue.shift();
            next();
        }
    }
}

/* eslint-disable @typescript-eslint/no-explicit-any, no-console */
const LOG_SEVERITY_MAP = {
    off: 0,
    error: 1,
    warn: 2,
    info: 3,
    debug: 4,
};
class AbstractLogger {
    constructor(logLevel) {
        Object.defineProperty(this, "logLevel", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "lastLoggedMap", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.logLevel = logLevel !== null && logLevel !== void 0 ? logLevel : 'off';
        this.lastLoggedMap = {
            off: 0,
            debug: 0,
            info: 0,
            warn: 0,
            error: 0,
        };
    }
    setLogLevel(level) {
        this.logLevel = level;
    }
    debug(message, ...args) {
        if (this.shouldLog('debug')) {
            this.writeDebug({ delta: this.calcDeltaMs('debug') }, message, ...args);
        }
    }
    info(message, ...args) {
        if (this.shouldLog('info')) {
            this.writeInfo({ delta: this.calcDeltaMs('info') }, message, ...args);
        }
    }
    warn(message, ...args) {
        if (this.shouldLog('warn')) {
            this.writeWarn({ delta: this.calcDeltaMs('warn') }, message, ...args);
        }
    }
    error(message, ...args) {
        if (this.shouldLog('error')) {
            this.writeError({ delta: this.calcDeltaMs('error') }, message, ...args);
        }
    }
    shouldLog(level) {
        return LOG_SEVERITY_MAP[level] <= LOG_SEVERITY_MAP[this.logLevel];
    }
    calcDeltaMs(level) {
        const now = Date.now();
        const delta = now - this.lastLoggedMap[level];
        this.lastLoggedMap[level] = now;
        return delta;
    }
}
class NoopLogger {
    debug(_message, ..._args) {
        // noop
    }
    info(_message, ..._args) {
        // noop
    }
    warn(_message, ..._args) {
        // noop
    }
    error(_message, ..._args) {
        // noop
    }
}
class ConsoleLogger extends AbstractLogger {
    constructor(options) {
        var _a, _b;
        super(options === null || options === void 0 ? void 0 : options.logLevel);
        Object.defineProperty(this, "options", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "isBrowser", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: typeof window !== 'undefined'
        });
        this.options = {
            banner: (_a = options === null || options === void 0 ? void 0 : options.banner) !== null && _a !== void 0 ? _a : 'JwtAuth',
            colors: (_b = options === null || options === void 0 ? void 0 : options.colors) !== null && _b !== void 0 ? _b : true,
        };
    }
    writeDebug(context, message, ...args) {
        console.debug(`${this.isBrowser ? '' : '[DEBUG]'}[${this.options.banner}] ${message}  ${this.formatDelta(context.delta)}`, ...args);
    }
    writeInfo(context, message, ...args) {
        console.info(`${this.isBrowser ? '' : '[INFO]'}[${this.options.banner}] ${message}  ${this.formatDelta(context.delta)}`, ...args);
    }
    writeWarn(context, message, ...args) {
        console.warn(`${this.isBrowser ? '' : '[WARN]'}[${this.options.banner}] ${message}  ${this.formatDelta(context.delta)}`, ...args);
    }
    writeError(context, message, ...args) {
        console.error(`${this.isBrowser ? '' : '[ERROR]'}[${this.options.banner}] ${message}  ${this.formatDelta(context.delta)}`, ...args);
    }
    formatDelta(delta) {
        const cappedDelta = Math.min(delta, 9999);
        return `+${cappedDelta}ms`;
    }
}

/**
 * Parse a cookie string into a key-value object.
 *
 * @param input A cookie string.
 * @returns A key-value cookie object.
 */
function parseCookie(input) {
    const trimmed = input.trim();
    if (trimmed === '') {
        return {};
    }
    return trimmed
        .split(';')
        .map((record) => parseCookieEntry(record))
        .reduce((acc, [key, value]) => {
        if (key == null || value == null) {
            return acc;
        }
        acc[key.trim()] = value.trim();
        return acc;
    }, {});
}
/**
 * Parse a Set-Cookie header value into a tuple.
 *
 * @param input A Set-Cookie header value.
 * @returns A tuple of name, value, and attributes.
 */
function parseSetCookieEntry(input) {
    const trimmed = input.trim();
    if (trimmed === '') {
        return undefined;
    }
    const [nameValue, ...attributes] = trimmed.split(';');
    if (nameValue == null) {
        return undefined;
    }
    const [name, value] = nameValue.split('=');
    if (name == null || value == null) {
        return undefined;
    }
    return [name.trim(), value.trim(), parseSetCookieAttributes(attributes)];
}
/**
 * Parse the attributes of a Set-Cookie header value.
 *
 * @param raw The raw string attributes of a Set-Cookie header value.
 * @returns The parsed attributes.
 */
function parseSetCookieAttributes(raw) {
    var _a;
    const parsedAttributes = raw
        .map((record) => parseCookieEntry(record))
        .reduce((acc, [key, value]) => {
        var _a;
        if (key == null) {
            return acc;
        }
        acc[key.trim().toLowerCase()] = (_a = value === null || value === void 0 ? void 0 : value.trim()) !== null && _a !== void 0 ? _a : '';
        return acc;
    }, {});
    const attributes = {};
    if (parsedAttributes['domain'] != null) {
        attributes.domain = parsedAttributes['domain'];
    }
    if (parsedAttributes['expires'] != null) {
        attributes.expires = new Date(parsedAttributes['expires']);
    }
    if (parsedAttributes['httponly'] != null) {
        attributes.httpOnly = true;
    }
    if (parsedAttributes['max-age'] != null) {
        const parsed = Number.parseInt(parsedAttributes['max-age'], 10);
        if (!Number.isNaN(parsed)) {
            attributes.maxAge = parsed;
        }
    }
    if (parsedAttributes['path'] != null) {
        attributes.path = parsedAttributes['path'];
    }
    if (parsedAttributes['partitioned'] != null) {
        attributes.partitioned = true;
    }
    if (parsedAttributes['secure'] != null) {
        attributes.secure = true;
    }
    const sameSiteAttr = (_a = parsedAttributes['samesite']) === null || _a === void 0 ? void 0 : _a.toLowerCase();
    if (sameSiteAttr != null && ['strict', 'lax', 'none'].includes(sameSiteAttr)) {
        attributes.sameSite = sameSiteAttr;
    }
    return attributes;
}
/**
 * Extract the set-cookie entries from the raw set-cookie content.
 */
function parseSetCookieEntries(input) {
    return input.reduce((res, sc) => {
        const parsed = parseSetCookieEntry(sc);
        if (parsed == null) {
            return res;
        }
        res.push(parsed);
        return res;
    }, []);
}
/**
 * Stringify a key-value cookie object into a cookie string.
 *
 * @param input A key-value cookie object.
 * @returns A cookie string.
 */
function stringifyCookie(input) {
    return Object.entries(input)
        .map(([key, value]) => `${key}=${value}`.trim())
        .join('; ');
}
/**
 * Delete cookie values from a cookie string.
 *
 * @param input A cookie string.
 * @param names Cookie names to delete.
 * @returns The cookie string with the specified cookie names deleted.
 */
function eraseCookie(input, names) {
    const trimmed = input.trim();
    if (trimmed === '') {
        return '';
    }
    const filtered = trimmed
        .split(';')
        .map((record) => parseCookieEntry(record))
        .filter(([key, value]) => {
        if (key == null || value == null) {
            return false;
        }
        return !names.includes(key.trim());
    });
    return filtered
        // Preserve the original encoding.
        .map(([key, value]) => `${key}=${value}`.trim())
        .join('; ');
}
function parseCookieEntry(input) {
    const [key, ...values] = input.split('=');
    return [key, values.length < 1 ? undefined : values.join('=')];
}
/**
 * Create a Set-Cookie header value from the specified parameters.
 * @param name The cookie name.
 * @param value The cookie value.
 * @param attributes The cookie attributes.
 * @returns A Set-Cookie header value string.
 */
function createSetCookieEntry(name, value, attributes) {
    const parts = [`${name}=${value}`];
    if ((attributes === null || attributes === void 0 ? void 0 : attributes.domain) != null) {
        parts.push(`Domain=${attributes.domain}`);
    }
    if ((attributes === null || attributes === void 0 ? void 0 : attributes.expires) != null) {
        parts.push(`Expires=${attributes.expires.toUTCString()}`);
    }
    if ((attributes === null || attributes === void 0 ? void 0 : attributes.httpOnly) != null) {
        parts.push('HttpOnly');
    }
    if ((attributes === null || attributes === void 0 ? void 0 : attributes.maxAge) != null) {
        parts.push(`Max-Age=${attributes.maxAge}`);
    }
    if ((attributes === null || attributes === void 0 ? void 0 : attributes.path) != null) {
        parts.push(`Path=${attributes.path}`);
    }
    if ((attributes === null || attributes === void 0 ? void 0 : attributes.partitioned) != null) {
        parts.push('Partitioned');
    }
    if ((attributes === null || attributes === void 0 ? void 0 : attributes.secure) != null) {
        parts.push('Secure');
    }
    if ((attributes === null || attributes === void 0 ? void 0 : attributes.sameSite) != null) {
        parts.push(`SameSite=${attributes.sameSite}`);
    }
    return parts.join('; ');
}
const MAKE_COOKIE_EXPIRED_ATTRIBUTES = {
    expires: new Date(0),
    maxAge: undefined,
};
// Note that attributes must match with the original cookie.
// Otherwise, the browser may not delete the cookie.
function createExpiredSetCookieEntry(name, attributes) {
    return createSetCookieEntry(name, '', { ...attributes, ...MAKE_COOKIE_EXPIRED_ATTRIBUTES });
}
/**
 * Extend a cookie string with the specified cookie object.
 *
 * @param cookie The cookie string to extend.
 * @param cookies The cookie object to extend.
 * @returns The extended cookie string.
 */
function extendCookie(cookie, cookies) {
    const cookieKeys = Object.keys(cookies);
    return `${eraseCookie(cookie, cookieKeys)}; ${stringifyCookie(cookies)}`;
}
/**
 * Extend a cookie within the specified headers with the specified cookie object.
 *
 * @param headers The headers to extend.
 * @param cookies The cookie object to extend.
 * @param replace Whether to replace the original cookie fully.
 * @returns The extended headers.
 */
function extendHeadersCookie(headers, cookies, replace) {
    const cookieKeys = Object.keys(cookies);
    if (cookieKeys.length < 1) {
        return headers;
    }
    const newHeaders = new Headers(headers);
    if (newHeaders.has('cookie') && !replace) {
        newHeaders.set('cookie', extendCookie(newHeaders.get('cookie'), cookies));
    }
    else {
        newHeaders.set('cookie', stringifyCookie(cookies));
    }
    return newHeaders;
}

function delay(ms) {
    return new Promise((resolve) => setTimeout(resolve, ms));
}
function createDeferred() {
    let cb;
    const p = new Promise((r) => (cb = r));
    return [p, cb];
}

class AbortError extends Error {
    constructor(message) {
        super();
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: 'AbortError'
        });
        Object.defineProperty(this, "originalError", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        if (message instanceof Error) {
            this.originalError = message;
            this.message = message.message;
        }
        else {
            const formatted = `Retry aborted: ${message !== null && message !== void 0 ? message : 'N/A'}`;
            this.originalError = new Error(formatted);
            this.originalError.stack = this.stack;
            this.message = formatted;
        }
    }
}
/**
 * A generic retry function.
 *
 * @param fn The function to retry, which can be async. The function will be called with `attemptCount` (starts from 0).
 * @param options Retry options.
 * @returns The return value of `fn`.
 * @throws {Error} If the retry limit is reached.
 * @throws {AbortError} If the retry is aborted.
 */
async function retry(fn, options) {
    var _a, _b, _c, _d;
    const retryLimit = (_a = options === null || options === void 0 ? void 0 : options.limit) !== null && _a !== void 0 ? _a : 2;
    const backoffLimit = (_b = options === null || options === void 0 ? void 0 : options.backoffLimit) !== null && _b !== void 0 ? _b : Infinity;
    let retryCount = 0;
    for (;;) {
        try {
            return await fn(retryCount, retryLimit);
        }
        catch (err) {
            if (retryCount >= retryLimit || err instanceof AbortError) {
                throw err;
            }
            retryCount++;
            const delayMs = (_d = (_c = options === null || options === void 0 ? void 0 : options.delay) === null || _c === void 0 ? void 0 : _c.call(options, retryCount)) !== null && _d !== void 0 ? _d : calculateDefaultDelay(retryCount);
            if (delayMs > 0) {
                await delay(Math.min(delayMs, backoffLimit));
            }
        }
    }
}
function calculateDefaultDelay(attemptCount) {
    return 0.3 * (2 ** (attemptCount - 1)) * 1000;
}

const MAX_SAFE_TIMEOUT = 2147483647;
class HttpError extends Error {
    constructor(response, request, options) {
        var _a;
        const code = response.status || response.status === 0 ? response.status : '';
        const title = (_a = response.statusText) !== null && _a !== void 0 ? _a : '';
        const status = `${code} ${title}`.trim();
        const reason = status ? `status code ${status}` : 'an unknown error';
        super(`Request failed with ${reason}`);
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: 'HttpError'
        });
        Object.defineProperty(this, "response", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "request", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "options", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.response = response;
        this.request = request;
        this.options = options;
    }
}
class TimeoutError extends Error {
    constructor(request) {
        super('Request timed out');
        Object.defineProperty(this, "request", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.name = 'TimeoutError';
        this.request = request;
    }
}
/**
 * Shortcut method for GET requests.
 *
 * Note that `method` option from `RequestInput` or `RequestOptions` will be ignored.
 *
 * @param input Input for the request, can be a URL string, a `URL` object, or a `Request` object
 * @param options Request options
 * @returns The GET response
 */
async function get(input, options) {
    return request(input, { ...options, method: 'GET' });
}
/**
 * Shortcut method for POST requests.
 *
 * Note that `method` option from `RequestInput` or `RequestOptions` will be ignored.
 *
 * @param input Input for the request, can be a URL string, a `URL` object, or a `Request` object
 * @param options Request options
 * @returns The POST response
 */
async function post(input, options) {
    return request(input, { ...options, method: 'POST' });
}
/**
 * Shortcut method for PUT requests.
 *
 * Note that `method` option from `RequestInput` or `RequestOptions` will be ignored.
 *
 * @param input Input for the request, can be a URL string, a `URL` object, or a `Request` object
 * @param options Request options
 * @returns The PUT response
 */
async function put(input, options) {
    return request(input, { ...options, method: 'PUT' });
}
/**
 * Shortcut method for PATCH requests.
 *
 * Note that `method` option from `RequestInput` or `RequestOptions` will be ignored.
 *
 * @param input Input for the request, can be a URL string, a `URL` object, or a `Request` object
 * @param options Request options
 * @returns The PATCH response
 */
async function patch(input, options) {
    return request(input, { ...options, method: 'PATCH' });
}
/**
 * Shortcut method for DELETE requests.
 *
 * Note that `method` option from `RequestInput` or `RequestOptions` will be ignored.
 *
 * @param input Input for the request, can be a URL string, a `URL` object, or a `Request` object
 * @param options Request options
 * @returns The DELETE response
 */
async function del(input, options) {
    return request(input, { ...options, method: 'DELETE' });
}
/**
 * Shortcut method for HEAD requests.
 *
 * Note that `method` option from `RequestInput` or `RequestOptions` will be ignored.
 *
 * @param input Input for the request, can be a URL string, a `URL` object, or a `Request` object
 * @param options Request options
 * @returns The HEAD response
 */
async function head(input, options) {
    return request(input, { ...options, method: 'HEAD' });
}
/**
 * The base request method for all HTTP methods
 *
 * @param input Input for the request, can be a URL string, a `URL` object, or a `Request` object
 * @param options Request options
 * @returns The fetch response
 */
async function request(input, options) {
    var _a;
    if ((options === null || options === void 0 ? void 0 : options.timeout) != null && options.timeout > MAX_SAFE_TIMEOUT) {
        throw new RangeError(`The \`timeout\` option cannot be greater than ${MAX_SAFE_TIMEOUT}`);
    }
    const { fetch: fetchFn, timeout, throwHttpErrors, json, ...requestOptions } = normalizeRequestOptions(input, options);
    const abortController = new globalThis.AbortController();
    if ((options === null || options === void 0 ? void 0 : options.signal) != null) {
        const originalSignal = options.signal;
        options.signal.addEventListener('abort', () => {
            abortController.abort(originalSignal.reason);
        }, { once: true });
    }
    let requestDescriptor = new globalThis.Request(input, {
        ...requestOptions,
        signal: abortController.signal,
    });
    // `json` option accepts `null` as a value
    if (json !== undefined) {
        const body = JSON.stringify(json);
        requestDescriptor.headers.set('content-type', (_a = requestOptions.headers.get('content-type')) !== null && _a !== void 0 ? _a : 'application/json');
        requestDescriptor = new globalThis.Request(requestDescriptor, { body, headers: requestDescriptor.headers });
    }
    const handleRequest = async () => {
        const res = await fetchFn(requestDescriptor.clone());
        if (throwHttpErrors && !res.ok) {
            throw new HttpError(res, requestDescriptor.clone(), requestOptions);
        }
        return res;
    };
    if (timeout > 0) {
        return Promise.race([
            handleRequest(),
            (async () => {
                await delay(timeout);
                // Throw timeout error first
                setTimeout(() => abortController.abort(), 1);
                throw new TimeoutError(requestDescriptor.clone());
            })(),
        ]);
    }
    return handleRequest();
}
function normalizeRequestOptions(input, options) {
    var _a, _b, _c, _d, _e;
    return {
        ...options,
        method: (_b = ((_a = options === null || options === void 0 ? void 0 : options.method) !== null && _a !== void 0 ? _a : input.method)) === null || _b === void 0 ? void 0 : _b.toUpperCase(),
        headers: mergeHeaders(input.headers, options === null || options === void 0 ? void 0 : options.headers),
        credentials: (_c = options === null || options === void 0 ? void 0 : options.credentials) !== null && _c !== void 0 ? _c : 'include',
        throwHttpErrors: (options === null || options === void 0 ? void 0 : options.throwHttpErrors) !== false,
        timeout: Math.max((_d = options === null || options === void 0 ? void 0 : options.timeout) !== null && _d !== void 0 ? _d : 10000, 0),
        fetch: (_e = options === null || options === void 0 ? void 0 : options.fetch) !== null && _e !== void 0 ? _e : globalThis.fetch.bind(globalThis),
    };
}
function mergeHeaders(a = {}, b = {}) {
    const result = new globalThis.Headers(a);
    const source = new globalThis.Headers(b);
    for (const [key, value] of source.entries()) {
        if ((b instanceof globalThis.Headers && value === 'undefined') || value === undefined) {
            result.delete(key);
        }
        else {
            result.set(key, value);
        }
    }
    return result;
}

/**
 * This error that will be thrown by the user in order to state that the
 * authentication failed and the request should be retried with the valid token.
 */
class AuthError extends Error {
    /**
     * @param continueWithNoAuth If `true`, the request will continue with no token.
     */
    constructor(continueWithNoAuth = false) {
        super('Authentication failed.');
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: 'AuthError'
        });
        Object.defineProperty(this, "continueWithNoAuth", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.continueWithNoAuth = continueWithNoAuth;
    }
}
/**
 * Throw an `AuthError`.
 */
function throwAuthError() {
    throw new AuthError();
}
/**
 * Create a function that throw an `AuthError` if retry is possible.
 */
function createThrowAuthErrorIfPossible(canRetry) {
    return (assert) => {
        if (canRetry && (assert !== null && assert !== void 0 ? assert : true)) {
            throw new AuthError();
        }
        return false;
    };
}
/**
 * Create a wrapper function that will throw an `AuthError` if retry is possible.
 */
function createRetryAuth(canRetry) {
    return async (fn) => {
        if (canRetry) {
            throw new AuthError();
        }
        return fn === null || fn === void 0 ? void 0 : fn();
    };
}
/**
 * Internal auth error that will be thrown by the instance.
 */
class InternalAuthError extends Error {
    constructor(message) {
        super();
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: 'InternalAuthError'
        });
        Object.defineProperty(this, "originalError", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        if (message instanceof Error) {
            this.originalError = message;
            this.message = message.message;
        }
        else {
            const formatted = `InternalAuthError: ${message !== null && message !== void 0 ? message : 'N/A'}`;
            this.originalError = new Error(formatted);
            this.originalError.stack = this.stack;
            this.message = formatted;
        }
    }
}
/**
 * Parse the input string as JWT token expiry.
 *
 * @param input The input string to parse as JWT token expiry.
 * @returns The parsed JWT token expiry, or `undefined` if the input is not a valid JWT token expiry.
 */
function parseAuthTokenExpiry(input) {
    const parsed = Number.parseInt(input !== null && input !== void 0 ? input : '', 10);
    if (Number.isNaN(parsed)) {
        return undefined;
    }
    return new Date(parsed * 1000);
}
/**
 * Format the given JWT token expiry to be used as a cookie value.
 */
function formatAuthTokenExpiry(expiry) {
    return String(Math.floor(expiry.getTime() / 1000));
}
/**
 * Parse the input string as JWT token and check its validity.
 *
 * @param input The input string to parse as JWT token.
 * @returns The parsed JWT token, or `undefined` if the input is not a valid JWT token.
 */
function parseAuthToken(input) {
    if (input == null || input === '') {
        return undefined;
    }
    if (!isJwtToken(input)) {
        return undefined;
    }
    return parseJwtToken(input);
}
/**
 * Ensure the given domain to have a leading dot.
 * Following: https://www.rfc-editor.org/rfc/rfc6265#section-4.1.2.3
 */
function ensureCookieDomain(domain) {
    if (domain == null) {
        return undefined;
    }
    if (domain.startsWith('.')) {
        return domain;
    }
    return `.${domain}`;
}

function filterObject(input, filter, target = {}) {
    return Object.entries(input)
        .reduce((res, [key, value]) => {
        if (filter(value, key, input)) {
            res[key] = value;
            return res;
        }
        return res;
    }, target);
}

/**
 * Build headers for the token refresh api.
 */
function extendTokenRefreshHeaders(params) {
    const { refreshToken } = params.tokenSet;
    // If the refresh token is not provided, it indicates that the user is sending
    // a request from the client-side.
    // In such case, `credentials` option from `fetch()` api will automatically
    // include necessary credentials for us.
    // See: https://developer.mozilla.org/en-US/docs/Web/API/Fetch_API/Using_Fetch#sending_a_request_with_credentials_included
    if (refreshToken == null) {
        return params.headers;
    }
    const normalizedCookies = convertTokenSetIntoCookie(params.tokenSet);
    return extendHeadersCookie(params.headers, normalizedCookies);
}
/**
 * Convert the given token set into a cookie object.
 */
function convertTokenSetIntoCookie(tokenSet) {
    const { refreshToken, accessToken, accessTokenExpiry } = tokenSet;
    return filterObject({
        [REFRESH_TOKEN_COOKIE_NAME]: refreshToken === null || refreshToken === void 0 ? void 0 : refreshToken.raw,
        [ACCESS_TOKEN_COOKIE_NAME]: accessToken === null || accessToken === void 0 ? void 0 : accessToken.raw,
        [ACCESS_TOKEN_EXPIRY_COOKIE_NAME]: accessTokenExpiry != null
            ? formatAuthTokenExpiry(accessTokenExpiry)
            : undefined,
    }, (v) => v != null);
}
/**
 * Create auth headers for the given access token.
 */
function buildAuthHeaders(params) {
    var _a, _b;
    const tokenSet = (_a = params === null || params === void 0 ? void 0 : params.tokenSet) !== null && _a !== void 0 ? _a : {};
    const updateCookies = (_b = params === null || params === void 0 ? void 0 : params.updateCookies) !== null && _b !== void 0 ? _b : false;
    const authHeaders = new Headers(params === null || params === void 0 ? void 0 : params.baseHeaders);
    if (tokenSet.accessToken != null) {
        authHeaders.set('authorization', `Bearer ${tokenSet.accessToken.raw}`);
    }
    // We need to mark the request as it's authenticated with the jwt token in
    // order to differentiate it from the legacy auth.
    // See: https://ohouse.atlassian.net/browse/HOMEPL-1035
    // See also: https://ohouse.atlassian.net/browse/OHSWEB-3430
    authHeaders.set(JWT_AUTH_MARKER_HEADER_NAME, '1');
    // Extend headers with the normalized cookie object.
    return updateCookies
        ? extendHeadersCookie(authHeaders, convertTokenSetIntoCookie(tokenSet))
        : authHeaders;
}
/**
 * Build headers object with the given set-cookie entries.
 */
function createHeadersWithSetCookieEntries(params) {
    const headers = new Headers(params.baseHeaders);
    for (const entry of params.setCookieEntriesRaw) {
        headers.append('set-cookie', entry);
    }
    return headers;
}
/**
 * Build set-cookie entries for expiring auth tokens.
 */
function buildAuthExpirationSetCookieEntries(params) {
    var _a;
    const cookieDomain = ensureCookieDomain((_a = params.cookieOptions) === null || _a === void 0 ? void 0 : _a.cookieDomain);
    return [
        [ACCESS_TOKEN_COOKIE_NAME, '', {
                ...MAKE_COOKIE_EXPIRED_ATTRIBUTES,
                domain: cookieDomain,
                // Please refer to the discussion for more details
                // https://ohou-se.slack.com/archives/C05JQR22E13/p1701678839504499
                path: '/',
            }],
        [ACCESS_TOKEN_EXPIRY_COOKIE_NAME, '', {
                ...MAKE_COOKIE_EXPIRED_ATTRIBUTES,
                domain: cookieDomain,
                // Please refer to the discussion for more details
                // https://ohou-se.slack.com/archives/C05JQR22E13/p1701678839504499
                path: '/',
            }],
    ];
}
/**
 * Build set-cookie entries for setting auth tokens.
 *
 * Each token field can be `undefined`, and will be excluded from the resulting entries.
 */
function buildAuthSetCookieEntries(params) {
    var _a, _b, _c;
    const { refreshToken, accessToken, accessTokenExpiry } = params.tokenSet;
    const cookieDomain = ensureCookieDomain((_a = params.cookieOptions) === null || _a === void 0 ? void 0 : _a.cookieDomain);
    const maxAgeSecs = (_c = (_b = params.cookieOptions) === null || _b === void 0 ? void 0 : _b.maxAgeSecs) !== null && _c !== void 0 ? _c : DEFAULT_SESSION_EXPIRATION_TIME;
    const entries = [];
    // Append refresh token as cookie entry if any.
    if (refreshToken != null) {
        entries.push([
            REFRESH_TOKEN_COOKIE_NAME,
            refreshToken.raw,
            {
                domain: cookieDomain,
                maxAge: maxAgeSecs,
                // Please refer to the discussion for more details
                // https://ohou-se.slack.com/archives/C05JQR22E13/p1701678839504499
                path: '/',
            },
        ]);
    }
    // Append access token as cookie entry if any.
    if (accessToken != null) {
        entries.push([
            ACCESS_TOKEN_COOKIE_NAME,
            accessToken.raw,
            {
                domain: cookieDomain,
                maxAge: maxAgeSecs,
                path: '/',
                // FIXME: can we enable secure cookie? (investigation needed on local)
            },
        ]);
    }
    // Append access token's expiry as cookie entry if any.
    if (accessTokenExpiry != null) {
        entries.push([
            ACCESS_TOKEN_EXPIRY_COOKIE_NAME,
            formatAuthTokenExpiry(accessTokenExpiry),
            {
                domain: cookieDomain,
                maxAge: maxAgeSecs,
                path: '/',
            },
        ]);
    }
    else if ((accessToken === null || accessToken === void 0 ? void 0 : accessToken.expiresAt) != null) {
        // Fallback to the expiry from the access token if any.
        entries.push([
            ACCESS_TOKEN_EXPIRY_COOKIE_NAME,
            formatAuthTokenExpiry(accessToken.expiresAt),
            {
                domain: cookieDomain,
                path: '/',
            },
        ]);
    }
    return entries;
}

/**
 * Extract the refresh token from the response headers.
 */
function extractRefreshTokenFromSetCookie(input) {
    var _a;
    const setCookieEntries = parseSetCookieEntries(input);
    return (_a = setCookieEntries.find(([name]) => name === REFRESH_TOKEN_COOKIE_NAME)) === null || _a === void 0 ? void 0 : _a[1];
}

class JwtAuth {
    constructor(options) {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        Object.defineProperty(this, "options", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "logger", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "isTokenRefreshing", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "isTokenUpdating", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "sharedRefreshAttempts", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "fencingToken", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "signals", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.options = {
            cookieDomain: options.cookieDomain,
            keepSignedIn: (_a = options.keepSignedIn) !== null && _a !== void 0 ? _a : true,
            sessionMaxAgeSecs: (_b = options.sessionMaxAgeSecs) !== null && _b !== void 0 ? _b : DEFAULT_SESSION_EXPIRATION_TIME,
            retryLimit: (_c = options.retryLimit) !== null && _c !== void 0 ? _c : 3,
            maxTokenRefresh: (_d = options.maxTokenRefresh) !== null && _d !== void 0 ? _d : 3,
            resetRetryCount: (_e = options.resetRetryCount) !== null && _e !== void 0 ? _e : false,
            fetchHeaders: options.fetchHeaders,
            fetchCookie: options.fetchCookie,
            refreshApiFn: options.refreshApiFn,
            predicateTokenExpired: (_f = options.predicateTokenExpired) !== null && _f !== void 0 ? _f : defaultPredicateTokenExpired,
            filterHeaders: (_g = options.filterHeaders) !== null && _g !== void 0 ? _g : defaultFilterHeaders,
            onTokenUpdate: options.onTokenUpdate,
            onSessionExpired: options.onSessionExpired,
        };
        this.logger = (_h = options.logger) !== null && _h !== void 0 ? _h : new NoopLogger();
        this.isTokenRefreshing = false;
        this.isTokenUpdating = false;
        this.sharedRefreshAttempts = 0;
        this.fencingToken = 0;
        this.signals = {
            tokenRefreshSignal: new Signal(),
            tokenRefreshCompleteSignal: new Signal(),
            tokenUpdateSignal: new Signal(),
            tokenUpdateCompleteSignal: new Signal(),
            setTokenReadySignal: new Signal(),
        };
        this.signals.tokenRefreshSignal.register(async (options) => {
            this.logger.info('Token refresh triggered.');
            if (options == null) {
                return;
            }
            this.logger.debug('Commencing token refresh..., with options:', options);
            // The retry count must be incremented only once within the time window
            // when the handlers are being called.
            // So, we are increasing the retry count right in the trigger signal.
            this.sharedRefreshAttempts++;
            let context;
            try {
                context = await this.processTokenRefresh({
                    lastRun: this.isTokenRefreshLimitReached(),
                    headers: options.headers,
                    tokenSet: options.tokenSet,
                });
                this.logger.info('Token refresh context received.');
                this.logger.debug('Token refresh result: ', context);
            }
            finally {
                // Before the token refresh process is complete, handle the token update.
                await this.signals.setTokenReadySignal.emit(undefined, { discardOnNoReceivers: true });
                this.isTokenRefreshing = false;
            }
            // Wait for all waiting handlers to receive the new token.
            await this.signals.tokenRefreshCompleteSignal.emit(context, { discardOnNoReceivers: true });
            this.logger.info('Token refresh process finished.');
        }, { takeLatest: true });
        this.signals.tokenUpdateSignal.register(async (command) => {
            var _a, _b, _c, _d;
            this.logger.info('Commencing token update...');
            if (command == null) {
                return;
            }
            this.isTokenUpdating = true;
            this.logger.debug('Calling the user-defined token update callback, with command:', command);
            try {
                switch (command.type) {
                    case 'updateToken': {
                        await ((_b = (_a = this.options).onTokenUpdate) === null || _b === void 0 ? void 0 : _b.call(_a, command.descriptor));
                        break;
                    }
                    case 'setSessionExpired': {
                        await ((_d = (_c = this.options).onSessionExpired) === null || _d === void 0 ? void 0 : _d.call(_c, command.info));
                        break;
                    }
                    default: {
                        // noop
                    }
                }
            }
            catch (err) {
                this.logger.error('Token update failed:', err);
            }
            finally {
                this.isTokenUpdating = false;
                await this.signals.tokenUpdateCompleteSignal.emit(undefined, { discardOnNoReceivers: true });
            }
        }, { takeLatest: true });
    }
    /**
     * Check whether the user is signed in or not.
     *
     * @returns A promise that resolves with `true` if the user is signed in, `false` otherwise.
     */
    async isSignedIn() {
        if (this.isTokenUpdating) {
            await this.signals.tokenUpdateCompleteSignal.waitOnce();
        }
        const headers = await this.getHeaders();
        const cookies = await this.getCookies(headers);
        return parseAuthTokenExpiry(cookies[ACCESS_TOKEN_EXPIRY_COOKIE_NAME]) != null;
    }
    /**
     * Handle API requests with authentication.
     *
     * Throw an `AuthError` to indicate that token refresh is required.
     *
     * If the authentication process is failed, the `fn` function will be called
     * **again** with the empty context, so that the request can make progress
     * without authentication.
     *
     * @param fn The function to handle the request.
     * @returns A promise that resolves when the request is finished.
     */
    async handleAuth(fn, options) {
        var _a, _b, _c;
        this.logger.info('Invoking authorization handler...');
        if (this.isTokenUpdating) {
            this.logger.info('Waiting for the token update to complete.');
            await this.signals.tokenUpdateCompleteSignal.waitOnce();
        }
        this.logger.debug('Reading headers and cookies for the current authentication context...');
        const headers = await this.getHeaders();
        const cookies = await this.getCookies(headers);
        // Since we have restricted access to the actual access token from the
        // client-side, the only way to check if the user is logged in is to check
        // the expiry marker in the client-readable cookies.
        //
        // Please refer to this document for more details:
        // https://www.notion.so/ohouse/Web-JWT-compliance-c0c7a1349e9b462d803aa6b4bf12a00b?pvs=4#81136b92de00403790abe6ab5da4fe03
        this.logger.info('Checking if the session is active...');
        this.logger.info('Reading the expiration status of the access token (ohouse-aat-expiry) from the cookies...');
        const accessTokenExpiry = parseAuthTokenExpiry(cookies[ACCESS_TOKEN_EXPIRY_COOKIE_NAME]);
        if (accessTokenExpiry == null) {
            // The user is not logged in.
            //
            // Just continue with an empty context, so that
            // the user can proceed with unauthorized requests if possible.
            this.logger.info('The access token expiry (ohouse-aat-expiry) is not available in this context. Considering this session as a guest.');
            return fn(this.buildUnauthorizedJwtAuthContext({ headers, isGuest: true, canRetry: false }));
        }
        this.logger.info('The access token expiry (ohouse-aat-expiry) is present and valid in this context. Proceeding to the authorization process.');
        const runWithEmptyContext = async () => {
            try {
                return await fn(this.buildUnauthorizedJwtAuthContext({ headers, canRetry: false }));
            }
            catch (err) {
                // Throw abort error so that no retry will be performed.
                throw new AbortError(err);
            }
        };
        let currentRefreshToken = parseAuthToken(cookies[REFRESH_TOKEN_COOKIE_NAME]);
        let currentAccessToken = parseAuthToken(cookies[ACCESS_TOKEN_COOKIE_NAME]);
        let currentAccessTokenExpiry = accessTokenExpiry;
        let shouldOverrideNextRefresh = false;
        this.logger.debug(`Current tokens (raw): RT=${(_a = currentRefreshToken === null || currentRefreshToken === void 0 ? void 0 : currentRefreshToken.raw) !== null && _a !== void 0 ? _a : 'N/A'} AT=${(_b = currentAccessToken === null || currentAccessToken === void 0 ? void 0 : currentAccessToken.raw) !== null && _b !== void 0 ? _b : 'N/A'} AT-EXP: ${(_c = currentAccessTokenExpiry === null || currentAccessTokenExpiry === void 0 ? void 0 : currentAccessTokenExpiry.toISOString()) !== null && _c !== void 0 ? _c : 'N/A'}`);
        this.logger.debug('Current tokens (actual):', currentRefreshToken, currentAccessToken, currentAccessTokenExpiry);
        return this.retryWithFencing(async (attemptCount) => {
            var _a;
            this.logger.info(`Running authorization process... (attempts: ${attemptCount})`);
            let context;
            const shouldRefresh = this.options.predicateTokenExpired({
                accessTokenExpiry: currentAccessTokenExpiry,
                accessToken: currentAccessToken === null || currentAccessToken === void 0 ? void 0 : currentAccessToken.raw,
                refreshToken: currentRefreshToken === null || currentRefreshToken === void 0 ? void 0 : currentRefreshToken.raw,
            });
            this.logger.info(`Check whether the current token is expired; current status: ${shouldRefresh ? '"expired"' : '"valid"'}, force refresh: ${(_a = options === null || options === void 0 ? void 0 : options.forceRefresh) !== null && _a !== void 0 ? _a : false}, override: ${shouldOverrideNextRefresh}`);
            if ((options === null || options === void 0 ? void 0 : options.forceRefresh) || shouldOverrideNextRefresh || shouldRefresh) {
                shouldOverrideNextRefresh = false;
                if (!this.options.keepSignedIn) {
                    this.logger.info('The application has opted not to maintain signed-in status, so the session will be marked as expired.');
                    await this.signals.tokenUpdateSignal.emit(createTokenExpirationCommand({
                        reason: 'noRevalidation',
                        cookieOptions: {
                            cookieDomain: this.options.cookieDomain,
                        },
                    }));
                    return runWithEmptyContext();
                }
                // If this instance is the first to trigger the token refresh.
                if (!this.isTokenRefreshing) {
                    this.isTokenRefreshing = true;
                    this.logger.info('No active token refresh process found; initiating token refresh.');
                    this.signals.tokenRefreshSignal.emit({
                        headers,
                        tokenSet: {
                            refreshToken: currentRefreshToken,
                            accessToken: currentAccessToken,
                            accessTokenExpiry: currentAccessTokenExpiry,
                        },
                    });
                }
                this.logger.info('Waiting for completion of the current token refresh process...');
                const result = await this.signals.tokenRefreshCompleteSignal.waitOnce();
                if (result == null) {
                    this.logger.error('Received invalid context from the token refresh process.');
                    throw new InternalAuthError();
                }
                this.logger.info('Token refresh process completed, proceeding with the new set of tokens.');
                // Set the new access/refresh tokens for next rounds.
                currentRefreshToken = result.refreshTokenParsed;
                currentAccessToken = result.accessTokenParsed;
                currentAccessTokenExpiry = result.accessTokenExpiry;
                context = result;
            }
            else {
                this.logger.info('Token refresh is not required, proceeding with the current set of tokens.');
                // There are some cases where the access token is in fact invalid even
                // when the expiry is not reached due to server-side errors.
                // So we mark the next refresh is required when the access token is considered already valid.
                shouldOverrideNextRefresh = true;
                context = this.buildAuthorizedJwtAuthContext({
                    lastRun: this.isTokenRefreshLimitReached(),
                    headers,
                    tokenSet: {
                        accessToken: currentAccessToken,
                        refreshToken: currentRefreshToken,
                        accessTokenExpiry: currentAccessTokenExpiry,
                    },
                });
            }
            try {
                this.logger.info('Running the user-defined authentication handler...');
                return await fn(context);
            }
            catch (err) {
                // Retry the request when the user requested the re-authentication.
                // This can happen when the access token is expired during the api calls.
                if (err instanceof AuthError) {
                    // If the user choose to continue with no auth, just continue with an empty context.
                    this.logger.error(`Failed to run user-defined authentication handler. (${attemptCount} attempts)`);
                    if (err.continueWithNoAuth) {
                        this.logger.warn('Resorting to the guest context as the user marked the request to continue without authentication.');
                        return runWithEmptyContext();
                    }
                    throw err;
                }
                // Otherwise, just bail with the error. All normal errors other than
                // `AuthError` must be thrown as-is.
                throw new AbortError(err);
            }
        });
    }
    /**
     * Get the authentication context.
     *
     * This method is useful when you only want to get the authentication context
     * without retrying the request.
     */
    async getAuthContext(options) {
        this.logger.info('Getting the authentication context...');
        return this.handleAuth(({ canRetry: _canRetry, retryAuth: _retryAuth, throwAuthError: _throwAuthError, throwAuthErrorIfPossible: _throwAuthErrorIfPossible, ...restCtx }) => ({ ...restCtx }), options);
    }
    /**
     * Trigger the access token refresh.
     *
     * This method is useful when you only want to trigger the token refresh
     * without retrying the request.
     */
    async refreshAccessToken(options) {
        this.logger.info('Triggering the access token refresh...');
        return this.handleAuth(() => { }, options);
    }
    /**
     * Set the access token.
     *
     * If the `token` parameter is `undefined` or **invalid**, it will be treated
     * as a sign-out operation.
     *
     * The setting of the access token is concurrency-controlled. If this method
     * is invoked during the token refresh process, it will be queued after the
     * other refresh process is complete.
     *
     * If you prefer not to wait for the refresh process to complete, you can omit
     * the `await` keyword when using the returned promise.
     *
     * Please note that this method will only work on the server-side since the
     * client-side cannot set the HttpOnly cookies with `set-cookie` header.
     *
     * @param token The access token to set. Use `undefined` to sign out.
     */
    async setAccessToken(token) {
        this.logger.info('Setting the access token manually...');
        if (this.isTokenRefreshing) {
            await this.signals.setTokenReadySignal.waitOnce();
        }
        // Make sure to prevent a new token refresh process from being triggered
        // until the token is updated.
        await this.signals.tokenRefreshSignal.transact(async () => {
            const parsedToken = parseAuthToken(token);
            const updateDescriptor = parsedToken != null
                ? createTokenUpdateCommand({
                    tokenSet: {
                        refreshToken: undefined,
                        accessToken: parsedToken,
                        accessTokenExpiry: parsedToken.expiresAt,
                    },
                    cookieOptions: {
                        cookieDomain: this.options.cookieDomain,
                        maxAgeSecs: this.options.sessionMaxAgeSecs,
                    },
                })
                : createTokenExpirationCommand({
                    reason: 'manualInvalidation',
                    cookieOptions: {
                        cookieDomain: this.options.cookieDomain,
                    },
                });
            await this.signals.tokenUpdateSignal.emit(updateDescriptor);
        });
    }
    /**
     * Reset the shared token refresh count, so that it allows the next refresh request to be retried.
     */
    resetSharedTokenRefreshCount() {
        this.sharedRefreshAttempts = 0;
    }
    async retryWithFencing(run) {
        const { fencingToken } = this;
        this.fencingToken++;
        try {
            return await retry(async (attemptCount, maxAttempts) => run(attemptCount, maxAttempts), {
                limit: this.options.retryLimit,
                // There must be no delay between the retries. Otherwise, the SSR will be delayed.
                delay: () => 0,
            });
        }
        catch (err) {
            if (err instanceof AbortError) {
                throw err.originalError;
            }
            throw err;
        }
        finally {
            // Reset the shared retry count if the current handler call is the last one
            // and there's no following handler calls.
            if (this.options.resetRetryCount && fencingToken === this.fencingToken) {
                this.sharedRefreshAttempts = 0;
            }
        }
    }
    isTokenRefreshLimitReached() {
        return this.sharedRefreshAttempts >= this.options.maxTokenRefresh;
    }
    async processTokenRefresh(options) {
        const refreshTokenCallHeaders = extendTokenRefreshHeaders({
            headers: options.headers,
            tokenSet: options.tokenSet,
        });
        const result = await this.requestTokenRefresh(refreshTokenCallHeaders);
        switch (result.type) {
            case 'failure': {
                // If the server has flagged the session as expired, mark the session as expired immediately.
                await this.signals.tokenUpdateSignal.emit(createTokenExpirationCommand({
                    reason: 'refreshFailed',
                    cookieOptions: {
                        cookieDomain: this.options.cookieDomain,
                    },
                }));
                return this.buildUnauthorizedJwtAuthContext({
                    headers: options.headers,
                    // We should treat the session expired as a guest session.
                    isGuest: true,
                    canRetry: false,
                });
            }
            case 'retry': {
                // If it's not the last run, just return `undefined` so that the upstream
                // can pick up to trigger retry.
                if (!options.lastRun) {
                    return undefined;
                }
                // The max retry limit is reached and all authentication attempts failed.
                // Notify that the session is expired and continue with an empty context.
                await this.signals.tokenUpdateSignal.emit(createTokenExpirationCommand({
                    reason: 'retryAttemptsFailed',
                    cookieOptions: {
                        cookieDomain: this.options.cookieDomain,
                    },
                }));
                return this.buildUnauthorizedJwtAuthContext({
                    headers: options.headers,
                    // We should treat the session expired as a guest session.
                    isGuest: true,
                });
            }
            case 'success': {
                const { data } = result;
                const tokenSet = {
                    refreshToken: data.refreshToken,
                    accessToken: data.accessToken,
                    accessTokenExpiry: data.accessTokenExpiry,
                };
                // Propagate the updated tokens.
                await this.signals.tokenUpdateSignal.emit(createTokenUpdateCommand({
                    headers: data.headers,
                    tokenSet,
                    useSetCookieAsIs: true,
                    cookieOptions: {
                        cookieDomain: this.options.cookieDomain,
                        maxAgeSecs: this.options.sessionMaxAgeSecs,
                    },
                }));
                return this.buildAuthorizedJwtAuthContext({
                    lastRun: options.lastRun,
                    headers: options.headers,
                    tokenSet,
                });
            }
            default: {
                throw new Error('Unreachable');
            }
        }
    }
    async requestTokenRefresh(headers) {
        try {
            const filteredHeaders = this.options.filterHeaders({ headers });
            const { body, headers: newHeaders } = await this.options.refreshApiFn({ headers: filteredHeaders });
            const newAccessToken = parseAuthToken(body.accessToken);
            if (newAccessToken == null) {
                return { type: 'retry' };
            }
            // Here we're extracting refresh token anyway regardless of the environment.
            // Since the client cannot access to the `set-cookie`, this is automatically no-op.
            //
            // In some runtime environments, the headers object does not have the `getSetCookie` method.
            // So we need to check the existence of the method first.
            const nextRefreshToken = 'getSetCookie' in newHeaders
                ? extractRefreshTokenFromSetCookie(newHeaders.getSetCookie())
                : undefined;
            return {
                type: 'success',
                data: {
                    headers: newHeaders,
                    refreshToken: parseAuthToken(nextRefreshToken),
                    accessToken: newAccessToken,
                    accessTokenExpiry: newAccessToken.expiresAt,
                },
            };
        }
        catch (err) {
            this.logger.error('API calls to token refresh failed:', err);
            if (err instanceof HttpError) {
                // If the token refresh request is failed due to the invalid refresh
                // token, mark the session as expired.
                if (err.response.status === 401) {
                    this.logger.error('Token refresh aborted as the server has flagged the session as expired.');
                    return { type: 'failure' };
                }
            }
            this.logger.error('Retrying token refresh...');
            return { type: 'retry' };
        }
    }
    buildAuthorizedJwtAuthContext(params) {
        var _a;
        const { refreshToken, accessToken, accessTokenExpiry } = params.tokenSet;
        const canRetry = !((_a = params.lastRun) !== null && _a !== void 0 ? _a : true);
        return {
            status: 'authorized',
            isGuest: false,
            canRetry,
            refreshToken: refreshToken === null || refreshToken === void 0 ? void 0 : refreshToken.raw,
            refreshTokenParsed: refreshToken,
            accessToken: accessToken === null || accessToken === void 0 ? void 0 : accessToken.raw,
            accessTokenParsed: accessToken,
            accessTokenExpiry: accessTokenExpiry !== null && accessTokenExpiry !== void 0 ? accessTokenExpiry : accessToken === null || accessToken === void 0 ? void 0 : accessToken.expiresAt,
            headers: buildAuthHeaders({ tokenSet: params.tokenSet }),
            fullHeaders: buildAuthHeaders({
                baseHeaders: params.headers,
                tokenSet: params.tokenSet,
                updateCookies: true,
            }),
            cookies: convertTokenSetIntoCookie(params.tokenSet),
            retryAuth: createRetryAuth(canRetry),
            throwAuthError,
            throwAuthErrorIfPossible: createThrowAuthErrorIfPossible(canRetry),
        };
    }
    buildUnauthorizedJwtAuthContext(params) {
        var _a, _b;
        const isGuest = (_a = params.isGuest) !== null && _a !== void 0 ? _a : false;
        const headers = isGuest ? new Headers() : buildAuthHeaders();
        const canRetry = (_b = params.canRetry) !== null && _b !== void 0 ? _b : false;
        return {
            status: 'unauthorized',
            isGuest,
            canRetry,
            refreshToken: undefined,
            refreshTokenParsed: undefined,
            accessToken: undefined,
            accessTokenParsed: undefined,
            accessTokenExpiry: undefined,
            headers: isGuest ? new Headers() : buildAuthHeaders(),
            fullHeaders: isGuest ? headers : buildAuthHeaders({ baseHeaders: headers }),
            cookies: {},
            retryAuth: createRetryAuth(canRetry),
            throwAuthError,
            throwAuthErrorIfPossible: createThrowAuthErrorIfPossible(canRetry),
        };
    }
    async getHeaders() {
        var _a, _b;
        return new Headers(await ((_b = (_a = this.options).fetchHeaders) === null || _b === void 0 ? void 0 : _b.call(_a)));
    }
    async getCookies(headers) {
        var _a, _b, _c;
        const cookie = await ((_b = (_a = this.options).fetchCookie) === null || _b === void 0 ? void 0 : _b.call(_a));
        const cookies = parseCookie((_c = cookie !== null && cookie !== void 0 ? cookie : headers === null || headers === void 0 ? void 0 : headers.get('cookie')) !== null && _c !== void 0 ? _c : '');
        // We need to look for the `set-cookie` header as well, since the `cookie`
        // header may be outdated on the server-side.
        const setCookies = headers != null && 'getSetCookie' in headers
            ? Object.fromEntries(parseSetCookieEntries(headers.getSetCookie()))
            : {};
        return { ...cookies, ...setCookies };
    }
}
function createTokenUpdateCommand(params) {
    var _a, _b;
    if (params.useSetCookieAsIs && params.headers != null && 'getSetCookie' in params.headers) {
        const setCookieRaw = params.headers.getSetCookie();
        return {
            type: 'updateToken',
            descriptor: {
                setCookieHeaders: params.headers,
                setCookieEntries: parseSetCookieEntries(setCookieRaw),
                setCookieEntriesSerialized: setCookieRaw,
                // Access token in this context cannot be `undefined` and always available.
                accessToken: params.tokenSet.accessToken.raw,
                refreshToken: (_a = params.tokenSet.refreshToken) === null || _a === void 0 ? void 0 : _a.raw,
            },
        };
    }
    const setCookieEntries = buildAuthSetCookieEntries({
        tokenSet: params.tokenSet,
        cookieOptions: params.cookieOptions,
    });
    const setCookieEntriesRaw = setCookieEntries.map((entry) => createSetCookieEntry(...entry));
    return {
        type: 'updateToken',
        descriptor: {
            setCookieHeaders: createHeadersWithSetCookieEntries({
                baseHeaders: params.headers,
                setCookieEntriesRaw,
            }),
            setCookieEntries,
            setCookieEntriesSerialized: setCookieEntries.map((entry) => createSetCookieEntry(...entry)),
            // Access token in this context cannot be `undefined` and always available.
            accessToken: params.tokenSet.accessToken.raw,
            refreshToken: (_b = params.tokenSet.refreshToken) === null || _b === void 0 ? void 0 : _b.raw,
        },
    };
}
function createTokenExpirationCommand(params) {
    const setCookieEntries = buildAuthExpirationSetCookieEntries({
        cookieOptions: params.cookieOptions,
    });
    return {
        type: 'setSessionExpired',
        info: {
            reason: params.reason,
            setCookieEntries,
            setCookieEntriesSerialized: setCookieEntries.map((entry) => createSetCookieEntry(...entry)),
        },
    };
}
function defaultPredicateTokenExpired(params) {
    return isDateExpired(params.accessTokenExpiry);
}
function defaultFilterHeaders(params) {
    return params.headers;
}

async function handleJwtAuth(options) {
    var _a;
    const inst = (_a = options.instance) !== null && _a !== void 0 ? _a : new JwtAuth(options);
    return inst.handleAuth((...args) => options.run(...args));
}

/**
 * Headers that are used for JWT authentication.
 *
 * - `cookie`
 * - `user-agent`
 * - `authorization`
 * - `x-ohouse-amk`
 */
const JWT_AUTH_HEADERS = [
    'cookie',
    'user-agent',
    'authorization',
    JWT_AUTH_MARKER_HEADER_NAME,
];
/**
 * Filter out headers that are not used for JWT authentication.
 *
 * You can use this function to filter out unnecessary headers from the incoming
 * request on BFF server or /api/* routes of Next.js.
 *
 * For what headers are used for JWT authentication, @see
 * {@link JWT_AUTH_HEADERS}.
 */
function filterJwtAuthHeaders(input) {
    const headers = new Headers(input);
    for (const key of headers.keys()) {
        if (!JWT_AUTH_HEADERS.includes(key)) {
            headers.delete(key);
        }
    }
    return headers;
}
/**
 * Filter out headers from an object that are not used for JWT authentication.
 *
 * You can use this function to filter out unnecessary headers from the incoming
 * request on BFF server or /api/* routes of Next.js.
 *
 * For what headers are used for JWT authentication, @see {@link JWT_AUTH_HEADERS}.
 */
function filterJwtAuthHeadersObject(input) {
    return filterObject(input, (_, key) => JWT_AUTH_HEADERS.includes(key.toLowerCase()));
}

const OHOUSE_CLIENT_HOST_MAP = {
    prod: 'https://ohou.se',
    qa: 'https://qa-web.dailyhou.se',
    stage: 'https://stage-web.dailyhou.se',
    dev: 'https://dev-web.dailyhou.se',
    local: 'https://stage-web.dailyhou.se',
};
const DEFAULT_OHOUSE_CLIENT_HOST = OHOUSE_CLIENT_HOST_MAP['prod'];
const GLOBAL_OHOUSE_CLIENT_HOST_MAP = {
    prod: 'https://ohouse.com',
    qa: 'https://qa-web.ohouse.in',
    stage: 'https://stage-web.dailyhou.se',
    dev: 'https://dev-web.dailyhou.se',
    local: 'https://qa-web.ohouse.in',
};
const GLOBAL_DEFAULT_OHOUSE_CLIENT_HOST = GLOBAL_OHOUSE_CLIENT_HOST_MAP['prod'];
const API_GATEWAY_HOST_MAP = {
    prod: 'https://api.ohou.se',
    qa: 'https://api.qa.dailyhou.se',
    stage: 'https://api.stage.dailyhou.se',
    dev: 'https://api.dev.dailyhou.se',
    local: 'https://api.stage.dailyhou.se',
};
const DEFAULT_API_GATEWAY_HOST = API_GATEWAY_HOST_MAP['prod'];
const GLOBAL_API_GATEWAY_HOST_MAP = {
    prod: 'https://mbff.ohouse.com',
    qa: 'https://mbff.qa-web.ohouse.in',
    stage: 'https://global-mbff.stage-web.dailyhou.se',
    dev: 'https://global-mbff.dev-web.dailyhou.se',
    local: 'https://mbff.qa-web.ohouse.in',
};
const GLOBAL_DEFAULT_API_GATEWAY_HOST = GLOBAL_API_GATEWAY_HOST_MAP['prod'];
function getHostByEnvironment(env, serviceType) {
    if (serviceType === 'OG') {
        return env != null ? GLOBAL_OHOUSE_CLIENT_HOST_MAP[env] : GLOBAL_DEFAULT_OHOUSE_CLIENT_HOST;
    }
    return env != null ? OHOUSE_CLIENT_HOST_MAP[env] : DEFAULT_OHOUSE_CLIENT_HOST;
}
function getApiGatewayHostByEnvironment(env, serviceType) {
    if (serviceType === 'OG') {
        return env != null ? GLOBAL_API_GATEWAY_HOST_MAP[env] : GLOBAL_DEFAULT_API_GATEWAY_HOST;
    }
    return env != null ? API_GATEWAY_HOST_MAP[env] : DEFAULT_API_GATEWAY_HOST;
}
function getCookieDomain(env, serviceType) {
    const host = getHostByEnvironment(env, serviceType);
    return /https?:\/\/([^/]+)/.exec(host)[1];
}

function parseRootDomain(host) {
    var _a;
    const match = /(?:https?:\/\/)?([^./]+)(\.[^./]+)?$/.exec(host);
    if (match == null) {
        return undefined;
    }
    return `${match[1]}${(_a = match[2]) !== null && _a !== void 0 ? _a : ''}`;
}


//# sourceMappingURL=index.mjs.map

;// CONCATENATED MODULE: ./node_modules/.pnpm/@bucketplace+jwt-auth@1.8.0_ky@1.1.3/node_modules/@bucketplace/jwt-auth/dist/client.mjs
const client_OHOUSE_CLIENT_HOST_MAP = {
    prod: 'https://ohou.se',
    qa: 'https://qa-web.dailyhou.se',
    stage: 'https://stage-web.dailyhou.se',
    dev: 'https://dev-web.dailyhou.se',
    local: 'https://stage-web.dailyhou.se',
};
const client_DEFAULT_OHOUSE_CLIENT_HOST = client_OHOUSE_CLIENT_HOST_MAP['prod'];
const client_GLOBAL_OHOUSE_CLIENT_HOST_MAP = {
    prod: 'https://ohouse.com',
    qa: 'https://qa-web.ohouse.in',
    stage: 'https://stage-web.dailyhou.se',
    dev: 'https://dev-web.dailyhou.se',
    local: 'https://qa-web.ohouse.in',
};
const client_GLOBAL_DEFAULT_OHOUSE_CLIENT_HOST = client_GLOBAL_OHOUSE_CLIENT_HOST_MAP['prod'];
function client_getHostByEnvironment(env, serviceType) {
    if (serviceType === 'OG') {
        return env != null ? client_GLOBAL_OHOUSE_CLIENT_HOST_MAP[env] : client_GLOBAL_DEFAULT_OHOUSE_CLIENT_HOST;
    }
    return env != null ? client_OHOUSE_CLIENT_HOST_MAP[env] : client_DEFAULT_OHOUSE_CLIENT_HOST;
}
function client_getCookieDomain(env, serviceType) {
    const host = client_getHostByEnvironment(env, serviceType);
    return /https?:\/\/([^/]+)/.exec(host)[1];
}

function client_delay(ms) {
    return new Promise((resolve) => setTimeout(resolve, ms));
}

const client_MAX_SAFE_TIMEOUT = 2147483647;
class client_HttpError extends Error {
    constructor(response, request, options) {
        var _a;
        const code = response.status || response.status === 0 ? response.status : '';
        const title = (_a = response.statusText) !== null && _a !== void 0 ? _a : '';
        const status = `${code} ${title}`.trim();
        const reason = status ? `status code ${status}` : 'an unknown error';
        super(`Request failed with ${reason}`);
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: 'HttpError'
        });
        Object.defineProperty(this, "response", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "request", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "options", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.response = response;
        this.request = request;
        this.options = options;
    }
}
class client_TimeoutError extends Error {
    constructor(request) {
        super('Request timed out');
        Object.defineProperty(this, "request", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.name = 'TimeoutError';
        this.request = request;
    }
}
/**
 * Shortcut method for POST requests.
 *
 * Note that `method` option from `RequestInput` or `RequestOptions` will be ignored.
 *
 * @param input Input for the request, can be a URL string, a `URL` object, or a `Request` object
 * @param options Request options
 * @returns The POST response
 */
async function client_post(input, options) {
    return client_request(input, { ...options, method: 'POST' });
}
/**
 * The base request method for all HTTP methods
 *
 * @param input Input for the request, can be a URL string, a `URL` object, or a `Request` object
 * @param options Request options
 * @returns The fetch response
 */
async function client_request(input, options) {
    var _a;
    if ((options === null || options === void 0 ? void 0 : options.timeout) != null && options.timeout > client_MAX_SAFE_TIMEOUT) {
        throw new RangeError(`The \`timeout\` option cannot be greater than ${client_MAX_SAFE_TIMEOUT}`);
    }
    const { fetch: fetchFn, timeout, throwHttpErrors, json, ...requestOptions } = client_normalizeRequestOptions(input, options);
    const abortController = new globalThis.AbortController();
    if ((options === null || options === void 0 ? void 0 : options.signal) != null) {
        const originalSignal = options.signal;
        options.signal.addEventListener('abort', () => {
            abortController.abort(originalSignal.reason);
        }, { once: true });
    }
    let requestDescriptor = new globalThis.Request(input, {
        ...requestOptions,
        signal: abortController.signal,
    });
    // `json` option accepts `null` as a value
    if (json !== undefined) {
        const body = JSON.stringify(json);
        requestDescriptor.headers.set('content-type', (_a = requestOptions.headers.get('content-type')) !== null && _a !== void 0 ? _a : 'application/json');
        requestDescriptor = new globalThis.Request(requestDescriptor, { body, headers: requestDescriptor.headers });
    }
    const handleRequest = async () => {
        const res = await fetchFn(requestDescriptor.clone());
        if (throwHttpErrors && !res.ok) {
            throw new client_HttpError(res, requestDescriptor.clone(), requestOptions);
        }
        return res;
    };
    if (timeout > 0) {
        return Promise.race([
            handleRequest(),
            (async () => {
                await client_delay(timeout);
                // Throw timeout error first
                setTimeout(() => abortController.abort(), 1);
                throw new client_TimeoutError(requestDescriptor.clone());
            })(),
        ]);
    }
    return handleRequest();
}
function client_normalizeRequestOptions(input, options) {
    var _a, _b, _c, _d, _e;
    return {
        ...options,
        method: (_b = ((_a = options === null || options === void 0 ? void 0 : options.method) !== null && _a !== void 0 ? _a : input.method)) === null || _b === void 0 ? void 0 : _b.toUpperCase(),
        headers: client_mergeHeaders(input.headers, options === null || options === void 0 ? void 0 : options.headers),
        credentials: (_c = options === null || options === void 0 ? void 0 : options.credentials) !== null && _c !== void 0 ? _c : 'include',
        throwHttpErrors: (options === null || options === void 0 ? void 0 : options.throwHttpErrors) !== false,
        timeout: Math.max((_d = options === null || options === void 0 ? void 0 : options.timeout) !== null && _d !== void 0 ? _d : 10000, 0),
        fetch: (_e = options === null || options === void 0 ? void 0 : options.fetch) !== null && _e !== void 0 ? _e : globalThis.fetch.bind(globalThis),
    };
}
function client_mergeHeaders(a = {}, b = {}) {
    const result = new globalThis.Headers(a);
    const source = new globalThis.Headers(b);
    for (const [key, value] of source.entries()) {
        if ((b instanceof globalThis.Headers && value === 'undefined') || value === undefined) {
            result.delete(key);
        }
        else {
            result.set(key, value);
        }
    }
    return result;
}

const client_ACCESS_TOKEN_COOKIE_NAME = 'ohouse-aat';
const client_ACCESS_TOKEN_EXPIRY_COOKIE_NAME = 'ohouse-aat-expiry';
const client_REFRESH_TOKEN_COOKIE_NAME = 'ohouse-art';
// See: https://ohouse.atlassian.net/browse/OHSWEB-3430
// See also: https://www.notion.so/ohouse/Web-JWT-compliance-c0c7a1349e9b462d803aa6b4bf12a00b?pvs=4#45bca8f1d5684030961d7b39dd2d879a
const client_JWT_AUTH_MARKER_HEADER_NAME = 'x-ohouse-amk';
const client_DEFAULT_JWT_EXPIRATION_SAFE_MARGIN = 1000 * 60; // 1 min in milliseconds
// We are only allowed to set up to 400 days of expiration time for cookies.
// See: https://developer.chrome.com/blog/cookie-max-age-expires
const client_DEFAULT_SESSION_EXPIRATION_TIME = 60 * 60 * 24 * 400; // 400 days in seconds

function client_filterObject(input, filter, target = {}) {
    return Object.entries(input)
        .reduce((res, [key, value]) => {
        if (filter(value, key, input)) {
            res[key] = value;
            return res;
        }
        return res;
    }, target);
}

/**
 * Headers that are used for JWT authentication.
 *
 * - `cookie`
 * - `user-agent`
 * - `authorization`
 * - `x-ohouse-amk`
 */
const client_JWT_AUTH_HEADERS = [
    'cookie',
    'user-agent',
    'authorization',
    client_JWT_AUTH_MARKER_HEADER_NAME,
];
/**
 * Filter out headers that are not used for JWT authentication.
 *
 * You can use this function to filter out unnecessary headers from the incoming
 * request on BFF server or /api/* routes of Next.js.
 *
 * For what headers are used for JWT authentication, @see
 * {@link JWT_AUTH_HEADERS}.
 */
function client_filterJwtAuthHeaders(input) {
    const headers = new Headers(input);
    for (const key of headers.keys()) {
        if (!client_JWT_AUTH_HEADERS.includes(key)) {
            headers.delete(key);
        }
    }
    return headers;
}

// https://www.notion.so/ohouse/auth-v1-refresh-4d1cea1de610404e910035924e3eae79
const client_API_PATH_POST_REFRESH_JWT = '/user/v1/auth/refresh';

function createClientRefreshApiFn(env, serviceType) {
    return async (context) => {
        const res = await client_post(`${client_getHostByEnvironment(env, serviceType)}${client_API_PATH_POST_REFRESH_JWT}`, {
            headers: client_mergeHeaders(client_filterJwtAuthHeaders(context.headers), {
                'accept': 'application/json',
                'content-type': 'application/json',
            }),
            json: {},
            credentials: 'include',
            // Match with the Android/iOS implementation.
            timeout: 3000,
        });
        const json = await res.json();
        return { body: json, headers: res.headers };
    };
}

class client_InvalidTokenError extends Error {
}
client_InvalidTokenError.prototype.name = "InvalidTokenError";
function client_b64DecodeUnicode(str) {
    return decodeURIComponent(atob(str).replace(/(.)/g, (m, p) => {
        let code = p.charCodeAt(0).toString(16).toUpperCase();
        if (code.length < 2) {
            code = "0" + code;
        }
        return "%" + code;
    }));
}
function client_base64UrlDecode(str) {
    let output = str.replace(/-/g, "+").replace(/_/g, "/");
    switch (output.length % 4) {
        case 0:
            break;
        case 2:
            output += "==";
            break;
        case 3:
            output += "=";
            break;
        default:
            throw new Error("base64 string is not of the correct length");
    }
    try {
        return client_b64DecodeUnicode(output);
    }
    catch (err) {
        return atob(output);
    }
}
function client_jwtDecode(token, options) {
    if (typeof token !== "string") {
        throw new client_InvalidTokenError("Invalid token specified: must be a string");
    }
    options || (options = {});
    const pos = options.header === true ? 0 : 1;
    const part = token.split(".")[pos];
    if (typeof part !== "string") {
        throw new client_InvalidTokenError(`Invalid token specified: missing part #${pos + 1}`);
    }
    let decoded;
    try {
        decoded = client_base64UrlDecode(part);
    }
    catch (e) {
        throw new client_InvalidTokenError(`Invalid token specified: invalid base64 for part #${pos + 1} (${e.message})`);
    }
    try {
        return JSON.parse(decoded);
    }
    catch (e) {
        throw new client_InvalidTokenError(`Invalid token specified: invalid json for part #${pos + 1} (${e.message})`);
    }
}

// JWT token validation algorithm:
// https://datatracker.ietf.org/doc/html/rfc7519#section-7.2
//
// Note: Since JWT uses "Base64 encoding with url", it will not include `=` for
// padding in the encoding of JWT’s.
// https://datatracker.ietf.org/doc/html/rfc4648#section-5
const client_JWT_REGEX = /^[A-Za-z0-9_-]{2,}(?:\.[A-Za-z0-9_-]{2,}){2}$/;
/**
 * Check if the input string is a valid JWT token.
 *
 * @param input The input string to check.
 * @returns `true` if the input is a valid JWT token, `false` otherwise.
 */
function client_isJwtToken(input) {
    return client_JWT_REGEX.test(input);
}
/**
 * Parse the input string as JWT token.
 *
 * @param input The input string to parse as JWT token.
 * @returns The parsed JWT token, or `undefined` if the input is not a valid JWT token.
 */
function client_parseJwtToken(input) {
    try {
        const payload = client_jwtDecode(input);
        // [RFC7519](https://www.rfc-editor.org/rfc/rfc7519#section-4.1.4) states
        // that `exp` is defined as the number of seconds, however `Date`
        // constructor accepts unix timestamp which is milliseconds.
        // So we need to multiply it by 1000.
        const expiresAt = new Date(payload.exp * 1000);
        return {
            raw: input,
            payload,
            expiresAt,
        };
    }
    catch (err) {
        return undefined;
    }
}
/**
 * Check if the date is expired.
 *
 * @param date The timestamp to check if it is expired.
 * @param safeMargin The safe margin in milliseconds that subtracted from the current time to consider the token as expired.
 * @returns `true` if the token is expired, `false` otherwise.
 */
function client_isDateExpired(date, safeMarginMs = client_DEFAULT_JWT_EXPIRATION_SAFE_MARGIN) {
    // `safeMarginMs` is used to prevent the token from being considered as valid
    // when the system clock is not accurate. e.g., Unix leap seconds, internet
    // time synchronization, etc.
    return date.getTime() <= (Date.now() + safeMarginMs);
}

class client_Signal {
    constructor() {
        Object.defineProperty(this, "currentRun", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "locked", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "slots", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "buffer", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "busyRunning", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "busyRunningQueue", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "beforeEmitHooks", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "afterEmitHooks", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.currentRun = 0;
        this.locked = 0;
        this.slots = new Map();
        this.buffer = [];
        this.busyRunning = 0;
        this.busyRunningQueue = [];
        this.beforeEmitHooks = new Set();
        this.afterEmitHooks = new Set();
    }
    /**
     * Get all slots currently registered.
     */
    getSlots() {
        return this.slots;
    }
    /**
     * Get current buffer values.
     */
    getCurrentBuffer() {
        return this.buffer;
    }
    /**
     * Check if the buffer is empty.
     */
    isBufferEmpty() {
        return this.buffer.length < 1;
    }
    /**
     * Increase the lock count by 1.
     */
    lock() {
        this.locked++;
    }
    /**
     * Decrease the lock count by 1.
     */
    unlock() {
        this.locked--;
        this.flushBuffer();
    }
    /**
     * Starts a transaction that will automatically wraps the given callback `fn`
     * with locks and flush once all done.
     *
     * @param fn A callback invoked on the transaction starts.
     * @param parallel Whether to continue through without waiting for the `fn` to complete.
     */
    async transact(fn, parallel) {
        this.locked++;
        try {
            // When `parallel` options is set, it will not wait for the promise
            // returned by the `fn` to complete, resulting the `finally` statement to
            // be called as quickly as possible regardless of the promise is
            // fulfilled.
            //
            // Otherwise, it will wait for the returned promise before unlocking.
            if (parallel) {
                return fn();
            }
            else {
                return await fn();
            }
        }
        finally {
            this.locked--;
            this.flushBuffer();
        }
    }
    /**
     * Registers a callback to the slots.
     *
     * Note that, you can't register the same callback already registered to its
     * identity to prevent shadowing, which is no-op.
     *
     * However, you can still register the same callback within the same callback
     * while running itself.
     *
     * @param fn a slot function.
     */
    register(fn, options) {
        var _a, _b, _c, _d;
        // Prevent registering duplicates to not mistakenly run into race-conditions
        // in some circumstances.
        if (!this.slots.has(fn)) {
            this.slots.set(fn, {
                callback: fn,
                once: (_a = options === null || options === void 0 ? void 0 : options.once) !== null && _a !== void 0 ? _a : false,
                takeLatest: (_b = options === null || options === void 0 ? void 0 : options.takeLatest) !== null && _b !== void 0 ? _b : false,
                parallel: (_c = options === null || options === void 0 ? void 0 : options.parallel) !== null && _c !== void 0 ? _c : false,
                receiveTeardown: (_d = options === null || options === void 0 ? void 0 : options.receiveTeardownValue) !== null && _d !== void 0 ? _d : false,
            });
            this.flushBuffer();
        }
        return fn;
    }
    /**
     * Removes the given callback from the slots.
     *
     * This will not remove a slot that is being flushed in current run.
     */
    unregister(fn) {
        return this.slots.delete(fn);
    }
    /**
     * Clear out all registered callbacks from the slots.
     */
    unregisterAll() {
        this.slots.clear();
    }
    /**
     * Returns a promise that will be fulfilled once the signal is emitted.
     *
     * This is effectively a convenient wrapper over calling
     * `register(resolve, options)` in promise executor.
     *
     * If `fn` is provided, it will return promise that also waits for
     * the `fn` to complete. This is useful for situation where you want to
     * process only single instance of slots at a time.
     *
     * By default, `fn` will not be called when the emit value has been teardown.
     *
     * @param fn An optional callback that will be called while processing values.
     * @param options The options.
     */
    async waitOnce(fn, options) {
        return new Promise((resolve, reject) => {
            var _a, _b, _c, _d;
            const resolveEmpty = (_a = options === null || options === void 0 ? void 0 : options.resolveEmpty) !== null && _a !== void 0 ? _a : false;
            const cb = async (value, meta) => {
                if (fn != null) {
                    try {
                        // Just forward the value after execution of the handler.
                        resolve(await fn(value, meta));
                    }
                    catch (err) {
                        reject(err);
                    }
                }
                else {
                    resolve(value);
                }
            };
            if (resolveEmpty && this.isBufferEmpty()) {
                cb(undefined, {
                    index: -1,
                    length: -1,
                    currentRun: -1,
                    teardown: false,
                    tag: undefined,
                    isLast: true,
                    extra: undefined,
                });
                return;
            }
            this.slots.set(cb, {
                callback: cb,
                once: true,
                takeLatest: (_b = options === null || options === void 0 ? void 0 : options.takeLatest) !== null && _b !== void 0 ? _b : false,
                parallel: (_c = options === null || options === void 0 ? void 0 : options.parallel) !== null && _c !== void 0 ? _c : false,
                // Unless otherwise set, the `cb` will be called only when non-teardown value is emitted.
                receiveTeardown: (_d = options === null || options === void 0 ? void 0 : options.receiveTeardownValue) !== null && _d !== void 0 ? _d : false,
            });
            this.flushBuffer();
        });
    }
    /**
     * Emit a value of type.
     *
     * @param value A value to emit.
     * @param options Options for value emit.
     */
    emit(value, options) {
        return new Promise((resolve) => {
            var _a;
            const discard = (_a = options === null || options === void 0 ? void 0 : options.discardOnNoReceivers) !== null && _a !== void 0 ? _a : false;
            if (discard && this.slots.size < 1) {
                resolve();
                return;
            }
            this.buffer.push([value, { ...options }, resolve]);
            this.flushBuffer();
        });
    }
    /**
     * Register a hook that will be called right before the signal emits, which
     * can prevent the signal from firing values by returning `false`.
     *
     * If `false` is returned, the given value will be marked as `teardown` and will
     * be excluded from emitting.
     *
     * @param fn A callback that can be used to abort the signal from firing
     * values.
     * @returns A function to unregister the hook.
     */
    beforeEmit(fn) {
        if (!this.beforeEmitHooks.has(fn)) {
            this.beforeEmitHooks.add(fn);
        }
        return () => {
            this.beforeEmitHooks.delete(fn);
        };
    }
    /**
     * Register a hook that will be called after the signal emits.
     *
     * @param fn A callback that will be called after the signal emits.
     * @returns A function to unregister the hook.
     */
    afterEmit(fn) {
        if (!this.afterEmitHooks.has(fn)) {
            this.afterEmitHooks.add(fn);
        }
        return () => {
            this.afterEmitHooks.delete(fn);
        };
    }
    /**
     * Discards all buffer content.
     */
    discardBuffer() {
        this.buffer = [];
    }
    wrapHooks(fn) {
        return async (value, meta) => {
            let cancelExecution = meta.teardown;
            if (!cancelExecution) {
                for (const beforeEmit of this.beforeEmitHooks) {
                    const result = await beforeEmit(value, meta);
                    if (typeof result === 'boolean' && !result) {
                        cancelExecution = true;
                        break;
                    }
                }
            }
            await fn(value, { ...meta, teardown: cancelExecution });
            for (const afterEmit of this.afterEmitHooks) {
                await afterEmit(value, meta);
            }
        };
    }
    async flushBuffer() {
        var _a;
        const { locked, buffer, slots, currentRun, busyRunningQueue, } = this;
        const curRun = currentRun + 1;
        if (locked > 0 || buffer.length < 1 || slots.size < 1) {
            return;
        }
        this.currentRun = curRun;
        this.buffer = [];
        const snapshotSlots = new Map(slots);
        for (const { callback, once } of snapshotSlots.values()) {
            // We need to clean up all once(ephemeral) slots for next run
            if (once) {
                slots.delete(callback);
            }
        }
        // If there's already another instance of `flushBuffer()` is running, we
        // need to wait for it to complete.
        if (this.busyRunning > 0) {
            await new Promise((resolve) => {
                busyRunningQueue.push(resolve);
            });
        }
        this.busyRunning++;
        const runWithHook = this.wrapHooks(async (value, meta) => {
            const { teardown, isLast } = meta;
            for (const { callback, once, parallel, takeLatest, receiveTeardown } of snapshotSlots.values()) {
                if ((teardown && !receiveTeardown) || (takeLatest && !isLast)) {
                    continue;
                }
                if (once && snapshotSlots.has(callback)) {
                    snapshotSlots.delete(callback);
                }
                // Handles a thenable, so the user logic must not rely on the synchronous callback invocation.
                if (parallel) {
                    callback(value, meta);
                }
                else {
                    await callback(value, meta);
                }
            }
        });
        // Iterate over buffer in a FIFO-ish manner then calling over listeners respectively.
        for (const [index, [value, options, callback]] of buffer.entries()) {
            await runWithHook(value, {
                index,
                length: buffer.length,
                currentRun: curRun,
                teardown: (_a = options.markAsTeardown) !== null && _a !== void 0 ? _a : false,
                tag: options.tag,
                isLast: index === buffer.length - 1,
                extra: options.extra,
            });
            if (callback != null) {
                callback();
            }
        }
        this.busyRunning--;
        // Exhaust the next element remaining in the queue.
        if (this.busyRunning < 1 && busyRunningQueue.length > 0) {
            const next = busyRunningQueue.shift();
            next();
        }
    }
}

/* eslint-disable @typescript-eslint/no-explicit-any, no-console */
class client_NoopLogger {
    debug(_message, ..._args) {
        // noop
    }
    info(_message, ..._args) {
        // noop
    }
    warn(_message, ..._args) {
        // noop
    }
    error(_message, ..._args) {
        // noop
    }
}

/**
 * Parse a cookie string into a key-value object.
 *
 * @param input A cookie string.
 * @returns A key-value cookie object.
 */
function client_parseCookie(input) {
    const trimmed = input.trim();
    if (trimmed === '') {
        return {};
    }
    return trimmed
        .split(';')
        .map((record) => client_parseCookieEntry(record))
        .reduce((acc, [key, value]) => {
        if (key == null || value == null) {
            return acc;
        }
        acc[key.trim()] = value.trim();
        return acc;
    }, {});
}
/**
 * Parse a Set-Cookie header value into a tuple.
 *
 * @param input A Set-Cookie header value.
 * @returns A tuple of name, value, and attributes.
 */
function client_parseSetCookieEntry(input) {
    const trimmed = input.trim();
    if (trimmed === '') {
        return undefined;
    }
    const [nameValue, ...attributes] = trimmed.split(';');
    if (nameValue == null) {
        return undefined;
    }
    const [name, value] = nameValue.split('=');
    if (name == null || value == null) {
        return undefined;
    }
    return [name.trim(), value.trim(), client_parseSetCookieAttributes(attributes)];
}
/**
 * Parse the attributes of a Set-Cookie header value.
 *
 * @param raw The raw string attributes of a Set-Cookie header value.
 * @returns The parsed attributes.
 */
function client_parseSetCookieAttributes(raw) {
    var _a;
    const parsedAttributes = raw
        .map((record) => client_parseCookieEntry(record))
        .reduce((acc, [key, value]) => {
        var _a;
        if (key == null) {
            return acc;
        }
        acc[key.trim().toLowerCase()] = (_a = value === null || value === void 0 ? void 0 : value.trim()) !== null && _a !== void 0 ? _a : '';
        return acc;
    }, {});
    const attributes = {};
    if (parsedAttributes['domain'] != null) {
        attributes.domain = parsedAttributes['domain'];
    }
    if (parsedAttributes['expires'] != null) {
        attributes.expires = new Date(parsedAttributes['expires']);
    }
    if (parsedAttributes['httponly'] != null) {
        attributes.httpOnly = true;
    }
    if (parsedAttributes['max-age'] != null) {
        const parsed = Number.parseInt(parsedAttributes['max-age'], 10);
        if (!Number.isNaN(parsed)) {
            attributes.maxAge = parsed;
        }
    }
    if (parsedAttributes['path'] != null) {
        attributes.path = parsedAttributes['path'];
    }
    if (parsedAttributes['partitioned'] != null) {
        attributes.partitioned = true;
    }
    if (parsedAttributes['secure'] != null) {
        attributes.secure = true;
    }
    const sameSiteAttr = (_a = parsedAttributes['samesite']) === null || _a === void 0 ? void 0 : _a.toLowerCase();
    if (sameSiteAttr != null && ['strict', 'lax', 'none'].includes(sameSiteAttr)) {
        attributes.sameSite = sameSiteAttr;
    }
    return attributes;
}
/**
 * Extract the set-cookie entries from the raw set-cookie content.
 */
function client_parseSetCookieEntries(input) {
    return input.reduce((res, sc) => {
        const parsed = client_parseSetCookieEntry(sc);
        if (parsed == null) {
            return res;
        }
        res.push(parsed);
        return res;
    }, []);
}
/**
 * Stringify a key-value cookie object into a cookie string.
 *
 * @param input A key-value cookie object.
 * @returns A cookie string.
 */
function client_stringifyCookie(input) {
    return Object.entries(input)
        .map(([key, value]) => `${key}=${value}`.trim())
        .join('; ');
}
/**
 * Delete cookie values from a cookie string.
 *
 * @param input A cookie string.
 * @param names Cookie names to delete.
 * @returns The cookie string with the specified cookie names deleted.
 */
function client_eraseCookie(input, names) {
    const trimmed = input.trim();
    if (trimmed === '') {
        return '';
    }
    const filtered = trimmed
        .split(';')
        .map((record) => client_parseCookieEntry(record))
        .filter(([key, value]) => {
        if (key == null || value == null) {
            return false;
        }
        return !names.includes(key.trim());
    });
    return filtered
        // Preserve the original encoding.
        .map(([key, value]) => `${key}=${value}`.trim())
        .join('; ');
}
function client_parseCookieEntry(input) {
    const [key, ...values] = input.split('=');
    return [key, values.length < 1 ? undefined : values.join('=')];
}
/**
 * Create a Set-Cookie header value from the specified parameters.
 * @param name The cookie name.
 * @param value The cookie value.
 * @param attributes The cookie attributes.
 * @returns A Set-Cookie header value string.
 */
function client_createSetCookieEntry(name, value, attributes) {
    const parts = [`${name}=${value}`];
    if ((attributes === null || attributes === void 0 ? void 0 : attributes.domain) != null) {
        parts.push(`Domain=${attributes.domain}`);
    }
    if ((attributes === null || attributes === void 0 ? void 0 : attributes.expires) != null) {
        parts.push(`Expires=${attributes.expires.toUTCString()}`);
    }
    if ((attributes === null || attributes === void 0 ? void 0 : attributes.httpOnly) != null) {
        parts.push('HttpOnly');
    }
    if ((attributes === null || attributes === void 0 ? void 0 : attributes.maxAge) != null) {
        parts.push(`Max-Age=${attributes.maxAge}`);
    }
    if ((attributes === null || attributes === void 0 ? void 0 : attributes.path) != null) {
        parts.push(`Path=${attributes.path}`);
    }
    if ((attributes === null || attributes === void 0 ? void 0 : attributes.partitioned) != null) {
        parts.push('Partitioned');
    }
    if ((attributes === null || attributes === void 0 ? void 0 : attributes.secure) != null) {
        parts.push('Secure');
    }
    if ((attributes === null || attributes === void 0 ? void 0 : attributes.sameSite) != null) {
        parts.push(`SameSite=${attributes.sameSite}`);
    }
    return parts.join('; ');
}
const client_MAKE_COOKIE_EXPIRED_ATTRIBUTES = {
    expires: new Date(0),
    maxAge: undefined,
};
/**
 * Extend a cookie string with the specified cookie object.
 *
 * @param cookie The cookie string to extend.
 * @param cookies The cookie object to extend.
 * @returns The extended cookie string.
 */
function client_extendCookie(cookie, cookies) {
    const cookieKeys = Object.keys(cookies);
    return `${client_eraseCookie(cookie, cookieKeys)}; ${client_stringifyCookie(cookies)}`;
}
/**
 * Extend a cookie within the specified headers with the specified cookie object.
 *
 * @param headers The headers to extend.
 * @param cookies The cookie object to extend.
 * @param replace Whether to replace the original cookie fully.
 * @returns The extended headers.
 */
function client_extendHeadersCookie(headers, cookies, replace) {
    const cookieKeys = Object.keys(cookies);
    if (cookieKeys.length < 1) {
        return headers;
    }
    const newHeaders = new Headers(headers);
    if (newHeaders.has('cookie') && !replace) {
        newHeaders.set('cookie', client_extendCookie(newHeaders.get('cookie'), cookies));
    }
    else {
        newHeaders.set('cookie', client_stringifyCookie(cookies));
    }
    return newHeaders;
}

class client_AbortError extends Error {
    constructor(message) {
        super();
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: 'AbortError'
        });
        Object.defineProperty(this, "originalError", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        if (message instanceof Error) {
            this.originalError = message;
            this.message = message.message;
        }
        else {
            const formatted = `Retry aborted: ${message !== null && message !== void 0 ? message : 'N/A'}`;
            this.originalError = new Error(formatted);
            this.originalError.stack = this.stack;
            this.message = formatted;
        }
    }
}
/**
 * A generic retry function.
 *
 * @param fn The function to retry, which can be async. The function will be called with `attemptCount` (starts from 0).
 * @param options Retry options.
 * @returns The return value of `fn`.
 * @throws {Error} If the retry limit is reached.
 * @throws {AbortError} If the retry is aborted.
 */
async function client_retry(fn, options) {
    var _a, _b, _c, _d;
    const retryLimit = (_a = options === null || options === void 0 ? void 0 : options.limit) !== null && _a !== void 0 ? _a : 2;
    const backoffLimit = (_b = options === null || options === void 0 ? void 0 : options.backoffLimit) !== null && _b !== void 0 ? _b : Infinity;
    let retryCount = 0;
    for (;;) {
        try {
            return await fn(retryCount, retryLimit);
        }
        catch (err) {
            if (retryCount >= retryLimit || err instanceof client_AbortError) {
                throw err;
            }
            retryCount++;
            const delayMs = (_d = (_c = options === null || options === void 0 ? void 0 : options.delay) === null || _c === void 0 ? void 0 : _c.call(options, retryCount)) !== null && _d !== void 0 ? _d : client_calculateDefaultDelay(retryCount);
            if (delayMs > 0) {
                await client_delay(Math.min(delayMs, backoffLimit));
            }
        }
    }
}
function client_calculateDefaultDelay(attemptCount) {
    return 0.3 * (2 ** (attemptCount - 1)) * 1000;
}

/**
 * This error that will be thrown by the user in order to state that the
 * authentication failed and the request should be retried with the valid token.
 */
class client_AuthError extends Error {
    /**
     * @param continueWithNoAuth If `true`, the request will continue with no token.
     */
    constructor(continueWithNoAuth = false) {
        super('Authentication failed.');
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: 'AuthError'
        });
        Object.defineProperty(this, "continueWithNoAuth", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.continueWithNoAuth = continueWithNoAuth;
    }
}
/**
 * Throw an `AuthError`.
 */
function client_throwAuthError() {
    throw new client_AuthError();
}
/**
 * Create a function that throw an `AuthError` if retry is possible.
 */
function client_createThrowAuthErrorIfPossible(canRetry) {
    return (assert) => {
        if (canRetry && (assert !== null && assert !== void 0 ? assert : true)) {
            throw new client_AuthError();
        }
        return false;
    };
}
/**
 * Create a wrapper function that will throw an `AuthError` if retry is possible.
 */
function client_createRetryAuth(canRetry) {
    return async (fn) => {
        if (canRetry) {
            throw new client_AuthError();
        }
        return fn === null || fn === void 0 ? void 0 : fn();
    };
}
/**
 * Internal auth error that will be thrown by the instance.
 */
class client_InternalAuthError extends Error {
    constructor(message) {
        super();
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: 'InternalAuthError'
        });
        Object.defineProperty(this, "originalError", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        if (message instanceof Error) {
            this.originalError = message;
            this.message = message.message;
        }
        else {
            const formatted = `InternalAuthError: ${message !== null && message !== void 0 ? message : 'N/A'}`;
            this.originalError = new Error(formatted);
            this.originalError.stack = this.stack;
            this.message = formatted;
        }
    }
}
/**
 * Parse the input string as JWT token expiry.
 *
 * @param input The input string to parse as JWT token expiry.
 * @returns The parsed JWT token expiry, or `undefined` if the input is not a valid JWT token expiry.
 */
function client_parseAuthTokenExpiry(input) {
    const parsed = Number.parseInt(input !== null && input !== void 0 ? input : '', 10);
    if (Number.isNaN(parsed)) {
        return undefined;
    }
    return new Date(parsed * 1000);
}
/**
 * Format the given JWT token expiry to be used as a cookie value.
 */
function client_formatAuthTokenExpiry(expiry) {
    return String(Math.floor(expiry.getTime() / 1000));
}
/**
 * Parse the input string as JWT token and check its validity.
 *
 * @param input The input string to parse as JWT token.
 * @returns The parsed JWT token, or `undefined` if the input is not a valid JWT token.
 */
function client_parseAuthToken(input) {
    if (input == null || input === '') {
        return undefined;
    }
    if (!client_isJwtToken(input)) {
        return undefined;
    }
    return client_parseJwtToken(input);
}
/**
 * Ensure the given domain to have a leading dot.
 * Following: https://www.rfc-editor.org/rfc/rfc6265#section-4.1.2.3
 */
function client_ensureCookieDomain(domain) {
    if (domain == null) {
        return undefined;
    }
    if (domain.startsWith('.')) {
        return domain;
    }
    return `.${domain}`;
}

/**
 * Build headers for the token refresh api.
 */
function client_extendTokenRefreshHeaders(params) {
    const { refreshToken } = params.tokenSet;
    // If the refresh token is not provided, it indicates that the user is sending
    // a request from the client-side.
    // In such case, `credentials` option from `fetch()` api will automatically
    // include necessary credentials for us.
    // See: https://developer.mozilla.org/en-US/docs/Web/API/Fetch_API/Using_Fetch#sending_a_request_with_credentials_included
    if (refreshToken == null) {
        return params.headers;
    }
    const normalizedCookies = client_convertTokenSetIntoCookie(params.tokenSet);
    return client_extendHeadersCookie(params.headers, normalizedCookies);
}
/**
 * Convert the given token set into a cookie object.
 */
function client_convertTokenSetIntoCookie(tokenSet) {
    const { refreshToken, accessToken, accessTokenExpiry } = tokenSet;
    return client_filterObject({
        [client_REFRESH_TOKEN_COOKIE_NAME]: refreshToken === null || refreshToken === void 0 ? void 0 : refreshToken.raw,
        [client_ACCESS_TOKEN_COOKIE_NAME]: accessToken === null || accessToken === void 0 ? void 0 : accessToken.raw,
        [client_ACCESS_TOKEN_EXPIRY_COOKIE_NAME]: accessTokenExpiry != null
            ? client_formatAuthTokenExpiry(accessTokenExpiry)
            : undefined,
    }, (v) => v != null);
}
/**
 * Create auth headers for the given access token.
 */
function client_buildAuthHeaders(params) {
    var _a, _b;
    const tokenSet = (_a = params === null || params === void 0 ? void 0 : params.tokenSet) !== null && _a !== void 0 ? _a : {};
    const updateCookies = (_b = params === null || params === void 0 ? void 0 : params.updateCookies) !== null && _b !== void 0 ? _b : false;
    const authHeaders = new Headers(params === null || params === void 0 ? void 0 : params.baseHeaders);
    if (tokenSet.accessToken != null) {
        authHeaders.set('authorization', `Bearer ${tokenSet.accessToken.raw}`);
    }
    // We need to mark the request as it's authenticated with the jwt token in
    // order to differentiate it from the legacy auth.
    // See: https://ohouse.atlassian.net/browse/HOMEPL-1035
    // See also: https://ohouse.atlassian.net/browse/OHSWEB-3430
    authHeaders.set(client_JWT_AUTH_MARKER_HEADER_NAME, '1');
    // Extend headers with the normalized cookie object.
    return updateCookies
        ? client_extendHeadersCookie(authHeaders, client_convertTokenSetIntoCookie(tokenSet))
        : authHeaders;
}
/**
 * Build headers object with the given set-cookie entries.
 */
function client_createHeadersWithSetCookieEntries(params) {
    const headers = new Headers(params.baseHeaders);
    for (const entry of params.setCookieEntriesRaw) {
        headers.append('set-cookie', entry);
    }
    return headers;
}
/**
 * Build set-cookie entries for expiring auth tokens.
 */
function client_buildAuthExpirationSetCookieEntries(params) {
    var _a;
    const cookieDomain = client_ensureCookieDomain((_a = params.cookieOptions) === null || _a === void 0 ? void 0 : _a.cookieDomain);
    return [
        [client_ACCESS_TOKEN_COOKIE_NAME, '', {
                ...client_MAKE_COOKIE_EXPIRED_ATTRIBUTES,
                domain: cookieDomain,
                // Please refer to the discussion for more details
                // https://ohou-se.slack.com/archives/C05JQR22E13/p1701678839504499
                path: '/',
            }],
        [client_ACCESS_TOKEN_EXPIRY_COOKIE_NAME, '', {
                ...client_MAKE_COOKIE_EXPIRED_ATTRIBUTES,
                domain: cookieDomain,
                // Please refer to the discussion for more details
                // https://ohou-se.slack.com/archives/C05JQR22E13/p1701678839504499
                path: '/',
            }],
    ];
}
/**
 * Build set-cookie entries for setting auth tokens.
 *
 * Each token field can be `undefined`, and will be excluded from the resulting entries.
 */
function client_buildAuthSetCookieEntries(params) {
    var _a, _b, _c;
    const { refreshToken, accessToken, accessTokenExpiry } = params.tokenSet;
    const cookieDomain = client_ensureCookieDomain((_a = params.cookieOptions) === null || _a === void 0 ? void 0 : _a.cookieDomain);
    const maxAgeSecs = (_c = (_b = params.cookieOptions) === null || _b === void 0 ? void 0 : _b.maxAgeSecs) !== null && _c !== void 0 ? _c : client_DEFAULT_SESSION_EXPIRATION_TIME;
    const entries = [];
    // Append refresh token as cookie entry if any.
    if (refreshToken != null) {
        entries.push([
            client_REFRESH_TOKEN_COOKIE_NAME,
            refreshToken.raw,
            {
                domain: cookieDomain,
                maxAge: maxAgeSecs,
                // Please refer to the discussion for more details
                // https://ohou-se.slack.com/archives/C05JQR22E13/p1701678839504499
                path: '/',
            },
        ]);
    }
    // Append access token as cookie entry if any.
    if (accessToken != null) {
        entries.push([
            client_ACCESS_TOKEN_COOKIE_NAME,
            accessToken.raw,
            {
                domain: cookieDomain,
                maxAge: maxAgeSecs,
                path: '/',
                // FIXME: can we enable secure cookie? (investigation needed on local)
            },
        ]);
    }
    // Append access token's expiry as cookie entry if any.
    if (accessTokenExpiry != null) {
        entries.push([
            client_ACCESS_TOKEN_EXPIRY_COOKIE_NAME,
            client_formatAuthTokenExpiry(accessTokenExpiry),
            {
                domain: cookieDomain,
                maxAge: maxAgeSecs,
                path: '/',
            },
        ]);
    }
    else if ((accessToken === null || accessToken === void 0 ? void 0 : accessToken.expiresAt) != null) {
        // Fallback to the expiry from the access token if any.
        entries.push([
            client_ACCESS_TOKEN_EXPIRY_COOKIE_NAME,
            client_formatAuthTokenExpiry(accessToken.expiresAt),
            {
                domain: cookieDomain,
                path: '/',
            },
        ]);
    }
    return entries;
}

/**
 * Extract the refresh token from the response headers.
 */
function client_extractRefreshTokenFromSetCookie(input) {
    var _a;
    const setCookieEntries = client_parseSetCookieEntries(input);
    return (_a = setCookieEntries.find(([name]) => name === client_REFRESH_TOKEN_COOKIE_NAME)) === null || _a === void 0 ? void 0 : _a[1];
}

class client_JwtAuth {
    constructor(options) {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        Object.defineProperty(this, "options", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "logger", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "isTokenRefreshing", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "isTokenUpdating", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "sharedRefreshAttempts", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "fencingToken", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "signals", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.options = {
            cookieDomain: options.cookieDomain,
            keepSignedIn: (_a = options.keepSignedIn) !== null && _a !== void 0 ? _a : true,
            sessionMaxAgeSecs: (_b = options.sessionMaxAgeSecs) !== null && _b !== void 0 ? _b : client_DEFAULT_SESSION_EXPIRATION_TIME,
            retryLimit: (_c = options.retryLimit) !== null && _c !== void 0 ? _c : 3,
            maxTokenRefresh: (_d = options.maxTokenRefresh) !== null && _d !== void 0 ? _d : 3,
            resetRetryCount: (_e = options.resetRetryCount) !== null && _e !== void 0 ? _e : false,
            fetchHeaders: options.fetchHeaders,
            fetchCookie: options.fetchCookie,
            refreshApiFn: options.refreshApiFn,
            predicateTokenExpired: (_f = options.predicateTokenExpired) !== null && _f !== void 0 ? _f : client_defaultPredicateTokenExpired,
            filterHeaders: (_g = options.filterHeaders) !== null && _g !== void 0 ? _g : client_defaultFilterHeaders,
            onTokenUpdate: options.onTokenUpdate,
            onSessionExpired: options.onSessionExpired,
        };
        this.logger = (_h = options.logger) !== null && _h !== void 0 ? _h : new client_NoopLogger();
        this.isTokenRefreshing = false;
        this.isTokenUpdating = false;
        this.sharedRefreshAttempts = 0;
        this.fencingToken = 0;
        this.signals = {
            tokenRefreshSignal: new client_Signal(),
            tokenRefreshCompleteSignal: new client_Signal(),
            tokenUpdateSignal: new client_Signal(),
            tokenUpdateCompleteSignal: new client_Signal(),
            setTokenReadySignal: new client_Signal(),
        };
        this.signals.tokenRefreshSignal.register(async (options) => {
            this.logger.info('Token refresh triggered.');
            if (options == null) {
                return;
            }
            this.logger.debug('Commencing token refresh..., with options:', options);
            // The retry count must be incremented only once within the time window
            // when the handlers are being called.
            // So, we are increasing the retry count right in the trigger signal.
            this.sharedRefreshAttempts++;
            let context;
            try {
                context = await this.processTokenRefresh({
                    lastRun: this.isTokenRefreshLimitReached(),
                    headers: options.headers,
                    tokenSet: options.tokenSet,
                });
                this.logger.info('Token refresh context received.');
                this.logger.debug('Token refresh result: ', context);
            }
            finally {
                // Before the token refresh process is complete, handle the token update.
                await this.signals.setTokenReadySignal.emit(undefined, { discardOnNoReceivers: true });
                this.isTokenRefreshing = false;
            }
            // Wait for all waiting handlers to receive the new token.
            await this.signals.tokenRefreshCompleteSignal.emit(context, { discardOnNoReceivers: true });
            this.logger.info('Token refresh process finished.');
        }, { takeLatest: true });
        this.signals.tokenUpdateSignal.register(async (command) => {
            var _a, _b, _c, _d;
            this.logger.info('Commencing token update...');
            if (command == null) {
                return;
            }
            this.isTokenUpdating = true;
            this.logger.debug('Calling the user-defined token update callback, with command:', command);
            try {
                switch (command.type) {
                    case 'updateToken': {
                        await ((_b = (_a = this.options).onTokenUpdate) === null || _b === void 0 ? void 0 : _b.call(_a, command.descriptor));
                        break;
                    }
                    case 'setSessionExpired': {
                        await ((_d = (_c = this.options).onSessionExpired) === null || _d === void 0 ? void 0 : _d.call(_c, command.info));
                        break;
                    }
                    default: {
                        // noop
                    }
                }
            }
            catch (err) {
                this.logger.error('Token update failed:', err);
            }
            finally {
                this.isTokenUpdating = false;
                await this.signals.tokenUpdateCompleteSignal.emit(undefined, { discardOnNoReceivers: true });
            }
        }, { takeLatest: true });
    }
    /**
     * Check whether the user is signed in or not.
     *
     * @returns A promise that resolves with `true` if the user is signed in, `false` otherwise.
     */
    async isSignedIn() {
        if (this.isTokenUpdating) {
            await this.signals.tokenUpdateCompleteSignal.waitOnce();
        }
        const headers = await this.getHeaders();
        const cookies = await this.getCookies(headers);
        return client_parseAuthTokenExpiry(cookies[client_ACCESS_TOKEN_EXPIRY_COOKIE_NAME]) != null;
    }
    /**
     * Handle API requests with authentication.
     *
     * Throw an `AuthError` to indicate that token refresh is required.
     *
     * If the authentication process is failed, the `fn` function will be called
     * **again** with the empty context, so that the request can make progress
     * without authentication.
     *
     * @param fn The function to handle the request.
     * @returns A promise that resolves when the request is finished.
     */
    async handleAuth(fn, options) {
        var _a, _b, _c;
        this.logger.info('Invoking authorization handler...');
        if (this.isTokenUpdating) {
            this.logger.info('Waiting for the token update to complete.');
            await this.signals.tokenUpdateCompleteSignal.waitOnce();
        }
        this.logger.debug('Reading headers and cookies for the current authentication context...');
        const headers = await this.getHeaders();
        const cookies = await this.getCookies(headers);
        // Since we have restricted access to the actual access token from the
        // client-side, the only way to check if the user is logged in is to check
        // the expiry marker in the client-readable cookies.
        //
        // Please refer to this document for more details:
        // https://www.notion.so/ohouse/Web-JWT-compliance-c0c7a1349e9b462d803aa6b4bf12a00b?pvs=4#81136b92de00403790abe6ab5da4fe03
        this.logger.info('Checking if the session is active...');
        this.logger.info('Reading the expiration status of the access token (ohouse-aat-expiry) from the cookies...');
        const accessTokenExpiry = client_parseAuthTokenExpiry(cookies[client_ACCESS_TOKEN_EXPIRY_COOKIE_NAME]);
        if (accessTokenExpiry == null) {
            // The user is not logged in.
            //
            // Just continue with an empty context, so that
            // the user can proceed with unauthorized requests if possible.
            this.logger.info('The access token expiry (ohouse-aat-expiry) is not available in this context. Considering this session as a guest.');
            return fn(this.buildUnauthorizedJwtAuthContext({ headers, isGuest: true, canRetry: false }));
        }
        this.logger.info('The access token expiry (ohouse-aat-expiry) is present and valid in this context. Proceeding to the authorization process.');
        const runWithEmptyContext = async () => {
            try {
                return await fn(this.buildUnauthorizedJwtAuthContext({ headers, canRetry: false }));
            }
            catch (err) {
                // Throw abort error so that no retry will be performed.
                throw new client_AbortError(err);
            }
        };
        let currentRefreshToken = client_parseAuthToken(cookies[client_REFRESH_TOKEN_COOKIE_NAME]);
        let currentAccessToken = client_parseAuthToken(cookies[client_ACCESS_TOKEN_COOKIE_NAME]);
        let currentAccessTokenExpiry = accessTokenExpiry;
        let shouldOverrideNextRefresh = false;
        this.logger.debug(`Current tokens (raw): RT=${(_a = currentRefreshToken === null || currentRefreshToken === void 0 ? void 0 : currentRefreshToken.raw) !== null && _a !== void 0 ? _a : 'N/A'} AT=${(_b = currentAccessToken === null || currentAccessToken === void 0 ? void 0 : currentAccessToken.raw) !== null && _b !== void 0 ? _b : 'N/A'} AT-EXP: ${(_c = currentAccessTokenExpiry === null || currentAccessTokenExpiry === void 0 ? void 0 : currentAccessTokenExpiry.toISOString()) !== null && _c !== void 0 ? _c : 'N/A'}`);
        this.logger.debug('Current tokens (actual):', currentRefreshToken, currentAccessToken, currentAccessTokenExpiry);
        return this.retryWithFencing(async (attemptCount) => {
            var _a;
            this.logger.info(`Running authorization process... (attempts: ${attemptCount})`);
            let context;
            const shouldRefresh = this.options.predicateTokenExpired({
                accessTokenExpiry: currentAccessTokenExpiry,
                accessToken: currentAccessToken === null || currentAccessToken === void 0 ? void 0 : currentAccessToken.raw,
                refreshToken: currentRefreshToken === null || currentRefreshToken === void 0 ? void 0 : currentRefreshToken.raw,
            });
            this.logger.info(`Check whether the current token is expired; current status: ${shouldRefresh ? '"expired"' : '"valid"'}, force refresh: ${(_a = options === null || options === void 0 ? void 0 : options.forceRefresh) !== null && _a !== void 0 ? _a : false}, override: ${shouldOverrideNextRefresh}`);
            if ((options === null || options === void 0 ? void 0 : options.forceRefresh) || shouldOverrideNextRefresh || shouldRefresh) {
                shouldOverrideNextRefresh = false;
                if (!this.options.keepSignedIn) {
                    this.logger.info('The application has opted not to maintain signed-in status, so the session will be marked as expired.');
                    await this.signals.tokenUpdateSignal.emit(client_createTokenExpirationCommand({
                        reason: 'noRevalidation',
                        cookieOptions: {
                            cookieDomain: this.options.cookieDomain,
                        },
                    }));
                    return runWithEmptyContext();
                }
                // If this instance is the first to trigger the token refresh.
                if (!this.isTokenRefreshing) {
                    this.isTokenRefreshing = true;
                    this.logger.info('No active token refresh process found; initiating token refresh.');
                    this.signals.tokenRefreshSignal.emit({
                        headers,
                        tokenSet: {
                            refreshToken: currentRefreshToken,
                            accessToken: currentAccessToken,
                            accessTokenExpiry: currentAccessTokenExpiry,
                        },
                    });
                }
                this.logger.info('Waiting for completion of the current token refresh process...');
                const result = await this.signals.tokenRefreshCompleteSignal.waitOnce();
                if (result == null) {
                    this.logger.error('Received invalid context from the token refresh process.');
                    throw new client_InternalAuthError();
                }
                this.logger.info('Token refresh process completed, proceeding with the new set of tokens.');
                // Set the new access/refresh tokens for next rounds.
                currentRefreshToken = result.refreshTokenParsed;
                currentAccessToken = result.accessTokenParsed;
                currentAccessTokenExpiry = result.accessTokenExpiry;
                context = result;
            }
            else {
                this.logger.info('Token refresh is not required, proceeding with the current set of tokens.');
                // There are some cases where the access token is in fact invalid even
                // when the expiry is not reached due to server-side errors.
                // So we mark the next refresh is required when the access token is considered already valid.
                shouldOverrideNextRefresh = true;
                context = this.buildAuthorizedJwtAuthContext({
                    lastRun: this.isTokenRefreshLimitReached(),
                    headers,
                    tokenSet: {
                        accessToken: currentAccessToken,
                        refreshToken: currentRefreshToken,
                        accessTokenExpiry: currentAccessTokenExpiry,
                    },
                });
            }
            try {
                this.logger.info('Running the user-defined authentication handler...');
                return await fn(context);
            }
            catch (err) {
                // Retry the request when the user requested the re-authentication.
                // This can happen when the access token is expired during the api calls.
                if (err instanceof client_AuthError) {
                    // If the user choose to continue with no auth, just continue with an empty context.
                    this.logger.error(`Failed to run user-defined authentication handler. (${attemptCount} attempts)`);
                    if (err.continueWithNoAuth) {
                        this.logger.warn('Resorting to the guest context as the user marked the request to continue without authentication.');
                        return runWithEmptyContext();
                    }
                    throw err;
                }
                // Otherwise, just bail with the error. All normal errors other than
                // `AuthError` must be thrown as-is.
                throw new client_AbortError(err);
            }
        });
    }
    /**
     * Get the authentication context.
     *
     * This method is useful when you only want to get the authentication context
     * without retrying the request.
     */
    async getAuthContext(options) {
        this.logger.info('Getting the authentication context...');
        return this.handleAuth(({ canRetry: _canRetry, retryAuth: _retryAuth, throwAuthError: _throwAuthError, throwAuthErrorIfPossible: _throwAuthErrorIfPossible, ...restCtx }) => ({ ...restCtx }), options);
    }
    /**
     * Trigger the access token refresh.
     *
     * This method is useful when you only want to trigger the token refresh
     * without retrying the request.
     */
    async refreshAccessToken(options) {
        this.logger.info('Triggering the access token refresh...');
        return this.handleAuth(() => { }, options);
    }
    /**
     * Set the access token.
     *
     * If the `token` parameter is `undefined` or **invalid**, it will be treated
     * as a sign-out operation.
     *
     * The setting of the access token is concurrency-controlled. If this method
     * is invoked during the token refresh process, it will be queued after the
     * other refresh process is complete.
     *
     * If you prefer not to wait for the refresh process to complete, you can omit
     * the `await` keyword when using the returned promise.
     *
     * Please note that this method will only work on the server-side since the
     * client-side cannot set the HttpOnly cookies with `set-cookie` header.
     *
     * @param token The access token to set. Use `undefined` to sign out.
     */
    async setAccessToken(token) {
        this.logger.info('Setting the access token manually...');
        if (this.isTokenRefreshing) {
            await this.signals.setTokenReadySignal.waitOnce();
        }
        // Make sure to prevent a new token refresh process from being triggered
        // until the token is updated.
        await this.signals.tokenRefreshSignal.transact(async () => {
            const parsedToken = client_parseAuthToken(token);
            const updateDescriptor = parsedToken != null
                ? client_createTokenUpdateCommand({
                    tokenSet: {
                        refreshToken: undefined,
                        accessToken: parsedToken,
                        accessTokenExpiry: parsedToken.expiresAt,
                    },
                    cookieOptions: {
                        cookieDomain: this.options.cookieDomain,
                        maxAgeSecs: this.options.sessionMaxAgeSecs,
                    },
                })
                : client_createTokenExpirationCommand({
                    reason: 'manualInvalidation',
                    cookieOptions: {
                        cookieDomain: this.options.cookieDomain,
                    },
                });
            await this.signals.tokenUpdateSignal.emit(updateDescriptor);
        });
    }
    /**
     * Reset the shared token refresh count, so that it allows the next refresh request to be retried.
     */
    resetSharedTokenRefreshCount() {
        this.sharedRefreshAttempts = 0;
    }
    async retryWithFencing(run) {
        const { fencingToken } = this;
        this.fencingToken++;
        try {
            return await client_retry(async (attemptCount, maxAttempts) => run(attemptCount, maxAttempts), {
                limit: this.options.retryLimit,
                // There must be no delay between the retries. Otherwise, the SSR will be delayed.
                delay: () => 0,
            });
        }
        catch (err) {
            if (err instanceof client_AbortError) {
                throw err.originalError;
            }
            throw err;
        }
        finally {
            // Reset the shared retry count if the current handler call is the last one
            // and there's no following handler calls.
            if (this.options.resetRetryCount && fencingToken === this.fencingToken) {
                this.sharedRefreshAttempts = 0;
            }
        }
    }
    isTokenRefreshLimitReached() {
        return this.sharedRefreshAttempts >= this.options.maxTokenRefresh;
    }
    async processTokenRefresh(options) {
        const refreshTokenCallHeaders = client_extendTokenRefreshHeaders({
            headers: options.headers,
            tokenSet: options.tokenSet,
        });
        const result = await this.requestTokenRefresh(refreshTokenCallHeaders);
        switch (result.type) {
            case 'failure': {
                // If the server has flagged the session as expired, mark the session as expired immediately.
                await this.signals.tokenUpdateSignal.emit(client_createTokenExpirationCommand({
                    reason: 'refreshFailed',
                    cookieOptions: {
                        cookieDomain: this.options.cookieDomain,
                    },
                }));
                return this.buildUnauthorizedJwtAuthContext({
                    headers: options.headers,
                    // We should treat the session expired as a guest session.
                    isGuest: true,
                    canRetry: false,
                });
            }
            case 'retry': {
                // If it's not the last run, just return `undefined` so that the upstream
                // can pick up to trigger retry.
                if (!options.lastRun) {
                    return undefined;
                }
                // The max retry limit is reached and all authentication attempts failed.
                // Notify that the session is expired and continue with an empty context.
                await this.signals.tokenUpdateSignal.emit(client_createTokenExpirationCommand({
                    reason: 'retryAttemptsFailed',
                    cookieOptions: {
                        cookieDomain: this.options.cookieDomain,
                    },
                }));
                return this.buildUnauthorizedJwtAuthContext({
                    headers: options.headers,
                    // We should treat the session expired as a guest session.
                    isGuest: true,
                });
            }
            case 'success': {
                const { data } = result;
                const tokenSet = {
                    refreshToken: data.refreshToken,
                    accessToken: data.accessToken,
                    accessTokenExpiry: data.accessTokenExpiry,
                };
                // Propagate the updated tokens.
                await this.signals.tokenUpdateSignal.emit(client_createTokenUpdateCommand({
                    headers: data.headers,
                    tokenSet,
                    useSetCookieAsIs: true,
                    cookieOptions: {
                        cookieDomain: this.options.cookieDomain,
                        maxAgeSecs: this.options.sessionMaxAgeSecs,
                    },
                }));
                return this.buildAuthorizedJwtAuthContext({
                    lastRun: options.lastRun,
                    headers: options.headers,
                    tokenSet,
                });
            }
            default: {
                throw new Error('Unreachable');
            }
        }
    }
    async requestTokenRefresh(headers) {
        try {
            const filteredHeaders = this.options.filterHeaders({ headers });
            const { body, headers: newHeaders } = await this.options.refreshApiFn({ headers: filteredHeaders });
            const newAccessToken = client_parseAuthToken(body.accessToken);
            if (newAccessToken == null) {
                return { type: 'retry' };
            }
            // Here we're extracting refresh token anyway regardless of the environment.
            // Since the client cannot access to the `set-cookie`, this is automatically no-op.
            //
            // In some runtime environments, the headers object does not have the `getSetCookie` method.
            // So we need to check the existence of the method first.
            const nextRefreshToken = 'getSetCookie' in newHeaders
                ? client_extractRefreshTokenFromSetCookie(newHeaders.getSetCookie())
                : undefined;
            return {
                type: 'success',
                data: {
                    headers: newHeaders,
                    refreshToken: client_parseAuthToken(nextRefreshToken),
                    accessToken: newAccessToken,
                    accessTokenExpiry: newAccessToken.expiresAt,
                },
            };
        }
        catch (err) {
            this.logger.error('API calls to token refresh failed:', err);
            if (err instanceof client_HttpError) {
                // If the token refresh request is failed due to the invalid refresh
                // token, mark the session as expired.
                if (err.response.status === 401) {
                    this.logger.error('Token refresh aborted as the server has flagged the session as expired.');
                    return { type: 'failure' };
                }
            }
            this.logger.error('Retrying token refresh...');
            return { type: 'retry' };
        }
    }
    buildAuthorizedJwtAuthContext(params) {
        var _a;
        const { refreshToken, accessToken, accessTokenExpiry } = params.tokenSet;
        const canRetry = !((_a = params.lastRun) !== null && _a !== void 0 ? _a : true);
        return {
            status: 'authorized',
            isGuest: false,
            canRetry,
            refreshToken: refreshToken === null || refreshToken === void 0 ? void 0 : refreshToken.raw,
            refreshTokenParsed: refreshToken,
            accessToken: accessToken === null || accessToken === void 0 ? void 0 : accessToken.raw,
            accessTokenParsed: accessToken,
            accessTokenExpiry: accessTokenExpiry !== null && accessTokenExpiry !== void 0 ? accessTokenExpiry : accessToken === null || accessToken === void 0 ? void 0 : accessToken.expiresAt,
            headers: client_buildAuthHeaders({ tokenSet: params.tokenSet }),
            fullHeaders: client_buildAuthHeaders({
                baseHeaders: params.headers,
                tokenSet: params.tokenSet,
                updateCookies: true,
            }),
            cookies: client_convertTokenSetIntoCookie(params.tokenSet),
            retryAuth: client_createRetryAuth(canRetry),
            throwAuthError: client_throwAuthError,
            throwAuthErrorIfPossible: client_createThrowAuthErrorIfPossible(canRetry),
        };
    }
    buildUnauthorizedJwtAuthContext(params) {
        var _a, _b;
        const isGuest = (_a = params.isGuest) !== null && _a !== void 0 ? _a : false;
        const headers = isGuest ? new Headers() : client_buildAuthHeaders();
        const canRetry = (_b = params.canRetry) !== null && _b !== void 0 ? _b : false;
        return {
            status: 'unauthorized',
            isGuest,
            canRetry,
            refreshToken: undefined,
            refreshTokenParsed: undefined,
            accessToken: undefined,
            accessTokenParsed: undefined,
            accessTokenExpiry: undefined,
            headers: isGuest ? new Headers() : client_buildAuthHeaders(),
            fullHeaders: isGuest ? headers : client_buildAuthHeaders({ baseHeaders: headers }),
            cookies: {},
            retryAuth: client_createRetryAuth(canRetry),
            throwAuthError: client_throwAuthError,
            throwAuthErrorIfPossible: client_createThrowAuthErrorIfPossible(canRetry),
        };
    }
    async getHeaders() {
        var _a, _b;
        return new Headers(await ((_b = (_a = this.options).fetchHeaders) === null || _b === void 0 ? void 0 : _b.call(_a)));
    }
    async getCookies(headers) {
        var _a, _b, _c;
        const cookie = await ((_b = (_a = this.options).fetchCookie) === null || _b === void 0 ? void 0 : _b.call(_a));
        const cookies = client_parseCookie((_c = cookie !== null && cookie !== void 0 ? cookie : headers === null || headers === void 0 ? void 0 : headers.get('cookie')) !== null && _c !== void 0 ? _c : '');
        // We need to look for the `set-cookie` header as well, since the `cookie`
        // header may be outdated on the server-side.
        const setCookies = headers != null && 'getSetCookie' in headers
            ? Object.fromEntries(client_parseSetCookieEntries(headers.getSetCookie()))
            : {};
        return { ...cookies, ...setCookies };
    }
}
function client_createTokenUpdateCommand(params) {
    var _a, _b;
    if (params.useSetCookieAsIs && params.headers != null && 'getSetCookie' in params.headers) {
        const setCookieRaw = params.headers.getSetCookie();
        return {
            type: 'updateToken',
            descriptor: {
                setCookieHeaders: params.headers,
                setCookieEntries: client_parseSetCookieEntries(setCookieRaw),
                setCookieEntriesSerialized: setCookieRaw,
                // Access token in this context cannot be `undefined` and always available.
                accessToken: params.tokenSet.accessToken.raw,
                refreshToken: (_a = params.tokenSet.refreshToken) === null || _a === void 0 ? void 0 : _a.raw,
            },
        };
    }
    const setCookieEntries = client_buildAuthSetCookieEntries({
        tokenSet: params.tokenSet,
        cookieOptions: params.cookieOptions,
    });
    const setCookieEntriesRaw = setCookieEntries.map((entry) => client_createSetCookieEntry(...entry));
    return {
        type: 'updateToken',
        descriptor: {
            setCookieHeaders: client_createHeadersWithSetCookieEntries({
                baseHeaders: params.headers,
                setCookieEntriesRaw,
            }),
            setCookieEntries,
            setCookieEntriesSerialized: setCookieEntries.map((entry) => client_createSetCookieEntry(...entry)),
            // Access token in this context cannot be `undefined` and always available.
            accessToken: params.tokenSet.accessToken.raw,
            refreshToken: (_b = params.tokenSet.refreshToken) === null || _b === void 0 ? void 0 : _b.raw,
        },
    };
}
function client_createTokenExpirationCommand(params) {
    const setCookieEntries = client_buildAuthExpirationSetCookieEntries({
        cookieOptions: params.cookieOptions,
    });
    return {
        type: 'setSessionExpired',
        info: {
            reason: params.reason,
            setCookieEntries,
            setCookieEntriesSerialized: setCookieEntries.map((entry) => client_createSetCookieEntry(...entry)),
        },
    };
}
function client_defaultPredicateTokenExpired(params) {
    return client_isDateExpired(params.accessTokenExpiry);
}
function client_defaultFilterHeaders(params) {
    return params.headers;
}

async function client_handleJwtAuth(options) {
    var _a;
    const inst = (_a = options.instance) !== null && _a !== void 0 ? _a : new client_JwtAuth(options);
    return inst.handleAuth((...args) => options.run(...args));
}

/**
 * Convenient function to handle JWT authentication on the client-side.
 * @param input
 * @returns
 */
async function clientHandleJwtAuth(input) {
    return client_handleJwtAuth({
        ...createDefaultJwtAuthClientOptions({ env: input.env, serviceType: input.serviceType }),
        ...input,
    });
}
/**
 * Create default JWT authentication options for the client-side.
 */
function createDefaultJwtAuthClientOptions(options) {
    return {
        cookieDomain: client_getCookieDomain(options === null || options === void 0 ? void 0 : options.env, options === null || options === void 0 ? void 0 : options.serviceType),
        fetchCookie: () => document.cookie,
        filterHeaders: (params) => {
            const newHeaders = new Headers(params.headers);
            // From the client-side, setting `cookie` header has no effect.
            newHeaders.delete('cookie');
            return newHeaders;
        },
        refreshApiFn: createClientRefreshApiFn(options === null || options === void 0 ? void 0 : options.env, options === null || options === void 0 ? void 0 : options.serviceType),
        resetRetryCount: true,
    };
}

class ClientSessionManager {
    constructor(options) {
        var _a;
        Object.defineProperty(this, "options", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "logger", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "instance", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "isReady", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "tokenRefreshTimeoutId", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "signals", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        const { env, serviceType, tokenExpirationInAdvance, ...jwtAuthOptions } = options;
        this.options = {
            tokenExpirationInAdvance: tokenExpirationInAdvance !== null && tokenExpirationInAdvance !== void 0 ? tokenExpirationInAdvance : client_DEFAULT_JWT_EXPIRATION_SAFE_MARGIN,
        };
        this.logger = (_a = options.logger) !== null && _a !== void 0 ? _a : new client_NoopLogger();
        this.instance = new client_JwtAuth({
            ...createDefaultJwtAuthClientOptions({ env, serviceType }),
            ...jwtAuthOptions,
        });
        this.isReady = false;
        this.tokenRefreshTimeoutId = undefined;
        this.signals = {
            readySignal: new client_Signal(),
        };
        this.signals.readySignal.register(() => {
            this.isReady = true;
        }, { takeLatest: true });
        this.instance.signals.tokenRefreshCompleteSignal.afterEmit((context, meta) => {
            if (!meta.isLast) {
                return;
            }
            if ((context === null || context === void 0 ? void 0 : context.accessTokenExpiry) == null) {
                return;
            }
            this.logger.info('ClientSessionManager: Token refresh complete, setting up refresh timeout.');
            this.setupRefreshTimeout(context.accessTokenExpiry);
        });
    }
    /**
     * Prepare the client session manager.
     */
    async prepare() {
        // It should run a setup on the client-side only.
        if (typeof window === 'undefined') {
            return;
        }
        // Trigger the blank authentication to refresh the access token.
        await this.instance.handleAuth((context) => {
            // Start the refresh interval if the access token is available.
            if ((context === null || context === void 0 ? void 0 : context.accessTokenExpiry) == null) {
                return;
            }
            this.logger.info('ClientSessionManager: Prepare complete, setting up refresh timeout.');
            this.setupRefreshTimeout(context.accessTokenExpiry);
        });
        await this.signals.readySignal.emit();
    }
    /**
     * Handle API requests with authentication.
     *
     * Throw an `AuthError` to indicate that token refresh is required.
     *
     * If the authentication process is failed, the `fn` function will be called
     * **again** with the empty context, so that the request can make progress
     * without authentication.
     *
     * @param fn The function to handle the request.
     * @returns A promise that resolves when the request is finished.
     */
    async handleAuth(fn, options) {
        await this.waitForReady();
        return this.instance.handleAuth(fn, options);
    }
    /**
     * Get the authentication context.
     *
     * This method is useful when you only want to get the authentication context
     * without retrying the request.
     */
    async getAuthContext(options) {
        await this.waitForReady();
        return this.instance.getAuthContext(options);
    }
    /**
     * Trigger the refresh of the access token.
     *
     * This function triggers the process to refresh the access token, ensuring
     * that it remains valid and up-to-date.
     */
    async refreshAccessToken(options) {
        await this.waitForReady();
        return this.instance.refreshAccessToken(options);
    }
    async waitForReady() {
        if (this.isReady) {
            return;
        }
        this.logger.info('ClientSessionManager: Waiting for the ready signal.');
        // Wait for the `isReady` flag to be set.
        await this.signals.readySignal.waitOnce();
    }
    setupRefreshTimeout(expiresAt) {
        clearTimeout(this.tokenRefreshTimeoutId);
        const now = new Date();
        const timeDiff = Math.max(expiresAt.getTime() - now.getTime() - this.options.tokenExpirationInAdvance, 0);
        this.logger.info(`ClientSessionManager: Setting up refresh timeout in ${timeDiff}ms.`);
        this.tokenRefreshTimeoutId = setTimeout(() => {
            this.logger.info(`ClientSessionManager: Timer is up, refreshing access token.`);
            this.refreshAccessToken({ forceRefresh: true });
        }, timeDiff);
    }
}


//# sourceMappingURL=client.mjs.map

// EXTERNAL MODULE: ./src/common/index.ts + 5 modules
var common = __webpack_require__(23336);
;// CONCATENATED MODULE: ./src/common/jwt-auth.ts



var sessionManager = new ClientSessionManager({
  env: common/* APP_PROFILE */.ui,
  logger: new ConsoleLogger({
    logLevel: common/* APP_PROFILE */.ui !== 'prod' ? 'debug' : 'off'
  })
});

/***/ }),

/***/ 42928:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "j": function() { return /* binding */ Error; }
/* harmony export */ });
/* harmony import */ var _emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(12851);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(75271);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(22220);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _bucketplace_design_system__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(54939);
/* harmony import */ var _common__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(23336);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(83128);







var Error = function Error(_ref) {
  var statusCode = _ref.statusCode;
  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsxs */ .BX)(Container, {
    children: [(0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(Title, {
      children: statusCode || 'ERROR'
    }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(SubTitle, {
      children: "\uC8C4\uC1A1\uD569\uB2C8\uB2E4. \uC624\uB958\uAC00 \uBC1C\uC0DD\uD588\uC2B5\uB2C8\uB2E4."
    }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsxs */ .BX)(Content, {
      children: ["\uC694\uCCAD\uD558\uC2E0 \uD398\uC774\uC9C0\uB97C \uCC98\uB9AC\uD558\uB294 \uB3C4\uC911 \uC608\uAE30\uCE58 \uBABB\uD55C \uC624\uB958\uAC00 \uBC1C\uC0DD\uD588\uC2B5\uB2C8\uB2E4.", (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)("br", {}), "\uC11C\uBE44\uC2A4 \uC774\uC6A9\uC5D0 \uBD88\uD3B8\uC744 \uB4DC\uB824 \uB300\uB2E8\uD788 \uC8C4\uC1A1\uD569\uB2C8\uB2E4. \uCD5C\uB300\uD55C \uBE68\uB9AC \uBB38\uC81C\uB97C \uD574\uACB0\uD558\uB3C4\uB85D \uD558\uACA0\uC2B5\uB2C8\uB2E4."]
    }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
      href: _common__WEBPACK_IMPORTED_MODULE_3__/* .EVENT_HOST */ .hE,
      passHref: true,
      children: (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(Anchor, {
        children: "\uC774\uBCA4\uD2B8 \uD648\uC73C\uB85C \uB3CC\uC544\uAC00\uAE30"
      })
    })]
  });
};

var Container = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("div",  true ? {
  target: "ec7l3nb4"
} : 0)("text-align:center;padding:", (0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_5__.p)(40), ";", _bucketplace_design_system__WEBPACK_IMPORTED_MODULE_5__.M.max('mobile', "\n    padding: ".concat((0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_5__.p)(20), ";\n  ")), ";" + ( true ? "" : 0));

var Title = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("h1",  true ? {
  target: "ec7l3nb3"
} : 0)("color:", function (_ref2) {
  var theme = _ref2.theme;
  return theme.content.primary1.basic;
}, ";font-size:", (0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_5__.p)(100), ";font-weight:600;", _bucketplace_design_system__WEBPACK_IMPORTED_MODULE_5__.M.max('mobile', "\n    font-size: ".concat((0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_5__.p)(70), ";\n  ")), ";" + ( true ? "" : 0));

var SubTitle = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("h2",  true ? {
  target: "ec7l3nb2"
} : 0)("font-size:", (0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_5__.p)(24), ";font-weight:400;", _bucketplace_design_system__WEBPACK_IMPORTED_MODULE_5__.M.max('mobile', "\n    font-size: ".concat((0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_5__.p)(16), ";\n  ")), ";" + ( true ? "" : 0));

var Content = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("p",  true ? {
  target: "ec7l3nb1"
} : 0)("font-size:", (0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_5__.p)(16), ";margin:", (0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_5__.p)(30), " 0;", _bucketplace_design_system__WEBPACK_IMPORTED_MODULE_5__.M.max('mobile', "\n    font-size: ".concat((0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_5__.p)(14), ";\n  ")), ";" + ( true ? "" : 0));

var Anchor = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("a",  true ? {
  target: "ec7l3nb0"
} : 0)("display:flex;align-items:center;justify-content:center;margin:0 auto;background-color:", function (_ref3) {
  var theme = _ref3.theme;
  return theme.content.primary1.basic;
}, ";width:", (0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_5__.p)(200), ";height:", (0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_5__.p)(50), ";border-radius:", (0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_5__.p)(10), ";color:#FFFFFF;font-size:", (0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_5__.p)(18), ";line-height:", (0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_5__.p)(27), ";cursor:pointer;box-shadow:0 ", (0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_5__.p)(5), " ", (0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_5__.p)(5), " 0 rgb(0 0 0 / 20%);&:hover{transform:translate(0, ", (0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_5__.p)(5), ");box-shadow:none;}", _bucketplace_design_system__WEBPACK_IMPORTED_MODULE_5__.M.max('mobile', "\n    width: ".concat((0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_5__.p)(150), ";\n    height: ").concat((0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_5__.p)(38), ";\n    border-radius: ").concat((0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_5__.p)(7), ";\n    font-size: ").concat((0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_5__.p)(14), ";\n    line-height: ").concat((0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_5__.p)(21), ";\n  ")), ";" + ( true ? "" : 0));

/***/ }),

/***/ 3600:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "X_": function() { return /* reexport */ CONTENTS_EXPERIMENT_TYPE; },
  "Ar": function() { return /* reexport */ Layout; },
  "Xg": function() { return /* reexport */ PageLayout; },
  "jf": function() { return /* reexport */ SuperLink; }
});

// UNUSED EXPORTS: CONTENTS_EXPERIMENT_KEY, DefaultHead, FooterContainer, Header, HeaderContainer

// EXTERNAL MODULE: ./node_modules/.pnpm/@emotion+styled@11.13.0_@emotion+react@11.13.3_@types+react@18.3.12_react@18.3.1/node_modules/@emotion/styled/base/dist/emotion-styled-base.browser.esm.js
var emotion_styled_base_browser_esm = __webpack_require__(12851);
// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.3.1/node_modules/react/index.js
var react = __webpack_require__(75271);
// EXTERNAL MODULE: ./node_modules/.pnpm/@bucketplace+design-system@5.3.3_@bucketplace+ui@1.0.9_@emotion+react@11.13.3_@emotion+styled_gws5alfnqy5ixwsabrkna3jsv4/node_modules/@bucketplace/design-system/dist/esm/bds.js + 72 modules
var bds = __webpack_require__(85435);
// EXTERNAL MODULE: ./src/common/index.ts + 5 modules
var common = __webpack_require__(23336);
// EXTERNAL MODULE: ./src/utils/index.ts + 7 modules
var utils = __webpack_require__(73387);
// EXTERNAL MODULE: ./node_modules/.pnpm/@emotion+react@11.13.3_@types+react@18.3.12_react@18.3.1/node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(83128);
;// CONCATENATED MODULE: ./src/components/Layout/FooterContainer.tsx


function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }






var FooterContainer = function FooterContainer(_ref) {
  var footerRef = _ref.footerRef;
  if ((0,utils/* isInApp */.Z0)()) return null;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Container, {
    ref: footerRef,
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(bds/* OhouseFooter */.wbw, {
      ohouseFooterLinks: (0,bds/* createOhouseFooterLinkSchema */.xd5)({
        ohs: common/* OHS_HOST */.K2,
        pro: common/* DOMAINS.O2O_PARTNER */.w7.O2O_PARTNER
      })
    })
  });
};

var Container = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1weh65o0"
} : 0)( true ? {
  name: "1lzs13d",
  styles: "position:absolute;bottom:0;width:100%"
} : 0);
// EXTERNAL MODULE: ./node_modules/.pnpm/next@12.3.4_@babel+core@7.26.0_react-dom@18.3.1_react@18.3.1_sass@1.80.4/node_modules/next/router.js
var next_router = __webpack_require__(17966);
// EXTERNAL MODULE: ./node_modules/.pnpm/@bucketplace+common@3.5.27_@bucketplace+config@0.1.2_@bucketplace+design-system@5.3.3_@bucket_ang3clxi3vvz7qz7nviwjn5pii/node_modules/@bucketplace/common/dist/index.es.js
var index_es = __webpack_require__(73581);
// EXTERNAL MODULE: ./src/provider/index.ts + 9 modules
var provider = __webpack_require__(90454);
// EXTERNAL MODULE: ./node_modules/.pnpm/next@12.3.4_@babel+core@7.26.0_react-dom@18.3.1_react@18.3.1_sass@1.80.4/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(88756);
// EXTERNAL MODULE: ./node_modules/.pnpm/next@12.3.4_@babel+core@7.26.0_react-dom@18.3.1_react@18.3.1_sass@1.80.4/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(85922);
// EXTERNAL MODULE: ./node_modules/.pnpm/next@12.3.4_@babel+core@7.26.0_react-dom@18.3.1_react@18.3.1_sass@1.80.4/node_modules/next/link.js
var next_link = __webpack_require__(22220);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
;// CONCATENATED MODULE: ./src/components/Link/SuperLink.tsx


var _excluded = ["href", "useAnchor", "children"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }




var SuperLink = function SuperLink(_ref) {
  var href = _ref.href,
      useAnchor = _ref.useAnchor,
      children = _ref.children,
      props = (0,objectWithoutProperties/* default */.Z)(_ref, _excluded);

  if (useAnchor) {
    return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("a", _objectSpread(_objectSpread({
      href: href
    }, props), {}, {
      children: children
    }));
  }

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
    href: href || '',
    passHref: true,
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("a", _objectSpread(_objectSpread({
      href: href
    }, props), {}, {
      children: children
    }))
  });
};
;// CONCATENATED MODULE: ./src/components/Layout/Header.tsx










var Header = function Header() {
  var _useUserContext = (0,provider/* useUserContext */.SE)(),
      userInfo = _useUserContext.userInfo,
      pcBanner = _useUserContext.pcBanner,
      nav = _useUserContext.nav,
      rawLoginUser = _useUserContext.rawLoginUser;

  var router = (0,next_router.useRouter)();
  var pathname = router.pathname,
      query = router.query;
  var search = "?".concat((0,utils/* getQueryString */.Wz)(query));
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
    children: [pcBanner && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(bds/* NavigationTopBanner */.ZiW, {
      location: {
        pathname: pathname,
        search: search
      },
      pcContentList: pcBanner,
      linkComponent: SuperLink,
      onAppOpen: utils/* handleOpenApp */.Qe,
      onLog: utils/* handleLog */.mT,
      isUserLoggedIn: !!userInfo.user
    }), !(0,utils/* isInApp */.Z0)() && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(index_es/* GNB */.Dk8, {
      linkComponent: "a",
      location: {
        pathname: pathname,
        search: search,
        origin: "https://events.ohou.se",
        hash: ''
      },
      env: "prod",
      subdomain: "events",
      menus: nav === null || nav === void 0 ? void 0 : nav.menus,
      supplementary: nav === null || nav === void 0 ? void 0 : nav.supplementary,
      searchMenus: nav === null || nav === void 0 ? void 0 : nav.searchMenus,
      trendingKeywords: nav === null || nav === void 0 ? void 0 : nav.trendingKeywords,
      getDeepLink: utils/* getDeepLink */.bW,
      user: rawLoginUser
    })]
  });
};
// EXTERNAL MODULE: ./node_modules/.pnpm/@bucketplace+xpc-sdk@1.3.7_@emotion+react@11.13.3_@emotion+styled@11.13.0_querystring@0.2.1_r_xg6uqiilojwxnlzpj6p7yiiceq/node_modules/@bucketplace/xpc-sdk/dist/index.esm.js
var index_esm = __webpack_require__(56738);
// EXTERNAL MODULE: ./src/hooks/Navigation/index.ts + 5 modules
var Navigation = __webpack_require__(88824);
;// CONCATENATED MODULE: ./src/components/Layout/HeaderContainer.tsx






var CONTENTS_EXPERIMENT_KEY = 641;
var CONTENTS_EXPERIMENT_TYPE = {
  LEGACY: 'A',
  NEW: 'B'
};
var HeaderContainer = function HeaderContainer() {
  var router = (0,next_router.useRouter)();

  var _useExperimentType = (0,index_esm/* useExperimentType */.XB)({
    experimentKey: CONTENTS_EXPERIMENT_KEY,
    type: 'AB'
  }),
      _useExperimentType$ex = _useExperimentType.experimentType,
      contentsRenewalExperimentType = _useExperimentType$ex === void 0 ? CONTENTS_EXPERIMENT_TYPE.LEGACY : _useExperimentType$ex;

  var experiments = {
    contents: contentsRenewalExperimentType
  };

  var _useNavigationMenu = (0,Navigation/* useNavigationMenu */.N1)(router.pathname, experiments),
      navigationMenu = _useNavigationMenu.data,
      error = _useNavigationMenu.error;

  if (error || !navigationMenu) return null;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Header, {});
};
// EXTERNAL MODULE: ./node_modules/.pnpm/next@12.3.4_@babel+core@7.26.0_react-dom@18.3.1_react@18.3.1_sass@1.80.4/node_modules/next/head.js
var head = __webpack_require__(27512);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./node_modules/.pnpm/next@12.3.4_@babel+core@7.26.0_react-dom@18.3.1_react@18.3.1_sass@1.80.4/node_modules/next/script.js
var script = __webpack_require__(32779);
var script_default = /*#__PURE__*/__webpack_require__.n(script);
// EXTERNAL MODULE: ./src/utils/Navigation/index.ts + 4 modules
var utils_Navigation = __webpack_require__(89369);
;// CONCATENATED MODULE: ./src/components/Layout/DefaultHead.tsx




var DefaultHead = /*#__PURE__*/(0,react.memo)(function () {
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)((head_default()), {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("title", {
      children: "\uC624\uB298\uC758\uC9D1 \uC774\uBCA4\uD2B8"
    }, "head-title"), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("meta", {
      charSet: "utf-8",
      lang: "ko"
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("meta", {
      name: "naver-site-verification",
      content: "6ca7ff6f5a2c14babde6ac5aec0171afa0b76049"
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("meta", {
      name: "viewport",
      content: "width=device-width,initial-scale=1.0,minimum-scale=1.0,maximum-scale=1.0,viewport-fit=cover"
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("link", {
      rel: "icon",
      href: "/favicon.ico"
    })]
  });
});
;// CONCATENATED MODULE: ./src/components/Layout/Layout.tsx









var Layout = function Layout(_ref) {
  var children = _ref.children;

  var _useUserContext = (0,provider/* useUserContext */.SE)(),
      userInfo = _useUserContext.userInfo;

  var isClientSide = true;
  (0,react.useEffect)(function () {
    if (!isClientSide || !userInfo) return;
    (0,utils_Navigation/* runMarketingHeaderScript */.Ht)(userInfo === null || userInfo === void 0 ? void 0 : userInfo.user);
    (0,utils_Navigation/* runMarketingFooterScript */.d4)(userInfo === null || userInfo === void 0 ? void 0 : userInfo.user);
  }, [userInfo, isClientSide]);
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DefaultHead, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((head_default()), {
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: (0,utils_Navigation/* getMarketingHeaderScript */.JM)(userInfo)
      })
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((script_default()), {
      type: "application/ld+json",
      dangerouslySetInnerHTML: {
        __html: JSON.stringify({
          '@context': 'http://schema.org',
          '@type': 'Organization',
          'name': '오늘의집',
          'url': 'https://ohou.se',
          'sameAs': ['https://www.instagram.com/todayhouse/?hl=ko', 'https://www.facebook.com/interiortoday', 'https://m.post.naver.com/my.nhn?memberNo=202156', 'https://itunes.apple.com/kr/app/id1008236892', 'https://play.google.com/store/apps/details?id=net.bucketplace&hl=ko', 'https://www.youtube.com/channel/UCBKtitA1RwY7F32rCniV1dA/featured']
        })
      }
    }, "json-script"), children, (0,utils_Navigation/* getMarketingFooterScript */.hA)()]
  });
};
;// CONCATENATED MODULE: ./node_modules/.pnpm/clsx@1.2.1/node_modules/clsx/dist/clsx.m.js
function r(e){var t,f,n="";if("string"==typeof e||"number"==typeof e)n+=e;else if("object"==typeof e)if(Array.isArray(e))for(t=0;t<e.length;t++)e[t]&&(f=r(e[t]))&&(n&&(n+=" "),n+=f);else for(t in e)e[t]&&(n&&(n+=" "),n+=t);return n}function clsx(){for(var e,t,f=0,n="";f<arguments.length;)(e=arguments[f++])&&(t=r(e))&&(n&&(n+=" "),n+=t);return n}/* harmony default export */ var clsx_m = (clsx);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-dom@18.3.1_react@18.3.1/node_modules/react-dom/index.js
var react_dom = __webpack_require__(30967);
;// CONCATENATED MODULE: ./node_modules/.pnpm/react-toastify@7.0.4_react-dom@18.3.1_react@18.3.1/node_modules/react-toastify/dist/react-toastify.esm.js




function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function isNum(v) {
  return typeof v === 'number' && !isNaN(v);
}
function isBool(v) {
  return typeof v === 'boolean';
}
function isStr(v) {
  return typeof v === 'string';
}
function isFn(v) {
  return typeof v === 'function';
}
function parseClassName(v) {
  return isStr(v) || isFn(v) ? v : null;
}
function isToastIdValid(toastId) {
  return toastId === 0 || toastId;
}
function getAutoCloseDelay(toastAutoClose, containerAutoClose) {
  return toastAutoClose === false || isNum(toastAutoClose) && toastAutoClose > 0 ? toastAutoClose : containerAutoClose;
}
var canUseDom = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
function canBeRendered(content) {
  return (0,react.isValidElement)(content) || isStr(content) || isFn(content) || isNum(content);
}

var POSITION = {
  TOP_LEFT: 'top-left',
  TOP_RIGHT: 'top-right',
  TOP_CENTER: 'top-center',
  BOTTOM_LEFT: 'bottom-left',
  BOTTOM_RIGHT: 'bottom-right',
  BOTTOM_CENTER: 'bottom-center'
};
var TYPE = {
  INFO: 'info',
  SUCCESS: 'success',
  WARNING: 'warning',
  ERROR: 'error',
  DEFAULT: 'default',
  DARK: 'dark'
};

/**
 * Used to collapse toast after exit animation
 */
function collapseToast(node, done, duration
/* COLLAPSE_DURATION */
) {
  if (duration === void 0) {
    duration = 300;
  }

  var height = node.scrollHeight;
  var style = node.style;
  requestAnimationFrame(function () {
    style.minHeight = 'initial';
    style.height = height + 'px';
    style.transition = "all " + duration + "ms";
    requestAnimationFrame(function () {
      style.height = '0';
      style.padding = '0';
      style.margin = '0';
      setTimeout(done, duration);
    });
  });
}

/**
 * Css animation that just work.
 * You could use animate.css for instance
 *
 *
 * ```
 * cssTransition({
 *   enter: "animate__animated animate__bounceIn",
 *   exit: "animate__animated animate__bounceOut"
 * })
 * ```
 *
 */

function cssTransition(_ref) {
  var enter = _ref.enter,
      exit = _ref.exit,
      _ref$appendPosition = _ref.appendPosition,
      appendPosition = _ref$appendPosition === void 0 ? false : _ref$appendPosition,
      _ref$collapse = _ref.collapse,
      collapse = _ref$collapse === void 0 ? true : _ref$collapse,
      _ref$collapseDuration = _ref.collapseDuration,
      collapseDuration = _ref$collapseDuration === void 0 ? 300 : _ref$collapseDuration;
  return function ToastTransition(_ref2) {
    var children = _ref2.children,
        position = _ref2.position,
        preventExitTransition = _ref2.preventExitTransition,
        done = _ref2.done,
        nodeRef = _ref2.nodeRef,
        isIn = _ref2.isIn;
    var enterClassName = appendPosition ? enter + "--" + position : enter;
    var exitClassName = appendPosition ? exit + "--" + position : exit;
    var baseClassName = (0,react.useRef)();
    var animationStep = (0,react.useRef)(0
    /* Enter */
    );
    (0,react.useLayoutEffect)(function () {
      onEnter();
    }, []);
    (0,react.useEffect)(function () {
      if (!isIn) preventExitTransition ? onExited() : onExit();
    }, [isIn]);

    function onEnter() {
      var node = nodeRef.current;
      baseClassName.current = node.className;
      node.className += " " + enterClassName;
      node.addEventListener('animationend', onEntered);
    }

    function onEntered() {
      var node = nodeRef.current;
      node.removeEventListener('animationend', onEntered);

      if (animationStep.current === 0
      /* Enter */
      ) {
          node.className = baseClassName.current;
        }
    }

    function onExit() {
      animationStep.current = 1
      /* Exit */
      ;
      var node = nodeRef.current;
      node.className += " " + exitClassName;
      node.addEventListener('animationend', onExited);
    }

    function onExited() {
      var node = nodeRef.current;
      node.removeEventListener('animationend', onExited);
      collapse ? collapseToast(node, done, collapseDuration) : done();
    }

    return react.createElement(react.Fragment, null, children);
  };
}

var eventManager = {
  list: /*#__PURE__*/new Map(),
  emitQueue: /*#__PURE__*/new Map(),
  on: function on(event, callback) {
    this.list.has(event) || this.list.set(event, []);
    this.list.get(event).push(callback);
    return this;
  },
  off: function off(event, callback) {
    if (callback) {
      var cb = this.list.get(event).filter(function (cb) {
        return cb !== callback;
      });
      this.list.set(event, cb);
      return this;
    }

    this.list["delete"](event);
    return this;
  },
  cancelEmit: function cancelEmit(event) {
    var timers = this.emitQueue.get(event);

    if (timers) {
      timers.forEach(clearTimeout);
      this.emitQueue["delete"](event);
    }

    return this;
  },

  /**
   * Enqueue the event at the end of the call stack
   * Doing so let the user call toast as follow:
   * toast('1')
   * toast('2')
   * toast('3')
   * Without setTimemout the code above will not work
   */
  emit: function emit(event) {
    var _this = this;

    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    this.list.has(event) && this.list.get(event).forEach(function (callback) {
      var timer = setTimeout(function () {
        // @ts-ignore
        callback.apply(void 0, args);
      }, 0);
      _this.emitQueue.has(event) || _this.emitQueue.set(event, []);

      _this.emitQueue.get(event).push(timer);
    });
  }
};

/**
 * `useKeeper` is a helper around `useRef`.
 *
 * You don't need to access the `.current`property to get the value
 * If refresh is set to true. The ref will be updated every render
 */

function useKeeper(arg, refresh) {
  if (refresh === void 0) {
    refresh = false;
  }

  var ref = (0,react.useRef)(arg);
  (0,react.useEffect)(function () {
    if (refresh) ref.current = arg;
  });
  return ref.current;
}

function reducer(state, action) {
  switch (action.type) {
    case 0
    /* ADD */
    :
      return [].concat(state, [action.toastId]).filter(function (id) {
        return id !== action.staleId;
      });

    case 1
    /* REMOVE */
    :
      return isToastIdValid(action.toastId) ? state.filter(function (id) {
        return id !== action.toastId;
      }) : [];
  }
}

function useToastContainer(props) {
  var _useReducer = (0,react.useReducer)(function (x) {
    return x + 1;
  }, 0),
      forceUpdate = _useReducer[1];

  var _useReducer2 = (0,react.useReducer)(reducer, []),
      toast = _useReducer2[0],
      dispatch = _useReducer2[1];

  var containerRef = (0,react.useRef)(null);
  var toastCount = useKeeper(0);
  var queue = useKeeper([]);
  var collection = useKeeper({});
  var instance = useKeeper({
    toastKey: 1,
    displayedToast: 0,
    props: props,
    containerId: null,
    isToastActive: isToastActive,
    getToast: function getToast(id) {
      return collection[id] || null;
    }
  });
  (0,react.useEffect)(function () {
    instance.containerId = props.containerId;
    eventManager.cancelEmit(3
    /* WillUnmount */
    ).on(0
    /* Show */
    , buildToast).on(1
    /* Clear */
    , function (toastId) {
      return containerRef.current && removeToast(toastId);
    }).on(5
    /* ClearWaitingQueue */
    , clearWaitingQueue).emit(2
    /* DidMount */
    , instance);
    return function () {
      return eventManager.emit(3
      /* WillUnmount */
      , instance);
    };
  }, []);
  (0,react.useEffect)(function () {
    instance.isToastActive = isToastActive;
    instance.displayedToast = toast.length;
    eventManager.emit(4
    /* Change */
    , toast.length, props.containerId);
  }, [toast]);
  (0,react.useEffect)(function () {
    instance.props = props;
  });

  function isToastActive(id) {
    return toast.indexOf(id) !== -1;
  }

  function clearWaitingQueue(_ref) {
    var containerId = _ref.containerId;
    var limit = instance.props.limit;

    if (limit && (!containerId || instance.containerId === containerId)) {
      toastCount -= queue.length;
      queue = [];
    }
  }

  function removeToast(toastId) {
    dispatch({
      type: 1
      /* REMOVE */
      ,
      toastId: toastId
    });
  }

  function dequeueToast() {
    var _queue$shift = queue.shift(),
        toastContent = _queue$shift.toastContent,
        toastProps = _queue$shift.toastProps,
        staleId = _queue$shift.staleId;

    appendToast(toastContent, toastProps, staleId);
  }
  /**
   * check if a container is attached to the dom
   * check for multi-container, build only if associated
   * check for duplicate toastId if no update
   */


  function isNotValid(_ref2) {
    var containerId = _ref2.containerId,
        toastId = _ref2.toastId,
        updateId = _ref2.updateId;
    return !containerRef.current || instance.props.enableMultiContainer && containerId !== instance.props.containerId || collection[toastId] && updateId == null ? true : false;
  } // this function and all the function called inside needs to rely on ref(`useKeeper`)


  function buildToast(content, _ref3) {
    var delay = _ref3.delay,
        staleId = _ref3.staleId,
        options = _objectWithoutPropertiesLoose(_ref3, ["delay", "staleId"]);

    if (!canBeRendered(content) || isNotValid(options)) return;
    var toastId = options.toastId,
        updateId = options.updateId;
    var props = instance.props;

    var closeToast = function closeToast() {
      return removeToast(toastId);
    };

    var isNotAnUpdate = options.updateId == null;
    if (isNotAnUpdate) toastCount++;
    var toastProps = {
      toastId: toastId,
      updateId: updateId,
      isIn: false,
      key: options.key || instance.toastKey++,
      type: options.type,
      closeToast: closeToast,
      closeButton: options.closeButton,
      rtl: props.rtl,
      position: options.position || props.position,
      transition: options.transition || props.transition,
      className: parseClassName(options.className || props.toastClassName),
      bodyClassName: parseClassName(options.bodyClassName || props.bodyClassName),
      style: options.style || props.toastStyle,
      bodyStyle: options.bodyStyle || props.bodyStyle,
      onClick: options.onClick || props.onClick,
      pauseOnHover: isBool(options.pauseOnHover) ? options.pauseOnHover : props.pauseOnHover,
      pauseOnFocusLoss: isBool(options.pauseOnFocusLoss) ? options.pauseOnFocusLoss : props.pauseOnFocusLoss,
      draggable: isBool(options.draggable) ? options.draggable : props.draggable,
      draggablePercent: isNum(options.draggablePercent) ? options.draggablePercent : props.draggablePercent,
      draggableDirection: options.draggableDirection || props.draggableDirection,
      closeOnClick: isBool(options.closeOnClick) ? options.closeOnClick : props.closeOnClick,
      progressClassName: parseClassName(options.progressClassName || props.progressClassName),
      progressStyle: options.progressStyle || props.progressStyle,
      autoClose: getAutoCloseDelay(options.autoClose, props.autoClose),
      hideProgressBar: isBool(options.hideProgressBar) ? options.hideProgressBar : props.hideProgressBar,
      progress: options.progress,
      role: isStr(options.role) ? options.role : props.role,
      deleteToast: function deleteToast() {
        removeFromCollection(toastId);
      }
    };
    if (isFn(options.onOpen)) toastProps.onOpen = options.onOpen;
    if (isFn(options.onClose)) toastProps.onClose = options.onClose; //  tweak for vertical dragging

    if (toastProps.draggableDirection === "y"
    /* Y */
    && toastProps.draggablePercent === 80
    /* DRAGGABLE_PERCENT */
    ) {
        toastProps.draggablePercent *= 1.5;
      }

    var closeButton = props.closeButton;

    if (options.closeButton === false || canBeRendered(options.closeButton)) {
      closeButton = options.closeButton;
    } else if (options.closeButton === true) {
      closeButton = canBeRendered(props.closeButton) ? props.closeButton : true;
    }

    toastProps.closeButton = closeButton;
    var toastContent = content;

    if ((0,react.isValidElement)(content) && !isStr(content.type)) {
      toastContent = (0,react.cloneElement)(content, {
        closeToast: closeToast,
        toastProps: toastProps
      });
    } else if (isFn(content)) {
      toastContent = content({
        closeToast: closeToast,
        toastProps: toastProps
      });
    } // not handling limit + delay by design. Waiting for user feedback first


    if (props.limit && props.limit > 0 && toastCount > props.limit && isNotAnUpdate) {
      queue.push({
        toastContent: toastContent,
        toastProps: toastProps,
        staleId: staleId
      });
    } else if (isNum(delay) && delay > 0) {
      setTimeout(function () {
        appendToast(toastContent, toastProps, staleId);
      }, delay);
    } else {
      appendToast(toastContent, toastProps, staleId);
    }
  }

  function appendToast(content, toastProps, staleId) {
    var toastId = toastProps.toastId;
    if (staleId) delete collection[staleId];
    collection[toastId] = {
      content: content,
      props: toastProps
    };
    dispatch({
      type: 0
      /* ADD */
      ,
      toastId: toastId,
      staleId: staleId
    });
  }

  function removeFromCollection(toastId) {
    delete collection[toastId];
    var queueLen = queue.length;
    toastCount = isToastIdValid(toastId) ? toastCount - 1 : toastCount - instance.displayedToast;
    if (toastCount < 0) toastCount = 0;

    if (queueLen > 0) {
      var freeSlot = isToastIdValid(toastId) ? 1 : instance.props.limit;

      if (queueLen === 1 || freeSlot === 1) {
        instance.displayedToast++;
        dequeueToast();
      } else {
        var toDequeue = freeSlot > queueLen ? queueLen : freeSlot;
        instance.displayedToast = toDequeue;

        for (var i = 0; i < toDequeue; i++) {
          dequeueToast();
        }
      }
    } else {
      forceUpdate();
    }
  }

  function getToastToRender(cb) {
    var toastToRender = {};
    var toastList = props.newestOnTop ? Object.keys(collection).reverse() : Object.keys(collection);

    for (var i = 0; i < toastList.length; i++) {
      var _toast = collection[toastList[i]];
      var position = _toast.props.position;
      toastToRender[position] || (toastToRender[position] = []);
      toastToRender[position].push(_toast);
    }

    return Object.keys(toastToRender).map(function (p) {
      return cb(p, toastToRender[p]);
    });
  }

  return {
    getToastToRender: getToastToRender,
    collection: collection,
    containerRef: containerRef,
    isToastActive: isToastActive
  };
}

function getX(e) {
  return e.targetTouches && e.targetTouches.length >= 1 ? e.targetTouches[0].clientX : e.clientX;
}

function getY(e) {
  return e.targetTouches && e.targetTouches.length >= 1 ? e.targetTouches[0].clientY : e.clientY;
}

function useToast(props) {
  var _useState = (0,react.useState)(true),
      isRunning = _useState[0],
      setIsRunning = _useState[1];

  var _useState2 = (0,react.useState)(false),
      preventExitTransition = _useState2[0],
      setPreventExitTransition = _useState2[1];

  var toastRef = (0,react.useRef)(null);
  var drag = useKeeper({
    start: 0,
    x: 0,
    y: 0,
    delta: 0,
    removalDistance: 0,
    canCloseOnClick: true,
    canDrag: false,
    boundingRect: null
  });
  var syncProps = useKeeper(props, true);
  var autoClose = props.autoClose,
      pauseOnHover = props.pauseOnHover,
      closeToast = props.closeToast,
      onClick = props.onClick,
      closeOnClick = props.closeOnClick;
  (0,react.useEffect)(function () {
    if (isFn(props.onOpen)) props.onOpen((0,react.isValidElement)(props.children) && props.children.props);
    return function () {
      if (isFn(syncProps.onClose)) syncProps.onClose((0,react.isValidElement)(syncProps.children) && syncProps.children.props);
    };
  }, []);
  (0,react.useEffect)(function () {
    props.draggable && bindDragEvents();
    return function () {
      props.draggable && unbindDragEvents();
    };
  }, [props.draggable]);
  (0,react.useEffect)(function () {
    props.pauseOnFocusLoss && bindFocusEvents();
    return function () {
      props.pauseOnFocusLoss && unbindFocusEvents();
    };
  }, [props.pauseOnFocusLoss]);

  function onDragStart(e) {
    if (props.draggable) {
      var toast = toastRef.current;
      drag.canCloseOnClick = true;
      drag.canDrag = true;
      drag.boundingRect = toast.getBoundingClientRect();
      toast.style.transition = '';
      drag.x = getX(e.nativeEvent);
      drag.y = getY(e.nativeEvent);

      if (props.draggableDirection === "x"
      /* X */
      ) {
          drag.start = drag.x;
          drag.removalDistance = toast.offsetWidth * (props.draggablePercent / 100);
        } else {
        drag.start = drag.y;
        drag.removalDistance = toast.offsetHeight * (props.draggablePercent / 100);
      }
    }
  }

  function onDragTransitionEnd() {
    if (drag.boundingRect) {
      var _drag$boundingRect = drag.boundingRect,
          top = _drag$boundingRect.top,
          bottom = _drag$boundingRect.bottom,
          left = _drag$boundingRect.left,
          right = _drag$boundingRect.right;

      if (props.pauseOnHover && drag.x >= left && drag.x <= right && drag.y >= top && drag.y <= bottom) {
        pauseToast();
      } else {
        playToast();
      }
    }
  }

  function playToast() {
    setIsRunning(true);
  }

  function pauseToast() {
    setIsRunning(false);
  }

  function bindFocusEvents() {
    if (!document.hasFocus()) pauseToast();
    window.addEventListener('focus', playToast);
    window.addEventListener('blur', pauseToast);
  }

  function unbindFocusEvents() {
    window.removeEventListener('focus', playToast);
    window.removeEventListener('blur', pauseToast);
  }

  function bindDragEvents() {
    document.addEventListener('mousemove', onDragMove);
    document.addEventListener('mouseup', onDragEnd);
    document.addEventListener('touchmove', onDragMove);
    document.addEventListener('touchend', onDragEnd);
  }

  function unbindDragEvents() {
    document.removeEventListener('mousemove', onDragMove);
    document.removeEventListener('mouseup', onDragEnd);
    document.removeEventListener('touchmove', onDragMove);
    document.removeEventListener('touchend', onDragEnd);
  }

  function onDragMove(e) {
    if (drag.canDrag) {
      e.preventDefault();
      var toast = toastRef.current;
      if (isRunning) pauseToast();
      drag.x = getX(e);
      drag.y = getY(e);

      if (props.draggableDirection === "x"
      /* X */
      ) {
          drag.delta = drag.x - drag.start;
        } else {
        drag.delta = drag.y - drag.start;
      } // prevent false positif during a toast click


      if (drag.start !== drag.x) drag.canCloseOnClick = false;
      toast.style.transform = "translate" + props.draggableDirection + "(" + drag.delta + "px)";
      toast.style.opacity = "" + (1 - Math.abs(drag.delta / drag.removalDistance));
    }
  }

  function onDragEnd() {
    var toast = toastRef.current;

    if (drag.canDrag) {
      drag.canDrag = false;

      if (Math.abs(drag.delta) > drag.removalDistance) {
        setPreventExitTransition(true);
        props.closeToast();
        return;
      }

      toast.style.transition = 'transform 0.2s, opacity 0.2s';
      toast.style.transform = "translate" + props.draggableDirection + "(0)";
      toast.style.opacity = '1';
    }
  }

  var eventHandlers = {
    onMouseDown: onDragStart,
    onTouchStart: onDragStart,
    onMouseUp: onDragTransitionEnd,
    onTouchEnd: onDragTransitionEnd
  };

  if (autoClose && pauseOnHover) {
    eventHandlers.onMouseEnter = pauseToast;
    eventHandlers.onMouseLeave = playToast;
  } // prevent toast from closing when user drags the toast


  if (closeOnClick) {
    eventHandlers.onClick = function (e) {
      onClick && onClick(e);
      drag.canCloseOnClick && closeToast();
    };
  }

  return {
    playToast: playToast,
    pauseToast: pauseToast,
    isRunning: isRunning,
    preventExitTransition: preventExitTransition,
    toastRef: toastRef,
    eventHandlers: eventHandlers
  };
}

function CloseButton(_ref) {
  var closeToast = _ref.closeToast,
      type = _ref.type,
      _ref$ariaLabel = _ref.ariaLabel,
      ariaLabel = _ref$ariaLabel === void 0 ? 'close' : _ref$ariaLabel;
  return (0,react.createElement)("button", {
    className: "Toastify"
    /* CSS_NAMESPACE */
    + "__close-button " + "Toastify"
    /* CSS_NAMESPACE */
    + "__close-button--" + type,
    type: "button",
    onClick: function onClick(e) {
      e.stopPropagation();
      closeToast(e);
    },
    "aria-label": ariaLabel
  }, (0,react.createElement)("svg", {
    "aria-hidden": "true",
    viewBox: "0 0 14 16"
  }, (0,react.createElement)("path", {
    fillRule: "evenodd",
    d: "M7.71 8.23l3.75 3.75-1.48 1.48-3.75-3.75-3.75 3.75L1 11.98l3.75-3.75L1 4.48 2.48 3l3.75 3.75L9.98 3l1.48 1.48-3.75 3.75z"
  })));
}

function ProgressBar(_ref) {
  var _cx, _animationEvent;

  var delay = _ref.delay,
      isRunning = _ref.isRunning,
      closeToast = _ref.closeToast,
      type = _ref.type,
      hide = _ref.hide,
      className = _ref.className,
      userStyle = _ref.style,
      controlledProgress = _ref.controlledProgress,
      progress = _ref.progress,
      rtl = _ref.rtl,
      isIn = _ref.isIn;

  var style = _extends({}, userStyle, {
    animationDuration: delay + "ms",
    animationPlayState: isRunning ? 'running' : 'paused',
    opacity: hide ? 0 : 1
  });

  if (controlledProgress) style.transform = "scaleX(" + progress + ")";
  var defaultClassName = clsx_m("Toastify"
  /* CSS_NAMESPACE */
  + "__progress-bar", controlledProgress ? "Toastify"
  /* CSS_NAMESPACE */
  + "__progress-bar--controlled" : "Toastify"
  /* CSS_NAMESPACE */
  + "__progress-bar--animated", "Toastify"
  /* CSS_NAMESPACE */
  + "__progress-bar--" + type, (_cx = {}, _cx["Toastify"
  /* CSS_NAMESPACE */
  + "__progress-bar--rtl"] = rtl, _cx));
  var classNames = isFn(className) ? className({
    rtl: rtl,
    type: type,
    defaultClassName: defaultClassName
  }) : clsx_m(defaultClassName, className); // 🧐 controlledProgress is derived from progress
  // so if controlledProgress is set
  // it means that this is also the case for progress

  var animationEvent = (_animationEvent = {}, _animationEvent[controlledProgress && progress >= 1 ? 'onTransitionEnd' : 'onAnimationEnd'] = controlledProgress && progress < 1 ? null : function () {
    isIn && closeToast();
  }, _animationEvent); // TODO: add aria-valuenow, aria-valuemax, aria-valuemin

  return (0,react.createElement)("div", Object.assign({
    role: "progressbar",
    "aria-hidden": hide ? 'true' : 'false',
    "aria-label": "notification timer",
    className: classNames,
    style: style
  }, animationEvent));
}
ProgressBar.defaultProps = {
  type: TYPE.DEFAULT,
  hide: false
};

var Toast = function Toast(props) {
  var _cx;

  var _useToast = useToast(props),
      isRunning = _useToast.isRunning,
      preventExitTransition = _useToast.preventExitTransition,
      toastRef = _useToast.toastRef,
      eventHandlers = _useToast.eventHandlers;

  var closeButton = props.closeButton,
      children = props.children,
      autoClose = props.autoClose,
      onClick = props.onClick,
      type = props.type,
      hideProgressBar = props.hideProgressBar,
      closeToast = props.closeToast,
      Transition = props.transition,
      position = props.position,
      className = props.className,
      style = props.style,
      bodyClassName = props.bodyClassName,
      bodyStyle = props.bodyStyle,
      progressClassName = props.progressClassName,
      progressStyle = props.progressStyle,
      updateId = props.updateId,
      role = props.role,
      progress = props.progress,
      rtl = props.rtl,
      toastId = props.toastId,
      deleteToast = props.deleteToast,
      isIn = props.isIn;
  var defaultClassName = clsx_m("Toastify"
  /* CSS_NAMESPACE */
  + "__toast", "Toastify"
  /* CSS_NAMESPACE */
  + "__toast--" + type, (_cx = {}, _cx["Toastify"
  /* CSS_NAMESPACE */
  + "__toast--rtl"] = rtl, _cx));
  var cssClasses = isFn(className) ? className({
    rtl: rtl,
    position: position,
    type: type,
    defaultClassName: defaultClassName
  }) : clsx_m(defaultClassName, className);
  var isProgressControlled = !!progress;

  function renderCloseButton(closeButton) {
    if (!closeButton) return;
    var props = {
      closeToast: closeToast,
      type: type
    };
    if (isFn(closeButton)) return closeButton(props);
    if ((0,react.isValidElement)(closeButton)) return (0,react.cloneElement)(closeButton, props);
  }

  return (0,react.createElement)(Transition, {
    isIn: isIn,
    done: deleteToast,
    position: position,
    preventExitTransition: preventExitTransition,
    nodeRef: toastRef
  }, (0,react.createElement)("div", Object.assign({
    id: toastId,
    onClick: onClick,
    className: cssClasses
  }, eventHandlers, {
    style: style,
    ref: toastRef
  }), (0,react.createElement)("div", Object.assign({}, isIn && {
    role: role
  }, {
    className: isFn(bodyClassName) ? bodyClassName({
      type: type
    }) : clsx_m("Toastify"
    /* CSS_NAMESPACE */
    + "__toast-body", bodyClassName),
    style: bodyStyle
  }), children), renderCloseButton(closeButton), (autoClose || isProgressControlled) && (0,react.createElement)(ProgressBar, Object.assign({}, updateId && !isProgressControlled ? {
    key: "pb-" + updateId
  } : {}, {
    rtl: rtl,
    delay: autoClose,
    isRunning: isRunning,
    isIn: isIn,
    closeToast: closeToast,
    hide: hideProgressBar,
    type: type,
    style: progressStyle,
    className: progressClassName,
    controlledProgress: isProgressControlled,
    progress: progress
  }))));
};

var Bounce = /*#__PURE__*/cssTransition({
  enter: "Toastify"
  /* CSS_NAMESPACE */
  + "--animate " + "Toastify"
  /* CSS_NAMESPACE */
  + "__bounce-enter",
  exit: "Toastify"
  /* CSS_NAMESPACE */
  + "--animate " + "Toastify"
  /* CSS_NAMESPACE */
  + "__bounce-exit",
  appendPosition: true
});
var Slide = /*#__PURE__*/cssTransition({
  enter: "Toastify"
  /* CSS_NAMESPACE */
  + "--animate " + "Toastify"
  /* CSS_NAMESPACE */
  + "__slide-enter",
  exit: "Toastify"
  /* CSS_NAMESPACE */
  + "--animate " + "Toastify"
  /* CSS_NAMESPACE */
  + "__slide-exit",
  appendPosition: true
});
var Zoom = /*#__PURE__*/cssTransition({
  enter: "Toastify"
  /* CSS_NAMESPACE */
  + "--animate " + "Toastify"
  /* CSS_NAMESPACE */
  + "__zoom-enter",
  exit: "Toastify"
  /* CSS_NAMESPACE */
  + "--animate " + "Toastify"
  /* CSS_NAMESPACE */
  + "__zoom-exit"
});
var Flip = /*#__PURE__*/cssTransition({
  enter: "Toastify"
  /* CSS_NAMESPACE */
  + "--animate " + "Toastify"
  /* CSS_NAMESPACE */
  + "__flip-enter",
  exit: "Toastify"
  /* CSS_NAMESPACE */
  + "--animate " + "Toastify"
  /* CSS_NAMESPACE */
  + "__flip-exit"
});

var ToastContainer = function ToastContainer(props) {
  var _useToastContainer = useToastContainer(props),
      getToastToRender = _useToastContainer.getToastToRender,
      containerRef = _useToastContainer.containerRef,
      isToastActive = _useToastContainer.isToastActive;

  var className = props.className,
      style = props.style,
      rtl = props.rtl,
      containerId = props.containerId;

  function getClassName(position) {
    var _cx;

    var defaultClassName = clsx_m("Toastify"
    /* CSS_NAMESPACE */
    + "__toast-container", "Toastify"
    /* CSS_NAMESPACE */
    + "__toast-container--" + position, (_cx = {}, _cx["Toastify"
    /* CSS_NAMESPACE */
    + "__toast-container--rtl"] = rtl, _cx));
    return isFn(className) ? className({
      position: position,
      rtl: rtl,
      defaultClassName: defaultClassName
    }) : clsx_m(defaultClassName, parseClassName(className));
  }

  return (0,react.createElement)("div", {
    ref: containerRef,
    className: "Toastify"
    /* CSS_NAMESPACE */
    ,
    id: containerId
  }, getToastToRender(function (position, toastList) {
    var containerStyle = toastList.length === 0 ? _extends({}, style, {
      pointerEvents: 'none'
    }) : _extends({}, style);
    return (0,react.createElement)("div", {
      className: getClassName(position),
      style: containerStyle,
      key: "container-" + position
    }, toastList.map(function (_ref) {
      var content = _ref.content,
          toastProps = _ref.props;
      return (0,react.createElement)(Toast, Object.assign({}, toastProps, {
        isIn: isToastActive(toastProps.toastId),
        key: "toast-" + toastProps.key,
        closeButton: toastProps.closeButton === true ? CloseButton : toastProps.closeButton
      }), content);
    }));
  }));
};
ToastContainer.defaultProps = {
  position: POSITION.TOP_RIGHT,
  transition: Bounce,
  rtl: false,
  autoClose: 5000,
  hideProgressBar: false,
  closeButton: CloseButton,
  pauseOnHover: true,
  pauseOnFocusLoss: true,
  closeOnClick: true,
  newestOnTop: false,
  draggable: true,
  draggablePercent: 80
  /* DRAGGABLE_PERCENT */
  ,
  draggableDirection: "x"
  /* X */
  ,
  role: 'alert'
};

var containers = /*#__PURE__*/new Map();
var latestInstance;
var containerDomNode;
var containerConfig;
var queue = [];
var lazy = false;
/**
 * Check whether any container is currently mounted in the DOM
 */

function isAnyContainerMounted() {
  return containers.size > 0;
}
/**
 * Get the toast by id, given it's in the DOM, otherwise returns null
 */


function getToast(toastId, _ref) {
  var containerId = _ref.containerId;
  var container = containers.get(containerId || latestInstance);
  if (!container) return null;
  return container.getToast(toastId);
}
/**
 * Generate a random toastId
 */


function generateToastId() {
  return Math.random().toString(36).substr(2, 9);
}
/**
 * Generate a toastId or use the one provided
 */


function getToastId(options) {
  if (options && (isStr(options.toastId) || isNum(options.toastId))) {
    return options.toastId;
  }

  return generateToastId();
}
/**
 * If the container is not mounted, the toast is enqueued and
 * the container lazy mounted
 */


function dispatchToast(content, options) {
  if (isAnyContainerMounted()) {
    eventManager.emit(0
    /* Show */
    , content, options);
  } else {
    queue.push({
      content: content,
      options: options
    });

    if (lazy && canUseDom) {
      lazy = false;
      containerDomNode = document.createElement('div');
      document.body.appendChild(containerDomNode);
      (0,react_dom.render)((0,react.createElement)(ToastContainer, Object.assign({}, containerConfig)), containerDomNode);
    }
  }

  return options.toastId;
}
/**
 * Merge provided options with the defaults settings and generate the toastId
 */


function mergeOptions(type, options) {
  return _extends({}, options, {
    type: options && options.type || type,
    toastId: getToastId(options)
  });
}

var createToastByType = function createToastByType(type) {
  return function (content, options) {
    return dispatchToast(content, mergeOptions(type, options));
  };
};

var toast = function toast(content, options) {
  return dispatchToast(content, mergeOptions(TYPE.DEFAULT, options));
};

toast.success = /*#__PURE__*/createToastByType(TYPE.SUCCESS);
toast.info = /*#__PURE__*/createToastByType(TYPE.INFO);
toast.error = /*#__PURE__*/createToastByType(TYPE.ERROR);
toast.warning = /*#__PURE__*/createToastByType(TYPE.WARNING);
toast.dark = /*#__PURE__*/createToastByType(TYPE.DARK);
toast.warn = toast.warning;
/**
 * Remove toast programmaticaly
 */

toast.dismiss = function (id) {
  return eventManager.emit(1
  /* Clear */
  , id);
};
/**
 * Clear waiting queue when limit is used
 */


toast.clearWaitingQueue = function (params) {
  if (params === void 0) {
    params = {};
  }

  return eventManager.emit(5
  /* ClearWaitingQueue */
  , params);
};
/**
 * return true if one container is displaying the toast
 */


toast.isActive = function (id) {
  var isToastActive = false;
  containers.forEach(function (container) {
    if (container.isToastActive && container.isToastActive(id)) {
      isToastActive = true;
    }
  });
  return isToastActive;
};

toast.update = function (toastId, options) {
  if (options === void 0) {
    options = {};
  }

  // if you call toast and toast.update directly nothing will be displayed
  // this is why I defered the update
  setTimeout(function () {
    var toast = getToast(toastId, options);

    if (toast) {
      var oldOptions = toast.props,
          oldContent = toast.content;

      var nextOptions = _extends({}, oldOptions, options, {
        toastId: options.toastId || toastId,
        updateId: generateToastId()
      });

      if (nextOptions.toastId !== toastId) nextOptions.staleId = toastId;
      var content = nextOptions.render || oldContent;
      delete nextOptions.render;
      dispatchToast(content, nextOptions);
    }
  }, 0);
};
/**
 * Used for controlled progress bar.
 */


toast.done = function (id) {
  toast.update(id, {
    progress: 1
  });
};
/**
 * Track changes. The callback get the number of toast displayed
 *
 */


toast.onChange = function (callback) {
  if (isFn(callback)) {
    eventManager.on(4
    /* Change */
    , callback);
  }

  return function () {
    isFn(callback) && eventManager.off(4
    /* Change */
    , callback);
  };
};
/**
 * Configure the ToastContainer when lazy mounted
 */


toast.configure = function (config) {
  if (config === void 0) {
    config = {};
  }

  lazy = true;
  containerConfig = config;
};

toast.POSITION = POSITION;
toast.TYPE = TYPE;
/**
 * Wait until the ToastContainer is mounted to dispatch the toast
 * and attach isActive method
 */

eventManager.on(2
/* DidMount */
, function (containerInstance) {
  latestInstance = containerInstance.containerId || containerInstance;
  containers.set(latestInstance, containerInstance);
  queue.forEach(function (item) {
    eventManager.emit(0
    /* Show */
    , item.content, item.options);
  });
  queue = [];
}).on(3
/* WillUnmount */
, function (containerInstance) {
  containers["delete"](containerInstance.containerId || containerInstance);

  if (containers.size === 0) {
    eventManager.off(0
    /* Show */
    ).off(1
    /* Clear */
    ).off(5
    /* ClearWaitingQueue */
    );
  }

  if (canUseDom && containerDomNode) {
    document.body.removeChild(containerDomNode);
  }
});


//# sourceMappingURL=react-toastify.esm.js.map

// EXTERNAL MODULE: ./node_modules/.pnpm/react-toastify@7.0.4_react-dom@18.3.1_react@18.3.1/node_modules/react-toastify/dist/ReactToastify.css
var ReactToastify = __webpack_require__(33370);
;// CONCATENATED MODULE: ./src/components/Layout/PageLayout.tsx


function PageLayout_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }









var PageLayout = function PageLayout(_ref) {
  var _getAppOsInfo;

  var children = _ref.children;

  var _useState = (0,react.useState)(0),
      footerHeight = _useState[0],
      setFooterHeight = _useState[1];

  var footerRef = (0,react.useRef)(null);
  var isAndroid = ((_getAppOsInfo = (0,utils/* getAppOsInfo */.ZA)()) === null || _getAppOsInfo === void 0 ? void 0 : _getAppOsInfo.osType) === 'Android';
  (0,react.useEffect)(function () {
    var handleFooterHeight = function handleFooterHeight() {
      return setFooterHeight(footerRef.current.offsetHeight);
    };

    if (footerRef.current) {
      setFooterHeight(footerRef.current.offsetHeight);
      window.addEventListener('resize', handleFooterHeight);
    }

    return function () {
      window.removeEventListener('resize', handleFooterHeight);
    };
  }, [footerRef]);
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(ContainerColumn, {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(HeaderContainer, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ContainerRow, {
      footerHeight: footerHeight,
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ContentsContainer, {
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PageWrap, {
          children: children
        })
      })
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FooterContainer, {
      footerRef: footerRef
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ToastContainer, {
      position: "bottom-center",
      hideProgressBar: true,
      autoClose: 2000,
      transition: Slide,
      style: {
        marginBottom: isAndroid ? '42px' : '0px',
        zIndex: 10001
      }
    })]
  });
};

var ContainerColumn = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "encumyy3"
} : 0)( true ? {
  name: "1hv1tju",
  styles: "display:flex;flex-direction:column;min-height:100vh;position:relative"
} : 0);

var ContainerRow = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "encumyy2"
} : 0)("display:flex;width:100%;padding-bottom:", function (_ref2) {
  var footerHeight = _ref2.footerHeight;
  return footerHeight;
}, "px;" + ( true ? "" : 0));

var ContentsContainer = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "encumyy1"
} : 0)( true ? {
  name: "1js61ur",
  styles: "width:100%;@media screen and (min-width: 768px){padding:0px 60px;margin:0 auto;box-sizing:border-box;flex:1 0 auto;max-width:1256px;}"
} : 0);

var PageWrap = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "encumyy0"
} : 0)( true ? {
  name: "1d3w5wq",
  styles: "width:100%"
} : 0);
;// CONCATENATED MODULE: ./src/components/Layout/index.ts








/***/ }),

/***/ 88824:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "EC": function() { return /* reexport */ getNavigationData; },
  "N1": function() { return /* reexport */ useNavigationMenu; }
});

// UNUSED EXPORTS: getNavigationHnCData

// EXTERNAL MODULE: ./node_modules/.pnpm/next@12.3.4_@babel+core@7.26.0_react-dom@18.3.1_react@18.3.1_sass@1.80.4/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(85922);
// EXTERNAL MODULE: ./node_modules/.pnpm/next@12.3.4_@babel+core@7.26.0_react-dom@18.3.1_react@18.3.1_sass@1.80.4/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(88756);
// EXTERNAL MODULE: ./node_modules/.pnpm/next@12.3.4_@babel+core@7.26.0_react-dom@18.3.1_react@18.3.1_sass@1.80.4/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js + 3 modules
var toConsumableArray = __webpack_require__(37555);
// EXTERNAL MODULE: ./node_modules/.pnpm/swr@1.3.0_react@18.3.1/node_modules/swr/dist/index.mjs
var dist = __webpack_require__(75182);
// EXTERNAL MODULE: ./node_modules/.pnpm/next@12.3.4_@babel+core@7.26.0_react-dom@18.3.1_react@18.3.1_sass@1.80.4/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(6325);
// EXTERNAL MODULE: ./node_modules/.pnpm/next@12.3.4_@babel+core@7.26.0_react-dom@18.3.1_react@18.3.1_sass@1.80.4/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(78838);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);
// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.3.1/node_modules/react/index.js
var react = __webpack_require__(75271);
// EXTERNAL MODULE: ./node_modules/.pnpm/@bucketplace+design-system@5.3.3_@bucketplace+ui@1.0.9_@emotion+react@11.13.3_@emotion+styled_gws5alfnqy5ixwsabrkna3jsv4/node_modules/@bucketplace/design-system/dist/esm/bds.js + 72 modules
var bds = __webpack_require__(85435);
// EXTERNAL MODULE: ./src/common/index.ts + 5 modules
var common = __webpack_require__(23336);
// EXTERNAL MODULE: ./src/components/Layout/index.ts + 9 modules
var Layout = __webpack_require__(3600);
// EXTERNAL MODULE: ./node_modules/.pnpm/humps@2.0.1/node_modules/humps/humps.js
var humps = __webpack_require__(87493);
// EXTERNAL MODULE: ./src/common/http.ts + 12 modules
var http = __webpack_require__(8585);
;// CONCATENATED MODULE: ./src/hooks/Navigation/getNavigationData.tsx




var getNavigationData = /*#__PURE__*/function () {
  var _ref = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee() {
    var response, json;
    return regenerator_default().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return http/* clientHttp.get */.J.get('/api/navigation', {
              throwHttpErrors: false
            });

          case 2:
            response = _context.sent;

            if (response.ok) {
              _context.next = 5;
              break;
            }

            throw new Error('unexpected http error occurred');

          case 5:
            _context.next = 7;
            return response.json();

          case 7:
            json = _context.sent;
            return _context.abrupt("return", (0,humps.camelizeKeys)(json));

          case 9:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function getNavigationData() {
    return _ref.apply(this, arguments);
  };
}();
var getNavigationHnCData = /*#__PURE__*/function () {
  var _ref2 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee2() {
    var response, data;
    return regenerator_default().wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return http/* clientHttp.get */.J.get('/api/navigation/topics');

          case 2:
            response = _context2.sent;
            _context2.next = 5;
            return response.json();

          case 5:
            data = _context2.sent;
            return _context2.abrupt("return", data);

          case 7:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function getNavigationHnCData() {
    return _ref2.apply(this, arguments);
  };
}();
// EXTERNAL MODULE: ./node_modules/.pnpm/@emotion+react@11.13.3_@types+react@18.3.12_react@18.3.1/node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(83128);
;// CONCATENATED MODULE: ./src/hooks/Navigation/useCreateHnCMenu.tsx









var useCreateHnCMenu = function useCreateHnCMenu(_ref) {
  var experiments = _ref.experiments;

  var _useState = (0,react.useState)({
    "default": {
      key: '',
      name: ''
    },
    fixed: []
  }),
      topics = _useState[0],
      setTopics = _useState[1];

  var experimentType = experiments === null || experiments === void 0 ? void 0 : experiments.contents;

  var formatTopics = function formatTopics(topics) {
    var _topics$find;

    /** recommendTopic 찾는 순서
     * 1. defaultTopic = true
     * 2. key = 'recommend'(DEFAULT_TOPIC_KEY)
     * 3. topics 중 첫번째 item
     */
    var recommendTopic = (_topics$find = topics.find(function (_ref2) {
      var defaultTopic = _ref2.defaultTopic,
          key = _ref2.key;
      return defaultTopic || key === 'recommend';
    })) !== null && _topics$find !== void 0 ? _topics$find : topics[0];
    var lifeTopics = topics.filter(function (topic) {
      return topic !== recommendTopic;
    });
    return {
      "default": recommendTopic,
      fixed: lifeTopics
    };
  };

  var createTopicMenu = function createTopicMenu(topics) {
    return topics.map(function (_ref3) {
      var name = _ref3.name,
          key = _ref3.key;
      return {
        title: "".concat(name),
        href: "".concat(common/* CONTENT_HOST */.Ro, "/topics/").concat(key),
        logId: key
      };
    });
  };

  var legacyMenu = (0,react.useMemo)(function () {
    return [{
      title: '커뮤니티',
      icon: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(bds/* Icon */.JO$, {
        size: 24,
        name: "home_outline"
      }),
      href: "".concat(common/* OHS_HOST */.K2),
      entries: [{
        title: '홈',
        href: "".concat(common/* OHS_HOST */.K2, "/")
      }, {
        title: '팔로잉',
        href: "".concat(common/* OHS_HOST */.K2, "/contents/follow/feed")
      }, {
        title: '사진',
        href: "".concat(common/* OHS_HOST */.K2, "/contents/card_collections")
      }, {
        title: '집들이',
        href: "".concat(common/* OHS_HOST */.K2, "/projects?writer=self")
      }, {
        title: '노하우',
        href: "".concat(common/* OHS_HOST */.K2, "/advices")
      }, {
        title: '전문가집들이',
        href: "".concat(common/* OHS_HOST */.K2, "/projects?writer=pro")
      }, {
        title: '셀프가이드',
        href: "".concat(common/* OHS_HOST */.K2, "/advices/guides/self_interior")
      }, {
        title: '3D인테리어',
        href: "".concat(common/* OHS_HOST */.K2, "/interior3ds"),
        badge: {
          text: 'BETA',
          type: 'fill',
          variant: 'base2'
        }
      }, {
        title: '이벤트',
        href: "".concat(common/* OHS_HOST */.K2, "/competitions/feed")
      }].filter(Boolean)
    }].filter(Boolean);
  }, []);
  var newMenu = (0,react.useMemo)(function () {
    return [{
      title: '커뮤니티',
      icon: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(bds/* Icon */.JO$, {
        size: 24,
        name: "home_outline"
      }),
      href: "".concat(common/* OHS_HOST */.K2),
      entries: [{
        title: '홈',
        href: "".concat(common/* OHS_HOST */.K2),
        logId: 'home'
      }].concat((0,toConsumableArray/* default */.Z)(createTopicMenu([topics["default"]])), [{
        title: '집들이',
        href: "".concat(common/* OHS_HOST */.K2, "/projects?writer=self"),
        logId: 'project'
      }, {
        title: '집사진',
        href: "".concat(common/* OHS_HOST */.K2, "/contents/card_collections"),
        logId: 'card'
      }], (0,toConsumableArray/* default */.Z)(createTopicMenu(topics.fixed)), [{
        title: '3D인테리어',
        href: "".concat(common/* OHS_HOST */.K2, "/interior3ds"),
        logId: 'interior3d'
      }, {
        title: '이벤트',
        href: "".concat(common/* OHS_HOST */.K2, "/competitions/feed"),
        logId: 'event'
      }]).filter(Boolean)
    }];
  }, [topics["default"], topics.fixed]);
  (0,react.useEffect)(function () {
    if (experimentType === Layout/* CONTENTS_EXPERIMENT_TYPE.LEGACY */.X_.LEGACY) return;

    var getHnCTopics = /*#__PURE__*/function () {
      var _ref4 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee() {
        var res, formattedTopics;
        return regenerator_default().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return getNavigationHnCData();

              case 3:
                res = _context.sent;
                formattedTopics = formatTopics(res.topics);
                setTopics(formattedTopics);
                _context.next = 10;
                break;

              case 8:
                _context.prev = 8;
                _context.t0 = _context["catch"](0);

              case 10:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[0, 8]]);
      }));

      return function getHnCTopics() {
        return _ref4.apply(this, arguments);
      };
    }();

    getHnCTopics();
  }, [experimentType]);
  return experimentType === Layout/* CONTENTS_EXPERIMENT_TYPE.LEGACY */.X_.LEGACY ? legacyMenu : newMenu;
};
;// CONCATENATED MODULE: ./src/hooks/Navigation/createO2OMenu.tsx



var createO2OMenu = function createO2OMenu() {
  return [{
    title: '이사/시공/수리',
    icon: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(bds/* Icon */.JO$, {
      size: 24,
      name: "truck_outline"
    }),
    href: "".concat(common/* OHS_HOST */.K2, "/experts"),
    entries: [{
      title: '홈',
      href: "".concat(common/* OHS_HOST */.K2, "/experts")
    }, {
      title: '주거공간시공',
      href: "".concat(common/* O2O_HOST */.al, "/remodeling/home/discovery")
    }, {
      title: '상업공간시공',
      href: "".concat(common/* O2O_HOST */.al, "/remodeling/business/discovery")
    }, {
      title: '아파트시공사례',
      href: "".concat(common/* OHS_HOST */.K2, "/experts/town")
    }, {
      title: '설치수리',
      href: "".concat(common/* O2O_HOST */.al, "/repair")
    }, {
      title: '이사',
      href: "".concat(common/* OHS_HOST */.K2, "/experts/moving")
    }, {
      title: '집보기체크리스트',
      href: "".concat(common/* O2O_HOST */.al, "/hometour")
    }]
  }];
};
// EXTERNAL MODULE: ./node_modules/.pnpm/next@12.3.4_@babel+core@7.26.0_react-dom@18.3.1_react@18.3.1_sass@1.80.4/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js + 3 modules
var slicedToArray = __webpack_require__(46003);
// EXTERNAL MODULE: ./node_modules/.pnpm/querystring@0.2.1/node_modules/querystring/index.js
var querystring = __webpack_require__(97150);
;// CONCATENATED MODULE: ./src/hooks/Navigation/createStoreMenu.tsx






var createStoreMenu = function createStoreMenu() {
  return [{
    title: '쇼핑',
    icon: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(bds/* Icon */.JO$, {
      size: 24,
      name: "store_outline"
    }),
    href: "".concat(common/* OHS_HOST */.K2, "/store"),
    active: true,
    entries: []
  }];
};
var STORE_FEEDS = {
  StoreWedding: 'StoreWeddingFeed',
  StoreCustom: 'StoreCustomFeed',
  Store: 'StoreFeed'
};

var getFeeds = function getFeeds(storeFeeds, type) {
  switch (type) {
    case STORE_FEEDS.StoreWedding:
      return storeFeeds.find(function (feed) {
        return feed.type === STORE_FEEDS.StoreWedding;
      });

    case STORE_FEEDS.StoreCustom:
      return storeFeeds.find(function (feed) {
        return feed.type === STORE_FEEDS.StoreCustom;
      });

    case STORE_FEEDS.Store:
      return storeFeeds.filter(function (feed) {
        return feed.type === STORE_FEEDS.Store;
      });

    default:
      return undefined;
  }
};

var composeStoreFeeds = function composeStoreFeeds(data, pathname) {
  var _data$storeFeeds, _data$storeHamburger$, _data$storeHamburger, _weddingItem$feedTitl;

  var storeFeeds = (_data$storeFeeds = data === null || data === void 0 ? void 0 : data.storeFeeds) !== null && _data$storeFeeds !== void 0 ? _data$storeFeeds : [];
  var weddingItem = getFeeds(storeFeeds, STORE_FEEDS.StoreWedding);
  var customFeedItem = getFeeds(storeFeeds, STORE_FEEDS.StoreCustom);
  var specialFeedItems = getFeeds(storeFeeds, STORE_FEEDS.Store);
  var storeHamburgerItems = ((_data$storeHamburger$ = data === null || data === void 0 ? void 0 : (_data$storeHamburger = data.storeHamburger) === null || _data$storeHamburger === void 0 ? void 0 : _data$storeHamburger.categories) !== null && _data$storeHamburger$ !== void 0 ? _data$storeHamburger$ : []).map(function (_ref) {
    var id = _ref.id,
        title = _ref.title,
        hash = _ref.hash,
        count = _ref.count,
        imageUrl = _ref.imageUrl;
    var queryString = querystring.stringify({
      affect_type: 'StoreHamburger',
      category: hash
    });
    return {
      title: title,
      hash: hash,
      count: count,
      imageUrl: imageUrl,
      id: +id,
      to: "".concat(common/* OHS_HOST */.K2, "/store/category?").concat(queryString)
    };
  });
  return [{
    title: '쇼핑홈',
    href: "".concat(common/* OHS_HOST */.K2, "/store")
  }, {
    title: '카테고리',
    href: "".concat(common/* OHS_HOST */.K2, "/store/category?category=0&order=popular"),
    renderBarChild: function renderBarChild() {
      return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(bds/* StoreCategory */.DWR, {
        categories: storeHamburgerItems
      });
    }
  }, {
    title: '베스트',
    href: "".concat(common/* OHS_HOST */.K2, "/commerces/ranks")
  }].concat((0,toConsumableArray/* default */.Z)(specialFeedItems.map(function (item) {
    var _$exec;

    var match = /(https?:\/\/[^/]+)(\/[^?]+)(\?[^#]+)?(#.+)?$/.exec(item.content.url);

    if (match == null) {
      return null;
    }

    var newUrl = "".concat(match[1]).concat(match[2]).concat(match[3] ? "".concat(match[3], "&") : '?', "special_feed=true"); // in events.ohou.se, special_feed must be active even when the first segment of full path matches

    var _ref2 = (_$exec = /^(\/[^/]*)/.exec(pathname)) !== null && _$exec !== void 0 ? _$exec : [],
        _ref3 = (0,slicedToArray/* default */.Z)(_ref2, 2),
        firstSegment = _ref3[1];

    return {
      title: item.feedTitle,
      bullet: item.updateAlert ? 'new' : undefined,
      href: match[2].includes('today_deals') ? "".concat(common/* OHS_HOST */.K2).concat(match[2]) : newUrl,
      active: match[2].startsWith(firstSegment)
    };
  })), [weddingItem != null ? {
    title: (_weddingItem$feedTitl = weddingItem.feedTitle) !== null && _weddingItem$feedTitl !== void 0 ? _weddingItem$feedTitl : '프리미엄',
    bullet: weddingItem.updateAlert ? 'new' : undefined,
    href: "".concat(common/* OHS_HOST */.K2, "/productions/premium")
  } : null, {
    title: '기획전',
    href: "".concat(common/* STORE_HOST */.PH, "/exhibitions?showroom=false")
  }, customFeedItem != null ? {
    title: customFeedItem.feedTitle,
    bullet: customFeedItem.updateAlert ? 'new' : undefined,
    href: "".concat(common/* OHS_HOST */.K2, "/commerces/custom_feeds/feed?logic=0")
  } : null]).filter(Boolean);
};
;// CONCATENATED MODULE: ./src/hooks/Navigation/useNavigationMenu.tsx



var _excluded = ["data"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }







var useCreateMenu = function useCreateMenu(navItems, pathname, experiments) {
  var hncMenu = useCreateHnCMenu({
    experiments: experiments
  });
  var navigationMenuList = [].concat((0,toConsumableArray/* default */.Z)(hncMenu), (0,toConsumableArray/* default */.Z)(createStoreMenu()), (0,toConsumableArray/* default */.Z)(createO2OMenu()));
  var navigationData = navigationMenuList.map(function (data) {
    // hooks over `/store/*`
    if (data.href != null && data.href.endsWith('/store')) {
      return _objectSpread(_objectSpread({}, data), {}, {
        entries: composeStoreFeeds(navItems, pathname)
      });
    }

    return data;
  });
  return navigationData;
};

var useNavigationMenu = function useNavigationMenu(pathname, experiments) {
  var _useSWR = (0,dist/* default */.ZP)(['navigation', 'menu'], function () {
    return getNavigationData();
  }),
      data = _useSWR.data,
      res = (0,objectWithoutProperties/* default */.Z)(_useSWR, _excluded);

  var combined = useCreateMenu(data, pathname, experiments);
  return _objectSpread(_objectSpread({}, res), {}, {
    data: combined
  });
};
;// CONCATENATED MODULE: ./src/hooks/Navigation/index.ts



/***/ }),

/***/ 91002:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "EC": function() { return /* reexport */ Navigation/* getNavigationData */.EC; },
  "Yz": function() { return /* reexport */ useInterval; },
  "N1": function() { return /* reexport */ Navigation/* useNavigationMenu */.N1; },
  "bg": function() { return /* reexport */ useNowTime; }
});

// UNUSED EXPORTS: SWITCHED_DEVICE_RATIO, getNavigationHnCData, useDeviceRatioType, useHash, useImpressionLog, useIsVideoPlaying, usePreventAutoPageviewLog, useResponsiveQuery

// EXTERNAL MODULE: ./src/hooks/Navigation/index.ts + 5 modules
var Navigation = __webpack_require__(88824);
// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.3.1/node_modules/react/index.js
var react = __webpack_require__(75271);
;// CONCATENATED MODULE: ./src/hooks/useInterval.tsx

var useInterval = function useInterval(callback, delay) {
  var savedCallback = (0,react.useRef)(null); // Remember the latest callback.

  (0,react.useEffect)(function () {
    savedCallback.current = callback;
  }, [callback]); // Set up the interval.

  (0,react.useEffect)(function () {
    var tick = function tick() {
      savedCallback.current();
    };

    var intervalHandle;

    if (delay !== null) {
      intervalHandle = window.setInterval(tick, delay);
    }

    return function () {
      if (intervalHandle != null) {
        clearInterval(intervalHandle);
      }
    };
  }, [delay]);
};
// EXTERNAL MODULE: ./node_modules/.pnpm/@bucketplace+bucket-log@1.2.3_@emotion+react@11.13.3_react-dom@18.3.1_react@18.3.1/node_modules/@bucketplace/bucket-log/dist/index.esm.js
var index_esm = __webpack_require__(46166);
;// CONCATENATED MODULE: ./src/hooks/usePreventAutoPageviewLog.ts


/**
 * This prevents automated pageview log from occurring.
 * With this hook, you can issue pageview event with additional data,
 * or prevent pageview event from occurring at all.
 */

function usePreventAutoPageviewLog() {
  useLayoutEffect(function () {
    bucketLog({
      category: 'disableAutoPageview'
    });
    return function () {
      bucketLog({
        category: 'enableAutoPageview'
      });
    };
  }, []);
}
// EXTERNAL MODULE: ./node_modules/.pnpm/next@12.3.4_@babel+core@7.26.0_react-dom@18.3.1_react@18.3.1_sass@1.80.4/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(6325);
// EXTERNAL MODULE: ./node_modules/.pnpm/next@12.3.4_@babel+core@7.26.0_react-dom@18.3.1_react@18.3.1_sass@1.80.4/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(78838);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);
// EXTERNAL MODULE: ./node_modules/.pnpm/swr@1.3.0_react@18.3.1/node_modules/swr/dist/index.mjs
var dist = __webpack_require__(75182);
// EXTERNAL MODULE: ./src/common/http.ts + 12 modules
var http = __webpack_require__(8585);
;// CONCATENATED MODULE: ./src/hooks/useNowTime.ts





var getNowTime = /*#__PURE__*/function () {
  var _ref = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee() {
    var json, nowDate;
    return regenerator_default().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return http/* clientHttp.get */.J.get('/api/time').json();

          case 2:
            json = _context.sent;
            nowDate = new Date(json);
            return _context.abrupt("return", nowDate);

          case 5:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function getNowTime() {
    return _ref.apply(this, arguments);
  };
}();

var useNowTime = function useNowTime() {
  return (0,dist/* default */.ZP)(['date'], getNowTime);
};
;// CONCATENATED MODULE: ./src/hooks/useImpressionLog.ts


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }




function useImpressionLog(_ref) {
  var logData = _ref.logData,
      threshold = _ref.threshold,
      disable = _ref.disable;

  var _useInView = useInView({
    threshold: threshold,
    skip: disable,
    triggerOnce: true
  }),
      ref = _useInView.ref,
      inView = _useInView.inView;

  useEffect(function () {
    if (inView && !disable && !!logData) {
      bucketLog({
        category: 'impression',
        data: [_objectSpread(_objectSpread({}, formattingLogData(logData)), {}, {
          time: Date.now()
        })]
      });
    }
  }, [inView, disable, logData]);
  return {
    ref: ref
  };
}
;// CONCATENATED MODULE: ./src/hooks/useResponsiveQuery.ts



function useResponsiveQuery(type, breakpoint, useMatchMediaOptions) {
  var query = useMemo(function () {
    return createMediaBreakQuery(type, breakpoint);
  }, [type, breakpoint]);

  var _useMatchMedia = useMatchMedia(query, useMatchMediaOptions),
      matches = _useMatchMedia.matches;

  return matches !== null && matches !== void 0 ? matches : false;
}
;// CONCATENATED MODULE: ./src/hooks/useHash.ts



function parseHash(url) {
  var _url$split = url.split('#'),
      _url$split2 = _slicedToArray(_url$split, 2),
      segment = _url$split2[1];

  return segment != null ? "#".concat(segment) : '';
}

function useHash(router) {
  // a hash should always result in empty string ('') as an initial value in
  // both server/client environment or you will get hydration errors.
  var _useState = useState(''),
      hash = _useState[0],
      setHash = _useState[1];

  useEffect(function () {
    var handleHashChangeStart = function handleHashChangeStart(url) {
      setHash(parseHash(url));
    };

    var handleHashChange = function handleHashChange(e) {
      setHash(parseHash(e.newURL));
    };

    router.events.on('hashChangeStart', handleHashChangeStart);
    window.addEventListener('hashchange', handleHashChange);
    setHash(parseHash(router.asPath));
    return function () {
      router.events.off('hashChangeStart', handleHashChangeStart);
      window.removeEventListener('hashchange', handleHashChange);
    };
  }, [router]);
  return hash;
}
;// CONCATENATED MODULE: ./src/hooks/useIsVideoPlaying.tsx

var useIsVideoPlaying = function useIsVideoPlaying(videoRef) {
  var _useState = useState(false),
      isVideoPlaying = _useState[0],
      setVideoPlaying = _useState[1];

  useEffect(function () {
    if (!videoRef.current) return null;
    var videoDOM = videoRef.current;

    var handleSuspend = function handleSuspend() {
      setVideoPlaying(false);
    };

    var handlePlay = function handlePlay() {
      setVideoPlaying(true);
    };

    videoDOM.addEventListener('suspend', handleSuspend);
    videoDOM.addEventListener('pause', handleSuspend);
    videoDOM.addEventListener('play', handlePlay);
    return function () {
      videoDOM.removeEventListener('suspend', handleSuspend);
      videoDOM.removeEventListener('pause', handleSuspend);
      videoDOM.removeEventListener('play', handlePlay);
    };
  }, [videoRef]);
  return isVideoPlaying;
};
;// CONCATENATED MODULE: ./src/campaign/hooks/useDeviceRatio.ts

/**
 * 디바이스 화면 비율 height / width
 */

var SWITCHED_DEVICE_RATIO = (/* unused pure expression or super */ null && (812 / 375));

/**
 * 디바이스 비율 종류를 반환합니다.
 * @return {string} 'long' | 'short'
 */
var useDeviceRatioType = function useDeviceRatioType() {
  var _useState = useState('long'),
      ratio = _useState[0],
      setRatio = _useState[1];

  useEffect(function () {
    var ratio = window.screen.availHeight / window.screen.availWidth;
    setRatio(function () {
      return ratio >= SWITCHED_DEVICE_RATIO ? 'long' : 'short';
    });
  }, []);
  if (false) {}
  return ratio;
};
;// CONCATENATED MODULE: ./src/hooks/index.ts











/***/ }),

/***/ 47618:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ _app; }
});

// EXTERNAL MODULE: ./node_modules/.pnpm/next@12.3.4_@babel+core@7.26.0_react-dom@18.3.1_react@18.3.1_sass@1.80.4/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(6325);
// EXTERNAL MODULE: ./node_modules/.pnpm/next@12.3.4_@babel+core@7.26.0_react-dom@18.3.1_react@18.3.1_sass@1.80.4/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(88756);
// EXTERNAL MODULE: ./node_modules/.pnpm/next@12.3.4_@babel+core@7.26.0_react-dom@18.3.1_react@18.3.1_sass@1.80.4/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(78838);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);
// EXTERNAL MODULE: ./node_modules/.pnpm/regenerator-runtime@0.13.11/node_modules/regenerator-runtime/runtime.js
var runtime = __webpack_require__(90250);
// EXTERNAL MODULE: ./node_modules/.pnpm/abortcontroller-polyfill@1.7.5/node_modules/abortcontroller-polyfill/dist/polyfill-patch-fetch.js
var polyfill_patch_fetch = __webpack_require__(47990);
// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.3.1/node_modules/react/index.js
var react = __webpack_require__(75271);
// EXTERNAL MODULE: ./node_modules/.pnpm/swr@1.3.0_react@18.3.1/node_modules/swr/dist/index.mjs
var dist = __webpack_require__(75182);
// EXTERNAL MODULE: ./node_modules/.pnpm/next@12.3.4_@babel+core@7.26.0_react-dom@18.3.1_react@18.3.1_sass@1.80.4/node_modules/next/app.js
var app = __webpack_require__(5352);
// EXTERNAL MODULE: ./node_modules/.pnpm/next@12.3.4_@babel+core@7.26.0_react-dom@18.3.1_react@18.3.1_sass@1.80.4/node_modules/next/router.js
var next_router = __webpack_require__(17966);
;// CONCATENATED MODULE: ./node_modules/.pnpm/@bucketplace+metadata@0.5.0/node_modules/@bucketplace/metadata/dist/chunk-WCWZMNBD.mjs
var re=Object.defineProperty;var H=Object.getOwnPropertySymbols;var ne=Object.prototype.hasOwnProperty,ie=Object.prototype.propertyIsEnumerable;var B=(e,o,t)=>o in e?re(e,o,{enumerable:!0,configurable:!0,writable:!0,value:t}):e[o]=t,ee=(e,o)=>{for(var t in o||(o={}))ne.call(o,t)&&B(e,t,o[t]);if(H)for(var t of H(o))ie.call(o,t)&&B(e,t,o[t]);return e};var ce=(e=>typeof require!="undefined"?require:typeof Proxy!="undefined"?new Proxy(e,{get:(o,t)=>(typeof require!="undefined"?require:o)[t]}):e)(function(e){if(typeof require!="undefined")return require.apply(this,arguments);throw Error('Dynamic require of "'+e+'" is not supported')});var s=(e,o,t)=>(B(e,typeof o!="symbol"?o+"":o,t),t);var de=(e,o,t)=>new Promise((a,p)=>{var m=n=>{try{i(t.next(n));}catch(l){p(l);}},c=n=>{try{i(t.throw(n));}catch(l){p(l);}},i=n=>n.done?a(n.value):Promise.resolve(n.value).then(m,c);i((t=t.apply(e,o)).next());});var u={OFF:0,ERROR:10,WARN:20,INFO:30,DEBUG:40};var h=class{constructor(o){s(this,"id");s(this,"level");this.id=o.id,this.level=o.level;}getLevel(){return this.level}setLevel(o){this.level=o;}error(o,t){this.level<u.ERROR||console.error("[ERROR]",this.createLogSchema(u.ERROR,o,t));}warn(o,t){this.level<u.WARN||console.warn("[WARN]",this.createLogSchema(u.WARN,o,t));}info(o,t){this.level<u.INFO||console.info("[INFO]",this.createLogSchema(u.INFO,o,t));}debug(o,t){this.level<u.DEBUG||console.debug("[DEBUG]",this.createLogSchema(u.DEBUG,o,t));}createLogSchema(o,t,a){return JSON.stringify({id:this.id,level:o,message:t,data:a,timestamp:Date.now()})}};var y="1.0.0",$="bp-m-ver",A="bp-cid",P="bp-sid",w="bp-aid",v="bp-p-type",chunk_WCWZMNBD_C="bp-p-ver",R="bp-a-name",g="bp-a-ver",T="bp-s-country",I="bp-locale",U="bp-tz",N="b_visitor_id",S=[$,A,P,w,v,chunk_WCWZMNBD_C,R,g,T,I,U,N];var Ee={LOCAL:"local",DEV:"dev",STAGE:"stage",QA:"qa",PROD:"prod",LOCAL_GLOBAL:"local-global",DEV_GLOBAL:"dev-global",STAGE_GLOBAL:"stage-global",QA_GLOBAL:"qa-global",PROD_GLOBAL:"prod-global"};function D(e){return e.includes("global")}function r(e=3456e7){return Date.now()+e}function f(){return {"bp-m-ver":"","bp-cid":"","bp-sid":"","bp-aid":"","bp-p-type":"","bp-p-ver":"","bp-a-name":"","bp-a-ver":"","bp-s-country":"","bp-locale":"","bp-tz":"",b_visitor_id:""}}function L(){let e=new Date;return [e.getFullYear()%100,`0${e.getMonth()+1}`.slice(-2),`0${e.getDate()}`.slice(-2),e.toTimeString().substring(0,8).replace(/\D/g,""),me().slice(-13)].join("")}function me(){if(typeof window=="undefined"&&typeof globalThis.crypto=="undefined"){let e=ce("crypto");globalThis.crypto=e;}return typeof window!="undefined"&&typeof window.crypto.randomUUID!="undefined"?window.crypto.randomUUID():("10000000-1000-4000-8000"+-1e11).replace(/[018]/g,e=>(e^globalThis.crypto.getRandomValues(new Uint8Array(1))[0]&15>>e/4).toString(16))}function oe(){return `w${Date.now()}${`000000${Math.random()*1e6|0}`.slice(-6)}`}function chunk_WCWZMNBD_O(e){return ["Android","iOS"].includes(e!=null?e:"")}function x(e){return e.split(";").reduce((o,t)=>{var c,i;let a=t.trim().split("="),p=(c=a[0])!=null?c:"",m=(i=a[1])!=null?i:"";return !p||!m||!S.includes(p)?o:Object.assign(o,{[p]:m})},f())}function G(e){let o=new URL(e).searchParams;return S.reduce((t,a)=>{var p,m,c,i,n;switch(a){case v:return t[a]=(m=(p=o.get(a))!=null?p:o.get("os_type"))!=null?m:"",t;case g:return t[a]=(i=(c=o.get(a))!=null?c:o.get("version"))!=null?i:"",t;default:return t[a]=(n=o.get(a))!=null?n:"",t}},f())}function z(e){return new URL(e).host.split(".").slice(-2).join(".")}function q(e){let o=N,t=e.value?e.value:oe();return {name:o,value:t,cookie:()=>{let a=r();return `${o}=${t}; path=/; domain=${e.domain}; expires=${new Date(a).toUTCString()}`}}}function F(e){let o=R,t=e.value?e.value:"";return {name:o,value:t,cookie:()=>{let a=r();return `${o}=${t}; path=/; domain=${e.domain}; expires=${new Date(a).toUTCString()}`}}}function W(e){let o=g,t=e.value?e.value:"";return {name:o,value:t,cookie:()=>{let a=r();return `${o}=${t}; path=/; domain=${e.domain}; expires=${new Date(a).toUTCString()}`}}}function te(e){let o=w,t=e.value?e.value:"";return {name:o,value:t,cookie:()=>{let a=r();return `${o}=${t}; path=/; domain=${e.domain}; expires=${new Date(a).toUTCString()}`}}}function Y(e){let o=A,t=e.value?e.value:pe();return {name:o,value:t,cookie:()=>{let a=Date.now()+3456e7;return `${o}=${t}; path=/; domain=${e.domain}; expires=${new Date(a).toUTCString()}`}}}function pe(){return `c${L()}`}function Q(e){let o=$,t=e.value?e.value:"";return {name:o,value:t,cookie:()=>{let a=r();return `${o}=${t}; path=/; domain=${e.domain}; expires=${new Date(a).toUTCString()}`}}}function M(e){let o=I,t=e.value?e.value:"";return {name:o,value:t,cookie:()=>{let a=r();return `${o}=${t}; path=/; domain=${e.domain}; expires=${new Date(a).toUTCString()}`}}}function X(e){let o=v,t=e.value?e.value:ue(e.ua);return {name:o,value:t,cookie:()=>{let a=r();return `${o}=${t}; path=/; domain=${e.domain}; expires=${new Date(a).toUTCString()}`}}}function ue(e){return /iPhone|iPad|iPod/.test(e)?"mWebIOS":/Android/.test(e)?"mWebAndroid":"Web"}function j(e){let o=chunk_WCWZMNBD_C,t=e.value?e.value:"";return {name:o,value:t,cookie:()=>{let a=r();return `${o}=${t}; path=/; domain=${e.domain}; expires=${new Date(a).toUTCString()}`}}}function ae(e){return e.replaceAll(";",",")}function K(e){let o=T,t=e.value?e.value:"";return {name:o,value:t,cookie:()=>{let a=r(864e5);return `${o}=${t}; path=/; domain=${e.domain}; expires=${new Date(a).toUTCString()}`}}}function b(e){let o=P,t=e.value?e.value:J();return {name:o,value:t,cookie:()=>{let a=Date.now()+3456e7;return `${o}=${t}; path=/; domain=${e.domain}; expires=${new Date(a).toUTCString()}`}}}function le(e){return /[-\w]{26}:\d+:\d+$/.test(e)}function J(){let e=Date.now(),o=e+24*3600*1e3,t=e+30*60*1e3;return `s${L()}:${o}:${t}`}function _(e){if(!le(e))return J();let[o,t=""]=e.split(":"),a=Date.now();return Number(t)<a?J():`${o}:${t}:${a+30*60*1e3}`}function k(e){let o=U,t=e.value?e.value:"Asia/Seoul";return {name:o,value:t,cookie:()=>{let a=r();return `${o}=${t}; path=/; domain=${e.domain}; expires=${new Date(a).toUTCString()}`}}}var V=class e{constructor(o){s(this,"config");s(this,"data",new Map);this.config={environment:o.environment,cookieDomain:o.cookieDomain};}get(o){return this.data.get(o)}set(o,t){return this.data.set(o,t),t}clear(){this.data.clear();}diff(o){let t=[];for(let a of this.data.values())a.value&&o[a.name]!==a.value&&t.push(a);return t}clone(){let o=new e({environment:this.config.environment,cookieDomain:this.config.cookieDomain});for(let t of this.data.values())o.set(t.name,ee({},t));return o}toJSON(){let o={};for(let t of this.data.values())t.value&&(o[t.name]=t.value);return o}};function E(e){return {value:o=>e.query[o]?e.query[o]:e.cookie[o],query:o=>e.query[o],cookie:o=>e.cookie[o]}}var d=new h({id:"metadata",level:u.OFF});function ut(e){var i,n;e.logLevel!==void 0&&d.setLevel(e.logLevel),d.info("\uCD08\uAE30\uD654:\uC2DC\uC791"),d.debug("\uCD08\uAE30\uD654:\uC635\uC158",e);let o=G(e.url),t=x((i=e.cookie)!=null?i:""),a=E({query:o,cookie:t}),m=chunk_WCWZMNBD_O(a.value("bp-p-type"))?fe(a,e):se(a,e),c=m.diff(t);return c.length>0&&(d.debug("\uCD08\uAE30\uD654:\uBCC0\uACBD\uB41C \uBA54\uD0C0\uB370\uC774\uD130 : ",c),(n=e==null?void 0:e.onUpdate)==null||n.call(e,c)),d.info("\uCD08\uAE30\uD654:\uC644\uB8CC"),m}function se(e,o){var m,c,i,n,l;let t=o.environment,a=new V({environment:t,cookieDomain:z(o.url)});a.set("bp-m-ver",Q({domain:a.config.cookieDomain,value:y})),a.set("bp-p-type",X({domain:a.config.cookieDomain,ua:o.ua,value:""})),a.set("bp-p-ver",j({domain:a.config.cookieDomain,value:ae(o.ua)})),a.set("bp-cid",Y({domain:a.config.cookieDomain,value:e.cookie("bp-cid")})),a.set("bp-sid",b({domain:a.config.cookieDomain,value:_(e.cookie("bp-sid"))}));let p=e.cookie("bp-locale")!==""?e.cookie("bp-locale"):(m=o.locale)!=null?m:"";return a.set("bp-locale",M({domain:a.config.cookieDomain,value:D(t)?p:(c=o.locale)!=null?c:""})),a.set("bp-tz",k({domain:a.config.cookieDomain,value:(i=o.timezone)!=null?i:""})),a.set("bp-s-country",K({domain:a.config.cookieDomain,value:e.cookie("bp-s-country")})),a.set("b_visitor_id",q({domain:a.config.cookieDomain,value:e.cookie("b_visitor_id")})),a.set("bp-a-name",F({domain:a.config.cookieDomain,value:(n=o.name)!=null?n:""})),a.set("bp-a-ver",W({domain:a.config.cookieDomain,value:(l=o.version)!=null?l:""})),a}function fe(e,o){let t=new V({environment:o.environment,cookieDomain:z(o.url)});return t.set("bp-m-ver",Q({domain:t.config.cookieDomain,value:y})),t.set("bp-p-type",X({domain:t.config.cookieDomain,ua:o.ua,value:e.value("bp-p-type")})),t.set("bp-p-ver",j({domain:t.config.cookieDomain,value:e.value("bp-p-ver")})),t.set("bp-cid",Y({domain:t.config.cookieDomain,value:e.value("bp-cid")})),t.set("bp-sid",b({domain:t.config.cookieDomain,value:e.value("bp-sid")})),t.set("bp-locale",M({domain:t.config.cookieDomain,value:e.value("bp-locale")})),t.set("bp-tz",k({domain:t.config.cookieDomain,value:e.value("bp-tz")})),t.set("bp-s-country",K({domain:t.config.cookieDomain,value:e.value("bp-s-country")})),t.set("b_visitor_id",q({domain:t.config.cookieDomain,value:e.cookie("b_visitor_id")})),t.set("bp-a-name",F({domain:t.config.cookieDomain,value:e.value("bp-a-name")})),t.set("bp-a-ver",W({domain:t.config.cookieDomain,value:e.value("bp-a-ver")})),t.set("bp-aid",te({domain:t.config.cookieDomain,value:e.value("bp-aid")})),t}function gt(e){var i,n,l,Z;let o=e.metadata.clone(),t=x(e.cookie),a=E({query:f(),cookie:t}),p=chunk_WCWZMNBD_O((i=o.get("bp-p-type"))==null?void 0:i.value),m=D(o.config.environment);if(p)return o;o.set("bp-sid",b({domain:o.config.cookieDomain,value:_((n=a.value("bp-sid"))!=null?n:"")})),e.timezone&&o.set("bp-tz",k({domain:o.config.cookieDomain,value:(l=e.timezone)!=null?l:a.value("bp-tz")})),!m&&e.locale&&o.set("bp-locale",M({domain:o.config.cookieDomain,value:e.locale}));let c=o.diff(t);return (Z=e.onUpdate)==null||Z.call(e,c),o}


//# sourceMappingURL=out.js.map
//# sourceMappingURL=chunk-WCWZMNBD.mjs.map
;// CONCATENATED MODULE: ./node_modules/.pnpm/@bucketplace+metadata@0.5.0/node_modules/@bucketplace/metadata/dist/chunk-VWBRSNY4.mjs


var chunk_VWBRSNY4_O={[Ee.LOCAL]:"https://api.stage.dailyhou.se",[Ee.DEV]:"https://api.dev.dailyhou.se",[Ee.STAGE]:"https://api.stage.dailyhou.se",[Ee.QA]:"https://api.qa.dailyhou.se",[Ee.PROD]:"https://api.ohou.se",[Ee.LOCAL_GLOBAL]:"https://global-mbff.stage-web.dailyhou.se",[Ee.DEV_GLOBAL]:" https://global-mbff.dev-web.dailyhou.se",[Ee.STAGE_GLOBAL]:"https://global-mbff.stage-web.dailyhou.se",[Ee.QA_GLOBAL]:"https://mbff.qa-web.ohouse.in",[Ee.PROD_GLOBAL]:"https://mbff.ohouse.com"};function chunk_VWBRSNY4_M(o=""){var e;return (e=chunk_VWBRSNY4_P(o)[0])==null?void 0:e.locale}function chunk_VWBRSNY4_P(o){return o.split(",").map(e=>chunk_VWBRSNY4_I(e.trim())).filter(e=>e!==void 0)}function chunk_VWBRSNY4_I(o){let e=o.match(new RegExp("^((?<language>([a-z]{2}))(-(?<country>[a-z]{2}|419))?)(;q=(?<quality>(1(\\.0{0,3})?)|(0(\\.\\d{0,3})?)))?$","i"));if(!(e!=null&&e.groups))return;let{language:r="",country:i,quality:n="1"}=e.groups;return {locale:i?`${r}-${i}`:r,language:r,quality:Number.parseFloat(n).toString()}}var a=new h({id:"metadata:server",level:u.OFF});function chunk_VWBRSNY4_E(o,e){return de(this,null,function*(){try{a.info("\uAD6D\uAC00:\uC11C\uBC84 \uC870\uD68C \uC694\uCCAD"),a.debug("\uAD6D\uAC00:\uC11C\uBC84 \uC870\uD68C \uC694\uCCAD - \uC0C1\uC138",{url:`${o}/config/meta/intro`,params:e});let i=yield (yield fetch(`${o}/config/meta/intro`,{headers:e})).json();return a.info("\uAD6D\uAC00:\uC11C\uBC84 \uC870\uD68C \uC644\uB8CC",i),i.country}catch(r){return a.error("\uAD6D\uAC00:\uC11C\uBC84 \uC870\uD68C \uC624\uB958",r),Promise.resolve("KR")}})}function chunk_VWBRSNY4_R(o){var r;let e=(r=o.headers["x-forwarded-for"])==null?void 0:r.toString().split(",").shift();return e||o.socket.remoteAddress}function chunk_VWBRSNY4_h(m){return de(this,arguments,function*({logLevel:o,environment:e,name:r,version:i,url:n,req:t,res:c}){var d,y,L,v;o!==void 0&&a.setLevel(o),a.info("\uCD08\uAE30\uD654:\uC2DC\uC791"),a.debug("\uCD08\uAE30\uD654:\uC635\uC158",{logLevel:o,environment:e,version:i,url:n});let p=ut({logLevel:o,environment:e,name:r,version:i,url:n,cookie:(d=t.headers.cookie)!=null?d:"",locale:chunk_VWBRSNY4_M(t.headers["accept-language"]),ua:(y=t.headers["user-agent"])!=null?y:"",onUpdate:f=>{let g=f.map(l=>`${l.name}=${l.value}`).join("; ");c.setHeader("set-cookie",f.map(l=>l.cookie())),t.headers.cookie=t.headers.cookie?`${t.headers.cookie}; ${g}`:g;}});if(t.metadata=p,!((L=p.get("bp-s-country"))!=null&&L.value)){let f=yield chunk_VWBRSNY4_E(chunk_VWBRSNY4_O[e],ee({"true-client-ip":(v=chunk_VWBRSNY4_R(t))!=null?v:""},p.toJSON())),g=K({domain:p.config.cookieDomain,value:f});p.set("bp-s-country",g);let l=c.getHeader("set-cookie");c.setHeader("set-cookie",Array.isArray(l)?[...l,g.cookie()]:[g.cookie()]),t.headers.cookie=`${t.headers.cookie}; ${g.name}=${g.value}`;}return a.info("\uCD08\uAE30\uD654:\uC644\uB8CC"),p})}var chunk_VWBRSNY4_ae={koa:({logLevel:o,environment:e,version:r,name:i,exclude:n=chunk_VWBRSNY4_S})=>(t,c)=>de(void 0,null,function*(){var m;return n((m=t.req.url)!=null?m:"")||(yield chunk_VWBRSNY4_h({logLevel:o,environment:e,name:i,version:r,url:t.URL.href,req:t.req,res:t.res})),c()}),express:({logLevel:o,environment:e,name:r,version:i,exclude:n=chunk_VWBRSNY4_S})=>(t,c,m)=>de(void 0,null,function*(){var d;let p=`${t.protocol}://${t.hostname}${t.originalUrl}`;n((d=t.url)!=null?d:"")||(yield chunk_VWBRSNY4_h({logLevel:o,environment:e,name:r,version:i,url:p,req:t,res:c})),m();})};function chunk_VWBRSNY4_S(o){return [".(js|css|json|png|jpg|jpeg|ico|gif)(.+)?","^/api","^/health"].some(r=>new RegExp(r).test(o))}function chunk_VWBRSNY4_le({metadata:o,req:e,res:r,value:i}){var m;if(typeof window!="undefined"){a.warn("\uC11C\uBC84 \uD658\uACBD\uC774 \uC544\uB2D9\uB2C8\uB2E4.");return}let n=o.set("bp-locale",C({domain:o.config.cookieDomain,value:i})),t=(m=r.getHeader("set-cookie"))!=null?m:[],c=`${n.name}=${n.value}`;r.setHeader("set-cookie",[...t,n.cookie()]),e.headers.cookie=e.headers.cookie?`${e.headers.cookie}; ${c}`:c;}


//# sourceMappingURL=out.js.map
//# sourceMappingURL=chunk-VWBRSNY4.mjs.map
;// CONCATENATED MODULE: ./node_modules/.pnpm/@bucketplace+metadata@0.5.0/node_modules/@bucketplace/metadata/dist/chunk-AUGNQZOJ.mjs


var p={initialized:!1,metadata:new V({environment:"dev",cookieDomain:""})};function o(){return p}function i(){try{return Intl.DateTimeFormat().resolvedOptions().timeZone}catch(e){return ""}}var n=new h({id:"metadata:browser",level:u.OFF});function chunk_AUGNQZOJ_w(e){if(typeof window=="undefined")return;e.logLevel!==void 0&&n.setLevel(e.logLevel),n.info("\uCD08\uAE30\uD654:\uC2DC\uC791"),n.debug("\uCD08\uAE30\uD654:\uC635\uC158",e);let t=o();if(t.initialized)return console.warn("\uC774\uBBF8 \uCD08\uAE30\uD654 \uB418\uC5C8\uC2B5\uB2C8\uB2E4."),t.metadata;let a=ut({logLevel:e.logLevel,environment:e.environment,name:e.name,version:e.version,url:window.location.href,cookie:window.document.cookie,ua:window.navigator.userAgent,locale:window.navigator.language,timezone:i(),onUpdate:r=>{for(let s of r)document.cookie=s.cookie();}});return t.initialized=!0,t.metadata=a,n.info("\uCD08\uAE30\uD654:\uC644\uB8CC"),t.metadata}function chunk_AUGNQZOJ_u(){let e=o();return typeof window=="undefined"||(e.metadata=O({metadata:e.metadata,cookie:window.document.cookie,locale:window.navigator.language,timezone:i(),onUpdate:t=>{for(let a of t)document.cookie=a.cookie();}})),e}function chunk_AUGNQZOJ_(e){var r;let t=o();if(typeof window=="undefined"){n.warn("\uBE0C\uB77C\uC6B0\uC800 \uD658\uACBD\uC774 \uC544\uB2D9\uB2C8\uB2E4.");return}let a=t.metadata.set("bp-locale",C({domain:t.metadata.config.cookieDomain,value:e}));document.cookie=(r=a.cookie())!=null?r:"";}


//# sourceMappingURL=out.js.map
//# sourceMappingURL=chunk-AUGNQZOJ.mjs.map
;// CONCATENATED MODULE: ./node_modules/.pnpm/@bucketplace+metadata@0.5.0/node_modules/@bucketplace/metadata/dist/next/index.mjs





var next_n={browser:chunk_AUGNQZOJ_w,server:chunk_VWBRSNY4_h};


//# sourceMappingURL=out.js.map
//# sourceMappingURL=index.mjs.map
// EXTERNAL MODULE: ./node_modules/.pnpm/@bucketplace+design-system@5.3.3_@bucketplace+ui@1.0.9_@emotion+react@11.13.3_@emotion+styled_gws5alfnqy5ixwsabrkna3jsv4/node_modules/@bucketplace/design-system/dist/esm/index.js
var esm = __webpack_require__(53700);
// EXTERNAL MODULE: ./node_modules/.pnpm/@bucketplace+common@3.5.27_@bucketplace+config@0.1.2_@bucketplace+design-system@5.3.3_@bucket_ang3clxi3vvz7qz7nviwjn5pii/node_modules/@bucketplace/common/dist/index.es.js
var index_es = __webpack_require__(73581);
// EXTERNAL MODULE: ./src/common/index.ts + 5 modules
var common = __webpack_require__(23336);
// EXTERNAL MODULE: ./src/common/jwt-auth.ts + 2 modules
var jwt_auth = __webpack_require__(7799);
// EXTERNAL MODULE: ./src/provider/index.ts + 9 modules
var provider = __webpack_require__(90454);
// EXTERNAL MODULE: ./src/api/fetcher.ts
var fetcher = __webpack_require__(83899);
// EXTERNAL MODULE: ./src/utils/index.ts + 7 modules
var utils = __webpack_require__(73387);
// EXTERNAL MODULE: ./src/components/Layout/index.ts + 9 modules
var Layout = __webpack_require__(3600);
// EXTERNAL MODULE: ./node_modules/.pnpm/next@12.3.4_@babel+core@7.26.0_react-dom@18.3.1_react@18.3.1_sass@1.80.4/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/classCallCheck.js
var classCallCheck = __webpack_require__(66677);
// EXTERNAL MODULE: ./node_modules/.pnpm/next@12.3.4_@babel+core@7.26.0_react-dom@18.3.1_react@18.3.1_sass@1.80.4/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/createClass.js
var createClass = __webpack_require__(48849);
// EXTERNAL MODULE: ./node_modules/.pnpm/next@12.3.4_@babel+core@7.26.0_react-dom@18.3.1_react@18.3.1_sass@1.80.4/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/inherits.js
var inherits = __webpack_require__(87646);
// EXTERNAL MODULE: ./node_modules/.pnpm/next@12.3.4_@babel+core@7.26.0_react-dom@18.3.1_react@18.3.1_sass@1.80.4/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/possibleConstructorReturn.js
var possibleConstructorReturn = __webpack_require__(77290);
// EXTERNAL MODULE: ./node_modules/.pnpm/next@12.3.4_@babel+core@7.26.0_react-dom@18.3.1_react@18.3.1_sass@1.80.4/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/getPrototypeOf.js
var getPrototypeOf = __webpack_require__(11430);
;// CONCATENATED MODULE: ./src/components/ErrorBoundary.tsx






function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0,getPrototypeOf/* default */.Z)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0,getPrototypeOf/* default */.Z)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0,possibleConstructorReturn/* default */.Z)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }


var ErrorBoundary = /*#__PURE__*/function (_React$Component) {
  (0,inherits/* default */.Z)(ErrorBoundary, _React$Component);

  var _super = _createSuper(ErrorBoundary);

  function ErrorBoundary(props) {
    var _this;

    (0,classCallCheck/* default */.Z)(this, ErrorBoundary);

    _this = _super.call(this, props);
    _this.state = {
      hasError: false
    };
    return _this;
  }

  (0,createClass/* default */.Z)(ErrorBoundary, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          fallback = _this$props.fallback,
          children = _this$props.children;
      var hasError = this.state.hasError;

      if (hasError) {
        return fallback;
      }

      return children;
    }
  }], [{
    key: "getDerivedStateFromError",
    value: function getDerivedStateFromError() {
      return {
        hasError: true
      };
    }
  }]);

  return ErrorBoundary;
}(react.Component);
// EXTERNAL MODULE: ./src/components/Error.tsx
var components_Error = __webpack_require__(42928);
// EXTERNAL MODULE: ./src/styles/global.css
var global = __webpack_require__(90604);
// EXTERNAL MODULE: ./node_modules/.pnpm/@emotion+react@11.13.3_@types+react@18.3.12_react@18.3.1/node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(83128);
;// CONCATENATED MODULE: ./src/pages/_app.tsx




function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }




















next_n.browser({
  environment: common/* APP_PROFILE */.ui,
  name: common/* APP_NAME */.iC,
  version: common/* APP_VERSION */.Ji !== null && common/* APP_VERSION */.Ji !== void 0 ? common/* APP_VERSION */.Ji : common/* APP_PROFILE */.ui
});
jwt_auth/* sessionManager.prepare */.c.prepare();
(0,index_es/* initDatadogRum */.AYH)({
  applicationId: '8c6ee7a4-2a88-4279-8468-5b3710dd460f',
  clientToken: 'pub7bcc0f23149f0ea6696b2d6f604c6919',
  service: 'event-web',
  env: common/* APP_PROFILE */.ui === 'local' ? 'dev' : common/* APP_PROFILE */.ui,
  version: common/* APP_VERSION */.Ji,
  sessionSampleRate: 1,
  sessionReplaySampleRate: 0
});

function MyApp(_ref) {
  var Component = _ref.Component,
      pageProps = _ref.pageProps;
  var router = (0,next_router.useRouter)();
  (0,react.useEffect)(function () {
    (0,utils/* setUtmData */.A2)();
    (0,utils/* saveAppOsInfo */.d5)();
    (0,utils/* sendA1MediaInflow */.gu)();
    router.events.on('routeChangeComplete', utils/* setUtmData */.A2);
    return function () {
      return router.events.off('routeChangeComplete', utils/* setUtmData */.A2);
    };
  }, [router.events]);

  var getLayout = Component.getLayout || function (page) {
    return page;
  };

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(esm/* DesignSystemProvider */.hOb, {
    mode: "light",
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(dist/* SWRConfig */.J$, {
      value: {
        revalidateOnFocus: false,
        fetcher: fetcher/* fetcher */._
      },
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(provider/* SearchQueryContextProvider */._9, {
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(provider/* UserContextProvider */.fS, {
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(provider/* GlobalModalProvider */.O8, {
            children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(provider/* PushSettingProvider */.E0, {
              children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(provider/* BrazeProvider */.eN, {
                children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Layout/* Layout */.Ar, {
                  children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Layout/* PageLayout */.Xg, {
                    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ErrorBoundary, {
                      fallback: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(components_Error/* Error */.j, {}),
                      children: getLayout((0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Component, _objectSpread({}, pageProps)))
                    })
                  })
                })
              })
            })
          })
        })
      })
    })
  });
}

MyApp.getInitialProps = /*#__PURE__*/function () {
  var _ref2 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee(context) {
    var appProps;
    return regenerator_default().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return app["default"].getInitialProps(context);

          case 2:
            appProps = _context.sent;
            return _context.abrupt("return", _objectSpread({}, appProps));

          case 4:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function (_x) {
    return _ref2.apply(this, arguments);
  };
}();

/* harmony default export */ var _app = (MyApp);

/***/ }),

/***/ 90454:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "eN": function() { return /* reexport */ BrazeProvider; },
  "O8": function() { return /* reexport */ GlobalModalProvider; },
  "E0": function() { return /* reexport */ PushSettingProvider; },
  "KY": function() { return /* reexport */ RaffleInfoProvider; },
  "_9": function() { return /* reexport */ SearchQueryContextProvider; },
  "fS": function() { return /* reexport */ UserContextProvider; },
  "JT": function() { return /* reexport */ useGlobalModal; },
  "Km": function() { return /* reexport */ useRaffleInfoContext; },
  "VN": function() { return /* reexport */ useSearchQueryContext; },
  "SE": function() { return /* reexport */ useUserContext; }
});

// UNUSED EXPORTS: GlobalModalContext, TabProvider, useBrazeAPI, usePushSettingContext, useTabContext

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.3.1/node_modules/react/index.js
var react = __webpack_require__(75271);
;// CONCATENATED MODULE: ./src/provider/TabProvider.tsx


var TabContext = /*#__PURE__*/(0,react.createContext)({
  currentMainId: '',
  setCurrentMainId: function setCurrentMainId() {
    /* noop */
  }
});
var TabProvider = function TabProvider(_ref) {
  var children = _ref.children,
      tabList = _ref.tabList;

  var _useState = useState(tabList[0]['id']),
      currentMainId = _useState[0],
      setCurrentMainId = _useState[1];

  var tabValue = useMemo(function () {
    return {
      currentMainId: currentMainId,
      setCurrentMainId: setCurrentMainId
    };
  }, [currentMainId]);
  return _jsx(TabContext.Provider, {
    value: tabValue,
    children: children
  });
};
var useTabContext = function useTabContext() {
  return useContext(TabContext);
};
// EXTERNAL MODULE: ./node_modules/.pnpm/next@12.3.4_@babel+core@7.26.0_react-dom@18.3.1_react@18.3.1_sass@1.80.4/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(88756);
// EXTERNAL MODULE: ./node_modules/.pnpm/next@12.3.4_@babel+core@7.26.0_react-dom@18.3.1_react@18.3.1_sass@1.80.4/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(6325);
// EXTERNAL MODULE: ./node_modules/.pnpm/next@12.3.4_@babel+core@7.26.0_react-dom@18.3.1_react@18.3.1_sass@1.80.4/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(78838);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);
// EXTERNAL MODULE: ./node_modules/.pnpm/next@12.3.4_@babel+core@7.26.0_react-dom@18.3.1_react@18.3.1_sass@1.80.4/node_modules/next/router.js
var next_router = __webpack_require__(17966);
var router_default = /*#__PURE__*/__webpack_require__.n(next_router);
// EXTERNAL MODULE: ./node_modules/.pnpm/humps@2.0.1/node_modules/humps/humps.js
var humps = __webpack_require__(87493);
// EXTERNAL MODULE: ./node_modules/.pnpm/@bucketplace+bucket-log@1.2.3_@emotion+react@11.13.3_react-dom@18.3.1_react@18.3.1/node_modules/@bucketplace/bucket-log/dist/index.esm.js
var index_esm = __webpack_require__(46166);
// EXTERNAL MODULE: ./src/hooks/index.ts + 8 modules
var hooks = __webpack_require__(91002);
// EXTERNAL MODULE: ./src/utils/index.ts + 7 modules
var utils = __webpack_require__(73387);
// EXTERNAL MODULE: ./src/common/http.ts + 12 modules
var http = __webpack_require__(8585);
// EXTERNAL MODULE: ./node_modules/.pnpm/@emotion+react@11.13.3_@types+react@18.3.12_react@18.3.1/node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(83128);
;// CONCATENATED MODULE: ./src/provider/UserContextProvider.tsx



function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }










var UserContext = /*#__PURE__*/(0,react.createContext)({});
var UserContextProvider = function UserContextProvider(_ref) {
  var children = _ref.children;
  var router = (0,next_router.useRouter)();
  var prevLocationRef = (0,react.useRef)(null);

  var _useState = (0,react.useState)(undefined),
      userInfo = _useState[0],
      setUserInfo = _useState[1];

  var _useState2 = (0,react.useState)(!userInfo),
      pending = _useState2[0],
      setPending = _useState2[1];

  var _useState3 = (0,react.useState)(null),
      appBanner = _useState3[0],
      setAppBanner = _useState3[1];

  var _useState4 = (0,react.useState)(null),
      pcBanner = _useState4[0],
      setPcBanner = _useState4[1];

  var _useState5 = (0,react.useState)(null),
      nav = _useState5[0],
      setNav = _useState5[1];

  var _useState6 = (0,react.useState)(null),
      rawLoginUser = _useState6[0],
      setRawLoginUser = _useState6[1];

  var fetchNavigationData = (0,react.useCallback)(function () {
    setPending(true);
    (0,hooks/* getNavigationData */.EC)().then(function (data) {
      return convertNavigationData(data);
    }).then(function (data) {
      var _data$loginUser, _bucketLog, _data$storePcTopBanne;

      var userId = data === null || data === void 0 ? void 0 : (_data$loginUser = data.loginUser) === null || _data$loginUser === void 0 ? void 0 : _data$loginUser.userId;
      (_bucketLog = window.bucketLog) === null || _bucketLog === void 0 ? void 0 : _bucketLog.push({
        user_id: userId || null
      });
      setUserInfo({
        user: data === null || data === void 0 ? void 0 : data.loginUser,
        cartCount: data === null || data === void 0 ? void 0 : data.cartCount,
        notificationCount: data === null || data === void 0 ? void 0 : data.unseenNotification
      });
      setRawLoginUser(data.rawLoginUser);
      setAppBanner(data === null || data === void 0 ? void 0 : data.appDownloadBanner);
      setPcBanner(data === null || data === void 0 ? void 0 : (_data$storePcTopBanne = data.storePcTopBanner) === null || _data$storePcTopBanne === void 0 ? void 0 : _data$storePcTopBanne.contents);
      setNav(data === null || data === void 0 ? void 0 : data.nav);
    })["finally"](function () {
      setPending(false);
    });
  }, []);
  (0,react.useLayoutEffect)(function () {
    if (userInfo == null) {
      fetchNavigationData();
    }
  }, [userInfo, fetchNavigationData]);
  (0,react.useEffect)(function () {
    if (userInfo != null) {
      router.events.on('routeChangeComplete', index_esm/* logPageviewAfterLoad */.up);
    }

    return function () {
      return router.events.off('routeChangeComplete', index_esm/* logPageviewAfterLoad */.up);
    };
  }, [userInfo, router.events]);
  (0,react.useEffect)(function () {
    if (userInfo == null) return;

    if (prevLocationRef.current == null) {
      prevLocationRef.current = router.asPath;
      return;
    }

    var prevPath = prevLocationRef.current;
    var currPath = router.asPath;

    if (prevPath !== currPath) {
      prevLocationRef.current = currPath;
      (0,index_esm/* logPageviewBeforeLoad */.m1)(prevPath, currPath);
    }
  }, [prevLocationRef, router, userInfo]);
  var signOut = (0,react.useCallback)( /*#__PURE__*/(0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee() {
    var json;
    return regenerator_default().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return http/* clientHttp.delete */.J["delete"]('/api/navigation/signOut').json();

          case 2:
            json = _context.sent;

            if (json.success) {
              _context.next = 5;
              break;
            }

            return _context.abrupt("return");

          case 5:
            fetchNavigationData();
            window.bucketLog.push({
              user_id: null
            });
            (0,utils/* airbridgeLogout */.jQ)();

          case 8:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  })), [fetchNavigationData]);

  var convertNavigationData = function convertNavigationData(navigationData) {
    navigationData = (0,humps.camelizeKeys)(navigationData);
    var _navigationData = navigationData,
        loginUser = _navigationData.loginUser;
    return _objectSpread(_objectSpread({}, navigationData), {}, {
      rawLoginUser: loginUser,
      loginUser: loginUser ? {
        userId: loginUser.id,
        isAdmin: loginUser.isAdmin,
        imageUrl: loginUser.profileImageUrl,
        nickname: loginUser.nickname,
        userableType: loginUser.userableType
      } : null
    });
  };

  var userValue = (0,react.useMemo)(function () {
    return {
      userInfo: userInfo,
      appBanner: appBanner,
      pcBanner: pcBanner,
      pending: pending,
      signOut: signOut,
      nav: nav,
      rawLoginUser: rawLoginUser
    };
  }, [appBanner, pcBanner, pending, signOut, userInfo, nav, rawLoginUser]);
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(UserContext.Provider, {
    value: userValue,
    children: children
  });
};
var useUserContext = function useUserContext() {
  var context = (0,react.useContext)(UserContext);
  return context;
};
// EXTERNAL MODULE: ./src/types/index.ts + 2 modules
var types = __webpack_require__(45706);
;// CONCATENATED MODULE: ./src/provider/SearchQueryProvider.tsx


function SearchQueryProvider_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function SearchQueryProvider_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? SearchQueryProvider_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : SearchQueryProvider_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }







var defaultQuery = {
  osType: 'WEB',
  qaMode: false
};
var SearchQueryContext = /*#__PURE__*/(0,react.createContext)({});
var SearchQueryContextProvider = function SearchQueryContextProvider(_ref) {
  var children = _ref.children;

  var _useState = (0,react.useState)(defaultQuery),
      query = _useState[0],
      setQuery = _useState[1];

  (0,react.useEffect)(function () {
    handleQuery();
    router_default().events.on('routeChangeComplete', handleQuery);
  }, []);

  var handleQuery = function handleQuery() {
    var _router$query$id;

    var query = (0,humps.camelizeKeys)((0,utils/* getQuery */.pm)(location.href));
    var queryList = (0,utils/* filter */.hX)(query, function (_, k) {
      return types.searchQueryKeyList.includes(k);
    });
    var idQuery = (_router$query$id = (router_default()).query.id) === null || _router$query$id === void 0 ? void 0 : _router$query$id.replace('%20', '').trim();
    setQuery(SearchQueryProvider_objectSpread(SearchQueryProvider_objectSpread(SearchQueryProvider_objectSpread({}, defaultQuery), queryList), {}, {
      id: idQuery,
      osType: (0,utils/* getOSType */.z2)((router_default()).query)
    }));
  };

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SearchQueryContext.Provider, {
    value: query,
    children: children
  });
};
var useSearchQueryContext = function useSearchQueryContext() {
  var context = (0,react.useContext)(SearchQueryContext);
  return context;
};
;// CONCATENATED MODULE: ./src/provider/RaffleInfoProvider.tsx


var RaffleInfoContext = /*#__PURE__*/(0,react.createContext)(null);
var RaffleInfoProvider = function RaffleInfoProvider(_ref) {
  var children = _ref.children,
      initialData = _ref.initialData;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(RaffleInfoContext.Provider, {
    value: initialData,
    children: children
  });
};
var useRaffleInfoContext = function useRaffleInfoContext() {
  var context = (0,react.useContext)(RaffleInfoContext);
  return context;
};
// EXTERNAL MODULE: ./node_modules/.pnpm/swr@1.3.0_react@18.3.1/node_modules/swr/dist/index.mjs
var dist = __webpack_require__(75182);
;// CONCATENATED MODULE: ./src/provider/PushSettingProvider.tsx



var PushSettingContext = /*#__PURE__*/(0,react.createContext)(null);
var PushSettingProvider = function PushSettingProvider(_ref) {
  var children = _ref.children;

  var _useSWR = (0,dist/* default */.ZP)('/api/campaign/raffle/push-setting'),
      data = _useSWR.data;

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PushSettingContext.Provider, {
    value: data === null || data === void 0 ? void 0 : data.data,
    children: children
  });
};
var usePushSettingContext = function usePushSettingContext() {
  return useContext(PushSettingContext);
};
;// CONCATENATED MODULE: ./src/provider/BrazeProvider.tsx
 // import { useRouter } from 'next/router';

 // import { isInApp } from 'utils';


var BRAZE_API_SRC = 'https://js.appboycdn.com/web-sdk/4.8/braze.min.js';
var BRAZE_TOKEN = '5195e134-c2c9-4bdb-8431-ee5fca29b935';
var BRAZE_BASE_URL = 'sdk.iad-03.appboy.com';
var appboyLoading = null;
var initialized = false;

function getBrazeAPI() {
  if (false) {}

  return window.braze;
}

function loadBrazeAPI() {
  if (window.braze != null) {
    if (!initialized) {
      try {
        window.braze.initialize(BRAZE_TOKEN, {
          baseUrl: BRAZE_BASE_URL,
          allowUserSuppliedJavascript: true,
          enableHtmlInAppMessages: true,
          // debug code
          enableLogging: "prod" !== 'prod'
        });
        window.braze.display.automaticallyShowNewInAppMessages();
        window.braze.openSession(); // (window as any).braze.registerBrazePushMessages();
      } catch (e) {//
      }

      initialized = true;
    }

    return Promise.resolve(window.braze);
  } else if (appboyLoading != null) {
    return appboyLoading;
  } else {
    appboyLoading = new Promise(function (resolve) {
      var script = document.createElement('script');
      script.addEventListener('load', function () {
        var Braze = window.braze;
        Braze.initialize(BRAZE_TOKEN, {
          baseUrl: BRAZE_BASE_URL,
          allowUserSuppliedJavascript: true,
          enableHtmlInAppMessages: true,
          // debug code
          enableLogging: "prod" !== 'prod'
        }); // Braze.display.automaticallyShowNewInAppMessages();

        Braze.openSession(); // Braze.registerBrazePushMessages();

        initialized = true;
        resolve(Braze);
      });
      script.src = BRAZE_API_SRC;
      document.body.appendChild(script);
    });
    return appboyLoading;
  }
}

function useBrazeAPI(userId, onUpdate) {
  var _useState = (0,react.useState)(false),
      loaded = _useState[0],
      setLoaded = _useState[1]; // const router = useRouter();
  // const query = router.query;
  // const isApp = isInApp(query);


  (0,react.useEffect)(function () {
    if (!loaded) {
      loadBrazeAPI().then(function () {
        setLoaded(true);

        if (onUpdate != null) {
          onUpdate();
        }
      });
    }
  }, [loaded, onUpdate]);
  (0,react.useEffect)(function () {
    if (loaded === true && userId) {
      getBrazeAPI().changeUser(userId);
    }
  }, [userId, loaded]);
  return getBrazeAPI();
}
var BrazeProvider = function BrazeProvider(_ref) {
  var _user$userInfo, _user$userInfo$user, _user$userInfo$user$u;

  var children = _ref.children;
  var user = useUserContext();
  useBrazeAPI(user === null || user === void 0 ? void 0 : (_user$userInfo = user.userInfo) === null || _user$userInfo === void 0 ? void 0 : (_user$userInfo$user = _user$userInfo.user) === null || _user$userInfo$user === void 0 ? void 0 : (_user$userInfo$user$u = _user$userInfo$user.userId) === null || _user$userInfo$user$u === void 0 ? void 0 : _user$userInfo$user$u.toString());
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
    children: children
  });
};
// EXTERNAL MODULE: ./node_modules/.pnpm/@emotion+styled@11.13.0_@emotion+react@11.13.3_@types+react@18.3.12_react@18.3.1/node_modules/@emotion/styled/base/dist/emotion-styled-base.browser.esm.js
var emotion_styled_base_browser_esm = __webpack_require__(12851);
// EXTERNAL MODULE: ./node_modules/.pnpm/@bucketplace+ui@1.0.9_@emotion+react@11.13.3_@emotion+styled@11.13.0_react-dom@18.3.1_react@18.3.1_scheduler@0.23.2/node_modules/@bucketplace/ui/lib-esm/index.js + 45 modules
var lib_esm = __webpack_require__(28746);
// EXTERNAL MODULE: ./node_modules/.pnpm/@bucketplace+design-system@5.3.3_@bucketplace+ui@1.0.9_@emotion+react@11.13.3_@emotion+styled_gws5alfnqy5ixwsabrkna3jsv4/node_modules/@bucketplace/design-system/dist/esm/foundation.js
var foundation = __webpack_require__(54939);
// EXTERNAL MODULE: ./node_modules/.pnpm/@bucketplace+design-system@5.3.3_@bucketplace+ui@1.0.9_@emotion+react@11.13.3_@emotion+styled_gws5alfnqy5ixwsabrkna3jsv4/node_modules/@bucketplace/design-system/dist/esm/bds.js + 72 modules
var bds = __webpack_require__(85435);
;// CONCATENATED MODULE: ./src/components/ConfirmModal/ConfirmModal.tsx



function ConfirmModal_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function ConfirmModal_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ConfirmModal_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ConfirmModal_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }










var _ref =  true ? {
  name: "157zzg4",
  styles: "z-index:1300"
} : 0;

function ConfirmModal(_ref2) {
  var message = _ref2.message,
      onConfirm = _ref2.onConfirm,
      onCancel = _ref2.onCancel,
      cancelable = _ref2.cancelable,
      confirmText = _ref2.confirmText,
      _ref2$secondaryText = _ref2.secondaryText,
      secondaryText = _ref2$secondaryText === void 0 ? '취소' : _ref2$secondaryText;
  var secondaryAction = {};

  if (cancelable) {
    secondaryAction = {
      secondary: {
        onClick: onCancel,
        text: secondaryText
      }
    };
  }

  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(lib_esm/* ScrollLock */.tH, {
      enabled: true
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(bds/* Modal */.u_l, {
      css: _ref,
      width: 300,
      isPopupInMobile: true,
      footer: {
        action: ConfirmModal_objectSpread({
          primary: {
            onClick: onConfirm,
            text: confirmText !== null && confirmText !== void 0 ? confirmText : '확인'
          }
        }, secondaryAction)
      },
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Content, {
        children: message
      })
    })]
  });
}

var Content = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("p",  true ? {
  target: "eek1r6l0"
} : 0)(foundation.F.body1_1, ";color:", function (_ref3) {
  var theme = _ref3.theme;
  return theme.content.base1;
}, ";padding:16px 16px 10px 16px;text-align:center;word-break:keep-all;white-space:pre-line;" + ( true ? "" : 0));
;// CONCATENATED MODULE: ./src/components/ConfirmModal/index.ts

;// CONCATENATED MODULE: ./src/provider/GlobalConfirmModalProvider.tsx


function GlobalConfirmModalProvider_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function GlobalConfirmModalProvider_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? GlobalConfirmModalProvider_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : GlobalConfirmModalProvider_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

/* eslint-disable @typescript-eslint/no-empty-function */




var GlobalModalContext = /*#__PURE__*/react.createContext({
  openConfirmModal: function openConfirmModal() {
    return new Promise(function () {});
  },
  openAlertModal: function openAlertModal() {
    return new Promise(function () {});
  }
});
/**
 * 다양한 곳에서 공통으로 사용되는 Confirm, Alert 모달을 생성하는 메서드를 제공합니다.
 * openConfirmModal: 공통으로 사용되는 Confirm 모달을 생성합니다.
 * openAlertModal: 공통으로 사용되는 Alert 모달을 생성합니다.
 */
// eslint-disable-next-line @typescript-eslint/ban-types

function GlobalModalProvider(_ref) {
  var children = _ref.children;

  var _useState = (0,react.useState)(null),
      confirmModalProps = _useState[0],
      setConfirmModalProps = _useState[1];

  var openConfirmModal = (0,react.useCallback)(function (props) {
    return new Promise(function (resolve) {
      setConfirmModalProps(GlobalConfirmModalProvider_objectSpread(GlobalConfirmModalProvider_objectSpread({}, props), {}, {
        cancelable: true,
        onConfirm: function onConfirm() {
          setConfirmModalProps(null);
          resolve(true);
        },
        onCancel: function onCancel() {
          setConfirmModalProps(null);
          resolve(false);
        }
      }));
    });
  }, []);
  var openAlertModal = (0,react.useCallback)(function (props) {
    return new Promise(function (resolve) {
      setConfirmModalProps(GlobalConfirmModalProvider_objectSpread(GlobalConfirmModalProvider_objectSpread({}, props), {}, {
        cancelable: false,
        onConfirm: function onConfirm() {
          resolve();
          setConfirmModalProps(null);
        }
      }));
    });
  }, []);
  return (// eslint-disable-next-line react/jsx-no-constructed-context-values
    (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(GlobalModalContext.Provider, {
      value: {
        openConfirmModal: openConfirmModal,
        openAlertModal: openAlertModal
      },
      children: [children, confirmModalProps && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ConfirmModal, GlobalConfirmModalProvider_objectSpread({}, confirmModalProps))]
    })
  );
}
function useGlobalModal() {
  return (0,react.useContext)(GlobalModalContext);
}
;// CONCATENATED MODULE: ./src/provider/index.ts








/***/ }),

/***/ 45706:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "DELIVERY_SERVICE_CODE": function() { return /* reexport */ DELIVERY_SERVICE_CODE; },
  "searchQueryKeyList": function() { return /* reexport */ searchQueryKeyList; }
});

;// CONCATENATED MODULE: ./src/types/Product.ts
var DELIVERY_SERVICE_CODE = {
  /** 화물택배 배송 */
  Cargo: 'CARGO',

  /** 미노출 */
  None: 'NONE',

  /** 일반택배 */
  Normal: 'NORMAL',

  /** 오늘의집 배송 */
  Ohouse: 'OHOUSE',

  /** 직접배송 */
  Seller: 'SELLER',

  /** 빠른가전배송 */
  ThirdPartyAppliance: 'THIRD_PARTY_APPLIANCE',

  /** 빠른가구배송 */
  ThirdPartyFurniture: 'THIRD_PARTY_FURNITURE'
};
;// CONCATENATED MODULE: ./src/types/Query.ts
var searchQueryKeyList = ['osType', 'version', 'qaMode', 'id'];
;// CONCATENATED MODULE: ./src/types/index.ts






/***/ }),

/***/ 89369:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "hA": function() { return /* reexport */ getMarketingFooterScript; },
  "JM": function() { return /* reexport */ getMarketingHeaderScript; },
  "My": function() { return /* reexport */ handleLog; },
  "Qe": function() { return /* reexport */ handleOpenApp; },
  "d4": function() { return /* reexport */ runMarketingFooterScript; },
  "Ht": function() { return /* reexport */ runMarketingHeaderScript; }
});

// UNUSED EXPORTS: runAmplitudeScript

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.3.1/node_modules/react/index.js
var react = __webpack_require__(75271);
// EXTERNAL MODULE: ./node_modules/.pnpm/next@12.3.4_@babel+core@7.26.0_react-dom@18.3.1_react@18.3.1_sass@1.80.4/node_modules/next/script.js
var script = __webpack_require__(32779);
var script_default = /*#__PURE__*/__webpack_require__.n(script);
// EXTERNAL MODULE: ./node_modules/.pnpm/@emotion+react@11.13.3_@types+react@18.3.12_react@18.3.1/node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(83128);
;// CONCATENATED MODULE: ./src/utils/Navigation/_marketingFooter.js
/* eslint-disable */




var getNaverSearch = function getNaverSearch() {
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((script_default()), {
    type: "text/javascript",
    src: "https://wcs.naver.net/wcslog.js"
  }, 'naver-search-js');
};

var runNaverSearch = function runNaverSearch() {
  if (window.wcs != null) {
    if (!window.wcs_add) window.wcs_add = {};
    window.wcs_add['wa'] = 's_2e85116be219';
    if (!_nasa) var _nasa = {};
    wcs.inflow('ohou.se');
    wcs_do(_nasa);
  }
};

var getKakaoMomentScript = function getKakaoMomentScript() {
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((script_default()), {
    type: "text/javascript",
    charset: "UTF-8",
    src: "//t1.daumcdn.net/adfit/static/kp.js"
  }, 'kakao-moment-js');
};

var runKakaoMomentScript = function runKakaoMomentScript() {
  if (window.kakaoPixel != null) {
    kakaoPixel('7919701595446099671').pageView();
  }
};

var getEnlipleScript = function getEnlipleScript() {
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((script_default()), {
    src: "https://cdn.megadata.co.kr/js/en_script/3.5/enliple_min3.5.js",
    async: "async",
    onLoad: function onLoad() {
      var rf = new EN();
      rf.setData('userid', 'bucketplace');
      rf.setSSL(true);
      rf.sendRf();

      if (typeof handleEnlipleLoadShop === 'function') {
        handleEnlipleLoadShop();
      }
    }
  }, 'enliple-js');
};

var getWiderPlanetScript = function getWiderPlanetScript() {
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((script_default()), {
    type: "text/javascript",
    async: "async",
    src: "//cdn-aitg.widerplanet.com/js/wp_astg_4.0.js"
  }, 'wider-planet-js');
};

var getWiderPrepareDiv = function getWiderPrepareDiv() {
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
    id: "wp_tg_cts",
    style: {
      display: 'none'
    }
  }, 'wider-planer-div');
};

var runWiderPlanetScript = function runWiderPlanetScript(user) {
  window.wptg_tagscript_vars = window.wptg_tagscript_vars || [];
  window.wptg_tagscript_vars.push(function () {
    return {
      wp_hcuid: user !== null && user !== void 0 && user.userId ? user.userId : '',
      ti: '47350',
      ty: 'Home',
      device: navigator.userAgent.match(/ios|iphone|ipad|android/i) ? 'mobile' : 'web'
    };
  });
};

var getMarketingFooterScript = function getMarketingFooterScript() {
  var isProduction = true;
  var scriptList = [];

  if (isProduction) {
    scriptList.push(getNaverSearch());
    scriptList.push(getKakaoMomentScript());
    scriptList.push(getEnlipleScript());
    scriptList.push(getWiderPrepareDiv());
    scriptList.push(getWiderPlanetScript());
  }

  return scriptList;
};
var runMarketingFooterScript = function runMarketingFooterScript(user) {
  var isProduction = true;

  if (isProduction) {
    runNaverSearch();
    runKakaoMomentScript();
    runWiderPlanetScript(user);
  } else {
    window.wptg_tagscript_vars = window.wptg_tagscript_vars || [];
  }
};
// EXTERNAL MODULE: ./node_modules/.pnpm/next@12.3.4_@babel+core@7.26.0_react-dom@18.3.1_react@18.3.1_sass@1.80.4/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(6325);
// EXTERNAL MODULE: ./node_modules/.pnpm/next@12.3.4_@babel+core@7.26.0_react-dom@18.3.1_react@18.3.1_sass@1.80.4/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(78838);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);
// EXTERNAL MODULE: ./node_modules/.pnpm/@bucketplace+bucket-log@1.2.3_@emotion+react@11.13.3_react-dom@18.3.1_react@18.3.1/node_modules/@bucketplace/bucket-log/dist/index.esm.js
var index_esm = __webpack_require__(46166);
// EXTERNAL MODULE: ./src/common/index.ts + 5 modules
var common = __webpack_require__(23336);
;// CONCATENATED MODULE: ./src/utils/Navigation/_marketingHeader.js



/* eslint-disable */








var runPrepareScript = function runPrepareScript() {
  window.dataLayer = [];
  window.bucketLog = window.bucketLog || [];

  window.fbq = function () {};
};

var getBucketLogScript = function getBucketLogScript() {
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("script", {
    id: "logging-js",
    src: (0,index_esm/* getLogURL */.Wq)({
      environment: common/* APP_PROFILE */.ui,
      version: common/* APP_VERSION */.Ji
    }),
    defer: true
  }, 'logging-js');
};

var runProdLogOhouseScript = function runProdLogOhouseScript(user) {
  window.bucketLog = window.bucketLog || [];

  if (user != null) {
    window.bucketLog.push({
      user_id: user.userId || null
    });
  }
};

var runGoogleTagManagerScript = function runGoogleTagManagerScript(user) {
  if (user !== null && user !== void 0 && user.userId) {
    var dataLayer = [{
      userID: user.userId
    }];
  }

  (function (w, d, s, l, i) {
    w[l] = w[l] || [];
    w[l].push({
      'gtm.start': new Date().getTime(),
      event: 'gtm.js'
    });
    var f = d.getElementsByTagName(s)[0],
        j = d.createElement(s),
        dl = l != 'dataLayer' ? '&l=' + l : '';
    j.async = true;
    j.src = 'https://www.googletagmanager.com/gtm.js?id=' + i + dl;
    f.parentNode.insertBefore(j, f);
  })(window, document, 'script', 'dataLayer', 'GTM-MK8DN2Q');
};

var getGoogleTagManagerScript = function getGoogleTagManagerScript() {
  (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("noscript", {
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("iframe", {
      src: "https://www.googletagmanager.com/ns.html?id=GTM-MK8DN2Q",
      height: "0",
      width: "0",
      style: "display:none;visibility:hidden",
      allowfullscreen: true
    })
  });
};

var runFaceBookPixelCodeScript = function runFaceBookPixelCodeScript() {
  !function (f, b, e, v, n, t, s) {
    if (f.fbq) return;

    n = f.fbq = function () {
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
    };

    if (!f._fbq) f._fbq = n;
    n.push = n;
    n.loaded = !0;
    n.version = '2.0';
    n.queue = [];
    t = b.createElement(e);
    t.async = !0;
    t.src = v;
    s = b.getElementsByTagName(e)[0];
    s.parentNode.insertBefore(t, s);
  }(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
  fbq('set', 'autoConfig', 'false', '937204509645248');
  fbq('init', '937204509645248');
  fbq('track', 'PageView');
};

var getFaceBookPixelPrepare = function getFaceBookPixelPrepare() {
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("noscript", {
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("img", {
      height: "1",
      width: "1",
      style: {
        display: 'none'
      },
      src: "https://www.facebook.com/tr?id=937204509645248&ev=PageView&noscript=1"
    })
  }, 'facebookpixel-prepare');
};

var runCriteoScript = function runCriteoScript(user) {
  (function () {
    var ua = navigator.userAgent.toLowerCase();
    var mobile = {
      isAndroid: ua.indexOf('android') > -1,
      isIos: ua.match(/(ipad|iphone|ipod)/g)
    };
    var type = '';

    if (mobile.isAndroid || mobile.isIos) {
      type = 'm';
    } else {
      type = 'd';
    }

    window.criteo_q = window.criteo_q || [];
    window.criteo_q.push({
      event: 'setAccount',
      account: 50838
    }, {
      event: 'setEmail',
      email: user !== null && user !== void 0 && user.userId ? "".concat(user.userId, "@bucketplace.net") : ''
    }, {
      event: 'setSiteType',
      type: type
    });
  })();
};

var getCriteoScript = function getCriteoScript() {
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("script", {
    type: "text/javascript",
    src: "//static.criteo.net/js/ld/ld.js",
    async: true
  }, 'criteo-js');
};

var runAmplitudeBefore = function runAmplitudeBefore() {
  (function (e, t) {
    var n = e.amplitude || {
      _q: [],
      _iq: {}
    };

    function i(e, t) {
      e.prototype[t] = function () {
        this._q.push([t].concat(Array.prototype.slice.call(arguments, 0)));

        return this;
      };
    }

    var o = function o() {
      this._q = [];
      return this;
    };

    var a = ["add", "append", "clearAll", "prepend", "set", "setOnce", "unset", "preInsert", "postInsert", "remove"];

    for (var c = 0; c < a.length; c++) {
      i(o, a[c]);
    }

    n.Identify = o;

    var l = function l() {
      this._q = [];
      return this;
    };

    var u = ["setProductId", "setQuantity", "setPrice", "setRevenueType", "setEventProperties"];

    for (var p = 0; p < u.length; p++) {
      i(l, u[p]);
    }

    n.Revenue = l;
    var d = ["init", "logEvent", "logRevenue", "setUserId", "setUserProperties", "setOptOut", "setVersionName", "setDomain", "setDeviceId", "enableTracking", "setGlobalUserProperties", "identify", "clearUserProperties", "setGroup", "logRevenueV2", "regenerateDeviceId", "groupIdentify", "onInit", "onNewSessionStart", "logEventWithTimestamp", "logEventWithGroups", "setSessionId", "resetSessionId", "getDeviceId", "getUserId", "setMinTimeBetweenSessionsMillis", "setEventUploadThreshold", "setUseDynamicConfig", "setServerZone", "setServerUrl", "sendEvents", "setLibrary", "setTransport"];

    function v(t) {
      function e(e) {
        t[e] = function () {
          t._q.push([e].concat(Array.prototype.slice.call(arguments, 0)));
        };
      }

      for (var n = 0; n < d.length; n++) {
        e(d[n]);
      }
    }

    v(n);

    n.getInstance = function (e) {
      e = (!e || e.length === 0 ? "$default_instance" : e).toLowerCase();

      if (!Object.prototype.hasOwnProperty.call(n._iq, e)) {
        n._iq[e] = {
          _q: []
        };
        v(n._iq[e]);
      }

      return n._iq[e];
    };

    e.amplitude = n;
  })(window, document);
};

var initAmplitude = function initAmplitude(isProduction, user) {
  var _user$userId;

  window.amplitude.getInstance().init(isProduction ? '5a87b5059b95b7a68fda866acf155c56' : 'dc73f13a3e81af36c9f61718642148af', (_user$userId = user === null || user === void 0 ? void 0 : user.userId) !== null && _user$userId !== void 0 ? _user$userId : null, function () {
    var accountGroup = '';

    if (user !== null && user !== void 0 && user.isAdmin) {
      accountGroup = '어드민';
    } else if ((user === null || user === void 0 ? void 0 : user.userableType) === 'ExpertUser') {
      accountGroup = '전문가';
    } else if ((user === null || user === void 0 ? void 0 : user.userableType) === 'SalesUser') {
      accountGroup = '판매자';
    } else if (user != null) {
      accountGroup = '일반회원';
    } else {
      accountGroup = null;
    }

    window.amplitude.getInstance().setUserProperties({
      'State of 로그인': user !== null && user !== void 0 && user.userId ? 'true' : 'false',
      'Account Group': accountGroup
    });
  });
};

var runAmplitudeBridge = function runAmplitudeBridge(isProduction, user) {
  var androidAvailable = window.ohouseAmplitudeInterface != null;
  var iosAvailable = window.webkit != null && window.webkit.messageHandlers != null && window.webkit.messageHandlers.ohouseAmplitudeInterface != null;

  if (androidAvailable || iosAvailable) {
    // Use a mock interface of Amplitude. However, we shouldn't override
    // original Amplitude object - it contains a queue that needs to be
    // executed.
    // Therefore, instead of overriding the object as whole, we should override
    // its methods.
    // First, read out all objects in window.amplitude
    var amplitude = window.amplitude || {
      _q: [],
      _iq: {}
    };
    window.amplitude = amplitude;

    var override = function override(v) {
      // Then, override certain methods we need to track
      v.logEvent = function (name, props, callback) {
        if (androidAvailable) {
          window.ohouseAmplitudeInterface.sendEvent(name, JSON.stringify(props));
        } else if (iosAvailable) {
          window.webkit.messageHandlers.ohouseAmplitudeInterface.postMessage({
            type: 'sendEvent',
            name: name,
            properties: props
          });
        }

        if (callback != null) callback();
      };

      v.setUserProperties = function (props) {
        var identify = new v.Identify(); // eslint-disable-next-line guard-for-in

        for (var name in props) {
          identify.set(name, props[name]);
        }

        v.identify(identify);
      };

      v.identify = function (identify) {
        // Fortunately identify's _q is equivalent to what we need to send
        if (androidAvailable) {
          window.ohouseAmplitudeInterface.identify(JSON.stringify(identify._q));
        } else if (iosAvailable) {
          window.webkit.messageHandlers.ohouseAmplitudeInterface.postMessage({
            type: 'identify',
            actions: identify._q
          });
        }
      }; // Supply 'Identify', 'Revenue' object


      v.Identify = amplitude.Identify;
      v.Revenue = amplitude.Revenue; // Finally, execute the queue.

      for (var i = 0; i < v._q.length; i += 1) {
        var command = v._q[i];

        if (['logEvent', 'setUserProperties', 'identify'].indexOf(command[0]) !== -1) {
          // eslint-disable-next-line prefer-spread
          v[command[0]].apply(v, command.slice(1));
        }
      }

      v._q = [];
    }; // Override amplitude object itself, and _iq


    override(amplitude); // eslint-disable-next-line guard-for-in

    for (var name in amplitude._iq) {
      override(amplitude._iq[name]);
    }
  } else {
    // Normal environment detected; just use regular SDK
    var r = document.createElement('script');
    r.type = 'text/javascript';
    r.integrity = 'sha384-cukXwabQy+j/QA1+RqiXSzxhgQg5Rrn3zVszlwH3pWj/bXJxlA8Ge7NhcD6vP2Ik';
    r.crossOrigin = 'anonymous';
    r.async = true;
    r.src = 'https://cdn.amplitude.com/libs/amplitude-7.1.0-min.gz.js';

    r.onload = function () {
      if (!window.amplitude.runQueuedFunctions) {
        console.log('[Amplitude] Error: could not load SDK');
      }

      initAmplitude(isProduction, user);
    };

    var i = document.getElementsByTagName('script')[0];
    i.parentNode.insertBefore(r, i);
  }
};

var runAmplitudeScript = /*#__PURE__*/function () {
  var _ref = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee(isProduction, user) {
    return regenerator_default().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return runAmplitudeBefore();

          case 2:
            _context.next = 4;
            return runAmplitudeBridge(isProduction, user);

          case 4:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function runAmplitudeScript(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();

var getADInsightScript = function getADInsightScript() {
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("script", {
      type: "text/javascript",
      children: "var TRS_AIDX = /iPhone|iPad|iPod|Android/.test(navigator.userAgent) ? 11603 : 11598;"
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("script", {
      type: "text/javascript",
      src: "https://analysis.adinsight.co.kr/emnet/trs_esc.js",
      defer: true
    }, 'ad-insight-js')]
  });
};

var runSentryTestingScript = function runSentryTestingScript(isProduction, user) {
  if (isProduction) {
    Raven.config('https://b8e5cc27b3eb44be8b976b0c81dd4115@sentry.io/271486').install();

    if (user != null) {
      Raven.setUserContext({
        id: user.userId,
        email: user.userId ? "".concat(user.userId, "@bucketplace.net") : '',
        nickname: user.nickname
      });
    }

    Raven.setUserContext({});
  }
};

var getSentryTestingScript = function getSentryTestingScript() {
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("script", {
    src: "https://cdn.ravenjs.com/3.26.4/raven.min.js",
    crossOrigin: "anonymous"
  }, 'sentry-testing-js');
};

var getJSONDataScript = function getJSONDataScript() {
  var structuredData = {
    "@context": "http://schema.org",
    "@type": "Organization",
    "name": "오늘의집",
    "url": "https://ohou.se",
    "sameAs": ["https://www.instagram.com/todayhouse/?hl=ko", "https://www.facebook.com/interiortoday", "https://m.post.naver.com/my.nhn?memberNo=202156", "https://itunes.apple.com/kr/app/id1008236892", "https://play.google.com/store/apps/details?id=net.bucketplace&hl=ko", "https://www.youtube.com/channel/UCBKtitA1RwY7F32rCniV1dA/featured"]
  };
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("script", {
    type: "application/ld+json",
    dangerouslySetInnerHTML: {
      __html: JSON.stringify(structuredData)
    }
  });
};

var runAirbridgeScript = function runAirbridgeScript(user) {
  (function (a_, i_, r_, _b, _r, _i, _d, _g, _e) {
    if (!a_[_b]) {
      var d = {
        queue: []
      };

      _r.concat(_i).forEach(function (a) {
        var i_ = a.split("."),
            a_ = i_.pop();

        i_.reduce(function (a, i_) {
          return a[i_] = a[i_] || {};
        }, d)[a_] = function () {
          d.queue.push([a, arguments]);
        };
      });

      a_[_b] = d;
      a_ = i_.getElementsByTagName(r_)[0];
      i_ = i_.createElement(r_);

      i_.onerror = function () {
        d.queue.filter(function (a) {
          return 0 <= _i.indexOf(a[0]);
        }).forEach(function (a) {
          a = a[1];
          a = a[a.length - 1];
          "function" === typeof a && a("error occur when load airbridge");
        });
      };

      i_.async = 1;
      i_.src = "//static.airbridge.io/sdk/latest/airbridge.min.js";
      a_.parentNode.insertBefore(i_, a_);
    }
  })(window, document, "script", "airbridge", "init fetchResource setBanner setDownload setDownloads setDeeplinks sendWeb setUserAgent setUserAlias addUserAlias setMobileAppData setUserId setUserEmail setUserPhone setUserAttributes clearUser setDeviceIFV setDeviceIFA setDeviceGAID events.send events.signIn events.signUp events.signOut events.purchased events.addedToCart events.productDetailsViewEvent events.homeViewEvent events.productListViewEvent events.searchResultViewEvent".split(" "), ["events.wait"]);

  var initObject = {
    app: 'ohouse',
    webToken: '2bd43efc5ef8401baece946c84ba155d',
    cookieWindow: 1,
    userHash: false,
    urlQueryMapping: {
      channel: 'utm_source',
      campaign: 'utm_campaign',
      term: 'utm_term',
      ad_creative: 'utm_content',
      ad_group: 'bp_adset',
      content: 'bp_content',
      sub_id: 'bp_sub_id',
      sub_id_1: 'bp_sub_id_1',
      sub_id_2: 'bp_sub_id_2',
      sub_id_3: 'utm_medium'
    }
  };

  if (user != null) {
    initObject.user = {
      externalUserID: "".concat(user.userId),
      externalUserEmail: "".concat(user.userId, "@bucketplace.net")
    };
  }

  airbridge.init(initObject);
};

var runA1mediaScript = function runA1mediaScript() {
  var linkback = linkback || {};

  (function () {
    var d = document,
        scr = d.createElement('script'),
        tar = d.getElementsByTagName('script')[0];
    scr.type = 'text/javascript';
    scr.async = true;
    var dt = new Date();
    var date_s = dt.getFullYear().toString() + ('0' + (dt.getMonth() + 1)).slice(-2) + ('0' + dt.getDate()).slice(-2);
    scr.src = 'https://linkback.contentsfeed.com/src/' + date_s + '/lb4ohouse.min.js';
    scr.charset = 'utf-8';

    if (!linkback.l) {
      linkback.l = true;
      tar.parentNode.insertBefore(scr, tar);
    }
  })();
};

var getMarketingHeaderScript = function getMarketingHeaderScript(userInfo) {
  var isProduction = true;
  var scriptList = [];

  if (userInfo) {
    scriptList.push(getBucketLogScript());
  }

  if (isProduction) {
    scriptList.push(getFaceBookPixelPrepare());
    scriptList.push(getCriteoScript());
    scriptList.push(getADInsightScript());
    scriptList.push(getSentryTestingScript());
    scriptList.push(getJSONDataScript());
    scriptList.push(getGoogleTagManagerScript());
  }

  return scriptList;
};
var runMarketingHeaderScript = function runMarketingHeaderScript(user) {
  var isProduction = true;

  if (isProduction) {
    runGoogleTagManagerScript(user);
    runFaceBookPixelCodeScript();
    runCriteoScript(user);
    runProdLogOhouseScript(user);
    runAmplitudeScript(isProduction, user);
    runSentryTestingScript(isProduction, user);
    runAirbridgeScript(user);
    runA1mediaScript();
  } else {
    runPrepareScript();
  }
};
// EXTERNAL MODULE: ./node_modules/.pnpm/next@12.3.4_@babel+core@7.26.0_react-dom@18.3.1_react@18.3.1_sass@1.80.4/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(88756);
;// CONCATENATED MODULE: ./src/utils/cookie.ts

var VISITOR_ID_KEY = 'b_visitor_id';
var getCookie = function getCookie(cookieName) {
  var _document;

  var cookieValue = null;

  if ((_document = document) !== null && _document !== void 0 && _document.cookie) {
    var array = document.cookie.split("".concat(escape(cookieName), "="));

    if (array.length >= 2) {
      var arraySub = array[1].split(';');
      cookieValue = unescape(arraySub[0]);
    }
  }

  return cookieValue;
};
var setCookie = function setCookie(name, value, delay) {
  document.cookie = ["".concat(name, "=").concat(value), 'path=/', 'domain=.ohou.se', "expires=".concat(new Date(Date.now() + delay).toUTCString())].join(';');
  document.cookie = ["".concat(name, "=").concat(value), 'path=/', "expires=".concat(new Date(Date.now() + delay).toUTCString())].join(';');
};
/**
 * document.cookie를 object 형태로 변환합니다.
 * @param {string} cookieString document.cookie
 * @return {object} cookie의 키-값 쌍
 */

var getDocumentCookieObject = function getDocumentCookieObject(cookieString) {
  return cookieString.split('; ').reduce(function (prev, current) {
    var _current$split = current.split('='),
        _current$split2 = _toArray(_current$split),
        name = _current$split2[0],
        value = _current$split2.slice(1);

    prev[name] = value.join('=');
    return prev;
  }, {});
};
/**
 * document.cookie에서 b_visitor_id 값을 추출합니다.
 * @param {object} context next api context
 * @return {string|undefined} b_visitor_id 값
 */

var getVisitorId = function getVisitorId(context) {
  var _context$req, _context$req$headers;

  var cookieObj = getDocumentCookieObject(((_context$req = context.req) === null || _context$req === void 0 ? void 0 : (_context$req$headers = _context$req.headers) === null || _context$req$headers === void 0 ? void 0 : _context$req$headers.cookie) || '');
  return cookieObj[VISITOR_ID_KEY];
};
// EXTERNAL MODULE: ./src/utils/tracking.ts + 5 modules
var tracking = __webpack_require__(24724);
;// CONCATENATED MODULE: ./src/utils/Navigation/banner.ts


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }




var LOG_MAP = {
  'banner.top.pc.click': {
    bucket: {
      section: '네비 배너'
    }
  },
  'banner.top.pc.close': {
    bucket: {
      section: '네비 배너 닫기'
    },
    cookie: 'ohsTopBannerClosed'
  },
  'banner.top.mobile.click': {
    bucket: {
      section: '네비 배너'
    }
  },
  'banner.top.mobile.close': {
    bucket: {
      section: '네비 배너 닫기'
    },
    cookie: 'ohsTopBannerClosed'
  },
  'banner.bottom.mobile.click': {
    bucket: {
      section: '앱 다운로드'
    }
  },
  'banner.bottom.mobile.close': {
    bucket: {
      section: '앱 다운로드 닫기'
    },
    cookie: 'ohsAppDownloadPopupClosed'
  }
};
var handleLog = function handleLog(type, index) {
  var _LOG_MAP$type = LOG_MAP[type],
      bucket = _LOG_MAP$type.bucket,
      cookie = _LOG_MAP$type.cookie;

  if (index !== undefined) {
    bucket = _objectSpread(_objectSpread({}, bucket), {}, {
      index: index
    });
  }

  if (bucket) {
    (0,index_esm/* bucketLog */._P)(_objectSpread({
      category: 'click'
    }, bucket));
  }

  if (cookie) {
    setCookie(cookie, 'yes', 24 * 3600 * 1000);
  }
};
var APP_OPEN_MAP = {
  'banner.bottom.mobile.click': {
    sub_id_1: 'web_bottom_bnr'
  },
  'banner.top.mobile.click': {
    sub_id_1: 'web_top_bnr'
  }
};
var handleOpenApp = function handleOpenApp(type) {
  window.location.href = (0,tracking/* getDeepLink */.bW)(APP_OPEN_MAP[type]);
};
;// CONCATENATED MODULE: ./src/utils/Navigation/index.ts




/***/ }),

/***/ 76823:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ getAppOsInfo; },
/* harmony export */   "d": function() { return /* binding */ saveAppOsInfo; }
/* harmony export */ });
/* harmony import */ var querystring__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(97150);
/* harmony import */ var _isSSR__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(17234);


var saveAppOsInfo = function saveAppOsInfo() {
  var search = querystring__WEBPACK_IMPORTED_MODULE_0__.parse(location.search.slice(1));

  try {
    localStorage.os_type = search.os_type;
    localStorage.os_version = search.version;
  } catch (err) {//
  }
}; // TODO: Type 구체화

var getAppOsInfo = function getAppOsInfo() {
  if (_isSSR__WEBPACK_IMPORTED_MODULE_1__/* .isSSR */ .y) {
    return null;
  }

  var search = querystring__WEBPACK_IMPORTED_MODULE_0__.parse(location.search.slice(1));
  var osType = null;
  var osVersion = null;

  if (search.os_type != null) {
    osType = search.os_type;
    localStorage.os_type = search.os_type;
  } else {
    osType = localStorage.os_type;
  }

  if (search.version != null) {
    osVersion = search.version;
    localStorage.os_version = search.version;
  } else {
    osVersion = localStorage.os_version;
  }

  return {
    osType: osType,
    osVersion: osVersion
  };
};

/***/ }),

/***/ 73387:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "jQ": function() { return /* reexport */ tracking/* airbridgeLogout */.jQ; },
  "Kc": function() { return /* reexport */ checkAppVersion; },
  "hX": function() { return /* reexport */ tracking/* filter */.hX; },
  "ZA": function() { return /* reexport */ OSVersion/* getAppOsInfo */.Z; },
  "bW": function() { return /* reexport */ tracking/* getDeepLink */.bW; },
  "l7": function() { return /* reexport */ getDeviceType; },
  "z2": function() { return /* reexport */ getOSType; },
  "pm": function() { return /* reexport */ tracking/* getQuery */.pm; },
  "Wz": function() { return /* reexport */ tracking/* getQueryString */.Wz; },
  "fe": function() { return /* reexport */ handleClickLog; },
  "mT": function() { return /* reexport */ Navigation/* handleLog */.My; },
  "Qe": function() { return /* reexport */ Navigation/* handleOpenApp */.Qe; },
  "a4": function() { return /* reexport */ intComma; },
  "Z0": function() { return /* reexport */ isInApp; },
  "tq": function() { return /* reexport */ isMobile; },
  "d5": function() { return /* reexport */ OSVersion/* saveAppOsInfo */.d; },
  "gu": function() { return /* reexport */ tracking/* sendA1MediaInflow */.gu; },
  "Gp": function() { return /* reexport */ sendBrazeLog; },
  "A2": function() { return /* reexport */ tracking/* setUtmData */.A2; },
  "Vl": function() { return /* reexport */ useAutoChangeComponent; }
});

// UNUSED EXPORTS: ANDROID_VERSION_ERROR_NAME, detectDeviceSSR, fetchKakaoAPI, formatOsType, getCookie, getDocumentCookieObject, getMarketingFooterScript, getMarketingHeaderScript, getOSTypeSSR, getUtmData, getUtmDataFromUrl, getVisitorId, imageLoader, isEmptyString, isSSR, memoize, omitKeys, runAmplitudeScript, runMarketingFooterScript, runMarketingHeaderScript, sendAirbridgeLog, sendBrazeAppLog, setCookie, share, shareKakao, throttle, useDetectDevice

// EXTERNAL MODULE: ./node_modules/.pnpm/querystring@0.2.1/node_modules/querystring/index.js
var querystring = __webpack_require__(97150);
// EXTERNAL MODULE: ./node_modules/.pnpm/ua-parser-js@1.0.39/node_modules/ua-parser-js/src/ua-parser.js
var ua_parser = __webpack_require__(93191);
var ua_parser_default = /*#__PURE__*/__webpack_require__.n(ua_parser);
// EXTERNAL MODULE: ./src/utils/isSSR.ts
var isSSR = __webpack_require__(17234);
;// CONCATENATED MODULE: ./src/utils/detectDevice.ts




var isMobile = function isMobile() {
  if (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1) {
    return true;
  }

  return /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
};
var isInApp = function isInApp(query) {
  if (isSSR/* isSSR */.y) {
    if (query != null) {
      return query.os_type != null || query.app != null;
    }

    return false;
  }

  var triggered = false;

  try {
    triggered = sessionStorage.webviewTriggered === 'yes';
  } catch (e) {//
  }

  var search = querystring.parse(location.search.slice(1));

  if (triggered || search.os_type != null && search.os_type !== '' || search.app != null) {
    try {
      sessionStorage.webviewTriggered = 'yes';
    } catch (e) {//
    }

    return true;
  }

  return false;
};
var useDetectDevice = function useDetectDevice() {
  var isDesktopOrLaptop = useMediaQuery({
    query: '(min-width: 768px)'
  });

  if (isInApp()) {
    return 'mobile';
  }

  if (isDesktopOrLaptop) {
    return 'web';
  }

  return 'mobileWeb';
};
var getOSType = function getOSType(query) {
  var _navigator;

  if (isSSR/* isSSR */.y) return 'WEB';
  var osType = query === null || query === void 0 ? void 0 : query.os_type;
  var osTypeParams = osType === null || osType === void 0 ? void 0 : osType.toUpperCase();
  var userAgent = (_navigator = navigator) === null || _navigator === void 0 ? void 0 : _navigator.userAgent;
  var parser = new (ua_parser_default())(userAgent);
  var result = parser.getResult();
  var isApp = osTypeParams && ['ANDROID', 'IOS'].includes(osTypeParams);

  if (isApp) {
    return osTypeParams;
  } else if (result.device.type) {
    return result.os.name === 'iOS' ? 'MWEBIOS' : 'MWEBANDROID';
  } else {
    return 'WEB';
  }
};
var getOSTypeSSR = function getOSTypeSSR(req) {
  var _req$_parsedUrl, _params$get;

  var params = new URLSearchParams(req === null || req === void 0 ? void 0 : (_req$_parsedUrl = req._parsedUrl) === null || _req$_parsedUrl === void 0 ? void 0 : _req$_parsedUrl.query);
  var osTypeParams = (_params$get = params.get('os_type')) === null || _params$get === void 0 ? void 0 : _params$get.toUpperCase();
  var userAgent = req === null || req === void 0 ? void 0 : req.headers['user-agent'];
  var parser = new UAParser(userAgent);
  var result = parser.getResult();
  var isApp = osTypeParams && ['ANDROID', 'IOS'].includes(osTypeParams);

  if (isApp) {
    return osTypeParams;
  } else if (result.device.type) {
    return result.os.name === 'iOS' ? 'MWEBIOS' : 'MWEBANDROID';
  } else {
    return 'WEB';
  }
};
var getDeviceType = function getDeviceType(osType) {
  switch (osType) {
    case 'IOS':
    case 'ANDROID':
      return 'mobile';

    case 'MWEBANDROID':
    case 'MWEBIOS':
      return 'mobileWeb';

    case 'WEB':
      return 'web';
  }
};
var detectDeviceSSR = function detectDeviceSSR(req) {
  var osType = getOSTypeSSR(req);
  return getDeviceType(osType);
};
// EXTERNAL MODULE: ./src/utils/tracking.ts + 5 modules
var tracking = __webpack_require__(24724);
// EXTERNAL MODULE: ./src/hooks/index.ts + 8 modules
var hooks = __webpack_require__(91002);
;// CONCATENATED MODULE: ./src/utils/autoChangeComponent.ts

var useAutoChangeComponent = function useAutoChangeComponent(targetDate) {
  var _useNowTime = (0,hooks/* useNowTime */.bg)(),
      nowDate = _useNowTime.data,
      error = _useNowTime.error;

  if (!nowDate || error) {
    return function (original, _) {
      return original;
    };
  }

  return function (original, change) {
    if (nowDate > targetDate) {
      return change;
    } else {
      return original;
    }
  };
};
// EXTERNAL MODULE: ./src/utils/OSVersion.ts
var OSVersion = __webpack_require__(76823);
// EXTERNAL MODULE: ./src/utils/Navigation/index.ts + 4 modules
var Navigation = __webpack_require__(89369);
;// CONCATENATED MODULE: ./src/utils/text.ts
var intComma = function intComma(x) {
  if (x == null || isNaN(Number(x))) {
    return '';
  }

  return x.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
};
// EXTERNAL MODULE: ./node_modules/.pnpm/next@12.3.4_@babel+core@7.26.0_react-dom@18.3.1_react@18.3.1_sass@1.80.4/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(78838);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);
;// CONCATENATED MODULE: ./src/utils/share.ts




function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

/**
 * Web Share API를 사용하여 시스템 공유창을 띄웁니다.
 * @param {object} data ShareData(lib.dom.d.ts)
 * @param {function} fallback Web Share API가 지원되지 않는 환경인 경우의 fallback
 * @return {Promise} Promise&lt;void&gt;
 */
var share = /*#__PURE__*/(/* unused pure expression or super */ null && (function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref) {
    var _ref$data, data, fallback, _document;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _ref$data = _ref.data, data = _ref$data === void 0 ? {} : _ref$data, fallback = _ref.fallback;

            if (!navigator.share) {
              _context.next = 12;
              break;
            }

            _context.prev = 2;
            _context.next = 5;
            return navigator.share(_objectSpread({
              title: data.title || ((_document = document) === null || _document === void 0 ? void 0 : _document.title)
            }, data));

          case 5:
            _context.next = 10;
            break;

          case 7:
            _context.prev = 7;
            _context.t0 = _context["catch"](2);
            console.error(_context.t0);

          case 10:
            _context.next = 13;
            break;

          case 12:
            fallback === null || fallback === void 0 ? void 0 : fallback();

          case 13:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[2, 7]]);
  }));

  return function share(_x) {
    return _ref2.apply(this, arguments);
  };
}()));
// EXTERNAL MODULE: ./src/campaign/utils/kakao.ts
var kakao = __webpack_require__(9675);
// EXTERNAL MODULE: ./node_modules/.pnpm/next@12.3.4_@babel+core@7.26.0_react-dom@18.3.1_react@18.3.1_sass@1.80.4/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(6325);
// EXTERNAL MODULE: ./src/common/http.ts + 12 modules
var http = __webpack_require__(8585);
;// CONCATENATED MODULE: ./src/utils/handleClickLog.ts



var handleClickLog = /*#__PURE__*/function () {
  var _ref2 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee(_ref) {
    var osType, eventId, promotionId, type;
    return regenerator_default().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            osType = _ref.osType, eventId = _ref.eventId, promotionId = _ref.promotionId, type = _ref.type;
            _context.prev = 1;
            _context.next = 4;
            return http/* clientHttp.put */.J.put('/api/campaign/raffle/clicks', {
              json: {
                promotionId: promotionId,
                eventId: eventId,
                platform: osType,
                type: type
              }
            });

          case 4:
            _context.next = 8;
            break;

          case 6:
            _context.prev = 6;
            _context.t0 = _context["catch"](1);

          case 8:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[1, 6]]);
  }));

  return function handleClickLog(_x) {
    return _ref2.apply(this, arguments);
  };
}();
;// CONCATENATED MODULE: ./src/utils/platform.ts
var formatOsType = function formatOsType(osType) {
  switch (osType) {
    case 'Android':
      return 'aos';

    case 'iOS':
      return 'ios';

    case 'mWebIOS':
    case 'mWebAndroid':
      return 'mweb';

    default:
      return 'web';
  }
};
var checkAppVersion = function checkAppVersion(_ref) {
  var _ref$osType = _ref.osType,
      osType = _ref$osType === void 0 ? 'Web' : _ref$osType,
      currentVersion = _ref.currentVersion,
      androidVersion = _ref.androidVersion,
      iosVersion = _ref.iosVersion;
  var targetSelected;

  if (osType === 'Android') {
    targetSelected = androidVersion;
  } else if (osType === 'iOS') {
    targetSelected = iosVersion;
  } else {
    return true;
  }

  if (currentVersion == null) {
    return true;
  }

  var versionFragments = currentVersion.split('.');
  var targetFragments = targetSelected.split('.');

  for (var i = 0; i < targetFragments.length; i += 1) {
    var _versionFragments$i;

    var targetFragment = parseInt(targetFragments[i], 10);
    var versionFragment = parseInt((_versionFragments$i = versionFragments[i]) !== null && _versionFragments$i !== void 0 ? _versionFragments$i : '0', 10);

    if (targetFragment > versionFragment) {
      return false;
    } else if (targetFragment < versionFragment) {
      return true;
    }
  }

  return true;
};
// EXTERNAL MODULE: ./node_modules/.pnpm/humps@2.0.1/node_modules/humps/humps.js
var humps = __webpack_require__(87493);
;// CONCATENATED MODULE: ./src/utils/braze.ts

function sendBrazeLog(eventName, log) {
  var _braze;

  if (((_braze = window.braze) === null || _braze === void 0 ? void 0 : _braze.logCustomEvent) != null) {
    window.braze = window.braze || {};
    window.braze.logCustomEvent(eventName, (0,humps.decamelizeKeys)(log));
  }
}
var sendBrazeAppLog = function sendBrazeAppLog(name, properties) {
  var _webkit, _webkit$messageHandle, _window;

  if (((_webkit = window.webkit) === null || _webkit === void 0 ? void 0 : (_webkit$messageHandle = _webkit.messageHandlers) === null || _webkit$messageHandle === void 0 ? void 0 : _webkit$messageHandle.ohouseBrazeInterface) != null) {
    window.webkit.messageHandlers.ohouseBrazeInterface.postMessage({
      name: name,
      properties: properties
    });
  } else if (((_window = window) === null || _window === void 0 ? void 0 : _window.ohouseBrazeInterface) != null) {
    window.ohouseBrazeInterface.sendLog(name, JSON.stringify(properties));
  }
};
;// CONCATENATED MODULE: ./src/utils/index.ts


















/***/ }),

/***/ 17234:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "y": function() { return /* binding */ isSSR; }
/* harmony export */ });
var isSSR = false;

/***/ }),

/***/ 24724:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "jQ": function() { return /* binding */ airbridgeLogout; },
  "hX": function() { return /* binding */ filter; },
  "bW": function() { return /* binding */ getDeepLink; },
  "pm": function() { return /* binding */ getQuery; },
  "Wz": function() { return /* binding */ getQueryString; },
  "gu": function() { return /* binding */ sendA1MediaInflow; },
  "A2": function() { return /* binding */ setUtmData; }
});

// UNUSED EXPORTS: getUtmData, getUtmDataFromUrl, memoize, omitKeys, sendAirbridgeLog

// EXTERNAL MODULE: ./node_modules/.pnpm/next@12.3.4_@babel+core@7.26.0_react-dom@18.3.1_react@18.3.1_sass@1.80.4/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(88756);
// EXTERNAL MODULE: ./node_modules/.pnpm/next@12.3.4_@babel+core@7.26.0_react-dom@18.3.1_react@18.3.1_sass@1.80.4/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js + 3 modules
var slicedToArray = __webpack_require__(46003);
// EXTERNAL MODULE: ./node_modules/.pnpm/querystring@0.2.1/node_modules/querystring/index.js
var querystring = __webpack_require__(97150);
// EXTERNAL MODULE: ./node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_baseGet.js
var _baseGet = __webpack_require__(49084);
// EXTERNAL MODULE: ./node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_assignValue.js
var _assignValue = __webpack_require__(61572);
// EXTERNAL MODULE: ./node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_castPath.js + 5 modules
var _castPath = __webpack_require__(99458);
// EXTERNAL MODULE: ./node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_isIndex.js
var _isIndex = __webpack_require__(99313);
// EXTERNAL MODULE: ./node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/isObject.js
var isObject = __webpack_require__(82433);
// EXTERNAL MODULE: ./node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_toKey.js
var _toKey = __webpack_require__(13383);
;// CONCATENATED MODULE: ./node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_baseSet.js






/**
 * The base implementation of `_.set`.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to set.
 * @param {*} value The value to set.
 * @param {Function} [customizer] The function to customize path creation.
 * @returns {Object} Returns `object`.
 */
function baseSet(object, path, value, customizer) {
  if (!(0,isObject/* default */.Z)(object)) {
    return object;
  }
  path = (0,_castPath/* default */.Z)(path, object);

  var index = -1,
      length = path.length,
      lastIndex = length - 1,
      nested = object;

  while (nested != null && ++index < length) {
    var key = (0,_toKey/* default */.Z)(path[index]),
        newValue = value;

    if (key === '__proto__' || key === 'constructor' || key === 'prototype') {
      return object;
    }

    if (index != lastIndex) {
      var objValue = nested[key];
      newValue = customizer ? customizer(objValue, key, nested) : undefined;
      if (newValue === undefined) {
        newValue = (0,isObject/* default */.Z)(objValue)
          ? objValue
          : ((0,_isIndex/* default */.Z)(path[index + 1]) ? [] : {});
      }
    }
    (0,_assignValue/* default */.Z)(nested, key, newValue);
    nested = nested[key];
  }
  return object;
}

/* harmony default export */ var _baseSet = (baseSet);

;// CONCATENATED MODULE: ./node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_basePickBy.js




/**
 * The base implementation of  `_.pickBy` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The source object.
 * @param {string[]} paths The property paths to pick.
 * @param {Function} predicate The function invoked per property.
 * @returns {Object} Returns the new object.
 */
function basePickBy(object, paths, predicate) {
  var index = -1,
      length = paths.length,
      result = {};

  while (++index < length) {
    var path = paths[index],
        value = (0,_baseGet/* default */.Z)(object, path);

    if (predicate(value, path)) {
      _baseSet(result, (0,_castPath/* default */.Z)(path, object), value);
    }
  }
  return result;
}

/* harmony default export */ var _basePickBy = (basePickBy);

// EXTERNAL MODULE: ./node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/hasIn.js + 2 modules
var hasIn = __webpack_require__(90177);
;// CONCATENATED MODULE: ./node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_basePick.js



/**
 * The base implementation of `_.pick` without support for individual
 * property identifiers.
 *
 * @private
 * @param {Object} object The source object.
 * @param {string[]} paths The property paths to pick.
 * @returns {Object} Returns the new object.
 */
function basePick(object, paths) {
  return _basePickBy(object, paths, function(value, path) {
    return (0,hasIn/* default */.Z)(object, path);
  });
}

/* harmony default export */ var _basePick = (basePick);

// EXTERNAL MODULE: ./node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_flatRest.js
var _flatRest = __webpack_require__(24982);
;// CONCATENATED MODULE: ./node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/pick.js



/**
 * Creates an object composed of the picked `object` properties.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The source object.
 * @param {...(string|string[])} [paths] The property paths to pick.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.pick(object, ['a', 'c']);
 * // => { 'a': 1, 'c': 3 }
 */
var pick = (0,_flatRest/* default */.Z)(function(object, paths) {
  return object == null ? {} : _basePick(object, paths);
});

/* harmony default export */ var lodash_es_pick = (pick);

// EXTERNAL MODULE: ./node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_baseKeys.js + 1 modules
var _baseKeys = __webpack_require__(88343);
// EXTERNAL MODULE: ./node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_getTag.js + 4 modules
var _getTag = __webpack_require__(25922);
// EXTERNAL MODULE: ./node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/isArguments.js + 1 modules
var isArguments = __webpack_require__(65380);
// EXTERNAL MODULE: ./node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/isArray.js
var isArray = __webpack_require__(56052);
// EXTERNAL MODULE: ./node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/isArrayLike.js
var isArrayLike = __webpack_require__(49634);
// EXTERNAL MODULE: ./node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/isBuffer.js + 1 modules
var isBuffer = __webpack_require__(45673);
// EXTERNAL MODULE: ./node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_isPrototype.js
var _isPrototype = __webpack_require__(5196);
// EXTERNAL MODULE: ./node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/isTypedArray.js + 1 modules
var isTypedArray = __webpack_require__(79064);
;// CONCATENATED MODULE: ./node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/isEmpty.js









/** `Object#toString` result references. */
var mapTag = '[object Map]',
    setTag = '[object Set]';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var isEmpty_hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Checks if `value` is an empty object, collection, map, or set.
 *
 * Objects are considered empty if they have no own enumerable string keyed
 * properties.
 *
 * Array-like values such as `arguments` objects, arrays, buffers, strings, or
 * jQuery-like collections are considered empty if they have a `length` of `0`.
 * Similarly, maps and sets are considered empty if they have a `size` of `0`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is empty, else `false`.
 * @example
 *
 * _.isEmpty(null);
 * // => true
 *
 * _.isEmpty(true);
 * // => true
 *
 * _.isEmpty(1);
 * // => true
 *
 * _.isEmpty([1, 2, 3]);
 * // => false
 *
 * _.isEmpty({ 'a': 1 });
 * // => false
 */
function isEmpty(value) {
  if (value == null) {
    return true;
  }
  if ((0,isArrayLike/* default */.Z)(value) &&
      ((0,isArray/* default */.Z)(value) || typeof value == 'string' || typeof value.splice == 'function' ||
        (0,isBuffer/* default */.Z)(value) || (0,isTypedArray/* default */.Z)(value) || (0,isArguments/* default */.Z)(value))) {
    return !value.length;
  }
  var tag = (0,_getTag/* default */.Z)(value);
  if (tag == mapTag || tag == setTag) {
    return !value.size;
  }
  if ((0,_isPrototype/* default */.Z)(value)) {
    return !(0,_baseKeys/* default */.Z)(value).length;
  }
  for (var key in value) {
    if (isEmpty_hasOwnProperty.call(value, key)) {
      return false;
    }
  }
  return true;
}

/* harmony default export */ var lodash_es_isEmpty = (isEmpty);

// EXTERNAL MODULE: ./node_modules/.pnpm/@bucketplace+bucket-log@1.2.3_@emotion+react@11.13.3_react-dom@18.3.1_react@18.3.1/node_modules/@bucketplace/bucket-log/dist/index.esm.js
var index_esm = __webpack_require__(46166);
;// CONCATENATED MODULE: ./src/utils/tracking.ts



function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }




var QUERY_BLACKLIST = ['airbridge_referrer', 'fallback_ios', 'fallback_android', 'short_id', 'https_deeplink', 'campaign', 'ad_group', 'ad_creative', 'term', 'deeplink_url', 'fallback_desktop', 'n_media', 'n_query', 'n_rank', 'n_ad_group', 'n_ad', 'n_keyword_id', 'n_keyword', 'n_campaign_type', 'n_ad_group_type', 'NaPm', 'routing_short_id', 'content', 'sub_id_1', 'sub_id_2', 'sub_id_3', 'campaign_id', 'ad_group_id', 'ad_creative_id', 'term_id'];
var UTM_TAG_LIST = ['source', 'utm_source', 'utm_campaign', 'utm_content', 'utm_media', 'utm_term', 'utm_medium', 'bp_adset', 'bp_content', 'bp_sub_id', 'bp_sub_id_1', 'bp_sub_id_2'];
function memoize(func) {
  var prevArgs = null;
  var prevResult = null;
  return function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    if (prevArgs == null || prevArgs.length !== args.length || prevArgs.some(function (v, i) {
      return v !== args[i];
    })) {
      prevArgs = args;
      prevResult = func.apply(void 0, args);
    }

    return prevResult;
  };
} // eslint-disable-next-line @typescript-eslint/ban-types

function omitKeys(obj, keys) {
  var output = {};
  Object.keys(obj).filter(function (k) {
    return !keys.includes(k);
  }).forEach(function (k) {
    return output[k] = obj[k];
  });
  return output;
}
function filter(obj, cb) {
  var output = {};

  for (var _k in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, _k) && cb(obj[_k], _k)) {
      output[_k] = obj[_k];
    }
  }

  return output;
}
var getQueryString = function getQueryString(query) {
  return querystring.stringify(query);
};
var getQuery = memoize(function (url) {
  var search = (/\?(.+)$/.exec(url) || ['', ''])[1];
  return querystring.parse(search.replace(/&amp;/g, '&'));
});
/**
 * 쿼리 문자열에서 utm 파라미터 객체를 추출합니다.
 * @param {string} queryString utmData를 추출하고픈 target 쿼리 문자열
 * @return {object} 추출된 utm 파라미터 객체
 */

var getUtmDataFromUrl = function getUtmDataFromUrl(queryString) {
  var query = getQuery(queryString !== null && queryString !== void 0 ? queryString : location.search);
  var utmQuery = lodash_es_pick(query, UTM_TAG_LIST);
  return escapeBracesInQuery(utmQuery);
};
var getUtmData = function getUtmData() {
  try {
    return JSON.parse(sessionStorage['ohsUtmData'] || '{}');
  } catch (e) {
    //
    return {};
  }
};
/**
 * 현재 url의 utmData를 추출하여 sessionStorage에 저장합니다.
 */

var setUtmData = function setUtmData() {
  var urlData = getUtmDataFromUrl();
  if (lodash_es_isEmpty(urlData)) return;

  try {
    sessionStorage.setItem('ohsUtmData', JSON.stringify(urlData));
  } catch (e) {//
  }
}; // eslint-disable-next-line @typescript-eslint/ban-types

function escapeBracesInQuery(query) {
  var trimmed = Object.fromEntries(Object.entries(query).map(function (_ref) {
    var _ref2 = (0,slicedToArray/* default */.Z)(_ref, 2),
        key = _ref2[0],
        value = _ref2[1];

    return [key, value === null || value === void 0 ? void 0 : value.replace(/([\\_]?{[^}]+})+/g, '')];
  }));
  return filter(trimmed, function (v) {
    return v != null && v !== '';
  });
}

var getDeepLink = function getDeepLink(additionalParams, pathname, query) {
  var queryObj = getQuery(query !== null && query !== void 0 ? query : location.search);
  var essentialQuery = filter(_objectSpread({}, omitKeys(queryObj, [].concat(UTM_TAG_LIST, QUERY_BLACKLIST))), function (v) {
    return v != null;
  });
  var escapedQuery = escapeBracesInQuery(essentialQuery);
  var searchString = querystring.stringify(_objectSpread(_objectSpread({}, escapedQuery), {}, {
    click_action_type: 'webview'
  }));
  var path = "/events".concat(pathname !== null && pathname !== void 0 ? pathname : location.pathname, "?").concat(searchString);
  var utmData = getUtmData(); // const isProd = process.env.APP_PROFILE === 'prod';
  // const host = isProd ? 'ohou.se': 'stage-web.dailyhou.se';

  return "https://link.ohou.se/@ohouse/".concat(utmData['utm_source'] || 'web_organic', "?") + querystring.stringify(_objectSpread({
    deeplink_url: "ohouseapp://ohou.se".concat(path),
    fallback_desktop: "https://ohou.se".concat(path),
    campaign: queryObj.campaign || utmData['utm_campaign'],
    term: queryObj.term || utmData['utm_term'],
    client_id: (0,index_esm/* getPageVariable */.Le)('visitor_id'),
    sub_id: queryObj.sub_id || utmData['bp_sub_id'],
    sub_id_1: 'ohouseWeb',
    sub_id_2: queryObj.sub_id_2 || utmData['bp_sub_id_2'],
    sub_id_3: queryObj.sub_id_3 || utmData['utm_medium'],
    ad_creative: queryObj.ad_creative || utmData['utm_content'],
    ad_group: queryObj.ad_group || utmData['bp_adset'],
    content: queryObj.content || utmData['bp_content']
  }, additionalParams !== null && additionalParams !== void 0 ? additionalParams : {}));
};
var airbridgeLogout = function airbridgeLogout() {
  var _window, _window$airbridge;

  sendAirbridgeLog({
    category: 'airbridge.user.signout'
  });
  (_window = window) === null || _window === void 0 ? void 0 : (_window$airbridge = _window.airbridge) === null || _window$airbridge === void 0 ? void 0 : _window$airbridge.clearUser();
};
var sendAirbridgeLog = function sendAirbridgeLog(_ref3) {
  var _window2, _window2$airbridge, _window2$airbridge$ev;

  var category = _ref3.category,
      attribute = _ref3.attribute;
  (_window2 = window) === null || _window2 === void 0 ? void 0 : (_window2$airbridge = _window2.airbridge) === null || _window2$airbridge === void 0 ? void 0 : (_window2$airbridge$ev = _window2$airbridge.events) === null || _window2$airbridge$ev === void 0 ? void 0 : _window2$airbridge$ev.send(category, attribute);
};
var KEYWORD_INFLOW_PATH_LIST = ['google', 'brand_google', 'naver', 'brand_naver', 'daum', 'brand_daum'];
var SHOPPING_INFLOW_PATH_LIST = ['naver_shop', 'google_shop', 'enuri_shop', 'googleadwords_int'];
var sendA1MediaInflow = function sendA1MediaInflow() {
  var utmData = getUtmData();

  if (KEYWORD_INFLOW_PATH_LIST.includes(utmData === null || utmData === void 0 ? void 0 : utmData.utm_source)) {
    var _window3, _window3$linkback, _window3$linkback$sen;

    (_window3 = window) === null || _window3 === void 0 ? void 0 : (_window3$linkback = _window3.linkback) === null || _window3$linkback === void 0 ? void 0 : (_window3$linkback$sen = _window3$linkback.send) === null || _window3$linkback$sen === void 0 ? void 0 : _window3$linkback$sen.call(_window3$linkback, 'inflow');
  } else if (SHOPPING_INFLOW_PATH_LIST.includes(utmData === null || utmData === void 0 ? void 0 : utmData.utm_source)) {
    var _window4, _window4$linkback, _window4$linkback$tra;

    (_window4 = window) === null || _window4 === void 0 ? void 0 : (_window4$linkback = _window4.linkback) === null || _window4$linkback === void 0 ? void 0 : (_window4$linkback$tra = _window4$linkback.track) === null || _window4$linkback$tra === void 0 ? void 0 : _window4$linkback$tra.call(_window4$linkback, 'inflow');
  }
};

/***/ }),

/***/ 49681:
/***/ (function(module) {

"use strict";

module.exports = function() {
    return Object.assign;
};

//# sourceMappingURL=polyfill.js.map

/***/ }),

/***/ 3986:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/_app",
      function () {
        return __webpack_require__(47618);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 51778:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var __dirname = "/";
/* provided dependency */ var Buffer = __webpack_require__(55872)["Buffer"];
/* provided dependency */ var process = __webpack_require__(14224);
(function(){"use strict";var e={742:function(e,t,i){var a=i(491);var r=i(562);var n=i(450);var s=i(324);var l=i(320);for(var f in l){t[f]=l[f]}t.NONE=0;t.DEFLATE=1;t.INFLATE=2;t.GZIP=3;t.GUNZIP=4;t.DEFLATERAW=5;t.INFLATERAW=6;t.UNZIP=7;var o=31;var h=139;function Zlib(e){if(typeof e!=="number"||e<t.DEFLATE||e>t.UNZIP){throw new TypeError("Bad argument")}this.dictionary=null;this.err=0;this.flush=0;this.init_done=false;this.level=0;this.memLevel=0;this.mode=e;this.strategy=0;this.windowBits=0;this.write_in_progress=false;this.pending_close=false;this.gzip_id_bytes_read=0}Zlib.prototype.close=function(){if(this.write_in_progress){this.pending_close=true;return}this.pending_close=false;a(this.init_done,"close before init");a(this.mode<=t.UNZIP);if(this.mode===t.DEFLATE||this.mode===t.GZIP||this.mode===t.DEFLATERAW){n.deflateEnd(this.strm)}else if(this.mode===t.INFLATE||this.mode===t.GUNZIP||this.mode===t.INFLATERAW||this.mode===t.UNZIP){s.inflateEnd(this.strm)}this.mode=t.NONE;this.dictionary=null};Zlib.prototype.write=function(e,t,i,a,r,n,s){return this._write(true,e,t,i,a,r,n,s)};Zlib.prototype.writeSync=function(e,t,i,a,r,n,s){return this._write(false,e,t,i,a,r,n,s)};Zlib.prototype._write=function(e,i,r,n,s,l,f,o){a.equal(arguments.length,8);a(this.init_done,"write before init");a(this.mode!==t.NONE,"already finalized");a.equal(false,this.write_in_progress,"write already in progress");a.equal(false,this.pending_close,"close is pending");this.write_in_progress=true;a.equal(false,i===undefined,"must provide flush value");this.write_in_progress=true;if(i!==t.Z_NO_FLUSH&&i!==t.Z_PARTIAL_FLUSH&&i!==t.Z_SYNC_FLUSH&&i!==t.Z_FULL_FLUSH&&i!==t.Z_FINISH&&i!==t.Z_BLOCK){throw new Error("Invalid flush value")}if(r==null){r=Buffer.alloc(0);s=0;n=0}this.strm.avail_in=s;this.strm.input=r;this.strm.next_in=n;this.strm.avail_out=o;this.strm.output=l;this.strm.next_out=f;this.flush=i;if(!e){this._process();if(this._checkError()){return this._afterSync()}return}var h=this;process.nextTick((function(){h._process();h._after()}));return this};Zlib.prototype._afterSync=function(){var e=this.strm.avail_out;var t=this.strm.avail_in;this.write_in_progress=false;return[t,e]};Zlib.prototype._process=function(){var e=null;switch(this.mode){case t.DEFLATE:case t.GZIP:case t.DEFLATERAW:this.err=n.deflate(this.strm,this.flush);break;case t.UNZIP:if(this.strm.avail_in>0){e=this.strm.next_in}switch(this.gzip_id_bytes_read){case 0:if(e===null){break}if(this.strm.input[e]===o){this.gzip_id_bytes_read=1;e++;if(this.strm.avail_in===1){break}}else{this.mode=t.INFLATE;break}case 1:if(e===null){break}if(this.strm.input[e]===h){this.gzip_id_bytes_read=2;this.mode=t.GUNZIP}else{this.mode=t.INFLATE}break;default:throw new Error("invalid number of gzip magic number bytes read")}case t.INFLATE:case t.GUNZIP:case t.INFLATERAW:this.err=s.inflate(this.strm,this.flush);if(this.err===t.Z_NEED_DICT&&this.dictionary){this.err=s.inflateSetDictionary(this.strm,this.dictionary);if(this.err===t.Z_OK){this.err=s.inflate(this.strm,this.flush)}else if(this.err===t.Z_DATA_ERROR){this.err=t.Z_NEED_DICT}}while(this.strm.avail_in>0&&this.mode===t.GUNZIP&&this.err===t.Z_STREAM_END&&this.strm.next_in[0]!==0){this.reset();this.err=s.inflate(this.strm,this.flush)}break;default:throw new Error("Unknown mode "+this.mode)}};Zlib.prototype._checkError=function(){switch(this.err){case t.Z_OK:case t.Z_BUF_ERROR:if(this.strm.avail_out!==0&&this.flush===t.Z_FINISH){this._error("unexpected end of file");return false}break;case t.Z_STREAM_END:break;case t.Z_NEED_DICT:if(this.dictionary==null){this._error("Missing dictionary")}else{this._error("Bad dictionary")}return false;default:this._error("Zlib error");return false}return true};Zlib.prototype._after=function(){if(!this._checkError()){return}var e=this.strm.avail_out;var t=this.strm.avail_in;this.write_in_progress=false;this.callback(t,e);if(this.pending_close){this.close()}};Zlib.prototype._error=function(e){if(this.strm.msg){e=this.strm.msg}this.onerror(e,this.err);this.write_in_progress=false;if(this.pending_close){this.close()}};Zlib.prototype.init=function(e,i,r,n,s){a(arguments.length===4||arguments.length===5,"init(windowBits, level, memLevel, strategy, [dictionary])");a(e>=8&&e<=15,"invalid windowBits");a(i>=-1&&i<=9,"invalid compression level");a(r>=1&&r<=9,"invalid memlevel");a(n===t.Z_FILTERED||n===t.Z_HUFFMAN_ONLY||n===t.Z_RLE||n===t.Z_FIXED||n===t.Z_DEFAULT_STRATEGY,"invalid strategy");this._init(i,e,r,n,s);this._setDictionary()};Zlib.prototype.params=function(){throw new Error("deflateParams Not supported")};Zlib.prototype.reset=function(){this._reset();this._setDictionary()};Zlib.prototype._init=function(e,i,a,l,f){this.level=e;this.windowBits=i;this.memLevel=a;this.strategy=l;this.flush=t.Z_NO_FLUSH;this.err=t.Z_OK;if(this.mode===t.GZIP||this.mode===t.GUNZIP){this.windowBits+=16}if(this.mode===t.UNZIP){this.windowBits+=32}if(this.mode===t.DEFLATERAW||this.mode===t.INFLATERAW){this.windowBits=-1*this.windowBits}this.strm=new r;switch(this.mode){case t.DEFLATE:case t.GZIP:case t.DEFLATERAW:this.err=n.deflateInit2(this.strm,this.level,t.Z_DEFLATED,this.windowBits,this.memLevel,this.strategy);break;case t.INFLATE:case t.GUNZIP:case t.INFLATERAW:case t.UNZIP:this.err=s.inflateInit2(this.strm,this.windowBits);break;default:throw new Error("Unknown mode "+this.mode)}if(this.err!==t.Z_OK){this._error("Init error")}this.dictionary=f;this.write_in_progress=false;this.init_done=true};Zlib.prototype._setDictionary=function(){if(this.dictionary==null){return}this.err=t.Z_OK;switch(this.mode){case t.DEFLATE:case t.DEFLATERAW:this.err=n.deflateSetDictionary(this.strm,this.dictionary);break;default:break}if(this.err!==t.Z_OK){this._error("Failed to set dictionary")}};Zlib.prototype._reset=function(){this.err=t.Z_OK;switch(this.mode){case t.DEFLATE:case t.DEFLATERAW:case t.GZIP:this.err=n.deflateReset(this.strm);break;case t.INFLATE:case t.INFLATERAW:case t.GUNZIP:this.err=s.inflateReset(this.strm);break;default:break}if(this.err!==t.Z_OK){this._error("Failed to reset stream")}};t.Zlib=Zlib},23:function(e,t,i){var a=i(300).Buffer;var r=i(781).Transform;var n=i(742);var s=i(837);var l=i(491).ok;var f=i(300).kMaxLength;var o="Cannot create final Buffer. It would be larger "+"than 0x"+f.toString(16)+" bytes";n.Z_MIN_WINDOWBITS=8;n.Z_MAX_WINDOWBITS=15;n.Z_DEFAULT_WINDOWBITS=15;n.Z_MIN_CHUNK=64;n.Z_MAX_CHUNK=Infinity;n.Z_DEFAULT_CHUNK=16*1024;n.Z_MIN_MEMLEVEL=1;n.Z_MAX_MEMLEVEL=9;n.Z_DEFAULT_MEMLEVEL=8;n.Z_MIN_LEVEL=-1;n.Z_MAX_LEVEL=9;n.Z_DEFAULT_LEVEL=n.Z_DEFAULT_COMPRESSION;var h=Object.keys(n);for(var _=0;_<h.length;_++){var d=h[_];if(d.match(/^Z/)){Object.defineProperty(t,d,{enumerable:true,value:n[d],writable:false})}}var u={Z_OK:n.Z_OK,Z_STREAM_END:n.Z_STREAM_END,Z_NEED_DICT:n.Z_NEED_DICT,Z_ERRNO:n.Z_ERRNO,Z_STREAM_ERROR:n.Z_STREAM_ERROR,Z_DATA_ERROR:n.Z_DATA_ERROR,Z_MEM_ERROR:n.Z_MEM_ERROR,Z_BUF_ERROR:n.Z_BUF_ERROR,Z_VERSION_ERROR:n.Z_VERSION_ERROR};var c=Object.keys(u);for(var v=0;v<c.length;v++){var b=c[v];u[u[b]]=b}Object.defineProperty(t,"codes",{enumerable:true,value:Object.freeze(u),writable:false});t.Deflate=Deflate;t.Inflate=Inflate;t.Gzip=Gzip;t.Gunzip=Gunzip;t.DeflateRaw=DeflateRaw;t.InflateRaw=InflateRaw;t.Unzip=Unzip;t.createDeflate=function(e){return new Deflate(e)};t.createInflate=function(e){return new Inflate(e)};t.createDeflateRaw=function(e){return new DeflateRaw(e)};t.createInflateRaw=function(e){return new InflateRaw(e)};t.createGzip=function(e){return new Gzip(e)};t.createGunzip=function(e){return new Gunzip(e)};t.createUnzip=function(e){return new Unzip(e)};t.deflate=function(e,t,i){if(typeof t==="function"){i=t;t={}}return zlibBuffer(new Deflate(t),e,i)};t.deflateSync=function(e,t){return zlibBufferSync(new Deflate(t),e)};t.gzip=function(e,t,i){if(typeof t==="function"){i=t;t={}}return zlibBuffer(new Gzip(t),e,i)};t.gzipSync=function(e,t){return zlibBufferSync(new Gzip(t),e)};t.deflateRaw=function(e,t,i){if(typeof t==="function"){i=t;t={}}return zlibBuffer(new DeflateRaw(t),e,i)};t.deflateRawSync=function(e,t){return zlibBufferSync(new DeflateRaw(t),e)};t.unzip=function(e,t,i){if(typeof t==="function"){i=t;t={}}return zlibBuffer(new Unzip(t),e,i)};t.unzipSync=function(e,t){return zlibBufferSync(new Unzip(t),e)};t.inflate=function(e,t,i){if(typeof t==="function"){i=t;t={}}return zlibBuffer(new Inflate(t),e,i)};t.inflateSync=function(e,t){return zlibBufferSync(new Inflate(t),e)};t.gunzip=function(e,t,i){if(typeof t==="function"){i=t;t={}}return zlibBuffer(new Gunzip(t),e,i)};t.gunzipSync=function(e,t){return zlibBufferSync(new Gunzip(t),e)};t.inflateRaw=function(e,t,i){if(typeof t==="function"){i=t;t={}}return zlibBuffer(new InflateRaw(t),e,i)};t.inflateRawSync=function(e,t){return zlibBufferSync(new InflateRaw(t),e)};function zlibBuffer(e,t,i){var r=[];var n=0;e.on("error",onError);e.on("end",onEnd);e.end(t);flow();function flow(){var t;while(null!==(t=e.read())){r.push(t);n+=t.length}e.once("readable",flow)}function onError(t){e.removeListener("end",onEnd);e.removeListener("readable",flow);i(t)}function onEnd(){var t;var s=null;if(n>=f){s=new RangeError(o)}else{t=a.concat(r,n)}r=[];e.close();i(s,t)}}function zlibBufferSync(e,t){if(typeof t==="string")t=a.from(t);if(!a.isBuffer(t))throw new TypeError("Not a string or buffer");var i=e._finishFlushFlag;return e._processChunk(t,i)}function Deflate(e){if(!(this instanceof Deflate))return new Deflate(e);Zlib.call(this,e,n.DEFLATE)}function Inflate(e){if(!(this instanceof Inflate))return new Inflate(e);Zlib.call(this,e,n.INFLATE)}function Gzip(e){if(!(this instanceof Gzip))return new Gzip(e);Zlib.call(this,e,n.GZIP)}function Gunzip(e){if(!(this instanceof Gunzip))return new Gunzip(e);Zlib.call(this,e,n.GUNZIP)}function DeflateRaw(e){if(!(this instanceof DeflateRaw))return new DeflateRaw(e);Zlib.call(this,e,n.DEFLATERAW)}function InflateRaw(e){if(!(this instanceof InflateRaw))return new InflateRaw(e);Zlib.call(this,e,n.INFLATERAW)}function Unzip(e){if(!(this instanceof Unzip))return new Unzip(e);Zlib.call(this,e,n.UNZIP)}function isValidFlushFlag(e){return e===n.Z_NO_FLUSH||e===n.Z_PARTIAL_FLUSH||e===n.Z_SYNC_FLUSH||e===n.Z_FULL_FLUSH||e===n.Z_FINISH||e===n.Z_BLOCK}function Zlib(e,i){var s=this;this._opts=e=e||{};this._chunkSize=e.chunkSize||t.Z_DEFAULT_CHUNK;r.call(this,e);if(e.flush&&!isValidFlushFlag(e.flush)){throw new Error("Invalid flush flag: "+e.flush)}if(e.finishFlush&&!isValidFlushFlag(e.finishFlush)){throw new Error("Invalid flush flag: "+e.finishFlush)}this._flushFlag=e.flush||n.Z_NO_FLUSH;this._finishFlushFlag=typeof e.finishFlush!=="undefined"?e.finishFlush:n.Z_FINISH;if(e.chunkSize){if(e.chunkSize<t.Z_MIN_CHUNK||e.chunkSize>t.Z_MAX_CHUNK){throw new Error("Invalid chunk size: "+e.chunkSize)}}if(e.windowBits){if(e.windowBits<t.Z_MIN_WINDOWBITS||e.windowBits>t.Z_MAX_WINDOWBITS){throw new Error("Invalid windowBits: "+e.windowBits)}}if(e.level){if(e.level<t.Z_MIN_LEVEL||e.level>t.Z_MAX_LEVEL){throw new Error("Invalid compression level: "+e.level)}}if(e.memLevel){if(e.memLevel<t.Z_MIN_MEMLEVEL||e.memLevel>t.Z_MAX_MEMLEVEL){throw new Error("Invalid memLevel: "+e.memLevel)}}if(e.strategy){if(e.strategy!=t.Z_FILTERED&&e.strategy!=t.Z_HUFFMAN_ONLY&&e.strategy!=t.Z_RLE&&e.strategy!=t.Z_FIXED&&e.strategy!=t.Z_DEFAULT_STRATEGY){throw new Error("Invalid strategy: "+e.strategy)}}if(e.dictionary){if(!a.isBuffer(e.dictionary)){throw new Error("Invalid dictionary: it should be a Buffer instance")}}this._handle=new n.Zlib(i);var l=this;this._hadError=false;this._handle.onerror=function(e,i){_close(l);l._hadError=true;var a=new Error(e);a.errno=i;a.code=t.codes[i];l.emit("error",a)};var f=t.Z_DEFAULT_COMPRESSION;if(typeof e.level==="number")f=e.level;var o=t.Z_DEFAULT_STRATEGY;if(typeof e.strategy==="number")o=e.strategy;this._handle.init(e.windowBits||t.Z_DEFAULT_WINDOWBITS,f,e.memLevel||t.Z_DEFAULT_MEMLEVEL,o,e.dictionary);this._buffer=a.allocUnsafe(this._chunkSize);this._offset=0;this._level=f;this._strategy=o;this.once("end",this.close);Object.defineProperty(this,"_closed",{get:function(){return!s._handle},configurable:true,enumerable:true})}s.inherits(Zlib,r);Zlib.prototype.params=function(e,i,a){if(e<t.Z_MIN_LEVEL||e>t.Z_MAX_LEVEL){throw new RangeError("Invalid compression level: "+e)}if(i!=t.Z_FILTERED&&i!=t.Z_HUFFMAN_ONLY&&i!=t.Z_RLE&&i!=t.Z_FIXED&&i!=t.Z_DEFAULT_STRATEGY){throw new TypeError("Invalid strategy: "+i)}if(this._level!==e||this._strategy!==i){var r=this;this.flush(n.Z_SYNC_FLUSH,(function(){l(r._handle,"zlib binding closed");r._handle.params(e,i);if(!r._hadError){r._level=e;r._strategy=i;if(a)a()}}))}else{process.nextTick(a)}};Zlib.prototype.reset=function(){l(this._handle,"zlib binding closed");return this._handle.reset()};Zlib.prototype._flush=function(e){this._transform(a.alloc(0),"",e)};Zlib.prototype.flush=function(e,t){var i=this;var r=this._writableState;if(typeof e==="function"||e===undefined&&!t){t=e;e=n.Z_FULL_FLUSH}if(r.ended){if(t)process.nextTick(t)}else if(r.ending){if(t)this.once("end",t)}else if(r.needDrain){if(t){this.once("drain",(function(){return i.flush(e,t)}))}}else{this._flushFlag=e;this.write(a.alloc(0),"",t)}};Zlib.prototype.close=function(e){_close(this,e);process.nextTick(emitCloseNT,this)};function _close(e,t){if(t)process.nextTick(t);if(!e._handle)return;e._handle.close();e._handle=null}function emitCloseNT(e){e.emit("close")}Zlib.prototype._transform=function(e,t,i){var r;var s=this._writableState;var l=s.ending||s.ended;var f=l&&(!e||s.length===e.length);if(e!==null&&!a.isBuffer(e))return i(new Error("invalid input"));if(!this._handle)return i(new Error("zlib binding closed"));if(f)r=this._finishFlushFlag;else{r=this._flushFlag;if(e.length>=s.length){this._flushFlag=this._opts.flush||n.Z_NO_FLUSH}}this._processChunk(e,r,i)};Zlib.prototype._processChunk=function(e,t,i){var r=e&&e.length;var n=this._chunkSize-this._offset;var s=0;var h=this;var _=typeof i==="function";if(!_){var d=[];var u=0;var c;this.on("error",(function(e){c=e}));l(this._handle,"zlib binding closed");do{var v=this._handle.writeSync(t,e,s,r,this._buffer,this._offset,n)}while(!this._hadError&&callback(v[0],v[1]));if(this._hadError){throw c}if(u>=f){_close(this);throw new RangeError(o)}var b=a.concat(d,u);_close(this);return b}l(this._handle,"zlib binding closed");var w=this._handle.write(t,e,s,r,this._buffer,this._offset,n);w.buffer=e;w.callback=callback;function callback(f,o){if(this){this.buffer=null;this.callback=null}if(h._hadError)return;var c=n-o;l(c>=0,"have should not go down");if(c>0){var v=h._buffer.slice(h._offset,h._offset+c);h._offset+=c;if(_){h.push(v)}else{d.push(v);u+=v.length}}if(o===0||h._offset>=h._chunkSize){n=h._chunkSize;h._offset=0;h._buffer=a.allocUnsafe(h._chunkSize)}if(o===0){s+=r-f;r=f;if(!_)return true;var b=h._handle.write(t,e,s,r,h._buffer,h._offset,h._chunkSize);b.callback=callback;b.buffer=e;return}if(!_)return false;i()}};s.inherits(Deflate,Zlib);s.inherits(Inflate,Zlib);s.inherits(Gzip,Zlib);s.inherits(Gunzip,Zlib);s.inherits(DeflateRaw,Zlib);s.inherits(InflateRaw,Zlib);s.inherits(Unzip,Zlib)},380:function(e,t){var i=typeof Uint8Array!=="undefined"&&typeof Uint16Array!=="undefined"&&typeof Int32Array!=="undefined";function _has(e,t){return Object.prototype.hasOwnProperty.call(e,t)}t.assign=function(e){var t=Array.prototype.slice.call(arguments,1);while(t.length){var i=t.shift();if(!i){continue}if(typeof i!=="object"){throw new TypeError(i+"must be non-object")}for(var a in i){if(_has(i,a)){e[a]=i[a]}}}return e};t.shrinkBuf=function(e,t){if(e.length===t){return e}if(e.subarray){return e.subarray(0,t)}e.length=t;return e};var a={arraySet:function(e,t,i,a,r){if(t.subarray&&e.subarray){e.set(t.subarray(i,i+a),r);return}for(var n=0;n<a;n++){e[r+n]=t[i+n]}},flattenChunks:function(e){var t,i,a,r,n,s;a=0;for(t=0,i=e.length;t<i;t++){a+=e[t].length}s=new Uint8Array(a);r=0;for(t=0,i=e.length;t<i;t++){n=e[t];s.set(n,r);r+=n.length}return s}};var r={arraySet:function(e,t,i,a,r){for(var n=0;n<a;n++){e[r+n]=t[i+n]}},flattenChunks:function(e){return[].concat.apply([],e)}};t.setTyped=function(e){if(e){t.Buf8=Uint8Array;t.Buf16=Uint16Array;t.Buf32=Int32Array;t.assign(t,a)}else{t.Buf8=Array;t.Buf16=Array;t.Buf32=Array;t.assign(t,r)}};t.setTyped(i)},496:function(e){function adler32(e,t,i,a){var r=e&65535|0,n=e>>>16&65535|0,s=0;while(i!==0){s=i>2e3?2e3:i;i-=s;do{r=r+t[a++]|0;n=n+r|0}while(--s);r%=65521;n%=65521}return r|n<<16|0}e.exports=adler32},320:function(e){e.exports={Z_NO_FLUSH:0,Z_PARTIAL_FLUSH:1,Z_SYNC_FLUSH:2,Z_FULL_FLUSH:3,Z_FINISH:4,Z_BLOCK:5,Z_TREES:6,Z_OK:0,Z_STREAM_END:1,Z_NEED_DICT:2,Z_ERRNO:-1,Z_STREAM_ERROR:-2,Z_DATA_ERROR:-3,Z_BUF_ERROR:-5,Z_NO_COMPRESSION:0,Z_BEST_SPEED:1,Z_BEST_COMPRESSION:9,Z_DEFAULT_COMPRESSION:-1,Z_FILTERED:1,Z_HUFFMAN_ONLY:2,Z_RLE:3,Z_FIXED:4,Z_DEFAULT_STRATEGY:0,Z_BINARY:0,Z_TEXT:1,Z_UNKNOWN:2,Z_DEFLATED:8}},307:function(e){function makeTable(){var e,t=[];for(var i=0;i<256;i++){e=i;for(var a=0;a<8;a++){e=e&1?3988292384^e>>>1:e>>>1}t[i]=e}return t}var t=makeTable();function crc32(e,i,a,r){var n=t,s=r+a;e^=-1;for(var l=r;l<s;l++){e=e>>>8^n[(e^i[l])&255]}return e^-1}e.exports=crc32},450:function(e,t,i){var a=i(380);var r=i(842);var n=i(496);var s=i(307);var l=i(31);var f=0;var o=1;var h=3;var _=4;var d=5;var u=0;var c=1;var v=-2;var b=-3;var w=-5;var p=-1;var g=1;var m=2;var k=3;var y=4;var E=0;var z=2;var Z=8;var x=9;var I=15;var R=8;var S=29;var L=256;var A=L+1+S;var T=30;var F=19;var N=2*A+1;var D=15;var B=3;var U=258;var O=U+B+1;var M=32;var C=42;var G=69;var H=73;var P=91;var K=103;var W=113;var V=666;var q=1;var X=2;var Y=3;var j=4;var J=3;function err(e,t){e.msg=l[t];return t}function rank(e){return(e<<1)-(e>4?9:0)}function zero(e){var t=e.length;while(--t>=0){e[t]=0}}function flush_pending(e){var t=e.state;var i=t.pending;if(i>e.avail_out){i=e.avail_out}if(i===0){return}a.arraySet(e.output,t.pending_buf,t.pending_out,i,e.next_out);e.next_out+=i;t.pending_out+=i;e.total_out+=i;e.avail_out-=i;t.pending-=i;if(t.pending===0){t.pending_out=0}}function flush_block_only(e,t){r._tr_flush_block(e,e.block_start>=0?e.block_start:-1,e.strstart-e.block_start,t);e.block_start=e.strstart;flush_pending(e.strm)}function put_byte(e,t){e.pending_buf[e.pending++]=t}function putShortMSB(e,t){e.pending_buf[e.pending++]=t>>>8&255;e.pending_buf[e.pending++]=t&255}function read_buf(e,t,i,r){var l=e.avail_in;if(l>r){l=r}if(l===0){return 0}e.avail_in-=l;a.arraySet(t,e.input,e.next_in,l,i);if(e.state.wrap===1){e.adler=n(e.adler,t,l,i)}else if(e.state.wrap===2){e.adler=s(e.adler,t,l,i)}e.next_in+=l;e.total_in+=l;return l}function longest_match(e,t){var i=e.max_chain_length;var a=e.strstart;var r;var n;var s=e.prev_length;var l=e.nice_match;var f=e.strstart>e.w_size-O?e.strstart-(e.w_size-O):0;var o=e.window;var h=e.w_mask;var _=e.prev;var d=e.strstart+U;var u=o[a+s-1];var c=o[a+s];if(e.prev_length>=e.good_match){i>>=2}if(l>e.lookahead){l=e.lookahead}do{r=t;if(o[r+s]!==c||o[r+s-1]!==u||o[r]!==o[a]||o[++r]!==o[a+1]){continue}a+=2;r++;do{}while(o[++a]===o[++r]&&o[++a]===o[++r]&&o[++a]===o[++r]&&o[++a]===o[++r]&&o[++a]===o[++r]&&o[++a]===o[++r]&&o[++a]===o[++r]&&o[++a]===o[++r]&&a<d);n=U-(d-a);a=d-U;if(n>s){e.match_start=t;s=n;if(n>=l){break}u=o[a+s-1];c=o[a+s]}}while((t=_[t&h])>f&&--i!==0);if(s<=e.lookahead){return s}return e.lookahead}function fill_window(e){var t=e.w_size;var i,r,n,s,l;do{s=e.window_size-e.lookahead-e.strstart;if(e.strstart>=t+(t-O)){a.arraySet(e.window,e.window,t,t,0);e.match_start-=t;e.strstart-=t;e.block_start-=t;r=e.hash_size;i=r;do{n=e.head[--i];e.head[i]=n>=t?n-t:0}while(--r);r=t;i=r;do{n=e.prev[--i];e.prev[i]=n>=t?n-t:0}while(--r);s+=t}if(e.strm.avail_in===0){break}r=read_buf(e.strm,e.window,e.strstart+e.lookahead,s);e.lookahead+=r;if(e.lookahead+e.insert>=B){l=e.strstart-e.insert;e.ins_h=e.window[l];e.ins_h=(e.ins_h<<e.hash_shift^e.window[l+1])&e.hash_mask;while(e.insert){e.ins_h=(e.ins_h<<e.hash_shift^e.window[l+B-1])&e.hash_mask;e.prev[l&e.w_mask]=e.head[e.ins_h];e.head[e.ins_h]=l;l++;e.insert--;if(e.lookahead+e.insert<B){break}}}}while(e.lookahead<O&&e.strm.avail_in!==0)}function deflate_stored(e,t){var i=65535;if(i>e.pending_buf_size-5){i=e.pending_buf_size-5}for(;;){if(e.lookahead<=1){fill_window(e);if(e.lookahead===0&&t===f){return q}if(e.lookahead===0){break}}e.strstart+=e.lookahead;e.lookahead=0;var a=e.block_start+i;if(e.strstart===0||e.strstart>=a){e.lookahead=e.strstart-a;e.strstart=a;flush_block_only(e,false);if(e.strm.avail_out===0){return q}}if(e.strstart-e.block_start>=e.w_size-O){flush_block_only(e,false);if(e.strm.avail_out===0){return q}}}e.insert=0;if(t===_){flush_block_only(e,true);if(e.strm.avail_out===0){return Y}return j}if(e.strstart>e.block_start){flush_block_only(e,false);if(e.strm.avail_out===0){return q}}return q}function deflate_fast(e,t){var i;var a;for(;;){if(e.lookahead<O){fill_window(e);if(e.lookahead<O&&t===f){return q}if(e.lookahead===0){break}}i=0;if(e.lookahead>=B){e.ins_h=(e.ins_h<<e.hash_shift^e.window[e.strstart+B-1])&e.hash_mask;i=e.prev[e.strstart&e.w_mask]=e.head[e.ins_h];e.head[e.ins_h]=e.strstart}if(i!==0&&e.strstart-i<=e.w_size-O){e.match_length=longest_match(e,i)}if(e.match_length>=B){a=r._tr_tally(e,e.strstart-e.match_start,e.match_length-B);e.lookahead-=e.match_length;if(e.match_length<=e.max_lazy_match&&e.lookahead>=B){e.match_length--;do{e.strstart++;e.ins_h=(e.ins_h<<e.hash_shift^e.window[e.strstart+B-1])&e.hash_mask;i=e.prev[e.strstart&e.w_mask]=e.head[e.ins_h];e.head[e.ins_h]=e.strstart}while(--e.match_length!==0);e.strstart++}else{e.strstart+=e.match_length;e.match_length=0;e.ins_h=e.window[e.strstart];e.ins_h=(e.ins_h<<e.hash_shift^e.window[e.strstart+1])&e.hash_mask}}else{a=r._tr_tally(e,0,e.window[e.strstart]);e.lookahead--;e.strstart++}if(a){flush_block_only(e,false);if(e.strm.avail_out===0){return q}}}e.insert=e.strstart<B-1?e.strstart:B-1;if(t===_){flush_block_only(e,true);if(e.strm.avail_out===0){return Y}return j}if(e.last_lit){flush_block_only(e,false);if(e.strm.avail_out===0){return q}}return X}function deflate_slow(e,t){var i;var a;var n;for(;;){if(e.lookahead<O){fill_window(e);if(e.lookahead<O&&t===f){return q}if(e.lookahead===0){break}}i=0;if(e.lookahead>=B){e.ins_h=(e.ins_h<<e.hash_shift^e.window[e.strstart+B-1])&e.hash_mask;i=e.prev[e.strstart&e.w_mask]=e.head[e.ins_h];e.head[e.ins_h]=e.strstart}e.prev_length=e.match_length;e.prev_match=e.match_start;e.match_length=B-1;if(i!==0&&e.prev_length<e.max_lazy_match&&e.strstart-i<=e.w_size-O){e.match_length=longest_match(e,i);if(e.match_length<=5&&(e.strategy===g||e.match_length===B&&e.strstart-e.match_start>4096)){e.match_length=B-1}}if(e.prev_length>=B&&e.match_length<=e.prev_length){n=e.strstart+e.lookahead-B;a=r._tr_tally(e,e.strstart-1-e.prev_match,e.prev_length-B);e.lookahead-=e.prev_length-1;e.prev_length-=2;do{if(++e.strstart<=n){e.ins_h=(e.ins_h<<e.hash_shift^e.window[e.strstart+B-1])&e.hash_mask;i=e.prev[e.strstart&e.w_mask]=e.head[e.ins_h];e.head[e.ins_h]=e.strstart}}while(--e.prev_length!==0);e.match_available=0;e.match_length=B-1;e.strstart++;if(a){flush_block_only(e,false);if(e.strm.avail_out===0){return q}}}else if(e.match_available){a=r._tr_tally(e,0,e.window[e.strstart-1]);if(a){flush_block_only(e,false)}e.strstart++;e.lookahead--;if(e.strm.avail_out===0){return q}}else{e.match_available=1;e.strstart++;e.lookahead--}}if(e.match_available){a=r._tr_tally(e,0,e.window[e.strstart-1]);e.match_available=0}e.insert=e.strstart<B-1?e.strstart:B-1;if(t===_){flush_block_only(e,true);if(e.strm.avail_out===0){return Y}return j}if(e.last_lit){flush_block_only(e,false);if(e.strm.avail_out===0){return q}}return X}function deflate_rle(e,t){var i;var a;var n,s;var l=e.window;for(;;){if(e.lookahead<=U){fill_window(e);if(e.lookahead<=U&&t===f){return q}if(e.lookahead===0){break}}e.match_length=0;if(e.lookahead>=B&&e.strstart>0){n=e.strstart-1;a=l[n];if(a===l[++n]&&a===l[++n]&&a===l[++n]){s=e.strstart+U;do{}while(a===l[++n]&&a===l[++n]&&a===l[++n]&&a===l[++n]&&a===l[++n]&&a===l[++n]&&a===l[++n]&&a===l[++n]&&n<s);e.match_length=U-(s-n);if(e.match_length>e.lookahead){e.match_length=e.lookahead}}}if(e.match_length>=B){i=r._tr_tally(e,1,e.match_length-B);e.lookahead-=e.match_length;e.strstart+=e.match_length;e.match_length=0}else{i=r._tr_tally(e,0,e.window[e.strstart]);e.lookahead--;e.strstart++}if(i){flush_block_only(e,false);if(e.strm.avail_out===0){return q}}}e.insert=0;if(t===_){flush_block_only(e,true);if(e.strm.avail_out===0){return Y}return j}if(e.last_lit){flush_block_only(e,false);if(e.strm.avail_out===0){return q}}return X}function deflate_huff(e,t){var i;for(;;){if(e.lookahead===0){fill_window(e);if(e.lookahead===0){if(t===f){return q}break}}e.match_length=0;i=r._tr_tally(e,0,e.window[e.strstart]);e.lookahead--;e.strstart++;if(i){flush_block_only(e,false);if(e.strm.avail_out===0){return q}}}e.insert=0;if(t===_){flush_block_only(e,true);if(e.strm.avail_out===0){return Y}return j}if(e.last_lit){flush_block_only(e,false);if(e.strm.avail_out===0){return q}}return X}function Config(e,t,i,a,r){this.good_length=e;this.max_lazy=t;this.nice_length=i;this.max_chain=a;this.func=r}var Q;Q=[new Config(0,0,0,0,deflate_stored),new Config(4,4,8,4,deflate_fast),new Config(4,5,16,8,deflate_fast),new Config(4,6,32,32,deflate_fast),new Config(4,4,16,16,deflate_slow),new Config(8,16,32,32,deflate_slow),new Config(8,16,128,128,deflate_slow),new Config(8,32,128,256,deflate_slow),new Config(32,128,258,1024,deflate_slow),new Config(32,258,258,4096,deflate_slow)];function lm_init(e){e.window_size=2*e.w_size;zero(e.head);e.max_lazy_match=Q[e.level].max_lazy;e.good_match=Q[e.level].good_length;e.nice_match=Q[e.level].nice_length;e.max_chain_length=Q[e.level].max_chain;e.strstart=0;e.block_start=0;e.lookahead=0;e.insert=0;e.match_length=e.prev_length=B-1;e.match_available=0;e.ins_h=0}function DeflateState(){this.strm=null;this.status=0;this.pending_buf=null;this.pending_buf_size=0;this.pending_out=0;this.pending=0;this.wrap=0;this.gzhead=null;this.gzindex=0;this.method=Z;this.last_flush=-1;this.w_size=0;this.w_bits=0;this.w_mask=0;this.window=null;this.window_size=0;this.prev=null;this.head=null;this.ins_h=0;this.hash_size=0;this.hash_bits=0;this.hash_mask=0;this.hash_shift=0;this.block_start=0;this.match_length=0;this.prev_match=0;this.match_available=0;this.strstart=0;this.match_start=0;this.lookahead=0;this.prev_length=0;this.max_chain_length=0;this.max_lazy_match=0;this.level=0;this.strategy=0;this.good_match=0;this.nice_match=0;this.dyn_ltree=new a.Buf16(N*2);this.dyn_dtree=new a.Buf16((2*T+1)*2);this.bl_tree=new a.Buf16((2*F+1)*2);zero(this.dyn_ltree);zero(this.dyn_dtree);zero(this.bl_tree);this.l_desc=null;this.d_desc=null;this.bl_desc=null;this.bl_count=new a.Buf16(D+1);this.heap=new a.Buf16(2*A+1);zero(this.heap);this.heap_len=0;this.heap_max=0;this.depth=new a.Buf16(2*A+1);zero(this.depth);this.l_buf=0;this.lit_bufsize=0;this.last_lit=0;this.d_buf=0;this.opt_len=0;this.static_len=0;this.matches=0;this.insert=0;this.bi_buf=0;this.bi_valid=0}function deflateResetKeep(e){var t;if(!e||!e.state){return err(e,v)}e.total_in=e.total_out=0;e.data_type=z;t=e.state;t.pending=0;t.pending_out=0;if(t.wrap<0){t.wrap=-t.wrap}t.status=t.wrap?C:W;e.adler=t.wrap===2?0:1;t.last_flush=f;r._tr_init(t);return u}function deflateReset(e){var t=deflateResetKeep(e);if(t===u){lm_init(e.state)}return t}function deflateSetHeader(e,t){if(!e||!e.state){return v}if(e.state.wrap!==2){return v}e.state.gzhead=t;return u}function deflateInit2(e,t,i,r,n,s){if(!e){return v}var l=1;if(t===p){t=6}if(r<0){l=0;r=-r}else if(r>15){l=2;r-=16}if(n<1||n>x||i!==Z||r<8||r>15||t<0||t>9||s<0||s>y){return err(e,v)}if(r===8){r=9}var f=new DeflateState;e.state=f;f.strm=e;f.wrap=l;f.gzhead=null;f.w_bits=r;f.w_size=1<<f.w_bits;f.w_mask=f.w_size-1;f.hash_bits=n+7;f.hash_size=1<<f.hash_bits;f.hash_mask=f.hash_size-1;f.hash_shift=~~((f.hash_bits+B-1)/B);f.window=new a.Buf8(f.w_size*2);f.head=new a.Buf16(f.hash_size);f.prev=new a.Buf16(f.w_size);f.lit_bufsize=1<<n+6;f.pending_buf_size=f.lit_bufsize*4;f.pending_buf=new a.Buf8(f.pending_buf_size);f.d_buf=1*f.lit_bufsize;f.l_buf=(1+2)*f.lit_bufsize;f.level=t;f.strategy=s;f.method=i;return deflateReset(e)}function deflateInit(e,t){return deflateInit2(e,t,Z,I,R,E)}function deflate(e,t){var i,a;var n,l;if(!e||!e.state||t>d||t<0){return e?err(e,v):v}a=e.state;if(!e.output||!e.input&&e.avail_in!==0||a.status===V&&t!==_){return err(e,e.avail_out===0?w:v)}a.strm=e;i=a.last_flush;a.last_flush=t;if(a.status===C){if(a.wrap===2){e.adler=0;put_byte(a,31);put_byte(a,139);put_byte(a,8);if(!a.gzhead){put_byte(a,0);put_byte(a,0);put_byte(a,0);put_byte(a,0);put_byte(a,0);put_byte(a,a.level===9?2:a.strategy>=m||a.level<2?4:0);put_byte(a,J);a.status=W}else{put_byte(a,(a.gzhead.text?1:0)+(a.gzhead.hcrc?2:0)+(!a.gzhead.extra?0:4)+(!a.gzhead.name?0:8)+(!a.gzhead.comment?0:16));put_byte(a,a.gzhead.time&255);put_byte(a,a.gzhead.time>>8&255);put_byte(a,a.gzhead.time>>16&255);put_byte(a,a.gzhead.time>>24&255);put_byte(a,a.level===9?2:a.strategy>=m||a.level<2?4:0);put_byte(a,a.gzhead.os&255);if(a.gzhead.extra&&a.gzhead.extra.length){put_byte(a,a.gzhead.extra.length&255);put_byte(a,a.gzhead.extra.length>>8&255)}if(a.gzhead.hcrc){e.adler=s(e.adler,a.pending_buf,a.pending,0)}a.gzindex=0;a.status=G}}else{var b=Z+(a.w_bits-8<<4)<<8;var p=-1;if(a.strategy>=m||a.level<2){p=0}else if(a.level<6){p=1}else if(a.level===6){p=2}else{p=3}b|=p<<6;if(a.strstart!==0){b|=M}b+=31-b%31;a.status=W;putShortMSB(a,b);if(a.strstart!==0){putShortMSB(a,e.adler>>>16);putShortMSB(a,e.adler&65535)}e.adler=1}}if(a.status===G){if(a.gzhead.extra){n=a.pending;while(a.gzindex<(a.gzhead.extra.length&65535)){if(a.pending===a.pending_buf_size){if(a.gzhead.hcrc&&a.pending>n){e.adler=s(e.adler,a.pending_buf,a.pending-n,n)}flush_pending(e);n=a.pending;if(a.pending===a.pending_buf_size){break}}put_byte(a,a.gzhead.extra[a.gzindex]&255);a.gzindex++}if(a.gzhead.hcrc&&a.pending>n){e.adler=s(e.adler,a.pending_buf,a.pending-n,n)}if(a.gzindex===a.gzhead.extra.length){a.gzindex=0;a.status=H}}else{a.status=H}}if(a.status===H){if(a.gzhead.name){n=a.pending;do{if(a.pending===a.pending_buf_size){if(a.gzhead.hcrc&&a.pending>n){e.adler=s(e.adler,a.pending_buf,a.pending-n,n)}flush_pending(e);n=a.pending;if(a.pending===a.pending_buf_size){l=1;break}}if(a.gzindex<a.gzhead.name.length){l=a.gzhead.name.charCodeAt(a.gzindex++)&255}else{l=0}put_byte(a,l)}while(l!==0);if(a.gzhead.hcrc&&a.pending>n){e.adler=s(e.adler,a.pending_buf,a.pending-n,n)}if(l===0){a.gzindex=0;a.status=P}}else{a.status=P}}if(a.status===P){if(a.gzhead.comment){n=a.pending;do{if(a.pending===a.pending_buf_size){if(a.gzhead.hcrc&&a.pending>n){e.adler=s(e.adler,a.pending_buf,a.pending-n,n)}flush_pending(e);n=a.pending;if(a.pending===a.pending_buf_size){l=1;break}}if(a.gzindex<a.gzhead.comment.length){l=a.gzhead.comment.charCodeAt(a.gzindex++)&255}else{l=0}put_byte(a,l)}while(l!==0);if(a.gzhead.hcrc&&a.pending>n){e.adler=s(e.adler,a.pending_buf,a.pending-n,n)}if(l===0){a.status=K}}else{a.status=K}}if(a.status===K){if(a.gzhead.hcrc){if(a.pending+2>a.pending_buf_size){flush_pending(e)}if(a.pending+2<=a.pending_buf_size){put_byte(a,e.adler&255);put_byte(a,e.adler>>8&255);e.adler=0;a.status=W}}else{a.status=W}}if(a.pending!==0){flush_pending(e);if(e.avail_out===0){a.last_flush=-1;return u}}else if(e.avail_in===0&&rank(t)<=rank(i)&&t!==_){return err(e,w)}if(a.status===V&&e.avail_in!==0){return err(e,w)}if(e.avail_in!==0||a.lookahead!==0||t!==f&&a.status!==V){var g=a.strategy===m?deflate_huff(a,t):a.strategy===k?deflate_rle(a,t):Q[a.level].func(a,t);if(g===Y||g===j){a.status=V}if(g===q||g===Y){if(e.avail_out===0){a.last_flush=-1}return u}if(g===X){if(t===o){r._tr_align(a)}else if(t!==d){r._tr_stored_block(a,0,0,false);if(t===h){zero(a.head);if(a.lookahead===0){a.strstart=0;a.block_start=0;a.insert=0}}}flush_pending(e);if(e.avail_out===0){a.last_flush=-1;return u}}}if(t!==_){return u}if(a.wrap<=0){return c}if(a.wrap===2){put_byte(a,e.adler&255);put_byte(a,e.adler>>8&255);put_byte(a,e.adler>>16&255);put_byte(a,e.adler>>24&255);put_byte(a,e.total_in&255);put_byte(a,e.total_in>>8&255);put_byte(a,e.total_in>>16&255);put_byte(a,e.total_in>>24&255)}else{putShortMSB(a,e.adler>>>16);putShortMSB(a,e.adler&65535)}flush_pending(e);if(a.wrap>0){a.wrap=-a.wrap}return a.pending!==0?u:c}function deflateEnd(e){var t;if(!e||!e.state){return v}t=e.state.status;if(t!==C&&t!==G&&t!==H&&t!==P&&t!==K&&t!==W&&t!==V){return err(e,v)}e.state=null;return t===W?err(e,b):u}function deflateSetDictionary(e,t){var i=t.length;var r;var s,l;var f;var o;var h;var _;var d;if(!e||!e.state){return v}r=e.state;f=r.wrap;if(f===2||f===1&&r.status!==C||r.lookahead){return v}if(f===1){e.adler=n(e.adler,t,i,0)}r.wrap=0;if(i>=r.w_size){if(f===0){zero(r.head);r.strstart=0;r.block_start=0;r.insert=0}d=new a.Buf8(r.w_size);a.arraySet(d,t,i-r.w_size,r.w_size,0);t=d;i=r.w_size}o=e.avail_in;h=e.next_in;_=e.input;e.avail_in=i;e.next_in=0;e.input=t;fill_window(r);while(r.lookahead>=B){s=r.strstart;l=r.lookahead-(B-1);do{r.ins_h=(r.ins_h<<r.hash_shift^r.window[s+B-1])&r.hash_mask;r.prev[s&r.w_mask]=r.head[r.ins_h];r.head[r.ins_h]=s;s++}while(--l);r.strstart=s;r.lookahead=B-1;fill_window(r)}r.strstart+=r.lookahead;r.block_start=r.strstart;r.insert=r.lookahead;r.lookahead=0;r.match_length=r.prev_length=B-1;r.match_available=0;e.next_in=h;e.input=_;e.avail_in=o;r.wrap=f;return u}t.deflateInit=deflateInit;t.deflateInit2=deflateInit2;t.deflateReset=deflateReset;t.deflateResetKeep=deflateResetKeep;t.deflateSetHeader=deflateSetHeader;t.deflate=deflate;t.deflateEnd=deflateEnd;t.deflateSetDictionary=deflateSetDictionary;t.deflateInfo="pako deflate (from Nodeca project)"},333:function(e){var t=30;var i=12;e.exports=function inflate_fast(e,a){var r;var n;var s;var l;var f;var o;var h;var _;var d;var u;var c;var v;var b;var w;var p;var g;var m;var k;var y;var E;var z;var Z;var x;var I,R;r=e.state;n=e.next_in;I=e.input;s=n+(e.avail_in-5);l=e.next_out;R=e.output;f=l-(a-e.avail_out);o=l+(e.avail_out-257);h=r.dmax;_=r.wsize;d=r.whave;u=r.wnext;c=r.window;v=r.hold;b=r.bits;w=r.lencode;p=r.distcode;g=(1<<r.lenbits)-1;m=(1<<r.distbits)-1;e:do{if(b<15){v+=I[n++]<<b;b+=8;v+=I[n++]<<b;b+=8}k=w[v&g];t:for(;;){y=k>>>24;v>>>=y;b-=y;y=k>>>16&255;if(y===0){R[l++]=k&65535}else if(y&16){E=k&65535;y&=15;if(y){if(b<y){v+=I[n++]<<b;b+=8}E+=v&(1<<y)-1;v>>>=y;b-=y}if(b<15){v+=I[n++]<<b;b+=8;v+=I[n++]<<b;b+=8}k=p[v&m];i:for(;;){y=k>>>24;v>>>=y;b-=y;y=k>>>16&255;if(y&16){z=k&65535;y&=15;if(b<y){v+=I[n++]<<b;b+=8;if(b<y){v+=I[n++]<<b;b+=8}}z+=v&(1<<y)-1;if(z>h){e.msg="invalid distance too far back";r.mode=t;break e}v>>>=y;b-=y;y=l-f;if(z>y){y=z-y;if(y>d){if(r.sane){e.msg="invalid distance too far back";r.mode=t;break e}}Z=0;x=c;if(u===0){Z+=_-y;if(y<E){E-=y;do{R[l++]=c[Z++]}while(--y);Z=l-z;x=R}}else if(u<y){Z+=_+u-y;y-=u;if(y<E){E-=y;do{R[l++]=c[Z++]}while(--y);Z=0;if(u<E){y=u;E-=y;do{R[l++]=c[Z++]}while(--y);Z=l-z;x=R}}}else{Z+=u-y;if(y<E){E-=y;do{R[l++]=c[Z++]}while(--y);Z=l-z;x=R}}while(E>2){R[l++]=x[Z++];R[l++]=x[Z++];R[l++]=x[Z++];E-=3}if(E){R[l++]=x[Z++];if(E>1){R[l++]=x[Z++]}}}else{Z=l-z;do{R[l++]=R[Z++];R[l++]=R[Z++];R[l++]=R[Z++];E-=3}while(E>2);if(E){R[l++]=R[Z++];if(E>1){R[l++]=R[Z++]}}}}else if((y&64)===0){k=p[(k&65535)+(v&(1<<y)-1)];continue i}else{e.msg="invalid distance code";r.mode=t;break e}break}}else if((y&64)===0){k=w[(k&65535)+(v&(1<<y)-1)];continue t}else if(y&32){r.mode=i;break e}else{e.msg="invalid literal/length code";r.mode=t;break e}break}}while(n<s&&l<o);E=b>>3;n-=E;b-=E<<3;v&=(1<<b)-1;e.next_in=n;e.next_out=l;e.avail_in=n<s?5+(s-n):5-(n-s);e.avail_out=l<o?257+(o-l):257-(l-o);r.hold=v;r.bits=b;return}},324:function(e,t,i){var a=i(380);var r=i(496);var n=i(307);var s=i(333);var l=i(19);var f=0;var o=1;var h=2;var _=4;var d=5;var u=6;var c=0;var v=1;var b=2;var w=-2;var p=-3;var g=-4;var m=-5;var k=8;var y=1;var E=2;var z=3;var Z=4;var x=5;var I=6;var R=7;var S=8;var L=9;var A=10;var T=11;var F=12;var N=13;var D=14;var B=15;var U=16;var O=17;var M=18;var C=19;var G=20;var H=21;var P=22;var K=23;var W=24;var V=25;var q=26;var X=27;var Y=28;var j=29;var J=30;var Q=31;var $=32;var ee=852;var te=592;var ie=15;var ae=ie;function zswap32(e){return(e>>>24&255)+(e>>>8&65280)+((e&65280)<<8)+((e&255)<<24)}function InflateState(){this.mode=0;this.last=false;this.wrap=0;this.havedict=false;this.flags=0;this.dmax=0;this.check=0;this.total=0;this.head=null;this.wbits=0;this.wsize=0;this.whave=0;this.wnext=0;this.window=null;this.hold=0;this.bits=0;this.length=0;this.offset=0;this.extra=0;this.lencode=null;this.distcode=null;this.lenbits=0;this.distbits=0;this.ncode=0;this.nlen=0;this.ndist=0;this.have=0;this.next=null;this.lens=new a.Buf16(320);this.work=new a.Buf16(288);this.lendyn=null;this.distdyn=null;this.sane=0;this.back=0;this.was=0}function inflateResetKeep(e){var t;if(!e||!e.state){return w}t=e.state;e.total_in=e.total_out=t.total=0;e.msg="";if(t.wrap){e.adler=t.wrap&1}t.mode=y;t.last=0;t.havedict=0;t.dmax=32768;t.head=null;t.hold=0;t.bits=0;t.lencode=t.lendyn=new a.Buf32(ee);t.distcode=t.distdyn=new a.Buf32(te);t.sane=1;t.back=-1;return c}function inflateReset(e){var t;if(!e||!e.state){return w}t=e.state;t.wsize=0;t.whave=0;t.wnext=0;return inflateResetKeep(e)}function inflateReset2(e,t){var i;var a;if(!e||!e.state){return w}a=e.state;if(t<0){i=0;t=-t}else{i=(t>>4)+1;if(t<48){t&=15}}if(t&&(t<8||t>15)){return w}if(a.window!==null&&a.wbits!==t){a.window=null}a.wrap=i;a.wbits=t;return inflateReset(e)}function inflateInit2(e,t){var i;var a;if(!e){return w}a=new InflateState;e.state=a;a.window=null;i=inflateReset2(e,t);if(i!==c){e.state=null}return i}function inflateInit(e){return inflateInit2(e,ae)}var re=true;var ne,se;function fixedtables(e){if(re){var t;ne=new a.Buf32(512);se=new a.Buf32(32);t=0;while(t<144){e.lens[t++]=8}while(t<256){e.lens[t++]=9}while(t<280){e.lens[t++]=7}while(t<288){e.lens[t++]=8}l(o,e.lens,0,288,ne,0,e.work,{bits:9});t=0;while(t<32){e.lens[t++]=5}l(h,e.lens,0,32,se,0,e.work,{bits:5});re=false}e.lencode=ne;e.lenbits=9;e.distcode=se;e.distbits=5}function updatewindow(e,t,i,r){var n;var s=e.state;if(s.window===null){s.wsize=1<<s.wbits;s.wnext=0;s.whave=0;s.window=new a.Buf8(s.wsize)}if(r>=s.wsize){a.arraySet(s.window,t,i-s.wsize,s.wsize,0);s.wnext=0;s.whave=s.wsize}else{n=s.wsize-s.wnext;if(n>r){n=r}a.arraySet(s.window,t,i-r,n,s.wnext);r-=n;if(r){a.arraySet(s.window,t,i-r,r,0);s.wnext=r;s.whave=s.wsize}else{s.wnext+=n;if(s.wnext===s.wsize){s.wnext=0}if(s.whave<s.wsize){s.whave+=n}}}return 0}function inflate(e,t){var i;var ee,te;var ie;var ae;var re,ne;var se;var le;var fe,oe;var he;var _e;var de;var ue=0;var ce,ve,be;var we,pe,ge;var me;var ke;var ye=new a.Buf8(4);var Ee;var ze;var Ze=[16,17,18,0,8,7,9,6,10,5,11,4,12,3,13,2,14,1,15];if(!e||!e.state||!e.output||!e.input&&e.avail_in!==0){return w}i=e.state;if(i.mode===F){i.mode=N}ae=e.next_out;te=e.output;ne=e.avail_out;ie=e.next_in;ee=e.input;re=e.avail_in;se=i.hold;le=i.bits;fe=re;oe=ne;ke=c;e:for(;;){switch(i.mode){case y:if(i.wrap===0){i.mode=N;break}while(le<16){if(re===0){break e}re--;se+=ee[ie++]<<le;le+=8}if(i.wrap&2&&se===35615){i.check=0;ye[0]=se&255;ye[1]=se>>>8&255;i.check=n(i.check,ye,2,0);se=0;le=0;i.mode=E;break}i.flags=0;if(i.head){i.head.done=false}if(!(i.wrap&1)||(((se&255)<<8)+(se>>8))%31){e.msg="incorrect header check";i.mode=J;break}if((se&15)!==k){e.msg="unknown compression method";i.mode=J;break}se>>>=4;le-=4;me=(se&15)+8;if(i.wbits===0){i.wbits=me}else if(me>i.wbits){e.msg="invalid window size";i.mode=J;break}i.dmax=1<<me;e.adler=i.check=1;i.mode=se&512?A:F;se=0;le=0;break;case E:while(le<16){if(re===0){break e}re--;se+=ee[ie++]<<le;le+=8}i.flags=se;if((i.flags&255)!==k){e.msg="unknown compression method";i.mode=J;break}if(i.flags&57344){e.msg="unknown header flags set";i.mode=J;break}if(i.head){i.head.text=se>>8&1}if(i.flags&512){ye[0]=se&255;ye[1]=se>>>8&255;i.check=n(i.check,ye,2,0)}se=0;le=0;i.mode=z;case z:while(le<32){if(re===0){break e}re--;se+=ee[ie++]<<le;le+=8}if(i.head){i.head.time=se}if(i.flags&512){ye[0]=se&255;ye[1]=se>>>8&255;ye[2]=se>>>16&255;ye[3]=se>>>24&255;i.check=n(i.check,ye,4,0)}se=0;le=0;i.mode=Z;case Z:while(le<16){if(re===0){break e}re--;se+=ee[ie++]<<le;le+=8}if(i.head){i.head.xflags=se&255;i.head.os=se>>8}if(i.flags&512){ye[0]=se&255;ye[1]=se>>>8&255;i.check=n(i.check,ye,2,0)}se=0;le=0;i.mode=x;case x:if(i.flags&1024){while(le<16){if(re===0){break e}re--;se+=ee[ie++]<<le;le+=8}i.length=se;if(i.head){i.head.extra_len=se}if(i.flags&512){ye[0]=se&255;ye[1]=se>>>8&255;i.check=n(i.check,ye,2,0)}se=0;le=0}else if(i.head){i.head.extra=null}i.mode=I;case I:if(i.flags&1024){he=i.length;if(he>re){he=re}if(he){if(i.head){me=i.head.extra_len-i.length;if(!i.head.extra){i.head.extra=new Array(i.head.extra_len)}a.arraySet(i.head.extra,ee,ie,he,me)}if(i.flags&512){i.check=n(i.check,ee,he,ie)}re-=he;ie+=he;i.length-=he}if(i.length){break e}}i.length=0;i.mode=R;case R:if(i.flags&2048){if(re===0){break e}he=0;do{me=ee[ie+he++];if(i.head&&me&&i.length<65536){i.head.name+=String.fromCharCode(me)}}while(me&&he<re);if(i.flags&512){i.check=n(i.check,ee,he,ie)}re-=he;ie+=he;if(me){break e}}else if(i.head){i.head.name=null}i.length=0;i.mode=S;case S:if(i.flags&4096){if(re===0){break e}he=0;do{me=ee[ie+he++];if(i.head&&me&&i.length<65536){i.head.comment+=String.fromCharCode(me)}}while(me&&he<re);if(i.flags&512){i.check=n(i.check,ee,he,ie)}re-=he;ie+=he;if(me){break e}}else if(i.head){i.head.comment=null}i.mode=L;case L:if(i.flags&512){while(le<16){if(re===0){break e}re--;se+=ee[ie++]<<le;le+=8}if(se!==(i.check&65535)){e.msg="header crc mismatch";i.mode=J;break}se=0;le=0}if(i.head){i.head.hcrc=i.flags>>9&1;i.head.done=true}e.adler=i.check=0;i.mode=F;break;case A:while(le<32){if(re===0){break e}re--;se+=ee[ie++]<<le;le+=8}e.adler=i.check=zswap32(se);se=0;le=0;i.mode=T;case T:if(i.havedict===0){e.next_out=ae;e.avail_out=ne;e.next_in=ie;e.avail_in=re;i.hold=se;i.bits=le;return b}e.adler=i.check=1;i.mode=F;case F:if(t===d||t===u){break e}case N:if(i.last){se>>>=le&7;le-=le&7;i.mode=X;break}while(le<3){if(re===0){break e}re--;se+=ee[ie++]<<le;le+=8}i.last=se&1;se>>>=1;le-=1;switch(se&3){case 0:i.mode=D;break;case 1:fixedtables(i);i.mode=G;if(t===u){se>>>=2;le-=2;break e}break;case 2:i.mode=O;break;case 3:e.msg="invalid block type";i.mode=J}se>>>=2;le-=2;break;case D:se>>>=le&7;le-=le&7;while(le<32){if(re===0){break e}re--;se+=ee[ie++]<<le;le+=8}if((se&65535)!==(se>>>16^65535)){e.msg="invalid stored block lengths";i.mode=J;break}i.length=se&65535;se=0;le=0;i.mode=B;if(t===u){break e}case B:i.mode=U;case U:he=i.length;if(he){if(he>re){he=re}if(he>ne){he=ne}if(he===0){break e}a.arraySet(te,ee,ie,he,ae);re-=he;ie+=he;ne-=he;ae+=he;i.length-=he;break}i.mode=F;break;case O:while(le<14){if(re===0){break e}re--;se+=ee[ie++]<<le;le+=8}i.nlen=(se&31)+257;se>>>=5;le-=5;i.ndist=(se&31)+1;se>>>=5;le-=5;i.ncode=(se&15)+4;se>>>=4;le-=4;if(i.nlen>286||i.ndist>30){e.msg="too many length or distance symbols";i.mode=J;break}i.have=0;i.mode=M;case M:while(i.have<i.ncode){while(le<3){if(re===0){break e}re--;se+=ee[ie++]<<le;le+=8}i.lens[Ze[i.have++]]=se&7;se>>>=3;le-=3}while(i.have<19){i.lens[Ze[i.have++]]=0}i.lencode=i.lendyn;i.lenbits=7;Ee={bits:i.lenbits};ke=l(f,i.lens,0,19,i.lencode,0,i.work,Ee);i.lenbits=Ee.bits;if(ke){e.msg="invalid code lengths set";i.mode=J;break}i.have=0;i.mode=C;case C:while(i.have<i.nlen+i.ndist){for(;;){ue=i.lencode[se&(1<<i.lenbits)-1];ce=ue>>>24;ve=ue>>>16&255;be=ue&65535;if(ce<=le){break}if(re===0){break e}re--;se+=ee[ie++]<<le;le+=8}if(be<16){se>>>=ce;le-=ce;i.lens[i.have++]=be}else{if(be===16){ze=ce+2;while(le<ze){if(re===0){break e}re--;se+=ee[ie++]<<le;le+=8}se>>>=ce;le-=ce;if(i.have===0){e.msg="invalid bit length repeat";i.mode=J;break}me=i.lens[i.have-1];he=3+(se&3);se>>>=2;le-=2}else if(be===17){ze=ce+3;while(le<ze){if(re===0){break e}re--;se+=ee[ie++]<<le;le+=8}se>>>=ce;le-=ce;me=0;he=3+(se&7);se>>>=3;le-=3}else{ze=ce+7;while(le<ze){if(re===0){break e}re--;se+=ee[ie++]<<le;le+=8}se>>>=ce;le-=ce;me=0;he=11+(se&127);se>>>=7;le-=7}if(i.have+he>i.nlen+i.ndist){e.msg="invalid bit length repeat";i.mode=J;break}while(he--){i.lens[i.have++]=me}}}if(i.mode===J){break}if(i.lens[256]===0){e.msg="invalid code -- missing end-of-block";i.mode=J;break}i.lenbits=9;Ee={bits:i.lenbits};ke=l(o,i.lens,0,i.nlen,i.lencode,0,i.work,Ee);i.lenbits=Ee.bits;if(ke){e.msg="invalid literal/lengths set";i.mode=J;break}i.distbits=6;i.distcode=i.distdyn;Ee={bits:i.distbits};ke=l(h,i.lens,i.nlen,i.ndist,i.distcode,0,i.work,Ee);i.distbits=Ee.bits;if(ke){e.msg="invalid distances set";i.mode=J;break}i.mode=G;if(t===u){break e}case G:i.mode=H;case H:if(re>=6&&ne>=258){e.next_out=ae;e.avail_out=ne;e.next_in=ie;e.avail_in=re;i.hold=se;i.bits=le;s(e,oe);ae=e.next_out;te=e.output;ne=e.avail_out;ie=e.next_in;ee=e.input;re=e.avail_in;se=i.hold;le=i.bits;if(i.mode===F){i.back=-1}break}i.back=0;for(;;){ue=i.lencode[se&(1<<i.lenbits)-1];ce=ue>>>24;ve=ue>>>16&255;be=ue&65535;if(ce<=le){break}if(re===0){break e}re--;se+=ee[ie++]<<le;le+=8}if(ve&&(ve&240)===0){we=ce;pe=ve;ge=be;for(;;){ue=i.lencode[ge+((se&(1<<we+pe)-1)>>we)];ce=ue>>>24;ve=ue>>>16&255;be=ue&65535;if(we+ce<=le){break}if(re===0){break e}re--;se+=ee[ie++]<<le;le+=8}se>>>=we;le-=we;i.back+=we}se>>>=ce;le-=ce;i.back+=ce;i.length=be;if(ve===0){i.mode=q;break}if(ve&32){i.back=-1;i.mode=F;break}if(ve&64){e.msg="invalid literal/length code";i.mode=J;break}i.extra=ve&15;i.mode=P;case P:if(i.extra){ze=i.extra;while(le<ze){if(re===0){break e}re--;se+=ee[ie++]<<le;le+=8}i.length+=se&(1<<i.extra)-1;se>>>=i.extra;le-=i.extra;i.back+=i.extra}i.was=i.length;i.mode=K;case K:for(;;){ue=i.distcode[se&(1<<i.distbits)-1];ce=ue>>>24;ve=ue>>>16&255;be=ue&65535;if(ce<=le){break}if(re===0){break e}re--;se+=ee[ie++]<<le;le+=8}if((ve&240)===0){we=ce;pe=ve;ge=be;for(;;){ue=i.distcode[ge+((se&(1<<we+pe)-1)>>we)];ce=ue>>>24;ve=ue>>>16&255;be=ue&65535;if(we+ce<=le){break}if(re===0){break e}re--;se+=ee[ie++]<<le;le+=8}se>>>=we;le-=we;i.back+=we}se>>>=ce;le-=ce;i.back+=ce;if(ve&64){e.msg="invalid distance code";i.mode=J;break}i.offset=be;i.extra=ve&15;i.mode=W;case W:if(i.extra){ze=i.extra;while(le<ze){if(re===0){break e}re--;se+=ee[ie++]<<le;le+=8}i.offset+=se&(1<<i.extra)-1;se>>>=i.extra;le-=i.extra;i.back+=i.extra}if(i.offset>i.dmax){e.msg="invalid distance too far back";i.mode=J;break}i.mode=V;case V:if(ne===0){break e}he=oe-ne;if(i.offset>he){he=i.offset-he;if(he>i.whave){if(i.sane){e.msg="invalid distance too far back";i.mode=J;break}}if(he>i.wnext){he-=i.wnext;_e=i.wsize-he}else{_e=i.wnext-he}if(he>i.length){he=i.length}de=i.window}else{de=te;_e=ae-i.offset;he=i.length}if(he>ne){he=ne}ne-=he;i.length-=he;do{te[ae++]=de[_e++]}while(--he);if(i.length===0){i.mode=H}break;case q:if(ne===0){break e}te[ae++]=i.length;ne--;i.mode=H;break;case X:if(i.wrap){while(le<32){if(re===0){break e}re--;se|=ee[ie++]<<le;le+=8}oe-=ne;e.total_out+=oe;i.total+=oe;if(oe){e.adler=i.check=i.flags?n(i.check,te,oe,ae-oe):r(i.check,te,oe,ae-oe)}oe=ne;if((i.flags?se:zswap32(se))!==i.check){e.msg="incorrect data check";i.mode=J;break}se=0;le=0}i.mode=Y;case Y:if(i.wrap&&i.flags){while(le<32){if(re===0){break e}re--;se+=ee[ie++]<<le;le+=8}if(se!==(i.total&4294967295)){e.msg="incorrect length check";i.mode=J;break}se=0;le=0}i.mode=j;case j:ke=v;break e;case J:ke=p;break e;case Q:return g;case $:default:return w}}e.next_out=ae;e.avail_out=ne;e.next_in=ie;e.avail_in=re;i.hold=se;i.bits=le;if(i.wsize||oe!==e.avail_out&&i.mode<J&&(i.mode<X||t!==_)){if(updatewindow(e,e.output,e.next_out,oe-e.avail_out)){i.mode=Q;return g}}fe-=e.avail_in;oe-=e.avail_out;e.total_in+=fe;e.total_out+=oe;i.total+=oe;if(i.wrap&&oe){e.adler=i.check=i.flags?n(i.check,te,oe,e.next_out-oe):r(i.check,te,oe,e.next_out-oe)}e.data_type=i.bits+(i.last?64:0)+(i.mode===F?128:0)+(i.mode===G||i.mode===B?256:0);if((fe===0&&oe===0||t===_)&&ke===c){ke=m}return ke}function inflateEnd(e){if(!e||!e.state){return w}var t=e.state;if(t.window){t.window=null}e.state=null;return c}function inflateGetHeader(e,t){var i;if(!e||!e.state){return w}i=e.state;if((i.wrap&2)===0){return w}i.head=t;t.done=false;return c}function inflateSetDictionary(e,t){var i=t.length;var a;var n;var s;if(!e||!e.state){return w}a=e.state;if(a.wrap!==0&&a.mode!==T){return w}if(a.mode===T){n=1;n=r(n,t,i,0);if(n!==a.check){return p}}s=updatewindow(e,t,i,i);if(s){a.mode=Q;return g}a.havedict=1;return c}t.inflateReset=inflateReset;t.inflateReset2=inflateReset2;t.inflateResetKeep=inflateResetKeep;t.inflateInit=inflateInit;t.inflateInit2=inflateInit2;t.inflate=inflate;t.inflateEnd=inflateEnd;t.inflateGetHeader=inflateGetHeader;t.inflateSetDictionary=inflateSetDictionary;t.inflateInfo="pako inflate (from Nodeca project)"},19:function(e,t,i){var a=i(380);var r=15;var n=852;var s=592;var l=0;var f=1;var o=2;var h=[3,4,5,6,7,8,9,10,11,13,15,17,19,23,27,31,35,43,51,59,67,83,99,115,131,163,195,227,258,0,0];var _=[16,16,16,16,16,16,16,16,17,17,17,17,18,18,18,18,19,19,19,19,20,20,20,20,21,21,21,21,16,72,78];var d=[1,2,3,4,5,7,9,13,17,25,33,49,65,97,129,193,257,385,513,769,1025,1537,2049,3073,4097,6145,8193,12289,16385,24577,0,0];var u=[16,16,16,16,17,17,18,18,19,19,20,20,21,21,22,22,23,23,24,24,25,25,26,26,27,27,28,28,29,29,64,64];e.exports=function inflate_table(e,t,i,c,v,b,w,p){var g=p.bits;var m=0;var k=0;var y=0,E=0;var z=0;var Z=0;var x=0;var I=0;var R=0;var S=0;var L;var A;var T;var F;var N;var D=null;var B=0;var U;var O=new a.Buf16(r+1);var M=new a.Buf16(r+1);var C=null;var G=0;var H,P,K;for(m=0;m<=r;m++){O[m]=0}for(k=0;k<c;k++){O[t[i+k]]++}z=g;for(E=r;E>=1;E--){if(O[E]!==0){break}}if(z>E){z=E}if(E===0){v[b++]=1<<24|64<<16|0;v[b++]=1<<24|64<<16|0;p.bits=1;return 0}for(y=1;y<E;y++){if(O[y]!==0){break}}if(z<y){z=y}I=1;for(m=1;m<=r;m++){I<<=1;I-=O[m];if(I<0){return-1}}if(I>0&&(e===l||E!==1)){return-1}M[1]=0;for(m=1;m<r;m++){M[m+1]=M[m]+O[m]}for(k=0;k<c;k++){if(t[i+k]!==0){w[M[t[i+k]]++]=k}}if(e===l){D=C=w;U=19}else if(e===f){D=h;B-=257;C=_;G-=257;U=256}else{D=d;C=u;U=-1}S=0;k=0;m=y;N=b;Z=z;x=0;T=-1;R=1<<z;F=R-1;if(e===f&&R>n||e===o&&R>s){return 1}for(;;){H=m-x;if(w[k]<U){P=0;K=w[k]}else if(w[k]>U){P=C[G+w[k]];K=D[B+w[k]]}else{P=32+64;K=0}L=1<<m-x;A=1<<Z;y=A;do{A-=L;v[N+(S>>x)+A]=H<<24|P<<16|K|0}while(A!==0);L=1<<m-1;while(S&L){L>>=1}if(L!==0){S&=L-1;S+=L}else{S=0}k++;if(--O[m]===0){if(m===E){break}m=t[i+w[k]]}if(m>z&&(S&F)!==T){if(x===0){x=z}N+=y;Z=m-x;I=1<<Z;while(Z+x<E){I-=O[Z+x];if(I<=0){break}Z++;I<<=1}R+=1<<Z;if(e===f&&R>n||e===o&&R>s){return 1}T=S&F;v[T]=z<<24|Z<<16|N-b|0}}if(S!==0){v[N+S]=m-x<<24|64<<16|0}p.bits=z;return 0}},31:function(e){e.exports={2:"need dictionary",1:"stream end",0:"","-1":"file error","-2":"stream error","-3":"data error","-4":"insufficient memory","-5":"buffer error","-6":"incompatible version"}},842:function(e,t,i){var a=i(380);var r=4;var n=0;var s=1;var l=2;function zero(e){var t=e.length;while(--t>=0){e[t]=0}}var f=0;var o=1;var h=2;var _=3;var d=258;var u=29;var c=256;var v=c+1+u;var b=30;var w=19;var p=2*v+1;var g=15;var m=16;var k=7;var y=256;var E=16;var z=17;var Z=18;var x=[0,0,0,0,0,0,0,0,1,1,1,1,2,2,2,2,3,3,3,3,4,4,4,4,5,5,5,5,0];var I=[0,0,0,0,1,1,2,2,3,3,4,4,5,5,6,6,7,7,8,8,9,9,10,10,11,11,12,12,13,13];var R=[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,2,3,7];var S=[16,17,18,0,8,7,9,6,10,5,11,4,12,3,13,2,14,1,15];var L=512;var A=new Array((v+2)*2);zero(A);var T=new Array(b*2);zero(T);var F=new Array(L);zero(F);var N=new Array(d-_+1);zero(N);var D=new Array(u);zero(D);var B=new Array(b);zero(B);function StaticTreeDesc(e,t,i,a,r){this.static_tree=e;this.extra_bits=t;this.extra_base=i;this.elems=a;this.max_length=r;this.has_stree=e&&e.length}var U;var O;var M;function TreeDesc(e,t){this.dyn_tree=e;this.max_code=0;this.stat_desc=t}function d_code(e){return e<256?F[e]:F[256+(e>>>7)]}function put_short(e,t){e.pending_buf[e.pending++]=t&255;e.pending_buf[e.pending++]=t>>>8&255}function send_bits(e,t,i){if(e.bi_valid>m-i){e.bi_buf|=t<<e.bi_valid&65535;put_short(e,e.bi_buf);e.bi_buf=t>>m-e.bi_valid;e.bi_valid+=i-m}else{e.bi_buf|=t<<e.bi_valid&65535;e.bi_valid+=i}}function send_code(e,t,i){send_bits(e,i[t*2],i[t*2+1])}function bi_reverse(e,t){var i=0;do{i|=e&1;e>>>=1;i<<=1}while(--t>0);return i>>>1}function bi_flush(e){if(e.bi_valid===16){put_short(e,e.bi_buf);e.bi_buf=0;e.bi_valid=0}else if(e.bi_valid>=8){e.pending_buf[e.pending++]=e.bi_buf&255;e.bi_buf>>=8;e.bi_valid-=8}}function gen_bitlen(e,t){var i=t.dyn_tree;var a=t.max_code;var r=t.stat_desc.static_tree;var n=t.stat_desc.has_stree;var s=t.stat_desc.extra_bits;var l=t.stat_desc.extra_base;var f=t.stat_desc.max_length;var o;var h,_;var d;var u;var c;var v=0;for(d=0;d<=g;d++){e.bl_count[d]=0}i[e.heap[e.heap_max]*2+1]=0;for(o=e.heap_max+1;o<p;o++){h=e.heap[o];d=i[i[h*2+1]*2+1]+1;if(d>f){d=f;v++}i[h*2+1]=d;if(h>a){continue}e.bl_count[d]++;u=0;if(h>=l){u=s[h-l]}c=i[h*2];e.opt_len+=c*(d+u);if(n){e.static_len+=c*(r[h*2+1]+u)}}if(v===0){return}do{d=f-1;while(e.bl_count[d]===0){d--}e.bl_count[d]--;e.bl_count[d+1]+=2;e.bl_count[f]--;v-=2}while(v>0);for(d=f;d!==0;d--){h=e.bl_count[d];while(h!==0){_=e.heap[--o];if(_>a){continue}if(i[_*2+1]!==d){e.opt_len+=(d-i[_*2+1])*i[_*2];i[_*2+1]=d}h--}}}function gen_codes(e,t,i){var a=new Array(g+1);var r=0;var n;var s;for(n=1;n<=g;n++){a[n]=r=r+i[n-1]<<1}for(s=0;s<=t;s++){var l=e[s*2+1];if(l===0){continue}e[s*2]=bi_reverse(a[l]++,l)}}function tr_static_init(){var e;var t;var i;var a;var r;var n=new Array(g+1);i=0;for(a=0;a<u-1;a++){D[a]=i;for(e=0;e<1<<x[a];e++){N[i++]=a}}N[i-1]=a;r=0;for(a=0;a<16;a++){B[a]=r;for(e=0;e<1<<I[a];e++){F[r++]=a}}r>>=7;for(;a<b;a++){B[a]=r<<7;for(e=0;e<1<<I[a]-7;e++){F[256+r++]=a}}for(t=0;t<=g;t++){n[t]=0}e=0;while(e<=143){A[e*2+1]=8;e++;n[8]++}while(e<=255){A[e*2+1]=9;e++;n[9]++}while(e<=279){A[e*2+1]=7;e++;n[7]++}while(e<=287){A[e*2+1]=8;e++;n[8]++}gen_codes(A,v+1,n);for(e=0;e<b;e++){T[e*2+1]=5;T[e*2]=bi_reverse(e,5)}U=new StaticTreeDesc(A,x,c+1,v,g);O=new StaticTreeDesc(T,I,0,b,g);M=new StaticTreeDesc(new Array(0),R,0,w,k)}function init_block(e){var t;for(t=0;t<v;t++){e.dyn_ltree[t*2]=0}for(t=0;t<b;t++){e.dyn_dtree[t*2]=0}for(t=0;t<w;t++){e.bl_tree[t*2]=0}e.dyn_ltree[y*2]=1;e.opt_len=e.static_len=0;e.last_lit=e.matches=0}function bi_windup(e){if(e.bi_valid>8){put_short(e,e.bi_buf)}else if(e.bi_valid>0){e.pending_buf[e.pending++]=e.bi_buf}e.bi_buf=0;e.bi_valid=0}function copy_block(e,t,i,r){bi_windup(e);if(r){put_short(e,i);put_short(e,~i)}a.arraySet(e.pending_buf,e.window,t,i,e.pending);e.pending+=i}function smaller(e,t,i,a){var r=t*2;var n=i*2;return e[r]<e[n]||e[r]===e[n]&&a[t]<=a[i]}function pqdownheap(e,t,i){var a=e.heap[i];var r=i<<1;while(r<=e.heap_len){if(r<e.heap_len&&smaller(t,e.heap[r+1],e.heap[r],e.depth)){r++}if(smaller(t,a,e.heap[r],e.depth)){break}e.heap[i]=e.heap[r];i=r;r<<=1}e.heap[i]=a}function compress_block(e,t,i){var a;var r;var n=0;var s;var l;if(e.last_lit!==0){do{a=e.pending_buf[e.d_buf+n*2]<<8|e.pending_buf[e.d_buf+n*2+1];r=e.pending_buf[e.l_buf+n];n++;if(a===0){send_code(e,r,t)}else{s=N[r];send_code(e,s+c+1,t);l=x[s];if(l!==0){r-=D[s];send_bits(e,r,l)}a--;s=d_code(a);send_code(e,s,i);l=I[s];if(l!==0){a-=B[s];send_bits(e,a,l)}}}while(n<e.last_lit)}send_code(e,y,t)}function build_tree(e,t){var i=t.dyn_tree;var a=t.stat_desc.static_tree;var r=t.stat_desc.has_stree;var n=t.stat_desc.elems;var s,l;var f=-1;var o;e.heap_len=0;e.heap_max=p;for(s=0;s<n;s++){if(i[s*2]!==0){e.heap[++e.heap_len]=f=s;e.depth[s]=0}else{i[s*2+1]=0}}while(e.heap_len<2){o=e.heap[++e.heap_len]=f<2?++f:0;i[o*2]=1;e.depth[o]=0;e.opt_len--;if(r){e.static_len-=a[o*2+1]}}t.max_code=f;for(s=e.heap_len>>1;s>=1;s--){pqdownheap(e,i,s)}o=n;do{s=e.heap[1];e.heap[1]=e.heap[e.heap_len--];pqdownheap(e,i,1);l=e.heap[1];e.heap[--e.heap_max]=s;e.heap[--e.heap_max]=l;i[o*2]=i[s*2]+i[l*2];e.depth[o]=(e.depth[s]>=e.depth[l]?e.depth[s]:e.depth[l])+1;i[s*2+1]=i[l*2+1]=o;e.heap[1]=o++;pqdownheap(e,i,1)}while(e.heap_len>=2);e.heap[--e.heap_max]=e.heap[1];gen_bitlen(e,t);gen_codes(i,f,e.bl_count)}function scan_tree(e,t,i){var a;var r=-1;var n;var s=t[0*2+1];var l=0;var f=7;var o=4;if(s===0){f=138;o=3}t[(i+1)*2+1]=65535;for(a=0;a<=i;a++){n=s;s=t[(a+1)*2+1];if(++l<f&&n===s){continue}else if(l<o){e.bl_tree[n*2]+=l}else if(n!==0){if(n!==r){e.bl_tree[n*2]++}e.bl_tree[E*2]++}else if(l<=10){e.bl_tree[z*2]++}else{e.bl_tree[Z*2]++}l=0;r=n;if(s===0){f=138;o=3}else if(n===s){f=6;o=3}else{f=7;o=4}}}function send_tree(e,t,i){var a;var r=-1;var n;var s=t[0*2+1];var l=0;var f=7;var o=4;if(s===0){f=138;o=3}for(a=0;a<=i;a++){n=s;s=t[(a+1)*2+1];if(++l<f&&n===s){continue}else if(l<o){do{send_code(e,n,e.bl_tree)}while(--l!==0)}else if(n!==0){if(n!==r){send_code(e,n,e.bl_tree);l--}send_code(e,E,e.bl_tree);send_bits(e,l-3,2)}else if(l<=10){send_code(e,z,e.bl_tree);send_bits(e,l-3,3)}else{send_code(e,Z,e.bl_tree);send_bits(e,l-11,7)}l=0;r=n;if(s===0){f=138;o=3}else if(n===s){f=6;o=3}else{f=7;o=4}}}function build_bl_tree(e){var t;scan_tree(e,e.dyn_ltree,e.l_desc.max_code);scan_tree(e,e.dyn_dtree,e.d_desc.max_code);build_tree(e,e.bl_desc);for(t=w-1;t>=3;t--){if(e.bl_tree[S[t]*2+1]!==0){break}}e.opt_len+=3*(t+1)+5+5+4;return t}function send_all_trees(e,t,i,a){var r;send_bits(e,t-257,5);send_bits(e,i-1,5);send_bits(e,a-4,4);for(r=0;r<a;r++){send_bits(e,e.bl_tree[S[r]*2+1],3)}send_tree(e,e.dyn_ltree,t-1);send_tree(e,e.dyn_dtree,i-1)}function detect_data_type(e){var t=4093624447;var i;for(i=0;i<=31;i++,t>>>=1){if(t&1&&e.dyn_ltree[i*2]!==0){return n}}if(e.dyn_ltree[9*2]!==0||e.dyn_ltree[10*2]!==0||e.dyn_ltree[13*2]!==0){return s}for(i=32;i<c;i++){if(e.dyn_ltree[i*2]!==0){return s}}return n}var C=false;function _tr_init(e){if(!C){tr_static_init();C=true}e.l_desc=new TreeDesc(e.dyn_ltree,U);e.d_desc=new TreeDesc(e.dyn_dtree,O);e.bl_desc=new TreeDesc(e.bl_tree,M);e.bi_buf=0;e.bi_valid=0;init_block(e)}function _tr_stored_block(e,t,i,a){send_bits(e,(f<<1)+(a?1:0),3);copy_block(e,t,i,true)}function _tr_align(e){send_bits(e,o<<1,3);send_code(e,y,A);bi_flush(e)}function _tr_flush_block(e,t,i,a){var n,s;var f=0;if(e.level>0){if(e.strm.data_type===l){e.strm.data_type=detect_data_type(e)}build_tree(e,e.l_desc);build_tree(e,e.d_desc);f=build_bl_tree(e);n=e.opt_len+3+7>>>3;s=e.static_len+3+7>>>3;if(s<=n){n=s}}else{n=s=i+5}if(i+4<=n&&t!==-1){_tr_stored_block(e,t,i,a)}else if(e.strategy===r||s===n){send_bits(e,(o<<1)+(a?1:0),3);compress_block(e,A,T)}else{send_bits(e,(h<<1)+(a?1:0),3);send_all_trees(e,e.l_desc.max_code+1,e.d_desc.max_code+1,f+1);compress_block(e,e.dyn_ltree,e.dyn_dtree)}init_block(e);if(a){bi_windup(e)}}function _tr_tally(e,t,i){e.pending_buf[e.d_buf+e.last_lit*2]=t>>>8&255;e.pending_buf[e.d_buf+e.last_lit*2+1]=t&255;e.pending_buf[e.l_buf+e.last_lit]=i&255;e.last_lit++;if(t===0){e.dyn_ltree[i*2]++}else{e.matches++;t--;e.dyn_ltree[(N[i]+c+1)*2]++;e.dyn_dtree[d_code(t)*2]++}return e.last_lit===e.lit_bufsize-1}t._tr_init=_tr_init;t._tr_stored_block=_tr_stored_block;t._tr_flush_block=_tr_flush_block;t._tr_tally=_tr_tally;t._tr_align=_tr_align},562:function(e){function ZStream(){this.input=null;this.next_in=0;this.avail_in=0;this.total_in=0;this.output=null;this.next_out=0;this.avail_out=0;this.total_out=0;this.msg="";this.state=null;this.data_type=2;this.adler=0}e.exports=ZStream},491:function(e){e.exports=__webpack_require__(29774)},300:function(e){e.exports=__webpack_require__(55872)},781:function(e){e.exports=__webpack_require__(41296)},837:function(e){e.exports=__webpack_require__(93585)}};var t={};function __nccwpck_require__(i){var a=t[i];if(a!==undefined){return a.exports}var r=t[i]={exports:{}};var n=true;try{e[i](r,r.exports,__nccwpck_require__);n=false}finally{if(n)delete t[i]}return r.exports}if(typeof __nccwpck_require__!=="undefined")__nccwpck_require__.ab=__dirname+"/";var i=__nccwpck_require__(23);module.exports=i})();

/***/ }),

/***/ 39272:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var __dirname = "/";
(function(){var r={528:function(r,e,t){var o=t(685);var a=t(310);var i=r.exports;for(var n in o){if(o.hasOwnProperty(n))i[n]=o[n]}i.request=function(r,e){r=validateParams(r);return o.request.call(this,r,e)};i.get=function(r,e){r=validateParams(r);return o.get.call(this,r,e)};function validateParams(r){if(typeof r==="string"){r=a.parse(r)}if(!r.protocol){r.protocol="https:"}if(r.protocol!=="https:"){throw new Error('Protocol "'+r.protocol+'" not supported. Expected "https:"')}return r}},685:function(r){"use strict";r.exports=__webpack_require__(81442)},310:function(r){"use strict";r.exports=__webpack_require__(31522)}};var e={};function __nccwpck_require__(t){var o=e[t];if(o!==undefined){return o.exports}var a=e[t]={exports:{}};var i=true;try{r[t](a,a.exports,__nccwpck_require__);i=false}finally{if(i)delete e[t]}return a.exports}if(typeof __nccwpck_require__!=="undefined")__nccwpck_require__.ab=__dirname+"/";var t=__nccwpck_require__(528);module.exports=t})();

/***/ }),

/***/ 33370:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 90604:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 31522:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var __dirname = "/";
(function(){var e={477:function(e){"use strict";e.exports=__webpack_require__(97150)}};var t={};function __nccwpck_require__(o){var a=t[o];if(a!==undefined){return a.exports}var s=t[o]={exports:{}};var n=true;try{e[o](s,s.exports,__nccwpck_require__);n=false}finally{if(n)delete t[o]}return s.exports}if(typeof __nccwpck_require__!=="undefined")__nccwpck_require__.ab=__dirname+"/";var o={};!function(){var e=o;var t,a=(t=__nccwpck_require__(477))&&"object"==typeof t&&"default"in t?t.default:t,s=/https?|ftp|gopher|file/;function r(e){"string"==typeof e&&(e=d(e));var t=function(e,t,o){var a=e.auth,s=e.hostname,n=e.protocol||"",p=e.pathname||"",c=e.hash||"",i=e.query||"",u=!1;a=a?encodeURIComponent(a).replace(/%3A/i,":")+"@":"",e.host?u=a+e.host:s&&(u=a+(~s.indexOf(":")?"["+s+"]":s),e.port&&(u+=":"+e.port)),i&&"object"==typeof i&&(i=t.encode(i));var f=e.search||i&&"?"+i||"";return n&&":"!==n.substr(-1)&&(n+=":"),e.slashes||(!n||o.test(n))&&!1!==u?(u="//"+(u||""),p&&"/"!==p[0]&&(p="/"+p)):u||(u=""),c&&"#"!==c[0]&&(c="#"+c),f&&"?"!==f[0]&&(f="?"+f),{protocol:n,host:u,pathname:p=p.replace(/[?#]/g,encodeURIComponent),search:f=f.replace("#","%23"),hash:c}}(e,a,s);return""+t.protocol+t.host+t.pathname+t.search+t.hash}var n="http://",p="w.w",c=n+p,i=/^([a-z0-9.+-]*:\/\/\/)([a-z0-9.+-]:\/*)?/i,u=/https?|ftp|gopher|file/;function h(e,t){var o="string"==typeof e?d(e):e;e="object"==typeof e?r(e):e;var a=d(t),s="";o.protocol&&!o.slashes&&(s=o.protocol,e=e.replace(o.protocol,""),s+="/"===t[0]||"/"===e[0]?"/":""),s&&a.protocol&&(s="",a.slashes||(s=a.protocol,t=t.replace(a.protocol,"")));var p=e.match(i);p&&!a.protocol&&(e=e.substr((s=p[1]+(p[2]||"")).length),/^\/\/[^/]/.test(t)&&(s=s.slice(0,-1)));var f=new URL(e,c+"/"),m=new URL(t,f).toString().replace(c,""),v=a.protocol||o.protocol;return v+=o.slashes||a.slashes?"//":"",!s&&v?m=m.replace(n,v):s&&(m=m.replace(n,"")),u.test(m)||~t.indexOf(".")||"/"===e.slice(-1)||"/"===t.slice(-1)||"/"!==m.slice(-1)||(m=m.slice(0,-1)),s&&(m=s+("/"===m[0]?m.substr(1):m)),m}function l(){}l.prototype.parse=d,l.prototype.format=r,l.prototype.resolve=h,l.prototype.resolveObject=h;var f=/^https?|ftp|gopher|file/,m=/^(.*?)([#?].*)/,v=/^([a-z0-9.+-]*:)(\/{0,3})(.*)/i,_=/^([a-z0-9.+-]*:)?\/\/\/*/i,b=/^([a-z0-9.+-]*:)(\/{0,2})\[(.*)\]$/i;function d(e,t,o){if(void 0===t&&(t=!1),void 0===o&&(o=!1),e&&"object"==typeof e&&e instanceof l)return e;var s=(e=e.trim()).match(m);e=s?s[1].replace(/\\/g,"/")+s[2]:e.replace(/\\/g,"/"),b.test(e)&&"/"!==e.slice(-1)&&(e+="/");var n=!/(^javascript)/.test(e)&&e.match(v),i=_.test(e),u="";n&&(f.test(n[1])||(u=n[1].toLowerCase(),e=""+n[2]+n[3]),n[2]||(i=!1,f.test(n[1])?(u=n[1],e=""+n[3]):e="//"+n[3]),3!==n[2].length&&1!==n[2].length||(u=n[1],e="/"+n[3]));var g,y=(s?s[1]:e).match(/^https?:\/\/[^/]+(:[0-9]+)(?=\/|$)/),w=y&&y[1],C=new l,U="",j="";try{g=new URL(e)}catch(t){U=t,u||o||!/^\/\//.test(e)||/^\/\/.+[@.]/.test(e)||(j="/",e=e.substr(1));try{g=new URL(e,c)}catch(e){return C.protocol=u,C.href=u,C}}C.slashes=i&&!j,C.host=g.host===p?"":g.host,C.hostname=g.hostname===p?"":g.hostname.replace(/(\[|\])/g,""),C.protocol=U?u||null:g.protocol,C.search=g.search.replace(/\\/g,"%5C"),C.hash=g.hash.replace(/\\/g,"%5C");var x=e.split("#");!C.search&&~x[0].indexOf("?")&&(C.search="?"),C.hash||""!==x[1]||(C.hash="#"),C.query=t?a.decode(g.search.substr(1)):C.search.substr(1),C.pathname=j+(n?function(e){return e.replace(/['^|`]/g,(function(e){return"%"+e.charCodeAt().toString(16).toUpperCase()})).replace(/((?:%[0-9A-F]{2})+)/g,(function(e,t){try{return decodeURIComponent(t).split("").map((function(e){var t=e.charCodeAt();return t>256||/^[a-z0-9]$/i.test(e)?e:"%"+t.toString(16).toUpperCase()})).join("")}catch(e){return t}}))}(g.pathname):g.pathname),"about:"===C.protocol&&"blank"===C.pathname&&(C.protocol="",C.pathname=""),U&&"/"!==e[0]&&(C.pathname=C.pathname.substr(1)),u&&!f.test(u)&&"/"!==e.slice(-1)&&"/"===C.pathname&&(C.pathname=""),C.path=C.pathname+C.search,C.auth=[g.username,g.password].map(decodeURIComponent).filter(Boolean).join(":"),C.port=g.port,w&&!C.host.endsWith(w)&&(C.host+=w,C.port=w.slice(1)),C.href=j?""+C.pathname+C.search+C.hash:r(C);var q=/^(file)/.test(C.href)?["host","hostname"]:[];return Object.keys(C).forEach((function(e){~q.indexOf(e)||(C[e]=C[e]||null)})),C}e.parse=d,e.format=r,e.resolve=h,e.resolveObject=function(e,t){return d(h(e,t))},e.Url=l}();module.exports=o})();

/***/ }),

/***/ 25597:
/***/ (function(module) {

var __dirname = "/";
(function(){if(typeof __nccwpck_require__!=="undefined")__nccwpck_require__.ab=__dirname+"/";var n={};!function(){var e=n;e.endianness=function(){return"LE"};e.hostname=function(){if(typeof location!=="undefined"){return location.hostname}else return""};e.loadavg=function(){return[]};e.uptime=function(){return 0};e.freemem=function(){return Number.MAX_VALUE};e.totalmem=function(){return Number.MAX_VALUE};e.cpus=function(){return[]};e.type=function(){return"Browser"};e.release=function(){if(typeof navigator!=="undefined"){return navigator.appVersion}return""};e.networkInterfaces=e.getNetworkInterfaces=function(){return{}};e.arch=function(){return"javascript"};e.platform=function(){return"browser"};e.tmpdir=e.tmpDir=function(){return"/tmp"};e.EOL="\n";e.homedir=function(){return"/"}}();module.exports=n})();

/***/ }),

/***/ 69771:
/***/ (function(module) {

var __dirname = "/";
(function(){"use strict";var e={114:function(e){function assertPath(e){if(typeof e!=="string"){throw new TypeError("Path must be a string. Received "+JSON.stringify(e))}}function normalizeStringPosix(e,r){var t="";var i=0;var n=-1;var a=0;var f;for(var l=0;l<=e.length;++l){if(l<e.length)f=e.charCodeAt(l);else if(f===47)break;else f=47;if(f===47){if(n===l-1||a===1){}else if(n!==l-1&&a===2){if(t.length<2||i!==2||t.charCodeAt(t.length-1)!==46||t.charCodeAt(t.length-2)!==46){if(t.length>2){var s=t.lastIndexOf("/");if(s!==t.length-1){if(s===-1){t="";i=0}else{t=t.slice(0,s);i=t.length-1-t.lastIndexOf("/")}n=l;a=0;continue}}else if(t.length===2||t.length===1){t="";i=0;n=l;a=0;continue}}if(r){if(t.length>0)t+="/..";else t="..";i=2}}else{if(t.length>0)t+="/"+e.slice(n+1,l);else t=e.slice(n+1,l);i=l-n-1}n=l;a=0}else if(f===46&&a!==-1){++a}else{a=-1}}return t}function _format(e,r){var t=r.dir||r.root;var i=r.base||(r.name||"")+(r.ext||"");if(!t){return i}if(t===r.root){return t+i}return t+e+i}var r={resolve:function resolve(){var e="";var r=false;var t;for(var i=arguments.length-1;i>=-1&&!r;i--){var n;if(i>=0)n=arguments[i];else{if(t===undefined)t="";n=t}assertPath(n);if(n.length===0){continue}e=n+"/"+e;r=n.charCodeAt(0)===47}e=normalizeStringPosix(e,!r);if(r){if(e.length>0)return"/"+e;else return"/"}else if(e.length>0){return e}else{return"."}},normalize:function normalize(e){assertPath(e);if(e.length===0)return".";var r=e.charCodeAt(0)===47;var t=e.charCodeAt(e.length-1)===47;e=normalizeStringPosix(e,!r);if(e.length===0&&!r)e=".";if(e.length>0&&t)e+="/";if(r)return"/"+e;return e},isAbsolute:function isAbsolute(e){assertPath(e);return e.length>0&&e.charCodeAt(0)===47},join:function join(){if(arguments.length===0)return".";var e;for(var t=0;t<arguments.length;++t){var i=arguments[t];assertPath(i);if(i.length>0){if(e===undefined)e=i;else e+="/"+i}}if(e===undefined)return".";return r.normalize(e)},relative:function relative(e,t){assertPath(e);assertPath(t);if(e===t)return"";e=r.resolve(e);t=r.resolve(t);if(e===t)return"";var i=1;for(;i<e.length;++i){if(e.charCodeAt(i)!==47)break}var n=e.length;var a=n-i;var f=1;for(;f<t.length;++f){if(t.charCodeAt(f)!==47)break}var l=t.length;var s=l-f;var o=a<s?a:s;var u=-1;var h=0;for(;h<=o;++h){if(h===o){if(s>o){if(t.charCodeAt(f+h)===47){return t.slice(f+h+1)}else if(h===0){return t.slice(f+h)}}else if(a>o){if(e.charCodeAt(i+h)===47){u=h}else if(h===0){u=0}}break}var c=e.charCodeAt(i+h);var v=t.charCodeAt(f+h);if(c!==v)break;else if(c===47)u=h}var g="";for(h=i+u+1;h<=n;++h){if(h===n||e.charCodeAt(h)===47){if(g.length===0)g+="..";else g+="/.."}}if(g.length>0)return g+t.slice(f+u);else{f+=u;if(t.charCodeAt(f)===47)++f;return t.slice(f)}},_makeLong:function _makeLong(e){return e},dirname:function dirname(e){assertPath(e);if(e.length===0)return".";var r=e.charCodeAt(0);var t=r===47;var i=-1;var n=true;for(var a=e.length-1;a>=1;--a){r=e.charCodeAt(a);if(r===47){if(!n){i=a;break}}else{n=false}}if(i===-1)return t?"/":".";if(t&&i===1)return"//";return e.slice(0,i)},basename:function basename(e,r){if(r!==undefined&&typeof r!=="string")throw new TypeError('"ext" argument must be a string');assertPath(e);var t=0;var i=-1;var n=true;var a;if(r!==undefined&&r.length>0&&r.length<=e.length){if(r.length===e.length&&r===e)return"";var f=r.length-1;var l=-1;for(a=e.length-1;a>=0;--a){var s=e.charCodeAt(a);if(s===47){if(!n){t=a+1;break}}else{if(l===-1){n=false;l=a+1}if(f>=0){if(s===r.charCodeAt(f)){if(--f===-1){i=a}}else{f=-1;i=l}}}}if(t===i)i=l;else if(i===-1)i=e.length;return e.slice(t,i)}else{for(a=e.length-1;a>=0;--a){if(e.charCodeAt(a)===47){if(!n){t=a+1;break}}else if(i===-1){n=false;i=a+1}}if(i===-1)return"";return e.slice(t,i)}},extname:function extname(e){assertPath(e);var r=-1;var t=0;var i=-1;var n=true;var a=0;for(var f=e.length-1;f>=0;--f){var l=e.charCodeAt(f);if(l===47){if(!n){t=f+1;break}continue}if(i===-1){n=false;i=f+1}if(l===46){if(r===-1)r=f;else if(a!==1)a=1}else if(r!==-1){a=-1}}if(r===-1||i===-1||a===0||a===1&&r===i-1&&r===t+1){return""}return e.slice(r,i)},format:function format(e){if(e===null||typeof e!=="object"){throw new TypeError('The "pathObject" argument must be of type Object. Received type '+typeof e)}return _format("/",e)},parse:function parse(e){assertPath(e);var r={root:"",dir:"",base:"",ext:"",name:""};if(e.length===0)return r;var t=e.charCodeAt(0);var i=t===47;var n;if(i){r.root="/";n=1}else{n=0}var a=-1;var f=0;var l=-1;var s=true;var o=e.length-1;var u=0;for(;o>=n;--o){t=e.charCodeAt(o);if(t===47){if(!s){f=o+1;break}continue}if(l===-1){s=false;l=o+1}if(t===46){if(a===-1)a=o;else if(u!==1)u=1}else if(a!==-1){u=-1}}if(a===-1||l===-1||u===0||u===1&&a===l-1&&a===f+1){if(l!==-1){if(f===0&&i)r.base=r.name=e.slice(1,l);else r.base=r.name=e.slice(f,l)}}else{if(f===0&&i){r.name=e.slice(1,a);r.base=e.slice(1,l)}else{r.name=e.slice(f,a);r.base=e.slice(f,l)}r.ext=e.slice(a,l)}if(f>0)r.dir=e.slice(0,f-1);else if(i)r.dir="/";return r},sep:"/",delimiter:":",win32:null,posix:null};r.posix=r;e.exports=r}};var r={};function __nccwpck_require__(t){var i=r[t];if(i!==undefined){return i.exports}var n=r[t]={exports:{}};var a=true;try{e[t](n,n.exports,__nccwpck_require__);a=false}finally{if(a)delete r[t]}return n.exports}if(typeof __nccwpck_require__!=="undefined")__nccwpck_require__.ab=__dirname+"/";var t=__nccwpck_require__(114);module.exports=t})();

/***/ }),

/***/ 41296:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var __dirname = "/";
/* provided dependency */ var process = __webpack_require__(14224);
(function(){var e={782:function(e){if(typeof Object.create==="function"){e.exports=function inherits(e,t){if(t){e.super_=t;e.prototype=Object.create(t.prototype,{constructor:{value:e,enumerable:false,writable:true,configurable:true}})}}}else{e.exports=function inherits(e,t){if(t){e.super_=t;var TempCtor=function(){};TempCtor.prototype=t.prototype;e.prototype=new TempCtor;e.prototype.constructor=e}}}},646:function(e){"use strict";const t={};function createErrorType(e,r,n){if(!n){n=Error}function getMessage(e,t,n){if(typeof r==="string"){return r}else{return r(e,t,n)}}class NodeError extends n{constructor(e,t,r){super(getMessage(e,t,r))}}NodeError.prototype.name=n.name;NodeError.prototype.code=e;t[e]=NodeError}function oneOf(e,t){if(Array.isArray(e)){const r=e.length;e=e.map((e=>String(e)));if(r>2){return`one of ${t} ${e.slice(0,r-1).join(", ")}, or `+e[r-1]}else if(r===2){return`one of ${t} ${e[0]} or ${e[1]}`}else{return`of ${t} ${e[0]}`}}else{return`of ${t} ${String(e)}`}}function startsWith(e,t,r){return e.substr(!r||r<0?0:+r,t.length)===t}function endsWith(e,t,r){if(r===undefined||r>e.length){r=e.length}return e.substring(r-t.length,r)===t}function includes(e,t,r){if(typeof r!=="number"){r=0}if(r+t.length>e.length){return false}else{return e.indexOf(t,r)!==-1}}createErrorType("ERR_INVALID_OPT_VALUE",(function(e,t){return'The value "'+t+'" is invalid for option "'+e+'"'}),TypeError);createErrorType("ERR_INVALID_ARG_TYPE",(function(e,t,r){let n;if(typeof t==="string"&&startsWith(t,"not ")){n="must not be";t=t.replace(/^not /,"")}else{n="must be"}let i;if(endsWith(e," argument")){i=`The ${e} ${n} ${oneOf(t,"type")}`}else{const r=includes(e,".")?"property":"argument";i=`The "${e}" ${r} ${n} ${oneOf(t,"type")}`}i+=`. Received type ${typeof r}`;return i}),TypeError);createErrorType("ERR_STREAM_PUSH_AFTER_EOF","stream.push() after EOF");createErrorType("ERR_METHOD_NOT_IMPLEMENTED",(function(e){return"The "+e+" method is not implemented"}));createErrorType("ERR_STREAM_PREMATURE_CLOSE","Premature close");createErrorType("ERR_STREAM_DESTROYED",(function(e){return"Cannot call "+e+" after a stream was destroyed"}));createErrorType("ERR_MULTIPLE_CALLBACK","Callback called multiple times");createErrorType("ERR_STREAM_CANNOT_PIPE","Cannot pipe, not readable");createErrorType("ERR_STREAM_WRITE_AFTER_END","write after end");createErrorType("ERR_STREAM_NULL_VALUES","May not write null values to stream",TypeError);createErrorType("ERR_UNKNOWN_ENCODING",(function(e){return"Unknown encoding: "+e}),TypeError);createErrorType("ERR_STREAM_UNSHIFT_AFTER_END_EVENT","stream.unshift() after end event");e.exports.q=t},403:function(e,t,r){"use strict";var n=Object.keys||function(e){var t=[];for(var r in e){t.push(r)}return t};e.exports=Duplex;var i=r(709);var a=r(337);r(782)(Duplex,i);{var o=n(a.prototype);for(var s=0;s<o.length;s++){var f=o[s];if(!Duplex.prototype[f])Duplex.prototype[f]=a.prototype[f]}}function Duplex(e){if(!(this instanceof Duplex))return new Duplex(e);i.call(this,e);a.call(this,e);this.allowHalfOpen=true;if(e){if(e.readable===false)this.readable=false;if(e.writable===false)this.writable=false;if(e.allowHalfOpen===false){this.allowHalfOpen=false;this.once("end",onend)}}}Object.defineProperty(Duplex.prototype,"writableHighWaterMark",{enumerable:false,get:function get(){return this._writableState.highWaterMark}});Object.defineProperty(Duplex.prototype,"writableBuffer",{enumerable:false,get:function get(){return this._writableState&&this._writableState.getBuffer()}});Object.defineProperty(Duplex.prototype,"writableLength",{enumerable:false,get:function get(){return this._writableState.length}});function onend(){if(this._writableState.ended)return;process.nextTick(onEndNT,this)}function onEndNT(e){e.end()}Object.defineProperty(Duplex.prototype,"destroyed",{enumerable:false,get:function get(){if(this._readableState===undefined||this._writableState===undefined){return false}return this._readableState.destroyed&&this._writableState.destroyed},set:function set(e){if(this._readableState===undefined||this._writableState===undefined){return}this._readableState.destroyed=e;this._writableState.destroyed=e}})},889:function(e,t,r){"use strict";e.exports=PassThrough;var n=r(170);r(782)(PassThrough,n);function PassThrough(e){if(!(this instanceof PassThrough))return new PassThrough(e);n.call(this,e)}PassThrough.prototype._transform=function(e,t,r){r(null,e)}},709:function(e,t,r){"use strict";e.exports=Readable;var n;Readable.ReadableState=ReadableState;var i=r(361).EventEmitter;var a=function EElistenerCount(e,t){return e.listeners(t).length};var o=r(678);var s=r(300).Buffer;var f=__webpack_require__.g.Uint8Array||function(){};function _uint8ArrayToBuffer(e){return s.from(e)}function _isUint8Array(e){return s.isBuffer(e)||e instanceof f}var l=r(837);var u;if(l&&l.debuglog){u=l.debuglog("stream")}else{u=function debug(){}}var d=r(379);var c=r(25);var h=r(776),p=h.getHighWaterMark;var b=r(646).q,g=b.ERR_INVALID_ARG_TYPE,y=b.ERR_STREAM_PUSH_AFTER_EOF,_=b.ERR_METHOD_NOT_IMPLEMENTED,v=b.ERR_STREAM_UNSHIFT_AFTER_END_EVENT;var w;var m;var S;r(782)(Readable,o);var R=c.errorOrDestroy;var E=["error","close","destroy","pause","resume"];function prependListener(e,t,r){if(typeof e.prependListener==="function")return e.prependListener(t,r);if(!e._events||!e._events[t])e.on(t,r);else if(Array.isArray(e._events[t]))e._events[t].unshift(r);else e._events[t]=[r,e._events[t]]}function ReadableState(e,t,i){n=n||r(403);e=e||{};if(typeof i!=="boolean")i=t instanceof n;this.objectMode=!!e.objectMode;if(i)this.objectMode=this.objectMode||!!e.readableObjectMode;this.highWaterMark=p(this,e,"readableHighWaterMark",i);this.buffer=new d;this.length=0;this.pipes=null;this.pipesCount=0;this.flowing=null;this.ended=false;this.endEmitted=false;this.reading=false;this.sync=true;this.needReadable=false;this.emittedReadable=false;this.readableListening=false;this.resumeScheduled=false;this.paused=true;this.emitClose=e.emitClose!==false;this.autoDestroy=!!e.autoDestroy;this.destroyed=false;this.defaultEncoding=e.defaultEncoding||"utf8";this.awaitDrain=0;this.readingMore=false;this.decoder=null;this.encoding=null;if(e.encoding){if(!w)w=r(704).s;this.decoder=new w(e.encoding);this.encoding=e.encoding}}function Readable(e){n=n||r(403);if(!(this instanceof Readable))return new Readable(e);var t=this instanceof n;this._readableState=new ReadableState(e,this,t);this.readable=true;if(e){if(typeof e.read==="function")this._read=e.read;if(typeof e.destroy==="function")this._destroy=e.destroy}o.call(this)}Object.defineProperty(Readable.prototype,"destroyed",{enumerable:false,get:function get(){if(this._readableState===undefined){return false}return this._readableState.destroyed},set:function set(e){if(!this._readableState){return}this._readableState.destroyed=e}});Readable.prototype.destroy=c.destroy;Readable.prototype._undestroy=c.undestroy;Readable.prototype._destroy=function(e,t){t(e)};Readable.prototype.push=function(e,t){var r=this._readableState;var n;if(!r.objectMode){if(typeof e==="string"){t=t||r.defaultEncoding;if(t!==r.encoding){e=s.from(e,t);t=""}n=true}}else{n=true}return readableAddChunk(this,e,t,false,n)};Readable.prototype.unshift=function(e){return readableAddChunk(this,e,null,true,false)};function readableAddChunk(e,t,r,n,i){u("readableAddChunk",t);var a=e._readableState;if(t===null){a.reading=false;onEofChunk(e,a)}else{var o;if(!i)o=chunkInvalid(a,t);if(o){R(e,o)}else if(a.objectMode||t&&t.length>0){if(typeof t!=="string"&&!a.objectMode&&Object.getPrototypeOf(t)!==s.prototype){t=_uint8ArrayToBuffer(t)}if(n){if(a.endEmitted)R(e,new v);else addChunk(e,a,t,true)}else if(a.ended){R(e,new y)}else if(a.destroyed){return false}else{a.reading=false;if(a.decoder&&!r){t=a.decoder.write(t);if(a.objectMode||t.length!==0)addChunk(e,a,t,false);else maybeReadMore(e,a)}else{addChunk(e,a,t,false)}}}else if(!n){a.reading=false;maybeReadMore(e,a)}}return!a.ended&&(a.length<a.highWaterMark||a.length===0)}function addChunk(e,t,r,n){if(t.flowing&&t.length===0&&!t.sync){t.awaitDrain=0;e.emit("data",r)}else{t.length+=t.objectMode?1:r.length;if(n)t.buffer.unshift(r);else t.buffer.push(r);if(t.needReadable)emitReadable(e)}maybeReadMore(e,t)}function chunkInvalid(e,t){var r;if(!_isUint8Array(t)&&typeof t!=="string"&&t!==undefined&&!e.objectMode){r=new g("chunk",["string","Buffer","Uint8Array"],t)}return r}Readable.prototype.isPaused=function(){return this._readableState.flowing===false};Readable.prototype.setEncoding=function(e){if(!w)w=r(704).s;var t=new w(e);this._readableState.decoder=t;this._readableState.encoding=this._readableState.decoder.encoding;var n=this._readableState.buffer.head;var i="";while(n!==null){i+=t.write(n.data);n=n.next}this._readableState.buffer.clear();if(i!=="")this._readableState.buffer.push(i);this._readableState.length=i.length;return this};var T=1073741824;function computeNewHighWaterMark(e){if(e>=T){e=T}else{e--;e|=e>>>1;e|=e>>>2;e|=e>>>4;e|=e>>>8;e|=e>>>16;e++}return e}function howMuchToRead(e,t){if(e<=0||t.length===0&&t.ended)return 0;if(t.objectMode)return 1;if(e!==e){if(t.flowing&&t.length)return t.buffer.head.data.length;else return t.length}if(e>t.highWaterMark)t.highWaterMark=computeNewHighWaterMark(e);if(e<=t.length)return e;if(!t.ended){t.needReadable=true;return 0}return t.length}Readable.prototype.read=function(e){u("read",e);e=parseInt(e,10);var t=this._readableState;var r=e;if(e!==0)t.emittedReadable=false;if(e===0&&t.needReadable&&((t.highWaterMark!==0?t.length>=t.highWaterMark:t.length>0)||t.ended)){u("read: emitReadable",t.length,t.ended);if(t.length===0&&t.ended)endReadable(this);else emitReadable(this);return null}e=howMuchToRead(e,t);if(e===0&&t.ended){if(t.length===0)endReadable(this);return null}var n=t.needReadable;u("need readable",n);if(t.length===0||t.length-e<t.highWaterMark){n=true;u("length less than watermark",n)}if(t.ended||t.reading){n=false;u("reading or ended",n)}else if(n){u("do read");t.reading=true;t.sync=true;if(t.length===0)t.needReadable=true;this._read(t.highWaterMark);t.sync=false;if(!t.reading)e=howMuchToRead(r,t)}var i;if(e>0)i=fromList(e,t);else i=null;if(i===null){t.needReadable=t.length<=t.highWaterMark;e=0}else{t.length-=e;t.awaitDrain=0}if(t.length===0){if(!t.ended)t.needReadable=true;if(r!==e&&t.ended)endReadable(this)}if(i!==null)this.emit("data",i);return i};function onEofChunk(e,t){u("onEofChunk");if(t.ended)return;if(t.decoder){var r=t.decoder.end();if(r&&r.length){t.buffer.push(r);t.length+=t.objectMode?1:r.length}}t.ended=true;if(t.sync){emitReadable(e)}else{t.needReadable=false;if(!t.emittedReadable){t.emittedReadable=true;emitReadable_(e)}}}function emitReadable(e){var t=e._readableState;u("emitReadable",t.needReadable,t.emittedReadable);t.needReadable=false;if(!t.emittedReadable){u("emitReadable",t.flowing);t.emittedReadable=true;process.nextTick(emitReadable_,e)}}function emitReadable_(e){var t=e._readableState;u("emitReadable_",t.destroyed,t.length,t.ended);if(!t.destroyed&&(t.length||t.ended)){e.emit("readable");t.emittedReadable=false}t.needReadable=!t.flowing&&!t.ended&&t.length<=t.highWaterMark;flow(e)}function maybeReadMore(e,t){if(!t.readingMore){t.readingMore=true;process.nextTick(maybeReadMore_,e,t)}}function maybeReadMore_(e,t){while(!t.reading&&!t.ended&&(t.length<t.highWaterMark||t.flowing&&t.length===0)){var r=t.length;u("maybeReadMore read 0");e.read(0);if(r===t.length)break}t.readingMore=false}Readable.prototype._read=function(e){R(this,new _("_read()"))};Readable.prototype.pipe=function(e,t){var r=this;var n=this._readableState;switch(n.pipesCount){case 0:n.pipes=e;break;case 1:n.pipes=[n.pipes,e];break;default:n.pipes.push(e);break}n.pipesCount+=1;u("pipe count=%d opts=%j",n.pipesCount,t);var i=(!t||t.end!==false)&&e!==process.stdout&&e!==process.stderr;var o=i?onend:unpipe;if(n.endEmitted)process.nextTick(o);else r.once("end",o);e.on("unpipe",onunpipe);function onunpipe(e,t){u("onunpipe");if(e===r){if(t&&t.hasUnpiped===false){t.hasUnpiped=true;cleanup()}}}function onend(){u("onend");e.end()}var s=pipeOnDrain(r);e.on("drain",s);var f=false;function cleanup(){u("cleanup");e.removeListener("close",onclose);e.removeListener("finish",onfinish);e.removeListener("drain",s);e.removeListener("error",onerror);e.removeListener("unpipe",onunpipe);r.removeListener("end",onend);r.removeListener("end",unpipe);r.removeListener("data",ondata);f=true;if(n.awaitDrain&&(!e._writableState||e._writableState.needDrain))s()}r.on("data",ondata);function ondata(t){u("ondata");var i=e.write(t);u("dest.write",i);if(i===false){if((n.pipesCount===1&&n.pipes===e||n.pipesCount>1&&indexOf(n.pipes,e)!==-1)&&!f){u("false write response, pause",n.awaitDrain);n.awaitDrain++}r.pause()}}function onerror(t){u("onerror",t);unpipe();e.removeListener("error",onerror);if(a(e,"error")===0)R(e,t)}prependListener(e,"error",onerror);function onclose(){e.removeListener("finish",onfinish);unpipe()}e.once("close",onclose);function onfinish(){u("onfinish");e.removeListener("close",onclose);unpipe()}e.once("finish",onfinish);function unpipe(){u("unpipe");r.unpipe(e)}e.emit("pipe",r);if(!n.flowing){u("pipe resume");r.resume()}return e};function pipeOnDrain(e){return function pipeOnDrainFunctionResult(){var t=e._readableState;u("pipeOnDrain",t.awaitDrain);if(t.awaitDrain)t.awaitDrain--;if(t.awaitDrain===0&&a(e,"data")){t.flowing=true;flow(e)}}}Readable.prototype.unpipe=function(e){var t=this._readableState;var r={hasUnpiped:false};if(t.pipesCount===0)return this;if(t.pipesCount===1){if(e&&e!==t.pipes)return this;if(!e)e=t.pipes;t.pipes=null;t.pipesCount=0;t.flowing=false;if(e)e.emit("unpipe",this,r);return this}if(!e){var n=t.pipes;var i=t.pipesCount;t.pipes=null;t.pipesCount=0;t.flowing=false;for(var a=0;a<i;a++){n[a].emit("unpipe",this,{hasUnpiped:false})}return this}var o=indexOf(t.pipes,e);if(o===-1)return this;t.pipes.splice(o,1);t.pipesCount-=1;if(t.pipesCount===1)t.pipes=t.pipes[0];e.emit("unpipe",this,r);return this};Readable.prototype.on=function(e,t){var r=o.prototype.on.call(this,e,t);var n=this._readableState;if(e==="data"){n.readableListening=this.listenerCount("readable")>0;if(n.flowing!==false)this.resume()}else if(e==="readable"){if(!n.endEmitted&&!n.readableListening){n.readableListening=n.needReadable=true;n.flowing=false;n.emittedReadable=false;u("on readable",n.length,n.reading);if(n.length){emitReadable(this)}else if(!n.reading){process.nextTick(nReadingNextTick,this)}}}return r};Readable.prototype.addListener=Readable.prototype.on;Readable.prototype.removeListener=function(e,t){var r=o.prototype.removeListener.call(this,e,t);if(e==="readable"){process.nextTick(updateReadableListening,this)}return r};Readable.prototype.removeAllListeners=function(e){var t=o.prototype.removeAllListeners.apply(this,arguments);if(e==="readable"||e===undefined){process.nextTick(updateReadableListening,this)}return t};function updateReadableListening(e){var t=e._readableState;t.readableListening=e.listenerCount("readable")>0;if(t.resumeScheduled&&!t.paused){t.flowing=true}else if(e.listenerCount("data")>0){e.resume()}}function nReadingNextTick(e){u("readable nexttick read 0");e.read(0)}Readable.prototype.resume=function(){var e=this._readableState;if(!e.flowing){u("resume");e.flowing=!e.readableListening;resume(this,e)}e.paused=false;return this};function resume(e,t){if(!t.resumeScheduled){t.resumeScheduled=true;process.nextTick(resume_,e,t)}}function resume_(e,t){u("resume",t.reading);if(!t.reading){e.read(0)}t.resumeScheduled=false;e.emit("resume");flow(e);if(t.flowing&&!t.reading)e.read(0)}Readable.prototype.pause=function(){u("call pause flowing=%j",this._readableState.flowing);if(this._readableState.flowing!==false){u("pause");this._readableState.flowing=false;this.emit("pause")}this._readableState.paused=true;return this};function flow(e){var t=e._readableState;u("flow",t.flowing);while(t.flowing&&e.read()!==null){}}Readable.prototype.wrap=function(e){var t=this;var r=this._readableState;var n=false;e.on("end",(function(){u("wrapped end");if(r.decoder&&!r.ended){var e=r.decoder.end();if(e&&e.length)t.push(e)}t.push(null)}));e.on("data",(function(i){u("wrapped data");if(r.decoder)i=r.decoder.write(i);if(r.objectMode&&(i===null||i===undefined))return;else if(!r.objectMode&&(!i||!i.length))return;var a=t.push(i);if(!a){n=true;e.pause()}}));for(var i in e){if(this[i]===undefined&&typeof e[i]==="function"){this[i]=function methodWrap(t){return function methodWrapReturnFunction(){return e[t].apply(e,arguments)}}(i)}}for(var a=0;a<E.length;a++){e.on(E[a],this.emit.bind(this,E[a]))}this._read=function(t){u("wrapped _read",t);if(n){n=false;e.resume()}};return this};if(typeof Symbol==="function"){Readable.prototype[Symbol.asyncIterator]=function(){if(m===undefined){m=r(871)}return m(this)}}Object.defineProperty(Readable.prototype,"readableHighWaterMark",{enumerable:false,get:function get(){return this._readableState.highWaterMark}});Object.defineProperty(Readable.prototype,"readableBuffer",{enumerable:false,get:function get(){return this._readableState&&this._readableState.buffer}});Object.defineProperty(Readable.prototype,"readableFlowing",{enumerable:false,get:function get(){return this._readableState.flowing},set:function set(e){if(this._readableState){this._readableState.flowing=e}}});Readable._fromList=fromList;Object.defineProperty(Readable.prototype,"readableLength",{enumerable:false,get:function get(){return this._readableState.length}});function fromList(e,t){if(t.length===0)return null;var r;if(t.objectMode)r=t.buffer.shift();else if(!e||e>=t.length){if(t.decoder)r=t.buffer.join("");else if(t.buffer.length===1)r=t.buffer.first();else r=t.buffer.concat(t.length);t.buffer.clear()}else{r=t.buffer.consume(e,t.decoder)}return r}function endReadable(e){var t=e._readableState;u("endReadable",t.endEmitted);if(!t.endEmitted){t.ended=true;process.nextTick(endReadableNT,t,e)}}function endReadableNT(e,t){u("endReadableNT",e.endEmitted,e.length);if(!e.endEmitted&&e.length===0){e.endEmitted=true;t.readable=false;t.emit("end");if(e.autoDestroy){var r=t._writableState;if(!r||r.autoDestroy&&r.finished){t.destroy()}}}}if(typeof Symbol==="function"){Readable.from=function(e,t){if(S===undefined){S=r(727)}return S(Readable,e,t)}}function indexOf(e,t){for(var r=0,n=e.length;r<n;r++){if(e[r]===t)return r}return-1}},170:function(e,t,r){"use strict";e.exports=Transform;var n=r(646).q,i=n.ERR_METHOD_NOT_IMPLEMENTED,a=n.ERR_MULTIPLE_CALLBACK,o=n.ERR_TRANSFORM_ALREADY_TRANSFORMING,s=n.ERR_TRANSFORM_WITH_LENGTH_0;var f=r(403);r(782)(Transform,f);function afterTransform(e,t){var r=this._transformState;r.transforming=false;var n=r.writecb;if(n===null){return this.emit("error",new a)}r.writechunk=null;r.writecb=null;if(t!=null)this.push(t);n(e);var i=this._readableState;i.reading=false;if(i.needReadable||i.length<i.highWaterMark){this._read(i.highWaterMark)}}function Transform(e){if(!(this instanceof Transform))return new Transform(e);f.call(this,e);this._transformState={afterTransform:afterTransform.bind(this),needTransform:false,transforming:false,writecb:null,writechunk:null,writeencoding:null};this._readableState.needReadable=true;this._readableState.sync=false;if(e){if(typeof e.transform==="function")this._transform=e.transform;if(typeof e.flush==="function")this._flush=e.flush}this.on("prefinish",prefinish)}function prefinish(){var e=this;if(typeof this._flush==="function"&&!this._readableState.destroyed){this._flush((function(t,r){done(e,t,r)}))}else{done(this,null,null)}}Transform.prototype.push=function(e,t){this._transformState.needTransform=false;return f.prototype.push.call(this,e,t)};Transform.prototype._transform=function(e,t,r){r(new i("_transform()"))};Transform.prototype._write=function(e,t,r){var n=this._transformState;n.writecb=r;n.writechunk=e;n.writeencoding=t;if(!n.transforming){var i=this._readableState;if(n.needTransform||i.needReadable||i.length<i.highWaterMark)this._read(i.highWaterMark)}};Transform.prototype._read=function(e){var t=this._transformState;if(t.writechunk!==null&&!t.transforming){t.transforming=true;this._transform(t.writechunk,t.writeencoding,t.afterTransform)}else{t.needTransform=true}};Transform.prototype._destroy=function(e,t){f.prototype._destroy.call(this,e,(function(e){t(e)}))};function done(e,t,r){if(t)return e.emit("error",t);if(r!=null)e.push(r);if(e._writableState.length)throw new s;if(e._transformState.transforming)throw new o;return e.push(null)}},337:function(e,t,r){"use strict";e.exports=Writable;function WriteReq(e,t,r){this.chunk=e;this.encoding=t;this.callback=r;this.next=null}function CorkedRequest(e){var t=this;this.next=null;this.entry=null;this.finish=function(){onCorkedFinish(t,e)}}var n;Writable.WritableState=WritableState;var i={deprecate:r(769)};var a=r(678);var o=r(300).Buffer;var s=__webpack_require__.g.Uint8Array||function(){};function _uint8ArrayToBuffer(e){return o.from(e)}function _isUint8Array(e){return o.isBuffer(e)||e instanceof s}var f=r(25);var l=r(776),u=l.getHighWaterMark;var d=r(646).q,c=d.ERR_INVALID_ARG_TYPE,h=d.ERR_METHOD_NOT_IMPLEMENTED,p=d.ERR_MULTIPLE_CALLBACK,b=d.ERR_STREAM_CANNOT_PIPE,g=d.ERR_STREAM_DESTROYED,y=d.ERR_STREAM_NULL_VALUES,_=d.ERR_STREAM_WRITE_AFTER_END,v=d.ERR_UNKNOWN_ENCODING;var w=f.errorOrDestroy;r(782)(Writable,a);function nop(){}function WritableState(e,t,i){n=n||r(403);e=e||{};if(typeof i!=="boolean")i=t instanceof n;this.objectMode=!!e.objectMode;if(i)this.objectMode=this.objectMode||!!e.writableObjectMode;this.highWaterMark=u(this,e,"writableHighWaterMark",i);this.finalCalled=false;this.needDrain=false;this.ending=false;this.ended=false;this.finished=false;this.destroyed=false;var a=e.decodeStrings===false;this.decodeStrings=!a;this.defaultEncoding=e.defaultEncoding||"utf8";this.length=0;this.writing=false;this.corked=0;this.sync=true;this.bufferProcessing=false;this.onwrite=function(e){onwrite(t,e)};this.writecb=null;this.writelen=0;this.bufferedRequest=null;this.lastBufferedRequest=null;this.pendingcb=0;this.prefinished=false;this.errorEmitted=false;this.emitClose=e.emitClose!==false;this.autoDestroy=!!e.autoDestroy;this.bufferedRequestCount=0;this.corkedRequestsFree=new CorkedRequest(this)}WritableState.prototype.getBuffer=function getBuffer(){var e=this.bufferedRequest;var t=[];while(e){t.push(e);e=e.next}return t};(function(){try{Object.defineProperty(WritableState.prototype,"buffer",{get:i.deprecate((function writableStateBufferGetter(){return this.getBuffer()}),"_writableState.buffer is deprecated. Use _writableState.getBuffer "+"instead.","DEP0003")})}catch(e){}})();var m;if(typeof Symbol==="function"&&Symbol.hasInstance&&typeof Function.prototype[Symbol.hasInstance]==="function"){m=Function.prototype[Symbol.hasInstance];Object.defineProperty(Writable,Symbol.hasInstance,{value:function value(e){if(m.call(this,e))return true;if(this!==Writable)return false;return e&&e._writableState instanceof WritableState}})}else{m=function realHasInstance(e){return e instanceof this}}function Writable(e){n=n||r(403);var t=this instanceof n;if(!t&&!m.call(Writable,this))return new Writable(e);this._writableState=new WritableState(e,this,t);this.writable=true;if(e){if(typeof e.write==="function")this._write=e.write;if(typeof e.writev==="function")this._writev=e.writev;if(typeof e.destroy==="function")this._destroy=e.destroy;if(typeof e.final==="function")this._final=e.final}a.call(this)}Writable.prototype.pipe=function(){w(this,new b)};function writeAfterEnd(e,t){var r=new _;w(e,r);process.nextTick(t,r)}function validChunk(e,t,r,n){var i;if(r===null){i=new y}else if(typeof r!=="string"&&!t.objectMode){i=new c("chunk",["string","Buffer"],r)}if(i){w(e,i);process.nextTick(n,i);return false}return true}Writable.prototype.write=function(e,t,r){var n=this._writableState;var i=false;var a=!n.objectMode&&_isUint8Array(e);if(a&&!o.isBuffer(e)){e=_uint8ArrayToBuffer(e)}if(typeof t==="function"){r=t;t=null}if(a)t="buffer";else if(!t)t=n.defaultEncoding;if(typeof r!=="function")r=nop;if(n.ending)writeAfterEnd(this,r);else if(a||validChunk(this,n,e,r)){n.pendingcb++;i=writeOrBuffer(this,n,a,e,t,r)}return i};Writable.prototype.cork=function(){this._writableState.corked++};Writable.prototype.uncork=function(){var e=this._writableState;if(e.corked){e.corked--;if(!e.writing&&!e.corked&&!e.bufferProcessing&&e.bufferedRequest)clearBuffer(this,e)}};Writable.prototype.setDefaultEncoding=function setDefaultEncoding(e){if(typeof e==="string")e=e.toLowerCase();if(!(["hex","utf8","utf-8","ascii","binary","base64","ucs2","ucs-2","utf16le","utf-16le","raw"].indexOf((e+"").toLowerCase())>-1))throw new v(e);this._writableState.defaultEncoding=e;return this};Object.defineProperty(Writable.prototype,"writableBuffer",{enumerable:false,get:function get(){return this._writableState&&this._writableState.getBuffer()}});function decodeChunk(e,t,r){if(!e.objectMode&&e.decodeStrings!==false&&typeof t==="string"){t=o.from(t,r)}return t}Object.defineProperty(Writable.prototype,"writableHighWaterMark",{enumerable:false,get:function get(){return this._writableState.highWaterMark}});function writeOrBuffer(e,t,r,n,i,a){if(!r){var o=decodeChunk(t,n,i);if(n!==o){r=true;i="buffer";n=o}}var s=t.objectMode?1:n.length;t.length+=s;var f=t.length<t.highWaterMark;if(!f)t.needDrain=true;if(t.writing||t.corked){var l=t.lastBufferedRequest;t.lastBufferedRequest={chunk:n,encoding:i,isBuf:r,callback:a,next:null};if(l){l.next=t.lastBufferedRequest}else{t.bufferedRequest=t.lastBufferedRequest}t.bufferedRequestCount+=1}else{doWrite(e,t,false,s,n,i,a)}return f}function doWrite(e,t,r,n,i,a,o){t.writelen=n;t.writecb=o;t.writing=true;t.sync=true;if(t.destroyed)t.onwrite(new g("write"));else if(r)e._writev(i,t.onwrite);else e._write(i,a,t.onwrite);t.sync=false}function onwriteError(e,t,r,n,i){--t.pendingcb;if(r){process.nextTick(i,n);process.nextTick(finishMaybe,e,t);e._writableState.errorEmitted=true;w(e,n)}else{i(n);e._writableState.errorEmitted=true;w(e,n);finishMaybe(e,t)}}function onwriteStateUpdate(e){e.writing=false;e.writecb=null;e.length-=e.writelen;e.writelen=0}function onwrite(e,t){var r=e._writableState;var n=r.sync;var i=r.writecb;if(typeof i!=="function")throw new p;onwriteStateUpdate(r);if(t)onwriteError(e,r,n,t,i);else{var a=needFinish(r)||e.destroyed;if(!a&&!r.corked&&!r.bufferProcessing&&r.bufferedRequest){clearBuffer(e,r)}if(n){process.nextTick(afterWrite,e,r,a,i)}else{afterWrite(e,r,a,i)}}}function afterWrite(e,t,r,n){if(!r)onwriteDrain(e,t);t.pendingcb--;n();finishMaybe(e,t)}function onwriteDrain(e,t){if(t.length===0&&t.needDrain){t.needDrain=false;e.emit("drain")}}function clearBuffer(e,t){t.bufferProcessing=true;var r=t.bufferedRequest;if(e._writev&&r&&r.next){var n=t.bufferedRequestCount;var i=new Array(n);var a=t.corkedRequestsFree;a.entry=r;var o=0;var s=true;while(r){i[o]=r;if(!r.isBuf)s=false;r=r.next;o+=1}i.allBuffers=s;doWrite(e,t,true,t.length,i,"",a.finish);t.pendingcb++;t.lastBufferedRequest=null;if(a.next){t.corkedRequestsFree=a.next;a.next=null}else{t.corkedRequestsFree=new CorkedRequest(t)}t.bufferedRequestCount=0}else{while(r){var f=r.chunk;var l=r.encoding;var u=r.callback;var d=t.objectMode?1:f.length;doWrite(e,t,false,d,f,l,u);r=r.next;t.bufferedRequestCount--;if(t.writing){break}}if(r===null)t.lastBufferedRequest=null}t.bufferedRequest=r;t.bufferProcessing=false}Writable.prototype._write=function(e,t,r){r(new h("_write()"))};Writable.prototype._writev=null;Writable.prototype.end=function(e,t,r){var n=this._writableState;if(typeof e==="function"){r=e;e=null;t=null}else if(typeof t==="function"){r=t;t=null}if(e!==null&&e!==undefined)this.write(e,t);if(n.corked){n.corked=1;this.uncork()}if(!n.ending)endWritable(this,n,r);return this};Object.defineProperty(Writable.prototype,"writableLength",{enumerable:false,get:function get(){return this._writableState.length}});function needFinish(e){return e.ending&&e.length===0&&e.bufferedRequest===null&&!e.finished&&!e.writing}function callFinal(e,t){e._final((function(r){t.pendingcb--;if(r){w(e,r)}t.prefinished=true;e.emit("prefinish");finishMaybe(e,t)}))}function prefinish(e,t){if(!t.prefinished&&!t.finalCalled){if(typeof e._final==="function"&&!t.destroyed){t.pendingcb++;t.finalCalled=true;process.nextTick(callFinal,e,t)}else{t.prefinished=true;e.emit("prefinish")}}}function finishMaybe(e,t){var r=needFinish(t);if(r){prefinish(e,t);if(t.pendingcb===0){t.finished=true;e.emit("finish");if(t.autoDestroy){var n=e._readableState;if(!n||n.autoDestroy&&n.endEmitted){e.destroy()}}}}return r}function endWritable(e,t,r){t.ending=true;finishMaybe(e,t);if(r){if(t.finished)process.nextTick(r);else e.once("finish",r)}t.ended=true;e.writable=false}function onCorkedFinish(e,t,r){var n=e.entry;e.entry=null;while(n){var i=n.callback;t.pendingcb--;i(r);n=n.next}t.corkedRequestsFree.next=e}Object.defineProperty(Writable.prototype,"destroyed",{enumerable:false,get:function get(){if(this._writableState===undefined){return false}return this._writableState.destroyed},set:function set(e){if(!this._writableState){return}this._writableState.destroyed=e}});Writable.prototype.destroy=f.destroy;Writable.prototype._undestroy=f.undestroy;Writable.prototype._destroy=function(e,t){t(e)}},871:function(e,t,r){"use strict";var n;function _defineProperty(e,t,r){if(t in e){Object.defineProperty(e,t,{value:r,enumerable:true,configurable:true,writable:true})}else{e[t]=r}return e}var i=r(698);var a=Symbol("lastResolve");var o=Symbol("lastReject");var s=Symbol("error");var f=Symbol("ended");var l=Symbol("lastPromise");var u=Symbol("handlePromise");var d=Symbol("stream");function createIterResult(e,t){return{value:e,done:t}}function readAndResolve(e){var t=e[a];if(t!==null){var r=e[d].read();if(r!==null){e[l]=null;e[a]=null;e[o]=null;t(createIterResult(r,false))}}}function onReadable(e){process.nextTick(readAndResolve,e)}function wrapForNext(e,t){return function(r,n){e.then((function(){if(t[f]){r(createIterResult(undefined,true));return}t[u](r,n)}),n)}}var c=Object.getPrototypeOf((function(){}));var h=Object.setPrototypeOf((n={get stream(){return this[d]},next:function next(){var e=this;var t=this[s];if(t!==null){return Promise.reject(t)}if(this[f]){return Promise.resolve(createIterResult(undefined,true))}if(this[d].destroyed){return new Promise((function(t,r){process.nextTick((function(){if(e[s]){r(e[s])}else{t(createIterResult(undefined,true))}}))}))}var r=this[l];var n;if(r){n=new Promise(wrapForNext(r,this))}else{var i=this[d].read();if(i!==null){return Promise.resolve(createIterResult(i,false))}n=new Promise(this[u])}this[l]=n;return n}},_defineProperty(n,Symbol.asyncIterator,(function(){return this})),_defineProperty(n,"return",(function _return(){var e=this;return new Promise((function(t,r){e[d].destroy(null,(function(e){if(e){r(e);return}t(createIterResult(undefined,true))}))}))})),n),c);var p=function createReadableStreamAsyncIterator(e){var t;var r=Object.create(h,(t={},_defineProperty(t,d,{value:e,writable:true}),_defineProperty(t,a,{value:null,writable:true}),_defineProperty(t,o,{value:null,writable:true}),_defineProperty(t,s,{value:null,writable:true}),_defineProperty(t,f,{value:e._readableState.endEmitted,writable:true}),_defineProperty(t,u,{value:function value(e,t){var n=r[d].read();if(n){r[l]=null;r[a]=null;r[o]=null;e(createIterResult(n,false))}else{r[a]=e;r[o]=t}},writable:true}),t));r[l]=null;i(e,(function(e){if(e&&e.code!=="ERR_STREAM_PREMATURE_CLOSE"){var t=r[o];if(t!==null){r[l]=null;r[a]=null;r[o]=null;t(e)}r[s]=e;return}var n=r[a];if(n!==null){r[l]=null;r[a]=null;r[o]=null;n(createIterResult(undefined,true))}r[f]=true}));e.on("readable",onReadable.bind(null,r));return r};e.exports=p},379:function(e,t,r){"use strict";function ownKeys(e,t){var r=Object.keys(e);if(Object.getOwnPropertySymbols){var n=Object.getOwnPropertySymbols(e);if(t)n=n.filter((function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable}));r.push.apply(r,n)}return r}function _objectSpread(e){for(var t=1;t<arguments.length;t++){var r=arguments[t]!=null?arguments[t]:{};if(t%2){ownKeys(Object(r),true).forEach((function(t){_defineProperty(e,t,r[t])}))}else if(Object.getOwnPropertyDescriptors){Object.defineProperties(e,Object.getOwnPropertyDescriptors(r))}else{ownKeys(Object(r)).forEach((function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(r,t))}))}}return e}function _defineProperty(e,t,r){if(t in e){Object.defineProperty(e,t,{value:r,enumerable:true,configurable:true,writable:true})}else{e[t]=r}return e}function _classCallCheck(e,t){if(!(e instanceof t)){throw new TypeError("Cannot call a class as a function")}}function _defineProperties(e,t){for(var r=0;r<t.length;r++){var n=t[r];n.enumerable=n.enumerable||false;n.configurable=true;if("value"in n)n.writable=true;Object.defineProperty(e,n.key,n)}}function _createClass(e,t,r){if(t)_defineProperties(e.prototype,t);if(r)_defineProperties(e,r);return e}var n=r(300),i=n.Buffer;var a=r(837),o=a.inspect;var s=o&&o.custom||"inspect";function copyBuffer(e,t,r){i.prototype.copy.call(e,t,r)}e.exports=function(){function BufferList(){_classCallCheck(this,BufferList);this.head=null;this.tail=null;this.length=0}_createClass(BufferList,[{key:"push",value:function push(e){var t={data:e,next:null};if(this.length>0)this.tail.next=t;else this.head=t;this.tail=t;++this.length}},{key:"unshift",value:function unshift(e){var t={data:e,next:this.head};if(this.length===0)this.tail=t;this.head=t;++this.length}},{key:"shift",value:function shift(){if(this.length===0)return;var e=this.head.data;if(this.length===1)this.head=this.tail=null;else this.head=this.head.next;--this.length;return e}},{key:"clear",value:function clear(){this.head=this.tail=null;this.length=0}},{key:"join",value:function join(e){if(this.length===0)return"";var t=this.head;var r=""+t.data;while(t=t.next){r+=e+t.data}return r}},{key:"concat",value:function concat(e){if(this.length===0)return i.alloc(0);var t=i.allocUnsafe(e>>>0);var r=this.head;var n=0;while(r){copyBuffer(r.data,t,n);n+=r.data.length;r=r.next}return t}},{key:"consume",value:function consume(e,t){var r;if(e<this.head.data.length){r=this.head.data.slice(0,e);this.head.data=this.head.data.slice(e)}else if(e===this.head.data.length){r=this.shift()}else{r=t?this._getString(e):this._getBuffer(e)}return r}},{key:"first",value:function first(){return this.head.data}},{key:"_getString",value:function _getString(e){var t=this.head;var r=1;var n=t.data;e-=n.length;while(t=t.next){var i=t.data;var a=e>i.length?i.length:e;if(a===i.length)n+=i;else n+=i.slice(0,e);e-=a;if(e===0){if(a===i.length){++r;if(t.next)this.head=t.next;else this.head=this.tail=null}else{this.head=t;t.data=i.slice(a)}break}++r}this.length-=r;return n}},{key:"_getBuffer",value:function _getBuffer(e){var t=i.allocUnsafe(e);var r=this.head;var n=1;r.data.copy(t);e-=r.data.length;while(r=r.next){var a=r.data;var o=e>a.length?a.length:e;a.copy(t,t.length-e,0,o);e-=o;if(e===0){if(o===a.length){++n;if(r.next)this.head=r.next;else this.head=this.tail=null}else{this.head=r;r.data=a.slice(o)}break}++n}this.length-=n;return t}},{key:s,value:function value(e,t){return o(this,_objectSpread({},t,{depth:0,customInspect:false}))}}]);return BufferList}()},25:function(e){"use strict";function destroy(e,t){var r=this;var n=this._readableState&&this._readableState.destroyed;var i=this._writableState&&this._writableState.destroyed;if(n||i){if(t){t(e)}else if(e){if(!this._writableState){process.nextTick(emitErrorNT,this,e)}else if(!this._writableState.errorEmitted){this._writableState.errorEmitted=true;process.nextTick(emitErrorNT,this,e)}}return this}if(this._readableState){this._readableState.destroyed=true}if(this._writableState){this._writableState.destroyed=true}this._destroy(e||null,(function(e){if(!t&&e){if(!r._writableState){process.nextTick(emitErrorAndCloseNT,r,e)}else if(!r._writableState.errorEmitted){r._writableState.errorEmitted=true;process.nextTick(emitErrorAndCloseNT,r,e)}else{process.nextTick(emitCloseNT,r)}}else if(t){process.nextTick(emitCloseNT,r);t(e)}else{process.nextTick(emitCloseNT,r)}}));return this}function emitErrorAndCloseNT(e,t){emitErrorNT(e,t);emitCloseNT(e)}function emitCloseNT(e){if(e._writableState&&!e._writableState.emitClose)return;if(e._readableState&&!e._readableState.emitClose)return;e.emit("close")}function undestroy(){if(this._readableState){this._readableState.destroyed=false;this._readableState.reading=false;this._readableState.ended=false;this._readableState.endEmitted=false}if(this._writableState){this._writableState.destroyed=false;this._writableState.ended=false;this._writableState.ending=false;this._writableState.finalCalled=false;this._writableState.prefinished=false;this._writableState.finished=false;this._writableState.errorEmitted=false}}function emitErrorNT(e,t){e.emit("error",t)}function errorOrDestroy(e,t){var r=e._readableState;var n=e._writableState;if(r&&r.autoDestroy||n&&n.autoDestroy)e.destroy(t);else e.emit("error",t)}e.exports={destroy:destroy,undestroy:undestroy,errorOrDestroy:errorOrDestroy}},698:function(e,t,r){"use strict";var n=r(646).q.ERR_STREAM_PREMATURE_CLOSE;function once(e){var t=false;return function(){if(t)return;t=true;for(var r=arguments.length,n=new Array(r),i=0;i<r;i++){n[i]=arguments[i]}e.apply(this,n)}}function noop(){}function isRequest(e){return e.setHeader&&typeof e.abort==="function"}function eos(e,t,r){if(typeof t==="function")return eos(e,null,t);if(!t)t={};r=once(r||noop);var i=t.readable||t.readable!==false&&e.readable;var a=t.writable||t.writable!==false&&e.writable;var o=function onlegacyfinish(){if(!e.writable)f()};var s=e._writableState&&e._writableState.finished;var f=function onfinish(){a=false;s=true;if(!i)r.call(e)};var l=e._readableState&&e._readableState.endEmitted;var u=function onend(){i=false;l=true;if(!a)r.call(e)};var d=function onerror(t){r.call(e,t)};var c=function onclose(){var t;if(i&&!l){if(!e._readableState||!e._readableState.ended)t=new n;return r.call(e,t)}if(a&&!s){if(!e._writableState||!e._writableState.ended)t=new n;return r.call(e,t)}};var h=function onrequest(){e.req.on("finish",f)};if(isRequest(e)){e.on("complete",f);e.on("abort",c);if(e.req)h();else e.on("request",h)}else if(a&&!e._writableState){e.on("end",o);e.on("close",o)}e.on("end",u);e.on("finish",f);if(t.error!==false)e.on("error",d);e.on("close",c);return function(){e.removeListener("complete",f);e.removeListener("abort",c);e.removeListener("request",h);if(e.req)e.req.removeListener("finish",f);e.removeListener("end",o);e.removeListener("close",o);e.removeListener("finish",f);e.removeListener("end",u);e.removeListener("error",d);e.removeListener("close",c)}}e.exports=eos},727:function(e,t,r){"use strict";function asyncGeneratorStep(e,t,r,n,i,a,o){try{var s=e[a](o);var f=s.value}catch(e){r(e);return}if(s.done){t(f)}else{Promise.resolve(f).then(n,i)}}function _asyncToGenerator(e){return function(){var t=this,r=arguments;return new Promise((function(n,i){var a=e.apply(t,r);function _next(e){asyncGeneratorStep(a,n,i,_next,_throw,"next",e)}function _throw(e){asyncGeneratorStep(a,n,i,_next,_throw,"throw",e)}_next(undefined)}))}}function ownKeys(e,t){var r=Object.keys(e);if(Object.getOwnPropertySymbols){var n=Object.getOwnPropertySymbols(e);if(t)n=n.filter((function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable}));r.push.apply(r,n)}return r}function _objectSpread(e){for(var t=1;t<arguments.length;t++){var r=arguments[t]!=null?arguments[t]:{};if(t%2){ownKeys(Object(r),true).forEach((function(t){_defineProperty(e,t,r[t])}))}else if(Object.getOwnPropertyDescriptors){Object.defineProperties(e,Object.getOwnPropertyDescriptors(r))}else{ownKeys(Object(r)).forEach((function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(r,t))}))}}return e}function _defineProperty(e,t,r){if(t in e){Object.defineProperty(e,t,{value:r,enumerable:true,configurable:true,writable:true})}else{e[t]=r}return e}var n=r(646).q.ERR_INVALID_ARG_TYPE;function from(e,t,r){var i;if(t&&typeof t.next==="function"){i=t}else if(t&&t[Symbol.asyncIterator])i=t[Symbol.asyncIterator]();else if(t&&t[Symbol.iterator])i=t[Symbol.iterator]();else throw new n("iterable",["Iterable"],t);var a=new e(_objectSpread({objectMode:true},r));var o=false;a._read=function(){if(!o){o=true;next()}};function next(){return _next2.apply(this,arguments)}function _next2(){_next2=_asyncToGenerator((function*(){try{var e=yield i.next(),t=e.value,r=e.done;if(r){a.push(null)}else if(a.push(yield t)){next()}else{o=false}}catch(e){a.destroy(e)}}));return _next2.apply(this,arguments)}return a}e.exports=from},442:function(e,t,r){"use strict";var n;function once(e){var t=false;return function(){if(t)return;t=true;e.apply(void 0,arguments)}}var i=r(646).q,a=i.ERR_MISSING_ARGS,o=i.ERR_STREAM_DESTROYED;function noop(e){if(e)throw e}function isRequest(e){return e.setHeader&&typeof e.abort==="function"}function destroyer(e,t,i,a){a=once(a);var s=false;e.on("close",(function(){s=true}));if(n===undefined)n=r(698);n(e,{readable:t,writable:i},(function(e){if(e)return a(e);s=true;a()}));var f=false;return function(t){if(s)return;if(f)return;f=true;if(isRequest(e))return e.abort();if(typeof e.destroy==="function")return e.destroy();a(t||new o("pipe"))}}function call(e){e()}function pipe(e,t){return e.pipe(t)}function popCallback(e){if(!e.length)return noop;if(typeof e[e.length-1]!=="function")return noop;return e.pop()}function pipeline(){for(var e=arguments.length,t=new Array(e),r=0;r<e;r++){t[r]=arguments[r]}var n=popCallback(t);if(Array.isArray(t[0]))t=t[0];if(t.length<2){throw new a("streams")}var i;var o=t.map((function(e,r){var a=r<t.length-1;var s=r>0;return destroyer(e,a,s,(function(e){if(!i)i=e;if(e)o.forEach(call);if(a)return;o.forEach(call);n(i)}))}));return t.reduce(pipe)}e.exports=pipeline},776:function(e,t,r){"use strict";var n=r(646).q.ERR_INVALID_OPT_VALUE;function highWaterMarkFrom(e,t,r){return e.highWaterMark!=null?e.highWaterMark:t?e[r]:null}function getHighWaterMark(e,t,r,i){var a=highWaterMarkFrom(t,i,r);if(a!=null){if(!(isFinite(a)&&Math.floor(a)===a)||a<0){var o=i?r:"highWaterMark";throw new n(o,a)}return Math.floor(a)}return e.objectMode?16:16*1024}e.exports={getHighWaterMark:getHighWaterMark}},678:function(e,t,r){e.exports=r(781)},55:function(e,t,r){var n=r(300);var i=n.Buffer;function copyProps(e,t){for(var r in e){t[r]=e[r]}}if(i.from&&i.alloc&&i.allocUnsafe&&i.allocUnsafeSlow){e.exports=n}else{copyProps(n,t);t.Buffer=SafeBuffer}function SafeBuffer(e,t,r){return i(e,t,r)}SafeBuffer.prototype=Object.create(i.prototype);copyProps(i,SafeBuffer);SafeBuffer.from=function(e,t,r){if(typeof e==="number"){throw new TypeError("Argument must not be a number")}return i(e,t,r)};SafeBuffer.alloc=function(e,t,r){if(typeof e!=="number"){throw new TypeError("Argument must be a number")}var n=i(e);if(t!==undefined){if(typeof r==="string"){n.fill(t,r)}else{n.fill(t)}}else{n.fill(0)}return n};SafeBuffer.allocUnsafe=function(e){if(typeof e!=="number"){throw new TypeError("Argument must be a number")}return i(e)};SafeBuffer.allocUnsafeSlow=function(e){if(typeof e!=="number"){throw new TypeError("Argument must be a number")}return n.SlowBuffer(e)}},173:function(e,t,r){e.exports=Stream;var n=r(361).EventEmitter;var i=r(782);i(Stream,n);Stream.Readable=r(709);Stream.Writable=r(337);Stream.Duplex=r(403);Stream.Transform=r(170);Stream.PassThrough=r(889);Stream.finished=r(698);Stream.pipeline=r(442);Stream.Stream=Stream;function Stream(){n.call(this)}Stream.prototype.pipe=function(e,t){var r=this;function ondata(t){if(e.writable){if(false===e.write(t)&&r.pause){r.pause()}}}r.on("data",ondata);function ondrain(){if(r.readable&&r.resume){r.resume()}}e.on("drain",ondrain);if(!e._isStdio&&(!t||t.end!==false)){r.on("end",onend);r.on("close",onclose)}var i=false;function onend(){if(i)return;i=true;e.end()}function onclose(){if(i)return;i=true;if(typeof e.destroy==="function")e.destroy()}function onerror(e){cleanup();if(n.listenerCount(this,"error")===0){throw e}}r.on("error",onerror);e.on("error",onerror);function cleanup(){r.removeListener("data",ondata);e.removeListener("drain",ondrain);r.removeListener("end",onend);r.removeListener("close",onclose);r.removeListener("error",onerror);e.removeListener("error",onerror);r.removeListener("end",cleanup);r.removeListener("close",cleanup);e.removeListener("close",cleanup)}r.on("end",cleanup);r.on("close",cleanup);e.on("close",cleanup);e.emit("pipe",r);return e}},704:function(e,t,r){"use strict";var n=r(55).Buffer;var i=n.isEncoding||function(e){e=""+e;switch(e&&e.toLowerCase()){case"hex":case"utf8":case"utf-8":case"ascii":case"binary":case"base64":case"ucs2":case"ucs-2":case"utf16le":case"utf-16le":case"raw":return true;default:return false}};function _normalizeEncoding(e){if(!e)return"utf8";var t;while(true){switch(e){case"utf8":case"utf-8":return"utf8";case"ucs2":case"ucs-2":case"utf16le":case"utf-16le":return"utf16le";case"latin1":case"binary":return"latin1";case"base64":case"ascii":case"hex":return e;default:if(t)return;e=(""+e).toLowerCase();t=true}}}function normalizeEncoding(e){var t=_normalizeEncoding(e);if(typeof t!=="string"&&(n.isEncoding===i||!i(e)))throw new Error("Unknown encoding: "+e);return t||e}t.s=StringDecoder;function StringDecoder(e){this.encoding=normalizeEncoding(e);var t;switch(this.encoding){case"utf16le":this.text=utf16Text;this.end=utf16End;t=4;break;case"utf8":this.fillLast=utf8FillLast;t=4;break;case"base64":this.text=base64Text;this.end=base64End;t=3;break;default:this.write=simpleWrite;this.end=simpleEnd;return}this.lastNeed=0;this.lastTotal=0;this.lastChar=n.allocUnsafe(t)}StringDecoder.prototype.write=function(e){if(e.length===0)return"";var t;var r;if(this.lastNeed){t=this.fillLast(e);if(t===undefined)return"";r=this.lastNeed;this.lastNeed=0}else{r=0}if(r<e.length)return t?t+this.text(e,r):this.text(e,r);return t||""};StringDecoder.prototype.end=utf8End;StringDecoder.prototype.text=utf8Text;StringDecoder.prototype.fillLast=function(e){if(this.lastNeed<=e.length){e.copy(this.lastChar,this.lastTotal-this.lastNeed,0,this.lastNeed);return this.lastChar.toString(this.encoding,0,this.lastTotal)}e.copy(this.lastChar,this.lastTotal-this.lastNeed,0,e.length);this.lastNeed-=e.length};function utf8CheckByte(e){if(e<=127)return 0;else if(e>>5===6)return 2;else if(e>>4===14)return 3;else if(e>>3===30)return 4;return e>>6===2?-1:-2}function utf8CheckIncomplete(e,t,r){var n=t.length-1;if(n<r)return 0;var i=utf8CheckByte(t[n]);if(i>=0){if(i>0)e.lastNeed=i-1;return i}if(--n<r||i===-2)return 0;i=utf8CheckByte(t[n]);if(i>=0){if(i>0)e.lastNeed=i-2;return i}if(--n<r||i===-2)return 0;i=utf8CheckByte(t[n]);if(i>=0){if(i>0){if(i===2)i=0;else e.lastNeed=i-3}return i}return 0}function utf8CheckExtraBytes(e,t,r){if((t[0]&192)!==128){e.lastNeed=0;return"�"}if(e.lastNeed>1&&t.length>1){if((t[1]&192)!==128){e.lastNeed=1;return"�"}if(e.lastNeed>2&&t.length>2){if((t[2]&192)!==128){e.lastNeed=2;return"�"}}}}function utf8FillLast(e){var t=this.lastTotal-this.lastNeed;var r=utf8CheckExtraBytes(this,e,t);if(r!==undefined)return r;if(this.lastNeed<=e.length){e.copy(this.lastChar,t,0,this.lastNeed);return this.lastChar.toString(this.encoding,0,this.lastTotal)}e.copy(this.lastChar,t,0,e.length);this.lastNeed-=e.length}function utf8Text(e,t){var r=utf8CheckIncomplete(this,e,t);if(!this.lastNeed)return e.toString("utf8",t);this.lastTotal=r;var n=e.length-(r-this.lastNeed);e.copy(this.lastChar,0,n);return e.toString("utf8",t,n)}function utf8End(e){var t=e&&e.length?this.write(e):"";if(this.lastNeed)return t+"�";return t}function utf16Text(e,t){if((e.length-t)%2===0){var r=e.toString("utf16le",t);if(r){var n=r.charCodeAt(r.length-1);if(n>=55296&&n<=56319){this.lastNeed=2;this.lastTotal=4;this.lastChar[0]=e[e.length-2];this.lastChar[1]=e[e.length-1];return r.slice(0,-1)}}return r}this.lastNeed=1;this.lastTotal=2;this.lastChar[0]=e[e.length-1];return e.toString("utf16le",t,e.length-1)}function utf16End(e){var t=e&&e.length?this.write(e):"";if(this.lastNeed){var r=this.lastTotal-this.lastNeed;return t+this.lastChar.toString("utf16le",0,r)}return t}function base64Text(e,t){var r=(e.length-t)%3;if(r===0)return e.toString("base64",t);this.lastNeed=3-r;this.lastTotal=3;if(r===1){this.lastChar[0]=e[e.length-1]}else{this.lastChar[0]=e[e.length-2];this.lastChar[1]=e[e.length-1]}return e.toString("base64",t,e.length-r)}function base64End(e){var t=e&&e.length?this.write(e):"";if(this.lastNeed)return t+this.lastChar.toString("base64",0,3-this.lastNeed);return t}function simpleWrite(e){return e.toString(this.encoding)}function simpleEnd(e){return e&&e.length?this.write(e):""}},769:function(e){e.exports=deprecate;function deprecate(e,t){if(config("noDeprecation")){return e}var r=false;function deprecated(){if(!r){if(config("throwDeprecation")){throw new Error(t)}else if(config("traceDeprecation")){console.trace(t)}else{console.warn(t)}r=true}return e.apply(this,arguments)}return deprecated}function config(e){try{if(!__webpack_require__.g.localStorage)return false}catch(e){return false}var t=__webpack_require__.g.localStorage[e];if(null==t)return false;return String(t).toLowerCase()==="true"}},300:function(e){"use strict";e.exports=__webpack_require__(55872)},361:function(e){"use strict";e.exports=__webpack_require__(72100)},781:function(e){"use strict";e.exports=(__webpack_require__(72100).EventEmitter)},837:function(e){"use strict";e.exports=__webpack_require__(93585)}};var t={};function __nccwpck_require__(r){var n=t[r];if(n!==undefined){return n.exports}var i=t[r]={exports:{}};var a=true;try{e[r](i,i.exports,__nccwpck_require__);a=false}finally{if(a)delete t[r]}return i.exports}if(typeof __nccwpck_require__!=="undefined")__nccwpck_require__.ab=__dirname+"/";var r=__nccwpck_require__(173);module.exports=r})();

/***/ }),

/***/ 81442:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var __dirname = "/";
/* provided dependency */ var process = __webpack_require__(14224);
/* provided dependency */ var Buffer = __webpack_require__(55872)["Buffer"];
(function(){var e={523:function(e){e.exports={100:"Continue",101:"Switching Protocols",102:"Processing",200:"OK",201:"Created",202:"Accepted",203:"Non-Authoritative Information",204:"No Content",205:"Reset Content",206:"Partial Content",207:"Multi-Status",208:"Already Reported",226:"IM Used",300:"Multiple Choices",301:"Moved Permanently",302:"Found",303:"See Other",304:"Not Modified",305:"Use Proxy",307:"Temporary Redirect",308:"Permanent Redirect",400:"Bad Request",401:"Unauthorized",402:"Payment Required",403:"Forbidden",404:"Not Found",405:"Method Not Allowed",406:"Not Acceptable",407:"Proxy Authentication Required",408:"Request Timeout",409:"Conflict",410:"Gone",411:"Length Required",412:"Precondition Failed",413:"Payload Too Large",414:"URI Too Long",415:"Unsupported Media Type",416:"Range Not Satisfiable",417:"Expectation Failed",418:"I'm a teapot",421:"Misdirected Request",422:"Unprocessable Entity",423:"Locked",424:"Failed Dependency",425:"Unordered Collection",426:"Upgrade Required",428:"Precondition Required",429:"Too Many Requests",431:"Request Header Fields Too Large",451:"Unavailable For Legal Reasons",500:"Internal Server Error",501:"Not Implemented",502:"Bad Gateway",503:"Service Unavailable",504:"Gateway Timeout",505:"HTTP Version Not Supported",506:"Variant Also Negotiates",507:"Insufficient Storage",508:"Loop Detected",509:"Bandwidth Limit Exceeded",510:"Not Extended",511:"Network Authentication Required"}},782:function(e){if(typeof Object.create==="function"){e.exports=function inherits(e,t){if(t){e.super_=t;e.prototype=Object.create(t.prototype,{constructor:{value:e,enumerable:false,writable:true,configurable:true}})}}}else{e.exports=function inherits(e,t){if(t){e.super_=t;var TempCtor=function(){};TempCtor.prototype=t.prototype;e.prototype=new TempCtor;e.prototype.constructor=e}}}},646:function(e){"use strict";const t={};function createErrorType(e,r,n){if(!n){n=Error}function getMessage(e,t,n){if(typeof r==="string"){return r}else{return r(e,t,n)}}class NodeError extends n{constructor(e,t,r){super(getMessage(e,t,r))}}NodeError.prototype.name=n.name;NodeError.prototype.code=e;t[e]=NodeError}function oneOf(e,t){if(Array.isArray(e)){const r=e.length;e=e.map((e=>String(e)));if(r>2){return`one of ${t} ${e.slice(0,r-1).join(", ")}, or `+e[r-1]}else if(r===2){return`one of ${t} ${e[0]} or ${e[1]}`}else{return`of ${t} ${e[0]}`}}else{return`of ${t} ${String(e)}`}}function startsWith(e,t,r){return e.substr(!r||r<0?0:+r,t.length)===t}function endsWith(e,t,r){if(r===undefined||r>e.length){r=e.length}return e.substring(r-t.length,r)===t}function includes(e,t,r){if(typeof r!=="number"){r=0}if(r+t.length>e.length){return false}else{return e.indexOf(t,r)!==-1}}createErrorType("ERR_INVALID_OPT_VALUE",(function(e,t){return'The value "'+t+'" is invalid for option "'+e+'"'}),TypeError);createErrorType("ERR_INVALID_ARG_TYPE",(function(e,t,r){let n;if(typeof t==="string"&&startsWith(t,"not ")){n="must not be";t=t.replace(/^not /,"")}else{n="must be"}let i;if(endsWith(e," argument")){i=`The ${e} ${n} ${oneOf(t,"type")}`}else{const r=includes(e,".")?"property":"argument";i=`The "${e}" ${r} ${n} ${oneOf(t,"type")}`}i+=`. Received type ${typeof r}`;return i}),TypeError);createErrorType("ERR_STREAM_PUSH_AFTER_EOF","stream.push() after EOF");createErrorType("ERR_METHOD_NOT_IMPLEMENTED",(function(e){return"The "+e+" method is not implemented"}));createErrorType("ERR_STREAM_PREMATURE_CLOSE","Premature close");createErrorType("ERR_STREAM_DESTROYED",(function(e){return"Cannot call "+e+" after a stream was destroyed"}));createErrorType("ERR_MULTIPLE_CALLBACK","Callback called multiple times");createErrorType("ERR_STREAM_CANNOT_PIPE","Cannot pipe, not readable");createErrorType("ERR_STREAM_WRITE_AFTER_END","write after end");createErrorType("ERR_STREAM_NULL_VALUES","May not write null values to stream",TypeError);createErrorType("ERR_UNKNOWN_ENCODING",(function(e){return"Unknown encoding: "+e}),TypeError);createErrorType("ERR_STREAM_UNSHIFT_AFTER_END_EVENT","stream.unshift() after end event");e.exports.q=t},403:function(e,t,r){"use strict";var n=Object.keys||function(e){var t=[];for(var r in e){t.push(r)}return t};e.exports=Duplex;var i=r(709);var a=r(337);r(782)(Duplex,i);{var o=n(a.prototype);for(var s=0;s<o.length;s++){var f=o[s];if(!Duplex.prototype[f])Duplex.prototype[f]=a.prototype[f]}}function Duplex(e){if(!(this instanceof Duplex))return new Duplex(e);i.call(this,e);a.call(this,e);this.allowHalfOpen=true;if(e){if(e.readable===false)this.readable=false;if(e.writable===false)this.writable=false;if(e.allowHalfOpen===false){this.allowHalfOpen=false;this.once("end",onend)}}}Object.defineProperty(Duplex.prototype,"writableHighWaterMark",{enumerable:false,get:function get(){return this._writableState.highWaterMark}});Object.defineProperty(Duplex.prototype,"writableBuffer",{enumerable:false,get:function get(){return this._writableState&&this._writableState.getBuffer()}});Object.defineProperty(Duplex.prototype,"writableLength",{enumerable:false,get:function get(){return this._writableState.length}});function onend(){if(this._writableState.ended)return;process.nextTick(onEndNT,this)}function onEndNT(e){e.end()}Object.defineProperty(Duplex.prototype,"destroyed",{enumerable:false,get:function get(){if(this._readableState===undefined||this._writableState===undefined){return false}return this._readableState.destroyed&&this._writableState.destroyed},set:function set(e){if(this._readableState===undefined||this._writableState===undefined){return}this._readableState.destroyed=e;this._writableState.destroyed=e}})},889:function(e,t,r){"use strict";e.exports=PassThrough;var n=r(170);r(782)(PassThrough,n);function PassThrough(e){if(!(this instanceof PassThrough))return new PassThrough(e);n.call(this,e)}PassThrough.prototype._transform=function(e,t,r){r(null,e)}},709:function(e,t,r){"use strict";e.exports=Readable;var n;Readable.ReadableState=ReadableState;var i=r(361).EventEmitter;var a=function EElistenerCount(e,t){return e.listeners(t).length};var o=r(678);var s=r(300).Buffer;var f=__webpack_require__.g.Uint8Array||function(){};function _uint8ArrayToBuffer(e){return s.from(e)}function _isUint8Array(e){return s.isBuffer(e)||e instanceof f}var l=r(837);var u;if(l&&l.debuglog){u=l.debuglog("stream")}else{u=function debug(){}}var d=r(379);var c=r(25);var h=r(776),p=h.getHighWaterMark;var b=r(646).q,y=b.ERR_INVALID_ARG_TYPE,g=b.ERR_STREAM_PUSH_AFTER_EOF,_=b.ERR_METHOD_NOT_IMPLEMENTED,v=b.ERR_STREAM_UNSHIFT_AFTER_END_EVENT;var m;var w;var R;r(782)(Readable,o);var S=c.errorOrDestroy;var E=["error","close","destroy","pause","resume"];function prependListener(e,t,r){if(typeof e.prependListener==="function")return e.prependListener(t,r);if(!e._events||!e._events[t])e.on(t,r);else if(Array.isArray(e._events[t]))e._events[t].unshift(r);else e._events[t]=[r,e._events[t]]}function ReadableState(e,t,i){n=n||r(403);e=e||{};if(typeof i!=="boolean")i=t instanceof n;this.objectMode=!!e.objectMode;if(i)this.objectMode=this.objectMode||!!e.readableObjectMode;this.highWaterMark=p(this,e,"readableHighWaterMark",i);this.buffer=new d;this.length=0;this.pipes=null;this.pipesCount=0;this.flowing=null;this.ended=false;this.endEmitted=false;this.reading=false;this.sync=true;this.needReadable=false;this.emittedReadable=false;this.readableListening=false;this.resumeScheduled=false;this.paused=true;this.emitClose=e.emitClose!==false;this.autoDestroy=!!e.autoDestroy;this.destroyed=false;this.defaultEncoding=e.defaultEncoding||"utf8";this.awaitDrain=0;this.readingMore=false;this.decoder=null;this.encoding=null;if(e.encoding){if(!m)m=r(704).s;this.decoder=new m(e.encoding);this.encoding=e.encoding}}function Readable(e){n=n||r(403);if(!(this instanceof Readable))return new Readable(e);var t=this instanceof n;this._readableState=new ReadableState(e,this,t);this.readable=true;if(e){if(typeof e.read==="function")this._read=e.read;if(typeof e.destroy==="function")this._destroy=e.destroy}o.call(this)}Object.defineProperty(Readable.prototype,"destroyed",{enumerable:false,get:function get(){if(this._readableState===undefined){return false}return this._readableState.destroyed},set:function set(e){if(!this._readableState){return}this._readableState.destroyed=e}});Readable.prototype.destroy=c.destroy;Readable.prototype._undestroy=c.undestroy;Readable.prototype._destroy=function(e,t){t(e)};Readable.prototype.push=function(e,t){var r=this._readableState;var n;if(!r.objectMode){if(typeof e==="string"){t=t||r.defaultEncoding;if(t!==r.encoding){e=s.from(e,t);t=""}n=true}}else{n=true}return readableAddChunk(this,e,t,false,n)};Readable.prototype.unshift=function(e){return readableAddChunk(this,e,null,true,false)};function readableAddChunk(e,t,r,n,i){u("readableAddChunk",t);var a=e._readableState;if(t===null){a.reading=false;onEofChunk(e,a)}else{var o;if(!i)o=chunkInvalid(a,t);if(o){S(e,o)}else if(a.objectMode||t&&t.length>0){if(typeof t!=="string"&&!a.objectMode&&Object.getPrototypeOf(t)!==s.prototype){t=_uint8ArrayToBuffer(t)}if(n){if(a.endEmitted)S(e,new v);else addChunk(e,a,t,true)}else if(a.ended){S(e,new g)}else if(a.destroyed){return false}else{a.reading=false;if(a.decoder&&!r){t=a.decoder.write(t);if(a.objectMode||t.length!==0)addChunk(e,a,t,false);else maybeReadMore(e,a)}else{addChunk(e,a,t,false)}}}else if(!n){a.reading=false;maybeReadMore(e,a)}}return!a.ended&&(a.length<a.highWaterMark||a.length===0)}function addChunk(e,t,r,n){if(t.flowing&&t.length===0&&!t.sync){t.awaitDrain=0;e.emit("data",r)}else{t.length+=t.objectMode?1:r.length;if(n)t.buffer.unshift(r);else t.buffer.push(r);if(t.needReadable)emitReadable(e)}maybeReadMore(e,t)}function chunkInvalid(e,t){var r;if(!_isUint8Array(t)&&typeof t!=="string"&&t!==undefined&&!e.objectMode){r=new y("chunk",["string","Buffer","Uint8Array"],t)}return r}Readable.prototype.isPaused=function(){return this._readableState.flowing===false};Readable.prototype.setEncoding=function(e){if(!m)m=r(704).s;var t=new m(e);this._readableState.decoder=t;this._readableState.encoding=this._readableState.decoder.encoding;var n=this._readableState.buffer.head;var i="";while(n!==null){i+=t.write(n.data);n=n.next}this._readableState.buffer.clear();if(i!=="")this._readableState.buffer.push(i);this._readableState.length=i.length;return this};var T=1073741824;function computeNewHighWaterMark(e){if(e>=T){e=T}else{e--;e|=e>>>1;e|=e>>>2;e|=e>>>4;e|=e>>>8;e|=e>>>16;e++}return e}function howMuchToRead(e,t){if(e<=0||t.length===0&&t.ended)return 0;if(t.objectMode)return 1;if(e!==e){if(t.flowing&&t.length)return t.buffer.head.data.length;else return t.length}if(e>t.highWaterMark)t.highWaterMark=computeNewHighWaterMark(e);if(e<=t.length)return e;if(!t.ended){t.needReadable=true;return 0}return t.length}Readable.prototype.read=function(e){u("read",e);e=parseInt(e,10);var t=this._readableState;var r=e;if(e!==0)t.emittedReadable=false;if(e===0&&t.needReadable&&((t.highWaterMark!==0?t.length>=t.highWaterMark:t.length>0)||t.ended)){u("read: emitReadable",t.length,t.ended);if(t.length===0&&t.ended)endReadable(this);else emitReadable(this);return null}e=howMuchToRead(e,t);if(e===0&&t.ended){if(t.length===0)endReadable(this);return null}var n=t.needReadable;u("need readable",n);if(t.length===0||t.length-e<t.highWaterMark){n=true;u("length less than watermark",n)}if(t.ended||t.reading){n=false;u("reading or ended",n)}else if(n){u("do read");t.reading=true;t.sync=true;if(t.length===0)t.needReadable=true;this._read(t.highWaterMark);t.sync=false;if(!t.reading)e=howMuchToRead(r,t)}var i;if(e>0)i=fromList(e,t);else i=null;if(i===null){t.needReadable=t.length<=t.highWaterMark;e=0}else{t.length-=e;t.awaitDrain=0}if(t.length===0){if(!t.ended)t.needReadable=true;if(r!==e&&t.ended)endReadable(this)}if(i!==null)this.emit("data",i);return i};function onEofChunk(e,t){u("onEofChunk");if(t.ended)return;if(t.decoder){var r=t.decoder.end();if(r&&r.length){t.buffer.push(r);t.length+=t.objectMode?1:r.length}}t.ended=true;if(t.sync){emitReadable(e)}else{t.needReadable=false;if(!t.emittedReadable){t.emittedReadable=true;emitReadable_(e)}}}function emitReadable(e){var t=e._readableState;u("emitReadable",t.needReadable,t.emittedReadable);t.needReadable=false;if(!t.emittedReadable){u("emitReadable",t.flowing);t.emittedReadable=true;process.nextTick(emitReadable_,e)}}function emitReadable_(e){var t=e._readableState;u("emitReadable_",t.destroyed,t.length,t.ended);if(!t.destroyed&&(t.length||t.ended)){e.emit("readable");t.emittedReadable=false}t.needReadable=!t.flowing&&!t.ended&&t.length<=t.highWaterMark;flow(e)}function maybeReadMore(e,t){if(!t.readingMore){t.readingMore=true;process.nextTick(maybeReadMore_,e,t)}}function maybeReadMore_(e,t){while(!t.reading&&!t.ended&&(t.length<t.highWaterMark||t.flowing&&t.length===0)){var r=t.length;u("maybeReadMore read 0");e.read(0);if(r===t.length)break}t.readingMore=false}Readable.prototype._read=function(e){S(this,new _("_read()"))};Readable.prototype.pipe=function(e,t){var r=this;var n=this._readableState;switch(n.pipesCount){case 0:n.pipes=e;break;case 1:n.pipes=[n.pipes,e];break;default:n.pipes.push(e);break}n.pipesCount+=1;u("pipe count=%d opts=%j",n.pipesCount,t);var i=(!t||t.end!==false)&&e!==process.stdout&&e!==process.stderr;var o=i?onend:unpipe;if(n.endEmitted)process.nextTick(o);else r.once("end",o);e.on("unpipe",onunpipe);function onunpipe(e,t){u("onunpipe");if(e===r){if(t&&t.hasUnpiped===false){t.hasUnpiped=true;cleanup()}}}function onend(){u("onend");e.end()}var s=pipeOnDrain(r);e.on("drain",s);var f=false;function cleanup(){u("cleanup");e.removeListener("close",onclose);e.removeListener("finish",onfinish);e.removeListener("drain",s);e.removeListener("error",onerror);e.removeListener("unpipe",onunpipe);r.removeListener("end",onend);r.removeListener("end",unpipe);r.removeListener("data",ondata);f=true;if(n.awaitDrain&&(!e._writableState||e._writableState.needDrain))s()}r.on("data",ondata);function ondata(t){u("ondata");var i=e.write(t);u("dest.write",i);if(i===false){if((n.pipesCount===1&&n.pipes===e||n.pipesCount>1&&indexOf(n.pipes,e)!==-1)&&!f){u("false write response, pause",n.awaitDrain);n.awaitDrain++}r.pause()}}function onerror(t){u("onerror",t);unpipe();e.removeListener("error",onerror);if(a(e,"error")===0)S(e,t)}prependListener(e,"error",onerror);function onclose(){e.removeListener("finish",onfinish);unpipe()}e.once("close",onclose);function onfinish(){u("onfinish");e.removeListener("close",onclose);unpipe()}e.once("finish",onfinish);function unpipe(){u("unpipe");r.unpipe(e)}e.emit("pipe",r);if(!n.flowing){u("pipe resume");r.resume()}return e};function pipeOnDrain(e){return function pipeOnDrainFunctionResult(){var t=e._readableState;u("pipeOnDrain",t.awaitDrain);if(t.awaitDrain)t.awaitDrain--;if(t.awaitDrain===0&&a(e,"data")){t.flowing=true;flow(e)}}}Readable.prototype.unpipe=function(e){var t=this._readableState;var r={hasUnpiped:false};if(t.pipesCount===0)return this;if(t.pipesCount===1){if(e&&e!==t.pipes)return this;if(!e)e=t.pipes;t.pipes=null;t.pipesCount=0;t.flowing=false;if(e)e.emit("unpipe",this,r);return this}if(!e){var n=t.pipes;var i=t.pipesCount;t.pipes=null;t.pipesCount=0;t.flowing=false;for(var a=0;a<i;a++){n[a].emit("unpipe",this,{hasUnpiped:false})}return this}var o=indexOf(t.pipes,e);if(o===-1)return this;t.pipes.splice(o,1);t.pipesCount-=1;if(t.pipesCount===1)t.pipes=t.pipes[0];e.emit("unpipe",this,r);return this};Readable.prototype.on=function(e,t){var r=o.prototype.on.call(this,e,t);var n=this._readableState;if(e==="data"){n.readableListening=this.listenerCount("readable")>0;if(n.flowing!==false)this.resume()}else if(e==="readable"){if(!n.endEmitted&&!n.readableListening){n.readableListening=n.needReadable=true;n.flowing=false;n.emittedReadable=false;u("on readable",n.length,n.reading);if(n.length){emitReadable(this)}else if(!n.reading){process.nextTick(nReadingNextTick,this)}}}return r};Readable.prototype.addListener=Readable.prototype.on;Readable.prototype.removeListener=function(e,t){var r=o.prototype.removeListener.call(this,e,t);if(e==="readable"){process.nextTick(updateReadableListening,this)}return r};Readable.prototype.removeAllListeners=function(e){var t=o.prototype.removeAllListeners.apply(this,arguments);if(e==="readable"||e===undefined){process.nextTick(updateReadableListening,this)}return t};function updateReadableListening(e){var t=e._readableState;t.readableListening=e.listenerCount("readable")>0;if(t.resumeScheduled&&!t.paused){t.flowing=true}else if(e.listenerCount("data")>0){e.resume()}}function nReadingNextTick(e){u("readable nexttick read 0");e.read(0)}Readable.prototype.resume=function(){var e=this._readableState;if(!e.flowing){u("resume");e.flowing=!e.readableListening;resume(this,e)}e.paused=false;return this};function resume(e,t){if(!t.resumeScheduled){t.resumeScheduled=true;process.nextTick(resume_,e,t)}}function resume_(e,t){u("resume",t.reading);if(!t.reading){e.read(0)}t.resumeScheduled=false;e.emit("resume");flow(e);if(t.flowing&&!t.reading)e.read(0)}Readable.prototype.pause=function(){u("call pause flowing=%j",this._readableState.flowing);if(this._readableState.flowing!==false){u("pause");this._readableState.flowing=false;this.emit("pause")}this._readableState.paused=true;return this};function flow(e){var t=e._readableState;u("flow",t.flowing);while(t.flowing&&e.read()!==null){}}Readable.prototype.wrap=function(e){var t=this;var r=this._readableState;var n=false;e.on("end",(function(){u("wrapped end");if(r.decoder&&!r.ended){var e=r.decoder.end();if(e&&e.length)t.push(e)}t.push(null)}));e.on("data",(function(i){u("wrapped data");if(r.decoder)i=r.decoder.write(i);if(r.objectMode&&(i===null||i===undefined))return;else if(!r.objectMode&&(!i||!i.length))return;var a=t.push(i);if(!a){n=true;e.pause()}}));for(var i in e){if(this[i]===undefined&&typeof e[i]==="function"){this[i]=function methodWrap(t){return function methodWrapReturnFunction(){return e[t].apply(e,arguments)}}(i)}}for(var a=0;a<E.length;a++){e.on(E[a],this.emit.bind(this,E[a]))}this._read=function(t){u("wrapped _read",t);if(n){n=false;e.resume()}};return this};if(typeof Symbol==="function"){Readable.prototype[Symbol.asyncIterator]=function(){if(w===undefined){w=r(871)}return w(this)}}Object.defineProperty(Readable.prototype,"readableHighWaterMark",{enumerable:false,get:function get(){return this._readableState.highWaterMark}});Object.defineProperty(Readable.prototype,"readableBuffer",{enumerable:false,get:function get(){return this._readableState&&this._readableState.buffer}});Object.defineProperty(Readable.prototype,"readableFlowing",{enumerable:false,get:function get(){return this._readableState.flowing},set:function set(e){if(this._readableState){this._readableState.flowing=e}}});Readable._fromList=fromList;Object.defineProperty(Readable.prototype,"readableLength",{enumerable:false,get:function get(){return this._readableState.length}});function fromList(e,t){if(t.length===0)return null;var r;if(t.objectMode)r=t.buffer.shift();else if(!e||e>=t.length){if(t.decoder)r=t.buffer.join("");else if(t.buffer.length===1)r=t.buffer.first();else r=t.buffer.concat(t.length);t.buffer.clear()}else{r=t.buffer.consume(e,t.decoder)}return r}function endReadable(e){var t=e._readableState;u("endReadable",t.endEmitted);if(!t.endEmitted){t.ended=true;process.nextTick(endReadableNT,t,e)}}function endReadableNT(e,t){u("endReadableNT",e.endEmitted,e.length);if(!e.endEmitted&&e.length===0){e.endEmitted=true;t.readable=false;t.emit("end");if(e.autoDestroy){var r=t._writableState;if(!r||r.autoDestroy&&r.finished){t.destroy()}}}}if(typeof Symbol==="function"){Readable.from=function(e,t){if(R===undefined){R=r(727)}return R(Readable,e,t)}}function indexOf(e,t){for(var r=0,n=e.length;r<n;r++){if(e[r]===t)return r}return-1}},170:function(e,t,r){"use strict";e.exports=Transform;var n=r(646).q,i=n.ERR_METHOD_NOT_IMPLEMENTED,a=n.ERR_MULTIPLE_CALLBACK,o=n.ERR_TRANSFORM_ALREADY_TRANSFORMING,s=n.ERR_TRANSFORM_WITH_LENGTH_0;var f=r(403);r(782)(Transform,f);function afterTransform(e,t){var r=this._transformState;r.transforming=false;var n=r.writecb;if(n===null){return this.emit("error",new a)}r.writechunk=null;r.writecb=null;if(t!=null)this.push(t);n(e);var i=this._readableState;i.reading=false;if(i.needReadable||i.length<i.highWaterMark){this._read(i.highWaterMark)}}function Transform(e){if(!(this instanceof Transform))return new Transform(e);f.call(this,e);this._transformState={afterTransform:afterTransform.bind(this),needTransform:false,transforming:false,writecb:null,writechunk:null,writeencoding:null};this._readableState.needReadable=true;this._readableState.sync=false;if(e){if(typeof e.transform==="function")this._transform=e.transform;if(typeof e.flush==="function")this._flush=e.flush}this.on("prefinish",prefinish)}function prefinish(){var e=this;if(typeof this._flush==="function"&&!this._readableState.destroyed){this._flush((function(t,r){done(e,t,r)}))}else{done(this,null,null)}}Transform.prototype.push=function(e,t){this._transformState.needTransform=false;return f.prototype.push.call(this,e,t)};Transform.prototype._transform=function(e,t,r){r(new i("_transform()"))};Transform.prototype._write=function(e,t,r){var n=this._transformState;n.writecb=r;n.writechunk=e;n.writeencoding=t;if(!n.transforming){var i=this._readableState;if(n.needTransform||i.needReadable||i.length<i.highWaterMark)this._read(i.highWaterMark)}};Transform.prototype._read=function(e){var t=this._transformState;if(t.writechunk!==null&&!t.transforming){t.transforming=true;this._transform(t.writechunk,t.writeencoding,t.afterTransform)}else{t.needTransform=true}};Transform.prototype._destroy=function(e,t){f.prototype._destroy.call(this,e,(function(e){t(e)}))};function done(e,t,r){if(t)return e.emit("error",t);if(r!=null)e.push(r);if(e._writableState.length)throw new s;if(e._transformState.transforming)throw new o;return e.push(null)}},337:function(e,t,r){"use strict";e.exports=Writable;function WriteReq(e,t,r){this.chunk=e;this.encoding=t;this.callback=r;this.next=null}function CorkedRequest(e){var t=this;this.next=null;this.entry=null;this.finish=function(){onCorkedFinish(t,e)}}var n;Writable.WritableState=WritableState;var i={deprecate:r(769)};var a=r(678);var o=r(300).Buffer;var s=__webpack_require__.g.Uint8Array||function(){};function _uint8ArrayToBuffer(e){return o.from(e)}function _isUint8Array(e){return o.isBuffer(e)||e instanceof s}var f=r(25);var l=r(776),u=l.getHighWaterMark;var d=r(646).q,c=d.ERR_INVALID_ARG_TYPE,h=d.ERR_METHOD_NOT_IMPLEMENTED,p=d.ERR_MULTIPLE_CALLBACK,b=d.ERR_STREAM_CANNOT_PIPE,y=d.ERR_STREAM_DESTROYED,g=d.ERR_STREAM_NULL_VALUES,_=d.ERR_STREAM_WRITE_AFTER_END,v=d.ERR_UNKNOWN_ENCODING;var m=f.errorOrDestroy;r(782)(Writable,a);function nop(){}function WritableState(e,t,i){n=n||r(403);e=e||{};if(typeof i!=="boolean")i=t instanceof n;this.objectMode=!!e.objectMode;if(i)this.objectMode=this.objectMode||!!e.writableObjectMode;this.highWaterMark=u(this,e,"writableHighWaterMark",i);this.finalCalled=false;this.needDrain=false;this.ending=false;this.ended=false;this.finished=false;this.destroyed=false;var a=e.decodeStrings===false;this.decodeStrings=!a;this.defaultEncoding=e.defaultEncoding||"utf8";this.length=0;this.writing=false;this.corked=0;this.sync=true;this.bufferProcessing=false;this.onwrite=function(e){onwrite(t,e)};this.writecb=null;this.writelen=0;this.bufferedRequest=null;this.lastBufferedRequest=null;this.pendingcb=0;this.prefinished=false;this.errorEmitted=false;this.emitClose=e.emitClose!==false;this.autoDestroy=!!e.autoDestroy;this.bufferedRequestCount=0;this.corkedRequestsFree=new CorkedRequest(this)}WritableState.prototype.getBuffer=function getBuffer(){var e=this.bufferedRequest;var t=[];while(e){t.push(e);e=e.next}return t};(function(){try{Object.defineProperty(WritableState.prototype,"buffer",{get:i.deprecate((function writableStateBufferGetter(){return this.getBuffer()}),"_writableState.buffer is deprecated. Use _writableState.getBuffer "+"instead.","DEP0003")})}catch(e){}})();var w;if(typeof Symbol==="function"&&Symbol.hasInstance&&typeof Function.prototype[Symbol.hasInstance]==="function"){w=Function.prototype[Symbol.hasInstance];Object.defineProperty(Writable,Symbol.hasInstance,{value:function value(e){if(w.call(this,e))return true;if(this!==Writable)return false;return e&&e._writableState instanceof WritableState}})}else{w=function realHasInstance(e){return e instanceof this}}function Writable(e){n=n||r(403);var t=this instanceof n;if(!t&&!w.call(Writable,this))return new Writable(e);this._writableState=new WritableState(e,this,t);this.writable=true;if(e){if(typeof e.write==="function")this._write=e.write;if(typeof e.writev==="function")this._writev=e.writev;if(typeof e.destroy==="function")this._destroy=e.destroy;if(typeof e.final==="function")this._final=e.final}a.call(this)}Writable.prototype.pipe=function(){m(this,new b)};function writeAfterEnd(e,t){var r=new _;m(e,r);process.nextTick(t,r)}function validChunk(e,t,r,n){var i;if(r===null){i=new g}else if(typeof r!=="string"&&!t.objectMode){i=new c("chunk",["string","Buffer"],r)}if(i){m(e,i);process.nextTick(n,i);return false}return true}Writable.prototype.write=function(e,t,r){var n=this._writableState;var i=false;var a=!n.objectMode&&_isUint8Array(e);if(a&&!o.isBuffer(e)){e=_uint8ArrayToBuffer(e)}if(typeof t==="function"){r=t;t=null}if(a)t="buffer";else if(!t)t=n.defaultEncoding;if(typeof r!=="function")r=nop;if(n.ending)writeAfterEnd(this,r);else if(a||validChunk(this,n,e,r)){n.pendingcb++;i=writeOrBuffer(this,n,a,e,t,r)}return i};Writable.prototype.cork=function(){this._writableState.corked++};Writable.prototype.uncork=function(){var e=this._writableState;if(e.corked){e.corked--;if(!e.writing&&!e.corked&&!e.bufferProcessing&&e.bufferedRequest)clearBuffer(this,e)}};Writable.prototype.setDefaultEncoding=function setDefaultEncoding(e){if(typeof e==="string")e=e.toLowerCase();if(!(["hex","utf8","utf-8","ascii","binary","base64","ucs2","ucs-2","utf16le","utf-16le","raw"].indexOf((e+"").toLowerCase())>-1))throw new v(e);this._writableState.defaultEncoding=e;return this};Object.defineProperty(Writable.prototype,"writableBuffer",{enumerable:false,get:function get(){return this._writableState&&this._writableState.getBuffer()}});function decodeChunk(e,t,r){if(!e.objectMode&&e.decodeStrings!==false&&typeof t==="string"){t=o.from(t,r)}return t}Object.defineProperty(Writable.prototype,"writableHighWaterMark",{enumerable:false,get:function get(){return this._writableState.highWaterMark}});function writeOrBuffer(e,t,r,n,i,a){if(!r){var o=decodeChunk(t,n,i);if(n!==o){r=true;i="buffer";n=o}}var s=t.objectMode?1:n.length;t.length+=s;var f=t.length<t.highWaterMark;if(!f)t.needDrain=true;if(t.writing||t.corked){var l=t.lastBufferedRequest;t.lastBufferedRequest={chunk:n,encoding:i,isBuf:r,callback:a,next:null};if(l){l.next=t.lastBufferedRequest}else{t.bufferedRequest=t.lastBufferedRequest}t.bufferedRequestCount+=1}else{doWrite(e,t,false,s,n,i,a)}return f}function doWrite(e,t,r,n,i,a,o){t.writelen=n;t.writecb=o;t.writing=true;t.sync=true;if(t.destroyed)t.onwrite(new y("write"));else if(r)e._writev(i,t.onwrite);else e._write(i,a,t.onwrite);t.sync=false}function onwriteError(e,t,r,n,i){--t.pendingcb;if(r){process.nextTick(i,n);process.nextTick(finishMaybe,e,t);e._writableState.errorEmitted=true;m(e,n)}else{i(n);e._writableState.errorEmitted=true;m(e,n);finishMaybe(e,t)}}function onwriteStateUpdate(e){e.writing=false;e.writecb=null;e.length-=e.writelen;e.writelen=0}function onwrite(e,t){var r=e._writableState;var n=r.sync;var i=r.writecb;if(typeof i!=="function")throw new p;onwriteStateUpdate(r);if(t)onwriteError(e,r,n,t,i);else{var a=needFinish(r)||e.destroyed;if(!a&&!r.corked&&!r.bufferProcessing&&r.bufferedRequest){clearBuffer(e,r)}if(n){process.nextTick(afterWrite,e,r,a,i)}else{afterWrite(e,r,a,i)}}}function afterWrite(e,t,r,n){if(!r)onwriteDrain(e,t);t.pendingcb--;n();finishMaybe(e,t)}function onwriteDrain(e,t){if(t.length===0&&t.needDrain){t.needDrain=false;e.emit("drain")}}function clearBuffer(e,t){t.bufferProcessing=true;var r=t.bufferedRequest;if(e._writev&&r&&r.next){var n=t.bufferedRequestCount;var i=new Array(n);var a=t.corkedRequestsFree;a.entry=r;var o=0;var s=true;while(r){i[o]=r;if(!r.isBuf)s=false;r=r.next;o+=1}i.allBuffers=s;doWrite(e,t,true,t.length,i,"",a.finish);t.pendingcb++;t.lastBufferedRequest=null;if(a.next){t.corkedRequestsFree=a.next;a.next=null}else{t.corkedRequestsFree=new CorkedRequest(t)}t.bufferedRequestCount=0}else{while(r){var f=r.chunk;var l=r.encoding;var u=r.callback;var d=t.objectMode?1:f.length;doWrite(e,t,false,d,f,l,u);r=r.next;t.bufferedRequestCount--;if(t.writing){break}}if(r===null)t.lastBufferedRequest=null}t.bufferedRequest=r;t.bufferProcessing=false}Writable.prototype._write=function(e,t,r){r(new h("_write()"))};Writable.prototype._writev=null;Writable.prototype.end=function(e,t,r){var n=this._writableState;if(typeof e==="function"){r=e;e=null;t=null}else if(typeof t==="function"){r=t;t=null}if(e!==null&&e!==undefined)this.write(e,t);if(n.corked){n.corked=1;this.uncork()}if(!n.ending)endWritable(this,n,r);return this};Object.defineProperty(Writable.prototype,"writableLength",{enumerable:false,get:function get(){return this._writableState.length}});function needFinish(e){return e.ending&&e.length===0&&e.bufferedRequest===null&&!e.finished&&!e.writing}function callFinal(e,t){e._final((function(r){t.pendingcb--;if(r){m(e,r)}t.prefinished=true;e.emit("prefinish");finishMaybe(e,t)}))}function prefinish(e,t){if(!t.prefinished&&!t.finalCalled){if(typeof e._final==="function"&&!t.destroyed){t.pendingcb++;t.finalCalled=true;process.nextTick(callFinal,e,t)}else{t.prefinished=true;e.emit("prefinish")}}}function finishMaybe(e,t){var r=needFinish(t);if(r){prefinish(e,t);if(t.pendingcb===0){t.finished=true;e.emit("finish");if(t.autoDestroy){var n=e._readableState;if(!n||n.autoDestroy&&n.endEmitted){e.destroy()}}}}return r}function endWritable(e,t,r){t.ending=true;finishMaybe(e,t);if(r){if(t.finished)process.nextTick(r);else e.once("finish",r)}t.ended=true;e.writable=false}function onCorkedFinish(e,t,r){var n=e.entry;e.entry=null;while(n){var i=n.callback;t.pendingcb--;i(r);n=n.next}t.corkedRequestsFree.next=e}Object.defineProperty(Writable.prototype,"destroyed",{enumerable:false,get:function get(){if(this._writableState===undefined){return false}return this._writableState.destroyed},set:function set(e){if(!this._writableState){return}this._writableState.destroyed=e}});Writable.prototype.destroy=f.destroy;Writable.prototype._undestroy=f.undestroy;Writable.prototype._destroy=function(e,t){t(e)}},871:function(e,t,r){"use strict";var n;function _defineProperty(e,t,r){if(t in e){Object.defineProperty(e,t,{value:r,enumerable:true,configurable:true,writable:true})}else{e[t]=r}return e}var i=r(698);var a=Symbol("lastResolve");var o=Symbol("lastReject");var s=Symbol("error");var f=Symbol("ended");var l=Symbol("lastPromise");var u=Symbol("handlePromise");var d=Symbol("stream");function createIterResult(e,t){return{value:e,done:t}}function readAndResolve(e){var t=e[a];if(t!==null){var r=e[d].read();if(r!==null){e[l]=null;e[a]=null;e[o]=null;t(createIterResult(r,false))}}}function onReadable(e){process.nextTick(readAndResolve,e)}function wrapForNext(e,t){return function(r,n){e.then((function(){if(t[f]){r(createIterResult(undefined,true));return}t[u](r,n)}),n)}}var c=Object.getPrototypeOf((function(){}));var h=Object.setPrototypeOf((n={get stream(){return this[d]},next:function next(){var e=this;var t=this[s];if(t!==null){return Promise.reject(t)}if(this[f]){return Promise.resolve(createIterResult(undefined,true))}if(this[d].destroyed){return new Promise((function(t,r){process.nextTick((function(){if(e[s]){r(e[s])}else{t(createIterResult(undefined,true))}}))}))}var r=this[l];var n;if(r){n=new Promise(wrapForNext(r,this))}else{var i=this[d].read();if(i!==null){return Promise.resolve(createIterResult(i,false))}n=new Promise(this[u])}this[l]=n;return n}},_defineProperty(n,Symbol.asyncIterator,(function(){return this})),_defineProperty(n,"return",(function _return(){var e=this;return new Promise((function(t,r){e[d].destroy(null,(function(e){if(e){r(e);return}t(createIterResult(undefined,true))}))}))})),n),c);var p=function createReadableStreamAsyncIterator(e){var t;var r=Object.create(h,(t={},_defineProperty(t,d,{value:e,writable:true}),_defineProperty(t,a,{value:null,writable:true}),_defineProperty(t,o,{value:null,writable:true}),_defineProperty(t,s,{value:null,writable:true}),_defineProperty(t,f,{value:e._readableState.endEmitted,writable:true}),_defineProperty(t,u,{value:function value(e,t){var n=r[d].read();if(n){r[l]=null;r[a]=null;r[o]=null;e(createIterResult(n,false))}else{r[a]=e;r[o]=t}},writable:true}),t));r[l]=null;i(e,(function(e){if(e&&e.code!=="ERR_STREAM_PREMATURE_CLOSE"){var t=r[o];if(t!==null){r[l]=null;r[a]=null;r[o]=null;t(e)}r[s]=e;return}var n=r[a];if(n!==null){r[l]=null;r[a]=null;r[o]=null;n(createIterResult(undefined,true))}r[f]=true}));e.on("readable",onReadable.bind(null,r));return r};e.exports=p},379:function(e,t,r){"use strict";function ownKeys(e,t){var r=Object.keys(e);if(Object.getOwnPropertySymbols){var n=Object.getOwnPropertySymbols(e);if(t)n=n.filter((function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable}));r.push.apply(r,n)}return r}function _objectSpread(e){for(var t=1;t<arguments.length;t++){var r=arguments[t]!=null?arguments[t]:{};if(t%2){ownKeys(Object(r),true).forEach((function(t){_defineProperty(e,t,r[t])}))}else if(Object.getOwnPropertyDescriptors){Object.defineProperties(e,Object.getOwnPropertyDescriptors(r))}else{ownKeys(Object(r)).forEach((function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(r,t))}))}}return e}function _defineProperty(e,t,r){if(t in e){Object.defineProperty(e,t,{value:r,enumerable:true,configurable:true,writable:true})}else{e[t]=r}return e}function _classCallCheck(e,t){if(!(e instanceof t)){throw new TypeError("Cannot call a class as a function")}}function _defineProperties(e,t){for(var r=0;r<t.length;r++){var n=t[r];n.enumerable=n.enumerable||false;n.configurable=true;if("value"in n)n.writable=true;Object.defineProperty(e,n.key,n)}}function _createClass(e,t,r){if(t)_defineProperties(e.prototype,t);if(r)_defineProperties(e,r);return e}var n=r(300),i=n.Buffer;var a=r(837),o=a.inspect;var s=o&&o.custom||"inspect";function copyBuffer(e,t,r){i.prototype.copy.call(e,t,r)}e.exports=function(){function BufferList(){_classCallCheck(this,BufferList);this.head=null;this.tail=null;this.length=0}_createClass(BufferList,[{key:"push",value:function push(e){var t={data:e,next:null};if(this.length>0)this.tail.next=t;else this.head=t;this.tail=t;++this.length}},{key:"unshift",value:function unshift(e){var t={data:e,next:this.head};if(this.length===0)this.tail=t;this.head=t;++this.length}},{key:"shift",value:function shift(){if(this.length===0)return;var e=this.head.data;if(this.length===1)this.head=this.tail=null;else this.head=this.head.next;--this.length;return e}},{key:"clear",value:function clear(){this.head=this.tail=null;this.length=0}},{key:"join",value:function join(e){if(this.length===0)return"";var t=this.head;var r=""+t.data;while(t=t.next){r+=e+t.data}return r}},{key:"concat",value:function concat(e){if(this.length===0)return i.alloc(0);var t=i.allocUnsafe(e>>>0);var r=this.head;var n=0;while(r){copyBuffer(r.data,t,n);n+=r.data.length;r=r.next}return t}},{key:"consume",value:function consume(e,t){var r;if(e<this.head.data.length){r=this.head.data.slice(0,e);this.head.data=this.head.data.slice(e)}else if(e===this.head.data.length){r=this.shift()}else{r=t?this._getString(e):this._getBuffer(e)}return r}},{key:"first",value:function first(){return this.head.data}},{key:"_getString",value:function _getString(e){var t=this.head;var r=1;var n=t.data;e-=n.length;while(t=t.next){var i=t.data;var a=e>i.length?i.length:e;if(a===i.length)n+=i;else n+=i.slice(0,e);e-=a;if(e===0){if(a===i.length){++r;if(t.next)this.head=t.next;else this.head=this.tail=null}else{this.head=t;t.data=i.slice(a)}break}++r}this.length-=r;return n}},{key:"_getBuffer",value:function _getBuffer(e){var t=i.allocUnsafe(e);var r=this.head;var n=1;r.data.copy(t);e-=r.data.length;while(r=r.next){var a=r.data;var o=e>a.length?a.length:e;a.copy(t,t.length-e,0,o);e-=o;if(e===0){if(o===a.length){++n;if(r.next)this.head=r.next;else this.head=this.tail=null}else{this.head=r;r.data=a.slice(o)}break}++n}this.length-=n;return t}},{key:s,value:function value(e,t){return o(this,_objectSpread({},t,{depth:0,customInspect:false}))}}]);return BufferList}()},25:function(e){"use strict";function destroy(e,t){var r=this;var n=this._readableState&&this._readableState.destroyed;var i=this._writableState&&this._writableState.destroyed;if(n||i){if(t){t(e)}else if(e){if(!this._writableState){process.nextTick(emitErrorNT,this,e)}else if(!this._writableState.errorEmitted){this._writableState.errorEmitted=true;process.nextTick(emitErrorNT,this,e)}}return this}if(this._readableState){this._readableState.destroyed=true}if(this._writableState){this._writableState.destroyed=true}this._destroy(e||null,(function(e){if(!t&&e){if(!r._writableState){process.nextTick(emitErrorAndCloseNT,r,e)}else if(!r._writableState.errorEmitted){r._writableState.errorEmitted=true;process.nextTick(emitErrorAndCloseNT,r,e)}else{process.nextTick(emitCloseNT,r)}}else if(t){process.nextTick(emitCloseNT,r);t(e)}else{process.nextTick(emitCloseNT,r)}}));return this}function emitErrorAndCloseNT(e,t){emitErrorNT(e,t);emitCloseNT(e)}function emitCloseNT(e){if(e._writableState&&!e._writableState.emitClose)return;if(e._readableState&&!e._readableState.emitClose)return;e.emit("close")}function undestroy(){if(this._readableState){this._readableState.destroyed=false;this._readableState.reading=false;this._readableState.ended=false;this._readableState.endEmitted=false}if(this._writableState){this._writableState.destroyed=false;this._writableState.ended=false;this._writableState.ending=false;this._writableState.finalCalled=false;this._writableState.prefinished=false;this._writableState.finished=false;this._writableState.errorEmitted=false}}function emitErrorNT(e,t){e.emit("error",t)}function errorOrDestroy(e,t){var r=e._readableState;var n=e._writableState;if(r&&r.autoDestroy||n&&n.autoDestroy)e.destroy(t);else e.emit("error",t)}e.exports={destroy:destroy,undestroy:undestroy,errorOrDestroy:errorOrDestroy}},698:function(e,t,r){"use strict";var n=r(646).q.ERR_STREAM_PREMATURE_CLOSE;function once(e){var t=false;return function(){if(t)return;t=true;for(var r=arguments.length,n=new Array(r),i=0;i<r;i++){n[i]=arguments[i]}e.apply(this,n)}}function noop(){}function isRequest(e){return e.setHeader&&typeof e.abort==="function"}function eos(e,t,r){if(typeof t==="function")return eos(e,null,t);if(!t)t={};r=once(r||noop);var i=t.readable||t.readable!==false&&e.readable;var a=t.writable||t.writable!==false&&e.writable;var o=function onlegacyfinish(){if(!e.writable)f()};var s=e._writableState&&e._writableState.finished;var f=function onfinish(){a=false;s=true;if(!i)r.call(e)};var l=e._readableState&&e._readableState.endEmitted;var u=function onend(){i=false;l=true;if(!a)r.call(e)};var d=function onerror(t){r.call(e,t)};var c=function onclose(){var t;if(i&&!l){if(!e._readableState||!e._readableState.ended)t=new n;return r.call(e,t)}if(a&&!s){if(!e._writableState||!e._writableState.ended)t=new n;return r.call(e,t)}};var h=function onrequest(){e.req.on("finish",f)};if(isRequest(e)){e.on("complete",f);e.on("abort",c);if(e.req)h();else e.on("request",h)}else if(a&&!e._writableState){e.on("end",o);e.on("close",o)}e.on("end",u);e.on("finish",f);if(t.error!==false)e.on("error",d);e.on("close",c);return function(){e.removeListener("complete",f);e.removeListener("abort",c);e.removeListener("request",h);if(e.req)e.req.removeListener("finish",f);e.removeListener("end",o);e.removeListener("close",o);e.removeListener("finish",f);e.removeListener("end",u);e.removeListener("error",d);e.removeListener("close",c)}}e.exports=eos},727:function(e,t,r){"use strict";function asyncGeneratorStep(e,t,r,n,i,a,o){try{var s=e[a](o);var f=s.value}catch(e){r(e);return}if(s.done){t(f)}else{Promise.resolve(f).then(n,i)}}function _asyncToGenerator(e){return function(){var t=this,r=arguments;return new Promise((function(n,i){var a=e.apply(t,r);function _next(e){asyncGeneratorStep(a,n,i,_next,_throw,"next",e)}function _throw(e){asyncGeneratorStep(a,n,i,_next,_throw,"throw",e)}_next(undefined)}))}}function ownKeys(e,t){var r=Object.keys(e);if(Object.getOwnPropertySymbols){var n=Object.getOwnPropertySymbols(e);if(t)n=n.filter((function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable}));r.push.apply(r,n)}return r}function _objectSpread(e){for(var t=1;t<arguments.length;t++){var r=arguments[t]!=null?arguments[t]:{};if(t%2){ownKeys(Object(r),true).forEach((function(t){_defineProperty(e,t,r[t])}))}else if(Object.getOwnPropertyDescriptors){Object.defineProperties(e,Object.getOwnPropertyDescriptors(r))}else{ownKeys(Object(r)).forEach((function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(r,t))}))}}return e}function _defineProperty(e,t,r){if(t in e){Object.defineProperty(e,t,{value:r,enumerable:true,configurable:true,writable:true})}else{e[t]=r}return e}var n=r(646).q.ERR_INVALID_ARG_TYPE;function from(e,t,r){var i;if(t&&typeof t.next==="function"){i=t}else if(t&&t[Symbol.asyncIterator])i=t[Symbol.asyncIterator]();else if(t&&t[Symbol.iterator])i=t[Symbol.iterator]();else throw new n("iterable",["Iterable"],t);var a=new e(_objectSpread({objectMode:true},r));var o=false;a._read=function(){if(!o){o=true;next()}};function next(){return _next2.apply(this,arguments)}function _next2(){_next2=_asyncToGenerator((function*(){try{var e=yield i.next(),t=e.value,r=e.done;if(r){a.push(null)}else if(a.push(yield t)){next()}else{o=false}}catch(e){a.destroy(e)}}));return _next2.apply(this,arguments)}return a}e.exports=from},442:function(e,t,r){"use strict";var n;function once(e){var t=false;return function(){if(t)return;t=true;e.apply(void 0,arguments)}}var i=r(646).q,a=i.ERR_MISSING_ARGS,o=i.ERR_STREAM_DESTROYED;function noop(e){if(e)throw e}function isRequest(e){return e.setHeader&&typeof e.abort==="function"}function destroyer(e,t,i,a){a=once(a);var s=false;e.on("close",(function(){s=true}));if(n===undefined)n=r(698);n(e,{readable:t,writable:i},(function(e){if(e)return a(e);s=true;a()}));var f=false;return function(t){if(s)return;if(f)return;f=true;if(isRequest(e))return e.abort();if(typeof e.destroy==="function")return e.destroy();a(t||new o("pipe"))}}function call(e){e()}function pipe(e,t){return e.pipe(t)}function popCallback(e){if(!e.length)return noop;if(typeof e[e.length-1]!=="function")return noop;return e.pop()}function pipeline(){for(var e=arguments.length,t=new Array(e),r=0;r<e;r++){t[r]=arguments[r]}var n=popCallback(t);if(Array.isArray(t[0]))t=t[0];if(t.length<2){throw new a("streams")}var i;var o=t.map((function(e,r){var a=r<t.length-1;var s=r>0;return destroyer(e,a,s,(function(e){if(!i)i=e;if(e)o.forEach(call);if(a)return;o.forEach(call);n(i)}))}));return t.reduce(pipe)}e.exports=pipeline},776:function(e,t,r){"use strict";var n=r(646).q.ERR_INVALID_OPT_VALUE;function highWaterMarkFrom(e,t,r){return e.highWaterMark!=null?e.highWaterMark:t?e[r]:null}function getHighWaterMark(e,t,r,i){var a=highWaterMarkFrom(t,i,r);if(a!=null){if(!(isFinite(a)&&Math.floor(a)===a)||a<0){var o=i?r:"highWaterMark";throw new n(o,a)}return Math.floor(a)}return e.objectMode?16:16*1024}e.exports={getHighWaterMark:getHighWaterMark}},678:function(e,t,r){e.exports=r(781)},726:function(e,t,r){var n=r(781);if(process.env.READABLE_STREAM==="disable"&&n){e.exports=n.Readable;Object.assign(e.exports,n);e.exports.Stream=n}else{t=e.exports=r(709);t.Stream=n||t;t.Readable=t;t.Writable=r(337);t.Duplex=r(403);t.Transform=r(170);t.PassThrough=r(889);t.finished=r(698);t.pipeline=r(442)}},55:function(e,t,r){var n=r(300);var i=n.Buffer;function copyProps(e,t){for(var r in e){t[r]=e[r]}}if(i.from&&i.alloc&&i.allocUnsafe&&i.allocUnsafeSlow){e.exports=n}else{copyProps(n,t);t.Buffer=SafeBuffer}function SafeBuffer(e,t,r){return i(e,t,r)}SafeBuffer.prototype=Object.create(i.prototype);copyProps(i,SafeBuffer);SafeBuffer.from=function(e,t,r){if(typeof e==="number"){throw new TypeError("Argument must not be a number")}return i(e,t,r)};SafeBuffer.alloc=function(e,t,r){if(typeof e!=="number"){throw new TypeError("Argument must be a number")}var n=i(e);if(t!==undefined){if(typeof r==="string"){n.fill(t,r)}else{n.fill(t)}}else{n.fill(0)}return n};SafeBuffer.allocUnsafe=function(e){if(typeof e!=="number"){throw new TypeError("Argument must be a number")}return i(e)};SafeBuffer.allocUnsafeSlow=function(e){if(typeof e!=="number"){throw new TypeError("Argument must be a number")}return n.SlowBuffer(e)}},813:function(e,t,r){var n=r(450);var i=r(254);var a=r(911);var o=r(523);var s=r(310);var f=t;f.request=function(e,t){if(typeof e==="string")e=s.parse(e);else e=a(e);var r=__webpack_require__.g.location.protocol.search(/^https?:$/)===-1?"http:":"";var i=e.protocol||r;var o=e.hostname||e.host;var f=e.port;var l=e.path||"/";if(o&&o.indexOf(":")!==-1)o="["+o+"]";e.url=(o?i+"//"+o:"")+(f?":"+f:"")+l;e.method=(e.method||"GET").toUpperCase();e.headers=e.headers||{};var u=new n(e);if(t)u.on("response",t);return u};f.get=function get(e,t){var r=f.request(e,t);r.end();return r};f.ClientRequest=n;f.IncomingMessage=i.IncomingMessage;f.Agent=function(){};f.Agent.defaultMaxSockets=4;f.globalAgent=new f.Agent;f.STATUS_CODES=o;f.METHODS=["CHECKOUT","CONNECT","COPY","DELETE","GET","HEAD","LOCK","M-SEARCH","MERGE","MKACTIVITY","MKCOL","MOVE","NOTIFY","OPTIONS","PATCH","POST","PROPFIND","PROPPATCH","PURGE","PUT","REPORT","SEARCH","SUBSCRIBE","TRACE","UNLOCK","UNSUBSCRIBE"]},301:function(e,t){t.fetch=isFunction(__webpack_require__.g.fetch)&&isFunction(__webpack_require__.g.ReadableStream);t.writableStream=isFunction(__webpack_require__.g.WritableStream);t.abortController=isFunction(__webpack_require__.g.AbortController);var r;function getXHR(){if(r!==undefined)return r;if(__webpack_require__.g.XMLHttpRequest){r=new __webpack_require__.g.XMLHttpRequest;try{r.open("GET",__webpack_require__.g.XDomainRequest?"/":"https://example.com")}catch(e){r=null}}else{r=null}return r}function checkTypeSupport(e){var t=getXHR();if(!t)return false;try{t.responseType=e;return t.responseType===e}catch(e){}return false}t.arraybuffer=t.fetch||checkTypeSupport("arraybuffer");t.msstream=!t.fetch&&checkTypeSupport("ms-stream");t.mozchunkedarraybuffer=!t.fetch&&checkTypeSupport("moz-chunked-arraybuffer");t.overrideMimeType=t.fetch||(getXHR()?isFunction(getXHR().overrideMimeType):false);function isFunction(e){return typeof e==="function"}r=null},450:function(e,t,r){var n=r(301);var i=r(782);var a=r(254);var o=r(726);var s=a.IncomingMessage;var f=a.readyStates;function decideMode(e,t){if(n.fetch&&t){return"fetch"}else if(n.mozchunkedarraybuffer){return"moz-chunked-arraybuffer"}else if(n.msstream){return"ms-stream"}else if(n.arraybuffer&&e){return"arraybuffer"}else{return"text"}}var l=e.exports=function(e){var t=this;o.Writable.call(t);t._opts=e;t._body=[];t._headers={};if(e.auth)t.setHeader("Authorization","Basic "+Buffer.from(e.auth).toString("base64"));Object.keys(e.headers).forEach((function(r){t.setHeader(r,e.headers[r])}));var r;var i=true;if(e.mode==="disable-fetch"||"requestTimeout"in e&&!n.abortController){i=false;r=true}else if(e.mode==="prefer-streaming"){r=false}else if(e.mode==="allow-wrong-content-type"){r=!n.overrideMimeType}else if(!e.mode||e.mode==="default"||e.mode==="prefer-fast"){r=true}else{throw new Error("Invalid value for opts.mode")}t._mode=decideMode(r,i);t._fetchTimer=null;t.on("finish",(function(){t._onFinish()}))};i(l,o.Writable);l.prototype.setHeader=function(e,t){var r=this;var n=e.toLowerCase();if(u.indexOf(n)!==-1)return;r._headers[n]={name:e,value:t}};l.prototype.getHeader=function(e){var t=this._headers[e.toLowerCase()];if(t)return t.value;return null};l.prototype.removeHeader=function(e){var t=this;delete t._headers[e.toLowerCase()]};l.prototype._onFinish=function(){var e=this;if(e._destroyed)return;var t=e._opts;var r=e._headers;var i=null;if(t.method!=="GET"&&t.method!=="HEAD"){i=new Blob(e._body,{type:(r["content-type"]||{}).value||""})}var a=[];Object.keys(r).forEach((function(e){var t=r[e].name;var n=r[e].value;if(Array.isArray(n)){n.forEach((function(e){a.push([t,e])}))}else{a.push([t,n])}}));if(e._mode==="fetch"){var o=null;if(n.abortController){var s=new AbortController;o=s.signal;e._fetchAbortController=s;if("requestTimeout"in t&&t.requestTimeout!==0){e._fetchTimer=__webpack_require__.g.setTimeout((function(){e.emit("requestTimeout");if(e._fetchAbortController)e._fetchAbortController.abort()}),t.requestTimeout)}}__webpack_require__.g.fetch(e._opts.url,{method:e._opts.method,headers:a,body:i||undefined,mode:"cors",credentials:t.withCredentials?"include":"same-origin",signal:o}).then((function(t){e._fetchResponse=t;e._connect()}),(function(t){__webpack_require__.g.clearTimeout(e._fetchTimer);if(!e._destroyed)e.emit("error",t)}))}else{var l=e._xhr=new __webpack_require__.g.XMLHttpRequest;try{l.open(e._opts.method,e._opts.url,true)}catch(t){process.nextTick((function(){e.emit("error",t)}));return}if("responseType"in l)l.responseType=e._mode;if("withCredentials"in l)l.withCredentials=!!t.withCredentials;if(e._mode==="text"&&"overrideMimeType"in l)l.overrideMimeType("text/plain; charset=x-user-defined");if("requestTimeout"in t){l.timeout=t.requestTimeout;l.ontimeout=function(){e.emit("requestTimeout")}}a.forEach((function(e){l.setRequestHeader(e[0],e[1])}));e._response=null;l.onreadystatechange=function(){switch(l.readyState){case f.LOADING:case f.DONE:e._onXHRProgress();break}};if(e._mode==="moz-chunked-arraybuffer"){l.onprogress=function(){e._onXHRProgress()}}l.onerror=function(){if(e._destroyed)return;e.emit("error",new Error("XHR error"))};try{l.send(i)}catch(t){process.nextTick((function(){e.emit("error",t)}));return}}};function statusValid(e){try{var t=e.status;return t!==null&&t!==0}catch(e){return false}}l.prototype._onXHRProgress=function(){var e=this;if(!statusValid(e._xhr)||e._destroyed)return;if(!e._response)e._connect();e._response._onXHRProgress()};l.prototype._connect=function(){var e=this;if(e._destroyed)return;e._response=new s(e._xhr,e._fetchResponse,e._mode,e._fetchTimer);e._response.on("error",(function(t){e.emit("error",t)}));e.emit("response",e._response)};l.prototype._write=function(e,t,r){var n=this;n._body.push(e);r()};l.prototype.abort=l.prototype.destroy=function(){var e=this;e._destroyed=true;__webpack_require__.g.clearTimeout(e._fetchTimer);if(e._response)e._response._destroyed=true;if(e._xhr)e._xhr.abort();else if(e._fetchAbortController)e._fetchAbortController.abort()};l.prototype.end=function(e,t,r){var n=this;if(typeof e==="function"){r=e;e=undefined}o.Writable.prototype.end.call(n,e,t,r)};l.prototype.flushHeaders=function(){};l.prototype.setTimeout=function(){};l.prototype.setNoDelay=function(){};l.prototype.setSocketKeepAlive=function(){};var u=["accept-charset","accept-encoding","access-control-request-headers","access-control-request-method","connection","content-length","cookie","cookie2","date","dnt","expect","host","keep-alive","origin","referer","te","trailer","transfer-encoding","upgrade","via"]},254:function(e,t,r){var n=r(301);var i=r(782);var a=r(726);var o=t.readyStates={UNSENT:0,OPENED:1,HEADERS_RECEIVED:2,LOADING:3,DONE:4};var s=t.IncomingMessage=function(e,t,r,i){var o=this;a.Readable.call(o);o._mode=r;o.headers={};o.rawHeaders=[];o.trailers={};o.rawTrailers=[];o.on("end",(function(){process.nextTick((function(){o.emit("close")}))}));if(r==="fetch"){o._fetchResponse=t;o.url=t.url;o.statusCode=t.status;o.statusMessage=t.statusText;t.headers.forEach((function(e,t){o.headers[t.toLowerCase()]=e;o.rawHeaders.push(t,e)}));if(n.writableStream){var s=new WritableStream({write:function(e){return new Promise((function(t,r){if(o._destroyed){r()}else if(o.push(Buffer.from(e))){t()}else{o._resumeFetch=t}}))},close:function(){__webpack_require__.g.clearTimeout(i);if(!o._destroyed)o.push(null)},abort:function(e){if(!o._destroyed)o.emit("error",e)}});try{t.body.pipeTo(s).catch((function(e){__webpack_require__.g.clearTimeout(i);if(!o._destroyed)o.emit("error",e)}));return}catch(e){}}var f=t.body.getReader();function read(){f.read().then((function(e){if(o._destroyed)return;if(e.done){__webpack_require__.g.clearTimeout(i);o.push(null);return}o.push(Buffer.from(e.value));read()})).catch((function(e){__webpack_require__.g.clearTimeout(i);if(!o._destroyed)o.emit("error",e)}))}read()}else{o._xhr=e;o._pos=0;o.url=e.responseURL;o.statusCode=e.status;o.statusMessage=e.statusText;var l=e.getAllResponseHeaders().split(/\r?\n/);l.forEach((function(e){var t=e.match(/^([^:]+):\s*(.*)/);if(t){var r=t[1].toLowerCase();if(r==="set-cookie"){if(o.headers[r]===undefined){o.headers[r]=[]}o.headers[r].push(t[2])}else if(o.headers[r]!==undefined){o.headers[r]+=", "+t[2]}else{o.headers[r]=t[2]}o.rawHeaders.push(t[1],t[2])}}));o._charset="x-user-defined";if(!n.overrideMimeType){var u=o.rawHeaders["mime-type"];if(u){var d=u.match(/;\s*charset=([^;])(;|$)/);if(d){o._charset=d[1].toLowerCase()}}if(!o._charset)o._charset="utf-8"}}};i(s,a.Readable);s.prototype._read=function(){var e=this;var t=e._resumeFetch;if(t){e._resumeFetch=null;t()}};s.prototype._onXHRProgress=function(){var e=this;var t=e._xhr;var r=null;switch(e._mode){case"text":r=t.responseText;if(r.length>e._pos){var n=r.substr(e._pos);if(e._charset==="x-user-defined"){var i=Buffer.alloc(n.length);for(var a=0;a<n.length;a++)i[a]=n.charCodeAt(a)&255;e.push(i)}else{e.push(n,e._charset)}e._pos=r.length}break;case"arraybuffer":if(t.readyState!==o.DONE||!t.response)break;r=t.response;e.push(Buffer.from(new Uint8Array(r)));break;case"moz-chunked-arraybuffer":r=t.response;if(t.readyState!==o.LOADING||!r)break;e.push(Buffer.from(new Uint8Array(r)));break;case"ms-stream":r=t.response;if(t.readyState!==o.LOADING)break;var s=new __webpack_require__.g.MSStreamReader;s.onprogress=function(){if(s.result.byteLength>e._pos){e.push(Buffer.from(new Uint8Array(s.result.slice(e._pos))));e._pos=s.result.byteLength}};s.onload=function(){e.push(null)};s.readAsArrayBuffer(r);break}if(e._xhr.readyState===o.DONE&&e._mode!=="ms-stream"){e.push(null)}}},704:function(e,t,r){"use strict";var n=r(55).Buffer;var i=n.isEncoding||function(e){e=""+e;switch(e&&e.toLowerCase()){case"hex":case"utf8":case"utf-8":case"ascii":case"binary":case"base64":case"ucs2":case"ucs-2":case"utf16le":case"utf-16le":case"raw":return true;default:return false}};function _normalizeEncoding(e){if(!e)return"utf8";var t;while(true){switch(e){case"utf8":case"utf-8":return"utf8";case"ucs2":case"ucs-2":case"utf16le":case"utf-16le":return"utf16le";case"latin1":case"binary":return"latin1";case"base64":case"ascii":case"hex":return e;default:if(t)return;e=(""+e).toLowerCase();t=true}}}function normalizeEncoding(e){var t=_normalizeEncoding(e);if(typeof t!=="string"&&(n.isEncoding===i||!i(e)))throw new Error("Unknown encoding: "+e);return t||e}t.s=StringDecoder;function StringDecoder(e){this.encoding=normalizeEncoding(e);var t;switch(this.encoding){case"utf16le":this.text=utf16Text;this.end=utf16End;t=4;break;case"utf8":this.fillLast=utf8FillLast;t=4;break;case"base64":this.text=base64Text;this.end=base64End;t=3;break;default:this.write=simpleWrite;this.end=simpleEnd;return}this.lastNeed=0;this.lastTotal=0;this.lastChar=n.allocUnsafe(t)}StringDecoder.prototype.write=function(e){if(e.length===0)return"";var t;var r;if(this.lastNeed){t=this.fillLast(e);if(t===undefined)return"";r=this.lastNeed;this.lastNeed=0}else{r=0}if(r<e.length)return t?t+this.text(e,r):this.text(e,r);return t||""};StringDecoder.prototype.end=utf8End;StringDecoder.prototype.text=utf8Text;StringDecoder.prototype.fillLast=function(e){if(this.lastNeed<=e.length){e.copy(this.lastChar,this.lastTotal-this.lastNeed,0,this.lastNeed);return this.lastChar.toString(this.encoding,0,this.lastTotal)}e.copy(this.lastChar,this.lastTotal-this.lastNeed,0,e.length);this.lastNeed-=e.length};function utf8CheckByte(e){if(e<=127)return 0;else if(e>>5===6)return 2;else if(e>>4===14)return 3;else if(e>>3===30)return 4;return e>>6===2?-1:-2}function utf8CheckIncomplete(e,t,r){var n=t.length-1;if(n<r)return 0;var i=utf8CheckByte(t[n]);if(i>=0){if(i>0)e.lastNeed=i-1;return i}if(--n<r||i===-2)return 0;i=utf8CheckByte(t[n]);if(i>=0){if(i>0)e.lastNeed=i-2;return i}if(--n<r||i===-2)return 0;i=utf8CheckByte(t[n]);if(i>=0){if(i>0){if(i===2)i=0;else e.lastNeed=i-3}return i}return 0}function utf8CheckExtraBytes(e,t,r){if((t[0]&192)!==128){e.lastNeed=0;return"�"}if(e.lastNeed>1&&t.length>1){if((t[1]&192)!==128){e.lastNeed=1;return"�"}if(e.lastNeed>2&&t.length>2){if((t[2]&192)!==128){e.lastNeed=2;return"�"}}}}function utf8FillLast(e){var t=this.lastTotal-this.lastNeed;var r=utf8CheckExtraBytes(this,e,t);if(r!==undefined)return r;if(this.lastNeed<=e.length){e.copy(this.lastChar,t,0,this.lastNeed);return this.lastChar.toString(this.encoding,0,this.lastTotal)}e.copy(this.lastChar,t,0,e.length);this.lastNeed-=e.length}function utf8Text(e,t){var r=utf8CheckIncomplete(this,e,t);if(!this.lastNeed)return e.toString("utf8",t);this.lastTotal=r;var n=e.length-(r-this.lastNeed);e.copy(this.lastChar,0,n);return e.toString("utf8",t,n)}function utf8End(e){var t=e&&e.length?this.write(e):"";if(this.lastNeed)return t+"�";return t}function utf16Text(e,t){if((e.length-t)%2===0){var r=e.toString("utf16le",t);if(r){var n=r.charCodeAt(r.length-1);if(n>=55296&&n<=56319){this.lastNeed=2;this.lastTotal=4;this.lastChar[0]=e[e.length-2];this.lastChar[1]=e[e.length-1];return r.slice(0,-1)}}return r}this.lastNeed=1;this.lastTotal=2;this.lastChar[0]=e[e.length-1];return e.toString("utf16le",t,e.length-1)}function utf16End(e){var t=e&&e.length?this.write(e):"";if(this.lastNeed){var r=this.lastTotal-this.lastNeed;return t+this.lastChar.toString("utf16le",0,r)}return t}function base64Text(e,t){var r=(e.length-t)%3;if(r===0)return e.toString("base64",t);this.lastNeed=3-r;this.lastTotal=3;if(r===1){this.lastChar[0]=e[e.length-1]}else{this.lastChar[0]=e[e.length-2];this.lastChar[1]=e[e.length-1]}return e.toString("base64",t,e.length-r)}function base64End(e){var t=e&&e.length?this.write(e):"";if(this.lastNeed)return t+this.lastChar.toString("base64",0,3-this.lastNeed);return t}function simpleWrite(e){return e.toString(this.encoding)}function simpleEnd(e){return e&&e.length?this.write(e):""}},769:function(e){e.exports=deprecate;function deprecate(e,t){if(config("noDeprecation")){return e}var r=false;function deprecated(){if(!r){if(config("throwDeprecation")){throw new Error(t)}else if(config("traceDeprecation")){console.trace(t)}else{console.warn(t)}r=true}return e.apply(this,arguments)}return deprecated}function config(e){try{if(!__webpack_require__.g.localStorage)return false}catch(e){return false}var t=__webpack_require__.g.localStorage[e];if(null==t)return false;return String(t).toLowerCase()==="true"}},911:function(e){e.exports=extend;var t=Object.prototype.hasOwnProperty;function extend(){var e={};for(var r=0;r<arguments.length;r++){var n=arguments[r];for(var i in n){if(t.call(n,i)){e[i]=n[i]}}}return e}},300:function(e){"use strict";e.exports=__webpack_require__(55872)},361:function(e){"use strict";e.exports=__webpack_require__(72100)},781:function(e){"use strict";e.exports=__webpack_require__(41296)},310:function(e){"use strict";e.exports=__webpack_require__(31522)},837:function(e){"use strict";e.exports=__webpack_require__(93585)}};var t={};function __nccwpck_require__(r){var n=t[r];if(n!==undefined){return n.exports}var i=t[r]={exports:{}};var a=true;try{e[r](i,i.exports,__nccwpck_require__);a=false}finally{if(a)delete t[r]}return i.exports}if(typeof __nccwpck_require__!=="undefined")__nccwpck_require__.ab=__dirname+"/";var r=__nccwpck_require__(813);module.exports=r})();

/***/ }),

/***/ 27512:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(58727)


/***/ }),

/***/ 22220:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(8490)


/***/ }),

/***/ 17966:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(53485)


/***/ }),

/***/ 32779:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(48398)


/***/ }),

/***/ 93321:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var hasMap = typeof Map === 'function' && Map.prototype;
var mapSizeDescriptor = Object.getOwnPropertyDescriptor && hasMap ? Object.getOwnPropertyDescriptor(Map.prototype, 'size') : null;
var mapSize = hasMap && mapSizeDescriptor && typeof mapSizeDescriptor.get === 'function' ? mapSizeDescriptor.get : null;
var mapForEach = hasMap && Map.prototype.forEach;
var hasSet = typeof Set === 'function' && Set.prototype;
var setSizeDescriptor = Object.getOwnPropertyDescriptor && hasSet ? Object.getOwnPropertyDescriptor(Set.prototype, 'size') : null;
var setSize = hasSet && setSizeDescriptor && typeof setSizeDescriptor.get === 'function' ? setSizeDescriptor.get : null;
var setForEach = hasSet && Set.prototype.forEach;
var hasWeakMap = typeof WeakMap === 'function' && WeakMap.prototype;
var weakMapHas = hasWeakMap ? WeakMap.prototype.has : null;
var hasWeakSet = typeof WeakSet === 'function' && WeakSet.prototype;
var weakSetHas = hasWeakSet ? WeakSet.prototype.has : null;
var hasWeakRef = typeof WeakRef === 'function' && WeakRef.prototype;
var weakRefDeref = hasWeakRef ? WeakRef.prototype.deref : null;
var booleanValueOf = Boolean.prototype.valueOf;
var objectToString = Object.prototype.toString;
var functionToString = Function.prototype.toString;
var $match = String.prototype.match;
var $slice = String.prototype.slice;
var $replace = String.prototype.replace;
var $toUpperCase = String.prototype.toUpperCase;
var $toLowerCase = String.prototype.toLowerCase;
var $test = RegExp.prototype.test;
var $concat = Array.prototype.concat;
var $join = Array.prototype.join;
var $arrSlice = Array.prototype.slice;
var $floor = Math.floor;
var bigIntValueOf = typeof BigInt === 'function' ? BigInt.prototype.valueOf : null;
var gOPS = Object.getOwnPropertySymbols;
var symToString = typeof Symbol === 'function' && typeof Symbol.iterator === 'symbol' ? Symbol.prototype.toString : null;
var hasShammedSymbols = typeof Symbol === 'function' && typeof Symbol.iterator === 'object';
// ie, `has-tostringtag/shams
var toStringTag = typeof Symbol === 'function' && Symbol.toStringTag && (typeof Symbol.toStringTag === hasShammedSymbols ? 'object' : 'symbol')
    ? Symbol.toStringTag
    : null;
var isEnumerable = Object.prototype.propertyIsEnumerable;

var gPO = (typeof Reflect === 'function' ? Reflect.getPrototypeOf : Object.getPrototypeOf) || (
    [].__proto__ === Array.prototype // eslint-disable-line no-proto
        ? function (O) {
            return O.__proto__; // eslint-disable-line no-proto
        }
        : null
);

function addNumericSeparator(num, str) {
    if (
        num === Infinity
        || num === -Infinity
        || num !== num
        || (num && num > -1000 && num < 1000)
        || $test.call(/e/, str)
    ) {
        return str;
    }
    var sepRegex = /[0-9](?=(?:[0-9]{3})+(?![0-9]))/g;
    if (typeof num === 'number') {
        var int = num < 0 ? -$floor(-num) : $floor(num); // trunc(num)
        if (int !== num) {
            var intStr = String(int);
            var dec = $slice.call(str, intStr.length + 1);
            return $replace.call(intStr, sepRegex, '$&_') + '.' + $replace.call($replace.call(dec, /([0-9]{3})/g, '$&_'), /_$/, '');
        }
    }
    return $replace.call(str, sepRegex, '$&_');
}

var utilInspect = __webpack_require__(25040);
var inspectCustom = utilInspect.custom;
var inspectSymbol = isSymbol(inspectCustom) ? inspectCustom : null;

module.exports = function inspect_(obj, options, depth, seen) {
    var opts = options || {};

    if (has(opts, 'quoteStyle') && (opts.quoteStyle !== 'single' && opts.quoteStyle !== 'double')) {
        throw new TypeError('option "quoteStyle" must be "single" or "double"');
    }
    if (
        has(opts, 'maxStringLength') && (typeof opts.maxStringLength === 'number'
            ? opts.maxStringLength < 0 && opts.maxStringLength !== Infinity
            : opts.maxStringLength !== null
        )
    ) {
        throw new TypeError('option "maxStringLength", if provided, must be a positive integer, Infinity, or `null`');
    }
    var customInspect = has(opts, 'customInspect') ? opts.customInspect : true;
    if (typeof customInspect !== 'boolean' && customInspect !== 'symbol') {
        throw new TypeError('option "customInspect", if provided, must be `true`, `false`, or `\'symbol\'`');
    }

    if (
        has(opts, 'indent')
        && opts.indent !== null
        && opts.indent !== '\t'
        && !(parseInt(opts.indent, 10) === opts.indent && opts.indent > 0)
    ) {
        throw new TypeError('option "indent" must be "\\t", an integer > 0, or `null`');
    }
    if (has(opts, 'numericSeparator') && typeof opts.numericSeparator !== 'boolean') {
        throw new TypeError('option "numericSeparator", if provided, must be `true` or `false`');
    }
    var numericSeparator = opts.numericSeparator;

    if (typeof obj === 'undefined') {
        return 'undefined';
    }
    if (obj === null) {
        return 'null';
    }
    if (typeof obj === 'boolean') {
        return obj ? 'true' : 'false';
    }

    if (typeof obj === 'string') {
        return inspectString(obj, opts);
    }
    if (typeof obj === 'number') {
        if (obj === 0) {
            return Infinity / obj > 0 ? '0' : '-0';
        }
        var str = String(obj);
        return numericSeparator ? addNumericSeparator(obj, str) : str;
    }
    if (typeof obj === 'bigint') {
        var bigIntStr = String(obj) + 'n';
        return numericSeparator ? addNumericSeparator(obj, bigIntStr) : bigIntStr;
    }

    var maxDepth = typeof opts.depth === 'undefined' ? 5 : opts.depth;
    if (typeof depth === 'undefined') { depth = 0; }
    if (depth >= maxDepth && maxDepth > 0 && typeof obj === 'object') {
        return isArray(obj) ? '[Array]' : '[Object]';
    }

    var indent = getIndent(opts, depth);

    if (typeof seen === 'undefined') {
        seen = [];
    } else if (indexOf(seen, obj) >= 0) {
        return '[Circular]';
    }

    function inspect(value, from, noIndent) {
        if (from) {
            seen = $arrSlice.call(seen);
            seen.push(from);
        }
        if (noIndent) {
            var newOpts = {
                depth: opts.depth
            };
            if (has(opts, 'quoteStyle')) {
                newOpts.quoteStyle = opts.quoteStyle;
            }
            return inspect_(value, newOpts, depth + 1, seen);
        }
        return inspect_(value, opts, depth + 1, seen);
    }

    if (typeof obj === 'function' && !isRegExp(obj)) { // in older engines, regexes are callable
        var name = nameOf(obj);
        var keys = arrObjKeys(obj, inspect);
        return '[Function' + (name ? ': ' + name : ' (anonymous)') + ']' + (keys.length > 0 ? ' { ' + $join.call(keys, ', ') + ' }' : '');
    }
    if (isSymbol(obj)) {
        var symString = hasShammedSymbols ? $replace.call(String(obj), /^(Symbol\(.*\))_[^)]*$/, '$1') : symToString.call(obj);
        return typeof obj === 'object' && !hasShammedSymbols ? markBoxed(symString) : symString;
    }
    if (isElement(obj)) {
        var s = '<' + $toLowerCase.call(String(obj.nodeName));
        var attrs = obj.attributes || [];
        for (var i = 0; i < attrs.length; i++) {
            s += ' ' + attrs[i].name + '=' + wrapQuotes(quote(attrs[i].value), 'double', opts);
        }
        s += '>';
        if (obj.childNodes && obj.childNodes.length) { s += '...'; }
        s += '</' + $toLowerCase.call(String(obj.nodeName)) + '>';
        return s;
    }
    if (isArray(obj)) {
        if (obj.length === 0) { return '[]'; }
        var xs = arrObjKeys(obj, inspect);
        if (indent && !singleLineValues(xs)) {
            return '[' + indentedJoin(xs, indent) + ']';
        }
        return '[ ' + $join.call(xs, ', ') + ' ]';
    }
    if (isError(obj)) {
        var parts = arrObjKeys(obj, inspect);
        if (!('cause' in Error.prototype) && 'cause' in obj && !isEnumerable.call(obj, 'cause')) {
            return '{ [' + String(obj) + '] ' + $join.call($concat.call('[cause]: ' + inspect(obj.cause), parts), ', ') + ' }';
        }
        if (parts.length === 0) { return '[' + String(obj) + ']'; }
        return '{ [' + String(obj) + '] ' + $join.call(parts, ', ') + ' }';
    }
    if (typeof obj === 'object' && customInspect) {
        if (inspectSymbol && typeof obj[inspectSymbol] === 'function' && utilInspect) {
            return utilInspect(obj, { depth: maxDepth - depth });
        } else if (customInspect !== 'symbol' && typeof obj.inspect === 'function') {
            return obj.inspect();
        }
    }
    if (isMap(obj)) {
        var mapParts = [];
        if (mapForEach) {
            mapForEach.call(obj, function (value, key) {
                mapParts.push(inspect(key, obj, true) + ' => ' + inspect(value, obj));
            });
        }
        return collectionOf('Map', mapSize.call(obj), mapParts, indent);
    }
    if (isSet(obj)) {
        var setParts = [];
        if (setForEach) {
            setForEach.call(obj, function (value) {
                setParts.push(inspect(value, obj));
            });
        }
        return collectionOf('Set', setSize.call(obj), setParts, indent);
    }
    if (isWeakMap(obj)) {
        return weakCollectionOf('WeakMap');
    }
    if (isWeakSet(obj)) {
        return weakCollectionOf('WeakSet');
    }
    if (isWeakRef(obj)) {
        return weakCollectionOf('WeakRef');
    }
    if (isNumber(obj)) {
        return markBoxed(inspect(Number(obj)));
    }
    if (isBigInt(obj)) {
        return markBoxed(inspect(bigIntValueOf.call(obj)));
    }
    if (isBoolean(obj)) {
        return markBoxed(booleanValueOf.call(obj));
    }
    if (isString(obj)) {
        return markBoxed(inspect(String(obj)));
    }
    // note: in IE 8, sometimes `global !== window` but both are the prototypes of each other
    /* eslint-env browser */
    if (typeof window !== 'undefined' && obj === window) {
        return '{ [object Window] }';
    }
    if (
        (typeof globalThis !== 'undefined' && obj === globalThis)
        || (typeof __webpack_require__.g !== 'undefined' && obj === __webpack_require__.g)
    ) {
        return '{ [object globalThis] }';
    }
    if (!isDate(obj) && !isRegExp(obj)) {
        var ys = arrObjKeys(obj, inspect);
        var isPlainObject = gPO ? gPO(obj) === Object.prototype : obj instanceof Object || obj.constructor === Object;
        var protoTag = obj instanceof Object ? '' : 'null prototype';
        var stringTag = !isPlainObject && toStringTag && Object(obj) === obj && toStringTag in obj ? $slice.call(toStr(obj), 8, -1) : protoTag ? 'Object' : '';
        var constructorTag = isPlainObject || typeof obj.constructor !== 'function' ? '' : obj.constructor.name ? obj.constructor.name + ' ' : '';
        var tag = constructorTag + (stringTag || protoTag ? '[' + $join.call($concat.call([], stringTag || [], protoTag || []), ': ') + '] ' : '');
        if (ys.length === 0) { return tag + '{}'; }
        if (indent) {
            return tag + '{' + indentedJoin(ys, indent) + '}';
        }
        return tag + '{ ' + $join.call(ys, ', ') + ' }';
    }
    return String(obj);
};

function wrapQuotes(s, defaultStyle, opts) {
    var quoteChar = (opts.quoteStyle || defaultStyle) === 'double' ? '"' : "'";
    return quoteChar + s + quoteChar;
}

function quote(s) {
    return $replace.call(String(s), /"/g, '&quot;');
}

function isArray(obj) { return toStr(obj) === '[object Array]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj)); }
function isDate(obj) { return toStr(obj) === '[object Date]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj)); }
function isRegExp(obj) { return toStr(obj) === '[object RegExp]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj)); }
function isError(obj) { return toStr(obj) === '[object Error]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj)); }
function isString(obj) { return toStr(obj) === '[object String]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj)); }
function isNumber(obj) { return toStr(obj) === '[object Number]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj)); }
function isBoolean(obj) { return toStr(obj) === '[object Boolean]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj)); }

// Symbol and BigInt do have Symbol.toStringTag by spec, so that can't be used to eliminate false positives
function isSymbol(obj) {
    if (hasShammedSymbols) {
        return obj && typeof obj === 'object' && obj instanceof Symbol;
    }
    if (typeof obj === 'symbol') {
        return true;
    }
    if (!obj || typeof obj !== 'object' || !symToString) {
        return false;
    }
    try {
        symToString.call(obj);
        return true;
    } catch (e) {}
    return false;
}

function isBigInt(obj) {
    if (!obj || typeof obj !== 'object' || !bigIntValueOf) {
        return false;
    }
    try {
        bigIntValueOf.call(obj);
        return true;
    } catch (e) {}
    return false;
}

var hasOwn = Object.prototype.hasOwnProperty || function (key) { return key in this; };
function has(obj, key) {
    return hasOwn.call(obj, key);
}

function toStr(obj) {
    return objectToString.call(obj);
}

function nameOf(f) {
    if (f.name) { return f.name; }
    var m = $match.call(functionToString.call(f), /^function\s*([\w$]+)/);
    if (m) { return m[1]; }
    return null;
}

function indexOf(xs, x) {
    if (xs.indexOf) { return xs.indexOf(x); }
    for (var i = 0, l = xs.length; i < l; i++) {
        if (xs[i] === x) { return i; }
    }
    return -1;
}

function isMap(x) {
    if (!mapSize || !x || typeof x !== 'object') {
        return false;
    }
    try {
        mapSize.call(x);
        try {
            setSize.call(x);
        } catch (s) {
            return true;
        }
        return x instanceof Map; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}

function isWeakMap(x) {
    if (!weakMapHas || !x || typeof x !== 'object') {
        return false;
    }
    try {
        weakMapHas.call(x, weakMapHas);
        try {
            weakSetHas.call(x, weakSetHas);
        } catch (s) {
            return true;
        }
        return x instanceof WeakMap; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}

function isWeakRef(x) {
    if (!weakRefDeref || !x || typeof x !== 'object') {
        return false;
    }
    try {
        weakRefDeref.call(x);
        return true;
    } catch (e) {}
    return false;
}

function isSet(x) {
    if (!setSize || !x || typeof x !== 'object') {
        return false;
    }
    try {
        setSize.call(x);
        try {
            mapSize.call(x);
        } catch (m) {
            return true;
        }
        return x instanceof Set; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}

function isWeakSet(x) {
    if (!weakSetHas || !x || typeof x !== 'object') {
        return false;
    }
    try {
        weakSetHas.call(x, weakSetHas);
        try {
            weakMapHas.call(x, weakMapHas);
        } catch (s) {
            return true;
        }
        return x instanceof WeakSet; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}

function isElement(x) {
    if (!x || typeof x !== 'object') { return false; }
    if (typeof HTMLElement !== 'undefined' && x instanceof HTMLElement) {
        return true;
    }
    return typeof x.nodeName === 'string' && typeof x.getAttribute === 'function';
}

function inspectString(str, opts) {
    if (str.length > opts.maxStringLength) {
        var remaining = str.length - opts.maxStringLength;
        var trailer = '... ' + remaining + ' more character' + (remaining > 1 ? 's' : '');
        return inspectString($slice.call(str, 0, opts.maxStringLength), opts) + trailer;
    }
    // eslint-disable-next-line no-control-regex
    var s = $replace.call($replace.call(str, /(['\\])/g, '\\$1'), /[\x00-\x1f]/g, lowbyte);
    return wrapQuotes(s, 'single', opts);
}

function lowbyte(c) {
    var n = c.charCodeAt(0);
    var x = {
        8: 'b',
        9: 't',
        10: 'n',
        12: 'f',
        13: 'r'
    }[n];
    if (x) { return '\\' + x; }
    return '\\x' + (n < 0x10 ? '0' : '') + $toUpperCase.call(n.toString(16));
}

function markBoxed(str) {
    return 'Object(' + str + ')';
}

function weakCollectionOf(type) {
    return type + ' { ? }';
}

function collectionOf(type, size, entries, indent) {
    var joinedEntries = indent ? indentedJoin(entries, indent) : $join.call(entries, ', ');
    return type + ' (' + size + ') {' + joinedEntries + '}';
}

function singleLineValues(xs) {
    for (var i = 0; i < xs.length; i++) {
        if (indexOf(xs[i], '\n') >= 0) {
            return false;
        }
    }
    return true;
}

function getIndent(opts, depth) {
    var baseIndent;
    if (opts.indent === '\t') {
        baseIndent = '\t';
    } else if (typeof opts.indent === 'number' && opts.indent > 0) {
        baseIndent = $join.call(Array(opts.indent + 1), ' ');
    } else {
        return null;
    }
    return {
        base: baseIndent,
        prev: $join.call(Array(depth + 1), baseIndent)
    };
}

function indentedJoin(xs, indent) {
    if (xs.length === 0) { return ''; }
    var lineJoiner = '\n' + indent.prev + indent.base;
    return lineJoiner + $join.call(xs, ',' + lineJoiner) + '\n' + indent.prev;
}

function arrObjKeys(obj, inspect) {
    var isArr = isArray(obj);
    var xs = [];
    if (isArr) {
        xs.length = obj.length;
        for (var i = 0; i < obj.length; i++) {
            xs[i] = has(obj, i) ? inspect(obj[i], obj) : '';
        }
    }
    var syms = typeof gOPS === 'function' ? gOPS(obj) : [];
    var symMap;
    if (hasShammedSymbols) {
        symMap = {};
        for (var k = 0; k < syms.length; k++) {
            symMap['$' + syms[k]] = syms[k];
        }
    }

    for (var key in obj) { // eslint-disable-line no-restricted-syntax
        if (!has(obj, key)) { continue; } // eslint-disable-line no-restricted-syntax, no-continue
        if (isArr && String(Number(key)) === key && key < obj.length) { continue; } // eslint-disable-line no-restricted-syntax, no-continue
        if (hasShammedSymbols && symMap['$' + key] instanceof Symbol) {
            // this is to prevent shammed Symbols, which are stored as strings, from being included in the string key section
            continue; // eslint-disable-line no-restricted-syntax, no-continue
        } else if ($test.call(/[^\w$]/, key)) {
            xs.push(inspect(key, obj) + ': ' + inspect(obj[key], obj));
        } else {
            xs.push(key + ': ' + inspect(obj[key], obj));
        }
    }
    if (typeof gOPS === 'function') {
        for (var j = 0; j < syms.length; j++) {
            if (isEnumerable.call(obj, syms[j])) {
                xs.push('[' + inspect(syms[j]) + ']: ' + inspect(obj[syms[j]], obj));
            }
        }
    }
    return xs;
}


/***/ }),

/***/ 44766:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var name = __webpack_require__(17952);

/**
 * Wrap callbacks to prevent double execution.
 *
 * @param {Function} fn Function that should only be called once.
 * @returns {Function} A wrapped callback which prevents multiple executions.
 * @public
 */
module.exports = function one(fn) {
  var called = 0
    , value;

  /**
   * The function that prevents double execution.
   *
   * @private
   */
  function onetime() {
    if (called) return value;

    called = 1;
    value = fn.apply(this, arguments);
    fn = null;

    return value;
  }

  //
  // To make debugging more easy we want to use the name of the supplied
  // function. So when you look at the functions that are assigned to event
  // listeners you don't see a load of `onetime` functions but actually the
  // names of the functions that this module will call.
  //
  // NOTE: We cannot override the `name` property, as that is `readOnly`
  // property, so displayName will have to do.
  //
  onetime.displayName = name(fn);
  return onetime;
};


/***/ }),

/***/ 41758:
/***/ (function(module) {

"use strict";


/** @type {import('.')} */
module.exports = [
	'Float32Array',
	'Float64Array',
	'Int8Array',
	'Int16Array',
	'Int32Array',
	'Uint8Array',
	'Uint8ClampedArray',
	'Uint16Array',
	'Uint32Array',
	'BigInt64Array',
	'BigUint64Array'
];


/***/ }),

/***/ 14224:
/***/ (function(module) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),

/***/ 74049:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = __webpack_require__(36257);

function emptyFunction() {}
function emptyFunctionWithReset() {}
emptyFunctionWithReset.resetWarningCache = emptyFunction;

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error(
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
    err.name = 'Invariant Violation';
    throw err;
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bigint: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    elementType: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim,

    checkPropTypes: emptyFunctionWithReset,
    resetWarningCache: emptyFunction
  };

  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),

/***/ 40507:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) { var throwOnDirectAccess, ReactIs; } else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(74049)();
}


/***/ }),

/***/ 36257:
/***/ (function(module) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),

/***/ 37165:
/***/ (function(module) {

"use strict";


var replace = String.prototype.replace;
var percentTwenties = /%20/g;

var Format = {
    RFC1738: 'RFC1738',
    RFC3986: 'RFC3986'
};

module.exports = {
    'default': Format.RFC3986,
    formatters: {
        RFC1738: function (value) {
            return replace.call(value, percentTwenties, '+');
        },
        RFC3986: function (value) {
            return String(value);
        }
    },
    RFC1738: Format.RFC1738,
    RFC3986: Format.RFC3986
};


/***/ }),

/***/ 93672:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var stringify = __webpack_require__(2069);
var parse = __webpack_require__(88287);
var formats = __webpack_require__(37165);

module.exports = {
    formats: formats,
    parse: parse,
    stringify: stringify
};


/***/ }),

/***/ 88287:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(31204);

var has = Object.prototype.hasOwnProperty;
var isArray = Array.isArray;

var defaults = {
    allowDots: false,
    allowEmptyArrays: false,
    allowPrototypes: false,
    allowSparse: false,
    arrayLimit: 20,
    charset: 'utf-8',
    charsetSentinel: false,
    comma: false,
    decodeDotInKeys: false,
    decoder: utils.decode,
    delimiter: '&',
    depth: 5,
    duplicates: 'combine',
    ignoreQueryPrefix: false,
    interpretNumericEntities: false,
    parameterLimit: 1000,
    parseArrays: true,
    plainObjects: false,
    strictDepth: false,
    strictNullHandling: false
};

var interpretNumericEntities = function (str) {
    return str.replace(/&#(\d+);/g, function ($0, numberStr) {
        return String.fromCharCode(parseInt(numberStr, 10));
    });
};

var parseArrayValue = function (val, options) {
    if (val && typeof val === 'string' && options.comma && val.indexOf(',') > -1) {
        return val.split(',');
    }

    return val;
};

// This is what browsers will submit when the ✓ character occurs in an
// application/x-www-form-urlencoded body and the encoding of the page containing
// the form is iso-8859-1, or when the submitted form has an accept-charset
// attribute of iso-8859-1. Presumably also with other charsets that do not contain
// the ✓ character, such as us-ascii.
var isoSentinel = 'utf8=%26%2310003%3B'; // encodeURIComponent('&#10003;')

// These are the percent-encoded utf-8 octets representing a checkmark, indicating that the request actually is utf-8 encoded.
var charsetSentinel = 'utf8=%E2%9C%93'; // encodeURIComponent('✓')

var parseValues = function parseQueryStringValues(str, options) {
    var obj = { __proto__: null };

    var cleanStr = options.ignoreQueryPrefix ? str.replace(/^\?/, '') : str;
    cleanStr = cleanStr.replace(/%5B/gi, '[').replace(/%5D/gi, ']');
    var limit = options.parameterLimit === Infinity ? undefined : options.parameterLimit;
    var parts = cleanStr.split(options.delimiter, limit);
    var skipIndex = -1; // Keep track of where the utf8 sentinel was found
    var i;

    var charset = options.charset;
    if (options.charsetSentinel) {
        for (i = 0; i < parts.length; ++i) {
            if (parts[i].indexOf('utf8=') === 0) {
                if (parts[i] === charsetSentinel) {
                    charset = 'utf-8';
                } else if (parts[i] === isoSentinel) {
                    charset = 'iso-8859-1';
                }
                skipIndex = i;
                i = parts.length; // The eslint settings do not allow break;
            }
        }
    }

    for (i = 0; i < parts.length; ++i) {
        if (i === skipIndex) {
            continue;
        }
        var part = parts[i];

        var bracketEqualsPos = part.indexOf(']=');
        var pos = bracketEqualsPos === -1 ? part.indexOf('=') : bracketEqualsPos + 1;

        var key, val;
        if (pos === -1) {
            key = options.decoder(part, defaults.decoder, charset, 'key');
            val = options.strictNullHandling ? null : '';
        } else {
            key = options.decoder(part.slice(0, pos), defaults.decoder, charset, 'key');
            val = utils.maybeMap(
                parseArrayValue(part.slice(pos + 1), options),
                function (encodedVal) {
                    return options.decoder(encodedVal, defaults.decoder, charset, 'value');
                }
            );
        }

        if (val && options.interpretNumericEntities && charset === 'iso-8859-1') {
            val = interpretNumericEntities(val);
        }

        if (part.indexOf('[]=') > -1) {
            val = isArray(val) ? [val] : val;
        }

        var existing = has.call(obj, key);
        if (existing && options.duplicates === 'combine') {
            obj[key] = utils.combine(obj[key], val);
        } else if (!existing || options.duplicates === 'last') {
            obj[key] = val;
        }
    }

    return obj;
};

var parseObject = function (chain, val, options, valuesParsed) {
    var leaf = valuesParsed ? val : parseArrayValue(val, options);

    for (var i = chain.length - 1; i >= 0; --i) {
        var obj;
        var root = chain[i];

        if (root === '[]' && options.parseArrays) {
            obj = options.allowEmptyArrays && (leaf === '' || (options.strictNullHandling && leaf === null))
                ? []
                : [].concat(leaf);
        } else {
            obj = options.plainObjects ? Object.create(null) : {};
            var cleanRoot = root.charAt(0) === '[' && root.charAt(root.length - 1) === ']' ? root.slice(1, -1) : root;
            var decodedRoot = options.decodeDotInKeys ? cleanRoot.replace(/%2E/g, '.') : cleanRoot;
            var index = parseInt(decodedRoot, 10);
            if (!options.parseArrays && decodedRoot === '') {
                obj = { 0: leaf };
            } else if (
                !isNaN(index)
                && root !== decodedRoot
                && String(index) === decodedRoot
                && index >= 0
                && (options.parseArrays && index <= options.arrayLimit)
            ) {
                obj = [];
                obj[index] = leaf;
            } else if (decodedRoot !== '__proto__') {
                obj[decodedRoot] = leaf;
            }
        }

        leaf = obj;
    }

    return leaf;
};

var parseKeys = function parseQueryStringKeys(givenKey, val, options, valuesParsed) {
    if (!givenKey) {
        return;
    }

    // Transform dot notation to bracket notation
    var key = options.allowDots ? givenKey.replace(/\.([^.[]+)/g, '[$1]') : givenKey;

    // The regex chunks

    var brackets = /(\[[^[\]]*])/;
    var child = /(\[[^[\]]*])/g;

    // Get the parent

    var segment = options.depth > 0 && brackets.exec(key);
    var parent = segment ? key.slice(0, segment.index) : key;

    // Stash the parent if it exists

    var keys = [];
    if (parent) {
        // If we aren't using plain objects, optionally prefix keys that would overwrite object prototype properties
        if (!options.plainObjects && has.call(Object.prototype, parent)) {
            if (!options.allowPrototypes) {
                return;
            }
        }

        keys.push(parent);
    }

    // Loop through children appending to the array until we hit depth

    var i = 0;
    while (options.depth > 0 && (segment = child.exec(key)) !== null && i < options.depth) {
        i += 1;
        if (!options.plainObjects && has.call(Object.prototype, segment[1].slice(1, -1))) {
            if (!options.allowPrototypes) {
                return;
            }
        }
        keys.push(segment[1]);
    }

    // If there's a remainder, check strictDepth option for throw, else just add whatever is left

    if (segment) {
        if (options.strictDepth === true) {
            throw new RangeError('Input depth exceeded depth option of ' + options.depth + ' and strictDepth is true');
        }
        keys.push('[' + key.slice(segment.index) + ']');
    }

    return parseObject(keys, val, options, valuesParsed);
};

var normalizeParseOptions = function normalizeParseOptions(opts) {
    if (!opts) {
        return defaults;
    }

    if (typeof opts.allowEmptyArrays !== 'undefined' && typeof opts.allowEmptyArrays !== 'boolean') {
        throw new TypeError('`allowEmptyArrays` option can only be `true` or `false`, when provided');
    }

    if (typeof opts.decodeDotInKeys !== 'undefined' && typeof opts.decodeDotInKeys !== 'boolean') {
        throw new TypeError('`decodeDotInKeys` option can only be `true` or `false`, when provided');
    }

    if (opts.decoder !== null && typeof opts.decoder !== 'undefined' && typeof opts.decoder !== 'function') {
        throw new TypeError('Decoder has to be a function.');
    }

    if (typeof opts.charset !== 'undefined' && opts.charset !== 'utf-8' && opts.charset !== 'iso-8859-1') {
        throw new TypeError('The charset option must be either utf-8, iso-8859-1, or undefined');
    }
    var charset = typeof opts.charset === 'undefined' ? defaults.charset : opts.charset;

    var duplicates = typeof opts.duplicates === 'undefined' ? defaults.duplicates : opts.duplicates;

    if (duplicates !== 'combine' && duplicates !== 'first' && duplicates !== 'last') {
        throw new TypeError('The duplicates option must be either combine, first, or last');
    }

    var allowDots = typeof opts.allowDots === 'undefined' ? opts.decodeDotInKeys === true ? true : defaults.allowDots : !!opts.allowDots;

    return {
        allowDots: allowDots,
        allowEmptyArrays: typeof opts.allowEmptyArrays === 'boolean' ? !!opts.allowEmptyArrays : defaults.allowEmptyArrays,
        allowPrototypes: typeof opts.allowPrototypes === 'boolean' ? opts.allowPrototypes : defaults.allowPrototypes,
        allowSparse: typeof opts.allowSparse === 'boolean' ? opts.allowSparse : defaults.allowSparse,
        arrayLimit: typeof opts.arrayLimit === 'number' ? opts.arrayLimit : defaults.arrayLimit,
        charset: charset,
        charsetSentinel: typeof opts.charsetSentinel === 'boolean' ? opts.charsetSentinel : defaults.charsetSentinel,
        comma: typeof opts.comma === 'boolean' ? opts.comma : defaults.comma,
        decodeDotInKeys: typeof opts.decodeDotInKeys === 'boolean' ? opts.decodeDotInKeys : defaults.decodeDotInKeys,
        decoder: typeof opts.decoder === 'function' ? opts.decoder : defaults.decoder,
        delimiter: typeof opts.delimiter === 'string' || utils.isRegExp(opts.delimiter) ? opts.delimiter : defaults.delimiter,
        // eslint-disable-next-line no-implicit-coercion, no-extra-parens
        depth: (typeof opts.depth === 'number' || opts.depth === false) ? +opts.depth : defaults.depth,
        duplicates: duplicates,
        ignoreQueryPrefix: opts.ignoreQueryPrefix === true,
        interpretNumericEntities: typeof opts.interpretNumericEntities === 'boolean' ? opts.interpretNumericEntities : defaults.interpretNumericEntities,
        parameterLimit: typeof opts.parameterLimit === 'number' ? opts.parameterLimit : defaults.parameterLimit,
        parseArrays: opts.parseArrays !== false,
        plainObjects: typeof opts.plainObjects === 'boolean' ? opts.plainObjects : defaults.plainObjects,
        strictDepth: typeof opts.strictDepth === 'boolean' ? !!opts.strictDepth : defaults.strictDepth,
        strictNullHandling: typeof opts.strictNullHandling === 'boolean' ? opts.strictNullHandling : defaults.strictNullHandling
    };
};

module.exports = function (str, opts) {
    var options = normalizeParseOptions(opts);

    if (str === '' || str === null || typeof str === 'undefined') {
        return options.plainObjects ? Object.create(null) : {};
    }

    var tempObj = typeof str === 'string' ? parseValues(str, options) : str;
    var obj = options.plainObjects ? Object.create(null) : {};

    // Iterate over the keys and setup the new object

    var keys = Object.keys(tempObj);
    for (var i = 0; i < keys.length; ++i) {
        var key = keys[i];
        var newObj = parseKeys(key, tempObj[key], options, typeof str === 'string');
        obj = utils.merge(obj, newObj, options);
    }

    if (options.allowSparse === true) {
        return obj;
    }

    return utils.compact(obj);
};


/***/ }),

/***/ 2069:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var getSideChannel = __webpack_require__(77700);
var utils = __webpack_require__(31204);
var formats = __webpack_require__(37165);
var has = Object.prototype.hasOwnProperty;

var arrayPrefixGenerators = {
    brackets: function brackets(prefix) {
        return prefix + '[]';
    },
    comma: 'comma',
    indices: function indices(prefix, key) {
        return prefix + '[' + key + ']';
    },
    repeat: function repeat(prefix) {
        return prefix;
    }
};

var isArray = Array.isArray;
var push = Array.prototype.push;
var pushToArray = function (arr, valueOrArray) {
    push.apply(arr, isArray(valueOrArray) ? valueOrArray : [valueOrArray]);
};

var toISO = Date.prototype.toISOString;

var defaultFormat = formats['default'];
var defaults = {
    addQueryPrefix: false,
    allowDots: false,
    allowEmptyArrays: false,
    arrayFormat: 'indices',
    charset: 'utf-8',
    charsetSentinel: false,
    delimiter: '&',
    encode: true,
    encodeDotInKeys: false,
    encoder: utils.encode,
    encodeValuesOnly: false,
    format: defaultFormat,
    formatter: formats.formatters[defaultFormat],
    // deprecated
    indices: false,
    serializeDate: function serializeDate(date) {
        return toISO.call(date);
    },
    skipNulls: false,
    strictNullHandling: false
};

var isNonNullishPrimitive = function isNonNullishPrimitive(v) {
    return typeof v === 'string'
        || typeof v === 'number'
        || typeof v === 'boolean'
        || typeof v === 'symbol'
        || typeof v === 'bigint';
};

var sentinel = {};

var stringify = function stringify(
    object,
    prefix,
    generateArrayPrefix,
    commaRoundTrip,
    allowEmptyArrays,
    strictNullHandling,
    skipNulls,
    encodeDotInKeys,
    encoder,
    filter,
    sort,
    allowDots,
    serializeDate,
    format,
    formatter,
    encodeValuesOnly,
    charset,
    sideChannel
) {
    var obj = object;

    var tmpSc = sideChannel;
    var step = 0;
    var findFlag = false;
    while ((tmpSc = tmpSc.get(sentinel)) !== void undefined && !findFlag) {
        // Where object last appeared in the ref tree
        var pos = tmpSc.get(object);
        step += 1;
        if (typeof pos !== 'undefined') {
            if (pos === step) {
                throw new RangeError('Cyclic object value');
            } else {
                findFlag = true; // Break while
            }
        }
        if (typeof tmpSc.get(sentinel) === 'undefined') {
            step = 0;
        }
    }

    if (typeof filter === 'function') {
        obj = filter(prefix, obj);
    } else if (obj instanceof Date) {
        obj = serializeDate(obj);
    } else if (generateArrayPrefix === 'comma' && isArray(obj)) {
        obj = utils.maybeMap(obj, function (value) {
            if (value instanceof Date) {
                return serializeDate(value);
            }
            return value;
        });
    }

    if (obj === null) {
        if (strictNullHandling) {
            return encoder && !encodeValuesOnly ? encoder(prefix, defaults.encoder, charset, 'key', format) : prefix;
        }

        obj = '';
    }

    if (isNonNullishPrimitive(obj) || utils.isBuffer(obj)) {
        if (encoder) {
            var keyValue = encodeValuesOnly ? prefix : encoder(prefix, defaults.encoder, charset, 'key', format);
            return [formatter(keyValue) + '=' + formatter(encoder(obj, defaults.encoder, charset, 'value', format))];
        }
        return [formatter(prefix) + '=' + formatter(String(obj))];
    }

    var values = [];

    if (typeof obj === 'undefined') {
        return values;
    }

    var objKeys;
    if (generateArrayPrefix === 'comma' && isArray(obj)) {
        // we need to join elements in
        if (encodeValuesOnly && encoder) {
            obj = utils.maybeMap(obj, encoder);
        }
        objKeys = [{ value: obj.length > 0 ? obj.join(',') || null : void undefined }];
    } else if (isArray(filter)) {
        objKeys = filter;
    } else {
        var keys = Object.keys(obj);
        objKeys = sort ? keys.sort(sort) : keys;
    }

    var encodedPrefix = encodeDotInKeys ? prefix.replace(/\./g, '%2E') : prefix;

    var adjustedPrefix = commaRoundTrip && isArray(obj) && obj.length === 1 ? encodedPrefix + '[]' : encodedPrefix;

    if (allowEmptyArrays && isArray(obj) && obj.length === 0) {
        return adjustedPrefix + '[]';
    }

    for (var j = 0; j < objKeys.length; ++j) {
        var key = objKeys[j];
        var value = typeof key === 'object' && typeof key.value !== 'undefined' ? key.value : obj[key];

        if (skipNulls && value === null) {
            continue;
        }

        var encodedKey = allowDots && encodeDotInKeys ? key.replace(/\./g, '%2E') : key;
        var keyPrefix = isArray(obj)
            ? typeof generateArrayPrefix === 'function' ? generateArrayPrefix(adjustedPrefix, encodedKey) : adjustedPrefix
            : adjustedPrefix + (allowDots ? '.' + encodedKey : '[' + encodedKey + ']');

        sideChannel.set(object, step);
        var valueSideChannel = getSideChannel();
        valueSideChannel.set(sentinel, sideChannel);
        pushToArray(values, stringify(
            value,
            keyPrefix,
            generateArrayPrefix,
            commaRoundTrip,
            allowEmptyArrays,
            strictNullHandling,
            skipNulls,
            encodeDotInKeys,
            generateArrayPrefix === 'comma' && encodeValuesOnly && isArray(obj) ? null : encoder,
            filter,
            sort,
            allowDots,
            serializeDate,
            format,
            formatter,
            encodeValuesOnly,
            charset,
            valueSideChannel
        ));
    }

    return values;
};

var normalizeStringifyOptions = function normalizeStringifyOptions(opts) {
    if (!opts) {
        return defaults;
    }

    if (typeof opts.allowEmptyArrays !== 'undefined' && typeof opts.allowEmptyArrays !== 'boolean') {
        throw new TypeError('`allowEmptyArrays` option can only be `true` or `false`, when provided');
    }

    if (typeof opts.encodeDotInKeys !== 'undefined' && typeof opts.encodeDotInKeys !== 'boolean') {
        throw new TypeError('`encodeDotInKeys` option can only be `true` or `false`, when provided');
    }

    if (opts.encoder !== null && typeof opts.encoder !== 'undefined' && typeof opts.encoder !== 'function') {
        throw new TypeError('Encoder has to be a function.');
    }

    var charset = opts.charset || defaults.charset;
    if (typeof opts.charset !== 'undefined' && opts.charset !== 'utf-8' && opts.charset !== 'iso-8859-1') {
        throw new TypeError('The charset option must be either utf-8, iso-8859-1, or undefined');
    }

    var format = formats['default'];
    if (typeof opts.format !== 'undefined') {
        if (!has.call(formats.formatters, opts.format)) {
            throw new TypeError('Unknown format option provided.');
        }
        format = opts.format;
    }
    var formatter = formats.formatters[format];

    var filter = defaults.filter;
    if (typeof opts.filter === 'function' || isArray(opts.filter)) {
        filter = opts.filter;
    }

    var arrayFormat;
    if (opts.arrayFormat in arrayPrefixGenerators) {
        arrayFormat = opts.arrayFormat;
    } else if ('indices' in opts) {
        arrayFormat = opts.indices ? 'indices' : 'repeat';
    } else {
        arrayFormat = defaults.arrayFormat;
    }

    if ('commaRoundTrip' in opts && typeof opts.commaRoundTrip !== 'boolean') {
        throw new TypeError('`commaRoundTrip` must be a boolean, or absent');
    }

    var allowDots = typeof opts.allowDots === 'undefined' ? opts.encodeDotInKeys === true ? true : defaults.allowDots : !!opts.allowDots;

    return {
        addQueryPrefix: typeof opts.addQueryPrefix === 'boolean' ? opts.addQueryPrefix : defaults.addQueryPrefix,
        allowDots: allowDots,
        allowEmptyArrays: typeof opts.allowEmptyArrays === 'boolean' ? !!opts.allowEmptyArrays : defaults.allowEmptyArrays,
        arrayFormat: arrayFormat,
        charset: charset,
        charsetSentinel: typeof opts.charsetSentinel === 'boolean' ? opts.charsetSentinel : defaults.charsetSentinel,
        commaRoundTrip: opts.commaRoundTrip,
        delimiter: typeof opts.delimiter === 'undefined' ? defaults.delimiter : opts.delimiter,
        encode: typeof opts.encode === 'boolean' ? opts.encode : defaults.encode,
        encodeDotInKeys: typeof opts.encodeDotInKeys === 'boolean' ? opts.encodeDotInKeys : defaults.encodeDotInKeys,
        encoder: typeof opts.encoder === 'function' ? opts.encoder : defaults.encoder,
        encodeValuesOnly: typeof opts.encodeValuesOnly === 'boolean' ? opts.encodeValuesOnly : defaults.encodeValuesOnly,
        filter: filter,
        format: format,
        formatter: formatter,
        serializeDate: typeof opts.serializeDate === 'function' ? opts.serializeDate : defaults.serializeDate,
        skipNulls: typeof opts.skipNulls === 'boolean' ? opts.skipNulls : defaults.skipNulls,
        sort: typeof opts.sort === 'function' ? opts.sort : null,
        strictNullHandling: typeof opts.strictNullHandling === 'boolean' ? opts.strictNullHandling : defaults.strictNullHandling
    };
};

module.exports = function (object, opts) {
    var obj = object;
    var options = normalizeStringifyOptions(opts);

    var objKeys;
    var filter;

    if (typeof options.filter === 'function') {
        filter = options.filter;
        obj = filter('', obj);
    } else if (isArray(options.filter)) {
        filter = options.filter;
        objKeys = filter;
    }

    var keys = [];

    if (typeof obj !== 'object' || obj === null) {
        return '';
    }

    var generateArrayPrefix = arrayPrefixGenerators[options.arrayFormat];
    var commaRoundTrip = generateArrayPrefix === 'comma' && options.commaRoundTrip;

    if (!objKeys) {
        objKeys = Object.keys(obj);
    }

    if (options.sort) {
        objKeys.sort(options.sort);
    }

    var sideChannel = getSideChannel();
    for (var i = 0; i < objKeys.length; ++i) {
        var key = objKeys[i];

        if (options.skipNulls && obj[key] === null) {
            continue;
        }
        pushToArray(keys, stringify(
            obj[key],
            key,
            generateArrayPrefix,
            commaRoundTrip,
            options.allowEmptyArrays,
            options.strictNullHandling,
            options.skipNulls,
            options.encodeDotInKeys,
            options.encode ? options.encoder : null,
            options.filter,
            options.sort,
            options.allowDots,
            options.serializeDate,
            options.format,
            options.formatter,
            options.encodeValuesOnly,
            options.charset,
            sideChannel
        ));
    }

    var joined = keys.join(options.delimiter);
    var prefix = options.addQueryPrefix === true ? '?' : '';

    if (options.charsetSentinel) {
        if (options.charset === 'iso-8859-1') {
            // encodeURIComponent('&#10003;'), the "numeric entity" representation of a checkmark
            prefix += 'utf8=%26%2310003%3B&';
        } else {
            // encodeURIComponent('✓')
            prefix += 'utf8=%E2%9C%93&';
        }
    }

    return joined.length > 0 ? prefix + joined : '';
};


/***/ }),

/***/ 31204:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var formats = __webpack_require__(37165);

var has = Object.prototype.hasOwnProperty;
var isArray = Array.isArray;

var hexTable = (function () {
    var array = [];
    for (var i = 0; i < 256; ++i) {
        array.push('%' + ((i < 16 ? '0' : '') + i.toString(16)).toUpperCase());
    }

    return array;
}());

var compactQueue = function compactQueue(queue) {
    while (queue.length > 1) {
        var item = queue.pop();
        var obj = item.obj[item.prop];

        if (isArray(obj)) {
            var compacted = [];

            for (var j = 0; j < obj.length; ++j) {
                if (typeof obj[j] !== 'undefined') {
                    compacted.push(obj[j]);
                }
            }

            item.obj[item.prop] = compacted;
        }
    }
};

var arrayToObject = function arrayToObject(source, options) {
    var obj = options && options.plainObjects ? Object.create(null) : {};
    for (var i = 0; i < source.length; ++i) {
        if (typeof source[i] !== 'undefined') {
            obj[i] = source[i];
        }
    }

    return obj;
};

var merge = function merge(target, source, options) {
    /* eslint no-param-reassign: 0 */
    if (!source) {
        return target;
    }

    if (typeof source !== 'object') {
        if (isArray(target)) {
            target.push(source);
        } else if (target && typeof target === 'object') {
            if ((options && (options.plainObjects || options.allowPrototypes)) || !has.call(Object.prototype, source)) {
                target[source] = true;
            }
        } else {
            return [target, source];
        }

        return target;
    }

    if (!target || typeof target !== 'object') {
        return [target].concat(source);
    }

    var mergeTarget = target;
    if (isArray(target) && !isArray(source)) {
        mergeTarget = arrayToObject(target, options);
    }

    if (isArray(target) && isArray(source)) {
        source.forEach(function (item, i) {
            if (has.call(target, i)) {
                var targetItem = target[i];
                if (targetItem && typeof targetItem === 'object' && item && typeof item === 'object') {
                    target[i] = merge(targetItem, item, options);
                } else {
                    target.push(item);
                }
            } else {
                target[i] = item;
            }
        });
        return target;
    }

    return Object.keys(source).reduce(function (acc, key) {
        var value = source[key];

        if (has.call(acc, key)) {
            acc[key] = merge(acc[key], value, options);
        } else {
            acc[key] = value;
        }
        return acc;
    }, mergeTarget);
};

var assign = function assignSingleSource(target, source) {
    return Object.keys(source).reduce(function (acc, key) {
        acc[key] = source[key];
        return acc;
    }, target);
};

var decode = function (str, decoder, charset) {
    var strWithoutPlus = str.replace(/\+/g, ' ');
    if (charset === 'iso-8859-1') {
        // unescape never throws, no try...catch needed:
        return strWithoutPlus.replace(/%[0-9a-f]{2}/gi, unescape);
    }
    // utf-8
    try {
        return decodeURIComponent(strWithoutPlus);
    } catch (e) {
        return strWithoutPlus;
    }
};

var limit = 1024;

/* eslint operator-linebreak: [2, "before"] */

var encode = function encode(str, defaultEncoder, charset, kind, format) {
    // This code was originally written by Brian White (mscdex) for the io.js core querystring library.
    // It has been adapted here for stricter adherence to RFC 3986
    if (str.length === 0) {
        return str;
    }

    var string = str;
    if (typeof str === 'symbol') {
        string = Symbol.prototype.toString.call(str);
    } else if (typeof str !== 'string') {
        string = String(str);
    }

    if (charset === 'iso-8859-1') {
        return escape(string).replace(/%u[0-9a-f]{4}/gi, function ($0) {
            return '%26%23' + parseInt($0.slice(2), 16) + '%3B';
        });
    }

    var out = '';
    for (var j = 0; j < string.length; j += limit) {
        var segment = string.length >= limit ? string.slice(j, j + limit) : string;
        var arr = [];

        for (var i = 0; i < segment.length; ++i) {
            var c = segment.charCodeAt(i);
            if (
                c === 0x2D // -
                || c === 0x2E // .
                || c === 0x5F // _
                || c === 0x7E // ~
                || (c >= 0x30 && c <= 0x39) // 0-9
                || (c >= 0x41 && c <= 0x5A) // a-z
                || (c >= 0x61 && c <= 0x7A) // A-Z
                || (format === formats.RFC1738 && (c === 0x28 || c === 0x29)) // ( )
            ) {
                arr[arr.length] = segment.charAt(i);
                continue;
            }

            if (c < 0x80) {
                arr[arr.length] = hexTable[c];
                continue;
            }

            if (c < 0x800) {
                arr[arr.length] = hexTable[0xC0 | (c >> 6)]
                    + hexTable[0x80 | (c & 0x3F)];
                continue;
            }

            if (c < 0xD800 || c >= 0xE000) {
                arr[arr.length] = hexTable[0xE0 | (c >> 12)]
                    + hexTable[0x80 | ((c >> 6) & 0x3F)]
                    + hexTable[0x80 | (c & 0x3F)];
                continue;
            }

            i += 1;
            c = 0x10000 + (((c & 0x3FF) << 10) | (segment.charCodeAt(i) & 0x3FF));

            arr[arr.length] = hexTable[0xF0 | (c >> 18)]
                + hexTable[0x80 | ((c >> 12) & 0x3F)]
                + hexTable[0x80 | ((c >> 6) & 0x3F)]
                + hexTable[0x80 | (c & 0x3F)];
        }

        out += arr.join('');
    }

    return out;
};

var compact = function compact(value) {
    var queue = [{ obj: { o: value }, prop: 'o' }];
    var refs = [];

    for (var i = 0; i < queue.length; ++i) {
        var item = queue[i];
        var obj = item.obj[item.prop];

        var keys = Object.keys(obj);
        for (var j = 0; j < keys.length; ++j) {
            var key = keys[j];
            var val = obj[key];
            if (typeof val === 'object' && val !== null && refs.indexOf(val) === -1) {
                queue.push({ obj: obj, prop: key });
                refs.push(val);
            }
        }
    }

    compactQueue(queue);

    return value;
};

var isRegExp = function isRegExp(obj) {
    return Object.prototype.toString.call(obj) === '[object RegExp]';
};

var isBuffer = function isBuffer(obj) {
    if (!obj || typeof obj !== 'object') {
        return false;
    }

    return !!(obj.constructor && obj.constructor.isBuffer && obj.constructor.isBuffer(obj));
};

var combine = function combine(a, b) {
    return [].concat(a, b);
};

var maybeMap = function maybeMap(val, fn) {
    if (isArray(val)) {
        var mapped = [];
        for (var i = 0; i < val.length; i += 1) {
            mapped.push(fn(val[i]));
        }
        return mapped;
    }
    return fn(val);
};

module.exports = {
    arrayToObject: arrayToObject,
    assign: assign,
    combine: combine,
    compact: compact,
    decode: decode,
    encode: encode,
    isBuffer: isBuffer,
    isRegExp: isRegExp,
    maybeMap: maybeMap,
    merge: merge
};


/***/ }),

/***/ 66489:
/***/ (function(module) {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.



// If obj.hasOwnProperty has been overridden, then calling
// obj.hasOwnProperty(prop) will break.
// See: https://github.com/joyent/node/issues/1707
function hasOwnProperty(obj, prop) {
  return Object.prototype.hasOwnProperty.call(obj, prop);
}

module.exports = function(qs, sep, eq, options) {
  sep = sep || '&';
  eq = eq || '=';
  var obj = {};

  if (typeof qs !== 'string' || qs.length === 0) {
    return obj;
  }

  var regexp = /\+/g;
  qs = qs.split(sep);

  var maxKeys = 1000;
  if (options && typeof options.maxKeys === 'number') {
    maxKeys = options.maxKeys;
  }

  var len = qs.length;
  // maxKeys <= 0 means that we should not limit keys count
  if (maxKeys > 0 && len > maxKeys) {
    len = maxKeys;
  }

  for (var i = 0; i < len; ++i) {
    var x = qs[i].replace(regexp, '%20'),
        idx = x.indexOf(eq),
        kstr, vstr, k, v;

    if (idx >= 0) {
      kstr = x.substr(0, idx);
      vstr = x.substr(idx + 1);
    } else {
      kstr = x;
      vstr = '';
    }

    k = decodeURIComponent(kstr);
    v = decodeURIComponent(vstr);

    if (!hasOwnProperty(obj, k)) {
      obj[k] = v;
    } else if (Array.isArray(obj[k])) {
      obj[k].push(v);
    } else {
      obj[k] = [obj[k], v];
    }
  }

  return obj;
};


/***/ }),

/***/ 23836:
/***/ (function(module) {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.



var stringifyPrimitive = function(v) {
  switch (typeof v) {
    case 'string':
      return v;

    case 'boolean':
      return v ? 'true' : 'false';

    case 'number':
      return isFinite(v) ? v : '';

    default:
      return '';
  }
};

module.exports = function(obj, sep, eq, name) {
  sep = sep || '&';
  eq = eq || '=';
  if (obj === null) {
    obj = undefined;
  }

  if (typeof obj === 'object') {
    return Object.keys(obj).map(function(k) {
      var ks = encodeURIComponent(stringifyPrimitive(k)) + eq;
      if (Array.isArray(obj[k])) {
        return obj[k].map(function(v) {
          return ks + encodeURIComponent(stringifyPrimitive(v));
        }).join(sep);
      } else {
        return ks + encodeURIComponent(stringifyPrimitive(obj[k]));
      }
    }).filter(Boolean).join(sep);

  }

  if (!name) return '';
  return encodeURIComponent(stringifyPrimitive(name)) + eq +
         encodeURIComponent(stringifyPrimitive(obj));
};


/***/ }),

/***/ 97150:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


exports.decode = exports.parse = __webpack_require__(66489);
exports.encode = exports.stringify = __webpack_require__(23836);


/***/ }),

/***/ 15154:
/***/ (function(module) {

/* global Map:readonly, Set:readonly, ArrayBuffer:readonly */

var hasElementType = typeof Element !== 'undefined';
var hasMap = typeof Map === 'function';
var hasSet = typeof Set === 'function';
var hasArrayBuffer = typeof ArrayBuffer === 'function' && !!ArrayBuffer.isView;

// Note: We **don't** need `envHasBigInt64Array` in fde es6/index.js

function equal(a, b) {
  // START: fast-deep-equal es6/index.js 3.1.3
  if (a === b) return true;

  if (a && b && typeof a == 'object' && typeof b == 'object') {
    if (a.constructor !== b.constructor) return false;

    var length, i, keys;
    if (Array.isArray(a)) {
      length = a.length;
      if (length != b.length) return false;
      for (i = length; i-- !== 0;)
        if (!equal(a[i], b[i])) return false;
      return true;
    }

    // START: Modifications:
    // 1. Extra `has<Type> &&` helpers in initial condition allow es6 code
    //    to co-exist with es5.
    // 2. Replace `for of` with es5 compliant iteration using `for`.
    //    Basically, take:
    //
    //    ```js
    //    for (i of a.entries())
    //      if (!b.has(i[0])) return false;
    //    ```
    //
    //    ... and convert to:
    //
    //    ```js
    //    it = a.entries();
    //    while (!(i = it.next()).done)
    //      if (!b.has(i.value[0])) return false;
    //    ```
    //
    //    **Note**: `i` access switches to `i.value`.
    var it;
    if (hasMap && (a instanceof Map) && (b instanceof Map)) {
      if (a.size !== b.size) return false;
      it = a.entries();
      while (!(i = it.next()).done)
        if (!b.has(i.value[0])) return false;
      it = a.entries();
      while (!(i = it.next()).done)
        if (!equal(i.value[1], b.get(i.value[0]))) return false;
      return true;
    }

    if (hasSet && (a instanceof Set) && (b instanceof Set)) {
      if (a.size !== b.size) return false;
      it = a.entries();
      while (!(i = it.next()).done)
        if (!b.has(i.value[0])) return false;
      return true;
    }
    // END: Modifications

    if (hasArrayBuffer && ArrayBuffer.isView(a) && ArrayBuffer.isView(b)) {
      length = a.length;
      if (length != b.length) return false;
      for (i = length; i-- !== 0;)
        if (a[i] !== b[i]) return false;
      return true;
    }

    if (a.constructor === RegExp) return a.source === b.source && a.flags === b.flags;
    // START: Modifications:
    // Apply guards for `Object.create(null)` handling. See:
    // - https://github.com/FormidableLabs/react-fast-compare/issues/64
    // - https://github.com/epoberezkin/fast-deep-equal/issues/49
    if (a.valueOf !== Object.prototype.valueOf && typeof a.valueOf === 'function' && typeof b.valueOf === 'function') return a.valueOf() === b.valueOf();
    if (a.toString !== Object.prototype.toString && typeof a.toString === 'function' && typeof b.toString === 'function') return a.toString() === b.toString();
    // END: Modifications

    keys = Object.keys(a);
    length = keys.length;
    if (length !== Object.keys(b).length) return false;

    for (i = length; i-- !== 0;)
      if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;
    // END: fast-deep-equal

    // START: react-fast-compare
    // custom handling for DOM elements
    if (hasElementType && a instanceof Element) return false;

    // custom handling for React/Preact
    for (i = length; i-- !== 0;) {
      if ((keys[i] === '_owner' || keys[i] === '__v' || keys[i] === '__o') && a.$$typeof) {
        // React-specific: avoid traversing React elements' _owner
        // Preact-specific: avoid traversing Preact elements' __v and __o
        //    __v = $_original / $_vnode
        //    __o = $_owner
        // These properties contain circular references and are not needed when
        // comparing the actual elements (and not their owners)
        // .$$typeof and ._store on just reasonable markers of elements

        continue;
      }

      // all other properties should be traversed as usual
      if (!equal(a[keys[i]], b[keys[i]])) return false;
    }
    // END: react-fast-compare

    // START: fast-deep-equal
    return true;
  }

  return a !== a && b !== b;
}
// end fast-deep-equal

module.exports = function isEqual(a, b) {
  try {
    return equal(a, b);
  } catch (error) {
    if (((error.message || '').match(/stack|recursion/i))) {
      // warn on circular references, don't crash
      // browsers give this different errors name and messages:
      // chrome/safari: "RangeError", "Maximum call stack size exceeded"
      // firefox: "InternalError", too much recursion"
      // edge: "Error", "Out of stack space"
      console.warn('react-fast-compare cannot handle circular refs');
      return false;
    }
    // some other error. we should definitely know about these
    throw error;
  }
};


/***/ }),

/***/ 60198:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var b="function"===typeof Symbol&&Symbol.for,c=b?Symbol.for("react.element"):60103,d=b?Symbol.for("react.portal"):60106,e=b?Symbol.for("react.fragment"):60107,f=b?Symbol.for("react.strict_mode"):60108,g=b?Symbol.for("react.profiler"):60114,h=b?Symbol.for("react.provider"):60109,k=b?Symbol.for("react.context"):60110,l=b?Symbol.for("react.async_mode"):60111,m=b?Symbol.for("react.concurrent_mode"):60111,n=b?Symbol.for("react.forward_ref"):60112,p=b?Symbol.for("react.suspense"):60113,q=b?
Symbol.for("react.suspense_list"):60120,r=b?Symbol.for("react.memo"):60115,t=b?Symbol.for("react.lazy"):60116,v=b?Symbol.for("react.block"):60121,w=b?Symbol.for("react.fundamental"):60117,x=b?Symbol.for("react.responder"):60118,y=b?Symbol.for("react.scope"):60119;
function z(a){if("object"===typeof a&&null!==a){var u=a.$$typeof;switch(u){case c:switch(a=a.type,a){case l:case m:case e:case g:case f:case p:return a;default:switch(a=a&&a.$$typeof,a){case k:case n:case t:case r:case h:return a;default:return u}}case d:return u}}}function A(a){return z(a)===m}exports.AsyncMode=l;exports.ConcurrentMode=m;exports.ContextConsumer=k;exports.ContextProvider=h;exports.Element=c;exports.ForwardRef=n;exports.Fragment=e;exports.Lazy=t;exports.Memo=r;exports.Portal=d;
exports.Profiler=g;exports.StrictMode=f;exports.Suspense=p;exports.isAsyncMode=function(a){return A(a)||z(a)===l};exports.isConcurrentMode=A;exports.isContextConsumer=function(a){return z(a)===k};exports.isContextProvider=function(a){return z(a)===h};exports.isElement=function(a){return"object"===typeof a&&null!==a&&a.$$typeof===c};exports.isForwardRef=function(a){return z(a)===n};exports.isFragment=function(a){return z(a)===e};exports.isLazy=function(a){return z(a)===t};
exports.isMemo=function(a){return z(a)===r};exports.isPortal=function(a){return z(a)===d};exports.isProfiler=function(a){return z(a)===g};exports.isStrictMode=function(a){return z(a)===f};exports.isSuspense=function(a){return z(a)===p};
exports.isValidElementType=function(a){return"string"===typeof a||"function"===typeof a||a===e||a===m||a===g||a===f||a===p||a===q||"object"===typeof a&&null!==a&&(a.$$typeof===t||a.$$typeof===r||a.$$typeof===h||a.$$typeof===k||a.$$typeof===n||a.$$typeof===w||a.$$typeof===x||a.$$typeof===y||a.$$typeof===v)};exports.typeOf=z;


/***/ }),

/***/ 56237:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(60198);
} else {}


/***/ }),

/***/ 58583:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ esm_CSSTransition; }
});

// EXTERNAL MODULE: ./node_modules/.pnpm/@babel+runtime@7.26.0/node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(2053);
;// CONCATENATED MODULE: ./node_modules/.pnpm/@babel+runtime@7.26.0/node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
function _objectWithoutPropertiesLoose(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (e.includes(n)) continue;
    t[n] = r[n];
  }
  return t;
}

;// CONCATENATED MODULE: ./node_modules/.pnpm/@babel+runtime@7.26.0/node_modules/@babel/runtime/helpers/esm/setPrototypeOf.js
function _setPrototypeOf(t, e) {
  return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) {
    return t.__proto__ = e, t;
  }, _setPrototypeOf(t, e);
}

;// CONCATENATED MODULE: ./node_modules/.pnpm/@babel+runtime@7.26.0/node_modules/@babel/runtime/helpers/esm/inheritsLoose.js

function _inheritsLoose(t, o) {
  t.prototype = Object.create(o.prototype), t.prototype.constructor = t, _setPrototypeOf(t, o);
}

;// CONCATENATED MODULE: ./node_modules/.pnpm/dom-helpers@5.2.1/node_modules/dom-helpers/esm/hasClass.js
/**
 * Checks if a given element has a CSS class.
 * 
 * @param element the element
 * @param className the CSS class name
 */
function hasClass(element, className) {
  if (element.classList) return !!className && element.classList.contains(className);
  return (" " + (element.className.baseVal || element.className) + " ").indexOf(" " + className + " ") !== -1;
}
;// CONCATENATED MODULE: ./node_modules/.pnpm/dom-helpers@5.2.1/node_modules/dom-helpers/esm/addClass.js

/**
 * Adds a CSS class to a given element.
 * 
 * @param element the element
 * @param className the CSS class name
 */

function addClass_addClass(element, className) {
  if (element.classList) element.classList.add(className);else if (!hasClass(element, className)) if (typeof element.className === 'string') element.className = element.className + " " + className;else element.setAttribute('class', (element.className && element.className.baseVal || '') + " " + className);
}
;// CONCATENATED MODULE: ./node_modules/.pnpm/dom-helpers@5.2.1/node_modules/dom-helpers/esm/removeClass.js
function replaceClassName(origClass, classToRemove) {
  return origClass.replace(new RegExp("(^|\\s)" + classToRemove + "(?:\\s|$)", 'g'), '$1').replace(/\s+/g, ' ').replace(/^\s*|\s*$/g, '');
}
/**
 * Removes a CSS class from a given element.
 * 
 * @param element the element
 * @param className the CSS class name
 */


function removeClass_removeClass(element, className) {
  if (element.classList) {
    element.classList.remove(className);
  } else if (typeof element.className === 'string') {
    element.className = replaceClassName(element.className, className);
  } else {
    element.setAttribute('class', replaceClassName(element.className && element.className.baseVal || '', className));
  }
}
// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.3.1/node_modules/react/index.js
var react = __webpack_require__(75271);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-dom@18.3.1_react@18.3.1/node_modules/react-dom/index.js
var react_dom = __webpack_require__(30967);
;// CONCATENATED MODULE: ./node_modules/.pnpm/react-transition-group@4.4.5_react-dom@18.3.1_react@18.3.1/node_modules/react-transition-group/esm/config.js
/* harmony default export */ var config = ({
  disabled: false
});
;// CONCATENATED MODULE: ./node_modules/.pnpm/react-transition-group@4.4.5_react-dom@18.3.1_react@18.3.1/node_modules/react-transition-group/esm/TransitionGroupContext.js

/* harmony default export */ var TransitionGroupContext = (react.createContext(null));
;// CONCATENATED MODULE: ./node_modules/.pnpm/react-transition-group@4.4.5_react-dom@18.3.1_react@18.3.1/node_modules/react-transition-group/esm/utils/reflow.js
var forceReflow = function forceReflow(node) {
  return node.scrollTop;
};
;// CONCATENATED MODULE: ./node_modules/.pnpm/react-transition-group@4.4.5_react-dom@18.3.1_react@18.3.1/node_modules/react-transition-group/esm/Transition.js









var UNMOUNTED = 'unmounted';
var EXITED = 'exited';
var ENTERING = 'entering';
var ENTERED = 'entered';
var EXITING = 'exiting';
/**
 * The Transition component lets you describe a transition from one component
 * state to another _over time_ with a simple declarative API. Most commonly
 * it's used to animate the mounting and unmounting of a component, but can also
 * be used to describe in-place transition states as well.
 *
 * ---
 *
 * **Note**: `Transition` is a platform-agnostic base component. If you're using
 * transitions in CSS, you'll probably want to use
 * [`CSSTransition`](https://reactcommunity.org/react-transition-group/css-transition)
 * instead. It inherits all the features of `Transition`, but contains
 * additional features necessary to play nice with CSS transitions (hence the
 * name of the component).
 *
 * ---
 *
 * By default the `Transition` component does not alter the behavior of the
 * component it renders, it only tracks "enter" and "exit" states for the
 * components. It's up to you to give meaning and effect to those states. For
 * example we can add styles to a component when it enters or exits:
 *
 * ```jsx
 * import { Transition } from 'react-transition-group';
 *
 * const duration = 300;
 *
 * const defaultStyle = {
 *   transition: `opacity ${duration}ms ease-in-out`,
 *   opacity: 0,
 * }
 *
 * const transitionStyles = {
 *   entering: { opacity: 1 },
 *   entered:  { opacity: 1 },
 *   exiting:  { opacity: 0 },
 *   exited:  { opacity: 0 },
 * };
 *
 * const Fade = ({ in: inProp }) => (
 *   <Transition in={inProp} timeout={duration}>
 *     {state => (
 *       <div style={{
 *         ...defaultStyle,
 *         ...transitionStyles[state]
 *       }}>
 *         I'm a fade Transition!
 *       </div>
 *     )}
 *   </Transition>
 * );
 * ```
 *
 * There are 4 main states a Transition can be in:
 *  - `'entering'`
 *  - `'entered'`
 *  - `'exiting'`
 *  - `'exited'`
 *
 * Transition state is toggled via the `in` prop. When `true` the component
 * begins the "Enter" stage. During this stage, the component will shift from
 * its current transition state, to `'entering'` for the duration of the
 * transition and then to the `'entered'` stage once it's complete. Let's take
 * the following example (we'll use the
 * [useState](https://reactjs.org/docs/hooks-reference.html#usestate) hook):
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <Transition in={inProp} timeout={500}>
 *         {state => (
 *           // ...
 *         )}
 *       </Transition>
 *       <button onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the button is clicked the component will shift to the `'entering'` state
 * and stay there for 500ms (the value of `timeout`) before it finally switches
 * to `'entered'`.
 *
 * When `in` is `false` the same thing happens except the state moves from
 * `'exiting'` to `'exited'`.
 */

var Transition = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(Transition, _React$Component);

  function Transition(props, context) {
    var _this;

    _this = _React$Component.call(this, props, context) || this;
    var parentGroup = context; // In the context of a TransitionGroup all enters are really appears

    var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;
    var initialStatus;
    _this.appearStatus = null;

    if (props.in) {
      if (appear) {
        initialStatus = EXITED;
        _this.appearStatus = ENTERING;
      } else {
        initialStatus = ENTERED;
      }
    } else {
      if (props.unmountOnExit || props.mountOnEnter) {
        initialStatus = UNMOUNTED;
      } else {
        initialStatus = EXITED;
      }
    }

    _this.state = {
      status: initialStatus
    };
    _this.nextCallback = null;
    return _this;
  }

  Transition.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
    var nextIn = _ref.in;

    if (nextIn && prevState.status === UNMOUNTED) {
      return {
        status: EXITED
      };
    }

    return null;
  } // getSnapshotBeforeUpdate(prevProps) {
  //   let nextStatus = null
  //   if (prevProps !== this.props) {
  //     const { status } = this.state
  //     if (this.props.in) {
  //       if (status !== ENTERING && status !== ENTERED) {
  //         nextStatus = ENTERING
  //       }
  //     } else {
  //       if (status === ENTERING || status === ENTERED) {
  //         nextStatus = EXITING
  //       }
  //     }
  //   }
  //   return { nextStatus }
  // }
  ;

  var _proto = Transition.prototype;

  _proto.componentDidMount = function componentDidMount() {
    this.updateStatus(true, this.appearStatus);
  };

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    var nextStatus = null;

    if (prevProps !== this.props) {
      var status = this.state.status;

      if (this.props.in) {
        if (status !== ENTERING && status !== ENTERED) {
          nextStatus = ENTERING;
        }
      } else {
        if (status === ENTERING || status === ENTERED) {
          nextStatus = EXITING;
        }
      }
    }

    this.updateStatus(false, nextStatus);
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.cancelNextCallback();
  };

  _proto.getTimeouts = function getTimeouts() {
    var timeout = this.props.timeout;
    var exit, enter, appear;
    exit = enter = appear = timeout;

    if (timeout != null && typeof timeout !== 'number') {
      exit = timeout.exit;
      enter = timeout.enter; // TODO: remove fallback for next major

      appear = timeout.appear !== undefined ? timeout.appear : enter;
    }

    return {
      exit: exit,
      enter: enter,
      appear: appear
    };
  };

  _proto.updateStatus = function updateStatus(mounting, nextStatus) {
    if (mounting === void 0) {
      mounting = false;
    }

    if (nextStatus !== null) {
      // nextStatus will always be ENTERING or EXITING.
      this.cancelNextCallback();

      if (nextStatus === ENTERING) {
        if (this.props.unmountOnExit || this.props.mountOnEnter) {
          var node = this.props.nodeRef ? this.props.nodeRef.current : react_dom.findDOMNode(this); // https://github.com/reactjs/react-transition-group/pull/749
          // With unmountOnExit or mountOnEnter, the enter animation should happen at the transition between `exited` and `entering`.
          // To make the animation happen,  we have to separate each rendering and avoid being processed as batched.

          if (node) forceReflow(node);
        }

        this.performEnter(mounting);
      } else {
        this.performExit();
      }
    } else if (this.props.unmountOnExit && this.state.status === EXITED) {
      this.setState({
        status: UNMOUNTED
      });
    }
  };

  _proto.performEnter = function performEnter(mounting) {
    var _this2 = this;

    var enter = this.props.enter;
    var appearing = this.context ? this.context.isMounting : mounting;

    var _ref2 = this.props.nodeRef ? [appearing] : [react_dom.findDOMNode(this), appearing],
        maybeNode = _ref2[0],
        maybeAppearing = _ref2[1];

    var timeouts = this.getTimeouts();
    var enterTimeout = appearing ? timeouts.appear : timeouts.enter; // no enter animation skip right to ENTERED
    // if we are mounting and running this it means appear _must_ be set

    if (!mounting && !enter || config.disabled) {
      this.safeSetState({
        status: ENTERED
      }, function () {
        _this2.props.onEntered(maybeNode);
      });
      return;
    }

    this.props.onEnter(maybeNode, maybeAppearing);
    this.safeSetState({
      status: ENTERING
    }, function () {
      _this2.props.onEntering(maybeNode, maybeAppearing);

      _this2.onTransitionEnd(enterTimeout, function () {
        _this2.safeSetState({
          status: ENTERED
        }, function () {
          _this2.props.onEntered(maybeNode, maybeAppearing);
        });
      });
    });
  };

  _proto.performExit = function performExit() {
    var _this3 = this;

    var exit = this.props.exit;
    var timeouts = this.getTimeouts();
    var maybeNode = this.props.nodeRef ? undefined : react_dom.findDOMNode(this); // no exit animation skip right to EXITED

    if (!exit || config.disabled) {
      this.safeSetState({
        status: EXITED
      }, function () {
        _this3.props.onExited(maybeNode);
      });
      return;
    }

    this.props.onExit(maybeNode);
    this.safeSetState({
      status: EXITING
    }, function () {
      _this3.props.onExiting(maybeNode);

      _this3.onTransitionEnd(timeouts.exit, function () {
        _this3.safeSetState({
          status: EXITED
        }, function () {
          _this3.props.onExited(maybeNode);
        });
      });
    });
  };

  _proto.cancelNextCallback = function cancelNextCallback() {
    if (this.nextCallback !== null) {
      this.nextCallback.cancel();
      this.nextCallback = null;
    }
  };

  _proto.safeSetState = function safeSetState(nextState, callback) {
    // This shouldn't be necessary, but there are weird race conditions with
    // setState callbacks and unmounting in testing, so always make sure that
    // we can cancel any pending setState callbacks after we unmount.
    callback = this.setNextCallback(callback);
    this.setState(nextState, callback);
  };

  _proto.setNextCallback = function setNextCallback(callback) {
    var _this4 = this;

    var active = true;

    this.nextCallback = function (event) {
      if (active) {
        active = false;
        _this4.nextCallback = null;
        callback(event);
      }
    };

    this.nextCallback.cancel = function () {
      active = false;
    };

    return this.nextCallback;
  };

  _proto.onTransitionEnd = function onTransitionEnd(timeout, handler) {
    this.setNextCallback(handler);
    var node = this.props.nodeRef ? this.props.nodeRef.current : react_dom.findDOMNode(this);
    var doesNotHaveTimeoutOrListener = timeout == null && !this.props.addEndListener;

    if (!node || doesNotHaveTimeoutOrListener) {
      setTimeout(this.nextCallback, 0);
      return;
    }

    if (this.props.addEndListener) {
      var _ref3 = this.props.nodeRef ? [this.nextCallback] : [node, this.nextCallback],
          maybeNode = _ref3[0],
          maybeNextCallback = _ref3[1];

      this.props.addEndListener(maybeNode, maybeNextCallback);
    }

    if (timeout != null) {
      setTimeout(this.nextCallback, timeout);
    }
  };

  _proto.render = function render() {
    var status = this.state.status;

    if (status === UNMOUNTED) {
      return null;
    }

    var _this$props = this.props,
        children = _this$props.children,
        _in = _this$props.in,
        _mountOnEnter = _this$props.mountOnEnter,
        _unmountOnExit = _this$props.unmountOnExit,
        _appear = _this$props.appear,
        _enter = _this$props.enter,
        _exit = _this$props.exit,
        _timeout = _this$props.timeout,
        _addEndListener = _this$props.addEndListener,
        _onEnter = _this$props.onEnter,
        _onEntering = _this$props.onEntering,
        _onEntered = _this$props.onEntered,
        _onExit = _this$props.onExit,
        _onExiting = _this$props.onExiting,
        _onExited = _this$props.onExited,
        _nodeRef = _this$props.nodeRef,
        childProps = _objectWithoutPropertiesLoose(_this$props, ["children", "in", "mountOnEnter", "unmountOnExit", "appear", "enter", "exit", "timeout", "addEndListener", "onEnter", "onEntering", "onEntered", "onExit", "onExiting", "onExited", "nodeRef"]);

    return (
      /*#__PURE__*/
      // allows for nested Transitions
      react.createElement(TransitionGroupContext.Provider, {
        value: null
      }, typeof children === 'function' ? children(status, childProps) : react.cloneElement(react.Children.only(children), childProps))
    );
  };

  return Transition;
}(react.Component);

Transition.contextType = TransitionGroupContext;
Transition.propTypes =  false ? 0 : {}; // Name the function so it is clearer in the documentation

function noop() {}

Transition.defaultProps = {
  in: false,
  mountOnEnter: false,
  unmountOnExit: false,
  appear: false,
  enter: true,
  exit: true,
  onEnter: noop,
  onEntering: noop,
  onEntered: noop,
  onExit: noop,
  onExiting: noop,
  onExited: noop
};
Transition.UNMOUNTED = UNMOUNTED;
Transition.EXITED = EXITED;
Transition.ENTERING = ENTERING;
Transition.ENTERED = ENTERED;
Transition.EXITING = EXITING;
/* harmony default export */ var esm_Transition = (Transition);
;// CONCATENATED MODULE: ./node_modules/.pnpm/react-transition-group@4.4.5_react-dom@18.3.1_react@18.3.1/node_modules/react-transition-group/esm/CSSTransition.js











var _addClass = function addClass(node, classes) {
  return node && classes && classes.split(' ').forEach(function (c) {
    return addClass_addClass(node, c);
  });
};

var removeClass = function removeClass(node, classes) {
  return node && classes && classes.split(' ').forEach(function (c) {
    return removeClass_removeClass(node, c);
  });
};
/**
 * A transition component inspired by the excellent
 * [ng-animate](https://docs.angularjs.org/api/ngAnimate) library, you should
 * use it if you're using CSS transitions or animations. It's built upon the
 * [`Transition`](https://reactcommunity.org/react-transition-group/transition)
 * component, so it inherits all of its props.
 *
 * `CSSTransition` applies a pair of class names during the `appear`, `enter`,
 * and `exit` states of the transition. The first class is applied and then a
 * second `*-active` class in order to activate the CSS transition. After the
 * transition, matching `*-done` class names are applied to persist the
 * transition state.
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <CSSTransition in={inProp} timeout={200} classNames="my-node">
 *         <div>
 *           {"I'll receive my-node-* classes"}
 *         </div>
 *       </CSSTransition>
 *       <button type="button" onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the `in` prop is set to `true`, the child component will first receive
 * the class `example-enter`, then the `example-enter-active` will be added in
 * the next tick. `CSSTransition` [forces a
 * reflow](https://github.com/reactjs/react-transition-group/blob/5007303e729a74be66a21c3e2205e4916821524b/src/CSSTransition.js#L208-L215)
 * between before adding the `example-enter-active`. This is an important trick
 * because it allows us to transition between `example-enter` and
 * `example-enter-active` even though they were added immediately one after
 * another. Most notably, this is what makes it possible for us to animate
 * _appearance_.
 *
 * ```css
 * .my-node-enter {
 *   opacity: 0;
 * }
 * .my-node-enter-active {
 *   opacity: 1;
 *   transition: opacity 200ms;
 * }
 * .my-node-exit {
 *   opacity: 1;
 * }
 * .my-node-exit-active {
 *   opacity: 0;
 *   transition: opacity 200ms;
 * }
 * ```
 *
 * `*-active` classes represent which styles you want to animate **to**, so it's
 * important to add `transition` declaration only to them, otherwise transitions
 * might not behave as intended! This might not be obvious when the transitions
 * are symmetrical, i.e. when `*-enter-active` is the same as `*-exit`, like in
 * the example above (minus `transition`), but it becomes apparent in more
 * complex transitions.
 *
 * **Note**: If you're using the
 * [`appear`](http://reactcommunity.org/react-transition-group/transition#Transition-prop-appear)
 * prop, make sure to define styles for `.appear-*` classes as well.
 */


var CSSTransition = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(CSSTransition, _React$Component);

  function CSSTransition() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
    _this.appliedClasses = {
      appear: {},
      enter: {},
      exit: {}
    };

    _this.onEnter = function (maybeNode, maybeAppearing) {
      var _this$resolveArgument = _this.resolveArguments(maybeNode, maybeAppearing),
          node = _this$resolveArgument[0],
          appearing = _this$resolveArgument[1];

      _this.removeClasses(node, 'exit');

      _this.addClass(node, appearing ? 'appear' : 'enter', 'base');

      if (_this.props.onEnter) {
        _this.props.onEnter(maybeNode, maybeAppearing);
      }
    };

    _this.onEntering = function (maybeNode, maybeAppearing) {
      var _this$resolveArgument2 = _this.resolveArguments(maybeNode, maybeAppearing),
          node = _this$resolveArgument2[0],
          appearing = _this$resolveArgument2[1];

      var type = appearing ? 'appear' : 'enter';

      _this.addClass(node, type, 'active');

      if (_this.props.onEntering) {
        _this.props.onEntering(maybeNode, maybeAppearing);
      }
    };

    _this.onEntered = function (maybeNode, maybeAppearing) {
      var _this$resolveArgument3 = _this.resolveArguments(maybeNode, maybeAppearing),
          node = _this$resolveArgument3[0],
          appearing = _this$resolveArgument3[1];

      var type = appearing ? 'appear' : 'enter';

      _this.removeClasses(node, type);

      _this.addClass(node, type, 'done');

      if (_this.props.onEntered) {
        _this.props.onEntered(maybeNode, maybeAppearing);
      }
    };

    _this.onExit = function (maybeNode) {
      var _this$resolveArgument4 = _this.resolveArguments(maybeNode),
          node = _this$resolveArgument4[0];

      _this.removeClasses(node, 'appear');

      _this.removeClasses(node, 'enter');

      _this.addClass(node, 'exit', 'base');

      if (_this.props.onExit) {
        _this.props.onExit(maybeNode);
      }
    };

    _this.onExiting = function (maybeNode) {
      var _this$resolveArgument5 = _this.resolveArguments(maybeNode),
          node = _this$resolveArgument5[0];

      _this.addClass(node, 'exit', 'active');

      if (_this.props.onExiting) {
        _this.props.onExiting(maybeNode);
      }
    };

    _this.onExited = function (maybeNode) {
      var _this$resolveArgument6 = _this.resolveArguments(maybeNode),
          node = _this$resolveArgument6[0];

      _this.removeClasses(node, 'exit');

      _this.addClass(node, 'exit', 'done');

      if (_this.props.onExited) {
        _this.props.onExited(maybeNode);
      }
    };

    _this.resolveArguments = function (maybeNode, maybeAppearing) {
      return _this.props.nodeRef ? [_this.props.nodeRef.current, maybeNode] // here `maybeNode` is actually `appearing`
      : [maybeNode, maybeAppearing];
    };

    _this.getClassNames = function (type) {
      var classNames = _this.props.classNames;
      var isStringClassNames = typeof classNames === 'string';
      var prefix = isStringClassNames && classNames ? classNames + "-" : '';
      var baseClassName = isStringClassNames ? "" + prefix + type : classNames[type];
      var activeClassName = isStringClassNames ? baseClassName + "-active" : classNames[type + "Active"];
      var doneClassName = isStringClassNames ? baseClassName + "-done" : classNames[type + "Done"];
      return {
        baseClassName: baseClassName,
        activeClassName: activeClassName,
        doneClassName: doneClassName
      };
    };

    return _this;
  }

  var _proto = CSSTransition.prototype;

  _proto.addClass = function addClass(node, type, phase) {
    var className = this.getClassNames(type)[phase + "ClassName"];

    var _this$getClassNames = this.getClassNames('enter'),
        doneClassName = _this$getClassNames.doneClassName;

    if (type === 'appear' && phase === 'done' && doneClassName) {
      className += " " + doneClassName;
    } // This is to force a repaint,
    // which is necessary in order to transition styles when adding a class name.


    if (phase === 'active') {
      if (node) forceReflow(node);
    }

    if (className) {
      this.appliedClasses[type][phase] = className;

      _addClass(node, className);
    }
  };

  _proto.removeClasses = function removeClasses(node, type) {
    var _this$appliedClasses$ = this.appliedClasses[type],
        baseClassName = _this$appliedClasses$.base,
        activeClassName = _this$appliedClasses$.active,
        doneClassName = _this$appliedClasses$.done;
    this.appliedClasses[type] = {};

    if (baseClassName) {
      removeClass(node, baseClassName);
    }

    if (activeClassName) {
      removeClass(node, activeClassName);
    }

    if (doneClassName) {
      removeClass(node, doneClassName);
    }
  };

  _proto.render = function render() {
    var _this$props = this.props,
        _ = _this$props.classNames,
        props = _objectWithoutPropertiesLoose(_this$props, ["classNames"]);

    return /*#__PURE__*/react.createElement(esm_Transition, (0,esm_extends/* default */.Z)({}, props, {
      onEnter: this.onEnter,
      onEntered: this.onEntered,
      onEntering: this.onEntering,
      onExit: this.onExit,
      onExiting: this.onExiting,
      onExited: this.onExited
    }));
  };

  return CSSTransition;
}(react.Component);

CSSTransition.defaultProps = {
  classNames: ''
};
CSSTransition.propTypes =  false ? 0 : {};
/* harmony default export */ var esm_CSSTransition = (CSSTransition);

/***/ }),

/***/ 60981:
/***/ (function(module) {

"use strict";


function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

var codes = {};

function createErrorType(code, message, Base) {
  if (!Base) {
    Base = Error;
  }

  function getMessage(arg1, arg2, arg3) {
    if (typeof message === 'string') {
      return message;
    } else {
      return message(arg1, arg2, arg3);
    }
  }

  var NodeError =
  /*#__PURE__*/
  function (_Base) {
    _inheritsLoose(NodeError, _Base);

    function NodeError(arg1, arg2, arg3) {
      return _Base.call(this, getMessage(arg1, arg2, arg3)) || this;
    }

    return NodeError;
  }(Base);

  NodeError.prototype.name = Base.name;
  NodeError.prototype.code = code;
  codes[code] = NodeError;
} // https://github.com/nodejs/node/blob/v10.8.0/lib/internal/errors.js


function oneOf(expected, thing) {
  if (Array.isArray(expected)) {
    var len = expected.length;
    expected = expected.map(function (i) {
      return String(i);
    });

    if (len > 2) {
      return "one of ".concat(thing, " ").concat(expected.slice(0, len - 1).join(', '), ", or ") + expected[len - 1];
    } else if (len === 2) {
      return "one of ".concat(thing, " ").concat(expected[0], " or ").concat(expected[1]);
    } else {
      return "of ".concat(thing, " ").concat(expected[0]);
    }
  } else {
    return "of ".concat(thing, " ").concat(String(expected));
  }
} // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/startsWith


function startsWith(str, search, pos) {
  return str.substr(!pos || pos < 0 ? 0 : +pos, search.length) === search;
} // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/endsWith


function endsWith(str, search, this_len) {
  if (this_len === undefined || this_len > str.length) {
    this_len = str.length;
  }

  return str.substring(this_len - search.length, this_len) === search;
} // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/includes


function includes(str, search, start) {
  if (typeof start !== 'number') {
    start = 0;
  }

  if (start + search.length > str.length) {
    return false;
  } else {
    return str.indexOf(search, start) !== -1;
  }
}

createErrorType('ERR_INVALID_OPT_VALUE', function (name, value) {
  return 'The value "' + value + '" is invalid for option "' + name + '"';
}, TypeError);
createErrorType('ERR_INVALID_ARG_TYPE', function (name, expected, actual) {
  // determiner: 'must be' or 'must not be'
  var determiner;

  if (typeof expected === 'string' && startsWith(expected, 'not ')) {
    determiner = 'must not be';
    expected = expected.replace(/^not /, '');
  } else {
    determiner = 'must be';
  }

  var msg;

  if (endsWith(name, ' argument')) {
    // For cases like 'first argument'
    msg = "The ".concat(name, " ").concat(determiner, " ").concat(oneOf(expected, 'type'));
  } else {
    var type = includes(name, '.') ? 'property' : 'argument';
    msg = "The \"".concat(name, "\" ").concat(type, " ").concat(determiner, " ").concat(oneOf(expected, 'type'));
  }

  msg += ". Received type ".concat(typeof actual);
  return msg;
}, TypeError);
createErrorType('ERR_STREAM_PUSH_AFTER_EOF', 'stream.push() after EOF');
createErrorType('ERR_METHOD_NOT_IMPLEMENTED', function (name) {
  return 'The ' + name + ' method is not implemented';
});
createErrorType('ERR_STREAM_PREMATURE_CLOSE', 'Premature close');
createErrorType('ERR_STREAM_DESTROYED', function (name) {
  return 'Cannot call ' + name + ' after a stream was destroyed';
});
createErrorType('ERR_MULTIPLE_CALLBACK', 'Callback called multiple times');
createErrorType('ERR_STREAM_CANNOT_PIPE', 'Cannot pipe, not readable');
createErrorType('ERR_STREAM_WRITE_AFTER_END', 'write after end');
createErrorType('ERR_STREAM_NULL_VALUES', 'May not write null values to stream', TypeError);
createErrorType('ERR_UNKNOWN_ENCODING', function (arg) {
  return 'Unknown encoding: ' + arg;
}, TypeError);
createErrorType('ERR_STREAM_UNSHIFT_AFTER_END_EVENT', 'stream.unshift() after end event');
module.exports.q = codes;


/***/ }),

/***/ 93337:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
/* provided dependency */ var process = __webpack_require__(14224);
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// a duplex stream is just a stream that is both readable and writable.
// Since JS doesn't have multiple prototypal inheritance, this class
// prototypally inherits from Readable, and then parasitically from
// Writable.



/*<replacement>*/
var objectKeys = Object.keys || function (obj) {
  var keys = [];
  for (var key in obj) keys.push(key);
  return keys;
};
/*</replacement>*/

module.exports = Duplex;
var Readable = __webpack_require__(25294);
var Writable = __webpack_require__(86481);
__webpack_require__(2937)(Duplex, Readable);
{
  // Allow the keys array to be GC'ed.
  var keys = objectKeys(Writable.prototype);
  for (var v = 0; v < keys.length; v++) {
    var method = keys[v];
    if (!Duplex.prototype[method]) Duplex.prototype[method] = Writable.prototype[method];
  }
}
function Duplex(options) {
  if (!(this instanceof Duplex)) return new Duplex(options);
  Readable.call(this, options);
  Writable.call(this, options);
  this.allowHalfOpen = true;
  if (options) {
    if (options.readable === false) this.readable = false;
    if (options.writable === false) this.writable = false;
    if (options.allowHalfOpen === false) {
      this.allowHalfOpen = false;
      this.once('end', onend);
    }
  }
}
Object.defineProperty(Duplex.prototype, 'writableHighWaterMark', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function get() {
    return this._writableState.highWaterMark;
  }
});
Object.defineProperty(Duplex.prototype, 'writableBuffer', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function get() {
    return this._writableState && this._writableState.getBuffer();
  }
});
Object.defineProperty(Duplex.prototype, 'writableLength', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function get() {
    return this._writableState.length;
  }
});

// the no-half-open enforcer
function onend() {
  // If the writable side ended, then we're ok.
  if (this._writableState.ended) return;

  // no more data can be written.
  // But allow more writes to happen in this tick.
  process.nextTick(onEndNT, this);
}
function onEndNT(self) {
  self.end();
}
Object.defineProperty(Duplex.prototype, 'destroyed', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function get() {
    if (this._readableState === undefined || this._writableState === undefined) {
      return false;
    }
    return this._readableState.destroyed && this._writableState.destroyed;
  },
  set: function set(value) {
    // we ignore the value if the stream
    // has not been initialized yet
    if (this._readableState === undefined || this._writableState === undefined) {
      return;
    }

    // backward compatibility, the user is explicitly
    // managing destroyed
    this._readableState.destroyed = value;
    this._writableState.destroyed = value;
  }
});

/***/ }),

/***/ 68797:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// a passthrough stream.
// basically just the most minimal sort of Transform stream.
// Every written chunk gets output as-is.



module.exports = PassThrough;
var Transform = __webpack_require__(41683);
__webpack_require__(2937)(PassThrough, Transform);
function PassThrough(options) {
  if (!(this instanceof PassThrough)) return new PassThrough(options);
  Transform.call(this, options);
}
PassThrough.prototype._transform = function (chunk, encoding, cb) {
  cb(null, chunk);
};

/***/ }),

/***/ 25294:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
/* provided dependency */ var process = __webpack_require__(14224);
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.



module.exports = Readable;

/*<replacement>*/
var Duplex;
/*</replacement>*/

Readable.ReadableState = ReadableState;

/*<replacement>*/
var EE = (__webpack_require__(72100).EventEmitter);
var EElistenerCount = function EElistenerCount(emitter, type) {
  return emitter.listeners(type).length;
};
/*</replacement>*/

/*<replacement>*/
var Stream = __webpack_require__(26922);
/*</replacement>*/

var Buffer = (__webpack_require__(55872).Buffer);
var OurUint8Array = (typeof __webpack_require__.g !== 'undefined' ? __webpack_require__.g : typeof window !== 'undefined' ? window : typeof self !== 'undefined' ? self : {}).Uint8Array || function () {};
function _uint8ArrayToBuffer(chunk) {
  return Buffer.from(chunk);
}
function _isUint8Array(obj) {
  return Buffer.isBuffer(obj) || obj instanceof OurUint8Array;
}

/*<replacement>*/
var debugUtil = __webpack_require__(82880);
var debug;
if (debugUtil && debugUtil.debuglog) {
  debug = debugUtil.debuglog('stream');
} else {
  debug = function debug() {};
}
/*</replacement>*/

var BufferList = __webpack_require__(96292);
var destroyImpl = __webpack_require__(33591);
var _require = __webpack_require__(16084),
  getHighWaterMark = _require.getHighWaterMark;
var _require$codes = (__webpack_require__(60981)/* .codes */ .q),
  ERR_INVALID_ARG_TYPE = _require$codes.ERR_INVALID_ARG_TYPE,
  ERR_STREAM_PUSH_AFTER_EOF = _require$codes.ERR_STREAM_PUSH_AFTER_EOF,
  ERR_METHOD_NOT_IMPLEMENTED = _require$codes.ERR_METHOD_NOT_IMPLEMENTED,
  ERR_STREAM_UNSHIFT_AFTER_END_EVENT = _require$codes.ERR_STREAM_UNSHIFT_AFTER_END_EVENT;

// Lazy loaded to improve the startup performance.
var StringDecoder;
var createReadableStreamAsyncIterator;
var from;
__webpack_require__(2937)(Readable, Stream);
var errorOrDestroy = destroyImpl.errorOrDestroy;
var kProxyEvents = ['error', 'close', 'destroy', 'pause', 'resume'];
function prependListener(emitter, event, fn) {
  // Sadly this is not cacheable as some libraries bundle their own
  // event emitter implementation with them.
  if (typeof emitter.prependListener === 'function') return emitter.prependListener(event, fn);

  // This is a hack to make sure that our error handler is attached before any
  // userland ones.  NEVER DO THIS. This is here only because this code needs
  // to continue to work with older versions of Node.js that do not include
  // the prependListener() method. The goal is to eventually remove this hack.
  if (!emitter._events || !emitter._events[event]) emitter.on(event, fn);else if (Array.isArray(emitter._events[event])) emitter._events[event].unshift(fn);else emitter._events[event] = [fn, emitter._events[event]];
}
function ReadableState(options, stream, isDuplex) {
  Duplex = Duplex || __webpack_require__(93337);
  options = options || {};

  // Duplex streams are both readable and writable, but share
  // the same options object.
  // However, some cases require setting options to different
  // values for the readable and the writable sides of the duplex stream.
  // These options can be provided separately as readableXXX and writableXXX.
  if (typeof isDuplex !== 'boolean') isDuplex = stream instanceof Duplex;

  // object stream flag. Used to make read(n) ignore n and to
  // make all the buffer merging and length checks go away
  this.objectMode = !!options.objectMode;
  if (isDuplex) this.objectMode = this.objectMode || !!options.readableObjectMode;

  // the point at which it stops calling _read() to fill the buffer
  // Note: 0 is a valid value, means "don't call _read preemptively ever"
  this.highWaterMark = getHighWaterMark(this, options, 'readableHighWaterMark', isDuplex);

  // A linked list is used to store data chunks instead of an array because the
  // linked list can remove elements from the beginning faster than
  // array.shift()
  this.buffer = new BufferList();
  this.length = 0;
  this.pipes = null;
  this.pipesCount = 0;
  this.flowing = null;
  this.ended = false;
  this.endEmitted = false;
  this.reading = false;

  // a flag to be able to tell if the event 'readable'/'data' is emitted
  // immediately, or on a later tick.  We set this to true at first, because
  // any actions that shouldn't happen until "later" should generally also
  // not happen before the first read call.
  this.sync = true;

  // whenever we return null, then we set a flag to say
  // that we're awaiting a 'readable' event emission.
  this.needReadable = false;
  this.emittedReadable = false;
  this.readableListening = false;
  this.resumeScheduled = false;
  this.paused = true;

  // Should close be emitted on destroy. Defaults to true.
  this.emitClose = options.emitClose !== false;

  // Should .destroy() be called after 'end' (and potentially 'finish')
  this.autoDestroy = !!options.autoDestroy;

  // has it been destroyed
  this.destroyed = false;

  // Crypto is kind of old and crusty.  Historically, its default string
  // encoding is 'binary' so we have to make this configurable.
  // Everything else in the universe uses 'utf8', though.
  this.defaultEncoding = options.defaultEncoding || 'utf8';

  // the number of writers that are awaiting a drain event in .pipe()s
  this.awaitDrain = 0;

  // if true, a maybeReadMore has been scheduled
  this.readingMore = false;
  this.decoder = null;
  this.encoding = null;
  if (options.encoding) {
    if (!StringDecoder) StringDecoder = (__webpack_require__(72699).StringDecoder);
    this.decoder = new StringDecoder(options.encoding);
    this.encoding = options.encoding;
  }
}
function Readable(options) {
  Duplex = Duplex || __webpack_require__(93337);
  if (!(this instanceof Readable)) return new Readable(options);

  // Checking for a Stream.Duplex instance is faster here instead of inside
  // the ReadableState constructor, at least with V8 6.5
  var isDuplex = this instanceof Duplex;
  this._readableState = new ReadableState(options, this, isDuplex);

  // legacy
  this.readable = true;
  if (options) {
    if (typeof options.read === 'function') this._read = options.read;
    if (typeof options.destroy === 'function') this._destroy = options.destroy;
  }
  Stream.call(this);
}
Object.defineProperty(Readable.prototype, 'destroyed', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function get() {
    if (this._readableState === undefined) {
      return false;
    }
    return this._readableState.destroyed;
  },
  set: function set(value) {
    // we ignore the value if the stream
    // has not been initialized yet
    if (!this._readableState) {
      return;
    }

    // backward compatibility, the user is explicitly
    // managing destroyed
    this._readableState.destroyed = value;
  }
});
Readable.prototype.destroy = destroyImpl.destroy;
Readable.prototype._undestroy = destroyImpl.undestroy;
Readable.prototype._destroy = function (err, cb) {
  cb(err);
};

// Manually shove something into the read() buffer.
// This returns true if the highWaterMark has not been hit yet,
// similar to how Writable.write() returns true if you should
// write() some more.
Readable.prototype.push = function (chunk, encoding) {
  var state = this._readableState;
  var skipChunkCheck;
  if (!state.objectMode) {
    if (typeof chunk === 'string') {
      encoding = encoding || state.defaultEncoding;
      if (encoding !== state.encoding) {
        chunk = Buffer.from(chunk, encoding);
        encoding = '';
      }
      skipChunkCheck = true;
    }
  } else {
    skipChunkCheck = true;
  }
  return readableAddChunk(this, chunk, encoding, false, skipChunkCheck);
};

// Unshift should *always* be something directly out of read()
Readable.prototype.unshift = function (chunk) {
  return readableAddChunk(this, chunk, null, true, false);
};
function readableAddChunk(stream, chunk, encoding, addToFront, skipChunkCheck) {
  debug('readableAddChunk', chunk);
  var state = stream._readableState;
  if (chunk === null) {
    state.reading = false;
    onEofChunk(stream, state);
  } else {
    var er;
    if (!skipChunkCheck) er = chunkInvalid(state, chunk);
    if (er) {
      errorOrDestroy(stream, er);
    } else if (state.objectMode || chunk && chunk.length > 0) {
      if (typeof chunk !== 'string' && !state.objectMode && Object.getPrototypeOf(chunk) !== Buffer.prototype) {
        chunk = _uint8ArrayToBuffer(chunk);
      }
      if (addToFront) {
        if (state.endEmitted) errorOrDestroy(stream, new ERR_STREAM_UNSHIFT_AFTER_END_EVENT());else addChunk(stream, state, chunk, true);
      } else if (state.ended) {
        errorOrDestroy(stream, new ERR_STREAM_PUSH_AFTER_EOF());
      } else if (state.destroyed) {
        return false;
      } else {
        state.reading = false;
        if (state.decoder && !encoding) {
          chunk = state.decoder.write(chunk);
          if (state.objectMode || chunk.length !== 0) addChunk(stream, state, chunk, false);else maybeReadMore(stream, state);
        } else {
          addChunk(stream, state, chunk, false);
        }
      }
    } else if (!addToFront) {
      state.reading = false;
      maybeReadMore(stream, state);
    }
  }

  // We can push more data if we are below the highWaterMark.
  // Also, if we have no data yet, we can stand some more bytes.
  // This is to work around cases where hwm=0, such as the repl.
  return !state.ended && (state.length < state.highWaterMark || state.length === 0);
}
function addChunk(stream, state, chunk, addToFront) {
  if (state.flowing && state.length === 0 && !state.sync) {
    state.awaitDrain = 0;
    stream.emit('data', chunk);
  } else {
    // update the buffer info.
    state.length += state.objectMode ? 1 : chunk.length;
    if (addToFront) state.buffer.unshift(chunk);else state.buffer.push(chunk);
    if (state.needReadable) emitReadable(stream);
  }
  maybeReadMore(stream, state);
}
function chunkInvalid(state, chunk) {
  var er;
  if (!_isUint8Array(chunk) && typeof chunk !== 'string' && chunk !== undefined && !state.objectMode) {
    er = new ERR_INVALID_ARG_TYPE('chunk', ['string', 'Buffer', 'Uint8Array'], chunk);
  }
  return er;
}
Readable.prototype.isPaused = function () {
  return this._readableState.flowing === false;
};

// backwards compatibility.
Readable.prototype.setEncoding = function (enc) {
  if (!StringDecoder) StringDecoder = (__webpack_require__(72699).StringDecoder);
  var decoder = new StringDecoder(enc);
  this._readableState.decoder = decoder;
  // If setEncoding(null), decoder.encoding equals utf8
  this._readableState.encoding = this._readableState.decoder.encoding;

  // Iterate over current buffer to convert already stored Buffers:
  var p = this._readableState.buffer.head;
  var content = '';
  while (p !== null) {
    content += decoder.write(p.data);
    p = p.next;
  }
  this._readableState.buffer.clear();
  if (content !== '') this._readableState.buffer.push(content);
  this._readableState.length = content.length;
  return this;
};

// Don't raise the hwm > 1GB
var MAX_HWM = 0x40000000;
function computeNewHighWaterMark(n) {
  if (n >= MAX_HWM) {
    // TODO(ronag): Throw ERR_VALUE_OUT_OF_RANGE.
    n = MAX_HWM;
  } else {
    // Get the next highest power of 2 to prevent increasing hwm excessively in
    // tiny amounts
    n--;
    n |= n >>> 1;
    n |= n >>> 2;
    n |= n >>> 4;
    n |= n >>> 8;
    n |= n >>> 16;
    n++;
  }
  return n;
}

// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function howMuchToRead(n, state) {
  if (n <= 0 || state.length === 0 && state.ended) return 0;
  if (state.objectMode) return 1;
  if (n !== n) {
    // Only flow one buffer at a time
    if (state.flowing && state.length) return state.buffer.head.data.length;else return state.length;
  }
  // If we're asking for more than the current hwm, then raise the hwm.
  if (n > state.highWaterMark) state.highWaterMark = computeNewHighWaterMark(n);
  if (n <= state.length) return n;
  // Don't have enough
  if (!state.ended) {
    state.needReadable = true;
    return 0;
  }
  return state.length;
}

// you can override either this method, or the async _read(n) below.
Readable.prototype.read = function (n) {
  debug('read', n);
  n = parseInt(n, 10);
  var state = this._readableState;
  var nOrig = n;
  if (n !== 0) state.emittedReadable = false;

  // if we're doing read(0) to trigger a readable event, but we
  // already have a bunch of data in the buffer, then just trigger
  // the 'readable' event and move on.
  if (n === 0 && state.needReadable && ((state.highWaterMark !== 0 ? state.length >= state.highWaterMark : state.length > 0) || state.ended)) {
    debug('read: emitReadable', state.length, state.ended);
    if (state.length === 0 && state.ended) endReadable(this);else emitReadable(this);
    return null;
  }
  n = howMuchToRead(n, state);

  // if we've ended, and we're now clear, then finish it up.
  if (n === 0 && state.ended) {
    if (state.length === 0) endReadable(this);
    return null;
  }

  // All the actual chunk generation logic needs to be
  // *below* the call to _read.  The reason is that in certain
  // synthetic stream cases, such as passthrough streams, _read
  // may be a completely synchronous operation which may change
  // the state of the read buffer, providing enough data when
  // before there was *not* enough.
  //
  // So, the steps are:
  // 1. Figure out what the state of things will be after we do
  // a read from the buffer.
  //
  // 2. If that resulting state will trigger a _read, then call _read.
  // Note that this may be asynchronous, or synchronous.  Yes, it is
  // deeply ugly to write APIs this way, but that still doesn't mean
  // that the Readable class should behave improperly, as streams are
  // designed to be sync/async agnostic.
  // Take note if the _read call is sync or async (ie, if the read call
  // has returned yet), so that we know whether or not it's safe to emit
  // 'readable' etc.
  //
  // 3. Actually pull the requested chunks out of the buffer and return.

  // if we need a readable event, then we need to do some reading.
  var doRead = state.needReadable;
  debug('need readable', doRead);

  // if we currently have less than the highWaterMark, then also read some
  if (state.length === 0 || state.length - n < state.highWaterMark) {
    doRead = true;
    debug('length less than watermark', doRead);
  }

  // however, if we've ended, then there's no point, and if we're already
  // reading, then it's unnecessary.
  if (state.ended || state.reading) {
    doRead = false;
    debug('reading or ended', doRead);
  } else if (doRead) {
    debug('do read');
    state.reading = true;
    state.sync = true;
    // if the length is currently zero, then we *need* a readable event.
    if (state.length === 0) state.needReadable = true;
    // call internal read method
    this._read(state.highWaterMark);
    state.sync = false;
    // If _read pushed data synchronously, then `reading` will be false,
    // and we need to re-evaluate how much data we can return to the user.
    if (!state.reading) n = howMuchToRead(nOrig, state);
  }
  var ret;
  if (n > 0) ret = fromList(n, state);else ret = null;
  if (ret === null) {
    state.needReadable = state.length <= state.highWaterMark;
    n = 0;
  } else {
    state.length -= n;
    state.awaitDrain = 0;
  }
  if (state.length === 0) {
    // If we have nothing in the buffer, then we want to know
    // as soon as we *do* get something into the buffer.
    if (!state.ended) state.needReadable = true;

    // If we tried to read() past the EOF, then emit end on the next tick.
    if (nOrig !== n && state.ended) endReadable(this);
  }
  if (ret !== null) this.emit('data', ret);
  return ret;
};
function onEofChunk(stream, state) {
  debug('onEofChunk');
  if (state.ended) return;
  if (state.decoder) {
    var chunk = state.decoder.end();
    if (chunk && chunk.length) {
      state.buffer.push(chunk);
      state.length += state.objectMode ? 1 : chunk.length;
    }
  }
  state.ended = true;
  if (state.sync) {
    // if we are sync, wait until next tick to emit the data.
    // Otherwise we risk emitting data in the flow()
    // the readable code triggers during a read() call
    emitReadable(stream);
  } else {
    // emit 'readable' now to make sure it gets picked up.
    state.needReadable = false;
    if (!state.emittedReadable) {
      state.emittedReadable = true;
      emitReadable_(stream);
    }
  }
}

// Don't emit readable right away in sync mode, because this can trigger
// another read() call => stack overflow.  This way, it might trigger
// a nextTick recursion warning, but that's not so bad.
function emitReadable(stream) {
  var state = stream._readableState;
  debug('emitReadable', state.needReadable, state.emittedReadable);
  state.needReadable = false;
  if (!state.emittedReadable) {
    debug('emitReadable', state.flowing);
    state.emittedReadable = true;
    process.nextTick(emitReadable_, stream);
  }
}
function emitReadable_(stream) {
  var state = stream._readableState;
  debug('emitReadable_', state.destroyed, state.length, state.ended);
  if (!state.destroyed && (state.length || state.ended)) {
    stream.emit('readable');
    state.emittedReadable = false;
  }

  // The stream needs another readable event if
  // 1. It is not flowing, as the flow mechanism will take
  //    care of it.
  // 2. It is not ended.
  // 3. It is below the highWaterMark, so we can schedule
  //    another readable later.
  state.needReadable = !state.flowing && !state.ended && state.length <= state.highWaterMark;
  flow(stream);
}

// at this point, the user has presumably seen the 'readable' event,
// and called read() to consume some data.  that may have triggered
// in turn another _read(n) call, in which case reading = true if
// it's in progress.
// However, if we're not ended, or reading, and the length < hwm,
// then go ahead and try to read some more preemptively.
function maybeReadMore(stream, state) {
  if (!state.readingMore) {
    state.readingMore = true;
    process.nextTick(maybeReadMore_, stream, state);
  }
}
function maybeReadMore_(stream, state) {
  // Attempt to read more data if we should.
  //
  // The conditions for reading more data are (one of):
  // - Not enough data buffered (state.length < state.highWaterMark). The loop
  //   is responsible for filling the buffer with enough data if such data
  //   is available. If highWaterMark is 0 and we are not in the flowing mode
  //   we should _not_ attempt to buffer any extra data. We'll get more data
  //   when the stream consumer calls read() instead.
  // - No data in the buffer, and the stream is in flowing mode. In this mode
  //   the loop below is responsible for ensuring read() is called. Failing to
  //   call read here would abort the flow and there's no other mechanism for
  //   continuing the flow if the stream consumer has just subscribed to the
  //   'data' event.
  //
  // In addition to the above conditions to keep reading data, the following
  // conditions prevent the data from being read:
  // - The stream has ended (state.ended).
  // - There is already a pending 'read' operation (state.reading). This is a
  //   case where the the stream has called the implementation defined _read()
  //   method, but they are processing the call asynchronously and have _not_
  //   called push() with new data. In this case we skip performing more
  //   read()s. The execution ends in this method again after the _read() ends
  //   up calling push() with more data.
  while (!state.reading && !state.ended && (state.length < state.highWaterMark || state.flowing && state.length === 0)) {
    var len = state.length;
    debug('maybeReadMore read 0');
    stream.read(0);
    if (len === state.length)
      // didn't get any data, stop spinning.
      break;
  }
  state.readingMore = false;
}

// abstract method.  to be overridden in specific implementation classes.
// call cb(er, data) where data is <= n in length.
// for virtual (non-string, non-buffer) streams, "length" is somewhat
// arbitrary, and perhaps not very meaningful.
Readable.prototype._read = function (n) {
  errorOrDestroy(this, new ERR_METHOD_NOT_IMPLEMENTED('_read()'));
};
Readable.prototype.pipe = function (dest, pipeOpts) {
  var src = this;
  var state = this._readableState;
  switch (state.pipesCount) {
    case 0:
      state.pipes = dest;
      break;
    case 1:
      state.pipes = [state.pipes, dest];
      break;
    default:
      state.pipes.push(dest);
      break;
  }
  state.pipesCount += 1;
  debug('pipe count=%d opts=%j', state.pipesCount, pipeOpts);
  var doEnd = (!pipeOpts || pipeOpts.end !== false) && dest !== process.stdout && dest !== process.stderr;
  var endFn = doEnd ? onend : unpipe;
  if (state.endEmitted) process.nextTick(endFn);else src.once('end', endFn);
  dest.on('unpipe', onunpipe);
  function onunpipe(readable, unpipeInfo) {
    debug('onunpipe');
    if (readable === src) {
      if (unpipeInfo && unpipeInfo.hasUnpiped === false) {
        unpipeInfo.hasUnpiped = true;
        cleanup();
      }
    }
  }
  function onend() {
    debug('onend');
    dest.end();
  }

  // when the dest drains, it reduces the awaitDrain counter
  // on the source.  This would be more elegant with a .once()
  // handler in flow(), but adding and removing repeatedly is
  // too slow.
  var ondrain = pipeOnDrain(src);
  dest.on('drain', ondrain);
  var cleanedUp = false;
  function cleanup() {
    debug('cleanup');
    // cleanup event handlers once the pipe is broken
    dest.removeListener('close', onclose);
    dest.removeListener('finish', onfinish);
    dest.removeListener('drain', ondrain);
    dest.removeListener('error', onerror);
    dest.removeListener('unpipe', onunpipe);
    src.removeListener('end', onend);
    src.removeListener('end', unpipe);
    src.removeListener('data', ondata);
    cleanedUp = true;

    // if the reader is waiting for a drain event from this
    // specific writer, then it would cause it to never start
    // flowing again.
    // So, if this is awaiting a drain, then we just call it now.
    // If we don't know, then assume that we are waiting for one.
    if (state.awaitDrain && (!dest._writableState || dest._writableState.needDrain)) ondrain();
  }
  src.on('data', ondata);
  function ondata(chunk) {
    debug('ondata');
    var ret = dest.write(chunk);
    debug('dest.write', ret);
    if (ret === false) {
      // If the user unpiped during `dest.write()`, it is possible
      // to get stuck in a permanently paused state if that write
      // also returned false.
      // => Check whether `dest` is still a piping destination.
      if ((state.pipesCount === 1 && state.pipes === dest || state.pipesCount > 1 && indexOf(state.pipes, dest) !== -1) && !cleanedUp) {
        debug('false write response, pause', state.awaitDrain);
        state.awaitDrain++;
      }
      src.pause();
    }
  }

  // if the dest has an error, then stop piping into it.
  // however, don't suppress the throwing behavior for this.
  function onerror(er) {
    debug('onerror', er);
    unpipe();
    dest.removeListener('error', onerror);
    if (EElistenerCount(dest, 'error') === 0) errorOrDestroy(dest, er);
  }

  // Make sure our error handler is attached before userland ones.
  prependListener(dest, 'error', onerror);

  // Both close and finish should trigger unpipe, but only once.
  function onclose() {
    dest.removeListener('finish', onfinish);
    unpipe();
  }
  dest.once('close', onclose);
  function onfinish() {
    debug('onfinish');
    dest.removeListener('close', onclose);
    unpipe();
  }
  dest.once('finish', onfinish);
  function unpipe() {
    debug('unpipe');
    src.unpipe(dest);
  }

  // tell the dest that it's being piped to
  dest.emit('pipe', src);

  // start the flow if it hasn't been started already.
  if (!state.flowing) {
    debug('pipe resume');
    src.resume();
  }
  return dest;
};
function pipeOnDrain(src) {
  return function pipeOnDrainFunctionResult() {
    var state = src._readableState;
    debug('pipeOnDrain', state.awaitDrain);
    if (state.awaitDrain) state.awaitDrain--;
    if (state.awaitDrain === 0 && EElistenerCount(src, 'data')) {
      state.flowing = true;
      flow(src);
    }
  };
}
Readable.prototype.unpipe = function (dest) {
  var state = this._readableState;
  var unpipeInfo = {
    hasUnpiped: false
  };

  // if we're not piping anywhere, then do nothing.
  if (state.pipesCount === 0) return this;

  // just one destination.  most common case.
  if (state.pipesCount === 1) {
    // passed in one, but it's not the right one.
    if (dest && dest !== state.pipes) return this;
    if (!dest) dest = state.pipes;

    // got a match.
    state.pipes = null;
    state.pipesCount = 0;
    state.flowing = false;
    if (dest) dest.emit('unpipe', this, unpipeInfo);
    return this;
  }

  // slow case. multiple pipe destinations.

  if (!dest) {
    // remove all.
    var dests = state.pipes;
    var len = state.pipesCount;
    state.pipes = null;
    state.pipesCount = 0;
    state.flowing = false;
    for (var i = 0; i < len; i++) dests[i].emit('unpipe', this, {
      hasUnpiped: false
    });
    return this;
  }

  // try to find the right one.
  var index = indexOf(state.pipes, dest);
  if (index === -1) return this;
  state.pipes.splice(index, 1);
  state.pipesCount -= 1;
  if (state.pipesCount === 1) state.pipes = state.pipes[0];
  dest.emit('unpipe', this, unpipeInfo);
  return this;
};

// set up data events if they are asked for
// Ensure readable listeners eventually get something
Readable.prototype.on = function (ev, fn) {
  var res = Stream.prototype.on.call(this, ev, fn);
  var state = this._readableState;
  if (ev === 'data') {
    // update readableListening so that resume() may be a no-op
    // a few lines down. This is needed to support once('readable').
    state.readableListening = this.listenerCount('readable') > 0;

    // Try start flowing on next tick if stream isn't explicitly paused
    if (state.flowing !== false) this.resume();
  } else if (ev === 'readable') {
    if (!state.endEmitted && !state.readableListening) {
      state.readableListening = state.needReadable = true;
      state.flowing = false;
      state.emittedReadable = false;
      debug('on readable', state.length, state.reading);
      if (state.length) {
        emitReadable(this);
      } else if (!state.reading) {
        process.nextTick(nReadingNextTick, this);
      }
    }
  }
  return res;
};
Readable.prototype.addListener = Readable.prototype.on;
Readable.prototype.removeListener = function (ev, fn) {
  var res = Stream.prototype.removeListener.call(this, ev, fn);
  if (ev === 'readable') {
    // We need to check if there is someone still listening to
    // readable and reset the state. However this needs to happen
    // after readable has been emitted but before I/O (nextTick) to
    // support once('readable', fn) cycles. This means that calling
    // resume within the same tick will have no
    // effect.
    process.nextTick(updateReadableListening, this);
  }
  return res;
};
Readable.prototype.removeAllListeners = function (ev) {
  var res = Stream.prototype.removeAllListeners.apply(this, arguments);
  if (ev === 'readable' || ev === undefined) {
    // We need to check if there is someone still listening to
    // readable and reset the state. However this needs to happen
    // after readable has been emitted but before I/O (nextTick) to
    // support once('readable', fn) cycles. This means that calling
    // resume within the same tick will have no
    // effect.
    process.nextTick(updateReadableListening, this);
  }
  return res;
};
function updateReadableListening(self) {
  var state = self._readableState;
  state.readableListening = self.listenerCount('readable') > 0;
  if (state.resumeScheduled && !state.paused) {
    // flowing needs to be set to true now, otherwise
    // the upcoming resume will not flow.
    state.flowing = true;

    // crude way to check if we should resume
  } else if (self.listenerCount('data') > 0) {
    self.resume();
  }
}
function nReadingNextTick(self) {
  debug('readable nexttick read 0');
  self.read(0);
}

// pause() and resume() are remnants of the legacy readable stream API
// If the user uses them, then switch into old mode.
Readable.prototype.resume = function () {
  var state = this._readableState;
  if (!state.flowing) {
    debug('resume');
    // we flow only if there is no one listening
    // for readable, but we still have to call
    // resume()
    state.flowing = !state.readableListening;
    resume(this, state);
  }
  state.paused = false;
  return this;
};
function resume(stream, state) {
  if (!state.resumeScheduled) {
    state.resumeScheduled = true;
    process.nextTick(resume_, stream, state);
  }
}
function resume_(stream, state) {
  debug('resume', state.reading);
  if (!state.reading) {
    stream.read(0);
  }
  state.resumeScheduled = false;
  stream.emit('resume');
  flow(stream);
  if (state.flowing && !state.reading) stream.read(0);
}
Readable.prototype.pause = function () {
  debug('call pause flowing=%j', this._readableState.flowing);
  if (this._readableState.flowing !== false) {
    debug('pause');
    this._readableState.flowing = false;
    this.emit('pause');
  }
  this._readableState.paused = true;
  return this;
};
function flow(stream) {
  var state = stream._readableState;
  debug('flow', state.flowing);
  while (state.flowing && stream.read() !== null);
}

// wrap an old-style stream as the async data source.
// This is *not* part of the readable stream interface.
// It is an ugly unfortunate mess of history.
Readable.prototype.wrap = function (stream) {
  var _this = this;
  var state = this._readableState;
  var paused = false;
  stream.on('end', function () {
    debug('wrapped end');
    if (state.decoder && !state.ended) {
      var chunk = state.decoder.end();
      if (chunk && chunk.length) _this.push(chunk);
    }
    _this.push(null);
  });
  stream.on('data', function (chunk) {
    debug('wrapped data');
    if (state.decoder) chunk = state.decoder.write(chunk);

    // don't skip over falsy values in objectMode
    if (state.objectMode && (chunk === null || chunk === undefined)) return;else if (!state.objectMode && (!chunk || !chunk.length)) return;
    var ret = _this.push(chunk);
    if (!ret) {
      paused = true;
      stream.pause();
    }
  });

  // proxy all the other methods.
  // important when wrapping filters and duplexes.
  for (var i in stream) {
    if (this[i] === undefined && typeof stream[i] === 'function') {
      this[i] = function methodWrap(method) {
        return function methodWrapReturnFunction() {
          return stream[method].apply(stream, arguments);
        };
      }(i);
    }
  }

  // proxy certain important events.
  for (var n = 0; n < kProxyEvents.length; n++) {
    stream.on(kProxyEvents[n], this.emit.bind(this, kProxyEvents[n]));
  }

  // when we try to consume some more bytes, simply unpause the
  // underlying stream.
  this._read = function (n) {
    debug('wrapped _read', n);
    if (paused) {
      paused = false;
      stream.resume();
    }
  };
  return this;
};
if (typeof Symbol === 'function') {
  Readable.prototype[Symbol.asyncIterator] = function () {
    if (createReadableStreamAsyncIterator === undefined) {
      createReadableStreamAsyncIterator = __webpack_require__(29954);
    }
    return createReadableStreamAsyncIterator(this);
  };
}
Object.defineProperty(Readable.prototype, 'readableHighWaterMark', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function get() {
    return this._readableState.highWaterMark;
  }
});
Object.defineProperty(Readable.prototype, 'readableBuffer', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function get() {
    return this._readableState && this._readableState.buffer;
  }
});
Object.defineProperty(Readable.prototype, 'readableFlowing', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function get() {
    return this._readableState.flowing;
  },
  set: function set(state) {
    if (this._readableState) {
      this._readableState.flowing = state;
    }
  }
});

// exposed for testing purposes only.
Readable._fromList = fromList;
Object.defineProperty(Readable.prototype, 'readableLength', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function get() {
    return this._readableState.length;
  }
});

// Pluck off n bytes from an array of buffers.
// Length is the combined lengths of all the buffers in the list.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function fromList(n, state) {
  // nothing buffered
  if (state.length === 0) return null;
  var ret;
  if (state.objectMode) ret = state.buffer.shift();else if (!n || n >= state.length) {
    // read it all, truncate the list
    if (state.decoder) ret = state.buffer.join('');else if (state.buffer.length === 1) ret = state.buffer.first();else ret = state.buffer.concat(state.length);
    state.buffer.clear();
  } else {
    // read part of list
    ret = state.buffer.consume(n, state.decoder);
  }
  return ret;
}
function endReadable(stream) {
  var state = stream._readableState;
  debug('endReadable', state.endEmitted);
  if (!state.endEmitted) {
    state.ended = true;
    process.nextTick(endReadableNT, state, stream);
  }
}
function endReadableNT(state, stream) {
  debug('endReadableNT', state.endEmitted, state.length);

  // Check that we didn't get one last unshift.
  if (!state.endEmitted && state.length === 0) {
    state.endEmitted = true;
    stream.readable = false;
    stream.emit('end');
    if (state.autoDestroy) {
      // In case of duplex streams we need a way to detect
      // if the writable side is ready for autoDestroy as well
      var wState = stream._writableState;
      if (!wState || wState.autoDestroy && wState.finished) {
        stream.destroy();
      }
    }
  }
}
if (typeof Symbol === 'function') {
  Readable.from = function (iterable, opts) {
    if (from === undefined) {
      from = __webpack_require__(82037);
    }
    return from(Readable, iterable, opts);
  };
}
function indexOf(xs, x) {
  for (var i = 0, l = xs.length; i < l; i++) {
    if (xs[i] === x) return i;
  }
  return -1;
}

/***/ }),

/***/ 41683:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// a transform stream is a readable/writable stream where you do
// something with the data.  Sometimes it's called a "filter",
// but that's not a great name for it, since that implies a thing where
// some bits pass through, and others are simply ignored.  (That would
// be a valid example of a transform, of course.)
//
// While the output is causally related to the input, it's not a
// necessarily symmetric or synchronous transformation.  For example,
// a zlib stream might take multiple plain-text writes(), and then
// emit a single compressed chunk some time in the future.
//
// Here's how this works:
//
// The Transform stream has all the aspects of the readable and writable
// stream classes.  When you write(chunk), that calls _write(chunk,cb)
// internally, and returns false if there's a lot of pending writes
// buffered up.  When you call read(), that calls _read(n) until
// there's enough pending readable data buffered up.
//
// In a transform stream, the written data is placed in a buffer.  When
// _read(n) is called, it transforms the queued up data, calling the
// buffered _write cb's as it consumes chunks.  If consuming a single
// written chunk would result in multiple output chunks, then the first
// outputted bit calls the readcb, and subsequent chunks just go into
// the read buffer, and will cause it to emit 'readable' if necessary.
//
// This way, back-pressure is actually determined by the reading side,
// since _read has to be called to start processing a new chunk.  However,
// a pathological inflate type of transform can cause excessive buffering
// here.  For example, imagine a stream where every byte of input is
// interpreted as an integer from 0-255, and then results in that many
// bytes of output.  Writing the 4 bytes {ff,ff,ff,ff} would result in
// 1kb of data being output.  In this case, you could write a very small
// amount of input, and end up with a very large amount of output.  In
// such a pathological inflating mechanism, there'd be no way to tell
// the system to stop doing the transform.  A single 4MB write could
// cause the system to run out of memory.
//
// However, even in such a pathological case, only a single written chunk
// would be consumed, and then the rest would wait (un-transformed) until
// the results of the previous transformed chunk were consumed.



module.exports = Transform;
var _require$codes = (__webpack_require__(60981)/* .codes */ .q),
  ERR_METHOD_NOT_IMPLEMENTED = _require$codes.ERR_METHOD_NOT_IMPLEMENTED,
  ERR_MULTIPLE_CALLBACK = _require$codes.ERR_MULTIPLE_CALLBACK,
  ERR_TRANSFORM_ALREADY_TRANSFORMING = _require$codes.ERR_TRANSFORM_ALREADY_TRANSFORMING,
  ERR_TRANSFORM_WITH_LENGTH_0 = _require$codes.ERR_TRANSFORM_WITH_LENGTH_0;
var Duplex = __webpack_require__(93337);
__webpack_require__(2937)(Transform, Duplex);
function afterTransform(er, data) {
  var ts = this._transformState;
  ts.transforming = false;
  var cb = ts.writecb;
  if (cb === null) {
    return this.emit('error', new ERR_MULTIPLE_CALLBACK());
  }
  ts.writechunk = null;
  ts.writecb = null;
  if (data != null)
    // single equals check for both `null` and `undefined`
    this.push(data);
  cb(er);
  var rs = this._readableState;
  rs.reading = false;
  if (rs.needReadable || rs.length < rs.highWaterMark) {
    this._read(rs.highWaterMark);
  }
}
function Transform(options) {
  if (!(this instanceof Transform)) return new Transform(options);
  Duplex.call(this, options);
  this._transformState = {
    afterTransform: afterTransform.bind(this),
    needTransform: false,
    transforming: false,
    writecb: null,
    writechunk: null,
    writeencoding: null
  };

  // start out asking for a readable event once data is transformed.
  this._readableState.needReadable = true;

  // we have implemented the _read method, and done the other things
  // that Readable wants before the first _read call, so unset the
  // sync guard flag.
  this._readableState.sync = false;
  if (options) {
    if (typeof options.transform === 'function') this._transform = options.transform;
    if (typeof options.flush === 'function') this._flush = options.flush;
  }

  // When the writable side finishes, then flush out anything remaining.
  this.on('prefinish', prefinish);
}
function prefinish() {
  var _this = this;
  if (typeof this._flush === 'function' && !this._readableState.destroyed) {
    this._flush(function (er, data) {
      done(_this, er, data);
    });
  } else {
    done(this, null, null);
  }
}
Transform.prototype.push = function (chunk, encoding) {
  this._transformState.needTransform = false;
  return Duplex.prototype.push.call(this, chunk, encoding);
};

// This is the part where you do stuff!
// override this function in implementation classes.
// 'chunk' is an input chunk.
//
// Call `push(newChunk)` to pass along transformed output
// to the readable side.  You may call 'push' zero or more times.
//
// Call `cb(err)` when you are done with this chunk.  If you pass
// an error, then that'll put the hurt on the whole operation.  If you
// never call cb(), then you'll never get another chunk.
Transform.prototype._transform = function (chunk, encoding, cb) {
  cb(new ERR_METHOD_NOT_IMPLEMENTED('_transform()'));
};
Transform.prototype._write = function (chunk, encoding, cb) {
  var ts = this._transformState;
  ts.writecb = cb;
  ts.writechunk = chunk;
  ts.writeencoding = encoding;
  if (!ts.transforming) {
    var rs = this._readableState;
    if (ts.needTransform || rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
  }
};

// Doesn't matter what the args are here.
// _transform does all the work.
// That we got here means that the readable side wants more data.
Transform.prototype._read = function (n) {
  var ts = this._transformState;
  if (ts.writechunk !== null && !ts.transforming) {
    ts.transforming = true;
    this._transform(ts.writechunk, ts.writeencoding, ts.afterTransform);
  } else {
    // mark that we need a transform, so that any data that comes in
    // will get processed, now that we've asked for it.
    ts.needTransform = true;
  }
};
Transform.prototype._destroy = function (err, cb) {
  Duplex.prototype._destroy.call(this, err, function (err2) {
    cb(err2);
  });
};
function done(stream, er, data) {
  if (er) return stream.emit('error', er);
  if (data != null)
    // single equals check for both `null` and `undefined`
    stream.push(data);

  // TODO(BridgeAR): Write a test for these two error cases
  // if there's nothing in the write buffer, then that means
  // that nothing more will ever be provided
  if (stream._writableState.length) throw new ERR_TRANSFORM_WITH_LENGTH_0();
  if (stream._transformState.transforming) throw new ERR_TRANSFORM_ALREADY_TRANSFORMING();
  return stream.push(null);
}

/***/ }),

/***/ 86481:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
/* provided dependency */ var process = __webpack_require__(14224);
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// A bit simpler than readable streams.
// Implement an async ._write(chunk, encoding, cb), and it'll handle all
// the drain event emission and buffering.



module.exports = Writable;

/* <replacement> */
function WriteReq(chunk, encoding, cb) {
  this.chunk = chunk;
  this.encoding = encoding;
  this.callback = cb;
  this.next = null;
}

// It seems a linked list but it is not
// there will be only 2 of these for each stream
function CorkedRequest(state) {
  var _this = this;
  this.next = null;
  this.entry = null;
  this.finish = function () {
    onCorkedFinish(_this, state);
  };
}
/* </replacement> */

/*<replacement>*/
var Duplex;
/*</replacement>*/

Writable.WritableState = WritableState;

/*<replacement>*/
var internalUtil = {
  deprecate: __webpack_require__(48863)
};
/*</replacement>*/

/*<replacement>*/
var Stream = __webpack_require__(26922);
/*</replacement>*/

var Buffer = (__webpack_require__(55872).Buffer);
var OurUint8Array = (typeof __webpack_require__.g !== 'undefined' ? __webpack_require__.g : typeof window !== 'undefined' ? window : typeof self !== 'undefined' ? self : {}).Uint8Array || function () {};
function _uint8ArrayToBuffer(chunk) {
  return Buffer.from(chunk);
}
function _isUint8Array(obj) {
  return Buffer.isBuffer(obj) || obj instanceof OurUint8Array;
}
var destroyImpl = __webpack_require__(33591);
var _require = __webpack_require__(16084),
  getHighWaterMark = _require.getHighWaterMark;
var _require$codes = (__webpack_require__(60981)/* .codes */ .q),
  ERR_INVALID_ARG_TYPE = _require$codes.ERR_INVALID_ARG_TYPE,
  ERR_METHOD_NOT_IMPLEMENTED = _require$codes.ERR_METHOD_NOT_IMPLEMENTED,
  ERR_MULTIPLE_CALLBACK = _require$codes.ERR_MULTIPLE_CALLBACK,
  ERR_STREAM_CANNOT_PIPE = _require$codes.ERR_STREAM_CANNOT_PIPE,
  ERR_STREAM_DESTROYED = _require$codes.ERR_STREAM_DESTROYED,
  ERR_STREAM_NULL_VALUES = _require$codes.ERR_STREAM_NULL_VALUES,
  ERR_STREAM_WRITE_AFTER_END = _require$codes.ERR_STREAM_WRITE_AFTER_END,
  ERR_UNKNOWN_ENCODING = _require$codes.ERR_UNKNOWN_ENCODING;
var errorOrDestroy = destroyImpl.errorOrDestroy;
__webpack_require__(2937)(Writable, Stream);
function nop() {}
function WritableState(options, stream, isDuplex) {
  Duplex = Duplex || __webpack_require__(93337);
  options = options || {};

  // Duplex streams are both readable and writable, but share
  // the same options object.
  // However, some cases require setting options to different
  // values for the readable and the writable sides of the duplex stream,
  // e.g. options.readableObjectMode vs. options.writableObjectMode, etc.
  if (typeof isDuplex !== 'boolean') isDuplex = stream instanceof Duplex;

  // object stream flag to indicate whether or not this stream
  // contains buffers or objects.
  this.objectMode = !!options.objectMode;
  if (isDuplex) this.objectMode = this.objectMode || !!options.writableObjectMode;

  // the point at which write() starts returning false
  // Note: 0 is a valid value, means that we always return false if
  // the entire buffer is not flushed immediately on write()
  this.highWaterMark = getHighWaterMark(this, options, 'writableHighWaterMark', isDuplex);

  // if _final has been called
  this.finalCalled = false;

  // drain event flag.
  this.needDrain = false;
  // at the start of calling end()
  this.ending = false;
  // when end() has been called, and returned
  this.ended = false;
  // when 'finish' is emitted
  this.finished = false;

  // has it been destroyed
  this.destroyed = false;

  // should we decode strings into buffers before passing to _write?
  // this is here so that some node-core streams can optimize string
  // handling at a lower level.
  var noDecode = options.decodeStrings === false;
  this.decodeStrings = !noDecode;

  // Crypto is kind of old and crusty.  Historically, its default string
  // encoding is 'binary' so we have to make this configurable.
  // Everything else in the universe uses 'utf8', though.
  this.defaultEncoding = options.defaultEncoding || 'utf8';

  // not an actual buffer we keep track of, but a measurement
  // of how much we're waiting to get pushed to some underlying
  // socket or file.
  this.length = 0;

  // a flag to see when we're in the middle of a write.
  this.writing = false;

  // when true all writes will be buffered until .uncork() call
  this.corked = 0;

  // a flag to be able to tell if the onwrite cb is called immediately,
  // or on a later tick.  We set this to true at first, because any
  // actions that shouldn't happen until "later" should generally also
  // not happen before the first write call.
  this.sync = true;

  // a flag to know if we're processing previously buffered items, which
  // may call the _write() callback in the same tick, so that we don't
  // end up in an overlapped onwrite situation.
  this.bufferProcessing = false;

  // the callback that's passed to _write(chunk,cb)
  this.onwrite = function (er) {
    onwrite(stream, er);
  };

  // the callback that the user supplies to write(chunk,encoding,cb)
  this.writecb = null;

  // the amount that is being written when _write is called.
  this.writelen = 0;
  this.bufferedRequest = null;
  this.lastBufferedRequest = null;

  // number of pending user-supplied write callbacks
  // this must be 0 before 'finish' can be emitted
  this.pendingcb = 0;

  // emit prefinish if the only thing we're waiting for is _write cbs
  // This is relevant for synchronous Transform streams
  this.prefinished = false;

  // True if the error was already emitted and should not be thrown again
  this.errorEmitted = false;

  // Should close be emitted on destroy. Defaults to true.
  this.emitClose = options.emitClose !== false;

  // Should .destroy() be called after 'finish' (and potentially 'end')
  this.autoDestroy = !!options.autoDestroy;

  // count buffered requests
  this.bufferedRequestCount = 0;

  // allocate the first CorkedRequest, there is always
  // one allocated and free to use, and we maintain at most two
  this.corkedRequestsFree = new CorkedRequest(this);
}
WritableState.prototype.getBuffer = function getBuffer() {
  var current = this.bufferedRequest;
  var out = [];
  while (current) {
    out.push(current);
    current = current.next;
  }
  return out;
};
(function () {
  try {
    Object.defineProperty(WritableState.prototype, 'buffer', {
      get: internalUtil.deprecate(function writableStateBufferGetter() {
        return this.getBuffer();
      }, '_writableState.buffer is deprecated. Use _writableState.getBuffer ' + 'instead.', 'DEP0003')
    });
  } catch (_) {}
})();

// Test _writableState for inheritance to account for Duplex streams,
// whose prototype chain only points to Readable.
var realHasInstance;
if (typeof Symbol === 'function' && Symbol.hasInstance && typeof Function.prototype[Symbol.hasInstance] === 'function') {
  realHasInstance = Function.prototype[Symbol.hasInstance];
  Object.defineProperty(Writable, Symbol.hasInstance, {
    value: function value(object) {
      if (realHasInstance.call(this, object)) return true;
      if (this !== Writable) return false;
      return object && object._writableState instanceof WritableState;
    }
  });
} else {
  realHasInstance = function realHasInstance(object) {
    return object instanceof this;
  };
}
function Writable(options) {
  Duplex = Duplex || __webpack_require__(93337);

  // Writable ctor is applied to Duplexes, too.
  // `realHasInstance` is necessary because using plain `instanceof`
  // would return false, as no `_writableState` property is attached.

  // Trying to use the custom `instanceof` for Writable here will also break the
  // Node.js LazyTransform implementation, which has a non-trivial getter for
  // `_writableState` that would lead to infinite recursion.

  // Checking for a Stream.Duplex instance is faster here instead of inside
  // the WritableState constructor, at least with V8 6.5
  var isDuplex = this instanceof Duplex;
  if (!isDuplex && !realHasInstance.call(Writable, this)) return new Writable(options);
  this._writableState = new WritableState(options, this, isDuplex);

  // legacy.
  this.writable = true;
  if (options) {
    if (typeof options.write === 'function') this._write = options.write;
    if (typeof options.writev === 'function') this._writev = options.writev;
    if (typeof options.destroy === 'function') this._destroy = options.destroy;
    if (typeof options.final === 'function') this._final = options.final;
  }
  Stream.call(this);
}

// Otherwise people can pipe Writable streams, which is just wrong.
Writable.prototype.pipe = function () {
  errorOrDestroy(this, new ERR_STREAM_CANNOT_PIPE());
};
function writeAfterEnd(stream, cb) {
  var er = new ERR_STREAM_WRITE_AFTER_END();
  // TODO: defer error events consistently everywhere, not just the cb
  errorOrDestroy(stream, er);
  process.nextTick(cb, er);
}

// Checks that a user-supplied chunk is valid, especially for the particular
// mode the stream is in. Currently this means that `null` is never accepted
// and undefined/non-string values are only allowed in object mode.
function validChunk(stream, state, chunk, cb) {
  var er;
  if (chunk === null) {
    er = new ERR_STREAM_NULL_VALUES();
  } else if (typeof chunk !== 'string' && !state.objectMode) {
    er = new ERR_INVALID_ARG_TYPE('chunk', ['string', 'Buffer'], chunk);
  }
  if (er) {
    errorOrDestroy(stream, er);
    process.nextTick(cb, er);
    return false;
  }
  return true;
}
Writable.prototype.write = function (chunk, encoding, cb) {
  var state = this._writableState;
  var ret = false;
  var isBuf = !state.objectMode && _isUint8Array(chunk);
  if (isBuf && !Buffer.isBuffer(chunk)) {
    chunk = _uint8ArrayToBuffer(chunk);
  }
  if (typeof encoding === 'function') {
    cb = encoding;
    encoding = null;
  }
  if (isBuf) encoding = 'buffer';else if (!encoding) encoding = state.defaultEncoding;
  if (typeof cb !== 'function') cb = nop;
  if (state.ending) writeAfterEnd(this, cb);else if (isBuf || validChunk(this, state, chunk, cb)) {
    state.pendingcb++;
    ret = writeOrBuffer(this, state, isBuf, chunk, encoding, cb);
  }
  return ret;
};
Writable.prototype.cork = function () {
  this._writableState.corked++;
};
Writable.prototype.uncork = function () {
  var state = this._writableState;
  if (state.corked) {
    state.corked--;
    if (!state.writing && !state.corked && !state.bufferProcessing && state.bufferedRequest) clearBuffer(this, state);
  }
};
Writable.prototype.setDefaultEncoding = function setDefaultEncoding(encoding) {
  // node::ParseEncoding() requires lower case.
  if (typeof encoding === 'string') encoding = encoding.toLowerCase();
  if (!(['hex', 'utf8', 'utf-8', 'ascii', 'binary', 'base64', 'ucs2', 'ucs-2', 'utf16le', 'utf-16le', 'raw'].indexOf((encoding + '').toLowerCase()) > -1)) throw new ERR_UNKNOWN_ENCODING(encoding);
  this._writableState.defaultEncoding = encoding;
  return this;
};
Object.defineProperty(Writable.prototype, 'writableBuffer', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function get() {
    return this._writableState && this._writableState.getBuffer();
  }
});
function decodeChunk(state, chunk, encoding) {
  if (!state.objectMode && state.decodeStrings !== false && typeof chunk === 'string') {
    chunk = Buffer.from(chunk, encoding);
  }
  return chunk;
}
Object.defineProperty(Writable.prototype, 'writableHighWaterMark', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function get() {
    return this._writableState.highWaterMark;
  }
});

// if we're already writing something, then just put this
// in the queue, and wait our turn.  Otherwise, call _write
// If we return false, then we need a drain event, so set that flag.
function writeOrBuffer(stream, state, isBuf, chunk, encoding, cb) {
  if (!isBuf) {
    var newChunk = decodeChunk(state, chunk, encoding);
    if (chunk !== newChunk) {
      isBuf = true;
      encoding = 'buffer';
      chunk = newChunk;
    }
  }
  var len = state.objectMode ? 1 : chunk.length;
  state.length += len;
  var ret = state.length < state.highWaterMark;
  // we must ensure that previous needDrain will not be reset to false.
  if (!ret) state.needDrain = true;
  if (state.writing || state.corked) {
    var last = state.lastBufferedRequest;
    state.lastBufferedRequest = {
      chunk: chunk,
      encoding: encoding,
      isBuf: isBuf,
      callback: cb,
      next: null
    };
    if (last) {
      last.next = state.lastBufferedRequest;
    } else {
      state.bufferedRequest = state.lastBufferedRequest;
    }
    state.bufferedRequestCount += 1;
  } else {
    doWrite(stream, state, false, len, chunk, encoding, cb);
  }
  return ret;
}
function doWrite(stream, state, writev, len, chunk, encoding, cb) {
  state.writelen = len;
  state.writecb = cb;
  state.writing = true;
  state.sync = true;
  if (state.destroyed) state.onwrite(new ERR_STREAM_DESTROYED('write'));else if (writev) stream._writev(chunk, state.onwrite);else stream._write(chunk, encoding, state.onwrite);
  state.sync = false;
}
function onwriteError(stream, state, sync, er, cb) {
  --state.pendingcb;
  if (sync) {
    // defer the callback if we are being called synchronously
    // to avoid piling up things on the stack
    process.nextTick(cb, er);
    // this can emit finish, and it will always happen
    // after error
    process.nextTick(finishMaybe, stream, state);
    stream._writableState.errorEmitted = true;
    errorOrDestroy(stream, er);
  } else {
    // the caller expect this to happen before if
    // it is async
    cb(er);
    stream._writableState.errorEmitted = true;
    errorOrDestroy(stream, er);
    // this can emit finish, but finish must
    // always follow error
    finishMaybe(stream, state);
  }
}
function onwriteStateUpdate(state) {
  state.writing = false;
  state.writecb = null;
  state.length -= state.writelen;
  state.writelen = 0;
}
function onwrite(stream, er) {
  var state = stream._writableState;
  var sync = state.sync;
  var cb = state.writecb;
  if (typeof cb !== 'function') throw new ERR_MULTIPLE_CALLBACK();
  onwriteStateUpdate(state);
  if (er) onwriteError(stream, state, sync, er, cb);else {
    // Check if we're actually ready to finish, but don't emit yet
    var finished = needFinish(state) || stream.destroyed;
    if (!finished && !state.corked && !state.bufferProcessing && state.bufferedRequest) {
      clearBuffer(stream, state);
    }
    if (sync) {
      process.nextTick(afterWrite, stream, state, finished, cb);
    } else {
      afterWrite(stream, state, finished, cb);
    }
  }
}
function afterWrite(stream, state, finished, cb) {
  if (!finished) onwriteDrain(stream, state);
  state.pendingcb--;
  cb();
  finishMaybe(stream, state);
}

// Must force callback to be called on nextTick, so that we don't
// emit 'drain' before the write() consumer gets the 'false' return
// value, and has a chance to attach a 'drain' listener.
function onwriteDrain(stream, state) {
  if (state.length === 0 && state.needDrain) {
    state.needDrain = false;
    stream.emit('drain');
  }
}

// if there's something in the buffer waiting, then process it
function clearBuffer(stream, state) {
  state.bufferProcessing = true;
  var entry = state.bufferedRequest;
  if (stream._writev && entry && entry.next) {
    // Fast case, write everything using _writev()
    var l = state.bufferedRequestCount;
    var buffer = new Array(l);
    var holder = state.corkedRequestsFree;
    holder.entry = entry;
    var count = 0;
    var allBuffers = true;
    while (entry) {
      buffer[count] = entry;
      if (!entry.isBuf) allBuffers = false;
      entry = entry.next;
      count += 1;
    }
    buffer.allBuffers = allBuffers;
    doWrite(stream, state, true, state.length, buffer, '', holder.finish);

    // doWrite is almost always async, defer these to save a bit of time
    // as the hot path ends with doWrite
    state.pendingcb++;
    state.lastBufferedRequest = null;
    if (holder.next) {
      state.corkedRequestsFree = holder.next;
      holder.next = null;
    } else {
      state.corkedRequestsFree = new CorkedRequest(state);
    }
    state.bufferedRequestCount = 0;
  } else {
    // Slow case, write chunks one-by-one
    while (entry) {
      var chunk = entry.chunk;
      var encoding = entry.encoding;
      var cb = entry.callback;
      var len = state.objectMode ? 1 : chunk.length;
      doWrite(stream, state, false, len, chunk, encoding, cb);
      entry = entry.next;
      state.bufferedRequestCount--;
      // if we didn't call the onwrite immediately, then
      // it means that we need to wait until it does.
      // also, that means that the chunk and cb are currently
      // being processed, so move the buffer counter past them.
      if (state.writing) {
        break;
      }
    }
    if (entry === null) state.lastBufferedRequest = null;
  }
  state.bufferedRequest = entry;
  state.bufferProcessing = false;
}
Writable.prototype._write = function (chunk, encoding, cb) {
  cb(new ERR_METHOD_NOT_IMPLEMENTED('_write()'));
};
Writable.prototype._writev = null;
Writable.prototype.end = function (chunk, encoding, cb) {
  var state = this._writableState;
  if (typeof chunk === 'function') {
    cb = chunk;
    chunk = null;
    encoding = null;
  } else if (typeof encoding === 'function') {
    cb = encoding;
    encoding = null;
  }
  if (chunk !== null && chunk !== undefined) this.write(chunk, encoding);

  // .end() fully uncorks
  if (state.corked) {
    state.corked = 1;
    this.uncork();
  }

  // ignore unnecessary end() calls.
  if (!state.ending) endWritable(this, state, cb);
  return this;
};
Object.defineProperty(Writable.prototype, 'writableLength', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function get() {
    return this._writableState.length;
  }
});
function needFinish(state) {
  return state.ending && state.length === 0 && state.bufferedRequest === null && !state.finished && !state.writing;
}
function callFinal(stream, state) {
  stream._final(function (err) {
    state.pendingcb--;
    if (err) {
      errorOrDestroy(stream, err);
    }
    state.prefinished = true;
    stream.emit('prefinish');
    finishMaybe(stream, state);
  });
}
function prefinish(stream, state) {
  if (!state.prefinished && !state.finalCalled) {
    if (typeof stream._final === 'function' && !state.destroyed) {
      state.pendingcb++;
      state.finalCalled = true;
      process.nextTick(callFinal, stream, state);
    } else {
      state.prefinished = true;
      stream.emit('prefinish');
    }
  }
}
function finishMaybe(stream, state) {
  var need = needFinish(state);
  if (need) {
    prefinish(stream, state);
    if (state.pendingcb === 0) {
      state.finished = true;
      stream.emit('finish');
      if (state.autoDestroy) {
        // In case of duplex streams we need a way to detect
        // if the readable side is ready for autoDestroy as well
        var rState = stream._readableState;
        if (!rState || rState.autoDestroy && rState.endEmitted) {
          stream.destroy();
        }
      }
    }
  }
  return need;
}
function endWritable(stream, state, cb) {
  state.ending = true;
  finishMaybe(stream, state);
  if (cb) {
    if (state.finished) process.nextTick(cb);else stream.once('finish', cb);
  }
  state.ended = true;
  stream.writable = false;
}
function onCorkedFinish(corkReq, state, err) {
  var entry = corkReq.entry;
  corkReq.entry = null;
  while (entry) {
    var cb = entry.callback;
    state.pendingcb--;
    cb(err);
    entry = entry.next;
  }

  // reuse the free corkReq.
  state.corkedRequestsFree.next = corkReq;
}
Object.defineProperty(Writable.prototype, 'destroyed', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function get() {
    if (this._writableState === undefined) {
      return false;
    }
    return this._writableState.destroyed;
  },
  set: function set(value) {
    // we ignore the value if the stream
    // has not been initialized yet
    if (!this._writableState) {
      return;
    }

    // backward compatibility, the user is explicitly
    // managing destroyed
    this._writableState.destroyed = value;
  }
});
Writable.prototype.destroy = destroyImpl.destroy;
Writable.prototype._undestroy = destroyImpl.undestroy;
Writable.prototype._destroy = function (err, cb) {
  cb(err);
};

/***/ }),

/***/ 29954:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
/* provided dependency */ var process = __webpack_require__(14224);


var _Object$setPrototypeO;
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var finished = __webpack_require__(43675);
var kLastResolve = Symbol('lastResolve');
var kLastReject = Symbol('lastReject');
var kError = Symbol('error');
var kEnded = Symbol('ended');
var kLastPromise = Symbol('lastPromise');
var kHandlePromise = Symbol('handlePromise');
var kStream = Symbol('stream');
function createIterResult(value, done) {
  return {
    value: value,
    done: done
  };
}
function readAndResolve(iter) {
  var resolve = iter[kLastResolve];
  if (resolve !== null) {
    var data = iter[kStream].read();
    // we defer if data is null
    // we can be expecting either 'end' or
    // 'error'
    if (data !== null) {
      iter[kLastPromise] = null;
      iter[kLastResolve] = null;
      iter[kLastReject] = null;
      resolve(createIterResult(data, false));
    }
  }
}
function onReadable(iter) {
  // we wait for the next tick, because it might
  // emit an error with process.nextTick
  process.nextTick(readAndResolve, iter);
}
function wrapForNext(lastPromise, iter) {
  return function (resolve, reject) {
    lastPromise.then(function () {
      if (iter[kEnded]) {
        resolve(createIterResult(undefined, true));
        return;
      }
      iter[kHandlePromise](resolve, reject);
    }, reject);
  };
}
var AsyncIteratorPrototype = Object.getPrototypeOf(function () {});
var ReadableStreamAsyncIteratorPrototype = Object.setPrototypeOf((_Object$setPrototypeO = {
  get stream() {
    return this[kStream];
  },
  next: function next() {
    var _this = this;
    // if we have detected an error in the meanwhile
    // reject straight away
    var error = this[kError];
    if (error !== null) {
      return Promise.reject(error);
    }
    if (this[kEnded]) {
      return Promise.resolve(createIterResult(undefined, true));
    }
    if (this[kStream].destroyed) {
      // We need to defer via nextTick because if .destroy(err) is
      // called, the error will be emitted via nextTick, and
      // we cannot guarantee that there is no error lingering around
      // waiting to be emitted.
      return new Promise(function (resolve, reject) {
        process.nextTick(function () {
          if (_this[kError]) {
            reject(_this[kError]);
          } else {
            resolve(createIterResult(undefined, true));
          }
        });
      });
    }

    // if we have multiple next() calls
    // we will wait for the previous Promise to finish
    // this logic is optimized to support for await loops,
    // where next() is only called once at a time
    var lastPromise = this[kLastPromise];
    var promise;
    if (lastPromise) {
      promise = new Promise(wrapForNext(lastPromise, this));
    } else {
      // fast path needed to support multiple this.push()
      // without triggering the next() queue
      var data = this[kStream].read();
      if (data !== null) {
        return Promise.resolve(createIterResult(data, false));
      }
      promise = new Promise(this[kHandlePromise]);
    }
    this[kLastPromise] = promise;
    return promise;
  }
}, _defineProperty(_Object$setPrototypeO, Symbol.asyncIterator, function () {
  return this;
}), _defineProperty(_Object$setPrototypeO, "return", function _return() {
  var _this2 = this;
  // destroy(err, cb) is a private API
  // we can guarantee we have that here, because we control the
  // Readable class this is attached to
  return new Promise(function (resolve, reject) {
    _this2[kStream].destroy(null, function (err) {
      if (err) {
        reject(err);
        return;
      }
      resolve(createIterResult(undefined, true));
    });
  });
}), _Object$setPrototypeO), AsyncIteratorPrototype);
var createReadableStreamAsyncIterator = function createReadableStreamAsyncIterator(stream) {
  var _Object$create;
  var iterator = Object.create(ReadableStreamAsyncIteratorPrototype, (_Object$create = {}, _defineProperty(_Object$create, kStream, {
    value: stream,
    writable: true
  }), _defineProperty(_Object$create, kLastResolve, {
    value: null,
    writable: true
  }), _defineProperty(_Object$create, kLastReject, {
    value: null,
    writable: true
  }), _defineProperty(_Object$create, kError, {
    value: null,
    writable: true
  }), _defineProperty(_Object$create, kEnded, {
    value: stream._readableState.endEmitted,
    writable: true
  }), _defineProperty(_Object$create, kHandlePromise, {
    value: function value(resolve, reject) {
      var data = iterator[kStream].read();
      if (data) {
        iterator[kLastPromise] = null;
        iterator[kLastResolve] = null;
        iterator[kLastReject] = null;
        resolve(createIterResult(data, false));
      } else {
        iterator[kLastResolve] = resolve;
        iterator[kLastReject] = reject;
      }
    },
    writable: true
  }), _Object$create));
  iterator[kLastPromise] = null;
  finished(stream, function (err) {
    if (err && err.code !== 'ERR_STREAM_PREMATURE_CLOSE') {
      var reject = iterator[kLastReject];
      // reject if we are waiting for data in the Promise
      // returned by next() and store the error
      if (reject !== null) {
        iterator[kLastPromise] = null;
        iterator[kLastResolve] = null;
        iterator[kLastReject] = null;
        reject(err);
      }
      iterator[kError] = err;
      return;
    }
    var resolve = iterator[kLastResolve];
    if (resolve !== null) {
      iterator[kLastPromise] = null;
      iterator[kLastResolve] = null;
      iterator[kLastReject] = null;
      resolve(createIterResult(undefined, true));
    }
    iterator[kEnded] = true;
  });
  stream.on('readable', onReadable.bind(null, iterator));
  return iterator;
};
module.exports = createReadableStreamAsyncIterator;

/***/ }),

/***/ 96292:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var _require = __webpack_require__(55872),
  Buffer = _require.Buffer;
var _require2 = __webpack_require__(87942),
  inspect = _require2.inspect;
var custom = inspect && inspect.custom || 'inspect';
function copyBuffer(src, target, offset) {
  Buffer.prototype.copy.call(src, target, offset);
}
module.exports = /*#__PURE__*/function () {
  function BufferList() {
    _classCallCheck(this, BufferList);
    this.head = null;
    this.tail = null;
    this.length = 0;
  }
  _createClass(BufferList, [{
    key: "push",
    value: function push(v) {
      var entry = {
        data: v,
        next: null
      };
      if (this.length > 0) this.tail.next = entry;else this.head = entry;
      this.tail = entry;
      ++this.length;
    }
  }, {
    key: "unshift",
    value: function unshift(v) {
      var entry = {
        data: v,
        next: this.head
      };
      if (this.length === 0) this.tail = entry;
      this.head = entry;
      ++this.length;
    }
  }, {
    key: "shift",
    value: function shift() {
      if (this.length === 0) return;
      var ret = this.head.data;
      if (this.length === 1) this.head = this.tail = null;else this.head = this.head.next;
      --this.length;
      return ret;
    }
  }, {
    key: "clear",
    value: function clear() {
      this.head = this.tail = null;
      this.length = 0;
    }
  }, {
    key: "join",
    value: function join(s) {
      if (this.length === 0) return '';
      var p = this.head;
      var ret = '' + p.data;
      while (p = p.next) ret += s + p.data;
      return ret;
    }
  }, {
    key: "concat",
    value: function concat(n) {
      if (this.length === 0) return Buffer.alloc(0);
      var ret = Buffer.allocUnsafe(n >>> 0);
      var p = this.head;
      var i = 0;
      while (p) {
        copyBuffer(p.data, ret, i);
        i += p.data.length;
        p = p.next;
      }
      return ret;
    }

    // Consumes a specified amount of bytes or characters from the buffered data.
  }, {
    key: "consume",
    value: function consume(n, hasStrings) {
      var ret;
      if (n < this.head.data.length) {
        // `slice` is the same for buffers and strings.
        ret = this.head.data.slice(0, n);
        this.head.data = this.head.data.slice(n);
      } else if (n === this.head.data.length) {
        // First chunk is a perfect match.
        ret = this.shift();
      } else {
        // Result spans more than one buffer.
        ret = hasStrings ? this._getString(n) : this._getBuffer(n);
      }
      return ret;
    }
  }, {
    key: "first",
    value: function first() {
      return this.head.data;
    }

    // Consumes a specified amount of characters from the buffered data.
  }, {
    key: "_getString",
    value: function _getString(n) {
      var p = this.head;
      var c = 1;
      var ret = p.data;
      n -= ret.length;
      while (p = p.next) {
        var str = p.data;
        var nb = n > str.length ? str.length : n;
        if (nb === str.length) ret += str;else ret += str.slice(0, n);
        n -= nb;
        if (n === 0) {
          if (nb === str.length) {
            ++c;
            if (p.next) this.head = p.next;else this.head = this.tail = null;
          } else {
            this.head = p;
            p.data = str.slice(nb);
          }
          break;
        }
        ++c;
      }
      this.length -= c;
      return ret;
    }

    // Consumes a specified amount of bytes from the buffered data.
  }, {
    key: "_getBuffer",
    value: function _getBuffer(n) {
      var ret = Buffer.allocUnsafe(n);
      var p = this.head;
      var c = 1;
      p.data.copy(ret);
      n -= p.data.length;
      while (p = p.next) {
        var buf = p.data;
        var nb = n > buf.length ? buf.length : n;
        buf.copy(ret, ret.length - n, 0, nb);
        n -= nb;
        if (n === 0) {
          if (nb === buf.length) {
            ++c;
            if (p.next) this.head = p.next;else this.head = this.tail = null;
          } else {
            this.head = p;
            p.data = buf.slice(nb);
          }
          break;
        }
        ++c;
      }
      this.length -= c;
      return ret;
    }

    // Make sure the linked list only shows the minimal necessary information.
  }, {
    key: custom,
    value: function value(_, options) {
      return inspect(this, _objectSpread(_objectSpread({}, options), {}, {
        // Only inspect one level.
        depth: 0,
        // It should not recurse.
        customInspect: false
      }));
    }
  }]);
  return BufferList;
}();

/***/ }),

/***/ 33591:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
/* provided dependency */ var process = __webpack_require__(14224);


// undocumented cb() API, needed for core, not for public API
function destroy(err, cb) {
  var _this = this;
  var readableDestroyed = this._readableState && this._readableState.destroyed;
  var writableDestroyed = this._writableState && this._writableState.destroyed;
  if (readableDestroyed || writableDestroyed) {
    if (cb) {
      cb(err);
    } else if (err) {
      if (!this._writableState) {
        process.nextTick(emitErrorNT, this, err);
      } else if (!this._writableState.errorEmitted) {
        this._writableState.errorEmitted = true;
        process.nextTick(emitErrorNT, this, err);
      }
    }
    return this;
  }

  // we set destroyed to true before firing error callbacks in order
  // to make it re-entrance safe in case destroy() is called within callbacks

  if (this._readableState) {
    this._readableState.destroyed = true;
  }

  // if this is a duplex stream mark the writable part as destroyed as well
  if (this._writableState) {
    this._writableState.destroyed = true;
  }
  this._destroy(err || null, function (err) {
    if (!cb && err) {
      if (!_this._writableState) {
        process.nextTick(emitErrorAndCloseNT, _this, err);
      } else if (!_this._writableState.errorEmitted) {
        _this._writableState.errorEmitted = true;
        process.nextTick(emitErrorAndCloseNT, _this, err);
      } else {
        process.nextTick(emitCloseNT, _this);
      }
    } else if (cb) {
      process.nextTick(emitCloseNT, _this);
      cb(err);
    } else {
      process.nextTick(emitCloseNT, _this);
    }
  });
  return this;
}
function emitErrorAndCloseNT(self, err) {
  emitErrorNT(self, err);
  emitCloseNT(self);
}
function emitCloseNT(self) {
  if (self._writableState && !self._writableState.emitClose) return;
  if (self._readableState && !self._readableState.emitClose) return;
  self.emit('close');
}
function undestroy() {
  if (this._readableState) {
    this._readableState.destroyed = false;
    this._readableState.reading = false;
    this._readableState.ended = false;
    this._readableState.endEmitted = false;
  }
  if (this._writableState) {
    this._writableState.destroyed = false;
    this._writableState.ended = false;
    this._writableState.ending = false;
    this._writableState.finalCalled = false;
    this._writableState.prefinished = false;
    this._writableState.finished = false;
    this._writableState.errorEmitted = false;
  }
}
function emitErrorNT(self, err) {
  self.emit('error', err);
}
function errorOrDestroy(stream, err) {
  // We have tests that rely on errors being emitted
  // in the same tick, so changing this is semver major.
  // For now when you opt-in to autoDestroy we allow
  // the error to be emitted nextTick. In a future
  // semver major update we should change the default to this.

  var rState = stream._readableState;
  var wState = stream._writableState;
  if (rState && rState.autoDestroy || wState && wState.autoDestroy) stream.destroy(err);else stream.emit('error', err);
}
module.exports = {
  destroy: destroy,
  undestroy: undestroy,
  errorOrDestroy: errorOrDestroy
};

/***/ }),

/***/ 43675:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
// Ported from https://github.com/mafintosh/end-of-stream with
// permission from the author, Mathias Buus (@mafintosh).



var ERR_STREAM_PREMATURE_CLOSE = (__webpack_require__(60981)/* .codes.ERR_STREAM_PREMATURE_CLOSE */ .q.ERR_STREAM_PREMATURE_CLOSE);
function once(callback) {
  var called = false;
  return function () {
    if (called) return;
    called = true;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    callback.apply(this, args);
  };
}
function noop() {}
function isRequest(stream) {
  return stream.setHeader && typeof stream.abort === 'function';
}
function eos(stream, opts, callback) {
  if (typeof opts === 'function') return eos(stream, null, opts);
  if (!opts) opts = {};
  callback = once(callback || noop);
  var readable = opts.readable || opts.readable !== false && stream.readable;
  var writable = opts.writable || opts.writable !== false && stream.writable;
  var onlegacyfinish = function onlegacyfinish() {
    if (!stream.writable) onfinish();
  };
  var writableEnded = stream._writableState && stream._writableState.finished;
  var onfinish = function onfinish() {
    writable = false;
    writableEnded = true;
    if (!readable) callback.call(stream);
  };
  var readableEnded = stream._readableState && stream._readableState.endEmitted;
  var onend = function onend() {
    readable = false;
    readableEnded = true;
    if (!writable) callback.call(stream);
  };
  var onerror = function onerror(err) {
    callback.call(stream, err);
  };
  var onclose = function onclose() {
    var err;
    if (readable && !readableEnded) {
      if (!stream._readableState || !stream._readableState.ended) err = new ERR_STREAM_PREMATURE_CLOSE();
      return callback.call(stream, err);
    }
    if (writable && !writableEnded) {
      if (!stream._writableState || !stream._writableState.ended) err = new ERR_STREAM_PREMATURE_CLOSE();
      return callback.call(stream, err);
    }
  };
  var onrequest = function onrequest() {
    stream.req.on('finish', onfinish);
  };
  if (isRequest(stream)) {
    stream.on('complete', onfinish);
    stream.on('abort', onclose);
    if (stream.req) onrequest();else stream.on('request', onrequest);
  } else if (writable && !stream._writableState) {
    // legacy streams
    stream.on('end', onlegacyfinish);
    stream.on('close', onlegacyfinish);
  }
  stream.on('end', onend);
  stream.on('finish', onfinish);
  if (opts.error !== false) stream.on('error', onerror);
  stream.on('close', onclose);
  return function () {
    stream.removeListener('complete', onfinish);
    stream.removeListener('abort', onclose);
    stream.removeListener('request', onrequest);
    if (stream.req) stream.req.removeListener('finish', onfinish);
    stream.removeListener('end', onlegacyfinish);
    stream.removeListener('close', onlegacyfinish);
    stream.removeListener('finish', onfinish);
    stream.removeListener('end', onend);
    stream.removeListener('error', onerror);
    stream.removeListener('close', onclose);
  };
}
module.exports = eos;

/***/ }),

/***/ 82037:
/***/ (function(module) {

module.exports = function () {
  throw new Error('Readable.from is not available in the browser')
};


/***/ }),

/***/ 95597:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
// Ported from https://github.com/mafintosh/pump with
// permission from the author, Mathias Buus (@mafintosh).



var eos;
function once(callback) {
  var called = false;
  return function () {
    if (called) return;
    called = true;
    callback.apply(void 0, arguments);
  };
}
var _require$codes = (__webpack_require__(60981)/* .codes */ .q),
  ERR_MISSING_ARGS = _require$codes.ERR_MISSING_ARGS,
  ERR_STREAM_DESTROYED = _require$codes.ERR_STREAM_DESTROYED;
function noop(err) {
  // Rethrow the error if it exists to avoid swallowing it
  if (err) throw err;
}
function isRequest(stream) {
  return stream.setHeader && typeof stream.abort === 'function';
}
function destroyer(stream, reading, writing, callback) {
  callback = once(callback);
  var closed = false;
  stream.on('close', function () {
    closed = true;
  });
  if (eos === undefined) eos = __webpack_require__(43675);
  eos(stream, {
    readable: reading,
    writable: writing
  }, function (err) {
    if (err) return callback(err);
    closed = true;
    callback();
  });
  var destroyed = false;
  return function (err) {
    if (closed) return;
    if (destroyed) return;
    destroyed = true;

    // request.destroy just do .end - .abort is what we want
    if (isRequest(stream)) return stream.abort();
    if (typeof stream.destroy === 'function') return stream.destroy();
    callback(err || new ERR_STREAM_DESTROYED('pipe'));
  };
}
function call(fn) {
  fn();
}
function pipe(from, to) {
  return from.pipe(to);
}
function popCallback(streams) {
  if (!streams.length) return noop;
  if (typeof streams[streams.length - 1] !== 'function') return noop;
  return streams.pop();
}
function pipeline() {
  for (var _len = arguments.length, streams = new Array(_len), _key = 0; _key < _len; _key++) {
    streams[_key] = arguments[_key];
  }
  var callback = popCallback(streams);
  if (Array.isArray(streams[0])) streams = streams[0];
  if (streams.length < 2) {
    throw new ERR_MISSING_ARGS('streams');
  }
  var error;
  var destroys = streams.map(function (stream, i) {
    var reading = i < streams.length - 1;
    var writing = i > 0;
    return destroyer(stream, reading, writing, function (err) {
      if (!error) error = err;
      if (err) destroys.forEach(call);
      if (reading) return;
      destroys.forEach(call);
      callback(error);
    });
  });
  return streams.reduce(pipe);
}
module.exports = pipeline;

/***/ }),

/***/ 16084:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var ERR_INVALID_OPT_VALUE = (__webpack_require__(60981)/* .codes.ERR_INVALID_OPT_VALUE */ .q.ERR_INVALID_OPT_VALUE);
function highWaterMarkFrom(options, isDuplex, duplexKey) {
  return options.highWaterMark != null ? options.highWaterMark : isDuplex ? options[duplexKey] : null;
}
function getHighWaterMark(state, options, duplexKey, isDuplex) {
  var hwm = highWaterMarkFrom(options, isDuplex, duplexKey);
  if (hwm != null) {
    if (!(isFinite(hwm) && Math.floor(hwm) === hwm) || hwm < 0) {
      var name = isDuplex ? duplexKey : 'highWaterMark';
      throw new ERR_INVALID_OPT_VALUE(name, hwm);
    }
    return Math.floor(hwm);
  }

  // Default value
  return state.objectMode ? 16 : 16 * 1024;
}
module.exports = {
  getHighWaterMark: getHighWaterMark
};

/***/ }),

/***/ 26922:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(72100).EventEmitter;


/***/ }),

/***/ 62981:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(25294);
exports.Stream = exports;
exports.Readable = exports;
exports.Writable = __webpack_require__(86481);
exports.Duplex = __webpack_require__(93337);
exports.Transform = __webpack_require__(41683);
exports.PassThrough = __webpack_require__(68797);
exports.finished = __webpack_require__(43675);
exports.pipeline = __webpack_require__(95597);


/***/ }),

/***/ 85067:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


// Keep this file as an alias for the full stream module.
module.exports = __webpack_require__(78591).Writable


/***/ }),

/***/ 47287:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


const { SymbolDispose } = __webpack_require__(54136)
const { AbortError, codes } = __webpack_require__(91198)
const { isNodeStream, isWebStream, kControllerErrorFunction } = __webpack_require__(87614)
const eos = __webpack_require__(86695)
const { ERR_INVALID_ARG_TYPE } = codes
let addAbortListener

// This method is inlined here for readable-stream
// It also does not allow for signal to not exist on the stream
// https://github.com/nodejs/node/pull/36061#discussion_r533718029
const validateAbortSignal = (signal, name) => {
  if (typeof signal !== 'object' || !('aborted' in signal)) {
    throw new ERR_INVALID_ARG_TYPE(name, 'AbortSignal', signal)
  }
}
module.exports.addAbortSignal = function addAbortSignal(signal, stream) {
  validateAbortSignal(signal, 'signal')
  if (!isNodeStream(stream) && !isWebStream(stream)) {
    throw new ERR_INVALID_ARG_TYPE('stream', ['ReadableStream', 'WritableStream', 'Stream'], stream)
  }
  return module.exports.addAbortSignalNoValidate(signal, stream)
}
module.exports.addAbortSignalNoValidate = function (signal, stream) {
  if (typeof signal !== 'object' || !('aborted' in signal)) {
    return stream
  }
  const onAbort = isNodeStream(stream)
    ? () => {
        stream.destroy(
          new AbortError(undefined, {
            cause: signal.reason
          })
        )
      }
    : () => {
        stream[kControllerErrorFunction](
          new AbortError(undefined, {
            cause: signal.reason
          })
        )
      }
  if (signal.aborted) {
    onAbort()
  } else {
    addAbortListener = addAbortListener || (__webpack_require__(89349).addAbortListener)
    const disposable = addAbortListener(signal, onAbort)
    eos(stream, disposable[SymbolDispose])
  }
  return stream
}


/***/ }),

/***/ 91247:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


const { StringPrototypeSlice, SymbolIterator, TypedArrayPrototypeSet, Uint8Array } = __webpack_require__(54136)
const { Buffer } = __webpack_require__(55872)
const { inspect } = __webpack_require__(89349)
module.exports = class BufferList {
  constructor() {
    this.head = null
    this.tail = null
    this.length = 0
  }
  push(v) {
    const entry = {
      data: v,
      next: null
    }
    if (this.length > 0) this.tail.next = entry
    else this.head = entry
    this.tail = entry
    ++this.length
  }
  unshift(v) {
    const entry = {
      data: v,
      next: this.head
    }
    if (this.length === 0) this.tail = entry
    this.head = entry
    ++this.length
  }
  shift() {
    if (this.length === 0) return
    const ret = this.head.data
    if (this.length === 1) this.head = this.tail = null
    else this.head = this.head.next
    --this.length
    return ret
  }
  clear() {
    this.head = this.tail = null
    this.length = 0
  }
  join(s) {
    if (this.length === 0) return ''
    let p = this.head
    let ret = '' + p.data
    while ((p = p.next) !== null) ret += s + p.data
    return ret
  }
  concat(n) {
    if (this.length === 0) return Buffer.alloc(0)
    const ret = Buffer.allocUnsafe(n >>> 0)
    let p = this.head
    let i = 0
    while (p) {
      TypedArrayPrototypeSet(ret, p.data, i)
      i += p.data.length
      p = p.next
    }
    return ret
  }

  // Consumes a specified amount of bytes or characters from the buffered data.
  consume(n, hasStrings) {
    const data = this.head.data
    if (n < data.length) {
      // `slice` is the same for buffers and strings.
      const slice = data.slice(0, n)
      this.head.data = data.slice(n)
      return slice
    }
    if (n === data.length) {
      // First chunk is a perfect match.
      return this.shift()
    }
    // Result spans more than one buffer.
    return hasStrings ? this._getString(n) : this._getBuffer(n)
  }
  first() {
    return this.head.data
  }
  *[SymbolIterator]() {
    for (let p = this.head; p; p = p.next) {
      yield p.data
    }
  }

  // Consumes a specified amount of characters from the buffered data.
  _getString(n) {
    let ret = ''
    let p = this.head
    let c = 0
    do {
      const str = p.data
      if (n > str.length) {
        ret += str
        n -= str.length
      } else {
        if (n === str.length) {
          ret += str
          ++c
          if (p.next) this.head = p.next
          else this.head = this.tail = null
        } else {
          ret += StringPrototypeSlice(str, 0, n)
          this.head = p
          p.data = StringPrototypeSlice(str, n)
        }
        break
      }
      ++c
    } while ((p = p.next) !== null)
    this.length -= c
    return ret
  }

  // Consumes a specified amount of bytes from the buffered data.
  _getBuffer(n) {
    const ret = Buffer.allocUnsafe(n)
    const retLen = n
    let p = this.head
    let c = 0
    do {
      const buf = p.data
      if (n > buf.length) {
        TypedArrayPrototypeSet(ret, buf, retLen - n)
        n -= buf.length
      } else {
        if (n === buf.length) {
          TypedArrayPrototypeSet(ret, buf, retLen - n)
          ++c
          if (p.next) this.head = p.next
          else this.head = this.tail = null
        } else {
          TypedArrayPrototypeSet(ret, new Uint8Array(buf.buffer, buf.byteOffset, n), retLen - n)
          this.head = p
          p.data = buf.slice(n)
        }
        break
      }
      ++c
    } while ((p = p.next) !== null)
    this.length -= c
    return ret
  }

  // Make sure the linked list only shows the minimal necessary information.
  [Symbol.for('nodejs.util.inspect.custom')](_, options) {
    return inspect(this, {
      ...options,
      // Only inspect one level.
      depth: 0,
      // It should not recurse.
      customInspect: false
    })
  }
}


/***/ }),

/***/ 29449:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


const { pipeline } = __webpack_require__(74989)
const Duplex = __webpack_require__(66695)
const { destroyer } = __webpack_require__(35441)
const {
  isNodeStream,
  isReadable,
  isWritable,
  isWebStream,
  isTransformStream,
  isWritableStream,
  isReadableStream
} = __webpack_require__(87614)
const {
  AbortError,
  codes: { ERR_INVALID_ARG_VALUE, ERR_MISSING_ARGS }
} = __webpack_require__(91198)
const eos = __webpack_require__(86695)
module.exports = function compose(...streams) {
  if (streams.length === 0) {
    throw new ERR_MISSING_ARGS('streams')
  }
  if (streams.length === 1) {
    return Duplex.from(streams[0])
  }
  const orgStreams = [...streams]
  if (typeof streams[0] === 'function') {
    streams[0] = Duplex.from(streams[0])
  }
  if (typeof streams[streams.length - 1] === 'function') {
    const idx = streams.length - 1
    streams[idx] = Duplex.from(streams[idx])
  }
  for (let n = 0; n < streams.length; ++n) {
    if (!isNodeStream(streams[n]) && !isWebStream(streams[n])) {
      // TODO(ronag): Add checks for non streams.
      continue
    }
    if (
      n < streams.length - 1 &&
      !(isReadable(streams[n]) || isReadableStream(streams[n]) || isTransformStream(streams[n]))
    ) {
      throw new ERR_INVALID_ARG_VALUE(`streams[${n}]`, orgStreams[n], 'must be readable')
    }
    if (n > 0 && !(isWritable(streams[n]) || isWritableStream(streams[n]) || isTransformStream(streams[n]))) {
      throw new ERR_INVALID_ARG_VALUE(`streams[${n}]`, orgStreams[n], 'must be writable')
    }
  }
  let ondrain
  let onfinish
  let onreadable
  let onclose
  let d
  function onfinished(err) {
    const cb = onclose
    onclose = null
    if (cb) {
      cb(err)
    } else if (err) {
      d.destroy(err)
    } else if (!readable && !writable) {
      d.destroy()
    }
  }
  const head = streams[0]
  const tail = pipeline(streams, onfinished)
  const writable = !!(isWritable(head) || isWritableStream(head) || isTransformStream(head))
  const readable = !!(isReadable(tail) || isReadableStream(tail) || isTransformStream(tail))

  // TODO(ronag): Avoid double buffering.
  // Implement Writable/Readable/Duplex traits.
  // See, https://github.com/nodejs/node/pull/33515.
  d = new Duplex({
    // TODO (ronag): highWaterMark?
    writableObjectMode: !!(head !== null && head !== undefined && head.writableObjectMode),
    readableObjectMode: !!(tail !== null && tail !== undefined && tail.readableObjectMode),
    writable,
    readable
  })
  if (writable) {
    if (isNodeStream(head)) {
      d._write = function (chunk, encoding, callback) {
        if (head.write(chunk, encoding)) {
          callback()
        } else {
          ondrain = callback
        }
      }
      d._final = function (callback) {
        head.end()
        onfinish = callback
      }
      head.on('drain', function () {
        if (ondrain) {
          const cb = ondrain
          ondrain = null
          cb()
        }
      })
    } else if (isWebStream(head)) {
      const writable = isTransformStream(head) ? head.writable : head
      const writer = writable.getWriter()
      d._write = async function (chunk, encoding, callback) {
        try {
          await writer.ready
          writer.write(chunk).catch(() => {})
          callback()
        } catch (err) {
          callback(err)
        }
      }
      d._final = async function (callback) {
        try {
          await writer.ready
          writer.close().catch(() => {})
          onfinish = callback
        } catch (err) {
          callback(err)
        }
      }
    }
    const toRead = isTransformStream(tail) ? tail.readable : tail
    eos(toRead, () => {
      if (onfinish) {
        const cb = onfinish
        onfinish = null
        cb()
      }
    })
  }
  if (readable) {
    if (isNodeStream(tail)) {
      tail.on('readable', function () {
        if (onreadable) {
          const cb = onreadable
          onreadable = null
          cb()
        }
      })
      tail.on('end', function () {
        d.push(null)
      })
      d._read = function () {
        while (true) {
          const buf = tail.read()
          if (buf === null) {
            onreadable = d._read
            return
          }
          if (!d.push(buf)) {
            return
          }
        }
      }
    } else if (isWebStream(tail)) {
      const readable = isTransformStream(tail) ? tail.readable : tail
      const reader = readable.getReader()
      d._read = async function () {
        while (true) {
          try {
            const { value, done } = await reader.read()
            if (!d.push(value)) {
              return
            }
            if (done) {
              d.push(null)
              return
            }
          } catch {
            return
          }
        }
      }
    }
  }
  d._destroy = function (err, callback) {
    if (!err && onclose !== null) {
      err = new AbortError()
    }
    onreadable = null
    ondrain = null
    onfinish = null
    if (onclose === null) {
      callback(err)
    } else {
      onclose = callback
      if (isNodeStream(tail)) {
        destroyer(tail, err)
      }
    }
  }
  return d
}


/***/ }),

/***/ 35441:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


/* replacement start */

const process = __webpack_require__(14224)

/* replacement end */

const {
  aggregateTwoErrors,
  codes: { ERR_MULTIPLE_CALLBACK },
  AbortError
} = __webpack_require__(91198)
const { Symbol } = __webpack_require__(54136)
const { kIsDestroyed, isDestroyed, isFinished, isServerRequest } = __webpack_require__(87614)
const kDestroy = Symbol('kDestroy')
const kConstruct = Symbol('kConstruct')
function checkError(err, w, r) {
  if (err) {
    // Avoid V8 leak, https://github.com/nodejs/node/pull/34103#issuecomment-652002364
    err.stack // eslint-disable-line no-unused-expressions

    if (w && !w.errored) {
      w.errored = err
    }
    if (r && !r.errored) {
      r.errored = err
    }
  }
}

// Backwards compat. cb() is undocumented and unused in core but
// unfortunately might be used by modules.
function destroy(err, cb) {
  const r = this._readableState
  const w = this._writableState
  // With duplex streams we use the writable side for state.
  const s = w || r
  if ((w !== null && w !== undefined && w.destroyed) || (r !== null && r !== undefined && r.destroyed)) {
    if (typeof cb === 'function') {
      cb()
    }
    return this
  }

  // We set destroyed to true before firing error callbacks in order
  // to make it re-entrance safe in case destroy() is called within callbacks
  checkError(err, w, r)
  if (w) {
    w.destroyed = true
  }
  if (r) {
    r.destroyed = true
  }

  // If still constructing then defer calling _destroy.
  if (!s.constructed) {
    this.once(kDestroy, function (er) {
      _destroy(this, aggregateTwoErrors(er, err), cb)
    })
  } else {
    _destroy(this, err, cb)
  }
  return this
}
function _destroy(self, err, cb) {
  let called = false
  function onDestroy(err) {
    if (called) {
      return
    }
    called = true
    const r = self._readableState
    const w = self._writableState
    checkError(err, w, r)
    if (w) {
      w.closed = true
    }
    if (r) {
      r.closed = true
    }
    if (typeof cb === 'function') {
      cb(err)
    }
    if (err) {
      process.nextTick(emitErrorCloseNT, self, err)
    } else {
      process.nextTick(emitCloseNT, self)
    }
  }
  try {
    self._destroy(err || null, onDestroy)
  } catch (err) {
    onDestroy(err)
  }
}
function emitErrorCloseNT(self, err) {
  emitErrorNT(self, err)
  emitCloseNT(self)
}
function emitCloseNT(self) {
  const r = self._readableState
  const w = self._writableState
  if (w) {
    w.closeEmitted = true
  }
  if (r) {
    r.closeEmitted = true
  }
  if ((w !== null && w !== undefined && w.emitClose) || (r !== null && r !== undefined && r.emitClose)) {
    self.emit('close')
  }
}
function emitErrorNT(self, err) {
  const r = self._readableState
  const w = self._writableState
  if ((w !== null && w !== undefined && w.errorEmitted) || (r !== null && r !== undefined && r.errorEmitted)) {
    return
  }
  if (w) {
    w.errorEmitted = true
  }
  if (r) {
    r.errorEmitted = true
  }
  self.emit('error', err)
}
function undestroy() {
  const r = this._readableState
  const w = this._writableState
  if (r) {
    r.constructed = true
    r.closed = false
    r.closeEmitted = false
    r.destroyed = false
    r.errored = null
    r.errorEmitted = false
    r.reading = false
    r.ended = r.readable === false
    r.endEmitted = r.readable === false
  }
  if (w) {
    w.constructed = true
    w.destroyed = false
    w.closed = false
    w.closeEmitted = false
    w.errored = null
    w.errorEmitted = false
    w.finalCalled = false
    w.prefinished = false
    w.ended = w.writable === false
    w.ending = w.writable === false
    w.finished = w.writable === false
  }
}
function errorOrDestroy(stream, err, sync) {
  // We have tests that rely on errors being emitted
  // in the same tick, so changing this is semver major.
  // For now when you opt-in to autoDestroy we allow
  // the error to be emitted nextTick. In a future
  // semver major update we should change the default to this.

  const r = stream._readableState
  const w = stream._writableState
  if ((w !== null && w !== undefined && w.destroyed) || (r !== null && r !== undefined && r.destroyed)) {
    return this
  }
  if ((r !== null && r !== undefined && r.autoDestroy) || (w !== null && w !== undefined && w.autoDestroy))
    stream.destroy(err)
  else if (err) {
    // Avoid V8 leak, https://github.com/nodejs/node/pull/34103#issuecomment-652002364
    err.stack // eslint-disable-line no-unused-expressions

    if (w && !w.errored) {
      w.errored = err
    }
    if (r && !r.errored) {
      r.errored = err
    }
    if (sync) {
      process.nextTick(emitErrorNT, stream, err)
    } else {
      emitErrorNT(stream, err)
    }
  }
}
function construct(stream, cb) {
  if (typeof stream._construct !== 'function') {
    return
  }
  const r = stream._readableState
  const w = stream._writableState
  if (r) {
    r.constructed = false
  }
  if (w) {
    w.constructed = false
  }
  stream.once(kConstruct, cb)
  if (stream.listenerCount(kConstruct) > 1) {
    // Duplex
    return
  }
  process.nextTick(constructNT, stream)
}
function constructNT(stream) {
  let called = false
  function onConstruct(err) {
    if (called) {
      errorOrDestroy(stream, err !== null && err !== undefined ? err : new ERR_MULTIPLE_CALLBACK())
      return
    }
    called = true
    const r = stream._readableState
    const w = stream._writableState
    const s = w || r
    if (r) {
      r.constructed = true
    }
    if (w) {
      w.constructed = true
    }
    if (s.destroyed) {
      stream.emit(kDestroy, err)
    } else if (err) {
      errorOrDestroy(stream, err, true)
    } else {
      process.nextTick(emitConstructNT, stream)
    }
  }
  try {
    stream._construct((err) => {
      process.nextTick(onConstruct, err)
    })
  } catch (err) {
    process.nextTick(onConstruct, err)
  }
}
function emitConstructNT(stream) {
  stream.emit(kConstruct)
}
function isRequest(stream) {
  return (stream === null || stream === undefined ? undefined : stream.setHeader) && typeof stream.abort === 'function'
}
function emitCloseLegacy(stream) {
  stream.emit('close')
}
function emitErrorCloseLegacy(stream, err) {
  stream.emit('error', err)
  process.nextTick(emitCloseLegacy, stream)
}

// Normalize destroy for legacy.
function destroyer(stream, err) {
  if (!stream || isDestroyed(stream)) {
    return
  }
  if (!err && !isFinished(stream)) {
    err = new AbortError()
  }

  // TODO: Remove isRequest branches.
  if (isServerRequest(stream)) {
    stream.socket = null
    stream.destroy(err)
  } else if (isRequest(stream)) {
    stream.abort()
  } else if (isRequest(stream.req)) {
    stream.req.abort()
  } else if (typeof stream.destroy === 'function') {
    stream.destroy(err)
  } else if (typeof stream.close === 'function') {
    // TODO: Don't lose err?
    stream.close()
  } else if (err) {
    process.nextTick(emitErrorCloseLegacy, stream, err)
  } else {
    process.nextTick(emitCloseLegacy, stream)
  }
  if (!stream.destroyed) {
    stream[kIsDestroyed] = true
  }
}
module.exports = {
  construct,
  destroyer,
  destroy,
  undestroy,
  errorOrDestroy
}


/***/ }),

/***/ 66695:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// a duplex stream is just a stream that is both readable and writable.
// Since JS doesn't have multiple prototype inheritance, this class
// prototypically inherits from Readable, and then parasitically from
// Writable.



const {
  ObjectDefineProperties,
  ObjectGetOwnPropertyDescriptor,
  ObjectKeys,
  ObjectSetPrototypeOf
} = __webpack_require__(54136)
module.exports = Duplex
const Readable = __webpack_require__(51560)
const Writable = __webpack_require__(26336)
ObjectSetPrototypeOf(Duplex.prototype, Readable.prototype)
ObjectSetPrototypeOf(Duplex, Readable)
{
  const keys = ObjectKeys(Writable.prototype)
  // Allow the keys array to be GC'ed.
  for (let i = 0; i < keys.length; i++) {
    const method = keys[i]
    if (!Duplex.prototype[method]) Duplex.prototype[method] = Writable.prototype[method]
  }
}
function Duplex(options) {
  if (!(this instanceof Duplex)) return new Duplex(options)
  Readable.call(this, options)
  Writable.call(this, options)
  if (options) {
    this.allowHalfOpen = options.allowHalfOpen !== false
    if (options.readable === false) {
      this._readableState.readable = false
      this._readableState.ended = true
      this._readableState.endEmitted = true
    }
    if (options.writable === false) {
      this._writableState.writable = false
      this._writableState.ending = true
      this._writableState.ended = true
      this._writableState.finished = true
    }
  } else {
    this.allowHalfOpen = true
  }
}
ObjectDefineProperties(Duplex.prototype, {
  writable: {
    __proto__: null,
    ...ObjectGetOwnPropertyDescriptor(Writable.prototype, 'writable')
  },
  writableHighWaterMark: {
    __proto__: null,
    ...ObjectGetOwnPropertyDescriptor(Writable.prototype, 'writableHighWaterMark')
  },
  writableObjectMode: {
    __proto__: null,
    ...ObjectGetOwnPropertyDescriptor(Writable.prototype, 'writableObjectMode')
  },
  writableBuffer: {
    __proto__: null,
    ...ObjectGetOwnPropertyDescriptor(Writable.prototype, 'writableBuffer')
  },
  writableLength: {
    __proto__: null,
    ...ObjectGetOwnPropertyDescriptor(Writable.prototype, 'writableLength')
  },
  writableFinished: {
    __proto__: null,
    ...ObjectGetOwnPropertyDescriptor(Writable.prototype, 'writableFinished')
  },
  writableCorked: {
    __proto__: null,
    ...ObjectGetOwnPropertyDescriptor(Writable.prototype, 'writableCorked')
  },
  writableEnded: {
    __proto__: null,
    ...ObjectGetOwnPropertyDescriptor(Writable.prototype, 'writableEnded')
  },
  writableNeedDrain: {
    __proto__: null,
    ...ObjectGetOwnPropertyDescriptor(Writable.prototype, 'writableNeedDrain')
  },
  destroyed: {
    __proto__: null,
    get() {
      if (this._readableState === undefined || this._writableState === undefined) {
        return false
      }
      return this._readableState.destroyed && this._writableState.destroyed
    },
    set(value) {
      // Backward compatibility, the user is explicitly
      // managing destroyed.
      if (this._readableState && this._writableState) {
        this._readableState.destroyed = value
        this._writableState.destroyed = value
      }
    }
  }
})
let webStreamsAdapters

// Lazy to avoid circular references
function lazyWebStreams() {
  if (webStreamsAdapters === undefined) webStreamsAdapters = {}
  return webStreamsAdapters
}
Duplex.fromWeb = function (pair, options) {
  return lazyWebStreams().newStreamDuplexFromReadableWritablePair(pair, options)
}
Duplex.toWeb = function (duplex) {
  return lazyWebStreams().newReadableWritablePairFromDuplex(duplex)
}
let duplexify
Duplex.from = function (body) {
  if (!duplexify) {
    duplexify = __webpack_require__(50501)
  }
  return duplexify(body, 'body')
}


/***/ }),

/***/ 50501:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/* replacement start */

const process = __webpack_require__(14224)

/* replacement end */

;('use strict')
const bufferModule = __webpack_require__(55872)
const {
  isReadable,
  isWritable,
  isIterable,
  isNodeStream,
  isReadableNodeStream,
  isWritableNodeStream,
  isDuplexNodeStream,
  isReadableStream,
  isWritableStream
} = __webpack_require__(87614)
const eos = __webpack_require__(86695)
const {
  AbortError,
  codes: { ERR_INVALID_ARG_TYPE, ERR_INVALID_RETURN_VALUE }
} = __webpack_require__(91198)
const { destroyer } = __webpack_require__(35441)
const Duplex = __webpack_require__(66695)
const Readable = __webpack_require__(51560)
const Writable = __webpack_require__(26336)
const { createDeferredPromise } = __webpack_require__(89349)
const from = __webpack_require__(93870)
const Blob = globalThis.Blob || bufferModule.Blob
const isBlob =
  typeof Blob !== 'undefined'
    ? function isBlob(b) {
        return b instanceof Blob
      }
    : function isBlob(b) {
        return false
      }
const AbortController = globalThis.AbortController || (__webpack_require__(21366).AbortController)
const { FunctionPrototypeCall } = __webpack_require__(54136)

// This is needed for pre node 17.
class Duplexify extends Duplex {
  constructor(options) {
    super(options)

    // https://github.com/nodejs/node/pull/34385

    if ((options === null || options === undefined ? undefined : options.readable) === false) {
      this._readableState.readable = false
      this._readableState.ended = true
      this._readableState.endEmitted = true
    }
    if ((options === null || options === undefined ? undefined : options.writable) === false) {
      this._writableState.writable = false
      this._writableState.ending = true
      this._writableState.ended = true
      this._writableState.finished = true
    }
  }
}
module.exports = function duplexify(body, name) {
  if (isDuplexNodeStream(body)) {
    return body
  }
  if (isReadableNodeStream(body)) {
    return _duplexify({
      readable: body
    })
  }
  if (isWritableNodeStream(body)) {
    return _duplexify({
      writable: body
    })
  }
  if (isNodeStream(body)) {
    return _duplexify({
      writable: false,
      readable: false
    })
  }
  if (isReadableStream(body)) {
    return _duplexify({
      readable: Readable.fromWeb(body)
    })
  }
  if (isWritableStream(body)) {
    return _duplexify({
      writable: Writable.fromWeb(body)
    })
  }
  if (typeof body === 'function') {
    const { value, write, final, destroy } = fromAsyncGen(body)
    if (isIterable(value)) {
      return from(Duplexify, value, {
        // TODO (ronag): highWaterMark?
        objectMode: true,
        write,
        final,
        destroy
      })
    }
    const then = value === null || value === undefined ? undefined : value.then
    if (typeof then === 'function') {
      let d
      const promise = FunctionPrototypeCall(
        then,
        value,
        (val) => {
          if (val != null) {
            throw new ERR_INVALID_RETURN_VALUE('nully', 'body', val)
          }
        },
        (err) => {
          destroyer(d, err)
        }
      )
      return (d = new Duplexify({
        // TODO (ronag): highWaterMark?
        objectMode: true,
        readable: false,
        write,
        final(cb) {
          final(async () => {
            try {
              await promise
              process.nextTick(cb, null)
            } catch (err) {
              process.nextTick(cb, err)
            }
          })
        },
        destroy
      }))
    }
    throw new ERR_INVALID_RETURN_VALUE('Iterable, AsyncIterable or AsyncFunction', name, value)
  }
  if (isBlob(body)) {
    return duplexify(body.arrayBuffer())
  }
  if (isIterable(body)) {
    return from(Duplexify, body, {
      // TODO (ronag): highWaterMark?
      objectMode: true,
      writable: false
    })
  }
  if (
    isReadableStream(body === null || body === undefined ? undefined : body.readable) &&
    isWritableStream(body === null || body === undefined ? undefined : body.writable)
  ) {
    return Duplexify.fromWeb(body)
  }
  if (
    typeof (body === null || body === undefined ? undefined : body.writable) === 'object' ||
    typeof (body === null || body === undefined ? undefined : body.readable) === 'object'
  ) {
    const readable =
      body !== null && body !== undefined && body.readable
        ? isReadableNodeStream(body === null || body === undefined ? undefined : body.readable)
          ? body === null || body === undefined
            ? undefined
            : body.readable
          : duplexify(body.readable)
        : undefined
    const writable =
      body !== null && body !== undefined && body.writable
        ? isWritableNodeStream(body === null || body === undefined ? undefined : body.writable)
          ? body === null || body === undefined
            ? undefined
            : body.writable
          : duplexify(body.writable)
        : undefined
    return _duplexify({
      readable,
      writable
    })
  }
  const then = body === null || body === undefined ? undefined : body.then
  if (typeof then === 'function') {
    let d
    FunctionPrototypeCall(
      then,
      body,
      (val) => {
        if (val != null) {
          d.push(val)
        }
        d.push(null)
      },
      (err) => {
        destroyer(d, err)
      }
    )
    return (d = new Duplexify({
      objectMode: true,
      writable: false,
      read() {}
    }))
  }
  throw new ERR_INVALID_ARG_TYPE(
    name,
    [
      'Blob',
      'ReadableStream',
      'WritableStream',
      'Stream',
      'Iterable',
      'AsyncIterable',
      'Function',
      '{ readable, writable } pair',
      'Promise'
    ],
    body
  )
}
function fromAsyncGen(fn) {
  let { promise, resolve } = createDeferredPromise()
  const ac = new AbortController()
  const signal = ac.signal
  const value = fn(
    (async function* () {
      while (true) {
        const _promise = promise
        promise = null
        const { chunk, done, cb } = await _promise
        process.nextTick(cb)
        if (done) return
        if (signal.aborted)
          throw new AbortError(undefined, {
            cause: signal.reason
          })
        ;({ promise, resolve } = createDeferredPromise())
        yield chunk
      }
    })(),
    {
      signal
    }
  )
  return {
    value,
    write(chunk, encoding, cb) {
      const _resolve = resolve
      resolve = null
      _resolve({
        chunk,
        done: false,
        cb
      })
    },
    final(cb) {
      const _resolve = resolve
      resolve = null
      _resolve({
        done: true,
        cb
      })
    },
    destroy(err, cb) {
      ac.abort()
      cb(err)
    }
  }
}
function _duplexify(pair) {
  const r = pair.readable && typeof pair.readable.read !== 'function' ? Readable.wrap(pair.readable) : pair.readable
  const w = pair.writable
  let readable = !!isReadable(r)
  let writable = !!isWritable(w)
  let ondrain
  let onfinish
  let onreadable
  let onclose
  let d
  function onfinished(err) {
    const cb = onclose
    onclose = null
    if (cb) {
      cb(err)
    } else if (err) {
      d.destroy(err)
    }
  }

  // TODO(ronag): Avoid double buffering.
  // Implement Writable/Readable/Duplex traits.
  // See, https://github.com/nodejs/node/pull/33515.
  d = new Duplexify({
    // TODO (ronag): highWaterMark?
    readableObjectMode: !!(r !== null && r !== undefined && r.readableObjectMode),
    writableObjectMode: !!(w !== null && w !== undefined && w.writableObjectMode),
    readable,
    writable
  })
  if (writable) {
    eos(w, (err) => {
      writable = false
      if (err) {
        destroyer(r, err)
      }
      onfinished(err)
    })
    d._write = function (chunk, encoding, callback) {
      if (w.write(chunk, encoding)) {
        callback()
      } else {
        ondrain = callback
      }
    }
    d._final = function (callback) {
      w.end()
      onfinish = callback
    }
    w.on('drain', function () {
      if (ondrain) {
        const cb = ondrain
        ondrain = null
        cb()
      }
    })
    w.on('finish', function () {
      if (onfinish) {
        const cb = onfinish
        onfinish = null
        cb()
      }
    })
  }
  if (readable) {
    eos(r, (err) => {
      readable = false
      if (err) {
        destroyer(r, err)
      }
      onfinished(err)
    })
    r.on('readable', function () {
      if (onreadable) {
        const cb = onreadable
        onreadable = null
        cb()
      }
    })
    r.on('end', function () {
      d.push(null)
    })
    d._read = function () {
      while (true) {
        const buf = r.read()
        if (buf === null) {
          onreadable = d._read
          return
        }
        if (!d.push(buf)) {
          return
        }
      }
    }
  }
  d._destroy = function (err, callback) {
    if (!err && onclose !== null) {
      err = new AbortError()
    }
    onreadable = null
    ondrain = null
    onfinish = null
    if (onclose === null) {
      callback(err)
    } else {
      onclose = callback
      destroyer(w, err)
      destroyer(r, err)
    }
  }
  return d
}


/***/ }),

/***/ 86695:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/* replacement start */

const process = __webpack_require__(14224)

/* replacement end */
// Ported from https://github.com/mafintosh/end-of-stream with
// permission from the author, Mathias Buus (@mafintosh).

;('use strict')
const { AbortError, codes } = __webpack_require__(91198)
const { ERR_INVALID_ARG_TYPE, ERR_STREAM_PREMATURE_CLOSE } = codes
const { kEmptyObject, once } = __webpack_require__(89349)
const { validateAbortSignal, validateFunction, validateObject, validateBoolean } = __webpack_require__(1712)
const { Promise, PromisePrototypeThen, SymbolDispose } = __webpack_require__(54136)
const {
  isClosed,
  isReadable,
  isReadableNodeStream,
  isReadableStream,
  isReadableFinished,
  isReadableErrored,
  isWritable,
  isWritableNodeStream,
  isWritableStream,
  isWritableFinished,
  isWritableErrored,
  isNodeStream,
  willEmitClose: _willEmitClose,
  kIsClosedPromise
} = __webpack_require__(87614)
let addAbortListener
function isRequest(stream) {
  return stream.setHeader && typeof stream.abort === 'function'
}
const nop = () => {}
function eos(stream, options, callback) {
  var _options$readable, _options$writable
  if (arguments.length === 2) {
    callback = options
    options = kEmptyObject
  } else if (options == null) {
    options = kEmptyObject
  } else {
    validateObject(options, 'options')
  }
  validateFunction(callback, 'callback')
  validateAbortSignal(options.signal, 'options.signal')
  callback = once(callback)
  if (isReadableStream(stream) || isWritableStream(stream)) {
    return eosWeb(stream, options, callback)
  }
  if (!isNodeStream(stream)) {
    throw new ERR_INVALID_ARG_TYPE('stream', ['ReadableStream', 'WritableStream', 'Stream'], stream)
  }
  const readable =
    (_options$readable = options.readable) !== null && _options$readable !== undefined
      ? _options$readable
      : isReadableNodeStream(stream)
  const writable =
    (_options$writable = options.writable) !== null && _options$writable !== undefined
      ? _options$writable
      : isWritableNodeStream(stream)
  const wState = stream._writableState
  const rState = stream._readableState
  const onlegacyfinish = () => {
    if (!stream.writable) {
      onfinish()
    }
  }

  // TODO (ronag): Improve soft detection to include core modules and
  // common ecosystem modules that do properly emit 'close' but fail
  // this generic check.
  let willEmitClose =
    _willEmitClose(stream) && isReadableNodeStream(stream) === readable && isWritableNodeStream(stream) === writable
  let writableFinished = isWritableFinished(stream, false)
  const onfinish = () => {
    writableFinished = true
    // Stream should not be destroyed here. If it is that
    // means that user space is doing something differently and
    // we cannot trust willEmitClose.
    if (stream.destroyed) {
      willEmitClose = false
    }
    if (willEmitClose && (!stream.readable || readable)) {
      return
    }
    if (!readable || readableFinished) {
      callback.call(stream)
    }
  }
  let readableFinished = isReadableFinished(stream, false)
  const onend = () => {
    readableFinished = true
    // Stream should not be destroyed here. If it is that
    // means that user space is doing something differently and
    // we cannot trust willEmitClose.
    if (stream.destroyed) {
      willEmitClose = false
    }
    if (willEmitClose && (!stream.writable || writable)) {
      return
    }
    if (!writable || writableFinished) {
      callback.call(stream)
    }
  }
  const onerror = (err) => {
    callback.call(stream, err)
  }
  let closed = isClosed(stream)
  const onclose = () => {
    closed = true
    const errored = isWritableErrored(stream) || isReadableErrored(stream)
    if (errored && typeof errored !== 'boolean') {
      return callback.call(stream, errored)
    }
    if (readable && !readableFinished && isReadableNodeStream(stream, true)) {
      if (!isReadableFinished(stream, false)) return callback.call(stream, new ERR_STREAM_PREMATURE_CLOSE())
    }
    if (writable && !writableFinished) {
      if (!isWritableFinished(stream, false)) return callback.call(stream, new ERR_STREAM_PREMATURE_CLOSE())
    }
    callback.call(stream)
  }
  const onclosed = () => {
    closed = true
    const errored = isWritableErrored(stream) || isReadableErrored(stream)
    if (errored && typeof errored !== 'boolean') {
      return callback.call(stream, errored)
    }
    callback.call(stream)
  }
  const onrequest = () => {
    stream.req.on('finish', onfinish)
  }
  if (isRequest(stream)) {
    stream.on('complete', onfinish)
    if (!willEmitClose) {
      stream.on('abort', onclose)
    }
    if (stream.req) {
      onrequest()
    } else {
      stream.on('request', onrequest)
    }
  } else if (writable && !wState) {
    // legacy streams
    stream.on('end', onlegacyfinish)
    stream.on('close', onlegacyfinish)
  }

  // Not all streams will emit 'close' after 'aborted'.
  if (!willEmitClose && typeof stream.aborted === 'boolean') {
    stream.on('aborted', onclose)
  }
  stream.on('end', onend)
  stream.on('finish', onfinish)
  if (options.error !== false) {
    stream.on('error', onerror)
  }
  stream.on('close', onclose)
  if (closed) {
    process.nextTick(onclose)
  } else if (
    (wState !== null && wState !== undefined && wState.errorEmitted) ||
    (rState !== null && rState !== undefined && rState.errorEmitted)
  ) {
    if (!willEmitClose) {
      process.nextTick(onclosed)
    }
  } else if (
    !readable &&
    (!willEmitClose || isReadable(stream)) &&
    (writableFinished || isWritable(stream) === false)
  ) {
    process.nextTick(onclosed)
  } else if (
    !writable &&
    (!willEmitClose || isWritable(stream)) &&
    (readableFinished || isReadable(stream) === false)
  ) {
    process.nextTick(onclosed)
  } else if (rState && stream.req && stream.aborted) {
    process.nextTick(onclosed)
  }
  const cleanup = () => {
    callback = nop
    stream.removeListener('aborted', onclose)
    stream.removeListener('complete', onfinish)
    stream.removeListener('abort', onclose)
    stream.removeListener('request', onrequest)
    if (stream.req) stream.req.removeListener('finish', onfinish)
    stream.removeListener('end', onlegacyfinish)
    stream.removeListener('close', onlegacyfinish)
    stream.removeListener('finish', onfinish)
    stream.removeListener('end', onend)
    stream.removeListener('error', onerror)
    stream.removeListener('close', onclose)
  }
  if (options.signal && !closed) {
    const abort = () => {
      // Keep it because cleanup removes it.
      const endCallback = callback
      cleanup()
      endCallback.call(
        stream,
        new AbortError(undefined, {
          cause: options.signal.reason
        })
      )
    }
    if (options.signal.aborted) {
      process.nextTick(abort)
    } else {
      addAbortListener = addAbortListener || (__webpack_require__(89349).addAbortListener)
      const disposable = addAbortListener(options.signal, abort)
      const originalCallback = callback
      callback = once((...args) => {
        disposable[SymbolDispose]()
        originalCallback.apply(stream, args)
      })
    }
  }
  return cleanup
}
function eosWeb(stream, options, callback) {
  let isAborted = false
  let abort = nop
  if (options.signal) {
    abort = () => {
      isAborted = true
      callback.call(
        stream,
        new AbortError(undefined, {
          cause: options.signal.reason
        })
      )
    }
    if (options.signal.aborted) {
      process.nextTick(abort)
    } else {
      addAbortListener = addAbortListener || (__webpack_require__(89349).addAbortListener)
      const disposable = addAbortListener(options.signal, abort)
      const originalCallback = callback
      callback = once((...args) => {
        disposable[SymbolDispose]()
        originalCallback.apply(stream, args)
      })
    }
  }
  const resolverFn = (...args) => {
    if (!isAborted) {
      process.nextTick(() => callback.apply(stream, args))
    }
  }
  PromisePrototypeThen(stream[kIsClosedPromise].promise, resolverFn, resolverFn)
  return nop
}
function finished(stream, opts) {
  var _opts
  let autoCleanup = false
  if (opts === null) {
    opts = kEmptyObject
  }
  if ((_opts = opts) !== null && _opts !== undefined && _opts.cleanup) {
    validateBoolean(opts.cleanup, 'cleanup')
    autoCleanup = opts.cleanup
  }
  return new Promise((resolve, reject) => {
    const cleanup = eos(stream, opts, (err) => {
      if (autoCleanup) {
        cleanup()
      }
      if (err) {
        reject(err)
      } else {
        resolve()
      }
    })
  })
}
module.exports = eos
module.exports.finished = finished


/***/ }),

/***/ 93870:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


/* replacement start */

const process = __webpack_require__(14224)

/* replacement end */

const { PromisePrototypeThen, SymbolAsyncIterator, SymbolIterator } = __webpack_require__(54136)
const { Buffer } = __webpack_require__(55872)
const { ERR_INVALID_ARG_TYPE, ERR_STREAM_NULL_VALUES } = (__webpack_require__(91198).codes)
function from(Readable, iterable, opts) {
  let iterator
  if (typeof iterable === 'string' || iterable instanceof Buffer) {
    return new Readable({
      objectMode: true,
      ...opts,
      read() {
        this.push(iterable)
        this.push(null)
      }
    })
  }
  let isAsync
  if (iterable && iterable[SymbolAsyncIterator]) {
    isAsync = true
    iterator = iterable[SymbolAsyncIterator]()
  } else if (iterable && iterable[SymbolIterator]) {
    isAsync = false
    iterator = iterable[SymbolIterator]()
  } else {
    throw new ERR_INVALID_ARG_TYPE('iterable', ['Iterable'], iterable)
  }
  const readable = new Readable({
    objectMode: true,
    highWaterMark: 1,
    // TODO(ronag): What options should be allowed?
    ...opts
  })

  // Flag to protect against _read
  // being called before last iteration completion.
  let reading = false
  readable._read = function () {
    if (!reading) {
      reading = true
      next()
    }
  }
  readable._destroy = function (error, cb) {
    PromisePrototypeThen(
      close(error),
      () => process.nextTick(cb, error),
      // nextTick is here in case cb throws
      (e) => process.nextTick(cb, e || error)
    )
  }
  async function close(error) {
    const hadError = error !== undefined && error !== null
    const hasThrow = typeof iterator.throw === 'function'
    if (hadError && hasThrow) {
      const { value, done } = await iterator.throw(error)
      await value
      if (done) {
        return
      }
    }
    if (typeof iterator.return === 'function') {
      const { value } = await iterator.return()
      await value
    }
  }
  async function next() {
    for (;;) {
      try {
        const { value, done } = isAsync ? await iterator.next() : iterator.next()
        if (done) {
          readable.push(null)
        } else {
          const res = value && typeof value.then === 'function' ? await value : value
          if (res === null) {
            reading = false
            throw new ERR_STREAM_NULL_VALUES()
          } else if (readable.push(res)) {
            continue
          } else {
            reading = false
          }
        }
      } catch (err) {
        readable.destroy(err)
      }
      break
    }
  }
  return readable
}
module.exports = from


/***/ }),

/***/ 23472:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


const { ArrayIsArray, ObjectSetPrototypeOf } = __webpack_require__(54136)
const { EventEmitter: EE } = __webpack_require__(72100)
function Stream(opts) {
  EE.call(this, opts)
}
ObjectSetPrototypeOf(Stream.prototype, EE.prototype)
ObjectSetPrototypeOf(Stream, EE)
Stream.prototype.pipe = function (dest, options) {
  const source = this
  function ondata(chunk) {
    if (dest.writable && dest.write(chunk) === false && source.pause) {
      source.pause()
    }
  }
  source.on('data', ondata)
  function ondrain() {
    if (source.readable && source.resume) {
      source.resume()
    }
  }
  dest.on('drain', ondrain)

  // If the 'end' option is not supplied, dest.end() will be called when
  // source gets the 'end' or 'close' events.  Only dest.end() once.
  if (!dest._isStdio && (!options || options.end !== false)) {
    source.on('end', onend)
    source.on('close', onclose)
  }
  let didOnEnd = false
  function onend() {
    if (didOnEnd) return
    didOnEnd = true
    dest.end()
  }
  function onclose() {
    if (didOnEnd) return
    didOnEnd = true
    if (typeof dest.destroy === 'function') dest.destroy()
  }

  // Don't leave dangling pipes when there are errors.
  function onerror(er) {
    cleanup()
    if (EE.listenerCount(this, 'error') === 0) {
      this.emit('error', er)
    }
  }
  prependListener(source, 'error', onerror)
  prependListener(dest, 'error', onerror)

  // Remove all the event listeners that were added.
  function cleanup() {
    source.removeListener('data', ondata)
    dest.removeListener('drain', ondrain)
    source.removeListener('end', onend)
    source.removeListener('close', onclose)
    source.removeListener('error', onerror)
    dest.removeListener('error', onerror)
    source.removeListener('end', cleanup)
    source.removeListener('close', cleanup)
    dest.removeListener('close', cleanup)
  }
  source.on('end', cleanup)
  source.on('close', cleanup)
  dest.on('close', cleanup)
  dest.emit('pipe', source)

  // Allow for unix-like usage: A.pipe(B).pipe(C)
  return dest
}
function prependListener(emitter, event, fn) {
  // Sadly this is not cacheable as some libraries bundle their own
  // event emitter implementation with them.
  if (typeof emitter.prependListener === 'function') return emitter.prependListener(event, fn)

  // This is a hack to make sure that our error handler is attached before any
  // userland ones.  NEVER DO THIS. This is here only because this code needs
  // to continue to work with older versions of Node.js that do not include
  // the prependListener() method. The goal is to eventually remove this hack.
  if (!emitter._events || !emitter._events[event]) emitter.on(event, fn)
  else if (ArrayIsArray(emitter._events[event])) emitter._events[event].unshift(fn)
  else emitter._events[event] = [fn, emitter._events[event]]
}
module.exports = {
  Stream,
  prependListener
}


/***/ }),

/***/ 28120:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


const AbortController = globalThis.AbortController || (__webpack_require__(21366).AbortController)
const {
  codes: { ERR_INVALID_ARG_VALUE, ERR_INVALID_ARG_TYPE, ERR_MISSING_ARGS, ERR_OUT_OF_RANGE },
  AbortError
} = __webpack_require__(91198)
const { validateAbortSignal, validateInteger, validateObject } = __webpack_require__(1712)
const kWeakHandler = (__webpack_require__(54136).Symbol)('kWeak')
const kResistStopPropagation = (__webpack_require__(54136).Symbol)('kResistStopPropagation')
const { finished } = __webpack_require__(86695)
const staticCompose = __webpack_require__(29449)
const { addAbortSignalNoValidate } = __webpack_require__(47287)
const { isWritable, isNodeStream } = __webpack_require__(87614)
const { deprecate } = __webpack_require__(89349)
const {
  ArrayPrototypePush,
  Boolean,
  MathFloor,
  Number,
  NumberIsNaN,
  Promise,
  PromiseReject,
  PromiseResolve,
  PromisePrototypeThen,
  Symbol
} = __webpack_require__(54136)
const kEmpty = Symbol('kEmpty')
const kEof = Symbol('kEof')
function compose(stream, options) {
  if (options != null) {
    validateObject(options, 'options')
  }
  if ((options === null || options === undefined ? undefined : options.signal) != null) {
    validateAbortSignal(options.signal, 'options.signal')
  }
  if (isNodeStream(stream) && !isWritable(stream)) {
    throw new ERR_INVALID_ARG_VALUE('stream', stream, 'must be writable')
  }
  const composedStream = staticCompose(this, stream)
  if (options !== null && options !== undefined && options.signal) {
    // Not validating as we already validated before
    addAbortSignalNoValidate(options.signal, composedStream)
  }
  return composedStream
}
function map(fn, options) {
  if (typeof fn !== 'function') {
    throw new ERR_INVALID_ARG_TYPE('fn', ['Function', 'AsyncFunction'], fn)
  }
  if (options != null) {
    validateObject(options, 'options')
  }
  if ((options === null || options === undefined ? undefined : options.signal) != null) {
    validateAbortSignal(options.signal, 'options.signal')
  }
  let concurrency = 1
  if ((options === null || options === undefined ? undefined : options.concurrency) != null) {
    concurrency = MathFloor(options.concurrency)
  }
  let highWaterMark = concurrency - 1
  if ((options === null || options === undefined ? undefined : options.highWaterMark) != null) {
    highWaterMark = MathFloor(options.highWaterMark)
  }
  validateInteger(concurrency, 'options.concurrency', 1)
  validateInteger(highWaterMark, 'options.highWaterMark', 0)
  highWaterMark += concurrency
  return async function* map() {
    const signal = (__webpack_require__(89349).AbortSignalAny)(
      [options === null || options === undefined ? undefined : options.signal].filter(Boolean)
    )
    const stream = this
    const queue = []
    const signalOpt = {
      signal
    }
    let next
    let resume
    let done = false
    let cnt = 0
    function onCatch() {
      done = true
      afterItemProcessed()
    }
    function afterItemProcessed() {
      cnt -= 1
      maybeResume()
    }
    function maybeResume() {
      if (resume && !done && cnt < concurrency && queue.length < highWaterMark) {
        resume()
        resume = null
      }
    }
    async function pump() {
      try {
        for await (let val of stream) {
          if (done) {
            return
          }
          if (signal.aborted) {
            throw new AbortError()
          }
          try {
            val = fn(val, signalOpt)
            if (val === kEmpty) {
              continue
            }
            val = PromiseResolve(val)
          } catch (err) {
            val = PromiseReject(err)
          }
          cnt += 1
          PromisePrototypeThen(val, afterItemProcessed, onCatch)
          queue.push(val)
          if (next) {
            next()
            next = null
          }
          if (!done && (queue.length >= highWaterMark || cnt >= concurrency)) {
            await new Promise((resolve) => {
              resume = resolve
            })
          }
        }
        queue.push(kEof)
      } catch (err) {
        const val = PromiseReject(err)
        PromisePrototypeThen(val, afterItemProcessed, onCatch)
        queue.push(val)
      } finally {
        done = true
        if (next) {
          next()
          next = null
        }
      }
    }
    pump()
    try {
      while (true) {
        while (queue.length > 0) {
          const val = await queue[0]
          if (val === kEof) {
            return
          }
          if (signal.aborted) {
            throw new AbortError()
          }
          if (val !== kEmpty) {
            yield val
          }
          queue.shift()
          maybeResume()
        }
        await new Promise((resolve) => {
          next = resolve
        })
      }
    } finally {
      done = true
      if (resume) {
        resume()
        resume = null
      }
    }
  }.call(this)
}
function asIndexedPairs(options = undefined) {
  if (options != null) {
    validateObject(options, 'options')
  }
  if ((options === null || options === undefined ? undefined : options.signal) != null) {
    validateAbortSignal(options.signal, 'options.signal')
  }
  return async function* asIndexedPairs() {
    let index = 0
    for await (const val of this) {
      var _options$signal
      if (
        options !== null &&
        options !== undefined &&
        (_options$signal = options.signal) !== null &&
        _options$signal !== undefined &&
        _options$signal.aborted
      ) {
        throw new AbortError({
          cause: options.signal.reason
        })
      }
      yield [index++, val]
    }
  }.call(this)
}
async function some(fn, options = undefined) {
  for await (const unused of filter.call(this, fn, options)) {
    return true
  }
  return false
}
async function every(fn, options = undefined) {
  if (typeof fn !== 'function') {
    throw new ERR_INVALID_ARG_TYPE('fn', ['Function', 'AsyncFunction'], fn)
  }
  // https://en.wikipedia.org/wiki/De_Morgan%27s_laws
  return !(await some.call(
    this,
    async (...args) => {
      return !(await fn(...args))
    },
    options
  ))
}
async function find(fn, options) {
  for await (const result of filter.call(this, fn, options)) {
    return result
  }
  return undefined
}
async function forEach(fn, options) {
  if (typeof fn !== 'function') {
    throw new ERR_INVALID_ARG_TYPE('fn', ['Function', 'AsyncFunction'], fn)
  }
  async function forEachFn(value, options) {
    await fn(value, options)
    return kEmpty
  }
  // eslint-disable-next-line no-unused-vars
  for await (const unused of map.call(this, forEachFn, options));
}
function filter(fn, options) {
  if (typeof fn !== 'function') {
    throw new ERR_INVALID_ARG_TYPE('fn', ['Function', 'AsyncFunction'], fn)
  }
  async function filterFn(value, options) {
    if (await fn(value, options)) {
      return value
    }
    return kEmpty
  }
  return map.call(this, filterFn, options)
}

// Specific to provide better error to reduce since the argument is only
// missing if the stream has no items in it - but the code is still appropriate
class ReduceAwareErrMissingArgs extends ERR_MISSING_ARGS {
  constructor() {
    super('reduce')
    this.message = 'Reduce of an empty stream requires an initial value'
  }
}
async function reduce(reducer, initialValue, options) {
  var _options$signal2
  if (typeof reducer !== 'function') {
    throw new ERR_INVALID_ARG_TYPE('reducer', ['Function', 'AsyncFunction'], reducer)
  }
  if (options != null) {
    validateObject(options, 'options')
  }
  if ((options === null || options === undefined ? undefined : options.signal) != null) {
    validateAbortSignal(options.signal, 'options.signal')
  }
  let hasInitialValue = arguments.length > 1
  if (
    options !== null &&
    options !== undefined &&
    (_options$signal2 = options.signal) !== null &&
    _options$signal2 !== undefined &&
    _options$signal2.aborted
  ) {
    const err = new AbortError(undefined, {
      cause: options.signal.reason
    })
    this.once('error', () => {}) // The error is already propagated
    await finished(this.destroy(err))
    throw err
  }
  const ac = new AbortController()
  const signal = ac.signal
  if (options !== null && options !== undefined && options.signal) {
    const opts = {
      once: true,
      [kWeakHandler]: this,
      [kResistStopPropagation]: true
    }
    options.signal.addEventListener('abort', () => ac.abort(), opts)
  }
  let gotAnyItemFromStream = false
  try {
    for await (const value of this) {
      var _options$signal3
      gotAnyItemFromStream = true
      if (
        options !== null &&
        options !== undefined &&
        (_options$signal3 = options.signal) !== null &&
        _options$signal3 !== undefined &&
        _options$signal3.aborted
      ) {
        throw new AbortError()
      }
      if (!hasInitialValue) {
        initialValue = value
        hasInitialValue = true
      } else {
        initialValue = await reducer(initialValue, value, {
          signal
        })
      }
    }
    if (!gotAnyItemFromStream && !hasInitialValue) {
      throw new ReduceAwareErrMissingArgs()
    }
  } finally {
    ac.abort()
  }
  return initialValue
}
async function toArray(options) {
  if (options != null) {
    validateObject(options, 'options')
  }
  if ((options === null || options === undefined ? undefined : options.signal) != null) {
    validateAbortSignal(options.signal, 'options.signal')
  }
  const result = []
  for await (const val of this) {
    var _options$signal4
    if (
      options !== null &&
      options !== undefined &&
      (_options$signal4 = options.signal) !== null &&
      _options$signal4 !== undefined &&
      _options$signal4.aborted
    ) {
      throw new AbortError(undefined, {
        cause: options.signal.reason
      })
    }
    ArrayPrototypePush(result, val)
  }
  return result
}
function flatMap(fn, options) {
  const values = map.call(this, fn, options)
  return async function* flatMap() {
    for await (const val of values) {
      yield* val
    }
  }.call(this)
}
function toIntegerOrInfinity(number) {
  // We coerce here to align with the spec
  // https://github.com/tc39/proposal-iterator-helpers/issues/169
  number = Number(number)
  if (NumberIsNaN(number)) {
    return 0
  }
  if (number < 0) {
    throw new ERR_OUT_OF_RANGE('number', '>= 0', number)
  }
  return number
}
function drop(number, options = undefined) {
  if (options != null) {
    validateObject(options, 'options')
  }
  if ((options === null || options === undefined ? undefined : options.signal) != null) {
    validateAbortSignal(options.signal, 'options.signal')
  }
  number = toIntegerOrInfinity(number)
  return async function* drop() {
    var _options$signal5
    if (
      options !== null &&
      options !== undefined &&
      (_options$signal5 = options.signal) !== null &&
      _options$signal5 !== undefined &&
      _options$signal5.aborted
    ) {
      throw new AbortError()
    }
    for await (const val of this) {
      var _options$signal6
      if (
        options !== null &&
        options !== undefined &&
        (_options$signal6 = options.signal) !== null &&
        _options$signal6 !== undefined &&
        _options$signal6.aborted
      ) {
        throw new AbortError()
      }
      if (number-- <= 0) {
        yield val
      }
    }
  }.call(this)
}
function take(number, options = undefined) {
  if (options != null) {
    validateObject(options, 'options')
  }
  if ((options === null || options === undefined ? undefined : options.signal) != null) {
    validateAbortSignal(options.signal, 'options.signal')
  }
  number = toIntegerOrInfinity(number)
  return async function* take() {
    var _options$signal7
    if (
      options !== null &&
      options !== undefined &&
      (_options$signal7 = options.signal) !== null &&
      _options$signal7 !== undefined &&
      _options$signal7.aborted
    ) {
      throw new AbortError()
    }
    for await (const val of this) {
      var _options$signal8
      if (
        options !== null &&
        options !== undefined &&
        (_options$signal8 = options.signal) !== null &&
        _options$signal8 !== undefined &&
        _options$signal8.aborted
      ) {
        throw new AbortError()
      }
      if (number-- > 0) {
        yield val
      }

      // Don't get another item from iterator in case we reached the end
      if (number <= 0) {
        return
      }
    }
  }.call(this)
}
module.exports.streamReturningOperators = {
  asIndexedPairs: deprecate(asIndexedPairs, 'readable.asIndexedPairs will be removed in a future version.'),
  drop,
  filter,
  flatMap,
  map,
  take,
  compose
}
module.exports.promiseReturningOperators = {
  every,
  forEach,
  reduce,
  toArray,
  some,
  find
}


/***/ }),

/***/ 29752:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// a passthrough stream.
// basically just the most minimal sort of Transform stream.
// Every written chunk gets output as-is.



const { ObjectSetPrototypeOf } = __webpack_require__(54136)
module.exports = PassThrough
const Transform = __webpack_require__(45033)
ObjectSetPrototypeOf(PassThrough.prototype, Transform.prototype)
ObjectSetPrototypeOf(PassThrough, Transform)
function PassThrough(options) {
  if (!(this instanceof PassThrough)) return new PassThrough(options)
  Transform.call(this, options)
}
PassThrough.prototype._transform = function (chunk, encoding, cb) {
  cb(null, chunk)
}


/***/ }),

/***/ 74989:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/* replacement start */

const process = __webpack_require__(14224)

/* replacement end */
// Ported from https://github.com/mafintosh/pump with
// permission from the author, Mathias Buus (@mafintosh).

;('use strict')
const { ArrayIsArray, Promise, SymbolAsyncIterator, SymbolDispose } = __webpack_require__(54136)
const eos = __webpack_require__(86695)
const { once } = __webpack_require__(89349)
const destroyImpl = __webpack_require__(35441)
const Duplex = __webpack_require__(66695)
const {
  aggregateTwoErrors,
  codes: {
    ERR_INVALID_ARG_TYPE,
    ERR_INVALID_RETURN_VALUE,
    ERR_MISSING_ARGS,
    ERR_STREAM_DESTROYED,
    ERR_STREAM_PREMATURE_CLOSE
  },
  AbortError
} = __webpack_require__(91198)
const { validateFunction, validateAbortSignal } = __webpack_require__(1712)
const {
  isIterable,
  isReadable,
  isReadableNodeStream,
  isNodeStream,
  isTransformStream,
  isWebStream,
  isReadableStream,
  isReadableFinished
} = __webpack_require__(87614)
const AbortController = globalThis.AbortController || (__webpack_require__(21366).AbortController)
let PassThrough
let Readable
let addAbortListener
function destroyer(stream, reading, writing) {
  let finished = false
  stream.on('close', () => {
    finished = true
  })
  const cleanup = eos(
    stream,
    {
      readable: reading,
      writable: writing
    },
    (err) => {
      finished = !err
    }
  )
  return {
    destroy: (err) => {
      if (finished) return
      finished = true
      destroyImpl.destroyer(stream, err || new ERR_STREAM_DESTROYED('pipe'))
    },
    cleanup
  }
}
function popCallback(streams) {
  // Streams should never be an empty array. It should always contain at least
  // a single stream. Therefore optimize for the average case instead of
  // checking for length === 0 as well.
  validateFunction(streams[streams.length - 1], 'streams[stream.length - 1]')
  return streams.pop()
}
function makeAsyncIterable(val) {
  if (isIterable(val)) {
    return val
  } else if (isReadableNodeStream(val)) {
    // Legacy streams are not Iterable.
    return fromReadable(val)
  }
  throw new ERR_INVALID_ARG_TYPE('val', ['Readable', 'Iterable', 'AsyncIterable'], val)
}
async function* fromReadable(val) {
  if (!Readable) {
    Readable = __webpack_require__(51560)
  }
  yield* Readable.prototype[SymbolAsyncIterator].call(val)
}
async function pumpToNode(iterable, writable, finish, { end }) {
  let error
  let onresolve = null
  const resume = (err) => {
    if (err) {
      error = err
    }
    if (onresolve) {
      const callback = onresolve
      onresolve = null
      callback()
    }
  }
  const wait = () =>
    new Promise((resolve, reject) => {
      if (error) {
        reject(error)
      } else {
        onresolve = () => {
          if (error) {
            reject(error)
          } else {
            resolve()
          }
        }
      }
    })
  writable.on('drain', resume)
  const cleanup = eos(
    writable,
    {
      readable: false
    },
    resume
  )
  try {
    if (writable.writableNeedDrain) {
      await wait()
    }
    for await (const chunk of iterable) {
      if (!writable.write(chunk)) {
        await wait()
      }
    }
    if (end) {
      writable.end()
      await wait()
    }
    finish()
  } catch (err) {
    finish(error !== err ? aggregateTwoErrors(error, err) : err)
  } finally {
    cleanup()
    writable.off('drain', resume)
  }
}
async function pumpToWeb(readable, writable, finish, { end }) {
  if (isTransformStream(writable)) {
    writable = writable.writable
  }
  // https://streams.spec.whatwg.org/#example-manual-write-with-backpressure
  const writer = writable.getWriter()
  try {
    for await (const chunk of readable) {
      await writer.ready
      writer.write(chunk).catch(() => {})
    }
    await writer.ready
    if (end) {
      await writer.close()
    }
    finish()
  } catch (err) {
    try {
      await writer.abort(err)
      finish(err)
    } catch (err) {
      finish(err)
    }
  }
}
function pipeline(...streams) {
  return pipelineImpl(streams, once(popCallback(streams)))
}
function pipelineImpl(streams, callback, opts) {
  if (streams.length === 1 && ArrayIsArray(streams[0])) {
    streams = streams[0]
  }
  if (streams.length < 2) {
    throw new ERR_MISSING_ARGS('streams')
  }
  const ac = new AbortController()
  const signal = ac.signal
  const outerSignal = opts === null || opts === undefined ? undefined : opts.signal

  // Need to cleanup event listeners if last stream is readable
  // https://github.com/nodejs/node/issues/35452
  const lastStreamCleanup = []
  validateAbortSignal(outerSignal, 'options.signal')
  function abort() {
    finishImpl(new AbortError())
  }
  addAbortListener = addAbortListener || (__webpack_require__(89349).addAbortListener)
  let disposable
  if (outerSignal) {
    disposable = addAbortListener(outerSignal, abort)
  }
  let error
  let value
  const destroys = []
  let finishCount = 0
  function finish(err) {
    finishImpl(err, --finishCount === 0)
  }
  function finishImpl(err, final) {
    var _disposable
    if (err && (!error || error.code === 'ERR_STREAM_PREMATURE_CLOSE')) {
      error = err
    }
    if (!error && !final) {
      return
    }
    while (destroys.length) {
      destroys.shift()(error)
    }
    ;(_disposable = disposable) === null || _disposable === undefined ? undefined : _disposable[SymbolDispose]()
    ac.abort()
    if (final) {
      if (!error) {
        lastStreamCleanup.forEach((fn) => fn())
      }
      process.nextTick(callback, error, value)
    }
  }
  let ret
  for (let i = 0; i < streams.length; i++) {
    const stream = streams[i]
    const reading = i < streams.length - 1
    const writing = i > 0
    const end = reading || (opts === null || opts === undefined ? undefined : opts.end) !== false
    const isLastStream = i === streams.length - 1
    if (isNodeStream(stream)) {
      if (end) {
        const { destroy, cleanup } = destroyer(stream, reading, writing)
        destroys.push(destroy)
        if (isReadable(stream) && isLastStream) {
          lastStreamCleanup.push(cleanup)
        }
      }

      // Catch stream errors that occur after pipe/pump has completed.
      function onError(err) {
        if (err && err.name !== 'AbortError' && err.code !== 'ERR_STREAM_PREMATURE_CLOSE') {
          finish(err)
        }
      }
      stream.on('error', onError)
      if (isReadable(stream) && isLastStream) {
        lastStreamCleanup.push(() => {
          stream.removeListener('error', onError)
        })
      }
    }
    if (i === 0) {
      if (typeof stream === 'function') {
        ret = stream({
          signal
        })
        if (!isIterable(ret)) {
          throw new ERR_INVALID_RETURN_VALUE('Iterable, AsyncIterable or Stream', 'source', ret)
        }
      } else if (isIterable(stream) || isReadableNodeStream(stream) || isTransformStream(stream)) {
        ret = stream
      } else {
        ret = Duplex.from(stream)
      }
    } else if (typeof stream === 'function') {
      if (isTransformStream(ret)) {
        var _ret
        ret = makeAsyncIterable((_ret = ret) === null || _ret === undefined ? undefined : _ret.readable)
      } else {
        ret = makeAsyncIterable(ret)
      }
      ret = stream(ret, {
        signal
      })
      if (reading) {
        if (!isIterable(ret, true)) {
          throw new ERR_INVALID_RETURN_VALUE('AsyncIterable', `transform[${i - 1}]`, ret)
        }
      } else {
        var _ret2
        if (!PassThrough) {
          PassThrough = __webpack_require__(29752)
        }

        // If the last argument to pipeline is not a stream
        // we must create a proxy stream so that pipeline(...)
        // always returns a stream which can be further
        // composed through `.pipe(stream)`.

        const pt = new PassThrough({
          objectMode: true
        })

        // Handle Promises/A+ spec, `then` could be a getter that throws on
        // second use.
        const then = (_ret2 = ret) === null || _ret2 === undefined ? undefined : _ret2.then
        if (typeof then === 'function') {
          finishCount++
          then.call(
            ret,
            (val) => {
              value = val
              if (val != null) {
                pt.write(val)
              }
              if (end) {
                pt.end()
              }
              process.nextTick(finish)
            },
            (err) => {
              pt.destroy(err)
              process.nextTick(finish, err)
            }
          )
        } else if (isIterable(ret, true)) {
          finishCount++
          pumpToNode(ret, pt, finish, {
            end
          })
        } else if (isReadableStream(ret) || isTransformStream(ret)) {
          const toRead = ret.readable || ret
          finishCount++
          pumpToNode(toRead, pt, finish, {
            end
          })
        } else {
          throw new ERR_INVALID_RETURN_VALUE('AsyncIterable or Promise', 'destination', ret)
        }
        ret = pt
        const { destroy, cleanup } = destroyer(ret, false, true)
        destroys.push(destroy)
        if (isLastStream) {
          lastStreamCleanup.push(cleanup)
        }
      }
    } else if (isNodeStream(stream)) {
      if (isReadableNodeStream(ret)) {
        finishCount += 2
        const cleanup = pipe(ret, stream, finish, {
          end
        })
        if (isReadable(stream) && isLastStream) {
          lastStreamCleanup.push(cleanup)
        }
      } else if (isTransformStream(ret) || isReadableStream(ret)) {
        const toRead = ret.readable || ret
        finishCount++
        pumpToNode(toRead, stream, finish, {
          end
        })
      } else if (isIterable(ret)) {
        finishCount++
        pumpToNode(ret, stream, finish, {
          end
        })
      } else {
        throw new ERR_INVALID_ARG_TYPE(
          'val',
          ['Readable', 'Iterable', 'AsyncIterable', 'ReadableStream', 'TransformStream'],
          ret
        )
      }
      ret = stream
    } else if (isWebStream(stream)) {
      if (isReadableNodeStream(ret)) {
        finishCount++
        pumpToWeb(makeAsyncIterable(ret), stream, finish, {
          end
        })
      } else if (isReadableStream(ret) || isIterable(ret)) {
        finishCount++
        pumpToWeb(ret, stream, finish, {
          end
        })
      } else if (isTransformStream(ret)) {
        finishCount++
        pumpToWeb(ret.readable, stream, finish, {
          end
        })
      } else {
        throw new ERR_INVALID_ARG_TYPE(
          'val',
          ['Readable', 'Iterable', 'AsyncIterable', 'ReadableStream', 'TransformStream'],
          ret
        )
      }
      ret = stream
    } else {
      ret = Duplex.from(stream)
    }
  }
  if (
    (signal !== null && signal !== undefined && signal.aborted) ||
    (outerSignal !== null && outerSignal !== undefined && outerSignal.aborted)
  ) {
    process.nextTick(abort)
  }
  return ret
}
function pipe(src, dst, finish, { end }) {
  let ended = false
  dst.on('close', () => {
    if (!ended) {
      // Finish if the destination closes before the source has completed.
      finish(new ERR_STREAM_PREMATURE_CLOSE())
    }
  })
  src.pipe(dst, {
    end: false
  }) // If end is true we already will have a listener to end dst.

  if (end) {
    // Compat. Before node v10.12.0 stdio used to throw an error so
    // pipe() did/does not end() stdio destinations.
    // Now they allow it but "secretly" don't close the underlying fd.

    function endFn() {
      ended = true
      dst.end()
    }
    if (isReadableFinished(src)) {
      // End the destination if the source has already ended.
      process.nextTick(endFn)
    } else {
      src.once('end', endFn)
    }
  } else {
    finish()
  }
  eos(
    src,
    {
      readable: true,
      writable: false
    },
    (err) => {
      const rState = src._readableState
      if (
        err &&
        err.code === 'ERR_STREAM_PREMATURE_CLOSE' &&
        rState &&
        rState.ended &&
        !rState.errored &&
        !rState.errorEmitted
      ) {
        // Some readable streams will emit 'close' before 'end'. However, since
        // this is on the readable side 'end' should still be emitted if the
        // stream has been ended and no error emitted. This should be allowed in
        // favor of backwards compatibility. Since the stream is piped to a
        // destination this should not result in any observable difference.
        // We don't need to check if this is a writable premature close since
        // eos will only fail with premature close on the reading side for
        // duplex streams.
        src.once('end', finish).once('error', finish)
      } else {
        finish(err)
      }
    }
  )
  return eos(
    dst,
    {
      readable: false,
      writable: true
    },
    finish
  )
}
module.exports = {
  pipelineImpl,
  pipeline
}


/***/ }),

/***/ 51560:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/* replacement start */

const process = __webpack_require__(14224)

/* replacement end */
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

;('use strict')
const {
  ArrayPrototypeIndexOf,
  NumberIsInteger,
  NumberIsNaN,
  NumberParseInt,
  ObjectDefineProperties,
  ObjectKeys,
  ObjectSetPrototypeOf,
  Promise,
  SafeSet,
  SymbolAsyncDispose,
  SymbolAsyncIterator,
  Symbol
} = __webpack_require__(54136)
module.exports = Readable
Readable.ReadableState = ReadableState
const { EventEmitter: EE } = __webpack_require__(72100)
const { Stream, prependListener } = __webpack_require__(23472)
const { Buffer } = __webpack_require__(55872)
const { addAbortSignal } = __webpack_require__(47287)
const eos = __webpack_require__(86695)
let debug = (__webpack_require__(89349).debuglog)('stream', (fn) => {
  debug = fn
})
const BufferList = __webpack_require__(91247)
const destroyImpl = __webpack_require__(35441)
const { getHighWaterMark, getDefaultHighWaterMark } = __webpack_require__(17279)
const {
  aggregateTwoErrors,
  codes: {
    ERR_INVALID_ARG_TYPE,
    ERR_METHOD_NOT_IMPLEMENTED,
    ERR_OUT_OF_RANGE,
    ERR_STREAM_PUSH_AFTER_EOF,
    ERR_STREAM_UNSHIFT_AFTER_END_EVENT
  },
  AbortError
} = __webpack_require__(91198)
const { validateObject } = __webpack_require__(1712)
const kPaused = Symbol('kPaused')
const { StringDecoder } = __webpack_require__(72699)
const from = __webpack_require__(93870)
ObjectSetPrototypeOf(Readable.prototype, Stream.prototype)
ObjectSetPrototypeOf(Readable, Stream)
const nop = () => {}
const { errorOrDestroy } = destroyImpl
const kObjectMode = 1 << 0
const kEnded = 1 << 1
const kEndEmitted = 1 << 2
const kReading = 1 << 3
const kConstructed = 1 << 4
const kSync = 1 << 5
const kNeedReadable = 1 << 6
const kEmittedReadable = 1 << 7
const kReadableListening = 1 << 8
const kResumeScheduled = 1 << 9
const kErrorEmitted = 1 << 10
const kEmitClose = 1 << 11
const kAutoDestroy = 1 << 12
const kDestroyed = 1 << 13
const kClosed = 1 << 14
const kCloseEmitted = 1 << 15
const kMultiAwaitDrain = 1 << 16
const kReadingMore = 1 << 17
const kDataEmitted = 1 << 18

// TODO(benjamingr) it is likely slower to do it this way than with free functions
function makeBitMapDescriptor(bit) {
  return {
    enumerable: false,
    get() {
      return (this.state & bit) !== 0
    },
    set(value) {
      if (value) this.state |= bit
      else this.state &= ~bit
    }
  }
}
ObjectDefineProperties(ReadableState.prototype, {
  objectMode: makeBitMapDescriptor(kObjectMode),
  ended: makeBitMapDescriptor(kEnded),
  endEmitted: makeBitMapDescriptor(kEndEmitted),
  reading: makeBitMapDescriptor(kReading),
  // Stream is still being constructed and cannot be
  // destroyed until construction finished or failed.
  // Async construction is opt in, therefore we start as
  // constructed.
  constructed: makeBitMapDescriptor(kConstructed),
  // A flag to be able to tell if the event 'readable'/'data' is emitted
  // immediately, or on a later tick.  We set this to true at first, because
  // any actions that shouldn't happen until "later" should generally also
  // not happen before the first read call.
  sync: makeBitMapDescriptor(kSync),
  // Whenever we return null, then we set a flag to say
  // that we're awaiting a 'readable' event emission.
  needReadable: makeBitMapDescriptor(kNeedReadable),
  emittedReadable: makeBitMapDescriptor(kEmittedReadable),
  readableListening: makeBitMapDescriptor(kReadableListening),
  resumeScheduled: makeBitMapDescriptor(kResumeScheduled),
  // True if the error was already emitted and should not be thrown again.
  errorEmitted: makeBitMapDescriptor(kErrorEmitted),
  emitClose: makeBitMapDescriptor(kEmitClose),
  autoDestroy: makeBitMapDescriptor(kAutoDestroy),
  // Has it been destroyed.
  destroyed: makeBitMapDescriptor(kDestroyed),
  // Indicates whether the stream has finished destroying.
  closed: makeBitMapDescriptor(kClosed),
  // True if close has been emitted or would have been emitted
  // depending on emitClose.
  closeEmitted: makeBitMapDescriptor(kCloseEmitted),
  multiAwaitDrain: makeBitMapDescriptor(kMultiAwaitDrain),
  // If true, a maybeReadMore has been scheduled.
  readingMore: makeBitMapDescriptor(kReadingMore),
  dataEmitted: makeBitMapDescriptor(kDataEmitted)
})
function ReadableState(options, stream, isDuplex) {
  // Duplex streams are both readable and writable, but share
  // the same options object.
  // However, some cases require setting options to different
  // values for the readable and the writable sides of the duplex stream.
  // These options can be provided separately as readableXXX and writableXXX.
  if (typeof isDuplex !== 'boolean') isDuplex = stream instanceof __webpack_require__(66695)

  // Bit map field to store ReadableState more effciently with 1 bit per field
  // instead of a V8 slot per field.
  this.state = kEmitClose | kAutoDestroy | kConstructed | kSync
  // Object stream flag. Used to make read(n) ignore n and to
  // make all the buffer merging and length checks go away.
  if (options && options.objectMode) this.state |= kObjectMode
  if (isDuplex && options && options.readableObjectMode) this.state |= kObjectMode

  // The point at which it stops calling _read() to fill the buffer
  // Note: 0 is a valid value, means "don't call _read preemptively ever"
  this.highWaterMark = options
    ? getHighWaterMark(this, options, 'readableHighWaterMark', isDuplex)
    : getDefaultHighWaterMark(false)

  // A linked list is used to store data chunks instead of an array because the
  // linked list can remove elements from the beginning faster than
  // array.shift().
  this.buffer = new BufferList()
  this.length = 0
  this.pipes = []
  this.flowing = null
  this[kPaused] = null

  // Should close be emitted on destroy. Defaults to true.
  if (options && options.emitClose === false) this.state &= ~kEmitClose

  // Should .destroy() be called after 'end' (and potentially 'finish').
  if (options && options.autoDestroy === false) this.state &= ~kAutoDestroy

  // Indicates whether the stream has errored. When true no further
  // _read calls, 'data' or 'readable' events should occur. This is needed
  // since when autoDestroy is disabled we need a way to tell whether the
  // stream has failed.
  this.errored = null

  // Crypto is kind of old and crusty.  Historically, its default string
  // encoding is 'binary' so we have to make this configurable.
  // Everything else in the universe uses 'utf8', though.
  this.defaultEncoding = (options && options.defaultEncoding) || 'utf8'

  // Ref the piped dest which we need a drain event on it
  // type: null | Writable | Set<Writable>.
  this.awaitDrainWriters = null
  this.decoder = null
  this.encoding = null
  if (options && options.encoding) {
    this.decoder = new StringDecoder(options.encoding)
    this.encoding = options.encoding
  }
}
function Readable(options) {
  if (!(this instanceof Readable)) return new Readable(options)

  // Checking for a Stream.Duplex instance is faster here instead of inside
  // the ReadableState constructor, at least with V8 6.5.
  const isDuplex = this instanceof __webpack_require__(66695)
  this._readableState = new ReadableState(options, this, isDuplex)
  if (options) {
    if (typeof options.read === 'function') this._read = options.read
    if (typeof options.destroy === 'function') this._destroy = options.destroy
    if (typeof options.construct === 'function') this._construct = options.construct
    if (options.signal && !isDuplex) addAbortSignal(options.signal, this)
  }
  Stream.call(this, options)
  destroyImpl.construct(this, () => {
    if (this._readableState.needReadable) {
      maybeReadMore(this, this._readableState)
    }
  })
}
Readable.prototype.destroy = destroyImpl.destroy
Readable.prototype._undestroy = destroyImpl.undestroy
Readable.prototype._destroy = function (err, cb) {
  cb(err)
}
Readable.prototype[EE.captureRejectionSymbol] = function (err) {
  this.destroy(err)
}
Readable.prototype[SymbolAsyncDispose] = function () {
  let error
  if (!this.destroyed) {
    error = this.readableEnded ? null : new AbortError()
    this.destroy(error)
  }
  return new Promise((resolve, reject) => eos(this, (err) => (err && err !== error ? reject(err) : resolve(null))))
}

// Manually shove something into the read() buffer.
// This returns true if the highWaterMark has not been hit yet,
// similar to how Writable.write() returns true if you should
// write() some more.
Readable.prototype.push = function (chunk, encoding) {
  return readableAddChunk(this, chunk, encoding, false)
}

// Unshift should *always* be something directly out of read().
Readable.prototype.unshift = function (chunk, encoding) {
  return readableAddChunk(this, chunk, encoding, true)
}
function readableAddChunk(stream, chunk, encoding, addToFront) {
  debug('readableAddChunk', chunk)
  const state = stream._readableState
  let err
  if ((state.state & kObjectMode) === 0) {
    if (typeof chunk === 'string') {
      encoding = encoding || state.defaultEncoding
      if (state.encoding !== encoding) {
        if (addToFront && state.encoding) {
          // When unshifting, if state.encoding is set, we have to save
          // the string in the BufferList with the state encoding.
          chunk = Buffer.from(chunk, encoding).toString(state.encoding)
        } else {
          chunk = Buffer.from(chunk, encoding)
          encoding = ''
        }
      }
    } else if (chunk instanceof Buffer) {
      encoding = ''
    } else if (Stream._isUint8Array(chunk)) {
      chunk = Stream._uint8ArrayToBuffer(chunk)
      encoding = ''
    } else if (chunk != null) {
      err = new ERR_INVALID_ARG_TYPE('chunk', ['string', 'Buffer', 'Uint8Array'], chunk)
    }
  }
  if (err) {
    errorOrDestroy(stream, err)
  } else if (chunk === null) {
    state.state &= ~kReading
    onEofChunk(stream, state)
  } else if ((state.state & kObjectMode) !== 0 || (chunk && chunk.length > 0)) {
    if (addToFront) {
      if ((state.state & kEndEmitted) !== 0) errorOrDestroy(stream, new ERR_STREAM_UNSHIFT_AFTER_END_EVENT())
      else if (state.destroyed || state.errored) return false
      else addChunk(stream, state, chunk, true)
    } else if (state.ended) {
      errorOrDestroy(stream, new ERR_STREAM_PUSH_AFTER_EOF())
    } else if (state.destroyed || state.errored) {
      return false
    } else {
      state.state &= ~kReading
      if (state.decoder && !encoding) {
        chunk = state.decoder.write(chunk)
        if (state.objectMode || chunk.length !== 0) addChunk(stream, state, chunk, false)
        else maybeReadMore(stream, state)
      } else {
        addChunk(stream, state, chunk, false)
      }
    }
  } else if (!addToFront) {
    state.state &= ~kReading
    maybeReadMore(stream, state)
  }

  // We can push more data if we are below the highWaterMark.
  // Also, if we have no data yet, we can stand some more bytes.
  // This is to work around cases where hwm=0, such as the repl.
  return !state.ended && (state.length < state.highWaterMark || state.length === 0)
}
function addChunk(stream, state, chunk, addToFront) {
  if (state.flowing && state.length === 0 && !state.sync && stream.listenerCount('data') > 0) {
    // Use the guard to avoid creating `Set()` repeatedly
    // when we have multiple pipes.
    if ((state.state & kMultiAwaitDrain) !== 0) {
      state.awaitDrainWriters.clear()
    } else {
      state.awaitDrainWriters = null
    }
    state.dataEmitted = true
    stream.emit('data', chunk)
  } else {
    // Update the buffer info.
    state.length += state.objectMode ? 1 : chunk.length
    if (addToFront) state.buffer.unshift(chunk)
    else state.buffer.push(chunk)
    if ((state.state & kNeedReadable) !== 0) emitReadable(stream)
  }
  maybeReadMore(stream, state)
}
Readable.prototype.isPaused = function () {
  const state = this._readableState
  return state[kPaused] === true || state.flowing === false
}

// Backwards compatibility.
Readable.prototype.setEncoding = function (enc) {
  const decoder = new StringDecoder(enc)
  this._readableState.decoder = decoder
  // If setEncoding(null), decoder.encoding equals utf8.
  this._readableState.encoding = this._readableState.decoder.encoding
  const buffer = this._readableState.buffer
  // Iterate over current buffer to convert already stored Buffers:
  let content = ''
  for (const data of buffer) {
    content += decoder.write(data)
  }
  buffer.clear()
  if (content !== '') buffer.push(content)
  this._readableState.length = content.length
  return this
}

// Don't raise the hwm > 1GB.
const MAX_HWM = 0x40000000
function computeNewHighWaterMark(n) {
  if (n > MAX_HWM) {
    throw new ERR_OUT_OF_RANGE('size', '<= 1GiB', n)
  } else {
    // Get the next highest power of 2 to prevent increasing hwm excessively in
    // tiny amounts.
    n--
    n |= n >>> 1
    n |= n >>> 2
    n |= n >>> 4
    n |= n >>> 8
    n |= n >>> 16
    n++
  }
  return n
}

// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function howMuchToRead(n, state) {
  if (n <= 0 || (state.length === 0 && state.ended)) return 0
  if ((state.state & kObjectMode) !== 0) return 1
  if (NumberIsNaN(n)) {
    // Only flow one buffer at a time.
    if (state.flowing && state.length) return state.buffer.first().length
    return state.length
  }
  if (n <= state.length) return n
  return state.ended ? state.length : 0
}

// You can override either this method, or the async _read(n) below.
Readable.prototype.read = function (n) {
  debug('read', n)
  // Same as parseInt(undefined, 10), however V8 7.3 performance regressed
  // in this scenario, so we are doing it manually.
  if (n === undefined) {
    n = NaN
  } else if (!NumberIsInteger(n)) {
    n = NumberParseInt(n, 10)
  }
  const state = this._readableState
  const nOrig = n

  // If we're asking for more than the current hwm, then raise the hwm.
  if (n > state.highWaterMark) state.highWaterMark = computeNewHighWaterMark(n)
  if (n !== 0) state.state &= ~kEmittedReadable

  // If we're doing read(0) to trigger a readable event, but we
  // already have a bunch of data in the buffer, then just trigger
  // the 'readable' event and move on.
  if (
    n === 0 &&
    state.needReadable &&
    ((state.highWaterMark !== 0 ? state.length >= state.highWaterMark : state.length > 0) || state.ended)
  ) {
    debug('read: emitReadable', state.length, state.ended)
    if (state.length === 0 && state.ended) endReadable(this)
    else emitReadable(this)
    return null
  }
  n = howMuchToRead(n, state)

  // If we've ended, and we're now clear, then finish it up.
  if (n === 0 && state.ended) {
    if (state.length === 0) endReadable(this)
    return null
  }

  // All the actual chunk generation logic needs to be
  // *below* the call to _read.  The reason is that in certain
  // synthetic stream cases, such as passthrough streams, _read
  // may be a completely synchronous operation which may change
  // the state of the read buffer, providing enough data when
  // before there was *not* enough.
  //
  // So, the steps are:
  // 1. Figure out what the state of things will be after we do
  // a read from the buffer.
  //
  // 2. If that resulting state will trigger a _read, then call _read.
  // Note that this may be asynchronous, or synchronous.  Yes, it is
  // deeply ugly to write APIs this way, but that still doesn't mean
  // that the Readable class should behave improperly, as streams are
  // designed to be sync/async agnostic.
  // Take note if the _read call is sync or async (ie, if the read call
  // has returned yet), so that we know whether or not it's safe to emit
  // 'readable' etc.
  //
  // 3. Actually pull the requested chunks out of the buffer and return.

  // if we need a readable event, then we need to do some reading.
  let doRead = (state.state & kNeedReadable) !== 0
  debug('need readable', doRead)

  // If we currently have less than the highWaterMark, then also read some.
  if (state.length === 0 || state.length - n < state.highWaterMark) {
    doRead = true
    debug('length less than watermark', doRead)
  }

  // However, if we've ended, then there's no point, if we're already
  // reading, then it's unnecessary, if we're constructing we have to wait,
  // and if we're destroyed or errored, then it's not allowed,
  if (state.ended || state.reading || state.destroyed || state.errored || !state.constructed) {
    doRead = false
    debug('reading, ended or constructing', doRead)
  } else if (doRead) {
    debug('do read')
    state.state |= kReading | kSync
    // If the length is currently zero, then we *need* a readable event.
    if (state.length === 0) state.state |= kNeedReadable

    // Call internal read method
    try {
      this._read(state.highWaterMark)
    } catch (err) {
      errorOrDestroy(this, err)
    }
    state.state &= ~kSync

    // If _read pushed data synchronously, then `reading` will be false,
    // and we need to re-evaluate how much data we can return to the user.
    if (!state.reading) n = howMuchToRead(nOrig, state)
  }
  let ret
  if (n > 0) ret = fromList(n, state)
  else ret = null
  if (ret === null) {
    state.needReadable = state.length <= state.highWaterMark
    n = 0
  } else {
    state.length -= n
    if (state.multiAwaitDrain) {
      state.awaitDrainWriters.clear()
    } else {
      state.awaitDrainWriters = null
    }
  }
  if (state.length === 0) {
    // If we have nothing in the buffer, then we want to know
    // as soon as we *do* get something into the buffer.
    if (!state.ended) state.needReadable = true

    // If we tried to read() past the EOF, then emit end on the next tick.
    if (nOrig !== n && state.ended) endReadable(this)
  }
  if (ret !== null && !state.errorEmitted && !state.closeEmitted) {
    state.dataEmitted = true
    this.emit('data', ret)
  }
  return ret
}
function onEofChunk(stream, state) {
  debug('onEofChunk')
  if (state.ended) return
  if (state.decoder) {
    const chunk = state.decoder.end()
    if (chunk && chunk.length) {
      state.buffer.push(chunk)
      state.length += state.objectMode ? 1 : chunk.length
    }
  }
  state.ended = true
  if (state.sync) {
    // If we are sync, wait until next tick to emit the data.
    // Otherwise we risk emitting data in the flow()
    // the readable code triggers during a read() call.
    emitReadable(stream)
  } else {
    // Emit 'readable' now to make sure it gets picked up.
    state.needReadable = false
    state.emittedReadable = true
    // We have to emit readable now that we are EOF. Modules
    // in the ecosystem (e.g. dicer) rely on this event being sync.
    emitReadable_(stream)
  }
}

// Don't emit readable right away in sync mode, because this can trigger
// another read() call => stack overflow.  This way, it might trigger
// a nextTick recursion warning, but that's not so bad.
function emitReadable(stream) {
  const state = stream._readableState
  debug('emitReadable', state.needReadable, state.emittedReadable)
  state.needReadable = false
  if (!state.emittedReadable) {
    debug('emitReadable', state.flowing)
    state.emittedReadable = true
    process.nextTick(emitReadable_, stream)
  }
}
function emitReadable_(stream) {
  const state = stream._readableState
  debug('emitReadable_', state.destroyed, state.length, state.ended)
  if (!state.destroyed && !state.errored && (state.length || state.ended)) {
    stream.emit('readable')
    state.emittedReadable = false
  }

  // The stream needs another readable event if:
  // 1. It is not flowing, as the flow mechanism will take
  //    care of it.
  // 2. It is not ended.
  // 3. It is below the highWaterMark, so we can schedule
  //    another readable later.
  state.needReadable = !state.flowing && !state.ended && state.length <= state.highWaterMark
  flow(stream)
}

// At this point, the user has presumably seen the 'readable' event,
// and called read() to consume some data.  that may have triggered
// in turn another _read(n) call, in which case reading = true if
// it's in progress.
// However, if we're not ended, or reading, and the length < hwm,
// then go ahead and try to read some more preemptively.
function maybeReadMore(stream, state) {
  if (!state.readingMore && state.constructed) {
    state.readingMore = true
    process.nextTick(maybeReadMore_, stream, state)
  }
}
function maybeReadMore_(stream, state) {
  // Attempt to read more data if we should.
  //
  // The conditions for reading more data are (one of):
  // - Not enough data buffered (state.length < state.highWaterMark). The loop
  //   is responsible for filling the buffer with enough data if such data
  //   is available. If highWaterMark is 0 and we are not in the flowing mode
  //   we should _not_ attempt to buffer any extra data. We'll get more data
  //   when the stream consumer calls read() instead.
  // - No data in the buffer, and the stream is in flowing mode. In this mode
  //   the loop below is responsible for ensuring read() is called. Failing to
  //   call read here would abort the flow and there's no other mechanism for
  //   continuing the flow if the stream consumer has just subscribed to the
  //   'data' event.
  //
  // In addition to the above conditions to keep reading data, the following
  // conditions prevent the data from being read:
  // - The stream has ended (state.ended).
  // - There is already a pending 'read' operation (state.reading). This is a
  //   case where the stream has called the implementation defined _read()
  //   method, but they are processing the call asynchronously and have _not_
  //   called push() with new data. In this case we skip performing more
  //   read()s. The execution ends in this method again after the _read() ends
  //   up calling push() with more data.
  while (
    !state.reading &&
    !state.ended &&
    (state.length < state.highWaterMark || (state.flowing && state.length === 0))
  ) {
    const len = state.length
    debug('maybeReadMore read 0')
    stream.read(0)
    if (len === state.length)
      // Didn't get any data, stop spinning.
      break
  }
  state.readingMore = false
}

// Abstract method.  to be overridden in specific implementation classes.
// call cb(er, data) where data is <= n in length.
// for virtual (non-string, non-buffer) streams, "length" is somewhat
// arbitrary, and perhaps not very meaningful.
Readable.prototype._read = function (n) {
  throw new ERR_METHOD_NOT_IMPLEMENTED('_read()')
}
Readable.prototype.pipe = function (dest, pipeOpts) {
  const src = this
  const state = this._readableState
  if (state.pipes.length === 1) {
    if (!state.multiAwaitDrain) {
      state.multiAwaitDrain = true
      state.awaitDrainWriters = new SafeSet(state.awaitDrainWriters ? [state.awaitDrainWriters] : [])
    }
  }
  state.pipes.push(dest)
  debug('pipe count=%d opts=%j', state.pipes.length, pipeOpts)
  const doEnd = (!pipeOpts || pipeOpts.end !== false) && dest !== process.stdout && dest !== process.stderr
  const endFn = doEnd ? onend : unpipe
  if (state.endEmitted) process.nextTick(endFn)
  else src.once('end', endFn)
  dest.on('unpipe', onunpipe)
  function onunpipe(readable, unpipeInfo) {
    debug('onunpipe')
    if (readable === src) {
      if (unpipeInfo && unpipeInfo.hasUnpiped === false) {
        unpipeInfo.hasUnpiped = true
        cleanup()
      }
    }
  }
  function onend() {
    debug('onend')
    dest.end()
  }
  let ondrain
  let cleanedUp = false
  function cleanup() {
    debug('cleanup')
    // Cleanup event handlers once the pipe is broken.
    dest.removeListener('close', onclose)
    dest.removeListener('finish', onfinish)
    if (ondrain) {
      dest.removeListener('drain', ondrain)
    }
    dest.removeListener('error', onerror)
    dest.removeListener('unpipe', onunpipe)
    src.removeListener('end', onend)
    src.removeListener('end', unpipe)
    src.removeListener('data', ondata)
    cleanedUp = true

    // If the reader is waiting for a drain event from this
    // specific writer, then it would cause it to never start
    // flowing again.
    // So, if this is awaiting a drain, then we just call it now.
    // If we don't know, then assume that we are waiting for one.
    if (ondrain && state.awaitDrainWriters && (!dest._writableState || dest._writableState.needDrain)) ondrain()
  }
  function pause() {
    // If the user unpiped during `dest.write()`, it is possible
    // to get stuck in a permanently paused state if that write
    // also returned false.
    // => Check whether `dest` is still a piping destination.
    if (!cleanedUp) {
      if (state.pipes.length === 1 && state.pipes[0] === dest) {
        debug('false write response, pause', 0)
        state.awaitDrainWriters = dest
        state.multiAwaitDrain = false
      } else if (state.pipes.length > 1 && state.pipes.includes(dest)) {
        debug('false write response, pause', state.awaitDrainWriters.size)
        state.awaitDrainWriters.add(dest)
      }
      src.pause()
    }
    if (!ondrain) {
      // When the dest drains, it reduces the awaitDrain counter
      // on the source.  This would be more elegant with a .once()
      // handler in flow(), but adding and removing repeatedly is
      // too slow.
      ondrain = pipeOnDrain(src, dest)
      dest.on('drain', ondrain)
    }
  }
  src.on('data', ondata)
  function ondata(chunk) {
    debug('ondata')
    const ret = dest.write(chunk)
    debug('dest.write', ret)
    if (ret === false) {
      pause()
    }
  }

  // If the dest has an error, then stop piping into it.
  // However, don't suppress the throwing behavior for this.
  function onerror(er) {
    debug('onerror', er)
    unpipe()
    dest.removeListener('error', onerror)
    if (dest.listenerCount('error') === 0) {
      const s = dest._writableState || dest._readableState
      if (s && !s.errorEmitted) {
        // User incorrectly emitted 'error' directly on the stream.
        errorOrDestroy(dest, er)
      } else {
        dest.emit('error', er)
      }
    }
  }

  // Make sure our error handler is attached before userland ones.
  prependListener(dest, 'error', onerror)

  // Both close and finish should trigger unpipe, but only once.
  function onclose() {
    dest.removeListener('finish', onfinish)
    unpipe()
  }
  dest.once('close', onclose)
  function onfinish() {
    debug('onfinish')
    dest.removeListener('close', onclose)
    unpipe()
  }
  dest.once('finish', onfinish)
  function unpipe() {
    debug('unpipe')
    src.unpipe(dest)
  }

  // Tell the dest that it's being piped to.
  dest.emit('pipe', src)

  // Start the flow if it hasn't been started already.

  if (dest.writableNeedDrain === true) {
    pause()
  } else if (!state.flowing) {
    debug('pipe resume')
    src.resume()
  }
  return dest
}
function pipeOnDrain(src, dest) {
  return function pipeOnDrainFunctionResult() {
    const state = src._readableState

    // `ondrain` will call directly,
    // `this` maybe not a reference to dest,
    // so we use the real dest here.
    if (state.awaitDrainWriters === dest) {
      debug('pipeOnDrain', 1)
      state.awaitDrainWriters = null
    } else if (state.multiAwaitDrain) {
      debug('pipeOnDrain', state.awaitDrainWriters.size)
      state.awaitDrainWriters.delete(dest)
    }
    if ((!state.awaitDrainWriters || state.awaitDrainWriters.size === 0) && src.listenerCount('data')) {
      src.resume()
    }
  }
}
Readable.prototype.unpipe = function (dest) {
  const state = this._readableState
  const unpipeInfo = {
    hasUnpiped: false
  }

  // If we're not piping anywhere, then do nothing.
  if (state.pipes.length === 0) return this
  if (!dest) {
    // remove all.
    const dests = state.pipes
    state.pipes = []
    this.pause()
    for (let i = 0; i < dests.length; i++)
      dests[i].emit('unpipe', this, {
        hasUnpiped: false
      })
    return this
  }

  // Try to find the right one.
  const index = ArrayPrototypeIndexOf(state.pipes, dest)
  if (index === -1) return this
  state.pipes.splice(index, 1)
  if (state.pipes.length === 0) this.pause()
  dest.emit('unpipe', this, unpipeInfo)
  return this
}

// Set up data events if they are asked for
// Ensure readable listeners eventually get something.
Readable.prototype.on = function (ev, fn) {
  const res = Stream.prototype.on.call(this, ev, fn)
  const state = this._readableState
  if (ev === 'data') {
    // Update readableListening so that resume() may be a no-op
    // a few lines down. This is needed to support once('readable').
    state.readableListening = this.listenerCount('readable') > 0

    // Try start flowing on next tick if stream isn't explicitly paused.
    if (state.flowing !== false) this.resume()
  } else if (ev === 'readable') {
    if (!state.endEmitted && !state.readableListening) {
      state.readableListening = state.needReadable = true
      state.flowing = false
      state.emittedReadable = false
      debug('on readable', state.length, state.reading)
      if (state.length) {
        emitReadable(this)
      } else if (!state.reading) {
        process.nextTick(nReadingNextTick, this)
      }
    }
  }
  return res
}
Readable.prototype.addListener = Readable.prototype.on
Readable.prototype.removeListener = function (ev, fn) {
  const res = Stream.prototype.removeListener.call(this, ev, fn)
  if (ev === 'readable') {
    // We need to check if there is someone still listening to
    // readable and reset the state. However this needs to happen
    // after readable has been emitted but before I/O (nextTick) to
    // support once('readable', fn) cycles. This means that calling
    // resume within the same tick will have no
    // effect.
    process.nextTick(updateReadableListening, this)
  }
  return res
}
Readable.prototype.off = Readable.prototype.removeListener
Readable.prototype.removeAllListeners = function (ev) {
  const res = Stream.prototype.removeAllListeners.apply(this, arguments)
  if (ev === 'readable' || ev === undefined) {
    // We need to check if there is someone still listening to
    // readable and reset the state. However this needs to happen
    // after readable has been emitted but before I/O (nextTick) to
    // support once('readable', fn) cycles. This means that calling
    // resume within the same tick will have no
    // effect.
    process.nextTick(updateReadableListening, this)
  }
  return res
}
function updateReadableListening(self) {
  const state = self._readableState
  state.readableListening = self.listenerCount('readable') > 0
  if (state.resumeScheduled && state[kPaused] === false) {
    // Flowing needs to be set to true now, otherwise
    // the upcoming resume will not flow.
    state.flowing = true

    // Crude way to check if we should resume.
  } else if (self.listenerCount('data') > 0) {
    self.resume()
  } else if (!state.readableListening) {
    state.flowing = null
  }
}
function nReadingNextTick(self) {
  debug('readable nexttick read 0')
  self.read(0)
}

// pause() and resume() are remnants of the legacy readable stream API
// If the user uses them, then switch into old mode.
Readable.prototype.resume = function () {
  const state = this._readableState
  if (!state.flowing) {
    debug('resume')
    // We flow only if there is no one listening
    // for readable, but we still have to call
    // resume().
    state.flowing = !state.readableListening
    resume(this, state)
  }
  state[kPaused] = false
  return this
}
function resume(stream, state) {
  if (!state.resumeScheduled) {
    state.resumeScheduled = true
    process.nextTick(resume_, stream, state)
  }
}
function resume_(stream, state) {
  debug('resume', state.reading)
  if (!state.reading) {
    stream.read(0)
  }
  state.resumeScheduled = false
  stream.emit('resume')
  flow(stream)
  if (state.flowing && !state.reading) stream.read(0)
}
Readable.prototype.pause = function () {
  debug('call pause flowing=%j', this._readableState.flowing)
  if (this._readableState.flowing !== false) {
    debug('pause')
    this._readableState.flowing = false
    this.emit('pause')
  }
  this._readableState[kPaused] = true
  return this
}
function flow(stream) {
  const state = stream._readableState
  debug('flow', state.flowing)
  while (state.flowing && stream.read() !== null);
}

// Wrap an old-style stream as the async data source.
// This is *not* part of the readable stream interface.
// It is an ugly unfortunate mess of history.
Readable.prototype.wrap = function (stream) {
  let paused = false

  // TODO (ronag): Should this.destroy(err) emit
  // 'error' on the wrapped stream? Would require
  // a static factory method, e.g. Readable.wrap(stream).

  stream.on('data', (chunk) => {
    if (!this.push(chunk) && stream.pause) {
      paused = true
      stream.pause()
    }
  })
  stream.on('end', () => {
    this.push(null)
  })
  stream.on('error', (err) => {
    errorOrDestroy(this, err)
  })
  stream.on('close', () => {
    this.destroy()
  })
  stream.on('destroy', () => {
    this.destroy()
  })
  this._read = () => {
    if (paused && stream.resume) {
      paused = false
      stream.resume()
    }
  }

  // Proxy all the other methods. Important when wrapping filters and duplexes.
  const streamKeys = ObjectKeys(stream)
  for (let j = 1; j < streamKeys.length; j++) {
    const i = streamKeys[j]
    if (this[i] === undefined && typeof stream[i] === 'function') {
      this[i] = stream[i].bind(stream)
    }
  }
  return this
}
Readable.prototype[SymbolAsyncIterator] = function () {
  return streamToAsyncIterator(this)
}
Readable.prototype.iterator = function (options) {
  if (options !== undefined) {
    validateObject(options, 'options')
  }
  return streamToAsyncIterator(this, options)
}
function streamToAsyncIterator(stream, options) {
  if (typeof stream.read !== 'function') {
    stream = Readable.wrap(stream, {
      objectMode: true
    })
  }
  const iter = createAsyncIterator(stream, options)
  iter.stream = stream
  return iter
}
async function* createAsyncIterator(stream, options) {
  let callback = nop
  function next(resolve) {
    if (this === stream) {
      callback()
      callback = nop
    } else {
      callback = resolve
    }
  }
  stream.on('readable', next)
  let error
  const cleanup = eos(
    stream,
    {
      writable: false
    },
    (err) => {
      error = err ? aggregateTwoErrors(error, err) : null
      callback()
      callback = nop
    }
  )
  try {
    while (true) {
      const chunk = stream.destroyed ? null : stream.read()
      if (chunk !== null) {
        yield chunk
      } else if (error) {
        throw error
      } else if (error === null) {
        return
      } else {
        await new Promise(next)
      }
    }
  } catch (err) {
    error = aggregateTwoErrors(error, err)
    throw error
  } finally {
    if (
      (error || (options === null || options === undefined ? undefined : options.destroyOnReturn) !== false) &&
      (error === undefined || stream._readableState.autoDestroy)
    ) {
      destroyImpl.destroyer(stream, null)
    } else {
      stream.off('readable', next)
      cleanup()
    }
  }
}

// Making it explicit these properties are not enumerable
// because otherwise some prototype manipulation in
// userland will fail.
ObjectDefineProperties(Readable.prototype, {
  readable: {
    __proto__: null,
    get() {
      const r = this._readableState
      // r.readable === false means that this is part of a Duplex stream
      // where the readable side was disabled upon construction.
      // Compat. The user might manually disable readable side through
      // deprecated setter.
      return !!r && r.readable !== false && !r.destroyed && !r.errorEmitted && !r.endEmitted
    },
    set(val) {
      // Backwards compat.
      if (this._readableState) {
        this._readableState.readable = !!val
      }
    }
  },
  readableDidRead: {
    __proto__: null,
    enumerable: false,
    get: function () {
      return this._readableState.dataEmitted
    }
  },
  readableAborted: {
    __proto__: null,
    enumerable: false,
    get: function () {
      return !!(
        this._readableState.readable !== false &&
        (this._readableState.destroyed || this._readableState.errored) &&
        !this._readableState.endEmitted
      )
    }
  },
  readableHighWaterMark: {
    __proto__: null,
    enumerable: false,
    get: function () {
      return this._readableState.highWaterMark
    }
  },
  readableBuffer: {
    __proto__: null,
    enumerable: false,
    get: function () {
      return this._readableState && this._readableState.buffer
    }
  },
  readableFlowing: {
    __proto__: null,
    enumerable: false,
    get: function () {
      return this._readableState.flowing
    },
    set: function (state) {
      if (this._readableState) {
        this._readableState.flowing = state
      }
    }
  },
  readableLength: {
    __proto__: null,
    enumerable: false,
    get() {
      return this._readableState.length
    }
  },
  readableObjectMode: {
    __proto__: null,
    enumerable: false,
    get() {
      return this._readableState ? this._readableState.objectMode : false
    }
  },
  readableEncoding: {
    __proto__: null,
    enumerable: false,
    get() {
      return this._readableState ? this._readableState.encoding : null
    }
  },
  errored: {
    __proto__: null,
    enumerable: false,
    get() {
      return this._readableState ? this._readableState.errored : null
    }
  },
  closed: {
    __proto__: null,
    get() {
      return this._readableState ? this._readableState.closed : false
    }
  },
  destroyed: {
    __proto__: null,
    enumerable: false,
    get() {
      return this._readableState ? this._readableState.destroyed : false
    },
    set(value) {
      // We ignore the value if the stream
      // has not been initialized yet.
      if (!this._readableState) {
        return
      }

      // Backward compatibility, the user is explicitly
      // managing destroyed.
      this._readableState.destroyed = value
    }
  },
  readableEnded: {
    __proto__: null,
    enumerable: false,
    get() {
      return this._readableState ? this._readableState.endEmitted : false
    }
  }
})
ObjectDefineProperties(ReadableState.prototype, {
  // Legacy getter for `pipesCount`.
  pipesCount: {
    __proto__: null,
    get() {
      return this.pipes.length
    }
  },
  // Legacy property for `paused`.
  paused: {
    __proto__: null,
    get() {
      return this[kPaused] !== false
    },
    set(value) {
      this[kPaused] = !!value
    }
  }
})

// Exposed for testing purposes only.
Readable._fromList = fromList

// Pluck off n bytes from an array of buffers.
// Length is the combined lengths of all the buffers in the list.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function fromList(n, state) {
  // nothing buffered.
  if (state.length === 0) return null
  let ret
  if (state.objectMode) ret = state.buffer.shift()
  else if (!n || n >= state.length) {
    // Read it all, truncate the list.
    if (state.decoder) ret = state.buffer.join('')
    else if (state.buffer.length === 1) ret = state.buffer.first()
    else ret = state.buffer.concat(state.length)
    state.buffer.clear()
  } else {
    // read part of list.
    ret = state.buffer.consume(n, state.decoder)
  }
  return ret
}
function endReadable(stream) {
  const state = stream._readableState
  debug('endReadable', state.endEmitted)
  if (!state.endEmitted) {
    state.ended = true
    process.nextTick(endReadableNT, state, stream)
  }
}
function endReadableNT(state, stream) {
  debug('endReadableNT', state.endEmitted, state.length)

  // Check that we didn't get one last unshift.
  if (!state.errored && !state.closeEmitted && !state.endEmitted && state.length === 0) {
    state.endEmitted = true
    stream.emit('end')
    if (stream.writable && stream.allowHalfOpen === false) {
      process.nextTick(endWritableNT, stream)
    } else if (state.autoDestroy) {
      // In case of duplex streams we need a way to detect
      // if the writable side is ready for autoDestroy as well.
      const wState = stream._writableState
      const autoDestroy =
        !wState ||
        (wState.autoDestroy &&
          // We don't expect the writable to ever 'finish'
          // if writable is explicitly set to false.
          (wState.finished || wState.writable === false))
      if (autoDestroy) {
        stream.destroy()
      }
    }
  }
}
function endWritableNT(stream) {
  const writable = stream.writable && !stream.writableEnded && !stream.destroyed
  if (writable) {
    stream.end()
  }
}
Readable.from = function (iterable, opts) {
  return from(Readable, iterable, opts)
}
let webStreamsAdapters

// Lazy to avoid circular references
function lazyWebStreams() {
  if (webStreamsAdapters === undefined) webStreamsAdapters = {}
  return webStreamsAdapters
}
Readable.fromWeb = function (readableStream, options) {
  return lazyWebStreams().newStreamReadableFromReadableStream(readableStream, options)
}
Readable.toWeb = function (streamReadable, options) {
  return lazyWebStreams().newReadableStreamFromStreamReadable(streamReadable, options)
}
Readable.wrap = function (src, options) {
  var _ref, _src$readableObjectMo
  return new Readable({
    objectMode:
      (_ref =
        (_src$readableObjectMo = src.readableObjectMode) !== null && _src$readableObjectMo !== undefined
          ? _src$readableObjectMo
          : src.objectMode) !== null && _ref !== undefined
        ? _ref
        : true,
    ...options,
    destroy(err, callback) {
      destroyImpl.destroyer(src, err)
      callback(err)
    }
  }).wrap(src)
}


/***/ }),

/***/ 17279:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


const { MathFloor, NumberIsInteger } = __webpack_require__(54136)
const { validateInteger } = __webpack_require__(1712)
const { ERR_INVALID_ARG_VALUE } = (__webpack_require__(91198).codes)
let defaultHighWaterMarkBytes = 16 * 1024
let defaultHighWaterMarkObjectMode = 16
function highWaterMarkFrom(options, isDuplex, duplexKey) {
  return options.highWaterMark != null ? options.highWaterMark : isDuplex ? options[duplexKey] : null
}
function getDefaultHighWaterMark(objectMode) {
  return objectMode ? defaultHighWaterMarkObjectMode : defaultHighWaterMarkBytes
}
function setDefaultHighWaterMark(objectMode, value) {
  validateInteger(value, 'value', 0)
  if (objectMode) {
    defaultHighWaterMarkObjectMode = value
  } else {
    defaultHighWaterMarkBytes = value
  }
}
function getHighWaterMark(state, options, duplexKey, isDuplex) {
  const hwm = highWaterMarkFrom(options, isDuplex, duplexKey)
  if (hwm != null) {
    if (!NumberIsInteger(hwm) || hwm < 0) {
      const name = isDuplex ? `options.${duplexKey}` : 'options.highWaterMark'
      throw new ERR_INVALID_ARG_VALUE(name, hwm)
    }
    return MathFloor(hwm)
  }

  // Default value
  return getDefaultHighWaterMark(state.objectMode)
}
module.exports = {
  getHighWaterMark,
  getDefaultHighWaterMark,
  setDefaultHighWaterMark
}


/***/ }),

/***/ 45033:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// a transform stream is a readable/writable stream where you do
// something with the data.  Sometimes it's called a "filter",
// but that's not a great name for it, since that implies a thing where
// some bits pass through, and others are simply ignored.  (That would
// be a valid example of a transform, of course.)
//
// While the output is causally related to the input, it's not a
// necessarily symmetric or synchronous transformation.  For example,
// a zlib stream might take multiple plain-text writes(), and then
// emit a single compressed chunk some time in the future.
//
// Here's how this works:
//
// The Transform stream has all the aspects of the readable and writable
// stream classes.  When you write(chunk), that calls _write(chunk,cb)
// internally, and returns false if there's a lot of pending writes
// buffered up.  When you call read(), that calls _read(n) until
// there's enough pending readable data buffered up.
//
// In a transform stream, the written data is placed in a buffer.  When
// _read(n) is called, it transforms the queued up data, calling the
// buffered _write cb's as it consumes chunks.  If consuming a single
// written chunk would result in multiple output chunks, then the first
// outputted bit calls the readcb, and subsequent chunks just go into
// the read buffer, and will cause it to emit 'readable' if necessary.
//
// This way, back-pressure is actually determined by the reading side,
// since _read has to be called to start processing a new chunk.  However,
// a pathological inflate type of transform can cause excessive buffering
// here.  For example, imagine a stream where every byte of input is
// interpreted as an integer from 0-255, and then results in that many
// bytes of output.  Writing the 4 bytes {ff,ff,ff,ff} would result in
// 1kb of data being output.  In this case, you could write a very small
// amount of input, and end up with a very large amount of output.  In
// such a pathological inflating mechanism, there'd be no way to tell
// the system to stop doing the transform.  A single 4MB write could
// cause the system to run out of memory.
//
// However, even in such a pathological case, only a single written chunk
// would be consumed, and then the rest would wait (un-transformed) until
// the results of the previous transformed chunk were consumed.



const { ObjectSetPrototypeOf, Symbol } = __webpack_require__(54136)
module.exports = Transform
const { ERR_METHOD_NOT_IMPLEMENTED } = (__webpack_require__(91198).codes)
const Duplex = __webpack_require__(66695)
const { getHighWaterMark } = __webpack_require__(17279)
ObjectSetPrototypeOf(Transform.prototype, Duplex.prototype)
ObjectSetPrototypeOf(Transform, Duplex)
const kCallback = Symbol('kCallback')
function Transform(options) {
  if (!(this instanceof Transform)) return new Transform(options)

  // TODO (ronag): This should preferably always be
  // applied but would be semver-major. Or even better;
  // make Transform a Readable with the Writable interface.
  const readableHighWaterMark = options ? getHighWaterMark(this, options, 'readableHighWaterMark', true) : null
  if (readableHighWaterMark === 0) {
    // A Duplex will buffer both on the writable and readable side while
    // a Transform just wants to buffer hwm number of elements. To avoid
    // buffering twice we disable buffering on the writable side.
    options = {
      ...options,
      highWaterMark: null,
      readableHighWaterMark,
      // TODO (ronag): 0 is not optimal since we have
      // a "bug" where we check needDrain before calling _write and not after.
      // Refs: https://github.com/nodejs/node/pull/32887
      // Refs: https://github.com/nodejs/node/pull/35941
      writableHighWaterMark: options.writableHighWaterMark || 0
    }
  }
  Duplex.call(this, options)

  // We have implemented the _read method, and done the other things
  // that Readable wants before the first _read call, so unset the
  // sync guard flag.
  this._readableState.sync = false
  this[kCallback] = null
  if (options) {
    if (typeof options.transform === 'function') this._transform = options.transform
    if (typeof options.flush === 'function') this._flush = options.flush
  }

  // When the writable side finishes, then flush out anything remaining.
  // Backwards compat. Some Transform streams incorrectly implement _final
  // instead of or in addition to _flush. By using 'prefinish' instead of
  // implementing _final we continue supporting this unfortunate use case.
  this.on('prefinish', prefinish)
}
function final(cb) {
  if (typeof this._flush === 'function' && !this.destroyed) {
    this._flush((er, data) => {
      if (er) {
        if (cb) {
          cb(er)
        } else {
          this.destroy(er)
        }
        return
      }
      if (data != null) {
        this.push(data)
      }
      this.push(null)
      if (cb) {
        cb()
      }
    })
  } else {
    this.push(null)
    if (cb) {
      cb()
    }
  }
}
function prefinish() {
  if (this._final !== final) {
    final.call(this)
  }
}
Transform.prototype._final = final
Transform.prototype._transform = function (chunk, encoding, callback) {
  throw new ERR_METHOD_NOT_IMPLEMENTED('_transform()')
}
Transform.prototype._write = function (chunk, encoding, callback) {
  const rState = this._readableState
  const wState = this._writableState
  const length = rState.length
  this._transform(chunk, encoding, (err, val) => {
    if (err) {
      callback(err)
      return
    }
    if (val != null) {
      this.push(val)
    }
    if (
      wState.ended ||
      // Backwards compat.
      length === rState.length ||
      // Backwards compat.
      rState.length < rState.highWaterMark
    ) {
      callback()
    } else {
      this[kCallback] = callback
    }
  })
}
Transform.prototype._read = function () {
  if (this[kCallback]) {
    const callback = this[kCallback]
    this[kCallback] = null
    callback()
  }
}


/***/ }),

/***/ 87614:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


const { SymbolAsyncIterator, SymbolIterator, SymbolFor } = __webpack_require__(54136)

// We need to use SymbolFor to make these globally available
// for interopt with readable-stream, i.e. readable-stream
// and node core needs to be able to read/write private state
// from each other for proper interoperability.
const kIsDestroyed = SymbolFor('nodejs.stream.destroyed')
const kIsErrored = SymbolFor('nodejs.stream.errored')
const kIsReadable = SymbolFor('nodejs.stream.readable')
const kIsWritable = SymbolFor('nodejs.stream.writable')
const kIsDisturbed = SymbolFor('nodejs.stream.disturbed')
const kIsClosedPromise = SymbolFor('nodejs.webstream.isClosedPromise')
const kControllerErrorFunction = SymbolFor('nodejs.webstream.controllerErrorFunction')
function isReadableNodeStream(obj, strict = false) {
  var _obj$_readableState
  return !!(
    (
      obj &&
      typeof obj.pipe === 'function' &&
      typeof obj.on === 'function' &&
      (!strict || (typeof obj.pause === 'function' && typeof obj.resume === 'function')) &&
      (!obj._writableState ||
        ((_obj$_readableState = obj._readableState) === null || _obj$_readableState === undefined
          ? undefined
          : _obj$_readableState.readable) !== false) &&
      // Duplex
      (!obj._writableState || obj._readableState)
    ) // Writable has .pipe.
  )
}

function isWritableNodeStream(obj) {
  var _obj$_writableState
  return !!(
    (
      obj &&
      typeof obj.write === 'function' &&
      typeof obj.on === 'function' &&
      (!obj._readableState ||
        ((_obj$_writableState = obj._writableState) === null || _obj$_writableState === undefined
          ? undefined
          : _obj$_writableState.writable) !== false)
    ) // Duplex
  )
}

function isDuplexNodeStream(obj) {
  return !!(
    obj &&
    typeof obj.pipe === 'function' &&
    obj._readableState &&
    typeof obj.on === 'function' &&
    typeof obj.write === 'function'
  )
}
function isNodeStream(obj) {
  return (
    obj &&
    (obj._readableState ||
      obj._writableState ||
      (typeof obj.write === 'function' && typeof obj.on === 'function') ||
      (typeof obj.pipe === 'function' && typeof obj.on === 'function'))
  )
}
function isReadableStream(obj) {
  return !!(
    obj &&
    !isNodeStream(obj) &&
    typeof obj.pipeThrough === 'function' &&
    typeof obj.getReader === 'function' &&
    typeof obj.cancel === 'function'
  )
}
function isWritableStream(obj) {
  return !!(obj && !isNodeStream(obj) && typeof obj.getWriter === 'function' && typeof obj.abort === 'function')
}
function isTransformStream(obj) {
  return !!(obj && !isNodeStream(obj) && typeof obj.readable === 'object' && typeof obj.writable === 'object')
}
function isWebStream(obj) {
  return isReadableStream(obj) || isWritableStream(obj) || isTransformStream(obj)
}
function isIterable(obj, isAsync) {
  if (obj == null) return false
  if (isAsync === true) return typeof obj[SymbolAsyncIterator] === 'function'
  if (isAsync === false) return typeof obj[SymbolIterator] === 'function'
  return typeof obj[SymbolAsyncIterator] === 'function' || typeof obj[SymbolIterator] === 'function'
}
function isDestroyed(stream) {
  if (!isNodeStream(stream)) return null
  const wState = stream._writableState
  const rState = stream._readableState
  const state = wState || rState
  return !!(stream.destroyed || stream[kIsDestroyed] || (state !== null && state !== undefined && state.destroyed))
}

// Have been end():d.
function isWritableEnded(stream) {
  if (!isWritableNodeStream(stream)) return null
  if (stream.writableEnded === true) return true
  const wState = stream._writableState
  if (wState !== null && wState !== undefined && wState.errored) return false
  if (typeof (wState === null || wState === undefined ? undefined : wState.ended) !== 'boolean') return null
  return wState.ended
}

// Have emitted 'finish'.
function isWritableFinished(stream, strict) {
  if (!isWritableNodeStream(stream)) return null
  if (stream.writableFinished === true) return true
  const wState = stream._writableState
  if (wState !== null && wState !== undefined && wState.errored) return false
  if (typeof (wState === null || wState === undefined ? undefined : wState.finished) !== 'boolean') return null
  return !!(wState.finished || (strict === false && wState.ended === true && wState.length === 0))
}

// Have been push(null):d.
function isReadableEnded(stream) {
  if (!isReadableNodeStream(stream)) return null
  if (stream.readableEnded === true) return true
  const rState = stream._readableState
  if (!rState || rState.errored) return false
  if (typeof (rState === null || rState === undefined ? undefined : rState.ended) !== 'boolean') return null
  return rState.ended
}

// Have emitted 'end'.
function isReadableFinished(stream, strict) {
  if (!isReadableNodeStream(stream)) return null
  const rState = stream._readableState
  if (rState !== null && rState !== undefined && rState.errored) return false
  if (typeof (rState === null || rState === undefined ? undefined : rState.endEmitted) !== 'boolean') return null
  return !!(rState.endEmitted || (strict === false && rState.ended === true && rState.length === 0))
}
function isReadable(stream) {
  if (stream && stream[kIsReadable] != null) return stream[kIsReadable]
  if (typeof (stream === null || stream === undefined ? undefined : stream.readable) !== 'boolean') return null
  if (isDestroyed(stream)) return false
  return isReadableNodeStream(stream) && stream.readable && !isReadableFinished(stream)
}
function isWritable(stream) {
  if (stream && stream[kIsWritable] != null) return stream[kIsWritable]
  if (typeof (stream === null || stream === undefined ? undefined : stream.writable) !== 'boolean') return null
  if (isDestroyed(stream)) return false
  return isWritableNodeStream(stream) && stream.writable && !isWritableEnded(stream)
}
function isFinished(stream, opts) {
  if (!isNodeStream(stream)) {
    return null
  }
  if (isDestroyed(stream)) {
    return true
  }
  if ((opts === null || opts === undefined ? undefined : opts.readable) !== false && isReadable(stream)) {
    return false
  }
  if ((opts === null || opts === undefined ? undefined : opts.writable) !== false && isWritable(stream)) {
    return false
  }
  return true
}
function isWritableErrored(stream) {
  var _stream$_writableStat, _stream$_writableStat2
  if (!isNodeStream(stream)) {
    return null
  }
  if (stream.writableErrored) {
    return stream.writableErrored
  }
  return (_stream$_writableStat =
    (_stream$_writableStat2 = stream._writableState) === null || _stream$_writableStat2 === undefined
      ? undefined
      : _stream$_writableStat2.errored) !== null && _stream$_writableStat !== undefined
    ? _stream$_writableStat
    : null
}
function isReadableErrored(stream) {
  var _stream$_readableStat, _stream$_readableStat2
  if (!isNodeStream(stream)) {
    return null
  }
  if (stream.readableErrored) {
    return stream.readableErrored
  }
  return (_stream$_readableStat =
    (_stream$_readableStat2 = stream._readableState) === null || _stream$_readableStat2 === undefined
      ? undefined
      : _stream$_readableStat2.errored) !== null && _stream$_readableStat !== undefined
    ? _stream$_readableStat
    : null
}
function isClosed(stream) {
  if (!isNodeStream(stream)) {
    return null
  }
  if (typeof stream.closed === 'boolean') {
    return stream.closed
  }
  const wState = stream._writableState
  const rState = stream._readableState
  if (
    typeof (wState === null || wState === undefined ? undefined : wState.closed) === 'boolean' ||
    typeof (rState === null || rState === undefined ? undefined : rState.closed) === 'boolean'
  ) {
    return (
      (wState === null || wState === undefined ? undefined : wState.closed) ||
      (rState === null || rState === undefined ? undefined : rState.closed)
    )
  }
  if (typeof stream._closed === 'boolean' && isOutgoingMessage(stream)) {
    return stream._closed
  }
  return null
}
function isOutgoingMessage(stream) {
  return (
    typeof stream._closed === 'boolean' &&
    typeof stream._defaultKeepAlive === 'boolean' &&
    typeof stream._removedConnection === 'boolean' &&
    typeof stream._removedContLen === 'boolean'
  )
}
function isServerResponse(stream) {
  return typeof stream._sent100 === 'boolean' && isOutgoingMessage(stream)
}
function isServerRequest(stream) {
  var _stream$req
  return (
    typeof stream._consuming === 'boolean' &&
    typeof stream._dumped === 'boolean' &&
    ((_stream$req = stream.req) === null || _stream$req === undefined ? undefined : _stream$req.upgradeOrConnect) ===
      undefined
  )
}
function willEmitClose(stream) {
  if (!isNodeStream(stream)) return null
  const wState = stream._writableState
  const rState = stream._readableState
  const state = wState || rState
  return (
    (!state && isServerResponse(stream)) || !!(state && state.autoDestroy && state.emitClose && state.closed === false)
  )
}
function isDisturbed(stream) {
  var _stream$kIsDisturbed
  return !!(
    stream &&
    ((_stream$kIsDisturbed = stream[kIsDisturbed]) !== null && _stream$kIsDisturbed !== undefined
      ? _stream$kIsDisturbed
      : stream.readableDidRead || stream.readableAborted)
  )
}
function isErrored(stream) {
  var _ref,
    _ref2,
    _ref3,
    _ref4,
    _ref5,
    _stream$kIsErrored,
    _stream$_readableStat3,
    _stream$_writableStat3,
    _stream$_readableStat4,
    _stream$_writableStat4
  return !!(
    stream &&
    ((_ref =
      (_ref2 =
        (_ref3 =
          (_ref4 =
            (_ref5 =
              (_stream$kIsErrored = stream[kIsErrored]) !== null && _stream$kIsErrored !== undefined
                ? _stream$kIsErrored
                : stream.readableErrored) !== null && _ref5 !== undefined
              ? _ref5
              : stream.writableErrored) !== null && _ref4 !== undefined
            ? _ref4
            : (_stream$_readableStat3 = stream._readableState) === null || _stream$_readableStat3 === undefined
            ? undefined
            : _stream$_readableStat3.errorEmitted) !== null && _ref3 !== undefined
          ? _ref3
          : (_stream$_writableStat3 = stream._writableState) === null || _stream$_writableStat3 === undefined
          ? undefined
          : _stream$_writableStat3.errorEmitted) !== null && _ref2 !== undefined
        ? _ref2
        : (_stream$_readableStat4 = stream._readableState) === null || _stream$_readableStat4 === undefined
        ? undefined
        : _stream$_readableStat4.errored) !== null && _ref !== undefined
      ? _ref
      : (_stream$_writableStat4 = stream._writableState) === null || _stream$_writableStat4 === undefined
      ? undefined
      : _stream$_writableStat4.errored)
  )
}
module.exports = {
  isDestroyed,
  kIsDestroyed,
  isDisturbed,
  kIsDisturbed,
  isErrored,
  kIsErrored,
  isReadable,
  kIsReadable,
  kIsClosedPromise,
  kControllerErrorFunction,
  kIsWritable,
  isClosed,
  isDuplexNodeStream,
  isFinished,
  isIterable,
  isReadableNodeStream,
  isReadableStream,
  isReadableEnded,
  isReadableFinished,
  isReadableErrored,
  isNodeStream,
  isWebStream,
  isWritable,
  isWritableNodeStream,
  isWritableStream,
  isWritableEnded,
  isWritableFinished,
  isWritableErrored,
  isServerRequest,
  isServerResponse,
  willEmitClose,
  isTransformStream
}


/***/ }),

/***/ 26336:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/* replacement start */

const process = __webpack_require__(14224)

/* replacement end */
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// A bit simpler than readable streams.
// Implement an async ._write(chunk, encoding, cb), and it'll handle all
// the drain event emission and buffering.

;('use strict')
const {
  ArrayPrototypeSlice,
  Error,
  FunctionPrototypeSymbolHasInstance,
  ObjectDefineProperty,
  ObjectDefineProperties,
  ObjectSetPrototypeOf,
  StringPrototypeToLowerCase,
  Symbol,
  SymbolHasInstance
} = __webpack_require__(54136)
module.exports = Writable
Writable.WritableState = WritableState
const { EventEmitter: EE } = __webpack_require__(72100)
const Stream = (__webpack_require__(23472).Stream)
const { Buffer } = __webpack_require__(55872)
const destroyImpl = __webpack_require__(35441)
const { addAbortSignal } = __webpack_require__(47287)
const { getHighWaterMark, getDefaultHighWaterMark } = __webpack_require__(17279)
const {
  ERR_INVALID_ARG_TYPE,
  ERR_METHOD_NOT_IMPLEMENTED,
  ERR_MULTIPLE_CALLBACK,
  ERR_STREAM_CANNOT_PIPE,
  ERR_STREAM_DESTROYED,
  ERR_STREAM_ALREADY_FINISHED,
  ERR_STREAM_NULL_VALUES,
  ERR_STREAM_WRITE_AFTER_END,
  ERR_UNKNOWN_ENCODING
} = (__webpack_require__(91198).codes)
const { errorOrDestroy } = destroyImpl
ObjectSetPrototypeOf(Writable.prototype, Stream.prototype)
ObjectSetPrototypeOf(Writable, Stream)
function nop() {}
const kOnFinished = Symbol('kOnFinished')
function WritableState(options, stream, isDuplex) {
  // Duplex streams are both readable and writable, but share
  // the same options object.
  // However, some cases require setting options to different
  // values for the readable and the writable sides of the duplex stream,
  // e.g. options.readableObjectMode vs. options.writableObjectMode, etc.
  if (typeof isDuplex !== 'boolean') isDuplex = stream instanceof __webpack_require__(66695)

  // Object stream flag to indicate whether or not this stream
  // contains buffers or objects.
  this.objectMode = !!(options && options.objectMode)
  if (isDuplex) this.objectMode = this.objectMode || !!(options && options.writableObjectMode)

  // The point at which write() starts returning false
  // Note: 0 is a valid value, means that we always return false if
  // the entire buffer is not flushed immediately on write().
  this.highWaterMark = options
    ? getHighWaterMark(this, options, 'writableHighWaterMark', isDuplex)
    : getDefaultHighWaterMark(false)

  // if _final has been called.
  this.finalCalled = false

  // drain event flag.
  this.needDrain = false
  // At the start of calling end()
  this.ending = false
  // When end() has been called, and returned.
  this.ended = false
  // When 'finish' is emitted.
  this.finished = false

  // Has it been destroyed
  this.destroyed = false

  // Should we decode strings into buffers before passing to _write?
  // this is here so that some node-core streams can optimize string
  // handling at a lower level.
  const noDecode = !!(options && options.decodeStrings === false)
  this.decodeStrings = !noDecode

  // Crypto is kind of old and crusty.  Historically, its default string
  // encoding is 'binary' so we have to make this configurable.
  // Everything else in the universe uses 'utf8', though.
  this.defaultEncoding = (options && options.defaultEncoding) || 'utf8'

  // Not an actual buffer we keep track of, but a measurement
  // of how much we're waiting to get pushed to some underlying
  // socket or file.
  this.length = 0

  // A flag to see when we're in the middle of a write.
  this.writing = false

  // When true all writes will be buffered until .uncork() call.
  this.corked = 0

  // A flag to be able to tell if the onwrite cb is called immediately,
  // or on a later tick.  We set this to true at first, because any
  // actions that shouldn't happen until "later" should generally also
  // not happen before the first write call.
  this.sync = true

  // A flag to know if we're processing previously buffered items, which
  // may call the _write() callback in the same tick, so that we don't
  // end up in an overlapped onwrite situation.
  this.bufferProcessing = false

  // The callback that's passed to _write(chunk, cb).
  this.onwrite = onwrite.bind(undefined, stream)

  // The callback that the user supplies to write(chunk, encoding, cb).
  this.writecb = null

  // The amount that is being written when _write is called.
  this.writelen = 0

  // Storage for data passed to the afterWrite() callback in case of
  // synchronous _write() completion.
  this.afterWriteTickInfo = null
  resetBuffer(this)

  // Number of pending user-supplied write callbacks
  // this must be 0 before 'finish' can be emitted.
  this.pendingcb = 0

  // Stream is still being constructed and cannot be
  // destroyed until construction finished or failed.
  // Async construction is opt in, therefore we start as
  // constructed.
  this.constructed = true

  // Emit prefinish if the only thing we're waiting for is _write cbs
  // This is relevant for synchronous Transform streams.
  this.prefinished = false

  // True if the error was already emitted and should not be thrown again.
  this.errorEmitted = false

  // Should close be emitted on destroy. Defaults to true.
  this.emitClose = !options || options.emitClose !== false

  // Should .destroy() be called after 'finish' (and potentially 'end').
  this.autoDestroy = !options || options.autoDestroy !== false

  // Indicates whether the stream has errored. When true all write() calls
  // should return false. This is needed since when autoDestroy
  // is disabled we need a way to tell whether the stream has failed.
  this.errored = null

  // Indicates whether the stream has finished destroying.
  this.closed = false

  // True if close has been emitted or would have been emitted
  // depending on emitClose.
  this.closeEmitted = false
  this[kOnFinished] = []
}
function resetBuffer(state) {
  state.buffered = []
  state.bufferedIndex = 0
  state.allBuffers = true
  state.allNoop = true
}
WritableState.prototype.getBuffer = function getBuffer() {
  return ArrayPrototypeSlice(this.buffered, this.bufferedIndex)
}
ObjectDefineProperty(WritableState.prototype, 'bufferedRequestCount', {
  __proto__: null,
  get() {
    return this.buffered.length - this.bufferedIndex
  }
})
function Writable(options) {
  // Writable ctor is applied to Duplexes, too.
  // `realHasInstance` is necessary because using plain `instanceof`
  // would return false, as no `_writableState` property is attached.

  // Trying to use the custom `instanceof` for Writable here will also break the
  // Node.js LazyTransform implementation, which has a non-trivial getter for
  // `_writableState` that would lead to infinite recursion.

  // Checking for a Stream.Duplex instance is faster here instead of inside
  // the WritableState constructor, at least with V8 6.5.
  const isDuplex = this instanceof __webpack_require__(66695)
  if (!isDuplex && !FunctionPrototypeSymbolHasInstance(Writable, this)) return new Writable(options)
  this._writableState = new WritableState(options, this, isDuplex)
  if (options) {
    if (typeof options.write === 'function') this._write = options.write
    if (typeof options.writev === 'function') this._writev = options.writev
    if (typeof options.destroy === 'function') this._destroy = options.destroy
    if (typeof options.final === 'function') this._final = options.final
    if (typeof options.construct === 'function') this._construct = options.construct
    if (options.signal) addAbortSignal(options.signal, this)
  }
  Stream.call(this, options)
  destroyImpl.construct(this, () => {
    const state = this._writableState
    if (!state.writing) {
      clearBuffer(this, state)
    }
    finishMaybe(this, state)
  })
}
ObjectDefineProperty(Writable, SymbolHasInstance, {
  __proto__: null,
  value: function (object) {
    if (FunctionPrototypeSymbolHasInstance(this, object)) return true
    if (this !== Writable) return false
    return object && object._writableState instanceof WritableState
  }
})

// Otherwise people can pipe Writable streams, which is just wrong.
Writable.prototype.pipe = function () {
  errorOrDestroy(this, new ERR_STREAM_CANNOT_PIPE())
}
function _write(stream, chunk, encoding, cb) {
  const state = stream._writableState
  if (typeof encoding === 'function') {
    cb = encoding
    encoding = state.defaultEncoding
  } else {
    if (!encoding) encoding = state.defaultEncoding
    else if (encoding !== 'buffer' && !Buffer.isEncoding(encoding)) throw new ERR_UNKNOWN_ENCODING(encoding)
    if (typeof cb !== 'function') cb = nop
  }
  if (chunk === null) {
    throw new ERR_STREAM_NULL_VALUES()
  } else if (!state.objectMode) {
    if (typeof chunk === 'string') {
      if (state.decodeStrings !== false) {
        chunk = Buffer.from(chunk, encoding)
        encoding = 'buffer'
      }
    } else if (chunk instanceof Buffer) {
      encoding = 'buffer'
    } else if (Stream._isUint8Array(chunk)) {
      chunk = Stream._uint8ArrayToBuffer(chunk)
      encoding = 'buffer'
    } else {
      throw new ERR_INVALID_ARG_TYPE('chunk', ['string', 'Buffer', 'Uint8Array'], chunk)
    }
  }
  let err
  if (state.ending) {
    err = new ERR_STREAM_WRITE_AFTER_END()
  } else if (state.destroyed) {
    err = new ERR_STREAM_DESTROYED('write')
  }
  if (err) {
    process.nextTick(cb, err)
    errorOrDestroy(stream, err, true)
    return err
  }
  state.pendingcb++
  return writeOrBuffer(stream, state, chunk, encoding, cb)
}
Writable.prototype.write = function (chunk, encoding, cb) {
  return _write(this, chunk, encoding, cb) === true
}
Writable.prototype.cork = function () {
  this._writableState.corked++
}
Writable.prototype.uncork = function () {
  const state = this._writableState
  if (state.corked) {
    state.corked--
    if (!state.writing) clearBuffer(this, state)
  }
}
Writable.prototype.setDefaultEncoding = function setDefaultEncoding(encoding) {
  // node::ParseEncoding() requires lower case.
  if (typeof encoding === 'string') encoding = StringPrototypeToLowerCase(encoding)
  if (!Buffer.isEncoding(encoding)) throw new ERR_UNKNOWN_ENCODING(encoding)
  this._writableState.defaultEncoding = encoding
  return this
}

// If we're already writing something, then just put this
// in the queue, and wait our turn.  Otherwise, call _write
// If we return false, then we need a drain event, so set that flag.
function writeOrBuffer(stream, state, chunk, encoding, callback) {
  const len = state.objectMode ? 1 : chunk.length
  state.length += len

  // stream._write resets state.length
  const ret = state.length < state.highWaterMark
  // We must ensure that previous needDrain will not be reset to false.
  if (!ret) state.needDrain = true
  if (state.writing || state.corked || state.errored || !state.constructed) {
    state.buffered.push({
      chunk,
      encoding,
      callback
    })
    if (state.allBuffers && encoding !== 'buffer') {
      state.allBuffers = false
    }
    if (state.allNoop && callback !== nop) {
      state.allNoop = false
    }
  } else {
    state.writelen = len
    state.writecb = callback
    state.writing = true
    state.sync = true
    stream._write(chunk, encoding, state.onwrite)
    state.sync = false
  }

  // Return false if errored or destroyed in order to break
  // any synchronous while(stream.write(data)) loops.
  return ret && !state.errored && !state.destroyed
}
function doWrite(stream, state, writev, len, chunk, encoding, cb) {
  state.writelen = len
  state.writecb = cb
  state.writing = true
  state.sync = true
  if (state.destroyed) state.onwrite(new ERR_STREAM_DESTROYED('write'))
  else if (writev) stream._writev(chunk, state.onwrite)
  else stream._write(chunk, encoding, state.onwrite)
  state.sync = false
}
function onwriteError(stream, state, er, cb) {
  --state.pendingcb
  cb(er)
  // Ensure callbacks are invoked even when autoDestroy is
  // not enabled. Passing `er` here doesn't make sense since
  // it's related to one specific write, not to the buffered
  // writes.
  errorBuffer(state)
  // This can emit error, but error must always follow cb.
  errorOrDestroy(stream, er)
}
function onwrite(stream, er) {
  const state = stream._writableState
  const sync = state.sync
  const cb = state.writecb
  if (typeof cb !== 'function') {
    errorOrDestroy(stream, new ERR_MULTIPLE_CALLBACK())
    return
  }
  state.writing = false
  state.writecb = null
  state.length -= state.writelen
  state.writelen = 0
  if (er) {
    // Avoid V8 leak, https://github.com/nodejs/node/pull/34103#issuecomment-652002364
    er.stack // eslint-disable-line no-unused-expressions

    if (!state.errored) {
      state.errored = er
    }

    // In case of duplex streams we need to notify the readable side of the
    // error.
    if (stream._readableState && !stream._readableState.errored) {
      stream._readableState.errored = er
    }
    if (sync) {
      process.nextTick(onwriteError, stream, state, er, cb)
    } else {
      onwriteError(stream, state, er, cb)
    }
  } else {
    if (state.buffered.length > state.bufferedIndex) {
      clearBuffer(stream, state)
    }
    if (sync) {
      // It is a common case that the callback passed to .write() is always
      // the same. In that case, we do not schedule a new nextTick(), but
      // rather just increase a counter, to improve performance and avoid
      // memory allocations.
      if (state.afterWriteTickInfo !== null && state.afterWriteTickInfo.cb === cb) {
        state.afterWriteTickInfo.count++
      } else {
        state.afterWriteTickInfo = {
          count: 1,
          cb,
          stream,
          state
        }
        process.nextTick(afterWriteTick, state.afterWriteTickInfo)
      }
    } else {
      afterWrite(stream, state, 1, cb)
    }
  }
}
function afterWriteTick({ stream, state, count, cb }) {
  state.afterWriteTickInfo = null
  return afterWrite(stream, state, count, cb)
}
function afterWrite(stream, state, count, cb) {
  const needDrain = !state.ending && !stream.destroyed && state.length === 0 && state.needDrain
  if (needDrain) {
    state.needDrain = false
    stream.emit('drain')
  }
  while (count-- > 0) {
    state.pendingcb--
    cb()
  }
  if (state.destroyed) {
    errorBuffer(state)
  }
  finishMaybe(stream, state)
}

// If there's something in the buffer waiting, then invoke callbacks.
function errorBuffer(state) {
  if (state.writing) {
    return
  }
  for (let n = state.bufferedIndex; n < state.buffered.length; ++n) {
    var _state$errored
    const { chunk, callback } = state.buffered[n]
    const len = state.objectMode ? 1 : chunk.length
    state.length -= len
    callback(
      (_state$errored = state.errored) !== null && _state$errored !== undefined
        ? _state$errored
        : new ERR_STREAM_DESTROYED('write')
    )
  }
  const onfinishCallbacks = state[kOnFinished].splice(0)
  for (let i = 0; i < onfinishCallbacks.length; i++) {
    var _state$errored2
    onfinishCallbacks[i](
      (_state$errored2 = state.errored) !== null && _state$errored2 !== undefined
        ? _state$errored2
        : new ERR_STREAM_DESTROYED('end')
    )
  }
  resetBuffer(state)
}

// If there's something in the buffer waiting, then process it.
function clearBuffer(stream, state) {
  if (state.corked || state.bufferProcessing || state.destroyed || !state.constructed) {
    return
  }
  const { buffered, bufferedIndex, objectMode } = state
  const bufferedLength = buffered.length - bufferedIndex
  if (!bufferedLength) {
    return
  }
  let i = bufferedIndex
  state.bufferProcessing = true
  if (bufferedLength > 1 && stream._writev) {
    state.pendingcb -= bufferedLength - 1
    const callback = state.allNoop
      ? nop
      : (err) => {
          for (let n = i; n < buffered.length; ++n) {
            buffered[n].callback(err)
          }
        }
    // Make a copy of `buffered` if it's going to be used by `callback` above,
    // since `doWrite` will mutate the array.
    const chunks = state.allNoop && i === 0 ? buffered : ArrayPrototypeSlice(buffered, i)
    chunks.allBuffers = state.allBuffers
    doWrite(stream, state, true, state.length, chunks, '', callback)
    resetBuffer(state)
  } else {
    do {
      const { chunk, encoding, callback } = buffered[i]
      buffered[i++] = null
      const len = objectMode ? 1 : chunk.length
      doWrite(stream, state, false, len, chunk, encoding, callback)
    } while (i < buffered.length && !state.writing)
    if (i === buffered.length) {
      resetBuffer(state)
    } else if (i > 256) {
      buffered.splice(0, i)
      state.bufferedIndex = 0
    } else {
      state.bufferedIndex = i
    }
  }
  state.bufferProcessing = false
}
Writable.prototype._write = function (chunk, encoding, cb) {
  if (this._writev) {
    this._writev(
      [
        {
          chunk,
          encoding
        }
      ],
      cb
    )
  } else {
    throw new ERR_METHOD_NOT_IMPLEMENTED('_write()')
  }
}
Writable.prototype._writev = null
Writable.prototype.end = function (chunk, encoding, cb) {
  const state = this._writableState
  if (typeof chunk === 'function') {
    cb = chunk
    chunk = null
    encoding = null
  } else if (typeof encoding === 'function') {
    cb = encoding
    encoding = null
  }
  let err
  if (chunk !== null && chunk !== undefined) {
    const ret = _write(this, chunk, encoding)
    if (ret instanceof Error) {
      err = ret
    }
  }

  // .end() fully uncorks.
  if (state.corked) {
    state.corked = 1
    this.uncork()
  }
  if (err) {
    // Do nothing...
  } else if (!state.errored && !state.ending) {
    // This is forgiving in terms of unnecessary calls to end() and can hide
    // logic errors. However, usually such errors are harmless and causing a
    // hard error can be disproportionately destructive. It is not always
    // trivial for the user to determine whether end() needs to be called
    // or not.

    state.ending = true
    finishMaybe(this, state, true)
    state.ended = true
  } else if (state.finished) {
    err = new ERR_STREAM_ALREADY_FINISHED('end')
  } else if (state.destroyed) {
    err = new ERR_STREAM_DESTROYED('end')
  }
  if (typeof cb === 'function') {
    if (err || state.finished) {
      process.nextTick(cb, err)
    } else {
      state[kOnFinished].push(cb)
    }
  }
  return this
}
function needFinish(state) {
  return (
    state.ending &&
    !state.destroyed &&
    state.constructed &&
    state.length === 0 &&
    !state.errored &&
    state.buffered.length === 0 &&
    !state.finished &&
    !state.writing &&
    !state.errorEmitted &&
    !state.closeEmitted
  )
}
function callFinal(stream, state) {
  let called = false
  function onFinish(err) {
    if (called) {
      errorOrDestroy(stream, err !== null && err !== undefined ? err : ERR_MULTIPLE_CALLBACK())
      return
    }
    called = true
    state.pendingcb--
    if (err) {
      const onfinishCallbacks = state[kOnFinished].splice(0)
      for (let i = 0; i < onfinishCallbacks.length; i++) {
        onfinishCallbacks[i](err)
      }
      errorOrDestroy(stream, err, state.sync)
    } else if (needFinish(state)) {
      state.prefinished = true
      stream.emit('prefinish')
      // Backwards compat. Don't check state.sync here.
      // Some streams assume 'finish' will be emitted
      // asynchronously relative to _final callback.
      state.pendingcb++
      process.nextTick(finish, stream, state)
    }
  }
  state.sync = true
  state.pendingcb++
  try {
    stream._final(onFinish)
  } catch (err) {
    onFinish(err)
  }
  state.sync = false
}
function prefinish(stream, state) {
  if (!state.prefinished && !state.finalCalled) {
    if (typeof stream._final === 'function' && !state.destroyed) {
      state.finalCalled = true
      callFinal(stream, state)
    } else {
      state.prefinished = true
      stream.emit('prefinish')
    }
  }
}
function finishMaybe(stream, state, sync) {
  if (needFinish(state)) {
    prefinish(stream, state)
    if (state.pendingcb === 0) {
      if (sync) {
        state.pendingcb++
        process.nextTick(
          (stream, state) => {
            if (needFinish(state)) {
              finish(stream, state)
            } else {
              state.pendingcb--
            }
          },
          stream,
          state
        )
      } else if (needFinish(state)) {
        state.pendingcb++
        finish(stream, state)
      }
    }
  }
}
function finish(stream, state) {
  state.pendingcb--
  state.finished = true
  const onfinishCallbacks = state[kOnFinished].splice(0)
  for (let i = 0; i < onfinishCallbacks.length; i++) {
    onfinishCallbacks[i]()
  }
  stream.emit('finish')
  if (state.autoDestroy) {
    // In case of duplex streams we need a way to detect
    // if the readable side is ready for autoDestroy as well.
    const rState = stream._readableState
    const autoDestroy =
      !rState ||
      (rState.autoDestroy &&
        // We don't expect the readable to ever 'end'
        // if readable is explicitly set to false.
        (rState.endEmitted || rState.readable === false))
    if (autoDestroy) {
      stream.destroy()
    }
  }
}
ObjectDefineProperties(Writable.prototype, {
  closed: {
    __proto__: null,
    get() {
      return this._writableState ? this._writableState.closed : false
    }
  },
  destroyed: {
    __proto__: null,
    get() {
      return this._writableState ? this._writableState.destroyed : false
    },
    set(value) {
      // Backward compatibility, the user is explicitly managing destroyed.
      if (this._writableState) {
        this._writableState.destroyed = value
      }
    }
  },
  writable: {
    __proto__: null,
    get() {
      const w = this._writableState
      // w.writable === false means that this is part of a Duplex stream
      // where the writable side was disabled upon construction.
      // Compat. The user might manually disable writable side through
      // deprecated setter.
      return !!w && w.writable !== false && !w.destroyed && !w.errored && !w.ending && !w.ended
    },
    set(val) {
      // Backwards compatible.
      if (this._writableState) {
        this._writableState.writable = !!val
      }
    }
  },
  writableFinished: {
    __proto__: null,
    get() {
      return this._writableState ? this._writableState.finished : false
    }
  },
  writableObjectMode: {
    __proto__: null,
    get() {
      return this._writableState ? this._writableState.objectMode : false
    }
  },
  writableBuffer: {
    __proto__: null,
    get() {
      return this._writableState && this._writableState.getBuffer()
    }
  },
  writableEnded: {
    __proto__: null,
    get() {
      return this._writableState ? this._writableState.ending : false
    }
  },
  writableNeedDrain: {
    __proto__: null,
    get() {
      const wState = this._writableState
      if (!wState) return false
      return !wState.destroyed && !wState.ending && wState.needDrain
    }
  },
  writableHighWaterMark: {
    __proto__: null,
    get() {
      return this._writableState && this._writableState.highWaterMark
    }
  },
  writableCorked: {
    __proto__: null,
    get() {
      return this._writableState ? this._writableState.corked : 0
    }
  },
  writableLength: {
    __proto__: null,
    get() {
      return this._writableState && this._writableState.length
    }
  },
  errored: {
    __proto__: null,
    enumerable: false,
    get() {
      return this._writableState ? this._writableState.errored : null
    }
  },
  writableAborted: {
    __proto__: null,
    enumerable: false,
    get: function () {
      return !!(
        this._writableState.writable !== false &&
        (this._writableState.destroyed || this._writableState.errored) &&
        !this._writableState.finished
      )
    }
  }
})
const destroy = destroyImpl.destroy
Writable.prototype.destroy = function (err, cb) {
  const state = this._writableState

  // Invoke pending callbacks.
  if (!state.destroyed && (state.bufferedIndex < state.buffered.length || state[kOnFinished].length)) {
    process.nextTick(errorBuffer, state)
  }
  destroy.call(this, err, cb)
  return this
}
Writable.prototype._undestroy = destroyImpl.undestroy
Writable.prototype._destroy = function (err, cb) {
  cb(err)
}
Writable.prototype[EE.captureRejectionSymbol] = function (err) {
  this.destroy(err)
}
let webStreamsAdapters

// Lazy to avoid circular references
function lazyWebStreams() {
  if (webStreamsAdapters === undefined) webStreamsAdapters = {}
  return webStreamsAdapters
}
Writable.fromWeb = function (writableStream, options) {
  return lazyWebStreams().newStreamWritableFromWritableStream(writableStream, options)
}
Writable.toWeb = function (streamWritable) {
  return lazyWebStreams().newWritableStreamFromStreamWritable(streamWritable)
}


/***/ }),

/***/ 1712:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
/* eslint jsdoc/require-jsdoc: "error" */



const {
  ArrayIsArray,
  ArrayPrototypeIncludes,
  ArrayPrototypeJoin,
  ArrayPrototypeMap,
  NumberIsInteger,
  NumberIsNaN,
  NumberMAX_SAFE_INTEGER,
  NumberMIN_SAFE_INTEGER,
  NumberParseInt,
  ObjectPrototypeHasOwnProperty,
  RegExpPrototypeExec,
  String,
  StringPrototypeToUpperCase,
  StringPrototypeTrim
} = __webpack_require__(54136)
const {
  hideStackFrames,
  codes: { ERR_SOCKET_BAD_PORT, ERR_INVALID_ARG_TYPE, ERR_INVALID_ARG_VALUE, ERR_OUT_OF_RANGE, ERR_UNKNOWN_SIGNAL }
} = __webpack_require__(91198)
const { normalizeEncoding } = __webpack_require__(89349)
const { isAsyncFunction, isArrayBufferView } = (__webpack_require__(89349).types)
const signals = {}

/**
 * @param {*} value
 * @returns {boolean}
 */
function isInt32(value) {
  return value === (value | 0)
}

/**
 * @param {*} value
 * @returns {boolean}
 */
function isUint32(value) {
  return value === value >>> 0
}
const octalReg = /^[0-7]+$/
const modeDesc = 'must be a 32-bit unsigned integer or an octal string'

/**
 * Parse and validate values that will be converted into mode_t (the S_*
 * constants). Only valid numbers and octal strings are allowed. They could be
 * converted to 32-bit unsigned integers or non-negative signed integers in the
 * C++ land, but any value higher than 0o777 will result in platform-specific
 * behaviors.
 * @param {*} value Values to be validated
 * @param {string} name Name of the argument
 * @param {number} [def] If specified, will be returned for invalid values
 * @returns {number}
 */
function parseFileMode(value, name, def) {
  if (typeof value === 'undefined') {
    value = def
  }
  if (typeof value === 'string') {
    if (RegExpPrototypeExec(octalReg, value) === null) {
      throw new ERR_INVALID_ARG_VALUE(name, value, modeDesc)
    }
    value = NumberParseInt(value, 8)
  }
  validateUint32(value, name)
  return value
}

/**
 * @callback validateInteger
 * @param {*} value
 * @param {string} name
 * @param {number} [min]
 * @param {number} [max]
 * @returns {asserts value is number}
 */

/** @type {validateInteger} */
const validateInteger = hideStackFrames((value, name, min = NumberMIN_SAFE_INTEGER, max = NumberMAX_SAFE_INTEGER) => {
  if (typeof value !== 'number') throw new ERR_INVALID_ARG_TYPE(name, 'number', value)
  if (!NumberIsInteger(value)) throw new ERR_OUT_OF_RANGE(name, 'an integer', value)
  if (value < min || value > max) throw new ERR_OUT_OF_RANGE(name, `>= ${min} && <= ${max}`, value)
})

/**
 * @callback validateInt32
 * @param {*} value
 * @param {string} name
 * @param {number} [min]
 * @param {number} [max]
 * @returns {asserts value is number}
 */

/** @type {validateInt32} */
const validateInt32 = hideStackFrames((value, name, min = -2147483648, max = 2147483647) => {
  // The defaults for min and max correspond to the limits of 32-bit integers.
  if (typeof value !== 'number') {
    throw new ERR_INVALID_ARG_TYPE(name, 'number', value)
  }
  if (!NumberIsInteger(value)) {
    throw new ERR_OUT_OF_RANGE(name, 'an integer', value)
  }
  if (value < min || value > max) {
    throw new ERR_OUT_OF_RANGE(name, `>= ${min} && <= ${max}`, value)
  }
})

/**
 * @callback validateUint32
 * @param {*} value
 * @param {string} name
 * @param {number|boolean} [positive=false]
 * @returns {asserts value is number}
 */

/** @type {validateUint32} */
const validateUint32 = hideStackFrames((value, name, positive = false) => {
  if (typeof value !== 'number') {
    throw new ERR_INVALID_ARG_TYPE(name, 'number', value)
  }
  if (!NumberIsInteger(value)) {
    throw new ERR_OUT_OF_RANGE(name, 'an integer', value)
  }
  const min = positive ? 1 : 0
  // 2 ** 32 === 4294967296
  const max = 4294967295
  if (value < min || value > max) {
    throw new ERR_OUT_OF_RANGE(name, `>= ${min} && <= ${max}`, value)
  }
})

/**
 * @callback validateString
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is string}
 */

/** @type {validateString} */
function validateString(value, name) {
  if (typeof value !== 'string') throw new ERR_INVALID_ARG_TYPE(name, 'string', value)
}

/**
 * @callback validateNumber
 * @param {*} value
 * @param {string} name
 * @param {number} [min]
 * @param {number} [max]
 * @returns {asserts value is number}
 */

/** @type {validateNumber} */
function validateNumber(value, name, min = undefined, max) {
  if (typeof value !== 'number') throw new ERR_INVALID_ARG_TYPE(name, 'number', value)
  if (
    (min != null && value < min) ||
    (max != null && value > max) ||
    ((min != null || max != null) && NumberIsNaN(value))
  ) {
    throw new ERR_OUT_OF_RANGE(
      name,
      `${min != null ? `>= ${min}` : ''}${min != null && max != null ? ' && ' : ''}${max != null ? `<= ${max}` : ''}`,
      value
    )
  }
}

/**
 * @callback validateOneOf
 * @template T
 * @param {T} value
 * @param {string} name
 * @param {T[]} oneOf
 */

/** @type {validateOneOf} */
const validateOneOf = hideStackFrames((value, name, oneOf) => {
  if (!ArrayPrototypeIncludes(oneOf, value)) {
    const allowed = ArrayPrototypeJoin(
      ArrayPrototypeMap(oneOf, (v) => (typeof v === 'string' ? `'${v}'` : String(v))),
      ', '
    )
    const reason = 'must be one of: ' + allowed
    throw new ERR_INVALID_ARG_VALUE(name, value, reason)
  }
})

/**
 * @callback validateBoolean
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is boolean}
 */

/** @type {validateBoolean} */
function validateBoolean(value, name) {
  if (typeof value !== 'boolean') throw new ERR_INVALID_ARG_TYPE(name, 'boolean', value)
}

/**
 * @param {any} options
 * @param {string} key
 * @param {boolean} defaultValue
 * @returns {boolean}
 */
function getOwnPropertyValueOrDefault(options, key, defaultValue) {
  return options == null || !ObjectPrototypeHasOwnProperty(options, key) ? defaultValue : options[key]
}

/**
 * @callback validateObject
 * @param {*} value
 * @param {string} name
 * @param {{
 *   allowArray?: boolean,
 *   allowFunction?: boolean,
 *   nullable?: boolean
 * }} [options]
 */

/** @type {validateObject} */
const validateObject = hideStackFrames((value, name, options = null) => {
  const allowArray = getOwnPropertyValueOrDefault(options, 'allowArray', false)
  const allowFunction = getOwnPropertyValueOrDefault(options, 'allowFunction', false)
  const nullable = getOwnPropertyValueOrDefault(options, 'nullable', false)
  if (
    (!nullable && value === null) ||
    (!allowArray && ArrayIsArray(value)) ||
    (typeof value !== 'object' && (!allowFunction || typeof value !== 'function'))
  ) {
    throw new ERR_INVALID_ARG_TYPE(name, 'Object', value)
  }
})

/**
 * @callback validateDictionary - We are using the Web IDL Standard definition
 *                                of "dictionary" here, which means any value
 *                                whose Type is either Undefined, Null, or
 *                                Object (which includes functions).
 * @param {*} value
 * @param {string} name
 * @see https://webidl.spec.whatwg.org/#es-dictionary
 * @see https://tc39.es/ecma262/#table-typeof-operator-results
 */

/** @type {validateDictionary} */
const validateDictionary = hideStackFrames((value, name) => {
  if (value != null && typeof value !== 'object' && typeof value !== 'function') {
    throw new ERR_INVALID_ARG_TYPE(name, 'a dictionary', value)
  }
})

/**
 * @callback validateArray
 * @param {*} value
 * @param {string} name
 * @param {number} [minLength]
 * @returns {asserts value is any[]}
 */

/** @type {validateArray} */
const validateArray = hideStackFrames((value, name, minLength = 0) => {
  if (!ArrayIsArray(value)) {
    throw new ERR_INVALID_ARG_TYPE(name, 'Array', value)
  }
  if (value.length < minLength) {
    const reason = `must be longer than ${minLength}`
    throw new ERR_INVALID_ARG_VALUE(name, value, reason)
  }
})

/**
 * @callback validateStringArray
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is string[]}
 */

/** @type {validateStringArray} */
function validateStringArray(value, name) {
  validateArray(value, name)
  for (let i = 0; i < value.length; i++) {
    validateString(value[i], `${name}[${i}]`)
  }
}

/**
 * @callback validateBooleanArray
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is boolean[]}
 */

/** @type {validateBooleanArray} */
function validateBooleanArray(value, name) {
  validateArray(value, name)
  for (let i = 0; i < value.length; i++) {
    validateBoolean(value[i], `${name}[${i}]`)
  }
}

/**
 * @callback validateAbortSignalArray
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is AbortSignal[]}
 */

/** @type {validateAbortSignalArray} */
function validateAbortSignalArray(value, name) {
  validateArray(value, name)
  for (let i = 0; i < value.length; i++) {
    const signal = value[i]
    const indexedName = `${name}[${i}]`
    if (signal == null) {
      throw new ERR_INVALID_ARG_TYPE(indexedName, 'AbortSignal', signal)
    }
    validateAbortSignal(signal, indexedName)
  }
}

/**
 * @param {*} signal
 * @param {string} [name='signal']
 * @returns {asserts signal is keyof signals}
 */
function validateSignalName(signal, name = 'signal') {
  validateString(signal, name)
  if (signals[signal] === undefined) {
    if (signals[StringPrototypeToUpperCase(signal)] !== undefined) {
      throw new ERR_UNKNOWN_SIGNAL(signal + ' (signals must use all capital letters)')
    }
    throw new ERR_UNKNOWN_SIGNAL(signal)
  }
}

/**
 * @callback validateBuffer
 * @param {*} buffer
 * @param {string} [name='buffer']
 * @returns {asserts buffer is ArrayBufferView}
 */

/** @type {validateBuffer} */
const validateBuffer = hideStackFrames((buffer, name = 'buffer') => {
  if (!isArrayBufferView(buffer)) {
    throw new ERR_INVALID_ARG_TYPE(name, ['Buffer', 'TypedArray', 'DataView'], buffer)
  }
})

/**
 * @param {string} data
 * @param {string} encoding
 */
function validateEncoding(data, encoding) {
  const normalizedEncoding = normalizeEncoding(encoding)
  const length = data.length
  if (normalizedEncoding === 'hex' && length % 2 !== 0) {
    throw new ERR_INVALID_ARG_VALUE('encoding', encoding, `is invalid for data of length ${length}`)
  }
}

/**
 * Check that the port number is not NaN when coerced to a number,
 * is an integer and that it falls within the legal range of port numbers.
 * @param {*} port
 * @param {string} [name='Port']
 * @param {boolean} [allowZero=true]
 * @returns {number}
 */
function validatePort(port, name = 'Port', allowZero = true) {
  if (
    (typeof port !== 'number' && typeof port !== 'string') ||
    (typeof port === 'string' && StringPrototypeTrim(port).length === 0) ||
    +port !== +port >>> 0 ||
    port > 0xffff ||
    (port === 0 && !allowZero)
  ) {
    throw new ERR_SOCKET_BAD_PORT(name, port, allowZero)
  }
  return port | 0
}

/**
 * @callback validateAbortSignal
 * @param {*} signal
 * @param {string} name
 */

/** @type {validateAbortSignal} */
const validateAbortSignal = hideStackFrames((signal, name) => {
  if (signal !== undefined && (signal === null || typeof signal !== 'object' || !('aborted' in signal))) {
    throw new ERR_INVALID_ARG_TYPE(name, 'AbortSignal', signal)
  }
})

/**
 * @callback validateFunction
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is Function}
 */

/** @type {validateFunction} */
const validateFunction = hideStackFrames((value, name) => {
  if (typeof value !== 'function') throw new ERR_INVALID_ARG_TYPE(name, 'Function', value)
})

/**
 * @callback validatePlainFunction
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is Function}
 */

/** @type {validatePlainFunction} */
const validatePlainFunction = hideStackFrames((value, name) => {
  if (typeof value !== 'function' || isAsyncFunction(value)) throw new ERR_INVALID_ARG_TYPE(name, 'Function', value)
})

/**
 * @callback validateUndefined
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is undefined}
 */

/** @type {validateUndefined} */
const validateUndefined = hideStackFrames((value, name) => {
  if (value !== undefined) throw new ERR_INVALID_ARG_TYPE(name, 'undefined', value)
})

/**
 * @template T
 * @param {T} value
 * @param {string} name
 * @param {T[]} union
 */
function validateUnion(value, name, union) {
  if (!ArrayPrototypeIncludes(union, value)) {
    throw new ERR_INVALID_ARG_TYPE(name, `('${ArrayPrototypeJoin(union, '|')}')`, value)
  }
}

/*
  The rules for the Link header field are described here:
  https://www.rfc-editor.org/rfc/rfc8288.html#section-3

  This regex validates any string surrounded by angle brackets
  (not necessarily a valid URI reference) followed by zero or more
  link-params separated by semicolons.
*/
const linkValueRegExp = /^(?:<[^>]*>)(?:\s*;\s*[^;"\s]+(?:=(")?[^;"\s]*\1)?)*$/

/**
 * @param {any} value
 * @param {string} name
 */
function validateLinkHeaderFormat(value, name) {
  if (typeof value === 'undefined' || !RegExpPrototypeExec(linkValueRegExp, value)) {
    throw new ERR_INVALID_ARG_VALUE(
      name,
      value,
      'must be an array or string of format "</styles.css>; rel=preload; as=style"'
    )
  }
}

/**
 * @param {any} hints
 * @return {string}
 */
function validateLinkHeaderValue(hints) {
  if (typeof hints === 'string') {
    validateLinkHeaderFormat(hints, 'hints')
    return hints
  } else if (ArrayIsArray(hints)) {
    const hintsLength = hints.length
    let result = ''
    if (hintsLength === 0) {
      return result
    }
    for (let i = 0; i < hintsLength; i++) {
      const link = hints[i]
      validateLinkHeaderFormat(link, 'hints')
      result += link
      if (i !== hintsLength - 1) {
        result += ', '
      }
    }
    return result
  }
  throw new ERR_INVALID_ARG_VALUE(
    'hints',
    hints,
    'must be an array or string of format "</styles.css>; rel=preload; as=style"'
  )
}
module.exports = {
  isInt32,
  isUint32,
  parseFileMode,
  validateArray,
  validateStringArray,
  validateBooleanArray,
  validateAbortSignalArray,
  validateBoolean,
  validateBuffer,
  validateDictionary,
  validateEncoding,
  validateFunction,
  validateInt32,
  validateInteger,
  validateNumber,
  validateObject,
  validateOneOf,
  validatePlainFunction,
  validatePort,
  validateSignalName,
  validateString,
  validateUint32,
  validateUndefined,
  validateUnion,
  validateAbortSignal,
  validateLinkHeaderValue
}


/***/ }),

/***/ 91198:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


const { format, inspect, AggregateError: CustomAggregateError } = __webpack_require__(89349)

/*
  This file is a reduced and adapted version of the main lib/internal/errors.js file defined at

  https://github.com/nodejs/node/blob/master/lib/internal/errors.js

  Don't try to replace with the original file and keep it up to date (starting from E(...) definitions)
  with the upstream file.
*/

const AggregateError = globalThis.AggregateError || CustomAggregateError
const kIsNodeError = Symbol('kIsNodeError')
const kTypes = [
  'string',
  'function',
  'number',
  'object',
  // Accept 'Function' and 'Object' as alternative to the lower cased version.
  'Function',
  'Object',
  'boolean',
  'bigint',
  'symbol'
]
const classRegExp = /^([A-Z][a-z0-9]*)+$/
const nodeInternalPrefix = '__node_internal_'
const codes = {}
function assert(value, message) {
  if (!value) {
    throw new codes.ERR_INTERNAL_ASSERTION(message)
  }
}

// Only use this for integers! Decimal numbers do not work with this function.
function addNumericalSeparator(val) {
  let res = ''
  let i = val.length
  const start = val[0] === '-' ? 1 : 0
  for (; i >= start + 4; i -= 3) {
    res = `_${val.slice(i - 3, i)}${res}`
  }
  return `${val.slice(0, i)}${res}`
}
function getMessage(key, msg, args) {
  if (typeof msg === 'function') {
    assert(
      msg.length <= args.length,
      // Default options do not count.
      `Code: ${key}; The provided arguments length (${args.length}) does not match the required ones (${msg.length}).`
    )
    return msg(...args)
  }
  const expectedLength = (msg.match(/%[dfijoOs]/g) || []).length
  assert(
    expectedLength === args.length,
    `Code: ${key}; The provided arguments length (${args.length}) does not match the required ones (${expectedLength}).`
  )
  if (args.length === 0) {
    return msg
  }
  return format(msg, ...args)
}
function E(code, message, Base) {
  if (!Base) {
    Base = Error
  }
  class NodeError extends Base {
    constructor(...args) {
      super(getMessage(code, message, args))
    }
    toString() {
      return `${this.name} [${code}]: ${this.message}`
    }
  }
  Object.defineProperties(NodeError.prototype, {
    name: {
      value: Base.name,
      writable: true,
      enumerable: false,
      configurable: true
    },
    toString: {
      value() {
        return `${this.name} [${code}]: ${this.message}`
      },
      writable: true,
      enumerable: false,
      configurable: true
    }
  })
  NodeError.prototype.code = code
  NodeError.prototype[kIsNodeError] = true
  codes[code] = NodeError
}
function hideStackFrames(fn) {
  // We rename the functions that will be hidden to cut off the stacktrace
  // at the outermost one
  const hidden = nodeInternalPrefix + fn.name
  Object.defineProperty(fn, 'name', {
    value: hidden
  })
  return fn
}
function aggregateTwoErrors(innerError, outerError) {
  if (innerError && outerError && innerError !== outerError) {
    if (Array.isArray(outerError.errors)) {
      // If `outerError` is already an `AggregateError`.
      outerError.errors.push(innerError)
      return outerError
    }
    const err = new AggregateError([outerError, innerError], outerError.message)
    err.code = outerError.code
    return err
  }
  return innerError || outerError
}
class AbortError extends Error {
  constructor(message = 'The operation was aborted', options = undefined) {
    if (options !== undefined && typeof options !== 'object') {
      throw new codes.ERR_INVALID_ARG_TYPE('options', 'Object', options)
    }
    super(message, options)
    this.code = 'ABORT_ERR'
    this.name = 'AbortError'
  }
}
E('ERR_ASSERTION', '%s', Error)
E(
  'ERR_INVALID_ARG_TYPE',
  (name, expected, actual) => {
    assert(typeof name === 'string', "'name' must be a string")
    if (!Array.isArray(expected)) {
      expected = [expected]
    }
    let msg = 'The '
    if (name.endsWith(' argument')) {
      // For cases like 'first argument'
      msg += `${name} `
    } else {
      msg += `"${name}" ${name.includes('.') ? 'property' : 'argument'} `
    }
    msg += 'must be '
    const types = []
    const instances = []
    const other = []
    for (const value of expected) {
      assert(typeof value === 'string', 'All expected entries have to be of type string')
      if (kTypes.includes(value)) {
        types.push(value.toLowerCase())
      } else if (classRegExp.test(value)) {
        instances.push(value)
      } else {
        assert(value !== 'object', 'The value "object" should be written as "Object"')
        other.push(value)
      }
    }

    // Special handle `object` in case other instances are allowed to outline
    // the differences between each other.
    if (instances.length > 0) {
      const pos = types.indexOf('object')
      if (pos !== -1) {
        types.splice(types, pos, 1)
        instances.push('Object')
      }
    }
    if (types.length > 0) {
      switch (types.length) {
        case 1:
          msg += `of type ${types[0]}`
          break
        case 2:
          msg += `one of type ${types[0]} or ${types[1]}`
          break
        default: {
          const last = types.pop()
          msg += `one of type ${types.join(', ')}, or ${last}`
        }
      }
      if (instances.length > 0 || other.length > 0) {
        msg += ' or '
      }
    }
    if (instances.length > 0) {
      switch (instances.length) {
        case 1:
          msg += `an instance of ${instances[0]}`
          break
        case 2:
          msg += `an instance of ${instances[0]} or ${instances[1]}`
          break
        default: {
          const last = instances.pop()
          msg += `an instance of ${instances.join(', ')}, or ${last}`
        }
      }
      if (other.length > 0) {
        msg += ' or '
      }
    }
    switch (other.length) {
      case 0:
        break
      case 1:
        if (other[0].toLowerCase() !== other[0]) {
          msg += 'an '
        }
        msg += `${other[0]}`
        break
      case 2:
        msg += `one of ${other[0]} or ${other[1]}`
        break
      default: {
        const last = other.pop()
        msg += `one of ${other.join(', ')}, or ${last}`
      }
    }
    if (actual == null) {
      msg += `. Received ${actual}`
    } else if (typeof actual === 'function' && actual.name) {
      msg += `. Received function ${actual.name}`
    } else if (typeof actual === 'object') {
      var _actual$constructor
      if (
        (_actual$constructor = actual.constructor) !== null &&
        _actual$constructor !== undefined &&
        _actual$constructor.name
      ) {
        msg += `. Received an instance of ${actual.constructor.name}`
      } else {
        const inspected = inspect(actual, {
          depth: -1
        })
        msg += `. Received ${inspected}`
      }
    } else {
      let inspected = inspect(actual, {
        colors: false
      })
      if (inspected.length > 25) {
        inspected = `${inspected.slice(0, 25)}...`
      }
      msg += `. Received type ${typeof actual} (${inspected})`
    }
    return msg
  },
  TypeError
)
E(
  'ERR_INVALID_ARG_VALUE',
  (name, value, reason = 'is invalid') => {
    let inspected = inspect(value)
    if (inspected.length > 128) {
      inspected = inspected.slice(0, 128) + '...'
    }
    const type = name.includes('.') ? 'property' : 'argument'
    return `The ${type} '${name}' ${reason}. Received ${inspected}`
  },
  TypeError
)
E(
  'ERR_INVALID_RETURN_VALUE',
  (input, name, value) => {
    var _value$constructor
    const type =
      value !== null &&
      value !== undefined &&
      (_value$constructor = value.constructor) !== null &&
      _value$constructor !== undefined &&
      _value$constructor.name
        ? `instance of ${value.constructor.name}`
        : `type ${typeof value}`
    return `Expected ${input} to be returned from the "${name}"` + ` function but got ${type}.`
  },
  TypeError
)
E(
  'ERR_MISSING_ARGS',
  (...args) => {
    assert(args.length > 0, 'At least one arg needs to be specified')
    let msg
    const len = args.length
    args = (Array.isArray(args) ? args : [args]).map((a) => `"${a}"`).join(' or ')
    switch (len) {
      case 1:
        msg += `The ${args[0]} argument`
        break
      case 2:
        msg += `The ${args[0]} and ${args[1]} arguments`
        break
      default:
        {
          const last = args.pop()
          msg += `The ${args.join(', ')}, and ${last} arguments`
        }
        break
    }
    return `${msg} must be specified`
  },
  TypeError
)
E(
  'ERR_OUT_OF_RANGE',
  (str, range, input) => {
    assert(range, 'Missing "range" argument')
    let received
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) {
      received = addNumericalSeparator(String(input))
    } else if (typeof input === 'bigint') {
      received = String(input)
      if (input > 2n ** 32n || input < -(2n ** 32n)) {
        received = addNumericalSeparator(received)
      }
      received += 'n'
    } else {
      received = inspect(input)
    }
    return `The value of "${str}" is out of range. It must be ${range}. Received ${received}`
  },
  RangeError
)
E('ERR_MULTIPLE_CALLBACK', 'Callback called multiple times', Error)
E('ERR_METHOD_NOT_IMPLEMENTED', 'The %s method is not implemented', Error)
E('ERR_STREAM_ALREADY_FINISHED', 'Cannot call %s after a stream was finished', Error)
E('ERR_STREAM_CANNOT_PIPE', 'Cannot pipe, not readable', Error)
E('ERR_STREAM_DESTROYED', 'Cannot call %s after a stream was destroyed', Error)
E('ERR_STREAM_NULL_VALUES', 'May not write null values to stream', TypeError)
E('ERR_STREAM_PREMATURE_CLOSE', 'Premature close', Error)
E('ERR_STREAM_PUSH_AFTER_EOF', 'stream.push() after EOF', Error)
E('ERR_STREAM_UNSHIFT_AFTER_END_EVENT', 'stream.unshift() after end event', Error)
E('ERR_STREAM_WRITE_AFTER_END', 'write after end', Error)
E('ERR_UNKNOWN_ENCODING', 'Unknown encoding: %s', TypeError)
module.exports = {
  AbortError,
  aggregateTwoErrors: hideStackFrames(aggregateTwoErrors),
  hideStackFrames,
  codes
}


/***/ }),

/***/ 54136:
/***/ (function(module) {

"use strict";


/*
  This file is a reduced and adapted version of the main lib/internal/per_context/primordials.js file defined at

  https://github.com/nodejs/node/blob/master/lib/internal/per_context/primordials.js

  Don't try to replace with the original file and keep it up to date with the upstream file.
*/
module.exports = {
  ArrayIsArray(self) {
    return Array.isArray(self)
  },
  ArrayPrototypeIncludes(self, el) {
    return self.includes(el)
  },
  ArrayPrototypeIndexOf(self, el) {
    return self.indexOf(el)
  },
  ArrayPrototypeJoin(self, sep) {
    return self.join(sep)
  },
  ArrayPrototypeMap(self, fn) {
    return self.map(fn)
  },
  ArrayPrototypePop(self, el) {
    return self.pop(el)
  },
  ArrayPrototypePush(self, el) {
    return self.push(el)
  },
  ArrayPrototypeSlice(self, start, end) {
    return self.slice(start, end)
  },
  Error,
  FunctionPrototypeCall(fn, thisArgs, ...args) {
    return fn.call(thisArgs, ...args)
  },
  FunctionPrototypeSymbolHasInstance(self, instance) {
    return Function.prototype[Symbol.hasInstance].call(self, instance)
  },
  MathFloor: Math.floor,
  Number,
  NumberIsInteger: Number.isInteger,
  NumberIsNaN: Number.isNaN,
  NumberMAX_SAFE_INTEGER: Number.MAX_SAFE_INTEGER,
  NumberMIN_SAFE_INTEGER: Number.MIN_SAFE_INTEGER,
  NumberParseInt: Number.parseInt,
  ObjectDefineProperties(self, props) {
    return Object.defineProperties(self, props)
  },
  ObjectDefineProperty(self, name, prop) {
    return Object.defineProperty(self, name, prop)
  },
  ObjectGetOwnPropertyDescriptor(self, name) {
    return Object.getOwnPropertyDescriptor(self, name)
  },
  ObjectKeys(obj) {
    return Object.keys(obj)
  },
  ObjectSetPrototypeOf(target, proto) {
    return Object.setPrototypeOf(target, proto)
  },
  Promise,
  PromisePrototypeCatch(self, fn) {
    return self.catch(fn)
  },
  PromisePrototypeThen(self, thenFn, catchFn) {
    return self.then(thenFn, catchFn)
  },
  PromiseReject(err) {
    return Promise.reject(err)
  },
  PromiseResolve(val) {
    return Promise.resolve(val)
  },
  ReflectApply: Reflect.apply,
  RegExpPrototypeTest(self, value) {
    return self.test(value)
  },
  SafeSet: Set,
  String,
  StringPrototypeSlice(self, start, end) {
    return self.slice(start, end)
  },
  StringPrototypeToLowerCase(self) {
    return self.toLowerCase()
  },
  StringPrototypeToUpperCase(self) {
    return self.toUpperCase()
  },
  StringPrototypeTrim(self) {
    return self.trim()
  },
  Symbol,
  SymbolFor: Symbol.for,
  SymbolAsyncIterator: Symbol.asyncIterator,
  SymbolHasInstance: Symbol.hasInstance,
  SymbolIterator: Symbol.iterator,
  SymbolDispose: Symbol.dispose || Symbol('Symbol.dispose'),
  SymbolAsyncDispose: Symbol.asyncDispose || Symbol('Symbol.asyncDispose'),
  TypedArrayPrototypeSet(self, buf, len) {
    return self.set(buf, len)
  },
  Boolean: Boolean,
  Uint8Array
}


/***/ }),

/***/ 89349:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


const bufferModule = __webpack_require__(55872)
const { kResistStopPropagation, SymbolDispose } = __webpack_require__(54136)
const AbortSignal = globalThis.AbortSignal || (__webpack_require__(21366).AbortSignal)
const AbortController = globalThis.AbortController || (__webpack_require__(21366).AbortController)
const AsyncFunction = Object.getPrototypeOf(async function () {}).constructor
const Blob = globalThis.Blob || bufferModule.Blob
/* eslint-disable indent */
const isBlob =
  typeof Blob !== 'undefined'
    ? function isBlob(b) {
        // eslint-disable-next-line indent
        return b instanceof Blob
      }
    : function isBlob(b) {
        return false
      }
/* eslint-enable indent */

const validateAbortSignal = (signal, name) => {
  if (signal !== undefined && (signal === null || typeof signal !== 'object' || !('aborted' in signal))) {
    throw new ERR_INVALID_ARG_TYPE(name, 'AbortSignal', signal)
  }
}
const validateFunction = (value, name) => {
  if (typeof value !== 'function') throw new ERR_INVALID_ARG_TYPE(name, 'Function', value)
}

// This is a simplified version of AggregateError
class AggregateError extends Error {
  constructor(errors) {
    if (!Array.isArray(errors)) {
      throw new TypeError(`Expected input to be an Array, got ${typeof errors}`)
    }
    let message = ''
    for (let i = 0; i < errors.length; i++) {
      message += `    ${errors[i].stack}\n`
    }
    super(message)
    this.name = 'AggregateError'
    this.errors = errors
  }
}
module.exports = {
  AggregateError,
  kEmptyObject: Object.freeze({}),
  once(callback) {
    let called = false
    return function (...args) {
      if (called) {
        return
      }
      called = true
      callback.apply(this, args)
    }
  },
  createDeferredPromise: function () {
    let resolve
    let reject

    // eslint-disable-next-line promise/param-names
    const promise = new Promise((res, rej) => {
      resolve = res
      reject = rej
    })
    return {
      promise,
      resolve,
      reject
    }
  },
  promisify(fn) {
    return new Promise((resolve, reject) => {
      fn((err, ...args) => {
        if (err) {
          return reject(err)
        }
        return resolve(...args)
      })
    })
  },
  debuglog() {
    return function () {}
  },
  format(format, ...args) {
    // Simplified version of https://nodejs.org/api/util.html#utilformatformat-args
    return format.replace(/%([sdifj])/g, function (...[_unused, type]) {
      const replacement = args.shift()
      if (type === 'f') {
        return replacement.toFixed(6)
      } else if (type === 'j') {
        return JSON.stringify(replacement)
      } else if (type === 's' && typeof replacement === 'object') {
        const ctor = replacement.constructor !== Object ? replacement.constructor.name : ''
        return `${ctor} {}`.trim()
      } else {
        return replacement.toString()
      }
    })
  },
  inspect(value) {
    // Vastly simplified version of https://nodejs.org/api/util.html#utilinspectobject-options
    switch (typeof value) {
      case 'string':
        if (value.includes("'")) {
          if (!value.includes('"')) {
            return `"${value}"`
          } else if (!value.includes('`') && !value.includes('${')) {
            return `\`${value}\``
          }
        }
        return `'${value}'`
      case 'number':
        if (isNaN(value)) {
          return 'NaN'
        } else if (Object.is(value, -0)) {
          return String(value)
        }
        return value
      case 'bigint':
        return `${String(value)}n`
      case 'boolean':
      case 'undefined':
        return String(value)
      case 'object':
        return '{}'
    }
  },
  types: {
    isAsyncFunction(fn) {
      return fn instanceof AsyncFunction
    },
    isArrayBufferView(arr) {
      return ArrayBuffer.isView(arr)
    }
  },
  isBlob,
  deprecate(fn, message) {
    return fn
  },
  addAbortListener:
    (__webpack_require__(72100).addAbortListener) ||
    function addAbortListener(signal, listener) {
      if (signal === undefined) {
        throw new ERR_INVALID_ARG_TYPE('signal', 'AbortSignal', signal)
      }
      validateAbortSignal(signal, 'signal')
      validateFunction(listener, 'listener')
      let removeEventListener
      if (signal.aborted) {
        queueMicrotask(() => listener())
      } else {
        signal.addEventListener('abort', listener, {
          __proto__: null,
          once: true,
          [kResistStopPropagation]: true
        })
        removeEventListener = () => {
          signal.removeEventListener('abort', listener)
        }
      }
      return {
        __proto__: null,
        [SymbolDispose]() {
          var _removeEventListener
          ;(_removeEventListener = removeEventListener) === null || _removeEventListener === undefined
            ? undefined
            : _removeEventListener()
        }
      }
    },
  AbortSignalAny:
    AbortSignal.any ||
    function AbortSignalAny(signals) {
      // Fast path if there is only one signal.
      if (signals.length === 1) {
        return signals[0]
      }
      const ac = new AbortController()
      const abort = () => ac.abort()
      signals.forEach((signal) => {
        validateAbortSignal(signal, 'signals')
        signal.addEventListener('abort', abort, {
          once: true
        })
      })
      ac.signal.addEventListener(
        'abort',
        () => {
          signals.forEach((signal) => signal.removeEventListener('abort', abort))
        },
        {
          once: true
        }
      )
      return ac.signal
    }
}
module.exports.promisify.custom = Symbol.for('nodejs.util.promisify.custom')


/***/ }),

/***/ 78591:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/* replacement start */

const { Buffer } = __webpack_require__(55872)

/* replacement end */
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

;('use strict')
const { ObjectDefineProperty, ObjectKeys, ReflectApply } = __webpack_require__(54136)
const {
  promisify: { custom: customPromisify }
} = __webpack_require__(89349)
const { streamReturningOperators, promiseReturningOperators } = __webpack_require__(28120)
const {
  codes: { ERR_ILLEGAL_CONSTRUCTOR }
} = __webpack_require__(91198)
const compose = __webpack_require__(29449)
const { setDefaultHighWaterMark, getDefaultHighWaterMark } = __webpack_require__(17279)
const { pipeline } = __webpack_require__(74989)
const { destroyer } = __webpack_require__(35441)
const eos = __webpack_require__(86695)
const internalBuffer = {}
const promises = __webpack_require__(59674)
const utils = __webpack_require__(87614)
const Stream = (module.exports = __webpack_require__(23472).Stream)
Stream.isDestroyed = utils.isDestroyed
Stream.isDisturbed = utils.isDisturbed
Stream.isErrored = utils.isErrored
Stream.isReadable = utils.isReadable
Stream.isWritable = utils.isWritable
Stream.Readable = __webpack_require__(51560)
for (const key of ObjectKeys(streamReturningOperators)) {
  const op = streamReturningOperators[key]
  function fn(...args) {
    if (new.target) {
      throw ERR_ILLEGAL_CONSTRUCTOR()
    }
    return Stream.Readable.from(ReflectApply(op, this, args))
  }
  ObjectDefineProperty(fn, 'name', {
    __proto__: null,
    value: op.name
  })
  ObjectDefineProperty(fn, 'length', {
    __proto__: null,
    value: op.length
  })
  ObjectDefineProperty(Stream.Readable.prototype, key, {
    __proto__: null,
    value: fn,
    enumerable: false,
    configurable: true,
    writable: true
  })
}
for (const key of ObjectKeys(promiseReturningOperators)) {
  const op = promiseReturningOperators[key]
  function fn(...args) {
    if (new.target) {
      throw ERR_ILLEGAL_CONSTRUCTOR()
    }
    return ReflectApply(op, this, args)
  }
  ObjectDefineProperty(fn, 'name', {
    __proto__: null,
    value: op.name
  })
  ObjectDefineProperty(fn, 'length', {
    __proto__: null,
    value: op.length
  })
  ObjectDefineProperty(Stream.Readable.prototype, key, {
    __proto__: null,
    value: fn,
    enumerable: false,
    configurable: true,
    writable: true
  })
}
Stream.Writable = __webpack_require__(26336)
Stream.Duplex = __webpack_require__(66695)
Stream.Transform = __webpack_require__(45033)
Stream.PassThrough = __webpack_require__(29752)
Stream.pipeline = pipeline
const { addAbortSignal } = __webpack_require__(47287)
Stream.addAbortSignal = addAbortSignal
Stream.finished = eos
Stream.destroy = destroyer
Stream.compose = compose
Stream.setDefaultHighWaterMark = setDefaultHighWaterMark
Stream.getDefaultHighWaterMark = getDefaultHighWaterMark
ObjectDefineProperty(Stream, 'promises', {
  __proto__: null,
  configurable: true,
  enumerable: true,
  get() {
    return promises
  }
})
ObjectDefineProperty(pipeline, customPromisify, {
  __proto__: null,
  enumerable: true,
  get() {
    return promises.pipeline
  }
})
ObjectDefineProperty(eos, customPromisify, {
  __proto__: null,
  enumerable: true,
  get() {
    return promises.finished
  }
})

// Backwards-compat with node 0.4.x
Stream.Stream = Stream
Stream._isUint8Array = function isUint8Array(value) {
  return value instanceof Uint8Array
}
Stream._uint8ArrayToBuffer = function _uint8ArrayToBuffer(chunk) {
  return Buffer.from(chunk.buffer, chunk.byteOffset, chunk.byteLength)
}


/***/ }),

/***/ 59674:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


const { ArrayPrototypePop, Promise } = __webpack_require__(54136)
const { isIterable, isNodeStream, isWebStream } = __webpack_require__(87614)
const { pipelineImpl: pl } = __webpack_require__(74989)
const { finished } = __webpack_require__(86695)
__webpack_require__(78591)
function pipeline(...streams) {
  return new Promise((resolve, reject) => {
    let signal
    let end
    const lastArg = streams[streams.length - 1]
    if (
      lastArg &&
      typeof lastArg === 'object' &&
      !isNodeStream(lastArg) &&
      !isIterable(lastArg) &&
      !isWebStream(lastArg)
    ) {
      const options = ArrayPrototypePop(streams)
      signal = options.signal
      end = options.end
    }
    pl(
      streams,
      (err, value) => {
        if (err) {
          reject(err)
        } else {
          resolve(value)
        }
      },
      {
        signal,
        end
      }
    )
  })
}
module.exports = {
  finished,
  pipeline
}


/***/ }),

/***/ 90250:
/***/ (function(module) {

/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var runtime = (function (exports) {
  "use strict";

  var Op = Object.prototype;
  var hasOwn = Op.hasOwnProperty;
  var defineProperty = Object.defineProperty || function (obj, key, desc) { obj[key] = desc.value; };
  var undefined; // More compressible than void 0.
  var $Symbol = typeof Symbol === "function" ? Symbol : {};
  var iteratorSymbol = $Symbol.iterator || "@@iterator";
  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  function define(obj, key, value) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
    return obj[key];
  }
  try {
    // IE 8 has a broken Object.defineProperty that only works on DOM objects.
    define({}, "");
  } catch (err) {
    define = function(obj, key, value) {
      return obj[key] = value;
    };
  }

  function wrap(innerFn, outerFn, self, tryLocsList) {
    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
    var generator = Object.create(protoGenerator.prototype);
    var context = new Context(tryLocsList || []);

    // The ._invoke method unifies the implementations of the .next,
    // .throw, and .return methods.
    defineProperty(generator, "_invoke", { value: makeInvokeMethod(innerFn, self, context) });

    return generator;
  }
  exports.wrap = wrap;

  // Try/catch helper to minimize deoptimizations. Returns a completion
  // record like context.tryEntries[i].completion. This interface could
  // have been (and was previously) designed to take a closure to be
  // invoked without arguments, but in all the cases we care about we
  // already have an existing method we want to call, so there's no need
  // to create a new function object. We can even get away with assuming
  // the method takes exactly one argument, since that happens to be true
  // in every case, so we don't have to touch the arguments object. The
  // only additional allocation required is the completion record, which
  // has a stable shape and so hopefully should be cheap to allocate.
  function tryCatch(fn, obj, arg) {
    try {
      return { type: "normal", arg: fn.call(obj, arg) };
    } catch (err) {
      return { type: "throw", arg: err };
    }
  }

  var GenStateSuspendedStart = "suspendedStart";
  var GenStateSuspendedYield = "suspendedYield";
  var GenStateExecuting = "executing";
  var GenStateCompleted = "completed";

  // Returning this object from the innerFn has the same effect as
  // breaking out of the dispatch switch statement.
  var ContinueSentinel = {};

  // Dummy constructor functions that we use as the .constructor and
  // .constructor.prototype properties for functions that return Generator
  // objects. For full spec compliance, you may wish to configure your
  // minifier not to mangle the names of these two functions.
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}

  // This is a polyfill for %IteratorPrototype% for environments that
  // don't natively support it.
  var IteratorPrototype = {};
  define(IteratorPrototype, iteratorSymbol, function () {
    return this;
  });

  var getProto = Object.getPrototypeOf;
  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  if (NativeIteratorPrototype &&
      NativeIteratorPrototype !== Op &&
      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
    // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
  }

  var Gp = GeneratorFunctionPrototype.prototype =
    Generator.prototype = Object.create(IteratorPrototype);
  GeneratorFunction.prototype = GeneratorFunctionPrototype;
  defineProperty(Gp, "constructor", { value: GeneratorFunctionPrototype, configurable: true });
  defineProperty(
    GeneratorFunctionPrototype,
    "constructor",
    { value: GeneratorFunction, configurable: true }
  );
  GeneratorFunction.displayName = define(
    GeneratorFunctionPrototype,
    toStringTagSymbol,
    "GeneratorFunction"
  );

  // Helper for defining the .next, .throw, and .return methods of the
  // Iterator interface in terms of a single ._invoke method.
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function(method) {
      define(prototype, method, function(arg) {
        return this._invoke(method, arg);
      });
    });
  }

  exports.isGeneratorFunction = function(genFun) {
    var ctor = typeof genFun === "function" && genFun.constructor;
    return ctor
      ? ctor === GeneratorFunction ||
        // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction"
      : false;
  };

  exports.mark = function(genFun) {
    if (Object.setPrototypeOf) {
      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
    } else {
      genFun.__proto__ = GeneratorFunctionPrototype;
      define(genFun, toStringTagSymbol, "GeneratorFunction");
    }
    genFun.prototype = Object.create(Gp);
    return genFun;
  };

  // Within the body of any async function, `await x` is transformed to
  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
  // `hasOwn.call(value, "__await")` to determine if the yielded value is
  // meant to be awaited.
  exports.awrap = function(arg) {
    return { __await: arg };
  };

  function AsyncIterator(generator, PromiseImpl) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if (record.type === "throw") {
        reject(record.arg);
      } else {
        var result = record.arg;
        var value = result.value;
        if (value &&
            typeof value === "object" &&
            hasOwn.call(value, "__await")) {
          return PromiseImpl.resolve(value.__await).then(function(value) {
            invoke("next", value, resolve, reject);
          }, function(err) {
            invoke("throw", err, resolve, reject);
          });
        }

        return PromiseImpl.resolve(value).then(function(unwrapped) {
          // When a yielded Promise is resolved, its final value becomes
          // the .value of the Promise<{value,done}> result for the
          // current iteration.
          result.value = unwrapped;
          resolve(result);
        }, function(error) {
          // If a rejected Promise was yielded, throw the rejection back
          // into the async generator function so it can be handled there.
          return invoke("throw", error, resolve, reject);
        });
      }
    }

    var previousPromise;

    function enqueue(method, arg) {
      function callInvokeWithMethodAndArg() {
        return new PromiseImpl(function(resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise =
        // If enqueue has been called before, then we want to wait until
        // all previous Promises have been resolved before calling invoke,
        // so that results are always delivered in the correct order. If
        // enqueue has not been called before, then it is important to
        // call invoke immediately, without waiting on a callback to fire,
        // so that the async generator function has the opportunity to do
        // any necessary setup in a predictable way. This predictability
        // is why the Promise constructor synchronously invokes its
        // executor callback, and why async functions synchronously
        // execute code before the first await. Since we implement simple
        // async functions in terms of async generators, it is especially
        // important to get this right, even though it requires care.
        previousPromise ? previousPromise.then(
          callInvokeWithMethodAndArg,
          // Avoid propagating failures to Promises returned by later
          // invocations of the iterator.
          callInvokeWithMethodAndArg
        ) : callInvokeWithMethodAndArg();
    }

    // Define the unified helper method that is used to implement .next,
    // .throw, and .return (see defineIteratorMethods).
    defineProperty(this, "_invoke", { value: enqueue });
  }

  defineIteratorMethods(AsyncIterator.prototype);
  define(AsyncIterator.prototype, asyncIteratorSymbol, function () {
    return this;
  });
  exports.AsyncIterator = AsyncIterator;

  // Note that simple async functions are implemented on top of
  // AsyncIterator objects; they just return a Promise for the value of
  // the final result produced by the iterator.
  exports.async = function(innerFn, outerFn, self, tryLocsList, PromiseImpl) {
    if (PromiseImpl === void 0) PromiseImpl = Promise;

    var iter = new AsyncIterator(
      wrap(innerFn, outerFn, self, tryLocsList),
      PromiseImpl
    );

    return exports.isGeneratorFunction(outerFn)
      ? iter // If outerFn is a generator, return the full iterator.
      : iter.next().then(function(result) {
          return result.done ? result.value : iter.next();
        });
  };

  function makeInvokeMethod(innerFn, self, context) {
    var state = GenStateSuspendedStart;

    return function invoke(method, arg) {
      if (state === GenStateExecuting) {
        throw new Error("Generator is already running");
      }

      if (state === GenStateCompleted) {
        if (method === "throw") {
          throw arg;
        }

        // Be forgiving, per 25.3.3.3.3 of the spec:
        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
        return doneResult();
      }

      context.method = method;
      context.arg = arg;

      while (true) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }

        if (context.method === "next") {
          // Setting context._sent for legacy support of Babel's
          // function.sent implementation.
          context.sent = context._sent = context.arg;

        } else if (context.method === "throw") {
          if (state === GenStateSuspendedStart) {
            state = GenStateCompleted;
            throw context.arg;
          }

          context.dispatchException(context.arg);

        } else if (context.method === "return") {
          context.abrupt("return", context.arg);
        }

        state = GenStateExecuting;

        var record = tryCatch(innerFn, self, context);
        if (record.type === "normal") {
          // If an exception is thrown from innerFn, we leave state ===
          // GenStateExecuting and loop back for another invocation.
          state = context.done
            ? GenStateCompleted
            : GenStateSuspendedYield;

          if (record.arg === ContinueSentinel) {
            continue;
          }

          return {
            value: record.arg,
            done: context.done
          };

        } else if (record.type === "throw") {
          state = GenStateCompleted;
          // Dispatch the exception by looping back around to the
          // context.dispatchException(context.arg) call above.
          context.method = "throw";
          context.arg = record.arg;
        }
      }
    };
  }

  // Call delegate.iterator[context.method](context.arg) and handle the
  // result, either by returning a { value, done } result from the
  // delegate iterator, or by modifying context.method and context.arg,
  // setting context.delegate to null, and returning the ContinueSentinel.
  function maybeInvokeDelegate(delegate, context) {
    var methodName = context.method;
    var method = delegate.iterator[methodName];
    if (method === undefined) {
      // A .throw or .return when the delegate iterator has no .throw
      // method, or a missing .next mehtod, always terminate the
      // yield* loop.
      context.delegate = null;

      // Note: ["return"] must be used for ES3 parsing compatibility.
      if (methodName === "throw" && delegate.iterator["return"]) {
        // If the delegate iterator has a return method, give it a
        // chance to clean up.
        context.method = "return";
        context.arg = undefined;
        maybeInvokeDelegate(delegate, context);

        if (context.method === "throw") {
          // If maybeInvokeDelegate(context) changed context.method from
          // "return" to "throw", let that override the TypeError below.
          return ContinueSentinel;
        }
      }
      if (methodName !== "return") {
        context.method = "throw";
        context.arg = new TypeError(
          "The iterator does not provide a '" + methodName + "' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);

    if (record.type === "throw") {
      context.method = "throw";
      context.arg = record.arg;
      context.delegate = null;
      return ContinueSentinel;
    }

    var info = record.arg;

    if (! info) {
      context.method = "throw";
      context.arg = new TypeError("iterator result is not an object");
      context.delegate = null;
      return ContinueSentinel;
    }

    if (info.done) {
      // Assign the result of the finished delegate to the temporary
      // variable specified by delegate.resultName (see delegateYield).
      context[delegate.resultName] = info.value;

      // Resume execution at the desired location (see delegateYield).
      context.next = delegate.nextLoc;

      // If context.method was "throw" but the delegate handled the
      // exception, let the outer generator proceed normally. If
      // context.method was "next", forget context.arg since it has been
      // "consumed" by the delegate iterator. If context.method was
      // "return", allow the original .return call to continue in the
      // outer generator.
      if (context.method !== "return") {
        context.method = "next";
        context.arg = undefined;
      }

    } else {
      // Re-yield the result returned by the delegate method.
      return info;
    }

    // The delegate iterator is finished, so forget it and continue with
    // the outer generator.
    context.delegate = null;
    return ContinueSentinel;
  }

  // Define Generator.prototype.{next,throw,return} in terms of the
  // unified ._invoke helper method.
  defineIteratorMethods(Gp);

  define(Gp, toStringTagSymbol, "Generator");

  // A Generator should always return itself as the iterator object when the
  // @@iterator function is called on it. Some browsers' implementations of the
  // iterator prototype chain incorrectly implement this, causing the Generator
  // object to not be returned from this call. This ensures that doesn't happen.
  // See https://github.com/facebook/regenerator/issues/274 for more details.
  define(Gp, iteratorSymbol, function() {
    return this;
  });

  define(Gp, "toString", function() {
    return "[object Generator]";
  });

  function pushTryEntry(locs) {
    var entry = { tryLoc: locs[0] };

    if (1 in locs) {
      entry.catchLoc = locs[1];
    }

    if (2 in locs) {
      entry.finallyLoc = locs[2];
      entry.afterLoc = locs[3];
    }

    this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal";
    delete record.arg;
    entry.completion = record;
  }

  function Context(tryLocsList) {
    // The root entry object (effectively a try statement without a catch
    // or a finally block) gives us a place to store values thrown from
    // locations where there is no enclosing try statement.
    this.tryEntries = [{ tryLoc: "root" }];
    tryLocsList.forEach(pushTryEntry, this);
    this.reset(true);
  }

  exports.keys = function(val) {
    var object = Object(val);
    var keys = [];
    for (var key in object) {
      keys.push(key);
    }
    keys.reverse();

    // Rather than returning an object with a next method, we keep
    // things simple and return the next function itself.
    return function next() {
      while (keys.length) {
        var key = keys.pop();
        if (key in object) {
          next.value = key;
          next.done = false;
          return next;
        }
      }

      // To avoid creating an additional object, we just hang the .value
      // and .done properties off the next function object itself. This
      // also ensures that the minifier will not anonymize the function.
      next.done = true;
      return next;
    };
  };

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) {
        return iteratorMethod.call(iterable);
      }

      if (typeof iterable.next === "function") {
        return iterable;
      }

      if (!isNaN(iterable.length)) {
        var i = -1, next = function next() {
          while (++i < iterable.length) {
            if (hasOwn.call(iterable, i)) {
              next.value = iterable[i];
              next.done = false;
              return next;
            }
          }

          next.value = undefined;
          next.done = true;

          return next;
        };

        return next.next = next;
      }
    }

    // Return an iterator with no values.
    return { next: doneResult };
  }
  exports.values = values;

  function doneResult() {
    return { value: undefined, done: true };
  }

  Context.prototype = {
    constructor: Context,

    reset: function(skipTempReset) {
      this.prev = 0;
      this.next = 0;
      // Resetting context._sent for legacy support of Babel's
      // function.sent implementation.
      this.sent = this._sent = undefined;
      this.done = false;
      this.delegate = null;

      this.method = "next";
      this.arg = undefined;

      this.tryEntries.forEach(resetTryEntry);

      if (!skipTempReset) {
        for (var name in this) {
          // Not sure about the optimal order of these conditions:
          if (name.charAt(0) === "t" &&
              hasOwn.call(this, name) &&
              !isNaN(+name.slice(1))) {
            this[name] = undefined;
          }
        }
      }
    },

    stop: function() {
      this.done = true;

      var rootEntry = this.tryEntries[0];
      var rootRecord = rootEntry.completion;
      if (rootRecord.type === "throw") {
        throw rootRecord.arg;
      }

      return this.rval;
    },

    dispatchException: function(exception) {
      if (this.done) {
        throw exception;
      }

      var context = this;
      function handle(loc, caught) {
        record.type = "throw";
        record.arg = exception;
        context.next = loc;

        if (caught) {
          // If the dispatched exception was caught by a catch block,
          // then let that catch block handle the exception normally.
          context.method = "next";
          context.arg = undefined;
        }

        return !! caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        var record = entry.completion;

        if (entry.tryLoc === "root") {
          // Exception thrown outside of any try block that could handle
          // it, so set the completion value of the entire function to
          // throw the exception.
          return handle("end");
        }

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc");
          var hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            } else if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            }

          } else if (hasFinally) {
            if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else {
            throw new Error("try statement without catch or finally");
          }
        }
      }
    },

    abrupt: function(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev &&
            hasOwn.call(entry, "finallyLoc") &&
            this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      if (finallyEntry &&
          (type === "break" ||
           type === "continue") &&
          finallyEntry.tryLoc <= arg &&
          arg <= finallyEntry.finallyLoc) {
        // Ignore the finally entry if control is not jumping to a
        // location outside the try/catch block.
        finallyEntry = null;
      }

      var record = finallyEntry ? finallyEntry.completion : {};
      record.type = type;
      record.arg = arg;

      if (finallyEntry) {
        this.method = "next";
        this.next = finallyEntry.finallyLoc;
        return ContinueSentinel;
      }

      return this.complete(record);
    },

    complete: function(record, afterLoc) {
      if (record.type === "throw") {
        throw record.arg;
      }

      if (record.type === "break" ||
          record.type === "continue") {
        this.next = record.arg;
      } else if (record.type === "return") {
        this.rval = this.arg = record.arg;
        this.method = "return";
        this.next = "end";
      } else if (record.type === "normal" && afterLoc) {
        this.next = afterLoc;
      }

      return ContinueSentinel;
    },

    finish: function(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) {
          this.complete(entry.completion, entry.afterLoc);
          resetTryEntry(entry);
          return ContinueSentinel;
        }
      }
    },

    "catch": function(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if (record.type === "throw") {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }

      // The context.catch method must only be called with a location
      // argument that corresponds to a known catch block.
      throw new Error("illegal catch attempt");
    },

    delegateYield: function(iterable, resultName, nextLoc) {
      this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      };

      if (this.method === "next") {
        // Deliberately forget the last sent value so that we don't
        // accidentally pass it on to the delegate.
        this.arg = undefined;
      }

      return ContinueSentinel;
    }
  };

  // Regardless of whether this script is executing as a CommonJS module
  // or not, return the runtime object so that we can declare the variable
  // regeneratorRuntime in the outer scope, which allows this module to be
  // injected easily by `bin/regenerator --include-runtime script.js`.
  return exports;

}(
  // If this script is executing as a CommonJS module, use module.exports
  // as the regeneratorRuntime namespace. Otherwise create a new empty
  // object. Either way, the resulting object will be used to initialize
  // the regeneratorRuntime variable at the top of this file.
   true ? module.exports : 0
));

try {
  regeneratorRuntime = runtime;
} catch (accidentalStrictMode) {
  // This module should not be running in strict mode, so the above
  // assignment should always work unless something is misconfigured. Just
  // in case runtime.js accidentally runs in strict mode, in modern engines
  // we can explicitly access globalThis. In older engines we can escape
  // strict mode using a global Function call. This could conceivably fail
  // if a Content Security Policy forbids using Function, but in that case
  // the proper solution is to fix the accidental strict mode problem. If
  // you've misconfigured your bundler to force strict mode and applied a
  // CSP to forbid Function, and you're not willing to fix either of those
  // problems, please detail your unique predicament in a GitHub issue.
  if (typeof globalThis === "object") {
    globalThis.regeneratorRuntime = runtime;
  } else {
    Function("r", "regeneratorRuntime = r")(runtime);
  }
}


/***/ }),

/***/ 61874:
/***/ (function(module, exports, __webpack_require__) {

/*! safe-buffer. MIT License. Feross Aboukhadijeh <https://feross.org/opensource> */
/* eslint-disable node/no-deprecated-api */
var buffer = __webpack_require__(55872)
var Buffer = buffer.Buffer

// alternative to using Object.keys for old browsers
function copyProps (src, dst) {
  for (var key in src) {
    dst[key] = src[key]
  }
}
if (Buffer.from && Buffer.alloc && Buffer.allocUnsafe && Buffer.allocUnsafeSlow) {
  module.exports = buffer
} else {
  // Copy properties from require('buffer')
  copyProps(buffer, exports)
  exports.Buffer = SafeBuffer
}

function SafeBuffer (arg, encodingOrOffset, length) {
  return Buffer(arg, encodingOrOffset, length)
}

SafeBuffer.prototype = Object.create(Buffer.prototype)

// Copy static methods from Buffer
copyProps(Buffer, SafeBuffer)

SafeBuffer.from = function (arg, encodingOrOffset, length) {
  if (typeof arg === 'number') {
    throw new TypeError('Argument must not be a number')
  }
  return Buffer(arg, encodingOrOffset, length)
}

SafeBuffer.alloc = function (size, fill, encoding) {
  if (typeof size !== 'number') {
    throw new TypeError('Argument must be a number')
  }
  var buf = Buffer(size)
  if (fill !== undefined) {
    if (typeof encoding === 'string') {
      buf.fill(fill, encoding)
    } else {
      buf.fill(fill)
    }
  } else {
    buf.fill(0)
  }
  return buf
}

SafeBuffer.allocUnsafe = function (size) {
  if (typeof size !== 'number') {
    throw new TypeError('Argument must be a number')
  }
  return Buffer(size)
}

SafeBuffer.allocUnsafeSlow = function (size) {
  if (typeof size !== 'number') {
    throw new TypeError('Argument must be a number')
  }
  return buffer.SlowBuffer(size)
}


/***/ }),

/***/ 34859:
/***/ (function(module, exports) {

"use strict";


const { hasOwnProperty } = Object.prototype

const stringify = configure()

// @ts-expect-error
stringify.configure = configure
// @ts-expect-error
stringify.stringify = stringify

// @ts-expect-error
stringify.default = stringify

// @ts-expect-error used for named export
exports.stringify = stringify
// @ts-expect-error used for named export
exports.configure = configure

module.exports = stringify

// eslint-disable-next-line no-control-regex
const strEscapeSequencesRegExp = /[\u0000-\u001f\u0022\u005c\ud800-\udfff]/

// Escape C0 control characters, double quotes, the backslash and every code
// unit with a numeric value in the inclusive range 0xD800 to 0xDFFF.
function strEscape (str) {
  // Some magic numbers that worked out fine while benchmarking with v8 8.0
  if (str.length < 5000 && !strEscapeSequencesRegExp.test(str)) {
    return `"${str}"`
  }
  return JSON.stringify(str)
}

function sort (array, comparator) {
  // Insertion sort is very efficient for small input sizes, but it has a bad
  // worst case complexity. Thus, use native array sort for bigger values.
  if (array.length > 2e2 || comparator) {
    return array.sort(comparator)
  }
  for (let i = 1; i < array.length; i++) {
    const currentValue = array[i]
    let position = i
    while (position !== 0 && array[position - 1] > currentValue) {
      array[position] = array[position - 1]
      position--
    }
    array[position] = currentValue
  }
  return array
}

const typedArrayPrototypeGetSymbolToStringTag =
  Object.getOwnPropertyDescriptor(
    Object.getPrototypeOf(
      Object.getPrototypeOf(
        new Int8Array()
      )
    ),
    Symbol.toStringTag
  ).get

function isTypedArrayWithEntries (value) {
  return typedArrayPrototypeGetSymbolToStringTag.call(value) !== undefined && value.length !== 0
}

function stringifyTypedArray (array, separator, maximumBreadth) {
  if (array.length < maximumBreadth) {
    maximumBreadth = array.length
  }
  const whitespace = separator === ',' ? '' : ' '
  let res = `"0":${whitespace}${array[0]}`
  for (let i = 1; i < maximumBreadth; i++) {
    res += `${separator}"${i}":${whitespace}${array[i]}`
  }
  return res
}

function getCircularValueOption (options) {
  if (hasOwnProperty.call(options, 'circularValue')) {
    const circularValue = options.circularValue
    if (typeof circularValue === 'string') {
      return `"${circularValue}"`
    }
    if (circularValue == null) {
      return circularValue
    }
    if (circularValue === Error || circularValue === TypeError) {
      return {
        toString () {
          throw new TypeError('Converting circular structure to JSON')
        }
      }
    }
    throw new TypeError('The "circularValue" argument must be of type string or the value null or undefined')
  }
  return '"[Circular]"'
}

function getDeterministicOption (options) {
  let value
  if (hasOwnProperty.call(options, 'deterministic')) {
    value = options.deterministic
    if (typeof value !== 'boolean' && typeof value !== 'function') {
      throw new TypeError('The "deterministic" argument must be of type boolean or comparator function')
    }
  }
  return value === undefined ? true : value
}

function getBooleanOption (options, key) {
  let value
  if (hasOwnProperty.call(options, key)) {
    value = options[key]
    if (typeof value !== 'boolean') {
      throw new TypeError(`The "${key}" argument must be of type boolean`)
    }
  }
  return value === undefined ? true : value
}

function getPositiveIntegerOption (options, key) {
  let value
  if (hasOwnProperty.call(options, key)) {
    value = options[key]
    if (typeof value !== 'number') {
      throw new TypeError(`The "${key}" argument must be of type number`)
    }
    if (!Number.isInteger(value)) {
      throw new TypeError(`The "${key}" argument must be an integer`)
    }
    if (value < 1) {
      throw new RangeError(`The "${key}" argument must be >= 1`)
    }
  }
  return value === undefined ? Infinity : value
}

function getItemCount (number) {
  if (number === 1) {
    return '1 item'
  }
  return `${number} items`
}

function getUniqueReplacerSet (replacerArray) {
  const replacerSet = new Set()
  for (const value of replacerArray) {
    if (typeof value === 'string' || typeof value === 'number') {
      replacerSet.add(String(value))
    }
  }
  return replacerSet
}

function getStrictOption (options) {
  if (hasOwnProperty.call(options, 'strict')) {
    const value = options.strict
    if (typeof value !== 'boolean') {
      throw new TypeError('The "strict" argument must be of type boolean')
    }
    if (value) {
      return (value) => {
        let message = `Object can not safely be stringified. Received type ${typeof value}`
        if (typeof value !== 'function') message += ` (${value.toString()})`
        throw new Error(message)
      }
    }
  }
}

function configure (options) {
  options = { ...options }
  const fail = getStrictOption(options)
  if (fail) {
    if (options.bigint === undefined) {
      options.bigint = false
    }
    if (!('circularValue' in options)) {
      options.circularValue = Error
    }
  }
  const circularValue = getCircularValueOption(options)
  const bigint = getBooleanOption(options, 'bigint')
  const deterministic = getDeterministicOption(options)
  const comparator = typeof deterministic === 'function' ? deterministic : undefined
  const maximumDepth = getPositiveIntegerOption(options, 'maximumDepth')
  const maximumBreadth = getPositiveIntegerOption(options, 'maximumBreadth')

  function stringifyFnReplacer (key, parent, stack, replacer, spacer, indentation) {
    let value = parent[key]

    if (typeof value === 'object' && value !== null && typeof value.toJSON === 'function') {
      value = value.toJSON(key)
    }
    value = replacer.call(parent, key, value)

    switch (typeof value) {
      case 'string':
        return strEscape(value)
      case 'object': {
        if (value === null) {
          return 'null'
        }
        if (stack.indexOf(value) !== -1) {
          return circularValue
        }

        let res = ''
        let join = ','
        const originalIndentation = indentation

        if (Array.isArray(value)) {
          if (value.length === 0) {
            return '[]'
          }
          if (maximumDepth < stack.length + 1) {
            return '"[Array]"'
          }
          stack.push(value)
          if (spacer !== '') {
            indentation += spacer
            res += `\n${indentation}`
            join = `,\n${indentation}`
          }
          const maximumValuesToStringify = Math.min(value.length, maximumBreadth)
          let i = 0
          for (; i < maximumValuesToStringify - 1; i++) {
            const tmp = stringifyFnReplacer(String(i), value, stack, replacer, spacer, indentation)
            res += tmp !== undefined ? tmp : 'null'
            res += join
          }
          const tmp = stringifyFnReplacer(String(i), value, stack, replacer, spacer, indentation)
          res += tmp !== undefined ? tmp : 'null'
          if (value.length - 1 > maximumBreadth) {
            const removedKeys = value.length - maximumBreadth - 1
            res += `${join}"... ${getItemCount(removedKeys)} not stringified"`
          }
          if (spacer !== '') {
            res += `\n${originalIndentation}`
          }
          stack.pop()
          return `[${res}]`
        }

        let keys = Object.keys(value)
        const keyLength = keys.length
        if (keyLength === 0) {
          return '{}'
        }
        if (maximumDepth < stack.length + 1) {
          return '"[Object]"'
        }
        let whitespace = ''
        let separator = ''
        if (spacer !== '') {
          indentation += spacer
          join = `,\n${indentation}`
          whitespace = ' '
        }
        const maximumPropertiesToStringify = Math.min(keyLength, maximumBreadth)
        if (deterministic && !isTypedArrayWithEntries(value)) {
          keys = sort(keys, comparator)
        }
        stack.push(value)
        for (let i = 0; i < maximumPropertiesToStringify; i++) {
          const key = keys[i]
          const tmp = stringifyFnReplacer(key, value, stack, replacer, spacer, indentation)
          if (tmp !== undefined) {
            res += `${separator}${strEscape(key)}:${whitespace}${tmp}`
            separator = join
          }
        }
        if (keyLength > maximumBreadth) {
          const removedKeys = keyLength - maximumBreadth
          res += `${separator}"...":${whitespace}"${getItemCount(removedKeys)} not stringified"`
          separator = join
        }
        if (spacer !== '' && separator.length > 1) {
          res = `\n${indentation}${res}\n${originalIndentation}`
        }
        stack.pop()
        return `{${res}}`
      }
      case 'number':
        return isFinite(value) ? String(value) : fail ? fail(value) : 'null'
      case 'boolean':
        return value === true ? 'true' : 'false'
      case 'undefined':
        return undefined
      case 'bigint':
        if (bigint) {
          return String(value)
        }
        // fallthrough
      default:
        return fail ? fail(value) : undefined
    }
  }

  function stringifyArrayReplacer (key, value, stack, replacer, spacer, indentation) {
    if (typeof value === 'object' && value !== null && typeof value.toJSON === 'function') {
      value = value.toJSON(key)
    }

    switch (typeof value) {
      case 'string':
        return strEscape(value)
      case 'object': {
        if (value === null) {
          return 'null'
        }
        if (stack.indexOf(value) !== -1) {
          return circularValue
        }

        const originalIndentation = indentation
        let res = ''
        let join = ','

        if (Array.isArray(value)) {
          if (value.length === 0) {
            return '[]'
          }
          if (maximumDepth < stack.length + 1) {
            return '"[Array]"'
          }
          stack.push(value)
          if (spacer !== '') {
            indentation += spacer
            res += `\n${indentation}`
            join = `,\n${indentation}`
          }
          const maximumValuesToStringify = Math.min(value.length, maximumBreadth)
          let i = 0
          for (; i < maximumValuesToStringify - 1; i++) {
            const tmp = stringifyArrayReplacer(String(i), value[i], stack, replacer, spacer, indentation)
            res += tmp !== undefined ? tmp : 'null'
            res += join
          }
          const tmp = stringifyArrayReplacer(String(i), value[i], stack, replacer, spacer, indentation)
          res += tmp !== undefined ? tmp : 'null'
          if (value.length - 1 > maximumBreadth) {
            const removedKeys = value.length - maximumBreadth - 1
            res += `${join}"... ${getItemCount(removedKeys)} not stringified"`
          }
          if (spacer !== '') {
            res += `\n${originalIndentation}`
          }
          stack.pop()
          return `[${res}]`
        }
        stack.push(value)
        let whitespace = ''
        if (spacer !== '') {
          indentation += spacer
          join = `,\n${indentation}`
          whitespace = ' '
        }
        let separator = ''
        for (const key of replacer) {
          const tmp = stringifyArrayReplacer(key, value[key], stack, replacer, spacer, indentation)
          if (tmp !== undefined) {
            res += `${separator}${strEscape(key)}:${whitespace}${tmp}`
            separator = join
          }
        }
        if (spacer !== '' && separator.length > 1) {
          res = `\n${indentation}${res}\n${originalIndentation}`
        }
        stack.pop()
        return `{${res}}`
      }
      case 'number':
        return isFinite(value) ? String(value) : fail ? fail(value) : 'null'
      case 'boolean':
        return value === true ? 'true' : 'false'
      case 'undefined':
        return undefined
      case 'bigint':
        if (bigint) {
          return String(value)
        }
        // fallthrough
      default:
        return fail ? fail(value) : undefined
    }
  }

  function stringifyIndent (key, value, stack, spacer, indentation) {
    switch (typeof value) {
      case 'string':
        return strEscape(value)
      case 'object': {
        if (value === null) {
          return 'null'
        }
        if (typeof value.toJSON === 'function') {
          value = value.toJSON(key)
          // Prevent calling `toJSON` again.
          if (typeof value !== 'object') {
            return stringifyIndent(key, value, stack, spacer, indentation)
          }
          if (value === null) {
            return 'null'
          }
        }
        if (stack.indexOf(value) !== -1) {
          return circularValue
        }
        const originalIndentation = indentation

        if (Array.isArray(value)) {
          if (value.length === 0) {
            return '[]'
          }
          if (maximumDepth < stack.length + 1) {
            return '"[Array]"'
          }
          stack.push(value)
          indentation += spacer
          let res = `\n${indentation}`
          const join = `,\n${indentation}`
          const maximumValuesToStringify = Math.min(value.length, maximumBreadth)
          let i = 0
          for (; i < maximumValuesToStringify - 1; i++) {
            const tmp = stringifyIndent(String(i), value[i], stack, spacer, indentation)
            res += tmp !== undefined ? tmp : 'null'
            res += join
          }
          const tmp = stringifyIndent(String(i), value[i], stack, spacer, indentation)
          res += tmp !== undefined ? tmp : 'null'
          if (value.length - 1 > maximumBreadth) {
            const removedKeys = value.length - maximumBreadth - 1
            res += `${join}"... ${getItemCount(removedKeys)} not stringified"`
          }
          res += `\n${originalIndentation}`
          stack.pop()
          return `[${res}]`
        }

        let keys = Object.keys(value)
        const keyLength = keys.length
        if (keyLength === 0) {
          return '{}'
        }
        if (maximumDepth < stack.length + 1) {
          return '"[Object]"'
        }
        indentation += spacer
        const join = `,\n${indentation}`
        let res = ''
        let separator = ''
        let maximumPropertiesToStringify = Math.min(keyLength, maximumBreadth)
        if (isTypedArrayWithEntries(value)) {
          res += stringifyTypedArray(value, join, maximumBreadth)
          keys = keys.slice(value.length)
          maximumPropertiesToStringify -= value.length
          separator = join
        }
        if (deterministic) {
          keys = sort(keys, comparator)
        }
        stack.push(value)
        for (let i = 0; i < maximumPropertiesToStringify; i++) {
          const key = keys[i]
          const tmp = stringifyIndent(key, value[key], stack, spacer, indentation)
          if (tmp !== undefined) {
            res += `${separator}${strEscape(key)}: ${tmp}`
            separator = join
          }
        }
        if (keyLength > maximumBreadth) {
          const removedKeys = keyLength - maximumBreadth
          res += `${separator}"...": "${getItemCount(removedKeys)} not stringified"`
          separator = join
        }
        if (separator !== '') {
          res = `\n${indentation}${res}\n${originalIndentation}`
        }
        stack.pop()
        return `{${res}}`
      }
      case 'number':
        return isFinite(value) ? String(value) : fail ? fail(value) : 'null'
      case 'boolean':
        return value === true ? 'true' : 'false'
      case 'undefined':
        return undefined
      case 'bigint':
        if (bigint) {
          return String(value)
        }
        // fallthrough
      default:
        return fail ? fail(value) : undefined
    }
  }

  function stringifySimple (key, value, stack) {
    switch (typeof value) {
      case 'string':
        return strEscape(value)
      case 'object': {
        if (value === null) {
          return 'null'
        }
        if (typeof value.toJSON === 'function') {
          value = value.toJSON(key)
          // Prevent calling `toJSON` again
          if (typeof value !== 'object') {
            return stringifySimple(key, value, stack)
          }
          if (value === null) {
            return 'null'
          }
        }
        if (stack.indexOf(value) !== -1) {
          return circularValue
        }

        let res = ''

        const hasLength = value.length !== undefined
        if (hasLength && Array.isArray(value)) {
          if (value.length === 0) {
            return '[]'
          }
          if (maximumDepth < stack.length + 1) {
            return '"[Array]"'
          }
          stack.push(value)
          const maximumValuesToStringify = Math.min(value.length, maximumBreadth)
          let i = 0
          for (; i < maximumValuesToStringify - 1; i++) {
            const tmp = stringifySimple(String(i), value[i], stack)
            res += tmp !== undefined ? tmp : 'null'
            res += ','
          }
          const tmp = stringifySimple(String(i), value[i], stack)
          res += tmp !== undefined ? tmp : 'null'
          if (value.length - 1 > maximumBreadth) {
            const removedKeys = value.length - maximumBreadth - 1
            res += `,"... ${getItemCount(removedKeys)} not stringified"`
          }
          stack.pop()
          return `[${res}]`
        }

        let keys = Object.keys(value)
        const keyLength = keys.length
        if (keyLength === 0) {
          return '{}'
        }
        if (maximumDepth < stack.length + 1) {
          return '"[Object]"'
        }
        let separator = ''
        let maximumPropertiesToStringify = Math.min(keyLength, maximumBreadth)
        if (hasLength && isTypedArrayWithEntries(value)) {
          res += stringifyTypedArray(value, ',', maximumBreadth)
          keys = keys.slice(value.length)
          maximumPropertiesToStringify -= value.length
          separator = ','
        }
        if (deterministic) {
          keys = sort(keys, comparator)
        }
        stack.push(value)
        for (let i = 0; i < maximumPropertiesToStringify; i++) {
          const key = keys[i]
          const tmp = stringifySimple(key, value[key], stack)
          if (tmp !== undefined) {
            res += `${separator}${strEscape(key)}:${tmp}`
            separator = ','
          }
        }
        if (keyLength > maximumBreadth) {
          const removedKeys = keyLength - maximumBreadth
          res += `${separator}"...":"${getItemCount(removedKeys)} not stringified"`
        }
        stack.pop()
        return `{${res}}`
      }
      case 'number':
        return isFinite(value) ? String(value) : fail ? fail(value) : 'null'
      case 'boolean':
        return value === true ? 'true' : 'false'
      case 'undefined':
        return undefined
      case 'bigint':
        if (bigint) {
          return String(value)
        }
        // fallthrough
      default:
        return fail ? fail(value) : undefined
    }
  }

  function stringify (value, replacer, space) {
    if (arguments.length > 1) {
      let spacer = ''
      if (typeof space === 'number') {
        spacer = ' '.repeat(Math.min(space, 10))
      } else if (typeof space === 'string') {
        spacer = space.slice(0, 10)
      }
      if (replacer != null) {
        if (typeof replacer === 'function') {
          return stringifyFnReplacer('', { '': value }, [], replacer, spacer, '')
        }
        if (Array.isArray(replacer)) {
          return stringifyArrayReplacer('', value, [], getUniqueReplacerSet(replacer), spacer, '')
        }
      }
      if (spacer.length !== 0) {
        return stringifyIndent('', value, [], spacer, '')
      }
    }
    return stringifySimple('', value, [])
  }

  return stringify
}


/***/ }),

/***/ 1118:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var GetIntrinsic = __webpack_require__(67415);
var define = __webpack_require__(18003);
var hasDescriptors = __webpack_require__(94074)();
var gOPD = __webpack_require__(70658);

var $TypeError = __webpack_require__(29837);
var $floor = GetIntrinsic('%Math.floor%');

/** @type {import('.')} */
module.exports = function setFunctionLength(fn, length) {
	if (typeof fn !== 'function') {
		throw new $TypeError('`fn` is not a function');
	}
	if (typeof length !== 'number' || length < 0 || length > 0xFFFFFFFF || $floor(length) !== length) {
		throw new $TypeError('`length` must be a positive 32-bit integer');
	}

	var loose = arguments.length > 2 && !!arguments[2];

	var functionLengthIsConfigurable = true;
	var functionLengthIsWritable = true;
	if ('length' in fn && gOPD) {
		var desc = gOPD(fn, 'length');
		if (desc && !desc.configurable) {
			functionLengthIsConfigurable = false;
		}
		if (desc && !desc.writable) {
			functionLengthIsWritable = false;
		}
	}

	if (functionLengthIsConfigurable || functionLengthIsWritable || !loose) {
		if (hasDescriptors) {
			define(/** @type {Parameters<define>[0]} */ (fn), 'length', length, true, true);
		} else {
			define(/** @type {Parameters<define>[0]} */ (fn), 'length', length);
		}
	}
	return fn;
};


/***/ }),

/***/ 77700:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var GetIntrinsic = __webpack_require__(67415);
var callBound = __webpack_require__(74161);
var inspect = __webpack_require__(93321);

var $TypeError = __webpack_require__(29837);
var $WeakMap = GetIntrinsic('%WeakMap%', true);
var $Map = GetIntrinsic('%Map%', true);

var $weakMapGet = callBound('WeakMap.prototype.get', true);
var $weakMapSet = callBound('WeakMap.prototype.set', true);
var $weakMapHas = callBound('WeakMap.prototype.has', true);
var $mapGet = callBound('Map.prototype.get', true);
var $mapSet = callBound('Map.prototype.set', true);
var $mapHas = callBound('Map.prototype.has', true);

/*
* This function traverses the list returning the node corresponding to the given key.
*
* That node is also moved to the head of the list, so that if it's accessed again we don't need to traverse the whole list. By doing so, all the recently used nodes can be accessed relatively quickly.
*/
/** @type {import('.').listGetNode} */
var listGetNode = function (list, key) { // eslint-disable-line consistent-return
	/** @type {typeof list | NonNullable<(typeof list)['next']>} */
	var prev = list;
	/** @type {(typeof list)['next']} */
	var curr;
	for (; (curr = prev.next) !== null; prev = curr) {
		if (curr.key === key) {
			prev.next = curr.next;
			// eslint-disable-next-line no-extra-parens
			curr.next = /** @type {NonNullable<typeof list.next>} */ (list.next);
			list.next = curr; // eslint-disable-line no-param-reassign
			return curr;
		}
	}
};

/** @type {import('.').listGet} */
var listGet = function (objects, key) {
	var node = listGetNode(objects, key);
	return node && node.value;
};
/** @type {import('.').listSet} */
var listSet = function (objects, key, value) {
	var node = listGetNode(objects, key);
	if (node) {
		node.value = value;
	} else {
		// Prepend the new node to the beginning of the list
		objects.next = /** @type {import('.').ListNode<typeof value>} */ ({ // eslint-disable-line no-param-reassign, no-extra-parens
			key: key,
			next: objects.next,
			value: value
		});
	}
};
/** @type {import('.').listHas} */
var listHas = function (objects, key) {
	return !!listGetNode(objects, key);
};

/** @type {import('.')} */
module.exports = function getSideChannel() {
	/** @type {WeakMap<object, unknown>} */ var $wm;
	/** @type {Map<object, unknown>} */ var $m;
	/** @type {import('.').RootNode<unknown>} */ var $o;

	/** @type {import('.').Channel} */
	var channel = {
		assert: function (key) {
			if (!channel.has(key)) {
				throw new $TypeError('Side channel does not contain ' + inspect(key));
			}
		},
		get: function (key) { // eslint-disable-line consistent-return
			if ($WeakMap && key && (typeof key === 'object' || typeof key === 'function')) {
				if ($wm) {
					return $weakMapGet($wm, key);
				}
			} else if ($Map) {
				if ($m) {
					return $mapGet($m, key);
				}
			} else {
				if ($o) { // eslint-disable-line no-lonely-if
					return listGet($o, key);
				}
			}
		},
		has: function (key) {
			if ($WeakMap && key && (typeof key === 'object' || typeof key === 'function')) {
				if ($wm) {
					return $weakMapHas($wm, key);
				}
			} else if ($Map) {
				if ($m) {
					return $mapHas($m, key);
				}
			} else {
				if ($o) { // eslint-disable-line no-lonely-if
					return listHas($o, key);
				}
			}
			return false;
		},
		set: function (key, value) {
			if ($WeakMap && key && (typeof key === 'object' || typeof key === 'function')) {
				if (!$wm) {
					$wm = new $WeakMap();
				}
				$weakMapSet($wm, key, value);
			} else if ($Map) {
				if (!$m) {
					$m = new $Map();
				}
				$mapSet($m, key, value);
			} else {
				if (!$o) {
					// Initialize the linked list as an empty node, so that we don't have to special-case handling of the first node: we can always refer to it as (previous node).next, instead of something like (list).head
					$o = { key: {}, next: null };
				}
				listSet($o, key, value);
			}
		}
	};
	return channel;
};


/***/ }),

/***/ 79008:
/***/ (function(__unused_webpack_module, exports) {

exports.get = function(belowFn) {
  var oldLimit = Error.stackTraceLimit;
  Error.stackTraceLimit = Infinity;

  var dummyObject = {};

  var v8Handler = Error.prepareStackTrace;
  Error.prepareStackTrace = function(dummyObject, v8StackTrace) {
    return v8StackTrace;
  };
  Error.captureStackTrace(dummyObject, belowFn || exports.get);

  var v8StackTrace = dummyObject.stack;
  Error.prepareStackTrace = v8Handler;
  Error.stackTraceLimit = oldLimit;

  return v8StackTrace;
};

exports.parse = function(err) {
  if (!err.stack) {
    return [];
  }

  var self = this;
  var lines = err.stack.split('\n').slice(1);

  return lines
    .map(function(line) {
      if (line.match(/^\s*[-]{4,}$/)) {
        return self._createParsedCallSite({
          fileName: line,
          lineNumber: null,
          functionName: null,
          typeName: null,
          methodName: null,
          columnNumber: null,
          'native': null,
        });
      }

      var lineMatch = line.match(/at (?:(.+)\s+\()?(?:(.+?):(\d+)(?::(\d+))?|([^)]+))\)?/);
      if (!lineMatch) {
        return;
      }

      var object = null;
      var method = null;
      var functionName = null;
      var typeName = null;
      var methodName = null;
      var isNative = (lineMatch[5] === 'native');

      if (lineMatch[1]) {
        functionName = lineMatch[1];
        var methodStart = functionName.lastIndexOf('.');
        if (functionName[methodStart-1] == '.')
          methodStart--;
        if (methodStart > 0) {
          object = functionName.substr(0, methodStart);
          method = functionName.substr(methodStart + 1);
          var objectEnd = object.indexOf('.Module');
          if (objectEnd > 0) {
            functionName = functionName.substr(objectEnd + 1);
            object = object.substr(0, objectEnd);
          }
        }
        typeName = null;
      }

      if (method) {
        typeName = object;
        methodName = method;
      }

      if (method === '<anonymous>') {
        methodName = null;
        functionName = null;
      }

      var properties = {
        fileName: lineMatch[2] || null,
        lineNumber: parseInt(lineMatch[3], 10) || null,
        functionName: functionName,
        typeName: typeName,
        methodName: methodName,
        columnNumber: parseInt(lineMatch[4], 10) || null,
        'native': isNative,
      };

      return self._createParsedCallSite(properties);
    })
    .filter(function(callSite) {
      return !!callSite;
    });
};

function CallSite(properties) {
  for (var property in properties) {
    this[property] = properties[property];
  }
}

var strProperties = [
  'this',
  'typeName',
  'functionName',
  'methodName',
  'fileName',
  'lineNumber',
  'columnNumber',
  'function',
  'evalOrigin'
];
var boolProperties = [
  'topLevel',
  'eval',
  'native',
  'constructor'
];
strProperties.forEach(function (property) {
  CallSite.prototype[property] = null;
  CallSite.prototype['get' + property[0].toUpperCase() + property.substr(1)] = function () {
    return this[property];
  }
});
boolProperties.forEach(function (property) {
  CallSite.prototype[property] = false;
  CallSite.prototype['is' + property[0].toUpperCase() + property.substr(1)] = function () {
    return this[property];
  }
});

exports._createParsedCallSite = function(properties) {
  return new CallSite(properties);
};


/***/ }),

/***/ 72699:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.



/*<replacement>*/

var Buffer = (__webpack_require__(61874).Buffer);
/*</replacement>*/

var isEncoding = Buffer.isEncoding || function (encoding) {
  encoding = '' + encoding;
  switch (encoding && encoding.toLowerCase()) {
    case 'hex':case 'utf8':case 'utf-8':case 'ascii':case 'binary':case 'base64':case 'ucs2':case 'ucs-2':case 'utf16le':case 'utf-16le':case 'raw':
      return true;
    default:
      return false;
  }
};

function _normalizeEncoding(enc) {
  if (!enc) return 'utf8';
  var retried;
  while (true) {
    switch (enc) {
      case 'utf8':
      case 'utf-8':
        return 'utf8';
      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return 'utf16le';
      case 'latin1':
      case 'binary':
        return 'latin1';
      case 'base64':
      case 'ascii':
      case 'hex':
        return enc;
      default:
        if (retried) return; // undefined
        enc = ('' + enc).toLowerCase();
        retried = true;
    }
  }
};

// Do not cache `Buffer.isEncoding` when checking encoding names as some
// modules monkey-patch it to support additional encodings
function normalizeEncoding(enc) {
  var nenc = _normalizeEncoding(enc);
  if (typeof nenc !== 'string' && (Buffer.isEncoding === isEncoding || !isEncoding(enc))) throw new Error('Unknown encoding: ' + enc);
  return nenc || enc;
}

// StringDecoder provides an interface for efficiently splitting a series of
// buffers into a series of JS strings without breaking apart multi-byte
// characters.
exports.StringDecoder = StringDecoder;
function StringDecoder(encoding) {
  this.encoding = normalizeEncoding(encoding);
  var nb;
  switch (this.encoding) {
    case 'utf16le':
      this.text = utf16Text;
      this.end = utf16End;
      nb = 4;
      break;
    case 'utf8':
      this.fillLast = utf8FillLast;
      nb = 4;
      break;
    case 'base64':
      this.text = base64Text;
      this.end = base64End;
      nb = 3;
      break;
    default:
      this.write = simpleWrite;
      this.end = simpleEnd;
      return;
  }
  this.lastNeed = 0;
  this.lastTotal = 0;
  this.lastChar = Buffer.allocUnsafe(nb);
}

StringDecoder.prototype.write = function (buf) {
  if (buf.length === 0) return '';
  var r;
  var i;
  if (this.lastNeed) {
    r = this.fillLast(buf);
    if (r === undefined) return '';
    i = this.lastNeed;
    this.lastNeed = 0;
  } else {
    i = 0;
  }
  if (i < buf.length) return r ? r + this.text(buf, i) : this.text(buf, i);
  return r || '';
};

StringDecoder.prototype.end = utf8End;

// Returns only complete characters in a Buffer
StringDecoder.prototype.text = utf8Text;

// Attempts to complete a partial non-UTF-8 character using bytes from a Buffer
StringDecoder.prototype.fillLast = function (buf) {
  if (this.lastNeed <= buf.length) {
    buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, this.lastNeed);
    return this.lastChar.toString(this.encoding, 0, this.lastTotal);
  }
  buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, buf.length);
  this.lastNeed -= buf.length;
};

// Checks the type of a UTF-8 byte, whether it's ASCII, a leading byte, or a
// continuation byte. If an invalid byte is detected, -2 is returned.
function utf8CheckByte(byte) {
  if (byte <= 0x7F) return 0;else if (byte >> 5 === 0x06) return 2;else if (byte >> 4 === 0x0E) return 3;else if (byte >> 3 === 0x1E) return 4;
  return byte >> 6 === 0x02 ? -1 : -2;
}

// Checks at most 3 bytes at the end of a Buffer in order to detect an
// incomplete multi-byte UTF-8 character. The total number of bytes (2, 3, or 4)
// needed to complete the UTF-8 character (if applicable) are returned.
function utf8CheckIncomplete(self, buf, i) {
  var j = buf.length - 1;
  if (j < i) return 0;
  var nb = utf8CheckByte(buf[j]);
  if (nb >= 0) {
    if (nb > 0) self.lastNeed = nb - 1;
    return nb;
  }
  if (--j < i || nb === -2) return 0;
  nb = utf8CheckByte(buf[j]);
  if (nb >= 0) {
    if (nb > 0) self.lastNeed = nb - 2;
    return nb;
  }
  if (--j < i || nb === -2) return 0;
  nb = utf8CheckByte(buf[j]);
  if (nb >= 0) {
    if (nb > 0) {
      if (nb === 2) nb = 0;else self.lastNeed = nb - 3;
    }
    return nb;
  }
  return 0;
}

// Validates as many continuation bytes for a multi-byte UTF-8 character as
// needed or are available. If we see a non-continuation byte where we expect
// one, we "replace" the validated continuation bytes we've seen so far with
// a single UTF-8 replacement character ('\ufffd'), to match v8's UTF-8 decoding
// behavior. The continuation byte check is included three times in the case
// where all of the continuation bytes for a character exist in the same buffer.
// It is also done this way as a slight performance increase instead of using a
// loop.
function utf8CheckExtraBytes(self, buf, p) {
  if ((buf[0] & 0xC0) !== 0x80) {
    self.lastNeed = 0;
    return '\ufffd';
  }
  if (self.lastNeed > 1 && buf.length > 1) {
    if ((buf[1] & 0xC0) !== 0x80) {
      self.lastNeed = 1;
      return '\ufffd';
    }
    if (self.lastNeed > 2 && buf.length > 2) {
      if ((buf[2] & 0xC0) !== 0x80) {
        self.lastNeed = 2;
        return '\ufffd';
      }
    }
  }
}

// Attempts to complete a multi-byte UTF-8 character using bytes from a Buffer.
function utf8FillLast(buf) {
  var p = this.lastTotal - this.lastNeed;
  var r = utf8CheckExtraBytes(this, buf, p);
  if (r !== undefined) return r;
  if (this.lastNeed <= buf.length) {
    buf.copy(this.lastChar, p, 0, this.lastNeed);
    return this.lastChar.toString(this.encoding, 0, this.lastTotal);
  }
  buf.copy(this.lastChar, p, 0, buf.length);
  this.lastNeed -= buf.length;
}

// Returns all complete UTF-8 characters in a Buffer. If the Buffer ended on a
// partial character, the character's bytes are buffered until the required
// number of bytes are available.
function utf8Text(buf, i) {
  var total = utf8CheckIncomplete(this, buf, i);
  if (!this.lastNeed) return buf.toString('utf8', i);
  this.lastTotal = total;
  var end = buf.length - (total - this.lastNeed);
  buf.copy(this.lastChar, 0, end);
  return buf.toString('utf8', i, end);
}

// For UTF-8, a replacement character is added when ending on a partial
// character.
function utf8End(buf) {
  var r = buf && buf.length ? this.write(buf) : '';
  if (this.lastNeed) return r + '\ufffd';
  return r;
}

// UTF-16LE typically needs two bytes per character, but even if we have an even
// number of bytes available, we need to check if we end on a leading/high
// surrogate. In that case, we need to wait for the next two bytes in order to
// decode the last character properly.
function utf16Text(buf, i) {
  if ((buf.length - i) % 2 === 0) {
    var r = buf.toString('utf16le', i);
    if (r) {
      var c = r.charCodeAt(r.length - 1);
      if (c >= 0xD800 && c <= 0xDBFF) {
        this.lastNeed = 2;
        this.lastTotal = 4;
        this.lastChar[0] = buf[buf.length - 2];
        this.lastChar[1] = buf[buf.length - 1];
        return r.slice(0, -1);
      }
    }
    return r;
  }
  this.lastNeed = 1;
  this.lastTotal = 2;
  this.lastChar[0] = buf[buf.length - 1];
  return buf.toString('utf16le', i, buf.length - 1);
}

// For UTF-16LE we do not explicitly append special replacement characters if we
// end on a partial character, we simply let v8 handle that.
function utf16End(buf) {
  var r = buf && buf.length ? this.write(buf) : '';
  if (this.lastNeed) {
    var end = this.lastTotal - this.lastNeed;
    return r + this.lastChar.toString('utf16le', 0, end);
  }
  return r;
}

function base64Text(buf, i) {
  var n = (buf.length - i) % 3;
  if (n === 0) return buf.toString('base64', i);
  this.lastNeed = 3 - n;
  this.lastTotal = 3;
  if (n === 1) {
    this.lastChar[0] = buf[buf.length - 1];
  } else {
    this.lastChar[0] = buf[buf.length - 2];
    this.lastChar[1] = buf[buf.length - 1];
  }
  return buf.toString('base64', i, buf.length - n);
}

function base64End(buf) {
  var r = buf && buf.length ? this.write(buf) : '';
  if (this.lastNeed) return r + this.lastChar.toString('base64', 0, 3 - this.lastNeed);
  return r;
}

// Pass bytes on through for single-byte encodings (e.g. ascii, latin1, hex)
function simpleWrite(buf) {
  return buf.toString(this.encoding);
}

function simpleEnd(buf) {
  return buf && buf.length ? this.write(buf) : '';
}

/***/ }),

/***/ 33699:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "focusable": function() { return /* binding */ focusable; },
/* harmony export */   "isFocusable": function() { return /* binding */ isFocusable; },
/* harmony export */   "isTabbable": function() { return /* binding */ isTabbable; },
/* harmony export */   "tabbable": function() { return /* binding */ tabbable; }
/* harmony export */ });
/*!
* tabbable 5.3.3
* @license MIT, https://github.com/focus-trap/tabbable/blob/master/LICENSE
*/
var candidateSelectors = ['input', 'select', 'textarea', 'a[href]', 'button', '[tabindex]:not(slot)', 'audio[controls]', 'video[controls]', '[contenteditable]:not([contenteditable="false"])', 'details>summary:first-of-type', 'details'];
var candidateSelector = /* #__PURE__ */candidateSelectors.join(',');
var NoElement = typeof Element === 'undefined';
var matches = NoElement ? function () {} : Element.prototype.matches || Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector;
var getRootNode = !NoElement && Element.prototype.getRootNode ? function (element) {
  return element.getRootNode();
} : function (element) {
  return element.ownerDocument;
};
/**
 * @param {Element} el container to check in
 * @param {boolean} includeContainer add container to check
 * @param {(node: Element) => boolean} filter filter candidates
 * @returns {Element[]}
 */

var getCandidates = function getCandidates(el, includeContainer, filter) {
  var candidates = Array.prototype.slice.apply(el.querySelectorAll(candidateSelector));

  if (includeContainer && matches.call(el, candidateSelector)) {
    candidates.unshift(el);
  }

  candidates = candidates.filter(filter);
  return candidates;
};
/**
 * @callback GetShadowRoot
 * @param {Element} element to check for shadow root
 * @returns {ShadowRoot|boolean} ShadowRoot if available or boolean indicating if a shadowRoot is attached but not available.
 */

/**
 * @callback ShadowRootFilter
 * @param {Element} shadowHostNode the element which contains shadow content
 * @returns {boolean} true if a shadow root could potentially contain valid candidates.
 */

/**
 * @typedef {Object} CandidatesScope
 * @property {Element} scope contains inner candidates
 * @property {Element[]} candidates
 */

/**
 * @typedef {Object} IterativeOptions
 * @property {GetShadowRoot|boolean} getShadowRoot true if shadow support is enabled; falsy if not;
 *  if a function, implies shadow support is enabled and either returns the shadow root of an element
 *  or a boolean stating if it has an undisclosed shadow root
 * @property {(node: Element) => boolean} filter filter candidates
 * @property {boolean} flatten if true then result will flatten any CandidatesScope into the returned list
 * @property {ShadowRootFilter} shadowRootFilter filter shadow roots;
 */

/**
 * @param {Element[]} elements list of element containers to match candidates from
 * @param {boolean} includeContainer add container list to check
 * @param {IterativeOptions} options
 * @returns {Array.<Element|CandidatesScope>}
 */


var getCandidatesIteratively = function getCandidatesIteratively(elements, includeContainer, options) {
  var candidates = [];
  var elementsToCheck = Array.from(elements);

  while (elementsToCheck.length) {
    var element = elementsToCheck.shift();

    if (element.tagName === 'SLOT') {
      // add shadow dom slot scope (slot itself cannot be focusable)
      var assigned = element.assignedElements();
      var content = assigned.length ? assigned : element.children;
      var nestedCandidates = getCandidatesIteratively(content, true, options);

      if (options.flatten) {
        candidates.push.apply(candidates, nestedCandidates);
      } else {
        candidates.push({
          scope: element,
          candidates: nestedCandidates
        });
      }
    } else {
      // check candidate element
      var validCandidate = matches.call(element, candidateSelector);

      if (validCandidate && options.filter(element) && (includeContainer || !elements.includes(element))) {
        candidates.push(element);
      } // iterate over shadow content if possible


      var shadowRoot = element.shadowRoot || // check for an undisclosed shadow
      typeof options.getShadowRoot === 'function' && options.getShadowRoot(element);
      var validShadowRoot = !options.shadowRootFilter || options.shadowRootFilter(element);

      if (shadowRoot && validShadowRoot) {
        // add shadow dom scope IIF a shadow root node was given; otherwise, an undisclosed
        //  shadow exists, so look at light dom children as fallback BUT create a scope for any
        //  child candidates found because they're likely slotted elements (elements that are
        //  children of the web component element (which has the shadow), in the light dom, but
        //  slotted somewhere _inside_ the undisclosed shadow) -- the scope is created below,
        //  _after_ we return from this recursive call
        var _nestedCandidates = getCandidatesIteratively(shadowRoot === true ? element.children : shadowRoot.children, true, options);

        if (options.flatten) {
          candidates.push.apply(candidates, _nestedCandidates);
        } else {
          candidates.push({
            scope: element,
            candidates: _nestedCandidates
          });
        }
      } else {
        // there's not shadow so just dig into the element's (light dom) children
        //  __without__ giving the element special scope treatment
        elementsToCheck.unshift.apply(elementsToCheck, element.children);
      }
    }
  }

  return candidates;
};

var getTabindex = function getTabindex(node, isScope) {
  if (node.tabIndex < 0) {
    // in Chrome, <details/>, <audio controls/> and <video controls/> elements get a default
    // `tabIndex` of -1 when the 'tabindex' attribute isn't specified in the DOM,
    // yet they are still part of the regular tab order; in FF, they get a default
    // `tabIndex` of 0; since Chrome still puts those elements in the regular tab
    // order, consider their tab index to be 0.
    // Also browsers do not return `tabIndex` correctly for contentEditable nodes;
    // so if they don't have a tabindex attribute specifically set, assume it's 0.
    //
    // isScope is positive for custom element with shadow root or slot that by default
    // have tabIndex -1, but need to be sorted by document order in order for their
    // content to be inserted in the correct position
    if ((isScope || /^(AUDIO|VIDEO|DETAILS)$/.test(node.tagName) || node.isContentEditable) && isNaN(parseInt(node.getAttribute('tabindex'), 10))) {
      return 0;
    }
  }

  return node.tabIndex;
};

var sortOrderedTabbables = function sortOrderedTabbables(a, b) {
  return a.tabIndex === b.tabIndex ? a.documentOrder - b.documentOrder : a.tabIndex - b.tabIndex;
};

var isInput = function isInput(node) {
  return node.tagName === 'INPUT';
};

var isHiddenInput = function isHiddenInput(node) {
  return isInput(node) && node.type === 'hidden';
};

var isDetailsWithSummary = function isDetailsWithSummary(node) {
  var r = node.tagName === 'DETAILS' && Array.prototype.slice.apply(node.children).some(function (child) {
    return child.tagName === 'SUMMARY';
  });
  return r;
};

var getCheckedRadio = function getCheckedRadio(nodes, form) {
  for (var i = 0; i < nodes.length; i++) {
    if (nodes[i].checked && nodes[i].form === form) {
      return nodes[i];
    }
  }
};

var isTabbableRadio = function isTabbableRadio(node) {
  if (!node.name) {
    return true;
  }

  var radioScope = node.form || getRootNode(node);

  var queryRadios = function queryRadios(name) {
    return radioScope.querySelectorAll('input[type="radio"][name="' + name + '"]');
  };

  var radioSet;

  if (typeof window !== 'undefined' && typeof window.CSS !== 'undefined' && typeof window.CSS.escape === 'function') {
    radioSet = queryRadios(window.CSS.escape(node.name));
  } else {
    try {
      radioSet = queryRadios(node.name);
    } catch (err) {
      // eslint-disable-next-line no-console
      console.error('Looks like you have a radio button with a name attribute containing invalid CSS selector characters and need the CSS.escape polyfill: %s', err.message);
      return false;
    }
  }

  var checked = getCheckedRadio(radioSet, node.form);
  return !checked || checked === node;
};

var isRadio = function isRadio(node) {
  return isInput(node) && node.type === 'radio';
};

var isNonTabbableRadio = function isNonTabbableRadio(node) {
  return isRadio(node) && !isTabbableRadio(node);
};

var isZeroArea = function isZeroArea(node) {
  var _node$getBoundingClie = node.getBoundingClientRect(),
      width = _node$getBoundingClie.width,
      height = _node$getBoundingClie.height;

  return width === 0 && height === 0;
};

var isHidden = function isHidden(node, _ref) {
  var displayCheck = _ref.displayCheck,
      getShadowRoot = _ref.getShadowRoot;

  // NOTE: visibility will be `undefined` if node is detached from the document
  //  (see notes about this further down), which means we will consider it visible
  //  (this is legacy behavior from a very long way back)
  // NOTE: we check this regardless of `displayCheck="none"` because this is a
  //  _visibility_ check, not a _display_ check
  if (getComputedStyle(node).visibility === 'hidden') {
    return true;
  }

  var isDirectSummary = matches.call(node, 'details>summary:first-of-type');
  var nodeUnderDetails = isDirectSummary ? node.parentElement : node;

  if (matches.call(nodeUnderDetails, 'details:not([open]) *')) {
    return true;
  } // The root node is the shadow root if the node is in a shadow DOM; some document otherwise
  //  (but NOT _the_ document; see second 'If' comment below for more).
  // If rootNode is shadow root, it'll have a host, which is the element to which the shadow
  //  is attached, and the one we need to check if it's in the document or not (because the
  //  shadow, and all nodes it contains, is never considered in the document since shadows
  //  behave like self-contained DOMs; but if the shadow's HOST, which is part of the document,
  //  is hidden, or is not in the document itself but is detached, it will affect the shadow's
  //  visibility, including all the nodes it contains). The host could be any normal node,
  //  or a custom element (i.e. web component). Either way, that's the one that is considered
  //  part of the document, not the shadow root, nor any of its children (i.e. the node being
  //  tested).
  // If rootNode is not a shadow root, it won't have a host, and so rootNode should be the
  //  document (per the docs) and while it's a Document-type object, that document does not
  //  appear to be the same as the node's `ownerDocument` for some reason, so it's safer
  //  to ignore the rootNode at this point, and use `node.ownerDocument`. Otherwise,
  //  using `rootNode.contains(node)` will _always_ be true we'll get false-positives when
  //  node is actually detached.


  var nodeRootHost = getRootNode(node).host;
  var nodeIsAttached = (nodeRootHost === null || nodeRootHost === void 0 ? void 0 : nodeRootHost.ownerDocument.contains(nodeRootHost)) || node.ownerDocument.contains(node);

  if (!displayCheck || displayCheck === 'full') {
    if (typeof getShadowRoot === 'function') {
      // figure out if we should consider the node to be in an undisclosed shadow and use the
      //  'non-zero-area' fallback
      var originalNode = node;

      while (node) {
        var parentElement = node.parentElement;
        var rootNode = getRootNode(node);

        if (parentElement && !parentElement.shadowRoot && getShadowRoot(parentElement) === true // check if there's an undisclosed shadow
        ) {
          // node has an undisclosed shadow which means we can only treat it as a black box, so we
          //  fall back to a non-zero-area test
          return isZeroArea(node);
        } else if (node.assignedSlot) {
          // iterate up slot
          node = node.assignedSlot;
        } else if (!parentElement && rootNode !== node.ownerDocument) {
          // cross shadow boundary
          node = rootNode.host;
        } else {
          // iterate up normal dom
          node = parentElement;
        }
      }

      node = originalNode;
    } // else, `getShadowRoot` might be true, but all that does is enable shadow DOM support
    //  (i.e. it does not also presume that all nodes might have undisclosed shadows); or
    //  it might be a falsy value, which means shadow DOM support is disabled
    // Since we didn't find it sitting in an undisclosed shadow (or shadows are disabled)
    //  now we can just test to see if it would normally be visible or not, provided it's
    //  attached to the main document.
    // NOTE: We must consider case where node is inside a shadow DOM and given directly to
    //  `isTabbable()` or `isFocusable()` -- regardless of `getShadowRoot` option setting.


    if (nodeIsAttached) {
      // this works wherever the node is: if there's at least one client rect, it's
      //  somehow displayed; it also covers the CSS 'display: contents' case where the
      //  node itself is hidden in place of its contents; and there's no need to search
      //  up the hierarchy either
      return !node.getClientRects().length;
    } // Else, the node isn't attached to the document, which means the `getClientRects()`
    //  API will __always__ return zero rects (this can happen, for example, if React
    //  is used to render nodes onto a detached tree, as confirmed in this thread:
    //  https://github.com/facebook/react/issues/9117#issuecomment-284228870)
    //
    // It also means that even window.getComputedStyle(node).display will return `undefined`
    //  because styles are only computed for nodes that are in the document.
    //
    // NOTE: THIS HAS BEEN THE CASE FOR YEARS. It is not new, nor is it caused by tabbable
    //  somehow. Though it was never stated officially, anyone who has ever used tabbable
    //  APIs on nodes in detached containers has actually implicitly used tabbable in what
    //  was later (as of v5.2.0 on Apr 9, 2021) called `displayCheck="none"` mode -- essentially
    //  considering __everything__ to be visible because of the innability to determine styles.

  } else if (displayCheck === 'non-zero-area') {
    // NOTE: Even though this tests that the node's client rect is non-zero to determine
    //  whether it's displayed, and that a detached node will __always__ have a zero-area
    //  client rect, we don't special-case for whether the node is attached or not. In
    //  this mode, we do want to consider nodes that have a zero area to be hidden at all
    //  times, and that includes attached or not.
    return isZeroArea(node);
  } // visible, as far as we can tell, or per current `displayCheck` mode


  return false;
}; // form fields (nested) inside a disabled fieldset are not focusable/tabbable
//  unless they are in the _first_ <legend> element of the top-most disabled
//  fieldset


var isDisabledFromFieldset = function isDisabledFromFieldset(node) {
  if (/^(INPUT|BUTTON|SELECT|TEXTAREA)$/.test(node.tagName)) {
    var parentNode = node.parentElement; // check if `node` is contained in a disabled <fieldset>

    while (parentNode) {
      if (parentNode.tagName === 'FIELDSET' && parentNode.disabled) {
        // look for the first <legend> among the children of the disabled <fieldset>
        for (var i = 0; i < parentNode.children.length; i++) {
          var child = parentNode.children.item(i); // when the first <legend> (in document order) is found

          if (child.tagName === 'LEGEND') {
            // if its parent <fieldset> is not nested in another disabled <fieldset>,
            // return whether `node` is a descendant of its first <legend>
            return matches.call(parentNode, 'fieldset[disabled] *') ? true : !child.contains(node);
          }
        } // the disabled <fieldset> containing `node` has no <legend>


        return true;
      }

      parentNode = parentNode.parentElement;
    }
  } // else, node's tabbable/focusable state should not be affected by a fieldset's
  //  enabled/disabled state


  return false;
};

var isNodeMatchingSelectorFocusable = function isNodeMatchingSelectorFocusable(options, node) {
  if (node.disabled || isHiddenInput(node) || isHidden(node, options) || // For a details element with a summary, the summary element gets the focus
  isDetailsWithSummary(node) || isDisabledFromFieldset(node)) {
    return false;
  }

  return true;
};

var isNodeMatchingSelectorTabbable = function isNodeMatchingSelectorTabbable(options, node) {
  if (isNonTabbableRadio(node) || getTabindex(node) < 0 || !isNodeMatchingSelectorFocusable(options, node)) {
    return false;
  }

  return true;
};

var isValidShadowRootTabbable = function isValidShadowRootTabbable(shadowHostNode) {
  var tabIndex = parseInt(shadowHostNode.getAttribute('tabindex'), 10);

  if (isNaN(tabIndex) || tabIndex >= 0) {
    return true;
  } // If a custom element has an explicit negative tabindex,
  // browsers will not allow tab targeting said element's children.


  return false;
};
/**
 * @param {Array.<Element|CandidatesScope>} candidates
 * @returns Element[]
 */


var sortByOrder = function sortByOrder(candidates) {
  var regularTabbables = [];
  var orderedTabbables = [];
  candidates.forEach(function (item, i) {
    var isScope = !!item.scope;
    var element = isScope ? item.scope : item;
    var candidateTabindex = getTabindex(element, isScope);
    var elements = isScope ? sortByOrder(item.candidates) : element;

    if (candidateTabindex === 0) {
      isScope ? regularTabbables.push.apply(regularTabbables, elements) : regularTabbables.push(element);
    } else {
      orderedTabbables.push({
        documentOrder: i,
        tabIndex: candidateTabindex,
        item: item,
        isScope: isScope,
        content: elements
      });
    }
  });
  return orderedTabbables.sort(sortOrderedTabbables).reduce(function (acc, sortable) {
    sortable.isScope ? acc.push.apply(acc, sortable.content) : acc.push(sortable.content);
    return acc;
  }, []).concat(regularTabbables);
};

var tabbable = function tabbable(el, options) {
  options = options || {};
  var candidates;

  if (options.getShadowRoot) {
    candidates = getCandidatesIteratively([el], options.includeContainer, {
      filter: isNodeMatchingSelectorTabbable.bind(null, options),
      flatten: false,
      getShadowRoot: options.getShadowRoot,
      shadowRootFilter: isValidShadowRootTabbable
    });
  } else {
    candidates = getCandidates(el, options.includeContainer, isNodeMatchingSelectorTabbable.bind(null, options));
  }

  return sortByOrder(candidates);
};

var focusable = function focusable(el, options) {
  options = options || {};
  var candidates;

  if (options.getShadowRoot) {
    candidates = getCandidatesIteratively([el], options.includeContainer, {
      filter: isNodeMatchingSelectorFocusable.bind(null, options),
      flatten: true,
      getShadowRoot: options.getShadowRoot
    });
  } else {
    candidates = getCandidates(el, options.includeContainer, isNodeMatchingSelectorFocusable.bind(null, options));
  }

  return candidates;
};

var isTabbable = function isTabbable(node, options) {
  options = options || {};

  if (!node) {
    throw new Error('No node provided');
  }

  if (matches.call(node, candidateSelector) === false) {
    return false;
  }

  return isNodeMatchingSelectorTabbable(options, node);
};

var focusableCandidateSelector = /* #__PURE__ */candidateSelectors.concat('iframe').join(',');

var isFocusable = function isFocusable(node, options) {
  options = options || {};

  if (!node) {
    throw new Error('No node provided');
  }

  if (matches.call(node, focusableCandidateSelector) === false) {
    return false;
  }

  return isNodeMatchingSelectorFocusable(options, node);
};


//# sourceMappingURL=index.esm.js.map


/***/ }),

/***/ 60971:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
/**
 * cli.js: Config that conform to commonly used CLI logging levels.
 *
 * (C) 2010 Charlie Robbins
 * MIT LICENCE
 */



/**
 * Default levels for the CLI configuration.
 * @type {Object}
 */
exports.levels = {
  error: 0,
  warn: 1,
  help: 2,
  data: 3,
  info: 4,
  debug: 5,
  prompt: 6,
  verbose: 7,
  input: 8,
  silly: 9
};

/**
 * Default colors for the CLI configuration.
 * @type {Object}
 */
exports.colors = {
  error: 'red',
  warn: 'yellow',
  help: 'cyan',
  data: 'grey',
  info: 'green',
  debug: 'blue',
  prompt: 'grey',
  verbose: 'cyan',
  input: 'grey',
  silly: 'magenta'
};


/***/ }),

/***/ 98016:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
/**
 * index.js: Default settings for all levels that winston knows about.
 *
 * (C) 2010 Charlie Robbins
 * MIT LICENCE
 */



/**
 * Export config set for the CLI.
 * @type {Object}
 */
Object.defineProperty(exports, "cli", ({
  value: __webpack_require__(60971)
}));

/**
 * Export config set for npm.
 * @type {Object}
 */
Object.defineProperty(exports, "npm", ({
  value: __webpack_require__(87746)
}));

/**
 * Export config set for the syslog.
 * @type {Object}
 */
Object.defineProperty(exports, "syslog", ({
  value: __webpack_require__(65667)
}));


/***/ }),

/***/ 87746:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
/**
 * npm.js: Config that conform to npm logging levels.
 *
 * (C) 2010 Charlie Robbins
 * MIT LICENCE
 */



/**
 * Default levels for the npm configuration.
 * @type {Object}
 */
exports.levels = {
  error: 0,
  warn: 1,
  info: 2,
  http: 3,
  verbose: 4,
  debug: 5,
  silly: 6
};

/**
 * Default levels for the npm configuration.
 * @type {Object}
 */
exports.colors = {
  error: 'red',
  warn: 'yellow',
  info: 'green',
  http: 'green',
  verbose: 'cyan',
  debug: 'blue',
  silly: 'magenta'
};


/***/ }),

/***/ 65667:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
/**
 * syslog.js: Config that conform to syslog logging levels.
 *
 * (C) 2010 Charlie Robbins
 * MIT LICENCE
 */



/**
 * Default levels for the syslog configuration.
 * @type {Object}
 */
exports.levels = {
  emerg: 0,
  alert: 1,
  crit: 2,
  error: 3,
  warning: 4,
  notice: 5,
  info: 6,
  debug: 7
};

/**
 * Default levels for the syslog configuration.
 * @type {Object}
 */
exports.colors = {
  emerg: 'red',
  alert: 'yellow',
  crit: 'red',
  error: 'red',
  warning: 'red',
  notice: 'yellow',
  info: 'green',
  debug: 'blue'
};


/***/ }),

/***/ 27735:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


/**
 * A shareable symbol constant that can be used
 * as a non-enumerable / semi-hidden level identifier
 * to allow the readable level property to be mutable for
 * operations like colorization
 *
 * @type {Symbol}
 */
Object.defineProperty(exports, "LEVEL", ({
  value: Symbol.for('level')
}));

/**
 * A shareable symbol constant that can be used
 * as a non-enumerable / semi-hidden message identifier
 * to allow the final message property to not have
 * side effects on another.
 *
 * @type {Symbol}
 */
Object.defineProperty(exports, "MESSAGE", ({
  value: Symbol.for('message')
}));

/**
 * A shareable symbol constant that can be used
 * as a non-enumerable / semi-hidden message identifier
 * to allow the extracted splat property be hidden
 *
 * @type {Symbol}
 */
Object.defineProperty(exports, "SPLAT", ({
  value: Symbol.for('splat')
}));

/**
 * A shareable object constant  that can be used
 * as a standard configuration for winston@3.
 *
 * @type {Object}
 */
Object.defineProperty(exports, "configs", ({
  value: __webpack_require__(98016)
}));


/***/ }),

/***/ 93191:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;/////////////////////////////////////////////////////////////////////////////////
/* UAParser.js v1.0.39
   Copyright © 2012-2021 Faisal Salman <f@faisalman.com>
   MIT License *//*
   Detect Browser, Engine, OS, CPU, and Device type/model from User-Agent data.
   Supports browser & node.js environment. 
   Demo   : https://faisalman.github.io/ua-parser-js
   Source : https://github.com/faisalman/ua-parser-js */
/////////////////////////////////////////////////////////////////////////////////

(function (window, undefined) {

    'use strict';

    //////////////
    // Constants
    /////////////


    var LIBVERSION  = '1.0.39',
        EMPTY       = '',
        UNKNOWN     = '?',
        FUNC_TYPE   = 'function',
        UNDEF_TYPE  = 'undefined',
        OBJ_TYPE    = 'object',
        STR_TYPE    = 'string',
        MAJOR       = 'major',
        MODEL       = 'model',
        NAME        = 'name',
        TYPE        = 'type',
        VENDOR      = 'vendor',
        VERSION     = 'version',
        ARCHITECTURE= 'architecture',
        CONSOLE     = 'console',
        MOBILE      = 'mobile',
        TABLET      = 'tablet',
        SMARTTV     = 'smarttv',
        WEARABLE    = 'wearable',
        EMBEDDED    = 'embedded',
        UA_MAX_LENGTH = 500;

    var AMAZON  = 'Amazon',
        APPLE   = 'Apple',
        ASUS    = 'ASUS',
        BLACKBERRY = 'BlackBerry',
        BROWSER = 'Browser',
        CHROME  = 'Chrome',
        EDGE    = 'Edge',
        FIREFOX = 'Firefox',
        GOOGLE  = 'Google',
        HUAWEI  = 'Huawei',
        LG      = 'LG',
        MICROSOFT = 'Microsoft',
        MOTOROLA  = 'Motorola',
        OPERA   = 'Opera',
        SAMSUNG = 'Samsung',
        SHARP   = 'Sharp',
        SONY    = 'Sony',
        XIAOMI  = 'Xiaomi',
        ZEBRA   = 'Zebra',
        FACEBOOK    = 'Facebook',
        CHROMIUM_OS = 'Chromium OS',
        MAC_OS  = 'Mac OS',
        SUFFIX_BROWSER = ' Browser';

    ///////////
    // Helper
    //////////

    var extend = function (regexes, extensions) {
            var mergedRegexes = {};
            for (var i in regexes) {
                if (extensions[i] && extensions[i].length % 2 === 0) {
                    mergedRegexes[i] = extensions[i].concat(regexes[i]);
                } else {
                    mergedRegexes[i] = regexes[i];
                }
            }
            return mergedRegexes;
        },
        enumerize = function (arr) {
            var enums = {};
            for (var i=0; i<arr.length; i++) {
                enums[arr[i].toUpperCase()] = arr[i];
            }
            return enums;
        },
        has = function (str1, str2) {
            return typeof str1 === STR_TYPE ? lowerize(str2).indexOf(lowerize(str1)) !== -1 : false;
        },
        lowerize = function (str) {
            return str.toLowerCase();
        },
        majorize = function (version) {
            return typeof(version) === STR_TYPE ? version.replace(/[^\d\.]/g, EMPTY).split('.')[0] : undefined;
        },
        trim = function (str, len) {
            if (typeof(str) === STR_TYPE) {
                str = str.replace(/^\s\s*/, EMPTY);
                return typeof(len) === UNDEF_TYPE ? str : str.substring(0, UA_MAX_LENGTH);
            }
    };

    ///////////////
    // Map helper
    //////////////

    var rgxMapper = function (ua, arrays) {

            var i = 0, j, k, p, q, matches, match;

            // loop through all regexes maps
            while (i < arrays.length && !matches) {

                var regex = arrays[i],       // even sequence (0,2,4,..)
                    props = arrays[i + 1];   // odd sequence (1,3,5,..)
                j = k = 0;

                // try matching uastring with regexes
                while (j < regex.length && !matches) {

                    if (!regex[j]) { break; }
                    matches = regex[j++].exec(ua);

                    if (!!matches) {
                        for (p = 0; p < props.length; p++) {
                            match = matches[++k];
                            q = props[p];
                            // check if given property is actually array
                            if (typeof q === OBJ_TYPE && q.length > 0) {
                                if (q.length === 2) {
                                    if (typeof q[1] == FUNC_TYPE) {
                                        // assign modified match
                                        this[q[0]] = q[1].call(this, match);
                                    } else {
                                        // assign given value, ignore regex match
                                        this[q[0]] = q[1];
                                    }
                                } else if (q.length === 3) {
                                    // check whether function or regex
                                    if (typeof q[1] === FUNC_TYPE && !(q[1].exec && q[1].test)) {
                                        // call function (usually string mapper)
                                        this[q[0]] = match ? q[1].call(this, match, q[2]) : undefined;
                                    } else {
                                        // sanitize match using given regex
                                        this[q[0]] = match ? match.replace(q[1], q[2]) : undefined;
                                    }
                                } else if (q.length === 4) {
                                        this[q[0]] = match ? q[3].call(this, match.replace(q[1], q[2])) : undefined;
                                }
                            } else {
                                this[q] = match ? match : undefined;
                            }
                        }
                    }
                }
                i += 2;
            }
        },

        strMapper = function (str, map) {

            for (var i in map) {
                // check if current value is array
                if (typeof map[i] === OBJ_TYPE && map[i].length > 0) {
                    for (var j = 0; j < map[i].length; j++) {
                        if (has(map[i][j], str)) {
                            return (i === UNKNOWN) ? undefined : i;
                        }
                    }
                } else if (has(map[i], str)) {
                    return (i === UNKNOWN) ? undefined : i;
                }
            }
            return map.hasOwnProperty('*') ? map['*'] : str;
    };

    ///////////////
    // String map
    //////////////

    // Safari < 3.0
    var oldSafariMap = {
            '1.0'   : '/8',
            '1.2'   : '/1',
            '1.3'   : '/3',
            '2.0'   : '/412',
            '2.0.2' : '/416',
            '2.0.3' : '/417',
            '2.0.4' : '/419',
            '?'     : '/'
        },
        windowsVersionMap = {
            'ME'        : '4.90',
            'NT 3.11'   : 'NT3.51',
            'NT 4.0'    : 'NT4.0',
            '2000'      : 'NT 5.0',
            'XP'        : ['NT 5.1', 'NT 5.2'],
            'Vista'     : 'NT 6.0',
            '7'         : 'NT 6.1',
            '8'         : 'NT 6.2',
            '8.1'       : 'NT 6.3',
            '10'        : ['NT 6.4', 'NT 10.0'],
            'RT'        : 'ARM'
    };

    //////////////
    // Regex map
    /////////////

    var regexes = {

        browser : [[

            /\b(?:crmo|crios)\/([\w\.]+)/i                                      // Chrome for Android/iOS
            ], [VERSION, [NAME, 'Chrome']], [
            /edg(?:e|ios|a)?\/([\w\.]+)/i                                       // Microsoft Edge
            ], [VERSION, [NAME, 'Edge']], [

            // Presto based
            /(opera mini)\/([-\w\.]+)/i,                                        // Opera Mini
            /(opera [mobiletab]{3,6})\b.+version\/([-\w\.]+)/i,                 // Opera Mobi/Tablet
            /(opera)(?:.+version\/|[\/ ]+)([\w\.]+)/i                           // Opera
            ], [NAME, VERSION], [
            /opios[\/ ]+([\w\.]+)/i                                             // Opera mini on iphone >= 8.0
            ], [VERSION, [NAME, OPERA+' Mini']], [
            /\bop(?:rg)?x\/([\w\.]+)/i                                          // Opera GX
            ], [VERSION, [NAME, OPERA+' GX']], [
            /\bopr\/([\w\.]+)/i                                                 // Opera Webkit
            ], [VERSION, [NAME, OPERA]], [

            // Mixed
            /\bb[ai]*d(?:uhd|[ub]*[aekoprswx]{5,6})[\/ ]?([\w\.]+)/i            // Baidu
            ], [VERSION, [NAME, 'Baidu']], [
            /(kindle)\/([\w\.]+)/i,                                             // Kindle
            /(lunascape|maxthon|netfront|jasmine|blazer|sleipnir)[\/ ]?([\w\.]*)/i,      
                                                                                // Lunascape/Maxthon/Netfront/Jasmine/Blazer/Sleipnir
            // Trident based
            /(avant|iemobile|slim)\s?(?:browser)?[\/ ]?([\w\.]*)/i,             // Avant/IEMobile/SlimBrowser
            /(?:ms|\()(ie) ([\w\.]+)/i,                                         // Internet Explorer

            // Webkit/KHTML based                                               // Flock/RockMelt/Midori/Epiphany/Silk/Skyfire/Bolt/Iron/Iridium/PhantomJS/Bowser/QupZilla/Falkon
            /(flock|rockmelt|midori|epiphany|silk|skyfire|ovibrowser|bolt|iron|vivaldi|iridium|phantomjs|bowser|qupzilla|falkon|rekonq|puffin|brave|whale(?!.+naver)|qqbrowserlite|duckduckgo|klar|helio)\/([-\w\.]+)/i,
                                                                                // Rekonq/Puffin/Brave/Whale/QQBrowserLite/QQ//Vivaldi/DuckDuckGo/Klar/Helio
            /(heytap|ovi)browser\/([\d\.]+)/i,                                  // HeyTap/Ovi
            /(weibo)__([\d\.]+)/i                                               // Weibo
            ], [NAME, VERSION], [
            /quark(?:pc)?\/([-\w\.]+)/i                                         // Quark
            ], [VERSION, [NAME, 'Quark']], [
            /\bddg\/([\w\.]+)/i                                                 // DuckDuckGo
            ], [VERSION, [NAME, 'DuckDuckGo']], [
            /(?:\buc? ?browser|(?:juc.+)ucweb)[\/ ]?([\w\.]+)/i                 // UCBrowser
            ], [VERSION, [NAME, 'UC'+BROWSER]], [
            /microm.+\bqbcore\/([\w\.]+)/i,                                     // WeChat Desktop for Windows Built-in Browser
            /\bqbcore\/([\w\.]+).+microm/i,
            /micromessenger\/([\w\.]+)/i                                        // WeChat
            ], [VERSION, [NAME, 'WeChat']], [
            /konqueror\/([\w\.]+)/i                                             // Konqueror
            ], [VERSION, [NAME, 'Konqueror']], [
            /trident.+rv[: ]([\w\.]{1,9})\b.+like gecko/i                       // IE11
            ], [VERSION, [NAME, 'IE']], [
            /ya(?:search)?browser\/([\w\.]+)/i                                  // Yandex
            ], [VERSION, [NAME, 'Yandex']], [
            /slbrowser\/([\w\.]+)/i                                             // Smart Lenovo Browser
            ], [VERSION, [NAME, 'Smart Lenovo '+BROWSER]], [
            /(avast|avg)\/([\w\.]+)/i                                           // Avast/AVG Secure Browser
            ], [[NAME, /(.+)/, '$1 Secure '+BROWSER], VERSION], [
            /\bfocus\/([\w\.]+)/i                                               // Firefox Focus
            ], [VERSION, [NAME, FIREFOX+' Focus']], [
            /\bopt\/([\w\.]+)/i                                                 // Opera Touch
            ], [VERSION, [NAME, OPERA+' Touch']], [
            /coc_coc\w+\/([\w\.]+)/i                                            // Coc Coc Browser
            ], [VERSION, [NAME, 'Coc Coc']], [
            /dolfin\/([\w\.]+)/i                                                // Dolphin
            ], [VERSION, [NAME, 'Dolphin']], [
            /coast\/([\w\.]+)/i                                                 // Opera Coast
            ], [VERSION, [NAME, OPERA+' Coast']], [
            /miuibrowser\/([\w\.]+)/i                                           // MIUI Browser
            ], [VERSION, [NAME, 'MIUI '+BROWSER]], [
            /fxios\/([-\w\.]+)/i                                                // Firefox for iOS
            ], [VERSION, [NAME, FIREFOX]], [
            /\bqihu|(qi?ho?o?|360)browser/i                                     // 360
            ], [[NAME, '360' + SUFFIX_BROWSER]], [
            /\b(qq)\/([\w\.]+)/i                                                // QQ
            ], [[NAME, /(.+)/, '$1Browser'], VERSION], [
            /(oculus|sailfish|huawei|vivo|pico)browser\/([\w\.]+)/i
            ], [[NAME, /(.+)/, '$1' + SUFFIX_BROWSER], VERSION], [              // Oculus/Sailfish/HuaweiBrowser/VivoBrowser/PicoBrowser
            /samsungbrowser\/([\w\.]+)/i                                        // Samsung Internet
            ], [VERSION, [NAME, SAMSUNG + ' Internet']], [
            /(comodo_dragon)\/([\w\.]+)/i                                       // Comodo Dragon
            ], [[NAME, /_/g, ' '], VERSION], [
            /metasr[\/ ]?([\d\.]+)/i                                            // Sogou Explorer
            ], [VERSION, [NAME, 'Sogou Explorer']], [
            /(sogou)mo\w+\/([\d\.]+)/i                                          // Sogou Mobile
            ], [[NAME, 'Sogou Mobile'], VERSION], [
            /(electron)\/([\w\.]+) safari/i,                                    // Electron-based App
            /(tesla)(?: qtcarbrowser|\/(20\d\d\.[-\w\.]+))/i,                   // Tesla
            /m?(qqbrowser|2345Explorer)[\/ ]?([\w\.]+)/i                        // QQBrowser/2345 Browser
            ], [NAME, VERSION], [
            /(lbbrowser|rekonq)/i,                                              // LieBao Browser/Rekonq
            /\[(linkedin)app\]/i                                                // LinkedIn App for iOS & Android
            ], [NAME], [

            // WebView
            /((?:fban\/fbios|fb_iab\/fb4a)(?!.+fbav)|;fbav\/([\w\.]+);)/i       // Facebook App for iOS & Android
            ], [[NAME, FACEBOOK], VERSION], [
            /(Klarna)\/([\w\.]+)/i,                                             // Klarna Shopping Browser for iOS & Android
            /(kakao(?:talk|story))[\/ ]([\w\.]+)/i,                             // Kakao App
            /(naver)\(.*?(\d+\.[\w\.]+).*\)/i,                                  // Naver InApp
            /safari (line)\/([\w\.]+)/i,                                        // Line App for iOS
            /\b(line)\/([\w\.]+)\/iab/i,                                        // Line App for Android
            /(alipay)client\/([\w\.]+)/i,                                       // Alipay
            /(twitter)(?:and| f.+e\/([\w\.]+))/i,                               // Twitter
            /(chromium|instagram|snapchat)[\/ ]([-\w\.]+)/i                     // Chromium/Instagram/Snapchat
            ], [NAME, VERSION], [
            /\bgsa\/([\w\.]+) .*safari\//i                                      // Google Search Appliance on iOS
            ], [VERSION, [NAME, 'GSA']], [
            /musical_ly(?:.+app_?version\/|_)([\w\.]+)/i                        // TikTok
            ], [VERSION, [NAME, 'TikTok']], [

            /headlesschrome(?:\/([\w\.]+)| )/i                                  // Chrome Headless
            ], [VERSION, [NAME, CHROME+' Headless']], [

            / wv\).+(chrome)\/([\w\.]+)/i                                       // Chrome WebView
            ], [[NAME, CHROME+' WebView'], VERSION], [

            /droid.+ version\/([\w\.]+)\b.+(?:mobile safari|safari)/i           // Android Browser
            ], [VERSION, [NAME, 'Android '+BROWSER]], [

            /(chrome|omniweb|arora|[tizenoka]{5} ?browser)\/v?([\w\.]+)/i       // Chrome/OmniWeb/Arora/Tizen/Nokia
            ], [NAME, VERSION], [

            /version\/([\w\.\,]+) .*mobile\/\w+ (safari)/i                      // Mobile Safari
            ], [VERSION, [NAME, 'Mobile Safari']], [
            /version\/([\w(\.|\,)]+) .*(mobile ?safari|safari)/i                // Safari & Safari Mobile
            ], [VERSION, NAME], [
            /webkit.+?(mobile ?safari|safari)(\/[\w\.]+)/i                      // Safari < 3.0
            ], [NAME, [VERSION, strMapper, oldSafariMap]], [

            /(webkit|khtml)\/([\w\.]+)/i
            ], [NAME, VERSION], [

            // Gecko based
            /(navigator|netscape\d?)\/([-\w\.]+)/i                              // Netscape
            ], [[NAME, 'Netscape'], VERSION], [
            /(wolvic)\/([\w\.]+)/i                                              // Wolvic
            ], [NAME, VERSION], [
            /mobile vr; rv:([\w\.]+)\).+firefox/i                               // Firefox Reality
            ], [VERSION, [NAME, FIREFOX+' Reality']], [
            /ekiohf.+(flow)\/([\w\.]+)/i,                                       // Flow
            /(swiftfox)/i,                                                      // Swiftfox
            /(icedragon|iceweasel|camino|chimera|fennec|maemo browser|minimo|conkeror)[\/ ]?([\w\.\+]+)/i,
                                                                                // IceDragon/Iceweasel/Camino/Chimera/Fennec/Maemo/Minimo/Conkeror
            /(seamonkey|k-meleon|icecat|iceape|firebird|phoenix|palemoon|basilisk|waterfox)\/([-\w\.]+)$/i,
                                                                                // Firefox/SeaMonkey/K-Meleon/IceCat/IceApe/Firebird/Phoenix
            /(firefox)\/([\w\.]+)/i,                                            // Other Firefox-based
            /(mozilla)\/([\w\.]+) .+rv\:.+gecko\/\d+/i,                         // Mozilla

            // Other
            /(polaris|lynx|dillo|icab|doris|amaya|w3m|netsurf|obigo|mosaic|(?:go|ice|up)[\. ]?browser)[-\/ ]?v?([\w\.]+)/i,
                                                                                // Polaris/Lynx/Dillo/iCab/Doris/Amaya/w3m/NetSurf/Obigo/Mosaic/Go/ICE/UP.Browser
            /(links) \(([\w\.]+)/i                                              // Links
            ], [NAME, [VERSION, /_/g, '.']], [
            
            /(cobalt)\/([\w\.]+)/i                                              // Cobalt
            ], [NAME, [VERSION, /master.|lts./, ""]]
        ],

        cpu : [[

            /(?:(amd|x(?:(?:86|64)[-_])?|wow|win)64)[;\)]/i                     // AMD64 (x64)
            ], [[ARCHITECTURE, 'amd64']], [

            /(ia32(?=;))/i                                                      // IA32 (quicktime)
            ], [[ARCHITECTURE, lowerize]], [

            /((?:i[346]|x)86)[;\)]/i                                            // IA32 (x86)
            ], [[ARCHITECTURE, 'ia32']], [

            /\b(aarch64|arm(v?8e?l?|_?64))\b/i                                 // ARM64
            ], [[ARCHITECTURE, 'arm64']], [

            /\b(arm(?:v[67])?ht?n?[fl]p?)\b/i                                   // ARMHF
            ], [[ARCHITECTURE, 'armhf']], [

            // PocketPC mistakenly identified as PowerPC
            /windows (ce|mobile); ppc;/i
            ], [[ARCHITECTURE, 'arm']], [

            /((?:ppc|powerpc)(?:64)?)(?: mac|;|\))/i                            // PowerPC
            ], [[ARCHITECTURE, /ower/, EMPTY, lowerize]], [

            /(sun4\w)[;\)]/i                                                    // SPARC
            ], [[ARCHITECTURE, 'sparc']], [

            /((?:avr32|ia64(?=;))|68k(?=\))|\barm(?=v(?:[1-7]|[5-7]1)l?|;|eabi)|(?=atmel )avr|(?:irix|mips|sparc)(?:64)?\b|pa-risc)/i
                                                                                // IA64, 68K, ARM/64, AVR/32, IRIX/64, MIPS/64, SPARC/64, PA-RISC
            ], [[ARCHITECTURE, lowerize]]
        ],

        device : [[

            //////////////////////////
            // MOBILES & TABLETS
            /////////////////////////

            // Samsung
            /\b(sch-i[89]0\d|shw-m380s|sm-[ptx]\w{2,4}|gt-[pn]\d{2,4}|sgh-t8[56]9|nexus 10)/i
            ], [MODEL, [VENDOR, SAMSUNG], [TYPE, TABLET]], [
            /\b((?:s[cgp]h|gt|sm)-(?![lr])\w+|sc[g-]?[\d]+a?|galaxy nexus)/i,
            /samsung[- ]((?!sm-[lr])[-\w]+)/i,
            /sec-(sgh\w+)/i
            ], [MODEL, [VENDOR, SAMSUNG], [TYPE, MOBILE]], [

            // Apple
            /(?:\/|\()(ip(?:hone|od)[\w, ]*)(?:\/|;)/i                          // iPod/iPhone
            ], [MODEL, [VENDOR, APPLE], [TYPE, MOBILE]], [
            /\((ipad);[-\w\),; ]+apple/i,                                       // iPad
            /applecoremedia\/[\w\.]+ \((ipad)/i,
            /\b(ipad)\d\d?,\d\d?[;\]].+ios/i
            ], [MODEL, [VENDOR, APPLE], [TYPE, TABLET]], [
            /(macintosh);/i
            ], [MODEL, [VENDOR, APPLE]], [

            // Sharp
            /\b(sh-?[altvz]?\d\d[a-ekm]?)/i
            ], [MODEL, [VENDOR, SHARP], [TYPE, MOBILE]], [

            // Huawei
            /\b((?:ag[rs][23]?|bah2?|sht?|btv)-a?[lw]\d{2})\b(?!.+d\/s)/i
            ], [MODEL, [VENDOR, HUAWEI], [TYPE, TABLET]], [
            /(?:huawei|honor)([-\w ]+)[;\)]/i,
            /\b(nexus 6p|\w{2,4}e?-[atu]?[ln][\dx][012359c][adn]?)\b(?!.+d\/s)/i
            ], [MODEL, [VENDOR, HUAWEI], [TYPE, MOBILE]], [

            // Xiaomi
            /\b(poco[\w ]+|m2\d{3}j\d\d[a-z]{2})(?: bui|\))/i,                  // Xiaomi POCO
            /\b; (\w+) build\/hm\1/i,                                           // Xiaomi Hongmi 'numeric' models
            /\b(hm[-_ ]?note?[_ ]?(?:\d\w)?) bui/i,                             // Xiaomi Hongmi
            /\b(redmi[\-_ ]?(?:note|k)?[\w_ ]+)(?: bui|\))/i,                   // Xiaomi Redmi
            /oid[^\)]+; (m?[12][0-389][01]\w{3,6}[c-y])( bui|; wv|\))/i,        // Xiaomi Redmi 'numeric' models
            /\b(mi[-_ ]?(?:a\d|one|one[_ ]plus|note lte|max|cc)?[_ ]?(?:\d?\w?)[_ ]?(?:plus|se|lite|pro)?)(?: bui|\))/i // Xiaomi Mi
            ], [[MODEL, /_/g, ' '], [VENDOR, XIAOMI], [TYPE, MOBILE]], [
            /oid[^\)]+; (2\d{4}(283|rpbf)[cgl])( bui|\))/i,                     // Redmi Pad
            /\b(mi[-_ ]?(?:pad)(?:[\w_ ]+))(?: bui|\))/i                        // Mi Pad tablets
            ],[[MODEL, /_/g, ' '], [VENDOR, XIAOMI], [TYPE, TABLET]], [

            // OPPO
            /; (\w+) bui.+ oppo/i,
            /\b(cph[12]\d{3}|p(?:af|c[al]|d\w|e[ar])[mt]\d0|x9007|a101op)\b/i
            ], [MODEL, [VENDOR, 'OPPO'], [TYPE, MOBILE]], [
            /\b(opd2\d{3}a?) bui/i
            ], [MODEL, [VENDOR, 'OPPO'], [TYPE, TABLET]], [

            // Vivo
            /vivo (\w+)(?: bui|\))/i,
            /\b(v[12]\d{3}\w?[at])(?: bui|;)/i
            ], [MODEL, [VENDOR, 'Vivo'], [TYPE, MOBILE]], [

            // Realme
            /\b(rmx[1-3]\d{3})(?: bui|;|\))/i
            ], [MODEL, [VENDOR, 'Realme'], [TYPE, MOBILE]], [

            // Motorola
            /\b(milestone|droid(?:[2-4x]| (?:bionic|x2|pro|razr))?:?( 4g)?)\b[\w ]+build\//i,
            /\bmot(?:orola)?[- ](\w*)/i,
            /((?:moto[\w\(\) ]+|xt\d{3,4}|nexus 6)(?= bui|\)))/i
            ], [MODEL, [VENDOR, MOTOROLA], [TYPE, MOBILE]], [
            /\b(mz60\d|xoom[2 ]{0,2}) build\//i
            ], [MODEL, [VENDOR, MOTOROLA], [TYPE, TABLET]], [

            // LG
            /((?=lg)?[vl]k\-?\d{3}) bui| 3\.[-\w; ]{10}lg?-([06cv9]{3,4})/i
            ], [MODEL, [VENDOR, LG], [TYPE, TABLET]], [
            /(lm(?:-?f100[nv]?|-[\w\.]+)(?= bui|\))|nexus [45])/i,
            /\blg[-e;\/ ]+((?!browser|netcast|android tv)\w+)/i,
            /\blg-?([\d\w]+) bui/i
            ], [MODEL, [VENDOR, LG], [TYPE, MOBILE]], [

            // Lenovo
            /(ideatab[-\w ]+)/i,
            /lenovo ?(s[56]000[-\w]+|tab(?:[\w ]+)|yt[-\d\w]{6}|tb[-\d\w]{6})/i
            ], [MODEL, [VENDOR, 'Lenovo'], [TYPE, TABLET]], [

            // Nokia
            /(?:maemo|nokia).*(n900|lumia \d+)/i,
            /nokia[-_ ]?([-\w\.]*)/i
            ], [[MODEL, /_/g, ' '], [VENDOR, 'Nokia'], [TYPE, MOBILE]], [

            // Google
            /(pixel c)\b/i                                                      // Google Pixel C
            ], [MODEL, [VENDOR, GOOGLE], [TYPE, TABLET]], [
            /droid.+; (pixel[\daxl ]{0,6})(?: bui|\))/i                         // Google Pixel
            ], [MODEL, [VENDOR, GOOGLE], [TYPE, MOBILE]], [

            // Sony
            /droid.+ (a?\d[0-2]{2}so|[c-g]\d{4}|so[-gl]\w+|xq-a\w[4-7][12])(?= bui|\).+chrome\/(?![1-6]{0,1}\d\.))/i
            ], [MODEL, [VENDOR, SONY], [TYPE, MOBILE]], [
            /sony tablet [ps]/i,
            /\b(?:sony)?sgp\w+(?: bui|\))/i
            ], [[MODEL, 'Xperia Tablet'], [VENDOR, SONY], [TYPE, TABLET]], [

            // OnePlus
            / (kb2005|in20[12]5|be20[12][59])\b/i,
            /(?:one)?(?:plus)? (a\d0\d\d)(?: b|\))/i
            ], [MODEL, [VENDOR, 'OnePlus'], [TYPE, MOBILE]], [

            // Amazon
            /(alexa)webm/i,
            /(kf[a-z]{2}wi|aeo(?!bc)\w\w)( bui|\))/i,                           // Kindle Fire without Silk / Echo Show
            /(kf[a-z]+)( bui|\)).+silk\//i                                      // Kindle Fire HD
            ], [MODEL, [VENDOR, AMAZON], [TYPE, TABLET]], [
            /((?:sd|kf)[0349hijorstuw]+)( bui|\)).+silk\//i                     // Fire Phone
            ], [[MODEL, /(.+)/g, 'Fire Phone $1'], [VENDOR, AMAZON], [TYPE, MOBILE]], [

            // BlackBerry
            /(playbook);[-\w\),; ]+(rim)/i                                      // BlackBerry PlayBook
            ], [MODEL, VENDOR, [TYPE, TABLET]], [
            /\b((?:bb[a-f]|st[hv])100-\d)/i,
            /\(bb10; (\w+)/i                                                    // BlackBerry 10
            ], [MODEL, [VENDOR, BLACKBERRY], [TYPE, MOBILE]], [

            // Asus
            /(?:\b|asus_)(transfo[prime ]{4,10} \w+|eeepc|slider \w+|nexus 7|padfone|p00[cj])/i
            ], [MODEL, [VENDOR, ASUS], [TYPE, TABLET]], [
            / (z[bes]6[027][012][km][ls]|zenfone \d\w?)\b/i
            ], [MODEL, [VENDOR, ASUS], [TYPE, MOBILE]], [

            // HTC
            /(nexus 9)/i                                                        // HTC Nexus 9
            ], [MODEL, [VENDOR, 'HTC'], [TYPE, TABLET]], [
            /(htc)[-;_ ]{1,2}([\w ]+(?=\)| bui)|\w+)/i,                         // HTC

            // ZTE
            /(zte)[- ]([\w ]+?)(?: bui|\/|\))/i,
            /(alcatel|geeksphone|nexian|panasonic(?!(?:;|\.))|sony(?!-bra))[-_ ]?([-\w]*)/i         // Alcatel/GeeksPhone/Nexian/Panasonic/Sony
            ], [VENDOR, [MODEL, /_/g, ' '], [TYPE, MOBILE]], [

            // TCL
            /droid [\w\.]+; ((?:8[14]9[16]|9(?:0(?:48|60|8[01])|1(?:3[27]|66)|2(?:6[69]|9[56])|466))[gqswx])\w*(\)| bui)/i
            ], [MODEL, [VENDOR, 'TCL'], [TYPE, TABLET]], [

            // itel
            /(itel) ((\w+))/i
            ], [[VENDOR, lowerize], MODEL, [TYPE, strMapper, { 'tablet' : ['p10001l', 'w7001'], '*' : 'mobile' }]], [

            // Acer
            /droid.+; ([ab][1-7]-?[0178a]\d\d?)/i
            ], [MODEL, [VENDOR, 'Acer'], [TYPE, TABLET]], [

            // Meizu
            /droid.+; (m[1-5] note) bui/i,
            /\bmz-([-\w]{2,})/i
            ], [MODEL, [VENDOR, 'Meizu'], [TYPE, MOBILE]], [
                
            // Ulefone
            /; ((?:power )?armor(?:[\w ]{0,8}))(?: bui|\))/i
            ], [MODEL, [VENDOR, 'Ulefone'], [TYPE, MOBILE]], [

            // Nothing
            /droid.+; (a(?:015|06[35]|142p?))/i
            ], [MODEL, [VENDOR, 'Nothing'], [TYPE, MOBILE]], [

            // MIXED
            /(blackberry|benq|palm(?=\-)|sonyericsson|acer|asus|dell|meizu|motorola|polytron|infinix|tecno)[-_ ]?([-\w]*)/i,
                                                                                // BlackBerry/BenQ/Palm/Sony-Ericsson/Acer/Asus/Dell/Meizu/Motorola/Polytron
            /(hp) ([\w ]+\w)/i,                                                 // HP iPAQ
            /(asus)-?(\w+)/i,                                                   // Asus
            /(microsoft); (lumia[\w ]+)/i,                                      // Microsoft Lumia
            /(lenovo)[-_ ]?([-\w]+)/i,                                          // Lenovo
            /(jolla)/i,                                                         // Jolla
            /(oppo) ?([\w ]+) bui/i                                             // OPPO
            ], [VENDOR, MODEL, [TYPE, MOBILE]], [

            /(kobo)\s(ereader|touch)/i,                                         // Kobo
            /(archos) (gamepad2?)/i,                                            // Archos
            /(hp).+(touchpad(?!.+tablet)|tablet)/i,                             // HP TouchPad
            /(kindle)\/([\w\.]+)/i,                                             // Kindle
            /(nook)[\w ]+build\/(\w+)/i,                                        // Nook
            /(dell) (strea[kpr\d ]*[\dko])/i,                                   // Dell Streak
            /(le[- ]+pan)[- ]+(\w{1,9}) bui/i,                                  // Le Pan Tablets
            /(trinity)[- ]*(t\d{3}) bui/i,                                      // Trinity Tablets
            /(gigaset)[- ]+(q\w{1,9}) bui/i,                                    // Gigaset Tablets
            /(vodafone) ([\w ]+)(?:\)| bui)/i                                   // Vodafone
            ], [VENDOR, MODEL, [TYPE, TABLET]], [

            /(surface duo)/i                                                    // Surface Duo
            ], [MODEL, [VENDOR, MICROSOFT], [TYPE, TABLET]], [
            /droid [\d\.]+; (fp\du?)(?: b|\))/i                                 // Fairphone
            ], [MODEL, [VENDOR, 'Fairphone'], [TYPE, MOBILE]], [
            /(u304aa)/i                                                         // AT&T
            ], [MODEL, [VENDOR, 'AT&T'], [TYPE, MOBILE]], [
            /\bsie-(\w*)/i                                                      // Siemens
            ], [MODEL, [VENDOR, 'Siemens'], [TYPE, MOBILE]], [
            /\b(rct\w+) b/i                                                     // RCA Tablets
            ], [MODEL, [VENDOR, 'RCA'], [TYPE, TABLET]], [
            /\b(venue[\d ]{2,7}) b/i                                            // Dell Venue Tablets
            ], [MODEL, [VENDOR, 'Dell'], [TYPE, TABLET]], [
            /\b(q(?:mv|ta)\w+) b/i                                              // Verizon Tablet
            ], [MODEL, [VENDOR, 'Verizon'], [TYPE, TABLET]], [
            /\b(?:barnes[& ]+noble |bn[rt])([\w\+ ]*) b/i                       // Barnes & Noble Tablet
            ], [MODEL, [VENDOR, 'Barnes & Noble'], [TYPE, TABLET]], [
            /\b(tm\d{3}\w+) b/i
            ], [MODEL, [VENDOR, 'NuVision'], [TYPE, TABLET]], [
            /\b(k88) b/i                                                        // ZTE K Series Tablet
            ], [MODEL, [VENDOR, 'ZTE'], [TYPE, TABLET]], [
            /\b(nx\d{3}j) b/i                                                   // ZTE Nubia
            ], [MODEL, [VENDOR, 'ZTE'], [TYPE, MOBILE]], [
            /\b(gen\d{3}) b.+49h/i                                              // Swiss GEN Mobile
            ], [MODEL, [VENDOR, 'Swiss'], [TYPE, MOBILE]], [
            /\b(zur\d{3}) b/i                                                   // Swiss ZUR Tablet
            ], [MODEL, [VENDOR, 'Swiss'], [TYPE, TABLET]], [
            /\b((zeki)?tb.*\b) b/i                                              // Zeki Tablets
            ], [MODEL, [VENDOR, 'Zeki'], [TYPE, TABLET]], [
            /\b([yr]\d{2}) b/i,
            /\b(dragon[- ]+touch |dt)(\w{5}) b/i                                // Dragon Touch Tablet
            ], [[VENDOR, 'Dragon Touch'], MODEL, [TYPE, TABLET]], [
            /\b(ns-?\w{0,9}) b/i                                                // Insignia Tablets
            ], [MODEL, [VENDOR, 'Insignia'], [TYPE, TABLET]], [
            /\b((nxa|next)-?\w{0,9}) b/i                                        // NextBook Tablets
            ], [MODEL, [VENDOR, 'NextBook'], [TYPE, TABLET]], [
            /\b(xtreme\_)?(v(1[045]|2[015]|[3469]0|7[05])) b/i                  // Voice Xtreme Phones
            ], [[VENDOR, 'Voice'], MODEL, [TYPE, MOBILE]], [
            /\b(lvtel\-)?(v1[12]) b/i                                           // LvTel Phones
            ], [[VENDOR, 'LvTel'], MODEL, [TYPE, MOBILE]], [
            /\b(ph-1) /i                                                        // Essential PH-1
            ], [MODEL, [VENDOR, 'Essential'], [TYPE, MOBILE]], [
            /\b(v(100md|700na|7011|917g).*\b) b/i                               // Envizen Tablets
            ], [MODEL, [VENDOR, 'Envizen'], [TYPE, TABLET]], [
            /\b(trio[-\w\. ]+) b/i                                              // MachSpeed Tablets
            ], [MODEL, [VENDOR, 'MachSpeed'], [TYPE, TABLET]], [
            /\btu_(1491) b/i                                                    // Rotor Tablets
            ], [MODEL, [VENDOR, 'Rotor'], [TYPE, TABLET]], [
            /(shield[\w ]+) b/i                                                 // Nvidia Shield Tablets
            ], [MODEL, [VENDOR, 'Nvidia'], [TYPE, TABLET]], [
            /(sprint) (\w+)/i                                                   // Sprint Phones
            ], [VENDOR, MODEL, [TYPE, MOBILE]], [
            /(kin\.[onetw]{3})/i                                                // Microsoft Kin
            ], [[MODEL, /\./g, ' '], [VENDOR, MICROSOFT], [TYPE, MOBILE]], [
            /droid.+; (cc6666?|et5[16]|mc[239][23]x?|vc8[03]x?)\)/i             // Zebra
            ], [MODEL, [VENDOR, ZEBRA], [TYPE, TABLET]], [
            /droid.+; (ec30|ps20|tc[2-8]\d[kx])\)/i
            ], [MODEL, [VENDOR, ZEBRA], [TYPE, MOBILE]], [

            ///////////////////
            // SMARTTVS
            ///////////////////

            /smart-tv.+(samsung)/i                                              // Samsung
            ], [VENDOR, [TYPE, SMARTTV]], [
            /hbbtv.+maple;(\d+)/i
            ], [[MODEL, /^/, 'SmartTV'], [VENDOR, SAMSUNG], [TYPE, SMARTTV]], [
            /(nux; netcast.+smarttv|lg (netcast\.tv-201\d|android tv))/i        // LG SmartTV
            ], [[VENDOR, LG], [TYPE, SMARTTV]], [
            /(apple) ?tv/i                                                      // Apple TV
            ], [VENDOR, [MODEL, APPLE+' TV'], [TYPE, SMARTTV]], [
            /crkey/i                                                            // Google Chromecast
            ], [[MODEL, CHROME+'cast'], [VENDOR, GOOGLE], [TYPE, SMARTTV]], [
            /droid.+aft(\w+)( bui|\))/i                                         // Fire TV
            ], [MODEL, [VENDOR, AMAZON], [TYPE, SMARTTV]], [
            /\(dtv[\);].+(aquos)/i,
            /(aquos-tv[\w ]+)\)/i                                               // Sharp
            ], [MODEL, [VENDOR, SHARP], [TYPE, SMARTTV]],[
            /(bravia[\w ]+)( bui|\))/i                                              // Sony
            ], [MODEL, [VENDOR, SONY], [TYPE, SMARTTV]], [
            /(mitv-\w{5}) bui/i                                                 // Xiaomi
            ], [MODEL, [VENDOR, XIAOMI], [TYPE, SMARTTV]], [
            /Hbbtv.*(technisat) (.*);/i                                         // TechniSAT
            ], [VENDOR, MODEL, [TYPE, SMARTTV]], [
            /\b(roku)[\dx]*[\)\/]((?:dvp-)?[\d\.]*)/i,                          // Roku
            /hbbtv\/\d+\.\d+\.\d+ +\([\w\+ ]*; *([\w\d][^;]*);([^;]*)/i         // HbbTV devices
            ], [[VENDOR, trim], [MODEL, trim], [TYPE, SMARTTV]], [
            /\b(android tv|smart[- ]?tv|opera tv|tv; rv:)\b/i                   // SmartTV from Unidentified Vendors
            ], [[TYPE, SMARTTV]], [

            ///////////////////
            // CONSOLES
            ///////////////////

            /(ouya)/i,                                                          // Ouya
            /(nintendo) ([wids3utch]+)/i                                        // Nintendo
            ], [VENDOR, MODEL, [TYPE, CONSOLE]], [
            /droid.+; (shield) bui/i                                            // Nvidia
            ], [MODEL, [VENDOR, 'Nvidia'], [TYPE, CONSOLE]], [
            /(playstation [345portablevi]+)/i                                   // Playstation
            ], [MODEL, [VENDOR, SONY], [TYPE, CONSOLE]], [
            /\b(xbox(?: one)?(?!; xbox))[\); ]/i                                // Microsoft Xbox
            ], [MODEL, [VENDOR, MICROSOFT], [TYPE, CONSOLE]], [

            ///////////////////
            // WEARABLES
            ///////////////////

            /\b(sm-[lr]\d\d[05][fnuw]?s?)\b/i                                   // Samsung Galaxy Watch
            ], [MODEL, [VENDOR, SAMSUNG], [TYPE, WEARABLE]], [
            /((pebble))app/i                                                    // Pebble
            ], [VENDOR, MODEL, [TYPE, WEARABLE]], [
            /(watch)(?: ?os[,\/]|\d,\d\/)[\d\.]+/i                              // Apple Watch
            ], [MODEL, [VENDOR, APPLE], [TYPE, WEARABLE]], [
            /droid.+; (glass) \d/i                                              // Google Glass
            ], [MODEL, [VENDOR, GOOGLE], [TYPE, WEARABLE]], [
            /droid.+; (wt63?0{2,3})\)/i
            ], [MODEL, [VENDOR, ZEBRA], [TYPE, WEARABLE]], [
            /(quest( \d| pro)?)/i                                               // Oculus Quest
            ], [MODEL, [VENDOR, FACEBOOK], [TYPE, WEARABLE]], [

            ///////////////////
            // EMBEDDED
            ///////////////////

            /(tesla)(?: qtcarbrowser|\/[-\w\.]+)/i                              // Tesla
            ], [VENDOR, [TYPE, EMBEDDED]], [
            /(aeobc)\b/i                                                        // Echo Dot
            ], [MODEL, [VENDOR, AMAZON], [TYPE, EMBEDDED]], [

            ////////////////////
            // MIXED (GENERIC)
            ///////////////////

            /droid .+?; ([^;]+?)(?: bui|; wv\)|\) applew).+? mobile safari/i    // Android Phones from Unidentified Vendors
            ], [MODEL, [TYPE, MOBILE]], [
            /droid .+?; ([^;]+?)(?: bui|\) applew).+?(?! mobile) safari/i       // Android Tablets from Unidentified Vendors
            ], [MODEL, [TYPE, TABLET]], [
            /\b((tablet|tab)[;\/]|focus\/\d(?!.+mobile))/i                      // Unidentifiable Tablet
            ], [[TYPE, TABLET]], [
            /(phone|mobile(?:[;\/]| [ \w\/\.]*safari)|pda(?=.+windows ce))/i    // Unidentifiable Mobile
            ], [[TYPE, MOBILE]], [
            /(android[-\w\. ]{0,9});.+buil/i                                    // Generic Android Device
            ], [MODEL, [VENDOR, 'Generic']]
        ],

        engine : [[

            /windows.+ edge\/([\w\.]+)/i                                       // EdgeHTML
            ], [VERSION, [NAME, EDGE+'HTML']], [

            /webkit\/537\.36.+chrome\/(?!27)([\w\.]+)/i                         // Blink
            ], [VERSION, [NAME, 'Blink']], [

            /(presto)\/([\w\.]+)/i,                                             // Presto
            /(webkit|trident|netfront|netsurf|amaya|lynx|w3m|goanna)\/([\w\.]+)/i, // WebKit/Trident/NetFront/NetSurf/Amaya/Lynx/w3m/Goanna
            /ekioh(flow)\/([\w\.]+)/i,                                          // Flow
            /(khtml|tasman|links)[\/ ]\(?([\w\.]+)/i,                           // KHTML/Tasman/Links
            /(icab)[\/ ]([23]\.[\d\.]+)/i,                                      // iCab
            /\b(libweb)/i
            ], [NAME, VERSION], [

            /rv\:([\w\.]{1,9})\b.+(gecko)/i                                     // Gecko
            ], [VERSION, NAME]
        ],

        os : [[

            // Windows
            /microsoft (windows) (vista|xp)/i                                   // Windows (iTunes)
            ], [NAME, VERSION], [
            /(windows (?:phone(?: os)?|mobile))[\/ ]?([\d\.\w ]*)/i             // Windows Phone
            ], [NAME, [VERSION, strMapper, windowsVersionMap]], [
            /windows nt 6\.2; (arm)/i,                                        // Windows RT
            /windows[\/ ]?([ntce\d\. ]+\w)(?!.+xbox)/i,
            /(?:win(?=3|9|n)|win 9x )([nt\d\.]+)/i
            ], [[VERSION, strMapper, windowsVersionMap], [NAME, 'Windows']], [

            // iOS/macOS
            /ip[honead]{2,4}\b(?:.*os ([\w]+) like mac|; opera)/i,              // iOS
            /(?:ios;fbsv\/|iphone.+ios[\/ ])([\d\.]+)/i,
            /cfnetwork\/.+darwin/i
            ], [[VERSION, /_/g, '.'], [NAME, 'iOS']], [
            /(mac os x) ?([\w\. ]*)/i,
            /(macintosh|mac_powerpc\b)(?!.+haiku)/i                             // Mac OS
            ], [[NAME, MAC_OS], [VERSION, /_/g, '.']], [

            // Mobile OSes
            /droid ([\w\.]+)\b.+(android[- ]x86|harmonyos)/i                    // Android-x86/HarmonyOS
            ], [VERSION, NAME], [                                               // Android/WebOS/QNX/Bada/RIM/Maemo/MeeGo/Sailfish OS
            /(android|webos|qnx|bada|rim tablet os|maemo|meego|sailfish)[-\/ ]?([\w\.]*)/i,
            /(blackberry)\w*\/([\w\.]*)/i,                                      // Blackberry
            /(tizen|kaios)[\/ ]([\w\.]+)/i,                                     // Tizen/KaiOS
            /\((series40);/i                                                    // Series 40
            ], [NAME, VERSION], [
            /\(bb(10);/i                                                        // BlackBerry 10
            ], [VERSION, [NAME, BLACKBERRY]], [
            /(?:symbian ?os|symbos|s60(?=;)|series60)[-\/ ]?([\w\.]*)/i         // Symbian
            ], [VERSION, [NAME, 'Symbian']], [
            /mozilla\/[\d\.]+ \((?:mobile|tablet|tv|mobile; [\w ]+); rv:.+ gecko\/([\w\.]+)/i // Firefox OS
            ], [VERSION, [NAME, FIREFOX+' OS']], [
            /web0s;.+rt(tv)/i,
            /\b(?:hp)?wos(?:browser)?\/([\w\.]+)/i                              // WebOS
            ], [VERSION, [NAME, 'webOS']], [
            /watch(?: ?os[,\/]|\d,\d\/)([\d\.]+)/i                              // watchOS
            ], [VERSION, [NAME, 'watchOS']], [

            // Google Chromecast
            /crkey\/([\d\.]+)/i                                                 // Google Chromecast
            ], [VERSION, [NAME, CHROME+'cast']], [
            /(cros) [\w]+(?:\)| ([\w\.]+)\b)/i                                  // Chromium OS
            ], [[NAME, CHROMIUM_OS], VERSION],[

            // Smart TVs
            /panasonic;(viera)/i,                                               // Panasonic Viera
            /(netrange)mmh/i,                                                   // Netrange
            /(nettv)\/(\d+\.[\w\.]+)/i,                                         // NetTV

            // Console
            /(nintendo|playstation) ([wids345portablevuch]+)/i,                 // Nintendo/Playstation
            /(xbox); +xbox ([^\);]+)/i,                                         // Microsoft Xbox (360, One, X, S, Series X, Series S)

            // Other
            /\b(joli|palm)\b ?(?:os)?\/?([\w\.]*)/i,                            // Joli/Palm
            /(mint)[\/\(\) ]?(\w*)/i,                                           // Mint
            /(mageia|vectorlinux)[; ]/i,                                        // Mageia/VectorLinux
            /([kxln]?ubuntu|debian|suse|opensuse|gentoo|arch(?= linux)|slackware|fedora|mandriva|centos|pclinuxos|red ?hat|zenwalk|linpus|raspbian|plan 9|minix|risc os|contiki|deepin|manjaro|elementary os|sabayon|linspire)(?: gnu\/linux)?(?: enterprise)?(?:[- ]linux)?(?:-gnu)?[-\/ ]?(?!chrom|package)([-\w\.]*)/i,
                                                                                // Ubuntu/Debian/SUSE/Gentoo/Arch/Slackware/Fedora/Mandriva/CentOS/PCLinuxOS/RedHat/Zenwalk/Linpus/Raspbian/Plan9/Minix/RISCOS/Contiki/Deepin/Manjaro/elementary/Sabayon/Linspire
            /(hurd|linux) ?([\w\.]*)/i,                                         // Hurd/Linux
            /(gnu) ?([\w\.]*)/i,                                                // GNU
            /\b([-frentopcghs]{0,5}bsd|dragonfly)[\/ ]?(?!amd|[ix346]{1,2}86)([\w\.]*)/i, // FreeBSD/NetBSD/OpenBSD/PC-BSD/GhostBSD/DragonFly
            /(haiku) (\w+)/i                                                    // Haiku
            ], [NAME, VERSION], [
            /(sunos) ?([\w\.\d]*)/i                                             // Solaris
            ], [[NAME, 'Solaris'], VERSION], [
            /((?:open)?solaris)[-\/ ]?([\w\.]*)/i,                              // Solaris
            /(aix) ((\d)(?=\.|\)| )[\w\.])*/i,                                  // AIX
            /\b(beos|os\/2|amigaos|morphos|openvms|fuchsia|hp-ux|serenityos)/i, // BeOS/OS2/AmigaOS/MorphOS/OpenVMS/Fuchsia/HP-UX/SerenityOS
            /(unix) ?([\w\.]*)/i                                                // UNIX
            ], [NAME, VERSION]
        ]
    };

    /////////////////
    // Constructor
    ////////////////

    var UAParser = function (ua, extensions) {

        if (typeof ua === OBJ_TYPE) {
            extensions = ua;
            ua = undefined;
        }

        if (!(this instanceof UAParser)) {
            return new UAParser(ua, extensions).getResult();
        }

        var _navigator = (typeof window !== UNDEF_TYPE && window.navigator) ? window.navigator : undefined;
        var _ua = ua || ((_navigator && _navigator.userAgent) ? _navigator.userAgent : EMPTY);
        var _uach = (_navigator && _navigator.userAgentData) ? _navigator.userAgentData : undefined;
        var _rgxmap = extensions ? extend(regexes, extensions) : regexes;
        var _isSelfNav = _navigator && _navigator.userAgent == _ua;

        this.getBrowser = function () {
            var _browser = {};
            _browser[NAME] = undefined;
            _browser[VERSION] = undefined;
            rgxMapper.call(_browser, _ua, _rgxmap.browser);
            _browser[MAJOR] = majorize(_browser[VERSION]);
            // Brave-specific detection
            if (_isSelfNav && _navigator && _navigator.brave && typeof _navigator.brave.isBrave == FUNC_TYPE) {
                _browser[NAME] = 'Brave';
            }
            return _browser;
        };
        this.getCPU = function () {
            var _cpu = {};
            _cpu[ARCHITECTURE] = undefined;
            rgxMapper.call(_cpu, _ua, _rgxmap.cpu);
            return _cpu;
        };
        this.getDevice = function () {
            var _device = {};
            _device[VENDOR] = undefined;
            _device[MODEL] = undefined;
            _device[TYPE] = undefined;
            rgxMapper.call(_device, _ua, _rgxmap.device);
            if (_isSelfNav && !_device[TYPE] && _uach && _uach.mobile) {
                _device[TYPE] = MOBILE;
            }
            // iPadOS-specific detection: identified as Mac, but has some iOS-only properties
            if (_isSelfNav && _device[MODEL] == 'Macintosh' && _navigator && typeof _navigator.standalone !== UNDEF_TYPE && _navigator.maxTouchPoints && _navigator.maxTouchPoints > 2) {
                _device[MODEL] = 'iPad';
                _device[TYPE] = TABLET;
            }
            return _device;
        };
        this.getEngine = function () {
            var _engine = {};
            _engine[NAME] = undefined;
            _engine[VERSION] = undefined;
            rgxMapper.call(_engine, _ua, _rgxmap.engine);
            return _engine;
        };
        this.getOS = function () {
            var _os = {};
            _os[NAME] = undefined;
            _os[VERSION] = undefined;
            rgxMapper.call(_os, _ua, _rgxmap.os);
            if (_isSelfNav && !_os[NAME] && _uach && _uach.platform && _uach.platform != 'Unknown') {
                _os[NAME] = _uach.platform  
                                    .replace(/chrome os/i, CHROMIUM_OS)
                                    .replace(/macos/i, MAC_OS);           // backward compatibility
            }
            return _os;
        };
        this.getResult = function () {
            return {
                ua      : this.getUA(),
                browser : this.getBrowser(),
                engine  : this.getEngine(),
                os      : this.getOS(),
                device  : this.getDevice(),
                cpu     : this.getCPU()
            };
        };
        this.getUA = function () {
            return _ua;
        };
        this.setUA = function (ua) {
            _ua = (typeof ua === STR_TYPE && ua.length > UA_MAX_LENGTH) ? trim(ua, UA_MAX_LENGTH) : ua;
            return this;
        };
        this.setUA(_ua);
        return this;
    };

    UAParser.VERSION = LIBVERSION;
    UAParser.BROWSER =  enumerize([NAME, VERSION, MAJOR]);
    UAParser.CPU = enumerize([ARCHITECTURE]);
    UAParser.DEVICE = enumerize([MODEL, VENDOR, TYPE, CONSOLE, MOBILE, SMARTTV, TABLET, WEARABLE, EMBEDDED]);
    UAParser.ENGINE = UAParser.OS = enumerize([NAME, VERSION]);

    ///////////
    // Export
    //////////

    // check js environment
    if (typeof(exports) !== UNDEF_TYPE) {
        // nodejs env
        if ("object" !== UNDEF_TYPE && module.exports) {
            exports = module.exports = UAParser;
        }
        exports.UAParser = UAParser;
    } else {
        // requirejs env (optional)
        if ("function" === FUNC_TYPE && __webpack_require__.amdO) {
            !(__WEBPACK_AMD_DEFINE_RESULT__ = (function () {
                return UAParser;
            }).call(exports, __webpack_require__, exports, module),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
        } else if (typeof window !== UNDEF_TYPE) {
            // browser env
            window.UAParser = UAParser;
        }
    }

    // jQuery/Zepto specific (optional)
    // Note:
    //   In AMD env the global scope should be kept clean, but jQuery is an exception.
    //   jQuery always exports to global scope, unless jQuery.noConflict(true) is used,
    //   and we should catch that.
    var $ = typeof window !== UNDEF_TYPE && (window.jQuery || window.Zepto);
    if ($ && !$.ua) {
        var parser = new UAParser();
        $.ua = parser.getResult();
        $.ua.get = function () {
            return parser.getUA();
        };
        $.ua.set = function (ua) {
            parser.setUA(ua);
            var result = parser.getResult();
            for (var prop in result) {
                $.ua[prop] = result[prop];
            }
        };
    }

})(typeof window === 'object' ? window : this);


/***/ }),

/***/ 48863:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {


/**
 * Module exports.
 */

module.exports = deprecate;

/**
 * Mark that a method should not be used.
 * Returns a modified function which warns once by default.
 *
 * If `localStorage.noDeprecation = true` is set, then it is a no-op.
 *
 * If `localStorage.throwDeprecation = true` is set, then deprecated functions
 * will throw an Error when invoked.
 *
 * If `localStorage.traceDeprecation = true` is set, then deprecated functions
 * will invoke `console.trace()` instead of `console.error()`.
 *
 * @param {Function} fn - the function to deprecate
 * @param {String} msg - the string to print to the console when `fn` is invoked
 * @returns {Function} a new "deprecated" version of `fn`
 * @api public
 */

function deprecate (fn, msg) {
  if (config('noDeprecation')) {
    return fn;
  }

  var warned = false;
  function deprecated() {
    if (!warned) {
      if (config('throwDeprecation')) {
        throw new Error(msg);
      } else if (config('traceDeprecation')) {
        console.trace(msg);
      } else {
        console.warn(msg);
      }
      warned = true;
    }
    return fn.apply(this, arguments);
  }

  return deprecated;
}

/**
 * Checks `localStorage` for boolean values for the given `name`.
 *
 * @param {String} name
 * @returns {Boolean}
 * @api private
 */

function config (name) {
  // accessing global.localStorage can trigger a DOMException in sandboxed iframes
  try {
    if (!__webpack_require__.g.localStorage) return false;
  } catch (_) {
    return false;
  }
  var val = __webpack_require__.g.localStorage[name];
  if (null == val) return false;
  return String(val).toLowerCase() === 'true';
}


/***/ }),

/***/ 25167:
/***/ (function(module) {

module.exports = function isBuffer(arg) {
  return arg && typeof arg === 'object'
    && typeof arg.copy === 'function'
    && typeof arg.fill === 'function'
    && typeof arg.readUInt8 === 'function';
}

/***/ }),

/***/ 86011:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

/* provided dependency */ var process = __webpack_require__(14224);
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

var formatRegExp = /%[sdj%]/g;
exports.format = function(f) {
  if (!isString(f)) {
    var objects = [];
    for (var i = 0; i < arguments.length; i++) {
      objects.push(inspect(arguments[i]));
    }
    return objects.join(' ');
  }

  var i = 1;
  var args = arguments;
  var len = args.length;
  var str = String(f).replace(formatRegExp, function(x) {
    if (x === '%%') return '%';
    if (i >= len) return x;
    switch (x) {
      case '%s': return String(args[i++]);
      case '%d': return Number(args[i++]);
      case '%j':
        try {
          return JSON.stringify(args[i++]);
        } catch (_) {
          return '[Circular]';
        }
      default:
        return x;
    }
  });
  for (var x = args[i]; i < len; x = args[++i]) {
    if (isNull(x) || !isObject(x)) {
      str += ' ' + x;
    } else {
      str += ' ' + inspect(x);
    }
  }
  return str;
};


// Mark that a method should not be used.
// Returns a modified function which warns once by default.
// If --no-deprecation is set, then it is a no-op.
exports.deprecate = function(fn, msg) {
  // Allow for deprecating things in the process of starting up.
  if (isUndefined(__webpack_require__.g.process)) {
    return function() {
      return exports.deprecate(fn, msg).apply(this, arguments);
    };
  }

  if (process.noDeprecation === true) {
    return fn;
  }

  var warned = false;
  function deprecated() {
    if (!warned) {
      if (process.throwDeprecation) {
        throw new Error(msg);
      } else if (process.traceDeprecation) {
        console.trace(msg);
      } else {
        console.error(msg);
      }
      warned = true;
    }
    return fn.apply(this, arguments);
  }

  return deprecated;
};


var debugs = {};
var debugEnviron;
exports.debuglog = function(set) {
  if (isUndefined(debugEnviron))
    debugEnviron = process.env.NODE_DEBUG || '';
  set = set.toUpperCase();
  if (!debugs[set]) {
    if (new RegExp('\\b' + set + '\\b', 'i').test(debugEnviron)) {
      var pid = process.pid;
      debugs[set] = function() {
        var msg = exports.format.apply(exports, arguments);
        console.error('%s %d: %s', set, pid, msg);
      };
    } else {
      debugs[set] = function() {};
    }
  }
  return debugs[set];
};


/**
 * Echos the value of a value. Trys to print the value out
 * in the best way possible given the different types.
 *
 * @param {Object} obj The object to print out.
 * @param {Object} opts Optional options object that alters the output.
 */
/* legacy: obj, showHidden, depth, colors*/
function inspect(obj, opts) {
  // default options
  var ctx = {
    seen: [],
    stylize: stylizeNoColor
  };
  // legacy...
  if (arguments.length >= 3) ctx.depth = arguments[2];
  if (arguments.length >= 4) ctx.colors = arguments[3];
  if (isBoolean(opts)) {
    // legacy...
    ctx.showHidden = opts;
  } else if (opts) {
    // got an "options" object
    exports._extend(ctx, opts);
  }
  // set default options
  if (isUndefined(ctx.showHidden)) ctx.showHidden = false;
  if (isUndefined(ctx.depth)) ctx.depth = 2;
  if (isUndefined(ctx.colors)) ctx.colors = false;
  if (isUndefined(ctx.customInspect)) ctx.customInspect = true;
  if (ctx.colors) ctx.stylize = stylizeWithColor;
  return formatValue(ctx, obj, ctx.depth);
}
exports.inspect = inspect;


// http://en.wikipedia.org/wiki/ANSI_escape_code#graphics
inspect.colors = {
  'bold' : [1, 22],
  'italic' : [3, 23],
  'underline' : [4, 24],
  'inverse' : [7, 27],
  'white' : [37, 39],
  'grey' : [90, 39],
  'black' : [30, 39],
  'blue' : [34, 39],
  'cyan' : [36, 39],
  'green' : [32, 39],
  'magenta' : [35, 39],
  'red' : [31, 39],
  'yellow' : [33, 39]
};

// Don't use 'blue' not visible on cmd.exe
inspect.styles = {
  'special': 'cyan',
  'number': 'yellow',
  'boolean': 'yellow',
  'undefined': 'grey',
  'null': 'bold',
  'string': 'green',
  'date': 'magenta',
  // "name": intentionally not styling
  'regexp': 'red'
};


function stylizeWithColor(str, styleType) {
  var style = inspect.styles[styleType];

  if (style) {
    return '\u001b[' + inspect.colors[style][0] + 'm' + str +
           '\u001b[' + inspect.colors[style][1] + 'm';
  } else {
    return str;
  }
}


function stylizeNoColor(str, styleType) {
  return str;
}


function arrayToHash(array) {
  var hash = {};

  array.forEach(function(val, idx) {
    hash[val] = true;
  });

  return hash;
}


function formatValue(ctx, value, recurseTimes) {
  // Provide a hook for user-specified inspect functions.
  // Check that value is an object with an inspect function on it
  if (ctx.customInspect &&
      value &&
      isFunction(value.inspect) &&
      // Filter out the util module, it's inspect function is special
      value.inspect !== exports.inspect &&
      // Also filter out any prototype objects using the circular check.
      !(value.constructor && value.constructor.prototype === value)) {
    var ret = value.inspect(recurseTimes, ctx);
    if (!isString(ret)) {
      ret = formatValue(ctx, ret, recurseTimes);
    }
    return ret;
  }

  // Primitive types cannot have properties
  var primitive = formatPrimitive(ctx, value);
  if (primitive) {
    return primitive;
  }

  // Look up the keys of the object.
  var keys = Object.keys(value);
  var visibleKeys = arrayToHash(keys);

  if (ctx.showHidden) {
    keys = Object.getOwnPropertyNames(value);
  }

  // IE doesn't make error fields non-enumerable
  // http://msdn.microsoft.com/en-us/library/ie/dww52sbt(v=vs.94).aspx
  if (isError(value)
      && (keys.indexOf('message') >= 0 || keys.indexOf('description') >= 0)) {
    return formatError(value);
  }

  // Some type of object without properties can be shortcutted.
  if (keys.length === 0) {
    if (isFunction(value)) {
      var name = value.name ? ': ' + value.name : '';
      return ctx.stylize('[Function' + name + ']', 'special');
    }
    if (isRegExp(value)) {
      return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
    }
    if (isDate(value)) {
      return ctx.stylize(Date.prototype.toString.call(value), 'date');
    }
    if (isError(value)) {
      return formatError(value);
    }
  }

  var base = '', array = false, braces = ['{', '}'];

  // Make Array say that they are Array
  if (isArray(value)) {
    array = true;
    braces = ['[', ']'];
  }

  // Make functions say that they are functions
  if (isFunction(value)) {
    var n = value.name ? ': ' + value.name : '';
    base = ' [Function' + n + ']';
  }

  // Make RegExps say that they are RegExps
  if (isRegExp(value)) {
    base = ' ' + RegExp.prototype.toString.call(value);
  }

  // Make dates with properties first say the date
  if (isDate(value)) {
    base = ' ' + Date.prototype.toUTCString.call(value);
  }

  // Make error with message first say the error
  if (isError(value)) {
    base = ' ' + formatError(value);
  }

  if (keys.length === 0 && (!array || value.length == 0)) {
    return braces[0] + base + braces[1];
  }

  if (recurseTimes < 0) {
    if (isRegExp(value)) {
      return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
    } else {
      return ctx.stylize('[Object]', 'special');
    }
  }

  ctx.seen.push(value);

  var output;
  if (array) {
    output = formatArray(ctx, value, recurseTimes, visibleKeys, keys);
  } else {
    output = keys.map(function(key) {
      return formatProperty(ctx, value, recurseTimes, visibleKeys, key, array);
    });
  }

  ctx.seen.pop();

  return reduceToSingleString(output, base, braces);
}


function formatPrimitive(ctx, value) {
  if (isUndefined(value))
    return ctx.stylize('undefined', 'undefined');
  if (isString(value)) {
    var simple = '\'' + JSON.stringify(value).replace(/^"|"$/g, '')
                                             .replace(/'/g, "\\'")
                                             .replace(/\\"/g, '"') + '\'';
    return ctx.stylize(simple, 'string');
  }
  if (isNumber(value))
    return ctx.stylize('' + value, 'number');
  if (isBoolean(value))
    return ctx.stylize('' + value, 'boolean');
  // For some reason typeof null is "object", so special case here.
  if (isNull(value))
    return ctx.stylize('null', 'null');
}


function formatError(value) {
  return '[' + Error.prototype.toString.call(value) + ']';
}


function formatArray(ctx, value, recurseTimes, visibleKeys, keys) {
  var output = [];
  for (var i = 0, l = value.length; i < l; ++i) {
    if (hasOwnProperty(value, String(i))) {
      output.push(formatProperty(ctx, value, recurseTimes, visibleKeys,
          String(i), true));
    } else {
      output.push('');
    }
  }
  keys.forEach(function(key) {
    if (!key.match(/^\d+$/)) {
      output.push(formatProperty(ctx, value, recurseTimes, visibleKeys,
          key, true));
    }
  });
  return output;
}


function formatProperty(ctx, value, recurseTimes, visibleKeys, key, array) {
  var name, str, desc;
  desc = Object.getOwnPropertyDescriptor(value, key) || { value: value[key] };
  if (desc.get) {
    if (desc.set) {
      str = ctx.stylize('[Getter/Setter]', 'special');
    } else {
      str = ctx.stylize('[Getter]', 'special');
    }
  } else {
    if (desc.set) {
      str = ctx.stylize('[Setter]', 'special');
    }
  }
  if (!hasOwnProperty(visibleKeys, key)) {
    name = '[' + key + ']';
  }
  if (!str) {
    if (ctx.seen.indexOf(desc.value) < 0) {
      if (isNull(recurseTimes)) {
        str = formatValue(ctx, desc.value, null);
      } else {
        str = formatValue(ctx, desc.value, recurseTimes - 1);
      }
      if (str.indexOf('\n') > -1) {
        if (array) {
          str = str.split('\n').map(function(line) {
            return '  ' + line;
          }).join('\n').substr(2);
        } else {
          str = '\n' + str.split('\n').map(function(line) {
            return '   ' + line;
          }).join('\n');
        }
      }
    } else {
      str = ctx.stylize('[Circular]', 'special');
    }
  }
  if (isUndefined(name)) {
    if (array && key.match(/^\d+$/)) {
      return str;
    }
    name = JSON.stringify('' + key);
    if (name.match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/)) {
      name = name.substr(1, name.length - 2);
      name = ctx.stylize(name, 'name');
    } else {
      name = name.replace(/'/g, "\\'")
                 .replace(/\\"/g, '"')
                 .replace(/(^"|"$)/g, "'");
      name = ctx.stylize(name, 'string');
    }
  }

  return name + ': ' + str;
}


function reduceToSingleString(output, base, braces) {
  var numLinesEst = 0;
  var length = output.reduce(function(prev, cur) {
    numLinesEst++;
    if (cur.indexOf('\n') >= 0) numLinesEst++;
    return prev + cur.replace(/\u001b\[\d\d?m/g, '').length + 1;
  }, 0);

  if (length > 60) {
    return braces[0] +
           (base === '' ? '' : base + '\n ') +
           ' ' +
           output.join(',\n  ') +
           ' ' +
           braces[1];
  }

  return braces[0] + base + ' ' + output.join(', ') + ' ' + braces[1];
}


// NOTE: These type checking functions intentionally don't use `instanceof`
// because it is fragile and can be easily faked with `Object.create()`.
function isArray(ar) {
  return Array.isArray(ar);
}
exports.isArray = isArray;

function isBoolean(arg) {
  return typeof arg === 'boolean';
}
exports.isBoolean = isBoolean;

function isNull(arg) {
  return arg === null;
}
exports.isNull = isNull;

function isNullOrUndefined(arg) {
  return arg == null;
}
exports.isNullOrUndefined = isNullOrUndefined;

function isNumber(arg) {
  return typeof arg === 'number';
}
exports.isNumber = isNumber;

function isString(arg) {
  return typeof arg === 'string';
}
exports.isString = isString;

function isSymbol(arg) {
  return typeof arg === 'symbol';
}
exports.isSymbol = isSymbol;

function isUndefined(arg) {
  return arg === void 0;
}
exports.isUndefined = isUndefined;

function isRegExp(re) {
  return isObject(re) && objectToString(re) === '[object RegExp]';
}
exports.isRegExp = isRegExp;

function isObject(arg) {
  return typeof arg === 'object' && arg !== null;
}
exports.isObject = isObject;

function isDate(d) {
  return isObject(d) && objectToString(d) === '[object Date]';
}
exports.isDate = isDate;

function isError(e) {
  return isObject(e) &&
      (objectToString(e) === '[object Error]' || e instanceof Error);
}
exports.isError = isError;

function isFunction(arg) {
  return typeof arg === 'function';
}
exports.isFunction = isFunction;

function isPrimitive(arg) {
  return arg === null ||
         typeof arg === 'boolean' ||
         typeof arg === 'number' ||
         typeof arg === 'string' ||
         typeof arg === 'symbol' ||  // ES6 symbol
         typeof arg === 'undefined';
}
exports.isPrimitive = isPrimitive;

exports.isBuffer = __webpack_require__(25167);

function objectToString(o) {
  return Object.prototype.toString.call(o);
}


function pad(n) {
  return n < 10 ? '0' + n.toString(10) : n.toString(10);
}


var months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep',
              'Oct', 'Nov', 'Dec'];

// 26 Feb 16:19:34
function timestamp() {
  var d = new Date();
  var time = [pad(d.getHours()),
              pad(d.getMinutes()),
              pad(d.getSeconds())].join(':');
  return [d.getDate(), months[d.getMonth()], time].join(' ');
}


// log is just a thin wrapper to console.log that prepends a timestamp
exports.log = function() {
  console.log('%s - %s', timestamp(), exports.format.apply(exports, arguments));
};


/**
 * Inherit the prototype methods from one constructor into another.
 *
 * The Function.prototype.inherits from lang.js rewritten as a standalone
 * function (not on Function.prototype). NOTE: If this file is to be loaded
 * during bootstrapping this function needs to be rewritten using some native
 * functions as prototype setup using normal JavaScript does not work as
 * expected during bootstrapping (see mirror.js in r114903).
 *
 * @param {function} ctor Constructor function which needs to inherit the
 *     prototype.
 * @param {function} superCtor Constructor function to inherit prototype from.
 */
exports.inherits = __webpack_require__(9846);

exports._extend = function(origin, add) {
  // Don't do anything if add isn't an object
  if (!add || !isObject(add)) return origin;

  var keys = Object.keys(add);
  var i = keys.length;
  while (i--) {
    origin[keys[i]] = add[keys[i]];
  }
  return origin;
};

function hasOwnProperty(obj, prop) {
  return Object.prototype.hasOwnProperty.call(obj, prop);
}


/***/ }),

/***/ 97952:
/***/ (function(module) {

module.exports = function isBuffer(arg) {
  return arg && typeof arg === 'object'
    && typeof arg.copy === 'function'
    && typeof arg.fill === 'function'
    && typeof arg.readUInt8 === 'function';
}

/***/ }),

/***/ 14911:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
// Currently in sync with Node.js lib/internal/util/types.js
// https://github.com/nodejs/node/commit/112cc7c27551254aa2b17098fb774867f05ed0d9



var isArgumentsObject = __webpack_require__(42571);
var isGeneratorFunction = __webpack_require__(89141);
var whichTypedArray = __webpack_require__(44418);
var isTypedArray = __webpack_require__(37261);

function uncurryThis(f) {
  return f.call.bind(f);
}

var BigIntSupported = typeof BigInt !== 'undefined';
var SymbolSupported = typeof Symbol !== 'undefined';

var ObjectToString = uncurryThis(Object.prototype.toString);

var numberValue = uncurryThis(Number.prototype.valueOf);
var stringValue = uncurryThis(String.prototype.valueOf);
var booleanValue = uncurryThis(Boolean.prototype.valueOf);

if (BigIntSupported) {
  var bigIntValue = uncurryThis(BigInt.prototype.valueOf);
}

if (SymbolSupported) {
  var symbolValue = uncurryThis(Symbol.prototype.valueOf);
}

function checkBoxedPrimitive(value, prototypeValueOf) {
  if (typeof value !== 'object') {
    return false;
  }
  try {
    prototypeValueOf(value);
    return true;
  } catch(e) {
    return false;
  }
}

exports.isArgumentsObject = isArgumentsObject;
exports.isGeneratorFunction = isGeneratorFunction;
exports.isTypedArray = isTypedArray;

// Taken from here and modified for better browser support
// https://github.com/sindresorhus/p-is-promise/blob/cda35a513bda03f977ad5cde3a079d237e82d7ef/index.js
function isPromise(input) {
	return (
		(
			typeof Promise !== 'undefined' &&
			input instanceof Promise
		) ||
		(
			input !== null &&
			typeof input === 'object' &&
			typeof input.then === 'function' &&
			typeof input.catch === 'function'
		)
	);
}
exports.isPromise = isPromise;

function isArrayBufferView(value) {
  if (typeof ArrayBuffer !== 'undefined' && ArrayBuffer.isView) {
    return ArrayBuffer.isView(value);
  }

  return (
    isTypedArray(value) ||
    isDataView(value)
  );
}
exports.isArrayBufferView = isArrayBufferView;


function isUint8Array(value) {
  return whichTypedArray(value) === 'Uint8Array';
}
exports.isUint8Array = isUint8Array;

function isUint8ClampedArray(value) {
  return whichTypedArray(value) === 'Uint8ClampedArray';
}
exports.isUint8ClampedArray = isUint8ClampedArray;

function isUint16Array(value) {
  return whichTypedArray(value) === 'Uint16Array';
}
exports.isUint16Array = isUint16Array;

function isUint32Array(value) {
  return whichTypedArray(value) === 'Uint32Array';
}
exports.isUint32Array = isUint32Array;

function isInt8Array(value) {
  return whichTypedArray(value) === 'Int8Array';
}
exports.isInt8Array = isInt8Array;

function isInt16Array(value) {
  return whichTypedArray(value) === 'Int16Array';
}
exports.isInt16Array = isInt16Array;

function isInt32Array(value) {
  return whichTypedArray(value) === 'Int32Array';
}
exports.isInt32Array = isInt32Array;

function isFloat32Array(value) {
  return whichTypedArray(value) === 'Float32Array';
}
exports.isFloat32Array = isFloat32Array;

function isFloat64Array(value) {
  return whichTypedArray(value) === 'Float64Array';
}
exports.isFloat64Array = isFloat64Array;

function isBigInt64Array(value) {
  return whichTypedArray(value) === 'BigInt64Array';
}
exports.isBigInt64Array = isBigInt64Array;

function isBigUint64Array(value) {
  return whichTypedArray(value) === 'BigUint64Array';
}
exports.isBigUint64Array = isBigUint64Array;

function isMapToString(value) {
  return ObjectToString(value) === '[object Map]';
}
isMapToString.working = (
  typeof Map !== 'undefined' &&
  isMapToString(new Map())
);

function isMap(value) {
  if (typeof Map === 'undefined') {
    return false;
  }

  return isMapToString.working
    ? isMapToString(value)
    : value instanceof Map;
}
exports.isMap = isMap;

function isSetToString(value) {
  return ObjectToString(value) === '[object Set]';
}
isSetToString.working = (
  typeof Set !== 'undefined' &&
  isSetToString(new Set())
);
function isSet(value) {
  if (typeof Set === 'undefined') {
    return false;
  }

  return isSetToString.working
    ? isSetToString(value)
    : value instanceof Set;
}
exports.isSet = isSet;

function isWeakMapToString(value) {
  return ObjectToString(value) === '[object WeakMap]';
}
isWeakMapToString.working = (
  typeof WeakMap !== 'undefined' &&
  isWeakMapToString(new WeakMap())
);
function isWeakMap(value) {
  if (typeof WeakMap === 'undefined') {
    return false;
  }

  return isWeakMapToString.working
    ? isWeakMapToString(value)
    : value instanceof WeakMap;
}
exports.isWeakMap = isWeakMap;

function isWeakSetToString(value) {
  return ObjectToString(value) === '[object WeakSet]';
}
isWeakSetToString.working = (
  typeof WeakSet !== 'undefined' &&
  isWeakSetToString(new WeakSet())
);
function isWeakSet(value) {
  return isWeakSetToString(value);
}
exports.isWeakSet = isWeakSet;

function isArrayBufferToString(value) {
  return ObjectToString(value) === '[object ArrayBuffer]';
}
isArrayBufferToString.working = (
  typeof ArrayBuffer !== 'undefined' &&
  isArrayBufferToString(new ArrayBuffer())
);
function isArrayBuffer(value) {
  if (typeof ArrayBuffer === 'undefined') {
    return false;
  }

  return isArrayBufferToString.working
    ? isArrayBufferToString(value)
    : value instanceof ArrayBuffer;
}
exports.isArrayBuffer = isArrayBuffer;

function isDataViewToString(value) {
  return ObjectToString(value) === '[object DataView]';
}
isDataViewToString.working = (
  typeof ArrayBuffer !== 'undefined' &&
  typeof DataView !== 'undefined' &&
  isDataViewToString(new DataView(new ArrayBuffer(1), 0, 1))
);
function isDataView(value) {
  if (typeof DataView === 'undefined') {
    return false;
  }

  return isDataViewToString.working
    ? isDataViewToString(value)
    : value instanceof DataView;
}
exports.isDataView = isDataView;

// Store a copy of SharedArrayBuffer in case it's deleted elsewhere
var SharedArrayBufferCopy = typeof SharedArrayBuffer !== 'undefined' ? SharedArrayBuffer : undefined;
function isSharedArrayBufferToString(value) {
  return ObjectToString(value) === '[object SharedArrayBuffer]';
}
function isSharedArrayBuffer(value) {
  if (typeof SharedArrayBufferCopy === 'undefined') {
    return false;
  }

  if (typeof isSharedArrayBufferToString.working === 'undefined') {
    isSharedArrayBufferToString.working = isSharedArrayBufferToString(new SharedArrayBufferCopy());
  }

  return isSharedArrayBufferToString.working
    ? isSharedArrayBufferToString(value)
    : value instanceof SharedArrayBufferCopy;
}
exports.isSharedArrayBuffer = isSharedArrayBuffer;

function isAsyncFunction(value) {
  return ObjectToString(value) === '[object AsyncFunction]';
}
exports.isAsyncFunction = isAsyncFunction;

function isMapIterator(value) {
  return ObjectToString(value) === '[object Map Iterator]';
}
exports.isMapIterator = isMapIterator;

function isSetIterator(value) {
  return ObjectToString(value) === '[object Set Iterator]';
}
exports.isSetIterator = isSetIterator;

function isGeneratorObject(value) {
  return ObjectToString(value) === '[object Generator]';
}
exports.isGeneratorObject = isGeneratorObject;

function isWebAssemblyCompiledModule(value) {
  return ObjectToString(value) === '[object WebAssembly.Module]';
}
exports.isWebAssemblyCompiledModule = isWebAssemblyCompiledModule;

function isNumberObject(value) {
  return checkBoxedPrimitive(value, numberValue);
}
exports.isNumberObject = isNumberObject;

function isStringObject(value) {
  return checkBoxedPrimitive(value, stringValue);
}
exports.isStringObject = isStringObject;

function isBooleanObject(value) {
  return checkBoxedPrimitive(value, booleanValue);
}
exports.isBooleanObject = isBooleanObject;

function isBigIntObject(value) {
  return BigIntSupported && checkBoxedPrimitive(value, bigIntValue);
}
exports.isBigIntObject = isBigIntObject;

function isSymbolObject(value) {
  return SymbolSupported && checkBoxedPrimitive(value, symbolValue);
}
exports.isSymbolObject = isSymbolObject;

function isBoxedPrimitive(value) {
  return (
    isNumberObject(value) ||
    isStringObject(value) ||
    isBooleanObject(value) ||
    isBigIntObject(value) ||
    isSymbolObject(value)
  );
}
exports.isBoxedPrimitive = isBoxedPrimitive;

function isAnyArrayBuffer(value) {
  return typeof Uint8Array !== 'undefined' && (
    isArrayBuffer(value) ||
    isSharedArrayBuffer(value)
  );
}
exports.isAnyArrayBuffer = isAnyArrayBuffer;

['isProxy', 'isExternal', 'isModuleNamespaceObject'].forEach(function(method) {
  Object.defineProperty(exports, method, {
    enumerable: false,
    value: function() {
      throw new Error(method + ' is not supported in userland');
    }
  });
});


/***/ }),

/***/ 93585:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

/* provided dependency */ var process = __webpack_require__(14224);
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

var getOwnPropertyDescriptors = Object.getOwnPropertyDescriptors ||
  function getOwnPropertyDescriptors(obj) {
    var keys = Object.keys(obj);
    var descriptors = {};
    for (var i = 0; i < keys.length; i++) {
      descriptors[keys[i]] = Object.getOwnPropertyDescriptor(obj, keys[i]);
    }
    return descriptors;
  };

var formatRegExp = /%[sdj%]/g;
exports.format = function(f) {
  if (!isString(f)) {
    var objects = [];
    for (var i = 0; i < arguments.length; i++) {
      objects.push(inspect(arguments[i]));
    }
    return objects.join(' ');
  }

  var i = 1;
  var args = arguments;
  var len = args.length;
  var str = String(f).replace(formatRegExp, function(x) {
    if (x === '%%') return '%';
    if (i >= len) return x;
    switch (x) {
      case '%s': return String(args[i++]);
      case '%d': return Number(args[i++]);
      case '%j':
        try {
          return JSON.stringify(args[i++]);
        } catch (_) {
          return '[Circular]';
        }
      default:
        return x;
    }
  });
  for (var x = args[i]; i < len; x = args[++i]) {
    if (isNull(x) || !isObject(x)) {
      str += ' ' + x;
    } else {
      str += ' ' + inspect(x);
    }
  }
  return str;
};


// Mark that a method should not be used.
// Returns a modified function which warns once by default.
// If --no-deprecation is set, then it is a no-op.
exports.deprecate = function(fn, msg) {
  if (typeof process !== 'undefined' && process.noDeprecation === true) {
    return fn;
  }

  // Allow for deprecating things in the process of starting up.
  if (typeof process === 'undefined') {
    return function() {
      return exports.deprecate(fn, msg).apply(this, arguments);
    };
  }

  var warned = false;
  function deprecated() {
    if (!warned) {
      if (process.throwDeprecation) {
        throw new Error(msg);
      } else if (process.traceDeprecation) {
        console.trace(msg);
      } else {
        console.error(msg);
      }
      warned = true;
    }
    return fn.apply(this, arguments);
  }

  return deprecated;
};


var debugs = {};
var debugEnvRegex = /^$/;

if (process.env.NODE_DEBUG) {
  var debugEnv = process.env.NODE_DEBUG;
  debugEnv = debugEnv.replace(/[|\\{}()[\]^$+?.]/g, '\\$&')
    .replace(/\*/g, '.*')
    .replace(/,/g, '$|^')
    .toUpperCase();
  debugEnvRegex = new RegExp('^' + debugEnv + '$', 'i');
}
exports.debuglog = function(set) {
  set = set.toUpperCase();
  if (!debugs[set]) {
    if (debugEnvRegex.test(set)) {
      var pid = process.pid;
      debugs[set] = function() {
        var msg = exports.format.apply(exports, arguments);
        console.error('%s %d: %s', set, pid, msg);
      };
    } else {
      debugs[set] = function() {};
    }
  }
  return debugs[set];
};


/**
 * Echos the value of a value. Trys to print the value out
 * in the best way possible given the different types.
 *
 * @param {Object} obj The object to print out.
 * @param {Object} opts Optional options object that alters the output.
 */
/* legacy: obj, showHidden, depth, colors*/
function inspect(obj, opts) {
  // default options
  var ctx = {
    seen: [],
    stylize: stylizeNoColor
  };
  // legacy...
  if (arguments.length >= 3) ctx.depth = arguments[2];
  if (arguments.length >= 4) ctx.colors = arguments[3];
  if (isBoolean(opts)) {
    // legacy...
    ctx.showHidden = opts;
  } else if (opts) {
    // got an "options" object
    exports._extend(ctx, opts);
  }
  // set default options
  if (isUndefined(ctx.showHidden)) ctx.showHidden = false;
  if (isUndefined(ctx.depth)) ctx.depth = 2;
  if (isUndefined(ctx.colors)) ctx.colors = false;
  if (isUndefined(ctx.customInspect)) ctx.customInspect = true;
  if (ctx.colors) ctx.stylize = stylizeWithColor;
  return formatValue(ctx, obj, ctx.depth);
}
exports.inspect = inspect;


// http://en.wikipedia.org/wiki/ANSI_escape_code#graphics
inspect.colors = {
  'bold' : [1, 22],
  'italic' : [3, 23],
  'underline' : [4, 24],
  'inverse' : [7, 27],
  'white' : [37, 39],
  'grey' : [90, 39],
  'black' : [30, 39],
  'blue' : [34, 39],
  'cyan' : [36, 39],
  'green' : [32, 39],
  'magenta' : [35, 39],
  'red' : [31, 39],
  'yellow' : [33, 39]
};

// Don't use 'blue' not visible on cmd.exe
inspect.styles = {
  'special': 'cyan',
  'number': 'yellow',
  'boolean': 'yellow',
  'undefined': 'grey',
  'null': 'bold',
  'string': 'green',
  'date': 'magenta',
  // "name": intentionally not styling
  'regexp': 'red'
};


function stylizeWithColor(str, styleType) {
  var style = inspect.styles[styleType];

  if (style) {
    return '\u001b[' + inspect.colors[style][0] + 'm' + str +
           '\u001b[' + inspect.colors[style][1] + 'm';
  } else {
    return str;
  }
}


function stylizeNoColor(str, styleType) {
  return str;
}


function arrayToHash(array) {
  var hash = {};

  array.forEach(function(val, idx) {
    hash[val] = true;
  });

  return hash;
}


function formatValue(ctx, value, recurseTimes) {
  // Provide a hook for user-specified inspect functions.
  // Check that value is an object with an inspect function on it
  if (ctx.customInspect &&
      value &&
      isFunction(value.inspect) &&
      // Filter out the util module, it's inspect function is special
      value.inspect !== exports.inspect &&
      // Also filter out any prototype objects using the circular check.
      !(value.constructor && value.constructor.prototype === value)) {
    var ret = value.inspect(recurseTimes, ctx);
    if (!isString(ret)) {
      ret = formatValue(ctx, ret, recurseTimes);
    }
    return ret;
  }

  // Primitive types cannot have properties
  var primitive = formatPrimitive(ctx, value);
  if (primitive) {
    return primitive;
  }

  // Look up the keys of the object.
  var keys = Object.keys(value);
  var visibleKeys = arrayToHash(keys);

  if (ctx.showHidden) {
    keys = Object.getOwnPropertyNames(value);
  }

  // IE doesn't make error fields non-enumerable
  // http://msdn.microsoft.com/en-us/library/ie/dww52sbt(v=vs.94).aspx
  if (isError(value)
      && (keys.indexOf('message') >= 0 || keys.indexOf('description') >= 0)) {
    return formatError(value);
  }

  // Some type of object without properties can be shortcutted.
  if (keys.length === 0) {
    if (isFunction(value)) {
      var name = value.name ? ': ' + value.name : '';
      return ctx.stylize('[Function' + name + ']', 'special');
    }
    if (isRegExp(value)) {
      return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
    }
    if (isDate(value)) {
      return ctx.stylize(Date.prototype.toString.call(value), 'date');
    }
    if (isError(value)) {
      return formatError(value);
    }
  }

  var base = '', array = false, braces = ['{', '}'];

  // Make Array say that they are Array
  if (isArray(value)) {
    array = true;
    braces = ['[', ']'];
  }

  // Make functions say that they are functions
  if (isFunction(value)) {
    var n = value.name ? ': ' + value.name : '';
    base = ' [Function' + n + ']';
  }

  // Make RegExps say that they are RegExps
  if (isRegExp(value)) {
    base = ' ' + RegExp.prototype.toString.call(value);
  }

  // Make dates with properties first say the date
  if (isDate(value)) {
    base = ' ' + Date.prototype.toUTCString.call(value);
  }

  // Make error with message first say the error
  if (isError(value)) {
    base = ' ' + formatError(value);
  }

  if (keys.length === 0 && (!array || value.length == 0)) {
    return braces[0] + base + braces[1];
  }

  if (recurseTimes < 0) {
    if (isRegExp(value)) {
      return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
    } else {
      return ctx.stylize('[Object]', 'special');
    }
  }

  ctx.seen.push(value);

  var output;
  if (array) {
    output = formatArray(ctx, value, recurseTimes, visibleKeys, keys);
  } else {
    output = keys.map(function(key) {
      return formatProperty(ctx, value, recurseTimes, visibleKeys, key, array);
    });
  }

  ctx.seen.pop();

  return reduceToSingleString(output, base, braces);
}


function formatPrimitive(ctx, value) {
  if (isUndefined(value))
    return ctx.stylize('undefined', 'undefined');
  if (isString(value)) {
    var simple = '\'' + JSON.stringify(value).replace(/^"|"$/g, '')
                                             .replace(/'/g, "\\'")
                                             .replace(/\\"/g, '"') + '\'';
    return ctx.stylize(simple, 'string');
  }
  if (isNumber(value))
    return ctx.stylize('' + value, 'number');
  if (isBoolean(value))
    return ctx.stylize('' + value, 'boolean');
  // For some reason typeof null is "object", so special case here.
  if (isNull(value))
    return ctx.stylize('null', 'null');
}


function formatError(value) {
  return '[' + Error.prototype.toString.call(value) + ']';
}


function formatArray(ctx, value, recurseTimes, visibleKeys, keys) {
  var output = [];
  for (var i = 0, l = value.length; i < l; ++i) {
    if (hasOwnProperty(value, String(i))) {
      output.push(formatProperty(ctx, value, recurseTimes, visibleKeys,
          String(i), true));
    } else {
      output.push('');
    }
  }
  keys.forEach(function(key) {
    if (!key.match(/^\d+$/)) {
      output.push(formatProperty(ctx, value, recurseTimes, visibleKeys,
          key, true));
    }
  });
  return output;
}


function formatProperty(ctx, value, recurseTimes, visibleKeys, key, array) {
  var name, str, desc;
  desc = Object.getOwnPropertyDescriptor(value, key) || { value: value[key] };
  if (desc.get) {
    if (desc.set) {
      str = ctx.stylize('[Getter/Setter]', 'special');
    } else {
      str = ctx.stylize('[Getter]', 'special');
    }
  } else {
    if (desc.set) {
      str = ctx.stylize('[Setter]', 'special');
    }
  }
  if (!hasOwnProperty(visibleKeys, key)) {
    name = '[' + key + ']';
  }
  if (!str) {
    if (ctx.seen.indexOf(desc.value) < 0) {
      if (isNull(recurseTimes)) {
        str = formatValue(ctx, desc.value, null);
      } else {
        str = formatValue(ctx, desc.value, recurseTimes - 1);
      }
      if (str.indexOf('\n') > -1) {
        if (array) {
          str = str.split('\n').map(function(line) {
            return '  ' + line;
          }).join('\n').slice(2);
        } else {
          str = '\n' + str.split('\n').map(function(line) {
            return '   ' + line;
          }).join('\n');
        }
      }
    } else {
      str = ctx.stylize('[Circular]', 'special');
    }
  }
  if (isUndefined(name)) {
    if (array && key.match(/^\d+$/)) {
      return str;
    }
    name = JSON.stringify('' + key);
    if (name.match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/)) {
      name = name.slice(1, -1);
      name = ctx.stylize(name, 'name');
    } else {
      name = name.replace(/'/g, "\\'")
                 .replace(/\\"/g, '"')
                 .replace(/(^"|"$)/g, "'");
      name = ctx.stylize(name, 'string');
    }
  }

  return name + ': ' + str;
}


function reduceToSingleString(output, base, braces) {
  var numLinesEst = 0;
  var length = output.reduce(function(prev, cur) {
    numLinesEst++;
    if (cur.indexOf('\n') >= 0) numLinesEst++;
    return prev + cur.replace(/\u001b\[\d\d?m/g, '').length + 1;
  }, 0);

  if (length > 60) {
    return braces[0] +
           (base === '' ? '' : base + '\n ') +
           ' ' +
           output.join(',\n  ') +
           ' ' +
           braces[1];
  }

  return braces[0] + base + ' ' + output.join(', ') + ' ' + braces[1];
}


// NOTE: These type checking functions intentionally don't use `instanceof`
// because it is fragile and can be easily faked with `Object.create()`.
exports.types = __webpack_require__(14911);

function isArray(ar) {
  return Array.isArray(ar);
}
exports.isArray = isArray;

function isBoolean(arg) {
  return typeof arg === 'boolean';
}
exports.isBoolean = isBoolean;

function isNull(arg) {
  return arg === null;
}
exports.isNull = isNull;

function isNullOrUndefined(arg) {
  return arg == null;
}
exports.isNullOrUndefined = isNullOrUndefined;

function isNumber(arg) {
  return typeof arg === 'number';
}
exports.isNumber = isNumber;

function isString(arg) {
  return typeof arg === 'string';
}
exports.isString = isString;

function isSymbol(arg) {
  return typeof arg === 'symbol';
}
exports.isSymbol = isSymbol;

function isUndefined(arg) {
  return arg === void 0;
}
exports.isUndefined = isUndefined;

function isRegExp(re) {
  return isObject(re) && objectToString(re) === '[object RegExp]';
}
exports.isRegExp = isRegExp;
exports.types.isRegExp = isRegExp;

function isObject(arg) {
  return typeof arg === 'object' && arg !== null;
}
exports.isObject = isObject;

function isDate(d) {
  return isObject(d) && objectToString(d) === '[object Date]';
}
exports.isDate = isDate;
exports.types.isDate = isDate;

function isError(e) {
  return isObject(e) &&
      (objectToString(e) === '[object Error]' || e instanceof Error);
}
exports.isError = isError;
exports.types.isNativeError = isError;

function isFunction(arg) {
  return typeof arg === 'function';
}
exports.isFunction = isFunction;

function isPrimitive(arg) {
  return arg === null ||
         typeof arg === 'boolean' ||
         typeof arg === 'number' ||
         typeof arg === 'string' ||
         typeof arg === 'symbol' ||  // ES6 symbol
         typeof arg === 'undefined';
}
exports.isPrimitive = isPrimitive;

exports.isBuffer = __webpack_require__(97952);

function objectToString(o) {
  return Object.prototype.toString.call(o);
}


function pad(n) {
  return n < 10 ? '0' + n.toString(10) : n.toString(10);
}


var months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep',
              'Oct', 'Nov', 'Dec'];

// 26 Feb 16:19:34
function timestamp() {
  var d = new Date();
  var time = [pad(d.getHours()),
              pad(d.getMinutes()),
              pad(d.getSeconds())].join(':');
  return [d.getDate(), months[d.getMonth()], time].join(' ');
}


// log is just a thin wrapper to console.log that prepends a timestamp
exports.log = function() {
  console.log('%s - %s', timestamp(), exports.format.apply(exports, arguments));
};


/**
 * Inherit the prototype methods from one constructor into another.
 *
 * The Function.prototype.inherits from lang.js rewritten as a standalone
 * function (not on Function.prototype). NOTE: If this file is to be loaded
 * during bootstrapping this function needs to be rewritten using some native
 * functions as prototype setup using normal JavaScript does not work as
 * expected during bootstrapping (see mirror.js in r114903).
 *
 * @param {function} ctor Constructor function which needs to inherit the
 *     prototype.
 * @param {function} superCtor Constructor function to inherit prototype from.
 */
exports.inherits = __webpack_require__(2937);

exports._extend = function(origin, add) {
  // Don't do anything if add isn't an object
  if (!add || !isObject(add)) return origin;

  var keys = Object.keys(add);
  var i = keys.length;
  while (i--) {
    origin[keys[i]] = add[keys[i]];
  }
  return origin;
};

function hasOwnProperty(obj, prop) {
  return Object.prototype.hasOwnProperty.call(obj, prop);
}

var kCustomPromisifiedSymbol = typeof Symbol !== 'undefined' ? Symbol('util.promisify.custom') : undefined;

exports.promisify = function promisify(original) {
  if (typeof original !== 'function')
    throw new TypeError('The "original" argument must be of type Function');

  if (kCustomPromisifiedSymbol && original[kCustomPromisifiedSymbol]) {
    var fn = original[kCustomPromisifiedSymbol];
    if (typeof fn !== 'function') {
      throw new TypeError('The "util.promisify.custom" argument must be of type Function');
    }
    Object.defineProperty(fn, kCustomPromisifiedSymbol, {
      value: fn, enumerable: false, writable: false, configurable: true
    });
    return fn;
  }

  function fn() {
    var promiseResolve, promiseReject;
    var promise = new Promise(function (resolve, reject) {
      promiseResolve = resolve;
      promiseReject = reject;
    });

    var args = [];
    for (var i = 0; i < arguments.length; i++) {
      args.push(arguments[i]);
    }
    args.push(function (err, value) {
      if (err) {
        promiseReject(err);
      } else {
        promiseResolve(value);
      }
    });

    try {
      original.apply(this, args);
    } catch (err) {
      promiseReject(err);
    }

    return promise;
  }

  Object.setPrototypeOf(fn, Object.getPrototypeOf(original));

  if (kCustomPromisifiedSymbol) Object.defineProperty(fn, kCustomPromisifiedSymbol, {
    value: fn, enumerable: false, writable: false, configurable: true
  });
  return Object.defineProperties(
    fn,
    getOwnPropertyDescriptors(original)
  );
}

exports.promisify.custom = kCustomPromisifiedSymbol

function callbackifyOnRejected(reason, cb) {
  // `!reason` guard inspired by bluebird (Ref: https://goo.gl/t5IS6M).
  // Because `null` is a special error value in callbacks which means "no error
  // occurred", we error-wrap so the callback consumer can distinguish between
  // "the promise rejected with null" or "the promise fulfilled with undefined".
  if (!reason) {
    var newReason = new Error('Promise was rejected with a falsy value');
    newReason.reason = reason;
    reason = newReason;
  }
  return cb(reason);
}

function callbackify(original) {
  if (typeof original !== 'function') {
    throw new TypeError('The "original" argument must be of type Function');
  }

  // We DO NOT return the promise as it gives the user a false sense that
  // the promise is actually somehow related to the callback's execution
  // and that the callback throwing will reject the promise.
  function callbackified() {
    var args = [];
    for (var i = 0; i < arguments.length; i++) {
      args.push(arguments[i]);
    }

    var maybeCb = args.pop();
    if (typeof maybeCb !== 'function') {
      throw new TypeError('The last argument must be of type Function');
    }
    var self = this;
    var cb = function() {
      return maybeCb.apply(self, arguments);
    };
    // In true node style we process the callback on `nextTick` with all the
    // implications (stack, `uncaughtException`, `async_hooks`)
    original.apply(this, args)
      .then(function(ret) { process.nextTick(cb.bind(null, null, ret)) },
            function(rej) { process.nextTick(callbackifyOnRejected.bind(null, rej, cb)) });
  }

  Object.setPrototypeOf(callbackified, Object.getPrototypeOf(original));
  Object.defineProperties(callbackified,
                          getOwnPropertyDescriptors(original));
  return callbackified;
}
exports.callbackify = callbackify;


/***/ }),

/***/ 89626:
/***/ (function(module) {

/**
 * This file automatically generated from `pre-publish.js`.
 * Do not manually edit.
 */

module.exports = {
  "area": true,
  "base": true,
  "br": true,
  "col": true,
  "embed": true,
  "hr": true,
  "img": true,
  "input": true,
  "link": true,
  "meta": true,
  "param": true,
  "source": true,
  "track": true,
  "wbr": true
};


/***/ }),

/***/ 44418:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var forEach = __webpack_require__(72904);
var availableTypedArrays = __webpack_require__(26773);
var callBind = __webpack_require__(96350);
var callBound = __webpack_require__(74161);
var gOPD = __webpack_require__(70658);

/** @type {(O: object) => string} */
var $toString = callBound('Object.prototype.toString');
var hasToStringTag = __webpack_require__(47388)();

var g = typeof globalThis === 'undefined' ? __webpack_require__.g : globalThis;
var typedArrays = availableTypedArrays();

var $slice = callBound('String.prototype.slice');
var getPrototypeOf = Object.getPrototypeOf; // require('getprototypeof');

/** @type {<T = unknown>(array: readonly T[], value: unknown) => number} */
var $indexOf = callBound('Array.prototype.indexOf', true) || function indexOf(array, value) {
	for (var i = 0; i < array.length; i += 1) {
		if (array[i] === value) {
			return i;
		}
	}
	return -1;
};

/** @typedef {(receiver: import('.').TypedArray) => string | typeof Uint8Array.prototype.slice.call | typeof Uint8Array.prototype.set.call} Getter */
/** @type {{ [k in `\$${import('.').TypedArrayName}`]?: Getter } & { __proto__: null }} */
var cache = { __proto__: null };
if (hasToStringTag && gOPD && getPrototypeOf) {
	forEach(typedArrays, function (typedArray) {
		var arr = new g[typedArray]();
		if (Symbol.toStringTag in arr) {
			var proto = getPrototypeOf(arr);
			// @ts-expect-error TS won't narrow inside a closure
			var descriptor = gOPD(proto, Symbol.toStringTag);
			if (!descriptor) {
				var superProto = getPrototypeOf(proto);
				// @ts-expect-error TS won't narrow inside a closure
				descriptor = gOPD(superProto, Symbol.toStringTag);
			}
			// @ts-expect-error TODO: fix
			cache['$' + typedArray] = callBind(descriptor.get);
		}
	});
} else {
	forEach(typedArrays, function (typedArray) {
		var arr = new g[typedArray]();
		var fn = arr.slice || arr.set;
		if (fn) {
			// @ts-expect-error TODO: fix
			cache['$' + typedArray] = callBind(fn);
		}
	});
}

/** @type {(value: object) => false | import('.').TypedArrayName} */
var tryTypedArrays = function tryAllTypedArrays(value) {
	/** @type {ReturnType<typeof tryAllTypedArrays>} */ var found = false;
	forEach(
		// eslint-disable-next-line no-extra-parens
		/** @type {Record<`\$${TypedArrayName}`, Getter>} */ /** @type {any} */ (cache),
		/** @type {(getter: Getter, name: `\$${import('.').TypedArrayName}`) => void} */
		function (getter, typedArray) {
			if (!found) {
				try {
				// @ts-expect-error TODO: fix
					if ('$' + getter(value) === typedArray) {
						found = $slice(typedArray, 1);
					}
				} catch (e) { /**/ }
			}
		}
	);
	return found;
};

/** @type {(value: object) => false | import('.').TypedArrayName} */
var trySlices = function tryAllSlices(value) {
	/** @type {ReturnType<typeof tryAllSlices>} */ var found = false;
	forEach(
		// eslint-disable-next-line no-extra-parens
		/** @type {Record<`\$${TypedArrayName}`, Getter>} */ /** @type {any} */ (cache),
		/** @type {(getter: typeof cache, name: `\$${import('.').TypedArrayName}`) => void} */ function (getter, name) {
			if (!found) {
				try {
					// @ts-expect-error TODO: fix
					getter(value);
					found = $slice(name, 1);
				} catch (e) { /**/ }
			}
		}
	);
	return found;
};

/** @type {import('.')} */
module.exports = function whichTypedArray(value) {
	if (!value || typeof value !== 'object') { return false; }
	if (!hasToStringTag) {
		/** @type {string} */
		var tag = $slice($toString(value), 8, -1);
		if ($indexOf(typedArrays, tag) > -1) {
			return tag;
		}
		if (tag !== 'Object') {
			return false;
		}
		// node < 0.6 hits here on real Typed Arrays
		return trySlices(value);
	}
	if (!gOPD) { return null; } // unknown engine
	return tryTypedArrays(value);
};


/***/ }),

/***/ 68367:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


// Expose modern transport directly as the export

module.exports = __webpack_require__(4686);

// Expose legacy stream
module.exports.LegacyTransportStream = __webpack_require__(69835);

/***/ }),

/***/ 69835:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var util = __webpack_require__(93585);

var _require = __webpack_require__(27735),
    LEVEL = _require.LEVEL;

var TransportStream = __webpack_require__(4686);

/**
 * Constructor function for the LegacyTransportStream. This is an internal
 * wrapper `winston >= 3` uses to wrap older transports implementing
 * log(level, message, meta).
 * @param {Object} options - Options for this TransportStream instance.
 * @param {Transpot} options.transport - winston@2 or older Transport to wrap.
 */

var LegacyTransportStream = module.exports = function LegacyTransportStream() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  TransportStream.call(this, options);
  if (!options.transport || typeof options.transport.log !== 'function') {
    throw new Error('Invalid transport, must be an object with a log method.');
  }

  this.transport = options.transport;
  this.level = this.level || options.transport.level;
  this.handleExceptions = this.handleExceptions || options.transport.handleExceptions;

  // Display our deprecation notice.
  this._deprecated();

  // Properly bubble up errors from the transport to the
  // LegacyTransportStream instance, but only once no matter how many times
  // this transport is shared.
  function transportError(err) {
    this.emit('error', err, this.transport);
  }

  if (!this.transport.__winstonError) {
    this.transport.__winstonError = transportError.bind(this);
    this.transport.on('error', this.transport.__winstonError);
  }
};

/*
 * Inherit from TransportStream using Node.js built-ins
 */
util.inherits(LegacyTransportStream, TransportStream);

/**
 * Writes the info object to our transport instance.
 * @param {mixed} info - TODO: add param description.
 * @param {mixed} enc - TODO: add param description.
 * @param {function} callback - TODO: add param description.
 * @returns {undefined}
 * @private
 */
LegacyTransportStream.prototype._write = function _write(info, enc, callback) {
  if (this.silent || info.exception === true && !this.handleExceptions) {
    return callback(null);
  }

  // Remark: This has to be handled in the base transport now because we
  // cannot conditionally write to our pipe targets as stream.
  if (!this.level || this.levels[this.level] >= this.levels[info[LEVEL]]) {
    this.transport.log(info[LEVEL], info.message, info, this._nop);
  }

  callback(null);
};

/**
 * Writes the batch of info objects (i.e. "object chunks") to our transport
 * instance after performing any necessary filtering.
 * @param {mixed} chunks - TODO: add params description.
 * @param {function} callback - TODO: add params description.
 * @returns {mixed} - TODO: add returns description.
 * @private
 */
LegacyTransportStream.prototype._writev = function _writev(chunks, callback) {
  for (var i = 0; i < chunks.length; i++) {
    if (this._accept(chunks[i])) {
      this.transport.log(chunks[i].chunk[LEVEL], chunks[i].chunk.message, chunks[i].chunk, this._nop);
      chunks[i].callback();
    }
  }

  return callback(null);
};

/**
 * Displays a deprecation notice. Defined as a function so it can be
 * overriden in tests.
 * @returns {undefined}
 */
LegacyTransportStream.prototype._deprecated = function _deprecated() {
  // eslint-disable-next-line no-console
  console.error([this.transport.name + ' is a legacy winston transport. Consider upgrading: ', '- Upgrade docs: https://github.com/winstonjs/winston/blob/master/UPGRADE-3.0.md'].join('\n'));
};

/**
 * Clean up error handling state on the legacy transport associated
 * with this instance.
 * @returns {undefined}
 */
LegacyTransportStream.prototype.close = function close() {
  if (this.transport.close) {
    this.transport.close();
  }

  if (this.transport.__winstonError) {
    this.transport.removeListener('error', this.transport.__winstonError);
    this.transport.__winstonError = null;
  }
};

/***/ }),

/***/ 4686:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var util = __webpack_require__(93585);
var Writable = __webpack_require__(85067);

var _require = __webpack_require__(27735),
    LEVEL = _require.LEVEL;

/**
 * Constructor function for the TransportStream. This is the base prototype
 * that all `winston >= 3` transports should inherit from.
 * @param {Object} options - Options for this TransportStream instance
 * @param {String} options.level - Highest level according to RFC5424.
 * @param {Boolean} options.handleExceptions - If true, info with
 * { exception: true } will be written.
 * @param {Function} options.log - Custom log function for simple Transport
 * creation
 * @param {Function} options.close - Called on "unpipe" from parent.
 */


var TransportStream = module.exports = function TransportStream() {
  var _this = this;

  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  Writable.call(this, { objectMode: true, highWaterMark: options.highWaterMark });

  this.format = options.format;
  this.level = options.level;
  this.handleExceptions = options.handleExceptions;
  this.handleRejections = options.handleRejections;
  this.silent = options.silent;

  if (options.log) this.log = options.log;
  if (options.logv) this.logv = options.logv;
  if (options.close) this.close = options.close;

  // Get the levels from the source we are piped from.
  this.once('pipe', function (logger) {
    // Remark (indexzero): this bookkeeping can only support multiple
    // Logger parents with the same `levels`. This comes into play in
    // the `winston.Container` code in which `container.add` takes
    // a fully realized set of options with pre-constructed TransportStreams.
    _this.levels = logger.levels;
    _this.parent = logger;
  });

  // If and/or when the transport is removed from this instance
  this.once('unpipe', function (src) {
    // Remark (indexzero): this bookkeeping can only support multiple
    // Logger parents with the same `levels`. This comes into play in
    // the `winston.Container` code in which `container.add` takes
    // a fully realized set of options with pre-constructed TransportStreams.
    if (src === _this.parent) {
      _this.parent = null;
      if (_this.close) {
        _this.close();
      }
    }
  });
};

/*
 * Inherit from Writeable using Node.js built-ins
 */
util.inherits(TransportStream, Writable);

/**
 * Writes the info object to our transport instance.
 * @param {mixed} info - TODO: add param description.
 * @param {mixed} enc - TODO: add param description.
 * @param {function} callback - TODO: add param description.
 * @returns {undefined}
 * @private
 */
TransportStream.prototype._write = function _write(info, enc, callback) {
  if (this.silent || info.exception === true && !this.handleExceptions) {
    return callback(null);
  }

  // Remark: This has to be handled in the base transport now because we
  // cannot conditionally write to our pipe targets as stream. We always
  // prefer any explicit level set on the Transport itself falling back to
  // any level set on the parent.
  var level = this.level || this.parent && this.parent.level;

  if (!level || this.levels[level] >= this.levels[info[LEVEL]]) {
    if (info && !this.format) {
      return this.log(info, callback);
    }

    var errState = void 0;
    var transformed = void 0;

    // We trap(and re-throw) any errors generated by the user-provided format, but also
    // guarantee that the streams callback is invoked so that we can continue flowing.
    try {
      transformed = this.format.transform(Object.assign({}, info), this.format.options);
    } catch (err) {
      errState = err;
    }

    if (errState || !transformed) {
      // eslint-disable-next-line callback-return
      callback();
      if (errState) throw errState;
      return;
    }

    return this.log(transformed, callback);
  }
  this._writableState.sync = false;
  return callback(null);
};

/**
 * Writes the batch of info objects (i.e. "object chunks") to our transport
 * instance after performing any necessary filtering.
 * @param {mixed} chunks - TODO: add params description.
 * @param {function} callback - TODO: add params description.
 * @returns {mixed} - TODO: add returns description.
 * @private
 */
TransportStream.prototype._writev = function _writev(chunks, callback) {
  if (this.logv) {
    var infos = chunks.filter(this._accept, this);
    if (!infos.length) {
      return callback(null);
    }

    // Remark (indexzero): from a performance perspective if Transport
    // implementers do choose to implement logv should we make it their
    // responsibility to invoke their format?
    return this.logv(infos, callback);
  }

  for (var i = 0; i < chunks.length; i++) {
    if (!this._accept(chunks[i])) continue;

    if (chunks[i].chunk && !this.format) {
      this.log(chunks[i].chunk, chunks[i].callback);
      continue;
    }

    var errState = void 0;
    var transformed = void 0;

    // We trap(and re-throw) any errors generated by the user-provided format, but also
    // guarantee that the streams callback is invoked so that we can continue flowing.
    try {
      transformed = this.format.transform(Object.assign({}, chunks[i].chunk), this.format.options);
    } catch (err) {
      errState = err;
    }

    if (errState || !transformed) {
      // eslint-disable-next-line callback-return
      chunks[i].callback();
      if (errState) {
        // eslint-disable-next-line callback-return
        callback(null);
        throw errState;
      }
    } else {
      this.log(transformed, chunks[i].callback);
    }
  }

  return callback(null);
};

/**
 * Predicate function that returns true if the specfied `info` on the
 * WriteReq, `write`, should be passed down into the derived
 * TransportStream's I/O via `.log(info, callback)`.
 * @param {WriteReq} write - winston@3 Node.js WriteReq for the `info` object
 * representing the log message.
 * @returns {Boolean} - Value indicating if the `write` should be accepted &
 * logged.
 */
TransportStream.prototype._accept = function _accept(write) {
  var info = write.chunk;
  if (this.silent) {
    return false;
  }

  // We always prefer any explicit level set on the Transport itself
  // falling back to any level set on the parent.
  var level = this.level || this.parent && this.parent.level;

  // Immediately check the average case: log level filtering.
  if (info.exception === true || !level || this.levels[level] >= this.levels[info[LEVEL]]) {
    // Ensure the info object is valid based on `{ exception }`:
    // 1. { handleExceptions: true }: all `info` objects are valid
    // 2. { exception: false }: accepted by all transports.
    if (this.handleExceptions || info.exception !== true) {
      return true;
    }
  }

  return false;
};

/**
 * _nop is short for "No operation"
 * @returns {Boolean} Intentionally false.
 */
TransportStream.prototype._nop = function _nop() {
  // eslint-disable-next-line no-undefined
  return void undefined;
};

/***/ }),

/***/ 28450:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


const util = __webpack_require__(93585);
const { LEVEL } = __webpack_require__(27735);
const TransportStream = __webpack_require__(3417);

/**
 * Constructor function for the LegacyTransportStream. This is an internal
 * wrapper `winston >= 3` uses to wrap older transports implementing
 * log(level, message, meta).
 * @param {Object} options - Options for this TransportStream instance.
 * @param {Transpot} options.transport - winston@2 or older Transport to wrap.
 */

const LegacyTransportStream = module.exports = function LegacyTransportStream(options = {}) {
  TransportStream.call(this, options);
  if (!options.transport || typeof options.transport.log !== 'function') {
    throw new Error('Invalid transport, must be an object with a log method.');
  }

  this.transport = options.transport;
  this.level = this.level || options.transport.level;
  this.handleExceptions = this.handleExceptions || options.transport.handleExceptions;

  // Display our deprecation notice.
  this._deprecated();

  // Properly bubble up errors from the transport to the
  // LegacyTransportStream instance, but only once no matter how many times
  // this transport is shared.
  function transportError(err) {
    this.emit('error', err, this.transport);
  }

  if (!this.transport.__winstonError) {
    this.transport.__winstonError = transportError.bind(this);
    this.transport.on('error', this.transport.__winstonError);
  }
};

/*
 * Inherit from TransportStream using Node.js built-ins
 */
util.inherits(LegacyTransportStream, TransportStream);

/**
 * Writes the info object to our transport instance.
 * @param {mixed} info - TODO: add param description.
 * @param {mixed} enc - TODO: add param description.
 * @param {function} callback - TODO: add param description.
 * @returns {undefined}
 * @private
 */
LegacyTransportStream.prototype._write = function _write(info, enc, callback) {
  if (this.silent || (info.exception === true && !this.handleExceptions)) {
    return callback(null);
  }

  // Remark: This has to be handled in the base transport now because we
  // cannot conditionally write to our pipe targets as stream.
  if (!this.level || this.levels[this.level] >= this.levels[info[LEVEL]]) {
    this.transport.log(info[LEVEL], info.message, info, this._nop);
  }

  callback(null);
};

/**
 * Writes the batch of info objects (i.e. "object chunks") to our transport
 * instance after performing any necessary filtering.
 * @param {mixed} chunks - TODO: add params description.
 * @param {function} callback - TODO: add params description.
 * @returns {mixed} - TODO: add returns description.
 * @private
 */
LegacyTransportStream.prototype._writev = function _writev(chunks, callback) {
  for (let i = 0; i < chunks.length; i++) {
    if (this._accept(chunks[i])) {
      this.transport.log(
        chunks[i].chunk[LEVEL],
        chunks[i].chunk.message,
        chunks[i].chunk,
        this._nop
      );
      chunks[i].callback();
    }
  }

  return callback(null);
};

/**
 * Displays a deprecation notice. Defined as a function so it can be
 * overriden in tests.
 * @returns {undefined}
 */
LegacyTransportStream.prototype._deprecated = function _deprecated() {
  // eslint-disable-next-line no-console
  console.error([
    `${this.transport.name} is a legacy winston transport. Consider upgrading: `,
    '- Upgrade docs: https://github.com/winstonjs/winston/blob/master/UPGRADE-3.0.md'
  ].join('\n'));
};

/**
 * Clean up error handling state on the legacy transport associated
 * with this instance.
 * @returns {undefined}
 */
LegacyTransportStream.prototype.close = function close() {
  if (this.transport.close) {
    this.transport.close();
  }

  if (this.transport.__winstonError) {
    this.transport.removeListener('error', this.transport.__winstonError);
    this.transport.__winstonError = null;
  }
};


/***/ }),

/***/ 3417:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


const util = __webpack_require__(93585);
const Writable = __webpack_require__(85067);
const { LEVEL } = __webpack_require__(27735);

/**
 * Constructor function for the TransportStream. This is the base prototype
 * that all `winston >= 3` transports should inherit from.
 * @param {Object} options - Options for this TransportStream instance
 * @param {String} options.level - Highest level according to RFC5424.
 * @param {Boolean} options.handleExceptions - If true, info with
 * { exception: true } will be written.
 * @param {Function} options.log - Custom log function for simple Transport
 * creation
 * @param {Function} options.close - Called on "unpipe" from parent.
 */
const TransportStream = module.exports = function TransportStream(options = {}) {
  Writable.call(this, { objectMode: true, highWaterMark: options.highWaterMark });

  this.format = options.format;
  this.level = options.level;
  this.handleExceptions = options.handleExceptions;
  this.handleRejections = options.handleRejections;
  this.silent = options.silent;

  if (options.log) this.log = options.log;
  if (options.logv) this.logv = options.logv;
  if (options.close) this.close = options.close;

  // Get the levels from the source we are piped from.
  this.once('pipe', logger => {
    // Remark (indexzero): this bookkeeping can only support multiple
    // Logger parents with the same `levels`. This comes into play in
    // the `winston.Container` code in which `container.add` takes
    // a fully realized set of options with pre-constructed TransportStreams.
    this.levels = logger.levels;
    this.parent = logger;
  });

  // If and/or when the transport is removed from this instance
  this.once('unpipe', src => {
    // Remark (indexzero): this bookkeeping can only support multiple
    // Logger parents with the same `levels`. This comes into play in
    // the `winston.Container` code in which `container.add` takes
    // a fully realized set of options with pre-constructed TransportStreams.
    if (src === this.parent) {
      this.parent = null;
      if (this.close) {
        this.close();
      }
    }
  });
};

/*
 * Inherit from Writeable using Node.js built-ins
 */
util.inherits(TransportStream, Writable);

/**
 * Writes the info object to our transport instance.
 * @param {mixed} info - TODO: add param description.
 * @param {mixed} enc - TODO: add param description.
 * @param {function} callback - TODO: add param description.
 * @returns {undefined}
 * @private
 */
TransportStream.prototype._write = function _write(info, enc, callback) {
  if (this.silent || (info.exception === true && !this.handleExceptions)) {
    return callback(null);
  }

  // Remark: This has to be handled in the base transport now because we
  // cannot conditionally write to our pipe targets as stream. We always
  // prefer any explicit level set on the Transport itself falling back to
  // any level set on the parent.
  const level = this.level || (this.parent && this.parent.level);

  if (!level || this.levels[level] >= this.levels[info[LEVEL]]) {
    if (info && !this.format) {
      return this.log(info, callback);
    }

    let errState;
    let transformed;

    // We trap(and re-throw) any errors generated by the user-provided format, but also
    // guarantee that the streams callback is invoked so that we can continue flowing.
    try {
      transformed = this.format.transform(Object.assign({}, info), this.format.options);
    } catch (err) {
      errState = err;
    }

    if (errState || !transformed) {
      // eslint-disable-next-line callback-return
      callback();
      if (errState) throw errState;
      return;
    }

    return this.log(transformed, callback);
  }
  this._writableState.sync = false;
  return callback(null);
};

/**
 * Writes the batch of info objects (i.e. "object chunks") to our transport
 * instance after performing any necessary filtering.
 * @param {mixed} chunks - TODO: add params description.
 * @param {function} callback - TODO: add params description.
 * @returns {mixed} - TODO: add returns description.
 * @private
 */
TransportStream.prototype._writev = function _writev(chunks, callback) {
  if (this.logv) {
    const infos = chunks.filter(this._accept, this);
    if (!infos.length) {
      return callback(null);
    }

    // Remark (indexzero): from a performance perspective if Transport
    // implementers do choose to implement logv should we make it their
    // responsibility to invoke their format?
    return this.logv(infos, callback);
  }

  for (let i = 0; i < chunks.length; i++) {
    if (!this._accept(chunks[i])) continue;

    if (chunks[i].chunk && !this.format) {
      this.log(chunks[i].chunk, chunks[i].callback);
      continue;
    }

    let errState;
    let transformed;

    // We trap(and re-throw) any errors generated by the user-provided format, but also
    // guarantee that the streams callback is invoked so that we can continue flowing.
    try {
      transformed = this.format.transform(
        Object.assign({}, chunks[i].chunk),
        this.format.options
      );
    } catch (err) {
      errState = err;
    }

    if (errState || !transformed) {
      // eslint-disable-next-line callback-return
      chunks[i].callback();
      if (errState) {
        // eslint-disable-next-line callback-return
        callback(null);
        throw errState;
      }
    } else {
      this.log(transformed, chunks[i].callback);
    }
  }

  return callback(null);
};

/**
 * Predicate function that returns true if the specfied `info` on the
 * WriteReq, `write`, should be passed down into the derived
 * TransportStream's I/O via `.log(info, callback)`.
 * @param {WriteReq} write - winston@3 Node.js WriteReq for the `info` object
 * representing the log message.
 * @returns {Boolean} - Value indicating if the `write` should be accepted &
 * logged.
 */
TransportStream.prototype._accept = function _accept(write) {
  const info = write.chunk;
  if (this.silent) {
    return false;
  }

  // We always prefer any explicit level set on the Transport itself
  // falling back to any level set on the parent.
  const level = this.level || (this.parent && this.parent.level);

  // Immediately check the average case: log level filtering.
  if (
    info.exception === true ||
    !level ||
    this.levels[level] >= this.levels[info[LEVEL]]
  ) {
    // Ensure the info object is valid based on `{ exception }`:
    // 1. { handleExceptions: true }: all `info` objects are valid
    // 2. { exception: false }: accepted by all transports.
    if (this.handleExceptions || info.exception !== true) {
      return true;
    }
  }

  return false;
};

/**
 * _nop is short for "No operation"
 * @returns {Boolean} Intentionally false.
 */
TransportStream.prototype._nop = function _nop() {
  // eslint-disable-next-line no-undefined
  return void undefined;
};


/***/ }),

/***/ 28634:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
/**
 * winston.js: Top-level include defining Winston.
 *
 * (C) 2010 Charlie Robbins
 * MIT LICENCE
 */



var logform = __webpack_require__(9364);
var _require = __webpack_require__(29736),
  warn = _require.warn;

/**
 * Expose version. Use `require` method for `webpack` support.
 * @type {string}
 */
exports.version = __webpack_require__(95334).version;
/**
 * Include transports defined by default by winston
 * @type {Array}
 */
exports.transports = __webpack_require__(94901);
/**
 * Expose utility methods
 * @type {Object}
 */
exports.config = __webpack_require__(87463);
/**
 * Hoist format-related functionality from logform.
 * @type {Object}
 */
exports.addColors = logform.levels;
/**
 * Hoist format-related functionality from logform.
 * @type {Object}
 */
exports.format = logform.format;
/**
 * Expose core Logging-related prototypes.
 * @type {function}
 */
exports.createLogger = __webpack_require__(9262);
/**
 * Expose core Logging-related prototypes.
 * @type {function}
 */
exports.Logger = __webpack_require__(57439);
/**
 * Expose core Logging-related prototypes.
 * @type {Object}
 */
exports.ExceptionHandler = __webpack_require__(87134);
/**
 * Expose core Logging-related prototypes.
 * @type {Object}
 */
exports.RejectionHandler = __webpack_require__(2785);
/**
 * Expose core Logging-related prototypes.
 * @type {Container}
 */
exports.Container = __webpack_require__(94584);
/**
 * Expose core Logging-related prototypes.
 * @type {Object}
 */
exports.Transport = __webpack_require__(68367);
/**
 * We create and expose a default `Container` to `winston.loggers` so that the
 * programmer may manage multiple `winston.Logger` instances without any
 * additional overhead.
 * @example
 *   // some-file1.js
 *   const logger = require('winston').loggers.get('something');
 *
 *   // some-file2.js
 *   const logger = require('winston').loggers.get('something');
 */
exports.loggers = new exports.Container();

/**
 * We create and expose a 'defaultLogger' so that the programmer may do the
 * following without the need to create an instance of winston.Logger directly:
 * @example
 *   const winston = require('winston');
 *   winston.log('info', 'some message');
 *   winston.error('some error');
 */
var defaultLogger = exports.createLogger();

// Pass through the target methods onto `winston.
Object.keys(exports.config.npm.levels).concat(['log', 'query', 'stream', 'add', 'remove', 'clear', 'profile', 'startTimer', 'handleExceptions', 'unhandleExceptions', 'handleRejections', 'unhandleRejections', 'configure', 'child']).forEach(function (method) {
  return exports[method] = function () {
    return defaultLogger[method].apply(defaultLogger, arguments);
  };
});

/**
 * Define getter / setter for the default logger level which need to be exposed
 * by winston.
 * @type {string}
 */
Object.defineProperty(exports, "level", ({
  get: function get() {
    return defaultLogger.level;
  },
  set: function set(val) {
    defaultLogger.level = val;
  }
}));

/**
 * Define getter for `exceptions` which replaces `handleExceptions` and
 * `unhandleExceptions`.
 * @type {Object}
 */
Object.defineProperty(exports, "exceptions", ({
  get: function get() {
    return defaultLogger.exceptions;
  }
}));

/**
 * Define getter for `rejections` which replaces `handleRejections` and
 * `unhandleRejections`.
 * @type {Object}
 */
Object.defineProperty(exports, "rejections", ({
  get: function get() {
    return defaultLogger.rejections;
  }
}));

/**
 * Define getters / setters for appropriate properties of the default logger
 * which need to be exposed by winston.
 * @type {Logger}
 */
['exitOnError'].forEach(function (prop) {
  Object.defineProperty(exports, prop, {
    get: function get() {
      return defaultLogger[prop];
    },
    set: function set(val) {
      defaultLogger[prop] = val;
    }
  });
});

/**
 * The default transports and exceptionHandlers for the default winston logger.
 * @type {Object}
 */
Object.defineProperty(exports, "default", ({
  get: function get() {
    return {
      exceptionHandlers: defaultLogger.exceptionHandlers,
      rejectionHandlers: defaultLogger.rejectionHandlers,
      transports: defaultLogger.transports
    };
  }
}));

// Have friendlier breakage notices for properties that were exposed by default
// on winston < 3.0.
warn.deprecated(exports, 'setLevels');
warn.forFunctions(exports, 'useFormat', ['cli']);
warn.forProperties(exports, 'useFormat', ['padLevels', 'stripColors']);
warn.forFunctions(exports, 'deprecated', ['addRewriter', 'addFilter', 'clone', 'extend']);
warn.forProperties(exports, 'deprecated', ['emitErrs', 'levelLength']);

/***/ }),

/***/ 29736:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
/**
 * common.js: Internal helper and utility functions for winston.
 *
 * (C) 2010 Charlie Robbins
 * MIT LICENCE
 */



var _require = __webpack_require__(93585),
  format = _require.format;

/**
 * Set of simple deprecation notices and a way to expose them for a set of
 * properties.
 * @type {Object}
 * @private
 */
exports.warn = {
  deprecated: function deprecated(prop) {
    return function () {
      throw new Error(format('{ %s } was removed in winston@3.0.0.', prop));
    };
  },
  useFormat: function useFormat(prop) {
    return function () {
      throw new Error([format('{ %s } was removed in winston@3.0.0.', prop), 'Use a custom winston.format = winston.format(function) instead.'].join('\n'));
    };
  },
  forFunctions: function forFunctions(obj, type, props) {
    props.forEach(function (prop) {
      obj[prop] = exports.warn[type](prop);
    });
  },
  forProperties: function forProperties(obj, type, props) {
    props.forEach(function (prop) {
      var notice = exports.warn[type](prop);
      Object.defineProperty(obj, prop, {
        get: notice,
        set: notice
      });
    });
  }
};

/***/ }),

/***/ 87463:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
/**
 * index.js: Default settings for all levels that winston knows about.
 *
 * (C) 2010 Charlie Robbins
 * MIT LICENCE
 */



var logform = __webpack_require__(9364);
var _require = __webpack_require__(27735),
  configs = _require.configs;

/**
 * Export config set for the CLI.
 * @type {Object}
 */
exports.cli = logform.levels(configs.cli);

/**
 * Export config set for npm.
 * @type {Object}
 */
exports.npm = logform.levels(configs.npm);

/**
 * Export config set for the syslog.
 * @type {Object}
 */
exports.syslog = logform.levels(configs.syslog);

/**
 * Hoist addColors from logform where it was refactored into in winston@3.
 * @type {Object}
 */
exports.addColors = logform.levels;

/***/ }),

/***/ 94584:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
/**
 * container.js: Inversion of control container for winston logger instances.
 *
 * (C) 2010 Charlie Robbins
 * MIT LICENCE
 */



function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var createLogger = __webpack_require__(9262);

/**
 * Inversion of control container for winston logger instances.
 * @type {Container}
 */
module.exports = /*#__PURE__*/function () {
  /**
   * Constructor function for the Container object responsible for managing a
   * set of `winston.Logger` instances based on string ids.
   * @param {!Object} [options={}] - Default pass-thru options for Loggers.
   */
  function Container() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    _classCallCheck(this, Container);
    this.loggers = new Map();
    this.options = options;
  }

  /**
   * Retrieves a `winston.Logger` instance for the specified `id`. If an
   * instance does not exist, one is created.
   * @param {!string} id - The id of the Logger to get.
   * @param {?Object} [options] - Options for the Logger instance.
   * @returns {Logger} - A configured Logger instance with a specified id.
   */
  return _createClass(Container, [{
    key: "add",
    value: function add(id, options) {
      var _this = this;
      if (!this.loggers.has(id)) {
        // Remark: Simple shallow clone for configuration options in case we pass
        // in instantiated protoypal objects
        options = Object.assign({}, options || this.options);
        var existing = options.transports || this.options.transports;

        // Remark: Make sure if we have an array of transports we slice it to
        // make copies of those references.
        if (existing) {
          options.transports = Array.isArray(existing) ? existing.slice() : [existing];
        } else {
          options.transports = [];
        }
        var logger = createLogger(options);
        logger.on('close', function () {
          return _this._delete(id);
        });
        this.loggers.set(id, logger);
      }
      return this.loggers.get(id);
    }

    /**
     * Retreives a `winston.Logger` instance for the specified `id`. If
     * an instance does not exist, one is created.
     * @param {!string} id - The id of the Logger to get.
     * @param {?Object} [options] - Options for the Logger instance.
     * @returns {Logger} - A configured Logger instance with a specified id.
     */
  }, {
    key: "get",
    value: function get(id, options) {
      return this.add(id, options);
    }

    /**
     * Check if the container has a logger with the id.
     * @param {?string} id - The id of the Logger instance to find.
     * @returns {boolean} - Boolean value indicating if this instance has a
     * logger with the specified `id`.
     */
  }, {
    key: "has",
    value: function has(id) {
      return !!this.loggers.has(id);
    }

    /**
     * Closes a `Logger` instance with the specified `id` if it exists.
     * If no `id` is supplied then all Loggers are closed.
     * @param {?string} id - The id of the Logger instance to close.
     * @returns {undefined}
     */
  }, {
    key: "close",
    value: function close(id) {
      var _this2 = this;
      if (id) {
        return this._removeLogger(id);
      }
      this.loggers.forEach(function (val, key) {
        return _this2._removeLogger(key);
      });
    }

    /**
     * Remove a logger based on the id.
     * @param {!string} id - The id of the logger to remove.
     * @returns {undefined}
     * @private
     */
  }, {
    key: "_removeLogger",
    value: function _removeLogger(id) {
      if (!this.loggers.has(id)) {
        return;
      }
      var logger = this.loggers.get(id);
      logger.close();
      this._delete(id);
    }

    /**
     * Deletes a `Logger` instance with the specified `id`.
     * @param {!string} id - The id of the Logger instance to delete from
     * container.
     * @returns {undefined}
     * @private
     */
  }, {
    key: "_delete",
    value: function _delete(id) {
      this.loggers["delete"](id);
    }
  }]);
}();

/***/ }),

/***/ 9262:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
/**
 * create-logger.js: Logger factory for winston logger instances.
 *
 * (C) 2010 Charlie Robbins
 * MIT LICENCE
 */



function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
var _require = __webpack_require__(27735),
  LEVEL = _require.LEVEL;
var config = __webpack_require__(87463);
var Logger = __webpack_require__(57439);
var debug = __webpack_require__(24169)('winston:create-logger');
function isLevelEnabledFunctionName(level) {
  return 'is' + level.charAt(0).toUpperCase() + level.slice(1) + 'Enabled';
}

/**
 * Create a new instance of a winston Logger. Creates a new
 * prototype for each instance.
 * @param {!Object} opts - Options for the created logger.
 * @returns {Logger} - A newly created logger instance.
 */
module.exports = function () {
  var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  //
  // Default levels: npm
  //
  opts.levels = opts.levels || config.npm.levels;

  /**
   * DerivedLogger to attach the logs level methods.
   * @type {DerivedLogger}
   * @extends {Logger}
   */
  var DerivedLogger = /*#__PURE__*/function (_Logger) {
    /**
     * Create a new class derived logger for which the levels can be attached to
     * the prototype of. This is a V8 optimization that is well know to increase
     * performance of prototype functions.
     * @param {!Object} options - Options for the created logger.
     */
    function DerivedLogger(options) {
      _classCallCheck(this, DerivedLogger);
      return _callSuper(this, DerivedLogger, [options]);
    }
    _inherits(DerivedLogger, _Logger);
    return _createClass(DerivedLogger);
  }(Logger);
  var logger = new DerivedLogger(opts);

  //
  // Create the log level methods for the derived logger.
  //
  Object.keys(opts.levels).forEach(function (level) {
    debug('Define prototype method for "%s"', level);
    if (level === 'log') {
      // eslint-disable-next-line no-console
      console.warn('Level "log" not defined: conflicts with the method "log". Use a different level name.');
      return;
    }

    //
    // Define prototype methods for each log level e.g.:
    // logger.log('info', msg) implies these methods are defined:
    // - logger.info(msg)
    // - logger.isInfoEnabled()
    //
    // Remark: to support logger.child this **MUST** be a function
    // so it'll always be called on the instance instead of a fixed
    // place in the prototype chain.
    //
    DerivedLogger.prototype[level] = function () {
      // Prefer any instance scope, but default to "root" logger
      var self = this || logger;

      // Optimize the hot-path which is the single object.
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      if (args.length === 1) {
        var msg = args[0];
        var info = msg && msg.message && msg || {
          message: msg
        };
        info.level = info[LEVEL] = level;
        self._addDefaultMeta(info);
        self.write(info);
        return this || logger;
      }

      // When provided nothing assume the empty string
      if (args.length === 0) {
        self.log(level, '');
        return self;
      }

      // Otherwise build argument list which could potentially conform to
      // either:
      // . v3 API: log(obj)
      // 2. v1/v2 API: log(level, msg, ... [string interpolate], [{metadata}], [callback])
      return self.log.apply(self, [level].concat(args));
    };
    DerivedLogger.prototype[isLevelEnabledFunctionName(level)] = function () {
      return (this || logger).isLevelEnabled(level);
    };
  });
  return logger;
};

/***/ }),

/***/ 87134:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
/* provided dependency */ var process = __webpack_require__(14224);
/**
 * exception-handler.js: Object for handling uncaughtException events.
 *
 * (C) 2010 Charlie Robbins
 * MIT LICENCE
 */



function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var os = __webpack_require__(25597);
var asyncForEach = __webpack_require__(42777);
var debug = __webpack_require__(24169)('winston:exception');
var once = __webpack_require__(44766);
var stackTrace = __webpack_require__(79008);
var ExceptionStream = __webpack_require__(6915);

/**
 * Object for handling uncaughtException events.
 * @type {ExceptionHandler}
 */
module.exports = /*#__PURE__*/function () {
  /**
   * TODO: add contructor description
   * @param {!Logger} logger - TODO: add param description
   */
  function ExceptionHandler(logger) {
    _classCallCheck(this, ExceptionHandler);
    if (!logger) {
      throw new Error('Logger is required to handle exceptions');
    }
    this.logger = logger;
    this.handlers = new Map();
  }

  /**
   * Handles `uncaughtException` events for the current process by adding any
   * handlers passed in.
   * @returns {undefined}
   */
  return _createClass(ExceptionHandler, [{
    key: "handle",
    value: function handle() {
      var _this = this;
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      args.forEach(function (arg) {
        if (Array.isArray(arg)) {
          return arg.forEach(function (handler) {
            return _this._addHandler(handler);
          });
        }
        _this._addHandler(arg);
      });
      if (!this.catcher) {
        this.catcher = this._uncaughtException.bind(this);
        process.on('uncaughtException', this.catcher);
      }
    }

    /**
     * Removes any handlers to `uncaughtException` events for the current
     * process. This does not modify the state of the `this.handlers` set.
     * @returns {undefined}
     */
  }, {
    key: "unhandle",
    value: function unhandle() {
      var _this2 = this;
      if (this.catcher) {
        process.removeListener('uncaughtException', this.catcher);
        this.catcher = false;
        Array.from(this.handlers.values()).forEach(function (wrapper) {
          return _this2.logger.unpipe(wrapper);
        });
      }
    }

    /**
     * TODO: add method description
     * @param {Error} err - Error to get information about.
     * @returns {mixed} - TODO: add return description.
     */
  }, {
    key: "getAllInfo",
    value: function getAllInfo(err) {
      var message = null;
      if (err) {
        message = typeof err === 'string' ? err : err.message;
      }
      return {
        error: err,
        // TODO (indexzero): how do we configure this?
        level: 'error',
        message: ["uncaughtException: ".concat(message || '(no error message)'), err && err.stack || '  No stack trace'].join('\n'),
        stack: err && err.stack,
        exception: true,
        date: new Date().toString(),
        process: this.getProcessInfo(),
        os: this.getOsInfo(),
        trace: this.getTrace(err)
      };
    }

    /**
     * Gets all relevant process information for the currently running process.
     * @returns {mixed} - TODO: add return description.
     */
  }, {
    key: "getProcessInfo",
    value: function getProcessInfo() {
      return {
        pid: process.pid,
        uid: process.getuid ? process.getuid() : null,
        gid: process.getgid ? process.getgid() : null,
        cwd: process.cwd(),
        execPath: process.execPath,
        version: process.version,
        argv: process.argv,
        memoryUsage: process.memoryUsage()
      };
    }

    /**
     * Gets all relevant OS information for the currently running process.
     * @returns {mixed} - TODO: add return description.
     */
  }, {
    key: "getOsInfo",
    value: function getOsInfo() {
      return {
        loadavg: os.loadavg(),
        uptime: os.uptime()
      };
    }

    /**
     * Gets a stack trace for the specified error.
     * @param {mixed} err - TODO: add param description.
     * @returns {mixed} - TODO: add return description.
     */
  }, {
    key: "getTrace",
    value: function getTrace(err) {
      var trace = err ? stackTrace.parse(err) : stackTrace.get();
      return trace.map(function (site) {
        return {
          column: site.getColumnNumber(),
          file: site.getFileName(),
          "function": site.getFunctionName(),
          line: site.getLineNumber(),
          method: site.getMethodName(),
          "native": site.isNative()
        };
      });
    }

    /**
     * Helper method to add a transport as an exception handler.
     * @param {Transport} handler - The transport to add as an exception handler.
     * @returns {void}
     */
  }, {
    key: "_addHandler",
    value: function _addHandler(handler) {
      if (!this.handlers.has(handler)) {
        handler.handleExceptions = true;
        var wrapper = new ExceptionStream(handler);
        this.handlers.set(handler, wrapper);
        this.logger.pipe(wrapper);
      }
    }

    /**
     * Logs all relevant information around the `err` and exits the current
     * process.
     * @param {Error} err - Error to handle
     * @returns {mixed} - TODO: add return description.
     * @private
     */
  }, {
    key: "_uncaughtException",
    value: function _uncaughtException(err) {
      var info = this.getAllInfo(err);
      var handlers = this._getExceptionHandlers();
      // Calculate if we should exit on this error
      var doExit = typeof this.logger.exitOnError === 'function' ? this.logger.exitOnError(err) : this.logger.exitOnError;
      var timeout;
      if (!handlers.length && doExit) {
        // eslint-disable-next-line no-console
        console.warn('winston: exitOnError cannot be true with no exception handlers.');
        // eslint-disable-next-line no-console
        console.warn('winston: not exiting process.');
        doExit = false;
      }
      function gracefulExit() {
        debug('doExit', doExit);
        debug('process._exiting', process._exiting);
        if (doExit && !process._exiting) {
          // Remark: Currently ignoring any exceptions from transports when
          // catching uncaught exceptions.
          if (timeout) {
            clearTimeout(timeout);
          }
          // eslint-disable-next-line no-process-exit
          process.exit(1);
        }
      }
      if (!handlers || handlers.length === 0) {
        return process.nextTick(gracefulExit);
      }

      // Log to all transports attempting to listen for when they are completed.
      asyncForEach(handlers, function (handler, next) {
        var done = once(next);
        var transport = handler.transport || handler;

        // Debug wrapping so that we can inspect what's going on under the covers.
        function onDone(event) {
          return function () {
            debug(event);
            done();
          };
        }
        transport._ending = true;
        transport.once('finish', onDone('finished'));
        transport.once('error', onDone('error'));
      }, function () {
        return doExit && gracefulExit();
      });
      this.logger.log(info);

      // If exitOnError is true, then only allow the logging of exceptions to
      // take up to `3000ms`.
      if (doExit) {
        timeout = setTimeout(gracefulExit, 3000);
      }
    }

    /**
     * Returns the list of transports and exceptionHandlers for this instance.
     * @returns {Array} - List of transports and exceptionHandlers for this
     * instance.
     * @private
     */
  }, {
    key: "_getExceptionHandlers",
    value: function _getExceptionHandlers() {
      // Remark (indexzero): since `logger.transports` returns all of the pipes
      // from the _readableState of the stream we actually get the join of the
      // explicit handlers and the implicit transports with
      // `handleExceptions: true`
      return this.logger.transports.filter(function (wrap) {
        var transport = wrap.transport || wrap;
        return transport.handleExceptions;
      });
    }
  }]);
}();

/***/ }),

/***/ 6915:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
/**
 * exception-stream.js: TODO: add file header handler.
 *
 * (C) 2010 Charlie Robbins
 * MIT LICENCE
 */



function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
var _require = __webpack_require__(62981),
  Writable = _require.Writable;

/**
 * TODO: add class description.
 * @type {ExceptionStream}
 * @extends {Writable}
 */
module.exports = /*#__PURE__*/function (_Writable) {
  /**
   * Constructor function for the ExceptionStream responsible for wrapping a
   * TransportStream; only allowing writes of `info` objects with
   * `info.exception` set to true.
   * @param {!TransportStream} transport - Stream to filter to exceptions
   */
  function ExceptionStream(transport) {
    var _this;
    _classCallCheck(this, ExceptionStream);
    _this = _callSuper(this, ExceptionStream, [{
      objectMode: true
    }]);
    if (!transport) {
      throw new Error('ExceptionStream requires a TransportStream instance.');
    }

    // Remark (indexzero): we set `handleExceptions` here because it's the
    // predicate checked in ExceptionHandler.prototype.__getExceptionHandlers
    _this.handleExceptions = true;
    _this.transport = transport;
    return _this;
  }

  /**
   * Writes the info object to our transport instance if (and only if) the
   * `exception` property is set on the info.
   * @param {mixed} info - TODO: add param description.
   * @param {mixed} enc - TODO: add param description.
   * @param {mixed} callback - TODO: add param description.
   * @returns {mixed} - TODO: add return description.
   * @private
   */
  _inherits(ExceptionStream, _Writable);
  return _createClass(ExceptionStream, [{
    key: "_write",
    value: function _write(info, enc, callback) {
      if (info.exception) {
        return this.transport.log(info, callback);
      }
      callback();
      return true;
    }
  }]);
}(Writable);

/***/ }),

/***/ 57439:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
/**
 * logger.js: TODO: add file header description.
 *
 * (C) 2010 Charlie Robbins
 * MIT LICENCE
 */



function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
var _require = __webpack_require__(62981),
  Stream = _require.Stream,
  Transform = _require.Transform;
var asyncForEach = __webpack_require__(42777);
var _require2 = __webpack_require__(27735),
  LEVEL = _require2.LEVEL,
  SPLAT = _require2.SPLAT;
var isStream = __webpack_require__(53528);
var ExceptionHandler = __webpack_require__(87134);
var RejectionHandler = __webpack_require__(2785);
var LegacyTransportStream = __webpack_require__(28450);
var Profiler = __webpack_require__(84741);
var _require3 = __webpack_require__(29736),
  warn = _require3.warn;
var config = __webpack_require__(87463);

/**
 * Captures the number of format (i.e. %s strings) in a given string.
 * Based on `util.format`, see Node.js source:
 * https://github.com/nodejs/node/blob/b1c8f15c5f169e021f7c46eb7b219de95fe97603/lib/util.js#L201-L230
 * @type {RegExp}
 */
var formatRegExp = /%[scdjifoO%]/g;

/**
 * TODO: add class description.
 * @type {Logger}
 * @extends {Transform}
 */
var Logger = /*#__PURE__*/function (_Transform) {
  /**
   * Constructor function for the Logger object responsible for persisting log
   * messages and metadata to one or more transports.
   * @param {!Object} options - foo
   */
  function Logger(options) {
    var _this;
    _classCallCheck(this, Logger);
    _this = _callSuper(this, Logger, [{
      objectMode: true
    }]);
    _this.configure(options);
    return _this;
  }
  _inherits(Logger, _Transform);
  return _createClass(Logger, [{
    key: "child",
    value: function child(defaultRequestMetadata) {
      var logger = this;
      return Object.create(logger, {
        write: {
          value: function value(info) {
            var infoClone = Object.assign({}, defaultRequestMetadata, info);

            // Object.assign doesn't copy inherited Error
            // properties so we have to do that explicitly
            //
            // Remark (indexzero): we should remove this
            // since the errors format will handle this case.
            //
            if (info instanceof Error) {
              infoClone.stack = info.stack;
              infoClone.message = info.message;
            }
            logger.write(infoClone);
          }
        }
      });
    }

    /**
     * This will wholesale reconfigure this instance by:
     * 1. Resetting all transports. Older transports will be removed implicitly.
     * 2. Set all other options including levels, colors, rewriters, filters,
     *    exceptionHandlers, etc.
     * @param {!Object} options - TODO: add param description.
     * @returns {undefined}
     */
  }, {
    key: "configure",
    value: function configure() {
      var _this2 = this;
      var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        silent = _ref.silent,
        format = _ref.format,
        defaultMeta = _ref.defaultMeta,
        levels = _ref.levels,
        _ref$level = _ref.level,
        level = _ref$level === void 0 ? 'info' : _ref$level,
        _ref$exitOnError = _ref.exitOnError,
        exitOnError = _ref$exitOnError === void 0 ? true : _ref$exitOnError,
        transports = _ref.transports,
        colors = _ref.colors,
        emitErrs = _ref.emitErrs,
        formatters = _ref.formatters,
        padLevels = _ref.padLevels,
        rewriters = _ref.rewriters,
        stripColors = _ref.stripColors,
        exceptionHandlers = _ref.exceptionHandlers,
        rejectionHandlers = _ref.rejectionHandlers;
      // Reset transports if we already have them
      if (this.transports.length) {
        this.clear();
      }
      this.silent = silent;
      this.format = format || this.format || __webpack_require__(58475)();
      this.defaultMeta = defaultMeta || null;
      // Hoist other options onto this instance.
      this.levels = levels || this.levels || config.npm.levels;
      this.level = level;
      if (this.exceptions) {
        this.exceptions.unhandle();
      }
      if (this.rejections) {
        this.rejections.unhandle();
      }
      this.exceptions = new ExceptionHandler(this);
      this.rejections = new RejectionHandler(this);
      this.profilers = {};
      this.exitOnError = exitOnError;

      // Add all transports we have been provided.
      if (transports) {
        transports = Array.isArray(transports) ? transports : [transports];
        transports.forEach(function (transport) {
          return _this2.add(transport);
        });
      }
      if (colors || emitErrs || formatters || padLevels || rewriters || stripColors) {
        throw new Error(['{ colors, emitErrs, formatters, padLevels, rewriters, stripColors } were removed in winston@3.0.0.', 'Use a custom winston.format(function) instead.', 'See: https://github.com/winstonjs/winston/tree/master/UPGRADE-3.0.md'].join('\n'));
      }
      if (exceptionHandlers) {
        this.exceptions.handle(exceptionHandlers);
      }
      if (rejectionHandlers) {
        this.rejections.handle(rejectionHandlers);
      }
    }
  }, {
    key: "isLevelEnabled",
    value: function isLevelEnabled(level) {
      var _this3 = this;
      var givenLevelValue = getLevelValue(this.levels, level);
      if (givenLevelValue === null) {
        return false;
      }
      var configuredLevelValue = getLevelValue(this.levels, this.level);
      if (configuredLevelValue === null) {
        return false;
      }
      if (!this.transports || this.transports.length === 0) {
        return configuredLevelValue >= givenLevelValue;
      }
      var index = this.transports.findIndex(function (transport) {
        var transportLevelValue = getLevelValue(_this3.levels, transport.level);
        if (transportLevelValue === null) {
          transportLevelValue = configuredLevelValue;
        }
        return transportLevelValue >= givenLevelValue;
      });
      return index !== -1;
    }

    /* eslint-disable valid-jsdoc */
    /**
     * Ensure backwards compatibility with a `log` method
     * @param {mixed} level - Level the log message is written at.
     * @param {mixed} msg - TODO: add param description.
     * @param {mixed} meta - TODO: add param description.
     * @returns {Logger} - TODO: add return description.
     *
     * @example
     *    // Supports the existing API:
     *    logger.log('info', 'Hello world', { custom: true });
     *    logger.log('info', new Error('Yo, it\'s on fire'));
     *
     *    // Requires winston.format.splat()
     *    logger.log('info', '%s %d%%', 'A string', 50, { thisIsMeta: true });
     *
     *    // And the new API with a single JSON literal:
     *    logger.log({ level: 'info', message: 'Hello world', custom: true });
     *    logger.log({ level: 'info', message: new Error('Yo, it\'s on fire') });
     *
     *    // Also requires winston.format.splat()
     *    logger.log({
     *      level: 'info',
     *      message: '%s %d%%',
     *      [SPLAT]: ['A string', 50],
     *      meta: { thisIsMeta: true }
     *    });
     *
     */
    /* eslint-enable valid-jsdoc */
  }, {
    key: "log",
    value: function log(level, msg) {
      for (var _len = arguments.length, splat = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
        splat[_key - 2] = arguments[_key];
      }
      // eslint-disable-line max-params
      // Optimize for the hotpath of logging JSON literals
      if (arguments.length === 1) {
        // Yo dawg, I heard you like levels ... seriously ...
        // In this context the LHS `level` here is actually the `info` so read
        // this as: info[LEVEL] = info.level;
        level[LEVEL] = level.level;
        this._addDefaultMeta(level);
        this.write(level);
        return this;
      }

      // Slightly less hotpath, but worth optimizing for.
      if (arguments.length === 2) {
        if (msg && _typeof(msg) === 'object') {
          msg[LEVEL] = msg.level = level;
          this._addDefaultMeta(msg);
          this.write(msg);
          return this;
        }
        msg = _defineProperty(_defineProperty(_defineProperty({}, LEVEL, level), "level", level), "message", msg);
        this._addDefaultMeta(msg);
        this.write(msg);
        return this;
      }
      var meta = splat[0];
      if (_typeof(meta) === 'object' && meta !== null) {
        // Extract tokens, if none available default to empty array to
        // ensure consistancy in expected results
        var tokens = msg && msg.match && msg.match(formatRegExp);
        if (!tokens) {
          var info = Object.assign({}, this.defaultMeta, meta, _defineProperty(_defineProperty(_defineProperty(_defineProperty({}, LEVEL, level), SPLAT, splat), "level", level), "message", msg));
          if (meta.message) info.message = "".concat(info.message, " ").concat(meta.message);
          if (meta.stack) info.stack = meta.stack;
          this.write(info);
          return this;
        }
      }
      this.write(Object.assign({}, this.defaultMeta, _defineProperty(_defineProperty(_defineProperty(_defineProperty({}, LEVEL, level), SPLAT, splat), "level", level), "message", msg)));
      return this;
    }

    /**
     * Pushes data so that it can be picked up by all of our pipe targets.
     * @param {mixed} info - TODO: add param description.
     * @param {mixed} enc - TODO: add param description.
     * @param {mixed} callback - Continues stream processing.
     * @returns {undefined}
     * @private
     */
  }, {
    key: "_transform",
    value: function _transform(info, enc, callback) {
      if (this.silent) {
        return callback();
      }

      // [LEVEL] is only soft guaranteed to be set here since we are a proper
      // stream. It is likely that `info` came in through `.log(info)` or
      // `.info(info)`. If it is not defined, however, define it.
      // This LEVEL symbol is provided by `triple-beam` and also used in:
      // - logform
      // - winston-transport
      // - abstract-winston-transport
      if (!info[LEVEL]) {
        info[LEVEL] = info.level;
      }

      // Remark: really not sure what to do here, but this has been reported as
      // very confusing by pre winston@2.0.0 users as quite confusing when using
      // custom levels.
      if (!this.levels[info[LEVEL]] && this.levels[info[LEVEL]] !== 0) {
        // eslint-disable-next-line no-console
        console.error('[winston] Unknown logger level: %s', info[LEVEL]);
      }

      // Remark: not sure if we should simply error here.
      if (!this._readableState.pipes) {
        // eslint-disable-next-line no-console
        console.error('[winston] Attempt to write logs with no transports, which can increase memory usage: %j', info);
      }

      // Here we write to the `format` pipe-chain, which on `readable` above will
      // push the formatted `info` Object onto the buffer for this instance. We trap
      // (and re-throw) any errors generated by the user-provided format, but also
      // guarantee that the streams callback is invoked so that we can continue flowing.
      try {
        this.push(this.format.transform(info, this.format.options));
      } finally {
        this._writableState.sync = false;
        // eslint-disable-next-line callback-return
        callback();
      }
    }

    /**
     * Delays the 'finish' event until all transport pipe targets have
     * also emitted 'finish' or are already finished.
     * @param {mixed} callback - Continues stream processing.
     */
  }, {
    key: "_final",
    value: function _final(callback) {
      var transports = this.transports.slice();
      asyncForEach(transports, function (transport, next) {
        if (!transport || transport.finished) return setImmediate(next);
        transport.once('finish', next);
        transport.end();
      }, callback);
    }

    /**
     * Adds the transport to this logger instance by piping to it.
     * @param {mixed} transport - TODO: add param description.
     * @returns {Logger} - TODO: add return description.
     */
  }, {
    key: "add",
    value: function add(transport) {
      // Support backwards compatibility with all existing `winston < 3.x.x`
      // transports which meet one of two criteria:
      // 1. They inherit from winston.Transport in  < 3.x.x which is NOT a stream.
      // 2. They expose a log method which has a length greater than 2 (i.e. more then
      //    just `log(info, callback)`.
      var target = !isStream(transport) || transport.log.length > 2 ? new LegacyTransportStream({
        transport: transport
      }) : transport;
      if (!target._writableState || !target._writableState.objectMode) {
        throw new Error('Transports must WritableStreams in objectMode. Set { objectMode: true }.');
      }

      // Listen for the `error` event and the `warn` event on the new Transport.
      this._onEvent('error', target);
      this._onEvent('warn', target);
      this.pipe(target);
      if (transport.handleExceptions) {
        this.exceptions.handle();
      }
      if (transport.handleRejections) {
        this.rejections.handle();
      }
      return this;
    }

    /**
     * Removes the transport from this logger instance by unpiping from it.
     * @param {mixed} transport - TODO: add param description.
     * @returns {Logger} - TODO: add return description.
     */
  }, {
    key: "remove",
    value: function remove(transport) {
      if (!transport) return this;
      var target = transport;
      if (!isStream(transport) || transport.log.length > 2) {
        target = this.transports.filter(function (match) {
          return match.transport === transport;
        })[0];
      }
      if (target) {
        this.unpipe(target);
      }
      return this;
    }

    /**
     * Removes all transports from this logger instance.
     * @returns {Logger} - TODO: add return description.
     */
  }, {
    key: "clear",
    value: function clear() {
      this.unpipe();
      return this;
    }

    /**
     * Cleans up resources (streams, event listeners) for all transports
     * associated with this instance (if necessary).
     * @returns {Logger} - TODO: add return description.
     */
  }, {
    key: "close",
    value: function close() {
      this.exceptions.unhandle();
      this.rejections.unhandle();
      this.clear();
      this.emit('close');
      return this;
    }

    /**
     * Sets the `target` levels specified on this instance.
     * @param {Object} Target levels to use on this instance.
     */
  }, {
    key: "setLevels",
    value: function setLevels() {
      warn.deprecated('setLevels');
    }

    /**
     * Queries the all transports for this instance with the specified `options`.
     * This will aggregate each transport's results into one object containing
     * a property per transport.
     * @param {Object} options - Query options for this instance.
     * @param {function} callback - Continuation to respond to when complete.
     */
  }, {
    key: "query",
    value: function query(options, callback) {
      if (typeof options === 'function') {
        callback = options;
        options = {};
      }
      options = options || {};
      var results = {};
      var queryObject = Object.assign({}, options.query || {});

      // Helper function to query a single transport
      function queryTransport(transport, next) {
        if (options.query && typeof transport.formatQuery === 'function') {
          options.query = transport.formatQuery(queryObject);
        }
        transport.query(options, function (err, res) {
          if (err) {
            return next(err);
          }
          if (typeof transport.formatResults === 'function') {
            res = transport.formatResults(res, options.format);
          }
          next(null, res);
        });
      }

      // Helper function to accumulate the results from `queryTransport` into
      // the `results`.
      function addResults(transport, next) {
        queryTransport(transport, function (err, result) {
          // queryTransport could potentially invoke the callback multiple times
          // since Transport code can be unpredictable.
          if (next) {
            result = err || result;
            if (result) {
              results[transport.name] = result;
            }

            // eslint-disable-next-line callback-return
            next();
          }
          next = null;
        });
      }

      // Iterate over the transports in parallel setting the appropriate key in
      // the `results`.
      asyncForEach(this.transports.filter(function (transport) {
        return !!transport.query;
      }), addResults, function () {
        return callback(null, results);
      });
    }

    /**
     * Returns a log stream for all transports. Options object is optional.
     * @param{Object} options={} - Stream options for this instance.
     * @returns {Stream} - TODO: add return description.
     */
  }, {
    key: "stream",
    value: function stream() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var out = new Stream();
      var streams = [];
      out._streams = streams;
      out.destroy = function () {
        var i = streams.length;
        while (i--) {
          streams[i].destroy();
        }
      };

      // Create a list of all transports for this instance.
      this.transports.filter(function (transport) {
        return !!transport.stream;
      }).forEach(function (transport) {
        var str = transport.stream(options);
        if (!str) {
          return;
        }
        streams.push(str);
        str.on('log', function (log) {
          log.transport = log.transport || [];
          log.transport.push(transport.name);
          out.emit('log', log);
        });
        str.on('error', function (err) {
          err.transport = err.transport || [];
          err.transport.push(transport.name);
          out.emit('error', err);
        });
      });
      return out;
    }

    /**
     * Returns an object corresponding to a specific timing. When done is called
     * the timer will finish and log the duration. e.g.:
     * @returns {Profile} - TODO: add return description.
     * @example
     *    const timer = winston.startTimer()
     *    setTimeout(() => {
     *      timer.done({
     *        message: 'Logging message'
     *      });
     *    }, 1000);
     */
  }, {
    key: "startTimer",
    value: function startTimer() {
      return new Profiler(this);
    }

    /**
     * Tracks the time inbetween subsequent calls to this method with the same
     * `id` parameter. The second call to this method will log the difference in
     * milliseconds along with the message.
     * @param {string} id Unique id of the profiler
     * @returns {Logger} - TODO: add return description.
     */
  }, {
    key: "profile",
    value: function profile(id) {
      var time = Date.now();
      if (this.profilers[id]) {
        var timeEnd = this.profilers[id];
        delete this.profilers[id];

        // Attempt to be kind to users if they are still using older APIs.
        for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
          args[_key2 - 1] = arguments[_key2];
        }
        if (typeof args[args.length - 2] === 'function') {
          // eslint-disable-next-line no-console
          console.warn('Callback function no longer supported as of winston@3.0.0');
          args.pop();
        }

        // Set the duration property of the metadata
        var info = _typeof(args[args.length - 1]) === 'object' ? args.pop() : {};
        info.level = info.level || 'info';
        info.durationMs = time - timeEnd;
        info.message = info.message || id;
        return this.write(info);
      }
      this.profilers[id] = time;
      return this;
    }

    /**
     * Backwards compatibility to `exceptions.handle` in winston < 3.0.0.
     * @returns {undefined}
     * @deprecated
     */
  }, {
    key: "handleExceptions",
    value: function handleExceptions() {
      var _this$exceptions;
      // eslint-disable-next-line no-console
      console.warn('Deprecated: .handleExceptions() will be removed in winston@4. Use .exceptions.handle()');
      (_this$exceptions = this.exceptions).handle.apply(_this$exceptions, arguments);
    }

    /**
     * Backwards compatibility to `exceptions.handle` in winston < 3.0.0.
     * @returns {undefined}
     * @deprecated
     */
  }, {
    key: "unhandleExceptions",
    value: function unhandleExceptions() {
      var _this$exceptions2;
      // eslint-disable-next-line no-console
      console.warn('Deprecated: .unhandleExceptions() will be removed in winston@4. Use .exceptions.unhandle()');
      (_this$exceptions2 = this.exceptions).unhandle.apply(_this$exceptions2, arguments);
    }

    /**
     * Throw a more meaningful deprecation notice
     * @throws {Error} - TODO: add throws description.
     */
  }, {
    key: "cli",
    value: function cli() {
      throw new Error(['Logger.cli() was removed in winston@3.0.0', 'Use a custom winston.formats.cli() instead.', 'See: https://github.com/winstonjs/winston/tree/master/UPGRADE-3.0.md'].join('\n'));
    }

    /**
     * Bubbles the `event` that occured on the specified `transport` up
     * from this instance.
     * @param {string} event - The event that occured
     * @param {Object} transport - Transport on which the event occured
     * @private
     */
  }, {
    key: "_onEvent",
    value: function _onEvent(event, transport) {
      function transportEvent(err) {
        // https://github.com/winstonjs/winston/issues/1364
        if (event === 'error' && !this.transports.includes(transport)) {
          this.add(transport);
        }
        this.emit(event, err, transport);
      }
      if (!transport['__winston' + event]) {
        transport['__winston' + event] = transportEvent.bind(this);
        transport.on(event, transport['__winston' + event]);
      }
    }
  }, {
    key: "_addDefaultMeta",
    value: function _addDefaultMeta(msg) {
      if (this.defaultMeta) {
        Object.assign(msg, this.defaultMeta);
      }
    }
  }]);
}(Transform);
function getLevelValue(levels, level) {
  var value = levels[level];
  if (!value && value !== 0) {
    return null;
  }
  return value;
}

/**
 * Represents the current readableState pipe targets for this Logger instance.
 * @type {Array|Object}
 */
Object.defineProperty(Logger.prototype, 'transports', {
  configurable: false,
  enumerable: true,
  get: function get() {
    var pipes = this._readableState.pipes;
    return !Array.isArray(pipes) ? [pipes].filter(Boolean) : pipes;
  }
});
module.exports = Logger;

/***/ }),

/***/ 84741:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
/**
 * profiler.js: TODO: add file header description.
 *
 * (C) 2010 Charlie Robbins
 * MIT LICENCE
 */



/**
 * TODO: add class description.
 * @type {Profiler}
 * @private
 */
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var Profiler = /*#__PURE__*/function () {
  /**
   * Constructor function for the Profiler instance used by
   * `Logger.prototype.startTimer`. When done is called the timer will finish
   * and log the duration.
   * @param {!Logger} logger - TODO: add param description.
   * @private
   */
  function Profiler(logger) {
    _classCallCheck(this, Profiler);
    var Logger = __webpack_require__(57439);
    if (_typeof(logger) !== 'object' || Array.isArray(logger) || !(logger instanceof Logger)) {
      throw new Error('Logger is required for profiling');
    } else {
      this.logger = logger;
      this.start = Date.now();
    }
  }

  /**
   * Ends the current timer (i.e. Profiler) instance and logs the `msg` along
   * with the duration since creation.
   * @returns {mixed} - TODO: add return description.
   * @private
   */
  return _createClass(Profiler, [{
    key: "done",
    value: function done() {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      if (typeof args[args.length - 1] === 'function') {
        // eslint-disable-next-line no-console
        console.warn('Callback function no longer supported as of winston@3.0.0');
        args.pop();
      }
      var info = _typeof(args[args.length - 1]) === 'object' ? args.pop() : {};
      info.level = info.level || 'info';
      info.durationMs = Date.now() - this.start;
      return this.logger.write(info);
    }
  }]);
}();
;
module.exports = Profiler;

/***/ }),

/***/ 2785:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
/* provided dependency */ var process = __webpack_require__(14224);
/**
 * exception-handler.js: Object for handling uncaughtException events.
 *
 * (C) 2010 Charlie Robbins
 * MIT LICENCE
 */



function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var os = __webpack_require__(25597);
var asyncForEach = __webpack_require__(42777);
var debug = __webpack_require__(24169)('winston:rejection');
var once = __webpack_require__(44766);
var stackTrace = __webpack_require__(79008);
var RejectionStream = __webpack_require__(12014);

/**
 * Object for handling unhandledRejection events.
 * @type {RejectionHandler}
 */
module.exports = /*#__PURE__*/function () {
  /**
   * TODO: add contructor description
   * @param {!Logger} logger - TODO: add param description
   */
  function RejectionHandler(logger) {
    _classCallCheck(this, RejectionHandler);
    if (!logger) {
      throw new Error('Logger is required to handle rejections');
    }
    this.logger = logger;
    this.handlers = new Map();
  }

  /**
   * Handles `unhandledRejection` events for the current process by adding any
   * handlers passed in.
   * @returns {undefined}
   */
  return _createClass(RejectionHandler, [{
    key: "handle",
    value: function handle() {
      var _this = this;
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      args.forEach(function (arg) {
        if (Array.isArray(arg)) {
          return arg.forEach(function (handler) {
            return _this._addHandler(handler);
          });
        }
        _this._addHandler(arg);
      });
      if (!this.catcher) {
        this.catcher = this._unhandledRejection.bind(this);
        process.on('unhandledRejection', this.catcher);
      }
    }

    /**
     * Removes any handlers to `unhandledRejection` events for the current
     * process. This does not modify the state of the `this.handlers` set.
     * @returns {undefined}
     */
  }, {
    key: "unhandle",
    value: function unhandle() {
      var _this2 = this;
      if (this.catcher) {
        process.removeListener('unhandledRejection', this.catcher);
        this.catcher = false;
        Array.from(this.handlers.values()).forEach(function (wrapper) {
          return _this2.logger.unpipe(wrapper);
        });
      }
    }

    /**
     * TODO: add method description
     * @param {Error} err - Error to get information about.
     * @returns {mixed} - TODO: add return description.
     */
  }, {
    key: "getAllInfo",
    value: function getAllInfo(err) {
      var message = null;
      if (err) {
        message = typeof err === 'string' ? err : err.message;
      }
      return {
        error: err,
        // TODO (indexzero): how do we configure this?
        level: 'error',
        message: ["unhandledRejection: ".concat(message || '(no error message)'), err && err.stack || '  No stack trace'].join('\n'),
        stack: err && err.stack,
        rejection: true,
        date: new Date().toString(),
        process: this.getProcessInfo(),
        os: this.getOsInfo(),
        trace: this.getTrace(err)
      };
    }

    /**
     * Gets all relevant process information for the currently running process.
     * @returns {mixed} - TODO: add return description.
     */
  }, {
    key: "getProcessInfo",
    value: function getProcessInfo() {
      return {
        pid: process.pid,
        uid: process.getuid ? process.getuid() : null,
        gid: process.getgid ? process.getgid() : null,
        cwd: process.cwd(),
        execPath: process.execPath,
        version: process.version,
        argv: process.argv,
        memoryUsage: process.memoryUsage()
      };
    }

    /**
     * Gets all relevant OS information for the currently running process.
     * @returns {mixed} - TODO: add return description.
     */
  }, {
    key: "getOsInfo",
    value: function getOsInfo() {
      return {
        loadavg: os.loadavg(),
        uptime: os.uptime()
      };
    }

    /**
     * Gets a stack trace for the specified error.
     * @param {mixed} err - TODO: add param description.
     * @returns {mixed} - TODO: add return description.
     */
  }, {
    key: "getTrace",
    value: function getTrace(err) {
      var trace = err ? stackTrace.parse(err) : stackTrace.get();
      return trace.map(function (site) {
        return {
          column: site.getColumnNumber(),
          file: site.getFileName(),
          "function": site.getFunctionName(),
          line: site.getLineNumber(),
          method: site.getMethodName(),
          "native": site.isNative()
        };
      });
    }

    /**
     * Helper method to add a transport as an exception handler.
     * @param {Transport} handler - The transport to add as an exception handler.
     * @returns {void}
     */
  }, {
    key: "_addHandler",
    value: function _addHandler(handler) {
      if (!this.handlers.has(handler)) {
        handler.handleRejections = true;
        var wrapper = new RejectionStream(handler);
        this.handlers.set(handler, wrapper);
        this.logger.pipe(wrapper);
      }
    }

    /**
     * Logs all relevant information around the `err` and exits the current
     * process.
     * @param {Error} err - Error to handle
     * @returns {mixed} - TODO: add return description.
     * @private
     */
  }, {
    key: "_unhandledRejection",
    value: function _unhandledRejection(err) {
      var info = this.getAllInfo(err);
      var handlers = this._getRejectionHandlers();
      // Calculate if we should exit on this error
      var doExit = typeof this.logger.exitOnError === 'function' ? this.logger.exitOnError(err) : this.logger.exitOnError;
      var timeout;
      if (!handlers.length && doExit) {
        // eslint-disable-next-line no-console
        console.warn('winston: exitOnError cannot be true with no rejection handlers.');
        // eslint-disable-next-line no-console
        console.warn('winston: not exiting process.');
        doExit = false;
      }
      function gracefulExit() {
        debug('doExit', doExit);
        debug('process._exiting', process._exiting);
        if (doExit && !process._exiting) {
          // Remark: Currently ignoring any rejections from transports when
          // catching unhandled rejections.
          if (timeout) {
            clearTimeout(timeout);
          }
          // eslint-disable-next-line no-process-exit
          process.exit(1);
        }
      }
      if (!handlers || handlers.length === 0) {
        return process.nextTick(gracefulExit);
      }

      // Log to all transports attempting to listen for when they are completed.
      asyncForEach(handlers, function (handler, next) {
        var done = once(next);
        var transport = handler.transport || handler;

        // Debug wrapping so that we can inspect what's going on under the covers.
        function onDone(event) {
          return function () {
            debug(event);
            done();
          };
        }
        transport._ending = true;
        transport.once('finish', onDone('finished'));
        transport.once('error', onDone('error'));
      }, function () {
        return doExit && gracefulExit();
      });
      this.logger.log(info);

      // If exitOnError is true, then only allow the logging of exceptions to
      // take up to `3000ms`.
      if (doExit) {
        timeout = setTimeout(gracefulExit, 3000);
      }
    }

    /**
     * Returns the list of transports and exceptionHandlers for this instance.
     * @returns {Array} - List of transports and exceptionHandlers for this
     * instance.
     * @private
     */
  }, {
    key: "_getRejectionHandlers",
    value: function _getRejectionHandlers() {
      // Remark (indexzero): since `logger.transports` returns all of the pipes
      // from the _readableState of the stream we actually get the join of the
      // explicit handlers and the implicit transports with
      // `handleRejections: true`
      return this.logger.transports.filter(function (wrap) {
        var transport = wrap.transport || wrap;
        return transport.handleRejections;
      });
    }
  }]);
}();

/***/ }),

/***/ 12014:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
/**
 * rejection-stream.js: TODO: add file header handler.
 *
 * (C) 2010 Charlie Robbins
 * MIT LICENCE
 */



function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
var _require = __webpack_require__(62981),
  Writable = _require.Writable;

/**
 * TODO: add class description.
 * @type {RejectionStream}
 * @extends {Writable}
 */
module.exports = /*#__PURE__*/function (_Writable) {
  /**
   * Constructor function for the RejectionStream responsible for wrapping a
   * TransportStream; only allowing writes of `info` objects with
   * `info.rejection` set to true.
   * @param {!TransportStream} transport - Stream to filter to rejections
   */
  function RejectionStream(transport) {
    var _this;
    _classCallCheck(this, RejectionStream);
    _this = _callSuper(this, RejectionStream, [{
      objectMode: true
    }]);
    if (!transport) {
      throw new Error('RejectionStream requires a TransportStream instance.');
    }
    _this.handleRejections = true;
    _this.transport = transport;
    return _this;
  }

  /**
   * Writes the info object to our transport instance if (and only if) the
   * `rejection` property is set on the info.
   * @param {mixed} info - TODO: add param description.
   * @param {mixed} enc - TODO: add param description.
   * @param {mixed} callback - TODO: add param description.
   * @returns {mixed} - TODO: add return description.
   * @private
   */
  _inherits(RejectionStream, _Writable);
  return _createClass(RejectionStream, [{
    key: "_write",
    value: function _write(info, enc, callback) {
      if (info.rejection) {
        return this.transport.log(info, callback);
      }
      callback();
      return true;
    }
  }]);
}(Writable);

/***/ }),

/***/ 85950:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
/* provided dependency */ var Buffer = __webpack_require__(55872)["Buffer"];
/**
 * tail-file.js: TODO: add file header description.
 *
 * (C) 2010 Charlie Robbins
 * MIT LICENCE
 */



var fs = __webpack_require__(97898);
var _require = __webpack_require__(72699),
  StringDecoder = _require.StringDecoder;
var _require2 = __webpack_require__(62981),
  Stream = _require2.Stream;

/**
 * Simple no-op function.
 * @returns {undefined}
 */
function noop() {}

/**
 * TODO: add function description.
 * @param {Object} options - Options for tail.
 * @param {function} iter - Iterator function to execute on every line.
* `tail -f` a file. Options must include file.
 * @returns {mixed} - TODO: add return description.
 */
module.exports = function (options, iter) {
  var buffer = Buffer.alloc(64 * 1024);
  var decode = new StringDecoder('utf8');
  var stream = new Stream();
  var buff = '';
  var pos = 0;
  var row = 0;
  if (options.start === -1) {
    delete options.start;
  }
  stream.readable = true;
  stream.destroy = function () {
    stream.destroyed = true;
    stream.emit('end');
    stream.emit('close');
  };
  fs.open(options.file, 'a+', '0644', function (err, fd) {
    if (err) {
      if (!iter) {
        stream.emit('error', err);
      } else {
        iter(err);
      }
      stream.destroy();
      return;
    }
    (function read() {
      if (stream.destroyed) {
        fs.close(fd, noop);
        return;
      }
      return fs.read(fd, buffer, 0, buffer.length, pos, function (error, bytes) {
        if (error) {
          if (!iter) {
            stream.emit('error', error);
          } else {
            iter(error);
          }
          stream.destroy();
          return;
        }
        if (!bytes) {
          if (buff) {
            // eslint-disable-next-line eqeqeq
            if (options.start == null || row > options.start) {
              if (!iter) {
                stream.emit('line', buff);
              } else {
                iter(null, buff);
              }
            }
            row++;
            buff = '';
          }
          return setTimeout(read, 1000);
        }
        var data = decode.write(buffer.slice(0, bytes));
        if (!iter) {
          stream.emit('data', data);
        }
        data = (buff + data).split(/\n+/);
        var l = data.length - 1;
        var i = 0;
        for (; i < l; i++) {
          // eslint-disable-next-line eqeqeq
          if (options.start == null || row > options.start) {
            if (!iter) {
              stream.emit('line', data[i]);
            } else {
              iter(null, data[i]);
            }
          }
          row++;
        }
        buff = data[l];
        pos += bytes;
        return read();
      });
    })();
  });
  if (!iter) {
    return stream;
  }
  return stream.destroy;
};

/***/ }),

/***/ 5822:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
/* eslint-disable no-console */
/*
 * console.js: Transport for outputting to the console.
 *
 * (C) 2010 Charlie Robbins
 * MIT LICENCE
 */



function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
var os = __webpack_require__(25597);
var _require = __webpack_require__(27735),
  LEVEL = _require.LEVEL,
  MESSAGE = _require.MESSAGE;
var TransportStream = __webpack_require__(68367);

/**
 * Transport for outputting to the console.
 * @type {Console}
 * @extends {TransportStream}
 */
module.exports = /*#__PURE__*/function (_TransportStream) {
  /**
   * Constructor function for the Console transport object responsible for
   * persisting log messages and metadata to a terminal or TTY.
   * @param {!Object} [options={}] - Options for this instance.
   */
  function Console() {
    var _this;
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    _classCallCheck(this, Console);
    _this = _callSuper(this, Console, [options]);

    // Expose the name of this Transport on the prototype
    _this.name = options.name || 'console';
    _this.stderrLevels = _this._stringArrayToSet(options.stderrLevels);
    _this.consoleWarnLevels = _this._stringArrayToSet(options.consoleWarnLevels);
    _this.eol = typeof options.eol === 'string' ? options.eol : os.EOL;
    _this.forceConsole = options.forceConsole || false;

    // Keep a reference to the log, warn, and error console methods
    // in case they get redirected to this transport after the logger is
    // instantiated. This prevents a circular reference issue.
    _this._consoleLog = console.log.bind(console);
    _this._consoleWarn = console.warn.bind(console);
    _this._consoleError = console.error.bind(console);
    _this.setMaxListeners(30);
    return _this;
  }

  /**
   * Core logging method exposed to Winston.
   * @param {Object} info - TODO: add param description.
   * @param {Function} callback - TODO: add param description.
   * @returns {undefined}
   */
  _inherits(Console, _TransportStream);
  return _createClass(Console, [{
    key: "log",
    value: function log(info, callback) {
      var _this2 = this;
      setImmediate(function () {
        return _this2.emit('logged', info);
      });

      // Remark: what if there is no raw...?
      if (this.stderrLevels[info[LEVEL]]) {
        if (console._stderr && !this.forceConsole) {
          // Node.js maps `process.stderr` to `console._stderr`.
          console._stderr.write("".concat(info[MESSAGE]).concat(this.eol));
        } else {
          // console.error adds a newline
          this._consoleError(info[MESSAGE]);
        }
        if (callback) {
          callback(); // eslint-disable-line callback-return
        }
        return;
      } else if (this.consoleWarnLevels[info[LEVEL]]) {
        if (console._stderr && !this.forceConsole) {
          // Node.js maps `process.stderr` to `console._stderr`.
          // in Node.js console.warn is an alias for console.error
          console._stderr.write("".concat(info[MESSAGE]).concat(this.eol));
        } else {
          // console.warn adds a newline
          this._consoleWarn(info[MESSAGE]);
        }
        if (callback) {
          callback(); // eslint-disable-line callback-return
        }
        return;
      }
      if (console._stdout && !this.forceConsole) {
        // Node.js maps `process.stdout` to `console._stdout`.
        console._stdout.write("".concat(info[MESSAGE]).concat(this.eol));
      } else {
        // console.log adds a newline.
        this._consoleLog(info[MESSAGE]);
      }
      if (callback) {
        callback(); // eslint-disable-line callback-return
      }
    }

    /**
     * Returns a Set-like object with strArray's elements as keys (each with the
     * value true).
     * @param {Array} strArray - Array of Set-elements as strings.
     * @param {?string} [errMsg] - Custom error message thrown on invalid input.
     * @returns {Object} - TODO: add return description.
     * @private
     */
  }, {
    key: "_stringArrayToSet",
    value: function _stringArrayToSet(strArray, errMsg) {
      if (!strArray) return {};
      errMsg = errMsg || 'Cannot make set from type other than Array of string elements';
      if (!Array.isArray(strArray)) {
        throw new Error(errMsg);
      }
      return strArray.reduce(function (set, el) {
        if (typeof el !== 'string') {
          throw new Error(errMsg);
        }
        set[el] = true;
        return set;
      }, {});
    }
  }]);
}(TransportStream);

/***/ }),

/***/ 5573:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
/* provided dependency */ var Buffer = __webpack_require__(55872)["Buffer"];
/* eslint-disable complexity,max-statements */
/**
 * file.js: Transport for outputting to a local log file.
 *
 * (C) 2010 Charlie Robbins
 * MIT LICENCE
 */



function _readOnlyError(r) { throw new TypeError('"' + r + '" is read-only'); }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
var fs = __webpack_require__(12355);
var path = __webpack_require__(69771);
var asyncSeries = __webpack_require__(18091);
var zlib = __webpack_require__(51778);
var _require = __webpack_require__(27735),
  MESSAGE = _require.MESSAGE;
var _require2 = __webpack_require__(62981),
  Stream = _require2.Stream,
  PassThrough = _require2.PassThrough;
var TransportStream = __webpack_require__(68367);
var debug = __webpack_require__(24169)('winston:file');
var os = __webpack_require__(25597);
var tailFile = __webpack_require__(85950);

/**
 * Transport for outputting to a local log file.
 * @type {File}
 * @extends {TransportStream}
 */
module.exports = /*#__PURE__*/function (_TransportStream) {
  /**
   * Constructor function for the File transport object responsible for
   * persisting log messages and metadata to one or more files.
   * @param {Object} options - Options for this instance.
   */
  function File() {
    var _this;
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    _classCallCheck(this, File);
    _this = _callSuper(this, File, [options]);

    // Expose the name of this Transport on the prototype.
    _this.name = options.name || 'file';

    // Helper function which throws an `Error` in the event that any of the
    // rest of the arguments is present in `options`.
    function throwIf(target) {
      for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }
      args.slice(1).forEach(function (name) {
        if (options[name]) {
          throw new Error("Cannot set ".concat(name, " and ").concat(target, " together"));
        }
      });
    }

    // Setup the base stream that always gets piped to to handle buffering.
    _this._stream = new PassThrough();
    _this._stream.setMaxListeners(30);

    // Bind this context for listener methods.
    _this._onError = _this._onError.bind(_this);
    if (options.filename || options.dirname) {
      throwIf('filename or dirname', 'stream');
      _this._basename = _this.filename = options.filename ? path.basename(options.filename) : 'winston.log';
      _this.dirname = options.dirname || path.dirname(options.filename);
      _this.options = options.options || {
        flags: 'a'
      };
    } else if (options.stream) {
      // eslint-disable-next-line no-console
      console.warn('options.stream will be removed in winston@4. Use winston.transports.Stream');
      throwIf('stream', 'filename', 'maxsize');
      _this._dest = _this._stream.pipe(_this._setupStream(options.stream));
      _this.dirname = path.dirname(_this._dest.path);
      // We need to listen for drain events when write() returns false. This
      // can make node mad at times.
    } else {
      throw new Error('Cannot log to file without filename or stream.');
    }
    _this.maxsize = options.maxsize || null;
    _this.rotationFormat = options.rotationFormat || false;
    _this.zippedArchive = options.zippedArchive || false;
    _this.maxFiles = options.maxFiles || null;
    _this.eol = typeof options.eol === 'string' ? options.eol : os.EOL;
    _this.tailable = options.tailable || false;
    _this.lazy = options.lazy || false;

    // Internal state variables representing the number of files this instance
    // has created and the current size (in bytes) of the current logfile.
    _this._size = 0;
    _this._pendingSize = 0;
    _this._created = 0;
    _this._drain = false;
    _this._opening = false;
    _this._ending = false;
    _this._fileExist = false;
    if (_this.dirname) _this._createLogDirIfNotExist(_this.dirname);
    if (!_this.lazy) _this.open();
    return _this;
  }
  _inherits(File, _TransportStream);
  return _createClass(File, [{
    key: "finishIfEnding",
    value: function finishIfEnding() {
      var _this2 = this;
      if (this._ending) {
        if (this._opening) {
          this.once('open', function () {
            _this2._stream.once('finish', function () {
              return _this2.emit('finish');
            });
            setImmediate(function () {
              return _this2._stream.end();
            });
          });
        } else {
          this._stream.once('finish', function () {
            return _this2.emit('finish');
          });
          setImmediate(function () {
            return _this2._stream.end();
          });
        }
      }
    }

    /**
     * Core logging method exposed to Winston. Metadata is optional.
     * @param {Object} info - TODO: add param description.
     * @param {Function} callback - TODO: add param description.
     * @returns {undefined}
     */
  }, {
    key: "log",
    value: function log(info) {
      var _this3 = this;
      var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {};
      // Remark: (jcrugzz) What is necessary about this callback(null, true) now
      // when thinking about 3.x? Should silent be handled in the base
      // TransportStream _write method?
      if (this.silent) {
        callback();
        return true;
      }

      // Output stream buffer is full and has asked us to wait for the drain event
      if (this._drain) {
        this._stream.once('drain', function () {
          _this3._drain = false;
          _this3.log(info, callback);
        });
        return;
      }
      if (this._rotate) {
        this._stream.once('rotate', function () {
          _this3._rotate = false;
          _this3.log(info, callback);
        });
        return;
      }
      if (this.lazy) {
        if (!this._fileExist) {
          if (!this._opening) {
            this.open();
          }
          this.once('open', function () {
            _this3._fileExist = true;
            _this3.log(info, callback);
            return;
          });
          return;
        }
        if (this._needsNewFile(this._pendingSize)) {
          this._dest.once('close', function () {
            if (!_this3._opening) {
              _this3.open();
            }
            _this3.once('open', function () {
              _this3.log(info, callback);
              return;
            });
            return;
          });
          return;
        }
      }

      // Grab the raw string and append the expected EOL.
      var output = "".concat(info[MESSAGE]).concat(this.eol);
      var bytes = Buffer.byteLength(output);

      // After we have written to the PassThrough check to see if we need
      // to rotate to the next file.
      //
      // Remark: This gets called too early and does not depict when data
      // has been actually flushed to disk.
      function logged() {
        var _this4 = this;
        this._size += bytes;
        this._pendingSize -= bytes;
        debug('logged %s %s', this._size, output);
        this.emit('logged', info);

        // Do not attempt to rotate files while rotating
        if (this._rotate) {
          return;
        }

        // Do not attempt to rotate files while opening
        if (this._opening) {
          return;
        }

        // Check to see if we need to end the stream and create a new one.
        if (!this._needsNewFile()) {
          return;
        }
        if (this.lazy) {
          this._endStream(function () {
            _this4.emit('fileclosed');
          });
          return;
        }

        // End the current stream, ensure it flushes and create a new one.
        // This could potentially be optimized to not run a stat call but its
        // the safest way since we are supporting `maxFiles`.
        this._rotate = true;
        this._endStream(function () {
          return _this4._rotateFile();
        });
      }

      // Keep track of the pending bytes being written while files are opening
      // in order to properly rotate the PassThrough this._stream when the file
      // eventually does open.
      this._pendingSize += bytes;
      if (this._opening && !this.rotatedWhileOpening && this._needsNewFile(this._size + this._pendingSize)) {
        this.rotatedWhileOpening = true;
      }
      var written = this._stream.write(output, logged.bind(this));
      if (!written) {
        this._drain = true;
        this._stream.once('drain', function () {
          _this3._drain = false;
          callback();
        });
      } else {
        callback(); // eslint-disable-line callback-return
      }
      debug('written', written, this._drain);
      this.finishIfEnding();
      return written;
    }

    /**
     * Query the transport. Options object is optional.
     * @param {Object} options - Loggly-like query options for this instance.
     * @param {function} callback - Continuation to respond to when complete.
     * TODO: Refactor me.
     */
  }, {
    key: "query",
    value: function query(options, callback) {
      if (typeof options === 'function') {
        callback = options;
        options = {};
      }
      options = normalizeQuery(options);
      var file = path.join(this.dirname, this.filename);
      var buff = '';
      var results = [];
      var row = 0;
      var stream = fs.createReadStream(file, {
        encoding: 'utf8'
      });
      stream.on('error', function (err) {
        if (stream.readable) {
          stream.destroy();
        }
        if (!callback) {
          return;
        }
        return err.code !== 'ENOENT' ? callback(err) : callback(null, results);
      });
      stream.on('data', function (data) {
        data = (buff + data).split(/\n+/);
        var l = data.length - 1;
        var i = 0;
        for (; i < l; i++) {
          if (!options.start || row >= options.start) {
            add(data[i]);
          }
          row++;
        }
        buff = data[l];
      });
      stream.on('close', function () {
        if (buff) {
          add(buff, true);
        }
        if (options.order === 'desc') {
          results = results.reverse();
        }

        // eslint-disable-next-line callback-return
        if (callback) callback(null, results);
      });
      function add(buff, attempt) {
        try {
          var log = JSON.parse(buff);
          if (check(log)) {
            push(log);
          }
        } catch (e) {
          if (!attempt) {
            stream.emit('error', e);
          }
        }
      }
      function push(log) {
        if (options.rows && results.length >= options.rows && options.order !== 'desc') {
          if (stream.readable) {
            stream.destroy();
          }
          return;
        }
        if (options.fields) {
          log = options.fields.reduce(function (obj, key) {
            obj[key] = log[key];
            return obj;
          }, {});
        }
        if (options.order === 'desc') {
          if (results.length >= options.rows) {
            results.shift();
          }
        }
        results.push(log);
      }
      function check(log) {
        if (!log) {
          return;
        }
        if (_typeof(log) !== 'object') {
          return;
        }
        var time = new Date(log.timestamp);
        if (options.from && time < options.from || options.until && time > options.until || options.level && options.level !== log.level) {
          return;
        }
        return true;
      }
      function normalizeQuery(options) {
        options = options || {};

        // limit
        options.rows = options.rows || options.limit || 10;

        // starting row offset
        options.start = options.start || 0;

        // now
        options.until = options.until || new Date();
        if (_typeof(options.until) !== 'object') {
          options.until = new Date(options.until);
        }

        // now - 24
        options.from = options.from || options.until - 24 * 60 * 60 * 1000;
        if (_typeof(options.from) !== 'object') {
          options.from = new Date(options.from);
        }

        // 'asc' or 'desc'
        options.order = options.order || 'desc';
        return options;
      }
    }

    /**
     * Returns a log stream for this transport. Options object is optional.
     * @param {Object} options - Stream options for this instance.
     * @returns {Stream} - TODO: add return description.
     * TODO: Refactor me.
     */
  }, {
    key: "stream",
    value: function stream() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var file = path.join(this.dirname, this.filename);
      var stream = new Stream();
      var tail = {
        file: file,
        start: options.start
      };
      stream.destroy = tailFile(tail, function (err, line) {
        if (err) {
          return stream.emit('error', err);
        }
        try {
          stream.emit('data', line);
          line = JSON.parse(line);
          stream.emit('log', line);
        } catch (e) {
          stream.emit('error', e);
        }
      });
      return stream;
    }

    /**
     * Checks to see the filesize of.
     * @returns {undefined}
     */
  }, {
    key: "open",
    value: function open() {
      var _this5 = this;
      // If we do not have a filename then we were passed a stream and
      // don't need to keep track of size.
      if (!this.filename) return;
      if (this._opening) return;
      this._opening = true;

      // Stat the target file to get the size and create the stream.
      this.stat(function (err, size) {
        if (err) {
          return _this5.emit('error', err);
        }
        debug('stat done: %s { size: %s }', _this5.filename, size);
        _this5._size = size;
        _this5._dest = _this5._createStream(_this5._stream);
        _this5._opening = false;
        _this5.once('open', function () {
          if (!_this5._stream.emit('rotate')) {
            _this5._rotate = false;
          }
        });
      });
    }

    /**
     * Stat the file and assess information in order to create the proper stream.
     * @param {function} callback - TODO: add param description.
     * @returns {undefined}
     */
  }, {
    key: "stat",
    value: function stat(callback) {
      var _this6 = this;
      var target = this._getFile();
      var fullpath = path.join(this.dirname, target);
      fs.stat(fullpath, function (err, stat) {
        if (err && err.code === 'ENOENT') {
          debug('ENOENT ok', fullpath);
          // Update internally tracked filename with the new target name.
          _this6.filename = target;
          return callback(null, 0);
        }
        if (err) {
          debug("err ".concat(err.code, " ").concat(fullpath));
          return callback(err);
        }
        if (!stat || _this6._needsNewFile(stat.size)) {
          // If `stats.size` is greater than the `maxsize` for this
          // instance then try again.
          return _this6._incFile(function () {
            return _this6.stat(callback);
          });
        }

        // Once we have figured out what the filename is, set it
        // and return the size.
        _this6.filename = target;
        callback(null, stat.size);
      });
    }

    /**
     * Closes the stream associated with this instance.
     * @param {function} cb - TODO: add param description.
     * @returns {undefined}
     */
  }, {
    key: "close",
    value: function close(cb) {
      var _this7 = this;
      if (!this._stream) {
        return;
      }
      this._stream.end(function () {
        if (cb) {
          cb(); // eslint-disable-line callback-return
        }
        _this7.emit('flush');
        _this7.emit('closed');
      });
    }

    /**
     * TODO: add method description.
     * @param {number} size - TODO: add param description.
     * @returns {undefined}
     */
  }, {
    key: "_needsNewFile",
    value: function _needsNewFile(size) {
      size = size || this._size;
      return this.maxsize && size >= this.maxsize;
    }

    /**
     * TODO: add method description.
     * @param {Error} err - TODO: add param description.
     * @returns {undefined}
     */
  }, {
    key: "_onError",
    value: function _onError(err) {
      this.emit('error', err);
    }

    /**
     * TODO: add method description.
     * @param {Stream} stream - TODO: add param description.
     * @returns {mixed} - TODO: add return description.
     */
  }, {
    key: "_setupStream",
    value: function _setupStream(stream) {
      stream.on('error', this._onError);
      return stream;
    }

    /**
     * TODO: add method description.
     * @param {Stream} stream - TODO: add param description.
     * @returns {mixed} - TODO: add return description.
     */
  }, {
    key: "_cleanupStream",
    value: function _cleanupStream(stream) {
      stream.removeListener('error', this._onError);
      stream.destroy();
      return stream;
    }

    /**
     * TODO: add method description.
     */
  }, {
    key: "_rotateFile",
    value: function _rotateFile() {
      var _this8 = this;
      this._incFile(function () {
        return _this8.open();
      });
    }

    /**
     * Unpipe from the stream that has been marked as full and end it so it
     * flushes to disk.
     *
     * @param {function} callback - Callback for when the current file has closed.
     * @private
     */
  }, {
    key: "_endStream",
    value: function _endStream() {
      var _this9 = this;
      var callback = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function () {};
      if (this._dest) {
        this._stream.unpipe(this._dest);
        this._dest.end(function () {
          _this9._cleanupStream(_this9._dest);
          callback();
        });
      } else {
        callback(); // eslint-disable-line callback-return
      }
    }

    /**
     * Returns the WritableStream for the active file on this instance. If we
     * should gzip the file then a zlib stream is returned.
     *
     * @param {ReadableStream} source –PassThrough to pipe to the file when open.
     * @returns {WritableStream} Stream that writes to disk for the active file.
     */
  }, {
    key: "_createStream",
    value: function _createStream(source) {
      var _this10 = this;
      var fullpath = path.join(this.dirname, this.filename);
      debug('create stream start', fullpath, this.options);
      var dest = fs.createWriteStream(fullpath, this.options)
      // TODO: What should we do with errors here?
      .on('error', function (err) {
        return debug(err);
      }).on('close', function () {
        return debug('close', dest.path, dest.bytesWritten);
      }).on('open', function () {
        debug('file open ok', fullpath);
        _this10.emit('open', fullpath);
        source.pipe(dest);

        // If rotation occured during the open operation then we immediately
        // start writing to a new PassThrough, begin opening the next file
        // and cleanup the previous source and dest once the source has drained.
        if (_this10.rotatedWhileOpening) {
          _this10._stream = new PassThrough();
          _this10._stream.setMaxListeners(30);
          _this10._rotateFile();
          _this10.rotatedWhileOpening = false;
          _this10._cleanupStream(dest);
          source.end();
        }
      });
      debug('create stream ok', fullpath);
      return dest;
    }

    /**
     * TODO: add method description.
     * @param {function} callback - TODO: add param description.
     * @returns {undefined}
     */
  }, {
    key: "_incFile",
    value: function _incFile(callback) {
      debug('_incFile', this.filename);
      var ext = path.extname(this._basename);
      var basename = path.basename(this._basename, ext);
      var tasks = [];
      if (this.zippedArchive) {
        tasks.push(function (cb) {
          var num = this._created > 0 && !this.tailable ? this._created : '';
          this._compressFile(path.join(this.dirname, "".concat(basename).concat(num).concat(ext)), path.join(this.dirname, "".concat(basename).concat(num).concat(ext, ".gz")), cb);
        }.bind(this));
      }
      tasks.push(function (cb) {
        if (!this.tailable) {
          this._created += 1;
          this._checkMaxFilesIncrementing(ext, basename, cb);
        } else {
          this._checkMaxFilesTailable(ext, basename, cb);
        }
      }.bind(this));
      asyncSeries(tasks, callback);
    }

    /**
     * Gets the next filename to use for this instance in the case that log
     * filesizes are being capped.
     * @returns {string} - TODO: add return description.
     * @private
     */
  }, {
    key: "_getFile",
    value: function _getFile() {
      var ext = path.extname(this._basename);
      var basename = path.basename(this._basename, ext);
      var isRotation = this.rotationFormat ? this.rotationFormat() : this._created;

      // Caveat emptor (indexzero): rotationFormat() was broken by design When
      // combined with max files because the set of files to unlink is never
      // stored.
      return !this.tailable && this._created ? "".concat(basename).concat(isRotation).concat(ext) : "".concat(basename).concat(ext);
    }

    /**
     * Increment the number of files created or checked by this instance.
     * @param {mixed} ext - TODO: add param description.
     * @param {mixed} basename - TODO: add param description.
     * @param {mixed} callback - TODO: add param description.
     * @returns {undefined}
     * @private
     */
  }, {
    key: "_checkMaxFilesIncrementing",
    value: function _checkMaxFilesIncrementing(ext, basename, callback) {
      // Check for maxFiles option and delete file.
      if (!this.maxFiles || this._created < this.maxFiles) {
        return setImmediate(callback);
      }
      var oldest = this._created - this.maxFiles;
      var isOldest = oldest !== 0 ? oldest : '';
      var isZipped = this.zippedArchive ? '.gz' : '';
      var filePath = "".concat(basename).concat(isOldest).concat(ext).concat(isZipped);
      var target = path.join(this.dirname, filePath);
      fs.unlink(target, callback);
    }

    /**
     * Roll files forward based on integer, up to maxFiles. e.g. if base if
     * file.log and it becomes oversized, roll to file1.log, and allow file.log
     * to be re-used. If file is oversized again, roll file1.log to file2.log,
     * roll file.log to file1.log, and so on.
     * @param {mixed} ext - TODO: add param description.
     * @param {mixed} basename - TODO: add param description.
     * @param {mixed} callback - TODO: add param description.
     * @returns {undefined}
     * @private
     */
  }, {
    key: "_checkMaxFilesTailable",
    value: function _checkMaxFilesTailable(ext, basename, callback) {
      var _this12 = this;
      var tasks = [];
      if (!this.maxFiles) {
        return;
      }

      // const isZipped = this.zippedArchive ? '.gz' : '';
      var isZipped = this.zippedArchive ? '.gz' : '';
      for (var x = this.maxFiles - 1; x > 1; x--) {
        tasks.push(function (i, cb) {
          var _this11 = this;
          var fileName = "".concat(basename).concat(i - 1).concat(ext).concat(isZipped);
          var tmppath = path.join(this.dirname, fileName);
          fs.exists(tmppath, function (exists) {
            if (!exists) {
              return cb(null);
            }
            fileName = "".concat(basename).concat(i).concat(ext).concat(isZipped);
            fs.rename(tmppath, path.join(_this11.dirname, fileName), cb);
          });
        }.bind(this, x));
      }
      asyncSeries(tasks, function () {
        fs.rename(path.join(_this12.dirname, "".concat(basename).concat(ext).concat(isZipped)), path.join(_this12.dirname, "".concat(basename, "1").concat(ext).concat(isZipped)), callback);
      });
    }

    /**
     * Compresses src to dest with gzip and unlinks src
     * @param {string} src - path to source file.
     * @param {string} dest - path to zipped destination file.
     * @param {Function} callback - callback called after file has been compressed.
     * @returns {undefined}
     * @private
     */
  }, {
    key: "_compressFile",
    value: function _compressFile(src, dest, callback) {
      fs.access(src, fs.F_OK, function (err) {
        if (err) {
          return callback();
        }
        var gzip = zlib.createGzip();
        var inp = fs.createReadStream(src);
        var out = fs.createWriteStream(dest);
        out.on('finish', function () {
          fs.unlink(src, callback);
        });
        inp.pipe(gzip).pipe(out);
      });
    }
  }, {
    key: "_createLogDirIfNotExist",
    value: function _createLogDirIfNotExist(dirPath) {
      /* eslint-disable no-sync */
      if (!fs.existsSync(dirPath)) {
        fs.mkdirSync(dirPath, {
          recursive: true
        });
      }
      /* eslint-enable no-sync */
    }
  }]);
}(TransportStream);

/***/ }),

/***/ 12935:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
/* provided dependency */ var Buffer = __webpack_require__(55872)["Buffer"];
/**
 * http.js: Transport for outputting to a json-rpcserver.
 *
 * (C) 2010 Charlie Robbins
 * MIT LICENCE
 */



function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _readOnlyError(r) { throw new TypeError('"' + r + '" is read-only'); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
var http = __webpack_require__(81442);
var https = __webpack_require__(39272);
var _require = __webpack_require__(62981),
  Stream = _require.Stream;
var TransportStream = __webpack_require__(68367);
var _require2 = __webpack_require__(34859),
  configure = _require2.configure;

/**
 * Transport for outputting to a json-rpc server.
 * @type {Stream}
 * @extends {TransportStream}
 */
module.exports = /*#__PURE__*/function (_TransportStream) {
  /**
   * Constructor function for the Http transport object responsible for
   * persisting log messages and metadata to a terminal or TTY.
   * @param {!Object} [options={}] - Options for this instance.
   */
  // eslint-disable-next-line max-statements
  function Http() {
    var _this;
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    _classCallCheck(this, Http);
    _this = _callSuper(this, Http, [options]);
    _this.options = options;
    _this.name = options.name || 'http';
    _this.ssl = !!options.ssl;
    _this.host = options.host || 'localhost';
    _this.port = options.port;
    _this.auth = options.auth;
    _this.path = options.path || '';
    _this.maximumDepth = options.maximumDepth;
    _this.agent = options.agent;
    _this.headers = options.headers || {};
    _this.headers['content-type'] = 'application/json';
    _this.batch = options.batch || false;
    _this.batchInterval = options.batchInterval || 5000;
    _this.batchCount = options.batchCount || 10;
    _this.batchOptions = [];
    _this.batchTimeoutID = -1;
    _this.batchCallback = {};
    if (!_this.port) {
      _this.port = _this.ssl ? 443 : 80;
    }
    return _this;
  }

  /**
   * Core logging method exposed to Winston.
   * @param {Object} info - TODO: add param description.
   * @param {function} callback - TODO: add param description.
   * @returns {undefined}
   */
  _inherits(Http, _TransportStream);
  return _createClass(Http, [{
    key: "log",
    value: function log(info, callback) {
      var _this2 = this;
      this._request(info, null, null, function (err, res) {
        if (res && res.statusCode !== 200) {
          err = new Error("Invalid HTTP Status Code: ".concat(res.statusCode));
        }
        if (err) {
          _this2.emit('warn', err);
        } else {
          _this2.emit('logged', info);
        }
      });

      // Remark: (jcrugzz) Fire and forget here so requests dont cause buffering
      // and block more requests from happening?
      if (callback) {
        setImmediate(callback);
      }
    }

    /**
     * Query the transport. Options object is optional.
     * @param {Object} options -  Loggly-like query options for this instance.
     * @param {function} callback - Continuation to respond to when complete.
     * @returns {undefined}
     */
  }, {
    key: "query",
    value: function query(options, callback) {
      if (typeof options === 'function') {
        callback = options;
        options = {};
      }
      options = {
        method: 'query',
        params: this.normalizeQuery(options)
      };
      var auth = options.params.auth || null;
      delete options.params.auth;
      var path = options.params.path || null;
      delete options.params.path;
      this._request(options, auth, path, function (err, res, body) {
        if (res && res.statusCode !== 200) {
          err = new Error("Invalid HTTP Status Code: ".concat(res.statusCode));
        }
        if (err) {
          return callback(err);
        }
        if (typeof body === 'string') {
          try {
            body = JSON.parse(body);
          } catch (e) {
            return callback(e);
          }
        }
        callback(null, body);
      });
    }

    /**
     * Returns a log stream for this transport. Options object is optional.
     * @param {Object} options - Stream options for this instance.
     * @returns {Stream} - TODO: add return description
     */
  }, {
    key: "stream",
    value: function stream() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var stream = new Stream();
      options = {
        method: 'stream',
        params: options
      };
      var path = options.params.path || null;
      delete options.params.path;
      var auth = options.params.auth || null;
      delete options.params.auth;
      var buff = '';
      var req = this._request(options, auth, path);
      stream.destroy = function () {
        return req.destroy();
      };
      req.on('data', function (data) {
        data = (buff + data).split(/\n+/);
        var l = data.length - 1;
        var i = 0;
        for (; i < l; i++) {
          try {
            stream.emit('log', JSON.parse(data[i]));
          } catch (e) {
            stream.emit('error', e);
          }
        }
        buff = data[l];
      });
      req.on('error', function (err) {
        return stream.emit('error', err);
      });
      return stream;
    }

    /**
     * Make a request to a winstond server or any http server which can
     * handle json-rpc.
     * @param {function} options - Options to sent the request.
     * @param {Object?} auth - authentication options
     * @param {string} path - request path
     * @param {function} callback - Continuation to respond to when complete.
     */
  }, {
    key: "_request",
    value: function _request(options, auth, path, callback) {
      options = options || {};
      auth = auth || this.auth;
      path = path || this.path || '';
      if (this.batch) {
        this._doBatch(options, callback, auth, path);
      } else {
        this._doRequest(options, callback, auth, path);
      }
    }

    /**
     * Send or memorize the options according to batch configuration
     * @param {function} options - Options to sent the request.
     * @param {function} callback - Continuation to respond to when complete.
     * @param {Object?} auth - authentication options
     * @param {string} path - request path
     */
  }, {
    key: "_doBatch",
    value: function _doBatch(options, callback, auth, path) {
      this.batchOptions.push(options);
      if (this.batchOptions.length === 1) {
        // First message stored, it's time to start the timeout!
        var me = this;
        this.batchCallback = callback;
        this.batchTimeoutID = setTimeout(function () {
          // timeout is reached, send all messages to endpoint
          me.batchTimeoutID = -1;
          me._doBatchRequest(me.batchCallback, auth, path);
        }, this.batchInterval);
      }
      if (this.batchOptions.length === this.batchCount) {
        // max batch count is reached, send all messages to endpoint
        this._doBatchRequest(this.batchCallback, auth, path);
      }
    }

    /**
     * Initiate a request with the memorized batch options, stop the batch timeout
     * @param {function} callback - Continuation to respond to when complete.
     * @param {Object?} auth - authentication options
     * @param {string} path - request path
     */
  }, {
    key: "_doBatchRequest",
    value: function _doBatchRequest(callback, auth, path) {
      if (this.batchTimeoutID > 0) {
        clearTimeout(this.batchTimeoutID);
        this.batchTimeoutID = -1;
      }
      var batchOptionsCopy = this.batchOptions.slice();
      this.batchOptions = [];
      this._doRequest(batchOptionsCopy, callback, auth, path);
    }

    /**
     * Make a request to a winstond server or any http server which can
     * handle json-rpc.
     * @param {function} options - Options to sent the request.
     * @param {function} callback - Continuation to respond to when complete.
     * @param {Object?} auth - authentication options
     * @param {string} path - request path
     */
  }, {
    key: "_doRequest",
    value: function _doRequest(options, callback, auth, path) {
      // Prepare options for outgoing HTTP request
      var headers = Object.assign({}, this.headers);
      if (auth && auth.bearer) {
        headers.Authorization = "Bearer ".concat(auth.bearer);
      }
      var req = (this.ssl ? https : http).request(_objectSpread(_objectSpread({}, this.options), {}, {
        method: 'POST',
        host: this.host,
        port: this.port,
        path: "/".concat(path.replace(/^\//, '')),
        headers: headers,
        auth: auth && auth.username && auth.password ? "".concat(auth.username, ":").concat(auth.password) : '',
        agent: this.agent
      }));
      req.on('error', callback);
      req.on('response', function (res) {
        return res.on('end', function () {
          return callback(null, res);
        }).resume();
      });
      var jsonStringify = configure(_objectSpread({}, this.maximumDepth && {
        maximumDepth: this.maximumDepth
      }));
      req.end(Buffer.from(jsonStringify(options, this.options.replacer), 'utf8'));
    }
  }]);
}(TransportStream);

/***/ }),

/***/ 94901:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
/**
 * transports.js: Set of all transports Winston knows about.
 *
 * (C) 2010 Charlie Robbins
 * MIT LICENCE
 */



/**
 * TODO: add property description.
 * @type {Console}
 */
Object.defineProperty(exports, "Console", ({
  configurable: true,
  enumerable: true,
  get: function get() {
    return __webpack_require__(5822);
  }
}));

/**
 * TODO: add property description.
 * @type {File}
 */
Object.defineProperty(exports, "File", ({
  configurable: true,
  enumerable: true,
  get: function get() {
    return __webpack_require__(5573);
  }
}));

/**
 * TODO: add property description.
 * @type {Http}
 */
Object.defineProperty(exports, "Http", ({
  configurable: true,
  enumerable: true,
  get: function get() {
    return __webpack_require__(12935);
  }
}));

/**
 * TODO: add property description.
 * @type {Stream}
 */
Object.defineProperty(exports, "Stream", ({
  configurable: true,
  enumerable: true,
  get: function get() {
    return __webpack_require__(94946);
  }
}));

/***/ }),

/***/ 94946:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
/**
 * stream.js: Transport for outputting to any arbitrary stream.
 *
 * (C) 2010 Charlie Robbins
 * MIT LICENCE
 */



function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
var isStream = __webpack_require__(53528);
var _require = __webpack_require__(27735),
  MESSAGE = _require.MESSAGE;
var os = __webpack_require__(25597);
var TransportStream = __webpack_require__(68367);

/**
 * Transport for outputting to any arbitrary stream.
 * @type {Stream}
 * @extends {TransportStream}
 */
module.exports = /*#__PURE__*/function (_TransportStream) {
  /**
   * Constructor function for the Console transport object responsible for
   * persisting log messages and metadata to a terminal or TTY.
   * @param {!Object} [options={}] - Options for this instance.
   */
  function Stream() {
    var _this;
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    _classCallCheck(this, Stream);
    _this = _callSuper(this, Stream, [options]);
    if (!options.stream || !isStream(options.stream)) {
      throw new Error('options.stream is required.');
    }

    // We need to listen for drain events when write() returns false. This can
    // make node mad at times.
    _this._stream = options.stream;
    _this._stream.setMaxListeners(Infinity);
    _this.isObjectMode = options.stream._writableState.objectMode;
    _this.eol = typeof options.eol === 'string' ? options.eol : os.EOL;
    return _this;
  }

  /**
   * Core logging method exposed to Winston.
   * @param {Object} info - TODO: add param description.
   * @param {Function} callback - TODO: add param description.
   * @returns {undefined}
   */
  _inherits(Stream, _TransportStream);
  return _createClass(Stream, [{
    key: "log",
    value: function log(info, callback) {
      var _this2 = this;
      setImmediate(function () {
        return _this2.emit('logged', info);
      });
      if (this.isObjectMode) {
        this._stream.write(info);
        if (callback) {
          callback(); // eslint-disable-line callback-return
        }
        return;
      }
      this._stream.write("".concat(info[MESSAGE]).concat(this.eol));
      if (callback) {
        callback(); // eslint-disable-line callback-return
      }
      return;
    }
  }]);
}(TransportStream);

/***/ }),

/***/ 25040:
/***/ (function() {

/* (ignored) */

/***/ }),

/***/ 87942:
/***/ (function() {

/* (ignored) */

/***/ }),

/***/ 82880:
/***/ (function() {

/* (ignored) */

/***/ }),

/***/ 12355:
/***/ (function() {

/* (ignored) */

/***/ }),

/***/ 97898:
/***/ (function() {

/* (ignored) */

/***/ }),

/***/ 26773:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var possibleNames = __webpack_require__(41758);

var g = typeof globalThis === 'undefined' ? __webpack_require__.g : globalThis;

/** @type {import('.')} */
module.exports = function availableTypedArrays() {
	var /** @type {ReturnType<typeof availableTypedArrays>} */ out = [];
	for (var i = 0; i < possibleNames.length; i++) {
		if (typeof g[possibleNames[i]] === 'function') {
			// @ts-expect-error
			out[out.length] = possibleNames[i];
		}
	}
	return out;
};


/***/ }),

/***/ 82187:
/***/ (function(module, exports) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;

	function classNames () {
		var classes = '';

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (arg) {
				classes = appendClass(classes, parseValue(arg));
			}
		}

		return classes;
	}

	function parseValue (arg) {
		if (typeof arg === 'string' || typeof arg === 'number') {
			return arg;
		}

		if (typeof arg !== 'object') {
			return '';
		}

		if (Array.isArray(arg)) {
			return classNames.apply(null, arg);
		}

		if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes('[native code]')) {
			return arg.toString();
		}

		var classes = '';

		for (var key in arg) {
			if (hasOwn.call(arg, key) && arg[key]) {
				classes = appendClass(classes, key);
			}
		}

		return classes;
	}

	function appendClass (value, newClass) {
		if (!newClass) {
			return value;
		}
	
		if (value) {
			return value + ' ' + newClass;
		}
	
		return value + newClass;
	}

	if ( true && module.exports) {
		classNames.default = classNames;
		module.exports = classNames;
	} else if (true) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function () {
			return classNames;
		}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {}
}());


/***/ }),

/***/ 2053:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _extends; }
/* harmony export */ });
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}


/***/ }),

/***/ 11779:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ _ListCache; }
});

;// CONCATENATED MODULE: ./node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_listCacheClear.js
/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
  this.size = 0;
}

/* harmony default export */ var _listCacheClear = (listCacheClear);

// EXTERNAL MODULE: ./node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/eq.js
var eq = __webpack_require__(54523);
;// CONCATENATED MODULE: ./node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_assocIndexOf.js


/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if ((0,eq/* default */.Z)(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

/* harmony default export */ var _assocIndexOf = (assocIndexOf);

;// CONCATENATED MODULE: ./node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_listCacheDelete.js


/** Used for built-in method references. */
var arrayProto = Array.prototype;

/** Built-in value references. */
var splice = arrayProto.splice;

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = _assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  --this.size;
  return true;
}

/* harmony default export */ var _listCacheDelete = (listCacheDelete);

;// CONCATENATED MODULE: ./node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_listCacheGet.js


/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = _assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

/* harmony default export */ var _listCacheGet = (listCacheGet);

;// CONCATENATED MODULE: ./node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_listCacheHas.js


/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return _assocIndexOf(this.__data__, key) > -1;
}

/* harmony default export */ var _listCacheHas = (listCacheHas);

;// CONCATENATED MODULE: ./node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_listCacheSet.js


/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = _assocIndexOf(data, key);

  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

/* harmony default export */ var _listCacheSet = (listCacheSet);

;// CONCATENATED MODULE: ./node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_ListCache.js






/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `ListCache`.
ListCache.prototype.clear = _listCacheClear;
ListCache.prototype['delete'] = _listCacheDelete;
ListCache.prototype.get = _listCacheGet;
ListCache.prototype.has = _listCacheHas;
ListCache.prototype.set = _listCacheSet;

/* harmony default export */ var _ListCache = (ListCache);


/***/ }),

/***/ 19385:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _getNative_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1311);
/* harmony import */ var _root_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(99615);



/* Built-in method references that are verified to be native. */
var Map = (0,_getNative_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_root_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, 'Map');

/* harmony default export */ __webpack_exports__["Z"] = (Map);


/***/ }),

/***/ 91380:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ _MapCache; }
});

// EXTERNAL MODULE: ./node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_getNative.js + 4 modules
var _getNative = __webpack_require__(1311);
;// CONCATENATED MODULE: ./node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_nativeCreate.js


/* Built-in method references that are verified to be native. */
var nativeCreate = (0,_getNative/* default */.Z)(Object, 'create');

/* harmony default export */ var _nativeCreate = (nativeCreate);

;// CONCATENATED MODULE: ./node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_hashClear.js


/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = _nativeCreate ? _nativeCreate(null) : {};
  this.size = 0;
}

/* harmony default export */ var _hashClear = (hashClear);

;// CONCATENATED MODULE: ./node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_hashDelete.js
/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}

/* harmony default export */ var _hashDelete = (hashDelete);

;// CONCATENATED MODULE: ./node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_hashGet.js


/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var _hashGet_hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (_nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return _hashGet_hasOwnProperty.call(data, key) ? data[key] : undefined;
}

/* harmony default export */ var _hashGet = (hashGet);

;// CONCATENATED MODULE: ./node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_hashHas.js


/** Used for built-in method references. */
var _hashHas_objectProto = Object.prototype;

/** Used to check objects for own properties. */
var _hashHas_hasOwnProperty = _hashHas_objectProto.hasOwnProperty;

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return _nativeCreate ? (data[key] !== undefined) : _hashHas_hasOwnProperty.call(data, key);
}

/* harmony default export */ var _hashHas = (hashHas);

;// CONCATENATED MODULE: ./node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_hashSet.js


/** Used to stand-in for `undefined` hash values. */
var _hashSet_HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = (_nativeCreate && value === undefined) ? _hashSet_HASH_UNDEFINED : value;
  return this;
}

/* harmony default export */ var _hashSet = (hashSet);

;// CONCATENATED MODULE: ./node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_Hash.js






/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `Hash`.
Hash.prototype.clear = _hashClear;
Hash.prototype['delete'] = _hashDelete;
Hash.prototype.get = _hashGet;
Hash.prototype.has = _hashHas;
Hash.prototype.set = _hashSet;

/* harmony default export */ var _Hash = (Hash);

// EXTERNAL MODULE: ./node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_ListCache.js + 6 modules
var _ListCache = __webpack_require__(11779);
// EXTERNAL MODULE: ./node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_Map.js
var _Map = __webpack_require__(19385);
;// CONCATENATED MODULE: ./node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_mapCacheClear.js




/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.size = 0;
  this.__data__ = {
    'hash': new _Hash,
    'map': new (_Map/* default */.Z || _ListCache/* default */.Z),
    'string': new _Hash
  };
}

/* harmony default export */ var _mapCacheClear = (mapCacheClear);

;// CONCATENATED MODULE: ./node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_isKeyable.js
/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

/* harmony default export */ var _isKeyable = (isKeyable);

;// CONCATENATED MODULE: ./node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_getMapData.js


/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return _isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

/* harmony default export */ var _getMapData = (getMapData);

;// CONCATENATED MODULE: ./node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_mapCacheDelete.js


/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  var result = _getMapData(this, key)['delete'](key);
  this.size -= result ? 1 : 0;
  return result;
}

/* harmony default export */ var _mapCacheDelete = (mapCacheDelete);

;// CONCATENATED MODULE: ./node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_mapCacheGet.js


/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return _getMapData(this, key).get(key);
}

/* harmony default export */ var _mapCacheGet = (mapCacheGet);

;// CONCATENATED MODULE: ./node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_mapCacheHas.js


/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return _getMapData(this, key).has(key);
}

/* harmony default export */ var _mapCacheHas = (mapCacheHas);

;// CONCATENATED MODULE: ./node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_mapCacheSet.js


/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  var data = _getMapData(this, key),
      size = data.size;

  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}

/* harmony default export */ var _mapCacheSet = (mapCacheSet);

;// CONCATENATED MODULE: ./node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_MapCache.js






/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `MapCache`.
MapCache.prototype.clear = _mapCacheClear;
MapCache.prototype['delete'] = _mapCacheDelete;
MapCache.prototype.get = _mapCacheGet;
MapCache.prototype.has = _mapCacheHas;
MapCache.prototype.set = _mapCacheSet;

/* harmony default export */ var _MapCache = (MapCache);


/***/ }),

/***/ 66711:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _root_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(99615);


/** Built-in value references. */
var Symbol = _root_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"].Symbol */ .Z.Symbol;

/* harmony default export */ __webpack_exports__["Z"] = (Symbol);


/***/ }),

/***/ 28019:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__) {

"use strict";
/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function arrayMap(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length,
      result = Array(length);

  while (++index < length) {
    result[index] = iteratee(array[index], index, array);
  }
  return result;
}

/* harmony default export */ __webpack_exports__["Z"] = (arrayMap);


/***/ }),

/***/ 18573:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__) {

"use strict";
/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */
function arrayPush(array, values) {
  var index = -1,
      length = values.length,
      offset = array.length;

  while (++index < length) {
    array[offset + index] = values[index];
  }
  return array;
}

/* harmony default export */ __webpack_exports__["Z"] = (arrayPush);


/***/ }),

/***/ 61572:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _baseAssignValue_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(857);
/* harmony import */ var _eq_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(54523);



/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignValue(object, key, value) {
  var objValue = object[key];
  if (!(hasOwnProperty.call(object, key) && (0,_eq_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(objValue, value)) ||
      (value === undefined && !(key in object))) {
    (0,_baseAssignValue_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(object, key, value);
  }
}

/* harmony default export */ __webpack_exports__["Z"] = (assignValue);


/***/ }),

/***/ 857:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(55136);


/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function baseAssignValue(object, key, value) {
  if (key == '__proto__' && _defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z) {
    (0,_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(object, key, {
      'configurable': true,
      'enumerable': true,
      'value': value,
      'writable': true
    });
  } else {
    object[key] = value;
  }
}

/* harmony default export */ __webpack_exports__["Z"] = (baseAssignValue);


/***/ }),

/***/ 84887:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ _baseFlatten; }
});

// EXTERNAL MODULE: ./node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_arrayPush.js
var _arrayPush = __webpack_require__(18573);
// EXTERNAL MODULE: ./node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_Symbol.js
var _Symbol = __webpack_require__(66711);
// EXTERNAL MODULE: ./node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/isArguments.js + 1 modules
var isArguments = __webpack_require__(65380);
// EXTERNAL MODULE: ./node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/isArray.js
var isArray = __webpack_require__(56052);
;// CONCATENATED MODULE: ./node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_isFlattenable.js




/** Built-in value references. */
var spreadableSymbol = _Symbol/* default */.Z ? _Symbol/* default.isConcatSpreadable */.Z.isConcatSpreadable : undefined;

/**
 * Checks if `value` is a flattenable `arguments` object or array.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
 */
function isFlattenable(value) {
  return (0,isArray/* default */.Z)(value) || (0,isArguments/* default */.Z)(value) ||
    !!(spreadableSymbol && value && value[spreadableSymbol]);
}

/* harmony default export */ var _isFlattenable = (isFlattenable);

;// CONCATENATED MODULE: ./node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_baseFlatten.js



/**
 * The base implementation of `_.flatten` with support for restricting flattening.
 *
 * @private
 * @param {Array} array The array to flatten.
 * @param {number} depth The maximum recursion depth.
 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
 * @param {Array} [result=[]] The initial result value.
 * @returns {Array} Returns the new flattened array.
 */
function baseFlatten(array, depth, predicate, isStrict, result) {
  var index = -1,
      length = array.length;

  predicate || (predicate = _isFlattenable);
  result || (result = []);

  while (++index < length) {
    var value = array[index];
    if (depth > 0 && predicate(value)) {
      if (depth > 1) {
        // Recursively flatten arrays (susceptible to call stack limits).
        baseFlatten(value, depth - 1, predicate, isStrict, result);
      } else {
        (0,_arrayPush/* default */.Z)(result, value);
      }
    } else if (!isStrict) {
      result[result.length] = value;
    }
  }
  return result;
}

/* harmony default export */ var _baseFlatten = (baseFlatten);


/***/ }),

/***/ 49084:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _castPath_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(99458);
/* harmony import */ var _toKey_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(13383);



/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */
function baseGet(object, path) {
  path = (0,_castPath_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(path, object);

  var index = 0,
      length = path.length;

  while (object != null && index < length) {
    object = object[(0,_toKey_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(path[index++])];
  }
  return (index && index == length) ? object : undefined;
}

/* harmony default export */ __webpack_exports__["Z"] = (baseGet);


/***/ }),

/***/ 33918:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ _baseGetTag; }
});

// EXTERNAL MODULE: ./node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_Symbol.js
var _Symbol = __webpack_require__(66711);
;// CONCATENATED MODULE: ./node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_getRawTag.js


/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var _getRawTag_hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = _Symbol/* default */.Z ? _Symbol/* default.toStringTag */.Z.toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = _getRawTag_hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

/* harmony default export */ var _getRawTag = (getRawTag);

;// CONCATENATED MODULE: ./node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_objectToString.js
/** Used for built-in method references. */
var _objectToString_objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var _objectToString_nativeObjectToString = _objectToString_objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return _objectToString_nativeObjectToString.call(value);
}

/* harmony default export */ var _objectToString = (objectToString);

;// CONCATENATED MODULE: ./node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_baseGetTag.js




/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var _baseGetTag_symToStringTag = _Symbol/* default */.Z ? _Symbol/* default.toStringTag */.Z.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (_baseGetTag_symToStringTag && _baseGetTag_symToStringTag in Object(value))
    ? _getRawTag(value)
    : _objectToString(value);
}

/* harmony default export */ var _baseGetTag = (baseGetTag);


/***/ }),

/***/ 88343:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ _baseKeys; }
});

// EXTERNAL MODULE: ./node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_isPrototype.js
var _isPrototype = __webpack_require__(5196);
// EXTERNAL MODULE: ./node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_overArg.js
var _overArg = __webpack_require__(45635);
;// CONCATENATED MODULE: ./node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_nativeKeys.js


/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys = (0,_overArg/* default */.Z)(Object.keys, Object);

/* harmony default export */ var _nativeKeys = (nativeKeys);

;// CONCATENATED MODULE: ./node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_baseKeys.js



/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var _baseKeys_hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!(0,_isPrototype/* default */.Z)(object)) {
    return _nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (_baseKeys_hasOwnProperty.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

/* harmony default export */ var _baseKeys = (baseKeys);


/***/ }),

/***/ 5467:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__) {

"use strict";
/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function baseUnary(func) {
  return function(value) {
    return func(value);
  };
}

/* harmony default export */ __webpack_exports__["Z"] = (baseUnary);


/***/ }),

/***/ 99458:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ _castPath; }
});

// EXTERNAL MODULE: ./node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/isArray.js
var isArray = __webpack_require__(56052);
// EXTERNAL MODULE: ./node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_isKey.js
var _isKey = __webpack_require__(61070);
// EXTERNAL MODULE: ./node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_MapCache.js + 14 modules
var _MapCache = __webpack_require__(91380);
;// CONCATENATED MODULE: ./node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/memoize.js


/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */
function memoize(func, resolver) {
  if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  var memoized = function() {
    var args = arguments,
        key = resolver ? resolver.apply(this, args) : args[0],
        cache = memoized.cache;

    if (cache.has(key)) {
      return cache.get(key);
    }
    var result = func.apply(this, args);
    memoized.cache = cache.set(key, result) || cache;
    return result;
  };
  memoized.cache = new (memoize.Cache || _MapCache/* default */.Z);
  return memoized;
}

// Expose `MapCache`.
memoize.Cache = _MapCache/* default */.Z;

/* harmony default export */ var lodash_es_memoize = (memoize);

;// CONCATENATED MODULE: ./node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_memoizeCapped.js


/** Used as the maximum memoize cache size. */
var MAX_MEMOIZE_SIZE = 500;

/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */
function memoizeCapped(func) {
  var result = lodash_es_memoize(func, function(key) {
    if (cache.size === MAX_MEMOIZE_SIZE) {
      cache.clear();
    }
    return key;
  });

  var cache = result.cache;
  return result;
}

/* harmony default export */ var _memoizeCapped = (memoizeCapped);

;// CONCATENATED MODULE: ./node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_stringToPath.js


/** Used to match property names within property paths. */
var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

/** Used to match backslashes in property paths. */
var reEscapeChar = /\\(\\)?/g;

/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */
var stringToPath = _memoizeCapped(function(string) {
  var result = [];
  if (string.charCodeAt(0) === 46 /* . */) {
    result.push('');
  }
  string.replace(rePropName, function(match, number, quote, subString) {
    result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
  });
  return result;
});

/* harmony default export */ var _stringToPath = (stringToPath);

// EXTERNAL MODULE: ./node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_Symbol.js
var _Symbol = __webpack_require__(66711);
// EXTERNAL MODULE: ./node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_arrayMap.js
var _arrayMap = __webpack_require__(28019);
// EXTERNAL MODULE: ./node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/isSymbol.js
var isSymbol = __webpack_require__(98111);
;// CONCATENATED MODULE: ./node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_baseToString.js





/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/** Used to convert symbols to primitives and strings. */
var symbolProto = _Symbol/* default */.Z ? _Symbol/* default.prototype */.Z.prototype : undefined,
    symbolToString = symbolProto ? symbolProto.toString : undefined;

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if ((0,isArray/* default */.Z)(value)) {
    // Recursively convert values (susceptible to call stack limits).
    return (0,_arrayMap/* default */.Z)(value, baseToString) + '';
  }
  if ((0,isSymbol/* default */.Z)(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

/* harmony default export */ var _baseToString = (baseToString);

;// CONCATENATED MODULE: ./node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/toString.js


/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString_toString(value) {
  return value == null ? '' : _baseToString(value);
}

/* harmony default export */ var lodash_es_toString = (toString_toString);

;// CONCATENATED MODULE: ./node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_castPath.js





/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */
function castPath(value, object) {
  if ((0,isArray/* default */.Z)(value)) {
    return value;
  }
  return (0,_isKey/* default */.Z)(value, object) ? [value] : _stringToPath(lodash_es_toString(value));
}

/* harmony default export */ var _castPath = (castPath);


/***/ }),

/***/ 55136:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _getNative_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1311);


var defineProperty = (function() {
  try {
    var func = (0,_getNative_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(Object, 'defineProperty');
    func({}, '', {});
    return func;
  } catch (e) {}
}());

/* harmony default export */ __webpack_exports__["Z"] = (defineProperty);


/***/ }),

/***/ 24982:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _flatten_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(23351);
/* harmony import */ var _overRest_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(38416);
/* harmony import */ var _setToString_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(80744);




/**
 * A specialized version of `baseRest` which flattens the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @returns {Function} Returns the new function.
 */
function flatRest(func) {
  return (0,_setToString_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)((0,_overRest_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(func, undefined, _flatten_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z), func + '');
}

/* harmony default export */ __webpack_exports__["Z"] = (flatRest);


/***/ }),

/***/ 97889:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__) {

"use strict";
/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/* harmony default export */ __webpack_exports__["Z"] = (freeGlobal);


/***/ }),

/***/ 1311:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ _getNative; }
});

// EXTERNAL MODULE: ./node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/isFunction.js
var isFunction = __webpack_require__(88987);
// EXTERNAL MODULE: ./node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_root.js
var _root = __webpack_require__(99615);
;// CONCATENATED MODULE: ./node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_coreJsData.js


/** Used to detect overreaching core-js shims. */
var coreJsData = _root/* default.__core-js_shared__ */.Z["__core-js_shared__"];

/* harmony default export */ var _coreJsData = (coreJsData);

;// CONCATENATED MODULE: ./node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_isMasked.js


/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(_coreJsData && _coreJsData.keys && _coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

/* harmony default export */ var _isMasked = (isMasked);

// EXTERNAL MODULE: ./node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/isObject.js
var isObject = __webpack_require__(82433);
// EXTERNAL MODULE: ./node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_toSource.js
var _toSource = __webpack_require__(65114);
;// CONCATENATED MODULE: ./node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_baseIsNative.js





/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var _baseIsNative_hasOwnProperty = objectProto.hasOwnProperty;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(_baseIsNative_hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!(0,isObject/* default */.Z)(value) || _isMasked(value)) {
    return false;
  }
  var pattern = (0,isFunction/* default */.Z)(value) ? reIsNative : reIsHostCtor;
  return pattern.test((0,_toSource/* default */.Z)(value));
}

/* harmony default export */ var _baseIsNative = (baseIsNative);

;// CONCATENATED MODULE: ./node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_getValue.js
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

/* harmony default export */ var _getValue = (getValue);

;// CONCATENATED MODULE: ./node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_getNative.js



/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = _getValue(object, key);
  return _baseIsNative(value) ? value : undefined;
}

/* harmony default export */ var _getNative = (getNative);


/***/ }),

/***/ 25922:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ _getTag; }
});

// EXTERNAL MODULE: ./node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_getNative.js + 4 modules
var _getNative = __webpack_require__(1311);
// EXTERNAL MODULE: ./node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_root.js
var _root = __webpack_require__(99615);
;// CONCATENATED MODULE: ./node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_DataView.js



/* Built-in method references that are verified to be native. */
var DataView = (0,_getNative/* default */.Z)(_root/* default */.Z, 'DataView');

/* harmony default export */ var _DataView = (DataView);

// EXTERNAL MODULE: ./node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_Map.js
var _Map = __webpack_require__(19385);
;// CONCATENATED MODULE: ./node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_Promise.js



/* Built-in method references that are verified to be native. */
var Promise = (0,_getNative/* default */.Z)(_root/* default */.Z, 'Promise');

/* harmony default export */ var _Promise = (Promise);

;// CONCATENATED MODULE: ./node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_Set.js



/* Built-in method references that are verified to be native. */
var Set = (0,_getNative/* default */.Z)(_root/* default */.Z, 'Set');

/* harmony default export */ var _Set = (Set);

;// CONCATENATED MODULE: ./node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_WeakMap.js



/* Built-in method references that are verified to be native. */
var WeakMap = (0,_getNative/* default */.Z)(_root/* default */.Z, 'WeakMap');

/* harmony default export */ var _WeakMap = (WeakMap);

// EXTERNAL MODULE: ./node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_baseGetTag.js + 2 modules
var _baseGetTag = __webpack_require__(33918);
// EXTERNAL MODULE: ./node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_toSource.js
var _toSource = __webpack_require__(65114);
;// CONCATENATED MODULE: ./node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_getTag.js








/** `Object#toString` result references. */
var mapTag = '[object Map]',
    objectTag = '[object Object]',
    promiseTag = '[object Promise]',
    setTag = '[object Set]',
    weakMapTag = '[object WeakMap]';

var dataViewTag = '[object DataView]';

/** Used to detect maps, sets, and weakmaps. */
var dataViewCtorString = (0,_toSource/* default */.Z)(_DataView),
    mapCtorString = (0,_toSource/* default */.Z)(_Map/* default */.Z),
    promiseCtorString = (0,_toSource/* default */.Z)(_Promise),
    setCtorString = (0,_toSource/* default */.Z)(_Set),
    weakMapCtorString = (0,_toSource/* default */.Z)(_WeakMap);

/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
var getTag = _baseGetTag/* default */.Z;

// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ((_DataView && getTag(new _DataView(new ArrayBuffer(1))) != dataViewTag) ||
    (_Map/* default */.Z && getTag(new _Map/* default */.Z) != mapTag) ||
    (_Promise && getTag(_Promise.resolve()) != promiseTag) ||
    (_Set && getTag(new _Set) != setTag) ||
    (_WeakMap && getTag(new _WeakMap) != weakMapTag)) {
  getTag = function(value) {
    var result = (0,_baseGetTag/* default */.Z)(value),
        Ctor = result == objectTag ? value.constructor : undefined,
        ctorString = Ctor ? (0,_toSource/* default */.Z)(Ctor) : '';

    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString: return dataViewTag;
        case mapCtorString: return mapTag;
        case promiseCtorString: return promiseTag;
        case setCtorString: return setTag;
        case weakMapCtorString: return weakMapTag;
      }
    }
    return result;
  };
}

/* harmony default export */ var _getTag = (getTag);


/***/ }),

/***/ 99313:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__) {

"use strict";
/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  var type = typeof value;
  length = length == null ? MAX_SAFE_INTEGER : length;

  return !!length &&
    (type == 'number' ||
      (type != 'symbol' && reIsUint.test(value))) &&
        (value > -1 && value % 1 == 0 && value < length);
}

/* harmony default export */ __webpack_exports__["Z"] = (isIndex);


/***/ }),

/***/ 61070:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _isArray_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(56052);
/* harmony import */ var _isSymbol_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(98111);



/** Used to match property names within property paths. */
var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
    reIsPlainProp = /^\w*$/;

/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */
function isKey(value, object) {
  if ((0,_isArray_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(value)) {
    return false;
  }
  var type = typeof value;
  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
      value == null || (0,_isSymbol_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(value)) {
    return true;
  }
  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
    (object != null && value in Object(object));
}

/* harmony default export */ __webpack_exports__["Z"] = (isKey);


/***/ }),

/***/ 5196:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__) {

"use strict";
/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

/* harmony default export */ __webpack_exports__["Z"] = (isPrototype);


/***/ }),

/***/ 92350:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _freeGlobal_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(97889);


/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Detect free variable `process` from Node.js. */
var freeProcess = moduleExports && _freeGlobal_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"].process */ .Z.process;

/** Used to access faster Node.js helpers. */
var nodeUtil = (function() {
  try {
    // Use `util.types` for Node.js 10+.
    var types = freeModule && freeModule.require && freeModule.require('util').types;

    if (types) {
      return types;
    }

    // Legacy `process.binding('util')` for Node.js < 10.
    return freeProcess && freeProcess.binding && freeProcess.binding('util');
  } catch (e) {}
}());

/* harmony default export */ __webpack_exports__["Z"] = (nodeUtil);


/***/ }),

/***/ 45635:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__) {

"use strict";
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

/* harmony default export */ __webpack_exports__["Z"] = (overArg);


/***/ }),

/***/ 38416:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ _overRest; }
});

;// CONCATENATED MODULE: ./node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_apply.js
/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */
function apply(func, thisArg, args) {
  switch (args.length) {
    case 0: return func.call(thisArg);
    case 1: return func.call(thisArg, args[0]);
    case 2: return func.call(thisArg, args[0], args[1]);
    case 3: return func.call(thisArg, args[0], args[1], args[2]);
  }
  return func.apply(thisArg, args);
}

/* harmony default export */ var _apply = (apply);

;// CONCATENATED MODULE: ./node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_overRest.js


/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */
function overRest(func, start, transform) {
  start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
  return function() {
    var args = arguments,
        index = -1,
        length = nativeMax(args.length - start, 0),
        array = Array(length);

    while (++index < length) {
      array[index] = args[start + index];
    }
    index = -1;
    var otherArgs = Array(start + 1);
    while (++index < start) {
      otherArgs[index] = args[index];
    }
    otherArgs[start] = transform(array);
    return _apply(func, this, otherArgs);
  };
}

/* harmony default export */ var _overRest = (overRest);


/***/ }),

/***/ 99615:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _freeGlobal_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(97889);


/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = _freeGlobal_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z || freeSelf || Function('return this')();

/* harmony default export */ __webpack_exports__["Z"] = (root);


/***/ }),

/***/ 80744:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ _setToString; }
});

;// CONCATENATED MODULE: ./node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/constant.js
/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */
function constant(value) {
  return function() {
    return value;
  };
}

/* harmony default export */ var lodash_es_constant = (constant);

// EXTERNAL MODULE: ./node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_defineProperty.js
var _defineProperty = __webpack_require__(55136);
// EXTERNAL MODULE: ./node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/identity.js
var identity = __webpack_require__(76402);
;// CONCATENATED MODULE: ./node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_baseSetToString.js




/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var baseSetToString = !_defineProperty/* default */.Z ? identity/* default */.Z : function(func, string) {
  return (0,_defineProperty/* default */.Z)(func, 'toString', {
    'configurable': true,
    'enumerable': false,
    'value': lodash_es_constant(string),
    'writable': true
  });
};

/* harmony default export */ var _baseSetToString = (baseSetToString);

;// CONCATENATED MODULE: ./node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_shortOut.js
/** Used to detect hot functions by number of calls within a span of milliseconds. */
var HOT_COUNT = 800,
    HOT_SPAN = 16;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeNow = Date.now;

/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */
function shortOut(func) {
  var count = 0,
      lastCalled = 0;

  return function() {
    var stamp = nativeNow(),
        remaining = HOT_SPAN - (stamp - lastCalled);

    lastCalled = stamp;
    if (remaining > 0) {
      if (++count >= HOT_COUNT) {
        return arguments[0];
      }
    } else {
      count = 0;
    }
    return func.apply(undefined, arguments);
  };
}

/* harmony default export */ var _shortOut = (shortOut);

;// CONCATENATED MODULE: ./node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_setToString.js



/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var setToString = _shortOut(_baseSetToString);

/* harmony default export */ var _setToString = (setToString);


/***/ }),

/***/ 13383:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _isSymbol_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(98111);


/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */
function toKey(value) {
  if (typeof value == 'string' || (0,_isSymbol_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(value)) {
    return value;
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

/* harmony default export */ __webpack_exports__["Z"] = (toKey);


/***/ }),

/***/ 65114:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__) {

"use strict";
/** Used for built-in method references. */
var funcProto = Function.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

/* harmony default export */ __webpack_exports__["Z"] = (toSource);


/***/ }),

/***/ 54523:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__) {

"use strict";
/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

/* harmony default export */ __webpack_exports__["Z"] = (eq);


/***/ }),

/***/ 23351:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _baseFlatten_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(84887);


/**
 * Flattens `array` a single level deep.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to flatten.
 * @returns {Array} Returns the new flattened array.
 * @example
 *
 * _.flatten([1, [2, [3, [4]], 5]]);
 * // => [1, 2, [3, [4]], 5]
 */
function flatten(array) {
  var length = array == null ? 0 : array.length;
  return length ? (0,_baseFlatten_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(array, 1) : [];
}

/* harmony default export */ __webpack_exports__["Z"] = (flatten);


/***/ }),

/***/ 90177:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ lodash_es_hasIn; }
});

;// CONCATENATED MODULE: ./node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_baseHasIn.js
/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */
function baseHasIn(object, key) {
  return object != null && key in Object(object);
}

/* harmony default export */ var _baseHasIn = (baseHasIn);

// EXTERNAL MODULE: ./node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_castPath.js + 5 modules
var _castPath = __webpack_require__(99458);
// EXTERNAL MODULE: ./node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/isArguments.js + 1 modules
var isArguments = __webpack_require__(65380);
// EXTERNAL MODULE: ./node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/isArray.js
var isArray = __webpack_require__(56052);
// EXTERNAL MODULE: ./node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_isIndex.js
var _isIndex = __webpack_require__(99313);
// EXTERNAL MODULE: ./node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/isLength.js
var isLength = __webpack_require__(65743);
// EXTERNAL MODULE: ./node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_toKey.js
var _toKey = __webpack_require__(13383);
;// CONCATENATED MODULE: ./node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_hasPath.js







/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */
function hasPath(object, path, hasFunc) {
  path = (0,_castPath/* default */.Z)(path, object);

  var index = -1,
      length = path.length,
      result = false;

  while (++index < length) {
    var key = (0,_toKey/* default */.Z)(path[index]);
    if (!(result = object != null && hasFunc(object, key))) {
      break;
    }
    object = object[key];
  }
  if (result || ++index != length) {
    return result;
  }
  length = object == null ? 0 : object.length;
  return !!length && (0,isLength/* default */.Z)(length) && (0,_isIndex/* default */.Z)(key, length) &&
    ((0,isArray/* default */.Z)(object) || (0,isArguments/* default */.Z)(object));
}

/* harmony default export */ var _hasPath = (hasPath);

;// CONCATENATED MODULE: ./node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/hasIn.js



/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */
function hasIn(object, path) {
  return object != null && _hasPath(object, path, _baseHasIn);
}

/* harmony default export */ var lodash_es_hasIn = (hasIn);


/***/ }),

/***/ 76402:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__) {

"use strict";
/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function identity(value) {
  return value;
}

/* harmony default export */ __webpack_exports__["Z"] = (identity);


/***/ }),

/***/ 65380:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ lodash_es_isArguments; }
});

// EXTERNAL MODULE: ./node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_baseGetTag.js + 2 modules
var _baseGetTag = __webpack_require__(33918);
// EXTERNAL MODULE: ./node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/isObjectLike.js
var isObjectLike = __webpack_require__(13795);
;// CONCATENATED MODULE: ./node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_baseIsArguments.js



/** `Object#toString` result references. */
var argsTag = '[object Arguments]';

/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */
function baseIsArguments(value) {
  return (0,isObjectLike/* default */.Z)(value) && (0,_baseGetTag/* default */.Z)(value) == argsTag;
}

/* harmony default export */ var _baseIsArguments = (baseIsArguments);

;// CONCATENATED MODULE: ./node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/isArguments.js



/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var isArguments_hasOwnProperty = objectProto.hasOwnProperty;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
var isArguments = _baseIsArguments(function() { return arguments; }()) ? _baseIsArguments : function(value) {
  return (0,isObjectLike/* default */.Z)(value) && isArguments_hasOwnProperty.call(value, 'callee') &&
    !propertyIsEnumerable.call(value, 'callee');
};

/* harmony default export */ var lodash_es_isArguments = (isArguments);


/***/ }),

/***/ 56052:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__) {

"use strict";
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

/* harmony default export */ __webpack_exports__["Z"] = (isArray);


/***/ }),

/***/ 49634:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _isFunction_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(88987);
/* harmony import */ var _isLength_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(65743);



/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && (0,_isLength_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(value.length) && !(0,_isFunction_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(value);
}

/* harmony default export */ __webpack_exports__["Z"] = (isArrayLike);


/***/ }),

/***/ 45673:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ lodash_es_isBuffer; }
});

// EXTERNAL MODULE: ./node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_root.js
var _root = __webpack_require__(99615);
;// CONCATENATED MODULE: ./node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/stubFalse.js
/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

/* harmony default export */ var lodash_es_stubFalse = (stubFalse);

;// CONCATENATED MODULE: ./node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/isBuffer.js



/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? _root/* default.Buffer */.Z.Buffer : undefined;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;

/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */
var isBuffer = nativeIsBuffer || lodash_es_stubFalse;

/* harmony default export */ var lodash_es_isBuffer = (isBuffer);


/***/ }),

/***/ 88987:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _baseGetTag_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(33918);
/* harmony import */ var _isObject_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(82433);



/** `Object#toString` result references. */
var asyncTag = '[object AsyncFunction]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    proxyTag = '[object Proxy]';

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  if (!(0,_isObject_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = (0,_baseGetTag_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(value);
  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}

/* harmony default export */ __webpack_exports__["Z"] = (isFunction);


/***/ }),

/***/ 65743:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__) {

"use strict";
/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

/* harmony default export */ __webpack_exports__["Z"] = (isLength);


/***/ }),

/***/ 82433:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__) {

"use strict";
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

/* harmony default export */ __webpack_exports__["Z"] = (isObject);


/***/ }),

/***/ 13795:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__) {

"use strict";
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

/* harmony default export */ __webpack_exports__["Z"] = (isObjectLike);


/***/ }),

/***/ 98111:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _baseGetTag_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(33918);
/* harmony import */ var _isObjectLike_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(13795);



/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    ((0,_isObjectLike_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(value) && (0,_baseGetTag_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(value) == symbolTag);
}

/* harmony default export */ __webpack_exports__["Z"] = (isSymbol);


/***/ }),

/***/ 79064:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ lodash_es_isTypedArray; }
});

// EXTERNAL MODULE: ./node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_baseGetTag.js + 2 modules
var _baseGetTag = __webpack_require__(33918);
// EXTERNAL MODULE: ./node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/isLength.js
var isLength = __webpack_require__(65743);
// EXTERNAL MODULE: ./node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/isObjectLike.js
var isObjectLike = __webpack_require__(13795);
;// CONCATENATED MODULE: ./node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_baseIsTypedArray.js




/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
typedArrayTags[errorTag] = typedArrayTags[funcTag] =
typedArrayTags[mapTag] = typedArrayTags[numberTag] =
typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
typedArrayTags[setTag] = typedArrayTags[stringTag] =
typedArrayTags[weakMapTag] = false;

/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */
function baseIsTypedArray(value) {
  return (0,isObjectLike/* default */.Z)(value) &&
    (0,isLength/* default */.Z)(value.length) && !!typedArrayTags[(0,_baseGetTag/* default */.Z)(value)];
}

/* harmony default export */ var _baseIsTypedArray = (baseIsTypedArray);

// EXTERNAL MODULE: ./node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_baseUnary.js
var _baseUnary = __webpack_require__(5467);
// EXTERNAL MODULE: ./node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_nodeUtil.js
var _nodeUtil = __webpack_require__(92350);
;// CONCATENATED MODULE: ./node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/isTypedArray.js




/* Node.js helper references. */
var nodeIsTypedArray = _nodeUtil/* default */.Z && _nodeUtil/* default.isTypedArray */.Z.isTypedArray;

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
var isTypedArray = nodeIsTypedArray ? (0,_baseUnary/* default */.Z)(nodeIsTypedArray) : _baseIsTypedArray;

/* harmony default export */ var lodash_es_isTypedArray = (isTypedArray);


/***/ }),

/***/ 93982:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _arrayLikeToArray; }
/* harmony export */ });
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

/***/ }),

/***/ 87855:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _assertThisInitialized; }
/* harmony export */ });
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

/***/ }),

/***/ 6325:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _asyncToGenerator; }
/* harmony export */ });
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

/***/ }),

/***/ 66677:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _classCallCheck; }
/* harmony export */ });
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

/***/ }),

/***/ 48849:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _createClass; }
/* harmony export */ });
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

/***/ }),

/***/ 88756:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _defineProperty; }
/* harmony export */ });
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

/***/ }),

/***/ 11430:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _getPrototypeOf; }
/* harmony export */ });
function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

/***/ }),

/***/ 87646:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _inherits; }
/* harmony export */ });
/* harmony import */ var _setPrototypeOf_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(53111);

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) (0,_setPrototypeOf_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(subClass, superClass);
}

/***/ }),

/***/ 85922:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ _objectWithoutProperties; }
});

;// CONCATENATED MODULE: ./node_modules/.pnpm/next@12.3.4_@babel+core@7.26.0_react-dom@18.3.1_react@18.3.1_sass@1.80.4/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}
;// CONCATENATED MODULE: ./node_modules/.pnpm/next@12.3.4_@babel+core@7.26.0_react-dom@18.3.1_react@18.3.1_sass@1.80.4/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

/***/ }),

/***/ 77290:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _possibleConstructorReturn; }
/* harmony export */ });
/* harmony import */ var next_dist_compiled_babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(39909);
/* harmony import */ var _assertThisInitialized_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(87855);


function _possibleConstructorReturn(self, call) {
  if (call && (next_dist_compiled_babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_0__(call) === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }

  return (0,_assertThisInitialized_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(self);
}

/***/ }),

/***/ 53111:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _setPrototypeOf; }
/* harmony export */ });
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

/***/ }),

/***/ 46003:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ _slicedToArray; }
});

;// CONCATENATED MODULE: ./node_modules/.pnpm/next@12.3.4_@babel+core@7.26.0_react-dom@18.3.1_react@18.3.1_sass@1.80.4/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/arrayWithHoles.js
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}
;// CONCATENATED MODULE: ./node_modules/.pnpm/next@12.3.4_@babel+core@7.26.0_react-dom@18.3.1_react@18.3.1_sass@1.80.4/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/iterableToArrayLimit.js
function _iterableToArrayLimit(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];

  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;

  var _s, _e;

  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}
// EXTERNAL MODULE: ./node_modules/.pnpm/next@12.3.4_@babel+core@7.26.0_react-dom@18.3.1_react@18.3.1_sass@1.80.4/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/unsupportedIterableToArray.js
var unsupportedIterableToArray = __webpack_require__(31866);
;// CONCATENATED MODULE: ./node_modules/.pnpm/next@12.3.4_@babel+core@7.26.0_react-dom@18.3.1_react@18.3.1_sass@1.80.4/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/nonIterableRest.js
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
;// CONCATENATED MODULE: ./node_modules/.pnpm/next@12.3.4_@babel+core@7.26.0_react-dom@18.3.1_react@18.3.1_sass@1.80.4/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js




function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || (0,unsupportedIterableToArray/* default */.Z)(arr, i) || _nonIterableRest();
}

/***/ }),

/***/ 37555:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ _toConsumableArray; }
});

// EXTERNAL MODULE: ./node_modules/.pnpm/next@12.3.4_@babel+core@7.26.0_react-dom@18.3.1_react@18.3.1_sass@1.80.4/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/arrayLikeToArray.js
var arrayLikeToArray = __webpack_require__(93982);
;// CONCATENATED MODULE: ./node_modules/.pnpm/next@12.3.4_@babel+core@7.26.0_react-dom@18.3.1_react@18.3.1_sass@1.80.4/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/arrayWithoutHoles.js

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return (0,arrayLikeToArray/* default */.Z)(arr);
}
;// CONCATENATED MODULE: ./node_modules/.pnpm/next@12.3.4_@babel+core@7.26.0_react-dom@18.3.1_react@18.3.1_sass@1.80.4/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/iterableToArray.js
function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
// EXTERNAL MODULE: ./node_modules/.pnpm/next@12.3.4_@babel+core@7.26.0_react-dom@18.3.1_react@18.3.1_sass@1.80.4/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/unsupportedIterableToArray.js
var unsupportedIterableToArray = __webpack_require__(31866);
;// CONCATENATED MODULE: ./node_modules/.pnpm/next@12.3.4_@babel+core@7.26.0_react-dom@18.3.1_react@18.3.1_sass@1.80.4/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/nonIterableSpread.js
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
;// CONCATENATED MODULE: ./node_modules/.pnpm/next@12.3.4_@babel+core@7.26.0_react-dom@18.3.1_react@18.3.1_sass@1.80.4/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js




function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || (0,unsupportedIterableToArray/* default */.Z)(arr) || _nonIterableSpread();
}

/***/ }),

/***/ 31866:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _unsupportedIterableToArray; }
/* harmony export */ });
/* harmony import */ var _arrayLikeToArray_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93982);

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return (0,_arrayLikeToArray_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return (0,_arrayLikeToArray_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(o, minLen);
}

/***/ }),

/***/ 75182:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "J$": function() { return /* binding */ SWRConfig; },
/* harmony export */   "ZP": function() { return /* binding */ useSWR; }
/* harmony export */ });
/* unused harmony exports mutate, unstable_serialize, useSWRConfig */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(75271);


/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

var noop = function () { };
// Using noop() as the undefined value as undefined can possibly be replaced
// by something else.  Prettier ignore and extra parentheses are necessary here
// to ensure that tsc doesn't remove the __NOINLINE__ comment.
// prettier-ignore
var UNDEFINED = ( /*#__NOINLINE__*/noop());
var OBJECT = Object;
var isUndefined = function (v) { return v === UNDEFINED; };
var isFunction = function (v) { return typeof v == 'function'; };
var mergeObjects = function (a, b) { return OBJECT.assign({}, a, b); };
var STR_UNDEFINED = 'undefined';
// NOTE: Use function to guarantee it's re-evaluated between jsdom and node runtime for tests.
var hasWindow = function () { return typeof window != STR_UNDEFINED; };
var hasDocument = function () { return typeof document != STR_UNDEFINED; };
var hasRequestAnimationFrame = function () {
    return hasWindow() && typeof window['requestAnimationFrame'] != STR_UNDEFINED;
};

// use WeakMap to store the object->key mapping
// so the objects can be garbage collected.
// WeakMap uses a hashtable under the hood, so the lookup
// complexity is almost O(1).
var table = new WeakMap();
// counter of the key
var counter = 0;
// A stable hash implementation that supports:
// - Fast and ensures unique hash properties
// - Handles unserializable values
// - Handles object key ordering
// - Generates short results
//
// This is not a serialization function, and the result is not guaranteed to be
// parsible.
var stableHash = function (arg) {
    var type = typeof arg;
    var constructor = arg && arg.constructor;
    var isDate = constructor == Date;
    var result;
    var index;
    if (OBJECT(arg) === arg && !isDate && constructor != RegExp) {
        // Object/function, not null/date/regexp. Use WeakMap to store the id first.
        // If it's already hashed, directly return the result.
        result = table.get(arg);
        if (result)
            return result;
        // Store the hash first for circular reference detection before entering the
        // recursive `stableHash` calls.
        // For other objects like set and map, we use this id directly as the hash.
        result = ++counter + '~';
        table.set(arg, result);
        if (constructor == Array) {
            // Array.
            result = '@';
            for (index = 0; index < arg.length; index++) {
                result += stableHash(arg[index]) + ',';
            }
            table.set(arg, result);
        }
        if (constructor == OBJECT) {
            // Object, sort keys.
            result = '#';
            var keys = OBJECT.keys(arg).sort();
            while (!isUndefined((index = keys.pop()))) {
                if (!isUndefined(arg[index])) {
                    result += index + ':' + stableHash(arg[index]) + ',';
                }
            }
            table.set(arg, result);
        }
    }
    else {
        result = isDate
            ? arg.toJSON()
            : type == 'symbol'
                ? arg.toString()
                : type == 'string'
                    ? JSON.stringify(arg)
                    : '' + arg;
    }
    return result;
};

/**
 * Due to bug https://bugs.chromium.org/p/chromium/issues/detail?id=678075,
 * it's not reliable to detect if the browser is currently online or offline
 * based on `navigator.onLine`.
 * As a work around, we always assume it's online on first load, and change
 * the status upon `online` or `offline` events.
 */
var online = true;
var isOnline = function () { return online; };
var hasWin = hasWindow();
var hasDoc = hasDocument();
// For node and React Native, `add/removeEventListener` doesn't exist on window.
var onWindowEvent = hasWin && window.addEventListener
    ? window.addEventListener.bind(window)
    : noop;
var onDocumentEvent = hasDoc ? document.addEventListener.bind(document) : noop;
var offWindowEvent = hasWin && window.removeEventListener
    ? window.removeEventListener.bind(window)
    : noop;
var offDocumentEvent = hasDoc
    ? document.removeEventListener.bind(document)
    : noop;
var isVisible = function () {
    var visibilityState = hasDoc && document.visibilityState;
    return isUndefined(visibilityState) || visibilityState !== 'hidden';
};
var initFocus = function (callback) {
    // focus revalidate
    onDocumentEvent('visibilitychange', callback);
    onWindowEvent('focus', callback);
    return function () {
        offDocumentEvent('visibilitychange', callback);
        offWindowEvent('focus', callback);
    };
};
var initReconnect = function (callback) {
    // revalidate on reconnected
    var onOnline = function () {
        online = true;
        callback();
    };
    // nothing to revalidate, just update the status
    var onOffline = function () {
        online = false;
    };
    onWindowEvent('online', onOnline);
    onWindowEvent('offline', onOffline);
    return function () {
        offWindowEvent('online', onOnline);
        offWindowEvent('offline', onOffline);
    };
};
var preset = {
    isOnline: isOnline,
    isVisible: isVisible
};
var defaultConfigOptions = {
    initFocus: initFocus,
    initReconnect: initReconnect
};

var IS_SERVER = !hasWindow() || 'Deno' in window;
// Polyfill requestAnimationFrame
var rAF = function (f) {
    return hasRequestAnimationFrame() ? window['requestAnimationFrame'](f) : setTimeout(f, 1);
};
// React currently throws a warning when using useLayoutEffect on the server.
// To get around it, we can conditionally useEffect on the server (no-op) and
// useLayoutEffect in the browser.
var useIsomorphicLayoutEffect = IS_SERVER ? react__WEBPACK_IMPORTED_MODULE_0__.useEffect : react__WEBPACK_IMPORTED_MODULE_0__.useLayoutEffect;
// This assignment is to extend the Navigator type to use effectiveType.
var navigatorConnection = typeof navigator !== 'undefined' &&
    navigator.connection;
// Adjust the config based on slow connection status (<= 70Kbps).
var slowConnection = !IS_SERVER &&
    navigatorConnection &&
    (['slow-2g', '2g'].includes(navigatorConnection.effectiveType) ||
        navigatorConnection.saveData);

var serialize = function (key) {
    if (isFunction(key)) {
        try {
            key = key();
        }
        catch (err) {
            // dependencies not ready
            key = '';
        }
    }
    var args = [].concat(key);
    // If key is not falsy, or not an empty array, hash it.
    key =
        typeof key == 'string'
            ? key
            : (Array.isArray(key) ? key.length : key)
                ? stableHash(key)
                : '';
    var infoKey = key ? '$swr$' + key : '';
    return [key, args, infoKey];
};

// Global state used to deduplicate requests and store listeners
var SWRGlobalState = new WeakMap();

var FOCUS_EVENT = 0;
var RECONNECT_EVENT = 1;
var MUTATE_EVENT = 2;

var broadcastState = function (cache, key, data, error, isValidating, revalidate, broadcast) {
    if (broadcast === void 0) { broadcast = true; }
    var _a = SWRGlobalState.get(cache), EVENT_REVALIDATORS = _a[0], STATE_UPDATERS = _a[1], FETCH = _a[3];
    var revalidators = EVENT_REVALIDATORS[key];
    var updaters = STATE_UPDATERS[key];
    // Cache was populated, update states of all hooks.
    if (broadcast && updaters) {
        for (var i = 0; i < updaters.length; ++i) {
            updaters[i](data, error, isValidating);
        }
    }
    // If we also need to revalidate, only do it for the first hook.
    if (revalidate) {
        // Invalidate the key by deleting the concurrent request markers so new
        // requests will not be deduped.
        delete FETCH[key];
        if (revalidators && revalidators[0]) {
            return revalidators[0](MUTATE_EVENT).then(function () {
                return cache.get(key);
            });
        }
    }
    return cache.get(key);
};

// Global timestamp.
var __timestamp = 0;
var getTimestamp = function () { return ++__timestamp; };

var internalMutate = function () {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    return __awaiter(void 0, void 0, void 0, function () {
        var cache, _key, _data, _opts, options, populateCache, revalidate, rollbackOnError, customOptimisticData, _a, key, keyInfo, _b, MUTATION, data, error, beforeMutationTs, hasCustomOptimisticData, rollbackData, optimisticData, res;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    cache = args[0], _key = args[1], _data = args[2], _opts = args[3];
                    options = typeof _opts === 'boolean' ? { revalidate: _opts } : _opts || {};
                    populateCache = isUndefined(options.populateCache)
                        ? true
                        : options.populateCache;
                    revalidate = options.revalidate !== false;
                    rollbackOnError = options.rollbackOnError !== false;
                    customOptimisticData = options.optimisticData;
                    _a = serialize(_key), key = _a[0], keyInfo = _a[2];
                    if (!key)
                        return [2 /*return*/];
                    _b = SWRGlobalState.get(cache), MUTATION = _b[2];
                    // If there is no new data provided, revalidate the key with current state.
                    if (args.length < 3) {
                        // Revalidate and broadcast state.
                        return [2 /*return*/, broadcastState(cache, key, cache.get(key), UNDEFINED, UNDEFINED, revalidate, true)];
                    }
                    data = _data;
                    beforeMutationTs = getTimestamp();
                    MUTATION[key] = [beforeMutationTs, 0];
                    hasCustomOptimisticData = !isUndefined(customOptimisticData);
                    rollbackData = cache.get(key);
                    // Do optimistic data update.
                    if (hasCustomOptimisticData) {
                        optimisticData = isFunction(customOptimisticData)
                            ? customOptimisticData(rollbackData)
                            : customOptimisticData;
                        cache.set(key, optimisticData);
                        broadcastState(cache, key, optimisticData);
                    }
                    if (isFunction(data)) {
                        // `data` is a function, call it passing current cache value.
                        try {
                            data = data(cache.get(key));
                        }
                        catch (err) {
                            // If it throws an error synchronously, we shouldn't update the cache.
                            error = err;
                        }
                    }
                    if (!(data && isFunction(data.then))) return [3 /*break*/, 2];
                    return [4 /*yield*/, data.catch(function (err) {
                            error = err;
                        })
                        // Check if other mutations have occurred since we've started this mutation.
                        // If there's a race we don't update cache or broadcast the change,
                        // just return the data.
                    ];
                case 1:
                    // This means that the mutation is async, we need to check timestamps to
                    // avoid race conditions.
                    data = _c.sent();
                    // Check if other mutations have occurred since we've started this mutation.
                    // If there's a race we don't update cache or broadcast the change,
                    // just return the data.
                    if (beforeMutationTs !== MUTATION[key][0]) {
                        if (error)
                            throw error;
                        return [2 /*return*/, data];
                    }
                    else if (error && hasCustomOptimisticData && rollbackOnError) {
                        // Rollback. Always populate the cache in this case but without
                        // transforming the data.
                        populateCache = true;
                        data = rollbackData;
                        cache.set(key, rollbackData);
                    }
                    _c.label = 2;
                case 2:
                    // If we should write back the cache after request.
                    if (populateCache) {
                        if (!error) {
                            // Transform the result into data.
                            if (isFunction(populateCache)) {
                                data = populateCache(data, rollbackData);
                            }
                            // Only update cached data if there's no error. Data can be `undefined` here.
                            cache.set(key, data);
                        }
                        // Always update or reset the error.
                        cache.set(keyInfo, mergeObjects(cache.get(keyInfo), { error: error }));
                    }
                    // Reset the timestamp to mark the mutation has ended.
                    MUTATION[key][1] = getTimestamp();
                    return [4 /*yield*/, broadcastState(cache, key, data, error, UNDEFINED, revalidate, !!populateCache)
                        // Throw error or return data
                    ];
                case 3:
                    res = _c.sent();
                    // Throw error or return data
                    if (error)
                        throw error;
                    return [2 /*return*/, populateCache ? res : data];
            }
        });
    });
};

var revalidateAllKeys = function (revalidators, type) {
    for (var key in revalidators) {
        if (revalidators[key][0])
            revalidators[key][0](type);
    }
};
var initCache = function (provider, options) {
    // The global state for a specific provider will be used to deduplicate
    // requests and store listeners. As well as a mutate function that bound to
    // the cache.
    // Provider's global state might be already initialized. Let's try to get the
    // global state associated with the provider first.
    if (!SWRGlobalState.has(provider)) {
        var opts = mergeObjects(defaultConfigOptions, options);
        // If there's no global state bound to the provider, create a new one with the
        // new mutate function.
        var EVENT_REVALIDATORS = {};
        var mutate = internalMutate.bind(UNDEFINED, provider);
        var unmount = noop;
        // Update the state if it's new, or the provider has been extended.
        SWRGlobalState.set(provider, [EVENT_REVALIDATORS, {}, {}, {}, mutate]);
        // This is a new provider, we need to initialize it and setup DOM events
        // listeners for `focus` and `reconnect` actions.
        if (!IS_SERVER) {
            // When listening to the native events for auto revalidations,
            // we intentionally put a delay (setTimeout) here to make sure they are
            // fired after immediate JavaScript executions, which can possibly be
            // React's state updates.
            // This avoids some unnecessary revalidations such as
            // https://github.com/vercel/swr/issues/1680.
            var releaseFocus_1 = opts.initFocus(setTimeout.bind(UNDEFINED, revalidateAllKeys.bind(UNDEFINED, EVENT_REVALIDATORS, FOCUS_EVENT)));
            var releaseReconnect_1 = opts.initReconnect(setTimeout.bind(UNDEFINED, revalidateAllKeys.bind(UNDEFINED, EVENT_REVALIDATORS, RECONNECT_EVENT)));
            unmount = function () {
                releaseFocus_1 && releaseFocus_1();
                releaseReconnect_1 && releaseReconnect_1();
                // When un-mounting, we need to remove the cache provider from the state
                // storage too because it's a side-effect. Otherwise when re-mounting we
                // will not re-register those event listeners.
                SWRGlobalState.delete(provider);
            };
        }
        // We might want to inject an extra layer on top of `provider` in the future,
        // such as key serialization, auto GC, etc.
        // For now, it's just a `Map` interface without any modifications.
        return [provider, mutate, unmount];
    }
    return [provider, SWRGlobalState.get(provider)[4]];
};

// error retry
var onErrorRetry = function (_, __, config, revalidate, opts) {
    var maxRetryCount = config.errorRetryCount;
    var currentRetryCount = opts.retryCount;
    // Exponential backoff
    var timeout = ~~((Math.random() + 0.5) *
        (1 << (currentRetryCount < 8 ? currentRetryCount : 8))) * config.errorRetryInterval;
    if (!isUndefined(maxRetryCount) && currentRetryCount > maxRetryCount) {
        return;
    }
    setTimeout(revalidate, timeout, opts);
};
// Default cache provider
var _a = initCache(new Map()), cache = _a[0], mutate = _a[1];
// Default config
var defaultConfig = mergeObjects({
    // events
    onLoadingSlow: noop,
    onSuccess: noop,
    onError: noop,
    onErrorRetry: onErrorRetry,
    onDiscarded: noop,
    // switches
    revalidateOnFocus: true,
    revalidateOnReconnect: true,
    revalidateIfStale: true,
    shouldRetryOnError: true,
    // timeouts
    errorRetryInterval: slowConnection ? 10000 : 5000,
    focusThrottleInterval: 5 * 1000,
    dedupingInterval: 2 * 1000,
    loadingTimeout: slowConnection ? 5000 : 3000,
    // providers
    compare: function (currentData, newData) {
        return stableHash(currentData) == stableHash(newData);
    },
    isPaused: function () { return false; },
    cache: cache,
    mutate: mutate,
    fallback: {}
}, 
// use web preset by default
preset);

var mergeConfigs = function (a, b) {
    // Need to create a new object to avoid mutating the original here.
    var v = mergeObjects(a, b);
    // If two configs are provided, merge their `use` and `fallback` options.
    if (b) {
        var u1 = a.use, f1 = a.fallback;
        var u2 = b.use, f2 = b.fallback;
        if (u1 && u2) {
            v.use = u1.concat(u2);
        }
        if (f1 && f2) {
            v.fallback = mergeObjects(f1, f2);
        }
    }
    return v;
};

var SWRConfigContext = (0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)({});
var SWRConfig$1 = function (props) {
    var value = props.value;
    // Extend parent context values and middleware.
    var extendedConfig = mergeConfigs((0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(SWRConfigContext), value);
    // Should not use the inherited provider.
    var provider = value && value.provider;
    // Use a lazy initialized state to create the cache on first access.
    var cacheContext = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(function () {
        return provider
            ? initCache(provider(extendedConfig.cache || cache), value)
            : UNDEFINED;
    })[0];
    // Override the cache if a new provider is given.
    if (cacheContext) {
        extendedConfig.cache = cacheContext[0];
        extendedConfig.mutate = cacheContext[1];
    }
    // Unsubscribe events.
    useIsomorphicLayoutEffect(function () { return (cacheContext ? cacheContext[2] : UNDEFINED); }, []);
    return (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)(SWRConfigContext.Provider, mergeObjects(props, {
        value: extendedConfig
    }));
};

/**
 * An implementation of state with dependency-tracking.
 */
var useStateWithDeps = function (state, unmountedRef) {
    var rerender = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)({})[1];
    var stateRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(state);
    // If a state property (data, error or isValidating) is accessed by the render
    // function, we mark the property as a dependency so if it is updated again
    // in the future, we trigger a rerender.
    // This is also known as dependency-tracking.
    var stateDependenciesRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)({
        data: false,
        error: false,
        isValidating: false
    });
    /**
     * @param payload To change stateRef, pass the values explicitly to setState:
     * @example
     * ```js
     * setState({
     *   isValidating: false
     *   data: newData // set data to newData
     *   error: undefined // set error to undefined
     * })
     *
     * setState({
     *   isValidating: false
     *   data: undefined // set data to undefined
     *   error: err // set error to err
     * })
     * ```
     */
    var setState = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function (payload) {
        var shouldRerender = false;
        var currentState = stateRef.current;
        for (var _ in payload) {
            var k = _;
            // If the property has changed, update the state and mark rerender as
            // needed.
            if (currentState[k] !== payload[k]) {
                currentState[k] = payload[k];
                // If the property is accessed by the component, a rerender should be
                // triggered.
                if (stateDependenciesRef.current[k]) {
                    shouldRerender = true;
                }
            }
        }
        if (shouldRerender && !unmountedRef.current) {
            rerender({});
        }
    }, 
    // config.suspense isn't allowed to change during the lifecycle
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []);
    // Always update the state reference.
    useIsomorphicLayoutEffect(function () {
        stateRef.current = state;
    });
    return [stateRef, stateDependenciesRef.current, setState];
};

var normalize = function (args) {
    return isFunction(args[1])
        ? [args[0], args[1], args[2] || {}]
        : [args[0], null, (args[1] === null ? args[2] : args[1]) || {}];
};

var useSWRConfig = function () {
    return mergeObjects(defaultConfig, (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(SWRConfigContext));
};

// It's tricky to pass generic types as parameters, so we just directly override
// the types here.
var withArgs = function (hook) {
    return function useSWRArgs() {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        // Get the default and inherited configuration.
        var fallbackConfig = useSWRConfig();
        // Normalize arguments.
        var _a = normalize(args), key = _a[0], fn = _a[1], _config = _a[2];
        // Merge configurations.
        var config = mergeConfigs(fallbackConfig, _config);
        // Apply middleware
        var next = hook;
        var use = config.use;
        if (use) {
            for (var i = use.length; i-- > 0;) {
                next = use[i](next);
            }
        }
        return next(key, fn || config.fetcher, config);
    };
};

// Add a callback function to a list of keyed callback functions and return
// the unsubscribe function.
var subscribeCallback = function (key, callbacks, callback) {
    var keyedRevalidators = callbacks[key] || (callbacks[key] = []);
    keyedRevalidators.push(callback);
    return function () {
        var index = keyedRevalidators.indexOf(callback);
        if (index >= 0) {
            // O(1): faster than splice
            keyedRevalidators[index] = keyedRevalidators[keyedRevalidators.length - 1];
            keyedRevalidators.pop();
        }
    };
};

var WITH_DEDUPE = { dedupe: true };
var useSWRHandler = function (_key, fetcher, config) {
    var cache = config.cache, compare = config.compare, fallbackData = config.fallbackData, suspense = config.suspense, revalidateOnMount = config.revalidateOnMount, refreshInterval = config.refreshInterval, refreshWhenHidden = config.refreshWhenHidden, refreshWhenOffline = config.refreshWhenOffline;
    var _a = SWRGlobalState.get(cache), EVENT_REVALIDATORS = _a[0], STATE_UPDATERS = _a[1], MUTATION = _a[2], FETCH = _a[3];
    // `key` is the identifier of the SWR `data` state, `keyInfo` holds extra
    // states such as `error` and `isValidating` inside,
    // all of them are derived from `_key`.
    // `fnArgs` is an array of arguments parsed from the key, which will be passed
    // to the fetcher.
    var _b = serialize(_key), key = _b[0], fnArgs = _b[1], keyInfo = _b[2];
    // If it's the initial render of this hook.
    var initialMountedRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(false);
    // If the hook is unmounted already. This will be used to prevent some effects
    // to be called after unmounting.
    var unmountedRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(false);
    // Refs to keep the key and config.
    var keyRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(key);
    var fetcherRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(fetcher);
    var configRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(config);
    var getConfig = function () { return configRef.current; };
    var isActive = function () { return getConfig().isVisible() && getConfig().isOnline(); };
    var patchFetchInfo = function (info) {
        return cache.set(keyInfo, mergeObjects(cache.get(keyInfo), info));
    };
    // Get the current state that SWR should return.
    var cached = cache.get(key);
    var fallback = isUndefined(fallbackData)
        ? config.fallback[key]
        : fallbackData;
    var data = isUndefined(cached) ? fallback : cached;
    var info = cache.get(keyInfo) || {};
    var error = info.error;
    var isInitialMount = !initialMountedRef.current;
    // - Suspense mode and there's stale data for the initial render.
    // - Not suspense mode and there is no fallback data and `revalidateIfStale` is enabled.
    // - `revalidateIfStale` is enabled but `data` is not defined.
    var shouldRevalidate = function () {
        // If `revalidateOnMount` is set, we take the value directly.
        if (isInitialMount && !isUndefined(revalidateOnMount))
            return revalidateOnMount;
        // If it's paused, we skip revalidation.
        if (getConfig().isPaused())
            return false;
        // Under suspense mode, it will always fetch on render if there is no
        // stale data so no need to revalidate immediately on mount again.
        // If data exists, only revalidate if `revalidateIfStale` is true.
        if (suspense)
            return isUndefined(data) ? false : config.revalidateIfStale;
        // If there is no stale data, we need to revalidate on mount;
        // If `revalidateIfStale` is set to true, we will always revalidate.
        return isUndefined(data) || config.revalidateIfStale;
    };
    // Resolve the current validating state.
    var resolveValidating = function () {
        if (!key || !fetcher)
            return false;
        if (info.isValidating)
            return true;
        // If it's not mounted yet and it should revalidate on mount, revalidate.
        return isInitialMount && shouldRevalidate();
    };
    var isValidating = resolveValidating();
    var _c = useStateWithDeps({
        data: data,
        error: error,
        isValidating: isValidating
    }, unmountedRef), stateRef = _c[0], stateDependencies = _c[1], setState = _c[2];
    // The revalidation function is a carefully crafted wrapper of the original
    // `fetcher`, to correctly handle the many edge cases.
    var revalidate = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function (revalidateOpts) { return __awaiter(void 0, void 0, void 0, function () {
        var currentFetcher, newData, startAt, loading, opts, shouldStartNewRequest, isCurrentKeyMounted, cleanupState, newState, finishRequestAndUpdateState, mutationInfo, err_1;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    currentFetcher = fetcherRef.current;
                    if (!key ||
                        !currentFetcher ||
                        unmountedRef.current ||
                        getConfig().isPaused()) {
                        return [2 /*return*/, false];
                    }
                    loading = true;
                    opts = revalidateOpts || {};
                    shouldStartNewRequest = !FETCH[key] || !opts.dedupe;
                    isCurrentKeyMounted = function () {
                        return !unmountedRef.current &&
                            key === keyRef.current &&
                            initialMountedRef.current;
                    };
                    cleanupState = function () {
                        // Check if it's still the same request before deleting.
                        var requestInfo = FETCH[key];
                        if (requestInfo && requestInfo[1] === startAt) {
                            delete FETCH[key];
                        }
                    };
                    newState = { isValidating: false };
                    finishRequestAndUpdateState = function () {
                        patchFetchInfo({ isValidating: false });
                        // We can only set state if it's safe (still mounted with the same key).
                        if (isCurrentKeyMounted()) {
                            setState(newState);
                        }
                    };
                    // Start fetching. Change the `isValidating` state, update the cache.
                    patchFetchInfo({
                        isValidating: true
                    });
                    setState({ isValidating: true });
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 3, , 4]);
                    if (shouldStartNewRequest) {
                        // Tell all other hooks to change the `isValidating` state.
                        broadcastState(cache, key, stateRef.current.data, stateRef.current.error, true);
                        // If no cache being rendered currently (it shows a blank page),
                        // we trigger the loading slow event.
                        if (config.loadingTimeout && !cache.get(key)) {
                            setTimeout(function () {
                                if (loading && isCurrentKeyMounted()) {
                                    getConfig().onLoadingSlow(key, config);
                                }
                            }, config.loadingTimeout);
                        }
                        // Start the request and save the timestamp.
                        FETCH[key] = [currentFetcher.apply(void 0, fnArgs), getTimestamp()];
                    }
                    _a = FETCH[key], newData = _a[0], startAt = _a[1];
                    return [4 /*yield*/, newData];
                case 2:
                    newData = _b.sent();
                    if (shouldStartNewRequest) {
                        // If the request isn't interrupted, clean it up after the
                        // deduplication interval.
                        setTimeout(cleanupState, config.dedupingInterval);
                    }
                    // If there're other ongoing request(s), started after the current one,
                    // we need to ignore the current one to avoid possible race conditions:
                    //   req1------------------>res1        (current one)
                    //        req2---------------->res2
                    // the request that fired later will always be kept.
                    // The timestamp maybe be `undefined` or a number
                    if (!FETCH[key] || FETCH[key][1] !== startAt) {
                        if (shouldStartNewRequest) {
                            if (isCurrentKeyMounted()) {
                                getConfig().onDiscarded(key);
                            }
                        }
                        return [2 /*return*/, false];
                    }
                    // Clear error.
                    patchFetchInfo({
                        error: UNDEFINED
                    });
                    newState.error = UNDEFINED;
                    mutationInfo = MUTATION[key];
                    if (!isUndefined(mutationInfo) &&
                        // case 1
                        (startAt <= mutationInfo[0] ||
                            // case 2
                            startAt <= mutationInfo[1] ||
                            // case 3
                            mutationInfo[1] === 0)) {
                        finishRequestAndUpdateState();
                        if (shouldStartNewRequest) {
                            if (isCurrentKeyMounted()) {
                                getConfig().onDiscarded(key);
                            }
                        }
                        return [2 /*return*/, false];
                    }
                    // Deep compare with latest state to avoid extra re-renders.
                    // For local state, compare and assign.
                    if (!compare(stateRef.current.data, newData)) {
                        newState.data = newData;
                    }
                    else {
                        // data and newData are deeply equal
                        // it should be safe to broadcast the stale data
                        newState.data = stateRef.current.data;
                        // At the end of this function, `brocastState` invokes the `onStateUpdate` function,
                        // which takes care of avoiding the re-render
                    }
                    // For global state, it's possible that the key has changed.
                    // https://github.com/vercel/swr/pull/1058
                    if (!compare(cache.get(key), newData)) {
                        cache.set(key, newData);
                    }
                    // Trigger the successful callback if it's the original request.
                    if (shouldStartNewRequest) {
                        if (isCurrentKeyMounted()) {
                            getConfig().onSuccess(newData, key, config);
                        }
                    }
                    return [3 /*break*/, 4];
                case 3:
                    err_1 = _b.sent();
                    cleanupState();
                    // Not paused, we continue handling the error. Otherwise discard it.
                    if (!getConfig().isPaused()) {
                        // Get a new error, don't use deep comparison for errors.
                        patchFetchInfo({ error: err_1 });
                        newState.error = err_1;
                        // Error event and retry logic. Only for the actual request, not
                        // deduped ones.
                        if (shouldStartNewRequest && isCurrentKeyMounted()) {
                            getConfig().onError(err_1, key, config);
                            if ((typeof config.shouldRetryOnError === 'boolean' &&
                                config.shouldRetryOnError) ||
                                (isFunction(config.shouldRetryOnError) &&
                                    config.shouldRetryOnError(err_1))) {
                                // When retrying, dedupe is always enabled
                                if (isActive()) {
                                    // If it's active, stop. It will auto revalidate when refocusing
                                    // or reconnecting.
                                    getConfig().onErrorRetry(err_1, key, config, revalidate, {
                                        retryCount: (opts.retryCount || 0) + 1,
                                        dedupe: true
                                    });
                                }
                            }
                        }
                    }
                    return [3 /*break*/, 4];
                case 4:
                    // Mark loading as stopped.
                    loading = false;
                    // Update the current hook's state.
                    finishRequestAndUpdateState();
                    // Here is the source of the request, need to tell all other hooks to
                    // update their states.
                    if (isCurrentKeyMounted() && shouldStartNewRequest) {
                        broadcastState(cache, key, newState.data, newState.error, false);
                    }
                    return [2 /*return*/, true];
            }
        });
    }); }, 
    // `setState` is immutable, and `eventsCallback`, `fnArgs`, `keyInfo`,
    // and `keyValidating` are depending on `key`, so we can exclude them from
    // the deps array.
    //
    // FIXME:
    // `fn` and `config` might be changed during the lifecycle,
    // but they might be changed every render like this.
    // `useSWR('key', () => fetch('/api/'), { suspense: true })`
    // So we omit the values from the deps array
    // even though it might cause unexpected behaviors.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [key]);
    // Similar to the global mutate, but bound to the current cache and key.
    // `cache` isn't allowed to change during the lifecycle.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    var boundMutate = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(
    // By using `bind` we don't need to modify the size of the rest arguments.
    // Due to https://github.com/microsoft/TypeScript/issues/37181, we have to
    // cast it to any for now.
    internalMutate.bind(UNDEFINED, cache, function () { return keyRef.current; }), 
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []);
    // Always update fetcher and config refs.
    useIsomorphicLayoutEffect(function () {
        fetcherRef.current = fetcher;
        configRef.current = config;
    });
    // After mounted or key changed.
    useIsomorphicLayoutEffect(function () {
        if (!key)
            return;
        var keyChanged = key !== keyRef.current;
        var softRevalidate = revalidate.bind(UNDEFINED, WITH_DEDUPE);
        // Expose state updater to global event listeners. So we can update hook's
        // internal state from the outside.
        var onStateUpdate = function (updatedData, updatedError, updatedIsValidating) {
            setState(mergeObjects({
                error: updatedError,
                isValidating: updatedIsValidating
            }, 
            // Since `setState` only shallowly compares states, we do a deep
            // comparison here.
            compare(stateRef.current.data, updatedData)
                ? UNDEFINED
                : {
                    data: updatedData
                }));
        };
        // Expose revalidators to global event listeners. So we can trigger
        // revalidation from the outside.
        var nextFocusRevalidatedAt = 0;
        var onRevalidate = function (type) {
            if (type == FOCUS_EVENT) {
                var now = Date.now();
                if (getConfig().revalidateOnFocus &&
                    now > nextFocusRevalidatedAt &&
                    isActive()) {
                    nextFocusRevalidatedAt = now + getConfig().focusThrottleInterval;
                    softRevalidate();
                }
            }
            else if (type == RECONNECT_EVENT) {
                if (getConfig().revalidateOnReconnect && isActive()) {
                    softRevalidate();
                }
            }
            else if (type == MUTATE_EVENT) {
                return revalidate();
            }
            return;
        };
        var unsubUpdate = subscribeCallback(key, STATE_UPDATERS, onStateUpdate);
        var unsubEvents = subscribeCallback(key, EVENT_REVALIDATORS, onRevalidate);
        // Mark the component as mounted and update corresponding refs.
        unmountedRef.current = false;
        keyRef.current = key;
        initialMountedRef.current = true;
        // When `key` updates, reset the state to the initial value
        // and trigger a rerender if necessary.
        if (keyChanged) {
            setState({
                data: data,
                error: error,
                isValidating: isValidating
            });
        }
        // Trigger a revalidation.
        if (shouldRevalidate()) {
            if (isUndefined(data) || IS_SERVER) {
                // Revalidate immediately.
                softRevalidate();
            }
            else {
                // Delay the revalidate if we have data to return so we won't block
                // rendering.
                rAF(softRevalidate);
            }
        }
        return function () {
            // Mark it as unmounted.
            unmountedRef.current = true;
            unsubUpdate();
            unsubEvents();
        };
    }, [key, revalidate]);
    // Polling
    useIsomorphicLayoutEffect(function () {
        var timer;
        function next() {
            // Use the passed interval
            // ...or invoke the function with the updated data to get the interval
            var interval = isFunction(refreshInterval)
                ? refreshInterval(data)
                : refreshInterval;
            // We only start next interval if `refreshInterval` is not 0, and:
            // - `force` is true, which is the start of polling
            // - or `timer` is not 0, which means the effect wasn't canceled
            if (interval && timer !== -1) {
                timer = setTimeout(execute, interval);
            }
        }
        function execute() {
            // Check if it's OK to execute:
            // Only revalidate when the page is visible, online and not errored.
            if (!stateRef.current.error &&
                (refreshWhenHidden || getConfig().isVisible()) &&
                (refreshWhenOffline || getConfig().isOnline())) {
                revalidate(WITH_DEDUPE).then(next);
            }
            else {
                // Schedule next interval to check again.
                next();
            }
        }
        next();
        return function () {
            if (timer) {
                clearTimeout(timer);
                timer = -1;
            }
        };
    }, [refreshInterval, refreshWhenHidden, refreshWhenOffline, revalidate]);
    // Display debug info in React DevTools.
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useDebugValue)(data);
    // In Suspense mode, we can't return the empty `data` state.
    // If there is `error`, the `error` needs to be thrown to the error boundary.
    // If there is no `error`, the `revalidation` promise needs to be thrown to
    // the suspense boundary.
    if (suspense && isUndefined(data) && key) {
        // Always update fetcher and config refs even with the Suspense mode.
        fetcherRef.current = fetcher;
        configRef.current = config;
        unmountedRef.current = false;
        throw isUndefined(error) ? revalidate(WITH_DEDUPE) : error;
    }
    return {
        mutate: boundMutate,
        get data() {
            stateDependencies.data = true;
            return data;
        },
        get error() {
            stateDependencies.error = true;
            return error;
        },
        get isValidating() {
            stateDependencies.isValidating = true;
            return isValidating;
        }
    };
};
var SWRConfig = OBJECT.defineProperty(SWRConfig$1, 'default', {
    value: defaultConfig
});
var unstable_serialize = function (key) { return serialize(key)[0]; };
var useSWR = withArgs(useSWRHandler);

// useSWR




/***/ }),

/***/ 64356:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Sz": function() { return /* binding */ useContextSelector; },
/* harmony export */   "kr": function() { return /* binding */ createContext; },
/* harmony export */   "qp": function() { return /* binding */ useContext; }
/* harmony export */ });
/* unused harmony exports BridgeProvider, useBridgeValue, useContextUpdate */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(75271);
/* harmony import */ var scheduler__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(97537);
/* harmony import */ var react_dom__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(30967);
/* provided dependency */ var process = __webpack_require__(14224);




const CONTEXT_VALUE = Symbol();
const ORIGINAL_PROVIDER = Symbol();
const isSSR = typeof window === 'undefined' || /ServerSideRendering/.test(window.navigator && window.navigator.userAgent);
const useIsomorphicLayoutEffect = isSSR ? react__WEBPACK_IMPORTED_MODULE_0__.useEffect : react__WEBPACK_IMPORTED_MODULE_0__.useLayoutEffect;
// for preact that doesn't have runWithPriority
const runWithNormalPriority = scheduler__WEBPACK_IMPORTED_MODULE_1__.unstable_runWithPriority ? thunk => {
  try {
    (0,scheduler__WEBPACK_IMPORTED_MODULE_1__.unstable_runWithPriority)(scheduler__WEBPACK_IMPORTED_MODULE_1__.unstable_NormalPriority, thunk);
  } catch (e) {
    if (e.message === 'Not implemented.') {
      thunk();
    } else {
      throw e;
    }
  }
} : thunk => thunk();
const createProvider = ProviderOrig => {
  const ContextProvider = ({
    value,
    children
  }) => {
    const valueRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(value);
    const versionRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(0);
    const [resolve, setResolve] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(null);
    if (resolve) {
      resolve(value);
      setResolve(null);
    }
    const contextValue = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)();
    if (!contextValue.current) {
      const listeners = new Set();
      const update = (thunk, options) => {
        (0,react_dom__WEBPACK_IMPORTED_MODULE_2__.unstable_batchedUpdates)(() => {
          versionRef.current += 1;
          const action = {
            n: versionRef.current
          };
          if (options != null && options.suspense) {
            action.n *= -1; // this is intentional to make it temporary version
            action.p = new Promise(r => {
              setResolve(() => v => {
                action.v = v;
                delete action.p;
                r(v);
              });
            });
          }
          listeners.forEach(listener => listener(action));
          thunk();
        });
      };
      contextValue.current = {
        [CONTEXT_VALUE]: {
          /* "v"alue     */v: valueRef,
          /* versio"n"   */n: versionRef,
          /* "l"isteners */l: listeners,
          /* "u"pdate    */u: update
        }
      };
    }
    useIsomorphicLayoutEffect(() => {
      valueRef.current = value;
      versionRef.current += 1;
      runWithNormalPriority(() => {
        contextValue.current[CONTEXT_VALUE].l.forEach(listener => {
          listener({
            n: versionRef.current,
            v: value
          });
        });
      });
    }, [value]);
    return (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)(ProviderOrig, {
      value: contextValue.current
    }, children);
  };
  return ContextProvider;
};
const identity = x => x;
/**
 * This creates a special context for `useContextSelector`.
 *
 * @example
 * import { createContext } from 'use-context-selector';
 *
 * const PersonContext = createContext({ firstName: '', familyName: '' });
 */
function createContext(defaultValue) {
  const context = (0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)({
    [CONTEXT_VALUE]: {
      /* "v"alue     */v: {
        current: defaultValue
      },
      /* versio"n"   */n: {
        current: -1
      },
      /* "l"isteners */l: new Set(),
      /* "u"pdate    */u: f => f()
    }
  });
  context[ORIGINAL_PROVIDER] = context.Provider;
  context.Provider = createProvider(context.Provider);
  delete context.Consumer; // no support for Consumer
  return context;
}
/**
 * This hook returns context selected value by selector.
 *
 * It will only accept context created by `createContext`.
 * It will trigger re-render if only the selected value is referentially changed.
 *
 * The selector should return referentially equal result for same input for better performance.
 *
 * @example
 * import { useContextSelector } from 'use-context-selector';
 *
 * const firstName = useContextSelector(PersonContext, state => state.firstName);
 */
function useContextSelector(context, selector) {
  const contextValue = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(context)[CONTEXT_VALUE];
  if (typeof process === 'object' && "production" !== 'production') {}
  const {
    /* "v"alue     */v: {
      current: value
    },
    /* versio"n"   */n: {
      current: version
    },
    /* "l"isteners */l: listeners
  } = contextValue;
  const selected = selector(value);
  const [state, dispatch] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useReducer)((prev, action) => {
    if (!action) {
      // case for `dispatch()` below
      return [value, selected];
    }
    if ('p' in action) {
      throw action.p;
    }
    if (action.n === version) {
      if (Object.is(prev[1], selected)) {
        return prev; // bail out
      }
      return [value, selected];
    }
    try {
      if ('v' in action) {
        if (Object.is(prev[0], action.v)) {
          return prev; // do not update
        }
        const nextSelected = selector(action.v);
        if (Object.is(prev[1], nextSelected)) {
          return prev; // do not update
        }
        return [action.v, nextSelected];
      }
    } catch (e) {
      // ignored (stale props or some other reason)
    }
    return [...prev]; // schedule update
  }, [value, selected]);
  if (!Object.is(state[1], selected)) {
    // schedule re-render
    // this is safe because it's self contained
    dispatch();
  }
  useIsomorphicLayoutEffect(() => {
    listeners.add(dispatch);
    return () => {
      listeners.delete(dispatch);
    };
  }, [listeners]);
  return state[1];
}
/**
 * This hook returns the entire context value.
 * Use this instead of React.useContext for consistent behavior.
 *
 * @example
 * import { useContext } from 'use-context-selector';
 *
 * const person = useContext(PersonContext);
 */
function useContext(context) {
  return useContextSelector(context, identity);
}
/**
 * This hook returns an update function that accepts a thunk function
 *
 * Use this for a function that will change a value in
 * concurrent rendering in React 18.
 * Otherwise, there's no need to use this hook.
 *
 * @example
 * import { useContextUpdate } from 'use-context-selector';
 *
 * const update = useContextUpdate();
 *
 * // Wrap set state function
 * update(() => setState(...));
 *
 * // Experimental suspense mode
 * update(() => setState(...), { suspense: true });
 */
function useContextUpdate(context) {
  const contextValue = useContext$1(context)[CONTEXT_VALUE];
  if (typeof process === 'object' && "production" !== 'production') {}
  const {
    u: update
  } = contextValue;
  return update;
}
/**
 * This is a Provider component for bridging multiple react roots
 *
 * @example
 * const valueToBridge = useBridgeValue(PersonContext);
 * return (
 *   <Renderer>
 *     <BridgeProvider context={PersonContext} value={valueToBridge}>
 *       {children}
 *     </BridgeProvider>
 *   </Renderer>
 * );
 */
const BridgeProvider = ({
  context,
  value,
  children
}) => {
  const {
    [ORIGINAL_PROVIDER]: ProviderOrig
  } = context;
  if (typeof process === 'object' && "production" !== 'production') {}
  return createElement(ProviderOrig, {
    value
  }, children);
};
/**
 * This hook return a value for BridgeProvider
 */
const useBridgeValue = context => {
  const bridgeValue = useContext$1(context);
  if (typeof process === 'object' && "production" !== 'production') {}
  return bridgeValue;
};


//# sourceMappingURL=index.modern.mjs.map


/***/ }),

/***/ 95334:
/***/ (function(module) {

"use strict";
module.exports = {"version":"3.15.0"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [774,179], function() { return __webpack_exec__(3986), __webpack_exec__(53485); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);